webix.protoUI({
	name:"codemirror-editor",
	defaults:{
		mode:"javascript",
		lineNumbers:true,
		matchBrackets:true,
		theme:"default"
	},
	$init:function(config){
		this.$view.innerHTML = "<textarea style='width:100%;height:100%;'></textarea>";
		this._waitEditor = webix.promise.defer();
		this.$ready.push(this._render_cm_editor);
	},
	_render_cm_editor:function(){
		webix.require("codemirror/lib/codemirror.css");
		var deps = [
			"codemirror/lib/codemirror.js"
		];

		if (this.config.mode == "htmlmixed"){
			deps.push("codemirror/mode/xml/xml.js");
			deps.push("codemirror/mode/css/css.js");
			deps.push("codemirror/mode/javascript/javascript.js");
		}

		deps.push("codemirror/mode/"+this.config.mode+"/"+this.config.mode+".js");
		webix.require(deps, this._render_when_ready, this);
	},
	_render_when_ready:function(){
		this._editor = CodeMirror.fromTextArea(this.$view.firstChild, {
			mode: this.config.mode,
			lineNumbers: this.config.lineNumbers,
			matchBrackets: this.config.matchBrackets,
			theme: this.config.theme
		});

		this._waitEditor.resolve(this._editor);

		this.setValue(this.config.value);
		if (this._focus_await)
			this.focus();
	},
	_set_inner_size:function(){
		if (!this._editor || !this.$width) return;

		this._updateScrollSize();
		this._editor.scrollTo(0,0); //force repaint, mandatory for IE
	},
	_updateScrollSize:function(){
		var box = this._editor.getWrapperElement();
		var height = (this.$height || 0) + "px";

		box.style.height = height;
		box.style.width = (this.$width || 0) + "px";

		var scroll = this._editor.getScrollerElement();
		if (scroll.style.height != height){
			scroll.style.height = height;
			this._editor.refresh();
		}
	},
	$setSize:function(x,y){
		if (webix.ui.view.prototype.$setSize.call(this, x, y)){
			this._set_inner_size();
		}
	},
	setValue:function(value){
		if(!value && value !== 0)
			value = "";

		this.config.value = value;
		if(this._editor){
			this._editor.setValue(value);
			//by default - clear editor's undo history when setting new value
			if(!this.config.preserveUndoHistory)
				this._editor.clearHistory();
			this._updateScrollSize();
		}
	},
	getValue:function(){
		return this._editor?this._editor.getValue():this.config.value;
	},
	focus:function(){
		this._focus_await = true;
		if (this._editor)
			this._editor.focus();
	},
	getEditor:function(waitEditor){
		return waitEditor?this._waitEditor:this._editor;
	},
	//undo, redo, etc
	undo:function(){
		this._editor.undo();
	},
	redo:function(){
		this._editor.redo();
	},
	undoLength:function(){
		return this._editor.historySize().undo;
	}
}, webix.ui.view);
webix.protoUI({
	name:"nic-editor",
	defaults:{
		config:{ },
		value:""
	},
	$init:function(config){
		this.$view.innerHTML = "<div style='padding:10px'>Loading...</div>";
		this.$view.className += " webix_selectable";

		this._waitEditor = webix.promise.defer();
		this.$ready.push(this._init_nic_editor);
	},
	_init_nic_editor:function(){

		if (this.config.cdn === false){
			this._render_nic_editor();
			return;
		};

		var sources = [];
		
		var cdn = this.config.cdn ? this.config.cdn : "niceditor";

		sources.push(cdn+"/nicedit_lib.js");

		if (!this.config.config.iconsPath)
			this.config.config.iconsPath = "/webix/codebase/niceditor/nicEditorIcons.gif";

		webix.require(sources)
		.then(webix.bind(this._render_nic_editor, this))
		.catch(function(e){
			console.log(e);
		});
	},
	_render_nic_editor:function(){
		if (!this._editorCss){
			var style = ".nicEdit-panel{height:auto}\n";
			style += ".nicEdit-panelContain{border-top-width:0px !important;}\n";
			style += ".webix_selectable>div:nth-child(2){overflow-y:auto;}";
			webix.html.addStyle(style);
			this._editorCss = true;
		}
				
		var nic = new nicEditor(this.config.config).panelInstance(this.$view.firstChild);
		this._3rd_editor = nic.nicInstances[nic.nicInstances.length-1];
		this._set_inner_size();

		this._waitEditor.resolve(this._3rd_editor);
		
		this.setValue(this.config.value);
		if (this._focus_await)
			this.focus();
	},
	_set_inner_size:function(){
		if (!this._3rd_editor || !this.$width) return;

		var editor = this.$view.firstChild;
		editor.style.width = this.$width+"px";

		editor = editor.nextSibling;
		editor.style.width = this.$width-20+"px";	//2x10 - padding
		editor.style.height = this.$height-46+"px";	//2x10 padding + 26 - header with borders
	},
	$setSize:function(x,y){
		if (webix.ui.view.prototype.$setSize.call(this, x, y)){
			this._set_inner_size();
		}
	},
	setValue:function(value){
		this.config.value = value;
		if (this._3rd_editor)
			this._3rd_editor.setContent(value);
	},
	getValue:function(){
		return this._3rd_editor?this._3rd_editor.getContent():this.config.value;
	},
	focus:function(){
		this._focus_await = true;
		if (this._3rd_editor)
			this._3rd_editor.elm.focus();
	},
	getEditor:function(waitEditor){
		return waitEditor?this._waitEditor:this._3rd_editor;
	}
}, webix.ui.view);
/**
 * Created by Erxin, Shang(Edwin) on 6/21/2016.
 * JavaScript Configuration file(.ini) content parser, similar to python ConfigParser without I/O operations
 * The license is under GPL-3.0
 * Git repo:https://github.com/shangerxin/config-ini
 * Author homepage: http://www.shangerxin.com
 * Version, 1.1.6
 */

(function (exports) {
    var error = {
        name   : "ConfigIniParser Error",
        message: "Parse config ini file error"
    };

    var errorNoSection = {
        name   : "ConfigIniParser Error",
        message: "The specify section not found"
    };

    var errorNoOption = {
        name   : "ConfigIniParser Error",
        message: "The specify option not found"
    };

    var errorDuplicateSectionError = {
        name   : "ConfigIniParser Error",
        message: "Found duplicated section in the given ini file"
    };

    var errorNoDelimiter = {
        name   : "ConfigIniParser Error",
        message: "The parameter delimiter is required"
    };

    var DEFAULT_SECTION    = "__DEFAULT_SECTION__";
    var _sectionRegex      = /^\s*\[\s*(\S+)\s*\]\s*/;
    var _optionRegex       = /\s*(\w+\[?\d{0,3}\]?)\s*[=]\s*(.*)\s*/;
    var _commentRegex      = /\s*[#;].*/;
    var _emptyRegex        = /^\s*$/;
    var SECTION_NAME_INDEX = 1;
    var OPTION_NAME_INDEX  = 1;
    var OPTION_VALUE_INDEX = 2;
    var NOT_FOUND          = -1;
    var DEFAULT_DELIMITER  = "\n";

    function _findSection(iniStructure, sectionName) {
        var sections = iniStructure.sections;
        for (var i = 0; i < sections.length; i++) {
            var section = sections[i];
            if (section.name == sectionName) {
                return section;
            }
        }
    }

    function _findSectionIndex(iniStructure, sectionName) {
        var sections = iniStructure.sections;
        for (var i = 0; i < sections.length; i++) {
            var section = sections[i];
            if (section.name == sectionName) {
                return i;
            }
        }

        return NOT_FOUND;
    }

    function _findOption(section, optionName) {
        var options = section.options;
        for (var i = 0; i < options.length; i++) {
            var option = options[i];
            if (option.name == optionName) {
                return option;
            }
        }
    }

    function _findOptionIndex(section, optionName) {
        var options = section.options;
        for (var i = 0; i < options.length; i++) {
            var option = options[i];
            if (option.name == optionName) {
                return i;
            }
        }

        return NOT_FOUND;
    }

    function _createSection(name) {
        return {
            name   : name,
            options: []
        };
    }

    function _createOption(name, value, comment) {
        return {
            name : name,
            value: value,
            comment:comment
        };
    }

    /*
     * Create a ini file parser, the format of ini file could be found at
     * https://en.wikipedia.org/wiki/INI_file
     *
     * Duplicated sections will cause exception, duplicated options will be
     * ignored and only the first one will take effect.
     *
     * @constructor
     * @param {string} delimiter, the line delimiter which is used to separate the lines
     * @return {ConfigIniParser} a ConfigIniParser object
     */
    var ConfigIniParser = function (delimiter) {
        this.delimiter = delimiter? delimiter:DEFAULT_DELIMITER;

        /*
         _init object structure
         {
             sections:[
                 {
                     name:string,
                     options:[
                         {
                             name:string,
                             value:value
                         },
                     ]
                 },
             ]
         }
         */
        this._ini = {
            sections: []
        };

        this._ini.sections.push(_createSection(DEFAULT_SECTION));
    };

    /*
     * Create a new section, if the section is already contain in the structure then
     * a duplicated section exception will be thrown
     * @param {string} sectionName a section name defined in ini [section name]
     * @return {object} the created section object
     */
    ConfigIniParser.prototype.addSection = function (sectionName) {
        if (_findSection(this._ini, sectionName)) {
            throw errorDuplicateSectionError;
        }
        else {
            var section = _createSection(sectionName);
            this._ini.sections.push(section);
            return this;
        }
    };

    /*
     * Get a specify option value
     * @param {string} sectionName the name defined in ini [section name]
     * @param {string} optionName the name defined in ini option-name = option-value
     * @param {object} defaultValue use the default value if the option is not exist
     * @return {string/object} the string value of the option or the defaultValue
     */
    ConfigIniParser.prototype.get = function (sectionName, optionName, defaultValue) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        if (section) {
            var option = _findOption(section, optionName);
            if (option) {
                return option.value;
            }
        }

        if(defaultValue){
            return defaultValue;
        }
        else{
            throw errorNoOption;
        }
    };

    /*
     * Convert the option value to boolean, if the value is a number then return true if it is
     * not equal to 0; if the value is string and which value is "true"/"false" then will be converted
     * to bool, return true if it is "true";
     * @return {boolean} indicate the value is true or false
     */
    ConfigIniParser.prototype.getBoolean = function (sectionName, optionName) {
        var value = this.get(sectionName ? sectionName : DEFAULT_SECTION, optionName);

        if (isNaN(value)) {
            return String(value).toLowerCase() == "true";
        }
        else {
            return value != 0;
        }
    };

    /*
     * Convert a option value to number
     * @return {number/NaN} number or NaN
     */
    ConfigIniParser.prototype.getNumber = function (sectionName, optionName) {
        return +this.get(sectionName ? sectionName : DEFAULT_SECTION, optionName);
    };

    /*
     * Check a specify section is exist or not
     * @return {boolean} to indicate the result
     */
    ConfigIniParser.prototype.isHaveSection = function (sectionName) {
        return !!_findSection(this._ini, sectionName);
    };

    /*
     * Check an option is exist in a section or not.
     * @return {boolean} boolean
     */
    ConfigIniParser.prototype.isHaveOption = function (sectionName, optionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        if (section) {
            var option = _findOption(section, optionName);
            if (option) {
                return true;
            }
        }
        return false;
    };

    /*
     * Get key/value pair of the options in the specify section
     * @param {string} sectionName a section name defined in ini [section name]
     * @return {Array.} an array contain several sub arrays which are composed by optionName,
     * optionValue. The returned array looks like [[optionName0, optionValue0], ...]
     */
    ConfigIniParser.prototype.items = function (sectionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        var items   = [];

        for (var i = 0; i < section.options.length; i++) {
            var option = section.options[i];
            items.push([option.name, option.value]);
        }

        return items;
    };

    ConfigIniParser.prototype.itemsKeyVal = function (sectionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        var items   = {};

        for (var i = 0; i < section.options.length; i++)
        {
            var option = section.options[i];
            items[option.name] = option.value;
        }

        return items;
    };

    /*
     * Get all the option names from the specify section
     * @param {string} sectionName a section name defined in ini [section name]
     * @return {Array.} an string array contain all the option names
     */
    ConfigIniParser.prototype.options = function (sectionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        if (section) {
            var optionNames = [];
            var options     = section.options;
            var option;
            for (var i = 0; i < options.length; i++) {
                option = options[i];
                optionNames.push(option.name);
            }
            return optionNames;
        }
        else {
            throw errorNoSection;
        }
    };

    /*
     * Remove the specify option from the section if the option exist then remove it
     * and return true else return false
     *
     * @param {string} sectionName a section name defined in ini [section name]
     * @param {string} optionName
     * @return, boolean
     */
    ConfigIniParser.prototype.removeOption = function (sectionName, optionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        if (section) {
            var optionIndex = _findOptionIndex(section, optionName);
            if (optionIndex != NOT_FOUND) {
                section.options.splice(optionIndex, 1);
                return true;
            }
        }

        return false;
    };

    /*
     * Remove the specify section if the section exist then remove it
     * and return true else return false
     *
     * @param {string} sectionName
     * @return {boolean}
     */
    ConfigIniParser.prototype.removeSection = function (sectionName) {
        var sectionIndex = _findSectionIndex(this._ini, sectionName);
        if (sectionIndex != NOT_FOUND) {
            this._ini.sections.splice(sectionIndex, 1);
            return true;
        }
        else {
            return false;
        }
    };

    /*
     * Get all the section names from the ini content
     * @return {Array.} an string array
     */
    ConfigIniParser.prototype.sections = function () {
        var sectionNames = [];
        var sections     = this._ini.sections;
        var section;
        for (var i = 0; i < sections.length; i++) {
            section = sections[i];
            if (section.name != DEFAULT_SECTION) {
                sectionNames.push(section.name);
            }
        }
        return sectionNames;
    };

    /*
     * Set a option value, if the option is not exist then it will be added to the section.
     * If the section is not exist an errorNoSection will be thrown
     * @param {string} sectionName, string
     * @param {string} optionName, string
     * @param {string} value, a value should be able to converted to string
     * @return {object} parser object itself
     */
    ConfigIniParser.prototype.set = function (sectionName, optionName, value, comment) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        var option;
        if (section) {
            option = _findOption(section, optionName);
            if (option)
            {
                option.value = value;
                option.comment = comment;
                return this;
            }
            else
                {
                option = _createOption(optionName, value, comment);
                section.options.push(option);
                return this;
            }
        }
        else {
            throw errorNoSection;
        }
    };

    /*
     * Convert the configuration content to strings the line will the separate with the
     * given line delimiter. A empty line will be added between each section
     *
     * @return {string} the content of configuration
     */
    ConfigIniParser.prototype.stringify = function (delimiter) {
        var lines    = [];
        var sections = this._ini.sections;
        var currentSection;
        var options;
        var currentOption;
        for (var i = 0; i < sections.length; i++) {
            currentSection = sections[i];
            if (currentSection.name != DEFAULT_SECTION) {
                lines.push("[" + currentSection.name + "]");
            }

            options = currentSection.options;
            for (var j = 0; j < options.length; j++) {
                currentOption = options[j];
                if(currentOption.comment)
                {
                    if(currentOption.comment === " ")
                    {
                        lines.push("");
                    }
                    else
                    {
                        lines.push("# " + currentOption.comment);
                    }

                }
                else if(currentOption.name)
                {
                    lines.push(currentOption.name + "=" + currentOption.value);
                }
            }
            lines.push("");
        }
        return lines.join(delimiter? delimiter:this.delimiter);
    };

    /*
     * Parse a given ini content
     * @param {string} iniContent, a string normally separated with \r\n or \n
     * @return {ConfigIniParser} the parser instance itself
     */
    ConfigIniParser.prototype.parse = function (iniContent) {
        var lines          = iniContent.split(this.delimiter);
        var currentSection = _findSection(this._ini, DEFAULT_SECTION);

        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            if (line.match(_commentRegex) || line.match(_emptyRegex)) {
                continue;
            }

            var sectionInfo = line.match(_sectionRegex);
            if (sectionInfo) {
                var sectionName = sectionInfo[SECTION_NAME_INDEX];
                if (_findSection(this._ini, sectionName)) {
                    throw errorDuplicateSectionError;
                }
                else {
                    currentSection = _createSection(sectionName);
                    this._ini.sections.push(currentSection);
                }
                continue;
            }

            var optionInfo = line.match(_optionRegex);
            if (optionInfo) {
                var optionName  = optionInfo[OPTION_NAME_INDEX];
                var optionValue = optionInfo[OPTION_VALUE_INDEX];
                var option      = _createOption(optionName, optionValue);
                currentSection.options.push(option);
                continue;
            }

            //throw error;
        }
        return this;
    };

    exports.ConfigIniParser = ConfigIniParser;
}(typeof exports != "undefined" ? exports : (typeof window != "undefined" ? window:{})));
/**
 * Created by Erxin, Shang(Edwin) on 6/21/2016.
 * JavaScript Configuration file(.ini) content parser, similar to python ConfigParser without I/O operations
 * The license is under GPL-3.0
 * Git repo:https://github.com/shangerxin/config-ini
 * Author homepage: http://www.shangerxin.com
 * Version, 1.1.6
 */

(function (exports) {
    var error = {
        name   : "ConfigIniParser Error",
        message: "Parse config ini file error"
    };

    var errorNoSection = {
        name   : "ConfigIniParser Error",
        message: "The specify section not found"
    };

    var errorNoOption = {
        name   : "ConfigIniParser Error",
        message: "The specify option not found"
    };

    var errorDuplicateSectionError = {
        name   : "ConfigIniParser Error",
        message: "Found duplicated section in the given ini file"
    };

    var errorNoDelimiter = {
        name   : "ConfigIniParser Error",
        message: "The parameter delimiter is required"
    };

    var DEFAULT_SECTION    = "__DEFAULT_SECTION__";
    var _sectionRegex      = /^\s*\[\s*(\S+)\s*\]\s*/;
    var _optionRegex       = /\s*(\w+\[?\d{0,3}\]?)\s*[=]\s*(.*)\s*/;
    var _commentRegex      = /\s*[#].*/;
    var _emptyRegex        = /^\s*$/;
    var _objectStartRegex       = /\s*(\w+\[?\d{0,3}\]?)\s*[{]\s*/;
    var _objectEndRegex       = /\s*[}]\s*/;
    var SECTION_NAME_INDEX = 1;
    var OPTION_NAME_INDEX  = 1;
    var OPTION_VALUE_INDEX = 2;
    var NOT_FOUND          = -1;
    var DEFAULT_DELIMITER  = "\n";

    function _findSection(iniStructure, sectionName) {
        var sections = iniStructure.sections;
        for (var i = 0; i < sections.length; i++) {
            var section = sections[i];
            if (section.name == sectionName) {
                return section;
            }
        }
    }

    function _findSectionIndex(iniStructure, sectionName) {
        var sections = iniStructure.sections;
        for (var i = 0; i < sections.length; i++) {
            var section = sections[i];
            if (section.name == sectionName) {
                return i;
            }
        }

        return NOT_FOUND;
    }

    function _findOption(section, optionName) {
        var options = section.options;
        for (var i = 0; i < options.length; i++) {
            var option = options[i];
            if (option.name == optionName) {
                return option;
            }
        }
    }

    function _findOptionIndex(section, optionName) {
        var options = section.options;
        for (var i = 0; i < options.length; i++) {
            var option = options[i];
            if (option.name == optionName) {
                return i;
            }
        }

        return NOT_FOUND;
    }

    function _createSection(name) {
        return {
            name   : name,
            options: []
        };
    }

    function _createOption(name, value, comment) {
        return {
            name : name,
            value: value,
            comment:comment
        };
    }

    /*
     * Create a ini file parser, the format of ini file could be found at
     * https://en.wikipedia.org/wiki/INI_file
     *
     * Duplicated sections will cause exception, duplicated options will be
     * ignored and only the first one will take effect.
     *
     * @constructor
     * @param {string} delimiter, the line delimiter which is used to separate the lines
     * @return {ConfigIniParser} a ConfigIniParser object
     */
    var ConfigIniCustomParser = function (delimiter) {
        this.delimiter = delimiter? delimiter:DEFAULT_DELIMITER;

        /*
         _init object structure
         {
             sections:[
                 {
                     name:string,
                     options:[
                         {
                             name:string,
                             value:value
                         },
                     ]
                 },
             ]
         }
         */
        this._ini = {
            sections: []
        };

        this._ini.sections.push(_createSection(DEFAULT_SECTION));
    };

    /*
     * Create a new section, if the section is already contain in the structure then
     * a duplicated section exception will be thrown
     * @param {string} sectionName a section name defined in ini [section name]
     * @return {object} the created section object
     */
    ConfigIniCustomParser.prototype.addSection = function (sectionName) {
        if (_findSection(this._ini, sectionName)) {
            throw errorDuplicateSectionError;
        }
        else {
            var section = _createSection(sectionName);
            this._ini.sections.push(section);
            return this;
        }
    };

    /*
     * Get a specify option value
     * @param {string} sectionName the name defined in ini [section name]
     * @param {string} optionName the name defined in ini option-name = option-value
     * @param {object} defaultValue use the default value if the option is not exist
     * @return {string/object} the string value of the option or the defaultValue
     */
    ConfigIniCustomParser.prototype.get = function (sectionName, optionName, defaultValue) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        if (section) {
            var option = _findOption(section, optionName);
            if (option) {
                return option.value;
            }
        }

        if(defaultValue){
            return defaultValue;
        }
        else{
            throw errorNoOption;
        }
    };

    /*
     * Convert the option value to boolean, if the value is a number then return true if it is
     * not equal to 0; if the value is string and which value is "true"/"false" then will be converted
     * to bool, return true if it is "true";
     * @return {boolean} indicate the value is true or false
     */
    ConfigIniCustomParser.prototype.getBoolean = function (sectionName, optionName) {
        var value = this.get(sectionName ? sectionName : DEFAULT_SECTION, optionName);

        if (isNaN(value)) {
            return String(value).toLowerCase() == "true";
        }
        else {
            return value != 0;
        }
    };

    /*
     * Convert a option value to number
     * @return {number/NaN} number or NaN
     */
    ConfigIniCustomParser.prototype.getNumber = function (sectionName, optionName) {
        return +this.get(sectionName ? sectionName : DEFAULT_SECTION, optionName);
    };

    /*
     * Check a specify section is exist or not
     * @return {boolean} to indicate the result
     */
    ConfigIniCustomParser.prototype.isHaveSection = function (sectionName) {
        return !!_findSection(this._ini, sectionName);
    };

    /*
     * Check an option is exist in a section or not.
     * @return {boolean} boolean
     */
    ConfigIniCustomParser.prototype.isHaveOption = function (sectionName, optionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        if (section) {
            var option = _findOption(section, optionName);
            if (option) {
                return true;
            }
        }
        return false;
    };

    /*
     * Get key/value pair of the options in the specify section
     * @param {string} sectionName a section name defined in ini [section name]
     * @return {Array.} an array contain several sub arrays which are composed by optionName,
     * optionValue. The returned array looks like [[optionName0, optionValue0], ...]
     */
    ConfigIniCustomParser.prototype.items = function (sectionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        var items   = [];

        for (var i = 0; i < section.options.length; i++) {
            var option = section.options[i];
            items.push([option.name, option.value]);
        }

        return items;
    };

    ConfigIniCustomParser.prototype.itemsKeyVal = function (sectionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        var items   = {};

        for (var i = 0; i < section.options.length; i++)
        {
            var option = section.options[i];
            items[option.name] = option.value;
        }

        return items;
    };

    /*
     * Get all the option names from the specify section
     * @param {string} sectionName a section name defined in ini [section name]
     * @return {Array.} an string array contain all the option names
     */
    ConfigIniCustomParser.prototype.options = function (sectionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        if (section) {
            var optionNames = [];
            var options     = section.options;
            var option;
            for (var i = 0; i < options.length; i++) {
                option = options[i];
                optionNames.push(option.name);
            }
            return optionNames;
        }
        else {
            throw errorNoSection;
        }
    };

    /*
     * Remove the specify option from the section if the option exist then remove it
     * and return true else return false
     *
     * @param {string} sectionName a section name defined in ini [section name]
     * @param {string} optionName
     * @return, boolean
     */
    ConfigIniCustomParser.prototype.removeOption = function (sectionName, optionName) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        if (section) {
            var optionIndex = _findOptionIndex(section, optionName);
            if (optionIndex != NOT_FOUND) {
                section.options.splice(optionIndex, 1);
                return true;
            }
        }

        return false;
    };

    /*
     * Remove the specify section if the section exist then remove it
     * and return true else return false
     *
     * @param {string} sectionName
     * @return {boolean}
     */
    ConfigIniCustomParser.prototype.removeSection = function (sectionName) {
        var sectionIndex = _findSectionIndex(this._ini, sectionName);
        if (sectionIndex != NOT_FOUND) {
            this._ini.sections.splice(sectionIndex, 1);
            return true;
        }
        else {
            return false;
        }
    };

    /*
     * Get all the section names from the ini content
     * @return {Array.} an string array
     */
    ConfigIniCustomParser.prototype.sections = function () {
        var sectionNames = [];
        var sections     = this._ini.sections;
        var section;
        for (var i = 0; i < sections.length; i++) {
            section = sections[i];
            if (section.name != DEFAULT_SECTION) {
                sectionNames.push(section.name);
            }
        }
        return sectionNames;
    };

    /*
     * Set a option value, if the option is not exist then it will be added to the section.
     * If the section is not exist an errorNoSection will be thrown
     * @param {string} sectionName, string
     * @param {string} optionName, string
     * @param {string} value, a value should be able to converted to string
     * @return {object} parser object itself
     */
    ConfigIniCustomParser.prototype.set = function (sectionName, optionName, value, comment) {
        var section = _findSection(this._ini, sectionName ? sectionName : DEFAULT_SECTION);
        var option;
        if (section) {
            option = _findOption(section, optionName);
            if (option)
            {
                option.value = value;
                option.comment = comment;
                return this;
            }
            else
                {
                option = _createOption(optionName, value, comment);
                section.options.push(option);
                return this;
            }
        }
        else {
            throw errorNoSection;
        }
    };

    /*
     * Convert the configuration content to strings the line will the separate with the
     * given line delimiter. A empty line will be added between each section
     *
     * @return {string} the content of configuration
     */
    ConfigIniCustomParser.prototype.stringify = function (delimiter) {
        var _this = this;
        var lines    = [];
        var sections = this._ini.sections;
        var currentSection;
        var options;
        var currentOption;
        for (var i = 0; i < sections.length; i++) {
            currentSection = sections[i];
            if (currentSection.name != DEFAULT_SECTION) {
                lines.push("[" + currentSection.name + "]");
            }

            options = currentSection.options;
            for (var j = 0; j < options.length; j++) {
                currentOption = options[j];
                if(currentOption.comment)
                {
                    if(currentOption.comment === " ")
                    {
                        lines.push("");
                    }
                    else
                    {
                        lines.push("# " + currentOption.comment);
                    }

                }
                else if(currentOption.name)
                {
                    if(Array.isArray(currentOption.value))
                    {
                        currentOption.value.forEach(function(Val){
                            if(Array.isArray(Val))
                            {
                                var objLines = [];
                                Val.forEach(function(V){
                                    if(Array.isArray(V.value)){
                                        V.value.forEach(function(_V){
                                            objLines.push(V.name + "=" + _V);
                                        });
                                    }
                                    else{
                                        objLines.push(V.name + "=" + V.value);
                                    }
                                });

                                if(objLines.length > 0)
                                {

                                    lines.push(currentOption.name + " {");

                                    objLines.forEach(function(Line){
                                        lines.push(Line);
                                    });

                                    lines.push("}");

                                    // lines.push("");
                                }
                            }
                            else{
                                lines.push(currentOption.name + "=" + Val);
                            }
                        });
                    }
                    else{
                        lines.push(currentOption.name + "=" + currentOption.value);
                    }

                }
            }
            lines.push("");
        }
        return lines.join(delimiter? delimiter:this.delimiter);
    };

    /*
     * Parse a given ini content
     * @param {string} iniContent, a string normally separated with \r\n or \n
     * @return {ConfigIniParser} the parser instance itself
     */
    ConfigIniCustomParser.prototype.parse = function (iniContent) {
        var lines          = iniContent.split(this.delimiter);
        var currentSection = _findSection(this._ini, DEFAULT_SECTION);
        var envObject=null;
        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            // if ((line.match(_commentRegex) || line.match(_emptyRegex)) && !line.match(_optionRegex)) {
            if ((line.match(_commentRegex) || line.match(_emptyRegex))) {
                continue;
            }
            var sectionInfo = line.match(_sectionRegex);
            if (sectionInfo) {
                var sectionName = sectionInfo[SECTION_NAME_INDEX];
                if (_findSection(this._ini, sectionName)) {
                    throw errorDuplicateSectionError;
                }
                else {
                    currentSection = _createSection(sectionName);
                    this._ini.sections.push(currentSection);
                }
                continue;
            }
            var optionInfo = line.match(_optionRegex);

            if (optionInfo) {
                var optionName  = optionInfo[OPTION_NAME_INDEX];
                var optionValue = optionInfo[OPTION_VALUE_INDEX];

                var option      = _createOption(optionName, optionValue);

                if(envObject)
                {
                    var index = envObject.value.findIndex(function(obj){
                        return obj.name == optionName;
                    });

                    if(index == -1)
                    {
                        envObject.value.push(option);
                    }
                    else{
                        var value = envObject.value[index].value;
                        var resVal = [];
                        if(Array.isArray(value))
                        {
                            resVal = value;
                        }
                        else
                        {
                            resVal = [value];
                        }

                        resVal.push(option.value);

                        envObject.value[index].value = resVal;
                    }
                }
                else{
                    var index = currentSection.options.findIndex(function(obj){
                        return obj.name == optionName;
                    });

                    if(index == -1)
                    {
                        currentSection.options.push(option);
                    }
                    else{
                        var value = currentSection.options[index].value;
                        var resVal = [];
                        if(Array.isArray(value))
                        {
                            resVal = value;
                        }
                        else
                        {
                            resVal = [value];
                        }

                        resVal.push(option.value);

                        currentSection.options[index].value = resVal;
                    }
                }

                continue;
            }
            else{
                var objStart = line.match(_objectStartRegex);
                if(objStart)
                {
                    var objName = objStart[OPTION_NAME_INDEX];
                    envObject = _createOption(objName, []);

                }else if(line.match(_objectEndRegex) && envObject)
                {
                    var envIndex = -1;
                    currentSection.options.forEach(function(obj, i){
                        if(obj.name == envObject.name)
                        {
                            envIndex = i;
                            return;
                        }
                    });

                    if(envIndex === -1)
                    {
                        currentSection.options.push(_createOption(envObject.name, [envObject.value]));
                    }
                    else{
                        var value = currentSection.options[envIndex].value;
                        var resVal = [];
                        if(Array.isArray(value))
                        {
                            resVal = value;
                        }
                        else
                        {
                            resVal = [value];
                        }

                        resVal.push(envObject.value);

                        currentSection.options[envIndex].value = resVal;
                    }

                    envObject = null;
                }
            }

            //throw error;
        }
        return this;
    };

    exports.ConfigIniCustomParser = ConfigIniCustomParser;
}(typeof exports != "undefined" ? exports : (typeof window != "undefined" ? window:{})));
webix.protoUI({
	name: "sidebar",
	defaults:{
		titleHeight: 40,
		type: "sideBar",
		activeTitle: true,
		select: true,
		scroll: false,
		collapsed: false,
		collapsedWidth: 41,
		position: "left",
		width: 250,
		mouseEventDelay: 10
	},
	$init: function(config){
		this.$ready.push(this._initSidebar);
		this.$ready.push(this._initContextMenu);
	},

	on_context:{},
	on_mouse_move:{},
	_initSidebar: function(){
		this._fullWidth = this.config.width;
		this.attachEvent("onBeforeOpen", function(id){
			if(!this.config.multipleOpen)
				this.closeAll();
			return !this.config.collapsed;
		});
		this.attachEvent("onItemClick", function(id, ev, node){
			if(this.getPopup() && !this.getPopup().config.hidden)
				ev.showpopup = true;
			if(webix.env.touch)
				this._showPopup(id, node);
		});
		this.attachEvent("onBeforeSelect", function(id){
			if(!this.getItem(id).$count){
				var selected = this.getSelectedId();
				if(selected && id!= selected){
					var parentId = this.getParentId(selected);

					this.removeCss(parentId, "webix_sidebar_selected");
				}
				return true;
			}
			return false;
		});
		this.attachEvent("onAfterSelect", function(id){
			var parentId = this.getParentId(id);
			this.addCss(parentId, "webix_sidebar_selected");
			var title = this.getPopupTitle();

			title.callEvent("onMasterSelect",[id]);
		});
		this.attachEvent("onMouseMove", function(id, ev, node){
			this._showPopup(id, node);
		});

		if(this.config.collapsed)
			this.collapse();
	},
	_showPopup: function(id, node){
		if(this.config.collapsed){
			var popup = this.getPopup();

			if(popup){
				var title = this.getPopupTitle();
				if(title){
					this._updateTitle(id);
				}
				var list = this.getPopupList();
				if(list){
					this._updateList(id);
				}
				var x = (this.config.position == "left"?this.config.collapsedWidth:-popup.config.width);
				popup.show(node, {x: x , y:-1});
			}
		}
	},
	_updateTitle: function(id){
		var title = this.getPopupTitle();
		title.masterId = id;
		title.parse(this.getItem(id));
		var selectedId = this.getSelectedId();
		if(selectedId && this.getParentId(selectedId) == id){
			webix.html.addCss(title.$view, "webix_sidebar_selected", true);
		}
		else{
			webix.html.removeCss(title.$view, "webix_sidebar_selected");
		}

		if(selectedId == id){
			webix.html.addCss(title.$view, "webix_selected", true);
		}
		else{
			webix.html.removeCss(title.$view, "webix_selected");
		}
	},
	_updateList: function(id){
		var list = this.getPopupList();
		list.masterId = id;
		var selectedId = this.getSelectedId();
		var data = [].concat(webix.copy(this.data.getBranch(id)));
		list.unselect();
		if(data.length){
			list.show();
			list.data.importData(data);
			if(list.exists(selectedId))
				list.select(selectedId);
		}
		else
			list.hide();

	},
	_initContextMenu: function(){
		var config = this.config,
			popup;

		if(config.popup){
			popup = webix.$$(config.popup);
		}
		if(!popup){
			var dirClassName = (config.position=="left"?"webix_sidebar_popup_left":"webix_sidebar_popup_right");
			var popupConfig = {
				view:"popup",
				css: "webix_sidebar_popup "+dirClassName,
				autofit: false,
				width: this._fullWidth - this.config.collapsedWidth,
				borderless: true,
				padding:0,
				body:{
					rows:[
						{
							view: "template", 	borderless: true, css: "webix_sidebar_popup_title",
							template: "#value#", height: this.config.titleHeight+2,
							on:{
								onMasterSelect: function(id){
									var master = this.getTopParentView().master;
									if( master && master.getParentId(id) == this.masterId){
										webix.html.addCss(this.$view, "webix_sidebar_selected", true);
									}
									if(master.config.collapsed && master.getItem(id).$level ==1){
										webix.html.addCss(this.$view, "webix_selected", true);
									}
								}
							},
							onClick:{
								webix_template: function(){
									var id = this.masterId;
									var master = this.getTopParentView().master;
									if(!master.getItem(id).$count)
										master.select(id);
								}
							}
						},
						{ view: "list", select: true, 	borderless: true, css: "webix_sidebar_popup_list",  autoheight: true,
							on:{
								onAfterSelect: function(id){
									this.getTopParentView().master.select(id);
								}
							}
						}
					]
				}
			};
			webix.extend(popupConfig, config.popup||{}, true);
			popup = webix.ui(popupConfig);
			popup.master = this;
		}
		popup.attachEvent("onBeforeShow",function(){
			return config.collapsed;
		});
		var master = this;
		var h = webix.event(document.body,"mousemove", function(e){
			var trg = e.target || e.srcElement;
			if(!popup.config.hidden && !popup.$view.contains(trg) && !master.$view.firstChild.contains(trg)){
				popup.hide();
			}
		});
		this.attachEvent("onDestruct", function(){
			if(webix.removeEvent)
				webix.removeEvent(h);

            if(webix.eventRemove)
                webix.eventRemove(h);

			if(popup)
				popup.destructor();
		});
		config.popupId = popup.config.id;
	},
	getPopup: function(){
		return webix.$$(this.config.popupId);
	},
	getPopupTitle: function(){
		var popup = this.getPopup();
		return popup.getBody().getChildViews()[0];
	},
	getPopupList: function(){
		var popup = this.getPopup();
		return popup.getBody().getChildViews()[1];
	},
	position_setter:function(value){
		var newPos = value;
		var oldPos = value=="left"?"right":"left";

		webix.html.removeCss(this.$view, "webix_sidebar_"+oldPos);
		webix.html.addCss(this.$view, "webix_sidebar_"+newPos, true);

		var popup = this.getPopup();
		if(popup){
			var popupEl = popup.$view;
			webix.html.removeCss(popupEl, "webix_sidebar_popup_"+oldPos);
			webix.html.addCss(popupEl, "webix_sidebar_popup_"+newPos, true);
		}
		return value;
	},
	collapse: function(){
		this.define("collapsed", true);
	},
	expand: function(){
		this.define("collapsed", false);
	},
	toggle: function(){
		var collapsed = !this.config.collapsed;
		this.define("collapsed", collapsed);
	},
	collapsed_setter: function(value){
		var width;

		if(!value){
			width = this._fullWidth;
		}
		else{
			width = this.config.collapsedWidth;
			this.closeAll();
		}

		if(!value){
			this.type.collapsed = false;
			webix.html.addCss(this.$view, "webix_sidebar_expanded", true);
		}
		else{
			this.type.collapsed = true;
			webix.html.removeCss(this.$view, "webix_sidebar_expanded");
		}

		this.define("width",width);
		this.resize();

		return value;
	}
}, webix.ui.tree);

webix.type(webix.ui.tree, {
	name:"sideBar",
	height: "auto",
	css: "webix_sidebar",
	template: function(obj, common){
		if(common.collapsed)
			return common.icon(obj, common);
		return   common.arrow(obj, common)+common.icon(obj, common) +"<span>"+obj.value+"</span>";
	},
	arrow: function(obj, common){
		var html = "";
		var open = "";
		for (var i=1; i<=obj.$level; i++){
			if (i==obj.$level && obj.$count){
				var className = "webix_sidebar_dir_icon webix_icon fa-angle-"+(obj.open?"down":"left");
				html+="<span class='"+className+"'></span>";
			}
		}
		return html;
	},
	icon:function(obj, common){
		if(obj.icon)
			return "<span class='webix_icon webix_sidebar_icon fa-"+obj.icon+"'></span>";
		return "";
	}
});
webix.i18n.locales["ru-RU"]={
	groupDelimiter:" ",
	groupSize:3,
	decimalDelimiter:",",
	decimalSize:2,

	dateFormat:"%d.%m.%Y",
	timeFormat:"%H:%i",
	longDateFormat:"%d %F %Y",
	fullDateFormat:"%d.%m.%Y %H:%i",

	price:"{obj} руб.",
	priceSettings:null, //use number defaults
	
	calendar:{
		monthFull:["Январь", "Февраль", "Март", "Апрель", "Maй", "Июнь", "Июль", "Август", "Сентябрь", "Oктябрь", "Ноябрь", "Декабрь"],
		monthShort:["Янв", "Фев", "Maр", "Aпр", "Maй", "Июн", "Июл", "Aвг", "Сен", "Окт", "Ноя", "Дек"],
		dayFull:[ "Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
    	dayShort:["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
		hours: "Часы",
		minutes: "Минуты",
		done: "Гoтовo",
		clear: "Очистить",
		today: "Сегодня"
	},

    dataExport:{
		page:"Страница",
		of:"из"
    },
    PDFviewer:{
		of:"из",
		automaticZoom:"Автоматический зум",
		actualSize:"Настоящий размер",
		pageFit:"Размер страницы",
		pageWidth:"Ширина страницы",
		pageHeight:"Высота страницы"
    },
    aria:{
		calendar:"Календарь",
		increaseValue:"Увеличить значение",
		decreaseValue:"Уменьшить значение",
		navMonth:["Предыдущий месяц", "Следующий месяц"],
		navYear:["Предыдущий год", "Следующий год"],
		navDecade:["Предыдущие десять лет", "Следующие десять лет"],
		dateFormat:"%d %F %Y",
		monthFormat:"%F %Y",
		yearFormat:"%Y",
		hourFormat:"Часы: %H",
		minuteFormat:"Минуты: %i",
		removeItem:"Удалить элемент",
		pages:["Первая страница", "Предыдущая страница", "Следующая страница", "Последняя страница"],
		page:"Страница",
		headermenu:"Меню шапки таблицы",
		openGroup:"Развернуть группу столбцов",
		closeGroup:"Свернуть группу столбцов",
		closeTab:"Закрыть вкладку",
		showTabs:"Показать больше вкладок",
		resetTreeMap:"Вернуться к первоначальному представлению",
		navTreeMap:"Перейти на уровень выше",
		nextTab:"Следующая вкладка",
		prevTab:"Предыдущая вкладка",
		multitextSection:"Добавить элемент",
		multitextextraSection:"Удалить элемент",
		showChart:"Показать чарт",
		hideChart:"Спрятать чарт",
		resizeChart:"Изменить размер чарта"
    },
    richtext:{
        underline: "Подчеркивание",
        bold: "Жирный",
        italic: "Курсив"
    },
    combo:{
    	select:"Выбрать",
        selectAll:"Выбрать все",
        unselectAll:"Сброс выбора"
    },
    message:{
    	ok:"OK",
    	cancel:"Отмена"
    }
};
webix.i18n.locales["en-US"]={
    groupDelimiter:",",
    groupSize:3,
    decimalDelimiter:".",
    decimalSize:2,

    dateFormat:"%m/%d/%Y",
    timeFormat:"%H:%i",
    longDateFormat:"%d %F %Y",
    fullDateFormat:"%m/%d/%Y %H:%i",
    //am:["am","AM"],
    //pm:["pm","PM"],

    price:"${obj}",
    priceSettings:{
        groupDelimiter:",",
        groupSize:3,
        decimalDelimiter:".",
        decimalSize:2
    },
    fileSize: ["b","Kb","Mb","Gb","Tb","Pb","Eb"],

    calendar: {
        monthFull:["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        monthShort:["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        dayFull:["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        dayShort:["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        hours: "Hours",
        minutes: "Minutes",
        done:"Done",
        clear: "Clear",
        today: "Today"
    },

    dataExport:{
        page:"Page",
        of:"of"
    },
    PDFviewer:{
        of:"of",
        automaticZoom:"Automatic Zoom",
        actualSize:"Actual Size",
        pageFit:"Page Fit",
        pageWidth:"Page Width",
        pageHeight:"Page Height"
    },
    aria:{
        calendar:"Calendar",
        increaseValue:"Increase value",
        decreaseValue:"Decrease value",
        navMonth:["Previous month", "Next month"],
        navYear:["Previous year", "Next year"],
        navDecade:["Previous decade", "Next decade"],
        dateFormat:"%d %F %Y",
        monthFormat:"%F %Y",
        yearFormat:"%Y",
        hourFormat:"Hours: %H",
        minuteFormat:"Minutes: %i",
        removeItem:"Remove item",
        pages:["First page", "Previous page", "Next page", "Last page"],
        page:"Page",
        headermenu:"Header menu",
        openGroup:"Open column group",
        closeGroup:"Close column group",
        closeTab:"Close tab",
        showTabs:"Show more tabs",
        resetTreeMap:"Reset tree map",
        navTreeMap:"Level up",
        nextTab:"Next tab",
        prevTab:"Previous tab",
        multitextSection:"Add section",
        multitextextraSection:"Remove section",
        showChart:"Show chart",
        hideChart:"Hide chart",
        resizeChart:"Resize chart"
    },
    richtext:{
        underline: "Underline",
        bold: "Bold",
        italic: "Italic"
    },
    combo:{
        select:"Select",
        selectAll:"Select all",
        unselectAll:"Unselect all"
    },
    message:{
        ok:"OK",
        cancel:"Cancel"
    }
};
/*!
 * Socket.IO v2.3.0
 * (c) 2014-2019 Guillermo Rauch
 * Released under the MIT License.
 */
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.io=e():t.io=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return t[r].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){function r(t,e){"object"==typeof t&&(e=t,t=void 0),e=e||{};var n,r=o(t),i=r.source,u=r.id,p=r.path,h=c[u]&&p in c[u].nsps,f=e.forceNew||e["force new connection"]||!1===e.multiplex||h;return f?(a("ignoring socket cache for %s",i),n=s(i,e)):(c[u]||(a("new io instance for %s",i),c[u]=s(i,e)),n=c[u]),r.query&&!e.query&&(e.query=r.query),n.socket(r.path,e)}var o=n(1),i=n(7),s=n(15),a=n(3)("socket.io-client");t.exports=e=r;var c=e.managers={};e.protocol=i.protocol,e.connect=r,e.Manager=n(15),e.Socket=n(39)},function(t,e,n){function r(t,e){var n=t;e=e||"undefined"!=typeof location&&location,null==t&&(t=e.protocol+"//"+e.host),"string"==typeof t&&("/"===t.charAt(0)&&(t="/"===t.charAt(1)?e.protocol+t:e.host+t),/^(https?|wss?):\/\//.test(t)||(i("protocol-less url %s",t),t="undefined"!=typeof e?e.protocol+"//"+t:"https://"+t),i("parse %s",t),n=o(t)),n.port||(/^(http|ws)$/.test(n.protocol)?n.port="80":/^(http|ws)s$/.test(n.protocol)&&(n.port="443")),n.path=n.path||"/";var r=n.host.indexOf(":")!==-1,s=r?"["+n.host+"]":n.host;return n.id=n.protocol+"://"+s+":"+n.port,n.href=n.protocol+"://"+s+(e&&e.port===n.port?"":":"+n.port),n}var o=n(2),i=n(3)("socket.io-client:url");t.exports=r},function(t,e){var n=/^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,r=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];t.exports=function(t){var e=t,o=t.indexOf("["),i=t.indexOf("]");o!=-1&&i!=-1&&(t=t.substring(0,o)+t.substring(o,i).replace(/:/g,";")+t.substring(i,t.length));for(var s=n.exec(t||""),a={},c=14;c--;)a[r[c]]=s[c]||"";return o!=-1&&i!=-1&&(a.source=e,a.host=a.host.substring(1,a.host.length-1).replace(/;/g,":"),a.authority=a.authority.replace("[","").replace("]","").replace(/;/g,":"),a.ipv6uri=!0),a}},function(t,e,n){(function(r){"use strict";function o(){return!("undefined"==typeof window||!window.process||"renderer"!==window.process.type&&!window.process.__nwjs)||("undefined"==typeof navigator||!navigator.userAgent||!navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))&&("undefined"!=typeof document&&document.documentElement&&document.documentElement.style&&document.documentElement.style.WebkitAppearance||"undefined"!=typeof window&&window.console&&(window.console.firebug||window.console.exception&&window.console.table)||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))}function i(e){if(e[0]=(this.useColors?"%c":"")+this.namespace+(this.useColors?" %c":" ")+e[0]+(this.useColors?"%c ":" ")+"+"+t.exports.humanize(this.diff),this.useColors){var n="color: "+this.color;e.splice(1,0,n,"color: inherit");var r=0,o=0;e[0].replace(/%[a-zA-Z%]/g,function(t){"%%"!==t&&(r++,"%c"===t&&(o=r))}),e.splice(o,0,n)}}function s(){var t;return"object"===("undefined"==typeof console?"undefined":p(console))&&console.log&&(t=console).log.apply(t,arguments)}function a(t){try{t?e.storage.setItem("debug",t):e.storage.removeItem("debug")}catch(n){}}function c(){var t=void 0;try{t=e.storage.getItem("debug")}catch(n){}return!t&&"undefined"!=typeof r&&"env"in r&&(t=r.env.DEBUG),t}function u(){try{return localStorage}catch(t){}}var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.log=s,e.formatArgs=i,e.save=a,e.load=c,e.useColors=o,e.storage=u(),e.colors=["#0000CC","#0000FF","#0033CC","#0033FF","#0066CC","#0066FF","#0099CC","#0099FF","#00CC00","#00CC33","#00CC66","#00CC99","#00CCCC","#00CCFF","#3300CC","#3300FF","#3333CC","#3333FF","#3366CC","#3366FF","#3399CC","#3399FF","#33CC00","#33CC33","#33CC66","#33CC99","#33CCCC","#33CCFF","#6600CC","#6600FF","#6633CC","#6633FF","#66CC00","#66CC33","#9900CC","#9900FF","#9933CC","#9933FF","#99CC00","#99CC33","#CC0000","#CC0033","#CC0066","#CC0099","#CC00CC","#CC00FF","#CC3300","#CC3333","#CC3366","#CC3399","#CC33CC","#CC33FF","#CC6600","#CC6633","#CC9900","#CC9933","#CCCC00","#CCCC33","#FF0000","#FF0033","#FF0066","#FF0099","#FF00CC","#FF00FF","#FF3300","#FF3333","#FF3366","#FF3399","#FF33CC","#FF33FF","#FF6600","#FF6633","#FF9900","#FF9933","#FFCC00","#FFCC33"],t.exports=n(5)(e);var h=t.exports.formatters;h.j=function(t){try{return JSON.stringify(t)}catch(e){return"[UnexpectedJSONParseError]: "+e.message}}}).call(e,n(4))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(t){if(p===setTimeout)return setTimeout(t,0);if((p===n||!p)&&setTimeout)return p=setTimeout,setTimeout(t,0);try{return p(t,0)}catch(e){try{return p.call(null,t,0)}catch(e){return p.call(this,t,0)}}}function i(t){if(h===clearTimeout)return clearTimeout(t);if((h===r||!h)&&clearTimeout)return h=clearTimeout,clearTimeout(t);try{return h(t)}catch(e){try{return h.call(null,t)}catch(e){return h.call(this,t)}}}function s(){y&&l&&(y=!1,l.length?d=l.concat(d):m=-1,d.length&&a())}function a(){if(!y){var t=o(s);y=!0;for(var e=d.length;e;){for(l=d,d=[];++m<e;)l&&l[m].run();m=-1,e=d.length}l=null,y=!1,i(t)}}function c(t,e){this.fun=t,this.array=e}function u(){}var p,h,f=t.exports={};!function(){try{p="function"==typeof setTimeout?setTimeout:n}catch(t){p=n}try{h="function"==typeof clearTimeout?clearTimeout:r}catch(t){h=r}}();var l,d=[],y=!1,m=-1;f.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];d.push(new c(t,e)),1!==d.length||y||o(a)},c.prototype.run=function(){this.fun.apply(null,this.array)},f.title="browser",f.browser=!0,f.env={},f.argv=[],f.version="",f.versions={},f.on=u,f.addListener=u,f.once=u,f.off=u,f.removeListener=u,f.removeAllListeners=u,f.emit=u,f.prependListener=u,f.prependOnceListener=u,f.listeners=function(t){return[]},f.binding=function(t){throw new Error("process.binding is not supported")},f.cwd=function(){return"/"},f.chdir=function(t){throw new Error("process.chdir is not supported")},f.umask=function(){return 0}},function(t,e,n){"use strict";function r(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function o(t){function e(t){for(var e=0,n=0;n<t.length;n++)e=(e<<5)-e+t.charCodeAt(n),e|=0;return o.colors[Math.abs(e)%o.colors.length]}function o(t){function n(){for(var t=arguments.length,e=Array(t),i=0;i<t;i++)e[i]=arguments[i];if(n.enabled){var s=n,a=Number(new Date),c=a-(r||a);s.diff=c,s.prev=r,s.curr=a,r=a,e[0]=o.coerce(e[0]),"string"!=typeof e[0]&&e.unshift("%O");var u=0;e[0]=e[0].replace(/%([a-zA-Z%])/g,function(t,n){if("%%"===t)return t;u++;var r=o.formatters[n];if("function"==typeof r){var i=e[u];t=r.call(s,i),e.splice(u,1),u--}return t}),o.formatArgs.call(s,e);var p=s.log||o.log;p.apply(s,e)}}var r=void 0;return n.namespace=t,n.enabled=o.enabled(t),n.useColors=o.useColors(),n.color=e(t),n.destroy=i,n.extend=s,"function"==typeof o.init&&o.init(n),o.instances.push(n),n}function i(){var t=o.instances.indexOf(this);return t!==-1&&(o.instances.splice(t,1),!0)}function s(t,e){var n=o(this.namespace+("undefined"==typeof e?":":e)+t);return n.log=this.log,n}function a(t){o.save(t),o.names=[],o.skips=[];var e=void 0,n=("string"==typeof t?t:"").split(/[\s,]+/),r=n.length;for(e=0;e<r;e++)n[e]&&(t=n[e].replace(/\*/g,".*?"),"-"===t[0]?o.skips.push(new RegExp("^"+t.substr(1)+"$")):o.names.push(new RegExp("^"+t+"$")));for(e=0;e<o.instances.length;e++){var i=o.instances[e];i.enabled=o.enabled(i.namespace)}}function c(){var t=[].concat(r(o.names.map(p)),r(o.skips.map(p).map(function(t){return"-"+t}))).join(",");return o.enable(""),t}function u(t){if("*"===t[t.length-1])return!0;var e=void 0,n=void 0;for(e=0,n=o.skips.length;e<n;e++)if(o.skips[e].test(t))return!1;for(e=0,n=o.names.length;e<n;e++)if(o.names[e].test(t))return!0;return!1}function p(t){return t.toString().substring(2,t.toString().length-2).replace(/\.\*\?$/,"*")}function h(t){return t instanceof Error?t.stack||t.message:t}return o.debug=o,o["default"]=o,o.coerce=h,o.disable=c,o.enable=a,o.enabled=u,o.humanize=n(6),Object.keys(t).forEach(function(e){o[e]=t[e]}),o.instances=[],o.names=[],o.skips=[],o.formatters={},o.selectColor=e,o.enable(o.load()),o}t.exports=o},function(t,e){function n(t){if(t=String(t),!(t.length>100)){var e=/^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);if(e){var n=parseFloat(e[1]),r=(e[2]||"ms").toLowerCase();switch(r){case"years":case"year":case"yrs":case"yr":case"y":return n*h;case"weeks":case"week":case"w":return n*p;case"days":case"day":case"d":return n*u;case"hours":case"hour":case"hrs":case"hr":case"h":return n*c;case"minutes":case"minute":case"mins":case"min":case"m":return n*a;case"seconds":case"second":case"secs":case"sec":case"s":return n*s;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return n;default:return}}}}function r(t){var e=Math.abs(t);return e>=u?Math.round(t/u)+"d":e>=c?Math.round(t/c)+"h":e>=a?Math.round(t/a)+"m":e>=s?Math.round(t/s)+"s":t+"ms"}function o(t){var e=Math.abs(t);return e>=u?i(t,e,u,"day"):e>=c?i(t,e,c,"hour"):e>=a?i(t,e,a,"minute"):e>=s?i(t,e,s,"second"):t+" ms"}function i(t,e,n,r){var o=e>=1.5*n;return Math.round(t/n)+" "+r+(o?"s":"")}var s=1e3,a=60*s,c=60*a,u=24*c,p=7*u,h=365.25*u;t.exports=function(t,e){e=e||{};var i=typeof t;if("string"===i&&t.length>0)return n(t);if("number"===i&&isFinite(t))return e["long"]?o(t):r(t);throw new Error("val is not a non-empty string or a valid number. val="+JSON.stringify(t))}},function(t,e,n){function r(){}function o(t){var n=""+t.type;if(e.BINARY_EVENT!==t.type&&e.BINARY_ACK!==t.type||(n+=t.attachments+"-"),t.nsp&&"/"!==t.nsp&&(n+=t.nsp+","),null!=t.id&&(n+=t.id),null!=t.data){var r=i(t.data);if(r===!1)return g;n+=r}return f("encoded %j as %s",t,n),n}function i(t){try{return JSON.stringify(t)}catch(e){return!1}}function s(t,e){function n(t){var n=d.deconstructPacket(t),r=o(n.packet),i=n.buffers;i.unshift(r),e(i)}d.removeBlobs(t,n)}function a(){this.reconstructor=null}function c(t){var n=0,r={type:Number(t.charAt(0))};if(null==e.types[r.type])return h("unknown packet type "+r.type);if(e.BINARY_EVENT===r.type||e.BINARY_ACK===r.type){for(var o="";"-"!==t.charAt(++n)&&(o+=t.charAt(n),n!=t.length););if(o!=Number(o)||"-"!==t.charAt(n))throw new Error("Illegal attachments");r.attachments=Number(o)}if("/"===t.charAt(n+1))for(r.nsp="";++n;){var i=t.charAt(n);if(","===i)break;if(r.nsp+=i,n===t.length)break}else r.nsp="/";var s=t.charAt(n+1);if(""!==s&&Number(s)==s){for(r.id="";++n;){var i=t.charAt(n);if(null==i||Number(i)!=i){--n;break}if(r.id+=t.charAt(n),n===t.length)break}r.id=Number(r.id)}if(t.charAt(++n)){var a=u(t.substr(n)),c=a!==!1&&(r.type===e.ERROR||y(a));if(!c)return h("invalid payload");r.data=a}return f("decoded %s as %j",t,r),r}function u(t){try{return JSON.parse(t)}catch(e){return!1}}function p(t){this.reconPack=t,this.buffers=[]}function h(t){return{type:e.ERROR,data:"parser error: "+t}}var f=n(8)("socket.io-parser"),l=n(11),d=n(12),y=n(13),m=n(14);e.protocol=4,e.types=["CONNECT","DISCONNECT","EVENT","ACK","ERROR","BINARY_EVENT","BINARY_ACK"],e.CONNECT=0,e.DISCONNECT=1,e.EVENT=2,e.ACK=3,e.ERROR=4,e.BINARY_EVENT=5,e.BINARY_ACK=6,e.Encoder=r,e.Decoder=a;var g=e.ERROR+'"encode error"';r.prototype.encode=function(t,n){if(f("encoding packet %j",t),e.BINARY_EVENT===t.type||e.BINARY_ACK===t.type)s(t,n);else{var r=o(t);n([r])}},l(a.prototype),a.prototype.add=function(t){var n;if("string"==typeof t)n=c(t),e.BINARY_EVENT===n.type||e.BINARY_ACK===n.type?(this.reconstructor=new p(n),0===this.reconstructor.reconPack.attachments&&this.emit("decoded",n)):this.emit("decoded",n);else{if(!m(t)&&!t.base64)throw new Error("Unknown type: "+t);if(!this.reconstructor)throw new Error("got binary data when not reconstructing a packet");n=this.reconstructor.takeBinaryData(t),n&&(this.reconstructor=null,this.emit("decoded",n))}},a.prototype.destroy=function(){this.reconstructor&&this.reconstructor.finishedReconstruction()},p.prototype.takeBinaryData=function(t){if(this.buffers.push(t),this.buffers.length===this.reconPack.attachments){var e=d.reconstructPacket(this.reconPack,this.buffers);return this.finishedReconstruction(),e}return null},p.prototype.finishedReconstruction=function(){this.reconPack=null,this.buffers=[]}},function(t,e,n){(function(r){"use strict";function o(){return!("undefined"==typeof window||!window.process||"renderer"!==window.process.type)||("undefined"==typeof navigator||!navigator.userAgent||!navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))&&("undefined"!=typeof document&&document.documentElement&&document.documentElement.style&&document.documentElement.style.WebkitAppearance||"undefined"!=typeof window&&window.console&&(window.console.firebug||window.console.exception&&window.console.table)||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))}function i(t){var n=this.useColors;if(t[0]=(n?"%c":"")+this.namespace+(n?" %c":" ")+t[0]+(n?"%c ":" ")+"+"+e.humanize(this.diff),n){var r="color: "+this.color;t.splice(1,0,r,"color: inherit");var o=0,i=0;t[0].replace(/%[a-zA-Z%]/g,function(t){"%%"!==t&&(o++,"%c"===t&&(i=o))}),t.splice(i,0,r)}}function s(){return"object"===("undefined"==typeof console?"undefined":p(console))&&console.log&&Function.prototype.apply.call(console.log,console,arguments)}function a(t){try{null==t?e.storage.removeItem("debug"):e.storage.debug=t}catch(n){}}function c(){var t;try{t=e.storage.debug}catch(n){}return!t&&"undefined"!=typeof r&&"env"in r&&(t=r.env.DEBUG),t}function u(){try{return window.localStorage}catch(t){}}var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e=t.exports=n(9),e.log=s,e.formatArgs=i,e.save=a,e.load=c,e.useColors=o,e.storage="undefined"!=typeof chrome&&"undefined"!=typeof chrome.storage?chrome.storage.local:u(),e.colors=["#0000CC","#0000FF","#0033CC","#0033FF","#0066CC","#0066FF","#0099CC","#0099FF","#00CC00","#00CC33","#00CC66","#00CC99","#00CCCC","#00CCFF","#3300CC","#3300FF","#3333CC","#3333FF","#3366CC","#3366FF","#3399CC","#3399FF","#33CC00","#33CC33","#33CC66","#33CC99","#33CCCC","#33CCFF","#6600CC","#6600FF","#6633CC","#6633FF","#66CC00","#66CC33","#9900CC","#9900FF","#9933CC","#9933FF","#99CC00","#99CC33","#CC0000","#CC0033","#CC0066","#CC0099","#CC00CC","#CC00FF","#CC3300","#CC3333","#CC3366","#CC3399","#CC33CC","#CC33FF","#CC6600","#CC6633","#CC9900","#CC9933","#CCCC00","#CCCC33","#FF0000","#FF0033","#FF0066","#FF0099","#FF00CC","#FF00FF","#FF3300","#FF3333","#FF3366","#FF3399","#FF33CC","#FF33FF","#FF6600","#FF6633","#FF9900","#FF9933","#FFCC00","#FFCC33"],e.formatters.j=function(t){try{return JSON.stringify(t)}catch(e){return"[UnexpectedJSONParseError]: "+e.message}},e.enable(c())}).call(e,n(4))},function(t,e,n){"use strict";function r(t){var n,r=0;for(n in t)r=(r<<5)-r+t.charCodeAt(n),r|=0;return e.colors[Math.abs(r)%e.colors.length]}function o(t){function n(){if(n.enabled){var t=n,r=+new Date,i=r-(o||r);t.diff=i,t.prev=o,t.curr=r,o=r;for(var s=new Array(arguments.length),a=0;a<s.length;a++)s[a]=arguments[a];s[0]=e.coerce(s[0]),"string"!=typeof s[0]&&s.unshift("%O");var c=0;s[0]=s[0].replace(/%([a-zA-Z%])/g,function(n,r){if("%%"===n)return n;c++;var o=e.formatters[r];if("function"==typeof o){var i=s[c];n=o.call(t,i),s.splice(c,1),c--}return n}),e.formatArgs.call(t,s);var u=n.log||e.log||console.log.bind(console);u.apply(t,s)}}var o;return n.namespace=t,n.enabled=e.enabled(t),n.useColors=e.useColors(),n.color=r(t),n.destroy=i,"function"==typeof e.init&&e.init(n),e.instances.push(n),n}function i(){var t=e.instances.indexOf(this);return t!==-1&&(e.instances.splice(t,1),!0)}function s(t){e.save(t),e.names=[],e.skips=[];var n,r=("string"==typeof t?t:"").split(/[\s,]+/),o=r.length;for(n=0;n<o;n++)r[n]&&(t=r[n].replace(/\*/g,".*?"),"-"===t[0]?e.skips.push(new RegExp("^"+t.substr(1)+"$")):e.names.push(new RegExp("^"+t+"$")));for(n=0;n<e.instances.length;n++){var i=e.instances[n];i.enabled=e.enabled(i.namespace)}}function a(){e.enable("")}function c(t){if("*"===t[t.length-1])return!0;var n,r;for(n=0,r=e.skips.length;n<r;n++)if(e.skips[n].test(t))return!1;for(n=0,r=e.names.length;n<r;n++)if(e.names[n].test(t))return!0;return!1}function u(t){return t instanceof Error?t.stack||t.message:t}e=t.exports=o.debug=o["default"]=o,e.coerce=u,e.disable=a,e.enable=s,e.enabled=c,e.humanize=n(10),e.instances=[],e.names=[],e.skips=[],e.formatters={}},function(t,e){function n(t){if(t=String(t),!(t.length>100)){var e=/^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t);if(e){var n=parseFloat(e[1]),r=(e[2]||"ms").toLowerCase();switch(r){case"years":case"year":case"yrs":case"yr":case"y":return n*p;case"days":case"day":case"d":return n*u;case"hours":case"hour":case"hrs":case"hr":case"h":return n*c;case"minutes":case"minute":case"mins":case"min":case"m":return n*a;case"seconds":case"second":case"secs":case"sec":case"s":return n*s;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return n;default:return}}}}function r(t){return t>=u?Math.round(t/u)+"d":t>=c?Math.round(t/c)+"h":t>=a?Math.round(t/a)+"m":t>=s?Math.round(t/s)+"s":t+"ms"}function o(t){return i(t,u,"day")||i(t,c,"hour")||i(t,a,"minute")||i(t,s,"second")||t+" ms"}function i(t,e,n){if(!(t<e))return t<1.5*e?Math.floor(t/e)+" "+n:Math.ceil(t/e)+" "+n+"s"}var s=1e3,a=60*s,c=60*a,u=24*c,p=365.25*u;t.exports=function(t,e){e=e||{};var i=typeof t;if("string"===i&&t.length>0)return n(t);if("number"===i&&isNaN(t)===!1)return e["long"]?o(t):r(t);throw new Error("val is not a non-empty string or a valid number. val="+JSON.stringify(t))}},function(t,e,n){function r(t){if(t)return o(t)}function o(t){for(var e in r.prototype)t[e]=r.prototype[e];return t}t.exports=r,r.prototype.on=r.prototype.addEventListener=function(t,e){return this._callbacks=this._callbacks||{},(this._callbacks["$"+t]=this._callbacks["$"+t]||[]).push(e),this},r.prototype.once=function(t,e){function n(){this.off(t,n),e.apply(this,arguments)}return n.fn=e,this.on(t,n),this},r.prototype.off=r.prototype.removeListener=r.prototype.removeAllListeners=r.prototype.removeEventListener=function(t,e){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var n=this._callbacks["$"+t];if(!n)return this;if(1==arguments.length)return delete this._callbacks["$"+t],this;for(var r,o=0;o<n.length;o++)if(r=n[o],r===e||r.fn===e){n.splice(o,1);break}return this},r.prototype.emit=function(t){this._callbacks=this._callbacks||{};var e=[].slice.call(arguments,1),n=this._callbacks["$"+t];if(n){n=n.slice(0);for(var r=0,o=n.length;r<o;++r)n[r].apply(this,e)}return this},r.prototype.listeners=function(t){return this._callbacks=this._callbacks||{},this._callbacks["$"+t]||[]},r.prototype.hasListeners=function(t){return!!this.listeners(t).length}},function(t,e,n){function r(t,e){if(!t)return t;if(s(t)){var n={_placeholder:!0,num:e.length};return e.push(t),n}if(i(t)){for(var o=new Array(t.length),a=0;a<t.length;a++)o[a]=r(t[a],e);return o}if("object"==typeof t&&!(t instanceof Date)){var o={};for(var c in t)o[c]=r(t[c],e);return o}return t}function o(t,e){if(!t)return t;if(t&&t._placeholder)return e[t.num];if(i(t))for(var n=0;n<t.length;n++)t[n]=o(t[n],e);else if("object"==typeof t)for(var r in t)t[r]=o(t[r],e);return t}var i=n(13),s=n(14),a=Object.prototype.toString,c="function"==typeof Blob||"undefined"!=typeof Blob&&"[object BlobConstructor]"===a.call(Blob),u="function"==typeof File||"undefined"!=typeof File&&"[object FileConstructor]"===a.call(File);e.deconstructPacket=function(t){var e=[],n=t.data,o=t;return o.data=r(n,e),o.attachments=e.length,{packet:o,buffers:e}},e.reconstructPacket=function(t,e){return t.data=o(t.data,e),t.attachments=void 0,t},e.removeBlobs=function(t,e){function n(t,a,p){if(!t)return t;if(c&&t instanceof Blob||u&&t instanceof File){r++;var h=new FileReader;h.onload=function(){p?p[a]=this.result:o=this.result,--r||e(o)},h.readAsArrayBuffer(t)}else if(i(t))for(var f=0;f<t.length;f++)n(t[f],f,t);else if("object"==typeof t&&!s(t))for(var l in t)n(t[l],l,t)}var r=0,o=t;n(o),r||e(o)}},function(t,e){var n={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},function(t,e){function n(t){return r&&Buffer.isBuffer(t)||o&&(t instanceof ArrayBuffer||i(t))}t.exports=n;var r="function"==typeof Buffer&&"function"==typeof Buffer.isBuffer,o="function"==typeof ArrayBuffer,i=function(t){return"function"==typeof ArrayBuffer.isView?ArrayBuffer.isView(t):t.buffer instanceof ArrayBuffer}},function(t,e,n){function r(t,e){if(!(this instanceof r))return new r(t,e);t&&"object"==typeof t&&(e=t,t=void 0),e=e||{},e.path=e.path||"/socket.io",this.nsps={},this.subs=[],this.opts=e,this.reconnection(e.reconnection!==!1),this.reconnectionAttempts(e.reconnectionAttempts||1/0),this.reconnectionDelay(e.reconnectionDelay||1e3),this.reconnectionDelayMax(e.reconnectionDelayMax||5e3),this.randomizationFactor(e.randomizationFactor||.5),this.backoff=new f({min:this.reconnectionDelay(),max:this.reconnectionDelayMax(),jitter:this.randomizationFactor()}),this.timeout(null==e.timeout?2e4:e.timeout),this.readyState="closed",this.uri=t,this.connecting=[],this.lastPing=null,this.encoding=!1,this.packetBuffer=[];var n=e.parser||a;this.encoder=new n.Encoder,this.decoder=new n.Decoder,this.autoConnect=e.autoConnect!==!1,this.autoConnect&&this.open()}var o=n(16),i=n(39),s=n(11),a=n(7),c=n(41),u=n(42),p=n(3)("socket.io-client:manager"),h=n(38),f=n(43),l=Object.prototype.hasOwnProperty;t.exports=r,r.prototype.emitAll=function(){this.emit.apply(this,arguments);for(var t in this.nsps)l.call(this.nsps,t)&&this.nsps[t].emit.apply(this.nsps[t],arguments)},r.prototype.updateSocketIds=function(){for(var t in this.nsps)l.call(this.nsps,t)&&(this.nsps[t].id=this.generateId(t))},r.prototype.generateId=function(t){return("/"===t?"":t+"#")+this.engine.id},s(r.prototype),r.prototype.reconnection=function(t){return arguments.length?(this._reconnection=!!t,this):this._reconnection},r.prototype.reconnectionAttempts=function(t){return arguments.length?(this._reconnectionAttempts=t,this):this._reconnectionAttempts},r.prototype.reconnectionDelay=function(t){return arguments.length?(this._reconnectionDelay=t,this.backoff&&this.backoff.setMin(t),this):this._reconnectionDelay},r.prototype.randomizationFactor=function(t){return arguments.length?(this._randomizationFactor=t,this.backoff&&this.backoff.setJitter(t),this):this._randomizationFactor},r.prototype.reconnectionDelayMax=function(t){return arguments.length?(this._reconnectionDelayMax=t,this.backoff&&this.backoff.setMax(t),this):this._reconnectionDelayMax},r.prototype.timeout=function(t){return arguments.length?(this._timeout=t,this):this._timeout},r.prototype.maybeReconnectOnOpen=function(){!this.reconnecting&&this._reconnection&&0===this.backoff.attempts&&this.reconnect()},r.prototype.open=r.prototype.connect=function(t,e){if(p("readyState %s",this.readyState),~this.readyState.indexOf("open"))return this;p("opening %s",this.uri),this.engine=o(this.uri,this.opts);var n=this.engine,r=this;this.readyState="opening",this.skipReconnect=!1;var i=c(n,"open",function(){r.onopen(),t&&t()}),s=c(n,"error",function(e){if(p("connect_error"),r.cleanup(),r.readyState="closed",r.emitAll("connect_error",e),t){var n=new Error("Connection error");n.data=e,t(n)}else r.maybeReconnectOnOpen()});if(!1!==this._timeout){var a=this._timeout;p("connect attempt will timeout after %d",a);var u=setTimeout(function(){p("connect attempt timed out after %d",a),i.destroy(),n.close(),n.emit("error","timeout"),r.emitAll("connect_timeout",a)},a);this.subs.push({destroy:function(){clearTimeout(u)}})}return this.subs.push(i),this.subs.push(s),this},r.prototype.onopen=function(){p("open"),this.cleanup(),this.readyState="open",this.emit("open");var t=this.engine;this.subs.push(c(t,"data",u(this,"ondata"))),this.subs.push(c(t,"ping",u(this,"onping"))),this.subs.push(c(t,"pong",u(this,"onpong"))),this.subs.push(c(t,"error",u(this,"onerror"))),this.subs.push(c(t,"close",u(this,"onclose"))),this.subs.push(c(this.decoder,"decoded",u(this,"ondecoded")))},r.prototype.onping=function(){this.lastPing=new Date,this.emitAll("ping")},r.prototype.onpong=function(){this.emitAll("pong",new Date-this.lastPing)},r.prototype.ondata=function(t){this.decoder.add(t)},r.prototype.ondecoded=function(t){this.emit("packet",t)},r.prototype.onerror=function(t){p("error",t),this.emitAll("error",t)},r.prototype.socket=function(t,e){function n(){~h(o.connecting,r)||o.connecting.push(r)}var r=this.nsps[t];if(!r){r=new i(this,t,e),this.nsps[t]=r;var o=this;r.on("connecting",n),r.on("connect",function(){r.id=o.generateId(t)}),this.autoConnect&&n()}return r},r.prototype.destroy=function(t){var e=h(this.connecting,t);~e&&this.connecting.splice(e,1),this.connecting.length||this.close()},r.prototype.packet=function(t){p("writing packet %j",t);var e=this;t.query&&0===t.type&&(t.nsp+="?"+t.query),e.encoding?e.packetBuffer.push(t):(e.encoding=!0,this.encoder.encode(t,function(n){for(var r=0;r<n.length;r++)e.engine.write(n[r],t.options);e.encoding=!1,e.processPacketQueue()}))},r.prototype.processPacketQueue=function(){if(this.packetBuffer.length>0&&!this.encoding){var t=this.packetBuffer.shift();this.packet(t)}},r.prototype.cleanup=function(){p("cleanup");for(var t=this.subs.length,e=0;e<t;e++){var n=this.subs.shift();n.destroy()}this.packetBuffer=[],this.encoding=!1,this.lastPing=null,this.decoder.destroy()},r.prototype.close=r.prototype.disconnect=function(){p("disconnect"),this.skipReconnect=!0,this.reconnecting=!1,"opening"===this.readyState&&this.cleanup(),this.backoff.reset(),this.readyState="closed",this.engine&&this.engine.close()},r.prototype.onclose=function(t){p("onclose"),this.cleanup(),this.backoff.reset(),this.readyState="closed",this.emit("close",t),this._reconnection&&!this.skipReconnect&&this.reconnect()},r.prototype.reconnect=function(){if(this.reconnecting||this.skipReconnect)return this;var t=this;if(this.backoff.attempts>=this._reconnectionAttempts)p("reconnect failed"),this.backoff.reset(),this.emitAll("reconnect_failed"),this.reconnecting=!1;else{var e=this.backoff.duration();p("will wait %dms before reconnect attempt",e),this.reconnecting=!0;var n=setTimeout(function(){t.skipReconnect||(p("attempting reconnect"),t.emitAll("reconnect_attempt",t.backoff.attempts),t.emitAll("reconnecting",t.backoff.attempts),t.skipReconnect||t.open(function(e){e?(p("reconnect attempt error"),t.reconnecting=!1,t.reconnect(),t.emitAll("reconnect_error",e.data)):(p("reconnect success"),t.onreconnect())}))},e);this.subs.push({destroy:function(){clearTimeout(n)}})}},r.prototype.onreconnect=function(){var t=this.backoff.attempts;this.reconnecting=!1,this.backoff.reset(),this.updateSocketIds(),this.emitAll("reconnect",t)}},function(t,e,n){t.exports=n(17),t.exports.parser=n(24)},function(t,e,n){function r(t,e){return this instanceof r?(e=e||{},t&&"object"==typeof t&&(e=t,t=null),t?(t=p(t),e.hostname=t.host,e.secure="https"===t.protocol||"wss"===t.protocol,e.port=t.port,t.query&&(e.query=t.query)):e.host&&(e.hostname=p(e.host).host),this.secure=null!=e.secure?e.secure:"undefined"!=typeof location&&"https:"===location.protocol,e.hostname&&!e.port&&(e.port=this.secure?"443":"80"),this.agent=e.agent||!1,this.hostname=e.hostname||("undefined"!=typeof location?location.hostname:"localhost"),this.port=e.port||("undefined"!=typeof location&&location.port?location.port:this.secure?443:80),this.query=e.query||{},"string"==typeof this.query&&(this.query=h.decode(this.query)),this.upgrade=!1!==e.upgrade,this.path=(e.path||"/engine.io").replace(/\/$/,"")+"/",this.forceJSONP=!!e.forceJSONP,this.jsonp=!1!==e.jsonp,this.forceBase64=!!e.forceBase64,this.enablesXDR=!!e.enablesXDR,this.withCredentials=!1!==e.withCredentials,this.timestampParam=e.timestampParam||"t",this.timestampRequests=e.timestampRequests,this.transports=e.transports||["polling","websocket"],this.transportOptions=e.transportOptions||{},this.readyState="",this.writeBuffer=[],this.prevBufferLen=0,this.policyPort=e.policyPort||843,this.rememberUpgrade=e.rememberUpgrade||!1,this.binaryType=null,this.onlyBinaryUpgrades=e.onlyBinaryUpgrades,this.perMessageDeflate=!1!==e.perMessageDeflate&&(e.perMessageDeflate||{}),!0===this.perMessageDeflate&&(this.perMessageDeflate={}),this.perMessageDeflate&&null==this.perMessageDeflate.threshold&&(this.perMessageDeflate.threshold=1024),this.pfx=e.pfx||null,this.key=e.key||null,this.passphrase=e.passphrase||null,this.cert=e.cert||null,this.ca=e.ca||null,this.ciphers=e.ciphers||null,this.rejectUnauthorized=void 0===e.rejectUnauthorized||e.rejectUnauthorized,this.forceNode=!!e.forceNode,this.isReactNative="undefined"!=typeof navigator&&"string"==typeof navigator.product&&"reactnative"===navigator.product.toLowerCase(),("undefined"==typeof self||this.isReactNative)&&(e.extraHeaders&&Object.keys(e.extraHeaders).length>0&&(this.extraHeaders=e.extraHeaders),e.localAddress&&(this.localAddress=e.localAddress)),this.id=null,this.upgrades=null,this.pingInterval=null,this.pingTimeout=null,this.pingIntervalTimer=null,this.pingTimeoutTimer=null,void this.open()):new r(t,e)}function o(t){var e={};for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n]);return e}var i=n(18),s=n(11),a=n(3)("engine.io-client:socket"),c=n(38),u=n(24),p=n(2),h=n(32);t.exports=r,r.priorWebsocketSuccess=!1,s(r.prototype),r.protocol=u.protocol,r.Socket=r,r.Transport=n(23),r.transports=n(18),r.parser=n(24),r.prototype.createTransport=function(t){a('creating transport "%s"',t);var e=o(this.query);e.EIO=u.protocol,e.transport=t;var n=this.transportOptions[t]||{};this.id&&(e.sid=this.id);var r=new i[t]({query:e,socket:this,agent:n.agent||this.agent,hostname:n.hostname||this.hostname,port:n.port||this.port,secure:n.secure||this.secure,path:n.path||this.path,forceJSONP:n.forceJSONP||this.forceJSONP,jsonp:n.jsonp||this.jsonp,forceBase64:n.forceBase64||this.forceBase64,enablesXDR:n.enablesXDR||this.enablesXDR,withCredentials:n.withCredentials||this.withCredentials,timestampRequests:n.timestampRequests||this.timestampRequests,timestampParam:n.timestampParam||this.timestampParam,policyPort:n.policyPort||this.policyPort,pfx:n.pfx||this.pfx,key:n.key||this.key,passphrase:n.passphrase||this.passphrase,cert:n.cert||this.cert,ca:n.ca||this.ca,ciphers:n.ciphers||this.ciphers,rejectUnauthorized:n.rejectUnauthorized||this.rejectUnauthorized,perMessageDeflate:n.perMessageDeflate||this.perMessageDeflate,extraHeaders:n.extraHeaders||this.extraHeaders,forceNode:n.forceNode||this.forceNode,localAddress:n.localAddress||this.localAddress,requestTimeout:n.requestTimeout||this.requestTimeout,protocols:n.protocols||void 0,isReactNative:this.isReactNative});return r},r.prototype.open=function(){var t;if(this.rememberUpgrade&&r.priorWebsocketSuccess&&this.transports.indexOf("websocket")!==-1)t="websocket";else{
if(0===this.transports.length){var e=this;return void setTimeout(function(){e.emit("error","No transports available")},0)}t=this.transports[0]}this.readyState="opening";try{t=this.createTransport(t)}catch(n){return this.transports.shift(),void this.open()}t.open(),this.setTransport(t)},r.prototype.setTransport=function(t){a("setting transport %s",t.name);var e=this;this.transport&&(a("clearing existing transport %s",this.transport.name),this.transport.removeAllListeners()),this.transport=t,t.on("drain",function(){e.onDrain()}).on("packet",function(t){e.onPacket(t)}).on("error",function(t){e.onError(t)}).on("close",function(){e.onClose("transport close")})},r.prototype.probe=function(t){function e(){if(f.onlyBinaryUpgrades){var e=!this.supportsBinary&&f.transport.supportsBinary;h=h||e}h||(a('probe transport "%s" opened',t),p.send([{type:"ping",data:"probe"}]),p.once("packet",function(e){if(!h)if("pong"===e.type&&"probe"===e.data){if(a('probe transport "%s" pong',t),f.upgrading=!0,f.emit("upgrading",p),!p)return;r.priorWebsocketSuccess="websocket"===p.name,a('pausing current transport "%s"',f.transport.name),f.transport.pause(function(){h||"closed"!==f.readyState&&(a("changing transport and sending upgrade packet"),u(),f.setTransport(p),p.send([{type:"upgrade"}]),f.emit("upgrade",p),p=null,f.upgrading=!1,f.flush())})}else{a('probe transport "%s" failed',t);var n=new Error("probe error");n.transport=p.name,f.emit("upgradeError",n)}}))}function n(){h||(h=!0,u(),p.close(),p=null)}function o(e){var r=new Error("probe error: "+e);r.transport=p.name,n(),a('probe transport "%s" failed because of error: %s',t,e),f.emit("upgradeError",r)}function i(){o("transport closed")}function s(){o("socket closed")}function c(t){p&&t.name!==p.name&&(a('"%s" works - aborting "%s"',t.name,p.name),n())}function u(){p.removeListener("open",e),p.removeListener("error",o),p.removeListener("close",i),f.removeListener("close",s),f.removeListener("upgrading",c)}a('probing transport "%s"',t);var p=this.createTransport(t,{probe:1}),h=!1,f=this;r.priorWebsocketSuccess=!1,p.once("open",e),p.once("error",o),p.once("close",i),this.once("close",s),this.once("upgrading",c),p.open()},r.prototype.onOpen=function(){if(a("socket open"),this.readyState="open",r.priorWebsocketSuccess="websocket"===this.transport.name,this.emit("open"),this.flush(),"open"===this.readyState&&this.upgrade&&this.transport.pause){a("starting upgrade probes");for(var t=0,e=this.upgrades.length;t<e;t++)this.probe(this.upgrades[t])}},r.prototype.onPacket=function(t){if("opening"===this.readyState||"open"===this.readyState||"closing"===this.readyState)switch(a('socket receive: type "%s", data "%s"',t.type,t.data),this.emit("packet",t),this.emit("heartbeat"),t.type){case"open":this.onHandshake(JSON.parse(t.data));break;case"pong":this.setPing(),this.emit("pong");break;case"error":var e=new Error("server error");e.code=t.data,this.onError(e);break;case"message":this.emit("data",t.data),this.emit("message",t.data)}else a('packet received with socket readyState "%s"',this.readyState)},r.prototype.onHandshake=function(t){this.emit("handshake",t),this.id=t.sid,this.transport.query.sid=t.sid,this.upgrades=this.filterUpgrades(t.upgrades),this.pingInterval=t.pingInterval,this.pingTimeout=t.pingTimeout,this.onOpen(),"closed"!==this.readyState&&(this.setPing(),this.removeListener("heartbeat",this.onHeartbeat),this.on("heartbeat",this.onHeartbeat))},r.prototype.onHeartbeat=function(t){clearTimeout(this.pingTimeoutTimer);var e=this;e.pingTimeoutTimer=setTimeout(function(){"closed"!==e.readyState&&e.onClose("ping timeout")},t||e.pingInterval+e.pingTimeout)},r.prototype.setPing=function(){var t=this;clearTimeout(t.pingIntervalTimer),t.pingIntervalTimer=setTimeout(function(){a("writing ping packet - expecting pong within %sms",t.pingTimeout),t.ping(),t.onHeartbeat(t.pingTimeout)},t.pingInterval)},r.prototype.ping=function(){var t=this;this.sendPacket("ping",function(){t.emit("ping")})},r.prototype.onDrain=function(){this.writeBuffer.splice(0,this.prevBufferLen),this.prevBufferLen=0,0===this.writeBuffer.length?this.emit("drain"):this.flush()},r.prototype.flush=function(){"closed"!==this.readyState&&this.transport.writable&&!this.upgrading&&this.writeBuffer.length&&(a("flushing %d packets in socket",this.writeBuffer.length),this.transport.send(this.writeBuffer),this.prevBufferLen=this.writeBuffer.length,this.emit("flush"))},r.prototype.write=r.prototype.send=function(t,e,n){return this.sendPacket("message",t,e,n),this},r.prototype.sendPacket=function(t,e,n,r){if("function"==typeof e&&(r=e,e=void 0),"function"==typeof n&&(r=n,n=null),"closing"!==this.readyState&&"closed"!==this.readyState){n=n||{},n.compress=!1!==n.compress;var o={type:t,data:e,options:n};this.emit("packetCreate",o),this.writeBuffer.push(o),r&&this.once("flush",r),this.flush()}},r.prototype.close=function(){function t(){r.onClose("forced close"),a("socket closing - telling transport to close"),r.transport.close()}function e(){r.removeListener("upgrade",e),r.removeListener("upgradeError",e),t()}function n(){r.once("upgrade",e),r.once("upgradeError",e)}if("opening"===this.readyState||"open"===this.readyState){this.readyState="closing";var r=this;this.writeBuffer.length?this.once("drain",function(){this.upgrading?n():t()}):this.upgrading?n():t()}return this},r.prototype.onError=function(t){a("socket error %j",t),r.priorWebsocketSuccess=!1,this.emit("error",t),this.onClose("transport error",t)},r.prototype.onClose=function(t,e){if("opening"===this.readyState||"open"===this.readyState||"closing"===this.readyState){a('socket close with reason: "%s"',t);var n=this;clearTimeout(this.pingIntervalTimer),clearTimeout(this.pingTimeoutTimer),this.transport.removeAllListeners("close"),this.transport.close(),this.transport.removeAllListeners(),this.readyState="closed",this.id=null,this.emit("close",t,e),n.writeBuffer=[],n.prevBufferLen=0}},r.prototype.filterUpgrades=function(t){for(var e=[],n=0,r=t.length;n<r;n++)~c(this.transports,t[n])&&e.push(t[n]);return e}},function(t,e,n){function r(t){var e,n=!1,r=!1,a=!1!==t.jsonp;if("undefined"!=typeof location){var c="https:"===location.protocol,u=location.port;u||(u=c?443:80),n=t.hostname!==location.hostname||u!==t.port,r=t.secure!==c}if(t.xdomain=n,t.xscheme=r,e=new o(t),"open"in e&&!t.forceJSONP)return new i(t);if(!a)throw new Error("JSONP disabled");return new s(t)}var o=n(19),i=n(21),s=n(35),a=n(36);e.polling=r,e.websocket=a},function(t,e,n){var r=n(20);t.exports=function(t){var e=t.xdomain,n=t.xscheme,o=t.enablesXDR;try{if("undefined"!=typeof XMLHttpRequest&&(!e||r))return new XMLHttpRequest}catch(i){}try{if("undefined"!=typeof XDomainRequest&&!n&&o)return new XDomainRequest}catch(i){}if(!e)try{return new(self[["Active"].concat("Object").join("X")])("Microsoft.XMLHTTP")}catch(i){}}},function(t,e){try{t.exports="undefined"!=typeof XMLHttpRequest&&"withCredentials"in new XMLHttpRequest}catch(n){t.exports=!1}},function(t,e,n){function r(){}function o(t){if(c.call(this,t),this.requestTimeout=t.requestTimeout,this.extraHeaders=t.extraHeaders,"undefined"!=typeof location){var e="https:"===location.protocol,n=location.port;n||(n=e?443:80),this.xd="undefined"!=typeof location&&t.hostname!==location.hostname||n!==t.port,this.xs=t.secure!==e}}function i(t){this.method=t.method||"GET",this.uri=t.uri,this.xd=!!t.xd,this.xs=!!t.xs,this.async=!1!==t.async,this.data=void 0!==t.data?t.data:null,this.agent=t.agent,this.isBinary=t.isBinary,this.supportsBinary=t.supportsBinary,this.enablesXDR=t.enablesXDR,this.withCredentials=t.withCredentials,this.requestTimeout=t.requestTimeout,this.pfx=t.pfx,this.key=t.key,this.passphrase=t.passphrase,this.cert=t.cert,this.ca=t.ca,this.ciphers=t.ciphers,this.rejectUnauthorized=t.rejectUnauthorized,this.extraHeaders=t.extraHeaders,this.create()}function s(){for(var t in i.requests)i.requests.hasOwnProperty(t)&&i.requests[t].abort()}var a=n(19),c=n(22),u=n(11),p=n(33),h=n(3)("engine.io-client:polling-xhr");if(t.exports=o,t.exports.Request=i,p(o,c),o.prototype.supportsBinary=!0,o.prototype.request=function(t){return t=t||{},t.uri=this.uri(),t.xd=this.xd,t.xs=this.xs,t.agent=this.agent||!1,t.supportsBinary=this.supportsBinary,t.enablesXDR=this.enablesXDR,t.withCredentials=this.withCredentials,t.pfx=this.pfx,t.key=this.key,t.passphrase=this.passphrase,t.cert=this.cert,t.ca=this.ca,t.ciphers=this.ciphers,t.rejectUnauthorized=this.rejectUnauthorized,t.requestTimeout=this.requestTimeout,t.extraHeaders=this.extraHeaders,new i(t)},o.prototype.doWrite=function(t,e){var n="string"!=typeof t&&void 0!==t,r=this.request({method:"POST",data:t,isBinary:n}),o=this;r.on("success",e),r.on("error",function(t){o.onError("xhr post error",t)}),this.sendXhr=r},o.prototype.doPoll=function(){h("xhr poll");var t=this.request(),e=this;t.on("data",function(t){e.onData(t)}),t.on("error",function(t){e.onError("xhr poll error",t)}),this.pollXhr=t},u(i.prototype),i.prototype.create=function(){var t={agent:this.agent,xdomain:this.xd,xscheme:this.xs,enablesXDR:this.enablesXDR};t.pfx=this.pfx,t.key=this.key,t.passphrase=this.passphrase,t.cert=this.cert,t.ca=this.ca,t.ciphers=this.ciphers,t.rejectUnauthorized=this.rejectUnauthorized;var e=this.xhr=new a(t),n=this;try{h("xhr open %s: %s",this.method,this.uri),e.open(this.method,this.uri,this.async);try{if(this.extraHeaders){e.setDisableHeaderCheck&&e.setDisableHeaderCheck(!0);for(var r in this.extraHeaders)this.extraHeaders.hasOwnProperty(r)&&e.setRequestHeader(r,this.extraHeaders[r])}}catch(o){}if("POST"===this.method)try{this.isBinary?e.setRequestHeader("Content-type","application/octet-stream"):e.setRequestHeader("Content-type","text/plain;charset=UTF-8")}catch(o){}try{e.setRequestHeader("Accept","*/*")}catch(o){}"withCredentials"in e&&(e.withCredentials=this.withCredentials),this.requestTimeout&&(e.timeout=this.requestTimeout),this.hasXDR()?(e.onload=function(){n.onLoad()},e.onerror=function(){n.onError(e.responseText)}):e.onreadystatechange=function(){if(2===e.readyState)try{var t=e.getResponseHeader("Content-Type");(n.supportsBinary&&"application/octet-stream"===t||"application/octet-stream; charset=UTF-8"===t)&&(e.responseType="arraybuffer")}catch(r){}4===e.readyState&&(200===e.status||1223===e.status?n.onLoad():setTimeout(function(){n.onError("number"==typeof e.status?e.status:0)},0))},h("xhr data %s",this.data),e.send(this.data)}catch(o){return void setTimeout(function(){n.onError(o)},0)}"undefined"!=typeof document&&(this.index=i.requestsCount++,i.requests[this.index]=this)},i.prototype.onSuccess=function(){this.emit("success"),this.cleanup()},i.prototype.onData=function(t){this.emit("data",t),this.onSuccess()},i.prototype.onError=function(t){this.emit("error",t),this.cleanup(!0)},i.prototype.cleanup=function(t){if("undefined"!=typeof this.xhr&&null!==this.xhr){if(this.hasXDR()?this.xhr.onload=this.xhr.onerror=r:this.xhr.onreadystatechange=r,t)try{this.xhr.abort()}catch(e){}"undefined"!=typeof document&&delete i.requests[this.index],this.xhr=null}},i.prototype.onLoad=function(){var t;try{var e;try{e=this.xhr.getResponseHeader("Content-Type")}catch(n){}t="application/octet-stream"===e||"application/octet-stream; charset=UTF-8"===e?this.xhr.response||this.xhr.responseText:this.xhr.responseText}catch(n){this.onError(n)}null!=t&&this.onData(t)},i.prototype.hasXDR=function(){return"undefined"!=typeof XDomainRequest&&!this.xs&&this.enablesXDR},i.prototype.abort=function(){this.cleanup()},i.requestsCount=0,i.requests={},"undefined"!=typeof document)if("function"==typeof attachEvent)attachEvent("onunload",s);else if("function"==typeof addEventListener){var f="onpagehide"in self?"pagehide":"unload";addEventListener(f,s,!1)}},function(t,e,n){function r(t){var e=t&&t.forceBase64;p&&!e||(this.supportsBinary=!1),o.call(this,t)}var o=n(23),i=n(32),s=n(24),a=n(33),c=n(34),u=n(3)("engine.io-client:polling");t.exports=r;var p=function(){var t=n(19),e=new t({xdomain:!1});return null!=e.responseType}();a(r,o),r.prototype.name="polling",r.prototype.doOpen=function(){this.poll()},r.prototype.pause=function(t){function e(){u("paused"),n.readyState="paused",t()}var n=this;if(this.readyState="pausing",this.polling||!this.writable){var r=0;this.polling&&(u("we are currently polling - waiting to pause"),r++,this.once("pollComplete",function(){u("pre-pause polling complete"),--r||e()})),this.writable||(u("we are currently writing - waiting to pause"),r++,this.once("drain",function(){u("pre-pause writing complete"),--r||e()}))}else e()},r.prototype.poll=function(){u("polling"),this.polling=!0,this.doPoll(),this.emit("poll")},r.prototype.onData=function(t){var e=this;u("polling got data %s",t);var n=function(t,n,r){return"opening"===e.readyState&&e.onOpen(),"close"===t.type?(e.onClose(),!1):void e.onPacket(t)};s.decodePayload(t,this.socket.binaryType,n),"closed"!==this.readyState&&(this.polling=!1,this.emit("pollComplete"),"open"===this.readyState?this.poll():u('ignoring poll - transport state "%s"',this.readyState))},r.prototype.doClose=function(){function t(){u("writing close packet"),e.write([{type:"close"}])}var e=this;"open"===this.readyState?(u("transport open - closing"),t()):(u("transport not open - deferring close"),this.once("open",t))},r.prototype.write=function(t){var e=this;this.writable=!1;var n=function(){e.writable=!0,e.emit("drain")};s.encodePayload(t,this.supportsBinary,function(t){e.doWrite(t,n)})},r.prototype.uri=function(){var t=this.query||{},e=this.secure?"https":"http",n="";!1!==this.timestampRequests&&(t[this.timestampParam]=c()),this.supportsBinary||t.sid||(t.b64=1),t=i.encode(t),this.port&&("https"===e&&443!==Number(this.port)||"http"===e&&80!==Number(this.port))&&(n=":"+this.port),t.length&&(t="?"+t);var r=this.hostname.indexOf(":")!==-1;return e+"://"+(r?"["+this.hostname+"]":this.hostname)+n+this.path+t}},function(t,e,n){function r(t){this.path=t.path,this.hostname=t.hostname,this.port=t.port,this.secure=t.secure,this.query=t.query,this.timestampParam=t.timestampParam,this.timestampRequests=t.timestampRequests,this.readyState="",this.agent=t.agent||!1,this.socket=t.socket,this.enablesXDR=t.enablesXDR,this.withCredentials=t.withCredentials,this.pfx=t.pfx,this.key=t.key,this.passphrase=t.passphrase,this.cert=t.cert,this.ca=t.ca,this.ciphers=t.ciphers,this.rejectUnauthorized=t.rejectUnauthorized,this.forceNode=t.forceNode,this.isReactNative=t.isReactNative,this.extraHeaders=t.extraHeaders,this.localAddress=t.localAddress}var o=n(24),i=n(11);t.exports=r,i(r.prototype),r.prototype.onError=function(t,e){var n=new Error(t);return n.type="TransportError",n.description=e,this.emit("error",n),this},r.prototype.open=function(){return"closed"!==this.readyState&&""!==this.readyState||(this.readyState="opening",this.doOpen()),this},r.prototype.close=function(){return"opening"!==this.readyState&&"open"!==this.readyState||(this.doClose(),this.onClose()),this},r.prototype.send=function(t){if("open"!==this.readyState)throw new Error("Transport not open");this.write(t)},r.prototype.onOpen=function(){this.readyState="open",this.writable=!0,this.emit("open")},r.prototype.onData=function(t){var e=o.decodePacket(t,this.socket.binaryType);this.onPacket(e)},r.prototype.onPacket=function(t){this.emit("packet",t)},r.prototype.onClose=function(){this.readyState="closed",this.emit("close")}},function(t,e,n){function r(t,n){var r="b"+e.packets[t.type]+t.data.data;return n(r)}function o(t,n,r){if(!n)return e.encodeBase64Packet(t,r);var o=t.data,i=new Uint8Array(o),s=new Uint8Array(1+o.byteLength);s[0]=v[t.type];for(var a=0;a<i.length;a++)s[a+1]=i[a];return r(s.buffer)}function i(t,n,r){if(!n)return e.encodeBase64Packet(t,r);var o=new FileReader;return o.onload=function(){e.encodePacket({type:t.type,data:o.result},n,!0,r)},o.readAsArrayBuffer(t.data)}function s(t,n,r){if(!n)return e.encodeBase64Packet(t,r);if(g)return i(t,n,r);var o=new Uint8Array(1);o[0]=v[t.type];var s=new w([o.buffer,t.data]);return r(s)}function a(t){try{t=d.decode(t,{strict:!1})}catch(e){return!1}return t}function c(t,e,n){for(var r=new Array(t.length),o=l(t.length,n),i=function(t,n,o){e(n,function(e,n){r[t]=n,o(e,r)})},s=0;s<t.length;s++)i(s,t[s],o)}var u,p=n(25),h=n(26),f=n(27),l=n(28),d=n(29);"undefined"!=typeof ArrayBuffer&&(u=n(30));var y="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),m="undefined"!=typeof navigator&&/PhantomJS/i.test(navigator.userAgent),g=y||m;e.protocol=3;var v=e.packets={open:0,close:1,ping:2,pong:3,message:4,upgrade:5,noop:6},b=p(v),C={type:"error",data:"parser error"},w=n(31);e.encodePacket=function(t,e,n,i){"function"==typeof e&&(i=e,e=!1),"function"==typeof n&&(i=n,n=null);var a=void 0===t.data?void 0:t.data.buffer||t.data;if("undefined"!=typeof ArrayBuffer&&a instanceof ArrayBuffer)return o(t,e,i);if("undefined"!=typeof w&&a instanceof w)return s(t,e,i);if(a&&a.base64)return r(t,i);var c=v[t.type];return void 0!==t.data&&(c+=n?d.encode(String(t.data),{strict:!1}):String(t.data)),i(""+c)},e.encodeBase64Packet=function(t,n){var r="b"+e.packets[t.type];if("undefined"!=typeof w&&t.data instanceof w){var o=new FileReader;return o.onload=function(){var t=o.result.split(",")[1];n(r+t)},o.readAsDataURL(t.data)}var i;try{i=String.fromCharCode.apply(null,new Uint8Array(t.data))}catch(s){for(var a=new Uint8Array(t.data),c=new Array(a.length),u=0;u<a.length;u++)c[u]=a[u];i=String.fromCharCode.apply(null,c)}return r+=btoa(i),n(r)},e.decodePacket=function(t,n,r){if(void 0===t)return C;if("string"==typeof t){if("b"===t.charAt(0))return e.decodeBase64Packet(t.substr(1),n);if(r&&(t=a(t),t===!1))return C;var o=t.charAt(0);return Number(o)==o&&b[o]?t.length>1?{type:b[o],data:t.substring(1)}:{type:b[o]}:C}var i=new Uint8Array(t),o=i[0],s=f(t,1);return w&&"blob"===n&&(s=new w([s])),{type:b[o],data:s}},e.decodeBase64Packet=function(t,e){var n=b[t.charAt(0)];if(!u)return{type:n,data:{base64:!0,data:t.substr(1)}};var r=u.decode(t.substr(1));return"blob"===e&&w&&(r=new w([r])),{type:n,data:r}},e.encodePayload=function(t,n,r){function o(t){return t.length+":"+t}function i(t,r){e.encodePacket(t,!!s&&n,!1,function(t){r(null,o(t))})}"function"==typeof n&&(r=n,n=null);var s=h(t);return n&&s?w&&!g?e.encodePayloadAsBlob(t,r):e.encodePayloadAsArrayBuffer(t,r):t.length?void c(t,i,function(t,e){return r(e.join(""))}):r("0:")},e.decodePayload=function(t,n,r){if("string"!=typeof t)return e.decodePayloadAsBinary(t,n,r);"function"==typeof n&&(r=n,n=null);var o;if(""===t)return r(C,0,1);for(var i,s,a="",c=0,u=t.length;c<u;c++){var p=t.charAt(c);if(":"===p){if(""===a||a!=(i=Number(a)))return r(C,0,1);if(s=t.substr(c+1,i),a!=s.length)return r(C,0,1);if(s.length){if(o=e.decodePacket(s,n,!1),C.type===o.type&&C.data===o.data)return r(C,0,1);var h=r(o,c+i,u);if(!1===h)return}c+=i,a=""}else a+=p}return""!==a?r(C,0,1):void 0},e.encodePayloadAsArrayBuffer=function(t,n){function r(t,n){e.encodePacket(t,!0,!0,function(t){return n(null,t)})}return t.length?void c(t,r,function(t,e){var r=e.reduce(function(t,e){var n;return n="string"==typeof e?e.length:e.byteLength,t+n.toString().length+n+2},0),o=new Uint8Array(r),i=0;return e.forEach(function(t){var e="string"==typeof t,n=t;if(e){for(var r=new Uint8Array(t.length),s=0;s<t.length;s++)r[s]=t.charCodeAt(s);n=r.buffer}e?o[i++]=0:o[i++]=1;for(var a=n.byteLength.toString(),s=0;s<a.length;s++)o[i++]=parseInt(a[s]);o[i++]=255;for(var r=new Uint8Array(n),s=0;s<r.length;s++)o[i++]=r[s]}),n(o.buffer)}):n(new ArrayBuffer(0))},e.encodePayloadAsBlob=function(t,n){function r(t,n){e.encodePacket(t,!0,!0,function(t){var e=new Uint8Array(1);if(e[0]=1,"string"==typeof t){for(var r=new Uint8Array(t.length),o=0;o<t.length;o++)r[o]=t.charCodeAt(o);t=r.buffer,e[0]=0}for(var i=t instanceof ArrayBuffer?t.byteLength:t.size,s=i.toString(),a=new Uint8Array(s.length+1),o=0;o<s.length;o++)a[o]=parseInt(s[o]);if(a[s.length]=255,w){var c=new w([e.buffer,a.buffer,t]);n(null,c)}})}c(t,r,function(t,e){return n(new w(e))})},e.decodePayloadAsBinary=function(t,n,r){"function"==typeof n&&(r=n,n=null);for(var o=t,i=[];o.byteLength>0;){for(var s=new Uint8Array(o),a=0===s[0],c="",u=1;255!==s[u];u++){if(c.length>310)return r(C,0,1);c+=s[u]}o=f(o,2+c.length),c=parseInt(c);var p=f(o,0,c);if(a)try{p=String.fromCharCode.apply(null,new Uint8Array(p))}catch(h){var l=new Uint8Array(p);p="";for(var u=0;u<l.length;u++)p+=String.fromCharCode(l[u])}i.push(p),o=f(o,c)}var d=i.length;i.forEach(function(t,o){r(e.decodePacket(t,n,!0),o,d)})}},function(t,e){t.exports=Object.keys||function(t){var e=[],n=Object.prototype.hasOwnProperty;for(var r in t)n.call(t,r)&&e.push(r);return e}},function(t,e,n){function r(t){if(!t||"object"!=typeof t)return!1;if(o(t)){for(var e=0,n=t.length;e<n;e++)if(r(t[e]))return!0;return!1}if("function"==typeof Buffer&&Buffer.isBuffer&&Buffer.isBuffer(t)||"function"==typeof ArrayBuffer&&t instanceof ArrayBuffer||s&&t instanceof Blob||a&&t instanceof File)return!0;if(t.toJSON&&"function"==typeof t.toJSON&&1===arguments.length)return r(t.toJSON(),!0);for(var i in t)if(Object.prototype.hasOwnProperty.call(t,i)&&r(t[i]))return!0;return!1}var o=n(13),i=Object.prototype.toString,s="function"==typeof Blob||"undefined"!=typeof Blob&&"[object BlobConstructor]"===i.call(Blob),a="function"==typeof File||"undefined"!=typeof File&&"[object FileConstructor]"===i.call(File);t.exports=r},function(t,e){t.exports=function(t,e,n){var r=t.byteLength;if(e=e||0,n=n||r,t.slice)return t.slice(e,n);if(e<0&&(e+=r),n<0&&(n+=r),n>r&&(n=r),e>=r||e>=n||0===r)return new ArrayBuffer(0);for(var o=new Uint8Array(t),i=new Uint8Array(n-e),s=e,a=0;s<n;s++,a++)i[a]=o[s];return i.buffer}},function(t,e){function n(t,e,n){function o(t,r){if(o.count<=0)throw new Error("after called too many times");--o.count,t?(i=!0,e(t),e=n):0!==o.count||i||e(null,r)}var i=!1;return n=n||r,o.count=t,0===t?e():o}function r(){}t.exports=n},function(t,e){function n(t){for(var e,n,r=[],o=0,i=t.length;o<i;)e=t.charCodeAt(o++),e>=55296&&e<=56319&&o<i?(n=t.charCodeAt(o++),56320==(64512&n)?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),o--)):r.push(e);return r}function r(t){for(var e,n=t.length,r=-1,o="";++r<n;)e=t[r],e>65535&&(e-=65536,o+=d(e>>>10&1023|55296),e=56320|1023&e),o+=d(e);return o}function o(t,e){if(t>=55296&&t<=57343){if(e)throw Error("Lone surrogate U+"+t.toString(16).toUpperCase()+" is not a scalar value");return!1}return!0}function i(t,e){return d(t>>e&63|128)}function s(t,e){if(0==(4294967168&t))return d(t);var n="";return 0==(4294965248&t)?n=d(t>>6&31|192):0==(4294901760&t)?(o(t,e)||(t=65533),n=d(t>>12&15|224),n+=i(t,6)):0==(4292870144&t)&&(n=d(t>>18&7|240),n+=i(t,12),n+=i(t,6)),n+=d(63&t|128)}function a(t,e){e=e||{};for(var r,o=!1!==e.strict,i=n(t),a=i.length,c=-1,u="";++c<a;)r=i[c],u+=s(r,o);return u}function c(){if(l>=f)throw Error("Invalid byte index");var t=255&h[l];if(l++,128==(192&t))return 63&t;throw Error("Invalid continuation byte")}function u(t){var e,n,r,i,s;if(l>f)throw Error("Invalid byte index");if(l==f)return!1;if(e=255&h[l],l++,0==(128&e))return e;if(192==(224&e)){if(n=c(),s=(31&e)<<6|n,s>=128)return s;throw Error("Invalid continuation byte")}if(224==(240&e)){if(n=c(),r=c(),s=(15&e)<<12|n<<6|r,s>=2048)return o(s,t)?s:65533;throw Error("Invalid continuation byte")}if(240==(248&e)&&(n=c(),r=c(),i=c(),s=(7&e)<<18|n<<12|r<<6|i,s>=65536&&s<=1114111))return s;throw Error("Invalid UTF-8 detected")}function p(t,e){e=e||{};var o=!1!==e.strict;h=n(t),f=h.length,l=0;for(var i,s=[];(i=u(o))!==!1;)s.push(i);return r(s)}/*! https://mths.be/utf8js v2.1.2 by @mathias */
var h,f,l,d=String.fromCharCode;t.exports={version:"2.1.2",encode:a,decode:p}},function(t,e){!function(){"use strict";for(var t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",n=new Uint8Array(256),r=0;r<t.length;r++)n[t.charCodeAt(r)]=r;e.encode=function(e){var n,r=new Uint8Array(e),o=r.length,i="";for(n=0;n<o;n+=3)i+=t[r[n]>>2],i+=t[(3&r[n])<<4|r[n+1]>>4],i+=t[(15&r[n+1])<<2|r[n+2]>>6],i+=t[63&r[n+2]];return o%3===2?i=i.substring(0,i.length-1)+"=":o%3===1&&(i=i.substring(0,i.length-2)+"=="),i},e.decode=function(t){var e,r,o,i,s,a=.75*t.length,c=t.length,u=0;"="===t[t.length-1]&&(a--,"="===t[t.length-2]&&a--);var p=new ArrayBuffer(a),h=new Uint8Array(p);for(e=0;e<c;e+=4)r=n[t.charCodeAt(e)],o=n[t.charCodeAt(e+1)],i=n[t.charCodeAt(e+2)],s=n[t.charCodeAt(e+3)],h[u++]=r<<2|o>>4,h[u++]=(15&o)<<4|i>>2,h[u++]=(3&i)<<6|63&s;return p}}()},function(t,e){function n(t){return t.map(function(t){if(t.buffer instanceof ArrayBuffer){var e=t.buffer;if(t.byteLength!==e.byteLength){var n=new Uint8Array(t.byteLength);n.set(new Uint8Array(e,t.byteOffset,t.byteLength)),e=n.buffer}return e}return t})}function r(t,e){e=e||{};var r=new i;return n(t).forEach(function(t){r.append(t)}),e.type?r.getBlob(e.type):r.getBlob()}function o(t,e){return new Blob(n(t),e||{})}var i="undefined"!=typeof i?i:"undefined"!=typeof WebKitBlobBuilder?WebKitBlobBuilder:"undefined"!=typeof MSBlobBuilder?MSBlobBuilder:"undefined"!=typeof MozBlobBuilder&&MozBlobBuilder,s=function(){try{var t=new Blob(["hi"]);return 2===t.size}catch(e){return!1}}(),a=s&&function(){try{var t=new Blob([new Uint8Array([1,2])]);return 2===t.size}catch(e){return!1}}(),c=i&&i.prototype.append&&i.prototype.getBlob;"undefined"!=typeof Blob&&(r.prototype=Blob.prototype,o.prototype=Blob.prototype),t.exports=function(){return s?a?Blob:o:c?r:void 0}()},function(t,e){e.encode=function(t){var e="";for(var n in t)t.hasOwnProperty(n)&&(e.length&&(e+="&"),e+=encodeURIComponent(n)+"="+encodeURIComponent(t[n]));return e},e.decode=function(t){for(var e={},n=t.split("&"),r=0,o=n.length;r<o;r++){var i=n[r].split("=");e[decodeURIComponent(i[0])]=decodeURIComponent(i[1])}return e}},function(t,e){t.exports=function(t,e){var n=function(){};n.prototype=e.prototype,t.prototype=new n,t.prototype.constructor=t}},function(t,e){"use strict";function n(t){var e="";do e=s[t%a]+e,t=Math.floor(t/a);while(t>0);return e}function r(t){var e=0;for(p=0;p<t.length;p++)e=e*a+c[t.charAt(p)];return e}function o(){var t=n(+new Date);return t!==i?(u=0,i=t):t+"."+n(u++)}for(var i,s="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""),a=64,c={},u=0,p=0;p<a;p++)c[s[p]]=p;o.encode=n,o.decode=r,t.exports=o},function(t,e,n){(function(e){function r(){}function o(){return"undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof e?e:{}}function i(t){if(s.call(this,t),this.query=this.query||{},!c){var e=o();c=e.___eio=e.___eio||[]}this.index=c.length;var n=this;c.push(function(t){n.onData(t)}),this.query.j=this.index,"function"==typeof addEventListener&&addEventListener("beforeunload",function(){n.script&&(n.script.onerror=r)},!1)}var s=n(22),a=n(33);t.exports=i;var c,u=/\n/g,p=/\\n/g;a(i,s),i.prototype.supportsBinary=!1,i.prototype.doClose=function(){this.script&&(this.script.parentNode.removeChild(this.script),this.script=null),this.form&&(this.form.parentNode.removeChild(this.form),this.form=null,this.iframe=null),s.prototype.doClose.call(this)},i.prototype.doPoll=function(){var t=this,e=document.createElement("script");this.script&&(this.script.parentNode.removeChild(this.script),this.script=null),e.async=!0,e.src=this.uri(),e.onerror=function(e){t.onError("jsonp poll error",e)};var n=document.getElementsByTagName("script")[0];n?n.parentNode.insertBefore(e,n):(document.head||document.body).appendChild(e),this.script=e;var r="undefined"!=typeof navigator&&/gecko/i.test(navigator.userAgent);r&&setTimeout(function(){var t=document.createElement("iframe");document.body.appendChild(t),document.body.removeChild(t)},100)},i.prototype.doWrite=function(t,e){function n(){r(),e()}function r(){if(o.iframe)try{o.form.removeChild(o.iframe)}catch(t){o.onError("jsonp polling iframe removal error",t)}try{var e='<iframe src="javascript:0" name="'+o.iframeId+'">';i=document.createElement(e)}catch(t){i=document.createElement("iframe"),i.name=o.iframeId,i.src="javascript:0"}i.id=o.iframeId,o.form.appendChild(i),o.iframe=i}var o=this;if(!this.form){var i,s=document.createElement("form"),a=document.createElement("textarea"),c=this.iframeId="eio_iframe_"+this.index;s.className="socketio",s.style.position="absolute",s.style.top="-1000px",s.style.left="-1000px",s.target=c,s.method="POST",s.setAttribute("accept-charset","utf-8"),a.name="d",s.appendChild(a),document.body.appendChild(s),this.form=s,this.area=a}this.form.action=this.uri(),r(),t=t.replace(p,"\\\n"),this.area.value=t.replace(u,"\\n");try{this.form.submit()}catch(h){}this.iframe.attachEvent?this.iframe.onreadystatechange=function(){"complete"===o.iframe.readyState&&n()}:this.iframe.onload=n}}).call(e,function(){return this}())},function(t,e,n){function r(t){var e=t&&t.forceBase64;e&&(this.supportsBinary=!1),this.perMessageDeflate=t.perMessageDeflate,this.usingBrowserWebSocket=o&&!t.forceNode,this.protocols=t.protocols,this.usingBrowserWebSocket||(l=i),s.call(this,t)}var o,i,s=n(23),a=n(24),c=n(32),u=n(33),p=n(34),h=n(3)("engine.io-client:websocket");if("undefined"!=typeof WebSocket?o=WebSocket:"undefined"!=typeof self&&(o=self.WebSocket||self.MozWebSocket),"undefined"==typeof window)try{i=n(37)}catch(f){}var l=o||i;t.exports=r,u(r,s),r.prototype.name="websocket",r.prototype.supportsBinary=!0,r.prototype.doOpen=function(){if(this.check()){var t=this.uri(),e=this.protocols,n={agent:this.agent,perMessageDeflate:this.perMessageDeflate};n.pfx=this.pfx,n.key=this.key,n.passphrase=this.passphrase,n.cert=this.cert,n.ca=this.ca,n.ciphers=this.ciphers,n.rejectUnauthorized=this.rejectUnauthorized,this.extraHeaders&&(n.headers=this.extraHeaders),this.localAddress&&(n.localAddress=this.localAddress);try{this.ws=this.usingBrowserWebSocket&&!this.isReactNative?e?new l(t,e):new l(t):new l(t,e,n)}catch(r){return this.emit("error",r)}void 0===this.ws.binaryType&&(this.supportsBinary=!1),this.ws.supports&&this.ws.supports.binary?(this.supportsBinary=!0,this.ws.binaryType="nodebuffer"):this.ws.binaryType="arraybuffer",this.addEventListeners()}},r.prototype.addEventListeners=function(){var t=this;this.ws.onopen=function(){t.onOpen()},this.ws.onclose=function(){t.onClose()},this.ws.onmessage=function(e){t.onData(e.data)},this.ws.onerror=function(e){t.onError("websocket error",e)}},r.prototype.write=function(t){function e(){n.emit("flush"),setTimeout(function(){n.writable=!0,n.emit("drain")},0)}var n=this;this.writable=!1;for(var r=t.length,o=0,i=r;o<i;o++)!function(t){a.encodePacket(t,n.supportsBinary,function(o){if(!n.usingBrowserWebSocket){var i={};if(t.options&&(i.compress=t.options.compress),n.perMessageDeflate){var s="string"==typeof o?Buffer.byteLength(o):o.length;s<n.perMessageDeflate.threshold&&(i.compress=!1)}}try{n.usingBrowserWebSocket?n.ws.send(o):n.ws.send(o,i)}catch(a){h("websocket closed before onclose event")}--r||e()})}(t[o])},r.prototype.onClose=function(){s.prototype.onClose.call(this)},r.prototype.doClose=function(){"undefined"!=typeof this.ws&&this.ws.close()},r.prototype.uri=function(){var t=this.query||{},e=this.secure?"wss":"ws",n="";this.port&&("wss"===e&&443!==Number(this.port)||"ws"===e&&80!==Number(this.port))&&(n=":"+this.port),this.timestampRequests&&(t[this.timestampParam]=p()),this.supportsBinary||(t.b64=1),t=c.encode(t),t.length&&(t="?"+t);var r=this.hostname.indexOf(":")!==-1;return e+"://"+(r?"["+this.hostname+"]":this.hostname)+n+this.path+t},r.prototype.check=function(){return!(!l||"__initialize"in l&&this.name===r.prototype.name)}},function(t,e){},function(t,e){var n=[].indexOf;t.exports=function(t,e){if(n)return t.indexOf(e);for(var r=0;r<t.length;++r)if(t[r]===e)return r;return-1}},function(t,e,n){function r(t,e,n){this.io=t,this.nsp=e,this.json=this,this.ids=0,this.acks={},this.receiveBuffer=[],this.sendBuffer=[],this.connected=!1,this.disconnected=!0,this.flags={},n&&n.query&&(this.query=n.query),this.io.autoConnect&&this.open()}var o=n(7),i=n(11),s=n(40),a=n(41),c=n(42),u=n(3)("socket.io-client:socket"),p=n(32),h=n(26);t.exports=e=r;var f={connect:1,connect_error:1,connect_timeout:1,connecting:1,disconnect:1,error:1,reconnect:1,reconnect_attempt:1,reconnect_failed:1,reconnect_error:1,reconnecting:1,ping:1,pong:1},l=i.prototype.emit;i(r.prototype),r.prototype.subEvents=function(){if(!this.subs){var t=this.io;this.subs=[a(t,"open",c(this,"onopen")),a(t,"packet",c(this,"onpacket")),a(t,"close",c(this,"onclose"))]}},r.prototype.open=r.prototype.connect=function(){return this.connected?this:(this.subEvents(),this.io.open(),"open"===this.io.readyState&&this.onopen(),this.emit("connecting"),this)},r.prototype.send=function(){var t=s(arguments);return t.unshift("message"),this.emit.apply(this,t),this},r.prototype.emit=function(t){if(f.hasOwnProperty(t))return l.apply(this,arguments),this;var e=s(arguments),n={type:(void 0!==this.flags.binary?this.flags.binary:h(e))?o.BINARY_EVENT:o.EVENT,data:e};return n.options={},n.options.compress=!this.flags||!1!==this.flags.compress,"function"==typeof e[e.length-1]&&(u("emitting packet with ack id %d",this.ids),this.acks[this.ids]=e.pop(),n.id=this.ids++),this.connected?this.packet(n):this.sendBuffer.push(n),this.flags={},this},r.prototype.packet=function(t){t.nsp=this.nsp,this.io.packet(t)},r.prototype.onopen=function(){if(u("transport is open - connecting"),"/"!==this.nsp)if(this.query){var t="object"==typeof this.query?p.encode(this.query):this.query;u("sending connect packet with query %s",t),this.packet({type:o.CONNECT,query:t})}else this.packet({type:o.CONNECT})},r.prototype.onclose=function(t){u("close (%s)",t),this.connected=!1,this.disconnected=!0,delete this.id,this.emit("disconnect",t)},r.prototype.onpacket=function(t){var e=t.nsp===this.nsp,n=t.type===o.ERROR&&"/"===t.nsp;if(e||n)switch(t.type){case o.CONNECT:this.onconnect();break;case o.EVENT:this.onevent(t);break;case o.BINARY_EVENT:this.onevent(t);break;case o.ACK:this.onack(t);break;case o.BINARY_ACK:this.onack(t);break;case o.DISCONNECT:this.ondisconnect();break;case o.ERROR:this.emit("error",t.data)}},r.prototype.onevent=function(t){var e=t.data||[];u("emitting event %j",e),null!=t.id&&(u("attaching ack callback to event"),e.push(this.ack(t.id))),this.connected?l.apply(this,e):this.receiveBuffer.push(e)},r.prototype.ack=function(t){var e=this,n=!1;return function(){if(!n){n=!0;var r=s(arguments);u("sending ack %j",r),e.packet({type:h(r)?o.BINARY_ACK:o.ACK,id:t,data:r})}}},r.prototype.onack=function(t){var e=this.acks[t.id];"function"==typeof e?(u("calling ack %s with %j",t.id,t.data),e.apply(this,t.data),delete this.acks[t.id]):u("bad ack %s",t.id)},r.prototype.onconnect=function(){this.connected=!0,this.disconnected=!1,this.emit("connect"),this.emitBuffered()},r.prototype.emitBuffered=function(){var t;for(t=0;t<this.receiveBuffer.length;t++)l.apply(this,this.receiveBuffer[t]);for(this.receiveBuffer=[],t=0;t<this.sendBuffer.length;t++)this.packet(this.sendBuffer[t]);this.sendBuffer=[]},r.prototype.ondisconnect=function(){u("server disconnect (%s)",this.nsp),this.destroy(),this.onclose("io server disconnect")},r.prototype.destroy=function(){if(this.subs){for(var t=0;t<this.subs.length;t++)this.subs[t].destroy();this.subs=null}this.io.destroy(this)},r.prototype.close=r.prototype.disconnect=function(){return this.connected&&(u("performing disconnect (%s)",this.nsp),this.packet({type:o.DISCONNECT})),this.destroy(),this.connected&&this.onclose("io client disconnect"),this},r.prototype.compress=function(t){return this.flags.compress=t,this},r.prototype.binary=function(t){return this.flags.binary=t,this}},function(t,e){function n(t,e){var n=[];e=e||0;for(var r=e||0;r<t.length;r++)n[r-e]=t[r];return n}t.exports=n},function(t,e){function n(t,e,n){return t.on(e,n),{destroy:function(){t.removeListener(e,n)}}}t.exports=n},function(t,e){var n=[].slice;t.exports=function(t,e){if("string"==typeof e&&(e=t[e]),"function"!=typeof e)throw new Error("bind() requires a function");var r=n.call(arguments,2);return function(){return e.apply(t,r.concat(n.call(arguments)))}}},function(t,e){function n(t){t=t||{},this.ms=t.min||100,this.max=t.max||1e4,this.factor=t.factor||2,this.jitter=t.jitter>0&&t.jitter<=1?t.jitter:0,this.attempts=0}t.exports=n,n.prototype.duration=function(){var t=this.ms*Math.pow(this.factor,this.attempts++);if(this.jitter){var e=Math.random(),n=Math.floor(e*this.jitter*t);t=0==(1&Math.floor(10*e))?t-n:t+n}return 0|Math.min(t,this.max)},n.prototype.reset=function(){this.attempts=0},n.prototype.setMin=function(t){this.ms=t},n.prototype.setMax=function(t){this.max=t},n.prototype.setJitter=function(t){this.jitter=t}}])});
//# sourceMappingURL=socket.io.js.map
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.ol=e():t.ol=e()}(window,(function(){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var i=e[n]={i:n,l:!1,exports:{}};return t[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)r.d(n,i,function(e){return t[e]}.bind(null,i));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=10)}([function(t,e,r){"use strict";(function(t,n){r.d(e,"a",(function(){return $})),r.d(e,"b",(function(){return _r})),r.d(e,"c",(function(){return Kr})),r.d(e,"d",(function(){return hr})),r.d(e,"e",(function(){return Hr})),r.d(e,"f",(function(){return i}));var i={$version:8,$root:{version:{required:!0,type:"enum",values:[8],doc:"Style specification version number. Must be 8.",example:8},name:{type:"string",doc:"A human-readable name for the style.",example:"Bright"},metadata:{type:"*",doc:"Arbitrary properties useful to track with the stylesheet, but do not influence rendering. Properties should be prefixed to avoid collisions, like 'mapbox:'."},center:{type:"array",value:"number",doc:"Default map center in longitude and latitude.  The style center will be used only if the map has not been positioned by other means (e.g. map options or user interaction).",example:[-73.9749,40.7736]},zoom:{type:"number",doc:"Default zoom level.  The style zoom will be used only if the map has not been positioned by other means (e.g. map options or user interaction).",example:12.5},bearing:{type:"number",default:0,period:360,units:"degrees",doc:'Default bearing, in degrees. The bearing is the compass direction that is "up"; for example, a bearing of 90° orients the map so that east is up. This value will be used only if the map has not been positioned by other means (e.g. map options or user interaction).',example:29},pitch:{type:"number",default:0,units:"degrees",doc:"Default pitch, in degrees. Zero is perpendicular to the surface, for a look straight down at the map, while a greater value like 60 looks ahead towards the horizon. The style pitch will be used only if the map has not been positioned by other means (e.g. map options or user interaction).",example:50},light:{type:"light",doc:"The global light source.",example:{anchor:"viewport",color:"white",intensity:.4}},sources:{required:!0,type:"sources",doc:"Data source specifications.",example:{"mapbox-streets":{type:"vector",url:"mapbox://mapbox.mapbox-streets-v6"}}},sprite:{type:"string",doc:"A base URL for retrieving the sprite image and metadata. The extensions `.png`, `.json` and scale factor `@2x.png` will be automatically appended. This property is required if any layer uses the `background-pattern`, `fill-pattern`, `line-pattern`, `fill-extrusion-pattern`, or `icon-image` properties. The URL must be absolute, containing the [scheme, authority and path components](https://en.wikipedia.org/wiki/URL#Syntax).",example:"mapbox://sprites/mapbox/bright-v8"},glyphs:{type:"string",doc:"A URL template for loading signed-distance-field glyph sets in PBF format. The URL must include `{fontstack}` and `{range}` tokens. This property is required if any layer uses the `text-field` layout property. The URL must be absolute, containing the [scheme, authority and path components](https://en.wikipedia.org/wiki/URL#Syntax).",example:"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},transition:{type:"transition",doc:"A global transition definition to use as a default across properties, to be used for timing transitions between one value and the next when no property-specific transition is set. Collision-based symbol fading is controlled independently of the style's `transition` property.",example:{duration:300,delay:0}},layers:{required:!0,type:"array",value:"layer",doc:"Layers will be drawn in the order of this array.",example:[{id:"water",source:"mapbox-streets","source-layer":"water",type:"fill",paint:{"fill-color":"#00ffff"}}]}},sources:{"*":{type:"source",doc:"Specification of a data source. For vector and raster sources, either TileJSON or a URL to a TileJSON must be provided. For image and video sources, a URL must be provided. For GeoJSON sources, a URL or inline GeoJSON must be provided."}},source:["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],source_vector:{type:{required:!0,type:"enum",values:{vector:{doc:"A vector tile source."}},doc:"The type of the source."},url:{type:"string",doc:"A URL to a TileJSON resource. Supported protocols are `http:`, `https:`, and `mapbox://<Tileset ID>`."},tiles:{type:"array",value:"string",doc:"An array of one or more tile source URLs, as in the TileJSON spec."},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129],doc:"An array containing the longitude and latitude of the southwest and northeast corners of the source's bounding box in the following order: `[sw.lng, sw.lat, ne.lng, ne.lat]`. When this property is included in a source, no tiles outside of the given bounds are requested by Mapbox GL."},scheme:{type:"enum",values:{xyz:{doc:"Slippy map tilenames scheme."},tms:{doc:"OSGeo spec scheme."}},default:"xyz",doc:"Influences the y direction of the tile coordinates. The global-mercator (aka Spherical Mercator) profile is assumed."},minzoom:{type:"number",default:0,doc:"Minimum zoom level for which tiles are available, as in the TileJSON spec."},maxzoom:{type:"number",default:22,doc:"Maximum zoom level for which tiles are available, as in the TileJSON spec. Data from tiles at the maxzoom are used when displaying the map at higher zoom levels."},attribution:{type:"string",doc:"Contains an attribution to be displayed when the map is shown to a user."},promoteId:{type:"promoteId",doc:"A property to use as a feature id (for feature state). Either a property name, or an object of the form `{<sourceLayer>: <propertyName>}`. If specified as a string for a vector tile source, the same property is used across all its source layers."},"*":{type:"*",doc:"Other keys to configure the data source."}},source_raster:{type:{required:!0,type:"enum",values:{raster:{doc:"A raster tile source."}},doc:"The type of the source."},url:{type:"string",doc:"A URL to a TileJSON resource. Supported protocols are `http:`, `https:`, and `mapbox://<Tileset ID>`."},tiles:{type:"array",value:"string",doc:"An array of one or more tile source URLs, as in the TileJSON spec."},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129],doc:"An array containing the longitude and latitude of the southwest and northeast corners of the source's bounding box in the following order: `[sw.lng, sw.lat, ne.lng, ne.lat]`. When this property is included in a source, no tiles outside of the given bounds are requested by Mapbox GL."},minzoom:{type:"number",default:0,doc:"Minimum zoom level for which tiles are available, as in the TileJSON spec."},maxzoom:{type:"number",default:22,doc:"Maximum zoom level for which tiles are available, as in the TileJSON spec. Data from tiles at the maxzoom are used when displaying the map at higher zoom levels."},tileSize:{type:"number",default:512,units:"pixels",doc:"The minimum visual size to display tiles for this layer. Only configurable for raster layers."},scheme:{type:"enum",values:{xyz:{doc:"Slippy map tilenames scheme."},tms:{doc:"OSGeo spec scheme."}},default:"xyz",doc:"Influences the y direction of the tile coordinates. The global-mercator (aka Spherical Mercator) profile is assumed."},attribution:{type:"string",doc:"Contains an attribution to be displayed when the map is shown to a user."},"*":{type:"*",doc:"Other keys to configure the data source."}},source_raster_dem:{type:{required:!0,type:"enum",values:{"raster-dem":{doc:"A RGB-encoded raster DEM source"}},doc:"The type of the source."},url:{type:"string",doc:"A URL to a TileJSON resource. Supported protocols are `http:`, `https:`, and `mapbox://<Tileset ID>`."},tiles:{type:"array",value:"string",doc:"An array of one or more tile source URLs, as in the TileJSON spec."},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129],doc:"An array containing the longitude and latitude of the southwest and northeast corners of the source's bounding box in the following order: `[sw.lng, sw.lat, ne.lng, ne.lat]`. When this property is included in a source, no tiles outside of the given bounds are requested by Mapbox GL."},minzoom:{type:"number",default:0,doc:"Minimum zoom level for which tiles are available, as in the TileJSON spec."},maxzoom:{type:"number",default:22,doc:"Maximum zoom level for which tiles are available, as in the TileJSON spec. Data from tiles at the maxzoom are used when displaying the map at higher zoom levels."},tileSize:{type:"number",default:512,units:"pixels",doc:"The minimum visual size to display tiles for this layer. Only configurable for raster layers."},attribution:{type:"string",doc:"Contains an attribution to be displayed when the map is shown to a user."},encoding:{type:"enum",values:{terrarium:{doc:"Terrarium format PNG tiles. See https://aws.amazon.com/es/public-datasets/terrain/ for more info."},mapbox:{doc:"Mapbox Terrain RGB tiles. See https://www.mapbox.com/help/access-elevation-data/#mapbox-terrain-rgb for more info."}},default:"mapbox",doc:"The encoding used by this source. Mapbox Terrain RGB is used by default"},"*":{type:"*",doc:"Other keys to configure the data source."}},source_geojson:{type:{required:!0,type:"enum",values:{geojson:{doc:"A GeoJSON data source."}},doc:"The data type of the GeoJSON source."},data:{type:"*",doc:"A URL to a GeoJSON file, or inline GeoJSON."},maxzoom:{type:"number",default:18,doc:"Maximum zoom level at which to create vector tiles (higher means greater detail at high zoom levels)."},attribution:{type:"string",doc:"Contains an attribution to be displayed when the map is shown to a user."},buffer:{type:"number",default:128,maximum:512,minimum:0,doc:"Size of the tile buffer on each side. A value of 0 produces no buffer. A value of 512 produces a buffer as wide as the tile itself. Larger values produce fewer rendering artifacts near tile edges and slower performance."},tolerance:{type:"number",default:.375,doc:"Douglas-Peucker simplification tolerance (higher means simpler geometries and faster performance)."},cluster:{type:"boolean",default:!1,doc:"If the data is a collection of point features, setting this to true clusters the points by radius into groups. Cluster groups become new `Point` features in the source with additional properties:\n * `cluster` Is `true` if the point is a cluster \n * `cluster_id` A unqiue id for the cluster to be used in conjunction with the [cluster inspection methods](https://www.mapbox.com/mapbox-gl-js/api/#geojsonsource#getclusterexpansionzoom)\n * `point_count` Number of original points grouped into this cluster\n * `point_count_abbreviated` An abbreviated point count"},clusterRadius:{type:"number",default:50,minimum:0,doc:"Radius of each cluster if clustering is enabled. A value of 512 indicates a radius equal to the width of a tile."},clusterMaxZoom:{type:"number",doc:"Max zoom on which to cluster points if clustering is enabled. Defaults to one zoom less than maxzoom (so that last zoom features are not clustered)."},clusterProperties:{type:"*",doc:'An object defining custom properties on the generated clusters if clustering is enabled, aggregating values from clustered points. Has the form `{"property_name": [operator, map_expression]}`. `operator` is any expression function that accepts at least 2 operands (e.g. `"+"` or `"max"`) — it accumulates the property value from clusters/points the cluster contains; `map_expression` produces the value of a single point.\n\nExample: `{"sum": ["+", ["get", "scalerank"]]}`.\n\nFor more advanced use cases, in place of `operator`, you can use a custom reduce expression that references a special `["accumulated"]` value, e.g.:\n`{"sum": [["+", ["accumulated"], ["get", "sum"]], ["get", "scalerank"]]}`'},lineMetrics:{type:"boolean",default:!1,doc:"Whether to calculate line distance metrics. This is required for line layers that specify `line-gradient` values."},generateId:{type:"boolean",default:!1,doc:"Whether to generate ids for the geojson features. When enabled, the `feature.id` property will be auto assigned based on its index in the `features` array, over-writing any previous values."},promoteId:{type:"promoteId",doc:"A property to use as a feature id (for feature state). Either a property name, or an object of the form `{<sourceLayer>: <propertyName>}`."}},source_video:{type:{required:!0,type:"enum",values:{video:{doc:"A video data source."}},doc:"The data type of the video source."},urls:{required:!0,type:"array",value:"string",doc:"URLs to video content in order of preferred format."},coordinates:{required:!0,doc:"Corners of video specified in longitude, latitude pairs.",type:"array",length:4,value:{type:"array",length:2,value:"number",doc:"A single longitude, latitude pair."}}},source_image:{type:{required:!0,type:"enum",values:{image:{doc:"An image data source."}},doc:"The data type of the image source."},url:{required:!0,type:"string",doc:"URL that points to an image."},coordinates:{required:!0,doc:"Corners of image specified in longitude, latitude pairs.",type:"array",length:4,value:{type:"array",length:2,value:"number",doc:"A single longitude, latitude pair."}}},layer:{id:{type:"string",doc:"Unique layer name.",required:!0},type:{type:"enum",values:{fill:{doc:"A filled polygon with an optional stroked border.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}}},line:{doc:"A stroked line.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}}},symbol:{doc:"An icon or a text label.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}}},circle:{doc:"A filled circle.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}}},heatmap:{doc:"A heatmap.","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"fill-extrusion":{doc:"An extruded (3D) polygon.","sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}}},raster:{doc:"Raster map textures such as satellite imagery.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}}},hillshade:{doc:"Client-side hillshading visualization based on DEM data. Currently, the implementation only supports Mapbox Terrain RGB and Mapzen Terrarium tiles.","sdk-support":{"basic functionality":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},background:{doc:"The background color or pattern of the map.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}}}},doc:"Rendering type of this layer.",required:!0},metadata:{type:"*",doc:"Arbitrary properties useful to track with the layer, but do not influence rendering. Properties should be prefixed to avoid collisions, like 'mapbox:'."},source:{type:"string",doc:"Name of a source description to be used for this layer. Required for all layer types except `background`."},"source-layer":{type:"string",doc:"Layer to use from a vector tile source. Required for vector tile sources; prohibited for all other source types, including GeoJSON sources."},minzoom:{type:"number",minimum:0,maximum:24,doc:"The minimum zoom level for the layer. At zoom levels less than the minzoom, the layer will be hidden."},maxzoom:{type:"number",minimum:0,maximum:24,doc:"The maximum zoom level for the layer. At zoom levels equal to or greater than the maxzoom, the layer will be hidden."},filter:{type:"filter",doc:"A expression specifying conditions on source features. Only features that match the filter are displayed. Zoom expressions in filters are only evaluated at integer zoom levels. The `feature-state` expression is not supported in filter expressions."},layout:{type:"layout",doc:"Layout properties for the layer."},paint:{type:"paint",doc:"Default paint properties for this layer."}},layout:["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background"],layout_background:{visibility:{type:"enum",values:{visible:{doc:"The layer is shown."},none:{doc:"The layer is not shown."}},default:"visible",doc:"Whether this layer is displayed.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},"property-type":"constant"}},layout_fill:{"fill-sort-key":{type:"number",doc:"Sorts features in ascending order based on this value. Features with a higher sort key will appear above features with a lower sort key.","sdk-support":{"basic functionality":{js:"1.2.0",android:"9.1.0",ios:"5.8.0",macos:"0.15.0"},"data-driven styling":{js:"1.2.0",android:"9.1.0",ios:"5.8.0",macos:"0.15.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{doc:"The layer is shown."},none:{doc:"The layer is not shown."}},default:"visible",doc:"Whether this layer is displayed.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},"property-type":"constant"}},layout_circle:{"circle-sort-key":{type:"number",doc:"Sorts features in ascending order based on this value. Features with a higher sort key will appear above features with a lower sort key.","sdk-support":{"basic functionality":{js:"1.2.0",android:"9.2.0",ios:"5.9.0",macos:"0.16.0"},"data-driven styling":{js:"1.2.0",android:"9.2.0",ios:"5.9.0",macos:"0.16.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{doc:"The layer is shown."},none:{doc:"The layer is not shown."}},default:"visible",doc:"Whether this layer is displayed.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},"property-type":"constant"}},layout_heatmap:{visibility:{type:"enum",values:{visible:{doc:"The layer is shown."},none:{doc:"The layer is not shown."}},default:"visible",doc:"Whether this layer is displayed.","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},"property-type":"constant"}},"layout_fill-extrusion":{visibility:{type:"enum",values:{visible:{doc:"The layer is shown."},none:{doc:"The layer is not shown."}},default:"visible",doc:"Whether this layer is displayed.","sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},"property-type":"constant"}},layout_line:{"line-cap":{type:"enum",values:{butt:{doc:"A cap with a squared-off end which is drawn to the exact endpoint of the line."},round:{doc:"A cap with a rounded end which is drawn beyond the endpoint of the line at a radius of one-half of the line's width and centered on the endpoint of the line."},square:{doc:"A cap with a squared-off end which is drawn beyond the endpoint of the line at a distance of one-half of the line's width."}},default:"butt",doc:"The display of line endings.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-join":{type:"enum",values:{bevel:{doc:"A join with a squared-off end which is drawn beyond the endpoint of the line at a distance of one-half of the line's width."},round:{doc:"A join with a rounded end which is drawn beyond the endpoint of the line at a radius of one-half of the line's width and centered on the endpoint of the line."},miter:{doc:"A join with a sharp, angled corner which is drawn with the outer sides beyond the endpoint of the path until they meet."}},default:"miter",doc:"The display of lines when joining.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.40.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{type:"number",default:2,doc:"Used to automatically convert miter joins to bevel joins for sharp angles.",requires:[{"line-join":"miter"}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-round-limit":{type:"number",default:1.05,doc:"Used to automatically convert round joins to miter joins for shallow angles.",requires:[{"line-join":"round"}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-sort-key":{type:"number",doc:"Sorts features in ascending order based on this value. Features with a higher sort key will appear above features with a lower sort key.","sdk-support":{"basic functionality":{js:"1.2.0",android:"9.1.0",ios:"5.8.0",macos:"0.15.0"},"data-driven styling":{js:"1.2.0",android:"9.1.0",ios:"5.8.0",macos:"0.15.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{doc:"The layer is shown."},none:{doc:"The layer is not shown."}},default:"visible",doc:"Whether this layer is displayed.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},"property-type":"constant"}},layout_symbol:{"symbol-placement":{type:"enum",values:{point:{doc:"The label is placed at the point where the geometry is located."},line:{doc:"The label is placed along the line of the geometry. Can only be used on `LineString` and `Polygon` geometries."},"line-center":{doc:"The label is placed at the center of the line of the geometry. Can only be used on `LineString` and `Polygon` geometries. Note that a single feature in a vector tile may contain multiple line geometries."}},default:"point",doc:"Label placement relative to its geometry.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"`line-center` value":{js:"0.47.0",android:"6.4.0",ios:"4.3.0",macos:"0.10.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-spacing":{type:"number",default:250,minimum:1,units:"pixels",doc:"Distance between two symbol anchors.",requires:[{"symbol-placement":"line"}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{type:"boolean",default:!1,doc:"If true, the symbols will not cross tile edges to avoid mutual collisions. Recommended in layers that don't have enough padding in the vector tile to prevent collisions, or if it is a point symbol layer placed after a line symbol layer. When using a client that supports global collision detection, like Mapbox GL JS version 0.42.0 or greater, enabling this property is not needed to prevent clipped labels at tile boundaries.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{type:"number",doc:"Sorts features in ascending order based on this value. Features with lower sort keys are drawn and placed first.  When `icon-allow-overlap` or `text-allow-overlap` is `false`, features with a lower sort key will have priority during placement. When `icon-allow-overlap` or `text-allow-overlap` is set to `true`, features with a higher sort key will overlap over features with a lower sort key.","sdk-support":{"basic functionality":{js:"0.53.0",android:"7.4.0",ios:"4.11.0",macos:"0.14.0"},"data-driven styling":{js:"0.53.0",android:"7.4.0",ios:"4.11.0",macos:"0.14.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{type:"enum",values:{auto:{doc:"Sorts symbols by `symbol-sort-key` if set. Otherwise, sorts symbols by their y-position relative to the viewport if `icon-allow-overlap` or `text-allow-overlap` is set to `true` or `icon-ignore-placement` or `text-ignore-placement` is `false`."},"viewport-y":{doc:"Sorts symbols by their y-position relative to the viewport if `icon-allow-overlap` or `text-allow-overlap` is set to `true` or `icon-ignore-placement` or `text-ignore-placement` is `false`."},source:{doc:"Sorts symbols by `symbol-sort-key` if set. Otherwise, no sorting is applied; symbols are rendered in the same order as the source data."}},default:"auto",doc:"Determines whether overlapping symbols in the same layer are rendered in the order that they appear in the data source or by their y-position relative to the viewport. To control the order and prioritization of symbols otherwise, use `symbol-sort-key`.","sdk-support":{"basic functionality":{js:"0.49.0",android:"6.6.0",ios:"4.5.0",macos:"0.12.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{type:"boolean",default:!1,doc:"If true, the icon will be visible even if it collides with other previously drawn symbols.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{type:"boolean",default:!1,doc:"If true, other symbols can be visible even if they collide with the icon.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-optional":{type:"boolean",default:!1,doc:"If true, text will display without their corresponding icons when the icon collides with other symbols and the text does not.",requires:["icon-image","text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{type:"enum",values:{map:{doc:"When `symbol-placement` is set to `point`, aligns icons east-west. When `symbol-placement` is set to `line` or `line-center`, aligns icon x-axes with the line."},viewport:{doc:"Produces icons whose x-axes are aligned with the x-axis of the viewport, regardless of the value of `symbol-placement`."},auto:{doc:"When `symbol-placement` is set to `point`, this is equivalent to `viewport`. When `symbol-placement` is set to `line` or `line-center`, this is equivalent to `map`."}},default:"auto",doc:"In combination with `symbol-placement`, determines the rotation behavior of icons.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"`auto` value":{js:"0.25.0",android:"4.2.0",ios:"3.4.0",macos:"0.3.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-size":{type:"number",default:1,minimum:0,units:"factor of the original icon size",doc:"Scales the original size of the icon by the provided factor. The new pixel size of the image will be the original pixel size multiplied by `icon-size`. 1 is the original size; 3 triples the size of the image.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.35.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{type:"enum",values:{none:{doc:"The icon is displayed at its intrinsic aspect ratio."},width:{doc:"The icon is scaled in the x-dimension to fit the width of the text."},height:{doc:"The icon is scaled in the y-dimension to fit the height of the text."},both:{doc:"The icon is scaled in both x- and y-dimensions."}},default:"none",doc:"Scales the icon to fit around the associated text.",requires:["icon-image","text-field"],"sdk-support":{"basic functionality":{js:"0.21.0",android:"4.2.0",ios:"3.4.0",macos:"0.2.1"},"stretchable icons":{js:"1.6.0",android:"9.2.0",ios:"5.8.0",macos:"0.15.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{type:"array",value:"number",length:4,default:[0,0,0,0],units:"pixels",doc:"Size of the additional area added to dimensions determined by `icon-text-fit`, in clockwise order: top, right, bottom, left.",requires:["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],"sdk-support":{"basic functionality":{js:"0.21.0",android:"4.2.0",ios:"3.4.0",macos:"0.2.1"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-image":{type:"resolvedImage",doc:"Name of image in sprite to use for drawing an image background.",tokens:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.35.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{type:"number",default:0,period:360,units:"degrees",doc:"Rotates the icon clockwise.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.21.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{type:"number",default:2,minimum:0,units:"pixels",doc:"Size of the additional area around the icon bounding box used for detecting symbol collisions.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{type:"boolean",default:!1,doc:"If true, the icon may be flipped to prevent it from being rendered upside-down.",requires:["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-offset":{type:"array",value:"number",length:2,default:[0,0],doc:"Offset distance of icon from its anchor. Positive values indicate right and down, while negative values indicate left and up. Each component is multiplied by the value of `icon-size` to obtain the final offset in pixels. When combined with `icon-rotate` the offset will be as if the rotated direction was up.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{type:"enum",values:{center:{doc:"The center of the icon is placed closest to the anchor."},left:{doc:"The left side of the icon is placed closest to the anchor."},right:{doc:"The right side of the icon is placed closest to the anchor."},top:{doc:"The top of the icon is placed closest to the anchor."},bottom:{doc:"The bottom of the icon is placed closest to the anchor."},"top-left":{doc:"The top left corner of the icon is placed closest to the anchor."},"top-right":{doc:"The top right corner of the icon is placed closest to the anchor."},"bottom-left":{doc:"The bottom left corner of the icon is placed closest to the anchor."},"bottom-right":{doc:"The bottom right corner of the icon is placed closest to the anchor."}},default:"center",doc:"Part of the icon placed closest to the anchor.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.40.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"},"data-driven styling":{js:"0.40.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{type:"enum",values:{map:{doc:"The icon is aligned to the plane of the map."},viewport:{doc:"The icon is aligned to the plane of the viewport."},auto:{doc:"Automatically matches the value of `icon-rotation-alignment`."}},default:"auto",doc:"Orientation of icon when map is pitched.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.39.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{type:"enum",values:{map:{doc:"The text is aligned to the plane of the map."},viewport:{doc:"The text is aligned to the plane of the viewport."},auto:{doc:"Automatically matches the value of `text-rotation-alignment`."}},default:"auto",doc:"Orientation of text when map is pitched.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.21.0",android:"4.2.0",ios:"3.4.0",macos:"0.2.1"},"`auto` value":{js:"0.25.0",android:"4.2.0",ios:"3.4.0",macos:"0.3.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{type:"enum",values:{map:{doc:"When `symbol-placement` is set to `point`, aligns text east-west. When `symbol-placement` is set to `line` or `line-center`, aligns text x-axes with the line."},viewport:{doc:"Produces glyphs whose x-axes are aligned with the x-axis of the viewport, regardless of the value of `symbol-placement`."},auto:{doc:"When `symbol-placement` is set to `point`, this is equivalent to `viewport`. When `symbol-placement` is set to `line` or `line-center`, this is equivalent to `map`."}},default:"auto",doc:"In combination with `symbol-placement`, determines the rotation behavior of the individual glyphs forming the text.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"`auto` value":{js:"0.25.0",android:"4.2.0",ios:"3.4.0",macos:"0.3.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-field":{type:"formatted",default:"",tokens:!0,doc:"Value to use for a text label. If a plain `string` is provided, it will be treated as a `formatted` with default/inherited formatting options.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-font":{type:"array",value:"string",default:["Open Sans Regular","Arial Unicode MS Regular"],doc:"Font stack to use for displaying text.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-size":{type:"number",default:16,minimum:0,units:"pixels",doc:"Font size.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.35.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{type:"number",default:10,minimum:0,units:"ems",doc:"The maximum line width for text wrapping.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.40.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"}},expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{type:"number",default:1.2,units:"ems",doc:"Text leading value for multi-line text.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-letter-spacing":{type:"number",default:0,units:"ems",doc:"Text tracking amount.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.40.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"}},expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-justify":{type:"enum",values:{auto:{doc:"The text is aligned towards the anchor position."},left:{doc:"The text is aligned to the left."},center:{doc:"The text is centered."},right:{doc:"The text is aligned to the right."}},default:"center",doc:"Text justification options.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.39.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"},auto:{js:"0.54.0",android:"7.4.0",ios:"4.10.0",macos:"0.14.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{type:"number",units:"ems",default:0,doc:"Radial offset of text, in the direction of the symbol's anchor. Useful in combination with `text-variable-anchor`, which defaults to using the two-dimensional `text-offset` if present.","sdk-support":{"basic functionality":{js:"0.54.0",android:"7.4.0",ios:"4.10.0",macos:"0.14.0"},"data-driven styling":{js:"0.54.0",android:"7.4.0",ios:"4.10.0",macos:"0.14.0"}},requires:["text-field"],"property-type":"data-driven",expression:{interpolated:!0,parameters:["zoom","feature"]}},"text-variable-anchor":{type:"array",value:"enum",values:{center:{doc:"The center of the text is placed closest to the anchor."},left:{doc:"The left side of the text is placed closest to the anchor."},right:{doc:"The right side of the text is placed closest to the anchor."},top:{doc:"The top of the text is placed closest to the anchor."},bottom:{doc:"The bottom of the text is placed closest to the anchor."},"top-left":{doc:"The top left corner of the text is placed closest to the anchor."},"top-right":{doc:"The top right corner of the text is placed closest to the anchor."},"bottom-left":{doc:"The bottom left corner of the text is placed closest to the anchor."},"bottom-right":{doc:"The bottom right corner of the text is placed closest to the anchor."}},requires:["text-field",{"symbol-placement":["point"]}],doc:"To increase the chance of placing high-priority labels on the map, you can provide an array of `text-anchor` locations: the renderer will attempt to place the label at each location, in order, before moving onto the next label. Use `text-justify: auto` to choose justification based on anchor position. To apply an offset, use the `text-radial-offset` or the two-dimensional `text-offset`.","sdk-support":{"basic functionality":{js:"0.54.0",android:"7.4.0",ios:"4.10.0",macos:"0.14.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-anchor":{type:"enum",values:{center:{doc:"The center of the text is placed closest to the anchor."},left:{doc:"The left side of the text is placed closest to the anchor."},right:{doc:"The right side of the text is placed closest to the anchor."},top:{doc:"The top of the text is placed closest to the anchor."},bottom:{doc:"The bottom of the text is placed closest to the anchor."},"top-left":{doc:"The top left corner of the text is placed closest to the anchor."},"top-right":{doc:"The top right corner of the text is placed closest to the anchor."},"bottom-left":{doc:"The bottom left corner of the text is placed closest to the anchor."},"bottom-right":{doc:"The bottom right corner of the text is placed closest to the anchor."}},default:"center",doc:"Part of the text placed closest to the anchor.",requires:["text-field",{"!":"text-variable-anchor"}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.39.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{type:"number",default:45,units:"degrees",doc:"Maximum angle change between adjacent characters.",requires:["text-field",{"symbol-placement":["line","line-center"]}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-writing-mode":{type:"array",value:"enum",values:{horizontal:{doc:"If a text's language supports horizontal writing mode, symbols with point placement would be laid out horizontally."},vertical:{doc:"If a text's language supports vertical writing mode, symbols with point placement would be laid out vertically."}},doc:"The property allows control over a symbol's orientation. Note that the property values act as a hint, so that a symbol whose language doesn’t support the provided orientation will be laid out in its natural orientation. Example: English point symbol will be rendered horizontally even if array value contains single 'vertical' enum value. The order of elements in an array define priority order for the placement of an orientation variant.",requires:["text-field",{"symbol-placement":["point"]}],"sdk-support":{"basic functionality":{js:"1.3.0",android:"8.3.0",ios:"5.3.0",macos:"0.15.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotate":{type:"number",default:0,period:360,units:"degrees",doc:"Rotates the text clockwise.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.35.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-padding":{type:"number",default:2,minimum:0,units:"pixels",doc:"Size of the additional area around the text bounding box used for detecting symbol collisions.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-keep-upright":{type:"boolean",default:!0,doc:"If true, the text may be flipped vertically to prevent it from being rendered upside-down.",requires:["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-transform":{type:"enum",values:{none:{doc:"The text is not altered."},uppercase:{doc:"Forces all letters to be displayed in uppercase."},lowercase:{doc:"Forces all letters to be displayed in lowercase."}},default:"none",doc:"Specifies how to capitalize text, similar to the CSS `text-transform` property.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-offset":{type:"array",doc:"Offset distance of text from its anchor. Positive values indicate right and down, while negative values indicate left and up. If used with text-variable-anchor, input values will be taken as absolute values. Offsets along the x- and y-axis will be applied automatically based on the anchor position.",value:"number",units:"ems",length:2,default:[0,0],requires:["text-field",{"!":"text-radial-offset"}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.35.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{type:"boolean",default:!1,doc:"If true, the text will be visible even if it collides with other previously drawn symbols.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{type:"boolean",default:!1,doc:"If true, other symbols can be visible even if they collide with the text.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-optional":{type:"boolean",default:!1,doc:"If true, icons will display without their corresponding text when the text collides with other symbols and the icon does not.",requires:["text-field","icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},visibility:{type:"enum",values:{visible:{doc:"The layer is shown."},none:{doc:"The layer is not shown."}},default:"visible",doc:"Whether this layer is displayed.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},"property-type":"constant"}},layout_raster:{visibility:{type:"enum",values:{visible:{doc:"The layer is shown."},none:{doc:"The layer is not shown."}},default:"visible",doc:"Whether this layer is displayed.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},"property-type":"constant"}},layout_hillshade:{visibility:{type:"enum",values:{visible:{doc:"The layer is shown."},none:{doc:"The layer is not shown."}},default:"visible",doc:"Whether this layer is displayed.","sdk-support":{"basic functionality":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},"property-type":"constant"}},filter:{type:"array",value:"*",doc:"A filter selects specific features from a layer."},filter_operator:{type:"enum",values:{"==":{doc:'`["==", key, value]` equality: `feature[key] = value`'},"!=":{doc:'`["!=", key, value]` inequality: `feature[key] ≠ value`'},">":{doc:'`[">", key, value]` greater than: `feature[key] > value`'},">=":{doc:'`[">=", key, value]` greater than or equal: `feature[key] ≥ value`'},"<":{doc:'`["<", key, value]` less than: `feature[key] < value`'},"<=":{doc:'`["<=", key, value]` less than or equal: `feature[key] ≤ value`'},in:{doc:'`["in", key, v0, ..., vn]` set inclusion: `feature[key] ∈ {v0, ..., vn}`'},"!in":{doc:'`["!in", key, v0, ..., vn]` set exclusion: `feature[key] ∉ {v0, ..., vn}`'},all:{doc:'`["all", f0, ..., fn]` logical `AND`: `f0 ∧ ... ∧ fn`'},any:{doc:'`["any", f0, ..., fn]` logical `OR`: `f0 ∨ ... ∨ fn`'},none:{doc:'`["none", f0, ..., fn]` logical `NOR`: `¬f0 ∧ ... ∧ ¬fn`'},has:{doc:'`["has", key]` `feature[key]` exists'},"!has":{doc:'`["!has", key]` `feature[key]` does not exist'},within:{doc:'`["within", object]` feature geometry is within object geometry'}},doc:"The filter operator."},geometry_type:{type:"enum",values:{Point:{doc:"Filter to point geometries."},LineString:{doc:"Filter to line geometries."},Polygon:{doc:"Filter to polygon geometries."}},doc:"The geometry type for the filter to select."},function:{expression:{type:"expression",doc:"An expression."},stops:{type:"array",doc:"An array of stops.",value:"function_stop"},base:{type:"number",default:1,minimum:0,doc:"The exponential base of the interpolation curve. It controls the rate at which the result increases. Higher values make the result increase more towards the high end of the range. With `1` the stops are interpolated linearly."},property:{type:"string",doc:"The name of a feature property to use as the function input.",default:"$zoom"},type:{type:"enum",values:{identity:{doc:"Return the input value as the output value."},exponential:{doc:"Generate an output by interpolating between stops just less than and just greater than the function input."},interval:{doc:"Return the output value of the stop just less than the function input."},categorical:{doc:"Return the output value of the stop equal to the function input."}},doc:"The interpolation strategy to use in function evaluation.",default:"exponential"},colorSpace:{type:"enum",values:{rgb:{doc:"Use the RGB color space to interpolate color values"},lab:{doc:"Use the LAB color space to interpolate color values."},hcl:{doc:"Use the HCL color space to interpolate color values, interpolating the Hue, Chroma, and Luminance channels individually."}},doc:"The color space in which colors interpolated. Interpolating colors in perceptual color spaces like LAB and HCL tend to produce color ramps that look more consistent and produce colors that can be differentiated more easily than those interpolated in RGB space.",default:"rgb"},default:{type:"*",required:!1,doc:"A value to serve as a fallback function result when a value isn't otherwise available. It is used in the following circumstances:\n* In categorical functions, when the feature value does not match any of the stop domain values.\n* In property and zoom-and-property functions, when a feature does not contain a value for the specified property.\n* In identity functions, when the feature value is not valid for the style property (for example, if the function is being used for a `circle-color` property but the feature property value is not a string or not a valid color).\n* In interval or exponential property and zoom-and-property functions, when the feature value is not numeric.\nIf no default is provided, the style property's default is used in these circumstances."}},function_stop:{type:"array",minimum:0,maximum:24,value:["number","color"],length:2,doc:"Zoom level and value pair."},expression:{type:"array",value:"*",minimum:1,doc:"An expression defines a function that can be used for data-driven style properties or feature filters."},expression_name:{doc:"",type:"enum",values:{let:{doc:'Binds expressions to named variables, which can then be referenced in the result expression using ["var", "variable_name"].',group:"Variable binding","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},var:{doc:'References variable bound using "let".',group:"Variable binding","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},literal:{doc:"Provides a literal array or object value.",group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},array:{doc:"Asserts that the input is an array (optionally with a specific item type and length).  If, when the input expression is evaluated, it is not of the asserted type, then this assertion will cause the whole expression to be aborted.",group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},at:{doc:"Retrieves an item from an array.",group:"Lookup","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},in:{doc:"Determines whether an item exists in an array or a substring exists in a string.",group:"Lookup","sdk-support":{"basic functionality":{js:"1.6.0",android:"9.1.0",ios:"5.8.0",macos:"0.15.0"}}},"index-of":{doc:"Returns the first position at which an item can be found in an array or a substring can be found in a string, or `-1` if the input cannot be found. Accepts an optional index from where to begin the search.",group:"Lookup","sdk-support":{"basic functionality":{js:"1.10.0"}}},slice:{doc:"Returns an item from an array or a substring from a string from a specified start index, or between a start index and an end index if set. The return value is inclusive of the start index but not of the end index.",group:"Lookup","sdk-support":{"basic functionality":{js:"1.10.0"}}},case:{doc:"Selects the first output whose corresponding test condition evaluates to true, or the fallback value otherwise.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},match:{doc:'Selects the output whose label value matches the input value, or the fallback value if no match is found. The input can be any expression (e.g. `["get", "building_type"]`). Each label must be either:\n - a single literal value; or\n - an array of literal values, whose values must be all strings or all numbers (e.g. `[100, 101]` or `["c", "b"]`). The input matches if any of the values in the array matches, similar to the `"in"` operator.\nEach label must be unique. If the input type does not match the type of the labels, the result will be the fallback value.',group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},coalesce:{doc:"Evaluates each expression in turn until the first non-null value is obtained, and returns that value.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},step:{doc:'Produces discrete, stepped results by evaluating a piecewise-constant function defined by pairs of input and output values ("stops"). The `input` may be any numeric expression (e.g., `["get", "population"]`). Stop inputs must be numeric literals in strictly ascending order. Returns the output value of the stop just less than the input, or the first output if the input is less than the first stop.',group:"Ramps, scales, curves","sdk-support":{"basic functionality":{js:"0.42.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},interpolate:{doc:'Produces continuous, smooth results by interpolating between pairs of input and output values ("stops"). The `input` may be any numeric expression (e.g., `["get", "population"]`). Stop inputs must be numeric literals in strictly ascending order. The output type must be `number`, `array<number>`, or `color`.\n\nInterpolation types:\n- `["linear"]`: Interpolates linearly between the pair of stops just less than and just greater than the input.\n- `["exponential", base]`: Interpolates exponentially between the stops just less than and just greater than the input. `base` controls the rate at which the output increases: higher values make the output increase more towards the high end of the range. With values close to 1 the output increases linearly.\n- `["cubic-bezier", x1, y1, x2, y2]`: Interpolates using the cubic bezier curve defined by the given control points.',group:"Ramps, scales, curves","sdk-support":{"basic functionality":{js:"0.42.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"interpolate-hcl":{doc:'Produces continuous, smooth results by interpolating between pairs of input and output values ("stops"). Works like `interpolate`, but the output type must be `color`, and the interpolation is performed in the Hue-Chroma-Luminance color space.',group:"Ramps, scales, curves","sdk-support":{"basic functionality":{js:"0.49.0"}}},"interpolate-lab":{doc:'Produces continuous, smooth results by interpolating between pairs of input and output values ("stops"). Works like `interpolate`, but the output type must be `color`, and the interpolation is performed in the CIELAB color space.',group:"Ramps, scales, curves","sdk-support":{"basic functionality":{js:"0.49.0"}}},ln2:{doc:"Returns mathematical constant ln(2).",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},pi:{doc:"Returns the mathematical constant pi.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},e:{doc:"Returns the mathematical constant e.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},typeof:{doc:"Returns a string describing the type of the given value.",group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},string:{doc:"Asserts that the input value is a string. If multiple values are provided, each one is evaluated in order until a string is obtained. If none of the inputs are strings, the expression is an error.",group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},number:{doc:"Asserts that the input value is a number. If multiple values are provided, each one is evaluated in order until a number is obtained. If none of the inputs are numbers, the expression is an error.",group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},boolean:{doc:"Asserts that the input value is a boolean. If multiple values are provided, each one is evaluated in order until a boolean is obtained. If none of the inputs are booleans, the expression is an error.",group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},object:{doc:"Asserts that the input value is an object. If multiple values are provided, each one is evaluated in order until an object is obtained. If none of the inputs are objects, the expression is an error.",group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},collator:{doc:"Returns a `collator` for use in locale-dependent comparison operations. The `case-sensitive` and `diacritic-sensitive` options default to `false`. The `locale` argument specifies the IETF language tag of the locale to use. If none is provided, the default locale is used. If the requested locale is not available, the `collator` will use a system-defined fallback locale. Use `resolved-locale` to test the results of locale fallback behavior.",group:"Types","sdk-support":{"basic functionality":{js:"0.45.0",android:"6.5.0",ios:"4.2.0",macos:"0.9.0"}}},format:{doc:'Returns a `formatted` string for displaying mixed-format text in the `text-field` property. The input may contain a string literal or expression, including an [`\'image\'`](#types-image) expression. Strings may be followed by a style override object that supports the following properties:\n- `"text-font"`: Overrides the font stack specified by the root layout property.\n- `"text-color"`: Overrides the color specified by the root paint property.\n- `"font-scale"`: Applies a scaling factor on `text-size` as specified by the root layout property.',group:"Types","sdk-support":{"basic functionality":{js:"0.48.0",android:"6.7.0",ios:"4.6.0",macos:"0.12.0"},"text-font":{js:"0.48.0",android:"6.7.0",ios:"4.6.0",macos:"0.12.0"},"font-scale":{js:"0.48.0",android:"6.7.0",ios:"4.6.0",macos:"0.12.0"},"text-color":{js:"1.3.0",android:"7.3.0",ios:"4.10.0",macos:"0.14.0"},image:{js:"1.6.0",android:"8.6.0",ios:"5.7.0",macos:"0.15.0"}}},image:{doc:"Returns an `image` type for use in `icon-image`, `*-pattern` entries and as a section in the `format` expression. If set, the `image` argument will check that the requested image exists in the style and will return either the resolved image name or `null`, depending on whether or not the image is currently in the style. This validation process is synchronous and requires the image to have been added to the style before requesting it in the `image` argument.",group:"Types","sdk-support":{"basic functionality":{js:"1.4.0",android:"8.6.0",ios:"5.7.0",macos:"0.15.0"}}},"number-format":{doc:"Converts the input number into a string representation using the providing formatting rules. If set, the `locale` argument specifies the locale to use, as a BCP 47 language tag. If set, the `currency` argument specifies an ISO 4217 code to use for currency-style formatting. If set, the `min-fraction-digits` and `max-fraction-digits` arguments specify the minimum and maximum number of fractional digits to include.",group:"Types","sdk-support":{"basic functionality":{js:"0.54.0"}}},"to-string":{doc:'Converts the input value to a string. If the input is `null`, the result is `""`. If the input is a boolean, the result is `"true"` or `"false"`. If the input is a number, it is converted to a string as specified by the ["NumberToString" algorithm](https://tc39.github.io/ecma262/#sec-tostring-applied-to-the-number-type) of the ECMAScript Language Specification. If the input is a color, it is converted to a string of the form `"rgba(r,g,b,a)"`, where `r`, `g`, and `b` are numerals ranging from 0 to 255, and `a` ranges from 0 to 1. Otherwise, the input is converted to a string in the format specified by the [`JSON.stringify`](https://tc39.github.io/ecma262/#sec-json.stringify) function of the ECMAScript Language Specification.',group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"to-number":{doc:'Converts the input value to a number, if possible. If the input is `null` or `false`, the result is 0. If the input is `true`, the result is 1. If the input is a string, it is converted to a number as specified by the ["ToNumber Applied to the String Type" algorithm](https://tc39.github.io/ecma262/#sec-tonumber-applied-to-the-string-type) of the ECMAScript Language Specification. If multiple values are provided, each one is evaluated in order until the first successful conversion is obtained. If none of the inputs can be converted, the expression is an error.',group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"to-boolean":{doc:"Converts the input value to a boolean. The result is `false` when then input is an empty string, 0, `false`, `null`, or `NaN`; otherwise it is `true`.",group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"to-rgba":{doc:"Returns a four-element array containing the input color's red, green, blue, and alpha components, in that order.",group:"Color","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"to-color":{doc:"Converts the input value to a color. If multiple values are provided, each one is evaluated in order until the first successful conversion is obtained. If none of the inputs can be converted, the expression is an error.",group:"Types","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},rgb:{doc:"Creates a color value from red, green, and blue components, which must range between 0 and 255, and an alpha component of 1. If any component is out of range, the expression is an error.",group:"Color","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},rgba:{doc:"Creates a color value from red, green, blue components, which must range between 0 and 255, and an alpha component which must range between 0 and 1. If any component is out of range, the expression is an error.",group:"Color","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},get:{doc:"Retrieves a property value from the current feature's properties, or from another object if a second argument is provided. Returns null if the requested property is missing.",group:"Lookup","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},has:{doc:"Tests for the presence of an property value in the current feature's properties, or from another object if a second argument is provided.",group:"Lookup","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},length:{doc:"Gets the length of an array or string.",group:"Lookup","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},properties:{doc:'Gets the feature properties object.  Note that in some cases, it may be more efficient to use ["get", "property_name"] directly.',group:"Feature data","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"feature-state":{doc:"Retrieves a property value from the current feature's state. Returns null if the requested property is not present on the feature's state. A feature's state is not part of the GeoJSON or vector tile data, and must be set programmatically on each feature. Features are identified by their `id` attribute, which must be an integer or a string that can be cast to an integer. Note that [\"feature-state\"] can only be used with paint properties that support data-driven styling.",group:"Feature data","sdk-support":{"basic functionality":{js:"0.46.0"}}},"geometry-type":{doc:"Gets the feature's geometry type: `Point`, `MultiPoint`, `LineString`, `MultiLineString`, `Polygon`, `MultiPolygon`.",group:"Feature data","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},id:{doc:"Gets the feature's id, if it has one.",group:"Feature data","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},zoom:{doc:'Gets the current zoom level.  Note that in style layout and paint properties, ["zoom"] may only appear as the input to a top-level "step" or "interpolate" expression.',group:"Zoom","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"heatmap-density":{doc:"Gets the kernel density estimation of a pixel in a heatmap layer, which is a relative measure of how many data points are crowded around a particular pixel. Can only be used in the `heatmap-color` property.",group:"Heatmap","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"line-progress":{doc:"Gets the progress along a gradient line. Can only be used in the `line-gradient` property.",group:"Feature data","sdk-support":{"basic functionality":{js:"0.45.0",android:"6.5.0",ios:"4.6.0",macos:"0.12.0"}}},accumulated:{doc:"Gets the value of a cluster property accumulated so far. Can only be used in the `clusterProperties` option of a clustered GeoJSON source.",group:"Feature data","sdk-support":{"basic functionality":{js:"0.53.0"}}},"+":{doc:"Returns the sum of the inputs.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"*":{doc:"Returns the product of the inputs.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"-":{doc:"For two inputs, returns the result of subtracting the second input from the first. For a single input, returns the result of subtracting it from 0.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"/":{doc:"Returns the result of floating point division of the first input by the second.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"%":{doc:"Returns the remainder after integer division of the first input by the second.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"^":{doc:"Returns the result of raising the first input to the power specified by the second.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},sqrt:{doc:"Returns the square root of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.42.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},log10:{doc:"Returns the base-ten logarithm of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},ln:{doc:"Returns the natural logarithm of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},log2:{doc:"Returns the base-two logarithm of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},sin:{doc:"Returns the sine of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},cos:{doc:"Returns the cosine of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},tan:{doc:"Returns the tangent of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},asin:{doc:"Returns the arcsine of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},acos:{doc:"Returns the arccosine of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},atan:{doc:"Returns the arctangent of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},min:{doc:"Returns the minimum value of the inputs.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},max:{doc:"Returns the maximum value of the inputs.",group:"Math","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},round:{doc:'Rounds the input to the nearest integer. Halfway values are rounded away from zero. For example, `["round", -1.5]` evaluates to -2.',group:"Math","sdk-support":{"basic functionality":{js:"0.45.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},abs:{doc:"Returns the absolute value of the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.45.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},ceil:{doc:"Returns the smallest integer that is greater than or equal to the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.45.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},floor:{doc:"Returns the largest integer that is less than or equal to the input.",group:"Math","sdk-support":{"basic functionality":{js:"0.45.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},distance:{doc:"Returns the shortest distance in meters between the evaluated feature and the input geometry. The input value can be a valid GeoJSON of type `Point`, `MultiPoint`, `LineString`, `MultiLineString`, `Polygon`, `MultiPolygon`, `Feature`, or `FeatureCollection`. Distance values returned may vary in precision due to loss in precision from encoding geometries, particularly below zoom level 13.",group:"Math","sdk-support":{"basic functionality":{android:"9.2.0",ios:"5.9.0",macos:"0.16.0"}}},"==":{doc:"Returns `true` if the input values are equal, `false` otherwise. The comparison is strictly typed: values of different runtime types are always considered unequal. Cases where the types are known to be different at parse time are considered invalid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"},collator:{js:"0.45.0",android:"6.5.0",ios:"4.2.0",macos:"0.9.0"}}},"!=":{doc:"Returns `true` if the input values are not equal, `false` otherwise. The comparison is strictly typed: values of different runtime types are always considered unequal. Cases where the types are known to be different at parse time are considered invalid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"},collator:{js:"0.45.0",android:"6.5.0",ios:"4.2.0",macos:"0.9.0"}}},">":{doc:"Returns `true` if the first input is strictly greater than the second, `false` otherwise. The arguments are required to be either both strings or both numbers; if during evaluation they are not, expression evaluation produces an error. Cases where this constraint is known not to hold at parse time are considered in valid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"},collator:{js:"0.45.0",android:"6.5.0",ios:"4.2.0",macos:"0.9.0"}}},"<":{doc:"Returns `true` if the first input is strictly less than the second, `false` otherwise. The arguments are required to be either both strings or both numbers; if during evaluation they are not, expression evaluation produces an error. Cases where this constraint is known not to hold at parse time are considered in valid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"},collator:{js:"0.45.0",android:"6.5.0",ios:"4.2.0",macos:"0.9.0"}}},">=":{doc:"Returns `true` if the first input is greater than or equal to the second, `false` otherwise. The arguments are required to be either both strings or both numbers; if during evaluation they are not, expression evaluation produces an error. Cases where this constraint is known not to hold at parse time are considered in valid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"},collator:{js:"0.45.0",android:"6.5.0",ios:"4.2.0",macos:"0.9.0"}}},"<=":{doc:"Returns `true` if the first input is less than or equal to the second, `false` otherwise. The arguments are required to be either both strings or both numbers; if during evaluation they are not, expression evaluation produces an error. Cases where this constraint is known not to hold at parse time are considered in valid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"},collator:{js:"0.45.0",android:"6.5.0",ios:"4.2.0",macos:"0.9.0"}}},all:{doc:"Returns `true` if all the inputs are `true`, `false` otherwise. The inputs are evaluated in order, and evaluation is short-circuiting: once an input expression evaluates to `false`, the result is `false` and no further input expressions are evaluated.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},any:{doc:"Returns `true` if any of the inputs are `true`, `false` otherwise. The inputs are evaluated in order, and evaluation is short-circuiting: once an input expression evaluates to `true`, the result is `true` and no further input expressions are evaluated.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"!":{doc:"Logical negation. Returns `true` if the input is `false`, and `false` if the input is `true`.",group:"Decision","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},within:{doc:"Returns `true` if the evaluated feature is fully contained inside a boundary of the input geometry, `false` otherwise. The input value can be a valid GeoJSON of type `Polygon`, `MultiPolygon`, `Feature`, or `FeatureCollection`. Supported features for evaluation:\n- `Point`: Returns `false` if a point is on the boundary or falls outside the boundary.\n- `LineString`: Returns `false` if any part of a line falls outside the boundary, the line intersects the boundary, or a line's endpoint is on the boundary.",group:"Decision","sdk-support":{"basic functionality":{js:"1.9.0",android:"9.1.0",ios:"5.8.0",macos:"0.15.0"}}},"is-supported-script":{doc:"Returns `true` if the input string is expected to render legibly. Returns `false` if the input string contains sections that cannot be rendered without potential loss of meaning (e.g. Indic scripts that require complex text shaping, or right-to-left scripts if the the `mapbox-gl-rtl-text` plugin is not in use in Mapbox GL JS).",group:"String","sdk-support":{"basic functionality":{js:"0.45.0",android:"6.6.0"}}},upcase:{doc:"Returns the input string converted to uppercase. Follows the Unicode Default Case Conversion algorithm and the locale-insensitive case mappings in the Unicode Character Database.",group:"String","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},downcase:{doc:"Returns the input string converted to lowercase. Follows the Unicode Default Case Conversion algorithm and the locale-insensitive case mappings in the Unicode Character Database.",group:"String","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},concat:{doc:"Returns a `string` consisting of the concatenation of the inputs. Each input is converted to a string as if by `to-string`.",group:"String","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}}},"resolved-locale":{doc:"Returns the IETF language tag of the locale being used by the provided `collator`. This can be used to determine the default system locale, or to determine if a requested locale was successfully loaded.",group:"String","sdk-support":{"basic functionality":{js:"0.45.0",android:"6.5.0",ios:"4.2.0",macos:"0.9.0"}}}}},light:{anchor:{type:"enum",default:"viewport",values:{map:{doc:"The position of the light source is aligned to the rotation of the map."},viewport:{doc:"The position of the light source is aligned to the rotation of the viewport."}},"property-type":"data-constant",transition:!1,expression:{interpolated:!1,parameters:["zoom"]},doc:"Whether extruded geometries are lit relative to the map or viewport.",example:"map","sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}}},position:{type:"array",default:[1.15,210,30],length:3,value:"number","property-type":"data-constant",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},doc:"Position of the light source relative to lit (extruded) geometries, in [r radial coordinate, a azimuthal angle, p polar angle] where r indicates the distance from the center of the base of an object to its light, a indicates the position of the light relative to 0° (0° when `light.anchor` is set to `viewport` corresponds to the top of the viewport, or 0° when `light.anchor` is set to `map` corresponds to due north, and degrees proceed clockwise), and p indicates the height of the light (from 0°, directly above, to 180°, directly below).",example:[1.5,90,80],"sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}}},color:{type:"color","property-type":"data-constant",default:"#ffffff",expression:{interpolated:!0,parameters:["zoom"]},transition:!0,doc:"Color tint for lighting extruded geometries.","sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}}},intensity:{type:"number","property-type":"data-constant",default:.5,minimum:0,maximum:1,expression:{interpolated:!0,parameters:["zoom"]},transition:!0,doc:"Intensity of lighting (on a scale from 0 to 1). Higher numbers will present as more extreme contrast.","sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}}}},paint:["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background"],paint_fill:{"fill-antialias":{type:"boolean",default:!0,doc:"Whether or not the fill should be antialiased.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-opacity":{type:"number",default:1,minimum:0,maximum:1,doc:"The opacity of the entire fill layer. In contrast to the `fill-color`, this value will also affect the 1px stroke around the fill, if the stroke is used.",transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.21.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{type:"color",default:"#000000",doc:"The color of the filled part of this layer. This color can be specified as `rgba` with an alpha component and the color's opacity will not affect the opacity of the 1px stroke, if it is used.",transition:!0,requires:[{"!":"fill-pattern"}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.19.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{type:"color",doc:"The outline color of the fill. Matches the value of `fill-color` if unspecified.",transition:!0,requires:[{"!":"fill-pattern"},{"fill-antialias":!0}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.19.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",doc:"The geometry's offset. Values are [x, y] where negatives indicate left and up, respectively.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{type:"enum",values:{map:{doc:"The fill is translated relative to the map."},viewport:{doc:"The fill is translated relative to the viewport."}},doc:"Controls the frame of reference for `fill-translate`.",default:"map",requires:["fill-translate"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-pattern":{type:"resolvedImage",transition:!0,doc:"Name of image in sprite to use for drawing image fills. For seamless patterns, image width and height must be a factor of two (2, 4, 8, ..., 512). Note that zoom-dependent expressions will be evaluated only at integer zoom levels.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.49.0",android:"6.5.0",macos:"0.11.0",ios:"4.4.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{type:"number",default:1,minimum:0,maximum:1,doc:"The opacity of the entire fill extrusion layer. This is rendered on a per-layer, not per-feature, basis, and data-driven styling is not available.",transition:!0,"sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{type:"color",default:"#000000",doc:"The base color of the extruded fill. The extrusion's surfaces will be shaded differently based on this color in combination with the root `light` settings. If this color is specified as `rgba` with an alpha component, the alpha component will be ignored; use `fill-extrusion-opacity` to set layer opacity.",transition:!0,requires:[{"!":"fill-extrusion-pattern"}],"sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"},"data-driven styling":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",doc:"The geometry's offset. Values are [x, y] where negatives indicate left and up (on the flat plane), respectively.","sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{type:"enum",values:{map:{doc:"The fill extrusion is translated relative to the map."},viewport:{doc:"The fill extrusion is translated relative to the viewport."}},doc:"Controls the frame of reference for `fill-extrusion-translate`.",default:"map",requires:["fill-extrusion-translate"],"sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{type:"resolvedImage",transition:!0,doc:"Name of image in sprite to use for drawing images on extruded fills. For seamless patterns, image width and height must be a factor of two (2, 4, 8, ..., 512). Note that zoom-dependent expressions will be evaluated only at integer zoom levels.","sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"},"data-driven styling":{js:"0.49.0",android:"6.5.0",macos:"0.11.0",ios:"4.4.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"fill-extrusion-height":{type:"number",default:0,minimum:0,units:"meters",doc:"The height with which to extrude this layer.",transition:!0,"sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"},"data-driven styling":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{type:"number",default:0,minimum:0,units:"meters",doc:"The height with which to extrude the base of this layer. Must be less than or equal to `fill-extrusion-height`.",transition:!0,requires:["fill-extrusion-height"],"sdk-support":{"basic functionality":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"},"data-driven styling":{js:"0.27.0",android:"5.1.0",ios:"3.6.0",macos:"0.5.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{type:"boolean",default:!0,doc:"Whether to apply a vertical gradient to the sides of a fill-extrusion layer. If true, sides will be shaded slightly darker farther down.",transition:!1,"sdk-support":{"basic functionality":{js:"0.50.0",ios:"4.7.0",macos:"0.13.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_line:{"line-opacity":{type:"number",doc:"The opacity at which the line will be drawn.",default:1,minimum:0,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{type:"color",doc:"The color with which the line will be drawn.",default:"#000000",transition:!0,requires:[{"!":"line-pattern"}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.23.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",doc:"The geometry's offset. Values are [x, y] where negatives indicate left and up, respectively.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{type:"enum",values:{map:{doc:"The line is translated relative to the map."},viewport:{doc:"The line is translated relative to the viewport."}},doc:"Controls the frame of reference for `line-translate`.",default:"map",requires:["line-translate"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-width":{type:"number",default:1,minimum:0,transition:!0,units:"pixels",doc:"Stroke thickness.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.39.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{type:"number",default:0,minimum:0,doc:"Draws a line casing outside of a line's actual path. Value indicates the width of the inner gap.",transition:!0,units:"pixels","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{type:"number",default:0,doc:"The line's offset. For linear features, a positive value offsets the line to the right, relative to the direction of the line, and a negative value to the left. For polygon features, a positive value results in an inset, and a negative value results in an outset.",transition:!0,units:"pixels","sdk-support":{"basic functionality":{js:"0.12.1",android:"3.0.0",ios:"3.1.0",macos:"0.1.0"},"data-driven styling":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",doc:"Blur applied to the line, in pixels.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{type:"array",value:"number",doc:"Specifies the lengths of the alternating dashes and gaps that form the dash pattern. The lengths are later scaled by the line width. To convert a dash length to pixels, multiply the length by the current line width. Note that GeoJSON sources with `lineMetrics: true` specified won't render dashed lines to the expected scale. Also note that zoom-dependent expressions will be evaluated only at integer zoom levels.",minimum:0,transition:!0,units:"line widths",requires:[{"!":"line-pattern"}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"line-pattern":{type:"resolvedImage",transition:!0,doc:"Name of image in sprite to use for drawing image lines. For seamless patterns, image width must be a factor of two (2, 4, 8, ..., 512). Note that zoom-dependent expressions will be evaluated only at integer zoom levels.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.49.0",android:"6.5.0",macos:"0.11.0",ios:"4.4.0"}},expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-gradient":{type:"color",doc:'Defines a gradient with which to color a line feature. Can only be used with GeoJSON sources that specify `"lineMetrics": true`.',transition:!1,requires:[{"!":"line-dasharray"},{"!":"line-pattern"},{source:"geojson",has:{lineMetrics:!0}}],"sdk-support":{"basic functionality":{js:"0.45.0",android:"6.5.0",ios:"4.4.0",macos:"0.11.0"},"data-driven styling":{}},expression:{interpolated:!0,parameters:["line-progress"]},"property-type":"color-ramp"}},paint_circle:{"circle-radius":{type:"number",default:5,minimum:0,transition:!0,units:"pixels",doc:"Circle radius.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.18.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{type:"color",default:"#000000",doc:"The fill color of the circle.",transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.18.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{type:"number",default:0,doc:"Amount to blur the circle. 1 blurs the circle such that only the centerpoint is full opacity.",transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.20.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{type:"number",doc:"The opacity at which the circle will be drawn.",default:1,minimum:0,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.20.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",doc:"The geometry's offset. Values are [x, y] where negatives indicate left and up, respectively.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{type:"enum",values:{map:{doc:"The circle is translated relative to the map."},viewport:{doc:"The circle is translated relative to the viewport."}},doc:"Controls the frame of reference for `circle-translate`.",default:"map",requires:["circle-translate"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{type:"enum",values:{map:{doc:"Circles are scaled according to their apparent distance to the camera."},viewport:{doc:"Circles are not scaled."}},default:"map",doc:"Controls the scaling behavior of the circle when the map is pitched.","sdk-support":{"basic functionality":{js:"0.21.0",android:"4.2.0",ios:"3.4.0",macos:"0.2.1"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{type:"enum",values:{map:{doc:"The circle is aligned to the plane of the map."},viewport:{doc:"The circle is aligned to the plane of the viewport."}},default:"viewport",doc:"Orientation of circle when map is pitched.","sdk-support":{"basic functionality":{js:"0.39.0",android:"5.2.0",ios:"3.7.0",macos:"0.6.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",doc:"The width of the circle's stroke. Strokes are placed outside of the `circle-radius`.","sdk-support":{"basic functionality":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"},"data-driven styling":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{type:"color",default:"#000000",doc:"The stroke color of the circle.",transition:!0,"sdk-support":{"basic functionality":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"},"data-driven styling":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{type:"number",doc:"The opacity of the circle's stroke.",default:1,minimum:0,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"},"data-driven styling":{js:"0.29.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"}},paint_heatmap:{"heatmap-radius":{type:"number",default:30,minimum:1,transition:!0,units:"pixels",doc:"Radius of influence of one heatmap point in pixels. Increasing the value makes the heatmap smoother, but less detailed.","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"},"data-driven styling":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{type:"number",default:1,minimum:0,transition:!1,doc:"A measure of how much an individual point contributes to the heatmap. A value of 10 would be equivalent to having 10 points of weight 1 in the same spot. Especially useful when combined with clustering.","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"},"data-driven styling":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{type:"number",default:1,minimum:0,transition:!0,doc:"Similar to `heatmap-weight` but controls the intensity of the heatmap globally. Primarily used for adjusting the heatmap based on zoom level.","sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"heatmap-color":{type:"color",default:["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",.1,"royalblue",.3,"cyan",.5,"lime",.7,"yellow",1,"red"],doc:'Defines the color of each pixel based on its density value in a heatmap.  Should be an expression that uses `["heatmap-density"]` as input.',transition:!1,"sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"},"data-driven styling":{}},expression:{interpolated:!0,parameters:["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{type:"number",doc:"The global opacity at which the heatmap layer will be drawn.",default:1,minimum:0,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.41.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_symbol:{"icon-opacity":{doc:"The opacity at which the icon will be drawn.",type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{type:"color",default:"#000000",transition:!0,doc:"The color of the icon. This can only be used with sdf icons.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,doc:"The color of the icon's halo. Icon halos can only be used with SDF icons.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",doc:"Distance of halo to the icon outline.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",doc:"Fade out the halo towards the outside.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",doc:"Distance that the icon's anchor is moved from its original placement. Positive values indicate right and down, while negative values indicate left and up.",requires:["icon-image"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{type:"enum",values:{map:{doc:"Icons are translated relative to the map."},viewport:{doc:"Icons are translated relative to the viewport."}},doc:"Controls the frame of reference for `icon-translate`.",default:"map",requires:["icon-image","icon-translate"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-opacity":{type:"number",doc:"The opacity at which the text will be drawn.",default:1,minimum:0,maximum:1,transition:!0,requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{type:"color",doc:"The color with which the text will be drawn.",default:"#000000",transition:!0,overridable:!0,requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,doc:"The color of the text's halo, which helps it stand out from backgrounds.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",doc:"Distance of halo to the font outline. Max text halo width is 1/4 of the font-size.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",doc:"The halo's fadeout distance towards the outside.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{js:"0.33.0",android:"5.0.0",ios:"3.5.0",macos:"0.4.0"}},expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",doc:"Distance that the text's anchor is moved from its original placement. Positive values indicate right and down, while negative values indicate left and up.",requires:["text-field"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{type:"enum",values:{map:{doc:"The text is translated relative to the map."},viewport:{doc:"The text is translated relative to the viewport."}},doc:"Controls the frame of reference for `text-translate`.",default:"map",requires:["text-field","text-translate"],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_raster:{"raster-opacity":{type:"number",doc:"The opacity at which the image will be drawn.",default:1,minimum:0,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{type:"number",default:0,period:360,transition:!0,units:"degrees",doc:"Rotates hues around the color wheel.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{type:"number",doc:"Increase or reduce the brightness of the image. The value is the minimum brightness.",default:0,minimum:0,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{type:"number",doc:"Increase or reduce the brightness of the image. The value is the maximum brightness.",default:1,minimum:0,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-saturation":{type:"number",doc:"Increase or reduce the saturation of the image.",default:0,minimum:-1,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-contrast":{type:"number",doc:"Increase or reduce the contrast of the image.",default:0,minimum:-1,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-resampling":{type:"enum",doc:"The resampling/interpolation method to use for overscaling, also known as texture magnification filter",values:{linear:{doc:"(Bi)linear filtering interpolates pixel values using the weighted average of the four closest original source pixels creating a smooth but blurry look when overscaled"},nearest:{doc:"Nearest neighbor filtering interpolates pixel values using the nearest original source pixel creating a sharp but pixelated look when overscaled"}},default:"linear","sdk-support":{"basic functionality":{js:"0.47.0",android:"6.3.0",ios:"4.2.0",macos:"0.9.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{type:"number",default:300,minimum:0,transition:!1,units:"milliseconds",doc:"Fade duration when a new tile is added.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_hillshade:{"hillshade-illumination-direction":{type:"number",default:335,minimum:0,maximum:359,doc:"The direction of the light source used to generate the hillshading with 0 as the top of the viewport if `hillshade-illumination-anchor` is set to `viewport` and due north if `hillshade-illumination-anchor` is set to `map`.",transition:!1,"sdk-support":{"basic functionality":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{type:"enum",values:{map:{doc:"The hillshade illumination is relative to the north direction."},viewport:{doc:"The hillshade illumination is relative to the top of the viewport."}},default:"viewport",doc:"Direction of light source when map is rotated.","sdk-support":{"basic functionality":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{type:"number",doc:"Intensity of the hillshade",default:.5,minimum:0,maximum:1,transition:!0,"sdk-support":{"basic functionality":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{type:"color",default:"#000000",doc:"The shading color of areas that face away from the light source.",transition:!0,"sdk-support":{"basic functionality":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{type:"color",default:"#FFFFFF",doc:"The shading color of areas that faces towards the light source.",transition:!0,"sdk-support":{"basic functionality":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{type:"color",default:"#000000",doc:"The shading color used to accentuate rugged terrain like sharp cliffs and gorges.",transition:!0,"sdk-support":{"basic functionality":{js:"0.43.0",android:"6.0.0",ios:"4.0.0",macos:"0.7.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_background:{"background-color":{type:"color",default:"#000000",doc:"The color with which the background will be drawn.",transition:!0,requires:[{"!":"background-pattern"}],"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"background-pattern":{type:"resolvedImage",transition:!0,doc:"Name of image in sprite to use for drawing an image background. For seamless patterns, image width and height must be a factor of two (2, 4, 8, ..., 512). Note that zoom-dependent expressions will be evaluated only at integer zoom levels.","sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"},"data-driven styling":{}},expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"background-opacity":{type:"number",default:1,minimum:0,maximum:1,doc:"The opacity at which the background will be drawn.",transition:!0,"sdk-support":{"basic functionality":{js:"0.10.0",android:"2.0.1",ios:"2.0.0",macos:"0.1.0"}},expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},transition:{duration:{type:"number",default:300,minimum:0,units:"milliseconds",doc:"Time allotted for transitions to complete."},delay:{type:"number",default:0,minimum:0,units:"milliseconds",doc:"Length of time before a transition begins."}},"property-type":{"data-driven":{type:"property-type",doc:"Property is interpolable and can be represented using a property expression."},"cross-faded":{type:"property-type",doc:"Property is non-interpolable; rather, its values will be cross-faded to smoothly transition between integer zooms."},"cross-faded-data-driven":{type:"property-type",doc:"Property is non-interpolable; rather, its values will be cross-faded to smoothly transition between integer zooms. It can be represented using a property expression."},"color-ramp":{type:"property-type",doc:"Property should be specified using a color ramp from which the output color can be sampled based on a property calculation."},"data-constant":{type:"property-type",doc:"Property is interpolable but cannot be represented using a property expression."},constant:{type:"property-type",doc:"Property is constant across all zoom levels and property values."}},promoteId:{"*":{type:"string",doc:"A name of a feature property to use as ID for feature state."}}};var o="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:void 0!==t?t:"undefined"!=typeof self?self:{};function a(){throw new Error("Dynamic requires are not currently supported by rollup-plugin-commonjs")}function s(t,e){return t(e={exports:{}},e.exports),e.exports}var u=s((function(t,e){!function(r){var n=e&&!e.nodeType&&e,i=t&&!t.nodeType&&t,a="object"==typeof o&&o;a.global!==a&&a.window!==a&&a.self!==a||(r=a);var s,u,l=2147483647,h=/^xn--/,c=/[^\x20-\x7E]/,p=/[\x2E\u3002\uFF0E\uFF61]/g,f={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},d=Math.floor,g=String.fromCharCode;function y(t){throw RangeError(f[t])}function m(t,e){for(var r=t.length,n=[];r--;)n[r]=e(t[r]);return n}function v(t,e){var r=t.split("@"),n="";return r.length>1&&(n=r[0]+"@",t=r[1]),n+m((t=t.replace(p,".")).split("."),e).join(".")}function _(t){for(var e,r,n=[],i=0,o=t.length;i<o;)(e=t.charCodeAt(i++))>=55296&&e<=56319&&i<o?56320==(64512&(r=t.charCodeAt(i++)))?n.push(((1023&e)<<10)+(1023&r)+65536):(n.push(e),i--):n.push(e);return n}function b(t){return m(t,(function(t){var e="";return t>65535&&(e+=g((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=g(t)})).join("")}function x(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function w(t,e,r){var n=0;for(t=r?d(t/700):t>>1,t+=d(t/e);t>455;n+=36)t=d(t/35);return d(n+36*t/(t+38))}function S(t){var e,r,n,i,o,a,s,u,h,c,p,f=[],g=t.length,m=0,v=128,_=72;for((r=t.lastIndexOf("-"))<0&&(r=0),n=0;n<r;++n)t.charCodeAt(n)>=128&&y("not-basic"),f.push(t.charCodeAt(n));for(i=r>0?r+1:0;i<g;){for(o=m,a=1,s=36;i>=g&&y("invalid-input"),((u=(p=t.charCodeAt(i++))-48<10?p-22:p-65<26?p-65:p-97<26?p-97:36)>=36||u>d((l-m)/a))&&y("overflow"),m+=u*a,!(u<(h=s<=_?1:s>=_+26?26:s-_));s+=36)a>d(l/(c=36-h))&&y("overflow"),a*=c;_=w(m-o,e=f.length+1,0==o),d(m/e)>l-v&&y("overflow"),v+=d(m/e),m%=e,f.splice(m++,0,v)}return b(f)}function T(t){var e,r,n,i,o,a,s,u,h,c,p,f,m,v,b,S=[];for(f=(t=_(t)).length,e=128,r=0,o=72,a=0;a<f;++a)(p=t[a])<128&&S.push(g(p));for(n=i=S.length,i&&S.push("-");n<f;){for(s=l,a=0;a<f;++a)(p=t[a])>=e&&p<s&&(s=p);for(s-e>d((l-r)/(m=n+1))&&y("overflow"),r+=(s-e)*m,e=s,a=0;a<f;++a)if((p=t[a])<e&&++r>l&&y("overflow"),p==e){for(u=r,h=36;!(u<(c=h<=o?1:h>=o+26?26:h-o));h+=36)b=u-c,v=36-c,S.push(g(x(c+b%v,0))),u=d(b/v);S.push(g(x(u,0))),o=w(r,m,n==i),r=0,++n}++r,++e}return S.join("")}if(s={version:"1.3.2",ucs2:{decode:_,encode:b},decode:S,encode:T,toASCII:function(t){return v(t,(function(t){return c.test(t)?"xn--"+T(t):t}))},toUnicode:function(t){return v(t,(function(t){return h.test(t)?S(t.slice(4).toLowerCase()):t}))}},n&&i)if(t.exports==n)i.exports=s;else for(u in s)s.hasOwnProperty(u)&&(n[u]=s[u]);else r.punycode=s}(o)})),l=function(t){return"string"==typeof t},h=function(t){return"object"==typeof t&&null!==t},c=function(t){return null===t},p=function(t){return null==t};function f(t,e){return Object.prototype.hasOwnProperty.call(t,e)}var d=function(t,e,r,n){e=e||"&",r=r||"=";var i={};if("string"!=typeof t||0===t.length)return i;var o=/\+/g;t=t.split(e);var a=1e3;n&&"number"==typeof n.maxKeys&&(a=n.maxKeys);var s=t.length;a>0&&s>a&&(s=a);for(var u=0;u<s;++u){var l,h,c,p,d=t[u].replace(o,"%20"),g=d.indexOf(r);g>=0?(l=d.substr(0,g),h=d.substr(g+1)):(l=d,h=""),c=decodeURIComponent(l),p=decodeURIComponent(h),f(i,c)?Array.isArray(i[c])?i[c].push(p):i[c]=[i[c],p]:i[c]=p}return i},g=function(t){switch(typeof t){case"string":return t;case"boolean":return t?"true":"false";case"number":return isFinite(t)?t:"";default:return""}},y=function(t,e,r,n){return e=e||"&",r=r||"=",null===t&&(t=void 0),"object"==typeof t?Object.keys(t).map((function(n){var i=encodeURIComponent(g(n))+r;return Array.isArray(t[n])?t[n].map((function(t){return i+encodeURIComponent(g(t))})).join(e):i+encodeURIComponent(g(t[n]))})).join(e):n?encodeURIComponent(g(n))+r+encodeURIComponent(g(t)):""},m=s((function(t,e){e.decode=e.parse=d,e.encode=e.stringify=y}));m.decode,m.parse,m.encode,m.stringify;function v(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}var _=/^([a-z0-9.+-]+:)/i,b=/:[0-9]*$/,x=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,w=["{","}","|","\\","^","`"].concat(["<",">",'"',"`"," ","\r","\n","\t"]),S=["'"].concat(w),T=["%","/","?",";","#"].concat(S),E=["/","?","#"],C=/^[+a-z0-9A-Z_-]{0,63}$/,P=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,R={javascript:!0,"javascript:":!0},O={javascript:!0,"javascript:":!0},I={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0};function L(t,e,r){if(t&&h(t)&&t instanceof v)return t;var n=new v;return n.parse(t,e,r),n}v.prototype.parse=function(t,e,r){if(!l(t))throw new TypeError("Parameter 'url' must be a string, not "+typeof t);var n=t.indexOf("?"),i=-1!==n&&n<t.indexOf("#")?"?":"#",o=t.split(i);o[0]=o[0].replace(/\\/g,"/");var a=t=o.join(i);if(a=a.trim(),!r&&1===t.split("#").length){var s=x.exec(a);if(s)return this.path=a,this.href=a,this.pathname=s[1],s[2]?(this.search=s[2],this.query=e?m.parse(this.search.substr(1)):this.search.substr(1)):e&&(this.search="",this.query={}),this}var h=_.exec(a);if(h){var c=(h=h[0]).toLowerCase();this.protocol=c,a=a.substr(h.length)}if(r||h||a.match(/^\/\/[^@\/]+@[^@\/]+/)){var p="//"===a.substr(0,2);!p||h&&O[h]||(a=a.substr(2),this.slashes=!0)}if(!O[h]&&(p||h&&!I[h])){for(var f,d,g=-1,y=0;y<E.length;y++){-1!==(v=a.indexOf(E[y]))&&(-1===g||v<g)&&(g=v)}-1!==(d=-1===g?a.lastIndexOf("@"):a.lastIndexOf("@",g))&&(f=a.slice(0,d),a=a.slice(d+1),this.auth=decodeURIComponent(f)),g=-1;for(y=0;y<T.length;y++){var v;-1!==(v=a.indexOf(T[y]))&&(-1===g||v<g)&&(g=v)}-1===g&&(g=a.length),this.host=a.slice(0,g),a=a.slice(g),this.parseHost(),this.hostname=this.hostname||"";var b="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!b)for(var w=this.hostname.split(/\./),L=(y=0,w.length);y<L;y++){var M=w[y];if(M&&!M.match(C)){for(var F="",A=0,k=M.length;A<k;A++)M.charCodeAt(A)>127?F+="x":F+=M[A];if(!F.match(C)){var N=w.slice(0,y),j=w.slice(y+1),G=M.match(P);G&&(N.push(G[1]),j.unshift(G[2])),j.length&&(a="/"+j.join(".")+a),this.hostname=N.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),b||(this.hostname=u.toASCII(this.hostname));var D=this.port?":"+this.port:"",z=this.hostname||"";this.host=z+D,this.href+=this.host,b&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==a[0]&&(a="/"+a))}if(!R[c])for(y=0,L=S.length;y<L;y++){var U=S[y];if(-1!==a.indexOf(U)){var B=encodeURIComponent(U);B===U&&(B=escape(U)),a=a.split(U).join(B)}}var Y=a.indexOf("#");-1!==Y&&(this.hash=a.substr(Y),a=a.slice(0,Y));var V=a.indexOf("?");if(-1!==V?(this.search=a.substr(V),this.query=a.substr(V+1),e&&(this.query=m.parse(this.query)),a=a.slice(0,V)):e&&(this.search="",this.query={}),a&&(this.pathname=a),I[c]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){D=this.pathname||"";var W=this.search||"";this.path=D+W}return this.href=this.format(),this},v.prototype.format=function(){var t=this.auth||"";t&&(t=(t=encodeURIComponent(t)).replace(/%3A/i,":"),t+="@");var e=this.protocol||"",r=this.pathname||"",n=this.hash||"",i=!1,o="";this.host?i=t+this.host:this.hostname&&(i=t+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(i+=":"+this.port)),this.query&&h(this.query)&&Object.keys(this.query).length&&(o=m.stringify(this.query));var a=this.search||o&&"?"+o||"";return e&&":"!==e.substr(-1)&&(e+=":"),this.slashes||(!e||I[e])&&!1!==i?(i="//"+(i||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):i||(i=""),n&&"#"!==n.charAt(0)&&(n="#"+n),a&&"?"!==a.charAt(0)&&(a="?"+a),e+i+(r=r.replace(/[?#]/g,(function(t){return encodeURIComponent(t)})))+(a=a.replace("#","%23"))+n},v.prototype.resolve=function(t){return this.resolveObject(L(t,!1,!0)).format()},v.prototype.resolveObject=function(t){if(l(t)){var e=new v;e.parse(t,!1,!0),t=e}for(var r=new v,n=Object.keys(this),i=0;i<n.length;i++){var o=n[i];r[o]=this[o]}if(r.hash=t.hash,""===t.href)return r.href=r.format(),r;if(t.slashes&&!t.protocol){for(var a=Object.keys(t),s=0;s<a.length;s++){var u=a[s];"protocol"!==u&&(r[u]=t[u])}return I[r.protocol]&&r.hostname&&!r.pathname&&(r.path=r.pathname="/"),r.href=r.format(),r}if(t.protocol&&t.protocol!==r.protocol){if(!I[t.protocol]){for(var h=Object.keys(t),f=0;f<h.length;f++){var d=h[f];r[d]=t[d]}return r.href=r.format(),r}if(r.protocol=t.protocol,t.host||O[t.protocol])r.pathname=t.pathname;else{for(var g=(t.pathname||"").split("/");g.length&&!(t.host=g.shift()););t.host||(t.host=""),t.hostname||(t.hostname=""),""!==g[0]&&g.unshift(""),g.length<2&&g.unshift(""),r.pathname=g.join("/")}if(r.search=t.search,r.query=t.query,r.host=t.host||"",r.auth=t.auth,r.hostname=t.hostname||t.host,r.port=t.port,r.pathname||r.search){var y=r.pathname||"",m=r.search||"";r.path=y+m}return r.slashes=r.slashes||t.slashes,r.href=r.format(),r}var _=r.pathname&&"/"===r.pathname.charAt(0),b=t.host||t.pathname&&"/"===t.pathname.charAt(0),x=b||_||r.host&&t.pathname,w=x,S=r.pathname&&r.pathname.split("/")||[],T=(g=t.pathname&&t.pathname.split("/")||[],r.protocol&&!I[r.protocol]);if(T&&(r.hostname="",r.port=null,r.host&&(""===S[0]?S[0]=r.host:S.unshift(r.host)),r.host="",t.protocol&&(t.hostname=null,t.port=null,t.host&&(""===g[0]?g[0]=t.host:g.unshift(t.host)),t.host=null),x=x&&(""===g[0]||""===S[0])),b)r.host=t.host||""===t.host?t.host:r.host,r.hostname=t.hostname||""===t.hostname?t.hostname:r.hostname,r.search=t.search,r.query=t.query,S=g;else if(g.length)S||(S=[]),S.pop(),S=S.concat(g),r.search=t.search,r.query=t.query;else if(!p(t.search)){if(T)r.hostname=r.host=S.shift(),(L=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=L.shift(),r.host=r.hostname=L.shift());return r.search=t.search,r.query=t.query,c(r.pathname)&&c(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r}if(!S.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var E=S.slice(-1)[0],C=(r.host||t.host||S.length>1)&&("."===E||".."===E)||""===E,P=0,R=S.length;R>=0;R--)"."===(E=S[R])?S.splice(R,1):".."===E?(S.splice(R,1),P++):P&&(S.splice(R,1),P--);if(!x&&!w)for(;P--;P)S.unshift("..");!x||""===S[0]||S[0]&&"/"===S[0].charAt(0)||S.unshift(""),C&&"/"!==S.join("/").substr(-1)&&S.push("");var L,M=""===S[0]||S[0]&&"/"===S[0].charAt(0);T&&(r.hostname=r.host=M?"":S.length?S.shift():"",(L=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=L.shift(),r.host=r.hostname=L.shift()));return(x=x||r.host&&S.length)&&!M&&S.unshift(""),S.length?r.pathname=S.join("/"):(r.pathname=null,r.path=null),c(r.pathname)&&c(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=t.auth||r.auth,r.slashes=r.slashes||t.slashes,r.href=r.format(),r},v.prototype.parseHost=function(){var t=this.host,e=b.exec(t);e&&(":"!==(e=e[0])&&(this.port=e.substr(1)),t=t.substr(0,t.length-e.length)),t&&(this.hostname=t)};function M(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var o=i[n];for(var a in o)t[a]=o[a]}return t}var F=function(t){function e(e,r){t.call(this,r),this.message=r,this.key=e}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Error),A=function(t,e){void 0===e&&(e=[]),this.parent=t,this.bindings={};for(var r=0,n=e;r<n.length;r+=1){var i=n[r],o=i[0],a=i[1];this.bindings[o]=a}};A.prototype.concat=function(t){return new A(this,t)},A.prototype.get=function(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(t+" not found in scope.")},A.prototype.has=function(t){return!!this.bindings[t]||!!this.parent&&this.parent.has(t)};var k={kind:"null"},N={kind:"number"},j={kind:"string"},G={kind:"boolean"},D={kind:"color"},z={kind:"object"},U={kind:"value"},B={kind:"collator"},Y={kind:"formatted"},V={kind:"resolvedImage"};function W(t,e){return{kind:"array",itemType:t,N:e}}function q(t){if("array"===t.kind){var e=q(t.itemType);return"number"==typeof t.N?"array<"+e+", "+t.N+">":"value"===t.itemType.kind?"array":"array<"+e+">"}return t.kind}var X=[k,N,j,G,D,Y,z,W(U),V];function Z(t,e){if("error"===e.kind)return null;if("array"===t.kind){if("array"===e.kind&&(0===e.N&&"value"===e.itemType.kind||!Z(t.itemType,e.itemType))&&("number"!=typeof t.N||t.N===e.N))return null}else{if(t.kind===e.kind)return null;if("value"===t.kind)for(var r=0,n=X;r<n.length;r+=1){if(!Z(n[r],e))return null}}return"Expected "+q(t)+" but found "+q(e)+" instead."}function K(t,e){return e.some((function(e){return e.kind===t.kind}))}function H(t,e){return e.some((function(e){return"null"===e?null===t:"array"===e?Array.isArray(t):"object"===e?t&&!Array.isArray(t)&&"object"==typeof t:e===typeof t}))}var J=s((function(t,e){var r={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};function n(t){return(t=Math.round(t))<0?0:t>255?255:t}function i(t){return t<0?0:t>1?1:t}function o(t){return"%"===t[t.length-1]?n(parseFloat(t)/100*255):n(parseInt(t))}function a(t){return"%"===t[t.length-1]?i(parseFloat(t)/100):i(parseFloat(t))}function s(t,e,r){return r<0?r+=1:r>1&&(r-=1),6*r<1?t+(e-t)*r*6:2*r<1?e:3*r<2?t+(e-t)*(2/3-r)*6:t}try{e.parseCSSColor=function(t){var e,i=t.replace(/ /g,"").toLowerCase();if(i in r)return r[i].slice();if("#"===i[0])return 4===i.length?(e=parseInt(i.substr(1),16))>=0&&e<=4095?[(3840&e)>>4|(3840&e)>>8,240&e|(240&e)>>4,15&e|(15&e)<<4,1]:null:7===i.length&&(e=parseInt(i.substr(1),16))>=0&&e<=16777215?[(16711680&e)>>16,(65280&e)>>8,255&e,1]:null;var u=i.indexOf("("),l=i.indexOf(")");if(-1!==u&&l+1===i.length){var h=i.substr(0,u),c=i.substr(u+1,l-(u+1)).split(","),p=1;switch(h){case"rgba":if(4!==c.length)return null;p=a(c.pop());case"rgb":return 3!==c.length?null:[o(c[0]),o(c[1]),o(c[2]),p];case"hsla":if(4!==c.length)return null;p=a(c.pop());case"hsl":if(3!==c.length)return null;var f=(parseFloat(c[0])%360+360)%360/360,d=a(c[1]),g=a(c[2]),y=g<=.5?g*(d+1):g+d-g*d,m=2*g-y;return[n(255*s(m,y,f+1/3)),n(255*s(m,y,f)),n(255*s(m,y,f-1/3)),p];default:return null}}return null}}catch(t){}})).parseCSSColor,$=function(t,e,r,n){void 0===n&&(n=1),this.r=t,this.g=e,this.b=r,this.a=n};$.parse=function(t){if(t){if(t instanceof $)return t;if("string"==typeof t){var e=J(t);if(e)return new $(e[0]/255*e[3],e[1]/255*e[3],e[2]/255*e[3],e[3])}}},$.prototype.toString=function(){var t=this.toArray(),e=t[0],r=t[1],n=t[2],i=t[3];return"rgba("+Math.round(e)+","+Math.round(r)+","+Math.round(n)+","+i+")"},$.prototype.toArray=function(){var t=this.r,e=this.g,r=this.b,n=this.a;return 0===n?[0,0,0,0]:[255*t/n,255*e/n,255*r/n,n]},$.black=new $(0,0,0,1),$.white=new $(1,1,1,1),$.transparent=new $(0,0,0,0),$.red=new $(1,0,0,1);var Q=function(t,e,r){this.sensitivity=t?e?"variant":"case":e?"accent":"base",this.locale=r,this.collator=new Intl.Collator(this.locale?this.locale:[],{sensitivity:this.sensitivity,usage:"search"})};Q.prototype.compare=function(t,e){return this.collator.compare(t,e)},Q.prototype.resolvedLocale=function(){return new Intl.Collator(this.locale?this.locale:[]).resolvedOptions().locale};var tt=function(t,e,r,n,i){this.text=t,this.image=e,this.scale=r,this.fontStack=n,this.textColor=i},et=function(t){this.sections=t};et.fromString=function(t){return new et([new tt(t,null,null,null,null)])},et.prototype.isEmpty=function(){return 0===this.sections.length||!this.sections.some((function(t){return 0!==t.text.length||t.image&&0!==t.image.name.length}))},et.factory=function(t){return t instanceof et?t:et.fromString(t)},et.prototype.toString=function(){return 0===this.sections.length?"":this.sections.map((function(t){return t.text})).join("")},et.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];if(n.image)t.push(["image",n.image.name]);else{t.push(n.text);var i={};n.fontStack&&(i["text-font"]=["literal",n.fontStack.split(",")]),n.scale&&(i["font-scale"]=n.scale),n.textColor&&(i["text-color"]=["rgba"].concat(n.textColor.toArray())),t.push(i)}}return t};var rt=function(t){this.name=t.name,this.available=t.available};function nt(t,e,r,n){return"number"==typeof t&&t>=0&&t<=255&&"number"==typeof e&&e>=0&&e<=255&&"number"==typeof r&&r>=0&&r<=255?void 0===n||"number"==typeof n&&n>=0&&n<=1?null:"Invalid rgba value ["+[t,e,r,n].join(", ")+"]: 'a' must be between 0 and 1.":"Invalid rgba value ["+("number"==typeof n?[t,e,r,n]:[t,e,r]).join(", ")+"]: 'r', 'g', and 'b' must be between 0 and 255."}function it(t){if(null===t)return!0;if("string"==typeof t)return!0;if("boolean"==typeof t)return!0;if("number"==typeof t)return!0;if(t instanceof $)return!0;if(t instanceof Q)return!0;if(t instanceof et)return!0;if(t instanceof rt)return!0;if(Array.isArray(t)){for(var e=0,r=t;e<r.length;e+=1){if(!it(r[e]))return!1}return!0}if("object"==typeof t){for(var n in t)if(!it(t[n]))return!1;return!0}return!1}function ot(t){if(null===t)return k;if("string"==typeof t)return j;if("boolean"==typeof t)return G;if("number"==typeof t)return N;if(t instanceof $)return D;if(t instanceof Q)return B;if(t instanceof et)return Y;if(t instanceof rt)return V;if(Array.isArray(t)){for(var e,r=t.length,n=0,i=t;n<i.length;n+=1){var o=ot(i[n]);if(e){if(e===o)continue;e=U;break}e=o}return W(e||U,r)}return z}function at(t){var e=typeof t;return null===t?"":"string"===e||"number"===e||"boolean"===e?String(t):t instanceof $||t instanceof et||t instanceof rt?t.toString():JSON.stringify(t)}rt.prototype.toString=function(){return this.name},rt.fromString=function(t){return t?new rt({name:t,available:!1}):null},rt.prototype.serialize=function(){return["image",this.name]};var st=function(t,e){this.type=t,this.value=e};st.parse=function(t,e){if(2!==t.length)return e.error("'literal' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(!it(t[1]))return e.error("invalid value");var r=t[1],n=ot(r),i=e.expectedType;return"array"!==n.kind||0!==n.N||!i||"array"!==i.kind||"number"==typeof i.N&&0!==i.N||(n=i),new st(n,r)},st.prototype.evaluate=function(){return this.value},st.prototype.eachChild=function(){},st.prototype.outputDefined=function(){return!0},st.prototype.serialize=function(){return"array"===this.type.kind||"object"===this.type.kind?["literal",this.value]:this.value instanceof $?["rgba"].concat(this.value.toArray()):this.value instanceof et?this.value.serialize():this.value};var ut=function(t){this.name="ExpressionEvaluationError",this.message=t};ut.prototype.toJSON=function(){return this.message};var lt={string:j,number:N,boolean:G,object:z},ht=function(t,e){this.type=t,this.args=e};ht.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r,n=1,i=t[0];if("array"===i){var o,a;if(t.length>2){var s=t[1];if("string"!=typeof s||!(s in lt)||"object"===s)return e.error('The item type argument of "array" must be one of string, number, boolean',1);o=lt[s],n++}else o=U;if(t.length>3){if(null!==t[2]&&("number"!=typeof t[2]||t[2]<0||t[2]!==Math.floor(t[2])))return e.error('The length argument to "array" must be a positive integer literal',2);a=t[2],n++}r=W(o,a)}else r=lt[i];for(var u=[];n<t.length;n++){var l=e.parse(t[n],n,U);if(!l)return null;u.push(l)}return new ht(r,u)},ht.prototype.evaluate=function(t){for(var e=0;e<this.args.length;e++){var r=this.args[e].evaluate(t);if(!Z(this.type,ot(r)))return r;if(e===this.args.length-1)throw new ut("Expected value to be of type "+q(this.type)+", but found "+q(ot(r))+" instead.")}return null},ht.prototype.eachChild=function(t){this.args.forEach(t)},ht.prototype.outputDefined=function(){return this.args.every((function(t){return t.outputDefined()}))},ht.prototype.serialize=function(){var t=this.type,e=[t.kind];if("array"===t.kind){var r=t.itemType;if("string"===r.kind||"number"===r.kind||"boolean"===r.kind){e.push(r.kind);var n=t.N;("number"==typeof n||this.args.length>1)&&e.push(n)}}return e.concat(this.args.map((function(t){return t.serialize()})))};var ct=function(t){this.type=Y,this.sections=t};ct.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r=t[1];if(!Array.isArray(r)&&"object"==typeof r)return e.error("First argument must be an image or text section.");for(var n=[],i=!1,o=1;o<=t.length-1;++o){var a=t[o];if(i&&"object"==typeof a&&!Array.isArray(a)){i=!1;var s=null;if(a["font-scale"]&&!(s=e.parse(a["font-scale"],1,N)))return null;var u=null;if(a["text-font"]&&!(u=e.parse(a["text-font"],1,W(j))))return null;var l=null;if(a["text-color"]&&!(l=e.parse(a["text-color"],1,D)))return null;var h=n[n.length-1];h.scale=s,h.font=u,h.textColor=l}else{var c=e.parse(t[o],1,U);if(!c)return null;var p=c.type.kind;if("string"!==p&&"value"!==p&&"null"!==p&&"resolvedImage"!==p)return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");i=!0,n.push({content:c,scale:null,font:null,textColor:null})}}return new ct(n)},ct.prototype.evaluate=function(t){return new et(this.sections.map((function(e){var r=e.content.evaluate(t);return ot(r)===V?new tt("",r,null,null,null):new tt(at(r),null,e.scale?e.scale.evaluate(t):null,e.font?e.font.evaluate(t).join(","):null,e.textColor?e.textColor.evaluate(t):null)})))},ct.prototype.eachChild=function(t){for(var e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t(n.content),n.scale&&t(n.scale),n.font&&t(n.font),n.textColor&&t(n.textColor)}},ct.prototype.outputDefined=function(){return!1},ct.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t.push(n.content.serialize());var i={};n.scale&&(i["font-scale"]=n.scale.serialize()),n.font&&(i["text-font"]=n.font.serialize()),n.textColor&&(i["text-color"]=n.textColor.serialize()),t.push(i)}return t};var pt=function(t){this.type=V,this.input=t};pt.parse=function(t,e){if(2!==t.length)return e.error("Expected two arguments.");var r=e.parse(t[1],1,j);return r?new pt(r):e.error("No image name provided.")},pt.prototype.evaluate=function(t){var e=this.input.evaluate(t),r=rt.fromString(e);return r&&t.availableImages&&(r.available=t.availableImages.indexOf(e)>-1),r},pt.prototype.eachChild=function(t){t(this.input)},pt.prototype.outputDefined=function(){return!1},pt.prototype.serialize=function(){return["image",this.input.serialize()]};var ft={"to-boolean":G,"to-color":D,"to-number":N,"to-string":j},dt=function(t,e){this.type=t,this.args=e};dt.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r=t[0];if(("to-boolean"===r||"to-string"===r)&&2!==t.length)return e.error("Expected one argument.");for(var n=ft[r],i=[],o=1;o<t.length;o++){var a=e.parse(t[o],o,U);if(!a)return null;i.push(a)}return new dt(n,i)},dt.prototype.evaluate=function(t){if("boolean"===this.type.kind)return Boolean(this.args[0].evaluate(t));if("color"===this.type.kind){for(var e,r,n=0,i=this.args;n<i.length;n+=1){if(r=null,(e=i[n].evaluate(t))instanceof $)return e;if("string"==typeof e){var o=t.parseColor(e);if(o)return o}else if(Array.isArray(e)&&!(r=e.length<3||e.length>4?"Invalid rbga value "+JSON.stringify(e)+": expected an array containing either three or four numeric values.":nt(e[0],e[1],e[2],e[3])))return new $(e[0]/255,e[1]/255,e[2]/255,e[3])}throw new ut(r||"Could not parse color from value '"+("string"==typeof e?e:String(JSON.stringify(e)))+"'")}if("number"===this.type.kind){for(var a=null,s=0,u=this.args;s<u.length;s+=1){if(null===(a=u[s].evaluate(t)))return 0;var l=Number(a);if(!isNaN(l))return l}throw new ut("Could not convert "+JSON.stringify(a)+" to number.")}return"formatted"===this.type.kind?et.fromString(at(this.args[0].evaluate(t))):"resolvedImage"===this.type.kind?rt.fromString(at(this.args[0].evaluate(t))):at(this.args[0].evaluate(t))},dt.prototype.eachChild=function(t){this.args.forEach(t)},dt.prototype.outputDefined=function(){return this.args.every((function(t){return t.outputDefined()}))},dt.prototype.serialize=function(){if("formatted"===this.type.kind)return new ct([{content:this.args[0],scale:null,font:null,textColor:null}]).serialize();if("resolvedImage"===this.type.kind)return new pt(this.args[0]).serialize();var t=["to-"+this.type.kind];return this.eachChild((function(e){t.push(e.serialize())})),t};var gt=["Unknown","Point","LineString","Polygon"],yt=function(){this.globals=null,this.feature=null,this.featureState=null,this.formattedSection=null,this._parseColorCache={},this.availableImages=null,this.canonical=null};yt.prototype.id=function(){return this.feature&&"id"in this.feature?this.feature.id:null},yt.prototype.geometryType=function(){return this.feature?"number"==typeof this.feature.type?gt[this.feature.type]:this.feature.type:null},yt.prototype.geometry=function(){return this.feature&&"geometry"in this.feature?this.feature.geometry:null},yt.prototype.canonicalID=function(){return this.canonical},yt.prototype.properties=function(){return this.feature&&this.feature.properties||{}},yt.prototype.parseColor=function(t){var e=this._parseColorCache[t];return e||(e=this._parseColorCache[t]=$.parse(t)),e};var mt=function(t,e,r,n){this.name=t,this.type=e,this._evaluate=r,this.args=n};mt.prototype.evaluate=function(t){return this._evaluate(t,this.args)},mt.prototype.eachChild=function(t){this.args.forEach(t)},mt.prototype.outputDefined=function(){return!1},mt.prototype.serialize=function(){return[this.name].concat(this.args.map((function(t){return t.serialize()})))},mt.parse=function(t,e){var r,n=t[0],i=mt.definitions[n];if(!i)return e.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0);for(var o=Array.isArray(i)?i[0]:i.type,a=Array.isArray(i)?[[i[1],i[2]]]:i.overloads,s=a.filter((function(e){var r=e[0];return!Array.isArray(r)||r.length===t.length-1})),u=null,l=0,h=s;l<h.length;l+=1){var c=h[l],p=c[0],f=c[1];u=new Dt(e.registry,e.path,null,e.scope);for(var d=[],g=!1,y=1;y<t.length;y++){var m=t[y],v=Array.isArray(p)?p[y-1]:p.type,_=u.parse(m,1+d.length,v);if(!_){g=!0;break}d.push(_)}if(!g)if(Array.isArray(p)&&p.length!==d.length)u.error("Expected "+p.length+" arguments, but found "+d.length+" instead.");else{for(var b=0;b<d.length;b++){var x=Array.isArray(p)?p[b]:p.type,w=d[b];u.concat(b+1).checkSubtype(x,w.type)}if(0===u.errors.length)return new mt(n,o,f,d)}}if(1===s.length)(r=e.errors).push.apply(r,u.errors);else{for(var S=(s.length?s:a).map((function(t){var e,r=t[0];return e=r,Array.isArray(e)?"("+e.map(q).join(", ")+")":"("+q(e.type)+"...)"})).join(" | "),T=[],E=1;E<t.length;E++){var C=e.parse(t[E],1+T.length);if(!C)return null;T.push(q(C.type))}e.error("Expected arguments of type "+S+", but found ("+T.join(", ")+") instead.")}return null},mt.register=function(t,e){for(var r in mt.definitions=e,e)t[r]=mt};var vt=function(t,e,r){this.type=B,this.locale=r,this.caseSensitive=t,this.diacriticSensitive=e};vt.parse=function(t,e){if(2!==t.length)return e.error("Expected one argument.");var r=t[1];if("object"!=typeof r||Array.isArray(r))return e.error("Collator options argument must be an object.");var n=e.parse(void 0!==r["case-sensitive"]&&r["case-sensitive"],1,G);if(!n)return null;var i=e.parse(void 0!==r["diacritic-sensitive"]&&r["diacritic-sensitive"],1,G);if(!i)return null;var o=null;return r.locale&&!(o=e.parse(r.locale,1,j))?null:new vt(n,i,o)},vt.prototype.evaluate=function(t){return new Q(this.caseSensitive.evaluate(t),this.diacriticSensitive.evaluate(t),this.locale?this.locale.evaluate(t):null)},vt.prototype.eachChild=function(t){t(this.caseSensitive),t(this.diacriticSensitive),this.locale&&t(this.locale)},vt.prototype.outputDefined=function(){return!1},vt.prototype.serialize=function(){var t={};return t["case-sensitive"]=this.caseSensitive.serialize(),t["diacritic-sensitive"]=this.diacriticSensitive.serialize(),this.locale&&(t.locale=this.locale.serialize()),["collator",t]};function _t(t,e){t[0]=Math.min(t[0],e[0]),t[1]=Math.min(t[1],e[1]),t[2]=Math.max(t[2],e[0]),t[3]=Math.max(t[3],e[1])}function bt(t,e){return!(t[0]<=e[0])&&(!(t[2]>=e[2])&&(!(t[1]<=e[1])&&!(t[3]>=e[3])))}function xt(t,e){var r,n=(180+t[0])/360,i=(r=t[1],(180-180/Math.PI*Math.log(Math.tan(Math.PI/4+r*Math.PI/360)))/360),o=Math.pow(2,e.z);return[Math.round(n*o*8192),Math.round(i*o*8192)]}function wt(t,e,r){return e[1]>t[1]!=r[1]>t[1]&&t[0]<(r[0]-e[0])*(t[1]-e[1])/(r[1]-e[1])+e[0]}function St(t,e){for(var r,n,i,o,a,s,u,l=!1,h=0,c=e.length;h<c;h++)for(var p=e[h],f=0,d=p.length;f<d-1;f++){if(r=t,n=p[f],i=p[f+1],o=void 0,a=void 0,s=void 0,u=void 0,o=r[0]-n[0],a=r[1]-n[1],s=r[0]-i[0],u=r[1]-i[1],o*u-s*a==0&&o*s<=0&&a*u<=0)return!1;wt(t,p[f],p[f+1])&&(l=!l)}return l}function Tt(t,e){for(var r=0;r<e.length;r++)if(St(t,e[r]))return!0;return!1}function Et(t,e,r,n){var i=t[0]-r[0],o=t[1]-r[1],a=e[0]-r[0],s=e[1]-r[1],u=n[0]-r[0],l=n[1]-r[1],h=i*l-u*o,c=a*l-u*s;return h>0&&c<0||h<0&&c>0}function Ct(t,e,r){for(var n=0,i=r;n<i.length;n+=1)for(var o=i[n],a=0;a<o.length-1;++a)if(s=t,u=e,l=o[a],h=o[a+1],c=void 0,p=void 0,f=void 0,d=void 0,f=[u[0]-s[0],u[1]-s[1]],d=[h[0]-l[0],h[1]-l[1]],0!=(c=d)[0]*(p=f)[1]-c[1]*p[0]&&Et(s,u,l,h)&&Et(l,h,s,u))return!0;var s,u,l,h,c,p,f,d;return!1}function Pt(t,e){for(var r=0;r<t.length;++r)if(!St(t[r],e))return!1;for(var n=0;n<t.length-1;++n)if(Ct(t[n],t[n+1],e))return!1;return!0}function Rt(t,e){for(var r=0;r<e.length;r++)if(Pt(t,e[r]))return!0;return!1}function Ot(t,e,r){for(var n=[],i=0;i<t.length;i++){for(var o=[],a=0;a<t[i].length;a++){var s=xt(t[i][a],r);_t(e,s),o.push(s)}n.push(o)}return n}function It(t,e,r){for(var n=[],i=0;i<t.length;i++){var o=Ot(t[i],e,r);n.push(o)}return n}function Lt(t,e,r,n){if(t[0]<r[0]||t[0]>r[2]){var i=.5*n,o=t[0]-r[0]>i?-n:r[0]-t[0]>i?n:0;0===o&&(o=t[0]-r[2]>i?-n:r[2]-t[0]>i?n:0),t[0]+=o}_t(e,t)}function Mt(t,e,r,n){for(var i=8192*Math.pow(2,n.z),o=[8192*n.x,8192*n.y],a=[],s=0,u=t;s<u.length;s+=1)for(var l=0,h=u[s];l<h.length;l+=1){var c=h[l],p=[c.x+o[0],c.y+o[1]];Lt(p,e,r,i),a.push(p)}return a}function Ft(t,e,r,n){for(var i,o=8192*Math.pow(2,n.z),a=[8192*n.x,8192*n.y],s=[],u=0,l=t;u<l.length;u+=1){for(var h=[],c=0,p=l[u];c<p.length;c+=1){var f=p[c],d=[f.x+a[0],f.y+a[1]];_t(e,d),h.push(d)}s.push(h)}if(e[2]-e[0]<=o/2){(i=e)[0]=i[1]=1/0,i[2]=i[3]=-1/0;for(var g=0,y=s;g<y.length;g+=1)for(var m=0,v=y[g];m<v.length;m+=1){Lt(v[m],e,r,o)}}return s}var At=function(t,e){this.type=G,this.geojson=t,this.geometries=e};function kt(t){if(t instanceof mt){if("get"===t.name&&1===t.args.length)return!1;if("feature-state"===t.name)return!1;if("has"===t.name&&1===t.args.length)return!1;if("properties"===t.name||"geometry-type"===t.name||"id"===t.name)return!1;if(/^filter-/.test(t.name))return!1}if(t instanceof At)return!1;var e=!0;return t.eachChild((function(t){e&&!kt(t)&&(e=!1)})),e}function Nt(t){if(t instanceof mt&&"feature-state"===t.name)return!1;var e=!0;return t.eachChild((function(t){e&&!Nt(t)&&(e=!1)})),e}function jt(t,e){if(t instanceof mt&&e.indexOf(t.name)>=0)return!1;var r=!0;return t.eachChild((function(t){r&&!jt(t,e)&&(r=!1)})),r}At.parse=function(t,e){if(2!==t.length)return e.error("'within' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(it(t[1])){var r=t[1];if("FeatureCollection"===r.type)for(var n=0;n<r.features.length;++n){var i=r.features[n].geometry.type;if("Polygon"===i||"MultiPolygon"===i)return new At(r,r.features[n].geometry)}else if("Feature"===r.type){var o=r.geometry.type;if("Polygon"===o||"MultiPolygon"===o)return new At(r,r.geometry)}else if("Polygon"===r.type||"MultiPolygon"===r.type)return new At(r,r)}return e.error("'within' expression requires valid geojson object that contains polygon geometry type.")},At.prototype.evaluate=function(t){if(null!=t.geometry()&&null!=t.canonicalID()){if("Point"===t.geometryType())return function(t,e){var r=[1/0,1/0,-1/0,-1/0],n=[1/0,1/0,-1/0,-1/0],i=t.canonicalID();if("Polygon"===e.type){var o=Ot(e.coordinates,n,i),a=Mt(t.geometry(),r,n,i);if(!bt(r,n))return!1;for(var s=0,u=a;s<u.length;s+=1){if(!St(u[s],o))return!1}}if("MultiPolygon"===e.type){var l=It(e.coordinates,n,i),h=Mt(t.geometry(),r,n,i);if(!bt(r,n))return!1;for(var c=0,p=h;c<p.length;c+=1){if(!Tt(p[c],l))return!1}}return!0}(t,this.geometries);if("LineString"===t.geometryType())return function(t,e){var r=[1/0,1/0,-1/0,-1/0],n=[1/0,1/0,-1/0,-1/0],i=t.canonicalID();if("Polygon"===e.type){var o=Ot(e.coordinates,n,i),a=Ft(t.geometry(),r,n,i);if(!bt(r,n))return!1;for(var s=0,u=a;s<u.length;s+=1){if(!Pt(u[s],o))return!1}}if("MultiPolygon"===e.type){var l=It(e.coordinates,n,i),h=Ft(t.geometry(),r,n,i);if(!bt(r,n))return!1;for(var c=0,p=h;c<p.length;c+=1){if(!Rt(p[c],l))return!1}}return!0}(t,this.geometries)}return!1},At.prototype.eachChild=function(){},At.prototype.outputDefined=function(){return!0},At.prototype.serialize=function(){return["within",this.geojson]};var Gt=function(t,e){this.type=e.type,this.name=t,this.boundExpression=e};Gt.parse=function(t,e){if(2!==t.length||"string"!=typeof t[1])return e.error("'var' expression requires exactly one string literal argument.");var r=t[1];return e.scope.has(r)?new Gt(r,e.scope.get(r)):e.error('Unknown variable "'+r+'". Make sure "'+r+'" has been bound in an enclosing "let" expression before using it.',1)},Gt.prototype.evaluate=function(t){return this.boundExpression.evaluate(t)},Gt.prototype.eachChild=function(){},Gt.prototype.outputDefined=function(){return!1},Gt.prototype.serialize=function(){return["var",this.name]};var Dt=function(t,e,r,n,i){void 0===e&&(e=[]),void 0===n&&(n=new A),void 0===i&&(i=[]),this.registry=t,this.path=e,this.key=e.map((function(t){return"["+t+"]"})).join(""),this.scope=n,this.errors=i,this.expectedType=r};function zt(t,e){for(var r,n,i=t.length-1,o=0,a=i,s=0;o<=a;)if(r=t[s=Math.floor((o+a)/2)],n=t[s+1],r<=e){if(s===i||e<n)return s;o=s+1}else{if(!(r>e))throw new ut("Input is not a number.");a=s-1}return 0}Dt.prototype.parse=function(t,e,r,n,i){return void 0===i&&(i={}),e?this.concat(e,r,n)._parse(t,i):this._parse(t,i)},Dt.prototype._parse=function(t,e){function r(t,e,r){return"assert"===r?new ht(e,[t]):"coerce"===r?new dt(e,[t]):t}if(null!==t&&"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t||(t=["literal",t]),Array.isArray(t)){if(0===t.length)return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');var n=t[0];if("string"!=typeof n)return this.error("Expression name must be a string, but found "+typeof n+' instead. If you wanted a literal array, use ["literal", [...]].',0),null;var i=this.registry[n];if(i){var o=i.parse(t,this);if(!o)return null;if(this.expectedType){var a=this.expectedType,s=o.type;if("string"!==a.kind&&"number"!==a.kind&&"boolean"!==a.kind&&"object"!==a.kind&&"array"!==a.kind||"value"!==s.kind)if("color"!==a.kind&&"formatted"!==a.kind&&"resolvedImage"!==a.kind||"value"!==s.kind&&"string"!==s.kind){if(this.checkSubtype(a,s))return null}else o=r(o,a,e.typeAnnotation||"coerce");else o=r(o,a,e.typeAnnotation||"assert")}if(!(o instanceof st)&&"resolvedImage"!==o.type.kind&&function t(e){if(e instanceof Gt)return t(e.boundExpression);if(e instanceof mt&&"error"===e.name)return!1;if(e instanceof vt)return!1;if(e instanceof At)return!1;var r=e instanceof dt||e instanceof ht,n=!0;if(e.eachChild((function(e){n=r?n&&t(e):n&&e instanceof st})),!n)return!1;return kt(e)&&jt(e,["zoom","heatmap-density","line-progress","accumulated","is-supported-script"])}(o)){var u=new yt;try{o=new st(o.type,o.evaluate(u))}catch(t){return this.error(t.message),null}}return o}return this.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0)}return void 0===t?this.error("'undefined' value invalid. Use null instead."):"object"==typeof t?this.error('Bare objects invalid. Use ["literal", {...}] instead.'):this.error("Expected an array, but found "+typeof t+" instead.")},Dt.prototype.concat=function(t,e,r){var n="number"==typeof t?this.path.concat(t):this.path,i=r?this.scope.concat(r):this.scope;return new Dt(this.registry,n,e||null,i,this.errors)},Dt.prototype.error=function(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];var n=""+this.key+e.map((function(t){return"["+t+"]"})).join("");this.errors.push(new F(n,t))},Dt.prototype.checkSubtype=function(t,e){var r=Z(t,e);return r&&this.error(r),r};var Ut=function(t,e,r){this.type=t,this.input=e,this.labels=[],this.outputs=[];for(var n=0,i=r;n<i.length;n+=1){var o=i[n],a=o[0],s=o[1];this.labels.push(a),this.outputs.push(s)}};Ut.parse=function(t,e){if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");var r=e.parse(t[1],1,N);if(!r)return null;var n=[],i=null;e.expectedType&&"value"!==e.expectedType.kind&&(i=e.expectedType);for(var o=1;o<t.length;o+=2){var a=1===o?-1/0:t[o],s=t[o+1],u=o,l=o+1;if("number"!=typeof a)return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',u);if(n.length&&n[n.length-1][0]>=a)return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',u);var h=e.parse(s,l,i);if(!h)return null;i=i||h.type,n.push([a,h])}return new Ut(i,r,n)},Ut.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;return n>=e[i-1]?r[i-1].evaluate(t):r[zt(e,n)].evaluate(t)},Ut.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e])}},Ut.prototype.outputDefined=function(){return this.outputs.every((function(t){return t.outputDefined()}))},Ut.prototype.serialize=function(){for(var t=["step",this.input.serialize()],e=0;e<this.labels.length;e++)e>0&&t.push(this.labels[e]),t.push(this.outputs[e].serialize());return t};var Bt=Yt;function Yt(t,e,r,n){this.cx=3*t,this.bx=3*(r-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(n-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=n,this.p2x=r,this.p2y=n}function Vt(t,e,r){return t*(1-r)+e*r}Yt.prototype.sampleCurveX=function(t){return((this.ax*t+this.bx)*t+this.cx)*t},Yt.prototype.sampleCurveY=function(t){return((this.ay*t+this.by)*t+this.cy)*t},Yt.prototype.sampleCurveDerivativeX=function(t){return(3*this.ax*t+2*this.bx)*t+this.cx},Yt.prototype.solveCurveX=function(t,e){var r,n,i,o,a;for(void 0===e&&(e=1e-6),i=t,a=0;a<8;a++){if(o=this.sampleCurveX(i)-t,Math.abs(o)<e)return i;var s=this.sampleCurveDerivativeX(i);if(Math.abs(s)<1e-6)break;i-=o/s}if((i=t)<(r=0))return r;if(i>(n=1))return n;for(;r<n;){if(o=this.sampleCurveX(i),Math.abs(o-t)<e)return i;t>o?r=i:n=i,i=.5*(n-r)+r}return i},Yt.prototype.solve=function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))};var Wt=Object.freeze({__proto__:null,number:Vt,color:function(t,e,r){return new $(Vt(t.r,e.r,r),Vt(t.g,e.g,r),Vt(t.b,e.b,r),Vt(t.a,e.a,r))},array:function(t,e,r){return t.map((function(t,n){return Vt(t,e[n],r)}))}}),qt=6/29,Xt=3*qt*qt,Zt=Math.PI/180,Kt=180/Math.PI;function Ht(t){return t>.008856451679035631?Math.pow(t,1/3):t/Xt+4/29}function Jt(t){return t>qt?t*t*t:Xt*(t-4/29)}function $t(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function Qt(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function te(t){var e=Qt(t.r),r=Qt(t.g),n=Qt(t.b),i=Ht((.4124564*e+.3575761*r+.1804375*n)/.95047),o=Ht((.2126729*e+.7151522*r+.072175*n)/1);return{l:116*o-16,a:500*(i-o),b:200*(o-Ht((.0193339*e+.119192*r+.9503041*n)/1.08883)),alpha:t.a}}function ee(t){var e=(t.l+16)/116,r=isNaN(t.a)?e:e+t.a/500,n=isNaN(t.b)?e:e-t.b/200;return e=1*Jt(e),r=.95047*Jt(r),n=1.08883*Jt(n),new $($t(3.2404542*r-1.5371385*e-.4985314*n),$t(-.969266*r+1.8760108*e+.041556*n),$t(.0556434*r-.2040259*e+1.0572252*n),t.alpha)}function re(t,e,r){var n=e-t;return t+r*(n>180||n<-180?n-360*Math.round(n/360):n)}var ne={forward:te,reverse:ee,interpolate:function(t,e,r){return{l:Vt(t.l,e.l,r),a:Vt(t.a,e.a,r),b:Vt(t.b,e.b,r),alpha:Vt(t.alpha,e.alpha,r)}}},ie={forward:function(t){var e=te(t),r=e.l,n=e.a,i=e.b,o=Math.atan2(i,n)*Kt;return{h:o<0?o+360:o,c:Math.sqrt(n*n+i*i),l:r,alpha:t.a}},reverse:function(t){var e=t.h*Zt,r=t.c;return ee({l:t.l,a:Math.cos(e)*r,b:Math.sin(e)*r,alpha:t.alpha})},interpolate:function(t,e,r){return{h:re(t.h,e.h,r),c:Vt(t.c,e.c,r),l:Vt(t.l,e.l,r),alpha:Vt(t.alpha,e.alpha,r)}}},oe=Object.freeze({__proto__:null,lab:ne,hcl:ie}),ae=function(t,e,r,n,i){this.type=t,this.operator=e,this.interpolation=r,this.input=n,this.labels=[],this.outputs=[];for(var o=0,a=i;o<a.length;o+=1){var s=a[o],u=s[0],l=s[1];this.labels.push(u),this.outputs.push(l)}};function se(t,e,r,n){var i=n-r,o=t-r;return 0===i?0:1===e?o/i:(Math.pow(e,o)-1)/(Math.pow(e,i)-1)}ae.interpolationFactor=function(t,e,r,n){var i=0;if("exponential"===t.name)i=se(e,t.base,r,n);else if("linear"===t.name)i=se(e,1,r,n);else if("cubic-bezier"===t.name){var o=t.controlPoints;i=new Bt(o[0],o[1],o[2],o[3]).solve(se(e,1,r,n))}return i},ae.parse=function(t,e){var r=t[0],n=t[1],i=t[2],o=t.slice(3);if(!Array.isArray(n)||0===n.length)return e.error("Expected an interpolation type expression.",1);if("linear"===n[0])n={name:"linear"};else if("exponential"===n[0]){var a=n[1];if("number"!=typeof a)return e.error("Exponential interpolation requires a numeric base.",1,1);n={name:"exponential",base:a}}else{if("cubic-bezier"!==n[0])return e.error("Unknown interpolation type "+String(n[0]),1,0);var s=n.slice(1);if(4!==s.length||s.some((function(t){return"number"!=typeof t||t<0||t>1})))return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);n={name:"cubic-bezier",controlPoints:s}}if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(!(i=e.parse(i,2,N)))return null;var u=[],l=null;"interpolate-hcl"===r||"interpolate-lab"===r?l=D:e.expectedType&&"value"!==e.expectedType.kind&&(l=e.expectedType);for(var h=0;h<o.length;h+=2){var c=o[h],p=o[h+1],f=h+3,d=h+4;if("number"!=typeof c)return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',f);if(u.length&&u[u.length-1][0]>=c)return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',f);var g=e.parse(p,d,l);if(!g)return null;l=l||g.type,u.push([c,g])}return"number"===l.kind||"color"===l.kind||"array"===l.kind&&"number"===l.itemType.kind&&"number"==typeof l.N?new ae(l,r,n,i,u):e.error("Type "+q(l)+" is not interpolatable.")},ae.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;if(n>=e[i-1])return r[i-1].evaluate(t);var o=zt(e,n),a=e[o],s=e[o+1],u=ae.interpolationFactor(this.interpolation,n,a,s),l=r[o].evaluate(t),h=r[o+1].evaluate(t);return"interpolate"===this.operator?Wt[this.type.kind.toLowerCase()](l,h,u):"interpolate-hcl"===this.operator?ie.reverse(ie.interpolate(ie.forward(l),ie.forward(h),u)):ne.reverse(ne.interpolate(ne.forward(l),ne.forward(h),u))},ae.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e])}},ae.prototype.outputDefined=function(){return this.outputs.every((function(t){return t.outputDefined()}))},ae.prototype.serialize=function(){var t;t="linear"===this.interpolation.name?["linear"]:"exponential"===this.interpolation.name?1===this.interpolation.base?["linear"]:["exponential",this.interpolation.base]:["cubic-bezier"].concat(this.interpolation.controlPoints);for(var e=[this.operator,t,this.input.serialize()],r=0;r<this.labels.length;r++)e.push(this.labels[r],this.outputs[r].serialize());return e};var ue=function(t,e){this.type=t,this.args=e};ue.parse=function(t,e){if(t.length<2)return e.error("Expectected at least one argument.");var r=null,n=e.expectedType;n&&"value"!==n.kind&&(r=n);for(var i=[],o=0,a=t.slice(1);o<a.length;o+=1){var s=a[o],u=e.parse(s,1+i.length,r,void 0,{typeAnnotation:"omit"});if(!u)return null;r=r||u.type,i.push(u)}var l=n&&i.some((function(t){return Z(n,t.type)}));return new ue(l?U:r,i)},ue.prototype.evaluate=function(t){for(var e,r=null,n=0,i=0,o=this.args;i<o.length;i+=1){if(n++,(r=o[i].evaluate(t))&&r instanceof rt&&!r.available&&(e||(e=r.name),r=null,n===this.args.length&&(r=e)),null!==r)break}return r},ue.prototype.eachChild=function(t){this.args.forEach(t)},ue.prototype.outputDefined=function(){return this.args.every((function(t){return t.outputDefined()}))},ue.prototype.serialize=function(){var t=["coalesce"];return this.eachChild((function(e){t.push(e.serialize())})),t};var le=function(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e};le.prototype.evaluate=function(t){return this.result.evaluate(t)},le.prototype.eachChild=function(t){for(var e=0,r=this.bindings;e<r.length;e+=1){t(r[e][1])}t(this.result)},le.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found "+(t.length-1)+" instead.");for(var r=[],n=1;n<t.length-1;n+=2){var i=t[n];if("string"!=typeof i)return e.error("Expected string, but found "+typeof i+" instead.",n);if(/[^a-zA-Z0-9_]/.test(i))return e.error("Variable names must contain only alphanumeric characters or '_'.",n);var o=e.parse(t[n+1],n+1);if(!o)return null;r.push([i,o])}var a=e.parse(t[t.length-1],t.length-1,e.expectedType,r);return a?new le(r,a):null},le.prototype.outputDefined=function(){return this.result.outputDefined()},le.prototype.serialize=function(){for(var t=["let"],e=0,r=this.bindings;e<r.length;e+=1){var n=r[e],i=n[0],o=n[1];t.push(i,o.serialize())}return t.push(this.result.serialize()),t};var he=function(t,e,r){this.type=t,this.index=e,this.input=r};he.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,N),n=e.parse(t[2],2,W(e.expectedType||U));if(!r||!n)return null;var i=n.type;return new he(i.itemType,r,n)},he.prototype.evaluate=function(t){var e=this.index.evaluate(t),r=this.input.evaluate(t);if(e<0)throw new ut("Array index out of bounds: "+e+" < 0.");if(e>=r.length)throw new ut("Array index out of bounds: "+e+" > "+(r.length-1)+".");if(e!==Math.floor(e))throw new ut("Array index must be an integer, but found "+e+" instead.");return r[e]},he.prototype.eachChild=function(t){t(this.index),t(this.input)},he.prototype.outputDefined=function(){return!1},he.prototype.serialize=function(){return["at",this.index.serialize(),this.input.serialize()]};var ce=function(t,e){this.type=G,this.needle=t,this.haystack=e};ce.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,U),n=e.parse(t[2],2,U);return r&&n?K(r.type,[G,j,N,k,U])?new ce(r,n):e.error("Expected first argument to be of type boolean, string, number or null, but found "+q(r.type)+" instead"):null},ce.prototype.evaluate=function(t){var e=this.needle.evaluate(t),r=this.haystack.evaluate(t);if(!r)return!1;if(!H(e,["boolean","string","number","null"]))throw new ut("Expected first argument to be of type boolean, string, number or null, but found "+q(ot(e))+" instead.");if(!H(r,["string","array"]))throw new ut("Expected second argument to be of type array or string, but found "+q(ot(r))+" instead.");return r.indexOf(e)>=0},ce.prototype.eachChild=function(t){t(this.needle),t(this.haystack)},ce.prototype.outputDefined=function(){return!0},ce.prototype.serialize=function(){return["in",this.needle.serialize(),this.haystack.serialize()]};var pe=function(t,e,r){this.type=N,this.needle=t,this.haystack=e,this.fromIndex=r};pe.parse=function(t,e){if(t.length<=2||t.length>=5)return e.error("Expected 3 or 4 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,U),n=e.parse(t[2],2,U);if(!r||!n)return null;if(!K(r.type,[G,j,N,k,U]))return e.error("Expected first argument to be of type boolean, string, number or null, but found "+q(r.type)+" instead");if(4===t.length){var i=e.parse(t[3],3,N);return i?new pe(r,n,i):null}return new pe(r,n)},pe.prototype.evaluate=function(t){var e=this.needle.evaluate(t),r=this.haystack.evaluate(t);if(!H(e,["boolean","string","number","null"]))throw new ut("Expected first argument to be of type boolean, string, number or null, but found "+q(ot(e))+" instead.");if(!H(r,["string","array"]))throw new ut("Expected second argument to be of type array or string, but found "+q(ot(r))+" instead.");if(this.fromIndex){var n=this.fromIndex.evaluate(t);return r.indexOf(e,n)}return r.indexOf(e)},pe.prototype.eachChild=function(t){t(this.needle),t(this.haystack),this.fromIndex&&t(this.fromIndex)},pe.prototype.outputDefined=function(){return!1},pe.prototype.serialize=function(){if(null!=this.fromIndex&&void 0!==this.fromIndex){var t=this.fromIndex.serialize();return["index-of",this.needle.serialize(),this.haystack.serialize(),t]}return["index-of",this.needle.serialize(),this.haystack.serialize()]};var fe=function(t,e,r,n,i,o){this.inputType=t,this.type=e,this.input=r,this.cases=n,this.outputs=i,this.otherwise=o};fe.parse=function(t,e){if(t.length<5)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if(t.length%2!=1)return e.error("Expected an even number of arguments.");var r,n;e.expectedType&&"value"!==e.expectedType.kind&&(n=e.expectedType);for(var i={},o=[],a=2;a<t.length-1;a+=2){var s=t[a],u=t[a+1];Array.isArray(s)||(s=[s]);var l=e.concat(a);if(0===s.length)return l.error("Expected at least one branch label.");for(var h=0,c=s;h<c.length;h+=1){var p=c[h];if("number"!=typeof p&&"string"!=typeof p)return l.error("Branch labels must be numbers or strings.");if("number"==typeof p&&Math.abs(p)>Number.MAX_SAFE_INTEGER)return l.error("Branch labels must be integers no larger than "+Number.MAX_SAFE_INTEGER+".");if("number"==typeof p&&Math.floor(p)!==p)return l.error("Numeric branch labels must be integer values.");if(r){if(l.checkSubtype(r,ot(p)))return null}else r=ot(p);if(void 0!==i[String(p)])return l.error("Branch labels must be unique.");i[String(p)]=o.length}var f=e.parse(u,a,n);if(!f)return null;n=n||f.type,o.push(f)}var d=e.parse(t[1],1,U);if(!d)return null;var g=e.parse(t[t.length-1],t.length-1,n);return g?"value"!==d.type.kind&&e.concat(1).checkSubtype(r,d.type)?null:new fe(r,n,d,i,o,g):null},fe.prototype.evaluate=function(t){var e=this.input.evaluate(t);return(ot(e)===this.inputType&&this.outputs[this.cases[e]]||this.otherwise).evaluate(t)},fe.prototype.eachChild=function(t){t(this.input),this.outputs.forEach(t),t(this.otherwise)},fe.prototype.outputDefined=function(){return this.outputs.every((function(t){return t.outputDefined()}))&&this.otherwise.outputDefined()},fe.prototype.serialize=function(){for(var t=this,e=["match",this.input.serialize()],r=[],n={},i=0,o=Object.keys(this.cases).sort();i<o.length;i+=1){var a=o[i];void 0===(c=n[this.cases[a]])?(n[this.cases[a]]=r.length,r.push([this.cases[a],[a]])):r[c][1].push(a)}for(var s=function(e){return"number"===t.inputType.kind?Number(e):e},u=0,l=r;u<l.length;u+=1){var h=l[u],c=h[0],p=h[1];1===p.length?e.push(s(p[0])):e.push(p.map(s)),e.push(this.outputs[outputIndex$1].serialize())}return e.push(this.otherwise.serialize()),e};var de=function(t,e,r){this.type=t,this.branches=e,this.otherwise=r};de.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found only "+(t.length-1)+".");if(t.length%2!=0)return e.error("Expected an odd number of arguments.");var r;e.expectedType&&"value"!==e.expectedType.kind&&(r=e.expectedType);for(var n=[],i=1;i<t.length-1;i+=2){var o=e.parse(t[i],i,G);if(!o)return null;var a=e.parse(t[i+1],i+1,r);if(!a)return null;n.push([o,a]),r=r||a.type}var s=e.parse(t[t.length-1],t.length-1,r);return s?new de(r,n,s):null},de.prototype.evaluate=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],o=n[1];if(i.evaluate(t))return o.evaluate(t)}return this.otherwise.evaluate(t)},de.prototype.eachChild=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],o=n[1];t(i),t(o)}t(this.otherwise)},de.prototype.outputDefined=function(){return this.branches.every((function(t){t[0];return t[1].outputDefined()}))&&this.otherwise.outputDefined()},de.prototype.serialize=function(){var t=["case"];return this.eachChild((function(e){t.push(e.serialize())})),t};var ge=function(t,e,r,n){this.type=t,this.input=e,this.beginIndex=r,this.endIndex=n};function ye(t,e){return"=="===t||"!="===t?"boolean"===e.kind||"string"===e.kind||"number"===e.kind||"null"===e.kind||"value"===e.kind:"string"===e.kind||"number"===e.kind||"value"===e.kind}function me(t,e,r,n){return 0===n.compare(e,r)}function ve(t,e,r){var n="=="!==t&&"!="!==t;return function(){function i(t,e,r){this.type=G,this.lhs=t,this.rhs=e,this.collator=r,this.hasUntypedArgument="value"===t.type.kind||"value"===e.type.kind}return i.parse=function(t,e){if(3!==t.length&&4!==t.length)return e.error("Expected two or three arguments.");var r=t[0],o=e.parse(t[1],1,U);if(!o)return null;if(!ye(r,o.type))return e.concat(1).error('"'+r+"\" comparisons are not supported for type '"+q(o.type)+"'.");var a=e.parse(t[2],2,U);if(!a)return null;if(!ye(r,a.type))return e.concat(2).error('"'+r+"\" comparisons are not supported for type '"+q(a.type)+"'.");if(o.type.kind!==a.type.kind&&"value"!==o.type.kind&&"value"!==a.type.kind)return e.error("Cannot compare types '"+q(o.type)+"' and '"+q(a.type)+"'.");n&&("value"===o.type.kind&&"value"!==a.type.kind?o=new ht(a.type,[o]):"value"!==o.type.kind&&"value"===a.type.kind&&(a=new ht(o.type,[a])));var s=null;if(4===t.length){if("string"!==o.type.kind&&"string"!==a.type.kind&&"value"!==o.type.kind&&"value"!==a.type.kind)return e.error("Cannot use collator to compare non-string types.");if(!(s=e.parse(t[3],3,B)))return null}return new i(o,a,s)},i.prototype.evaluate=function(i){var o=this.lhs.evaluate(i),a=this.rhs.evaluate(i);if(n&&this.hasUntypedArgument){var s=ot(o),u=ot(a);if(s.kind!==u.kind||"string"!==s.kind&&"number"!==s.kind)throw new ut('Expected arguments for "'+t+'" to be (string, string) or (number, number), but found ('+s.kind+", "+u.kind+") instead.")}if(this.collator&&!n&&this.hasUntypedArgument){var l=ot(o),h=ot(a);if("string"!==l.kind||"string"!==h.kind)return e(i,o,a)}return this.collator?r(i,o,a,this.collator.evaluate(i)):e(i,o,a)},i.prototype.eachChild=function(t){t(this.lhs),t(this.rhs),this.collator&&t(this.collator)},i.prototype.outputDefined=function(){return!0},i.prototype.serialize=function(){var e=[t];return this.eachChild((function(t){e.push(t.serialize())})),e},i}()}ge.parse=function(t,e){if(t.length<=2||t.length>=5)return e.error("Expected 3 or 4 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,U),n=e.parse(t[2],2,N);if(!r||!n)return null;if(!K(r.type,[W(U),j,U]))return e.error("Expected first argument to be of type array or string, but found "+q(r.type)+" instead");if(4===t.length){var i=e.parse(t[3],3,N);return i?new ge(r.type,r,n,i):null}return new ge(r.type,r,n)},ge.prototype.evaluate=function(t){var e=this.input.evaluate(t),r=this.beginIndex.evaluate(t);if(!H(e,["string","array"]))throw new ut("Expected first argument to be of type array or string, but found "+q(ot(e))+" instead.");if(this.endIndex){var n=this.endIndex.evaluate(t);return e.slice(r,n)}return e.slice(r)},ge.prototype.eachChild=function(t){t(this.input),t(this.beginIndex),this.endIndex&&t(this.endIndex)},ge.prototype.outputDefined=function(){return!1},ge.prototype.serialize=function(){if(null!=this.endIndex&&void 0!==this.endIndex){var t=this.endIndex.serialize();return["slice",this.input.serialize(),this.beginIndex.serialize(),t]}return["slice",this.input.serialize(),this.beginIndex.serialize()]};var _e=ve("==",(function(t,e,r){return e===r}),me),be=ve("!=",(function(t,e,r){return e!==r}),(function(t,e,r,n){return!me(0,e,r,n)})),xe=ve("<",(function(t,e,r){return e<r}),(function(t,e,r,n){return n.compare(e,r)<0})),we=ve(">",(function(t,e,r){return e>r}),(function(t,e,r,n){return n.compare(e,r)>0})),Se=ve("<=",(function(t,e,r){return e<=r}),(function(t,e,r,n){return n.compare(e,r)<=0})),Te=ve(">=",(function(t,e,r){return e>=r}),(function(t,e,r,n){return n.compare(e,r)>=0})),Ee=function(t,e,r,n,i){this.type=j,this.number=t,this.locale=e,this.currency=r,this.minFractionDigits=n,this.maxFractionDigits=i};Ee.parse=function(t,e){if(3!==t.length)return e.error("Expected two arguments.");var r=e.parse(t[1],1,N);if(!r)return null;var n=t[2];if("object"!=typeof n||Array.isArray(n))return e.error("NumberFormat options argument must be an object.");var i=null;if(n.locale&&!(i=e.parse(n.locale,1,j)))return null;var o=null;if(n.currency&&!(o=e.parse(n.currency,1,j)))return null;var a=null;if(n["min-fraction-digits"]&&!(a=e.parse(n["min-fraction-digits"],1,N)))return null;var s=null;return n["max-fraction-digits"]&&!(s=e.parse(n["max-fraction-digits"],1,N))?null:new Ee(r,i,o,a,s)},Ee.prototype.evaluate=function(t){return new Intl.NumberFormat(this.locale?this.locale.evaluate(t):[],{style:this.currency?"currency":"decimal",currency:this.currency?this.currency.evaluate(t):void 0,minimumFractionDigits:this.minFractionDigits?this.minFractionDigits.evaluate(t):void 0,maximumFractionDigits:this.maxFractionDigits?this.maxFractionDigits.evaluate(t):void 0}).format(this.number.evaluate(t))},Ee.prototype.eachChild=function(t){t(this.number),this.locale&&t(this.locale),this.currency&&t(this.currency),this.minFractionDigits&&t(this.minFractionDigits),this.maxFractionDigits&&t(this.maxFractionDigits)},Ee.prototype.outputDefined=function(){return!1},Ee.prototype.serialize=function(){var t={};return this.locale&&(t.locale=this.locale.serialize()),this.currency&&(t.currency=this.currency.serialize()),this.minFractionDigits&&(t["min-fraction-digits"]=this.minFractionDigits.serialize()),this.maxFractionDigits&&(t["max-fraction-digits"]=this.maxFractionDigits.serialize()),["number-format",this.number.serialize(),t]};var Ce=function(t){this.type=N,this.input=t};Ce.parse=function(t,e){if(2!==t.length)return e.error("Expected 1 argument, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1);return r?"array"!==r.type.kind&&"string"!==r.type.kind&&"value"!==r.type.kind?e.error("Expected argument of type string or array, but found "+q(r.type)+" instead."):new Ce(r):null},Ce.prototype.evaluate=function(t){var e=this.input.evaluate(t);if("string"==typeof e)return e.length;if(Array.isArray(e))return e.length;throw new ut("Expected value to be of type string or array, but found "+q(ot(e))+" instead.")},Ce.prototype.eachChild=function(t){t(this.input)},Ce.prototype.outputDefined=function(){return!1},Ce.prototype.serialize=function(){var t=["length"];return this.eachChild((function(e){t.push(e.serialize())})),t};var Pe={"==":_e,"!=":be,">":we,"<":xe,">=":Te,"<=":Se,array:ht,at:he,boolean:ht,case:de,coalesce:ue,collator:vt,format:ct,image:pt,in:ce,"index-of":pe,interpolate:ae,"interpolate-hcl":ae,"interpolate-lab":ae,length:Ce,let:le,literal:st,match:fe,number:ht,"number-format":Ee,object:ht,slice:ge,step:Ut,string:ht,"to-boolean":dt,"to-color":dt,"to-number":dt,"to-string":dt,var:Gt,within:At};function Re(t,e){var r=e[0],n=e[1],i=e[2],o=e[3];r=r.evaluate(t),n=n.evaluate(t),i=i.evaluate(t);var a=o?o.evaluate(t):1,s=nt(r,n,i,a);if(s)throw new ut(s);return new $(r/255*a,n/255*a,i/255*a,a)}function Oe(t,e){return t in e}function Ie(t,e){var r=e[t];return void 0===r?null:r}function Le(t){return{type:t}}function Me(t){return{result:"success",value:t}}function Fe(t){return{result:"error",value:t}}function Ae(t){return"data-driven"===t["property-type"]||"cross-faded-data-driven"===t["property-type"]}function ke(t){return!!t.expression&&t.expression.parameters.indexOf("zoom")>-1}function Ne(t){return!!t.expression&&t.expression.interpolated}function je(t){return t instanceof Number?"number":t instanceof String?"string":t instanceof Boolean?"boolean":Array.isArray(t)?"array":null===t?"null":typeof t}function Ge(t){return"object"==typeof t&&null!==t&&!Array.isArray(t)}function De(t){return t}function ze(t,e){var r,n,i,o="color"===e.type,a=t.stops&&"object"==typeof t.stops[0][0],s=a||void 0!==t.property,u=a||!s,l=t.type||(Ne(e)?"exponential":"interval");if(o&&((t=M({},t)).stops&&(t.stops=t.stops.map((function(t){return[t[0],$.parse(t[1])]}))),t.default?t.default=$.parse(t.default):t.default=$.parse(e.default)),t.colorSpace&&"rgb"!==t.colorSpace&&!oe[t.colorSpace])throw new Error("Unknown color space: "+t.colorSpace);if("exponential"===l)r=Ve;else if("interval"===l)r=Ye;else if("categorical"===l){r=Be,n=Object.create(null);for(var h=0,c=t.stops;h<c.length;h+=1){var p=c[h];n[p[0]]=p[1]}i=typeof t.stops[0][0]}else{if("identity"!==l)throw new Error('Unknown function type "'+l+'"');r=We}if(a){for(var f={},d=[],g=0;g<t.stops.length;g++){var y=t.stops[g],m=y[0].zoom;void 0===f[m]&&(f[m]={zoom:m,type:t.type,property:t.property,default:t.default,stops:[]},d.push(m)),f[m].stops.push([y[0].value,y[1]])}for(var v=[],_=0,b=d;_<b.length;_+=1){var x=b[_];v.push([f[x].zoom,ze(f[x],e)])}var w={name:"linear"};return{kind:"composite",interpolationType:w,interpolationFactor:ae.interpolationFactor.bind(void 0,w),zoomStops:v.map((function(t){return t[0]})),evaluate:function(r,n){var i=r.zoom;return Ve({stops:v,base:t.base},e,i).evaluate(i,n)}}}if(u){var S="exponential"===l?{name:"exponential",base:void 0!==t.base?t.base:1}:null;return{kind:"camera",interpolationType:S,interpolationFactor:ae.interpolationFactor.bind(void 0,S),zoomStops:t.stops.map((function(t){return t[0]})),evaluate:function(o){var a=o.zoom;return r(t,e,a,n,i)}}}return{kind:"source",evaluate:function(o,a){var s=a&&a.properties?a.properties[t.property]:void 0;return void 0===s?Ue(t.default,e.default):r(t,e,s,n,i)}}}function Ue(t,e,r){return void 0!==t?t:void 0!==e?e:void 0!==r?r:void 0}function Be(t,e,r,n,i){return Ue(typeof r===i?n[r]:void 0,t.default,e.default)}function Ye(t,e,r){if("number"!==je(r))return Ue(t.default,e.default);var n=t.stops.length;if(1===n)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[n-1][0])return t.stops[n-1][1];var i=zt(t.stops.map((function(t){return t[0]})),r);return t.stops[i][1]}function Ve(t,e,r){var n=void 0!==t.base?t.base:1;if("number"!==je(r))return Ue(t.default,e.default);var i=t.stops.length;if(1===i)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[i-1][0])return t.stops[i-1][1];var o=zt(t.stops.map((function(t){return t[0]})),r),a=function(t,e,r,n){var i=n-r,o=t-r;return 0===i?0:1===e?o/i:(Math.pow(e,o)-1)/(Math.pow(e,i)-1)}(r,n,t.stops[o][0],t.stops[o+1][0]),s=t.stops[o][1],u=t.stops[o+1][1],l=Wt[e.type]||De;if(t.colorSpace&&"rgb"!==t.colorSpace){var h=oe[t.colorSpace];l=function(t,e){return h.reverse(h.interpolate(h.forward(t),h.forward(e),a))}}return"function"==typeof s.evaluate?{evaluate:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];var r=s.evaluate.apply(void 0,t),n=u.evaluate.apply(void 0,t);if(void 0!==r&&void 0!==n)return l(r,n,a)}}:l(s,u,a)}function We(t,e,r){return"color"===e.type?r=$.parse(r):"formatted"===e.type?r=et.fromString(r.toString()):"resolvedImage"===e.type?r=rt.fromString(r.toString()):je(r)===e.type||"enum"===e.type&&e.values[r]||(r=void 0),Ue(r,t.default,e.default)}mt.register(Pe,{error:[{kind:"error"},[j],function(t,e){var r=e[0];throw new ut(r.evaluate(t))}],typeof:[j,[U],function(t,e){return q(ot(e[0].evaluate(t)))}],"to-rgba":[W(N,4),[D],function(t,e){return e[0].evaluate(t).toArray()}],rgb:[D,[N,N,N],Re],rgba:[D,[N,N,N,N],Re],has:{type:G,overloads:[[[j],function(t,e){return Oe(e[0].evaluate(t),t.properties())}],[[j,z],function(t,e){var r=e[0],n=e[1];return Oe(r.evaluate(t),n.evaluate(t))}]]},get:{type:U,overloads:[[[j],function(t,e){return Ie(e[0].evaluate(t),t.properties())}],[[j,z],function(t,e){var r=e[0],n=e[1];return Ie(r.evaluate(t),n.evaluate(t))}]]},"feature-state":[U,[j],function(t,e){return Ie(e[0].evaluate(t),t.featureState||{})}],properties:[z,[],function(t){return t.properties()}],"geometry-type":[j,[],function(t){return t.geometryType()}],id:[U,[],function(t){return t.id()}],zoom:[N,[],function(t){return t.globals.zoom}],"heatmap-density":[N,[],function(t){return t.globals.heatmapDensity||0}],"line-progress":[N,[],function(t){return t.globals.lineProgress||0}],accumulated:[U,[],function(t){return void 0===t.globals.accumulated?null:t.globals.accumulated}],"+":[N,Le(N),function(t,e){for(var r=0,n=0,i=e;n<i.length;n+=1){r+=i[n].evaluate(t)}return r}],"*":[N,Le(N),function(t,e){for(var r=1,n=0,i=e;n<i.length;n+=1){r*=i[n].evaluate(t)}return r}],"-":{type:N,overloads:[[[N,N],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)-n.evaluate(t)}],[[N],function(t,e){return-e[0].evaluate(t)}]]},"/":[N,[N,N],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)/n.evaluate(t)}],"%":[N,[N,N],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)%n.evaluate(t)}],ln2:[N,[],function(){return Math.LN2}],pi:[N,[],function(){return Math.PI}],e:[N,[],function(){return Math.E}],"^":[N,[N,N],function(t,e){var r=e[0],n=e[1];return Math.pow(r.evaluate(t),n.evaluate(t))}],sqrt:[N,[N],function(t,e){var r=e[0];return Math.sqrt(r.evaluate(t))}],log10:[N,[N],function(t,e){var r=e[0];return Math.log(r.evaluate(t))/Math.LN10}],ln:[N,[N],function(t,e){var r=e[0];return Math.log(r.evaluate(t))}],log2:[N,[N],function(t,e){var r=e[0];return Math.log(r.evaluate(t))/Math.LN2}],sin:[N,[N],function(t,e){var r=e[0];return Math.sin(r.evaluate(t))}],cos:[N,[N],function(t,e){var r=e[0];return Math.cos(r.evaluate(t))}],tan:[N,[N],function(t,e){var r=e[0];return Math.tan(r.evaluate(t))}],asin:[N,[N],function(t,e){var r=e[0];return Math.asin(r.evaluate(t))}],acos:[N,[N],function(t,e){var r=e[0];return Math.acos(r.evaluate(t))}],atan:[N,[N],function(t,e){var r=e[0];return Math.atan(r.evaluate(t))}],min:[N,Le(N),function(t,e){return Math.min.apply(Math,e.map((function(e){return e.evaluate(t)})))}],max:[N,Le(N),function(t,e){return Math.max.apply(Math,e.map((function(e){return e.evaluate(t)})))}],abs:[N,[N],function(t,e){var r=e[0];return Math.abs(r.evaluate(t))}],round:[N,[N],function(t,e){var r=e[0].evaluate(t);return r<0?-Math.round(-r):Math.round(r)}],floor:[N,[N],function(t,e){var r=e[0];return Math.floor(r.evaluate(t))}],ceil:[N,[N],function(t,e){var r=e[0];return Math.ceil(r.evaluate(t))}],"filter-==":[G,[j,U],function(t,e){var r=e[0],n=e[1];return t.properties()[r.value]===n.value}],"filter-id-==":[G,[U],function(t,e){var r=e[0];return t.id()===r.value}],"filter-type-==":[G,[j],function(t,e){var r=e[0];return t.geometryType()===r.value}],"filter-<":[G,[j,U],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],o=n.value;return typeof i==typeof o&&i<o}],"filter-id-<":[G,[U],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<i}],"filter->":[G,[j,U],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],o=n.value;return typeof i==typeof o&&i>o}],"filter-id->":[G,[U],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>i}],"filter-<=":[G,[j,U],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],o=n.value;return typeof i==typeof o&&i<=o}],"filter-id-<=":[G,[U],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<=i}],"filter->=":[G,[j,U],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],o=n.value;return typeof i==typeof o&&i>=o}],"filter-id->=":[G,[U],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>=i}],"filter-has":[G,[U],function(t,e){return e[0].value in t.properties()}],"filter-has-id":[G,[],function(t){return null!==t.id()&&void 0!==t.id()}],"filter-type-in":[G,[W(j)],function(t,e){return e[0].value.indexOf(t.geometryType())>=0}],"filter-id-in":[G,[W(U)],function(t,e){return e[0].value.indexOf(t.id())>=0}],"filter-in-small":[G,[j,W(U)],function(t,e){var r=e[0];return e[1].value.indexOf(t.properties()[r.value])>=0}],"filter-in-large":[G,[j,W(U)],function(t,e){var r=e[0],n=e[1];return function(t,e,r,n){for(;r<=n;){var i=r+n>>1;if(e[i]===t)return!0;e[i]>t?n=i-1:r=i+1}return!1}(t.properties()[r.value],n.value,0,n.value.length-1)}],all:{type:G,overloads:[[[G,G],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)&&n.evaluate(t)}],[Le(G),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(!n[r].evaluate(t))return!1}return!0}]]},any:{type:G,overloads:[[[G,G],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)||n.evaluate(t)}],[Le(G),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(n[r].evaluate(t))return!0}return!1}]]},"!":[G,[G],function(t,e){return!e[0].evaluate(t)}],"is-supported-script":[G,[j],function(t,e){var r=e[0],n=t.globals&&t.globals.isSupportedScript;return!n||n(r.evaluate(t))}],upcase:[j,[j],function(t,e){return e[0].evaluate(t).toUpperCase()}],downcase:[j,[j],function(t,e){return e[0].evaluate(t).toLowerCase()}],concat:[j,Le(U),function(t,e){return e.map((function(e){return at(e.evaluate(t))})).join("")}],"resolved-locale":[j,[B],function(t,e){return e[0].evaluate(t).resolvedLocale()}]});var qe=function(t,e){var r;this.expression=t,this._warningHistory={},this._evaluator=new yt,this._defaultValue=e?"color"===(r=e).type&&Ge(r.default)?new $(0,0,0,0):"color"===r.type?$.parse(r.default)||null:void 0===r.default?null:r.default:null,this._enumValues=e&&"enum"===e.type?e.values:null};function Xe(t){return Array.isArray(t)&&t.length>0&&"string"==typeof t[0]&&t[0]in Pe}function Ze(t,e){var r=new Dt(Pe,[],e?function(t){var e={color:D,string:j,number:N,enum:j,boolean:G,formatted:Y,resolvedImage:V};if("array"===t.type)return W(e[t.value]||U,t.length);return e[t.type]}(e):void 0),n=r.parse(t,void 0,void 0,void 0,e&&"string"===e.type?{typeAnnotation:"coerce"}:void 0);return n?Me(new qe(n,e)):Fe(r.errors)}qe.prototype.evaluateWithoutErrorHandling=function(t,e,r,n,i,o){return this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=r,this._evaluator.canonical=n,this._evaluator.availableImages=i||null,this._evaluator.formattedSection=o,this.expression.evaluate(this._evaluator)},qe.prototype.evaluate=function(t,e,r,n,i,o){this._evaluator.globals=t,this._evaluator.feature=e||null,this._evaluator.featureState=r||null,this._evaluator.canonical=n,this._evaluator.availableImages=i||null,this._evaluator.formattedSection=o||null;try{var a=this.expression.evaluate(this._evaluator);if(null==a||"number"==typeof a&&a!=a)return this._defaultValue;if(this._enumValues&&!(a in this._enumValues))throw new ut("Expected value to be one of "+Object.keys(this._enumValues).map((function(t){return JSON.stringify(t)})).join(", ")+", but found "+JSON.stringify(a)+" instead.");return a}catch(t){return this._warningHistory[t.message]||(this._warningHistory[t.message]=!0,"undefined"!=typeof console&&console.warn(t.message)),this._defaultValue}};var Ke=function(t,e){this.kind=t,this._styleExpression=e,this.isStateDependent="constant"!==t&&!Nt(e.expression)};Ke.prototype.evaluateWithoutErrorHandling=function(t,e,r,n,i,o){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i,o)},Ke.prototype.evaluate=function(t,e,r,n,i,o){return this._styleExpression.evaluate(t,e,r,n,i,o)};var He=function(t,e,r,n){this.kind=t,this.zoomStops=r,this._styleExpression=e,this.isStateDependent="camera"!==t&&!Nt(e.expression),this.interpolationType=n};function Je(t,e){if("error"===(t=Ze(t,e)).result)return t;var r=t.value.expression,n=kt(r);if(!n&&!Ae(e))return Fe([new F("","data expressions not supported")]);var i=jt(r,["zoom"]);if(!i&&!ke(e))return Fe([new F("","zoom expressions not supported")]);var o=function t(e){var r=null;if(e instanceof le)r=t(e.result);else if(e instanceof ue)for(var n=0,i=e.args;n<i.length;n+=1){var o=i[n];if(r=t(o))break}else(e instanceof Ut||e instanceof ae)&&e.input instanceof mt&&"zoom"===e.input.name&&(r=e);if(r instanceof F)return r;return e.eachChild((function(e){var n=t(e);n instanceof F?r=n:!r&&n?r=new F("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):r&&n&&r!==n&&(r=new F("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'))})),r}(r);if(!o&&!i)return Fe([new F("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);if(o instanceof F)return Fe([o]);if(o instanceof ae&&!Ne(e))return Fe([new F("",'"interpolate" expressions cannot be used with this property')]);if(!o)return Me(new Ke(n?"constant":"source",t.value));var a=o instanceof ae?o.interpolation:void 0;return Me(new He(n?"camera":"composite",t.value,o.labels,a))}He.prototype.evaluateWithoutErrorHandling=function(t,e,r,n,i,o){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i,o)},He.prototype.evaluate=function(t,e,r,n,i,o){return this._styleExpression.evaluate(t,e,r,n,i,o)},He.prototype.interpolationFactor=function(t,e,r){return this.interpolationType?ae.interpolationFactor(this.interpolationType,t,e,r):0};var $e=function(t,e){this._parameters=t,this._specification=e,M(this,ze(this._parameters,this._specification))};function Qe(t){return"object"==typeof t?["literal",t]:t}function tr(t,e){var r=t.stops;if(!r)return function(t,e){var r=["get",t.property];if(void 0===t.default)return"string"===e.type?["string",r]:r;if("enum"===e.type)return["match",r,Object.keys(e.values),r,t.default];var n=["color"===e.type?"to-color":e.type,r,Qe(t.default)];return"array"===e.type&&n.splice(1,0,e.value,e.length||null),n}(t,e);var n=r&&"object"==typeof r[0][0],i=n||void 0!==t.property,o=n||!i;return r=r.map((function(t){return!i&&e.tokens&&"string"==typeof t[1]?[t[0],sr(t[1])]:[t[0],Qe(t[1])]})),n?function(t,e,r){for(var n={},i={},o=[],a=0;a<r.length;a++){var s=r[a],u=s[0].zoom;void 0===n[u]&&(n[u]={zoom:u,type:t.type,property:t.property,default:t.default},i[u]=[],o.push(u)),i[u].push([s[0].value,s[1]])}if("exponential"===ar({},e)){for(var l=[er(t),["linear"],["zoom"]],h=0,c=o;h<c.length;h+=1){var p=c[h],f=nr(n[p],e,i[p]);or(l,p,f,!1)}return l}for(var d=["step",["zoom"]],g=0,y=o;g<y.length;g+=1){var m=y[g],v=nr(n[m],e,i[m]);or(d,m,v,!0)}return ir(d),d}(t,e,r):o?function(t,e,r,n){void 0===n&&(n=["zoom"]);var i,o=ar(t,e),a=!1;if("interval"===o)i=["step",n],a=!0;else{if("exponential"!==o)throw new Error('Unknown zoom function type "'+o+'"');var s=void 0!==t.base?t.base:1;i=[er(t),1===s?["linear"]:["exponential",s],n]}for(var u=0,l=r;u<l.length;u+=1){var h=l[u];or(i,h[0],h[1],a)}return ir(i),i}(t,e,r):nr(t,e,r)}function er(t){switch(t.colorSpace){case"hcl":return"interpolate-hcl";case"lab":return"interpolate-lab";default:return"interpolate"}}function rr(t,e){return void 0!==t?t:void 0!==e?e:void 0}function nr(t,e,r){var n=ar(t,e),i=["get",t.property];if("categorical"===n&&"boolean"==typeof r[0][0]){for(var o=["case"],a=0,s=r;a<s.length;a+=1){var u=s[a];o.push(["==",i,u[0]],u[1])}return o.push(Qe(rr(t.default,e.default))),o}if("categorical"===n){for(var l=["match",i],h=0,c=r;h<c.length;h+=1){var p=c[h];or(l,p[0],p[1],!1)}return l.push(Qe(rr(t.default,e.default))),l}if("interval"===n){for(var f=["step",["number",i]],d=0,g=r;d<g.length;d+=1){var y=g[d];or(f,y[0],y[1],!0)}return ir(f),void 0===t.default?f:["case",["==",["typeof",i],"number"],f,Qe(t.default)]}if("exponential"===n){for(var m=void 0!==t.base?t.base:1,v=[er(t),1===m?["linear"]:["exponential",m],["number",i]],_=0,b=r;_<b.length;_+=1){var x=b[_];or(v,x[0],x[1],!1)}return void 0===t.default?v:["case",["==",["typeof",i],"number"],v,Qe(t.default)]}throw new Error("Unknown property function type "+n)}function ir(t){"step"===t[0]&&3===t.length&&(t.push(0),t.push(t[3]))}function or(t,e,r,n){t.length>3&&e===t[t.length-2]||(n&&2===t.length||t.push(e),t.push(r))}function ar(t,e){return t.type?t.type:e.expression.interpolated?"exponential":"interval"}function sr(t){for(var e=["concat"],r=/{([^{}]+)}/g,n=0,i=r.exec(t);null!==i;i=r.exec(t)){var o=t.slice(n,r.lastIndex-i[0].length);n=r.lastIndex,o.length>0&&e.push(o),e.push(["get",i[1]])}if(1===e.length)return t;if(n<t.length)e.push(t.slice(n));else if(2===e.length)return["to-string",e[1]];return e}function ur(t){if(!0===t||!1===t)return!0;if(!Array.isArray(t)||0===t.length)return!1;switch(t[0]){case"has":return t.length>=2&&"$id"!==t[1]&&"$type"!==t[1];case"in":return t.length>=3&&("string"!=typeof t[1]||Array.isArray(t[2]));case"!in":case"!has":case"none":return!1;case"==":case"!=":case">":case">=":case"<":case"<=":return 3!==t.length||Array.isArray(t[1])||Array.isArray(t[2]);case"any":case"all":for(var e=0,r=t.slice(1);e<r.length;e+=1){var n=r[e];if(!ur(n)&&"boolean"!=typeof n)return!1}return!0;default:return!0}}$e.deserialize=function(t){return new $e(t._parameters,t._specification)},$e.serialize=function(t){return{_parameters:t._parameters,_specification:t._specification}};var lr={type:"boolean",default:!1,transition:!1,"property-type":"data-driven",expression:{interpolated:!1,parameters:["zoom","feature"]}};function hr(t){if(null==t)return{filter:function(){return!0},needGeometry:!1};ur(t)||(t=pr(t));var e=Ze(t,lr);if("error"===e.result)throw new Error(e.value.map((function(t){return t.key+": "+t.message})).join(", "));return{filter:function(t,r,n){return e.value.evaluate(t,r,{},n)},needGeometry:function t(e){if(!Array.isArray(e))return!1;if("within"===e[0])return!0;for(var r=1;r<e.length;r++)if(t(e[r]))return!0;return!1}(t)}}function cr(t,e){return t<e?-1:t>e?1:0}function pr(t){if(!t)return!0;var e,r=t[0];return t.length<=1?"any"!==r:"=="===r?fr(t[1],t[2],"=="):"!="===r?yr(fr(t[1],t[2],"==")):"<"===r||">"===r||"<="===r||">="===r?fr(t[1],t[2],r):"any"===r?(e=t.slice(1),["any"].concat(e.map(pr))):"all"===r?["all"].concat(t.slice(1).map(pr)):"none"===r?["all"].concat(t.slice(1).map(pr).map(yr)):"in"===r?dr(t[1],t.slice(2)):"!in"===r?yr(dr(t[1],t.slice(2))):"has"===r?gr(t[1]):"!has"===r?yr(gr(t[1])):"within"!==r||t}function fr(t,e,r){switch(t){case"$type":return["filter-type-"+r,e];case"$id":return["filter-id-"+r,e];default:return["filter-"+r,t,e]}}function dr(t,e){if(0===e.length)return!1;switch(t){case"$type":return["filter-type-in",["literal",e]];case"$id":return["filter-id-in",["literal",e]];default:return e.length>200&&!e.some((function(t){return typeof t!=typeof e[0]}))?["filter-in-large",t,["literal",e.sort(cr)]]:["filter-in-small",t,["literal",e]]}}function gr(t){switch(t){case"$type":return!0;case"$id":return["filter-has-id"];default:return["filter-has",t]}}function yr(t){return["!",t]}var mr=["type","source","source-layer","minzoom","maxzoom","filter","layout"];function vr(t,e){var r={};for(var n in t)"ref"!==n&&(r[n]=t[n]);return mr.forEach((function(t){t in e&&(r[t]=e[t])})),r}function _r(t){t=t.slice();for(var e=Object.create(null),r=0;r<t.length;r++)e[t[r].id]=t[r];for(var n=0;n<t.length;n++)"ref"in t[n]&&(t[n]=vr(t[n],e[t[n].ref]));return t}var br=function(t,e,r,n){this.message=(t?t+": ":"")+r,n&&(this.identifier=n),null!=e&&e.__line__&&(this.line=e.__line__)},xr=function(t){this.error=t,this.message=t.message;var e=t.message.match(/line (\d+)/);this.line=e?parseInt(e[1],10):0};function wr(t){var e=t.key,r=t.value;return r?[new br(e,r,"constants have been deprecated as of v8")]:[]}function Sr(t){return t instanceof Number||t instanceof String||t instanceof Boolean?t.valueOf():t}function Tr(t){if(Array.isArray(t))return t.map(Tr);if(t instanceof Object&&!(t instanceof Number||t instanceof String||t instanceof Boolean)){var e={};for(var r in t)e[r]=Tr(t[r]);return e}return Sr(t)}function Er(t){var e=t.key,r=t.value,n=t.valueSpec||{},i=t.objectElementValidators||{},o=t.style,a=t.styleSpec,s=[],u=je(r);if("object"!==u)return[new br(e,r,"object expected, "+u+" found")];for(var l in r){var h=l.split(".")[0],c=n[h]||n["*"],p=void 0;if(i[h])p=i[h];else if(n[h])p=Ur;else if(i["*"])p=i["*"];else{if(!n["*"]){s.push(new br(e,r[l],'unknown property "'+l+'"'));continue}p=Ur}s=s.concat(p({key:(e?e+".":e)+l,value:r[l],valueSpec:c,style:o,styleSpec:a,object:r,objectKey:l},r))}for(var f in n)i[f]||n[f].required&&void 0===n[f].default&&void 0===r[f]&&s.push(new br(e,r,'missing required property "'+f+'"'));return s}function Cr(t){var e=t.value,r=t.valueSpec,n=t.style,i=t.styleSpec,o=t.key,a=t.arrayElementValidator||Ur;if("array"!==je(e))return[new br(o,e,"array expected, "+je(e)+" found")];if(r.length&&e.length!==r.length)return[new br(o,e,"array length "+r.length+" expected, length "+e.length+" found")];if(r["min-length"]&&e.length<r["min-length"])return[new br(o,e,"array length at least "+r["min-length"]+" expected, length "+e.length+" found")];var s={type:r.value,values:r.values};i.$version<7&&(s.function=r.function),"object"===je(r.value)&&(s=r.value);for(var u=[],l=0;l<e.length;l++)u=u.concat(a({array:e,arrayIndex:l,value:e[l],valueSpec:s,style:n,styleSpec:i,key:o+"["+l+"]"}));return u}function Pr(t){var e=t.key,r=t.value,n=t.valueSpec,i=je(r);return"number"===i&&r!=r&&(i="NaN"),"number"!==i?[new br(e,r,"number expected, "+i+" found")]:"minimum"in n&&r<n.minimum?[new br(e,r,r+" is less than the minimum value "+n.minimum)]:"maximum"in n&&r>n.maximum?[new br(e,r,r+" is greater than the maximum value "+n.maximum)]:[]}function Rr(t){var e,r,n,i=t.valueSpec,o=Sr(t.value.type),a={},s="categorical"!==o&&void 0===t.value.property,u=!s,l="array"===je(t.value.stops)&&"array"===je(t.value.stops[0])&&"object"===je(t.value.stops[0][0]),h=Er({key:t.key,value:t.value,valueSpec:t.styleSpec.function,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{stops:function(t){if("identity"===o)return[new br(t.key,t.value,'identity function may not have a "stops" property')];var e=[],r=t.value;e=e.concat(Cr({key:t.key,value:r,valueSpec:t.valueSpec,style:t.style,styleSpec:t.styleSpec,arrayElementValidator:c})),"array"===je(r)&&0===r.length&&e.push(new br(t.key,r,"array must have at least one stop"));return e},default:function(t){return Ur({key:t.key,value:t.value,valueSpec:i,style:t.style,styleSpec:t.styleSpec})}}});return"identity"===o&&s&&h.push(new br(t.key,t.value,'missing required property "property"')),"identity"===o||t.value.stops||h.push(new br(t.key,t.value,'missing required property "stops"')),"exponential"===o&&t.valueSpec.expression&&!Ne(t.valueSpec)&&h.push(new br(t.key,t.value,"exponential functions not supported")),t.styleSpec.$version>=8&&(u&&!Ae(t.valueSpec)?h.push(new br(t.key,t.value,"property functions not supported")):s&&!ke(t.valueSpec)&&h.push(new br(t.key,t.value,"zoom functions not supported"))),"categorical"!==o&&!l||void 0!==t.value.property||h.push(new br(t.key,t.value,'"property" property is required')),h;function c(t){var e=[],o=t.value,s=t.key;if("array"!==je(o))return[new br(s,o,"array expected, "+je(o)+" found")];if(2!==o.length)return[new br(s,o,"array length 2 expected, length "+o.length+" found")];if(l){if("object"!==je(o[0]))return[new br(s,o,"object expected, "+je(o[0])+" found")];if(void 0===o[0].zoom)return[new br(s,o,"object stop key must have zoom")];if(void 0===o[0].value)return[new br(s,o,"object stop key must have value")];if(n&&n>Sr(o[0].zoom))return[new br(s,o[0].zoom,"stop zoom values must appear in ascending order")];Sr(o[0].zoom)!==n&&(n=Sr(o[0].zoom),r=void 0,a={}),e=e.concat(Er({key:s+"[0]",value:o[0],valueSpec:{zoom:{}},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{zoom:Pr,value:p}}))}else e=e.concat(p({key:s+"[0]",value:o[0],valueSpec:{},style:t.style,styleSpec:t.styleSpec},o));return Xe(Tr(o[1]))?e.concat([new br(s+"[1]",o[1],"expressions are not allowed in function stops.")]):e.concat(Ur({key:s+"[1]",value:o[1],valueSpec:i,style:t.style,styleSpec:t.styleSpec}))}function p(t,n){var s=je(t.value),u=Sr(t.value),l=null!==t.value?t.value:n;if(e){if(s!==e)return[new br(t.key,l,s+" stop domain type must match previous stop domain type "+e)]}else e=s;if("number"!==s&&"string"!==s&&"boolean"!==s)return[new br(t.key,l,"stop domain value must be a number, string, or boolean")];if("number"!==s&&"categorical"!==o){var h="number expected, "+s+" found";return Ae(i)&&void 0===o&&(h+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new br(t.key,l,h)]}return"categorical"!==o||"number"!==s||isFinite(u)&&Math.floor(u)===u?"categorical"!==o&&"number"===s&&void 0!==r&&u<r?[new br(t.key,l,"stop domain values must appear in ascending order")]:(r=u,"categorical"===o&&u in a?[new br(t.key,l,"stop domain values must be unique")]:(a[u]=!0,[])):[new br(t.key,l,"integer expected, found "+u)]}}function Or(t){var e=("property"===t.expressionContext?Je:Ze)(Tr(t.value),t.valueSpec);if("error"===e.result)return e.value.map((function(e){return new br(""+t.key+e.key,t.value,e.message)}));var r=e.value.expression||e.value._styleExpression.expression;if("property"===t.expressionContext&&"text-font"===t.propertyKey&&!r.outputDefined())return[new br(t.key,t.value,'Invalid data expression for "'+t.propertyKey+'". Output values must be contained as literals within the expression.')];if("property"===t.expressionContext&&"layout"===t.propertyType&&!Nt(r))return[new br(t.key,t.value,'"feature-state" data expressions are not supported with layout properties.')];if("filter"===t.expressionContext&&!Nt(r))return[new br(t.key,t.value,'"feature-state" data expressions are not supported with filters.')];if(t.expressionContext&&0===t.expressionContext.indexOf("cluster")){if(!jt(r,["zoom","feature-state"]))return[new br(t.key,t.value,'"zoom" and "feature-state" expressions are not supported with cluster properties.')];if("cluster-initial"===t.expressionContext&&!kt(r))return[new br(t.key,t.value,"Feature data expressions are not supported with initial expression part of cluster properties.")]}return[]}function Ir(t){var e=t.key,r=t.value,n=t.valueSpec,i=[];return Array.isArray(n.values)?-1===n.values.indexOf(Sr(r))&&i.push(new br(e,r,"expected one of ["+n.values.join(", ")+"], "+JSON.stringify(r)+" found")):-1===Object.keys(n.values).indexOf(Sr(r))&&i.push(new br(e,r,"expected one of ["+Object.keys(n.values).join(", ")+"], "+JSON.stringify(r)+" found")),i}function Lr(t){return ur(Tr(t.value))?Or(M({},t,{expressionContext:"filter",valueSpec:{value:"boolean"}})):function t(e){var r=e.value,n=e.key;if("array"!==je(r))return[new br(n,r,"array expected, "+je(r)+" found")];var i,o=e.styleSpec,a=[];if(r.length<1)return[new br(n,r,"filter array must have at least 1 element")];switch(a=a.concat(Ir({key:n+"[0]",value:r[0],valueSpec:o.filter_operator,style:e.style,styleSpec:e.styleSpec})),Sr(r[0])){case"<":case"<=":case">":case">=":r.length>=2&&"$type"===Sr(r[1])&&a.push(new br(n,r,'"$type" cannot be use with operator "'+r[0]+'"'));case"==":case"!=":3!==r.length&&a.push(new br(n,r,'filter array for operator "'+r[0]+'" must have 3 elements'));case"in":case"!in":r.length>=2&&"string"!==(i=je(r[1]))&&a.push(new br(n+"[1]",r[1],"string expected, "+i+" found"));for(var s=2;s<r.length;s++)i=je(r[s]),"$type"===Sr(r[1])?a=a.concat(Ir({key:n+"["+s+"]",value:r[s],valueSpec:o.geometry_type,style:e.style,styleSpec:e.styleSpec})):"string"!==i&&"number"!==i&&"boolean"!==i&&a.push(new br(n+"["+s+"]",r[s],"string, number, or boolean expected, "+i+" found"));break;case"any":case"all":case"none":for(var u=1;u<r.length;u++)a=a.concat(t({key:n+"["+u+"]",value:r[u],style:e.style,styleSpec:e.styleSpec}));break;case"has":case"!has":i=je(r[1]),2!==r.length?a.push(new br(n,r,'filter array for "'+r[0]+'" operator must have 2 elements')):"string"!==i&&a.push(new br(n+"[1]",r[1],"string expected, "+i+" found"));break;case"within":i=je(r[1]),2!==r.length?a.push(new br(n,r,'filter array for "'+r[0]+'" operator must have 2 elements')):"object"!==i&&a.push(new br(n+"[1]",r[1],"object expected, "+i+" found"))}return a}(t)}function Mr(t,e){var r=t.key,n=t.style,i=t.styleSpec,o=t.value,a=t.objectKey,s=i[e+"_"+t.layerType];if(!s)return[];var u=a.match(/^(.*)-transition$/);if("paint"===e&&u&&s[u[1]]&&s[u[1]].transition)return Ur({key:r,value:o,valueSpec:i.transition,style:n,styleSpec:i});var l,h=t.valueSpec||s[a];if(!h)return[new br(r,o,'unknown property "'+a+'"')];if("string"===je(o)&&Ae(h)&&!h.tokens&&(l=/^{([^}]+)}$/.exec(o)))return[new br(r,o,'"'+a+'" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": '+JSON.stringify(l[1])+" }`.")];var c=[];return"symbol"===t.layerType&&("text-field"===a&&n&&!n.glyphs&&c.push(new br(r,o,'use of "text-field" requires a style "glyphs" property')),"text-font"===a&&Ge(Tr(o))&&"identity"===Sr(o.type)&&c.push(new br(r,o,'"text-font" does not support identity functions'))),c.concat(Ur({key:t.key,value:o,valueSpec:h,style:n,styleSpec:i,expressionContext:"property",propertyType:e,propertyKey:a}))}function Fr(t){return Mr(t,"paint")}function Ar(t){return Mr(t,"layout")}function kr(t){var e=[],r=t.value,n=t.key,i=t.style,o=t.styleSpec;r.type||r.ref||e.push(new br(n,r,'either "type" or "ref" is required'));var a,s=Sr(r.type),u=Sr(r.ref);if(r.id)for(var l=Sr(r.id),h=0;h<t.arrayIndex;h++){var c=i.layers[h];Sr(c.id)===l&&e.push(new br(n,r.id,'duplicate layer id "'+r.id+'", previously used at line '+c.id.__line__))}if("ref"in r)["type","source","source-layer","filter","layout"].forEach((function(t){t in r&&e.push(new br(n,r[t],'"'+t+'" is prohibited for ref layers'))})),i.layers.forEach((function(t){Sr(t.id)===u&&(a=t)})),a?a.ref?e.push(new br(n,r.ref,"ref cannot reference another ref layer")):s=Sr(a.type):e.push(new br(n,r.ref,'ref layer "'+u+'" not found'));else if("background"!==s)if(r.source){var p=i.sources&&i.sources[r.source],f=p&&Sr(p.type);p?"vector"===f&&"raster"===s?e.push(new br(n,r.source,'layer "'+r.id+'" requires a raster source')):"raster"===f&&"raster"!==s?e.push(new br(n,r.source,'layer "'+r.id+'" requires a vector source')):"vector"!==f||r["source-layer"]?"raster-dem"===f&&"hillshade"!==s?e.push(new br(n,r.source,"raster-dem source can only be used with layer type 'hillshade'.")):"line"!==s||!r.paint||!r.paint["line-gradient"]||"geojson"===f&&p.lineMetrics||e.push(new br(n,r,'layer "'+r.id+'" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')):e.push(new br(n,r,'layer "'+r.id+'" must specify a "source-layer"')):e.push(new br(n,r.source,'source "'+r.source+'" not found'))}else e.push(new br(n,r,'missing required property "source"'));return e=e.concat(Er({key:n,value:r,valueSpec:o.layer,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(){return[]},type:function(){return Ur({key:n+".type",value:r.type,valueSpec:o.layer.type,style:t.style,styleSpec:t.styleSpec,object:r,objectKey:"type"})},filter:Lr,layout:function(t){return Er({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return Ar(M({layerType:s},t))}}})},paint:function(t){return Er({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return Fr(M({layerType:s},t))}}})}}}))}function Nr(t){var e=t.value,r=t.key,n=je(e);return"string"!==n?[new br(r,e,"string expected, "+n+" found")]:[]}var jr={promoteId:function(t){var e=t.key,r=t.value;if("string"===je(r))return Nr({key:e,value:r});var n=[];for(var i in r)n.push.apply(n,Nr({key:e+"."+i,value:r[i]}));return n}};function Gr(t){var e=t.value,r=t.key,n=t.styleSpec,i=t.style;if(!e.type)return[new br(r,e,'"type" is required')];var o,a=Sr(e.type);switch(a){case"vector":case"raster":case"raster-dem":return o=Er({key:r,value:e,valueSpec:n["source_"+a.replace("-","_")],style:t.style,styleSpec:n,objectElementValidators:jr});case"geojson":if(o=Er({key:r,value:e,valueSpec:n.source_geojson,style:i,styleSpec:n,objectElementValidators:jr}),e.cluster)for(var s in e.clusterProperties){var u=e.clusterProperties[s],l=u[0],h=u[1],c="string"==typeof l?[l,["accumulated"],["get",s]]:l;o.push.apply(o,Or({key:r+"."+s+".map",value:h,expressionContext:"cluster-map"})),o.push.apply(o,Or({key:r+"."+s+".reduce",value:c,expressionContext:"cluster-reduce"}))}return o;case"video":return Er({key:r,value:e,valueSpec:n.source_video,style:i,styleSpec:n});case"image":return Er({key:r,value:e,valueSpec:n.source_image,style:i,styleSpec:n});case"canvas":return[new br(r,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")];default:return Ir({key:r+".type",value:e.type,valueSpec:{values:["vector","raster","raster-dem","geojson","video","image"]},style:i,styleSpec:n})}}function Dr(t){var e=t.value,r=t.styleSpec,n=r.light,i=t.style,o=[],a=je(e);if(void 0===e)return o;if("object"!==a)return o=o.concat([new br("light",e,"object expected, "+a+" found")]);for(var s in e){var u=s.match(/^(.*)-transition$/);o=u&&n[u[1]]&&n[u[1]].transition?o.concat(Ur({key:s,value:e[s],valueSpec:r.transition,style:i,styleSpec:r})):n[s]?o.concat(Ur({key:s,value:e[s],valueSpec:n[s],style:i,styleSpec:r})):o.concat([new br(s,e[s],'unknown property "'+s+'"')])}return o}var zr={"*":function(){return[]},array:Cr,boolean:function(t){var e=t.value,r=t.key,n=je(e);return"boolean"!==n?[new br(r,e,"boolean expected, "+n+" found")]:[]},number:Pr,color:function(t){var e=t.key,r=t.value,n=je(r);return"string"!==n?[new br(e,r,"color expected, "+n+" found")]:null===J(r)?[new br(e,r,'color expected, "'+r+'" found')]:[]},constants:wr,enum:Ir,filter:Lr,function:Rr,layer:kr,object:Er,source:Gr,light:Dr,string:Nr,formatted:function(t){return 0===Nr(t).length?[]:Or(t)},resolvedImage:function(t){return 0===Nr(t).length?[]:Or(t)}};function Ur(t){var e=t.value,r=t.valueSpec,n=t.styleSpec;return r.expression&&Ge(Sr(e))?Rr(t):r.expression&&Xe(Tr(e))?Or(t):r.type&&zr[r.type]?zr[r.type](t):Er(M({},t,{valueSpec:r.type?n[r.type]:r}))}function Br(t){var e=t.value,r=t.key,n=Nr(t);return n.length||(-1===e.indexOf("{fontstack}")&&n.push(new br(r,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&n.push(new br(r,e,'"glyphs" url must include a "{range}" token'))),n}function Yr(t,e){void 0===e&&(e=i);var r=[];return r=r.concat(Ur({key:"",value:t,valueSpec:e.$root,styleSpec:e,style:t,objectElementValidators:{glyphs:Br,"*":function(){return[]}}})),t.constants&&(r=r.concat(wr({key:"constants",value:t.constants,style:t,styleSpec:e}))),Vr(r)}function Vr(t){return[].concat(t).sort((function(t,e){return t.line-e.line}))}function Wr(t){return function(){for(var e=[],r=arguments.length;r--;)e[r]=arguments[r];return Vr(t.apply(this,e))}}Yr.source=Wr(Gr),Yr.light=Wr(Dr),Yr.layer=Wr(kr),Yr.filter=Wr(Lr),Yr.paintProperty=Wr(Fr),Yr.layoutProperty=Wr(Ar);var qr=s((function(t,e){var r=function(){var t=function(t,e,r,n){for(r=r||{},n=t.length;n--;r[t[n]]=e);return r},e=[1,12],r=[1,13],n=[1,9],i=[1,10],o=[1,11],a=[1,14],s=[1,15],u=[14,18,22,24],l=[18,22],h=[22,24],c={trace:function(){},yy:{},symbols_:{error:2,JSONString:3,STRING:4,JSONNumber:5,NUMBER:6,JSONNullLiteral:7,NULL:8,JSONBooleanLiteral:9,TRUE:10,FALSE:11,JSONText:12,JSONValue:13,EOF:14,JSONObject:15,JSONArray:16,"{":17,"}":18,JSONMemberList:19,JSONMember:20,":":21,",":22,"[":23,"]":24,JSONElementList:25,$accept:0,$end:1},terminals_:{2:"error",4:"STRING",6:"NUMBER",8:"NULL",10:"TRUE",11:"FALSE",14:"EOF",17:"{",18:"}",21:":",22:",",23:"[",24:"]"},productions_:[0,[3,1],[5,1],[7,1],[9,1],[9,1],[12,2],[13,1],[13,1],[13,1],[13,1],[13,1],[13,1],[15,2],[15,3],[20,3],[19,1],[19,3],[16,2],[16,3],[25,1],[25,3]],performAction:function(t,e,r,n,i,o,a){var s=o.length-1;switch(i){case 1:this.$=new String(t.replace(/\\(\\|")/g,"$1").replace(/\\n/g,"\n").replace(/\\r/g,"\r").replace(/\\t/g,"\t").replace(/\\v/g,"\v").replace(/\\f/g,"\f").replace(/\\b/g,"\b")),this.$.__line__=this._$.first_line;break;case 2:this.$=new Number(t),this.$.__line__=this._$.first_line;break;case 3:this.$=null;break;case 4:this.$=new Boolean(!0),this.$.__line__=this._$.first_line;break;case 5:this.$=new Boolean(!1),this.$.__line__=this._$.first_line;break;case 6:return this.$=o[s-1];case 13:this.$={},Object.defineProperty(this.$,"__line__",{value:this._$.first_line,enumerable:!1});break;case 14:case 19:this.$=o[s-1],Object.defineProperty(this.$,"__line__",{value:this._$.first_line,enumerable:!1});break;case 15:this.$=[o[s-2],o[s]];break;case 16:this.$={},this.$[o[s][0]]=o[s][1];break;case 17:this.$=o[s-2],o[s-2][o[s][0]]=o[s][1];break;case 18:this.$=[],Object.defineProperty(this.$,"__line__",{value:this._$.first_line,enumerable:!1});break;case 20:this.$=[o[s]];break;case 21:this.$=o[s-2],o[s-2].push(o[s])}},table:[{3:5,4:e,5:6,6:r,7:3,8:n,9:4,10:i,11:o,12:1,13:2,15:7,16:8,17:a,23:s},{1:[3]},{14:[1,16]},t(u,[2,7]),t(u,[2,8]),t(u,[2,9]),t(u,[2,10]),t(u,[2,11]),t(u,[2,12]),t(u,[2,3]),t(u,[2,4]),t(u,[2,5]),t([14,18,21,22,24],[2,1]),t(u,[2,2]),{3:20,4:e,18:[1,17],19:18,20:19},{3:5,4:e,5:6,6:r,7:3,8:n,9:4,10:i,11:o,13:23,15:7,16:8,17:a,23:s,24:[1,21],25:22},{1:[2,6]},t(u,[2,13]),{18:[1,24],22:[1,25]},t(l,[2,16]),{21:[1,26]},t(u,[2,18]),{22:[1,28],24:[1,27]},t(h,[2,20]),t(u,[2,14]),{3:20,4:e,20:29},{3:5,4:e,5:6,6:r,7:3,8:n,9:4,10:i,11:o,13:30,15:7,16:8,17:a,23:s},t(u,[2,19]),{3:5,4:e,5:6,6:r,7:3,8:n,9:4,10:i,11:o,13:31,15:7,16:8,17:a,23:s},t(l,[2,17]),t(l,[2,15]),t(h,[2,21])],defaultActions:{16:[2,6]},parseError:function(t,e){if(!e.recoverable)throw new Error(t);this.trace(t)},parse:function(t){var e=this,r=[0],n=[null],i=[],o=this.table,a="",s=0,u=0,l=2,h=1,c=i.slice.call(arguments,1),p=Object.create(this.lexer),f={yy:{}};for(var d in this.yy)Object.prototype.hasOwnProperty.call(this.yy,d)&&(f.yy[d]=this.yy[d]);p.setInput(t,f.yy),f.yy.lexer=p,f.yy.parser=this,void 0===p.yylloc&&(p.yylloc={});var g=p.yylloc;i.push(g);var y=p.options&&p.options.ranges;function m(){var t;return"number"!=typeof(t=p.lex()||h)&&(t=e.symbols_[t]||t),t}"function"==typeof f.yy.parseError?this.parseError=f.yy.parseError:this.parseError=Object.getPrototypeOf(this).parseError;for(var v,_,b,x,w,S,T,E,C={};;){if(_=r[r.length-1],this.defaultActions[_]?b=this.defaultActions[_]:(null==v&&(v=m()),b=o[_]&&o[_][v]),void 0===b||!b.length||!b[0]){var P="";for(w in E=[],o[_])this.terminals_[w]&&w>l&&E.push("'"+this.terminals_[w]+"'");P=p.showPosition?"Parse error on line "+(s+1)+":\n"+p.showPosition()+"\nExpecting "+E.join(", ")+", got '"+(this.terminals_[v]||v)+"'":"Parse error on line "+(s+1)+": Unexpected "+(v==h?"end of input":"'"+(this.terminals_[v]||v)+"'"),this.parseError(P,{text:p.match,token:this.terminals_[v]||v,line:p.yylineno,loc:g,expected:E})}if(b[0]instanceof Array&&b.length>1)throw new Error("Parse Error: multiple actions possible at state: "+_+", token: "+v);switch(b[0]){case 1:r.push(v),n.push(p.yytext),i.push(p.yylloc),r.push(b[1]),v=null,u=p.yyleng,a=p.yytext,s=p.yylineno,g=p.yylloc;break;case 2:if(S=this.productions_[b[1]][1],C.$=n[n.length-S],C._$={first_line:i[i.length-(S||1)].first_line,last_line:i[i.length-1].last_line,first_column:i[i.length-(S||1)].first_column,last_column:i[i.length-1].last_column},y&&(C._$.range=[i[i.length-(S||1)].range[0],i[i.length-1].range[1]]),void 0!==(x=this.performAction.apply(C,[a,u,s,f.yy,b[1],n,i].concat(c))))return x;S&&(r=r.slice(0,-1*S*2),n=n.slice(0,-1*S),i=i.slice(0,-1*S)),r.push(this.productions_[b[1]][0]),n.push(C.$),i.push(C._$),T=o[r[r.length-2]][r[r.length-1]],r.push(T);break;case 3:return!0}}return!0}},p={EOF:1,parseError:function(t,e){if(!this.yy.parser)throw new Error(t);this.yy.parser.parseError(t,e)},setInput:function(t,e){return this.yy=e||this.yy||{},this._input=t,this._more=this._backtrack=this.done=!1,this.yylineno=this.yyleng=0,this.yytext=this.matched=this.match="",this.conditionStack=["INITIAL"],this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0},this.options.ranges&&(this.yylloc.range=[0,0]),this.offset=0,this},input:function(){var t=this._input[0];return this.yytext+=t,this.yyleng++,this.offset++,this.match+=t,this.matched+=t,t.match(/(?:\r\n?|\n).*/g)?(this.yylineno++,this.yylloc.last_line++):this.yylloc.last_column++,this.options.ranges&&this.yylloc.range[1]++,this._input=this._input.slice(1),t},unput:function(t){var e=t.length,r=t.split(/(?:\r\n?|\n)/g);this._input=t+this._input,this.yytext=this.yytext.substr(0,this.yytext.length-e),this.offset-=e;var n=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1),this.matched=this.matched.substr(0,this.matched.length-1),r.length-1&&(this.yylineno-=r.length-1);var i=this.yylloc.range;return this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:r?(r.length===n.length?this.yylloc.first_column:0)+n[n.length-r.length].length-r[0].length:this.yylloc.first_column-e},this.options.ranges&&(this.yylloc.range=[i[0],i[0]+this.yyleng-e]),this.yyleng=this.yytext.length,this},more:function(){return this._more=!0,this},reject:function(){return this.options.backtrack_lexer?(this._backtrack=!0,this):this.parseError("Lexical error on line "+(this.yylineno+1)+". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})},less:function(t){this.unput(this.match.slice(t))},pastInput:function(){var t=this.matched.substr(0,this.matched.length-this.match.length);return(t.length>20?"...":"")+t.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var t=this.match;return t.length<20&&(t+=this._input.substr(0,20-t.length)),(t.substr(0,20)+(t.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var t=this.pastInput(),e=new Array(t.length+1).join("-");return t+this.upcomingInput()+"\n"+e+"^"},test_match:function(t,e){var r,n,i;if(this.options.backtrack_lexer&&(i={yylineno:this.yylineno,yylloc:{first_line:this.yylloc.first_line,last_line:this.last_line,first_column:this.yylloc.first_column,last_column:this.yylloc.last_column},yytext:this.yytext,match:this.match,matches:this.matches,matched:this.matched,yyleng:this.yyleng,offset:this.offset,_more:this._more,_input:this._input,yy:this.yy,conditionStack:this.conditionStack.slice(0),done:this.done},this.options.ranges&&(i.yylloc.range=this.yylloc.range.slice(0))),(n=t[0].match(/(?:\r\n?|\n).*/g))&&(this.yylineno+=n.length),this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:n?n[n.length-1].length-n[n.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+t[0].length},this.yytext+=t[0],this.match+=t[0],this.matches=t,this.yyleng=this.yytext.length,this.options.ranges&&(this.yylloc.range=[this.offset,this.offset+=this.yyleng]),this._more=!1,this._backtrack=!1,this._input=this._input.slice(t[0].length),this.matched+=t[0],r=this.performAction.call(this,this.yy,this,e,this.conditionStack[this.conditionStack.length-1]),this.done&&this._input&&(this.done=!1),r)return r;if(this._backtrack){for(var o in i)this[o]=i[o];return!1}return!1},next:function(){if(this.done)return this.EOF;var t,e,r,n;this._input||(this.done=!0),this._more||(this.yytext="",this.match="");for(var i=this._currentRules(),o=0;o<i.length;o++)if((r=this._input.match(this.rules[i[o]]))&&(!e||r[0].length>e[0].length)){if(e=r,n=o,this.options.backtrack_lexer){if(!1!==(t=this.test_match(r,i[o])))return t;if(this._backtrack){e=!1;continue}return!1}if(!this.options.flex)break}return e?!1!==(t=this.test_match(e,i[n]))&&t:""===this._input?this.EOF:this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})},lex:function(){var t=this.next();return t||this.lex()},begin:function(t){this.conditionStack.push(t)},popState:function(){return this.conditionStack.length-1>0?this.conditionStack.pop():this.conditionStack[0]},_currentRules:function(){return this.conditionStack.length&&this.conditionStack[this.conditionStack.length-1]?this.conditions[this.conditionStack[this.conditionStack.length-1]].rules:this.conditions.INITIAL.rules},topState:function(t){return(t=this.conditionStack.length-1-Math.abs(t||0))>=0?this.conditionStack[t]:"INITIAL"},pushState:function(t){this.begin(t)},stateStackSize:function(){return this.conditionStack.length},options:{},performAction:function(t,e,r,n){switch(r){case 0:break;case 1:return 6;case 2:return e.yytext=e.yytext.substr(1,e.yyleng-2),4;case 3:return 17;case 4:return 18;case 5:return 23;case 6:return 24;case 7:return 22;case 8:return 21;case 9:return 10;case 10:return 11;case 11:return 8;case 12:return 14;case 13:return"INVALID"}},rules:[/^(?:\s+)/,/^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/,/^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/,/^(?:\{)/,/^(?:\})/,/^(?:\[)/,/^(?:\])/,/^(?:,)/,/^(?::)/,/^(?:true\b)/,/^(?:false\b)/,/^(?:null\b)/,/^(?:$)/,/^(?:.)/],conditions:{INITIAL:{rules:[0,1,2,3,4,5,6,7,8,9,10,11,12,13],inclusive:!0}}};function f(){this.yy={}}return c.lexer=p,f.prototype=c,c.Parser=f,new f}();void 0!==a&&(e.parser=r,e.Parser=r.Parser,e.parse=function(){return r.parse.apply(r,arguments)})}));qr.parser,qr.Parser,qr.parse;function Xr(t){if(t instanceof String||"string"==typeof t||t instanceof n)try{return qr.parse(t.toString())}catch(t){throw new xr(t)}return t}function Zr(t,e){void 0===e&&(e=i);var r=t;try{r=Xr(r)}catch(t){return[t]}return Yr(r,e)}var Kr={StyleExpression:qe,isExpression:Xe,isExpressionFilter:ur,createExpression:Ze,createPropertyExpression:Je,normalizePropertyExpression:function(t,e){if(Ge(t))return new $e(t,e);if(Xe(t)){var r=Je(t,e);if("error"===r.result)throw new Error(r.value.map((function(t){return t.key+": "+t.message})).join(", "));return r.value}var n=t;return"string"==typeof t&&"color"===e.type&&(n=$.parse(t)),{kind:"constant",evaluate:function(){return n}}},ZoomConstantExpression:Ke,ZoomDependentExpression:He,StylePropertyFunction:$e},Hr={convertFunction:tr,createFunction:ze,isFunction:Ge};Zr.parsed=Zr,Zr.latest=Zr}).call(this,r(4),r(7).Buffer)},function(t,e,r){t.exports=function(){"use strict";function t(t,n,i,o,a){!function t(r,n,i,o,a){for(;o>i;){if(o-i>600){var s=o-i+1,u=n-i+1,l=Math.log(s),h=.5*Math.exp(2*l/3),c=.5*Math.sqrt(l*h*(s-h)/s)*(u-s/2<0?-1:1),p=Math.max(i,Math.floor(n-u*h/s+c)),f=Math.min(o,Math.floor(n+(s-u)*h/s+c));t(r,n,p,f,a)}var d=r[n],g=i,y=o;for(e(r,i,n),a(r[o],d)>0&&e(r,i,o);g<y;){for(e(r,g,y),g++,y--;a(r[g],d)<0;)g++;for(;a(r[y],d)>0;)y--}0===a(r[i],d)?e(r,i,y):(y++,e(r,y,o)),y<=n&&(i=y+1),n<=y&&(o=y-1)}}(t,n,i||0,o||t.length-1,a||r)}function e(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function r(t,e){return t<e?-1:t>e?1:0}var n=function(t){void 0===t&&(t=9),this._maxEntries=Math.max(4,t),this._minEntries=Math.max(2,Math.ceil(.4*this._maxEntries)),this.clear()};function i(t,e,r){if(!r)return e.indexOf(t);for(var n=0;n<e.length;n++)if(r(t,e[n]))return n;return-1}function o(t,e){a(t,0,t.children.length,e,t)}function a(t,e,r,n,i){i||(i=d(null)),i.minX=1/0,i.minY=1/0,i.maxX=-1/0,i.maxY=-1/0;for(var o=e;o<r;o++){var a=t.children[o];s(i,t.leaf?n(a):a)}return i}function s(t,e){return t.minX=Math.min(t.minX,e.minX),t.minY=Math.min(t.minY,e.minY),t.maxX=Math.max(t.maxX,e.maxX),t.maxY=Math.max(t.maxY,e.maxY),t}function u(t,e){return t.minX-e.minX}function l(t,e){return t.minY-e.minY}function h(t){return(t.maxX-t.minX)*(t.maxY-t.minY)}function c(t){return t.maxX-t.minX+(t.maxY-t.minY)}function p(t,e){return t.minX<=e.minX&&t.minY<=e.minY&&e.maxX<=t.maxX&&e.maxY<=t.maxY}function f(t,e){return e.minX<=t.maxX&&e.minY<=t.maxY&&e.maxX>=t.minX&&e.maxY>=t.minY}function d(t){return{children:t,height:1,leaf:!0,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0}}function g(e,r,n,i,o){for(var a=[r,n];a.length;)if(!((n=a.pop())-(r=a.pop())<=i)){var s=r+Math.ceil((n-r)/i/2)*i;t(e,s,r,n,o),a.push(r,s,s,n)}}return n.prototype.all=function(){return this._all(this.data,[])},n.prototype.search=function(t){var e=this.data,r=[];if(!f(t,e))return r;for(var n=this.toBBox,i=[];e;){for(var o=0;o<e.children.length;o++){var a=e.children[o],s=e.leaf?n(a):a;f(t,s)&&(e.leaf?r.push(a):p(t,s)?this._all(a,r):i.push(a))}e=i.pop()}return r},n.prototype.collides=function(t){var e=this.data;if(!f(t,e))return!1;for(var r=[];e;){for(var n=0;n<e.children.length;n++){var i=e.children[n],o=e.leaf?this.toBBox(i):i;if(f(t,o)){if(e.leaf||p(t,o))return!0;r.push(i)}}e=r.pop()}return!1},n.prototype.load=function(t){if(!t||!t.length)return this;if(t.length<this._minEntries){for(var e=0;e<t.length;e++)this.insert(t[e]);return this}var r=this._build(t.slice(),0,t.length-1,0);if(this.data.children.length)if(this.data.height===r.height)this._splitRoot(this.data,r);else{if(this.data.height<r.height){var n=this.data;this.data=r,r=n}this._insert(r,this.data.height-r.height-1,!0)}else this.data=r;return this},n.prototype.insert=function(t){return t&&this._insert(t,this.data.height-1),this},n.prototype.clear=function(){return this.data=d([]),this},n.prototype.remove=function(t,e){if(!t)return this;for(var r,n,o,a=this.data,s=this.toBBox(t),u=[],l=[];a||u.length;){if(a||(a=u.pop(),n=u[u.length-1],r=l.pop(),o=!0),a.leaf){var h=i(t,a.children,e);if(-1!==h)return a.children.splice(h,1),u.push(a),this._condense(u),this}o||a.leaf||!p(a,s)?n?(r++,a=n.children[r],o=!1):a=null:(u.push(a),l.push(r),r=0,n=a,a=a.children[0])}return this},n.prototype.toBBox=function(t){return t},n.prototype.compareMinX=function(t,e){return t.minX-e.minX},n.prototype.compareMinY=function(t,e){return t.minY-e.minY},n.prototype.toJSON=function(){return this.data},n.prototype.fromJSON=function(t){return this.data=t,this},n.prototype._all=function(t,e){for(var r=[];t;)t.leaf?e.push.apply(e,t.children):r.push.apply(r,t.children),t=r.pop();return e},n.prototype._build=function(t,e,r,n){var i,a=r-e+1,s=this._maxEntries;if(a<=s)return o(i=d(t.slice(e,r+1)),this.toBBox),i;n||(n=Math.ceil(Math.log(a)/Math.log(s)),s=Math.ceil(a/Math.pow(s,n-1))),(i=d([])).leaf=!1,i.height=n;var u=Math.ceil(a/s),l=u*Math.ceil(Math.sqrt(s));g(t,e,r,l,this.compareMinX);for(var h=e;h<=r;h+=l){var c=Math.min(h+l-1,r);g(t,h,c,u,this.compareMinY);for(var p=h;p<=c;p+=u){var f=Math.min(p+u-1,c);i.children.push(this._build(t,p,f,n-1))}}return o(i,this.toBBox),i},n.prototype._chooseSubtree=function(t,e,r,n){for(;n.push(e),!e.leaf&&n.length-1!==r;){for(var i=1/0,o=1/0,a=void 0,s=0;s<e.children.length;s++){var u=e.children[s],l=h(u),c=(p=t,f=u,(Math.max(f.maxX,p.maxX)-Math.min(f.minX,p.minX))*(Math.max(f.maxY,p.maxY)-Math.min(f.minY,p.minY))-l);c<o?(o=c,i=l<i?l:i,a=u):c===o&&l<i&&(i=l,a=u)}e=a||e.children[0]}var p,f;return e},n.prototype._insert=function(t,e,r){var n=r?t:this.toBBox(t),i=[],o=this._chooseSubtree(n,this.data,e,i);for(o.children.push(t),s(o,n);e>=0&&i[e].children.length>this._maxEntries;)this._split(i,e),e--;this._adjustParentBBoxes(n,i,e)},n.prototype._split=function(t,e){var r=t[e],n=r.children.length,i=this._minEntries;this._chooseSplitAxis(r,i,n);var a=this._chooseSplitIndex(r,i,n),s=d(r.children.splice(a,r.children.length-a));s.height=r.height,s.leaf=r.leaf,o(r,this.toBBox),o(s,this.toBBox),e?t[e-1].children.push(s):this._splitRoot(r,s)},n.prototype._splitRoot=function(t,e){this.data=d([t,e]),this.data.height=t.height+1,this.data.leaf=!1,o(this.data,this.toBBox)},n.prototype._chooseSplitIndex=function(t,e,r){for(var n,i,o,s,u,l,c,p=1/0,f=1/0,d=e;d<=r-e;d++){var g=a(t,0,d,this.toBBox),y=a(t,d,r,this.toBBox),m=(i=g,o=y,s=void 0,u=void 0,l=void 0,c=void 0,s=Math.max(i.minX,o.minX),u=Math.max(i.minY,o.minY),l=Math.min(i.maxX,o.maxX),c=Math.min(i.maxY,o.maxY),Math.max(0,l-s)*Math.max(0,c-u)),v=h(g)+h(y);m<p?(p=m,n=d,f=v<f?v:f):m===p&&v<f&&(f=v,n=d)}return n||r-e},n.prototype._chooseSplitAxis=function(t,e,r){var n=t.leaf?this.compareMinX:u,i=t.leaf?this.compareMinY:l;this._allDistMargin(t,e,r,n)<this._allDistMargin(t,e,r,i)&&t.children.sort(n)},n.prototype._allDistMargin=function(t,e,r,n){t.children.sort(n);for(var i=this.toBBox,o=a(t,0,e,i),u=a(t,r-e,r,i),l=c(o)+c(u),h=e;h<r-e;h++){var p=t.children[h];s(o,t.leaf?i(p):p),l+=c(o)}for(var f=r-e-1;f>=e;f--){var d=t.children[f];s(u,t.leaf?i(d):d),l+=c(u)}return l},n.prototype._adjustParentBBoxes=function(t,e,r){for(var n=r;n>=0;n--)s(e[n],t)},n.prototype._condense=function(t){for(var e=t.length-1,r=void 0;e>=0;e--)0===t[e].children.length?e>0?(r=t[e-1].children).splice(r.indexOf(t[e]),1):this.clear():o(t[e],this.toBBox)},n}()},function(t,e){var r={thin:100,hairline:100,"ultra-light":100,"extra-light":100,light:200,book:300,regular:400,normal:400,plain:400,roman:400,standard:400,medium:500,"semi-bold":600,"demi-bold":600,bold:700,heavy:800,black:800,"extra-bold":800,"ultra-black":900,"extra-black":900,"ultra-bold":900,"heavy-black":900,fat:900,poster:900},n=/(italic|oblique)$/i,i={};t.exports=function(t,e,o){var a=i[t];if(!a){Array.isArray(t)||(t=[t]);for(var s=400,u="normal",l=[],h=0,c=t.length;h<c;++h){var p=t[h].split(" "),f=p[p.length-1].toLowerCase();for(var d in"normal"==f||"italic"==f||"oblique"==f?(u=f,p.pop(),f=p[p.length-1].toLowerCase()):n.test(f)&&(f=f.replace(n,""),u=p[p.length-1].replace(f,"")),r)if(f==d||f==d.replace("-","")||f==d.replace("-"," ")){s=r[d],p.pop();break}"number"==typeof f&&(s=f);var g=p.join(" ").replace("Klokantech Noto Sans","Noto Sans");-1!==g.indexOf(" ")&&(g='"'+g+'"'),l.push(g)}a=i[t]=[u,s,l]}return a[0]+" "+a[1]+" "+e+"px"+(o?"/"+o:"")+" "+a[2]}},function(t,e){e.read=function(t,e,r,n,i){var o,a,s=8*i-n-1,u=(1<<s)-1,l=u>>1,h=-7,c=r?i-1:0,p=r?-1:1,f=t[e+c];for(c+=p,o=f&(1<<-h)-1,f>>=-h,h+=s;h>0;o=256*o+t[e+c],c+=p,h-=8);for(a=o&(1<<-h)-1,o>>=-h,h+=n;h>0;a=256*a+t[e+c],c+=p,h-=8);if(0===o)o=1-l;else{if(o===u)return a?NaN:1/0*(f?-1:1);a+=Math.pow(2,n),o-=l}return(f?-1:1)*a*Math.pow(2,o-n)},e.write=function(t,e,r,n,i,o){var a,s,u,l=8*o-i-1,h=(1<<l)-1,c=h>>1,p=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,f=n?0:o-1,d=n?1:-1,g=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,a=h):(a=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-a))<1&&(a--,u*=2),(e+=a+c>=1?p/u:p*Math.pow(2,1-c))*u>=2&&(a++,u/=2),a+c>=h?(s=0,a=h):a+c>=1?(s=(e*u-1)*Math.pow(2,i),a+=c):(s=e*Math.pow(2,c-1)*Math.pow(2,i),a=0));i>=8;t[r+f]=255&s,f+=d,s/=256,i-=8);for(a=a<<i|s,l+=i;l>0;t[r+f]=255&a,f+=d,a/=256,l-=8);t[r+f-d]|=128*g}},function(t,e){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(t){"object"==typeof window&&(r=window)}t.exports=r},function(t,e,r){"use strict";t.exports=i;var n=r(3);function i(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length}i.Varint=0,i.Fixed64=1,i.Bytes=2,i.Fixed32=5;var o="undefined"==typeof TextDecoder?null:new TextDecoder("utf8");function a(t){return t.type===i.Bytes?t.readVarint()+t.pos:t.pos+1}function s(t,e,r){return r?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function u(t,e,r){var n=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.floor(Math.log(e)/(7*Math.LN2));r.realloc(n);for(var i=r.pos-1;i>=t;i--)r.buf[i+n]=r.buf[i]}function l(t,e){for(var r=0;r<t.length;r++)e.writeVarint(t[r])}function h(t,e){for(var r=0;r<t.length;r++)e.writeSVarint(t[r])}function c(t,e){for(var r=0;r<t.length;r++)e.writeFloat(t[r])}function p(t,e){for(var r=0;r<t.length;r++)e.writeDouble(t[r])}function f(t,e){for(var r=0;r<t.length;r++)e.writeBoolean(t[r])}function d(t,e){for(var r=0;r<t.length;r++)e.writeFixed32(t[r])}function g(t,e){for(var r=0;r<t.length;r++)e.writeSFixed32(t[r])}function y(t,e){for(var r=0;r<t.length;r++)e.writeFixed64(t[r])}function m(t,e){for(var r=0;r<t.length;r++)e.writeSFixed64(t[r])}function v(t,e){return(t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function _(t,e,r){t[r]=e,t[r+1]=e>>>8,t[r+2]=e>>>16,t[r+3]=e>>>24}function b(t,e){return(t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}i.prototype={destroy:function(){this.buf=null},readFields:function(t,e,r){for(r=r||this.length;this.pos<r;){var n=this.readVarint(),i=n>>3,o=this.pos;this.type=7&n,t(i,e,this),this.pos===o&&this.skip(n)}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=v(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=b(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=v(this.buf,this.pos)+4294967296*v(this.buf,this.pos+4);return this.pos+=8,t},readSFixed64:function(){var t=v(this.buf,this.pos)+4294967296*b(this.buf,this.pos+4);return this.pos+=8,t},readFloat:function(){var t=n.read(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=n.read(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,r,n=this.buf;return e=127&(r=n[this.pos++]),r<128?e:(e|=(127&(r=n[this.pos++]))<<7,r<128?e:(e|=(127&(r=n[this.pos++]))<<14,r<128?e:(e|=(127&(r=n[this.pos++]))<<21,r<128?e:function(t,e,r){var n,i,o=r.buf;if(i=o[r.pos++],n=(112&i)>>4,i<128)return s(t,n,e);if(i=o[r.pos++],n|=(127&i)<<3,i<128)return s(t,n,e);if(i=o[r.pos++],n|=(127&i)<<10,i<128)return s(t,n,e);if(i=o[r.pos++],n|=(127&i)<<17,i<128)return s(t,n,e);if(i=o[r.pos++],n|=(127&i)<<24,i<128)return s(t,n,e);if(i=o[r.pos++],n|=(1&i)<<31,i<128)return s(t,n,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(r=n[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=this.pos;return this.pos=t,t-e>=12&&o?function(t,e,r){return o.decode(t.subarray(e,r))}(this.buf,e,t):function(t,e,r){var n="",i=e;for(;i<r;){var o,a,s,u=t[i],l=null,h=u>239?4:u>223?3:u>191?2:1;if(i+h>r)break;1===h?u<128&&(l=u):2===h?128==(192&(o=t[i+1]))&&(l=(31&u)<<6|63&o)<=127&&(l=null):3===h?(o=t[i+1],a=t[i+2],128==(192&o)&&128==(192&a)&&((l=(15&u)<<12|(63&o)<<6|63&a)<=2047||l>=55296&&l<=57343)&&(l=null)):4===h&&(o=t[i+1],a=t[i+2],s=t[i+3],128==(192&o)&&128==(192&a)&&128==(192&s)&&((l=(15&u)<<18|(63&o)<<12|(63&a)<<6|63&s)<=65535||l>=1114112)&&(l=null)),null===l?(l=65533,h=1):l>65535&&(l-=65536,n+=String.fromCharCode(l>>>10&1023|55296),l=56320|1023&l),n+=String.fromCharCode(l),i+=h}return n}(this.buf,e,t)},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){if(this.type!==i.Bytes)return t.push(this.readVarint(e));var r=a(this);for(t=t||[];this.pos<r;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){if(this.type!==i.Bytes)return t.push(this.readSVarint());var e=a(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){if(this.type!==i.Bytes)return t.push(this.readBoolean());var e=a(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){if(this.type!==i.Bytes)return t.push(this.readFloat());var e=a(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){if(this.type!==i.Bytes)return t.push(this.readDouble());var e=a(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){if(this.type!==i.Bytes)return t.push(this.readFixed32());var e=a(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){if(this.type!==i.Bytes)return t.push(this.readSFixed32());var e=a(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){if(this.type!==i.Bytes)return t.push(this.readFixed64());var e=a(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){if(this.type!==i.Bytes)return t.push(this.readSFixed64());var e=a(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===i.Varint)for(;this.buf[this.pos++]>127;);else if(e===i.Bytes)this.pos=this.readVarint()+this.pos;else if(e===i.Fixed32)this.pos+=4;else{if(e!==i.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8}},writeTag:function(t,e){this.writeVarint(t<<3|e)},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var r=new Uint8Array(e);r.set(this.buf),this.buf=r,this.length=e}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),_(this.buf,t,this.pos),this.pos+=4},writeSFixed32:function(t){this.realloc(4),_(this.buf,t,this.pos),this.pos+=4},writeFixed64:function(t){this.realloc(8),_(this.buf,-1&t,this.pos),_(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8},writeSFixed64:function(t){this.realloc(8),_(this.buf,-1&t,this.pos),_(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var r,n;t>=0?(r=t%4294967296|0,n=t/4294967296|0):(n=~(-t/4294967296),4294967295^(r=~(-t%4294967296))?r=r+1|0:(r=0,n=n+1|0));if(t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,r){r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos]=127&t}(r,0,e),function(t,e){var r=(7&t)<<4;if(e.buf[e.pos++]|=r|((t>>>=3)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;e.buf[e.pos++]=127&t}(n,e)}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))))},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t)},writeBoolean:function(t){this.writeVarint(Boolean(t))},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,r){for(var n,i,o=0;o<e.length;o++){if((n=e.charCodeAt(o))>55295&&n<57344){if(!i){n>56319||o+1===e.length?(t[r++]=239,t[r++]=191,t[r++]=189):i=n;continue}if(n<56320){t[r++]=239,t[r++]=191,t[r++]=189,i=n;continue}n=i-55296<<10|n-56320|65536,i=null}else i&&(t[r++]=239,t[r++]=191,t[r++]=189,i=null);n<128?t[r++]=n:(n<2048?t[r++]=n>>6|192:(n<65536?t[r++]=n>>12|224:(t[r++]=n>>18|240,t[r++]=n>>12&63|128),t[r++]=n>>6&63|128),t[r++]=63&n|128)}return r}(this.buf,t,this.pos);var r=this.pos-e;r>=128&&u(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r},writeFloat:function(t){this.realloc(4),n.write(this.buf,t,this.pos,!0,23,4),this.pos+=4},writeDouble:function(t){this.realloc(8),n.write(this.buf,t,this.pos,!0,52,8),this.pos+=8},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var r=0;r<e;r++)this.buf[this.pos++]=t[r]},writeRawMessage:function(t,e){this.pos++;var r=this.pos;t(e,this);var n=this.pos-r;n>=128&&u(r,n,this),this.pos=r-1,this.writeVarint(n),this.pos+=n},writeMessage:function(t,e,r){this.writeTag(t,i.Bytes),this.writeRawMessage(e,r)},writePackedVarint:function(t,e){e.length&&this.writeMessage(t,l,e)},writePackedSVarint:function(t,e){e.length&&this.writeMessage(t,h,e)},writePackedBoolean:function(t,e){e.length&&this.writeMessage(t,f,e)},writePackedFloat:function(t,e){e.length&&this.writeMessage(t,c,e)},writePackedDouble:function(t,e){e.length&&this.writeMessage(t,p,e)},writePackedFixed32:function(t,e){e.length&&this.writeMessage(t,d,e)},writePackedSFixed32:function(t,e){e.length&&this.writeMessage(t,g,e)},writePackedFixed64:function(t,e){e.length&&this.writeMessage(t,y,e)},writePackedSFixed64:function(t,e){e.length&&this.writeMessage(t,m,e)},writeBytesField:function(t,e){this.writeTag(t,i.Bytes),this.writeBytes(e)},writeFixed32Field:function(t,e){this.writeTag(t,i.Fixed32),this.writeFixed32(e)},writeSFixed32Field:function(t,e){this.writeTag(t,i.Fixed32),this.writeSFixed32(e)},writeFixed64Field:function(t,e){this.writeTag(t,i.Fixed64),this.writeFixed64(e)},writeSFixed64Field:function(t,e){this.writeTag(t,i.Fixed64),this.writeSFixed64(e)},writeVarintField:function(t,e){this.writeTag(t,i.Varint),this.writeVarint(e)},writeSVarintField:function(t,e){this.writeTag(t,i.Varint),this.writeSVarint(e)},writeStringField:function(t,e){this.writeTag(t,i.Bytes),this.writeString(e)},writeFloatField:function(t,e){this.writeTag(t,i.Fixed32),this.writeFloat(e)},writeDoubleField:function(t,e){this.writeTag(t,i.Fixed64),this.writeDouble(e)},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e))}}},function(t,e){(function(){var e;t.exports={icon:"icons/google.svg",name:"google",title:"Google Fonts",link:"google.com/fonts",getNames:function(){return e},getLink:function(t){return"https://fonts.google.com/specimen/"+t.replace(/( )/g,"+")},normalizeName:function(t){return t}},e=["ABeeZee","Abel","Abril Fatface","Aclonica","Acme","Actor","Adamina","Advent Pro","Aguafina Script","Akronim","Aladin","Aldrich","Alef","Alegreya","Alegreya SC","Alegreya Sans","Alegreya Sans SC","Alex Brush","Alfa Slab One","Alice","Alike","Alike Angular","Allan","Allerta","Allerta Stencil","Allura","Almendra","Almendra Display","Almendra SC","Amarante","Amaranth","Amatic SC","Amethysta","Amiri","Amita","Anaheim","Andada","Andika","Angkor","Annie Use Your Telescope","Anonymous Pro","Antic","Antic Didone","Antic Slab","Anton","Arapey","Arbutus","Arbutus Slab","Architects Daughter","Archivo Black","Archivo Narrow","Arimo","Arizonia","Armata","Artifika","Arvo","Arya","Asap","Asar","Asset","Astloch","Asul","Atomic Age","Aubrey","Audiowide","Autour One","Average","Average Sans","Averia Gruesa Libre","Averia Libre","Averia Sans Libre","Averia Serif Libre","Bad Script","Balthazar","Bangers","Basic","Battambang","Baumans","Bayon","Belgrano","Belleza","BenchNine","Bentham","Berkshire Swash","Bevan","Bigelow Rules","Bigshot One","Bilbo","Bilbo Swash Caps","Biryani","Bitter","Black Ops One","Bokor","Bonbon","Boogaloo","Bowlby One","Bowlby One SC","Brawler","Bree Serif","Bubblegum Sans","Bubbler One","Buda","Buenard","Butcherman","Butterfly Kids","Cabin","Cabin Condensed","Cabin Sketch","Caesar Dressing","Cagliostro","Calligraffitti","Cambay","Cambo","Candal","Cantarell","Cantata One","Cantora One","Capriola","Cardo","Carme","Carrois Gothic","Carrois Gothic SC","Carter One","Catamaran","Caudex","Caveat","Caveat Brush","Cedarville Cursive","Ceviche One","Changa One","Chango","Chau Philomene One","Chela One","Chelsea Market","Chenla","Cherry Cream Soda","Cherry Swash","Chewy","Chicle","Chivo","Chonburi","Cinzel","Cinzel Decorative","Clicker Script","Coda","Coda Caption","Codystar","Combo","Comfortaa","Coming Soon","Concert One","Condiment","Content","Contrail One","Convergence","Cookie","Copse","Corben","Courgette","Cousine","Coustard","Covered By Your Grace","Crafty Girls","Creepster","Crete Round","Crimson Text","Croissant One","Crushed","Cuprum","Cutive","Cutive Mono","Damion","Dancing Script","Dangrek","Dawning of a New Day","Days One","Dekko","Delius","Delius Swash Caps","Delius Unicase","Della Respira","Denk One","Devonshire","Dhurjati","Didact Gothic","Diplomata","Diplomata SC","Domine","Donegal One","Doppio One","Dorsa","Dosis","Dr Sugiyama","Droid Sans","Droid Sans Mono","Droid Serif","Duru Sans","Dynalight","EB Garamond","Eagle Lake","Eater","Economica","Eczar","Ek Mukta","Electrolize","Elsie","Elsie Swash Caps","Emblema One","Emilys Candy","Engagement","Englebert","Enriqueta","Erica One","Esteban","Euphoria Script","Ewert","Exo","Exo 2","Expletus Sans","Fanwood Text","Fascinate","Fascinate Inline","Faster One","Fasthand","Fauna One","Federant","Federo","Felipa","Fenix","Finger Paint","Fira Mono","Fira Sans","Fjalla One","Fjord One","Flamenco","Flavors","Fondamento","Fontdiner Swanky","Forum","Francois One","Freckle Face","Fredericka the Great","Fredoka One","Freehand","Fresca","Frijole","Fruktur","Fugaz One","GFS Didot","GFS Neohellenic","Gabriela","Gafata","Galdeano","Galindo","Gentium Basic","Gentium Book Basic","Geo","Geostar","Geostar Fill","Germania One","Gidugu","Gilda Display","Give You Glory","Glass Antiqua","Glegoo","Gloria Hallelujah","Goblin One","Gochi Hand","Gorditas","Goudy Bookletter 1911","Graduate","Grand Hotel","Gravitas One","Great Vibes","Griffy","Gruppo","Gudea","Gurajada","Habibi","Halant","Hammersmith One","Hanalei","Hanalei Fill","Handlee","Hanuman","Happy Monkey","Headland One","Henny Penny","Herr Von Muellerhoff","Hind","Hind Siliguri","Hind Vadodara","Holtwood One SC","Homemade Apple","Homenaje","IM Fell DW Pica","IM Fell DW Pica SC","IM Fell Double Pica","IM Fell Double Pica SC","IM Fell English","IM Fell English SC","IM Fell French Canon","IM Fell French Canon SC","IM Fell Great Primer","IM Fell Great Primer SC","Iceberg","Iceland","Imprima","Inconsolata","Inder","Indie Flower","Inika","Inknut Antiqua","Irish Grover","Istok Web","Italiana","Italianno","Itim","Jacques Francois","Jacques Francois Shadow","Jaldi","Jim Nightshade","Jockey One","Jolly Lodger","Josefin Sans","Josefin Slab","Joti One","Judson","Julee","Julius Sans One","Junge","Jura","Just Another Hand","Just Me Again Down Here","Kadwa","Kalam","Kameron","Kantumruy","Karla","Karma","Kaushan Script","Kavoon","Kdam Thmor","Keania One","Kelly Slab","Kenia","Khand","Khmer","Khula","Kite One","Knewave","Kotta One","Koulen","Kranky","Kreon","Kristi","Krona One","Kurale","La Belle Aurore","Laila","Lakki Reddy","Lancelot","Lateef","Lato","League Script","Leckerli One","Ledger","Lekton","Lemon","Libre Baskerville","Life Savers","Lilita One","Lily Script One","Limelight","Linden Hill","Lobster","Lobster Two","Londrina Outline","Londrina Shadow","Londrina Sketch","Londrina Solid","Lora","Love Ya Like A Sister","Loved by the King","Lovers Quarrel","Luckiest Guy","Lusitana","Lustria","Macondo","Macondo Swash Caps","Magra","Maiden Orange","Mako","Mallanna","Mandali","Marcellus","Marcellus SC","Marck Script","Margarine","Marko One","Marmelad","Martel","Martel Sans","Marvel","Mate","Mate SC","Maven Pro","McLaren","Meddon","MedievalSharp","Medula One","Megrim","Meie Script","Merienda","Merienda One","Merriweather","Merriweather Sans","Metal","Metal Mania","Metamorphous","Metrophobic","Michroma","Milonga","Miltonian","Miltonian Tattoo","Miniver","Miss Fajardose","Modak","Modern Antiqua","Molengo","Molle","Monda","Monofett","Monoton","Monsieur La Doulaise","Montaga","Montez","Montserrat","Montserrat Alternates","Montserrat Subrayada","Moul","Moulpali","Mountains of Christmas","Mouse Memoirs","Mr Bedfort","Mr Dafoe","Mr De Haviland","Mrs Saint Delafield","Mrs Sheppards","Muli","Mystery Quest","NTR","Neucha","Neuton","New Rocker","News Cycle","Niconne","Nixie One","Nobile","Nokora","Norican","Nosifer","Nothing You Could Do","Noticia Text","Noto Sans","Noto Serif","Nova Cut","Nova Flat","Nova Mono","Nova Oval","Nova Round","Nova Script","Nova Slim","Nova Square","Numans","Nunito","Odor Mean Chey","Offside","Old Standard TT","Oldenburg","Oleo Script","Oleo Script Swash Caps","Open Sans","Open Sans Condensed","Oranienbaum","Orbitron","Oregano","Orienta","Original Surfer","Oswald","Over the Rainbow","Overlock","Overlock SC","Ovo","Oxygen","Oxygen Mono","PT Mono","PT Sans","PT Sans Caption","PT Sans Narrow","PT Serif","PT Serif Caption","Pacifico","Palanquin","Palanquin Dark","Paprika","Parisienne","Passero One","Passion One","Pathway Gothic One","Patrick Hand","Patrick Hand SC","Patua One","Paytone One","Peddana","Peralta","Permanent Marker","Petit Formal Script","Petrona","Philosopher","Piedra","Pinyon Script","Pirata One","Plaster","Play","Playball","Playfair Display","Playfair Display SC","Podkova","Poiret One","Poller One","Poly","Pompiere","Pontano Sans","Poppins","Port Lligat Sans","Port Lligat Slab","Pragati Narrow","Prata","Preahvihear","Press Start 2P","Princess Sofia","Prociono","Prosto One","Puritan","Purple Purse","Quando","Quantico","Quattrocento","Quattrocento Sans","Questrial","Quicksand","Quintessential","Qwigley","Racing Sans One","Radley","Rajdhani","Raleway","Raleway Dots","Ramabhadra","Ramaraja","Rambla","Rammetto One","Ranchers","Rancho","Ranga","Rationale","Ravi Prakash","Redressed","Reenie Beanie","Revalia","Rhodium Libre","Ribeye","Ribeye Marrow","Righteous","Risque","Roboto","Roboto Condensed","Roboto Mono","Roboto Slab","Rochester","Rock Salt","Rokkitt","Romanesco","Ropa Sans","Rosario","Rosarivo","Rouge Script","Rozha One","Rubik","Rubik Mono One","Rubik One","Ruda","Rufina","Ruge Boogie","Ruluko","Rum Raisin","Ruslan Display","Russo One","Ruthie","Rye","Sacramento","Sahitya","Sail","Salsa","Sanchez","Sancreek","Sansita One","Sarala","Sarina","Sarpanch","Satisfy","Scada","Scheherazade","Schoolbell","Seaweed Script","Sevillana","Seymour One","Shadows Into Light","Shadows Into Light Two","Shanti","Share","Share Tech","Share Tech Mono","Shojumaru","Short Stack","Siemreap","Sigmar One","Signika","Signika Negative","Simonetta","Sintony","Sirin Stencil","Six Caps","Skranji","Slabo 13px","Slabo 27px","Slackey","Smokum","Smythe","Sniglet","Snippet","Snowburst One","Sofadi One","Sofia","Sonsie One","Sorts Mill Goudy","Source Code Pro","Source Sans Pro","Source Serif Pro","Special Elite","Spicy Rice","Spinnaker","Spirax","Squada One","Sree Krushnadevaraya","Stalemate","Stalinist One","Stardos Stencil","Stint Ultra Condensed","Stint Ultra Expanded","Stoke","Strait","Sue Ellen Francisco","Sumana","Sunshiney","Supermercado One","Sura","Suranna","Suravaram","Suwannaphum","Swanky and Moo Moo","Syncopate","Tangerine","Taprom","Tauri","Teko","Telex","Tenali Ramakrishna","Tenor Sans","Text Me One","The Girl Next Door","Tienne","Tillana","Timmana","Tinos","Titan One","Titillium Web","Trade Winds","Trocchi","Trochut","Trykker","Tulpen One","Ubuntu","Ubuntu Condensed","Ubuntu Mono","Ultra","Uncial Antiqua","Underdog","Unica One","UnifrakturCook","UnifrakturMaguntia","Unkempt","Unlock","Unna","VT323","Vampiro One","Varela","Varela Round","Vast Shadow","Vesper Libre","Vibur","Vidaloka","Viga","Voces","Volkhov","Vollkorn","Voltaire","Waiting for the Sunrise","Wallpoet","Walter Turncoat","Warnes","Wellfleet","Wendy One","Wire One","Work Sans","Yanone Kaffeesatz","Yantramanav","Yellowtail","Yeseva One","Yesteryear","Zeyada"]}).call(this)},function(t,e,r){"use strict";(function(t){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
var n=r(8),i=r(3),o=r(9);function a(){return u.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function s(t,e){if(a()<e)throw new RangeError("Invalid typed array length");return u.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e)).__proto__=u.prototype:(null===t&&(t=new u(e)),t.length=e),t}function u(t,e,r){if(!(u.TYPED_ARRAY_SUPPORT||this instanceof u))return new u(t,e,r);if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return c(this,t)}return l(this,t,e,r)}function l(t,e,r,n){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?function(t,e,r,n){if(e.byteLength,r<0||e.byteLength<r)throw new RangeError("'offset' is out of bounds");if(e.byteLength<r+(n||0))throw new RangeError("'length' is out of bounds");e=void 0===r&&void 0===n?new Uint8Array(e):void 0===n?new Uint8Array(e,r):new Uint8Array(e,r,n);u.TYPED_ARRAY_SUPPORT?(t=e).__proto__=u.prototype:t=p(t,e);return t}(t,e,r,n):"string"==typeof e?function(t,e,r){"string"==typeof r&&""!==r||(r="utf8");if(!u.isEncoding(r))throw new TypeError('"encoding" must be a valid string encoding');var n=0|d(e,r),i=(t=s(t,n)).write(e,r);i!==n&&(t=t.slice(0,i));return t}(t,e,r):function(t,e){if(u.isBuffer(e)){var r=0|f(e.length);return 0===(t=s(t,r)).length||e.copy(t,0,0,r),t}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return"number"!=typeof e.length||(n=e.length)!=n?s(t,0):p(t,e);if("Buffer"===e.type&&o(e.data))return p(t,e.data)}var n;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(t,e)}function h(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(t<0)throw new RangeError('"size" argument must not be negative')}function c(t,e){if(h(e),t=s(t,e<0?0:0|f(e)),!u.TYPED_ARRAY_SUPPORT)for(var r=0;r<e;++r)t[r]=0;return t}function p(t,e){var r=e.length<0?0:0|f(e.length);t=s(t,r);for(var n=0;n<r;n+=1)t[n]=255&e[n];return t}function f(t){if(t>=a())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+a().toString(16)+" bytes");return 0|t}function d(t,e){if(u.isBuffer(t))return t.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;"string"!=typeof t&&(t=""+t);var r=t.length;if(0===r)return 0;for(var n=!1;;)switch(e){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return z(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return U(t).length;default:if(n)return z(t).length;e=(""+e).toLowerCase(),n=!0}}function g(t,e,r){var n=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===r||r>this.length)&&(r=this.length),r<=0)return"";if((r>>>=0)<=(e>>>=0))return"";for(t||(t="utf8");;)switch(t){case"hex":return O(this,e,r);case"utf8":case"utf-8":return C(this,e,r);case"ascii":return P(this,e,r);case"latin1":case"binary":return R(this,e,r);case"base64":return E(this,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return I(this,e,r);default:if(n)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),n=!0}}function y(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function m(t,e,r,n,i){if(0===t.length)return-1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),r=+r,isNaN(r)&&(r=i?0:t.length-1),r<0&&(r=t.length+r),r>=t.length){if(i)return-1;r=t.length-1}else if(r<0){if(!i)return-1;r=0}if("string"==typeof e&&(e=u.from(e,n)),u.isBuffer(e))return 0===e.length?-1:v(t,e,r,n,i);if("number"==typeof e)return e&=255,u.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,e,r):Uint8Array.prototype.lastIndexOf.call(t,e,r):v(t,[e],r,n,i);throw new TypeError("val must be string, number or Buffer")}function v(t,e,r,n,i){var o,a=1,s=t.length,u=e.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return-1;a=2,s/=2,u/=2,r/=2}function l(t,e){return 1===a?t[e]:t.readUInt16BE(e*a)}if(i){var h=-1;for(o=r;o<s;o++)if(l(t,o)===l(e,-1===h?0:o-h)){if(-1===h&&(h=o),o-h+1===u)return h*a}else-1!==h&&(o-=o-h),h=-1}else for(r+u>s&&(r=s-u),o=r;o>=0;o--){for(var c=!0,p=0;p<u;p++)if(l(t,o+p)!==l(e,p)){c=!1;break}if(c)return o}return-1}function _(t,e,r,n){r=Number(r)||0;var i=t.length-r;n?(n=Number(n))>i&&(n=i):n=i;var o=e.length;if(o%2!=0)throw new TypeError("Invalid hex string");n>o/2&&(n=o/2);for(var a=0;a<n;++a){var s=parseInt(e.substr(2*a,2),16);if(isNaN(s))return a;t[r+a]=s}return a}function b(t,e,r,n){return B(z(e,t.length-r),t,r,n)}function x(t,e,r,n){return B(function(t){for(var e=[],r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}(e),t,r,n)}function w(t,e,r,n){return x(t,e,r,n)}function S(t,e,r,n){return B(U(e),t,r,n)}function T(t,e,r,n){return B(function(t,e){for(var r,n,i,o=[],a=0;a<t.length&&!((e-=2)<0);++a)r=t.charCodeAt(a),n=r>>8,i=r%256,o.push(i),o.push(n);return o}(e,t.length-r),t,r,n)}function E(t,e,r){return 0===e&&r===t.length?n.fromByteArray(t):n.fromByteArray(t.slice(e,r))}function C(t,e,r){r=Math.min(t.length,r);for(var n=[],i=e;i<r;){var o,a,s,u,l=t[i],h=null,c=l>239?4:l>223?3:l>191?2:1;if(i+c<=r)switch(c){case 1:l<128&&(h=l);break;case 2:128==(192&(o=t[i+1]))&&(u=(31&l)<<6|63&o)>127&&(h=u);break;case 3:o=t[i+1],a=t[i+2],128==(192&o)&&128==(192&a)&&(u=(15&l)<<12|(63&o)<<6|63&a)>2047&&(u<55296||u>57343)&&(h=u);break;case 4:o=t[i+1],a=t[i+2],s=t[i+3],128==(192&o)&&128==(192&a)&&128==(192&s)&&(u=(15&l)<<18|(63&o)<<12|(63&a)<<6|63&s)>65535&&u<1114112&&(h=u)}null===h?(h=65533,c=1):h>65535&&(h-=65536,n.push(h>>>10&1023|55296),h=56320|1023&h),n.push(h),i+=c}return function(t){var e=t.length;if(e<=4096)return String.fromCharCode.apply(String,t);var r="",n=0;for(;n<e;)r+=String.fromCharCode.apply(String,t.slice(n,n+=4096));return r}(n)}e.Buffer=u,e.SlowBuffer=function(t){+t!=t&&(t=0);return u.alloc(+t)},e.INSPECT_MAX_BYTES=50,u.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:function(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&"function"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(t){return!1}}(),e.kMaxLength=a(),u.poolSize=8192,u._augment=function(t){return t.__proto__=u.prototype,t},u.from=function(t,e,r){return l(null,t,e,r)},u.TYPED_ARRAY_SUPPORT&&(u.prototype.__proto__=Uint8Array.prototype,u.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&u[Symbol.species]===u&&Object.defineProperty(u,Symbol.species,{value:null,configurable:!0})),u.alloc=function(t,e,r){return function(t,e,r,n){return h(e),e<=0?s(t,e):void 0!==r?"string"==typeof n?s(t,e).fill(r,n):s(t,e).fill(r):s(t,e)}(null,t,e,r)},u.allocUnsafe=function(t){return c(null,t)},u.allocUnsafeSlow=function(t){return c(null,t)},u.isBuffer=function(t){return!(null==t||!t._isBuffer)},u.compare=function(t,e){if(!u.isBuffer(t)||!u.isBuffer(e))throw new TypeError("Arguments must be Buffers");if(t===e)return 0;for(var r=t.length,n=e.length,i=0,o=Math.min(r,n);i<o;++i)if(t[i]!==e[i]){r=t[i],n=e[i];break}return r<n?-1:n<r?1:0},u.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},u.concat=function(t,e){if(!o(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return u.alloc(0);var r;if(void 0===e)for(e=0,r=0;r<t.length;++r)e+=t[r].length;var n=u.allocUnsafe(e),i=0;for(r=0;r<t.length;++r){var a=t[r];if(!u.isBuffer(a))throw new TypeError('"list" argument must be an Array of Buffers');a.copy(n,i),i+=a.length}return n},u.byteLength=d,u.prototype._isBuffer=!0,u.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)y(this,e,e+1);return this},u.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)y(this,e,e+3),y(this,e+1,e+2);return this},u.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)y(this,e,e+7),y(this,e+1,e+6),y(this,e+2,e+5),y(this,e+3,e+4);return this},u.prototype.toString=function(){var t=0|this.length;return 0===t?"":0===arguments.length?C(this,0,t):g.apply(this,arguments)},u.prototype.equals=function(t){if(!u.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===u.compare(this,t)},u.prototype.inspect=function(){var t="",r=e.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,r).match(/.{2}/g).join(" "),this.length>r&&(t+=" ... ")),"<Buffer "+t+">"},u.prototype.compare=function(t,e,r,n,i){if(!u.isBuffer(t))throw new TypeError("Argument must be a Buffer");if(void 0===e&&(e=0),void 0===r&&(r=t?t.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),e<0||r>t.length||n<0||i>this.length)throw new RangeError("out of range index");if(n>=i&&e>=r)return 0;if(n>=i)return-1;if(e>=r)return 1;if(this===t)return 0;for(var o=(i>>>=0)-(n>>>=0),a=(r>>>=0)-(e>>>=0),s=Math.min(o,a),l=this.slice(n,i),h=t.slice(e,r),c=0;c<s;++c)if(l[c]!==h[c]){o=l[c],a=h[c];break}return o<a?-1:a<o?1:0},u.prototype.includes=function(t,e,r){return-1!==this.indexOf(t,e,r)},u.prototype.indexOf=function(t,e,r){return m(this,t,e,r,!0)},u.prototype.lastIndexOf=function(t,e,r){return m(this,t,e,r,!1)},u.prototype.write=function(t,e,r,n){if(void 0===e)n="utf8",r=this.length,e=0;else if(void 0===r&&"string"==typeof e)n=e,r=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e|=0,isFinite(r)?(r|=0,void 0===n&&(n="utf8")):(n=r,r=void 0)}var i=this.length-e;if((void 0===r||r>i)&&(r=i),t.length>0&&(r<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");for(var o=!1;;)switch(n){case"hex":return _(this,t,e,r);case"utf8":case"utf-8":return b(this,t,e,r);case"ascii":return x(this,t,e,r);case"latin1":case"binary":return w(this,t,e,r);case"base64":return S(this,t,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return T(this,t,e,r);default:if(o)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),o=!0}},u.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function P(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(127&t[i]);return n}function R(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(t[i]);return n}function O(t,e,r){var n=t.length;(!e||e<0)&&(e=0),(!r||r<0||r>n)&&(r=n);for(var i="",o=e;o<r;++o)i+=D(t[o]);return i}function I(t,e,r){for(var n=t.slice(e,r),i="",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function L(t,e,r){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>r)throw new RangeError("Trying to access beyond buffer length")}function M(t,e,r,n,i,o){if(!u.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>i||e<o)throw new RangeError('"value" argument is out of bounds');if(r+n>t.length)throw new RangeError("Index out of range")}function F(t,e,r,n){e<0&&(e=65535+e+1);for(var i=0,o=Math.min(t.length-r,2);i<o;++i)t[r+i]=(e&255<<8*(n?i:1-i))>>>8*(n?i:1-i)}function A(t,e,r,n){e<0&&(e=4294967295+e+1);for(var i=0,o=Math.min(t.length-r,4);i<o;++i)t[r+i]=e>>>8*(n?i:3-i)&255}function k(t,e,r,n,i,o){if(r+n>t.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function N(t,e,r,n,o){return o||k(t,0,r,4),i.write(t,e,r,n,23,4),r+4}function j(t,e,r,n,o){return o||k(t,0,r,8),i.write(t,e,r,n,52,8),r+8}u.prototype.slice=function(t,e){var r,n=this.length;if((t=~~t)<0?(t+=n)<0&&(t=0):t>n&&(t=n),(e=void 0===e?n:~~e)<0?(e+=n)<0&&(e=0):e>n&&(e=n),e<t&&(e=t),u.TYPED_ARRAY_SUPPORT)(r=this.subarray(t,e)).__proto__=u.prototype;else{var i=e-t;r=new u(i,void 0);for(var o=0;o<i;++o)r[o]=this[o+t]}return r},u.prototype.readUIntLE=function(t,e,r){t|=0,e|=0,r||L(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return n},u.prototype.readUIntBE=function(t,e,r){t|=0,e|=0,r||L(t,e,this.length);for(var n=this[t+--e],i=1;e>0&&(i*=256);)n+=this[t+--e]*i;return n},u.prototype.readUInt8=function(t,e){return e||L(t,1,this.length),this[t]},u.prototype.readUInt16LE=function(t,e){return e||L(t,2,this.length),this[t]|this[t+1]<<8},u.prototype.readUInt16BE=function(t,e){return e||L(t,2,this.length),this[t]<<8|this[t+1]},u.prototype.readUInt32LE=function(t,e){return e||L(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},u.prototype.readUInt32BE=function(t,e){return e||L(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},u.prototype.readIntLE=function(t,e,r){t|=0,e|=0,r||L(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return n>=(i*=128)&&(n-=Math.pow(2,8*e)),n},u.prototype.readIntBE=function(t,e,r){t|=0,e|=0,r||L(t,e,this.length);for(var n=e,i=1,o=this[t+--n];n>0&&(i*=256);)o+=this[t+--n]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*e)),o},u.prototype.readInt8=function(t,e){return e||L(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},u.prototype.readInt16LE=function(t,e){e||L(t,2,this.length);var r=this[t]|this[t+1]<<8;return 32768&r?4294901760|r:r},u.prototype.readInt16BE=function(t,e){e||L(t,2,this.length);var r=this[t+1]|this[t]<<8;return 32768&r?4294901760|r:r},u.prototype.readInt32LE=function(t,e){return e||L(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},u.prototype.readInt32BE=function(t,e){return e||L(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},u.prototype.readFloatLE=function(t,e){return e||L(t,4,this.length),i.read(this,t,!0,23,4)},u.prototype.readFloatBE=function(t,e){return e||L(t,4,this.length),i.read(this,t,!1,23,4)},u.prototype.readDoubleLE=function(t,e){return e||L(t,8,this.length),i.read(this,t,!0,52,8)},u.prototype.readDoubleBE=function(t,e){return e||L(t,8,this.length),i.read(this,t,!1,52,8)},u.prototype.writeUIntLE=function(t,e,r,n){(t=+t,e|=0,r|=0,n)||M(this,t,e,r,Math.pow(2,8*r)-1,0);var i=1,o=0;for(this[e]=255&t;++o<r&&(i*=256);)this[e+o]=t/i&255;return e+r},u.prototype.writeUIntBE=function(t,e,r,n){(t=+t,e|=0,r|=0,n)||M(this,t,e,r,Math.pow(2,8*r)-1,0);var i=r-1,o=1;for(this[e+i]=255&t;--i>=0&&(o*=256);)this[e+i]=t/o&255;return e+r},u.prototype.writeUInt8=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,1,255,0),u.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),this[e]=255&t,e+1},u.prototype.writeUInt16LE=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):F(this,t,e,!0),e+2},u.prototype.writeUInt16BE=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):F(this,t,e,!1),e+2},u.prototype.writeUInt32LE=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t):A(this,t,e,!0),e+4},u.prototype.writeUInt32BE=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):A(this,t,e,!1),e+4},u.prototype.writeIntLE=function(t,e,r,n){if(t=+t,e|=0,!n){var i=Math.pow(2,8*r-1);M(this,t,e,r,i-1,-i)}var o=0,a=1,s=0;for(this[e]=255&t;++o<r&&(a*=256);)t<0&&0===s&&0!==this[e+o-1]&&(s=1),this[e+o]=(t/a>>0)-s&255;return e+r},u.prototype.writeIntBE=function(t,e,r,n){if(t=+t,e|=0,!n){var i=Math.pow(2,8*r-1);M(this,t,e,r,i-1,-i)}var o=r-1,a=1,s=0;for(this[e+o]=255&t;--o>=0&&(a*=256);)t<0&&0===s&&0!==this[e+o+1]&&(s=1),this[e+o]=(t/a>>0)-s&255;return e+r},u.prototype.writeInt8=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,1,127,-128),u.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),t<0&&(t=255+t+1),this[e]=255&t,e+1},u.prototype.writeInt16LE=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):F(this,t,e,!0),e+2},u.prototype.writeInt16BE=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):F(this,t,e,!1),e+2},u.prototype.writeInt32LE=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,4,2147483647,-2147483648),u.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24):A(this,t,e,!0),e+4},u.prototype.writeInt32BE=function(t,e,r){return t=+t,e|=0,r||M(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),u.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):A(this,t,e,!1),e+4},u.prototype.writeFloatLE=function(t,e,r){return N(this,t,e,!0,r)},u.prototype.writeFloatBE=function(t,e,r){return N(this,t,e,!1,r)},u.prototype.writeDoubleLE=function(t,e,r){return j(this,t,e,!0,r)},u.prototype.writeDoubleBE=function(t,e,r){return j(this,t,e,!1,r)},u.prototype.copy=function(t,e,r,n){if(r||(r=0),n||0===n||(n=this.length),e>=t.length&&(e=t.length),e||(e=0),n>0&&n<r&&(n=r),n===r)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(r<0||r>=this.length)throw new RangeError("sourceStart out of bounds");if(n<0)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),t.length-e<n-r&&(n=t.length-e+r);var i,o=n-r;if(this===t&&r<e&&e<n)for(i=o-1;i>=0;--i)t[i+e]=this[i+r];else if(o<1e3||!u.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)t[i+e]=this[i+r];else Uint8Array.prototype.set.call(t,this.subarray(r,r+o),e);return o},u.prototype.fill=function(t,e,r,n){if("string"==typeof t){if("string"==typeof e?(n=e,e=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),1===t.length){var i=t.charCodeAt(0);i<256&&(t=i)}if(void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!u.isEncoding(n))throw new TypeError("Unknown encoding: "+n)}else"number"==typeof t&&(t&=255);if(e<0||this.length<e||this.length<r)throw new RangeError("Out of range index");if(r<=e)return this;var o;if(e>>>=0,r=void 0===r?this.length:r>>>0,t||(t=0),"number"==typeof t)for(o=e;o<r;++o)this[o]=t;else{var a=u.isBuffer(t)?t:z(new u(t,n).toString()),s=a.length;for(o=0;o<r-e;++o)this[o+e]=a[o%s]}return this};var G=/[^+\/0-9A-Za-z-_]/g;function D(t){return t<16?"0"+t.toString(16):t.toString(16)}function z(t,e){var r;e=e||1/0;for(var n=t.length,i=null,o=[],a=0;a<n;++a){if((r=t.charCodeAt(a))>55295&&r<57344){if(!i){if(r>56319){(e-=3)>-1&&o.push(239,191,189);continue}if(a+1===n){(e-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(r<56320){(e-=3)>-1&&o.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320)}else i&&(e-=3)>-1&&o.push(239,191,189);if(i=null,r<128){if((e-=1)<0)break;o.push(r)}else if(r<2048){if((e-=2)<0)break;o.push(r>>6|192,63&r|128)}else if(r<65536){if((e-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(r<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return o}function U(t){return n.toByteArray(function(t){if((t=function(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}(t).replace(G,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function B(t,e,r,n){for(var i=0;i<n&&!(i+r>=e.length||i>=t.length);++i)e[i+r]=t[i];return i}}).call(this,r(4))},function(t,e,r){"use strict";e.byteLength=function(t){var e=l(t),r=e[0],n=e[1];return 3*(r+n)/4-n},e.toByteArray=function(t){var e,r,n=l(t),a=n[0],s=n[1],u=new o(function(t,e,r){return 3*(e+r)/4-r}(0,a,s)),h=0,c=s>0?a-4:a;for(r=0;r<c;r+=4)e=i[t.charCodeAt(r)]<<18|i[t.charCodeAt(r+1)]<<12|i[t.charCodeAt(r+2)]<<6|i[t.charCodeAt(r+3)],u[h++]=e>>16&255,u[h++]=e>>8&255,u[h++]=255&e;2===s&&(e=i[t.charCodeAt(r)]<<2|i[t.charCodeAt(r+1)]>>4,u[h++]=255&e);1===s&&(e=i[t.charCodeAt(r)]<<10|i[t.charCodeAt(r+1)]<<4|i[t.charCodeAt(r+2)]>>2,u[h++]=e>>8&255,u[h++]=255&e);return u},e.fromByteArray=function(t){for(var e,r=t.length,i=r%3,o=[],a=0,s=r-i;a<s;a+=16383)o.push(h(t,a,a+16383>s?s:a+16383));1===i?(e=t[r-1],o.push(n[e>>2]+n[e<<4&63]+"==")):2===i&&(e=(t[r-2]<<8)+t[r-1],o.push(n[e>>10]+n[e>>4&63]+n[e<<2&63]+"="));return o.join("")};for(var n=[],i=[],o="undefined"!=typeof Uint8Array?Uint8Array:Array,a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=0,u=a.length;s<u;++s)n[s]=a[s],i[a.charCodeAt(s)]=s;function l(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=t.indexOf("=");return-1===r&&(r=e),[r,r===e?0:4-r%4]}function h(t,e,r){for(var i,o,a=[],s=e;s<r;s+=3)i=(t[s]<<16&16711680)+(t[s+1]<<8&65280)+(255&t[s+2]),a.push(n[(o=i)>>18&63]+n[o>>12&63]+n[o>>6&63]+n[63&o]);return a.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},function(t,e){var r={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==r.call(t)}},function(t,e,r){"use strict";function n(){return function(){throw new Error("Unimplemented abstract method.")}()}r.r(e);var i=0;function o(t){return t.ol_uid||(t.ol_uid=String(++i))}var a,s=(a=function(t,e){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(t,e)},function(t,e){function r(){this.constructor=t}a(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)}),u=function(t){function e(e){var r=this,n="Assertion failed. See https://openlayers.org/en/"+("v"+"6.4.3".split("-")[0])+"/doc/errors/#"+e+" for details.";return(r=t.call(this,n)||this).code=e,r.name="AssertionError",r.message=n,r}return s(e,t),e}(Error);function l(t){t.stopPropagation()}var h=function(){function t(t){this.propagationStopped,this.type=t,this.target=null}return t.prototype.preventDefault=function(){this.propagationStopped=!0},t.prototype.stopPropagation=function(){this.propagationStopped=!0},t}(),c="propertychange",p=function(){function t(){this.disposed=!1}return t.prototype.dispose=function(){this.disposed||(this.disposed=!0,this.disposeInternal())},t.prototype.disposeInternal=function(){},t}();function f(t,e){return t>e?1:t<e?-1:0}function d(t,e){return t.indexOf(e)>=0}function g(t,e,r){var n=t.length;if(t[0]<=e)return 0;if(e<=t[n-1])return n-1;var i=void 0;if(r>0){for(i=1;i<n;++i)if(t[i]<e)return i-1}else if(r<0){for(i=1;i<n;++i)if(t[i]<=e)return i}else for(i=1;i<n;++i){if(t[i]==e)return i;if(t[i]<e)return t[i-1]-e<e-t[i]?i-1:i}return n-1}function y(t,e,r){for(;e<r;){var n=t[e];t[e]=t[r],t[r]=n,++e,--r}}function m(t,e){for(var r=Array.isArray(e)?e:[e],n=r.length,i=0;i<n;i++)t[t.length]=r[i]}function v(t,e){for(var r,n=t.length>>>0,i=0;i<n;i++)if(e(r=t[i],i,t))return r;return null}function _(t,e){var r=t.length;if(r!==e.length)return!1;for(var n=0;n<r;n++)if(t[n]!==e[n])return!1;return!0}function b(t,e){var r;return!t.every((function(n,i){return r=i,!e(n,i,t)}))?r:-1}function x(){return!0}function w(){return!1}function S(){}var T="function"==typeof Object.assign?Object.assign:function(t,e){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var r=Object(t),n=1,i=arguments.length;n<i;++n){var o=arguments[n];if(null!=o)for(var a in o)o.hasOwnProperty(a)&&(r[a]=o[a])}return r};function E(t){for(var e in t)delete t[e]}var C="function"==typeof Object.values?Object.values:function(t){var e=[];for(var r in t)e.push(t[r]);return e};function P(t){var e;for(e in t)return!1;return!e}var R=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),O=function(t){function e(e){var r=t.call(this)||this;return r.eventTarget_=e,r.pendingRemovals_=null,r.dispatching_=null,r.listeners_=null,r}return R(e,t),e.prototype.addEventListener=function(t,e){if(t&&e){var r=this.listeners_||(this.listeners_={}),n=r[t]||(r[t]=[]);-1===n.indexOf(e)&&n.push(e)}},e.prototype.dispatchEvent=function(t){var e="string"==typeof t?new h(t):t,r=e.type;e.target||(e.target=this.eventTarget_||this);var n,i=this.listeners_&&this.listeners_[r];if(i){var o=this.dispatching_||(this.dispatching_={}),a=this.pendingRemovals_||(this.pendingRemovals_={});r in o||(o[r]=0,a[r]=0),++o[r];for(var s=0,u=i.length;s<u;++s)if(!1===(n="handleEvent"in i[s]?i[s].handleEvent(e):i[s].call(this,e))||e.propagationStopped){n=!1;break}if(--o[r],0===o[r]){var l=a[r];for(delete a[r];l--;)this.removeEventListener(r,S);delete o[r]}return n}},e.prototype.disposeInternal=function(){this.listeners_&&E(this.listeners_)},e.prototype.getListeners=function(t){return this.listeners_&&this.listeners_[t]||void 0},e.prototype.hasListener=function(t){return!!this.listeners_&&(t?t in this.listeners_:Object.keys(this.listeners_).length>0)},e.prototype.removeEventListener=function(t,e){var r=this.listeners_&&this.listeners_[t];if(r){var n=r.indexOf(e);-1!==n&&(this.pendingRemovals_&&t in this.pendingRemovals_?(r[n]=S,++this.pendingRemovals_[t]):(r.splice(n,1),0===r.length&&delete this.listeners_[t]))}},e}(p),I="change",L="error",M="clear",F="contextmenu",A="click",k="dblclick",N="dragenter",j="dragover",G="drop",D="keydown",z="keypress",U="load",B="resize",Y="touchmove",V="wheel";function W(t,e,r,n,i){if(n&&n!==t&&(r=r.bind(n)),i){var o=r;r=function(){t.removeEventListener(e,r),o.apply(this,arguments)}}var a={target:t,type:e,listener:r};return t.addEventListener(e,r),a}function q(t,e,r,n){return W(t,e,r,n,!0)}function X(t){t&&t.target&&(t.target.removeEventListener(t.type,t.listener),E(t))}var Z=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function K(t){if(Array.isArray(t))for(var e=0,r=t.length;e<r;++e)X(t[e]);else X(t)}var H=function(t){function e(){var e=t.call(this)||this;return e.revision_=0,e}return Z(e,t),e.prototype.changed=function(){++this.revision_,this.dispatchEvent(I)},e.prototype.getRevision=function(){return this.revision_},e.prototype.on=function(t,e){if(Array.isArray(t)){for(var r=t.length,n=new Array(r),i=0;i<r;++i)n[i]=W(this,t[i],e);return n}return W(this,t,e)},e.prototype.once=function(t,e){var r;if(Array.isArray(t)){var n=t.length;r=new Array(n);for(var i=0;i<n;++i)r[i]=q(this,t[i],e)}else r=q(this,t,e);return e.ol_key=r,r},e.prototype.un=function(t,e){var r=e.ol_key;if(r)K(r);else if(Array.isArray(t))for(var n=0,i=t.length;n<i;++n)this.removeEventListener(t[n],e);else this.removeEventListener(t,e)},e}(O),J=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),$=function(t){function e(e,r,n){var i=t.call(this,e)||this;return i.key=r,i.oldValue=n,i}return J(e,t),e}(h),Q=function(t){function e(e){var r=t.call(this)||this;return o(r),r.values_=null,void 0!==e&&r.setProperties(e),r}return J(e,t),e.prototype.get=function(t){var e;return this.values_&&this.values_.hasOwnProperty(t)&&(e=this.values_[t]),e},e.prototype.getKeys=function(){return this.values_&&Object.keys(this.values_)||[]},e.prototype.getProperties=function(){return this.values_&&T({},this.values_)||{}},e.prototype.hasProperties=function(){return!!this.values_},e.prototype.notify=function(t,e){var r;r=et(t),this.dispatchEvent(new $(r,t,e)),r=c,this.dispatchEvent(new $(r,t,e))},e.prototype.set=function(t,e,r){var n=this.values_||(this.values_={});if(r)n[t]=e;else{var i=n[t];n[t]=e,i!==e&&this.notify(t,i)}},e.prototype.setProperties=function(t,e){for(var r in t)this.set(r,t[r],e)},e.prototype.unset=function(t,e){if(this.values_&&t in this.values_){var r=this.values_[t];delete this.values_[t],P(this.values_)&&(this.values_=null),e||this.notify(t,r)}},e}(H),tt={};function et(t){return tt.hasOwnProperty(t)?tt[t]:tt[t]="change:"+t}var rt=Q,nt="add",it="remove",ot=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),at="length",st=function(t){function e(e,r,n){var i=t.call(this,e)||this;return i.element=r,i.index=n,i}return ot(e,t),e}(h),ut=function(t){function e(e,r){var n=t.call(this)||this,i=r||{};if(n.unique_=!!i.unique,n.array_=e||[],n.unique_)for(var o=0,a=n.array_.length;o<a;++o)n.assertUnique_(n.array_[o],o);return n.updateLength_(),n}return ot(e,t),e.prototype.clear=function(){for(;this.getLength()>0;)this.pop()},e.prototype.extend=function(t){for(var e=0,r=t.length;e<r;++e)this.push(t[e]);return this},e.prototype.forEach=function(t){for(var e=this.array_,r=0,n=e.length;r<n;++r)t(e[r],r,e)},e.prototype.getArray=function(){return this.array_},e.prototype.item=function(t){return this.array_[t]},e.prototype.getLength=function(){return this.get(at)},e.prototype.insertAt=function(t,e){this.unique_&&this.assertUnique_(e),this.array_.splice(t,0,e),this.updateLength_(),this.dispatchEvent(new st(nt,e,t))},e.prototype.pop=function(){return this.removeAt(this.getLength()-1)},e.prototype.push=function(t){this.unique_&&this.assertUnique_(t);var e=this.getLength();return this.insertAt(e,t),this.getLength()},e.prototype.remove=function(t){for(var e=this.array_,r=0,n=e.length;r<n;++r)if(e[r]===t)return this.removeAt(r)},e.prototype.removeAt=function(t){var e=this.array_[t];return this.array_.splice(t,1),this.updateLength_(),this.dispatchEvent(new st(it,e,t)),e},e.prototype.setAt=function(t,e){var r=this.getLength();if(t<r){this.unique_&&this.assertUnique_(e,t);var n=this.array_[t];this.array_[t]=e,this.dispatchEvent(new st(it,n,t)),this.dispatchEvent(new st(nt,e,t))}else{for(var i=r;i<t;++i)this.insertAt(i,void 0);this.insertAt(t,e)}},e.prototype.updateLength_=function(){this.set(at,this.array_.length)},e.prototype.assertUnique_=function(t,e){for(var r=0,n=this.array_.length;r<n;++r)if(this.array_[r]===t&&r!==e)throw new u(58)},e}(rt);function lt(t,e){if(!t)throw new u(e)}var ht=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();var ct=function(t){function e(e){var r=t.call(this)||this;if(r.id_=void 0,r.geometryName_="geometry",r.style_=null,r.styleFunction_=void 0,r.geometryChangeKey_=null,r.addEventListener(et(r.geometryName_),r.handleGeometryChanged_),e)if("function"==typeof e.getSimplifiedGeometry){var n=e;r.setGeometry(n)}else{var i=e;r.setProperties(i)}return r}return ht(e,t),e.prototype.clone=function(){var t=new e(this.hasProperties()?this.getProperties():null);t.setGeometryName(this.getGeometryName());var r=this.getGeometry();r&&t.setGeometry(r.clone());var n=this.getStyle();return n&&t.setStyle(n),t},e.prototype.getGeometry=function(){return this.get(this.geometryName_)},e.prototype.getId=function(){return this.id_},e.prototype.getGeometryName=function(){return this.geometryName_},e.prototype.getStyle=function(){return this.style_},e.prototype.getStyleFunction=function(){return this.styleFunction_},e.prototype.handleGeometryChange_=function(){this.changed()},e.prototype.handleGeometryChanged_=function(){this.geometryChangeKey_&&(X(this.geometryChangeKey_),this.geometryChangeKey_=null);var t=this.getGeometry();t&&(this.geometryChangeKey_=W(t,I,this.handleGeometryChange_,this)),this.changed()},e.prototype.setGeometry=function(t){this.set(this.geometryName_,t)},e.prototype.setStyle=function(t){this.style_=t,this.styleFunction_=t?function(t){if("function"==typeof t)return t;var e;Array.isArray(t)?e=t:(lt("function"==typeof t.getZIndex,41),e=[t]);return function(){return e}}(t):void 0,this.changed()},e.prototype.setId=function(t){this.id_=t,this.changed()},e.prototype.setGeometryName=function(t){this.removeEventListener(et(this.geometryName_),this.handleGeometryChanged_),this.geometryName_=t,this.addEventListener(et(this.geometryName_),this.handleGeometryChanged_),this.handleGeometryChanged_()},e}(rt),pt="XY",ft="XYZ",dt="XYM",gt="XYZM",yt={POINT:"Point",LINE_STRING:"LineString",LINEAR_RING:"LinearRing",POLYGON:"Polygon",MULTI_POINT:"MultiPoint",MULTI_LINE_STRING:"MultiLineString",MULTI_POLYGON:"MultiPolygon",GEOMETRY_COLLECTION:"GeometryCollection",CIRCLE:"Circle"},mt={DEGREES:"degrees",FEET:"ft",METERS:"m",PIXELS:"pixels",TILE_PIXELS:"tile-pixels",USFEET:"us-ft"},vt={};vt[mt.DEGREES]=2*Math.PI*6370997/360,vt[mt.FEET]=.3048,vt[mt.METERS]=1,vt[mt.USFEET]=1200/3937;var _t=mt,bt=new Array(6);function xt(t){return St(t,1,0,0,1,0,0)}function wt(t,e){var r=t[0],n=t[1],i=t[2],o=t[3],a=t[4],s=t[5],u=e[0],l=e[1],h=e[2],c=e[3],p=e[4],f=e[5];return t[0]=r*u+i*l,t[1]=n*u+o*l,t[2]=r*h+i*c,t[3]=n*h+o*c,t[4]=r*p+i*f+a,t[5]=n*p+o*f+s,t}function St(t,e,r,n,i,o,a){return t[0]=e,t[1]=r,t[2]=n,t[3]=i,t[4]=o,t[5]=a,t}function Tt(t,e){var r=e[0],n=e[1];return e[0]=t[0]*r+t[2]*n+t[4],e[1]=t[1]*r+t[3]*n+t[5],e}function Et(t,e,r){return wt(t,St(bt,e,0,0,r,0,0))}function Ct(t,e,r,n,i,o,a,s){var u=Math.sin(o),l=Math.cos(o);return t[0]=n*l,t[1]=i*u,t[2]=-n*u,t[3]=i*l,t[4]=a*n*l-s*n*u+e,t[5]=a*i*u+s*i*l+r,t}function Pt(t,e){var r,n=(r=e)[0]*r[3]-r[1]*r[2];lt(0!==n,32);var i=e[0],o=e[1],a=e[2],s=e[3],u=e[4],l=e[5];return t[0]=s/n,t[1]=-o/n,t[2]=-a/n,t[3]=i/n,t[4]=(a*l-s*u)/n,t[5]=-(i*l-o*u)/n,t}function Rt(t){return"matrix("+t.join(", ")+")"}var Ot="bottom-left",It="bottom-right",Lt="top-left",Mt="top-right",Ft=0,At=1,kt=2,Nt=4,jt=8,Gt=16;function Dt(t){for(var e=Xt(),r=0,n=t.length;r<n;++r)te(e,t[r]);return e}function zt(t,e,r){return r?(r[0]=t[0]-e,r[1]=t[1]-e,r[2]=t[2]+e,r[3]=t[3]+e,r):[t[0]-e,t[1]-e,t[2]+e,t[3]+e]}function Ut(t,e){return e?(e[0]=t[0],e[1]=t[1],e[2]=t[2],e[3]=t[3],e):t.slice()}function Bt(t,e,r){var n,i;return(n=e<t[0]?t[0]-e:t[2]<e?e-t[2]:0)*n+(i=r<t[1]?t[1]-r:t[3]<r?r-t[3]:0)*i}function Yt(t,e){return Wt(t,e[0],e[1])}function Vt(t,e){return t[0]<=e[0]&&e[2]<=t[2]&&t[1]<=e[1]&&e[3]<=t[3]}function Wt(t,e,r){return t[0]<=e&&e<=t[2]&&t[1]<=r&&r<=t[3]}function qt(t,e){var r=t[0],n=t[1],i=t[2],o=t[3],a=e[0],s=e[1],u=Ft;return a<r?u|=Gt:a>i&&(u|=Nt),s<n?u|=jt:s>o&&(u|=kt),u===Ft&&(u=At),u}function Xt(){return[1/0,1/0,-1/0,-1/0]}function Zt(t,e,r,n,i){return i?(i[0]=t,i[1]=e,i[2]=r,i[3]=n,i):[t,e,r,n]}function Kt(t){return Zt(1/0,1/0,-1/0,-1/0,t)}function Ht(t,e){var r=t[0],n=t[1];return Zt(r,n,r,n,e)}function Jt(t,e,r,n,i){return re(Kt(i),t,e,r,n)}function $t(t,e){return t[0]==e[0]&&t[2]==e[2]&&t[1]==e[1]&&t[3]==e[3]}function Qt(t,e){return e[0]<t[0]&&(t[0]=e[0]),e[2]>t[2]&&(t[2]=e[2]),e[1]<t[1]&&(t[1]=e[1]),e[3]>t[3]&&(t[3]=e[3]),t}function te(t,e){e[0]<t[0]&&(t[0]=e[0]),e[0]>t[2]&&(t[2]=e[0]),e[1]<t[1]&&(t[1]=e[1]),e[1]>t[3]&&(t[3]=e[1])}function ee(t,e){for(var r=0,n=e.length;r<n;++r)te(t,e[r]);return t}function re(t,e,r,n,i){for(;r<n;r+=i)ne(t,e[r],e[r+1]);return t}function ne(t,e,r){t[0]=Math.min(t[0],e),t[1]=Math.min(t[1],r),t[2]=Math.max(t[2],e),t[3]=Math.max(t[3],r)}function ie(t,e){var r;return(r=e(ae(t)))||(r=e(se(t)))||(r=e(de(t)))?r:(r=e(fe(t)))||!1}function oe(t){var e=0;return me(t)||(e=ge(t)*ce(t)),e}function ae(t){return[t[0],t[1]]}function se(t){return[t[2],t[1]]}function ue(t){return[(t[0]+t[2])/2,(t[1]+t[3])/2]}function le(t,e){var r;return e===Ot?r=ae(t):e===It?r=se(t):e===Lt?r=fe(t):e===Mt?r=de(t):lt(!1,13),r}function he(t,e,r,n,i){var o=e*n[0]/2,a=e*n[1]/2,s=Math.cos(r),u=Math.sin(r),l=o*s,h=o*u,c=a*s,p=a*u,f=t[0],d=t[1],g=f-l+p,y=f-l-p,m=f+l-p,v=f+l+p,_=d-h-c,b=d-h+c,x=d+h+c,w=d+h-c;return Zt(Math.min(g,y,m,v),Math.min(_,b,x,w),Math.max(g,y,m,v),Math.max(_,b,x,w),i)}function ce(t){return t[3]-t[1]}function pe(t,e,r){var n=r||[1/0,1/0,-1/0,-1/0];return ye(t,e)?(t[0]>e[0]?n[0]=t[0]:n[0]=e[0],t[1]>e[1]?n[1]=t[1]:n[1]=e[1],t[2]<e[2]?n[2]=t[2]:n[2]=e[2],t[3]<e[3]?n[3]=t[3]:n[3]=e[3]):Kt(n),n}function fe(t){return[t[0],t[3]]}function de(t){return[t[2],t[3]]}function ge(t){return t[2]-t[0]}function ye(t,e){return t[0]<=e[2]&&t[2]>=e[0]&&t[1]<=e[3]&&t[3]>=e[1]}function me(t){return t[2]<t[0]||t[3]<t[1]}function ve(t,e){var r=(t[2]-t[0])/2*(e-1),n=(t[3]-t[1])/2*(e-1);t[0]-=r,t[2]+=r,t[1]-=n,t[3]+=n}function _e(t,e,r,n){var i=[];if(n>1)for(var o=t[2]-t[0],a=t[3]-t[1],s=0;s<n;++s)i.push(t[0]+o*s/n,t[1],t[2],t[1]+a*s/n,t[2]-o*s/n,t[3],t[0],t[3]-a*s/n);else i=[t[0],t[1],t[2],t[1],t[2],t[3],t[0],t[3]];e(i,i,2);for(var u=[],l=[],h=(s=0,i.length);s<h;s+=2)u.push(i[s]),l.push(i[s+1]);return function(t,e,r){return Zt(Math.min.apply(null,t),Math.min.apply(null,e),Math.max.apply(null,t),Math.max.apply(null,e),r)}(u,l,r)}function be(t,e){var r=e.getExtent(),n=ue(t);if(e.canWrapX()&&(n[0]<r[0]||n[0]>=r[2])){var i=ge(r),o=Math.floor((n[0]-r[0])/i)*i;t[0]-=o,t[2]-=o}return t}var xe=function(){function t(t){this.code_=t.code,this.units_=t.units,this.extent_=void 0!==t.extent?t.extent:null,this.worldExtent_=void 0!==t.worldExtent?t.worldExtent:null,this.axisOrientation_=void 0!==t.axisOrientation?t.axisOrientation:"enu",this.global_=void 0!==t.global&&t.global,this.canWrapX_=!(!this.global_||!this.extent_),this.getPointResolutionFunc_=t.getPointResolution,this.defaultTileGrid_=null,this.metersPerUnit_=t.metersPerUnit}return t.prototype.canWrapX=function(){return this.canWrapX_},t.prototype.getCode=function(){return this.code_},t.prototype.getExtent=function(){return this.extent_},t.prototype.getUnits=function(){return this.units_},t.prototype.getMetersPerUnit=function(){return this.metersPerUnit_||vt[this.units_]},t.prototype.getWorldExtent=function(){return this.worldExtent_},t.prototype.getAxisOrientation=function(){return this.axisOrientation_},t.prototype.isGlobal=function(){return this.global_},t.prototype.setGlobal=function(t){this.global_=t,this.canWrapX_=!(!t||!this.extent_)},t.prototype.getDefaultTileGrid=function(){return this.defaultTileGrid_},t.prototype.setDefaultTileGrid=function(t){this.defaultTileGrid_=t},t.prototype.setExtent=function(t){this.extent_=t,this.canWrapX_=!(!this.global_||!t)},t.prototype.setWorldExtent=function(t){this.worldExtent_=t},t.prototype.setGetPointResolution=function(t){this.getPointResolutionFunc_=t},t.prototype.getPointResolutionFunc=function(){return this.getPointResolutionFunc_},t}();function we(t,e,r){return Math.min(Math.max(t,e),r)}var Se="cosh"in Math?Math.cosh:function(t){var e=Math.exp(t);return(e+1/e)/2},Te="log2"in Math?Math.log2:function(t){return Math.log(t)*Math.LOG2E};function Ee(t,e,r,n,i,o){var a=i-r,s=o-n;if(0!==a||0!==s){var u=((t-r)*a+(e-n)*s)/(a*a+s*s);u>1?(r=i,n=o):u>0&&(r+=a*u,n+=s*u)}return Ce(t,e,r,n)}function Ce(t,e,r,n){var i=r-t,o=n-e;return i*i+o*o}function Pe(t){return 180*t/Math.PI}function Re(t){return t*Math.PI/180}function Oe(t,e){var r=t%e;return r*e<0?r+e:r}function Ie(t,e,r){return t+r*(e-t)}var Le=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Me=6378137*Math.PI,Fe=[-Me,-Me,Me,Me],Ae=[-180,-85,180,85],ke=function(t){function e(e){return t.call(this,{code:e,units:_t.METERS,extent:Fe,global:!0,worldExtent:Ae,getPointResolution:function(t,e){return t/Se(e[1]/6378137)}})||this}return Le(e,t),e}(xe),Ne=[new ke("EPSG:3857"),new ke("EPSG:102100"),new ke("EPSG:102113"),new ke("EPSG:900913"),new ke("urn:ogc:def:crs:EPSG:6.18:3:3857"),new ke("urn:ogc:def:crs:EPSG::3857"),new ke("http://www.opengis.net/gml/srs/epsg.xml#3857")];function je(t,e,r){var n=t.length,i=r>1?r:2,o=e;void 0===o&&(o=i>2?t.slice():new Array(n));for(var a=Me,s=0;s<n;s+=i){o[s]=a*t[s]/180;var u=6378137*Math.log(Math.tan(Math.PI*(+t[s+1]+90)/360));u>a?u=a:u<-a&&(u=-a),o[s+1]=u}return o}function Ge(t,e,r){var n=t.length,i=r>1?r:2,o=e;void 0===o&&(o=i>2?t.slice():new Array(n));for(var a=0;a<n;a+=i)o[a]=180*t[a]/Me,o[a+1]=360*Math.atan(Math.exp(t[a+1]/6378137))/Math.PI-90;return o}var De=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ze=[-180,-90,180,90],Ue=6378137*Math.PI/180,Be=function(t){function e(e,r){return t.call(this,{code:e,units:_t.DEGREES,extent:ze,axisOrientation:r,global:!0,metersPerUnit:Ue,worldExtent:ze})||this}return De(e,t),e}(xe),Ye=[new Be("CRS:84"),new Be("EPSG:4326","neu"),new Be("urn:ogc:def:crs:EPSG::4326","neu"),new Be("urn:ogc:def:crs:EPSG:6.6:4326","neu"),new Be("urn:ogc:def:crs:OGC:1.3:CRS84"),new Be("urn:ogc:def:crs:OGC:2:84"),new Be("http://www.opengis.net/gml/srs/epsg.xml#4326","neu"),new Be("urn:x-ogc:def:crs:EPSG:4326","neu")],Ve={};var We={};function qe(t,e,r){var n=t.getCode(),i=e.getCode();n in We||(We[n]={}),We[n][i]=r}function Xe(t,e){var r;return t in We&&e in We[t]&&(r=We[t][e]),r}function Ze(t,e,r){var n=r||6371008.8,i=Re(t[1]),o=Re(e[1]),a=(o-i)/2,s=Re(e[0]-t[0])/2,u=Math.sin(a)*Math.sin(a)+Math.sin(s)*Math.sin(s)*Math.cos(i)*Math.cos(o);return 2*n*Math.atan2(Math.sqrt(u),Math.sqrt(1-u))}function Ke(t,e){for(var r=0,n=0,i=t.length;n<i-1;++n)r+=Ze(t[n],t[n+1],e);return r}function He(t,e){for(var r=0,n=t.length,i=t[n-1][0],o=t[n-1][1],a=0;a<n;a++){var s=t[a][0],u=t[a][1];r+=Re(s-i)*(2+Math.sin(Re(o))+Math.sin(Re(u))),i=s,o=u}return r*e*e/2}function Je(t,e,r,n){var i=n||6371008.8,o=Re(t[1]),a=Re(t[0]),s=e/i,u=Math.asin(Math.sin(o)*Math.cos(s)+Math.cos(o)*Math.sin(s)*Math.cos(r));return[Pe(a+Math.atan2(Math.sin(r)*Math.sin(s)*Math.cos(o),Math.cos(s)-Math.sin(o)*Math.sin(u))),Pe(u)]}function $e(t,e,r){var n=void 0!==r?t.toFixed(r):""+t,i=n.indexOf(".");return(i=-1===i?n.length:i)>e?n:new Array(1+e-i).join("0")+n}function Qe(t,e){for(var r=(""+t).split("."),n=(""+e).split("."),i=0;i<Math.max(r.length,n.length);i++){var o=parseInt(r[i]||"0",10),a=parseInt(n[i]||"0",10);if(o>a)return 1;if(a>o)return-1}return 0}function tr(t,e){return t[0]+=+e[0],t[1]+=+e[1],t}function er(t,e){var r,n,i=t[0],o=t[1],a=e[0],s=e[1],u=a[0],l=a[1],h=s[0],c=s[1],p=h-u,f=c-l,d=0===p&&0===f?0:(p*(i-u)+f*(o-l))/(p*p+f*f||0);return d<=0?(r=u,n=l):d>=1?(r=h,n=c):(r=u+d*p,n=l+d*f),[r,n]}function rr(t,e,r){var n=Oe(e+180,360)-180,i=Math.abs(3600*n),o=r||0,a=Math.pow(10,o),s=Math.floor(i/3600),u=Math.floor((i-3600*s)/60),l=i-3600*s-60*u;return(l=Math.ceil(l*a)/a)>=60&&(l=0,u+=1),u>=60&&(u=0,s+=1),s+"° "+$e(u,2)+"′ "+$e(l,2,o)+"″"+(0==n?"":" "+t.charAt(n<0?1:0))}function nr(t,e,r){return t?e.replace("{x}",t[0].toFixed(r)).replace("{y}",t[1].toFixed(r)):""}function ir(t,e){for(var r=!0,n=t.length-1;n>=0;--n)if(t[n]!=e[n]){r=!1;break}return r}function or(t,e){var r=Math.cos(e),n=Math.sin(e),i=t[0]*r-t[1]*n,o=t[1]*r+t[0]*n;return t[0]=i,t[1]=o,t}function ar(t,e){return t[0]*=e,t[1]*=e,t}function sr(t,e){var r=t[0]-e[0],n=t[1]-e[1];return r*r+n*n}function ur(t,e){return Math.sqrt(sr(t,e))}function lr(t,e){return sr(t,er(t,e))}function hr(t,e){return nr(t,"{x}, {y}",e)}function cr(t,e){if(e.canWrapX()){var r=ge(e.getExtent()),n=pr(t,e,r);n&&(t[0]-=n*r)}return t}function pr(t,e,r){var n=e.getExtent(),i=0;if(e.canWrapX()&&(t[0]<n[0]||t[0]>n[2])){var o=r||ge(n);i=Math.floor((t[0]-n[0])/o)}return i}function fr(t,e,r){var n;if(void 0!==e){for(var i=0,o=t.length;i<o;++i)e[i]=t[i];n=e}else n=t.slice();return n}function dr(t,e,r){if(void 0!==e&&t!==e){for(var n=0,i=t.length;n<i;++n)e[n]=t[n];t=e}return t}function gr(t){!function(t,e){Ve[t]=e}(t.getCode(),t),qe(t,t,fr)}function yr(t){return"string"==typeof t?Ve[t]||null:t||null}function mr(t,e,r,n){var i,o=(t=yr(t)).getPointResolutionFunc();if(o)i=o(e,r),n&&n!==t.getUnits()&&(a=t.getMetersPerUnit())&&(i=i*a/vt[n]);else if(t.getUnits()==_t.DEGREES&&!n||n==_t.DEGREES)i=e;else{var a,s=Tr(t,yr("EPSG:4326")),u=[r[0]-e/2,r[1],r[0]+e/2,r[1],r[0],r[1]-e/2,r[0],r[1]+e/2];i=(Ze((u=s(u,u,2)).slice(0,2),u.slice(2,4))+Ze(u.slice(4,6),u.slice(6,8)))/2,void 0!==(a=n?vt[n]:t.getMetersPerUnit())&&(i/=a)}return i}function vr(t){!function(t){t.forEach(gr)}(t),t.forEach((function(e){t.forEach((function(t){e!==t&&qe(e,t,fr)}))}))}function _r(t,e){return t?"string"==typeof t?yr(t):t:yr(e)}function br(t){return function(e,r,n){for(var i=e.length,o=void 0!==n?n:2,a=void 0!==r?r:new Array(i),s=0;s<i;s+=o){var u=t([e[s],e[s+1]]);a[s]=u[0],a[s+1]=u[1];for(var l=o-1;l>=2;--l)a[s+l]=e[s+l]}return a}}function xr(t,e,r,n){var i=yr(t),o=yr(e);qe(i,o,br(r)),qe(o,i,br(n))}function wr(t,e){return Cr(t,"EPSG:4326",void 0!==e?e:"EPSG:3857")}function Sr(t,e){if(t===e)return!0;var r=t.getUnits()===e.getUnits();return(t.getCode()===e.getCode()||Tr(t,e)===fr)&&r}function Tr(t,e){var r=Xe(t.getCode(),e.getCode());return r||(r=dr),r}function Er(t,e){return Tr(yr(t),yr(e))}function Cr(t,e,r){return Er(e,r)(t,void 0,t.length)}function Pr(t,e,r,n){return _e(t,Er(e,r),void 0,n)}var Rr,Or,Ir,Lr=null;function Mr(){return Lr}function Fr(t,e){return Lr?Cr(t,e,Lr):t}function Ar(t,e){return Lr?Cr(t,Lr,e):t}function kr(t,e){return Lr?Pr(t,e,Lr):t}function Nr(t,e){return Lr?Pr(t,Lr,e):t}function jr(t,e,r){return function(n){var i,o,a=n[0],s=n[1];if(t.canWrapX()){var u=t.getExtent(),l=ge(u);(o=pr(n,t,l))&&(a-=o*l),a=we(a,u[0],u[2]),s=we(s,u[1],u[3]),i=r([a,s])}else i=r(n);return o&&e.canWrapX()&&(i[0]+=o*ge(e.getExtent())),i}}function Gr(t,e,r,n,i,o){for(var a=o||[],s=0,u=e;u<r;u+=n){var l=t[u],h=t[u+1];a[s++]=i[0]*l+i[2]*h+i[4],a[s++]=i[1]*l+i[3]*h+i[5]}return o&&a.length!=s&&(a.length=s),a}function Dr(t,e,r,n,i,o,a){for(var s=a||[],u=Math.cos(i),l=Math.sin(i),h=o[0],c=o[1],p=0,f=e;f<r;f+=n){var d=t[f]-h,g=t[f+1]-c;s[p++]=h+d*u-g*l,s[p++]=c+d*l+g*u;for(var y=f+2;y<f+n;++y)s[p++]=t[y]}return a&&s.length!=p&&(s.length=p),s}function zr(t,e,r,n,i,o,a){for(var s=a||[],u=0,l=e;l<r;l+=n){s[u++]=t[l]+i,s[u++]=t[l+1]+o;for(var h=l+2;h<l+n;++h)s[u++]=t[h]}return a&&s.length!=u&&(s.length=u),s}vr(Ne),vr(Ye),Rr=Ne,Or=je,Ir=Ge,Ye.forEach((function(t){Rr.forEach((function(e){qe(t,e,Or),qe(e,t,Ir)}))}));var Ur=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Br=[1,0,0,1,0,0],Yr=function(t){function e(){var e,r,n,i,o,a=t.call(this)||this;return a.extent_=[1/0,1/0,-1/0,-1/0],a.extentRevision_=-1,a.simplifiedGeometryMaxMinSquaredTolerance=0,a.simplifiedGeometryRevision=0,a.simplifyTransformedInternal=(e=function(t,e,r){if(!r)return this.getSimplifiedGeometry(e);var n=this.clone();return n.applyTransform(r),n.getSimplifiedGeometry(e)},o=!1,function(){var t=Array.prototype.slice.call(arguments);return o&&this===i&&_(t,n)||(o=!0,i=this,n=t,r=e.apply(this,arguments)),r}),a}return Ur(e,t),e.prototype.simplifyTransformed=function(t,e){return this.simplifyTransformedInternal(this.getRevision(),t,e)},e.prototype.clone=function(){return n()},e.prototype.closestPointXY=function(t,e,r,i){return n()},e.prototype.containsXY=function(t,e){var r=this.getClosestPoint([t,e]);return r[0]===t&&r[1]===e},e.prototype.getClosestPoint=function(t,e){var r=e||[NaN,NaN];return this.closestPointXY(t[0],t[1],r,1/0),r},e.prototype.intersectsCoordinate=function(t){return this.containsXY(t[0],t[1])},e.prototype.computeExtent=function(t){return n()},e.prototype.getExtent=function(t){if(this.extentRevision_!=this.getRevision()){var e=this.computeExtent(this.extent_);(isNaN(e[0])||isNaN(e[1]))&&Kt(e),this.extentRevision_=this.getRevision()}return function(t,e){return e?(e[0]=t[0],e[1]=t[1],e[2]=t[2],e[3]=t[3],e):t}(this.extent_,t)},e.prototype.rotate=function(t,e){n()},e.prototype.scale=function(t,e,r){n()},e.prototype.simplify=function(t){return this.getSimplifiedGeometry(t*t)},e.prototype.getSimplifiedGeometry=function(t){return n()},e.prototype.getType=function(){return n()},e.prototype.applyTransform=function(t){n()},e.prototype.intersectsExtent=function(t){return n()},e.prototype.translate=function(t,e){n()},e.prototype.transform=function(t,e){var r=yr(t),n=r.getUnits()==_t.TILE_PIXELS?function(t,n,i){var o=r.getExtent(),a=r.getWorldExtent(),s=ce(a)/ce(o);return Ct(Br,a[0],a[3],s,-s,0,0,0),Gr(t,0,t.length,i,Br,n),Er(r,e)(t,n,i)}:Er(r,e);return this.applyTransform(n),this},e}(rt),Vr=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Wr(t){var e;return t==pt?e=2:t==ft||t==dt?e=3:t==gt&&(e=4),e}var qr=function(t){function e(){var e=t.call(this)||this;return e.layout=pt,e.stride=2,e.flatCoordinates=null,e}return Vr(e,t),e.prototype.computeExtent=function(t){return Jt(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,t)},e.prototype.getCoordinates=function(){return n()},e.prototype.getFirstCoordinate=function(){return this.flatCoordinates.slice(0,this.stride)},e.prototype.getFlatCoordinates=function(){return this.flatCoordinates},e.prototype.getLastCoordinate=function(){return this.flatCoordinates.slice(this.flatCoordinates.length-this.stride)},e.prototype.getLayout=function(){return this.layout},e.prototype.getSimplifiedGeometry=function(t){if(this.simplifiedGeometryRevision!==this.getRevision()&&(this.simplifiedGeometryMaxMinSquaredTolerance=0,this.simplifiedGeometryRevision=this.getRevision()),t<0||0!==this.simplifiedGeometryMaxMinSquaredTolerance&&t<=this.simplifiedGeometryMaxMinSquaredTolerance)return this;var e=this.getSimplifiedGeometryInternal(t);return e.getFlatCoordinates().length<this.flatCoordinates.length?e:(this.simplifiedGeometryMaxMinSquaredTolerance=t,this)},e.prototype.getSimplifiedGeometryInternal=function(t){return this},e.prototype.getStride=function(){return this.stride},e.prototype.setFlatCoordinates=function(t,e){this.stride=Wr(t),this.layout=t,this.flatCoordinates=e},e.prototype.setCoordinates=function(t,e){n()},e.prototype.setLayout=function(t,e,r){var n;if(t)n=Wr(t);else{for(var i=0;i<r;++i){if(0===e.length)return this.layout=pt,void(this.stride=2);e=e[0]}t=function(t){var e;2==t?e=pt:3==t?e=ft:4==t&&(e=gt);return e}(n=e.length)}this.layout=t,this.stride=n},e.prototype.applyTransform=function(t){this.flatCoordinates&&(t(this.flatCoordinates,this.flatCoordinates,this.stride),this.changed())},e.prototype.rotate=function(t,e){var r=this.getFlatCoordinates();if(r){var n=this.getStride();Dr(r,0,r.length,n,t,e,r),this.changed()}},e.prototype.scale=function(t,e,r){var n=e;void 0===n&&(n=t);var i=r;i||(i=ue(this.getExtent()));var o=this.getFlatCoordinates();if(o){var a=this.getStride();!function(t,e,r,n,i,o,a,s){for(var u=s||[],l=a[0],h=a[1],c=0,p=e;p<r;p+=n){var f=t[p]-l,d=t[p+1]-h;u[c++]=l+i*f,u[c++]=h+o*d;for(var g=p+2;g<p+n;++g)u[c++]=t[g]}s&&u.length!=c&&(u.length=c)}(o,0,o.length,a,t,n,i,o),this.changed()}},e.prototype.translate=function(t,e){var r=this.getFlatCoordinates();if(r){var n=this.getStride();zr(r,0,r.length,n,t,e,r),this.changed()}},e}(Yr);function Xr(t,e,r,n,i,o,a){var s,u=t[e],l=t[e+1],h=t[r]-u,c=t[r+1]-l;if(0===h&&0===c)s=e;else{var p=((i-u)*h+(o-l)*c)/(h*h+c*c);if(p>1)s=r;else{if(p>0){for(var f=0;f<n;++f)a[f]=Ie(t[e+f],t[r+f],p);return void(a.length=n)}s=e}}for(f=0;f<n;++f)a[f]=t[s+f];a.length=n}function Zr(t,e,r,n,i){var o=t[e],a=t[e+1];for(e+=n;e<r;e+=n){var s=t[e],u=t[e+1],l=Ce(o,a,s,u);l>i&&(i=l),o=s,a=u}return i}function Kr(t,e,r,n,i){for(var o=0,a=r.length;o<a;++o){var s=r[o];i=Zr(t,e,s,n,i),e=s}return i}function Hr(t,e,r,n,i,o,a,s,u,l,h){if(e==r)return l;var c,p;if(0===i){if((p=Ce(a,s,t[e],t[e+1]))<l){for(c=0;c<n;++c)u[c]=t[e+c];return u.length=n,p}return l}for(var f=h||[NaN,NaN],d=e+n;d<r;)if(Xr(t,d-n,d,n,a,s,f),(p=Ce(a,s,f[0],f[1]))<l){for(l=p,c=0;c<n;++c)u[c]=f[c];u.length=n,d+=n}else d+=n*Math.max((Math.sqrt(p)-Math.sqrt(l))/i|0,1);if(o&&(Xr(t,r-n,e,n,a,s,f),(p=Ce(a,s,f[0],f[1]))<l)){for(l=p,c=0;c<n;++c)u[c]=f[c];u.length=n}return l}function Jr(t,e,r,n,i,o,a,s,u,l,h){for(var c=h||[NaN,NaN],p=0,f=r.length;p<f;++p){var d=r[p];l=Hr(t,e,d,n,i,o,a,s,u,l,c),e=d}return l}function $r(t,e,r,n){for(var i=0,o=r.length;i<o;++i)t[e++]=r[i];return e}function Qr(t,e,r,n){for(var i=0,o=r.length;i<o;++i)for(var a=r[i],s=0;s<n;++s)t[e++]=a[s];return e}function tn(t,e,r,n,i){for(var o=i||[],a=0,s=0,u=r.length;s<u;++s){var l=Qr(t,e,r[s],n);o[a++]=l,e=l}return o.length=a,o}function en(t,e,r,n,i,o,a){var s=(r-e)/n;if(s<3){for(;e<r;e+=n)o[a++]=t[e],o[a++]=t[e+1];return a}var u=new Array(s);u[0]=1,u[s-1]=1;for(var l=[e,r-n],h=0;l.length>0;){for(var c=l.pop(),p=l.pop(),f=0,d=t[p],g=t[p+1],y=t[c],m=t[c+1],v=p+n;v<c;v+=n){var _=Ee(t[v],t[v+1],d,g,y,m);_>f&&(h=v,f=_)}f>i&&(u[(h-e)/n]=1,p+n<h&&l.push(p,h),h+n<c&&l.push(h,c))}for(v=0;v<s;++v)u[v]&&(o[a++]=t[e+v*n],o[a++]=t[e+v*n+1]);return a}function rn(t,e,r,n,i,o,a,s){for(var u=0,l=r.length;u<l;++u){var h=r[u];a=en(t,e,h,n,i,o,a),s.push(a),e=h}return a}function nn(t,e){return e*Math.round(t/e)}function on(t,e,r,n,i,o,a){if(e==r)return a;var s,u,l=nn(t[e],i),h=nn(t[e+1],i);e+=n,o[a++]=l,o[a++]=h;do{if(s=nn(t[e],i),u=nn(t[e+1],i),(e+=n)==r)return o[a++]=s,o[a++]=u,a}while(s==l&&u==h);for(;e<r;){var c=nn(t[e],i),p=nn(t[e+1],i);if(e+=n,c!=s||p!=u){var f=s-l,d=u-h,g=c-l,y=p-h;f*y==d*g&&(f<0&&g<f||f==g||f>0&&g>f)&&(d<0&&y<d||d==y||d>0&&y>d)?(s=c,u=p):(o[a++]=s,o[a++]=u,l=s,h=u,s=c,u=p)}}return o[a++]=s,o[a++]=u,a}function an(t,e,r,n,i,o,a,s){for(var u=0,l=r.length;u<l;++u){var h=r[u];a=on(t,e,h,n,i,o,a),s.push(a),e=h}return a}function sn(t,e,r,n,i){for(var o=void 0!==i?i:[],a=0,s=e;s<r;s+=n)o[a++]=t.slice(s,s+n);return o.length=a,o}function un(t,e,r,n,i){for(var o=void 0!==i?i:[],a=0,s=0,u=r.length;s<u;++s){var l=r[s];o[a++]=sn(t,e,l,n,o[a]),e=l}return o.length=a,o}function ln(t,e,r,n,i){for(var o=void 0!==i?i:[],a=0,s=0,u=r.length;s<u;++s){var l=r[s];o[a++]=un(t,e,l,n,o[a]),e=l[l.length-1]}return o.length=a,o}function hn(t,e,r,n){for(var i=0,o=t[r-n],a=t[r-n+1];e<r;e+=n){var s=t[e],u=t[e+1];i+=a*s-o*u,o=s,a=u}return i/2}function cn(t,e,r,n){for(var i=0,o=0,a=r.length;o<a;++o){var s=r[o];i+=hn(t,e,s,n),e=s}return i}var pn=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),fn=function(t){function e(e,r){var n=t.call(this)||this;return n.maxDelta_=-1,n.maxDeltaRevision_=-1,void 0===r||Array.isArray(e[0])?n.setCoordinates(e,r):n.setFlatCoordinates(r,e),n}return pn(e,t),e.prototype.clone=function(){return new e(this.flatCoordinates.slice(),this.layout)},e.prototype.closestPointXY=function(t,e,r,n){return n<Bt(this.getExtent(),t,e)?n:(this.maxDeltaRevision_!=this.getRevision()&&(this.maxDelta_=Math.sqrt(Zr(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,0)),this.maxDeltaRevision_=this.getRevision()),Hr(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,this.maxDelta_,!0,t,e,r,n))},e.prototype.getArea=function(){return hn(this.flatCoordinates,0,this.flatCoordinates.length,this.stride)},e.prototype.getCoordinates=function(){return sn(this.flatCoordinates,0,this.flatCoordinates.length,this.stride)},e.prototype.getSimplifiedGeometryInternal=function(t){var r=[];return r.length=en(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,t,r,0),new e(r,pt)},e.prototype.getType=function(){return yt.LINEAR_RING},e.prototype.intersectsExtent=function(t){return!1},e.prototype.setCoordinates=function(t,e){this.setLayout(e,t,1),this.flatCoordinates||(this.flatCoordinates=[]),this.flatCoordinates.length=Qr(this.flatCoordinates,0,t,this.stride),this.changed()},e}(qr),dn=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),gn=function(t){function e(e,r){var n=t.call(this)||this;return n.setCoordinates(e,r),n}return dn(e,t),e.prototype.clone=function(){return new e(this.flatCoordinates.slice(),this.layout)},e.prototype.closestPointXY=function(t,e,r,n){var i=this.flatCoordinates,o=Ce(t,e,i[0],i[1]);if(o<n){for(var a=this.stride,s=0;s<a;++s)r[s]=i[s];return r.length=a,o}return n},e.prototype.getCoordinates=function(){return this.flatCoordinates?this.flatCoordinates.slice():[]},e.prototype.computeExtent=function(t){return Ht(this.flatCoordinates,t)},e.prototype.getType=function(){return yt.POINT},e.prototype.intersectsExtent=function(t){return Wt(t,this.flatCoordinates[0],this.flatCoordinates[1])},e.prototype.setCoordinates=function(t,e){this.setLayout(e,t,0),this.flatCoordinates||(this.flatCoordinates=[]),this.flatCoordinates.length=$r(this.flatCoordinates,0,t,this.stride),this.changed()},e}(qr);function yn(t,e,r,n,i){return!ie(i,(function(i){return!mn(t,e,r,n,i[0],i[1])}))}function mn(t,e,r,n,i,o){for(var a=0,s=t[r-n],u=t[r-n+1];e<r;e+=n){var l=t[e],h=t[e+1];u<=o?h>o&&(l-s)*(o-u)-(i-s)*(h-u)>0&&a++:h<=o&&(l-s)*(o-u)-(i-s)*(h-u)<0&&a--,s=l,u=h}return 0!==a}function vn(t,e,r,n,i,o){if(0===r.length)return!1;if(!mn(t,e,r[0],n,i,o))return!1;for(var a=1,s=r.length;a<s;++a)if(mn(t,r[a-1],r[a],n,i,o))return!1;return!0}function _n(t,e,r,n,i,o,a){for(var s,u,l,h,c,p,d,g=i[o+1],y=[],m=0,v=r.length;m<v;++m){var _=r[m];for(h=t[_-n],p=t[_-n+1],s=e;s<_;s+=n)c=t[s],d=t[s+1],(g<=p&&d<=g||p<=g&&g<=d)&&(l=(g-p)/(d-p)*(c-h)+h,y.push(l)),h=c,p=d}var b=NaN,x=-1/0;for(y.sort(f),h=y[0],s=1,u=y.length;s<u;++s){c=y[s];var w=Math.abs(c-h);w>x&&vn(t,e,r,n,l=(h+c)/2,g)&&(b=l,x=w),h=c}return isNaN(b)&&(b=i[o]),a?(a.push(b,g,x),a):[b,g,x]}function bn(t,e,r,n,i){for(var o=[],a=0,s=r.length;a<s;++a){var u=r[a];o=_n(t,e,u,n,i,2*a,o),e=u[u.length-1]}return o}function xn(t,e,r,n,i){for(var o,a=[t[e],t[e+1]],s=[];e+n<r;e+=n){if(s[0]=t[e+n],s[1]=t[e+n+1],o=i(a,s))return o;a[0]=s[0],a[1]=s[1]}return!1}function wn(t,e,r,n,i){var o=re([1/0,1/0,-1/0,-1/0],t,e,r,n);return!!ye(i,o)&&(!!Vt(i,o)||(o[0]>=i[0]&&o[2]<=i[2]||(o[1]>=i[1]&&o[3]<=i[3]||xn(t,e,r,n,(function(t,e){return function(t,e,r){var n=!1,i=qt(t,e),o=qt(t,r);if(i===At||o===At)n=!0;else{var a=t[0],s=t[1],u=t[2],l=t[3],h=e[0],c=e[1],p=r[0],f=r[1],d=(f-c)/(p-h),g=void 0,y=void 0;o&kt&&!(i&kt)&&(n=(g=p-(f-l)/d)>=a&&g<=u),n||!(o&Nt)||i&Nt||(n=(y=f-(p-u)*d)>=s&&y<=l),n||!(o&jt)||i&jt||(n=(g=p-(f-s)/d)>=a&&g<=u),n||!(o&Gt)||i&Gt||(n=(y=f-(p-a)*d)>=s&&y<=l)}return n}(i,t,e)})))))}function Sn(t,e,r,n,i){if(!function(t,e,r,n,i){return!!wn(t,e,r,n,i)||(!!mn(t,e,r,n,i[0],i[1])||(!!mn(t,e,r,n,i[0],i[3])||(!!mn(t,e,r,n,i[2],i[1])||!!mn(t,e,r,n,i[2],i[3]))))}(t,e,r[0],n,i))return!1;if(1===r.length)return!0;for(var o=1,a=r.length;o<a;++o)if(yn(t,r[o-1],r[o],n,i)&&!wn(t,r[o-1],r[o],n,i))return!1;return!0}function Tn(t,e,r,n){for(;e<r-n;){for(var i=0;i<n;++i){var o=t[e+i];t[e+i]=t[r-n+i],t[r-n+i]=o}e+=n,r-=n}}function En(t,e,r,n){for(var i=!0,o=0;o<n;++o)if(t[e+o]!==t[r-n+o]){i=!1;break}i&&(r-=n);var a=function(t,e,r,n){for(var i=-1,o=1/0,a=1/0,s=e;s<r;s+=n){var u=t[s],l=t[s+1];l>o||(l==o&&u>=a||(i=s,o=l,a=u))}return i}(t,e,r,n),s=a-n;s<e&&(s=r-n);var u=a+n;u>=r&&(u=e);var l=t[s],h=t[s+1],c=t[a],p=t[a+1],f=t[u],d=t[u+1];return c*d+l*p+h*f-(h*c+p*f+l*d)<0}function Cn(t,e,r,n,i){for(var o=void 0!==i&&i,a=0,s=r.length;a<s;++a){var u=r[a],l=En(t,e,u,n);if(0===a){if(o&&l||!o&&!l)return!1}else if(o&&!l||!o&&l)return!1;e=u}return!0}function Pn(t,e,r,n,i){for(var o=void 0!==i&&i,a=0,s=r.length;a<s;++a){var u=r[a],l=En(t,e,u,n);(0===a?o&&l||!o&&!l:o&&!l||!o&&l)&&Tn(t,e,u,n),e=u}return e}function Rn(t,e,r,n,i){for(var o=0,a=r.length;o<a;++o)e=Pn(t,e,r[o],n,i);return e}var On=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),In=function(t){function e(e,r,n){var i=t.call(this)||this;return i.ends_=[],i.flatInteriorPointRevision_=-1,i.flatInteriorPoint_=null,i.maxDelta_=-1,i.maxDeltaRevision_=-1,i.orientedRevision_=-1,i.orientedFlatCoordinates_=null,void 0!==r&&n?(i.setFlatCoordinates(r,e),i.ends_=n):i.setCoordinates(e,r),i}return On(e,t),e.prototype.appendLinearRing=function(t){this.flatCoordinates?m(this.flatCoordinates,t.getFlatCoordinates()):this.flatCoordinates=t.getFlatCoordinates().slice(),this.ends_.push(this.flatCoordinates.length),this.changed()},e.prototype.clone=function(){return new e(this.flatCoordinates.slice(),this.layout,this.ends_.slice())},e.prototype.closestPointXY=function(t,e,r,n){return n<Bt(this.getExtent(),t,e)?n:(this.maxDeltaRevision_!=this.getRevision()&&(this.maxDelta_=Math.sqrt(Kr(this.flatCoordinates,0,this.ends_,this.stride,0)),this.maxDeltaRevision_=this.getRevision()),Jr(this.flatCoordinates,0,this.ends_,this.stride,this.maxDelta_,!0,t,e,r,n))},e.prototype.containsXY=function(t,e){return vn(this.getOrientedFlatCoordinates(),0,this.ends_,this.stride,t,e)},e.prototype.getArea=function(){return cn(this.getOrientedFlatCoordinates(),0,this.ends_,this.stride)},e.prototype.getCoordinates=function(t){var e;return void 0!==t?Pn(e=this.getOrientedFlatCoordinates().slice(),0,this.ends_,this.stride,t):e=this.flatCoordinates,un(e,0,this.ends_,this.stride)},e.prototype.getEnds=function(){return this.ends_},e.prototype.getFlatInteriorPoint=function(){if(this.flatInteriorPointRevision_!=this.getRevision()){var t=ue(this.getExtent());this.flatInteriorPoint_=_n(this.getOrientedFlatCoordinates(),0,this.ends_,this.stride,t,0),this.flatInteriorPointRevision_=this.getRevision()}return this.flatInteriorPoint_},e.prototype.getInteriorPoint=function(){return new gn(this.getFlatInteriorPoint(),dt)},e.prototype.getLinearRingCount=function(){return this.ends_.length},e.prototype.getLinearRing=function(t){return t<0||this.ends_.length<=t?null:new fn(this.flatCoordinates.slice(0===t?0:this.ends_[t-1],this.ends_[t]),this.layout)},e.prototype.getLinearRings=function(){for(var t=this.layout,e=this.flatCoordinates,r=this.ends_,n=[],i=0,o=0,a=r.length;o<a;++o){var s=r[o],u=new fn(e.slice(i,s),t);n.push(u),i=s}return n},e.prototype.getOrientedFlatCoordinates=function(){if(this.orientedRevision_!=this.getRevision()){var t=this.flatCoordinates;Cn(t,0,this.ends_,this.stride)?this.orientedFlatCoordinates_=t:(this.orientedFlatCoordinates_=t.slice(),this.orientedFlatCoordinates_.length=Pn(this.orientedFlatCoordinates_,0,this.ends_,this.stride)),this.orientedRevision_=this.getRevision()}return this.orientedFlatCoordinates_},e.prototype.getSimplifiedGeometryInternal=function(t){var r=[],n=[];return r.length=an(this.flatCoordinates,0,this.ends_,this.stride,Math.sqrt(t),r,0,n),new e(r,pt,n)},e.prototype.getType=function(){return yt.POLYGON},e.prototype.intersectsExtent=function(t){return Sn(this.getOrientedFlatCoordinates(),0,this.ends_,this.stride,t)},e.prototype.setCoordinates=function(t,e){this.setLayout(e,t,2),this.flatCoordinates||(this.flatCoordinates=[]);var r=tn(this.flatCoordinates,0,t,this.stride,this.ends_);this.flatCoordinates.length=0===r.length?0:r[r.length-1],this.changed()},e}(qr),Ln=In;function Mn(t,e,r,n){for(var i=r||32,o=[],a=0;a<i;++a)m(o,Je(t,e,2*Math.PI*a/i,n));return o.push(o[0],o[1]),new In(o,pt,[o.length])}function Fn(t){var e=t[0],r=t[1],n=t[2],i=t[3],o=[e,r,e,i,n,i,n,r,e,r];return new In(o,pt,[o.length])}function An(t,e,r){for(var n=e||32,i=t.getStride(),o=t.getLayout(),a=t.getCenter(),s=i*(n+1),u=new Array(s),l=0;l<s;l+=i){u[l]=0,u[l+1]=0;for(var h=2;h<i;h++)u[l+h]=a[h]}var c=[u.length],p=new In(u,o,c);return kn(p,a,t.getRadius(),r),p}function kn(t,e,r,n){for(var i=t.getFlatCoordinates(),o=t.getStride(),a=i.length/o-1,s=n||0,u=0;u<=a;++u){var l=u*o,h=s+2*Oe(u,a)*Math.PI/a;i[l]=e[0]+r*Math.cos(h),i[l+1]=e[1]+r*Math.sin(h)}t.changed()}var Nn=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),jn="accuracy",Gn="accuracyGeometry",Dn="altitude",zn="altitudeAccuracy",Un="heading",Bn="position",Yn="projection",Vn="speed",Wn="tracking",qn="trackingOptions",Xn=function(t){function e(e){var r=t.call(this,L)||this;return r.code=e.code,r.message=e.message,r}return Nn(e,t),e}(h),Zn=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.position_=null,r.transform_=dr,r.watchId_=void 0,r.addEventListener(et(Yn),r.handleProjectionChanged_),r.addEventListener(et(Wn),r.handleTrackingChanged_),void 0!==n.projection&&r.setProjection(n.projection),void 0!==n.trackingOptions&&r.setTrackingOptions(n.trackingOptions),r.setTracking(void 0!==n.tracking&&n.tracking),r}return Nn(e,t),e.prototype.disposeInternal=function(){this.setTracking(!1),t.prototype.disposeInternal.call(this)},e.prototype.handleProjectionChanged_=function(){var t=this.getProjection();t&&(this.transform_=Tr(yr("EPSG:4326"),t),this.position_&&this.set(Bn,this.transform_(this.position_)))},e.prototype.handleTrackingChanged_=function(){if("geolocation"in navigator){var t=this.getTracking();t&&void 0===this.watchId_?this.watchId_=navigator.geolocation.watchPosition(this.positionChange_.bind(this),this.positionError_.bind(this),this.getTrackingOptions()):t||void 0===this.watchId_||(navigator.geolocation.clearWatch(this.watchId_),this.watchId_=void 0)}},e.prototype.positionChange_=function(t){var e=t.coords;this.set(jn,e.accuracy),this.set(Dn,null===e.altitude?void 0:e.altitude),this.set(zn,null===e.altitudeAccuracy?void 0:e.altitudeAccuracy),this.set(Un,null===e.heading?void 0:Re(e.heading)),this.position_?(this.position_[0]=e.longitude,this.position_[1]=e.latitude):this.position_=[e.longitude,e.latitude];var r=this.transform_(this.position_);this.set(Bn,r),this.set(Vn,null===e.speed?void 0:e.speed);var n=Mn(this.position_,e.accuracy);n.applyTransform(this.transform_),this.set(Gn,n),this.changed()},e.prototype.positionError_=function(t){this.dispatchEvent(new Xn(t))},e.prototype.getAccuracy=function(){return this.get(jn)},e.prototype.getAccuracyGeometry=function(){return this.get(Gn)||null},e.prototype.getAltitude=function(){return this.get(Dn)},e.prototype.getAltitudeAccuracy=function(){return this.get(zn)},e.prototype.getHeading=function(){return this.get(Un)},e.prototype.getPosition=function(){return this.get(Bn)},e.prototype.getProjection=function(){return this.get(Yn)},e.prototype.getSpeed=function(){return this.get(Vn)},e.prototype.getTracking=function(){return this.get(Wn)},e.prototype.getTrackingOptions=function(){return this.get(qn)},e.prototype.setProjection=function(t){this.set(Yn,yr(t))},e.prototype.setTracking=function(t){this.set(Wn,t)},e.prototype.setTrackingOptions=function(t){this.set(qn,t)},e}(rt),Kn=function(){function t(t,e,r){this.decay_=t,this.minVelocity_=e,this.delay_=r,this.points_=[],this.angle_=0,this.initialVelocity_=0}return t.prototype.begin=function(){this.points_.length=0,this.angle_=0,this.initialVelocity_=0},t.prototype.update=function(t,e){this.points_.push(t,e,Date.now())},t.prototype.end=function(){if(this.points_.length<6)return!1;var t=Date.now()-this.delay_,e=this.points_.length-3;if(this.points_[e+2]<t)return!1;for(var r=e-3;r>0&&this.points_[r+2]>t;)r-=3;var n=this.points_[e+2]-this.points_[r+2];if(n<1e3/60)return!1;var i=this.points_[e]-this.points_[r],o=this.points_[e+1]-this.points_[r+1];return this.angle_=Math.atan2(o,i),this.initialVelocity_=Math.sqrt(i*i+o*o)/n,this.initialVelocity_>this.minVelocity_},t.prototype.getDistance=function(){return(this.minVelocity_-this.initialVelocity_)/this.decay_},t.prototype.getAngle=function(){return this.angle_},t}(),Hn=/^#([a-f0-9]{3}|[a-f0-9]{4}(?:[a-f0-9]{2}){0,2})$/i,Jn=/^([a-z]*)$|^hsla?\(.*\)$/i;function $n(t){return"string"==typeof t?t:oi(t)}function Qn(t){var e=document.createElement("div");if(e.style.color=t,""!==e.style.color){document.body.appendChild(e);var r=getComputedStyle(e).color;return document.body.removeChild(e),r}return""}var ti,ei,ri=(ti={},ei=0,function(t){var e;if(ti.hasOwnProperty(t))e=ti[t];else{if(ei>=1024){var r=0;for(var n in ti)0==(3&r++)&&(delete ti[n],--ei)}e=function(t){var e,r,n,i,o;if(Jn.exec(t)&&(t=Qn(t)),Hn.exec(t)){var a=t.length-1,s=void 0;s=a<=4?1:2;var u=4===a||8===a;e=parseInt(t.substr(1+0*s,s),16),r=parseInt(t.substr(1+1*s,s),16),n=parseInt(t.substr(1+2*s,s),16),i=u?parseInt(t.substr(1+3*s,s),16):255,1==s&&(e=(e<<4)+e,r=(r<<4)+r,n=(n<<4)+n,u&&(i=(i<<4)+i)),o=[e,r,n,i/255]}else 0==t.indexOf("rgba(")?ii(o=t.slice(5,-1).split(",").map(Number)):0==t.indexOf("rgb(")?((o=t.slice(4,-1).split(",").map(Number)).push(1),ii(o)):lt(!1,14);return o}(t),ti[t]=e,++ei}return e});function ni(t){return Array.isArray(t)?t:ri(t)}function ii(t){return t[0]=we(t[0]+.5|0,0,255),t[1]=we(t[1]+.5|0,0,255),t[2]=we(t[2]+.5|0,0,255),t[3]=we(t[3],0,1),t}function oi(t){var e=t[0];e!=(0|e)&&(e=e+.5|0);var r=t[1];r!=(0|r)&&(r=r+.5|0);var n=t[2];return n!=(0|n)&&(n=n+.5|0),"rgba("+e+","+r+","+n+","+(void 0===t[3]?1:t[3])+")"}var ai=function(){function t(){this.cache_={},this.cacheSize_=0,this.maxCacheSize_=32}return t.prototype.clear=function(){this.cache_={},this.cacheSize_=0},t.prototype.canExpireCache=function(){return this.cacheSize_>this.maxCacheSize_},t.prototype.expire=function(){if(this.canExpireCache()){var t=0;for(var e in this.cache_){var r=this.cache_[e];0!=(3&t++)||r.hasListener()||(delete this.cache_[e],--this.cacheSize_)}}},t.prototype.get=function(t,e,r){var n=si(t,e,r);return n in this.cache_?this.cache_[n]:null},t.prototype.set=function(t,e,r,n){var i=si(t,e,r);this.cache_[i]=n,++this.cacheSize_},t.prototype.setSize=function(t){this.maxCacheSize_=t,this.expire()},t}();function si(t,e,r){return e+":"+t+":"+(r?$n(r):"null")}var ui=new ai,li="opacity",hi="visible",ci="extent",pi="zIndex",fi="maxResolution",di="minResolution",gi="maxZoom",yi="minZoom",mi="source",vi=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),_i=function(t){function e(e){var r=t.call(this)||this,n=T({},e);return n[li]=void 0!==e.opacity?e.opacity:1,lt("number"==typeof n[li],64),n[hi]=void 0===e.visible||e.visible,n[pi]=e.zIndex,n[fi]=void 0!==e.maxResolution?e.maxResolution:1/0,n[di]=void 0!==e.minResolution?e.minResolution:0,n[yi]=void 0!==e.minZoom?e.minZoom:-1/0,n[gi]=void 0!==e.maxZoom?e.maxZoom:1/0,r.className_=void 0!==n.className?e.className:"ol-layer",delete n.className,r.setProperties(n),r.state_=null,r}return vi(e,t),e.prototype.getClassName=function(){return this.className_},e.prototype.getLayerState=function(t){var e=this.state_||{layer:this,managed:void 0===t||t},r=this.getZIndex();return e.opacity=we(Math.round(100*this.getOpacity())/100,0,1),e.sourceState=this.getSourceState(),e.visible=this.getVisible(),e.extent=this.getExtent(),e.zIndex=void 0!==r?r:!1===e.managed?1/0:0,e.maxResolution=this.getMaxResolution(),e.minResolution=Math.max(this.getMinResolution(),0),e.minZoom=this.getMinZoom(),e.maxZoom=this.getMaxZoom(),this.state_=e,e},e.prototype.getLayersArray=function(t){return n()},e.prototype.getLayerStatesArray=function(t){return n()},e.prototype.getExtent=function(){return this.get(ci)},e.prototype.getMaxResolution=function(){return this.get(fi)},e.prototype.getMinResolution=function(){return this.get(di)},e.prototype.getMinZoom=function(){return this.get(yi)},e.prototype.getMaxZoom=function(){return this.get(gi)},e.prototype.getOpacity=function(){return this.get(li)},e.prototype.getSourceState=function(){return n()},e.prototype.getVisible=function(){return this.get(hi)},e.prototype.getZIndex=function(){return this.get(pi)},e.prototype.setExtent=function(t){this.set(ci,t)},e.prototype.setMaxResolution=function(t){this.set(fi,t)},e.prototype.setMinResolution=function(t){this.set(di,t)},e.prototype.setMaxZoom=function(t){this.set(gi,t)},e.prototype.setMinZoom=function(t){this.set(yi,t)},e.prototype.setOpacity=function(t){lt("number"==typeof t,64),this.set(li,t)},e.prototype.setVisible=function(t){this.set(hi,t)},e.prototype.setZIndex=function(t){this.set(pi,t)},e.prototype.disposeInternal=function(){this.state_&&(this.state_.layer=null,this.state_=null),t.prototype.disposeInternal.call(this)},e}(rt),bi="prerender",xi="postrender",wi="precompose",Si="postcompose",Ti="rendercomplete",Ei="undefined",Ci="loading",Pi="ready",Ri="error",Oi=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Ii(t,e){if(!t.visible)return!1;var r=e.resolution;if(r<t.minResolution||r>=t.maxResolution)return!1;var n=e.zoom;return n>t.minZoom&&n<=t.maxZoom}var Li=function(t){function e(e){var r=this,n=T({},e);delete n.source,(r=t.call(this,n)||this).mapPrecomposeKey_=null,r.mapRenderKey_=null,r.sourceChangeKey_=null,r.renderer_=null,e.render&&(r.render=e.render),e.map&&r.setMap(e.map),r.addEventListener(et(mi),r.handleSourcePropertyChange_);var i=e.source?e.source:null;return r.setSource(i),r}return Oi(e,t),e.prototype.getLayersArray=function(t){var e=t||[];return e.push(this),e},e.prototype.getLayerStatesArray=function(t){var e=t||[];return e.push(this.getLayerState()),e},e.prototype.getSource=function(){return this.get(mi)||null},e.prototype.getSourceState=function(){var t=this.getSource();return t?t.getState():Ei},e.prototype.handleSourceChange_=function(){this.changed()},e.prototype.handleSourcePropertyChange_=function(){this.sourceChangeKey_&&(X(this.sourceChangeKey_),this.sourceChangeKey_=null);var t=this.getSource();t&&(this.sourceChangeKey_=W(t,I,this.handleSourceChange_,this)),this.changed()},e.prototype.getFeatures=function(t){return this.renderer_.getFeatures(t)},e.prototype.render=function(t,e){var r=this.getRenderer();if(r.prepareFrame(t))return r.renderFrame(t,e)},e.prototype.setMap=function(t){this.mapPrecomposeKey_&&(X(this.mapPrecomposeKey_),this.mapPrecomposeKey_=null),t||this.changed(),this.mapRenderKey_&&(X(this.mapRenderKey_),this.mapRenderKey_=null),t&&(this.mapPrecomposeKey_=W(t,wi,(function(t){var e=t.frameState.layerStatesArray,r=this.getLayerState(!1);lt(!e.some((function(t){return t.layer===r.layer})),67),e.push(r)}),this),this.mapRenderKey_=W(this,I,t.render,t),this.changed())},e.prototype.setSource=function(t){this.set(mi,t)},e.prototype.getRenderer=function(){return this.renderer_||(this.renderer_=this.createRenderer()),this.renderer_},e.prototype.hasRenderer=function(){return!!this.renderer_},e.prototype.createRenderer=function(){return null},e.prototype.disposeInternal=function(){this.setSource(null),t.prototype.disposeInternal.call(this)},e}(_i),Mi=function(){function t(){}return t.prototype.drawCustom=function(t,e,r){},t.prototype.drawGeometry=function(t){},t.prototype.setStyle=function(t){},t.prototype.drawCircle=function(t,e){},t.prototype.drawFeature=function(t,e){},t.prototype.drawGeometryCollection=function(t,e){},t.prototype.drawLineString=function(t,e){},t.prototype.drawMultiLineString=function(t,e){},t.prototype.drawMultiPoint=function(t,e){},t.prototype.drawMultiPolygon=function(t,e){},t.prototype.drawPoint=function(t,e){},t.prototype.drawPolygon=function(t,e){},t.prototype.drawText=function(t,e){},t.prototype.setFillStrokeStyle=function(t,e){},t.prototype.setImageStyle=function(t,e){},t.prototype.setTextStyle=function(t,e){},t}();function Fi(t){return Array.isArray(t)?oi(t):t}var Ai="undefined"!=typeof navigator&&void 0!==navigator.userAgent?navigator.userAgent.toLowerCase():"",ki=-1!==Ai.indexOf("firefox"),Ni=(-1!==Ai.indexOf("safari")&&Ai.indexOf("chrom"),-1!==Ai.indexOf("webkit")&&-1==Ai.indexOf("edge")),ji=-1!==Ai.indexOf("macintosh"),Gi="undefined"!=typeof devicePixelRatio?devicePixelRatio:1,Di="undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof OffscreenCanvas&&self instanceof WorkerGlobalScope,zi="undefined"!=typeof Image&&Image.prototype.decode,Ui=function(){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("_",null,e),window.removeEventListener("_",null,e)}catch(t){}return t}();function Bi(t,e,r){var n=r&&r.length?r.shift():Di?new OffscreenCanvas(t||300,e||300):document.createElement("canvas");return t&&(n.width=t),e&&(n.height=e),n.getContext("2d")}function Yi(t){var e=t.offsetWidth,r=getComputedStyle(t);return e+=parseInt(r.marginLeft,10)+parseInt(r.marginRight,10)}function Vi(t){var e=t.offsetHeight,r=getComputedStyle(t);return e+=parseInt(r.marginTop,10)+parseInt(r.marginBottom,10)}function Wi(t,e){var r=e.parentNode;r&&r.replaceChild(t,e)}function qi(t){return t&&t.parentNode?t.parentNode.removeChild(t):null}function Xi(t){for(;t.lastChild;)t.removeChild(t.lastChild)}var Zi=new RegExp(["^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)","(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)","(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)","(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?","(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))","(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))","?\\s*([-,\\\"\\'\\sa-z]+?)\\s*$"].join(""),"i"),Ki=["style","variant","weight","size","lineHeight","family"],Hi=function(t){var e=t.match(Zi);if(!e)return null;for(var r={lineHeight:"normal",size:"1.2em",style:"normal",weight:"normal",variant:"normal"},n=0,i=Ki.length;n<i;++n){var o=e[n+1];void 0!==o&&(r[Ki[n]]=o)}return r.families=r.family.split(/,\s?/),r},Ji=[],$i=[0,0,0,0],Qi=new rt,to=new O;to.setSize=function(){console.warn("labelCache is deprecated.")};var eo,ro,no,io=null,oo={},ao=function(){var t,e,r=["monospace","serif"],n=r.length,i="wmytzilWMYTZIL@#/&?$%10";function o(t,o,a){for(var s=!0,u=0;u<n;++u){var l=r[u];if(e=lo(t+" "+o+" 32px "+l,i),a!=l){var h=lo(t+" "+o+" 32px "+a+","+l,i);s=s&&h!=e}}return!!s}function a(){for(var e=!0,r=Qi.getKeys(),n=0,i=r.length;n<i;++n){var a=r[n];Qi.get(a)<100&&(o.apply(this,a.split("\n"))?(E(oo),io=null,eo=void 0,Qi.set(a,100)):(Qi.set(a,Qi.get(a)+1,!0),e=!1))}e&&(clearInterval(t),t=void 0)}return function(e){var r=Hi(e);if(r)for(var n=r.families,i=0,s=n.length;i<s;++i){var u=n[i],l=r.style+"\n"+r.weight+"\n"+u;void 0===Qi.get(l)&&(Qi.set(l,100,!0),o(r.style,r.weight,u)||(Qi.set(l,0,!0),void 0===t&&(t=setInterval(a,32))))}}}(),so=(no=oo,function(t){var e=no[t];if(null==e)if(Di){var r=Hi(t),n=uo(t,"Žg"),i=isNaN(Number(r.lineHeight))?1.2:Number(r.lineHeight);oo[t]=i*(n.actualBoundingBoxAscent+n.actualBoundingBoxDescent)}else ro||((ro=document.createElement("div")).innerHTML="M",ro.style.margin="0 !important",ro.style.padding="0 !important",ro.style.position="absolute !important",ro.style.left="-99999px !important"),ro.style.font=t,document.body.appendChild(ro),e=ro.offsetHeight,no[t]=e,document.body.removeChild(ro);return e});function uo(t,e){return io||(io=Bi(1,1)),t!=eo&&(io.font=t,eo=io.font),io.measureText(e)}function lo(t,e){return uo(t,e).width}function ho(t,e,r){if(e in r)return r[e];var n=lo(t,e);return r[e]=n,n}function co(t,e,r,n){0!==e&&(t.translate(r,n),t.rotate(e),t.translate(-r,-n))}function po(t,e,r,n,i,o,a,s,u,l,h){t.save(),1!==r&&(t.globalAlpha*=r),e&&t.setTransform.apply(t,e),n.contextInstructions?(t.translate(u,l),t.scale(h[0],h[1]),function(t,e){for(var r=t.contextInstructions,n=0,i=r.length;n<i;n+=2)Array.isArray(r[n+1])?e[r[n]].apply(e,r[n+1]):e[r[n]]=r[n+1]}(n,t)):h[0]<0||h[1]<0?(t.translate(u,l),t.scale(h[0],h[1]),t.drawImage(n,i,o,a,s,0,0,a,s)):t.drawImage(n,i,o,a,s,u,l,a*h[0],s*h[1]),t.restore()}var fo=null;function go(t){return Di?Rt(t):(fo||(fo=Bi(1,1).canvas),fo.style.transform=Rt(t),fo.style.transform)}var yo=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),mo=function(t){function e(e,r,n,i,o,a,s){var u=t.call(this)||this;return u.context_=e,u.pixelRatio_=r,u.extent_=n,u.transform_=i,u.viewRotation_=o,u.squaredTolerance_=a,u.userTransform_=s,u.contextFillState_=null,u.contextStrokeState_=null,u.contextTextState_=null,u.fillState_=null,u.strokeState_=null,u.image_=null,u.imageAnchorX_=0,u.imageAnchorY_=0,u.imageHeight_=0,u.imageOpacity_=0,u.imageOriginX_=0,u.imageOriginY_=0,u.imageRotateWithView_=!1,u.imageRotation_=0,u.imageScale_=[0,0],u.imageWidth_=0,u.text_="",u.textOffsetX_=0,u.textOffsetY_=0,u.textRotateWithView_=!1,u.textRotation_=0,u.textScale_=[0,0],u.textFillState_=null,u.textStrokeState_=null,u.textState_=null,u.pixelCoordinates_=[],u.tmpLocalTransform_=[1,0,0,1,0,0],u}return yo(e,t),e.prototype.drawImages_=function(t,e,r,n){if(this.image_){var i=Gr(t,e,r,2,this.transform_,this.pixelCoordinates_),o=this.context_,a=this.tmpLocalTransform_,s=o.globalAlpha;1!=this.imageOpacity_&&(o.globalAlpha=s*this.imageOpacity_);var u=this.imageRotation_;this.imageRotateWithView_&&(u+=this.viewRotation_);for(var l=0,h=i.length;l<h;l+=2){var c=i[l]-this.imageAnchorX_,p=i[l+1]-this.imageAnchorY_;if(0!==u||1!=this.imageScale_[0]||1!=this.imageScale_[1]){var f=c+this.imageAnchorX_,d=p+this.imageAnchorY_;Ct(a,f,d,1,1,u,-f,-d),o.setTransform.apply(o,a),o.translate(f,d),o.scale(this.imageScale_[0],this.imageScale_[1]),o.drawImage(this.image_,this.imageOriginX_,this.imageOriginY_,this.imageWidth_,this.imageHeight_,-this.imageAnchorX_,-this.imageAnchorY_,this.imageWidth_,this.imageHeight_),o.setTransform(1,0,0,1,0,0)}else o.drawImage(this.image_,this.imageOriginX_,this.imageOriginY_,this.imageWidth_,this.imageHeight_,c,p,this.imageWidth_,this.imageHeight_)}1!=this.imageOpacity_&&(o.globalAlpha=s)}},e.prototype.drawText_=function(t,e,r,n){if(this.textState_&&""!==this.text_){this.textFillState_&&this.setContextFillState_(this.textFillState_),this.textStrokeState_&&this.setContextStrokeState_(this.textStrokeState_),this.setContextTextState_(this.textState_);var i=Gr(t,e,r,n,this.transform_,this.pixelCoordinates_),o=this.context_,a=this.textRotation_;for(this.textRotateWithView_&&(a+=this.viewRotation_);e<r;e+=n){var s=i[e]+this.textOffsetX_,u=i[e+1]+this.textOffsetY_;if(0!==a||1!=this.textScale_[0]||1!=this.textScale_[1]){var l=Ct(this.tmpLocalTransform_,s,u,1,1,a,-s,-u);o.setTransform.apply(o,l),o.translate(s,u),o.scale(this.textScale_[0],this.textScale_[1]),this.textStrokeState_&&o.strokeText(this.text_,0,0),this.textFillState_&&o.fillText(this.text_,0,0),o.setTransform(1,0,0,1,0,0)}else this.textStrokeState_&&o.strokeText(this.text_,s,u),this.textFillState_&&o.fillText(this.text_,s,u)}}},e.prototype.moveToLineTo_=function(t,e,r,n,i){var o=this.context_,a=Gr(t,e,r,n,this.transform_,this.pixelCoordinates_);o.moveTo(a[0],a[1]);var s=a.length;i&&(s-=2);for(var u=2;u<s;u+=2)o.lineTo(a[u],a[u+1]);return i&&o.closePath(),r},e.prototype.drawRings_=function(t,e,r,n){for(var i=0,o=r.length;i<o;++i)e=this.moveToLineTo_(t,e,r[i],n,!0);return e},e.prototype.drawCircle=function(t){if(ye(this.extent_,t.getExtent())){if(this.fillState_||this.strokeState_){this.fillState_&&this.setContextFillState_(this.fillState_),this.strokeState_&&this.setContextStrokeState_(this.strokeState_);var e=function(t,e,r){var n=t.getFlatCoordinates();if(n){var i=t.getStride();return Gr(n,0,n.length,i,e,r)}return null}(t,this.transform_,this.pixelCoordinates_),r=e[2]-e[0],n=e[3]-e[1],i=Math.sqrt(r*r+n*n),o=this.context_;o.beginPath(),o.arc(e[0],e[1],i,0,2*Math.PI),this.fillState_&&o.fill(),this.strokeState_&&o.stroke()}""!==this.text_&&this.drawText_(t.getCenter(),0,2,2)}},e.prototype.setStyle=function(t){this.setFillStrokeStyle(t.getFill(),t.getStroke()),this.setImageStyle(t.getImage()),this.setTextStyle(t.getText())},e.prototype.setTransform=function(t){this.transform_=t},e.prototype.drawGeometry=function(t){switch(t.getType()){case yt.POINT:this.drawPoint(t);break;case yt.LINE_STRING:this.drawLineString(t);break;case yt.POLYGON:this.drawPolygon(t);break;case yt.MULTI_POINT:this.drawMultiPoint(t);break;case yt.MULTI_LINE_STRING:this.drawMultiLineString(t);break;case yt.MULTI_POLYGON:this.drawMultiPolygon(t);break;case yt.GEOMETRY_COLLECTION:this.drawGeometryCollection(t);break;case yt.CIRCLE:this.drawCircle(t)}},e.prototype.drawFeature=function(t,e){var r=e.getGeometryFunction()(t);r&&ye(this.extent_,r.getExtent())&&(this.setStyle(e),this.drawGeometry(r))},e.prototype.drawGeometryCollection=function(t){for(var e=t.getGeometriesArray(),r=0,n=e.length;r<n;++r)this.drawGeometry(e[r])},e.prototype.drawPoint=function(t){this.squaredTolerance_&&(t=t.simplifyTransformed(this.squaredTolerance_,this.userTransform_));var e=t.getFlatCoordinates(),r=t.getStride();this.image_&&this.drawImages_(e,0,e.length,r),""!==this.text_&&this.drawText_(e,0,e.length,r)},e.prototype.drawMultiPoint=function(t){this.squaredTolerance_&&(t=t.simplifyTransformed(this.squaredTolerance_,this.userTransform_));var e=t.getFlatCoordinates(),r=t.getStride();this.image_&&this.drawImages_(e,0,e.length,r),""!==this.text_&&this.drawText_(e,0,e.length,r)},e.prototype.drawLineString=function(t){if(this.squaredTolerance_&&(t=t.simplifyTransformed(this.squaredTolerance_,this.userTransform_)),ye(this.extent_,t.getExtent())){if(this.strokeState_){this.setContextStrokeState_(this.strokeState_);var e=this.context_,r=t.getFlatCoordinates();e.beginPath(),this.moveToLineTo_(r,0,r.length,t.getStride(),!1),e.stroke()}if(""!==this.text_){var n=t.getFlatMidpoint();this.drawText_(n,0,2,2)}}},e.prototype.drawMultiLineString=function(t){this.squaredTolerance_&&(t=t.simplifyTransformed(this.squaredTolerance_,this.userTransform_));var e=t.getExtent();if(ye(this.extent_,e)){if(this.strokeState_){this.setContextStrokeState_(this.strokeState_);var r=this.context_,n=t.getFlatCoordinates(),i=0,o=t.getEnds(),a=t.getStride();r.beginPath();for(var s=0,u=o.length;s<u;++s)i=this.moveToLineTo_(n,i,o[s],a,!1);r.stroke()}if(""!==this.text_){var l=t.getFlatMidpoints();this.drawText_(l,0,l.length,2)}}},e.prototype.drawPolygon=function(t){if(this.squaredTolerance_&&(t=t.simplifyTransformed(this.squaredTolerance_,this.userTransform_)),ye(this.extent_,t.getExtent())){if(this.strokeState_||this.fillState_){this.fillState_&&this.setContextFillState_(this.fillState_),this.strokeState_&&this.setContextStrokeState_(this.strokeState_);var e=this.context_;e.beginPath(),this.drawRings_(t.getOrientedFlatCoordinates(),0,t.getEnds(),t.getStride()),this.fillState_&&e.fill(),this.strokeState_&&e.stroke()}if(""!==this.text_){var r=t.getFlatInteriorPoint();this.drawText_(r,0,2,2)}}},e.prototype.drawMultiPolygon=function(t){if(this.squaredTolerance_&&(t=t.simplifyTransformed(this.squaredTolerance_,this.userTransform_)),ye(this.extent_,t.getExtent())){if(this.strokeState_||this.fillState_){this.fillState_&&this.setContextFillState_(this.fillState_),this.strokeState_&&this.setContextStrokeState_(this.strokeState_);var e=this.context_,r=t.getOrientedFlatCoordinates(),n=0,i=t.getEndss(),o=t.getStride();e.beginPath();for(var a=0,s=i.length;a<s;++a){var u=i[a];n=this.drawRings_(r,n,u,o)}this.fillState_&&e.fill(),this.strokeState_&&e.stroke()}if(""!==this.text_){var l=t.getFlatInteriorPoints();this.drawText_(l,0,l.length,2)}}},e.prototype.setContextFillState_=function(t){var e=this.context_,r=this.contextFillState_;r?r.fillStyle!=t.fillStyle&&(r.fillStyle=t.fillStyle,e.fillStyle=t.fillStyle):(e.fillStyle=t.fillStyle,this.contextFillState_={fillStyle:t.fillStyle})},e.prototype.setContextStrokeState_=function(t){var e=this.context_,r=this.contextStrokeState_;r?(r.lineCap!=t.lineCap&&(r.lineCap=t.lineCap,e.lineCap=t.lineCap),e.setLineDash&&(_(r.lineDash,t.lineDash)||e.setLineDash(r.lineDash=t.lineDash),r.lineDashOffset!=t.lineDashOffset&&(r.lineDashOffset=t.lineDashOffset,e.lineDashOffset=t.lineDashOffset)),r.lineJoin!=t.lineJoin&&(r.lineJoin=t.lineJoin,e.lineJoin=t.lineJoin),r.lineWidth!=t.lineWidth&&(r.lineWidth=t.lineWidth,e.lineWidth=t.lineWidth),r.miterLimit!=t.miterLimit&&(r.miterLimit=t.miterLimit,e.miterLimit=t.miterLimit),r.strokeStyle!=t.strokeStyle&&(r.strokeStyle=t.strokeStyle,e.strokeStyle=t.strokeStyle)):(e.lineCap=t.lineCap,e.setLineDash&&(e.setLineDash(t.lineDash),e.lineDashOffset=t.lineDashOffset),e.lineJoin=t.lineJoin,e.lineWidth=t.lineWidth,e.miterLimit=t.miterLimit,e.strokeStyle=t.strokeStyle,this.contextStrokeState_={lineCap:t.lineCap,lineDash:t.lineDash,lineDashOffset:t.lineDashOffset,lineJoin:t.lineJoin,lineWidth:t.lineWidth,miterLimit:t.miterLimit,strokeStyle:t.strokeStyle})},e.prototype.setContextTextState_=function(t){var e=this.context_,r=this.contextTextState_,n=t.textAlign?t.textAlign:"center";r?(r.font!=t.font&&(r.font=t.font,e.font=t.font),r.textAlign!=n&&(r.textAlign=n,e.textAlign=n),r.textBaseline!=t.textBaseline&&(r.textBaseline=t.textBaseline,e.textBaseline=t.textBaseline)):(e.font=t.font,e.textAlign=n,e.textBaseline=t.textBaseline,this.contextTextState_={font:t.font,textAlign:n,textBaseline:t.textBaseline})},e.prototype.setFillStrokeStyle=function(t,e){if(t){var r=t.getColor();this.fillState_={fillStyle:Fi(r||"#000")}}else this.fillState_=null;if(e){var n=e.getColor(),i=e.getLineCap(),o=e.getLineDash(),a=e.getLineDashOffset(),s=e.getLineJoin(),u=e.getWidth(),l=e.getMiterLimit();this.strokeState_={lineCap:void 0!==i?i:"round",lineDash:o||Ji,lineDashOffset:a||0,lineJoin:void 0!==s?s:"round",lineWidth:this.pixelRatio_*(void 0!==u?u:1),miterLimit:void 0!==l?l:10,strokeStyle:Fi(n||"#000")}}else this.strokeState_=null},e.prototype.setImageStyle=function(t){if(t){var e=t.getSize();if(e){var r=t.getAnchor(),n=t.getImage(1),i=t.getOrigin(),o=t.getScaleArray();this.imageAnchorX_=r[0],this.imageAnchorY_=r[1],this.imageHeight_=e[1],this.image_=n,this.imageOpacity_=t.getOpacity(),this.imageOriginX_=i[0],this.imageOriginY_=i[1],this.imageRotateWithView_=t.getRotateWithView(),this.imageRotation_=t.getRotation(),this.imageScale_=[this.pixelRatio_*o[0],this.pixelRatio_*o[1]],this.imageWidth_=e[0]}else this.image_=null}else this.image_=null},e.prototype.setTextStyle=function(t){if(t){var e=t.getFill();if(e){var r=e.getColor();this.textFillState_={fillStyle:Fi(r||"#000")}}else this.textFillState_=null;var n=t.getStroke();if(n){var i=n.getColor(),o=n.getLineCap(),a=n.getLineDash(),s=n.getLineDashOffset(),u=n.getLineJoin(),l=n.getWidth(),h=n.getMiterLimit();this.textStrokeState_={lineCap:void 0!==o?o:"round",lineDash:a||Ji,lineDashOffset:s||0,lineJoin:void 0!==u?u:"round",lineWidth:void 0!==l?l:1,miterLimit:void 0!==h?h:10,strokeStyle:Fi(i||"#000")}}else this.textStrokeState_=null;var c=t.getFont(),p=t.getOffsetX(),f=t.getOffsetY(),d=t.getRotateWithView(),g=t.getRotation(),y=t.getScaleArray(),m=t.getText(),v=t.getTextAlign(),_=t.getTextBaseline();this.textState_={font:void 0!==c?c:"10px sans-serif",textAlign:void 0!==v?v:"center",textBaseline:void 0!==_?_:"middle"},this.text_=void 0!==m?m:"",this.textOffsetX_=void 0!==p?this.pixelRatio_*p:0,this.textOffsetY_=void 0!==f?this.pixelRatio_*f:0,this.textRotateWithView_=void 0!==d&&d,this.textRotation_=void 0!==g?g:0,this.textScale_=[this.pixelRatio_*y[0],this.pixelRatio_*y[1]]}else this.text_=""},e}(Mi),vo="Circle",_o="Default",bo="Image",xo="LineString",wo="Polygon",So="Text",To=0,Eo=1,Co=2,Po=3,Ro=4,Oo={Point:function(t,e,r,n){var i=r.getImage();if(i){if(i.getImageState()!=Co)return;var o=t.getBuilder(r.getZIndex(),bo);o.setImageStyle(i,t.addDeclutter(!1)),o.drawPoint(e,n)}var a=r.getText();if(a){var s=t.getBuilder(r.getZIndex(),So);s.setTextStyle(a,t.addDeclutter(!!i)),s.drawText(e,n)}},LineString:function(t,e,r,n){var i=r.getStroke();if(i){var o=t.getBuilder(r.getZIndex(),xo);o.setFillStrokeStyle(null,i),o.drawLineString(e,n)}var a=r.getText();if(a){var s=t.getBuilder(r.getZIndex(),So);s.setTextStyle(a,t.addDeclutter(!1)),s.drawText(e,n)}},Polygon:function(t,e,r,n){var i=r.getFill(),o=r.getStroke();if(i||o){var a=t.getBuilder(r.getZIndex(),wo);a.setFillStrokeStyle(i,o),a.drawPolygon(e,n)}var s=r.getText();if(s){var u=t.getBuilder(r.getZIndex(),So);u.setTextStyle(s,t.addDeclutter(!1)),u.drawText(e,n)}},MultiPoint:function(t,e,r,n){var i=r.getImage();if(i){if(i.getImageState()!=Co)return;var o=t.getBuilder(r.getZIndex(),bo);o.setImageStyle(i,t.addDeclutter(!1)),o.drawMultiPoint(e,n)}var a=r.getText();if(a){var s=t.getBuilder(r.getZIndex(),So);s.setTextStyle(a,t.addDeclutter(!!i)),s.drawText(e,n)}},MultiLineString:function(t,e,r,n){var i=r.getStroke();if(i){var o=t.getBuilder(r.getZIndex(),xo);o.setFillStrokeStyle(null,i),o.drawMultiLineString(e,n)}var a=r.getText();if(a){var s=t.getBuilder(r.getZIndex(),So);s.setTextStyle(a,t.addDeclutter(!1)),s.drawText(e,n)}},MultiPolygon:function(t,e,r,n){var i=r.getFill(),o=r.getStroke();if(o||i){var a=t.getBuilder(r.getZIndex(),wo);a.setFillStrokeStyle(i,o),a.drawMultiPolygon(e,n)}var s=r.getText();if(s){var u=t.getBuilder(r.getZIndex(),So);u.setTextStyle(s,t.addDeclutter(!1)),u.drawText(e,n)}},GeometryCollection:function(t,e,r,n){var i,o,a=e.getGeometriesArray();for(i=0,o=a.length;i<o;++i){(0,Oo[a[i].getType()])(t,a[i],r,n)}},Circle:function(t,e,r,n){var i=r.getFill(),o=r.getStroke();if(i||o){var a=t.getBuilder(r.getZIndex(),vo);a.setFillStrokeStyle(i,o),a.drawCircle(e,n)}var s=r.getText();if(s){var u=t.getBuilder(r.getZIndex(),So);u.setTextStyle(s,t.addDeclutter(!1)),u.drawText(e,n)}}};function Io(t,e){return parseInt(o(t),10)-parseInt(o(e),10)}function Lo(t,e){var r=Mo(t,e);return r*r}function Mo(t,e){return.5*t/e}function Fo(t,e,r,n,i,o){var a=!1,s=r.getImage();if(s){var u=s.getImageState();u==Co||u==Po?s.unlistenImageChange(i):(u==To&&s.load(),u=s.getImageState(),s.listenImageChange(i),a=!0)}return function(t,e,r,n,i){var o=r.getGeometryFunction()(e);if(!o)return;var a=o.simplifyTransformed(n,i);if(r.getRenderer())!function t(e,r,n,i){if(r.getType()==yt.GEOMETRY_COLLECTION){for(var o=r.getGeometries(),a=0,s=o.length;a<s;++a)t(e,o[a],n,i);return}e.getBuilder(n.getZIndex(),_o).drawCustom(r,i,n.getRenderer())}(t,a,r,e);else{(0,Oo[a.getType()])(t,a,r,e)}}(t,e,r,n,o),a}function Ao(t){var e,r=t.frameState,n=wt(t.inversePixelTransform.slice(),r.coordinateToPixelTransform),i=Lo(r.viewState.resolution,r.pixelRatio),o=Mr();return o&&(e=Tr(o,r.viewState.projection)),new mo(t.context,r.pixelRatio,r.extent,n,r.viewState.rotation,i,e)}function ko(t,e){e&&e.clear();for(var r=t.declutterItems,n=r.length-1;n>=0;--n)for(var i=r[n],o=i.items,a=0,s=o.length;a<s;a+=3)e=o[a].renderDeclutter(o[a+1],o[a+2],i.opacity,e);return r.length=0,e}var No=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function jo(t,e){ui.expire()}var Go=function(t){function e(e){var r=t.call(this)||this;return r.map_=e,r.declutterTree_=null,r}return No(e,t),e.prototype.dispatchRenderEvent=function(t,e){n()},e.prototype.calculateMatrices2D=function(t){var e=t.viewState,r=t.coordinateToPixelTransform,n=t.pixelToCoordinateTransform;Ct(r,t.size[0]/2,t.size[1]/2,1/e.resolution,-1/e.resolution,-e.rotation,-e.center[0],-e.center[1]),Pt(n,r)},e.prototype.forEachFeatureAtCoordinate=function(t,e,r,n,i,o,a,s){var u,l=e.viewState;function h(t,e,r){return i.call(o,e,t?r:null)}var c=l.projection,p=cr(t.slice(),c),f=[[0,0]];if(c.canWrapX()&&n){var d=ge(c.getExtent());f.push([-d,0],[d,0])}var g,y=e.layerStatesArray,m=y.length;this.declutterTree_&&(g=this.declutterTree_.all().map((function(t){return t.value})));for(var v=[],_=0;_<f.length;_++)for(var b=m-1;b>=0;--b){var x=y[b],w=x.layer;if(w.hasRenderer()&&Ii(x,l)&&a.call(s,w)){var S=w.getRenderer(),T=w.getSource();if(S&&T){var E=T.getWrapX()?p:t,C=h.bind(null,x.managed);v[0]=E[0]+f[_][0],v[1]=E[1]+f[_][1],u=S.forEachFeatureAtCoordinate(v,e,r,C,g)}if(u)return u}}},e.prototype.forEachLayerAtPixel=function(t,e,r,i,o){return n()},e.prototype.hasFeatureAtCoordinate=function(t,e,r,n,i,o){return void 0!==this.forEachFeatureAtCoordinate(t,e,r,n,x,this,i,o)},e.prototype.getMap=function(){return this.map_},e.prototype.renderFrame=function(t){this.declutterTree_=ko(t,this.declutterTree_)},e.prototype.scheduleExpireIconCache=function(t){ui.canExpireCache()&&t.postRenderFunctions.push(jo)},e}(p),Do=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),zo=function(t){function e(e,r,n,i){var o=t.call(this,e)||this;return o.inversePixelTransform=r,o.frameState=n,o.context=i,o}return Do(e,t),e}(h),Uo=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Bo=function(t){function e(e){var r=t.call(this,e)||this;r.fontChangeListenerKey_=W(Qi,c,e.redrawText.bind(e)),r.element_=document.createElement("div");var n=r.element_.style;n.position="absolute",n.width="100%",n.height="100%",n.zIndex="0",r.element_.className="ol-unselectable ol-layers";var i=e.getViewport();return i.insertBefore(r.element_,i.firstChild||null),r.children_=[],r.renderedVisible_=!0,r}return Uo(e,t),e.prototype.dispatchRenderEvent=function(t,e){var r=this.getMap();if(r.hasListener(t)){var n=new zo(t,void 0,e);r.dispatchEvent(n)}},e.prototype.disposeInternal=function(){X(this.fontChangeListenerKey_),this.element_.parentNode.removeChild(this.element_),t.prototype.disposeInternal.call(this)},e.prototype.renderFrame=function(e){if(e){this.calculateMatrices2D(e),this.dispatchRenderEvent(wi,e);var r=e.layerStatesArray.sort((function(t,e){return t.zIndex-e.zIndex})),n=e.viewState;this.children_.length=0;for(var i=null,o=0,a=r.length;o<a;++o){var s=r[o];if(e.layerIndex=o,Ii(s,n)&&(s.sourceState==Pi||s.sourceState==Ei)){var u=s.layer.render(e,i);u&&u!==i&&(this.children_.push(u),i=u)}}t.prototype.renderFrame.call(this,e),function(t,e){for(var r=t.childNodes,n=0;;++n){var i=r[n],o=e[n];if(!i&&!o)break;i!==o&&(i?o?t.insertBefore(o,i):(t.removeChild(i),--n):t.appendChild(o))}}(this.element_,this.children_),this.dispatchRenderEvent(Si,e),this.renderedVisible_||(this.element_.style.display="",this.renderedVisible_=!0),this.scheduleExpireIconCache(e)}else this.renderedVisible_&&(this.element_.style.display="none",this.renderedVisible_=!1)},e.prototype.forEachLayerAtPixel=function(t,e,r,n,i){for(var o=e.viewState,a=e.layerStatesArray,s=a.length-1;s>=0;--s){var u=a[s],l=u.layer;if(l.hasRenderer()&&Ii(u,o)&&i(l)){var h=l.getRenderer().getDataAtPixel(t,e,r);if(h){var c=n(l,h);if(c)return c}}}},e}(Go),Yo=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Vo="layers",Wo=function(t){function e(e){var r=this,n=e||{},i=T({},n);delete i.layers;var o=n.layers;return(r=t.call(this,i)||this).layersListenerKeys_=[],r.listenerKeys_={},r.addEventListener(et(Vo),r.handleLayersChanged_),o?Array.isArray(o)?o=new ut(o.slice(),{unique:!0}):lt("function"==typeof o.getArray,43):o=new ut(void 0,{unique:!0}),r.setLayers(o),r}return Yo(e,t),e.prototype.handleLayerChange_=function(){this.changed()},e.prototype.handleLayersChanged_=function(){this.layersListenerKeys_.forEach(X),this.layersListenerKeys_.length=0;var t=this.getLayers();for(var e in this.layersListenerKeys_.push(W(t,nt,this.handleLayersAdd_,this),W(t,it,this.handleLayersRemove_,this)),this.listenerKeys_)this.listenerKeys_[e].forEach(X);E(this.listenerKeys_);for(var r=t.getArray(),n=0,i=r.length;n<i;n++){var a=r[n];this.listenerKeys_[o(a)]=[W(a,c,this.handleLayerChange_,this),W(a,I,this.handleLayerChange_,this)]}this.changed()},e.prototype.handleLayersAdd_=function(t){var e=t.element;this.listenerKeys_[o(e)]=[W(e,c,this.handleLayerChange_,this),W(e,I,this.handleLayerChange_,this)],this.changed()},e.prototype.handleLayersRemove_=function(t){var e=o(t.element);this.listenerKeys_[e].forEach(X),delete this.listenerKeys_[e],this.changed()},e.prototype.getLayers=function(){return this.get(Vo)},e.prototype.setLayers=function(t){this.set(Vo,t)},e.prototype.getLayersArray=function(t){var e=void 0!==t?t:[];return this.getLayers().forEach((function(t){t.getLayersArray(e)})),e},e.prototype.getLayerStatesArray=function(t){var e=void 0!==t?t:[],r=e.length;this.getLayers().forEach((function(t){t.getLayerStatesArray(e)}));for(var n=this.getLayerState(),i=r,o=e.length;i<o;i++){var a=e[i];a.opacity*=n.opacity,a.visible=a.visible&&n.visible,a.maxResolution=Math.min(a.maxResolution,n.maxResolution),a.minResolution=Math.max(a.minResolution,n.minResolution),a.minZoom=Math.max(a.minZoom,n.minZoom),a.maxZoom=Math.min(a.maxZoom,n.maxZoom),void 0!==n.extent&&(void 0!==a.extent?a.extent=pe(a.extent,n.extent):a.extent=n.extent)}return e},e.prototype.getSourceState=function(){return Pi},e}(_i),qo=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Xo=function(t){function e(e,r,n){var i=t.call(this,e)||this;return i.map=r,i.frameState=void 0!==n?n:null,i}return qo(e,t),e}(h),Zo=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ko=function(t){function e(e,r,n,i,o){var a=t.call(this,e,r,o)||this;return a.originalEvent=n,a.pixel_=null,a.coordinate_=null,a.dragging=void 0!==i&&i,a}return Zo(e,t),Object.defineProperty(e.prototype,"pixel",{get:function(){return this.pixel_||(this.pixel_=this.map.getEventPixel(this.originalEvent)),this.pixel_},set:function(t){this.pixel_=t},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"coordinate",{get:function(){return this.coordinate_||(this.coordinate_=this.map.getCoordinateFromPixel(this.pixel)),this.coordinate_},set:function(t){this.coordinate_=t},enumerable:!1,configurable:!0}),e.prototype.preventDefault=function(){t.prototype.preventDefault.call(this),this.originalEvent.preventDefault()},e.prototype.stopPropagation=function(){t.prototype.stopPropagation.call(this),this.originalEvent.stopPropagation()},e}(Xo),Ho={SINGLECLICK:"singleclick",CLICK:A,DBLCLICK:k,POINTERDRAG:"pointerdrag",POINTERMOVE:"pointermove",POINTERDOWN:"pointerdown",POINTERUP:"pointerup",POINTEROVER:"pointerover",POINTEROUT:"pointerout",POINTERENTER:"pointerenter",POINTERLEAVE:"pointerleave",POINTERCANCEL:"pointercancel"},Jo="pointermove",$o="pointerdown",Qo="pointerup",ta="pointerout",ea=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ra=function(t){function e(e,r){var n=t.call(this,e)||this;n.map_=e,n.clickTimeoutId_,n.dragging_=!1,n.dragListenerKeys_=[],n.moveTolerance_=r?r*Gi:Gi,n.down_=null;var i=n.map_.getViewport();return n.activePointers_=0,n.trackedTouches_={},n.element_=i,n.pointerdownListenerKey_=W(i,$o,n.handlePointerDown_,n),n.originalPointerMoveEvent_,n.relayedListenerKey_=W(i,Jo,n.relayEvent_,n),n.boundHandleTouchMove_=n.handleTouchMove_.bind(n),n.element_.addEventListener(Y,n.boundHandleTouchMove_,!!Ui&&{passive:!1}),n}return ea(e,t),e.prototype.emulateClick_=function(t){var e=new Ko(Ho.CLICK,this.map_,t);this.dispatchEvent(e),void 0!==this.clickTimeoutId_?(clearTimeout(this.clickTimeoutId_),this.clickTimeoutId_=void 0,e=new Ko(Ho.DBLCLICK,this.map_,t),this.dispatchEvent(e)):this.clickTimeoutId_=setTimeout(function(){this.clickTimeoutId_=void 0;var e=new Ko(Ho.SINGLECLICK,this.map_,t);this.dispatchEvent(e)}.bind(this),250)},e.prototype.updateActivePointers_=function(t){var e=t;e.type==Ho.POINTERUP||e.type==Ho.POINTERCANCEL?delete this.trackedTouches_[e.pointerId]:e.type==Ho.POINTERDOWN&&(this.trackedTouches_[e.pointerId]=!0),this.activePointers_=Object.keys(this.trackedTouches_).length},e.prototype.handlePointerUp_=function(t){this.updateActivePointers_(t);var e=new Ko(Ho.POINTERUP,this.map_,t);this.dispatchEvent(e),e.propagationStopped||this.dragging_||!this.isMouseActionButton_(t)||this.emulateClick_(this.down_),0===this.activePointers_&&(this.dragListenerKeys_.forEach(X),this.dragListenerKeys_.length=0,this.dragging_=!1,this.down_=null)},e.prototype.isMouseActionButton_=function(t){return 0===t.button},e.prototype.handlePointerDown_=function(t){this.updateActivePointers_(t);var e=new Ko(Ho.POINTERDOWN,this.map_,t);this.dispatchEvent(e),this.down_=t,0===this.dragListenerKeys_.length&&(this.dragListenerKeys_.push(W(document,Ho.POINTERMOVE,this.handlePointerMove_,this),W(document,Ho.POINTERUP,this.handlePointerUp_,this),W(this.element_,Ho.POINTERCANCEL,this.handlePointerUp_,this)),this.element_.getRootNode&&this.element_.getRootNode()!==document&&this.dragListenerKeys_.push(W(this.element_.getRootNode(),Ho.POINTERUP,this.handlePointerUp_,this)))},e.prototype.handlePointerMove_=function(t){if(this.isMoving_(t)){this.dragging_=!0;var e=new Ko(Ho.POINTERDRAG,this.map_,t,this.dragging_);this.dispatchEvent(e)}},e.prototype.relayEvent_=function(t){this.originalPointerMoveEvent_=t;var e=!(!this.down_||!this.isMoving_(t));this.dispatchEvent(new Ko(t.type,this.map_,t,e))},e.prototype.handleTouchMove_=function(t){this.originalPointerMoveEvent_&&!this.originalPointerMoveEvent_.defaultPrevented||t.preventDefault()},e.prototype.isMoving_=function(t){return this.dragging_||Math.abs(t.clientX-this.down_.clientX)>this.moveTolerance_||Math.abs(t.clientY-this.down_.clientY)>this.moveTolerance_},e.prototype.disposeInternal=function(){this.relayedListenerKey_&&(X(this.relayedListenerKey_),this.relayedListenerKey_=null),this.element_.removeEventListener(Y,this.boundHandleTouchMove_),this.pointerdownListenerKey_&&(X(this.pointerdownListenerKey_),this.pointerdownListenerKey_=null),this.dragListenerKeys_.forEach(X),this.dragListenerKeys_.length=0,this.element_=null,t.prototype.disposeInternal.call(this)},e}(O),na="postrender",ia="movestart",oa="moveend",aa="layergroup",sa="size",ua="target",la="view",ha=function(){function t(t,e){this.priorityFunction_=t,this.keyFunction_=e,this.elements_=[],this.priorities_=[],this.queuedElements_={}}return t.prototype.clear=function(){this.elements_.length=0,this.priorities_.length=0,E(this.queuedElements_)},t.prototype.dequeue=function(){var t=this.elements_,e=this.priorities_,r=t[0];1==t.length?(t.length=0,e.length=0):(t[0]=t.pop(),e[0]=e.pop(),this.siftUp_(0));var n=this.keyFunction_(r);return delete this.queuedElements_[n],r},t.prototype.enqueue=function(t){lt(!(this.keyFunction_(t)in this.queuedElements_),31);var e=this.priorityFunction_(t);return e!=1/0&&(this.elements_.push(t),this.priorities_.push(e),this.queuedElements_[this.keyFunction_(t)]=!0,this.siftDown_(0,this.elements_.length-1),!0)},t.prototype.getCount=function(){return this.elements_.length},t.prototype.getLeftChildIndex_=function(t){return 2*t+1},t.prototype.getRightChildIndex_=function(t){return 2*t+2},t.prototype.getParentIndex_=function(t){return t-1>>1},t.prototype.heapify_=function(){var t;for(t=(this.elements_.length>>1)-1;t>=0;t--)this.siftUp_(t)},t.prototype.isEmpty=function(){return 0===this.elements_.length},t.prototype.isKeyQueued=function(t){return t in this.queuedElements_},t.prototype.isQueued=function(t){return this.isKeyQueued(this.keyFunction_(t))},t.prototype.siftUp_=function(t){for(var e=this.elements_,r=this.priorities_,n=e.length,i=e[t],o=r[t],a=t;t<n>>1;){var s=this.getLeftChildIndex_(t),u=this.getRightChildIndex_(t),l=u<n&&r[u]<r[s]?u:s;e[t]=e[l],r[t]=r[l],t=l}e[t]=i,r[t]=o,this.siftDown_(a,t)},t.prototype.siftDown_=function(t,e){for(var r=this.elements_,n=this.priorities_,i=r[e],o=n[e];e>t;){var a=this.getParentIndex_(e);if(!(n[a]>o))break;r[e]=r[a],n[e]=n[a],e=a}r[e]=i,n[e]=o},t.prototype.reprioritize=function(){var t,e,r,n=this.priorityFunction_,i=this.elements_,o=this.priorities_,a=0,s=i.length;for(e=0;e<s;++e)(r=n(t=i[e]))==1/0?delete this.queuedElements_[this.keyFunction_(t)]:(o[a]=r,i[a++]=t);i.length=a,o.length=a,this.heapify_()},t}(),ca=0,pa=1,fa=2,da=3,ga=4,ya=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ma=function(t){function e(e,r){var n=t.call(this,(function(t){return e.apply(null,t)}),(function(t){return t[0].getKey()}))||this;return n.boundHandleTileChange_=n.handleTileChange.bind(n),n.tileChangeCallback_=r,n.tilesLoading_=0,n.tilesLoadingKeys_={},n}return ya(e,t),e.prototype.enqueue=function(e){var r=t.prototype.enqueue.call(this,e);r&&e[0].addEventListener(I,this.boundHandleTileChange_);return r},e.prototype.getTilesLoading=function(){return this.tilesLoading_},e.prototype.handleTileChange=function(t){var e=t.target,r=e.getState();if(e.hifi&&r===fa||r===da||r===ga){e.removeEventListener(I,this.boundHandleTileChange_);var n=e.getKey();n in this.tilesLoadingKeys_&&(delete this.tilesLoadingKeys_[n],--this.tilesLoading_),this.tileChangeCallback_()}},e.prototype.loadMoreTiles=function(t,e){for(var r,n,i=0;this.tilesLoading_<t&&i<e&&this.getCount()>0;)n=(r=this.dequeue()[0]).getKey(),r.getState()!==ca||n in this.tilesLoadingKeys_||(this.tilesLoadingKeys_[n]=!0,++this.tilesLoading_,++i,r.load())},e}(ha);var va=0,_a=1,ba="center",xa="resolution",wa="rotation";function Sa(t,e,r){return function(n,i,o,a){if(n){var s=e?0:o[0]*i,u=e?0:o[1]*i,l=t[0]+s/2,h=t[2]-s/2,c=t[1]+u/2,p=t[3]-u/2;l>h&&(h=l=(h+l)/2),c>p&&(p=c=(p+c)/2);var f=we(n[0],l,h),d=we(n[1],c,p),g=30*i;return a&&r&&(f+=-g*Math.log(1+Math.max(0,l-n[0])/g)+g*Math.log(1+Math.max(0,n[0]-h)/g),d+=-g*Math.log(1+Math.max(0,c-n[1])/g)+g*Math.log(1+Math.max(0,n[1]-p)/g)),[f,d]}}}function Ta(t){return t}function Ea(t,e,r,n){var i=ge(e)/r[0],o=ce(e)/r[1];return n?Math.min(t,Math.max(i,o)):Math.min(t,Math.min(i,o))}function Ca(t,e,r){var n=Math.min(t,e);return n*=Math.log(1+50*Math.max(0,t/e-1))/50+1,r&&(n=Math.max(n,r),n/=Math.log(1+50*Math.max(0,r/t-1))/50+1),we(n,r/2,2*e)}function Pa(t,e,r,n,i){return function(o,a,s,u){if(void 0!==o){var l=n?Ea(t,n,s,i):t;return(void 0===r||r)&&u?Ca(o,l,e):we(o,e,l)}}}function Ra(t){return void 0!==t?0:void 0}function Oa(t){return void 0!==t?t:void 0}function Ia(t){return Math.pow(t,3)}function La(t){return 1-Ia(1-t)}function Ma(t){return 3*t*t-2*t*t*t}function Fa(t){return t}var Aa=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function ka(t,e){setTimeout((function(){t(e)}),0)}function Na(t){return!(t.sourceCenter&&t.targetCenter&&!ir(t.sourceCenter,t.targetCenter))&&(t.sourceResolution===t.targetResolution&&t.sourceRotation===t.targetRotation)}var ja=function(t){function e(e){var r=t.call(this)||this,n=T({},e);return r.hints_=[0,0],r.animations_=[],r.updateAnimationKey_,r.projection_=_r(n.projection,"EPSG:3857"),r.viewportSize_=[100,100],r.targetCenter_=null,r.targetResolution_,r.targetRotation_,r.cancelAnchor_=void 0,n.center&&(n.center=Ar(n.center,r.projection_)),n.extent&&(n.extent=Nr(n.extent,r.projection_)),r.applyOptions_(n),r}return Aa(e,t),e.prototype.applyOptions_=function(t){var e=function(t){var e,r,n,i=void 0!==t.minZoom?t.minZoom:0,o=void 0!==t.maxZoom?t.maxZoom:28,a=void 0!==t.zoomFactor?t.zoomFactor:2,s=void 0!==t.multiWorld&&t.multiWorld,u=void 0===t.smoothResolutionConstraint||t.smoothResolutionConstraint,l=void 0!==t.showFullExtent&&t.showFullExtent,h=_r(t.projection,"EPSG:3857"),c=h.getExtent(),p=t.constrainOnlyCenter,f=t.extent;s||f||!h.isGlobal()||(p=!1,f=c);if(void 0!==t.resolutions){var d=t.resolutions;r=d[i],n=void 0!==d[o]?d[o]:d[d.length-1],e=t.constrainResolution?function(t,e,r,n){return function(i,o,a,s){if(void 0!==i){var u=t[0],l=t[t.length-1],h=r?Ea(u,r,a,n):u;if(s)return void 0===e||e?Ca(i,h,l):we(i,l,h);var c=Math.min(h,i),p=Math.floor(g(t,c,o));return t[p]>h&&p<t.length-1?t[p+1]:t[p]}}}(d,u,!p&&f,l):Pa(r,n,u,!p&&f,l)}else{var y=(c?Math.max(ge(c),ce(c)):360*vt[_t.DEGREES]/h.getMetersPerUnit())/256/Math.pow(2,0),m=y/Math.pow(2,28);void 0!==(r=t.maxResolution)?i=0:r=y/Math.pow(a,i),void 0===(n=t.minResolution)&&(n=void 0!==t.maxZoom?void 0!==t.maxResolution?r/Math.pow(a,o):y/Math.pow(a,o):m),o=i+Math.floor(Math.log(r/n)/Math.log(a)),n=r/Math.pow(a,o-i),e=t.constrainResolution?function(t,e,r,n,i,o){return function(a,s,u,l){if(void 0!==a){var h=i?Ea(e,i,u,o):e,c=void 0!==r?r:0;if(l)return void 0===n||n?Ca(a,h,c):we(a,c,h);var p=Math.ceil(Math.log(e/h)/Math.log(t)-1e-9),f=-s*(.5-1e-9)+.5,d=Math.min(h,a),g=Math.floor(Math.log(e/d)/Math.log(t)+f),y=Math.max(p,g);return we(e/Math.pow(t,y),c,h)}}}(a,r,n,u,!p&&f,l):Pa(r,n,u,!p&&f,l)}return{constraint:e,maxResolution:r,minResolution:n,minZoom:i,zoomFactor:a}}(t);this.maxResolution_=e.maxResolution,this.minResolution_=e.minResolution,this.zoomFactor_=e.zoomFactor,this.resolutions_=t.resolutions,this.minZoom_=e.minZoom;var r=function(t){if(void 0!==t.extent){var e=void 0===t.smoothExtentConstraint||t.smoothExtentConstraint;return Sa(t.extent,t.constrainOnlyCenter,e)}var r=_r(t.projection,"EPSG:3857");if(!0!==t.multiWorld&&r.isGlobal()){var n=r.getExtent().slice();return n[0]=-1/0,n[2]=1/0,Sa(n,!1,!1)}return Ta}(t),n=e.constraint,i=function(t){if(void 0===t.enableRotation||t.enableRotation){var e=t.constrainRotation;return void 0===e||!0===e?(o=i||Re(5),function(t,e){return e?t:void 0!==t?Math.abs(t)<=o?0:t:void 0}):!1===e?Oa:"number"==typeof e?(r=e,n=2*Math.PI/r,function(t,e){return e?t:void 0!==t?t=Math.floor(t/n+.5)*n:void 0}):Oa}return Ra;var r,n;var i,o}(t);this.constraints_={center:r,resolution:n,rotation:i},this.setRotation(void 0!==t.rotation?t.rotation:0),this.setCenterInternal(void 0!==t.center?t.center:null),void 0!==t.resolution?this.setResolution(t.resolution):void 0!==t.zoom&&this.setZoom(t.zoom),this.setProperties({}),this.options_=t},e.prototype.getUpdatedOptions_=function(t){var e=T({},this.options_);return void 0!==e.resolution?e.resolution=this.getResolution():e.zoom=this.getZoom(),e.center=this.getCenterInternal(),e.rotation=this.getRotation(),T({},e,t)},e.prototype.animate=function(t){this.isDef()&&!this.getAnimating()&&this.resolveConstraints(0);for(var e=new Array(arguments.length),r=0;r<e.length;++r){var n=arguments[r];n.center&&((n=T({},n)).center=Ar(n.center,this.getProjection())),n.anchor&&((n=T({},n)).anchor=Ar(n.anchor,this.getProjection())),e[r]=n}this.animateInternal.apply(this,e)},e.prototype.animateInternal=function(t){var e,r=arguments.length;if(r>1&&"function"==typeof arguments[r-1]&&(e=arguments[r-1],--r),!this.isDef()){var n=arguments[r-1];return n.center&&this.setCenterInternal(n.center),void 0!==n.zoom&&this.setZoom(n.zoom),void 0!==n.rotation&&this.setRotation(n.rotation),void(e&&ka(e,!0))}for(var i=Date.now(),o=this.targetCenter_.slice(),a=this.targetResolution_,s=this.targetRotation_,u=[],l=0;l<r;++l){var h=arguments[l],c={start:i,complete:!1,anchor:h.anchor,duration:void 0!==h.duration?h.duration:1e3,easing:h.easing||Ma,callback:e};if(h.center&&(c.sourceCenter=o,c.targetCenter=h.center.slice(),o=c.targetCenter),void 0!==h.zoom?(c.sourceResolution=a,c.targetResolution=this.getResolutionForZoom(h.zoom),a=c.targetResolution):h.resolution&&(c.sourceResolution=a,c.targetResolution=h.resolution,a=c.targetResolution),void 0!==h.rotation){c.sourceRotation=s;var p=Oe(h.rotation-s+Math.PI,2*Math.PI)-Math.PI;c.targetRotation=s+p,s=c.targetRotation}Na(c)?c.complete=!0:i+=c.duration,u.push(c)}this.animations_.push(u),this.setHint(va,1),this.updateAnimations_()},e.prototype.getAnimating=function(){return this.hints_[va]>0},e.prototype.getInteracting=function(){return this.hints_[_a]>0},e.prototype.cancelAnimations=function(){var t;this.setHint(va,-this.hints_[va]);for(var e=0,r=this.animations_.length;e<r;++e){var n=this.animations_[e];if(n[0].callback&&ka(n[0].callback,!1),!t)for(var i=0,o=n.length;i<o;++i){var a=n[i];if(!a.complete){t=a.anchor;break}}}this.animations_.length=0,this.cancelAnchor_=t},e.prototype.updateAnimations_=function(){if(void 0!==this.updateAnimationKey_&&(cancelAnimationFrame(this.updateAnimationKey_),this.updateAnimationKey_=void 0),this.getAnimating()){for(var t=Date.now(),e=!1,r=this.animations_.length-1;r>=0;--r){for(var n=this.animations_[r],i=!0,o=0,a=n.length;o<a;++o){var s=n[o];if(!s.complete){var u=t-s.start,l=s.duration>0?u/s.duration:1;l>=1?(s.complete=!0,l=1):i=!1;var h=s.easing(l);if(s.sourceCenter){var c=s.sourceCenter[0],p=s.sourceCenter[1],f=c+h*(s.targetCenter[0]-c),d=p+h*(s.targetCenter[1]-p);this.targetCenter_=[f,d]}if(s.sourceResolution&&s.targetResolution){var g=1===h?s.targetResolution:s.sourceResolution+h*(s.targetResolution-s.sourceResolution);if(s.anchor){var y=this.getViewportSize_(this.getRotation()),m=this.constraints_.resolution(g,0,y,!0);this.targetCenter_=this.calculateCenterZoom(m,s.anchor)}this.targetResolution_=g,this.applyTargetState_(!0)}if(void 0!==s.sourceRotation&&void 0!==s.targetRotation){var v=1===h?Oe(s.targetRotation+Math.PI,2*Math.PI)-Math.PI:s.sourceRotation+h*(s.targetRotation-s.sourceRotation);if(s.anchor){var _=this.constraints_.rotation(v,!0);this.targetCenter_=this.calculateCenterRotate(_,s.anchor)}this.targetRotation_=v}if(this.applyTargetState_(!0),e=!0,!s.complete)break}}if(i){this.animations_[r]=null,this.setHint(va,-1);var b=n[0].callback;b&&ka(b,!0)}}this.animations_=this.animations_.filter(Boolean),e&&void 0===this.updateAnimationKey_&&(this.updateAnimationKey_=requestAnimationFrame(this.updateAnimations_.bind(this)))}},e.prototype.calculateCenterRotate=function(t,e){var r,n=this.getCenterInternal();return void 0!==n&&(or(r=[n[0]-e[0],n[1]-e[1]],t-this.getRotation()),tr(r,e)),r},e.prototype.calculateCenterZoom=function(t,e){var r,n=this.getCenterInternal(),i=this.getResolution();void 0!==n&&void 0!==i&&(r=[e[0]-t*(e[0]-n[0])/i,e[1]-t*(e[1]-n[1])/i]);return r},e.prototype.getViewportSize_=function(t){var e=this.viewportSize_;if(t){var r=e[0],n=e[1];return[Math.abs(r*Math.cos(t))+Math.abs(n*Math.sin(t)),Math.abs(r*Math.sin(t))+Math.abs(n*Math.cos(t))]}return e},e.prototype.setViewportSize=function(t){this.viewportSize_=Array.isArray(t)?t.slice():[100,100],this.getAnimating()||this.resolveConstraints(0)},e.prototype.getCenter=function(){var t=this.getCenterInternal();return t?Fr(t,this.getProjection()):t},e.prototype.getCenterInternal=function(){return this.get(ba)},e.prototype.getConstraints=function(){return this.constraints_},e.prototype.getConstrainResolution=function(){return this.options_.constrainResolution},e.prototype.getHints=function(t){return void 0!==t?(t[0]=this.hints_[0],t[1]=this.hints_[1],t):this.hints_.slice()},e.prototype.calculateExtent=function(t){return kr(this.calculateExtentInternal(t),this.getProjection())},e.prototype.calculateExtentInternal=function(t){var e=t||this.getViewportSize_(),r=this.getCenterInternal();lt(r,1);var n=this.getResolution();lt(void 0!==n,2);var i=this.getRotation();return lt(void 0!==i,3),he(r,n,i,e)},e.prototype.getMaxResolution=function(){return this.maxResolution_},e.prototype.getMinResolution=function(){return this.minResolution_},e.prototype.getMaxZoom=function(){return this.getZoomForResolution(this.minResolution_)},e.prototype.setMaxZoom=function(t){this.applyOptions_(this.getUpdatedOptions_({maxZoom:t}))},e.prototype.getMinZoom=function(){return this.getZoomForResolution(this.maxResolution_)},e.prototype.setMinZoom=function(t){this.applyOptions_(this.getUpdatedOptions_({minZoom:t}))},e.prototype.setConstrainResolution=function(t){this.applyOptions_(this.getUpdatedOptions_({constrainResolution:t}))},e.prototype.getProjection=function(){return this.projection_},e.prototype.getResolution=function(){return this.get(xa)},e.prototype.getResolutions=function(){return this.resolutions_},e.prototype.getResolutionForExtent=function(t,e){return this.getResolutionForExtentInternal(Nr(t,this.getProjection()),e)},e.prototype.getResolutionForExtentInternal=function(t,e){var r=e||this.getViewportSize_(),n=ge(t)/r[0],i=ce(t)/r[1];return Math.max(n,i)},e.prototype.getResolutionForValueFunction=function(t){var e=t||2,r=this.getConstrainedResolution(this.maxResolution_),n=this.minResolution_,i=Math.log(r/n)/Math.log(e);return function(t){return r/Math.pow(e,t*i)}},e.prototype.getRotation=function(){return this.get(wa)},e.prototype.getValueForResolutionFunction=function(t){var e=Math.log(t||2),r=this.getConstrainedResolution(this.maxResolution_),n=this.minResolution_,i=Math.log(r/n)/e;return function(t){return Math.log(r/t)/e/i}},e.prototype.getState=function(){var t=this.getCenterInternal(),e=this.getProjection(),r=this.getResolution(),n=this.getRotation();return{center:t.slice(0),projection:void 0!==e?e:null,resolution:r,rotation:n,zoom:this.getZoom()}},e.prototype.getZoom=function(){var t,e=this.getResolution();return void 0!==e&&(t=this.getZoomForResolution(e)),t},e.prototype.getZoomForResolution=function(t){var e,r,n=this.minZoom_||0;if(this.resolutions_){var i=g(this.resolutions_,t,1);n=i,e=this.resolutions_[i],r=i==this.resolutions_.length-1?2:e/this.resolutions_[i+1]}else e=this.maxResolution_,r=this.zoomFactor_;return n+Math.log(e/t)/Math.log(r)},e.prototype.getResolutionForZoom=function(t){if(this.resolutions_){if(this.resolutions_.length<=1)return 0;var e=we(Math.floor(t),0,this.resolutions_.length-2),r=this.resolutions_[e]/this.resolutions_[e+1];return this.resolutions_[e]/Math.pow(r,we(t-e,0,1))}return this.maxResolution_/Math.pow(this.zoomFactor_,t-this.minZoom_)},e.prototype.fit=function(t,e){var r,n=T({size:this.getViewportSize_()},e||{});if(lt(Array.isArray(t)||"function"==typeof t.getSimplifiedGeometry,24),Array.isArray(t))lt(!me(t),25),r=Fn(i=Nr(t,this.getProjection()));else if(t.getType()===yt.CIRCLE){var i;(r=Fn(i=Nr(t.getExtent(),this.getProjection()))).rotate(this.getRotation(),ue(i))}else{var o=Mr();r=o?t.clone().transform(o,this.getProjection()):t}this.fitInternal(r,n)},e.prototype.fitInternal=function(t,e){var r=e||{},n=r.size;n||(n=this.getViewportSize_());var i,o=void 0!==r.padding?r.padding:[0,0,0,0],a=void 0!==r.nearest&&r.nearest;i=void 0!==r.minResolution?r.minResolution:void 0!==r.maxZoom?this.getResolutionForZoom(r.maxZoom):0;for(var s=t.getFlatCoordinates(),u=this.getRotation(),l=Math.cos(-u),h=Math.sin(-u),c=1/0,p=1/0,f=-1/0,d=-1/0,g=t.getStride(),y=0,m=s.length;y<m;y+=g){var v=s[y]*l-s[y+1]*h,_=s[y]*h+s[y+1]*l;c=Math.min(c,v),p=Math.min(p,_),f=Math.max(f,v),d=Math.max(d,_)}var b=this.getResolutionForExtentInternal([c,p,f,d],[n[0]-o[1]-o[3],n[1]-o[0]-o[2]]);b=isNaN(b)?i:Math.max(b,i),b=this.getConstrainedResolution(b,a?0:1),h=-h;var x=(c+f)/2,w=(p+d)/2,T=[(x+=(o[1]-o[3])/2*b)*l-(w+=(o[0]-o[2])/2*b)*h,w*l+x*h],E=r.callback?r.callback:S;void 0!==r.duration?this.animateInternal({resolution:b,center:this.getConstrainedCenter(T,b),duration:r.duration,easing:r.easing},E):(this.targetResolution_=b,this.targetCenter_=T,this.applyTargetState_(!1,!0),ka(E,!0))},e.prototype.centerOn=function(t,e,r){this.centerOnInternal(Ar(t,this.getProjection()),e,r)},e.prototype.centerOnInternal=function(t,e,r){var n=this.getRotation(),i=Math.cos(-n),o=Math.sin(-n),a=t[0]*i-t[1]*o,s=t[1]*i+t[0]*o,u=this.getResolution(),l=(a+=(e[0]/2-r[0])*u)*i-(s+=(r[1]-e[1]/2)*u)*(o=-o),h=s*i+a*o;this.setCenterInternal([l,h])},e.prototype.isDef=function(){return!!this.getCenterInternal()&&void 0!==this.getResolution()},e.prototype.adjustCenter=function(t){var e=Fr(this.targetCenter_,this.getProjection());this.setCenter([e[0]+t[0],e[1]+t[1]])},e.prototype.adjustCenterInternal=function(t){var e=this.targetCenter_;this.setCenterInternal([e[0]+t[0],e[1]+t[1]])},e.prototype.adjustResolution=function(t,e){var r=e&&Ar(e,this.getProjection());this.adjustResolutionInternal(t,r)},e.prototype.adjustResolutionInternal=function(t,e){var r=this.getAnimating()||this.getInteracting(),n=this.getViewportSize_(this.getRotation()),i=this.constraints_.resolution(this.targetResolution_*t,0,n,r);e&&(this.targetCenter_=this.calculateCenterZoom(i,e)),this.targetResolution_*=t,this.applyTargetState_()},e.prototype.adjustZoom=function(t,e){this.adjustResolution(Math.pow(this.zoomFactor_,-t),e)},e.prototype.adjustRotation=function(t,e){e&&(e=Ar(e,this.getProjection())),this.adjustRotationInternal(t,e)},e.prototype.adjustRotationInternal=function(t,e){var r=this.getAnimating()||this.getInteracting(),n=this.constraints_.rotation(this.targetRotation_+t,r);e&&(this.targetCenter_=this.calculateCenterRotate(n,e)),this.targetRotation_+=t,this.applyTargetState_()},e.prototype.setCenter=function(t){this.setCenterInternal(Ar(t,this.getProjection()))},e.prototype.setCenterInternal=function(t){this.targetCenter_=t,this.applyTargetState_()},e.prototype.setHint=function(t,e){return this.hints_[t]+=e,this.changed(),this.hints_[t]},e.prototype.setResolution=function(t){this.targetResolution_=t,this.applyTargetState_()},e.prototype.setRotation=function(t){this.targetRotation_=t,this.applyTargetState_()},e.prototype.setZoom=function(t){this.setResolution(this.getResolutionForZoom(t))},e.prototype.applyTargetState_=function(t,e){var r=this.getAnimating()||this.getInteracting()||e,n=this.constraints_.rotation(this.targetRotation_,r),i=this.getViewportSize_(n),o=this.constraints_.resolution(this.targetResolution_,0,i,r),a=this.constraints_.center(this.targetCenter_,o,i,r);this.get(wa)!==n&&this.set(wa,n),this.get(xa)!==o&&this.set(xa,o),this.get(ba)&&ir(this.get(ba),a)||this.set(ba,a),this.getAnimating()&&!t&&this.cancelAnimations(),this.cancelAnchor_=void 0},e.prototype.resolveConstraints=function(t,e,r){var n=void 0!==t?t:200,i=e||0,o=this.constraints_.rotation(this.targetRotation_),a=this.getViewportSize_(o),s=this.constraints_.resolution(this.targetResolution_,i,a),u=this.constraints_.center(this.targetCenter_,s,a);if(0===n&&!this.cancelAnchor_)return this.targetResolution_=s,this.targetRotation_=o,this.targetCenter_=u,void this.applyTargetState_();var l=r||(0===n?this.cancelAnchor_:void 0);this.cancelAnchor_=void 0,this.getResolution()===s&&this.getRotation()===o&&this.getCenterInternal()&&ir(this.getCenterInternal(),u)||(this.getAnimating()&&this.cancelAnimations(),this.animateInternal({rotation:o,center:u,resolution:s,duration:n,easing:La,anchor:l}))},e.prototype.beginInteraction=function(){this.resolveConstraints(0),this.setHint(_a,1)},e.prototype.endInteraction=function(t,e,r){var n=r&&Ar(r,this.getProjection());this.endInteractionInternal(t,e,n)},e.prototype.endInteractionInternal=function(t,e,r){this.setHint(_a,-1),this.resolveConstraints(t,e,r)},e.prototype.getConstrainedCenter=function(t,e){var r=this.getViewportSize_(this.getRotation());return this.constraints_.center(t,e||this.getResolution(),r)},e.prototype.getConstrainedZoom=function(t,e){var r=this.getResolutionForZoom(t);return this.getZoomForResolution(this.getConstrainedResolution(r,e))},e.prototype.getConstrainedResolution=function(t,e){var r=e||0,n=this.getViewportSize_(this.getRotation());return this.constraints_.resolution(t,r,n)},e}(rt);function Ga(t,e,r){return void 0===r&&(r=[0,0]),r[0]=t[0]+2*e,r[1]=t[1]+2*e,r}function Da(t,e,r){return void 0===r&&(r=[0,0]),r[0]=t[0]*e+.5|0,r[1]=t[1]*e+.5|0,r}function za(t,e){return Array.isArray(t)?t:(void 0===e?e=[t,t]:(e[0]=t,e[1]=t),e)}var Ua=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();var Ba=function(t){function e(e){var r=t.call(this)||this,n=function(t){var e=null;void 0!==t.keyboardEventTarget&&(e="string"==typeof t.keyboardEventTarget?document.getElementById(t.keyboardEventTarget):t.keyboardEventTarget);var r,n,i,o={},a=t.layers&&"function"==typeof t.layers.getLayers?t.layers:new Wo({layers:t.layers});o[aa]=a,o[ua]=t.target,o[la]=void 0!==t.view?t.view:new ja,void 0!==t.controls&&(Array.isArray(t.controls)?r=new ut(t.controls.slice()):(lt("function"==typeof t.controls.getArray,47),r=t.controls));void 0!==t.interactions&&(Array.isArray(t.interactions)?n=new ut(t.interactions.slice()):(lt("function"==typeof t.interactions.getArray,48),n=t.interactions));void 0!==t.overlays?Array.isArray(t.overlays)?i=new ut(t.overlays.slice()):(lt("function"==typeof t.overlays.getArray,49),i=t.overlays):i=new ut;return{controls:r,interactions:n,keyboardEventTarget:e,overlays:i,values:o}}(e);return r.boundHandleBrowserEvent_=r.handleBrowserEvent.bind(r),r.maxTilesLoading_=void 0!==e.maxTilesLoading?e.maxTilesLoading:16,r.pixelRatio_=void 0!==e.pixelRatio?e.pixelRatio:Gi,r.postRenderTimeoutHandle_,r.animationDelayKey_,r.animationDelay_=function(){this.animationDelayKey_=void 0,this.renderFrame_(Date.now())}.bind(r),r.coordinateToPixelTransform_=[1,0,0,1,0,0],r.pixelToCoordinateTransform_=[1,0,0,1,0,0],r.frameIndex_=0,r.frameState_=null,r.previousExtent_=null,r.viewPropertyListenerKey_=null,r.viewChangeListenerKey_=null,r.layerGroupPropertyListenerKeys_=null,r.viewport_=document.createElement("div"),r.viewport_.className="ol-viewport"+("ontouchstart"in window?" ol-touch":""),r.viewport_.style.position="relative",r.viewport_.style.overflow="hidden",r.viewport_.style.width="100%",r.viewport_.style.height="100%",r.overlayContainer_=document.createElement("div"),r.overlayContainer_.style.position="absolute",r.overlayContainer_.style.zIndex="0",r.overlayContainer_.style.width="100%",r.overlayContainer_.style.height="100%",r.overlayContainer_.style.pointerEvents="none",r.overlayContainer_.className="ol-overlaycontainer",r.viewport_.appendChild(r.overlayContainer_),r.overlayContainerStopEvent_=document.createElement("div"),r.overlayContainerStopEvent_.style.position="absolute",r.overlayContainerStopEvent_.style.zIndex="0",r.overlayContainerStopEvent_.style.width="100%",r.overlayContainerStopEvent_.style.height="100%",r.overlayContainerStopEvent_.style.pointerEvents="none",r.overlayContainerStopEvent_.className="ol-overlaycontainer-stopevent",r.viewport_.appendChild(r.overlayContainerStopEvent_),r.mapBrowserEventHandler_=null,r.moveTolerance_=e.moveTolerance,r.keyboardEventTarget_=n.keyboardEventTarget,r.keyHandlerKeys_=null,r.controls=n.controls||new ut,r.interactions=n.interactions||new ut,r.overlays_=n.overlays,r.overlayIdIndex_={},r.renderer_=null,r.handleResize_,r.postRenderFunctions_=[],r.tileQueue_=new ma(r.getTilePriority.bind(r),r.handleTileChange_.bind(r)),r.addEventListener(et(aa),r.handleLayerGroupChanged_),r.addEventListener(et(la),r.handleViewChanged_),r.addEventListener(et(sa),r.handleSizeChanged_),r.addEventListener(et(ua),r.handleTargetChanged_),r.setProperties(n.values),r.controls.forEach(function(t){t.setMap(this)}.bind(r)),r.controls.addEventListener(nt,function(t){t.element.setMap(this)}.bind(r)),r.controls.addEventListener(it,function(t){t.element.setMap(null)}.bind(r)),r.interactions.forEach(function(t){t.setMap(this)}.bind(r)),r.interactions.addEventListener(nt,function(t){t.element.setMap(this)}.bind(r)),r.interactions.addEventListener(it,function(t){t.element.setMap(null)}.bind(r)),r.overlays_.forEach(r.addOverlayInternal_.bind(r)),r.overlays_.addEventListener(nt,function(t){this.addOverlayInternal_(t.element)}.bind(r)),r.overlays_.addEventListener(it,function(t){var e=t.element.getId();void 0!==e&&delete this.overlayIdIndex_[e.toString()],t.element.setMap(null)}.bind(r)),r}return Ua(e,t),e.prototype.createRenderer=function(){throw new Error("Use a map type that has a createRenderer method")},e.prototype.addControl=function(t){this.getControls().push(t)},e.prototype.addInteraction=function(t){this.getInteractions().push(t)},e.prototype.addLayer=function(t){this.getLayerGroup().getLayers().push(t)},e.prototype.addOverlay=function(t){this.getOverlays().push(t)},e.prototype.addOverlayInternal_=function(t){var e=t.getId();void 0!==e&&(this.overlayIdIndex_[e.toString()]=t),t.setMap(this)},e.prototype.disposeInternal=function(){this.setTarget(null),t.prototype.disposeInternal.call(this)},e.prototype.forEachFeatureAtPixel=function(t,e,r){if(this.frameState_){var n=this.getCoordinateFromPixelInternal(t),i=void 0!==(r=void 0!==r?r:{}).hitTolerance?r.hitTolerance*this.frameState_.pixelRatio:0,o=void 0!==r.layerFilter?r.layerFilter:x,a=!1!==r.checkWrapped;return this.renderer_.forEachFeatureAtCoordinate(n,this.frameState_,i,a,e,null,o,null)}},e.prototype.getFeaturesAtPixel=function(t,e){var r=[];return this.forEachFeatureAtPixel(t,(function(t){r.push(t)}),e),r},e.prototype.forEachLayerAtPixel=function(t,e,r){if(this.frameState_){var n=r||{},i=void 0!==n.hitTolerance?n.hitTolerance*this.frameState_.pixelRatio:0,o=n.layerFilter||x;return this.renderer_.forEachLayerAtPixel(t,this.frameState_,i,e,o)}},e.prototype.hasFeatureAtPixel=function(t,e){if(!this.frameState_)return!1;var r=this.getCoordinateFromPixelInternal(t),n=void 0!==(e=void 0!==e?e:{}).layerFilter?e.layerFilter:x,i=void 0!==e.hitTolerance?e.hitTolerance*this.frameState_.pixelRatio:0,o=!1!==e.checkWrapped;return this.renderer_.hasFeatureAtCoordinate(r,this.frameState_,i,o,n,null)},e.prototype.getEventCoordinate=function(t){return this.getCoordinateFromPixel(this.getEventPixel(t))},e.prototype.getEventCoordinateInternal=function(t){return this.getCoordinateFromPixelInternal(this.getEventPixel(t))},e.prototype.getEventPixel=function(t){var e=this.viewport_.getBoundingClientRect(),r="changedTouches"in t?t.changedTouches[0]:t;return[r.clientX-e.left,r.clientY-e.top]},e.prototype.getTarget=function(){return this.get(ua)},e.prototype.getTargetElement=function(){var t=this.getTarget();return void 0!==t?"string"==typeof t?document.getElementById(t):t:null},e.prototype.getCoordinateFromPixel=function(t){return Fr(this.getCoordinateFromPixelInternal(t),this.getView().getProjection())},e.prototype.getCoordinateFromPixelInternal=function(t){var e=this.frameState_;return e?Tt(e.pixelToCoordinateTransform,t.slice()):null},e.prototype.getControls=function(){return this.controls},e.prototype.getOverlays=function(){return this.overlays_},e.prototype.getOverlayById=function(t){var e=this.overlayIdIndex_[t.toString()];return void 0!==e?e:null},e.prototype.getInteractions=function(){return this.interactions},e.prototype.getLayerGroup=function(){return this.get(aa)},e.prototype.getLayers=function(){return this.getLayerGroup().getLayers()},e.prototype.getLoading=function(){for(var t=this.getLayerGroup().getLayerStatesArray(),e=0,r=t.length;e<r;++e){var n=t[e].layer.getSource();if(n&&n.loading)return!0}return!1},e.prototype.getPixelFromCoordinate=function(t){var e=Ar(t,this.getView().getProjection());return this.getPixelFromCoordinateInternal(e)},e.prototype.getPixelFromCoordinateInternal=function(t){var e=this.frameState_;return e?Tt(e.coordinateToPixelTransform,t.slice(0,2)):null},e.prototype.getRenderer=function(){return this.renderer_},e.prototype.getSize=function(){return this.get(sa)},e.prototype.getView=function(){return this.get(la)},e.prototype.getViewport=function(){return this.viewport_},e.prototype.getOverlayContainer=function(){return this.overlayContainer_},e.prototype.getOverlayContainerStopEvent=function(){return this.overlayContainerStopEvent_},e.prototype.getTilePriority=function(t,e,r,n){return function(t,e,r,n,i){if(!t||!(r in t.wantedTiles))return 1/0;if(!t.wantedTiles[r][e.getKey()])return 1/0;var o=t.viewState.center,a=n[0]-o[0],s=n[1]-o[1];return 65536*Math.log(i)+Math.sqrt(a*a+s*s)/i}(this.frameState_,t,e,r,n)},e.prototype.handleBrowserEvent=function(t,e){var r=e||t.type,n=new Ko(r,this,t);this.handleMapBrowserEvent(n)},e.prototype.handleMapBrowserEvent=function(t){if(this.frameState_){var e=t.originalEvent,r=e.type;if(r===$o||r===V||r===D){var n=this.viewport_.getRootNode?this.viewport_.getRootNode():document,i=n===document?e.target:n.elementFromPoint(e.clientX,e.clientY);if(this.overlayContainerStopEvent_.contains(i)||!(n===document?document.documentElement:n).contains(i))return}t.frameState=this.frameState_;var o=this.getInteractions().getArray();if(!1!==this.dispatchEvent(t))for(var a=o.length-1;a>=0;a--){var s=o[a];if(s.getActive())if(!s.handleEvent(t))break}}},e.prototype.handlePostRender=function(){var t=this.frameState_,e=this.tileQueue_;if(!e.isEmpty()){var r=this.maxTilesLoading_,n=r;if(t){var i=t.viewHints;if(i[va]||i[_a]){var o=!zi&&Date.now()-t.time>8;r=o?0:8,n=o?0:2}}e.getTilesLoading()<r&&(e.reprioritize(),e.loadMoreTiles(r,n))}!t||!this.hasListener(Ti)||t.animate||this.tileQueue_.getTilesLoading()||this.getLoading()||this.renderer_.dispatchRenderEvent(Ti,t);for(var a=this.postRenderFunctions_,s=0,u=a.length;s<u;++s)a[s](this,t);a.length=0},e.prototype.handleSizeChanged_=function(){this.getView()&&!this.getView().getAnimating()&&this.getView().resolveConstraints(0),this.render()},e.prototype.handleTargetChanged_=function(){var t;if(this.getTarget()&&(t=this.getTargetElement()),this.mapBrowserEventHandler_){for(var e=0,r=this.keyHandlerKeys_.length;e<r;++e)X(this.keyHandlerKeys_[e]);this.keyHandlerKeys_=null,this.viewport_.removeEventListener(F,this.boundHandleBrowserEvent_),this.viewport_.removeEventListener(V,this.boundHandleBrowserEvent_),void 0!==this.handleResize_&&(removeEventListener(B,this.handleResize_,!1),this.handleResize_=void 0),this.mapBrowserEventHandler_.dispose(),this.mapBrowserEventHandler_=null,qi(this.viewport_)}if(t){for(var n in t.appendChild(this.viewport_),this.renderer_||(this.renderer_=this.createRenderer()),this.mapBrowserEventHandler_=new ra(this,this.moveTolerance_),Ho)this.mapBrowserEventHandler_.addEventListener(Ho[n],this.handleMapBrowserEvent.bind(this));this.viewport_.addEventListener(F,this.boundHandleBrowserEvent_,!1),this.viewport_.addEventListener(V,this.boundHandleBrowserEvent_,!!Ui&&{passive:!1});var i=this.keyboardEventTarget_?this.keyboardEventTarget_:t;this.keyHandlerKeys_=[W(i,D,this.handleBrowserEvent,this),W(i,z,this.handleBrowserEvent,this)],this.handleResize_||(this.handleResize_=this.updateSize.bind(this),window.addEventListener(B,this.handleResize_,!1))}else this.renderer_&&(clearTimeout(this.postRenderTimeoutHandle_),this.postRenderFunctions_.length=0,this.renderer_.dispose(),this.renderer_=null),this.animationDelayKey_&&(cancelAnimationFrame(this.animationDelayKey_),this.animationDelayKey_=void 0);this.updateSize()},e.prototype.handleTileChange_=function(){this.render()},e.prototype.handleViewPropertyChanged_=function(){this.render()},e.prototype.handleViewChanged_=function(){this.viewPropertyListenerKey_&&(X(this.viewPropertyListenerKey_),this.viewPropertyListenerKey_=null),this.viewChangeListenerKey_&&(X(this.viewChangeListenerKey_),this.viewChangeListenerKey_=null);var t=this.getView();t&&(this.updateViewportSize_(),this.viewPropertyListenerKey_=W(t,c,this.handleViewPropertyChanged_,this),this.viewChangeListenerKey_=W(t,I,this.handleViewPropertyChanged_,this),t.resolveConstraints(0)),this.render()},e.prototype.handleLayerGroupChanged_=function(){this.layerGroupPropertyListenerKeys_&&(this.layerGroupPropertyListenerKeys_.forEach(X),this.layerGroupPropertyListenerKeys_=null);var t=this.getLayerGroup();t&&(this.layerGroupPropertyListenerKeys_=[W(t,c,this.render,this),W(t,I,this.render,this)]),this.render()},e.prototype.isRendered=function(){return!!this.frameState_},e.prototype.renderSync=function(){this.animationDelayKey_&&cancelAnimationFrame(this.animationDelayKey_),this.animationDelay_()},e.prototype.redrawText=function(){for(var t=this.getLayerGroup().getLayerStatesArray(),e=0,r=t.length;e<r;++e){var n=t[e].layer;n.hasRenderer()&&n.getRenderer().handleFontsChanged()}},e.prototype.render=function(){this.renderer_&&void 0===this.animationDelayKey_&&(this.animationDelayKey_=requestAnimationFrame(this.animationDelay_))},e.prototype.removeControl=function(t){return this.getControls().remove(t)},e.prototype.removeInteraction=function(t){return this.getInteractions().remove(t)},e.prototype.removeLayer=function(t){return this.getLayerGroup().getLayers().remove(t)},e.prototype.removeOverlay=function(t){return this.getOverlays().remove(t)},e.prototype.renderFrame_=function(t){var e=this.getSize(),r=this.getView(),n=this.frameState_,i=null;if(void 0!==e&&function(t){return t[0]>0&&t[1]>0}(e)&&r&&r.isDef()){var o=r.getHints(this.frameState_?this.frameState_.viewHints:void 0),a=r.getState();i={animate:!1,coordinateToPixelTransform:this.coordinateToPixelTransform_,declutterItems:n?n.declutterItems:[],extent:he(a.center,a.resolution,a.rotation,e),index:this.frameIndex_++,layerIndex:0,layerStatesArray:this.getLayerGroup().getLayerStatesArray(),pixelRatio:this.pixelRatio_,pixelToCoordinateTransform:this.pixelToCoordinateTransform_,postRenderFunctions:[],size:e,tileQueue:this.tileQueue_,time:t,usedTiles:{},viewState:a,viewHints:o,wantedTiles:{}}}if(this.frameState_=i,this.renderer_.renderFrame(i),i){if(i.animate&&this.render(),Array.prototype.push.apply(this.postRenderFunctions_,i.postRenderFunctions),n)(!this.previousExtent_||!me(this.previousExtent_)&&!$t(i.extent,this.previousExtent_))&&(this.dispatchEvent(new Xo(ia,this,n)),this.previousExtent_=Kt(this.previousExtent_));this.previousExtent_&&!i.viewHints[va]&&!i.viewHints[_a]&&!$t(i.extent,this.previousExtent_)&&(this.dispatchEvent(new Xo(oa,this,i)),Ut(i.extent,this.previousExtent_))}this.dispatchEvent(new Xo(na,this,i)),this.postRenderTimeoutHandle_=setTimeout(this.handlePostRender.bind(this),0)},e.prototype.setLayerGroup=function(t){this.set(aa,t)},e.prototype.setSize=function(t){this.set(sa,t)},e.prototype.setTarget=function(t){this.set(ua,t)},e.prototype.setView=function(t){this.set(la,t)},e.prototype.updateSize=function(){var t=this.getTargetElement();if(t){var e=getComputedStyle(t);this.setSize([t.offsetWidth-parseFloat(e.borderLeftWidth)-parseFloat(e.paddingLeft)-parseFloat(e.paddingRight)-parseFloat(e.borderRightWidth),t.offsetHeight-parseFloat(e.borderTopWidth)-parseFloat(e.paddingTop)-parseFloat(e.paddingBottom)-parseFloat(e.borderBottomWidth)])}else this.setSize(void 0);this.updateViewportSize_()},e.prototype.updateViewportSize_=function(){var t=this.getView();if(t){var e=void 0,r=getComputedStyle(this.viewport_);r.width&&r.height&&(e=[parseInt(r.width,10),parseInt(r.height,10)]),t.setViewportSize(e)}},e}(rt),Ya=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Va=function(t){function e(e){var r=t.call(this)||this,n=e.element;return!n||e.target||n.style.pointerEvents||(n.style.pointerEvents="auto"),r.element=n||null,r.target_=null,r.map_=null,r.listenerKeys=[],e.render&&(r.render=e.render),e.target&&r.setTarget(e.target),r}return Ya(e,t),e.prototype.disposeInternal=function(){qi(this.element),t.prototype.disposeInternal.call(this)},e.prototype.getMap=function(){return this.map_},e.prototype.setMap=function(t){this.map_&&qi(this.element);for(var e=0,r=this.listenerKeys.length;e<r;++e)X(this.listenerKeys[e]);(this.listenerKeys.length=0,this.map_=t,this.map_)&&((this.target_?this.target_:t.getOverlayContainerStopEvent()).appendChild(this.element),this.render!==S&&this.listenerKeys.push(W(t,na,this.render,this)),t.render())},e.prototype.render=function(t){},e.prototype.setTarget=function(t){this.target_="string"==typeof t?document.getElementById(t):t},e}(rt),Wa=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),qa=function(t){function e(e){var r=this,n=e||{};(r=t.call(this,{element:document.createElement("div"),render:n.render,target:n.target})||this).ulElement_=document.createElement("ul"),r.collapsed_=void 0===n.collapsed||n.collapsed,r.overrideCollapsible_=void 0!==n.collapsible,r.collapsible_=void 0===n.collapsible||n.collapsible,r.collapsible_||(r.collapsed_=!1);var i=void 0!==n.className?n.className:"ol-attribution",o=void 0!==n.tipLabel?n.tipLabel:"Attributions",a=void 0!==n.collapseLabel?n.collapseLabel:"»";"string"==typeof a?(r.collapseLabel_=document.createElement("span"),r.collapseLabel_.textContent=a):r.collapseLabel_=a;var s=void 0!==n.label?n.label:"i";"string"==typeof s?(r.label_=document.createElement("span"),r.label_.textContent=s):r.label_=s;var u=r.collapsible_&&!r.collapsed_?r.collapseLabel_:r.label_,l=document.createElement("button");l.setAttribute("type","button"),l.title=o,l.appendChild(u),l.addEventListener(A,r.handleClick_.bind(r),!1);var h=i+" ol-unselectable ol-control"+(r.collapsed_&&r.collapsible_?" ol-collapsed":"")+(r.collapsible_?"":" ol-uncollapsible"),c=r.element;return c.className=h,c.appendChild(r.ulElement_),c.appendChild(l),r.renderedAttributions_=[],r.renderedVisible_=!0,r}return Wa(e,t),e.prototype.collectSourceAttributions_=function(t){for(var e={},r=[],n=t.layerStatesArray,i=0,o=n.length;i<o;++i){var a=n[i];if(Ii(a,t.viewState)){var s=a.layer.getSource();if(s){var u=s.getAttributions();if(u){var l=u(t);if(l)if(this.overrideCollapsible_||!1!==s.getAttributionsCollapsible()||this.setCollapsible(!1),Array.isArray(l))for(var h=0,c=l.length;h<c;++h)l[h]in e||(r.push(l[h]),e[l[h]]=!0);else l in e||(r.push(l),e[l]=!0)}}}}return r},e.prototype.updateElement_=function(t){if(t){var e=this.collectSourceAttributions_(t),r=e.length>0;if(this.renderedVisible_!=r&&(this.element.style.display=r?"":"none",this.renderedVisible_=r),!_(e,this.renderedAttributions_)){Xi(this.ulElement_);for(var n=0,i=e.length;n<i;++n){var o=document.createElement("li");o.innerHTML=e[n],this.ulElement_.appendChild(o)}this.renderedAttributions_=e}}else this.renderedVisible_&&(this.element.style.display="none",this.renderedVisible_=!1)},e.prototype.handleClick_=function(t){t.preventDefault(),this.handleToggle_()},e.prototype.handleToggle_=function(){this.element.classList.toggle("ol-collapsed"),this.collapsed_?Wi(this.collapseLabel_,this.label_):Wi(this.label_,this.collapseLabel_),this.collapsed_=!this.collapsed_},e.prototype.getCollapsible=function(){return this.collapsible_},e.prototype.setCollapsible=function(t){this.collapsible_!==t&&(this.collapsible_=t,this.element.classList.toggle("ol-uncollapsible"),!t&&this.collapsed_&&this.handleToggle_())},e.prototype.setCollapsed=function(t){this.collapsible_&&this.collapsed_!==t&&this.handleToggle_()},e.prototype.getCollapsed=function(){return this.collapsed_},e.prototype.render=function(t){this.updateElement_(t.frameState)},e}(Va),Xa=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Za=function(t){function e(e){var r=this,n=e||{};r=t.call(this,{element:document.createElement("div"),render:n.render,target:n.target})||this;var i=void 0!==n.className?n.className:"ol-rotate",o=void 0!==n.label?n.label:"⇧";r.label_=null,"string"==typeof o?(r.label_=document.createElement("span"),r.label_.className="ol-compass",r.label_.textContent=o):(r.label_=o,r.label_.classList.add("ol-compass"));var a=n.tipLabel?n.tipLabel:"Reset rotation",s=document.createElement("button");s.className=i+"-reset",s.setAttribute("type","button"),s.title=a,s.appendChild(r.label_),s.addEventListener(A,r.handleClick_.bind(r),!1);var u=i+" ol-unselectable ol-control",l=r.element;return l.className=u,l.appendChild(s),r.callResetNorth_=n.resetNorth?n.resetNorth:void 0,r.duration_=void 0!==n.duration?n.duration:250,r.autoHide_=void 0===n.autoHide||n.autoHide,r.rotation_=void 0,r.autoHide_&&r.element.classList.add("ol-hidden"),r}return Xa(e,t),e.prototype.handleClick_=function(t){t.preventDefault(),void 0!==this.callResetNorth_?this.callResetNorth_():this.resetNorth_()},e.prototype.resetNorth_=function(){var t=this.getMap().getView();if(t){var e=t.getRotation();void 0!==e&&(this.duration_>0&&e%(2*Math.PI)!=0?t.animate({rotation:0,duration:this.duration_,easing:La}):t.setRotation(0))}},e.prototype.render=function(t){var e=t.frameState;if(e){var r=e.viewState.rotation;if(r!=this.rotation_){var n="rotate("+r+"rad)";if(this.autoHide_){var i=this.element.classList.contains("ol-hidden");i||0!==r?i&&0!==r&&this.element.classList.remove("ol-hidden"):this.element.classList.add("ol-hidden")}this.label_.style.transform=n}this.rotation_=r}},e}(Va),Ka=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ha=function(t){function e(e){var r=this,n=e||{};r=t.call(this,{element:document.createElement("div"),target:n.target})||this;var i=void 0!==n.className?n.className:"ol-zoom",o=void 0!==n.delta?n.delta:1,a=void 0!==n.zoomInLabel?n.zoomInLabel:"+",s=void 0!==n.zoomOutLabel?n.zoomOutLabel:"−",u=void 0!==n.zoomInTipLabel?n.zoomInTipLabel:"Zoom in",l=void 0!==n.zoomOutTipLabel?n.zoomOutTipLabel:"Zoom out",h=document.createElement("button");h.className=i+"-in",h.setAttribute("type","button"),h.title=u,h.appendChild("string"==typeof a?document.createTextNode(a):a),h.addEventListener(A,r.handleClick_.bind(r,o),!1);var c=document.createElement("button");c.className=i+"-out",c.setAttribute("type","button"),c.title=l,c.appendChild("string"==typeof s?document.createTextNode(s):s),c.addEventListener(A,r.handleClick_.bind(r,-o),!1);var p=i+" ol-unselectable ol-control",f=r.element;return f.className=p,f.appendChild(h),f.appendChild(c),r.duration_=void 0!==n.duration?n.duration:250,r}return Ka(e,t),e.prototype.handleClick_=function(t,e){e.preventDefault(),this.zoomByDelta_(t)},e.prototype.zoomByDelta_=function(t){var e=this.getMap().getView();if(e){var r=e.getZoom();if(void 0!==r){var n=e.getConstrainedZoom(r+t);this.duration_>0?(e.getAnimating()&&e.cancelAnimations(),e.animate({zoom:n,duration:this.duration_,easing:La})):e.setZoom(n)}}},e}(Va);function Ja(t){var e=t||{},r=new ut;return(void 0===e.zoom||e.zoom)&&r.push(new Ha(e.zoomOptions)),(void 0===e.rotate||e.rotate)&&r.push(new Za(e.rotateOptions)),(void 0===e.attribution||e.attribution)&&r.push(new qa(e.attributionOptions)),r}var $a="active",Qa=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function ts(t,e,r,n){var i=t.getZoom();if(void 0!==i){var o=t.getConstrainedZoom(i+e),a=t.getResolutionForZoom(o);t.getAnimating()&&t.cancelAnimations(),t.animate({resolution:a,anchor:r,duration:void 0!==n?n:250,easing:La})}}var es=function(t){function e(e){var r=t.call(this)||this;return e&&e.handleEvent&&(r.handleEvent=e.handleEvent),r.map_=null,r.setActive(!0),r}return Qa(e,t),e.prototype.getActive=function(){return this.get($a)},e.prototype.getMap=function(){return this.map_},e.prototype.handleEvent=function(t){return!0},e.prototype.setActive=function(t){this.set($a,t)},e.prototype.setMap=function(t){this.map_=t},e}(rt),rs=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ns=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.delta_=n.delta?n.delta:1,r.duration_=void 0!==n.duration?n.duration:250,r}return rs(e,t),e.prototype.handleEvent=function(t){var e=!1;if(t.type==Ho.DBLCLICK){var r=t.originalEvent,n=t.map,i=t.coordinate,o=r.shiftKey?-this.delta_:this.delta_;ts(n.getView(),o,i,this.duration_),t.preventDefault(),e=!0}return!e},e}(es),is=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function os(t){for(var e=t.length,r=0,n=0,i=0;i<e;i++)r+=t[i].clientX,n+=t[i].clientY;return[r/e,n/e]}var as=function(t){function e(e){var r=this,n=e||{};return r=t.call(this,n)||this,n.handleDownEvent&&(r.handleDownEvent=n.handleDownEvent),n.handleDragEvent&&(r.handleDragEvent=n.handleDragEvent),n.handleMoveEvent&&(r.handleMoveEvent=n.handleMoveEvent),n.handleUpEvent&&(r.handleUpEvent=n.handleUpEvent),n.stopDown&&(r.stopDown=n.stopDown),r.handlingDownUpSequence=!1,r.trackedPointers_={},r.targetPointers=[],r}return is(e,t),e.prototype.getPointerCount=function(){return this.targetPointers.length},e.prototype.handleDownEvent=function(t){return!1},e.prototype.handleDragEvent=function(t){},e.prototype.handleEvent=function(t){if(!t.originalEvent)return!0;var e=!1;if(this.updateTrackedPointers_(t),this.handlingDownUpSequence){if(t.type==Ho.POINTERDRAG)this.handleDragEvent(t),t.preventDefault();else if(t.type==Ho.POINTERUP){var r=this.handleUpEvent(t);this.handlingDownUpSequence=r&&this.targetPointers.length>0}}else if(t.type==Ho.POINTERDOWN){var n=this.handleDownEvent(t);this.handlingDownUpSequence=n,e=this.stopDown(n)}else t.type==Ho.POINTERMOVE&&this.handleMoveEvent(t);return!e},e.prototype.handleMoveEvent=function(t){},e.prototype.handleUpEvent=function(t){return!1},e.prototype.stopDown=function(t){return t},e.prototype.updateTrackedPointers_=function(t){if(function(t){var e=t.type;return e===Ho.POINTERDOWN||e===Ho.POINTERDRAG||e===Ho.POINTERUP}(t)){var e=t.originalEvent,r=e.pointerId.toString();t.type==Ho.POINTERUP?delete this.trackedPointers_[r]:(t.type==Ho.POINTERDOWN||r in this.trackedPointers_)&&(this.trackedPointers_[r]=e),this.targetPointers=C(this.trackedPointers_)}},e}(es);function ss(t){var e=arguments;return function(t){for(var r=!0,n=0,i=e.length;n<i&&(r=r&&e[n](t));++n);return r}}var us=function(t){var e=t.originalEvent;return e.altKey&&!(e.metaKey||e.ctrlKey)&&!e.shiftKey},ls=function(t){var e=t.originalEvent;return e.altKey&&!(e.metaKey||e.ctrlKey)&&e.shiftKey},hs=function(t){return t.target.getTargetElement().contains(document.activeElement)},cs=function(t){return!t.map.getTargetElement().hasAttribute("tabindex")||hs(t)},ps=x,fs=function(t){var e=t.originalEvent;return 0==e.button&&!(Ni&&ji&&e.ctrlKey)},ds=w,gs=function(t){return t.type==Ho.SINGLECLICK},ys=function(t){var e=t.originalEvent;return!e.altKey&&!(e.metaKey||e.ctrlKey)&&!e.shiftKey},ms=function(t){var e=t.originalEvent;return!e.altKey&&!(e.metaKey||e.ctrlKey)&&e.shiftKey},vs=function(t){var e=t.originalEvent.target.tagName;return"INPUT"!==e&&"SELECT"!==e&&"TEXTAREA"!==e},_s=function(t){var e=t.originalEvent;return lt(void 0!==e,56),"mouse"==e.pointerType},bs=function(t){var e=t.originalEvent;return lt(void 0!==e,56),e.isPrimary&&0===e.button},xs=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ws=function(t){function e(e){var r=t.call(this,{stopDown:w})||this,n=e||{};r.kinetic_=n.kinetic,r.lastCentroid=null,r.lastPointersCount_,r.panning_=!1;var i=n.condition?n.condition:ss(ys,bs);return r.condition_=n.onFocusOnly?ss(cs,i):i,r.noKinetic_=!1,r}return xs(e,t),e.prototype.handleDragEvent=function(t){this.panning_||(this.panning_=!0,this.getMap().getView().beginInteraction());var e=this.targetPointers,r=os(e);if(e.length==this.lastPointersCount_){if(this.kinetic_&&this.kinetic_.update(r[0],r[1]),this.lastCentroid){var n=[this.lastCentroid[0]-r[0],r[1]-this.lastCentroid[1]],i=t.map.getView();ar(n,i.getResolution()),or(n,i.getRotation()),i.adjustCenterInternal(n)}}else this.kinetic_&&this.kinetic_.begin();this.lastCentroid=r,this.lastPointersCount_=e.length,t.originalEvent.preventDefault()},e.prototype.handleUpEvent=function(t){var e=t.map,r=e.getView();if(0===this.targetPointers.length){if(!this.noKinetic_&&this.kinetic_&&this.kinetic_.end()){var n=this.kinetic_.getDistance(),i=this.kinetic_.getAngle(),o=r.getCenterInternal(),a=e.getPixelFromCoordinateInternal(o),s=e.getCoordinateFromPixelInternal([a[0]-n*Math.cos(i),a[1]-n*Math.sin(i)]);r.animateInternal({center:r.getConstrainedCenter(s),duration:500,easing:La})}return this.panning_&&(this.panning_=!1,r.endInteraction()),!1}return this.kinetic_&&this.kinetic_.begin(),this.lastCentroid=null,!0},e.prototype.handleDownEvent=function(t){if(this.targetPointers.length>0&&this.condition_(t)){var e=t.map.getView();return this.lastCentroid=null,e.getAnimating()&&e.cancelAnimations(),this.kinetic_&&this.kinetic_.begin(),this.noKinetic_=this.targetPointers.length>1,!0}return!1},e}(as),Ss=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ts=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,{stopDown:w})||this).condition_=n.condition?n.condition:ls,r.lastAngle_=void 0,r.duration_=void 0!==n.duration?n.duration:250,r}return Ss(e,t),e.prototype.handleDragEvent=function(t){if(_s(t)){var e=t.map,r=e.getView();if(r.getConstraints().rotation!==Ra){var n=e.getSize(),i=t.pixel,o=Math.atan2(n[1]/2-i[1],i[0]-n[0]/2);if(void 0!==this.lastAngle_){var a=o-this.lastAngle_;r.adjustRotationInternal(-a)}this.lastAngle_=o}}},e.prototype.handleUpEvent=function(t){return!_s(t)||(t.map.getView().endInteraction(this.duration_),!1)},e.prototype.handleDownEvent=function(t){return!!_s(t)&&(!(!fs(t)||!this.condition_(t))&&(t.map.getView().beginInteraction(),this.lastAngle_=void 0,!0))},e}(as),Es=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Cs=function(t){function e(e){var r=t.call(this)||this;return r.geometry_=null,r.element_=document.createElement("div"),r.element_.style.position="absolute",r.element_.style.pointerEvents="auto",r.element_.className="ol-box "+e,r.map_=null,r.startPixel_=null,r.endPixel_=null,r}return Es(e,t),e.prototype.disposeInternal=function(){this.setMap(null)},e.prototype.render_=function(){var t=this.startPixel_,e=this.endPixel_,r=this.element_.style;r.left=Math.min(t[0],e[0])+"px",r.top=Math.min(t[1],e[1])+"px",r.width=Math.abs(e[0]-t[0])+"px",r.height=Math.abs(e[1]-t[1])+"px"},e.prototype.setMap=function(t){if(this.map_){this.map_.getOverlayContainer().removeChild(this.element_);var e=this.element_.style;e.left="inherit",e.top="inherit",e.width="inherit",e.height="inherit"}this.map_=t,this.map_&&this.map_.getOverlayContainer().appendChild(this.element_)},e.prototype.setPixels=function(t,e){this.startPixel_=t,this.endPixel_=e,this.createOrUpdateGeometry(),this.render_()},e.prototype.createOrUpdateGeometry=function(){var t=this.startPixel_,e=this.endPixel_,r=[t,[t[0],e[1]],e,[e[0],t[1]]].map(this.map_.getCoordinateFromPixelInternal,this.map_);r[4]=r[0].slice(),this.geometry_?this.geometry_.setCoordinates([r]):this.geometry_=new Ln([r])},e.prototype.getGeometry=function(){return this.geometry_},e}(p),Ps=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Rs="boxstart",Os="boxdrag",Is="boxend",Ls=function(t){function e(e,r,n){var i=t.call(this,e)||this;return i.coordinate=r,i.mapBrowserEvent=n,i}return Ps(e,t),e}(h),Ms=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.box_=new Cs(n.className||"ol-dragbox"),r.minArea_=void 0!==n.minArea?n.minArea:64,n.onBoxEnd&&(r.onBoxEnd=n.onBoxEnd),r.startPixel_=null,r.condition_=n.condition?n.condition:fs,r.boxEndCondition_=n.boxEndCondition?n.boxEndCondition:r.defaultBoxEndCondition,r}return Ps(e,t),e.prototype.defaultBoxEndCondition=function(t,e,r){var n=r[0]-e[0],i=r[1]-e[1];return n*n+i*i>=this.minArea_},e.prototype.getGeometry=function(){return this.box_.getGeometry()},e.prototype.handleDragEvent=function(t){this.box_.setPixels(this.startPixel_,t.pixel),this.dispatchEvent(new Ls(Os,t.coordinate,t))},e.prototype.handleUpEvent=function(t){return this.box_.setMap(null),this.boxEndCondition_(t,this.startPixel_,t.pixel)&&(this.onBoxEnd(t),this.dispatchEvent(new Ls(Is,t.coordinate,t))),!1},e.prototype.handleDownEvent=function(t){return!!this.condition_(t)&&(this.startPixel_=t.pixel,this.box_.setMap(t.map),this.box_.setPixels(this.startPixel_,this.startPixel_),this.dispatchEvent(new Ls(Rs,t.coordinate,t)),!0)},e.prototype.onBoxEnd=function(t){},e}(as),Fs=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),As=function(t){function e(e){var r=this,n=e||{},i=n.condition?n.condition:ms;return(r=t.call(this,{condition:i,className:n.className||"ol-dragzoom",minArea:n.minArea})||this).duration_=void 0!==n.duration?n.duration:200,r.out_=void 0!==n.out&&n.out,r}return Fs(e,t),e.prototype.onBoxEnd=function(t){var e,r,n=this.getMap(),i=n.getView(),o=n.getSize(),a=this.getGeometry().getExtent();if(this.out_){var s=i.calculateExtentInternal(o),u=(e=[n.getPixelFromCoordinateInternal(ae(a)),n.getPixelFromCoordinateInternal(de(a))],ee(Kt(r),e));ve(s,1/i.getResolutionForExtentInternal(u,o)),a=s}var l=i.getConstrainedResolution(i.getResolutionForExtentInternal(a,o)),h=i.getConstrainedCenter(ue(a),l);i.animateInternal({resolution:l,center:h,duration:this.duration_,easing:La})},e}(Ms),ks=37,Ns=38,js=39,Gs=40,Ds=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),zs=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.defaultCondition_=function(t){return ys(t)&&vs(t)},r.condition_=void 0!==n.condition?n.condition:r.defaultCondition_,r.duration_=void 0!==n.duration?n.duration:100,r.pixelDelta_=void 0!==n.pixelDelta?n.pixelDelta:128,r}return Ds(e,t),e.prototype.handleEvent=function(t){var e=!1;if(t.type==D){var r=t.originalEvent.keyCode;if(this.condition_(t)&&(r==Gs||r==ks||r==js||r==Ns)){var n=t.map.getView(),i=n.getResolution()*this.pixelDelta_,o=0,a=0;r==Gs?a=-i:r==ks?o=-i:r==js?o=i:a=i;var s=[o,a];or(s,n.getRotation()),function(t,e,r){var n=t.getCenterInternal();if(n){var i=[n[0]+e[0],n[1]+e[1]];t.animateInternal({duration:void 0!==r?r:250,easing:Fa,center:t.getConstrainedCenter(i)})}}(n,s,this.duration_),t.preventDefault(),e=!0}}return!e},e}(es),Us=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Bs=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.condition_=n.condition?n.condition:vs,r.delta_=n.delta?n.delta:1,r.duration_=void 0!==n.duration?n.duration:100,r}return Us(e,t),e.prototype.handleEvent=function(t){var e=!1;if(t.type==D||t.type==z){var r=t.originalEvent.charCode;if(this.condition_(t)&&(r=="+".charCodeAt(0)||r=="-".charCodeAt(0))){var n=t.map,i=r=="+".charCodeAt(0)?this.delta_:-this.delta_;ts(n.getView(),i,void 0,this.duration_),t.preventDefault(),e=!0}}return!e},e}(es),Ys=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Vs="trackpad",Ws="wheel",qs=function(t){function e(e){var r=this,n=e||{};(r=t.call(this,n)||this).totalDelta_=0,r.lastDelta_=0,r.maxDelta_=void 0!==n.maxDelta?n.maxDelta:1,r.duration_=void 0!==n.duration?n.duration:250,r.timeout_=void 0!==n.timeout?n.timeout:80,r.useAnchor_=void 0===n.useAnchor||n.useAnchor,r.constrainResolution_=void 0!==n.constrainResolution&&n.constrainResolution;var i=n.condition?n.condition:ps;return r.condition_=n.onFocusOnly?ss(cs,i):i,r.lastAnchor_=null,r.startTime_=void 0,r.timeoutId_,r.mode_=void 0,r.trackpadEventGap_=400,r.trackpadTimeoutId_,r.deltaPerZoom_=300,r}return Ys(e,t),e.prototype.endInteraction_=function(){this.trackpadTimeoutId_=void 0,this.getMap().getView().endInteraction(void 0,this.lastDelta_?this.lastDelta_>0?1:-1:0,this.lastAnchor_)},e.prototype.handleEvent=function(t){if(!this.condition_(t))return!0;if(t.type!==V)return!0;t.preventDefault();var e,r=t.map,n=t.originalEvent;if(this.useAnchor_&&(this.lastAnchor_=t.coordinate),t.type==V&&(e=n.deltaY,ki&&n.deltaMode===WheelEvent.DOM_DELTA_PIXEL&&(e/=Gi),n.deltaMode===WheelEvent.DOM_DELTA_LINE&&(e*=40)),0===e)return!1;this.lastDelta_=e;var i=Date.now();void 0===this.startTime_&&(this.startTime_=i),(!this.mode_||i-this.startTime_>this.trackpadEventGap_)&&(this.mode_=Math.abs(e)<4?Vs:Ws);var o=r.getView();if(this.mode_===Vs&&!o.getConstrainResolution()&&!this.constrainResolution_)return this.trackpadTimeoutId_?clearTimeout(this.trackpadTimeoutId_):(o.getAnimating()&&o.cancelAnimations(),o.beginInteraction()),this.trackpadTimeoutId_=setTimeout(this.endInteraction_.bind(this),this.timeout_),o.adjustZoom(-e/this.deltaPerZoom_,this.lastAnchor_),this.startTime_=i,!1;this.totalDelta_+=e;var a=Math.max(this.timeout_-(i-this.startTime_),0);return clearTimeout(this.timeoutId_),this.timeoutId_=setTimeout(this.handleWheelZoom_.bind(this,r),a),!1},e.prototype.handleWheelZoom_=function(t){var e=t.getView();e.getAnimating()&&e.cancelAnimations();var r=-we(this.totalDelta_,-this.maxDelta_*this.deltaPerZoom_,this.maxDelta_*this.deltaPerZoom_)/this.deltaPerZoom_;(e.getConstrainResolution()||this.constrainResolution_)&&(r=r?r>0?1:-1:0),ts(e,r,this.lastAnchor_,this.duration_),this.mode_=void 0,this.totalDelta_=0,this.lastAnchor_=null,this.startTime_=void 0,this.timeoutId_=void 0},e.prototype.setMouseAnchor=function(t){this.useAnchor_=t,t||(this.lastAnchor_=null)},e}(es),Xs=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Zs=function(t){function e(e){var r=this,n=e||{},i=n;return i.stopDown||(i.stopDown=w),(r=t.call(this,i)||this).anchor_=null,r.lastAngle_=void 0,r.rotating_=!1,r.rotationDelta_=0,r.threshold_=void 0!==n.threshold?n.threshold:.3,r.duration_=void 0!==n.duration?n.duration:250,r}return Xs(e,t),e.prototype.handleDragEvent=function(t){var e=0,r=this.targetPointers[0],n=this.targetPointers[1],i=Math.atan2(n.clientY-r.clientY,n.clientX-r.clientX);if(void 0!==this.lastAngle_){var o=i-this.lastAngle_;this.rotationDelta_+=o,!this.rotating_&&Math.abs(this.rotationDelta_)>this.threshold_&&(this.rotating_=!0),e=o}this.lastAngle_=i;var a=t.map,s=a.getView();if(s.getConstraints().rotation!==Ra){var u=a.getViewport().getBoundingClientRect(),l=os(this.targetPointers);l[0]-=u.left,l[1]-=u.top,this.anchor_=a.getCoordinateFromPixelInternal(l),this.rotating_&&(a.render(),s.adjustRotationInternal(e,this.anchor_))}},e.prototype.handleUpEvent=function(t){return!(this.targetPointers.length<2)||(t.map.getView().endInteraction(this.duration_),!1)},e.prototype.handleDownEvent=function(t){if(this.targetPointers.length>=2){var e=t.map;return this.anchor_=null,this.lastAngle_=void 0,this.rotating_=!1,this.rotationDelta_=0,this.handlingDownUpSequence||e.getView().beginInteraction(),!0}return!1},e}(as),Ks=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Hs=function(t){function e(e){var r=this,n=e||{},i=n;return i.stopDown||(i.stopDown=w),(r=t.call(this,i)||this).anchor_=null,r.duration_=void 0!==n.duration?n.duration:400,r.lastDistance_=void 0,r.lastScaleDelta_=1,r}return Ks(e,t),e.prototype.handleDragEvent=function(t){var e=1,r=this.targetPointers[0],n=this.targetPointers[1],i=r.clientX-n.clientX,o=r.clientY-n.clientY,a=Math.sqrt(i*i+o*o);void 0!==this.lastDistance_&&(e=this.lastDistance_/a),this.lastDistance_=a;var s=t.map,u=s.getView();1!=e&&(this.lastScaleDelta_=e);var l=s.getViewport().getBoundingClientRect(),h=os(this.targetPointers);h[0]-=l.left,h[1]-=l.top,this.anchor_=s.getCoordinateFromPixelInternal(h),s.render(),u.adjustResolutionInternal(e,this.anchor_)},e.prototype.handleUpEvent=function(t){if(this.targetPointers.length<2){var e=t.map.getView(),r=this.lastScaleDelta_>1?1:-1;return e.endInteraction(this.duration_,r),!1}return!0},e.prototype.handleDownEvent=function(t){if(this.targetPointers.length>=2){var e=t.map;return this.anchor_=null,this.lastDistance_=void 0,this.lastScaleDelta_=1,this.handlingDownUpSequence||e.getView().beginInteraction(),!0}return!1},e}(as);function Js(t){var e=t||{},r=new ut,n=new Kn(-.005,.05,100);return(void 0===e.altShiftDragRotate||e.altShiftDragRotate)&&r.push(new Ts),(void 0===e.doubleClickZoom||e.doubleClickZoom)&&r.push(new ns({delta:e.zoomDelta,duration:e.zoomDuration})),(void 0===e.dragPan||e.dragPan)&&r.push(new ws({onFocusOnly:e.onFocusOnly,kinetic:n})),(void 0===e.pinchRotate||e.pinchRotate)&&r.push(new Zs),(void 0===e.pinchZoom||e.pinchZoom)&&r.push(new Hs({duration:e.zoomDuration})),(void 0===e.keyboard||e.keyboard)&&(r.push(new zs),r.push(new Bs({delta:e.zoomDelta,duration:e.zoomDuration}))),(void 0===e.mouseWheelZoom||e.mouseWheelZoom)&&r.push(new qs({onFocusOnly:e.onFocusOnly,duration:e.zoomDuration})),(void 0===e.shiftDragZoom||e.shiftDragZoom)&&r.push(new As({duration:e.zoomDuration})),r}var $s=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Qs=function(t){function e(e){return(e=T({},e)).controls||(e.controls=Ja()),e.interactions||(e.interactions=Js({onFocusOnly:!0})),t.call(this,e)||this}return $s(e,t),e.prototype.createRenderer=function(){return new Bo(this)},e}(Ba),tu="bottom-left",eu="bottom-center",ru="bottom-right",nu="center-left",iu="center-center",ou="center-right",au="top-left",su="top-center",uu="top-right",lu=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),hu="element",cu="map",pu="offset",fu="position",du="positioning",gu=function(t){function e(e){var r=t.call(this)||this;r.options=e,r.id=e.id,r.insertFirst=void 0===e.insertFirst||e.insertFirst,r.stopEvent=void 0===e.stopEvent||e.stopEvent,r.element=document.createElement("div"),r.element.className=void 0!==e.className?e.className:"ol-overlay-container ol-selectable",r.element.style.position="absolute",r.element.style.pointerEvents="auto";var n=e.autoPan;return n&&"object"!=typeof n&&(n={animation:e.autoPanAnimation,margin:e.autoPanMargin}),r.autoPan=n||!1,r.rendered={transform_:"",visible:!0},r.mapPostrenderListenerKey=null,r.addEventListener(et(hu),r.handleElementChanged),r.addEventListener(et(cu),r.handleMapChanged),r.addEventListener(et(pu),r.handleOffsetChanged),r.addEventListener(et(fu),r.handlePositionChanged),r.addEventListener(et(du),r.handlePositioningChanged),void 0!==e.element&&r.setElement(e.element),r.setOffset(void 0!==e.offset?e.offset:[0,0]),r.setPositioning(void 0!==e.positioning?e.positioning:au),void 0!==e.position&&r.setPosition(e.position),r}return lu(e,t),e.prototype.getElement=function(){return this.get(hu)},e.prototype.getId=function(){return this.id},e.prototype.getMap=function(){return this.get(cu)},e.prototype.getOffset=function(){return this.get(pu)},e.prototype.getPosition=function(){return this.get(fu)},e.prototype.getPositioning=function(){return this.get(du)},e.prototype.handleElementChanged=function(){Xi(this.element);var t=this.getElement();t&&this.element.appendChild(t)},e.prototype.handleMapChanged=function(){this.mapPostrenderListenerKey&&(qi(this.element),X(this.mapPostrenderListenerKey),this.mapPostrenderListenerKey=null);var t=this.getMap();if(t){this.mapPostrenderListenerKey=W(t,na,this.render,this),this.updatePixelPosition();var e=this.stopEvent?t.getOverlayContainerStopEvent():t.getOverlayContainer();this.insertFirst?e.insertBefore(this.element,e.childNodes[0]||null):e.appendChild(this.element),this.performAutoPan()}},e.prototype.render=function(){this.updatePixelPosition()},e.prototype.handleOffsetChanged=function(){this.updatePixelPosition()},e.prototype.handlePositionChanged=function(){this.updatePixelPosition(),this.performAutoPan()},e.prototype.handlePositioningChanged=function(){this.updatePixelPosition()},e.prototype.setElement=function(t){this.set(hu,t)},e.prototype.setMap=function(t){this.set(cu,t)},e.prototype.setOffset=function(t){this.set(pu,t)},e.prototype.setPosition=function(t){this.set(fu,t)},e.prototype.performAutoPan=function(){this.autoPan&&this.panIntoView(this.autoPan)},e.prototype.panIntoView=function(t){var e=this.getMap();if(e&&e.getTargetElement()&&this.get(fu)){var r=this.getRect(e.getTargetElement(),e.getSize()),n=this.getElement(),i=this.getRect(n,[Yi(n),Vi(n)]),o=t||{},a=void 0===o.margin?20:o.margin;if(!Vt(r,i)){var s=i[0]-r[0],u=r[2]-i[2],l=i[1]-r[1],h=r[3]-i[3],c=[0,0];if(s<0?c[0]=s-a:u<0&&(c[0]=Math.abs(u)+a),l<0?c[1]=l-a:h<0&&(c[1]=Math.abs(h)+a),0!==c[0]||0!==c[1]){var p=e.getView().getCenterInternal(),f=e.getPixelFromCoordinateInternal(p),d=[f[0]+c[0],f[1]+c[1]],g=o.animation||{};e.getView().animateInternal({center:e.getCoordinateFromPixelInternal(d),duration:g.duration,easing:g.easing})}}}},e.prototype.getRect=function(t,e){var r=t.getBoundingClientRect(),n=r.left+window.pageXOffset,i=r.top+window.pageYOffset;return[n,i,n+e[0],i+e[1]]},e.prototype.setPositioning=function(t){this.set(du,t)},e.prototype.setVisible=function(t){this.rendered.visible!==t&&(this.element.style.display=t?"":"none",this.rendered.visible=t)},e.prototype.updatePixelPosition=function(){var t=this.getMap(),e=this.getPosition();if(t&&t.isRendered()&&e){var r=t.getPixelFromCoordinate(e),n=t.getSize();this.updateRenderedPosition(r,n)}else this.setVisible(!1)},e.prototype.updateRenderedPosition=function(t,e){var r=this.element.style,n=this.getOffset(),i=this.getPositioning();this.setVisible(!0);var o=Math.round(t[0]+n[0])+"px",a=Math.round(t[1]+n[1])+"px",s="0%",u="0%";i==ru||i==ou||i==uu?s="-100%":i!=eu&&i!=iu&&i!=su||(s="-50%"),i==tu||i==eu||i==ru?u="-100%":i!=nu&&i!=iu&&i!=ou||(u="-50%");var l="translate("+s+", "+u+") translate("+o+", "+a+")";this.rendered.transform_!=l&&(this.rendered.transform_=l,r.transform=l,r.msTransform=l)},e.prototype.getOptions=function(){return this.options},e}(rt),yu="arraybuffer",mu="json",vu="text",_u="xml",bu=!1;function xu(t,e,r,n){return function(i,o,a){var s=new XMLHttpRequest;s.open("GET","function"==typeof t?t(i,o,a):t,!0),e.getType()==yu&&(s.responseType="arraybuffer"),s.withCredentials=bu,s.onload=function(t){if(!s.status||s.status>=200&&s.status<300){var o=e.getType(),u=void 0;o==mu||o==vu?u=s.responseText:o==_u?(u=s.responseXML)||(u=(new DOMParser).parseFromString(s.responseText,"application/xml")):o==yu&&(u=s.response),u?r.call(this,e.readFeatures(u,{extent:i,featureProjection:a}),e.readProjection(u)):n.call(this)}else n.call(this)}.bind(this),s.onerror=function(){n.call(this)}.bind(this),s.send()}}function wu(t,e){return xu(t,e,(function(t,e){"function"==typeof this.addFeatures&&this.addFeatures(t)}),S)}function Su(t,e){return[[-1/0,-1/0,1/0,1/0]]}var Tu=function(){function t(t,e,r,n){this.minX=t,this.maxX=e,this.minY=r,this.maxY=n}return t.prototype.contains=function(t){return this.containsXY(t[1],t[2])},t.prototype.containsTileRange=function(t){return this.minX<=t.minX&&t.maxX<=this.maxX&&this.minY<=t.minY&&t.maxY<=this.maxY},t.prototype.containsXY=function(t,e){return this.minX<=t&&t<=this.maxX&&this.minY<=e&&e<=this.maxY},t.prototype.equals=function(t){return this.minX==t.minX&&this.minY==t.minY&&this.maxX==t.maxX&&this.maxY==t.maxY},t.prototype.extend=function(t){t.minX<this.minX&&(this.minX=t.minX),t.maxX>this.maxX&&(this.maxX=t.maxX),t.minY<this.minY&&(this.minY=t.minY),t.maxY>this.maxY&&(this.maxY=t.maxY)},t.prototype.getHeight=function(){return this.maxY-this.minY+1},t.prototype.getSize=function(){return[this.getWidth(),this.getHeight()]},t.prototype.getWidth=function(){return this.maxX-this.minX+1},t.prototype.intersects=function(t){return this.minX<=t.maxX&&this.maxX>=t.minX&&this.minY<=t.maxY&&this.maxY>=t.minY},t}();function Eu(t,e,r,n,i){return void 0!==i?(i.minX=t,i.maxX=e,i.minY=r,i.maxY=n,i):new Tu(t,e,r,n)}var Cu=Tu;function Pu(t,e,r,n){return void 0!==n?(n[0]=t,n[1]=e,n[2]=r,n):[t,e,r]}function Ru(t,e,r){return t+"/"+e+"/"+r}function Ou(t){return Ru(t[0],t[1],t[2])}function Iu(t){return t.split("/").map(Number)}function Lu(t){return(t[1]<<t[0])+t[2]}var Mu=[0,0,0],Fu=function(){function t(t){var e,r,n,i;if(this.minZoom=void 0!==t.minZoom?t.minZoom:0,this.resolutions_=t.resolutions,lt((e=this.resolutions_,r=!0,n=function(t,e){return e-t}||f,e.every((function(t,i){if(0===i)return!0;var o=n(e[i-1],t);return!(o>0||r&&0===o)}))),17),!t.origins)for(var o=0,a=this.resolutions_.length-1;o<a;++o)if(i){if(this.resolutions_[o]/this.resolutions_[o+1]!==i){i=void 0;break}}else i=this.resolutions_[o]/this.resolutions_[o+1];this.zoomFactor_=i,this.maxZoom=this.resolutions_.length-1,this.origin_=void 0!==t.origin?t.origin:null,this.origins_=null,void 0!==t.origins&&(this.origins_=t.origins,lt(this.origins_.length==this.resolutions_.length,20));var s=t.extent;void 0===s||this.origin_||this.origins_||(this.origin_=fe(s)),lt(!this.origin_&&this.origins_||this.origin_&&!this.origins_,18),this.tileSizes_=null,void 0!==t.tileSizes&&(this.tileSizes_=t.tileSizes,lt(this.tileSizes_.length==this.resolutions_.length,19)),this.tileSize_=void 0!==t.tileSize?t.tileSize:this.tileSizes_?null:256,lt(!this.tileSize_&&this.tileSizes_||this.tileSize_&&!this.tileSizes_,22),this.extent_=void 0!==s?s:null,this.fullTileRanges_=null,this.tmpSize_=[0,0],void 0!==t.sizes?this.fullTileRanges_=t.sizes.map((function(t,e){return new Cu(Math.min(0,t[0]),Math.max(t[0]-1,-1),Math.min(0,t[1]),Math.max(t[1]-1,-1))}),this):s&&this.calculateTileRanges_(s)}return t.prototype.forEachTileCoord=function(t,e,r){for(var n=this.getTileRangeForExtentAndZ(t,e),i=n.minX,o=n.maxX;i<=o;++i)for(var a=n.minY,s=n.maxY;a<=s;++a)r([e,i,a])},t.prototype.forEachTileCoordParentTileRange=function(t,e,r,n){var i,o,a=null,s=t[0]-1;for(2===this.zoomFactor_?(i=t[1],o=t[2]):a=this.getTileCoordExtent(t,n);s>=this.minZoom;){if(e(s,2===this.zoomFactor_?Eu(i=Math.floor(i/2),i,o=Math.floor(o/2),o,r):this.getTileRangeForExtentAndZ(a,s,r)))return!0;--s}return!1},t.prototype.getExtent=function(){return this.extent_},t.prototype.getMaxZoom=function(){return this.maxZoom},t.prototype.getMinZoom=function(){return this.minZoom},t.prototype.getOrigin=function(t){return this.origin_?this.origin_:this.origins_[t]},t.prototype.getResolution=function(t){return this.resolutions_[t]},t.prototype.getResolutions=function(){return this.resolutions_},t.prototype.getTileCoordChildTileRange=function(t,e,r){if(t[0]<this.maxZoom){if(2===this.zoomFactor_){var n=2*t[1],i=2*t[2];return Eu(n,n+1,i,i+1,e)}var o=this.getTileCoordExtent(t,r);return this.getTileRangeForExtentAndZ(o,t[0]+1,e)}return null},t.prototype.getTileRangeExtent=function(t,e,r){var n=this.getOrigin(t),i=this.getResolution(t),o=za(this.getTileSize(t),this.tmpSize_),a=n[0]+e.minX*o[0]*i,s=n[0]+(e.maxX+1)*o[0]*i;return Zt(a,n[1]+e.minY*o[1]*i,s,n[1]+(e.maxY+1)*o[1]*i,r)},t.prototype.getTileRangeForExtentAndZ=function(t,e,r){var n=Mu;this.getTileCoordForXYAndZ_(t[0],t[3],e,!1,n);var i=n[1],o=n[2];return this.getTileCoordForXYAndZ_(t[2],t[1],e,!0,n),Eu(i,n[1],o,n[2],r)},t.prototype.getTileCoordCenter=function(t){var e=this.getOrigin(t[0]),r=this.getResolution(t[0]),n=za(this.getTileSize(t[0]),this.tmpSize_);return[e[0]+(t[1]+.5)*n[0]*r,e[1]-(t[2]+.5)*n[1]*r]},t.prototype.getTileCoordExtent=function(t,e){var r=this.getOrigin(t[0]),n=this.getResolution(t[0]),i=za(this.getTileSize(t[0]),this.tmpSize_),o=r[0]+t[1]*i[0]*n,a=r[1]-(t[2]+1)*i[1]*n;return Zt(o,a,o+i[0]*n,a+i[1]*n,e)},t.prototype.getTileCoordForCoordAndResolution=function(t,e,r){return this.getTileCoordForXYAndResolution_(t[0],t[1],e,!1,r)},t.prototype.getTileCoordForXYAndResolution_=function(t,e,r,n,i){var o=this.getZForResolution(r),a=r/this.getResolution(o),s=this.getOrigin(o),u=za(this.getTileSize(o),this.tmpSize_),l=n?.5:0,h=n?.5:0,c=Math.floor((t-s[0])/r+l),p=Math.floor((s[1]-e)/r+h),f=a*c/u[0],d=a*p/u[1];return n?(f=Math.ceil(f)-1,d=Math.ceil(d)-1):(f=Math.floor(f),d=Math.floor(d)),Pu(o,f,d,i)},t.prototype.getTileCoordForXYAndZ_=function(t,e,r,n,i){var o=this.getOrigin(r),a=this.getResolution(r),s=za(this.getTileSize(r),this.tmpSize_),u=n?.5:0,l=n?.5:0,h=Math.floor((t-o[0])/a+u),c=Math.floor((o[1]-e)/a+l),p=h/s[0],f=c/s[1];return n?(p=Math.ceil(p)-1,f=Math.ceil(f)-1):(p=Math.floor(p),f=Math.floor(f)),Pu(r,p,f,i)},t.prototype.getTileCoordForCoordAndZ=function(t,e,r){return this.getTileCoordForXYAndZ_(t[0],t[1],e,!1,r)},t.prototype.getTileCoordResolution=function(t){return this.resolutions_[t[0]]},t.prototype.getTileSize=function(t){return this.tileSize_?this.tileSize_:this.tileSizes_[t]},t.prototype.getFullTileRange=function(t){return this.fullTileRanges_?this.fullTileRanges_[t]:null},t.prototype.getZForResolution=function(t,e){return we(g(this.resolutions_,t,e||0),this.minZoom,this.maxZoom)},t.prototype.calculateTileRanges_=function(t){for(var e=this.resolutions_.length,r=new Array(e),n=this.minZoom;n<e;++n)r[n]=this.getTileRangeForExtentAndZ(t,n);this.fullTileRanges_=r},t}();function Au(t){var e=t.getDefaultTileGrid();return e||(e=ju(t),t.setDefaultTileGrid(e)),e}function ku(t){var e=t||{},r=e.extent||yr("EPSG:3857").getExtent(),n={extent:r,minZoom:e.minZoom,tileSize:e.tileSize,resolutions:Nu(r,e.maxZoom,e.tileSize,e.maxResolution)};return new Fu(n)}function Nu(t,e,r,n){for(var i=void 0!==e?e:42,o=ce(t),a=ge(t),s=za(void 0!==r?r:256),u=n>0?n:Math.max(a/s[0],o/s[1]),l=i+1,h=new Array(l),c=0;c<l;++c)h[c]=u/Math.pow(2,c);return h}function ju(t,e,r,n){return function(t,e,r,n){var i=void 0!==n?n:Lt,o=Nu(t,e,r);return new Fu({extent:t,origin:le(t,i),resolutions:o,tileSize:r})}(Gu(t),e,r,n)}function Gu(t){var e=(t=yr(t)).getExtent();if(!e){var r=180*vt[_t.DEGREES]/t.getMetersPerUnit();e=Zt(-r,-r,r,r)}return e}var Du,zu=["experimental-webgl","webgl","webkit-3d","moz-webgl"];function Uu(t,e){for(var r=zu.length,n=0;n<r;++n)try{var i=t.getContext(zu[n],e);if(i)return i}catch(t){}return null}var Bu="http://www.w3.org/2001/XMLSchema-instance";function Yu(t,e){return hl().createElementNS(t,e)}function Vu(t,e){return function t(e,r,n){if(e.nodeType==Node.CDATA_SECTION_NODE||e.nodeType==Node.TEXT_NODE)r?n.push(String(e.nodeValue).replace(/(\r\n|\r|\n)/g,"")):n.push(e.nodeValue);else{var i=void 0;for(i=e.firstChild;i;i=i.nextSibling)t(i,r,n)}return n}(t,e,[]).join("")}function Wu(t){return"documentElement"in t}function qu(t){return(new DOMParser).parseFromString(t,"application/xml")}function Xu(t,e){return function(r,n){var i=t.call(void 0!==e?e:this,r,n);void 0!==i&&m(n[n.length-1],i)}}function Zu(t,e){return function(r,n){var i=t.call(void 0!==e?e:this,r,n);void 0!==i&&n[n.length-1].push(i)}}function Ku(t,e){return function(r,n){var i=t.call(void 0!==e?e:this,r,n);void 0!==i&&(n[n.length-1]=i)}}function Hu(t,e,r){return function(n,i){var o=t.call(void 0!==r?r:this,n,i);if(void 0!==o){var a=i[i.length-1],s=void 0!==e?e:n.localName,u=void 0;s in a?u=a[s]:(u=[],a[s]=u),u.push(o)}}}function Ju(t,e,r){return function(n,i){var o=t.call(void 0!==r?r:this,n,i);void 0!==o&&(i[i.length-1][void 0!==e?e:n.localName]=o)}}function $u(t,e){return function(r,n,i){t.call(void 0!==e?e:this,r,n,i),i[i.length-1].node.appendChild(r)}}function Qu(t,e){var r,n;return function(e,i,o){if(void 0===r){r={};var a={};a[e.localName]=t,r[e.namespaceURI]=a,n=tl(e.localName)}al(r,n,i,o)}}function tl(t,e){var r=t;return function(t,n,i){var o=n[n.length-1].node,a=r;return void 0===a&&(a=i),Yu(void 0!==e?e:o.namespaceURI,a)}}var el=tl();function rl(t,e){for(var r=e.length,n=new Array(r),i=0;i<r;++i)n[i]=t[e[i]];return n}function nl(t,e,r){var n,i,o=void 0!==r?r:{};for(n=0,i=t.length;n<i;++n)o[t[n]]=e;return o}function il(t,e,r,n){var i;for(i=e.firstElementChild;i;i=i.nextElementSibling){var o=t[i.namespaceURI];if(void 0!==o){var a=o[i.localName];void 0!==a&&a.call(n,i,r)}}}function ol(t,e,r,n,i){return n.push(t),il(e,r,n,i),n.pop()}function al(t,e,r,n,i,o){for(var a,s,u=(void 0!==i?i:r).length,l=0;l<u;++l)void 0!==(a=r[l])&&void 0!==(s=e.call(void 0!==o?o:this,a,n,void 0!==i?i[l]:void 0))&&t[s.namespaceURI][s.localName].call(o,s,a,n)}function sl(t,e,r,n,i,o,a){return i.push(t),al(e,r,n,i,o,a),i.pop()}var ul=void 0;var ll=void 0;function hl(){return void 0===ll&&"undefined"!=typeof document&&(ll=document.implementation.createDocument("","",null)),ll}var cl=35044;function pl(t){switch(t){case 34962:return Float32Array;case 34963:return Uint32Array;default:return Float32Array}}var fl=function(){function t(t,e){this.array=null,this.type=t,lt(34962===t||34963===t,62),this.usage=void 0!==e?e:cl}return t.prototype.ofSize=function(t){this.array=new(pl(this.type))(t)},t.prototype.fromArray=function(t){this.array=pl(this.type).from(t)},t.prototype.fromArrayBuffer=function(t){this.array=new(pl(this.type))(t)},t.prototype.getType=function(){return this.type},t.prototype.getArray=function(){return this.array},t.prototype.getUsage=function(){return this.usage},t.prototype.getSize=function(){return this.array?this.array.length:0},t}(),dl="webglcontextlost",gl="webglcontextrestored",yl=function(){function t(t){this.gl_=t.webGlContext;var e=this.gl_;this.scaleRatio_=t.scaleRatio||1,this.renderTargetTexture_=e.createTexture(),this.renderTargetTextureSize_=null,this.frameBuffer_=e.createFramebuffer();var r=e.createShader(e.VERTEX_SHADER);e.shaderSource(r,t.vertexShader||"\n  precision mediump float;\n  \n  attribute vec2 a_position;\n  varying vec2 v_texCoord;\n  varying vec2 v_screenCoord;\n  \n  uniform vec2 u_screenSize;\n   \n  void main() {\n    v_texCoord = a_position * 0.5 + 0.5;\n    v_screenCoord = v_texCoord * u_screenSize;\n    gl_Position = vec4(a_position, 0.0, 1.0);\n  }\n"),e.compileShader(r);var n=e.createShader(e.FRAGMENT_SHADER);e.shaderSource(n,t.fragmentShader||"\n  precision mediump float;\n   \n  uniform sampler2D u_image;\n   \n  varying vec2 v_texCoord;\n   \n  void main() {\n    gl_FragColor = texture2D(u_image, v_texCoord);\n  }\n"),e.compileShader(n),this.renderTargetProgram_=e.createProgram(),e.attachShader(this.renderTargetProgram_,r),e.attachShader(this.renderTargetProgram_,n),e.linkProgram(this.renderTargetProgram_),this.renderTargetVerticesBuffer_=e.createBuffer();e.bindBuffer(e.ARRAY_BUFFER,this.renderTargetVerticesBuffer_),e.bufferData(e.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,1,-1,1,1,-1,1]),e.STATIC_DRAW),this.renderTargetAttribLocation_=e.getAttribLocation(this.renderTargetProgram_,"a_position"),this.renderTargetUniformLocation_=e.getUniformLocation(this.renderTargetProgram_,"u_screenSize"),this.renderTargetTextureLocation_=e.getUniformLocation(this.renderTargetProgram_,"u_image"),this.uniforms_=[],t.uniforms&&Object.keys(t.uniforms).forEach(function(r){this.uniforms_.push({value:t.uniforms[r],location:e.getUniformLocation(this.renderTargetProgram_,r)})}.bind(this))}return t.prototype.getGL=function(){return this.gl_},t.prototype.init=function(t){var e=this.getGL(),r=[e.drawingBufferWidth*this.scaleRatio_,e.drawingBufferHeight*this.scaleRatio_];if(e.bindFramebuffer(e.FRAMEBUFFER,this.getFrameBuffer()),e.viewport(0,0,r[0],r[1]),!this.renderTargetTextureSize_||this.renderTargetTextureSize_[0]!==r[0]||this.renderTargetTextureSize_[1]!==r[1]){this.renderTargetTextureSize_=r;var n=e.RGBA,i=e.RGBA,o=e.UNSIGNED_BYTE;e.bindTexture(e.TEXTURE_2D,this.renderTargetTexture_),e.texImage2D(e.TEXTURE_2D,0,n,r[0],r[1],0,i,o,null),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,e.LINEAR),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.CLAMP_TO_EDGE),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.CLAMP_TO_EDGE),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,this.renderTargetTexture_,0)}},t.prototype.apply=function(t,e){var r=this.getGL(),n=t.size;r.bindFramebuffer(r.FRAMEBUFFER,e?e.getFrameBuffer():null),r.activeTexture(r.TEXTURE0),r.bindTexture(r.TEXTURE_2D,this.renderTargetTexture_),r.clearColor(0,0,0,0),r.clear(r.COLOR_BUFFER_BIT),r.enable(r.BLEND),r.blendFunc(r.ONE,r.ONE_MINUS_SRC_ALPHA),r.viewport(0,0,r.drawingBufferWidth,r.drawingBufferHeight),r.bindBuffer(r.ARRAY_BUFFER,this.renderTargetVerticesBuffer_),r.useProgram(this.renderTargetProgram_),r.enableVertexAttribArray(this.renderTargetAttribLocation_),r.vertexAttribPointer(this.renderTargetAttribLocation_,2,r.FLOAT,!1,0,0),r.uniform2f(this.renderTargetUniformLocation_,n[0],n[1]),r.uniform1i(this.renderTargetTextureLocation_,0),this.applyUniforms(t),r.drawArrays(r.TRIANGLES,0,6)},t.prototype.getFrameBuffer=function(){return this.frameBuffer_},t.prototype.applyUniforms=function(t){var e,r=this.getGL(),n=1;this.uniforms_.forEach((function(i){if((e="function"==typeof i.value?i.value(t):i.value)instanceof HTMLCanvasElement||e instanceof ImageData)i.texture||(i.texture=r.createTexture()),r.activeTexture(r["TEXTURE"+n]),r.bindTexture(r.TEXTURE_2D,i.texture),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MIN_FILTER,r.LINEAR),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_S,r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_T,r.CLAMP_TO_EDGE),e instanceof ImageData?r.texImage2D(r.TEXTURE_2D,0,r.RGBA,r.RGBA,e.width,e.height,0,r.UNSIGNED_BYTE,new Uint8Array(e.data)):r.texImage2D(r.TEXTURE_2D,0,r.RGBA,r.RGBA,r.UNSIGNED_BYTE,e),r.uniform1i(i.location,n++);else if(Array.isArray(e))switch(e.length){case 2:return void r.uniform2f(i.location,e[0],e[1]);case 3:return void r.uniform3f(i.location,e[0],e[1],e[2]);case 4:return void r.uniform4f(i.location,e[0],e[1],e[2],e[3]);default:return}else"number"==typeof e&&r.uniform1f(i.location,e)}))},t}();function ml(t,e){return t[0]=e[0],t[1]=e[1],t[4]=e[2],t[5]=e[3],t[12]=e[4],t[13]=e[5],t}var vl=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),_l="u_projectionMatrix",bl="u_offsetScaleMatrix",xl="u_offsetRotateMatrix",wl="u_time",Sl="u_zoom",Tl="u_resolution",El={UNSIGNED_BYTE:5121,UNSIGNED_SHORT:5123,UNSIGNED_INT:5125,FLOAT:5126};function Cl(t){for(var e=0,r=0;r<t.length;r++){var n=t[r];e+=n.size*Pl(n.type)}return e}function Pl(t){switch(t){case El.UNSIGNED_BYTE:return Uint8Array.BYTES_PER_ELEMENT;case El.UNSIGNED_SHORT:return Uint16Array.BYTES_PER_ELEMENT;case El.UNSIGNED_INT:return Uint32Array.BYTES_PER_ELEMENT;case El.FLOAT:default:return Float32Array.BYTES_PER_ELEMENT}}var Rl=function(t){function e(e){var r=t.call(this)||this,n=e||{};r.boundHandleWebGLContextLost_=r.handleWebGLContextLost.bind(r),r.boundHandleWebGLContextRestored_=r.handleWebGLContextRestored.bind(r),r.canvas_=document.createElement("canvas"),r.canvas_.style.position="absolute",r.canvas_.style.left="0",r.gl_=Uu(r.canvas_);var i=r.getGL();if(r.bufferCache_={},r.currentProgram_=null,lt(d(function(){if(!Du){var t=Uu(document.createElement("canvas"));t&&(Du=t.getSupportedExtensions())}return Du}(),"OES_element_index_uint"),63),i.getExtension("OES_element_index_uint"),r.canvas_.addEventListener(dl,r.boundHandleWebGLContextLost_),r.canvas_.addEventListener(gl,r.boundHandleWebGLContextRestored_),r.offsetRotateMatrix_=[1,0,0,1,0,0],r.offsetScaleMatrix_=[1,0,0,1,0,0],r.tmpMat4_=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],r.uniformLocations_={},r.attribLocations_={},r.uniforms_=[],n.uniforms)for(var o in n.uniforms)r.uniforms_.push({name:o,value:n.uniforms[o]});return r.postProcessPasses_=n.postProcesses?n.postProcesses.map((function(t){return new yl({webGlContext:i,scaleRatio:t.scaleRatio,vertexShader:t.vertexShader,fragmentShader:t.fragmentShader,uniforms:t.uniforms})})):[new yl({webGlContext:i})],r.shaderCompileErrors_=null,r.startTime_=Date.now(),r}return vl(e,t),e.prototype.bindBuffer=function(t){var e=this.getGL(),r=o(t),n=this.bufferCache_[r];n||(n={buffer:t,webGlBuffer:e.createBuffer()},this.bufferCache_[r]=n);e.bindBuffer(t.getType(),n.webGlBuffer)},e.prototype.flushBufferData=function(t){var e=this.getGL();this.bindBuffer(t),e.bufferData(t.getType(),t.getArray(),t.getUsage())},e.prototype.deleteBuffer=function(t){var e=this.getGL(),r=o(t),n=this.bufferCache_[r];e.isContextLost()||e.deleteBuffer(n.buffer),delete this.bufferCache_[r]},e.prototype.disposeInternal=function(){this.canvas_.removeEventListener(dl,this.boundHandleWebGLContextLost_),this.canvas_.removeEventListener(gl,this.boundHandleWebGLContextRestored_)},e.prototype.prepareDraw=function(t){var e=this.getGL(),r=this.getCanvas(),n=t.size,i=t.pixelRatio;r.width=n[0]*i,r.height=n[1]*i,r.style.width=n[0]+"px",r.style.height=n[1]+"px",e.useProgram(this.currentProgram_);for(var o=this.postProcessPasses_.length-1;o>=0;o--)this.postProcessPasses_[o].init(t);e.bindTexture(e.TEXTURE_2D,null),e.clearColor(0,0,0,0),e.clear(e.COLOR_BUFFER_BIT),e.enable(e.BLEND),e.blendFunc(e.ONE,e.ONE_MINUS_SRC_ALPHA),e.useProgram(this.currentProgram_),this.applyFrameState(t),this.applyUniforms(t)},e.prototype.prepareDrawToRenderTarget=function(t,e,r){var n=this.getGL(),i=e.getSize();n.bindFramebuffer(n.FRAMEBUFFER,e.getFramebuffer()),n.viewport(0,0,i[0],i[1]),n.bindTexture(n.TEXTURE_2D,e.getTexture()),n.clearColor(0,0,0,0),n.clear(n.COLOR_BUFFER_BIT),n.enable(n.BLEND),n.blendFunc(n.ONE,r?n.ZERO:n.ONE_MINUS_SRC_ALPHA),n.useProgram(this.currentProgram_),this.applyFrameState(t),this.applyUniforms(t)},e.prototype.drawElements=function(t,e){var r=this.getGL(),n=r.UNSIGNED_INT,i=e-t,o=4*t;r.drawElements(r.TRIANGLES,i,n,o)},e.prototype.finalizeDraw=function(t){for(var e=0;e<this.postProcessPasses_.length;e++)this.postProcessPasses_[e].apply(t,this.postProcessPasses_[e+1]||null)},e.prototype.getCanvas=function(){return this.canvas_},e.prototype.getGL=function(){return this.gl_},e.prototype.applyFrameState=function(t){var e=t.size,r=t.viewState.rotation,n=xt(this.offsetScaleMatrix_);Et(n,2/e[0],2/e[1]);var i,o,a,s,u=xt(this.offsetRotateMatrix_);0!==r&&(i=u,o=-r,a=Math.cos(o),s=Math.sin(o),wt(i,St(bt,a,s,-s,a,0,0))),this.setUniformMatrixValue(bl,ml(this.tmpMat4_,n)),this.setUniformMatrixValue(xl,ml(this.tmpMat4_,u)),this.setUniformFloatValue(wl,.001*(Date.now()-this.startTime_)),this.setUniformFloatValue(Sl,t.viewState.zoom),this.setUniformFloatValue(Tl,t.viewState.resolution)},e.prototype.applyUniforms=function(t){var e,r=this.getGL(),n=0;this.uniforms_.forEach(function(i){if((e="function"==typeof i.value?i.value(t):i.value)instanceof HTMLCanvasElement||e instanceof HTMLImageElement||e instanceof ImageData)i.texture||(i.prevValue=void 0,i.texture=r.createTexture()),r.activeTexture(r["TEXTURE"+n]),r.bindTexture(r.TEXTURE_2D,i.texture),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MIN_FILTER,r.LINEAR),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_S,r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_T,r.CLAMP_TO_EDGE),(!(e instanceof HTMLImageElement)||e.complete)&&i.prevValue!==e&&(i.prevValue=e,r.texImage2D(r.TEXTURE_2D,0,r.RGBA,r.RGBA,r.UNSIGNED_BYTE,e)),r.uniform1i(this.getUniformLocation(i.name),n++);else if(Array.isArray(e)&&6===e.length)this.setUniformMatrixValue(i.name,ml(this.tmpMat4_,e));else if(Array.isArray(e)&&e.length<=4)switch(e.length){case 2:return void r.uniform2f(this.getUniformLocation(i.name),e[0],e[1]);case 3:return void r.uniform3f(this.getUniformLocation(i.name),e[0],e[1],e[2]);case 4:return void r.uniform4f(this.getUniformLocation(i.name),e[0],e[1],e[2],e[3]);default:return}else"number"==typeof e&&r.uniform1f(this.getUniformLocation(i.name),e)}.bind(this))},e.prototype.useProgram=function(t){return t!=this.currentProgram_&&(this.getGL().useProgram(t),this.currentProgram_=t,this.uniformLocations_={},this.attribLocations_={},!0)},e.prototype.compileShader=function(t,e){var r=this.getGL(),n=r.createShader(e);return r.shaderSource(n,t),r.compileShader(n),n},e.prototype.getProgram=function(t,e){var r=this.getGL(),n=this.compileShader(t,r.FRAGMENT_SHADER),i=this.compileShader(e,r.VERTEX_SHADER);this.shaderCompileErrors_=null,r.getShaderInfoLog(n)&&(this.shaderCompileErrors_="Fragment shader compilation failed:\n"+r.getShaderInfoLog(n)),r.getShaderInfoLog(i)&&(this.shaderCompileErrors_=(this.shaderCompileErrors_||"")+"Vertex shader compilation failed:\n"+r.getShaderInfoLog(i));var o=r.createProgram();return r.attachShader(o,n),r.attachShader(o,i),r.linkProgram(o),o},e.prototype.getShaderCompileErrors=function(){return this.shaderCompileErrors_},e.prototype.getUniformLocation=function(t){return void 0===this.uniformLocations_[t]&&(this.uniformLocations_[t]=this.getGL().getUniformLocation(this.currentProgram_,t)),this.uniformLocations_[t]},e.prototype.getAttributeLocation=function(t){return void 0===this.attribLocations_[t]&&(this.attribLocations_[t]=this.getGL().getAttribLocation(this.currentProgram_,t)),this.attribLocations_[t]},e.prototype.makeProjectionTransform=function(t,e){var r=t.size,n=t.viewState.rotation,i=t.viewState.resolution,o=t.viewState.center;return xt(e),Ct(e,0,0,2/(i*r[0]),2/(i*r[1]),-n,-o[0],-o[1]),e},e.prototype.setUniformFloatValue=function(t,e){this.getGL().uniform1f(this.getUniformLocation(t),e)},e.prototype.setUniformMatrixValue=function(t,e){this.getGL().uniformMatrix4fv(this.getUniformLocation(t),!1,e)},e.prototype.enableAttributeArray_=function(t,e,r,n,i){var o=this.getAttributeLocation(t);o<0||(this.getGL().enableVertexAttribArray(o),this.getGL().vertexAttribPointer(o,e,r,!1,n,i))},e.prototype.enableAttributes=function(t){for(var e=Cl(t),r=0,n=0;n<t.length;n++){var i=t[n];this.enableAttributeArray_(i.name,i.size,i.type||5126,e,r),r+=i.size*Pl(i.type)}},e.prototype.handleWebGLContextLost=function(){E(this.bufferCache_),this.currentProgram_=null},e.prototype.handleWebGLContextRestored=function(){},e.prototype.createTexture=function(t,e,r){var n=this.getGL(),i=r||n.createTexture(),o=n.RGBA,a=n.RGBA,s=n.UNSIGNED_BYTE;return n.bindTexture(n.TEXTURE_2D,i),e?n.texImage2D(n.TEXTURE_2D,0,o,a,s,e):n.texImage2D(n.TEXTURE_2D,0,o,t[0],t[1],0,a,s,null),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,n.LINEAR),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,n.CLAMP_TO_EDGE),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,n.CLAMP_TO_EDGE),i},e}(p),Ol=new Uint8Array(4),Il=function(){function t(t,e){this.helper_=t;var r=t.getGL();this.texture_=r.createTexture(),this.framebuffer_=r.createFramebuffer(),this.size_=e||[1,1],this.data_=new Uint8Array(0),this.dataCacheDirty_=!0,this.updateSize_()}return t.prototype.setSize=function(t){_(t,this.size_)||(this.size_[0]=t[0],this.size_[1]=t[1],this.updateSize_())},t.prototype.getSize=function(){return this.size_},t.prototype.clearCachedData=function(){this.dataCacheDirty_=!0},t.prototype.readAll=function(){if(this.dataCacheDirty_){var t=this.size_,e=this.helper_.getGL();e.bindFramebuffer(e.FRAMEBUFFER,this.framebuffer_),e.readPixels(0,0,t[0],t[1],e.RGBA,e.UNSIGNED_BYTE,this.data_),this.dataCacheDirty_=!1}return this.data_},t.prototype.readPixel=function(t,e){if(t<0||e<0||t>this.size_[0]||e>=this.size_[1])return Ol[0]=0,Ol[1]=0,Ol[2]=0,Ol[3]=0,Ol;this.readAll();var r=Math.floor(t)+(this.size_[1]-Math.floor(e)-1)*this.size_[0];return Ol[0]=this.data_[4*r],Ol[1]=this.data_[4*r+1],Ol[2]=this.data_[4*r+2],Ol[3]=this.data_[4*r+3],Ol},t.prototype.getTexture=function(){return this.texture_},t.prototype.getFramebuffer=function(){return this.framebuffer_},t.prototype.updateSize_=function(){var t=this.size_,e=this.helper_.getGL();this.texture_=this.helper_.createTexture(t,null,this.texture_),e.bindFramebuffer(e.FRAMEBUFFER,this.framebuffer_),e.viewport(0,0,t[0],t[1]),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,this.texture_,0),this.data_=new Uint8Array(t[0]*t[1]*4)},t}(),Ll=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ml=function(t){function e(e){var r=t.call(this,{extent:e.extent,origin:e.origin,origins:e.origins,resolutions:e.resolutions,tileSize:e.tileSize,tileSizes:e.tileSizes,sizes:e.sizes})||this;return r.matrixIds_=e.matrixIds,r}return Ll(e,t),e.prototype.getMatrixId=function(t){return this.matrixIds_[t]},e.prototype.getMatrixIds=function(){return this.matrixIds_},e}(Fu),Fl=Ml;function Al(t,e,r){var n=[],i=[],o=[],a=[],s=[],u=void 0!==r?r:[],l=t.SupportedCRS,h=yr(l.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"))||yr(l),c=h.getMetersPerUnit(),p="ne"==h.getAxisOrientation().substr(0,2);return t.TileMatrix.sort((function(t,e){return e.ScaleDenominator-t.ScaleDenominator})),t.TileMatrix.forEach((function(e){if(!(u.length>0)||v(u,(function(r){return e.Identifier==r.TileMatrix||-1===e.Identifier.indexOf(":")&&t.Identifier+":"+e.Identifier===r.TileMatrix}))){i.push(e.Identifier);var r=28e-5*e.ScaleDenominator/c,l=e.TileWidth,h=e.TileHeight;p?o.push([e.TopLeftCorner[1],e.TopLeftCorner[0]]):o.push(e.TopLeftCorner),n.push(r),a.push(l==h?l:[l,h]),s.push([e.MatrixWidth,e.MatrixHeight])}})),new Ml({extent:e,origins:o,resolutions:n,matrixIds:i,tileSizes:a,sizes:s})}var kl=function(){function t(t){this.opacity_=t.opacity,this.rotateWithView_=t.rotateWithView,this.rotation_=t.rotation,this.scale_=t.scale,this.scaleArray_=za(t.scale),this.displacement_=t.displacement}return t.prototype.clone=function(){var e=this.getScale();return new t({opacity:this.getOpacity(),scale:Array.isArray(e)?e.slice():e,rotation:this.getRotation(),rotateWithView:this.getRotateWithView(),displacement:this.getDisplacement().slice()})},t.prototype.getOpacity=function(){return this.opacity_},t.prototype.getRotateWithView=function(){return this.rotateWithView_},t.prototype.getRotation=function(){return this.rotation_},t.prototype.getScale=function(){return this.scale_},t.prototype.getScaleArray=function(){return this.scaleArray_},t.prototype.getDisplacement=function(){return this.displacement_},t.prototype.getAnchor=function(){return n()},t.prototype.getImage=function(t){return n()},t.prototype.getHitDetectionImage=function(){return n()},t.prototype.getPixelRatio=function(t){return 1},t.prototype.getImageState=function(){return n()},t.prototype.getImageSize=function(){return n()},t.prototype.getHitDetectionImageSize=function(){return n()},t.prototype.getOrigin=function(){return n()},t.prototype.getSize=function(){return n()},t.prototype.setOpacity=function(t){this.opacity_=t},t.prototype.setRotateWithView=function(t){this.rotateWithView_=t},t.prototype.setRotation=function(t){this.rotation_=t},t.prototype.setScale=function(t){this.scale_=t,this.scaleArray_=za(t)},t.prototype.listenImageChange=function(t){n()},t.prototype.load=function(){n()},t.prototype.unlistenImageChange=function(t){n()},t}(),Nl=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),jl=function(t){function e(e){var r=this,n=void 0!==e.rotateWithView&&e.rotateWithView;return(r=t.call(this,{opacity:1,rotateWithView:n,rotation:void 0!==e.rotation?e.rotation:0,scale:1,displacement:void 0!==e.displacement?e.displacement:[0,0]})||this).canvas_={},r.hitDetectionCanvas_=null,r.fill_=void 0!==e.fill?e.fill:null,r.origin_=[0,0],r.points_=e.points,r.radius_=void 0!==e.radius?e.radius:e.radius1,r.radius2_=e.radius2,r.angle_=void 0!==e.angle?e.angle:0,r.stroke_=void 0!==e.stroke?e.stroke:null,r.anchor_=null,r.size_=null,r.imageSize_=null,r.hitDetectionImageSize_=null,r.render(),r}return Nl(e,t),e.prototype.clone=function(){var t=new e({fill:this.getFill()?this.getFill().clone():void 0,points:this.getPoints(),radius:this.getRadius(),radius2:this.getRadius2(),angle:this.getAngle(),stroke:this.getStroke()?this.getStroke().clone():void 0,rotation:this.getRotation(),rotateWithView:this.getRotateWithView(),displacement:this.getDisplacement().slice()});return t.setOpacity(this.getOpacity()),t.setScale(this.getScale()),t},e.prototype.getAnchor=function(){return this.anchor_},e.prototype.getAngle=function(){return this.angle_},e.prototype.getFill=function(){return this.fill_},e.prototype.getHitDetectionImage=function(){if(!this.hitDetectionCanvas_){var t=this.createRenderOptions();this.createHitDetectionCanvas_(t)}return this.hitDetectionCanvas_},e.prototype.getImage=function(t){if(!this.canvas_[t||1]){var e=this.createRenderOptions(),r=Bi(e.size*t||1,e.size*t||1);this.draw_(e,r,0,0,t||1),this.canvas_[t||1]=r.canvas}return this.canvas_[t||1]},e.prototype.getPixelRatio=function(t){return t},e.prototype.getImageSize=function(){return this.imageSize_},e.prototype.getHitDetectionImageSize=function(){return this.hitDetectionImageSize_},e.prototype.getImageState=function(){return Co},e.prototype.getOrigin=function(){return this.origin_},e.prototype.getPoints=function(){return this.points_},e.prototype.getRadius=function(){return this.radius_},e.prototype.getRadius2=function(){return this.radius2_},e.prototype.getSize=function(){return this.size_},e.prototype.getStroke=function(){return this.stroke_},e.prototype.listenImageChange=function(t){},e.prototype.load=function(){},e.prototype.unlistenImageChange=function(t){},e.prototype.createRenderOptions=function(){var t,e="round",r="round",n=0,i=null,o=0,a=0;return this.stroke_&&(null===(t=this.stroke_.getColor())&&(t="#000"),t=Fi(t),void 0===(a=this.stroke_.getWidth())&&(a=1),i=this.stroke_.getLineDash(),o=this.stroke_.getLineDashOffset(),void 0===(r=this.stroke_.getLineJoin())&&(r="round"),void 0===(e=this.stroke_.getLineCap())&&(e="round"),void 0===(n=this.stroke_.getMiterLimit())&&(n=10)),{strokeStyle:t,strokeWidth:a,size:2*(this.radius_+a)+1,lineCap:e,lineDash:i,lineDashOffset:o,lineJoin:r,miterLimit:n}},e.prototype.render=function(){var t=this.createRenderOptions(),e=Bi(t.size,t.size);this.draw_(t,e,0,0,1),this.canvas_[1]=e.canvas;var r=e.canvas.width,n=r,i=this.getDisplacement();this.hitDetectionImageSize_=[t.size,t.size],this.createHitDetectionCanvas_(t),this.anchor_=[r/2-i[0],r/2+i[1]],this.size_=[r,r],this.imageSize_=[n,n]},e.prototype.draw_=function(t,e,r,n,i){var o,a,s;e.setTransform(i,0,0,i,0,0),e.translate(r,n),e.beginPath();var u=this.points_;if(u===1/0)e.arc(t.size/2,t.size/2,this.radius_,0,2*Math.PI,!0);else{var l=void 0!==this.radius2_?this.radius2_:this.radius_;for(l!==this.radius_&&(u*=2),o=0;o<=u;o++)a=2*o*Math.PI/u-Math.PI/2+this.angle_,s=o%2==0?this.radius_:l,e.lineTo(t.size/2+s*Math.cos(a),t.size/2+s*Math.sin(a))}if(this.fill_){var h=this.fill_.getColor();null===h&&(h="#000"),e.fillStyle=Fi(h),e.fill()}this.stroke_&&(e.strokeStyle=t.strokeStyle,e.lineWidth=t.strokeWidth,e.setLineDash&&t.lineDash&&(e.setLineDash(t.lineDash),e.lineDashOffset=t.lineDashOffset),e.lineCap=t.lineCap,e.lineJoin=t.lineJoin,e.miterLimit=t.miterLimit,e.stroke()),e.closePath()},e.prototype.createHitDetectionCanvas_=function(t){if(this.hitDetectionCanvas_=this.getImage(1),this.fill_){var e=this.fill_.getColor(),r=0;if("string"==typeof e&&(e=ni(e)),null===e?r=1:Array.isArray(e)&&(r=4===e.length?e[3]:1),0===r){var n=Bi(t.size,t.size);this.hitDetectionCanvas_=n.canvas,this.drawHitDetectionCanvas_(t,n,0,0)}}},e.prototype.drawHitDetectionCanvas_=function(t,e,r,n){e.translate(r,n),e.beginPath();var i=this.points_;if(i===1/0)e.arc(t.size/2,t.size/2,this.radius_,0,2*Math.PI,!0);else{var o=void 0!==this.radius2_?this.radius2_:this.radius_;o!==this.radius_&&(i*=2);var a=void 0,s=void 0,u=void 0;for(a=0;a<=i;a++)u=2*a*Math.PI/i-Math.PI/2+this.angle_,s=a%2==0?this.radius_:o,e.lineTo(t.size/2+s*Math.cos(u),t.size/2+s*Math.sin(u))}e.fillStyle="#000",e.fill(),this.stroke_&&(e.strokeStyle=t.strokeStyle,e.lineWidth=t.strokeWidth,t.lineDash&&(e.setLineDash(t.lineDash),e.lineDashOffset=t.lineDashOffset),e.stroke()),e.closePath()},e}(kl),Gl=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Dl=function(t){function e(e){var r=e||{};return t.call(this,{points:1/0,fill:r.fill,radius:r.radius,stroke:r.stroke,displacement:void 0!==r.displacement?r.displacement:[0,0]})||this}return Gl(e,t),e.prototype.clone=function(){var t=new e({fill:this.getFill()?this.getFill().clone():void 0,stroke:this.getStroke()?this.getStroke().clone():void 0,radius:this.getRadius(),displacement:this.getDisplacement().slice()});return t.setOpacity(this.getOpacity()),t.setScale(this.getScale()),t},e.prototype.setRadius=function(t){this.radius_=t,this.render()},e}(jl),zl=function(){function t(t){var e=t||{};this.color_=void 0!==e.color?e.color:null}return t.prototype.clone=function(){var e=this.getColor();return new t({color:Array.isArray(e)?e.slice():e||void 0})},t.prototype.getColor=function(){return this.color_},t.prototype.setColor=function(t){this.color_=t},t}(),Ul="fraction",Bl="pixels",Yl="bottom-left",Vl="bottom-right",Wl="top-left",ql="top-right",Xl=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Zl=function(t){function e(e,r,n,i){var o=t.call(this)||this;return o.extent=e,o.pixelRatio_=n,o.resolution=r,o.state=i,o}return Xl(e,t),e.prototype.changed=function(){this.dispatchEvent(I)},e.prototype.getExtent=function(){return this.extent},e.prototype.getImage=function(){return n()},e.prototype.getPixelRatio=function(){return this.pixelRatio_},e.prototype.getResolution=function(){return this.resolution},e.prototype.getState=function(){return this.state},e.prototype.load=function(){n()},e}(O),Kl=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Hl(t,e,r){var n=t;if(n.src&&zi){var i=n.decode(),o=!0;return i.then((function(){o&&e()})).catch((function(t){o&&("EncodingError"===t.name&&"Invalid image type."===t.message?e():r())})),function(){o=!1}}var a=[q(n,U,e),q(n,L,r)];return function(){a.forEach(X)}}var Jl=function(t){function e(e,r,n,i,o,a){var s=t.call(this,e,r,n,To)||this;return s.src_=i,s.image_=new Image,null!==o&&(s.image_.crossOrigin=o),s.unlisten_=null,s.state=To,s.imageLoadFunction_=a,s}return Kl(e,t),e.prototype.getImage=function(){return this.image_},e.prototype.handleImageError_=function(){this.state=Po,this.unlistenImage_(),this.changed()},e.prototype.handleImageLoad_=function(){void 0===this.resolution&&(this.resolution=ce(this.extent)/this.image_.height),this.state=Co,this.unlistenImage_(),this.changed()},e.prototype.load=function(){this.state!=To&&this.state!=Po||(this.state=Eo,this.changed(),this.imageLoadFunction_(this,this.src_),this.unlisten_=Hl(this.image_,this.handleImageLoad_.bind(this),this.handleImageError_.bind(this)))},e.prototype.setImage=function(t){this.image_=t},e.prototype.unlistenImage_=function(){this.unlisten_&&(this.unlisten_(),this.unlisten_=null)},e}(Zl),$l=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ql=null,th=function(t){function e(e,r,n,i,o,a){var s=t.call(this)||this;return s.hitDetectionImage_=null,s.image_=e||new Image,null!==i&&(s.image_.crossOrigin=i),s.canvas_={},s.color_=a,s.unlisten_=null,s.imageState_=o,s.size_=n,s.src_=r,s.tainted_,s}return $l(e,t),e.prototype.isTainted_=function(){if(void 0===this.tainted_&&this.imageState_===Co){Ql||(Ql=Bi(1,1)),Ql.drawImage(this.image_,0,0);try{Ql.getImageData(0,0,1,1),this.tainted_=!1}catch(t){Ql=null,this.tainted_=!0}}return!0===this.tainted_},e.prototype.dispatchChangeEvent_=function(){this.dispatchEvent(I)},e.prototype.handleImageError_=function(){this.imageState_=Po,this.unlistenImage_(),this.dispatchChangeEvent_()},e.prototype.handleImageLoad_=function(){this.imageState_=Co,this.size_?(this.image_.width=this.size_[0],this.image_.height=this.size_[1]):this.size_=[this.image_.width,this.image_.height],this.unlistenImage_(),this.dispatchChangeEvent_()},e.prototype.getImage=function(t){return this.replaceColor_(t),this.canvas_[t]?this.canvas_[t]:this.image_},e.prototype.getPixelRatio=function(t){return this.replaceColor_(t),this.canvas_[t]?t:1},e.prototype.getImageState=function(){return this.imageState_},e.prototype.getHitDetectionImage=function(){if(!this.hitDetectionImage_)if(this.isTainted_()){var t=this.size_[0],e=this.size_[1],r=Bi(t,e);r.fillRect(0,0,t,e),this.hitDetectionImage_=r.canvas}else this.hitDetectionImage_=this.image_;return this.hitDetectionImage_},e.prototype.getSize=function(){return this.size_},e.prototype.getSrc=function(){return this.src_},e.prototype.load=function(){if(this.imageState_==To){this.imageState_=Eo;try{this.image_.src=this.src_}catch(t){this.handleImageError_()}this.unlisten_=Hl(this.image_,this.handleImageLoad_.bind(this),this.handleImageError_.bind(this))}},e.prototype.replaceColor_=function(t){if(this.color_&&!this.canvas_[t]){var e=document.createElement("canvas");this.canvas_[t]=e,e.width=Math.ceil(this.image_.width*t),e.height=Math.ceil(this.image_.height*t);var r=e.getContext("2d");if(r.scale(t,t),r.drawImage(this.image_,0,0),this.isTainted_()){var n=this.color_;return r.globalCompositeOperation="multiply",r.fillStyle="rgb("+n[0]+","+n[1]+","+n[2]+")",r.fillRect(0,0,e.width,e.height),r.globalCompositeOperation="destination-in",void r.drawImage(this.image_,0,0)}for(var i=r.getImageData(0,0,e.width,e.height),o=i.data,a=this.color_[0]/255,s=this.color_[1]/255,u=this.color_[2]/255,l=0,h=o.length;l<h;l+=4)o[l]*=a,o[l+1]*=s,o[l+2]*=u;r.putImageData(i,0,0)}},e.prototype.unlistenImage_=function(){this.unlisten_&&(this.unlisten_(),this.unlisten_=null)},e}(O);var eh=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),rh=function(t){function e(e){var r=this,n=e||{},i=void 0!==n.opacity?n.opacity:1,a=void 0!==n.rotation?n.rotation:0,s=void 0!==n.scale?n.scale:1,u=void 0!==n.rotateWithView&&n.rotateWithView;(r=t.call(this,{opacity:i,rotation:a,scale:s,displacement:void 0!==n.displacement?n.displacement:[0,0],rotateWithView:u})||this).anchor_=void 0!==n.anchor?n.anchor:[.5,.5],r.normalizedAnchor_=null,r.anchorOrigin_=void 0!==n.anchorOrigin?n.anchorOrigin:Wl,r.anchorXUnits_=void 0!==n.anchorXUnits?n.anchorXUnits:Ul,r.anchorYUnits_=void 0!==n.anchorYUnits?n.anchorYUnits:Ul,r.crossOrigin_=void 0!==n.crossOrigin?n.crossOrigin:null;var l=void 0!==n.img?n.img:null,h=void 0!==n.imgSize?n.imgSize:null,c=n.src;lt(!(void 0!==c&&l),4),lt(!l||l&&h,5),void 0!==c&&0!==c.length||!l||(c=l.src||o(l)),lt(void 0!==c&&c.length>0,6);var p=void 0!==n.src?To:Co;return r.color_=void 0!==n.color?ni(n.color):null,r.iconImage_=function(t,e,r,n,i,o){var a=ui.get(e,n,o);return a||(a=new th(t,e,r,n,i,o),ui.set(e,n,o,a)),a}(l,c,h,r.crossOrigin_,p,r.color_),r.offset_=void 0!==n.offset?n.offset:[0,0],r.offsetOrigin_=void 0!==n.offsetOrigin?n.offsetOrigin:Wl,r.origin_=null,r.size_=void 0!==n.size?n.size:null,r}return eh(e,t),e.prototype.clone=function(){var t=this.getScale();return new e({anchor:this.anchor_.slice(),anchorOrigin:this.anchorOrigin_,anchorXUnits:this.anchorXUnits_,anchorYUnits:this.anchorYUnits_,crossOrigin:this.crossOrigin_,color:this.color_&&this.color_.slice?this.color_.slice():this.color_||void 0,src:this.getSrc(),offset:this.offset_.slice(),offsetOrigin:this.offsetOrigin_,size:null!==this.size_?this.size_.slice():void 0,opacity:this.getOpacity(),scale:Array.isArray(t)?t.slice():t,rotation:this.getRotation(),rotateWithView:this.getRotateWithView()})},e.prototype.getAnchor=function(){if(this.normalizedAnchor_)return this.normalizedAnchor_;var t=this.anchor_,e=this.getSize();if(this.anchorXUnits_==Ul||this.anchorYUnits_==Ul){if(!e)return null;t=this.anchor_.slice(),this.anchorXUnits_==Ul&&(t[0]*=e[0]),this.anchorYUnits_==Ul&&(t[1]*=e[1])}if(this.anchorOrigin_!=Wl){if(!e)return null;t===this.anchor_&&(t=this.anchor_.slice()),this.anchorOrigin_!=ql&&this.anchorOrigin_!=Vl||(t[0]=-t[0]+e[0]),this.anchorOrigin_!=Yl&&this.anchorOrigin_!=Vl||(t[1]=-t[1]+e[1])}return this.normalizedAnchor_=t,this.normalizedAnchor_},e.prototype.setAnchor=function(t){this.anchor_=t,this.normalizedAnchor_=null},e.prototype.getColor=function(){return this.color_},e.prototype.getImage=function(t){return this.iconImage_.getImage(t)},e.prototype.getPixelRatio=function(t){return this.iconImage_.getPixelRatio(t)},e.prototype.getImageSize=function(){return this.iconImage_.getSize()},e.prototype.getHitDetectionImageSize=function(){return this.getImageSize()},e.prototype.getImageState=function(){return this.iconImage_.getImageState()},e.prototype.getHitDetectionImage=function(){return this.iconImage_.getHitDetectionImage()},e.prototype.getOrigin=function(){if(this.origin_)return this.origin_;var t=this.offset_,e=this.getDisplacement();if(this.offsetOrigin_!=Wl){var r=this.getSize(),n=this.iconImage_.getSize();if(!r||!n)return null;t=t.slice(),this.offsetOrigin_!=ql&&this.offsetOrigin_!=Vl||(t[0]=n[0]-r[0]-t[0]),this.offsetOrigin_!=Yl&&this.offsetOrigin_!=Vl||(t[1]=n[1]-r[1]-t[1])}return t[0]+=e[0],t[1]+=e[1],this.origin_=t,this.origin_},e.prototype.getSrc=function(){return this.iconImage_.getSrc()},e.prototype.getSize=function(){return this.size_?this.size_:this.iconImage_.getSize()},e.prototype.listenImageChange=function(t){this.iconImage_.addEventListener(I,t)},e.prototype.load=function(){this.iconImage_.load()},e.prototype.unlistenImageChange=function(t){this.iconImage_.removeEventListener(I,t)},e}(kl),nh=function(){function t(t){var e=t||{};this.color_=void 0!==e.color?e.color:null,this.lineCap_=e.lineCap,this.lineDash_=void 0!==e.lineDash?e.lineDash:null,this.lineDashOffset_=e.lineDashOffset,this.lineJoin_=e.lineJoin,this.miterLimit_=e.miterLimit,this.width_=e.width}return t.prototype.clone=function(){var e=this.getColor();return new t({color:Array.isArray(e)?e.slice():e||void 0,lineCap:this.getLineCap(),lineDash:this.getLineDash()?this.getLineDash().slice():void 0,lineDashOffset:this.getLineDashOffset(),lineJoin:this.getLineJoin(),miterLimit:this.getMiterLimit(),width:this.getWidth()})},t.prototype.getColor=function(){return this.color_},t.prototype.getLineCap=function(){return this.lineCap_},t.prototype.getLineDash=function(){return this.lineDash_},t.prototype.getLineDashOffset=function(){return this.lineDashOffset_},t.prototype.getLineJoin=function(){return this.lineJoin_},t.prototype.getMiterLimit=function(){return this.miterLimit_},t.prototype.getWidth=function(){return this.width_},t.prototype.setColor=function(t){this.color_=t},t.prototype.setLineCap=function(t){this.lineCap_=t},t.prototype.setLineDash=function(t){this.lineDash_=t},t.prototype.setLineDashOffset=function(t){this.lineDashOffset_=t},t.prototype.setLineJoin=function(t){this.lineJoin_=t},t.prototype.setMiterLimit=function(t){this.miterLimit_=t},t.prototype.setWidth=function(t){this.width_=t},t}(),ih=function(){function t(t){var e=t||{};this.geometry_=null,this.geometryFunction_=uh,void 0!==e.geometry&&this.setGeometry(e.geometry),this.fill_=void 0!==e.fill?e.fill:null,this.image_=void 0!==e.image?e.image:null,this.renderer_=void 0!==e.renderer?e.renderer:null,this.stroke_=void 0!==e.stroke?e.stroke:null,this.text_=void 0!==e.text?e.text:null,this.zIndex_=e.zIndex}return t.prototype.clone=function(){var e=this.getGeometry();return e&&"object"==typeof e&&(e=e.clone()),new t({geometry:e,fill:this.getFill()?this.getFill().clone():void 0,image:this.getImage()?this.getImage().clone():void 0,stroke:this.getStroke()?this.getStroke().clone():void 0,text:this.getText()?this.getText().clone():void 0,zIndex:this.getZIndex()})},t.prototype.getRenderer=function(){return this.renderer_},t.prototype.setRenderer=function(t){this.renderer_=t},t.prototype.getGeometry=function(){return this.geometry_},t.prototype.getGeometryFunction=function(){return this.geometryFunction_},t.prototype.getFill=function(){return this.fill_},t.prototype.setFill=function(t){this.fill_=t},t.prototype.getImage=function(){return this.image_},t.prototype.setImage=function(t){this.image_=t},t.prototype.getStroke=function(){return this.stroke_},t.prototype.setStroke=function(t){this.stroke_=t},t.prototype.getText=function(){return this.text_},t.prototype.setText=function(t){this.text_=t},t.prototype.getZIndex=function(){return this.zIndex_},t.prototype.setGeometry=function(t){"function"==typeof t?this.geometryFunction_=t:"string"==typeof t?this.geometryFunction_=function(e){return e.get(t)}:t?void 0!==t&&(this.geometryFunction_=function(){return t}):this.geometryFunction_=uh,this.geometry_=t},t.prototype.setZIndex=function(t){this.zIndex_=t},t}();var oh=null;function ah(t,e){if(!oh){var r=new zl({color:"rgba(255,255,255,0.4)"}),n=new nh({color:"#3399CC",width:1.25});oh=[new ih({image:new Dl({fill:r,stroke:n,radius:5}),fill:r,stroke:n})]}return oh}function sh(){var t={},e=[255,255,255,1],r=[0,153,255,1];return t[yt.POLYGON]=[new ih({fill:new zl({color:[255,255,255,.5]})})],t[yt.MULTI_POLYGON]=t[yt.POLYGON],t[yt.LINE_STRING]=[new ih({stroke:new nh({color:e,width:5})}),new ih({stroke:new nh({color:r,width:3})})],t[yt.MULTI_LINE_STRING]=t[yt.LINE_STRING],t[yt.CIRCLE]=t[yt.POLYGON].concat(t[yt.LINE_STRING]),t[yt.POINT]=[new ih({image:new Dl({radius:6,fill:new zl({color:r}),stroke:new nh({color:e,width:1.5})}),zIndex:1/0})],t[yt.MULTI_POINT]=t[yt.POINT],t[yt.GEOMETRY_COLLECTION]=t[yt.POLYGON].concat(t[yt.LINE_STRING],t[yt.POINT]),t}function uh(t){return t.getGeometry()}var lh=ih,hh="point",ch="line",ph=function(){function t(t){var e=t||{};this.font_=e.font,this.rotation_=e.rotation,this.rotateWithView_=e.rotateWithView,this.scale_=e.scale,this.scaleArray_=za(void 0!==e.scale?e.scale:1),this.text_=e.text,this.textAlign_=e.textAlign,this.textBaseline_=e.textBaseline,this.fill_=void 0!==e.fill?e.fill:new zl({color:"#333"}),this.maxAngle_=void 0!==e.maxAngle?e.maxAngle:Math.PI/4,this.placement_=void 0!==e.placement?e.placement:hh,this.overflow_=!!e.overflow,this.stroke_=void 0!==e.stroke?e.stroke:null,this.offsetX_=void 0!==e.offsetX?e.offsetX:0,this.offsetY_=void 0!==e.offsetY?e.offsetY:0,this.backgroundFill_=e.backgroundFill?e.backgroundFill:null,this.backgroundStroke_=e.backgroundStroke?e.backgroundStroke:null,this.padding_=void 0===e.padding?null:e.padding}return t.prototype.clone=function(){var e=this.getScale();return new t({font:this.getFont(),placement:this.getPlacement(),maxAngle:this.getMaxAngle(),overflow:this.getOverflow(),rotation:this.getRotation(),rotateWithView:this.getRotateWithView(),scale:Array.isArray(e)?e.slice():e,text:this.getText(),textAlign:this.getTextAlign(),textBaseline:this.getTextBaseline(),fill:this.getFill()?this.getFill().clone():void 0,stroke:this.getStroke()?this.getStroke().clone():void 0,offsetX:this.getOffsetX(),offsetY:this.getOffsetY(),backgroundFill:this.getBackgroundFill()?this.getBackgroundFill().clone():void 0,backgroundStroke:this.getBackgroundStroke()?this.getBackgroundStroke().clone():void 0,padding:this.getPadding()})},t.prototype.getOverflow=function(){return this.overflow_},t.prototype.getFont=function(){return this.font_},t.prototype.getMaxAngle=function(){return this.maxAngle_},t.prototype.getPlacement=function(){return this.placement_},t.prototype.getOffsetX=function(){return this.offsetX_},t.prototype.getOffsetY=function(){return this.offsetY_},t.prototype.getFill=function(){return this.fill_},t.prototype.getRotateWithView=function(){return this.rotateWithView_},t.prototype.getRotation=function(){return this.rotation_},t.prototype.getScale=function(){return this.scale_},t.prototype.getScaleArray=function(){return this.scaleArray_},t.prototype.getStroke=function(){return this.stroke_},t.prototype.getText=function(){return this.text_},t.prototype.getTextAlign=function(){return this.textAlign_},t.prototype.getTextBaseline=function(){return this.textBaseline_},t.prototype.getBackgroundFill=function(){return this.backgroundFill_},t.prototype.getBackgroundStroke=function(){return this.backgroundStroke_},t.prototype.getPadding=function(){return this.padding_},t.prototype.setOverflow=function(t){this.overflow_=t},t.prototype.setFont=function(t){this.font_=t},t.prototype.setMaxAngle=function(t){this.maxAngle_=t},t.prototype.setOffsetX=function(t){this.offsetX_=t},t.prototype.setOffsetY=function(t){this.offsetY_=t},t.prototype.setPlacement=function(t){this.placement_=t},t.prototype.setRotateWithView=function(t){this.rotateWithView_=t},t.prototype.setFill=function(t){this.fill_=t},t.prototype.setRotation=function(t){this.rotation_=t},t.prototype.setScale=function(t){this.scale_=t,this.scaleArray_=za(void 0!==t?t:1)},t.prototype.setStroke=function(t){this.stroke_=t},t.prototype.setText=function(t){this.text_=t},t.prototype.setTextAlign=function(t){this.textAlign_=t},t.prototype.setTextBaseline=function(t){this.textBaseline_=t},t.prototype.setBackgroundFill=function(t){this.backgroundFill_=t},t.prototype.setBackgroundStroke=function(t){this.backgroundStroke_=t},t.prototype.setPadding=function(t){this.padding_=t},t}(),fh=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),dh=function(t){function e(e,r,n){var i=t.call(this)||this,o=n||{};return i.tileCoord=e,i.state=r,i.interimTile=null,i.hifi=!0,i.key="",i.transition_=void 0===o.transition?250:o.transition,i.transitionStarts_={},i}return fh(e,t),e.prototype.changed=function(){this.dispatchEvent(I)},e.prototype.release=function(){},e.prototype.getKey=function(){return this.key+"/"+this.tileCoord},e.prototype.getInterimTile=function(){if(!this.interimTile)return this;var t=this.interimTile;do{if(t.getState()==fa)return this.transition_=0,t;t=t.interimTile}while(t);return this},e.prototype.refreshInterimChain=function(){if(this.interimTile){var t=this.interimTile,e=this;do{if(t.getState()==fa){t.interimTile=null;break}t.getState()==pa?e=t:t.getState()==ca?e.interimTile=t.interimTile:e=t,t=e.interimTile}while(t)}},e.prototype.getTileCoord=function(){return this.tileCoord},e.prototype.getState=function(){return this.state},e.prototype.setState=function(t){if(this.state!==da&&this.state>t)throw new Error("Tile load sequence violation");this.state=t,this.changed()},e.prototype.load=function(){n()},e.prototype.getAlpha=function(t,e){if(!this.transition_)return 1;var r=this.transitionStarts_[t];if(r){if(-1===r)return 1}else r=e,this.transitionStarts_[t]=r;var n=e-r+1e3/60;return n>=this.transition_?1:Ia(n/this.transition_)},e.prototype.inTransition=function(t){return!!this.transition_&&-1!==this.transitionStarts_[t]},e.prototype.endTransition=function(t){this.transition_&&(this.transitionStarts_[t]=-1)},e}(O),gh=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();var yh,mh=function(t){function e(e,r,n,i,o,a){var s=t.call(this,e,r,a)||this;return s.crossOrigin_=i,s.src_=n,s.image_=new Image,null!==i&&(s.image_.crossOrigin=i),s.unlisten_=null,s.tileLoadFunction_=o,s}return gh(e,t),e.prototype.getImage=function(){return this.image_},e.prototype.getKey=function(){return this.src_},e.prototype.handleImageError_=function(){var t;this.state=da,this.unlistenImage_(),this.image_=((t=Bi(1,1)).fillStyle="rgba(0,0,0,0)",t.fillRect(0,0,1,1),t.canvas),this.changed()},e.prototype.handleImageLoad_=function(){var t=this.image_;t.naturalWidth&&t.naturalHeight?this.state=fa:this.state=ga,this.unlistenImage_(),this.changed()},e.prototype.load=function(){this.state==da&&(this.state=ca,this.image_=new Image,null!==this.crossOrigin_&&(this.image_.crossOrigin=this.crossOrigin_)),this.state==ca&&(this.state=pa,this.changed(),this.tileLoadFunction_(this,this.src_),this.unlisten_=Hl(this.image_,this.handleImageLoad_.bind(this),this.handleImageError_.bind(this)))},e.prototype.unlistenImage_=function(){this.unlisten_&&(this.unlisten_(),this.unlisten_=null)},e}(dh),vh=function(){function t(t,e,r,n,i,o){this.sourceProj_=t,this.targetProj_=e;var a={},s=Er(this.targetProj_,this.sourceProj_);this.transformInv_=function(t){var e=t[0]+"/"+t[1];return a[e]||(a[e]=s(t)),a[e]},this.maxSourceExtent_=n,this.errorThresholdSquared_=i*i,this.triangles_=[],this.wrapsXInSource_=!1,this.canWrapXInSource_=this.sourceProj_.canWrapX()&&!!n&&!!this.sourceProj_.getExtent()&&ge(n)==ge(this.sourceProj_.getExtent()),this.sourceWorldWidth_=this.sourceProj_.getExtent()?ge(this.sourceProj_.getExtent()):null,this.targetWorldWidth_=this.targetProj_.getExtent()?ge(this.targetProj_.getExtent()):null;var u=fe(r),l=de(r),h=se(r),c=ae(r),p=this.transformInv_(u),f=this.transformInv_(l),d=this.transformInv_(h),g=this.transformInv_(c),y=10+(o?Math.max(0,Math.ceil(Te(oe(r)/(o*o*256*256)))):0);if(this.addQuad_(u,l,h,c,p,f,d,g,y),this.wrapsXInSource_){var m=1/0;this.triangles_.forEach((function(t,e,r){m=Math.min(m,t.source[0][0],t.source[1][0],t.source[2][0])})),this.triangles_.forEach(function(t){if(Math.max(t.source[0][0],t.source[1][0],t.source[2][0])-m>this.sourceWorldWidth_/2){var e=[[t.source[0][0],t.source[0][1]],[t.source[1][0],t.source[1][1]],[t.source[2][0],t.source[2][1]]];e[0][0]-m>this.sourceWorldWidth_/2&&(e[0][0]-=this.sourceWorldWidth_),e[1][0]-m>this.sourceWorldWidth_/2&&(e[1][0]-=this.sourceWorldWidth_),e[2][0]-m>this.sourceWorldWidth_/2&&(e[2][0]-=this.sourceWorldWidth_);var r=Math.min(e[0][0],e[1][0],e[2][0]);Math.max(e[0][0],e[1][0],e[2][0])-r<this.sourceWorldWidth_/2&&(t.source=e)}}.bind(this))}a={}}return t.prototype.addTriangle_=function(t,e,r,n,i,o){this.triangles_.push({source:[n,i,o],target:[t,e,r]})},t.prototype.addQuad_=function(t,e,r,n,i,o,a,s,u){var l=Dt([i,o,a,s]),h=this.sourceWorldWidth_?ge(l)/this.sourceWorldWidth_:null,c=this.sourceWorldWidth_,p=this.sourceProj_.canWrapX()&&h>.5&&h<1,f=!1;if(u>0){if(this.targetProj_.isGlobal()&&this.targetWorldWidth_)f=ge(Dt([t,e,r,n]))/this.targetWorldWidth_>.25||f;!p&&this.sourceProj_.isGlobal()&&h&&(f=h>.25||f)}if(!(!f&&this.maxSourceExtent_&&isFinite(l[0])&&isFinite(l[1])&&isFinite(l[2])&&isFinite(l[3]))||ye(l,this.maxSourceExtent_)){var d=0;if(!(f||isFinite(i[0])&&isFinite(i[1])&&isFinite(o[0])&&isFinite(o[1])&&isFinite(a[0])&&isFinite(a[1])&&isFinite(s[0])&&isFinite(s[1])))if(u>0)f=!0;else if(1!=(d=(isFinite(i[0])&&isFinite(i[1])?0:8)+(isFinite(o[0])&&isFinite(o[1])?0:4)+(isFinite(a[0])&&isFinite(a[1])?0:2)+(isFinite(s[0])&&isFinite(s[1])?0:1))&&2!=d&&4!=d&&8!=d)return;if(u>0){if(!f){var g=[(t[0]+r[0])/2,(t[1]+r[1])/2],y=this.transformInv_(g),m=void 0;if(p)m=(Oe(i[0],c)+Oe(a[0],c))/2-Oe(y[0],c);else m=(i[0]+a[0])/2-y[0];var v=(i[1]+a[1])/2-y[1];f=m*m+v*v>this.errorThresholdSquared_}if(f){if(Math.abs(t[0]-r[0])<=Math.abs(t[1]-r[1])){var _=[(e[0]+r[0])/2,(e[1]+r[1])/2],b=this.transformInv_(_),x=[(n[0]+t[0])/2,(n[1]+t[1])/2],w=this.transformInv_(x);this.addQuad_(t,e,_,x,i,o,b,w,u-1),this.addQuad_(x,_,r,n,w,b,a,s,u-1)}else{var S=[(t[0]+e[0])/2,(t[1]+e[1])/2],T=this.transformInv_(S),E=[(r[0]+n[0])/2,(r[1]+n[1])/2],C=this.transformInv_(E);this.addQuad_(t,S,E,n,i,T,C,s,u-1),this.addQuad_(S,e,r,E,T,o,a,C,u-1)}return}}if(p){if(!this.canWrapXInSource_)return;this.wrapsXInSource_=!0}0==(11&d)&&this.addTriangle_(t,r,n,i,a,s),0==(14&d)&&this.addTriangle_(t,r,e,i,a,o),d&&(0==(13&d)&&this.addTriangle_(e,n,t,o,s,i),0==(7&d)&&this.addTriangle_(e,n,r,o,s,a))}},t.prototype.calculateSourceExtent=function(){var t=[1/0,1/0,-1/0,-1/0];return this.triangles_.forEach((function(e,r,n){var i=e.source;te(t,i[0]),te(t,i[1]),te(t,i[2])})),t},t.prototype.getTriangles=function(){return this.triangles_},t}(),_h={imageSmoothingEnabled:!1,msImageSmoothingEnabled:!1};function bh(t,e,r,n,i){t.beginPath(),t.moveTo(0,0),t.lineTo(e,r),t.lineTo(n,i),t.closePath(),t.save(),t.clip(),t.fillRect(0,0,Math.max(e,n)+1,Math.max(r,i)),t.restore()}function xh(t,e){return Math.abs(t[4*e]-210)>2||Math.abs(t[4*e+3]-191.25)>2}function wh(t,e,r,n){var i=Cr(r,e,t),o=mr(e,n,r),a=e.getMetersPerUnit();void 0!==a&&(o*=a);var s=t.getMetersPerUnit();void 0!==s&&(o/=s);var u=t.getExtent();if(!u||Yt(u,i)){var l=mr(t,o,i)/o;isFinite(l)&&l>0&&(o/=l)}return o}function Sh(t,e,r,n,i,o,a,s,u,l,h,c){var p=Bi(Math.round(r*t),Math.round(r*e));if(T(p,c),0===u.length)return p.canvas;function f(t){return Math.round(t*r)/r}p.scale(r,r),p.globalCompositeOperation="lighter";var d=[1/0,1/0,-1/0,-1/0];u.forEach((function(t,e,r){Qt(d,t.extent)}));var g=ge(d),y=ce(d),m=Bi(Math.round(r*g/n),Math.round(r*y/n));T(m,c);var v=r/n;u.forEach((function(t,e,r){var n=t.extent[0]-d[0],i=-(t.extent[3]-d[3]),o=ge(t.extent),a=ce(t.extent);t.image.width>0&&t.image.height>0&&m.drawImage(t.image,l,l,t.image.width-2*l,t.image.height-2*l,n*v,i*v,o*v,a*v)}));var _=fe(a);return s.getTriangles().forEach((function(t,e,i){var a=t.source,s=t.target,u=a[0][0],l=a[0][1],h=a[1][0],g=a[1][1],y=a[2][0],v=a[2][1],b=f((s[0][0]-_[0])/o),x=f(-(s[0][1]-_[1])/o),w=f((s[1][0]-_[0])/o),S=f(-(s[1][1]-_[1])/o),T=f((s[2][0]-_[0])/o),E=f(-(s[2][1]-_[1])/o),C=u,P=l;u=0,l=0;var R=function(t){for(var e=t.length,r=0;r<e;r++){for(var n=r,i=Math.abs(t[r][r]),o=r+1;o<e;o++){var a=Math.abs(t[o][r]);a>i&&(i=a,n=o)}if(0===i)return null;var s=t[n];t[n]=t[r],t[r]=s;for(var u=r+1;u<e;u++)for(var l=-t[u][r]/t[r][r],h=r;h<e+1;h++)r==h?t[u][h]=0:t[u][h]+=l*t[r][h]}for(var c=new Array(e),p=e-1;p>=0;p--){c[p]=t[p][e]/t[p][p];for(var f=p-1;f>=0;f--)t[f][e]-=t[f][p]*c[p]}return c}([[h-=C,g-=P,0,0,w-b],[y-=C,v-=P,0,0,T-b],[0,0,h,g,S-x],[0,0,y,v,E-x]]);if(R){if(p.save(),p.beginPath(),function(){if(void 0===yh){var t=document.createElement("canvas").getContext("2d");t.globalCompositeOperation="lighter",t.fillStyle="rgba(210, 0, 0, 0.75)",bh(t,4,5,4,0),bh(t,4,5,0,5);var e=t.getImageData(0,0,3,3).data;yh=xh(e,0)||xh(e,4)||xh(e,8)}return yh}()||c===_h){p.moveTo(w,S);for(var O=b-w,I=x-S,L=0;L<4;L++)p.lineTo(w+f((L+1)*O/4),S+f(L*I/3)),3!=L&&p.lineTo(w+f((L+1)*O/4),S+f((L+1)*I/3));p.lineTo(T,E)}else p.moveTo(w,S),p.lineTo(b,x),p.lineTo(T,E);p.clip(),p.transform(R[0],R[2],R[1],R[3],b,x),p.translate(d[0]-C,d[3]-P),p.scale(n/r,-n/r),p.drawImage(m.canvas,0,0),p.restore()}})),h&&(p.save(),p.globalCompositeOperation="source-over",p.strokeStyle="black",p.lineWidth=1,s.getTriangles().forEach((function(t,e,r){var n=t.target,i=(n[0][0]-_[0])/o,a=-(n[0][1]-_[1])/o,s=(n[1][0]-_[0])/o,u=-(n[1][1]-_[1])/o,l=(n[2][0]-_[0])/o,h=-(n[2][1]-_[1])/o;p.beginPath(),p.moveTo(s,u),p.lineTo(i,a),p.lineTo(l,h),p.closePath(),p.stroke()})),p.restore()),p.canvas}var Th=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Eh=function(t){function e(e,r,n,i,o,a,s,u,l,h,c,p){var f=t.call(this,o,ca)||this;f.renderEdges_=void 0!==c&&c,f.contextOptions_=p,f.pixelRatio_=s,f.gutter_=u,f.canvas_=null,f.sourceTileGrid_=r,f.targetTileGrid_=i,f.wrappedTileCoord_=a||o,f.sourceTiles_=[],f.sourcesListenerKeys_=null,f.sourceZ_=0;var d=i.getTileCoordExtent(f.wrappedTileCoord_),g=f.targetTileGrid_.getExtent(),y=f.sourceTileGrid_.getExtent(),m=g?pe(d,g):d;if(0===oe(m))return f.state=ga,f;var v=e.getExtent();v&&(y=y?pe(y,v):v);var _=i.getResolution(f.wrappedTileCoord_[0]),b=function(t,e,r,n){var i=ue(r),o=wh(t,e,i,n);return(!isFinite(o)||o<=0)&&ie(r,(function(r){return o=wh(t,e,r,n),isFinite(o)&&o>0})),o}(e,n,m,_);if(!isFinite(b)||b<=0)return f.state=ga,f;var x=void 0!==h?h:.5;if(f.triangulation_=new vh(e,n,m,y,b*x,_),0===f.triangulation_.getTriangles().length)return f.state=ga,f;f.sourceZ_=r.getZForResolution(b);var w=f.triangulation_.calculateSourceExtent();if(y&&(e.canWrapX()?(w[1]=we(w[1],y[1],y[3]),w[3]=we(w[3],y[1],y[3])):w=pe(w,y)),oe(w)){for(var S=r.getTileRangeForExtentAndZ(w,f.sourceZ_),T=S.minX;T<=S.maxX;T++)for(var E=S.minY;E<=S.maxY;E++){var C=l(f.sourceZ_,T,E,s);C&&f.sourceTiles_.push(C)}0===f.sourceTiles_.length&&(f.state=ga)}else f.state=ga;return f}return Th(e,t),e.prototype.getImage=function(){return this.canvas_},e.prototype.reproject_=function(){var t=[];if(this.sourceTiles_.forEach(function(e,r,n){e&&e.getState()==fa&&t.push({extent:this.sourceTileGrid_.getTileCoordExtent(e.tileCoord),image:e.getImage()})}.bind(this)),this.sourceTiles_.length=0,0===t.length)this.state=da;else{var e=this.wrappedTileCoord_[0],r=this.targetTileGrid_.getTileSize(e),n="number"==typeof r?r:r[0],i="number"==typeof r?r:r[1],o=this.targetTileGrid_.getResolution(e),a=this.sourceTileGrid_.getResolution(this.sourceZ_),s=this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);this.canvas_=Sh(n,i,this.pixelRatio_,a,this.sourceTileGrid_.getExtent(),o,s,this.triangulation_,t,this.gutter_,this.renderEdges_,this.contextOptions_),this.state=fa}this.changed()},e.prototype.load=function(){if(this.state==ca){this.state=pa,this.changed();var t=0;this.sourcesListenerKeys_=[],this.sourceTiles_.forEach(function(e,r,n){var i=e.getState();if(i==ca||i==pa){t++;var o=W(e,I,(function(r){var n=e.getState();n!=fa&&n!=da&&n!=ga||(X(o),0===--t&&(this.unlistenSources_(),this.reproject_()))}),this);this.sourcesListenerKeys_.push(o)}}.bind(this)),this.sourceTiles_.forEach((function(t,e,r){t.getState()==ca&&t.load()})),0===t&&setTimeout(this.reproject_.bind(this),0)}},e.prototype.unlistenSources_=function(){this.sourcesListenerKeys_.forEach(X),this.sourcesListenerKeys_=null},e}(dh),Ch=function(){function t(t){this.highWaterMark=void 0!==t?t:2048,this.count_=0,this.entries_={},this.oldest_=null,this.newest_=null}return t.prototype.canExpireCache=function(){return this.highWaterMark>0&&this.getCount()>this.highWaterMark},t.prototype.clear=function(){this.count_=0,this.entries_={},this.oldest_=null,this.newest_=null},t.prototype.containsKey=function(t){return this.entries_.hasOwnProperty(t)},t.prototype.forEach=function(t){for(var e=this.oldest_;e;)t(e.value_,e.key_,this),e=e.newer},t.prototype.get=function(t,e){var r=this.entries_[t];return lt(void 0!==r,15),r===this.newest_||(r===this.oldest_?(this.oldest_=this.oldest_.newer,this.oldest_.older=null):(r.newer.older=r.older,r.older.newer=r.newer),r.newer=null,r.older=this.newest_,this.newest_.newer=r,this.newest_=r),r.value_},t.prototype.remove=function(t){var e=this.entries_[t];return lt(void 0!==e,15),e===this.newest_?(this.newest_=e.older,this.newest_&&(this.newest_.newer=null)):e===this.oldest_?(this.oldest_=e.newer,this.oldest_&&(this.oldest_.older=null)):(e.newer.older=e.older,e.older.newer=e.newer),delete this.entries_[t],--this.count_,e.value_},t.prototype.getCount=function(){return this.count_},t.prototype.getKeys=function(){var t,e=new Array(this.count_),r=0;for(t=this.newest_;t;t=t.older)e[r++]=t.key_;return e},t.prototype.getValues=function(){var t,e=new Array(this.count_),r=0;for(t=this.newest_;t;t=t.older)e[r++]=t.value_;return e},t.prototype.peekLast=function(){return this.oldest_.value_},t.prototype.peekLastKey=function(){return this.oldest_.key_},t.prototype.peekFirstKey=function(){return this.newest_.key_},t.prototype.pop=function(){var t=this.oldest_;return delete this.entries_[t.key_],t.newer&&(t.newer.older=null),this.oldest_=t.newer,this.oldest_||(this.newest_=null),--this.count_,t.value_},t.prototype.replace=function(t,e){this.get(t),this.entries_[t].value_=e},t.prototype.set=function(t,e){lt(!(t in this.entries_),16);var r={key_:t,newer:null,older:this.newest_,value_:e};this.newest_?this.newest_.newer=r:this.oldest_=r,this.newest_=r,this.entries_[t]=r,++this.count_},t.prototype.setSize=function(t){this.highWaterMark=t},t}(),Ph=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Rh=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return Ph(e,t),e.prototype.expireCache=function(t){for(;this.canExpireCache();){if(this.peekLast().getKey()in t)break;this.pop().release()}},e.prototype.pruneExceptNewestZ=function(){if(0!==this.getCount()){var t=Iu(this.peekFirstKey())[0];this.forEach(function(e){e.tileCoord[0]!==t&&(this.remove(Ou(e.tileCoord)),e.release())}.bind(this))}},e}(Ch),Oh="tileloadstart",Ih="tileloadend",Lh="tileloaderror",Mh=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Fh(t){return t?Array.isArray(t)?function(e){return t}:"function"==typeof t?t:function(e){return[t]}:null}var Ah=function(t){function e(e){var r=t.call(this)||this;return r.projection_=yr(e.projection),r.attributions_=Fh(e.attributions),r.attributionsCollapsible_=void 0===e.attributionsCollapsible||e.attributionsCollapsible,r.loading=!1,r.state_=void 0!==e.state?e.state:Pi,r.wrapX_=void 0!==e.wrapX&&e.wrapX,r}return Mh(e,t),e.prototype.getAttributions=function(){return this.attributions_},e.prototype.getAttributionsCollapsible=function(){return this.attributionsCollapsible_},e.prototype.getProjection=function(){return this.projection_},e.prototype.getResolutions=function(){return n()},e.prototype.getState=function(){return this.state_},e.prototype.getWrapX=function(){return this.wrapX_},e.prototype.getContextOptions=function(){},e.prototype.refresh=function(){this.changed()},e.prototype.setAttributions=function(t){this.attributions_=Fh(t),this.changed()},e.prototype.setState=function(t){this.state_=t,this.changed()},e}(rt),kh=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Nh=function(t){function e(e){var r=t.call(this,{attributions:e.attributions,attributionsCollapsible:e.attributionsCollapsible,projection:e.projection,state:e.state,wrapX:e.wrapX})||this;r.opaque_=void 0!==e.opaque&&e.opaque,r.tilePixelRatio_=void 0!==e.tilePixelRatio?e.tilePixelRatio:1,r.tileGrid=void 0!==e.tileGrid?e.tileGrid:null;var n=e.tileGrid;return n&&za(n.getTileSize(n.getMinZoom()),[256,256]),r.tileCache=new Rh(e.cacheSize||0),r.tmpSize=[0,0],r.key_=e.key||"",r.tileOptions={transition:e.transition},r.zDirection=e.zDirection?e.zDirection:0,r}return kh(e,t),e.prototype.canExpireCache=function(){return this.tileCache.canExpireCache()},e.prototype.expireCache=function(t,e){var r=this.getTileCacheForProjection(t);r&&r.expireCache(e)},e.prototype.forEachLoadedTile=function(t,e,r,n){var i=this.getTileCacheForProjection(t);if(!i)return!1;for(var o,a,s,u=!0,l=r.minX;l<=r.maxX;++l)for(var h=r.minY;h<=r.maxY;++h)a=Ru(e,l,h),s=!1,i.containsKey(a)&&(s=(o=i.get(a)).getState()===fa)&&(s=!1!==n(o)),s||(u=!1);return u},e.prototype.getGutterForProjection=function(t){return 0},e.prototype.getKey=function(){return this.key_},e.prototype.setKey=function(t){this.key_!==t&&(this.key_=t,this.changed())},e.prototype.getOpaque=function(t){return this.opaque_},e.prototype.getResolutions=function(){return this.tileGrid.getResolutions()},e.prototype.getTile=function(t,e,r,i,o){return n()},e.prototype.getTileGrid=function(){return this.tileGrid},e.prototype.getTileGridForProjection=function(t){return this.tileGrid?this.tileGrid:Au(t)},e.prototype.getTileCacheForProjection=function(t){var e=this.getProjection();return e&&!Sr(e,t)?null:this.tileCache},e.prototype.getTilePixelRatio=function(t){return this.tilePixelRatio_},e.prototype.getTilePixelSize=function(t,e,r){var n=this.getTileGridForProjection(r),i=this.getTilePixelRatio(e),o=za(n.getTileSize(t),this.tmpSize);return 1==i?o:Da(o,i,this.tmpSize)},e.prototype.getTileCoordForTileUrlFunction=function(t,e){var r=void 0!==e?e:this.getProjection(),n=this.getTileGridForProjection(r);return this.getWrapX()&&r.isGlobal()&&(t=function(t,e,r){var n=e[0],i=t.getTileCoordCenter(e),o=Gu(r);if(Yt(o,i))return e;var a=ge(o),s=Math.ceil((o[0]-i[0])/a);return i[0]+=a*s,t.getTileCoordForCoordAndZ(i,n)}(n,t,r)),function(t,e){var r=t[0],n=t[1],i=t[2];if(e.getMinZoom()>r||r>e.getMaxZoom())return!1;var o,a=e.getExtent();return!(o=a?e.getTileRangeForExtentAndZ(a,r):e.getFullTileRange(r))||o.containsXY(n,i)}(t,n)?t:null},e.prototype.clear=function(){this.tileCache.clear()},e.prototype.refresh=function(){this.clear(),t.prototype.refresh.call(this)},e.prototype.updateCacheSize=function(t,e){var r=this.getTileCacheForProjection(e);t>r.highWaterMark&&(r.highWaterMark=t)},e.prototype.useTile=function(t,e,r,n){},e}(Ah),jh=function(t){function e(e,r){var n=t.call(this,e)||this;return n.tile=r,n}return kh(e,t),e}(h),Gh=Nh;function Dh(t,e){var r=/\{z\}/g,n=/\{x\}/g,i=/\{y\}/g,o=/\{-y\}/g;return function(a,s,u){return a?t.replace(r,a[0].toString()).replace(n,a[1].toString()).replace(i,a[2].toString()).replace(o,(function(){var t=a[0],r=e.getFullTileRange(t);return lt(r,55),(r.getHeight()-a[2]-1).toString()})):void 0}}function zh(t,e){for(var r=t.length,n=new Array(r),i=0;i<r;++i)n[i]=Dh(t[i],e);return Uh(n)}function Uh(t){return 1===t.length?t[0]:function(e,r,n){if(e){var i=Oe(Lu(e),t.length);return t[i](e,r,n)}}}function Bh(t,e,r){}function Yh(t){var e=[],r=/\{([a-z])-([a-z])\}/.exec(t);if(r){var n=r[1].charCodeAt(0),i=r[2].charCodeAt(0),o=void 0;for(o=n;o<=i;++o)e.push(t.replace(r[0],String.fromCharCode(o)));return e}if(r=/\{(\d+)-(\d+)\}/.exec(t)){for(var a=parseInt(r[2],10),s=parseInt(r[1],10);s<=a;s++)e.push(t.replace(r[0],s.toString()));return e}return e.push(t),e}var Vh=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Wh=function(t){function e(r){var n=t.call(this,{attributions:r.attributions,cacheSize:r.cacheSize,opaque:r.opaque,projection:r.projection,state:r.state,tileGrid:r.tileGrid,tilePixelRatio:r.tilePixelRatio,wrapX:r.wrapX,transition:r.transition,key:r.key,attributionsCollapsible:r.attributionsCollapsible,zDirection:r.zDirection})||this;return n.generateTileUrlFunction_=n.tileUrlFunction===e.prototype.tileUrlFunction,n.tileLoadFunction=r.tileLoadFunction,r.tileUrlFunction&&(n.tileUrlFunction=r.tileUrlFunction.bind(n)),n.urls=null,r.urls?n.setUrls(r.urls):r.url&&n.setUrl(r.url),n.tileLoadingKeys_={},n}return Vh(e,t),e.prototype.getTileLoadFunction=function(){return this.tileLoadFunction},e.prototype.getTileUrlFunction=function(){return this.tileUrlFunction},e.prototype.getUrls=function(){return this.urls},e.prototype.handleTileChange=function(t){var e,r=t.target,n=o(r),i=r.getState();i==pa?(this.tileLoadingKeys_[n]=!0,e=Oh):n in this.tileLoadingKeys_&&(delete this.tileLoadingKeys_[n],e=i==da?Lh:i==fa?Ih:void 0),null!=e&&this.dispatchEvent(new jh(e,r))},e.prototype.setTileLoadFunction=function(t){this.tileCache.clear(),this.tileLoadFunction=t,this.changed()},e.prototype.setTileUrlFunction=function(t,e){this.tileUrlFunction=t,this.tileCache.pruneExceptNewestZ(),void 0!==e?this.setKey(e):this.changed()},e.prototype.setUrl=function(t){var e=Yh(t);this.urls=e,this.setUrls(e)},e.prototype.setUrls=function(t){this.urls=t;var e=t.join("\n");this.generateTileUrlFunction_?this.setTileUrlFunction(zh(t,this.tileGrid),e):this.setKey(e)},e.prototype.tileUrlFunction=function(t,e,r){},e.prototype.useTile=function(t,e,r){var n=Ru(t,e,r);this.tileCache.containsKey(n)&&this.tileCache.get(n)},e}(Gh),qh=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Xh(t,e){t.getImage().src=e}var Zh=function(t){function e(e){var r=t.call(this,{attributions:e.attributions,cacheSize:e.cacheSize,opaque:e.opaque,projection:e.projection,state:e.state,tileGrid:e.tileGrid,tileLoadFunction:e.tileLoadFunction?e.tileLoadFunction:Xh,tilePixelRatio:e.tilePixelRatio,tileUrlFunction:e.tileUrlFunction,url:e.url,urls:e.urls,wrapX:e.wrapX,transition:e.transition,key:e.key,attributionsCollapsible:e.attributionsCollapsible,zDirection:e.zDirection})||this;return r.crossOrigin=void 0!==e.crossOrigin?e.crossOrigin:null,r.tileClass=void 0!==e.tileClass?e.tileClass:mh,r.tileCacheForProjection={},r.tileGridForProjection={},r.reprojectionErrorThreshold_=e.reprojectionErrorThreshold,r.contextOptions_=!1===e.imageSmoothing?_h:void 0,r.renderReprojectionEdges_=!1,r}return qh(e,t),e.prototype.canExpireCache=function(){if(this.tileCache.canExpireCache())return!0;for(var t in this.tileCacheForProjection)if(this.tileCacheForProjection[t].canExpireCache())return!0;return!1},e.prototype.expireCache=function(t,e){var r=this.getTileCacheForProjection(t);for(var n in this.tileCache.expireCache(this.tileCache==r?e:{}),this.tileCacheForProjection){var i=this.tileCacheForProjection[n];i.expireCache(i==r?e:{})}},e.prototype.getContextOptions=function(){return this.contextOptions_},e.prototype.getGutterForProjection=function(t){return this.getProjection()&&t&&!Sr(this.getProjection(),t)?0:this.getGutter()},e.prototype.getGutter=function(){return 0},e.prototype.getKey=function(){return t.prototype.getKey.call(this)+(this.contextOptions_?"\n"+JSON.stringify(this.contextOptions_):"")},e.prototype.getOpaque=function(e){return!(this.getProjection()&&e&&!Sr(this.getProjection(),e))&&t.prototype.getOpaque.call(this,e)},e.prototype.getTileGridForProjection=function(t){var e=this.getProjection();if(!this.tileGrid||e&&!Sr(e,t)){var r=o(t);return r in this.tileGridForProjection||(this.tileGridForProjection[r]=Au(t)),this.tileGridForProjection[r]}return this.tileGrid},e.prototype.getTileCacheForProjection=function(t){var e=this.getProjection();if(!e||Sr(e,t))return this.tileCache;var r=o(t);return r in this.tileCacheForProjection||(this.tileCacheForProjection[r]=new Rh(this.tileCache.highWaterMark)),this.tileCacheForProjection[r]},e.prototype.createTile_=function(t,e,r,n,i,o){var a=[t,e,r],s=this.getTileCoordForTileUrlFunction(a,i),u=s?this.tileUrlFunction(s,n,i):void 0,l=new this.tileClass(a,void 0!==u?ca:ga,void 0!==u?u:"",this.crossOrigin,this.tileLoadFunction,this.tileOptions);return l.key=o,l.addEventListener(I,this.handleTileChange.bind(this)),l},e.prototype.getTile=function(t,e,r,n,i){var o=this.getProjection();if(o&&i&&!Sr(o,i)){var a=this.getTileCacheForProjection(i),s=[t,e,r],u=void 0,l=Ou(s);a.containsKey(l)&&(u=a.get(l));var h=this.getKey();if(u&&u.key==h)return u;var c=this.getTileGridForProjection(o),p=this.getTileGridForProjection(i),f=this.getTileCoordForTileUrlFunction(s,i),d=new Eh(o,c,i,p,s,f,this.getTilePixelRatio(n),this.getGutter(),function(t,e,r,n){return this.getTileInternal(t,e,r,n,o)}.bind(this),this.reprojectionErrorThreshold_,this.renderReprojectionEdges_,this.contextOptions_);return d.key=h,u?(d.interimTile=u,d.refreshInterimChain(),a.replace(l,d)):a.set(l,d),d}return this.getTileInternal(t,e,r,n,o||i)},e.prototype.getTileInternal=function(t,e,r,n,i){var o=null,a=Ru(t,e,r),s=this.getKey();if(this.tileCache.containsKey(a)){if((o=this.tileCache.get(a)).key!=s){var u=o;o=this.createTile_(t,e,r,n,i,s),u.getState()==ca?o.interimTile=u.interimTile:o.interimTile=u,o.refreshInterimChain(),this.tileCache.replace(a,o)}}else o=this.createTile_(t,e,r,n,i,s),this.tileCache.set(a,o);return o},e.prototype.setRenderReprojectionEdges=function(t){if(this.renderReprojectionEdges_!=t){for(var e in this.renderReprojectionEdges_=t,this.tileCacheForProjection)this.tileCacheForProjection[e].clear();this.changed()}},e.prototype.setTileGridForProjection=function(t,e){var r=yr(t);if(r){var n=o(r);n in this.tileGridForProjection||(this.tileGridForProjection[n]=e)}},e}(Wh);function Kh(t,e,r,n){var i=document.createElement("script"),a="olc_"+o(e);function s(){delete window[a],i.parentNode.removeChild(i)}i.async=!0,i.src=t+(-1==t.indexOf("?")?"?":"&")+(n||"callback")+"="+a;var u=setTimeout((function(){s(),r&&r()}),1e4);window[a]=function(t){clearTimeout(u),s(),e(t)},document.getElementsByTagName("head")[0].appendChild(i)}var Hh=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();var Jh=function(t){function e(e){var r=this,n=void 0!==e.hidpi&&e.hidpi;return(r=t.call(this,{cacheSize:e.cacheSize,crossOrigin:"anonymous",imageSmoothing:e.imageSmoothing,opaque:!0,projection:yr("EPSG:3857"),reprojectionErrorThreshold:e.reprojectionErrorThreshold,state:Ci,tileLoadFunction:e.tileLoadFunction,tilePixelRatio:n?2:1,wrapX:void 0===e.wrapX||e.wrapX,transition:e.transition})||this).hidpi_=n,r.culture_=void 0!==e.culture?e.culture:"en-us",r.maxZoom_=void 0!==e.maxZoom?e.maxZoom:-1,r.apiKey_=e.key,r.imagerySet_=e.imagerySet,Kh("https://dev.virtualearth.net/REST/v1/Imagery/Metadata/"+r.imagerySet_+"?uriScheme=https&include=ImageryProviders&key="+r.apiKey_+"&c="+r.culture_,r.handleImageryMetadataResponse.bind(r),void 0,"jsonp"),r}return Hh(e,t),e.prototype.getApiKey=function(){return this.apiKey_},e.prototype.getImagerySet=function(){return this.imagerySet_},e.prototype.handleImageryMetadataResponse=function(t){if(200==t.statusCode&&"OK"==t.statusDescription&&"ValidCredentials"==t.authenticationResultCode&&1==t.resourceSets.length&&1==t.resourceSets[0].resources.length){var e=t.resourceSets[0].resources[0],r=-1==this.maxZoom_?e.zoomMax:this.maxZoom_,n=Gu(this.getProjection()),i=this.hidpi_?2:1,o=e.imageWidth==e.imageHeight?e.imageWidth/i:[e.imageWidth/i,e.imageHeight/i],a=ku({extent:n,minZoom:e.zoomMin,maxZoom:r,tileSize:o});this.tileGrid=a;var s=this.culture_,u=this.hidpi_;if(this.tileUrlFunction=Uh(e.imageUrlSubdomains.map((function(t){var r=[0,0,0],n=e.imageUrl.replace("{subdomain}",t).replace("{culture}",s);return function(t,e,i){if(t){Pu(t[0],t[1],t[2],r);var o=n;return u&&(o+="&dpi=d1&device=mobile"),o.replace("{quadkey}",function(t){var e,r,n=t[0],i=new Array(n),o=1<<n-1;for(e=0;e<n;++e)r=48,t[1]&o&&(r+=1),t[2]&o&&(r+=2),i[e]=String.fromCharCode(r),o>>=1;return i.join("")}(r))}}}))),e.imageryProviders){var l=Tr(yr("EPSG:4326"),this.getProjection());this.setAttributions(function(t){var r=[],n=t.viewState,i=this.getTileGrid(),o=i.getZForResolution(n.resolution,this.zDirection),a=i.getTileCoordForCoordAndZ(n.center,o)[0];return e.imageryProviders.map((function(e){for(var n=!1,i=e.coverageAreas,o=0,s=i.length;o<s;++o){var u=i[o];if(a>=u.zoomMin&&a<=u.zoomMax){var h=u.bbox;if(ye(_e([h[1],h[0],h[3],h[2]],l),t.extent)){n=!0;break}}}n&&r.push(e.attribution)})),r.push('<a class="ol-attribution-bing-tos" href="https://www.microsoft.com/maps/product/terms.html" target="_blank">Terms of Use</a>'),r}.bind(this))}this.setState(Pi)}else this.setState(Ri)},e}(Zh),$h=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Qh=function(t){function e(e){var r=e||{},n=void 0!==r.projection?r.projection:"EPSG:3857",i=void 0!==r.tileGrid?r.tileGrid:ku({extent:Gu(n),maxResolution:r.maxResolution,maxZoom:r.maxZoom,minZoom:r.minZoom,tileSize:r.tileSize});return t.call(this,{attributions:r.attributions,cacheSize:r.cacheSize,crossOrigin:r.crossOrigin,imageSmoothing:r.imageSmoothing,opaque:r.opaque,projection:n,reprojectionErrorThreshold:r.reprojectionErrorThreshold,tileGrid:i,tileLoadFunction:r.tileLoadFunction,tilePixelRatio:r.tilePixelRatio,tileUrlFunction:r.tileUrlFunction,url:r.url,urls:r.urls,wrapX:void 0===r.wrapX||r.wrapX,transition:r.transition,attributionsCollapsible:r.attributionsCollapsible,zDirection:r.zDirection})||this}return $h(e,t),e}(Zh),tc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ec=function(t){function e(e){var r=t.call(this,{attributions:e.attributions,cacheSize:e.cacheSize,crossOrigin:e.crossOrigin,maxZoom:void 0!==e.maxZoom?e.maxZoom:18,minZoom:e.minZoom,projection:e.projection,wrapX:e.wrapX})||this;return r.account_=e.account,r.mapId_=e.map||"",r.config_=e.config||{},r.templateCache_={},r.initializeMap_(),r}return tc(e,t),e.prototype.getConfig=function(){return this.config_},e.prototype.updateConfig=function(t){T(this.config_,t),this.initializeMap_()},e.prototype.setConfig=function(t){this.config_=t||{},this.initializeMap_()},e.prototype.initializeMap_=function(){var t=JSON.stringify(this.config_);if(this.templateCache_[t])this.applyTemplate_(this.templateCache_[t]);else{var e="https://"+this.account_+".carto.com/api/v1/map";this.mapId_&&(e+="/named/"+this.mapId_);var r=new XMLHttpRequest;r.addEventListener("load",this.handleInitResponse_.bind(this,t)),r.addEventListener("error",this.handleInitError_.bind(this)),r.open("POST",e),r.setRequestHeader("Content-type","application/json"),r.send(JSON.stringify(this.config_))}},e.prototype.handleInitResponse_=function(t,e){var r=e.target;if(!r.status||r.status>=200&&r.status<300){var n=void 0;try{n=JSON.parse(r.responseText)}catch(t){return void this.setState(Ri)}this.applyTemplate_(n),this.templateCache_[t]=n,this.setState(Pi)}else this.setState(Ri)},e.prototype.handleInitError_=function(t){this.setState(Ri)},e.prototype.applyTemplate_=function(t){var e="https://"+t.cdn_url.https+"/"+this.account_+"/api/v1/map/"+t.layergroupid+"/{z}/{x}/{y}.png";this.setUrl(e)},e}(Qh),rc=r(1),nc=r.n(rc),ic=function(){function t(t){this.rbush_=new nc.a(t),this.items_={}}return t.prototype.insert=function(t,e){var r={minX:t[0],minY:t[1],maxX:t[2],maxY:t[3],value:e};this.rbush_.insert(r),this.items_[o(e)]=r},t.prototype.load=function(t,e){for(var r=new Array(e.length),n=0,i=e.length;n<i;n++){var a=t[n],s=e[n],u={minX:a[0],minY:a[1],maxX:a[2],maxY:a[3],value:s};r[n]=u,this.items_[o(s)]=u}this.rbush_.load(r)},t.prototype.remove=function(t){var e=o(t),r=this.items_[e];return delete this.items_[e],null!==this.rbush_.remove(r)},t.prototype.update=function(t,e){var r=this.items_[o(e)];$t([r.minX,r.minY,r.maxX,r.maxY],t)||(this.remove(e),this.insert(t,e))},t.prototype.getAll=function(){return this.rbush_.all().map((function(t){return t.value}))},t.prototype.getInExtent=function(t){var e={minX:t[0],minY:t[1],maxX:t[2],maxY:t[3]};return this.rbush_.search(e).map((function(t){return t.value}))},t.prototype.forEach=function(t){return this.forEach_(this.getAll(),t)},t.prototype.forEachInExtent=function(t,e){return this.forEach_(this.getInExtent(t),e)},t.prototype.forEach_=function(t,e){for(var r,n=0,i=t.length;n<i;n++)if(r=e(t[n]))return r;return r},t.prototype.isEmpty=function(){return P(this.items_)},t.prototype.clear=function(){this.rbush_.clear(),this.items_={}},t.prototype.getExtent=function(t){var e=this.rbush_.toJSON();return Zt(e.minX,e.minY,e.maxX,e.maxY,t)},t.prototype.concat=function(t){for(var e in this.rbush_.load(t.rbush_.all()),t.items_)this.items_[e]=t.items_[e]},t}(),oc="addfeature",ac="changefeature",sc="clear",uc="removefeature",lc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),hc=function(t){function e(e,r){var n=t.call(this,e)||this;return n.feature=r,n}return lc(e,t),e}(h),cc=function(t){function e(e){var r=this,n=e||{};(r=t.call(this,{attributions:n.attributions,projection:void 0,state:Pi,wrapX:void 0===n.wrapX||n.wrapX})||this).loader_=S,r.format_=n.format,r.overlaps_=void 0===n.overlaps||n.overlaps,r.url_=n.url,void 0!==n.loader?r.loader_=n.loader:void 0!==r.url_&&(lt(r.format_,7),r.loader_=wu(r.url_,r.format_)),r.strategy_=void 0!==n.strategy?n.strategy:Su;var i,o,a=void 0===n.useSpatialIndex||n.useSpatialIndex;return r.featuresRtree_=a?new ic:null,r.loadedExtentsRtree_=new ic,r.nullGeometryFeatures_={},r.idIndex_={},r.uidIndex_={},r.featureChangeKeys_={},r.featuresCollection_=null,Array.isArray(n.features)?o=n.features:n.features&&(o=(i=n.features).getArray()),a||void 0!==i||(i=new ut(o)),void 0!==o&&r.addFeaturesInternal(o),void 0!==i&&r.bindFeaturesCollection_(i),r}return lc(e,t),e.prototype.addFeature=function(t){this.addFeatureInternal(t),this.changed()},e.prototype.addFeatureInternal=function(t){var e=o(t);if(this.addToIndex_(e,t)){this.setupChangeEvents_(e,t);var r=t.getGeometry();if(r){var n=r.getExtent();this.featuresRtree_&&this.featuresRtree_.insert(n,t)}else this.nullGeometryFeatures_[e]=t;this.dispatchEvent(new hc(oc,t))}else this.featuresCollection_&&this.featuresCollection_.remove(t)},e.prototype.setupChangeEvents_=function(t,e){this.featureChangeKeys_[t]=[W(e,I,this.handleFeatureChange_,this),W(e,c,this.handleFeatureChange_,this)]},e.prototype.addToIndex_=function(t,e){var r=!0,n=e.getId();return void 0!==n&&(n.toString()in this.idIndex_?r=!1:this.idIndex_[n.toString()]=e),r&&(lt(!(t in this.uidIndex_),30),this.uidIndex_[t]=e),r},e.prototype.addFeatures=function(t){this.addFeaturesInternal(t),this.changed()},e.prototype.addFeaturesInternal=function(t){for(var e=[],r=[],n=[],i=0,a=t.length;i<a;i++){var s=o(l=t[i]);this.addToIndex_(s,l)&&r.push(l)}i=0;for(var u=r.length;i<u;i++){var l;s=o(l=r[i]);this.setupChangeEvents_(s,l);var h=l.getGeometry();if(h){var c=h.getExtent();e.push(c),n.push(l)}else this.nullGeometryFeatures_[s]=l}this.featuresRtree_&&this.featuresRtree_.load(e,n);i=0;for(var p=r.length;i<p;i++)this.dispatchEvent(new hc(oc,r[i]))},e.prototype.bindFeaturesCollection_=function(t){var e=!1;this.addEventListener(oc,(function(r){e||(e=!0,t.push(r.feature),e=!1)})),this.addEventListener(uc,(function(r){e||(e=!0,t.remove(r.feature),e=!1)})),t.addEventListener(nt,function(t){e||(e=!0,this.addFeature(t.element),e=!1)}.bind(this)),t.addEventListener(it,function(t){e||(e=!0,this.removeFeature(t.element),e=!1)}.bind(this)),this.featuresCollection_=t},e.prototype.clear=function(t){if(t){for(var e in this.featureChangeKeys_){this.featureChangeKeys_[e].forEach(X)}this.featuresCollection_||(this.featureChangeKeys_={},this.idIndex_={},this.uidIndex_={})}else if(this.featuresRtree_)for(var r in this.featuresRtree_.forEach(this.removeFeatureInternal.bind(this)),this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[r]);this.featuresCollection_&&this.featuresCollection_.clear(),this.featuresRtree_&&this.featuresRtree_.clear(),this.nullGeometryFeatures_={};var n=new hc(sc);this.dispatchEvent(n),this.changed()},e.prototype.forEachFeature=function(t){if(this.featuresRtree_)return this.featuresRtree_.forEach(t);this.featuresCollection_&&this.featuresCollection_.forEach(t)},e.prototype.forEachFeatureAtCoordinateDirect=function(t,e){var r=[t[0],t[1],t[0],t[1]];return this.forEachFeatureInExtent(r,(function(r){return r.getGeometry().intersectsCoordinate(t)?e(r):void 0}))},e.prototype.forEachFeatureInExtent=function(t,e){if(this.featuresRtree_)return this.featuresRtree_.forEachInExtent(t,e);this.featuresCollection_&&this.featuresCollection_.forEach(e)},e.prototype.forEachFeatureIntersectingExtent=function(t,e){return this.forEachFeatureInExtent(t,(function(r){if(r.getGeometry().intersectsExtent(t)){var n=e(r);if(n)return n}}))},e.prototype.getFeaturesCollection=function(){return this.featuresCollection_},e.prototype.getFeatures=function(){var t;return this.featuresCollection_?t=this.featuresCollection_.getArray():this.featuresRtree_&&(t=this.featuresRtree_.getAll(),P(this.nullGeometryFeatures_)||m(t,C(this.nullGeometryFeatures_))),t},e.prototype.getFeaturesAtCoordinate=function(t){var e=[];return this.forEachFeatureAtCoordinateDirect(t,(function(t){e.push(t)})),e},e.prototype.getFeaturesInExtent=function(t){return this.featuresRtree_?this.featuresRtree_.getInExtent(t):this.featuresCollection_?this.featuresCollection_.getArray():[]},e.prototype.getClosestFeatureToCoordinate=function(t,e){var r=t[0],n=t[1],i=null,o=[NaN,NaN],a=1/0,s=[-1/0,-1/0,1/0,1/0],u=e||x;return this.featuresRtree_.forEachInExtent(s,(function(t){if(u(t)){var e=t.getGeometry(),l=a;if((a=e.closestPointXY(r,n,o,a))<l){i=t;var h=Math.sqrt(a);s[0]=r-h,s[1]=n-h,s[2]=r+h,s[3]=n+h}}})),i},e.prototype.getExtent=function(t){return this.featuresRtree_.getExtent(t)},e.prototype.getFeatureById=function(t){var e=this.idIndex_[t.toString()];return void 0!==e?e:null},e.prototype.getFeatureByUid=function(t){var e=this.uidIndex_[t];return void 0!==e?e:null},e.prototype.getFormat=function(){return this.format_},e.prototype.getOverlaps=function(){return this.overlaps_},e.prototype.getUrl=function(){return this.url_},e.prototype.handleFeatureChange_=function(t){var e=t.target,r=o(e),n=e.getGeometry();if(n){var i=n.getExtent();r in this.nullGeometryFeatures_?(delete this.nullGeometryFeatures_[r],this.featuresRtree_&&this.featuresRtree_.insert(i,e)):this.featuresRtree_&&this.featuresRtree_.update(i,e)}else r in this.nullGeometryFeatures_||(this.featuresRtree_&&this.featuresRtree_.remove(e),this.nullGeometryFeatures_[r]=e);var a=e.getId();if(void 0!==a){var s=a.toString();this.idIndex_[s]!==e&&(this.removeFromIdIndex_(e),this.idIndex_[s]=e)}else this.removeFromIdIndex_(e),this.uidIndex_[r]=e;this.changed(),this.dispatchEvent(new hc(ac,e))},e.prototype.hasFeature=function(t){var e=t.getId();return void 0!==e?e in this.idIndex_:o(t)in this.uidIndex_},e.prototype.isEmpty=function(){return this.featuresRtree_.isEmpty()&&P(this.nullGeometryFeatures_)},e.prototype.loadFeatures=function(t,e,r){var n=this.loadedExtentsRtree_,i=this.strategy_(t,e);this.loading=!1;for(var o=function(t,o){var s=i[t];n.forEachInExtent(s,(function(t){return Vt(t.extent,s)}))||(a.loader_.call(a,s,e,r),n.insert(s,{extent:s.slice()}),a.loading=a.loader_!==S)},a=this,s=0,u=i.length;s<u;++s)o(s)},e.prototype.refresh=function(){this.clear(!0),this.loadedExtentsRtree_.clear(),t.prototype.refresh.call(this)},e.prototype.removeLoadedExtent=function(t){var e,r=this.loadedExtentsRtree_;r.forEachInExtent(t,(function(r){if($t(r.extent,t))return e=r,!0})),e&&r.remove(e)},e.prototype.removeFeature=function(t){var e=o(t);e in this.nullGeometryFeatures_?delete this.nullGeometryFeatures_[e]:this.featuresRtree_&&this.featuresRtree_.remove(t),this.removeFeatureInternal(t),this.changed()},e.prototype.removeFeatureInternal=function(t){var e=o(t);this.featureChangeKeys_[e].forEach(X),delete this.featureChangeKeys_[e];var r=t.getId();void 0!==r&&delete this.idIndex_[r.toString()],delete this.uidIndex_[e],this.dispatchEvent(new hc(uc,t))},e.prototype.removeFromIdIndex_=function(t){var e=!1;for(var r in this.idIndex_)if(this.idIndex_[r]===t){delete this.idIndex_[r],e=!0;break}return e},e.prototype.setLoader=function(t){this.loader_=t},e.prototype.setUrl=function(t){lt(this.format_,7),this.setLoader(wu(t,this.format_))},e}(Ah),pc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),fc=function(t){function e(e){var r=t.call(this,{attributions:e.attributions,wrapX:e.wrapX})||this;return r.resolution=void 0,r.distance=void 0!==e.distance?e.distance:20,r.features=[],r.geometryFunction=e.geometryFunction||function(t){var e=t.getGeometry();return lt(e.getType()==yt.POINT,10),e},r.boundRefresh_=r.refresh.bind(r),r.setSource(e.source||null),r}return pc(e,t),e.prototype.clear=function(e){this.features.length=0,t.prototype.clear.call(this,e)},e.prototype.getDistance=function(){return this.distance},e.prototype.getSource=function(){return this.source},e.prototype.loadFeatures=function(t,e,r){this.source.loadFeatures(t,e,r),e!==this.resolution&&(this.clear(),this.resolution=e,this.cluster(),this.addFeatures(this.features))},e.prototype.setDistance=function(t){this.distance=t,this.refresh()},e.prototype.setSource=function(t){this.source&&this.source.removeEventListener(I,this.boundRefresh_),this.source=t,t&&t.addEventListener(I,this.boundRefresh_),this.refresh()},e.prototype.refresh=function(){this.clear(),this.cluster(),this.addFeatures(this.features)},e.prototype.cluster=function(){if(void 0!==this.resolution&&this.source)for(var t=[1/0,1/0,-1/0,-1/0],e=this.distance*this.resolution,r=this.source.getFeatures(),n={},i=0,a=r.length;i<a;i++){var s=r[i];if(!(o(s)in n)){var u=this.geometryFunction(s);if(u){Ht(u.getCoordinates(),t),zt(t,e,t);var l=this.source.getFeaturesInExtent(t);l=l.filter((function(t){var e=o(t);return!(e in n)&&(n[e]=!0,!0)})),this.features.push(this.createCluster(l))}}}},e.prototype.createCluster=function(t){for(var e=[0,0],r=t.length-1;r>=0;--r){var n=this.geometryFunction(t[r]);n?tr(e,n.getCoordinates()):t.splice(r,1)}ar(e,1/t.length);var i=new ct(new gn(e));return i.set("features",t),i},e}(cc),dc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),gc="default",yc="truncated",mc=function(t){function e(e,r,n,i,o,a,s){var u=t.call(this,r,n,i,o,a,s)||this;return u.zoomifyImage_=null,u.tileSize_=e,u}return dc(e,t),e.prototype.getImage=function(){if(this.zoomifyImage_)return this.zoomifyImage_;var e=t.prototype.getImage.call(this);if(this.state==fa){var r=this.tileSize_;if(e.width==r[0]&&e.height==r[1])return this.zoomifyImage_=e,e;var n=Bi(r[0],r[1]);return n.drawImage(e,0,0),this.zoomifyImage_=n.canvas,n.canvas}return e},e}(mh),vc=function(t){function e(e){var r=this,n=e,i=n.size,o=void 0!==n.tierSizeCalculation?n.tierSizeCalculation:gc,a=n.tilePixelRatio||1,s=i[0],u=i[1],l=[],h=n.tileSize||256,c=h*a;switch(o){case gc:for(;s>c||u>c;)l.push([Math.ceil(s/c),Math.ceil(u/c)]),c+=c;break;case yc:for(var p=s,f=u;p>c||f>c;)l.push([Math.ceil(p/c),Math.ceil(f/c)]),p>>=1,f>>=1;break;default:lt(!1,53)}l.push([1,1]),l.reverse();for(var d=[a],g=[0],y=1,m=l.length;y<m;y++)d.push(a<<y),g.push(l[y-1][0]*l[y-1][1]+g[y-1]);d.reverse();var v=new Fu({tileSize:h,extent:n.extent||[0,-u,s,0],resolutions:d}),_=n.url;_&&-1==_.indexOf("{TileGroup}")&&-1==_.indexOf("{tileIndex}")&&(_+="{TileGroup}/{z}-{x}-{y}.jpg");var b=Yh(_),x=h*a;var w=Uh(b.map((function(t){return function(e,r,n){if(e){var i=e[0],o=e[1],a=e[2],s=o+a*l[i][0],u={z:i,x:o,y:a,tileIndex:s,TileGroup:"TileGroup"+((s+g[i])/x|0)};return t.replace(/\{(\w+?)\}/g,(function(t,e){return u[e]}))}}}))),S=mc.bind(null,za(h*a));(r=t.call(this,{attributions:n.attributions,cacheSize:n.cacheSize,crossOrigin:n.crossOrigin,imageSmoothing:n.imageSmoothing,projection:n.projection,tilePixelRatio:a,reprojectionErrorThreshold:n.reprojectionErrorThreshold,tileClass:S,tileGrid:v,tileUrlFunction:w,transition:n.transition})||this).zDirection=n.zDirection;var T=w(v.getTileCoordForCoordAndResolution(ue(v.getExtent()),d[d.length-1]),1,null),E=new Image;return E.addEventListener("error",function(){x=h,this.changed()}.bind(r)),E.src=T,r}return dc(e,t),e}(Zh),_c=function(){for(var t=0,e=0,r=arguments.length;e<r;e++)t+=arguments[e].length;var n=Array(t),i=0;for(e=0;e<r;e++)for(var o=arguments[e],a=0,s=o.length;a<s;a++,i++)n[i]=o[a];return n},bc="version1",xc="version2",wc="version3",Sc={};Sc[bc]={level0:{supports:[],formats:[],qualities:["native"]},level1:{supports:["regionByPx","sizeByW","sizeByH","sizeByPct"],formats:["jpg"],qualities:["native"]},level2:{supports:["regionByPx","regionByPct","sizeByW","sizeByH","sizeByPct","sizeByConfinedWh","sizeByWh"],formats:["jpg","png"],qualities:["native","color","grey","bitonal"]}},Sc[xc]={level0:{supports:[],formats:["jpg"],qualities:["default"]},level1:{supports:["regionByPx","sizeByW","sizeByH","sizeByPct"],formats:["jpg"],qualities:["default"]},level2:{supports:["regionByPx","regionByPct","sizeByW","sizeByH","sizeByPct","sizeByConfinedWh","sizeByDistortedWh","sizeByWh"],formats:["jpg","png"],qualities:["default","bitonal"]}},Sc[wc]={level0:{supports:[],formats:["jpg"],qualities:["default"]},level1:{supports:["regionByPx","regionSquare","sizeByW","sizeByH","sizeByWh"],formats:["jpg"],qualities:["default"]},level2:{supports:["regionByPx","regionSquare","regionByPct","sizeByW","sizeByH","sizeByPct","sizeByConfinedWh","sizeByWh"],formats:["jpg","png"],qualities:["default"]}},Sc.none={none:{supports:[],formats:[],qualities:[]}};var Tc=/^https?:\/\/library\.stanford\.edu\/iiif\/image-api\/(?:1\.1\/)?compliance\.html#level[0-2]$/,Ec=/^https?:\/\/iiif\.io\/api\/image\/2\/level[0-2](?:\.json)?$/,Cc=/(^https?:\/\/iiif\.io\/api\/image\/3\/level[0-2](?:\.json)?$)|(^level[0-2]$)/;var Pc={};Pc[bc]=function(t){var e=t.getComplianceLevelSupportedFeatures();return void 0===e&&(e=Sc[bc].level0),{url:void 0===t.imageInfo["@id"]?void 0:t.imageInfo["@id"].replace(/\/?(?:info\.json)?$/g,""),supports:e.supports,formats:_c(e.formats,[void 0===t.imageInfo.formats?[]:t.imageInfo.formats]),qualities:_c(e.qualities,[void 0===t.imageInfo.qualities?[]:t.imageInfo.qualities]),resolutions:t.imageInfo.scale_factors,tileSize:void 0!==t.imageInfo.tile_width?void 0!==t.imageInfo.tile_height?[t.imageInfo.tile_width,t.imageInfo.tile_height]:[t.imageInfo.tile_width,t.imageInfo.tile_width]:null!=t.imageInfo.tile_height?[t.imageInfo.tile_height,t.imageInfo.tile_height]:void 0}},Pc[xc]=function(t){var e=t.getComplianceLevelSupportedFeatures(),r=Array.isArray(t.imageInfo.profile)&&t.imageInfo.profile.length>1,n=r&&t.imageInfo.profile[1].supports?t.imageInfo.profile[1].supports:[],i=r&&t.imageInfo.profile[1].formats?t.imageInfo.profile[1].formats:[],o=r&&t.imageInfo.profile[1].qualities?t.imageInfo.profile[1].qualities:[];return{url:t.imageInfo["@id"].replace(/\/?(?:info\.json)?$/g,""),sizes:void 0===t.imageInfo.sizes?void 0:t.imageInfo.sizes.map((function(t){return[t.width,t.height]})),tileSize:void 0===t.imageInfo.tiles?void 0:[t.imageInfo.tiles.map((function(t){return t.width}))[0],t.imageInfo.tiles.map((function(t){return void 0===t.height?t.width:t.height}))[0]],resolutions:void 0===t.imageInfo.tiles?void 0:t.imageInfo.tiles.map((function(t){return t.scaleFactors}))[0],supports:_c(e.supports,n),formats:_c(e.formats,i),qualities:_c(e.qualities,o)}},Pc[wc]=function(t){var e=t.getComplianceLevelSupportedFeatures(),r=void 0===t.imageInfo.extraFormats?e.formats:_c(e.formats,t.imageInfo.extraFormats),n=void 0!==t.imageInfo.preferredFormats&&Array.isArray(t.imageInfo.preferredFormats)&&t.imageInfo.preferredFormats.length>0?t.imageInfo.preferredFormats.filter((function(t){return["jpg","png","gif"].includes(t)})).reduce((function(t,e){return void 0===t&&r.includes(e)?e:t}),void 0):void 0;return{url:t.imageInfo.id,sizes:void 0===t.imageInfo.sizes?void 0:t.imageInfo.sizes.map((function(t){return[t.width,t.height]})),tileSize:void 0===t.imageInfo.tiles?void 0:[t.imageInfo.tiles.map((function(t){return t.width}))[0],t.imageInfo.tiles.map((function(t){return t.height}))[0]],resolutions:void 0===t.imageInfo.tiles?void 0:t.imageInfo.tiles.map((function(t){return t.scaleFactors}))[0],supports:void 0===t.imageInfo.extraFeatures?e.supports:_c(e.supports,t.imageInfo.extraFeatures),formats:r,qualities:void 0===t.imageInfo.extraQualities?e.qualities:_c(e.qualities,t.imageInfo.extraQualities),preferredFormat:n}};var Rc=function(){function t(t){this.setImageInfo(t)}return t.prototype.setImageInfo=function(t){this.imageInfo="string"==typeof t?JSON.parse(t):t},t.prototype.getImageApiVersion=function(){if(void 0!==this.imageInfo){var t=this.imageInfo["@context"]||"ol-no-context";"string"==typeof t&&(t=[t]);for(var e=0;e<t.length;e++)switch(t[e]){case"http://library.stanford.edu/iiif/image-api/1.1/context.json":case"http://iiif.io/api/image/1/context.json":return bc;case"http://iiif.io/api/image/2/context.json":return xc;case"http://iiif.io/api/image/3/context.json":return wc;case"ol-no-context":if(this.getComplianceLevelEntryFromProfile(bc)&&this.imageInfo.identifier)return bc}lt(!1,61)}},t.prototype.getComplianceLevelEntryFromProfile=function(t){if(void 0!==this.imageInfo&&void 0!==this.imageInfo.profile)switch(void 0===t&&(t=this.getImageApiVersion()),t){case bc:if(Tc.test(this.imageInfo.profile))return this.imageInfo.profile;break;case wc:if(Cc.test(this.imageInfo.profile))return this.imageInfo.profile;break;case xc:if("string"==typeof this.imageInfo.profile&&Ec.test(this.imageInfo.profile))return this.imageInfo.profile;if(Array.isArray(this.imageInfo.profile)&&this.imageInfo.profile.length>0&&"string"==typeof this.imageInfo.profile[0]&&Ec.test(this.imageInfo.profile[0]))return this.imageInfo.profile[0]}},t.prototype.getComplianceLevelFromProfile=function(t){var e=this.getComplianceLevelEntryFromProfile(t);if(void 0!==e){var r=e.match(/level[0-2](?:\.json)?$/g);return Array.isArray(r)?r[0].replace(".json",""):void 0}},t.prototype.getComplianceLevelSupportedFeatures=function(){if(void 0!==this.imageInfo){var t=this.getImageApiVersion(),e=this.getComplianceLevelFromProfile(t);return void 0===e?Sc.none.none:Sc[t][e]}},t.prototype.getTileSourceOptions=function(t){var e=t||{},r=this.getImageApiVersion();if(void 0!==r){var n=void 0===r?void 0:Pc[r](this);if(void 0!==n)return{url:n.url,version:r,size:[this.imageInfo.width,this.imageInfo.height],sizes:n.sizes,format:void 0!==e.format&&n.formats.includes(e.format)?e.format:void 0!==n.preferredFormat?n.preferredFormat:"jpg",supports:n.supports,quality:e.quality&&n.qualities.includes(e.quality)?e.quality:n.qualities.includes("native")?"native":"default",resolutions:Array.isArray(n.resolutions)?n.resolutions.sort((function(t,e){return e-t})):void 0,tileSize:n.tileSize}}},t}(),Oc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Ic(t){return t.toLocaleString("en",{maximumFractionDigits:10})}var Lc=function(t){function e(e){var r=this,n=e||{},i=n.url||"";i+=i.lastIndexOf("/")===i.length-1||""===i?"":"/";var o=n.version||xc,a=n.sizes||[],s=n.size;lt(null!=s&&Array.isArray(s)&&2==s.length&&!isNaN(s[0])&&s[0]>0&&!isNaN(s[1])&&s[1]>0,60);var u,l,h,c=s[0],p=s[1],f=n.tileSize,d=n.tilePixelRatio||1,g=n.format||"jpg",y=n.quality||(n.version==bc?"native":"default"),m=n.resolutions||[],v=n.supports||[],_=n.extent||[0,-p,c,0],b=null!=a&&Array.isArray(a)&&a.length>0,x=void 0!==f&&("number"==typeof f&&Number.isInteger(f)&&f>0||Array.isArray(f)&&f.length>0),w=null!=v&&Array.isArray(v)&&(v.includes("regionByPx")||v.includes("regionByPct"))&&(v.includes("sizeByWh")||v.includes("sizeByH")||v.includes("sizeByW")||v.includes("sizeByPct"));if(m.sort((function(t,e){return e-t})),x||w)if(null!=f&&("number"==typeof f&&Number.isInteger(f)&&f>0?(u=f,l=f):Array.isArray(f)&&f.length>0&&((1==f.length||null==f[1]&&Number.isInteger(f[0]))&&(u=f[0],l=f[0]),2==f.length&&(Number.isInteger(f[0])&&Number.isInteger(f[1])?(u=f[0],l=f[1]):null==f[0]&&Number.isInteger(f[1])&&(u=f[1],l=f[1])))),void 0!==u&&void 0!==l||(u=256,l=256),0==m.length)for(var S=h=Math.max(Math.ceil(Math.log(c/u)/Math.LN2),Math.ceil(Math.log(p/l)/Math.LN2));S>=0;S--)m.push(Math.pow(2,S));else{var T=Math.max.apply(Math,m);h=Math.round(Math.log(T)/Math.LN2)}else if(u=c,l=p,m=[],b){a.sort((function(t,e){return t[0]-e[0]})),h=-1;var E=[];for(S=0;S<a.length;S++){var C=c/a[S][0];m.length>0&&m[m.length-1]==C?E.push(S):(m.push(C),h++)}if(E.length>0)for(S=0;S<E.length;S++)a.splice(E[S]-S,1)}else m.push(1),a.push([c,p]),h=0;var P=new Fu({tileSize:[u,l],extent:_,origin:fe(_),resolutions:m}),R=mc.bind(null,za(f||256).map((function(t){return t*d})));return(r=t.call(this,{attributions:n.attributions,attributionsCollapsible:n.attributionsCollapsible,cacheSize:n.cacheSize,crossOrigin:n.crossOrigin,imageSmoothing:n.imageSmoothing,projection:n.projection,reprojectionErrorThreshold:n.reprojectionErrorThreshold,state:n.state,tileClass:R,tileGrid:P,tilePixelRatio:n.tilePixelRatio,tileUrlFunction:function(t,e,r){var n,s,f=t[0];if(!(f>h)){var d=t[1],_=t[2],S=m[f];if(!(void 0===d||void 0===_||void 0===S||d<0||Math.ceil(c/S/u)<=d||_<0||Math.ceil(p/S/l)<=_)){if(w||x){var T=d*u*S,E=_*l*S,C=u*S,P=l*S,R=u,O=l;if(T+C>c&&(C=c-T),E+P>p&&(P=p-E),T+u*S>c&&(R=Math.floor((c-T+S-1)/S)),E+l*S>p&&(O=Math.floor((p-E+S-1)/S)),0==T&&C==c&&0==E&&P==p)n="full";else if(!w||v.includes("regionByPx"))n=T+","+E+","+C+","+P;else if(v.includes("regionByPct")){n="pct:"+Ic(T/c*100)+","+Ic(E/p*100)+","+Ic(C/c*100)+","+Ic(P/p*100)}o!=wc||w&&!v.includes("sizeByWh")?!w||v.includes("sizeByW")?s=R+",":v.includes("sizeByH")?s=","+O:v.includes("sizeByWh")?s=R+","+O:v.includes("sizeByPct")&&(s="pct:"+Ic(100/S)):s=R+","+O}else if(n="full",b){var I=a[f][0],L=a[f][1];s=o==wc?I==c&&L==p?"max":I+","+L:I==c?"full":I+","}else s=o==wc?"max":"full";return i+n+"/"+s+"/0/"+y+"."+g}}},transition:n.transition})||this).zDirection=n.zDirection,r}return Oc(e,t),e}(Zh),Mc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Fc=function(t){function e(e,r,n,i,o,a,s){var u=this,l=e.getExtent(),h=r.getExtent(),c=h?pe(n,h):n,p=wh(e,r,ue(c),i),f=new vh(e,r,c,l,.5*p,i),d=a(f.calculateSourceExtent(),p,o),g=d?To:Ro,y=d?d.getPixelRatio():1;return(u=t.call(this,n,i,y,g)||this).targetProj_=r,u.maxSourceExtent_=l,u.triangulation_=f,u.targetResolution_=i,u.targetExtent_=n,u.sourceImage_=d,u.sourcePixelRatio_=y,u.contextOptions_=s,u.canvas_=null,u.sourceListenerKey_=null,u}return Mc(e,t),e.prototype.disposeInternal=function(){this.state==Eo&&this.unlistenSource_(),t.prototype.disposeInternal.call(this)},e.prototype.getImage=function(){return this.canvas_},e.prototype.getProjection=function(){return this.targetProj_},e.prototype.reproject_=function(){var t=this.sourceImage_.getState();if(t==Co){var e=ge(this.targetExtent_)/this.targetResolution_,r=ce(this.targetExtent_)/this.targetResolution_;this.canvas_=Sh(e,r,this.sourcePixelRatio_,this.sourceImage_.getResolution(),this.maxSourceExtent_,this.targetResolution_,this.targetExtent_,this.triangulation_,[{extent:this.sourceImage_.getExtent(),image:this.sourceImage_.getImage()}],0,void 0,this.contextOptions_)}this.state=t,this.changed()},e.prototype.load=function(){if(this.state==To){this.state=Eo,this.changed();var t=this.sourceImage_.getState();t==Co||t==Po?this.reproject_():(this.sourceListenerKey_=W(this.sourceImage_,I,(function(t){var e=this.sourceImage_.getState();e!=Co&&e!=Po||(this.unlistenSource_(),this.reproject_())}),this),this.sourceImage_.load())}},e.prototype.unlistenSource_=function(){X(this.sourceListenerKey_),this.sourceListenerKey_=null},e}(Zl),Ac=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),kc="imageloadstart",Nc="imageloadend",jc="imageloaderror",Gc=function(t){function e(e,r){var n=t.call(this,e)||this;return n.image=r,n}return Ac(e,t),e}(h);function Dc(t,e){t.getImage().src=e}var zc=function(t){function e(e){var r=t.call(this,{attributions:e.attributions,projection:e.projection,state:e.state})||this;return r.resolutions_=void 0!==e.resolutions?e.resolutions:null,r.reprojectedImage_=null,r.reprojectedRevision_=0,r.contextOptions_=!1===e.imageSmoothing?_h:void 0,r}return Ac(e,t),e.prototype.getResolutions=function(){return this.resolutions_},e.prototype.getContextOptions=function(){return this.contextOptions_},e.prototype.findNearestResolution=function(t){if(this.resolutions_){var e=g(this.resolutions_,t,0);t=this.resolutions_[e]}return t},e.prototype.getImage=function(t,e,r,n){var i=this.getProjection();if(i&&n&&!Sr(i,n)){if(this.reprojectedImage_){if(this.reprojectedRevision_==this.getRevision()&&Sr(this.reprojectedImage_.getProjection(),n)&&this.reprojectedImage_.getResolution()==e&&$t(this.reprojectedImage_.getExtent(),t))return this.reprojectedImage_;this.reprojectedImage_.dispose(),this.reprojectedImage_=null}return this.reprojectedImage_=new Fc(i,n,t,e,r,function(t,e,r){return this.getImageInternal(t,e,r,i)}.bind(this),this.contextOptions_),this.reprojectedRevision_=this.getRevision(),this.reprojectedImage_}return i&&(n=i),this.getImageInternal(t,e,r,n)},e.prototype.getImageInternal=function(t,e,r,i){return n()},e.prototype.handleImageChange=function(t){var e=t.target;switch(e.getState()){case Eo:this.loading=!0,this.dispatchEvent(new Gc(kc,e));break;case Co:this.loading=!1,this.dispatchEvent(new Gc(Nc,e));break;case Po:this.loading=!1,this.dispatchEvent(new Gc(jc,e))}},e}(Ah);function Uc(t,e){var r=[];Object.keys(e).forEach((function(t){null!==e[t]&&void 0!==e[t]&&r.push(t+"="+encodeURIComponent(e[t]))}));var n=r.join("&");return(t=-1===(t=t.replace(/[?&]$/,"")).indexOf("?")?t+"?":t+"&")+n}var Bc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Yc=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,{attributions:n.attributions,imageSmoothing:n.imageSmoothing,projection:n.projection,resolutions:n.resolutions})||this).crossOrigin_=void 0!==n.crossOrigin?n.crossOrigin:null,r.hidpi_=void 0===n.hidpi||n.hidpi,r.url_=n.url,r.imageLoadFunction_=void 0!==n.imageLoadFunction?n.imageLoadFunction:Dc,r.params_=n.params||{},r.image_=null,r.imageSize_=[0,0],r.renderedRevision_=0,r.ratio_=void 0!==n.ratio?n.ratio:1.5,r}return Bc(e,t),e.prototype.getParams=function(){return this.params_},e.prototype.getImageInternal=function(t,e,r,n){if(void 0===this.url_)return null;e=this.findNearestResolution(e),r=this.hidpi_?r:1;var i=this.image_;if(i&&this.renderedRevision_==this.getRevision()&&i.getResolution()==e&&i.getPixelRatio()==r&&Vt(i.getExtent(),t))return i;var o={F:"image",FORMAT:"PNG32",TRANSPARENT:!0};T(o,this.params_);var a=((t=t.slice())[0]+t[2])/2,s=(t[1]+t[3])/2;if(1!=this.ratio_){var u=this.ratio_*ge(t)/2,l=this.ratio_*ce(t)/2;t[0]=a-u,t[1]=s-l,t[2]=a+u,t[3]=s+l}var h=e/r,c=Math.ceil(ge(t)/h),p=Math.ceil(ce(t)/h);t[0]=a-h*c/2,t[2]=a+h*c/2,t[1]=s-h*p/2,t[3]=s+h*p/2,this.imageSize_[0]=c,this.imageSize_[1]=p;var f=this.getRequestUrl_(t,this.imageSize_,r,n,o);return this.image_=new Jl(t,e,r,f,this.crossOrigin_,this.imageLoadFunction_),this.renderedRevision_=this.getRevision(),this.image_.addEventListener(I,this.handleImageChange.bind(this)),this.image_},e.prototype.getImageLoadFunction=function(){return this.imageLoadFunction_},e.prototype.getRequestUrl_=function(t,e,r,n,i){var o=n.getCode().split(":").pop();i.SIZE=e[0]+","+e[1],i.BBOX=t.join(","),i.BBOXSR=o,i.IMAGESR=o,i.DPI=Math.round(90*r);var a=this.url_,s=a.replace(/MapServer\/?$/,"MapServer/export").replace(/ImageServer\/?$/,"ImageServer/exportImage");return s==a&&lt(!1,50),Uc(s,i)},e.prototype.getUrl=function(){return this.url_},e.prototype.setImageLoadFunction=function(t){this.image_=null,this.imageLoadFunction_=t,this.changed()},e.prototype.setUrl=function(t){t!=this.url_&&(this.url_=t,this.image_=null,this.changed())},e.prototype.updateParams=function(t){T(this.params_,t),this.image_=null,this.changed()},e}(zc),Vc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Wc=function(t){function e(e,r,n,i,o){var a=this,s=void 0!==o?To:Co;return(a=t.call(this,e,r,n,s)||this).loader_=void 0!==o?o:null,a.canvas_=i,a.error_=null,a}return Vc(e,t),e.prototype.getError=function(){return this.error_},e.prototype.handleLoad_=function(t){t?(this.error_=t,this.state=Po):this.state=Co,this.changed()},e.prototype.load=function(){this.state==To&&(this.state=Eo,this.changed(),this.loader_(this.handleLoad_.bind(this)))},e.prototype.getImage=function(){return this.canvas_},e}(Zl),qc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Xc=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,{attributions:n.attributions,imageSmoothing:n.imageSmoothing,projection:n.projection,resolutions:n.resolutions,state:n.state})||this).canvasFunction_=n.canvasFunction,r.canvas_=null,r.renderedRevision_=0,r.ratio_=void 0!==n.ratio?n.ratio:1.5,r}return qc(e,t),e.prototype.getImageInternal=function(t,e,r,n){e=this.findNearestResolution(e);var i=this.canvas_;if(i&&this.renderedRevision_==this.getRevision()&&i.getResolution()==e&&i.getPixelRatio()==r&&Vt(i.getExtent(),t))return i;ve(t=t.slice(),this.ratio_);var o=[ge(t)/e*r,ce(t)/e*r],a=this.canvasFunction_.call(this,t,e,r,o,n);return a&&(i=new Wc(t,e,r,a)),this.canvas_=i,this.renderedRevision_=this.getRevision(),i},e}(zc),Zc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();var Kc=function(t){function e(e){var r=t.call(this,{imageSmoothing:e.imageSmoothing,projection:e.projection,resolutions:e.resolutions})||this;return r.crossOrigin_=void 0!==e.crossOrigin?e.crossOrigin:null,r.displayDpi_=void 0!==e.displayDpi?e.displayDpi:96,r.params_=e.params||{},r.url_=e.url,r.imageLoadFunction_=void 0!==e.imageLoadFunction?e.imageLoadFunction:Dc,r.hidpi_=void 0===e.hidpi||e.hidpi,r.metersPerUnit_=void 0!==e.metersPerUnit?e.metersPerUnit:1,r.ratio_=void 0!==e.ratio?e.ratio:1,r.useOverlay_=void 0!==e.useOverlay&&e.useOverlay,r.image_=null,r.renderedRevision_=0,r}return Zc(e,t),e.prototype.getParams=function(){return this.params_},e.prototype.getImageInternal=function(t,e,r,n){e=this.findNearestResolution(e),r=this.hidpi_?r:1;var i=this.image_;if(i&&this.renderedRevision_==this.getRevision()&&i.getResolution()==e&&i.getPixelRatio()==r&&Vt(i.getExtent(),t))return i;1!=this.ratio_&&ve(t=t.slice(),this.ratio_);var o=[ge(t)/e*r,ce(t)/e*r];if(void 0!==this.url_){var a=this.getUrl(this.url_,this.params_,t,o,n);(i=new Jl(t,e,r,a,this.crossOrigin_,this.imageLoadFunction_)).addEventListener(I,this.handleImageChange.bind(this))}else i=null;return this.image_=i,this.renderedRevision_=this.getRevision(),i},e.prototype.getImageLoadFunction=function(){return this.imageLoadFunction_},e.prototype.updateParams=function(t){T(this.params_,t),this.changed()},e.prototype.getUrl=function(t,e,r,n,i){var o=function(t,e,r,n){var i=ge(t),o=ce(t),a=e[0],s=e[1],u=.0254/n;return s*i>a*o?i*r/(a*u):o*r/(s*u)}(r,n,this.metersPerUnit_,this.displayDpi_),a=ue(r),s={OPERATION:this.useOverlay_?"GETDYNAMICMAPOVERLAYIMAGE":"GETMAPIMAGE",VERSION:"2.0.0",LOCALE:"en",CLIENTAGENT:"ol/source/ImageMapGuide source",CLIP:"1",SETDISPLAYDPI:this.displayDpi_,SETDISPLAYWIDTH:Math.round(n[0]),SETDISPLAYHEIGHT:Math.round(n[1]),SETVIEWSCALE:o,SETVIEWCENTERX:a[0],SETVIEWCENTERY:a[1]};return T(s,e),Uc(t,s)},e.prototype.setImageLoadFunction=function(t){this.image_=null,this.imageLoadFunction_=t,this.changed()},e}(zc),Hc=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Jc=function(t){function e(e){var r=this,n=void 0!==e.crossOrigin?e.crossOrigin:null,i=void 0!==e.imageLoadFunction?e.imageLoadFunction:Dc;return(r=t.call(this,{attributions:e.attributions,imageSmoothing:e.imageSmoothing,projection:yr(e.projection)})||this).url_=e.url,r.imageExtent_=e.imageExtent,r.image_=new Jl(r.imageExtent_,void 0,1,r.url_,n,i),r.imageSize_=e.imageSize?e.imageSize:null,r.image_.addEventListener(I,r.handleImageChange.bind(r)),r}return Hc(e,t),e.prototype.getImageExtent=function(){return this.imageExtent_},e.prototype.getImageInternal=function(t,e,r,n){return ye(t,this.image_.getExtent())?this.image_:null},e.prototype.getUrl=function(){return this.url_},e.prototype.handleImageChange=function(e){if(this.image_.getState()==Co){var r=this.image_.getExtent(),n=this.image_.getImage(),i=void 0,o=void 0;this.imageSize_?(i=this.imageSize_[0],o=this.imageSize_[1]):(i=n.width,o=n.height);var a=ce(r)/o,s=Math.ceil(ge(r)/a);if(s!=i){var u=Bi(s,o);T(u,this.getContextOptions());var l=u.canvas;u.drawImage(n,0,0,i,o,0,0,l.width,l.height),this.image_.setImage(l)}}t.prototype.handleImageChange.call(this,e)},e}(zc),$c="carmentaserver",Qc="geoserver",tp="mapserver",ep="qgis",rp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),np=[101,101],ip=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,{attributions:n.attributions,imageSmoothing:n.imageSmoothing,projection:n.projection,resolutions:n.resolutions})||this).crossOrigin_=void 0!==n.crossOrigin?n.crossOrigin:null,r.url_=n.url,r.imageLoadFunction_=void 0!==n.imageLoadFunction?n.imageLoadFunction:Dc,r.params_=n.params||{},r.v13_=!0,r.updateV13_(),r.serverType_=n.serverType,r.hidpi_=void 0===n.hidpi||n.hidpi,r.image_=null,r.imageSize_=[0,0],r.renderedRevision_=0,r.ratio_=void 0!==n.ratio?n.ratio:1.5,r}return rp(e,t),e.prototype.getFeatureInfoUrl=function(t,e,r,n){if(void 0!==this.url_){var i=yr(r),o=this.getProjection();o&&o!==i&&(e=wh(o,i,t,e),t=Cr(t,i,o));var a=he(t,e,0,np),s={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetFeatureInfo",FORMAT:"image/png",TRANSPARENT:!0,QUERY_LAYERS:this.params_.LAYERS};T(s,this.params_,n);var u=Math.floor((t[0]-a[0])/e),l=Math.floor((a[3]-t[1])/e);return s[this.v13_?"I":"X"]=u,s[this.v13_?"J":"Y"]=l,this.getRequestUrl_(a,np,1,o||i,s)}},e.prototype.getLegendUrl=function(t,e){if(void 0!==this.url_){var r={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetLegendGraphic",FORMAT:"image/png"};if(void 0===e||void 0===e.LAYER){var n=this.params_.LAYERS;if(!(!Array.isArray(n)||1===n.length))return;r.LAYER=n}if(void 0!==t){var i=this.getProjection()?this.getProjection().getMetersPerUnit():1;r.SCALE=t*i*39.37*(25.4/.28)}return T(r,e),Uc(this.url_,r)}},e.prototype.getParams=function(){return this.params_},e.prototype.getImageInternal=function(t,e,r,n){if(void 0===this.url_)return null;e=this.findNearestResolution(e),1==r||this.hidpi_&&void 0!==this.serverType_||(r=1);var i=e/r,o=ue(t),a=he(o,i,0,[Math.ceil(ge(t)/i),Math.ceil(ce(t)/i)]),s=he(o,i,0,[Math.ceil(this.ratio_*ge(t)/i),Math.ceil(this.ratio_*ce(t)/i)]),u=this.image_;if(u&&this.renderedRevision_==this.getRevision()&&u.getResolution()==e&&u.getPixelRatio()==r&&Vt(u.getExtent(),a))return u;var l={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetMap",FORMAT:"image/png",TRANSPARENT:!0};T(l,this.params_),this.imageSize_[0]=Math.round(ge(s)/i),this.imageSize_[1]=Math.round(ce(s)/i);var h=this.getRequestUrl_(s,this.imageSize_,r,n,l);return this.image_=new Jl(s,e,r,h,this.crossOrigin_,this.imageLoadFunction_),this.renderedRevision_=this.getRevision(),this.image_.addEventListener(I,this.handleImageChange.bind(this)),this.image_},e.prototype.getImageLoadFunction=function(){return this.imageLoadFunction_},e.prototype.getRequestUrl_=function(t,e,r,n,i){if(lt(void 0!==this.url_,9),i[this.v13_?"CRS":"SRS"]=n.getCode(),"STYLES"in this.params_||(i.STYLES=""),1!=r)switch(this.serverType_){case Qc:var o=90*r+.5|0;"FORMAT_OPTIONS"in i?i.FORMAT_OPTIONS+=";dpi:"+o:i.FORMAT_OPTIONS="dpi:"+o;break;case tp:i.MAP_RESOLUTION=90*r;break;case $c:case ep:i.DPI=90*r;break;default:lt(!1,8)}i.WIDTH=e[0],i.HEIGHT=e[1];var a,s=n.getAxisOrientation();return a=this.v13_&&"ne"==s.substr(0,2)?[t[1],t[0],t[3],t[2]]:t,i.BBOX=a.join(","),Uc(this.url_,i)},e.prototype.getUrl=function(){return this.url_},e.prototype.setImageLoadFunction=function(t){this.image_=null,this.imageLoadFunction_=t,this.changed()},e.prototype.setUrl=function(t){t!=this.url_&&(this.url_=t,this.image_=null,this.changed())},e.prototype.updateParams=function(t){T(this.params_,t),this.updateV13_(),this.image_=null,this.changed()},e.prototype.updateV13_=function(){var t=this.params_.VERSION||"1.3.0";this.v13_=Qe(t,"1.3")>=0},e}(zc),op=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ap='&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.',sp=function(t){function e(e){var r,n=e||{};r=void 0!==n.attributions?n.attributions:[ap];var i=void 0!==n.crossOrigin?n.crossOrigin:"anonymous",o=void 0!==n.url?n.url:"https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png";return t.call(this,{attributions:r,cacheSize:n.cacheSize,crossOrigin:i,imageSmoothing:n.imageSmoothing,opaque:void 0===n.opaque||n.opaque,maxZoom:void 0!==n.maxZoom?n.maxZoom:19,reprojectionErrorThreshold:n.reprojectionErrorThreshold,tileLoadFunction:n.tileLoadFunction,url:o,wrapX:n.wrapX,attributionsCollapsible:!1})||this}return op(e,t),e}(Qh),up=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),lp=function(t){function e(e){var r=e||{};return t.call(this,r)||this}return up(e,t),e}(Li),hp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),cp=function(t){function e(e){var r=t.call(this)||this;return r.boundHandleImageChange_=r.handleImageChange_.bind(r),r.layer_=e,r}return hp(e,t),e.prototype.getFeatures=function(t){return n()},e.prototype.prepareFrame=function(t){return n()},e.prototype.renderFrame=function(t,e){return n()},e.prototype.loadedTileCallback=function(t,e,r){t[e]||(t[e]={}),t[e][r.tileCoord.toString()]=r},e.prototype.createLoadedTileFinder=function(t,e,r){return function(n,i){var o=this.loadedTileCallback.bind(this,r,n);return t.forEachLoadedTile(e,n,i,o)}.bind(this)},e.prototype.forEachFeatureAtCoordinate=function(t,e,r,n,i){},e.prototype.getDataAtPixel=function(t,e,r){return n()},e.prototype.getLayer=function(){return this.layer_},e.prototype.handleFontsChanged=function(){},e.prototype.handleImageChange_=function(t){t.target.getState()===Co&&this.renderIfReadyAndVisible()},e.prototype.loadImage=function(t){var e=t.getState();return e!=Co&&e!=Po&&t.addEventListener(I,this.boundHandleImageChange_),e==To&&(t.load(),e=t.getState()),e==Co},e.prototype.renderIfReadyAndVisible=function(){var t=this.getLayer();t.getVisible()&&t.getSourceState()==Pi&&t.changed()},e}(H),pp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),fp=function(t){function e(e){var r=t.call(this,e)||this;return r.container=null,r.renderedResolution,r.tempTransform=[1,0,0,1,0,0],r.pixelTransform=[1,0,0,1,0,0],r.inversePixelTransform=[1,0,0,1,0,0],r.context=null,r.containerReused=!1,r}return pp(e,t),e.prototype.useContainer=function(t,e,r){var n,i,o=this.getLayer().getClassName();t&&""===t.style.opacity&&t.className===o&&((s=t.firstElementChild)instanceof HTMLCanvasElement&&(i=s.getContext("2d")));if(!i||0!==i.canvas.width&&i.canvas.style.transform!==e?this.containerReused&&(this.container=null,this.context=null,this.containerReused=!1):(this.container=t,this.context=i,this.containerReused=!0),!this.container){(n=document.createElement("div")).className=o;var a=n.style;a.position="absolute",a.width="100%",a.height="100%";var s=(i=Bi()).canvas;n.appendChild(s),(a=s.style).position="absolute",a.left="0",a.transformOrigin="top left",this.container=n,this.context=i}},e.prototype.clip=function(t,e,r){var n=e.pixelRatio,i=e.size[0]*n/2,o=e.size[1]*n/2,a=e.viewState.rotation,s=fe(r),u=de(r),l=se(r),h=ae(r);Tt(e.coordinateToPixelTransform,s),Tt(e.coordinateToPixelTransform,u),Tt(e.coordinateToPixelTransform,l),Tt(e.coordinateToPixelTransform,h),t.save(),co(t,-a,i,o),t.beginPath(),t.moveTo(s[0]*n,s[1]*n),t.lineTo(u[0]*n,u[1]*n),t.lineTo(l[0]*n,l[1]*n),t.lineTo(h[0]*n,h[1]*n),t.clip(),co(t,a,i,o)},e.prototype.clipUnrotated=function(t,e,r){var n=fe(r),i=de(r),o=se(r),a=ae(r);Tt(e.coordinateToPixelTransform,n),Tt(e.coordinateToPixelTransform,i),Tt(e.coordinateToPixelTransform,o),Tt(e.coordinateToPixelTransform,a);var s=this.inversePixelTransform;Tt(s,n),Tt(s,i),Tt(s,o),Tt(s,a),t.save(),t.beginPath(),t.moveTo(Math.round(n[0]),Math.round(n[1])),t.lineTo(Math.round(i[0]),Math.round(i[1])),t.lineTo(Math.round(o[0]),Math.round(o[1])),t.lineTo(Math.round(a[0]),Math.round(a[1])),t.clip()},e.prototype.dispatchRenderEvent_=function(t,e,r){var n=this.getLayer();if(n.hasListener(t)){var i=new zo(t,this.inversePixelTransform,r,e);n.dispatchEvent(i)}},e.prototype.preRender=function(t,e){this.dispatchRenderEvent_(bi,t,e)},e.prototype.postRender=function(t,e){this.dispatchRenderEvent_(xi,t,e)},e.prototype.getRenderTransform=function(t,e,r,n,i,o,a){var s=i/2,u=o/2,l=n/e,h=-l,c=-t[0]+a,p=-t[1];return Ct(this.tempTransform,s,u,l,h,-r,c,p)},e.prototype.getDataAtPixel=function(t,e,r){var n,i=Tt(this.inversePixelTransform,t.slice()),o=this.context;try{var a=Math.round(i[0]),s=Math.round(i[1]),u=document.createElement("canvas"),l=u.getContext("2d");u.width=1,u.height=1,l.clearRect(0,0,1,1),l.drawImage(o.canvas,a,s,1,1,0,0,1,1),n=l.getImageData(0,0,1,1).data}catch(t){return"SecurityError"===t.name?new Uint8Array:n}return 0===n[3]?null:n},e}(cp),dp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),gp=function(t){function e(e){var r=t.call(this,e)||this;return r.image_=null,r}return dp(e,t),e.prototype.getImage=function(){return this.image_?this.image_.getImage():null},e.prototype.prepareFrame=function(t){var e=t.layerStatesArray[t.layerIndex],r=t.pixelRatio,n=t.viewState,i=n.resolution,o=this.getLayer().getSource(),a=t.viewHints,s=t.extent;if(void 0!==e.extent&&(s=pe(s,Nr(e.extent,n.projection))),!a[va]&&!a[_a]&&!me(s))if(o){var u=n.projection,l=o.getImage(s,i,r,u);l&&this.loadImage(l)&&(this.image_=l)}else this.image_=null;return!!this.image_},e.prototype.renderFrame=function(t,e){var r=this.image_,n=r.getExtent(),i=r.getResolution(),o=r.getPixelRatio(),a=t.layerStatesArray[t.layerIndex],s=t.pixelRatio,u=t.viewState,l=u.center,h=u.resolution,c=t.size,p=s*i/(h*o),f=Math.round(c[0]*s),d=Math.round(c[1]*s),g=u.rotation;if(g){var y=Math.round(Math.sqrt(f*f+d*d));f=y,d=y}Ct(this.pixelTransform,t.size[0]/2,t.size[1]/2,1/s,1/s,g,-f/2,-d/2),Pt(this.inversePixelTransform,this.pixelTransform);var m=go(this.pixelTransform);this.useContainer(e,m,a.opacity);var v=this.context,_=v.canvas;_.width!=f||_.height!=d?(_.width=f,_.height=d):this.containerReused||v.clearRect(0,0,f,d);var b=!1;if(a.extent){var x=Nr(a.extent,u.projection);(b=!Vt(x,t.extent)&&ye(x,t.extent))&&this.clipUnrotated(v,t,x)}var w=r.getImage(),S=Ct(this.tempTransform,f/2,d/2,p,p,0,o*(n[0]-l[0])/i,o*(l[1]-n[3])/i);this.renderedResolution=i*s/o;var E=S[4],C=S[5],P=w.width*S[0],R=w.height*S[3];if(T(v,this.getLayer().getSource().getContextOptions()),this.preRender(v,t),P>=.5&&R>=.5){var O=a.opacity,I=void 0;1!==O&&(I=this.context.globalAlpha,this.context.globalAlpha=O),this.context.drawImage(w,0,0,+w.width,+w.height,Math.round(E),Math.round(C),Math.round(P),Math.round(R)),1!==O&&(this.context.globalAlpha=I)}return this.postRender(v,t),b&&v.restore(),m!==_.style.transform&&(_.style.transform=m),this.container},e}(fp),yp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),mp=function(t){function e(e){return t.call(this,e)||this}return yp(e,t),e.prototype.createRenderer=function(){return new gp(this)},e}(lp),vp="preload",_p="useInterimTilesOnError",bp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),xp=function(t){function e(e){var r=this,n=e||{},i=T({},n);return delete i.preload,delete i.useInterimTilesOnError,(r=t.call(this,i)||this).setPreload(void 0!==n.preload?n.preload:0),r.setUseInterimTilesOnError(void 0===n.useInterimTilesOnError||n.useInterimTilesOnError),r}return bp(e,t),e.prototype.getPreload=function(){return this.get(vp)},e.prototype.setPreload=function(t){this.set(vp,t)},e.prototype.getUseInterimTilesOnError=function(){return this.get(_p)},e.prototype.setUseInterimTilesOnError=function(t){this.set(_p,t)},e}(Li),wp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Sp=function(t){function e(e){var r=t.call(this,e)||this;return r.extentChanged=!0,r.renderedExtent_=null,r.renderedPixelRatio,r.renderedProjection=null,r.renderedRevision,r.renderedTiles=[],r.newTiles_=!1,r.tmpExtent=[1/0,1/0,-1/0,-1/0],r.tmpTileRange_=new Cu(0,0,0,0),r}return wp(e,t),e.prototype.isDrawableTile=function(t){var e=this.getLayer(),r=t.getState(),n=e.getUseInterimTilesOnError();return r==fa||r==ga||r==da&&!n},e.prototype.getTile=function(t,e,r,n){var i=n.pixelRatio,o=n.viewState.projection,a=this.getLayer(),s=a.getSource().getTile(t,e,r,i,o);return s.getState()==da&&(a.getUseInterimTilesOnError()?a.getPreload()>0&&(this.newTiles_=!0):s.setState(fa)),this.isDrawableTile(s)||(s=s.getInterimTile()),s},e.prototype.loadedTileCallback=function(e,r,n){return!!this.isDrawableTile(n)&&t.prototype.loadedTileCallback.call(this,e,r,n)},e.prototype.prepareFrame=function(t){return!!this.getLayer().getSource()},e.prototype.renderFrame=function(t,e){var r=t.layerStatesArray[t.layerIndex],n=t.viewState,i=n.projection,a=n.resolution,s=n.center,u=n.rotation,l=t.pixelRatio,h=this.getLayer(),c=h.getSource(),p=c.getRevision(),d=c.getTileGridForProjection(i),g=d.getZForResolution(a,c.zDirection),y=d.getResolution(g),m=t.extent,v=r.extent&&Nr(r.extent,i);v&&(m=pe(m,Nr(r.extent,i)));var _=c.getTilePixelRatio(l),b=Math.round(t.size[0]*_),x=Math.round(t.size[1]*_);if(u){var w=Math.round(Math.sqrt(b*b+x*x));b=w,x=w}var S=y*b/2/_,E=y*x/2/_,C=[s[0]-S,s[1]-E,s[0]+S,s[1]+E],P=d.getTileRangeForExtentAndZ(m,g),R={};R[g]={};var O=this.createLoadedTileFinder(c,i,R),I=this.tmpExtent,L=this.tmpTileRange_;this.newTiles_=!1;for(var M=P.minX;M<=P.maxX;++M)for(var F=P.minY;F<=P.maxY;++F){var A=this.getTile(g,M,F,t);if(this.isDrawableTile(A)){var k=o(this);if(A.getState()==fa){R[g][A.tileCoord.toString()]=A;var N=A.inTransition(k);this.newTiles_||!N&&-1!==this.renderedTiles.indexOf(A)||(this.newTiles_=!0)}if(1===A.getAlpha(k,t.time))continue}var j=d.getTileCoordChildTileRange(A.tileCoord,L,I),G=!1;j&&(G=O(g+1,j)),G||d.forEachTileCoordParentTileRange(A.tileCoord,O,L,I)}var D=y/a;Ct(this.pixelTransform,t.size[0]/2,t.size[1]/2,1/_,1/_,u,-b/2,-x/2);var z=go(this.pixelTransform);this.useContainer(e,z,r.opacity);var U=this.context,B=U.canvas;Pt(this.inversePixelTransform,this.pixelTransform),Ct(this.tempTransform,b/2,x/2,D,D,0,-b/2,-x/2),B.width!=b||B.height!=x?(B.width=b,B.height=x):this.containerReused||U.clearRect(0,0,b,x),v&&this.clipUnrotated(U,t,v),T(U,c.getContextOptions()),this.preRender(U,t),this.renderedTiles.length=0;var Y,V,W,q=Object.keys(R).map(Number);q.sort(f),1!==r.opacity||this.containerReused&&!c.getOpaque(t.viewState.projection)?(Y=[],V=[]):q=q.reverse();for(var X=q.length-1;X>=0;--X){var Z=q[X],K=c.getTilePixelSize(Z,l,i),H=d.getResolution(Z)/y,J=K[0]*H*D,$=K[1]*H*D,Q=d.getTileCoordForCoordAndZ(fe(C),Z),tt=d.getTileCoordExtent(Q),et=Tt(this.tempTransform,[_*(tt[0]-C[0])/y,_*(C[3]-tt[3])/y]),rt=_*c.getGutterForProjection(i),nt=R[Z];for(var it in nt){var ot=(A=nt[it]).tileCoord,at=et[0]-(Q[1]-ot[1])*J,st=Math.round(at+J),ut=et[1]-(Q[2]-ot[2])*$,lt=Math.round(ut+$),ht=st-(M=Math.round(at)),ct=lt-(F=Math.round(ut)),pt=g===Z;if(!(N=pt&&1!==A.getAlpha(o(this),t.time)))if(Y){U.save(),W=[M,F,M+ht,F,M+ht,F+ct,M,F+ct];for(var ft=0,dt=Y.length;ft<dt;++ft)if(g!==Z&&Z<V[ft]){var gt=Y[ft];U.beginPath(),U.moveTo(W[0],W[1]),U.lineTo(W[2],W[3]),U.lineTo(W[4],W[5]),U.lineTo(W[6],W[7]),U.moveTo(gt[6],gt[7]),U.lineTo(gt[4],gt[5]),U.lineTo(gt[2],gt[3]),U.lineTo(gt[0],gt[1]),U.clip()}Y.push(W),V.push(Z)}else U.clearRect(M,F,ht,ct);this.drawTileImage(A,t,M,F,ht,ct,rt,pt,r.opacity),Y&&!N&&U.restore(),this.renderedTiles.push(A),this.updateUsedTiles(t.usedTiles,c,A)}}return this.renderedRevision=p,this.renderedResolution=y,this.extentChanged=!this.renderedExtent_||!$t(this.renderedExtent_,C),this.renderedExtent_=C,this.renderedPixelRatio=l,this.renderedProjection=i,this.manageTilePyramid(t,c,d,l,i,m,g,h.getPreload()),this.scheduleExpireCache(t,c),this.postRender(U,t),r.extent&&U.restore(),z!==B.style.transform&&(B.style.transform=z),this.container},e.prototype.drawTileImage=function(t,e,r,n,i,a,s,u,l){var h=this.getTileImage(t);if(h){var c=o(this),p=u?t.getAlpha(c,e.time):1,f=l*p,d=f!==this.context.globalAlpha;d&&(this.context.save(),this.context.globalAlpha=f),this.context.drawImage(h,s,s,h.width-2*s,h.height-2*s,r,n,i,a),d&&this.context.restore(),1!==p?e.animate=!0:u&&t.endTransition(c)}},e.prototype.getImage=function(){var t=this.context;return t?t.canvas:null},e.prototype.getTileImage=function(t){return t.getImage()},e.prototype.scheduleExpireCache=function(t,e){if(e.canExpireCache()){var r=function(t,e,r){var n=o(t);n in r.usedTiles&&t.expireCache(r.viewState.projection,r.usedTiles[n])}.bind(null,e);t.postRenderFunctions.push(r)}},e.prototype.updateUsedTiles=function(t,e,r){var n=o(e);n in t||(t[n]={}),t[n][r.getKey()]=!0},e.prototype.manageTilePyramid=function(t,e,r,n,i,a,s,u,l){var h=o(e);h in t.wantedTiles||(t.wantedTiles[h]={});var c,p,f,d,g,y,m=t.wantedTiles[h],v=t.tileQueue,_=0;for(y=r.getMinZoom();y<=s;++y)for(p=r.getTileRangeForExtentAndZ(a,y,p),f=r.getResolution(y),d=p.minX;d<=p.maxX;++d)for(g=p.minY;g<=p.maxY;++g)s-y<=u?(++_,(c=e.getTile(y,d,g,n,i)).getState()==ca&&(m[c.getKey()]=!0,v.isKeyQueued(c.getKey())||v.enqueue([c,h,r.getTileCoordCenter(c.tileCoord),f])),void 0!==l&&l(c)):e.useTile(y,d,g,i);e.updateCacheSize(_,i)},e}(fp);Sp.prototype.getLayer;var Tp=Sp,Ep=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Cp=function(t){function e(e){return t.call(this,e)||this}return Ep(e,t),e.prototype.createRenderer=function(){return new Tp(this)},e}(xp),Pp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Rp=!0;try{new ImageData(10,10)}catch(t){Rp=!1}var Op=document.createElement("canvas").getContext("2d");function Ip(t){var e=!0;try{new ImageData(10,10)}catch(t){e=!1}function r(t,r,n){return e?new ImageData(t,r,n):{data:t,width:r,height:n}}return function(e){var n,i,o=e.buffers,a=e.meta,s=e.imageOps,u=e.width,l=e.height,h=o.length,c=o[0].byteLength;if(s){var p=new Array(h);for(i=0;i<h;++i)p[i]=r(new Uint8ClampedArray(o[i]),u,l);n=t(p,a).data}else{n=new Uint8ClampedArray(c);var f=new Array(h),d=new Array(h);for(i=0;i<h;++i)f[i]=new Uint8ClampedArray(o[i]),d[i]=[0,0,0,0];for(var g=0;g<c;g+=4){for(var y=0;y<h;++y){var m=f[y];d[y][0]=m[g],d[y][1]=m[g+1],d[y][2]=m[g+2],d[y][3]=m[g+3]}var v=t(d,a);n[g]=v[0],n[g+1]=v[1],n[g+2]=v[2],n[g+3]=v[3]}}return n.buffer}}function Lp(t,e){var r=Object.keys(t.lib||{}).map((function(e){return"var "+e+" = "+t.lib[e].toString()+";"})).concat(["var __minion__ = ("+Ip.toString()+")(",t.operation.toString(),");",'self.addEventListener("message", function(event) {',"  var buffer = __minion__(event.data);","  self.postMessage({buffer: buffer, meta: event.data.meta}, [buffer]);","});"]),n=new Blob(r,{type:"text/javascript"}),i=URL.createObjectURL(n),o=new Worker(i);return o.addEventListener("message",e),o}var Mp=function(t){function e(e){var r,n=t.call(this)||this;n._imageOps=!!e.imageOps;var i=[];if(r=0===e.threads?0:n._imageOps?1:e.threads||1)for(var o=0;o<r;++o)i[o]=Lp(e,n._onWorkerMessage.bind(n,o));else i[0]=function(t,e){var r=Ip(t.operation),n=!1;return{postMessage:function(t){setTimeout((function(){n||e({data:{buffer:r(t),meta:t.meta}})}),0)},terminate:function(){n=!0}}}(e,n._onWorkerMessage.bind(n,0));return n._workers=i,n._queue=[],n._maxQueueLength=e.queue||1/0,n._running=0,n._dataLookup={},n._job=null,n}return Pp(e,t),e.prototype.process=function(t,e,r){this._enqueue({inputs:t,meta:e,callback:r}),this._dispatch()},e.prototype._enqueue=function(t){for(this._queue.push(t);this._queue.length>this._maxQueueLength;)this._queue.shift().callback(null,null)},e.prototype._dispatch=function(){if(0===this._running&&this._queue.length>0){var t=this._queue.shift();this._job=t;var e=t.inputs[0].width,r=t.inputs[0].height,n=t.inputs.map((function(t){return t.data.buffer})),i=this._workers.length;if(this._running=i,1===i)this._workers[0].postMessage({buffers:n,meta:t.meta,imageOps:this._imageOps,width:e,height:r},n);else for(var o=t.inputs[0].data.length,a=4*Math.ceil(o/4/i),s=0;s<i;++s){for(var u=s*a,l=[],h=0,c=n.length;h<c;++h)l.push(n[s].slice(u,u+a));this._workers[s].postMessage({buffers:l,meta:t.meta,imageOps:this._imageOps,width:e,height:r},l)}}},e.prototype._onWorkerMessage=function(t,e){this.disposed||(this._dataLookup[t]=e.data,--this._running,0===this._running&&this._resolveJob())},e.prototype._resolveJob=function(){var t,e,r=this._job,n=this._workers.length;if(1===n)t=new Uint8ClampedArray(this._dataLookup[0].buffer),e=this._dataLookup[0].meta;else{var i=r.inputs[0].data.length;t=new Uint8ClampedArray(i),e=new Array(i);for(var o=4*Math.ceil(i/4/n),a=0;a<n;++a){var s=this._dataLookup[a].buffer,u=a*o;t.set(new Uint8ClampedArray(s),u),e[a]=this._dataLookup[a].meta}}this._job=null,this._dataLookup={},r.callback(null,function(t,e,r){if(Rp)return new ImageData(t,e,r);var n=Op.createImageData(e,r);return n.data.set(t),n}(t,r.inputs[0].width,r.inputs[0].height),e),this._dispatch()},e.prototype.disposeInternal=function(){for(var t=0;t<this._workers.length;++t)this._workers[t].terminate();this._workers.length=0},e}(p),Fp="beforeoperations",Ap="afteroperations",kp="pixel",Np="image",jp=function(t){function e(e,r,n){var i=t.call(this,e)||this;return i.extent=r.extent,i.resolution=r.viewState.resolution/r.pixelRatio,i.data=n,i}return Pp(e,t),e}(h),Gp=function(t){function e(e){var r=t.call(this,{projection:null})||this;r.processor_=null,r.operationType_=void 0!==e.operationType?e.operationType:kp,r.threads_=void 0!==e.threads?e.threads:1,r.layers_=function(t){for(var e=t.length,r=new Array(e),n=0;n<e;++n)r[n]=Up(t[n]);return r}(e.sources);for(var n,i=r.changed.bind(r),o=0,a=r.layers_.length;o<a;++o)r.layers_[o].addEventListener(I,i);return r.tileQueue_=new ma((function(){return 1}),r.changed.bind(r)),r.requestedFrameState_,r.renderedImageCanvas_=null,r.renderedRevision_,r.frameState_={animate:!1,coordinateToPixelTransform:[1,0,0,1,0,0],extent:null,index:0,layerIndex:0,layerStatesArray:(n=r.layers_,n.map((function(t){return t.getLayerState()}))),pixelRatio:1,pixelToCoordinateTransform:[1,0,0,1,0,0],postRenderFunctions:[],size:[0,0],tileQueue:r.tileQueue_,time:Date.now(),usedTiles:{},viewState:{rotation:0},viewHints:[],wantedTiles:{},declutterItems:[]},r.setAttributions((function(t){for(var r=[],n=0,i=e.sources.length;n<i;++n){var o=e.sources[n],a=(o instanceof Ah?o:o.getSource()).getAttributions();if("function"==typeof a){var s=a(t);r.push.apply(r,s)}}return 0!==r.length?r:null})),void 0!==e.operation&&r.setOperation(e.operation,e.lib),r}return Pp(e,t),e.prototype.setOperation=function(t,e){this.processor_&&this.processor_.dispose(),this.processor_=new Mp({operation:t,imageOps:this.operationType_===Np,queue:1,lib:e,threads:this.threads_}),this.changed()},e.prototype.updateFrameState_=function(t,e,r){var n=T({},this.frameState_);n.viewState=T({},n.viewState);var i=ue(t);n.extent=t.slice(),n.size[0]=Math.round(ge(t)/e),n.size[1]=Math.round(ce(t)/e),n.time=1/0;var o=n.viewState;return o.center=i,o.projection=r,o.resolution=e,n},e.prototype.allSourcesReady_=function(){for(var t=!0,e=0,r=this.layers_.length;e<r;++e)if(this.layers_[e].getSource().getState()!==Pi){t=!1;break}return t},e.prototype.getImage=function(t,e,r,n){if(!this.allSourcesReady_())return null;var i=this.updateFrameState_(t,e,n);if(this.requestedFrameState_=i,this.renderedImageCanvas_){var o=this.renderedImageCanvas_.getResolution(),a=this.renderedImageCanvas_.getExtent();e===o&&$t(t,a)||(this.renderedImageCanvas_=null)}return this.renderedImageCanvas_&&this.getRevision()===this.renderedRevision_||this.processSources_(),i.tileQueue.loadMoreTiles(16,16),i.animate&&requestAnimationFrame(this.changed.bind(this)),this.renderedImageCanvas_},e.prototype.processSources_=function(){for(var t=this.requestedFrameState_,e=this.layers_.length,r=new Array(e),n=0;n<e;++n){t.layerIndex=n;var i=zp(this.layers_[n],t);if(!i)return;r[n]=i}var o={};this.dispatchEvent(new jp(Fp,t,o)),this.processor_.process(r,o,this.onWorkerComplete_.bind(this,t))},e.prototype.onWorkerComplete_=function(t,e,r,n){if(!e&&r){var i=t.extent,o=t.viewState.resolution;if(o===this.requestedFrameState_.viewState.resolution&&$t(i,this.requestedFrameState_.extent)){var a;if(this.renderedImageCanvas_)a=this.renderedImageCanvas_.getImage().getContext("2d");else a=Bi(Math.round(ge(i)/o),Math.round(ce(i)/o)),this.renderedImageCanvas_=new Wc(i,o,1,a.canvas);a.putImageData(r,0,0),this.changed(),this.renderedRevision_=this.getRevision(),this.dispatchEvent(new jp(Ap,t,n))}}},e.prototype.getImageInternal=function(){return null},e.prototype.disposeInternal=function(){this.processor_&&this.processor_.dispose(),t.prototype.disposeInternal.call(this)},e}(zc);Gp.prototype.dispose;var Dp=null;function zp(t,e){var r=t.getRenderer();if(!r)throw new Error("Unsupported layer type: "+t);if(!r.prepareFrame(e))return null;var n,i=e.size[0],o=e.size[1],a=r.renderFrame(e,null);if(a&&(n=a.firstElementChild),!(n instanceof HTMLCanvasElement))throw new Error("Unsupported rendered element: "+n);if(n.width===i&&n.height===o)return n.getContext("2d").getImageData(0,0,i,o);if(Dp){var s=Dp.canvas;s.width!==i||s.height!==o?Dp=Bi(i,o):Dp.clearRect(0,0,i,o)}else Dp=Bi(i,o);return Dp.drawImage(n,0,0,i,o),Dp.getImageData(0,0,i,o)}function Up(t){var e;return t instanceof Ah?t instanceof Gh?e=new Cp({source:t}):t instanceof zc&&(e=new mp({source:t})):e=t,e}var Bp=Gp,Yp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Vp=['Map tiles by <a href="https://stamen.com/" target="_blank">Stamen Design</a>, under <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank">CC BY 3.0</a>.',ap],Wp={terrain:{extension:"jpg",opaque:!0},"terrain-background":{extension:"jpg",opaque:!0},"terrain-labels":{extension:"png",opaque:!1},"terrain-lines":{extension:"png",opaque:!1},"toner-background":{extension:"png",opaque:!0},toner:{extension:"png",opaque:!0},"toner-hybrid":{extension:"png",opaque:!1},"toner-labels":{extension:"png",opaque:!1},"toner-lines":{extension:"png",opaque:!1},"toner-lite":{extension:"png",opaque:!0},watercolor:{extension:"jpg",opaque:!0}},qp={terrain:{minZoom:0,maxZoom:18},toner:{minZoom:0,maxZoom:20},watercolor:{minZoom:0,maxZoom:18}},Xp=function(t){function e(e){var r=e.layer.indexOf("-"),n=-1==r?e.layer:e.layer.slice(0,r),i=qp[n],o=Wp[e.layer],a=void 0!==e.url?e.url:"https://stamen-tiles-{a-d}.a.ssl.fastly.net/"+e.layer+"/{z}/{x}/{y}."+o.extension;return t.call(this,{attributions:Vp,cacheSize:e.cacheSize,crossOrigin:"anonymous",imageSmoothing:e.imageSmoothing,maxZoom:null!=e.maxZoom?e.maxZoom:i.maxZoom,minZoom:null!=e.minZoom?e.minZoom:i.minZoom,opaque:o.opaque,reprojectionErrorThreshold:e.reprojectionErrorThreshold,tileLoadFunction:e.tileLoadFunction,transition:e.transition,url:a,wrapX:e.wrapX})||this}return Yp(e,t),e}(Qh),Zp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Kp=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,{attributions:n.attributions,cacheSize:n.cacheSize,crossOrigin:n.crossOrigin,imageSmoothing:n.imageSmoothing,projection:n.projection,reprojectionErrorThreshold:n.reprojectionErrorThreshold,tileGrid:n.tileGrid,tileLoadFunction:n.tileLoadFunction,url:n.url,urls:n.urls,wrapX:void 0===n.wrapX||n.wrapX,transition:n.transition})||this).params_=n.params||{},r.hidpi_=void 0===n.hidpi||n.hidpi,r.tmpExtent_=[1/0,1/0,-1/0,-1/0],r.setKey(r.getKeyForParams_()),r}return Zp(e,t),e.prototype.getKeyForParams_=function(){var t=0,e=[];for(var r in this.params_)e[t++]=r+"-"+this.params_[r];return e.join("/")},e.prototype.getParams=function(){return this.params_},e.prototype.getRequestUrl_=function(t,e,r,n,i,o){var a=this.urls;if(a){var s,u=i.getCode().split(":").pop();if(o.SIZE=e[0]+","+e[1],o.BBOX=r.join(","),o.BBOXSR=u,o.IMAGESR=u,o.DPI=Math.round(o.DPI?o.DPI*n:90*n),1==a.length)s=a[0];else s=a[Oe(Lu(t),a.length)];return Uc(s.replace(/MapServer\/?$/,"MapServer/export").replace(/ImageServer\/?$/,"ImageServer/exportImage"),o)}},e.prototype.getTilePixelRatio=function(t){return this.hidpi_?t:1},e.prototype.updateParams=function(t){T(this.params_,t),this.setKey(this.getKeyForParams_())},e.prototype.tileUrlFunction=function(t,e,r){var n=this.getTileGrid();if(n||(n=this.getTileGridForProjection(r)),!(n.getResolutions().length<=t[0])){1==e||this.hidpi_||(e=1);var i=n.getTileCoordExtent(t,this.tmpExtent_),o=za(n.getTileSize(t[0]),this.tmpSize);1!=e&&(o=Da(o,e,this.tmpSize));var a={F:"image",FORMAT:"PNG32",TRANSPARENT:!0};return T(a,this.params_),this.getRequestUrl_(t,o,i,e,r,a)}},e}(Zh),Hp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Jp=function(t){function e(e,r,n){var i=t.call(this,e,fa)||this;return i.tileSize_=r,i.text_=n,i.canvas_=null,i}return Hp(e,t),e.prototype.getImage=function(){if(this.canvas_)return this.canvas_;var t=this.tileSize_,e=Bi(t[0],t[1]);return e.strokeStyle="grey",e.strokeRect(.5,.5,t[0]+.5,t[1]+.5),e.fillStyle="grey",e.strokeStyle="white",e.textAlign="center",e.textBaseline="middle",e.font="24px sans-serif",e.lineWidth=4,e.strokeText(this.text_,t[0]/2,t[1]/2,t[0]),e.fillText(this.text_,t[0]/2,t[1]/2,t[0]),this.canvas_=e.canvas,e.canvas},e.prototype.load=function(){},e}(dh),$p=function(t){function e(e){var r=e||{};return t.call(this,{opaque:!1,projection:r.projection,tileGrid:r.tileGrid,wrapX:void 0===r.wrapX||r.wrapX,zDirection:r.zDirection})||this}return Hp(e,t),e.prototype.getTile=function(t,e,r){var n=Ru(t,e,r);if(this.tileCache.containsKey(n))return this.tileCache.get(n);var i=za(this.tileGrid.getTileSize(t)),o=[t,e,r],a=this.getTileCoordForTileUrlFunction(o),s=void 0;s=a?"z:"+a[0]+" x:"+a[1]+" y:"+a[2]:"none";var u=new Jp(o,i,s);return this.tileCache.set(n,u),u},e}(Qh),Qp=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),tf=function(t){function e(e){var r=t.call(this,{attributions:e.attributions,cacheSize:e.cacheSize,crossOrigin:e.crossOrigin,imageSmoothing:e.imageSmoothing,projection:yr("EPSG:3857"),reprojectionErrorThreshold:e.reprojectionErrorThreshold,state:Ci,tileLoadFunction:e.tileLoadFunction,wrapX:void 0===e.wrapX||e.wrapX,transition:e.transition})||this;if(r.tileJSON_=null,r.tileSize_=e.tileSize,e.url)if(e.jsonp)Kh(e.url,r.handleTileJSONResponse.bind(r),r.handleTileJSONError.bind(r));else{var n=new XMLHttpRequest;n.addEventListener("load",r.onXHRLoad_.bind(r)),n.addEventListener("error",r.onXHRError_.bind(r)),n.open("GET",e.url),n.send()}else e.tileJSON?r.handleTileJSONResponse(e.tileJSON):lt(!1,51);return r}return Qp(e,t),e.prototype.onXHRLoad_=function(t){var e=t.target;if(!e.status||e.status>=200&&e.status<300){var r=void 0;try{r=JSON.parse(e.responseText)}catch(t){return void this.handleTileJSONError()}this.handleTileJSONResponse(r)}else this.handleTileJSONError()},e.prototype.onXHRError_=function(t){this.handleTileJSONError()},e.prototype.getTileJSON=function(){return this.tileJSON_},e.prototype.handleTileJSONResponse=function(t){var e,r=yr("EPSG:4326"),n=this.getProjection();if(void 0!==t.bounds){var i=Tr(r,n);e=_e(t.bounds,i)}var o=t.minzoom||0,a=t.maxzoom||22,s=ku({extent:Gu(n),maxZoom:a,minZoom:o,tileSize:this.tileSize_});if(this.tileGrid=s,this.tileUrlFunction=zh(t.tiles,s),void 0!==t.attribution&&!this.getAttributions()){var u=void 0!==e?e:r.getExtent();this.setAttributions((function(e){return ye(u,e.extent)?[t.attribution]:null}))}this.tileJSON_=t,this.setState(Pi)},e.prototype.handleTileJSONError=function(){this.setState(Ri)},e}(Zh),ef=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),rf=function(t){function e(e){var r=this,n=e||{},i=n.params||{},o=!("TRANSPARENT"in i)||i.TRANSPARENT;return(r=t.call(this,{attributions:n.attributions,cacheSize:n.cacheSize,crossOrigin:n.crossOrigin,imageSmoothing:n.imageSmoothing,opaque:!o,projection:n.projection,reprojectionErrorThreshold:n.reprojectionErrorThreshold,tileClass:n.tileClass,tileGrid:n.tileGrid,tileLoadFunction:n.tileLoadFunction,url:n.url,urls:n.urls,wrapX:void 0===n.wrapX||n.wrapX,transition:n.transition})||this).gutter_=void 0!==n.gutter?n.gutter:0,r.params_=i,r.v13_=!0,r.serverType_=n.serverType,r.hidpi_=void 0===n.hidpi||n.hidpi,r.tmpExtent_=[1/0,1/0,-1/0,-1/0],r.updateV13_(),r.setKey(r.getKeyForParams_()),r}return ef(e,t),e.prototype.getFeatureInfoUrl=function(t,e,r,n){var i=yr(r),o=this.getProjection(),a=this.getTileGrid();a||(a=this.getTileGridForProjection(i));var s=a.getZForResolution(e,this.zDirection),u=a.getTileCoordForCoordAndZ(t,s);if(!(a.getResolutions().length<=u[0])){var l=a.getResolution(u[0]),h=a.getTileCoordExtent(u,this.tmpExtent_),c=za(a.getTileSize(u[0]),this.tmpSize),p=this.gutter_;0!==p&&(c=Ga(c,p,this.tmpSize),h=zt(h,l*p,h)),o&&o!==i&&(l=wh(o,i,t,l),h=Pr(h,i,o),t=Cr(t,i,o));var f={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetFeatureInfo",FORMAT:"image/png",TRANSPARENT:!0,QUERY_LAYERS:this.params_.LAYERS};T(f,this.params_,n);var d=Math.floor((t[0]-h[0])/l),g=Math.floor((h[3]-t[1])/l);return f[this.v13_?"I":"X"]=d,f[this.v13_?"J":"Y"]=g,this.getRequestUrl_(u,c,h,1,o||i,f)}},e.prototype.getLegendUrl=function(t,e){if(void 0!==this.urls[0]){var r={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetLegendGraphic",FORMAT:"image/png"};if(void 0===e||void 0===e.LAYER){var n=this.params_.LAYERS;if(!(!Array.isArray(n)||1===n.length))return;r.LAYER=n}if(void 0!==t){var i=this.getProjection()?this.getProjection().getMetersPerUnit():1;r.SCALE=t*i*39.37*(25.4/.28)}return T(r,e),Uc(this.urls[0],r)}},e.prototype.getGutter=function(){return this.gutter_},e.prototype.getParams=function(){return this.params_},e.prototype.getRequestUrl_=function(t,e,r,n,i,o){var a=this.urls;if(a){if(o.WIDTH=e[0],o.HEIGHT=e[1],o[this.v13_?"CRS":"SRS"]=i.getCode(),"STYLES"in this.params_||(o.STYLES=""),1!=n)switch(this.serverType_){case Qc:var s=90*n+.5|0;"FORMAT_OPTIONS"in o?o.FORMAT_OPTIONS+=";dpi:"+s:o.FORMAT_OPTIONS="dpi:"+s;break;case tp:o.MAP_RESOLUTION=90*n;break;case $c:case ep:o.DPI=90*n;break;default:lt(!1,52)}var u,l=i.getAxisOrientation(),h=r;if(this.v13_&&"ne"==l.substr(0,2)){var c=void 0;c=r[0],h[0]=r[1],h[1]=c,c=r[2],h[2]=r[3],h[3]=c}if(o.BBOX=h.join(","),1==a.length)u=a[0];else u=a[Oe(Lu(t),a.length)];return Uc(u,o)}},e.prototype.getTilePixelRatio=function(t){return this.hidpi_&&void 0!==this.serverType_?t:1},e.prototype.getKeyForParams_=function(){var t=0,e=[];for(var r in this.params_)e[t++]=r+"-"+this.params_[r];return e.join("/")},e.prototype.updateParams=function(t){T(this.params_,t),this.updateV13_(),this.setKey(this.getKeyForParams_())},e.prototype.updateV13_=function(){var t=this.params_.VERSION||"1.3.0";this.v13_=Qe(t,"1.3")>=0},e.prototype.tileUrlFunction=function(t,e,r){var n=this.getTileGrid();if(n||(n=this.getTileGridForProjection(r)),!(n.getResolutions().length<=t[0])){1==e||this.hidpi_&&void 0!==this.serverType_||(e=1);var i=n.getResolution(t[0]),o=n.getTileCoordExtent(t,this.tmpExtent_),a=za(n.getTileSize(t[0]),this.tmpSize),s=this.gutter_;0!==s&&(a=Ga(a,s,this.tmpSize),o=zt(o,i*s,o)),1!=e&&(a=Da(a,e,this.tmpSize));var u={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetMap",FORMAT:"image/png",TRANSPARENT:!0};return T(u,this.params_),this.getRequestUrl_(t,a,o,e,r,u)}},e}(Zh),nf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),of=function(t){function e(e,r,n,i,o,a){var s=t.call(this,e,r)||this;return s.src_=n,s.extent_=i,s.preemptive_=o,s.grid_=null,s.keys_=null,s.data_=null,s.jsonp_=a,s}return nf(e,t),e.prototype.getImage=function(){return null},e.prototype.getData=function(t){if(!this.grid_||!this.keys_)return null;var e=(t[0]-this.extent_[0])/(this.extent_[2]-this.extent_[0]),r=(t[1]-this.extent_[1])/(this.extent_[3]-this.extent_[1]),n=this.grid_[Math.floor((1-r)*this.grid_.length)];if("string"!=typeof n)return null;var i=n.charCodeAt(Math.floor(e*n.length));i>=93&&i--,i>=35&&i--;var o=null;if((i-=32)in this.keys_){var a=this.keys_[i];o=this.data_&&a in this.data_?this.data_[a]:a}return o},e.prototype.forDataAtCoordinate=function(t,e,r){this.state==ga&&!0===r?(this.state=ca,q(this,I,(function(r){e(this.getData(t))}),this),this.loadInternal_()):!0===r?setTimeout(function(){e(this.getData(t))}.bind(this),0):e(this.getData(t))},e.prototype.getKey=function(){return this.src_},e.prototype.handleError_=function(){this.state=da,this.changed()},e.prototype.handleLoad_=function(t){this.grid_=t.grid,this.keys_=t.keys,this.data_=t.data,this.state=fa,this.changed()},e.prototype.loadInternal_=function(){if(this.state==ca)if(this.state=pa,this.jsonp_)Kh(this.src_,this.handleLoad_.bind(this),this.handleError_.bind(this));else{var t=new XMLHttpRequest;t.addEventListener("load",this.onXHRLoad_.bind(this)),t.addEventListener("error",this.onXHRError_.bind(this)),t.open("GET",this.src_),t.send()}},e.prototype.onXHRLoad_=function(t){var e=t.target;if(!e.status||e.status>=200&&e.status<300){var r=void 0;try{r=JSON.parse(e.responseText)}catch(t){return void this.handleError_()}this.handleLoad_(r)}else this.handleError_()},e.prototype.onXHRError_=function(t){this.handleError_()},e.prototype.load=function(){this.preemptive_?this.loadInternal_():this.setState(ga)},e}(dh),af=function(t){function e(e){var r=t.call(this,{projection:yr("EPSG:3857"),state:Ci})||this;if(r.preemptive_=void 0===e.preemptive||e.preemptive,r.tileUrlFunction_=Bh,r.template_=void 0,r.jsonp_=e.jsonp||!1,e.url)if(r.jsonp_)Kh(e.url,r.handleTileJSONResponse.bind(r),r.handleTileJSONError.bind(r));else{var n=new XMLHttpRequest;n.addEventListener("load",r.onXHRLoad_.bind(r)),n.addEventListener("error",r.onXHRError_.bind(r)),n.open("GET",e.url),n.send()}else e.tileJSON?r.handleTileJSONResponse(e.tileJSON):lt(!1,51);return r}return nf(e,t),e.prototype.onXHRLoad_=function(t){var e=t.target;if(!e.status||e.status>=200&&e.status<300){var r=void 0;try{r=JSON.parse(e.responseText)}catch(t){return void this.handleTileJSONError()}this.handleTileJSONResponse(r)}else this.handleTileJSONError()},e.prototype.onXHRError_=function(t){this.handleTileJSONError()},e.prototype.getTemplate=function(){return this.template_},e.prototype.forDataAtCoordinateAndResolution=function(t,e,r,n){if(this.tileGrid){var i=this.tileGrid.getZForResolution(e,this.zDirection),o=this.tileGrid.getTileCoordForCoordAndZ(t,i);this.getTile(o[0],o[1],o[2],1,this.getProjection()).forDataAtCoordinate(t,r,n)}else!0===n?setTimeout((function(){r(null)}),0):r(null)},e.prototype.handleTileJSONError=function(){this.setState(Ri)},e.prototype.handleTileJSONResponse=function(t){var e,r=yr("EPSG:4326"),n=this.getProjection();if(void 0!==t.bounds){var i=Tr(r,n);e=_e(t.bounds,i)}var o=t.minzoom||0,a=t.maxzoom||22,s=ku({extent:Gu(n),maxZoom:a,minZoom:o});this.tileGrid=s,this.template_=t.template;var u=t.grids;if(u){if(this.tileUrlFunction_=zh(u,s),void 0!==t.attribution){var l=void 0!==e?e:r.getExtent();this.setAttributions((function(e){return ye(l,e.extent)?[t.attribution]:null}))}this.setState(Pi)}else this.setState(Ri)},e.prototype.getTile=function(t,e,r,n,i){var o=Ru(t,e,r);if(this.tileCache.containsKey(o))return this.tileCache.get(o);var a=[t,e,r],s=this.getTileCoordForTileUrlFunction(a,i),u=this.tileUrlFunction_(s,n,i),l=new of(a,void 0!==u?ca:ga,void 0!==u?u:"",this.tileGrid.getTileCoordExtent(a),this.preemptive_,this.jsonp_);return this.tileCache.set(o,l),l},e.prototype.useTile=function(t,e,r){var n=Ru(t,e,r);this.tileCache.containsKey(n)&&this.tileCache.get(n)},e}(Gh),sf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),uf=function(t){function e(e,r,n,i,o,a){var s=t.call(this,e,r,a)||this;return s.extent=null,s.format_=i,s.features_=null,s.loader_,s.projection=null,s.resolution,s.tileLoadFunction_=o,s.url_=n,s}return sf(e,t),e.prototype.getFormat=function(){return this.format_},e.prototype.getFeatures=function(){return this.features_},e.prototype.getKey=function(){return this.url_},e.prototype.load=function(){this.state==ca&&(this.setState(pa),this.tileLoadFunction_(this,this.url_),this.loader_&&this.loader_(this.extent,this.resolution,this.projection))},e.prototype.onLoad=function(t,e){this.setFeatures(t)},e.prototype.onError=function(){this.setState(da)},e.prototype.setFeatures=function(t){this.features_=t,this.setState(fa)},e.prototype.setLoader=function(t){this.loader_=t},e}(dh),lf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),hf=[],cf=function(t){function e(e,r,n,i){var o=t.call(this,e,r,{transition:0})||this;return o.context_={},o.executorGroups={},o.loadingSourceTiles=0,o.errorSourceTileKeys={},o.hitDetectionImageData={},o.replayState_={},o.sourceTiles=null,o.wantedResolution,o.getSourceTiles=i.bind(void 0,o),o.sourceZ=-1,o.hifi=!1,o.wrappedTileCoord=n,o}return lf(e,t),e.prototype.getContext=function(t){var e=o(t);return e in this.context_||(this.context_[e]=Bi(1,1,hf)),this.context_[e]},e.prototype.hasContext=function(t){return o(t)in this.context_},e.prototype.getImage=function(t){return this.hasContext(t)?this.getContext(t).canvas:null},e.prototype.getReplayState=function(t){var e=o(t);return e in this.replayState_||(this.replayState_[e]={dirty:!1,renderedRenderOrder:null,renderedResolution:NaN,renderedRevision:-1,renderedTileResolution:NaN,renderedTileRevision:-1,renderedZ:-1,renderedTileZ:-1}),this.replayState_[e]},e.prototype.load=function(){this.getSourceTiles()},e.prototype.release=function(){for(var e in this.context_)hf.push(this.context_[e].canvas);t.prototype.release.call(this)},e}(dh),pf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ff=function(t){function e(e){var r=this,n=e.projection||"EPSG:3857",i=e.extent||Gu(n),o=e.tileGrid||ku({extent:i,maxResolution:e.maxResolution,maxZoom:void 0!==e.maxZoom?e.maxZoom:22,minZoom:e.minZoom,tileSize:e.tileSize||512});return(r=t.call(this,{attributions:e.attributions,attributionsCollapsible:e.attributionsCollapsible,cacheSize:e.cacheSize,opaque:!1,projection:n,state:e.state,tileGrid:o,tileLoadFunction:e.tileLoadFunction?e.tileLoadFunction:df,tileUrlFunction:e.tileUrlFunction,url:e.url,urls:e.urls,wrapX:void 0===e.wrapX||e.wrapX,transition:e.transition,zDirection:void 0===e.zDirection?1:e.zDirection})||this).format_=e.format?e.format:null,r.loadingTiles_={},r.sourceTileCache=new Rh(r.tileCache.highWaterMark),r.overlaps_=null==e.overlaps||e.overlaps,r.tileClass=e.tileClass?e.tileClass:uf,r.tileGrids_={},r}return pf(e,t),e.prototype.getFeaturesInExtent=function(t){var e=[],r=this.tileCache;if(0===r.getCount())return e;var n=Iu(r.peekFirstKey())[0],i=this.tileGrid;return r.forEach((function(r){if(r.tileCoord[0]===n&&r.getState()===fa)for(var o=r.getSourceTiles(),a=0,s=o.length;a<s;++a){var u=o[a],l=u.tileCoord;if(ye(t,i.getTileCoordExtent(l))){var h=u.getFeatures();if(h)for(var c=0,p=h.length;c<p;++c){var f=h[c],d=f.getGeometry();ye(t,d.getExtent())&&e.push(f)}}}})),e},e.prototype.getOverlaps=function(){return this.overlaps_},e.prototype.clear=function(){this.tileCache.clear(),this.sourceTileCache.clear()},e.prototype.expireCache=function(e,r){t.prototype.expireCache.call(this,e,r),this.sourceTileCache.expireCache({})},e.prototype.getSourceTiles=function(t,e,r){var n=r.wrappedTileCoord,i=this.getTileGridForProjection(e),o=i.getTileCoordExtent(n),a=n[0],s=i.getResolution(a);zt(o,-s,o);var u=this.tileGrid,l=u.getExtent();l&&pe(o,l,o);var h,c,p,f=u.getZForResolution(s,1),d=u.getMinZoom(),g=r.sourceTiles;if(g&&g.length>0&&g[0].tileCoord[0]===f)h=g,c=!0,p=f;else{h=[],p=f+1;do{--p,c=!0,u.forEachTileCoord(o,p,function(n){var i,o=this.tileUrlFunction(n,t,e);if(void 0!==o)if(this.sourceTileCache.containsKey(o)){var a=(i=this.sourceTileCache.get(o)).getState();if(a===fa||a===da||a===ga)return void h.push(i)}else p===f&&((i=new this.tileClass(n,ca,o,this.format_,this.tileLoadFunction)).extent=u.getTileCoordExtent(n),i.projection=e,i.resolution=u.getResolution(n[0]),this.sourceTileCache.set(o,i),i.addEventListener(I,this.handleTileChange.bind(this)),i.load());c=c&&i&&i.getState()===fa,i&&i.getState()!==ga&&r.getState()===ca&&(r.loadingSourceTiles++,i.addEventListener(I,(function t(){var e=i.getState(),n=i.getKey();if(e===fa||e===da){e===fa?(i.removeEventListener(I,t),r.loadingSourceTiles--,delete r.errorSourceTileKeys[n]):e===da&&(r.errorSourceTileKeys[n]=!0);var o=Object.keys(r.errorSourceTileKeys).length;r.loadingSourceTiles-o==0&&(r.hifi=0===o,r.sourceZ=f,r.setState(fa))}})))}.bind(this)),c||(h.length=0)}while(!c&&p>d)}return r.getState()===ca&&r.setState(pa),c&&(r.hifi=f===p,r.sourceZ=p,r.getState()<fa?r.setState(fa):g&&_(h,g)||(r.sourceTiles=h)),h},e.prototype.getTile=function(t,e,r,n,i){var o,a=Ru(t,e,r),s=this.getKey();if(this.tileCache.containsKey(a)&&(o=this.tileCache.get(a)).key===s)return o;var u=[t,e,r],l=this.getTileCoordForTileUrlFunction(u,i),h=this.getTileGrid().getExtent(),c=this.getTileGridForProjection(i);if(l&&h){var p=c.getTileCoordExtent(l);zt(p,-c.getResolution(t),p),ye(h,p)||(l=null)}var f=!0;if(null!==l){var d=this.tileGrid,g=c.getResolution(t),y=d.getZForResolution(g,1),m=c.getTileCoordExtent(l);zt(m,-g,m),d.forEachTileCoord(m,y,function(t){f=f&&!this.tileUrlFunction(t,n,i)}.bind(this))}var v=new cf(u,f?ga:ca,l,this.getSourceTiles.bind(this,n,i));return v.key=s,o?(v.interimTile=o,v.refreshInterimChain(),this.tileCache.replace(a,v)):this.tileCache.set(a,v),v},e.prototype.getTileGridForProjection=function(t){var e=t.getCode(),r=this.tileGrids_[e];if(!r){var n=this.tileGrid;r=ju(t,void 0,n?n.getTileSize(n.getMinZoom()):void 0),this.tileGrids_[e]=r}return r},e.prototype.getTilePixelRatio=function(t){return t},e.prototype.getTilePixelSize=function(t,e,r){var n=za(this.getTileGridForProjection(r).getTileSize(t),this.tmpSize);return[Math.round(n[0]*e),Math.round(n[1]*e)]},e.prototype.updateCacheSize=function(e,r){t.prototype.updateCacheSize.call(this,2*e,r)},e}(Wh);function df(t,e){var r=xu(e,t.getFormat(),t.onLoad.bind(t),t.onError.bind(t));t.setLoader(r)}var gf="KVP",yf="REST",mf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),vf=function(t){function e(e){var r=this,n=void 0!==e.requestEncoding?e.requestEncoding:gf,i=e.tileGrid,o=e.urls;return void 0===o&&void 0!==e.url&&(o=Yh(e.url)),(r=t.call(this,{attributions:e.attributions,cacheSize:e.cacheSize,crossOrigin:e.crossOrigin,imageSmoothing:e.imageSmoothing,projection:e.projection,reprojectionErrorThreshold:e.reprojectionErrorThreshold,tileClass:e.tileClass,tileGrid:i,tileLoadFunction:e.tileLoadFunction,tilePixelRatio:e.tilePixelRatio,urls:o,wrapX:void 0!==e.wrapX&&e.wrapX,transition:e.transition})||this).version_=void 0!==e.version?e.version:"1.0.0",r.format_=void 0!==e.format?e.format:"image/jpeg",r.dimensions_=void 0!==e.dimensions?e.dimensions:{},r.layer_=e.layer,r.matrixSet_=e.matrixSet,r.style_=e.style,r.requestEncoding_=n,r.setKey(r.getKeyForDimensions_()),o&&o.length>0&&(r.tileUrlFunction=Uh(o.map(r.createFromWMTSTemplate.bind(r)))),r}return mf(e,t),e.prototype.setUrls=function(t){this.urls=t;var e=t.join("\n");this.setTileUrlFunction(Uh(t.map(this.createFromWMTSTemplate.bind(this))),e)},e.prototype.getDimensions=function(){return this.dimensions_},e.prototype.getFormat=function(){return this.format_},e.prototype.getLayer=function(){return this.layer_},e.prototype.getMatrixSet=function(){return this.matrixSet_},e.prototype.getRequestEncoding=function(){return this.requestEncoding_},e.prototype.getStyle=function(){return this.style_},e.prototype.getVersion=function(){return this.version_},e.prototype.getKeyForDimensions_=function(){var t=0,e=[];for(var r in this.dimensions_)e[t++]=r+"-"+this.dimensions_[r];return e.join("/")},e.prototype.updateDimensions=function(t){T(this.dimensions_,t),this.setKey(this.getKeyForDimensions_())},e.prototype.createFromWMTSTemplate=function(t){var e=this.requestEncoding_,r={layer:this.layer_,style:this.style_,tilematrixset:this.matrixSet_};e==gf&&T(r,{Service:"WMTS",Request:"GetTile",Version:this.version_,Format:this.format_}),t=e==gf?Uc(t,r):t.replace(/\{(\w+?)\}/g,(function(t,e){return e.toLowerCase()in r?r[e.toLowerCase()]:t}));var n=this.tileGrid,i=this.dimensions_;return function(r,o,a){if(r){var s={TileMatrix:n.getMatrixId(r[0]),TileCol:r[1],TileRow:r[2]};T(s,i);var u=t;return u=e==gf?Uc(u,s):u.replace(/\{(\w+?)\}/g,(function(t,e){return s[e]}))}}},e}(Zh);var _f=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),bf="renderOrder",xf=function(t){function e(e){var r=this,n=e||{},i=T({},n);return delete i.style,delete i.renderBuffer,delete i.updateWhileAnimating,delete i.updateWhileInteracting,(r=t.call(this,i)||this).declutter_=void 0!==n.declutter&&n.declutter,r.renderBuffer_=void 0!==n.renderBuffer?n.renderBuffer:100,r.style_=null,r.styleFunction_=void 0,r.setStyle(n.style),r.updateWhileAnimating_=void 0!==n.updateWhileAnimating&&n.updateWhileAnimating,r.updateWhileInteracting_=void 0!==n.updateWhileInteracting&&n.updateWhileInteracting,r}return _f(e,t),e.prototype.getDeclutter=function(){return this.declutter_},e.prototype.getFeatures=function(e){return t.prototype.getFeatures.call(this,e)},e.prototype.getRenderBuffer=function(){return this.renderBuffer_},e.prototype.getRenderOrder=function(){return this.get(bf)},e.prototype.getStyle=function(){return this.style_},e.prototype.getStyleFunction=function(){return this.styleFunction_},e.prototype.getUpdateWhileAnimating=function(){return this.updateWhileAnimating_},e.prototype.getUpdateWhileInteracting=function(){return this.updateWhileInteracting_},e.prototype.setRenderOrder=function(t){this.set(bf,t)},e.prototype.setStyle=function(t){this.style_=void 0!==t?t:ah,this.styleFunction_=null===t?void 0:function(t){var e;if("function"==typeof t)e=t;else{var r;if(Array.isArray(t))r=t;else lt("function"==typeof t.getZIndex,41),r=[t];e=function(){return r}}return e}(this.style_),this.changed()},e}(Li),wf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Sf="GENERATE_BUFFERS",Tf=function(t){function e(e,r){var n=t.call(this,e)||this,i=r||{};return n.helper=new Rl({postProcesses:i.postProcesses,uniforms:i.uniforms}),n}return wf(e,t),e.prototype.disposeInternal=function(){this.helper.dispose(),t.prototype.disposeInternal.call(this)},e.prototype.getShaderCompileErrors=function(){return this.helper.getShaderCompileErrors()},e}(cp);var Ef=Tf,Cf=new Blob(['var e="function"==typeof Object.assign?Object.assign:function(e,n){if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var t=Object(e),r=1,o=arguments.length;r<o;++r){var i=arguments[r];if(null!=i)for(var f in i)i.hasOwnProperty(f)&&(t[f]=i[f])}return t},n="GENERATE_BUFFERS",t=[],r={vertexPosition:0,indexPosition:0};function o(e,n,t,r,o){e[n+0]=t,e[n+1]=r,e[n+2]=o}function i(e,n,i,f,s,u){var a=3+s,l=e[n+0],v=e[n+1],c=t;c.length=s;for(var g=0;g<c.length;g++)c[g]=e[n+2+g];var b=u?u.vertexPosition:0,h=u?u.indexPosition:0,d=b/a;return o(i,b,l,v,0),c.length&&i.set(c,b+3),o(i,b+=a,l,v,1),c.length&&i.set(c,b+3),o(i,b+=a,l,v,2),c.length&&i.set(c,b+3),o(i,b+=a,l,v,3),c.length&&i.set(c,b+3),b+=a,f[h++]=d,f[h++]=d+1,f[h++]=d+3,f[h++]=d+1,f[h++]=d+2,f[h++]=d+3,r.vertexPosition=b,r.indexPosition=h,r}var f=self;f.onmessage=function(t){var r=t.data;if(r.type===n){for(var o=r.customAttributesCount,s=2+o,u=new Float32Array(r.renderInstructions),a=u.length/s,l=4*a*(o+3),v=new Uint32Array(6*a),c=new Float32Array(l),g=null,b=0;b<u.length;b+=s)g=i(u,b,c,v,o,g);var h=e({vertexBuffer:c.buffer,indexBuffer:v.buffer,renderInstructions:u.buffer},r);f.postMessage(h,[c.buffer,v.buffer,u.buffer])}};'],{type:"application/javascript"}),Pf=URL.createObjectURL(Cf);var Rf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Of=function(t){function e(e,r){var n=this,i=r.uniforms||{},a=[1,0,0,1,0,0];i[_l]=a,(n=t.call(this,e,{uniforms:i,postProcesses:r.postProcesses})||this).sourceRevision_=-1,n.verticesBuffer_=new fl(34962,35048),n.hitVerticesBuffer_=new fl(34962,35048),n.indicesBuffer_=new fl(34963,35048),n.program_=n.helper.getProgram(r.fragmentShader,r.vertexShader),n.hitDetectionEnabled_=!(!r.hitFragmentShader||!r.hitVertexShader),n.hitProgram_=n.hitDetectionEnabled_&&n.helper.getProgram(r.hitFragmentShader,r.hitVertexShader);var s=r.attributes?r.attributes.map((function(t){return{name:"a_"+t.name,size:1,type:El.FLOAT}})):[];n.attributes=[{name:"a_position",size:2,type:El.FLOAT},{name:"a_index",size:1,type:El.FLOAT}].concat(s),n.hitDetectionAttributes=[{name:"a_position",size:2,type:El.FLOAT},{name:"a_index",size:1,type:El.FLOAT},{name:"a_hitColor",size:4,type:El.FLOAT},{name:"a_featureUid",size:1,type:El.FLOAT}].concat(s),n.customAttributes=r.attributes?r.attributes:[],n.previousExtent_=[1/0,1/0,-1/0,-1/0],n.currentTransform_=a,n.renderTransform_=[1,0,0,1,0,0],n.invertRenderTransform_=[1,0,0,1,0,0],n.renderInstructions_=new Float32Array(0),n.hitRenderInstructions_=new Float32Array(0),n.hitRenderTarget_=n.hitDetectionEnabled_&&new Il(n.helper),n.worker_=new Worker(Pf),n.worker_.addEventListener("message",function(t){var e=t.data;if(e.type===Sf){var r=e.projectionTransform;e.hitDetection?(this.hitVerticesBuffer_.fromArrayBuffer(e.vertexBuffer),this.helper.flushBufferData(this.hitVerticesBuffer_)):(this.verticesBuffer_.fromArrayBuffer(e.vertexBuffer),this.helper.flushBufferData(this.verticesBuffer_)),this.indicesBuffer_.fromArrayBuffer(e.indexBuffer),this.helper.flushBufferData(this.indicesBuffer_),this.renderTransform_=r,Pt(this.invertRenderTransform_,this.renderTransform_),e.hitDetection?this.hitRenderInstructions_=new Float32Array(t.data.renderInstructions):this.renderInstructions_=new Float32Array(t.data.renderInstructions),this.getLayer().changed()}}.bind(n)),n.featureCache_={},n.featureCount_=0;var u=n.getLayer().getSource();return n.sourceListenKeys_=[W(u,oc,n.handleSourceFeatureAdded_,n),W(u,ac,n.handleSourceFeatureChanged_,n),W(u,uc,n.handleSourceFeatureDelete_,n),W(u,sc,n.handleSourceFeatureClear_,n)],u.forEachFeature(function(t){this.featureCache_[o(t)]={feature:t,properties:t.getProperties(),geometry:t.getGeometry()},this.featureCount_++}.bind(n)),n}return Rf(e,t),e.prototype.handleSourceFeatureAdded_=function(t){var e=t.feature;this.featureCache_[o(e)]={feature:e,properties:e.getProperties(),geometry:e.getGeometry()},this.featureCount_++},e.prototype.handleSourceFeatureChanged_=function(t){var e=t.feature;this.featureCache_[o(e)]={feature:e,properties:e.getProperties(),geometry:e.getGeometry()}},e.prototype.handleSourceFeatureDelete_=function(t){var e=t.feature;delete this.featureCache_[o(e)],this.featureCount_--},e.prototype.handleSourceFeatureClear_=function(){this.featureCache_={},this.featureCount_=0},e.prototype.renderFrame=function(t){var e=this.indicesBuffer_.getSize();this.helper.drawElements(0,e),this.helper.finalizeDraw(t);var r=this.helper.getCanvas(),n=t.layerStatesArray[t.layerIndex].opacity;return n!==parseFloat(r.style.opacity)&&(r.style.opacity=String(n)),this.hitDetectionEnabled_&&(this.renderHitDetection(t),this.hitRenderTarget_.clearCachedData()),r},e.prototype.prepareFrame=function(t){var e=this.getLayer(),r=e.getSource(),n=t.viewState,i=!t.viewHints[va]&&!t.viewHints[_a],o=!$t(this.previousExtent_,t.extent),a=this.sourceRevision_<r.getRevision();if(a&&(this.sourceRevision_=r.getRevision()),i&&(o||a)){var s=n.projection,u=n.resolution,l=e instanceof xf?e.getRenderBuffer():0,h=zt(t.extent,l*u);r.loadFeatures(h,u,s),this.rebuildBuffers_(t),this.previousExtent_=t.extent.slice()}return this.helper.makeProjectionTransform(t,this.currentTransform_),wt(this.currentTransform_,this.invertRenderTransform_),this.helper.useProgram(this.program_),this.helper.prepareDraw(t),this.helper.bindBuffer(this.verticesBuffer_),this.helper.bindBuffer(this.indicesBuffer_),this.helper.enableAttributes(this.attributes),!0},e.prototype.rebuildBuffers_=function(t){var e=[1,0,0,1,0,0];this.helper.makeProjectionTransform(t,e);var r,n,i=(2+this.customAttributes.length)*this.featureCount_;if(this.renderInstructions_&&this.renderInstructions_.length===i||(this.renderInstructions_=new Float32Array(i)),this.hitDetectionEnabled_){var o=(7+this.customAttributes.length)*this.featureCount_;this.hitRenderInstructions_&&this.hitRenderInstructions_.length===o||(this.hitRenderInstructions_=new Float32Array(o))}var a,s,u,l=[],h=[],c=0,p=0;for(var f in this.featureCache_)if((n=(r=this.featureCache_[f]).geometry)&&n.getType()===yt.POINT){l[0]=n.getFlatCoordinates()[0],l[1]=n.getFlatCoordinates()[1],Tt(e,l),s=p+6,u=void 0,(u=h||[])[0]=Math.floor(s/256/256/256)/255,u[1]=Math.floor(s/256/256)%256/255,u[2]=Math.floor(s/256)%256/255,u[3]=s%256/255,a=u,this.renderInstructions_[c++]=l[0],this.renderInstructions_[c++]=l[1],this.hitDetectionEnabled_&&(this.hitRenderInstructions_[p++]=l[0],this.hitRenderInstructions_[p++]=l[1],this.hitRenderInstructions_[p++]=a[0],this.hitRenderInstructions_[p++]=a[1],this.hitRenderInstructions_[p++]=a[2],this.hitRenderInstructions_[p++]=a[3],this.hitRenderInstructions_[p++]=Number(f));for(var d=void 0,g=0;g<this.customAttributes.length;g++)d=this.customAttributes[g].callback(r.feature,r.properties),this.renderInstructions_[c++]=d,this.hitDetectionEnabled_&&(this.hitRenderInstructions_[p++]=d)}var y={type:Sf,renderInstructions:this.renderInstructions_.buffer,customAttributesCount:this.customAttributes.length};if(y.projectionTransform=e,this.worker_.postMessage(y,[this.renderInstructions_.buffer]),this.renderInstructions_=null,this.hitDetectionEnabled_){var m={type:Sf,renderInstructions:this.hitRenderInstructions_.buffer,customAttributesCount:5+this.customAttributes.length};m.projectionTransform=e,m.hitDetection=!0,this.worker_.postMessage(m,[this.hitRenderInstructions_.buffer]),this.hitRenderInstructions_=null}},e.prototype.forEachFeatureAtCoordinate=function(t,e,r,n,i){if(lt(this.hitDetectionEnabled_,66),this.hitRenderInstructions_){var o=Tt(e.coordinateToPixelTransform,t.slice()),a=this.hitRenderTarget_.readPixel(o[0]/2,o[1]/2),s=function(t){var e=0;return e+=Math.round(256*t[0]*256*256*255),e+=Math.round(256*t[1]*256*255),e+=Math.round(256*t[2]*255),e+=Math.round(255*t[3])}([a[0]/255,a[1]/255,a[2]/255,a[3]/255]),u=this.hitRenderInstructions_[s],l=Math.floor(u).toString(),h=this.getLayer().getSource().getFeatureByUid(l);return h?n(h,this.getLayer()):void 0}},e.prototype.renderHitDetection=function(t){if(this.hitVerticesBuffer_.getSize()){this.hitRenderTarget_.setSize([Math.floor(t.size[0]/2),Math.floor(t.size[1]/2)]),this.helper.useProgram(this.hitProgram_),this.helper.prepareDrawToRenderTarget(t,this.hitRenderTarget_,!0),this.helper.bindBuffer(this.hitVerticesBuffer_),this.helper.bindBuffer(this.indicesBuffer_),this.helper.enableAttributes(this.hitDetectionAttributes);var e=this.indicesBuffer_.getSize();this.helper.drawElements(0,e)}},e.prototype.disposeInternal=function(){this.worker_.terminate(),this.layer_=null,this.sourceListenKeys_.forEach((function(t){X(t)})),this.sourceListenKeys_=null,t.prototype.disposeInternal.call(this)},e}(Ef),If={BEGIN_GEOMETRY:0,BEGIN_PATH:1,CIRCLE:2,CLOSE_PATH:3,CUSTOM:4,DRAW_CHARS:5,DRAW_IMAGE:6,END_GEOMETRY:7,FILL:8,MOVE_TO_LINE_TO:9,SET_FILL_STYLE:10,SET_STROKE_STYLE:11,STROKE:12},Lf=[If.FILL],Mf=[If.STROKE],Ff=[If.BEGIN_PATH],Af=[If.CLOSE_PATH],kf=If,Nf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),jf=function(t){function e(e,r,n,i){var o=t.call(this)||this;return o.tolerance=e,o.maxExtent=r,o.pixelRatio=i,o.maxLineWidth=0,o.resolution=n,o.beginGeometryInstruction1_=null,o.beginGeometryInstruction2_=null,o.bufferedMaxExtent_=null,o.instructions=[],o.coordinates=[],o.tmpCoordinate_=[],o.hitDetectionInstructions=[],o.state={},o}return Nf(e,t),e.prototype.applyPixelRatio=function(t){var e=this.pixelRatio;return 1==e?t:t.map((function(t){return t*e}))},e.prototype.appendFlatCoordinates=function(t,e,r,n,i,o){var a=this.coordinates.length,s=this.getBufferedMaxExtent();o&&(e+=n);var u,l,h,c=t[e],p=t[e+1],f=this.tmpCoordinate_,d=!0;for(u=e+n;u<r;u+=n)f[0]=t[u],f[1]=t[u+1],(h=qt(s,f))!==l?(d&&(this.coordinates[a++]=c,this.coordinates[a++]=p),this.coordinates[a++]=f[0],this.coordinates[a++]=f[1],d=!1):h===At?(this.coordinates[a++]=f[0],this.coordinates[a++]=f[1],d=!1):d=!0,c=f[0],p=f[1],l=h;return(i&&d||u===e+n)&&(this.coordinates[a++]=c,this.coordinates[a++]=p),a},e.prototype.drawCustomCoordinates_=function(t,e,r,n,i){for(var o=0,a=r.length;o<a;++o){var s=r[o],u=this.appendFlatCoordinates(t,e,s,n,!1,!1);i.push(u),e=s}return e},e.prototype.drawCustom=function(t,e,r){this.beginGeometry(t,e);var n,i,o,a,s,u=t.getType(),l=t.getStride(),h=this.coordinates.length;if(u==yt.MULTI_POLYGON){n=t.getOrientedFlatCoordinates(),a=[];var c=t.getEndss();s=0;for(var p=0,f=c.length;p<f;++p){var d=[];s=this.drawCustomCoordinates_(n,s,c[p],l,d),a.push(d)}this.instructions.push([kf.CUSTOM,h,a,t,r,ln])}else u==yt.POLYGON||u==yt.MULTI_LINE_STRING?(o=[],n=u==yt.POLYGON?t.getOrientedFlatCoordinates():t.getFlatCoordinates(),s=this.drawCustomCoordinates_(n,0,t.getEnds(),l,o),this.instructions.push([kf.CUSTOM,h,o,t,r,un])):u==yt.LINE_STRING||u==yt.MULTI_POINT?(n=t.getFlatCoordinates(),i=this.appendFlatCoordinates(n,0,n.length,l,!1,!1),this.instructions.push([kf.CUSTOM,h,i,t,r,sn])):u==yt.POINT&&(n=t.getFlatCoordinates(),this.coordinates.push(n[0],n[1]),i=this.coordinates.length,this.instructions.push([kf.CUSTOM,h,i,t,r]));this.endGeometry(e)},e.prototype.beginGeometry=function(t,e){var r=t.getExtent();this.beginGeometryInstruction1_=[kf.BEGIN_GEOMETRY,e,0,r],this.instructions.push(this.beginGeometryInstruction1_),this.beginGeometryInstruction2_=[kf.BEGIN_GEOMETRY,e,0,r],this.hitDetectionInstructions.push(this.beginGeometryInstruction2_)},e.prototype.finish=function(){return{instructions:this.instructions,hitDetectionInstructions:this.hitDetectionInstructions,coordinates:this.coordinates}},e.prototype.reverseHitDetectionInstructions=function(){var t,e=this.hitDetectionInstructions;e.reverse();var r,n,i=e.length,o=-1;for(t=0;t<i;++t)(n=(r=e[t])[0])==kf.END_GEOMETRY?o=t:n==kf.BEGIN_GEOMETRY&&(r[2]=t,y(this.hitDetectionInstructions,o,t),o=-1)},e.prototype.setFillStrokeStyle=function(t,e){var r=this.state;if(t){var n=t.getColor();r.fillStyle=Fi(n||"#000")}else r.fillStyle=void 0;if(e){var i=e.getColor();r.strokeStyle=Fi(i||"#000");var o=e.getLineCap();r.lineCap=void 0!==o?o:"round";var a=e.getLineDash();r.lineDash=a?a.slice():Ji;var s=e.getLineDashOffset();r.lineDashOffset=s||0;var u=e.getLineJoin();r.lineJoin=void 0!==u?u:"round";var l=e.getWidth();r.lineWidth=void 0!==l?l:1;var h=e.getMiterLimit();r.miterLimit=void 0!==h?h:10,r.lineWidth>this.maxLineWidth&&(this.maxLineWidth=r.lineWidth,this.bufferedMaxExtent_=null)}else r.strokeStyle=void 0,r.lineCap=void 0,r.lineDash=null,r.lineDashOffset=void 0,r.lineJoin=void 0,r.lineWidth=void 0,r.miterLimit=void 0},e.prototype.createFill=function(t){var e=t.fillStyle,r=[kf.SET_FILL_STYLE,e];return"string"!=typeof e&&r.push(!0),r},e.prototype.applyStroke=function(t){this.instructions.push(this.createStroke(t))},e.prototype.createStroke=function(t){return[kf.SET_STROKE_STYLE,t.strokeStyle,t.lineWidth*this.pixelRatio,t.lineCap,t.lineJoin,t.miterLimit,this.applyPixelRatio(t.lineDash),t.lineDashOffset*this.pixelRatio]},e.prototype.updateFillStyle=function(t,e){var r=t.fillStyle;"string"==typeof r&&t.currentFillStyle==r||(void 0!==r&&this.instructions.push(e.call(this,t)),t.currentFillStyle=r)},e.prototype.updateStrokeStyle=function(t,e){var r=t.strokeStyle,n=t.lineCap,i=t.lineDash,o=t.lineDashOffset,a=t.lineJoin,s=t.lineWidth,u=t.miterLimit;(t.currentStrokeStyle!=r||t.currentLineCap!=n||i!=t.currentLineDash&&!_(t.currentLineDash,i)||t.currentLineDashOffset!=o||t.currentLineJoin!=a||t.currentLineWidth!=s||t.currentMiterLimit!=u)&&(void 0!==r&&e.call(this,t),t.currentStrokeStyle=r,t.currentLineCap=n,t.currentLineDash=i,t.currentLineDashOffset=o,t.currentLineJoin=a,t.currentLineWidth=s,t.currentMiterLimit=u)},e.prototype.endGeometry=function(t){this.beginGeometryInstruction1_[2]=this.instructions.length,this.beginGeometryInstruction1_=null,this.beginGeometryInstruction2_[2]=this.hitDetectionInstructions.length,this.beginGeometryInstruction2_=null;var e=[kf.END_GEOMETRY,t];this.instructions.push(e),this.hitDetectionInstructions.push(e)},e.prototype.getBufferedMaxExtent=function(){if(!this.bufferedMaxExtent_&&(this.bufferedMaxExtent_=Ut(this.maxExtent),this.maxLineWidth>0)){var t=this.resolution*(this.maxLineWidth+1)/2;zt(this.bufferedMaxExtent_,t,this.bufferedMaxExtent_)}return this.bufferedMaxExtent_},e}(Mi),Gf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Df=function(t){function e(e,r,n,i){var o=t.call(this,e,r,n,i)||this;return o.declutterGroups_=null,o.hitDetectionImage_=null,o.image_=null,o.imagePixelRatio_=void 0,o.anchorX_=void 0,o.anchorY_=void 0,o.height_=void 0,o.opacity_=void 0,o.originX_=void 0,o.originY_=void 0,o.rotateWithView_=void 0,o.rotation_=void 0,o.scale_=void 0,o.width_=void 0,o}return Gf(e,t),e.prototype.drawCoordinates_=function(t,e,r,n){return this.appendFlatCoordinates(t,e,r,n,!1,!1)},e.prototype.drawPoint=function(t,e){if(this.image_){this.beginGeometry(t,e);var r=t.getFlatCoordinates(),n=t.getStride(),i=this.coordinates.length,o=this.drawCoordinates_(r,0,r.length,n);this.instructions.push([kf.DRAW_IMAGE,i,o,this.image_,this.anchorX_*this.imagePixelRatio_,this.anchorY_*this.imagePixelRatio_,this.declutterGroups_,Math.ceil(this.height_*this.imagePixelRatio_),this.opacity_,this.originX_,this.originY_,this.rotateWithView_,this.rotation_,[this.scale_[0]*this.pixelRatio/this.imagePixelRatio_,this.scale_[1]*this.pixelRatio/this.imagePixelRatio_],Math.ceil(this.width_*this.imagePixelRatio_)]),this.hitDetectionInstructions.push([kf.DRAW_IMAGE,i,o,this.hitDetectionImage_,this.anchorX_,this.anchorY_,this.declutterGroups_,this.height_,this.opacity_,this.originX_,this.originY_,this.rotateWithView_,this.rotation_,this.scale_,this.width_]),this.endGeometry(e)}},e.prototype.drawMultiPoint=function(t,e){if(this.image_){this.beginGeometry(t,e);var r=t.getFlatCoordinates(),n=t.getStride(),i=this.coordinates.length,o=this.drawCoordinates_(r,0,r.length,n);this.instructions.push([kf.DRAW_IMAGE,i,o,this.image_,this.anchorX_*this.imagePixelRatio_,this.anchorY_*this.imagePixelRatio_,this.declutterGroups_,Math.ceil(this.height_*this.imagePixelRatio_),this.opacity_,this.originX_,this.originY_,this.rotateWithView_,this.rotation_,[this.scale_[0]*this.pixelRatio/this.imagePixelRatio_,this.scale_[1]*this.pixelRatio/this.imagePixelRatio_],Math.ceil(this.width_*this.imagePixelRatio_)]),this.hitDetectionInstructions.push([kf.DRAW_IMAGE,i,o,this.hitDetectionImage_,this.anchorX_,this.anchorY_,this.declutterGroups_,this.height_,this.opacity_,this.originX_,this.originY_,this.rotateWithView_,this.rotation_,this.scale_,this.width_]),this.endGeometry(e)}},e.prototype.finish=function(){return this.reverseHitDetectionInstructions(),this.anchorX_=void 0,this.anchorY_=void 0,this.hitDetectionImage_=null,this.image_=null,this.imagePixelRatio_=void 0,this.height_=void 0,this.scale_=void 0,this.opacity_=void 0,this.originX_=void 0,this.originY_=void 0,this.rotateWithView_=void 0,this.rotation_=void 0,this.width_=void 0,t.prototype.finish.call(this)},e.prototype.setImageStyle=function(t,e){var r=t.getAnchor(),n=t.getSize(),i=t.getHitDetectionImage(),o=t.getImage(this.pixelRatio),a=t.getOrigin();this.imagePixelRatio_=t.getPixelRatio(this.pixelRatio),this.anchorX_=r[0],this.anchorY_=r[1],this.declutterGroups_=e,this.hitDetectionImage_=i,this.image_=o,this.height_=n[1],this.opacity_=t.getOpacity(),this.originX_=a[0],this.originY_=a[1],this.rotateWithView_=t.getRotateWithView(),this.rotation_=t.getRotation(),this.scale_=t.getScaleArray(),this.width_=n[0]},e}(jf),zf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Uf=function(t){function e(e,r,n,i){return t.call(this,e,r,n,i)||this}return zf(e,t),e.prototype.drawFlatCoordinates_=function(t,e,r,n){var i=this.coordinates.length,o=this.appendFlatCoordinates(t,e,r,n,!1,!1),a=[kf.MOVE_TO_LINE_TO,i,o];return this.instructions.push(a),this.hitDetectionInstructions.push(a),r},e.prototype.drawLineString=function(t,e){var r=this.state,n=r.strokeStyle,i=r.lineWidth;if(void 0!==n&&void 0!==i){this.updateStrokeStyle(r,this.applyStroke),this.beginGeometry(t,e),this.hitDetectionInstructions.push([kf.SET_STROKE_STYLE,r.strokeStyle,r.lineWidth,r.lineCap,r.lineJoin,r.miterLimit,r.lineDash,r.lineDashOffset],Ff);var o=t.getFlatCoordinates(),a=t.getStride();this.drawFlatCoordinates_(o,0,o.length,a),this.hitDetectionInstructions.push(Mf),this.endGeometry(e)}},e.prototype.drawMultiLineString=function(t,e){var r=this.state,n=r.strokeStyle,i=r.lineWidth;if(void 0!==n&&void 0!==i){this.updateStrokeStyle(r,this.applyStroke),this.beginGeometry(t,e),this.hitDetectionInstructions.push([kf.SET_STROKE_STYLE,r.strokeStyle,r.lineWidth,r.lineCap,r.lineJoin,r.miterLimit,r.lineDash,r.lineDashOffset],Ff);for(var o=t.getEnds(),a=t.getFlatCoordinates(),s=t.getStride(),u=0,l=0,h=o.length;l<h;++l)u=this.drawFlatCoordinates_(a,u,o[l],s);this.hitDetectionInstructions.push(Mf),this.endGeometry(e)}},e.prototype.finish=function(){var e=this.state;return null!=e.lastStroke&&e.lastStroke!=this.coordinates.length&&this.instructions.push(Mf),this.reverseHitDetectionInstructions(),this.state=null,t.prototype.finish.call(this)},e.prototype.applyStroke=function(e){null!=e.lastStroke&&e.lastStroke!=this.coordinates.length&&(this.instructions.push(Mf),e.lastStroke=this.coordinates.length),e.lastStroke=0,t.prototype.applyStroke.call(this,e),this.instructions.push(Ff)},e}(jf),Bf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Yf=function(t){function e(e,r,n,i){return t.call(this,e,r,n,i)||this}return Bf(e,t),e.prototype.drawFlatCoordinatess_=function(t,e,r,n){var i=this.state,o=void 0!==i.fillStyle,a=void 0!==i.strokeStyle,s=r.length;this.instructions.push(Ff),this.hitDetectionInstructions.push(Ff);for(var u=0;u<s;++u){var l=r[u],h=this.coordinates.length,c=this.appendFlatCoordinates(t,e,l,n,!0,!a),p=[kf.MOVE_TO_LINE_TO,h,c];this.instructions.push(p),this.hitDetectionInstructions.push(p),a&&(this.instructions.push(Af),this.hitDetectionInstructions.push(Af)),e=l}return o&&(this.instructions.push(Lf),this.hitDetectionInstructions.push(Lf)),a&&(this.instructions.push(Mf),this.hitDetectionInstructions.push(Mf)),e},e.prototype.drawCircle=function(t,e){var r=this.state,n=r.fillStyle,i=r.strokeStyle;if(void 0!==n||void 0!==i){this.setFillStrokeStyles_(),this.beginGeometry(t,e),void 0!==r.fillStyle&&this.hitDetectionInstructions.push([kf.SET_FILL_STYLE,"#000"]),void 0!==r.strokeStyle&&this.hitDetectionInstructions.push([kf.SET_STROKE_STYLE,r.strokeStyle,r.lineWidth,r.lineCap,r.lineJoin,r.miterLimit,r.lineDash,r.lineDashOffset]);var o=t.getFlatCoordinates(),a=t.getStride(),s=this.coordinates.length;this.appendFlatCoordinates(o,0,o.length,a,!1,!1);var u=[kf.CIRCLE,s];this.instructions.push(Ff,u),this.hitDetectionInstructions.push(Ff,u),void 0!==r.fillStyle&&(this.instructions.push(Lf),this.hitDetectionInstructions.push(Lf)),void 0!==r.strokeStyle&&(this.instructions.push(Mf),this.hitDetectionInstructions.push(Mf)),this.endGeometry(e)}},e.prototype.drawPolygon=function(t,e){var r=this.state,n=r.fillStyle,i=r.strokeStyle;if(void 0!==n||void 0!==i){this.setFillStrokeStyles_(),this.beginGeometry(t,e),void 0!==r.fillStyle&&this.hitDetectionInstructions.push([kf.SET_FILL_STYLE,"#000"]),void 0!==r.strokeStyle&&this.hitDetectionInstructions.push([kf.SET_STROKE_STYLE,r.strokeStyle,r.lineWidth,r.lineCap,r.lineJoin,r.miterLimit,r.lineDash,r.lineDashOffset]);var o=t.getEnds(),a=t.getOrientedFlatCoordinates(),s=t.getStride();this.drawFlatCoordinatess_(a,0,o,s),this.endGeometry(e)}},e.prototype.drawMultiPolygon=function(t,e){var r=this.state,n=r.fillStyle,i=r.strokeStyle;if(void 0!==n||void 0!==i){this.setFillStrokeStyles_(),this.beginGeometry(t,e),void 0!==r.fillStyle&&this.hitDetectionInstructions.push([kf.SET_FILL_STYLE,"#000"]),void 0!==r.strokeStyle&&this.hitDetectionInstructions.push([kf.SET_STROKE_STYLE,r.strokeStyle,r.lineWidth,r.lineCap,r.lineJoin,r.miterLimit,r.lineDash,r.lineDashOffset]);for(var o=t.getEndss(),a=t.getOrientedFlatCoordinates(),s=t.getStride(),u=0,l=0,h=o.length;l<h;++l)u=this.drawFlatCoordinatess_(a,u,o[l],s);this.endGeometry(e)}},e.prototype.finish=function(){this.reverseHitDetectionInstructions(),this.state=null;var e=this.tolerance;if(0!==e)for(var r=this.coordinates,n=0,i=r.length;n<i;++n)r[n]=nn(r[n],e);return t.prototype.finish.call(this)},e.prototype.setFillStrokeStyles_=function(){var t=this.state;void 0!==t.fillStyle&&this.updateFillStyle(t,this.createFill),void 0!==t.strokeStyle&&this.updateStrokeStyle(t,this.applyStroke)},e}(jf);function Vf(t,e,r,n,i){var o,a,s,u,l,h,c,p,f,d=r,g=r,y=0,m=0,v=r;for(o=r;o<n;o+=i){var _=e[o],b=e[o+1];void 0!==u&&(p=_-u,f=b-l,s=Math.sqrt(p*p+f*f),void 0!==h&&(m+=a,Math.acos((h*p+c*f)/(a*s))>t&&(m>y&&(y=m,d=v,g=o),m=0,v=o-i)),a=s,h=p,c=f),u=_,l=b}return(m+=s)>y?[v,o]:[d,g]}var Wf=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),qf={left:0,end:0,center:.5,right:1,start:1,top:0,middle:.5,hanging:.2,alphabetic:.8,ideographic:.8,bottom:1},Xf={Circle:Yf,Default:jf,Image:Df,LineString:Uf,Polygon:Yf,Text:function(t){function e(e,r,n,i){var o=t.call(this,e,r,n,i)||this;return o.declutterGroups_,o.labels_=null,o.text_="",o.textOffsetX_=0,o.textOffsetY_=0,o.textRotateWithView_=void 0,o.textRotation_=0,o.textFillState_=null,o.fillStates={},o.textStrokeState_=null,o.strokeStates={},o.textState_={},o.textStates={},o.textKey_="",o.fillKey_="",o.strokeKey_="",o}return Wf(e,t),e.prototype.finish=function(){var e=t.prototype.finish.call(this);return e.textStates=this.textStates,e.fillStates=this.fillStates,e.strokeStates=this.strokeStates,e},e.prototype.drawText=function(t,e){var r=this.textFillState_,n=this.textStrokeState_,i=this.textState_;if(""!==this.text_&&i&&(r||n)){var o,a,s=this.coordinates.length,u=t.getType(),l=null,h=2,c=t.getStride();if(i.placement===ch){if(!ye(this.getBufferedMaxExtent(),t.getExtent()))return;var p=void 0;if(l=t.getFlatCoordinates(),u==yt.LINE_STRING)p=[l.length];else if(u==yt.MULTI_LINE_STRING)p=t.getEnds();else if(u==yt.POLYGON)p=t.getEnds().slice(0,1);else if(u==yt.MULTI_POLYGON){var f=t.getEndss();for(p=[],o=0,a=f.length;o<a;++o)p.push(f[o][0])}this.beginGeometry(t,e);for(var d=i.textAlign,g=0,y=void 0,m=0,v=p.length;m<v;++m){if(null==d){var _=Vf(i.maxAngle,l,g,p[m],c);g=_[0],y=_[1]}else y=p[m];for(o=g;o<y;o+=c)this.coordinates.push(l[o],l[o+1]);h=this.coordinates.length,g=p[m];var b=this.declutterGroups_?0===m?this.declutterGroups_[0]:[].concat(this.declutterGroups_[0]):null;this.drawChars_(s,h,b),s=h}this.endGeometry(e)}else{var x=null;switch(i.overflow||(x=[]),u){case yt.POINT:case yt.MULTI_POINT:h=(l=t.getFlatCoordinates()).length;break;case yt.LINE_STRING:l=t.getFlatMidpoint();break;case yt.CIRCLE:l=t.getCenter();break;case yt.MULTI_LINE_STRING:c=2,h=(l=t.getFlatMidpoints()).length;break;case yt.POLYGON:l=t.getFlatInteriorPoint(),i.overflow||x.push(l[2]/this.resolution),c=3;break;case yt.MULTI_POLYGON:var w=t.getFlatInteriorPoints();for(l=[],o=0,a=w.length;o<a;o+=3)i.overflow||x.push(w[o+2]/this.resolution),l.push(w[o],w[o+1]);if(c=2,0==(h=l.length))return}h=this.appendFlatCoordinates(l,0,h,c,!1,!1),this.saveTextStates_(),(i.backgroundFill||i.backgroundStroke)&&(this.setFillStrokeStyle(i.backgroundFill,i.backgroundStroke),i.backgroundFill&&(this.updateFillStyle(this.state,this.createFill),this.hitDetectionInstructions.push(this.createFill(this.state))),i.backgroundStroke&&(this.updateStrokeStyle(this.state,this.applyStroke),this.hitDetectionInstructions.push(this.createStroke(this.state)))),this.beginGeometry(t,e);var S=i.padding;if(S!=$i&&(i.scale[0]<0||i.scale[1]<0)){var T=i.padding[0],E=i.padding[1],C=i.padding[2],P=i.padding[3];i.scale[0]<0&&(E=-E,P=-P),i.scale[1]<0&&(T=-T,C=-C),S=[T,E,C,P]}var R=this.pixelRatio;this.instructions.push([kf.DRAW_IMAGE,s,h,null,NaN,NaN,this.declutterGroups_,NaN,1,0,0,this.textRotateWithView_,this.textRotation_,[1,1],NaN,S==$i?$i:S.map((function(t){return t*R})),!!i.backgroundFill,!!i.backgroundStroke,this.text_,this.textKey_,this.strokeKey_,this.fillKey_,this.textOffsetX_,this.textOffsetY_,x]);var O=1/R;this.hitDetectionInstructions.push([kf.DRAW_IMAGE,s,h,null,NaN,NaN,this.declutterGroups_,NaN,1,0,0,this.textRotateWithView_,this.textRotation_,[O,O],NaN,S,!!i.backgroundFill,!!i.backgroundStroke,this.text_,this.textKey_,this.strokeKey_,this.fillKey_,this.textOffsetX_,this.textOffsetY_,x]),this.endGeometry(e)}}},e.prototype.saveTextStates_=function(){var t=this.textStrokeState_,e=this.textState_,r=this.textFillState_,n=this.strokeKey_;t&&(n in this.strokeStates||(this.strokeStates[n]={strokeStyle:t.strokeStyle,lineCap:t.lineCap,lineDashOffset:t.lineDashOffset,lineWidth:t.lineWidth,lineJoin:t.lineJoin,miterLimit:t.miterLimit,lineDash:t.lineDash}));var i=this.textKey_;i in this.textStates||(this.textStates[i]={font:e.font,textAlign:e.textAlign||"center",textBaseline:e.textBaseline||"middle",scale:e.scale});var o=this.fillKey_;r&&(o in this.fillStates||(this.fillStates[o]={fillStyle:r.fillStyle}))},e.prototype.drawChars_=function(t,e,r){var n=this.textStrokeState_,i=this.textState_,o=this.strokeKey_,a=this.textKey_,s=this.fillKey_;this.saveTextStates_();var u=this.pixelRatio,l=qf[i.textBaseline],h=this.textOffsetY_*u,c=this.text_,p=n?n.lineWidth*Math.abs(i.scale[0])/2:0;this.instructions.push([kf.DRAW_CHARS,t,e,l,r,i.overflow,s,i.maxAngle,u,h,o,p*u,c,a,1]),this.hitDetectionInstructions.push([kf.DRAW_CHARS,t,e,l,r,i.overflow,s,i.maxAngle,1,h,o,p,c,a,1/u])},e.prototype.setTextStyle=function(t,e){var r,n,i;if(t){this.declutterGroups_=e;var a=t.getFill();a?((n=this.textFillState_)||(n={},this.textFillState_=n),n.fillStyle=Fi(a.getColor()||"#000")):(n=null,this.textFillState_=n);var s=t.getStroke();if(s){(i=this.textStrokeState_)||(i={},this.textStrokeState_=i);var u=s.getLineDash(),l=s.getLineDashOffset(),h=s.getWidth(),c=s.getMiterLimit();i.lineCap=s.getLineCap()||"round",i.lineDash=u?u.slice():Ji,i.lineDashOffset=void 0===l?0:l,i.lineJoin=s.getLineJoin()||"round",i.lineWidth=void 0===h?1:h,i.miterLimit=void 0===c?10:c,i.strokeStyle=Fi(s.getColor()||"#000")}else i=null,this.textStrokeState_=i;r=this.textState_;var p=t.getFont()||"10px sans-serif";ao(p);var f=t.getScaleArray();r.overflow=t.getOverflow(),r.font=p,r.maxAngle=t.getMaxAngle(),r.placement=t.getPlacement(),r.textAlign=t.getTextAlign(),r.textBaseline=t.getTextBaseline()||"middle",r.backgroundFill=t.getBackgroundFill(),r.backgroundStroke=t.getBackgroundStroke(),r.padding=t.getPadding()||$i,r.scale=void 0===f?[1,1]:f;var d=t.getOffsetX(),g=t.getOffsetY(),y=t.getRotateWithView(),m=t.getRotation();this.text_=t.getText()||"",this.textOffsetX_=void 0===d?0:d,this.textOffsetY_=void 0===g?0:g,this.textRotateWithView_=void 0!==y&&y,this.textRotation_=void 0===m?0:m,this.strokeKey_=i?("string"==typeof i.strokeStyle?i.strokeStyle:o(i.strokeStyle))+i.lineCap+i.lineDashOffset+"|"+i.lineWidth+i.lineJoin+i.miterLimit+"["+i.lineDash.join()+"]":"",this.textKey_=r.font+r.scale+(r.textAlign||"?")+(r.textBaseline||"?"),this.fillKey_=n?"string"==typeof n.fillStyle?n.fillStyle:"|"+o(n.fillStyle):""}else this.text_=""},e}(jf)},Zf=function(){function t(t,e,r,n,i){this.declutter_=i,this.declutterGroups_=null,this.tolerance_=t,this.maxExtent_=e,this.pixelRatio_=n,this.resolution_=r,this.buildersByZIndex_={}}return t.prototype.addDeclutter=function(t){var e=null;return this.declutter_&&(t?(e=this.declutterGroups_)[0][0]++:(e=[[1]],this.declutterGroups_=e)),e},t.prototype.finish=function(){var t={};for(var e in this.buildersByZIndex_){t[e]=t[e]||{};var r=this.buildersByZIndex_[e];for(var n in r){var i=r[n].finish();t[e][n]=i}}return t},t.prototype.getBuilder=function(t,e){var r=void 0!==t?t.toString():"0",n=this.buildersByZIndex_[r];void 0===n&&(n={},this.buildersByZIndex_[r]=n);var i=n[e];void 0===i&&(i=new(0,Xf[e])(this.tolerance_,this.maxExtent_,this.resolution_,this.pixelRatio_),n[e]=i);return i},t}();function Kf(t,e,r,n,i,o,a,s,u,l,h,c){var p,f=[];if(c){var d=Dr(t,e,r,n,c,[t[e],t[e+1]]);p=d[0]>d[d.length-n]}else p=t[e]>t[r-n];for(var g,y,m=i.length,v=t[e],_=t[e+1],b=t[e+=n],x=t[e+1],w=0,S=Math.sqrt(Math.pow(b-v,2)+Math.pow(x-_,2)),T=!1,E=0;E<m;++E){for(var C=i[g=p?m-E-1:E],P=s*u(l,C,h),R=o+P/2;e<r-n&&w+S<R;)v=b,_=x,b=t[e+=n],x=t[e+1],w+=S,S=Math.sqrt(Math.pow(b-v,2)+Math.pow(x-_,2));var O=R-w,I=Math.atan2(x-_,b-v);if(p&&(I+=I>0?-Math.PI:Math.PI),void 0!==y){var L=I-y;if(T=T||0!==L,L+=L>Math.PI?-2*Math.PI:L<-Math.PI?2*Math.PI:0,Math.abs(L)>a)return null}y=I;var M=O/S,F=Ie(v,b,M),A=Ie(_,x,M);f[g]=[F,A,P/2,I,C],o+=P}return T?f:[[f[0][0],f[0][1],f[0][2],f[0][3],i]]}function Hf(t,e,r,n){for(var i=t[e],o=t[e+1],a=0,s=e+n;s<r;s+=n){var u=t[s],l=t[s+1];a+=Math.sqrt((u-i)*(u-i)+(l-o)*(l-o)),i=u,o=l}return a}var Jf=[1/0,1/0,-1/0,-1/0],$f=[1,0,0,1,0,0],Qf=[],td=[],ed=[],rd=[],nd=function(){function t(t,e,r,n,i){this.overlaps=r,this.pixelRatio=e,this.resolution=t,this.alignFill_,this.declutterItems=[],this.instructions=n.instructions,this.coordinates=n.coordinates,this.coordinateCache_={},this.renderBuffer_=i,this.renderedTransform_=[1,0,0,1,0,0],this.hitDetectionInstructions=n.hitDetectionInstructions,this.pixelCoordinates_=null,this.viewRotation_=0,this.fillStates=n.fillStates||{},this.strokeStates=n.strokeStates||{},this.textStates=n.textStates||{},this.widths_={},this.labels_={}}return t.prototype.createLabel=function(t,e,r,n){var i=t+e+r+n;if(this.labels_[i])return this.labels_[i];var o=n?this.strokeStates[n]:null,a=r?this.fillStates[r]:null,s=this.textStates[e],u=this.pixelRatio,l=[s.scale[0]*u,s.scale[1]*u],h=qf[s.textAlign||"center"],c=n&&o.lineWidth?o.lineWidth:0,p=t.split("\n"),f=p.length,d=[],g=function(t,e,r){for(var n=e.length,i=0,o=0;o<n;++o){var a=lo(t,e[o]);i=Math.max(i,a),r.push(a)}return i}(s.font,p,d),y=so(s.font),m=g+c,v=[],_=(m+2)*l[0],b=(y*f+c)*l[1],x={width:_<0?Math.floor(_):Math.ceil(_),height:b<0?Math.floor(b):Math.ceil(b),contextInstructions:v};(1==l[0]&&1==l[1]||v.push("scale",l),v.push("font",s.font),n)&&(v.push("strokeStyle",o.strokeStyle),v.push("lineWidth",c),v.push("lineCap",o.lineCap),v.push("lineJoin",o.lineJoin),v.push("miterLimit",o.miterLimit),(Di?OffscreenCanvasRenderingContext2D:CanvasRenderingContext2D).prototype.setLineDash&&(v.push("setLineDash",[o.lineDash]),v.push("lineDashOffset",o.lineDashOffset)));r&&v.push("fillStyle",a.fillStyle),v.push("textBaseline","middle"),v.push("textAlign","center");var w,S=.5-h,T=h*m+S*c;if(n)for(w=0;w<f;++w)v.push("strokeText",[p[w],T+S*d[w],.5*(c+y)+w*y]);if(r)for(w=0;w<f;++w)v.push("fillText",[p[w],T+S*d[w],.5*(c+y)+w*y]);return this.labels_[i]=x,x},t.prototype.replayTextBackground_=function(t,e,r,n,i,o,a,s){t.beginPath(),t.moveTo.apply(t,e),t.lineTo.apply(t,r),t.lineTo.apply(t,n),t.lineTo.apply(t,i),t.lineTo.apply(t,e),o&&(this.alignFill_=o[2],s&&(t.fillStyle=o[1]),this.fill_(t)),a&&(this.setStrokeStyle_(t,a),t.stroke())},t.prototype.replayImageOrLabel_=function(t,e,r,n,i,o,a,s,u,l,h,c,p,f,d,g,y,m,v){var _=m||v;r-=o*=f[0],n-=a*=f[1];var b=g+h>i.width?i.width-h:g,x=u+c>i.height?i.height-c:u,w=y[3]+b*f[0]+y[1],S=y[0]+x*f[1]+y[2],T=r-y[3],E=n-y[0];(_||0!==p)&&(Qf[0]=T,rd[0]=T,Qf[1]=E,td[1]=E,td[0]=T+w,ed[0]=td[0],ed[1]=E+S,rd[1]=ed[1]);var C=null;if(0!==p){var P=r+o,R=n+a;C=Ct($f,P,R,1,1,p,-P,-R),Tt($f,Qf),Tt($f,td),Tt($f,ed),Tt($f,rd),Zt(Math.min(Qf[0],td[0],ed[0],rd[0]),Math.min(Qf[1],td[1],ed[1],rd[1]),Math.max(Qf[0],td[0],ed[0],rd[0]),Math.max(Qf[1],td[1],ed[1],rd[1]),Jf)}else Zt(T,E,T+w,E+S,Jf);var O=0,I=0;if(s){var L=this.renderBuffer_;L[0]=Math.max(L[0],ge(Jf)),O=L[0],L[1]=Math.max(L[1],ce(Jf)),I=L[1]}var M=t.canvas,F=v?v[2]*f[0]/2:0,A=Jf[0]-F<=(M.width+O)/e&&Jf[2]+F>=-O/e&&Jf[1]-F<=(M.height+I)/e&&Jf[3]+F>=-I/e;if(d&&(r=Math.round(r),n=Math.round(n)),s){if(!A&&1==s[0])return!1;var k=A?[t,C?C.slice(0):null,l,i,h,c,b,x,r,n,f,Jf.slice()]:null;k&&(_&&k.push(m,v,Qf.slice(0),td.slice(0),ed.slice(0),rd.slice(0)),s.push(k))}else A&&(_&&this.replayTextBackground_(t,Qf,td,ed,rd,m,v,!1),po(t,C,l,i,h,c,b,x,r,n,f));return!0},t.prototype.fill_=function(t){if(this.alignFill_){var e=Tt(this.renderedTransform_,[0,0]),r=512*this.pixelRatio;t.save(),t.translate(e[0]%r,e[1]%r),t.rotate(this.viewRotation_)}t.fill(),this.alignFill_&&t.restore()},t.prototype.setStrokeStyle_=function(t,e){t.strokeStyle=e[1],t.lineWidth=e[2],t.lineCap=e[3],t.lineJoin=e[4],t.miterLimit=e[5],t.setLineDash&&(t.lineDashOffset=e[7],t.setLineDash(e[6]))},t.prototype.renderDeclutter=function(t,e,r,n){for(var i=[],o=1,a=t.length;o<a;++o){var s=(c=t[o])[11];i.push({minX:s[0],minY:s[1],maxX:s[2],maxY:s[3],value:e})}n||(n=new nc.a(9));var u=!1;for(o=0,a=i.length;o<a;++o)if(n.collides(i[o])){u=!0;break}if(!u){n.load(i);for(var l=1,h=t.length;l<h;++l){var c,p=(c=t[l])[0],f=p.globalAlpha;f!==r&&(p.globalAlpha=r),c.length>12&&this.replayTextBackground_(c[0],c[14],c[15],c[16],c[17],c[12],c[13],!0),po.apply(void 0,c),f!==r&&(p.globalAlpha=f)}}return t.length=1,n},t.prototype.drawLabelWithPointPlacement_=function(t,e,r,n){var i=this.textStates[e],o=this.createLabel(t,e,n,r),a=this.strokeStates[r],s=this.pixelRatio,u=qf[i.textAlign||"center"],l=qf[i.textBaseline||"middle"],h=a&&a.lineWidth?a.lineWidth:0;return{label:o,anchorX:u*(o.width/s-2*i.scale[0])+2*(.5-u)*h,anchorY:l*o.height/s+2*(.5-l)*h}},t.prototype.execute_=function(t,e,r,n,i,o,a){var s,u,l;this.declutterItems.length=0,this.pixelCoordinates_&&_(r,this.renderedTransform_)?s=this.pixelCoordinates_:(this.pixelCoordinates_||(this.pixelCoordinates_=[]),s=Gr(this.coordinates,0,this.coordinates.length,2,r,this.pixelCoordinates_),u=this.renderedTransform_,l=r,u[0]=l[0],u[1]=l[1],u[2]=l[2],u[3]=l[3],u[4]=l[4],u[5]=l[5]);for(var h,c,p,f,d,g,y,m,v,b,x,w,S,T,E,C,P,R=0,O=n.length,I=0,L=0,M=0,F=null,A=null,k=this.coordinateCache_,N=this.viewRotation_,j=Math.round(1e12*Math.atan2(-r[1],r[0]))/1e12,G={context:t,pixelRatio:this.pixelRatio,resolution:this.resolution,rotation:N},D=this.instructions!=n||this.overlaps?0:200;R<O;){var z=n[R];switch(z[0]){case kf.BEGIN_GEOMETRY:(E=z[1]).getGeometry()?void 0===a||ye(a,z[3])?++R:R=z[2]+1:R=z[2];break;case kf.BEGIN_PATH:L>D&&(this.fill_(t),L=0),M>D&&(t.stroke(),M=0),L||M||(t.beginPath(),f=NaN,d=NaN),++R;break;case kf.CIRCLE:var U=s[I=z[1]],B=s[I+1],Y=s[I+2]-U,V=s[I+3]-B,W=Math.sqrt(Y*Y+V*V);t.moveTo(U+W,B),t.arc(U,B,W,0,2*Math.PI,!0),++R;break;case kf.CLOSE_PATH:t.closePath(),++R;break;case kf.CUSTOM:I=z[1],h=z[2];var q=z[3],X=z[4],Z=6==z.length?z[5]:void 0;G.geometry=q,G.feature=E,R in k||(k[R]=[]);var K=k[R];Z?Z(s,I,h,2,K):(K[0]=s[I],K[1]=s[I+1],K.length=2),X(K,G),++R;break;case kf.DRAW_IMAGE:I=z[1],h=z[2],b=z[3],c=z[4],p=z[5],v=o?null:z[6];var H=z[7],J=z[8],$=z[9],Q=z[10],tt=z[11],et=z[12],rt=z[13],nt=z[14];if(!b&&z.length>=19){x=z[18],w=z[19],S=z[20],T=z[21];var it=this.drawLabelWithPointPlacement_(x,w,S,T);b=it.label,z[3]=b;var ot=z[22];c=(it.anchorX-ot)*this.pixelRatio,z[4]=c;var at=z[23];p=(it.anchorY-at)*this.pixelRatio,z[5]=p,H=b.height,z[7]=H,nt=b.width,z[14]=nt}var st=void 0;z.length>24&&(st=z[24]);var ut=void 0,lt=void 0,ht=void 0;z.length>16?(ut=z[15],lt=z[16],ht=z[17]):(ut=$i,lt=!1,ht=!1),tt&&j?et+=N:tt||j||(et-=N);for(var ct=0,pt=0;I<h;I+=2)if(!(st&&st[ct++]<nt/this.pixelRatio)){if(v){var ft=Math.floor(pt);m=v.length<ft+1?[v[0][0]]:v[ft]}(Lt=this.replayImageOrLabel_(t,e,s[I],s[I+1],b,c,p,m,H,J,$,Q,et,rt,i,nt,ut,lt?F:null,ht?A:null))&&m&&v[v.length-1]!==m&&v.push(m),m&&(m.length-1===m[0]&&this.declutterItems.push(this,m,E),pt+=1/m[0])}++R;break;case kf.DRAW_CHARS:var dt=z[1],gt=z[2],yt=z[3];m=o?null:z[4];var mt=z[5];T=z[6];var vt=z[7],_t=z[8],bt=z[9];S=z[10];var xt=z[11];x=z[12],w=z[13];var wt=[z[14],z[14]],St=this.textStates[w],Tt=St.font,Et=[St.scale[0]*_t,St.scale[1]*_t],Ct=void 0;Tt in this.widths_?Ct=this.widths_[Tt]:(Ct={},this.widths_[Tt]=Ct);var Pt=Hf(s,dt,gt,2),Rt=Math.abs(Et[0])*ho(Tt,x,Ct);if(mt||Rt<=Pt){var Ot=this.textStates[w].textAlign,It=Kf(s,dt,gt,2,x,(Pt-Rt)*qf[Ot],vt,Math.abs(Et[0]),ho,Tt,Ct,j?0:this.viewRotation_);if(It){var Lt=!1,Mt=void 0,Ft=void 0,At=void 0,kt=void 0,Nt=void 0;if(S)for(Mt=0,Ft=It.length;Mt<Ft;++Mt)At=(Nt=It[Mt])[4],kt=this.createLabel(At,w,"",S),c=Nt[2]+xt,p=yt*kt.height+2*(.5-yt)*xt*Et[1]/Et[0]-bt,Lt=this.replayImageOrLabel_(t,e,Nt[0],Nt[1],kt,c,p,m,kt.height,1,0,0,Nt[3],wt,!1,kt.width,$i,null,null)||Lt;if(T)for(Mt=0,Ft=It.length;Mt<Ft;++Mt)At=(Nt=It[Mt])[4],kt=this.createLabel(At,w,T,""),c=Nt[2],p=yt*kt.height-bt,Lt=this.replayImageOrLabel_(t,e,Nt[0],Nt[1],kt,c,p,m,kt.height,1,0,0,Nt[3],wt,!1,kt.width,$i,null,null)||Lt;Lt&&this.declutterItems.push(this,m,E)}}++R;break;case kf.END_GEOMETRY:if(void 0!==o){var jt=o(E=z[1]);if(jt)return jt}++R;break;case kf.FILL:D?L++:this.fill_(t),++R;break;case kf.MOVE_TO_LINE_TO:for(I=z[1],h=z[2],C=s[I],y=(P=s[I+1])+.5|0,(g=C+.5|0)===f&&y===d||(t.moveTo(C,P),f=g,d=y),I+=2;I<h;I+=2)g=(C=s[I])+.5|0,y=(P=s[I+1])+.5|0,I!=h-2&&g===f&&y===d||(t.lineTo(C,P),f=g,d=y);++R;break;case kf.SET_FILL_STYLE:F=z,this.alignFill_=z[2],L&&(this.fill_(t),L=0,M&&(t.stroke(),M=0)),t.fillStyle=z[1],++R;break;case kf.SET_STROKE_STYLE:A=z,M&&(t.stroke(),M=0),this.setStrokeStyle_(t,z),++R;break;case kf.STROKE:D?M++:t.stroke(),++R;break;default:++R}}L&&this.fill_(t),M&&t.stroke()},t.prototype.execute=function(t,e,r,n,i){this.viewRotation_=n,this.execute_(t,e,r,this.instructions,i,void 0,void 0)},t.prototype.executeHitDetection=function(t,e,r,n,i){return this.viewRotation_=r,this.execute_(t,1,e,this.hitDetectionInstructions,!0,n,i)},t}(),id=[wo,vo,xo,bo,So,_o],od=function(){function t(t,e,r,n,i,o){this.maxExtent_=t,this.overlaps_=n,this.pixelRatio_=r,this.resolution_=e,this.renderBuffer_=o,this.executorsByZIndex_={},this.hitDetectionContext_=null,this.hitDetectionTransform_=[1,0,0,1,0,0],this.createExecutors_(i)}return t.prototype.clip=function(t,e){var r=this.getClipCoords(e);t.beginPath(),t.moveTo(r[0],r[1]),t.lineTo(r[2],r[3]),t.lineTo(r[4],r[5]),t.lineTo(r[6],r[7]),t.clip()},t.prototype.createExecutors_=function(t){for(var e in t){var r=this.executorsByZIndex_[e];void 0===r&&(r={},this.executorsByZIndex_[e]=r);var n=t[e],i=[this.renderBuffer_||0,this.renderBuffer_||0];for(var o in n){var a=n[o];r[o]=new nd(this.resolution_,this.pixelRatio_,this.overlaps_,a,i)}}},t.prototype.hasExecutors=function(t){for(var e in this.executorsByZIndex_)for(var r=this.executorsByZIndex_[e],n=0,i=t.length;n<i;++n)if(t[n]in r)return!0;return!1},t.prototype.forEachFeatureAtCoordinate=function(t,e,r,n,i,o){var a=2*(n=Math.round(n))+1,s=Ct(this.hitDetectionTransform_,n+.5,n+.5,1/e,-1/e,-r,-t[0],-t[1]);this.hitDetectionContext_||(this.hitDetectionContext_=Bi(a,a));var u,l=this.hitDetectionContext_;l.canvas.width!==a||l.canvas.height!==a?(l.canvas.width=a,l.canvas.height=a):l.clearRect(0,0,a,a),void 0!==this.renderBuffer_&&(te(u=[1/0,1/0,-1/0,-1/0],t),zt(u,e*(this.renderBuffer_+n),u));var h,c=function(t){if(void 0!==ad[t])return ad[t];for(var e=2*t+1,r=new Array(e),n=0;n<e;n++)r[n]=new Array(e);var i=t,o=0,a=0;for(;i>=o;)sd(r,t+i,t+o),sd(r,t+o,t+i),sd(r,t-o,t+i),sd(r,t-i,t+o),sd(r,t-i,t-o),sd(r,t-o,t-i),sd(r,t+o,t-i),sd(r,t+i,t-o),o++,2*((a+=1+2*o)-i)+1>0&&(a+=1-2*(i-=1));return ad[t]=r,r}(n);function p(t){for(var e=l.getImageData(0,0,a,a).data,r=0;r<a;r++)for(var n=0;n<a;n++)if(c[r][n]&&e[4*(n*a+r)+3]>0){var s=void 0;return(!o||h!=bo&&h!=So||-1!==o.indexOf(t))&&(s=i(t)),s||void l.clearRect(0,0,a,a)}}var d,g,y,m,v,_=Object.keys(this.executorsByZIndex_).map(Number);for(_.sort(f),d=_.length-1;d>=0;--d){var b=_[d].toString();for(y=this.executorsByZIndex_[b],g=id.length-1;g>=0;--g)if(void 0!==(m=y[h=id[g]])&&(v=m.executeHitDetection(l,s,r,p,u)))return v}},t.prototype.getClipCoords=function(t){var e=this.maxExtent_;if(!e)return null;var r=e[0],n=e[1],i=e[2],o=e[3],a=[r,n,r,o,i,o,i,n];return Gr(a,0,8,2,t,a),a},t.prototype.isEmpty=function(){return P(this.executorsByZIndex_)},t.prototype.execute=function(t,e,r,n,i,o,a){var s=Object.keys(this.executorsByZIndex_).map(Number);s.sort(f),this.maxExtent_&&(t.save(),this.clip(t,r));var u,l,h,c,p,d,g=o||id;for(u=0,l=s.length;u<l;++u){var y=s[u].toString();for(p=this.executorsByZIndex_[y],h=0,c=g.length;h<c;++h){var m=g[h];if(void 0!==(d=p[m]))if(!a||m!=bo&&m!=So)d.execute(t,e,r,n,i);else{var v=a[y];v?v.push(d,r.slice(0)):a[y]=[d,r.slice(0)]}}}this.maxExtent_&&t.restore()},t}(),ad={0:[[!0]]};function sd(t,e,r){var n,i=Math.floor(t.length/2);if(e>=i)for(n=i;n<e;n++)t[n][r]=!0;else if(e<i)for(n=e+1;n<i;n++)t[n][r]=!0}function ud(t,e,r,n,i,o){for(var a=Object.keys(t).map(Number).sort(f),s=0,u=a.length;s<u;++s)for(var l=t[a[s].toString()],h=void 0,c=0,p=l.length;c<p;){var d=l[c++],g=l[c++];d.execute(e,1,g,r,i),d!==h&&d.declutterItems.length>0&&(h=d,o.push({items:d.declutterItems,opacity:n}))}}var ld=od;function hd(t,e,r,n,i,o,a){var s=Bi(t[0]/2,t[1]/2);s.imageSmoothingEnabled=!1;for(var u=s.canvas,l=new mo(s,.5,i,null,a),h=r.length,c=Math.floor(16777215/h),p={},d=1;d<=h;++d){var g=r[d-1],y=g.getStyleFunction()||n;if(n){var m=y(g,o);if(m){Array.isArray(m)||(m=[m]);for(var v="#"+("000000"+(d*c).toString(16)).slice(-6),_=0,b=m.length;_<b;++_){var x=m[_],w=x.clone(),S=w.getFill();S&&S.setColor(v);var T=w.getStroke();T&&T.setColor(v),w.setText(void 0);var E=x.getImage();if(E){var C=E.getImageSize();if(!C)continue;var P=document.createElement("canvas");P.width=C[0],P.height=C[1];var R=P.getContext("2d",{alpha:!1});R.fillStyle=v;var O=R.canvas;R.fillRect(0,0,O.width,O.height),Bi(C?C[0]:O.width,C?C[1]:O.height).drawImage(O,0,0),w.setImage(new rh({img:O,imgSize:C,anchor:E.getAnchor(),anchorXUnits:Bl,anchorYUnits:Bl,offset:E.getOrigin(),size:E.getSize(),opacity:E.getOpacity(),scale:E.getScale(),rotation:E.getRotation(),rotateWithView:E.getRotateWithView()}))}var I=Number(w.getZIndex());(A=p[I])||(A={},p[I]=A,A[yt.POLYGON]=[],A[yt.CIRCLE]=[],A[yt.LINE_STRING]=[],A[yt.POINT]=[]);var L=w.getGeometryFunction()(g);L&&ye(i,L.getExtent())&&A[L.getType().replace("Multi","")].push(L,w)}}}}for(var M=Object.keys(p).map(Number).sort(f),F=(d=0,M.length);d<F;++d){var A=p[M[d]];for(var k in A){var N=A[k];for(_=0,b=N.length;_<b;_+=2){l.setStyle(N[_+1]);for(var j=0,G=e.length;j<G;++j)l.setTransform(e[j]),l.drawGeometry(N[_])}}}return s.getImageData(0,0,u.width,u.height)}function cd(t,e,r){var n=[];if(r){var i=4*(Math.round(t[0]/2)+Math.round(t[1]/2)*r.width),o=r.data[i],a=r.data[i+1],s=r.data[i+2]+256*(a+256*o),u=Math.floor(16777215/e.length);s&&s%u==0&&n.push(e[s/u-1])}return n}var pd=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),fd=function(t){function e(e){var r=t.call(this,e)||this;return r.boundHandleStyleImageChange_=r.handleStyleImageChange_.bind(r),r.animatingOrInteracting_,r.dirty_=!1,r.hitDetectionImageData_=null,r.renderedFeatures_=null,r.renderedRevision_=-1,r.renderedResolution_=NaN,r.renderedExtent_=[1/0,1/0,-1/0,-1/0],r.renderedRotation_,r.renderedCenter_=null,r.renderedProjection_=null,r.renderedRenderOrder_=null,r.replayGroup_=null,r.replayGroupChanged=!0,r.clipping=!0,r}return pd(e,t),e.prototype.useContainer=function(e,r,n){n<1&&(e=null),t.prototype.useContainer.call(this,e,r,n)},e.prototype.renderFrame=function(t,e){var r=t.pixelRatio,n=t.layerStatesArray[t.layerIndex];!function(t,e,r){St(t,e,0,0,r,0,0)}(this.pixelTransform,1/r,1/r),Pt(this.inversePixelTransform,this.pixelTransform);var i=Rt(this.pixelTransform);this.useContainer(e,i,n.opacity);var o=this.context,a=o.canvas,s=this.replayGroup_;if(!s||s.isEmpty())return!this.containerReused&&a.width>0&&(a.width=0),this.container;var u=Math.round(t.size[0]*r),l=Math.round(t.size[1]*r);a.width!=u||a.height!=l?(a.width=u,a.height=l,a.style.transform!==i&&(a.style.transform=i)):this.containerReused||o.clearRect(0,0,u,l),this.preRender(o,t);var h=t.extent,c=t.viewState,p=c.center,f=c.resolution,d=c.projection,g=c.rotation,y=d.getExtent(),m=this.getLayer().getSource(),v=!1;if(n.extent&&this.clipping){var _=Nr(n.extent,d);(v=!Vt(_,t.extent)&&ye(_,t.extent))&&this.clipUnrotated(o,t,_)}var b=t.viewHints,x=!(b[va]||b[_a]),w=this.getRenderTransform(p,f,g,r,u,l,0),S=this.getLayer().getDeclutter()?{}:null;if(s.execute(o,1,w,g,x,void 0,S),m.getWrapX()&&d.canWrapX()&&!Vt(y,h)){for(var T=h[0],E=ge(y),C=0,P=void 0;T<y[0];){P=E*--C;var R=this.getRenderTransform(p,f,g,r,u,l,P);s.execute(o,1,R,g,x,void 0,S),T+=E}for(C=0,T=h[2];T>y[2];){P=E*++C;var O=this.getRenderTransform(p,f,g,r,u,l,P);s.execute(o,1,O,g,x,void 0,S),T-=E}}if(S){var I=t.viewHints;ud(S,o,g,1,!(I[va]||I[_a]),t.declutterItems)}v&&o.restore(),this.postRender(o,t);var L=n.opacity,M=this.container;return L!==parseFloat(M.style.opacity)&&(M.style.opacity=1===L?"":String(L)),this.renderedRotation_!==c.rotation&&(this.renderedRotation_=c.rotation,this.hitDetectionImageData_=null),this.container},e.prototype.getFeatures=function(t){return new Promise(function(e,r){if(!this.hitDetectionImageData_&&!this.animatingOrInteracting_){var n=[this.context.canvas.width,this.context.canvas.height];Tt(this.pixelTransform,n);var i=this.renderedCenter_,o=this.renderedResolution_,a=this.renderedRotation_,s=this.renderedProjection_,u=this.renderedExtent_,l=this.getLayer(),h=[],c=n[0]/2,p=n[1]/2;h.push(this.getRenderTransform(i,o,a,.5,c,p,0).slice());var f=l.getSource(),d=s.getExtent();if(f.getWrapX()&&s.canWrapX()&&!Vt(d,u)){for(var g=u[0],y=ge(d),m=0,v=void 0;g<d[0];)v=y*--m,h.push(this.getRenderTransform(i,o,a,.5,c,p,v).slice()),g+=y;for(m=0,g=u[2];g>d[2];)v=y*++m,h.push(this.getRenderTransform(i,o,a,.5,c,p,v).slice()),g-=y}this.hitDetectionImageData_=hd(n,h,this.renderedFeatures_,l.getStyleFunction(),u,o,a)}e(cd(t,this.renderedFeatures_,this.hitDetectionImageData_))}.bind(this))},e.prototype.forEachFeatureAtCoordinate=function(t,e,r,n,i){if(this.replayGroup_){var a=e.viewState.resolution,s=e.viewState.rotation,u=this.getLayer(),l={};return this.replayGroup_.forEachFeatureAtCoordinate(t,a,s,r,(function(t){var e=o(t);if(!(e in l))return l[e]=!0,n(t,u)}),u.getDeclutter()?i:null)}},e.prototype.handleFontsChanged=function(){var t=this.getLayer();t.getVisible()&&this.replayGroup_&&t.changed()},e.prototype.handleStyleImageChange_=function(t){this.renderIfReadyAndVisible()},e.prototype.prepareFrame=function(t){var e=this.getLayer(),r=e.getSource();if(!r)return!1;var n=t.viewHints[va],i=t.viewHints[_a],o=e.getUpdateWhileAnimating(),a=e.getUpdateWhileInteracting();if(!this.dirty_&&!o&&n||!a&&i)return this.animatingOrInteracting_=!0,!0;this.animatingOrInteracting_=!1;var s=t.extent,u=t.viewState,l=u.projection,h=u.resolution,c=t.pixelRatio,p=e.getRevision(),f=e.getRenderBuffer(),d=e.getRenderOrder();void 0===d&&(d=Io);var g=u.center.slice(),y=zt(s,f*h),m=[y.slice()],v=l.getExtent();if(r.getWrapX()&&l.canWrapX()&&!Vt(v,t.extent)){var _=ge(v),b=Math.max(ge(y)/2,_);y[0]=v[0]-b,y[2]=v[2]+b,cr(g,l);var x=be(m[0],l);x[0]<v[0]&&x[2]<v[2]?m.push([x[0]+_,x[1],x[2]+_,x[3]]):x[0]>v[0]&&x[2]>v[2]&&m.push([x[0]-_,x[1],x[2]-_,x[3]])}if(!this.dirty_&&this.renderedResolution_==h&&this.renderedRevision_==p&&this.renderedRenderOrder_==d&&Vt(this.renderedExtent_,y))return this.replayGroupChanged=!1,!0;this.replayGroup_=null,this.dirty_=!1;var w,S=new Zf(Mo(h,c),y,h,c,e.getDeclutter()),T=Mr();if(T){for(var E=0,C=m.length;E<C;++E)r.loadFeatures(kr(m[E],l),h,T);w=Tr(T,l)}else for(E=0,C=m.length;E<C;++E)r.loadFeatures(m[E],h,l);var P=Lo(h,c),R=function(t){var r,n=t.getStyleFunction()||e.getStyleFunction();if(n&&(r=n(t,h)),r){var i=this.renderFeature(t,P,r,S,w);this.dirty_=this.dirty_||i}}.bind(this),O=kr(y,l),I=r.getFeaturesInExtent(O);d&&I.sort(d);for(E=0,C=I.length;E<C;++E)R(I[E]);this.renderedFeatures_=I;var L=S.finish(),M=new ld(y,h,c,r.getOverlaps(),L,e.getRenderBuffer());return this.renderedResolution_=h,this.renderedRevision_=p,this.renderedRenderOrder_=d,this.renderedExtent_=y,this.renderedCenter_=g,this.renderedProjection_=l,this.replayGroup_=M,this.hitDetectionImageData_=null,this.replayGroupChanged=!0,!0},e.prototype.renderFeature=function(t,e,r,n,i){if(!r)return!1;var o=!1;if(Array.isArray(r))for(var a=0,s=r.length;a<s;++a)o=Fo(n,t,r[a],e,this.boundHandleStyleImageChange_,i)||o;else o=Fo(n,t,r,e,this.boundHandleStyleImageChange_,i);return o},e}(fp),dd=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),gd=function(t){function e(e){var r=t.call(this,e)||this;return r.vectorRenderer_=new fd(e),r.layerImageRatio_=e.getImageRatio(),r.coordinateToVectorPixelTransform_=[1,0,0,1,0,0],r.renderedPixelToCoordinateTransform_=null,r}return dd(e,t),e.prototype.disposeInternal=function(){this.vectorRenderer_.dispose(),t.prototype.disposeInternal.call(this)},e.prototype.getFeatures=function(t){if(this.vectorRenderer_){var e=Tt(this.coordinateToVectorPixelTransform_,Tt(this.renderedPixelToCoordinateTransform_,t.slice()));return this.vectorRenderer_.getFeatures(e)}return new Promise((function(t,e){t([])}))},e.prototype.handleFontsChanged=function(){this.vectorRenderer_.handleFontsChanged()},e.prototype.prepareFrame=function(t){var e=t.pixelRatio,r=t.viewState,n=r.resolution,i=t.viewHints,o=this.vectorRenderer_,a=t.extent;1!==this.layerImageRatio_&&ve(a=a.slice(0),this.layerImageRatio_);var s=ge(a)/n,u=ce(a)/n;if(!i[va]&&!i[_a]&&!me(a)){o.useContainer(null,null,1);var l=o.context,h=T({},t,{declutterItems:[],extent:a,size:[s,u],viewState:T({},t.viewState,{rotation:0})}),c=new Wc(a,n,e,l.canvas,(function(t){o.prepareFrame(h)&&o.replayGroupChanged&&(o.clipping=!1,o.renderFrame(h,null),ko(h,null),t())}));c.addEventListener(I,function(){if(c.getState()===Co){this.image_=c;var t=c.getResolution(),n=c.getPixelRatio(),i=t*e/n;this.renderedResolution=i,this.coordinateToVectorPixelTransform_=Ct(this.coordinateToVectorPixelTransform_,s/2,u/2,1/i,-1/i,0,-r.center[0],-r.center[1])}}.bind(this)),c.load()}return this.image_&&(this.renderedPixelToCoordinateTransform_=t.pixelToCoordinateTransform.slice()),!!this.image_},e.prototype.preRender=function(){},e.prototype.postRender=function(){},e.prototype.forEachFeatureAtCoordinate=function(e,r,n,i,o){return this.vectorRenderer_?this.vectorRenderer_.forEachFeatureAtCoordinate(e,r,n,i,o):t.prototype.forEachFeatureAtCoordinate.call(this,e,r,n,i,o)},e}(gp),yd="image",md="hybrid",vd="vector",_d=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),bd={image:[wo,vo,xo,bo,So],hybrid:[wo,xo],vector:[]},xd={image:[_o],hybrid:[bo,So,_o],vector:[wo,vo,xo,bo,So,_o]},wd=function(t){function e(e){var r=t.call(this,e)||this;return r.boundHandleStyleImageChange_=r.handleStyleImageChange_.bind(r),r.dirty_=!1,r.renderedLayerRevision_,r.renderedPixelToCoordinateTransform_=null,r.renderedRotation_,r.renderTileImageQueue_={},r.tileListenerKeys_={},r.tmpTransform_=[1,0,0,1,0,0],r}return _d(e,t),e.prototype.prepareTile=function(t,e,r,n){var i,a=o(t),s=t.getState();return(s===fa&&t.hifi||s===da)&&a in this.tileListenerKeys_&&(X(this.tileListenerKeys_[a]),delete this.tileListenerKeys_[a]),s!==fa&&s!==da||(this.updateExecutorGroup_(t,e,r),this.tileImageNeedsRender_(t,e,r)&&(i=!0,n&&(this.renderTileImageQueue_[a]=t))),i},e.prototype.getTile=function(e,r,n,i){var a=i.pixelRatio,s=i.viewState,u=s.resolution,l=s.projection,h=this.getLayer(),c=h.getSource().getTile(e,r,n,a,l);if(c.getState()<fa){c.wantedResolution=u;var p=o(c);if(!(p in this.tileListenerKeys_)){var f=W(c,I,this.prepareTile.bind(this,c,a,l,!0));this.tileListenerKeys_[p]=f}}else{var d=i.viewHints;!!(d[va]||d[_a])&&c.wantedResolution||(c.wantedResolution=u),this.prepareTile(c,a,l,!1)&&h.getRenderMode()!==vd&&this.renderTileImage_(c,i)}return t.prototype.getTile.call(this,e,r,n,i)},e.prototype.isDrawableTile=function(e){var r=this.getLayer();return t.prototype.isDrawableTile.call(this,e)&&(r.getRenderMode()===vd?o(r)in e.executorGroups:e.hasContext(r))},e.prototype.getTileImage=function(t){return t.getImage(this.getLayer())},e.prototype.prepareFrame=function(e){var r=this.getLayer().getRevision();return this.renderedLayerRevision_!=r&&(this.renderedTiles.length=0),this.renderedLayerRevision_=r,t.prototype.prepareFrame.call(this,e)},e.prototype.updateExecutorGroup_=function(t,e,r){var n=this.getLayer(),i=n.getRevision(),a=n.getRenderOrder()||null,s=t.wantedResolution,u=t.getReplayState(n);if(u.dirty||u.renderedResolution!==s||u.renderedRevision!=i||u.renderedRenderOrder!=a||u.renderedZ!==t.sourceZ){var l=n.getSource(),h=l.getTileGrid(),c=l.getTileGridForProjection(r).getTileCoordExtent(t.wrappedTileCoord),p=l.getSourceTiles(e,r,t),f=o(n);delete t.hitDetectionImageData[f],t.executorGroups[f]=[];for(var d=function(r,i){var o=p[r];if(o.getState()!=fa)return"continue";var d=o.tileCoord,y=h.getTileCoordExtent(d),m=pe(c,y),v=$t(y,m)?null:zt(m,n.getRenderBuffer()*s,g.tmpExtent);u.dirty=!1;var _=new Zf(0,m,s,e,n.getDeclutter()),b=Lo(s,e),x=function(t){var e,r=t.getStyleFunction()||n.getStyleFunction();if(r&&(e=r(t,s)),e){var i=this.renderFeature(t,b,e,_);this.dirty_=this.dirty_||i,u.dirty=u.dirty||i}},w=o.getFeatures();a&&a!==u.renderedRenderOrder&&w.sort(a);for(var S=0,T=w.length;S<T;++S){var E=w[S];v&&!ye(v,E.getGeometry().getExtent())||x.call(g,E)}var C=_.finish(),P=n.getRenderMode()!==vd&&n.getDeclutter()&&1===p.length?null:m,R=new ld(P,s,e,l.getOverlaps(),C,n.getRenderBuffer());t.executorGroups[f].push(R)},g=this,y=0,m=p.length;y<m;++y)d(y);u.renderedRevision=i,u.renderedZ=t.sourceZ,u.renderedRenderOrder=a,u.renderedResolution=s}},e.prototype.forEachFeatureAtCoordinate=function(t,e,r,n,i){var a=e.viewState.resolution,s=e.viewState.rotation;r=null==r?0:r;var u,l,h,c=this.getLayer(),p=c.getDeclutter(),f=c.getSource().getTileGridForProjection(e.viewState.projection),d={},g=this.renderedTiles,y=function(){var e=g[l],h=Yt(f.getTileCoordExtent(e.wrappedTileCoord),t);if(!p&&!h)return"continue";for(var y=e.executorGroups[o(c)],m=0,v=y.length;m<v;++m){var _=y[m];u=u||_.forEachFeatureAtCoordinate(t,a,s,r,(function(t){if(h||i&&-1!==i.indexOf(t)){var e=t.getId();if(void 0===e&&(e=o(t)),!(e in d))return d[e]=!0,n(t,c)}}),c.getDeclutter()?i:null)}};for(l=0,h=g.length;l<h;++l)y();return u},e.prototype.getFeatures=function(t){return new Promise(function(e,r){for(var n,i=this.getLayer(),a=o(i),s=i.getSource(),u=this.renderedProjection,l=u.getExtent(),h=this.renderedResolution,c=s.getTileGridForProjection(u),p=Tt(this.renderedPixelToCoordinateTransform_,t.slice()),f=c.getTileCoordForCoordAndResolution(p,h),d=0,g=this.renderedTiles.length;d<g;++d)if(f.toString()===this.renderedTiles[d].tileCoord.toString()){if((n=this.renderedTiles[d]).getState()===fa&&n.hifi){var y=c.getTileCoordExtent(n.tileCoord);s.getWrapX()&&u.canWrapX()&&!Vt(l,y)&&cr(p,u);break}n=void 0}if(!n||n.loadingSourceTiles>0)e([]);else{var m=fe(c.getTileCoordExtent(n.wrappedTileCoord)),v=[(p[0]-m[0])/h,(m[1]-p[1])/h],_=n.getSourceTiles().reduce((function(t,e){return t.concat(e.getFeatures())}),[]),b=n.hitDetectionImageData[a];if(!b&&!this.animatingOrInteracting_){var x=za(c.getTileSize(c.getZForResolution(h))),w=[x[0]/2,x[1]/2],S=this.renderedRotation_;b=hd(x,[this.getRenderTransform(c.getTileCoordCenter(n.wrappedTileCoord),h,0,.5,w[0],w[1],0)],_,i.getStyleFunction(),c.getTileCoordExtent(n.wrappedTileCoord),n.getReplayState(i).renderedResolution,S),n.hitDetectionImageData[a]=b}e(cd(v,_,b))}}.bind(this))},e.prototype.handleFontsChanged=function(){E(this.renderTileImageQueue_);var t=this.getLayer();t.getVisible()&&void 0!==this.renderedLayerRevision_&&t.changed()},e.prototype.handleStyleImageChange_=function(t){this.renderIfReadyAndVisible()},e.prototype.renderFrame=function(e,r){var n=e.viewHints,i=!(n[va]||n[_a]);this.renderQueuedTileImages_(i,e),t.prototype.renderFrame.call(this,e,r),this.renderedPixelToCoordinateTransform_=e.pixelToCoordinateTransform.slice(),this.renderedRotation_=e.viewState.rotation;var a=this.getLayer(),s=a.getRenderMode();if(s===yd)return this.container;var u=a.getSource(),l=e.usedTiles[o(u)];for(var h in this.renderTileImageQueue_)l&&h in l||delete this.renderTileImageQueue_[h];for(var c=this.context,p=a.getDeclutter()?{}:null,f=xd[s],d=e.pixelRatio,g=e.viewState,y=g.center,m=g.resolution,v=g.rotation,_=e.size,b=Math.round(_[0]*d),x=Math.round(_[1]*d),w=this.renderedTiles,S=u.getTileGridForProjection(e.viewState.projection),T=[],E=[],C=w.length-1;C>=0;--C)for(var P=w[C],R=P.tileCoord,O=S.getTileCoordExtent(P.wrappedTileCoord),I=S.getTileCoordExtent(R,this.tmpExtent)[0]-O[0],L=wt(Et(this.inversePixelTransform.slice(),1/d,1/d),this.getRenderTransform(y,m,v,d,b,x,I)),M=P.executorGroups[o(a)],F=!1,A=0,k=M.length;A<k;++A){var N=M[A];if(N.hasExecutors(f)){var j=P.tileCoord[0],G=void 0;if(!p&&!F){G=N.getClipCoords(L),c.save();for(var D=0,z=T.length;D<z;++D){var U=T[D];j<E[D]&&(c.beginPath(),c.moveTo(G[0],G[1]),c.lineTo(G[2],G[3]),c.lineTo(G[4],G[5]),c.lineTo(G[6],G[7]),c.moveTo(U[6],U[7]),c.lineTo(U[4],U[5]),c.lineTo(U[2],U[3]),c.lineTo(U[0],U[1]),c.clip())}}N.execute(c,1,L,v,i,f,p),p||F||(c.restore(),T.push(G),E.push(j),F=!0)}}p&&ud(p,c,v,e.layerStatesArray[e.layerIndex].opacity,i,e.declutterItems);return this.container},e.prototype.renderQueuedTileImages_=function(t,e){for(var r in this.renderTileImageQueue_){if(!t&&Date.now()-e.time>8){e.animate=!0;break}var n=this.renderTileImageQueue_[r];delete this.renderTileImageQueue_[r],this.renderTileImage_(n,e)}},e.prototype.renderFeature=function(t,e,r,n){if(!r)return!1;var i=!1;if(Array.isArray(r))for(var o=0,a=r.length;o<a;++o)i=Fo(n,t,r[o],e,this.boundHandleStyleImageChange_)||i;else i=Fo(n,t,r,e,this.boundHandleStyleImageChange_);return i},e.prototype.tileImageNeedsRender_=function(t,e,r){var n=this.getLayer(),i=t.getReplayState(n),o=n.getRevision(),a=t.sourceZ,s=t.wantedResolution;return i.renderedTileResolution!==s||i.renderedTileRevision!==o||i.renderedTileZ!==a},e.prototype.renderTileImage_=function(t,e){var r=this.getLayer(),n=t.getReplayState(r),i=r.getRevision(),a=t.executorGroups[o(r)];n.renderedTileRevision=i,n.renderedTileZ=t.sourceZ;var s=t.wrappedTileCoord,u=s[0],l=r.getSource(),h=e.pixelRatio,c=e.viewState.projection,p=l.getTileGridForProjection(c),f=p.getResolution(t.tileCoord[0]),d=e.pixelRatio/t.wantedResolution*f,g=p.getResolution(u),y=t.getContext(r);h=Math.max(h,d/h);var m=l.getTilePixelSize(u,h,c);y.canvas.width=m[0],y.canvas.height=m[1];var v=h/d;if(1!==v){var _=xt(this.tmpTransform_);Et(_,v,v),y.setTransform.apply(y,_)}var b=p.getTileCoordExtent(s,this.tmpExtent),x=d/g,w=xt(this.tmpTransform_);Et(w,x,-x),function(t,e,r){wt(t,St(bt,1,0,0,1,e,r))}(w,-b[0],-b[3]);for(var S=0,T=a.length;S<T;++S){a[S].execute(y,v,w,0,!0,bd[r.getRenderMode()])}n.renderedTileResolution=t.wantedResolution},e}(Tp);function Sd(t,e,r,n,i,o,a){var s,u,l=(r-e)/n;if(1===l)s=e;else if(2===l)s=e,u=i;else if(0!==l){for(var h=t[e],c=t[e+1],p=0,d=[0],g=e+n;g<r;g+=n){var y=t[g],m=t[g+1];p+=Math.sqrt((y-h)*(y-h)+(m-c)*(m-c)),d.push(p),h=y,c=m}var v=i*p,_=function(t,e,r){for(var n,i,o=r||f,a=0,s=t.length,u=!1;a<s;)(i=+o(t[n=a+(s-a>>1)],e))<0?a=n+1:(s=n,u=!i);return u?a:~a}(d,v);_<0?(u=(v-d[-_-2])/(d[-_-1]-d[-_-2]),s=e+(-_-2)*n):s=e+_*n}var b=a>1?a:2,x=o||new Array(b);for(g=0;g<b;++g)x[g]=void 0===s?NaN:void 0===u?t[s+g]:Ie(t[s+g],t[s+n+g],u);return x}function Td(t,e,r,n,i,o){if(r==e)return null;var a;if(i<t[e+n-1])return o?((a=t.slice(e,e+n))[n-1]=i,a):null;if(t[r-1]<i)return o?((a=t.slice(r-n,r))[n-1]=i,a):null;if(i==t[e+n-1])return t.slice(e,e+n);for(var s=e/n,u=r/n;s<u;){var l=s+u>>1;i<t[(l+1)*n-1]?u=l:s=l+1}var h=t[s*n-1];if(i==h)return t.slice((s-1)*n,(s-1)*n+n);var c=(i-h)/(t[(s+1)*n-1]-h);a=[];for(var p=0;p<n-1;++p)a.push(Ie(t[(s-1)*n+p],t[s*n+p],c));return a.push(i),a}var Ed=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Cd=function(t){function e(e,r){var n=t.call(this)||this;return n.flatMidpoint_=null,n.flatMidpointRevision_=-1,n.maxDelta_=-1,n.maxDeltaRevision_=-1,void 0===r||Array.isArray(e[0])?n.setCoordinates(e,r):n.setFlatCoordinates(r,e),n}return Ed(e,t),e.prototype.appendCoordinate=function(t){this.flatCoordinates?m(this.flatCoordinates,t):this.flatCoordinates=t.slice(),this.changed()},e.prototype.clone=function(){return new e(this.flatCoordinates.slice(),this.layout)},e.prototype.closestPointXY=function(t,e,r,n){return n<Bt(this.getExtent(),t,e)?n:(this.maxDeltaRevision_!=this.getRevision()&&(this.maxDelta_=Math.sqrt(Zr(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,0)),this.maxDeltaRevision_=this.getRevision()),Hr(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,this.maxDelta_,!1,t,e,r,n))},e.prototype.forEachSegment=function(t){return xn(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,t)},e.prototype.getCoordinateAtM=function(t,e){if(this.layout!=dt&&this.layout!=gt)return null;var r=void 0!==e&&e;return Td(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,t,r)},e.prototype.getCoordinates=function(){return sn(this.flatCoordinates,0,this.flatCoordinates.length,this.stride)},e.prototype.getCoordinateAt=function(t,e){return Sd(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,t,e,this.stride)},e.prototype.getLength=function(){return Hf(this.flatCoordinates,0,this.flatCoordinates.length,this.stride)},e.prototype.getFlatMidpoint=function(){return this.flatMidpointRevision_!=this.getRevision()&&(this.flatMidpoint_=this.getCoordinateAt(.5,this.flatMidpoint_),this.flatMidpointRevision_=this.getRevision()),this.flatMidpoint_},e.prototype.getSimplifiedGeometryInternal=function(t){var r=[];return r.length=en(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,t,r,0),new e(r,pt)},e.prototype.getType=function(){return yt.LINE_STRING},e.prototype.intersectsExtent=function(t){return wn(this.flatCoordinates,0,this.flatCoordinates.length,this.stride,t)},e.prototype.setCoordinates=function(t,e){this.setLayout(e,t,1),this.flatCoordinates||(this.flatCoordinates=[]),this.flatCoordinates.length=Qr(this.flatCoordinates,0,t,this.stride),this.changed()},e}(qr),Pd=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Rd=function(t){function e(e){return t.call(this,e)||this}return Pd(e,t),e.prototype.createRenderer=function(){return new fd(this)},e}(xf);function Od(t,e,r){for(var n,i,o,a,s,u,l=[],h=t(0),c=t(1),p=e(h),f=e(c),d=[c,h],g=[f,p],y=[1,0],m={},v=1e5;--v>0&&y.length>0;)o=y.pop(),h=d.pop(),p=g.pop(),(u=o.toString())in m||(l.push(p[0],p[1]),m[u]=!0),a=y.pop(),c=d.pop(),f=g.pop(),Ee((i=e(n=t(s=(o+a)/2)))[0],i[1],p[0],p[1],f[0],f[1])<r?(l.push(f[0],f[1]),m[u=a.toString()]=!0):(y.push(a,s,s,o),g.push(f,i,i,p),d.push(c,n,n,h));return l}var Id=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ld=new nh({color:"rgba(0,0,0,0.2)"}),Md=[90,45,30,20,10,5,2,1,.5,.2,.1,.05,.01,.005,.002,.001],Fd=function(t){function e(e){var r=this,n=e||{},i=T({updateWhileAnimating:!0,updateWhileInteracting:!0,renderBuffer:0},n);return delete i.maxLines,delete i.strokeStyle,delete i.targetSize,delete i.showLabels,delete i.lonLabelFormatter,delete i.latLabelFormatter,delete i.lonLabelPosition,delete i.latLabelPosition,delete i.lonLabelStyle,delete i.latLabelStyle,delete i.intervals,(r=t.call(this,i)||this).projection_=null,r.maxLat_=1/0,r.maxLon_=1/0,r.minLat_=-1/0,r.minLon_=-1/0,r.maxX_=1/0,r.maxY_=1/0,r.minX_=-1/0,r.minY_=-1/0,r.targetSize_=void 0!==n.targetSize?n.targetSize:100,r.maxLines_=void 0!==n.maxLines?n.maxLines:100,r.meridians_=[],r.parallels_=[],r.strokeStyle_=void 0!==n.strokeStyle?n.strokeStyle:Ld,r.fromLonLatTransform_=void 0,r.toLonLatTransform_=void 0,r.projectionCenterLonLat_=null,r.bottomLeft_=null,r.bottomRight_=null,r.topLeft_=null,r.topRight_=null,r.meridiansLabels_=null,r.parallelsLabels_=null,n.showLabels&&(r.lonLabelFormatter_=null==n.lonLabelFormatter?rr.bind(r,"EW"):n.lonLabelFormatter,r.latLabelFormatter_=null==n.latLabelFormatter?rr.bind(r,"NS"):n.latLabelFormatter,r.lonLabelPosition_=null==n.lonLabelPosition?0:n.lonLabelPosition,r.latLabelPosition_=null==n.latLabelPosition?1:n.latLabelPosition,r.lonLabelStyleBase_=new lh({text:void 0!==n.lonLabelStyle?n.lonLabelStyle.clone():new ph({font:"12px Calibri,sans-serif",textBaseline:"bottom",fill:new zl({color:"rgba(0,0,0,1)"}),stroke:new nh({color:"rgba(255,255,255,1)",width:3})})}),r.lonLabelStyle_=function(t){var e=t.get("graticule_label");return this.lonLabelStyleBase_.getText().setText(e),this.lonLabelStyleBase_}.bind(r),r.latLabelStyleBase_=new lh({text:void 0!==n.latLabelStyle?n.latLabelStyle.clone():new ph({font:"12px Calibri,sans-serif",textAlign:"right",fill:new zl({color:"rgba(0,0,0,1)"}),stroke:new nh({color:"rgba(255,255,255,1)",width:3})})}),r.latLabelStyle_=function(t){var e=t.get("graticule_label");return this.latLabelStyleBase_.getText().setText(e),this.latLabelStyleBase_}.bind(r),r.meridiansLabels_=[],r.parallelsLabels_=[],r.addEventListener(xi,r.drawLabels_.bind(r))),r.intervals_=void 0!==n.intervals?n.intervals:Md,r.setSource(new cc({loader:r.loaderFunction.bind(r),strategy:r.strategyFunction.bind(r),features:new ut,overlaps:!1,useSpatialIndex:!1,wrapX:n.wrapX})),r.featurePool_=[],r.lineStyle_=new lh({stroke:r.strokeStyle_}),r.loadedExtent_=null,r.renderedExtent_=null,r.setRenderOrder(null),r}return Id(e,t),e.prototype.strategyFunction=function(t,e){var r,n,i,o=t.slice();return this.projection_&&this.getSource().getWrapX()&&be(o,this.projection_),this.loadedExtent_&&(r=this.loadedExtent_,n=o,i=e,Math.abs(r[0]-n[0])<i&&Math.abs(r[2]-n[2])<i&&Math.abs(r[1]-n[1])<i&&Math.abs(r[3]-n[3])<i?o=this.loadedExtent_.slice():this.getSource().removeLoadedExtent(this.loadedExtent_)),[o]},e.prototype.loaderFunction=function(t,e,r){this.loadedExtent_=t;var n=this.getSource(),i=pe(this.getExtent()||[-1/0,-1/0,1/0,1/0],t);if(!(this.renderedExtent_&&$t(this.renderedExtent_,i)||(this.renderedExtent_=i,me(i)))){var o=ue(i),a=e*e/4;(!this.projection_||!Sr(this.projection_,r))&&this.updateProjectionInfo_(r),this.createGraticule_(i,o,e,a);var s,u=this.meridians_.length+this.parallels_.length;for(this.meridiansLabels_&&(u+=this.meridians_.length),this.parallelsLabels_&&(u+=this.parallels_.length);u>this.featurePool_.length;)s=new ct,this.featurePool_.push(s);var l=n.getFeaturesCollection();l.clear();var h,c,p=0;for(h=0,c=this.meridians_.length;h<c;++h)(s=this.featurePool_[p++]).setGeometry(this.meridians_[h]),s.setStyle(this.lineStyle_),l.push(s);for(h=0,c=this.parallels_.length;h<c;++h)(s=this.featurePool_[p++]).setGeometry(this.parallels_[h]),s.setStyle(this.lineStyle_),l.push(s)}},e.prototype.addMeridian_=function(t,e,r,n,i,o){var a=this.getMeridian_(t,e,r,n,o);if(ye(a.getExtent(),i)){if(this.meridiansLabels_){var s=this.lonLabelFormatter_(t);o in this.meridiansLabels_?this.meridiansLabels_[o].text=s:this.meridiansLabels_[o]={geom:new gn([]),text:s}}this.meridians_[o++]=a}return o},e.prototype.addParallel_=function(t,e,r,n,i,o){var a=this.getParallel_(t,e,r,n,o);if(ye(a.getExtent(),i)){if(this.parallelsLabels_){var s=this.latLabelFormatter_(t);o in this.parallelsLabels_?this.parallelsLabels_[o].text=s:this.parallelsLabels_[o]={geom:new gn([]),text:s}}this.parallels_[o++]=a}return o},e.prototype.drawLabels_=function(t){var e=t.frameState.viewState.rotation,r=t.frameState.extent,n=ue(r),i=r;if(e){var o=ge(r),a=ce(r),s=Math.abs(Math.cos(e)),u=Math.abs(Math.sin(e)),l=(u*a-s*o)/(u*u-s*s),h=(u*o-s*a)/(u*u-s*s);i=[n[0]-l/2,n[1]-h/2,n[0]+l/2,n[1]+h/2]}var c=0,p=0,f=this.latLabelPosition_<.5,d=this.projection_.getExtent(),g=ge(d);this.getSource().getWrapX()&&this.projection_.canWrapX()&&!Vt(d,r)&&(c=Math.floor((r[0]-d[0])/g),p=Math.ceil((r[2]-d[2])/g),f=f!==Math.abs(e)>Math.PI/2);for(var y=Ao(t),m=c;m<=p;++m){var v=this.meridians_.length+this.parallels_.length,_=void 0,b=void 0,x=void 0,w=void 0;if(this.meridiansLabels_)for(b=0,x=this.meridiansLabels_.length;b<x;++b){var S=this.meridians_[b];if(e||0!==m)(T=S.clone()).translate(m*g,0),T.rotate(-e,n),(w=this.getMeridianPoint_(T,i,b)).rotate(e,n);else w=this.getMeridianPoint_(S,r,b);(_=this.featurePool_[v++]).setGeometry(w),_.set("graticule_label",this.meridiansLabels_[b].text),y.drawFeature(_,this.lonLabelStyle_(_))}if(this.parallelsLabels_&&(m===c&&f||m===p&&!f))for(b=0,x=this.parallels_.length;b<x;++b){var T;S=this.parallels_[b];if(e||0!==m)(T=S.clone()).translate(m*g,0),T.rotate(-e,n),(w=this.getParallelPoint_(T,i,b)).rotate(e,n);else w=this.getParallelPoint_(S,r,b);(_=this.featurePool_[v++]).setGeometry(w),_.set("graticule_label",this.parallelsLabels_[b].text),y.drawFeature(_,this.latLabelStyle_(_))}}},e.prototype.createGraticule_=function(t,e,r,n){var i=this.getInterval_(r);if(-1==i)return this.meridians_.length=0,this.parallels_.length=0,this.meridiansLabels_&&(this.meridiansLabels_.length=0),void(this.parallelsLabels_&&(this.parallelsLabels_.length=0));var o=!1,a=this.projection_.getExtent(),s=ge(a);this.getSource().getWrapX()&&this.projection_.canWrapX()&&!Vt(a,t)&&(ge(t)>=s?(t[0]=a[0],t[2]=a[2]):o=!0);var u=[we(e[0],this.minX_,this.maxX_),we(e[1],this.minY_,this.maxY_)],l=this.toLonLatTransform_(u);isNaN(l[1])&&(l[1]=Math.abs(this.maxLat_)>=Math.abs(this.minLat_)?this.maxLat_:this.minLat_);var h,c,p,f,d=we(l[0],this.minLon_,this.maxLon_),g=we(l[1],this.minLat_,this.maxLat_),y=this.maxLines_,m=t;o||(m=[we(t[0],this.minX_,this.maxX_),we(t[1],this.minY_,this.maxY_),we(t[2],this.minX_,this.maxX_),we(t[3],this.minY_,this.maxY_)]);var v=_e(m,this.toLonLatTransform_,void 0,8),_=v[3],b=v[2],x=v[1],w=v[0];if(o||(Yt(m,this.bottomLeft_)&&(w=this.minLon_,x=this.minLat_),Yt(m,this.bottomRight_)&&(b=this.maxLon_,x=this.minLat_),Yt(m,this.topLeft_)&&(w=this.minLon_,_=this.maxLat_),Yt(m,this.topRight_)&&(b=this.maxLon_,_=this.maxLat_),_=we(_,g,this.maxLat_),b=we(b,d,this.maxLon_),x=we(x,this.minLat_,g),w=we(w,this.minLon_,d)),f=we(d=Math.floor(d/i)*i,this.minLon_,this.maxLon_),c=this.addMeridian_(f,x,_,n,t,0),h=0,o)for(;(f-=i)>=w&&h++<y;)c=this.addMeridian_(f,x,_,n,t,c);else for(;f!=this.minLon_&&h++<y;)f=Math.max(f-i,this.minLon_),c=this.addMeridian_(f,x,_,n,t,c);if(f=we(d,this.minLon_,this.maxLon_),h=0,o)for(;(f+=i)<=b&&h++<y;)c=this.addMeridian_(f,x,_,n,t,c);else for(;f!=this.maxLon_&&h++<y;)f=Math.min(f+i,this.maxLon_),c=this.addMeridian_(f,x,_,n,t,c);for(this.meridians_.length=c,this.meridiansLabels_&&(this.meridiansLabels_.length=c),p=we(g=Math.floor(g/i)*i,this.minLat_,this.maxLat_),c=this.addParallel_(p,w,b,n,t,0),h=0;p!=this.minLat_&&h++<y;)p=Math.max(p-i,this.minLat_),c=this.addParallel_(p,w,b,n,t,c);for(p=we(g,this.minLat_,this.maxLat_),h=0;p!=this.maxLat_&&h++<y;)p=Math.min(p+i,this.maxLat_),c=this.addParallel_(p,w,b,n,t,c);this.parallels_.length=c,this.parallelsLabels_&&(this.parallelsLabels_.length=c)},e.prototype.getInterval_=function(t){for(var e=this.projectionCenterLonLat_[0],r=this.projectionCenterLonLat_[1],n=-1,i=Math.pow(this.targetSize_*t,2),o=[],a=[],s=0,u=this.intervals_.length;s<u;++s){var l=we(this.intervals_[s]/2,0,90),h=we(r,-90+l,90-l);if(o[0]=e-l,o[1]=h-l,a[0]=e+l,a[1]=h+l,this.fromLonLatTransform_(o,o),this.fromLonLatTransform_(a,a),Math.pow(a[0]-o[0],2)+Math.pow(a[1]-o[1],2)<=i)break;n=this.intervals_[s]}return n},e.prototype.getMeridian_=function(t,e,r,n,i){var o=function(t,e,r,n,i){return Od((function(n){return[t,e+(r-e)*n]}),Er(yr("EPSG:4326"),n),i)}(t,e,r,this.projection_,n),a=this.meridians_[i];return a?(a.setFlatCoordinates(pt,o),a.changed()):(a=new Cd(o,pt),this.meridians_[i]=a),a},e.prototype.getMeridianPoint_=function(t,e,r){var n=t.getFlatCoordinates(),i=1,o=n.length-1;n[i]>n[o]&&(i=o,o=1);var a=Math.max(e[1],n[i]),s=Math.min(e[3],n[o]),u=we(e[1]+Math.abs(e[1]-e[3])*this.lonLabelPosition_,a,s),l=[n[i-1]+(n[o-1]-n[i-1])*(u-n[i])/(n[o]-n[i]),u],h=this.meridiansLabels_[r].geom;return h.setCoordinates(l),h},e.prototype.getMeridians=function(){return this.meridians_},e.prototype.getParallel_=function(t,e,r,n,i){var o=function(t,e,r,n,i){return Od((function(n){return[e+(r-e)*n,t]}),Er(yr("EPSG:4326"),n),i)}(t,e,r,this.projection_,n),a=this.parallels_[i];return a?(a.setFlatCoordinates(pt,o),a.changed()):a=new Cd(o,pt),a},e.prototype.getParallelPoint_=function(t,e,r){var n=t.getFlatCoordinates(),i=0,o=n.length-2;n[i]>n[o]&&(i=o,o=0);var a=Math.max(e[0],n[i]),s=Math.min(e[2],n[o]),u=we(e[0]+Math.abs(e[0]-e[2])*this.latLabelPosition_,a,s),l=[u,n[i+1]+(n[o+1]-n[i+1])*(u-n[i])/(n[o]-n[i])],h=this.parallelsLabels_[r].geom;return h.setCoordinates(l),h},e.prototype.getParallels=function(){return this.parallels_},e.prototype.updateProjectionInfo_=function(t){var e=yr("EPSG:4326"),r=t.getWorldExtent();this.maxLat_=r[3],this.maxLon_=r[2],this.minLat_=r[1],this.minLon_=r[0];var n=Er(t,e);if(this.minLon_<this.maxLon_)this.toLonLatTransform_=n;else{var i=this.minLon_+this.maxLon_/2;this.maxLon_+=360,this.toLonLatTransform_=function(t,e,r){for(var o=r||2,a=n(t,e,o),s=0,u=a.length;s<u;s+=o)a[s]<i&&(a[s]+=360);return a}}this.fromLonLatTransform_=Er(e,t);var o=_e([this.minLon_,this.minLat_,this.maxLon_,this.maxLat_],this.fromLonLatTransform_,void 0,8);this.minX_=o[0],this.maxX_=o[2],this.minY_=o[1],this.maxY_=o[3],this.bottomLeft_=this.fromLonLatTransform_([this.minLon_,this.minLat_]),this.bottomRight_=this.fromLonLatTransform_([this.maxLon_,this.minLat_]),this.topLeft_=this.fromLonLatTransform_([this.minLon_,this.maxLat_]),this.topRight_=this.fromLonLatTransform_([this.maxLon_,this.maxLat_]),this.projectionCenterLonLat_=this.toLonLatTransform_(ue(t.getExtent())),isNaN(this.projectionCenterLonLat_[1])&&(this.projectionCenterLonLat_[1]=Math.abs(this.maxLat_)>=Math.abs(this.minLat_)?this.maxLat_:this.minLat_),this.projection_=t},e}(Rd),Ad=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),kd="blur",Nd="gradient",jd="radius",Gd=["#00f","#0ff","#0f0","#ff0","#f00"];var Dd=function(t){function e(e){var r=this,n=e||{},i=T({},n);delete i.gradient,delete i.radius,delete i.blur,delete i.weight,(r=t.call(this,i)||this).gradient_=null,r.addEventListener(et(Nd),r.handleGradientChanged_),r.setGradient(n.gradient?n.gradient:Gd),r.setBlur(void 0!==n.blur?n.blur:15),r.setRadius(void 0!==n.radius?n.radius:8);var o=n.weight?n.weight:"weight";return r.weightFunction_="string"==typeof o?function(t){return t.get(o)}:o,r.setRenderOrder(null),r}return Ad(e,t),e.prototype.getBlur=function(){return this.get(kd)},e.prototype.getGradient=function(){return this.get(Nd)},e.prototype.getRadius=function(){return this.get(jd)},e.prototype.handleGradientChanged_=function(){this.gradient_=function(t){for(var e=Bi(1,256),r=e.createLinearGradient(0,0,1,256),n=1/(t.length-1),i=0,o=t.length;i<o;++i)r.addColorStop(i*n,t[i]);return e.fillStyle=r,e.fillRect(0,0,1,256),e.canvas}(this.getGradient())},e.prototype.setBlur=function(t){this.set(kd,t)},e.prototype.setGradient=function(t){this.set(Nd,t)},e.prototype.setRadius=function(t){this.set(jd,t)},e.prototype.createRenderer=function(){return new Of(this,{attributes:[{name:"weight",callback:function(t){var e=this.weightFunction_(t);return void 0!==e?we(e,0,1):1}.bind(this)}],vertexShader:"\n        precision mediump float;\n        uniform mat4 u_projectionMatrix;\n        uniform mat4 u_offsetScaleMatrix;\n        uniform float u_size;\n        attribute vec2 a_position;\n        attribute float a_index;\n        attribute float a_weight;\n\n        varying vec2 v_texCoord;\n        varying float v_weight;\n\n        void main(void) {\n          mat4 offsetMatrix = u_offsetScaleMatrix;\n          float offsetX = a_index == 0.0 || a_index == 3.0 ? -u_size / 2.0 : u_size / 2.0;\n          float offsetY = a_index == 0.0 || a_index == 1.0 ? -u_size / 2.0 : u_size / 2.0;\n          vec4 offsets = offsetMatrix * vec4(offsetX, offsetY, 0.0, 0.0);\n          gl_Position = u_projectionMatrix * vec4(a_position, 0.0, 1.0) + offsets;\n          float u = a_index == 0.0 || a_index == 3.0 ? 0.0 : 1.0;\n          float v = a_index == 0.0 || a_index == 1.0 ? 0.0 : 1.0;\n          v_texCoord = vec2(u, v);\n          v_weight = a_weight;\n        }",fragmentShader:"\n        precision mediump float;\n        uniform float u_blurSlope;\n\n        varying vec2 v_texCoord;\n        varying float v_weight;\n\n        void main(void) {\n          vec2 texCoord = v_texCoord * 2.0 - vec2(1.0, 1.0);\n          float sqRadius = texCoord.x * texCoord.x + texCoord.y * texCoord.y;\n          float value = (1.0 - sqrt(sqRadius)) * u_blurSlope;\n          float alpha = smoothstep(0.0, 1.0, value) * v_weight;\n          gl_FragColor = vec4(alpha, alpha, alpha, alpha);\n        }",hitVertexShader:"\n        precision mediump float;\n        uniform mat4 u_projectionMatrix;\n        uniform mat4 u_offsetScaleMatrix;\n        uniform float u_size;\n        attribute vec2 a_position;\n        attribute float a_index;\n        attribute float a_weight;\n        attribute vec4 a_hitColor;\n\n        varying vec2 v_texCoord;\n        varying float v_weight;\n        varying vec4 v_hitColor;\n\n        void main(void) {\n          mat4 offsetMatrix = u_offsetScaleMatrix;\n          float offsetX = a_index == 0.0 || a_index == 3.0 ? -u_size / 2.0 : u_size / 2.0;\n          float offsetY = a_index == 0.0 || a_index == 1.0 ? -u_size / 2.0 : u_size / 2.0;\n          vec4 offsets = offsetMatrix * vec4(offsetX, offsetY, 0.0, 0.0);\n          gl_Position = u_projectionMatrix * vec4(a_position, 0.0, 1.0) + offsets;\n          float u = a_index == 0.0 || a_index == 3.0 ? 0.0 : 1.0;\n          float v = a_index == 0.0 || a_index == 1.0 ? 0.0 : 1.0;\n          v_texCoord = vec2(u, v);\n          v_hitColor = a_hitColor;\n          v_weight = a_weight;\n        }",hitFragmentShader:"\n        precision mediump float;\n        uniform float u_blurSlope;\n\n        varying vec2 v_texCoord;\n        varying float v_weight;\n        varying vec4 v_hitColor;\n\n        void main(void) {\n          vec2 texCoord = v_texCoord * 2.0 - vec2(1.0, 1.0);\n          float sqRadius = texCoord.x * texCoord.x + texCoord.y * texCoord.y;\n          float value = (1.0 - sqrt(sqRadius)) * u_blurSlope;\n          float alpha = smoothstep(0.0, 1.0, value) * v_weight;\n          if (alpha < 0.05) {\n            discard;\n          }\n\n          gl_FragColor = v_hitColor;\n        }",uniforms:{u_size:function(){return 2*(this.get(jd)+this.get(kd))}.bind(this),u_blurSlope:function(){return this.get(jd)/Math.max(1,this.get(kd))}.bind(this)},postProcesses:[{fragmentShader:"\n            precision mediump float;\n\n            uniform sampler2D u_image;\n            uniform sampler2D u_gradientTexture;\n\n            varying vec2 v_texCoord;\n\n            void main() {\n              vec4 color = texture2D(u_image, v_texCoord);\n              gl_FragColor.a = color.a;\n              gl_FragColor.rgb = texture2D(u_gradientTexture, vec2(0.5, color.a)).rgb;\n              gl_FragColor.rgb *= gl_FragColor.a;\n            }",uniforms:{u_gradientTexture:function(){return this.gradient_}.bind(this)}}]})},e}(Rd),zd=function(){function t(){this.dataProjection=null,this.defaultFeatureProjection=null}return t.prototype.getReadOptions=function(t,e){var r;if(e){var n=e.dataProjection?yr(e.dataProjection):this.readProjection(t);e.extent&&n&&n.getUnits()===_t.TILE_PIXELS&&(n=yr(n)).setWorldExtent(e.extent),r={dataProjection:n,featureProjection:e.featureProjection}}return this.adaptOptions(r)},t.prototype.adaptOptions=function(t){return T({dataProjection:this.dataProjection,featureProjection:this.defaultFeatureProjection},t)},t.prototype.getType=function(){return n()},t.prototype.readFeature=function(t,e){return n()},t.prototype.readFeatures=function(t,e){return n()},t.prototype.readGeometry=function(t,e){return n()},t.prototype.readProjection=function(t){return n()},t.prototype.writeFeature=function(t,e){return n()},t.prototype.writeFeatures=function(t,e){return n()},t.prototype.writeGeometry=function(t,e){return n()},t}();function Ud(t,e,r){var n,i=r?yr(r.featureProjection):null,o=r?yr(r.dataProjection):null;if(n=i&&o&&!Sr(i,o)?(e?t.clone():t).transform(e?i:o,e?o:i):t,e&&r&&void 0!==r.decimals){var a=Math.pow(10,r.decimals);n===t&&(n=t.clone()),n.applyTransform((function(t){for(var e=0,r=t.length;e<r;++e)t[e]=Math.round(t[e]*a)/a;return t}))}return n}function Bd(t,e){var r=e?yr(e.featureProjection):null,n=e?yr(e.dataProjection):null;return r&&n&&!Sr(r,n)?Pr(t,n,r):t}var Yd=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Vd=function(t){function e(e,r,n){var i=t.call(this)||this;if(i.ends_=[],i.maxDelta_=-1,i.maxDeltaRevision_=-1,Array.isArray(e[0]))i.setCoordinates(e,r);else if(void 0!==r&&n)i.setFlatCoordinates(r,e),i.ends_=n;else{for(var o=i.getLayout(),a=e,s=[],u=[],l=0,h=a.length;l<h;++l){var c=a[l];0===l&&(o=c.getLayout()),m(s,c.getFlatCoordinates()),u.push(s.length)}i.setFlatCoordinates(o,s),i.ends_=u}return i}return Yd(e,t),e.prototype.appendLineString=function(t){this.flatCoordinates?m(this.flatCoordinates,t.getFlatCoordinates().slice()):this.flatCoordinates=t.getFlatCoordinates().slice(),this.ends_.push(this.flatCoordinates.length),this.changed()},e.prototype.clone=function(){return new e(this.flatCoordinates.slice(),this.layout,this.ends_.slice())},e.prototype.closestPointXY=function(t,e,r,n){return n<Bt(this.getExtent(),t,e)?n:(this.maxDeltaRevision_!=this.getRevision()&&(this.maxDelta_=Math.sqrt(Kr(this.flatCoordinates,0,this.ends_,this.stride,0)),this.maxDeltaRevision_=this.getRevision()),Jr(this.flatCoordinates,0,this.ends_,this.stride,this.maxDelta_,!1,t,e,r,n))},e.prototype.getCoordinateAtM=function(t,e,r){if(this.layout!=dt&&this.layout!=gt||0===this.flatCoordinates.length)return null;var n=void 0!==e&&e,i=void 0!==r&&r;return function(t,e,r,n,i,o,a){if(a)return Td(t,e,r[r.length-1],n,i,o);var s;if(i<t[n-1])return o?((s=t.slice(0,n))[n-1]=i,s):null;if(t[t.length-1]<i)return o?((s=t.slice(t.length-n))[n-1]=i,s):null;for(var u=0,l=r.length;u<l;++u){var h=r[u];if(e!=h){if(i<t[e+n-1])return null;if(i<=t[h-1])return Td(t,e,h,n,i,!1);e=h}}return null}(this.flatCoordinates,0,this.ends_,this.stride,t,n,i)},e.prototype.getCoordinates=function(){return un(this.flatCoordinates,0,this.ends_,this.stride)},e.prototype.getEnds=function(){return this.ends_},e.prototype.getLineString=function(t){return t<0||this.ends_.length<=t?null:new Cd(this.flatCoordinates.slice(0===t?0:this.ends_[t-1],this.ends_[t]),this.layout)},e.prototype.getLineStrings=function(){for(var t=this.flatCoordinates,e=this.ends_,r=this.layout,n=[],i=0,o=0,a=e.length;o<a;++o){var s=e[o],u=new Cd(t.slice(i,s),r);n.push(u),i=s}return n},e.prototype.getFlatMidpoints=function(){for(var t=[],e=this.flatCoordinates,r=0,n=this.ends_,i=this.stride,o=0,a=n.length;o<a;++o){var s=n[o];m(t,Sd(e,r,s,i,.5)),r=s}return t},e.prototype.getSimplifiedGeometryInternal=function(t){var r=[],n=[];return r.length=rn(this.flatCoordinates,0,this.ends_,this.stride,t,r,0,n),new e(r,pt,n)},e.prototype.getType=function(){return yt.MULTI_LINE_STRING},e.prototype.intersectsExtent=function(t){return function(t,e,r,n,i){for(var o=0,a=r.length;o<a;++o){if(wn(t,e,r[o],n,i))return!0;e=r[o]}return!1}(this.flatCoordinates,0,this.ends_,this.stride,t)},e.prototype.setCoordinates=function(t,e){this.setLayout(e,t,2),this.flatCoordinates||(this.flatCoordinates=[]);var r=tn(this.flatCoordinates,0,t,this.stride,this.ends_);this.flatCoordinates.length=0===r.length?0:r[r.length-1],this.changed()},e}(qr),Wd=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),qd=function(t){function e(e,r){var n=t.call(this)||this;return r&&!Array.isArray(e[0])?n.setFlatCoordinates(r,e):n.setCoordinates(e,r),n}return Wd(e,t),e.prototype.appendPoint=function(t){this.flatCoordinates?m(this.flatCoordinates,t.getFlatCoordinates()):this.flatCoordinates=t.getFlatCoordinates().slice(),this.changed()},e.prototype.clone=function(){return new e(this.flatCoordinates.slice(),this.layout)},e.prototype.closestPointXY=function(t,e,r,n){if(n<Bt(this.getExtent(),t,e))return n;for(var i=this.flatCoordinates,o=this.stride,a=0,s=i.length;a<s;a+=o){var u=Ce(t,e,i[a],i[a+1]);if(u<n){n=u;for(var l=0;l<o;++l)r[l]=i[a+l];r.length=o}}return n},e.prototype.getCoordinates=function(){return sn(this.flatCoordinates,0,this.flatCoordinates.length,this.stride)},e.prototype.getPoint=function(t){var e=this.flatCoordinates?this.flatCoordinates.length/this.stride:0;return t<0||e<=t?null:new gn(this.flatCoordinates.slice(t*this.stride,(t+1)*this.stride),this.layout)},e.prototype.getPoints=function(){for(var t=this.flatCoordinates,e=this.layout,r=this.stride,n=[],i=0,o=t.length;i<o;i+=r){var a=new gn(t.slice(i,i+r),e);n.push(a)}return n},e.prototype.getType=function(){return yt.MULTI_POINT},e.prototype.intersectsExtent=function(t){for(var e=this.flatCoordinates,r=this.stride,n=0,i=e.length;n<i;n+=r){if(Wt(t,e[n],e[n+1]))return!0}return!1},e.prototype.setCoordinates=function(t,e){this.setLayout(e,t,1),this.flatCoordinates||(this.flatCoordinates=[]),this.flatCoordinates.length=Qr(this.flatCoordinates,0,t,this.stride),this.changed()},e}(qr);function Xd(t,e,r,n){for(var i=[],o=[1/0,1/0,-1/0,-1/0],a=0,s=r.length;a<s;++a){var u=r[a];o=Jt(t,e,u[0],n),i.push((o[0]+o[2])/2,(o[1]+o[3])/2),e=u[u.length-1]}return i}var Zd=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Kd=function(t){function e(e,r,n){var i=t.call(this)||this;if(i.endss_=[],i.flatInteriorPointsRevision_=-1,i.flatInteriorPoints_=null,i.maxDelta_=-1,i.maxDeltaRevision_=-1,i.orientedRevision_=-1,i.orientedFlatCoordinates_=null,!n&&!Array.isArray(e[0])){for(var o=i.getLayout(),a=e,s=[],u=[],l=0,h=a.length;l<h;++l){var c=a[l];0===l&&(o=c.getLayout());for(var p=s.length,f=c.getEnds(),d=0,g=f.length;d<g;++d)f[d]+=p;m(s,c.getFlatCoordinates()),u.push(f)}r=o,e=s,n=u}return void 0!==r&&n?(i.setFlatCoordinates(r,e),i.endss_=n):i.setCoordinates(e,r),i}return Zd(e,t),e.prototype.appendPolygon=function(t){var e;if(this.flatCoordinates){var r=this.flatCoordinates.length;m(this.flatCoordinates,t.getFlatCoordinates());for(var n=0,i=(e=t.getEnds().slice()).length;n<i;++n)e[n]+=r}else this.flatCoordinates=t.getFlatCoordinates().slice(),e=t.getEnds().slice(),this.endss_.push();this.endss_.push(e),this.changed()},e.prototype.clone=function(){for(var t=this.endss_.length,r=new Array(t),n=0;n<t;++n)r[n]=this.endss_[n].slice();return new e(this.flatCoordinates.slice(),this.layout,r)},e.prototype.closestPointXY=function(t,e,r,n){return n<Bt(this.getExtent(),t,e)?n:(this.maxDeltaRevision_!=this.getRevision()&&(this.maxDelta_=Math.sqrt(function(t,e,r,n,i){for(var o=0,a=r.length;o<a;++o){var s=r[o];i=Kr(t,e,s,n,i),e=s[s.length-1]}return i}(this.flatCoordinates,0,this.endss_,this.stride,0)),this.maxDeltaRevision_=this.getRevision()),function(t,e,r,n,i,o,a,s,u,l,h){for(var c=h||[NaN,NaN],p=0,f=r.length;p<f;++p){var d=r[p];l=Jr(t,e,d,n,i,o,a,s,u,l,c),e=d[d.length-1]}return l}(this.getOrientedFlatCoordinates(),0,this.endss_,this.stride,this.maxDelta_,!0,t,e,r,n))},e.prototype.containsXY=function(t,e){return function(t,e,r,n,i,o){if(0===r.length)return!1;for(var a=0,s=r.length;a<s;++a){var u=r[a];if(vn(t,e,u,n,i,o))return!0;e=u[u.length-1]}return!1}(this.getOrientedFlatCoordinates(),0,this.endss_,this.stride,t,e)},e.prototype.getArea=function(){return function(t,e,r,n){for(var i=0,o=0,a=r.length;o<a;++o){var s=r[o];i+=cn(t,e,s,n),e=s[s.length-1]}return i}(this.getOrientedFlatCoordinates(),0,this.endss_,this.stride)},e.prototype.getCoordinates=function(t){var e;return void 0!==t?Rn(e=this.getOrientedFlatCoordinates().slice(),0,this.endss_,this.stride,t):e=this.flatCoordinates,ln(e,0,this.endss_,this.stride)},e.prototype.getEndss=function(){return this.endss_},e.prototype.getFlatInteriorPoints=function(){if(this.flatInteriorPointsRevision_!=this.getRevision()){var t=Xd(this.flatCoordinates,0,this.endss_,this.stride);this.flatInteriorPoints_=bn(this.getOrientedFlatCoordinates(),0,this.endss_,this.stride,t),this.flatInteriorPointsRevision_=this.getRevision()}return this.flatInteriorPoints_},e.prototype.getInteriorPoints=function(){return new qd(this.getFlatInteriorPoints().slice(),dt)},e.prototype.getOrientedFlatCoordinates=function(){if(this.orientedRevision_!=this.getRevision()){var t=this.flatCoordinates;!function(t,e,r,n,i){for(var o=0,a=r.length;o<a;++o){var s=r[o];if(!Cn(t,e,s,n,i))return!1;s.length&&(e=s[s.length-1])}return!0}(t,0,this.endss_,this.stride)?(this.orientedFlatCoordinates_=t.slice(),this.orientedFlatCoordinates_.length=Rn(this.orientedFlatCoordinates_,0,this.endss_,this.stride)):this.orientedFlatCoordinates_=t,this.orientedRevision_=this.getRevision()}return this.orientedFlatCoordinates_},e.prototype.getSimplifiedGeometryInternal=function(t){var r=[],n=[];return r.length=function(t,e,r,n,i,o,a,s){for(var u=0,l=r.length;u<l;++u){var h=r[u],c=[];a=an(t,e,h,n,i,o,a,c),s.push(c),e=h[h.length-1]}return a}(this.flatCoordinates,0,this.endss_,this.stride,Math.sqrt(t),r,0,n),new e(r,pt,n)},e.prototype.getPolygon=function(t){if(t<0||this.endss_.length<=t)return null;var e;if(0===t)e=0;else{var r=this.endss_[t-1];e=r[r.length-1]}var n=this.endss_[t].slice(),i=n[n.length-1];if(0!==e)for(var o=0,a=n.length;o<a;++o)n[o]-=e;return new Ln(this.flatCoordinates.slice(e,i),this.layout,n)},e.prototype.getPolygons=function(){for(var t=this.layout,e=this.flatCoordinates,r=this.endss_,n=[],i=0,o=0,a=r.length;o<a;++o){var s=r[o].slice(),u=s[s.length-1];if(0!==i)for(var l=0,h=s.length;l<h;++l)s[l]-=i;var c=new Ln(e.slice(i,u),t,s);n.push(c),i=u}return n},e.prototype.getType=function(){return yt.MULTI_POLYGON},e.prototype.intersectsExtent=function(t){return function(t,e,r,n,i){for(var o=0,a=r.length;o<a;++o){var s=r[o];if(Sn(t,e,s,n,i))return!0;e=s[s.length-1]}return!1}(this.getOrientedFlatCoordinates(),0,this.endss_,this.stride,t)},e.prototype.setCoordinates=function(t,e){this.setLayout(e,t,3),this.flatCoordinates||(this.flatCoordinates=[]);var r=function(t,e,r,n,i){for(var o=i||[],a=0,s=0,u=r.length;s<u;++s){var l=tn(t,e,r[s],n,o[a]);o[a++]=l,e=l[l.length-1]}return o.length=a,o}(this.flatCoordinates,0,t,this.stride,this.endss_);if(0===r.length)this.flatCoordinates.length=0;else{var n=r[r.length-1];this.flatCoordinates.length=0===n.length?0:n[n.length-1]}this.changed()},e}(qr),Hd=r(5),Jd=r.n(Hd),$d=[1,0,0,1,0,0],Qd=function(){function t(t,e,r,n,i){this.extent_,this.id_=i,this.type_=t,this.flatCoordinates_=e,this.flatInteriorPoints_=null,this.flatMidpoints_=null,this.ends_=r,this.properties_=n}return t.prototype.get=function(t){return this.properties_[t]},t.prototype.getExtent=function(){return this.extent_||(this.extent_=this.type_===yt.POINT?Ht(this.flatCoordinates_):Jt(this.flatCoordinates_,0,this.flatCoordinates_.length,2)),this.extent_},t.prototype.getFlatInteriorPoint=function(){if(!this.flatInteriorPoints_){var t=ue(this.getExtent());this.flatInteriorPoints_=_n(this.flatCoordinates_,0,this.ends_,2,t,0)}return this.flatInteriorPoints_},t.prototype.getFlatInteriorPoints=function(){if(!this.flatInteriorPoints_){var t=Xd(this.flatCoordinates_,0,this.ends_,2);this.flatInteriorPoints_=bn(this.flatCoordinates_,0,this.ends_,2,t)}return this.flatInteriorPoints_},t.prototype.getFlatMidpoint=function(){return this.flatMidpoints_||(this.flatMidpoints_=Sd(this.flatCoordinates_,0,this.flatCoordinates_.length,2,.5)),this.flatMidpoints_},t.prototype.getFlatMidpoints=function(){if(!this.flatMidpoints_){this.flatMidpoints_=[];for(var t=this.flatCoordinates_,e=0,r=this.ends_,n=0,i=r.length;n<i;++n){var o=r[n],a=Sd(t,e,o,2,.5);m(this.flatMidpoints_,a),e=o}}return this.flatMidpoints_},t.prototype.getId=function(){return this.id_},t.prototype.getOrientedFlatCoordinates=function(){return this.flatCoordinates_},t.prototype.getGeometry=function(){return this},t.prototype.getSimplifiedGeometry=function(t){return this},t.prototype.simplifyTransformed=function(t,e){return this},t.prototype.getProperties=function(){return this.properties_},t.prototype.getStride=function(){return 2},t.prototype.getStyleFunction=function(){},t.prototype.getType=function(){return this.type_},t.prototype.transform=function(t,e){var r=(t=yr(t)).getExtent(),n=t.getWorldExtent(),i=ce(n)/ce(r);Ct($d,n[0],n[3],i,-i,0,0,0),Gr(this.flatCoordinates_,0,this.flatCoordinates_.length,2,$d,this.flatCoordinates_)},t.prototype.getEnds=function(){return this.ends_},t}();Qd.prototype.getEndss=Qd.prototype.getEnds,Qd.prototype.getFlatCoordinates=Qd.prototype.getOrientedFlatCoordinates;var tg=Qd,eg=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function rg(t,e,r){if(3===t){var n={keys:[],values:[],features:[]},i=r.readVarint()+r.pos;r.readFields(ng,n,i),n.length=n.features.length,n.length&&(e[n.name]=n)}}function ng(t,e,r){if(15===t)e.version=r.readVarint();else if(1===t)e.name=r.readString();else if(5===t)e.extent=r.readVarint();else if(2===t)e.features.push(r.pos);else if(3===t)e.keys.push(r.readString());else if(4===t){for(var n=null,i=r.readVarint()+r.pos;r.pos<i;)n=1===(t=r.readVarint()>>3)?r.readString():2===t?r.readFloat():3===t?r.readDouble():4===t?r.readVarint64():5===t?r.readVarint():6===t?r.readSVarint():7===t?r.readBoolean():null;e.values.push(n)}}function ig(t,e,r){if(1==t)e.id=r.readVarint();else if(2==t)for(var n=r.readVarint()+r.pos;r.pos<n;){var i=e.layer.keys[r.readVarint()],o=e.layer.values[r.readVarint()];e.properties[i]=o}else 3==t?e.type=r.readVarint():4==t&&(e.geometry=r.pos)}function og(t,e,r){t.pos=e.features[r];var n=t.readVarint()+t.pos,i={layer:e,type:0,properties:{}};return t.readFields(ig,i,n),i}var ag=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.dataProjection=new xe({code:"",units:_t.TILE_PIXELS}),r.featureClass_=n.featureClass?n.featureClass:tg,r.geometryName_=n.geometryName,r.layerName_=n.layerName?n.layerName:"layer",r.layers_=n.layers?n.layers:null,r.idProperty_=n.idProperty,r}return eg(e,t),e.prototype.readRawGeometry_=function(t,e,r,n){t.pos=e.geometry;for(var i=t.readVarint()+t.pos,o=1,a=0,s=0,u=0,l=0,h=0;t.pos<i;){if(!a){var c=t.readVarint();o=7&c,a=c>>3}a--,1===o||2===o?(s+=t.readSVarint(),u+=t.readSVarint(),1===o&&l>h&&(n.push(l),h=l),r.push(s,u),l+=2):7===o?l>h&&(r.push(r[h],r[h+1]),l+=2):lt(!1,59)}l>h&&(n.push(l),h=l)},e.prototype.createFeature_=function(t,e,r){var n,i=e.type;if(0===i)return null;var o,a=e.properties;this.idProperty_?(o=a[this.idProperty_],delete a[this.idProperty_]):o=e.id,a[this.layerName_]=e.layer.name;var s=[],u=[];this.readRawGeometry_(t,e,s,u);var l=function(t,e){var r;1===t?r=1===e?yt.POINT:yt.MULTI_POINT:2===t?r=1===e?yt.LINE_STRING:yt.MULTI_LINE_STRING:3===t&&(r=yt.POLYGON);return r}(i,u.length);if(this.featureClass_===tg)(n=new this.featureClass_(l,s,u,a,o)).transform(r.dataProjection,r.featureProjection);else{var h=void 0;if(l==yt.POLYGON){for(var c=[],p=0,f=0,d=0,g=u.length;d<g;++d){var y=u[d];if(En(s,p,y,2)){if(0===c.length)continue;c[c.length-1].push(u[f])}else c.push(u.slice(f,d+1));f=d+1,p=y}h=c.length>1?new Kd(s,pt,c):new Ln(s,pt,u)}else h=l===yt.POINT?new gn(s,pt):l===yt.LINE_STRING?new Cd(s,pt):l===yt.POLYGON?new Ln(s,pt,u):l===yt.MULTI_POINT?new qd(s,pt):l===yt.MULTI_LINE_STRING?new Vd(s,pt,u):null;n=new(0,this.featureClass_),this.geometryName_&&n.setGeometryName(this.geometryName_);var m=Ud(h,!1,r);n.setGeometry(m),n.setId(o),n.setProperties(a,!0)}return n},e.prototype.getType=function(){return yu},e.prototype.readFeatures=function(t,e){var r=this.layers_,n=this.adaptOptions(e),i=yr(n.dataProjection);i.setWorldExtent(n.extent),n.dataProjection=i;var o=new Jd.a(t),a=o.readFields(rg,{}),s=[];for(var u in a)if(!r||-1!=r.indexOf(u)){var l=a[u],h=l?[0,0,l.extent,l.extent]:null;i.setExtent(h);for(var c=0,p=l.length;c<p;++c){var f=og(o,l,c);s.push(this.createFeature_(o,f,n))}}return s},e.prototype.readProjection=function(t){return this.dataProjection},e.prototype.setLayers=function(t){this.layers_=t},e}(zd),sg=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ug=function(t){function e(e){var r=this,n=e||{},i=T({},n);delete i.preload,delete i.useInterimTilesOnError,r=t.call(this,i)||this;var o=n.renderMode||md;return lt(null==o||o==yd||o==md||o==vd,28),r.renderMode_=o,r.setPreload(n.preload?n.preload:0),r.setUseInterimTilesOnError(void 0===n.useInterimTilesOnError||n.useInterimTilesOnError),r}return sg(e,t),e.prototype.createRenderer=function(){return new wd(this)},e.prototype.getFeatures=function(e){return t.prototype.getFeatures.call(this,e)},e.prototype.getRenderMode=function(){return this.renderMode_},e.prototype.getPreload=function(){return this.get(vp)},e.prototype.getUseInterimTilesOnError=function(){return this.get(_p)},e.prototype.setPreload=function(t){this.set(vp,t)},e.prototype.setUseInterimTilesOnError=function(t){this.set(_p,t)},e}(xf),lg=r(2),hg=r.n(lg),cg=r(0);function pg(t){return t*Math.PI/180}var fg=function(){for(var t=[],e=78271.51696402048;t.length<=24;e/=2)t.push(e);return t}();function dg(t,e){if("undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope&&"undefined"!=typeof OffscreenCanvas)return new OffscreenCanvas(t,e);var r=document.createElement("canvas");return r.width=t,r.height=e,r}var gg,yg=Array(256).join(" ");function mg(t,e){if(e>=.05){for(var r="",n=t.split("\n"),i=yg.slice(0,Math.round(e/.1)),o=0,a=n.length;o<a;++o)o>0&&(r+="\n"),r+=n[o].split("").join(i);return r}return t}function vg(){return gg||(gg=dg(1,1).getContext("2d")),gg}function _g(t,e){return vg().measureText(t).width+(t.length-1)*e}var bg={};to&&W(to,M,(function(){bg={}}));var xg,wg,Sg=cg.e.isFunction,Tg=cg.e.convertFunction,Eg=cg.c.isExpression,Cg=cg.c.createPropertyExpression,Pg={Point:1,MultiPoint:1,LineString:2,MultiLineString:2,Polygon:3,MultiPolygon:3},Rg={center:[.5,.5],left:[0,.5],right:[1,.5],top:[.5,0],bottom:[.5,1],"top-left":[0,0],"top-right":[1,0],"bottom-left":[0,1],"bottom-right":[1,1]},Og={},Ig={zoom:0},Lg={};function Mg(t,e,r,n,i){var o=t.id;Lg[o]||(Lg[o]={});var a=Lg[o];if(!a[r]){var s=(t[e]||Og)[r],u=cg.f[e+"_"+t.type][r];void 0===s&&(s=u.default);var l=Eg(s);if(!l&&Sg(s)&&(s=Tg(s,u),l=!0),l){var h=function(t,e){var r=Cg(t,e);if("error"===r.result)throw new Error(r.value.map((function(t){return t.key+": "+t.message})).join(", "));return r.value}(s,u);a[r]=h.evaluate.bind(h)}else"color"==u.type&&(s=cg.a.parse(s)),a[r]=function(){return s}}return Ig.zoom=n,a[r](Ig,i)}var Fg={};function Ag(t,e){if(t){if(0===t.a||0===e)return;var r=t.a;return e=void 0===e?1:e,"rgba("+Math.round(255*t.r/r)+","+Math.round(255*t.g/r)+","+Math.round(255*t.b/r)+","+r*e+")"}return t}var kg=/^([^]*)\{(.*)\}([^]*)$/;function Ng(t,e){var r;do{if(r=t.match(kg)){var n=e[r[2]]||"";t=r[1]+n+r[3]}}while(r);return t}var jg=function(t,e,r,n,i,o,a){if(void 0===n&&(n=fg),"string"==typeof e&&(e=JSON.parse(e)),8!=e.version)throw new Error("glStyle version 8 required.");var s,u;if(o)if("undefined"!=typeof Image){var l=new Image;l.crossOrigin="anonymous",l.onload=function(){s=l,u=[l.width,l.height],t.changed(),l.onload=null},l.src=o}else if("undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope){var h=self;h.postMessage({action:"loadImage",src:o}),h.addEventListener("message",(function(t){"imageLoaded"===t.data.action&&t.data.src===o&&(s=t.data.image,u=[s.width,s.height])}))}for(var c,p=Object(cg.b)(e.layers),f={},d=[],g=0,y=p.length;g<y;++g){var m=p[g],v=m.id;if("string"==typeof r&&m.source==r||-1!==r.indexOf(v)){var _=m["source-layer"];if(!c){c=m.source;var b=e.sources[c];if(!b)throw new Error('Source "'+c+'" is not defined');var x=b.type;if("vector"!==x&&"geojson"!==x)throw new Error('Source "'+c+'" is not of type "vector" or "geojson", but "'+x+'"')}var w=f[_];w||(w=f[_]=[]),w.push({layer:m,index:g}),d.push(v)}delete Lg[v],delete Fg[v]}var S=new nh,T=new zl,E={},C={},P=[],R=function(t,e){var r=t.getProperties(),o=f[r.layer];if(o){var l=n.indexOf(e);-1==l&&(l=function(t,e){for(var r=0,n=e.length;r<n;++r){if(e[r]<t&&r+1<n){var i=e[r]/e[r+1];return r+Math.log(e[r]/t)/Math.log(i)}}return n-1}(e,n));for(var h=Pg[t.getGeometry().getType()],c={properties:r,type:h},p=-1,d=function(n,f){var d=o[n],g=d.layer,y=g.id,m=g.layout||Og,v=g.paint||Og;if("none"===m.visibility||"minzoom"in g&&l<g.minzoom||"maxzoom"in g&&l>=g.maxzoom)return"continue";var _=g.filter;if(!_||function(t,e,r,n){return t in Fg||(Fg[t]=Object(cg.d)(e).filter),Ig.zoom=n,Fg[t](Ig,r)}(y,_,c,l)){var b=void 0,x=void 0,w=void 0,R=void 0,O=void 0,I=void 0,L=d.index;if(3==h&&"fill"==g.type)if(x=Mg(g,"paint","fill-opacity",l,c),"fill-pattern"in v){var M=Mg(g,"paint","fill-pattern",l,c);if(M){var F="string"==typeof M?Ng(M,r):M.toString();if(s&&i&&i[F]){++p,(I=P[p])&&I.getFill()&&!I.getStroke()&&!I.getText()||(I=P[p]=new lh({fill:new zl})),w=I.getFill(),I.setZIndex(L);var A=C[ut=F+"."+x];if(!A)(ct=(ht=dg((lt=i[F]).width,lt.height)).getContext("2d")).globalAlpha=x,ct.drawImage(s,lt.x,lt.y,lt.width,lt.height,0,0,lt.width,lt.height),A=ct.createPattern(ht,"repeat"),C[ut]=A;w.setColor(A)}}}else(b=Ag(Mg(g,"paint","fill-color",l,c),x))&&("fill-outline-color"in v&&(O=Ag(Mg(g,"paint","fill-outline-color",l,c),x)),O||(O=b),++p,(I=P[p])&&I.getFill()&&I.getStroke()&&!I.getText()||(I=P[p]=new lh({fill:new zl,stroke:new nh})),(w=I.getFill()).setColor(b),(R=I.getStroke()).setColor(O),R.setWidth(1),I.setZIndex(L));if(1!=h&&"line"==g.type){b=!("line-pattern"in v)&&"line-color"in v?Ag(Mg(g,"paint","line-color",l,c),Mg(g,"paint","line-opacity",l,c)):void 0;var k=Mg(g,"paint","line-width",l,c);b&&k>0&&(++p,(I=P[p])&&I.getStroke()&&!I.getFill()&&!I.getText()||(I=P[p]=new lh({stroke:new nh})),(R=I.getStroke()).setLineCap(Mg(g,"layout","line-cap",l,c)),R.setLineJoin(Mg(g,"layout","line-join",l,c)),R.setMiterLimit(Mg(g,"layout","line-miter-limit",l,c)),R.setColor(b),R.setWidth(k),R.setLineDash(v["line-dasharray"]?Mg(g,"paint","line-dasharray",l,c).map((function(t){return t*k})):null),I.setZIndex(L))}var N=!1,j=null,G=0,D=void 0,z=void 0,U=void 0;if((1==h||2==h)&&"icon-image"in m){var B=Mg(g,"layout","icon-image",l,c);if(B){D="string"==typeof B?Ng(B,r):B.toString();var Y=void 0;if(s&&i&&i[D]){var V=Mg(g,"layout","icon-rotation-alignment",l,c);if(2==h){var W=t.getGeometry();if(W.getFlatMidpoint||W.getFlatMidpoints){var q=W.getExtent();if(Math.sqrt(Math.max(Math.pow((q[2]-q[0])/e,2),Math.pow((q[3]-q[1])/e,2)))>150){var X="MultiLineString"===W.getType()?W.getFlatMidpoints():W.getFlatMidpoint();if(wg||(wg=new tg("Point",xg=[NaN,NaN],[],{},null)),Y=wg,xg[0]=X[0],xg[1]=X[1],"line"===(Lt=Mg(g,"layout","symbol-placement",l,c))&&"map"===V)for(var Z=W.getStride(),K=W.getFlatCoordinates(),H=0,J=K.length-Z;H<J;H+=Z){var $=K[H],Q=K[H+1],tt=K[H+Z],et=K[H+Z+1],rt=Math.min($,tt),nt=Math.min(Q,et),it=Math.max($,tt),ot=Math.max(Q,et);if(X[0]>=rt&&X[0]<=it&&X[1]>=nt&&X[1]<=ot){G=Math.atan2(Q-et,tt-$);break}}}}}if(2!==h||Y){++p,(I=P[p])&&I.getImage()&&!I.getFill()&&!I.getStroke()||(I=P[p]=new lh),I.setGeometry(Y);var at=Mg(g,"layout","icon-size",l,c),st=void 0!==v["icon-color"]?Mg(g,"paint","icon-color",l,c):null,ut=D+"."+at;if(null!==st&&(ut+="."+st),!(z=E[ut])){var lt=i[D];if(null!==st){var ht,ct;(ct=(ht=dg(lt.width,lt.height)).getContext("2d")).drawImage(s,lt.x,lt.y,lt.width,lt.height,0,0,lt.width,lt.height);for(var pt=ct.getImageData(0,0,ht.width,ht.height),ft=0,dt=pt.data.length;ft<dt;ft+=4){var gt=st.a;0!==gt&&(pt.data[ft]=255*st.r/gt,pt.data[ft+1]=255*st.g/gt,pt.data[ft+2]=255*st.b/gt),pt.data[ft+3]=gt}ct.putImageData(pt,0,0),z=E[ut]=new rh({img:ht,imgSize:[ht.width,ht.height],scale:at/lt.pixelRatio})}else z=E[ut]=new rh({img:s,imgSize:u,size:[lt.width,lt.height],offset:[lt.x,lt.y],rotateWithView:"map"===V,scale:at/lt.pixelRatio})}z.setRotation(G+pg(Mg(g,"layout","icon-rotate",l,c))),z.setOpacity(Mg(g,"paint","icon-opacity",l,c)),z.setAnchor(Rg[Mg(g,"layout","icon-anchor",l,c)]),I.setImage(z),j=I.getText(),I.setText(void 0),I.setZIndex(L),N=!0,U=!1}else U=!0}}}if(1==h&&"circle-radius"in v){++p,(I=P[p])&&I.getImage()&&!I.getFill()&&!I.getStroke()||(I=P[p]=new lh);var yt=Mg(g,"paint","circle-radius",l,c),mt=Ag(Mg(g,"paint","circle-stroke-color",l,c),Mg(g,"paint","circle-stroke-opacity",l,c)),vt=Ag(Mg(g,"paint","circle-color",l,c),Mg(g,"paint","circle-opacity",l,c)),_t=Mg(g,"paint","circle-stroke-width",l,c),bt=yt+"."+mt+"."+vt+"."+_t;(z=E[bt])||(z=E[bt]=new Dl({radius:yt,stroke:mt&&_t>0?new nh({width:_t,color:mt}):void 0,fill:vt?new zl({color:vt}):void 0})),I.setImage(z),j=I.getText(),I.setText(void 0),I.setGeometry(void 0),I.setZIndex(L),N=!0}var xt=void 0;if("text-field"in m)xt=Ng(Mg(g,"layout","text-field",l,c).toString(),r).trim(),x=Mg(g,"paint","text-opacity",l,c);if(xt&&x&&!U){N||(++p,(I=P[p])&&I.getText()&&!I.getFill()&&!I.getStroke()||(I=P[p]=new lh),I.setImage(void 0),I.setGeometry(void 0)),I.getText()||I.setText(j||new ph({padding:[2,2,2,2]})),j=I.getText();var wt=Math.round(Mg(g,"layout","text-size",l,c)),St=Mg(g,"layout","text-font",l,c),Tt=Mg(g,"layout","text-line-height",l,c),Et=hg()(a?a(St):St,wt,Tt),Ct=m["text-transform"];"uppercase"==Ct?xt=xt.toUpperCase():"lowercase"==Ct&&(xt=xt.toLowerCase());var Pt=Mg(g,"layout","text-max-width",l,c),Rt=Mg(g,"layout","text-letter-spacing",l,c),Ot=2==h?mg(xt,Rt):function t(e,r,n,i){if(-1!==e.indexOf("\n")){for(var o=e.split("\n"),a=[],s=0,u=o.length;s<u;++s)a.push(t(o[s],r,n,i));return a.join("\n")}var l=n+","+r+","+e+","+i,h=bg[l];if(!h){var c=e.split(" ");if(c.length>1){var p=vg();p.font=r;var f=p.measureText("M").width*n,d="";for(a=[],s=0,u=c.length;s<u;++s){var g=c[s],y=d+(d?" ":"")+g;_g(y,i)<=f?d=y:(d&&a.push(d),d=g)}d&&a.push(d);for(s=0;s<a.length;++s){var m=a[s];if(_g(m,i)<.35*f){var v=s>0?_g(a[s-1],i):1/0,_=s<a.length-1?_g(a[s+1],i):1/0;a.splice(s,1),v<_?(a[s-1]+=" "+m,s-=1):a[s]=m+" "+a[s]}}for(s=0,u=a.length-1;s<u;++s){var b=a[s],x=a[s+1];if(_g(b,i)>.7*f&&_g(x,i)<.6*f){var w=b.split(" "),S=w.pop();_g(S,i)<.2*f&&(a[s]=w.join(" "),a[s+1]=S+" "+x),u-=1}}h=a.join("\n")}else h=e;h=mg(h,i),bg[l]=h}return h}(xt,Et,Pt,Rt);j.setText(Ot),j.setFont(Et),j.setRotation(pg(Mg(g,"layout","text-rotate",l,c)));var It=Mg(g,"layout","text-anchor",l,c),Lt=N||1==h?"point":Mg(g,"layout","symbol-placement",l,c);j.setPlacement(Lt);var Mt=Mg(g,"paint","text-halo-width",l,c),Ft=Mg(g,"layout","text-offset",l,c),At=Mg(g,"paint","text-translate",l,c),kt=0,Nt=0;if("point"==Lt){var jt="center";-1!==It.indexOf("left")?(jt="left",Nt=Mt):-1!==It.indexOf("right")&&(jt="right",Nt=-Mt),j.setTextAlign(jt);var Gt=Mg(g,"layout","text-rotation-alignment",l,c);j.setRotateWithView("map"==Gt)}else j.setMaxAngle(pg(Mg(g,"layout","text-max-angle",l,c))*xt.length/Ot.length),j.setTextAlign(),j.setRotateWithView(!1);var Dt="middle";0==It.indexOf("bottom")?(Dt="bottom",kt=-Mt-.5*(Tt-1)*wt):0==It.indexOf("top")&&(Dt="top",kt=Mt+.5*(Tt-1)*wt),j.setTextBaseline(Dt),j.setOffsetX(Ft[0]*wt+Nt+At[0]),j.setOffsetY(Ft[1]*wt+kt+At[1]),T.setColor(Ag(Mg(g,"paint","text-color",l,c),x)),j.setFill(T);var zt=Ag(Mg(g,"paint","text-halo-color",l,c),x);if(zt){S.setColor(zt),Mt*=2;var Ut=.5*wt;S.setWidth(Mt<=Ut?Mt:Ut),j.setStroke(S)}else j.setStroke(void 0);var Bt=Mg(g,"layout","text-padding",l,c),Yt=j.getPadding();Bt!==Yt[0]&&(Yt[0]=Yt[1]=Yt[2]=Yt[3]=Bt),I.setZIndex(L)}}},g=0,y=o.length;g<y;++g)d(g);return p>-1?(P.length=p+1,P):void 0}};return t.setStyle(R),t.set("mapbox-source",c),t.set("mapbox-layers",d),R},Gg=r(6),Dg=r.n(Gg),zg=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Ug(t){for(var e=[],r=0,n=t.length;r<n;++r)e.push(t[r].clone());return e}var Bg=function(t){function e(e){var r=t.call(this)||this;return r.geometries_=e||null,r.changeEventsKeys_=[],r.listenGeometriesChange_(),r}return zg(e,t),e.prototype.unlistenGeometriesChange_=function(){this.changeEventsKeys_.forEach(X),this.changeEventsKeys_.length=0},e.prototype.listenGeometriesChange_=function(){if(this.geometries_)for(var t=0,e=this.geometries_.length;t<e;++t)this.changeEventsKeys_.push(W(this.geometries_[t],I,this.changed,this))},e.prototype.clone=function(){var t=new e(null);return t.setGeometries(this.geometries_),t},e.prototype.closestPointXY=function(t,e,r,n){if(n<Bt(this.getExtent(),t,e))return n;for(var i=this.geometries_,o=0,a=i.length;o<a;++o)n=i[o].closestPointXY(t,e,r,n);return n},e.prototype.containsXY=function(t,e){for(var r=this.geometries_,n=0,i=r.length;n<i;++n)if(r[n].containsXY(t,e))return!0;return!1},e.prototype.computeExtent=function(t){Kt(t);for(var e=this.geometries_,r=0,n=e.length;r<n;++r)Qt(t,e[r].getExtent());return t},e.prototype.getGeometries=function(){return Ug(this.geometries_)},e.prototype.getGeometriesArray=function(){return this.geometries_},e.prototype.getGeometriesArrayRecursive=function(){for(var t=[],e=this.geometries_,r=0,n=e.length;r<n;++r)e[r].getType()===this.getType()?t=t.concat(e[r].getGeometriesArrayRecursive()):t.push(e[r]);return t},e.prototype.getSimplifiedGeometry=function(t){if(this.simplifiedGeometryRevision!==this.getRevision()&&(this.simplifiedGeometryMaxMinSquaredTolerance=0,this.simplifiedGeometryRevision=this.getRevision()),t<0||0!==this.simplifiedGeometryMaxMinSquaredTolerance&&t<this.simplifiedGeometryMaxMinSquaredTolerance)return this;for(var r=[],n=this.geometries_,i=!1,o=0,a=n.length;o<a;++o){var s=n[o],u=s.getSimplifiedGeometry(t);r.push(u),u!==s&&(i=!0)}if(i){var l=new e(null);return l.setGeometriesArray(r),l}return this.simplifiedGeometryMaxMinSquaredTolerance=t,this},e.prototype.getType=function(){return yt.GEOMETRY_COLLECTION},e.prototype.intersectsExtent=function(t){for(var e=this.geometries_,r=0,n=e.length;r<n;++r)if(e[r].intersectsExtent(t))return!0;return!1},e.prototype.isEmpty=function(){return 0===this.geometries_.length},e.prototype.rotate=function(t,e){for(var r=this.geometries_,n=0,i=r.length;n<i;++n)r[n].rotate(t,e);this.changed()},e.prototype.scale=function(t,e,r){var n=r;n||(n=ue(this.getExtent()));for(var i=this.geometries_,o=0,a=i.length;o<a;++o)i[o].scale(t,e,n);this.changed()},e.prototype.setGeometries=function(t){this.setGeometriesArray(Ug(t))},e.prototype.setGeometriesArray=function(t){this.unlistenGeometriesChange_(),this.geometries_=t,this.listenGeometriesChange_(),this.changed()},e.prototype.applyTransform=function(t){for(var e=this.geometries_,r=0,n=e.length;r<n;++r)e[r].applyTransform(t);this.changed()},e.prototype.translate=function(t,e){for(var r=this.geometries_,n=0,i=r.length;n<i;++n)r[n].translate(t,e);this.changed()},e.prototype.disposeInternal=function(){this.unlistenGeometriesChange_(),t.prototype.disposeInternal.call(this)},e}(Yr),Yg=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Vg(t){if("string"==typeof t){var e=JSON.parse(t);return e||null}return null!==t?t:null}var Wg=function(t){function e(){return t.call(this)||this}return Yg(e,t),e.prototype.getType=function(){return mu},e.prototype.readFeature=function(t,e){return this.readFeatureFromObject(Vg(t),this.getReadOptions(t,e))},e.prototype.readFeatures=function(t,e){return this.readFeaturesFromObject(Vg(t),this.getReadOptions(t,e))},e.prototype.readFeatureFromObject=function(t,e){return n()},e.prototype.readFeaturesFromObject=function(t,e){return n()},e.prototype.readGeometry=function(t,e){return this.readGeometryFromObject(Vg(t),this.getReadOptions(t,e))},e.prototype.readGeometryFromObject=function(t,e){return n()},e.prototype.readProjection=function(t){return this.readProjectionFromObject(Vg(t))},e.prototype.readProjectionFromObject=function(t){return n()},e.prototype.writeFeature=function(t,e){return JSON.stringify(this.writeFeatureObject(t,e))},e.prototype.writeFeatureObject=function(t,e){return n()},e.prototype.writeFeatures=function(t,e){return JSON.stringify(this.writeFeaturesObject(t,e))},e.prototype.writeFeaturesObject=function(t,e){return n()},e.prototype.writeGeometry=function(t,e){return JSON.stringify(this.writeGeometryObject(t,e))},e.prototype.writeGeometryObject=function(t,e){return n()},e}(zd),qg=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Xg(t,e){if(!t)return null;var r;switch(t.type){case yt.POINT:r=function(t){return new gn(t.coordinates)}(t);break;case yt.LINE_STRING:r=function(t){return new Cd(t.coordinates)}(t);break;case yt.POLYGON:r=function(t){return new Ln(t.coordinates)}(t);break;case yt.MULTI_POINT:r=function(t){return new qd(t.coordinates)}(t);break;case yt.MULTI_LINE_STRING:r=function(t){return new Vd(t.coordinates)}(t);break;case yt.MULTI_POLYGON:r=function(t){return new Kd(t.coordinates)}(t);break;case yt.GEOMETRY_COLLECTION:r=function(t,e){var r=t.geometries.map((function(t){return Xg(t,e)}));return new Bg(r)}(t);break;default:throw new Error("Unsupported GeoJSON type: "+t.type)}return Ud(r,!1,e)}function Zg(t,e){var r,n=(t=Ud(t,!0,e)).getType();switch(n){case yt.POINT:r=function(t,e){return{type:"Point",coordinates:t.getCoordinates()}}(t);break;case yt.LINE_STRING:r=function(t,e){return{type:"LineString",coordinates:t.getCoordinates()}}(t);break;case yt.POLYGON:r=function(t,e){var r;e&&(r=e.rightHanded);return{type:"Polygon",coordinates:t.getCoordinates(r)}}(t,e);break;case yt.MULTI_POINT:r=function(t,e){return{type:"MultiPoint",coordinates:t.getCoordinates()}}(t);break;case yt.MULTI_LINE_STRING:r=function(t,e){return{type:"MultiLineString",coordinates:t.getCoordinates()}}(t);break;case yt.MULTI_POLYGON:r=function(t,e){var r;e&&(r=e.rightHanded);return{type:"MultiPolygon",coordinates:t.getCoordinates(r)}}(t,e);break;case yt.GEOMETRY_COLLECTION:r=function(t,e){return{type:"GeometryCollection",geometries:t.getGeometriesArray().map((function(t){var r=T({},e);return delete r.featureProjection,Zg(t,r)}))}}(t,e);break;case yt.CIRCLE:r={type:"GeometryCollection",geometries:[]};break;default:throw new Error("Unsupported geometry type: "+n)}return r}var Kg,Hg=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this)||this).dataProjection=yr(n.dataProjection?n.dataProjection:"EPSG:4326"),n.featureProjection&&(r.defaultFeatureProjection=yr(n.featureProjection)),r.geometryName_=n.geometryName,r.extractGeometryName_=n.extractGeometryName,r}return qg(e,t),e.prototype.readFeatureFromObject=function(t,e){var r=null,n=Xg((r="Feature"===t.type?t:{type:"Feature",geometry:t,properties:null}).geometry,e),i=new ct;return this.geometryName_?i.setGeometryName(this.geometryName_):this.extractGeometryName_&&"geometry_name"in r!==void 0&&i.setGeometryName(r.geometry_name),i.setGeometry(n),"id"in r&&i.setId(r.id),r.properties&&i.setProperties(r.properties,!0),i},e.prototype.readFeaturesFromObject=function(t,e){var r=null;if("FeatureCollection"===t.type){r=[];for(var n=t.features,i=0,o=n.length;i<o;++i)r.push(this.readFeatureFromObject(n[i],e))}else r=[this.readFeatureFromObject(t,e)];return r},e.prototype.readGeometryFromObject=function(t,e){return Xg(t,e)},e.prototype.readProjectionFromObject=function(t){var e,r=t.crs;return r?"name"==r.type?e=yr(r.properties.name):"EPSG"===r.type?e=yr("EPSG:"+r.properties.code):lt(!1,36):e=this.dataProjection,e},e.prototype.writeFeatureObject=function(t,e){e=this.adaptOptions(e);var r={type:"Feature",geometry:null,properties:null},n=t.getId();if(void 0!==n&&(r.id=n),!t.hasProperties())return r;var i=t.getProperties(),o=t.getGeometry();return o&&(r.geometry=Zg(o,e),delete i[t.getGeometryName()]),P(i)||(r.properties=i),r},e.prototype.writeFeaturesObject=function(t,e){e=this.adaptOptions(e);for(var r=[],n=0,i=t.length;n<i;++n)r.push(this.writeFeatureObject(t[n],e));return{type:"FeatureCollection",features:r}},e.prototype.writeGeometryObject=function(t,e){return Zg(t,this.adaptOptions(e))},e}(Wg),Jg=/font-family: ?([^;]*);/,$g=/("|')/g;function Qg(t){if(!Kg){Kg={};for(var e=document.styleSheets,r=0,n=e.length;r<n;++r){var i=e[r];try{var o=i.rules||i.cssRules;if(o)for(var a=0,s=o.length;a<s;++a){var u=o[a];if(5==u.type){var l=u.cssText.match(Jg);Kg[l[1].replace($g,"")]=!0}}}catch(t){}}}return t in Kg}var ty={},ey=Dg.a.getNames();function ry(t){var e=t.toString();if(e in ty)return t;for(var r=t.map((function(t){var e=hg()(t,1).split(" ");return[e.slice(3).join(" ").replace(/"/g,""),e[1]+e[0]]})),n=0,i=r.length;n<i;++n){var o=r[n],a=o[0];if(!Qg(a)&&-1!==ey.indexOf(a)){var s="https://fonts.googleapis.com/css?family="+a.replace(/ /g,"+")+":"+o[1];if(!document.querySelector('link[href="'+s+'"]')){var u=document.createElement("link");u.href=s,u.rel="stylesheet",document.head.appendChild(u)}}}return ty[e]=!0,t}var ny=/^(.*)(\?.*)$/;function iy(t,e){return e&&0===t.indexOf(".")&&(t=e+t),t}function oy(t,e,r){var n=(t=iy(t,e)).match(ny);return n?n[1]+r+(n.length>2?n[2]:""):t+r}function ay(t,e,r,n,i){return new Promise((function(o,a){if("object"!=typeof e&&(e=JSON.parse(e)),8!=e.version)return a(new Error("glStyle version 8 required."));if(!(t instanceof Rd||t instanceof ug))return a(new Error("Can only apply to VectorLayer or VectorTileLayer"));var s,u,l;function h(){l||e.sprite&&!s?l?(t.setStyle(l),o()):a(new Error("Something went wrong trying to apply style.")):(l=jg(t,e,r,i,s,u,ry),t.getStyle()?o():a(new Error("Nothing to show for source ["+r+"]")))}if(e.sprite){var c=.5==(window.devicePixelRatio>=1.5?.5:1)?"@2x":"",p=oy(e.sprite,n,c+".json");fetch(p,{credentials:"same-origin"}).then((function(t){return t.ok||""===c?t:(p=oy(e.sprite,n,".json"),fetch(p,{credentials:"same-origin"}))})).then((function(t){if(t.ok)return t.json();a(new Error("Problem fetching sprite from "+p+": "+t.statusText))})).then((function(t){if(void 0===t||0===Object.keys(t).length)return a(new Error("No sprites found."));s=t,u=oy(e.sprite,n,c+".png"),h()})).catch((function(t){a(new Error("Sprites cannot be loaded: "+p+": "+t.message))}))}else h()}))}new Hg;var sy=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function uy(t){return 0!==t.indexOf("mapbox://")?"":t.slice("mapbox://".length)}var ly=function(t){function e(e){var r=t.call(this,L)||this;return r.error=e,r}return sy(e,t),e}(h),hy="vector",cy=function(t){function e(e){var r=this,n=!("declutter"in e)||e.declutter,i=new ff({state:Ci,format:new ag});return(r=t.call(this,{source:i,declutter:n,className:e.className,opacity:e.opacity,visible:e.visible,zIndex:e.zIndex,minResolution:e.minResolution,maxResolution:e.maxResolution,minZoom:e.minZoom,maxZoom:e.maxZoom,renderOrder:e.renderOrder,renderBuffer:e.renderBuffer,renderMode:e.renderMode,map:e.map,updateWhileAnimating:e.updateWhileAnimating,updateWhileInteracting:e.updateWhileInteracting,preload:e.preload,useInterimTilesOnError:e.useInterimTilesOnError})||this).sourceId=e.source,r.layers=e.layers,r.accessToken=e.accessToken,r.fetchStyle(e.styleUrl),r}return sy(e,t),e.prototype.fetchStyle=function(t){var e=this,r=function(t,e){var r=uy(t);if(!r)return t;if(0!==r.indexOf("styles/"))throw new Error("unexpected style url: "+t);return"https://api.mapbox.com/styles/v1/"+r.slice("styles/".length)+"?&access_token="+e}(t,this.accessToken);fetch(r).then((function(t){if(!t.ok)throw new Error("unexpected response when fetching style: "+t.status);return t.json()})).then((function(t){e.onStyleLoad(t)})).catch((function(t){e.handleError(t)}))},e.prototype.onStyleLoad=function(t){var e,r,n=this;if(this.layers){for(var i={},o=0;o<t.layers.length;++o){var a=t.layers[o];a.source&&(i[a.id]=a.source)}var s=void 0;for(o=0;o<this.layers.length;++o){var u=i[this.layers[o]];if(!u)return void this.handleError(new Error("could not find source for "+this.layers[o]));if(s){if(s!==u)return void this.handleError(new Error("layers can only use a single source, found "+s+" and "+u))}else s=u}e=s,r=this.layers}else r=e=this.sourceId;r||(r=e=Object.keys(t.sources)[0]),t.sprite&&(t.sprite=function(t,e){var r=uy(t);if(!r)return t;if(0!==r.indexOf("sprites/"))throw new Error("unexpected sprites url: "+t);return"https://api.mapbox.com/styles/v1/"+r.slice("sprites/".length)+"/sprite?access_token="+e}(t.sprite,this.accessToken)),t.glyphs&&(t.glyphs=function(t,e){var r=uy(t);if(!r)return t;if(0!==r.indexOf("fonts/"))throw new Error("unexpected fonts url: "+t);return"https://api.mapbox.com/fonts/v1/"+r.slice("fonts/".length)+"/0-255.pbf?access_token="+e}(t.glyphs,this.accessToken));var l=t.sources[e];if(l.type===hy){var h,c,p,f=this.getSource();f.setUrl((h=l.url,c=this.accessToken,(p=uy(h))?"https://{a-d}.tiles.mapbox.com/v4/"+p+"/{z}/{x}/{y}.vector.pbf?access_token="+c:h)),ay(this,t,r).then((function(){f.setState(Pi)})).catch((function(t){n.handleError(t)}))}else this.handleError(new Error("only works for vector sources, found "+l.type))},e.prototype.handleError=function(t){this.dispatchEvent(new ly(t)),this.getSource().setState(Ri)},e}(ug),py=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),fy=function(t){function e(e){var r=this,n=e||{},i=T({},n);return delete i.imageRatio,(r=t.call(this,i)||this).imageRatio_=void 0!==n.imageRatio?n.imageRatio:1,r}return py(e,t),e.prototype.getImageRatio=function(){return this.imageRatio_},e.prototype.createRenderer=function(){return new gd(this)},e}(xf),dy=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),gy="addfeatures",yy=function(t){function e(e,r,n,i){var o=t.call(this,e)||this;return o.features=n,o.file=r,o.projection=i,o}return dy(e,t),e}(h),my=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,{handleEvent:x})||this).formatConstructors_=n.formatConstructors?n.formatConstructors:[],r.projection_=n.projection?yr(n.projection):null,r.dropListenKeys_=null,r.source_=n.source||null,r.target=n.target?n.target:null,r}return dy(e,t),e.prototype.handleResult_=function(t,e){var r=e.target.result,n=this.getMap(),i=this.projection_;i||(i=n.getView().getProjection());for(var o=this.formatConstructors_,a=0,s=o.length;a<s;++a){var u=new o[a],l=this.tryReadFeatures_(u,r,{featureProjection:i});if(l&&l.length>0){this.source_&&(this.source_.clear(),this.source_.addFeatures(l)),this.dispatchEvent(new yy(gy,t,l,i));break}}},e.prototype.registerListeners_=function(){var t=this.getMap();if(t){var e=this.target?this.target:t.getViewport();this.dropListenKeys_=[W(e,G,this.handleDrop,this),W(e,N,this.handleStop,this),W(e,j,this.handleStop,this),W(e,G,this.handleStop,this)]}},e.prototype.setActive=function(e){!this.getActive()&&e&&this.registerListeners_(),this.getActive()&&!e&&this.unregisterListeners_(),t.prototype.setActive.call(this,e)},e.prototype.setMap=function(e){this.unregisterListeners_(),t.prototype.setMap.call(this,e),this.getActive()&&this.registerListeners_()},e.prototype.tryReadFeatures_=function(t,e,r){try{return t.readFeatures(e,r)}catch(t){return null}},e.prototype.unregisterListeners_=function(){this.dropListenKeys_&&(this.dropListenKeys_.forEach(X),this.dropListenKeys_=null)},e.prototype.handleDrop=function(t){for(var e=t.dataTransfer.files,r=0,n=e.length;r<n;++r){var i=e.item(r),o=new FileReader;o.addEventListener(U,this.handleResult_.bind(this,i)),o.readAsText(i)}},e.prototype.handleStop=function(t){t.stopPropagation(),t.preventDefault(),t.dataTransfer.dropEffect="copy"},e}(es),vy=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),_y=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,n)||this).condition_=n.condition?n.condition:ms,r.lastAngle_=void 0,r.lastMagnitude_=void 0,r.lastScaleDelta_=0,r.duration_=void 0!==n.duration?n.duration:400,r}return vy(e,t),e.prototype.handleDragEvent=function(t){if(_s(t)){var e=t.map,r=e.getSize(),n=t.pixel,i=n[0]-r[0]/2,o=r[1]/2-n[1],a=Math.atan2(o,i),s=Math.sqrt(i*i+o*o),u=e.getView();if(void 0!==this.lastAngle_){var l=this.lastAngle_-a;u.adjustRotationInternal(l)}this.lastAngle_=a,void 0!==this.lastMagnitude_&&u.adjustResolutionInternal(this.lastMagnitude_/s),void 0!==this.lastMagnitude_&&(this.lastScaleDelta_=this.lastMagnitude_/s),this.lastMagnitude_=s}},e.prototype.handleUpEvent=function(t){if(!_s(t))return!0;var e=t.map.getView(),r=this.lastScaleDelta_>1?1:-1;return e.endInteraction(this.duration_,r),this.lastScaleDelta_=0,!1},e.prototype.handleDownEvent=function(t){return!!_s(t)&&(!!this.condition_(t)&&(t.map.getView().beginInteraction(),this.lastAngle_=void 0,this.lastMagnitude_=void 0,!0))},e}(as),by=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),xy=function(t){function e(e,r,n){var i=t.call(this)||this;if(void 0!==n&&void 0===r)i.setFlatCoordinates(n,e);else{var o=r||0;i.setCenterAndRadius(e,o,n)}return i}return by(e,t),e.prototype.clone=function(){return new e(this.flatCoordinates.slice(),void 0,this.layout)},e.prototype.closestPointXY=function(t,e,r,n){var i=this.flatCoordinates,o=t-i[0],a=e-i[1],s=o*o+a*a;if(s<n){if(0===s)for(var u=0;u<this.stride;++u)r[u]=i[u];else{var l=this.getRadius()/Math.sqrt(s);r[0]=i[0]+l*o,r[1]=i[1]+l*a;for(u=2;u<this.stride;++u)r[u]=i[u]}return r.length=this.stride,s}return n},e.prototype.containsXY=function(t,e){var r=this.flatCoordinates,n=t-r[0],i=e-r[1];return n*n+i*i<=this.getRadiusSquared_()},e.prototype.getCenter=function(){return this.flatCoordinates.slice(0,this.stride)},e.prototype.computeExtent=function(t){var e=this.flatCoordinates,r=e[this.stride]-e[0];return Zt(e[0]-r,e[1]-r,e[0]+r,e[1]+r,t)},e.prototype.getRadius=function(){return Math.sqrt(this.getRadiusSquared_())},e.prototype.getRadiusSquared_=function(){var t=this.flatCoordinates[this.stride]-this.flatCoordinates[0],e=this.flatCoordinates[this.stride+1]-this.flatCoordinates[1];return t*t+e*e},e.prototype.getType=function(){return yt.CIRCLE},e.prototype.intersectsExtent=function(t){if(ye(t,this.getExtent())){var e=this.getCenter();return t[0]<=e[0]&&t[2]>=e[0]||(t[1]<=e[1]&&t[3]>=e[1]||ie(t,this.intersectsCoordinate.bind(this)))}return!1},e.prototype.setCenter=function(t){var e=this.stride,r=this.flatCoordinates[e]-this.flatCoordinates[0],n=t.slice();n[e]=n[0]+r;for(var i=1;i<e;++i)n[e+i]=t[i];this.setFlatCoordinates(this.layout,n),this.changed()},e.prototype.setCenterAndRadius=function(t,e,r){this.setLayout(r,t,0),this.flatCoordinates||(this.flatCoordinates=[]);var n=this.flatCoordinates,i=$r(n,0,t,this.stride);n[i++]=n[0]+e;for(var o=1,a=this.stride;o<a;++o)n[i++]=n[o];n.length=i,this.changed()},e.prototype.getCoordinates=function(){return null},e.prototype.setCoordinates=function(t,e){},e.prototype.setRadius=function(t){this.flatCoordinates[this.stride]=this.flatCoordinates[0]+t,this.changed()},e.prototype.rotate=function(t,e){var r=this.getCenter(),n=this.getStride();this.setCenter(Dr(r,0,r.length,n,t,e,r)),this.changed()},e.prototype.translate=function(t,e){var r=this.getCenter(),n=this.getStride();this.setCenter(zr(r,0,r.length,n,t,e,r)),this.changed()},e}(qr);xy.prototype.transform;var wy=xy,Sy=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ty="Point",Ey="LineString",Cy="Polygon",Py="Circle",Ry="drawstart",Oy="drawend",Iy="drawabort",Ly=function(t){function e(e,r){var n=t.call(this,e)||this;return n.feature=r,n}return Sy(e,t),e}(h);var My=function(t){function e(e){var r=this,n=e;n.stopDown||(n.stopDown=w),(r=t.call(this,n)||this).shouldHandle_=!1,r.downPx_=null,r.downTimeout_,r.lastDragTime_,r.freehand_=!1,r.source_=e.source?e.source:null,r.features_=e.features?e.features:null,r.snapTolerance_=e.snapTolerance?e.snapTolerance:12,r.type_=e.type,r.mode_=function(t){var e;t===yt.POINT||t===yt.MULTI_POINT?e=Ty:t===yt.LINE_STRING||t===yt.MULTI_LINE_STRING?e=Ey:t===yt.POLYGON||t===yt.MULTI_POLYGON?e=Cy:t===yt.CIRCLE&&(e=Py);return e}(r.type_),r.stopClick_=!!e.stopClick,r.minPoints_=e.minPoints?e.minPoints:r.mode_===Cy?3:2,r.maxPoints_=e.maxPoints?e.maxPoints:1/0,r.finishCondition_=e.finishCondition?e.finishCondition:x;var i,o=e.geometryFunction;if(!o)if(r.type_===yt.CIRCLE)o=function(t,e,r){var n=e||new wy([NaN,NaN]),i=Ar(t[0],r),o=sr(i,Ar(t[1],r));n.setCenterAndRadius(i,Math.sqrt(o));var a=Mr();return a&&n.transform(r,a),n};else{var a,s=r.mode_;s===Ty?a=gn:s===Ey?a=Cd:s===Cy&&(a=Ln),o=function(t,e,r){var n=e;return n?s===Cy?t[0].length?n.setCoordinates([t[0].concat([t[0][0]])]):n.setCoordinates([]):n.setCoordinates(t):n=new a(t),n}}return r.geometryFunction_=o,r.dragVertexDelay_=void 0!==e.dragVertexDelay?e.dragVertexDelay:500,r.finishCoordinate_=null,r.sketchFeature_=null,r.sketchPoint_=null,r.sketchCoords_=null,r.sketchLine_=null,r.sketchLineCoords_=null,r.squaredClickTolerance_=e.clickTolerance?e.clickTolerance*e.clickTolerance:36,r.overlay_=new Rd({source:new cc({useSpatialIndex:!1,wrapX:!!e.wrapX&&e.wrapX}),style:e.style?e.style:(i=sh(),function(t,e){return i[t.getGeometry().getType()]}),updateWhileInteracting:!0}),r.geometryName_=e.geometryName,r.condition_=e.condition?e.condition:ys,r.freehandCondition_,e.freehand?r.freehandCondition_=ps:r.freehandCondition_=e.freehandCondition?e.freehandCondition:ms,r.addEventListener(et($a),r.updateState_),r}return Sy(e,t),e.prototype.setMap=function(e){t.prototype.setMap.call(this,e),this.updateState_()},e.prototype.getOverlay=function(){return this.overlay_},e.prototype.handleEvent=function(e){e.originalEvent.type===F&&e.preventDefault(),this.freehand_=this.mode_!==Ty&&this.freehandCondition_(e);var r=e.type===Ho.POINTERMOVE,n=!0;!this.freehand_&&this.lastDragTime_&&e.type===Ho.POINTERDRAG&&(Date.now()-this.lastDragTime_>=this.dragVertexDelay_?(this.downPx_=e.pixel,this.shouldHandle_=!this.freehand_,r=!0):this.lastDragTime_=void 0,this.shouldHandle_&&void 0!==this.downTimeout_&&(clearTimeout(this.downTimeout_),this.downTimeout_=void 0));return this.freehand_&&e.type===Ho.POINTERDRAG&&null!==this.sketchFeature_?(this.addToDrawing_(e.coordinate),n=!1):this.freehand_&&e.type===Ho.POINTERDOWN?n=!1:r?(n=e.type===Ho.POINTERMOVE)&&this.freehand_?(this.handlePointerMove_(e),this.shouldHandle_&&e.preventDefault()):("mouse"==e.originalEvent.pointerType||e.type===Ho.POINTERDRAG&&void 0===this.downTimeout_)&&this.handlePointerMove_(e):e.type===Ho.DBLCLICK&&(n=!1),t.prototype.handleEvent.call(this,e)&&n},e.prototype.handleDownEvent=function(t){return this.shouldHandle_=!this.freehand_,this.freehand_?(this.downPx_=t.pixel,this.finishCoordinate_||this.startDrawing_(t),!0):this.condition_(t)?(this.lastDragTime_=Date.now(),this.downTimeout_=setTimeout(function(){this.handlePointerMove_(new Ko(Ho.POINTERMOVE,t.map,t.originalEvent,!1,t.frameState))}.bind(this),this.dragVertexDelay_),this.downPx_=t.pixel,!0):(this.lastDragTime_=void 0,!1)},e.prototype.handleUpEvent=function(t){var e=!0;this.downTimeout_&&(clearTimeout(this.downTimeout_),this.downTimeout_=void 0),this.handlePointerMove_(t);var r=this.mode_===Py;return this.shouldHandle_?(this.finishCoordinate_?this.freehand_||r?this.finishDrawing():this.atFinish_(t)?this.finishCondition_(t)&&this.finishDrawing():this.addToDrawing_(t.coordinate):(this.startDrawing_(t),this.mode_===Ty&&this.finishDrawing()),e=!1):this.freehand_&&this.abortDrawing(),!e&&this.stopClick_&&t.stopPropagation(),e},e.prototype.handlePointerMove_=function(t){if(this.downPx_&&(!this.freehand_&&this.shouldHandle_||this.freehand_&&!this.shouldHandle_)){var e=this.downPx_,r=t.pixel,n=e[0]-r[0],i=e[1]-r[1],o=n*n+i*i;if(this.shouldHandle_=this.freehand_?o>this.squaredClickTolerance_:o<=this.squaredClickTolerance_,!this.shouldHandle_)return}this.finishCoordinate_?this.modifyDrawing_(t):this.createOrUpdateSketchPoint_(t)},e.prototype.atFinish_=function(t){var e=!1;if(this.sketchFeature_){var r=!1,n=[this.finishCoordinate_];if(this.mode_===Ey)r=this.sketchCoords_.length>this.minPoints_;else if(this.mode_===Cy){var i=this.sketchCoords_;r=i[0].length>this.minPoints_,n=[i[0][0],i[0][i[0].length-2]]}if(r)for(var o=t.map,a=0,s=n.length;a<s;a++){var u=n[a],l=o.getPixelFromCoordinate(u),h=t.pixel,c=h[0]-l[0],p=h[1]-l[1],f=this.freehand_?1:this.snapTolerance_;if(e=Math.sqrt(c*c+p*p)<=f){this.finishCoordinate_=u;break}}}return e},e.prototype.createOrUpdateSketchPoint_=function(t){var e=t.coordinate.slice();this.sketchPoint_?this.sketchPoint_.getGeometry().setCoordinates(e):(this.sketchPoint_=new ct(new gn(e)),this.updateSketchFeatures_())},e.prototype.startDrawing_=function(t){var e=t.coordinate,r=t.map.getView().getProjection();this.finishCoordinate_=e,this.mode_===Ty?this.sketchCoords_=e.slice():this.mode_===Cy?(this.sketchCoords_=[[e.slice(),e.slice()]],this.sketchLineCoords_=this.sketchCoords_[0]):this.sketchCoords_=[e.slice(),e.slice()],this.sketchLineCoords_&&(this.sketchLine_=new ct(new Cd(this.sketchLineCoords_)));var n=this.geometryFunction_(this.sketchCoords_,void 0,r);this.sketchFeature_=new ct,this.geometryName_&&this.sketchFeature_.setGeometryName(this.geometryName_),this.sketchFeature_.setGeometry(n),this.updateSketchFeatures_(),this.dispatchEvent(new Ly(Ry,this.sketchFeature_))},e.prototype.modifyDrawing_=function(t){var e,r,n,i=t.coordinate,o=this.sketchFeature_.getGeometry(),a=t.map.getView().getProjection();(this.mode_===Ty?r=this.sketchCoords_:this.mode_===Cy?(r=(e=this.sketchCoords_[0])[e.length-1],this.atFinish_(t)&&(i=this.finishCoordinate_.slice())):r=(e=this.sketchCoords_)[e.length-1],r[0]=i[0],r[1]=i[1],this.geometryFunction_(this.sketchCoords_,o,a),this.sketchPoint_)&&this.sketchPoint_.getGeometry().setCoordinates(i);if(o.getType()==yt.POLYGON&&this.mode_!==Cy){this.sketchLine_||(this.sketchLine_=new ct);var s=o.getLinearRing(0);(n=this.sketchLine_.getGeometry())?(n.setFlatCoordinates(s.getLayout(),s.getFlatCoordinates()),n.changed()):(n=new Cd(s.getFlatCoordinates(),s.getLayout()),this.sketchLine_.setGeometry(n))}else this.sketchLineCoords_&&(n=this.sketchLine_.getGeometry()).setCoordinates(this.sketchLineCoords_);this.updateSketchFeatures_()},e.prototype.addToDrawing_=function(t){var e,r,n=this.sketchFeature_.getGeometry(),i=this.getMap().getView().getProjection();this.mode_===Ey?(this.finishCoordinate_=t.slice(),(r=this.sketchCoords_).length>=this.maxPoints_&&(this.freehand_?r.pop():e=!0),r.push(t.slice()),this.geometryFunction_(r,n,i)):this.mode_===Cy&&((r=this.sketchCoords_[0]).length>=this.maxPoints_&&(this.freehand_?r.pop():e=!0),r.push(t.slice()),e&&(this.finishCoordinate_=r[0]),this.geometryFunction_(this.sketchCoords_,n,i)),this.updateSketchFeatures_(),e&&this.finishDrawing()},e.prototype.removeLastPoint=function(){if(this.sketchFeature_){var t,e=this.sketchFeature_.getGeometry(),r=this.getMap().getView().getProjection();this.mode_===Ey?((t=this.sketchCoords_).splice(-2,1),this.geometryFunction_(t,e,r),t.length>=2&&(this.finishCoordinate_=t[t.length-2].slice())):this.mode_===Cy&&((t=this.sketchCoords_[0]).splice(-2,1),this.sketchLine_.getGeometry().setCoordinates(t),this.geometryFunction_(this.sketchCoords_,e,r)),0===t.length&&this.abortDrawing(),this.updateSketchFeatures_()}},e.prototype.finishDrawing=function(){var t=this.abortDrawing_();if(t){var e=this.sketchCoords_,r=t.getGeometry(),n=this.getMap().getView().getProjection();this.mode_===Ey?(e.pop(),this.geometryFunction_(e,r,n)):this.mode_===Cy&&(e[0].pop(),this.geometryFunction_(e,r,n),e=r.getCoordinates()),this.type_===yt.MULTI_POINT?t.setGeometry(new qd([e])):this.type_===yt.MULTI_LINE_STRING?t.setGeometry(new Vd([e])):this.type_===yt.MULTI_POLYGON&&t.setGeometry(new Kd([e])),this.dispatchEvent(new Ly(Oy,t)),this.features_&&this.features_.push(t),this.source_&&this.source_.addFeature(t)}},e.prototype.abortDrawing_=function(){this.finishCoordinate_=null;var t=this.sketchFeature_;return this.sketchFeature_=null,this.sketchPoint_=null,this.sketchLine_=null,this.overlay_.getSource().clear(!0),t},e.prototype.abortDrawing=function(){var t=this.abortDrawing_();t&&this.dispatchEvent(new Ly(Iy,t))},e.prototype.appendCoordinates=function(t){var e=this.mode_,r=[];e===Ey?r=this.sketchCoords_:e===Cy&&(r=this.sketchCoords_&&this.sketchCoords_.length?this.sketchCoords_[0]:[]);for(var n=r.pop(),i=0;i<t.length;i++)this.addToDrawing_(t[i]);this.addToDrawing_(n)},e.prototype.extend=function(t){var e=t.getGeometry();this.sketchFeature_=t,this.sketchCoords_=e.getCoordinates();var r=this.sketchCoords_[this.sketchCoords_.length-1];this.finishCoordinate_=r.slice(),this.sketchCoords_.push(r.slice()),this.updateSketchFeatures_(),this.dispatchEvent(new Ly(Ry,this.sketchFeature_))},e.prototype.updateSketchFeatures_=function(){var t=[];this.sketchFeature_&&t.push(this.sketchFeature_),this.sketchLine_&&t.push(this.sketchLine_),this.sketchPoint_&&t.push(this.sketchPoint_);var e=this.overlay_.getSource();e.clear(!0),e.addFeatures(t)},e.prototype.updateState_=function(){var t=this.getMap(),e=this.getActive();t&&e||this.abortDrawing(),this.overlay_.setMap(e?t:null)},e}(as),Fy=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ay="extentchanged",ky=function(t){function e(e){var r=t.call(this,Ay)||this;return r.extent=e,r}return Fy(e,t),e}(h);function Ny(){var t=sh();return function(e,r){return t[yt.POINT]}}function jy(t){return function(e){return Dt([t,e])}}function Gy(t,e){return t[0]==e[0]?function(r){return Dt([t,[r[0],e[1]]])}:t[1]==e[1]?function(r){return Dt([t,[e[0],r[1]]])}:null}var Dy=function(t){function e(e){var r,n=this,i=e||{};return(n=t.call(this,i)||this).condition_=i.condition?i.condition:ps,n.extent_=null,n.pointerHandler_=null,n.pixelTolerance_=void 0!==i.pixelTolerance?i.pixelTolerance:10,n.snappedToVertex_=!1,n.extentFeature_=null,n.vertexFeature_=null,e||(e={}),n.extentOverlay_=new Rd({source:new cc({useSpatialIndex:!1,wrapX:!!e.wrapX}),style:e.boxStyle?e.boxStyle:(r=sh(),function(t,e){return r[yt.POLYGON]}),updateWhileAnimating:!0,updateWhileInteracting:!0}),n.vertexOverlay_=new Rd({source:new cc({useSpatialIndex:!1,wrapX:!!e.wrapX}),style:e.pointerStyle?e.pointerStyle:Ny(),updateWhileAnimating:!0,updateWhileInteracting:!0}),e.extent&&n.setExtent(e.extent),n}return Fy(e,t),e.prototype.snapToVertex_=function(t,e){var r=e.getCoordinateFromPixelInternal(t),n=this.getExtentInternal();if(n){var i=function(t){return[[[t[0],t[1]],[t[0],t[3]]],[[t[0],t[3]],[t[2],t[3]]],[[t[2],t[3]],[t[2],t[1]]],[[t[2],t[1]],[t[0],t[1]]]]}(n);i.sort((function(t,e){return lr(r,t)-lr(r,e)}));var o=i[0],a=er(r,o),s=e.getPixelFromCoordinateInternal(a);if(ur(t,s)<=this.pixelTolerance_){var u=e.getPixelFromCoordinateInternal(o[0]),l=e.getPixelFromCoordinateInternal(o[1]),h=sr(s,u),c=sr(s,l),p=Math.sqrt(Math.min(h,c));return this.snappedToVertex_=p<=this.pixelTolerance_,this.snappedToVertex_&&(a=h>c?o[1]:o[0]),a}}return null},e.prototype.handlePointerMove_=function(t){var e=t.pixel,r=t.map,n=this.snapToVertex_(e,r);n||(n=r.getCoordinateFromPixelInternal(e)),this.createOrUpdatePointerFeature_(n)},e.prototype.createOrUpdateExtentFeature_=function(t){var e=this.extentFeature_;return e?t?e.setGeometry(Fn(t)):e.setGeometry(void 0):(e=new ct(t?Fn(t):{}),this.extentFeature_=e,this.extentOverlay_.getSource().addFeature(e)),e},e.prototype.createOrUpdatePointerFeature_=function(t){var e=this.vertexFeature_;e?e.getGeometry().setCoordinates(t):(e=new ct(new gn(t)),this.vertexFeature_=e,this.vertexOverlay_.getSource().addFeature(e));return e},e.prototype.handleEvent=function(e){return!e.originalEvent||!this.condition_(e)||(e.type!=Ho.POINTERMOVE||this.handlingDownUpSequence||this.handlePointerMove_(e),t.prototype.handleEvent.call(this,e),!1)},e.prototype.handleDownEvent=function(t){var e=t.pixel,r=t.map,n=this.getExtentInternal(),i=this.snapToVertex_(e,r),o=function(t){var e=null,r=null;return t[0]==n[0]?e=n[2]:t[0]==n[2]&&(e=n[0]),t[1]==n[1]?r=n[3]:t[1]==n[3]&&(r=n[1]),null!==e&&null!==r?[e,r]:null};if(i&&n){var a=i[0]==n[0]||i[0]==n[2]?i[0]:null,s=i[1]==n[1]||i[1]==n[3]?i[1]:null;null!==a&&null!==s?this.pointerHandler_=jy(o(i)):null!==a?this.pointerHandler_=Gy(o([a,n[1]]),o([a,n[3]])):null!==s&&(this.pointerHandler_=Gy(o([n[0],s]),o([n[2],s])))}else i=r.getCoordinateFromPixelInternal(e),this.setExtent([i[0],i[1],i[0],i[1]]),this.pointerHandler_=jy(i);return!0},e.prototype.handleDragEvent=function(t){if(this.pointerHandler_){var e=t.coordinate;this.setExtent(this.pointerHandler_(e)),this.createOrUpdatePointerFeature_(e)}},e.prototype.handleUpEvent=function(t){this.pointerHandler_=null;var e=this.getExtentInternal();return e&&0!==oe(e)||this.setExtent(null),!1},e.prototype.setMap=function(e){this.extentOverlay_.setMap(e),this.vertexOverlay_.setMap(e),t.prototype.setMap.call(this,e)},e.prototype.getExtent=function(){return kr(this.getExtentInternal(),this.getMap().getView().getProjection())},e.prototype.getExtentInternal=function(){return this.extent_},e.prototype.setExtent=function(t){this.extent_=t||null,this.createOrUpdateExtentFeature_(t),this.dispatchEvent(new ky(this.extent_))},e}(as),zy=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Uy=[0,0,0,0],By=[],Yy="modifystart",Vy="modifyend",Wy=function(t){function e(e,r,n){var i=t.call(this,e)||this;return i.features=r,i.mapBrowserEvent=n,i}return zy(e,t),e}(h);function qy(t,e){return t.index-e.index}function Xy(t,e,r){var n=e.geometry;if(n.getType()===yt.CIRCLE){var i=n;if(1===e.index){var o=Mr();o&&(i=i.clone().transform(o,r));var a=sr(i.getCenter(),Ar(t,r)),s=Math.sqrt(a)-i.getRadius();return s*s}}var u=Ar(t,r);return By[0]=Ar(e.segment[0],r),By[1]=Ar(e.segment[1],r),lr(u,By)}function Zy(t,e,r){var n=e.geometry;if(n.getType()===yt.CIRCLE&&1===e.index){var i=n,o=Mr();return o&&(i=i.clone().transform(o,r)),Fr(i.getClosestPoint(Ar(t,r)),r)}var a=Ar(t,r);return By[0]=Ar(e.segment[0],r),By[1]=Ar(e.segment[1],r),Fr(er(a,By),r)}var Ky=function(t){function e(e){var r,n,i=t.call(this,e)||this;if(i.boundHandleFeatureChange_=i.handleFeatureChange_.bind(i),i.condition_=e.condition?e.condition:bs,i.defaultDeleteCondition_=function(t){return us(t)&&gs(t)},i.deleteCondition_=e.deleteCondition?e.deleteCondition:i.defaultDeleteCondition_,i.insertVertexCondition_=e.insertVertexCondition?e.insertVertexCondition:ps,i.vertexFeature_=null,i.vertexSegments_=null,i.lastPixel_=[0,0],i.ignoreNextSingleClick_=!1,i.modified_=!1,i.rBush_=new ic,i.pixelTolerance_=void 0!==e.pixelTolerance?e.pixelTolerance:10,i.snappedToVertex_=!1,i.changingFeature_=!1,i.dragSegments_=[],i.overlay_=new Rd({source:new cc({useSpatialIndex:!1,wrapX:!!e.wrapX}),style:e.style?e.style:(r=sh(),function(t,e){return r[yt.POINT]}),updateWhileAnimating:!0,updateWhileInteracting:!0}),i.SEGMENT_WRITERS_={Point:i.writePointGeometry_.bind(i),LineString:i.writeLineStringGeometry_.bind(i),LinearRing:i.writeLineStringGeometry_.bind(i),Polygon:i.writePolygonGeometry_.bind(i),MultiPoint:i.writeMultiPointGeometry_.bind(i),MultiLineString:i.writeMultiLineStringGeometry_.bind(i),MultiPolygon:i.writeMultiPolygonGeometry_.bind(i),Circle:i.writeCircleGeometry_.bind(i),GeometryCollection:i.writeGeometryCollectionGeometry_.bind(i)},i.source_=null,e.source?(i.source_=e.source,n=new ut(i.source_.getFeatures()),i.source_.addEventListener(oc,i.handleSourceAdd_.bind(i)),i.source_.addEventListener(uc,i.handleSourceRemove_.bind(i))):n=e.features,!n)throw new Error("The modify interaction requires features or a source");return i.features_=n,i.features_.forEach(i.addFeature_.bind(i)),i.features_.addEventListener(nt,i.handleFeatureAdd_.bind(i)),i.features_.addEventListener(it,i.handleFeatureRemove_.bind(i)),i.lastPointerEvent_=null,i}return zy(e,t),e.prototype.addFeature_=function(t){var e=t.getGeometry();if(e){var r=this.SEGMENT_WRITERS_[e.getType()];r&&r(t,e)}var n=this.getMap();n&&n.isRendered()&&this.getActive()&&this.handlePointerAtPixel_(this.lastPixel_,n),t.addEventListener(I,this.boundHandleFeatureChange_)},e.prototype.willModifyFeatures_=function(t){this.modified_||(this.modified_=!0,this.dispatchEvent(new Wy(Yy,this.features_,t)))},e.prototype.removeFeature_=function(t){this.removeFeatureSegmentData_(t),this.vertexFeature_&&0===this.features_.getLength()&&(this.overlay_.getSource().removeFeature(this.vertexFeature_),this.vertexFeature_=null),t.removeEventListener(I,this.boundHandleFeatureChange_)},e.prototype.removeFeatureSegmentData_=function(t){var e=this.rBush_,r=[];e.forEach((function(e){t===e.feature&&r.push(e)}));for(var n=r.length-1;n>=0;--n){for(var i=r[n],o=this.dragSegments_.length-1;o>=0;--o)this.dragSegments_[o][0]===i&&this.dragSegments_.splice(o,1);e.remove(i)}},e.prototype.setActive=function(e){this.vertexFeature_&&!e&&(this.overlay_.getSource().removeFeature(this.vertexFeature_),this.vertexFeature_=null),t.prototype.setActive.call(this,e)},e.prototype.setMap=function(e){this.overlay_.setMap(e),t.prototype.setMap.call(this,e)},e.prototype.getOverlay=function(){return this.overlay_},e.prototype.handleSourceAdd_=function(t){t.feature&&this.features_.push(t.feature)},e.prototype.handleSourceRemove_=function(t){t.feature&&this.features_.remove(t.feature)},e.prototype.handleFeatureAdd_=function(t){this.addFeature_(t.element)},e.prototype.handleFeatureChange_=function(t){if(!this.changingFeature_){var e=t.target;this.removeFeature_(e),this.addFeature_(e)}},e.prototype.handleFeatureRemove_=function(t){var e=t.element;this.removeFeature_(e)},e.prototype.writePointGeometry_=function(t,e){var r=e.getCoordinates(),n={feature:t,geometry:e,segment:[r,r]};this.rBush_.insert(e.getExtent(),n)},e.prototype.writeMultiPointGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length;n<i;++n){var o=r[n],a={feature:t,geometry:e,depth:[n],index:n,segment:[o,o]};this.rBush_.insert(e.getExtent(),a)}},e.prototype.writeLineStringGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length-1;n<i;++n){var o=r.slice(n,n+2),a={feature:t,geometry:e,index:n,segment:o};this.rBush_.insert(Dt(o),a)}},e.prototype.writeMultiLineStringGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length;n<i;++n)for(var o=r[n],a=0,s=o.length-1;a<s;++a){var u=o.slice(a,a+2),l={feature:t,geometry:e,depth:[n],index:a,segment:u};this.rBush_.insert(Dt(u),l)}},e.prototype.writePolygonGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length;n<i;++n)for(var o=r[n],a=0,s=o.length-1;a<s;++a){var u=o.slice(a,a+2),l={feature:t,geometry:e,depth:[n],index:a,segment:u};this.rBush_.insert(Dt(u),l)}},e.prototype.writeMultiPolygonGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length;n<i;++n)for(var o=r[n],a=0,s=o.length;a<s;++a)for(var u=o[a],l=0,h=u.length-1;l<h;++l){var c=u.slice(l,l+2),p={feature:t,geometry:e,depth:[a,n],index:l,segment:c};this.rBush_.insert(Dt(c),p)}},e.prototype.writeCircleGeometry_=function(t,e){var r=e.getCenter(),n={feature:t,geometry:e,index:0,segment:[r,r]},i={feature:t,geometry:e,index:1,segment:[r,r]},o=[n,i];n.featureSegments=o,i.featureSegments=o,this.rBush_.insert(Ht(r),n);var a=e,s=Mr();if(s&&this.getMap()){var u=this.getMap().getView().getProjection();a=An(a=a.clone().transform(s,u)).transform(u,s)}this.rBush_.insert(a.getExtent(),i)},e.prototype.writeGeometryCollectionGeometry_=function(t,e){for(var r=e.getGeometriesArray(),n=0;n<r.length;++n){var i=r[n];(0,this.SEGMENT_WRITERS_[i.getType()])(t,i)}},e.prototype.createOrUpdateVertexFeature_=function(t){var e=this.vertexFeature_;e?e.getGeometry().setCoordinates(t):(e=new ct(new gn(t)),this.vertexFeature_=e,this.overlay_.getSource().addFeature(e));return e},e.prototype.handleEvent=function(e){return!e.originalEvent||(this.lastPointerEvent_=e,e.map.getView().getInteracting()||e.type!=Ho.POINTERMOVE||this.handlingDownUpSequence||this.handlePointerMove_(e),this.vertexFeature_&&this.deleteCondition_(e)&&(r=!(e.type!=Ho.SINGLECLICK||!this.ignoreNextSingleClick_)||this.removePoint()),e.type==Ho.SINGLECLICK&&(this.ignoreNextSingleClick_=!1),t.prototype.handleEvent.call(this,e)&&!r);var r},e.prototype.handleDragEvent=function(t){this.ignoreNextSingleClick_=!1,this.willModifyFeatures_(t);for(var e=t.coordinate,r=0,n=this.dragSegments_.length;r<n;++r){for(var i=this.dragSegments_[r],o=i[0],a=o.depth,s=o.geometry,u=void 0,l=o.segment,h=i[1];e.length<s.getStride();)e.push(l[h][e.length]);switch(s.getType()){case yt.POINT:u=e,l[0]=e,l[1]=e;break;case yt.MULTI_POINT:(u=s.getCoordinates())[o.index]=e,l[0]=e,l[1]=e;break;case yt.LINE_STRING:(u=s.getCoordinates())[o.index+h]=e,l[h]=e;break;case yt.MULTI_LINE_STRING:case yt.POLYGON:(u=s.getCoordinates())[a[0]][o.index+h]=e,l[h]=e;break;case yt.MULTI_POLYGON:(u=s.getCoordinates())[a[1]][a[0]][o.index+h]=e,l[h]=e;break;case yt.CIRCLE:if(l[0]=e,l[1]=e,0===o.index)this.changingFeature_=!0,s.setCenter(e),this.changingFeature_=!1;else{this.changingFeature_=!0;var c=t.map.getView().getProjection(),p=ur(Ar(s.getCenter(),c),Ar(e,c)),f=Mr();if(f){var d=s.clone().transform(f,c);d.setRadius(p),p=d.transform(c,f).getRadius()}s.setRadius(p),this.changingFeature_=!1}}u&&this.setGeometryCoordinates_(s,u)}this.createOrUpdateVertexFeature_(e)},e.prototype.handleDownEvent=function(t){if(!this.condition_(t))return!1;var e=t.coordinate;this.handlePointerAtPixel_(t.pixel,t.map,e),this.dragSegments_.length=0,this.modified_=!1;var r=this.vertexFeature_;if(r){var n=t.map.getView().getProjection(),i=[],a=r.getGeometry().getCoordinates(),s=Dt([a]),u=this.rBush_.getInExtent(s),l={};u.sort(qy);for(var h=0,c=u.length;h<c;++h){var p=u[h],f=p.segment,d=o(p.geometry),g=p.depth;if(g&&(d+="-"+g.join("-")),l[d]||(l[d]=new Array(2)),p.geometry.getType()!==yt.CIRCLE||1!==p.index)if(!ir(f[0],a)||l[d][0])if(!ir(f[1],a)||l[d][1])o(f)in this.vertexSegments_&&!l[d][0]&&!l[d][1]&&this.insertVertexCondition_(t)&&i.push([p,a]);else{if((p.geometry.getType()===yt.LINE_STRING||p.geometry.getType()===yt.MULTI_LINE_STRING)&&l[d][0]&&0===l[d][0].index)continue;this.dragSegments_.push([p,1]),l[d][1]=p}else this.dragSegments_.push([p,0]),l[d][0]=p;else ir(Zy(e,p,n),a)&&!l[d][0]&&(this.dragSegments_.push([p,0]),l[d][0]=p)}i.length&&this.willModifyFeatures_(t);for(var y=i.length-1;y>=0;--y)this.insertVertex_.apply(this,i[y])}return!!this.vertexFeature_},e.prototype.handleUpEvent=function(t){for(var e=this.dragSegments_.length-1;e>=0;--e){var r=this.dragSegments_[e][0],n=r.geometry;if(n.getType()===yt.CIRCLE){var i=n.getCenter(),o=r.featureSegments[0],a=r.featureSegments[1];o.segment[0]=i,o.segment[1]=i,a.segment[0]=i,a.segment[1]=i,this.rBush_.update(Ht(i),o);var s=n,u=Mr();if(u){var l=t.map.getView().getProjection();s=An(s=s.clone().transform(u,l)).transform(l,u)}this.rBush_.update(s.getExtent(),a)}else this.rBush_.update(Dt(r.segment),r)}return this.modified_&&(this.dispatchEvent(new Wy(Vy,this.features_,t)),this.modified_=!1),!1},e.prototype.handlePointerMove_=function(t){this.lastPixel_=t.pixel,this.handlePointerAtPixel_(t.pixel,t.map,t.coordinate)},e.prototype.handlePointerAtPixel_=function(t,e,r){var n=r||e.getCoordinateFromPixel(t),i=e.getView().getProjection(),a=kr(zt(Nr(Ht(n,Uy),i),e.getView().getResolution()*this.pixelTolerance_,Uy),i),s=this.rBush_.getInExtent(a);if(s.length>0){s.sort((function(t,e){return Xy(n,t,i)-Xy(n,e,i)}));var u=s[0],l=u.segment,h=Zy(n,u,i),c=e.getPixelFromCoordinate(h),p=ur(t,c);if(p<=this.pixelTolerance_){var f={};if(u.geometry.getType()===yt.CIRCLE&&1===u.index)this.snappedToVertex_=!0,this.createOrUpdateVertexFeature_(h);else{var d=e.getPixelFromCoordinate(l[0]),g=e.getPixelFromCoordinate(l[1]),y=sr(c,d),m=sr(c,g);p=Math.sqrt(Math.min(y,m)),this.snappedToVertex_=p<=this.pixelTolerance_,this.snappedToVertex_&&(h=y>m?l[1]:l[0]),this.createOrUpdateVertexFeature_(h);for(var v=1,_=s.length;v<_;++v){var b=s[v].segment;if(!(ir(l[0],b[0])&&ir(l[1],b[1])||ir(l[0],b[1])&&ir(l[1],b[0])))break;f[o(b)]=!0}}return f[o(l)]=!0,void(this.vertexSegments_=f)}}this.vertexFeature_&&(this.overlay_.getSource().removeFeature(this.vertexFeature_),this.vertexFeature_=null)},e.prototype.insertVertex_=function(t,e){for(var r,n=t.segment,i=t.feature,o=t.geometry,a=t.depth,s=t.index;e.length<o.getStride();)e.push(0);switch(o.getType()){case yt.MULTI_LINE_STRING:case yt.POLYGON:(r=o.getCoordinates())[a[0]].splice(s+1,0,e);break;case yt.MULTI_POLYGON:(r=o.getCoordinates())[a[1]][a[0]].splice(s+1,0,e);break;case yt.LINE_STRING:(r=o.getCoordinates()).splice(s+1,0,e);break;default:return}this.setGeometryCoordinates_(o,r);var u=this.rBush_;u.remove(t),this.updateSegmentIndices_(o,s,a,1);var l={segment:[n[0],e],feature:i,geometry:o,depth:a,index:s};u.insert(Dt(l.segment),l),this.dragSegments_.push([l,1]);var h={segment:[e,n[1]],feature:i,geometry:o,depth:a,index:s+1};u.insert(Dt(h.segment),h),this.dragSegments_.push([h,0]),this.ignoreNextSingleClick_=!0},e.prototype.removePoint=function(){if(this.lastPointerEvent_&&this.lastPointerEvent_.type!=Ho.POINTERDRAG){var t=this.lastPointerEvent_;this.willModifyFeatures_(t);var e=this.removeVertex_();return this.dispatchEvent(new Wy(Vy,this.features_,t)),this.modified_=!1,e}return!1},e.prototype.removeVertex_=function(){var t,e,r,n,i,a,s,u,l,h,c,p=this.dragSegments_,f={},d=!1;for(i=p.length-1;i>=0;--i)c=o((h=(r=p[i])[0]).feature),h.depth&&(c+="-"+h.depth.join("-")),c in f||(f[c]={}),0===r[1]?(f[c].right=h,f[c].index=h.index):1==r[1]&&(f[c].left=h,f[c].index=h.index+1);for(c in f){switch(l=f[c].right,s=f[c].left,(u=(a=f[c].index)-1)<0&&(u=0),t=e=(n=(h=void 0!==s?s:l).geometry).getCoordinates(),d=!1,n.getType()){case yt.MULTI_LINE_STRING:e[h.depth[0]].length>2&&(e[h.depth[0]].splice(a,1),d=!0);break;case yt.LINE_STRING:e.length>2&&(e.splice(a,1),d=!0);break;case yt.MULTI_POLYGON:t=t[h.depth[1]];case yt.POLYGON:(t=t[h.depth[0]]).length>4&&(a==t.length-1&&(a=0),t.splice(a,1),d=!0,0===a&&(t.pop(),t.push(t[0]),u=t.length-1))}if(d){this.setGeometryCoordinates_(n,e);var g=[];if(void 0!==s&&(this.rBush_.remove(s),g.push(s.segment[0])),void 0!==l&&(this.rBush_.remove(l),g.push(l.segment[1])),void 0!==s&&void 0!==l){var y={depth:h.depth,feature:h.feature,geometry:h.geometry,index:u,segment:g};this.rBush_.insert(Dt(y.segment),y)}this.updateSegmentIndices_(n,a,h.depth,-1),this.vertexFeature_&&(this.overlay_.getSource().removeFeature(this.vertexFeature_),this.vertexFeature_=null),p.length=0}}return d},e.prototype.setGeometryCoordinates_=function(t,e){this.changingFeature_=!0,t.setCoordinates(e),this.changingFeature_=!1},e.prototype.updateSegmentIndices_=function(t,e,r,n){this.rBush_.forEachInExtent(t.getExtent(),(function(i){i.geometry===t&&(void 0===r||void 0===i.depth||_(i.depth,r))&&i.index>e&&(i.index+=n)}))},e}(as),Hy=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Jy="select",$y=function(t){function e(e,r,n,i){var o=t.call(this,e)||this;return o.selected=r,o.deselected=n,o.mapBrowserEvent=i,o}return Hy(e,t),e}(h),Qy={};var tm=function(t){function e(e){var r,n,i=t.call(this)||this,o=e||{};if(i.boundAddFeature_=i.addFeature_.bind(i),i.boundRemoveFeature_=i.removeFeature_.bind(i),i.condition_=o.condition?o.condition:gs,i.addCondition_=o.addCondition?o.addCondition:ds,i.removeCondition_=o.removeCondition?o.removeCondition:ds,i.toggleCondition_=o.toggleCondition?o.toggleCondition:ms,i.multi_=!!o.multi&&o.multi,i.filter_=o.filter?o.filter:x,i.hitTolerance_=o.hitTolerance?o.hitTolerance:0,i.style_=void 0!==o.style?o.style:(m((r=sh())[yt.POLYGON],r[yt.LINE_STRING]),m(r[yt.GEOMETRY_COLLECTION],r[yt.LINE_STRING]),function(t){return t.getGeometry()?r[t.getGeometry().getType()]:null}),i.features_=o.features||new ut,o.layers)if("function"==typeof o.layers)n=o.layers;else{var a=o.layers;n=function(t){return d(a,t)}}else n=x;return i.layerFilter_=n,i.featureLayerAssociation_={},i}return Hy(e,t),e.prototype.addFeatureLayerAssociation_=function(t,e){this.featureLayerAssociation_[o(t)]=e},e.prototype.getFeatures=function(){return this.features_},e.prototype.getHitTolerance=function(){return this.hitTolerance_},e.prototype.getLayer=function(t){return this.featureLayerAssociation_[o(t)]},e.prototype.setHitTolerance=function(t){this.hitTolerance_=t},e.prototype.setMap=function(e){this.getMap()&&this.style_&&this.features_.forEach(this.restorePreviousStyle_.bind(this)),t.prototype.setMap.call(this,e),e?(this.features_.addEventListener(nt,this.boundAddFeature_),this.features_.addEventListener(it,this.boundRemoveFeature_),this.style_&&this.features_.forEach(this.applySelectedStyle_.bind(this))):(this.features_.removeEventListener(nt,this.boundAddFeature_),this.features_.removeEventListener(it,this.boundRemoveFeature_))},e.prototype.addFeature_=function(t){var e=t.element;this.style_&&this.applySelectedStyle_(e)},e.prototype.removeFeature_=function(t){var e=t.element;this.style_&&this.restorePreviousStyle_(e)},e.prototype.getStyle=function(){return this.style_},e.prototype.applySelectedStyle_=function(t){var e=o(t);e in Qy||(Qy[e]=t.getStyle()),t.setStyle(this.style_)},e.prototype.restorePreviousStyle_=function(t){var r=o(t),n=this.getMap().getInteractions().getArray().filter((function(r){return r instanceof e&&r.getStyle()&&-1!==r.getFeatures().getArray().indexOf(t)}));n.length>0?t.setStyle(n[n.length-1].getStyle()):(t.setStyle(Qy[r]),delete Qy[r])},e.prototype.removeFeatureLayerAssociation_=function(t){delete this.featureLayerAssociation_[o(t)]},e.prototype.handleEvent=function(t){if(!this.condition_(t))return!0;var e=this.addCondition_(t),r=this.removeCondition_(t),n=this.toggleCondition_(t),i=!e&&!r&&!n,o=t.map,a=this.getFeatures(),s=[],u=[];if(i){E(this.featureLayerAssociation_),o.forEachFeatureAtPixel(t.pixel,function(t,e){if(this.filter_(t,e))return u.push(t),this.addFeatureLayerAssociation_(t,e),!this.multi_}.bind(this),{layerFilter:this.layerFilter_,hitTolerance:this.hitTolerance_});for(var l=a.getLength()-1;l>=0;--l){var h=a.item(l),c=u.indexOf(h);c>-1?u.splice(c,1):(a.remove(h),s.push(h))}0!==u.length&&a.extend(u)}else{o.forEachFeatureAtPixel(t.pixel,function(t,i){if(this.filter_(t,i))return!e&&!n||d(a.getArray(),t)?(r||n)&&d(a.getArray(),t)&&(s.push(t),this.removeFeatureLayerAssociation_(t)):(u.push(t),this.addFeatureLayerAssociation_(t,i)),!this.multi_}.bind(this),{layerFilter:this.layerFilter_,hitTolerance:this.hitTolerance_});for(var p=s.length-1;p>=0;--p)a.remove(s[p]);a.extend(u)}return(u.length>0||s.length>0)&&this.dispatchEvent(new $y(Jy,u,s,t)),!0},e}(es),em=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function rm(t){return t.feature?t.feature:t.element?t.element:void 0}var nm=[],im=function(t){function e(e){var r=this,n=e||{},i=n;return i.handleDownEvent||(i.handleDownEvent=x),i.stopDown||(i.stopDown=w),(r=t.call(this,i)||this).source_=n.source?n.source:null,r.vertex_=void 0===n.vertex||n.vertex,r.edge_=void 0===n.edge||n.edge,r.features_=n.features?n.features:null,r.featuresListenerKeys_=[],r.featureChangeListenerKeys_={},r.indexedFeaturesExtents_={},r.pendingFeatures_={},r.pixelTolerance_=void 0!==n.pixelTolerance?n.pixelTolerance:10,r.rBush_=new ic,r.SEGMENT_WRITERS_={Point:r.writePointGeometry_.bind(r),LineString:r.writeLineStringGeometry_.bind(r),LinearRing:r.writeLineStringGeometry_.bind(r),Polygon:r.writePolygonGeometry_.bind(r),MultiPoint:r.writeMultiPointGeometry_.bind(r),MultiLineString:r.writeMultiLineStringGeometry_.bind(r),MultiPolygon:r.writeMultiPolygonGeometry_.bind(r),GeometryCollection:r.writeGeometryCollectionGeometry_.bind(r),Circle:r.writeCircleGeometry_.bind(r)},r}return em(e,t),e.prototype.addFeature=function(t,e){var r=void 0===e||e,n=o(t),i=t.getGeometry();if(i){var a=this.SEGMENT_WRITERS_[i.getType()];a&&(this.indexedFeaturesExtents_[n]=i.getExtent([1/0,1/0,-1/0,-1/0]),a(t,i))}r&&(this.featureChangeListenerKeys_[n]=W(t,I,this.handleFeatureChange_,this))},e.prototype.forEachFeatureAdd_=function(t){this.addFeature(t)},e.prototype.forEachFeatureRemove_=function(t){this.removeFeature(t)},e.prototype.getFeatures_=function(){var t;return this.features_?t=this.features_:this.source_&&(t=this.source_.getFeatures()),t},e.prototype.handleEvent=function(e){var r=this.snapTo(e.pixel,e.coordinate,e.map);return r.snapped&&(e.coordinate=r.vertex.slice(0,2),e.pixel=r.vertexPixel),t.prototype.handleEvent.call(this,e)},e.prototype.handleFeatureAdd_=function(t){var e=rm(t);this.addFeature(e)},e.prototype.handleFeatureRemove_=function(t){var e=rm(t);this.removeFeature(e)},e.prototype.handleFeatureChange_=function(t){var e=t.target;if(this.handlingDownUpSequence){var r=o(e);r in this.pendingFeatures_||(this.pendingFeatures_[r]=e)}else this.updateFeature_(e)},e.prototype.handleUpEvent=function(t){var e=C(this.pendingFeatures_);return e.length&&(e.forEach(this.updateFeature_.bind(this)),this.pendingFeatures_={}),!1},e.prototype.removeFeature=function(t,e){var r=void 0===e||e,n=o(t),i=this.indexedFeaturesExtents_[n];if(i){var a=this.rBush_,s=[];a.forEachInExtent(i,(function(e){t===e.feature&&s.push(e)}));for(var u=s.length-1;u>=0;--u)a.remove(s[u])}r&&(X(this.featureChangeListenerKeys_[n]),delete this.featureChangeListenerKeys_[n])},e.prototype.setMap=function(e){var r=this.getMap(),n=this.featuresListenerKeys_,i=this.getFeatures_();r&&(n.forEach(X),n.length=0,i.forEach(this.forEachFeatureRemove_.bind(this))),t.prototype.setMap.call(this,e),e&&(this.features_?n.push(W(this.features_,nt,this.handleFeatureAdd_,this),W(this.features_,it,this.handleFeatureRemove_,this)):this.source_&&n.push(W(this.source_,oc,this.handleFeatureAdd_,this),W(this.source_,uc,this.handleFeatureRemove_,this)),i.forEach(this.forEachFeatureAdd_.bind(this)))},e.prototype.snapTo=function(t,e,r){var n=Dt([r.getCoordinateFromPixel([t[0]-this.pixelTolerance_,t[1]+this.pixelTolerance_]),r.getCoordinateFromPixel([t[0]+this.pixelTolerance_,t[1]-this.pixelTolerance_])]),i=this.rBush_.getInExtent(n);this.vertex_&&!this.edge_&&(i=i.filter((function(t){return t.feature.getGeometry().getType()!==yt.CIRCLE})));var o=!1,a=null,s=null;if(0===i.length)return{snapped:o,vertex:a,vertexPixel:s};for(var u,l=r.getView().getProjection(),h=Ar(e,l),c=1/0,p=0;p<i.length;++p){var f=i[p];nm[0]=Ar(f.segment[0],l),nm[1]=Ar(f.segment[1],l);var d=lr(h,nm);d<c&&(u=f,c=d)}var g=u.segment;if(this.vertex_&&!this.edge_){var y=r.getPixelFromCoordinate(g[0]),m=r.getPixelFromCoordinate(g[1]),v=sr(t,y),_=sr(t,m);Math.sqrt(Math.min(v,_))<=this.pixelTolerance_&&(o=!0,a=v>_?g[1]:g[0],s=r.getPixelFromCoordinate(a))}else if(this.edge_){var b=u.feature.getGeometry().getType()===yt.CIRCLE;if(b){var x=u.feature.getGeometry(),w=Mr();w&&(x=x.clone().transform(w,l)),a=Fr(function(t,e){var r=e.getRadius(),n=e.getCenter(),i=n[0],o=n[1],a=t[0]-i,s=t[1]-o;0===a&&0===s&&(a=1);var u=Math.sqrt(a*a+s*s);return[i+r*a/u,o+r*s/u]}(h,x),l)}else nm[0]=Ar(g[0],l),nm[1]=Ar(g[1],l),a=Fr(er(h,nm),l);if(ur(t,s=r.getPixelFromCoordinate(a))<=this.pixelTolerance_&&(o=!0,this.vertex_&&!b)){y=r.getPixelFromCoordinate(g[0]),m=r.getPixelFromCoordinate(g[1]),v=sr(s,y),_=sr(s,m);Math.sqrt(Math.min(v,_))<=this.pixelTolerance_&&(a=v>_?g[1]:g[0],s=r.getPixelFromCoordinate(a))}}return o&&(s=[Math.round(s[0]),Math.round(s[1])]),{snapped:o,vertex:a,vertexPixel:s}},e.prototype.updateFeature_=function(t){this.removeFeature(t,!1),this.addFeature(t,!1)},e.prototype.writeCircleGeometry_=function(t,e){var r=this.getMap().getView().getProjection(),n=e,i=Mr();i&&(n=n.clone().transform(i,r));var o=An(n);i&&o.transform(r,i);for(var a=o.getCoordinates()[0],s=0,u=a.length-1;s<u;++s){var l=a.slice(s,s+2),h={feature:t,segment:l};this.rBush_.insert(Dt(l),h)}},e.prototype.writeGeometryCollectionGeometry_=function(t,e){for(var r=e.getGeometriesArray(),n=0;n<r.length;++n){var i=this.SEGMENT_WRITERS_[r[n].getType()];i&&i(t,r[n])}},e.prototype.writeLineStringGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length-1;n<i;++n){var o=r.slice(n,n+2),a={feature:t,segment:o};this.rBush_.insert(Dt(o),a)}},e.prototype.writeMultiLineStringGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length;n<i;++n)for(var o=r[n],a=0,s=o.length-1;a<s;++a){var u=o.slice(a,a+2),l={feature:t,segment:u};this.rBush_.insert(Dt(u),l)}},e.prototype.writeMultiPointGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length;n<i;++n){var o=r[n],a={feature:t,segment:[o,o]};this.rBush_.insert(e.getExtent(),a)}},e.prototype.writeMultiPolygonGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length;n<i;++n)for(var o=r[n],a=0,s=o.length;a<s;++a)for(var u=o[a],l=0,h=u.length-1;l<h;++l){var c=u.slice(l,l+2),p={feature:t,segment:c};this.rBush_.insert(Dt(c),p)}},e.prototype.writePointGeometry_=function(t,e){var r=e.getCoordinates(),n={feature:t,segment:[r,r]};this.rBush_.insert(e.getExtent(),n)},e.prototype.writePolygonGeometry_=function(t,e){for(var r=e.getCoordinates(),n=0,i=r.length;n<i;++n)for(var o=r[n],a=0,s=o.length-1;a<s;++a){var u=o.slice(a,a+2),l={feature:t,segment:u};this.rBush_.insert(Dt(u),l)}},e}(as),om=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),am="translatestart",sm="translating",um="translateend",lm=function(t){function e(e,r,n,i,o){var a=t.call(this,e)||this;return a.features=r,a.coordinate=n,a.startCoordinate=i,a.mapBrowserEvent=o,a}return om(e,t),e}(h),hm=function(t){function e(e){var r,n=this,i=e||{};if((n=t.call(this,i)||this).lastCoordinate_=null,n.startCoordinate_=null,n.features_=void 0!==i.features?i.features:null,i.layers)if("function"==typeof i.layers)r=i.layers;else{var o=i.layers;r=function(t){return d(o,t)}}else r=x;return n.layerFilter_=r,n.filter_=i.filter?i.filter:x,n.hitTolerance_=i.hitTolerance?i.hitTolerance:0,n.lastFeature_=null,n.addEventListener(et($a),n.handleActiveChanged_),n}return om(e,t),e.prototype.handleDownEvent=function(t){if(this.lastFeature_=this.featuresAtPixel_(t.pixel,t.map),!this.lastCoordinate_&&this.lastFeature_){this.startCoordinate_=t.coordinate,this.lastCoordinate_=t.coordinate,this.handleMoveEvent(t);var e=this.features_||new ut([this.lastFeature_]);return this.dispatchEvent(new lm(am,e,t.coordinate,this.startCoordinate_,t)),!0}return!1},e.prototype.handleUpEvent=function(t){if(this.lastCoordinate_){this.lastCoordinate_=null,this.handleMoveEvent(t);var e=this.features_||new ut([this.lastFeature_]);return this.dispatchEvent(new lm(um,e,t.coordinate,this.startCoordinate_,t)),this.startCoordinate_=null,!0}return!1},e.prototype.handleDragEvent=function(t){if(this.lastCoordinate_){var e=t.coordinate,r=e[0]-this.lastCoordinate_[0],n=e[1]-this.lastCoordinate_[1],i=this.features_||new ut([this.lastFeature_]);i.forEach((function(t){var e=t.getGeometry();e.translate(r,n),t.setGeometry(e)})),this.lastCoordinate_=e,this.dispatchEvent(new lm(sm,i,e,this.startCoordinate_,t))}},e.prototype.handleMoveEvent=function(t){var e=t.map.getViewport();this.featuresAtPixel_(t.pixel,t.map)?(e.classList.remove(this.lastCoordinate_?"ol-grab":"ol-grabbing"),e.classList.add(this.lastCoordinate_?"ol-grabbing":"ol-grab")):e.classList.remove("ol-grab","ol-grabbing")},e.prototype.featuresAtPixel_=function(t,e){return e.forEachFeatureAtPixel(t,function(t,e){if(this.filter_(t,e)&&(!this.features_||d(this.features_.getArray(),t)))return t}.bind(this),{layerFilter:this.layerFilter_,hitTolerance:this.hitTolerance_})},e.prototype.getHitTolerance=function(){return this.hitTolerance_},e.prototype.setHitTolerance=function(t){this.hitTolerance_=t},e.prototype.setMap=function(e){var r=this.getMap();t.prototype.setMap.call(this,e),this.updateState_(r)},e.prototype.handleActiveChanged_=function(){this.updateState_(null)},e.prototype.updateState_=function(t){var e=this.getMap(),r=this.getActive();e&&r||(e=e||t)&&e.getViewport().classList.remove("ol-grab","ol-grabbing")},e}(as),cm=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),pm={};pm[yt.POINT]=function(t){var e;e=void 0!==t.m&&void 0!==t.z?new gn([t.x,t.y,t.z,t.m],gt):void 0!==t.z?new gn([t.x,t.y,t.z],ft):void 0!==t.m?new gn([t.x,t.y,t.m],dt):new gn([t.x,t.y]);return e},pm[yt.LINE_STRING]=function(t){var e=gm(t);return new Cd(t.paths[0],e)},pm[yt.POLYGON]=function(t){var e=gm(t);return new Ln(t.rings,e)},pm[yt.MULTI_POINT]=function(t){var e=gm(t);return new qd(t.points,e)},pm[yt.MULTI_LINE_STRING]=function(t){var e=gm(t);return new Vd(t.paths,e)},pm[yt.MULTI_POLYGON]=function(t){var e=gm(t);return new Kd(t.rings,e)};var fm={};function dm(t,e){var r,n,i;if(!t)return null;if("number"==typeof t.x&&"number"==typeof t.y)i=yt.POINT;else if(t.points)i=yt.MULTI_POINT;else if(t.paths){i=1===t.paths.length?yt.LINE_STRING:yt.MULTI_LINE_STRING}else if(t.rings){var o=t,a=gm(o),s=function(t,e){var r,n,i=[],o=[],a=[];for(r=0,n=t.length;r<n;++r){i.length=0,Qr(i,0,t[r],e.length),En(i,0,i.length,e.length)?o.push([t[r]]):a.push(t[r])}for(;a.length;){var s=a.shift(),u=!1;for(r=o.length-1;r>=0;r--){var l=o[r][0];if(Vt(new fn(l).getExtent(),new fn(s).getExtent())){o[r].push(s),u=!0;break}}u||o.push([s.reverse()])}return o}(o.rings,a);1===s.length?(i=yt.POLYGON,t=T({},t,((r={}).rings=s[0],r))):(i=yt.MULTI_POLYGON,t=T({},t,((n={}).rings=s,n)))}return Ud((0,pm[i])(t),!1,e)}function gm(t){var e=pt;return!0===t.hasZ&&!0===t.hasM?e=gt:!0===t.hasZ?e=ft:!0===t.hasM&&(e=dt),e}function ym(t){var e=t.getLayout();return{hasZ:e===ft||e===gt,hasM:e===dt||e===gt}}function mm(t,e){return(0,fm[t.getType()])(Ud(t,!0,e),e)}fm[yt.POINT]=function(t,e){var r,n=t.getCoordinates(),i=t.getLayout();i===ft?r={x:n[0],y:n[1],z:n[2]}:i===dt?r={x:n[0],y:n[1],m:n[2]}:i===gt?r={x:n[0],y:n[1],z:n[2],m:n[3]}:i===pt?r={x:n[0],y:n[1]}:lt(!1,34);return r},fm[yt.LINE_STRING]=function(t,e){var r=ym(t);return{hasZ:r.hasZ,hasM:r.hasM,paths:[t.getCoordinates()]}},fm[yt.POLYGON]=function(t,e){var r=ym(t);return{hasZ:r.hasZ,hasM:r.hasM,rings:t.getCoordinates(!1)}},fm[yt.MULTI_POINT]=function(t,e){var r=ym(t);return{hasZ:r.hasZ,hasM:r.hasM,points:t.getCoordinates()}},fm[yt.MULTI_LINE_STRING]=function(t,e){var r=ym(t);return{hasZ:r.hasZ,hasM:r.hasM,paths:t.getCoordinates()}},fm[yt.MULTI_POLYGON]=function(t,e){for(var r=ym(t),n=t.getCoordinates(!1),i=[],o=0;o<n.length;o++)for(var a=n[o].length-1;a>=0;a--)i.push(n[o][a]);return{hasZ:r.hasZ,hasM:r.hasM,rings:i}};var vm=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this)||this).geometryName_=n.geometryName,r}return cm(e,t),e.prototype.readFeatureFromObject=function(t,e,r){var n=t,i=dm(n.geometry,e),o=new ct;if(this.geometryName_&&o.setGeometryName(this.geometryName_),o.setGeometry(i),n.attributes){o.setProperties(n.attributes,!0);var a=n.attributes[r];void 0!==a&&o.setId(a)}return o},e.prototype.readFeaturesFromObject=function(t,e){var r=e||{};if(t.features){for(var n=[],i=t.features,o=0,a=i.length;o<a;++o)n.push(this.readFeatureFromObject(i[o],r,t.objectIdFieldName));return n}return[this.readFeatureFromObject(t,r)]},e.prototype.readGeometryFromObject=function(t,e){return dm(t,e)},e.prototype.readProjectionFromObject=function(t){return t.spatialReference&&void 0!==t.spatialReference.wkid?yr("EPSG:"+t.spatialReference.wkid):null},e.prototype.writeGeometryObject=function(t,e){return mm(t,this.adaptOptions(e))},e.prototype.writeFeatureObject=function(t,e){e=this.adaptOptions(e);var r={};if(!t.hasProperties())return r.attributes={},r;var n=t.getProperties(),i=t.getGeometry();return i&&(r.geometry=mm(i,e),e&&e.featureProjection&&(r.geometry.spatialReference={wkid:Number(yr(e.featureProjection).getCode().split(":").pop())}),delete n[t.getGeometryName()]),P(n)?r.attributes={}:r.attributes=n,r},e.prototype.writeFeaturesObject=function(t,e){e=this.adaptOptions(e);for(var r=[],n=0,i=t.length;n<i;++n)r.push(this.writeFeatureObject(t[n],e));return{features:r}},e}(Wg),_m=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),bm=function(t){function e(){var e=t.call(this)||this;return e.xmlSerializer_=(void 0===ul&&"undefined"!=typeof XMLSerializer&&(ul=new XMLSerializer),ul),e}return _m(e,t),e.prototype.getType=function(){return _u},e.prototype.readFeature=function(t,e){if(t){if("string"==typeof t){var r=qu(t);return this.readFeatureFromDocument(r,e)}return Wu(t)?this.readFeatureFromDocument(t,e):this.readFeatureFromNode(t,e)}return null},e.prototype.readFeatureFromDocument=function(t,e){var r=this.readFeaturesFromDocument(t,e);return r.length>0?r[0]:null},e.prototype.readFeatureFromNode=function(t,e){return null},e.prototype.readFeatures=function(t,e){if(t){if("string"==typeof t){var r=qu(t);return this.readFeaturesFromDocument(r,e)}return Wu(t)?this.readFeaturesFromDocument(t,e):this.readFeaturesFromNode(t,e)}return[]},e.prototype.readFeaturesFromDocument=function(t,e){for(var r=[],n=t.firstChild;n;n=n.nextSibling)n.nodeType==Node.ELEMENT_NODE&&m(r,this.readFeaturesFromNode(n,e));return r},e.prototype.readFeaturesFromNode=function(t,e){return n()},e.prototype.readGeometry=function(t,e){if(t){if("string"==typeof t){var r=qu(t);return this.readGeometryFromDocument(r,e)}return Wu(t)?this.readGeometryFromDocument(t,e):this.readGeometryFromNode(t,e)}return null},e.prototype.readGeometryFromDocument=function(t,e){return null},e.prototype.readGeometryFromNode=function(t,e){return null},e.prototype.readProjection=function(t){if(t){if("string"==typeof t){var e=qu(t);return this.readProjectionFromDocument(e)}return Wu(t)?this.readProjectionFromDocument(t):this.readProjectionFromNode(t)}return null},e.prototype.readProjectionFromDocument=function(t){return this.dataProjection},e.prototype.readProjectionFromNode=function(t){return this.dataProjection},e.prototype.writeFeature=function(t,e){var r=this.writeFeatureNode(t,e);return this.xmlSerializer_.serializeToString(r)},e.prototype.writeFeatureNode=function(t,e){return null},e.prototype.writeFeatures=function(t,e){var r=this.writeFeaturesNode(t,e);return this.xmlSerializer_.serializeToString(r)},e.prototype.writeFeaturesNode=function(t,e){return null},e.prototype.writeGeometry=function(t,e){var r=this.writeGeometryNode(t,e);return this.xmlSerializer_.serializeToString(r)},e.prototype.writeGeometryNode=function(t,e){return null},e}(zd),xm=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wm="http://www.opengis.net/gml",Sm=/^[\s\xa0]*$/,Tm=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.featureType=n.featureType,r.featureNS=n.featureNS,r.srsName=n.srsName,r.schemaLocation="",r.FEATURE_COLLECTION_PARSERS={},r.FEATURE_COLLECTION_PARSERS[r.namespace]={featureMember:Zu(r.readFeaturesInternal),featureMembers:Ku(r.readFeaturesInternal)},r}return xm(e,t),e.prototype.readFeaturesInternal=function(t,e){var r=t.localName,n=null;if("FeatureCollection"==r)n=ol([],this.FEATURE_COLLECTION_PARSERS,t,e,this);else if("featureMembers"==r||"featureMember"==r){var i=e[0],o=i.featureType,a=i.featureNS;if(!o&&t.childNodes){o=[],a={};for(var s=0,u=t.childNodes.length;s<u;++s){var l=t.childNodes[s];if(1===l.nodeType){var h=l.nodeName.split(":").pop();if(-1===o.indexOf(h)){var c="",p=0,f=l.namespaceURI;for(var d in a){if(a[d]===f){c=d;break}++p}c||(a[c="p"+p]=f),o.push(c+":"+h)}}}"featureMember"!=r&&(i.featureType=o,i.featureNS=a)}if("string"==typeof a){var g=a;(a={}).p0=g}var y={},m=Array.isArray(o)?o:[o];for(var v in a){var _={};for(s=0,u=m.length;s<u;++s){(-1===m[s].indexOf(":")?"p0":m[s].split(":")[0])===v&&(_[m[s].split(":").pop()]="featureMembers"==r?Zu(this.readFeatureElement,this):Ku(this.readFeatureElement,this))}y[a[v]]=_}n=ol("featureMember"==r?void 0:[],y,t,e)}return null===n&&(n=[]),n},e.prototype.readGeometryElement=function(t,e){var r=e[0];r.srsName=t.firstElementChild.getAttribute("srsName"),r.srsDimension=t.firstElementChild.getAttribute("srsDimension");var n=ol(null,this.GEOMETRY_PARSERS,t,e,this);return n?Array.isArray(n)?Bd(n,r):Ud(n,!1,r):void 0},e.prototype.readFeatureElementInternal=function(t,e,r){for(var n,i={},o=t.firstElementChild;o;o=o.nextElementSibling){var a=void 0,s=o.localName;0===o.childNodes.length||1===o.childNodes.length&&(3===o.firstChild.nodeType||4===o.firstChild.nodeType)?(a=Vu(o,!1),Sm.test(a)&&(a=void 0)):(r&&(a=this.readGeometryElement(o,e)),a?"boundedBy"!==s&&(n=s):a=this.readFeatureElementInternal(o,e,!1)),i[s]?(i[s]instanceof Array||(i[s]=[i[s]]),i[s].push(a)):i[s]=a;var u=o.attributes.length;if(u>0){i[s]={_content_:i[s]};for(var l=0;l<u;l++){var h=o.attributes[l].name;i[s][h]=o.attributes[l].value}}}if(r){var c=new ct(i);n&&c.setGeometryName(n);var p=t.getAttribute("fid")||function(t,e,r){return t.getAttributeNS(e,r)||""}(t,this.namespace,"id");return p&&c.setId(p),c}return i},e.prototype.readFeatureElement=function(t,e){return this.readFeatureElementInternal(t,e,!0)},e.prototype.readPoint=function(t,e){var r=this.readFlatCoordinatesFromNode(t,e);if(r)return new gn(r,ft)},e.prototype.readMultiPoint=function(t,e){var r=ol([],this.MULTIPOINT_PARSERS,t,e,this);return r?new qd(r):void 0},e.prototype.readMultiLineString=function(t,e){var r=ol([],this.MULTILINESTRING_PARSERS,t,e,this);if(r)return new Vd(r)},e.prototype.readMultiPolygon=function(t,e){var r=ol([],this.MULTIPOLYGON_PARSERS,t,e,this);if(r)return new Kd(r)},e.prototype.pointMemberParser=function(t,e){il(this.POINTMEMBER_PARSERS,t,e,this)},e.prototype.lineStringMemberParser=function(t,e){il(this.LINESTRINGMEMBER_PARSERS,t,e,this)},e.prototype.polygonMemberParser=function(t,e){il(this.POLYGONMEMBER_PARSERS,t,e,this)},e.prototype.readLineString=function(t,e){var r=this.readFlatCoordinatesFromNode(t,e);return r?new Cd(r,ft):void 0},e.prototype.readFlatLinearRing=function(t,e){var r=ol(null,this.GEOMETRY_FLAT_COORDINATES_PARSERS,t,e,this);return r||void 0},e.prototype.readLinearRing=function(t,e){var r=this.readFlatCoordinatesFromNode(t,e);if(r)return new fn(r,ft)},e.prototype.readPolygon=function(t,e){var r=ol([null],this.FLAT_LINEAR_RINGS_PARSERS,t,e,this);if(r&&r[0]){var n,i=r[0],o=[i.length],a=void 0;for(a=1,n=r.length;a<n;++a)m(i,r[a]),o.push(i.length);return new Ln(i,ft,o)}},e.prototype.readFlatCoordinatesFromNode=function(t,e){return ol(null,this.GEOMETRY_FLAT_COORDINATES_PARSERS,t,e,this)},e.prototype.readGeometryFromNode=function(t,e){var r=this.readGeometryElement(t,[this.getReadOptions(t,e||{})]);return r||null},e.prototype.readFeaturesFromNode=function(t,e){var r={featureType:this.featureType,featureNS:this.featureNS};return e&&T(r,this.getReadOptions(t,e)),this.readFeaturesInternal(t,[r])||[]},e.prototype.readProjectionFromNode=function(t){return yr(this.srsName?this.srsName:t.firstElementChild.getAttribute("srsName"))},e}(bm);Tm.prototype.namespace=wm,Tm.prototype.FLAT_LINEAR_RINGS_PARSERS={"http://www.opengis.net/gml":{}},Tm.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS={"http://www.opengis.net/gml":{}},Tm.prototype.GEOMETRY_PARSERS={"http://www.opengis.net/gml":{}},Tm.prototype.MULTIPOINT_PARSERS={"http://www.opengis.net/gml":{pointMember:Zu(Tm.prototype.pointMemberParser),pointMembers:Zu(Tm.prototype.pointMemberParser)}},Tm.prototype.MULTILINESTRING_PARSERS={"http://www.opengis.net/gml":{lineStringMember:Zu(Tm.prototype.lineStringMemberParser),lineStringMembers:Zu(Tm.prototype.lineStringMemberParser)}},Tm.prototype.MULTIPOLYGON_PARSERS={"http://www.opengis.net/gml":{polygonMember:Zu(Tm.prototype.polygonMemberParser),polygonMembers:Zu(Tm.prototype.polygonMemberParser)}},Tm.prototype.POINTMEMBER_PARSERS={"http://www.opengis.net/gml":{Point:Zu(Tm.prototype.readFlatCoordinatesFromNode)}},Tm.prototype.LINESTRINGMEMBER_PARSERS={"http://www.opengis.net/gml":{LineString:Zu(Tm.prototype.readLineString)}},Tm.prototype.POLYGONMEMBER_PARSERS={"http://www.opengis.net/gml":{Polygon:Zu(Tm.prototype.readPolygon)}},Tm.prototype.RING_PARSERS={"http://www.opengis.net/gml":{LinearRing:Ku(Tm.prototype.readFlatLinearRing)}};var Em=Tm;function Cm(t){return Pm(Vu(t,!1))}function Pm(t){var e=/^\s*(true|1)|(false|0)\s*$/.exec(t);return e?void 0!==e[1]||!1:void 0}function Rm(t){var e=Vu(t,!1),r=Date.parse(e);return isNaN(r)?void 0:r/1e3}function Om(t){return Im(Vu(t,!1))}function Im(t){var e=/^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*$/i.exec(t);return e?parseFloat(e[1]):void 0}function Lm(t){return Mm(Vu(t,!1))}function Mm(t){var e=/^\s*(\d+)\s*$/.exec(t);return e?parseInt(e[1],10):void 0}function Fm(t){return Vu(t,!1).trim()}function Am(t,e){jm(t,e?"1":"0")}function km(t,e){var r=e.toPrecision();t.appendChild(hl().createTextNode(r))}function Nm(t,e){var r=e.toString();t.appendChild(hl().createTextNode(r))}function jm(t,e){t.appendChild(hl().createTextNode(e))}var Gm=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Dm={MultiLineString:"lineStringMember",MultiCurve:"curveMember",MultiPolygon:"polygonMember",MultiSurface:"surfaceMember"},zm=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,n)||this).surface_=void 0!==n.surface&&n.surface,r.curve_=void 0!==n.curve&&n.curve,r.multiCurve_=void 0===n.multiCurve||n.multiCurve,r.multiSurface_=void 0===n.multiSurface||n.multiSurface,r.schemaLocation=n.schemaLocation?n.schemaLocation:"http://www.opengis.net/gml http://schemas.opengis.net/gml/3.1.1/profiles/gmlsfProfile/1.0.0/gmlsf.xsd",r.hasZ=void 0!==n.hasZ&&n.hasZ,r}return Gm(e,t),e.prototype.readMultiCurve=function(t,e){var r=ol([],this.MULTICURVE_PARSERS,t,e,this);return r?new Vd(r):void 0},e.prototype.readMultiSurface=function(t,e){var r=ol([],this.MULTISURFACE_PARSERS,t,e,this);if(r)return new Kd(r)},e.prototype.curveMemberParser=function(t,e){il(this.CURVEMEMBER_PARSERS,t,e,this)},e.prototype.surfaceMemberParser=function(t,e){il(this.SURFACEMEMBER_PARSERS,t,e,this)},e.prototype.readPatch=function(t,e){return ol([null],this.PATCHES_PARSERS,t,e,this)},e.prototype.readSegment=function(t,e){return ol([null],this.SEGMENTS_PARSERS,t,e,this)},e.prototype.readPolygonPatch=function(t,e){return ol([null],this.FLAT_LINEAR_RINGS_PARSERS,t,e,this)},e.prototype.readLineStringSegment=function(t,e){return ol([null],this.GEOMETRY_FLAT_COORDINATES_PARSERS,t,e,this)},e.prototype.interiorParser=function(t,e){var r=ol(void 0,this.RING_PARSERS,t,e,this);r&&e[e.length-1].push(r)},e.prototype.exteriorParser=function(t,e){var r=ol(void 0,this.RING_PARSERS,t,e,this);r&&(e[e.length-1][0]=r)},e.prototype.readSurface=function(t,e){var r=ol([null],this.SURFACE_PARSERS,t,e,this);if(r&&r[0]){var n,i=r[0],o=[i.length],a=void 0;for(a=1,n=r.length;a<n;++a)m(i,r[a]),o.push(i.length);return new Ln(i,ft,o)}},e.prototype.readCurve=function(t,e){var r=ol([null],this.CURVE_PARSERS,t,e,this);return r?new Cd(r,ft):void 0},e.prototype.readEnvelope=function(t,e){var r=ol([null],this.ENVELOPE_PARSERS,t,e,this);return Zt(r[1][0],r[1][1],r[2][0],r[2][1])},e.prototype.readFlatPos=function(t,e){for(var r,n=Vu(t,!1),i=/^\s*([+\-]?\d*\.?\d+(?:[eE][+\-]?\d+)?)\s*/,o=[];r=i.exec(n);)o.push(parseFloat(r[1])),n=n.substr(r[0].length);if(""===n){var a=e[0].srsName,s="enu";if(a)s=yr(a).getAxisOrientation();if("neu"===s){var u,l=void 0;for(l=0,u=o.length;l<u;l+=3){var h=o[l],c=o[l+1];o[l]=c,o[l+1]=h}}var p=o.length;if(2==p&&o.push(0),0!==p)return o}},e.prototype.readFlatPosList=function(t,e){var r=Vu(t,!1).replace(/^\s*|\s*$/g,""),n=e[0],i=n.srsName,o=n.srsDimension,a="enu";i&&(a=yr(i).getAxisOrientation());var s,u,l,h=r.split(/\s+/),c=2;t.getAttribute("srsDimension")?c=Mm(t.getAttribute("srsDimension")):t.getAttribute("dimension")?c=Mm(t.getAttribute("dimension")):t.parentNode.getAttribute("srsDimension")?c=Mm(t.parentNode.getAttribute("srsDimension")):o&&(c=Mm(o));for(var p=[],f=0,d=h.length;f<d;f+=c)s=parseFloat(h[f]),u=parseFloat(h[f+1]),l=3===c?parseFloat(h[f+2]):0,"en"===a.substr(0,2)?p.push(s,u,l):p.push(u,s,l);return p},e.prototype.writePos_=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=i?"3":"2";t.setAttribute("srsDimension",o);var a=n.srsName,s="enu";a&&(s=yr(a).getAxisOrientation());var u,l=e.getCoordinates();(u="en"===s.substr(0,2)?l[0]+" "+l[1]:l[1]+" "+l[0],i)&&(u+=" "+(l[2]||0));jm(t,u)},e.prototype.getCoords_=function(t,e,r){var n="enu";e&&(n=yr(e).getAxisOrientation());var i="en"===n.substr(0,2)?t[0]+" "+t[1]:t[1]+" "+t[0];r&&(i+=" "+(t[2]||0));return i},e.prototype.writePosList_=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=i?"3":"2";t.setAttribute("srsDimension",o);for(var a,s=n.srsName,u=e.getCoordinates(),l=u.length,h=new Array(l),c=0;c<l;++c)a=u[c],h[c]=this.getCoords_(a,s,i);jm(t,h.join(" "))},e.prototype.writePoint=function(t,e,r){var n=r[r.length-1].srsName;n&&t.setAttribute("srsName",n);var i=Yu(t.namespaceURI,"pos");t.appendChild(i),this.writePos_(i,e,r)},e.prototype.writeEnvelope=function(t,e,r){var n=r[r.length-1].srsName;n&&t.setAttribute("srsName",n);var i=[e[0]+" "+e[1],e[2]+" "+e[3]];sl({node:t},this.ENVELOPE_SERIALIZERS,el,i,r,["lowerCorner","upperCorner"],this)},e.prototype.writeLinearRing=function(t,e,r){var n=r[r.length-1].srsName;n&&t.setAttribute("srsName",n);var i=Yu(t.namespaceURI,"posList");t.appendChild(i),this.writePosList_(i,e,r)},e.prototype.RING_NODE_FACTORY_=function(t,e,r){var n=e[e.length-1],i=n.node,o=n.exteriorWritten;return void 0===o&&(n.exteriorWritten=!0),Yu(i.namespaceURI,void 0!==o?"interior":"exterior")},e.prototype.writeSurfaceOrPolygon=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=n.srsName;if("PolygonPatch"!==t.nodeName&&o&&t.setAttribute("srsName",o),"Polygon"===t.nodeName||"PolygonPatch"===t.nodeName){var a=e.getLinearRings();sl({node:t,hasZ:i,srsName:o},this.RING_SERIALIZERS,this.RING_NODE_FACTORY_,a,r,void 0,this)}else if("Surface"===t.nodeName){var s=Yu(t.namespaceURI,"patches");t.appendChild(s),this.writeSurfacePatches_(s,e,r)}},e.prototype.writeCurveOrLineString=function(t,e,r){var n=r[r.length-1].srsName;if("LineStringSegment"!==t.nodeName&&n&&t.setAttribute("srsName",n),"LineString"===t.nodeName||"LineStringSegment"===t.nodeName){var i=Yu(t.namespaceURI,"posList");t.appendChild(i),this.writePosList_(i,e,r)}else if("Curve"===t.nodeName){var o=Yu(t.namespaceURI,"segments");t.appendChild(o),this.writeCurveSegments_(o,e,r)}},e.prototype.writeMultiSurfaceOrPolygon=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=n.srsName,a=n.surface;o&&t.setAttribute("srsName",o);var s=e.getPolygons();sl({node:t,hasZ:i,srsName:o,surface:a},this.SURFACEORPOLYGONMEMBER_SERIALIZERS,this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_,s,r,void 0,this)},e.prototype.writeMultiPoint=function(t,e,r){var n=r[r.length-1],i=n.srsName,o=n.hasZ;i&&t.setAttribute("srsName",i);var a=e.getPoints();sl({node:t,hasZ:o,srsName:i},this.POINTMEMBER_SERIALIZERS,tl("pointMember"),a,r,void 0,this)},e.prototype.writeMultiCurveOrLineString=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=n.srsName,a=n.curve;o&&t.setAttribute("srsName",o);var s=e.getLineStrings();sl({node:t,hasZ:i,srsName:o,curve:a},this.LINESTRINGORCURVEMEMBER_SERIALIZERS,this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_,s,r,void 0,this)},e.prototype.writeRing=function(t,e,r){var n=Yu(t.namespaceURI,"LinearRing");t.appendChild(n),this.writeLinearRing(n,e,r)},e.prototype.writeSurfaceOrPolygonMember=function(t,e,r){var n=this.GEOMETRY_NODE_FACTORY_(e,r);n&&(t.appendChild(n),this.writeSurfaceOrPolygon(n,e,r))},e.prototype.writePointMember=function(t,e,r){var n=Yu(t.namespaceURI,"Point");t.appendChild(n),this.writePoint(n,e,r)},e.prototype.writeLineStringOrCurveMember=function(t,e,r){var n=this.GEOMETRY_NODE_FACTORY_(e,r);n&&(t.appendChild(n),this.writeCurveOrLineString(n,e,r))},e.prototype.writeSurfacePatches_=function(t,e,r){var n=Yu(t.namespaceURI,"PolygonPatch");t.appendChild(n),this.writeSurfaceOrPolygon(n,e,r)},e.prototype.writeCurveSegments_=function(t,e,r){var n=Yu(t.namespaceURI,"LineStringSegment");t.appendChild(n),this.writeCurveOrLineString(n,e,r)},e.prototype.writeGeometryElement=function(t,e,r){var n,i=r[r.length-1],o=T({},i);o.node=t,n=Array.isArray(e)?Bd(e,i):Ud(e,!0,i),sl(o,this.GEOMETRY_SERIALIZERS,this.GEOMETRY_NODE_FACTORY_,[n],r,void 0,this)},e.prototype.writeFeatureElement=function(t,e,r){var n=e.getId();n&&t.setAttribute("fid",n);var i=r[r.length-1],o=i.featureNS,a=e.getGeometryName();i.serializers||(i.serializers={},i.serializers[o]={});var s=[],u=[];if(e.hasProperties()){var l=e.getProperties();for(var h in l){var c=l[h];null!==c&&(s.push(h),u.push(c),h==a||"function"==typeof c.getSimplifiedGeometry?h in i.serializers[o]||(i.serializers[o][h]=$u(this.writeGeometryElement,this)):h in i.serializers[o]||(i.serializers[o][h]=$u(jm)))}}var p=T({},i);p.node=t,sl(p,i.serializers,tl(void 0,o),u,r,s)},e.prototype.writeFeatureMembers_=function(t,e,r){var n=r[r.length-1],i=n.featureType,o=n.featureNS,a={};a[o]={},a[o][i]=$u(this.writeFeatureElement,this);var s=T({},n);s.node=t,sl(s,a,tl(i,o),e,r)},e.prototype.MULTIGEOMETRY_MEMBER_NODE_FACTORY_=function(t,e,r){var n=e[e.length-1].node;return Yu(this.namespace,Dm[n.nodeName])},e.prototype.GEOMETRY_NODE_FACTORY_=function(t,e,r){var n,i=e[e.length-1],o=i.multiSurface,a=i.surface,s=i.curve,u=i.multiCurve;return Array.isArray(t)?n="Envelope":"MultiPolygon"===(n=t.getType())&&!0===o?n="MultiSurface":"Polygon"===n&&!0===a?n="Surface":"LineString"===n&&!0===s?n="Curve":"MultiLineString"===n&&!0===u&&(n="MultiCurve"),Yu(this.namespace,n)},e.prototype.writeGeometryNode=function(t,e){e=this.adaptOptions(e);var r=Yu(this.namespace,"geom"),n={node:r,hasZ:this.hasZ,srsName:this.srsName,curve:this.curve_,surface:this.surface_,multiSurface:this.multiSurface_,multiCurve:this.multiCurve_};return e&&T(n,e),this.writeGeometryElement(r,t,[n]),r},e.prototype.writeFeaturesNode=function(t,e){e=this.adaptOptions(e);var r=Yu(this.namespace,"featureMembers");r.setAttributeNS(Bu,"xsi:schemaLocation",this.schemaLocation);var n={srsName:this.srsName,hasZ:this.hasZ,curve:this.curve_,surface:this.surface_,multiSurface:this.multiSurface_,multiCurve:this.multiCurve_,featureNS:this.featureNS,featureType:this.featureType};return e&&T(n,e),this.writeFeatureMembers_(r,t,[n]),r},e}(Em);zm.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS={"http://www.opengis.net/gml":{pos:Ku(zm.prototype.readFlatPos),posList:Ku(zm.prototype.readFlatPosList)}},zm.prototype.FLAT_LINEAR_RINGS_PARSERS={"http://www.opengis.net/gml":{interior:zm.prototype.interiorParser,exterior:zm.prototype.exteriorParser}},zm.prototype.GEOMETRY_PARSERS={"http://www.opengis.net/gml":{Point:Ku(Em.prototype.readPoint),MultiPoint:Ku(Em.prototype.readMultiPoint),LineString:Ku(Em.prototype.readLineString),MultiLineString:Ku(Em.prototype.readMultiLineString),LinearRing:Ku(Em.prototype.readLinearRing),Polygon:Ku(Em.prototype.readPolygon),MultiPolygon:Ku(Em.prototype.readMultiPolygon),Surface:Ku(zm.prototype.readSurface),MultiSurface:Ku(zm.prototype.readMultiSurface),Curve:Ku(zm.prototype.readCurve),MultiCurve:Ku(zm.prototype.readMultiCurve),Envelope:Ku(zm.prototype.readEnvelope)}},zm.prototype.MULTICURVE_PARSERS={"http://www.opengis.net/gml":{curveMember:Zu(zm.prototype.curveMemberParser),curveMembers:Zu(zm.prototype.curveMemberParser)}},zm.prototype.MULTISURFACE_PARSERS={"http://www.opengis.net/gml":{surfaceMember:Zu(zm.prototype.surfaceMemberParser),surfaceMembers:Zu(zm.prototype.surfaceMemberParser)}},zm.prototype.CURVEMEMBER_PARSERS={"http://www.opengis.net/gml":{LineString:Zu(Em.prototype.readLineString),Curve:Zu(zm.prototype.readCurve)}},zm.prototype.SURFACEMEMBER_PARSERS={"http://www.opengis.net/gml":{Polygon:Zu(Em.prototype.readPolygon),Surface:Zu(zm.prototype.readSurface)}},zm.prototype.SURFACE_PARSERS={"http://www.opengis.net/gml":{patches:Ku(zm.prototype.readPatch)}},zm.prototype.CURVE_PARSERS={"http://www.opengis.net/gml":{segments:Ku(zm.prototype.readSegment)}},zm.prototype.ENVELOPE_PARSERS={"http://www.opengis.net/gml":{lowerCorner:Zu(zm.prototype.readFlatPosList),upperCorner:Zu(zm.prototype.readFlatPosList)}},zm.prototype.PATCHES_PARSERS={"http://www.opengis.net/gml":{PolygonPatch:Ku(zm.prototype.readPolygonPatch)}},zm.prototype.SEGMENTS_PARSERS={"http://www.opengis.net/gml":{LineStringSegment:Ku(zm.prototype.readLineStringSegment)}},zm.prototype.writeFeatures,zm.prototype.RING_SERIALIZERS={"http://www.opengis.net/gml":{exterior:$u(zm.prototype.writeRing),interior:$u(zm.prototype.writeRing)}},zm.prototype.ENVELOPE_SERIALIZERS={"http://www.opengis.net/gml":{lowerCorner:$u(jm),upperCorner:$u(jm)}},zm.prototype.SURFACEORPOLYGONMEMBER_SERIALIZERS={"http://www.opengis.net/gml":{surfaceMember:$u(zm.prototype.writeSurfaceOrPolygonMember),polygonMember:$u(zm.prototype.writeSurfaceOrPolygonMember)}},zm.prototype.POINTMEMBER_SERIALIZERS={"http://www.opengis.net/gml":{pointMember:$u(zm.prototype.writePointMember)}},zm.prototype.LINESTRINGORCURVEMEMBER_SERIALIZERS={"http://www.opengis.net/gml":{lineStringMember:$u(zm.prototype.writeLineStringOrCurveMember),curveMember:$u(zm.prototype.writeLineStringOrCurveMember)}},zm.prototype.GEOMETRY_SERIALIZERS={"http://www.opengis.net/gml":{Curve:$u(zm.prototype.writeCurveOrLineString),MultiCurve:$u(zm.prototype.writeMultiCurveOrLineString),Point:$u(zm.prototype.writePoint),MultiPoint:$u(zm.prototype.writeMultiPoint),LineString:$u(zm.prototype.writeCurveOrLineString),MultiLineString:$u(zm.prototype.writeMultiCurveOrLineString),LinearRing:$u(zm.prototype.writeLinearRing),Polygon:$u(zm.prototype.writeSurfaceOrPolygon),MultiPolygon:$u(zm.prototype.writeMultiSurfaceOrPolygon),Surface:$u(zm.prototype.writeSurfaceOrPolygon),MultiSurface:$u(zm.prototype.writeMultiSurfaceOrPolygon),Envelope:$u(zm.prototype.writeEnvelope)}};var Um=zm,Bm=Um;Bm.prototype.writeFeatures,Bm.prototype.writeFeaturesNode;var Ym=Bm,Vm=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Wm={MultiLineString:"lineStringMember",MultiCurve:"curveMember",MultiPolygon:"polygonMember",MultiSurface:"surfaceMember"},qm=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,n)||this).FEATURE_COLLECTION_PARSERS[wm].featureMember=Zu(r.readFeaturesInternal),r.schemaLocation=n.schemaLocation?n.schemaLocation:"http://www.opengis.net/gml http://schemas.opengis.net/gml/2.1.2/feature.xsd",r}return Vm(e,t),e.prototype.readFlatCoordinates=function(t,e){var r=Vu(t,!1).replace(/^\s*|\s*$/g,""),n=e[0].srsName,i="enu";if(n){var o=yr(n);o&&(i=o.getAxisOrientation())}for(var a=r.trim().split(/\s+/),s=[],u=0,l=a.length;u<l;u++){var h=a[u].split(/,+/),c=parseFloat(h[0]),p=parseFloat(h[1]),f=3===h.length?parseFloat(h[2]):0;"en"===i.substr(0,2)?s.push(c,p,f):s.push(p,c,f)}return s},e.prototype.readBox=function(t,e){var r=ol([null],this.BOX_PARSERS_,t,e,this);return Zt(r[1][0],r[1][1],r[1][3],r[1][4])},e.prototype.innerBoundaryIsParser=function(t,e){var r=ol(void 0,this.RING_PARSERS,t,e,this);r&&e[e.length-1].push(r)},e.prototype.outerBoundaryIsParser=function(t,e){var r=ol(void 0,this.RING_PARSERS,t,e,this);r&&(e[e.length-1][0]=r)},e.prototype.GEOMETRY_NODE_FACTORY_=function(t,e,r){var n,i=e[e.length-1],o=i.multiSurface,a=i.surface,s=i.multiCurve;return Array.isArray(t)?n="Envelope":"MultiPolygon"===(n=t.getType())&&!0===o?n="MultiSurface":"Polygon"===n&&!0===a?n="Surface":"MultiLineString"===n&&!0===s&&(n="MultiCurve"),Yu("http://www.opengis.net/gml",n)},e.prototype.writeFeatureElement=function(t,e,r){var n=e.getId();n&&t.setAttribute("fid",n);var i=r[r.length-1],o=i.featureNS,a=e.getGeometryName();i.serializers||(i.serializers={},i.serializers[o]={});var s=[],u=[];if(e.hasProperties()){var l=e.getProperties();for(var h in l){var c=l[h];null!==c&&(s.push(h),u.push(c),h==a||"function"==typeof c.getSimplifiedGeometry?h in i.serializers[o]||(i.serializers[o][h]=$u(this.writeGeometryElement,this)):h in i.serializers[o]||(i.serializers[o][h]=$u(jm)))}}var p=T({},i);p.node=t,sl(p,i.serializers,tl(void 0,o),u,r,s)},e.prototype.writeCurveOrLineString=function(t,e,r){var n=r[r.length-1].srsName;if("LineStringSegment"!==t.nodeName&&n&&t.setAttribute("srsName",n),"LineString"===t.nodeName||"LineStringSegment"===t.nodeName){var i=this.createCoordinatesNode_(t.namespaceURI);t.appendChild(i),this.writeCoordinates_(i,e,r)}else if("Curve"===t.nodeName){var o=Yu(t.namespaceURI,"segments");t.appendChild(o),this.writeCurveSegments_(o,e,r)}},e.prototype.writeLineStringOrCurveMember=function(t,e,r){var n=this.GEOMETRY_NODE_FACTORY_(e,r);n&&(t.appendChild(n),this.writeCurveOrLineString(n,e,r))},e.prototype.writeMultiCurveOrLineString=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=n.srsName,a=n.curve;o&&t.setAttribute("srsName",o);var s=e.getLineStrings();sl({node:t,hasZ:i,srsName:o,curve:a},this.LINESTRINGORCURVEMEMBER_SERIALIZERS,this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_,s,r,void 0,this)},e.prototype.writeGeometryElement=function(t,e,r){var n,i=r[r.length-1],o=T({},i);o.node=t,n=Array.isArray(e)?Bd(e,i):Ud(e,!0,i),sl(o,this.GEOMETRY_SERIALIZERS,this.GEOMETRY_NODE_FACTORY_,[n],r,void 0,this)},e.prototype.createCoordinatesNode_=function(t){var e=Yu(t,"coordinates");return e.setAttribute("decimal","."),e.setAttribute("cs",","),e.setAttribute("ts"," "),e},e.prototype.writeCoordinates_=function(t,e,r){for(var n=r[r.length-1],i=n.hasZ,o=n.srsName,a=e.getCoordinates(),s=a.length,u=new Array(s),l=0;l<s;++l){var h=a[l];u[l]=this.getCoords_(h,o,i)}jm(t,u.join(" "))},e.prototype.writeCurveSegments_=function(t,e,r){var n=Yu(t.namespaceURI,"LineStringSegment");t.appendChild(n),this.writeCurveOrLineString(n,e,r)},e.prototype.writeSurfaceOrPolygon=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=n.srsName;if("PolygonPatch"!==t.nodeName&&o&&t.setAttribute("srsName",o),"Polygon"===t.nodeName||"PolygonPatch"===t.nodeName){var a=e.getLinearRings();sl({node:t,hasZ:i,srsName:o},this.RING_SERIALIZERS,this.RING_NODE_FACTORY_,a,r,void 0,this)}else if("Surface"===t.nodeName){var s=Yu(t.namespaceURI,"patches");t.appendChild(s),this.writeSurfacePatches_(s,e,r)}},e.prototype.RING_NODE_FACTORY_=function(t,e,r){var n=e[e.length-1],i=n.node,o=n.exteriorWritten;return void 0===o&&(n.exteriorWritten=!0),Yu(i.namespaceURI,void 0!==o?"innerBoundaryIs":"outerBoundaryIs")},e.prototype.writeSurfacePatches_=function(t,e,r){var n=Yu(t.namespaceURI,"PolygonPatch");t.appendChild(n),this.writeSurfaceOrPolygon(n,e,r)},e.prototype.writeRing=function(t,e,r){var n=Yu(t.namespaceURI,"LinearRing");t.appendChild(n),this.writeLinearRing(n,e,r)},e.prototype.getCoords_=function(t,e,r){var n="enu";e&&(n=yr(e).getAxisOrientation());var i="en"===n.substr(0,2)?t[0]+","+t[1]:t[1]+","+t[0];r&&(i+=","+(t[2]||0));return i},e.prototype.writePoint=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=n.srsName;o&&t.setAttribute("srsName",o);var a=this.createCoordinatesNode_(t.namespaceURI);t.appendChild(a);var s=e.getCoordinates();jm(a,this.getCoords_(s,o,i))},e.prototype.writeMultiPoint=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=n.srsName;o&&t.setAttribute("srsName",o);var a=e.getPoints();sl({node:t,hasZ:i,srsName:o},this.POINTMEMBER_SERIALIZERS,tl("pointMember"),a,r,void 0,this)},e.prototype.writePointMember=function(t,e,r){var n=Yu(t.namespaceURI,"Point");t.appendChild(n),this.writePoint(n,e,r)},e.prototype.writeLinearRing=function(t,e,r){var n=r[r.length-1].srsName;n&&t.setAttribute("srsName",n);var i=this.createCoordinatesNode_(t.namespaceURI);t.appendChild(i),this.writeCoordinates_(i,e,r)},e.prototype.writeMultiSurfaceOrPolygon=function(t,e,r){var n=r[r.length-1],i=n.hasZ,o=n.srsName,a=n.surface;o&&t.setAttribute("srsName",o);var s=e.getPolygons();sl({node:t,hasZ:i,srsName:o,surface:a},this.SURFACEORPOLYGONMEMBER_SERIALIZERS,this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_,s,r,void 0,this)},e.prototype.writeSurfaceOrPolygonMember=function(t,e,r){var n=this.GEOMETRY_NODE_FACTORY_(e,r);n&&(t.appendChild(n),this.writeSurfaceOrPolygon(n,e,r))},e.prototype.writeEnvelope=function(t,e,r){var n=r[r.length-1].srsName;n&&t.setAttribute("srsName",n);var i=[e[0]+" "+e[1],e[2]+" "+e[3]];sl({node:t},this.ENVELOPE_SERIALIZERS,el,i,r,["lowerCorner","upperCorner"],this)},e.prototype.MULTIGEOMETRY_MEMBER_NODE_FACTORY_=function(t,e,r){var n=e[e.length-1].node;return Yu("http://www.opengis.net/gml",Wm[n.nodeName])},e}(Em);qm.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS={"http://www.opengis.net/gml":{coordinates:Ku(qm.prototype.readFlatCoordinates)}},qm.prototype.FLAT_LINEAR_RINGS_PARSERS={"http://www.opengis.net/gml":{innerBoundaryIs:qm.prototype.innerBoundaryIsParser,outerBoundaryIs:qm.prototype.outerBoundaryIsParser}},qm.prototype.BOX_PARSERS_={"http://www.opengis.net/gml":{coordinates:Zu(qm.prototype.readFlatCoordinates)}},qm.prototype.GEOMETRY_PARSERS={"http://www.opengis.net/gml":{Point:Ku(Em.prototype.readPoint),MultiPoint:Ku(Em.prototype.readMultiPoint),LineString:Ku(Em.prototype.readLineString),MultiLineString:Ku(Em.prototype.readMultiLineString),LinearRing:Ku(Em.prototype.readLinearRing),Polygon:Ku(Em.prototype.readPolygon),MultiPolygon:Ku(Em.prototype.readMultiPolygon),Box:Ku(qm.prototype.readBox)}},qm.prototype.GEOMETRY_SERIALIZERS={"http://www.opengis.net/gml":{Curve:$u(qm.prototype.writeCurveOrLineString),MultiCurve:$u(qm.prototype.writeMultiCurveOrLineString),Point:$u(qm.prototype.writePoint),MultiPoint:$u(qm.prototype.writeMultiPoint),LineString:$u(qm.prototype.writeCurveOrLineString),MultiLineString:$u(qm.prototype.writeMultiCurveOrLineString),LinearRing:$u(qm.prototype.writeLinearRing),Polygon:$u(qm.prototype.writeSurfaceOrPolygon),MultiPolygon:$u(qm.prototype.writeMultiSurfaceOrPolygon),Surface:$u(qm.prototype.writeSurfaceOrPolygon),MultiSurface:$u(qm.prototype.writeMultiSurfaceOrPolygon),Envelope:$u(qm.prototype.writeEnvelope)}},qm.prototype.LINESTRINGORCURVEMEMBER_SERIALIZERS={"http://www.opengis.net/gml":{lineStringMember:$u(qm.prototype.writeLineStringOrCurveMember),curveMember:$u(qm.prototype.writeLineStringOrCurveMember)}},qm.prototype.RING_SERIALIZERS={"http://www.opengis.net/gml":{outerBoundaryIs:$u(qm.prototype.writeRing),innerBoundaryIs:$u(qm.prototype.writeRing)}},qm.prototype.POINTMEMBER_SERIALIZERS={"http://www.opengis.net/gml":{pointMember:$u(qm.prototype.writePointMember)}},qm.prototype.SURFACEORPOLYGONMEMBER_SERIALIZERS={"http://www.opengis.net/gml":{surfaceMember:$u(qm.prototype.writeSurfaceOrPolygonMember),polygonMember:$u(qm.prototype.writeSurfaceOrPolygonMember)}},qm.prototype.ENVELOPE_SERIALIZERS={"http://www.opengis.net/gml":{lowerCorner:$u(jm),upperCorner:$u(jm)}};var Xm=qm,Zm=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Km=function(t){function e(e){var r=this,n=e||{};return(r=t.call(this,n)||this).schemaLocation=n.schemaLocation?n.schemaLocation:r.namespace+" http://schemas.opengis.net/gml/3.2.1/gml.xsd",r}return Zm(e,t),e}(Um);Km.prototype.namespace="http://www.opengis.net/gml/3.2",Km.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS={"http://www.opengis.net/gml/3.2":{pos:Ku(Um.prototype.readFlatPos),posList:Ku(Um.prototype.readFlatPosList)}},Km.prototype.FLAT_LINEAR_RINGS_PARSERS={"http://www.opengis.net/gml/3.2":{interior:Um.prototype.interiorParser,exterior:Um.prototype.exteriorParser}},Km.prototype.GEOMETRY_PARSERS={"http://www.opengis.net/gml/3.2":{Point:Ku(Em.prototype.readPoint),MultiPoint:Ku(Em.prototype.readMultiPoint),LineString:Ku(Em.prototype.readLineString),MultiLineString:Ku(Em.prototype.readMultiLineString),LinearRing:Ku(Em.prototype.readLinearRing),Polygon:Ku(Em.prototype.readPolygon),MultiPolygon:Ku(Em.prototype.readMultiPolygon),Surface:Ku(Km.prototype.readSurface),MultiSurface:Ku(Um.prototype.readMultiSurface),Curve:Ku(Km.prototype.readCurve),MultiCurve:Ku(Um.prototype.readMultiCurve),Envelope:Ku(Km.prototype.readEnvelope)}},Km.prototype.MULTICURVE_PARSERS={"http://www.opengis.net/gml/3.2":{curveMember:Zu(Um.prototype.curveMemberParser),curveMembers:Zu(Um.prototype.curveMemberParser)}},Km.prototype.MULTISURFACE_PARSERS={"http://www.opengis.net/gml/3.2":{surfaceMember:Zu(Um.prototype.surfaceMemberParser),surfaceMembers:Zu(Um.prototype.surfaceMemberParser)}},Km.prototype.CURVEMEMBER_PARSERS={"http://www.opengis.net/gml/3.2":{LineString:Zu(Em.prototype.readLineString),Curve:Zu(Um.prototype.readCurve)}},Km.prototype.SURFACEMEMBER_PARSERS={"http://www.opengis.net/gml/3.2":{Polygon:Zu(Em.prototype.readPolygon),Surface:Zu(Um.prototype.readSurface)}},Km.prototype.SURFACE_PARSERS={"http://www.opengis.net/gml/3.2":{patches:Ku(Um.prototype.readPatch)}},Km.prototype.CURVE_PARSERS={"http://www.opengis.net/gml/3.2":{segments:Ku(Um.prototype.readSegment)}},Km.prototype.ENVELOPE_PARSERS={"http://www.opengis.net/gml/3.2":{lowerCorner:Zu(Um.prototype.readFlatPosList),upperCorner:Zu(Um.prototype.readFlatPosList)}},Km.prototype.PATCHES_PARSERS={"http://www.opengis.net/gml/3.2":{PolygonPatch:Ku(Um.prototype.readPolygonPatch)}},Km.prototype.SEGMENTS_PARSERS={"http://www.opengis.net/gml/3.2":{LineStringSegment:Ku(Um.prototype.readLineStringSegment)}},Km.prototype.MULTIPOINT_PARSERS={"http://www.opengis.net/gml/3.2":{pointMember:Zu(Em.prototype.pointMemberParser),pointMembers:Zu(Em.prototype.pointMemberParser)}},Km.prototype.MULTILINESTRING_PARSERS={"http://www.opengis.net/gml/3.2":{lineStringMember:Zu(Em.prototype.lineStringMemberParser),lineStringMembers:Zu(Em.prototype.lineStringMemberParser)}},Km.prototype.MULTIPOLYGON_PARSERS={"http://www.opengis.net/gml/3.2":{polygonMember:Zu(Em.prototype.polygonMemberParser),polygonMembers:Zu(Em.prototype.polygonMemberParser)}},Km.prototype.POINTMEMBER_PARSERS={"http://www.opengis.net/gml/3.2":{Point:Zu(Em.prototype.readFlatCoordinatesFromNode)}},Km.prototype.LINESTRINGMEMBER_PARSERS={"http://www.opengis.net/gml/3.2":{LineString:Zu(Em.prototype.readLineString)}},Km.prototype.POLYGONMEMBER_PARSERS={"http://www.opengis.net/gml/3.2":{Polygon:Zu(Em.prototype.readPolygon)}},Km.prototype.RING_PARSERS={"http://www.opengis.net/gml/3.2":{LinearRing:Ku(Em.prototype.readFlatLinearRing)}},Km.prototype.RING_SERIALIZERS={"http://www.opengis.net/gml/3.2":{exterior:$u(Um.prototype.writeRing),interior:$u(Um.prototype.writeRing)}},Km.prototype.ENVELOPE_SERIALIZERS={"http://www.opengis.net/gml/3.2":{lowerCorner:$u(jm),upperCorner:$u(jm)}},Km.prototype.SURFACEORPOLYGONMEMBER_SERIALIZERS={"http://www.opengis.net/gml/3.2":{surfaceMember:$u(Um.prototype.writeSurfaceOrPolygonMember),polygonMember:$u(Um.prototype.writeSurfaceOrPolygonMember)}},Km.prototype.POINTMEMBER_SERIALIZERS={"http://www.opengis.net/gml/3.2":{pointMember:$u(Um.prototype.writePointMember)}},Km.prototype.LINESTRINGORCURVEMEMBER_SERIALIZERS={"http://www.opengis.net/gml/3.2":{lineStringMember:$u(Um.prototype.writeLineStringOrCurveMember),curveMember:$u(Um.prototype.writeLineStringOrCurveMember)}},Km.prototype.GEOMETRY_SERIALIZERS={"http://www.opengis.net/gml/3.2":{Curve:$u(Um.prototype.writeCurveOrLineString),MultiCurve:$u(Um.prototype.writeMultiCurveOrLineString),Point:$u(Km.prototype.writePoint),MultiPoint:$u(Um.prototype.writeMultiPoint),LineString:$u(Um.prototype.writeCurveOrLineString),MultiLineString:$u(Um.prototype.writeMultiCurveOrLineString),LinearRing:$u(Um.prototype.writeLinearRing),Polygon:$u(Um.prototype.writeSurfaceOrPolygon),MultiPolygon:$u(Um.prototype.writeMultiSurfaceOrPolygon),Surface:$u(Um.prototype.writeSurfaceOrPolygon),MultiSurface:$u(Um.prototype.writeMultiSurfaceOrPolygon),Envelope:$u(Um.prototype.writeEnvelope)}};var Hm=Km,Jm=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),$m=[null,"http://www.topografix.com/GPX/1/0","http://www.topografix.com/GPX/1/1"],Qm={rte:Pv,trk:Rv,wpt:Ov},tv=nl($m,{rte:Zu(Pv),trk:Zu(Rv),wpt:Zu(Ov)}),ev=nl($m,{text:Ju(Fm,"linkText"),type:Ju(Fm,"linkType")}),rv=nl($m,{rte:$u((function(t,e,r){var n=r[0],i=e.getProperties(),o={node:t};o.properties=i;var a=e.getGeometry();if(a.getType()==yt.LINE_STRING){var s=Ud(a,!0,n);o.geometryLayout=s.getLayout(),i.rtept=s.getCoordinates()}var u=r[r.length-1].node,l=pv[u.namespaceURI],h=rl(i,l);sl(o,fv,el,h,r,l)})),trk:$u((function(t,e,r){var n=r[0],i=e.getProperties(),o={node:t};o.properties=i;var a=e.getGeometry();if(a.getType()==yt.MULTI_LINE_STRING){var s=Ud(a,!0,n);i.trkseg=s.getLineStrings()}var u=r[r.length-1].node,l=gv[u.namespaceURI],h=rl(i,l);sl(o,yv,el,h,r,l)})),wpt:$u((function(t,e,r){var n=r[0],i=r[r.length-1];i.properties=e.getProperties();var o=e.getGeometry();if(o.getType()==yt.POINT){var a=Ud(o,!0,n);i.geometryLayout=a.getLayout(),Lv(t,a.getCoordinates(),r)}}))}),nv=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.dataProjection=yr("EPSG:4326"),r.readExtensions_=n.readExtensions,r}return Jm(e,t),e.prototype.handleReadExtensions_=function(t){t||(t=[]);for(var e=0,r=t.length;e<r;++e){var n=t[e];if(this.readExtensions_){var i=n.get("extensionsNode_")||null;this.readExtensions_(n,i)}n.set("extensionsNode_",void 0)}},e.prototype.readFeatureFromNode=function(t,e){if(!d($m,t.namespaceURI))return null;var r=Qm[t.localName];if(!r)return null;var n=r(t,[this.getReadOptions(t,e)]);return n?(this.handleReadExtensions_([n]),n):null},e.prototype.readFeaturesFromNode=function(t,e){if(!d($m,t.namespaceURI))return[];if("gpx"==t.localName){var r=ol([],tv,t,[this.getReadOptions(t,e)]);return r?(this.handleReadExtensions_(r),r):[]}return[]},e.prototype.writeFeaturesNode=function(t,e){e=this.adaptOptions(e);var r=Yu("http://www.topografix.com/GPX/1/1","gpx");return r.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:xsi",Bu),r.setAttributeNS(Bu,"xsi:schemaLocation","http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd"),r.setAttribute("version","1.1"),r.setAttribute("creator","OpenLayers"),sl({node:r},rv,wv,t,[e]),r},e}(bm),iv=nl($m,{name:Ju(Fm),cmt:Ju(Fm),desc:Ju(Fm),src:Ju(Fm),link:Ev,number:Ju(Lm),extensions:Cv,type:Ju(Fm),rtept:function(t,e){var r=ol({},ov,t,e);if(r){var n=e[e.length-1],i=n.flatCoordinates,o=n.layoutOptions;Sv(i,o,t,r)}}}),ov=nl($m,{ele:Ju(Om),time:Ju(Rm)}),av=nl($m,{name:Ju(Fm),cmt:Ju(Fm),desc:Ju(Fm),src:Ju(Fm),link:Ev,number:Ju(Lm),type:Ju(Fm),extensions:Cv,trkseg:function(t,e){var r=e[e.length-1];il(sv,t,e);var n=r.flatCoordinates;r.ends.push(n.length)}}),sv=nl($m,{trkpt:function(t,e){var r=ol({},uv,t,e);if(r){var n=e[e.length-1],i=n.flatCoordinates,o=n.layoutOptions;Sv(i,o,t,r)}}}),uv=nl($m,{ele:Ju(Om),time:Ju(Rm)}),lv=nl($m,{ele:Ju(Om),time:Ju(Rm),magvar:Ju(Om),geoidheight:Ju(Om),name:Ju(Fm),cmt:Ju(Fm),desc:Ju(Fm),src:Ju(Fm),link:Ev,sym:Ju(Fm),type:Ju(Fm),fix:Ju(Fm),sat:Ju(Lm),hdop:Ju(Om),vdop:Ju(Om),pdop:Ju(Om),ageofdgpsdata:Ju(Om),dgpsid:Ju(Lm),extensions:Cv}),hv=["text","type"],cv=nl($m,{text:$u(jm),type:$u(jm)}),pv=nl($m,["name","cmt","desc","src","link","number","type","rtept"]),fv=nl($m,{name:$u(jm),cmt:$u(jm),desc:$u(jm),src:$u(jm),link:$u(Iv),number:$u(Nm),type:$u(jm),rtept:Qu($u(Lv))}),dv=nl($m,["ele","time"]),gv=nl($m,["name","cmt","desc","src","link","number","type","trkseg"]),yv=nl($m,{name:$u(jm),cmt:$u(jm),desc:$u(jm),src:$u(jm),link:$u(Iv),number:$u(Nm),type:$u(jm),trkseg:Qu($u((function(t,e,r){var n={node:t};n.geometryLayout=e.getLayout(),n.properties={},sl(n,vv,mv,e.getCoordinates(),r)})))}),mv=tl("trkpt"),vv=nl($m,{trkpt:$u(Lv)}),_v=nl($m,["ele","time","magvar","geoidheight","name","cmt","desc","src","link","sym","type","fix","sat","hdop","vdop","pdop","ageofdgpsdata","dgpsid"]),bv=nl($m,{ele:$u(km),time:$u((function(t,e){var r=new Date(1e3*e),n=r.getUTCFullYear()+"-"+$e(r.getUTCMonth()+1,2)+"-"+$e(r.getUTCDate(),2)+"T"+$e(r.getUTCHours(),2)+":"+$e(r.getUTCMinutes(),2)+":"+$e(r.getUTCSeconds(),2)+"Z";t.appendChild(hl().createTextNode(n))})),magvar:$u(km),geoidheight:$u(km),name:$u(jm),cmt:$u(jm),desc:$u(jm),src:$u(jm),link:$u(Iv),sym:$u(jm),type:$u(jm),fix:$u(jm),sat:$u(Nm),hdop:$u(km),vdop:$u(km),pdop:$u(km),ageofdgpsdata:$u(km),dgpsid:$u(Nm)}),xv={Point:"wpt",LineString:"rte",MultiLineString:"trk"};function wv(t,e,r){var n=t.getGeometry();if(n){var i=xv[n.getType()];if(i)return Yu(e[e.length-1].node.namespaceURI,i)}}function Sv(t,e,r,n){return t.push(parseFloat(r.getAttribute("lon")),parseFloat(r.getAttribute("lat"))),"ele"in n?(t.push(n.ele),delete n.ele,e.hasZ=!0):t.push(0),"time"in n?(t.push(n.time),delete n.time,e.hasM=!0):t.push(0),t}function Tv(t,e,r){var n=pt,i=2;if(t.hasZ&&t.hasM?(n=gt,i=4):t.hasZ?(n=ft,i=3):t.hasM&&(n=dt,i=3),4!==i){for(var o=0,a=e.length/4;o<a;o++)e[o*i]=e[4*o],e[o*i+1]=e[4*o+1],t.hasZ&&(e[o*i+2]=e[4*o+2]),t.hasM&&(e[o*i+2]=e[4*o+3]);if(e.length=e.length/4*i,r)for(o=0,a=r.length;o<a;o++)r[o]=r[o]/4*i}return n}function Ev(t,e){var r=e[e.length-1],n=t.getAttribute("href");null!==n&&(r.link=n),il(ev,t,e)}function Cv(t,e){e[e.length-1].extensionsNode_=t}function Pv(t,e){var r=e[0],n=ol({flatCoordinates:[],layoutOptions:{}},iv,t,e);if(n){var i=n.flatCoordinates;delete n.flatCoordinates;var o=n.layoutOptions;delete n.layoutOptions;var a=Tv(o,i),s=new Cd(i,a);Ud(s,!1,r);var u=new ct(s);return u.setProperties(n,!0),u}}function Rv(t,e){var r=e[0],n=ol({flatCoordinates:[],ends:[],layoutOptions:{}},av,t,e);if(n){var i=n.flatCoordinates;delete n.flatCoordinates;var o=n.ends;delete n.ends;var a=n.layoutOptions;delete n.layoutOptions;var s=Tv(a,i,o),u=new Vd(i,s,o);Ud(u,!1,r);var l=new ct(u);return l.setProperties(n,!0),l}}function Ov(t,e){var r=e[0],n=ol({},lv,t,e);if(n){var i={},o=Sv([],i,t,n),a=Tv(i,o),s=new gn(o,a);Ud(s,!1,r);var u=new ct(s);return u.setProperties(n,!0),u}}function Iv(t,e,r){t.setAttribute("href",e);var n=r[r.length-1].properties,i=[n.linkText,n.linkType];sl({node:t},cv,el,i,r,hv)}function Lv(t,e,r){var n=r[r.length-1],i=n.node.namespaceURI,o=n.properties;switch(t.setAttributeNS(null,"lat",String(e[1])),t.setAttributeNS(null,"lon",String(e[0])),n.geometryLayout){case gt:0!==e[3]&&(o.time=e[3]);case ft:0!==e[2]&&(o.ele=e[2]);break;case dt:0!==e[2]&&(o.time=e[2])}var a="rtept"==t.nodeName?dv[i]:_v[i],s=rl(o,a);sl({node:t,properties:o},bv,el,s,r,a)}var Mv=nv,Fv=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function Av(t){return"string"==typeof t?t:""}var kv,Nv,jv,Gv,Dv,zv,Uv,Bv=function(t){function e(){return t.call(this)||this}return Fv(e,t),e.prototype.getType=function(){return vu},e.prototype.readFeature=function(t,e){return this.readFeatureFromText(Av(t),this.adaptOptions(e))},e.prototype.readFeatureFromText=function(t,e){return n()},e.prototype.readFeatures=function(t,e){return this.readFeaturesFromText(Av(t),this.adaptOptions(e))},e.prototype.readFeaturesFromText=function(t,e){return n()},e.prototype.readGeometry=function(t,e){return this.readGeometryFromText(Av(t),this.adaptOptions(e))},e.prototype.readGeometryFromText=function(t,e){return n()},e.prototype.readProjection=function(t){return this.readProjectionFromText(Av(t))},e.prototype.readProjectionFromText=function(t){return this.dataProjection},e.prototype.writeFeature=function(t,e){return this.writeFeatureText(t,this.adaptOptions(e))},e.prototype.writeFeatureText=function(t,e){return n()},e.prototype.writeFeatures=function(t,e){return this.writeFeaturesText(t,this.adaptOptions(e))},e.prototype.writeFeaturesText=function(t,e){return n()},e.prototype.writeGeometry=function(t,e){return this.writeGeometryText(t,this.adaptOptions(e))},e.prototype.writeGeometryText=function(t,e){return n()},e}(zd),Yv=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Vv="barometric",Wv="gps",qv="none",Xv=/^B(\d{2})(\d{2})(\d{2})(\d{2})(\d{5})([NS])(\d{3})(\d{5})([EW])([AV])(\d{5})(\d{5})/,Zv=/^H.([A-Z]{3}).*?:(.*)/,Kv=/^HFDTE(\d{2})(\d{2})(\d{2})/,Hv=/\r\n|\r|\n/,Jv=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.dataProjection=yr("EPSG:4326"),r.altitudeMode_=n.altitudeMode?n.altitudeMode:qv,r}return Yv(e,t),e.prototype.readFeatureFromText=function(t,e){var r,n,i=this.altitudeMode_,o=t.split(Hv),a={},s=[],u=2e3,l=0,h=1,c=-1;for(r=0,n=o.length;r<n;++r){var p=o[r],f=void 0;if("B"==p.charAt(0)){if(f=Xv.exec(p)){var d=parseInt(f[1],10),g=parseInt(f[2],10),y=parseInt(f[3],10),m=parseInt(f[4],10)+parseInt(f[5],10)/6e4;"S"==f[6]&&(m=-m);var v=parseInt(f[7],10)+parseInt(f[8],10)/6e4;if("W"==f[9]&&(v=-v),s.push(v,m),i!=qv){var _=void 0;_=i==Wv?parseInt(f[11],10):i==Vv?parseInt(f[12],10):0,s.push(_)}var b=Date.UTC(u,l,h,d,g,y);b<c&&(b=Date.UTC(u,l,h+1,d,g,y)),s.push(b/1e3),c=b}}else"H"==p.charAt(0)&&((f=Kv.exec(p))?(h=parseInt(f[1],10),l=parseInt(f[2],10)-1,u=2e3+parseInt(f[3],10)):(f=Zv.exec(p))&&(a[f[1]]=f[2].trim()))}if(0===s.length)return null;var x=new Cd(s,i==qv?dt:gt),w=new ct(Ud(x,!1,e));return w.setProperties(a,!0),w},e.prototype.readFeaturesFromText=function(t,e){var r=this.readFeatureFromText(t,e);return r?[r]:[]},e}(Bv),$v=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Qv=["http://www.google.com/kml/ext/2.2"],t_=[null,"http://earth.google.com/kml/2.0","http://earth.google.com/kml/2.1","http://earth.google.com/kml/2.2","http://www.opengis.net/kml/2.2"],e_={fraction:Ul,pixels:Bl,insetPixels:Bl},r_=nl(t_,{ExtendedData:K_,Region:H_,MultiGeometry:Ju(z_,"geometry"),LineString:Ju(j_,"geometry"),LinearRing:Ju(G_,"geometry"),Point:Ju(U_,"geometry"),Polygon:Ju(Y_,"geometry"),Style:Ju(W_),StyleMap:function(t,e){var r=S_.call(this,t,e);if(!r)return;var n=e[e.length-1];Array.isArray(r)?n.Style=r:"string"==typeof r?n.styleUrl=r:lt(!1,38)},address:Ju(Fm),description:Ju(Fm),name:Ju(Fm),open:Ju(Cm),phoneNumber:Ju(Fm),styleUrl:Ju(b_),visibility:Ju(Cm)},nl(Qv,{MultiTrack:Ju((function(t,e){var r=ol([],I_,t,e);if(!r)return;return new Vd(r)}),"geometry"),Track:Ju(M_,"geometry")})),n_=nl(t_,{ExtendedData:K_,Region:H_,Link:function(t,e){il(i_,t,e)},address:Ju(Fm),description:Ju(Fm),name:Ju(Fm),open:Ju(Cm),phoneNumber:Ju(Fm),visibility:Ju(Cm)}),i_=nl(t_,{href:Ju(b_)}),o_=nl(t_,{LatLonAltBox:function(t,e){var r=ol({},Q_,t,e);if(!r)return;var n=e[e.length-1],i=[parseFloat(r.west),parseFloat(r.south),parseFloat(r.east),parseFloat(r.north)];n.extent=i,n.altitudeMode=r.altitudeMode,n.minAltitude=parseFloat(r.minAltitude),n.maxAltitude=parseFloat(r.maxAltitude)},Lod:function(t,e){var r=ol({},tb,t,e);if(!r)return;var n=e[e.length-1];n.minLodPixels=parseFloat(r.minLodPixels),n.maxLodPixels=parseFloat(r.maxLodPixels),n.minFadeExtent=parseFloat(r.minFadeExtent),n.maxFadeExtent=parseFloat(r.maxFadeExtent)}}),a_=nl(t_,["Document","Placemark"]),s_=nl(t_,{Document:$u((function(t,e,r){sl({node:t},ob,ab,e,r,void 0,this)})),Placemark:$u(Ib)}),u_=null;var l_,h_=null;var c_,p_=null;var f_=null;var d_=null;var g_,y_=null;var m_=function(t){function e(e){var r=t.call(this)||this,n=e||{};return y_||(u_=new zl({color:kv=[255,255,255,1]}),h_=new rh({anchor:Nv=[20,2],anchorOrigin:Yl,anchorXUnits:jv=Bl,anchorYUnits:Gv=Bl,crossOrigin:"anonymous",rotation:0,scale:Uv=.5,size:Dv=[64,64],src:zv="https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png"}),l_="NO_IMAGE",p_=new nh({color:kv,width:1}),c_=new nh({color:[51,51,51,1],width:2}),f_=new ph({font:"bold 16px Helvetica",fill:u_,stroke:c_,scale:.8}),d_=new lh({fill:u_,image:h_,text:f_,stroke:p_,zIndex:0}),y_=[d_]),r.dataProjection=yr("EPSG:4326"),r.defaultStyle_=n.defaultStyle?n.defaultStyle:y_,r.extractStyles_=void 0===n.extractStyles||n.extractStyles,r.writeStyles_=void 0===n.writeStyles||n.writeStyles,r.sharedStyles_={},r.showPointNames_=void 0===n.showPointNames||n.showPointNames,r.crossOrigin_=void 0!==n.crossOrigin?n.crossOrigin:"anonymous",r}return $v(e,t),e.prototype.readDocumentOrFolder_=function(t,e){var r=ol([],nl(t_,{Document:Xu(this.readDocumentOrFolder_,this),Folder:Xu(this.readDocumentOrFolder_,this),Placemark:Zu(this.readPlacemark_,this),Style:this.readSharedStyle_.bind(this),StyleMap:this.readSharedStyleMap_.bind(this)}),t,e,this);return r||void 0},e.prototype.readPlacemark_=function(t,e){var r=ol({geometry:null},r_,t,e,this);if(r){var n=new ct,i=t.getAttribute("id");null!==i&&n.setId(i);var o=e[0],a=r.geometry;if(a&&Ud(a,!1,o),n.setGeometry(a),delete r.geometry,this.extractStyles_){var s=function(t,e,r,n,i){return function(o,a){var s=i,u="",l=[];if(s){var h=o.getGeometry();if(h){var c=h.getType();s=c===yt.GEOMETRY_COLLECTION?(l=h.getGeometriesArrayRecursive().filter((function(t){var e=t.getType();return e===yt.POINT||e===yt.MULTI_POINT}))).length>0:c===yt.POINT||c===yt.MULTI_POINT}}s&&(u=o.get("name"),(s=s&&!!u)&&u.search(/&[^&]+;/)>-1&&(g_||(g_=document.createElement("textarea")),g_.innerHTML=u,u=g_.value));var p=r;if(t?p=t:e&&(p=function t(e,r,n){return Array.isArray(e)?e:"string"==typeof e?(!(e in n)&&"#"+e in n&&(e="#"+e),t(n[e],r,n)):r}(e,r,n)),s){var f=function(t,e){var r=[0,0],n="start",i=t.getImage();if(i){var o=i.getImageSize();if(null===o&&(o=Dv),2==o.length){var a=i.getScaleArray();r[0]=a[0]*o[0]/2,r[1]=-a[1]*o[1]/2,n="left"}}var s=t.getText();s?((s=s.clone()).setFont(s.getFont()||f_.getFont()),s.setScale(s.getScale()||f_.getScale()),s.setFill(s.getFill()||f_.getFill()),s.setStroke(s.getStroke()||c_)):s=f_.clone();return s.setText(e),s.setOffsetX(r[0]),s.setOffsetY(r[1]),s.setTextAlign(n),new lh({image:i,text:s})}(p[0],u);return l.length>0?(f.setGeometry(new Bg(l)),[f,new lh({geometry:p[0].getGeometry(),image:null,fill:p[0].getFill(),stroke:p[0].getStroke(),text:null})].concat(p.slice(1))):f}return p}}(r.Style,r.styleUrl,this.defaultStyle_,this.sharedStyles_,this.showPointNames_);n.setStyle(s)}return delete r.Style,n.setProperties(r,!0),n}},e.prototype.readSharedStyle_=function(t,e){var r=t.getAttribute("id");if(null!==r){var n=W_.call(this,t,e);if(n){var i=void 0,o=t.baseURI;if(o&&"about:blank"!=o||(o=window.location.href),o)i=new URL("#"+r,o).href;else i="#"+r;this.sharedStyles_[i]=n}}},e.prototype.readSharedStyleMap_=function(t,e){var r=t.getAttribute("id");if(null!==r){var n=S_.call(this,t,e);if(n){var i,o=t.baseURI;if(o&&"about:blank"!=o||(o=window.location.href),o)i=new URL("#"+r,o).href;else i="#"+r;this.sharedStyles_[i]=n}}},e.prototype.readFeatureFromNode=function(t,e){if(!d(t_,t.namespaceURI))return null;var r=this.readPlacemark_(t,[this.getReadOptions(t,e)]);return r||null},e.prototype.readFeaturesFromNode=function(t,e){if(!d(t_,t.namespaceURI))return[];var r,n=t.localName;if("Document"==n||"Folder"==n)return(r=this.readDocumentOrFolder_(t,[this.getReadOptions(t,e)]))||[];if("Placemark"==n){var i=this.readPlacemark_(t,[this.getReadOptions(t,e)]);return i?[i]:[]}if("kml"==n){r=[];for(var o=t.firstElementChild;o;o=o.nextElementSibling){var a=this.readFeaturesFromNode(o,e);a&&m(r,a)}return r}return[]},e.prototype.readName=function(t){if(t){if("string"==typeof t){var e=qu(t);return this.readNameFromDocument(e)}return Wu(t)?this.readNameFromDocument(t):this.readNameFromNode(t)}},e.prototype.readNameFromDocument=function(t){for(var e=t.firstChild;e;e=e.nextSibling)if(e.nodeType==Node.ELEMENT_NODE){var r=this.readNameFromNode(e);if(r)return r}},e.prototype.readNameFromNode=function(t){for(var e=t.firstElementChild;e;e=e.nextElementSibling)if(d(t_,e.namespaceURI)&&"name"==e.localName)return Fm(e);for(e=t.firstElementChild;e;e=e.nextElementSibling){var r=e.localName;if(d(t_,e.namespaceURI)&&("Document"==r||"Folder"==r||"Placemark"==r||"kml"==r)){var n=this.readNameFromNode(e);if(n)return n}}},e.prototype.readNetworkLinks=function(t){var e=[];if("string"==typeof t){var r=qu(t);m(e,this.readNetworkLinksFromDocument(r))}else Wu(t)?m(e,this.readNetworkLinksFromDocument(t)):m(e,this.readNetworkLinksFromNode(t));return e},e.prototype.readNetworkLinksFromDocument=function(t){for(var e=[],r=t.firstChild;r;r=r.nextSibling)r.nodeType==Node.ELEMENT_NODE&&m(e,this.readNetworkLinksFromNode(r));return e},e.prototype.readNetworkLinksFromNode=function(t){for(var e=[],r=t.firstElementChild;r;r=r.nextElementSibling)if(d(t_,r.namespaceURI)&&"NetworkLink"==r.localName){var n=ol({},n_,r,[]);e.push(n)}for(r=t.firstElementChild;r;r=r.nextElementSibling){var i=r.localName;!d(t_,r.namespaceURI)||"Document"!=i&&"Folder"!=i&&"kml"!=i||m(e,this.readNetworkLinksFromNode(r))}return e},e.prototype.readRegion=function(t){var e=[];if("string"==typeof t){var r=qu(t);m(e,this.readRegionFromDocument(r))}else Wu(t)?m(e,this.readRegionFromDocument(t)):m(e,this.readRegionFromNode(t));return e},e.prototype.readRegionFromDocument=function(t){for(var e=[],r=t.firstChild;r;r=r.nextSibling)r.nodeType==Node.ELEMENT_NODE&&m(e,this.readRegionFromNode(r));return e},e.prototype.readRegionFromNode=function(t){for(var e=[],r=t.firstElementChild;r;r=r.nextElementSibling)if(d(t_,r.namespaceURI)&&"Region"==r.localName){var n=ol({},o_,r,[]);e.push(n)}for(r=t.firstElementChild;r;r=r.nextElementSibling){var i=r.localName;!d(t_,r.namespaceURI)||"Document"!=i&&"Folder"!=i&&"kml"!=i||m(e,this.readRegionFromNode(r))}return e},e.prototype.writeFeaturesNode=function(t,e){e=this.adaptOptions(e);var r=Yu(t_[4],"kml"),n="http://www.w3.org/2000/xmlns/";r.setAttributeNS(n,"xmlns:gx",Qv[0]),r.setAttributeNS(n,"xmlns:xsi",Bu),r.setAttributeNS(Bu,"xsi:schemaLocation","http://www.opengis.net/kml/2.2 https://developers.google.com/kml/schema/kml22gx.xsd");var i={node:r},o={};t.length>1?o.Document=t:1==t.length&&(o.Placemark=t[0]);var a=a_[r.namespaceURI],s=rl(o,a);return sl(i,s_,el,s,[e],a,this),r},e}(bm);function v_(t){var e=Vu(t,!1),r=/^\s*#?\s*([0-9A-Fa-f]{8})\s*$/.exec(e);if(r){var n=r[1];return[parseInt(n.substr(6,2),16),parseInt(n.substr(4,2),16),parseInt(n.substr(2,2),16),parseInt(n.substr(0,2),16)/255]}}function __(t){for(var e,r=Vu(t,!1),n=[],i=/^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?))?\s*/i;e=i.exec(r);){var o=parseFloat(e[1]),a=parseFloat(e[2]),s=e[3]?parseFloat(e[3]):0;n.push(o,a,s),r=r.substr(e[0].length)}if(""===r)return n}function b_(t){var e=Vu(t,!1).trim(),r=t.baseURI;return r&&"about:blank"!=r||(r=window.location.href),r?new URL(e,r).href:e}function x_(t){return Om(t)}var w_=nl(t_,{Pair:function(t,e){var r=ol({},J_,t,e,this);if(!r)return;var n=r.key;if(n&&"normal"==n){var i=r.styleUrl;i&&(e[e.length-1]=i);var o=r.Style;o&&(e[e.length-1]=o)}}});function S_(t,e){return ol(void 0,w_,t,e,this)}var T_=nl(t_,{Icon:Ju((function(t,e){var r=ol({},F_,t,e);return r||null})),color:Ju(v_),heading:Ju(Om),hotSpot:Ju((function(t){var e,r=t.getAttribute("xunits"),n=t.getAttribute("yunits");return e="insetPixels"!==r?"insetPixels"!==n?Yl:Wl:"insetPixels"!==n?Vl:ql,{x:parseFloat(t.getAttribute("x")),xunits:e_[r],y:parseFloat(t.getAttribute("y")),yunits:e_[n],origin:e}})),scale:Ju(x_)});var E_=nl(t_,{color:Ju(v_),scale:Ju(x_)});var C_=nl(t_,{color:Ju(v_),width:Ju(Om)});var P_=nl(t_,{color:Ju(v_),fill:Ju(Cm),outline:Ju(Cm)});var R_=nl(t_,{coordinates:Ku(__)});function O_(t,e){return ol(null,R_,t,e)}var I_=nl(Qv,{Track:Zu(M_)});var L_=nl(t_,{when:function(t,e){var r=e[e.length-1].whens,n=Vu(t,!1),i=Date.parse(n);r.push(isNaN(i)?0:i)}},nl(Qv,{coord:function(t,e){var r=e[e.length-1].flatCoordinates,n=Vu(t,!1),i=/^\s*([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s*$/i.exec(n);if(i){var o=parseFloat(i[1]),a=parseFloat(i[2]),s=parseFloat(i[3]);r.push(o,a,s,0)}else r.push(0,0,0,0)}}));function M_(t,e){var r=ol({flatCoordinates:[],whens:[]},L_,t,e);if(r){for(var n=r.flatCoordinates,i=r.whens,o=0,a=Math.min(n.length,i.length);o<a;++o)n[4*o+3]=i[o];return new Cd(n,gt)}}var F_=nl(t_,{href:Ju(b_)},nl(Qv,{x:Ju(Om),y:Ju(Om),w:Ju(Om),h:Ju(Om)}));var A_=nl(t_,{coordinates:Ku(__)});function k_(t,e){return ol(null,A_,t,e)}var N_=nl(t_,{extrude:Ju(Cm),tessellate:Ju(Cm),altitudeMode:Ju(Fm)});function j_(t,e){var r=ol({},N_,t,e),n=k_(t,e);if(n){var i=new Cd(n,ft);return i.setProperties(r,!0),i}}function G_(t,e){var r=ol({},N_,t,e),n=k_(t,e);if(n){var i=new Ln(n,ft,[n.length]);return i.setProperties(r,!0),i}}var D_=nl(t_,{LineString:Zu(j_),LinearRing:Zu(G_),MultiGeometry:Zu(z_),Point:Zu(U_),Polygon:Zu(Y_)});function z_(t,e){var r,n=ol([],D_,t,e);if(!n)return null;if(0===n.length)return new Bg(n);for(var i=!0,o=n[0].getType(),a=1,s=n.length;a<s;++a)if(n[a].getType()!=o){i=!1;break}if(i){var u=void 0,l=void 0;if(o==yt.POINT){var h=n[0];u=h.getLayout(),l=h.getFlatCoordinates();for(a=1,s=n.length;a<s;++a)m(l,n[a].getFlatCoordinates());q_(r=new qd(l,u),n)}else o==yt.LINE_STRING?q_(r=new Vd(n),n):o==yt.POLYGON?q_(r=new Kd(n),n):o==yt.GEOMETRY_COLLECTION?r=new Bg(n):lt(!1,37)}else r=new Bg(n);return r}function U_(t,e){var r=ol({},N_,t,e),n=k_(t,e);if(n){var i=new gn(n,ft);return i.setProperties(r,!0),i}}var B_=nl(t_,{innerBoundaryIs:function(t,e){var r=ol(void 0,eb,t,e);if(r){e[e.length-1].push(r)}},outerBoundaryIs:function(t,e){var r=ol(void 0,rb,t,e);if(r){e[e.length-1][0]=r}}});function Y_(t,e){var r=ol({},N_,t,e),n=ol([null],B_,t,e);if(n&&n[0]){for(var i=n[0],o=[i.length],a=1,s=n.length;a<s;++a)m(i,n[a]),o.push(i.length);var u=new Ln(i,ft,o);return u.setProperties(r,!0),u}}var V_=nl(t_,{IconStyle:function(t,e){var r=ol({},T_,t,e);if(r){var n,i,o,a,s=e[e.length-1],u="Icon"in r?r.Icon:{},l=!("Icon"in r)||Object.keys(u).length>0,h=u.href;h?n=h:l&&(n=zv);var c,p=Yl,f=r.hotSpot;f?(i=[f.x,f.y],o=f.xunits,a=f.yunits,p=f.origin):n===zv?(i=Nv,o=jv,a=Gv):/^http:\/\/maps\.(?:google|gstatic)\.com\//.test(n)&&(i=[.5,0],o=Ul,a=Ul);var d,g=u.x,y=u.y;void 0!==g&&void 0!==y&&(c=[g,y]);var m,v=u.w,_=u.h;void 0!==v&&void 0!==_&&(d=[v,_]);var b=r.heading;void 0!==b&&(m=Re(b));var x=r.scale,w=r.color;if(l){n==zv&&(d=Dv,void 0===x&&(x=Uv));var S=new rh({anchor:i,anchorOrigin:p,anchorXUnits:o,anchorYUnits:a,crossOrigin:this.crossOrigin_,offset:c,offsetOrigin:Yl,rotation:m,scale:x,size:d,src:n,color:w});s.imageStyle=S}else s.imageStyle=l_}},LabelStyle:function(t,e){var r=ol({},E_,t,e);if(r){var n=e[e.length-1],i=new ph({fill:new zl({color:"color"in r?r.color:kv}),scale:r.scale});n.textStyle=i}},LineStyle:function(t,e){var r=ol({},C_,t,e);if(r){var n=e[e.length-1],i=new nh({color:"color"in r?r.color:kv,width:"width"in r?r.width:1});n.strokeStyle=i}},PolyStyle:function(t,e){var r=ol({},P_,t,e);if(r){var n=e[e.length-1],i=new zl({color:"color"in r?r.color:kv});n.fillStyle=i;var o=r.fill;void 0!==o&&(n.fill=o);var a=r.outline;void 0!==a&&(n.outline=a)}}});function W_(t,e){var r=ol({},V_,t,e,this);if(!r)return null;var n,i="fillStyle"in r?r.fillStyle:u_,o=r.fill;void 0===o||o||(i=null),"imageStyle"in r?r.imageStyle!=l_&&(n=r.imageStyle):n=h_;var a="textStyle"in r?r.textStyle:f_,s="strokeStyle"in r?r.strokeStyle:p_,u=r.outline;return void 0===u||u?[new lh({fill:i,image:n,stroke:s,text:a,zIndex:void 0})]:[new lh({geometry:function(t){var e=t.getGeometry(),r=e.getType();return r===yt.GEOMETRY_COLLECTION?new Bg(e.getGeometriesArrayRecursive().filter((function(t){var e=t.getType();return e!==yt.POLYGON&&e!==yt.MULTI_POLYGON}))):r!==yt.POLYGON&&r!==yt.MULTI_POLYGON?e:void 0},fill:i,image:n,stroke:s,text:a,zIndex:void 0}),new lh({geometry:function(t){var e=t.getGeometry(),r=e.getType();return r===yt.GEOMETRY_COLLECTION?new Bg(e.getGeometriesArrayRecursive().filter((function(t){var e=t.getType();return e===yt.POLYGON||e===yt.MULTI_POLYGON}))):r===yt.POLYGON||r===yt.MULTI_POLYGON?e:void 0},fill:i,stroke:null,zIndex:void 0})]}function q_(t,e){var r,n,i,o=e.length,a=new Array(e.length),s=new Array(e.length),u=new Array(e.length);r=!1,n=!1,i=!1;for(var l=0;l<o;++l){var h=e[l];a[l]=h.get("extrude"),s[l]=h.get("tessellate"),u[l]=h.get("altitudeMode"),r=r||void 0!==a[l],n=n||void 0!==s[l],i=i||u[l]}r&&t.set("extrude",a),n&&t.set("tessellate",s),i&&t.set("altitudeMode",u)}var X_=nl(t_,{displayName:Ju(Fm),value:Ju(Fm)});var Z_=nl(t_,{Data:function(t,e){var r=t.getAttribute("name");il(X_,t,e);var n=e[e.length-1];r&&n.displayName?n[r]={value:n.value,displayName:n.displayName,toString:function(){return n.value}}:null!==r?n[r]=n.value:null!==n.displayName&&(n[n.displayName]=n.value),delete n.value},SchemaData:function(t,e){il($_,t,e)}});function K_(t,e){il(Z_,t,e)}function H_(t,e){il(o_,t,e)}var J_=nl(t_,{Style:Ju(W_),key:Ju(Fm),styleUrl:Ju(b_)});var $_=nl(t_,{SimpleData:function(t,e){var r=t.getAttribute("name");if(null!==r){var n=Fm(t);e[e.length-1][r]=n}}});var Q_=nl(t_,{altitudeMode:Ju(Fm),minAltitude:Ju(Om),maxAltitude:Ju(Om),north:Ju(Om),south:Ju(Om),east:Ju(Om),west:Ju(Om)});var tb=nl(t_,{minLodPixels:Ju(Om),maxLodPixels:Ju(Om),minFadeExtent:Ju(Om),maxFadeExtent:Ju(Om)});var eb=nl(t_,{LinearRing:Ku(O_)});var rb=nl(t_,{LinearRing:Ku(O_)});function nb(t,e){for(var r=ni(e),n=[255*(4==r.length?r[3]:1),r[2],r[1],r[0]],i=0;i<4;++i){var o=Math.floor(n[i]).toString(16);n[i]=1==o.length?"0"+o:o}jm(t,n.join(""))}var ib=nl(t_,{Data:$u((function(t,e,r){t.setAttribute("name",e.name);var n={node:t},i=e.value;"object"==typeof i?(null!==i&&i.displayName&&sl(n,ib,el,[i.displayName],r,["displayName"]),null!==i&&i.value&&sl(n,ib,el,[i.value],r,["value"])):sl(n,ib,el,[i],r,["value"])})),value:$u((function(t,e){jm(t,e)})),displayName:$u((function(t,e){!function(t,e){t.appendChild(hl().createCDATASection(e))}(t,e)}))});var ob=nl(t_,{Placemark:$u(Ib)}),ab=function(t,e,r){return Yu(e[e.length-1].node.namespaceURI,"Placemark")};var sb=tl("Data");var ub=nl(t_,["href"],nl(Qv,["x","y","w","h"])),lb=nl(t_,{href:$u(jm)},nl(Qv,{x:$u(km),y:$u(km),w:$u(km),h:$u(km)})),hb=function(t,e,r){return Yu(Qv[0],"gx:"+r)};var cb=nl(t_,["scale","heading","Icon","color","hotSpot"]),pb=nl(t_,{Icon:$u((function(t,e,r){var n={node:t},i=r[r.length-1].node,o=ub[i.namespaceURI],a=rl(e,o);sl(n,lb,el,a,r,o),a=rl(e,o=ub[Qv[0]]),sl(n,lb,hb,a,r,o)})),color:$u(nb),heading:$u(km),hotSpot:$u((function(t,e){t.setAttribute("x",String(e.x)),t.setAttribute("y",String(e.y)),t.setAttribute("xunits",e.xunits),t.setAttribute("yunits",e.yunits)})),scale:$u(zb)});var fb=nl(t_,["color","scale"]),db=nl(t_,{color:$u(nb),scale:$u(zb)});var gb=nl(t_,["color","width"]),yb=nl(t_,{color:$u(nb),width:$u(km)});var mb={Point:"Point",LineString:"LineString",LinearRing:"LinearRing",Polygon:"Polygon",MultiPoint:"MultiGeometry",MultiLineString:"MultiGeometry",MultiPolygon:"MultiGeometry",GeometryCollection:"MultiGeometry"},vb=function(t,e,r){if(t)return Yu(e[e.length-1].node.namespaceURI,mb[t.getType()])},_b=tl("Point"),bb=tl("LineString"),xb=tl("LinearRing"),wb=tl("Polygon"),Sb=nl(t_,{LineString:$u(Fb),Point:$u(Fb),Polygon:$u(Gb),GeometryCollection:$u(Tb)});function Tb(t,e,r){var n,i={node:t},o=e.getType(),a=[];o===yt.GEOMETRY_COLLECTION?(e.getGeometriesArrayRecursive().forEach((function(t){var e=t.getType();e===yt.MULTI_POINT?a=a.concat(t.getPoints()):e===yt.MULTI_LINE_STRING?a=a.concat(t.getLineStrings()):e===yt.MULTI_POLYGON?a=a.concat(t.getPolygons()):e===yt.POINT||e===yt.LINE_STRING||e===yt.POLYGON?a.push(t):lt(!1,39)})),n=vb):o===yt.MULTI_POINT?(a=e.getPoints(),n=_b):o===yt.MULTI_LINE_STRING?(a=e.getLineStrings(),n=bb):o===yt.MULTI_POLYGON?(a=e.getPolygons(),n=wb):lt(!1,39),sl(i,Sb,n,a,r)}var Eb=nl(t_,{LinearRing:$u(Fb)});function Cb(t,e,r){sl({node:t},Eb,xb,[e],r)}var Pb=nl(t_,{ExtendedData:$u((function(t,e,r){for(var n={node:t},i=e.names,o=e.values,a=i.length,s=0;s<a;s++)sl(n,ib,sb,[{name:i[s],value:o[s]}],r)})),MultiGeometry:$u(Tb),LineString:$u(Fb),LinearRing:$u(Fb),Point:$u(Fb),Polygon:$u(Gb),Style:$u((function(t,e,r){var n={node:t},i={};if(e.pointStyles.length){var o=e.pointStyles[0].getText();o&&(i.LabelStyle=o);var a=e.pointStyles[0].getImage();a&&"function"==typeof a.getSrc&&(i.IconStyle=a)}if(e.lineStyles.length){(s=e.lineStyles[0].getStroke())&&(i.LineStyle=s)}if(e.polyStyles.length){var s;(s=e.polyStyles[0].getStroke())&&!i.LineStyle&&(i.LineStyle=s),i.PolyStyle=e.polyStyles[0]}var u=r[r.length-1].node,l=Ub[u.namespaceURI],h=rl(i,l);sl(n,Bb,el,h,r,l)})),address:$u(jm),description:$u(jm),name:$u(jm),open:$u(Am),phoneNumber:$u(jm),styleUrl:$u(jm),visibility:$u(Am)}),Rb=nl(t_,["name","open","visibility","address","phoneNumber","description","styleUrl","Style"]),Ob=tl("ExtendedData");function Ib(t,e,r){var n={node:t};e.getId()&&t.setAttribute("id",e.getId());var i=e.getProperties(),o={address:1,description:1,name:1,open:1,phoneNumber:1,styleUrl:1,visibility:1};o[e.getGeometryName()]=1;var a=Object.keys(i||{}).sort().filter((function(t){return!o[t]})),s=e.getStyleFunction();if(s){var u=s(e,0);if(u){var l=Array.isArray(u)?u:[u],h=l;if(e.getGeometry()&&(h=l.filter((function(t){var r=t.getGeometryFunction()(e);if(r){var n=r.getType();return n===yt.GEOMETRY_COLLECTION?r.getGeometriesArrayRecursive().filter((function(t){var e=t.getType();return e===yt.POINT||e===yt.MULTI_POINT})).length:n===yt.POINT||n===yt.MULTI_POINT}}))),this.writeStyles_){var c=l,p=l;e.getGeometry()&&(c=l.filter((function(t){var r=t.getGeometryFunction()(e);if(r){var n=r.getType();return n===yt.GEOMETRY_COLLECTION?r.getGeometriesArrayRecursive().filter((function(t){var e=t.getType();return e===yt.LINE_STRING||e===yt.MULTI_LINE_STRING})).length:n===yt.LINE_STRING||n===yt.MULTI_LINE_STRING}})),p=l.filter((function(t){var r=t.getGeometryFunction()(e);if(r){var n=r.getType();return n===yt.GEOMETRY_COLLECTION?r.getGeometriesArrayRecursive().filter((function(t){var e=t.getType();return e===yt.POLYGON||e===yt.MULTI_POLYGON})).length:n===yt.POLYGON||n===yt.MULTI_POLYGON}}))),i.Style={pointStyles:h,lineStyles:c,polyStyles:p}}if(h.length&&void 0===i.name){var f=h[0].getText();f&&(i.name=f.getText())}}}var d=r[r.length-1].node,g=Rb[d.namespaceURI],y=rl(i,g);if(sl(n,Pb,el,y,r,g),a.length>0){var m=rl(i,a);sl(n,Pb,Ob,[{names:a,values:m}],r)}var v=r[0],_=e.getGeometry();_&&(_=Ud(_,!0,v)),sl(n,Pb,vb,[_],r)}var Lb=nl(t_,["extrude","tessellate","altitudeMode","coordinates"]),Mb=nl(t_,{extrude:$u(Am),tessellate:$u(Am),altitudeMode:$u(jm),coordinates:$u((function(t,e,r){var n,i=r[r.length-1],o=i.layout,a=i.stride;o==pt||o==dt?n=2:o==ft||o==gt?n=3:lt(!1,34);var s=e.length,u="";if(s>0){u+=e[0];for(var l=1;l<n;++l)u+=","+e[l];for(var h=a;h<s;h+=a){u+=" "+e[h];for(l=1;l<n;++l)u+=","+e[h+l]}}jm(t,u)}))});function Fb(t,e,r){var n=e.getFlatCoordinates(),i={node:t};i.layout=e.getLayout(),i.stride=e.getStride();var o=e.getProperties();o.coordinates=n;var a=r[r.length-1].node,s=Lb[a.namespaceURI],u=rl(o,s);sl(i,Mb,el,u,r,s)}var Ab=nl(t_,["color","fill","outline"]),kb=nl(t_,{outerBoundaryIs:$u(Cb),innerBoundaryIs:$u(Cb)}),Nb=tl("innerBoundaryIs"),jb=tl("outerBoundaryIs");function Gb(t,e,r){var n=e.getLinearRings(),i=n.shift(),o={node:t};sl(o,kb,Nb,n,r),sl(o,kb,jb,[i],r)}var Db=nl(t_,{color:$u(nb),fill:$u(Am),outline:$u(Am)});function zb(t,e){km(t,Math.round(1e6*e)/1e6)}var Ub=nl(t_,["IconStyle","LabelStyle","LineStyle","PolyStyle"]),Bb=nl(t_,{IconStyle:$u((function(t,e,r){var n={node:t},i={},o=e.getSrc(),a=e.getSize(),s=e.getImageSize(),u={href:o};if(a){u.w=a[0],u.h=a[1];var l=e.getAnchor(),h=e.getOrigin();if(h&&s&&0!==h[0]&&h[1]!==a[1]&&(u.x=h[0],u.y=s[1]-(h[1]+a[1])),l&&(l[0]!==a[0]/2||l[1]!==a[1]/2)){var c={x:l[0],xunits:Bl,y:a[1]-l[1],yunits:Bl};i.hotSpot=c}}i.Icon=u;var p=e.getScale();1!==p&&(i.scale=p);var f=e.getRotation();0!==f&&(i.heading=f);var d=e.getColor();d&&(i.color=d);var g=r[r.length-1].node,y=cb[g.namespaceURI],m=rl(i,y);sl(n,pb,el,m,r,y)})),LabelStyle:$u((function(t,e,r){var n={node:t},i={},o=e.getFill();o&&(i.color=o.getColor());var a=e.getScale();a&&1!==a&&(i.scale=a);var s=r[r.length-1].node,u=fb[s.namespaceURI],l=rl(i,u);sl(n,db,el,l,r,u)})),LineStyle:$u((function(t,e,r){var n={node:t},i={color:e.getColor(),width:Number(e.getWidth())||1},o=r[r.length-1].node,a=gb[o.namespaceURI],s=rl(i,a);sl(n,yb,el,s,r,a)})),PolyStyle:$u((function(t,e,r){var n={node:t},i=e.getFill(),o=e.getStroke(),a={color:i?i.getColor():void 0,fill:!!i&&void 0,outline:!!o&&void 0},s=r[r.length-1].node,u=Ab[s.namespaceURI],l=rl(a,u);sl(n,Db,el,l,r,u)}))});var Yb=m_,Vb=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Wb=[null],qb=nl(Wb,{nd:function(t,e){e[e.length-1].ndrefs.push(t.getAttribute("ref"))},tag:Hb}),Xb=nl(Wb,{node:function(t,e){var r=e[0],n=e[e.length-1],i=t.getAttribute("id"),o=[parseFloat(t.getAttribute("lon")),parseFloat(t.getAttribute("lat"))];n.nodes[i]=o;var a=ol({tags:{}},Kb,t,e);if(!P(a.tags)){var s=new gn(o);Ud(s,!1,r);var u=new ct(s);u.setId(i),u.setProperties(a.tags,!0),n.features.push(u)}},way:function(t,e){var r=ol({id:t.getAttribute("id"),ndrefs:[],tags:{}},qb,t,e);e[e.length-1].ways.push(r)}}),Zb=function(t){function e(){var e=t.call(this)||this;return e.dataProjection=yr("EPSG:4326"),e}return Vb(e,t),e.prototype.readFeaturesFromNode=function(t,e){var r=this.getReadOptions(t,e);if("osm"==t.localName){for(var n=ol({nodes:{},ways:[],features:[]},Xb,t,[r]),i=0;i<n.ways.length;i++){for(var o=n.ways[i],a=[],s=0,u=o.ndrefs.length;s<u;s++){m(a,n.nodes[o.ndrefs[s]])}var l=void 0;Ud(l=o.ndrefs[0]==o.ndrefs[o.ndrefs.length-1]?new Ln(a,pt,[a.length]):new Cd(a,pt),!1,r);var h=new ct(l);h.setId(o.id),h.setProperties(o.tags,!0),n.features.push(h)}if(n.features)return n.features}return[]},e}(bm),Kb=nl(Wb,{tag:Hb});function Hb(t,e){e[e.length-1].tags[t.getAttribute("k")]=t.getAttribute("v")}var Jb=Zb;function $b(t,e,r,n,i,o){var a,s;void 0!==i?(a=i,s=void 0!==o?o:0):(a=[],s=0);for(var u=e;u<r;){var l=t[u++];a[s++]=t[u++],a[s++]=l;for(var h=2;h<n;++h)a[s++]=t[u++]}return a.length=s,a}var Qb=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();function tx(t,e,r){var n,i=r||1e5,o=new Array(e);for(n=0;n<e;++n)o[n]=0;for(var a=0,s=t.length;a<s;)for(n=0;n<e;++n,++a){var u=t[a],l=u-o[n];o[n]=u,t[a]=l}return rx(t,i)}function ex(t,e,r){var n,i=r||1e5,o=new Array(e);for(n=0;n<e;++n)o[n]=0;for(var a=nx(t,i),s=0,u=a.length;s<u;)for(n=0;n<e;++n,++s)o[n]+=a[s],a[s]=o[n];return a}function rx(t,e){for(var r=e||1e5,n=0,i=t.length;n<i;++n)t[n]=Math.round(t[n]*r);return function(t){for(var e=0,r=t.length;e<r;++e){var n=t[e];t[e]=n<0?~(n<<1):n<<1}return function(t){for(var e="",r=0,n=t.length;r<n;++r)e+=ix(t[r]);return e}(t)}(t)}function nx(t,e){for(var r=e||1e5,n=function(t){for(var e=function(t){for(var e=[],r=0,n=0,i=0,o=t.length;i<o;++i){var a=t.charCodeAt(i)-63;r|=(31&a)<<n,a<32?(e.push(r),r=0,n=0):n+=5}return e}(t),r=0,n=e.length;r<n;++r){var i=e[r];e[r]=1&i?~(i>>1):i>>1}return e}(t),i=0,o=n.length;i<o;++i)n[i]/=r;return n}function ix(t){for(var e,r="";t>=32;)e=63+(32|31&t),r+=String.fromCharCode(e),t>>=5;return e=t+63,r+=String.fromCharCode(e)}var ox=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.dataProjection=yr("EPSG:4326"),r.factor_=n.factor?n.factor:1e5,r.geometryLayout_=n.geometryLayout?n.geometryLayout:pt,r}return Qb(e,t),e.prototype.readFeatureFromText=function(t,e){var r=this.readGeometryFromText(t,e);return new ct(r)},e.prototype.readFeaturesFromText=function(t,e){return[this.readFeatureFromText(t,e)]},e.prototype.readGeometryFromText=function(t,e){var r=Wr(this.geometryLayout_),n=ex(t,r,this.factor_);$b(n,0,n.length,r,n);var i=sn(n,0,n.length,r);return Ud(new Cd(i,this.geometryLayout_),!1,this.adaptOptions(e))},e.prototype.writeFeatureText=function(t,e){var r=t.getGeometry();return r?this.writeGeometryText(r,e):(lt(!1,40),"")},e.prototype.writeFeaturesText=function(t,e){return this.writeFeatureText(t[0],e)},e.prototype.writeGeometryText=function(t,e){var r=(t=Ud(t,!0,this.adaptOptions(e))).getFlatCoordinates(),n=t.getStride();return $b(r,0,r.length,n,r),tx(r,n,this.factor_)},e}(Bv),ax=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),sx=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.layerName_=n.layerName,r.layers_=n.layers?n.layers:null,r.dataProjection=yr(n.dataProjection?n.dataProjection:"EPSG:4326"),r}return ax(e,t),e.prototype.readFeaturesFromObject=function(t,e){if("Topology"==t.type){var r=t,n=void 0,i=null,o=null;r.transform&&(i=(n=r.transform).scale,o=n.translate);var a=r.arcs;n&&function(t,e,r){for(var n=0,i=t.length;n<i;++n)px(t[n],e,r)}(a,i,o);var s=[],u=r.objects,l=this.layerName_,h=void 0;for(var c in u)this.layers_&&-1==this.layers_.indexOf(c)||("GeometryCollection"===u[c].type?(h=u[c],s.push.apply(s,hx(h,a,i,o,l,c,e))):(h=u[c],s.push(cx(h,a,i,o,l,c,e))));return s}return[]},e.prototype.readProjectionFromObject=function(t){return this.dataProjection},e}(Wg),ux={Point:function(t,e,r){var n=t.coordinates;e&&r&&fx(n,e,r);return new gn(n)},LineString:function(t,e){var r=lx(t.arcs,e);return new Cd(r)},Polygon:function(t,e){for(var r=[],n=0,i=t.arcs.length;n<i;++n)r[n]=lx(t.arcs[n],e);return new Ln(r)},MultiPoint:function(t,e,r){var n=t.coordinates;if(e&&r)for(var i=0,o=n.length;i<o;++i)fx(n[i],e,r);return new qd(n)},MultiLineString:function(t,e){for(var r=[],n=0,i=t.arcs.length;n<i;++n)r[n]=lx(t.arcs[n],e);return new Vd(r)},MultiPolygon:function(t,e){for(var r=[],n=0,i=t.arcs.length;n<i;++n){for(var o=t.arcs[n],a=[],s=0,u=o.length;s<u;++s)a[s]=lx(o[s],e);r[n]=a}return new Kd(r)}};function lx(t,e){for(var r,n,i=[],o=0,a=t.length;o<a;++o)r=t[o],o>0&&i.pop(),n=r>=0?e[r]:e[~r].slice().reverse(),i.push.apply(i,n);for(var s=0,u=i.length;s<u;++s)i[s]=i[s].slice();return i}function hx(t,e,r,n,i,o,a){for(var s=t.geometries,u=[],l=0,h=s.length;l<h;++l)u[l]=cx(s[l],e,r,n,i,o,a);return u}function cx(t,e,r,n,i,o,a){var s,u=t.type,l=ux[u];s="Point"===u||"MultiPoint"===u?l(t,r,n):l(t,e);var h=new ct;h.setGeometry(Ud(s,!1,a)),void 0!==t.id&&h.setId(t.id);var c=t.properties;return i&&(c||(c={}),c[i]=o),c&&h.setProperties(c,!0),h}function px(t,e,r){for(var n=0,i=0,o=0,a=t.length;o<a;++o){var s=t[o];n+=s[0],i+=s[1],s[0]=n,s[1]=i,fx(s,e,r)}}function fx(t,e,r){t[0]=t[0]*e[0]+r[0],t[1]=t[1]*e[1]+r[1]}var dx=sx,gx=function(){function t(t){this.tagName_=t}return t.prototype.getTagName=function(){return this.tagName_},t}(),yx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),mx=function(t){function e(e,r){var n=t.call(this,e)||this;return n.conditions=r,lt(n.conditions.length>=2,57),n}return yx(e,t),e}(gx),vx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),_x=function(t){function e(e){return t.call(this,"And",Array.prototype.slice.call(arguments))||this}return vx(e,t),e}(mx),bx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),xx=function(t){function e(e,r,n){var i=t.call(this,"BBOX")||this;if(i.geometryName=e,i.extent=r,4!==r.length)throw new Error("Expected an extent with four values ([minX, minY, maxX, maxY])");return i.srsName=n,i}return bx(e,t),e}(gx),wx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Sx=function(t){function e(e,r,n,i){var o=t.call(this,e)||this;return o.geometryName=r||"the_geom",o.geometry=n,o.srsName=i,o}return wx(e,t),e}(gx),Tx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ex=function(t){function e(e,r,n){return t.call(this,"Contains",e,r,n)||this}return Tx(e,t),e}(Sx),Cx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Px=function(t){function e(e,r){var n=t.call(this,e)||this;return n.propertyName=r,n}return Cx(e,t),e}(gx),Rx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ox=function(t){function e(e,r,n){var i=t.call(this,"During",e)||this;return i.begin=r,i.end=n,i}return Rx(e,t),e}(Px),Ix=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Lx=function(t){function e(e,r,n,i){var o=t.call(this,e,r)||this;return o.expression=n,o.matchCase=i,o}return Ix(e,t),e}(Px),Mx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Fx=function(t){function e(e,r,n){return t.call(this,"PropertyIsEqualTo",e,r,n)||this}return Mx(e,t),e}(Lx),Ax=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),kx=function(t){function e(e,r){return t.call(this,"PropertyIsGreaterThan",e,r)||this}return Ax(e,t),e}(Lx),Nx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),jx=function(t){function e(e,r){return t.call(this,"PropertyIsGreaterThanOrEqualTo",e,r)||this}return Nx(e,t),e}(Lx),Gx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Dx=function(t){function e(e,r,n){return t.call(this,"Intersects",e,r,n)||this}return Gx(e,t),e}(Sx),zx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ux=function(t){function e(e,r,n){var i=t.call(this,"PropertyIsBetween",e)||this;return i.lowerBoundary=r,i.upperBoundary=n,i}return zx(e,t),e}(Px),Bx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Yx=function(t){function e(e,r,n,i,o,a){var s=t.call(this,"PropertyIsLike",e)||this;return s.pattern=r,s.wildCard=void 0!==n?n:"*",s.singleChar=void 0!==i?i:".",s.escapeChar=void 0!==o?o:"!",s.matchCase=a,s}return Bx(e,t),e}(Px),Vx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Wx=function(t){function e(e){return t.call(this,"PropertyIsNull",e)||this}return Vx(e,t),e}(Px),qx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Xx=function(t){function e(e,r){return t.call(this,"PropertyIsLessThan",e,r)||this}return qx(e,t),e}(Lx),Zx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Kx=function(t){function e(e,r){return t.call(this,"PropertyIsLessThanOrEqualTo",e,r)||this}return Zx(e,t),e}(Lx),Hx=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Jx=function(t){function e(e){var r=t.call(this,"Not")||this;return r.condition=e,r}return Hx(e,t),e}(gx),$x=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Qx=function(t){function e(e,r,n){return t.call(this,"PropertyIsNotEqualTo",e,r,n)||this}return $x(e,t),e}(Lx),tw=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ew=function(t){function e(e){return t.call(this,"Or",Array.prototype.slice.call(arguments))||this}return tw(e,t),e}(mx),rw=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),nw=function(t){function e(e,r,n){return t.call(this,"Within",e,r,n)||this}return rw(e,t),e}(Sx);function iw(t){var e=[null].concat(Array.prototype.slice.call(arguments));return new(Function.prototype.bind.apply(_x,e))}function ow(t,e,r){return new xx(t,e,r)}var aw=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),sw={"http://www.opengis.net/gml":{boundedBy:Ju(Em.prototype.readGeometryElement,"bounds")}},uw={"http://www.opengis.net/wfs":{totalInserted:Ju(Lm),totalUpdated:Ju(Lm),totalDeleted:Ju(Lm)}},lw={"http://www.opengis.net/wfs":{TransactionSummary:Ju((function(t,e){return ol({},uw,t,e)}),"transactionSummary"),InsertResults:Ju((function(t,e){return ol([],vw,t,e)}),"insertIds")}},hw={"http://www.opengis.net/wfs":{PropertyName:$u(jm)}},cw={"http://www.opengis.net/wfs":{Insert:$u((function(t,e,r){var n=r[r.length-1],i=n.featureType,o=n.featureNS,a=n.gmlVersion,s=Yu(o,i);t.appendChild(s),2===a?Xm.prototype.writeFeatureElement(s,e,r):Um.prototype.writeFeatureElement(s,e,r)})),Update:$u((function(t,e,r){var n=r[r.length-1];lt(void 0!==e.getId(),27);var i=n.featureType,o=n.featurePrefix,a=n.featureNS,s=bw(o,i),u=e.getGeometryName();t.setAttribute("typeName",s),t.setAttributeNS(pw,"xmlns:"+o,a);var l=e.getId();if(void 0!==l){for(var h=e.getKeys(),c=[],p=0,f=h.length;p<f;p++){var d=e.get(h[p]);if(void 0!==d){var g=h[p];d&&"function"==typeof d.getSimplifiedGeometry&&(g=u),c.push({name:g,value:d})}}sl({gmlVersion:n.gmlVersion,node:t,hasZ:n.hasZ,srsName:n.srsName},cw,tl("Property"),c,r),_w(t,l,r)}})),Delete:$u((function(t,e,r){var n=r[r.length-1];lt(void 0!==e.getId(),26);var i=n.featureType,o=n.featurePrefix,a=n.featureNS,s=bw(o,i);t.setAttribute("typeName",s),t.setAttributeNS(pw,"xmlns:"+o,a);var u=e.getId();void 0!==u&&_w(t,u,r)})),Property:$u((function(t,e,r){var n=Yu(dw,"Name"),i=r[r.length-1].gmlVersion;if(t.appendChild(n),jm(n,e.name),void 0!==e.value&&null!==e.value){var o=Yu(dw,"Value");t.appendChild(o),e.value&&"function"==typeof e.value.getSimplifiedGeometry?2===i?Xm.prototype.writeGeometryElement(o,e.value,r):Um.prototype.writeGeometryElement(o,e.value,r):jm(o,e.value)}})),Native:$u((function(t,e,r){e.vendorId&&t.setAttribute("vendorId",e.vendorId);void 0!==e.safeToIgnore&&t.setAttribute("safeToIgnore",String(e.safeToIgnore));void 0!==e.value&&jm(t,e.value)}))}},pw="http://www.w3.org/2000/xmlns/",fw="http://www.opengis.net/ogc",dw="http://www.opengis.net/wfs",gw={"1.1.0":"http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.1.0/wfs.xsd","1.0.0":"http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.0.0/wfs.xsd"},yw=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.featureType_=n.featureType,r.featureNS_=n.featureNS,r.gmlFormat_=n.gmlFormat?n.gmlFormat:new Um,r.schemaLocation_=n.schemaLocation?n.schemaLocation:gw["1.1.0"],r}return aw(e,t),e.prototype.getFeatureType=function(){return this.featureType_},e.prototype.setFeatureType=function(t){this.featureType_=t},e.prototype.readFeaturesFromNode=function(t,e){var r={node:t};T(r,{featureType:this.featureType_,featureNS:this.featureNS_}),T(r,this.getReadOptions(t,e||{}));var n=[r];this.gmlFormat_.FEATURE_COLLECTION_PARSERS[wm].featureMember=Zu(Em.prototype.readFeaturesInternal);var i=ol([],this.gmlFormat_.FEATURE_COLLECTION_PARSERS,t,n,this.gmlFormat_);return i||(i=[]),i},e.prototype.readTransactionResponse=function(t){if(t){if("string"==typeof t){var e=qu(t);return this.readTransactionResponseFromDocument(e)}return Wu(t)?this.readTransactionResponseFromDocument(t):this.readTransactionResponseFromNode(t)}},e.prototype.readFeatureCollectionMetadata=function(t){if(t){if("string"==typeof t){var e=qu(t);return this.readFeatureCollectionMetadataFromDocument(e)}return Wu(t)?this.readFeatureCollectionMetadataFromDocument(t):this.readFeatureCollectionMetadataFromNode(t)}},e.prototype.readFeatureCollectionMetadataFromDocument=function(t){for(var e=t.firstChild;e;e=e.nextSibling)if(e.nodeType==Node.ELEMENT_NODE)return this.readFeatureCollectionMetadataFromNode(e)},e.prototype.readFeatureCollectionMetadataFromNode=function(t){var e={},r=Mm(t.getAttribute("numberOfFeatures"));return e.numberOfFeatures=r,ol(e,sw,t,[],this.gmlFormat_)},e.prototype.readTransactionResponseFromDocument=function(t){for(var e=t.firstChild;e;e=e.nextSibling)if(e.nodeType==Node.ELEMENT_NODE)return this.readTransactionResponseFromNode(e)},e.prototype.readTransactionResponseFromNode=function(t){return ol({},lw,t,[])},e.prototype.writeGetFeature=function(t){var e,r=Yu(dw,"GetFeature");if(r.setAttribute("service","WFS"),r.setAttribute("version","1.1.0"),t&&(t.handle&&r.setAttribute("handle",t.handle),t.outputFormat&&r.setAttribute("outputFormat",t.outputFormat),void 0!==t.maxFeatures&&r.setAttribute("maxFeatures",String(t.maxFeatures)),t.resultType&&r.setAttribute("resultType",t.resultType),void 0!==t.startIndex&&r.setAttribute("startIndex",String(t.startIndex)),void 0!==t.count&&r.setAttribute("count",String(t.count)),void 0!==t.viewParams&&r.setAttribute("viewParams",t.viewParams),e=t.filter,t.bbox)){lt(t.geometryName,12);var n=ow(t.geometryName,t.bbox,t.srsName);e=e?iw(e,n):n}r.setAttributeNS(Bu,"xsi:schemaLocation",this.schemaLocation_);var i={node:r};return T(i,{srsName:t.srsName,featureNS:t.featureNS?t.featureNS:this.featureNS_,featurePrefix:t.featurePrefix,geometryName:t.geometryName,filter:e,propertyNames:t.propertyNames?t.propertyNames:[]}),lt(Array.isArray(t.featureTypes),11),function(t,e,r){var n=r[r.length-1],i=T({},n);i.node=t,sl(i,xw,tl("Query"),e,r)}(r,t.featureTypes,[i]),r},e.prototype.writeTransaction=function(t,e,r,n){var i,o,a=[],s=Yu(dw,"Transaction"),u=n.version?n.version:"1.1.0",l="1.0.0"===u?2:3;s.setAttribute("service","WFS"),s.setAttribute("version",u),n&&(i=n.gmlOptions?n.gmlOptions:{},n.handle&&s.setAttribute("handle",n.handle));var h=gw[u];s.setAttributeNS(Bu,"xsi:schemaLocation",h);var c=n.featurePrefix?n.featurePrefix:"feature";return t&&(o=T({node:s},{featureNS:n.featureNS,featureType:n.featureType,featurePrefix:c,gmlVersion:l,hasZ:n.hasZ,srsName:n.srsName}),T(o,i),sl(o,cw,tl("Insert"),t,a)),e&&(o=T({node:s},{featureNS:n.featureNS,featureType:n.featureType,featurePrefix:c,gmlVersion:l,hasZ:n.hasZ,srsName:n.srsName}),T(o,i),sl(o,cw,tl("Update"),e,a)),r&&sl({node:s,featureNS:n.featureNS,featureType:n.featureType,featurePrefix:c,gmlVersion:l,srsName:n.srsName},cw,tl("Delete"),r,a),n.nativeElements&&sl({node:s,featureNS:n.featureNS,featureType:n.featureType,featurePrefix:c,gmlVersion:l,srsName:n.srsName},cw,tl("Native"),n.nativeElements,a),s},e.prototype.readProjectionFromDocument=function(t){for(var e=t.firstChild;e;e=e.nextSibling)if(e.nodeType==Node.ELEMENT_NODE)return this.readProjectionFromNode(e);return null},e.prototype.readProjectionFromNode=function(t){if(t.firstElementChild&&t.firstElementChild.firstElementChild)for(var e=(t=t.firstElementChild.firstElementChild).firstElementChild;e;e=e.nextElementSibling)if(0!==e.childNodes.length&&(1!==e.childNodes.length||3!==e.firstChild.nodeType)){var r=[{}];return this.gmlFormat_.readGeometryElement(e,r),yr(r.pop().srsName)}return null},e}(bm);var mw={"http://www.opengis.net/ogc":{FeatureId:Zu((function(t,e){return t.getAttribute("fid")}))}};var vw={"http://www.opengis.net/wfs":{Feature:function(t,e){il(mw,t,e)}}};function _w(t,e,r){var n=Yu(fw,"Filter"),i=Yu(fw,"FeatureId");n.appendChild(i),i.setAttribute("fid",e),t.appendChild(n)}function bw(t,e){var r=(t=t||"feature")+":";return 0===e.indexOf(r)?e:r+e}var xw={"http://www.opengis.net/wfs":{Query:$u((function(t,e,r){var n,i=r[r.length-1],o=i.featurePrefix,a=i.featureNS,s=i.propertyNames,u=i.srsName;n=o?bw(o,e):e;t.setAttribute("typeName",n),u&&t.setAttribute("srsName",u);a&&t.setAttributeNS(pw,"xmlns:"+o,a);var l=T({},i);l.node=t,sl(l,hw,tl("PropertyName"),s,r);var h=i.filter;if(h){var c=Yu(fw,"Filter");t.appendChild(c),ww(c,h,r)}}))},"http://www.opengis.net/ogc":{During:$u((function(t,e,r){var n=Yu("http://www.opengis.net/fes","ValueReference");jm(n,e.propertyName),t.appendChild(n);var i=Yu(wm,"TimePeriod");t.appendChild(i);var o=Yu(wm,"begin");i.appendChild(o),Rw(o,e.begin);var a=Yu(wm,"end");i.appendChild(a),Rw(a,e.end)})),And:$u(Sw),Or:$u(Sw),Not:$u((function(t,e,r){var n={node:t},i=e.condition;sl(n,xw,tl(i.getTagName()),[i],r)})),BBOX:$u((function(t,e,r){r[r.length-1].srsName=e.srsName,Cw(t,e.geometryName),Um.prototype.writeGeometryElement(t,e.extent,r)})),Contains:$u((function(t,e,r){r[r.length-1].srsName=e.srsName,Cw(t,e.geometryName),Um.prototype.writeGeometryElement(t,e.geometry,r)})),Intersects:$u((function(t,e,r){r[r.length-1].srsName=e.srsName,Cw(t,e.geometryName),Um.prototype.writeGeometryElement(t,e.geometry,r)})),Within:$u((function(t,e,r){r[r.length-1].srsName=e.srsName,Cw(t,e.geometryName),Um.prototype.writeGeometryElement(t,e.geometry,r)})),PropertyIsEqualTo:$u(Tw),PropertyIsNotEqualTo:$u(Tw),PropertyIsLessThan:$u(Tw),PropertyIsLessThanOrEqualTo:$u(Tw),PropertyIsGreaterThan:$u(Tw),PropertyIsGreaterThanOrEqualTo:$u(Tw),PropertyIsNull:$u((function(t,e,r){Cw(t,e.propertyName)})),PropertyIsBetween:$u((function(t,e,r){Cw(t,e.propertyName);var n=Yu(fw,"LowerBoundary");t.appendChild(n),Pw(n,""+e.lowerBoundary);var i=Yu(fw,"UpperBoundary");t.appendChild(i),Pw(i,""+e.upperBoundary)})),PropertyIsLike:$u((function(t,e,r){t.setAttribute("wildCard",e.wildCard),t.setAttribute("singleChar",e.singleChar),t.setAttribute("escapeChar",e.escapeChar),void 0!==e.matchCase&&t.setAttribute("matchCase",e.matchCase.toString());Cw(t,e.propertyName),Pw(t,""+e.pattern)}))}};function ww(t,e,r){sl({node:t},xw,tl(e.getTagName()),[e],r)}function Sw(t,e,r){for(var n={node:t},i=e.conditions,o=0,a=i.length;o<a;++o){var s=i[o];sl(n,xw,tl(s.getTagName()),[s],r)}}function Tw(t,e,r){void 0!==e.matchCase&&t.setAttribute("matchCase",e.matchCase.toString()),Cw(t,e.propertyName),Pw(t,""+e.expression)}function Ew(t,e,r){var n=Yu(fw,t);jm(n,r),e.appendChild(n)}function Cw(t,e){Ew("PropertyName",t,e)}function Pw(t,e){Ew("Literal",t,e)}function Rw(t,e){var r=Yu(wm,"TimeInstant");t.appendChild(r);var n=Yu(wm,"timePosition");r.appendChild(n),jm(n,e)}var Ow=yw,Iw=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Lw={POINT:gn,LINESTRING:Cd,POLYGON:Ln,MULTIPOINT:qd,MULTILINESTRING:Vd,MULTIPOLYGON:Kd},Mw=1,Fw=2,Aw=3,kw=4,Nw=5,jw=6,Gw={};for(var Dw in yt)Gw[Dw]=yt[Dw].toUpperCase();var zw=function(){function t(t){this.wkt=t,this.index_=-1}return t.prototype.isAlpha_=function(t){return t>="a"&&t<="z"||t>="A"&&t<="Z"},t.prototype.isNumeric_=function(t,e){return t>="0"&&t<="9"||"."==t&&!(void 0!==e&&e)},t.prototype.isWhiteSpace_=function(t){return" "==t||"\t"==t||"\r"==t||"\n"==t},t.prototype.nextChar_=function(){return this.wkt.charAt(++this.index_)},t.prototype.nextToken=function(){var t,e=this.nextChar_(),r=this.index_,n=e;if("("==e)t=Fw;else if(","==e)t=Nw;else if(")"==e)t=Aw;else if(this.isNumeric_(e)||"-"==e)t=kw,n=this.readNumber_();else if(this.isAlpha_(e))t=Mw,n=this.readText_();else{if(this.isWhiteSpace_(e))return this.nextToken();if(""!==e)throw new Error("Unexpected character: "+e);t=jw}return{position:r,value:n,type:t}},t.prototype.readNumber_=function(){var t,e=this.index_,r=!1,n=!1;do{"."==t?r=!0:"e"!=t&&"E"!=t||(n=!0),t=this.nextChar_()}while(this.isNumeric_(t,r)||!n&&("e"==t||"E"==t)||n&&("-"==t||"+"==t));return parseFloat(this.wkt.substring(e,this.index_--))},t.prototype.readText_=function(){var t,e=this.index_;do{t=this.nextChar_()}while(this.isAlpha_(t));return this.wkt.substring(e,this.index_--).toUpperCase()},t}(),Uw=function(){function t(t){this.lexer_=t,this.token_,this.layout_=pt}return t.prototype.consume_=function(){this.token_=this.lexer_.nextToken()},t.prototype.isTokenType=function(t){return this.token_.type==t},t.prototype.match=function(t){var e=this.isTokenType(t);return e&&this.consume_(),e},t.prototype.parse=function(){return this.consume_(),this.parseGeometry_()},t.prototype.parseGeometryLayout_=function(){var t=pt,e=this.token_;if(this.isTokenType(Mw)){var r=e.value;"Z"===r?t=ft:"M"===r?t=dt:"ZM"===r&&(t=gt),t!==pt&&this.consume_()}return t},t.prototype.parseGeometryCollectionText_=function(){if(this.match(Fw)){var t=[];do{t.push(this.parseGeometry_())}while(this.match(Nw));if(this.match(Aw))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())},t.prototype.parsePointText_=function(){if(this.match(Fw)){var t=this.parsePoint_();if(this.match(Aw))return t}else if(this.isEmptyGeometry_())return null;throw new Error(this.formatErrorMessage_())},t.prototype.parseLineStringText_=function(){if(this.match(Fw)){var t=this.parsePointList_();if(this.match(Aw))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())},t.prototype.parsePolygonText_=function(){if(this.match(Fw)){var t=this.parseLineStringTextList_();if(this.match(Aw))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())},t.prototype.parseMultiPointText_=function(){if(this.match(Fw)){var t=void 0;if(t=this.token_.type==Fw?this.parsePointTextList_():this.parsePointList_(),this.match(Aw))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())},t.prototype.parseMultiLineStringText_=function(){if(this.match(Fw)){var t=this.parseLineStringTextList_();if(this.match(Aw))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())},t.prototype.parseMultiPolygonText_=function(){if(this.match(Fw)){var t=this.parsePolygonTextList_();if(this.match(Aw))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())},t.prototype.parsePoint_=function(){for(var t=[],e=this.layout_.length,r=0;r<e;++r){var n=this.token_;if(!this.match(kw))break;t.push(n.value)}if(t.length==e)return t;throw new Error(this.formatErrorMessage_())},t.prototype.parsePointList_=function(){for(var t=[this.parsePoint_()];this.match(Nw);)t.push(this.parsePoint_());return t},t.prototype.parsePointTextList_=function(){for(var t=[this.parsePointText_()];this.match(Nw);)t.push(this.parsePointText_());return t},t.prototype.parseLineStringTextList_=function(){for(var t=[this.parseLineStringText_()];this.match(Nw);)t.push(this.parseLineStringText_());return t},t.prototype.parsePolygonTextList_=function(){for(var t=[this.parsePolygonText_()];this.match(Nw);)t.push(this.parsePolygonText_());return t},t.prototype.isEmptyGeometry_=function(){var t=this.isTokenType(Mw)&&"EMPTY"==this.token_.value;return t&&this.consume_(),t},t.prototype.formatErrorMessage_=function(){return"Unexpected `"+this.token_.value+"` at position "+this.token_.position+" in `"+this.lexer_.wkt+"`"},t.prototype.parseGeometry_=function(){var t=this.token_;if(this.match(Mw)){var e=t.value;if(this.layout_=this.parseGeometryLayout_(),"GEOMETRYCOLLECTION"==e){var r=this.parseGeometryCollectionText_();return new Bg(r)}var n=Lw[e];if(!n)throw new Error("Invalid geometry type: "+e);var i=void 0;switch(e){case"POINT":i=this.parsePointText_();break;case"LINESTRING":i=this.parseLineStringText_();break;case"POLYGON":i=this.parsePolygonText_();break;case"MULTIPOINT":i=this.parseMultiPointText_();break;case"MULTILINESTRING":i=this.parseMultiLineStringText_();break;case"MULTIPOLYGON":i=this.parseMultiPolygonText_();break;default:throw new Error("Invalid geometry type: "+e)}return i||(i=n===Lw.POINT?[NaN,NaN]:[]),new n(i,this.layout_)}throw new Error(this.formatErrorMessage_())},t}(),Bw=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.splitCollection_=void 0!==n.splitCollection&&n.splitCollection,r}return Iw(e,t),e.prototype.parse_=function(t){var e=new zw(t);return new Uw(e).parse()},e.prototype.readFeatureFromText=function(t,e){var r=this.readGeometryFromText(t,e);if(r){var n=new ct;return n.setGeometry(r),n}return null},e.prototype.readFeaturesFromText=function(t,e){for(var r=[],n=this.readGeometryFromText(t,e),i=[],o=0,a=(r=this.splitCollection_&&n.getType()==yt.GEOMETRY_COLLECTION?n.getGeometriesArray():[n]).length;o<a;++o){var s=new ct;s.setGeometry(r[o]),i.push(s)}return i},e.prototype.readGeometryFromText=function(t,e){var r=this.parse_(t);return r?Ud(r,!1,e):null},e.prototype.writeFeatureText=function(t,e){var r=t.getGeometry();return r?this.writeGeometryText(r,e):""},e.prototype.writeFeaturesText=function(t,e){if(1==t.length)return this.writeFeatureText(t[0],e);for(var r=[],n=0,i=t.length;n<i;++n)r.push(t[n].getGeometry());var o=new Bg(r);return this.writeGeometryText(o,e)},e.prototype.writeGeometryText=function(t,e){return Xw(Ud(t,!0,e))},e}(Bv);function Yw(t){var e=t.getCoordinates();return 0===e.length?"":e.join(" ")}function Vw(t){for(var e=t.getCoordinates(),r=[],n=0,i=e.length;n<i;++n)r.push(e[n].join(" "));return r.join(",")}function Ww(t){for(var e=[],r=t.getLinearRings(),n=0,i=r.length;n<i;++n)e.push("("+Vw(r[n])+")");return e.join(",")}var qw={Point:Yw,LineString:Vw,Polygon:Ww,MultiPoint:function(t){for(var e=[],r=t.getPoints(),n=0,i=r.length;n<i;++n)e.push("("+Yw(r[n])+")");return e.join(",")},MultiLineString:function(t){for(var e=[],r=t.getLineStrings(),n=0,i=r.length;n<i;++n)e.push("("+Vw(r[n])+")");return e.join(",")},MultiPolygon:function(t){for(var e=[],r=t.getPolygons(),n=0,i=r.length;n<i;++n)e.push("("+Ww(r[n])+")");return e.join(",")},GeometryCollection:function(t){for(var e=[],r=t.getGeometries(),n=0,i=r.length;n<i;++n)e.push(Xw(r[n]));return e.join(",")}};function Xw(t){var e=t.getType(),r=(0,qw[e])(t);if(e=e.toUpperCase(),"function"==typeof t.getFlatCoordinates){var n=function(t){var e=t.getLayout(),r="";return e!==ft&&e!==gt||(r+="Z"),e!==dt&&e!==gt||(r+="M"),r}(t);n.length>0&&(e+=" "+n)}return 0===r.length?e+" EMPTY":e+"("+r+")"}var Zw=Bw,Kw=function(){function t(){}return t.prototype.read=function(t){if(t){if("string"==typeof t){var e=qu(t);return this.readFromDocument(e)}return Wu(t)?this.readFromDocument(t):this.readFromNode(t)}return null},t.prototype.readFromDocument=function(t){for(var e=t.firstChild;e;e=e.nextSibling)if(e.nodeType==Node.ELEMENT_NODE)return this.readFromNode(e);return null},t.prototype.readFromNode=function(t){},t}();function Hw(t){return t.getAttributeNS("http://www.w3.org/1999/xlink","href")}var Jw=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),$w=[null,"http://www.opengis.net/wms"],Qw=nl($w,{Service:Ju((function(t,e){return ol({},rS,t,e)})),Capability:Ju((function(t,e){return ol({},tS,t,e)}))}),tS=nl($w,{Request:Ju((function(t,e){return ol({},hS,t,e)})),Exception:Ju((function(t,e){return ol([],aS,t,e)})),Layer:Ju((function(t,e){return ol({},sS,t,e)}))}),eS=function(t){function e(){var e=t.call(this)||this;return e.version=void 0,e}return Jw(e,t),e.prototype.readFromNode=function(t){this.version=t.getAttribute("version").trim();var e=ol({version:this.version},Qw,t,[]);return e||null},e}(Kw),rS=nl($w,{Name:Ju(Fm),Title:Ju(Fm),Abstract:Ju(Fm),KeywordList:Ju(bS),OnlineResource:Ju(Hw),ContactInformation:Ju((function(t,e){return ol({},nS,t,e)})),Fees:Ju(Fm),AccessConstraints:Ju(Fm),LayerLimit:Ju(Lm),MaxWidth:Ju(Lm),MaxHeight:Ju(Lm)}),nS=nl($w,{ContactPersonPrimary:Ju((function(t,e){return ol({},iS,t,e)})),ContactPosition:Ju(Fm),ContactAddress:Ju((function(t,e){return ol({},oS,t,e)})),ContactVoiceTelephone:Ju(Fm),ContactFacsimileTelephone:Ju(Fm),ContactElectronicMailAddress:Ju(Fm)}),iS=nl($w,{ContactPerson:Ju(Fm),ContactOrganization:Ju(Fm)}),oS=nl($w,{AddressType:Ju(Fm),Address:Ju(Fm),City:Ju(Fm),StateOrProvince:Ju(Fm),PostCode:Ju(Fm),Country:Ju(Fm)}),aS=nl($w,{Format:Zu(Fm)}),sS=nl($w,{Name:Ju(Fm),Title:Ju(Fm),Abstract:Ju(Fm),KeywordList:Ju(bS),CRS:Hu(Fm),EX_GeographicBoundingBox:Ju((function(t,e){var r=ol({},lS,t,e);if(!r)return;var n=r.westBoundLongitude,i=r.southBoundLatitude,o=r.eastBoundLongitude,a=r.northBoundLatitude;if(void 0===n||void 0===i||void 0===o||void 0===a)return;return[n,i,o,a]})),BoundingBox:Hu((function(t,e){var r=[Im(t.getAttribute("minx")),Im(t.getAttribute("miny")),Im(t.getAttribute("maxx")),Im(t.getAttribute("maxy"))],n=[Im(t.getAttribute("resx")),Im(t.getAttribute("resy"))];return{crs:t.getAttribute("CRS"),extent:r,res:n}})),Dimension:Hu((function(t,e){return{name:t.getAttribute("name"),units:t.getAttribute("units"),unitSymbol:t.getAttribute("unitSymbol"),default:t.getAttribute("default"),multipleValues:Pm(t.getAttribute("multipleValues")),nearestValue:Pm(t.getAttribute("nearestValue")),current:Pm(t.getAttribute("current")),values:Fm(t)}})),Attribution:Ju((function(t,e){return ol({},uS,t,e)})),AuthorityURL:Hu((function(t,e){var r=mS(t,e);if(r)return r.name=t.getAttribute("name"),r;return})),Identifier:Hu(Fm),MetadataURL:Hu((function(t,e){var r=mS(t,e);if(r)return r.type=t.getAttribute("type"),r;return})),DataURL:Hu(mS),FeatureListURL:Hu(mS),Style:Hu((function(t,e){return ol({},dS,t,e)})),MinScaleDenominator:Ju(Om),MaxScaleDenominator:Ju(Om),Layer:Hu((function(t,e){var r=e[e.length-1],n=ol({},sS,t,e);if(!n)return;var i=Pm(t.getAttribute("queryable"));void 0===i&&(i=r.queryable);n.queryable=void 0!==i&&i;var o=Mm(t.getAttribute("cascaded"));void 0===o&&(o=r.cascaded);n.cascaded=o;var a=Pm(t.getAttribute("opaque"));void 0===a&&(a=r.opaque);n.opaque=void 0!==a&&a;var s=Pm(t.getAttribute("noSubsets"));void 0===s&&(s=r.noSubsets);n.noSubsets=void 0!==s&&s;var u=Im(t.getAttribute("fixedWidth"));u||(u=r.fixedWidth);n.fixedWidth=u;var l=Im(t.getAttribute("fixedHeight"));l||(l=r.fixedHeight);n.fixedHeight=l,["Style","CRS","AuthorityURL"].forEach((function(t){if(t in r){var e=n[t]||[];n[t]=e.concat(r[t])}}));return["EX_GeographicBoundingBox","BoundingBox","Dimension","Attribution","MinScaleDenominator","MaxScaleDenominator"].forEach((function(t){if(!(t in n)){var e=r[t];n[t]=e}})),n}))}),uS=nl($w,{Title:Ju(Fm),OnlineResource:Ju(Hw),LogoURL:Ju(_S)}),lS=nl($w,{westBoundLongitude:Ju(Om),eastBoundLongitude:Ju(Om),southBoundLatitude:Ju(Om),northBoundLatitude:Ju(Om)}),hS=nl($w,{GetCapabilities:Ju(vS),GetMap:Ju(vS),GetFeatureInfo:Ju(vS)}),cS=nl($w,{Format:Hu(Fm),DCPType:Hu((function(t,e){return ol({},pS,t,e)}))}),pS=nl($w,{HTTP:Ju((function(t,e){return ol({},fS,t,e)}))}),fS=nl($w,{Get:Ju(mS),Post:Ju(mS)}),dS=nl($w,{Name:Ju(Fm),Title:Ju(Fm),Abstract:Ju(Fm),LegendURL:Hu(_S),StyleSheetURL:Ju(mS),StyleURL:Ju(mS)}),gS=nl($w,{Format:Ju(Fm),OnlineResource:Ju(Hw)}),yS=nl($w,{Keyword:Zu(Fm)});function mS(t,e){return ol({},gS,t,e)}function vS(t,e){return ol({},cS,t,e)}function _S(t,e){var r=mS(t,e);if(r){var n=[Mm(t.getAttribute("width")),Mm(t.getAttribute("height"))];return r.size=n,r}}function bS(t,e){return ol([],yS,t,e)}var xS=eS,wS=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),SS=function(t){function e(e){var r=t.call(this)||this,n=e||{};return r.featureNS_="http://mapserver.gis.umn.edu/mapserver",r.gmlFormat_=new Xm,r.layers_=n.layers?n.layers:null,r}return wS(e,t),e.prototype.getLayers=function(){return this.layers_},e.prototype.setLayers=function(t){this.layers_=t},e.prototype.readFeatures_=function(t,e){t.setAttribute("namespaceURI",this.featureNS_);var r=t.localName,n=[];if(0===t.childNodes.length)return n;if("msGMLOutput"==r)for(var i=0,o=t.childNodes.length;i<o;i++){var a=t.childNodes[i];if(a.nodeType===Node.ELEMENT_NODE){var s=a,u=e[0],l=s.localName.replace("_layer","");if(!this.layers_||d(this.layers_,l)){var h=l+"_feature";u.featureType=h,u.featureNS=this.featureNS_;var c={};c[h]=Zu(this.gmlFormat_.readFeatureElement,this.gmlFormat_);var p=nl([u.featureNS,null],c);s.setAttribute("namespaceURI",this.featureNS_);var f=ol([],p,s,e,this.gmlFormat_);f&&m(n,f)}}}if("FeatureCollection"==r){var g=ol([],this.gmlFormat_.FEATURE_COLLECTION_PARSERS,t,[{}],this.gmlFormat_);g&&(n=g)}return n},e.prototype.readFeaturesFromNode=function(t,e){var r={};return e&&T(r,this.getReadOptions(t,e)),this.readFeatures_(t,[r])},e}(bm),TS=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ES=[null,"http://www.opengis.net/ows/1.1"],CS=nl(ES,{ServiceIdentification:Ju((function(t,e){return ol({},DS,t,e)})),ServiceProvider:Ju((function(t,e){return ol({},zS,t,e)})),OperationsMetadata:Ju((function(t,e){return ol({},kS,t,e)}))}),PS=function(t){function e(){return t.call(this)||this}return TS(e,t),e.prototype.readFromNode=function(t){var e=ol({},CS,t,[]);return e||null},e}(Kw),RS=nl(ES,{DeliveryPoint:Ju(Fm),City:Ju(Fm),AdministrativeArea:Ju(Fm),PostalCode:Ju(Fm),Country:Ju(Fm),ElectronicMailAddress:Ju(Fm)}),OS=nl(ES,{Value:Hu((function(t,e){return Fm(t)}))}),IS=nl(ES,{AllowedValues:Ju((function(t,e){return ol({},OS,t,e)}))}),LS=nl(ES,{Phone:Ju((function(t,e){return ol({},NS,t,e)})),Address:Ju((function(t,e){return ol({},RS,t,e)}))}),MS=nl(ES,{HTTP:Ju((function(t,e){return ol({},FS,t,e)}))}),FS=nl(ES,{Get:Hu((function(t,e){var r=Hw(t);if(!r)return;return ol({href:r},jS,t,e)})),Post:void 0}),AS=nl(ES,{DCP:Ju((function(t,e){return ol({},MS,t,e)}))}),kS=nl(ES,{Operation:function(t,e){var r=t.getAttribute("name"),n=ol({},AS,t,e);if(!n)return;e[e.length-1][r]=n}}),NS=nl(ES,{Voice:Ju(Fm),Facsimile:Ju(Fm)}),jS=nl(ES,{Constraint:Hu((function(t,e){var r=t.getAttribute("name");if(!r)return;return ol({name:r},IS,t,e)}))}),GS=nl(ES,{IndividualName:Ju(Fm),PositionName:Ju(Fm),ContactInfo:Ju((function(t,e){return ol({},LS,t,e)}))}),DS=nl(ES,{Abstract:Ju(Fm),AccessConstraints:Ju(Fm),Fees:Ju(Fm),Title:Ju(Fm),ServiceTypeVersion:Ju(Fm),ServiceType:Ju(Fm)}),zS=nl(ES,{ProviderName:Ju(Fm),ProviderSite:Ju(Hw),ServiceContact:Ju((function(t,e){return ol({},GS,t,e)}))});var US=PS,BS=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),YS=[null,"http://www.opengis.net/wmts/1.0"],VS=[null,"http://www.opengis.net/ows/1.1"],WS=nl(YS,{Contents:Ju((function(t,e){return ol({},XS,t,e)}))}),qS=function(t){function e(){var e=t.call(this)||this;return e.owsParser_=new US,e}return BS(e,t),e.prototype.readFromNode=function(t){var e=t.getAttribute("version");e&&(e=e.trim());var r=this.owsParser_.readFromNode(t);return r?(r.version=e,(r=ol(r,WS,t,[]))||null):null},e}(Kw),XS=nl(YS,{Layer:Hu((function(t,e){return ol({},ZS,t,e)})),TileMatrixSet:Hu((function(t,e){return ol({},eT,t,e)}))}),ZS=nl(YS,{Style:Hu((function(t,e){var r=ol({},KS,t,e);if(!r)return;var n="true"===t.getAttribute("isDefault");return r.isDefault=n,r})),Format:Hu(Fm),TileMatrixSetLink:Hu((function(t,e){return ol({},HS,t,e)})),Dimension:Hu((function(t,e){return ol({},QS,t,e)})),ResourceURL:Hu((function(t,e){var r=t.getAttribute("format"),n=t.getAttribute("template"),i=t.getAttribute("resourceType"),o={};r&&(o.format=r);n&&(o.template=n);i&&(o.resourceType=i);return o}))},nl(VS,{Title:Ju(Fm),Abstract:Ju(Fm),WGS84BoundingBox:Ju((function(t,e){var r=ol([],tT,t,e);if(2!=r.length)return;return Dt(r)})),Identifier:Ju(Fm)})),KS=nl(YS,{LegendURL:Hu((function(t,e){var r={};return r.format=t.getAttribute("format"),r.href=Hw(t),r}))},nl(VS,{Title:Ju(Fm),Identifier:Ju(Fm)})),HS=nl(YS,{TileMatrixSet:Ju(Fm),TileMatrixSetLimits:Ju((function(t,e){return ol([],JS,t,e)}))}),JS=nl(YS,{TileMatrixLimits:Zu((function(t,e){return ol({},$S,t,e)}))}),$S=nl(YS,{TileMatrix:Ju(Fm),MinTileRow:Ju(Lm),MaxTileRow:Ju(Lm),MinTileCol:Ju(Lm),MaxTileCol:Ju(Lm)}),QS=nl(YS,{Default:Ju(Fm),Value:Hu(Fm)},nl(VS,{Identifier:Ju(Fm)})),tT=nl(VS,{LowerCorner:Zu(nT),UpperCorner:Zu(nT)}),eT=nl(YS,{WellKnownScaleSet:Ju(Fm),TileMatrix:Hu((function(t,e){return ol({},rT,t,e)}))},nl(VS,{SupportedCRS:Ju(Fm),Identifier:Ju(Fm)})),rT=nl(YS,{TopLeftCorner:Ju(nT),ScaleDenominator:Ju(Om),TileWidth:Ju(Lm),TileHeight:Ju(Lm),MatrixWidth:Ju(Lm),MatrixHeight:Ju(Lm)},nl(VS,{Identifier:Ju(Fm)}));function nT(t,e){var r=Fm(t).split(/\s+/);if(r&&2==r.length){var n=+r[0],i=+r[1];if(!isNaN(n)&&!isNaN(i))return[n,i]}}var iT=qS,oT=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),aT=["fullscreenchange","webkitfullscreenchange","MSFullscreenChange"],sT="enterfullscreen",uT="leavefullscreen";function lT(){var t=document.body;return!!(t.webkitRequestFullscreen||t.msRequestFullscreen&&document.msFullscreenEnabled||t.requestFullscreen&&document.fullscreenEnabled)}function hT(){return!!(document.webkitIsFullScreen||document.msFullscreenElement||document.fullscreenElement)}function cT(t){t.requestFullscreen?t.requestFullscreen():t.msRequestFullscreen?t.msRequestFullscreen():t.webkitRequestFullscreen&&t.webkitRequestFullscreen()}var pT=function(t){function e(e){var r=this,n=e||{};(r=t.call(this,{element:document.createElement("div"),target:n.target})||this).cssClassName_=void 0!==n.className?n.className:"ol-full-screen";var i=void 0!==n.label?n.label:"⤢";r.labelNode_="string"==typeof i?document.createTextNode(i):i;var o=void 0!==n.labelActive?n.labelActive:"×";r.labelActiveNode_="string"==typeof o?document.createTextNode(o):o,r.button_=document.createElement("button");var a=n.tipLabel?n.tipLabel:"Toggle full-screen";r.setClassName_(r.button_,hT()),r.button_.setAttribute("type","button"),r.button_.title=a,r.button_.appendChild(r.labelNode_),r.button_.addEventListener(A,r.handleClick_.bind(r),!1);var s=r.cssClassName_+" ol-unselectable ol-control "+(lT()?"":"ol-unsupported"),u=r.element;return u.className=s,u.appendChild(r.button_),r.keys_=void 0!==n.keys&&n.keys,r.source_=n.source,r}return oT(e,t),e.prototype.handleClick_=function(t){t.preventDefault(),this.handleFullScreen_()},e.prototype.handleFullScreen_=function(){if(lT()){var t=this.getMap();if(t)if(hT())document.exitFullscreen?document.exitFullscreen():document.msExitFullscreen?document.msExitFullscreen():document.webkitExitFullscreen&&document.webkitExitFullscreen();else{var e=void 0;e=this.source_?"string"==typeof this.source_?document.getElementById(this.source_):this.source_:t.getTargetElement(),this.keys_?function(t){t.webkitRequestFullscreen?t.webkitRequestFullscreen():cT(t)}(e):cT(e)}}},e.prototype.handleFullScreenChange_=function(){var t=this.getMap();hT()?(this.setClassName_(this.button_,!0),Wi(this.labelActiveNode_,this.labelNode_),this.dispatchEvent(sT)):(this.setClassName_(this.button_,!1),Wi(this.labelNode_,this.labelActiveNode_),this.dispatchEvent(uT)),t&&t.updateSize()},e.prototype.setClassName_=function(t,e){var r=this.cssClassName_+"-true",n=this.cssClassName_+"-false",i=e?r:n;t.classList.remove(r),t.classList.remove(n),t.classList.add(i)},e.prototype.setMap=function(e){if(t.prototype.setMap.call(this,e),e)for(var r=0,n=aT.length;r<n;++r)this.listenerKeys.push(W(document,aT[r],this.handleFullScreenChange_,this))},e}(Va),fT=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),dT=function(t){function e(e){var r=this,n=e||{},i=document.createElement("div");return i.className=void 0!==n.className?n.className:"ol-mouse-position",(r=t.call(this,{element:i,render:n.render,target:n.target})||this).addEventListener(et("projection"),r.handleProjectionChanged_),n.coordinateFormat&&r.setCoordinateFormat(n.coordinateFormat),n.projection&&r.setProjection(n.projection),r.undefinedHTML_=void 0!==n.undefinedHTML?n.undefinedHTML:"&#160;",r.renderOnMouseOut_=!!r.undefinedHTML_,r.renderedHTML_=i.innerHTML,r.mapProjection_=null,r.transform_=null,r}return fT(e,t),e.prototype.handleProjectionChanged_=function(){this.transform_=null},e.prototype.getCoordinateFormat=function(){return this.get("coordinateFormat")},e.prototype.getProjection=function(){return this.get("projection")},e.prototype.handleMouseMove=function(t){var e=this.getMap();this.updateHTML_(e.getEventPixel(t))},e.prototype.handleMouseOut=function(t){this.updateHTML_(null)},e.prototype.setMap=function(e){if(t.prototype.setMap.call(this,e),e){var r=e.getViewport();this.listenerKeys.push(W(r,Jo,this.handleMouseMove,this)),this.renderOnMouseOut_&&this.listenerKeys.push(W(r,ta,this.handleMouseOut,this))}},e.prototype.setCoordinateFormat=function(t){this.set("coordinateFormat",t)},e.prototype.setProjection=function(t){this.set("projection",yr(t))},e.prototype.updateHTML_=function(t){var e=this.undefinedHTML_;if(t&&this.mapProjection_){if(!this.transform_){var r=this.getProjection();this.transform_=r?Tr(this.mapProjection_,r):dr}var n=this.getMap().getCoordinateFromPixelInternal(t);if(n){var i=Mr();i&&(this.transform_=Tr(this.mapProjection_,i)),this.transform_(n,n);var o=this.getCoordinateFormat();e=o?o(n):n.toString()}}this.renderedHTML_&&e===this.renderedHTML_||(this.element.innerHTML=e,this.renderedHTML_=e)},e.prototype.render=function(t){var e=t.frameState;e?this.mapProjection_!=e.viewState.projection&&(this.mapProjection_=e.viewState.projection,this.transform_=null):this.mapProjection_=null},e}(Va),gT=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),yT=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return gT(e,t),e.prototype.createRenderer=function(){return new Bo(this)},e}(Ba),mT=function(t){function e(e){var r=this,n=e||{};(r=t.call(this,{element:document.createElement("div"),render:n.render,target:n.target})||this).boundHandleRotationChanged_=r.handleRotationChanged_.bind(r),r.collapsed_=void 0===n.collapsed||n.collapsed,r.collapsible_=void 0===n.collapsible||n.collapsible,r.collapsible_||(r.collapsed_=!1),r.rotateWithView_=void 0!==n.rotateWithView&&n.rotateWithView,r.viewExtent_=void 0;var i=void 0!==n.className?n.className:"ol-overviewmap",o=void 0!==n.tipLabel?n.tipLabel:"Overview map",a=void 0!==n.collapseLabel?n.collapseLabel:"«";"string"==typeof a?(r.collapseLabel_=document.createElement("span"),r.collapseLabel_.textContent=a):r.collapseLabel_=a;var s=void 0!==n.label?n.label:"»";"string"==typeof s?(r.label_=document.createElement("span"),r.label_.textContent=s):r.label_=s;var u=r.collapsible_&&!r.collapsed_?r.collapseLabel_:r.label_,l=document.createElement("button");l.setAttribute("type","button"),l.title=o,l.appendChild(u),l.addEventListener(A,r.handleClick_.bind(r),!1),r.ovmapDiv_=document.createElement("div"),r.ovmapDiv_.className="ol-overviewmap-map",r.view_=n.view,r.ovmap_=new yT({view:n.view});var h=r.ovmap_;n.layers&&n.layers.forEach((function(t){h.addLayer(t)}));var c=document.createElement("div");c.className="ol-overviewmap-box",c.style.boxSizing="border-box",r.boxOverlay_=new gu({position:[0,0],positioning:iu,element:c}),r.ovmap_.addOverlay(r.boxOverlay_);var p=i+" ol-unselectable ol-control"+(r.collapsed_&&r.collapsible_?" ol-collapsed":"")+(r.collapsible_?"":" ol-uncollapsible"),f=r.element;f.className=p,f.appendChild(r.ovmapDiv_),f.appendChild(l);var d=r,g=r.boxOverlay_,y=r.boxOverlay_.getElement(),m=function(t){var e,r={clientX:(e=t).clientX,clientY:e.clientY},n=h.getEventCoordinateInternal(r);g.setPosition(n)},v=function(t){var e=h.getEventCoordinateInternal(t);d.getMap().getView().setCenterInternal(e),window.removeEventListener("mousemove",m),window.removeEventListener("mouseup",v)};return y.addEventListener("mousedown",(function(){window.addEventListener("mousemove",m),window.addEventListener("mouseup",v)})),r}return gT(e,t),e.prototype.setMap=function(e){var r=this.getMap();if(e!==r){if(r){var n=r.getView();n&&this.unbindView_(n),this.ovmap_.setTarget(null)}if(t.prototype.setMap.call(this,e),e){this.ovmap_.setTarget(this.ovmapDiv_),this.listenerKeys.push(W(e,c,this.handleMapPropertyChange_,this));var i=e.getView();i&&(this.bindView_(i),i.isDef()&&(this.ovmap_.updateSize(),this.resetExtent_()))}}},e.prototype.handleMapPropertyChange_=function(t){if(t.key===la){var e=t.oldValue;e&&this.unbindView_(e);var r=this.getMap().getView();this.bindView_(r)}},e.prototype.bindView_=function(t){if(!this.view_){var e=new ja({projection:t.getProjection()});this.ovmap_.setView(e)}t.addEventListener(et(wa),this.boundHandleRotationChanged_),this.handleRotationChanged_()},e.prototype.unbindView_=function(t){t.removeEventListener(et(wa),this.boundHandleRotationChanged_)},e.prototype.handleRotationChanged_=function(){this.rotateWithView_&&this.ovmap_.getView().setRotation(this.getMap().getView().getRotation())},e.prototype.validateExtent_=function(){var t=this.getMap(),e=this.ovmap_;if(t.isRendered()&&e.isRendered()){var r=t.getSize(),n=t.getView().calculateExtentInternal(r);if(!this.viewExtent_||!$t(n,this.viewExtent_)){this.viewExtent_=n;var i=e.getSize(),o=e.getView().calculateExtentInternal(i),a=e.getPixelFromCoordinateInternal(fe(n)),s=e.getPixelFromCoordinateInternal(se(n)),u=Math.abs(a[0]-s[0]),l=Math.abs(a[1]-s[1]),h=i[0],c=i[1];u<.1*h||l<.1*c||u>.75*h||l>.75*c?this.resetExtent_():Vt(o,n)||this.recenter_()}}},e.prototype.resetExtent_=function(){var t=this.getMap(),e=this.ovmap_,r=t.getSize(),n=t.getView().calculateExtentInternal(r),i=e.getView(),o=Math.log(7.5)/Math.LN2;ve(n,1/(.1*Math.pow(2,o/2))),i.fitInternal(Fn(n))},e.prototype.recenter_=function(){var t=this.getMap(),e=this.ovmap_,r=t.getView();e.getView().setCenterInternal(r.getCenterInternal())},e.prototype.updateBox_=function(){var t=this.getMap(),e=this.ovmap_;if(t.isRendered()&&e.isRendered()){var r=t.getSize(),n=t.getView(),i=e.getView(),o=this.rotateWithView_?0:-n.getRotation(),a=this.boxOverlay_,s=this.boxOverlay_.getElement(),u=n.getCenterInternal(),l=n.getResolution(),h=i.getResolution(),c=r[0]*l/h,p=r[1]*l/h;if(a.setPosition(u),s){s.style.width=c+"px",s.style.height=p+"px";var f="rotate("+o+"rad)";s.style.transform=f}}},e.prototype.handleClick_=function(t){t.preventDefault(),this.handleToggle_()},e.prototype.handleToggle_=function(){this.element.classList.toggle("ol-collapsed"),this.collapsed_?Wi(this.collapseLabel_,this.label_):Wi(this.label_,this.collapseLabel_),this.collapsed_=!this.collapsed_;var t=this.ovmap_;if(!this.collapsed_){if(t.isRendered())return this.viewExtent_=void 0,void t.render();t.updateSize(),this.resetExtent_(),q(t,na,(function(t){this.updateBox_()}),this)}},e.prototype.getCollapsible=function(){return this.collapsible_},e.prototype.setCollapsible=function(t){this.collapsible_!==t&&(this.collapsible_=t,this.element.classList.toggle("ol-uncollapsible"),!t&&this.collapsed_&&this.handleToggle_())},e.prototype.setCollapsed=function(t){this.collapsible_&&this.collapsed_!==t&&this.handleToggle_()},e.prototype.getCollapsed=function(){return this.collapsed_},e.prototype.getRotateWithView=function(){return this.rotateWithView_},e.prototype.setRotateWithView=function(t){this.rotateWithView_!==t&&(this.rotateWithView_=t,0!==this.getMap().getView().getRotation()&&(this.rotateWithView_?this.handleRotationChanged_():this.ovmap_.getView().setRotation(0),this.viewExtent_=void 0,this.validateExtent_(),this.updateBox_()))},e.prototype.getOverviewMap=function(){return this.ovmap_},e.prototype.render=function(t){this.validateExtent_(),this.updateBox_()},e}(Va),vT=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),_T="degrees",bT="imperial",xT="nautical",wT="metric",ST="us",TT=[1,2,5],ET=function(t){function e(e){var r=this,n=e||{},i=void 0!==n.className?n.className:n.bar?"ol-scale-bar":"ol-scale-line";return(r=t.call(this,{element:document.createElement("div"),render:n.render,target:n.target})||this).innerElement_=document.createElement("div"),r.innerElement_.className=i+"-inner",r.element.className=i+" ol-unselectable",r.element.appendChild(r.innerElement_),r.viewState_=null,r.minWidth_=void 0!==n.minWidth?n.minWidth:64,r.renderedVisible_=!1,r.renderedWidth_=void 0,r.renderedHTML_="",r.addEventListener(et("units"),r.handleUnitsChanged_),r.setUnits(n.units||wT),r.scaleBar_=n.bar||!1,r.scaleBarSteps_=n.steps||4,r.scaleBarText_=n.text||!1,r.dpi_=n.dpi||void 0,r}return vT(e,t),e.prototype.getUnits=function(){return this.get("units")},e.prototype.handleUnitsChanged_=function(){this.updateElement_()},e.prototype.setUnits=function(t){this.set("units",t)},e.prototype.setDpi=function(t){this.dpi_=t},e.prototype.updateElement_=function(){var t=this.viewState_;if(t){var e=t.center,r=t.projection,n=this.getUnits(),i=n==_T?_t.DEGREES:_t.METERS,o=mr(r,t.resolution,e,i),a=this.minWidth_*(this.dpi_||25.4/.28)/(25.4/.28),s=a*o,u="";if(n==_T){var l=vt[_t.DEGREES];(s*=l)<l/60?(u="″",o*=3600):s<l?(u="′",o*=60):u="°"}else n==bT?s<.9144?(u="in",o/=.0254):s<1609.344?(u="ft",o/=.3048):(u="mi",o/=1609.344):n==xT?(o/=1852,u="nm"):n==wT?s<.001?(u="μm",o*=1e6):s<1?(u="mm",o*=1e3):s<1e3?u="m":(u="km",o/=1e3):n==ST?s<.9144?(u="in",o*=39.37):s<1609.344?(u="ft",o/=.30480061):(u="mi",o/=1609.3472):lt(!1,33);for(var h,c,p,f,d=3*Math.floor(Math.log(a*o)/Math.log(10));;){p=Math.floor(d/3);var g=Math.pow(10,p);if(h=TT[(d%3+3)%3]*g,c=Math.round(h/o),isNaN(c))return this.element.style.display="none",void(this.renderedVisible_=!1);if(c>=a)break;++d}f=this.scaleBar_?this.createScaleBar(c,h,u):h.toFixed(p<0?-p:0)+" "+u,this.renderedHTML_!=f&&(this.innerElement_.innerHTML=f,this.renderedHTML_=f),this.renderedWidth_!=c&&(this.innerElement_.style.width=c+"px",this.renderedWidth_=c),this.renderedVisible_||(this.element.style.display="",this.renderedVisible_=!0)}else this.renderedVisible_&&(this.element.style.display="none",this.renderedVisible_=!1)},e.prototype.createScaleBar=function(t,e,r){for(var n="1 : "+Math.round(this.getScaleForResolution()).toLocaleString(),i=[],o=t/this.scaleBarSteps_,a="#ffffff",s=0;s<this.scaleBarSteps_;s++)0===s&&i.push(this.createMarker("absolute",s)),i.push('<div><div class="ol-scale-singlebar" style="width: '+o+"px;background-color: "+a+';"></div>'+this.createMarker("relative",s)+(s%2==0||2===this.scaleBarSteps_?this.createStepText(s,t,!1,e,r):"")+"</div>"),s===this.scaleBarSteps_-1&&i.push(this.createStepText(s+1,t,!0,e,r)),a="#ffffff"===a?"#000000":"#ffffff";return'<div style="display: flex;">'+(this.scaleBarText_?'<div class="ol-scale-text" style="width: '+t+'px;">'+n+"</div>":"")+i.join("")+"</div>"},e.prototype.createMarker=function(t,e){return'<div class="ol-scale-step-marker" style="position: '+t+";top: "+("absolute"===t?3:-10)+'px;"></div>'},e.prototype.createStepText=function(t,e,r,n,i){var o=(0===t?0:Math.round(n/this.scaleBarSteps_*t*100)/100)+(0===t?"":" "+i);return'<div class="ol-scale-step-text" style="margin-left: '+(0===t?-3:e/this.scaleBarSteps_*-1)+"px;text-align: "+(0===t?"left":"center")+"; min-width: "+(0===t?0:e/this.scaleBarSteps_*2)+"px;left: "+(r?e+"px":"unset")+';">'+o+"</div>"},e.prototype.getScaleForResolution=function(){var t=mr(this.viewState_.projection,this.viewState_.resolution,this.viewState_.center),e=this.dpi_||25.4/.28,r=this.viewState_.projection.getMetersPerUnit();return parseFloat(t.toString())*r*39.37*e},e.prototype.render=function(t){var e=t.frameState;this.viewState_=e?e.viewState:null,this.updateElement_()},e}(Va),CT=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),PT=0,RT=1,OT=function(t){function e(e){var r=this,n=e||{};(r=t.call(this,{element:document.createElement("div"),render:n.render})||this).dragListenerKeys_=[],r.currentResolution_=void 0,r.direction_=PT,r.dragging_,r.heightLimit_=0,r.widthLimit_=0,r.startX_,r.startY_,r.thumbSize_=null,r.sliderInitialized_=!1,r.duration_=void 0!==n.duration?n.duration:200;var i=void 0!==n.className?n.className:"ol-zoomslider",o=document.createElement("button");o.setAttribute("type","button"),o.className=i+"-thumb ol-unselectable";var a=r.element;return a.className=i+" ol-unselectable ol-control",a.appendChild(o),a.addEventListener($o,r.handleDraggerStart_.bind(r),!1),a.addEventListener(Jo,r.handleDraggerDrag_.bind(r),!1),a.addEventListener(Qo,r.handleDraggerEnd_.bind(r),!1),a.addEventListener(A,r.handleContainerClick_.bind(r),!1),o.addEventListener(A,l,!1),r}return CT(e,t),e.prototype.setMap=function(e){t.prototype.setMap.call(this,e),e&&e.render()},e.prototype.initSlider_=function(){var t=this.element,e=t.offsetWidth,r=t.offsetHeight;if(0===e&&0===r)return this.sliderInitialized_=!1;var n=t.firstElementChild,i=getComputedStyle(n),o=n.offsetWidth+parseFloat(i.marginRight)+parseFloat(i.marginLeft),a=n.offsetHeight+parseFloat(i.marginTop)+parseFloat(i.marginBottom);return this.thumbSize_=[o,a],e>r?(this.direction_=RT,this.widthLimit_=e-o):(this.direction_=PT,this.heightLimit_=r-a),this.sliderInitialized_=!0},e.prototype.handleContainerClick_=function(t){var e=this.getMap().getView(),r=this.getRelativePosition_(t.offsetX-this.thumbSize_[0]/2,t.offsetY-this.thumbSize_[1]/2),n=this.getResolutionForPosition_(r),i=e.getConstrainedZoom(e.getZoomForResolution(n));e.animateInternal({zoom:i,duration:this.duration_,easing:La})},e.prototype.handleDraggerStart_=function(t){if(!this.dragging_&&t.target===this.element.firstElementChild){var e=this.element.firstElementChild;if(this.getMap().getView().beginInteraction(),this.startX_=t.clientX-parseFloat(e.style.left),this.startY_=t.clientY-parseFloat(e.style.top),this.dragging_=!0,0===this.dragListenerKeys_.length){var r=this.handleDraggerDrag_,n=this.handleDraggerEnd_;this.dragListenerKeys_.push(W(document,Jo,r,this),W(document,Qo,n,this))}}},e.prototype.handleDraggerDrag_=function(t){if(this.dragging_){var e=t.clientX-this.startX_,r=t.clientY-this.startY_,n=this.getRelativePosition_(e,r);this.currentResolution_=this.getResolutionForPosition_(n),this.getMap().getView().setResolution(this.currentResolution_)}},e.prototype.handleDraggerEnd_=function(t){this.dragging_&&(this.getMap().getView().endInteraction(),this.dragging_=!1,this.startX_=void 0,this.startY_=void 0,this.dragListenerKeys_.forEach(X),this.dragListenerKeys_.length=0)},e.prototype.setThumbPosition_=function(t){var e=this.getPositionForResolution_(t),r=this.element.firstElementChild;this.direction_==RT?r.style.left=this.widthLimit_*e+"px":r.style.top=this.heightLimit_*e+"px"},e.prototype.getRelativePosition_=function(t,e){return we(this.direction_===RT?t/this.widthLimit_:e/this.heightLimit_,0,1)},e.prototype.getResolutionForPosition_=function(t){return this.getMap().getView().getResolutionForValueFunction()(1-t)},e.prototype.getPositionForResolution_=function(t){return we(1-this.getMap().getView().getValueForResolutionFunction()(t),0,1)},e.prototype.render=function(t){if(t.frameState&&(this.sliderInitialized_||this.initSlider_())){var e=t.frameState.viewState.resolution;this.currentResolution_=e,this.setThumbPosition_(e)}},e}(Va),IT=function(){var t=function(e,r){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),LT=function(t){function e(e){var r=this,n=e||{};(r=t.call(this,{element:document.createElement("div"),target:n.target})||this).extent=n.extent?n.extent:null;var i=void 0!==n.className?n.className:"ol-zoom-extent",o=void 0!==n.label?n.label:"E",a=void 0!==n.tipLabel?n.tipLabel:"Fit to extent",s=document.createElement("button");s.setAttribute("type","button"),s.title=a,s.appendChild("string"==typeof o?document.createTextNode(o):o),s.addEventListener(A,r.handleClick_.bind(r),!1);var u=i+" ol-unselectable ol-control",l=r.element;return l.className=u,l.appendChild(s),r}return IT(e,t),e.prototype.handleClick_=function(t){t.preventDefault(),this.handleZoomToExtent()},e.prototype.handleZoomToExtent=function(){var t=this.getMap().getView(),e=this.extent?this.extent:t.getProjection().getExtent();t.fitInternal(Fn(e))},e}(Va),MT={array:{},color:{},colorlike:{},control:{},coordinate:{},easing:{},events:{}};MT.events.condition={},MT.extent={},MT.featureloader={},MT.format={},MT.format.filter={},MT.geom={},MT.has={},MT.interaction={},MT.layer={},MT.loadingstrategy={},MT.proj={},MT.proj.Units={},MT.proj.proj4={},MT.render={},MT.render.canvas={},MT.renderer={},MT.renderer.canvas={},MT.renderer.webgl={},MT.size={},MT.source={},MT.sphere={},MT.style={},MT.style.IconImageCache={},MT.tilegrid={},MT.transform={},MT.util={},MT.webgl={},MT.xml={},MT.Collection=ut,MT.Feature=ct,MT.Geolocation=Zn,MT.Kinetic=Kn,MT.Map=Qs,MT.Object=rt,MT.Observable=H,MT.Observable.unByKey=K,MT.Overlay=gu,MT.PluggableMap=Ba,MT.View=ja,MT.array.stableSort=function(t,e){var r,n=t.length,i=Array(t.length);for(r=0;r<n;r++)i[r]={index:r,value:t[r]};for(i.sort((function(t,r){return e(t.value,r.value)||t.index-r.index})),r=0;r<t.length;r++)t[r]=i[r].value},MT.color.asArray=ni,MT.color.asString=$n,MT.colorlike.asColorLike=Fi,MT.control.Attribution=qa,MT.control.Control=Va,MT.control.FullScreen=pT,MT.control.MousePosition=dT,MT.control.OverviewMap=mT,MT.control.Rotate=Za,MT.control.ScaleLine=ET,MT.control.Zoom=Ha,MT.control.ZoomSlider=OT,MT.control.ZoomToExtent=LT,MT.control.defaults=Ja,MT.coordinate.add=tr,MT.coordinate.createStringXY=function(t){return function(e){return hr(e,t)}},MT.coordinate.format=nr,MT.coordinate.rotate=or,MT.coordinate.toStringHDMS=function(t,e){return t?rr("NS",t[1],e)+" "+rr("EW",t[0],e):""},MT.coordinate.toStringXY=hr,MT.easing.easeIn=Ia,MT.easing.easeOut=La,MT.easing.inAndOut=Ma,MT.easing.linear=Fa,MT.easing.upAndDown=function(t){return t<.5?Ma(2*t):1-Ma(2*(t-.5))},MT.events.condition.altKeyOnly=us,MT.events.condition.altShiftKeysOnly=ls,MT.events.condition.always=ps,MT.events.condition.click=function(t){return t.type==Ho.CLICK},MT.events.condition.doubleClick=function(t){return t.type==Ho.DBLCLICK},MT.events.condition.focus=hs,MT.events.condition.mouseOnly=_s,MT.events.condition.never=ds,MT.events.condition.noModifierKeys=ys,MT.events.condition.penOnly=function(t){var e=t.originalEvent;return lt(void 0!==e,56),"pen"===e.pointerType},MT.events.condition.platformModifierKeyOnly=function(t){var e=t.originalEvent;return!e.altKey&&(ji?e.metaKey:e.ctrlKey)&&!e.shiftKey},MT.events.condition.pointerMove=function(t){return"pointermove"==t.type},MT.events.condition.primaryAction=bs,MT.events.condition.shiftKeyOnly=ms,MT.events.condition.singleClick=gs,MT.events.condition.targetNotEditable=vs,MT.events.condition.touchOnly=function(t){var e=t.originalEvent;return lt(void 0!==e,56),"touch"===e.pointerType},MT.extent.applyTransform=_e,MT.extent.boundingExtent=Dt,MT.extent.buffer=zt,MT.extent.containsCoordinate=Yt,MT.extent.containsExtent=Vt,MT.extent.containsXY=Wt,MT.extent.createEmpty=Xt,MT.extent.equals=$t,MT.extent.extend=Qt,MT.extent.getArea=oe,MT.extent.getBottomLeft=ae,MT.extent.getBottomRight=se,MT.extent.getCenter=ue,MT.extent.getHeight=ce,MT.extent.getIntersection=pe,MT.extent.getSize=function(t){return[t[2]-t[0],t[3]-t[1]]},MT.extent.getTopLeft=fe,MT.extent.getTopRight=de,MT.extent.getWidth=ge,MT.extent.intersects=ye,MT.extent.isEmpty=me,MT.featureloader.setWithCredentials=function(t){bu=t},MT.featureloader.xhr=wu,MT.format.EsriJSON=vm,MT.format.Feature=zd,MT.format.GML=Ym,MT.format.GML2=Xm,MT.format.GML3=Um,MT.format.GML32=Hm,MT.format.GPX=Mv,MT.format.GeoJSON=Hg,MT.format.IGC=Jv,MT.format.IIIFInfo=Rc,MT.format.KML=Yb,MT.format.MVT=ag,MT.format.OSMXML=Jb,MT.format.Polyline=ox,MT.format.Polyline.decodeDeltas=ex,MT.format.Polyline.decodeFloats=nx,MT.format.Polyline.encodeDeltas=tx,MT.format.Polyline.encodeFloats=rx,MT.format.TopoJSON=dx,MT.format.WFS=Ow,MT.format.WFS.writeFilter=function(t){var e=Yu(fw,"Filter");return ww(e,t,[]),e},MT.format.WKT=Zw,MT.format.WMSCapabilities=xS,MT.format.WMSGetFeatureInfo=SS,MT.format.WMTSCapabilities=iT,MT.format.filter.Bbox=xx,MT.format.filter.Contains=Ex,MT.format.filter.During=Ox,MT.format.filter.EqualTo=Fx,MT.format.filter.GreaterThan=kx,MT.format.filter.GreaterThanOrEqualTo=jx,MT.format.filter.Intersects=Dx,MT.format.filter.IsBetween=Ux,MT.format.filter.IsLike=Yx,MT.format.filter.IsNull=Wx,MT.format.filter.LessThan=Xx,MT.format.filter.LessThanOrEqualTo=Kx,MT.format.filter.Not=Jx,MT.format.filter.NotEqualTo=Qx,MT.format.filter.Or=ew,MT.format.filter.Within=nw,MT.format.filter.and=iw,MT.format.filter.bbox=ow,MT.format.filter.between=function(t,e,r){return new Ux(t,e,r)},MT.format.filter.contains=function(t,e,r){return new Ex(t,e,r)},MT.format.filter.during=function(t,e,r){return new Ox(t,e,r)},MT.format.filter.equalTo=function(t,e,r){return new Fx(t,e,r)},MT.format.filter.greaterThan=function(t,e){return new kx(t,e)},MT.format.filter.greaterThanOrEqualTo=function(t,e){return new jx(t,e)},MT.format.filter.intersects=function(t,e,r){return new Dx(t,e,r)},MT.format.filter.isNull=function(t){return new Wx(t)},MT.format.filter.lessThan=function(t,e){return new Xx(t,e)},MT.format.filter.lessThanOrEqualTo=function(t,e){return new Kx(t,e)},MT.format.filter.like=function(t,e,r,n,i,o){return new Yx(t,e,r,n,i,o)},MT.format.filter.not=function(t){return new Jx(t)},MT.format.filter.notEqualTo=function(t,e,r){return new Qx(t,e,r)},MT.format.filter.or=function(t){var e=[null].concat(Array.prototype.slice.call(arguments));return new(Function.prototype.bind.apply(ew,e))},MT.format.filter.within=function(t,e,r){return new nw(t,e,r)},MT.geom.Circle=wy,MT.geom.Geometry=Yr,MT.geom.GeometryCollection=Bg,MT.geom.LineString=Cd,MT.geom.LinearRing=fn,MT.geom.MultiLineString=Vd,MT.geom.MultiPoint=qd,MT.geom.MultiPolygon=Kd,MT.geom.Point=gn,MT.geom.Polygon=Ln,MT.geom.Polygon.circular=Mn,MT.geom.Polygon.fromCircle=An,MT.geom.Polygon.fromExtent=Fn,MT.geom.SimpleGeometry=qr,MT.has.DEVICE_PIXEL_RATIO=Gi,MT.interaction.DoubleClickZoom=ns,MT.interaction.DragAndDrop=my,MT.interaction.DragBox=Ms,MT.interaction.DragPan=ws,MT.interaction.DragRotate=Ts,MT.interaction.DragRotateAndZoom=_y,MT.interaction.DragZoom=As,MT.interaction.Draw=My,MT.interaction.Draw.createBox=function(){return function(t,e,r){var n=Dt(t.map((function(t){return Ar(t,r)}))),i=[[ae(n),se(n),de(n),fe(n),ae(n)]],o=e;o?o.setCoordinates(i):o=new Ln(i);var a=Mr();return a&&o.transform(r,a),o}},MT.interaction.Draw.createRegularPolygon=function(t,e){return function(r,n,i){var o=Ar(r[0],i),a=Ar(r[1],i),s=Math.sqrt(sr(o,a)),u=n||An(new wy(o),t),l=e;if(!e){var h=a[0]-o[0],c=a[1]-o[1];l=Math.atan(c/h)-(h<0?Math.PI:0)}kn(u,o,s,l);var p=Mr();return p&&u.transform(i,p),u}},MT.interaction.Extent=Dy,MT.interaction.Interaction=es,MT.interaction.KeyboardPan=zs,MT.interaction.KeyboardZoom=Bs,MT.interaction.Modify=Ky,MT.interaction.MouseWheelZoom=qs,MT.interaction.PinchRotate=Zs,MT.interaction.PinchZoom=Hs,MT.interaction.Pointer=as,MT.interaction.Select=tm,MT.interaction.Snap=im,MT.interaction.Translate=hm,MT.interaction.defaults=Js,MT.layer.Base=_i,MT.layer.BaseImage=lp,MT.layer.BaseTile=xp,MT.layer.BaseVector=xf,MT.layer.Graticule=Fd,MT.layer.Group=Wo,MT.layer.Heatmap=Dd,MT.layer.Image=mp,MT.layer.Layer=Li,MT.layer.MapboxVector=cy,MT.layer.Tile=Cp,MT.layer.Vector=Rd,MT.layer.VectorImage=fy,MT.layer.VectorTile=ug,MT.loadingstrategy.all=Su,MT.loadingstrategy.bbox=function(t,e){return[t]},MT.loadingstrategy.tile=function(t){return function(e,r){var n=t.getZForResolution(r),i=t.getTileRangeForExtentAndZ(e,n),o=[],a=[n,0,0];for(a[1]=i.minX;a[1]<=i.maxX;++a[1])for(a[2]=i.minY;a[2]<=i.maxY;++a[2])o.push(t.getTileCoordExtent(a));return o}},MT.proj.Projection=xe,MT.proj.Units.METERS_PER_UNIT=vt,MT.proj.addCoordinateTransforms=xr,MT.proj.addEquivalentProjections=vr,MT.proj.addProjection=gr,MT.proj.equivalent=Sr,MT.proj.fromLonLat=wr,MT.proj.get=yr,MT.proj.getPointResolution=mr,MT.proj.getTransform=Er,MT.proj.proj4.register=function(t){var e,r,n=Object.keys(t.defs),i=n.length;for(e=0;e<i;++e){var o=n[e];if(!yr(o)){var a=t.defs(o);gr(new xe({code:o,axisOrientation:a.axis,metersPerUnit:a.to_meter,units:a.units}))}}for(e=0;e<i;++e){var s=n[e],u=yr(s);for(r=0;r<i;++r){var l=n[r],h=yr(l);if(!Xe(s,l)){var c=t.defs(s),p=t.defs(l);if(c===p)vr([u,h]);else{var f=t(T({},c,{axis:void 0}),T({},p,{axis:void 0}));xr(u,h,jr(u,h,f.forward),jr(h,u,f.inverse))}}}}},MT.proj.toLonLat=function(t,e){var r=Cr(t,void 0!==e?e:"EPSG:3857","EPSG:4326"),n=r[0];return(n<-180||n>180)&&(r[0]=Oe(n+180,360)-180),r},MT.proj.transform=Cr,MT.proj.transformExtent=Pr,MT.render.VectorContext=Mi,MT.render.canvas.labelCache=to,MT.render.getRenderPixel=function(t,e){var r=e.slice(0);return Tt(t.inversePixelTransform.slice(),r),r},MT.render.getVectorContext=Ao,MT.render.toContext=function(t,e){var r=t.canvas,n=e||{},i=n.pixelRatio||Gi,o=n.size;o&&(r.width=o[0]*i,r.height=o[1]*i,r.style.width=o[0]+"px",r.style.height=o[1]+"px");var a=[0,0,r.width,r.height],s=Et([1,0,0,1,0,0],i,i);return new mo(t,i,a,s,0)},MT.renderer.Composite=Bo,MT.renderer.canvas.ImageLayer=gp,MT.renderer.canvas.TileLayer=Tp,MT.renderer.canvas.VectorImageLayer=gd,MT.renderer.canvas.VectorLayer=fd,MT.renderer.canvas.VectorTileLayer=wd,MT.renderer.webgl.PointsLayer=Of,MT.size.toSize=za,MT.source.BingMaps=Jh,MT.source.CartoDB=ec,MT.source.Cluster=fc,MT.source.IIIF=Lc,MT.source.Image=zc,MT.source.ImageArcGISRest=Yc,MT.source.ImageCanvas=Xc,MT.source.ImageMapGuide=Kc,MT.source.ImageStatic=Jc,MT.source.ImageWMS=ip,MT.source.OSM=sp,MT.source.OSM.ATTRIBUTION=ap,MT.source.Raster=Bp,MT.source.Source=Ah,MT.source.Stamen=Xp,MT.source.Tile=Gh,MT.source.TileArcGISRest=Kp,MT.source.TileDebug=$p,MT.source.TileImage=Zh,MT.source.TileJSON=tf,MT.source.TileWMS=rf,MT.source.UTFGrid=af,MT.source.Vector=cc,MT.source.VectorTile=ff,MT.source.WMTS=vf,MT.source.WMTS.optionsFromCapabilities=function(t,e){var r=v(t.Contents.Layer,(function(t,r,n){return t.Identifier==e.layer}));if(null===r)return null;var n,i=t.Contents.TileMatrixSet;(n=r.TileMatrixSetLink.length>1?b(r.TileMatrixSetLink,"projection"in e?function(t,r,n){var o=v(i,(function(e){return e.Identifier==t.TileMatrixSet})).SupportedCRS,a=yr(o.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"))||yr(o),s=yr(e.projection);return a&&s?Sr(a,s):o==e.projection}:function(t,r,n){return t.TileMatrixSet==e.matrixSet}):0)<0&&(n=0);var o=r.TileMatrixSetLink[n].TileMatrixSet,a=r.TileMatrixSetLink[n].TileMatrixSetLimits,s=r.Format[0];"format"in e&&(s=e.format),(n=b(r.Style,(function(t,r,n){return"style"in e?t.Title==e.style:t.isDefault})))<0&&(n=0);var u=r.Style[n].Identifier,l={};"Dimension"in r&&r.Dimension.forEach((function(t,e,r){var n=t.Identifier,i=t.Default;void 0===i&&(i=t.Value[0]),l[n]=i}));var h,c=v(t.Contents.TileMatrixSet,(function(t,e,r){return t.Identifier==o})),p=c.SupportedCRS;if(p&&(h=yr(p.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"))||yr(p)),"projection"in e){var f=yr(e.projection);f&&(h&&!Sr(f,h)||(h=f))}var g="ne"==h.getAxisOrientation().substr(0,2),y=c.TileMatrix[0],m={MinTileCol:0,MinTileRow:0,MaxTileCol:y.MatrixWidth-1,MaxTileRow:y.MatrixHeight-1};a&&(m=a[a.length-1],y=v(c.TileMatrix,(function(t){return t.Identifier===m.TileMatrix})));var _=28e-5*y.ScaleDenominator/h.getMetersPerUnit(),x=g?[y.TopLeftCorner[1],y.TopLeftCorner[0]]:y.TopLeftCorner,w=y.TileWidth*_,S=y.TileHeight*_,T=[x[0]+w*m.MinTileCol,x[1]-S*(1+m.MaxTileRow),x[0]+w*(1+m.MaxTileCol),x[1]-S*m.MinTileRow];null===h.getExtent()&&h.setExtent(T);var E=Al(c,T,a),C=[],P=e.requestEncoding;if(P=void 0!==P?P:"","OperationsMetadata"in t&&"GetTile"in t.OperationsMetadata)for(var R=t.OperationsMetadata.GetTile.DCP.HTTP.Get,O=0,I=R.length;O<I;++O)if(R[O].Constraint){var L=v(R[O].Constraint,(function(t){return"GetEncoding"==t.name})).AllowedValues.Value;if(""===P&&(P=L[0]),P!==gf)break;d(L,gf)&&C.push(R[O].href)}else R[O].href&&(P=gf,C.push(R[O].href));return 0===C.length&&(P=yf,r.ResourceURL.forEach((function(t){"tile"===t.resourceType&&(s=t.format,C.push(t.template))}))),{urls:C,layer:e.layer,matrixSet:o,format:s,projection:h,requestEncoding:P,tileGrid:E,style:u,dimensions:l,wrapX:!1,crossOrigin:e.crossOrigin}},MT.source.XYZ=Qh,MT.source.Zoomify=vc,MT.sphere.getArea=function t(e,r){var n=r||{},i=n.radius||6371008.8,o=n.projection||"EPSG:3857",a=e.getType();a!==yt.GEOMETRY_COLLECTION&&(e=e.clone().transform(o,"EPSG:4326"));var s,u,l,h,c,p,f=0;switch(a){case yt.POINT:case yt.MULTI_POINT:case yt.LINE_STRING:case yt.MULTI_LINE_STRING:case yt.LINEAR_RING:break;case yt.POLYGON:for(s=e.getCoordinates(),f=Math.abs(He(s[0],i)),l=1,h=s.length;l<h;++l)f-=Math.abs(He(s[l],i));break;case yt.MULTI_POLYGON:for(l=0,h=(s=e.getCoordinates()).length;l<h;++l)for(u=s[l],f+=Math.abs(He(u[0],i)),c=1,p=u.length;c<p;++c)f-=Math.abs(He(u[c],i));break;case yt.GEOMETRY_COLLECTION:var d=e.getGeometries();for(l=0,h=d.length;l<h;++l)f+=t(d[l],r);break;default:throw new Error("Unsupported geometry type: "+a)}return f},MT.sphere.getDistance=Ze,MT.sphere.getLength=function t(e,r){var n=r||{},i=n.radius||6371008.8,o=n.projection||"EPSG:3857",a=e.getType();a!==yt.GEOMETRY_COLLECTION&&(e=e.clone().transform(o,"EPSG:4326"));var s,u,l,h,c,p,f=0;switch(a){case yt.POINT:case yt.MULTI_POINT:break;case yt.LINE_STRING:case yt.LINEAR_RING:f=Ke(s=e.getCoordinates(),i);break;case yt.MULTI_LINE_STRING:case yt.POLYGON:for(l=0,h=(s=e.getCoordinates()).length;l<h;++l)f+=Ke(s[l],i);break;case yt.MULTI_POLYGON:for(l=0,h=(s=e.getCoordinates()).length;l<h;++l)for(c=0,p=(u=s[l]).length;c<p;++c)f+=Ke(u[c],i);break;case yt.GEOMETRY_COLLECTION:var d=e.getGeometries();for(l=0,h=d.length;l<h;++l)f+=t(d[l],r);break;default:throw new Error("Unsupported geometry type: "+a)}return f},MT.style.Circle=Dl,MT.style.Fill=zl,MT.style.Icon=rh,MT.style.IconImageCache.shared=ui,MT.style.Image=kl,MT.style.RegularShape=jl,MT.style.Stroke=nh,MT.style.Style=lh,MT.style.Text=ph,MT.tilegrid.TileGrid=Fu,MT.tilegrid.WMTS=Fl,MT.tilegrid.WMTS.createFromCapabilitiesMatrixSet=Al,MT.tilegrid.createXYZ=ku,MT.transform.composeCssTransform=function(t,e,r,n,i,o,a){return Rt(Ct([1,0,0,1,0,0],t,e,r,n,i,o,a))},MT.util.getUid=o,MT.webgl.ARRAY_BUFFER=34962,MT.webgl.Buffer=fl,MT.webgl.DYNAMIC_DRAW=35048,MT.webgl.ELEMENT_ARRAY_BUFFER=34963,MT.webgl.Helper=Rl,MT.webgl.Helper.computeAttributesStride=Cl,MT.webgl.PostProcessingPass=yl,MT.webgl.RenderTarget=Il,MT.webgl.STATIC_DRAW=35044,MT.webgl.STREAM_DRAW=35040,MT.xml.getAllTextContent=Vu,MT.xml.parse=qu,MT.xml.registerDocument=function(t){ll=t},MT.xml.registerXMLSerializer=function(t){ul=t};e.default=MT}]).default}));
//# sourceMappingURL=ol.js.map
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['exports'], factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        factory(exports);
    } else {
        // Browser globals
        var exp = {};
        factory(exp);
        root.AnsiUp = exp.default;
    }
}(this, function (exports) {
    "use strict";
    var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };
    var PacketKind;
    (function (PacketKind) {
        PacketKind[PacketKind["EOS"] = 0] = "EOS";
        PacketKind[PacketKind["Text"] = 1] = "Text";
        PacketKind[PacketKind["Incomplete"] = 2] = "Incomplete";
        PacketKind[PacketKind["ESC"] = 3] = "ESC";
        PacketKind[PacketKind["Unknown"] = 4] = "Unknown";
        PacketKind[PacketKind["SGR"] = 5] = "SGR";
        PacketKind[PacketKind["OSCURL"] = 6] = "OSCURL";
    })(PacketKind || (PacketKind = {}));
    var AnsiUp = (function () {
        function AnsiUp() {
            this.VERSION = "4.0.3";
            this.setup_palettes();
            this._use_classes = false;
            this._escape_for_html = true;
            this.bold = false;
            this.fg = this.bg = null;
            this._buffer = '';
            this._url_whitelist = { 'http': 1, 'https': 1 };
        }
        Object.defineProperty(AnsiUp.prototype, "use_classes", {
            get: function () {
                return this._use_classes;
            },
            set: function (arg) {
                this._use_classes = arg;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AnsiUp.prototype, "escape_for_html", {
            get: function () {
                return this._escape_for_html;
            },
            set: function (arg) {
                this._escape_for_html = arg;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AnsiUp.prototype, "url_whitelist", {
            get: function () {
                return this._url_whitelist;
            },
            set: function (arg) {
                this._url_whitelist = arg;
            },
            enumerable: true,
            configurable: true
        });
        AnsiUp.prototype.setup_palettes = function () {
            var _this = this;
            this.ansi_colors =
                [
                    [
                        { rgb: [0, 0, 0], class_name: "ansi-black" },
                        { rgb: [187, 0, 0], class_name: "ansi-red" },
                        { rgb: [0, 187, 0], class_name: "ansi-green" },
                        { rgb: [187, 187, 0], class_name: "ansi-yellow" },
                        { rgb: [0, 0, 187], class_name: "ansi-blue" },
                        { rgb: [187, 0, 187], class_name: "ansi-magenta" },
                        { rgb: [0, 187, 187], class_name: "ansi-cyan" },
                        { rgb: [255, 255, 255], class_name: "ansi-white" }
                    ],
                    [
                        { rgb: [85, 85, 85], class_name: "ansi-bright-black" },
                        { rgb: [255, 85, 85], class_name: "ansi-bright-red" },
                        { rgb: [0, 255, 0], class_name: "ansi-bright-green" },
                        { rgb: [255, 255, 85], class_name: "ansi-bright-yellow" },
                        { rgb: [85, 85, 255], class_name: "ansi-bright-blue" },
                        { rgb: [255, 85, 255], class_name: "ansi-bright-magenta" },
                        { rgb: [85, 255, 255], class_name: "ansi-bright-cyan" },
                        { rgb: [255, 255, 255], class_name: "ansi-bright-white" }
                    ]
                ];
            this.palette_256 = [];
            this.ansi_colors.forEach(function (palette) {
                palette.forEach(function (rec) {
                    _this.palette_256.push(rec);
                });
            });
            var levels = [0, 95, 135, 175, 215, 255];
            for (var r = 0; r < 6; ++r) {
                for (var g = 0; g < 6; ++g) {
                    for (var b = 0; b < 6; ++b) {
                        var col = { rgb: [levels[r], levels[g], levels[b]], class_name: 'truecolor' };
                        this.palette_256.push(col);
                    }
                }
            }
            var grey_level = 8;
            for (var i = 0; i < 24; ++i, grey_level += 10) {
                var gry = { rgb: [grey_level, grey_level, grey_level], class_name: 'truecolor' };
                this.palette_256.push(gry);
            }
        };
        AnsiUp.prototype.escape_txt_for_html = function (txt) {
            return txt.replace(/[&<>]/gm, function (str) {
                if (str === "&")
                    return "&amp;";
                if (str === "<")
                    return "&lt;";
                if (str === ">")
                    return "&gt;";
            });
        };
        AnsiUp.prototype.append_buffer = function (txt) {
            var str = this._buffer + txt;
            this._buffer = str;
        };
        AnsiUp.prototype.get_next_packet = function () {
            var pkt = {
                kind: PacketKind.EOS,
                text: '',
                url: ''
            };
            var len = this._buffer.length;
            if (len == 0)
                return pkt;
            var pos = this._buffer.indexOf("\x1B");
            if (pos == -1) {
                pkt.kind = PacketKind.Text;
                pkt.text = this._buffer;
                this._buffer = '';
                return pkt;
            }
            if (pos > 0) {
                pkt.kind = PacketKind.Text;
                pkt.text = this._buffer.slice(0, pos);
                this._buffer = this._buffer.slice(pos);
                return pkt;
            }
            if (pos == 0) {
                if (len == 1) {
                    pkt.kind = PacketKind.Incomplete;
                    return pkt;
                }
                var next_char = this._buffer.charAt(1);
                if ((next_char != '[') && (next_char != ']')) {
                    pkt.kind = PacketKind.ESC;
                    pkt.text = this._buffer.slice(0, 1);
                    this._buffer = this._buffer.slice(1);
                    return pkt;
                }
                if (next_char == '[') {
                    if (!this._csi_regex) {
                        this._csi_regex = rgx(__makeTemplateObject(["\n                        ^                           # beginning of line\n                                                    #\n                                                    # First attempt\n                        (?:                         # legal sequence\n                          \u001B[                      # CSI\n                          ([<-?]?)              # private-mode char\n                          ([d;]*)                    # any digits or semicolons\n                          ([ -/]?               # an intermediate modifier\n                          [@-~])                # the command\n                        )\n                        |                           # alternate (second attempt)\n                        (?:                         # illegal sequence\n                          \u001B[                      # CSI\n                          [ -~]*                # anything legal\n                          ([\0-\u001F:])              # anything illegal\n                        )\n                    "], ["\n                        ^                           # beginning of line\n                                                    #\n                                                    # First attempt\n                        (?:                         # legal sequence\n                          \\x1b\\[                      # CSI\n                          ([\\x3c-\\x3f]?)              # private-mode char\n                          ([\\d;]*)                    # any digits or semicolons\n                          ([\\x20-\\x2f]?               # an intermediate modifier\n                          [\\x40-\\x7e])                # the command\n                        )\n                        |                           # alternate (second attempt)\n                        (?:                         # illegal sequence\n                          \\x1b\\[                      # CSI\n                          [\\x20-\\x7e]*                # anything legal\n                          ([\\x00-\\x1f:])              # anything illegal\n                        )\n                    "]));
                    }
                    var match = this._buffer.match(this._csi_regex);
                    if (match === null) {
                        pkt.kind = PacketKind.Incomplete;
                        return pkt;
                    }
                    if (match[4]) {
                        pkt.kind = PacketKind.ESC;
                        pkt.text = this._buffer.slice(0, 1);
                        this._buffer = this._buffer.slice(1);
                        return pkt;
                    }
                    if ((match[1] != '') || (match[3] != 'm'))
                        pkt.kind = PacketKind.Unknown;
                    else
                        pkt.kind = PacketKind.SGR;
                    pkt.text = match[2];
                    var rpos = match[0].length;
                    this._buffer = this._buffer.slice(rpos);
                    return pkt;
                }
                if (next_char == ']') {
                    if (len < 4) {
                        pkt.kind = PacketKind.Incomplete;
                        return pkt;
                    }
                    if ((this._buffer.charAt(2) != '8')
                        || (this._buffer.charAt(3) != ';')) {
                        pkt.kind = PacketKind.ESC;
                        pkt.text = this._buffer.slice(0, 1);
                        this._buffer = this._buffer.slice(1);
                        return pkt;
                    }
                    if (!this._osc_st) {
                        this._osc_st = rgxG(__makeTemplateObject(["\n                        (?:                         # legal sequence\n                          (\u001B\\)                    # ESC                           |                           # alternate\n                          (\u0007)                      # BEL (what xterm did)\n                        )\n                        |                           # alternate (second attempt)\n                        (                           # illegal sequence\n                          [\0-\u0006]                 # anything illegal\n                          |                           # alternate\n                          [\b-\u001A]                 # anything illegal\n                          |                           # alternate\n                          [\u001C-\u001F]                 # anything illegal\n                        )\n                    "], ["\n                        (?:                         # legal sequence\n                          (\\x1b\\\\)                    # ESC \\\n                          |                           # alternate\n                          (\\x07)                      # BEL (what xterm did)\n                        )\n                        |                           # alternate (second attempt)\n                        (                           # illegal sequence\n                          [\\x00-\\x06]                 # anything illegal\n                          |                           # alternate\n                          [\\x08-\\x1a]                 # anything illegal\n                          |                           # alternate\n                          [\\x1c-\\x1f]                 # anything illegal\n                        )\n                    "]));
                    }
                    this._osc_st.lastIndex = 0;
                    {
                        var match_1 = this._osc_st.exec(this._buffer);
                        if (match_1 === null) {
                            pkt.kind = PacketKind.Incomplete;
                            return pkt;
                        }
                        if (match_1[3]) {
                            pkt.kind = PacketKind.ESC;
                            pkt.text = this._buffer.slice(0, 1);
                            this._buffer = this._buffer.slice(1);
                            return pkt;
                        }
                    }
                    {
                        var match_2 = this._osc_st.exec(this._buffer);
                        if (match_2 === null) {
                            pkt.kind = PacketKind.Incomplete;
                            return pkt;
                        }
                        if (match_2[3]) {
                            pkt.kind = PacketKind.ESC;
                            pkt.text = this._buffer.slice(0, 1);
                            this._buffer = this._buffer.slice(1);
                            return pkt;
                        }
                    }
                    if (!this._osc_regex) {
                        this._osc_regex = rgx(__makeTemplateObject(["\n                        ^                           # beginning of line\n                                                    #\n                        \u001B]8;                    # OSC Hyperlink\n                        [ -:<-~]*       # params (excluding ;)\n                        ;                           # end of params\n                        ([!-~]{0,512})        # URL capture\n                        (?:                         # ST\n                          (?:\u001B\\)                  # ESC                           |                           # alternate\n                          (?:\u0007)                    # BEL (what xterm did)\n                        )\n                        ([!-~]+)              # TEXT capture\n                        \u001B]8;;                   # OSC Hyperlink End\n                        (?:                         # ST\n                          (?:\u001B\\)                  # ESC                           |                           # alternate\n                          (?:\u0007)                    # BEL (what xterm did)\n                        )\n                    "], ["\n                        ^                           # beginning of line\n                                                    #\n                        \\x1b\\]8;                    # OSC Hyperlink\n                        [\\x20-\\x3a\\x3c-\\x7e]*       # params (excluding ;)\n                        ;                           # end of params\n                        ([\\x21-\\x7e]{0,512})        # URL capture\n                        (?:                         # ST\n                          (?:\\x1b\\\\)                  # ESC \\\n                          |                           # alternate\n                          (?:\\x07)                    # BEL (what xterm did)\n                        )\n                        ([\\x21-\\x7e]+)              # TEXT capture\n                        \\x1b\\]8;;                   # OSC Hyperlink End\n                        (?:                         # ST\n                          (?:\\x1b\\\\)                  # ESC \\\n                          |                           # alternate\n                          (?:\\x07)                    # BEL (what xterm did)\n                        )\n                    "]));
                    }
                    var match = this._buffer.match(this._osc_regex);
                    if (match === null) {
                        pkt.kind = PacketKind.ESC;
                        pkt.text = this._buffer.slice(0, 1);
                        this._buffer = this._buffer.slice(1);
                        return pkt;
                    }
                    pkt.kind = PacketKind.OSCURL;
                    pkt.url = match[1];
                    pkt.text = match[2];
                    var rpos = match[0].length;
                    this._buffer = this._buffer.slice(rpos);
                    return pkt;
                }
            }
        };
        AnsiUp.prototype.ansi_to_html = function (txt) {
            this.append_buffer(txt);
            var blocks = [];
            while (true) {
                var packet = this.get_next_packet();
                if ((packet.kind == PacketKind.EOS)
                    || (packet.kind == PacketKind.Incomplete))
                    break;
                if ((packet.kind == PacketKind.ESC)
                    || (packet.kind == PacketKind.Unknown))
                    continue;
                if (packet.kind == PacketKind.Text)
                    blocks.push(this.transform_to_html(this.with_state(packet)));
                else if (packet.kind == PacketKind.SGR)
                    this.process_ansi(packet);
                else if (packet.kind == PacketKind.OSCURL)
                    blocks.push(this.process_hyperlink(packet));
            }
            return blocks.join("");
        };
        AnsiUp.prototype.with_state = function (pkt) {
            return { bold: this.bold, fg: this.fg, bg: this.bg, text: pkt.text };
        };
        AnsiUp.prototype.process_ansi = function (pkt) {
            var sgr_cmds = pkt.text.split(';');
            while (sgr_cmds.length > 0) {
                var sgr_cmd_str = sgr_cmds.shift();
                var num = parseInt(sgr_cmd_str, 10);
                if (isNaN(num) || num === 0) {
                    this.fg = this.bg = null;
                    this.bold = false;
                }
                else if (num === 1) {
                    this.bold = true;
                }
                else if (num === 22) {
                    this.bold = false;
                }
                else if (num === 39) {
                    this.fg = null;
                }
                else if (num === 49) {
                    this.bg = null;
                }
                else if ((num >= 30) && (num < 38)) {
                    this.fg = this.ansi_colors[0][(num - 30)];
                }
                else if ((num >= 40) && (num < 48)) {
                    this.bg = this.ansi_colors[0][(num - 40)];
                }
                else if ((num >= 90) && (num < 98)) {
                    this.fg = this.ansi_colors[1][(num - 90)];
                }
                else if ((num >= 100) && (num < 108)) {
                    this.bg = this.ansi_colors[1][(num - 100)];
                }
                else if (num === 38 || num === 48) {
                    if (sgr_cmds.length > 0) {
                        var is_foreground = (num === 38);
                        var mode_cmd = sgr_cmds.shift();
                        if (mode_cmd === '5' && sgr_cmds.length > 0) {
                            var palette_index = parseInt(sgr_cmds.shift(), 10);
                            if (palette_index >= 0 && palette_index <= 255) {
                                if (is_foreground)
                                    this.fg = this.palette_256[palette_index];
                                else
                                    this.bg = this.palette_256[palette_index];
                            }
                        }
                        if (mode_cmd === '2' && sgr_cmds.length > 2) {
                            var r = parseInt(sgr_cmds.shift(), 10);
                            var g = parseInt(sgr_cmds.shift(), 10);
                            var b = parseInt(sgr_cmds.shift(), 10);
                            if ((r >= 0 && r <= 255) && (g >= 0 && g <= 255) && (b >= 0 && b <= 255)) {
                                var c = { rgb: [r, g, b], class_name: 'truecolor' };
                                if (is_foreground)
                                    this.fg = c;
                                else
                                    this.bg = c;
                            }
                        }
                    }
                }
            }
        };
        AnsiUp.prototype.transform_to_html = function (fragment) {
            var txt = fragment.text;
            if (txt.length === 0)
                return txt;
            if (this._escape_for_html)
                txt = this.escape_txt_for_html(txt);
            if (!fragment.bold && fragment.fg === null && fragment.bg === null)
                return txt;
            var styles = [];
            var classes = [];
            var fg = fragment.fg;
            var bg = fragment.bg;
            if (fragment.bold)
                styles.push('font-weight:bold');
            if (!this._use_classes) {
                if (fg)
                    styles.push("color:rgb(" + fg.rgb.join(',') + ")");
                if (bg)
                    styles.push("background-color:rgb(" + bg.rgb + ")");
            }
            else {
                if (fg) {
                    if (fg.class_name !== 'truecolor') {
                        classes.push(fg.class_name + "-fg");
                    }
                    else {
                        styles.push("color:rgb(" + fg.rgb.join(',') + ")");
                    }
                }
                if (bg) {
                    if (bg.class_name !== 'truecolor') {
                        classes.push(bg.class_name + "-bg");
                    }
                    else {
                        styles.push("background-color:rgb(" + bg.rgb.join(',') + ")");
                    }
                }
            }
            var class_string = '';
            var style_string = '';
            if (classes.length)
                class_string = " class=\"" + classes.join(' ') + "\"";
            if (styles.length)
                style_string = " style=\"" + styles.join(';') + "\"";
            return "<span" + style_string + class_string + ">" + txt + "</span>";
        };
        ;
        AnsiUp.prototype.process_hyperlink = function (pkt) {
            var parts = pkt.url.split(':');
            if (parts.length < 1)
                return '';
            if (!this._url_whitelist[parts[0]])
                return '';
            var result = "<a href=\"" + this.escape_txt_for_html(pkt.url) + "\">" + this.escape_txt_for_html(pkt.text) + "</a>";
            return result;
        };
        return AnsiUp;
    }());
    function rgx(tmplObj) {
        var subst = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            subst[_i - 1] = arguments[_i];
        }
        var regexText = tmplObj.raw[0];
        var wsrgx = /^\s+|\s+\n|\s*#[\s\S]*?\n|\n/gm;
        var txt2 = regexText.replace(wsrgx, '');
        return new RegExp(txt2);
    }
    function rgxG(tmplObj) {
        var subst = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            subst[_i - 1] = arguments[_i];
        }
        var regexText = tmplObj.raw[0];
        var wsrgx = /^\s+|\s+\n|\s*#[\s\S]*?\n|\n/gm;
        var txt2 = regexText.replace(wsrgx, '');
        return new RegExp(txt2, 'g');
    }
//# sourceMappingURL=ansi_up.js.map
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = AnsiUp;
}));
webix.i18n.locales["ru-RU"].dpiui2 = {};

webix.i18n.locales["ru-RU"].dpiui2.AppView =
    {
        Title:"СКАТ DPI",
        "Hardware ssh terminal": "SSH терминал устройства",
        "Raw Gtp flow": "Сырой GTP флоу",
        "DPI control":"Управление DPI",
        "PCRF control":"Управление PCRF",
        "Performance":"Производительность",
        "Configuration":"Конфигурация",
        "Protocol prioritization (DSCP)":"Приоритизация по протоколам",
        "Priority for ASN":"Приоритизация по ASN",
        "Prioritization for autonomous systems (AS)":"Приоритизация для автономных систем (AS)",
        "Logs":"Логи",

        "Services control":"Управление услугами",
        "Subscribers and services":"Абоненты и услуги",
        "Subscribers":"Абоненты",
        "Services":"Услуги",
        "Tariff plans":"Тарифные планы",
        "Adv control": "Управление рекламой",

        "QoE analytics":"QoE аналитика",
        "QoE dashboard":"QoE дашборд",
        "Dashboard":"Дашборд",
        "Clickstream":"Кликстрим",
        "Netflow":"Нетфлоу",
        "GTP flow":"GTP флоу",
        "NAT flow":"NAT флоу",
        "Raw NAT flow":"Сырой NAT флоу",
        "Raw full netflow":"Сырой полный нетфлоу",
        "Raw clickstream":"Сырой кликстрим",
        "DDoS attacks":"DDoS атаки",
        "DDoS attacks log":"Лог DDoS атак",
        "Administrator":"Администратор",
        "Triggers & Alerts":"Триггеры и Нотификация",
        "Custom reports":"Спец. отчеты",
        "Raw DNS flow":"Сырой DNS флоу",
        "DNS flow":"DNS флоу",
        "My reports":"Мои отчеты",

        "Restart fastdpi":"Перезапуск fastdpi",
        "Updating hot options":"Обновление горячих параметров",
        "Updating options":"Обновление параметров",
        "Device information":"Информация об устройстве",
        "License information":"Информация о лицензии",
        "Select from list":"Выбрать из списка",
        "Managing the list of devices":"Управление списком оборудования",

        "My profile":"Мой профиль",
        "Users":"Пользователи",
        "Roles":"Роли",
        "Users actions log":"Журнал действий пользователей",
        "Managing users and roles":"Управление пользователями и ролями",
        "DPIUI2 (GUI) server configuration":"Конфигурация GUI",
        "QoE Stor (fastor) server configuration":"Конфигурация QoE Stor",
        "Server configuration":"Конфигурация сервера",

        "Lawful interception":"Законный перехват",

        "Log out":"Выход",
        "Logout":"Логаут",

        "Edit profile":"Редактирование профиля",
        "Username":"Имя пользователя",
        "Enter user name":"Введите имя пользователя",
        "Full name":"ФИО",
        "Last name First name Middle name":"Фамилия Имя Отчество полностью",
        "Enter your full name":"Введите ФИО полностью",
        "Position":"Должность",
        "Enter your position":"Введите должность",
        "Organization":"Организация",
        "Name of the organization":"Название организации",
        "Enter the name of the organization":"Введите название организации",
        "Enter your e-mail":"Введите e-mail",
        "Phone":"Телефон",
        "Contact number":"Контактный телефон",
        "Enter phone number":"Введите номер телефона",
        "Change password":"Смена пароля",
        "Old password":"Старый пароль",
        "Enter password":"Введите пароль",
        "New password":"Новый пароль",
        "Confirm password":"Подтвердить пароль",
        "Passwords do not match":"Пароли не совпадают",

        "Are you sure you want to restart the fastdpi process?":"Вы действительно хотите перезапустить fastdpi процесс?",
        "Are you sure you want to update the hot settings?":"Вы действительно хотите произвести обновление горячих параметров?",
        "Restart":"Перезапустить",
        "No equipment selected":"Не выбрано оборудование",

        "Name":"Название",
        "Port":"Порт",
        "Login":"Логин",
        "Can be controlled by other GUI":"Может управляться другими GUI",

        "Start fastdpi error": "Ошибка запуска FastDPI",
        "fastdpi is stopped": "FastDPI остановлен",
        "fastdpi остановлен": "FastDPI остановлен",
        "Many messages": "Несколько сообщений",
        "Several messages":"Несколько сообщений",

        "New version FastDPI is available": "Доступна новая версия FastDPI",
        "FastDPI is stopped":"FastDPI остановлен",

        "New GUI version is available": "Доступна новая версия GUI",
        "SSH connection error": "Ошибка SSH соединения",
        "Need to add dpui2 hardware": "Если выходите получать информацию о новых версиях, необходимо добавить ssh подключение к dpiui2.",
        "HotSpot": "ХотСпот",

        "Just close":"Просто закрыть",
        "Don't show again":"Не показывать снова",

        "In one of the sections of the program, we prepared a surprise. By clicking on one of the buttons in this section, you will receive a gift - the year of subscription to the dpiui2 Standart version.":"В одном из разделов программы мы подготовили сюрприз. Нажав на одну из кнопок в этом разделе, вы получите подарок - <b>год подписки на версию dpiui2 Standart</b>.",
        "Watch the Happy New Year video":"Смотрите видео C Новым Годом!",
        "Find a gift!":"Найдите подарок!",

        "Congratulations! You have found your gift!":"Поздравляем! Вы нашли свой подарок!",
        "You have one year of subscription to the dpiui2 Standart version! To take your gift complete the next form, please.":"У вас есть год подписки на стандартную версию dpiui2! Чтобы получить подарок, заполните следующую форму, пожалуйста.",

        "Are you shure you don`t want to take your gift?":"Вы уверены, что не хотите взять свой подарок?",
        "I don`t want":"Я не хочу",
        "I want my gift":"Я хочу свой подарок",

        "Fast PCRF (fastpcrf) server configuration": "Конфигурация Fast PCRF (fastpcrf)",
        "Fast PCRF (fastpcrf) logs": "Логи Fast PCRF (fastpcrf)",
        "Fast PCRF Config": "Конфигурация Fast PCRF",
        "Fast PCRF logs": "Логи Fast PCRF",
        "Gtp flow": "GTP флоу",
        "Subscriber synchronization process timeout - 10 minutes": "Таймаут процесса синхронизации абонентов – 10 мин",
        "DPIUI2 logs": "Логи GUI",
        "DPIUI2 (GUI) update": "Обновление GUI",
        "QoE Stor (fastor) logs": "Логи QoE Stor",
        "Traffic decode": "Разбор трафика",

        "Go to the section":"Перейти к разделу",
        "Choose device":"Выбор устройства",
        "Device not selected":"Оборудование не выбрано",
        "Online reports":"Онлайн отчеты",
        "Online netflow":"Онлайн нетфлоу",
        "Captcha configuration": "Конфигурация CAPTCHA",
        "Captcha logs": "Логи CAPTCHA",
        "CAPTCHA logs": "Логи CAPTCHA",
        "CAPTCHA language": "Язык CAPTCHA",
        "Spanish": "Испанский",
        "The current language of CAPTCHA image": "Текущий язык изображения CAPTCHA",
        "CAPTCHA encryption key": "Ключ шифрования CAPTCHA",
        "Encryption key for CAPTCHA": "Ключ шифрования для CAPTCHA",
        "Token salt for CAPTCHA": "Соль шифрования для CAPTCHA",
        "CAPTCHA image format": "Формат изображеня CAPTCHA",
        "PNG": "PNG",
        "JPEG": "JPEG",
        "The current format of CAPTCHA image": "Текущий формат изображения CAPTCHA",
        "CAPTCHA line width": "Расстояние между буквами CAPTCHA",
        "The current length of CAPTCHA image": "Текущее колличество символов в изображении CAPTCHA",
        "CAPTCHA scale": "Размер CAPTCHA",
        "CAPTCHA length": "Длина CAPTCHA",
        "CAPTCHA random": "Рандомизировать CAPTCHA",
        "The current scale of CAPTCHA image": "Текущий размер изображения CAPTCHA",
        "CAPTCHA image blur": "Размытие изображения CAPTCHA",
        "This option sets random chars of CAPTCHA image": "Данная опция задает случайные символы в изображении CAPTCHA",
        "Captcha template":"Темплейт CAPTCHA",
        "Reset template":"Сбросить темплейт",
        "Reload view":"Перезагрузить превью",
        "Are you sure you want to reset template?":"Вы уверены, что хотите сбросить темплейт?",
        "Are you sure you want to delete template?":"Вы уверены, что хотите удалить темплейт?",
        "CAPTCHA domain for cookie" : "CAPTCHA домен для куки",
        "CAPTCHA app language" : "Язык клиента CAPTCHA",
        "CAPTCHA app template" : "Темплейт клиента CAPTCHA",
        "CAPTCHA store" : "CAPTCHA хранилище",
        "CAPTCHA token salt" : "Соль шифрования токена CAPTCHA",
        "CAPTCHA font" : "CAPTCHA шрифт",
        "CAPTCHA app title" : "CAPTCHA заголовок приложения",
        "CAPTCHA redirect service" : "CAPTCHA сервис для перенаправления",
        "CAPTCHA redirect service url" : "CAPTCHA урл сервиса для перенаправления",
        "The current language of CAPTCHA app" : "Текущий язык клиента CAPTCHA",
        "The current template of CAPTCHA app" : "Текущий темплейт CAPTCHA",
        "The current store of CAPTCHA" : "Текущее хранилище CAPTCHA",
        "This option sets CAPTCHA font" : "Данная опция задает шрифт CAPTCHA",
        "The redirect service of CAPTCHA app" : "Сервис для перенаправления CAPTCHA",
        "The redirect service url of CAPTCHA app" : "Ссылка сервиса для перенаправления CAPTCHA",
        "Template clone":"Темплейт клон",
        "Template name":"Название темплейта",
        "Template saved":"Темплейт сохранен",
        "Enter template name":"Введите название темплейта",
        "Choose template clone":"Выберите название темплейта",
        "Connections":"Соединения",
        "Traffic control":"Управление трафиком",
        "Traffic capture":"Захват трафика",
        "Traffic generation":"Генерация трафика",
        "Blocking and redirection":"Блокирование и перенаправление",
        "Cloning a website":"Клонирование  веб-сайта",
        "Network utilities":"Сетевые утилиты",
        "Network audit":"Аудит сети",
        "Traffic decode logs": "Логи разбора трафика",
        "Health map":"Карта здоровья",
        "Chart type":"Тип графика",
        "Scale type":"Тип шкалы",
        "Chart step":"Шаг графика",
        "Group by":"Группировка по",
        "Order by":"Сортировка по",
        "Sort direction":"Направление сортировки",
        "Columns visibility":"Видимость колонок",
        "Items limit":"Лимит элементов",
        "Rows limit":"Лимит строк",
        "Hotkey":"Горячая клавиша",
        "Manual refresh":"Ручное обновление",
        "Auto refresh":"Авто обновленние",
        "Y axis detalization":"Детализация оси Y",
        "Series metrics":"Метрики серий",

        "Balancer server configuration": "Конфигурация IPFIX-балансира",
        "Balancer logs": "Логи IPFIX-балансира",

        "Mailing templates":"Шаблоны рассылок",
        "Edit":"Редактировать",

        "Auto":"Авто",
        "Low":"Низкая",
        "Medium":"Средняя",
        "High":"Высокая",

        "Ascending":"По возрастанию",
        "Descending":"По убыванию"
    };

webix.i18n.locales["ru-RU"].dpiui2.LoginView =
    {
        "Sign in to control panel CKAT DPI":"Войти в панель управления СКАТ",
        "Login":"Логин",
        "Enter login":"Введите логин",
        "Password":"Пароль",
        "Enter password":"Введите пароль",
        "Remember me":"Запомнить меня",
        "Sign in":"Войти"
    };

webix.i18n.locales["ru-RU"].dpiui2.Subscribers =
    {
        "List of subscribers":"Список абонентов",

        "Id":"Код",
        "Login":"Логин",
        "IP-address":"IP-адрес",
        "IP-address or IP-addresss range":"IP-адрес или блок IP-адресов",
        "Bind type":"Тип привязки",
        "Services":"Услуги",
        "Service":"Услуга",
        "Tariffs":"Тарифы",
        "Tariff":"Тариф",

        "Add subscriber":"Добавить абонента",

        "Enter IP-address":"Введите IP-адрес",
        "Enter login":"Введите логин",

        "Profile":"Профиль",

        "Enabled":"Подключена",

        "Subscriber":"Абонент",
        "Forced subscribers synchronization": "Принудительная синхронизация абонентов",
        "Forced synchronization subscribers running in the background": "Принудительная синхронизация абонентов запущенна в фоновом режиме",
        "No tariff": "Нет тарифа",
        "No services": "Нет сервисов",
        "Set up tariff for filtered subscribers": "Установка тарифа с использованием фильтра абонентов",
        "Tariff for filtered subscribers will be set up in the background": "Установка тарифа для отфильтрованных абонентов пройдет в фоновом режиме",
        "No profile":"Нет профиля",
        "Unknown": "Неизвестно",
        "In progress": "Ожидание ответа",
        "In progress ajb": "Передан в поток ajb",
        "Authorized": "Авторизован",
        "Unauthorized": "Неавторизован",
        "Auth status": "Статус авторизации",
        "Ping" : "Пинг",
        "Unavailable":"Недоступен",
        "Allowed": "Разрешен",
        "L2-props are not set":"L2-свойства не установлены",
        "Ping command options form": "Опции команды ping",
        "Address": "Адрес",
        "L2-settings": "L2-свойства",
        "Subscriber`s MAC-address": "MAC-адрес абонента",
        "Subscriber`s VLAN or QinQ": " VLAN или QinQ абонента",
        "DNA-interface index": "Индекс DNA-интерфейса",
        "Ping settings": "Свойства ping",
        "Ping number": "Число пингов",
        "Payload length": "Длина payload, байт",
        "TTL value": "Значение поля TTL",
        "Execute": "Выполнить",
        "Authorization": "Авторизация",
        "L2-props": "L2-свойства",
        "Are you sure you want to reset the authorization status of subscribers?": "Вы уверены, что хотите сбросить статус авторизации абонентов?",
        "The authorization status is set to \"unknown\", which will lead to L3-authorization request as the packet from the subscriber arrives.": "Статус авторизации устанавливается в \"unknown\", что приведет к отправке запроса L3-авторизации по приходе пакета от абонента.",
        "Expire at": "Срок действия, до",
        "Expired at": "Срок действия, до",
        "Undefined": "Неопределенный",
        "DHCP": "DHCP",
        "PPPoE": "PPPoE",
        "Gateway": "Шлюз",
        "ARP": "ARP",
        "L3": "L3",
        "Acquired": "Приобретен",
        "Released": "Выпущен",
        "Are you sure you want to delete the L2-props of subscribers?": "Вы уверены, что хотите удалить L2-свойства абонентов?",
        "This command actually removes the IP address from the internal database. To remove a specific subscriber property, use subs prop set.": "Эта команда фактичяески удаляет IP-адрес из внутренней БД. Для удаления конкретного свойства абонента используйте subs prop set.",
        "Sync L2-props": "Синхронизировать L2-свойства",
        "Options": "Свойства",
        "Session type": "Тип сессии",
        "Session status": "Статус сессии",
        "MAC address": "MAC адрес",
        "VLAN or QinQ": "VLAN или QinQ",
        "in_dev interface index": "Индекс in_dev интерфейса",
        "Expiration time": "Время окончания срока действия",
        "Output MAC address": "Выходной MAC адрес",
        "Output VLAN=NN": "Выходной VLAN=NN",
        "Disable local connect for subscriber": "Отключить локальное подключение для абонента",
        "IP options": "IP-свойства",
        "'route via' property": "Свойство 'route via'",
        "IPv4 subnet mask": "IPv4 маска подсети",
        "Opt82 CircuitId": "Opt82 CircuitId",
        "Opt82 RemoteId": "Opt82 RemoteId",
        "Do not save changes parameters in UDR": "Не сохранять изменения в UDR",
        "Last update": "Последнее обновление",
        "L2-props loaded": "L2-свойства загружены",
        "L2-props deleted": "L2-свойства удалены",
        "L2-props saved": "L2-свойства сохранены",
        "Auth state cleared": "Статус авторизации удален",
        "Auth state saved": "Статус авторизации сохранен",
        "Input valid MAC-address":  "Введите корректный MAC-адрес",
        "Set for selected": "Для выбранных",
        "Set for all": "Для всех",
        "Vchannels": "Каналы",
        "Disabled": "Не активирован",
        "There are no services or policing for subscriber!": "Абоненту не назначены услуги или тариф!",
        "Identity type": "Идентификатор",
        "Not valid form":"Неверно заполена форма",

        "List IP": "Список IP",
        "Extended": "Расширенный",
        "Group": "Группировка",

        "Element": "элемент",
        "Elements": "элемента",
        "ElementsMany": "элементов",
    };

webix.i18n.locales["ru-RU"].dpiui2.DpiPerformance =
    {
        "Online":"Онлайн",
        "Statistics":"Статистика",

        "Processors and memory":"Процессоры и память",
        "CPU usage (%)":"Использование процессоров (%)",
        "Memory usage (%)":"Использование памяти (%)",

        "User's<br/>processes (us)":"Пользовательские<br/>процессы (us)",
        "System<br/>processes (sy)":"Системные<br/>процессы (sy)",
        "Process<br/>fastdpi":"Процесс<br/>fastdpi",
        "Status<br/>idle (id)":"Бездействие<br/>системы (id)",

        "Operative<br/>memory (mem)":"Оперативная<br/>память (mem)",
        "Swap<br/>file":"Файл<br/>подкачки (swap)",
        "The process<br/>fastdpi (mem)":"Процесс<br/>fastdpi (mem)",

        "Idle state":"Бездействие системы (idle)",
        "Fastdpi process":"Процесс fastdpi",
        "User processes (us)":"Пользовательские процессы (us)",
        "System processes (sy)":"Системные процессы (sy)",

        "Operative memory (mem)":"Оперативная память (mem)",
        "Process fastdpi (mem)":"Процесс fastdpi (mem)",
        "Swap file":"Файл подкачки (swap)",

        "Top 30 processes":"Top 30 процессов",
        "Process Id":"Id процесса",
        "Process":"Процесс",

        "Processors usage (%)":"Использование процессоров (%)",
        "Memory usage (GB)":"Использование памяти (Гб)",
        "Virtual memory (virt)":"Виртуальная память (virt)",
        "Physical memory (res)":"Физическая память (res)",

        "HTTP statistics":"Статистика HTTP",
        "HTTP statistics (number of processed)":"Статистика HTTP (количество обработанных)",
        "HTTP statistics (number of blocked)":"Статистика HTTP (количество заблокированных)",

        "Network interfaces":"Сетевые интерфейсы",
        "Traffic on the interface":"Трафик на интерфейсе",

        "Received":"Получено",
        "Sent":"Отправлено",
        "Dropped":"Отброшено",
        "packages":"пакетов",
        "Nat statistics": "Статистика NAT",
        "Top pools": "Топ пулов",
        "Addresses": "Адреса",
        "Used" : "Используется",
        "Top profiles": "Топ профили",
        "Top pool/s": "Топ пулы",

        "For the correct display of traffic graphs by class, you need in the Configuration section":"Для корректного отображения графиков траффика по классам, нужно в разделе Конфигурация<br/><br/>1. Настроить параметр dbg_log_mask в разделе Трассировка<br/>2. Настроить Полисинг",
        "Open the Configuration section":"Открыть раздел Конфигурация",
            "Devices": "Устройства",
            "Device": "Устройство",
            "Status": "Состояние",

        "Units":"Единицы измерения",
        "Bytes":"Байты",
        "Packets":"Пакеты"
    };

webix.i18n.locales["ru-RU"].dpiui2.DpiConfig =
    {
        "Cancel": "Отменить",
        "Verify": "Проверить",
        "Verify and save": "Проверить и сохранить",
        "Save without verification": "Сохранить без проверки",
        "Incoming": "Входящий",
        "Outgoing": "Исходящий",
        "Upload from file": "Загрузить из файла",
        "Download from history": "Загрузить из истории",
        "Class": "Класс",
        "Back": "Назад",
        "Forward": "Вперед",
        "Configuration is correct": "Конфигурация верна",
        "Configuration saved": "Конфигурация сохранена",
        "Configuration loaded":"Конфигурация загружена",
        "Show comments":"Показать комментарии",
        "Show all params":"Показать все параметры",

        "Service reloaded successfully": "Сервис успешно перезагружен",
        "Are you sure you want to restart the DPI process?": "Вы уверены, что хотите перезагрузить процесс DPI?",
        "Are you sure you want to update the hot settings?": "Вы уверены, что хотите обновить горячие параметры?",
        "Restart DPI": "Перезапустить DPI",
        "Updating hot options": "Обновить горячие параметры",
        "Fast DPI config saved!": "Конфигурация Fast DPI сохранена!",
        "Update the hot parameters or restart Fast DPI for applying the changes!": "Обновите горячие параметры или перезапустите Fast DPI, чтобы изменения применились!",
        "Granted all privileges successfully": "Все привилегии успешно предоставлены",
        "Enter correct CIDR":"Введите корректный CIDR",
        "Enter correct Vchannel":"Введите корректный Vchannel",
        "Data is Invalid":"Некорректные данные"
    };

webix.i18n.locales["ru-RU"].dpiui2.DpiDscpConfig =
    {
        "Priority configuration":"Конфигурация приоритетов",
        "List of protocols and priorities":"Список протоколов и приоритетов",
        "Protocol":"Протокол",
        "The value of dscp":"Значение dscp",
        "CIDR list for AS":"Список CIDR для AS",
        "DSCP name":"Имя DSCP",
        "Binary value":"Двоичное значение",
        "Decimal value":"Десятичное значение",
        "Priority":"Приоритет",
        "Policing class":"Класс полисинга",
        "Dscp configuration saved":"Конфигурация dscp сохранена",
        "Dscp configuration loaded":"Конфигурация dscp загружена",
        "Group": "Группа",
        "Groups": "Группы",
        "No groups selected!": "Выберите группы!",
        "Set dscp for protocol groups": "Установить dscp для групп протоколов",
        "Set dscp value": "Установить значение dscp",
        "Show all protocols": "Отобразить все протоколы",
        "Add protocol or show all protocols": "Добавьте протокол или отобразите все протоколы",
        "List of protocols groups": "Список групп протоколов",
            "mixed": "смешанное"
    };

webix.i18n.locales["ru-RU"].dpiui2.DpiAsnDscpConfig =
    {
        "Configuration of AS and DSCP priorities":"Конфигурация AS и DSCP приоритетов",
        "AS resource list":"Список ресурсов AS",
        "AS number":"Номер AS",
        "List of AS and IP":"Список AS и IP",
        "List of AS and DSCP":"Список AS и Dscp",
        "Add AS":"Добавить AS",
        "Add CIDR":"Добавить CIDR",
        "Add DSCP":"Добавить Dscp",
        "DSCP list for AS":"Список Dscp для AS",
        "DSCP name":"Имя DSCP",
        "Binary value":"Двоичное значение",
        "Decimal value":"Десятичное значение",
        "Priority":"Приоритет",
        "Policing class":"Класс полисинга",
        "Asn dscp configuration saved":"Конфигурация asn dscp сохранена",
            "CIDR list for AS": "Список CIDR для AS",
            "List of IPv4 and AS": "Список IPv4 и AS",
            "List of IPv6 and AS": "Список IPv6 и AS"
    };

webix.i18n.locales["ru-RU"].dpiui2.All =
    {
        "Commands dictionaries  could not be loaded": "Не удалось загрузить справочник команд",
        "Can not connect to hardware": "Не удалось подключиться к устройству",
        "The configuration model could not be loaded": "Модель конфигурации не может быть загружена",
        "Yes":"Да",
        "No":"Нет",

        "No connection":"Нет соединения",
        "In developing":"В разработке",
        "Access denied":"Доступ запрещен",
        "No found":"Не найдено",

        "Russian":"Русский",
        "Rus.":"Рус.",
        "English":"Английский",
        "Eng.":"Англ.",

        "Refresh":"Обновить",
        "Cancel":"Отменить",
        "Delete":"Удалить",
        "Remove all":"Удалить все",
        "Close":"Закрыть",
        "Save":"Сохранить",
        "Add value":"Добавить значение",
        "Upload from file":"Загрузить из файла",
        "Download from history":"Загрузить из истории",
        "Saved":"Сохранено",
        "Deleted":"Удалено",
        "Removed":"Удалено",
        "Cleared": "Очищено",

        "Are you sure you want to delete the selected records?":"Вы действительно хотите удалить выбранные записи?",
        "Are you sure you want to delete the selected record?":"Вы действительно хотите удалить выбранную запись?",
        "Are you sure you want to remove all list items?":"Вы действительно хотите удалить все записи?",

        "The form":"Форма",
        "Editor":"Редактор",

        "Settings":"Настройки",

        "Click to download or drag a file": "Нажмите чтобы загрузить или перетащите сюда файл",
        "Apply": "Применить",
        "Applied": "Применено",
        "History": "История",
        "Could not upload file": "Не удалось загрузить файл",
        "Config": "Конфиг",

        "Back":"Назад",
        "Forward":"Вперед",

        "Date": "Дата",

        "Download the complete file":"Скачать файл",
        "Download zipped file":"Запаковать и скачать файл",

        "Error":"Ошибка",
        "Warning":"Предупреждение",
        "See logs":"Смотрите логи",

        "History loaded":"История загружена",
        "Verified":"Проверено",

        "Restart was successful":"Перезапуск произведен успешно",
        "Hot options updated":"Горячие параметры обновлены",

        "Parser error":"Ошибка парсера",

        "Total":"Всего",
        "Done":"Выполнено",

        "Period":"Период",
        "Interval":"Интервал",
        "1 second":"1 секунда",
        "5 seconds":"5 секунд",
        "10 seconds":"10 секунд",
        "15 seconds":"15 секунд",
        "30 seconds":"30 секунд",
        "0 minutes":"0 минут",
        "1 minute":"1 минута",
        "2 minutes":"2 минуты",
        "3 minutes":"3 минуты",
        "4 minutes":"4 минуты",
        "5 minutes":"5 минут",
        "6 minutes":"6 минут",
        "7 minutes":"7 минут",
        "8 minutes":"8 минут",
        "9 minutes":"9 минут",
        "10 minutes":"10 минут",
        "15 minutes":"15 минут",
        "30 minutes":"30 минут",
        "60 minutes":"60 минут",
        "1 hour":"1 час",
        "2 hours":"2 часа",
        "3 hours":"3 часа",
        "4 hours":"4 часа",
        "5 hours":"5 часов",
        "6 hours":"6 часов",
        "7 hours":"7 часов",
        "8 hours":"8 часов",
        "9 hours":"9 часов",
        "10 hours":"10 часов",
        "11 hours":"11 часов",
        "12 hours":"12 часов",
        "13 hours":"13 часов",
        "14 hours":"14 часов",
        "15 hours":"15 часов",
        "16 hours":"16 часов",
        "17 hours":"17 часов",
        "18 hours":"18 часов",
        "19 hours":"19 часов",
        "20 hours":"20 часов",
        "21 hours":"21 час",
        "22 hours":"22 часа",
        "23 hours":"23 часа",
        "24 hours":"24 часа",
        "1 day":"1 день",
        "2 days":"2 дня",
        "3 days":"3 дня",
        "4 days":"4 дня",
        "5 days":"5 дней",
        "6 days":"6 дней",
        "7 days":"7 дней",
        "30 days":"30 дней",
        "1 month":"1 месяц",
        "3 months":"3 месяца",
        "6 months":"6 месяцев",
        "1 year":"1 год",
        "Unlimited":"Неограниченно",

        "Bytes":"Байт",
        "Kb":"Кб",
        "Mb":"Мб",
        "Gb":"Гб",
        "Tb":"Тб",
        "Pb":"Pб",

        "Pkts":"Пак",
        "Kpkts":"КПак",
        "Mpkts":"МПак",
        "Gpkts":"ГПак",
        "Tpkts":"ТПак",
        "Ppkts":"ППак",

        "Bytes/s":"Байт/с",
        "Kb/s":"Кб/с",
        "Mb/s":"Мб/с",
        "Gb/s":"Гб/с",
        "Tb/s":"Тб/с",
        "Pb/s":"Пб/с",

        "Bit/s":"Бит/с",
        "Kbit/s":"Кбит/с",
        "Mbit/s":"Мбит/с",
        "Gbit/s":"Гбит/с",
        "Tbit/s":"Тбит/с",
        "Pbit/s":"Пбит/с",

        "Pkts/s":"Пак/с",
        "Kpkts/s":"Кпак/с",
        "Mpkts/s":"Мпак/с",
        "Gpkts/s":"Гпак/с",
        "Tpkts/s":"Тпак/с",
        "Ppkts/s":"Ппак/с",

        "ns":"нс",
        "µs":"мкс",
        "ms":"мс",
        "s":"с",
        "ks":"кс",
        "Ms":"Мс",
        "Gs":"Гс",
        "Ts":"Тс",

        "K":"Тыс.",
        "M":"Млн.",
        "G":"Млрд.",
        "T":"Трлн.",
        "Quad":"Квадрлн.",
        "Quint":"Квинтлн",
        "Sextil":"Cекстилн",

        "On":"Вкл.",
        "Off":"Выкл.",

        "min":"мин",
        "calls":"звонки",

        "Reset":"Сбросить",
        "By default":"По умолчанию",

        "Next":"Продолжить",

        "Page size":"Размер страницы",
        "Slide size":"Размер слайда",
        "Export":"Экспорт",
        "File name":"Имя файла",
        "Export format":"Формат экспорта",
        "Switch form?": "Переключить форму?",
        "There are unsaved changes. Are you sure you want to switch form?": "Есть несохраненные изменения.<br/>Вы уверены, что хотите переключить форму?",
        "Current changes have not been saved.":"Текущие изменения не сохранены.",
        "Save changes?":"Cохранить изменения?",
        "Switch": "Переключить",

        "Select":"Выбрать",

        "On page":"На странице",

        "Filter":"Фильтр",

        "Send":"Отправить",

        "Groups": "Группы",
        "Search": "Поиск",
        "Params": "Параметры",

        "Not":"Не",

        "From wich DPI device":"С какого устройства DPI",
        "Maximum report execution time":"Максимальное время выполнения отчета",

        "Row deleted successfully":"Строка успешно удалена",
        "Rows deleted successfully":"Строки успешно удалены",

        "Enable":"Включить",
        "Disable":"Выключить",

        "Required field" : "Обязательное поле",

        "Profile deleted": "Профиль удален",

        "chart":"график",

        "Description Category Host":"Описание категории хоста",
        "Description Protocols Groups":"Описание группы протоколов",

        "Copy of": "Копия",
        "Server error":"Ошибка сервера",

        "Link to wiki":"Ссылка на Wiki"
    };

webix.i18n.locales["ru-RU"].dpiui2.Dics =
    {
        "Pcap decode server": "Сервер разбора Pcap",
        "SSO authorization password": "Пароль для авторизации через SSO",
        "SSO authorization username": "Имя пользователя для авторизации через SSO",
        "SSO authorization host": "Хост для авторизации через SSO",
        "SSO authorization settings": "Настройки SSO-авторизации",
        "Enable SSO authorization": "Включение авторизации через SSO",
        "Ipfix lists upload path": "Путь для сохранения списков IPFIX",
        "Coordinates": "Координаты",
        "Bonus program": "Бонусная программа",
        "Advertising": "Реклама",
        "Ad blocking": "Блокировка рекламы",
        "Black list": "Чёрный список",
        "White list": "Белый список",
        "Black and white lists": "Черные и белые списки",
        "Announcement": "Уведомление",
        "Caching": "Кеширование",
        "Passed DDoS protection": "Пройдена DDoS защита",
        "Netflow stats": "Netflow статистика",
        "DDoS protection": "Защита от DDoS",
        "CGNAT": "CGNAT",
        "Notification": "Нотификация",

        "Without bind": "Без привязки",
        "Single": "Одиночная",
        "Multi": "Мульти",
        "Single: one IP - one login": "Одиночная: один IP - один логин",
        "Multi: multiple IP - one login": "Мульти: несколько IP - один логин",

        "Common": "Общие",
        "Filtering by blacklist": "Фильтрация по реестру запрещенных сайтов",
        "Collection and analysis of statistics on protocols and directions": "Сбор и анализ статистики по протоколам и направлениям",
        "Traffic priority marking depending on the protocol": "Разметка приоритета трафика в зависимости от протокола",
        "External channels' usage optimization": "Полисинг внешних каналов доступа",
        "Blocking and replacing advertising": "Блокировка и замена рекламы",
        "Whitelist and Captive Portal": "Белый список и Captive Portal",
        "Notification of subscribers": "Уведомление абонентов",
        "Protection from DoS and DDoS attacks": "Защита от DoS и DDoS атак",
        "Operator's LI": "Операторский LI",
        "System": "Системные",
        "Unknown parameters": "Неизвестные параметры",

        "UDP protocol detector (only_tcp)": "UDP протокол детектор (only_tcp)",
        "UDP (Torrent and other) detector is active": "Активен UDP (Torrent и тп) детектор",
        "UDP (Torrent and other) detector is not active": "Не активен UDP (Torrent и тп) детектор",

        "Use the internal database (udr)": "Использовать внутреннюю базу данных (udr)",
        "Use an internal database to preserve the state of services (udr)": "Использовать внутреннюю базу данных для сохранения состояния услуг (udr)",
        "Do not use internal database": "Не использовать внутреннюю базу данных",
        "Store state in internal database": "Сохранять состояние во внутренней базе данных",

        "Filtering control by registry (black_list_sm)": "Управление фильтрацией по реестру (black_list_sm)",
        "Enable filtering control by registry as a subscription service": "Включить управление фильтрацией по реестру в виде абонентской услуги",
        "Filtering is active for all subscribers": "Фильтрация активна для всех абонентов",
        "Only for subscribers with enabled filtering service": "Только для абонетов с подключенной услугой фильтрации",

        "Automatic loading of the registry from the cloud service (federal_black_list)": "Автоматическая загрузка реестра из облачного сервиса (federal_black_list)",
        "Enable automatic download and application of the registry from the cloud service (federal_black_list)": "Включить автоматическую загрузку и применение реестра из облачного сервиса (federal_black_list)",
        "Disabled. Use only local filter lists": "Отключена. Использовать только локальные списки фильтрации",
        "Enabled. Russian list": "Включена. Российский список",
        "Enabled. Private operator list from the cloud VE": "Включена. Приватный список оператора из облака VE",
        "Enabled. Belarusian list": "Включена. Белорусский список",
        "Enabled. Iraq list": "Включена. Иракский список",

        "Redirecting to a page (black_list_redirect)": "Переадресация на страницу (black_list_redirect)",
        "If this parameter is terminated with ? or & the UrlRedir parameter will be added to the resulting URL with the page where the user was directed": "Если данный параметр закончить на ? или & в результирующий URL будет добавлен параметр UrlRedir со указанием страницы, куда направлялся пользователь",
        "Enter the correct url": "Введите правильный url",

        "URL dictionary for HTTP blocking (custom_url_black_list)": "Словарь URL для блокирования по протоколу HTTP (custom_url_black_list)",
        "Enter the correct url or file path": "Введите правильный url или путь к файлу",

        "Dictionary of names for blocking HTTPS protocol by certificate (custom_cname_black_list)": "Словарь имен для блокирования протокола HTTPS по сертификату (custom_cname_black_list)",

        "Dictionary of IP-addresses for blocking the HTTPS protocol over IP (custom_ip_black_list)": "Словарь IP адресов для блокирования протокола HTTPS по IP (custom_ip_black_list)",

        "Dictionary of hosts names for blocking HTTPS by SNI (custom_sni_black_list)": "Словарь имен хостов для блокирования HTTPS по SNI (custom_sni_black_list)",

        "Frequency of checking the update of the blacklist in minutes (timeout_check_new_bl)": "Периодичность проверки обновления черного списка в минутах (timeout_check_new_bl)",
        "Frequency of checking blacklist updates in minutes (timeout_check_new_bl). The default is 60 minutes.": "Периодичность проверки обновления черного списка в минутах (timeout_check_new_bl). По умолчанию 60 минут.",
        "Enter the number": "Введите число",

        "The maximum number of profiles for blacklists (max_profiles_black_list)": "Максимальное количество профилей для черных списков (max_profiles_black_list)",
        "The maximum number of profiles for blacklists (max_profiles_black_list): 64 by default.": "Максимальное количество профилей для черных списков (max_profiles_black_list). По умолчанию 64.",

        "Enabling the collection and export of statistics (netflow)": "Включение сбора и экспорта статистики (netflow)",
        "Export statistics by protocols (port numbers)": "Экспорт статистики по протоколам (номерам портов)",
        "Export statistics by directions (numbers of autonomous systems)": "Экспорт статистики по направлениям (номерам автономных систем)",
        "Export billing statistics": "Экспорт статистики для биллинга",
        "Export of complete statistics for sessions": "Экспорт полной статистики по сессиям",
        "Name of the network interface that sends netflow with statistics (netflow_dev)": "Имя сетевого интерфейса, через который будет отправляться netflow со статистикой (netflow_dev)",
        "Network interface name (netflow_dev)": "Имя сетевого интерфейса (netflow_dev)",
        "Enter the interface": "Введите интерфейс",
        "Periodicity of data export in seconds (netflow_timeout)": "Периодичность экспорта данных в секундах (netflow_timeout)",
        "IP address of netflow collector with statistics by protocols (netflow_collector)": "IP адрес коллектора netflow со статистикой по протоколам (netflow_collector)",
        "IP address and port number of netflow collector with statistics by protocols (netflow_collector)": "IP адрес и номер порта коллектора netflow со статистикой по протоколам (netflow_collector)",
        "Enter the IP address and port number": "Введите IP адрес и номер порта",
        "Directions for collecting statistics and aggregation (netflow_as_direction)": "Направления сбора статистики и агрегации (netflow_as_direction)",
        "For external autonomous systems": "Для внешних автономных систем",
        "For internal autonomous systems": "Для внутренних автономных систем",
        "IP address of the netflow collector with statistics by directions (netflow_as_collector)": "IP адрес коллектора netflow со статистикой по направлениям (netflow_as_collector)",
        "IP address and port number of the netflow collector with direction statistics (netflow_as_collector)": "IP адрес и номер порта коллектора netflow со статистикой по направлениям (netflow_as_collector)",
        "IP address of netflow collector with statistics for billing (netflow_bill_collector)": "IP адрес коллектора netflow со статистикой для биллинга (netflow_bill_collector)",
        "IP address and port number of the netflow collector with statistics for billing (netflow_bill_collector)": "IP address and port number of the netflow collector with statistics for billing (netflow_bill_collector)",
        "Payload accounting method (netflow_bill_method)": "Метод учета полезной нагрузки (netflow_bill_method)",
        "Only consider the payload (netflow_bill_method)": "Учитывать только полезную нагрузку (netflow_bill_method)",
        "Consider the full volume, including package headers": "Учитывать полный объем, включая заголовки пакетов",
        "Only payload": "Только полезную нагрузку",
        "The export format for the complete netflow (netflow_full_collector_type)": "Формат экспорта полного netflow (netflow_full_collector_type)",
        "Managing the export format for a complete netflow (netflow_full_collector_type)": "Управление форматом экспорта полного netflow (netflow_full_collector_type)",
        "Netflow5 format export": "Экспорт в формате netflow5",
        "Export ipfix to udp header": "Экспорт IPFIX на udp коллектор",
        "Export ipfix to tcp header": "Экспорт IPFIX на tcp коллектор",
        "IP address of the netflow collector with full statistics (netflow_full_collector)": "IP адрес коллектора netflow с полной статистикой (netflow_full_collector)",
        "IP address and port number of the netflow collector with full statistics (netflow_full_collector)": "IP адрес и номер порта коллектора netflow с полной статистикой (netflow_full_collector)",
        "Inactive session timeout in seconds (netflow_passive_timeout)": "Таймаут неактивной сессии в секундах (netflow_passive_timeout)",
        "The time in seconds after which the non-active session is considered complete (netflow_passive_timeout)": "Время в секундах, после которого не активная сессия считается завершенной (netflow_passive_timeout)",
        "Timeout of the active session in seconds (netflow_active_timeout)": "Таймаут активной сессии в секундах (netflow_active_timeout)",
        "The length of the fragment for a long session in seconds (netflow_active_timeout)": "Продолжительность фрагмента для длительной сессии в секундах (netflow_active_timeout)",
        "Send information about protocols in the port number (netflow_full_port_swap)": "Передавать информацию о протоколах в номере порта (netflow_full_port_swap)",
        "Keep original port numbers": "Cохранять оригинальные номера портов",
        "Send information about protocols in the port number": "Передавать информацию о протоколах в номере порта",
        "The maximum netflow in Mbit/s (netflow_rate_limit)": "Максимальный поток netflow в Мбит/c (netflow_rate_limit)",
        "Priority traffic markup (set_packet_priority)": "Приоритетная разметка трафика (set_packet_priority)",
        "Enable priority traffic markup (set_packet_priority)": "Включить приоритетную разметку трафика (set_packet_priority)",
        "At the IP header level": "На уровне заголовка IP",
        "At the VLAN/QinQ header level": "На уровне заголовка VLAN/QinQ",
        "At the MPLS header level": "На уровне заголовка MPLS",
        "Policing type (policing_type)": "Тип полисинга (policing_type)",
        "TBF Class [number] for outbound traffic": "TBF Класс [number] для исходящего трафика",
        "TBF Class [number] for inbound traffic": "TBF Класс [number] для входящего трафика",
        "HTB Class [number] for outbound traffic": "HTB Class [number] for outbound traffic",
        "HTB Class [number] for inbound traffic": "HTB Class [number] for inbound traffic",
        "The content server (ad_server)": "Cервер контента (ad_server)",
        "The content server (cp_server)": "Cервер контента (cp_server)",
        "The content server (ntf_server)": "Cервер контента (ntf_server)",
        "The name or address of the server where the information page is located (cp_server)": "Имя или адрес сервера, на котором размещена информационная страница (cp_server)",
        "The name or address of the server where the information page is located (ntf_server)": "Имя или адрес сервера, на котором размещена информационная страница (ntf_server)",
        "Enter the server name or address": "Введите имя или адрес сервера",
        "The name or address of the server from which new content is delivered (ad_server)": "Имя или адрес сервера, с которого производится доставка нового контента (ad_server)",
        "Logging of protection triggering (syncf_trace)": "Логгирование срабатывания защиты (syncf_trace)",
        "The sync per second threshold (syncf_threshold)": "Порог количества syn в секунду (syncf_threshold)",
        "The threshold of the amount of syn per second (without confirmation), when we consider that everything is normal (by default 50)": "Порог кол-ва syn в секунду (без подтверждения), когда считаем, что все нормально ( по умолчанию 50 )",
        "The interval of checking the amount of syn in milliseconds (syncf_check_tmout)": "Интервал в миллисекундах проверки количества syn (syncf_check_tmout)",
        "The interval of checking the number of syn and confirmed syn in milliseconds(by default 100)": "Интервал в миллисекундах проверки кол-ва syn и подтвержденных syn ( по умолчанию 100 )",
        "Media server (cache_server)": "Медиа сервер (cache_server)",
        "IP address or domain name of the media server": "IP адрес или доменное имя медиасервера",
        "Directions for which statistics are collected and aggregation (netflow_as_direction)": "Направления по которым производится сбор статистики и агрегация (netflow_as_direction)",
        "Protection mode (syncf_protection)": "Режим защиты (syncf_protection)",
        "Enable protection mode (syncf_protection)": "Активировать режим защиты (syncf_protection)",
        "Security off": "Защита выключена",
        "Automatically activated": "Активируется автоматически",
        "Always enabled": "Включена всегда",
        "Logging of protection triggering 0 / 1 - no / yes ( by default 0 ) (syncf_trace)": "Логгирование срабатывания защиты 0 / 1 - нет / да ( по умолчанию 0 ) (syncf_trace)",
        "Logging disabled": "Логирование отключено",
        "Logging enabled": "Логирование включено",
        "The time interval for monitoring the response to syn+ack (syncf_tracking_packs_time)": "Интервал времени мониторинга ответа на syn+ack(syncf_tracking_packs_time)",
        "The time interval in seconds of monitoring the response to syn + ack, generated by CKAT (by default 60)": "Интервал времени в секундах мониторинга ответа на syn+ack, сформированного скат ( по умолчанию 60 )",
        "Protected port numbers (syncf_ports)": "Защищаемые номера портов (syncf_ports)",
        "Protected port numbers (by default 80, can be changed online)": "Защищаемые номера портов ( по умолчанию 80 , можно менять online )",
        "Enter the port numbers through the colon": "Введите номера портов через двоеточие",
        "The percentage of unconfirmed queries for activating protection (syncf_unconfirmed_percent)": "Процент неподтвержденных запросов для активации защиты (syncf_unconfirmed_percent)",
        "The percentage of unconfirmed requests from the client, in which the protection is automatically activated (by default 5, can be changed online)": "Процент неподтвержденных запросов со стороны клиента, при котором защита автоматически активируется ( по умолчанию 5 , можно менять online )",
        "CAPTCHA page (ddos_check_server)": "Страничка с CAPTCHA (ddos_check_server)",
        "Page with CAPTCHA, to which redirection is performed for verification (ddos_check_server)": "Страничка с CAPTCHA, на которую производится перенаправление для проверки (ddos_check_server)",
        "Number of requests per second in normal operation (ddos_reqsec_threshold)": "Количество запросов в секунду при нормальной работе (ddos_reqsec_threshold)",
        "The number of requests per second that comes to the protected site during normal operation (ddos_reqsec_threshold)": "Количество запросов в секунду, приходящее на защищаемый сайт при нормальной работе (ddos_reqsec_threshold)",
        "The percentage of possible rejection of requests during normal operation of the site (ddos_reqsec_variation)": "Процент возможного отклонения запросов при нормальной работе сайта (ddos_reqsec_variation)",
        "The percentage of possible rejection of requests from the site specified in the normal operation (ddos_reqsec_variation)": "Процент возможного отклонения запросов от заданного в нормальной работе сайта (ddos_reqsec_variation)",
        "Number of packets per second in normal operation (ddos_pktsec_threshold)": "Количество пакетов в секунду при нормальной работе (ddos_pktsec_threshold)",
        "The number of packets per second that comes to the protected site during normal operation (ddos_pktsec_threshold)": "Количество пакетов в секунду, приходящее на защищаемый сайт при нормальной работе (ddos_pktsec_threshold)",
        "Percentage of possible deviation of packets during normal operation of the site (ddos_pktsec_variation)": "Процент возможного отклонения пакетов при нормальной работе сайта (ddos_pktsec_variation)",
        "The percentage of possible deviation of packets from the site specified in the normal operation (ddos_pktsec_variation)": "Процент возможного отклонения пакетов от заданного в нормальной работе сайта (ddos_pktsec_variation)",
        "Reserve memory for buffer (ajb_reserved)": "Зарезервировать память под буфер (ajb_reserved)",
        "Enabled": "Включено",
        "Disabled": "Отключено",
        "If enabled, the memory for the write buffer is reserved in advance (at the start of DPI) and it becomes possible to activate and stop the data record instantly by changing the value of the parameters ajb_save_url, ajb_save_udpi and ajb_save_ip": "Если включено, то память под буфер записи резервируется заранее (при старте DPI) и становиться возможным активировать и останавливать запись данных на лету, изменяя значение параметров ajb_save_url, ajb_save_udpi и ajb_save_ip",
        "Activate the traffic record according to the list of protocols (ajb_save_udpi)": "Активировать запись трафика по списку протоколов (ajb_save_udpi)",
        "List of recorded protocols (ajb_save_udpi_proto)": "Cписок записываемых протоколов (ajb_save_udpi_proto)",
        "List (through the colon) of recorded protocols in the form of test or digital identifiers (ajb_save_udpi_proto)": "Cписок (через двоеточие) записываемых протоколов в виде тестовых или цифровых идентификаторов (ajb_save_udpi_proto)",
        "Placement of files with a record (ajb_udpi_path)": "Место размещения файлов с записью (ajb_udpi_path)",
        "Placement of files with a record (by default /var/dump/dpi)": "Место размещения файлов с записью (по умолчанию /var/dump/dpi)",
        "Enter the path to the file": "Введите путь к файлу",
        "Enable recording of traffic by IP or CIDR (ajb_save_ip)": "Активировать запись трафика по IP или CIDR (ajb_save_ip)",
        "Activate the recording of traffic by IP or CIDR (0.0.0.0/0 - to record all traffic)": "Активировать запись трафика по IP или CIDR (0.0.0.0/0 - для записи всего трафика)",
        "Enter the IP address or CIDR": "Введите IP адрес или CIDR",
        "Activate the record of HTTP metadata (ajb_save_url)": "Активировать запись метаданных HTTP (ajb_save_url)",
        "List of recorded metadata (ajb_save_url_format)": "Cписок записываемых метаданных (ajb_save_url_format)",
        "Placement of files with metadata records (ajb_url_path)": "Место размещения файлов с записью метаданных (ajb_url_path)",
        "The name of the network interface for sending clickstream via ipfix (ipfix_dev)": "Имя сетевого интерфейса для отправки clickstream через IPFIX (ipfix_dev)",
        "IP or the domain name (: port) of the ipfix collector clickstream (ipfix_udp_collectors)": "IP или доменное имя (:порт) коллектора IPFIX clickstream (ipfix_udp_collectors)",
        "IP or the domain name (: port) of the ipfix collector clickstream (ipfix_tcp_collectors)": "IP или доменное имя (:порт) коллектора IPFIX clickstream (ipfix_tcp_collectors)",
        "IP or the domain name (: port) of the ipfix collector meta clickstream (ipfix_meta_udp_collectors)": "IP или доменное имя (:порт) коллектора IPFIX meta clickstream (ipfix_meta_udp_collectors)",
        "IP or the domain name (: port) of the ipfix collector meta clickstream (ipfix_meta_tcp_collectors)": "IP или доменное имя (:порт) коллектора IPFIX meta clickstream (ipfix_meta_tcp_collectors)",
        "IP or the domain name (: port) of the clickstream header ipfix. You can specify several collectors separated by a comma.": "IP или доменное имя (:порт) коллектора IPFIX clickstream. Можно задать несколько коллекторов через запятую.",
        "IP or the domain name (: port) of the meta clickstream header ipfix. You can specify several collectors separated by a comma.": "IP или доменное имя (:порт) коллектора IPFIX meta clickstream. Можно задать несколько коллекторов через запятую.",
        "Unique domain (id) for the recognition by the collector (ipfix_observation)": "Уникальный домен (id) для распознавания коллектором (ipfix_observation)",
        "Incoming interfaces (in_dev, to subscribers)": "Интерфейсы входящие (in_dev, к абонентам )",
        "Entered through the ':' or '|' (for clusters separation). Example: dna0:dna2:dna4 or dna0|dna2|dna4": "Вводятся через ':' или '|' (для разделения кластеров). Пример: dna0:dna2:dna4 или dna0|dna2|dna4",
        "Entered through the ':' or '|' (for clusters separation). Example: dna1:dna3:dna5 or dna1|dna3|dna5": "Вводятся через ':' или '|' (для разделения кластеров). Пример: dna1:dna3:dna5 или dna1|dna3|dna5",
        "List the interfaces separating by : or | (for clusters separation)": "Перечислите интерфейсы разделяя через : или | (для разделения кластеров)",
        "Outgoing interfaces (out_dev, Internet)": "Интерфейсы исходящие (out_dev, в Интернет )",
        "Interface for sending responses in the traffic mirroring mode (tap_dev)": "Интерфейс для отправки ответов в режиме зеркалирования трафика (tap_dev)",
        "Disassembling of the PPTP / L2TP / GRE / IPIP tunnels (check_tunnels)": "Разбор туннелей PPTP/L2TP/GRE/IPIP (check_tunnels)",
        "DPI management port (ctrl_port)": "Порт для управления DPI (ctrl_port)",
        "DPI management port: fdpi_ctrl utility (ctrl_port)": "Порт для управления DPI: утилита fdpi_ctrl (ctrl_port)",
        "DPI management interface (ctrl_dev)": "Интерфейс для управления DPI (ctrl_dev)",
        "DPI management interface: fdpi_ctrl utility (ctrl_dev)": "Интерфейс для управления DPI: утилита fdpi_ctrl(ctrl_dev)",
        "Configuring the log output (dbg_log_mask)": "Конфигурирование вывода лога (dbg_log_mask)",
        "Configuring the output of the log (0x80 output to the log ipfix stats) (dbg_log_mask)": "Конфигурирование вывода лога (0x80 выводить в лог IPFIX stats) (dbg_log_mask)",
        "Asymmetric (or mixed) operation DPI mode (asym_mode)": "Асимметричный (или смешанный) режим работы DPI (asym_mode)",
        "DPI packets sending direction(emit_direction)": "Направление отправки DPI пакетов (emit_direction)",
        "In which interface to send DPI-generated packets (emit_direction)": "В какой интерфейс отправлять генерируемые DPI пакеты (emit_direction)",
        "Send the package to the interface through which the package came to, to which we respond (by default)": "Отправлять пакет в интерфейс, через который пришел пакет, на который мы отвечаем (по умолчанию)",
        "Send packets to the in_dev interface": "Отправлять пакеты в интерфейс in_dev",
        "Send packets to the out_dev interface": "Отправлять пакеты в интерфейс out_dev",
        "Traffic mode (tap_mode)": "Режим работы с трафиком (tap_mode)",
        "Traffic transmission normal mode": "Обычный режим работы пропуска трафика",
        "Passive mode (without out_dev/tap_dev)": "Пассивный режим (без использования out_dev/tap_dev)",
        "Use tap_dev to send answers to the subscriber": "Использовать tap_dev для отправки ответов абоненту",
        "Managing the work with tagged traffic (strip_tap_tags)": "Управление работы с тэгированным трафиком (strip_tap_tags)",
        "Management of working with tagged traffic (0 - Save TAG, 1 - Delete TAG)": "Управление работы с тэгированным трафиком (0 - Сохранять ТЭГ, 1 - Удалять ТЭГ)",
        "Disabled (Save TAG)": "Отключено (Сохранять ТЭГ)",
        "Enabled (Delete TAG)": "Включено (Удалять ТЭГ)",
        "out_dev card MAC address(replace_source_mac)": "MAC адрес карты out_dev (replace_source_mac)",
        "Enter the MAC address": "Введите MAC адрес",
        "Router MAC address(replace_destination_mac)": "MAC адрес маршрутизатора (replace_destination_mac)",
        "Number of repetitions (duplicates) of a package with a redirect or blocking (emit_duplication)": "Кол-во повторов (дублей) пакета с редиректом или блокировкой  (emit_duplication)",
        "Number of repetitions (duplicates) of a package with a redirect or blocking (emit_duplication) when the platform is connected in the mode of processing the mirrored traffic": "Кол-во повторов (дублей) пакета с редиректом или блокировкой  (emit_duplication) при подключении платформы в режиме обработки зеркалированного трафика",
        "The MAC address of the out_dev card when the platform is connected in the mode of processing the mirrored traffic. in_dev receive a traffic mirror, and out_dev is connected to a router that receives and forwards replies to subscribers and to the Internet": "MAC адрес карты out_dev при подключении платформы в режиме обработки зеркалированного трафика. in_dev принимают зеркало трафика, а out_dev подключен к маршрутизатору, который принимает и перенаправляет ответы абонентам и в инет",
        "MAC address of the router (or routing switch) when the platform is connected in the mode of mirrored traffic processing": "MAC адрес маршрутизатора (или маршрутизирующего коммутатора) при подключении платформы в режиме обработки зеркалированного трафика",
        "Vertical scale (scale_factor)": "Вертикальный масштаб  (scale_factor)",
        "The value of the parameter is approximately equal to the overall channel width and varies in the range of 1-10 (1 for 1G, 10 for 10G and higher)": "Значение параметра примерно равно общей ширине каналов и изменяется в диапазоне 1-10 (1 - для канала 1G, 10 для 10G и выше)",
        "Timer for troubleshooting (timeout_check_dev)": "Таймер проверки неисправности (timeout_check_dev)",
        "Number of queues (num_threads)": "Количество очередей (num_threads)",
        "Trace session by IP (trace_ip)": "Трассировка сессии по IP (trace_ip)",
        "Enter the IP address": "Введите IP адрес",
        "Tracing of subscriber bandwidth restriction by IP (plc_trace_ip)": "Трассировка ограничения абонетской полосы по IP (plc_trace_ip)",
        "The asn dscp configuration is loaded": "Конфигурация asn dscp загружена",
        "The asn dscp configuration is saved": "Конфигурация asn dscp сохранена",
        "History loaded": "История загружена",
        "Hardware Management": "Управление оборудованием",
        "DPI Management / Performance and Statistics": "Управление DPI / Производительность и статистика",
        "DPI Management / Configuration": "Управление DPI / Конфигурация",
        "DPI Management / Logs": "Управление DPI / Логи",
        "Service management / Subscribers": "Управление услугами / Абоненты",
        "Service Management / Services": "Управление услугами / Услуги",
        "Service management / Tariffs": "Управление услугами / Тарифы",
        "Service management / Advertising controll": "Управление услугами / Управление рекламой",
        "QoE analytics": "QoE аналитика",
        "Companies": "Компании",
        "Users": "Пользователи",
        "Roles": "Роли",
        "Send Error": "Отправить ошибку",
        "Sites classifier": "Классификатор сайтов",
        "Sites classifier model": "Модель классификатора сайтов",
        "Sites classifier admin": "Администирирование классификатора сайтов",
        "Error message": "Сообщение об ошибке",
        "Question": "Вопрос",
        "Sentence": "Предложение",
        "Message": "Сообщение",
        "Introduced": "Введена",
        "Waiting": "Ожидает",
        "Active": "Активна",
        "Completed": "Завершена",
        "Bps": "Бит/с",
        "Kbps": "Кбит/с",
        "Mbps": "Мбит/с",
        "Gbps": "Гбит/с",
        "Bit": "Бит",
        "Kbit": "Кбит",
        "Mbit": "Мбит",
        "Gbit": "Гбит",
        "Mon": "Пн",
        "Tue": "Вт",
        "Wed": "Ср",
        "Thu": "Чт",
        "Fri": "Пт",
        "Sat": "Сб",
        "Sun": "Вс",
        "Profile [number]": "Профиль [number]",
        "Group [number]": "Группа [number]",
        "By default, dpi does not parse the tunnels, since traffic from different operators or clients with conflicting IP sets can be transmitted in tunnels but for non-standard connection (up to BRAS), tunneling is necessary.": "По умолчанию dpi не разбирает туннели, так как в туннелях может передаваться трафик разных операторов или клиентов с конфликтующим набором IP, но при нестандартном подключении (до BRAS) разбор туннелей необходим.",

        "https://wiki.vasexperts.com/doku.php?id=start": "https://wiki.vasexperts.ru/doku.php?id=start",
        "https://wiki.vasexperts.com/doku.php?id=dpi:install_point_scat:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:install_point_scat",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:platform:dpi_config:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_components:platform:dpi_config",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_filtration:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:base_functionality:opt_filtration",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_statistics:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:base_functionality:opt_statistics",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_priority:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:base_functionality:opt_priority",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_shaping:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:base_functionality:opt_shaping",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_advertising:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:base_functionality:opt_advertising",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_capture:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:base_functionality:opt_capture",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_notify:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:base_functionality:opt_notify",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:extra_functionality:opt_cache:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:extra_functionality:opt_cache",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_ddos:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:base_functionality:opt_ddos",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_li:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:base_functionality:opt_li",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_filtration:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_filtration",

        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_statistics:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_statistics",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_priority",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_shaping:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_shaping",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_advertising:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_advertising",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_capture:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_capture",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_notify:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_notify",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_cache:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_cache",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_ddos:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_ddos",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_li:start":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_li",

        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:priority_config:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_priority:priority_config",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:priority_config_as:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_priority:priority_config_as",
        "Inactive": "Не активная",
        "Ready": "Подготовлена",
        "Subscriber.Inactive": "Не активен",
        "Subscriber.Introduced": "Введен",
        "Subscriber.Ready": "Готов",
        "Subscriber.Active": "Активен",
        "Subscriber.Completed": "Завершен",
        "Subscriber.Error": "Ошибка",
        "Campaign is stopped (default)": "Кампания остановлена (по умолчанию)",
        "Campaign started": "Кампания запущена",
        "Named tariff": "Профиль",
        "Personal tariff": "Индивидуальный",
        "Named tariff assigned to a group of subscribers": "Именованный тариф назначенный на группу абонентов",
        "Unnamed tariff assigned personally to the subscriber": "Неименованный тариф назначенный персонально на абонента",
        "Mini Firewall": "Мини Файрвол",

        "Subscriber CIDRs": "Абонентские подсети",
        "All QoE statistics will be filtered by this parameter": "Вся статистика QoE будет отфильтрована по этому параметру. Используйте запятую, чтобы добавить несколько значений.",
        "Channel numbers are indicated. If channel names are used in statistics, you must specify names, not numbers.":"Указываются номера каналов. В случае, если используются имена каналов в статистике, необходимо задать имена, а не номера.",

        "Network interfaces work mode": "Режим работы сетевых интерфейсов",
        "PCAP Recording, IPFIX Export (Clickstream and metadata: SIP, FTP)": "Запись PCAP, экспорт IPFIX (Кликстрим и метаданные: SIP, FTP)",
        "Trace": "Трассировка",

        "Subscriber logins": "Логины абонентов",
        "Set to see triggers of all users or not. You can see only triggers of your own by default.": "Установите, чтобы видеть триггеры всех пользователей. По умолчанию вы можете видеть только свои собственные триггеры.",

        "FastDPI server": "FastDPI сервер",
        "FastPCRF server":"FastPCRF сервер",
        "DPIUI2 server (GUI)": "DPIUI2 сервер (GUI)",
        "HOTSPOT server": "ХОТСПОТ сервер",
        "QoE Stor server": "QoE Stor сервер",
        "Traffic generator server": "Сервер генерации трафика",
        "Sites cloning server": "Сервер клонирования сайтов",
        "Network audit server": "Сервер аудита сети",

        "DB (MySql) connection": "Подключение к БД MySql",
        "SMTP settings": "Настройки SMTP",
        "QoE Stor: DB (Clickhouse) connection": "QoE Stor: Соединение с БД (Clickhouse)",
        "Jobs intervals and periods": "Интервалы джобов",
        "Application URL": "Урл приложения",
        "QoE Stor: DB lifetime settings": "QoE Stor: Настройки времени жизни БД",
        "QoE Stor: Discs settings":"QoE Stor: Настройки дисков",

        "Environment": "Окружение",
        "Local": "Локальное",
        "Production": "Продакшн",
        "Development": "Разработка",
        "The current application environment.": "Текущее окружение приложения.",
        "<b>Do not change this setting</b>. This can lead to unpredictable behavior.": "<b>Не меняйте эту настройку</b>. Это может привести к непредсказуемому поведению.",
        "Application debug": "Отладка приложения",
        "When an exception is uncaught and the APP_DEBUG environment variable is true, the debug page will show all environment variables and their contents. In some cases you may want to obscure certain variables.": "Если исключение не обработано, а переменная среды APP_DEBUG имеет значение true, на странице отладки будут показаны все переменные среды и их содержимое.",
        "Encryption key": "Ключ шифрования",
        "Session and cookie encryption key. If this is empty, the key is generated automatically.": "Сеанс и ключ шифрования cookie. Если он пуст, ключ генерируется автоматически.",
        "Application timezone": "Часовой пояс приложения",
        "UTC by default.": "UTC по умолчанию.",
        "VAS Cloud host": "Хост VAS Cloud",
        "App cache driver": "Драйвер кеша",
        "App queue driver": "Драйвер очереди",
        "App session driver": "Драйвер сессии",

        "DB connection type": "Тип подключения к БД",
        "DB host": "Хост БД",
        "DB port": "Порт БД",
        "DB name": "Имя БД",
        "DB username": "Имя пользователя БД",
        "DB password": "Пароль БД",

        "SMTP host":"Хост SMTP",
        "SMTP port":"Порт SMTP",
        "SMTP encryption type":"Тип шифрования SMTP",
        "SMTP username":"Имя пользователя SMTP",
        "SMTP password":"Пароль SMTP",
        "Tech. support email":"E-mail тех. поддержки",
        "Send copy to":"Отправлять копию",
        "From field":"Поле От",
        "Sender":"Отправитель",
        "If empty, value of CFG_SMTP_UNAME is used by default":"Если пусто, по умолчанию используется значение CFG_SMTP_UNAME",

        "Test email settings":"Тестирование email",
        "Send test email to address:":"Отправить тестовое письмо на адрес:",
        "Email subject":"Тема письма:",
        "Email body:":"Текст письма:",
        "Send test email":"Отправить тестовое письмо",
        "Test email was sent successfully.":"Тестовое письмо успешно отправлено.",
        "Test email was not sent.":"Тестовое письмо не отправлено.",
        "Apply current options?":"Применить текущие настройки?",
        "Field could not be empty!":"Поле не может быть пустым!",

        "QoE Stor host":"Хост QoE Stor",
        "QoE Stor port":"Порт QoE Stor",
        "QoE Stor username":"Имя пользователя QoE Stor",
        "QoE Stor password":"Пароль QoE Stor",
        "QoE Stor database name":"Имя БД QoE Stor",
        "To connect to the QoE Stor (Clickhouse) database.":"Для подключения к базе данных QoE Stor (Clickhouse).",
        "QoE Stor cluster mode":"Режим кластера QoE Stor",
        "If enabled, all queries are executed on the server cluster.":"Если этот параметр включен, все запросы выполняются в кластере серверов.",
        "Cluster mode disabled (Default)":"Режим кластера отключен (по умолчанию)",
        "Cluster mode enabled":"Включен кластерный режим",
        "QoE Stor sql optimizer for cluster mode":"Отимизатор sql запросов для кластерного режима",
        "If enabled, all sql queries to distributed tables (cluster) will be optimized for best performance.":"Если этот параметр включен, все запросы sql к распределенным таблицам (кластеру) будут оптимизированы для обеспечения максимальной производительности.",
        "Disabled (Default)":"Отключен (по умолчанию)",

        "Subscribers synchronization":"Синхронизация абонентов",
        "Disable subscribers synchronization (enabled by default). Synchronization of subscribers, services, tariffs.":"Отключить синхронизацию абонентов (по умолчанию включено). Синхронизация абонентов, услуг, тарифов.",
        "Synchronization enabled":"Синхронизация включена",
        "Synchronization disabled":"Синхронизация отключена",
        "Subscribers synchronization period in minutes":"Период синхронизации абонентов в минутах",
        "Subscribers synchronization period in minutes. Synchronization period of subscribers, services, tariffs.":"Период синхронизации подписчиков в минутах. Период синхронизации абонентов, услуг, тарифов.",

        "Stat & Alert logs synchronization":"Синхронизация логов статистики и оповещений",
        "Disable Stat & Alert logs synchronization (enabled by default).":"Отключить синхронизацию логов статистики и оповещений (по умолчанию включено).",
        "Period of data clearing DPI stat. logs in days":"Период очистки данных DPI stat. логов в днях",

        "CGNAT synchronization":"Синхронизация CGNAT",
        "Disable CGNAT synchronization (enabled by default).":"Отключить синхронизацию CGNAT (по умолчанию включено).",
        "CGNAT data synchronization period in minutes":"Период синхронизации данных CGNAT в минутах",

        "Link to the application. It is used, in particular, with QoE templates for reports sent by mail.":"Ссылка на приложение. Она используется, в частности, в шаблонах QoE для отчетов, отправляемых по почте..",

        "QoE Stor cache lifetime in seconds":"Время жизни кеша QoE Stor в секундах",
        "QoE Stor main log lifetime in hours":"Время жизни основного лога QoE Stor в часах",
        "QoE Stor aggregated log lifetime in days":"Время жизни агрегированного лога QoE Stor в днях",
        "QoE reports cache life time in seconds":"Время жизни кеша отчетов QoE Stor в секундах",
        "QoE main (raw) log lifetime in hours":"Время жизни основного (необработанного) лога QoE в часах",
        "QoE aggregated log lifetime in days":"Время жизни агрегированного лога QoE в днях",

        "QoE Stor fullflow main log lifetime in hours":"Время жизни основного лога fullflow QoE Stor в часах",
        "QoE Stor fullflow aggregated log lifetime in days":"Время жизни агрегированного лога fullflow QoE Stor в днях",

        "QoE Stor clickstream main log lifetime in hours":"Время жизни основного лога clickstream QoE Stor в часах",
        "QoE Stor clickstream aggregated log lifetime in days":"Время жизни агрегированного лога clickstream QoE Stor в днях",

        "QoE Stor NAT main log lifetime in hours":"Время жизни основного лога NAT QoE Stor в часах",
        "QoE Stor NAT aggregated log lifetime in days":"Время жизни агрегированного лога NAT QoE Stor в днях",

        "QoE Stor DNS main log lifetime in hours":"Время жизни основного лога DNS QoE Stor в часах",
        "QoE Stor DNS aggregated log lifetime in days":"Время жизни агрегированного лога DNS QoE Stor в днях",

        "QoE Stor AAA main log lifetime in hours":"Время жизни основного лога AAA QoE Stor в часах",
        "QoE Stor AAA UDR log lifetime in hours":"Время жизни агрегированного лога AAA UDR QoE Stor в часах",

        "QoE Stor GTP main log lifetime in hours":"Время жизни основного лога GTP QoE Stor в часах",
        "QoE Stor GTP aggregated log lifetime in days":"Время жизни агрегированного лога GTP QoE Stor в днях",
        "QoE Stor custom aggregated logs lifetime in days":"Время жизни пользовательских агрегированных логов QoE Stor в днях",
        "QoE Stor online aggregated logs lifetime in minutes":"Время жизни онлайн агрегированных логов QoE Stor в минутах",

        "DDoS attack logs lifetime in hours":"Время жизни лога DDoS атак в часах",
        "DDoS attack aggregated logs lifetime in days":"Время жизни агрегированного лога DDoS атак в днях",
        "DDoS attack metrics logs lifetime in hours":"Время жизни лога метрик DDoS атак в часах",
        "DDoS attack metrics aggregated logs lifetime in days":"Время жизни агрегированного лога метрик DDoS атак в днях",

        "Export files lifetime in hours": "Время хранения экспортируемых файлов в часах",
        "Limit lines in export file": "Количество строк в экспортируемом файле",
        "File limit for report export":"Лимит файлов для экспорта отчета",
        "The maximum number of files created when exporting reports in each format.":"Максимальное количество файлов, создаваемых при экспорте отчётов в каждом формате.",

        "GTP LOAD RATE from fullflow logs lifetime in days":"Время жизни логов статистики по нагрузке в GTP в днях",

        "UPLINK LOAD RATE from fullflow logs lifetime in days":"Время жизни статистики UPLINK LOAD RATE в днях",

        "Enable moving data to HOT disk":"Перенос данных на HOT диск",
        "Enable moving data to HOT disk from COLD disk":"Перенос данных на HOT диск из COLD диска",
        "Logs list to move to HOT disk":"Список логов для перемещения на HOT диск",
        "QoE Stor logs lifetime before moving to HOT disk, in hours":"Время жизни лога до переноса на HOT диск в часах",
        "Days of week to HOT disk":"Дни недели на HOT диск",
        "Days of week when partitions movings to HOT disk are possible":"Дни недели, когда возможен перенос разделов на HOT диск",
        "Hours of day to HOT disk":"Часы на HOT диск",
        "Hours of day when partitions movings to HOT disk are possible":"Часы суток, когда возможно перемещение разделов на HOT диск",

        "Enable moving data to COLD disk":"Перенос данных на COLD диск",
        "Logs list to move to COLD disk":"Список логов для перемещения на COLD диск",
        "QoE Stor logs lifetime before moving to COLD disk, in hours":"Время жизни лога до переноса на COLD диск в часах",
        "Days of week to COLD disk":"Дни недели на COLD диск",
        "Days of week when partitions movings to COLD disk are possible":"Дни недели, когда возможен перенос разделов на COLD диск",
        "Hours of day to COLD disk":"Часы на COLD диск",
        "Hours of day when partitions movings to COLD disk are possible":"Часы суток, когда возможно перемещение разделов на COLD диск",
        "All by default":"Все по умолчанию",

        "Dpiui2(GUI) autoupdate":"Автообновление Dpiui2(GUI)",
        "Enables Dpiui2(GUI) autoupdate":"Включает автообновление Dpiui2(GUI)",

        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:dpiui:dpiui2#version_information":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_components:dpiui:install_and_update:version_information",

        "Receivers":"Ресиверы",
        "Filtration":"Фильтрация",

        "Traffic direction definition":"Определение направления трафика",
        "As is":"Как есть",
        "By AS":"По АС",
        "For fullflow only":"Только для fullflow",
        "By CIDR":"По CIDR",
        "For fullflow and clickstream":"Для fullflow и clickstream",
        "By both: AS and CIDR":"По АС и CIDR",
        "By any: AS or CIDR":"По АС или CIDR",
        "0 - 'As is' - The direction of traffic does not change and is determined by the DPI":"0 - 'Как есть' - направление трафика не меняется и определяется DPI",
        "1 - 'By AS' - The direction of traffic is determined by the list of operator`s AS specified in the dictionary":"1 - 'По АС' - Направление трафика определяется списком АС оператора, указанным в словаре",
        "2 - 'By CIDR' - The direction of traffic is determined by the CIDRs list specified in the dictionary":"2 - 'По CIDR' - Направление трафика определяется списком CIDR, указанным в словаре",
        "3 - 'By both: AS and CIDR'":"3 - 'По АС и CIDR'",
        "4 - 'By any: AS or CIDR'":"4 - 'По АС или CIDR'",

        "No filter":"Нет фильтрации",
        "Subscribers filter":"Фильтр по абонентам",
        "0 - 'No filter' - No filtration applied, all flow data is saved":"0 - 'Нет фильтрации' - Фильтрация не применяется, все flow-данные сохраняются",
        "1 - 'By AS' - The flow data is filtering by the list of operator`s AS specified in the dictionary":"1 - 'По АС' - Flow-данные фильтруются по списку АС оператора, указанному в словаре",
        "2 - 'By CIDR' - The flow data is filtering by the CIDRs list specified in the dictionary":"2 - 'По CIDR' - Flow-данные фильтруются по списку CIDR, указанному в словаре",

        "Exclusions from the subscribers filter":"Исключения из фильтра абонентов",
        "No exclude":"Не исключать",
        "0 - 'No exclude' - No exclusion applied":"0 - 'Не исключать' - исключение не применяется",
        "1 - 'By AS' - Exclusions are applied to the AS list of the operator specified in the dictionary":"1 - 'По АС' - Исключения применяются к списку АС оператора, указанному в словаре",
        "2 - 'By CIDR' - Exclusions are applied to the CIDRs list of the operator specified in the dictionary":"2 - 'По CIDR' - Исключения применяются к списку CIDR, указанному в словаре",

        "QoE Stor (fastor) autoupdate":"Автообновление QoE Stor",
        "Enables QoE Stor (fastor) autoupdate":"Включает автообновление QoE Stor",

        "Autoload of hosts (urls) categories dictionaries":"Автозагрузка словарей категорий хостов",
        "Enables autoload of hosts (urls) categories dictionaries":"Включает автозагрузку словарей категорий хостов",

        "Autoload AS numbers dictionary":"Автозагрузка словаря номеров АС",
        "Enables autoload of AS numbers dictionary":"Включает автозагрузку словаря номеров АС",

        "URL for downloading of hosts (urls) categories dictionaries":"URL для скачивания словарей категорий хостов (urls)",

        "Autoload protocols dictionary":"Автозагрузка словаря протоколов",
        "Autoload company protocols dictionary": "Автозагрузка словаря протоколов компании",
        "Enables autoload of applications protocols dictionary":"Включает автозагрузку словаря прикладных протоколов",
        "URL for downloading protocols dictionary":"URL для загрузки словаря протоколов",
        "URL for downloading company protocols dictionary":"URL для загрузки словаря протоколов компании",
        "URL for downloading company protocol groups dictionary":"URL для загрузки словаря групп протоколов компании",
        "URL for downloading application protocols dictionary":"URL для загрузки словаря прикладных протоколов",
        "Autoload custom protocols dictionary":"Автозагрузка словаря пользовательских протоколов",
        "Enables autoload of custom applications protocols dictionary":"Включает автозагрузку словаря пользовательских прикладных протоколов",
        "URL for downloading custom protocols dictionary":"URL для загрузки словаря пользовательских протоколов",
        "URL for downloading custom application protocols dictionary":"URL для загрузки словаря пользовательских прикладных протоколов",
        "URL for downloading custom protocol groups dictionary":"URL для загрузки словаря групп пользовательских протоколов",
        "URL for downloading custom application protocol groups dictionary":"URL для загрузки словаря групп пользовательских прикладных протоколов",
        "Enabled by default":"Включено по умолчанию",
        "Disabled by default":"Выключено по умолчанию",
        "Under construction!":"В разработке!",

        "Receiver type":"Тип ресивера",
        "Port type":"Тип порта",
        "Port":"Порт",
        "Rotate in minutes":"Ротация в минутах",
        "Rotate in seconds":"Ротация в секундах",
        "Receiver dump rotate in seconds. The same as the rotation in minutes, only in seconds.":"Ротация дампов в секундах. То же самое, что и ротация в минутах, только в секундах.",
        "If this value is enabled the value in minutes is ignored.":"Если это значение включено, значение в минутах игнорируется.",
        "Rotate by flows":"Ротация по флоу",
        "Rotation by flows records number. Works simultaneously with rotates in minutes or seconds.":"Ротация по количеству записей в флоу. Работает одновременно с ротацией в минутах или секундах.",
        "Delay in seconds":"Задержка в секундах",
        "Queue size":"Размер очереди",
        "Export":"Экспорт",

        "Fullflow port type":"Тип порта Фулфлоу",
        "Fullflow port number":"Номер порта Фулфлоу",
        "Clickstream port type":"Тип порта Кликстрим",
        "Clickstream port number":"Номер порта Кликстрим",
        "tcp or udp":"tcp или udp",

        "Recommended":"Рекомендовано",
        "It`s recommended to use tcp":"Рекомендуется использовать tcp",

        "Fullflow or Clickstream":"Фулфлоу или Клистрим",
        "Fullflow is a receiver for fullflow data":"Фулфлоу - ресивер для получения фулфлоу данных",
        "Clickstream is a receiver for clickstream data":"Кликстрим - ресивер для получения данных кликстрим",
        "Any port you wish. The main thing that would be different for each thread":"Любой порт, который вы хотите. Главное, что бы он отличался для каждого потока",
        "Default values are 1500 for fullflow thread and 1501 for clickstream thread":"Значения по умолчанию: 1500 для фулфлоу и 1501 для кликстрим",

        "Receiver dump rotate period or data loading period into the database":"Период обращения дампа приемника или период загрузки данных в БД",
        "Default value is 10 minutes":"Значение по умолчанию 10 минут",
        "Default value is 10 minutes for fullflow and 12 minutes for clickstream":"Значение по умолчанию 10 минут для фулфлоу и 12 минут для кликстрим",
        "Dump rotate period for cliksteam should be greater or equal than the same period for fullflow. When fullflow dump rotates the HUP signal is sent to synchronize threads.":"Период поворота дампа для кликстрим должен быть больше или равен тому же периоду для фулфлоу. Когда дамп фулфлоу оборачивается, посылается сигнал HUP для синхронизации потоков.",
        "Do not change this setting unnecessarily":"Не меняйте этот параметр без необходимости",

        "Data loading delay into the database":"Задержка загрузки данных в БД",
        "Default values are 0 seconds for fullflow thread and 400 seconds for clickstream thread":"Значения по умолчанию: 0 секунд для фулфлоу и 400 секунд для кликтрим",

        "Receiver dump loading queue size":"Размер очереди загрузки дампа ресивера",
        "Default value is 10":"Значение по умолчанию 10",

        "Reciver can export data to other receivers":"Ресивер может экспортировать данные на другие ресиверы",
        "Format is":"Формат: ",

        "Insert processes number":"Число процессов вставки",
        "Number of dump insert processes":"Число процессов вставки дампа",

        "Balancer":"Балансир",
        "Balancer type":"Тип балансира",
        "RoundRobin or All":"RoundRobin или All",
        "RoundRobin mode splits IPFIX flow":"Режим RoundRobin разделяет поток IPFIX",
        "All mode replicate IPFIX flow":"Режим All реплицирует поток IPFIX",
        "Balancer subreceivers":"Субресиверы балансира",
        "Balancer can split or replicate data to other receivers":"Балансир может разделять или реплицировать данные на другие приемники",
        "Balancer subreceivers type":"Тип субприемников балансира",
        "Balancer auto":"Балансир авто",
        "If Auto mode enabled it will create and start subreceivers automatic":"Если включен автоматический режим, он автоматически создаст и запустит субресиверы",

        "Websocket notifications": "Вебсокет нотификации",
        "Period of data clearing Ulr tasks in days": "Период очистки данных Ulr задач в днях",
        "Period of clearing old Ulr logs in days": "Период очистки старых Ulr логов в днях",
        "Schedule mode for updating lists": "Режим расписания для обновления списков",
        "Updating the lists every YOUR_VALUE hours": "Обновлять списки каждые ВАШЕ_ЗНАЧЕНИЕ часов",
        "Ulr settings": "Настройки Ulr",
        "White list redirect URL": "URL редиректа для услуги \"Белый список\"",
        "Black list redirect URL": "URL редиректа для услуги \"Черный список\"",
        "Black list upload host": "Хост для выгрузки списка блокируемых ресурсов",
        "Black list upload port": "Порт для выгрузки списка блокируемых ресурсов",
        "To connect to the black list resources server.": "Для подключения к серверу блокируемых ресурсов.",
        "Black list upload username": "Имя пользователя для выгрузки списка блокируемых ресурсов",
        "Black list upload password": "Пароль для выгрузки списка блокируемых ресурсов",
        "Info": "Инфо",
        "Debug": "Отладка",
        "Log level detalization": "Уровень детализации логов",
        "Black list upload path": "Путь для сохранения черных списков",
        "ASN for IP-exclude rules": "ASN для правил IP-исключений",
        "Black list upload use sudo": "Использовать sudo при выгрузке списка блокируемых ресурсов",
        "Use": "Использовать",
        "Don`t use": "Не использовать",
        "Use only when there is a category": "Использовать только при наличии категорий",

        "Push notifications settings": "Настройки пуш-нотификаций",
        "Broadcast driver for push notifications": "Драйвер трансляции пуш-нотификаций",
        "Redis": "Redis",
        "Redis host": "Хост Redis",
        "Redis port": "Порт Redis",
        "Redis password": "Пароль Redis",

        "Require authorization on ASN (OIMS) server":"Требовать авторизацию на сервере ASN (OIMS)",
        "ASN (OIMS) server":"ASN (OIMS) сервер",
        "ASN user ID":"ASN ID пользователя",
        "ASN token":"ASN токен",
        "ASN version":"ASN версия",
        "DPI hardware ID":"Идентификатор оборудования DPI",
        "Traffic generator executable path":"Путь к генератору трафика",
        "PCI Ethernet controllers ports numbers":"Номера портов контроллеров PCI Ethernet",
        "Traffic generator pid addition":"Добавка к pid генератора трафика",
        "Are you sure you want to restart the PCRF process?": "Вы действительно хотите перезапустить процесс PCRF?",
        "Cancel": "Отменить",
        "Restart": "Перезапустить",
        "Are you sure you want to update the hot settings?": "Вы действительно хотите обновить горячие параметры?",
        "Restart PCRF": "Перезапустить PCRF",
        "Updating hot options": "Обновить горячие параметры",
        "Default": "Стандарная группировка",
        "Default value":"Значение по умолчанию",
        "General settings": "Общие настройки",
        "Authorization server": "Сервер авторизации",
        "Radius parameters": "Параметры Radius",
        "Radius servers": "Radius серверы",
        "Accounting": "Аккаунтинг",
        "CoA parameters": "Параметры CoA",
        "DHCP parameters": "Параметры DHCP",
        "Persistent FIFO": "Постоянный FIFO",


        "Startup fdpi_pcrf as daemon": "Запускать fdpi_pcrf как демон",
        "No": "Нет",
        "Yes": "да",
        "Detailed logging": "Подробное логирование",
        "Trace flags by subsystems": "Флаги трассировки (подробного логирования) по подсистемам",
        "Radius connections monitor": "Монитор соединений Радиуса",
        "Internal task scheduler":"Внутренний планировщик задач",
        "Auth server": "Сервер авторизации",
        "radius_client connections": "Запросы Access-Request и ответы Access-Accept/Reject",
        "radius_client monitor": "Запросы Server-Status проверки живости Радиус-сервера и ответов на них",
        "CoA-server events":"Журналирование событий CoA",
        "CoA-listener connects": "Создание соединений с CoA-клиентами",
        "CoA-requests":"CoA-запросы",
        "fastDPI sending data events":"События отправки данных fastDPI",
        "Events queue from fastPCRF to fastDPI":"События очереди сообщений от fastPCRF к fastDPI",
        "start/stop accounting requests": "Отправка start/stop accounting",
        "interim update accounting requests": "Отправка interim update accounting",
        "Raw accounting data from fastDPI receiving": "Прием сырых данных аккаунтинга от fastDPI",
        "trace param ignoring if verbose=1.": "Если verbose=1, параметр trace не учитывается.",
        "Max filesize": "Максимальный размер файла при записи, байт",
        "Default value is 1G (1073741824 bytes)": "Значение по умолчанию – 1G (1073741824 байт)",
        "Statistics output period in seconds":"Периодичность вывода статистики, секунд",
        "Default value is 300 seconds (every 5 minutes).": "Значение по умолчанию - 300 секунд (раз в 5 минут).",
        "Working threads number": "Число рабочих потоков",
        "Every fdpi_pcrf component can live in separate thread.<br/>Setting threads number greater then 5 is pointless.": "Каждый компонент fdpi_pcrf может жить в отдельном потоке.<br/>Задавать число потоков более 5 бессмысленно.",
        "Internal asynchronous message transfer queue size": "Размер очереди асинхронных событий",
        "Default value is 512*1024=524288.": "Значение по умолчанию - 512*1024=524288.",
        "Policing profile name for unauthorized users": "Имя профайла полисинга для неавторизованных пользователей",
        "White list (service 5) profile name for unauthorized users": "Имя профиля услуги 5 (белый список) для неавторизованных пользователей",
        "fastDPI server": "fastDPI сервер",
        "where:": "где:",
        " - ip - fastDPI server ip-address": " - ip - IP-адрес сервера fastDPI",
        " - dev - interface name for connecting": " - dev - интерфейс, с которого идет соединение",
        " - port - port for fastpcrf->fastdpi connection (29000 - default fdpi_ctrl port)": " - port - порт обратной связи fastpcrf -> fastdpi (обычно 29000 - стандартный порт fdpi_ctrl)",
        " - name=value - additional server parameters": " - name=value - дополнительные параметры сервера",
        "   - attr_nas_ip  - IPv4 address for NAS-IP-Address attribute; using fastdpi IP-address if not set": "   - attr_nas_ip  - IPv4-адрес для атрибута NAS-IP-Address; если не задан - применяется IP-адрес fastdpi (ip)",
        "   - attr_nas_ipv6  - NAS-IPv6-Address attribute value for current fastdpi": "   - attr_nas_ipv6  - значение атрибута NAS-IPv6-Address для данного fastdpi",
        "   - attr_nas_id  - NAS-Identifier attribute value for current fastdpi": "   - attr_nas_id  - значение атрибута NAS-Identifier для данного fastdpi",
        "fastDPI server list": "Список fastDPI-серверов",
        "Using parameters fdpi_server allows you to set additional attributes for each fastdpi-server": "Лучше использовать параметры fdpi_server, так как они позволяют задавать дополнительные атрибуты для каждого fastdpi-сервера",
        "Connection listener interface(device) name": "Имя интерфейса (девайса), на котором слушать входящие соединения",
        "Listen port": "Listen port",
        "Default value is": "Значение по умолчанию -",
        "Inbound connections max number": "Максимальное число входящих соединений",
        "Radius server configuration": "Параметры radius-сервера",
        " - secret - radius server secret": " - secret - разделяемый секрет Radius-сервера",
        " - ip - radius server ip-address": " - ip - IP-адрес Radius-сервера",
        " - dev(not required) - interface name for connecting": " - dev(не обязательно) - интерфейс, на котором устанавливается соединение с Radius-сервером",
        " - port - port": " - port - UDP-порт Radius-сервера",
        " - param=value - set of radius server configuration parameters": " - param=value - необязательный перечень параметров, уникальных для данного Radius-сервера",
        "Radius server revive period(in seconds)": "Таймаут проверки доступности master-сервера, секунд",
        "Default value is 120 seconds": "Значение по умолчанию - 120 секунд",
        "Max number of connections to server": "Максимальное число коннектов к серверу",
        "Each connection can serve less then 256 simultaneous requests": "Согласно Radius RFC, каждый коннект может обслуживать не более 256 одновременных запросов",
        "Value 0 is unlimited; this opportunity should be used very carefully!": "Значение 0 - без ограничений; этой возможностью следует пользоваться весьма осторожно!",
        "Accounting auth port connections max number": "Максимальное количество коннектов по порту accounting-авторизации",
        "Response time, seconds": "Время ответа, секунд",
        "If will not received response for Access-Request for this time, the request will be repeated radius_resend_count times": "Если в течение этого времени не получен ответ на Access-Request, запрос будет повторен radius_resend_count раз",
        "Attempts to send request max number": "Максимальное число попыток отправки запроса",
        "0 - do not repeat": "0 - не пытаться повторять",
        "Radius server dead timeout, seconds": "Таймаут Radius-сервера, секунды",
        "Current radius server considered dead if will not received response for any request for this time": "Если от radius-сервера не пришло ни одного ответа в течение данного времени данный radius-сервер считается умершим",
        "and fdpi_pcrf will try to switch to another radius server": "и fdpi_pcrf будет пытаться переключиться на другой radius-сервер",
        "This parameter must be at least 2 times smaller than radius_revive_period": "Данный параметр должен быть как минимум в 2 раза меньше, чем radius_revive_period",
        "Radius server Status-Server request": "Поддерживает или нет radius-сервер запрос Status-Server",
        "Radius server Message-Authenticator attribute": "Признак поддержки radius-сервером атрибута Message-Authenticator",
        "User-Name attribute for L3 auth-requests Accept-Request": "Что писать в атрибут User-Name для L3 auth-запросов Access-Request",
        "List of identifiers": "Cписок идентификаторов в порядке предпочтения",
        "Valid values:": "Допустимые значения:",
        " - login: User-Name=login, if login known": " - login: если известен логин, User-Name = логин абонента",
        " - ip: User-Name=ip as string": " - ip: User-Name = IP-адрес абонента в виде строки",
        " - qinq:User-Name=outerVlan.innerVlan, if web is QinQ(double VLAN, vlan-per-user)": " - qinq: если сеть QinQ (double VLAN, vlan-per-user), то User-Name = outerVlan.innerVlan",
        "User-Name attribute for DHCP-requests Accept-Request":"Что писать в атрибут User-Name для DHCP-запросов Access-Request",
        " - mac: User-Name=mac-address as string like \"XX:XX:XX:XX:XX:XX\"": " - mac: User-Name = MAC-адрес в строковом виде \"XX:XX:XX:XX:XX:XX\"",
        "User-Name attribute for ARP-requests Accept-Request": "Что писать в атрибут User-Name для ARP-запросов Access-Request",
        "User-Password attribute for requests Accept-Request": "Что писать в атрибут User-Password для ARP-запросов Access-Request",
        "NAS-Port-Type attribute value for request Access-Request": "Значение атрибута NAS-Port-Type запроса Access-Request",
        "The list of valid values is given by RFC 2865": "Число, перечень допустимых значений задается RFC 2865",
        "Default value is 5 (Virtual)": "Значение по умолчанию: 5 (Virtual)",
        "Service-Type attribute value for request Access-Request": "Значение атрибута Service-Type запроса Access-Request",
        "Accounting Radius-server port": "Порт Radius-сервера для Accounting",
        "Time interval for sending intermediate accounting, in seconds": "Интервал времени посылки промежуточного аккаунтинга, в секундах",
        "Minimum value is": "Минимально допустимое значение –",

        "Interim update will sent if traffic amount greater then volume": "Объем трафика, после превышения которого посылается interim update",
        "Default value is 0 (only by time)": "Значение по умолчанию - 0 (посылать только по времени)",
        "Set in bytes, kilobytes (65K), megabytes(65M), gigabytes(10G)": "Задается в байтах, килобайтах (пример - 65K) , мегабайтах (65M), гигабайтах (10G)",
        "Accounting data persistence timeout, in seconds": "Тайм-аут неизменности данных аккаунтинга, секунд",
        "If during this timeout the subscriber statistics did not change, it is considered that the subscriber's session is timed out and sent Accounting Stop.": "Если в течение этого тайм-аута статистика абонента не изменялась, то считается, что сессия абонента завершена по тайм-ауту и посылается Accounting Stop.",
        "CoA notifications receiving UDP-port": "UDP-порт, на который поступают Change-of-Authorization (CoA) оповещения",
        "Set this parameter value 0 if radius server not provides CoA": "Если radius-сервер не поддерживает CoA, следует задать этому параметру значение 0",
        "CoA-response resending timeout, in seconds": "Тайм-аут перепосылки CoA-ответов (Disconnect-ACK, Disconnect-NAK, CoA-ACK, CoA-NAK), в секундах",
        "Resend number is setting by radius_resend_count parameter": "Количество повторных попыток задается параметром radius_resend_count",
        "Stop occurrence control mode by data invariance": "Режим контроля наступления Stop по неизменности данных",
        "Accounting start point": "Точка отсчета accounting",
        "Sign of compatibility with LanBilling": "Проверять наличие активной сессии абонента перед его авторизацией",
        "Acct-Request attributes format": "Формат Acct-Reqiest атрибутов",
        "Frequency of sending ready accounting data, in seconds": "Периодичность вызова отправки готовых данных аккаунтинга, в секундах",
        "<b>Do not change this setting</b>.": "<b>Не изменяйте данный параметр!</b>.",
        "Swap traffic direction for accounting Radius-attributes": "Изменение направления трафика в Радиус-атрибутах аккаунтинга",
        "Disable sending to Acct-Request traffic class breakdown": "Отключает отправку в Acct-Request разбивку по классам трафика",
        "What traffic classes to include in accounting": "Какие классы трафика включать в аккаунтинг",
        "Pending CoA-requests from radius-servers max number": "Максимальный размер очереди необработанных CoA-оповещений",
        "CoA-client format": "Задание CoA-клиентов",
        " - secret - shared secret": " - secret - разделяемый секрет",
        " - ip - CoA-client ip-address": " - ip - IP-адрес CoA-клиента",
        " - dev - interface for caching CoA-client alerts": " - dev - интерфейс, на котором ловятся оповещения CoA-клиента",
        " - port - UDP-port": " - port - UDP-порт",
        "DHCP Netmask": "opt1 Маска подсети (Radius-атрибут 9 Framed-IP-Netmask)",
        "DHCP Gateway": "opt3 Шлюз по умолчанию",
        "MTU size": "opt26 MTU size (Radius-атрибут 12 Framed-MTU)",
        "Ip address lease time, seconds": "opt51 Время аренды (lease time) IP-адреса в секундах",
        "DNS address": "opt6 Адреса Domain name server (Radius-VSA-атрибут vendorId=43823 attrId=41 VasExperts-DHCP-DNS)",
        "Static routing table": "opt121 статическая таблица маршрутизации (Radius-атрибут 22 Framed-Route)",
        "Persistent FIFO folder": "Каталог, в котором создаются персистентные очереди",
        "Queue pages max number": "Максимальное число страниц в очереди",
        "Page size is 2M.": "Размер каждой страницы = 2M.",
        "0 - pages number is unlimited.": "0 - число страниц не ограничено.",
        "Minimal value is 2.": "Минимальное значение: 2",
        "Queue max files size is rlimit_fsize. Queue can not be greater then rlimit_fsize.": "Следует учитывать, что размер файла очереди ограничен сверху параметром rlimit_fsize больше этого размера очередь не может быть.",
        "Reconncet to fastdpi servers timeout, seconds": "Тайм-аут попытки подсоединения к fastdpi-серверам, секунд",
        "Pending requests from fastdpi-servers max number": "Максимальное число ожидающих выполнения запросов от fastdpi-серверов",
        "No changes in inbound and outbound traffic": "Нет изменений во входящем и исходящем трафике",
        "No changes in outbound traffic only": "Нет изменений только в исходящем трафике (нет активности абонента)",
        "From the last Stop event": "С последнего Stop (это значение по умолчанию)",
        "From the start of Start event. Ignore all traffic from the last Stop event": "С начала события Start. В этом случае весь \"паразитный\" входной трафик, накопленный с момента последнего Stop, игнорируется.",
        "Do not change": "Не изменять",
        "Swap inbound/uotbound traffic counters": "Поменять местами счетчики входящего/исходящего трафика",
        "List of classes": "Список классов",
        "Send Stop accounting before authorization": "Посылать аккаунтинг Stop перед авторизацией",
        "FastDPI Submission Queue": "Очередь отправки на FastDPI",
        "FastDPI servers": "FastDPI серверы",

        "To send user authentication status to fastDPI servers and its parameters a persistent queue is organized.": "Для отправки fastDPI-серверам статуса авторизации пользователя и его параметров организуется персистентная очередь.",
        "This ensures that even if one of the fastDPI servers is unavailable, all authorization messages for it will be saved and sent as soon as it becomes available.": "Тем самым гарантируется, что даже если один из fastDPI-серверов будет недоступен, все авторизационные сообщения для него будут сохранены и отправлены как только он станет доступным.",
        "(bras_dhcp_mode=2 in fastdpi.conf)": "(bras_dhcp_mode=2 в fastdpi.conf)",
        "Applicable only if fastDPI works in DHCP proxy via Radius mode": "Применяются только если fastDPI работает в режиме DHCP proxy via Radius",
        "If, however, no value is specified in this config-file, the corresponding DHCP option will be absent in the DHCP-Offer.": "Если же и в данном config-файле значение не задано - соответствующая DHCP-опция будет отсуствовать в DHCP-Offer.",
        "fdpi_pcrf switches to master server as soon as it become available.": "Как только master-сервер становится доступным, fdpi_pcrf переключается на него.",
        "If this one is not available to connect, it will try to connect to next one, availability of master-server periodically checked by Server-Status request.": "Если master-сервер становится недоступным, fdpi_pcrf переключается на один из резервных, при этом master-сервер периодически пингуется запросом Server-Status.",
        "fdpi_pcrf trying to connect to master-server": "fdpi_pcrf старается подключиться к master-серверу",
        "fdpi_pcrf interact only one server from the list.": "fdpi_pcrf работает только с одним из серверов.",
        "Usually at least two radius servers are specified - master and reserve.": "Обычно задается как минимум два radius-сервера - главный и резервный.",
        "The most preferred server(master-server) is the first, then less preferred(reserve).": "первым задается самый предпочтительный сервер (master server), затем менее предпочтительные (резервные).",
        "Radius servers should be listed in order of preference:": "Radius-сервера должны быть перечислены в порядке предпочтения:",
        "You can specify up to 16 different radius-servers.": "Допускается задание до 16 разных radius-серверов.",
        "Each option specify radius-server address and his parameters.": "Каждая опция задает адрес radius-сервера и его параметры",
        "You can set any radius servers but it will interact only one of them.": "Radius-серверов можно указать много но взаимодействие ведется только с одним из них.",
        "Profile's names for services": "Имена профилей по услугам",
        "List of services": "Список подключенных услуг",
        "Policing profile": "Профиль полисинга",
        "This component interacts with the Radius server, asking it for authorization and user's parameters": "Этот компонент взаимодействует с Radius-сервером, запрашивая у него авторизацию и параметры пользователей",
        "Authorization server is the part of fastpcrf that accepts requests for authorization from fastDPI.": "Сервер авторизации - часть fastpcrf, принимающая запросы  на авторизацию от fastDPI.",
        "These values will be substituted into the configured DHCP-Offer, if Radius does not reported relevant attributes.": "Эти значения будут подставлены в формируемый DHCP-Offer, если Radius не сообщил соответствующих атрибутов.",

        "Frame Pools": "Поддержка фрейм пуллов",
        "DHCP server Address": "Адрес DHCP-сервера",
        "address - DHCP server IP-address": "address - IP-адрес DHCP-сервера",
        "dev - local interface for communication with DHCP server": "dev - с какого локального интерфейса общаться с DHCP-сервером",
        "Enter valid address": "Введите корректный адрес",
        "In which option of the DHCP request to send the pool name": "В какой опции DHCP-запроса посылать имя пула",
        "Pool name will added to opt125 (default)": "Имя пула будет добавляться в opt125. (по умолчанию)",
        "If option is already exists it will replaced by the pool name": "Если опция уже есть, её значение заменяется на имя пула",
        "This option is always added": "Опция всегда добавляется",
        "All DHCP requests are always sent to all servers specified in the dhcp_server parameters.": "Все DHCP-запросы всегда шлются на все сервера, указанне в параметрах dhcp_server.",
        "If multiple DHCP servers are configured, the PCRF takes the first response into account, and responses from the other DHCP servers are ignored.": "Если сконфигурировано несколько DHCP-серверов, PCRF принимает во внимание первый по времени ответ, ответы от остальных DHCP-серверов игнорируются.",
        "ipv6 - DHCPv6 server address": "ipv6 - адрес DHCPv6-сервера",
        "port - port, default is 547": "port - порт, default=547",
        "options - additional options": "options - дополнительные опции",
        "source_ip=address - The source IPv6 address that the request is sent to the DHCPv6 server from": "source_ip=address - исходный IPv6-адрес, от имени которого идет запрос на DHCPv6-сервер",
        "If source_ip is not specified, then:": "Если source_ip не задан, то:",
        "If server address link-local - using link-local address of dev interface": "если адрес сервера link-local - берется link-local адрес интерфейса dev",
        "If server address is global - using global address of dev interface": "если адрес сервера глобальный - берется глобальный адрес интерфейса dev",
        "relay_ip=address - Relay IPv6 address. DHCPv6 server considers this address as relay address": "relay_ip=address - IPv6-адрес релея. Именно этот адрес учитывает DHCPv6-сервер как адрес релея",
        "If relay_ip is not specified it equals source_ip": "Если не задан - равен source_ip",
        "You can set up to 16 servers.": "Поддерживается задание до 16 серверов.",
        "Pool name will send in Vendor-Specific option (default)": "Имя пула будет передаваться в Vendor-Specific опции (по умолчанию)",
        "All DHCPv6 requests are always sent to all servers specified in the dhcp6_server parameters.": "Все DHCPv6-запросы всегда шлются на все сервера, указанне в параметрах dhcp6_server.",
        "If multiple DHCPv6 servers are configured, the PCRF takes the first response into account, and responses from the other DHCPv6 servers are ignored.": "Если сконфигурировано несколько DHCPv6-серверов, PCRF принимает во внимание первый по времени ответ, ответы от остальных DHCPv6-серверов игнорируются.",

        "CKAT expects to get the subscriber`s IP address in the Access-Accept Radius response.": "СКАТ ожидает получить IP-адрес абонента в ответе Радиуса Access-Accept.",
        "Instead of issuing an IP address, the billing service behind the Radius can provide the name of a pool of addresses from which to distribute the address to this subscriber.": "Биллинг, стоящий за Радиусом, может вместо выдачи IP-адреса сообщить имя пула адресов, из которых следует распределить адрес данному абоненту.",
        "For IPv4, the pool name is specified in the Framed-Pool attribute; for IPv6, it is specified in the Framed - IPv6-Pool attribute.": "Для IPv4 имя пула указывается в атрибуте Framed-Pool, для IPv6 - в атрибуте Framed-IPv6-Pool.",
        "FastPCRF, after getting the pool name in Access-Accept, requests the subscriber's IP address from the DHCP server.": "FastPCRF, получив в Access-Accept имя пула, запрашивает IP-адрес абонента у DHCP-сервера.",
        "After receiving a response from the DHCP server, fastPCRF allocates the IP address from it, combines the options specified in the DHCP response with the Access-Accept attributes, and sends the authorization response via fastdpi to the subscriber.": "По получении ответа от DHCP-сервера fastPCRF выделяет из него IP-адрес, комбинирует опции, заданные в DHCP-ответе, с атрибутами Access-Accept, и посылает ответ авторизации через fastdpi абоненту.",


        "Input correct address": "Введите корректный адрес",
        "Input correct value": "Введите корректное значение",
        "Update": "Обновить",
        "Configuration loaded.": "Конфигурация загружена",
        "Radius-client is one of the components of fast_pcrf.": "Radius-client - один из комнонентов fast_pcrf.",
        "acct and auth are out of sync": "acct и auth не синхронизированы",
        "acct and auth synchronized": "acct и auth синхронизированы",
        "NAT 1:1 and subscriber's white address known": "NAT 1:1 и известен белый адрес абонента",
        "Period of clearing Ulr users actions log in days": "Период очистки логов действий Ulr-пользователей в днях",
        "Enter valid value": "Введите корректное значение",
        "Enter valid folder": "Введите корректный адрес папки",
        "Prioritization of multiple channels": "Приоритизация нескольких каналов",
        "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_shaping:shaping_multi:start": "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_shaping:shaping_multi",
        "Distinguish type for channels": "Метод распознавания каналов",
        "Using NICs for different channels": "Для разных каналов используются разные сетевые интерфейсы",
        "Using VLANs for different channels": "Для разных каналов используются разные VLAN",
        "Using CIDRs for different channels": "Для разных каналов используются разные CIDR",
        "NICs or VLANs list for virtual channels": "Список физических интерфейсов и VLAN-ов образующих виртуальный канал",
        "dna0:dna1|dna2:dna3 or 100:101-115|200:201:240-250": "dna0:dna1|dna2:dna3 или 100:101-115|200:201:240-250",
        "Hosts classifier server":"Сервер классификатора сайтов",
        "More...": "Подробнее...",
        "Network interface name":"Имя сетевого интерфейса",
        "IP address of QoE Stor":"IP-адрес QoE Stor",
        "Type":"Тип",

        "Replacing Login with Vchannel":"Замена поля Login полем Vchannel",
        "Use dictionary when replacing Login":"Использовать словарь при замене Login",
        "Enable auto replacing Login with vchannel on insert":"Включить автозамену поля Login полем Vchannel при вставке данных",
        "Enabled if Login is empty":"Включено, если Логин пуст",
        "Vchannels names dic autoload":"Автозагрузка словаря названий Vchannels",
        "Vchannels names dic url":"Url словаря названий Vchannels",

        "NAT log settings":"Настройки журнала NAT",
        "Import NAT events from fullflow":"Импорт событий NAT из fullflow",
        "Fields to save when aggregating NAT log":"Поля для сохранения при агрегировании журнала NAT",
        "Time interval for aggregating NAT logs":"Интервал времени для агрегирования логов NAT",
        "Enable filling IP-LOGIN bind from fullflow":"Включить заполнение привязки IP-LOGIN из fullflow",
        "Enable adding LOGIN to NAT log from IP-LOGIN binding":"Включить добавление LOGIN в журнал NAT из привязки IP-LOGIN",
        "Use distributed IP-LOGIN binding table":"Использовать распределенную таблицу привязки IP-LOGIN",

        "Protocol ID":"ID протокола",
        "Event type":"Тип события",
        "Source IPv4":"IPv4 адрес источника",
        "Source port":"Порт источника",
        "Destination IPv4":"IPv4 адрес получателя",
        "Destination port":"Порт получателя",
        "Post NAT source IPv4":"IPv4 адрес источника после NAT",
        "Post NAT source port":"Порт источника после NAT",
        "Session ID":"Идентификатор сессии",
        "Login":"Логин",
        "DPI ID":"Идентификатор DPI",

        "All fields are enabled by default":"По умолчанию все поля включены",

        "Raw fullflow":"Сырой fullflow",
        "Agg fullflow":"Агрегированный fullflow",
        "Raw clickstream":"Сырой clickstream",
        "Agg clickstream":"Агрегированный clickstream",
        "Raw NAT flow":"Сырой NAT flow",
        "Agg NAT flow":"Агрегированный NAT flow",
        "Raw GTP flow":"Сырой GTP flow",
        "Agg GTP flow":"Агрегированный GTP flow",
        "Agg custom logs":"Агрегированные пользовательские логи",
        "Agg online flow":"Агрегированный онлайн fullflow",
        "Raw aaaflow":"Сырой aaaflow",
        "AAA UDR fullflow and clickstream":"AAA UDR логи fullflow и clickstream",

        "Raw attacks log":"Сырые логи атак",
        "Agg attacks log":"Агрегированные логи атак",
        "Raw attacks metrics log":"Сырые метрики атак",
        "Agg attacks metrics log":"Агрегированные метрики атак",

        "Default value":"Значение по умолчанию",

        "FULLFLOW log settings":"Настройки журнала FULLFLOW",
        "FULLFLOW AGG log settings":"Настройки журнала FULLFLOW AGG",
        "Fields to save when aggregating FULLFLOW log":"Поля для сохранения при агрегировании журнала FULLFLOW",
        "Enable VOIP traffic data":"Включить данные VOIP трафика",
        "Time interval for aggregating FULLFLOW logs":"Интервал времени для агрегирования логов FULLFLOW",
        "Enable FULLFLOW log background compressing":"Включить фоновое сжатие логов FULLFLOW",
        "Enable DSCP from original TOS":"Включить DSCP из исходного TOS",
        "Enable collection of information about blocked traffic":"Включить сбор информации о заблокированном трафике",
        "Threshold value for traffic detection as a drop":"Порог значения для определения трафика как drop",
        "Threshold value for traffic detection as a policing":"Порог значения для определения трафика как полисинг",
        "Enter a number between 0 and 1, including floating point numbers":"Введите число от 0 до 1, включая числа с плавающей точкой",
        "Blocked traffic":"Заблокированный трафик",

        "CLICKSTREAM log settings":"Настройки журнала CLICKSTREAM",
        "CLICKSTREAM AGG log settings":"Настройки журнала CLICKSTREAM AGG",
        "Fields to save when aggregating CLICKSTREAM log":"Поля для сохранения при агрегировании журнала CLICKSTREAM",
        "Time interval for aggregating CLICKSTREAM logs":"Интервал времени для агрегирования логов CLICKSTREAM",

        "ONLINEFLOW log settings":"Настройки журнала ONLINEFLOW",
        "Time interval for aggregating ONLINEFLOW logs":"Интервал времени для агрегирования логов ONLINEFLOW",

        "OpenCellID settings":"Настройки OpenCellID",
        "Enables autoload of OpenCellID catalog":"Включение автозагрузки OpenCellID словаря",
        "Token in LocalAPI platform":"Токен в LocalAPI платформе",
        "OpenCellID level of log":"Уровень логирования OpenCellID",
        "Time interval to update empty data cell towers for report of geoposition":"Глубина запроса пустых данных для отчета по геопозициям, в часах",

        "GTP settings":"Настройки сервиса сбора аномалий в GTP",
        "Import GTP LOAD RATE from fullflow":"Cбор статистики по нагрузке в GTP",
        "Enable a service for detecting anomalies in the load rate of base stations":"Включает сервис для детектирования аномалии в нагрузке базовых станций",
        "Fields to save when aggregating GTP log":"Поля для сохранения",
        "Fields to save when aggregating GTP log tooltip":"Данные, которые будут записаны в журнал во время работы сервиса детектирования аномалий",
        "Save traffic volume":"Объем трафика",
        "Group by protocol code":"Код протокола",
        "Save subscribers":"Логин абонента",
        "Time interval for aggregating GTP LOAD RATE logs in minutes":"Период агрегации в минутах",
        "Time interval for aggregating GTP LOAD RATE logs in minutes tooltip":"Период агрегирования данных для сервиса детектирования аномалий",
        "1 week":"1 неделя",

        "UPLINK LOAD RATE settings":"Настройки сервиса сбора статистики UPLINK LOAD RATE",
        "Import UPLINK LOAD RATE from fullflow":"Сбор статистики UPLINK LOAD RATE из fullflow",
        "Fields to save when aggregating UPLINK LOAD RATE log":"Поля при сохранении логов UPLINK LOAD RATE",
        "Enable a service for import UPLINK LOAD RATE info from fullflow":"Включить сервис для импорта UPLINK LOAD RATE логов",
        "Time interval for aggregating UPLINK LOAD RATE logs in minutes":"Период агрегирования данных для сервиса UPLINK LOAD RATE в минутах",
        "RTT":"RTT",

        "Kaspersky list of infected hosts":"Список зараженных хостов Касперского",
        "Import Kaspersky list of infected hosts":"Импорт списка зараженных хостов Касперского",
        "Enable a service for import Kaspersky list of infected hosts":"Включить сервис импорта списка зараженных хостов Касперского",
        "Id category of malicious hosts":"Id категории вредоностных хостов",
        "Id category of botnet hosts":"Id категории ботнет хостов",
        "Id category of phishing hosts":"Id категории фишинговых хостов",
        "Id category of IoT hosts":"Id категории IoT хостов",


        "Source IP":"IP источника",
        "Destination IP":"IP получателя",
        "Source AS number":"Номер АС источника",
        "Destination AS number":"Номер АС получателя",
        "Source AS title":"Название АС источника",
        "Destination AS title":"Название АС получателя",
        "Subscriber":"Абонент",
        "Subscriber login":"Логин абонента",
        "Host IP":"IP хоста",
        "Host":"Хост",
        "Protocol code":"Код протокола",
        "Protocol identifier":"Идентификатор протокола",
        "Post NAT port":"Порт после NAT",
        "Vchannel":"Vchannel",

        "Device":"Устройство",
        "Referal":"Реферал",
        "User agent":"Агент пользователя",
        "Cookie":"Cookie",
        "Method":"Метод",
        "Result code":"Код результата",
        "Content type":"Тип контента",

        "Subscribers bind mode":"Режим привязки абонентов",
        "0 - 'Default' - Binding by LOGIN if not empty or IP":"0 - 'По умолчанию' - Привязка по LOGIN, если не пустой или IP",
        "1 - 'By IP'":"1 - 'По IP'",
        "2 - 'By LOGIN'":"2 - 'По LOGIN'",
        "Binding by LOGIN if not empty or IP (default)":"Привязка по LOGIN, если не пустой или IP (По умолчанию)",
        "By IP":"По IP",
        "By LOGIN":"По LOGIN",

        "Receivers clickstream":"Ресиверы clickstream",
        "Model settings":"Настройки модели",
        "Company code":"Код компании",
        "Rotate bash":"Выполнить bash",
        "Processing processes number":"Число процессов обработки",
        "Default models":"Модели по умолчанию",
        "Number of dump processing processes":"Количество процессов обработки дампа",
        "You can receive clickstream from multiple operators and provide a Company Code for convenience":"Вы можете принимать кликстрим от нескольких операторов и указать Код компании для удобства",
        "Bash script for processing dumps. By default run_dump_process.sh":"Bash скрипт выполняющий обработку дампов. По умолчанию run_dump_process.sh",

        "Maps settings": "Настройки карты",
        "Map data storage period, days": "Период хранения данных карты, в днях",
        "Add data from FULLFLOW":"Добавлять информацию из FULLFLOW",
        "Interface logs storage period in days": "Период хранения интерфейс-логов, в днях",
        "Lumen logs storage period in days": "Период хранения люмен-логов, в днях",

        "Number of precesses for the default queue": "Количество процессов в обычной очереди",
        "Number of precesses for the default QoE queue": "Количество процессов в обычной очереди QoE",
        "Number of precesses for the long QoE queue": "Количество процессов в длиной очереди QoE",


        "Number of precesses for the backgrounds QoE queue": "Количество процессов в фоновой очереди QoE",
        "Number of precesses for the custom protocols QoE queue": "Количество процессов в очереди обработки кастомных протоколов",


        "Number of precesses for the default LI queue": "Количество процессов в обычной очереди LI",
        "Number of precesses for the long LI queue": "Количество процессов в длиной очереди LI",
        "Number of precesses for the default ULR queue": "Количество процессов в обычной очереди ULR",
        "Number of precesses for the long ULR queue": "Количество процессов в длиной очереди ULR",
        "Number of free precesses for the default ULR queue": "Количество свободных процессов в обычной очереди ULR",
        "Number of free precesses for the default QoE queue": "Количество свободных процессов в обычной очереди QoE",
        "if": "если",
        "else": "иначе",
        "Catalog server": "Каталог сервер",
        "PDI number. If the value is -1 or not specified, then the DPI number is determined by the order of the receiver in the list.":"Номер PDI. Если значение равно -1 или не указано, то номер PDI определяется порядком получателя в списке.",
        "Period of clearing custom protocols queue logs in days": "Период хранения логов очередей пользовательских протоколов в днях",
        "VasCloud settings": "Настройки VasCloud",
        "Period of clearing traffic decoding queue logs in days": "Период хранения логов очередей разбора трафика в днях",
        "If a token is specified, authorization is performed using the token. If not specified, by login and password.":"Если задан токен, авторизация производится по токену. Если не задан, по логину и паролю.",

        "Enable force moving data":"Включить принудительное перемещение данных",
        "Attention! By default, data deletion on this drive is enabled.":"<strong>Внимание!</strong> По умолчанию включено удаление данных на этом диске.",
        "for DEFAULT disk":"для DEFAULT диска",
        "for HOT disk":"для HOT диска",
        "for COLD disk":"для COLD диска",
        "Move factor":"Коэффициент перемещения",
        "The amount of free space before force moving enabled":"Количество свободного места до включения принудительного перемещения",
        "Enable data removing!":"Включить удаление данных!",
        "Enable move to":"Включить перемещение на",
        "Autoload MCC and MNC dictionaries":"Автозагрузка словарей MCC и MNC",
        "Enables autoload of MCC and MNC dictionaries":"Включает автозагрузку словарей MCC и MNC",

        "Availability of porn images": "Наличие порно изображений",

        "Nudes images and videos": "Порно изображения и видео",
        "Threshold": "Вероятность",
        "Porn Category Code": "Код порно категории",
        "Limit": "Лимит",
        "Timeout": "Время ожидания",
        "Mark only": "Только отмечать",
        "Amount of threads": "Количество потоков",

        "Enabled image processing":"Включить обработку изображений",
        "Enabled video processing":"Включить обработку видео",
        "Enables/disables image processing for the presence of porn in them": "Включает/отключает обработку изображений на предмет наличия в них порнографии",
        "Enables/disables video processing for the presence of porn in them": "Включает/отключает обработку видео на предмет наличия в них порнографии",
        "Adjusts the probability of recognition from 0 to 1. The higher the value, the more likely the image will NOT fall into the category of pornography.": "Регулирует вероятность распознавания от 0 до 1. Чем выше значение, тем больше вероятность, что изображение НЕ попадет в категорию порнографии.",
        "Adjusts the probability of recognition from 0 to 1. The higher the value, the more likely the video will NOT fall into the category of pornography.": "Регулирует вероятность распознавания от 0 до 1. Чем выше значение, тем больше вероятность, что видео НЕ попадет в категорию порнографии.",
        "The category to which the recognized pornography will be moved": "Категория, в которую будет перемещена распознанная порнография",
        "Number of images uploading from the host": "Количество изображений, загружаемых с хоста",
        "Number of videos uploading from the host": "Количество видео, загружаемых с хоста",
        "Waiting time if the picture is not loaded": "Время ожидания, если картинка не загружена",
        "Waiting time if the video is not loaded": "Время ожидания, если видео не загружено",
        "Hosts on which pornographic images have been recognized, if this option is enabled, will only be marked, otherwise these hosts will be automatically moved to the porn category": "Хосты, на которых были распознаны порнографические изображения, если эта опция включена, будут только отмечены, иначе эти хосты будут автоматически перемещены в категорию порно",
        "Hosts on which pornographic videos have been recognized, if this option is enabled, will only be marked, otherwise these hosts will be automatically moved to the porn category": "Хосты, на которых были распознаны порнографические видео, если эта опция включена, будут только отмечены, иначе эти хосты будут автоматически перемещены в категорию порно",
        "This field allows you to configure amount of processor threads that will be used to downloading images.</br></br>Default is 1": "Это поле позволяет вам настроить количество потоков процессора, которые будут использоваться для загрузки изображений.</br></br>По умолчанию 1",
        "This field allows you to configure amount of processor threads that will be used to downloading videos.</br></br>Default is 1": "Это поле позволяет вам настроить количество потоков процессора, которые будут использоваться для загрузки видео.</br></br>По умолчанию 1",
        "Default models (to specify multiple models, list them via ',').":"Модели по умолчанию (чтобы указать несколько моделей, добавьте их после ',').",
        "This field allows you to set the minimum number of characters for the text classifier.</br>If there are not enough characters in the text, the site will be placed in the category 'unknown'.</br></br>Default is 150":"Это поле позволяет вам установить минимальное количество символов для текстового классификатора.</br>Если в тексте недостаточно символов, сайт будет помещен в категорию 'unknown'.</br></br>По умолчанию 150",
        "Category code to recheck.</br></br>Default is 'unknown'":"Код категории для повторной проверки.</br></br>По умолчанию 'unknown'",
        "Default is 0.5":"По умолчанию - 0.5",
        "Maximum video size":"Максимальный размер видео ",
        "Maximum video size in megabytes</br></br>Default is 50":"Максимальный размер видео в мегабайтах</br></br>По умолчанию - 50",

        "Minimum text length":"Минимальная длина текста",
        "Recheck category":"Перепроверить категорию",
        "Hosts recheck":"Перепроверка хостов",
        "Dump size for category recheck":"Размер дампов для процесса перепроверки категорий",
        "Amount of threads for category recheck process":"Кол-во потоков для для процесса перепроверки категорий",
        "General":"Общие",
        "Logs level":"Уровни логов",
        "Captcha server":"Captcha сервер",
        "This field allows you to configure dump size for category recheck</br></br>Default is 1000":"Это поле позволяет вам настроить размер дампов для процесса перепроверки категорий.</br></br> По умолчанию 1000",
        "This field allows you to configure amount of threads for category recheck</br>":"Это поле позволяет вам настроить кол-во потоков для процесса перепроверки категорий</br>",

        "Cluster settings":"Настройки кластера",
        "MariaDB Galera Cluster hosts":"Хосты MariaDB Galera Cluster",
        "Comma separated IPs or hostsnames":"IP-адреса или имена хостов, разделенные запятыми",
        "GlusterFS hosts":"Хосты GlusterFS",
        "Cluster primary host":"Основной хост кластера",
        "IP or hostname where data synchronization should be performed":"IP или имя хоста, где должна выполняться синхронизация данных",
        "VIP subscriber": "VIP абонент",
        "Backup settings": "Настройки резервного копирования",
        "Enable DB backup": "Включить резервное копирование БД",
        "Backup DB time interval, hours": "Временной интервал резервного копирования БД, часы",
        "Backup DB save path": "Путь для сохранения бэкапов БД",
        "Enable FS backup": "Включение резервного копирования файлов",
        "Backup FS time interval, hours": "Временной интервал резервного копирования файлов, часы",
        "Backup FS save path": "Путь для сохранения бэкапов файлов",
        "Default path is": "Путь по умолчанию",
        "Delete old DB backups interval, hours": "Время удаления старых бэкапов БД, часы",
        "0 - don`t delete": "0 - не удалять",
        "Delete old FS backups interval, hours": "Время удаления старых бэкапов файлов, часы",
        "Remote server host for storing backups": "Хост удаленного сервера для хранения резервных копий",
        "Remote server port for storing backups": "Порт удаленного сервера для хранения резервных копий",
        "Backup storage username": "Имя пользователя для хранения резервных копий",
        "Backup storage password": "Пароль для хранения резервных копий",
        "Backup DB remote path": "Путь для хранения резервных копий БД на удаленном сервере",
        "Backup FS remote path": "Путь для хранения резервных копий файлов на удаленном сервере",
        "Folder should be exist": "Папка должна существовать",
        "User should have permissions for this folder": "У пользователя должны быть права доступа к этой папке",
        "SCP will use public key for user authorization if password does not set!": "SCP будет использовать авторизацию по ключу, если пароль не задан!",


        "How to receive access token": "Как получить токен",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:qoestor:dictionaries:opencellid:start": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_components:qoestor:dictionaries:opencellid",

        "Backup restoration settings": "Настройки восстановления из резервных копий",
        "Enable DB restoration from backup": "Включить восстановление БД из резервных копий",
        "DB backup folder": "Папка с резервными копиями БД",
        "Enable FS restoration from backup": "Включить восстановление файлов из резервных копий",
        "FS backup folder": "Папка с резервными копиями файлов",
        "Backup DB time interval, minutes": "Временной интервал резервного копирования БД, минуты",
        "Delete old DB backups interval, minutes": "Время удаления старых бэкапов БД, минуты",
        "Backup FS time interval, minutes": "Временной интервал резервного копирования файлов, минуты",
        "Delete old FS backups interval, minutes": "Время удаления старых бэкапов файлов, минуты",
        "Enable DB auto restoration from backup": "Включить авто восстановление БД из резервных копий",
        "Enable FS auto restoration from backup": "Включить авто восстановление файлов из резервных копий",
        "Backup auto restoration settings": "Настройки авто восстановления из резервных копий",

        "Telegram settings": "Настройки Telegram",
        "Enable telegram bot": "Включить telegram бот",
        "Telegram bot API token": "Токен API Telegram бота",

        "Language for mailing":"Язык рассылки",
        "Language for export files in triggers":"Язык для экспортируемых файлов в триггерах",
        "Enable value formatting for export file in triggers":"Включить форматирование значений в экспортируемых файлах в триггерах",
        "Trigger settings": "Настройки Триггеров",
        "Export settings":"Настройки экспорта",
            
        "Share usage statistics with VAS Experts": "Делиться статистикой об использовании с VAS Experts",
        "By enabling this functionality, you help us improve the product. No confidential information is transferred. (enabled by default)": "Включив данный функционал, вы помогаете нам в улучшении продукта. Никакой конфиденциальной информации не передается. (по умолчанию включено)",
        "Period of clearing statictics queue logs in days": "Период хранения логов очередей статистики в днях",
        "Period of clearing collected statistics logs in days": "Период хранения логов собираемой статистики в днях",

        "Users actions storage period in days": "Период хранения действий пользователей, в днях",
        "Max page size of QoE query": "Максимальный размер страницы для запроса QoE",
        "Default page size of QoE query": "Размер страницы для запроса QoE по умолчанию",
        "DSCP Protocols backup mode": "Режим резервного копирования DSCP Протоколов",
        "QoE Stor: Raw log aggregation settings": "QoE Stor: Агрегация сырого лога",
        "QoE Stor aggregation time interval in hours": "Период агрегации сырого лога QoE Stor в часах",
        "Parallel processing partitions number": "Количество параллельно обрабатываемых партиций",

        "BGP server": "BGP сервер",
        "BGP settings": "Настройки BGP",
        "Path to export prefix dump": "Путь для экспорта дампа префиксов",
        "Path to env for bgp_watcher": "Путь до env для bgp_watcher",
        "BGP dumps loading": "Загрузка  BGP дампов",
        "Enable BGP watcher": "Включить BGP наблюдателя",

        "Order of entries in the ipchannels file by network type":"Порядок записей в файле ipchannels по типу сети",
        "Order of entries in the ipchannels file by the number of network hosts":"Порядок записей в файле ipchannels по количеству хостов в сети",
        "in ascending":"по возрастанию",
        "in descending":"по убыванию",
        "first":"сначала",

        "Traffic redirection": "Перенаправление трафика",
        "Session policings": "Сессионные полисинги",
        "Place to store user actions logs": "Место для хранения логов действий пользователя",
        "DB": "БД",
        "Ulr log file": "Файл логов Ulr",
        "Syslog": "Syslog",
        "Place to store ulr logs": "Место для хранения ulr логов",
        "Place to store interface logs": "Место для хранения интерфейс-логов",

        "Syslog facility of interfaces logs":"Категория логов интерфейса в syslog",
        "Syslog facility of user actions logs":"Категория действий пользователя в syslog",
        "Syslog facility of ulr logs":"Категория логов ulr в syslog",
        "Add default ports on export white/black lists": "Добавлять порты по умолчанию при экспорте черных/белых списков",
        "For each IP or PREFIX the following ports will be added": "Для каждого IP или Префикса будут добавленны следующие порты",
        "System settings": "Системные настройки",
        "Web rules lists": "Список Web правил",
        "System Web rule ID": "Идентификатор системного Web правила",
        "Chosen Web rule should be exist": "Выбранное правило должно существовать",
        "Web rule can not be deleted": "Web правило нельзя удалить",
        "System Web rule resources list file path": "Путь к файлу с ресурсами для системного Web правила",
        "File will be loaded from hardware inputed in ULR_BLACK_LIST_DEPLOY_HOST option": "Файл будет загружен с машины указанной в опции ULR_BLACK_LIST_DEPLOY_HOST",

        "PCAP recording": "Запись PCAP",
        "FastPCAP server": "FastPCAP сервер",
        "Blocking IPv6": "Блокировка IPv6",

        "DNS flow": "DNS флоу",
        "DNS AGG log settings": "Настройки журнала DNS AGG",
        "Subscriber IP": "IP абонента",
        "Fields to save when aggregating DNS flow log": "Поля для сохранения при агрегировании журнала DNS флоу",
        "DNS port": "Порт DNS",
        "Subscriber port": "Порт абонента",
        "DNS transport": "DNS транспорт",
        "DNS host": "Хост DNS",
        "Time interval for aggregating DNS flow logs": "Интервал времени для агрегирования логов DNS флоу",
        "Vchannel numbers": "Номера каналов",

        "Hide display of protocol number in exported PDF format": "Скрыть отображение номера протокола в экспортируемом PDF-формате",

        "Shards": "Шарды",
        "Replicas": "Реплики",
        "Enter the correct IP address,port number, user and password": "Введите корректный IP адрес, номер порта, имя пользователя и пароль",
        "In each shard, you can set multiple replicas, Use comma to add several items.": "В каждом Шарде можно указать несколько реплик. Используйте запятую, чтобы добавить несколько значений.",
        "The replica is set in host/port/user/password format": "Реплика задается в формате host/port/user/password",

        "Balancer server": "Сервер IPFIX-балансира",
        "Sync is running. Started at": "Синхронизация запущенна. Начало ",
        "Subscribers is loaded at": "Абоненты синхронизированны от",
        "Vchannels is loaded at": "Каналы синхронизированны от",
        "Subscribers sync is failed. Last started at": "Синхронизация абонентов закончилась ошибкой. Последняя попытка от",
        "Vchannels sync is failed. Last started at": "Синхронизация каналов закончилась ошибкой. Последняя попытка от",

        "Autoload AS numbers prefixes dictionary":"Автозагрузка словаря префиксов номеров АС",
        "Enables autoload of AS numbers prefixes dictionary":"Включает автозагрузку словаря префиксов номеров АС",
        "URL for downloading AS numbers prefixes dictionary":"URL для загрузки словаря префиксов номеров АС",
        "Use AS number prefixes in inserts":"Использовать префиксы номеров АС во вставках",

        "Spoof DNS": "DNS-ответ",

        "WiKi server": "WiKi сервер",
        "FastSig server": "FastSig сервер",


        "SSH keys management": "Управление SSH ключами",

        "Balancer taskset": "Номер ядра балансира",
        "This parameter is responsible for determining which core ipfix-balancer is running on.": "Данный параметр отвечает за определение на каком ядре работает ipfix-балансир",
        "This parameter is responsible for determining which core QoE Stor is running on.": "Данный параметр отвечает за определение на каком ядре работает QoE Stor",
        "Default value is 0.": "Значение по умолчанию 0.",
        "Default value is -1.": "Значение по умолчанию -1.",
        "Default value is empty.": "Значение по умолчанию пустое.",

        "BL Revisor server": "BL Revisor сервер",
        "Export lists to BL Revisor": "Выгрузка списков в BL Revisor",
        "Rules for export to BL Revisor": "Правила для выгрузки в BL Revisor",
        "Enter a rule ID or a comma separated list of rule IDs": "Введите ИД правила или список ИД правил через запятую",
        "Path to save lists in BL Revisor": "Путь для сохранения списков в BL Revisor",

        "Set the user to see only their own tasks or also tasks of other users.":"Установите что бы пользователь видел только свои задачи или также задачи других пользователей.",
        "Tasks of all users":"Задачи всех пользователей",
        "Only user tasks":"Только задачи пользователя",
        "Tasks visibility":"Видимость задач",
        "Tasks management":"Управление задачами",
        "Maximum task priority":"Максимальный приоритет задач",
        "Run task out of queue":"Запуск задач вне очереди",
        "Set whether the user can manage tasks:":"Установите, может ли пользователь управлять задачами:",
        "enable/disable task":"вкл/выкл задачи",
        "edit task":"редактирование задачи",
        "copy task":"копирование задачи",
        "delete task":"удаление задачи",
        "Maximum task priority for user task.":"Максимальный приоритет задач пользователя.",
        "Set whether the user can run tasks out of turn.":"Установите, может ли пользователь запускать задачи вне очереди.",
        "QoE table": "Таблица QoE",
        "Settings": "Настройки",
        "Filter": "Фильтр",
        "Should be selected at least 1 column": "Должна быть выбрана хотя бы одна колонка",
        "Columns": "Колонки",
        "Imported resource lifetime, days": "Время жини ресурсов, в днях",
        "Input correct number": "Введите корректное число",
        "Requests interval, minutes": "Периодичность запросов, в минутах",
        "Minimal interval is 5 minute.": "Минимальный интервал - 5 минут.",
        "Error! Can not read import file.": "Ошибка! Невозможно прочитать импортируемый файл.",

        "CIDR - static prefix":"CIDR - статический префикс",
        "BGP - dynamic prefix":"BGP - динамический префикс",

        "Link to the application. It`s used by scripts for import from QoE resources for custom protocols and web rules.": "Ссылка на приложение. Используется скриптами импорта ресурсов из QoE для кастомных протоколов и Web правил.",
        "By default is using the APP_URL value": "По умолчанию используется значение настройки APP_URL",
        "Import from QoE application URL": "Урл приложения для импорта из QoE",

        "AAA log settings":"Настройки журнала AAA",
        "FILL_IP_LOGIN_BINDING_FROM_AAA_title":"Включить заполнение словаря IP-Login из потока AAA",
        "FILL_IP_LOGIN_BINDING_FROM_AAA_descr":"Параметр включает формирование словаря IP - Login из AAA - потока.",
        "AAA_REPLACE_LOGIN_IP_LOGIN_BIND_title":"Включить замену поля Login в сырых логах",
        "AAA_REPLACE_LOGIN_IP_LOGIN_BIND_descr":"Параметр включает подмену поля Login в сырых логах fullflow и clickstream на основе данных из AAA. Параметр FILL_IP_LOGIN_BINDING_FROM_AAA должен быть включен.",
        "Always replace":"Заменять всегда",
        "Replace only if the Login field is empty":"Заменять только, если Login пустой",

        "FILL_ACC_STATE_FROM_AAA_title":"Включить создание таблицы состояний AAA",
        "FILL_ACC_STATE_FROM_AAA_descr":"Включает формирование таблицы состояний по данным их AAA. Таблица необходима для дальнейшего заполнения таблиц UDR  для fullflow и clickstream.",

        "FILL_UDR_FULLFLOW_title":"Включить создание UDR из fullflow",
        "FILL_UDR_FULLFLOW_descr":"Включает формирование таблицы UDR на основе fullflow. Параметр FILL_ACC_STATE_FROM_AAA должен быть включен.",

        "FILL_UDR_CLICKSTREAM_title":"Включить создание UDR из clickstream",
        "FILL_UDR_CLICKSTREAM_descr":"Включает формирование таблицы UDR на основе clickstream. Параметр FILL_ACC_STATE_FROM_AAA должен быть включен.",

        "UDR_FULLFLOW_FILTER_title":"Фильтр для UDR fullflow",
        "UDR_FULLFLOW_FILTER_descr":"При создании UDR на основе  fullflow предусмотрен фильтр для отсева лишних данных, например по протоколам. Фильтр заполняется только специалистом через обращение в техническую поддержку.",

        "UDR_CLICKSTREAM_FILTER_title":"Фильтр для UDR clickstream",
        "UDR_CLICKSTREAM_FILTER_descr":"При создании UDR на основе clickstream предусмотрен фильтр для отсева лишних данных, например по протоколам. Фильтр заполняется только специалистом через обращение в техническую поддержку.",

        "UDR_SCP_title":"SCP сервер",
        "UDR_SCP_descr":"Сервер в формате login@host. Если параметр заполнен, все создаваемые UDR будут отправлены по SCP на указанный сервер. Для отправки необходимо предварительно настроить авторизацию на удаленном сервер по ключу.",

        "UDR_SCP_PORT_title":"Порт SCP сервера",
        "UDR_SCP_PORT_descr":"Порт удаленного сервера. По умолчанию 22.",

        "UDR_FULLFLOW_FORMAT_title":"Формат файлов UDR fullflow",
        "UDR_FULLFLOW_FORMAT_descr":"Формат итоговых файлов UDR.",

        "UDR_CLICKSTREAM_FORMAT_title":"Формат файлов UDR clickstream",
        "UDR_CLICKSTREAM_FORMAT_descr":"Формат итоговых файлов UDR.",


        "UDR_FULLFLOW_DIST_MODE_title":"Включить кластерный режим формирования UDR для fullflow.",
        "UDR_FULLFLOW_DIST_MODE_descr":"В данном режиме итоговые UDR формируются путем выполнения распределенного запроса, агрегирующего данные со всех узлов кластера.",
        "UDR_CLICKSTREAM_DIST_MODE_title":"Включить кластерный режим формирования UDR для clickstream.",
        "UDR_CLICKSTREAM_DIST_MODE_descr":"В данном режиме итоговые UDR формируются путем выполнения распределенного запроса, агрегирующего данные со всех узлов кластера.",

        "UDR_FULLFLOW_TIME_INTERVAL_title":"Интервал UDR fullflow",
        "UDR_CLICKSTREAM_TIME_INTERVAL_title":"Интервал UDR clickstream",
        "UDR_FULLFLOW_TIME_INTERVAL_descr":"Интервал времени, за который группируются данные для UDR fullflow. По умолчанию 15 минут.",
        "UDR_CLICKSTREAM_TIME_INTERVAL_descr":"Интервал времени, за который группируются данные для UDR clickstream. По умолчанию 15 минут.",

        "UDR_FULLFLOW_PERIOD_FROM_title":"Период экспорта данных UDR fullflow (C)",
        "UDR_FULLFLOW_PERIOD_TO_title":"Период экспорта данных UDR fullflow (По)",
        "UDR_CLICKSTREAM_PERIOD_FROM_title":"Период экспорта данных UDR clickstream (C)",
        "UDR_CLICKSTREAM_PERIOD_TO_title":"Период экспорта данных UDR clickstream (По)",

        "UDR_PERIOD_descr":"Укажите временной интервал, за который необходимо выгружать записи UDR.<br/><br/>Начало периода (С): now()-30*60 (по умолчанию: 30 минут назад)<br/>Конец периода (ПО): now()-15*60 (по умолчанию: 15 минут назад)",

        "DDoS attack log settings":"Настройки журнала DDoS атак",
        "Time interval for aggregating DDoS attack logs":"Интервал времени для агрегирования логов DDoS атак",
        "Fields to save when aggregating DDoS attack log":"Поля для сохранения при агрегировании журнала DDoS атак",
        "Automatic update of the geodata dictionary":"Автообновление словаря геоданных",
        "UDR_FULLFLOW_DATE_TIME_FORMAT_title":"Форматы даты-времени для UDR fullflow",
        "UDR_CLICKSTREAM_DATE_TIME_FORMAT_title":"Форматы даты-времени для UDR clickstream",
        "UDR_DATE_TIME_FORMAT_descr":"Timestamp — это формат по умолчанию. <br/>Вы можете установить любой другой формат, например, %Y%m%d%H%i%S"
    };

webix.i18n.locales["ru-RU"].dpiui2.Roles =
    {
        "Are you sure you want to delete the role?":"Вы действительно хотите удалить роль?",

        "Roles":"Роли",
        "Add role":"Добавить роль",

        "Role":"Роль",

        "Program sections":"Разделы программы",
        "Code":"Код",
        "Section":"Раздел",
        "Read":"Чтение",
        "Record":"Запись"
    };

webix.i18n.locales["ru-RU"].dpiui2.Users =
    {
        "Are you sure you want to delete the user?":"Вы действительно хотите удалить пользователя?",
        "User name":"Имя пользователя",
        "Enter user name":"Введите имя пользователя",
        "Full name":"ФИО",
        "Enter full name":"Введите ФИО полностью",
        "Enter e-mail":"Введите e-mail",
        "Phone":"Телефон",
        "Enter phone number":"Введите номер телефона",
        "Company":"Компания",
        "Enter the name of the organization":"Введите название организации",
        "Position":"Должность",
        "Enter the position":"Введите должность",
        "Role":"Роль",

        "Passwords do not match":"Пароли не совпадают",

        "New password":"Новый пароль",
        "Enter password":"Введите пароль",
        "Confirm password":"Подтвердить пароль",

        "Add user":"Добавить пользователя",
        "Users":"Пользователи"
    };

webix.i18n.locales["ru-RU"].dpiui2.UsersActionsLog =
    {
        "Users actions log":"Журнал действий пользователей",
        "Row id":"Номер строки",
        "Hardware name":"Оборудование",
        "Section":"Раздел",
        "Action":"Действие",
        "Differences":"Различия",
        "Old value":"Старое значение",
        "New value":"Новое значение",
        "Create time":"Время создания",
        "Update time":"Время обновления",
        "Create user":"Создавший пользователь",
        "Update user":"Обновивший пользователь",
        "Configuration DPI":"Конфигурация DPI",
        "Configuration QoE":"Конфигурация QoE",
        "Configuration GUI":"Конфигурация GUI",
        "Configuration Balancer": "Конфигурация IPFIX-балансира",
        "Tariff plans":"Тарифные планы",
        "Protocol prioritization": "Приоритизация по протоколам",
        "Priority for ASN": "Приоритизация по ASN",
        "Start":"Старт",
        "Stop":"Стоп",
        "Create":"Создание",
        "Edit":"Изменение",
        "Delete":"Удаление",
        "Restart Queue":"Перезапуск",
        "Updating hot options":"Обновление горячих параметров",
        "Tariff name":"Имя тарифа",
        "Tariff type":"Тип тарифа",
        "Status":"Статус",
        "Profile":"Профиль",
        "Schedule":"Расписание",
        "Personal":"Индивидуальный",
        "Enabled":"Включен",
        "Disabled":"Выключен",
        "Configuration changes":"Изменения конфигурации",
        "Current configuration":"Текущая конфигурация",
        "Tariff schedule changes":"Изменения расписания тарифа",
        "Schedule Disabled":"Выключено",
        "Schedule Enabled":"Включено",
        "IPv4 and AS changes":"IPv4 и AS изменения",
        "IPv6 and AS changes":"IPv6 и AS изменения",
        "AS and DSCP changes":"AS и DSCP изменения",

        // Black and white lists
        "Black and white lists":"Черные и белые списки",
        "List name":"Имя списка",
        "List type":"Тип списка",
        "Black list":"Черный список",
        "White list":"Белый список",
        "URL to redirect":"URL для переадресации",
        "Use federal":"Использование федеральных списков",
        "Federal Enabled":"Включено",
        "Federal Disabled":"Выключено",
        "Synchronization status": "Статус синхронизации",
        "Synchronization changes": "Изменение синхронизации",
        "Synchronization period in hours": "Период синхронизации в часах",
        "Resources list changes":"Изменения ресурсов списка",
        "Category":"Категория",
        "Resources limit":"Лимит ресурсов",
        "Type":"Тип",
        "Resource":"Ресурсы",
        "deleted over":"удалено более",
        "resources":"ресурсов",

        // Subscribers
        "Subscribers L2-props deleted":"L2-свойства абонента удалены",
        "Subscribers L2-props edited":"L2-свойства абонента изменены",
        "Could not determine the specified service": "Не удалось определить заданную услугу",
        "Could not determine the specified profile": "Не удалось определить заданный профиль",
        "Failed to determine the set tariff": "Не удалось определить заданный тариф",
        "Subscriber changes": "Изменение абонента",
        "Auth status": "Статус авторизации",
        "Auth expired": "Срок действия",
        "Policing": "Тариф",
        "Services profiles": "Профили услуг",
        "Subscribers auth cleared":"Авторизация абонентов очищена",
        "Subscribers auth changed":"Авторизация абонентов изменена",
        "All subscribers":"Все абоненты",
        "Session type": "Тип сессии",
        "Session status": "Статус сессии",
        "MAC address": "MAC адрес",
        "VLAN or QinQ": "VLAN или QinQ",
        "in_dev interface index": "Индекс in_dev интерфейса",
        "Expiration time": "Время окончания срока действия",
        "Output MAC address": "Выходной MAC адрес",
        "Output VLAN=NN": "Выходной VLAN=NN",
        "Disable local connect for subscriber": "Отключить локальное подключение для абонента",
        "'route via' property": "Свойство 'route via'",
        "IPv4 subnet mask": "IPv4 маска подсети",
        "Opt82 CircuitId": "Opt82 CircuitId",
        "Opt82 RemoteId": "Opt82 RemoteId",
        "Bind type": "Тип привязки",

        "Column": "Колонка",
        "Login":"Вход",
        "Logout":"Выход",

        "Search":"Поиск",
        "Interface":"Интерфейс",
        "Navigation":"Навигация",
        "Viewing the report":"Просмотр отчета",
        "Creating report cache":"Создание кэша отчета",
        "Export report":"Экспорт отчета",

        "Receivers restarted":"Ресиверы перезапущены",
        "Receivers stopped":"Ресиверы остановлены"
    };

webix.i18n.locales["ru-RU"].dpiui2.DpiInfo =
    {
        "Device information":"Информация об устройстве",
        "Property":"Свойство",
        "Value":"Значение",
    };

webix.i18n.locales["ru-RU"].dpiui2.Hardwares =
    {
        "Do you really want to delete the equipment?":"Вы действительно хотите удалить оборудование?",
        "Name":"Название",
        "Enter the title":"Введите название",
        "Host":"Хост",
        "Enter Ip":"Введите Ip или хост",
        "Port":"Порт",
        "Enter Port":"Введите Порт",
        "Login":"Логин",
        "Enter login":"Введите Логин",
        "Password":"Пароль",
        "Enter password":"Введите Пароль",
        "Sudo user":"Sudo пользователь",
        "Enable sync":"Включить синхронизацию",
        "Type":"Тип",
        "Hardware type": "Тип оборудования",
        "Enter hardware type": "Введите тип оборудования",

        "Hardware Management":"Управление оборудованием",
        "Equipment":"Оборудование",
        "Add equipment":"Добавить оборудование",

        "Hardware settings":"Настройки оборудования",
        "Ipfix settings":"Настройки IPFIX",
        "Id on ipfix collector":"Идентификатор на IPFIX коллекторе",
        "IPFIX ID":"ИД IPFIX",

        "Enable subscribers sync":"Синхр. абонентов",
        "Enable logs sync":"Синхр. стат. логов",
        "Enable CGNAT sync":"Синхр CGNAT",

        "Synchronization settings":"Настройки синхронизации",
        "Enable subscribers auth status sync": "Синхр. статусов абонентов",

        "ID":"ИД",
        "Version": "Версия",
        "Sync tool version": "Синхронизация версии",
        "Do you really want to sync tool version for the equipment?": "Вы действительно хотите синхронизировать версию оборудования?",
        "Sync": "Синхронизировать",
        "Tool version successfully synced": "Версия оборудования успешно синхронизирована",
        "Ssh connection": "Ssh соединение",
        "Scp command": "Scp команда",
        "File sending": "Отправка файла",
        "Internet connection": "Доступ в интернет",
        "Property": "Свойство",
        "State": "Состояние",
        "Hardware state": "Состояние оборудования",
        "Auth type": "Тип авторизации",
        "By password": "По паролю",
        "By key": "По ключу",

        "SUDO_USER_HELP_POPUP": "Создание пользователя sudo для подключения к оборудованию - <a href='https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_components:dpiui:user_guide:admin_section:equipment_management:sudo_user' target='_blank'>статья</a>."
    };

webix.i18n.locales["ru-RU"].dpiui2.DpiLogs =
    {
        "Log of information messages and errors":"Лог информационных сообщений и ошибок",
        "Statistics log":"Лог статистики",
        "Message log loaded":"Лог сообщений загружен",
        "Statistics log loaded":"Лог статистики загружен"
    };

webix.i18n.locales["ru-RU"].dpiui2.HardwareLogs =
    {
        "Files":"Файлы",
        "File":"Файл",
        "Log file content":"Содержимое лог файла",
        "Search (Grep)": "Поиск (Grep)",
        "FastDPI > FastPCRF interaction":"FastDPI > FastPCRF взаимодействие",
        "Requests and answers to Radius servers":"Запросы и ответы на Radius-серверы",
        "Accounting":"Аккаунтинг",
        "FastPCRF > FastDPI interaction":"FastPCRF > FastDPI взаимодействие",
        "Network interfaces status and services":"Состояние сетевых интерфейсов и услуги",
        "Network interfaces status":"Состояние сетевых интерфейсов",
        "BRAS DHCP logs (none-default)":"Журналы DHCP BRAS (не по умолчанию)",
        "Lines":"Строки",
        "Lines before and after the match":"Кол-во строк до и после соответствия"
    };

webix.i18n.locales["ru-RU"].dpiui2.Notifications =
    {
        "Read selection":"Прочитать выделенное",
        "Delete selection":"Удалить выделенное",
        "Messages":"Сообщения",
        "Message":"Сообщение",
        "Read":"Прочитано",
        "Equipment":"Оборудование",
        "Importance":"Важность",
        "Are you sure you want to delete the selected records?": "Вы уверены, что хотите удалить все выбранные записи?",
        "Are you sure you want to delete all the records?": "Вы уверены, что хотите удалить все записи?",
        "Read notifications": "Пометить как прочитанные",
        "Read selected": "Прочитать выбранные",
        "Read all": "Прочитать все",
        "Delete notifications": "Удалить нотификации",
        "Delete selected": "Удалить выбранные",
        "Delete all": "Удалить все"
    };

webix.i18n.locales["ru-RU"].dpiui2.CreateTicket =
    {
        "Send a message":"Отправить сообщение",
        "Message subject":"Предмет сообщения",
        "Message text":"Текст сообщения",
        "Enter here any text":"Введите сюда любой текст",
        "DPI message Log":"Лог сообщений DPI",
        "Log of information messages and errors":"Лог информационных сообщений и ошибок",
        "DPI statistics log":"Лог статистики DPI",
        "UI log":"UI лог",
        "Send":"Отправить",
        "Message sent successfully":"Сообщение успешно отправлено",
        "Protocol":"Протокол",
        "Additional email":"Дополнительный email"
    };

webix.i18n.locales["ru-RU"].dpiui2.Advc = {
    "Profile saved": "Профиль сохранен",
    "Group saved": "Группа сохранена",
    "Deleted": "Профиль удален",
    "Add new adv profile": "Добавить новый профиль",
    "Add new adv group": "Добавить новую группу",
    "Add adv sub profile": "Добавить подпрофиль",
    "Add adv sub group": "Добавить подгруппу",
    "Campaign saved": "Кампания сохранена",
    "Profile": "Профиль",
    "Group": "Группа",
    "Cancel": "Отменить",
    "Save": "Сохранить",
    "Delete": "Удалить",
    "Are you sure you want to delete this profile? All advertising campaigns associated with this profile will be deleted.": "Вы действительно хотите удалить этот профиль? Все рекламные кампании, свзанные с данным профилем будут удалены.",
    "Are you sure you want to delete this group? All advertising campaigns associated with this group will be deleted.": "Вы действительно хотите удалить эту группу? Все рекламные кампании, свзанные с данной группой будут удалены.",
    "Title": "Название",
    "Hardware group": "Группа оборудования",
    "Responsible": "Ответственный",
    "Campaign Dates / Time": "Даты/время кампании",
    "Days of the week": "Дни недели",
    "Bundle": "Пачка",
    "Total": "Всего",
    "Redirect URL": "URL перенаправления",
    "Are you sure you want to delete this campaign?": "Вы действительно хотите удалить эту кампанию?",
    "Service Management": "Управление услугами",
    "Advertising": "Реклама",
    "Profiles": "Профили",
    "Groups": "Группы",
    "Add a lock to the list": "Добавить блокировку в список",
    "Campaigns": "Кампании",
    "Campaign": "Кампания",
    "Period": "Период",
    "Status": "Результат",
    "Done": "Выполнено",
    "Campaign settings": "Настройки кампании",
    "Campaign data": "Данные кампании",
    "Add new campaign data": "Добавить новые данные кампании",
    "Data name": "Наименование параметра",
    "Data type": "Тип параметра",
    "Default value": "По умолчанию",
    "Are you sure you want to delete this subscriber from campaign?":"Вы действительно хотите удалить этого абонента?",
    "String": "Строка",
    "Enumeration": "Перечисление",
    "Import campaign data from file": "Загрузить данные рекламной кампании",
    "Add campaign data": "Добавить данные кампании",
    "Click to download or drag a file": "Нажмите, чтобы загрузить или перетащите файл",
    "Import":"Импортировать",
    "Campaign data saved": "Данные кампании сохранены",
    "Add campaign": "Добавить кампанию",
    "Subscriber": "Абонент",
    "Notification date": "Дата нотификации",
    "Profiles and campaigns": "Профили и кампании",
    "Groups and campaigns": "Группы и кампании",
    "Campaign subscribers": "Абоненты кампании",
    "Campaign period": "Период кампании",
    "Campaign time": "Время проведения кампании",
    "Title can not be empty": "Название не может быть пустым",
    "Date of campaign should be filled": "Дата проведения кампании должны быть заполены",
    "Should be selected at least one day of week": "Должен быть выбран хотя бы один день недели",
    "Bundle should be a number": "Пачка должна быть числом",
    "Input correct URL address": "Введите корректный URL адрес",
    "Subscriber should be filled!": "Абонент должен быть заполнен!",
    "Time from": "Время с",
    "Campaign show time": "Время показа кампании",
    "Time to": "Время по",
    "Required field" : "Обязательное поле",
    "Campaign finish time should be filled": "Время конца показа кампании должно быть заполнено правильно",
    "Campaign title": "Название кампании",
    "User responsible for the campaign": "Пользователь ответственный за кампанию",
    "Dates of the advertising campaign": "Даты проведения рекламной кампании",
    "Days of the advertising campaign": "Дни рекламной кампании",
    "Select or create new profile":"Выберите профиль или создайте новый",
    "Select or create new group":"Выберите группу или создайте новую",
    "Select or enter new profile name":"Выберите или введите новое имя профиля",
    "Select or enter new group name":"Выберите или введите новое имя группы",
    "Campaign profile":"Профиль кампании",
    "Campaign group":"Группа кампании",
    "A new profile and campaign will be created. Continue?":"Будут созданы новый профиль и кампания. Продолжить?",
    "A new group and campaign will be created. Continue?":"Будут созданы новая группа и кампания. Продолжить?",
    "Select or create new campaign":"Выберите или создайте новую кампанию",
    "Select or enter new campaign name":"Select or enter new campaign name",
    "A new campaign will be created. Continue?":"Будет создана новая кампания. Продолжить?",
    "How to export subscribers":"Как экспортировать абонентов",
    "By IP-address":"По IP-адресу",
    "By login":"По логину",
    "By IP-address if login is empty":"По IP-адресу если логин пустой",
    "The task of importing successfully launched":"Успешно запущена задача импорта",
    "Start campaign": "Запустить кампанию",
    "Stop campaign": "Остановить кампанию",
    "Enable": "Включить",
    "Enable campaign after saving?": "Запустить кампанию после сохранения?",
    "Campaign enabled": "Кампания запущена",
    "Campaign disabled": "Кампания остановлена",
    "Number of subscribers":"Количество абонентов",
    "All subscribers":"Все абоненты",
    "% subscribers":"% абонентов",
    "Campaign deleted": "Кампания удалена",
    "Campaign state": "Состояние кампании",
    "Get template" : "Получить шаблон",
    "Download the subscirbers file":"Скачать файл с абонентами",
    "Campaign show time (DPI local time)": "Время показа кампании (локальное время DPI)",
    "Forced campaign synchronization": "Принудительная синхронизация кампаний",
    "Forced synchronization campaigns running in the background": "Принудительная синхронизация кампаний запущена в фоновом режиме",
    "Restart campaign for subscriber": "Перезапустить кампанию для абонента",
    "Campaign restarted": "Кампания перезапущена",
    "Restart campaign": "Перезапустить кампанию"
};

webix.i18n.locales["ru-RU"].dpiui2.QoE =
    {
        "Map reports": "Отчеты по картам",
        "Success": "Успех",
        "Service and tracking": "Сервис и трекинг",
        "Subscribers location": "Местоположение абонентов",
        "Subscribers routes": "Маршруты абонентов",
        "Top hosts":"Топ хостов",
        "Top AS":"Топ АС",
        "Top subscriber`s AS":"Топ абонентских АС",
        "Top subscribers":"Топ абонентов",
        "Top devices":"Топ устройств",
        "Top protocols":"Топ протоколов",
        "Top application protocols":"Топ прикладных протоколов",
        "Top application protocols with high traffic":"Топ прикладных протоколов с высоким трафиком",
        "Top application protocols with high traffic volume":"Топ прикладных протоколов с высоким объемом трафика",
        "Top application protocols with high RTT":"Топ прикладных протоколов с высоким RTT",
        "Top switches":"Топ коммутаторов",
        "Top trunk switches":"Топ магистральных коммутаторов",
        "Traffic by protocols":"Трафик по протоколам",
        "Traffic by application protocols":"Трафик по прикладным протоколам",
        "Traffic by AS":"Трафик по АС",
        "Traffic by subscriber`s AS":"Трафик по абонентским АС",
        "Flow by protocols":"Флоу по протоколам",
        "Flow by application protocols":"Флоу по прикладным протоколам",
        "Top hosts IPs":"Топ IP-адресов хостов",
        "RTT by time":"RTT по времени",
        "RTT from subscriber":"RTT от абонента",
        "RTT to subscriber":"RTT к абоненту",
        "RTT median":"RTT медиана",
        "RTT distribution":"RTT распределение",
        "RTT distribution from subscriber":"RTT распределение от абонента",
        "RTT distribution to subscriber":"RTT распределение к абоненту",
        "Top subscribers with high RTT":"Топ абонентов с высоким RTT",
        "Top subscribers with high traffic":"Топ абонентов с высоким трафиком",
        "Top subscribers with high retransmits":"Топ абонентов с высоким % ретрансмитов",
        "Top protocols with high RTT":"Топ протоколов с высоким RTT",
        "Top protocols with high traffic":"Топ протоколов с высоким трафиком",
        "Top protocols with high flow":"Топ протоколов с высоким флоу",
        "Top application protocols with high retransmits":"Топ прикладных протоколов с высоким % ретрансмитов",
        "Top application protocols with high flow":"Топ прикладных протоколов с высоким флоу",
        "Top hosts with high RTT":"Топ хостов с высоким RTT",
        "Top hosts with high traffic":"Топ хостов с высоким трафиком",
        "Top hosts with high traffic volume":"Топ хостов с высоким объемом трафика",
        "Top hosts with high retransmits":"Топ хостов с высоким % ретрансмитов",
        "Top host categories with high RTT":"Топ категорий хостов с высоким RTT",
        "Top host categories with high traffic":"Топ категорий хостов с высоким трафиком",
        "Top host categories with high retransmits":"Топ категорий хостов с высоким % ретрансмитов",
        "Top AS with high RTT":"Топ АС с высоким RTT",
        "Top subscriber`s AS with high RTT":"Топ абонентских АС с высоким RTT",
        "Top AS with high traffic":"Топ АС с высоким трафиком",
        "Top subscriber`s AS with high traffic":"Топ абонентских АС с высоким трафиком",
        "Top AS with high retransmits":"Топ АС с высоким % ретрансмитов",
        "Top subscriber`s AS with high retransmits":"Топ абонентских АС с высоким % ретрансмитов",
        "Top switches with high RTT":"Топ коммутаторов с высоким RTT",
        "Top trunk switches with high RTT":"Топ магистральных коммутаторов с высоким RTT",
        "Retransmits by time":"Ретрансмиты по времени",
        "Top with high traffic":"Топ с высоким трафиком",
        "Top with high RTT":"Топ с высоким RTT",
        "Top with high retransmits":"Топ с высоким % ретрансмитов",
        "Applications & subscribers":"Приложения и абоненты",
        "Top applications by subscribers":"Топ приложений по абонентам",
        "Top applications by growth rate":"Топ приложений по темпам роста",
        "Top applications protocols by subscribers":"Топ прикладных протоколов по абонентам",
        "Top applications protocols groups by subscribers":"Топ групп прикладных протоколов по абонентам",
        "Top applications protocols by growth rate":"Топ прикладных протоколов по темпам роста",
        "Top applications protocols groups by growth rate":"Топ групп прикладных протоколов по темпам роста",
        "Top subscribers by applications":"Топ абонентов по приложениям",
        "Top logins by applications":"Топ логинов по приложениям",
        "Top protocol":"Топ протокол",
        "Top group":"Top группа",
        "Application protocol groups":"Группы прикладных протоколов",
        "Mini":"Мини",
        "Top":"Топ",
        "Reports":"Отчеты",
        "with high RTT":"с высоким RTT",
        "with high traffic":"с высоким трафиком",
        "with high retransmits":"с высоким % ретрансмитов",
        "Group":"Группа",

        "Total":"Всего",
        "Sessions":"Сессии",
        "Hosts":"Хосты",
        "Subscribers":"Абоненты",
        "Subscriber":"Абонент",
        "Login":"Логин",
        "Host":"Хост",
        "User agents":"Агенты пользователя",
        "Top user agents":"Топ агентов пользователя",
        "User agent":"Агент пользователя",
        "Agents":"Агенты",
        "Agents number":"Количество агентов",
        "Devices":"Устройства",
        "Device":"Устройство",
        "Protocol":"Протокол",
        "Host IP":"IP хоста",
        "Hosts IPs":"IP-адреса хостов",
        "Subscriber devices":"Устройства абонента",
        "Devices number":"Количество устройств",
        "Details":"Детали",
        "Application protocol":"Прикладной протокол",
        "Hosts number":"Число хостов",
        "Host IPs number":"Число IP-адресов хостов",
        "Retransmits":"Ретрансмиты",
        "Retransmits from subscriber":"Ретрансмиты от абонента",
        "Retransmits to subscriber":"Ретрансмиты к абоненту",
        "Fragments":"Фрагменты",
        "Protocols":"Протоколы",
        "Application protocols":"Прикладные протоколы",
        "Connections":"Соединения",
        "Totals":"Общие данные",
        "Url":"Урл",
        "Top URLs":"Топ УРЛов",
        "URLs":"УРЛы",
        "Subscribers growth rate":"Темпы роста абонентов",
        "Logins growth rate":"Темпы роста логинов",

        "Threats monitor Widget (Netfow)": "Монитор киберугроз (Нетфлоу)",
        "Threats monitor Widget (Clickstream)": "Монитор киберугроз (Кликстрим)",
        "Malicious traffic": "Вредоносный трафик",
        "Botnet traffic": "Ботнет трафик",
        "Phishing traffic": "Фишинговый трафик",
        "IoT traffic": "Трафиком Интернета вещей (IoT)",
        "Infected subscribers": "Зараженные абоненты",

        "Subscribers with malicious traffic": "Абоненты с вредоносным трафиком",
        "Subscribers with botnet traffic": "Абоненты с ботнет трафиком",
        "Subscribers with phishing traffic": "Абоненты с фишинговым трафиком",
        "Subscribers with IoT traffic": "Абоненты с трафиком Интернета вещей (IoT)",

        "Top infected subscribers":"Топ зараженных абонентов",
        "Top infected subscribers with malicious traffic":"Топ зараженных абонентов с вредоносным трафиком",
        "Top infected subscribers with botnet traffic":"Топ зараженных абонентов с ботнет трафиком",
        "Top infected subscribers with phishing traffic":"Топ зараженных абонентов с фишинговым трафиком",

        "Top infected subscribers (Netflow)":"Топ зараженных абонентов (Нетфлоу)",
        "Top infected subscribers with malicious traffic (Netflow)":"Топ зараженных абонентов с вредоносным трафиком (Netflow)",
        "Top infected subscribers with botnet traffic (Netflow)":"Топ зараженных абонентов с ботнет трафиком (Netflow)",
        "Top infected subscribers with phishing traffic (Netflow)":"Топ зараженных абонентов с фишинговым трафиком (Netflow)",

        "Top infected subscribers (Clickstream)":"Топ зараженных абонентов (Кликстрим)",
        "Top infected subscribers with malicious traffic (Clickstream)":"Топ зараженных абонентов с вредоносным трафиком (Clickstream)",
        "Top infected subscribers with botnet traffic (Clickstream)":"Топ зараженных абонентов с ботнет трафиком (Clickstream)",
        "Top infected subscribers with phishing traffic (Clickstream)":"Топ зараженных абонентов с фишинговым трафиком (Clickstream)",

        "Infected traffic category":"Категория зараженного трафика",

        "Subscribers with undefined RTT":"Абоненты с неопределенным RTT",
        "Subscribers with big RTT":"Абоненты с большим RTT",
        "Subscribers with medium RTT":"Абоненты со средним RTT",
        "Subscribers with small RTT":"Абоненты с маленьким RTT",

        "Widgets, drag from here":"Виджеты, перетащить отсюда",
        "Subscribers RTT":"RTT абонентов",
        "Traffic":"Скорость трафика",
        "Traffic from subscriber":"Скорость трафика от абонента",
        "Traffic from subscribers":"Скорость трафика от абонентов",
        "Traffic to subscriber":"Скорость трафика к абоненту",
        "Traffic to subscribers":"Скорость трафика к абонентам",
        "Flow":"Флоу",
        "Flow from subscriber":"Флоу от абонента",
        "Flow to subscriber":"Флоу к абоненту",
        "Flow from subscribers":"Флоу от абонентов",
        "Flow to subscribers":"Флоу к абонентам",
        "Traffic volume":"Объем трафика",
        "Traffic volume from subscriber":"Объем трафика от абонента",
        "Traffic volume from subscribers":"Объем трафика от абонентов",
        "Traffic volume to subscribers":"Объем трафика к абоненту",
        "Traffic volume to subscriber":"Объем трафика к абонентам",
        "Flow volume":"Объем флоу",
        "Flow volume from subscriber":"Объем флоу от абонента",
        "Flow volume from subscribers":"Объем флоу от абонентов",
        "Flow volume to subscriber":"Объем флоу к абоненту",
        "Flow volume to subscribers":"Объем флоу к абонентам",

        "For all DPI devices":"По всем DPI устройствам",
        "Current DPI device":"Текущее DPI устройство",

        "Group by":"Группировать",
        "By subscribers":"По абонентам",
        "By switches":"По коммутаторам",
        "By access switch":"По ком. доступа",
        "By trunk switch":"По магистральным",
        "By owner":"По собственнику",
        "By name":"По имени",
        "By type":"По типу",
        "By region":"По региону",
        "By address":"По адресу",
        "By operator":"По оператору",
        "By IP-address":"По IP-адресу",
        "By login":"По логину",
        "By unit vendor":"По вендору абон. устройства",
        "By cabel":"По кабелю",
        "By contract":"По договору",
        "By services":"По сервисам",
        "Unit vendor":"Вендор абон. устройства",
        "Cabel":"Кабель",
        "Contract":"Договор",
        "Services":"Сервисы",
        "Switch IP-address":"IP-адрес коммутатора",
        "Switch name":"Название коммутатора",
        "Switch type":"Тип коммутатора",
        "Region":"Регион",
        "Switch address":"Адрес коммутатора",
        "Operator":"Оператор",
        "Owner":"Собственник",

        "By AS":"По АС",
        "By AS number":"По номеру АС",
        "By AS title":"По названию АС",
        "AS number":"Номер АС",
        "AS title":"Название АС",
        "Source AS number":"Номер АС источника",
        "Destination AS number":"Номер АС получателя",
        "By GTP cells":"По GTP cells",

        "Waiting queue":"Ожидание очереди",
        "Processing":"Обработка",
        "Read rows":"Прочитано строк",
        "Read bytes":"Прочитано байт",
        "Total rows":"Всего строк",

        "Clear cache":"Очистить кеш",
        "Cache cleared":"Кеш очищен",

        "We can`t process export to PDF when page size is more then 100":"Мы не можем обработать экспорт в PDF, если размер страницы превышает 100",

        "Clickstream raw log":"Лог кликстрим",
        "Source IPv4-address":"IPv4-адрес источника",
        "Source IPv6-address":"IPv6-адрес источника",
        "Source port":"Порт источника",
        "Destination IPv4-address":"IPv4-адрес получателя",
        "Destination IPv6-address":"IPv6-адрес получателя",
        "Destination port":"Порт получателя",
        "Path":"Путь",
        "Referer":"УРЛ источника запроса",
        "Cookie":"Куки",
        "Session ID":"ИД сессии",
        "Method":"Метод",
        "Result code":"Код результата",
        "Content length":"Размер контента",
        "Content type":"Тип контента",

        "Netflow raw log":"Лог нетфлоу",
        "Flow start time":"Начало флоу",
        "Flow start time in milliseconds":"Начало флоу в миллисекундах",
        "Flow end time":"Окончание флоу",
        "Flow end time in milliseconds":"Окончание флоу в миллисекундах",
        "Source AS":"АС источника",
        "Destination AS":"АС получателя",
        "Octet delta":"Дельта октетов",
        "Packet delta":"Дельта пакетов",
        "Net protocol":"Сетевой протокол",
        "Service class":"Класс сервиса",
        "Input SNMP":"Индекс IP-интерфейса получателя",
        "Output SNMP":"Индекс IP-интерфейса отправителя",
        "IP version":"Версия IP",
        "Post nat source IPv4-address":"IPv4-адрес источника после nat",
        "Post nat source port":"Порт источника после nat",
        "Fragmented packets delta":"Дельта фрагментированных пакетов",
        "Repeated packets delta":"Дельта повторных пакетов",
        "Time":"Время",

        "Spline area":"Сплайн-область",
        "Area":"Область",
        "Stacked area":"Уложенная область",
        "Line":"Линия",
        "Stacked bar chart":"Гистограмма с накоплением",

        "Linear":"Линейный",
        "Logarithmic":"Логарифмический",

        "Top host categories":"Топ категорий хостов",
        "Host categories":"Категории хостов",
        "Host category":"Категория хоста",

        "hcn_undefined":"Не определена",
        "hcn_unknown":"Неизвестна",
        "hcn_software_tools":"Программные средства",
        "hcn_search_engine":"Поисковая система",
        "hcn_0_other":"Другое",
        "hcn_school":"Школа",
        "hcn_proxys":"Прокси",
        "hcn_tabak_alkohol":"Табак, алкоголь",
        "hcn_religia":"Религия",
        "hcn_0_bad_gateway":"Плохой шлюз (HTTP 502)",
        "hcn_porno_sex":"Порно, секс",
        "hcn_nenormativ_lexika":"Ненормативная лексика",
        "hcn_0_forbidden":"Запрещённый (HTTP 403)",
        "hcn_music_sites":"Музыкальные сайты",
        "hcn_game_sites":"Игровые сайты",
        "hcn_video_hostings":"Видео-хостинг",
        "hcn_file_archives":"Файловые архивы",
        "hcn_social_networks":"Социальные сети",
        "hcn_im":"Мессенджеры",
        "hcn_dosug_cafe_kino_restorans":"Досуг, кафе, кинотеатры, рестораны",
        "hcn_goverment":"Правительство",
        "hcn_organizations":"Организации",
        "hcn_telecom_operators":"Телеком операторы",
        "hcn_shops":"Магазины",
        "hcn_forums_18+":"Форумы 18+",
        "hcn_bank_finances":"Банковское дело, финансы",
        "hcn_museum":"Музеи",
        "hcn_medicina_hostitals":"Медицина, больницы",
        "hcn_miners_pools_curs_etc":"Майнеры, пулы, валюта и т.д.",
        "hcn_humor_anectdots":"Юмор, шутки",
        "hcn_job_hunters":"Работа, охотники",
        "hcn_military":"Военные",
        "hcn_news":"Новости",
        "hcn_child_sites":"Детские сайты",
        "hcn_tech_inteface":"Тех. интерфейсы",
        "hcn_ads":"Реклама",
        "hcn_blog":"Блоги",
        "hcn_coocking":"Приготовление еды",
        "hcn_metrics":"Метрика",
        "hcn_forex":"Форекс",
        "hcn_cdn":"Сеть доставки контента",
        "hcn_personal":"Личный",
        "hcn_antivirus":"Антивирусы",
        "hcn_education":"Образование",
        "hcn_gambling":"Азартные игры",
        "hcn_drugs":"Наркотики",
        "hcn_building":"Строительство",
        "hcn_malware":"Вредоносные программы",
        "hcn_blocked":"Блокированный",
        "hcn_classified":"Объявления",
        "hcn_magazins":"Журналы",
        "hcn_sport":"Спорт",
        "hcn_turism":"Туризм",
        "hcn_auto":"Авто",
        "hcn_relocation":"Переселение",
        "hcn_realestate":"Недвижимость",
        "hcn_mail":"Почта",
        "hcn_telecom_operators, call-centre":"Телеком операторы, Call-Centre",

        "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].":"Версия QoE Stor несовместима. Должна быть [COMPATIBLE_VERSION]+. Текущая [CURRENT_VERSION].",

        "Start":"Начало",
        "End":"Конец",
        "Custom range":"Пользовательский диапазон",
        "Quick ranges":"Быстрые диапазоны",

        "Last 5 minutes":"Последние 5 минут",
        "Last 15 minutes":"Последние 15 минут",
        "Last 30 minutes":"Последние 30 минут",

        "This hour":"Этот час",
        "This hour so far":"Этот час и до сейчас",
        "This 2 hours":"Эти 2 часа",
        "This 2 hours so far":"Эти 2 часа и до сейчас",
        "This 3 hours":"Эти 3 часа",
        "This 3 hours so far":"Эти 3 часа и до сейчас",

        "Last 1 hour":"Последний 1 час",
        "Last 2 hours":"Последние 2 часа",
        "Last 3 hours":"Последние 3 часа",
        "Last 4 hours":"Последние 4 часа",
        "Last 5 hours":"Последние 5 часов",
        "Last 6 hours":"Последние 6 часов",
        "Last 12 hours":"Последние 12 часов",
        "Last 24 hours":"Последние 24 часа",


        "Last 2 days":"Последние 2 дня",
        "Last 3 days":"Последние 3 дня",
        "Last 4 days":"Последние 4 дня",
        "Last 5 days":"Последние 5 дней",
        "Last 6 days":"Последние 6 дней",
        "Last 7 days":"Последние 7 дней",
        "Last 15 days":"Последние 15 дней",
        "Last 30 days":"Последние 30 дней",
        "Last 90 days":"Последние 90 дней",
        "Last 6 months":"Последние 6 месяцев",
        "Last 1 year":"Последний 1 год",
        "Last 2 years":"Последние 2 года",
        "Last 5 years":"Последние 5 лет",

        "Yesterday":"Вчера",
        "Day before yesterday":"Позавчера",
        "This day last week":"Этот день на прошлой неделе",
        "Previous week":"Предыдущая неделя",
        "Previous month":"Прошлый месяц",
        "Previous year":"Предыдущий год",

        "Today":"Сегодня",
        "Today so far":"Сегодня и до сейчас",
        "This week":"Эта неделя",
        "This week so far":"Эта неделя и до сейчас",
        "This month":"Этот месяц",
        "This month so far":"Этот месяц и до сейчас",
        "This year":"Этот год",
        "This year so far":"Этот год и до сейчас",

        "now":"сейчас",
        "now - 1 minute":"сейчас - 1 минута",
        "now - 5 minutes":"сейчас - 5 минут",
        "now - 10 minutes":"сейчас - 10 минут",
        "now - 15 minutes":"сейчас - 15 минут",
        "now - 20 minutes": "сейчас - 20 минут",
        "now - 30 minutes":"сейчас - 30 минут",
        "now - 45 minutes":"сейчас - 45 минут",

        "now - 1 hour":"сейчас - 1 час",
        "now - 2 hours":"сейчас - 2 часа",
        "now - 3 hours":"сейчас - 3 часа",
        "now - 4 hours":"сейчас - 4 часа",
        "now - 5 hours":"сейчас - 5 часов",
        "now - 6 hours":"сейчас - 6 часов",
        "now - 12 hours":"сейчас - 12 часов",
        "now - 24 hours":"сейчас - 24 часа",

        "now - 2 days":"сейчас - 2 дня",
        "now - 3 days":"сейчас - 3 дня",
        "now - 4 days":"сейчас - 4 дня",
        "now - 5 days":"сейчас - 5 дней",
        "now - 6 days":"сейчас - 6 дней",
        "now - 7 days":"сейчас - 7 дней",
        "now - 15 days":"сейчас - 15 дней",
        "now - 30 days":"сейчас - 30 дней",
        "now - 90 days":"сейчас - 90 дней",
        "now - 6 months":"сейчас - 6 месяцев",
        "now - 1 year":"сейчас - 1 год",
        "now - 2 years":"сейчас - 2 года",
        "now - 5 years":"сейчас - 5 лет",

        "Tablespace info":"Информация о табличном пространстве",
        "Table":"Таблица",
        "Min partition":"Мин. партиция",
        "Max partition":"Макс. партиция",
        "On disk":"На диске",
        "Partitions info":"Информация о партициях",
        "Partition":"Партиция",
        "Delete partitions":"Удалить партиции",

        "Panels":"Панели",
        "Series charts":"Графики",
        "Pie charts":"Круговые диаграммы",
        "Tables":"Таблицы",

        "Dictionaries info":"Информация о справочниках",
        "Name":"Имя",
        "Origin":"Конфиг",
        "Source":"Путь",
        "Count":"Количество записей",
        "Creation time":"Дата создания",
        "Last exception":"Последняя ошибка",

        "Id":"Ид",
        "Description":"Описание",
        "Hardware ID":"Ид оборудования",
        "Hardware port":"Порт оборудования",
        "CRC value":"CRC значение",
        "Value":"Значение",
        "CIDR or IP":"CIDR или IP",
        "IP":"IP",
        "MAC":"MAC",
        "Type":"Тип",
        "Address":"Адрес",
        "Higher hardware":"Вышестоящее оборудование",
        "Linked from hardware":"Вышестоящее оборудование",
        "Linked from port":"Вышестоящий порт",
        "Belongs to":"Принадлежность",

        "AS numbers dictionary":"Справочник номеров АС",
        "Local AS numbers dictionary":"Справочник номеров локальных АС",
        "Excluded AS numbers dictionary":"Справочник номеров исключенных АС",
        "CRC dictionary":"CRC справочник",
        "Net protocols dictionary":"Справочник сетевых протоколов",
        "App protocols dictionary":"Справочник протоколов приложений",
        "Settings dictionary":"Справочник настроек",
        "Local subnets dictionary":"Справочник локальных подсетей",
        "Excluded subnets dictionary":"Справочник исключенных подсетей",
        "Switches dictionary":"Справочник коммутаторов",
        "Subscribers dictionary":"Справочник абонентов",

        "Category ID":"Ид категории",
        "Host categories dictionary":"Справочник категорий хостов",
        "Hosts in categories dictionary":"Справочник хостов в категориях",
        "Dictionaries are reloaded":"Справочники обновлены",

        "Caches info":"Информация о кеше",

        "Queries processes list":"Список процессов запросов",
        "User":"Пользователь",
        "Query":"Запрос",
        "Query ID":"ИД запроса",
        "Elapsed":"Время выполнения",
        "seconds":"секунды",
        "Memory usage":"Использование памяти",
        "Peak memory usage":"Пиковое использование памяти",
        "Rows read":"Прочитано строк",
        "Bytes read":"Прочитано байтов",

        "Cancel query":"Отменить запрос",
        "Canceled":"Отменен",
        "All queries are canceled":"Все запросы отменены",
        "Cancel queries":"Отменить запросы",
        "Cancel all queries":"Отменить все запросы",
        "Query was cancelled":"Запрос отменен",
        "Are you sure you want to cancel the selected queries?":"Вы действительно хотите отменить выбранные запросы?",

        "Data not found":"Данные не найдены",

        "Triggers":"Триггеры",
        "Alerts":"Нотификации",
        "Alerts actions":"Действия",
        "Add trigger":"Добавить триггер",
        "Trigger name":"Название триггера",
        "Trigger title / description":"Название триггера / описание",
        "Enter trigger name":"Введите название триггера",
        "Are you sure you want to delete the trigger?":"Вы уверены, что хотите удалить триггер?",
        "Are you sure you want to delete the trigger alert?":"Вы уверены, что хотите удалить нотификацию?",

        "Common":"Общее",
        "Queries":"Запросы",
        "Conditions":"Условия",
        "Conditions notes":"Примечания к условиям",
        "Report link":"Ссылка на отчет",

        "Days of the week":"Дни недели",
        "Days when the trigger works":"Дни, когда триггер работает",
        "Check frequency":"Частота проверки",
        "Check frequency in seconds":"Частота проверки в секундах",
        "Number of positives":"Количество срабатываний",
        "Number of positives before notification":"Количество срабатываний перед нотификацией",
        "Start date":"Дата начала",
        "Trigger start date":"Дата начала работы триггера",
        "End date":"Дата окончания",
        "Trigger end date":"Дата окончания работы триггера",
        "Start time":"Время начала",
        "Trigger start time":"Время начала работы триггера",
        "End time":"Время окончания",
        "Trigger end time":"Время окончания работы триггера",

        "Based on":"На основе",
        "With filter":"С фильтром",
        "For period from":"За период с",
        "To":"по",

        "Query name":"Название",
        "Report":"Отчет",
        "Filter":"Фильтр",
        "Period from":"Период с",
        "Period to":"Период по",
        "Bind":"Связь",
        "Function":"Функция",
        "Combinator":"Комбинатор",
        "Serie":"Серия",
        "Note":"Заметка",

        "Trigger":"Триггер",
        "Enabled":"Включен",
        "Disabled":"Выключен",
        "Severity":"Важность",
        "Trigger saved":"Триггер сохранен",
        "Trigger enabled":"Триггер включен",
        "Trigger disabled":"Триггер выключен",

        "No data & error handling":"Обработка ошибок",
        "If no data":"Если нет данных",
        "Set state when no data":"Установить состояние, когда нет данных",
        "If execution error or timeout":"Если ошибка выполнения или тайм-аут",
        "Set state when execution error or timeout":"Установить состояние при ошибке выполнения или тайм-ауте",

        "Information":"Информация",
        "Warning":"Предупреждение",
        "Average":"Средня важность",
        "Hight":"Высокая важность",

        "Alerting":"Нотификация",
        "No data":"Нет данных",
        "Keep last state":"Сохранить последнее состояние",
        "Ok":"Ok",

        "State":"Статус",
        "Status":"Статус",
        "Ready":"Готов",
        "Caching":"Кеширование",
        "Checking":"Проверка",
        "Firing":"Оповещение",
        "Invalid":"Не исправен",
        "In progress":"В процессе",
        "Complete":"Завершено",
        "Max attempts":"Макс. число попыток",

        "Actions":"Действия",
        "Send to":"Кому",
        "Message recipients email-addresses":"Email-адреса получателей сообщений",
        "Message":"Сообщение",
        "Subject":"Тема",

        "Only selected triggers":"Только выбранные триггеры",
        "Only selected notifications":"Только выбранные нотификации",

        "E-mail action":"E-mail действие",
        "Http action":"Http действие",
        "Notification action": "Нотификация",
        "Telegram action": "Telegram действие",
        "Notification": "Нотификация",
        "Notification title":"Заголовок нотификации",
        "Notification subtitle": "Подзаголовок нотификации",
        "Notification type": "Тип нотификации",
        "Headers":"Заголовки",
        "Body":"Тело",
        "Add header":"Добавить заголовок",

        "Set default template":"Установить шаблон по умолчанию",
        "Tepmplate parameters":"Параметры шаблона",
        "Select one or more identifiers (via shift or ctr). Use ctrl + c to copy and ctrl + v to insert a message into the template.":"Выберите один или несколько идентификаторов (через <b>shift</b> или <b>ctr</b>). Используйте <b>ctrl+c</b> для копирования и <b>ctrl+v</b> для вставки в шаблон сообщения.",

        "Trigger id":"Ид триггера",
        "Notification id":"Ид нотификации",
        "Notification notes":"Причины нотификации",

        "Trigger fired":"Сработал триггер",

        "AND":"И",
        "OR":"ИЛИ",
        "if is not NaN":"если не NaN",
        "if is not Null":"если не Null",
        "if is NaN":"если NaN",
        "if is Null":"если Null",

        "Reset filters":"Сбросить фильтры",

        "Subscriber`s AS number":"Номер АС абонента",
        "Host`s AS number":"Номер АС хоста",

        "Subscriber`s port":"Порт абонента",
        "Host`s port":"Порт хоста",

        "Raw log":"Сырой лог",
        "Short raw log":"Сокращенный сырой лог",
        "Subscriber raw log":"Сырой лог абонента",
        "Full raw log":"Полный сырой лог",

        "By traffic":"По трафику",
        "By flow":"По флоу",
        "By sessions":"По сессиям",
        "By RTT":"По RTT",
        "By session lifetime":"По времени жизни сессии",
        "By subscribers and hosts":"По абонентам и хостам",
        "By traffic volume":"По объему трафика",

        "Distribution":"Распределение",

        "Attacks detection":"Обнаружение атак",

        "Session lifetime":"Время жизни сессии",
        "From subscriber":"От абонента",
        "To subscriber":"К абоненту",

        "Logins":"Логины",

        "With netflow":"С нетфлоу",

        "Locked":"Заблокирован",
        "Locked total":"Заблокированные (кол-во)",
        "Not locked":"Незаблокированный",
        "By DROP":"По DROP",
        "By policing":"По полисингу",

        "Dropped bytes":"Отброшенные байты",
        "Dropped packets":"Отброшенные пакеты",

        "Host type":"Тип хоста",
        "New trigger": "Новый триггер",
        "Copy trigger": "Копировать триггер",
        "Trigger type": "Тип триггера",
        "Custom": "Пользовательский",
        "System": "Системный",
        "Ssh bruteforce": "SSH брутфорс",
        "Sessions per subscriber": "Сессий на абонента",

        "Kill current report processes":"Отменить процесс для данного отчета",
        "Kill processes for all reports in section":"Отменить процессы для данного раздела",
        "Kill all my processes":"Отменить все мои процессы",
        "Kill processes for all users":"Отменить все процессы всех пользователей",

        "Clear current report cache":"Очистить кеш для данного отчета",
        "Clear cache for all reports in section":"Очистить кеш для данного раздела",
        "Clear all my cache":"Очистить весь мой кеш",
        "Clear cache for all users":"Очистить весь кеш всех пользователей",

        "Select a report and options to get another report":"Выберите отчет и параметры, чтобы получить другой отчет",

        "Menu":"Меню",
        "Open report":"Открыть отчет",

        "Link":"Ссылка",

        "Triggers of all users":"Триггеры всех пользователей",
        "Only my triggers":"Только мои триггеры",
        "Gtp cells locations dictionary": "Словарь местоположений элементов GTP",
        "Cell ID": "Идентификатор элемента",
        "Cell name": "Имя элемента",
        "Cell description": "Описание элемента",
        "Latitude": "Широта",
        "Longitude": "Долгота",
        "Mobile country code": "Код страны",
        "Mobile network (operator) code": "Код сети(оператора)",
        "Service/Tracking area code": "Код зоны покрытия",
        "Base station code": "Код базовой станции",

        "GTP version": "Версия GTP",
        "Request message ID": "ИД запроса",
        "Response message ID": "ИД ответа",
        "SGW control plane IP": "IP слоя управления SGW",
        "SGW control plane TEID": "TEID слоя управления SGW",
        "SGW data plane IP": "IP слоя хранения данных SGW",
        "SGW data plane TEID": "TEID слоя хранения данных SGW",
        "PGW control plane IP": "IP слоя управления PGW",
        "PGW control plane TEID": "TEID слоя управления PGW",
        "PGW data plane IP": "IP слоя хранения данных PGW",
        "PGW data plane TEID": "TEID слоя управления PGW",
        "Subscriber ipv4 address": "IPv4 адрес абонента",
        "Subscriber ipv6 address": "IPv6 адрес абонента",
        "SIM card number": "Номер SIM-карты",
        "Phone number": "Номер телефона",
        "IMEI": "IMEI",
        "Access Point Name": "Имя точки доступа",
        "Time of ULI": "Временная отметка абонента",
        "Rat": "Rat",
        "DPI ID": "ИД DPI",
        "Vlan ID": "ИД VLAN",
        "Post vlan ID": "ИД Post VLAN",
        "Aggregated log":"Аггрегированный лог",
        "Session unique ID": "Уникальный ИД сессии",

        "Vchannels names dictionary":"Словарь названий Vchannels",

        "NAT flow raw log":"Сырой NAT лог",

        "Event type":"Тип события",

        "NAT flow aggregated log":"Агрегированный лог NAT",

        "Top post NAT IPs":"Топ IP-адресов после NAT",

        "Vchannel/Bridge":"Канал/Мост",
        "Vchannels":"Каналы",
        "By vchannel":"По каналу",

        "Traffic by vchannels":"Трафик по каналам",
        "Top vchannels with high traffic":"Топ каналов с высоким трафиком",
        "Flow by vchannels":"Флоу по каналам",
        "Top vchannels with high flow":"Топ каналов с высоким флоу",
        "Top vchannels":"Топ каналов",
        "Top vchannels with high RTT":"Топ каналов с высоким РТТ",
        "Top vchannels with high retransmits":"Топ каналов с высоким % ретрансмитов",
        "Copy role": "Копировать роль",

        "Top classes":"Топ классов",
        "Traffic by classes":"Трафик по классам",
        "Traffic by DSCP":"Трафик по DSCP",
        "Flow by classes":"Флоу по классам",
        "Flow by DSCP":"Флоу по DSCP",
        "Top classes with high traffic":"Топ классов с высоким трафиком",
        "Top DSCP classes with high traffic":"Топ DSCP классов с высоким трафиком",
        "Top DSCP classes with high flow":"Топ DSCP классов с высоким флоу",
        "Top classes with high flow":"Топ классов с высоким флоу",
        "Top classes with high RTT":"Топ классов с высоким РТТ",
        "Top classes with high retransmits":"Топ классов с высоким % ретрансмитов",
        "Class":"Класс",
        "Top DSCP classes":"Топ DSCP классов",
        "Reasons for the occurrence of notification":"Причины появления уведомления",
        "Links to reports":"Ссылки на отчеты",
        "Links to PDF reports":"Ссылки на PDF отчеты",
        "Final report":"Итоговый отчет",
        "App protocols groups dictionary": "Справочник групп прикладных протоколов",
        "App protocols groups": "Группы прикладных протоколов",
        "App protocol group": "Группа прикладного протокола",
        "Traffic by application protocols groups": "Трафик по группам прикладных протоколов",
        "Top application protocols groups with high retransmits": "Топ групп прикладных протоколов с высоким % ретрансмитов",
        "Top application protocols groups with high traffic": "Топ групп прикладных протоколов с высоким трафиком",
        "Top application protocols groups with high traffic volume": "Топ групп прикладных протоколов с высоким объемом трафика",
        "Top application protocols groups with high flow": "Топ групп прикладных протоколов с высоким флоу",
        "Top protocols groups": "Топ групп прикладных протоколов",
        "Top application protocols groups with high RTT": "Топ групп прикладных протоколов с высоким RTT",
        "Flow by application protocols groups": "Флоу по группам прикладных протоколов",
        "Top application protocols groups": "Топ групп прикладных протоколов",
        "Top GTP cells":"Топ GTP cells",
        "Not applicable":"Не применимо",

        "Report name":"Имя отчета",

        "Agg logs":"Агрегированные логи",
        "Log name":"Название лога",
        "Top hosts by subscribers":"ТОП хостов по абонентам",
        "Top app protocols by subscribers (fullflow)":"ТОП прикладных протоколов по абонентам (fullflow)",
        "Agg log enabled":"Агрегированный лог включен",
        "Agg log disabled":"Агрегированный лог выключен",
        "Top categories of hosts by subscribers":"ТОП категорий хостов по абонентам",
        "Top application protocols by subscribers":"ТОП прикладных протоколов по абонентам",
        "Top application protocols groups by subscribers":"ТОП групп прикладных протоколов по абонентам",
        "Application protocol group":"Группа прикладных протоколов",
        "Host domain":"Домен хоста",
        "Known host category":"Известные категории хоста",
        "Protocol group":"Группа протоколов",
        "Top subscribers by hosts":"Топ абонентов по хостам",
        "Disk name":"Диск",
        "Cluster host":"Хост кластера",

        "Gtp country dictionary":"Словарь стран GTP",
        "Country name":"Название страны",
        "Gtp network (operator) dictionary":"Словарь сетей (операторов) GTP",
        "Network (operator) name":"Название сети (оператора)",

        "UPLINK LOAD RATE protocols dictionary":"Словарь протоколов для сервиса UPLINK LOAD RATE",
        "Protocol code":"Код протокола",
        "Protocol category":"Категория протокола",


        "Aggregation period":"Период агрегирования",
        "Window width":"Ширина окна",
        "Start collecting data":"Начать сбор данных",
        "Stop collecting data":"Остановить сбор данных",

        "Dashboards":"Дашборды",
        "Saved dashboards":"Сохраненные дашборды",
        "Add dashboard":"Добавить дашборд",
        "Add subdashboard":"Добавить поддашборд",
        "Dashboard name":"Имя дашборда",
        "Enter dashboard name":"Введите имя дашборда",
        "For whom the dashboard is available?":"Для кого доступен дашборд?",
        "Create a new dashboard":"Создайте новый дашборд",
        "Dashboard deleted":"Дашборд удален",
        "Back to the dashboard":"Вернуться к дашборду",

        "Template":"Шаблон",
        "Templates":"Шаблоны",
        "Saved dashboard templates":"Сохраненные шаблоны дашбордов",
        "Template name":"Имя шаблона",
        "For whom the template is available?":"Для кого доступен шаблон?",
        "Enter template name":"Введите имя шаблона",
        "Dashboard template":"Шаблон дашборда",
        "Save as template":"Сохранить как шаблон",
        "Template deleted":"Шаблон удален",

        "Role":"Роль",
        "Select roles":"Выберите роли",
        "To me only":"Только для меня",
        "To any users":"Для всех пользователей",
        "To users with roles":"Для пользователей с ролями",

        "Filters":"Фильтры",
        "Start collecting":"Начать сбор",
        "You have not created any filters":"Вы не создали ни одного фильтра",
        "Are you sure you want to start data collection?":"Вы уверены, что хотите начать сбор данных?",
        "Report refresh rate":"Частота обновления отчета",
        "As in the aggregation period":"Как в периоде агрегирования",
        "Allows you to select the aggregation period for reports. The set of available values depends on the smallest rotation period of the receivers":"Позволяет выбрать период агрегирования для отчетов. Набор доступных значений зависит от наименьшего периода ротации ресиверов",
        "Allows you to increase the aggregation period":"Позволяет увеличить период агрегирования",

        "Flow capture":"Захват флоу",
        "Subscriber flow capture":"Захват флоу абонента",
        "Host flow capture":"Захват флоу хоста",
        "Subscriber login":"Логин абонента",
        "Subscriber IP":"IP абонента",
        "At least one field must be filled":"По крайней мере одно поле должно быть заполнено",
        "Capture":"Захватить",
        "Capture type":"Тип захвата",

        "Widget created":"Виджет создан",
        "Widget deleted":"Виджет удален",
        "Widget name":"Имя виджета",
        "Enter widget name":"Введите имя виджета",
        "Incorrect value":"Неверное значение",
        "Bot token":"Токен бота",
        "Bot token for sending a message":"Токен бота для отправки сообщения",
        "Chat Id":"Идентификатор чата",
        "Chat ID where the bot will send the message":"Идентификатор чата, куда бот отправит сообщение",
        "Links to files": "Ссылки на файлы",
        "Create CSV file":"Создать CSV файл",
        "Create TabSeparated file":"Создать TabSeparated файл",
        "Create Excel file":"Создать Excel файл",
        "Create PDF file":"Создать PDF file",
        "Radius": "Радиус",

        "Add protocol": "Добавить протокол",
        "None (0 points)": "Нет (0 баллов)",
        "First category (+2 points)": "Первая категория (+2 балла)",
        "Second category (+1 point)": "Вторая категория (+1 балл)",
        "Metrics": "Метрики",
        "Traffic volume delta": "Дельта объема трафика",
        "Delta with normal": "Дельта от нормы",
        "Points": "Баллы",
        "RTT to, median": "RTT к, медиана",
        "Other": "Иначе",
        "Protocol health mark": "Оценка здоровья протокола",
        "Protocol health mark changes": "Изменения оценки здоровья протокола",

        "Aggregation raw logs fullflow info": "Информация о агрегированном сыром логе fullflow",
        "Task type from": "Исходная таблица",
        "Action": "Действие",
        "Task type to": "Целевая таблица",
        "Partition name": "Название партиции",
        "Node": "Узел",
        "Status description": "Описание статуса",
        "Attempts": "Попытки",
        "Data": "Данные",
        "Create time": "Время создания",
        "Update time": "Время обновления",

        "New": "Новый",
        "Waiting": "Ожидание",
        "Waiting processing": "Ожидание обработки",
        "Skipped": "Пропущено",

        "Move To": "Переместить в",
        "Drop Partition": "Удалить партицию",
        "Wait Move": "Ожидание перемещения",
        "Wait Drop Partition": "Ожидание удаления партиции",

        "Enter valid date, example: 22.02.2023 00:00": "Введите валидную дату, например: 22.02.2023 00:00",
        "Enter valid date, example: ": "Введите валидную дату, например: ",
        "Scheduled": "По расписанию",
        "All reports in single PDF": "Все отчеты в одном PDF файле",

        "Top logins":"Топ логинов",

        "Traffic direction":"Направление трафика",

        "Link to CSV file": "Ссылка на CSV файл",
        "Link to TabSeparated file": "Ссылка на TabSeparated файл",
        "Link to Excel file": "Ссылка на Excel файл",
        "Link to PDF file": "Ссылка на PDF файл",
        "Link to PDF file with all reports": "Ссылка на PDF файл со всеми отчетами",
        "Attach CSV file": "Прикрепить CSV файл",
        "Email only": "Только для Email",
        "Attach archive with CSV file": "Прикрепить архив с CSV файлом",
        "Attach TabSeparated file": "Прикрепить TabSeparated файл",
        "Attach archive with TabSeparated file": "Прикрепить архив с TabSeparated файлом",
        "Attach Excel file": "Прикрепить Excel файл",
        "Attach archive with Excel file": "Прикрепить архив с Excel файлом",
        "Link to Excel file with all reports":"Ссылка на Excel файл со всеми отчетами",
        "Attach Excel file with all reports":"Прикрепить Excel файл со всеми отчетами",
        "Attach archive with Excel file with all reports":"Прикрепить архив с Excel файлом со всеми отчетами",
        "Attach PDF file": "Прикрепить PDF файл",
        "Attach archive with PDF file": "Прикрепить архив с PDF файлом",
        "Attach PDF file with all reports": "Прикрепить PDF файл со всеми отчетами",
        "Attach archive with PDF file with all reports": "Прикрепить архив с PDF файлом со всеми отчетами",
        "Redirected":"Перенаправлен",
        "Both: locked + redirected":"Заблокирован + перенаправлен",
        "Locked traffic":"Заблокированный трафик",
        "Redirected traffic":"Перенаправленный трафик",
        "Both: redirected and locked traffic":"Заблокированный + перенаправленный трафик",
        "MPLS labels": "MPLS метки",
        "Raw DNS log":"Сырой DNS лог",
        "DNS transport": "Транспорт DNS",
        "DNS type": "Тип DNS",
        "Subscriber port": "Порт абонента",
        "Host port": "Порт хоста",
        "DNS data": "Данные DNS",
        "Rrclass": "Rrclass",
        "Rrtype": "Тип DNS",
        "TTL": "TTL",
        "Top DNS hosts IPs": "Топ IP DNS хостов",
        "Top DNS servers IPs": "Топ IP DNS серверов",
        "DNS host IP": "IP DNS хоста",
        "DNS host port": "Порт DNS хоста",
        "DNS server IP": "IP DNS сервера",
        "DNS server port": "Порт DNS сервера",
        "Cache error":"Ошибка кеширования",
        "DSCP":"DSCP",

        "Edit":"Редактировать",
        "Report settings":"Настройки отчета",
        "Save settings":"Сохранить настройки",
        "Settings successfully saved.":"Настройки успешно сохранены.",
        "Settings successfully deleted.":"Настройки успешно удалены.",
        "New settings":"Новые настройки",
        "Items visibility":"Видимость элементов",
        "The setting allows to select which field will be used to group the report.":"Настройка позволяет выбрать, какое поле будет использоваться для группировки отчета.",
        "The setting allows to choose which data columns will be visible in the report.":"Настройка позволяет выбрать, какие столбцы данных будут отображаться в отчете.",
        "The setting allows you to set a limit on the number of data rows displayed in the report.":"Настройка позволяет установить ограничение на количество строк данных, отображаемых в отчете.",
        "The setting allows to choose whether the data filter will be displayed on the PDF report.":"Настройка позволяет выбрать, будет ли фильтр данных отображаться в PDF отчете.",
        "The setting allows to select the page orientation (portrait, landscape) for the report. Auto mode selects orientation depending on the amount of data.":"Настройка позволяет выбрать ориентацию страницы (книжная, альбомная) для отчета. Автоматический режим выбирает ориентацию в зависимости от объема данных.",
        "The setting allows to control the visibility of series or chart elements.":"Настройка позволяет управлять видимостью серий или элементов графика.",
        "The setting determines the interval or step between values on the graph.":"Настройка определяет интервал или шаг между значениями на графике.",
        "The setting determines chart type.":"Настройка определяет тип графика.",
        "The setting determines chart scale type.":"Настройка определяет тип шкалы графика.",
        "The setting determines the sorting field for the chart series.":"Параметр определяет поле сортировки серий графика.",
        "The setting determines the direction of sorting field for the chart series.":"Параметр определяет направление сортировки поля серий графика.",
        "The setting determines the sorting field.":"Параметр определяет поле сортировки.",
        "The setting determines the direction of sorting.":"Параметр определяет направление сортировки.",
        "The setting allows to control the detalization of the Y axis. Available options: Auto, Low, Medium, High. They differ by the number of tick marks displayed on the Y axis.":"Эта настройка позволяет управлять детализацией оси Y. Доступные варианты: Авто, Низкая, Средняя, Высокая. Они различаются количеством делений, отображаемых на оси Y.",
        "Report settings allow to change the display of the report in the interface and exported reports.":"Настройки отчета позволяют изменять отображение отчета в интерфейсе и экспортируемых отчетах.",
        "Displays the minimum, maximum, and average values for each series in the chart legend.":"Отображает минимальное, максимальное и среднее значения для каждой серии в легенде графика.",
        "Restore to default":"Восстановить настройки по умолчанию",
        "Add": "Добавить",
        "QoE reports settings history storage period in days":"Срок хранения истории настроек QoE отчетов в днях",
        "The setting allows to specify the name of the PDF report.":"Настройка позволяет указать имя PDF отчета.",

        "with high flow":"с высоким флоу",
        "Top with high flow":"Топ с высоким флоу",
        "Top subscribers with high flow":"Топ абонентов с высоким флоу",
        "Top hosts with high flow":"Топ хостов с высоким флоу",

        "Top host categories with high flow":"Топ категорий хостов с высоким флоу",
        "Top AS with high flow":"Топ АС с высоким флоу",
        "Top subscriber`s AS with high flow":"Топ абонентских АС с высоким флоу",

        "Set table properties to default":"Установить свойства таблицы по умолчанию",

        "My reports":"Мои отчеты",
        "Report description":"Описание отчета",
        "Tasks for building a report":"Задачи на построение отчета",
        "Create task":"Создать задачу",
        "Create report task":"Создать задачу по отчету",
        "Maximum execute time":"Максимальное время выполнения",
        "Time to store cache":"Времия хранение кэша",
        "Priority":"Приоритет",
        "No queue":"Без очереди",
        "Send to email":"Отправить на почту",
        "Send to telegram":"Отправить в телеграм",
        "Email address":"Адрес почты",
        "Formats":"Форматы",
        "Split report":"Разделить отчет",
        "Separate delivery":"Раздельная отправка",
        "Split by":"Разделить по",
        "By time":"По времени",
        "By lines":"По количеству строк",
        "Lines":"Количество строк",
        "Delayed start":"Отложенный запуск",
        "Task schedule":"Расписание задачи",
        "Task name":"Название задачи",
        "Task id":"Ид задачи",
        "The field cannot be empty":"Поле не может быть пустым",
        "The period is incorrect":"Некорректный период",
        "Copy of task":"Копия задачи",
        "Task successfully saved":"Задача успешно сохранена",
        "and run":"и запущена",
        "Save and run":"Сохранить и запустить",
        "Done": "Выполнен",
        "Cache":"Кэш",
        "Cache date":"Дата кэша",
        "Preparing":"Подготовка",
        "Add task":"Добавить задачу",
        "Edit task":"Редактировать задачу",
        "Run task":"Запустить задачу",
        "Stop task":"Остановить задачу",
        "Copy task":"Копировать задачу",
        "Delete task":"Удалить задачу",
        "Task settings":"Настройки задачи",
        "Are you sure you want to stop task?":"Вы уверены, что хотите остановить задачу?",
        "Stop":"Остановить",
        "The parameter specifies the maximum time (in hours) to complete the report generation task.":"Параметр задает максимальное время (в часах) для выполнения задачи по построению отчета.",
        "The parameter defines the storage duration of cached data (in days) for loading the report.":"Параметр определяет продолжительность хранения кешированных данных (в днях) для загрузки отчета.",
        "The parameter determines the order of execution of tasks in the range from 1 (minimum priority) to 10 (maximum priority). Tasks with a higher priority are executed earlier. If two tasks have the same priority, the one that was created earlier is taken into work first.":"Параметр определяет порядок выполнения задач в диапазоне от 1 (минимальный приоритет) до 10 (максимальный приоритет). Задачи с более высоким приоритетом выполняются раньше. Если две задачи имеют одинаковый приоритет, первой в работу берется та, которая была создана раньше.",
        "Parameter that determines whether the task will be executed out of queue, i.e. immediately and independently of other report generation tasks. If this parameter is enabled, the task will be processed first, even if other tasks are in the queue.":"Параметр, который определяет, будет ли задача выполнена вне очереди, то есть сразу и независимо от других задач на построение отчета. Если этот параметр включен, задача будет обработана в первую очередь, даже если другие задачи находятся в очереди.",
        "The parameter determines whether an email notification will be sent upon task completion. If the parameter is enabled, the system will automatically send an email to the specified address. It is also possible to customize the email template so that the notification meets specific requirements. By default, the standard email template is used.":"Параметр определяет, будет ли отправлено уведомление по электронной почте по завершении задачи. Если параметр включен, система автоматически отправит письмо на указанный адрес. Также возможно настроить шаблон письма, чтобы уведомление соответствовало конкретным требованиям. По умолчанию используется стандартный шаблон письма.",
        "The parameter determines whether a notification will be sent to the telegram channel upon completion of the task. If the parameter is enabled, the system will automatically send a message. It is also possible to customize the message template so that the notification meets specific requirements. By default, the standard message template is used.":"Параметр определяет, будет ли отправлено уведомление в телеграм канал по завершении задачи. Если параметр включен, система автоматически отправит сообщение. Также возможно настроить шаблон сообщения, чтобы уведомление соответствовало конкретным требованиям. По умолчанию используется стандартный шаблон сообщения.",
        "An option that enables splitting a report into multiple subreports using two alternative methods: by time interval in hours or by the maximum number of rows. When splitting by time, each subreport covers the specified number of hours. When splitting by rows, each subreport contains no more than the defined number of rows.":"Параметр позволяет разделить отчет на несколько подотчетов, используя два альтернативных метода: по временному интервалу в часах или по максимальному количеству строк. При разделении по времени каждый подотчет охватывает указанное количество часов. При разделении по строкам каждый подотчет содержит не более заданного количества строк.",
        "Separate sending - each generated file is sent as a separate email or telegram message.":"Раздельная отправка — каждый сгенерированный файл отправляется отдельным электронным письмом или сообщением в Telegram.",
        "Option that determines whether the task will be delayed before execution. If this option is enabled, you can specify a delay time after which the task will be added to the queue. By default, if the option is not enabled, the task is immediately queued for execution.":"Параметр, который определяет, будет ли задача отложена перед выполнением. Если этот параметр включен, можно указать время задержки, после которого задача будет добавлена в очередь. По умолчанию, если параметр не включен, задача сразу встает в очередь на выполнение.",
        "Option that enable task schedule.":"Опция, включающая расписание задачи.",
        "By default, the language of system templates is English. To set the template language, set the trigger template language option in the GUI configuration.":"По умолчанию язык системных шаблонов английский. Чтобы задать язык шаблонов, установите в конфигурации GUI  опцию языка шаблонов триггеров.",
        "Cache.Ready":"Готов",
        "Cache.NotReady":"Не готов",
        "Cache lifetime":"Время жизни кэша",
        "Task update error":"Ошибка обновления задачи",
        "Cache data":"Данные кэша",
        "Task data":"Данные задачи",
        "Days":"Дни",
        "Cache progress":"Прогресс",
        "Max available number of queries is 100.": "Максимальное количество запросов - 100.",
        "Hours":"Часы",
        "Channel":"Канал",
        "Add schedule":"Добавить расписание",
        "No schedule added":"Не добавлено расписание",

        "Report file":"Файл отчета",

        "Top VOIP protocols":"Топ VOIP протоколов",
        "Top VOIP protocols by numbers of calls":"Топ VOIP протоколов по количеству звонков",
        "Top VOIP Protocols by total call duration":"Топ VOIP протоколов по общей продолжительности звонков",
        "Top VOIP Protocols by number of users":"Топ VOIP протоколов по количеству пользователей",
        "Top VOIP protocols with high traffic":"Топ VOIP протоколов c высоким трафиком",
        "Traffic by VOIP protocols":"Трафик по VOIP протоколам",
        "Calls by protocols":"Звонки по протоколам",
        "Minutes by protocols":"Минуты по протоколам",
        "Subscribers by protocols":"Абоненты по протоколам",
        "Calls":"Звонки",
        "Minutes":"Минуты",

        "Duration in seconds":"Длительность в секундах",
        "Duration in milliseconds":"Длительность в миллисекундах",

        "Cache report stat":"Статистика кэша отчета",

        "Raw DDoS attack log":"Сырой лог DDoS атак",
        "Attack type":"Тип атаки",
        "Attack direction":"Направление атаки",
        "Event":"Событие",
        "Attacker IP address":"Ip-адрес атакующего",
        "Attacker ports":"Порты атакующего",
        "Target IP address":"IP-адрес цели",
        "Target port":"Целевой порт",
        "Event object":"Объект события",
        "Event action":"Действие",
        "Flows records":"Записей флоу",
        "Dropped traffic":"Отброшенный трафик",
        "Dropped flow":"Отброшенный флоу",
        "Top attacks":"Топ атак",
        "Top attacks by AS":"Топ атак по АС",
        "Top attacks by protocols":"Топ атак по протоколам",
        "Top attacks by application protocols":"Топ атак по прикладным протоколам",
        "Attack intensity by source AS":"Интенсивность атак по АС источника",
        "Attack intensity by protocols":"Интенсивность атак по протоколам",
        "Attack intensity by application protocols":"Интенсивность атак по прикладным протоколам",
        "Duration":"Продолжительность",
        "Peak traffic":"Пиковый трафик",
        "Average intensity":"Средняя интенсивность",
        "Traffic speed":"Скорость трафика",
        "Peak flow":"Пиковый поток",
        "Flow speed":"Скорость потока",
        "Start time in milliseconds":"Начало в миллисекундах",
        "End time in milliseconds":"Окончание в миллисекундах",
        "Average duration":"Средняя продолжительность",
        "Attack intensity":"Интенсивность атак",
        "Intensity":"Интенсивность",
        "Incidents":"Инциденты",
        "Mitigation":"Митигация",
        "Number of attacks":"Количество атак",
        "Number of attack types":"Количество типов атак",
        "Blocked traffic volume":"Объем заблокированного трафика",
        "Country code":"Код страны",
        "GeoState":"Регион",
        "City":"Город",
        "Top attacker locations":"Топ атакующих локаций",
        "Top attacker Ip addresses":"Топ атакующих IP-адресов",
        "Geo":"Гео",
        "Number of attackers":"Количество атакующих",
        "Top attacker countries":"Топ атакующих стран",
        "Number of locations":"Количество локаций",

        "Service flags":"Флаги сервисов",
        "Detection flags":"Флаги детекции",
        "Action flags":"Флаги действий",

        "Rating group":"Рейтинговая группа",

        "Tethering":"Тетеринг",

        "No flags":"Нет флагов",

        "Top logins with high RTT":"Топ логинов с высоким RTT",
        "Top logins with high traffic":"Топ логинов с высоким трафиком",
        "Top logins with high retransmits":"Топ логинов с высоким % ретрансмитов",
        "Top logins with high flow":"Топ логинов с высоким флоу",

        "CITRA - Capacity planning report": "CITRA - Отчет о планировании мощностей",
        "Top ISP's with high traffic": "Топ провайдеров с высоким трафиком",
        "Traffic by ISP's": "Трафик по провайдером",
        "Kuwait's Traffic Utilization": "Использование трафика в Кувейте",
        "Globally Trending applications behavior in Kuwait":"Глобальные тренды в поведении приложений в Кувейте",
        "VOIP protocols": "VOIP протоколы",
        "VOIP application Usage report": "Отчет об использовании приложения VOIP",
        "Network latency": "Сетевая задержка",
        "Quarter consumption": "Потребление за квартал",

        "Quarter": "Квартал",
        "Traffic volume consumption by quarter": "Потребление трафика по кварталам",
        "Traffic volume consumption growth rates by quarter": "Темпы роста потребления трафика по кварталам",
        "Traffic volume growth rate":"Темпы роста объема трафика",
        "Traffic volume from subscriber growth rate":"Темпы роста объема трафика от абонентов",
        "Traffic volume to subscriber growth rate":"Темпы роста объема трафика к абонентам"
    };

webix.i18n.locales["ru-RU"].dpiui2.QoEPopupFilterWidget =
    {
        "Title":"Название",
        "Saved filters":"Сохраненные фильтры",
        "Filters":"Фильтры",
        "Filter":"Фильтр",
        "Operator":"Оператор",
        "Value":"Значение",
        "Add filter":"Добавить фильтр",
        "Values are separated by a new line. Use Shift + Enter to make new line.":"Значения разделены новой строкой. Используйте <b>Shift</b> + <b>Enter</b>, чтобы создать новую строку.",
        "Filter is saved":"Фильтр сохранен",
        "Are you sure you want to delete the filter?":"Вы уверены, что хотите удалить этот фильтр?",
        "Checks whether a string matches a simple regular expression.":"Проверка строки на соответствие простому регулярному выражению.<br/>Регулярное выражение может содержать метасимволы % и _.<br/>% обозначает любое количество любых байт (в том числе, нулевое количество символов).<br/>_ обозначает один любой байт.",
        "There are no common filters":"Нет общих фильтров",
        "New filter":"Новый фильтр",
        "Save filter":"Сохранить фильтр",
        "Saved":"Сохраненные",
        "Enable/Disable":"Включить/Выключить",
        "Details":"Подробности",
        "Help":"Помощь",
        "Apply filter":"Применить фильтр",
        "Cancel filter":"Отменить фильтр",
        "Edit next property":"Редактировать следующее свойство",
        "Enable/Disable filter setting":"Включить/Выключить настройку фильтра",
        "Delete selected":"Удалить выбранное",
        "Add new saved filter":"Добавить новый сохранненый фильтр",
        "Refresh tables":"Обновить таблицы",
        "Show help":"Показать помощь",
        "Show/Hide filter settings window":"Показать/Скрыть окно настройки фильтра",
        "Delete all filter settings":"Удалить все настройки фильтра",
        "Set default filter state":"Установить состояние фильтра по умолчанию",
        "Clear value":"Очистить значение",
        "Are you sure you want to set filter settings to default?":"Вы уверены, что хотите установить настройки фильтра по умолчанию?",
        "Are you sure you want to delete all filter settings?":"Вы уверены, что хотите удалить все настройки фильтра?"
    };

webix.i18n.locales["ru-RU"].dpiui2.QoEMonitorWidget =
    {
        "Bytes":"Байт",
        "Kb":"Кбайт",
        "Mb":"Мбайт",
        "Gb":"Гбайт",
        "Tb":"Тбайт",

        "median":"медиана"
    };

webix.i18n.locales["ru-RU"].dpiui2.QoESubscribers =
    {
        "Filter is saved":"Фильтр сохранен",
        "Add subscribers to campaign":"Добавить абонентов в кампанию"
    };

webix.i18n.locales["ru-RU"].dpiui2.BlackListService =
    {
        "Profiles":"Профили",
        "List of nodes scan profiles":"Список профилей сканирования узлов",
        "Add profile":"Добавить профиль",
        "Add subprofile":"Добавить подпрофиль",

        "Profile":"Профиль",
        "Date":"Дата",
        "User":"Пользователь",
        "Status":"Статус",

        "Enable profile":"Включить профиль",
        "Disable profile":"Отключить профиль",

        "List of black and white profiles":"Список черных и белых профилей",
        "Black and white lists":"Чёрные и белые списки",

        "Black":"Чёрный",
        "White":"Белый",

        "Disabled":"Выключен",
        "Enabled":"Включен",

        "Type":"Тип",
        "Type: black or white":"Тип: чёрный или белый",

        "Black or white profile":"Чёрный или белый профиль",
        "Description":"Описание",
        "IP-addresses":"IP-адреса",
        "IP-addresses or CIDRs. Each with a new line":"IP-адреса или CIDR. Каждый с новой строки",

        "Resource":"Ресурс",
        "Redirect":"Переадресовывать",
        "URL to redirect":"URL для переадресации",

        "Add list item":"Добавить в список",
        "Import from file":"Импортировать из файла",

        "Profile enabled":"Профиль включен",
        "Profile not enabled":"Профиль не включен",
        "Profile disabled":"Профиль выключен",
        "Profile not disabled":"Профиль не выключен",

        "List item saved":"Запись сохранена",

        "You should set url to redirect":"Вы должны установить URL для перенаправления",
        "You should set ip addresses or CIDRs":"Вы должны установить IP-адреса или CIDR-ы",
        "You should set url to redirect when white list is enabled":"Вы должны установить URL-адрес для перенаправления, когда включен белый список",
        "Are you sure you want to delete the profile?":"Вы действительно хотите удалить профиль?",
        "from":"от",
        "On page":"На странице",
        "Are you sure you want to delete this record?":"Вы действительно хотите удалить эту запись?",
        "Input correct IP addresses!": "Коректно заполните IP адреса!",
        "Subscribers": "Абоненты",
        "IP-address": "IP-адрес",
        "IP-address saved":"IP-адрес сохранен",
        "Black and white lists subscribers": "Абоненты для черных и белых списков",
        "Profile saved":"Профиль сохранен",
        "Import categories from QoE":"Импортировать категории из QoE",
        "Import list items from QoE" : "Импортировать списки из QoE",
        "Import": "Импортировать",
        "Category": "Категория",
        "CategoryEnabled": "Подключена",
        "Imported successfully": "Импортировано успешно",
        "Get template" : "Получить шаблон",
        "Subscriber saved":"Абонент сохранен",
        "Resource field should be valid": "Поле ресурса должно быть корректно заполнено",
        "Export to Excel": "Экспортировать в Excel",

        "Advertising & Ad blocking lists":"Рекламные списки и списки блокировки рекламы",
        "The task of importing successfully launched":"Успешно запущена задача импорта",
        "This profile loaded from hardware. Profile will be deleted if you stop it. Delete profile?": "Этот профиль был загружен с устройства.<br/> Профиль будет удален, если Вы выключите его.<br/> Удалить профиль?",
        "Import of resources from QoE running in background": "Импорт ресурсов из QoE запущен в фоновом режиме",
        "All resources": "Все ресурсы",
        "% resources": "% ресурсов",
        "Number of resources":"Количество ресурсов",
        "Please select at least one category.": "Выберите хотя бы одну категорию.",
        "Clear list": "Очистить список",
        "Are you sure you want to delete all records?": "Вы уверены, что хотите удалить все записи?",
        "All records have been deleted!": "Все записи были удалены!",
        "Federal":"Федеральный",
        "Use federal lists": "Использовать федеральные списки",
        "Use federal" : "Использовать федеральный",
        "Task title / description": "Описание профиля",
        "Code": "Код",
        "Profile name using on DPI": "Имя профиля используемое на DPI",
        "Category removed": "Категория удалена",
        "Sites category": "Категория сайтов",
        "Classifier categories not applied": "Категории классификатора не применены",
        "Synchronization period in hours": "Период синхронизации в часах",
        "Task sync time update success": "Время синхронизации задачи успешно обновлено",

        "VASE Lists": "Списки VASE",
        "Successfully imported  rows: ": "Успешно импортированных записей: "
    };

    webix.i18n.locales["ru-RU"].dpiui2.SessionPolicingsService =
    {
        "Session policings": "Сессионные полисинги",
        "Protocols": "Протоколы",
        "Profiles":"Профили",
        "List of nodes scan profiles":"Список профилей сканирования узлов",
        "Add profile":"Добавить профиль",
        "Add subprofile":"Добавить подпрофиль",
        "Profile name":"Имя профиля",
        "Protocol saved": "Протокол сохранен",

        "In your configuration, the parameter (support_service_18) is disabled, which is necessary for the correct operation of this service. Go to the configuration section?":"В вашей конфигурации выключен параметр (support_service_18) который необходим для верной работы данного сервиса. Перейти в раздел конфигурации?",
        "Configuration error!":"Ошибка конфигурации!",
        "Go to":"Перейти",

        "Profile":"Профиль",
        "Date":"Дата",
        "User":"Пользователь",
        "Status":"Статус",

        "Enable profile":"Включить профиль",
        "Disable profile":"Отключить профиль",

        "Disabled":"Выключен",
        "Enabled":"Включен",

        "Type":"Тип",

        "Description":"Описание",

        "Resource":"Ресурс",
        "Redirect":"Переадресовывать",
        "URL to redirect":"URL для переадресации",

        "Add list item":"Добавить в список",
        "Import from file":"Импортировать из файла",

        "Profile enabled":"Профиль включен",
        "Profile not enabled":"Профиль не включен",
        "Profile disabled":"Профиль выключен",
        "Profile not disabled":"Профиль не выключен",

        "List item saved":"Запись сохранена",

        "Are you sure you want to delete the profile?":"Вы действительно хотите удалить профиль?",
        "from":"от",
        "On page":"На странице",
        "Are you sure you want to delete this record?":"Вы действительно хотите удалить эту запись?",
        "Subscribers": "Абоненты",
        "Profile saved":"Профиль сохранен",
        "Category": "Категория",
        "CategoryEnabled": "Подключена",
        "Subscriber saved":"Абонент сохранен",
        "Resource field should be valid": "Поле ресурса должно быть корректно заполнено",
        "All subscribers associated with this profile will be unsubscribed from the Session Policings service.": "Все абоненты привязанные к этому профилю будут отписаны от услуги Сессионные полисинги.",
    };

webix.i18n.locales["ru-RU"].dpiui2.Tariffs =
    {
        "Tarrif.Introduced": "Введен",
        "Tarrif.Config error": "Ошибка конфига",
        "Tarrif.Active": "Активен",
        "Tariff name": "Название тарифа",
        "Cancel" : "Отменить",
        "Save": "Сохранить",
        "Delete": "Удалить",
        "Are you sure you want to delete this tariff?" : "Вы действительно хотите удалить этот тариф?",
        "Click to download or drag a file": "Нажмите, чтобы загрузить или перетащите файл",
        "Continue": "Продолжить",
        "Service Management": "Управление услугами",
        "Tariffs": "Тарифы",
        "Add tariff": "Добавить тариф",
        "Tariff": "Тариф",
        "Status": "Статус",
        "Load from file": "Загрузить из файла",
        "Tariff plan configuration": "Конфигурация тарифного плана",
        "Class": "Класс",
        "Inbound": "Входящий",
        "Outbound": "Исходящий",
        "Subscribers" : "Абоненты",
        "Tariff deleted": "Тариф удален",
        "Tariff saved": "Тариф сохранен",
        "Config field must not be empty!": "Поле конфигурации тарифного плана не может быть пустым!",
        "Export config to file": "Экспортировать конфигурацию тарифного плана в файл",
        "Cancel changes": "Отменить изменения",
        "Simple form": "Упрощенная форма",
        "Common form": "Обычная форма",
        "Advanced form": "Расширенная форма",
        "Hierarchy": "Иерархия",
        "Hierarchy types: \"HTB\" or \"TDF\"":"Типы иерархий: \"HTB\" или \"TDF\"",
        "Inbound rate": "Скорость входящего трафика",
        "Outbound rate": "Скорость исходящего трафика",
        "Burst inbound rate": "Burst скорость входящего трафика",
        "Burst outbound rate": "Burst скорость исходящего трафика",
        "Value should be positive integer number!": "Значение должно быть положительным целым числом!",
        "Classes": "Классы",
        "Save and continue": "Сохранить и продолжить",
        "Type": "Тип",
        "Copy": "Копия",
        "Copy tariff": "Копировать тариф",
        "Class rate summ should be less then root rate!":"Сумма rate по классам должна быть меньше чем значение root rate!",
        "Subscribers filter": "Фильтр абонентов",
        "Policing type": "Тип полисинга",
        "Policing types: \"HTB\" or \"TDF\"":"Типы полисинга: \"HTB\" или \"TDF\"",
        "Code": "Код",
        "Profile name using on DPI": "Имя профиля используемое на DPI",
        "Profile enabled": "Профиль включен",
        "Profile disabled": "Профиль выключен",
        "Start time": "Время начала",
        "Required field": "Обязательное поле",
        "Invalid time": "Некорректное время",
        "End time": "Время окончания",
        "Days of the week": "Дни недели",
        "Apply": "Применить",
        "Are you sure you want to delete this row?": "Вы действительно хотите удалить эту строку?",
        "Add": "Добавить",
        "Time": "Время",
        "Mon": "Пн",
        "Tue": "Вт",
        "Wed": "Ср",
        "Thu": "Чт",
        "Fri": "Пт",
        "Sat": "Сб",
        "Sun": "Вс",
        "Enable": "Включить",
        "Timetable": "Расписание",
        "The tariff is used, deletion is not possible": "Тариф используется, удаление невозможно",
        "Click + to add a schedule": "Нажмите + чтобы добавить расписание",
        "Schedule saved successfully": "Расписание успешно сохранено"
    };

webix.i18n.locales["ru-RU"].dpiui2.SubscribersEmbedded = webix.i18n.locales["ru-RU"].dpiui2.Subscribers;

webix.i18n.locales["ru-RU"].dpiui2.AdBlockRedirectService = webix.i18n.locales["ru-RU"].dpiui2.BlackListService;

webix.i18n.locales["ru-RU"].dpiui2.VasCloud =
    {
        "Vas cloud services":"Сервисы VAS cloud",
        "Personal area":"Личный кабинет",
        "Vas Ads":"Реклама VAS Ads",
        "Billing information":"Информация об оплате",
        "License shop":"Магазин лицензий",
        "Catalog":"Каталог",
        "My orders":"Мои заказы",

        "Account":"Аккаунт",
        "Company":"Компания",
        "Profile":"Профиль",
        "Security":"Безопасность",
        "Company code":"Код компании",
        "Enter company code":"Введите код компании",
        "Company name":"Название компании",
        "Name of your company":"Название вашей компании",
        "Enter company name":"Введите название компании",

        "Ads":"Реклама Ads",
        "Earn with Vas cloud Ads":"Зарабатывайте с VAS cloud Ads",
        "Enabled":"Включено",
        "Disabled":"Выключено",
        "Devices list":"Список DPI устройств",

        "Not need to restart":"Рестарт не требуется",
        "Sync not started":"Синхронизация неактивна",
        "Sync in progress":"Процесс синхронизации",
        "Sync comleted and neet restart":"Синхронизация завершена, требуется рестарт DPI",
        "Sync comleted":"Синхронизация завершена",
        "Sync error":"Sync error",

        "Force sync of lists":"Принудительная синхронизация списков",
        "Sync have been started in background":"Синхронизация была запущена в фоновом режиме",

        "Welcome to VAS Cloud":"Добро пожаловать в VAS Cloud",
        "Send us a request and we will process it as soon as possible":"Отправьте нам запрос, и мы обработаем его как можно скорее",
        "Submit request":"Отправить запрос",
        "Your request is accepted":"Ваш запрос принят",

        "Forgot your password?":"Забыли пароль?",
        "I do not have an account":"У меня нет аккаунта",
        "Password recovery":"Восстановление пароля",
        "Restore":"Восстановить",

        "Subscription status":"Состояние подписки",
        "Active":"Активна",
        "Not active":"Неактивна",
        "Trial period":"Пробный период",
        "remain %s days":"осталось %s дней",
        "You need to activate the subscription to make work this section correctly. You can write to us at sd@vas.expert or request a license by clicking the \"Send request\" button.":"Для корректной работы данного раздела вам необходимо активировать подписку.  <br/><br/>Вы можете написать нам на ящик sd@vas.expert или запросить лицензию, нажав кнопку \"Отправить запрос\".",

        "Check your mail. We have sent you a code": "Проверьте вашу почту. Мы отправили вам код",
        "Code from e-mail":"Код из почты",
        "Enter code from e-mail":"Введите код из почты",
        "Check your mail. We have sent you a new password":"Проверьте вашу почту. Мы отправили вам новый пароль",

        "Licence":"Лицензия",
        "Licences":"Лицензии",
        "Product type":"Продукт",
        "Licence level":"Уровень лицензии",
        "DPI licence level":"Уровень лицензии DPI",
        "Expiration date":"Срок лицензии",
        "Support expiration date":"Срок поддержки",
        "Product uuid":"UUID продукта",
        "Licence limit":"Лимит",
        "Board serial":"Серийный номер платы",
        "Chassis serial":"Серийный номер шасси",
        "MAC addresses":"MAC адреса",
        "Speeds":"Скорости",
        "Add licence":"Добавить лицензию",
        "Licence enabled":"Лицензия активна",
        "Licence disabled":"Лицензия неактивна",
        "No licences found":"Лицензии не найдены",

        "Send":"Отправить",
        "Request a licenсe":"Запросить лицензию",
        "Send request":"Отправить запрос",

        "CKAT":"СКАТ",
        "Making money on affiliate programs is easy! <br/> <br/> <b> VAS cloud Ads </b> offers operators a wide selection of profitable affiliate program offers. Cooperating with us, you can earn big money on other people's sites.":"Заработать на партнерских программах — легко!<br/><br/> <b>VAS cloud Ads</b> предлагает операторам широкий выбор выгодных офферов партнерских программ. Сотрудничая с нами, Вы сможете заработать на чужих сайтах большие деньги.",

        "Copied to clipboard": "Скопировано в буфер обмена",
        "Copy to clipboard":"Скопировать в буфер обмена",
        "Lic options":"Опции лицензии"
    };

webix.i18n.locales["ru-RU"].dpiui2.CgNatService =
    {
        "Are you sure you want to delete the profile?": "Вы уверены, что хотите удалить профиль?",
        "Cancel": "Отменить",
        "Delete": "Удалить",
        "CGNAT profile": "CGNAT профиль",
        "Description": "Описание",
        "Profile title / description": "Описание / имя профиля",
        "Type": "Тип",
        "Type: default or 1:1": "Тип профиля: стандартный или 1:1",
        "Nat IP pool": "NAT IP пул",
        "External IP address range in CIDR format": "Диапазон внешних IP-адресов в формате CIDR",
        "IP pool is incorrect": "Некорректный пул IP-адресов",
        "TCP sessions": "Число TCP сессий",
        "Maximum number of TCP sessions that a subscriber can create": "Максимальное числов TCP сессий, который может создать абонент",
        "Input correct positive number": "Введите целое положительное число",
        "UDP sessions": "Число UDP сессий",
        "Maximum number of UDP sessions that a subscriber can create": "Максимальное числов UDP сессий, который может создать абонент",
        "Save" : "Сохранить",
        "Profiles": "Профили",
        "Add profile": "Добавить профиль",
        "Enable profile": "Включить профиль",
        "Disable profile": "Выключить профиль",
        "Refresh": "Обновить",
        "Profile status": "Статус профиля",
        "Profile": "Профиль",
        "Nat type": "Тип NAT",
        "Status": "Статус",
        "On page": "На странице",
        "Subscribers": "Абоненты",
        "Profile saved": "Профиль сохранен",
        "Profile enabled": "Профиль включен",
        "Profile not enabled": "Профиль не включен",
        "Profile disabled": "Профиль выключен",
        "Profile not disabled": "Профиль не выключен",
        "Profile deleted": "Профиль удален",
        "Full status": "Общий статус",
        "Detailed status": "Подробный статус",
        "Protocol": "Протокол",
        "NTHR": "Номер потока",
        "IP mask": "IP маска",
        "Addresses": "Адресов",
        "Ports": "Портов",
        "Ports in use": "Используется портов",
        "Used": "Используется",
        "IP": "IP",
        "Default": "CGNAT",
        "1:1":"1:1",
        "TCP": "TCP",
        "UDP": "UDP",
        "0": "0",
        "1": "1",
        "0x0": "0x0",
        "0x1": "0x1",
        "Subscribers status": "Статус абонентов",
        "White IP": "Белый IP",
        "Addresses in use": "Используется адресов",
        "Download the file": "Скачать файл",
        "Addresses number": "Количество адресов",
        "Ports number": "Количество портов",
        "All subscribers associated with this profile will be unsubscribed from the CG NAT service.": "Все абоненты привязанные к этому профилю будут отписаны от услуги CG NAT.",
        "IP mask: 0x0 is even address; 0x1 is not even address": "IP маска: 0x0 - четный адрес; 0x1 - не четный адрес",
        "Even address": "Четный адрес",
        "Not even address": "Не четный адрес"
    };

webix.i18n.locales["ru-RU"].dpiui2.HotSpot =
    {
        "Configuration deleted": "Конфигурация удалена",
        "Are you sure you want to delete hotspot configuration?": "Вы уверены, что хотите удалить конфигурацию ХотСпота?",
        "Delete configuration": "Удалить конфигурацию",

        "Are you sure you want to delete the selected language?": "Вы уверены, что хотите удалить данный язык?",
        "Cancel": "Отменить",
        "Delete": "Удалить",
        "Language": "Язык",
        "Field is required": "Поле является обязательным",
        "Add": "Добавить",
        "Cancel changes": "Отменить изменения",
        "Save": "Сохранить",
        "Web server configuration": "Конфигурация web сервера",
        "Web server": "Web сервер",
        "Add new hardware": "Добавить новое устройство",
        "Captive portal URL": "Captive portal URL",
        "Will be created/updated profile for white list service with inputed URL": "Будет создан/изменен профиль услуги Белый список с введенным URL",
        "Profile name is hotspot_white_list_profile": "Имя профиля - hotspot_white_list_profile",
        "Session lifetime (sec)": "Время жизни сессии (сек)",
        "Session lifetime": "Время жизни сессии",
        "Redirect URL": "URL для редиректа",
        "Subscriber will be redirected to URL after authorization proceed":"Абонент будет перенапревлен по этому URL после того как пройдет авторизацию",
        "WiFi authorization configurations": "Конфигурация Wi-Fi авторизации",
        "WiFi authorization enabled": "Включение Wi-Fi авторизации",
        "SMS authorization enabled": "SMS авторизация",
        "SMS authorization settings": "Настройки SMS авторизации",
        "Call authorization enabled": "Авторизация звонком",
        "Call authorization settings": "Настройки авторизации звонком",
        "Sequential authorization": "Последовательная авторизация",
        "This mode allows you to select the initial authorization method": "Данный режим позволяет выбрать первоначальный способ авторизации",
        "Debug mode": "Режим отладки",
        "Debug mode allows you to send an authorization code to the email inputed to the phone number field.": "Режим отладки позволяет отправить код авторизации на email указанный в поле телефонного номера.",
        "This function allows you to test after authorizations scripts.": "Эта функция позволяет Вам протестировать сценарии после авторизации абонента",
        "Click wrap configuration": "Конфигурация Клик-оферты",
        "Click wrap enabled": "Включение Клик-оферты",
        "Policings configuration": "Конфигурация тарифов",
        "Authorization Policing": "Тариф для авторизации",
        "Wifi Policing": "Тариф для бесплатного Wi-Fi",
        "Payed Wifi Policing": "Тариф для платного Wi-Fi",
        "Subscribers services customization": "Управление услугами",
        "Captive portal customization": "Настройки Captive portal",
        "View configuration": "Настройки вида",
        "Favicon": "Иконка",
        "Logo": "Логотип",
        "View image": "Посмотреть содержимое",
        "Language configuration": "Настройка языка",
        "Add new language": "Добавить язык",
        "Key": "Ключ",
        "Value": "Значение",
        "Set as dafault": "Установить по умолчанию",
        "Logs": "Логи",
        "HotSpot tool interface log": "Логи интерфейса ХотСпот",
        "Refresh": "Обновить",
        "Click wrap log": "Логи Клик-оферты",
        "WIKI": "WIKI",
        "Add parameters to the request body or url for the request to be processed correctly": "Добавьте параметры в тело или URL, чтобы запроса корректно отработал",
        "Example": "Пример",
        "Phone": "Телефон",
        "Code": "Код",
        "Body type": "Тело запроса",
        "Settings was successfully saved": "Настройки успешно сохранены",
        "This language is already existing in dictionary!": "Этот язык локализации уже присутствует в словаре!",
        "Configure <a href=\"https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:platform:subscriber_management:subsman_remote\">remote ssh commands</a>": "Настроить <a target='_blank' href=\"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_components:platform:subscriber_management:subsman_remote\">удаленный запуск команд через SSH</a>",
        "Set up on the trigger for issuing a new IP:": "Установить на триггер на выдачу нового IP:",
        "DHCP configuration": "Настройки DHCP",
        "For Wi-Fi authorization use this trigger:": "Для Wi-Fi авторизации используйте этот триггер:",
        "If you need only click-wrap function use this trigger:": "Если Вам нужна только функция Клик-оферты, используйте этот триггер:",
        "Input correct url!": "Введите корректный URL!",
        "HotSpot": "ХотСпот",
        "Wi-Fi tool interface log": "Логи Wi-Fi интерфейса",
        "Image file max size is 750kb": "Максимальный размер файла с изображением 750 кб",
        "SMS": "СМС",
        "Call": "Звонок",
        "Common settings": "Общие настройки",
        "View settings": "Настройки внешнего вида",
        "Localizations settings": "Настройки локализации",
        "Auth and Click-Wrap settings": "Настройки авторизации и клик-оферты",
        "Services settings": "Настройки услуг",
        "Tariffs settings": "Настройки тарифов",
        "Session management enabled": "Включить управление сессиями",
        "Session init Web-hook configuration": "Настройки Web-хука для создания сессии",
        "Authorization type": "Тип авторизации",
        "Outgoing call service settings": "Настройки Web-хука для исходящего звонка",
        "Outgoing call phones list": "Номера телефонов для исходящего звонка",
        "Secret key for hash generating": "Секретный ключ для генерации хэша",
        "By auth code": "По коду",
        "By outgoing call": "По исходящему звонку",
        "Enable Advertising (service id = 2)": "Включить Рекламу (id услуги = 2)",
        "Enable Ad blocking (service id = 3)": "Включить Блокировку рекламы (id услуги = 3)",
        "Enable black list (service id = 4)": "Включить Черный список (id услуги = 4)",
        "Use black list named profile": "Использовать именованный профиль Черного списка (id услуги = 4)",
        "CGNAT named profile (service id = 11)": "Использовать именованный профиль CGNAT (id услуги = 11)",
        "Enable Notification (service id = 50)": "Включить Нотификации (id услуги = 50)",
        "No profile": "Без профиля",
        "Tariff": "Тариф",
        "HOTSPOT_WIKI_URL": "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_components:dpiui:user_guide:ssg_control_section:management_hotspot",
        "If session management enabled - HotSpot will execute scripts for subscriber session initiation on DPI": "Если управление сессиями включено - ХотСпот будет выполнять скрипты для создания абонента на стороне DPI",
        "If disabled - HotSpot will make http request for initiate subscriber session": "Если выключено - ХотСпот выполнит HTTP запрос для создания сессии абонента",
        "Subscriber session lifetime, seconds": "Время жизни сессии, в секундах",
        "HotSpot will execute script for delete subscriber from DPI and load auth policing and captive portal service for his IP address": "По истечению времени жизни ХотСпот выполнит скрипт для удаления абонента с DPI и применит тариф авторизации и услугу Captive Portal для его IP адреса",
        "Subscriber session init HTTP request configuration": "Конфигурация HTTP запроса для создания сессии абонента",
        "HotSpot will make http request for initiate subscriber session": "ХотСпот выполнит HTTP запрос для создания сессии абонента",
        "Request template params:": "Параметры запроса для шаблона:",
        "IP address": "IP адрес",
        "HTTP request configuration for sending a pre-generated authorization code via SMS": "Конфигурация HTTP запроса для отправки предварительно сгенерированного кода авторизации через СМС",
        "HTTP request configuration for sending a pre-generated authorization code via incoming call": "Конфигурация HTTP запроса для отправки предварительно сгенерированного кода авторизации через входящий звонок",
        "Call service settings": "Настройки отправки кода авторизации через входящий звонок",
        "Input phone numbers separated by comas.": "Введите нормера телефонов через запятую.",
        "HotSpot will select random phone number from list for authorize subscriber by outgoing call.": "ХотСпот выберет случайный номер телефона для авторизации абонента по исходящему вызову.",
        "Configure your call service for sending HTTP request on call received from subscriber.": "Настройте Ваш сервис звонков для отправки HTTP запроса о получении исходящего звонка от абонента на ХотСпот.",
        "Available API method for receiving signal": "API метод ХотСпота для получения сигнала",
        "Hash generating:": "Создание хэша:",
        "Advertising service(id=2) will apply for authorized subscriber.": "К авторизованным абонентам будет применена услуга рекламы(id=2).",
        "Ad blocking service(id=3) will apply for authorized subscriber.": "К авторизованным абонентам будет применена услуга блокировки рекламы(id=3).",
        "Black list service(id=3) will apply for authorized subscriber.": "К авторизованным абонентам будет применена услуга черного списка(id=4).",
        "Black list service named profile will apply for authorized subscriber.": "К авторизованным абонентам будет применен именованный профиль услуги черного списка(id=4).",
        "CGNAT named profile will apply for authorized subscriber (service id = 11).": "К авторизованным абонентам будет применен именованный профиль услуги CGNAT (id услуги = 11).",
        "Notification service(id=50) will apply for authorized subscriber.": "К авторизованным абонентам будет применена услуга нотификации(id=50).",
        "Configure <a href=\"https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:platform:subscriber_management:subsman_remote\">remote ssh commands</a>": "Настройка <a href=\"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_components:platform:subscriber_management:subsman_remote\">удаленного запуска ssh команд</a>",
        "Delete leading '+7' and '8' from phone": "Удалить ведущие '+7' и '8' из номера телефона клиента"
    };

webix.i18n.locales["ru-RU"].dpiui2.MiniFirewallService = {
    "Are you sure you want to delete the profile?": "Вы уверены, что хотите удалить данный профиль?",
    "All subscribers associated with this profile will be unsubscribed from the Mini FireWall service.": "Все абоненты привязанные к этому профилю будут отписаны от услуги Мини Файрвол.",
    "Cancel": "Отменить",
    "Delete": "Удалить",
    "Mini Firewall profile": "Профиль услуги Мини Файрвол",
    "Description": "Описание",
    "Profile title / description": "Описание / имя профиля",
    "Port numbers": "Блокировать порты до",
    "The port number, below which access is blocked": "Номер порта, ниже которого блокируется доступ",
    "Allowed ports": "Исключить порты",
    "List of ports that are allowed to access bypassing the max_port limit":"Список портов, к которым разрешается доступ в обход ограничения max_port",
    "List of ports to which outbound traffic is closed": "Список портов, на которые закрыт исходящий трафик",
    "Closed ports": "Запрет исходящих портов",
    "Save": "Сохранить",
    "Profiles": "Профили",
    "Add profile": "Добавить профиль",
    "Enable profile": "Включить профиль",
    "Disable profile": "Выключить профиль",
    "Refresh": "Обновить",
    "Profile with name 'noname' doesn`t support this feature!" : "Неименованные профили не поддерживают данную функцию!",
    'noname': 'Неименованный профиль',
    "Profile enabled": "Профиль включен",
    "Profile not enabled": "Профиль не включен",
    "Profile disabled": "Профиль выключен",
    "Profile not disabled": "Профиль не выключен",
    "Profile saved": "Профиль сохранен",
    "Profile deleted": "Профиль удален",
    "Profile": "Профиль",
    "Status": "Статус",
    "Input correct integer number between 1 and 1024": "Введите корректное целое число от 1 до 65535",
    "Enter port numbers separated by commas": "Введите номера портов через запятую"
};

webix.i18n.locales["ru-RU"].dpiui2.Services = {
    "License level": "Уровень лицензии",
    "License status": "Состояние лицензии",
    "Functions of this service will not work on DPI": "Функции данной услуги не будут работать на DPI",
    "Service not available for your DPI license level!": "Сервис не доступен для вашей лицензии DPI!",
    "Service available!": "Сервис доступен!"
};

webix.i18n.locales["ru-RU"].dpiui2.Dpiui2Config =
    {
        "Configuration loaded":"Конфигурация загружена",
        "Queue restarted successfully":"Очередь перезапущена",

        "New version [version] is available.":"Доступна новая версия [version].",
        "Current version is":"Текущая версия - ",
        "Date of install / update is":"Дата установки / обновления - ",
        "Last check for update is":"Последняя проверка обновления - ",
        "Automatically install updates.":"Автоматически устанавливать обновления.",
        "Check for updates":"Проверить обновления",
        "Update now":"Обновить сейчас",
        "DPIUI2 update":"DPIUI2 обновление",
        "DPIUI2(GUI) update":"DPIUI2(GUI) обновление",
        "DPIUI2 last update log":"DPIUI2 лог последнего обновления",
        "DPIUI2 last check for update log":"DPIUI2 лог последней проверки обновления",
        "Reversed order":"Обратный порядок",
        "Update can take several minutes. Please wait till it finished. Don`t forget press Ctrl+F5 after.":"Обновление может занять несколько минут. Пожалуйста, подождите, пока оно не закончится. Не забудьте нажать Ctrl + F5 после.",
        "The update script has completed the work. It` required to refresh the page. Click Refresh page or ctrl + f5.":"Сценарий обновления завершил работу. Требуется обновить страницу. Нажмите Обновить страницу или нажмите Ctrl + F5.",
        "Reload page":"Обновить страницу",
        "Restart queue": "Перезапустить очередь",
        "Hot options updated!": "Горячие параметры обновлены!",
        "Download from history":"Загрузить из истории"
    };

webix.i18n.locales["ru-RU"].dpiui2.SocketNotifications =
{
    "Are you sure you want to delete the selected records?": "Вы уверены, что хотите удалить все выбранные записи?",
    "Cancel": "Отменить",
    "Delete": "Удалить",
    "Are you sure you want to delete all the records?": "Вы уверены, что хотите удалить все записи?",
    "Details": "Детали",
    "Mark as read": "Пометить как прочитанное",
    "Notifications": "Нотификации",
    "Close": "Закрыть",
    "Select all notifications": "Выбрать все нотификации",
    "Read notifications": "Пометить как прочитанные",
    "Read selected": "Прочитать выбранные",
    "Read all": "Прочитать все",
    "Delete notifications": "Удалить нотификации",
    "Delete selected": "Удалить выбранные",
    "Delete all": "Удалить все",
    "Refresh": "Обновить",
    "Back": "Назад",
    "Status": "Статус",
    "Notification date": "Дата нотификации",
    "Notify type": "Тип нотификации",
    "Notification content": "Содержимое нотификации",
    "Unread notifications: ": "Непрочитанных нотификаций: ",
    "Unknown": "Неизвестно",
    "Subscribers synchronization completed successfully": "Синхронизация абонентов успешно завершена",
        "Subscribers and vchannels synchronization completed successfully": "Синхронизация абонентов и каналов успешно завершена",
    "Ssh not connected": "Отсутсвует SSH соединение",
    "Ssh connected": "SSH подключен",
    "Hardware": "Устройство",
    "Information":"Информация",
    "Warning": "Предупреждение",
    "Error": "Ошибка",
    "Success": "Успешно",
    "Other": "Другое",
    "News": "Новости",
    "Subscribers synchronization": "Синхронизация абонентов",
        "Subscribers and vchannels synchronization": "Синхронизация абонентов и каналов",
    "Messages": "Сообщение",
    "Ssh connection": "SSH соединение",
    "Read": "Прочитано",
    "New": "Новое",
    "Trigger fired": "Сработал триггер",
    "Forcing moving or removing data for":"Принудительное перемещение или удаление данных для",
    "Partitions to move":"Партиции для перемещения",
    "Partitions to remove":"Партиции для удаления",
    "QoE report ready": "Подготовлен QoE отчет",
    "QoE report": "QoE отчет"
};

webix.i18n.locales["ru-RU"].dpiui2.QoEStorConfig =
    {
        "Do you want to restart configuration?":"Вы хотите перезапустить конфигурацию?",
        "Add receiver":"Добавить ресивер",
        "Restart finished":"Перезагрузка завершена",
        "QoE Stor nodes":"Ноды QoE Stor",
        "There is no QoE Stor nodes.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>.":"Отсутствуют ноды QoE Stor.<br/>Вы можете их добавить в <a href='#Hardwares'>разделе Оборудование</a>.",
        "Forced download of directories": "Принудительная загрузка справочников",
        "Forced download finished":"Принудительная загрузка завершена",
        "Start forced download":"Принудительная загрузка началась",
        "Started dictionaries forced download in background":"Принудительная загрузка словарей началась в фоновом режиме",
        "Move":"Перейти",
        "You are not authorized in VAS Cloud":"Вы не авторизованы в VAS Cloud",
        "Move to login page?":"Перейти на страницу авторизации?",

        "fullflow aggregation settings":"Настройки агрегации fullflow",
        "fullflow additional aggregation settings": "Настройки дополнительной агрегации fullflow",
        "After how many days to reaggregate logs":"Спустя сколько дней проводить переагрегацию логов",
        "Time interval for log aggregation":"Интервал времени для агрегирования логов",
        "The data from the fullflow_agg table will be reaggregated at the specified interval in the fullflow_agg_compressed_N table and after the specified number of days will be moved to the fullflow_agg table and replace the corresponding partitions.":"Данные из таблицы fullflow_agg будут переагрегированны с указанным интервалом в таблице fullflow_agg_comressed_N и через указаное количество дней переместятся в таблицу fullflow_agg и заменят соответствующие партиции.",
        "Stage":"Этап",
        "After 7 days":"Спустя 7 дней",
        "After 30 days":"Спустя 30 дней",
        "Enable fullflow additional aggregation Stage":"Включить дополнительную агрегацию fullflow Этап",
        "Specify the number of days to reaggregate on stage":"Укажите количество дней для повторного агрегирования на этапе",
        "Time interval for fullflow log aggregation must be less than time on stage":"Интервал времени для агрегирования логов fullflow должен быть меньше, чем время на этапе",
        "The number of days for reaggregation on stage 1 must be less than on stage 2.":"Количество дней для реагрегации на этапе 1 должно быть меньше, чем на этапе 2.",
        "The time interval for reaggregation on stage 1 must be less than on stage 2.":"Интервал времени для реагрегации на этапе 1 должен быть меньше, чем на этапе 2.",

        "Restart receivers": "Перезапустить ресиверы",
        "Stop receivers": "Остановить ресиверы",
        "Are you sure you want to restart all receivers?":"Вы уверены что хотите перезапустить все ресиверы?",
        "Are you sure you want to stop all receivers?":"Вы уверены что хотите остановить все ресиверы?",
        "QoE receivers successfully restarted.":"QoE ресиверы успешно перезапущены.",
        "QoE receivers successfully stopped.":"QoE ресиверы успешно остановлены.",
        "Download receivers configuration file":"Скачать файл конфигурации ресиверов",
        "Upload receivers configuration from file":"Загрузить конфигурацию ресиверов из файла",
        "configuration file":"кофигурационный файл",
        "Restart configuration": "Перезапустить конфигурацию"
    };

webix.i18n.locales["ru-RU"].dpiui2.FastPcrfConfig = {
    "Service restarted successfully": "Сервис FastPCRF успешно перезапущен",
    "Service reloaded successfully": "Сервис FastPCRF успешно перезагружен",

    "All fastdpi services from property fdpi_server will be restarted!": "Все fastdpi сервисы из опции fdpi_server будут перезапущены!",
    "FastDPI service started successfully": "Сервис FastDPI успешно запущен",
    "FastDPI service stopped successfully": "Сервис FastDPI успешно остановлен",
    "Fast PCRF config saved!": "Fast PCRF конфигурация сохранена!",
    "Update the hot parameters or restart Fast PCRF for applying the changes!": "Для того, чтобы изменения вступили в силу обновите горячие параметры или перезапустите Fast PCRF!",
    "Configuration loaded.": "Конфигурация загружена.",
    "Applied": "Применено",
    "FastDPI service restarted successfully": "Сервис FastDPI успешно перезапущен"
};

webix.i18n.locales["ru-RU"].dpiui2.SshTerminal = {
        "Welcome to remote hardware terminal!": "Добро пожаловать в удаленный терминал устройства!",
        "Hardware ssh terminal": "SSH терминал устройства",
        "Hardwares": "Устройства",
        "Hardware": "Устройство",
        "Type": "Тип",
        "Hardware connections": "Подключения к устройствам",
        "Terminal": "Терминал",
        "Clear": "Очистить",
        "Execute": "Выполнить",
        "Commands": "Команды"
};

webix.i18n.locales["ru-RU"].dpiui2.Vchannels = {
        "Vchannel number": "Номер канала",
        "Vchannel name": "Имя канала",
        "Tariffs": "Тарифы",
        "Are you sure you want to delete services and tariffs in the selected records?": "Вы действительно хотите удалить услуги и тарифы у выбранных записей?",
        "List of vchannels": "Список каналов",
        "No services": "Нет сервисов",
        "Services": "Услуги",
        "Tariffs": "Тарифы",
        "Delete": "Удалить",
        "Update": "Обновить",
        "Forced vchannels synchronization": "Принудительная синхронизация каналов",
        "Refresh": "Обновить",
        "No profile": "Нет профилей",
        "Forced synchronization vchannels running in the background": "Принудительная синхронизация каналов запущена в фоновм режиме",
        "Deleted": "Удалено",
        "Error": "Ошибка",
        "See logs": "Просмотрите логи",
        "Канал": "Канал",
        "Saved": "Сохранено",
        "Id": "Код",
        "Service": "Услуга",
        "Enabled": "Подключена",
        "Disabled": "Не активирован",
        "Profile": "Профиль",
        "Tariff": "Тариф",

        "Are you sure you want to save the cidr list?":"Вы уверены что хотите сохранить список CIDR? ",
        "When you click on the Save button, only the CIDR list is saved":"При нажатии на кнопку «Сохранить» сохраняется только список CIDR",
        "Vchannel settings saved": "Настройки списка vchannels сохранены",
        "List of CIDRs for Vchannels": "Список CIDR для Vchannel-ов",
        "Vchannel number": "Номер vchannel"
};

webix.i18n.locales["ru-RU"].dpiui2.Protocols = {
        "Hardwares": "Оборудование",
        "Protocols": "Протоколы",
        "Custom Protocols": "Пользовательские протоколы",
        "Resource List": "Список ресурсов",
        "Custom protocols: Resource List": "Пользовательские протоколы: Список ресурсов",
        "List type": "Тип списка",
        "Number": "Номер",
        "Description": "Описание",
        "Type": "Тип",
        "Test": "Тестовый",
        "Main": "Основной",
        "Enabled": "Включено",
        "Status": "Статус",
        "Status Description": "Описание статуса",
        "Event": "Событие",
        "Attempts": "Попытки",
        "Create Time": "Время создания",
        "Update Time": "Время обновления",
        "Create User": "Создал пользователь",
        "Update User": "Обновил пользователь",
        "Custom number": "Пользовательский номер",
        "Main List": "Основной список",
        "Custom number is a protocol identifier, a range limited to values from 1 to 4096 is reserved for custom protocols.": "Пользовательский номер - это идентификатор протокола, под пользовательские протоколы зарезервирован диапазон, который ограничен значениями от 1 до 4096.",
        "Protocol saved": "Протокол сохранен",

        "Protocol saved successfully":"Протокол успешно сохранен",
        "Protocol deleted successfully":"Протокол успешно удален",

        "Synchronization mode":"Режим синхронизации",
        "Company":"Компания",
        "Hardware saved successfully":"Оборудование успешно сохранено",
        "Protocols erased successfully":"Протоколы успешно удалены",
        "Protocols deleted successfully":"Протоколы успешно удалены",
        "Protocol enabled successfully":"Протокол успешно включен",
        "Protocol disabled successfully":"Протокол успешно отключен",
        "Protocols enabled successfully":"Протоколы успешно включены",
        "Protocols disabled successfully":"Протоколы успешно отключены",
        "Protocol Item enabled successfully":"Элемент протокола успешно включен",
        "Protocol Item disabled successfully":"Элемент протокола успешно отключен",
        "Protocol Items enabled successfully":"Элементы протокола успешно включены",
        "Protocol Items disabled successfully":"Элементы протокола успешно отключены",
        "Resource List saved successfully":"Список ресурсов успешно сохранен",
        "Resource List deleted successfully":"Список ресурсов успешно удален",
        "Protocols Items erased successfully":"Элементы протоколов успешно удалены",
        "Protocols Items deleted successfully":"Элементы протоколов успешно удалены",
        "Imported successfully":"Импортировано успешно",
        "Custom Protocols Items":"Элементы настраиваемых протоколов",

        "Type of list<br/>Which list to load on the equipment: Main or Test.<br/>Default is Main.":"Тип списка<br/>Какой список загружать на оборудование: Основной или Тестовый.<br/>По умолчанию Основной.",
        "Synchronization mode<br/>Protocol list synchronization mode.<br/>By DPIUI2 - dpiui2 module downloads lists to equipment.<br/>By URL - FastDPI downloads lists by link.<br/>By URL is default.":"Режим синхронизации<br/>Режим синхронизации списков протоколов.<br/>By DPIUI2 – модуль dpiui2 загружает списки на оборудование.<br/>By URL – FastDPI загружает списки по ссылке.<br/>По умолчанию By URL.",

        "ok":"ок",
        "error":"ошибка",
        "downloading":"скачивание",
        "unpacking":"распаковка",
        "preparing":"подготовка",
        "uploading":"загрузка",
        "reloading":"перезагрузка",
        "clearing":"очистка",

        "Clear list":"Очистить список",

        "Get":"Получить",
        "Record":"Запись",
        "Items added successfully":"Элементы успешно добавлены",

        "Validation error":"Ошибка валидации",

        "For single IP\n201.1.1.1\n2001:db9::1\n\nFor IP with port\n201.1.2.3 8081\n2001:db9::1 9090\n\nFor CIDR\n201.198.4.0/24\n2001:db8::0/64":"Для одного IP\n201.1.1.1\n2001:db9::1\n\nДля IP с Port\n201.1.2.3 8081\n2001:db9::1 9090\n\nДля CIDR\n201.198.4.0/24\n2001:db8::0/64",
        "For single IP":"Для одного IP",
        "For IP with Port":"Для IP с Port",
        "For CIDR":"Для CIDR",
        "For CIDR with Port":"Для CIDR с Port",

        "Data":"Данные",
        "Help":"Помощь",

        "Automatic resource type detection":"Автоматическое определение типа ресурса",
        "For some domain":"Для домена",
        "For some subdomain":"Для поддомена",
        "For domain with all subdomains":"Для домена со всеми поддоменами",

        "Any AS number":"Номер АС"
};

webix.i18n.locales["ru-RU"].dpiui2.DDoSProtectionService = {
        "Are you sure you want to delete the profile?": "Вы уверены, что хотите удалить данный профиль?",
        "All subscribers associated with this profile will be unsubscribed from the DDoS Protection service.": "Все абоненты привязанные к этому профилю будут отписаны от услуги защита от DDoS",
        "Cancel": "Отменить",
        "Delete": "Удалить",
        "Save": "Сохранить",
        "Profiles": "Профили",
        "Add profile": "Добавить профиль",
        "Enable profile": "Включить профиль",
        "Disable profile": "Выключить профиль",
        "Refresh": "Обновить",
        "Status": "Статус",
        "Profile with name 'noname' doesn`t support this feature!" : "Неименованные профили не поддерживают данную функцию!",
        "noname": "Неименованный профиль",
        "Profile enabled": "Профиль включен",
        "Profile not enabled": "Профиль не включен",
        "Profile disabled": "Профиль выключен",
        "Profile not disabled": "Профиль не выключен",
        "Profile saved": "Профиль сохранен",
        "Profile deleted": "Профиль удален",
        "Profile": "Профиль",
        "Profile name":"Имя профиля",
        "Enter profile name":"Введите имя профиля",
        "Profile title / description": "Описание / имя профиля",
        "DDoS Protection profile": "Профиль защита от DDoS",
        "DoS configuration": "DoS конфигурация",
        "DDoS configuration": "DDoS конфигурация",
        "Protection mode": "Режим защиты",
        "The sync per second threshold": "Порог количества syn в секунду",
        "Logging of protection triggering":"Логирование срабатывания защиты",
        "Enter value between 0 and 2": "Введите значение от 0 до 2",
        "Enter value between 0 and 1": "Введите значение от 0 до 1",
        "Enter a value higher than 0": "Введите значение больше 0",
        "Enter value between 0 and 100":"Введите значение от 0 до 100",
        "The interval of checking the amount of syn in milliseconds": "Интервал в миллисекундах проверки количества syn",
        "The time interval for monitoring the response to syn+ack":"Интервал времени мониторинга ответа на syn+ack",
        "Protected port numbers":"Защищаемые номера портов",
        "% of unconfirmed queries for activating protection":"Процент неподтвержденных запросов для активации защиты",
        "CAPTCHA page":"Страничка с CAPTCHA",
        "Encryption key":"Ключ шифрования",
        "Number of requests per second in normal operation":"Количество запросов в секунду при нормальной работе",
        "% of possible rejection of requests during normal operation of the site":"% возможного отклонения запросов при нормальной работе сайта",
        "Number of packets per second in normal operation":"Количество пакетов в секунду при нормальной работе",
        "% of possible deviation of packets during normal operation of the site":"% возможного отклонения пакетов при нормальной работе сайта",
        "The CAPTCHA server is not connected. Connect in the Hardware section":"Не подключен сервер CAPTCHA. Подключите в разделе Оборудование",

        "For single IP\n201.1.1.1\n2001:db9::1\n\nFor IP with port\n201.1.2.3 8081\n2001:db9::1 9090\n\nFor CIDR\n201.198.4.0/24\n2001:db8::0/64":"Для одного IP\n201.1.1.1\n2001:db9::1\n\nДля IP с Port\n201.1.2.3 8081\n2001:db9::1 9090\n\nДля CIDR\n201.198.4.0/24\n2001:db8::0/64",

        "DPI Version": "Версия DPI",

        //DicDDoSLocale
        "Protection is off":"Защита выключена",
        "Protection is activated automatically":"Активируется автоматически",
        "Protection is always on":"Включена всегда",
        "Alert logging is off":"Нет",
        "Alert logging triggering on/off":"Переключения срабатывания защиты on/off",

        //HelpPopupLocale
        "Link to wiki": "Ссылка на Wiki",

        //DOS
        "To switch the protection mode on and off (off by default) ": "Активировать режим защиты (по умолчанию выключена) ",
        "Protection triggering logging (default No) ": " Логирование срабатывания защиты (по умолчанию Нет) ",
        "Threshold for number of syn per second (no confirmation) when we consider everything OK (default is 50) ": "Порог количества SYN-запросов в секунду (без ответа), при котором трафик считается нормальным (по умолчанию 50) ",
        "Interval in milliseconds for checking the number of syn and verified syn (defaults to 100) ":"Интервал в миллисекундах проверки кол-ва syn и подтвержденных syn (по умолчанию 100) ",
        "Time interval in seconds to monitor the syn+ack response generated by the scat (default is 60) ":"Интервал времени в секундах мониторинга ответа на syn+ack, сформированного скат (по умолчанию 60) ",
        "The main configuration file /etc/dpi/fastdpi.conf specifies the protected port numbers (default is 80, can be changed online) ":"В основном конфигурационном файле /etc/dpi/fastdpi.conf указываются защищаемые номера портов (по умолчанию 80, можно менять online) ",
        "Percentage of unconfirmed client requests at which protection is automatically activated (default 5, can be changed online) ":"Процент неподтвержденных запросов со стороны клиента, при котором защита активируется автоматически. По умолчанию 5, значение можно менять онлайн ",

        //DDOS
        "CAPTCHA page to be redirected to for verification ":"Страничка с CAPTCHA, на которую производится перенаправление для проверки ",
        "The encryption key used in generating the tokens that indicate to the dpi that the verification has been successfully passed ":"Ключ шифрования, используемый при формировании токенов, индицирующих для DPI успешное прохождение проверки ",
        "The number of requests per second to the protected site, usually selected at the maximum value observed during normal operation of the site ":"Количество запросов в секунду, приходящее на защищаемый сайт, обычно выбирается максимальное значение, которое наблюдалось при нормальной работе сайта ",
        "Is the percentage of possible deviation from the threshold set in ddos_reqsec_threshold at which protection is activated or deactivated respectively, set to avoid the «chatter effect» and set to 5% by default ":"Это заданное в процентах возможное отклонение от заданного в поле(Количество запросов в секунду при нормальной работе) порога, при котором происходит соответственно включение или отключение защиты, задается для избежания эффекта «дребезга» и по умолчание составляет 5% ",
        "The number of packets per second arriving at the protected site, usually selected at the maximum value observed during normal operation of the site ":"Количество пакетов в секунду, приходящее на защищаемый сайт, обычно выбирается максимальное значение, которое наблюдалось при нормальной работе сайта ",
        "Is the percentage of possible deviation from the threshold set in ddos_pktsec_threshold at which protection is activated or deactivated respectively, set to avoid the «chatter effect» and set to 5% by default ":"Это заданное в процентах возможное отклонение от заданного в поле(Количество пакетов в секунду при нормальной работе) порога, при котором происходит соответственно включение или отключение защиты, задается для избежания эффекта «дребезга» и по умолчание составляет 5% "
};

webix.i18n.locales["ru-RU"].dpiui2.WikiLinks = {
        "wiki_doku_link":"https://wiki.vasexperts.ru/doku.php?id=",
        "dpiui2_versions_info":"dpi:dpi_components:dpiui:install_and_update:version_information",
        "ddos_settings":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_ddos:ddos_ddos:ddos_ddos_settings",
        "ddos_dos_synflood":"https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:opt_ddos:ddos_dos:ddos_dos_synflood",

        "qoe_online_reports":"https://wiki.vasexperts.ru/doku.php?id=dpi:qoe:use_cases:online_reports_module"
};

webix.i18n.locales["ru-RU"].dpiui2.BalancerConfig =
{
        "Balancer servers": "Серверы IPFIX-балансира",
        "There is no Balancer servers.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>.":"Отсутствуют серверы IPFIX-балансира.<br/>Вы можете их добавить в <a href='#Hardwares'>разделе Оборудование</a>."
};

webix.i18n.locales["ru-RU"].dpiui2.Messages =
{
        "Delete messages": "Удалить сообщения",
        "Are you sure you want to delete all messages?": "Вы уверены, что хотите удалить все сообщения?",
        "Are you sure you want to delete the selected messages?": "Вы уверены, что хотите удалить выбранные сообщения?",
        "Message date": "Дата сообщения",
        "Message type": "Тип сообщения",
        "Message content": "Содержимое сообщения",
        "Select all messages": "Выбрать все сообщения",
        "Read messages": "Прочитать сообщения"
};

webix.i18n.locales["ru-RU"].dpiui2.HardwareSshKeys =
{
        "SSH keys": "SSH ключи",
        "SSH key": "SSH ключ",
        "SSH key settings": "Настройки SSH ключа",
        "Add ssh key": "Добавить SSH ключ",
        "Private key": "Приватный ключ",
        "Public key": "Публичный ключ",
        "Clear SSH keys": "Очистить SSH ключи",
        "Generate SSH keys": "Сгенерировать SSH ключи",
        "Generate": "Сгенерировать",
        "Generating SSH keys": "Генерация SSH ключей",
        "Do you really want to delete the ssh key?": "Вы действительно хотите удалить этот SSH ключ?",
        "Download public key": "Скачать публичный ключ",
        "Download private key": "Скачать приватный ключ",
        "Upload public key": "Загрузить публичный ключ",
        "Upload private key": "Загрузить приватный ключ",
        "Generate SSH key successfully": "Генерация SSH ключей успешно завершена",
        "Passphrase": "Кодовая фраза",
        "PASSPHRASE_HELP_POPUP_TEXT": "Введите кодовую фразу которую указывали при создании ключа.<br><br>Если кодовая фраза не была установлена, оставьте поле пустым",
        "SSH_KEY_HELP_POPUP_TEXT": "Конфигурация ssh для подключения к оборудованию - <a href='https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_components:dpiui:user_guide:admin_section:equipment_management:ssh_keys' target='_blank'>статья</a>.<br><br>Если нужные ssh файлы отсутствуют, их можно создать с помощью генерации ключей нажав на кнопку ключа выше и после генерации скачать их для настройки ssh подключения к оборудованию.<br><br>Если приватный ключ зашифрован, то необходимо предоставить кодовую фразу.",
        "Algorithm": "Алгоритм",
        "Format": "Формат",
};

webix.i18n.locales["ru-RU"].dpiui2.MailingTemplates = {
        "Template":"Шаблон",
        "Template name":"Название шаблона",
        "Template data":"Данные шаблона",
        "Add template":"Добавить шаблон",
        "Add new template":"Добавить новый шаблон",
        "Edit template":"Редактировать шаблон",
        "Copy template":"Копировать шаблон",
        "Delete template":"Удалить шаблон",
        "Template editing":"Редактирование шаблона",
        "Template type":"Тип шаблона",
        "Email":"Почта",
        "Telegram":"Телеграм",
        "Set default template":"Установить шаблон по умолчанию",
        "Template options":"Опции шаблона",
        "Please, select template or create new":"Пожалуйста, выберите шаблон или создайте новый",
        "Template successfully saved.":"Шаблон успешно сохранен.",
        "Template successfully deleted.":"Шаблон успешно удален",
        "Or double click to add item to the template.":"Или дважды щелкните, чтобы добавить элемент в шаблон.",
        "Templates visibility":"Видимость шаблонов",
        "Set the user to see only their own templates or also templates of other users.":"Установите что бы пользователь видел только свои шаблоны или также шаблоны других пользователей",
        "Templates of all users":"Шаблоны всех пользователей",
        "Only user templates":"Только шаблоны пользователя",
        "Templates editability":"Редактируемость шаблонов",
        "Set the user to edit only their own templates or also templates of other users.":"Установите что бы пользователь мог редактировать только свои шаблоны или также шаблоны других пользователей",
        "Restore template":"Востановить шаблон",
        "View template":"Просмотр шаблона",
        "Show template":"Показать шаблон",
        "for user":"для пользователя",
        "for all users":"для всех пользователей",
        "Template visibility":"Видимость шаблона",
        "Final report":"Итоговый отчет",
        "Links to reports":"Ссылки на отчеты",
        "Links to PDF reports":"Ссылки на PDF отчеты",
        "Default template":"Шаблон по умолчанию",
        "XLSX template":"XLSX шаблон",
        "PDF template":"PDF шаблон",
        "redmine.json default template":"redmine.json шаблон по умолчанию",
        "Display period in filename":"Отобразить период в имени файла",
        "Display period":"Отобразить период",
        "redmine.xml default template":"redmine.xml шаблон по умолчанию"
};

webix.i18n.locales["ru-RU"].dpiui2.CustomProtocolsGroups = {
        "Custom protocols groups": "Пользовательские группы протоколов",
        "Protocols groups": "Группы протоколов",
        "Override Cloud": "Переопределить облачную",
        "Create a new group": "Создать новую группу",
        "Group code": "Код группы",
        "Group name": "Название группы",
        "Cloud protocol": "Облачный протокол",
        "Cloud group": "Облачная группа",
        "Custom protocol": "Пользовательский протокол",
        "Add cloud protocol": "Добавить облачный протокол",
        "Add custom protocol": "Добавить пользовательский протокол",
        "Protocol type": "Тип протокола",
        "Cloudy": "Облачный",
        "Custom": "Пользовательский",
        "Protocol": "Протокол"
};
webix.i18n.locales["en-US"].dpiui2 = {};

webix.i18n.locales["en-US"].dpiui2.AppView =
    {
        Title:"SSG",
        "Hardware ssh terminal": "Hardware SSH terminal",
        "Raw Gtp flow": "Raw GTP flow",
        "DPI control":"SSG control",
        "PCRF control":"PCRF control",
        "Performance":"Performance",
        "Configuration":"Configuration",
        "Protocol prioritization (DSCP)":"Protocol prioritization",
        "Priority for ASN":"Priority for ASN",
        "Prioritization for autonomous systems (AS)":"Prioritization for autonomous systems (AS)",
        "Logs":"Logs",

        "Services control":"Services control",
        "Subscribers and services":"Subscribers and services",
        "Subscribers":"Subscribers",
        "Services":"Services",
        "Tariff plans":"Tariff plans",
        "Adv control": "Adv control",

        "QoE analytics":"QoE analytics",
        "QoE dashboard":"QoE dashboard",
        "Dashboard":"Dashboard",
        "Clickstream":"Clickstream",
        "Netflow":"Netflow",
        "GTP flow":"GTP flow",
        "NAT flow":"NAT flow",
        "Raw NAT flow":"Raw NAT flow",
        "Raw full netflow":"Raw full netflow",
        "Raw clickstream":"Raw clickstream",
        "DDoS attacks":"DDoS attacks",
        "DDoS attacks log":"DDoS attacks log",
        "Administrator":"Administrator",
        "Triggers & Alerts":"Triggers & Alerts",
        "Custom reports":"Custom reports",
        "Raw DNS flow":"Raw DNS flow",
        "DNS flow":"DNS flow",
        "My reports":"My reports",

        "Restart fastdpi":"Restart fastdpi",
        "Updating hot options":"Updating hot options",
        "Updating options":"Updating options",
        "Device information":"Device information",
        "License information":"License information",
        "Select from list":"Select from list",
        "Managing the list of devices":"Managing the list of devices",

        "My profile":"My profile",
        "Users":"Users",
        "Roles":"Roles",
        "Users actions log":"Users actions log",
        "Managing users and roles":"Managing users and roles",
        "DPIUI2 (GUI) server configuration":"GUI configuration",
        "QoE Stor (fastor) server configuration":"QoE Stor configuration",
        "Server configuration":"Server configuration",

        "Lawful interception":"Lawful interception",

        "Log out":"Log out",

        "Edit profile":"Edit profile",
        "Username":"Username",
        "Enter user name":"Enter user name",
        "Full name":"Full name",
        "Last name First name Middle name":"Last name First name Middle name",
        "Enter your full name":"Enter your full name",
        "Position":"Position",
        "Enter your position":"Enter your position",
        "Organization":"Organization",
        "Name of the organization":"Name of the organization",
        "Enter the name of the organization":"Enter the name of the organization",
        "Enter your e-mail":"Enter your e-mail",
        "Phone":"Phone",
        "Contact number":"Contact number",
        "Enter phone number":"Enter phone number",
        "Change password":"Change password",
        "Old password":"Old password",
        "Enter password":"Enter password",
        "New password":"New password",
        "Confirm password":"Confirm password",
        "Passwords do not match":"Passwords do not match",

        "Are you sure you want to restart the fastdpi process?":"Are you sure you want to restart the fastdpi process?",
        "Are you sure you want to update the hot settings?":"Are you sure you want to update the hot settings?",
        "Restart":"Restart",
        "No equipment selected":"No equipment selected",

        "Name":"Name",
        "Port":"Port",
        "Login":"Login",
        "Can be controlled by other GUI":"Can be controlled by other GUI",

        "Start fastdpi error": "Start FastDPI error",
        "fastdpi is stopped": "FastDPI is stopped",
        "fastdpi остановлен": "FastDPI is stopped",
        "Many messages": "Many messages",
        "Several messages": "Several messages",

        "New version FastDPI is available": "New version FastDPI is available",
        "FastDPI is stopped": "FastDPI is stopped",

        "New GUI version is available": "New GUI version is available",
        "SSH connection error": "SSH connection error",
        "Need to add dpui2 hardware": "If you want to receive information about new versions, you need to add an SSH connection to dpiui2.",
        "HotSpot": "HotSpot",

        "Just close":"Just close",
        "Don't show again":"Don't show again",

        "In one of the sections of the program, we prepared a surprise. By clicking on one of the buttons in this section, you will receive a gift - the year of subscription to the dpiui2 Standart version.":"In one of the sections of the program, we prepared a surprise. By clicking on one of the buttons in this section, you will receive a gift - <b>the year of subscription to the dpiui2 Standart version</b>.",
        "Watch the Happy New Year video":"Watch the Happy New Year video",
        "Find a gift!":"Find a gift!",

        "Congratulations! You have found your gift!":"Congratulations! You have found your gift!",
        "You have one year of subscription to the dpiui2 Standart version! To take your gift complete the next form, please.":"You have one year of subscription to the dpiui2 Standart version! To take your gift complete the next form, please.",

        "Are you shure you don`t want to take your gift?":"Are you shure you don`t want to take your gift?",
        "I don`t want":"I don`t want",
        "I want my gift":"I want my gift",

        "Fast PCRF (fastpcrf) server configuration": "Fast PCRF (fastpcrf) server configuration",
        "Fast PCRF (fastpcrf) logs": "Fast PCRF (fastpcrf) logs",
        "Fast PCRF Config": "Fast PCRF Config",
        "Fast PCRF logs": "Fast PCRF logs",
        "Gtp flow": "GTP flow",
        "Subscriber synchronization process timeout - 10 minutes": "Subscriber synchronization process timeout - 10 minutes",
        "DPIUI2 logs": "GUI logs",
        "DPIUI2 (GUI) update": "GUI update",
        "QoE Stor (fastor) logs": "QoE Stor logs",
            "Traffic decode": "Traffic decode",

        "Go to the section":"Go to the section",
        "Choose device":"Choose device",
        "Device not selected":"Device not selected",

        "Online reports":"Online reports",
        "Online netflow":"Online netflow",
        "Captcha configuration": "Captcha configuration",
        "Captcha logs": "Captcha logs",
        "CAPTCHA logs": "CAPTCHA logs",
        "CAPTCHA language": "CAPTCHA language",
        "Spanish": "Spanish",
        "The current language of CAPTCHA image": "The current language of CAPTCHA image",
        "CAPTCHA encryption key": "CAPTCHA encryption key",
        "Encryption key for CAPTCHA": "Encryption key for CAPTCHA",
        "Token salt for CAPTCHA": "Token salt for CAPTCHA",
        "CAPTCHA image format": "CAPTCHA image format",
        "PNG": "PNG",
        "JPEG": "JPEG",
        "The current format of CAPTCHA image": "The current format of CAPTCHA image",
        "CAPTCHA length": "CAPTCHA length",
        "The current length of CAPTCHA image": "The current length of CAPTCHA image",
        "CAPTCHA scale": "CAPTCHA scale",
        "The current scale of CAPTCHA image": "The current scale of CAPTCHA image",
        "CAPTCHA random": "CAPTCHA random",
        "This option sets random chars of CAPTCHA image": "This option sets random chars of CAPTCHA image",
        "Captcha template":"Captcha template",
        "Reset template":"Reset template",
        "Reload view":"Reload view",
        "Are you sure you want to reset template?":"Are you sure you want to reset template?",
        "Are you sure you want to delete template?":"Are you sure you want to delete template?",
        "CAPTCHA domain for cookie" : "CAPTCHA domain for cookie",
        "CAPTCHA app language" : "CAPTCHA app language",
        "CAPTCHA app template" : "CAPTCHA app template",
        "CAPTCHA store" : "CAPTCHA store",
        "CAPTCHA token salt" : "CAPTCHA token salt",
        "CAPTCHA font" : "CAPTCHA font",
        "CAPTCHA app title" : "CAPTCHA app title",
        "CAPTCHA redirect service" : "CAPTCHA redirect service",
        "CAPTCHA redirect service url" : "CAPTCHA redirect service url",
        "The current language of CAPTCHA app" : "The current language of CAPTCHA app",
        "The current template of CAPTCHA app" : "The current template of CAPTCHA app",
        "The current store of CAPTCHA" : "The current store of CAPTCHA",
        "This option sets CAPTCHA font" : "This option sets CAPTCHA font",
        "The redirect service of CAPTCHA app" : "The redirect service of CAPTCHA app",
        "The redirect service url of CAPTCHA app" : "The redirect service url of CAPTCHA app",
        "Template clone":"Template clone",
        "Template name":"Template name",
        "Template saved":"Template saved",
        "Enter template name":"Enter template name",
        "Choose template clone":"Choose template clone",

        "Connections":"Connections",
        "Traffic control":"Traffic control",
        "Traffic capture":"Traffic capture",
        "Traffic generation":"Traffic generation",
        "Blocking and redirection":"Blocking and redirection",
        "Cloning a website":"Cloning a website",
        "Network utilities":"Network utilities",
        "Network audit":"Network audit",
        "Traffic decode logs": "Traffic decode logs",
        "Health map":  "Health map",
        "Chart type":"Chart type",
        "Scale type":"Scale type",
        "Chart step":"Chart step",
        "Group by":"Group by",
        "Order by":"Order by",
        "Sort direction":"Sort direction",
        "Columns visibility":"Columns visibility",
        "Items limit":"Items limit",
        "Rows limit":"Rows limit",
        "Hotkey":"Hotkey",
        "Manual refresh":"Manual refresh",
        "Auto refresh":"Auto refresh",
        "Y axis detalization":"Y axis detalization",
        "Series metrics":"Series metrics",

        "Balancer server configuration": "IPFIX-balancer сonfiguration",
        "Balancer logs": "IPFIX-balancer logs",

        "Mailing templates":"Mailing templates",
        "Edit":"Edit",

        "Auto":"Auto",
        "Low":"Low",
        "Medium":"Medium",
        "High":"High",

        "Ascending":"Ascending",
        "Descending":"Descending"
    };

webix.i18n.locales["en-US"].dpiui2.LoginView =
    {
        "Sign in to control panel CKAT DPI":"Sign in to SSG control panel",
        "Login":"Login",
        "Enter login":"Enter login",
        "Password":"Password",
        "Enter password":"Enter password",
        "Remember me":"Remember me",
        "Sign in":"Sign in"
    };

webix.i18n.locales["en-US"].dpiui2.Subscribers =
    {
        "List of subscribers":"List of subscribers",

        "Id":"Id",
        "Login":"Login",
        "IP-address":"IP-address",
        "IP-address or IP-addresss range":"IP-address or IP-addresss range",
        "Bind type":"Bind type",
        "Services":"Services",
        "Service":"Service",
        "Tariffs":"Tariffs",
        "Tariff":"Tariff",

        "Add subscriber":"Add subscriber",

        "Enter IP-address":"Enter IP-address",
        "Enter login":"Enter login",

        "Profile":"Profile",

        "Enabled":"Enabled",

        "Subscriber":"Subscriber",
        "Forced subscribers synchronization": "Forced subscribers synchronization",
        "Forced synchronization subscribers running in the background": "Forced synchronization subscribers running in the background",
        "No tariff": "No tariff",
        "No services": "No services",
        "Set up tariff for filtered subscribers": "Set up tariff for filtered subscribers",
        "Tariff for filtered subscribers will be set up in the background": "Tariff for filtered subscribers will be set up in the background",
        "No profile":"No profile",
        "Unknown": "Unknown",
        "In progress": "In progress",
        "In progress abj": "In progress abj",
        "Authorized": "Authorized",
        "Unauthorized": "Unauthorized",
        "Auth status": "Auth status",
        "Ping" : "Ping",
        "Allowed": "Allowed",
        "Unavailable":"Unavailable",
        "L2-props are not set":"L2-props are not set",
        "Ping command options form": "Ping command options form",
        "Address": "Address",
        "L2-settings": "L2-settings",
        "Subscriber`s MAC-address": "Subscriber`s MAC-address",
        "Subscriber`s VLAN or QinQ": "Subscriber`s VLAN or QinQ",
        "DNA-interface index": "DNA-interface index",
        "Ping settings": "Ping settings",
        "Ping number": "Ping number",
        "Payload length": "Payload length",
        "TTL value": "TTL value",
        "Execute": "Execute",
        "Authorization": "Authorization",
        "L2-props": "L2-props",
        "Are you sure you want to reset the authorization status of subscribers?": "Are you sure you want to reset the authorization status of subscribers?",
        "The authorization status is set to \"unknown\", which will lead to L3-authorization request as the packet from the subscriber arrives.": "The authorization status is set to \"unknown\", which will lead to L3-authorization request as the packet from the subscriber arrives.",
        "Expire at": "Expire at",
        "Expired at": "Expired at",
        "Undefined": "Undefined",
        "DHCP": "DHCP",
        "PPPoE": "PPPoE",
        "Gateway": "Gateway",
        "ARP": "ARP",
        "L3": "L3",
        "Acquired": "Acquired",
        "Released": "Released",
        "Are you sure you want to delete the L2-props of subscribers?": "Are you sure you want to delete the L2-props of subscribers?",
        "This command actually removes the IP address from the internal database. To remove a specific subscriber property, use subs prop set.": "This command actually removes the IP address from the internal database. To remove a specific subscriber property, use subs prop set.",
        "Sync L2-props": "Sync L2-props",
        "Options": "Options",
        "Session type": "Session type",
        "Session status": "Session status",
        "MAC address": "MAC address",
        "VLAN or QinQ": "VLAN or QinQ",
        "in_dev interface index": "in_dev interface index",
        "Expiration time": "Expiration time",
        "Output MAC address": "Output MAC address",
        "Output VLAN=NN": "Output VLAN=NN",
        "Disable local connect for subscriber": "Disable local connect for subscriber",
        "IP options": "IP options",
        "'route via' property": "'route via' property",
        "IPv4 subnet mask": "IPv4 subnet mask",
        "Opt82 CircuitId": "Opt82 CircuitId",
        "Opt82 RemoteId": "Opt82 RemoteId",
        "Do not save changes parameters in UDR": "Do not save changes parameters in UDR",
        "Last update": "Last update",
        "L2-props loaded": "L2-props loaded",
        "L2-props deleted": "L2-props deleted",
        "L2-props saved": "L2-props saved",
        "Auth state cleared": "Auth state cleared",
        "Auth state saved": "Auth state saved",
        "Input valid MAC-address":  "Input valid MAC-address",
        "Set for selected": "Set for selected",
        "Set for all": "Set for all",
        "Vchannels": "Vchannels",
        "There are no services or policing for subscriber!": "There are no services or policing for subscriber!",
        "Identity type": "Identity type",
        "Not valid form":"Not valid form",

        "List IP": "List IP",
        "Extended": "Extended",
        "Group": "Group",

        "Element": "item",
        "Elements": "items",
        "ElementsMany": "items",
    };

webix.i18n.locales["en-US"].dpiui2.DpiPerformance =
    {
        "Online":"Online",
        "Statistics":"Statistics",

        "Processors and memory":"Processors and memory",
        "CPU usage (%)":"CPU usage (%)",
        "Memory usage (%)":"Memory usage (%)",

        "User's<br/>processes (us)":"User's <br/> processes (us)",
        "System<br/>processes (sy)":"System <br/> processes (sy)",
        "Process<br/>fastdpi":"Process <br/> fastdpi",
        "Status<br/>idle (id)":"Status <br/> idle (id)",

        "Operative<br/>memory (mem)":"Operative <br/> memory (mem)",
        "Swap<br/>file":"Swap<br/>file",
        "The process<br/>fastdpi (mem)":"The process <br/> fastdpi (mem)",

        "Idle state":"Idle state",
        "Fastdpi process":"Fastdpi process",
        "User processes (us)":"User processes (us)",
        "System processes (sy)":"System processes (sy)",

        "Operative memory (mem)":"Operative memory (mem)",
        "Process fastdpi (mem)":"Process fastdpi (mem)",
        "Swap file":"Swap file",

        "Top 30 processes":"Top 30 processes",
        "Process Id":"Process Id",
        "Process":"Process",

        "Processors usage (%)":"Processors usage (%)",
        "Memory usage (GB)":"Memory usage (GB)",
        "Virtual memory (virt)":"Virtual memory (virt)",
        "Physical memory (res)":"Physical memory (res)",

        "HTTP statistics":"HTTP statistics",
        "HTTP statistics (number of processed)":"HTTP statistics (number of processed)",
        "HTTP statistics (number of blocked)":"HTTP statistics (number of blocked)",

        "Network interfaces":"Network interfaces",
        "Traffic on the interface":"Traffic on the interface",

        "Received":"Received",
        "Sent":"Sent",
        "Dropped":"Dropped",
        "packages":"packages",
        "Nat statistics": "NAT statistics",
        "Top pools": "Top pools",
        "Addresses": "Addresses",
        "Used" : "Used",
        "Top profiles": "Top profiles",
        "Top pool/s": "Top pools",

        "For the correct display of traffic graphs by class, you need in the Configuration section":"For the correct display of traffic graphs by class, you need in the Configuration section<br/><br/>1. Configure the dbg_log_mask parameter in the Trace section<br/>2. Set up Policing",
        "Open the Configuration section":"Open the Configuration section",
            "Devices": "Devices",
            "Device": "Device",
            "Status": "Status",

        "Units":"Units",
        "Bytes":"Bytes",
        "Packets":"Packets"
    };

webix.i18n.locales["en-US"].dpiui2.DpiConfig =
    {
        "Cancel": "Cancel",
        "Verify": "Verify",
        "Verify and save": "Verify and save",
        "Save without verification": "Save without verification",
        "Incoming": "Incoming",
        "Outgoing": "Outgoing",
        "Upload from file": "Upload from file",
        "Download from history": "Download from history",
        "Class": "Class",
        "Back": "Back",
        "Forward": "Forward",
        "Configuration is correct": "Configuration is correct",
        "Configuration saved": "Configuration saved",
        "Configuration loaded":"Configuration loaded",
        "Show comments":"Show comments",
        "Show all params":"Show all params",

        "Service reloaded successfully": "Service reloaded successfully",
        "Are you sure you want to restart the DPI process?": "Are you sure you want to restart the DPI process?",
        "Are you sure you want to update the hot settings?": "Are you sure you want to update the hot settings?",
        "Restart DPI": "Restart DPI",
        "Updating hot options": "Updating hot options",
        "Fast DPI config saved!": "Fast DPI config saved!",
        "Update the hot parameters or restart Fast DPI for applying the changes!": "Update the hot parameters or restart Fast DPI for applying the changes!",
        "Granted all privileges successfully": "Granted all privileges successfully",
        "Enter correct CIDR":"Enter correct CIDR",
        "Enter correct Vchannel":"Enter correct Vchannel",
        "Data is Invalid":"Data is Invalid"
    };

webix.i18n.locales["en-US"].dpiui2.DpiDscpConfig =
    {
        "Priority configuration":"Priority configuration",
        "List of protocols and priorities":"List of protocols and priorities",
        "Protocol":"Protocol",
        "The value of dscp":"The value of dscp",
        "CIDR list for AS":"CIDR list for AS",
        "DSCP name":"DSCP name",
        "Binary value":"Binary value",
        "Decimal value":"Decimal value",
        "Priority":"Priority",
        "Policing class":"Policing class",
        "Dscp configuration saved":"Dscp configuration saved",
        "Dscp configuration loaded":"Dscp configuration loaded",
        "Group": "Group",
        "Groups": "Groups",
        "No groups selected!": "No groups selected!",
        "Set dscp for protocol groups": "Set dscp for protocol groups",
        "Set dscp value": "Set dscp value",
        "Show all protocols": "Show all protocols",
        "Add protocol or show all protocols": "Add protocol or show all protocols",
        "List of protocols groups": "List of protocols groups",
            "mixed": "mixed"
    };

webix.i18n.locales["en-US"].dpiui2.DpiAsnDscpConfig =
    {
        "Configuration of AS and DSCP priorities":"Configuration of AS and DSCP priorities",
        "AS resource list":"AS resource list",
        "AS number":"AS number",
        "List of IP and AS":"List of IP and AS",
        "List of AS and DSCP":"List of AS and DSCP",
        "Add AS":"Add AS",
        "Add CIDR":"Add CIDR",
        "Add DSCP":"Add DSCP",
        "DSCP list for AS":"DSCP list for AS",
        "DSCP name":"DSCP name",
        "Binary value":"Binary value",
        "Decimal value":"Decimal value",
        "Priority":"Priority",
        "Policing class":"Policing class",
        "Asn dscp configuration saved":"Asn dscp configuration saved",
            "CIDR list for AS": "CIDR list for AS",
            "List of IPv4 and AS": "List of IPv4 and AS",
            "List of IPv6 and AS": "List of IPv6 and AS"
    };

webix.i18n.locales["en-US"].dpiui2.All =
    {
        "Commands dictionaries  could not be loaded": "Commands dictionaries  could not be loaded",
        "Can not connect to hardware": "Can not connect to hardware",
        "The configuration model could not be loaded": "The configuration model could not be loaded",
        "Yes":"Yes",
        "No":"No",

        "No connection":"No connection",
        "In developing":"In developing",
        "Access denied":"Access denied",
        "No found":"No found",

        "Russian":"Russian",
        "Rus.":"Rus.",
        "English":"English",
        "Eng.":"Eng.",

        "Refresh":"Refresh",
        "Cancel":"Cancel",
        "Delete":"Delete",
        "Remove all":"Remove all",
        "Close":"Close",
        "Save":"Save",
        "Add value":"Add value",
        "Upload from file":"Upload from file",
        "Download from history":"Download from history",
        "Saved":"Saved",
        "Deleted":"Deleted",
        "Removed":"Removed",
        "Cleared": "Cleared",

        "Are you sure you want to delete the selected records?":"Are you sure you want to delete the selected records?",
        "Are you sure you want to delete the selected record?":"Are you sure you want to delete the selected record?",
        "Are you sure you want to remove all list items?":"Are you sure you want to remove all list items?",

        "The form":"The form",
        "Editor":"Editor",

        "Settings":"Settings",

        "Click to download or drag a file": "Click to download or drag a file",
        "Apply": "Apply",
        "Applied": "Applied",
        "History": "History",
        "Could not upload file": "Could not upload file",
        "Config": "Config",

        "Back":"Back",
        "Forward":"Forward",

        "Date":"Date",

        "Download the complete file":"Download file",

        "Error":"Error",
        "See logs":"See logs",

        "History loaded":"History loaded",
        "Verified":"Verified",

        "Restart was successful":"Restart was successful",
        "Hot options updated":"Hot options updated",

        "Parser error":"Parser error",

        "Total":"Total",
        "Done":"Done",

        "Period":"Period",
        "Interval":"Interval",
        "1 second":"1 second",
        "5 seconds":"5 seconds",
        "10 seconds":"10 seconds",
        "15 seconds":"15 seconds",
        "30 seconds":"30 seconds",
        "0 minutes":"0 minutes",
        "1 minute":"1 minute",
        "2 minutes":"2 minutes",
        "3 minutes":"3 minutes",
        "4 minutes":"4 minutes",
        "5 minutes":"5 minutes",
        "6 minutes":"6 minutes",
        "7 minutes":"7 minutes",
        "8 minutes":"8 minutes",
        "9 minutes":"9 minutes",
        "10 minutes":"10 minutes",
        "15 minutes":"15 minutes",
        "30 minutes":"30 minutes",
        "60 minutes":"60 minutes",
        "1 hour":"1 hour",
        "2 hours":"2 hours",
        "3 hours":"3 hours",
        "4 hours":"4 hours",
        "5 hours":"5 hours",
        "6 hours":"6 hours",
        "7 hours":"7 hours",
        "8 hours":"8 hours",
        "9 hours":"9 hours",
        "10 hours":"10 hours",
        "11 hours":"11 hours",
        "12 hours":"12 hours",
        "13 hours":"13 hours",
        "14 hours":"14 hours",
        "15 hours":"15 hours",
        "16 hours":"16 hours",
        "17 hours":"17 hours",
        "18 hours":"18 hours",
        "19 hours":"19 hours",
        "20 hours":"20 hours",
        "21 hours":"21 hours",
        "22 hours":"22 hours",
        "23 hours":"23 hours",
        "24 hours":"24 hours",
        "1 day":"1 day",
        "2 days":"2 days",
        "3 days":"3 days",
        "4 days":"4 days",
        "5 days":"5 days",
        "6 days":"6 days",
        "7 days":"7 days",
        "30 days":"30 days",
        "1 month":"1 month",
        "3 months":"3 months",
        "6 months":"6 months",
        "1 year":"1 year",
        "Unlimited":"Unlimited",

        "Bytes":"Bytes",
        "Kb":"Kb",
        "Mb":"Mb",
        "Gb":"Gb",
        "Tb":"Tb",
        "Pb":"Pb",

        "Pkts":"Pkts",
        "Kpkts":"Kpkts",
        "Mpkts":"Mpkts",
        "Gpkts":"Gpkts",
        "Tpkts":"Tpkts",
        "Ppkts":"Ppkts",

        "Bytes/s":"Bytes/s",
        "Kb/s":"Kb/s",
        "Mb/s":"Mb/s",
        "Gb/s":"Gb/s",
        "Tb/s":"Tb/s",
        "Pb/s":"Pb/s",

        "Bit/s":"Bit/s",
        "Kbit/s":"Kbit/s",
        "Mbit/s":"Mbit/s",
        "Gbit/s":"Gbit/s",
        "Tbit/s":"Tbit/s",
        "Pbit/s":"Pbit/s",

        "Pkts/s":"Pkts/s",
        "Kpkts/s":"Kpkts/s",
        "Mpkts/s":"Mpkts/s",
        "Gpkts/s":"Gpkts/s",
        "Tpkts/s":"Tpkts/s",
        "Ppkts/s":"Ppkts/s",

        "ns":"ns",
        "µs":"µs",
        "ms":"ms",
        "s":"s",
        "ks":"ks",
        "Ms":"Ms",
        "Gs":"Gs",
        "Ts":"Ts",

        "K":"K",
        "M":"M",
        "G":"B",
        "T":"T",
        "Quad":"Quad",
        "Quint":"Quint",
        "Sextil":"Sextil",

        "On":"On",
        "Off":"Off",

        "min":"min",
        "calls":"calls",

        "Reset":"Reset",
        "By default":"By default",

        "Next":"Next",

        "Page size":"Page size",
        "Slide size":"Slide size",
        "Export":"Export",
        "File name":"File name",
        "Export format":"Export format",
        "Switch form?": "Switch form?",
        "There are unsaved changes. Are you sure you want to switch form?": "There are unsaved changes.<br/>Are you sure you want to switch form?",

        "Current changes have not been saved.":"Current changes have not been saved.",
        "Save changes?":"Save changes?",

        "Switch": "Switch",

        "Select":"Select",

        "On page":"On page",

        "Filter":"Filter",

        "Send":"Send",

        "Groups": "Groups",
        "Search": "Search",
        "Params": "Params",

        "Not": "Not",

        "From wich DPI device":"From wich DPI device",
        "Maximum report execution time":"Maximum report execution time",

        "Row deleted successfully":"Row deleted successfully",
        "Rows deleted successfully":"Rows deleted successfully",

        "Enable":"Enable",
        "Disable":"Disable",

        "Required field" : "Required field",

        "Profile deleted": "Profile deleted",

        "chart":"chart",

        "Description Category Host":"Description Category Host",
        "Description Protocols Groups":"Description Protocols Groups",

        "Copy of": "Copy of",
        "Server error":"Server error",

        "Link to wiki":"Link to wiki"
    };

webix.i18n.locales["en-US"].dpiui2.Dics =
    {
        "Pcap decode server": "Pcap decode server",
        "SSO authorization password": "SSO authorization password",
        "SSO authorization username": "SSO authorization username",
        "SSO authorization host": "SSO authorization host",
        "SSO authorization settings": "SSO authorization settings",
        "Enable SSO authorization": "Enable SSO authorization",
        "Ipfix lists upload path": "IPFIX lists upload path",
        "Coordinates": "Coordinates",
        "Bonus program":"Bonus program",
        "Advertising":"Advertising",
        "Ad blocking":"Ad blocking",
        "Black list":"Black list",
        "White list":"White list",
        "Black and white lists": "Black and white lists",
        "Announcement":"Announcement",
        "Caching":"Caching",
        "Passed DDoS protection":"Passed DDoS protection",
        "Netflow stats":"Netflow stats",
        "DDoS protection":"DDoS protection",
        "CGNAT":"CGNAT",
        "Notification":"Notification",

        "Without bind":"Without bind",
        "Single":"Single",
        "Multi":"Multi",
        "Single: one IP - one login":"Single: one IP - one login",
        "Multi: multiple IP - one login":"Multi: multiple IP - one login",

        "Common":"Common",
        "Filtering by blacklist":"Filtering by blacklist",
        "Collection and analysis of statistics on protocols and directions":"Collection and analysis of statistics on protocols and directions",
        "Traffic priority marking depending on the protocol":"Traffic priority marking depending on the protocol",
        "External channels' usage optimization": "External channels' usage optimization",
        "Blocking and replacing advertising":"Blocking and replacing advertising",
        "Whitelist and Captive Portal":"Whitelist and Captive Portal",
        "Notification of subscribers":"Notification of subscribers",
        "Protection from DoS and DDoS attacks":"Protection from DoS and DDoS attacks",
        "Operator's LI":"Operator's LI",
        "System":"System",
        "Unknown parameters":"Unknown parameters",

        "UDP protocol detector (only_tcp)":"UDP protocol detector (only_tcp)",
        "UDP (Torrent and other) detector is active":"UDP (Torrent and other) detector is active",
        "UDP (Torrent and other) detector is not active":"UDP (Torrent and other) detector is not active",

        "Use the internal database (udr)":"Use the internal database (udr)",
        "Use an internal database to preserve the state of services (udr)":"Use an internal database to preserve the state of services (udr)",
        "Do not use internal database":"Do not use internal database",
        "Store state in internal database":"Store state in internal database",

        "Filtering control by registry (black_list_sm)":"Filtering control by registry (black_list_sm)",
        "Enable filtering control by registry as a subscription service":"Enable filtering control by registry as a subscription service",
        "Filtering is active for all subscribers":"Filtering is active for all subscribers",
        "Only for subscribers with enabled filtering service":"Only for subscribers with enabled filtering service",

        "Automatic loading of the registry from the cloud service (federal_black_list)":"Automatic loading of the registry from the cloud service (federal_black_list)",
        "Enable automatic download and application of the registry from the cloud service (federal_black_list)":"Enable automatic download and application of the registry from the cloud service (federal_black_list)",
        "Disabled. Use only local filter lists":"Disabled. Use only local filter lists",
        "Enabled. Russian list":"Enabled. Russian list",
        "Enabled. Private operator list from the cloud VE":"Enabled. Private operator list from the cloud VE",
        "Enabled. Belarusian list":"Enabled. Belarusian list",
        "Enabled. Iraq list": "Enabled. Iraq list",

        "Redirecting to a page (black_list_redirect)":"Redirecting to a page (black_list_redirect)",
        "If this parameter is terminated with ? or & the UrlRedir parameter will be added to the resulting URL with the page where the user was directed":"If this parameter is terminated with ? or & the UrlRedir parameter will be added to the resulting URL with the page where the user was directed",
        "Enter the correct url":"Enter the correct url",

        "URL dictionary for HTTP blocking (custom_url_black_list)":"URL dictionary for HTTP blocking (custom_url_black_list)",
        "Enter the correct url or file path":"Enter the correct url or file path",

        "Dictionary of names for blocking HTTPS protocol by certificate (custom_cname_black_list)":"Dictionary of names for blocking HTTPS protocol by certificate (custom_cname_black_list)",

        "Dictionary of IP-addresses for blocking the HTTPS protocol over IP (custom_ip_black_list)":"Dictionary of IP-addresses for blocking the HTTPS protocol over IP (custom_ip_black_list)",

        "Dictionary of hosts names for blocking HTTPS by SNI (custom_sni_black_list)":"Dictionary of hosts names for blocking HTTPS by SNI (custom_sni_black_list)",

        "Frequency of checking the update of the blacklist in minutes (timeout_check_new_bl)":"Frequency of checking the update of the blacklist in minutes (timeout_check_new_bl)",
        "Frequency of checking blacklist updates in minutes (timeout_check_new_bl). The default is 60 minutes.":"Frequency of checking blacklist updates in minutes (timeout_check_new_bl). The default is 60 minutes.",
        "Enter the number":"Enter the number",

        "The maximum number of profiles for blacklists (max_profiles_black_list)":"The maximum number of profiles for blacklists (max_profiles_black_list)",
        "The maximum number of profiles for blacklists (max_profiles_black_list): 64 by default.":"The maximum number of profiles for blacklists (max_profiles_black_list): 64 by default.",
        //
        "Enabling the collection and export of statistics (netflow)": "Enabling the collection and export of statistics (netflow)",
        "Export statistics by protocols (port numbers)": "Export statistics by protocols (port numbers)",
        "Export statistics by directions (numbers of autonomous systems)": "Export statistics by directions (numbers of autonomous systems)",
        "Export billing statistics": "Export billing statistics",
        "Export of complete statistics for sessions": "Export of complete statistics for sessions",
        "Name of the network interface that sends netflow with statistics (netflow_dev)": "Name of the network interface that sends netflow with statistics (netflow_dev)",
        "Network interface name (netflow_dev)": "Network interface name (netflow_dev)",
        "Enter the interface": "Enter the interface",
        "Periodicity of data export in seconds (netflow_timeout)": "Periodicity of data export in seconds (netflow_timeout)",
        "IP address of netflow collector with statistics by protocols (netflow_collector)": "IP address of netflow collector with statistics by protocols (netflow_collector)",
        "IP address and port number of netflow collector with statistics by protocols (netflow_collector)": "IP address and port number of netflow collector with statistics by protocols (netflow_collector)",
        "Enter the IP address and port number": "Enter the IP address and port number",
        "Directions for collecting statistics and aggregation (netflow_as_direction)": "Directions for collecting statistics and aggregation (netflow_as_direction)",
        "For external autonomous systems": "For external autonomous systems",
        "For internal autonomous systems": "For internal autonomous systems",
        "IP address of the netflow collector with statistics by directions (netflow_as_collector)": "IP address of the netflow collector with statistics by directions (netflow_as_collector)",
        "IP address and port number of the netflow collector with direction statistics (netflow_as_collector)": "IP address and port number of the netflow collector with direction statistics (netflow_as_collector)",
        "IP address of netflow collector with statistics for billing (netflow_bill_collector)": "IP address of netflow collector with statistics for billing (netflow_bill_collector)",
        "IP address and port number of the netflow collector with statistics for billing (netflow_bill_collector)": "IP address and port number of the netflow collector with statistics for billing (netflow_bill_collector)",
        "Payload accounting method (netflow_bill_method)": "Payload accounting method (netflow_bill_method)",
        "Only consider the payload (netflow_bill_method)": "Only consider the payload (netflow_bill_method)",
        "Consider the full volume, including package headers": "Consider the full volume, including package headers",
        "Only payload": "Only payload",
        "The export format for the complete netflow (netflow_full_collector_type)": "The export format for the complete netflow (netflow_full_collector_type)",
        "Managing the export format for a complete netflow (netflow_full_collector_type)": "Managing the export format for a complete netflow (netflow_full_collector_type)",
        "Netflow5 format export": "netflow5 format export",
        "Export ipfix to udp header": "Export IPFIX to udp header",
        "Export ipfix to tcp header": "Export IPFIX to tcp header",
        "IP address of the netflow collector with full statistics (netflow_full_collector)": "IP address of the netflow collector with full statistics (netflow_full_collector)",
        "IP address and port number of the netflow collector with full statistics (netflow_full_collector)": "IP address and port number of the netflow collector with full statistics (netflow_full_collector)",
        "Inactive session timeout in seconds (netflow_passive_timeout)": "Inactive session timeout in seconds (netflow_passive_timeout)",
        "The time in seconds after which the non-active session is considered complete (netflow_passive_timeout)": "The time in seconds after which the non-active session is considered complete (netflow_passive_timeout)",
        "Timeout of the active session in seconds (netflow_active_timeout)": "Timeout of the active session in seconds (netflow_active_timeout)",
        "The length of the fragment for a long session in seconds (netflow_active_timeout)": "The length of the fragment for a long session in seconds (netflow_active_timeout)",
        "Send information about protocols in the port number (netflow_full_port_swap)": "Send information about protocols in the port number (netflow_full_port_swap)",
        "Keep original port numbers": "Keep original port numbers",
        "Send information about protocols in the port number": "Send information about protocols in the port number",
        "The maximum netflow in Mbit/s (netflow_rate_limit)": "The maximum netflow in Mbit/s (netflow_rate_limit)",
        "Priority traffic markup (set_packet_priority)": "Priority traffic markup (set_packet_priority)",
        "Enable priority traffic markup (set_packet_priority)": "Enable priority traffic markup (set_packet_priority)",
        "At the IP header level": "At the IP header level",
        "At the VLAN/QinQ header level": "At the VLAN/QinQ header level",
        "At the MPLS header level": "At the MPLS header level",
        "Policing type (policing_type)": "Policing type (policing_type)",
        "TBF Class [number] for outbound traffic": "TBF Class [number] for outbound traffic",
        "TBF Class [number] for inbound traffic": "TBF Class [number] for inbound traffic",
        "HTB Class [number] for outbound traffic": "HTB Class [number] for outbound traffic",
        "HTB Class [number] for inbound traffic": "HTB Class [number] for inbound traffic",
        "The content server (ad_server)": "The content server (ad_server)",
        "The content server (cp_server)": "The content server (cp_server)",
        "The content server (ntf_server)": "The content server (ntf_server)",
        "The name or address of the server where the information page is located (cp_server)": "The name or address of the server where the information page is located (cp_server)",
        "The name or address of the server where the information page is located (ntf_server)": "The name or address of the server where the information page is located (ntf_server)",
        "Enter the server name or address": "Enter the server name or address",
        "The name or address of the server from which new content is delivered (ad_server)": "The name or address of the server from which new content is delivered (ad_server)",
        "Logging of protection triggering (syncf_trace)": "Logging of protection triggering (syncf_trace)",
        "The sync per second threshold (syncf_threshold)": "The sync per second threshold (syncf_threshold)",
        "The threshold of the amount of syn per second (without confirmation), when we consider that everything is normal (by default 50)": "The threshold of the amount of syn per second (without confirmation), when we consider that everything is normal (by default 50)",
        "The interval of checking the amount of syn in milliseconds (syncf_check_tmout)": "The interval of checking the amount of syn in milliseconds (syncf_check_tmout)",
        "The interval of checking the number of syn and confirmed syn in milliseconds(by default 100)": "The interval of checking the number of syn and confirmed syn in milliseconds(by default 100)",
        "Media server (cache_server)": "Media server (cache_server)",
        "IP address or domain name of the media server": "IP address or domain name of the media server",
        "Directions for which statistics are collected and aggregation (netflow_as_direction)": "Directions for which statistics are collected and aggregation (netflow_as_direction)",
        "Protection mode (syncf_protection)": "Protection mode (syncf_protection)",
        "Enable protection mode (syncf_protection)": "Enable protection mode (syncf_protection)",
        "Security off": "Security off",
        "Automatically activated": "Automatically activated",
        "Always enabled": "Always enabled",
        "Logging of protection triggering 0 / 1 - no / yes ( by default 0 ) (syncf_trace)": "Logging of protection triggering 0 / 1 - no / yes ( by default 0 ) (syncf_trace)",
        "Logging disabled": "Logging disabled",
        "Logging enabled": "Logging enabled",
        "The time interval for monitoring the response to syn+ack (syncf_tracking_packs_time)": "The time interval for monitoring the response to syn+ack (syncf_tracking_packs_time)",
        "The time interval in seconds of monitoring the response to syn + ack, generated by CKAT (by default 60)": "The time interval in seconds of monitoring the response to syn + ack, generated by CKAT (by default 60)",
        "Protected port numbers (syncf_ports)": "Protected port numbers (syncf_ports)",
        "Protected port numbers (by default 80, can be changed online)": "Protected port numbers (by default 80, can be changed online)",
        "Enter the port numbers through the colon": "Enter the port numbers through the colon",
        "The percentage of unconfirmed queries for activating protection (syncf_unconfirmed_percent)": "The percentage of unconfirmed queries for activating protection (syncf_unconfirmed_percent)",
        "The percentage of unconfirmed requests from the client, in which the protection is automatically activated (by default 5, can be changed online)": "The percentage of unconfirmed requests from the client at which the protection is automatically activated. Default is 5, the value can be changed online ",
        "CAPTCHA page (ddos_check_server)": "CAPTCHA page (ddos_check_server)",
        "Page with CAPTCHA, to which redirection is performed for verification (ddos_check_server)": "Page with CAPTCHA, to which redirection is performed for verification (ddos_check_server)",
        "Number of requests per second in normal operation (ddos_reqsec_threshold)": "Number of requests per second in normal operation (ddos_reqsec_threshold)",
        "The number of requests per second that comes to the protected site during normal operation (ddos_reqsec_threshold)": "The number of requests per second that comes to the protected site during normal operation (ddos_reqsec_threshold)",
        "The percentage of possible rejection of requests during normal operation of the site (ddos_reqsec_variation)": "The percentage of possible rejection of requests during normal operation of the site (ddos_reqsec_variation)",
        "The percentage of possible rejection of requests from the site specified in the normal operation (ddos_reqsec_variation)": "The percentage of possible rejection of requests from the site specified in the normal operation (ddos_reqsec_variation)",
        "Number of packets per second in normal operation (ddos_pktsec_threshold)": "Number of packets per second in normal operation (ddos_pktsec_threshold)",
        "The number of packets per second that comes to the protected site during normal operation (ddos_pktsec_threshold)": "The number of packets per second that comes to the protected site during normal operation (ddos_pktsec_threshold)",
        "Percentage of possible deviation of packets during normal operation of the site (ddos_pktsec_variation)": "Percentage of possible deviation of packets during normal operation of the site (ddos_pktsec_variation)",
        "The percentage of possible deviation of packets from the site specified in the normal operation (ddos_pktsec_variation)": "The percentage of possible deviation of packets from the site specified in the normal operation (ddos_pktsec_variation)",
        "Reserve memory for buffer (ajb_reserved)": "Reserve memory for buffer (ajb_reserved)",
        "Enabled":"Enabled",
        "Disabled":"Disabled",
        "If enabled, the memory for the write buffer is reserved in advance (at the start of DPI) and it becomes possible to activate and stop the data record instantly by changing the value of the parameters ajb_save_url, ajb_save_udpi and ajb_save_ip": "If enabled, the memory for the write buffer is reserved in advance (at the start of DPI) and it becomes possible to activate and stop the data record instantly by changing the value of the parameters ajb_save_url, ajb_save_udpi and ajb_save_ip",
        "Activate the traffic record according to the list of protocols (ajb_save_udpi)": "Activate the traffic record according to the list of protocols (ajb_save_udpi)",
        "List of recorded protocols (ajb_save_udpi_proto)": "List of recorded protocols (ajb_save_udpi_proto)",
        "List (through the colon) of recorded protocols in the form of test or digital identifiers (ajb_save_udpi_proto)": "List (through the colon) of recorded protocols in the form of test or digital identifiers (ajb_save_udpi_proto)",
        "Placement of files with a record (ajb_udpi_path)": "Placement of files with a record (ajb_udpi_path)",
        "Placement of files with a record (by default /var/dump/dpi)": "Placement of files with a record (by default /var/dump/dpi)",
        "Enter the path to the file": "Enter the path to the file",
        "Enable recording of traffic by IP or CIDR (ajb_save_ip)": "Enable recording of traffic by IP or CIDR (ajb_save_ip)",
        "Activate the recording of traffic by IP or CIDR (0.0.0.0/0 - to record all traffic)": "Activate the recording of traffic by IP or CIDR (0.0.0.0/0 - to record all traffic)",
        "Enter the IP address or CIDR": "Enter the IP address or CIDR",
        "Activate the record of HTTP metadata (ajb_save_url)": "Activate the record of HTTP metadata (ajb_save_url)",
        "List of recorded metadata (ajb_save_url_format)": "List of recorded metadata (ajb_save_url_format)",
        "Placement of files with metadata records (ajb_url_path)": "Placement of files with metadata records (ajb_url_path)",
        "The name of the network interface for sending clickstream via ipfix (ipfix_dev)": "The name of the network interface for sending clickstream via IPFIX (ipfix_dev)",
        "IP or the domain name (: port) of the ipfix collector clickstream (ipfix_udp_collectors)": "IP or the domain name (: port) of the IPFIX collector clickstream (ipfix_udp_collectors)",
        "IP or the domain name (: port) of the ipfix collector clickstream (ipfix_tcp_collectors)": "IP or the domain name (: port) of the IPFIX collector clickstream (ipfix_tcp_collectors)",
        "IP or the domain name (: port) of the ipfix collector meta clickstream (ipfix_meta_udp_collectors)": "IP or the domain name (: port) of the IPFIX collector meta clickstream (ipfix_meta_udp_collectors)",
        "IP or the domain name (: port) of the ipfix collector meta clickstream (ipfix_meta_tcp_collectors)": "IP or the domain name (: port) of the IPFIX collector meta clickstream (ipfix_meta_tcp_collectors)",
        "IP or the domain name (: port) of the clickstream header ipfix. You can specify several collectors separated by a comma.": "IP or the domain name (: port) of the clickstream header IPFIX. You can specify several collectors separated by a comma.",
        "IP or the domain name (: port) of the meta clickstream header ipfix. You can specify several collectors separated by a comma.": "IP or the domain name (: port) of the meta clickstream header ipfix. You can specify several collectors separated by a comma.",
        "Unique domain (id) for the recognition by the collector (ipfix_observation)": "Unique domain (id) for the recognition by the collector (ipfix_observation)",
        "Incoming interfaces (in_dev, to subscribers)": "Incoming interfaces (in_dev, to subscribers)",
        "Entered through the ':' or '|' (for clusters separation). Example: dna0:dna2:dna4 or dna0|dna2|dna4": "Entered through the ':' or '|' (for clusters separation). Example: dna0:dna2:dna4 or dna0|dna2|dna4",
        "Entered through the ':' or '|' (for clusters separation). Example: dna1:dna3:dna5 or dna1|dna3|dna5": "Entered through the ':' or '|' (for clusters separation). Example: dna1:dna3:dna5 or dna1|dna3|dna5",
        "List the interfaces separating by : or | (for clusters separation)":"List the interfaces separating by : or | (for clusters separation)",
        "Outgoing interfaces (out_dev, Internet)": "Outgoing interfaces (out_dev, Internet)",
        "Interface for sending responses in the traffic mirroring mode (tap_dev)": "Interface for sending responses in the traffic mirroring mode (tap_dev)",
        "Disassembling of the PPTP / L2TP / GRE / IPIP tunnels (check_tunnels)": "Disassembling of the PPTP / L2TP / GRE / IPIP tunnels (check_tunnels)",
        "DPI management port (ctrl_port)": "DPI management port (ctrl_port)",
        "DPI management port: fdpi_ctrl utility (ctrl_port)": "DPI management port: fdpi_ctrl utility (ctrl_port)",
        "DPI management interface (ctrl_dev)": "DPI management interface (ctrl_dev)",
        "DPI management interface: fdpi_ctrl utility (ctrl_dev)": "DPI management interface: fdpi_ctrl utility (ctrl_dev)",
        "Configuring the log output (dbg_log_mask)": "Configuring the log output (dbg_log_mask)",
        "Configuring the output of the log (0x80 output to the log ipfix stats) (dbg_log_mask)": "Configuring the output of the log (0x80 output to the log IPFIX stats) (dbg_log_mask)",
        "Asymmetric (or mixed) operation DPI mode (asym_mode)": "Asymmetric (or mixed) operation DPI mode (asym_mode)",
        "DPI packets sending direction(emit_direction)": "DPI packets sending direction(emit_direction)",
        "In which interface to send DPI-generated packets (emit_direction)": "In which interface to send DPI-generated packets (emit_direction)",
        "Send the package to the interface through which the package came to, to which we respond (by default)": "Send the package to the interface through which the package came to, to which we respond (by default)",
        "Send packets to the in_dev interface": "Send packets to the in_dev interface",
        "Send packets to the out_dev interface": "Send packets to the out_dev interface",
        "Traffic mode (tap_mode)": "Traffic mode (tap_mode)",
        "Traffic transmission normal mode": "Traffic transmission normal mode",
        "Passive mode (without out_dev/tap_dev)": "Passive mode (without out_dev/tap_dev)",
        "Use tap_dev to send answers to the subscriber": "Use tap_dev to send answers to the subscriber",
        "Managing the work with tagged traffic (strip_tap_tags)": "Managing the work with tagged traffic (strip_tap_tags)",
        "Management of working with tagged traffic (0 - Save TAG, 1 - Delete TAG)": "Management of working with tagged traffic (0 - Save TAG, 1 - Delete TAG)",
        "Disabled (Save TAG)": "Disabled (Save TAG)",
        "Enabled (Delete TAG)": "Enabled (Delete TAG)",
        "out_dev card MAC address(replace_source_mac)":"out_dev card MAC address(replace_source_mac)",
        "Enter the MAC address": "Enter the MAC address",
        "Router MAC address(replace_destination_mac)": "Router MAC address(replace_destination_mac)",
        "Number of repetitions (duplicates) of a package with a redirect or blocking (emit_duplication)": "Number of repetitions (duplicates) of a package with a redirect or blocking (emit_duplication)",
        "Number of repetitions (duplicates) of a package with a redirect or blocking (emit_duplication) when the platform is connected in the mode of processing the mirrored traffic":"Number of repetitions (duplicates) of a package with a redirect or blocking (emit_duplication) when the platform is connected in the mode of processing the mirrored traffic",
        "The MAC address of the out_dev card when the platform is connected in the mode of processing the mirrored traffic. in_dev receive a traffic mirror, and out_dev is connected to a router that receives and forwards replies to subscribers and to the Internet": "The MAC address of the out_dev card when the platform is connected in the mode of processing the mirrored traffic. in_dev receive a traffic mirror, and out_dev is connected to a router that receives and forwards replies to subscribers and to the Internet",
        "MAC address of the router (or routing switch) when the platform is connected in the mode of mirrored traffic processing": "MAC address of the router (or routing switch) when the platform is connected in the mode of mirrored traffic processing",
        "Vertical scale (scale_factor)": "Vertical scale (scale_factor)",
        "The value of the parameter is approximately equal to the overall channel width and varies in the range of 1-10 (1 for 1G, 10 for 10G and higher)": "The value of the parameter is approximately equal to the overall channel width and varies in the range of 1-10 (1 for 1G, 10 for 10G and higher)",
        "Timer for troubleshooting (timeout_check_dev)": "Timer for troubleshooting (timeout_check_dev)",
        "Number of queues (num_threads)": "Number of queues (num_threads)",
        "Trace session by IP (trace_ip)": "Trace session by IP (trace_ip)",
        "Enter the IP address":"Enter the IP address",
        "Tracing of subscriber bandwidth restriction by IP (plc_trace_ip)": "Tracing of subscriber bandwidth restriction by IP (plc_trace_ip)",
        "The asn dscp configuration is loaded": "The asn dscp configuration is loaded",
        "The asn dscp configuration is saved": "The asn dscp configuration is saved",
        "History loaded": "History loaded",
        "Hardware Management":"Hardware Management",
        "DPI Management / Performance and Statistics": "DPI Management / Performance and Statistics",
        "DPI Management / Configuration": "DPI Management / Configuration",
        "DPI Management / Logs": "DPI Management / Logs",
        "Service management / Subscribers": "Service management / Subscribers",
        "Service Management / Services": "Service Management / Services",
        "Service management / Tariffs": "Service management / Tariffs",
        "Service management / Advertising controll":"Service management / Advertising controll",
        "QoE analytics":"QoE analytics",
        "Companies": "Companies",
        "Users": "Users",
        "Roles": "Roles",
        "Send Error": "Send Error",
        "Sites classifier": "Sites classifier",
        "Sites classifier model": "Sites classifier model",
        "Sites classifier admin": "Sites classifier admin",
        "Error message": "Error message",
        "Question": "Question",
        "Sentence": "Sentence",
        "Message": "Message",
        "Introduced": "Introduced",
        "Waiting": "Waiting",
        "Active": "Active",
        "Completed": "Completed",
        "Bps": "bps",
        "Kbps":"kbps",
        "Mbps": "Mbps",
        "Gbps": "Gbps",
        "Bit": "Bit",
        "Kbit": "Kbit",
        "Mbit": "Mbit",
        "Gbit": "Gbit",
        "Mon": "Mon",
        "Tue": "Tue",
        "Wed": "Wed",
        "Thu": "Thu",
        "Fri": "Fri",
        "Sat": "Sat",
        "Sun": "Sun",
        "Profile [number]": "Profile [number]",
        "Group [number]": "Group [number]",
        "By default, dpi does not parse the tunnels, since traffic from different operators or clients with conflicting IP sets can be transmitted in tunnels but for non-standard connection (up to BRAS), tunneling is necessary.": "By default, dpi does not parse the tunnels, since traffic from different operators or clients with conflicting IP sets can be transmitted in tunnels but for non-standard connection (up to BRAS), tunneling is necessary.",

        "https://wiki.vasexperts.com/doku.php?id=start":"https://wiki.vasexperts.com/doku.php?id=start",
        "https://wiki.vasexperts.com/doku.php?id=dpi:install_point_scat:start":"https://wiki.vasexperts.com/doku.php?id=dpi:install_point_scat",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:platform:dpi_config:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:platform:dpi_config",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_filtration:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_filtration",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_statistics:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_statistics",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_priority:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_priority",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_shaping:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_shaping",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_advertising:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_advertising",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_capture:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_capture",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_notify:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_notify",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:extra_functionality:opt_cache:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:extra_functionality:opt_cache",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_ddos:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_ddos",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_li:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:base_functionality:opt_li",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_filtration:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_filtration",

        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_statistics:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_statistics",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_shaping:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_shaping",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_advertising:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_advertising",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_capture:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_capture",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_notify:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_notify",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_cache:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_cache",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_ddos:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_ddos",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_li:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_li",

        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:priority_config:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:priority_config",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:priority_config_as:start":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:priority_config_as",
        "Inactive": "Inactive",
        "Ready": "Ready",
        "Subscriber.Inactive":"Inactive",
        "Subscriber.Introduced":"Introduced",
        "Subscriber.Ready":"Ready",
        "Subscriber.Active":"Active",
        "Subscriber.Completed":"Completed",
        "Subscriber.Error": "Error",
        "Campaign is stopped (default)": "Campaign is stopped (default)",
        "Campaign started" : "Campaign started",
        "Named tariff" : "Profile",
        "Personal tariff": "Personal",
        "Named tariff assigned to a group of subscribers": "Named tariff assigned to a group of subscribers",
        "Unnamed tariff assigned personally to the subscriber": "Unnamed tariff assigned personally to the subscriber",
        "Mini Firewall": "Mini Firewall",

        "Subscriber CIDRs":"Subscriber CIDRs",
        "All QoE statistics will be filtered by this parameter":"All QoE statistics will be filtered by this parameter. Use comma to add several items.",
        "Channel numbers are indicated. If channel names are used in statistics, you must specify names, not numbers.":"Channel numbers are indicated. If channel names are used in statistics, you must specify names, not numbers.",

        "Network interfaces work mode":"Network interfaces work mode",
        "PCAP Recording, IPFIX Export (Clickstream and metadata: SIP, FTP)":"PCAP Recording, IPFIX Export (Clickstream and metadata: SIP, FTP)",
        "Trace":"Trace",

        "Subscriber logins":"Subscriber logins",
        "Set to see triggers of all users or not. You can see only triggers of your own by default.":"Set to see triggers of all users or not. You can see only triggers of your own by default.",

        "FastDPI server":"FastDPI server",
        "FastPCRF server":"FastPCRF server",
        "DPIUI2 server (GUI)":"DPIUI2 server (GUI)",
        "HOTSPOT server":"HOTSPOT server",
        "QoE Stor server": "QoE Stor server",
        "Traffic generator server": "Traffic generator server",
        "Sites cloning server": "Sites cloning server",
        "Network audit server": "Network audit server",

        "DB (MySql) connection":"DB (MySql) connection",
        "SMTP settings":"SMTP settings",
        "QoE Stor: DB (Clickhouse) connection":"QoE Stor: DB (Clickhouse) connection",
        "Jobs intervals and periods":"Jobs intervals and periods",
        "Application URL":"Application URL",
        "QoE Stor: DB lifetime settings":"QoE Stor: DB lifetime settings",
        "QoE Stor: discs settings":"QoE Stor: discs settings",

        "Environment":"Environment",
        "Local":"Local",
        "Production":"Production",
        "Development":"Development",
        "The current application environment.":"The current application environment.",
        "<b>Do not change this setting</b>. This can lead to unpredictable behavior.":"<b>Do not change this setting</b>. This can lead to unpredictable behavior.",
        "Application debug":"Application debug",
        "When an exception is uncaught and the APP_DEBUG environment variable is true, the debug page will show all environment variables and their contents. In some cases you may want to obscure certain variables.":"When an exception is uncaught and the APP_DEBUG environment variable is true, the debug page will show all environment variables and their contents. In some cases you may want to obscure certain variables.",
        "Encryption key":"Encryption key",
        "Session and cookie encryption key. If this is empty, the key is generated automatically.":"Session and cookie encryption key. If this is empty, the key is generated automatically.",
        "Application timezone":"Application timezone",
        "UTC by default.":"UTC by default.",
        "VAS Cloud host":"VAS Cloud host",
        "App cache driver":"App cache driver",
        "App queue driver":"App queue driver",
        "App session driver":"App session driver",

        "DB connection type":"DB connection type",
        "DB host":"DB host",
        "DB port":"DB port",
        "DB name":"DB name",
        "DB username":"DB username",
        "DB password":"DB password",

        "SMTP host":"SMTP host",
        "SMTP port":"SMTP port",
        "SMTP encryption type":"SMTP encryption type",
        "SMTP username":"SMTP username",
        "SMTP password":"SMTP password",
        "Tech. support email":"Tech. support email",
        "Send copy to":"Send copy to",
        "From field":"From field",
        "Sender":"Sender",
        "If empty, value of CFG_SMTP_UNAME is used by default":"If empty, value of CFG_SMTP_UNAME is used by default",

        "Test email settings":"Test email settings",
        "Send test email to address:":"Send test email to address:",
        "Email subject":"Email subject",
        "Email body:":"Email body:",
        "Send test email":"Send test email",
        "Test email was sent successfully.":"Test email was sent successfully.",
        "Test email was not sent.":"Test email was not sent.",
        "Apply current options?":"Apply current options?",
        "Field could not be empty!":"Field could not be empty!",


        "QoE Stor host":"QoE Stor host",
        "QoE Stor port":"QoE Stor port",
        "QoE Stor username":"QoE Stor username",
        "QoE Stor password":"QoE Stor password",
        "QoE Stor database name":"QoE Stor database name",
        "To connect to the QoE Stor (Clickhouse) database.":"To connect to the QoE Stor (Clickhouse) database.",
        "QoE Stor cluster mode":"QoE Stor cluster mode",
        "If enabled, all queries are executed on the server cluster.":"If enabled, all queries are executed on the server cluster.",
        "Cluster mode disabled (Default)":"Cluster mode disabled (Default)",
        "Cluster mode enabled":"Cluster mode enabled",
        "QoE Stor sql optimizer for cluster mode":"QoE Stor sql optimizer for cluster mode",
        "If enabled, all sql queries to distributed tables (cluster) will be optimized for best performance.":"If enabled, all sql queries to distributed tables (cluster) will be optimized for best performance.",
        "Disabled (Default)":"Disabled (Default)",


        "Subscribers synchronization":"Subscribers synchronization",
        "Disable subscribers synchronization (enabled by default). Synchronization of subscribers, services, tariffs.":"Disable subscribers synchronization (enabled by default). Synchronization of subscribers, services, tariffs.",
        "Synchronization enabled":"Synchronization enabled",
        "Synchronization disabled":"Synchronization disabled",
        "Subscribers synchronization period in minutes":"Subscribers synchronization period in minutes",
        "Subscribers synchronization period in minutes. Synchronization period of subscribers, services, tariffs.":"Subscribers synchronization period in minutes. Synchronization period of subscribers, services, tariffs.",

        "Stat & Alert logs synchronization":"Stat & Alert logs synchronization",
        "Disable Stat & Alert logs synchronization (enabled by default).":"Disable Stat & Alert logs synchronization (enabled by default).",
        "Period of data clearing DPI stat. logs in days":"Period of data clearing DPI stat. logs in days",

        "CGNAT synchronization":"CGNAT synchronization",
        "Disable CGNAT synchronization (enabled by default).":"Disable CGNAT synchronization (enabled by default).",
        "CGNAT data synchronization period in minutes":"CGNAT data synchronization period in minutes",

        "Link to the application. It is used, in particular, with QoE templates for reports sent by mail.":"Link to the application. It is used, in particular, with QoE templates for reports sent by mail.",

        "QoE Stor cache lifetime in seconds":"QoE Stor cache lifetime in seconds",
        "QoE Stor main log lifetime in hours":"QoE Stor main log lifetime in hours",
        "QoE Stor aggregated log lifetime in days":"QoE Stor aggregated log lifetime in days",
        "QoE reports cache life time in seconds":"QoE reports cache life time in seconds",
        "QoE main (raw) log lifetime in hours":"QoE main (raw) log lifetime in hours",
        "QoE aggregated log lifetime in days":"QoE aggregated log lifetime in days",

        "QoE Stor fullflow main log lifetime in hours":"QoE Stor fullflow main log lifetime in hours",
        "QoE Stor fullflow aggregated log lifetime in days":"QoE Stor fullflow aggregated log lifetime in days",

        "QoE Stor clickstream main log lifetime in hours":"QoE Stor clickstream main log lifetime in hours",
        "QoE Stor clickstream aggregated log lifetime in days":"QoE Stor clickstream aggregated log lifetime in days",

        "QoE Stor NAT main log lifetime in hours":"QoE Stor NAT main log lifetime in hours",
        "QoE Stor NAT aggregated log lifetime in days":"QoE Stor NAT aggregated log lifetime in days",

        "QoE Stor DNS main log lifetime in hours":"QoE Stor DNS main log lifetime in hours",
        "QoE Stor DNS aggregated log lifetime in days":"QoE Stor DNS aggregated log lifetime in days",

        "QoE Stor GTP main log lifetime in hours":"QoE Stor GTP main log lifetime in hours",
        "QoE Stor GTP aggregated log lifetime in days":"QoE Stor GTP aggregated log lifetime in days",
        "QoE Stor custom aggregated logs lifetime in days":"QoE Stor custom aggregated logs lifetime in days",
        "QoE Stor online aggregated logs lifetime in minutes":"QoE Stor online aggregated logs lifetime in minutes",

        "DDoS attack logs lifetime in hours":"DDoS attack logs lifetime in hours",
        "DDoS attack aggregated logs lifetime in days":"DDoS attack aggregated logs lifetime in days",
        "DDoS attack metrics logs lifetime in hours":"DDoS attack metrics logs lifetime in hours",
        "DDoS attack metrics aggregated logs lifetime in days":"DDoS attack metrics aggregated logs lifetime in days",

        "Export files lifetime in hours": "Export files life time in hours",
        "Limit lines in export file": "Limit lines in export file",
        "File limit for report export":"File limit for report export",
        "The maximum number of files created when exporting reports in each format.":"The maximum number of files created when exporting reports in each format.",

        "GTP LOAD RATE from fullflow logs lifetime in days":"GTP LOAD RATE from fullflow logs lifetime in days",

        "UPLINK LOAD RATE from fullflow logs lifetime in days":"UPLINK LOAD RATE from fullflow logs lifetime in days",

        "Enable moving data to HOT disk":"Enable moving data to HOT disk",
        "Enable moving data to HOT disk from COLD disk":"Enable moving data to HOT disk from COLD disk",
        "Logs list to move to HOT disk":"Logs list to move to HOT disk",
        "QoE Stor logs lifetime before moving to HOT disk, in hours":"QoE Stor logs lifetime before moving to HOT disk, in hours",
        "Days of week to HOT disk":"Days of week to HOT disk",
        "Days of week when partitions movings to HOT disk are possible":"Days of week when partitions movings to HOT disk are possible",
        "Hours of day to HOT disk":"Hours of day to HOT disk",
        "Hours of day when partitions movings to HOT disk are possible":"Hours of day when partitions movings to HOT disk are possible",
        "All by default":"All by default",

        "Enable moving data to COLD disk":"Enable moving data to COLD disk",
        "Logs list to move to COLD disk":"Logs list to move to COLD disk",
        "QoE Stor logs lifetime before moving to COLD disk, in hours":"QoE Stor logs lifetime before moving to COLD disk, in hours",
        "Days of week to COLD disk":"Days of week to COLD disk",
        "Days of week when partitions movings to COLD disk are possible":"Days of week when partitions movings to COLD disk are possible",
        "Hours of day to COLD disk":"Hours of day to COLD disk",
        "Hours of day when partitions movings to COLD disk are possible":"Hours of day when partitions movings to COLD disk are possible",

        "Dpiui2(GUI) autoupdate":"Dpiui2(GUI) autoupdate",
        "Enables Dpiui2(GUI) autoupdate":"Enables Dpiui2(GUI) autoupdate",

        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:dpiui:dpiui2#version_information":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:dpiui:dpiui2#version_information",

        "Receivers":"Receivers",
        "Filtration":"Filtration",

        "Traffic direction definition":"Traffic direction definition",
        "As is":"As is",
        "By AS":"By AS",
        "For fullflow only":"For fullflow only",
        "By CIDR":"By CIDR",
        "For fullflow and clickstream":"For fullflow and clickstream",
        "By both: AS and CIDR":"By both: AS and CIDR",
        "By any: AS or CIDR":"By any: AS or CIDR",
        "0 - 'As is' - The direction of traffic does not change and is determined by the DPI":"0 - 'As is' - The direction of traffic does not change and is determined by the DPI",
        "1 - 'By AS' - The direction of traffic is determined by the list of operator`s AS specified in the dictionary":"1 - 'By AS' - The direction of traffic is determined by the list of operator`s AS specified in the dictionary",
        "2 - 'By CIDR' - The direction of traffic is determined by the CIDRs list specified in the dictionary":"2 - 'By CIDR' - The direction of traffic is determined by the CIDRs list specified in the dictionary",
        "3 - 'By both: AS and CIDR'":"3 - 'By both: AS and CIDR'",
        "4 - 'By any: AS or CIDR'":"4 - 'By any: AS or CIDR'",

        "No filter":"No filter",
        "Subscribers filter":"Subscribers filter",
        "0 - 'No filter' - No filtration applied, all flow data is saved":"0 - 'No filter' - No filtration applied, all flow data is saved",
        "1 - 'By AS' - The flow data is filtering by the list of operator`s AS specified in the dictionary":"1 - 'By AS' - The flow data is filtering by the list of operator`s AS specified in the dictionary",
        "2 - 'By CIDR' - The flow data is filtering by the CIDRs list specified in the dictionary":"2 - 'By CIDR' - The flow data is filtering by the CIDRs list specified in the dictionary",

        "Exclusions from the subscribers filter":"Exclusions from the subscribers filter",
        "No exclude":"No exclude",
        "0 - 'No exclude' - No exclusion applied":"0 - 'No exclude' - No exclusion applied",
        "1 - 'By AS' - Exclusions are applied to the AS list of the operator specified in the dictionary":"1 - 'By AS' - Exclusions are applied to the AS list of the operator specified in the dictionary",
        "2 - 'By CIDR' - Exclusions are applied to the CIDRs list of the operator specified in the dictionary":"2 - 'By CIDR' - Exclusions are applied to the CIDRs list of the operator specified in the dictionary",

        "QoE Stor (fastor) autoupdate":"QoE Stor autoupdate",
        "Enables QoE Stor (fastor) autoupdate":"Enables QoE Stor autoupdate",

        "Autoload of hosts (urls) categories dictionaries":"Autoload of hosts (urls) categories dictionaries",
        "Enables autoload of hosts (urls) categories dictionaries":"Enables autoload of hosts (urls) categories dictionaries",

        "URL for downloading of hosts (urls) categories dictionaries":"URL for downloading of hosts (urls) categories dictionaries",

        "Autoload AS numbers dictionary":"Autoload AS numbers dictionary",
        "Enables autoload of AS numbers dictionary":"Enables autoload of AS numbers dictionary",

        "Autoload protocols dictionary":"Autoload protocols dictionary",
        "Autoload company protocols dictionary": "Autoload company protocols dictionary",
        "Enables autoload of applications protocols dictionary":"Enables autoload of applications protocols dictionary",
        "URL for downloading protocols dictionary":"URL for downloading protocols dictionary",
        "URL for downloading company protocols dictionary":"URL for downloading company protocols dictionary",
        "URL for downloading company protocol groups dictionary":"URL for downloading company protocol groups dictionary",
        "URL for downloading application protocols dictionary":"URL for downloading application protocols dictionary",
        "Autoload custom protocols dictionary":"Autoload custom protocols dictionary",
        "Enables autoload of custom applications protocols dictionary":"Enables autoload of custom applications protocols dictionary",
        "URL for downloading custom protocols dictionary":"URL for downloading custom protocols dictionary",
        "URL for downloading custom application protocols dictionary":"URL for downloading custom application protocols dictionary",
        "URL for downloading custom protocol groups dictionary":"URL for downloading custom protocol groups dictionary",
        "URL for downloading custom application protocol groups dictionary":"URL for downloading custom application protocol groups dictionary",
        "Enabled by default":"Enabled by default",
        "Disabled by default":"Disabled by default",
        "Under construction!":"Under construction!",

        "Receiver type":"Receiver type",
        "Port type":"Port type",
        "Port":"Port",
        "Rotate in minutes":"Rotate in minutes",
        "Rotate in seconds":"Rotate in seconds",
        "Receiver dump rotate in seconds. The same as the rotation in minutes, only in seconds.":"Receiver dump rotate in seconds. The same as the rotation in minutes, only in seconds.",
        "If this value is enabled the value in minutes is ignored.":"If this value is enabled the value in minutes is ignored.",
        "Rotate by flows":"Rotate by flows",
        "Rotation by flows records number. Works simultaneously with rotates in minutes or seconds.":"Rotation by flows records number. Works simultaneously with rotates in minutes or seconds.",
        "Delay in seconds":"Delay in seconds",
        "Queue size":"Queue size",
        "Export":"Export",

        "Fullflow port type":"Fullflow port type",
        "Fullflow port number":"Fullflow port number",
        "Clickstream port type":"Clickstream port type",
        "Clickstream port number":"Clickstream port number",
        "tcp or udp":"tcp or udp",

        "Recommended":"Recommended",
        "It`s recommended to use tcp":"It`s recommended to use tcp",

        "Fullflow or Clickstream":"Fullflow or Clickstream",
        "Fullflow is a receiver for fullflow data":"Fullflow is a receiver for fullflow data",
        "Clickstream is a receiver for clickstream data":"Clickstream is a receiver for clickstream data",
        "Any port you wish. The main thing that would be different for each thread":"Any port you wish. The main thing that would be different for each thread",
        "Default values are 1500 for fullflow thread and 1501 for clickstream thread":"Default values are 1500 for fullflow thread and 1501 for clickstream thread",

        "Receiver dump rotate period or data loading period into the database":"Receiver dump rotate period or data loading period into the database",
        "Default value is 10 minutes":"Default value is 10 minutes",
        "Default value is 10 minutes for fullflow and 12 minutes for clickstream":"Default value is 10 minutes for fullflow and 12 minutes for clickstream",
        "Dump rotate period for cliksteam should be greater or equal than the same period for fullflow. When fullflow dump rotates the HUP signal is sent to synchronize threads.":"Dump rotate period for cliksteam should be greater or equal than the same period for fullflow. When fullflow dump rotates the HUP signal is sent to synchronize threads.",
        "Do not change this setting unnecessarily":"Do not change this setting unnecessarily",

        "Data loading delay into the database":"Data loading delay into the database",
        "Default values are 0 seconds for fullflow thread and 400 seconds for clickstream thread":"Default values are 0 seconds for fullflow thread and 400 seconds for clickstream thread",

        "Receiver dump loading queue size":"Receiver dump loading queue size",
        "Default value is 10":"Default value is 10",

        "Reciver can export data to other receivers":"Reciver can export data to other receivers",
        "Format is":"Format is",

        "Insert processes number":"Insert processes number",
        "Number of dump insert processes":"Number of dump insert processes",

        "Balancer":"Balancer",
        "Balancer type":"Balancer type",
        "RoundRobin or All":"RoundRobin or All",
        "RoundRobin mode splits IPFIX flow":"RoundRobin mode splits IPFIX flow",
        "All mode replicate IPFIX flow":"All mode replicate IPFIX flow",
        "Balancer subreceivers":"Balancer subreceivers",
        "Balancer can split or replicate data to other receivers":"Balancer can split or replicate data to other receivers",
        "Balancer subreceivers type":"Balancer subreceivers type",
        "Balancer auto":"Balancer auto",
        "If Auto mode enabled it will create and start subreceivers automatic":"If Auto mode enabled it will create and start subreceivers automatic",

        "Websocket notifications": "Websocket notifications",
        "Period of data clearing Ulr tasks in days": "Period of data clearing Ulr tasks in days",
        "Period of clearing old Ulr logs in days": "Period of clearing old Ulr logs in days",
        "Schedule mode for updating lists": "Schedule mode for updating lists",
        "Updating the lists every YOUR_VALUE hours": "Updating the lists every YOUR_VALUE hours",

        "Ulr settings": "Ulr settings",
        "White list redirect URL": "White list redirect URL",
        "Black list redirect URL": "Black list redirect URL",
        "Black list upload host": "Black list upload host",
        "Black list upload port": "Black list upload port",
        "To connect to the black list resources server.": "To connect to the black list resources server.",
        "Black list upload username": "Black list upload username",
        "Black list upload password": "Black list upload password",
        "Info": "Info",
        "Debug": "Debug",
        "Log level detalization": "Log level detalization",
        "Black list upload path": "Black list upload path",
        "ASN for IP-exclude rules": "ASN for IP-exclude rules",
        "Black list upload use sudo": "Black list upload use sudo",
        "Use": "Use",
        "Don`t use": "Don`t use",
        "Use only when there is a category": "Use only when there is a category",

        "Push notifications settings": "Push notifications settings",
        "Broadcast driver for push notifications": "Broadcast driver for push notifications",
        "Redis": "Redis",
        "Redis host": "Redis host",
        "Redis port": "Redis port",
        "Redis password": "Redis password",

        "Require authorization on ASN (OIMS) server":"Require authorization on ASN (OIMS) server",
        "ASN (OIMS) server":"ASN (OIMS) server",
        "ASN user ID":"ASN user ID",
        "ASN token":"ASN token",
        "ASN version":"ASN version",
        "DPI hardware ID":"DPI hardware ID",
        "Traffic generator executable path":"Traffic generator executable path",
        "PCI Ethernet controllers ports numbers":"PCI Ethernet controllers ports numbers",
        "Traffic generator pid addition":"Traffic generator pid addition",
        "Are you sure you want to restart the PCRF process?": "Are you sure you want to restart the PCRF process?",
        "Cancel": "Cancel",
        "Restart": "Restart",
        "Are you sure you want to update the hot settings?": "Are you sure you want to update the hot settings?",
        "Restart PCRF": "Restart PCRF",
        "Updating hot options": "Updating hot options",
        "Fast PCRF Config": "Fast PCRF Config",
        "Fast PCRF logs": "Fast PCRF logs",
        "Default": "Default",
        "Default value":"Default value",
        "General settings": "General settings",
        "Authorization server": "Authorization server",
        "Radius parameters": "Radius parameters",
        "Radius servers": "Radius servers",
        "Accounting": "Accounting",
        "CoA parameters": "CoA parameters",
        "DHCP parameters": "DHCP parameters",
        "Persistent FIFO": "Persistent FIFO",

        "Startup fdpi_pcrf as daemon": "Startup fdpi_pcrf as daemon",
        "No": "No",
        "Yes": "Yes",
        "Detailed logging": "Detailed logging",
        "Trace flags by subsystems": "Trace flags by subsystems",
        "Radius connections monitor": "Radius connections monitor",
        "Internal task scheduler":"Internal task scheduler",
        "Auth server": "Auth server",
        "radius_client connections": "radius_client connections",
        "radius_client monitor": "radius_client monitor",
        "CoA-server events":"CoA-server events",
        "CoA-listener connects": "CoA-listener connects",
        "CoA-requests":"CoA-requests",
        "fastDPI sending data events":"fastDPI sending data events",
        "Events queue from fastPCRF to fastDPI":"Events queue from fastPCRF to fastDPI",
        "start/stop accounting requests": "start/stop accounting requests",
        "interim update accounting requests": "interim update accounting requests",
        "Raw accounting data from fastDPI receiving": "Raw accounting data from fastDPI receiving",
        "trace param ignoring if verbose=1.": "trace param ignoring if verbose=1.",
        "Max filesize": "Max filesize",
        "Default value is 1G (1073741824 bytes)": "Default value is 1G (1073741824 bytes)",
        "Statistics output period in seconds":"Statistics output period in seconds",
        "Default value is 300 seconds (every 5 minutes).": "Default value is 300 seconds (every 5 minutes).",
        "Working threads number": "Working threads number",
        "Every fdpi_pcrf component can live in separate thread.<br/>Setting threads number greater then 5 is pointless.": "Every fdpi_pcrf component can live in separate thread.<br/>Setting threads number greater then 5 is pointless.",
        "Internal asynchronous message transfer queue size": "Internal asynchronous message transfer queue size",
        "Default value is 512*1024=524288.": "Default value is 512*1024=524288.",
        "Policing profile name for unauthorized users": "Policing profile name for unauthorized users",
        "White list (service 5) profile name for unauthorized users": "White list (service 5) profile name for unauthorized users",
        "fastDPI server": "fastDPI server",
        "where:": "where:",
        " - ip - fastDPI server ip-address": " - ip - fastDPI server ip-address",
        " - dev - interface name for connecting": " - dev - interface name for connecting",
        " - port - port for fastpcrf->fastdpi connection (29000 - default fdpi_ctrl port)": " - port - port for fastpcrf->fastdpi connection (29000 - default fdpi_ctrl port)",
        " - name=value - additional server parameters": " - name=value - additional server parameters",
        "   - attr_nas_ip  - IPv4 address for NAS-IP-Address attribute; using fastdpi IP-address if not set": "   - attr_nas_ip  - IPv4 address for NAS-IP-Address attribute; using fastdpi IP-address if not set",
        "   - attr_nas_ipv6  - NAS-IPv6-Address attribute value for current fastdpi": "   - attr_nas_ipv6  - NAS-IPv6-Address attribute value for current fastdpi",
        "   - attr_nas_id  - NAS-Identifier attribute value for current fastdpi": "   - attr_nas_id  - NAS-Identifier attribute value for current fastdpi",
        "fastDPI server list": "fastDPI server list",
        "Using parameters fdpi_server allows you to set additional attributes for each fastdpi-server": "Using parameters fdpi_server allows you to set additional attributes for each fastdpi-server",
        "Connection listener interface(device) name": "Connection listener interface(device) name",
        "Listen port": "Listen port",
        "Default value is": "Default value is",
        "Inbound connections max number": "Inbound connections max number",
        "Radius server configuration": "Radius server configuration",
        " - secret - radius server secret": " - secret - radius server secret",
        " - ip - radius server ip-address": " - ip - radius server ip-address",
        " - dev(not required) - interface name for connecting": " - dev(not required) - interface name for connecting",
        " - port - port": " - port - port",
        " - param=value - set of radius server configuration parameters": " - param=value - set of radius server configuration parameters",
        "Radius server revive period(in seconds)": "Radius server revive period(in seconds)",
        "Default value is 120 seconds": "Default value is 120 seconds",
        "Max number of connections to server": "Max number of connections to server",
        "Each connection can serve less then 256 simultaneous requests": "Each connection can serve less then 256 simultaneous requests",
        "Value 0 is unlimited; this opportunity should be used very carefully!": "Value 0 is unlimited; this opportunity should be used very carefully!",
        "Accounting auth port connections max number": "Accounting auth port connections max number",
        "Response time, seconds": "Response time, seconds",
        "If will not received response for Access-Request for this time, the request will be repeated radius_resend_count times": "If will not received response for Access-Request for this time, the request will be repeated radius_resend_count times",
        "Attempts to send request max number": "Attempts to send request max number",
        "0 - do not repeat": "0 - do not repeat",
        "Radius server dead timeout, seconds": "Radius server dead timeout, seconds",
        "Current radius server considered dead if will not received response for any request for this time": "Current radius server considered dead if will not received response for any request for this time",
        "and fdpi_pcrf will try to switch to another radius server": "and fdpi_pcrf will try to switch to another radius server",
        "This parameter must be at least 2 times smaller than radius_revive_period": "This parameter must be at least 2 times smaller than radius_revive_period",
        "Radius server Status-Server request": "Radius server Status-Server request",
        "Radius server Message-Authenticator attribute": "Radius server Message-Authenticator attribute",
        "User-Name attribute for L3 auth-requests Accept-Request": "User-Name attribute for L3 auth-requests Accept-Request",
        "List of identifiers": "List of identifiers",
        "Valid values:": "Valid values:",
        " - login: User-Name=login, if login known": " - login: User-Name=login, if login known",
        " - ip: User-Name=ip as string": " - ip: User-Name=ip as string",
        " - qinq:User-Name=outerVlan.innerVlan, if web is QinQ(double VLAN, vlan-per-user)": " - qinq:User-Name=outerVlan.innerVlan, if web is QinQ(double VLAN, vlan-per-user)",
        "User-Name attribute for DHCP-requests Accept-Request":"User-Name attribute for DHCP-requests Accept-Request",
        " - mac: User-Name=mac-address as string like \"XX:XX:XX:XX:XX:XX\"": " - mac: User-Name=mac-address as string like \"XX:XX:XX:XX:XX:XX\"",
        "User-Name attribute for ARP-requests Accept-Request": "User-Name attribute for ARP-requests Accept-Request",
        "User-Password attribute for requests Accept-Request": "User-Password attribute for requests Accept-Request",
        "NAS-Port-Type attribute value for request Access-Request": "NAS-Port-Type attribute value for request Access-Request",
        "The list of valid values is given by RFC 2865": "The list of valid values is given by RFC 2865",
        "Default value is 5 (Virtual)": "Default value is 5 (Virtual)",
        "Service-Type attribute value for request Access-Request": "Service-Type attribute value for request Access-Request",
        "Accounting Radius-server port": "Accounting Radius-server port",
        "Time interval for sending intermediate accounting, in seconds": "Time interval for sending intermediate accounting, in seconds",
        "Minimum value is": "Minimum value is",
        "Interim update will sent if traffic amount greater then volume": "Interim update will sent if traffic amount greater then volume",
        "Default value is 0 (only by time)": "Default value is 0 (only by time)",
        "Set in bytes, kilobytes (65K), megabytes(65M), gigabytes(10G)": "Set in bytes, kilobytes (65K), megabytes(65M), gigabytes(10G)",
        "Accounting data persistence timeout, in seconds": "Accounting data persistence timeout, in seconds",
        "If during this timeout the subscriber statistics did not change, it is considered that the subscriber's session is timed out and sent Accounting Stop.": "If during this timeout the subscriber statistics did not change, it is considered that the subscriber's session is timed out and sent Accounting Stop.",
        "CoA notifications receiving UDP-port": "CoA notifications receiving UDP-port",
        "Set this parameter value 0 if radius server not provides CoA": "Set this parameter value 0 if radius server not provides CoA",
        "CoA-response resending timeout, in seconds": "CoA-response resending timeout, in seconds",
        "Resend number is setting by radius_resend_count parameter": "Resend number is setting by radius_resend_count parameter",
        "Stop occurrence control mode by data invariance": "Stop occurrence control mode by data invariance",
        "Accounting start point": "Accounting start point",
        "Sign of compatibility with LanBilling": "Sign of compatibility with LanBilling",
        "Acct-Request attributes format": "Acct-Request attributes format",
        "Frequency of sending ready accounting data, in seconds": "Frequency of sending ready accounting data, in seconds",
        "<b>Do not change this setting</b>.": "<b>Do not change this setting</b>.",
        "Swap traffic direction for accounting Radius-attributes": "Swap traffic direction for accounting Radius-attributes",
        "Disable sending to Acct-Request traffic class breakdown": "Disable sending to Acct-Request traffic class breakdown",
        "What traffic classes to include in accounting": "What traffic classes to include in accounting",
        "Pending CoA-requests from radius-servers max number": "Pending CoA-requests from radius-servers max number",
        "CoA-client format": "CoA-client format",
        " - secret - shared secret": " - secret - shared secret",
        " - ip - CoA-client ip-address": " - ip - CoA-client ip-address",
        " - dev - interface for caching CoA-client alerts": " - dev - interface for caching CoA-client alerts",
        " - port - UDP-port": " - port - UDP-port",
        "DHCP Netmask": "DHCP Netmask",
        "DHCP Gateway": "DHCP Gateway",
        "MTU size": "MTU size",
        "Ip address lease time, seconds": "Ip address lease time, seconds",
        "DNS address": "DNS address",
        "Static routing table": "Static routing table",
        "Persistent FIFO folder": "Persistent FIFO folder",
        "Queue pages max number": "Queue pages max number",
        "Page size is 2M.": "Page size is 2M.",
        "0 - pages number is unlimited.": "0 - pages number is unlimited.",
        "Minimal value is 2.": "Minimal value is 2.",
        "Queue max files size is rlimit_fsize. Queue can not be greater then rlimit_fsize.": "Queue max files size is rlimit_fsize. Queue can not be greater then rlimit_fsize.",
        "Reconncet to fastdpi servers timeout, seconds": "Reconncet to fastdpi servers timeout, seconds",
        "Pending requests from fastdpi-servers max number": "Pending requests from fastdpi-servers max number",
        "No changes in inbound and outbound traffic": "No changes in inbound and outbound traffic",
        "No changes in outbound traffic only": "No changes in outbound traffic only",
        "From the last Stop event": "From the last Stop event (by default)",
        "From the start of Start event. Ignore all traffic from the last Stop event": "From the start of Start event. Ignore all traffic from the last Stop event",
        "Do not change": "Do not change",
        "Swap inbound/uotbound traffic counters": "Swap inbound/uotbound traffic counters",
        "List of classes": "List of classes",
        "Send Stop accounting before authorization": "Send Stop accounting before authorization",
        "FastDPI Submission Queue": "FastDPI Submission Queue",
        "FastDPI servers": "FastDPI servers",

        "To send user authentication status to fastDPI servers and its parameters a persistent queue is organized.": "To send user authentication status to fastDPI servers and its parameters a persistent queue is organized.",
        "This ensures that even if one of the fastDPI servers is unavailable, all authorization messages for it will be saved and sent as soon as it becomes available.": "This ensures that even if one of the fastDPI servers is unavailable, all authorization messages for it will be saved and sent as soon as it becomes available.",
        "(bras_dhcp_mode=2 in fastdpi.conf)": "(bras_dhcp_mode=2 in fastdpi.conf)",
        "Applicable only if fastDPI works in DHCP proxy via Radius mode": "Applicable only if fastDPI works in DHCP proxy via Radius mode",
        "If, however, no value is specified in this config-file, the corresponding DHCP option will be absent in the DHCP-Offer.": "If, however, no value is specified in this config-file, the corresponding DHCP option will be absent in the DHCP-Offer.",
        "fdpi_pcrf switches to master server as soon as it become available.": "fdpi_pcrf switches to master server as soon as it become available.",
        "If this one is not available to connect, it will try to connect to next one, availability of master-server periodically checked by Server-Status request.": "If this one is not available to connect, it will try to connect to next one, availability of master-server periodically checked by Server-Status request.",
        "fdpi_pcrf trying to connect to master-server": "fdpi_pcrf trying to connect to master-server",
        "fdpi_pcrf interact only one server from the list.": "fdpi_pcrf interact only one server from the list.",
        "Usually at least two radius servers are specified - master and reserve.": "Usually at least two radius servers are specified - master and reserve.",
        "The most preferred server(master-server) is the first, then less preferred(reserve).": "The most preferred server(master-server) is the first, then less preferred(reserve).",
        "Radius servers should be listed in order of preference:": "Radius servers should be listed in order of preference:",
        "You can specify up to 16 different radius-servers.": "You can specify up to 16 different radius-servers.",
        "Each option specify radius-server address and his parameters.": "Each option specify radius-server address and his parameters.",
        "You can set any radius servers but it will interact only one of them.": "You can set any radius servers but it will interact only one of them.",
        "Profile's names for services": "Profile's names for services",
        "List of services": "List of services",
        "Policing profile": "Policing profile",
        "This component interacts with the Radius server, asking it for authorization and user's parameters": "This component interacts with the Radius server, asking it for authorization and user's parameters",
        "Authorization server is the part of fastpcrf that accepts requests for authorization from fastDPI.": "Authorization server is the part of fastpcrf that accepts requests for authorization from fastDPI.",
        "These values will be substituted into the configured DHCP-Offer, if Radius does not reported relevant attributes.": "These values will be substituted into the configured DHCP-Offer, if Radius does not reported relevant attributes.",

        "Frame Pools": "Frame Pools",
        "DHCP server Address": "DHCP server Address",
        "address - DHCP server IP-address": "address - DHCP server IP-address",
        "dev - local interface for communication with DHCP server": "dev - local interface for communication with DHCP server",
        "Enter valid address": "Enter valid address",
        "In which option of the DHCP request to send the pool name": "In which option of the DHCP request to send the pool name",
        "Pool name will added to opt125 (default)": "Pool name will added to opt125 (default)",
        "If option is already exists it will replaced by the pool name": "If option is already exists it will replaced by the pool name",
        "This option is always added": "This option is always added",
        "All DHCP requests are always sent to all servers specified in the dhcp_server parameters.": "All DHCP requests are always sent to all servers specified in the dhcp_server parameters.",
        "If multiple DHCP servers are configured, the PCRF takes the first response into account, and responses from the other DHCP servers are ignored.": "If multiple DHCP servers are configured, the PCRF takes the first response into account, and responses from the other DHCP servers are ignored.",
        "ipv6 - DHCPv6 server address": "ipv6 - DHCPv6 server address",
        "port - port, default is 547": "port - port, default is 547",
        "options - additional options": "options - additional options",
        "source_ip=address - The source IPv6 address that the request is sent to the DHCPv6 server from": "source_ip=address - The source IPv6 address that the request is sent to the DHCPv6 server from",
        "If source_ip is not specified, then:": "If source_ip is not specified, then:",
        "If server address link-local - using link-local address of dev interface": "If server address link-local - using link-local address of dev interface",
        "If server address is global - using global address of dev interface": "If server address is global - using global address of dev interface",
        "relay_ip=address - Relay IPv6 address. DHCPv6 server considers this address as relay address": "relay_ip=address - Relay IPv6 address. DHCPv6 server considers this address as relay address",
        "If relay_ip is not specified it equals source_ip": "If relay_ip is not specified it equals source_ip",
        "You can set up to 16 servers.": "You can set up to 16 servers.",
        "Pool name will send in Vendor-Specific option (default)": "Pool name will send in Vendor-Specific option (default)",
        "All DHCPv6 requests are always sent to all servers specified in the dhcp6_server parameters.": "All DHCPv6 requests are always sent to all servers specified in the dhcp6_server parameters.",
        "If multiple DHCPv6 servers are configured, the PCRF takes the first response into account, and responses from the other DHCPv6 servers are ignored.": "If multiple DHCPv6 servers are configured, the PCRF takes the first response into account, and responses from the other DHCPv6 servers are ignored.",

        "CKAT expects to get the subscriber`s IP address in the Access-Accept Radius response.": "CKAT expects to get the subscriber`s IP address in the Access-Accept Radius response.",
        "Instead of issuing an IP address, the billing service behind the Radius can provide the name of a pool of addresses from which to distribute the address to this subscriber.": "Instead of issuing an IP address, the billing service behind the Radius can provide the name of a pool of addresses from which to distribute the address to this subscriber.",
        "For IPv4, the pool name is specified in the Framed-Pool attribute; for IPv6, it is specified in the Framed - IPv6-Pool attribute.": "For IPv4, the pool name is specified in the Framed-Pool attribute; for IPv6, it is specified in the Framed - IPv6-Pool attribute.",
        "FastPCRF, after getting the pool name in Access-Accept, requests the subscriber's IP address from the DHCP server.": "FastPCRF, after getting the pool name in Access-Accept, requests the subscriber's IP address from the DHCP server.",
        "After receiving a response from the DHCP server, fastPCRF allocates the IP address from it, combines the options specified in the DHCP response with the Access-Accept attributes, and sends the authorization response via fastdpi to the subscriber.": "After receiving a response from the DHCP server, fastPCRF allocates the IP address from it, combines the options specified in the DHCP response with the Access-Accept attributes, and sends the authorization response via fastdpi to the subscriber.",

        "Input correct address": "Input correct address",
        "Input correct value": "Input correct value",
        "Update": "Update",
        "Configuration loaded.": "Configuration loaded.",
        "Radius-client is one of the components of fast_pcrf.": "Radius-client is one of the components of fast_pcrf.",
        "acct and auth are out of sync": "acct and auth are out of sync",
        "acct and auth synchronized": "acct and auth synchronized",
        "NAT 1:1 and subscriber's white address known": "NAT 1:1 and subscriber's white address known",
        "Period of clearing Ulr users actions log in days": "Period of clearing Ulr users actions log in days",
        "Enter valid value": "Enter valid value",
        "Enter valid folder": "Enter valid folder",
        "Prioritization of multiple channels": "Prioritization of multiple channels",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_shaping:shaping_multi:start": "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_shaping:shaping_multi",
        "Distinguish type for channels": "Distinguish type for channels",
        "Using NICs for different channels": "Using NICs for different channels",
        "Using VLANs for different channels": "Using VLANs for different channels",
        "Using CIDRs for different channels": "Using CIDRs for different channels",
        "NICs or VLANs list for virtual channels": "NICs or VLANs list for virtual channels",
        "dna0:dna1|dna2:dna3 or 100:101-115|200:201:240-250": "dna0:dna1|dna2:dna3 or 100:101-115|200:201:240-250",
        "Hosts classifier server":"Hosts classifier server",
        "More...": "More...",
        "Network interface name":"Network interface name",
        "IP address of QoE Stor":"IP address of QoE Stor",
        "Type":"Type",

        "Replacing Login with Vchannel":"Replacing Login with Vchannel",
        "Use dictionary when replacing Login":"Use dictionary when replacing Login",
        "Enable auto replacing Login with vchannel on insert":"Enable auto replacing Login with vchannel on insert",
        "Enabled if Login is empty":"Enabled if Login is empty",
        "Vchannels names dic autoload":"Vchannels names dic autoload",
        "Vchannels names dic url":"Vchannels names dic url",

        "NAT log settings":"NAT log settings",
        "Import NAT events from fullflow":"Import NAT events from fullflow",
        "Fields to save when aggregating NAT log":"Fields to save when aggregating NAT log",
        "Time interval for aggregating NAT logs":"Time interval for aggregating NAT logs",
        "Enable filling IP-LOGIN bind from fullflow":"Enable filling IP-LOGIN bind from fullflow",
        "Enable adding LOGIN to NAT log from IP-LOGIN binding":"Enable adding LOGIN to NAT log from IP-LOGIN binding",
        "Use distributed IP-LOGIN binding table":"Use distributed IP-LOGIN binding table",

        "Protocol ID":"Protocol ID",
        "Event type":"Event type",
        "Source IPv4":"Source IPv4",
        "Source port":"Source port",
        "Destination IPv4":"Destination IPv4",
        "Destination port":"Destination port",
        "Post NAT source IPv4":"Post NAT source IPv4",
        "Post NAT source port":"Post NAT source port",
        "Session ID":"Session ID",
        "Login":"Login",
        "DPI ID":"DPI ID",

        "All fields are enabled by default":"All fields are enabled by default",

        "Raw fullflow":"Raw fullflow",
        "Agg fullflow":"Agg fullflow",
        "Raw clickstream":"Raw clickstream",
        "Agg clickstream":"Agg clickstream",
        "Raw NAT flow":"Raw NAT flow",
        "Agg NAT flow":"Agg NAT flow",
        "Raw GTP flow":"Raw GTP flow",
        "Agg GTP flow":"Agg GTP flow",
        "Agg custom logs":"Agg custom logs",
        "Agg online flow":"Agg online flow",
        "Raw aaaflow":"Raw aaaflow",
        "AAA UDR fullflow and clickstream":"AAA UDR fullflow and clickstream",

        "Default value":"Default value",

        "FULLFLOW log settings":"FULLFLOW log settings",
        "FULLFLOW AGG log settings":"FULLFLOW AGG log settings",
        "Fields to save when aggregating FULLFLOW log":"Fields to save when aggregating FULLFLOW log",
        "Enable VOIP traffic data":"Enable VOIP traffic data",
        "Time interval for aggregating FULLFLOW logs":"Time interval for aggregating FULLFLOW logs",
        "Enable FULLFLOW log background compressing":"Enable FULLFLOW log background compressing",
        "Enable DSCP from original TOS":"Enable DSCP from original TOS",
        "Enable collection of information about blocked traffic":"Enable collection of information about blocked traffic",
        "Threshold value for traffic detection as a drop":"Threshold value for traffic detection as a drop",
        "Threshold value for traffic detection as a policing":"Threshold value for traffic detection as a policing",
        "Enter a number between 0 and 1, including floating point numbers":"Enter a number between 0 and 1, including floating point numbers",
        "Blocked traffic":"Blocked traffic",


        "CLICKSTREAM log settings":"CLICKSTREAM log settings",
        "CLICKSTREAM AGG log settings":"CLICKSTREAM AGG log settings",
        "Fields to save when aggregating CLICKSTREAM log":"Fields to save when aggregating CLICKSTREAM log",
        "Time interval for aggregating CLICKSTREAM logs":"Time interval for aggregating CLICKSTREAM logs",

        "ONLINEFLOW log settings":"ONLINEFLOW log settings",
        "Time interval for aggregating ONLINEFLOW logs":"Time interval for aggregating ONLINEFLOW logs",

        "OpenCellID settings":"OpenCellID settings",
        "Enables autoload of OpenCellID catalog":"Enables autoload of OpenCellID catalog",
        "Token in LocalAPI platform":"Token in LocalAPI platform",
        "OpenCellID level of log":"OpenCellID level of log",
        "Time interval to update empty data cell towers for report of geoposition": "NULL data query depth for location report, hours",

        "GTP settings":"GTP settings",
        "Import GTP LOAD RATE from fullflow":"Import GTP LOAD RATE from fullflow",
        "Enable a service for detecting anomalies in the load rate of base stations":"Enable a service for detecting anomalies in the load rate of base stations",
        "Fields to save when aggregating GTP log":"Fields to save when aggregating GTP log",
        "Fields to save when aggregating GTP log tooltip":"Fields to save when aggregating GTP log",
        "Save traffic volume":"Save traffic volume",
        "Group by protocol code":"Group by protocol code",
        "Save subscribers":"Save subscribers",
        "Time interval for aggregating GTP LOAD RATE logs in minutes":"Time interval for aggregating GTP LOAD RATE logs in minutes",
        "Time interval for aggregating GTP LOAD RATE logs in minutes tooltip":"Time interval for aggregating GTP LOAD RATE logs in minutes",

        "UPLINK LOAD RATE settings":"UPLINK LOAD RATE settings",
        "Import UPLINK LOAD RATE from fullflow":"Import UPLINK LOAD RATE from fullflow",
        "Fields to save when aggregating UPLINK LOAD RATE log":"Fields to save when aggregating UPLINK LOAD RATE log",
        "Enable a service for import UPLINK LOAD RATE info from fullflow":"Enable a service for import UPLINK LOAD RATE info from fullflow",
        "Time interval for aggregating UPLINK LOAD RATE logs in minutes":"Time interval for aggregating UPLINK LOAD RATE logs in minutes",
        "RTT":"RTT",

        "Kaspersky list of infected hosts":"Kaspersky list of infected hosts",
        "Import Kaspersky list of infected hosts":"Import Kaspersky list of infected hosts",
        "Enable a service for import Kaspersky list of infected hosts":"Enable a service for import Kaspersky list of infected hosts",
        "Id category of malicious hosts":"Id category of malicious hosts",
        "Id category of botnet hosts":"Id category of botnet hosts",
        "Id category of phishing hosts":"Id category of phishing hosts",
        "Id category of IoT hosts":"Id category of IoT hosts",


        "Source IP":"Source IP",
        "Destination IP":"Destination IP",
        "Source AS number":"Source AS number",
        "Destination AS number":"Destination AS number",
        "Source AS title":"Source AS title",
        "Destination AS title":"Destination AS title",
        "Subscriber":"Subscriber",
        "Subscriber login":"Subscriber login",
        "Host IP":"Host IP",
        "Host":"Host",
        "Protocol code":"Protocol code",
        "Protocol identifier":"Protocol identifier",
        "Post NAT port":"Post NAT port",
        "Vchannel":"Vchannel",

        "Device":"Device",
        "Referal":"Referal",
        "User agent":"User agent",
        "Cookie":"Cookie",
        "Method":"Method",
        "Result code":"Result code",
        "Content type":"Content type",

        "Subscribers bind mode":"Subscribers bind mode",
        "0 - 'Default' - Binding by LOGIN if not empty or IP":"0 - 'Default' - Binding by LOGIN if not empty or IP",
        "1 - 'By IP'":"1 - 'By IP'",
        "2 - 'By LOGIN'":"2 - 'By LOGIN'",
        "Binding by LOGIN if not empty or IP (default)":"Binding by LOGIN if not empty or IP (default)",
        "By IP":"By IP",
        "By LOGIN":"By LOGIN",

        "Receivers clickstream":"Receivers clickstream",
        "Model settings":"Model settings",
        "Company code":"Company code",
        "Rotate bash":"Rotate bash",
        "Processing processes number":"Processing processes number",
        "Default models":"Default models",
        "Number of dump processing processes":"Number of dump processing processes",
        "You can receive clickstream from multiple operators and provide a Company Code for convenience":"You can receive clickstream from multiple operators and provide a Company Code for convenience",
        "Bash script for processing dumps. By default run_dump_process.sh":"Bash script for processing dumps. By default run_dump_process.sh",

        "Maps settings": "Maps settings",
        "Map data storage period, days": "Map data storage period, days",
        "Add data from FULLFLOW":"Add data from FULLFLOW",
        "Interface logs storage period in days": "Interface logs storage period in days",
        "Lumen logs storage period in days": "Lumen logs storage period in days",

        "Number of precesses for the default queue": "Number of precesses for the default queue",
        "Number of precesses for the default QoE queue": "Number of precesses for the default QoE queue",
        "Number of precesses for the long QoE queue": "Number of precesses for the long QoE queue",
        "Number of precesses for the backgrounds QoE queue": "Number of precesses for the backgrounds QoE queue",
        "Number of precesses for the custom protocols QoE queue": "Number of precesses for the custom protocols QoE queue",
        "Number of precesses for the default LI queue": "Number of precesses for the default LI queue",
        "Number of precesses for the long LI queue": "Number of precesses for the long LI queue",
        "Number of free precesses for the default QoE queue": "Number of free precesses for the default QoE queue",
        "Number of precesses for the long ULR queue": "Number of precesses for the long ULR queue",
        "Number of precesses for the default ULR queue": "Number of precesses for the default ULR queue",
        "Number of free precesses for the default ULR queue": "Number of free precesses for the default ULR queue",
        "if": "if",
        "else": "else",
        "Catalog server": "Catalog server",
        "PDI number. If the value is -1 or not specified, then the DPI number is determined by the order of the receiver in the list.":"PDI number. If the value is -1 or not specified, then the DPI number is determined by the order of the receiver in the list.",
        "Period of clearing custom protocols queue logs in days": "Period of clearing custom protocols queue logs in days",
        "VasCloud settings": "VasCloud settings",
        "Period of clearing traffic decoding queue logs in days": "Period of clearing traffic decoding queue logs in days",
        "If a token is specified, authorization is performed using the token. If not specified, by login and password.":"If a token is specified, authorization is performed using the token. If not specified, by login and password.",

        "Enable force moving data":"Enable force moving data",
        "Attention! By default, data deletion on this drive is enabled.":"<strong>Attention!</strong> By default, data deletion on this drive is enabled.",
        "for DEFAULT disk":"for DEFAULT disk",
        "for HOT disk":"for HOT disk",
        "for COLD disk":"for COLD disk",
        "Move factor":"Move factor",
        "The amount of free space before force moving enabled":"The amount of free space before force moving enabled",
        "Enable data removing!":"Enable data removing!",
        "Enable move to":"Enable move to",
        "Autoload MCC and MNC dictionaries":"Autoload MCC and MNC dictionaries",
        "Enables autoload of MCC and MNC dictionaries":"Enables autoload of MCC and MNC dictionaries",

        "Availability of porn images": "Availability of porn images",

        "Nudes images and videos": "Nudes images and videos",
        "Threshold": "Threshold",
        "Porn Category Code": "Porn Category Code",
        "Limit": "Limit",
        "Timeout": "Timeout",
        "Mark only": "Mark only",
        "Amount of threads": "Amount of threads",

        "Enabled image processing":"Enabled image processing",
        "Enabled video processing":"Enabled video processing",
        "Enables/disables image processing for the presence of porn in them": "Enables/disables image processing for the presence of porn in them",
        "Enables/disables video processing for the presence of porn in them": "Enables/disables video processing for the presence of porn in them",
        "Adjusts the probability of recognition from 0 to 1. The higher the value, the more likely the image will NOT fall into the category of pornography.": "Adjusts the probability of recognition from 0 to 1. The higher the value, the more likely the image will NOT fall into the category of pornography.",
        "Adjusts the probability of recognition from 0 to 1. The higher the value, the more likely the video will NOT fall into the category of pornography.": "Adjusts the probability of recognition from 0 to 1. The higher the value, the more likely the video will NOT fall into the category of pornography.",
        "The category to which the recognized pornography will be moved": "The category to which the recognized pornography will be moved",
        "Number of images uploading from the host": "Number of images uploading from the host",
        "Number of videos uploading from the host": "Number of videos uploading from the host",
        "Waiting time if the picture is not loaded": "Waiting time if the picture is not loaded",
        "Waiting time if the video is not loaded": "Waiting time if the video is not loaded",
        "Hosts on which pornographic images have been recognized, if this option is enabled, will only be marked, otherwise these hosts will be automatically moved to the porn category": "Hosts on which pornographic images have been recognized, if this option is enabled, will only be marked, otherwise these hosts will be automatically moved to the porn category",
        "Hosts on which pornographic videos have been recognized, if this option is enabled, will only be marked, otherwise these hosts will be automatically moved to the porn category": "Hosts on which pornographic videos have been recognized, if this option is enabled, will only be marked, otherwise these hosts will be automatically moved to the porn category",
        "This field allows you to configure amount of processor threads that will be used to downloading images.</br></br>Default is 1": "This field allows you to configure amount of processor threads that will be used to downloading images.</br></br>Default is 1",
        "This field allows you to configure amount of processor threads that will be used to downloading videos.</br></br>Default is 1": "This field allows you to configure amount of processor threads that will be used to downloading videos.</br></br>Default is 1",
        "Default models (to specify multiple models, list them via ',').":"Default models (to specify multiple models, list them via ',').",
        "This field allows you to set the minimum number of characters for the text classifier.</br>If there are not enough characters in the text, the site will be placed in the category 'unknown'.</br></br>Default is 150":"This field allows you to set the minimum number of characters for the text classifier.</br>If there are not enough characters in the text, the site will be placed in the category 'unknown'.</br></br>Default is 150",
        "Category code to recheck.</br></br>Default is 'unknown'":"Category code to recheck.</br></br>Default is 'unknown'",
        "Default is 0.5":"Default is 0.5",
        "Maximum video size":"Maximum video size",
        "Maximum video size in megabytes</br></br>Default is 50":"Maximum video size in megabytes</br></br>Default is 50",

        "Minimum text length":"Minimum text length",
        "Recheck category":"Recheck category",
        "Hosts recheck":"Hosts recheck",
        "Dump size for category recheck":"Dump size for category recheck",
        "Amount of threads for category recheck process":"Amount of threads for category recheck process",
        "General":"General",
        "Logs level":"Logs level",
        "Captcha server": "Captcha server",

        "Cluster settings":"Cluster settings",
        "MariaDB Galera Cluster hosts":"MariaDB Galera Cluster hosts",
        "Comma separated IPs or hostsnames":"Comma separated IPs or hostsnames",
        "GlusterFS hosts":"GlusterFS hosts",
        "GlusterFS peer hosts":"GlusterFS peer hosts",
        "Cluster primary host":"Cluster primary host",
        "IP or hostname where data synchronization should be performed":"IP or hostname where data synchronization should be performed",
        "VIP subscriber": "VIP subscriber",
        "Backup settings": "Backup settings",
        "Enable DB backup": "Enable DB backup",
        "Backup DB time interval, hours": "Backup DB time interval, hours",
        "Backup DB save path": "Backup DB save path",
        "Enable FS backup": "Enable FS backup",
        "Backup FS time interval, hours": "Backup FS time interval, hours",
        "Backup FS save path": "Backup FS save path",
        "Default path is": "Default path is",
        "Delete old DB backups interval, hours": "Delete old DB backups interval, hours",
        "0 - don`t delete": "0 - don`t delete",
        "Delete old FS backups interval, hours": "Delete old FS backups interval, hours",
        "Remote server host for storing backups": "Remote server host for storing backups",
        "Remote server port for storing backups": "Remote server port for storing backups",
        "Backup storage username": "Backup storage username",
        "Backup storage password": "Backup storage password",
        "Backup DB remote path": "Backup DB remote path",
        "Backup FS remote path": "Backup FS remote path",
        "Folder should be exist": "Folder should be exist",
        "User should have permissions for this folder": "User should have permissions for this folder",
        "SCP will use public key for user authorization if password does not set!": "SCP will use public key for user authorization if password does not set!",

        "How to receive access token": "How to receive access token",
        "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:qoestor:dictionaries:opencellid:start": "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:qoestor:dictionaries:opencellid",

        "Backup restoration settings": "Backup restoration settings",
        "Enable DB restoration from backup": "Enable DB restoration from backup",
        "DB backup folder": "DB backup folder",
        "Enable FS restoration from backup": "Enable FS restoration from backup",
        "FS backup folder": "FS backup folder",
        "Backup DB time interval, minutes": "Backup DB time interval, minutes",
        "Delete old DB backups interval, minutes": "Delete old DB backups interval, minutes",
        "Backup FS time interval, minutes": "Backup FS time interval, minutes",
        "Delete old FS backups interval, minutes": "Delete old FS backups interval, minutes",
        "Enable DB auto restoration from backup": "Enable DB auto restoration from backup",
        "Enable FS auto restoration from backup": "Enable FS auto restoration from backup",
        "Backup auto restoration settings": "Backup auto restoration settings",

        "Telegram settings": "Telegram settings",
        "Enable telegram bot": "Enable telegram bot",
        "Telegram bot API token": "Telegram bot API token",

        "Language for mailing":"Language for mailing",
        "Language for export files in triggers":"Language for export files in triggers",
        "Enable value formatting for export file in triggers":"Enable value formatting for export file in triggers",
        "Trigger settings": "Trigger settings",
        "Export settings":"Export settings",
            
        "Share usage statistics with VAS Experts": "Share usage statistics with VAS Experts",
        "By enabling this functionality, you help us improve the product. No confidential information is transferred. (enabled by default)": "By enabling this functionality, you help us improve the product. No confidential information is transferred. (enabled by default)",
        "Period of clearing statictics queue logs in days":"Period of clearing statictics queue logs in days",
        "Period of clearing collected statistics logs in days": "Period of clearing collected statistics logs in days",

        "Users actions storage period in days": "Users actions storage period in days",
        "Max page size of QoE query": "Max page size of QoE query",
        "Default page size of QoE query": "Default page size of QoE query",
        "DSCP Protocols backup mode": "DSCP Protocols backup mode",
        "QoE Stor: Raw log aggregation settings": "QoE Stor: Raw log aggregation settings",
        "QoE Stor aggregation time interval in hours": "QoE Stor aggregation time interval in hours",
        "Parallel processing partitions number": "Parallel processing partitions number",

        "BGP server": "BGP server",
        "BGP settings": "BGP settings",
        "Path to export prefix dump": "Path to export prefix dump",
        "Path to env for bgp_watcher": "Path to env for bgp_watcher",
        "BGP dumps loading": "BGP dumps loading",
        "Enable BGP watcher": "Enable BGP watcher",

        "Order of entries in the ipchannels file by network type":"Order of entries in the ipchannels file by network type",
        "Order of entries in the ipchannels file by the number of network hosts":"Order of entries in the ipchannels file by the number of network hosts",
        "in ascending":"in ascending",
        "in descending":"in descending",
        "first":"first",

        "Traffic redirection": "Traffic redirection",
        "Session policings": "Session policings",
        "Place to store user actions logs": "Place to store user actions logs",
        "DB": "DB",
        "Ulr log file": "Ulr log file",
        "Syslog": "Syslog",
        "Place to store ulr logs": "Place to store ulr logs",
        "Place to store interface logs": "Place to store interface logs",

        "Syslog facility of interfaces logs":"Syslog facility of interfaces logs",
        "Syslog facility of user actions logs":"Syslog facility of user actions logs",
        "Syslog facility of ulr logs":"Syslog facility of ulr logs",
        "Add default ports on export white/black lists": "Add default ports on export white/black lists",
        "For each IP or PREFIX the following ports will be added": "For each IP or PREFIX the following ports will be added",
        "System settings": "System settings",
        "Web rules lists": "Web rules lists",
        "System Web rule ID": "System Web rule ID",
        "Chosen Web rule should be exist": "Chosen Web rule should be exist",
        "Web rule can not be deleted": "Web rule can not be deleted",
        "System Web rule resources list file path": "System Web rule resources list file path",
        "File will be loaded from hardware inputed in ULR_BLACK_LIST_DEPLOY_HOST option": "File will be loaded from hardware inputed in ULR_BLACK_LIST_DEPLOY_HOST option",

        "PCAP recording": "PCAP recording",
        "FastPCAP server": "FastPCAP server",
        "Blocking IPv6": "Blocking IPv6",

        "DNS flow": "DNS flow",
        "DNS AGG log settings": "DNS AGG log settings",
        "Subscriber IP": "Subscriber IP",
        "Fields to save when aggregating DNS flow log": "Fields to save when aggregating DNS flow log",
        "DNS port": "DNS port",
        "Subscriber port": "Subscriber port",
        "DNS transport": "DNS transport",
        "DNS host": "DNS host",
        "Time interval for aggregating DNS flow logs": "Time interval for aggregating DNS flow logs",
        "Vchannel numbers": "Vchannel numbers",

        "Hide display of protocol number in exported PDF format":"Hide display of protocol number in exported PDF format",

        "Shards": "Shards",
        "Replicas": "Replicas",
        "Enter the correct IP address,port number, user and password": "Enter the correct IP address,port number, user and password",
        "In each shard, you can set multiple replicas, Use comma to add several items.": "In each shard, you can set multiple replicas, Use comma to add several items.",
        "The replica is set in host/port/user/password format": "The replica is set in host/port/user/password format.",

        "Balancer server": "IPFIX-balancer server",
        "Sync is running. Started at": "Sync is running. Started at",
        "Subscribers is loaded at": "Subscribers is loaded at",
        "Vchannels is loaded at": "Vchannels is loaded at",
        "Subscribers sync is failed. Last started at": "Subscribers sync is failed. Last started at",
        "Vchannels sync is failed. Last started at": "Vchannels sync is failed. Last started at",

        "Autoload AS numbers prefixes dictionary":"Autoload AS numbers prefixes dictionary",
        "Enables autoload of AS numbers prefixes dictionary":"Enables autoload of AS numbers prefixes dictionary",
        "URL for downloading AS numbers prefixes dictionary":"URL for downloading AS numbers prefixes dictionary",
        "Use AS number prefixes in inserts":"Use AS number prefixes in inserts",

        "Spoof DNS": "Spoof DNS",

        "WiKi server": "WiKi Server",
        "FastSig server": "FastSig Server",

        "SSH keys management": "SSH keys management",

        "Balancer taskset": "Balancer core number",
        "This parameter is responsible for determining which core ipfix-balancer is running on.": "This parameter is responsible for determining which core ipfix-balancer is running on.",
        "This parameter is responsible for determining which core QoE Stor is running on.": "This parameter is responsible for determining which core QoE Stor is running on.",
        "Default value is 0.": "Default value is 0.",
        "Default value is -1.": "Default value is -1.",
        "Default value is empty.": "Default value is empty.",

        "BL Revisor server": "BL Revisor server",
        "Export lists to BL Revisor": "Export lists to BL Revisor",
        "Rules for export to BL Revisor": "Rules for export to BL Revisor",
        "Enter a rule ID or a comma separated list of rule IDs": "Enter a rule ID or a comma separated list of rule IDs",
        "Path to save lists in BL Revisor": "Path to save lists in BL Revisor",

        "Set the user to see only their own tasks or also tasks of other users.":"Установите что бы пользователь видел только свои задачи или также задачи других пользователей.",
        "Tasks of all users":"Tasks of all users",
        "Only user tasks":"Only user tasks",
        "Tasks visibility":"Tasks visibility",
        "Tasks management":"Tasks management",
        "Maximum task priority":"Maximum task priority",
        "Run task out of queue":"Run task out of queue",
        "Set whether the user can manage tasks:":"Set whether the user can manage tasks:",
        "enable/disable task":"enable/disable task",
        "edit task":"edit task",
        "copy task":"copy task",
        "delete task":"delete task",
        "Maximum task priority for user task.":"Maximum task priority for user task.",
        "Set whether the user can run tasks out of turn.":"Set whether the user can run tasks out of turn.",
        "QoE table": "QoE table",
        "Settings": "Settings",
        "Filter": "Filter",
        "Should be selected at least 1 column": "Should be selected at least 1 column",
        "Columns": "Columns",
        "Imported resource lifetime, days": "Imported resource lifetime, days",
        "Input correct number": "Input correct number",
        "Requests interval, minutes": "Requests interval, minutes",
        "Minimal interval is 5 minute.": "Minimal interval is 5 minutes.",
        "Error! Can not read import file.": "Error! Can not read import file.",

        "Link to the application. It`s used by scripts for import from QoE resources for custom protocols and web rules.": "Link to the application. It`s used by scripts for import from QoE resources for custom protocols and web rules.",
        "By default is using the APP_URL value": "By default is using the APP_URL value",
        "Import from QoE application URL": "Import from QoE application URL",

        "AAA log settings":"AAA log settings",
        "FILL_IP_LOGIN_BINDING_FROM_AAA_title":"Enable filling IP-LOGIN bind from AAA flow",
        "FILL_IP_LOGIN_BINDING_FROM_AAA_descr":"This parameter enables the creation of a Login-IP dictionary from the AAA data stream.",
        "AAA_REPLACE_LOGIN_IP_LOGIN_BIND_title":"Enables the replacement of the Login field in the raws logs",
        "AAA_REPLACE_LOGIN_IP_LOGIN_BIND_descr":"This parameter enables the replacement of the Login field in the raw fullflow and clickstream logs based on data from AAA. The FILL_IP_LOGIN_BINDING_FROM_AAA parameter must be enabled.",

        "FILL_ACC_STATE_FROM_AAA_title":"Enable AAA states table creation",
        "FILL_ACC_STATE_FROM_AAA_descr":"Enables the creation of a state table from AAA data. This table is required for the subsequent population of UDR tables for fullflow and clickstream.",

        "FILL_UDR_FULLFLOW_title":"Enable fullflow UDR creation",
        "FILL_UDR_FULLFLOW_descr":"Enables the creation of the UDR table based on fullflow. The FILL_ACC_STATE_FROM_AAA parameter must be enabled.",

        "FILL_UDR_CLICKSTREAM_title":"Enable clickstream UDR creation",
        "FILL_UDR_CLICKSTREAM_descr":"Enables the creation of the UDR table based on clickstream. The FILL_ACC_STATE_FROM_AAA parameter must be enabled.",

        "UDR_FULLFLOW_FILTER_title":"Filter for UDR fullflow",
        "UDR_FULLFLOW_FILTER_descr":"When creating UDRs based on fullflow, a filter is available to weed out unnecessary data, for example, by protocol. The filter can only be configured by a specialist by contacting technical support.",

        "UDR_CLICKSTREAM_FILTER_title":"Filter for UDR clickstream",
        "UDR_CLICKSTREAM_FILTER_descr":"When creating UDRs based on clickstream, a filter is available to weed out unnecessary data, for example, by protocol. The filter can only be configured by a specialist by contacting technical support.",

        "UDR_SCP_title":"SCP server",
        "UDR_SCP_descr":"Server in login@host format. If this parameter is specified, all created UDRs will be sent via SCP to the specified server. To enable sending, key-based authentication must be pre-configured on the remote server.",

        "UDR_SCP_PORT_title":"SCP server port",
        "UDR_SCP_PORT_descr":"The port of the remote server. Default is 22.",

        "UDR_FULLFLOW_FORMAT_title":"UDR fullflow files format",
        "UDR_FULLFLOW_FORMAT_descr":"The format of the final UDR files.",

        "UDR_CLICKSTREAM_FORMAT_title":"UDR clickstream files format",
        "UDR_CLICKSTREAM_FORMAT_descr":"The format of the final UDR files.",

        "UDR_FULLFLOW_DIST_MODE_title":"Enable cluster-based UDR generation mode for fullflow.",
        "UDR_FULLFLOW_DIST_MODE_descr":"In this mode, the final UDRs are generated by executing a distributed query that aggregates data from all cluster nodes.",
        "UDR_CLICKSTREAM_DIST_MODE_title":"Enable cluster-based UDR generation mode for clickstream.",
        "UDR_CLICKSTREAM_DIST_MODE_descr":"In this mode, the final UDRs are generated by executing a distributed query that aggregates data from all cluster nodes.",

        "UDR_FULLFLOW_TIME_INTERVAL_title":"UDR fullflow interval",
        "UDR_CLICKSTREAM_TIME_INTERVAL_title":"UDR clickstream interval",
        "UDR_FULLFLOW_TIME_INTERVAL_descr":"The time period over which data is aggregated for UDR fullflow. The default is 15 minutes.",
        "UDR_CLICKSTREAM_TIME_INTERVAL_descr":"The time period over which data is aggregated for UDR clickstream. The default is 15 minutes.",

        "UDR_FULLFLOW_PERIOD_FROM_title":"UDR fullflow export time range From",
        "UDR_FULLFLOW_PERIOD_TO_title":"UDR fullflow export time range To",
        "UDR_CLICKSTREAM_PERIOD_FROM_title":"UDR clickstream export time range From",
        "UDR_CLICKSTREAM_PERIOD_TO_title":"UDR clickstream export time range To",

        "UDR_PERIOD_descr":"Specify the time period for which to export UDR records.<br/><br/>Start Time (From): now()-30*60 (default: 30 minutes ago)<br/>End Time (To): now()-15*60 (default: 15 minutes ago)<br/>",

        "DDoS attack log settings":"DDoS attack log settings",
        "Time interval for aggregating DDoS attack logs":"Time interval for aggregating DDoS attack logs",
        "Fields to save when aggregating DDoS attack log":"Fields to save when aggregating DDoS attack log",
        "Automatic update of the geodata dictionary":"Automatic update of the geodata dictionary",
        "UDR_FULLFLOW_DATE_TIME_FORMAT_title":"UDR fullflow export date time format",
        "UDR_CLICKSTREAM_DATE_TIME_FORMAT_title":"UDR clickstream export date time format",
        "UDR_DATE_TIME_FORMAT_descr":"Timestamp is default format. <br/>You can set any other format, for example - %Y%m%d%H%i%S"
    };

webix.i18n.locales["en-US"].dpiui2.Roles =
    {
        "Are you sure you want to delete the role?":"Are you sure you want to delete the role?",

        "Roles":"Roles",
        "Add role":"Add role",

        "Role":"Role",

        "Program sections":"Program sections",
        "Code":"Code",
        "Section":"Section",
        "Read":"Read",
        "Record":"Record"
    };

webix.i18n.locales["en-US"].dpiui2.Users =
    {
        "Are you sure you want to delete the user?":"Are you sure you want to delete the user?",
        "User name":"User name",
        "Enter user name":"Enter user name",
        "Full name":"Full name",
        "Enter full name":"Enter full name",
        "Enter e-mail":"Enter e-mail",
        "Phone":"Phone",
        "Enter phone number":"Enter phone number",
        "Company":"Company",
        "Enter the name of the organization":"Enter the name of the organization",
        "Position":"Position",
        "Enter the position":"Enter the position",
        "Role":"Role",

        "Passwords do not match":"Passwords do not match",

        "New password":"New password",
        "Enter password":"Enter password",
        "Confirm password":"Confirm password",

        "Add user":"Add user",
        "Users":"Users"
    };

webix.i18n.locales["en-US"].dpiui2.UsersActionsLog =
    {
        "Users actions log":"Users actions log",
        "Row id":"Row id",
        "Hardware name":"Hardware",
        "Section":"Section",
        "Action":"Action",
        "Differences":"Differences",
        "Old value":"Old value",
        "New value":"New value",
        "Create time":"Create time",
        "Update time":"Update time",
        "Create user":"Create user",
        "Update user":"Update user",
        "Configuration DPI":"Configuration DPI",
        "Configuration QoE":"Configuration QoE",
        "Configuration GUI":"Configuration GUI",
        "Configuration Balancer": "Configuration Balancer",
        "Tariff plans":"Tariff plans",
        "Protocol prioritization": "Protocol prioritization",
        "Priority for ASN": "Priority for ASN",
        "Start":"Start",
        "Stop":"Stop",
        "Create":"Create",
        "Edit":"Edit",
        "Delete":"Delete",
        "Restart Queue":"Restart Queue",
        "Updating hot options":"Updating hot options",
        "Tariff name":"Tariff name",
        "Tariff type":"Tariff type",
        "Status":"Status",
        "Profile":"Profile",
        "Personal":"Personal",
        "Schedule":"Schedule",
        "Enabled":"Enabled",
        "Disabled":"Disabled",
        "Configuration changes":"Configuration changes",
        "Current configuration":"Current configuration",
        "Tariff schedule changes":"Tariff schedule changes",
        "Schedule Disabled":"Disabled",
        "Schedule Enabled":"Enabled",
        "IPv4 and AS changes":"IPv4 and AS changes",
        "IPv6 and AS changes":"IPv6 and AS changes",
        "AS and DSCP changes":"AS and DSCP changes",

        // Black and white lists
        "Black and white lists":"Black and white lists",
        "List name":"List name",
        "List type":"List type",
        "Black list":"Black list",
        "White list":"White list",
        "URL to redirect":"URL to redirect",
        "Use federal":"Use federal",
        "Federal Enabled":"Enabled",
        "Federal Disabled":"Disabled",
        "Synchronization status":"Synchronization status",
        "Synchronization changes":"Synchronization changes",
        "Synchronization period in hours":"Synchronization period in hours",
        "Resources list changes":"Resources list changes",
        "Category":"Category",
        "Resources limit":"Resources limit",
        "Type":"Type",
        "Resource":"Resource",
        "deleted over":"deleted over",
        "resources":"resources",

            // Subscribers
        "Subscribers L2-props deleted":"Subscribers L2-props deleted",
        "Subscribers L2-props edited":"Subscribers L2-props edited",
        "Could not determine the specified service": "Could not determine the specified service",
        "Could not determine the specified profile": "Could not determine the specified profile",
        "Failed to determine the set tariff": "Failed to determine the set tariff",
        "Subscriber changes": "Subscriber changes",
        "Auth status": "Auth status",
        "Auth expired": "Expire At",
        "Policing": "Tariff",
        "Services profiles": "Services profiles",
        "Subscribers auth cleared":"Subscribers auth cleared",
        "Subscribers auth changed":"Subscribers auth changed",
        "All subscribers":"All subscribers",
        "Session type": "Session type",
        "Session status": "Session status",
        "MAC address": "MAC address",
        "VLAN or QinQ": "VLAN or QinQ",
        "in_dev interface index": "in_dev interface index",
        "Expiration time": "Expiration time",
        "Output MAC address": "Output MAC address",
        "Output VLAN=NN": "Output VLAN=NN",
        "Disable local connect for subscriber": "Disable local connect for subscriber",
        "'route via' property": "'route via' property",
        "IPv4 subnet mask": "IPv4 subnet mask",
        "Opt82 CircuitId": "Opt82 CircuitId",
        "Opt82 RemoteId": "Opt82 RemoteId",
        "Bind type": "Bind type",

        "Column": "Column",
        "Login":"Login",
        "Logout":"Logout",

        "Search":"Search",
        "Interface":"Interface",
        "Navigation":"Navigation",
        "Viewing the report":"Viewing the report",
        "Creating report cache":"Creating report cache",
        "Export report":"Export report",

        "Receivers restarted":"Receivers restarted",
        "Receivers stopped":"Receivers stopped"
    };

webix.i18n.locales["en-US"].dpiui2.DpiInfo =
    {
        "Device information":"Device information",
        "Property":"Property",
        "Value":"Value"
    };

webix.i18n.locales["en-US"].dpiui2.Hardwares =
    {
        "Do you really want to delete the equipment?":"Do you really want to delete the equipment?",
        "Name":"Name",
        "Enter the title":"Enter the title",
        "Host":"Host",
        "Enter Ip":"Enter Ip-address or host",
        "Port":"Port",
        "Enter Port":"Enter Port",
        "Login":"Login",
        "Enter login":"Enter login",
        "Password":"Password",
        "Enter password":"Enter password",
        "Sudo user":"Sudo user",
        "Enable sync":"Enable sync",
        "Type":"Type",
        "Hardware type": "Hardware type",
        "Enter hardware type": "Enter hardware type",

        "Hardware Management":"Hardware Management",
        "Equipment":"Equipment",
        "Add equipment":"Add equipment",

        "Hardware settings":"Hardware settings",
        "Ipfix settings":"IPFIX settings",
        "Id on ipfix collector":"Id on IPFIX collector",
        "IPFIX ID":"IPFIX ID",

        "Enable subscribers sync":"Enable subscribers sync",
        "Enable logs sync":"Enable logs sync",
        "Enable CGNAT sync":"Enable CGNAT sync",

        "Synchronization settings":"Synchronization settings",
        "Enable subscribers auth status sync": "Enable subscribers auth status sync",

        "ID":"ID",
        "Version": "Version",
        "Sync tool version": "Sync tool version",
        "Do you really want to sync tool version for the equipment?": "Do you really want to sync tool version for the equipment?",
        "Sync": "Sync",
        "Tool version successfully synced": "Tool version successfully synced",
        "Ssh connection": "Ssh connection",
        "Scp command": "Scp command",
        "File sending": "File sending",
        "Internet connection": "Internet connection",
        "Property": "Property",
        "State": "State",
        "Hardware state": "Hardware state",
        "Auth type": "Auth type",
        "By password": "By password",
        "By key": "By key",

        "SUDO_USER_HELP_POPUP": "Creating a sudo user to connect to the hardware - <a href='https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:dpiui:user_guide:admin_section:equipment_management:sudo_user' target='_blank'>article</a>."
    };

webix.i18n.locales["en-US"].dpiui2.DpiLogs =
    {
        "Log of information messages and errors":"Log of information messages and errors",
        "Statistics log":"Statistics log",
        "Message log loaded":"Message log loaded",
        "Statistics log loaded":"Statistics log loaded"
    };

webix.i18n.locales["en-US"].dpiui2.HardwareLogs =
    {
        "Files":"Files",
        "File":"File",
        "Log file content":"Log file content",
        "Search (Grep)": "Search (Grep)",
        "FastDPI > FastPCRF interaction":"FastDPI > FastPCRF interaction",
        "Requests and answers to Radius servers":"Requests and answers to Radius servers",
        "Accounting":"Accounting",
        "FastPCRF > FastDPI interaction":"FastPCRF > FastDPI interaction",
        "Network interfaces status and services":"Network interfaces status and services",
        "Network interfaces status":"Network interfaces status",
        "BRAS DHCP logs (none-default)":"BRAS DHCP logs (none-default)",
        "Lines":"Lines",
        "Lines before and after the match":"Lines before and after the match"
    };

webix.i18n.locales["en-US"].dpiui2.Notifications =
    {
        "Read selection":"Read selection",
        "Delete selection":"Delete selection",
        "Messages":"Messages",
        "Message":"Message",
        "Read":"Read",
        "Equipment":"Equipment",
        "Importance":"Importance",
        "Are you sure you want to delete the selected records?": "Are you sure you want to delete the selected records?",
        "Are you sure you want to delete all the records?": "Are you sure you want to delete all the records?",
        "Read notifications": "Read notifications",
        "Read selected": "Read selected",
        "Read all": "Read all",
        "Delete notifications": "Delete notifications",
        "Delete selected": "Delete selected",
        "Delete all": "Delete all"
    };

webix.i18n.locales["en-US"].dpiui2.CreateTicket =
    {
        "Send a message":"Send a message",
        "Message subject":"Message subject",
        "Message text":"Message text",
        "Enter here any text":"Enter here any text",
        "DPI message Log":"DPI message Log",
        "Log of information messages and errors":"Log of information messages and errors",
        "DPI statistics log":"DPI statistics log",
        "UI log":"UI log",
        "Send":"Send",
        "Message sent successfully":"Message sent successfully",
        "Protocol":"Protocol",
        "Additional email":"Additional email"
    };

webix.i18n.locales["en-US"].dpiui2.Advc = {
    "Profile saved": "Profile saved",
    "Group saved":"Group saved",
    "Deleted": "Deleted",
    "Add new adv profile": "Add new adv profile",
    "Add new adv group":"Add new adv group",
    "Add adv sub profile": "Add adv sub profile",
    "Add adv sub griup": "Add adv sub group",
    "Company saved": "Company saved",
    "Profile": "Profile",
    "Group":"Group",
    "Cancel": "Cancel",
    "Save": "Save",
    "Delete": "Delete",
    "Are you sure you want to delete this profile? All advertising campaigns associated with this profile will be deleted.": "Are you sure you want to delete this profile? All advertising campaigns associated with this profile will be deleted.",
    "Are you sure you want to delete this group? All advertising campaigns associated with this group will be deleted.": "Are you sure you want to delete this group? All advertising campaigns associated with this group will be deleted.",
    "Title": "Title",
    "Hardware group": "Hardware group",
    "Responsible": "Responsible",
    "Company Dates / Time": "Company Dates / Time",
    "Days of the week": "Days of the week",
    "Bundle": "Bundle",
    "Total": "Total",
    "Redirect URL": "Redirect URL",
    "Are you sure you want to delete this company?": "Are you sure you want to delete this campaign?",
    "Service Management": "Service Management",
    "Advertising": "Advertising",
    "Profiles": "Profiles",
    "Groups": "Groups",
    "Add a lock to the list": "Add a lock to the list",
    "Campaigns": "Campaigns",
    "Campaign": "Campaign",
    "Period": "Period",
    "Status": "Status",
    "Done": "Done",
    "Campaign settings": "Campaign settings",
    "Campaign data": "Campaign data",
    "Add new campaign data": "Add new campaign data",
    "Data name": "Data name",
    "Data type": "Data type",
    "Default value": "Default value",
    "Are you sure you want to delete this subscriber from campaign?":"Are you sure you want to delete this subscriber from campaign?",
    "String": "String",
    "Enumeration": "Enumeration",
    "Import campaign data from file": "Import campaign data from file",
    "Add campaign data": "Add campaign data",
    "Click to download or drag a file": "Click to download or drag a file",
    "Import":"Import",
    "Campaign data saved": "Campaign data saved",
    "Add campaign": "Add campaign",
    "Subscriber": "Subscriber",
    "Notification date": "Notification date",
    "Profiles and campaigns": "Profiles and campaigns",
    "Groups and campaigns": "Group and campaigns",
    "Campaign subscribers": "Campaign subscribers",
    "Campaign period": "Campaign period",
    "Campaign time": "Campaign time",
    "Title can not be empty": "Title can not be empty",
    "Date of campaign should be filled": "Date of campaign should be filled",
    "Should be selected at least one day of week": "Should be selected at least one day of week",
    "Bundle should be a number": "Bundle should be a number",
    "Input correct URL address": "Input correct URL address",
    "Subscriber should be filled!": "Subscriber should be filled!",
    "Time from": "Time from",
    "Campaign show time": "Campaign show time",
    "Time to": "Time to",
    "Required field" : "Required field",
    "Campaign finish time should be filled": "Campaign finish time should be filled",
    "Campaign title": "Campaign title",
    "User responsible for the campaign": "User responsible for the campaign",
    "Dates of the advertising campaign": "Dates of the advertising campaign",
    "Days of the advertising campaign": "Days of the advertising campaign",
    "Select or create new profile":"Select or create new profile",
    "Select or create new group":"Select or create new group",
    "Select or enter new profile name":"Select or enter new profile name",
    "Select or enter new group name":"Select or enter new group name",
    "Campaign profile":"Campaign profile",
    "Campaign group":"Campaign group",
    "A new profile and campaign will be created. Continue?":"A new profile and campaign will be created. Continue?",
    "A new group and campaign will be created. Continue?":"A new group and campaign will be created. Continue?",
    "Select or create new campaign":"Select or create new campaign",
    "Select or enter new campaign name":"Select or enter new campaign name",
    "A new campaign will be created. Continue?":"A new campaign will be created. Continue?",
    "How to export subscribers":"How to export subscribers",
    "By IP-address":"By IP-address",
    "By login":"By login",
    "By IP-address if login is empty":"By IP-address if login is empty",
    "The task of importing successfully launched":"The task of importing successfully launched",
    "Start campaign": "Start campaign",
    "Stop campaign": "Stop campaign",
    "Enable": "Enable",
    "Enable campaign after saving?": "Enable campaign after saving?",
    "Campaign enabled": "Campaign enabled",
    "Campaign disabled": "Campaign disabled",
    "Number of subscribers":"Number of subscribers",
    "All subscribers":"All subscribers",
    "% subscribers":"% subscribers",
    "Campaign deleted": "Campaign deleted",
    "Campaign state": "Campaign state",
    "Get template" : "Get template",
    "Download the subscirbers file":"Download the subscirbers file",
    "Campaign show time (DPI local time)":"Campaign show time (DPI local time)",
    "Forced campaign synchronization": "Forced campaign synchronization",
    "Forced synchronization campaigns running in the background": "Forced synchronization campaigns running in the background",
    "Restart campaign for subscriber": "Restart campaign for subscriber",
    "Campaign restarted": "Campaign restarted",
    "Restart campaign": "Restart campaign"
};

webix.i18n.locales["en-US"].dpiui2.QoE =
    {
        "Map reports": "Map reports",
        "Success": "Success",
        "Service and tracking": "Service and tracking",
        "Subscribers location": "Subscribers location",
        "Subscribers routes": "Subscribers routes",
        "Top hosts":"Top hosts",
        "Top AS":"Top AS",
        "Top subscriber`s AS":"Top subscriber`s AS",
        "Top subscribers":"Top subscribers",
        "Top devices":"Top devices",
        "Top protocols":"Top protocols",
        "Top application protocols":"Top application protocols",
        "Top application protocols with high traffic":"Top application protocols with high traffic",
        "Top application protocols with high traffic volume":"Top application protocols with high traffic volume",
        "Top application protocols with high RTT":"Top application protocols with high RTT",
        "Top switches":"Top switches",
        "Top trunk switches":"Top trunk switches",
        "Traffic by protocols":"Traffic by protocols",
        "Traffic by application protocols":"Traffic by application protocols",
        "Traffic by AS":"Traffic by AS",
        "Traffic by subscriber`s AS":"Traffic by subscriber`s AS",
        "Flow by protocols":"Flow by protocols",
        "Flow by application protocols":"Flow by application protocols",
        "Top hosts IPs":"Top hosts IPs",
        "RTT by time":"RTT by time",
        "RTT from subscriber":"RTT from subscriber",
        "RTT to subscriber":"RTT to subscriber",
        "RTT median":"RTT median",
        "RTT distribution":"RTT distribution",
        "RTT distribution from subscriber":"RTT distribution from subscriber",
        "RTT distribution to subscriber":"RTT distribution to subscriber",
        "Top subscribers with high RTT":"Top subscribers with high RTT",
        "Top subscribers with high traffic":"Top subscribers with high traffic",
        "Top subscribers with high retransmits":"Top subscribers with high retransmits",
        "Top protocols with high RTT":"Top protocols with high RTT",
        "Top protocols with high traffic":"Top protocols with high traffic",
        "Top protocols with high flow":"Top protocols with high flow",
        "Top application protocols with high retransmits":"Top application protocols with high retransmits",
        "Top application protocols with high flow":"Top application protocols with high flow",
        "Top hosts with high RTT":"Top hosts with high RTT",
        "Top hosts with high traffic":"Top hosts with high traffic",
        "Top hosts with high traffic volume":"Top hosts with high traffic volume",
        "Top hosts with high retransmits":"Top hosts with high retransmits",
        "Top host categories with high RTT":"Top host categories with high RTT",
        "Top host categories with high traffic":"Top host categories with high traffic",
        "Top host categories with high retransmits":"Top host categories with high retransmits",
        "Top AS with high RTT":"Top AS with high RTT",
        "Top subscriber`s AS with high RTT":"Top subscriber`s AS with high RTT",
        "Top AS with high traffic":"Top AS with high traffic",
        "Top subscriber`s AS with high traffic":"Top subscriber`s AS with high traffic",
        "Top AS with high retransmits":"Top AS with high retransmits",
        "Top subscriber`s AS with high retransmits":"Top subscriber`s AS with high retransmits",
        "Top switches with high RTT":"Top switches with high RTT",
        "Top trunk switches with high RTT":"Top trunk switches with high RTT",
        "Retransmits by time":"Retransmits by time",
        "Top with high traffic":"Top with high traffic",
        "Top with high RTT":"Top with high RTT",
        "Top with high retransmits":"Top with high retransmits",
        "Applications & subscribers":"Applications & subscribers",
        "Top applications by subscribers":"Top applications by subscribers",
        "Top applications by growth rate":"Top applications by growth rate",
        "Top applications protocols by subscribers":"Top applications protocols by subscribers",
        "Top applications protocols groups by subscribers":"Top applications protocols groups by subscribers",
        "Top applications protocols by growth rate":"Top applications protocols by growth rate",
        "Top applications protocols groups by growth rate":"Top applications protocols groups by growth rate",
        "Top subscribers by applications":"Top subscribers by applications",
        "Top logins by applications":"Top logins by applications",
        "Top protocol":"Top protocol",
        "Top group":"Top group",
        "Application protocol groups":"Application protocol groups",
        "Mini":"Mini",
        "Top":"Top",
        "Reports":"Reports",
        "with high RTT":"with high RTT",
        "with high traffic":"with high traffic",
        "with high retransmits":"with high retransmits",
        "Group":"Group",

        "Total":"Total",
        "Sessions":"Sessions",
        "Hosts":"Hosts",
        "Subscribers":"Subscribers",
        "Subscriber":"Subscriber",
        "Login":"Login",
        "Host":"Host",
        "User agents":"User agents",
        "Top user agents":"Top user agents",
        "User agent":"User agent",
        "Agents":"Agents",
        "Agents number":"Agents number",
        "Devices":"Devices",
        "Device":"Device",
        "Protocol":"Protocol",
        "Host IP":"Host IP",
        "Hosts IPs":"Hosts IPs",
        "Subscriber devices":"Subscriber devices",
        "Devices number":"Devices number",
        "Details":"Details",
        "Application protocol":"Application protocol",
        "Hosts number":"Hosts number",
        "Host IPs number":"Host IPs number",
        "Retransmits":"Retransmits",
        "Retransmits from subscriber":"Retransmits from subscriber",
        "Retransmits to subscriber":"Retransmits to subscriber",
        "Fragments":"Fragments",
        "Protocols":"Protocols",
        "Application protocols":"Application protocols",
        "Connections":"Connections",
        "Totals":"Totals",
        "Url":"Url",
        "Top URLs":"Top URLs",
        "URLs":"URLs",
        "Subscribers growth rate":"Subscribers growth rate",
        "Logins growth rate":"Logins growth rate",

        "QoE threats monitor Widget (Netfow)": "QoE threats monitor Widget (Netfow)",
        "QoE threats monitor Widget (Cleakstream)": "QoE threats monitor Widget (Cleakstream)",

        "Malicious traffic": "Malicious traffic",
        "Botnet traffic": "Botnet traffic",
        "Phishing traffic": "Phishing traffic",
        "IoT traffic": "IoT traffic",

        "Infected subscribers": "Infected subscribers",

        "Subscribers with malicious traffic": "Subscribers with malicious traffic",
        "Subscribers with botnet traffic": "Subscribers with botnet traffic",
        "Subscribers with phishing traffic": "Subscribers with phishing traffic",
        "Subscribers with IoT traffic": "Subscribers with iot traffic",

        "Top infected subscribers":"Top infected subscribers",
        "Top infected subscribers with malicious traffic":"Top infected subscribers with malicious traffic",
        "Top infected subscribers with botnet traffic":"Top infected subscribers with botnet botnet",
        "Top infected subscribers with phishing traffic":"Top infected subscribers with phishing botnet",

        "Top infected subscribers (Netflow)":"Top infected subscribers (Netflow)",
        "Top infected subscribers with malicious traffic (Netflow)":"Top infected subscribers with malicious traffic (Netflow)",
        "Top infected subscribers with botnet traffic (Netflow)":"Top infected subscribers with botnet botnet (Netflow)",
        "Top infected subscribers with phishing traffic (Netflow)":"Top infected subscribers with phishing botnet (Netflow)",

        "Top infected subscribers (Clickstream)":"Top infected subscribers (Clickstream)",
        "Top infected subscribers with malicious traffic (Clickstream)":"Top infected subscribers with malicious traffic (Clickstream)",
        "Top infected subscribers with botnet traffic (Clickstream)":"Top infected subscribers with botnet botnet (Clickstream)",
        "Top infected subscribers with phishing traffic (Clickstream)":"Top infected subscribers with phishing botnet (Clickstream)",

        "Infected traffic category":"Infected traffic category",

        "Subscribers with undefined RTT":"Subscribers with undefined RTT",
        "Subscribers with big RTT":"Subscribers with big RTT",
        "Subscribers with medium RTT":"Subscribers with medium RTT",
        "Subscribers with small RTT":"Subscribers with small RTT",

        "Widgets, drag from here":"Widgets, drag from here",
        "Subscribers RTT":"Subscribers RTT",
        "Traffic":"Traffic speed",
        "Traffic from subscriber":"Traffic speed from subscriber",
        "Traffic from subscribers":"Traffic speed from subscribers",
        "Traffic to subscribers":"Traffic speed to subscribers",
        "Traffic to subscriber":"Traffic speed to subscriber",
        "Flow":"Flow",
        "Flow from subscriber":"Flow from subscriber",
        "Flow to subscriber":"Flow to subscriber",
        "Flow from subscribers":"Flow from subscribers",
        "Flow to subscribers":"Flow to subscribers",
        "Traffic volume":"Traffic volume",
        "Traffic volume from subscriber":"Traffic volume from subscriber",
        "Traffic volume from subscribers":"Traffic volume from subscribers",
        "Traffic volume to subscribers":"Traffic volume to subscribers",
        "Traffic volume to subscriber":"Traffic volume to subscriber",
        "Flow volume":"Flow volume",
        "Flow volume from subscriber":"Flow volume from subscriber",
        "Flow volume from subscribers":"Flow volume from subscribers",
        "Flow volume to subscriber":"Flow volume to subscriber",
        "Flow volume to subscribers":"Flow volume to subscribers",

        "For all DPI devices":"For all DPI devices",
        "Current DPI device":"Current DPI device",

        "Group by":"Group by",
        "By subscribers":"By subscribers",
        "By switches":"By switches",
        "By access switch":"By access switch",
        "By trunk switch":"By trunk switch",
        "By owner":"By owner",
        "By name":"By name",
        "By type":"By type",
        "By region":"By region",
        "By address":"By address",
        "By operator":"By operator",
        "By IP-address":"By IP-address",
        "By login":"By login",
        "By unit vendor":"By unit vendor",
        "By cabel":"By cabel",
        "By contract":"By contract",
        "By services":"By services",
        "Unit vendor":"Unit vendor",
        "Cabel":"Cabel",
        "Contract":"Contract",
        "Services":"Services",
        "Switch IP-address":"Switch IP-address",
        "Switch name":"Switch name",
        "Switch type":"Switch type",
        "Region":"Region",
        "Switch address":"Switch address",
        "Operator":"Operator",
        "Owner":"Owner",

        "By AS":"By AS",
        "By AS number":"By AS number",
        "By AS title":"By AS title",
        "AS number":"AS number",
        "AS title":"AS title",
        "Source AS number":"Source AS number",
        "Destination AS number":"Destination AS number",
        "By GTP cells":"By GTP cells",

        "Waiting queue":"Waiting queue",
        "Processing":"Processing",
        "Read rows":"Read rows",
        "Read bytes":"Read bytes",
        "Total rows":"Total rows",

        "Clear cache":"Clear cache",
        "Cache cleared":"Cache cleared",

        "We can`t process export to PDF when page size is more then 100":"We can`t process export to PDF when page size is more then 100",

        "Clickstream raw log":"Clickstream raw log",
        "Source IPv4-address":"Source IPv4-address",
        "Source IPv6-address":"Source IPv6-address",
        "Source port":"Source port",
        "Destination IPv4-address":"Destination IPv4-address",
        "Destination IPv6-address":"Destination IPv6-address",
        "Destination port":"Destination port",
        "Path":"Path",
        "Referer":"Referer",
        "Cookie":"Cookie",
        "Session ID":"Session ID",
        "Method":"Method",
        "Result code":"Result code",
        "Content length":"Content length",
        "Content type":"Content type",

        "Netflow raw log":"Netflow raw log",
        "Flow start time":"Flow start time",
        "Flow start time in milliseconds":"Flow start time in milliseconds",
        "Flow end time":"Flow end time",
        "Flow end time in milliseconds":"Flow end time in milliseconds",
        "Source AS":"Source AS",
        "Destination AS":"Destination AS",
        "Octet delta":"Octet delta",
        "Packet delta":"Packet delta",
        "Net protocol":"Net protocol",
        "Service class":"Service class",
        "Input SNMP":"Reciever IP-interface index",
        "Output SNMP":"Sender IP-interface index",
        "IP version":"IP version",
        "Post nat source IPv4-address":"Post nat source IPv4-address",
        "Post nat source port":"Post nat source port",
        "Fragmented packets delta":"Fragmented packets delta",
        "Repeated packets delta":"Repeated packets delta",
        "Time":"Time",

        "Spline area":"Spline area",
        "Area":"Area",
        "Stacked area":"Stacked area",
        "Line":"Line",
        "Stacked bar chart":"Stacked bar chart",

        "Linear":"Linear",
        "Logarithmic":"Logarithmic",

        "Top host categories":"Top host categories",
        "Host categories":"Host categories",
        "Host category":"Host category",

        "hcn_undefined":"Undefined",
        "hcn_unknown":"Unknown",
        "hcn_software_tools":"Software tools",
        "hcn_search_engine":"Search engine",
        "hcn_0_other":"Other",
        "hcn_school":"School",
        "hcn_proxys":"Proxies",
        "hcn_tabak_alkohol":"Tobacco, alcohol",
        "hcn_religia":"Religion",
        "hcn_0_bad_gateway":"Bad gateway (HTTP 502)",
        "hcn_porno_sex":"Porn, sex",
        "hcn_nenormativ_lexika":"Profanity",
        "hcn_0_forbidden":"Forbidden (HTTP 403)",
        "hcn_music_sites":"Music sites",
        "hcn_game_sites":"Gaming sites",
        "hcn_video_hostings":"Video hostings",
        "hcn_file_archives":"File archives",
        "hcn_social_networks":"Social networks",
        "hcn_im":"Instant messaging",
        "hcn_dosug_cafe_kino_restorans":"Leisure, cafe, cinema, restaurants",
        "hcn_goverment":"Government",
        "hcn_organizations":"Organizations",
        "hcn_telecom_operators":"Telecom operators",
        "hcn_shops":"Shops",
        "hcn_forums_18+":"Forums 18+",
        "hcn_bank_finances":"Banking, finance",
        "hcn_museum":"Museums",
        "hcn_medicina_hostitals":"Medicine, hospitals",
        "hcn_miners_pools_curs_etc":"Miners, pools, currency, etc.",
        "hcn_humor_anectdots":"Humor, jokes",
        "hcn_job_hunters":"Job, hunters",
        "hcn_military":"Military",
        "hcn_news":"News",
        "hcn_child_sites":"Child sites",
        "hcn_tech_inteface":"Tech inteface",
        "hcn_ads":"Ads",
        "hcn_blog":"Blogs",
        "hcn_coocking":"Cooking",
        "hcn_metrics":"Metrics",
        "hcn_forex":"Forex",
        "hcn_cdn":"Cdn",
        "hcn_personal":"Personal",
        "hcn_antivirus":"Antivirus",
        "hcn_education":"Education",
        "hcn_gambling":"Gambling",
        "hcn_drugs":"Drugs",
        "hcn_building":"Building",
        "hcn_malware":"Malware",
        "hcn_blocked":"Blocked",
        "hcn_classified":"Classified",
        "hcn_magazins":"Magazins",
        "hcn_sport":"Sport",
        "hcn_turism":"Turism",
        "hcn_auto":"Auto",
        "hcn_relocation":"Relocation",
        "hcn_realestate":"Realestate",
        "hcn_mail":"Mail",
        "hcn_telecom_operators, call-centre":"Telecom operators, Call-Centre",

        "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].":"QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].",

        "Start":"Start",
        "End":"End",
        "Custom range":"Custom range",
        "Quick ranges":"Quick ranges",

        "Last 5 minutes":"Last 5 minutes",
        "Last 15 minutes":"Last 15 minutes",
        "Last 30 minutes":"Last 30 minutes",

        "This hour":"This hour",
        "This hour so far":"This hour so far",
        "This 2 hours":"This 2 hours",
        "This 2 hours so far":"This 2 hours so far",
        "This 3 hours":"This 3 hours",
        "This 3 hours so far":"This 3 hours so far",

        "Last 1 hour":"Last 1 hour",
        "Last 2 hours":"Last 2 hours",
        "Last 3 hours":"Last 3 hours",
        "Last 4 hours":"Last 4 hours",
        "Last 5 hours":"Last 5 hours",
        "Last 6 hours":"Last 6 hours",
        "Last 12 hours":"Last 12 hours",
        "Last 24 hours":"Last 24 hours",


        "Last 2 days":"Last 2 days",
        "Last 3 days":"Last 3 days",
        "Last 4 days":"Last 4 days",
        "Last 5 days":"Last 5 days",
        "Last 6 days":"Last 6 days",
        "Last 7 days":"Last 7 days",
        "Last 15 days":"Last 15 days",
        "Last 30 days":"Last 30 days",
        "Last 90 days":"Last 90 days",
        "Last 6 months":"Last 6 months",
        "Last 1 year":"Last 1 year",
        "Last 2 years":"Last 2 years",
        "Last 5 years":"Last 5 years",

        "Yesterday":"Yesterday",
        "Day before yesterday":"Day before yesterday",
        "This day last week":"This day last week",
        "Previous week":"Previous week",
        "Previous month":"Previous month",
        "Previous year":"Previous year",

        "Today":"Today",
        "Today so far":"Today so far",
        "This week":"This week",
        "This week so far":"This week so far",
        "This month":"This month",
        "This month so far":"This month so far",
        "This year":"This year",
        "This year so far":"This year so far",

        "now":"now",
        "now - 1 minute":"now - 1 minute",
        "now - 5 minutes":"now - 5 minutes",
        "now - 10 minutes":"now - 10 minutes",
        "now - 15 minutes":"now - 15 minutes",
        "now - 20 minutes": "now - 20 minutes",
        "now - 30 minutes":"now - 30 minutes",
        "now - 45 minutes":"now - 45 minutes",

        "now - 1 hour":"now - 1 hour",
        "now - 2 hours":"now - 2 hours",
        "now - 3 hours":"now - 3 hours",
        "now - 4 hours":"now - 4 hours",
        "now - 5 hours":"now - 5 hours",
        "now - 6 hours":"now - 6 hours",
        "now - 12 hours":"now - 12 hours",
        "now - 24 hours":"now - 24 hours",

        "now - 2 days":"now - 2 days",
        "now - 3 days":"now - 3 days",
        "now - 4 days":"now - 4 days",
        "now - 5 days":"now - 5 days",
        "now - 6 days":"now - 6 days",
        "now - 7 days":"now - 7 days",
        "now - 15 days":"now - 15 days",
        "now - 30 days":"now - 30 days",
        "now - 90 days":"now - 90 days",
        "now - 6 months":"now - 6 months",
        "now - 1 year":"now - 1 year",
        "now - 2 years":"now - 2 years",
        "now - 5 years":"now - 5 years",

        "Tablespace info":"Tablespace info",
        "Table":"Table",
        "Min partition":"Min partition",
        "Max partition":"Max partition",
        "On disk":"On disk",
        "Partitions info":"Partitions info",
        "Partition":"Partition",
        "Delete partitions":"Delete partitions",

        "Panels":"Panels",
        "Series charts":"Series charts",
        "Pie charts":"Pie charts",
        "Tables":"Tables",

        "Dictionaries info":"Dictionaries info",
        "Name":"Name",
        "Origin":"Origin",
        "Source":"Source",
        "Count":"Count",
        "Creation time":"Creation time",
        "Last exception":"Last exception",

        "Id":"Id",
        "Description":"Description",
        "Hardware ID":"Hardware ID",
        "Hardware port":"Hardware port",
        "CRC value":"CRC value",
        "Value":"Value",
        "CIDR or IP":"CIDR or IP",
        "IP":"IP",
        "MAC":"MAC",
        "Type":"Type",
        "Address":"Address",
        "Higher hardware":"Higher hardware",
        "Linked from hardware":"Linked from hardware",
        "Linked from port":"Linked from port",
        "Belongs to":"Belongs to",

        "AS numbers dictionary":"AS numbers dictionary",
        "Local AS numbers dictionary":"Local AS numbers dictionary",
        "Excluded AS numbers dictionary":"Excluded AS numbers dictionary",
        "CRC dictionary":"CRC dictionary",
        "Net protocols dictionary":"Net protocols dictionary",
        "App protocols dictionary":"App protocols dictionary",
        "Settings dictionary":"Settings dictionary",
        "Local subnets dictionary":"Local subnets dictionary",
        "Excluded subnets dictionary":"Excluded subnets dictionary",
        "Switches dictionary":"Switches dictionary",
        "Subscribers dictionary":"Subscribers dictionary",

        "Category ID":"Category ID",
        "Host categories dictionary":"Host categories dictionary",
        "Hosts in categories dictionary":"Hosts in categories dictionary",
        "Dictionaries are reloaded":"Dictionaries are reloaded",

        "Caches info":"Caches info",

        "Queries processes list":"Queries processes list",
        "User":"User",
        "Query":"Query",
        "Query ID":"Query ID",
        "Elapsed":"Elapsed",
        "seconds":"seconds",
        "Memory usage":"Memory usage",
        "Peak memory usage":"Peak memory usage",
        "Rows read":"Rows read",
        "Bytes read":"Bytes read",

        "Cancel query":"Cancel query",
        "Canceled":"Canceled",
        "All queries are canceled":"All queries are canceled",
        "Cancel queries":"Cancel queries",
        "Cancel all queries":"Cancel all queries",
        "Query was cancelled":"Query was cancelled",
        "Are you sure you want to cancel the selected queries?":"Are you sure you want to cancel the selected queries?",

        "Data not found":"Data not found",

        "Triggers":"Triggers",
        "Alerts":"Alerts",
        "Alerts actions":"Alerts actions",
        "Add trigger":"Add trigger",
        "Trigger name":"Trigger name",
        "Trigger title / description":"Trigger title / description",
        "Enter trigger name":"Enter trigger name",
        "Are you sure you want to delete the trigger?":"Are you sure you want to delete the trigger?",
        "Are you sure you want to delete the trigger alert?":"Are you sure you want to delete the trigger alert?",

        "Common":"Common",
        "Queries":"Queries",
        "Conditions":"Conditions",
        "Conditions notes":"Conditions notes",
        "Report link":"Report link",

        "Days of the week":"Days of the week",
        "Days when the trigger works":"Days when the trigger works",
        "Check frequency":"Check frequency",
        "Check frequency in seconds":"Check frequency in seconds",
        "Number of positives":"Number of positives",
        "Number of positives before notification":"Number of positives before notification",
        "Start date":"Start date",
        "Trigger start date":"Trigger start date",
        "End date":"End date",
        "Trigger end date":"Trigger end date",
        "Start time":"Start time",
        "Trigger start time":"Trigger start time",
        "End time":"End time",
        "Trigger end time":"Trigger end time",

        "Based on":"Based on",
        "With filter":"With filter",
        "For period from":"For period from",
        "To":"To",

        "Query name":"Query name",
        "Report":"Report",
        "Filter":"Filter",
        "Period from":"Period from",
        "Period to":"Period to",
        "Bind":"Bind",
        "Function":"Function",
        "Combinator":"Combinator",
        "Serie":"Serie",
        "Note":"Note",

        "Trigger":"Trigger",
        "Enabled":"Enabled",
        "Disabled":"Disabled",
        "Severity":"Severity",
        "Trigger saved":"Trigger saved",
        "Trigger enabled":"Trigger enabled",
        "Trigger disabled":"Trigger disabled",

        "No data & error handling":"No data & error handling",
        "If no data":"If no data",
        "Set state when no data":"Set state when no data",
        "If execution error or timeout":"If execution error or timeout",
        "Set state when execution error or timeout":"Set state when execution error or timeout",

        "Information":"Information",
        "Warning":"Warning",
        "Average":"Average",
        "Hight":"Hight",

        "Alerting":"Alerting",
        "No data":"No data",
        "Keep last state":"Keep last state",
        "Ok":"Ok",

        "State":"State",
        "Status":"Status",
        "Ready":"Ready",
        "Caching":"Caching",
        "Checking":"Checking",
        "Firing":"Firing",
        "Invalid":"Invalid",
        "In progress":"In progress",
        "Complete":"Complete",
        "Max attempts":"Max attempts",

        "Actions":"Actions",
        "Send to":"Send to",
        "Message recipients email-addresses":"Message recipients email-addresses",
        "Message":"Message",
        "Subject":"Subject",

        "Only selected triggers":"Only selected triggers",
        "Only selected notifications":"Only selected notifications",

        "E-mail action":"E-mail action",
        "Http action":"Http action",
        "Notification action":"Notification action",
        "Telegram action":"Telegram action",
        "Notification": "Notification",
        "Notification title":"Notification title",
        "Notification subtitle": "Notification subtitle",
        "Notification type": "Notification type",
        "Headers":"Headers",
        "Body":"Body",
        "Add header":"Add header",

        "Set default template":"Set default template",
        "Tepmplate parameters":"Tepmplate parameters",
        "Select one or more identifiers (via shift or ctr). Use ctrl + c to copy and ctrl + v to insert a message into the template.":"Select one or more identifiers (via <b>shift</b> or <b>ctr</b>). Use <b>ctrl + c</b> to copy and <b>ctrl + v</b> to insert a message into the template.",

        "Trigger id":"Trigger id",
        "Notification id":"Notification id",
        "Notification notes":"Notification notes",

        "Trigger fired":"Trigger fired",

        "AND":"AND",
        "OR":"OR",
        "if is not NaN":"if is not NaN",
        "if is not Null":"if is not Null",
        "if is NaN":"if is NaN",
        "if is Null":"if is Null",

        "Reset filters":"Reset filters",

        "Subscriber`s AS number":"Subscriber`s AS number",
        "Host`s AS number":"Host`s AS number",

        "Subscriber`s port":"Subscriber`s port",
        "Host`s port":"Host`s port",

        "Raw log":"Raw log",
        "Short raw log":"Short raw log",
        "Subscriber raw log":"Subscriber raw log",
        "Full raw log":"Full raw log",

        "By traffic":"By traffic",
        "By flow":"By flow",
        "By sessions":"By sessions",
        "By RTT":"By RTT",
        "By session lifetime":"By session lifetime",
        "By subscribers and hosts":"By subscribers and hosts",
        "By traffic volume":"By traffic volume",

        "Distribution":"Distribution",

        "Attacks detection":"Attacks detection",

        "Session lifetime":"Session lifetime",
        "From subscriber":"From subscriber",
        "To subscriber":"To subscriber",

        "Logins":"Logins",

        "With netflow":"With netflow",

        "Locked":"Locked",
        "Locked total":"Locked total",
        "Not locked":"Not locked",
        "By DROP":"By DROP",
        "By policing":"By policing",

        "Dropped bytes":"Dropped bytes",
        "Dropped packets":"Dropped packets",

        "Host type":"Host type",
        "New trigger": "New trigger",
        "Copy trigger": "Copy trigger",
        "Trigger type": "Trigger type",
        "Custom": "Custom",
        "System": "System",
        "Ssh bruteforce": "SSH bruteforce",
        "Sessions per subscriber": "Sessions per subscriber",

        "Kill current report processes":"Kill current report processes",
        "Kill processes for all reports in section":"Kill processes for all reports in section",
        "Kill all my processes":"Kill all my processes",
        "Kill processes for all users":"Kill processes for all users",

        "Clear current report cache":"Clear current report cache",
        "Clear cache for all reports in section":"Clear cache for all reports in section",
        "Clear all my cache":"Clear all my cache",
        "Clear cache for all users":"Clear cache for all users",

        "Select a report and options to get another report":"Select a report and options to get another report",

        "Menu":"Menu",
        "Open report":"Open report",

        "Link":"Link",

        "Triggers of all users":"Triggers of all users",
        "Only my triggers":"Only my triggers",
        "Gtp cells locations dictionary": "GTP cells locations dictionary",

        "Cell ID": "Cell ID",
        "Cell name": "Cell name",
        "Cell description": "Cell description",
        "Latitude": "Latitude",
        "Longitude": "Longitude",
        "Mobile country code": "Mobile country code",
        "Mobile network (operator) code": "Mobile network (operator) code",
        "Service/Tracking area code": "Service/Tracking area code",
        "Base station code": "Base station code",

        "GTP version": "GTP version",
        "Request message ID": "Request message ID",
        "Response message ID": "Response message ID",
        "SGW control plane IP": "SGW control plane IP",
        "SGW control plane TEID": "SGW control plane TEID",
        "SGW data plane IP": "SGW data plane IP",
        "SGW data plane TEID": "SGW data plane TEID",
        "PGW control plane IP": "PGW control plane IP",
        "PGW control plane TEID": "PGW control plane TEID",
        "PGW data plane IP": "PGW data plane IP",
        "PGW data plane TEID": "PGW data plane TEID",
        "Subscriber ipv4 address": "Subscriber ipv4 address",
        "Subscriber ipv6 address": "Subscriber ipv6 address",
        "SIM card number": "SIM card number",
        "Phone number": "Phone number",
        "IMEI": "IMEI",
        "Access Point Name": "Access Point Name",
        "Time of ULI": "Time of ULI",
        "Rat": "Rat",
        "DPI ID": "DPI ID",
        "Vlan ID": "VLAN ID",
        "Post vlan ID": "Post VLAN ID",
        "Aggregated log":"Aggregated log",
        "Session unique ID": "Session unique ID",

        "Vchannels names dictionary":"Vchannels names dictionary",

        "NAT flow raw log":"NAT flow raw log",

        "Event type":"Event type",

        "NAT flow aggregated log":"NAT flow aggregated log",

        "Top post NAT IPs":"Top post NAT IPs",

        "Vchannel/Bridge":"Vchannel/Bridge",
        "Vchannels":"Vchannels",
        "By vchannel":"By vchannel",

        "Traffic by vchannels":"Traffic by vchannels",
        "Top vchannels with high traffic":"Top vchannels with high traffic",
        "Flow by vchannels":"Flow by vchannels",
        "Top vchannels with high flow":"Top vchannels with high flow",
        "Top vchannels":"Top vchannels",
        "Top vchannels with high RTT":"Top vchannels with high RTT",
        "Top vchannels with high retransmits":"Top vchannels with high retransmits",
        "Copy role": "Copy role",

        "Top classes":"Top classes",
        "Traffic by classes":"Traffic by classes",
        "Traffic by DSCP":"Traffic by DSCP",
        "Flow by classes":"Flow by classes",
        "Flow by DSCP":"Flow by DSCP",
        "Top classes with high traffic":"Top classes with high traffic",
        "Top DSCP classes with high traffic":"Top DSCP classes with high traffic",
        "Top DSCP classes with high flow":"Top DSCP classes with high flow",
        "Top classes with high flow":"Top classes with high flow",
        "Top classes with high RTT":"Top classes with high RTT",
        "Top classes with high retransmits":"Top classes with high retransmits",
        "Class":"Class",
        "Top DSCP classes":"Top DSCP classes",

        "Reasons for the occurrence of notification":"Reasons for the occurrence of notification",
        "Links to reports":"Links to reports",
        "Links to PDF reports":"Links to PDF reports",
        "Final report":"Final report",
        "App protocols groups dictionary": "App protocols groups dictionary",
        "App protocols groups": "App protocols groups",
        "App protocol group": "App protocol group",
        "Traffic by application protocols groups": "Traffic by application protocols groups",
        "Top application protocols groups with high retransmits": "Top application protocols groups with high retransmits",
        "Top application protocols groups with high traffic": "Top application protocols groups with high traffic",
        "Top application protocols groups with high traffic volume": "Top application protocols groups with high traffic volume",
        "Top application protocols groups with high flow": "Top application protocols groups with high flow",
        "Top protocols groups": "Top protocols groups",
        "Top application protocols groups with high RTT": "Top applications protocols groups with high RTT",
        "Flow by application protocols groups": "Flow by application protocols groups",
        "Top application protocols groups": "Top application protocols groups",
        "Top GTP cells":"Top GTP cells",
        "Not applicable":"Not applicable",

        "Report name":"Report name",

        "Agg logs":"Agg logs",
        "Log name":"Log name",
        "Top hosts by subscribers":"Top hosts by subscribers",
        "Top app protocols by subscribers (fullflow)":"Top app protocols by subscribers (fullflow)",
        "Agg log enabled":"Agg log enabled",
        "Agg log disabled":"Agg log disabled",
        "Top categories of hosts by subscribers":"Top categories of hosts by subscribers",
        "Top application protocols by subscribers":"Top application protocols by subscribers",
        "Top application protocols groups by subscribers":"Top application protocols groups by subscribers",
        "Application protocol group":"Application protocol group",
        "Host domain":"Host domain",
        "Known host category":"Known host category",
        "Protocol group":"Protocol group",
        "Top subscribers by hosts":"Top subscribers by hosts",
        "Disk name":"Disk name",
        "Cluster host":"Cluster host",

        "Gtp country dictionary":"Gtp country dictionary",
        "Country name":"Country name",
        "Gtp network (operator) dictionary":"Gtp network (operator) dictionary",
        "Network (operator) name":"Network (operator) name",

        "UPLINK LOAD RATE protocols dictionary":"UPLINK LOAD RATE protocols dictionary",
        "Protocol code":"Protocol code",
        "Protocol category":"Protocol category",

        "Aggregation period":"Aggregation period",
        "Window width":"Window width",
        "Start collecting data":"Start collecting data",
        "Stop collecting data":"Stop collecting data",

        "Dashboards":"Dashboards",
        "Saved dashboards":"Saved dashboards",
        "Add dashboard":"Add dashboard",
        "Add subdashboard":"Add subdashboard",
        "Dashboard name":"Dashboard name",
        "Enter dashboard name":"Enter dashboard name",
        "For whom the dashboard is available?":"For whom the dashboard is available?",
        "Create a new dashboard":"Create a new dashboard",
        "Dashboard deleted":"Dashboard deleted",
        "Back to the dashboard":"Back to the dashboard",

        "Template":"Template",
        "Templates":"Templates",
        "Saved dashboard templates":"Saved dashboard templates",
        "Template name":"Template name",
        "For whom the template is available?":"For whom the template is available?",
        "Enter template name":"Enter template name",
        "Dashboard template":"Dashboard template",
        "Save as template":"Save as template",
        "Template deleted":"Template deleted",

        "Role":"Role",
        "Select roles":"Select roles",
        "To me only":"To me only",
        "To any users":"To any users",
        "To users with roles":"To users with roles",

        "Filters":"Filters",
        "Start collecting":"Start collecting",
        "You have not created any filters":"You have not created any filters",
        "Are you sure you want to start data collection?":"Are you sure you want to start data collection?",
        "Report refresh rate":"Report refresh rate",
        "As in the aggregation period":"As in the aggregation period",
        "Allows you to select the aggregation period for reports. The set of available values depends on the smallest rotation period of the receivers":"Allows you to select the aggregation period for reports. The set of available values depends on the smallest rotation period of the receivers",
        "Allows you to increase the aggregation period":"Allows you to increase the aggregation period",

        "Flow capture":"Flow capture",
        "Subscriber flow capture":"Subscriber flow capture",
        "Host flow capture":"Host flow capture",
        "Subscriber login":"Subscriber login",
        "Subscriber IP":"Subscriber IP",
        "At least one field must be filled":"At least one field must be filled",
        "Capture":"Capture",
        "Capture type":"Capture type",

        "Widget created":"Widget created",
        "Widget deleted":"Widget deleted",
        "Widget name":"Widget name",
        "Enter widget name":"Enter widget name",
        "Incorrect value":"Incorrect value",
        "Bot token":"Bot token",
        "Bot token for sending a message":"Bot token for sending a message",
        "Chat Id":"Chat Id",
        "Chat ID where the bot will send the message":"Chat ID where the bot will send the message",
        "Links to files": "Links to files",
        "Create CSV file":"Create CSV file",
        "Create TabSeparated file":"Create TabSeparated file",
        "Create Excel file":"Create Excel file",
        "Create PDF file":"Create PDF file",
        "Radius": "Radius",

        "Add protocol": "Add protocol",
        "None (0 points)": "None (0 points)",
        "First category (+2 points)": "First category (+2 points)",
        "Second category (+1 point)": "Second category (+1 point)",
        "Metrics": "Metrics",
        "Traffic volume delta": "Traffic volume delta",
        "Delta with normal": "Delta with normal",
        "Points": "Points",
        "RTT to, median": "RTT to, median",
        "Other" : "Other",
        "Protocol health mark": "Protocol health mark",
        "Protocol health mark changes": "Protocol health mark changes",

        "Aggregation raw logs fullflow info": "Aggregation raw logs fullflow info",
        "Task type from": "Source table",
        "Action": "Action",
        "Task type to": "Target table",
        "Partition name": "Partition name",
        "Node": "Node",
        "Status description": "Status description",
        "Attempts": "Attempts",
        "Data": "Data",
        "Create time": "Create time",
        "Update time": "Update time",

        "New": "New",
        "Waiting": "Waiting",
        "Waiting processing": "Waiting processing",
        "Skipped": "Skipped",

        "Move To": "Move To",
        "Drop Partition": "Drop Partition",
        "Wait Move": "Wait Move",
        "Wait Drop Partition": "Wait Drop Partition",

        "Enter valid date, example: 22.02.2023 00:00": "Enter valid date, example: 22.02.2023 00:00",
        "Enter valid date, example: ": "Enter valid date, example: ",
        "Scheduled": "Scheduled",
        "All reports in single PDF": "All reports in single PDF",

        "Top logins":"Top logins",

        "Traffic direction":"Traffic direction",

        "Link to CSV file": "Link to CSV file",
        "Link to TabSeparated file": "Link to TabSeparated file",
        "Link to Excel file": "Link to Excel file",
        "Link to PDF file": "Link to PDF file",
        "Link to PDF file with all reports": "Link to PDF file with all reports",
        "Attach CSV file": "Attach CSV file",
        "Email only": "Email only",
        "Attach archive with CSV file": "Attach archive with CSV file",
        "Attach TabSeparated file": "Attach TabSeparated file",
        "Attach archive with TabSeparated file": "Attach archive with TabSeparated file",
        "Attach Excel file": "Attach Excel file",
        "Attach archive with Excel file": "Attach archive with Excel file",
        "Link to Excel file with all reports":"Link to Excel file with all reports",
        "Attach Excel file with all reports":"Attach Excel file with all reports",
        "Attach archive with Excel file with all reports":"Attach archive with Excel file with all reports",
        "Attach PDF file": "Attach PDF file",
        "Attach archive with PDF file": "Attach archive with PDF file",
        "Attach PDF file with all reports": "Attach PDF file with all reports",
        "Attach archive with PDF file with all reports": "Attach archive with PDF file with all reports",
        "Redirected":"Redirected",
        "Both: locked + redirected":"Both: locked + redirected",
        "Locked traffic":"Locked traffic",
        "Redirected traffic":"Redirected traffic",
        "Both: redirected and locked traffic":"Both: redirected and locked traffic",
        "MPLS labels": "MPLS labels",
        "Raw DNS log":"Raw DNS log",
        "DNS transport": "DNS transport",
        "DNS type": "DNS type",
        "Subscriber port": "Subscriber port",
        "Host port": "Host port",
        "DNS data": "DNS data",
        "Rrclass": "Rrclass",
        "Rrtype": "DNS type",
        "TTL": "TTL",
        "Top DNS hosts IPs": "Top DNS hosts IPs",
        "Top DNS servers IPs": "Top DNS servers IPs",
        "DNS host IP": "DNS host IP",
        "DNS host port": "DNS host port",
        "DNS server IP": "DNS server IP",
        "DNS server port": "DNS server port",
        "Cache error":"Cache error",
        "DSCP":"DSCP",

        "Edit":"Edit",
        "Report settings":"Report settings",
        "Save settings":"Save settings",
        "Settings successfully saved.":"Settings successfully saved.",
        "Settings successfully deleted.":"Settings successfully deleted.",
        "New settings":"New settings",
        "Items visibility":"Items visibility",
        "The setting allows to select which field will be used to group the report.":"The setting allows to select which field will be used to group the report.",
        "The setting allows to choose which data columns will be visible in the report.":"The setting allows to choose which data columns will be visible in the report.",
        "The setting allows you to set a limit on the number of data rows displayed in the report.":"The setting allows you to set a limit on the number of data rows displayed in the report.",
        "The setting allows to choose whether the data filter will be displayed on the PDF report.":"The setting allows to choose whether the data filter will be displayed on the PDF report.",
        "The setting allows to select the page orientation (portrait, landscape) for the report. Auto mode selects orientation depending on the amount of data.":"The setting allows to select the page orientation (portrait, landscape) for the report. Auto mode selects orientation depending on the amount of data.",
        "The setting allows to control the visibility of series or chart elements.":"The setting allows to control the visibility of series or chart elements.",
        "The setting determines the interval or step between values on the graph.":"The setting determines the interval or step between values on the graph.",
        "The setting determines chart type.":"The setting determines chart type.",
        "The setting determines chart scale type.":"The setting determines chart scale type.",
        "The setting determines the sorting field for the chart series.":"The setting determines the sorting field for the chart series.",
        "The setting determines the direction of sorting field for the chart series.":"The setting determines the direction of sorting field for the chart series.",
        "The setting determines the sorting field.":"The setting determines the sorting field.",
        "The setting determines the direction of sorting.":"The setting determines the direction of sorting.",
        "The setting allows to control the detalization of the Y axis. Available options: Auto, Low, Medium, High. They differ by the number of tick marks displayed on the Y axis.":"The setting allows to control the detalization of the Y axis. Available options: Auto, Low, Medium, High. They differ by the number of tick marks displayed on the Y axis.",
        "Report settings allow to change the display of the report in the interface and exported reports.":"Report settings allow to change the display of the report in the interface and exported reports.",
        "Displays the minimum, maximum, and average values for each series in the chart legend.":"Displays the minimum, maximum, and average values for each series in the chart legend.",
        "Restore to default":"Restore to default",
        "Add": "Add",
        "QoE reports settings history storage period in days":"QoE reports settings history storage period in days",
        "The setting allows to specify the name of the PDF report.":"The setting allows to specify the name of the PDF report.",

        "with high flow":"with high flow",
        "Top with high flow":"Top with high flow",
        "Top subscribers with high flow":"Top subscribers with high flow",
        "Top hosts with high flow":"Top hosts with high flow",
        "Top host categories with high flow":"Top host categories with high flow",
        "Top AS with high flow":"Top AS with high flow",
        "Top subscriber`s AS with high flow":"Top subscriber`s AS with high flow",

        "Set table properties to default":"Set table properties to default",

        "My reports":"My reports",
        "Report description":"Report description",
        "Tasks for building a report":"Tasks for building a report",
        "Create task":"Create task",
        "Create report task":"Create report task",
        "Maximum execute time":"Maximum execute time",
        "Time to store cache":"Time to store cache",
        "Priority":"Priority",
        "No queue":"No queue",
        "Send to telegram":"Send to telegram",
        "Email address":"Email address",
        "Formats":"Formats",
        "Split report":"Split report",
        "Separate delivery":"Separate delivery",
        "Split by":"Split by",
        "By time":"By time",
        "By lines":"By lines",
        "Lines":"Lines",
        "Delayed start":"Delayed start",
        "Task schedule":"Task schedule",
        "Task name":"Task name",
        "Task id":"Task id",
        "The field cannot be empty": "The field cannot be empty",
        "The period is incorrect":"The period is incorrect",
        "Copy of task":"Copy of task",
        "Task successfully saved":"Task successfully saved",
        "and run":"and run",
        "Save and run":"Save and run",
        "Done": "Done",
        "Cache":"Cache",
        "Cache date":"Cache date",
        "Preparing":"Preparing",
        "Add task":"Add task",
        "Edit task":"Edit task",
        "Run task":"Run task",
        "Stop task":"Stop task",
        "Copy task":"Copy task",
        "Delete task":"Delete task",
        "Task settings":"Task settings",
        "Are you sure you want to stop task?":"Are you sure you want to stop task?",
        "Stop":"Stop",
        "The parameter specifies the maximum time (in hours) to complete the report generation task.":"The parameter specifies the maximum time (in hours) to complete the report generation task.",
        "The parameter defines the storage duration of cached data (in days) for loading the report.":"The parameter defines the storage duration of cached data (in days) for loading the report.",
        "The parameter determines the order of execution of tasks in the range from 1 (minimum priority) to 10 (maximum priority). Tasks with a higher priority are executed earlier. If two tasks have the same priority, the one that was created earlier is taken into work first.":"The parameter determines the order of execution of tasks in the range from 1 (minimum priority) to 10 (maximum priority). Tasks with a higher priority are executed earlier. If two tasks have the same priority, the one that was created earlier is taken into work first.",
        "Parameter that determines whether the task will be executed out of queue, i.e. immediately and independently of other report generation tasks. If this parameter is enabled, the task will be processed first, even if other tasks are in the queue.":"Parameter that determines whether the task will be executed out of queue, i.e. immediately and independently of other report generation tasks. If this parameter is enabled, the task will be processed first, even if other tasks are in the queue.",
        "The parameter determines whether an email notification will be sent upon task completion. If the parameter is enabled, the system will automatically send an email to the specified address. It is also possible to customize the email template so that the notification meets specific requirements. By default, the standard email template is used.":"The parameter determines whether an email notification will be sent upon task completion. If the parameter is enabled, the system will automatically send an email to the specified address. It is also possible to customize the email template so that the notification meets specific requirements. By default, the standard email template is used.",
        "The parameter determines whether a notification will be sent to the telegram channel upon completion of the task. If the parameter is enabled, the system will automatically send a message. It is also possible to customize the message template so that the notification meets specific requirements. By default, the standard message template is used.":"The parameter determines whether a notification will be sent to the telegram channel upon completion of the task. If the parameter is enabled, the system will automatically send a message. It is also possible to customize the message template so that the notification meets specific requirements. By default, the standard message template is used.",
        "An option that enables splitting a report into multiple subreports using two alternative methods: by time interval in hours or by the maximum number of rows. When splitting by time, each subreport covers the specified number of hours. When splitting by rows, each subreport contains no more than the defined number of rows.":"An option that enables splitting a report into multiple subreports using two alternative methods: by time interval in hours or by the maximum number of rows. When splitting by time, each subreport covers the specified number of hours. When splitting by rows, each subreport contains no more than the defined number of rows.",
        "Separate sending - each generated file is sent as a separate email or telegram message.":"Separate sending - each generated file is sent as a separate email or telegram message.",
        "Option that determines whether the task will be delayed before execution. If this option is enabled, you can specify a delay time after which the task will be added to the queue. By default, if the option is not enabled, the task is immediately queued for execution.":"Option that determines whether the task will be delayed before execution. If this option is enabled, you can specify a delay time after which the task will be added to the queue. By default, if the option is not enabled, the task is immediately queued for execution.",
        "Option that enable task schedule.":"Option that enable task schedule.",
        "By default, the language of system templates is English. To set the template language, set the trigger template language option in the GUI configuration.":"By default, the language of system templates is English. To set the template language, set the trigger template language option in the GUI configuration.",
        "Cache.Ready":"Ready",
        "Cache.NotReady":"Not ready",
        "Cache lifetime":"Cache lifetime",
        "Task update error":"Task update error",
        "Cache data":"Cache data",
        "Task data":"Task data",
        "Days":"Days",
        "Max available number of queries is 100.": "Max available number of queries is 100.",
        "Add schedule":"Add schedule",
        "No schedule added":"No schedule added",

        "Report file":"Report file",

        "Top VOIP protocols":"Top VOIP protocols",
        "Top VOIP protocols by numbers of calls":"Top VOIP protocols by numbers of calls",
        "Top VOIP Protocols by total call duration":"Top VOIP Protocols by total call duration",
        "Top VOIP Protocols by number of users":"Top VOIP Protocols by number of users",
        "Top VOIP protocols with high traffic":"Top VOIP protocols with high traffic",
        "Traffic by VOIP protocols":"Traffic by VOIP protocols",
        "Calls by protocols":"Calls by protocols",
        "Minutes by protocols":"Minutes by protocols",
        "Subscribers by protocols":"Users by protocols",
        "Calls":"Calls",
        "Minutes":"Minutes",

        "Duration in seconds":"Duration in seconds",
        "Duration in milliseconds":"Duration in milliseconds",

        "Cache report stat":"Cache report stat",

        "Raw DDoS attack log":"Raw DDoS attack log",
        "Attack type":"Attack type",
        "Attack direction":"Attack direction",
        "Event":"Event",
        "Attacker ip":"Attacker ip",
        "Attacker ports":"Attacker ports",
        "Target ip":"Target ip",
        "Target port":"Target port",
        "Event object":"Event object",
        "Event action":"Event action",
        "Flows records":"Flows records",
        "Dropped traffic":"Dropped traffic",
        "Dropped flow":"Dropped flow",
        "Top attacks":"Top attacks",
        "Top attacks by AS":"Top attacks by AS",
        "Top attacks by protocols":"Top attacks by protocols",
        "Top attacks by application protocols":"Top attacks by application protocols",
        "Attack intensity by source AS":"Attack intensity by source AS",
        "Attack intensity by protocols":"Attack intensity by protocols",
        "Attack intensity by application protocols":"Attack intensity by application protocols",
        "Duration":"Duration",
        "Peak traffic":"Peak traffic",
        "Average intensity":"Average intensity",
        "Traffic speed":"Traffic speed",
        "Peak flow":"Peak flow",
        "Flow speed":"flow speed",
        "Start time in milliseconds":"Start time in milliseconds",
        "End time in milliseconds":"End time in milliseconds",
        "Average duration":"Average duration",
        "Attack intensity":"Attack intensity",
        "Intensity":"Intensity",
        "Incidents":"Incidents",
        "Mitigation":"Mitigation",
        "Number of attacks":"Number of attacks",
        "Number of attack types":"Number of attack types",
        "Blocked traffic volume":"Blocked traffic volume",
        "Country code":"Country code",
        "GeoState":"State",
        "City":"City",
        "Top attacker locations":"Top attacker locations",
        "Top attacker Ip addresses":"Top attacker Ip addresses",
        "Geo":"Geo",
        "Number of attackers":"Number of attackers",
        "Top attacker countries":"Top attacker countries",
        "Number of locations":"Number of locations",

        "Service flags":"Service flags",
        "Detection flags":"Detection flags",
        "Action flags":"Action flags",

        "Rating group":"Rating group",

        "Tethering":"Tethering",
        "No flags":"Нет флагов",

        "Top logins with high RTT":"Top logins with high RTT",
        "Top logins with high traffic":"Top logins with high traffic",
        "Top logins with high retransmits":"Top logins with high retransmits",
        "Top logins with high flow":"Top logins with high flow",

        "CITRA - Capacity planning report": "CITRA - Capacity planning report",
        "Top ISP's with high traffic": "Top ISP's with high traffic",
        "Traffic by ISP's": "Traffic by ISP's",
        "Kuwait's Traffic Utilization": "Kuwait's Traffic Utilization",
        "Globally Trending applications behavior in Kuwait":"Globally Trending applications behavior in Kuwait",
        "VOIP protocols": "VOIP protocols",
        "VOIP application Usage report": "VOIP application Usage report",
        "Network latency": "Network latency",
        "Quarter consumption": "Quarter consumption",

        "Quarter": "Quarter",
        "Traffic volume consumption by quarter": "Traffic volume consumption by quarter",
        "Traffic volume consumption growth rates by quarter": "Traffic volume consumption growth rates by quarter",
        "Traffic volume growth rate":"Traffic volume growth rate",
        "Traffic volume from subscriber growth rate":"Traffic volume from subscriber growth rate",
        "Traffic volume to subscriber growth rate":"Traffic volume to subscriber growth rate"
    };

webix.i18n.locales["en-US"].dpiui2.QoEPopupFilterWidget =
    {
        "Title":"Title",
        "Saved filters":"Saved filters",
        "Filters":"Filters",
        "Filter":"Filter",
        "Operator":"Operator",
        "Value":"Value",
        "Add filter":"Add filter",
        "Values are separated by a new line. Use Shift + Enter to make new line.":"Values are separated by a new line. Use <b>Shift</b> + <b>Enter</b> to make new line.",
        "Filter is saved":"Filter is saved",
        "Are you sure you want to delete the filter?":"Are you sure you want to delete the filter?",
        "Checks whether a string matches a simple regular expression.":"Checks whether a string matches a simple regular expression.<br/>The regular expression can contain the metasymbols % and _.<br/>% indicates any quantity of any bytes (including zero characters).<br/>_ indicates any one byte.",
        "There are no common filters":"There are no common filters",
        "New filter": "New filter",
        "Save filter":"Save filter",
        "Saved":"Saved",
        "Enable/Disable":"Enable/Disable",
        "Details":"Details",
        "Help":"Help",
        "Apply filter":"Apply filter",
        "Cancel filter":"Cancel filter",
        "Edit next property":"Edit next property",
        "Enable/Disable filter setting":"Enable/Disable filter setting",
        "Delete selected":"Delete selected",
        "Add new saved filter":"Add new saved filter",
        "Refresh tables":"Refresh tables",
        "Show help":"Show help",
        "Show/Hide filter settings window":"Show/Hide filter settings",
        "Delete all filter settings":"Delete all filter settings",
        "Set default filter state":"Set default filter state",
        "Clear value":"Clear value",
        "Are you sure you want to set filter settings to default?":"Are you sure you want to set filter settings to default?",
        "Are you sure you want to delete all filter settings?":"Are you sure you want to delete all filter settings?"
    };

webix.i18n.locales["en-US"].dpiui2.QoEMonitorWidget =
{
        "Bytes":"Bytes",
        "Kb":"Kbytes",
        "Mb":"Mbytes",
        "Gb":"Gbytes",
        "Tb":"Tbytes",

        "median":"median"
}

webix.i18n.locales["en-US"].dpiui2.QoESubscribers =
    {
        "Filter is saved":"Filter is saved",
        "Add subscribers to campaign":"Add subscribers to campaign"
    };

webix.i18n.locales["en-US"].dpiui2.BlackListService =
    {
        "Profiles":"Profiles",
        "List of nodes scan profiles":"List of nodes scan profiles",
        "Add profile":"Add profile",
        "Add subprofile":"Add subprofile",

        "Profile":"Profile",
        "Date":"Date",
        "User":"User",
        "Status":"Status",

        "Enable profile":"Enable profile",
        "Disable profile":"Disable profile",

        "List of black and white profiles":"List of black and white profiles",
        "Black and white lists":"Black and white lists",

        "Black":"Black",
        "White":"White",

        "Disabled":"Disabled",
        "Enabled":"Enabled",

        "Type":"Type",
        "Type: black or white":"Type: black or white",

        "Black or white profile":"Black or white profile",
        "Description":"Description",
        "IP-addresses":"IP-addresses",
        "IP-addresses or CIDRs. Each with a new line":"IP-addresses or CIDRs. Each with a new line",

        "Resource":"Resource",
        "Redirect":"Redirect",
        "URL to redirect":"URL to redirect",

        "Add list item":"Add list item",
        "Import from file":"Import from file",

        "Profile enabled":"Profile enabled",
        "Profile not enabled":"Profile not enabled",
        "Profile disabled":"Profile disabled",
        "Profile not disabled":"Profile not disabled",

        "List item saved":"List item saved",
        
        "You should set url to redirect":"You should set url to redirect",
        "You should set ip addresses or CIDRs":"You should set ip addresses or CIDRs",
        "You should set url to redirect when white list is enabled":"You should set url to redirect when white list is enabled",
        "Are you sure you want to delete the profile?": "Are you sure you want to delete the profile?",
        "from":"from",
        "On page":"On page",
        "Are you sure you want to delete this record?":"Are you sure you want to delete this record?",
        "Input correct IP addresses!": "Input correct IP addresses!",
        "Subscribers": "Subscribers",
        "IP-address": "IP-address",
        "IP-address saved":"IP-address saved",
        "Black and white lists subscribers": "Black and white lists subscribers",
        "Profile saved":"Profile saved",
        "Import categories from QoE":"Import categories from QoE",
        "Import list items from QoE" : "Import list items from QoE",
        "Import": "Import",
        "Category": "Category",
        "CategoryEnabled": "Enabled",
        "Imported successfully": "Imported successfully",
        "Get template" : "Get template",
        "Subscriber saved":"Subscriber saved",
        "Resource field should be valid": "Resource field should be valid",
        "Export to Excel": "Export to Excel",

        "Advertising & Ad blocking lists":"Advertising & Ad blocking lists",
        "The task of importing successfully launched":"The task of importing successfully launched",
        "This profile loaded from hardware. Profile will be deleted if you stop it. Delete profile?": "This profile loaded from hardware.<br/> Profile will be deleted if you stop it.<br/> Delete profile?",
        "Import of resources from QoE running in background": "Import of resources from QoE running in background",
        "All resources": "All resources",
        "% resources": "% resources",
        "Number of resources":"Number of resources",
        "Please select at least one category.": "Please select at least one category.",
        "Clear list": "Clear list",
        "Are you sure you want to delete all records?": "Are you sure you want to delete all records?",
        "All records have been deleted!": "All records have been deleted!",
        "Federal":"Federal",
        "Use federal lists": "Use federal lists",
        "Use federal" : "Use federal",
        "Task title / description": "Task title / description",
        "Code": "Code",
        "Profile name using on DPI": "Profile name using on DPI",
        "Category removed": "Category removed",
        "Sites category": "Sites category",
        "Classifier categories not applied": "Classifier categories not applied",
        "Synchronization period in hours": "Synchronization period in hours",
        "Task sync time update success": "Task sync time update success",

        "VASE Lists": "VASE Lists",
        "Successfully imported  rows: ": "Successfully imported  rows: "
    };

    
webix.i18n.locales["en-US"].dpiui2.SessionPolicingsService =
{
    "Session policings": "Session policings",
    "Protocols": "Protocols",
    "Profiles":"Profiles",
    "List of nodes scan profiles":"List of nodes scan profiles",
    "Add profile":"Add profile",
    "Add subprofile":"Add subprofile",
    "Profile name":"Profile name",
    "Profile":"Profile",
    "Date":"Date",
    "User":"User",
    "Status":"Status",
    "Protocol saved": "Protocol saved",

    "In your configuration, the parameter (support_service_18) is disabled, which is necessary for the correct operation of this service. Go to the configuration section?":"In your configuration, the parameter (support_service_18) is disabled, which is necessary for the correct operation of this service. Go to the configuration section?",
    "Configuration error!":"Configuration error!",
    "Go to":"Go to",

    "Enable profile":"Enable profile",
    "Disable profile":"Disable profile",

    "Disabled":"Disabled",
    "Enabled":"Enabled",

    "Type":"Type",

    "Description":"Description",

    "Resource":"Resource",
    "Redirect":"Redirect",
    "URL to redirect":"URL to redirect",

    "Add list item":"Add list item",

    "Profile enabled":"Profile enabled",
    "Profile not enabled":"Profile not enabled",
    "Profile disabled":"Profile disabled",
    "Profile not disabled":"Profile not disabled",

    "List item saved":"List item saved",

    "Are you sure you want to delete the profile?": "Are you sure you want to delete the profile?",
    "from":"from",
    "On page":"On page",
    "Are you sure you want to delete this record?":"Are you sure you want to delete this record?",
    "Subscribers": "Subscribers",
    "Profile saved":"Profile saved",
    "Category": "Category",
    "CategoryEnabled": "Enabled",
    "Subscriber saved":"Subscriber saved",
    "Resource field should be valid": "Resource field should be valid",
    "All subscribers associated with this profile will be unsubscribed from the Session Policings service.": "All subscribers associated with this profile will be unsubscribed from the Session Policings service.",

};

webix.i18n.locales["en-US"].dpiui2.Tariffs =
    {
        "Tarrif.Introduced": "Introduced",
        "Tarrif.Config error": "Config error",
        "Tarrif.Active": "Active",
        "Tariff name": "Tariff name",
        "Cancel" : "Cancel",
        "Save": "Save",
        "Delete": "Delete",
        "Are you sure you want to delete this tariff?" : "Are you sure you want to delete this tariff?",
        "Click to download or drag a file": "Click to download or drag a file",
        "Continue": "Continue",
        "Service Management": "Service Management",
        "Tariffs": "Tariffs",
        "Add tariff": "Add tariff",
        "Tariff": "Tariff",
        "Status": "Status",
        "Load from file": "Load from file",
        "Tariff plan configuration": "Tariff plan configuration",
        "Class": "Class",
        "Inbound": "Inboud",
        "Outbound": "Outbound",
        "Subscribers" : "Subscribers",
        "Tariff deleted": "Tariff deleted",
        "Tariff saved": "Tariff saved",
        "Config field must not be empty!": "Config field must not be empty!",
        "Export config to file": "Export config to file",
        "Cancel changes": "Cancel changes",
        "Simple form": "Simple form",
        "Common form": "Common form",
        "Advanced form": "Advanced form",
        "Hierarchy": "Hierarchy",
        "Hierarchy types: \"HTB\" or \"TDF\"":"Hierarchy types: \"HTB\" or \"TDF\"",
        "Inbound rate": "Inbound rate",
        "Outbound rate": "Outbound rate",
        "Burst inbound rate": "Burst inbound rate",
        "Burst outbound rate": "Burst outbound rate",
        "Value should be positive integer number!": "Value should be positive integer number!",
        "Classes": "Classes",
        "Save and continue": "Save and continue",
        "Type": "Type",
        "Copy": "Copy",
        "Copy tariff": "Copy tariff",
        "Class rate summ should be less then root rate!":"Class rate summ should be less then root rate!",
        "Subscribers filter": "Subscribers filter",
        "Policing type": "Policing type",
        "Policing types: \"HTB\" or \"TBF\"":"Policing types: \"HTB\" or \"TBF\"",
        "Code": "Code",
        "Profile name using on DPI": "Profile name using on DPI",
        "Profile enabled": "Profile enabled",
        "Profile disabled": "Profile disabled",
        "Start time": "Start time",
        "Required field": "Required field",
        "Invalid time": "Invalid time",
        "End time": "End time",
        "Days of the week": "Days of the week",
        "Apply": "Apply",
        "Are you sure you want to delete this row?": "Are you sure you want to delete this row?",
        "Add": "Add",
        "Time": "Time",
        "Mon": "Mon",
        "Tue": "Tue",
        "Wed": "Wed",
        "Thu": "Thu",
        "Fri": "Fri",
        "Sat": "Sat",
        "Sun": "Sun",
        "Enable": "Enable",
        "Timetable": "Timetable",
        "The tariff is used, deletion is not possible": "The tariff is used, deletion is not possible",
        "Click + to add a schedule":"Click + to add a schedule",
        "Schedule saved successfully":"Schedule saved successfully"
    };

webix.i18n.locales["en-US"].dpiui2.SubscribersEmbedded = webix.i18n.locales["en-US"].dpiui2.Subscribers;

webix.i18n.locales["en-US"].dpiui2.AdBlockRedirectService = webix.i18n.locales["en-US"].dpiui2.BlackListService;

webix.i18n.locales["en-US"].dpiui2.VasCloud =
    {
        "Vas cloud services":"VAS cloud services",
        "Personal area":"Personal area",
        "Vas Ads":"VAS Ads",
        "Billing information":"Billing information",
        "License shop":"License shop",
        "Catalog":"Catalog",
        "My orders":"My orders",

        "Account":"Account",
        "Company":"Company",
        "Profile":"Profile",
        "Security":"Security",
        "Company code":"Company code",
        "Enter company code":"Enter company code",
        "Company name":"Company name",
        "Name of your company":"Name of your company",
        "Enter company name":"Enter company name",

        "Ads":"Ads",
        "Earn with Vas cloud Ads":"Earn with VAS cloud Ads",
        "Enabled":"Enabled",
        "Disabled":"Disabled",
        "Devices list":"Devices list",

        "Not need to restart":"Not need to restart",
        "Sync not started":"Sync not started",
        "Sync in progress":"Sync in progress",
        "Sync comleted and neet restart":"Sync comleted and need to restart",
        "Sync comleted":"Sync comleted",
        "Sync error":"Sync error",

        "Force sync of lists":"Force sync of lists",
        "Sync have been started in background":"Sync have been started in background",

        "Welcome to VAS Cloud":"Welcome to VAS Cloud",
        "Send us a request and we will process it as soon as possible":"Send us a request and we will process it as soon as possible",
        "Submit request":"Submit request",
        "Your request is accepted":"Your request is accepted",

        "Forgot your password?":"Forgot your password?",
        "I do not have an account":"I do not have an account",
        "Password recovery":"Password recovery",
        "Restore":"Restore",

        "Subscription status":"Subscription status",
        "Active":"Active",
        "Not active":"Not active",
        "Trial period":"Trial period",
        "remain %s days":"remain %s days",
        "You need to activate the subscription to make work this section correctly. You can write to us at sd@vas.expert or request a license by clicking the \"Send request\" button.":"You need to activate the subscription to make work this section correctly. <br/><br/>You can write to us at sd@vas.expert or request a license by clicking the \"Send request\" button.",

        "Check your mail. We have sent you a code": "Check your mail. We have sent you a code",
        "Code from e-mail":"Code from e-mail",
        "Enter code from e-mail":"Enter code from e-mail",
        "Check your mail. We have sent you a new password":"Check your mail. We have sent you a new password",

        "Licence":"Licence",
        "Licences":"Licences",
        "Product type":"Product type",
        "Licence level":"Licence level",
        "DPI licence level":"DPI licence level",
        "Expiration date":"Expiration date",
        "Support expiration date":"Support expiration date",
        "Product uuid":"Product uuid",
        "Licence limit":"Licence limit",
        "Board serial":"Board serial",
        "Chassis serial":"Chassis serial",
        "MAC addresses":"MAC addresses",
        "Speeds":"Speeds",
        "Add licence":"Add licence",
        "Licence enabled":"Licence enabled",
        "Licence disabled":"Licence disabled",
        "No licences found":"No licences found",

        "Send":"Send",
        "Request a licenсe":"Request a licence",
        "Send request":"Send request",

        "CKAT":"SSG",
        "Making money on affiliate programs is easy! <br/> <br/> <b> VAS cloud Ads </b> offers operators a wide selection of profitable affiliate program offers. Cooperating with us, you can earn big money on other people's sites.":"Making money on affiliate programs is easy! <br/> <br/> <b> VAS cloud Ads </b> offers operators a wide selection of profitable affiliate program offers. Cooperating with us, you can earn big money on other people's sites.",

        "Copied to clipboard": "Copied to clipboard",
        "Lic options":"Lic options"
    };

webix.i18n.locales["en-US"].dpiui2.CgNatService =
    {
        "Are you sure you want to delete the profile?": "Are you sure you want to delete the profile?",
        "Cancel": "Cancel",
        "Delete": "Delete",
        "CGNAT profile": "CGNAT profile",
        "Description": "Description",
        "Profile title / description": "Profile title / description",
        "Type": "Type",
        "Type: default or 1:1": "Type: default or 1:1",
        "Nat IP pool": "NAT IP pool",
        "External IP address range in CIDR format": "External IP address range in CIDR format",
        "IP pool is incorrect": "IP pool is incorrect",
        "TCP sessions": "TCP sessions",
        "Maximum number of TCP sessions that a subscriber can create": "Maximum number of TCP sessions that a subscriber can create",
        "Input correct positive number": "Input correct positive number",
        "UDP sessions": "UDP sessions",
        "Maximum number of UDP sessions that a subscriber can create": "Maximum number of UDP sessions that a subscriber can create",
        "Save" : "Save",
        "Profiles": "Profiles",
        "Add profile": "Add profile",
        "Enable profile": "Enable profile",
        "Disable profile": "Disable profile",
        "Refresh": "Refresh",
        "Profile status": "Profile status",
        "Profile": "Profile",
        "Nat type": "NAT type",
        "Status": "Status",
        "On page": "On page",
        "Subscribers": "Subscribers",
        "Profile saved": "Profile saved",
        "Profile enabled": "Profile enabled",
        "Profile not enabled": "Profile not enabled",
        "Profile disabled": "Profile disabled",
        "Profile not disabled": "Profile not disabled",
        "Profile deleted": "Profile deleted",
        "Full status": "Full status",
        "Detailed status": "Detailed status",
        "Protocol": "Protocol",
        "NTHR": "Stream number",
        "IP mask": "IP mask",
        "Addresses": "Addresses",
        "Ports": "Ports",
        "Ports in use": "Ports in use",
        "Used": "Used",
        "IP": "IP",
        "Default": "CGNAT",
        "1:1":"1:1",
        "TCP": "TCP",
        "UDP": "UDP",
        "0": "0",
        "1": "1",
        "0x0": "0x0",
        "0x1": "0x1",
        "Subscribers status": "Subscribers status",
        "White IP": "White IP",
        "Addresses in use": "Addresses in use",
        "Download the file": "Download the file",
        "Addresses number": "Adresses number",
        "Ports number": "Ports number",
        "All subscribers associated with this profile will be unsubscribed from the CG NAT service.": "All subscribers associated with this profile will be unsubscribed from the CG NAT service.",
        "IP mask: 0x0 is even address; 0x1 is not even address": "IP mask: 0x0 is even address; 0x1 is not even address",
        "Even address": "Even address",
        "Not even address": "Not even address"
    };

webix.i18n.locales["en-US"].dpiui2.HotSpot =
    {
        "Configuration deleted": "Configuration deleted",
        "Are you sure you want to delete hotspot configuration?": "Are you sure you want to delete hotspot configuration?",
        "Delete configuration": "Delete configuration",

        "Are you sure you want to delete the selected language?": "Are you sure you want to delete the selected language?",
        "Cancel": "Cancel",
        "Delete": "Delete",
        "Language": "Language",
        "Field is required": "Field is required",
        "Add": "Add",
        "Cancel changes": "Cancel changes",
        "Save": "Save",
        "Web server": "Web server",
        "Add new hardware": "Add new hardware",
        "Captive portal URL": "Captive portal URL",
        "Will be created/updated profile for white list service with inputed URL": "Will be created/updated profile for white list service with inputed URL",
        "Profile name is hotspot_white_list_profile": "Profile name is hotspot_white_list_profile",
        "Session lifetime (sec)": "Session lifetime (sec)",
        "Session lifetime": "Session lifetime",
        "Redirect URL": "Redirect URL",
        "Subscriber will be redirected to URL after authorization proceed": "Subscriber will be redirected to URL after authorization proceed",
        "WiFi authorization configurations": "WiFi authorization configurations",
        "WiFi authorization enabled": "WiFi authorization enabled",
        "SMS authorization enabled": "SMS authorization enabled",
        "SMS authorization settings": "SMS authorization settings",
        "Call authorization enabled": "Call authorization enabled",
        "Call authorization settings": "Call authorization settings",
        "Sequential authorization": "Sequential authorization",
        "This mode allows you to select the initial authorization method": "This mode allows you to select the initial authorization method",
        "Debug mode": "Debug mode",
        "Debug mode allows you to send an authorization code to the email inputed to the phone number field.": "Debug mode allows you to send an authorization code to the email inputed to the phone number field.",
        "This function allows you to test after authorizations scripts.": "This function allows you to test after authorizations scripts.",
        "Click wrap configuration": "Click wrap configuration",
        "Click wrap enabled": "Click wrap enabled",
        "Policings configuration": "Policings configuration",
        "Authorization Policing": "Authorization Policing",
        "Wifi Policing": "Wifi Policing",
        "Payed Wifi Policing": "Payed Wifi Policing",
        "Subscribers services customization": "Subscribers services customization",
        "Captive portal customization": "Captive portal customization",
        "View configuration": "View configuration",
        "Favicon": "Favicon",
        "Logo": "Logo",
        "View image": "View image",
        "Language configuration": "Language configuration",
        "Add new language": "Add new language",
        "Key": "Key",
        "Value": "Value",
        "Set as dafault": "Set as dafault",
        "Logs": "Logs",
        "HotSpot tool interface log": "HotSpot tool interface log",
        "Refresh": "Refresh",
        "Click wrap log": "Click wrap log",
        "WIKI": "WIKI",
        "Add parameters to the request body or url for the request to be processed correctly": "Add parameters to the request body or url for the request to be processed correctly",
        "Example": "Example",
        "Phone": "Phone",
        "Code": "Code",
        "Body type": "Body type",
        "Settings was successfully saved": "Settings was successfully saved",
        "This language is already existing in dictionary!": "This language is already existing in dictionary!",
        "Configure <a href=\"https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:platform:subscriber_management:subsman_remote\">remote SSH commands</a>": "Configure <a target='_blank' href=\"https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:platform:subscriber_management:subsman_remote\">remote SSH commands</a>",
        "Set up on the trigger for issuing a new IP:": "Set up on the trigger for issuing a new IP:",
        "DHCP configuration": "DHCP configuration",
        "For Wi-Fi authorization use this trigger:": "For Wi-Fi authorization use this trigger:",
        "If you need only click-wrap function use this trigger:": "If you need only click-wrap function use this trigger:",
        "Input correct url!": "Input correct url!",
        "HotSpot": "HotSpot",
        "Wi-Fi tool interface log": "Wi-Fi tool interface log",
        "Image file max size is 750kb": "Image file max size is 750kb",
        "SMS": "SMS",
        "Call": "Call",
        "Common settings": "Common settings",
        "View settings": "View settings",
        "Localizations settings": "Localizations settings",
        "Auth and Click-Wrap settings": "Auth and Click-Wrap settings",
        "Services settings": "Services settings",
        "Tariffs settings": "Tariffs settings",
        "Session management enabled": "Session management enabled",
        "Session init Web-hook configuration": "Session init Web-hook configuration",
        "Authorization type": "Authorization type",
        "Outgoing call service settings": "Outgoing call service settings",
        "Outgoing call phones list": "Outgoing call phones list",
        "Secret key for hash generating": "Secret key for hash generating",
        "By auth code": "By auth code",
        "By outgoing call": "By outgoing call",
        "Enable Advertising (service id = 2)": "Enable Advertising (service id = 2)",
        "Enable Ad blocking (service id = 3)": "Enable Ad blocking (service id = 3)",
        "Enable black list (service id = 4)": "Enable black list (service id = 4)",
        "Use black list named profile": "Use black list named profile (service id = 4)",
        "CGNAT named profile (service id = 11)": "CGNAT named profile (service id = 11)",
        "Enable Notification (service id = 50)": "Enable Notification (service id = 50)",
        "No profile": "No profile",
        "Tariff": "Tariff",
        "HOTSPOT_WIKI_URL": "https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:dpiui:user_guide:ssg_control_section:management_hotspot",
        "If session management enabled - HotSpot will execute scripts for subscriber session initiation on DPI": "If session management enabled - HotSpot will execute scripts for subscriber session initiation on DPI",
        "If disabled - HotSpot will make http request for initiate subscriber session": "If disabled - HotSpot will make HTTP request for initiate subscriber session",
        "Subscriber session lifetime, seconds": "Subscriber session lifetime, seconds",
        "HotSpot will execute script for delete subscriber from DPI and load auth policing and captive portal service for his IP address": "HotSpot will execute script for delete subscriber from DPI and load auth policing and captive portal service for his IP address",
        "Subscriber session init HTTP request configuration": "Subscriber session init HTTP request configuration",
        "HotSpot will make http request for initiate subscriber session": "HotSpot will make http request for initiate subscriber session",
        "Request template params:": "Request template params:",
        "IP address": "IP address",
        "HTTP request configuration for sending a pre-generated authorization code via SMS": "HTTP request configuration for sending a pre-generated authorization code via SMS",
        "HTTP request configuration for sending a pre-generated authorization code via incoming call": "HTTP request configuration for sending a pre-generated authorization code via incoming call",
        "Call service settings": "Call service settings",
        "Input phone numbers separated by comas.": "Input phone numbers separated by comas.",
        "HotSpot will select random phone number from list for authorize subscriber by outgoing call.": "HotSpot will select random phone number from list for authorize subscriber by outgoing call.",
        "Configure your call service for sending HTTP request on call received from subscriber.": "Configure your call service for sending HTTP request on call received from subscriber.",
        "Available API method for receiving signal": "Available API method for receiving signal",
        "Hash generating:": "Hash generating:",
        "Advertising service(id=2) will apply for authorized subscriber.": "Advertising service(id=2) will apply for authorized subscriber.",
        "Ad blocking service(id=3) will apply for authorized subscriber.": "Ad blocking service(id=3) will apply for authorized subscriber.",
        "Black list service(id=3) will apply for authorized subscriber.": "Black list service(id=3) will apply for authorized subscriber.",
        "Black list service named profile will apply for authorized subscriber.": "Black list service(id=4) named profile will apply for authorized subscriber.",
        "CGNAT named profile will apply for authorized subscriber (service id = 11).": "CGNAT named profile will apply for authorized subscriber (service id = 11).",
        "Notification service(id=50) will apply for authorized subscriber.": "Notification service(id=50) will apply for authorized subscriber.",
        "Configure <a href=\"https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:platform:subscriber_management:subsman_remote\">remote ssh commands</a>": "Configure <a href=\"https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:platform:subscriber_management:subsman_remote\">remote ssh commands</a>",
        "Delete leading '+7' and '8' from phone": "Delete leading '+7' and '8' from client phone number"
    };

webix.i18n.locales["en-US"].dpiui2.MiniFirewallService = {
    "Are you sure you want to delete the profile?": "Are you sure you want to delete the profile?",
    "All subscribers associated with this profile will be unsubscribed from the Mini FireWall service.": "All subscribers associated with this profile will be unsubscribed from the Mini Firewall service.",
    "Cancel": "Cancel",
    "Delete": "Delete",
    "Mini Firewall profile": "Mini Firewall profile",
    "Description": "Description",
    "Profile title / description": "Profile title / description",
    "Port numbers": "Block ports until",
    "The port number, below which access is blocked": "The port number, below which access is blocked",
    "Allowed ports": "Exclude ports",
    "List of ports that are allowed to access bypassing the max_port limit":"List of ports that are allowed to access bypassing the max_port limit",
    "List of ports to which outbound traffic is closed": "List of ports to which outbound traffic is closed",
    "Closed ports": "Outbound Port Ban",
    "Save": "Save",
    "Profiles": "Profiles",
    "Add profile": "Add profile",
    "Enable profile": "Enable profile",
    "Disable profile": "Disable profile",
    "Refresh": "Refresh",
    "Profile with name 'noname' doesn`t support this feature!" : "Noname profiles doesn`t support this feature!",
    'noname': 'Noname profile',
    "Profile enabled": "Profile enabled",
    "Profile not enabled": "Profile not enabled",
    "Profile disabled": "Profile disabled",
    "Profile not disabled": "Profile not disabled",
    "Profile saved": "Profile saved",
    "Profile deleted": "Profile deleted",
    "Profile": "Profile",
    "Status": "Status",
    "Input correct integer number between 1 and 1024": "Input correct integer number between 1 and 1024"
};

webix.i18n.locales["en-US"].dpiui2.Services = {
    "License level": "License level",
    "License status": "License status",
    "Functions of this service will not work on DPI": "Functions of this service will not work on DPI",
    "Service not available for your DPI license level!": "Service not available for your DPI license level!",
    "Service available!": "Service available!"
};

webix.i18n.locales["en-US"].dpiui2.Dpiui2Config =
    {
        "Configuration loaded":"Configuration loaded",
        "Queue restarted successfully":"Queue restarted successfully",

        "New version [version] is available.":"New version [version] is available.",
        "Current version is":"Current version is",
        "Date of install / update is":"Date of install / update is",
        "Last check for update is":"Last check for update is",
        "Automatically install updates.":"Automatically install updates.",
        "Check for updates":"Check for updates",
        "Update now":"Update now",
        "DPIUI2 update":"DPIUI2 update",
        "DPIUI2(GUI) update":"DPIUI2(GUI) update",
        "DPIUI2 last update log":"DPIUI2 last update log",
        "DPIUI2 last check for update log":"DPIUI2 last check for update log",
        "Reversed order":"Reversed order",
        "Update can take several minutes. Please wait till it finished. Don`t forget press Ctrl+F5 after.":"Update can take several minutes. Please wait till it finished. Don`t forget press Ctrl+F5 after.",
        "The update script has completed the work. It` required to refresh the page. Click Refresh page or ctrl + f5.":"The update script has completed the work. It` required to refresh the page. Click Refresh page or ctrl + f5.",
        "Reload page":"Reload page",
        "Restart queue": "Restart queue",
        "Hot options updated!": "Hot options updated!",
        "Download from history":"Download from history"
    };

webix.i18n.locales["en-US"].dpiui2.SocketNotifications =
{
    "Are you sure you want to delete the selected records?": "Are you sure you want to delete the selected records?",
    "Cancel": "Cancel",
    "Delete": "Delete",
    "Are you sure you want to delete all the records?": "Are you sure you want to delete all the records?",
    "Details": "Details",
    "Mark as read": "Mark as read",
    "Notifications": "Notifications",
    "Close": "Close",
    "Select all notifications": "Select all notifications",
    "Read notifications": "Read notifications",
    "Read selected": "Read selected",
    "Read all": "Read all",
    "Delete notifications": "Delete notifications",
    "Delete selected": "Delete selected",
    "Delete all": "Delete all",
    "Refresh": "Refresh",
    "Back": "Back",
    "Status": "Status",
    "Notification date": "Notification date",
    "Notify type": "Notify type",
    "Notification content": "Notification content",
    "Unread notifications: ": "Unread notifications: ",
    "Unknown": "Unknown",
    "Subscribers synchronization completed successfully": "Subscribers synchronization completed successfully",
        "Subscribers and vchannels synchronization completed successfully": "Subscribers and vchannels synchronization completed successfully",
    "Ssh not connected": "SSH not connected",
    "Ssh connected": "SSH connected",
    "Hardware": "Hardware",
    "Information":"Information",
    "Warning": "Warning",
    "Error": "Error",
    "Success": "Success",
    "Other": "Other",
    "News": "News",
    "Subscribers synchronization": "Subscribers synchronization",
    "Subscribers and vchannels synchronization": "Subscribers and vchannels synchronization",
    "Messages": "Messages",
    "Ssh connection": "SSH connection",
    "Read": "Read",
    "New": "New",
    "Trigger fired": "Trigger fired",
    "Forcing moving or removing data for":"Forcing moving or removing data for",
    "Partitions to move":"Partitions to move",
    "Partitions to remove":"Partitions to remove",
    "QoE report ready": "QoE report ready",
    "QoE report": "QoE report"
};

webix.i18n.locales["en-US"].dpiui2.QoEStorConfig =
    {
        "Do you want to restart configuration?":"Do you want to restart configuration?",
        "Add receiver":"Add receiver",
        "Restart finished":"Restart finished",
        "QoE Stor nodes":"QoE Stor nodes",
        "There is no QoE Stor nodes.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>.":"There is no QoE Stor nodes.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>.",
        "Forced download of directories": "Forced download of directories",
        "Forced download finished":"Forced download finished",
        "Start Forced Download":"Start Forced Download",
        "Started dictionaries forced download in background":"Started dictionaries forced download in background",
        "Move":"Move",
        "You are not authorized in VAS Cloud":"You are not authorized in VAS Cloud",
        "Move to login page?":"Move to login page?",

        "fullflow aggregation settings":"fullflow aggregation settings",
        "fullflow additional aggregation settings":"fullflow additional aggregation settings",
        "After how many days to reaggregate logs":"After how many days to reaggregate logs",
        "Time interval for log aggregation":"Time interval for log aggregation",
        "The data from the fullflow_agg table will be reaggregated at the specified interval in the fullflow_agg_compressed_N table and after the specified number of days will be moved to the fullflow_agg table and replace the corresponding partitions.":"The data from the fullflow_agg table will be reaggregated at the specified interval in the fullflow_agg_compressed_N table and after the specified number of days will be moved to the fullflow_agg table and replace the corresponding partitions.",
        "Stage":"Stage",
        "After 7 days":"After 7 days",
        "After 30 days":"After 30 days",
        "Enable fullflow additional aggregation Stage":"Enable fullflow additional aggregation Stage",
        "Specify the number of days to reaggregate on stage":"Specify the number of days to reaggregate on stage",
        "Time interval for fullflow log aggregation must be less than time on stage":"Time interval for fullflow log aggregation must be less than time on stage",
        "The number of days for reaggregation on stage 1 must be less than on stage 2.":"The number of days for reaggregation on stage 1 must be less than on stage 2.",
        "The time interval for reaggregation on stage 1 must be less than on stage 2.":"The time interval for reaggregation on stage 1 must be less than on stage 2.",

        "Restart receivers": "Restart receivers",
        "Stop receivers": "Stop receivers",
        "Are you sure?":"Are you sure?",
        "Are you sure you want to restart all receivers?":"Are you sure you want to restart all receivers?",
        "Are you sure you want to stop all receivers?":"Are you sure you want to stop all receivers?",
        "QoE receivers successfully restarted.":"QoE receivers successfully restarted.",
        "QoE receivers successfully stopped.":"QoE receivers successfully stopped.",
        "Download receivers configuration file":"Download receivers configuration file",
        "Upload receivers configuration from file":"Upload receivers configuration from file",
        "configuration file":"configuration file",
        "Restart configuration": "Restart configuration"
    };

webix.i18n.locales["en-US"].dpiui2.FastPcrfConfig = {
    "Service restarted successfully": "FastPCRF service restarted successfully",
    "Service reloaded successfully": "FastPCRF service reloaded successfully",

    "All fastdpi services from property fdpi_server will be restarted!": "All fastdpi services from property fdpi_server will be restarted!",
    "FastDPI service started successfully": "FastDPI service started successfully",
    "FastDPI service stopped successfully": "FastDPI service stopped successfully",
    "Fast PCRF config saved!": "Fast PCRF config saved!",
    "Update the hot parameters or restart Fast PCRF for applying the changes!": "Update the hot parameters or restart Fast PCRF for applying the changes!",
    "Configuration loaded.": "Configuration loaded.",
    "Applied": "Applied",
    "FastDPI service restarted successfully": "FastDPI service restarted successfully"
};

webix.i18n.locales["en-US"].dpiui2.SshTerminal = {
        "Welcome to remote hardware terminal!": "Welcome to remote hardware terminal!",
        "Hardware ssh terminal": "Hardware SSH terminal",
        "Hardwares": "Hardwares",
        "Hardware": "Hardware",
        "Type": "Type",
        "Hardware connections": "Hardware connections",
        "Terminal": "Terminal",
        "Clear": "Clear",
        "Execute": "Execute",
        "Commands": "Commands"

};

webix.i18n.locales["en-US"].dpiui2.Vchannels = {
        "Vchannel number": "Vchannel number",
        "Vchannel name": "Vchannel name",
        "Tariffs": "Tariffs",
        "Are you sure you want to delete services and tariffs in the selected records?": "Are you sure you want to delete services and tariffs in the selected records?",
        "List of vchannels": "List of vchannels",
        "No services": "No services",
        "Services": "Services",
        "Tariffs": "Tariffs",
        "Delete": "Delete",
        "Update": "Update",
        "Forced vchannels synchronization": "Forced vchannels synchronization",
        "Refresh": "Refresh",
        "No profile": "No profile",
        "Forced synchronization vchannels running in the background": "Forced synchronization vchannels running in the background",
        "Deleted": "Deleted",
        "Error": "Error",
        "See logs": "See logs",
        "Vchannel": "Vchannel",
        "Saved": "Saved",
        "Id": "Id",
        "Service": "Service",
        "Enabled": "Enabled",
        "Disabled": "Disabled",
        "Profile": "Profile",
        "Tariff": "Tariff",

        "Are you sure you want to save the cidr list?":"Are you sure you want to save the cidr list? ",
        "When you click on the Save button, only the CIDR list is saved":"When you click on the «Save» button, only the CIDR list is saved",
        "Vchannel settings saved": "Vchannels list settings saved",
        "List of CIDRs for Vchannels":"List of CIDRs for Vchannels",
        "Vchannel number":"vchannel number"
};

webix.i18n.locales["en-US"].dpiui2.Protocols = {
        "Hardwares": "Hardwares",
        "Protocols": "Protocols",
        "Custom Protocols": "Custom protocols",
        "Resource List": "Resource List",
        "Custom protocols: Resource List": "Custom protocols: Resource List",
        "List type": "List type",
        "Number": "Number",
        "Description": "Description",
        "Type": "Type",
        "Test": "Test",
        "Main": "Main",
        "Enabled": "Enabled",
        "Status": "Status",
        "Status Description": "Status Description",
        "Event": "Event",
        "Attempts": "Attempts",
        "Create Time": "Create Time",
        "Update Time": "Update Time",
        "Create User": "Create User",
        "Update User": "Update User",
        "Custom number": "Custom number",
        "Main List": "Main List",
        "Custom number is a protocol identifier, a range limited to values from 1 to 4096 is reserved for custom protocols.": "Custom number is a protocol identifier, a range limited to values from 1 to 4096 is reserved for custom protocols.",
        "Protocol saved": "Protocol saved",
        "Protocol saved successfully":"Protocol saved successfully",
        "Protocol deleted successfully":"Protocol deleted successfully",

        "Synchronization mode":"Synchronization mode",
        "Company":"Company",
        "Hardware saved successfully":"Hardware saved successfully",
        "Protocols erased successfully":"Protocols erased successfully",
        "Protocols deleted successfully":"Protocols deleted successfully",
        "Protocol enabled successfully":"Protocol enabled successfully",
        "Protocol disabled successfully":"Protocol disabled successfully",
        "Protocols enabled successfully":"Protocols enabled successfully",
        "Protocols disabled successfully":"Protocols disabled successfully",
        "Protocol Item enabled successfully":"Protocol Item enabled successfully",
        "Protocol Item disabled successfully":"Protocol Item disabled successfully",
        "Protocol Items enabled successfully":"Protocol Items enabled successfully",
        "Protocol Items disabled successfully":"Protocol Items disabled successfully",
        "Resource List saved successfully":"Resource List saved successfully",
        "Resource List deleted successfully":"Resource List deleted successfully",
        "Protocols Items erased successfully":"Protocols Items erased successfully",
        "Protocols Items deleted successfully":"Protocols Items deleted successfully",
        "Imported successfully":"Imported successfully",
        "Custom Protocols Items":"Custom protocols items",

        "Type of list<br/>Which list to load on the equipment: Main or Test.<br/>Default is Main.":"Type of list<br/>Which list to load on the equipment: Main or Test.<br/>Default is Main.",
        "Synchronization mode<br/>Protocol list synchronization mode.<br/>By DPIUI2 - dpiui2 module downloads lists to equipment.<br/>By URL - FastDPI downloads lists by link.<br/>By URL is default.":"Synchronization mode<br/>Protocol list synchronization mode.<br/>By DPIUI2 - dpiui2 module downloads lists to equipment.<br/>By URL - FastDPI downloads lists by link.<br/>By URL is default.",

        "ok":"ok",
        "error":"error",
        "downloading":"downloading",
        "unpacking":"unpacking",
        "preparing":"preparing",
        "uploading":"uploading",
        "reloading":"reloading",
        "clearing":"clearing",

        "Clear list":"Clear list",

        "Get":"Get",
        "Record":"Record",
        "Items added successfully":"Items added successfully",

        "Validation error":"Validation error",

        "For single IP\n201.1.1.1\n2001:db9::1\n\nFor IP with port\n201.1.2.3 8081\n2001:db9::1 9090\n\nFor CIDR\n201.198.4.0/24\n2001:db8::0/64":"For single IP\n201.1.1.1\n2001:db9::1\n\nFor IP with port\n201.1.2.3 8081\n2001:db9::1 9090\n\nFor CIDR\n201.198.4.0/24\n2001:db8::0/64",
        "For single IP":"For single IP",
        "For IP with Port":"For IP with Port",
        "For CIDR":"For CIDR",
        "For CIDR with Port":"For CIDR with Port",

        "Data":"Data",
        "Help":"Help",

        "Automatic resource type detection":"Automatic resource type detection",
        "For some domain":"For some domain",
        "For some subdomain":"For some subdomain",
        "For domain with all subdomains":"For domain with all subdomains",

        "Any AS number":"Any AS number"
};

webix.i18n.locales["en-US"].dpiui2.DDoSProtectionService = {
        "Are you sure you want to delete the profile?": "Are you sure you want to delete the profile?",
        "All subscribers associated with this profile will be unsubscribed from the DDoS Protection service.": "All subscribers associated with this profile will be unsubscribed from the DDoS Protection service.",
        "Cancel": "Cancel",
        "Delete": "Delete",
        "Save": "Save",
        "Profiles": "Profiles",
        "Add profile": "Add profile",
        "Enable profile": "Enable profile",
        "Disable profile": "Disable profile",
        "Refresh": "Refresh",
        "Status": "Status",
        "Profile with name 'noname' doesn`t support this feature!" : "Noname profiles doesn`t support this feature!",
        'noname': 'Noname profile',
        "Profile enabled": "Profile enabled",
        "Profile not enabled": "Profile not enabled",
        "Profile disabled": "Profile disabled",
        "Profile not disabled": "Profile not disabled",
        "Profile saved": "Profile saved",
        "Profile deleted": "Profile deleted",
        "Profile": "Profile",
        "Profile name":"Profile name",
        "Enter profile name":"Enter profile name",
        "Profile title / description": "Profile title / description",
        "DDoS Protection profile": "DDoS Protection profile",
        "DoS configuration": "DoS configuration",
        "Protection mode": "Protection mode",
        "The sync per second threshold": "The sync per second threshold",
        "Logging of protection triggering":"Logging of protection triggering",
        "Enter value between 0 and 2": "Enter value between 0 and 2",
        "Enter value between 0 and 1": "Enter value between 0 and 1",
        "Enter a value higher than 0": "Enter a value higher than 0",
        "Enter value between 0 and 100":"Enter value between 0 and 100",
        "The interval of checking the amount of syn in milliseconds": "The interval of checking the amount of syn in milliseconds",
        "The time interval for monitoring the response to syn+ack":"The time interval for monitoring the response to syn+ack",
        "Protected port numbers":"Protected port numbers",
        "% of unconfirmed queries for activating protection":"% of unconfirmed queries for activating protection",
        "CAPTCHA page":"CAPTCHA page",
        "Encryption key":"Encryption key",
        "Number of requests per second in normal operation":"Number of requests per second in normal operation",
        "% of possible rejection of requests during normal operation of the site":"% of possible rejection of requests during normal operation of the site",
        "Number of packets per second in normal operation":"Number of packets per second in normal operation",
        "% of possible deviation of packets during normal operation of the site":"% of possible deviation of packets during normal operation of the site",
        "The CAPTCHA server is not connected. Connect in the Hardware section":"The CAPTCHA server is not connected. Connect in the Hardware section",

        "For single IP\n201.1.1.1\n2001:db9::1\n\nFor IP with port\n201.1.2.3 8081\n2001:db9::1 9090\n\nFor CIDR\n201.198.4.0/24\n2001:db8::0/64":"For single IP\n201.1.1.1\n2001:db9::1\n\nFor IP with port\n201.1.2.3 8081\n2001:db9::1 9090\n\nFor CIDR\n201.198.4.0/24\n2001:db8::0/64",

        "DPI Version": "DPI Version",

        //DicDDoSLocale
        "Protection is off":"Protection is off",
        "Protection is activated automatically":"Protection is activated automatically",
        "Protection is always on":"Protection is always on",
        "Alert logging is off":"Alert logging is off",
        "Alert logging triggering on/off":"Alert logging triggering on/off",

        //HelpPopupLocale
        "Link to wiki": "Link to wiki",

        //DOS
        "To switch the protection mode on and off (off by default) ": "To switch the protection mode on and off (off by default) ",
        "Protection triggering logging (default No) ": "Protection triggering logging (default No) ",
        "Threshold for number of syn per second (no confirmation) when we consider everything OK (default is 50) ": "The threshold for the number of SYN requests per second (unanswered) at which traffic is considered normal (default is 50) ",
        "Interval in milliseconds for checking the number of syn and verified syn (defaults to 100) ":"Interval in milliseconds for checking the number of syn and verified syn (defaults to 100) ",
        "Time interval in seconds to monitor the syn+ack response generated by the scat (default is 60) ":"Time interval in seconds to monitor the syn+ack response generated by the scat (default is 60) ",
        "The main configuration file /etc/dpi/fastdpi.conf specifies the protected port numbers (default is 80, can be changed online) ":"The main configuration file /etc/dpi/fastdpi.conf specifies the protected port numbers (default is 80, can be changed online) ",
        "Percentage of unconfirmed client requests at which protection is automatically activated (default 5, can be changed online) ":"Percentage of unconfirmed client requests at which protection is automatically activated (default 5, can be changed online) ",

        //DDOS
        "CAPTCHA page to be redirected to for verification ":"CAPTCHA page to be redirected to for verification ",
        "The encryption key used in generating the tokens that indicate to the dpi that the verification has been successfully passed ":"The encryption key used in generating the tokens that indicate to the SSG that the verification has been successfully passed ",
        "The number of requests per second to the protected site, usually selected at the maximum value observed during normal operation of the site ":"The number of requests per second to the protected site, usually selected at the maximum value observed during normal operation of the site ",
        "Is the percentage of possible deviation from the threshold set in ddos_reqsec_threshold at which protection is activated or deactivated respectively, set to avoid the «chatter effect» and set to 5% by default ":"Is the percentage of possible deviation from the threshold set in the (Number of requests per second during normal operation) field at which the protection is activated or deactivated respectively, set to avoid the «chatter effect» and set to 5% by default ",
        "The number of packets per second arriving at the protected site, usually selected at the maximum value observed during normal operation of the site ":"The number of packets per second arriving at the protected site, usually selected at the maximum value observed during normal operation of the site ",
        "Is the percentage of possible deviation from the threshold set in ddos_pktsec_threshold at which protection is activated or deactivated respectively, set to avoid the «chatter effect» and set to 5% by default ":"Is the percentage of possible deviation from the (Number of packets per second during normal operation) threshold at which protection is activated or deactivated respectively, set to avoid a «chatter effect» and set to 5% by default ",

};

webix.i18n.locales["en-US"].dpiui2.WikiLinks = {
        "wiki_doku_link":"https://wiki.vasexperts.ru/doku.php?id=",
        "dpiui2_versions_info":"en:dpi:dpi_components:dpiui:install_and_update:version_information",
        "ddos_settings":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_ddos:ddos_ddos:ddos_ddos_settings",
        "ddos_dos_synflood":"https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_ddos:ddos_dos:ddos_dos_synflood",

        "qoe_online_reports":"https://wiki.vasexperts.com/doku.php?id=dpi:qoe:use_cases:online_reports_module"
};

webix.i18n.locales["en-US"].dpiui2.BalancerConfig =
{
        "Balancer servers": "IPFIX-balancer servers",
        "There is no Balancer servers.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>.":"There is no IPFIX-balancer servers.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>."
};

webix.i18n.locales["en-US"].dpiui2.Messages =
{
        "Delete messages": "Delete messages",
        "Are you sure you want to delete all messages?": "Are you sure you want to delete all messages?",
        "Are you sure you want to delete the selected messages?": "Are you sure you want to delete the selected messages?",
        "Message date": "Message date",
        "Message type": "Message type",
        "Message content": "Message content",
        "Select all messages": "Выбрать все сообщения",
        "Read messages": "Прочитать сообщения"
};

webix.i18n.locales["en-US"].dpiui2.HardwareSshKeys =
{
        "SSH keys": "SSH keys",
        "SSH key": "SSH key",
        "Add ssh key": "Add SSH key",
        "Private key": "Private key",
        "Public key": "Public key",
        "Clear SSH keys": "Clear SSH keys",
        "Generate SSH keys": "Generate SSH keys",
        "Generate": "Generate",
        "Generating SSH keys": "Generating SSH keys",
        "Do you really want to delete the ssh key?": "Do you really want to delete the ssh key?",
        "Download public key": "Download public key",
        "Download private key": "Download private key",
        "Upload public key": "Upload public key",
        "Upload private key": "Upload private key",
        "Generate SSH key successfully": "Generate SSH key successfully",
        "Passphrase": "Passphrase",
        "PASSPHRASE_HELP_POPUP_TEXT": "Enter the passphrase you specified when creating the key.<br><br>If the passphrase has not been set, leave the field blank",
        "SSH_KEY_HELP_POPUP_TEXT": "Ssh configuration for connecting to equipment - <a href='https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:dpiui:user_guide:admin_section:equipment_management:ssh_keys' target='_blank'>article</a>.<br><br>f the required ssh files are missing, you can create them using key generation by clicking on the key button above and, after generation, download them to set up an ssh connection to the equipment.<br><br>If the private key is encrypted, you must provide a passphrase.",
        "Algorithm": "Algorithm",
        "Format": "Format",
};

webix.i18n.locales["en-US"].dpiui2.MailingTemplates = {
        "Template":"Template",
        "Template name":"Template name",
        "Template data":"Template data",
        "Add template":"Add template",
        "Add new template":"Add new template",
        "Edit template":"Edit template",
        "Copy template":"Copy template",
        "Delete template":"Delete template",
        "Template editing":"Template editing",
        "Template type":"Template type",
        "Email":"Email",
        "Telegram":"Telegram",
        "Set default template":"Set default template",
        "Template options":"Template options",
        "Please, select template or create new":"Please, select template or create new",
        "Template successfully saved.":"Template successfully saved.",
        "Template successfully deleted.":"Template successfully deleted.",
        "Or double click to add item to the template.":"Or double click to add item to the template.",
        "Templates visibility":"Templates visibility",
        "Set the user to see only their own templates or also templates of other users.":"Set the user to see only their own templates or also templates of other users.",
        "Templates of all users":"Templates of all users",
        "Only user templates":"Only user templates",
        "Templates editability":"Templates editability",
        "Set the user to edit only their own templates or also templates of other users.":"Set the user to edit only their own templates or also templates of other users.",
        "Restore template":"Restore template",
        "View template":"View template",
        "Show template":"Show template",
        "for user":"for user",
        "for all users":"for all users",
        "Template visibility":"Template visibility",
        "Final report":"Final report",
        "Links to reports":"Links to reports",
        "Links to PDF reports":"Links to PDF reports",
        "Default template":"Default template",
        "XLSX template":"XLSX template",
        "PDF template":"PDF template",
        "redmine.json default template":"redmine.json default template",
        "redmine.xml default template":"redmine.xml default template",
        "Display period in filename":"Display period in filename",
        "Display period":"Display period"
};

webix.i18n.locales["en-US"].dpiui2.CustomProtocolsGroups = {
        "Custom protocols groups": "Protocol group Management",
        "Protocols groups": "Protocols groups",
        "Override Cloud": "Override Cloud",
        "Create a new group": "Create a new group",
        "Group code": "Group code",
        "Group name": "Group name",
        "Cloud protocol": "Cloud protocol",
        "Cloud group": "Cloud group",
        "Custom protocol": "Custom protocol",
        "Add cloud protocol": "Add cloud protocol",
        "Add custom protocol": "Add custom protocol",
        "Protocol type": "Protocol type",
        "Cloudy": "Cloud",
        "Custom": "Custom",
        "Protocol": "Protocol"
};
webix.i18n.locales["ru-RU"].vascloud = {};

webix.i18n.locales["ru-RU"].vascloud.AppView =
    {
        Title:"VAS Cloud",

        "DPI control":"Управление DPI",
        "Performance":"Производительность",
        "Configuration":"Конфигурация",
        "Protocol prioritization (DSCP)":"Приоритизация по протоколам (DSCP)",
        "Priority for ASN":"Приоритизация по ASN",
        "Prioritization for autonomous systems (AS)":"Приоритизация для автономных систем (AS)",
        "Logs":"Логи",

        "Services control":"Управление услугами",
        "Subscribers and services":"Абоненты и услуги",
        "Subscribers":"Абоненты",
        "Services":"Услуги",
        "Tariff plans":"Тарифные планы",
        "Adv control": "Управление рекламой",

        "QoE analytics":"QoE аналитика",
        "QoE dashboard":"QoE дашборд",
        "Dashboard":"Дашборд",
        "Clickstream":"Кликстрим",
        "Netflow":"Нетфлоу",
        "Administrator":"Администратор",
        "Licences":"Лицензии",
        "Licenses Token": "Токены Лицензий",
        "Companies":"Компании",
        "Javascript lists":"Списки яваскриптов",
        "Prepared Javascript templates":"Подготовленные шаблоны яваскриптов",
        "Javascript templates":"Шаблоны яваскриптов",
        "Javascript rules":"Правила для яваскриптов",
        "Javascript cache":"Кеш яваскриптов",
        "Statistics":"Статистика",
        "JS statistics":"JS статистика",
        "Javascript statistics":"Javascript статистика",
        "ADS statistics":"ADS статистика",
        "Accruals and payments":"Начисления и платежи",

        "Restart fastdpi":"Перезапуск fastdpi",
        "Updating hot options":"Обновление горячих параметров",
        "Updating options":"Обновление параметров",
        "Device information":"Информация об устройстве",
        "License information":"Информация о лицензии",
        "Select from list":"Выбрать из списка",
        "Managing the list of devices":"Управление списком оборудования",

        "My profile":"Мой профиль",
        "Users":"Пользователи",
        "Roles":"Роли",
        "Managing users and roles":"Управление пользователями и ролями",

        "Log out":"Выход",

        "Edit profile":"Редактирование профиля",
        "Username":"Имя пользователя",
        "Enter user name":"Введите имя пользователя",
        "Full name":"ФИО",
        "Last name First name Middle name":"Фамилия Имя Отчество полностью",
        "Enter your full name":"Введите ФИО полностью",
        "Position":"Должность",
        "Enter your position":"Введите должность",
        "Organization":"Организация",
        "Name of the organization":"Название организации",
        "Enter the name of the organization":"Введите название организации",
        "Enter your e-mail":"Введите e-mail",
        "Phone":"Телефон",
        "Contact number":"Контактный телефон",
        "Enter phone number":"Введите номер телефона",
        "Change password":"Смена пароля",
        "Old password":"Старый пароль",
        "Enter password":"Введите пароль",
        "New password":"Новый пароль",
        "Confirm password":"Подтвердить пароль",
        "Passwords do not match":"Пароли не совпадают",

        "Are you sure you want to restart the fastdpi process?":"Вы действительно хотите перезапустить fastdpi процесс?",
        "Are you sure you want to update the hot settings?":"Вы действительно хотите произвести обновление горячих параметров?",
        "Restart":"Перезапустить",
        "No equipment selected":"Не выбрано оборудование",

        "Name":"Название",
        "Port":"Порт",
        "Login":"Логин",
        "Can be controlled by other GUI":"Может управляться другими GUI",

        "Start fastdpi error": "Ошибка запуска FASTDPI",
        "fastdpi is stopped": "FASTDPI остановлен",
        "fastdpi остановлен": "FASTDPI остановлен",
        "Classifier": "Классификатор",
        "Hosts Categories":"Категории сайтов",
        "Protocols":"Протоколы",
        "Protocol groups":"Группы протоколов",

        "Request Trial":"Список заявок",
        "Logging": "Журнал действий пользователя",

        "App statistics":"Аналитика",
        "Test companies":"Тестовые компании",
        "Companies without SD":"Компании без ТП",

        "DPI version":"Версия DPI"
    };

webix.i18n.locales["ru-RU"].vascloud.LoginView =
    {
        "Sign in to control panel CKAT DPI":"Войти в панель управления СКАТ",
        "Login":"Логин",
        "Enter login":"Введите логин",
        "Password":"Пароль",
        "Enter password":"Введите пароль",
        "Remember me":"Запомнить меня",
        "Sign in":"Войти"
    };

webix.i18n.locales["ru-RU"].vascloud.All =
    {
        "Yes":"Да",
		"No":"Нет",

    	"No connection":"Нет соединения",
        "In developing":"В разработке",
        "Access denied":"Доступ запрещен",

        "Russian":"Русский",
        "Rus.":"Рус.",
        "English":"Английский",
        "Eng.":"Англ.",

        "Add":"Добавить",
        "Refresh":"Обновить",
		"Cancel":"Отменить",
        "Delete":"Удалить",
        "Remove all":"Удалить все",
        "Close":"Закрыть",
        "Save":"Сохранить",
        "Add value":"Добавить значение",
        "Upload from file":"Загрузить из файла",
        "Download from history":"Загрузить из истории",
        "Saved":"Сохранено",
        "Deleted":"Удалено",
        "Removed":"Удалено",

        "Are you sure you want to delete the selected records?":"Вы действительно хотите удалить выбранные записи?",
        "Are you sure you want to remove all list items?":"Вы действительно хотите удалить все записи?",

        "The form":"Форма",
        "Editor":"Редактор",

        "Settings":"Настройки",

        "Click to download or drag a file": "Нажмите чтобы загрузить или перетащите сюда файл",
        "Apply": "Применить",
        "Applied": "Применено",
        "History": "История",
        "Could not upload file": "Не удалось загрузить файл",
        "Config": "Конфиг",

        "Back":"Назад",
        "Forward":"Вперед",

        "Date": "Дата",

        "Download the complete file":"Скачать файл полностью",

        "Error":"Ошибка",
        "See logs":"Смотрите логи",

        "History loaded":"История загружена",
        "Verified":"Проверено",

        "Restart was successful":"Перезапуск произведен успешно",
        "Hot options updated":"Горячие параметры обновлены",

        "Parser error":"Ошибка парсера",

        "Total":"Всего",
        "Done":"Выполнено",

        "Period":"Период",
        "Interval":"Интервал",
        "1 minute":"1 минута",
        "15 minutes":"15 минут",
        "30 minutes":"30 минут",
        "1 hour":"1 час",
        "1 day":"1 день",
        "1 month":"1 месяц",

        "Bytes":"Байт",
        "Kb":"Кб",
        "Mb":"Мб",
        "Gb":"Гб",
        "Tb":"Тб",

        "Bytes/s":"Байт/s",
        "Kb/s":"Кб/сек",
        "Mb/s":"Мб/сек",
        "Gb/s":"Гб/сек",
        "Tb/s":"Тб/сек",

        "Bit/s":"Бит/s",
        "Kbit/s":"Кбит/сек",
        "Mbit/s":"Мбит/сек",
        "Gbit/s":"Гбит/сек",
        "Tbit/s":"Тбит/сек",

        "Pkts/s":"Пак/сек",
        "Kpkts/s":"Кпак/сек",
        "Mpkts/s":"Мпак/сек",
        "Gpkts/s":"Гпак/сек",
        "Tpkts/s":"Тпак/сек",

        "ns":"нс",
        "µs":"мкс",
        "ms":"мс",
        "s":"с",
        "ks":"кс",
        "Ms":"Мс",
        "Gs":"Гс",
        "Ts":"Тс",

        "K":"К",
        "M":"М",
        "G":"Г",
        "T":"Т",

        "On":"Вкл.",
        "Off":"Выкл.",

        "Reset":"Сбросить",
        "By default":"По умолчанию",

        "Next":"Продолжить",

        "Page size":"Размер страницы",
        "Export":"Экспорт",
        "File name":"Имя файла",
        "Export format":"Формат экспорта",
        "Switch form?": "Переключить форму?",
        "There are unsaved changes. Are you sure you want to switch form?": "Есть несохраненные изменения.<br/>Вы уверены, что хотите переключить форму?",
        "Switch": "Переключить",

        "Import from file":"Импорт из файла",
        "Export to Excel":"Экспорт в Эксель",
        "Import":"Импорт",
        "Get template":"Получить шаблон",

        "On page":"На странице",

        "Imported":"Импортировано",
        "LK User": "Пользователь ЛК",
        "LK Super user": "ЛК SU",
        "Tickets": "Обращения",
        "All users tickets": "Обращения всех пользователей",
        "Only my tickets": "Только мои обращения",
        "Set to see tickets of all users or not. User can see all tickets by default.": "Установка видимости обращений: всех пользователей или только своих. По умолчанию пользователь видит обращения всех пользователей.",
        "LK User company admin": "Администратор компании ЛК",
        "Of": "Из"
    };

webix.i18n.locales["ru-RU"].vascloud.Roles =
    {
        "Are you sure you want to delete the role?":"Вы действительно хотите удалить роль?",

        "Roles":"Роли",
        "Add role":"Добавить роль",

        "Role":"Роль",

        "Program sections":"Разделы программы",
        "Code":"Код",
        "Section":"Раздел",
        "Read":"Чтение",
        "Record":"Запись",
        "Removal":"Удаление"
    };

webix.i18n.locales["ru-RU"].vascloud.Users =
    {
        "Are you sure you want to delete the user?":"Вы действительно хотите удалить пользователя?",
        "User name":"Имя пользователя",
        "Enter user name":"Введите имя пользователя",
        "Full name":"ФИО",
        "Enter full name":"Введите ФИО полностью",
        "Enter e-mail":"Введите e-mail",
        "Phone":"Телефон",
        "Enter phone number":"Введите номер телефона",
        "Company":"Компания",
        "Enter the name of the organization":"Введите название организации",
        "Position":"Должность",
        "Enter the position":"Введите должность",
        "Role":"Роль",
        "User saved":"Пользователь сохранен",
        "Enter the company":"Выберите компанию",

        "Passwords do not match":"Пароли не совпадают",

        "New password":"Новый пароль",
        "Enter password":"Введите пароль",
        "Confirm password":"Подтвердить пароль",

        "Add user":"Добавить пользователя",
        "Users":"Пользователи",
        "Generate password":"Сгенерировать пароль",
        "Copied to clipboard":"Скопировано в буфер обмена",
        "Block user": "Заблокировать пользователя",
        "User blocked": "Пользователь заблокирован",
        "Are you sure you want to block this user?": "Вы действительно хотите заблокировать этого пользователя?",
        "Block": "Заблокировать"
    };

webix.i18n.locales["ru-RU"].vascloud.CreateTicket =
    {
        "Send a message":"Отправить сообщение",
        "Message subject":"Предмет сообщения",
        "Message text":"Текст сообщения",
        "Enter here any text":"Введите сюда любой текст",
        "DPI message Log":"Лог сообщений DPI",
        "Log of information messages and errors":"Лог информационных сообщений и ошибок",
        "DPI statistics log":"Лог статистики DPI",
        "UI log":"UI лог",
        "Send":"Отправить",
        "Message sent successfully":"Сообщение успешно отправлено"
    };

webix.i18n.locales["ru-RU"].vascloud.Lics =
    {
        "Licence":"Лицензия",
        "Licences":"Лицензии",
        "Product type":"Продукт",
        "Company":"Компания",
        "Licence level":"Уровень лицензии",
        "DPI licence level":"Уровень лицензии DPI",
        "Expiration date":"Срок лицензии",
        "Support expiration date":"Срок поддержки",
        "Product uuid":"UUID продукта",
        "Licence limit":"Лимит",
        "Board serial":"Серийный номер платы",
        "Chassis serial":"Серийный номер шасси",
        "Product serial":"Серийный номер продукта",
        "MAC addresses":"MAC адреса",
        "Speeds":"Скорости",
        "Add licence":"Добавить лицензию",
        "Active":"Активна",
        "Not active":"Неактивна",
        "Licence enabled":"Лицензия активна",
        "Licence disabled":"Лицензия неактивна",
        "Contact ID": "ИД контакта",
        "Contact name": "Имя контакта",
        "Contact phone": "Телефон контакта",
        "Contact email": "Email контакта",
        "Contact organization": "Название организации",
        "Renewal":"Обновление",
        "Permanent":"Постоянная",
        "Lics Saved":"Лицензия сохранена",
        "General":"Общие",
        "License parameters" : "Параметры лицензии",
        "Set flag Refresh": "Установить флаг Обновление",
        "Unflag Refresh": "Снять флаг Обновление",
        "License Updated": "Лицензии обновлены",
        "Mass Refresh": "Массовые операции",
        "Lic Options" : "Опции лицензии",
        "Add option" : "Добавить опцию",
        "Option name" : "Название опции",
        "License data": "Данные лицензии",
        "License version": "Версия лицензии",
        "Unbound": "Привязка",
        "Contact data": "Контактные данные",
        "Person": "Персона",
        "Email": "E-mail",
        "Bios vendor": "Вендор БИОСа",
        "Board name": "Название платы",
        "Board vendor": "Вендор платы",
        "Product name": "Название продукта",
        "Product UUID": "UUID продукта",
        "Code": "Код",
        "Description": "Описание",
        "VasCloud local license": "Локальная лицензия VasCloud",
        "DPI remote license": "Серверная лицензия DPI",
        "Licence data successfully uploaded":"Данные о лицензиях успешно загружены",
        "License on VAS Cloud":"Лицензия в VAS Cloud",
        "License on 'lics server'":"Лицензия на 'lics server'",
        "EPDG / PCEF / PGW license data": "Данные EPDG / PCEF / PGW лицензии",

        "Host Name": "Имя хоста",
        "Host Addr": "Адрес хоста",
        "Oper mcc": "Oper mcc",
        "Oper mnc": "Oper mnc",
        "IMSI range": "Диапазон IMSI",
        "Served Realm": "Served Realm",
        "Served Apn": "Served Apn",
        "Served net": "Served net",
        "Auth mode": "Режим аутентификации",
        "Tune mode": "Tune mode",
        "Max users": "Максимальное кол-во пользователей",
        "Max bitrate": "Максимальный bitrate",
        "Max CPU": "Максимально CPU",
        "Max threads": "Максимально потоков",
        "Max auth servers": "Максимальное кол-во серверов аутентификации",
        "Max tun servers": "Max tun servers",
        "Feature balance": "Feature balance",
        "Feature failover": "Feature failover",
        "Feature ipv4 kernel gtpu": "Feature ipv4 kernel gtpu",
        "Feature ipv4 soft gtpu": "Feature ipv4 soft gtpu",
        "Feature ipv4 kernel ipv6 soft gtpu": "Feature ipv4 kernel ipv6 soft gtpu",
        "Feature ipv4 soft ipv6 soft gtpu": "Feature ipv4 soft ipv6 soft gtpu",
        "Unavailable for selected licenses": "Недоступно для выбранных лицензий",
        "Options successfully updated for selected licenses": "Опции успешно обновлены для выбранных лицензий",
        "Set options": "Задать опции",
        "Hardware Expiration date": "Срок лицензии на оборудовании",
        "Expiration dates are different!": "Сроки лицензий отличаются!"
    };

webix.i18n.locales["ru-RU"].vascloud.Companies =
    {
        "Companies":"Компании",
        "Company":"Компания",
        "Company Id":"ИД компании",
        "Are you sure you want to delete the company?":"Вы действительно хотите удалить компанию?",
        "Add company":"Добавить компанию",
        "Company name":"Название компании",
        "Contact Id": "Id контакта",
        "Enter company name":"Введите название компании",
        "Company code":"Код компании",
        "Enter company code":"Введите код компании",
        "Enter contact Id":"Укажите Id контакта",
        "External id":"Внешний идентификатор",
        "ITN":"ИНН",

        "Identity type":"Тип идентификатора",
        "Company identifier":"Идентификатор компании",
        "Choose a company":"Выберите компанию",
        "Company saved successfully":"Компания успешно сохранена",
        "Identifier":"Идентификатор"
    };

webix.i18n.locales["ru-RU"].vascloud.VasAdsLists =
    {
        "hcn_unknown":"Неизвестна",
        "hcn_software_tools":"Программные средства",
        "hcn_search_engine":"Поисковая система",
        "hcn_0_other":"Другое",
        "hcn_school":"Школа",
        "hcn_proxys":"Прокси",
        "hcn_tabak_alkohol":"Табак, алкоголь",
        "hcn_religia":"Религия",
        "hcn_0_bad_gateway":"Плохой шлюз (HTTP 502)",
        "hcn_porno_sex":"Порно, секс",
        "hcn_nenormativ_lexika":"Ненормативная лексика",
        "hcn_0_forbidden":"Запрещённый (HTTP 403)",
        "hcn_music_sites":"Музыкальные сайты",
        "hcn_game_sites":"Игровые сайты",
        "hcn_video_hostings":"Видео-хостинг",
        "hcn_file_archives":"Файловые архивы",
        "hcn_social_networks":"Социальные сети",
        "hcn_im":"Мессенджеры",
        "hcn_dosug_cafe_kino_restorans":"Досуг, кафе, кинотеатры, рестораны",
        "hcn_goverment":"Правительство",
        "hcn_organizations":"Организации",
        "hcn_telecom_operators":"Телеком операторы",
        "hcn_shops":"Магазины",
        "hcn_forums_18+":"Форумы 18+",
        "hcn_bank_finances":"Банковское дело, финансы",
        "hcn_museum":"Музеи",
        "hcn_medicina_hostitals":"Медицина, больницы",
        "hcn_miners_pools_curs_etc":"Майнеры, пулы, валюта и т.д.",
        "hcn_humor_anectdots":"Юмор, шутки",
        "hcn_job_hunters":"Работа, охотники",
        "hcn_military":"Военные",
        "hcn_news":"Новости",
        "hcn_child_sites":"Детские сайты",
        "hcn_tech_inteface":"Тех. интерфейсы",
        "hcn_ads":"Реклама",
        "hcn_blog":"Блоги",
        "hcn_coocking":"Приготовление еды",
        "hcn_metrics":"Метрика",
        "hcn_forex":"Форекс",
        "hcn_cdn":"Сеть доставки контента",
        "hcn_personal":"Личный",
        "hcn_antivirus":"Антивирусы",
        "hcn_education":"Образование",
        "hcn_gambling":"Азартные игры",
        "hcn_drugs":"Наркотики",
        "hcn_building":"Строительство",
        "hcn_malware":"Вредоносные программы",
        "hcn_blocked":"Блокированный",
        "hcn_classified":"Объявления",
        "hcn_magazins":"Журналы",
        "hcn_sport":"Спорт",
        "hcn_turism":"Туризм",
        "hcn_auto":"Авто",
        "hcn_relocation":"Переселение",
        "hcn_realestate":"Недвижимость",
        "hcn_mail":"Почта",
        "hcn_telecom_operators, call-centre":"Телеком операторы, Call-Centre"
    };

webix.i18n.locales["ru-RU"].vascloud.VasAds =
    {
        "Add list item":"Добавить в список",
        "Advertising javascript lists":"Рекламные списки яваскриптов",
        "Groups of js templates":"Группы шаблонов яваскриптов",
        "Js list items in groups":"Группы назначенные скрипту",
        "Groups assigned to the script":"Группы назначенные скрипту",
        "Resource":"Ресурс",
        "Host categories":"Категории хостов",
        "Host category":"Категория хоста",
        "Name":"Наименование",
        "Template":"Шаблон",
        "Edit template":"Редактировать шаблон",
        "Edit parameters":"Редактировать параметры",
        "Value":"Значение",
        "Default":"По умолчанию",
        "Edit javascript body":"Редактировать тело яваскрпита",
        "Add rule":"Добавить правило",
        "Company code":"Код компании",
        "Days of the week":"Дни недели",
        "Start date":"Дата начала",
        "End date":"Дата окончания",
        "Start time":"Время начала",
        "End time":"Время окончания",
        "Every nth transition":"Каждый n-й переход",
        "Enabled":"Включено",

        "Lifetime, secs":"Время жизни, сек",
        "Shows count":"Количество показов",
        "Origin script":"Оригинальный скрипт",
        "Prepared script":"Подготовленный скрипт",

        "Show time":"Время показа",
        "Pause, sec":"Пауза, сек.",

        "Cache table":"Кеш таблица",
        "Cache content":"Содержимое кеша",

        "Main":"Основное",
        "Additionally":"Дополнительно",

        "Referer":"Реферер",
        "Referer host":"Реферер хост",
        "Company":"Компания",
        "Company name":"Компания",
        "Group":"Группа",
        "Template name":"Имя шаблона",
        "Origin":"Оригинал",
        "Prepared":"Подготовленный",
        "Shows":"Показы",

        "Common":"Общий",
        "Top companies":"Топ компаний",
        "Top templates":"Топ шаблонов",
        "Top hosts categories":"Топ категорий хостов",

        "Reports":"Отчеты",

        "Referer hosts":"Реферер хосты",
        "Templates":"Шаблоны",
        "Origins":"Оригиналы",
        "Companies":"Компании",
        "Hosts categories":"Категории хостов"
    };

webix.i18n.locales["ru-RU"].vascloud.VasCloudAdsStatistics =
    {
        "Common":"Общее",
        "Content provider":"Провайдер",
        "Offer id":"ИД оффера",
        "Offer":"Оффер",
        "Subaccount":"Субаккаунт",
        "Company name":"Компания",
        "Traffic":"Трафик",
        "Shows":"Показы",
        "Hits":"Хиты",
        "Clicks":"Клик",
        "Back url":"Back url",
        "Leads":"Лиды",
        "Approved":"Одобрено",
        "Opened":"Открыто",
        "Rejected":"Отклонено",
        "Paid targets":"Оплачено целей",
        "Efficiency":"Эффективность",
        "Сommission":"Комиссия"
    };

webix.i18n.locales["ru-RU"].vascloud.VasCloudAccrualsAndPayments =
    {
        "Accruals and payments":"Начисления и платежи",
        "Id":"Ид",
        "Date":"Дата",
        "Accrual":"Начисление",
        "Write-off":"Списание",
        "Note":"Детали",
        "Content provider":"Провайдер",
        "Content provider name":"Имя провайдера",
        "Company":"Компания",
        "Compdany name":"Имя компании",
        "Show canceled":"Показывать отмененные",
        "Request payment":"Запросить платеж",
        "Send us request to get your money and we process it as soon as possible":"Отправьте нам запрос на получение денег, и мы обработаем их как можно скорее",
        "Amount of payment":"Сумма платежа",
        "Enter amount of payment":"Введите сумму платежа",
        "Notes":"Примечания",

        "Make transaction":"Создать транзакцию",
        "Document type":"Тип документа",
        "Accrue to the counterparty":"Начислить контрагенту",
        "Write off from counterparty":"Списать с контрагента",
        "Amount":"Сумма",
        "Service":"Сервис",
        "ADS service by VAS Experts":"Реклама на ресурсах VAS Experts",
        "ADS service by Operator":"Реклама на ресурсах оператора связи",
        "External ID":"Внешний счет",
        "Type":"Тип",
        "From counterparty":"От контрагента",
        "To counterparty":"К контрагенту",
        "Counterparty":"Контрагент",

        "Charge":"Начисление за услугу",
        "Payment":"Платеж",
        "Transfer":"Перевод средств",
        "Remain":"Начисление остатка",

        "Cash":"Наличными",
        "Cashless":"Безналичный",

        "Enter counterparty":"Введите контрагента",
        "Enter amount":"Введите сумму",
        "Select service":"Выберите сервис",
        "Select payment type":"Выберите тип платежа",
        "Enter date":"Введите дату",

        "Transaction saved":"Транзакция сохранена"
    };

webix.i18n.locales["ru-RU"].vascloud.Classifier =
    {
        "Hosts Categories":"Категории сайтов",
        "Classifier model":"Модель классификатора",
        "Categories":"Категории",
        "Category":"Категория",
        "Category added successfully":"Категория успешно добавлена",
        "Category deleted successfully":"Категория успешно удалена",
        "Categories deleted successfully":"Категории успешно удалены",
        "Code":"Код",
        "Host":"Сайт",
        "Hosts":"Сайты",
        "Host text":"Текст сайта",
        "Host added successfully":"Сайт успешно добавлен",
        "Host deleted successfully":"Сайт успешно удален",
        "Hosts deleted successfully":"Сайты успешно удалены",
        "Imported successfully":"Импортировано успешно",
        "Required field":"Обязательное поле",
        "Host category":"Категория",
        "Get":"Получить",
        "Check":"Проверить",
        "Percentage received successfully":"Процент получен успешно",
        "Likely category":"Вероятная категория",
        "Recognition correctness":"Корректность распознавания",
        "Train":"Обучить",
        "Models":"Модели",
        "Folders":"Папки",
        "Files":"Файлы",
        "Model":"Модель",
        "Folder":"Папка",
        "File":"Файл",
        "File contents":"Содержимое файла",
        "Add item item":"Добавить элемент",
        "Duplicate model":"Дублировать модель",
        "Set default model":"Установить модель по умолчанию",
        "Set folder":"Установить папку",
        "Save file":"Сохранить файл",
        "Duplicate name":"Имя дубликата",
        "Model saved successfully":"Модель успешно сохранена",
        "Model duplicated successful":"Модель скопирована успешно",
        "File saved successfully":"Файл успешно сохранен",
        "Folder saved successfully":"Папка успешно сохранена",
        "File delete successfully":"Файл успешно удален",
        "File text received successfully":"Текст файла успешно получен",
        "HTML text received successfully":"HTML-текст успешно получен",
        "File text saved successfully":"Текст файла успешно сохранен",
        "Select file":"Выберите файл",
        "Select folder":"Выберите папку",
        "Select model":"Выберите модель",
        "Folder set successfully":"Папка успешно установлена",
        "Folder delete successfully":"Папка успешно удалена",
        "Files erased successfully":"Файлы успешно удалены",
        "Model delete successfully":"Модель удалена успешно",
        "Classifier version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].":"Версия Классификатора несовместима. Должна быть [COMPATIBLE_VERSION]+. Текущая [CURRENT_VERSION].",
        "Recheck category":"Отправить на ерепроверку хосты в выбранной категории",
        "Recheck hosts":"Отправить на перепроверку выбранные хосты",
        "To recheck":"Статус перепроверки",
        "Recheck date":"Дата перепроверки",
        "Hosts recheck successful":"Выбранные хосты будут перепроверены",
        "Hosts recheck failed":"Перепроверка выбранных хостов не выполнена",
        "Category recheck successful":"Хосты в выбранных категориях будут перепроверены",
        "Category recheck failed":"Перепроверка хостов в выбранных категориях не выполнена",
        "Recheck":"Продолжить",
        "Are you sure you want to recheck the selected hosts?":"Вы действительно хотите отправить выбранные хосты на перепроверку?",
        "Are you sure you want to recheck the selected hosts in categories?":"Вы действительно хотите отправить хосты из выбранных категорий на проверку?"
    };

webix.i18n.locales["ru-RU"].vascloud.Protocols =
    {
            "Protocol":"Протокол",
            "Protocols":"Протоколы",
            "Required field":"Обязательное поле",
            "Group":"Группа",
            "Add list item":"Добавить элемент списка",
            "Protocol groups":"Группы протоколов",
            "Click to upload or drag a file here":"Нажмите, чтобы загрузить или перетащите файл сюда",
            "File size": "Размер файла",
            "File":"Файл",
            "State":"Статус",
            "Help":"Помощь",
            "Duplicates":"Дубликаты",
            "Rows count: ":"Кол-во строк: ",
            "Error items count: ":"Кол-во строк с ошибкой: ",
            "Duplicates count: ":"Кол-во дублирующих строк: ",
            "Inserted items count: ":"Кол-во вставленных строк: ",
            "Download duplicates file":"Скачать файл с дубликатами",
            "Download errors file":"Скачать файл с проблемными",
            "Set":"Установить",
            "Unset":"Снять",
            "Are you want to set or unset testing flag?":"Вы хотите установить или снять флаг \"Тестирование\"?",
            "Setting or unsetting testing flag":"Установка или снятие флага \"Тестирование\"",
            "Flag changed successfully":"Флаг изменен успешно",


            //Messages
            "Group saved successfully":"Группа успешно сохранена",
            "Group deleted successfully":"Группа успешно удалена",
            "Protocol saved successfully":"Протокол успешно сохранен",
            "Protocol deleted successfully":"Протокол успешно удален",
            "Protocols from group deleted successfully":"Протоколы из группы успешно удалены",

            "Suggest group":"Предложить группу",

            "Synchronization mode":"Режим синхронизации",
            "Company":"Компания",
            "Hardware saved successfully":"Оборудование успешно сохранено",
            "Protocols erased successfully":"Протоколы успешно удалены",
            "Protocols deleted successfully":"Протоколы успешно удалены",
            "Protocol enabled successfully":"Протокол успешно включен",
            "Protocol disabled successfully":"Протокол успешно отключен",
            "Protocol Item enabled successfully":"Элемент протокола успешно включен",
            "Protocol Item disabled successfully":"Элемент протокола успешно отключен",
            "Resource List saved successfully":"Список ресурсов успешно сохранен",
            "Resource List deleted successfully":"Список ресурсов успешно удален",
            "Protocols Items erased successfully":"Элементы протоколов успешно удалены",
            "Protocols Items deleted successfully":"Элементы протоколов успешно удалены",
            "Imported successfully":"Импортировано успешно",
            "Custom Protocols Items":"Элементы настраиваемых протоколов",
            "Clients Area Manager":"Менедежер по работе с клиентами",

            //Status
            "New":"Новый",
            "Processing":"Обработка",
            "Success":"Успех",
            "Error":"Ошибка",
            "Skipped":"Пропущено",
            "DPI Version": "Версия DPI",
            "Minimum DPI Version": "Минимальная Версия DPI",
            "Enter correct version number": "Введите корректный номер версии",
            "Data":"Данные",
            "Protocols copied successfully": "Протоколы успешно скопированы",
            "Copy": "Копировать",
            "Company name": "Название компании",
            "Field is required": "Поле обязательно к заполнению",

            "Import successfully": "Импорт завершен",
            "Rows deleted successfully": "Строки удалены успешно",
            "Row saved successfully":"Строка сохранена успешно",
            "You have not imported data": "Вы не импортировали данные",

            "Forced unloading of custom protocols and default lists": "Принудительная выгрузка кастомных протоколов и дефолтных списков",
            "Started forced unloading of custom protocols and default lists": "Началась принудительная выгрузка кастомных протоколов и дефолтных списков",
            "Finished forced unloading of custom protocols and default lists": "Завершилась принудительная выгрузка кастомных протоколов и дефолтных списков",
            "Forced unloading of protocol directory": "Принудительная выгрузка справочника протоколов",
            "Started forced unloading of protocol directory": "Началась принудительная выгрузка справочника протоколов",
            "Finish forced unloading of protocol directory": "Завершилась принудительная выгрузка справочника протоколов",
            "Run":"Запустить",
            "Defaults lists": "Списки по умолчанию",
            "Lists VPN companies": "Списки VPN компаний",
            "Lists without VPN": "Списки без VPN",
            "By company code": "По коду компании",
            "Templates": "Шаблоны",
            "List of unsaved items": "Список несохраненных элементов",
            "Items added": "Элементы добавлены",
            "Items deleted": "Элементы удалены",
            "Items updated": "Элементы обновлены",

            "Intersections with the cloud list count: ": "Кол-во пересечений с облачным списком: ",
            "Items checked successfully": "Элементы проверены успешно",
            "Warning": "Предупреждение",
            "There is a '{resource}' intersection in the cloud protocol '{protocol}'": "Есть пересечение '{resource}' с облачным протоколом '{protocol}'",
            "Check resource": "Проверить ресурс",
            "AS resources": "Ресурсы АС",
            "AS number": "Номер АС",
            "Comment": "Комментарий",
            "Set invalid for protocols resources": "Установить невалидность для ресурсов протоколов",
            "Any of: SNI, IP, CIDR, IP PORT": "Любой ресурс вида: SNI, IP, CIDR, IP PORT",
            "Updated": "Обновлено",
            "Search in protocols": "Искать в протоколах",
            "Search protocols completed": "Поиск протоколов выполнен",
            "Common list": "Общий список",

            "Description protocol": "Описание протокола",
            "Protocol description in Russian": "Описание протокола на русском",
            "Protocol description in English": "Описание протокола на английском",
            "DPI Wiki Version": "Версия DPI Wiki",
            "No found": "Не найдено",
            "ERROR_VALIDATE_FORM": "Не все обязательные поля заполнены"
    };

webix.i18n.locales["ru-RU"].vascloud.CompanyProtocols =
{
        "Company Protocols": "Протоколы компаний",
        "Add company protocol": "Добавить протокол компании",
        "Priority": "Приоритет",
        "Are you sure you want to delete the company protocol?":"Вы действительно хотите удалить протокол компании?",
        "The higher the value is, the higher the priority of items from this protocol in unloading": "Чем больше значение, тем выше приоритет элементов из этого протокола при выгрузке",
        "Enter protocol": "Выберите протокол",
        "Enter company": "Выберите компанию"
}

webix.i18n.locales["ru-RU"].vascloud.CompanyEditForm = {
        "Company": "Компания",
        "Company name": "Название компании",
        "Company title / description": "Название компании / описание",
        "Enter company name": "Введите название компании",
        "Company code": "Код компании",
        "Enter company code": "Введите код компании",
        "External id": "Внешний идентификатор",
        "ITN": "ИНН",
        "Additional parameters": "Дополнительные параметры",
        "Custom protocols queue priority": "Приоритет для пользовательских протоколов",
        "Enter the number": "Введите число",
        "VPN catalog service": "Услуга VPN-каталога",
        "Enabled": "Подключена",
        "Disabled": "Отключена"
};

webix.i18n.locales["ru-RU"].vascloud.LicensesToken =
    {
        "ID":"ИД",
        "Attempts":"Попытки",
        "Licenses Token":"Токены лицензий",
        "Token":"Токен",
        "Company":"Компания",
        "License":"Лицензия",
        "License ID":"ИД лицензии",
        "Last Error":"Последняя ошибка",
        "Row updated successful":"Строка обновлена успешно",
        "Row added successful":"Строка добавлена успешно",
        "Automatic generation":"Автоматическая генерация",
        "Autobinding. Do not fill in unnecessarily":"Автосвязывание. Не заполнять без надобности",
        "Created date":"Дата создания",
        "Updated date":"Дата изменения",
        "Comments":"Комментарии",
        "Ticket":"Тикет",

        "Only selected tokens": "Только выбранные токены",
        "Type": "Тип",
        "Message": "Сообщение",
        "Client address": "Адрес клиента",
        "Add License Token": "Добавить токен лицензии",
        "FastInstall script": "Скрипт FastInstall",
        "OIMA FastLic script": "Скрипт FastLic для OIMA",
        "DPI Script": "Скрипт DPI",
        "OIMA Script": "Скрипт OIMA",
        "OCLD Script": "Скрипт OCLD",
        "OIPA Script": "Скрипт OIPA",
        "EPDG Script": "Скрипт EPDG",
        "Script":"Скрипт",
        "DPI":"DPI",
        "OIMA":"OIMA",
        "OCLD":"OCLD",
        "OIPA":"OIPA",
        "EPDG":"EPDG",

    };

webix.i18n.locales["ru-RU"].vascloud.RequestTrial = {
        "Company":"Компания",
        "Full Name":"ФИО",
        "Email":"E-mail",
        "Phone":"Телефон",
        "Notes":"Заметки",
        "Status":"Статус",
        "Request Trial":"Список заявок",
        "New":"Новая",
        "Solved":"Решена",
        "Closed":"Закрыта",
        "Applications":"Заявки",
        "Add Request Trial":"Добавить заявку",
        "Id":"Id",
        "Enter company name":"Введите название компании",
        "Enter Full Name":"Введите ФИО",
        "Enter correct Email":"Введите корректный Email",
        "Enter correct Phone":"Введите корректный телефон",
        "Enter status":"Выберите статус",
        "Date Created":"Дата создания",
        "Date Updated":"Дата изменения"
    };

webix.i18n.locales["ru-RU"].vascloud.UserActionsLog = {
        "Row id":"Идентификатор строки",
        "Type code":"Таблица",
        "Action":"Изменение",
        "Value old":"Старое значение",
        "Value new":"Новое значение",
        "Create time":"Время создания",
        "Update time":"Время обновления",
        "Create user":"Создавший пользователь",
        "Update user":"Обновивший пользователь",
        "Differences": "Различия"
};

webix.i18n.locales["ru-RU"].vascloud.AppStatistics = {
        "Application statistics":"Статистика приложения",
        "Hardware state":"Состояние оборудования",
        "Property":"Свойство",
        "State":"Состояние",
        "connect":"подключено",
        "disconnect":"отключено",
        "Lic options":"Лицензии",
        "License":"Лицензия",
        "Expiration date":"Срок лицензии",
        "Lic level":"Уровень лицензии",
        "Program sections":"Разделы программы",
        "Code":"Код",
        "Section":"Раздел",
        "Read":"Чтение",
        "Record":"Запись",
        "Reports":"Отчеты",
        "Hardware usage":"Оборудование пользователей",
        "Dpiui2 usage":"Действия пользователей",

        "App info":"Информация",
        "Action":"Действие",
        "Action date":"Дата действия",
        "Client ip":"Ip клиента",
        "Company info":"Информация о компании",
        "Vas Cloud authorization":"Авторизация на Vas Cloud",
        "authorized":"авторизован",
        "unauthorized": "не авторизован",
        "Lic info":"Информация о лицензиях",
        "User info":"Информация о пользователе",
        "Contact id":"Id контакта",
        "Lic limit":"Лимит лицензии",
        "Hardware info":"Информация об оборудовнии",
        "Hardware type":"Тип оборудования",
        "Software version":"Версия ПО",
        "Hardware id":"Id оборудования",
        "Cloud id":"Cloud id",
        "Hardware name":"Имя оборудования",
        "Hardware ip":"Ip оборудования",
        "Hardware state info":"Информация о состоянии",

        "Username":"Имя пользователь",
        "User role":"Роль пользоваьеля",
        "User sections":"Разделы пользователя",
        "Version":"Версия",

        "Collect hardware info":"Сбор данных об оборудовании",
        "Authentication":"Аутентификация",
        "Login":"Логин",
        "Logout":"Логаут",
        "Installation":"Инсталляция",

        "Dpiui2 version":"Версия Dpiui2"

};

webix.i18n.locales["ru-RU"].vascloud.TestCompanies = {
        "Test companies":"Тестовые компании",
        "Managing test companies":"Управление тестовыми компаниями"
};

webix.i18n.locales["ru-RU"].vascloud.WosdCompanies = {
        "Companies without SD":"Компании без ТП",
        "Enter correct DPI version":"Введите корректную версию DPI",
        "Managing companies without SD":"Управление компаниями без ТП"
};

webix.i18n.locales["ru-RU"].vascloud.UlrModule = {
        "Datatable search...":"Поиск по таблице...",
};

webix.i18n.locales["ru-RU"].vascloud.ApiKeys = {
        "API key":"API ключ",
        "API keys":"API ключи",
        "Add API key":"Добавить API ключ",
        "Key copied to clipboard": "Ключ скопирован в буфер обмена",
        "Blocked": "Заблокирован"
};

webix.i18n.locales["ru-RU"].vascloud.CustomProtocolsGroups = {
        "Custom protocols groups": "Пользовательские группы протоколов",
        "Override Cloud": "Переопределить облачную",
        "Create a new group": "Создать новую группу",
        "Group code": "Код группы",
        "Group name": "Название группы",
        "Cloud protocol": "Облачный протокол",
        "Cloud group": "Облачная группа",
        "Custom protocol": "Пользовательский протокол",
        "Add cloud protocol": "Добавить облачный протокол",
        "Add custom protocol": "Добавить пользовательский протокол",
        "Protocol type": "Тип протокола",
        "Cloudy": "Облачный",
        "Custom": "Пользовательский",
        "Protocol": "Протокол"
};
webix.i18n.locales["en-US"].vascloud = {};

webix.i18n.locales["en-US"].vascloud.AppView =
    {
        Title:"VAS Cloud",

        "DPI control":"SSG control",
        "Performance":"Performance",
        "Configuration":"Configuration",
        "Protocol prioritization (DSCP)":"Protocol prioritization (DSCP)",
        "Priority for ASN":"Priority for ASN",
        "Prioritization for autonomous systems (AS)":"Prioritization for autonomous systems (AS)",
        "Logs":"Logs",

        "Services control":"Services control",
        "Subscribers and services":"Subscribers and services",
        "Subscribers":"Subscribers",
        "Services":"Services",
        "Tariff plans":"Tariff plans",
        "Adv control": "Adv control",

        "QoE analytics":"QoE analytics",
        "QoE dashboard":"QoE dashboard",
        "Dashboard":"Dashboard",
        "Clickstream":"Clickstream",
        "Netflow":"Netflow",
        "Administrator":"Administrator",
        "Licences":"Licences",
        "Licenses Token":"Licenses Token",
        "Companies":"Companies",
        "Javascript lists":"Javascript lists",
        "Prepared Javascript templates":"Prepared Javascript templates",
        "Javascript templates":"Javascript templates",
        "Javascript rules":"Javascript rules",
        "Javascript cache":"Javascript cache",
        "Statistics":"Statistics",
        "JS statistics":"JS statistics",
        "Javascript statistics":"Javascript statistics",
        "ADS statistics":"ADS statistics",
        "Accruals and payments":"Accruals and payments",

        "Restart fastdpi":"Restart fastdpi",
        "Updating hot options":"Updating hot options",
        "Updating options":"Updating options",
        "Device information":"Device information",
        "License information":"License information",
        "Select from list":"Select from list",
        "Managing the list of devices":"Managing the list of devices",

        "My profile":"My profile",
        "Users":"Users",
        "Roles":"Roles",
        "Managing users and roles":"Managing users and roles",

        "Log out":"Log out",

        "Edit profile":"Edit profile",
        "Username":"Username",
        "Enter user name":"Enter user name",
        "Full name":"Full name",
        "Last name First name Middle name":"Last name First name Middle name",
        "Enter your full name":"Enter your full name",
        "Position":"Position",
        "Enter your position":"Enter your position",
        "Organization":"Organization",
        "Name of the organization":"Name of the organization",
        "Enter the name of the organization":"Enter the name of the organization",
        "Enter your e-mail":"Enter your e-mail",
        "Phone":"Phone",
        "Contact number":"Contact number",
        "Enter phone number":"Enter phone number",
        "Change password":"Change password",
        "Old password":"Old password",
        "Enter password":"Enter password",
        "New password":"New password",
        "Confirm password":"Confirm password",
        "Passwords do not match":"Passwords do not match",

        "Are you sure you want to restart the fastdpi process?":"Are you sure you want to restart the fastdpi process?",
        "Are you sure you want to update the hot settings?":"Are you sure you want to update the hot settings?",
        "Restart":"Restart",
        "No equipment selected":"No equipment selected",

        "Name":"Name",
        "Port":"Port",
        "Login":"Login",
        "Can be controlled by other GUI":"Can be controlled by other GUI",

        "Start fastdpi error": "Start fastdpi error",
        "fastdpi is stopped": "FASTDPI is stopped",
        "fastdpi остановлен": "FASTDPI is stopped",
        "Classifier": "Classifier",
        "Hosts Categories":"Hosts Categories",
        "Protocols":"Protocols",
        "Protocol groups":"Protocol groups",

        "Request Trial":"Request Trial",
        "Logging": "User activity log",

        "App statistics":"App statistics",
        "Test companies":"Test companies",
        "Companies without SD":"Companies without SD",

        "DPI version":"DPI version"
};

webix.i18n.locales["en-US"].vascloud.LoginView =
    {
        "Sign in to control panel CKAT DPI":"Sign in to SSG control panel",
        "Login":"Login",
        "Enter login":"Enter login",
        "Password":"Password",
        "Enter password":"Enter password",
        "Remember me":"Remember me",
        "Sign in":"Sign in"
    };

webix.i18n.locales["en-US"].vascloud.All =
    {
        "Yes":"Yes",
        "No":"No",

        "No connection":"No connection",
        "In developing":"In developing",
        "Access denied":"Access denied",

        "Russian":"Russian",
        "Rus.":"Rus.",
        "English":"English",
        "Eng.":"Eng.",

        "Add":"Add",
        "Refresh":"Refresh",
        "Cancel":"Cancel",
        "Delete":"Delete",
        "Remove all":"Remove all",
        "Close":"Close",
        "Save":"Save",
        "Add value":"Add value",
        "Upload from file":"Upload from file",
        "Download from history":"Download from history",
        "Saved":"Saved",
        "Deleted":"Deleted",
        "Removed":"Removed",

        "Are you sure you want to delete the selected records?":"Are you sure you want to delete the selected records?",
        "Are you sure you want to remove all list items?":"Are you sure you want to remove all list items?",

        "The form":"The form",
        "Editor":"Editor",

        "Settings":"Settings",

        "Click to download or drag a file": "Click to download or drag a file",
        "Apply": "Apply",
        "Applied": "Applied",
        "History": "History",
        "Could not upload file": "Could not upload file",
        "Config": "Config",

        "Back":"Back",
        "Forward":"Forward",

        "Date":"Date",

        "Download the complete file":"Download the complete file",

        "Error":"Error",
        "See logs":"See logs",

        "History loaded":"History loaded",
        "Verified":"Verified",

        "Restart was successful":"Restart was successful",
        "Hot options updated":"Hot options updated",

        "Parser error":"Parser error",

        "Total":"Total",
        "Done":"Done",

        "Period":"Period",
        "Interval":"Interval",
        "1 minute":"1 minute",
        "15 minutes":"15 minutes",
        "30 minutes":"30 minutes",
        "1 hour":"1 hour",
        "1 day":"1 day",
        "1 month":"1 month",

        "Bytes":"Bytes",
        "Kb":"Kb",
        "Mb":"Mb",
        "Gb":"Gb",
        "Tb":"Tb",

        "Bytes/s":"Bytes/s",
        "Kb/s":"Kb/s",
        "Mb/s":"Mb/s",
        "Gb/s":"Gb/s",
        "Tb/s":"Tb/s",

        "Bit/s":"Bit/s",
        "Kbit/s":"Kbit/s",
        "Mbit/s":"Mbit/s",
        "Gbit/s":"Gbit/s",
        "Tbit/s":"Tbit/s",

        "Pkts/s":"Pkts/s",
        "Kpkts/s":"Kpkts/s",
        "Mpkts/s":"Mpkts/s",
        "Gpkts/s":"Gpkts/s",
        "Tpkts/s":"Tpkts/s",

        "ns":"ns",
        "µs":"µs",
        "ms":"ms",
        "s":"s",
        "ks":"ks",
        "Ms":"Ms",
        "Gs":"Gs",
        "Ts":"Ts",

        "K":"K",
        "M":"M",
        "G":"G",
        "T":"T",

        "On":"On",
        "Off":"Off",

        "Reset":"Reset",
        "By default":"By default",

        "Next":"Next",

        "Page size":"Page size",
        "Export":"Export",
        "File name":"File name",
        "Export format":"Export format",
        "Switch form?": "Switch form?",
        "There are unsaved changes. Are you sure you want to switch form?": "There are unsaved changes.<br/>Are you sure you want to switch form?",
        "Switch": "Switch",

        "Import from file":"Import from file",
        "Export to Excel":"Export to Excel",
        "Import":"Import",
        "Get template":"Get template",

        "On page":"On page",
        "Warning": "Warning",
        "LK User": "LK User",
        "LK Super user": "LK Super user",
        "Tickets": "Tickets",
        "All users tickets": "All users tickets",
        "Only my tickets": "Only my tickets",
        "Set to see tickets of all users or not. User can see all tickets by default.": "Set to see tickets of all users or not. User can see all tickets by default.",
        "LK User company admin": "LK User company admin",
        "Of": "Of"
    };

webix.i18n.locales["en-US"].vascloud.Roles =
    {
        "Are you sure you want to delete the role?":"Are you sure you want to delete the role?",

        "Roles":"Roles",
        "Add role":"Add role",

        "Role":"Role",

        "Program sections":"Program sections",
        "Code":"Code",
        "Section":"Section",
        "Read":"Read",
        "Record":"Record",
        "Removal":"Removal"
    };

webix.i18n.locales["en-US"].vascloud.Users =
    {
        "Are you sure you want to delete the user?":"Are you sure you want to delete the user?",
        "User name":"User name",
        "Enter user name":"Enter user name",
        "Full name":"Full name",
        "Enter full name":"Enter full name",
        "Enter e-mail":"Enter e-mail",
        "Phone":"Phone",
        "Enter phone number":"Enter phone number",
        "Company":"Company",
        "Enter the name of the organization":"Enter the name of the organization",
        "Position":"Position",
        "Enter the position":"Enter the position",
        "Role":"Role",
        "User saved":"User saved",
        "Enter the company":"Enter the company",

        "Passwords do not match":"Passwords do not match",

        "New password":"New password",
        "Enter password":"Enter password",
        "Confirm password":"Confirm password",

        "Add user":"Add user",
        "Users":"Users",
        "Generate password":"Generate password",
        "Copied to clipboard":"Copied to clipboard",
        "Block user": "Block user",
        "User blocked": "User blocked",
        "Are you sure you want to block this user?": "Are you sure you want to block this user?",
        "Block": "Block"
    };

webix.i18n.locales["en-US"].vascloud.CreateTicket =
    {
        "Send a message":"Send a message",
        "Message subject":"Message subject",
        "Message text":"Message text",
        "Enter here any text":"Enter here any text",
        "DPI message Log":"DPI message Log",
        "Log of information messages and errors":"Log of information messages and errors",
        "DPI statistics log":"DPI statistics log",
        "UI log":"UI log",
        "Send":"Send",
        "Message sent successfully":"Message sent successfully"
    };

webix.i18n.locales["en-US"].vascloud.Lics =
    {
        "Licence":"Licence",
        "Licences":"Licences",
        "Product type":"Product type",
        "Company":"Company",
        "Licence level":"Licence level",
        "DPI licence level":"DPI licence level",
        "Expiration date":"Expiration date",
        "Support expiration date":"Support expiration date",
        "Product uuid":"Product uuid",
        "Licence limit":"Licence limit",
        "Board serial":"Board serial",
        "Chassis serial":"Chassis serial",
        "Product serial":"Product serial",
        "MAC addresses":"MAC addresses",
        "Speeds":"Speeds",
        "Add licence":"Add licence",
        "Active":"Active",
        "Not active":"Not active",
        "Licence enabled":"Licence enabled",
        "Licence disabled":"Licence disabled",
        "Contact ID": "Contact ID",
        "Contact name": "Contact name",
        "Contact phone": "Contact phone",
        "Contact email": "Contact email",
        "Contact organization": "Contact organization",
        "Renewal":"Renewal",
        "Permanent":"Permanent",
        "Lics Saved":"Lics Saved",
        "General":"General",
        "License parameters":"License parameters",
        "Set flag Refresh": "Set flag Refresh",
        "Unflag Refresh": "Unflag Refresh",
        "License Updated": "Licenses Updated",
        "Mass Refresh": "Mass Operations",
        "Lic Options" : "Lic options",
        "Add option" : "Add option",
        "Option name" : "Option name",
        "License data": "License data",
        "License version": "License version",
        "Unbound": "Unbound",
        "Contact data": "Contact data",
        "Person": "Person",
        "Email": "Email",
        "Bios vendor": "Bios vendor",
        "Board name": "Board name",
        "Board vendor": "Board vendor",
        "Product name": "Product name",
        "Product UUID": "Product UUID",
        "Code": "Code",
        "Description": "Description",
        "VasCloud local license": "VasCloud local license",
        "DPI remote license": "DPI remote license",
        "Licence data successfully uploaded":"Licence data successfully uploaded",
        "License on VAS Cloud":"License on VAS Cloud",
        "License on 'lics server'":"License on 'lics server'",
        "EPDG / PCEF / PGW license data": "EPDG / PCEF / PGW license data",

        "Host Name": "Host Name",
        "Host Addr": "Host Addr",
        "Oper mcc": "Oper mcc",
        "Oper mnc": "Oper mnc",
        "IMSI range": "IMSI range",
        "Served Realm": "Served Realm",
        "Served Apn": "Served Apn",
        "Served net": "Served net",
        "Auth mode": "Auth mode",
        "Tune mode": "Tune mode",
        "Max users": "Max users",
        "Max bitrate": "Max bitrate",
        "Max CPU": "Max CPU",
        "Max threads": "Max threads",
        "Max auth servers": "Max auth servers",
        "Max tun servers": "Max tun servers",
        "Feature balance": "Feature balance",
        "Feature failover": "Feature failover",
        "Feature ipv4 kernel gtpu": "Feature ipv4 kernel gtpu",
        "Feature ipv4 soft gtpu": "Feature ipv4 soft gtpu",
        "Feature ipv4 kernel ipv6 soft gtpu": "Feature ipv4 kernel ipv6 soft gtpu",
        "Feature ipv4 soft ipv6 soft gtpu": "Feature ipv4 soft ipv6 soft gtpu",
        "Unavailable for selected licenses": "Unavailable for selected licenses",
        "Options successfully updated for selected licenses": "Options successfully updated for selected licenses",
        "Set options": "Set options"
    };

webix.i18n.locales["en-US"].vascloud.Companies =
    {
        "Companies":"Companies",
        "Company":"Company",
        "Company Id":"Company Id",
        "Are you sure you want to delete the company?":"Are you sure you want to delete the company?",
        "Add company":"Add company",
        "Company name":"Company name",
        "Contact Id": "Contact Id",
        "Enter company name":"Enter company name",
        "Company code":"Company code",
        "Enter company code":"Enter company code",
        "Enter contact Id":"Enter contact Id",
        "External id":"External id",
        "ITN":"ITN",

        "Identity type":"Identity type",
        "Company identifier":"Company identifier",
        "Choose a company":"Choose a company",
        "Company saved successfully":"Company saved successfully",
        "Identifier":"Identifier"
    };

webix.i18n.locales["en-US"].vascloud.VasAdsLists =
    {
        "hcn_unknown":"Unknown",
        "hcn_software_tools":"Software tools",
        "hcn_search_engine":"Search engine",
        "hcn_0_other":"Other",
        "hcn_school":"School",
        "hcn_proxys":"Proxies",
        "hcn_tabak_alkohol":"Tobacco, alcohol",
        "hcn_religia":"Religion",
        "hcn_0_bad_gateway":"Bad gateway (HTTP 502)",
        "hcn_porno_sex":"Porn, sex",
        "hcn_nenormativ_lexika":"Profanity",
        "hcn_0_forbidden":"Forbidden (HTTP 403)",
        "hcn_music_sites":"Music sites",
        "hcn_game_sites":"Gaming sites",
        "hcn_video_hostings":"Video hostings",
        "hcn_file_archives":"File archives",
        "hcn_social_networks":"Social networks",
        "hcn_im":"Instant messaging",
        "hcn_dosug_cafe_kino_restorans":"Leisure, cafe, cinema, restaurants",
        "hcn_goverment":"Government",
        "hcn_organizations":"Organizations",
        "hcn_telecom_operators":"Telecom operators",
        "hcn_shops":"Shops",
        "hcn_forums_18+":"Forums 18+",
        "hcn_bank_finances":"Banking, finance",
        "hcn_museum":"Museums",
        "hcn_medicina_hostitals":"Medicine, hospitals",
        "hcn_miners_pools_curs_etc":"Miners, pools, currency, etc.",
        "hcn_humor_anectdots":"Humor, jokes",
        "hcn_job_hunters":"Job, hunters",
        "hcn_military":"Military",
        "hcn_news":"News",
        "hcn_child_sites":"Child sites",
        "hcn_tech_inteface":"Tech inteface",
        "hcn_ads":"Ads",
        "hcn_blog":"Blogs",
        "hcn_coocking":"Cooking",
        "hcn_metrics":"Metrics",
        "hcn_forex":"Forex",
        "hcn_cdn":"Cdn",
        "hcn_personal":"Personal",
        "hcn_antivirus":"Antivirus",
        "hcn_education":"Education",
        "hcn_gambling":"Gambling",
        "hcn_drugs":"Drugs",
        "hcn_building":"Building",
        "hcn_malware":"Malware",
        "hcn_blocked":"Blocked",
        "hcn_classified":"Classified",
        "hcn_magazins":"Magazins",
        "hcn_sport":"Sport",
        "hcn_turism":"Turism",
        "hcn_auto":"Auto",
        "hcn_relocation":"Relocation",
        "hcn_realestate":"Realestate",
        "hcn_mail":"Mail",
        "hcn_telecom_operators, call-centre":"Telecom operators, Call-Centre"
    };

webix.i18n.locales["en-US"].vascloud.VasAds =
    {
        "Add list item":"Add list item",
        "Advertising javascript lists":"Advertising javascript lists",
        "Groups of js templates":"Groups of js templates",
        "Js list items in groups":"Js list items in groups",
        "Groups assigned to the script":"Groups assigned to the script",
        "Resource":"Resource",
        "Host categories":"Host categories",
        "Host category":"Host category",
        "Name":"Name",
        "Template":"Template",
        "Edit template":"Edit template",
        "Edit parameters":"Edit parameters",
        "Value":"Value",
        "Default":"Default",
        "Edit javascript body":"Edit javascript body",
        "Add rule":"Add rule",
        "Company code":"Company code",
        "Days of the week":"Days of the week",
        "Start date":"Start date",
        "End date":"End date",
        "Start time":"Start time",
        "End time":"End time",
        "Every nth transition":"Every nth transition",
        "Enabled":"Enabled",

        "Lifetime, secs":"Lifetime, secs",
        "Shows count":"Shows count",
        "Origin script":"Origin script",
        "Prepared script":"Prepared script",

        "Show time":"Show time",
        "Pause, sec":"Pause, sec",

        "Cache table":"Cache table",
        "Cache content":"Cache content",

        "Main":"Main",
        "Additionally":"Additionally",

        "Referer":"Referer",
        "Referer host":"Referer host",
        "Company":"Company",
        "Company name":"Company name",
        "Group":"Group",
        "Template name":"Template name",
        "Origin":"Origin",
        "Prepared":"Prepared",
        "Shows":"Shows",

        "Common":"Common",
        "Top companies":"Top companies",
        "Top templates":"Top templates",
        "Top hosts categories":"Top hosts categories",

        "Reports":"Reports",

        "Referer hosts":"Referer hosts",
        "Templates":"Templates",
        "Origins":"Origins",
        "Companies":"Companies",
        "Hosts categories":"Hosts categories"
    };

webix.i18n.locales["en-US"].vascloud.VasCloudAdsStatistics =
    {
        "Common":"Common",
        "Content provider":"Content provider",
        "Offer id":"Offer id",
        "Offer":"Offer",
        "Subaccount":"Subaccount",
        "Company name":"Company name",
        "Traffic":"Traffic",
        "Shows":"Shows",
        "Hits":"Hits",
        "Clicks":"Clicks",
        "Back url":"Back url",
        "Leads":"Leads",
        "Approved":"Approved",
        "Opened":"Opened",
        "Rejected":"Rejected",
        "Paid targets":"Paid targets",
        "Efficiency":"Efficiency",
        "Сommission":"Сommission"
    };

webix.i18n.locales["en-US"].vascloud.VasCloudAccrualsAndPayments =
    {
        "Accruals and payments":"Accruals and payments",
        "Id":"Id",
        "Date":"Date",
        "Accrual":"Accrual",
        "Write-off":"Write-off",
        "Note":"Note",
        "Content provider":"Content provider",
        "Content provider name":"Content provider name",
        "Company":"Company",
        "Compdany name":"Company name",
        "Show canceled":"Show canceled",
        "Request payment":"Request payment",
        "Send us request to get your money and we process it as soon as possible":"Send us request to get your money and we process it as soon as possible",
        "Amount of payment":"Amount of payment",
        "Enter amount of payment":"Enter amount of payment",
        "Notes":"Notes",

        "Make transaction":"Make transaction",
        "Document type":"Document type",
        "Accrue to the counterparty":"Accrue to the counterparty",
        "Write off from counterparty":"Write off from counterparty",
        "Amount":"Amount",
        "Service":"Service",
        "ADS service by VAS Experts":"ADS service by VAS Experts",
        "ADS service by Operator":"ADS service by Operator",
        "External ID":"External ID",
        "Type":"Type",
        "From counterparty":"From counterparty",
        "To counterparty":"To counterparty",
        "Counterparty":"Counterparty",

        "Charge":"Charge",
        "Payment":"Payment",
        "Transfer":"Transfer",
        "Remain":"Remain",

        "Cash":"Cash",
        "Cashless":"Cashless",

        "Enter counterparty":"Enter counterparty",
        "Enter amount":"Enter amount",
        "Select service":"Select service",
        "Select payment type":"Select payment type",
        "Enter date":"Enter date",

        "Transaction saved":"Transaction saved"
    };

webix.i18n.locales["en-US"].vascloud.Classifier =
    {
            "Hosts Categories":"Hosts Categories",
            "Classifier model":"Classifier model",
            "Categories":"Categories",
            "Category":"Category",
            "Category added successfully":"Category added successfully",
            "Category deleted successfully":"Category deleted successfully",
            "Categories deleted successfully":"Categories deleted successfully",
            "Code":"Code",
            "Host":"Host",
            "Hosts":"Hosts",
            "Host text":"Host text",
            "Host added successfully":"Host added successfully",
            "Host deleted successfully":"Host deleted successfully",
            "Hosts deleted successfully":"Hosts deleted successfully",
            "Imported successfully":"Imported successfully",
            "Required field":"Required field",
            "Host category":"Host category",
            "Get":"Get",
            "Check":"Check",
            "Percentage received successfully":"Percentage received successfully",
            "Likely category":"Likely category",
            "Recognition correctness":"Recognition correctness",
            "Train":"Train",
            "Models":"Models",
            "Folders":"Folders",
            "Files":"Files",
            "Model":"Model",
            "Folder":"Folder",
            "File":"File",
            "File contents":"File contents",
            "Add item item":"Add item item",
            "Duplicate model":"Duplicate model",
            "Set default model":"Set default model",
            "Set folder":"Set folder",
            "Save file":"Save file",
            "Duplicate name":"Duplicate name",
            "Model saved successfully":"Model saved successfully",
            "Model duplicated successful":"Model duplicated successful",
            "File saved successfully":"File saved successfully",
            "Folder saved successfully":"Folder saved successfully",
            "File delete successfully":"File delete successfully",
            "File text received successfully":"File text received successfully",
            "HTML text received successfully":"HTML text received successfully",
            "File text saved successfully":"File text saved successfully",
            "Select file":"Select file",
            "Select folder":"Select folder",
            "Select model":"Select model",
            "Folder set successfully":"Folder set successfully",
            "Folder delete successfully":"Folder delete successfully",
            "Files erased successfully":"Files erased successfully",
            "Model delete successfully":"Model delete successfully",
            "Classifier version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].":"Classifier version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].",
            "Recheck category":"Recheck category",
            "Recheck hosts":"Recheck hosts",
            "To recheck":"To recheck",
            "Recheck date":"Recheck date",
            "Hosts recheck successful":"Hosts recheck successful",
            "Hosts recheck failed":"Hosts recheck failed",
            "Category recheck successful":"Category recheck successful",
            "Category recheck failed":"Category recheck failed",
            "Recheck":"Recheck",
            "Are you sure you want to recheck the selected hosts?":"Are you sure you want to recheck the selected hosts?",
            "Are you sure you want to recheck the selected hosts in categories?":"Are you sure you want to recheck the selected hosts in categories?"
    };

webix.i18n.locales["en-US"].vascloud.Protocols =
    {
            "Protocol":"Protocol",
            "Protocols":"Protocols",
            "Required field":"Required field",
            "Group":"Group",
            "Add list item":"Add list item",
            "Protocol groups":"Protocol groups",
            "Click to upload or drag a file here":"Click to upload or drag a file here",
            "File size": "File size",
            "File":"File",
            "State":"State",
            "Help":"Help",
            "Duplicates":"Duplicates",
            "Rows count: ":"Rows count: ",
            "Error items count: ":"Error items count: ",
            "Duplicates count: ":"Duplicates count: ",
            "Inserted items count: ":"Inserted items count: ",
            "Download duplicates file":"Download duplicates file",
            "Download errors file":"Download errors file",
            "Set":"Set",
            "Unset":"Unset",
            "Are you want to set or unset testing flag?":"Are you want to set or unset testing flag?",
            "Setting or unsetting testing flag":"Setting or unsetting testing flag",
            "Flag changed successfully":"Flag changed successfully",

            //Messages
            "Group saved successfully":"Group saved successfully",
            "Group deleted successfully":"Group deleted successfully",
            "Protocol saved successfully":"Protocol saved successfully",
            "Protocol deleted successfully":"Protocol deleted successfully",
            "Protocols from group deleted successfully":"Protocols from group deleted successfully",

            "Suggest group":"Suggest group",

            "Synchronization mode":"Synchronization mode",
            "Company":"Company",
            "Hardware saved successfully":"Hardware saved successfully",
            "Protocols erased successfully":"Protocols erased successfully",
            "Protocols deleted successfully":"Protocols deleted successfully",
            "Protocol enabled successfully":"Protocol enabled successfully",
            "Protocol disabled successfully":"Protocol disabled successfully",
            "Protocol Item enabled successfully":"Protocol Item enabled successfully",
            "Protocol Item disabled successfully":"Protocol Item disabled successfully",
            "Resource List saved successfully":"Resource List saved successfully",
            "Resource List deleted successfully":"Resource List deleted successfully",
            "Protocols Items erased successfully":"Protocols Items erased successfully",
            "Protocols Items deleted successfully":"Protocols Items deleted successfully",
            "Imported successfully":"Imported successfully",
            "Custom Protocols Items":"Custom Protocols Items",
            "Clients Area Manager":"Clients Area Manager",

            //Status
            "New":"New",
            "Processing":"Processing",
            "Success":"Success",
            "Error":"Error",
            "Skipped":"Skipped",
            "DPI Version": "DPI Version",
            "Minimum DPI Version": "Minimum DPI Version",
            "Enter correct version number": "Enter correct version number",
            "Data":"Data",
            "Protocols copied successfully": "Protocols copied successfully",
            "Copy": "Copy",
            "Company name": "Company name",
            "Field is required": "Field is required",

            "Successfully imported rows": "Successfully imported rows",
            "Rows deleted successfully":"Row deleted successfully",
            "Row saved successfully":"Row saved successfully",
            "You have not imported data": "You have not imported data",
            "Forced unloading of custom protocols and default lists": "Forced unloading of custom protocols and default lists",
            "Started forced unloading of custom protocols and default lists": "Started forced unloading of custom protocols and default lists",
            "Finished forced unloading of custom protocols and default lists": "Finished forced unloading of custom protocols and default lists",
            "Forced unloading of protocol directory": "Forced unloading of protocol directory",
            "Started forced unloading of protocol directory": "Started forced unloading of protocol directory",
            "Finish forced unloading of protocol directory": "Finish forced unloading of protocol directory",
            "Run":"Run",
            "Defaults lists": "Defaults lists",
            "Lists VPN companies": "Lists VPN companies",
            "Lists without VPN": "Lists without VPN",
            "By company code": "By company code",
            "Templates": "Templates",
            "List of unsaved items": "List of unsaved items",
            "Items added": "Items added",
            "Items deleted": "Items deleted",
            "Items updated": "Items updated",

            "Intersections with the cloud list count: ": "Intersections with the cloud list count: ",
            "Items checked successfully": "Items checked successfully",
            "There is a '{resource}' intersection in the cloud protocol '{protocol}'": "There is a '{resource}' intersection in the cloud protocol '{protocol}'",
            "Check resource": "Check resource",
            "AS resources": "AS resources",
            "AS number": "AS number",
            "Comment": "Comment",
            "Set invalid for protocols resources": "Set invalid for protocols resources",
            "Any of: SNI, IP, CIDR, IP PORT": "Любой ресурс вида: SNI, IP, CIDR, IP PORT",
            "Updated": "Updated",
            "Search in protocols": "Search in protocols",
            "Search protocols completed": "Search protocols completed",
            "Common list": "Common list",

            "Description protocol": "Description protocol",
            "Protocol description in Russian": "Protocol description in Russian",
            "Protocol description in English": "Protocol description in English",
            "DPI Wiki Version": "DPI Wiki Version",
            "No found": "No found",
            "ERROR_VALIDATE_FORM": "Not all required fields are filled in"
    };

webix.i18n.locales["en-US"].vascloud.CompanyProtocols =
{
        "Company Protocols": "Company Protocols",
        "Add company protocol": "Add company protocol",
        "Priority": "Priority",
        "Are you sure you want to delete the company protocol?":"Are you sure you want to delete the company protocol?",
        "The higher the value is, the higher the priority of items from this protocol in unloading": "The higher the value is, the higher the priority of items from this protocol in unloading",
        "Enter protocol": "Enter protocol",
        "Enter company": "Enter company"
}

webix.i18n.locales["en-US"].vascloud.CompanyEditForm = {
        "Company": "Company",
        "Company name": "Company name",
        "Company title / description": "Company title / description",
        "Enter company name": "Enter company name",
        "Company code": "Company code",
        "Enter company code": "Enter company code",
        "External id": "External id",
        "ITN": "ITN",
        "Additional parameters": "Additional parameters",
        "Custom protocols queue priority": "Custom protocols queue priority",
        "Enter the number": "Enter the number",
        "VPN catalog service": "VPN catalog service",
        "Enabled": "Enabled",
        "Disabled": "Disabled"
};

webix.i18n.locales["en-US"].vascloud.LicensesToken =
    {
            "ID":"ID",
            "Attempts":"Attempts",
            "Licenses Token":"Licenses Token",
            "Token":"Token",
            "Company":"Company",
            "License":"License",
            "License ID":"License ID",
            "Last Error":"Last error",
            "Row updated successful":"Row updated successful",
            "Row added successful":"Row added successful",
            "Automatic generation":"Automatic generation",
            "Autobinding. Do not fill in unnecessarily":"Autobinding. Do not fill in unnecessarily",
            "Created date":"Created date",
            "Updated date":"Updated date",
            "Comments":"Comments",
            "Ticket":"Ticket",

            "Only selected tokens": "Only selected tokens",
            "Type": "Type",
            "Message": "Message",
            "Client address": "Client address",
            "Add License Token": "Add License Token",
            "FastInstall script": "FastInstall script",
            "OIMA FastLic script": "OIMA FastLic script",
            "DPI Script": "DPI Script",
            "OIMA Script": "OIMA Script",
            "OCLD Script": "OCLD Script",
            "OIPA Script": "OIPA Script",
            "EPDG Script": "EPDG Script",
            "Script":"Script",
            "DPI":"DPI",
            "OIMA":"OIMA",
            "OCLD":"OCLD",
            "OIPA":"OIPA",
            "EPDG":"EPDG",
    };

webix.i18n.locales["en-US"].vascloud.RequestTrial = {
        "Company":"Company",
        "Full Name":"Full Name",
        "Email":"E-mail",
        "Phone":"Phone",
        "Notes":"Notes",
        "Status":"Status",
        "Request Trial":"Request Trial",
        "New":"New",
        "Solved":"Solved",
        "Closed":"Closed",
        "Applications":"Applications",
        "Add Request Trial":"Add Request Trial",
        "Id":"Id",
        "Enter company name":"Enter company name",
        "Enter Full Name":"Enter Full Name",
        "Enter correct Email":"Enter correct Email",
        "Enter correct Phone":"Enter correct Phone",
        "Enter status":"Enter status",
        "Date Created":"Date Created",
        "Date Updated":"Date Updated"
};

webix.i18n.locales["en-US"].vascloud.UserActionsLog = {
        "Row id":"Row id",
        "Type code":"Type code",
        "Action":"Action",
        "Value old":"Value old",
        "Value new":"Value new",
        "Create time":"Create time",
        "Update time":"Update time",
        "Create user":"Create user",
        "Update user":"Update user",
        "Differences":"Differences"
};

webix.i18n.locales["en-US"].vascloud.AppStatistics = {
        "Application statistics":"Application statistics",
        "Hardware state":"Hardware state",
        "Property":"Property",
        "State":"State",
        "connect":"connect",
        "disconnect":"disconnect",
        "Lic options":"Lic options",
        "License":"License",
        "Expiration date":"Expiration date",
        "Lic level":"Lic level",
        "Program sections":"Program sections",
        "Code":"Code",
        "Section":"Section",
        "Read":"Read",
        "Record":"Record",
        "Reports":"Reports",
        "Hardware usage":"Hardware usage",
        "Dpiui2 usage":"Dpiui2 usage",

        "App info":"App info",
        "Action":"Action",
        "Action date":"Action date",
        "Client ip":"Client ip",
        "Company info":"Company info",
        "Vas Cloud authorization":"Vas Cloud authorization",
        "authorized":"authorized",
        "unauthorized": "unauthorized",
        "User info":"User info",
        "Lic info":"Lic info",
        "Contact id":"Contact id",
        "Lic limit":"Lic limit",
        "Hardware info":"Hardware info",
        "Hardware type":"Hardware type",
        "Software version":"Software version",
        "Hardware id":"Hardware id",
        "Cloud id":"Cloud id",
        "Hardware name":"Hardware name",
        "Hardware ip":"Hardware ip",
        "Hardware state info":"Hardware state info",

        "Username":"Username",
        "User role":"User role",
        "User sections":"User sections",
        "Version":"Version",

        "Collect hardware info":"Collect hardware info",
        "Authentication":"Authentication",
        "Login":"Login",
        "Logout":"Logout",
        "Installation":"Installation",

        "Dpiui2 version":"Dpiui2 version"
};

webix.i18n.locales["en-US"].vascloud.TestCompanies = {
        "Test companies":"Test companies",
        "Managing test companies":"Managing test companies"
};

webix.i18n.locales["en-US"].vascloud.WosdCompanies = {
        "Companies without SD":"Companies without SD",
        "Enter correct DPI version":"Enter correct DPI version",
        "Managing companies without SD":"Managing companies without SD"
};

webix.i18n.locales["en-US"].vascloud.UlrModule = {
        "Datatable search...":"Datatable search...",
};

webix.i18n.locales["en-US"].vascloud.ApiKeys = {
        "API key":"API key",
        "API keys":"API keys",
        "Add API key":"Add API key",
        "Key copied to clipboard": "Key copied to clipboard",
        "Blocked": "Blocked",
};

webix.i18n.locales["en-US"].vascloud.CustomProtocolsGroups = {
        "Custom protocols groups": "Custom protocols groups",
        "Override Cloud": "Override Cloud",
        "Create a new group": "Create a new group",
        "Group code": "Group code",
        "Group name": "Group name",
        "Cloud protocol": "Cloud protocol",
        "Cloud group": "Cloud group",
        "Custom protocol": "Custom protocol",
        "Add cloud protocol": "Add cloud protocol",
        "Add custom protocol": "Add custom protocol",
        "Protocol type": "Protocol type",
        "Cloudy": "Cloud",
        "Custom": "Custom",
        "Protocol": "Protocol"
};
webix.i18n.locales["ru-RU"].ulr = {};

webix.i18n.locales["ru-RU"].ulr.All = {};

webix.i18n.locales["ru-RU"].ulr.UlrModule =
    {
        "Ipfix number": "Номер Ipfix",
        "Universal lock rules":"Универсальные правила блокировки",
        "Web filter":"Web фильтр",
        "Host categories":"Категории хостов",
        "Add new rule":"Добавить новое правило",
        "Check domain":"Проверить домен",
        "Search database":"Поиск по базе",
        "Bandwidth management": "Управление полосой",
        "Applications & policings":"Приложения и полисинги",
        "Policings profiles":"Профили полисинга",
        "DSCP rules":"Правила DSCP",
        "AS DSCP rules":"Управление приоритетом",
        "Protocols list":"Список протоколов",
        "ASN filter":"Управление AS",
        "IP & ASN excludes":"Исключения IP & AS",
        "IP excludes":"Исключения IP",
        "ASN excludes":"Исключения номеров AS",
        "Whitelist":"Белый список",
        "ISPs & IGWs profiles":"Профили каналов и площадок",
        "ISPs list":"Список каналов",
        "Subscribers list":"Управление абонентами",
        "Add new subscriber":"Добавить абонента",
        "Subscriber management":"Управление абонентами",
        "Add new ISP profile":"Добавить профиль канала",
        "IGWs list":"Список сайтов",
        "Add new IGW profile":"Добавить профиль площадки",
        "Profile management":"Управление профилями",
        "Channels management":"Управление каналами",
        "Channels":"Каналы",
        "Add new channel":"Добавить канал",
        "Sites list":"Список площадок",
        "Add new site":"Добавить площадку",
        "Database search":"Поиск по базе",
        "System global state":"Состояние системы",
        "Dictionaries":"Справочники",
        "Host": "Хост",
        "Sync marker": "Маркер",
        "Hosts list of the {CATEGORY} category": "Список хостов для категории '{CATEGORY}'",
        "Applications CS{INDEX} list":"Список приложений для CS{INDEX}",
        "List host categories":"Список категорий хостов",
        "Host categories":"Категории хостов",
        "Category name":"Название категории",
        "Categories":"Категории",
        "Regulators":"Регуляторы",
        "Mailing":"Рассылки",
        "Edit mailing":"Редактировать рассылку",
        "Mailing id":"id рассылки",
        "Mailing state":"Состояние рассылки",
        "Letter subject":"Тема письма",
        "Timetable":"Расписание",
        "Start time":"Время начала",
        "End time":"Время окончания",
        "Duplicate":"Дубликат",
        "Invalid E-Mail":"Неверный E-Mail",
        "Mail template":"Шаблон письма",
        "Add recipient group":"Добавить группу получателей",
        "Recipient group":"Группа получателей",
        "Recipient contact":"Контакт получателя",
        "Add mailing":"Добавить рассылку",
        "Add new mailing":"Добавить рассылку",
        "Select Mailing from the list":"Выберите рассылку из списка",
        "Mailing list":"Список рассылок",
        "Recipient group list":"Список групп получателей",
        "Select recipient group from the list":"Выберите группу получателей из списка",
        "Group name":"Название группы",
        "Value":"Значение",
        "Add contact":"Добавить контакт",
        "Add new recipient group":"Добавить группу получателей",
        "Edit recipient group":"Редактировать группу получателей",
        "Rules":"Правила",

        "WEB_FILTER_SECTION_ATTENTION": "Web фильтр реализует функцию фильтрации по черному списку протоколов HTTP, HTTPS, QUIC.",
        "WEB_FILTER_SECTION_DESCRIPTION": "Web фильтр реализует функцию фильтрации по черному списку протоколов HTTP, HTTPS, QUIC. В качестве критерия фильтра могут выступать поля протокола HTTP URL, SNI, CN для протоколов HTTPS и QUIC, также поддерживается блокировка трафика для ip или ip port. Данный фильтр реализует политику безусловной блокировки. В качестве цели фильтра могут выступать: канал, список каналов, абонент. В случае если цель не определена политика применяется глобально ко всему трафику проходящему через DPI.В случае, если IP адрес попадает как в определение канала, так и в определение абонента – черный список абонента будет иметь приоритет. При этом, записи внесенные в глобальный черный список будут фильтроваться для всех абонентов и каналов (объединяться со списками, примененными для абонентов и каналов).",
        "Web/IP firewall summary":"Статистика правил Web фильтра",
        "Last entries in Web/IP register":"Последние записи в реестре Web фильтра",
        "Web rule":"Web правило",
        "Enable state changing":"Изменение состояния Вкл./Выкл.",

        "Success":"Успех",
        "Error":"Ошибка",
        "Code":"Код",

        "Delete":"Удалить",
        "Cancel":"Отменить",
        "Ok":"Ок",

        "Are you sure?":"Вы уверены?",
        "Deleting":"Удаление",

        "Id":"id",
        "Mode":"Режим",
        "Date":"Дата",
        "Name":"Название",
        "Type":"Тип",
        "Active":"Активно",
        "Disabled":"Выключено",
        "Enabled":"Включено",
        "Total":"Всего",
        "Rule":"Правило",
        "Rule id":"id правила",
        "Resource raw":"Ресурс",
        "Resource validated":"Проверенный ресурс",
        "Regulator":"Регулятор",
        "Reason":"Причина",
        "Last entries in Whitelist register":"Последние записи в реестре Белого фильтра",
        "Description":"Описание",
        "Status":"Статус",
        "Invalid":"Неправильный",
        "Valid":"Правильный",
        "No validation":"Без проверки",
        "User":"Пользователь",
        "Action":"Действие",
        "Attempts":"Попытки",
        "Max tries":"Макс. число",
        "Hardware":"Оборудование",
        "New value":"Новое значение",
        "Old value":"Старое значение",
        "Network learning":"Обучение сети",
        "State":"Состояние",
        "Running":"Запущено",
        "Not running":"Не запущено",
        "CIDRs num":"Количество IP-prefix",
        "Bridges":"Мосты",
        "CIDR":"IP-prefix",
        "Auto":"Авто",
        "Manual":"Ручной",
        "Just added":"Только что добавленное",
        "Binded":"Связанный",
        "Unbinded":"Несвязанный",
        "Policing profiles":"Профили полисинга",
        "Protocol name":"Название протокола",
        "Priority":"Приоритет",
        "DSCP name":"Название DSCP",
        "Binary value":"Двоичное значение",
        "Decimal value":"Десятичное значение",
        "Policing class":"Класс полисинга",
        "AS number":"Номер AS",
        "Rule name":"Название правила",

        "ASN DSCP rules":"Правила DSCP для номеров AS",
        "IP or CIDR":"IP или IP-prefix",
        "Domain name":"Название домена",
        "Address":"Адрес",
        "TTL":"TTL",
        "Applications protocols":"Прикладные протоколы",
        "DPI hardware name":"Название оборудования DPI",
        "Categories dic items list":"Справочник категорий",
        "Regulators dic items list":"Справочник регуляторов",
        "Status description":"Описание статуса",
        "Export tasks list":"Список задач экспорта",
        "Database extended query syntax":"Расширенный синтаксис запросов к базе данных",
        "Datatable search...":"Поиск по таблице...",
        "Show":"Показать",

        "Warning":"Предупреждение",
        "This lock all resources except the resources in list below!":"Это блокирует все ресурсы, кроме ресурсов в списке ниже!",
        "Rule state":"Состояние правила",
        "Required field":"Обязательное поле",
        "Enter Latin letters and numbers in lowercase":"Введите латинские буквы и цифры в нижнем регистре",
        "Category":"Категория",
        "Public description":"Публичное описание",
        "This description will be shown if you have public blacklist database":"Это описание будет показано, если у вас есть публичная база данных черного списка",
        "This is internal description helps you to find this rule to edit  or change state":"Это внутреннее описание поможет вам найти это правило для редактирования или изменения состояния",
        "Resource":"Ресурс",
        "Resources":"Ресурсы",
        "Select type of resource and put the URL, SNI, CN, IP, IP:PORT or CIDR to this field.":"Выберите тип ресурса и укажите в этом поле URL, SNI, CN, IPv4/IPv6 [PORT], IPv4-prefix [PORT].",
        "Validate":"Проверить",
        "Validation result":"Результат проверки",
        "Add to list":"Добавить в список",
        "Import from file":"Импортировать из файла",
        "List of resources":"Список ресурсов",
        "List of resourses":"Список ресурсов",
        "Clear all":"Очистить все",
        "Apply the rule to ISPs from the list":"Применить правило к каналам из списка",
        "The rule will be applied for all ISPs by default":"Правило будет применяться ко всем каналам по умолчанию",
        "Select ISP which the rule will be applied":"Выберите канал, к которому будет применено правило",
        "Select all":"Выбрать все",
        "Unselect all":"Снять все",
        "Actions log":"Журнал действий",
        "Users actions log":"Журнал действий пользователя",
        "Save changes":"Сохранить изменения",
        "Save and enable":"Сохранить и включить",
        "Save and disable":"Сохранить и отключить",
        "Export rule":"Экспортировать правило",
        "Delete rule":"Удалить правило",
        "Import resources":"Импорт ресурсов",
        "File or clipboard content to import":"Содержимое файла или буфера обмена для импорта",
        "Import":"Импортировать",
        "Paste from clipboard":"Вставить из буфера обмена",
        "Export format":"Формат экспорта",
        "Export to PDF":"Экспорт в PDF",
        "Export to Excel":"Экспорт в Excel",
        "Export to CSV":"Экспорт в CSV",
        "Export":"Экспорт",
        "Whitelist rule":"Правило Белого списка",
        "Saving":"Сохранение",
        "Edit rule":"Редактирование правила",
        "The IP address is valid.":"IP-адрес действителен.",
        "You can add it to the list.":"Вы можете добавить его в список.",
        "Next IP:PORTS will be added:":"Следующие IP будут добавлены:",
        "The IP address is not valid.":"IP-адрес недействителен.",
        "Please enter the IPv4 or IPv6 address in a proper format.":"Пожалуйста, введите адрес IPv4 или IPv6 в правильном формате.",
        "You can add a port number to the ip address with a colon as separator.":"Вы можете добавить номер порта к IP-адресу с двоеточием в качестве разделителя.",
        "This will not work if you add this to the list.":"Это не будет работать, если вы добавите это в список.",
        "The CIDR address is valid.":"IP-prefix действителен.",
        "Next IP-prefix:PORTS will be added:":"Следующие IP-prefix будут добавлены:",
        "The CIDR address is not valid.":"IP-prefix недействителен.",
        "Please enter the IPv4 or IPv6 CIDR in a proper format.":"Пожалуйста, введите IP-prefix IPv4 или IPv6 в правильном формате.",
        "The URL is valid and accessible.":"URL действителен и доступен.",
        "The resource is accessible.":"Ресурс доступен.",
        "The resource is not accessible or not valid.":"Ресурс недоступен или недействителен.",
        "The resource is available via {TYPE} protocol.":"Ресурс доступен по протоколу {TYPE}.",
        "The following resources will be added:":"Будут добавлены следующие ресурсы:",
        "A similar resource has already been added to the following rules:":"Похожий ресурс уже добавлен в следующие правила:",
        "But URL is differ.":"Но URL отличается.",
        "URL":"URL",
        "This is SSL/TLS resource. We can block FULL DOMAIN!":"Это ресурс SSL / TLS. Мы можем заблокировать ДОМЕН ЦЕЛИКОМ!",
        "Next SNI and CN will be added to the list.":"Следующие SNI и CN будут добавлены в список.",
        "SNI":"SNI",
        "CN":"CN",
        "The URL is not accessible or not valid.":"URL не доступен или недействителен.",
        "The CN is valid.":"CN действителен.",
        "But CN is differ.":"Но CN отличается.",
        "The proper CN will be added to the list.":"Правильный CN будет добавлен в список.",
        "The resource is not SSL/TLS or not accessible.":"Ресурс не является SSL / TLS или недоступен.",
        "The SNI is valid.":"SNI действителен.",
        "But SNI is differ.":"Но SNI отличается.",
        "The proper SNI will be added to the list.":"Правильный SNI будет добавлен в список.",
        "Description public":"Публичное описание",
        "Description private":"Частное описание",
        "Click to upload or drag a file here":"Нажмите, чтобы загрузить или перетащите файл сюда",

        "Enter IP or URL with <b>http/https</b> prefix to check resource create correct rule":"Введите IP или URL с префиксом <b>HTTP/HTTPS</b>, чтобы проверить, что ресурс создает правильное правило",
        "Resource check":"Проверка ресурса",
        "Check":"Проверить",
        "This is {TYPE} resource.":"Это ресурс {TYPE}.",
        "Type of block is {TYPE}!":"Тип блокировки: {TYPE}",
        "Certificate general information":"Общая информация по сертификату",
        "Show OpenSSL handshake":"Показать OpenSSL рукопожатие",
        "DNS info":"Информация о DNS",
        "DNS recursion":"DNS рекурсия",
        "Result information":"Информация о результате",
        "To block this resource only with certificate use":"Чтобы заблокировать этот ресурс с помощью сертификата используйте",
        "Download file 1":"Скачать файл 1",
        "To block this resource with certificate + all IPs use":"Чтобы заблокировать этот ресурс с сертификатом + все IP используйте",
        "Download file to import to rule":"Скачать файл для импорта в правило",
        "Download file 2":"Скачать файл 2",
        "To block this resource only with URL use":"Чтобы заблокировать этот ресурс с помощью URL используйте",
        "To block this resource with URL + all IPs use":"Чтобы заблокировать этот ресурс с URL + все IP-адреса используйте",
        "Export results":"Экспорт результатов",
        "Export content":"Экспорт контента",
        "Copy to clipboard":"Скопировать в буфер обмена",
        "Common name":"Общее имя",
        "SANs":"SANs",
        "Total number of SANs":"Общее количество SANs",
        "SSL":"SSL",
        "Signature algorithm":"Алгоритм подписи",
        "Key type":"Тип ключа",
        "Key size":"Размер ключа",
        "Serial Number":"Серийный номер",
        "Not Before":"Не до",
        "Not After":"Не после",
        "Number of certs":"Количество сертификатов",
        "Yes":"Да",
        "No":"Нет",
        "Validation error":"Ошибка проверки",
        "Domain is not accessible or not valid":"Домен недоступен или недействителен",

        "Search by all database rules.":"Поиск по всем правилам базы данных.",
        "Search by Web/IP database.":"Поиск по базе данных Web фильтра.",
        "Use <b>*</b> before and after search word to make wildcard.":"Используйте <b>*</b> до и после поискового слова для поиска по шаблону.",
        "Use <b>\"</b> before and after to serach certain phrase.":"Используйте <b>\"</b> до и после для поиска определенной фразы.",
        "More help.":"Больше помощи.",
        "IP, CIDR, Domain, Commentary":"IP, IP-prefix, Домен, Комментарий",
        "Full text":"Полный текст",
        "By resource":"По ресурсам",
        "By desctription":"По описанию",
        "Search":"Поиск",
        "Search results for":"Результаты поиска для",

        "Policing profiles are connected to ISP profile.":"Профили полисинга связаны с профилем канала.",
        "This profiles can be enabled and disabled. You can edit them.":"Эти профили могут быть включены и отключены. Вы можете редактировать их.",
        "You can use HTB or TBF style policing. TBF doesn`t require root class but don`t support traffic ceiling.":"Вы можете использовать правила HTB или TBF. TBF не требует корневого класса, но не поддерживает потолок трафика.",

        "Edit application policing profile":"Редактирование профиля полисинга",
        "ISP profile configuration":"Настройка профиля канала",
        "Policing type":"Тип полисинга",
        "Inbound profile":"Входящий профиль",
        "Outbound profile":"Исходящий профиль",
        "Numeric value":"Числовое значение",
        "Unit":"Ед. изм.",
        "Enable":"Включить",
        "Disable":"Выключить",
        "Static":"Статик",
        "Applications CS{INDEX} list":"Список приложений для CS{INDEX}",
        "Save profile":"Сохранить профиль",
        "Clear profile":"Очистить профиль",
        "Delete profile":"Удалить профиль",
        "Profile name":"Имя профиля",
        "Set ISP profile schedule":"Установить расписание профиля полисинга",
        "Enable profile":"Включить профиль",
        "Disable profile":"Выключить профиль",
        "Apply template":"Применить шаблон",
        "Cancel template":"Отменить шаблон",
        "Apply profile configuration":"Применить конфигурацию профиля",
        "Week days":"Дни недели",
        "Edit schedule":"Редактировать расписание",

        "Set DSCP":"Установить DSCP",
        "Set DCSP priority to application to use it in ISP profile or use DROP to block application on all DPI units.":"Установите приоритет DSCP для приложения, чтобы использовать его в профиле канала, или используйте DROP, чтобы заблокировать приложение на всех устройствах DPI.",
        "Priority works globally!":"Приоритет работает глобально!",
        "Priority works globally if no ISP is specified!":"Правило устанавливается глобально, если не указаны каналы!",
        "Set priority to protocol":"Установить приоритет для протокола",
        "Start typing protocol name or use protocol list helper.":"Начните вводить имя протокола или используйте вспомогательный список протоколов.",
        "Application protocol":"Протокол приложения",
        "Does not exist":"Не существует",
        "A rule with the selected protocol already exists.":"Правило с выбранным протоколом уже существует.",
        "Replace":"Заменить",
        "Protocol":"Протокол",

        "Protocols list with priority applied.":"Список протоколов с примененным приоритетом.",

        "Set DCSP priority to ASN direction to use it in ISP profile or use DROP to block ASN traffic on all DPI units.":"Установите приоритет DSCP в направлении AS, чтобы использовать его в профиле канала, или используйте DROP, чтобы заблокировать трафик AS на всех устройствах DPI.",
        "Add AS numbers to lists and all ASN traffic will be passed without processing.":"Добавьте номера AS в списки, и весь трафик AS будет проходить без обработки.",
        "Add IP or CIDR to lists and all IP traffic will be passed without processing.":"Добавьте IP или IP-prefix в списки, и весь IP-трафик будет проходить без обработки.",
        "This sets PASS priority to AS numbers and works globally!":"Это устанавливает приоритет PASS для номеров AS и работает глобально!",
        "This sets PASS priority to IP-addresses and works globally!":"Это устанавливает приоритет PASS для IP-адресов и работает глобально!",
        "Enter the CIDR or IP":"Введите IP-prefix или IP",
        "Enter the number":"Введите число",
        "Set exclusion":"Установить исключение",
        "A rule with the selected name already exists.":"Правило с выбранным именем уже существует.",
        "A rule with the selected IP or CIDR already exists.":"Правило с выбранным IP или IP-prefix уже существует.",
        "A rule with the selected AS number already exists.":"Правило с выбранным номером AS уже существует.",

        "Add rule":"Добавить правило",

        "Select ISP Profile from the list":"Выберите профиль канала из списка",
        "Select Subscriber Profile from the list":"Выберите профиль абонента из списка",

        "Only manual":"Только ручной",
        "Only auto":"Только авто",
        "Manual + auto":"Ручной + авто",
        "App DSCP":"DSCP приложений",
        "ASN DSCP":"DSCP номеров AS",

        "Edit ISP profile":"Изменить профиль канала",
        "Edit subscriber profile":"Изменить профиль абонента",
        "ISP profile id":"id профиля канала",
        "Subscriber profile id":"id профиля абонента",
        "ISP profile state":"Состояние профиля канала",
        "ISP profile name":"Имя профиля канала",
        "Subscriber profile name":"Имя профиля абонента",
        "Border":"Площадка",
        "Login on DPI node":"Логин на узле DPI",
        "Lists prefix on DPI node":"Имя профилей услуг на узле DPI",
        "DPI nodes":"Узлы DPI",
        "Select DPI nodes and ports which passing traffic of ISP. If it works via NPB system select all nodes automatically.":"Выберите узлы DPI и порты, которые пропускают трафик канала. Если это работает через систему NPB, выберите все узлы автоматически.",
        "Select DPI nodes and bridges/virtual channel which passing traffic of ISP.":"Выберите узлы DPI и мосты / виртуальные каналы, которые пропускают трафик канала.",
        "Select the DPI nodes that pass subscriber traffic.":"Выберите узлы DPI, которые пропускают трафик абонента.",
        "Add prefix":"Добавить префиксы",
        "Not a CIDR":"Не IP-prefix",
        "Prefix type":"Тип префикса",
        "CIDR - static prefix":"CIDR - статический префикс",
        "BGP - dynamic prefix":"BGP - динамический префикс",
        "Add":"Добавить",
        "Bind":"Привязать",
        "Unbind":"Отвязать",
        "Add ISP profile":"Добавить профиль канала",
        "Add subscriber profile":"Добавить абонента",
        "Dublicate entry":"Двойная запись",

        "Select IGW profile from the list":"Выберите профиль площадки из списка",

        "Edit IGW profile":"Изменить профиль площадки",
        "Edit node":"Редактировать узел",
        "Node name":"Имя узла",
        "IGW profile id":"id профиля площадки",
        "IGW profile name":"Имя профиля площадки",
        "Nodes":"Узлы",
        "Add site":"Добавить площадку",
        "Rule type":"Тип правила",

        "Dictionary":"Справочник",
        "Edit item":"Изменить запись",
        "Item name":"Название",
        "Save item":"Сохранить запись",
        "Add new item":"Добавить новую запись",
        "Add item":"Добавить запись",

        "Sum of classes rates should be less or equal root rate.":"Сумма rate классов должна быть меньше или равна корневому rate.",
        "Autofill":"Автозаполнение",

        "Global Whitelist":"Глобальный Белый список",
        "Set mode for Global Whitelist. It activates all Whitelist rules marked as global.  The Global Whitelist rules applied for all ISPs.":"Установите режим для глобального Белого списка. Он активирует все правила Белого списка, помеченные как глобальные. Правила глобального Белого списка применяются ко всем каналам.",
        "Whitelist for ISPs":"Белый список для каналов",
        "Whitelist for subscribers":"Белый список для абонентов",
        "Set Whitelist mode for subscribers. If enabled for some sibscribers the Whitelist rules which connected to subscriber will be applied.": "Установите режим белого списка для убонента. Если этот параметр включен для какого-либо абонента, применяются правила Белого списка, которые подключены к абоненту.",
        "Set Whitelist mode for ISPs. If enabled for some ISP the Whitelist rules which connected to ISP will be applied.":"Установите режим белого списка для канала. Если этот параметр включен для какого-либо канала, применяются правила Белого списка, которые подключены к каналу.",
        "ISP Whitelist":"Белый список канала",

        "IGWs nodes list":"Список DPI узлов",
        "Select a node from the list to configure":"Выберите ноду из списка для настройки",

        "Tasks":"Задачи",
        "of tasks":"задач",
        "Delete all":"Удалить все",
        "Delete all node tasks":"Удалить все задачи ноды",
        "Node tasks":"Задачи ноды",
        "Tasks list":"Список задач",

        "IGW node":"Нода DPI",
        "Whitelist state":"Состояние Белого списка",
        "ISP profile":"Профиль канала",
        "IGW profile":"Профиль площадки",
        "Subscriber profile":"Профиль абонента",
        "VIP subscriber":"VIP абонент",
        "Policing profile":"Профиль полисинга",

        "Filters":"Фильтры",

        "Check bypass status":"Проверить статус bypass",
        "Disable bypass":"Выключить bypass",
        "Enable bypass":"Включить bypass",
        "Enable non standard mode for NIC":"Включить нестандартный режим для NIC",
        "Disable non standard mode for NIC":"Выключить нестандартный режим для NIC",

        "Checking bypass status of node {name}":"Проверка статуса bypass для ноды {name}",
        "Enabling bypass for node {name}":"Включение bypass для ноды {name}",
        "Disabling bypass for node {name}":"Выключение bypass для ноды {name}",
        "Starting checking bypass state of selected nodes":"Старт проверки статуса bypass для выбранных нод",
        "Starting changing bypass state of selected nodes":"Старт изменений статуса bypass для выбранных нод",
        "Starting changing standard / non-standard NIC mode of selected nodes":"Переключение стандартного / нестандартного режимов для выбранных нод",
        "Finishing checking bypass state of selected nodes":"Завершение проверки статуса bypass для выбранных нод",
        "Finishing changing bypass state of selected nodes":"Завершение изменений статуса bypass для выбранных нод",
        "Finishing changing standard / non-standard NIC mode of selected nodes":"Завершение переключения стандартного / нестандартного режимов для выбранных нод",
        "Enabling non-standard NIC mode for node {name}":"Включение нестандартного режима работы NIC для ноды {name}",
        "Disabling non-standard NIC mode for node {name}":"Выключение нестандартного режима работы NIC для ноды {name}",

        "IGW name":"Площадка",

        "Unknown":"Неизвестно",
        "Some IFs in bypass mode":"Некоторые интерфейсы в режиме bypass",
        "All IFs in bypass mode":"Все интерфейсы в режиме bypass",
        "Some IFs works in standard mode!":"Некоторые интерфейсы работают в стандартном режиме!",
        "All IFs works in standard mode!":"Все интерфейсы работают в стандартном режиме!",
        "Not available":"Недоступно",

        "Node performance":"Производительность ноды",
        "Node logs":"Логи ноды",
        "Nodes list":"Список нод",
        "Node info": "Информация о ноде",
        "Sync node info": "Синхронизировать информацию о ноде",

        "IGWs QoEs list":"Список QoE узлов",
        "Select IGW QoE UI from the list":"Выберите QoE UI узел из списка",
        "QoE UI host":"Хост QoE UI",
        "Protocols group": "Группа протоколов",
        "Protocol / Group name": "Протокол / Группа",
        "Group": "Группа",
        "Hardware list":"Список DPI",
        "Hardware performance":"Производительность DPI",
        "Hardware logs":"Логи DPI",

        "ID":"id",

        "AS resource list":"Переопределенные блоки",
        "Add AS":"Переопределить блок",
        "Edit AS":"Редактирование блок",
        "AS id":"id AS",
        "AS name":"Название AS",
        "Delete AS":"Удалить AS",
        "Enter CIDR to this field.":"Введите IP-prefix в это поле.",
        "This is internal description helps you to find this AS to edit or change state":"Это внутреннее описание поможет вам найти эту AS для редактирования или изменения состояния.",
        "VIP subscribers": "VIP абоненты",
        "VIP subscribers list": "Список VIP абонентов",
        "Last entries of VIP subscribers": "Последние записи VIP абонентов",
        "Subscriber": "Абонент",
        "VIP subscriber [TYPE] is [VALUE].": "[TYPE] VIP абонента - [VALUE].",
        "Add subscriber`s Login or IP to the list and the traffic for this subscriber will pass without restrictions.": "Добавьте Логин или IP абонента в список и трафик для этого абонента будет проходить без ограничений.",
        "The VIP subscriber`s rule is set globally if no ISPs are specified!": "Правило для VIP абонента устанавливается глобально, если не указаны каналы!",

        "AS number must be greater than 0":"Номер AS должен быть больше 0",
        "Duplicate entry":"Дублирующая запись",
        "AS & DSCP":"Управление AS",
        "Enable DSCP App rules edit mode": "Режим редактирования правил DSCP",
        "DSCP backups process": "Процесс бэкапирования DSCP",
        "Created DSCP bakups": "Создано бэкапов DSCP",

        "Custom Protocols": "Кастомные протоколы",

        "Policing profiles are connected to channel profile.": "Профили полисинга связаны с профилем канала.",
        "Policing profiles are connected to place profile.": "Профили полисинга связаны с профилем площадки.",
        "Whole channel policing": "Полисинг общего канала",
        "Edit whole channel policing profile": "Редактировать профиль полисинга общего канала",
        "Place profile configuration": "Редактировать профиль площадки",
        "Channel profile configuration": "Редактировать профиль канала",

        "No info":"Нет информации",
        "Subscribers policing": "Полисинг абонентов",
        "Policing profiles are connected to subscriber profile.": "Профили полисинга связаны с профилем абонента.",
        "Subscriber profile configuration": "Редактировать профиль абонента",

        "ISP policing":"Полисинг каналов",
        "IGW policing":"Полисинг площадок",
        "Subscriber policing":"Полисинг абонентов",

        "Edit ISP policing profile":"Редактировать профиль полисинга канала",
        "Edit IGW policing profile":"Редактировать профиль полисинга площадки",
        "Edit subscriber policing profile":"Редактировать профиль полисинга абонента",
        "Apply the rule to subscribers from the list": "Применить правило к абонентам из списка",
        "The rule will be applied for all subscribers by default": "Правило будет применяться ко всем абонентам по умолчанию",
        "ISP": "Канал",
        "Web Filter rules configuration": "Конфигурация правил Web фильтра",
        "Use federal black lists for Web Filter service profile": "Использовать Глобальные списки для правил в разделе Web фильтр",
        "Vchannel mode": "Режим для каналов",

        "BGP diff auto apply": "Автоприменение изменений BGP",
        "BGP diff notification": "Уведомления об изменениях BGP",
        "Diff created": "Изменение создано",
        "Diff applied": "Изменение применено",
        "IP version": "Версия IP",
        "BOTH": "Оба",
        "Create node export tasks": "Создать задачи экспорта для ноды",
        "Create": "Создать",
        "Nodes export tasks created": "Задачи экспорта для нод созданы",
        "ISP session policing": "DSCP & Per-session канальный",
        "Session policing profiles are connected to channel profile.": "Профиль полисинга сессии связан с профилем канала.",
        "You can set DSCP priority and TBF style policing for protocols.": "Вы можете установить DSCP приоритет и TBF полисинг для протоколов.",
        "Session policing profiles are connected to subscriber profile.": "Профиль полисинга сессии связан с профилем абонента.",
        "Subscribers session policing": "DSCP & Per-session абонентский",
        "Edit ISP session policing profile": "Редактировать профиль полисинга сессии канала",
        "Edit subscriber session policing profile": "Редактировать профиль полисинга сессии абонента",
        "Add protocol / protocol group": "Добавить протокол / группу протоколов",
        "Inbound rate": "Входящий rate",
        "Outbound rate": "Исходящий rate",
        "Edit protocol / protocol group": "Редактировать протокол / группу протоколов",
        "Remove from list":"Убрать из списка",
        "Unmark for deletion":"Снять отметку для удаления",
        "Mark for deletion":"Пометить для удаления",

        "Traffic redirection": "Зеркалирование трафика",
        "Traffic redirection subscriber": "Зеркалирование трафика абонента",
        "List traffic redirection subscribers": "Правила зеркалирования трафика абонентов",
        "Traffic redirection subscriber rule": "Правило зеркалирования трафика абонента",
        "Add the subscriber's login or IP to the list and traffic for this subscriber will be redirected to an external platform.": "Добавьте Логин или IP абонента в список и трафик для этого абонента будет отзеркалирован на внешнюю платформу.",
        "The subscriber`s rule is set globally if no ISPs are specified!": "Правило для абонента устанавливается глобально, если не указаны каналы!",
        "Latest records of subscriber traffic redirection": "Правила зеркалирования трафика абонентов",
        "Traffic redirection subscriber [TYPE] is [VALUE].": "[TYPE] Зеркалированного трафика абонента - [VALUE].",
        "Select subscriber": "Выбрать абонента",
        "Input correct IP address":"Введите корректный IP адрес",
        "Input correct subscriber name":"Введите корректное название абонента",

        "Fill at least one of inputs!":"Заполните хотя бы одно из полей!",

        "SESSION_POLICING_PROFILE_DESCRIPTION_FOR_VCHANNEL":"Профиль полисинга сессии связан с профилем канала. Эти профили позволяют определить классы трафика на уровне канала и поддерживают ограничения скорости отдельных сессий для протоколов.",
        "SESSION_POLICING_PROFILE_DESCRIPTION_FOR_SUBSCRIBER":"Профиль полисинга сессии связан с профилем абонента. Эти профили позволяют определить классы трафика на уровне канала и поддерживают ограничения скорости отдельных сессий для протоколов.",
        "BGP prefixes": "Префиксы BGP",
        "Prefix": "Префикс",
        "BGP time": "Время получения",
        "Help bgp regex": "Помощь по регулярным выражениям bgp",
        "BGP: Regex Guide": "BGP: Руководство по регулярным выражениям",
        "Send time": "Время отправки",
        "Receiver": "Получатель",
        "Force run mailing": "Запустить рассылку принудительно",
        "Run": "Запустить",

        "Resource type": "Тип ресурса",
        "Global": "Глобальное",
        "Globals": "Глобальный",
        "For channels": "Для каналов",
        "For subscribers": "Для абонентов",
        "For channels and subscribers": "Для каналов и абонентов",
        "Rules statistics": "Статистика правил",
        "All filters": "Все фильтры",
        "Just added resources": "Только что добавленные ресурсы",
        "File": "Файл",
        "File size": "Размер файла",
        "New": "Новый",
        "Uploading": "Загружается",
        "Uploaded": "Загружен",
        "Failed": "Ошибка",
        "Clear": "Очистить",
        "Import prefixes": "Импорт префиксов",

        "WEB Filter: import resources":"Web фильтр: импорт ресурсов",
        "List of IPv4 and IPv6": "Список IPv4 и IPv6 адресов",
        "Each IP should be written by new line": "Каждый IP должен быть написан с новой строки",
        "Max available of each type of address": "Максимальное допустимое количество каждого типа адресов",
        "For example": "Например",
        "Enable Trace IP": "Включить Trace IP",
        "List of IPs": "Список IP адресов",
        "Input correct IP list": "Введите корректный список IP адресов",
        "Trace IP": "Trace IP",
        "Check Trace IP status": "Синхронизировать статус Trace IP",
        "Disable Trace IP": "Выключить Trace IP",
        "Trace IP status syncing for {name} started": "Запущен процесс синхронизации Trace IP для {name}",
        "Starting enable/disable Trace IP for {name}": "Запущен процесс вкл./выкл. Trace IP для {name}",
        "Trace IP status syncing for {name} finished": "Завершен процесс синхронизации Trace IP для {name}",
        "Finishing enable/disable Trace IP {name}": "Завершен процесс вкл./выкл. Trace IP для {name}",
        "Trace IP status for {name} synced": "Статус Trace IP для {name} синхронизирован",

        "List of IP-prefixes":"Список IP-префиксов",
        "Just added IP-refixes":"Только что добавленные IP-префиксы",

        "Input number from 1 to 1024": "Введите число от 1 до 1024",
        "Number channel": "Номер канала",
        "Not found free channel": "Не найдено свободного канала",
        "The number exceeded the number of channels on one of the nodes": "Номер превысил количество каналов на одном из узлов",
        "This channel is busy": "Данный канал занят",
        "CIDR: static prefix":"CIDR: статический префикс",
        "Trace IP for {name} enabled/disabled": "Trace IP для {name} вкл./выкл.",
        "Trace IP status syncing for selected nodes finished": "Завершен процесс синхронизации Trace IP для выбранных нод",
        "Finishing enable/disable Trace IP for selected nodes": "Запущен процесс вкл./выкл. Trace IP для выбранных нод",
        "Trace IP status syncing for selected nodes started": "Запущен процесс синхронизации Trace IP для выбранных нод",
        "Starting enable/disable Trace IP for selected nodes": "Запущен процесс вкл./выкл. Trace IP для выбранных нод",

        "Mailing templates list": "Список шаблонов рассылки",
        "Add new mailing template": "Добавить шаблон рассылки",
        "Edit mailing template": "Редактировать шаблон рассылки",
        "Add mailing template": "Добавить шаблон рассылки",
        "Mailing template": "Шаблон рассылки",
        "Mailing templates": "Шаблоны рассылки",
        "Mailing template id": "id шаблона рассылки",
        "Template": "Шаблон",
        "Select Mailing template from the list": "Выберите шаблон рассылки из списка",
        "Insert": "Вставить",
        "Select template": "Выбрать шаблон",
        "Apply": "Применить",
        "System template": "Системный шаблон",

        "Block IPv6 traffic configuration": "Настройки блокировки IPv6 трафика",
        "Block IPv6 traffic for this profile": "Блокировать IPv6 трафик для этого профиля",
        "This channel can not be used": "Это канал не может быть использован",
        "Input correct channel number": "Введите корректный номер канала",
        "Policing": "Полисинг",
        "Per-session policing": "Сессионный полисинг",
        "ISP Session policing Enabled/Disabled": "Сессионный полисинг канала Вкл./Выкл.",
        "ISP policing Enabled/Disabled": "Полисинг канала Вкл./Выкл.",
        "Subscriber Session policing Enabled/Disabled": "Сессионный полисинг абонента Вкл./Выкл.",
        "Subscriber policing Enabled/Disabled": "Полисинг абонента Вкл./Выкл.",
        "Web rules": "Web правила",
        "Isps": "Каналы",
        "Web rules list": "Список Web правил",
        "Global lists": "Глобальные списки",
        "Block IPv6 traffic": "Блокировать IPv6 траффик",
        "Global list state changing": "Изменение состояния глобальных списков",
        "Exclusion list state changing": "Изменение состояния списка исключений",
        "Block IPv6 state changing": "Изменение состояния блокировки IPv6 траффика",
        "Save result": "Результат сохранения",
        "Save prefixes result": "Результат сохранения префиксов",
        "Total prefixes": "Всего префиксов",
        "Inserted prefixes": "Вставлено префиксов",
        "Skipped / duplicates prefixes": "Пропущено / дубликатов префиксов",

        "AS list": "Список AS",
        "Blocks": "Блоки",
        "Search rules":"Искать правила",
        "Search resources":"Искать ресурсы",
        "Search blocks": "Искать блоки",

        "Check resource": "Проверка ресурса",
        "Enter IP or SNI to check that the resource does not overlap with the protocol directory": "Введите IP или SNI чтобы проверить пересечение ресурса с облачным протоколом",
        "Verifiable resource": "Проверяемый ресурс",
        "Protocol id": "id Протокола",
        "Intersection resource": "Пересекаемый ресурс",
        "Intersection info":"Информация о пересечении",
        "No intersections found":"Пересечений не найдено",

        "Cloud protocols":"Облачные протоколы",
        "Custom protocols":"Кастомные протоколы",

        "PCAP recording": "Запись PCAP",
        "PCAP Servers": "Серверы PCAP",
        "To record a subscriber's traffic in PCAP files, add its IP or Login to the rule. Install additional filters.": "Для записи трафика абонента в PCAP файлы, добавьте его IP или Логин в правило. Установите дополнительные фильтры.",
        "PCAP rules": "Правила PCAP",
        "PCAP record rule": "Запись PCAP правила",
        "PCAP record rules [TYPE] is [VALUE].": "[TYPE] запись PCAP правила - [VALUE].",
        "Network protocol": "Сетевой протокол",
        "Files": "Файлы",
        "File content": "Содержимое файла",
        "firts packets": "первые пакеты",
        "Content": "Содержимое",
        "Time": "Время",
        "Source": "Источник",
        "Destination": "Получатель",
        "Info": "Информация",
        "Start now": "Запустить сейчас",
        "Pending start": "Отложенный запуск",
        "Recording duration": "Продолжительность записи",
        "Starting time": "Время старта",
        "You can't specify a date less than the current date": "Нельзя указать дату меньше чем сейчас",
        "Starts in": "Запустится в ",
        "Ends in": "Завершится в ",
        "Catalogs": "Каталоги",
        "Are you sure you want to delete the catalog?": "Вы действительно хотите удалить каталог?",
        "Are you sure you want to clear the catalog?": "Вы действительно хотите очистить каталог?",
        "Expand tree": "Развернуть дерево",
        "Collapse tree": "Свернуть дерево",
        "Download the complete files": "Скачать файлы",
        "Dst ip": "Ip получателя",
        "Destination IPs or prefixes with comma separated":"IP-адреса или префиксы назначения, разделенные запятыми",
        "Input correct IPs or prefixes":"Введите правильные IP-адреса или префиксы",
        "Ports or ports range with comma separated":"Порты или диапазон портов, разделенные запятыми",
        "Input correct ports or ports range":"Введите правильные порты или диапазон портов",

        "Set per-session policing":"Настроить полисинг сессии",
        "Enable per-session policing":"Включить полисинг сессии",
        "Disable per-session policing":"Выключить полисинг сессии",
        "Clear per-session policing":"Очистить полисинг сессии",
        "Added new per-session policing profiles":"Добавлены новые профили полисинга сессии",
        "For selected profiles added new per-session policing profiles.":"Для выбранных профилей добавлены новые профили полисинга сессии.",
        "Set per-session policing for selected profiles":"Настройка полисинга сессий для выбранных профилей",
        "No protocol added.":"Не добавлен протокол.",
        "To set per-session policing for selected profiles, add at least one protocol.":"Чтобы настроить для выбранных профилей полисинг сессии, добавьте хотя бы один протокол.",
        "Protocol has already been added.":"Протокол уже добавлен.",
        "Upload common policings":"Загрузить общие полисинги",
        "Upload common":"Загрузить общее",
        "Upload different":"Загрузить разное",
        "Channel profile":"Профиль канала",
        "Enable profiles":"Включить профили",
        "Disable profiles":"Выключить профили",
        "No common protocols found.":"Общие протоколы не найдены.",
        "No protocols found.":"Протоколы не найдены.",
        "has already been added.":"уже добавлен.",
        "Not all properties are specified for selected protocol.":"Для выбранного протокола указаны не все свойства.",
        "Per-session policing for [PROFILE] is already enabled.":"Полисинг сессии для [PROFILE] уже включен.",
        "Per-session policing for [PROFILE] is already disabled.":"Полисинг сессии для [PROFILE] уже выключен.",
        "To Enable/Disable per-session policing, it must be configured.":"Чтобы включить/выключить полисинг сесии, его необходимо настроить.",
        "Session policing removed.":"Сессионный полисинг удален.",

        "Exclusion list":"Список исключений",
        "Excluded resources":"Исключенные ресурсы",
        "Help":"Помощь",
        "Add resource":"Добавить ресурс",
        "Resources to add":"Ресурсы к добавлению",
        "Import resources from file":"Импорт ресурсов из файла",
        "Add resources to exclusion list":"Добавление ресурсов в список исключений",
        "The web filter exclusion list prevents important resources from being accidentally blocked when blocking lists are automatically imported.":"Список исключений для Web фильтра предотвращает случайную блокировку важных ресурсов при автоматическом импорте списков блокировки.",
        "Exclusions affect the Web filter and Spoof DNS sections.":"Исключения влияют на разделы Web фильтр и DNS-ответ.",
        "Use WEB filter exclusion list":"Использовать список исключений для Web фильтра",
        "Selected resource successfully updated.":"Выбранный ресурс успешно обновлен.",
        "Selected resource successfully deleted.":"Выбранный ресурс успешно удален",
        "Selected resource not updated.":"Выбранный ресурс не обновился.",
        "Selected resource not deleted.":"Выбранный ресурс не удален.",
        "Resources added to exclusion list.":"Ресурсы добавлены в список исключений.",
        "The selected resources are not saved.":"Выбранные ресурсы не сохранены.",
        "All resources successfully deleted.":"Все ресурсы успешно удалены",
        "Resources not deleted.":"Ресурсы не удалены.",
        "Enable selected resources":"Включить выбранные ресурсы",
        "Disable selected resources":"Выключить выбранные ресурсы",
        "Delete selected resources":"Удалить выбранные ресурсы",
        "Delete all resources":"Удалить все ресурсы",
        "Clear exclusion list":"Очистка списка исключений",

        "Created":"Создано",
        "Updated":"Обновлено",

        "Users groups of protocols":"Пользовательские группы протоколов",
        "Protocol groups":"Группы протоколов",
        "Add group":"Добавить группу",
        "Available protocols":"Доступные протоколы",
        "Protocols filter":"Фильтр протоколов",
        "by name":"по названию",
        "by group":"по группе",
        "Group saved successfully.":"Группа успешно сохранена",
        "Group not saved.":"Группа не сохранена.",
        "Group deleted successfully.":"Группа успешно удалена.",
        "Group not deleted.":"Группа не удалена.",
        "Error loading custom group protocol list.":"Ошибка при загрузке списка протоколов пользовательской группы.",
        "To edit custom group protocol list, select or create a group.":"Что бы редактировать пользовательскую группу протоколов, выберите или создайте группу.",
        "To add protocols to group, select available protocols.":"Чтобы добавить протоколы в группу, выберите доступные протоколы.",
        "To remove protocols from a group, select protocols from a custom group.":"Чтобы удалить протоколы из группы, выберите протоколы из пользовательской группы.",
        "Cancel changes":"Отменить изменения",
        "The group has not been saved. Save current group?":"Группа не сохранена. Сохранить текущую группу?",
        "Server error.":"Ошибка сервера.",
        "Users groups of protocols not created":"Пользовательские группы протоколов не созданы",
        "Filter":"Фильтр",
        "Protocol information missing from database.":"Информация о протоколе отсутствует в базе данных.",
        "Custom group information missing from database.":"Информация о пользовательской группе отсутствует в базе данных.",

        "Mailing time":"Время рассылки",
        "Report time":"Время отчета",
        "Set report time":"Настроить время отчета",

        "Page orientation": "Ориентация страницы",
        "Portrait": "Книжная",
        "Landscape": "Альбомная",

        "Display filter":"Отображение фильтра",
        "Apply and disable": "Применить и выключить",

        "Enable IP addresses hard blocking": "Строгая блокировка IP",
        "WEB Filter: IPs hard blocking":"Web фильтр: Строгая блокировка IP адресов",

        "Spoof DNS": "DNS-ответ",
        "Spoof DNS rule": "DNS-ответ правило",
        "SPOOF_DNS_SECTION_DESCRIPTION": "DNS-ОТВЕТ реализует функцию подмены DNS ответов, возвращаемых DNS-сервером для определенных доменных имен. Правила подмены можно включить глобально, а также на каналы. Это позволяет осуществить как балансировку, так и блокировку DNS-ответов.",
        "Enter the host you need in the host field and specify IPv4 in the ip field": "Укажите в поле хост нужный вам хост и в поле IP укажите IPv4.",
        "Enter the host you need in the host field and specify IPv4/IPv6 in the ip field": "Укажите в поле хост нужный вам хост и в поле IP укажите IPv4/IPv6.",
        "Enter the correct host": "Введите корректный хост",
        "Enter the correct IPv4": "Введите корректный IPv4-адрес",
        "Enter the correct IPv4/IPv6": "Введите корректный IPv4/IPv6-адрес",
        "Resources other than IPv4 will be skipped": "Ресурсы отличающиеся от IPv4 будут пропущены.",
        "Resources other than IPv4/IPv6 will be skipped": "Ресурсы отличающиеся от IPv4/IPv6 будут пропущены.",
        "Spoof DNS: import resources": "DNS-ответ: импорт ресурсов",
        "Last entries in Spoof DNS register": "Последние записи в реестре DNS-ответа",
        "Spoof DNS configuration": "Настройки DNS-ответа",
        "Use Spoof DNS for this profile": "Использовать DNS-ответ для этого профиля",
        "Spoof DNS state changing": "Изменение состояния DNS-ответа",

        "Tags": "Метки",
        "Description of tags": "Описание меток",

        "Clear slave logs": "Очистить slave логи",
        "Start trace ip not set": "TRACE IP не запланирован",
        "End trace ip not set": "Завершение trace ip не задан",

        "BRIDGE_CHANNELS_DSCP_NOTE":"Используется только в режиме, когда каналы определены парами портов (bridge). Каждый канал определен на отдельном DPI. Не совместимо с режимом определения каналов по CIDR / IP-prefix.",
        "ULR_FASTRESOURCE": "Импорт из QoE",

        "Imported from QoE.": "Импортирован из QoE.",
        "Will be deleted after [DATE]": "Будет удален после [DATE]",
        "Imported from QoE resource": "Ресурс импортирован из QoE",
        "Unadded resource": "Недобавленный ресурс",
        "You have unadded resource.": "У Вас есть недобавленный ресурс.",
        "Save anyway": "Все равно сохранить",
        "Import of SNI, IP, IP PORT resources into custom protocols from QoE on schedule according to the set filters.": "Импорт ресурсов SNI, IP, IP PORT в кастомные протоколы из QoE по расписанию согласно установленным фильтрам.",

        "Custom protocols groups": "Кастомные группы протоколов",
        "Protocols groups": "Группы протоколов",
        "Custom Protocols groups": "Кастомные группы протоколов",
        "Session policing templates": "Шаблоны сессионных полисингов",
        "List of session policings templates": "Список шаблонов DSCP & Per-session",
        "Template id": "ID шаблона",
        "Session policings templates": "Шаблоны DSCP & Per-session",
        "Add template": "Добавить шаблон",
        "Save template": "Сохранить шаблон",
        "Clear template": "Очистить шаблон",
        "Delete template": "Удалить шаблон",
        "Session policing template": "Шаблон сессионного полисинга",
        "SESSION_POLICING_TEMPLATE_DESCRIPTION": "Конфигурация шаблона DSCP & Per-session",
        "Add session policing template": "Добавить шаблон DSCP & Per-session",
        "Session policings templates list": "Список шаблонов DSCP & Per-session",
        "Isp policings templates list": "Список шаблонов полисингов",

        "Remove protocols": "Удалить протоколы",
        "Protocols from the list will be removed from session policing profile.": "Протоколы из списка будут удалены из профилей полисинга сессий.",
        "Session policing profile": "Профиль DSCP & Per-session",
        "App policing": "Профиль полисинга",

        "Set per-session policing schedule": "Настроить расписание полисинга сессии",
        "Enable per-session policing schedule": "Включить расписание полисинга сессии",
        "Disable per-session policing schedule": "Выключить расписание полисинга сессии",
        "Clear per-session policing schedule": "Очистить расписание полисинга сессии",

        "Subscriber Session policing schedule Enabled/Disabled": "Расписания сессионного полисинга абонента Вкл./Выкл.",
        "ISP Session policing schedule Enabled/Disabled": "Расписания сессионного полисинга канала Вкл./Выкл.",

        "Set per-session policing schedule for selected profiles": "Настройка расписания полисинга сессий для выбранных профилей",
        "Clear current schedule": "Очистить текущее расписание",
        "Upload common schedules": "Загрузить общее расписание",
        "ISP Session policing schedule cleared":"Конфигурая расписания DSCP & Per-session для канала очищена",
        "Subscriber Session policing schedule cleared": "Конфигурая расписания DSCP & Per-session для абонента очищена",
        "No common schedules found.": "Общее расписание не найдено",
        "Configured new per-session policing schedule": "Конфигурация нового расписания DSCP & Per-session",
        "For selected profiles added new per-session policing schedule.": "Для выбранных профилей добавлено новое расписание DSCP & Per-session",
        "Replace configuration by template": "Заменить конфигурацию шаблоном",
        "Add template to configuration": "Добавить шаблон в конфигурацию",
        "Template not found": "Нет шаблона",


        "Enable rules": "Включить правила",
        "Disable rules": "Выключить правила",
        "Rules not selected": "Правила не выбраны",
        "Error disabling rules": "Ошибка выключения правил",
        "Error enabling rules": "Ошибка включения правил",
        "Enabling rules successfully": "Включение правил успешно",
        "Disabling rules successfully": "Выключение правил успешно",

        "Get template": "Получить шаблон",
        "Single column list": "Одноколоночный список",
        "Multi column list": "Многоколоночный список",

        "Block resources as ECH": "Блокировка DNS",
        "WEB Filter: Block resources as ECH": "Web фильтр: Блокировка DNS",
        "DNS Record Type": "Тип DNS-записи",
        "Response": "Ответ",
        "Inputted value": "Введенное значение",
        "Action type": "Действие",
        "Enter the correct value": "Введите корректное значение",
        "Specify Host, DNS Record Type, Action, and Response.": "Укажите Хост, Тип DNS-записи, Действие и Ответ.",
        "Use spoof DNS": "Использовать DNS-ответ",
        "Drop": "Блокировка",
        "Redirect": "Перенаправление",
        "IPv4 for DNS redirect (A)": "IPv4 для редиректа DNS (A)",
        "IPv6 for DNS redirect (AAAA)": "IPv6 для редиректа DNS (AAAA)"
    };
webix.i18n.locales["en-US"].ulr = {};

webix.i18n.locales["en-US"].ulr.All = {};

webix.i18n.locales["en-US"].ulr.UlrModule =
    {
        "Ipfix number": "Ipfix number",
        "Universal lock rules":"Universal lock rules",
        "Web filter":"Web filter",
        "Host categories":"Host categories",
        "Add new rule":"Add new rule",
        "Check domain":"Check domain",
        "Search database":"Search database",
        "Bandwidth management": "Bandwidth management",
        "Applications & policings":"Applications & policings",
        "Policings profiles":"Policings profiles",
        "DSCP rules":"DSCP Rules",
        "AS DSCP rules":"DSCP rules",
        "Protocols list":"Protocols list",
        "ASN filter":"AS filter",
        "IP & ASN excludes":"IP & AS excludes",
        "IP excludes":"IP excludes",
        "ASN excludes":"AS excludes",
        "Whitelist":"Whitelist",
        "Add new  rule":"Add new  rule",
        "ISPs & IGWs profiles":"Channel & Sites profiles",
        "ISPs list":"Channels list",
        "Subscribers list":"Subscribers",
        "Add new ISP profile":"Add new channel profile",
        "Add new subscriber profile":"Add new subscriber profile",
        "Subscriber management":"Subscriber management",
        "IGWs list":"Sites list",
        "Add new IGW profile":"Add new site profile",
        "Profile management":"Profile management",
        "Channels management":"Channels",
        "Channels":"Channels",
        "Add new channel":"Add new channel",
        "Sites list":"Sites",
        "Add new site":"Add new site",
        "Database search":"Database search",
        "System global state":"System global state",
        "Dictionaries":"Dictionaries",
        "Host": "Host",
        "Sync marker": "Marker",
        "Hosts list of the {CATEGORY} category": "Hosts list of the '{CATEGORY}' category",
        "List host categories":"List of host categories",
        "Host categories":"Host categories",
        "Category name":"Category name",
        "Categories":"Categories",
        "Regulators":"Regulators",
        "Rules":"Rules",
        "Mailing":"Mailing",
        "Edit mailing":"Edit mailing",
        "Mailing id":"Mailing id",
        "Mailing state":"Mailing state",
        "Letter subject":"Letter subject",
        "Timetable":"Timetable",
        "Start time":"Start time",
        "End time":"End time",
        "Duplicate":"Duplicate",
        "Invalid E-Mail":"Invalid E-Mail",
        "Mail template":"Mail template",
        "Add recipient group":"Add recipient group",
        "Select Mailing from the list":"Select Mailing from the list",
        "Mailing list":"Mailing list",
        "Add mailing":"Add mailing",
        "Recipient group list":"Recipient group list",
        "Recipient contact":"Recipient contact",
        "Select recipient group from the list":"Select recipient group from the list",
        "Add new mailing":"Add new mailing",
        "Group name":"Group name",
        "Value":"Value",
        "Add contact":"Add contact",
        "Edit recipient group":"Edit recipient group",
        "Add new recipient group":"Add new recipient group",
        "Recipient group":"Recipient group",

        "WEB_FILTER_SECTION_ATTENTION": "Web filter implements the filtering function according to the black list of HTTP, HTTPS, QUIC protocols.",
        "WEB_FILTER_SECTION_DESCRIPTION": "Web filter implements the filtering function according to the black list of HTTP, HTTPS, QUIC protocols. The HTTP URL, SNI, CN protocol fields for HTTPS and QUIC protocols can act as a filter criterion, traffic blocking for ip or ip port are also supported. This filter implements an unconditional blocking policy. The filter target can be: channel, channel list, subscriber. If the target is not defined, the policy is applied globally to all traffic passing through DPI.If the IP address falls into both the channel definition and the subscriber definition, the subscriber blacklist will have priority. At the same time, the entries included in the global blacklist will be filtered for all subscribers and channels (combined with the lists applied to subscribers and channels).",
        "Web/IP firewall summary":"Web filter summary",
        "Last entries in Web/IP register":"Last entries in Web filter register",
        "Web rule":"Web filter rule",
        "Enable state changing":"Enable state changing",

        "Success":"Success",
        "Error":"Error",
        "Code":"Code",

        "Delete":"Delete",
        "Cancel":"Cancel",
        "Ok":"Ok",

        "Are you sure?":"Are you sure?",
        "Deleting":"Deleting",

        "Id":"Id",
        "Mode":"Mode",
        "Date":"Date",
        "Name":"Name",
        "Type":"Type",
        "Active":"Active",
        "Disabled":"Disabled",
        "Enabled":"Enabled",
        "Total":"Total",
        "Rule":"Rule",
        "Rule id":"Rule id",
        "Resource raw":"Resource raw",
        "Resource validated":"Resource validated",
        "Regulator":"Regulator",
        "Reason":"Reason",
        "Last entries in Whitelist register":"Last entries in Whitelist register",
        "Description":"Description",
        "Status":"Status",
        "Invalid":"Invalid",
        "Valid":"Valid",
        "No validation":"No validation",
        "User":"User",
        "Action":"Action",
        "Attempts":"Attempts",
        "Max tries":"Max tries",
        "Hardware":"Hardware",
        "New value":"New value",
        "Old value":"Old value",
        "Network learning":"Network learning",
        "State":"State",
        "Running":"Running",
        "Not running":"Not running",
        "CIDRs num":"IP-prefixes num",
        "Bridges":"Bridges",
        "CIDR":"IP-prefix",
        "Auto":"Auto",
        "Manual":"Manual",
        "Just added":"Just added",
        "Binded":"Binded",
        "Unbinded":"Unbinded",
        "Policing profiles":"Policing profiles",
        "Protocol name":"Protocol name",
        "Priority":"Priority",
        "DSCP name":"DSCP name",
        "Binary value":"Binary value",
        "Decimal value":"Decimal value",
        "Policing class":"Policing class",
        "AS number":"AS number",
        "Rule name":"Rule name",
        "ASN DSCP rules":"AS DSCP rules",
        "IP or CIDR":"IP or IP-prefix",
        "Domain name":"Domain name",
        "Address":"Address",
        "TTL":"TTL",
        "Applications protocols":"Applications protocols",
        "DPI hardware name":"DPI hardware name",
        "Categories dic items list":"Categories dic items list",
        "Regulators dic items list":"Regulators dic items list",
        "Status description":"Status description",
        "Export tasks list":"Export tasks list",
        "Database extended query syntax":"Database extended query syntax",
        "Datatable search...":"Datatable search...",
        "Show":"Show",

        "Warning":"Warning",
        "This lock all resources except the resources in list below!":"This lock all resources except the resources in list below!",
        "Rule state":"Rule state",
        "Required field":"Required field",
        "Enter Latin letters and numbers in lowercase":"Enter Latin letters and numbers in lowercase",
        "Category":"Category",
        "Public description":"Public description",
        "This description will be shown if you have public blacklist database":"This description will be shown if you have public blacklist database",
        "This is internal description helps you to find this rule to edit  or change state":"This is internal description helps you to find this rule to edit  or change state",
        "Resource":"Resource",
        "Resources":"Resources",
        "Select type of resource and put the URL, SNI, CN, IP, IP:PORT or CIDR to this field.":"Select type of resource and put the URL, SNI, CN, IPv4/IPv6 [PORT], IPv4-prefix [PORT] to this field",
        "Validate":"Validate",
        "Validation result":"Validation result",
        "Add to list":"Add to list",
        "Import from file":"Import from file",
        "List of resourses":"List of resourses",
        "List of resources":"List of resources",
        "Clear all":"Clear all",
        "Apply the rule to ISPs from the list":"Apply the rule to channels from the list",
        "The rule will be applied for all ISPs by default":"The rule will be applied for all channels by default",
        "Select ISP which the rule will be applied":"Select channel which the rule will be applied",
        "Select all":"Select all",
        "Unselect all":"Unselect all",
        "Actions log":"Actions log",
        "Users actions log":"Users actions log",
        "Save changes":"Save changes",
        "Save and enable":"Save and enable",
        "Save and disable":"Save and disable",
        "Export rule":"Export rule",
        "Delete rule":"Delete rule",
        "Import resources":"Import resources",
        "File or clipboard content to import":"File or clipboard content to import",
        "Import":"Import",
        "Paste from clipboard":"Paste from clipboard",
        "Export format":"Export format",
        "Export to PDF":"Export to PDF",
        "Export to Excel":"Export to Excel",
        "Export to CSV":"Export to CSV",
        "Export":"Export",
        "Whitelist rule":"Whitelist rule",
        "Saving":"Saving",
        "Edit rule":"Edit rule",
        "The IP address is valid.":"The IP address is valid.",
        "You can add it to the list.":"You can add it to the list.",
        "Next IP:PORTS will be added:":"Next IP:PORTS will be added:",
        "The IP address is not valid.":"The IP address is not valid.",
        "Please enter the IPv4 or IPv6 address in a proper format.":"Please enter the IPv4 or IPv6 address in a proper format.",
        "You can add a port number to the ip address with a colon as separator.":"You can add a port number to the ip address with a colon as separator.",
        "This will not work if you add this to the list.":"This will not work if you add this to the list.",
        "The CIDR address is valid.":"The IP-prefix address is valid.",
        "Next IP-prefix:PORTS will be added:":"Next IP-prefix:PORTS will be added:",
        "The CIDR address is not valid.":"The IP-prefix address is not valid.",
        "Please enter the IPv4 or IPv6 CIDR in a proper format.":"Please enter the IPv4 or IPv6 IP-prefix in a proper format.",
        "The URL is valid and accessible.":"The URL is valid and accessible.",
        "The resource is accessible.":"The resource is accessible.",
        "The resource is not accessible or not valid.":"The resource is not accessible or not valid.",
        "The resource is available via {TYPE} protocol.":"The resource is available via {TYPE} protocol.",
        "The following resources will be added:":"The following resources will be added:",
        "A similar resource has already been added to the following rules:":"A similar resource has already been added to the following rules:",
        "But URL is differ.":"But URL is differ.",
        "URL":"URL",
        "This is SSL/TLS resource. We can block FULL DOMAIN!":"This is SSL/TLS resource. We can block FULL DOMAIN!",
        "Next SNI and CN will be added to the list.":"Next SNI and CN will be added to the list.",
        "SNI":"SNI",
        "CN":"CN",
        "The URL is not accessible or not valid.":"The URL is not accessible or not valid.",
        "The CN is valid.":"The CN is valid.",
        "But CN is differ.":"But CN is differ.",
        "The proper CN will be added to the list.":"The proper CN will be added to the list.",
        "The resource is not SSL/TLS or not accessible.":"The resource is not SSL/TLS or not accessible.",
        "The SNI is valid.":"The SNI is valid.",
        "But SNI is differ.":"But SNI is differ.",
        "The proper SNI will be added to the list.":"The proper SNI will be added to the list.",
        "Description public":"Description public",
        "Description private":"Description private",
        "Click to upload or drag a file here":"Click to upload or drag a file here",

        "Enter IP or URL with <b>http/https</b> prefix to check resource create correct rule":"Enter IP or URL with <b>HTTP/HTTPS</b> prefix to check resource create correct rule",
        "Resource check":"Resource check",
        "Check":"Check",
        "This is {TYPE} resource.":"This is {TYPE} resource.",
        "Type of block is {TYPE}!":"Type of block is {TYPE}!",
        "Certificate general information":"Certificate general information",
        "Show OpenSSL handshake":"Show OpenSSL handshake",
        "DNS info":"DNS info",
        "DNS recursion":"DNS recursion",
        "Result information":"Result information",
        "To block this resource only with certificate use":"To block this resource only with certificate use",
        "Download file 1":"Download file 1",
        "To block this resource with certificate + all IPs use":"To block this resource with certificate + all IPs use",
        "Download file to import to rule":"Download file to import to rule",
        "Download file 2":"Download file 2",
        "To block this resource only with URL use":"To block this resource only with URL use",
        "To block this resource with URL + all IPs use":"To block this resource with URL + all IPs use",
        "Export results":"Export results",
        "Export content":"Export content",
        "Copy to clipboard":"Copy to clipboard",
        "Common name":"Common name",
        "SANs":"SANs",
        "Total number of SANs":"Total number of SANs",
        "SSL":"SSL",
        "Signature algorithm":"Signature algorithm",
        "Key type":"Key type",
        "Key size":"Key size",
        "Serial Number":"Serial Number",
        "Not Before":"Not Before",
        "Not After":"Not After",
        "Number of certs":"Number of certs",
        "Yes":"Yes",
        "No":"No",
        "Validation error":"Validation error",
        "Domain is not accessible or not valid":"Domain is not accessible or not valid",

        "Search by all database rules.":"Search by all database rules.",
        "Search by Web/IP database.":"Search by Web filter database.",
        "Use <b>*</b> before and after search word to make wildcard.":"Use <b>*</b> before and after search word to make wildcard.",
        "Use <b>\"</b> before and after to serach certain phrase.":"Use <b>\"</b> before and after to serach certain phrase.",
        "More help.":"More help.",
        "IP, CIDR, Domain, Commentary":"IP, IP-prefix, Domain, Commentary",
        "Full text":"Full text",
        "By resource":"By resource",
        "By desctription":"By desctription",
        "Search":"Search",
        "Search results for":"Search results for",

        "Policing profiles are connected to ISP profile.":"Policing profiles are connected to channels profiles.",
        "This profiles can be enabled and disabled. You can edit them.":"This profiles can be enabled and disabled. You can edit them.",
        "You can use HTB or TBF style policing. TBF doesn`t require root class but don`t support traffic ceiling.":"You can use HTB or TBF style policing. TBF doesn`t require root class but don`t support traffic ceiling.",

        "Edit application policing profile":"Edit application policing profile",
        "ISP profile configuration":"Channel profile configuration",
        "Policing type":"Policing type",
        "Inbound profile":"Inbound profile",
        "Outbound profile":"Outbound profile",
        "Numeric value":"Numeric value",
        "Unit":"Unit",
        "Enable":"Enable",
        "Disable":"Disable",
        "Static":"Static",
        "Applications CS{INDEX} list":"Applications CS{INDEX} list",
        "Save profile":"Save profile",
        "Clear profile":"Clear profile",
        "Delete profile":"Delete profile",
        "Profile name":"Profile name",
        "Set ISP profile schedule":"Set ISP profile schedule",
        "Enable profile":"Enable profile",
        "Disable profile":"Disable profile",
        "Apply template":"Apply template",
        "Cancel template":"Cancel template",
        "Apply profile configuration":"Apply profile configuration",
        "Week days":"Week days",
        "Edit schedule":"Edit schedule",

        "Set DSCP":"Set DSCP",
        "Set DCSP priority to application to use it in ISP profile or use DROP to block application on all DPI units.":"Set DCSP priority to application to use it in channel profile or use DROP to block application on all DPI units.",
        "Priority works globally!":"Priority works globally!",
        "Priority works globally if no ISP is specified!":"Priority works globally if no channel is specified!",
        "Set priority to protocol":"Set priority to protocol",
        "Start typing protocol name or use protocol list helper.":"Start typing protocol name or use protocol list helper.",
        "Application protocol":"Application protocol",
        "Does not exist":"Does not exist",
        "A rule with the selected protocol already exists.":"A rule with the selected protocol already exists.",
        "Replace":"Replace",
        "Protocol":"Protocol",

        "Protocols list with priority applied.":"Protocols list with priority applied.",

        "Set DCSP priority to ASN direction to use it in ISP profile or use DROP to block ASN traffic on all DPI units.":"Set DCSP priority to AS direction to use it in channel profile or use DROP to block AS traffic on all DPI units.",
        "Add AS numbers to lists and all ASN traffic will be passed without processing.":"Add AS numbers to lists and all AS traffic will be passed without processing.",
        "Add IP or CIDR to lists and all IP traffic will be passed without processing.":"Add IP or IP-prefix to lists and all IP traffic will be passed without processing.",
        "This sets PASS priority to AS numbers and works globally!":"This sets PASS priority to AS numbers and works globally!",
        "This sets PASS priority to IP-addresses and works globally!":"This sets PASS priority to IP-addresses and works globally!",
        "Enter the CIDR or IP":"Enter the IP-prefix or IP",
        "Enter the number":"Enter the number",
        "Set exclusion":"Set exclusion",
        "A rule with the selected name already exists.":"A rule with the selected name already exists.",
        "A rule with the selected IP or CIDR already exists.":"A rule with the selected IP or IP-prefix already exists.",
        "A rule with the selected AS number already exists.":"A rule with the selected AS number already exists.",

        "Add rule":"Add rule",

        "Select ISP Profile from the list":"Select channel profile from the list",
        "Select Subscriber Profile from the list":"Select subscriber profile from the list",

        "Only manual":"Only manual",
        "Only auto":"Only auto",
        "Manual + auto":"Manual + auto",
        "App DSCP":"App DSCP",
        "ASN DSCP":"AS DSCP",

        "Edit ISP profile":"Edit channel profile",
        "Edit subscriber profile":"Edit subscriber profile",
        "ISP profile id":"Channel profile id",
        "Subscriber profile id":"Subscriber profile id",
        "ISP profile state":"Channel profile state",
        "ISP profile name":"Channel profile name",
        "Subscriber profile name":"Subscriber profile name",
        "Border":"Border",
        "Login on DPI node":"Login on DPI node",
        "Lists prefix on DPI node":"Name of service profiles on DPI node",
        "DPI nodes":"DPI nodes",
        "Select DPI nodes and ports which passing traffic of ISP. If it works via NPB system select all nodes automatically.":"Select DPI nodes and ports which passing traffic of channel. If it works via NPB system select all nodes automatically.",
        "Select DPI nodes and bridges/virtual channel which passing traffic of ISP.":"Select DPI nodes and bridges/virtual channel which passing traffic of channel.",
        "Select the DPI nodes that pass subscriber traffic.":"Select the DPI nodes that pass subscriber traffic.",
        "Add prefix":"Add prefix",
        "Not a CIDR":"Not a IP-prefix",
        "Prefix type":"Prefix type",
        "CIDR - static prefix":"CIDR - static prefix",
        "BGP - dynamic prefix":"BGP - dynamic prefix",
        "Add":"Add",
        "Bind":"Bind",
        "Unbind":"Unbind",
        "Add ISP profile":"Add channel profile",
        "Add subscriber profile":"Add subscriber profile",
        "Dublicate entry":"Dublicate entry",

        "Select IGW profile from the list":"Select site profile from the list",

        "Edit IGW profile":"Edit site profile",
        "Edit node":"Edit node",
        "Node name":"Node name",
        "IGW profile id":"Site profile id",
        "IGW profile name":"Site profile name",
        "Nodes":"Nodes",
        "Add site":"Add site",
        "Rule type":"Rule type",

        "Dictionary":"Dictionary",
        "Edit item":"Edit item",
        "Item name":"Item name",
        "Save item":"Save item",
        "Add new item":"Add new item",
        "Add item":"Add item",

        "Sum of classes rates should be less or equal root rate.":"Sum of classes rates should be less or equal root rate.",
        "Autofill":"Autofill",

        "Global Whitelist":"Global Whitelist",
        "Set mode for Global Whitelist. It activates all Whitelist rules marked as global.  The Global Whitelist rules applied for all ISPs.":"Set mode for Global Whitelist. It activates all Whitelist rules marked as global.  The Global Whitelist rules applied for all channels.",
        "Whitelist for ISPs":"Whitelist for channels",
        "Whitelist for subscribers":"Whitelist for subscribers",
        "Set Whitelist mode for subscribers. If enabled for some sibscribers the Whitelist rules which connected to subscriber will be applied.": "Set Whitelist mode for subscribers. If enabled for some sibscribers the Whitelist rules which connected to subscriber will be applied.",
        "Set Whitelist mode for ISPs. If enabled for some ISP the Whitelist rules which connected to ISP will be applied.":"Set Whitelist mode for channels. If enabled for some channel the Whitelist rules which connected to channel will be applied.",
        "ISP Whitelist":"Channel whitelist",

        "IGWs nodes list":"DPIs nodes list",
        "Select a node from the list to configure":"Select a node from the list to configure",

        "Tasks":"Tasks",
        "of tasks":"of tasks",
        "Delete all":"Delete all",
        "Delete all node tasks":"Delete all node tasks",
        "Node tasks":"Node tasks",
        "Tasks list":"Tasks list",

        "IGW node":"Site node",
        "Whitelist state":"Whitelist state",
        "ISP profile":"Channel profile",
        "IGW profile":"Site profile",
        "Subscriber profile":"Subscriber profile",
        "VIP subscriber":"VIP subscriber",
        "Policing profile":"Policing profile",

        "Filters":"Filters",

        "Check bypass status":"Check bypass status",
        "Disable bypass":"Disable bypass",
        "Enable bypass":"Enable bypass",
        "Enable non standard mode for NIC":"Enable non standard mode for NIC",
        "Disable non standard mode for NIC":"Disable non standard mode for NIC",

        "Checking bypass status of node {name}":"Checking bypass status of node {name}",
        "Enabling bypass for node {name}":"Enabling bypass for node {name}",
        "Disabling bypass for node {name}":"Disabling bypass for node {name}",
        "Starting checking bypass state of selected nodes":"Starting checking bypass state of selected nodes",
        "Starting changing bypass state of selected nodes":"Starting changing bypass state of selected nodes",
        "Starting changing standard / non-standard NIC mode of selected nodes":"Starting changing standard / non-standard NIC mode of selected nodes",
        "Finishing checking bypass state of selected nodes":"Finishing checking bypass state of selected nodes",
        "Finishing changing bypass state of selected nodes":"Finishing changing bypass state of selected nodes",
        "Finishing changing standard / non-standard NIC mode of selected nodes":"Finishing changing standard / non-standard NIC mode of selected nodes",
        "Enabling non-standard NIC mode for node {name}":"Enabling non-standard NIC mode for node {name}",
        "Disabling non-standard NIC mode for node {name}":"Disabling non-standard NIC mode for node {name}",

        "IGW name":"Site name",

        "Unknown":"Unknown",
        "Some IFs in bypass mode":"Some IFs in bypass mode",
        "All IFs in bypass mode":"All IFs in bypass mode",
        "Some IFs works in standard mode!":"Some IFs works in standard mode!",
        "All IFs works in standard mode!":"All IFs works in standard mode!",
        "Not available":"Not available",

        "Node performance":"Node performance",
        "Node logs":"Node logs",
        "Nodes list":"Nodes list",
        "Node info": "Node info",
        "Sync node info": "Sync node info",

        "IGWs QoEs list":"QoEs nodes list",
        "Select IGW QoE UI from the list":"Select QoE UI node from the list",
        "QoE UI host":"QoE UI host",
        "Protocols group": "Protocols group",
        "Protocol / Group name": "Protocol / Group name",
        "Group": "Group",
        "Hardware list":"Hardware list",
        "Hardware performance":"Hardware performance",
        "Hardware logs":"Hardware logs",

        "ID":"ID",

        "AS resource list":"AS resource list",
        "Add AS":"Add AS",
        "Edit AS":"Edit AS",
        "AS id":"AS id",
        "AS name":"AS name",
        "Delete AS":"Delete AS",
        "Enter CIDR to this field.":"Enter IP-prefix to this field.",
        "This is internal description helps you to find this AS to edit or change state":"This is internal description helps you to find this AS to edit or change state",
        "VIP subscribers": "VIP subscribers",
        "VIP subscribers list": "VIP subscribers list",
        "Last entries of VIP subscribers": "Last entries of VIP subscribers",
        "Subscriber": "Subscriber",
        "VIP subscriber [TYPE] is [VALUE].": "VIP subscriber [TYPE] is [VALUE].",
        "Add subscriber`s Login or IP to the list and the traffic for this subscriber will pass without restrictions.": "Add subscriber`s Login or IP to the list and the traffic for this subscriber will pass without restrictions.",
        "The VIP subscriber`s rule is set globally if no ISPs are specified!": "The VIP subscriber`s rule is set globally if no channels are specified!",

        "AS number must be greater than 0":"AS number must be greater than 0",
        "Duplicate entry":"Duplicate entry",
        "AS & DSCP":"AS & DSCP",
        "Enable DSCP App rules edit mode": "Enable DSCP App rules edit mode",
        "DSCP backups process": "DSCP backups process",
        "Created DSCP bakups": "Created DSCP backups",

        "Custom Protocols": "Custom protocols",

        "Policing profiles are connected to channel profile.": "Policing profiles are connected to channels profiles.",
        "Policing profiles are connected to place profile.": "Policing profiles are connected to sites profiles.",
        "Whole channel policing": "Whole channel policing",
        "Edit whole channel policing profile": "Edit whole channel policing profile",
        "Place profile configuration": "Site profile configuration",
        "Channel profile configuration": "Channel profile configuration",

        "No info":"No info",
        "Subscribers policing": "Subscribers policing",
        "Policing profiles are connected to subscriber profile.": "Policing profiles are connected to subscribers profiles.",
        "Subscriber profile configuration": "Subscriber profile configuration",

        "ISP policing":"Channels policing",
        "IGW policing":"Sites policing",
        "Subscriber policing":"Subscriber policing",

        "Edit ISP policing profile":"Edit channel policing profile",
        "Edit IGW policing profile":"Edit site policing profile",
        "Edit subscriber policing profile":"Edit subscriber policing profile",
        "Apply the rule to subscribers from the list": "Apply the rule to subscribers from the list",
        "The rule will be applied for all subscribers by default": "The rule will be applied for all subscribers by default",
        "ISP": "Channel",

        "Web Filter rules configuration": "Web filter rules configuration",
        "Use federal black lists for Web Filter service profile": "Use Global lists for rules in the Web filter",
        "Vchannel mode": "Vchannel mode",

        "BGP diff auto apply": "BGP diff auto apply",
        "BGP diff notification": "BGP diff notification",
        "Diff created": "Diff created",
        "Diff applied": "Diff applied",
        "IP version": "IP version",
        "BOTH": "BOTH",
        "Create node export tasks": "Create node export tasks",
        "Create": "Create",
        "Nodes export tasks created": "Nodes export tasks created",
        "ISP session policing": "DSCP & Per-session channel",
        "Session policing profiles are connected to channel profile.": "Session policing profiles are connected to channel profile.",
        "You can set DSCP priority and TBF style policing for protocols.": "You can set DSCP priority and TBF style policing for protocols.",
        "Session policing profiles are connected to subscriber profile.": "Session policing profiles are connected to subscribers profiles.",
        "Subscribers session policing": "DSCP & Per-session subscriber",
        "Edit ISP session policing profile": "Edit channel session policing profile",
        "Edit subscriber session policing profile": "Edit subscriber session policing profile",
        "Add protocol / protocol group": "Add protocol / protocol group",
        "Inbound rate": "Inbound rate",
        "Outbound rate": "Outbound rate",
        "Edit protocol / protocol group": "Edit protocol / protocol group",
        "Remove from list":"Remove from list",
        "Unmark for deletion":"Unmark for deletion",
        "Mark for deletion":"Mark for deletion",

        "Traffic redirection": "Traffic mirroring",
        "Traffic redirection subscriber": "Traffic mirroring for subscriber",
        "List traffic redirection subscribers": "Subscribers traffic mirroring rules",
        "Traffic redirection subscriber rule": "Subscriber traffic mirroring rule",
        "Add the subscriber's login or IP to the list and traffic for this subscriber will be redirected to an external platform.": "Add the subscriber's login or IP to the list and traffic for this subscriber will be redirected to an external platform.",
        "The subscriber`s rule is set globally if no ISPs are specified!": "The subscriber`s rule is set globally if no channels are specified!",
        "Latest records of subscriber traffic redirection": "Latest records of subscriber traffic mirroring",
        "Traffic redirection subscriber [TYPE] is [VALUE].":"Subscriber traffic mirroring [TYPE] is [VALUE].",
        "Select subscriber": "Select subscriber",
        "Input correct IP address":"Input correct IP address",
        "Input correct subscriber name":"Input correct subscriber name",

        "Fill at least one of inputs!":"Fill at least one of inputs!",

        "SESSION_POLICING_PROFILE_DESCRIPTION_FOR_VCHANNEL":"A session policy profile is associated with a channel profile. These profiles allow you to define traffic classes at the channel level and maintain per-session rate limits for protocols.",
        "SESSION_POLICING_PROFILE_DESCRIPTION_FOR_SUBSCRIBER":"A session policy profile is associated with a subscriber profile. These profiles allow you to define traffic classes at the subscriber level and maintain per-session rate limits for protocols.",
        "BGP prefixes": "BGP prefixes",
        "Prefix": "Prefix",
        "BGP time": "BGP time",
        "Help bgp regex": "Help bgp regex",
        "BGP: Regex Guide": "BGP: Regex Guide",
        "Send time": "Send time",
        "Receiver": "Receiver",
        "Force run mailing": "Force run mailing",
        "Run": "Run",
        "Resource type": "Resource type",
        "Global": "Global",
        "Globals": "Globals",
        "For channels": "For channels",
        "For subscribers": "For subscribers",
        "For channels and subscribers": "For channels and subscribers",
        "Rules statistics": "Rules statistics",
        "All filters": "All filters",
        "Clear": "Clear",

        "Just added resources": "Just added resources",
        "File": "File",
        "File size": "File size",
        "New": "New",
        "Uploading": "Uploading",
        "Uploaded": "Uploaded",
        "Failed": "Failed",
        "Import prefixes": "Import prefixes",

        "WEB Filter: import resources":"Web filter: import resources",
        "List of IPv4 and IPv6": "List of IPv4 and IPv6",
        "Each IP should be written by new line": "Each IP should be written by new line",
        "Max available of each type of address": "Max available of each type of address",
        "For example": "For example",
        "Enable Trace IP": "Enable Trace IP",
        "List of IPs": "List of IPs",
        "Input correct IP list": "Input correct IP list",
        "Trace IP": "Trace IP",
        "Check Trace IP status": "Check Trace IP status",
        "Disable Trace IP": "Disable Trace IP",
        "Trace IP status syncing for {name} started": "Trace IP syncing for {name} started",
        "Starting enable/disable Trace IP for {name}": "Starting enable/disable Trace IP for {name}",
        "Trace IP status syncing for {name} finished": "Trace IP status syncing for {name} finished",
        "Finishing enable/disable Trace IP {name}": "Finishing enable/disable Trace IP {name}",
        "Trace IP status for {name} synced": "Trace IP status for {name} synced",

        "List of IP-prefixes":"List of IP-prefixes",
        "Just added IP-refixes":"Just added IP-refixes",

        "Input number from 1 to 1024": "Input number from 1 to 1024",
        "Number channel": "Number channel",
        "Not found free channel": "Not found free channel",
        "The number exceeded the number of channels on one of the nodes": "The number exceeded the number of channels on one of the nodes",
        "This channel is busy": "This channel is busy",
        "CIDR: static prefix":"CIDR: static prefix",
        "Trace IP for {name} enabled/disabled": "Trace IP for {name} enabled/disabled",
        "Trace IP status syncing for selected nodes finished": "Trace IP status syncing for selected nodes finished",
        "Finishing enable/disable Trace IP for selected nodes": "Finishing enable/disable Trace IP for selected nodes",
        "Trace IP status syncing for selected nodes started": "Trace IP status syncing for selected nodes started",
        "Starting enable/disable Trace IP for selected nodes": "Starting enable/disable Trace IP for selected nodes",

        "Mailing templates list": "Mailing templates list",
        "Add new mailing template": "Add new mailing template",
        "Edit mailing template": "Edit mailing template",
        "Add mailing template": "Add mailing template",
        "Mailing template": "Mailing template",
        "Mailing templates": "Mailing templates",
        "Mailing template id": "Mailing template id",
        "Template": "Template",
        "Select Mailing template from the list": "Select Mailing template from the list",
        "Insert": "Insert",
        "Select template": "Select templates",
        "Apply": "Применить",
        "System template": "System template",

        "Block IPv6 traffic configuration": "Block IPv6 traffic configuration",
        "Block IPv6 traffic for this profile": "Block IPv6 traffic for this profile",
        "This channel can not be used": "This channel can not be used",
        "Input correct channel number": "Input correct channel number",
        "Policing": "Policing",
        "Per-session policing": "Per-session policing",
        "ISP Session policing Enabled/Disabled": "Channel session policing Enabled/Disabled",
        "ISP policing Enabled/Disabled": "Channel policing Enabled/Disabled",
        "Subscriber Session policing Enabled/Disabled": "Subscriber Session policing Enabled/Disabled",
        "Subscriber policing Enabled/Disabled": "Subscriber policing Enabled/Disabled",
        "Web rules": "Web filter rules",
        "Isps": "Channels",
        "Web rules list": "Web filter rules list",
        "Global lists": "Global lists",
        "Block IPv6 traffic": "Block IPv6 traffic",
        "Global list state changing": "Global list state changing",
        "Exclusion list state changing": "Exclusion list state changing",
        "Block IPv6 state changing": "Block IPv6 state changing",
        "Save result": "Save result",
        "Save prefixes result": "Save prefixes result",
        "Total prefixes": "Total prefixes",
        "Inserted prefixes": "Inserted prefixes",
        "Skipped / duplicates prefixes": "Skipped / duplicates prefixes",

        "AS list": "AS list",
        "Blocks": "Blocks",
        "Search rules":"Search rules",
        "Search resources":"Search resources",
        "Search blocks": "Search blocks",

        "Check resource": "Check resource",
        "Enter IP or SNI to check that the resource does not overlap with the protocol directory": "Enter IP or SNI to check the intersection of the resource with the cloud protocol",
        "Verifiable resource": "Verifiable resource",
        "Protocol id": "Protocol ID",
        "Intersection resource": "Intersection resource",
        "Intersection info": "Intersection info",
        "No intersections found":"No intersections found",

        "Cloud protocols":"Cloud protocols",
        "Custom protocols":"Custom protocols",

        "PCAP recording": "PCAP recording",
        "PCAP Servers": "PCAP Servers",
        "To record a subscriber's traffic in PCAP files, add its IP or Login to the rule. Install additional filters.": "To record a subscriber's traffic in PCAP files, add its IP or Login to the rule. Install additional filters.",
        "PCAP rules": "PCAP rules",
        "PCAP record rule": "PCAP record rule",
        "PCAP record rules [TYPE] is [VALUE].": "PCAP record rules [TYPE] is [VALUE].",
        "Network protocol": "Network protocol",
        "Files": "Files",
        "File content": "File content",
        "firts packets": "firts packets",
        "Content": "Content",
        "Time": "Time",
        "Source": "Source",
        "Destination": "Destination",
        "Info": "Info",
        "Start now": "Start now",
        "Pending start": "Pending start",
        "Recording duration": "Recording duration",
        "Starting time": "Start time",
        "You can't specify a date less than the current date": "You can't specify a date less than the current date",
        "Starts in": "Starts in ",
        "Ends in": "Ends in ",
        "Catalogs": "Catalogs",
        "Are you sure you want to delete the file?": "Are you sure you want to delete the file?",
        "Are you sure you want to delete the catalog?": "Are you sure you want to delete the catalog?",
        "Are you sure you want to clear the catalog?": "Are you sure you want to clear the catalog?",
        "Expand tree": "Expand tree",
        "Collapse tree": "Collapse tree",
        "Download the complete files": "Download files",
        "Dst ip": "Dst ip",
        "Destination IPs or prefixes with comma separated":"Destination IPs or prefixes with comma separated",
        "Input correct IPs or prefixes":"Input correct IPs or prefixes",
        "Ports or ports range with comma separated":"Ports or port range with comma separated",
        "Input correct ports or ports range":"Input correct ports or ports range",

        "Set per-session policing":"Set per-session policing",
        "Enable per-session policing":"Enable per-session policing",
        "Disable per-session policing":"Disable per-session policing",
        "Clear per-session policing":"Clear per-session policing",
        "Added new per-session policing profiles":"Add new per-session policing profiles",
        "For selected profiles added new per-session policing profiles.":"For selected profiles added new per-session policing profiles.",
        "Set per-session policing for selected profiles":"Set per-session policing for selected profiles",
        "No protocol added.":"No protocol added.",
        "To set per-session policing for selected profiles, add at least one protocol.":"To set per-session policing for selected profiles, add at least one protocol.",
        "Protocol has already been added.":"Protocol has already been added.",
        "Upload common policings":"Upload common policings",
        "Upload common":"Upload common",
        "Upload different":"Upload different",
        "Channel profile":"Channel profile",
        "Enable profiles":"Enable profiles",
        "Disable profiles":"Disable profiles",
        "No protocols found.":"No protocols found.",
        "has already been added.":"has already been added.",
        "Not all properties are specified for selected protocol.":"Not all properties are specified for selected protocol.",
        "Per-session policing for [PROFILE] is already enabled.":"Per-session policing for [PROFILE] is already enabled.",
        "Per-session policing for [PROFILE] is already disabled.":"Per-session policing for [PROFILE] is already disabled.",
        "To Enable/Disable per-session policing, it must be configured.":"To Enable/Disable per-session policing, it must be configured.",

        "Session policing removed.":"Session policing removed.",

        "Exclusion list":"Exclusion list",
        "Excluded resources":"Excluded resources",
        "Help":"Help",
        "Add resource":"Add resource",
        "Resources to add":"Resources to add",
        "Import resources from file":"Import resources from file",
        "Add resources to exclusion list":"Add resources to exclusion list",
        "The web filter exclusion list prevents important resources from being accidentally blocked when blocking lists are automatically imported.":"The Web filter exclusion list prevents important resources from being accidentally blocked when blocking lists are automatically imported.",
        "Exclusions affect the Web filter and Spoof DNS sections.":"Exclusions affect the Web Filter and Spoof DNS sections.",
        "Use WEB filter exclusion list":"Use Web filter exclusion list",
        "Selected resource successfully updated.":"Selected resource successfully updated.",
        "Selected resource successfully deleted.":"Selected resource successfully deleted.",
        "Selected resource not updated.":"Selected resource not updated.",
        "Selected resource not deleted.":"Selected resource not deleted.",
        "Resources added to exclusion list.":"Resources added to exclusion list.",
        "The selected resources are not saved.":"The selected resources are not saved.",
        "All resources successfully deleted.":"All resources successfully deleted.",
        "Resources not deleted.":"Resources not deleted.",
        "Enable selected resources":"Enable selected resources",
        "Disable selected resources":"Disable selected resources",
        "Delete selected resources":"Delete selected resources",
        "Delete all resources":"Delete all resources",
        "Clear exclusion list":"Clear exclusion list",

        "Created":"Created",
        "Updated":"Updated",

        "Users groups of protocols":"User groups of protocols",
        "Protocol groups":"Protocol groups",
        "Add group":"Add group",
        "Available protocols":"Available protocols",
        "Protocols filter":"Protocols filter",
        "by name":"by name",
        "by group":"by group",
        "Group saved successfully.":"Group saved successfully.",
        "Group not saved.":"Group not saved",
        "Group deleted successfully.":"Group deleted successfully.",
        "Group not deleted.":"Group not deleted.",
        "Error loading custom group protocol list.":"Error loading custom group protocol list.",
        "To edit custom group protocol list, select or create a group.":"To edit custom group protocol list, select or create a group.",
        "To add protocols to group, select available protocols.":"To add protocols to group, select available protocols.",
        "To remove protocols from a group, select protocols from a custom group.":"To remove protocols from a group, select protocols from a custom group.",
        "Cancel changes":"Cancel changes",
        "The group has not been saved. Save current group?":"The group has not been saved. Save current group?",
        "Server error.":"Server error.",
        "Users groups of protocols not created":"User groups of protocols not created",
        "Filter":"Filter",
        "Protocol information missing from database.":"Protocol information missing from database.",
        "Custom group information missing from database.":"Custom group information missing from database.",

        "Mailing time":"Mailing time",
        "Report time":"Report time",
        "Set report time":"Set report time",

        "Page orientation": "Page orientation",
        "Portrait": "Portrait",
        "Landscape": "Landscape",

        "Display filter":"Display filter",
        "Apply and disable": "Apply and disable",

        "Enable IP addresses hard blocking": "Strict IP blocking",
        "WEB Filter: IPs hard blocking":"Web filter: Strict IP blocking",

        "Spoof DNS": "Spoof DNS",
        "Spoof DNS rule": "Spoof DNS rule",
        "SPOOF_DNS_SECTION_DESCRIPTION": "The Spoof DNS implements the function of spoofing DNS responses returned by the DNS server for certain domain names. Substitution rules can be enabled globally as well as per channel. This allows for both balancing and blocking of DNS responses.",
        "Enter the host you need in the host field and specify IPv4 in the ip field": "Enter the host you need in the host field and specify IPv4 in the IP field.",
        "Enter the host you need in the host field and specify IPv4/IPv6 in the ip field": "Enter the host you need in the host field and specify IPv4/IPv6 in the IP field.",
        "Enter the correct host": "Enter the correct host",
        "Enter the correct IPv4": "Enter the correct IPv4",
        "Enter the correct IPv4/IPv6": "Enter the correct IPv4/IPv6",
        "Resources other than IPv4 will be skipped": "Resources other than IPv4 will be skipped.",
        "Resources other than IPv4/IPv6 will be skipped": "Resources other than IPv4/IPv6 will be skipped.",
        "Spoof DNS: import resources": "Spoof DNS: import resources",
        "Last entries in Spoof DNS register": "Last entries in Spoof DNS register",
        "Spoof DNS configuration": "Spoof Dns configuration",
        "Use Spoof DNS for this profile": "Use Spoof DNS for this profile",
        "Spoof DNS state changing": "Spoof DNS state changing",

        "Tags": "Tags",
        "Description of tags": "Description of tags",

        "Clear slave logs": "Clear slave logs",
        "Start trace ip not set":"TRACE IP is not scheduled",
        "End trace ip not set": "End trace ip not set",

        "BRIDGE_CHANNELS_DSCP_NOTE":"Used only in the mode where channels are defined by port pairs (bridge). Each channel is defined on a separate DPI. Not compatible with the mode of defining channels by CIDR / IP-prefix.",
        "ULR_FASTRESOURCE": "QoE Import",

        "Imported from QoE.": "Imported from QoE.",
        "Will be deleted after [DATE]": "Will be deleted after [DATE]",
        "Imported from QoE resource": "Imported from QoE resource",
        "Unadded resource": "Unadded resource",
        "You have unadded resource.": "You have unadded resource.",
        "Save anyway": "Save anyway",
        "Import of SNI, IP, IP PORT resources into custom protocols from QoE on schedule according to the set filters.": "Import of SNI, IP, IP PORT resources into custom protocols from QoE on schedule according to the set filters.",

        "Custom protocols groups": "Protocol group management",
        "Protocols groups": "Protocols groups",
        "Custom Protocols groups": "Protocol group management",
        "Session policing templates": "Session policing templates",
        "List of session policings templates": "List of session policings templates",
        "Template id": "Template id",
        "Session policings templates": "Session policings templates",
        "Add session policing template": "Add session policing template",
        "Save template": "Save template",
        "Clear template": "Clear template",
        "Delete template": "Delete template",
        "Session policing template": "Session policing template",
        "SESSION_POLICING_TEMPLATE_DESCRIPTION": "Configure session policing template",
        "Session policings templates list": "Session policings templates list",
        "Isp policings templates list": "Policings templates list",

        "Remove protocols": "Remove protocols",
        "Protocols from the list will be removed from session policing profile.": "Protocols from the list will be removed from session policing profile.",
        "Session policing profile": "Session policing profile",
        "App policing": "App policing",

        "Set per-session policing schedule": "Set per-session policing schedule",
        "Enable per-session policing schedule": "Enable per-session policing schedule",
        "Disable per-session policing schedule": "Disable per-session policing schedule",
        "Clear per-session policing schedule": "Clear per-session policing schedule",

        "Subscriber Session policing schedule Enabled/Disabled": "Subscriber Session policing schedule Enabled/Disabled",
        "ISP Session policing schedule Enabled/Disabled": "ISP Session policing schedule Enabled/Disabled",

        "Set per-session policing schedule for selected profiles": "Set per-session policing schedule for selected profiles",
        "Clear current schedule": "Clear current schedule",
        "Upload common schedules": "Upload common schedules",
        "ISP Session policing schedule cleared":"ISP Session policing schedule cleared",
        "Subscriber Session policing schedule cleared": "Subscriber Session policing schedule cleared",
        "No common schedules found.": "No common schedules found.",
        "Configured new per-session policing schedule": "Configured new per-session policing schedule",
        "For selected profiles added new per-session policing schedule.": "For selected profiles added new per-session policing schedule.",
        "Replace configuration by template": "Replace configuration by template",
        "Add template to configuration": "Add template to configuration",
        "Template not found": "Template not found",

        "Enable rules": "Enable rules",
        "Disable rules": "Disable rules",
        "Rules not selected": "Rules not selected",
        "Error disabling rules": "Error disabling rules",
        "Error enabling rules": "Error enabling rules",
        "Enabling rules successfully": "Enabling rules successfully",
        "Disabling rules successfully": "Disabling rules successfully",

        "Get template": "Get template",
        "Single column list": "Single column list",
        "Multi column list": "Multi column list",

        "Block resources as ECH": "DNS blocking",
        "WEB Filter: Block resources as ECH": "WEB Filter: DNS blocking",
        "DNS Record Type": "DNS Record Type",
        "Response": "Response",
        "Inputted value": "Inputted value",
        "Action type": "Action type",
        "Enter the correct value": "Enter the correct value",
        "Specify Host, DNS Record Type, Action, and Response.":"Specify Host, DNS Record Type, Action, and Response.",
        "Use spoof DNS": "Use spoof DNS",
        "Drop": "Drop",
        "Redirect": "Redirect",
        "IPv4 for DNS redirect (A)": "IPv4 for DNS redirect (A)",
        "IPv6 for DNS redirect (AAAA)": "IPv6 for DNS redirect (AAAA)"
    };
var RequireResourceTypeEnum = {
    "js":"js",
    "css":"css"
};

var RequireModuleEnum = {
    ol:"ol"
};

var RequireModuleFileEnum =
{
    ol:["/webix/codebase/ol.js"]
};

function RequireHelper() {};

RequireHelper.RequireCss = function (Path, Id, OldId, OnLoad)
{
    var head  = document.getElementsByTagName('head')[0];
    var link  = document.createElement('link');
    var oldLink = OldId ? document.getElementById(OldId) : null;

    link.rel  = 'stylesheet';
    link.type = 'text/css';
    link.href = Path;
    link.media = 'all';
    if(Id)
        link.id  = Id;

    if(OnLoad && typeof OnLoad == "function")
    {
        link.onload = function()
        {
            if(oldLink)
                head.removeChild(oldLink);

            OnLoad();
        };
    }
    else if(oldLink)
        head.removeChild(oldLink);


    head.appendChild(link);
};

RequireHelper.RequireJs = function (Path, Id, OldId, OnLoad)
{
    var head  = document.getElementsByTagName('head')[0];
    var link  = document.createElement('script');
    var oldLink = OldId ? document.getElementById(OldId) : null;

    link.type = 'text/javascript';
    link.src = Path;
    link.async = "true";
    if(Id)
        link.id  = Id;

    if(OnLoad && typeof OnLoad == "function")
    {
        link.onload = function()
        {
            if(oldLink)
                head.removeChild(oldLink);

            OnLoad();
        };
    }
    else if(oldLink)
        head.removeChild(oldLink);


    head.appendChild(link);
};

RequireHelper.RequireModule = function (Modules, CallBack)
{
    var modules = Array.isArray(Modules) ? Modules : [Modules];

    var filesArr = [];

    modules.forEach(function (Module)
    {
        if(Module && !window[Module])
        {
            if(RequireModuleEnum[Module]&&RequireModuleFileEnum[Module])
            {
                RequireModuleFileEnum[Module].forEach(function (File)
                {
                    filesArr.push("../.." + File);
                });
            }
        }
    });

    if(filesArr.length)
    {
        webix.require(filesArr, function()
        {
            setTimeout(function () {
                CallBack();
            },1);
        });
    }
    else
    {
        CallBack();
    }
};

RequireHelper.RequireFavicon = function (Path, Id, OldId, OnLoad) {
    var head = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    var oldLink = OldId ? document.getElementById(OldId) : null;

    link.rel = 'shortcut icon';
    link.type = 'image/x-icon';
    link.href = Path;

    if (Id)
        link.id = Id;

    if (OnLoad && typeof OnLoad == "function") {
        link.onload = function () {
            if (oldLink)
                head.removeChild(oldLink);

            OnLoad();
        };
    } else if (oldLink)
        head.removeChild(oldLink);


    head.appendChild(link);
};
var LocalesEnum =
    {
        en:{locale:"en-US", code:"en", title:"English", title_short:"Eng."},
        ru:{locale:"ru-RU", code:"ru", title:"Русский", title_short:"Рус."}
    };

var NonConvertLocalesValues = [" ", ",", ".", "!", ";", ":", "*", "&", "(", ")", "%", "min", "max"];

function LangHelper() {};

LangHelper.GetString = function (Module, Key, Default)
{
    var str = LangHelper._GetString(Module, Key, Default);

    if(SkinHelper.GetDefaultSkin() == SkinsEnum.dpiui2_inss || SkinHelper.IsCubroSkin())
    {
        str = str
            .replace('VAS cloud services', 'Cubro services')
            .replace('VAS Cloud', 'Cubro')
            .replace('VAS Ads', 'Ads')
            .replace('wiki.vasexperts.ru', 'dpidocs.cubro.com')
            .replace('wiki.vasexperts.com', 'dpidocs.cubro.com')
            .replace('VASE Lists', 'Cubro lists')
            .replace(/vas/gi, '');


        return str;
    }

    return str;
}

LangHelper._GetString = function (Module, Key, Default)
{
    if (webix.i18n.dpiui2[Module] && webix.i18n.dpiui2[Module][Key])
    {


        return webix.i18n.dpiui2[Module][Key];
    }

    if (webix.i18n.dpiui2["AppView"][Key])
    {
        return webix.i18n.dpiui2["AppView"][Key];
    }

    if (webix.i18n.dpiui2["All"][Key])
    {
        return webix.i18n.dpiui2["All"][Key];
    }

    if (webix.i18n.vascloud[Module] && webix.i18n.vascloud[Module][Key])
    {
        return webix.i18n.vascloud[Module][Key];
    }

    if (webix.i18n.vascloud["All"][Key])
    {
        return webix.i18n.vascloud["All"][Key];
    }

    if (webix.i18n.ulr[Module] && webix.i18n.ulr[Module][Key])
    {
        return webix.i18n.ulr[Module][Key];
    }

    if (webix.i18n.ulr["All"][Key])
    {
        return webix.i18n.ulr["All"][Key];
    }

    if(webix.i18n.li)
    {
        if (webix.i18n.li[Module] && webix.i18n.li[Module][Key])
        {
            return webix.i18n.li[Module][Key];
        }

        if (webix.i18n.li["All"][Key])
        {
            return webix.i18n.li["All"][Key];
        }
    }


    return Default ? Default : Key;
};

LangHelper.SetLocale = function(Locale)
{
    var locale = Locale ? Locale : LocalesEnum.en.code;

    webix.i18n.setLocale(LocalesEnum[locale].locale);

    localStorage.setItem("locale", locale);
};

LangHelper.GetLocale = function(Locale)
{
    var locale = localStorage.getItem("locale");

    if(!locale)
    {
        var localeLocale = navigator.language || navigator.userLanguage;

        Object.keys(LocalesEnum).every(function (Key)
        {
            if(localeLocale == LocalesEnum[Key].locale)
            {
                locale = Key;
                return false;
            }

            return true;
        });
    }

    if(!locale)
        locale = LocalesEnum.en.code;

    return locale;
};

LangHelper.RestoreLocale = function(Locale)
{
    LangHelper.SetLocale(LangHelper.GetLocale());
};

LangHelper.GetWikiLink = function (Key)
{
    if(webix.i18n.dpiui2["WikiLinks"] && webix.i18n.dpiui2["WikiLinks"]["wiki_doku_link"])
    {
        if(webix.i18n.dpiui2["WikiLinks"][Key])
        {
            return webix.i18n.dpiui2["WikiLinks"]["wiki_doku_link"] + webix.i18n.dpiui2["WikiLinks"][Key];
        }

        return webix.i18n.dpiui2["WikiLinks"]["wiki_doku_link"] + Key;
    }

    return Key;
};

LangHelper.LoadModule = function (Module)
{
    const code = LangHelper.GetLocale();
    const locale = LocalesEnum[code].locale;

    const locales = webix.i18n.locales;

    if(locales[locale] && locales[locale][Module])
    {
        webix.i18n[Module] = locales[locale][Module];
    }
}

LangHelper.RestoreLocale();

LangHelper.GetAfterDaysString = function(numDays)
{
    if (!numDays || isNaN(numDays)) {
        return;
    }

    var locale = LangHelper.GetLocale();

    if (locale === "ru") {

        var res = `Спустя ${numDays} `

        var lastDigit = numDays % 10;
        var lastTwoDigits = numDays % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return res + 'дней';
        } else if (lastDigit === 1) {
            return res + 'день';
        } else if (lastDigit >= 2 && lastDigit <= 4) {
            return res + 'дня';
        } else {
            return res + 'дней';
        }
    }
    else {
        return `After ${numDays} days`;
    }
};

LangHelper.GetReverseLangDic = function (langCode, moduleNames = [])
{
    let resultDic = {};

    if(langCode in LocalesEnum)
    {
        let locale = LocalesEnum[langCode].locale;
        let langDic = webix.i18n.locales[locale].dpiui2;

        if(moduleNames.length)
        {
            let filteredKeys = Object.keys(langDic).filter(key => moduleNames.includes(key));
            langDic = filteredKeys.reduce((filteredDic, moduleKey) => {
                filteredDic[moduleKey] = langDic[moduleKey];
                return filteredDic;
            }, {});
        }

        for (let moduleKey in langDic)
        {
            let moduleDic = langDic[moduleKey];
            let reverseModuleDic = [];

            for(let localeKey in moduleDic)
            {
                let key = moduleDic[localeKey]
                reverseModuleDic[key] = localeKey;
            }

            resultDic[moduleKey] = reverseModuleDic;
        }
    }

    return resultDic;
};

LangHelper.SearchLangKeys = function (str, langDic)
{
    const regex = /([\w\p{L}]+|\S(?=\s|$)|(?<=\s|^)\S)/gu;
    let lastLine = "";
    let foundedKeys = [];
    let itemsArr = [];

    for (let module in langDic)
    {
        let moduleDic = langDic[module];
        if (str in moduleDic) {
            foundedKeys.push({
                lang_key: moduleDic[str],
                module: module
            })
            return foundedKeys;
        }
    }

    let strArr = str.split(regex).filter(item => item !== "");

    let foundedFlag = false;

    while(true)
    {
        foundedFlag = false;

        let line = strArr.join("");

        if (line === lastLine)
            break;

        for (let module in langDic)
        {
            let moduleDic = langDic[module];

            if (NonConvertLocalesValues.includes(line) || line in moduleDic) {
                foundedKeys.push({
                    lang_key: line in moduleDic ? moduleDic[line] : line,
                    module: NonConvertLocalesValues.includes(line) ? null : module
                });
                strArr = itemsArr.reverse();
                lastLine = line;
                itemsArr = [];
                foundedFlag = true;
                break;
            }
        }

        if(foundedFlag)
            continue;

        itemsArr.push(strArr.pop());
        lastLine = line;
    }

    return foundedKeys;
};

LangHelper.GetStringByLangKeys = function(langCode, keysArr)
{
    let result = "";

    if(langCode)
    {
        let locale = LocalesEnum[langCode].locale;
        let langDic = webix.i18n.locales[locale].dpiui2;

        for (let item of keysArr)
        {
            if(item.lang_key)
            {
                result += item.module ? langDic[item.module][item.lang_key] : item.lang_key;
            }
        }
    }

    return result;
};

var SkinsEnum = {
    "dpiui2":"dpiui2",
    "dpiui2_spectre":"dpiui2_spectre",
    "dpiui2_vulkan":"dpiui2_vulkan",
    "dpiui2_dark":"dpiui2_dark",
    "dpiui2_inss":"dpiui2_vulkan",
    "dpiui2_cubro":"dpiui2_cubro",
    "dpiui2_cubro_main":"dpiui2_cubro_main"
};

function SkinHelper() {};

SkinHelper.GetDefaultSkin = function ()
{
    return webix.skin.DefaultSkin ? webix.skin.DefaultSkin : SkinsEnum.dpiui2;
};

SkinHelper.SetDefaultSkin = function (Skin)
{
    webix.skin.DefaultSkin = Skin;
};

SkinHelper.GetSkin = function ()
{
    return webix.skin.$name;
};

SkinHelper.SetSkin = function(Skin, OnLoad)
{
    var currSkin = SkinHelper.GetSkin();

    if(Skin == currSkin)
    {
        OnLoad();
        return;
    }

    if(!SkinsEnum[currSkin])
        currSkin = null;

    webix.skin.set(Skin);

    RequireHelper.RequireCss(SkinsMap[Skin], Skin, currSkin ? currSkin : null, OnLoad);
};


SkinHelper.SetFavicon = function(Favicon, OnLoad)
{
    RequireHelper.RequireFavicon(Favicon, "Favicon", "Favicon", OnLoad);
};



SkinHelper.GetDefaultFilterUiSkin = function ()
{
    return AppEnv.DefaultFilterUiSkin  ? AppEnv.DefaultFilterUiSkin  : SkinsEnum.dpiui2_spectre;
};

SkinHelper.IsFilterUiSkin = function ()
{
    return SkinHelper.GetSkin() === SkinsEnum.dpiui2_spectre || SkinHelper.GetSkin() === SkinsEnum.dpiui2_cubro;
};

SkinHelper.IsCubroSkin = function ()
{
    return SkinHelper.GetSkin() === SkinsEnum.dpiui2_cubro_main ||
        SkinHelper.GetSkin() === SkinsEnum.dpiui2_cubro ||
        vendor === "cubro";
};

SkinHelper.IsVulkanSkin = function ()
{
    return SkinHelper.GetSkin() === SkinsEnum.dpiui2_vulkan || SkinHelper.GetSkin() === SkinsEnum.dpiui2_inss;
};

SkinHelper.GetChartStyle = function ()
{
    if
    (
        webix.skin[SkinHelper.GetSkin()] &&
        webix.skin[SkinHelper.GetSkin()].chart &&
        webix.skin[SkinHelper.GetSkin()].chart.xAxis &&
        webix.skin[SkinHelper.GetSkin()].chart.yAxis
    )
    {
        return  webix.skin[SkinHelper.GetSkin()].chart;
    }

    return undefined;
};
var ServicesDic = {
    "4": {
        "value": LangHelper.GetString("Dics", "Black list"),
        "code": "black_list",
        "id": 4,
        "order": 0
    },
    "5": {
        "value": LangHelper.GetString("Dics", "White list"),
        "code": "white_list",
        "id": 5,
        "order": 1
    },
    "9": {
        "value": LangHelper.GetString("Dics", "Netflow stats"),
        "code": "netflow",
        "id": 9,
        "order": 2
    },
    "11": {
        "value": LangHelper.GetString("Dics", "CGNAT"),
        "code": "cgnat",
        "id": 11,
        "order": 3
    },
    "13": {
        "value": LangHelper.GetString("Dics", "Mini Firewall"),
        "code": "firewall",
        "id": 13,
        "order": 4
    },
    "15": {
        "value": LangHelper.GetString("Dics", "VIP subscriber"),
        "code": "vip",
        "id": 15,
        "order": 5
    },
    "10": {
        "value": LangHelper.GetString("Dics", "DDoS protection"),
        "code": "ddos_guard",
        "id": 10,
        "order": 6
    },
    "8": {
        "value": LangHelper.GetString("Dics", "Passed DDoS protection"),
        "code": "ddos_pass",
        "id": 8,
        "order": 7
    },
    "6": {
        "value": LangHelper.GetString("Dics", "Announcement"),
        "code": "user_alert",
        "id": 6,
        "order": 8
    },
    "50": {
        "value": LangHelper.GetString("Dics", "Notification"),
        "code": "notify",
        "id": 50,
        "order": 9
    },
    "1": {
        "value": LangHelper.GetString("Dics", "Bonus program"),
        "code": "bonus",
        "id": 1,
        "order": 10
    },
    "2": {
        "value": LangHelper.GetString("Dics", "Advertising"),
        "code": "adv",
        "id": 2,
        "order": 11
    },
    "3": {
        "value": LangHelper.GetString("Dics", "Ad blocking"),
        "code": "adv_block",
        "id": 3,
        "order": 12
    },
    "7": {
        "value": LangHelper.GetString("Dics", "Caching"),
        "code": "cash",
        "id": 7,
        "order": 13
    },
    "17": {
        "value": LangHelper.GetString("Dics", "Traffic redirection"),
        "code": "traffic_redirection",
        "id": 17,
        "order": 14
    },
    "18": {
        "value": LangHelper.GetString("Dics", "Session policings"),
        "code": "session_policings",
        "id": 18,
        "order": 15
    },
    "12": {
        "value": LangHelper.GetString("Dics", "PCAP recording"),
        "code": "pcap",
        "id": 12,
        "order": 16
    },
    "49": {
        "value": LangHelper.GetString("Dics", "Blocking IPv6"),
        "code": "block_ipv6",
        "id": 49,
        "order": 17
    },
    "19": {
        "value": LangHelper.GetString("Dics", "Spoof DNS"),
        "code": "spoof_dns",
        "id": 19,
        "order": 18
    }
};

var ServicesEnum =
    {
        bonus:"1",
        adv:"2",
        adv_block:"3",
        black_white_list:"4",
        black_list:"4",
        white_list:"5",
        user_alert:"6",
        cash:"7",
        ddos_pass:"8",
        netflow:"9",
        ddos_guard:"10",
        cgnat:"11",
        pcap:"12",
        firewall:"13",
        vip:"15",
        traffic_redirection:"17",
        session_policings:"18",
        notify:"50"
    }

var ServicesTabsDic = {
    "1": {"value": LangHelper.GetString("Dics", "Bonus program"), "code": "bonus", "id": 1},
    "2": {"value": LangHelper.GetString("Dics", "Advertising"), "code": "adv", "id": 2},
    "3": {"value": LangHelper.GetString("Dics", "Ad blocking"), "code": "adv_block", "id": 3},
    "4": {"value": LangHelper.GetString("Dics", "Black and white lists"), "code": "black_white_list", "id": 4},
    "6": {"value": LangHelper.GetString("Dics", "Announcement"), "code": "user_alert", "id": 6},
    "7": {"value": LangHelper.GetString("Dics", "Caching"), "code": "cash", "id": 7},
    "8": {"value": LangHelper.GetString("Dics", "Passed DDoS protection"), "code": "ddos_pass", "id": 8},
    "9": {"value": LangHelper.GetString("Dics", "Netflow stats"), "code": "netflow", "id": 9},
    "10": {"value": LangHelper.GetString("Dics", "DDoS protection"), "code": "ddos_guard", "id": 10},
    "11": {"value": LangHelper.GetString("Dics", "CGNAT"), "code": "cgnat", "id": 11},
    "12": {"value": LangHelper.GetString("Dics", "PCAP recording"), "code": "pcap", "id": 12},
    "13": {"value": LangHelper.GetString("Dics", "Mini Firewall"), "code": "firewall", "id": 13},
    "15": {"value": LangHelper.GetString("Dics", "VIP subscriber"), "code": "vip", "id": 15},
    "17": {"value": LangHelper.GetString("Dics", "Traffic redirection"), "code": "traffic_redirection", "id": 17},
    "18": {"value": LangHelper.GetString("Dics", "Session policings"), "code": "session_policings", "id": 18},
    "50": {"value": LangHelper.GetString("Dics", "Notification"), "code": "notify", "id": 50}
};

var ServicesLicLevelsDic = {
    "1": {"id": 1},
    "2": {"id": 2, "lic_level": ["complete"], "lic_options": ""},
    "3": {"id": 3},
    "4": {"id": 4, "lic_level": ["bras", "complete"]},
    "6": {"id": 6},
    "7": {"id": 7},
    "8": {"id": 8},
    "9": {"id": 9},
    "10": {"id": 10, "lic_level": ["complete"], "lic_options": "ddos_pass"},
    "11": {"id": 11, "lic_level": ["complete"], "lic_options": "cgnat"},
    "13": {"id": 13, "lic_level": ["complete"], "lic_options": "firewall"},
    "18": {"id": 18, "lic_level": ["base", "complete"], "lic_options": "channels"},
    "50": {"id": 50}
};

var BlProfileDic =
    {
        "1": {"value": LangHelper.GetString("Dics", "Profile [number]").replace("[number]", "1"), "id": "1"},
        "2": {"value": LangHelper.GetString("Dics", "Profile [number]").replace("[number]", "2"), "id": "2"},
        "3": {"value": LangHelper.GetString("Dics", "Profile [number]").replace("[number]", "3"), "id": "3"},
        "4": {"value": LangHelper.GetString("Dics", "Profile [number]").replace("[number]", "4"), "id": "4"}
    };

var TariffProfileDic =
    {
        "1": {"value": "Tariff 1", "id": "1"},
        "2": {"value": "Tariff 2", "id": "2"},
        "3": {"value": "Tariff 3", "id": "3"},
        "4": {"value": "Tariff 4", "id": "4"}
    };

var TrafficUnits =
    {
        "1": {"value": LangHelper.GetString("Dics", "Bps"), "id": "bit"},
        "2": {"value": LangHelper.GetString("Dics", "Kbps"), "id": "kbit"},
        "3": {"value": LangHelper.GetString("Dics", "Mbps"), "id": "mbit"},
        "4": {"value": LangHelper.GetString("Dics", "Gbps"), "id": "gbit"}
    };

var TrafficUnitsEnum =
    {
        "bit": LangHelper.GetString("Dics", "Bps"),
        "kbit": LangHelper.GetString("Dics", "Kbps"),
        "mbit": LangHelper.GetString("Dics", "Mbps"),
        "gbit": LangHelper.GetString("Dics", "Gbps")
    };

var TrafficVals = {
    "bit": {id: "bit", value: 1},
    "kbit": {id: "kbit", value: Math.pow(10, 3)},
    "mbit": {id: "mbit", value: Math.pow(10, 6)},
    "gbit": {id: "gbit", value: Math.pow(10, 9)}
};

var TariffTypes = {
    "0": {"value": LangHelper.GetString("Dics", "Named tariff"), "id": "0"},
    "1": {"value": LangHelper.GetString("Dics", "Personal tariff"), "id": "1"}
};

var TariffTypesTooltip = {
    "0": {"value": LangHelper.GetString("Dics", "Named tariff assigned to a group of subscribers"), "id": "0"},
    "1": {"value": LangHelper.GetString("Dics", "Unnamed tariff assigned personally to the subscriber"), "id": "1"}
};

var BufferUnits =
    {
        "1": {"value": LangHelper.GetString("Dics", "Bit"), "id": "bit"},
        "2": {"value": LangHelper.GetString("Dics", "Kbit"), "id": "kbit"},
        "3": {"value": LangHelper.GetString("Dics", "Mbit"), "id": "mbit"},
        "4": {"value": LangHelper.GetString("Dics", "Gbit"), "id": "gbit"}
    };

var AdvsStatesDic =
    {
        "1": {"value": LangHelper.GetString("Dics", "Introduced"), "id": "1"},
        "2": {"value": LangHelper.GetString("Dics", "Waiting"), "id": "2"},
        "3": {"value": LangHelper.GetString("Dics", "Active"), "id": "3"},
        "4": {"value": LangHelper.GetString("Dics", "Completed"), "id": "4"}
    };

var AdvcProcessedSubscribersStatesDic = {
    "-1": {"value": LangHelper.GetString("Dics", "Subscriber.Inactive"), "id": "-1"},
    "1": {"value": LangHelper.GetString("Dics", "Subscriber.Introduced"), "id": "1"},
    "2": {"value": LangHelper.GetString("Dics", "Subscriber.Ready"), "id": "2"},
    "3": {"value": LangHelper.GetString("Dics", "Subscriber.Active"), "id": "3"},
    "4": {"value": LangHelper.GetString("Dics", "Subscriber.Completed"), "id": "4"},
    "5": {"value": LangHelper.GetString("Dics", "Subscriber.Error"), "id": "5"}
};


var AdvCampaignParamTypes = {
    "string": {id: "string", value: LangHelper.GetString("Advc", "String")},
    "enum": {id: "enum", value: LangHelper.GetString("Advc", "Enumeration")}
};

var UsersDic =
    {
        "1": {"value": "Руснак А.", "id": "1"},
        "2": {"value": "Парамонов К.", "id": "2"}
    };

var DpiGroupDic =
    {
        "1": {"value": LangHelper.GetString("Dics", "Group [number]").replace("[number]", "1"), "id": "1"},
        "2": {"value": LangHelper.GetString("Dics", "Group [number]").replace("[number]", "2"), "id": "2"}
    };

var DaysOfWeekDic =
    {
        "1": {"value": LangHelper.GetString("Dics", "Mon"), "id": "1"},
        "2": {"value": LangHelper.GetString("Dics", "Tue"), "id": "2"},
        "3": {"value": LangHelper.GetString("Dics", "Wed"), "id": "3"},
        "4": {"value": LangHelper.GetString("Dics", "Thu"), "id": "4"},
        "5": {"value": LangHelper.GetString("Dics", "Fri"), "id": "5"},
        "6": {"value": LangHelper.GetString("Dics", "Sat"), "id": "6"},
        "7": {"value": LangHelper.GetString("Dics", "Sun"), "id": "7"}
    };

var EnableDic = {
    "0": {"value": LangHelper.GetString("Dics", "Campaign is stopped (default)"), "id": "0"},
    "1": {"value": LangHelper.GetString("Dics", "Campaign started"), "id": "1"}

};

var DateFormatDic = {
    en:{ru:"en", date_format:"%m/%d/%Y", datetime_format:"%m/%d/%Y %H:%i", full_format:"%m/%d/%Y %H:%i:%s", datetime_short_format:"%m/%d %H:%i"},
    ru:{id:"ru", date_format:"%d.%m.%Y", datetime_format:"%d.%m.%Y %H:%i", full_format:"%d.%m.%Y %H:%i:%s", datetime_short_format:"%d.%m %H:%i"}
}

var ChartTypesDic = {
    "splineArea": {id:"splineArea", value:LangHelper.GetString("QoE","Spline area")},
    "area": {id:"area", value:LangHelper.GetString("QoE","Area")},
    "stackedArea": {id:"stackedArea", value:LangHelper.GetString("QoE","Stacked area")},
    "line": {id:"line", value:LangHelper.GetString("QoE","Line")},
    "stackedBar": {id:"stackedBar", value:LangHelper.GetString("QoE", "Stacked bar chart")}
};

var ChartScalesDic = {
    "linear": {id:"linear", value:LangHelper.GetString("QoE", "Linear")},
    "logarithmic": {id:"logarithmic", value:LangHelper.GetString("QoE", "Logarithmic")}
};

var ChartsTimeStepsDic = {
    "auto": {id: "auto", value: LangHelper.GetString("UlrModule", "Auto")},
    1: {id: 1, value: LangHelper.GetString("All", "1 minute")},
    5: {id: 5, value:LangHelper.GetString("All", "5 minutes")},
    10: {id: 10, value:LangHelper.GetString("All", "10 minutes")},
    15: {id: 15, value:LangHelper.GetString("All", "15 minutes")},
    30: {id: 30, value:LangHelper.GetString("All", "30 minutes")},
    60: {id: 60, value:LangHelper.GetString("All", "1 hour")},
    1440: {id: 1440, value: LangHelper.GetString("All", "1 day")},
    43200: {id: 43200, value: LangHelper.GetString("All", "1 month")},
    129600: {id: 129600, value: LangHelper.GetString("All", "3 months")},
    518400: {id: 518400, value: LangHelper.GetString("All", "1 year")}
};

var ColorsDic =
    {
        "1": {"value": "#949fb1", "id": "1"},
        "2": {"value": "#ba68c8", "id": "2"},
        "3": {"value": "#7986cb", "id": "3"},
        "4": {"value": "#4fc3f7", "id": "4"},
        "5": {"value": "#4db6ac", "id": "5"},
        "6": {"value": "#aed581", "id": "6"},
        "7": {"value": "#ffb74d", "id": "7"},
        "8": {"value": "#ff8a65", "id": "8"},
        "9": {"value": "#7e8b9f", "id": "9"},
        "10": {"value": "#5c6bc0", "id": "10"},
        "11": {"value": "#29b6f6", "id": "11"},
        "12": {"value": "#26a69a", "id": "12"},
        "13": {"value": "#9ccc65", "id": "13"},
        "14": {"value": "#ffa726", "id": "14"},
        "15": {"value": "#ff7043", "id": "15"},
        "16": {"value": "#5c6b7f", "id": "16"},
        "17": {"value": "#8e24aa", "id": "17"},
        "18": {"value": "#3949ab", "id": "18"},
        "19": {"value": "#039be5", "id": "19"},
        "20": {"value": "#00897b", "id": "20"},
        "21": {"value": "#7cb342", "id": "21"},
        "22": {"value": "#fb8c00", "id": "22"},
        "23": {"value": "#f4511e", "id": "23"},
        "24": {"value": "#374150", "id": "24"},
        "25": {"value": "#6a1b9a", "id": "25"},
        "26": {"value": "#283593", "id": "26"},
        "27": {"value": "#0277bd", "id": "27"},
        "28": {"value": "#00695c", "id": "28"},
        "29": {"value": "#558b2f", "id": "29"},
        "30": {"value": "#ef6c00", "id": "30"},
        "31": {"value": "#d84315", "id": "31"}
    };

if(vendor === 'cubro')
{
    ColorsDic =
        {
            "1": {"value": "#949FB1", "id": "1"},
            "2": {"value": "#ec618f", "id": "2"},
            "3": {"value": "#fdbcb4", "id": "3"},
            "4": {"value": "#ce14ff", "id": "4"},
            "5": {"value": "#ffbf00", "id": "5"},
            "6": {"value": "#747370", "id": "6"},
            "7": {"value": "#8fb96a", "id": "7"},
            "8": {"value": "#8b0000", "id": "8"},
            "9": {"value": "#ff90d7", "id": "9"},
            "10": {"value": "#c08081", "id": "10"},
            "11": {"value": "#fe6f5e", "id": "11"},
            "12": {"value": "#ffee60", "id": "12"},
            "13": {"value": "#dc143c", "id": "13"},
            "14": {"value": "#e97451", "id": "14"},
            "15": {"value": "#efdfbb", "id": "15"},
            "16": {"value": "#b284be", "id": "16"},
            "17": {"value": "#3b00db", "id": "17"},
            "18": {"value": "#40e0d0", "id": "18"},
            "19": {"value": "#177245", "id": "19"},
            "20": {"value": "#c8a045", "id": "20"},
            "21": {"value": "#6c3082", "id": "21"},
            "22": {"value": "#ccccff", "id": "22"},
            "23": {"value": "#6cb4ee", "id": "23"},
            "24": {"value": "#c3f0ff", "id": "24"},
            "25": {"value": "#ace1af", "id": "25"},
            "26": {"value": "#808000", "id": "26"},
            "27": {"value": "#d1e231", "id": "27"}
        };
}

var CreateTicketSubjectsDic =
    {
        "1": {"value": LangHelper.GetString("Dics", "Error message"), "id": "1"},
        "2": {"value": LangHelper.GetString("Dics", "Question"), "id": "2"},
        "3": {"value": LangHelper.GetString("Dics", "Sentence"), "id": "3"},
        "4": {"value": LangHelper.GetString("Dics", "Message"), "id": "4"}
    };

var CreateTicketDPISecureDic =
    {
        "1": {"value": "tls", "id": "1"},
        "2": {"value": "ssl", "id": "2"}
    };

var BindTypesDic =
    {
        "-1": {
            "value": LangHelper.GetString("Dics", "Without bind"),
            "tooltip": LangHelper.GetString("Dics", "Without bind"),
            "id": "-1"
        },
        "0": {
            "value": LangHelper.GetString("Dics", "Single"),
            "tooltip": LangHelper.GetString("Dics", "Single: one IP - one login"),
            "id": "0"
        },
        "1": {
            "value": LangHelper.GetString("Dics", "Multi"),
            "tooltip": LangHelper.GetString("Dics", "Multi: multiple IP - one login"),
            "id": "1"
        }
    };

var SectionsDic =
    {
        "hardware": {"value": LangHelper.GetString("Dics", "Hardware Management"), "id": "hardware"},
        "hardware_ssh_keys": {"value": LangHelper.GetString("Dics", "SSH keys management"), "id": "hardware_ssh_keys"},
        "performance": {
            "value": LangHelper.GetString("Dics", "DPI Management / Performance and Statistics"),
            "id": "performance"
        },
        "config": {"value": LangHelper.GetString("Dics", "DPI Management / Configuration"), "id": "config"},
        "logs": {"value": LangHelper.GetString("Dics", "DPI Management / Logs"), "id": "logs"},
        "subscribers": {"value": LangHelper.GetString("Dics", "Service management / Subscribers"), "id": "subscribers"},
        "services": {"value": LangHelper.GetString("Dics", "Service Management / Services"), "id": "services"},
        "tariffs": {"value": LangHelper.GetString("Dics", "Service management / Tariffs"), "id": "tariffs"},
        "advc": {"value": LangHelper.GetString("Dics", "Service management / Advertising controll"), "id": "advc"},

        "pcrf": {"value": LangHelper.GetString("AppView", "PCRF control"), "id": "pcrf"},
        "pcrf_config": {"value": LangHelper.GetString("AppView", "PCRF control") + " / " + LangHelper.GetString("Dics", "Configuration"), "id": "pcrf_config"},
        "pcrf_logs": {"value": LangHelper.GetString("AppView", "PCRF control") + " / " + LangHelper.GetString("Dics", "Logs"), "id": "pcrf_logs"},

        "qoeanalytics": {
            "value": LangHelper.GetString("Dics", "QoE analytics"), "id": "qoeanalytics",
            "params":
                {
                    "subscriber_cidrs":
                        {
                            "view": "text",
                            "label": LangHelper.GetString("Dics", "Subscriber CIDRs"),
                            "tooltip": LangHelper.GetString("Dics", "All QoE statistics will be filtered by this parameter"),
                            "placeholder":"192.168.1.246/32,192.168.2.0/24",
                            "validate": function (Val) {
                                if (Val) {
                                    var ok = true;

                                    Val.split(",").forEach(function (V) {
                                        if (!Helper.ValidateIPaddressOrCidr(V))
                                            ok = false;
                                    });

                                    return ok;
                                } else
                                    return true;
                            },
                            "invalidMessage": LangHelper.GetString("Dics", "Enter the IP address or CIDR")
                        },
                    "subscriber_logins":
                        {
                            "view": "text",
                            "placeholder":"login1,login2",
                            "label": LangHelper.GetString("Dics", "Subscriber logins"),
                            "tooltip": LangHelper.GetString("Dics", "All QoE statistics will be filtered by this parameter")
                        },
                    "bridge_vchannel_nums":
                        {
                            "view": "text",
                            "placeholder":"1,2,3 or ch_name1,ch_name2,ch_name3",
                            "label": LangHelper.GetString("Dics", "Vchannel numbers"),
                            "tooltip": LangHelper.GetString("Dics", "All QoE statistics will be filtered by this parameter")
                                + "<br/><br/><br/>"
                                + LangHelper.GetString("Dics", "Channel numbers are indicated. If channel names are used in statistics, you must specify names, not numbers.")
                        }
                }
        },
        "qoeanalytics_dashboard": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "QoE dashboard"),
            "id": "qoeanalytics_dashboard"
        },
        "qoeanalytics_fullnetflow": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Netflow"),
            "id": "qoeanalytics_fullnetflow"
        },
        "qoeanalytics_rawfullnetflow": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Raw full netflow"),
            "id": "qoeanalytics_rawfullnetflow"
        },
        "qoeanalytics_clickstream": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Clickstream"),
            "id": "qoeanalytics_clickstream"
        },
        "qoeanalytics_rawclickstream": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Raw clickstream"),
            "id": "qoeanalytics_rawclickstream"
        },
        "qoeanalytics_gtp": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Gtp flow"),
            "id": "qoeanalytics_gtp"
        },
        "qoeanalytics_rawgtp": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Raw Gtp flow"),
            "id": "qoeanalytics_rawgtp"
        },

        "qoeanalytics_nat": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "NAT flow"),
            "id": "qoeanalytics_nat"
        },
        "qoeanalytics_rawnat": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Raw NAT flow"),
            "id": "qoeanalytics_rawnat"
        },

        "qoeanalytics_dns": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "DNS flow"),
            "id": "qoeanalytics_dns"
        },
        "qoeanalytics_rawdns": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Raw DNS flow"),
            "id": "qoeanalytics_rawdns"
        },

        "qoeanalytics_ddos_attack": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "DDoS attacks"),
            "id": "qoeanalytics_ddos_attack"
        },
        "qoeanalytics_raw_ddos_attack": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "DDoS attacks log"),
            "id": "qoeanalytics_raw_ddos_attack"
        },

        "qoeanalytics_subscribers": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Subscribers"),
            "id": "qoeanalytics_subscribers"
        },
        "qoeanalytics_online_reports":{
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Online reports"),
            "id": "qoeanalytics_online_reports"
        },
        "qoeanalytics_triggers": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Triggers & Alerts"),
            "id": "qoeanalytics_triggers",
            "params": {
                "see_all_users":
                    {
                        "view": "richselect",
                        "label": LangHelper.GetString("Dics", "Users"),
                        "options": [
                            {id: "all", value: LangHelper.GetString("QoE", "Triggers of all users")},
                            {id: "my", value: LangHelper.GetString("QoE", "Only my triggers")}
                        ],
                        "tooltip": LangHelper.GetString("Dics", "Set to see triggers of all users or not. You can see only triggers of your own by default.")
                    }
            }
        },
        "qoeanalytics_customreports": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Custom reports"),
            "id": "qoeanalytics_customreports"
        },
        "qoeanalytics_reports_manager": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "My reports"),
            "id": "qoeanalytics_reports_manager",
            "params": {
                "see_all_users":
                    {
                        "view": "richselect",
                        "label": LangHelper.GetString("Dics", "Tasks visibility"),
                        "options": [
                            {id: "all", value: LangHelper.GetString("Dics", "Tasks of all users")},
                            {id: "my", value: LangHelper.GetString("Dics", "Only user tasks")}
                        ],
                        "tooltip": LangHelper.GetString("Dics", "Set the user to see only their own tasks or also tasks of other users.") + "<br><br>" +
                            LangHelper.GetString("All", "By default") + ": " + LangHelper.GetString("Dics", "Only user tasks").toLowerCase()
                    },
                "tasks_management":
                    {
                        "view": "richselect",
                        "label": LangHelper.GetString("Dics", "Tasks management"),
                        "options": [
                            {id: "all", value: LangHelper.GetString("Dics", "Tasks of all users")},
                            {id: "my", value: LangHelper.GetString("Dics", "Only user tasks")}
                        ],
                        "value": "my",
                        "tooltip": LangHelper.GetString("Dics", "Set whether the user can manage tasks:") + "<br>" +
                            "-" + LangHelper.GetString("Dics", "enable/disable task") + "<br>" +
                            "-" + LangHelper.GetString("Dics", "edit task") + "<br>" +
                            "-" + LangHelper.GetString("Dics", "copy task") + "<br>" +
                            "-" + LangHelper.GetString("Dics", "delete task") + "<br><br>" +
                            LangHelper.GetString("All", "By default") + ": " + LangHelper.GetString("Dics", "Only user tasks").toLowerCase()
                    },
                "max_task_priority":
                    {
                        "view": "richselect",
                        "label": LangHelper.GetString("Dics", "Maximum task priority"),
                        "options": [1,2,3,4,5,6,7,8,9,10].reduce((acc, num) => {
                            acc.push({id:num, value:num});
                            return acc;
                        }, []),
                        "tooltip": LangHelper.GetString("Dics", "Maximum task priority for user task.") + "<br><br>" +
                            LangHelper.GetString("All", "By default") + ": 1"
                    },
                "out_of_turn":
                    {
                        "view": "label",
                        "label": LangHelper.GetString("Dics", "Run task out of queue"),
                        "tooltip": LangHelper.GetString("Dics", "Set whether the user can run tasks out of turn.")
                    }
            }
        },
        "qoeanalytics_mailing_templates": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Mailing templates"),
            "id": "qoeanalytics_mailing_templates",
            "params": {
                "see_all_users": {
                        "view": "richselect",
                        "label": LangHelper.GetString("MailingTemplates", "Templates visibility"),
                        "options": [
                            {id: "all", value: LangHelper.GetString("MailingTemplates", "Templates of all users")},
                            {id: "my", value: LangHelper.GetString("MailingTemplates", "Only user templates")}
                        ],
                        "tooltip": LangHelper.GetString("MailingTemplates", "Set the user to see only their own templates or also templates of other users.") + "<br><br>" +
                            LangHelper.GetString("All", "By default") + ": " + LangHelper.GetString("MailingTemplates", "Only user templates").toLowerCase()
                },
                "edit_all_users": {
                    "view": "richselect",
                    "label": LangHelper.GetString("MailingTemplates", "Templates editability"),
                    "options": [
                        {id: "all", value: LangHelper.GetString("MailingTemplates", "Templates of all users")},
                        {id: "my", value: LangHelper.GetString("MailingTemplates", "Only user templates")}
                    ],
                    "tooltip": LangHelper.GetString("MailingTemplates", "Set the user to edit only their own templates or also templates of other users.") + "<br><br>" +
                        LangHelper.GetString("All", "By default") + ": " + LangHelper.GetString("MailingTemplates", "Only user templates").toLowerCase()
                },
            }
        },
        "qoeanalytics_admin": {
            "value": LangHelper.GetString("AppView", "QoE analytics") + " / " + LangHelper.GetString("AppView", "Administrator"),
            "id": "qoeanalytics_admin"
        },

        "administrator": {"value": LangHelper.GetString("Dics", "Administrator"), "id": "administrator"},
        "administrator_users": {"value": LangHelper.GetString("Dics", "Users"), "id": "administrator_users"},
        "administrator_roles": {"value": LangHelper.GetString("Dics", "Roles"), "id": "administrator_roles"},
        "administrator_send_error": {
            "value": LangHelper.GetString("Dics", "Send Error"),
            "id": "administrator_send_error"
        },
        "administrator_dpiui2": {
            "value": LangHelper.GetString("Dics", "Administrator DPIUI2"),
            "id": "administrator_dpiui2"
        },
        "administrator_users_actions_log": {"value": LangHelper.GetString("Dics", "Users actions log"), "id": "administrator_users_actions_log"},

        "vascloud": {"value": LangHelper.GetString("Dics", "VAS Cloud services"), "id": "vascloud"},
        "socket": {"value": LangHelper.GetString("Dics", "Websocket notifications"), "id": "socket"},

        "ulr": {"value": LangHelper.GetString("UlrModule", "Universal lock rules"), "id": "ulr"},
        "ulr_web_rules": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Web filter"),
            "id": "ulr_web_rules"
        },
        "ulr_hosts_list": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Host categories"),
            "id": "ulr_hosts_list"
        },
        "ulr_spoof_dns": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Spoof DNS"),
            "id": "ulr_spoof_dns"
        },
        "ulr_white_rules": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Whitelist"),
            "id": "ulr_white_rules"
        },
        "ulr_policings": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Applications & policings"),
            "id": "ulr_policings"
        },
        "ulr_custom_prtcls": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Custom Protocols"),
            "id": "ulr_custom_prtcls"
        },
        "ulr_as_rules": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "ASN filter"),
            "id": "ulr_as_rules"
        },
        "ulr_excludes": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "IP & ASN excludes"),
            "id": "ulr_excludes"
        },
        "ulr_record_pcap": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "PCAP recording"),
            "id": "ulr_record_pcap"
        },
        "ulr_db_search": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Database search"),
            "id": "ulr_db_search"
        },
        "ulr_isp_igw_profiles": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Profile management"),
            "id": "ulr_isp_igw_profiles"
        },
        "ulr_mailing": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Mailing"),
            "id": "ulr_mailing"
        },
        "ulr_dics": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "Dictionaries"),
            "id": "ulr_dics"
        },
        "ulr_system_state": {
            "value": LangHelper.GetString("UlrModule", "Universal lock rules") + " / " + LangHelper.GetString("UlrModule", "System global state"),
            "id": "ulr_system_state"
        },

        "li": {"value": LangHelper.GetString("AppView", "Lawful interception"), "id": "li"},
        "li_connections": {
            "value": LangHelper.GetString("AppView", "Lawful interception") + " / " + LangHelper.GetString("AppView", "Connections"),
            "id": "li_connections"
        },
        "li_t_capture": {
            "value": LangHelper.GetString("AppView", "Lawful interception") + " / " + LangHelper.GetString("AppView", "Traffic capture"),
            "id": "li_t_capture"
        },
        "li_t_generation": {
            "value": LangHelper.GetString("AppView", "Lawful interception") + " / " + LangHelper.GetString("AppView", "Traffic generation"),
            "id": "li_t_generation"
        },
        "li_t_blocking": {
            "value": LangHelper.GetString("AppView", "Lawful interception") + " / " + LangHelper.GetString("AppView", "Blocking and redirection"),
            "id": "li_t_blocking"
        },
        "li_site_clone": {
            "value": LangHelper.GetString("AppView", "Lawful interception") + " / " + LangHelper.GetString("AppView", "Cloning a website"),
            "id": "li_site_clone"
        },
        "li_n_audit": {
            "value": LangHelper.GetString("AppView", "Lawful interception") + " / " + LangHelper.GetString("AppView", "Network audit"),
            "id": "li_n_audit"
        },
        "li_traffic_decode": {
            "value": LangHelper.GetString("AppView", "Lawful interception") + " / " + LangHelper.GetString("AppView", "Traffic decode"),
            "id": "li_traffic_decode"
        },

        "li_health": {
            "value": LangHelper.GetString("AppView", "Lawful interception") + " / " + LangHelper.GetString("AppView", "Health map"),
            "id": "li_health"
        },

        "sites_clsfr": {"value": LangHelper.GetString("Dics", "Sites classifier"), "id": "sites_clsfr"},
        "sites_clsfr_model": {"value": LangHelper.GetString("Dics", "Sites classifier model"), "id": "sites_clsfr_model"},
        "sites_clsfr_admin": {"value": LangHelper.GetString("Dics", "Sites classifier admin"), "id": "sites_clsfr_admin"},

        "sso_auth": {"value": LangHelper.GetString("Dics", "SSO"), "id": "sso_auth"},
        "ssh_terminal": {"value": LangHelper.GetString("Dics", "Hardware ssh terminal"), "id": "ssh_terminal"},

        "antiddos": {"value": LangHelper.GetString("Dics", "AntiDDoS"), "id": "antiddos"},
        "antiddos_network": {"value": LangHelper.GetString("Dics", "Network"), "id": "antiddos_network"},
        "antiddos_threats": {"value": LangHelper.GetString("Dics", "Threats"), "id": "antiddos_threats"},
        "antiddos_protection": {"value": LangHelper.GetString("Dics", "Protection"), "id": "antiddos_protection"},

    };

var UsersActionsLogTypeCodes =
    {
        "Configuration DPI": {"value": LangHelper.GetString("UsersActionsLog", "Configuration DPI"), "id": "Configuration DPI"},
        "Configuration QoE": {"value": LangHelper.GetString("UsersActionsLog", "Configuration QoE"), "id": "Configuration QoE"},
        "Configuration GUI": {"value": LangHelper.GetString("UsersActionsLog", "Configuration GUI"), "id": "Configuration GUI"},
        "Configuration Balancer": {"value": LangHelper.GetString("UsersActionsLog", "Configuration Balancer"), "id": "Configuration Balancer"},
        "Tariff plans": {"value": LangHelper.GetString("UsersActionsLog", "Tariff plans"), "id": "Tariff plans"},
        "Subscribers and services": {"value": LangHelper.GetString("AppView", "Subscribers and services"), "id": "Subscribers and services"},
        "Protocol prioritization": {"value": LangHelper.GetString("UsersActionsLog", "Protocol prioritization"), "id": "Protocol prioritization"},
        "Priority for ASN": {"value": LangHelper.GetString("UsersActionsLog", "Priority for ASN"), "id": "Priority for ASN"},
        "Services": {"value": LangHelper.GetString("Subscribers", "Services"), "id": "Services"},
        "Black and white lists": {"value": LangHelper.GetString("UsersActionsLog", "Black and white lists"), "id": "Black and white lists"},
        "ui_type": {"value": LangHelper.GetString("UsersActionsLog", "Interface"), "id": "ui_type"},
        "qoe_type": {"value": LangHelper.GetString("UsersActionsLog", "QoE"), "id": "qoe_type"}
    };

var UsersActionsLogNameSection =
    {
        "Services": {"value": LangHelper.GetString("Subscribers", "Services"), "id": "Services"},
        "Tariffs": {"value": LangHelper.GetString("UsersActionsLog", "Tariff plans"), "id": "Tariffs"},
        "Subscribers": {"value": LangHelper.GetString("AppView", "Subscribers and services"), "id": "Subscribers"},
    }

var UsersActionsLogActions =
    {
        "created": {"value": LangHelper.GetString("UsersActionsLog", "Create"), "id": "created"},
        "edited": {"value": LangHelper.GetString("UsersActionsLog", "Edit"), "id": "edited"},
        "deleted": {"value": LangHelper.GetString("UsersActionsLog", "Delete"), "id": "deleted"},
        "reloaded": {"value": LangHelper.GetString("UsersActionsLog", "Updating hot options"), "id": "reloaded"},
        "restarted": {"value": LangHelper.GetString("UsersActionsLog", "Restart Queue"), "id": "restarted"},
        "started": {"value": LangHelper.GetString("UsersActionsLog", "Start"), "id": "started"},
        "stopped": {"value": LangHelper.GetString("UsersActionsLog", "Stop"), "id": "stopped"},
        "subscribers auth cleared": {"value": LangHelper.GetString("UsersActionsLog", "Subscribers auth cleared"), "id": "subscribers auth cleared"},
        "subscribers auth changed": {"value": LangHelper.GetString("UsersActionsLog", "Subscribers auth changed"), "id": "subscribers auth changed"},
        "subscribers L2-props edited": {"value": LangHelper.GetString("UsersActionsLog", "Subscribers L2-props edited"), "id": "subscribers L2-props edited"},
        "subscribers L2-props deleted": {"value": LangHelper.GetString("UsersActionsLog", "Subscribers L2-props deleted"), "id": "subscribers L2-props deleted"},
        "search": {"value": LangHelper.GetString("All", "Search"), "id": "search"},
        // "edited policing": {"value": LangHelper.GetString("UsersActionsLog", "Edited policing"), "id": "edited policing"},
        "ui_sections_navigation": {"value": LangHelper.GetString("UsersActionsLog", "Navigation"), "id": "ui_sections_navigation"},
        "ui_login": {"value": LangHelper.GetString("UsersActionsLog", "Login"), "id": "ui_login"},
        "ui_logout": {"value": LangHelper.GetString("UsersActionsLog", "Logout"), "id": "ui_logout"},
        "qoe_get_report": {"value": LangHelper.GetString("UsersActionsLog", "Viewing the report"), "id": "qoe_get_report"},
        "qoe_create_cache_report": {"value": LangHelper.GetString("UsersActionsLog", "Creating report cache"), "id": "qoe_create_cache_report"},
        "qoe_export_report": {"value": LangHelper.GetString("UsersActionsLog", "Export report"), "id": "qoe_export_report"},
        "qoe_receivers_restarted": {"value": LangHelper.GetString("UsersActionsLog", "Receivers restarted"), "id": "qoe_receivers_restarted"},
        "qoe_receivers_stopped": {"value": LangHelper.GetString("UsersActionsLog", "Receivers stopped"), "id": "qoe_receivers_stopped"}

    };

var FileSizeUnits = [
    LangHelper.GetString("All", "Bytes"),
    LangHelper.GetString("All", "Kb"),
    LangHelper.GetString("All", "Mb"),
    LangHelper.GetString("All", "Gb"),
    LangHelper.GetString("All", "Tb"),
    LangHelper.GetString("All", "Pb")
];

var TrafficSpeedUnits = [
    LangHelper.GetString("All", "Bytes/s"),
    LangHelper.GetString("All", "Kb/s"),
    LangHelper.GetString("All", "Mb/s"),
    LangHelper.GetString("All", "Gb/s"),
    LangHelper.GetString("All", "Tb/s"),
    LangHelper.GetString("All", "Pb/s")
];

var TrafficSpeedBitUnits = [
    LangHelper.GetString("All", "Bit/s"),
    LangHelper.GetString("All", "Kbit/s"),
    LangHelper.GetString("All", "Mbit/s"),
    LangHelper.GetString("All", "Gbit/s"),
    LangHelper.GetString("All", "Tbit/s"),
    LangHelper.GetString("All", "Pbit/s")
];

var PacketsUnits = [
    LangHelper.GetString("All", "Pkts"),
    LangHelper.GetString("All", "Kpkts"),
    LangHelper.GetString("All", "Mpkts"),
    LangHelper.GetString("All", "Gpkts"),
    LangHelper.GetString("All", "Tpkts"),
    LangHelper.GetString("All", "Ppkts")
];

var NetFlowSpeedUnits = [
    LangHelper.GetString("All", "Pkts/s"),
    LangHelper.GetString("All", "Kpkts/s"),
    LangHelper.GetString("All", "Mpkts/s"),
    LangHelper.GetString("All", "Gpkts/s"),
    LangHelper.GetString("All", "Tpkts/s"),
    LangHelper.GetString("All", "Ppkts/s")
];

var TimeUnits = {
    "-3": LangHelper.GetString("All", "ns"),
    "-2": LangHelper.GetString("All", "µs"),
    "-1": LangHelper.GetString("All", "ms"),
    "0": LangHelper.GetString("All", "s"),
    "1": LangHelper.GetString("All", "ks"),
    "2": LangHelper.GetString("All", "Ms"),
    "3": LangHelper.GetString("All", "Gs"),
    "4": LangHelper.GetString("All", "Ts")
};

var SimpleTimeUnits = [
    LangHelper.GetString("All", "ms"),
    LangHelper.GetString("All", "s")
]

var RateUnits = {
    "-3": LangHelper.GetString("All", "ns"),
    "-2": LangHelper.GetString("All", "µs"),
    "-1": LangHelper.GetString("All", "ms"),
    "0": LangHelper.GetString("All", "s"),
    "1": LangHelper.GetString("All", "ks"),
    "2": LangHelper.GetString("All", "Ms"),
    "3": LangHelper.GetString("All", "Gs"),
    "4": LangHelper.GetString("All", "Ts")
};

var CountUnits = [
    "",
    LangHelper.GetString("All", "K"),
    LangHelper.GetString("All", "M"),
    LangHelper.GetString("All", "G"),
    LangHelper.GetString("All", "T"),
    LangHelper.GetString("All", "Quad"),
    LangHelper.GetString("All", "Quint"),
    LangHelper.GetString("All", "Sextil")
];

var QoeMonitorWidgetFileSizeUnits = [
    LangHelper.GetString("QoEMonitorWidget", "Bytes"),
    LangHelper.GetString("QoEMonitorWidget", "Kb"),
    LangHelper.GetString("QoEMonitorWidget", "Mb"),
    LangHelper.GetString("QoEMonitorWidget", "Gb"),
    LangHelper.GetString("QoEMonitorWidget", "Tb")
];

var UnitsFormatData = {
    TrafficSpeedBitUnits: {id:"TrafficSpeedBitUnits", units:{[LangHelper.GetLocale()]: TrafficSpeedBitUnits}, divider:1000},
    FileSizeUnits: {id:"FileSizeUnits", units:{[LangHelper.GetLocale()]: FileSizeUnits}, divider:1024},
    NetFlowSpeedUnits: {id:"NetFlowSpeedUnits", units:{[LangHelper.GetLocale()]: NetFlowSpeedUnits}, divider:1000},
    PacketsUnits: {id:"PacketsUnits", units:{[LangHelper.GetLocale()]: PacketsUnits}, divider:1000},
    SimpleTimeUnits: {id:"SimpleTimeUnits", units:{[LangHelper.GetLocale()]: SimpleTimeUnits}, divider:1000},
 }

var DscpDic = {
    "keep": {
        "id": "keep",
        "value": "keep",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    },
    "drop": {
        "id": "drop",
        "value": "drop",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    },
    "cs0": {
        "id": "cs0",
        "value": "cs0",
        "binary": "000 000",
        "decimal": 0,
        "hexadecimal": "0",
        "priority": 0,
        "class": 0,
        "class_order_1": 7
    },
    "cs1": {
        "id": "cs1",
        "value": "cs1",
        "binary": "001 000",
        "decimal": 8,
        "hexadecimal": "8",
        "priority": 1,
        "class": 1,
        "class_order_1": 6
    },
    "cs2": {
        "id": "cs2",
        "value": "cs2",
        "binary": "010 000",
        "decimal": 16,
        "hexadecimal": "10",
        "priority": 2,
        "class": 2,
        "class_order_1": 5
    },
    "cs3": {
        "id": "cs3",
        "value": "cs3",
        "binary": "011 000",
        "decimal": 24,
        "hexadecimal": "18",
        "priority": 3,
        "class": 3,
        "class_order_1": 4
    },
    "cs4": {
        "id": "cs4",
        "value": "cs4",
        "binary": "100 000",
        "decimal": 32,
        "hexadecimal": "20",
        "priority": 4,
        "class": 4,
        "class_order_1": 3
    },
    "cs5": {
        "id": "cs5",
        "value": "cs5",
        "binary": "101 000",
        "decimal": 40,
        "hexadecimal": "28",
        "priority": 5,
        "class": 5,
        "class_order_1": 2
    },
    "cs6": {
        "id": "cs6",
        "value": "cs6",
        "binary": "110 000",
        "decimal": 48,
        "hexadecimal": "30",
        "priority": 6,
        "class": 6,
        "class_order_1": 1
    },
    "cs7": {
        "id": "cs7",
        "value": "cs7",
        "binary": "111 000",
        "decimal": 56,
        "hexadecimal": "38",
        "priority": 7,
        "class": 7,
        "class_order_1": 0
    },
    "af11": {
        "id": "af11",
        "value": "af11",
        "binary": "001 010",
        "decimal": 10,
        "hexadecimal": "a",
        "priority": 1,
        "class": 1,
        "class_order_1": 6
    },
    "af12": {
        "id": "af12",
        "value": "af12",
        "binary": "001 100",
        "decimal": 12,
        "hexadecimal": "c",
        "priority": 1,
        "class": 1,
        "class_order_1": 6
    },
    "af13": {
        "id": "af13",
        "value": "af13",
        "binary": "001 110",
        "decimal": 14,
        "hexadecimal": "e",
        "priority": 1,
        "class": 1,
        "class_order_1": 6
    },
    "af21": {
        "id": "af21",
        "value": "af21",
        "binary": "010 010",
        "decimal": 18,
        "hexadecimal": "12",
        "priority": 2,
        "class": 2,
        "class_order_1": 5
    },
    "af22": {
        "id": "af22",
        "value": "af22",
        "binary": "010 100",
        "decimal": 20,
        "hexadecimal": "14",
        "priority": 2,
        "class": 2,
        "class_order_1": 5
    },
    "af23": {
        "id": "af23",
        "value": "af23",
        "binary": "010 110",
        "decimal": 22,
        "hexadecimal": "16",
        "priority": 2,
        "class": 2,
        "class_order_1": 5
    },
    "af31": {
        "id": "af31",
        "value": "af31",
        "binary": "011 010",
        "decimal": 26,
        "hexadecimal": "1a",
        "priority": 3,
        "class": 3,
        "class_order_1": 4
    },
    "af32": {
        "id": "af32",
        "value": "af32",
        "binary": "011 100",
        "decimal": 28,
        "hexadecimal": "1c",
        "priority": 3,
        "class": 3,
        "class_order_1": 4
    },
    "af33": {
        "id": "af33",
        "value": "af33",
        "binary": "011 110",
        "decimal": 30,
        "hexadecimal": "1e",
        "priority": 3,
        "class": 3,
        "class_order_1": 4
    },
    "af41": {
        "id": "af41",
        "value": "af41",
        "binary": "100 010",
        "decimal": 34,
        "hexadecimal": "22",
        "priority": 4,
        "class": 4,
        "class_order_1": 3
    },
    "af42": {
        "id": "af42",
        "value": "af42",
        "binary": "100 100",
        "decimal": 36,
        "hexadecimal": "24",
        "priority": 4,
        "class": 4,
        "class_order_1": 3
    },
    "af43": {
        "id": "af43",
        "value": "af43",
        "binary": "100 110",
        "decimal": 38,
        "hexadecimal": "26",
        "priority": 4,
        "class": 4,
        "class_order_1": 3
    },
    "ef": {
        "id": "ef",
        "value": "ef",
        "binary": "101 110",
        "decimal": 46,
        "hexadecimal": "2e",
        "priority": 5,
        "class": 5,
        "class_order_1": 2
    }
};

var AsnDscpDic = {
    "drop": {
        "id": "drop",
        "value": "drop",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    },
    "pass": {
        "id": "pass",
        "value": "pass",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    },
    "local": {
        "id": "local",
        "value": "local",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    },
    "peer": {
        "id": "peer",
        "value": "peer",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    },
    "term": {
        "id": "term",
        "value": "term",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    },
    "cs0": {
        "id": "cs0",
        "value": "cs0",
        "binary": "000 000",
        "decimal": 0,
        "hexadecimal": "0",
        "priority": 0,
        "class": 0,
        "class_order_1": 7
    },
    "cs1": {
        "id": "cs1",
        "value": "cs1",
        "binary": "001 000",
        "decimal": 8,
        "hexadecimal": "8",
        "priority": 1,
        "class": 1,
        "class_order_1": 6
    },
    "cs2": {
        "id": "cs2",
        "value": "cs2",
        "binary": "010 000",
        "decimal": 16,
        "hexadecimal": "10",
        "priority": 2,
        "class": 2,
        "class_order_1": 5
    },
    "cs3": {
        "id": "cs3",
        "value": "cs3",
        "binary": "011 000",
        "decimal": 24,
        "hexadecimal": "18",
        "priority": 3,
        "class": 3,
        "class_order_1": 4
    },
    "cs4": {
        "id": "cs4",
        "value": "cs4",
        "binary": "100 000",
        "decimal": 32,
        "hexadecimal": "20",
        "priority": 4,
        "class": 4,
        "class_order_1": 3
    },
    "cs5": {
        "id": "cs5",
        "value": "cs5",
        "binary": "101 000",
        "decimal": 40,
        "hexadecimal": "28",
        "priority": 5,
        "class": 5,
        "class_order_1": 2
    },
    "cs6": {
        "id": "cs6",
        "value": "cs6",
        "binary": "110 000",
        "decimal": 48,
        "hexadecimal": "30",
        "priority": 6,
        "class": 6,
        "class_order_1": 1
    },
    "cs7": {
        "id": "cs7",
        "value": "cs7",
        "binary": "111 000",
        "decimal": 56,
        "hexadecimal": "38",
        "priority": 7,
        "class": 7,
        "class_order_1": 0
    },
    "af11": {
        "id": "af11",
        "value": "af11",
        "binary": "001 010",
        "decimal": 10,
        "hexadecimal": "a",
        "priority": 1,
        "class": 1,
        "class_order_1": 6
    },
    "af12": {
        "id": "af12",
        "value": "af12",
        "binary": "001 100",
        "decimal": 12,
        "hexadecimal": "c",
        "priority": 1,
        "class": 1,
        "class_order_1": 6
    },
    "af13": {
        "id": "af13",
        "value": "af13",
        "binary": "001 110",
        "decimal": 14,
        "hexadecimal": "e",
        "priority": 1,
        "class": 1,
        "class_order_1": 6
    },
    "af21": {
        "id": "af21",
        "value": "af21",
        "binary": "010 010",
        "decimal": 18,
        "hexadecimal": "12",
        "priority": 2,
        "class": 2,
        "class_order_1": 5
    },
    "af22": {
        "id": "af22",
        "value": "af22",
        "binary": "010 100",
        "decimal": 20,
        "hexadecimal": "14",
        "priority": 2,
        "class": 2,
        "class_order_1": 5
    },
    "af23": {
        "id": "af23",
        "value": "af23",
        "binary": "010 110",
        "decimal": 22,
        "hexadecimal": "16",
        "priority": 2,
        "class": 2,
        "class_order_1": 5
    },
    "af31": {
        "id": "af31",
        "value": "af31",
        "binary": "011 010",
        "decimal": 26,
        "hexadecimal": "1a",
        "priority": 3,
        "class": 3,
        "class_order_1": 4
    },
    "af32": {
        "id": "af32",
        "value": "af32",
        "binary": "011 100",
        "decimal": 28,
        "hexadecimal": "1c",
        "priority": 3,
        "class": 3,
        "class_order_1": 4
    },
    "af33": {
        "id": "af33",
        "value": "af33",
        "binary": "011 110",
        "decimal": 30,
        "hexadecimal": "1e",
        "priority": 3,
        "class": 3,
        "class_order_1": 4
    },
    "af41": {
        "id": "af41",
        "value": "af41",
        "binary": "100 010",
        "decimal": 34,
        "hexadecimal": "22",
        "priority": 4,
        "class": 4,
        "class_order_1": 3
    },
    "af42": {
        "id": "af42",
        "value": "af42",
        "binary": "100 100",
        "decimal": 36,
        "hexadecimal": "24",
        "priority": 4,
        "class": 4,
        "class_order_1": 3
    },
    "af43": {
        "id": "af43",
        "value": "af43",
        "binary": "100 110",
        "decimal": 38,
        "hexadecimal": "26",
        "priority": 4,
        "class": 4,
        "class_order_1": 3
    },
    "ef": {
        "id": "ef",
        "value": "ef",
        "binary": "101 110",
        "decimal": 46,
        "hexadecimal": "2e",
        "priority": 5,
        "class": 5,
        "class_order_1": 2
    },
    "mark1": {
        "id": "mark1",
        "value": "mark1",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    },
    "mark2": {
        "id": "mark2",
        "value": "mark2",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    },
    "mark3": {
        "id": "mark3",
        "value": "mark3",
        "binary": "-",
        "decimal": "-",
        "hexadecimal": "-",
        "priority": "-",
        "class": "-",
        "class_order_1": "-"
    }
};

var OnOffDic =
    {
        "0": {"value": LangHelper.GetString("All", "Off"), "id": "0"},
        "1": {"value": LangHelper.GetString("All", "On"), "id": "1"}
    };

var YesNoDic =
    {
        "0": {"value": LangHelper.GetString("All", "No"), "id": "0"},
        "1": {"value": LangHelper.GetString("All", "Yes"), "id": "1"}
    };

var PornYesNoDic =
    {
        "0": {"value": LangHelper.GetString("Dics", "Non Porn"), "id": "0"},
        "1": {"value": LangHelper.GetString("Dics", "Porn"), "id": "1"},
        "2": {"value": LangHelper.GetString("Dics", "Not verified"), "id": "null"}
    };

var FilterOperatorsDic =
    {
        "=": {"value": LangHelper.GetString("QoEPopupFilterWidget", "Equals"), "id": "="},
        "!=": {"value": LangHelper.GetString("QoEPopupFilterWidget", "Not equals"), "id": "!="},
        "like": {"value": LangHelper.GetString("QoEPopupFilterWidget", "Like"), "id": "like"},
        ">": {"value": LangHelper.GetString("QoEPopupFilterWidget", "Greater"), "id": ">"},
        ">=": {"value": LangHelper.GetString("QoEPopupFilterWidget", "Greater or equals"), "id": ">="},
        "<": {"value": LangHelper.GetString("QoEPopupFilterWidget", "Less"), "id": "<"},
        "<=": {"value": LangHelper.GetString("QoEPopupFilterWidget", "Less or equals"), "id": "<="},
        "in": {"value": LangHelper.GetString("QoEPopupFilterWidget", "In"), "id": "in"},
        "not in": {"value": LangHelper.GetString("QoEPopupFilterWidget", "Not in"), "id": "not in"},
        "between": {"value": LangHelper.GetString("QoEPopupFilterWidget", "Between"), "id": "between"}
    };

var QoeFilterWidgetHotKeysDic = {
    "Ctrl+Shift+f": {bind:false, help:LangHelper.GetString("QoEPopupFilterWidget", "Show/Hide filter settings window")},
    "Enter": {bind:true, help:LangHelper.GetString("QoEPopupFilterWidget", "Apply filter")},
    "Esc": {bind:true, help:LangHelper.GetString("QoEPopupFilterWidget", "Cancel filter")},
    "Ctrl+Enter": {bind:false, help:LangHelper.GetString("QoEPopupFilterWidget", "Edit next property")},
    "Shift+Enter": {bind:true, help:LangHelper.GetString("QoEPopupFilterWidget", "Enable/Disable filter setting")},
    "delete": {bind:true, help:LangHelper.GetString("QoEPopupFilterWidget", "Delete selected")},
    "Ctrl+f": {bind:true, help:LangHelper.GetString("QoEPopupFilterWidget", "Add new saved filter")},
    "Ctrl+s": {bind:true, help:LangHelper.GetString("QoEPopupFilterWidget", "Save filter")},
    "Ctrl+r": {bind:true, help:LangHelper.GetString("QoEPopupFilterWidget", "Refresh tables")},
    "Ctrl+h": {bind:true, help:LangHelper.GetString("QoEPopupFilterWidget", "Show help")}
}

var TrafficDirectionDic =
    {
        "0": {"value": LangHelper.GetString("QoE", "To subscriber"), "id": "0"},
        "1": {"value": LangHelper.GetString("QoE", "From subscriber"), "id": "1"}
    };

var DnsTransportDic = {
    "0": {"value": LangHelper.GetString("QoE", "UDP"), "id": "0"},
    "1": {"value": LangHelper.GetString("QoE", "TCP"), "id": "1"}
};

var DnsRtypeDic = {
    "1": {"value": LangHelper.GetString("QoE", "1 - A"), "id":"1"},
    "2": {"value": LangHelper.GetString("QoE", "2 - NS"), "id":"2"},
    "5": {"value": LangHelper.GetString("QoE", "5 - CNAME"), "id":"5"},
    "6": {"value": LangHelper.GetString("QoE", "6 - SOA"), "id":"6"},
    "12": {"value": LangHelper.GetString("QoE", "12 - PTR"), "id":"12"},
    "13": {"value": LangHelper.GetString("QoE", "13 - HINFO"), "id":"13"},
    "15": {"value": LangHelper.GetString("QoE", "15 - MX"), "id":"15"},
    "16": {"value": LangHelper.GetString("QoE", "16 - TXT"), "id":"16"},
    "17": {"value": LangHelper.GetString("QoE", "17 - RP"), "id":"17"},
    "18": {"value": LangHelper.GetString("QoE", "18 - AFSDB"), "id": "18"},
    "24": {"value": LangHelper.GetString("QoE", "24 - SIG"), "id": "24"},
    "25": {"value": LangHelper.GetString("QoE", "25 - KEY"), "id": "25"},
    "28": {"value": LangHelper.GetString("QoE", "28 - AAAA"), "id": "28"},
    "29": {"value": LangHelper.GetString("QoE", "29 - LOC"), "id": "29"},
    "33": {"value": LangHelper.GetString("QoE", "33 - SRV"), "id": "33"},
    "35": {"value": LangHelper.GetString("QoE", "35 - NAPTR"), "id": "35"},
    "36": {"value": LangHelper.GetString("QoE", "36 - KX"), "id": "36"},
    "37	": {"value": LangHelper.GetString("QoE", "37 - CERT"), "id": "37"},
    "39": {"value": LangHelper.GetString("QoE", "39 - DNAME"), "id": "39"},
    "42": {"value": LangHelper.GetString("QoE", "42 - APL"), "id": "42"},
    "43": {"value": LangHelper.GetString("QoE", "43 - DS"), "id": "43"},
    "44": {"value": LangHelper.GetString("QoE", "44 - SSHFP"), "id": "44"},
    "45": {"value": LangHelper.GetString("QoE", "45 - IPSECKEY"), "id": "45"},
    "46": {"value": LangHelper.GetString("QoE", "46 - RRSIG"), "id": "46"},
    "47": {"value": LangHelper.GetString("QoE", "47 - NSEC"), "id": "47"},
    "48": {"value": LangHelper.GetString("QoE", "48 - DNSKEY"), "id": "48"},
    "49": {"value": LangHelper.GetString("QoE", "49 - DHCID"), "id": "49"},
    "50": {"value": LangHelper.GetString("QoE", "50 - NSEC3"), "id": "50"},
    "51": {"value": LangHelper.GetString("QoE", "51 - NSEC3PARAM"), "id": "51"},
    "52": {"value": LangHelper.GetString("QoE", "52 - TLSA"), "id": "52"},
    "53": {"value": LangHelper.GetString("QoE", "53 - SMIMEA"), "id": "53"},
    "55": {"value": LangHelper.GetString("QoE", "55 - HIP"), "id": "55"},
    "59	": {"value": LangHelper.GetString("QoE", "59 - CDS"), "id": "59"},
    "60": {"value": LangHelper.GetString("QoE", "60 - CDNSKEY"), "id": "60"},
    "61": {"value": LangHelper.GetString("QoE", "61 - OPENPGPKEY"), "id": "61"},
    "62": {"value": LangHelper.GetString("QoE", "62 - CSYNC"), "id": "62"},
    "63": {"value": LangHelper.GetString("QoE", "63 - ZONEMD"), "id": "63"},
    "64": {"value": LangHelper.GetString("QoE", "64 - SVCB"), "id": "64"},
    "65": {"value": LangHelper.GetString("QoE", "65 - HTTPS"), "id": "65"},
    "108": {"value": LangHelper.GetString("QoE", "108 - EUI48"), "id": "108"},
    "109": {"value": LangHelper.GetString("QoE", "109 - EUI64"), "id": "109"},
    "249": {"value": LangHelper.GetString("QoE", "249 - TKEY"), "id": "249"},
    "250": {"value": LangHelper.GetString("QoE", "250 - TSIG"), "id": "250"},
    "256": {"value": LangHelper.GetString("QoE", "256 - URI"), "id": "256"},
    "257": {"value": LangHelper.GetString("QoE", "257 - CAA"), "id": "257"},
    "32768": {"value": LangHelper.GetString("QoE", "32768 - TA"), "id": "32768"},
    "32769": {"value": LangHelper.GetString("QoE", "32769 - DLV"), "id": "32769"},
};

var BlTypesDic =
    {
        "0": {"value": LangHelper.GetString("BlackListService", "Black"), "id": "0"},
        "1": {"value": LangHelper.GetString("BlackListService", "White"), "id": "1"}
    };

var InfoDebugDic =
    {
        "INFO": {"value": LangHelper.GetString("Classifier", "INFO"), "id": "INFO"},
        "DEBUG": {"value": LangHelper.GetString("Classifier", "DEBUG"), "id": "DEBUG"}
    };

var CgNatTypesDic =
    {
        "0": {"value": LangHelper.GetString("CgNatService", "Default"), "id": "0"},
        "1": {"value": LangHelper.GetString("CgNatService", "1:1"), "id": "1"}
    };

var CgNatStatusProtoDic =
    {
        "TCP": {"value": LangHelper.GetString("CgNatService", "TCP"), "id": "TCP"},
        "UDP": {"value": LangHelper.GetString("CgNatService", "UDP"), "id": "UDP"}
    };

var CgNatStatusNTHRDic =
    {
        "0": {"value": LangHelper.GetString("CgNatService", "0"), "id": "0"},
        "1": {"value": LangHelper.GetString("CgNatService", "1"), "id": "1"}
    };

var CgNatStatusIpMaskDic =
    {
        "0x0": {"value": LangHelper.GetString("CgNatService", "0x0"), "id": "0x0"},
        "0x1": {"value": LangHelper.GetString("CgNatService", "0x1"), "id": "0x1"}
    };

var BlListItemTypeDic =
    {
        "url": {"value": LangHelper.GetString("BlackListService", "URL"), "id": "url"},
        "ip": {"value": LangHelper.GetString("BlackListService", "IP PORT"), "id": "ip"},
        "sni": {"value": LangHelper.GetString("BlackListService", "SNI"), "id": "sni"},
        "cn": {"value": LangHelper.GetString("BlackListService", "CN"), "id": "cn"},
        "clsfr": {"value": LangHelper.GetString("BlackListService", "Sites category"), "id": "clsfr"},
        "vase": {"value": LangHelper.GetString("BlackListService", "VASE Lists"), "id": "vase"},
    };

var BlStatusesDic =
    {
        "0": {"value": LangHelper.GetString("BlackListService", "Disabled"), "id": "0"},
        "1": {"value": LangHelper.GetString("BlackListService", "Enabled"), "id": "1"}
    };

var PolicingStatusesDic = {
    "0": {"value": LangHelper.GetString("Tariffs", "Tarrif.Active"), "id": "0"},
    "4": {"value": LangHelper.GetString("Tariffs", "Tarrif.Config error"), "id": "4"}
};

var BlTargetsStateDic = {
    "0": {"value": LangHelper.GetString("Dics", "Subscriber.Inactive"), "id": "0"},
    "1": {"value": LangHelper.GetString("Dics", "Subscriber.Active"), "id": "1"},
    "2": {"value": LangHelper.GetString("Dics", "Subscriber.Error"), "id": "2"}
};

var PolicingsConfigTypesDic = {
    "HTB": {"value": LangHelper.GetString("Dics", "HTB"), "id": "HTB"},
    "TBF": {"value": LangHelper.GetString("Dics", "TBF"), "id": "TBF"}
};

var HardwareConfigPolicingsConfigTypesDic = {
    "0": {"value": "", id: "0"},
    "HTB": {"value": LangHelper.GetString("Dics", "HTB"), "id": "HTB"},
    "TBF": {"value": LangHelper.GetString("Dics", "TBF"), "id": "TBF"}
};

var FullflowBlockedTrafficDataTypesDic = {
    "0x0": {"id": "0x0", "value": LangHelper.GetString("QoE", "Not locked")},
    "0x1": {"id": "0x1", "value": LangHelper.GetString("QoE", "By DROP")},
    "0x2": {"id": "0x2", "value": LangHelper.GetString("QoE", "By policing")}
};

var FullflowServiceFlagsTrafficDataTypesDic = {
    "0x0": {"id": "0x0", "value": LangHelper.GetString("QoE", "No flags")},
    "0x1": {"id": "0x1", "value": LangHelper.GetString("QoE", "Tethering")}
};

var PagingSizeOptions = [
    {id: 10, value: "10"},
    {id: 50, value: "50"},
    {id: 100, value: "100"},
    {id: 200, value: "200"},
    {id: 500, value: "500"},
    {id: 1000, value: "1 000"},
    {id: 10000, value: "10 000"}
];

var QoeTriggersConditionsCombinatorsDic =
    {
        "isNotNaN": {value: "if is not NaN"},
        "isNotNull": {value: "if is not Null"},
        "isNaN": {value: "if is NaN"},
        "isNull": {value: "if is Null"}
    };

var QoETriggerStateCodeDic =
    {
        "ready": {"value": LangHelper.GetString("QoE", "Ready"), "id": "ready"},
        "caching": {"value": LangHelper.GetString("QoE", "Caching"), "id": "caching"},
        "checking": {"value": LangHelper.GetString("QoE", "Checking"), "id": "checking"},
        "firing": {"value": LangHelper.GetString("QoE", "Firing"), "id": "firing"},
        "no_data": {"value": LangHelper.GetString("QoE", "No data"), "id": "no_data"},
        "invalid": {"value": LangHelper.GetString("QoE", "Invalid"), "id": "invalid"},
        "cache_error": {"value": LangHelper.GetString("QoE", "Cache error"), "id": "cache_error"},
        "scheduled_ready": {"value": LangHelper.GetString("QoE", "Waiting"), "id": "scheduled_ready"},
        "done": {"value": LangHelper.GetString("QoE", "Done"), "id": "done"}
    };

var QoETriggerTypesDic = {
    "user": {"value": LangHelper.GetString("QoE", "Custom"), "id": "user"},
    "system": {"value": LangHelper.GetString("QoE", "System"), "id": "system"},
    "scheduled": {id: "scheduled", value: LangHelper.GetString("QoE", "Scheduled")},
    "report": {id: "report", value: LangHelper.GetString("QoE", "Report")}
};

var QoETriggerAlertTypeDic =
    {
        "alerting": {"value": LangHelper.GetString("QoE", "Alerting"), "id": "alerting"},
        "no data": {"value": LangHelper.GetString("QoE", "No data"), "id": "no data"},
        "keep last state": {"value": LangHelper.GetString("QoE", "Keep last state"), "id": "keep last state"},
        "ok": {"value": LangHelper.GetString("QoE", "Ok"), "id": "ok"}
    };

var QoESecondsChunckPeriodDic =
    {
        "0": {"value": LangHelper.GetString("QoE", "0 minutes"), "id": "0"},
        "60": {"value": LangHelper.GetString("QoE", "1 minute"), "id": "60"},
        "300": {"value": LangHelper.GetString("QoE", "5 minutes"), "id": "300"},
        "600": {"value": LangHelper.GetString("QoE", "10 minutes"), "id": "600"},
        "1800": {"value": LangHelper.GetString("QoE", "30 minutes"), "id": "1800"},
        "3600": {"value": LangHelper.GetString("QoE", "1 hour"), "id": "1800"},
        "14400": {"value": LangHelper.GetString("QoE", "4 hours"), "id": "14400"},
        "43200": {"value": LangHelper.GetString("QoE", "12 hours"), "id": "43200"},
        "86400": {"value": LangHelper.GetString("QoE", "24 hours"), "id": "86400"}
    };

var WifiLocalizationLabelsDic = {
    "ru": [
        {
            key: "info_label",
            value: "Для активации доступа в интернет укажите номер своего мобильного телефона. После этого введите проверочный код, который Вы получите в SMS-сообщении либо позвоните по указанному номеру."
        },
        {
            key: "phone_label",
            value: "Номер телефона"
        },
        {
            key: "get_code_button",
            value: "Получить код"
        },
        {
            key: "call_button",
            value: "Позвонить"
        },
        {
            key: "call_text",
            value: "Для авторизации позвоните по этому номеру"
        },
        {
            key: "sms_code_input label",
            value: "Код из смс"
        },
        {
            key: "auth_code_button",
            value: "Авторизоваться"
        },
        {
            key: "success_text",
            value: "Какой то длинный или короткий текст при успешной авторизации"
        }
    ],
    "en": [
        {
            key: "info_label",
            value: "To activate Internet access, specify your mobile phone number. After that, enter the verification code that you will receive in the SMS-message or call the specified number."
        },
        {
            key: "phone_label",
            value: "Phone number"
        },
        {
            key: "get_code_button",
            value: "Get code"
        },
        {
            key: "call_button",
            value: "Make call"
        },
        {
            key: "call_text",
            value: "Call this number for authorization"
        },
        {
            key: "sms_code_input label",
            value: "Code from sms"
        },
        {
            key: "auth_code_button",
            value: "Authorize"
        },
        {
            key: "success_text",
            value: "Some success authorization text of any length"
        }
    ]
};

var QoETriggerAlertActionTypeDic =
    {
        "email": {"value": LangHelper.GetString("QoE", "E-mail"), "id": "email"},
        "http": {"value": LangHelper.GetString("QoE", "HTTP"), "id": "http"}
    };

var QoETriggerAlertActionStateCodeDic =
    {
        "ready": {"value": LangHelper.GetString("QoE", "Ready"), "id": "ready"},
        "in progress": {"value": LangHelper.GetString("QoE", "In progress"), "id": "in progress"},
        "complete": {"value": LangHelper.GetString("QoE", "Complete"), "id": "complete"},
        "error": {"value": LangHelper.GetString("QoE", "Error"), "id": "error"},
        "max attempts": {"value": LangHelper.GetString("QoE", "Max attempts"), "id": "max attempts"},
        "cancel": {"value": LangHelper.GetString("QoE", "Cancel"), "id": "cancel"}
    };

var QoETriggerAlertActionBodyTemplateParametersDic =
    {
        "{trigger.id}": {"value": LangHelper.GetString("QoE", "Trigger id"), "id": "{trigger.id}"},
        "{trigger.name}": {"value": LangHelper.GetString("QoE", "Trigger name"), "id": "{trigger.name}"},
        "{trigger.severity}": {"value": LangHelper.GetString("QoE", "Severity"), "id": "{trigger.severity}"},
        "{trigger.status}": {"value": LangHelper.GetString("QoE", "Status"), "id": "{trigger.status}"},
        "{trigger.queries}": {"value": LangHelper.GetString("QoE", "Queries"), "id": "{trigger.queries}"},
        //"{trigger.conditions}":{"value": LangHelper.GetString("QoE","Conditions"), "id": "{trigger.conditions}"},
        "{trigger.notification.id}": {
            "value": LangHelper.GetString("QoE", "Notification id"),
            "id": "{trigger.notification.id}"
        },
        "{trigger.notification.notes}": {
            "value": LangHelper.GetString("QoE", "Notification notes"),
            "id": "{trigger.notification.notes}"
        },
        "{trigger.report.link}": {"value": LangHelper.GetString("QoE", "Report link"), "id": "{trigger.report.link}"},
        "{trigger.report.csv}": {"value": LangHelper.GetString("QoE", "Link to CSV file"), "id": "{trigger.report.csv}"},
        "{trigger.report.csv.as_file}": {
            "value": LangHelper.GetString("QoE", "Attach CSV file") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.csv.as_file}"
        },
        "{trigger.report.csv.as_file.zip}": {
            "value": LangHelper.GetString("QoE", "Attach archive with CSV file") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.csv.as_file.zip}"
        },
        "{trigger.report.tsv}": {"value": LangHelper.GetString("QoE", "Link to TabSeparated file"), "id": "{trigger.report.tsv}"},
        "{trigger.report.tsv.as_file}": {
            "value": LangHelper.GetString("QoE", "Attach TabSeparated file") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.tsv.as_file}"
        },
        "{trigger.report.tsv.as_file.zip}": {
            "value": LangHelper.GetString("QoE", "Attach archive with TabSeparated file") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.tsv.as_file.zip}"
        },
        "{trigger.report.xlsx}": {"value": LangHelper.GetString("QoE", "Link to Excel file"), "id": "{trigger.report.xlsx}"},
        "{trigger.report.xlsx.as_file}": {
            "value": LangHelper.GetString("QoE", "Attach Excel file") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.xlsx.as_file}"
        },
        "{trigger.report.xlsx.as_file.zip}": {
            "value": LangHelper.GetString("QoE", "Attach archive with Excel file") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.xlsx.as_file.zip}"
        },
        "{trigger.report.merged_xlsx}": {
            "value": LangHelper.GetString("QoE", "Link to Excel file with all reports"),
            "id": "{trigger.report.merged_xlsx}"
        },
        "{trigger.report.merged_xlsx.as_file}": {
            "value": LangHelper.GetString("QoE", "Attach Excel file with all reports") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.merged_xlsx.as_file}"
        },
        "{trigger.report.merged_xlsx.as_file.zip}": {
            "value": LangHelper.GetString("QoE", "Attach archive with Excel file with all reports") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.merged_xlsx.as_file.zip}"
        },
        "{trigger.report.pdf}": {
            "value": LangHelper.GetString("QoE", "Link to PDF file"),
            "id": "{trigger.report.pdf}"
        },
        "{trigger.report.pdf.as_file}": {
            "value": LangHelper.GetString("QoE", "Attach PDF file") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.pdf.as_file}"
        },
        "{trigger.report.pdf.as_file.zip}": {
            "value": LangHelper.GetString("QoE", "Attach archive with PDF file") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.pdf.as_file.zip}"
        },
        "{trigger.report.merged_pdf}": {"value": LangHelper.GetString("QoE", "Link to PDF file with all reports"), "id": "{trigger.report.merged_pdf}"},
        "{trigger.report.merged_pdf.as_file}": {
            "value": LangHelper.GetString("QoE", "Attach PDF file with all reports") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.merged_pdf.as_file}"
        },
        "{trigger.report.merged_pdf.as_file.zip}": {
            "value": LangHelper.GetString("QoE", "Attach archive with PDF file with all reports") + " (" + LangHelper.GetString("QoE", "Email only") + ")",
            "id": "{trigger.report.merged_pdf.as_file.zip}"
        },
    };

var FlagsDic = {
    "en": {id: "en", icon: "en", code: "en", value: LangHelper.GetString("Dics", "English"), name: "English"},
    "ru": {id: "ru", icon: "ru", code: "ru", value: LangHelper.GetString("Dics", "Russian"), name: "Русский"},
    "tr": {id: "tr", icon: "tr", code: "tr", value: LangHelper.GetString("Dics", "Turkish"), name: "Türk"},
    "cn": {id: "cn", icon: "cn", code: "cn", value: LangHelper.GetString("Dics", "China"), name: "中国"},
    "per": {id: "per", icon: "per", code: "per", value: LangHelper.GetString("Dics", "Persian"), name: "زبان فارسی"},
    "hin": {id: "hin", icon: "hin", code: "hin", value: LangHelper.GetString("Dics", "Hindi"), name: "हिन्दी"},
    "gre": {id: "gre", icon: "gre", code: "gre", value: LangHelper.GetString("Dics", "Greek"), name: "Ελληνική γλώσσα"},
    "urd": {id: "urd", icon: "urd", code: "urd", value: LangHelper.GetString("Dics", "Urdu"), name: "اردو۔"},
    "ar": {id: "ar", icon: "ar", code: "ar", value: LangHelper.GetString("Dics", "Arab"), name: "العربية"},
    "tat": {id: "tat", icon: "tat", code: "tat", value: LangHelper.GetString("Dics", "Tatar"), name: "Татар теле"}
};

if(vendor === 'cubro')
{
    var FlagsDic = {
        "en": {id: "en", icon: "en", code: "en", value: LangHelper.GetString("Dics", "English"), name: "English"}
    };
}

var QoeThreatsWidgetDic = {
    "kaspersky_malicious_hosts": {id: "kaspersky_malicious_hosts", value: LangHelper.GetString("QoE", "Malicious traffic"), sub_value: LangHelper.GetString("QoE", "Subscribers with malicious traffic")},
    "kaspersky_botnet_hosts": {id: "kaspersky_botnet_hosts", value: LangHelper.GetString("QoE", "Botnet traffic"), sub_value: LangHelper.GetString("QoE", "Subscribers with botnet traffic")},
    "kaspersky_phishing_hosts": {id: "kaspersky_phishing_hosts", value: LangHelper.GetString("QoE", "Phishing traffic"), sub_value: LangHelper.GetString("QoE", "Subscribers with phishing traffic")},
}

var SocketNotificationsTypeDic = {
    "info": {"value": LangHelper.GetString("SocketNotifications", "Information"), "id": "info"},
    "warning": {"value": LangHelper.GetString("SocketNotifications", "Warning"), "id": "warning"},
    "error": {"value": LangHelper.GetString("SocketNotifications", "Error"), "id": "error"},
    "success": {"value": LangHelper.GetString("SocketNotifications", "Success"), "id": "success"},
    "other": {"value": LangHelper.GetString("SocketNotifications", "Other"), "id": "other"}
};

var SocketNotificationsEventsDic = {
    "news": {"value": LangHelper.GetString("SocketNotifications", "News"), "id": "news"},
    "subscribers": {
        "value": LangHelper.GetString("SocketNotifications", "Subscribers and vchannels synchronization"),
        "id": "subscribers"
    },
    "messages": {"value": LangHelper.GetString("SocketNotifications", "Messages"), "id": "messages"},
    "connection": {"value": LangHelper.GetString("SocketNotifications", "Ssh connection"), "id": "connection"},
    "triggers": {"value": LangHelper.GetString("SocketNotifications", "Triggers"), "id": "triggers"},
    "qoe": {"value": LangHelper.GetString("SocketNotifications", "QoE"), "id": "qoe"},
    "qoe_report": {"value": LangHelper.GetString("SocketNotifications", "QoE report"), "id": "qoe_report"}
};

var SocketNotificationsStatusDic = {
    "read": {"value": LangHelper.GetString("SocketNotifications", "Read"), "id": "read"},
    "new": {"value": LangHelper.GetString("SocketNotifications", "New"), "id": "new"}
};

var SmtpSecureOptions = {
    "tls": {"id": "tls", "value": LangHelper.GetString("Dics", "tls")},
    "ssl": {"id": "ssl", "value": LangHelper.GetString("Dics", "ssl")}
}

var HardwareTypesDic = {
    "dpi": {id: "dpi", value: LangHelper.GetString("Dics", "FastDPI server")},
    "pcrf": {id: "pcrf", value: LangHelper.GetString("Dics", "FastPCRF server")},
    "dpiui2": {id: "dpiui2", value: LangHelper.GetString("Dics", "DPIUI2 server (GUI)")},
    "wifi_web": {id: "wifi_web", value: LangHelper.GetString("Dics", "HOTSPOT server")},
    "qoestor": {id: "qoestor", value: LangHelper.GetString("Dics", "QoE Stor server")},
    "balancer": {id: "balancer", value: LangHelper.GetString("Dics", "Balancer server")},
    "tragen": {id: "tragen", value: LangHelper.GetString("Dics", "Traffic generator server")},
    "wget": {id: "wget", value: LangHelper.GetString("Dics", "Sites cloning server")},
    "nmap": {id: "nmap", value: LangHelper.GetString("Dics", "Network audit server")},
    "clsfr": {id: "clsfr", value: LangHelper.GetString("Dics", "Hosts classifier server")},
    "pcap_decode": {id: "pcap_decode", value: LangHelper.GetString("Dics", "Pcap decode server")},
    "pcap": {id: "pcap", value: LangHelper.GetString("Dics", "FastPCAP server")},
    "captcha_server": {id: "captcha_server", value: LangHelper.GetString("Dics", "Captcha server")},
    "bgp": {id: "bgp", value: LangHelper.GetString("Dics", "BGP server")},
    "bl_revisor": {id: "bl_revisor", value: LangHelper.GetString("Dics", "BL Revisor server")}
};

var SyslogFacilityOptions = {
    "16": {"id": "16", "value": "local 0 (id: 16) - " + LangHelper.GetString("Dics", "Default value")},
    "17": {"id": "17", "value": "local 1 (id: 17)"},
    "18": {"id": "18", "value": "local 2 (id: 18)"},
    "19": {"id": "19", "value": "local 3 (id: 19)"},
    "20": {"id": "20", "value": "local 4 (id: 20)"},
    "21": {"id": "21", "value": "local 5 (id: 21)"},
    "22": {"id": "22", "value": "local 6 (id: 22)"},
    "23": {"id": "23", "value": "local 7 (id: 23)"}
};


var Dpiui2EnvConfigGroupDic =
    {
        "1": {"id": "1", "order": 7, "value": LangHelper.GetString("Dics", "System")},
        "2": {"id": "2", "order": 8, "value": LangHelper.GetString("Dics", "DB (MySql) connection")},
        "3": {"id": "3", "order": 6, "value": LangHelper.GetString("Dics", "SMTP settings")},
        "4": {"id": "4", "order": 3, "value": LangHelper.GetString("Dics", "QoE Stor: DB (Clickhouse) connection")},
        "5": {"id": "5", "order": 2, "value": LangHelper.GetString("Dics", "Jobs intervals and periods")},
        "6": {"id": "6", "order": 1, "value": LangHelper.GetString("Dics", "Common")},
        "7": {"id": "7", "order": 4, "value": LangHelper.GetString("Dics", "QoE Stor: DB lifetime settings")},
        "8": {
            "id": "8",
            "order": 9,
            "value": LangHelper.GetString("Dics", "Ulr settings") + ": " + LangHelper.GetString("Dics", "System settings"),
            lic: "ulr",
            lic_level: "standard"
        },
        "9": {"id": "9", "order": 11, "value": LangHelper.GetString("Dics", "Push notifications settings")},
        "10": {
            "id": "10",
            "order": 12,
            "value": LangHelper.GetString("Dics", "Lawful interception"),
            lic: "li",
            lic_level: "standard"
        },
        "11": {"id": "11", "order": 5, "value": LangHelper.GetString("Dics", "QoE Stor: Discs settings")},
        "12": {"id": "12", "order": 13, "value": LangHelper.GetString("Dics", "SSO authorization settings")},
        "13": {"id": "13", "order": 14, "value": LangHelper.GetString("Dics", "Maps settings")},
        "14": {"id": "14", "order": 15, "value": LangHelper.GetString("Dics", "VasCloud settings")},
        "15": {"id": "15", "order": 16, "value": LangHelper.GetString("Dics", "Cluster settings")},
        "16": {"id": "16", "order": 17, "value": LangHelper.GetString("Dics", "Backup settings")},
        "17": {"id": "17", "order": 18, "value": LangHelper.GetString("Dics", "Backup auto restoration settings")},
        "18": {"id": "18", "order": 19, "value": LangHelper.GetString("Dics", "Telegram settings")},
        "19": {"id": "19", "order": 20, "value": LangHelper.GetString("Dics", "Trigger settings")},
        "20": {id: "20", order: 3, value: LangHelper.GetString("Dics", "QoE Stor: Raw log aggregation settings")},
        "21": {
            id: "21",
            order: 10,
            value: LangHelper.GetString("Dics", "Ulr settings") + ": " + LangHelper.GetString("Dics", "Web rules lists"),
            lic: "ulr",
            lic_level: "standard"
        },
        "22": {id: "22", "order": 21, "value": LangHelper.GetString("Dics", "Export settings")}
    };

var CaptchaEnvConfigGroupDic =
    {
        "1": {"id": "1", "order": 1, "value": LangHelper.GetString("Dics", "Config")},
    };



var CaptchaEnvConfigDic = function () {
    var dic = {};

    var clAddToDic = function (Group, Arr) {
        Arr.forEach(function (Item, Index) {
            var key = Group + "." + (Index + 1);
            dic[key] = Item;
            dic[key].group = Group + "";
        });
    };

    clAddToDic(1, [
        {
            "id": "APP_DOMAIN", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA domain for cookie"),
            "view": "text",
            "tooltip": LangHelper.GetString("AppView", "CAPTCHA domain for cookie")
        },
        {
            "id": "APP_TITLE", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA app title"),
            "view": "text",
            "tooltip": LangHelper.GetString("AppView", "CAPTCHA app title")
        },
        {
            "id": "APP_LANG", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA app language"),
            "view": "richselect",
            "options": function()
                {
                    var list  = {
                        "1": {"id": "en", "value": LangHelper.GetString("AppView", "English")},
                        "2": {"id": "ru", "value": LangHelper.GetString("AppView", "Russian")},
                        "3": {"id": "es", "value": LangHelper.GetString("AppView", "Spanish")}
                    }

                    if (vendor === 'cubro')
                        list =  { "1": {"id": "en", "value": LangHelper.GetString("AppView", "English")} }

                    return list;

                }(),
            "tooltip": LangHelper.GetString("AppView", "The current language of CAPTCHA app")
        },
        {
            "id": "APP_TEMPLATE", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA app template"),
            "view": "richselect",
            "options":
                {

                },
            "tooltip": LangHelper.GetString("AppView", "The current template of CAPTCHA app")
        },
        {
            "id": "APP_STORE_CAPTCHA", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA store"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "input", "value": LangHelper.GetString("AppView", "input")},
                    "2": {"id": "session", "value": LangHelper.GetString("AppView", "session")},
                    "3": {"id": "cookie", "value": LangHelper.GetString("AppView", "cookie")}
                },
            "tooltip": LangHelper.GetString("AppView", "The current store of CAPTCHA")
        },
        {
            "id": "CAPTCHA_LANG", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA language"),
            "view": "richselect",
            "options": function()
            {
                var list  = {
                    "1": {"id": "en", "value": LangHelper.GetString("AppView", "English")},
                    "2": {"id": "ru", "value": LangHelper.GetString("AppView", "Russian")},
                    "3": {"id": "es", "value": LangHelper.GetString("AppView", "Spanish")}
                }

                if (vendor === 'cubro')
                    list =  { "1": {"id": "en", "value": LangHelper.GetString("AppView", "English")} }

                return list;

            }(),
            "tooltip": LangHelper.GetString("AppView", "The current language of CAPTCHA image")
        },
        {
            "id": "DPI_KEY", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA encryption key"),
            "view": "text",
            "tooltip": LangHelper.GetString("AppView", "Encryption key for CAPTCHA")
        },
        {
            "id": "TOKEN_SALT", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA token salt"),
            "view": "text",
            "tooltip": LangHelper.GetString("AppView", "Token salt for CAPTCHA")
        },
        {
            "id": "CAPTCHA_FORMAT", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA image format"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "png", "value": LangHelper.GetString("AppView", "PNG")},
                    "2": {"id": "jpeg", "value": LangHelper.GetString("AppView", "JPEG")},
                },
            "tooltip": LangHelper.GetString("AppView", "The current format of CAPTCHA image")
        },
        {
            "id": "CAPTCHA_LENGTH", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA length"),
            "view": "text",
            "tooltip": LangHelper.GetString("AppView", "The current length of CAPTCHA image")
        },
        {
            "id": "CAPTCHA_SCALE", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA scale"),
            "view": "text",
            "tooltip": LangHelper.GetString("AppView", "The current scale of CAPTCHA image")
        },
        {
            "id": "CAPTCHA_RANDOM", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA random"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "1", "value": LangHelper.GetString("AppView", "Yes")},
                    "2": {"id": "0", "value": LangHelper.GetString("AppView", "No")},
                },
            "tooltip": LangHelper.GetString("AppView", "This option sets random chars of CAPTCHA image")
        },
        {
            "id": "CAPTCHA_FONT", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA font"),
            "view": "richselect",
            "options":
                {

                },
            "tooltip": LangHelper.GetString("AppView", "This option sets CAPTCHA font")
        },
        {
            "id": "REDIRECT_SERVICE", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA redirect service"),
            "view": "text",
            "tooltip": LangHelper.GetString("AppView", "The redirect service of CAPTCHA app")
        },
        {
            "id": "REDIRECT_SERVICE_URL", "group": "1", "value": LangHelper.GetString("AppView", "CAPTCHA redirect service url"),
            "view": "text",
            "tooltip": LangHelper.GetString("AppView", "The redirect service url of CAPTCHA app")
        }
    ])

    return dic;
}()

var Dpiui2EnvConfigDic = function () {
    var dic = {};

    var clAddToDic = function (Group, Arr) {
        Arr.forEach(function (Item, Index) {
            var key = Group + "." + (Index + 1);
            dic[key] = Item;
            dic[key].group = Group + "";
        });
    };

    //Group 1
    clAddToDic(1, [
        {
            "id": "APP_ENV", "group": "1", "value": LangHelper.GetString("Dics", "Environment") + " (APP_ENV)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "local", "value": LangHelper.GetString("Dics", "Local")},
                    "2": {"id": "production", "value": LangHelper.GetString("Dics", "Production")},
                    "3": {"id": "development", "value": LangHelper.GetString("Dics", "Development")}
                },
            "tooltip": LangHelper.GetString("Dics", "The current application environment.") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "APP_DEBUG",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Application debug") + " (APP_DEBUG)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "When an exception is uncaught and the APP_DEBUG environment variable is true, the debug page will show all environment variables and their contents. In some cases you may want to obscure certain variables.") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "APP_KEY", "group": "1", "value": LangHelper.GetString("Dics", "Encryption key") + " (APP_KEY)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Session and cookie encryption key. If this is empty, the key is generated automatically.") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "FASTRESOURCE_API_TOKEN",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Dpiui2 api token for import fastresources") + " (FASTRESOURCE_API_TOKEN)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Dpiui2 api token for import fastresources")
        },
        {
            "id": "APP_TIMEZONE",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Application timezone") + " (APP_TIMEZONE)",
            "view": "text",
            "default": "UTC",
            "placeholder": "UTC",
            "tooltip": LangHelper.GetString("Dics", "UTC by default.") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "CACHE_DRIVER",
            "group": "1",
            "value": LangHelper.GetString("Dics", "App cache driver") + " (CACHE_DRIVER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "App cache driver") + ".<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior."),
            "default": "file"
        },
        {
            "id": "QUEUE_DRIVER",
            "group": "1",
            "value": LangHelper.GetString("Dics", "App queue driver") + " (QUEUE_DRIVER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "App queue driver") + ".<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior."),
            "default": "database"
        },
        {
            "id": "SESSION_DRIVER",
            "group": "1",
            "value": LangHelper.GetString("Dics", "App session driver") + " (SESSION_DRIVER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "App session driver") + ".<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior."),
            "default": "cookie"
        },
        {
            "id": "QUEUE_DEFAULT_NUM_PROCESSES",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of precesses for the default queue") + " (QUEUE_DEFAULT_NUM_PROCESSES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of precesses for the default queue"),
            "default": 16,
            "placeholder": "16",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUEUE_QOE_DEFAULT_NUM_PROCESSES",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of precesses for the default QoE queue") + " (QUEUE_QOE_DEFAULT_NUM_PROCESSES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of precesses for the default QoE queue"),
            "default": 8,
            "placeholder": "8",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUEUE_QOE_BACKGROUNDS_NUM_PROCESSES",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of precesses for the backgrounds QoE queue") + " (QUEUE_QOE_BACKGROUNDS_NUM_PROCESSES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of precesses for the backgrounds QoE queue"),
            "default": 8,
            "placeholder": "8",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUEUE_QOE_DEFAULT_NUM_PROCESS_FREE",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of free precesses for the default QoE queue") + " (QUEUE_QOE_DEFAULT_NUM_PROCESS_FREE)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of free precesses for the default QoE queue")
                + '<br/>' +
                LangHelper.GetString("Dics", "Default value is") + "(QUEUE_QOE_DEFAULT_NUM_PROCESSES / 2) "
                + LangHelper.GetString("Dics", "if") + " QUEUE_QOE_DEFAULT_NUM_PROCESSES>1 , <br/>"
                + LangHelper.GetString("Dics", "else")+ " 0."
            ,
            "default": 0,
            "placeholder": "0",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUEUE_QOE_LONG_NUM_PROCESSES",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of precesses for the long QoE queue") + " (QUEUE_QOE_LONG_NUM_PROCESSES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of precesses for the long QoE queue"),
            "default": 8,
            "placeholder": "1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUEUE_CUSTOM_PRTCLS_NUM_PROCESSES",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of precesses for the custom protocols QoE queue") + " (QUEUE_CUSTOM_PRTCLS_NUM_PROCESSES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of precesses for the custom protocols QoE queue"),
            "default": 8,
            "placeholder": "8",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUEUE_LI_DEFAULT_NUM_PROCESSES",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of precesses for the default LI queue") + " (QUEUE_LI_DEFAULT_NUM_PROCESSES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of precesses for the default LI queue"),
            "default": 1,
            "placeholder": "1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUEUE_LI_LONG_NUM_PROCESSES",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of precesses for the long LI queue") + " (QUEUE_LI_LONG_NUM_PROCESSES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of precesses for the long LI queue"),
            "default": 1,
            "placeholder": "1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },

        {
            "id": "QUEUE_ULR_DEFAULT_NUM_PROCESSES",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of precesses for the default ULR queue") + " (QUEUE_ULR_DEFAULT_NUM_PROCESSES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of precesses for the default ULR queue"),
            // "default": 1,
            "placeholder": "8",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUEUE_ULR_LONG_NUM_PROCESSES",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of precesses for the long ULR queue") + " (QUEUE_ULR_LONG_NUM_PROCESSES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of precesses for the long ULR queue"),
            // "default": 1,
            "placeholder": "8",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUEUE_ULR_DEFAULT_NUM_PROCESS_FREE",
            "group": "1",
            "value": LangHelper.GetString("Dics", "Number of free precesses for the default ULR queue") + " (QUEUE_ULR_DEFAULT_NUM_PROCESS_FREE)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Number of free precesses for the default ULR queue"),
            // "default": 1,
            "placeholder": "4",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        }
    ]);

    //Group 2
    clAddToDic(2, [
        {
            "id": "DB_CONNECTION",
            "group": "2",
            "value": LangHelper.GetString("Dics", "DB connection type") + " (DB_CONNECTION)",
            "view": "richselect",
            "options":
                {
                    "mysql": {"id": "mysql", "value": LangHelper.GetString("Dics", "MySql")}
                },
            "tooltip": LangHelper.GetString("Dics", "DB connection type") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "DB_HOST", "group": "2", "value": LangHelper.GetString("Dics", "DB host") + " (DB_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB host") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "DB_PORT", "group": "2", "value": LangHelper.GetString("Dics", "DB port") + " (DB_PORT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB port") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior."),
            "default": 3306,
            "placeholder": "3306",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "DB_DATABASE", "group": "2", "value": LangHelper.GetString("Dics", "DB name") + " (DB_DATABASE)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB name") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "DB_USERNAME", "group": "2", "value": LangHelper.GetString("Dics", "DB username") + " (DB_USERNAME)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB username") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "DB_PASSWORD", "group": "2", "value": LangHelper.GetString("Dics", "DB password") + " (DB_PASSWORD)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB password") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        }
    ]);

    //Group 3
    clAddToDic(3, [
        {
            "id": "CFG_SMTP_HOST",
            "group": "3",
            "value": LangHelper.GetString("Dics", "SMTP host") + " (CFG_SMTP_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "SMTP host") + ". " + LangHelper.GetString("Dics", "To send email messages.")
        },
        {
            "id": "CFG_SMTP_PORT",
            "group": "3",
            "value": LangHelper.GetString("Dics", "SMTP port") + " (CFG_SMTP_PORT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "SMTP port") + ". " + LangHelper.GetString("Dics", "To send email messages."),
            "default": 587,
            "placeholder": "587",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "CFG_SMTP_SECURE",
            "group": "3",
            "value": LangHelper.GetString("Dics", "SMTP encryption type") + " (CFG_SMTP_SECURE)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "SMTP  encryption type") + ". " + LangHelper.GetString("Dics", "To send email messages."),
            "default": "tls",
            "options":
                {
                    "tls": {"id": "tls", "value": LangHelper.GetString("Dics", "tls")},
                    "ssl": {"id": "ssl", "value": LangHelper.GetString("Dics", "ssl")}
                }
        },
        {
            "id": "CFG_SMTP_UNAME",
            "group": "3",
            "value": LangHelper.GetString("Dics", "SMTP username") + " (CFG_SMTP_UNAME)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "SMTP username") + ". " + LangHelper.GetString("Dics", "To send email messages.")
        },
        {
            "id": "CFG_SMTP_PW",
            "group": "3",
            "value": LangHelper.GetString("Dics", "SMTP password") + " (CFG_SMTP_PW)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "SMTP password") + ". " + LangHelper.GetString("Dics", "To send email messages.")
        },
        {
            "id": "CFG_SMTP_FROM",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Sender") + " (CFG_SMTP_FROM)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Sender") + ". " + LangHelper.GetString("Dics", "If empty, value of CFG_SMTP_UNAME is used by default")
        },
        {
            "id": "CFG_SEND_ERROR_EMAIL",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Tech. support email") + " (CFG_SEND_ERROR_EMAIL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Tech. support email") + ".",
            "default": "sd@vas.expert",
            "placeholder": "sd@vas.expert"
        },
        {
            "id": "CFG_SEND_COPY_EMAIL",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Send copy to") + " (CFG_SEND_COPY_EMAIL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Send copy to") + "."
        }
    ]);

    //Group 4
    clAddToDic(4, [
        {
            "id": "QOESTOR_DB_HOST",
            "group": "4",
            "value": LangHelper.GetString("Dics", "QoE Stor host") + " (QOESTOR_DB_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor host") + ". " + LangHelper.GetString("Dics", "To connect to the QoE Stor (Clickhouse) database."),
            "default": "localhost",
            "placeholder": "localhost"
        },
        {
            "id": "QOESTOR_DB_PORT",
            "group": "4",
            "value": LangHelper.GetString("Dics", "QoE Stor port") + " (QOESTOR_DB_PORT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor port") + ". " + LangHelper.GetString("Dics", "To connect to the QoE Stor (Clickhouse) database."),
            "default": 8123,
            "placeholder": "8123",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOESTOR_DB_USER",
            "group": "4",
            "value": LangHelper.GetString("Dics", "QoE Stor username") + " (QOESTOR_DB_USER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor username") + ". " + LangHelper.GetString("Dics", "To connect to the QoE Stor (Clickhouse) database."),
            "default": "default",
            "placeholder": "default"
        },
        {
            "id": "QOESTOR_DB_PASS",
            "group": "4",
            "value": LangHelper.GetString("Dics", "QoE Stor password") + " (QOESTOR_DB_PASS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor password") + ". " + LangHelper.GetString("Dics", "To connect to the QoE Stor (Clickhouse) database.")
        },
        {
            "id": "QOESTOR_DB_NAME",
            "group": "4",
            "value": LangHelper.GetString("Dics", "QoE Stor database name") + " (QOESTOR_DB_NAME)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor database name") + ". " + LangHelper.GetString("Dics", "To connect to the QoE Stor (Clickhouse) database."),
            "default": "qoestor",
            "placeholder": "qoestor"
        },
        {
            "id": "QOESTOR_DB_CLUSTER_MODE",
            "group": "4",
            "value": LangHelper.GetString("Dics", "QoE Stor cluster mode") + " (QOESTOR_DB_CLUSTER_MODE)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor cluster mode") + ". " + LangHelper.GetString("Dics", "If enabled, all queries are executed on the server cluster."),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Cluster mode disabled (Default)")},
                {id: "1", value: LangHelper.GetString("Dics", "Cluster mode enabled")}
            ]
        },
        {
            "id": "QOESTOR_ENABLE_SQL_CONFIG_OPTIMIZER",
            "group": "4",
            "value": LangHelper.GetString("Dics", "QoE Stor sql optimizer for cluster mode") + " (QOESTOR_ENABLE_SQL_CONFIG_OPTIMIZER)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor sql optimizer for cluster mode") + ". " + LangHelper.GetString("Dics", "If enabled, all sql queries to distributed tables (cluster) will be optimized for best performance."),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled (Default)")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        }
    ]);

    //Group 5
    clAddToDic(5, [
        {
            "id": "SM_DISABLE_AUTOSYNC",
            "group": "5",
            "value": LangHelper.GetString("Dics", "Subscribers synchronization") + " (SM_DISABLE_AUTOSYNC)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Disable subscribers synchronization (enabled by default). Synchronization of subscribers, services, tariffs."),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Synchronization enabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Synchronization disabled")}
            ]
        },
        {
            "id": "SM_SUBSCRIBERS_UPDATE_PERIOD_MINUTES",
            "group": "5",
            "value": LangHelper.GetString("Dics", "Subscribers synchronization period in minutes") + " (SM_SUBSCRIBERS_UPDATE_PERIOD_MINUTES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Subscribers synchronization period in minutes. Synchronization period of subscribers, services, tariffs."),
            "default": 30,
            "placeholder": "30",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "CG_NAT_DISABLE_AUTOSYNC",
            "group": "5",
            "value": LangHelper.GetString("Dics", "CGNAT synchronization") + " (CG_NAT_DISABLE_AUTOSYNC)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Disable CGNAT synchronization (enabled by default)."),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Synchronization enabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Synchronization disabled")}
            ]
        },
        {
            "id": "CG_NAT_SYNC_MINUTES_INTERVAL",
            "group": "5",
            "value": LangHelper.GetString("Dics", "CGNAT data synchronization period in minutes") + " (CG_NAT_SYNC_MINUTES_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "CGNAT data synchronization period in minutes"),
            "default": 5,
            "placeholder": "5",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "STAT_ALERT_LOGS_DISABLE_AUTOSYNC",
            "group": "5",
            "value": LangHelper.GetString("Dics", "Stat & Alert logs synchronization") + " (STAT_ALERT_LOGS_DISABLE_AUTOSYNC)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Disable Stat & Alert logs synchronization (enabled by default)."),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Synchronization enabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Synchronization disabled")}
            ]
        },
        {
            "id": "CHART_DATA_DELETE_DAYS_INTERVAL",
            "group": "5",
            "value": LangHelper.GetString("Dics", "Period of data clearing DPI stat. logs in days") + " (CHART_DATA_DELETE_DAYS_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Period of data clearing DPI stat. logs in days"),
            "default": 30,
            "placeholder": "30",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            id: "INTERFACE_LOGS_WRITE_TO",
            group: "5",
            value: LangHelper.GetString("Dics", "Place to store interface logs") + " (INTERFACE_LOGS_WRITE_TO)",
            view: "multiselectBitMask",
            params:{
                maskFormat:"hex"
            },
            options:
                {
                    "0x2": {id: "0x2", value: "0x2 - " + LangHelper.GetString("Dics", "Interface log file")},
                    "0x4": {id: "0x4", value: "0x4 - " + LangHelper.GetString("Dics", "Syslog")}
                },
            tooltip: LangHelper.GetString("Dics", "Place to store interface logs") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x2" + "." + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "Interface log file") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Syslog"),
            tooltipWidth:480,
            tooltipHeight:480
        },
        {
            id: "SYSLOG_FACILITY_INTERFACE_LOGS",
            group: "5",
            value: LangHelper.GetString("Dics", "Syslog facility of interfaces logs") + " (SYSLOG_FACILITY_INTERFACE_LOGS)",
            "view": "richselect",
            "options": SyslogFacilityOptions,
            "tooltip":  LangHelper.GetString("Dics", "Syslog facility of interfaces logs")
        },
        {
            "id": "INTERFACE_CLEAR_OLD_LOGS_PERIOD",
            "group": "5",
            "value": LangHelper.GetString("Dics", "Interface logs storage period in days") + " (INTERFACE_CLEAR_OLD_LOGS_PERIOD)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Interface logs storage period in days"),
            "default": 5,
            "placeholder": "5",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "LUMEN_CLEAR_OLD_LOGS_PERIOD",
            "group": "5",
            "value": LangHelper.GetString("Dics", "Lumen logs storage period in days") + " (LUMEN_CLEAR_OLD_LOGS_PERIOD)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Lumen logs storage period in days"),
            "default": 30,
            "placeholder": "30",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            id: "USER_ACTION_LOGS_WRITE_TO",
            group: "8",
            value: LangHelper.GetString("Dics", "Place to store user actions logs") + " (USER_ACTION_LOGS_WRITE_TO)",
            view: "multiselectBitMask",
            params:{
                maskFormat:"hex"
            },
            options:
                {
                    "0x1": {id: "0x1", value: "0x1 - " + LangHelper.GetString("Dics", "DB")},
                    "0x2": {id: "0x2", value: "0x2 - " + LangHelper.GetString("Dics", "Interface log file")},
                    "0x4": {id: "0x4", value: "0x4 - " + LangHelper.GetString("Dics", "Syslog")}
                },
            tooltip: LangHelper.GetString("Dics", "Place to store user actions logs") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x1" + "." + "<br/><br/>" +
                "0x1 - " + LangHelper.GetString("Dics", "DB") + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "Interface log file") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Syslog"),
            tooltipWidth:480,
            tooltipHeight:480
        },
        {
            id: "SYSLOG_FACILITY_USER_ACTION_LOGS",
            group: "5",
            value: LangHelper.GetString("Dics", "Syslog facility of user actions logs") + " (SYSLOG_FACILITY_USER_ACTION_LOGS)",
            "view": "richselect",
            "options": SyslogFacilityOptions,
            "tooltip":  LangHelper.GetString("Dics", "Syslog facility of user actions logs")
        },
        {
            id: "USER_ACTION_UI_TYPE_ACTIONS",
            group: "5",
            value: LangHelper.GetString("UsersActionsLog", "Enable user ui actions logging") + " (USER_ACTION_UI_TYPE_ACTIONS)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("UsersActionsLog", "Enable user ui actions logging") + "<br>" + "- " + LangHelper.GetString("UsersActionsLog", "user login") +
                "<br>" + "- " + LangHelper.GetString("UsersActionsLog", "user logout") + "<br>" + "- " + LangHelper.GetString("UsersActionsLog", "user visit to QoE analytics sections") +
                "<br>" + "- " + LangHelper.GetString("UsersActionsLog", "receiving QoE report") + "<br>" + "- " + LangHelper.GetString("UsersActionsLog", "export QoE report") +
                "<br><br>" + LangHelper.GetString("Dics", "Default value") + ": " + LangHelper.GetString("Dics", "Enabled"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "CLEAR_OLD_USERS_ACTIONS_LOG_PERIOD",
            "group": "5",
            "value": LangHelper.GetString("Dics", "Users actions storage period in days") + " (CLEAR_OLD_USERS_ACTIONS_LOG_PERIOD)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Users actions storage period in days"),
            "default": 30,
            "placeholder": "30",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOE_REPORTS_SETTINGS_HISTORY_DELETE_DAYS_INTERVAL",
            "group": "5",
            "value": LangHelper.GetString("QoE", "QoE reports settings history storage period in days") + " (QOE_REPORTS_SETTINGS_HISTORY_DELETE_TASKS_DAYS_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("QoE", "QoE reports settings history storage period in days") + ".",
            "default": 30,
            "placeholder": "30",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
    ]);

    //Group 6
    clAddToDic(6, [
        {
            "id": "APP_URL", "group": "6", "value": LangHelper.GetString("Dics", "Application URL") + " (APP_URL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Link to the application. It is used, in particular, with QoE templates for reports sent by mail.")
        },
        {
            "id": "ENABLE_AUTOUPDATE",
            "group": "6",
            "value": LangHelper.GetString("Dics", "Dpiui2(GUI) autoupdate") + " (ENABLE_AUTOUPDATE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables Dpiui2(GUI) autoupdate") + "."
        }
    ]);

    //Group 7
    clAddToDic(7, [
        {
            "id": "QOESTOR_CACHE_LIFE_TIME_SEC",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor cache lifetime in seconds") + " (QOESTOR_CACHE_LIFE_TIME_SEC)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE reports cache life time in seconds") + ".",
            "default": 3600,
            "placeholder": "3600",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOESTOR_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor main log lifetime in hours") + " (QOESTOR_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE main (raw) log lifetime in hours") + ".",
            "default": 2,
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOESTOR_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor aggregated log lifetime in days") + " (QOESTOR_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE aggregated log lifetime in days") + ".",
            "default": 14,
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },

        {
            "id": "QOESTOR_FULLFLOW_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor fullflow main log lifetime in hours") + " (QOESTOR_FULLFLOW_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor fullflow main log lifetime in hours") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 2" + ".",
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_FULLFLOW_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor fullflow aggregated log lifetime in days") + " (QOESTOR_FULLFLOW_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor fullflow aggregated log lifetime in days") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 14" + ".",
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },

        {
            "id": "QOESTOR_CLICKSTREAM_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor clickstream main log lifetime in hours") + " (QOESTOR_CLICKSTREAM_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor clickstream main log lifetime in hours") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 2" + ".",
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_CLICKSTREAM_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor clickstream aggregated log lifetime in days") + " (QOESTOR_CLICKSTREAM_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor clickstream aggregated log lifetime in days") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 14" + ".",
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },

        {
            "id": "QOESTOR_NAT_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor NAT main log lifetime in hours") + " (QOESTOR_NAT_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor NAT main log lifetime in hours") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 2" + ".",
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_NAT_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor NAT aggregated log lifetime in days") + " (QOESTOR_NAT_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor NAT aggregated log lifetime in days") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 14" + ".",
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },

        {
            "id": "QOESTOR_GTP_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor GTP main log lifetime in hours") + " (QOESTOR_GTP_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor GTP main log lifetime in hours") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 2" + ".",
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_GTP_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor GTP aggregated log lifetime in days") + " (QOESTOR_GTP_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor GTP aggregated log lifetime in days") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 14" + ".",
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },

        {
            "id": "QOESTOR_DNS_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor DNS main log lifetime in hours") + " (QOESTOR_DNS_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor DNS main log lifetime in hours") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 2" + ".",
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_DNS_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor DNS aggregated log lifetime in days") + " (QOESTOR_DNS_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor DNS aggregated log lifetime in days") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 14" + ".",
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },

        {
            "id": "QOESTOR_AAA_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor AAA main log lifetime in hours") + " (QOESTOR_AAA_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor AAA main log lifetime in hours") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 2" + ".",
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_AAA_UDR_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor AAA UDR log lifetime in hours") + " (QOESTOR_AAA_UDR_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor AAA UDR log lifetime in hours") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 2" + ".",
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },

        {
            "id": "QOESTOR_CUSTOM_AGG_LOGS_PARTITIONS_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor custom aggregated logs lifetime in days") + " (QOESTOR_CUSTOM_AGG_LOGS_PARTITIONS_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor custom aggregated logs lifetime in days") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 14" + ".",
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_ONLINE_AGG_LOGS_PARTITIONS_LIFE_TIME_MINUTES",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor online aggregated logs lifetime in minutes") + " (QOESTOR_ONLINE_AGG_LOGS_PARTITIONS_LIFE_TIME_MINUTES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor online aggregated logs lifetime in minutes") + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 100" + ".",
            "placeholder": "100",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "GTP_LOAD_RATE_FROM_FULLFLOW_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "GTP LOAD RATE from fullflow logs lifetime in days") + " (GTP_LOAD_RATE_FROM_FULLFLOW_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "GTP LOAD RATE from fullflow logs lifetime in days") + ". <br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": "  + LangHelper.GetString("Dics", "30 days") + ".",
            "placeholder": LangHelper.GetString("Dics", "30 days"),
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "UPLINK_LOAD_RATE_FROM_FULLFLOW_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "UPLINK LOAD RATE from fullflow logs lifetime in days") + " (UPLINK_LOAD_RATE_FROM_FULLFLOW_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UPLINK LOAD RATE from fullflow logs lifetime in days") + ". <br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": "  + LangHelper.GetString("Dics", "30 days") + ".",
            "placeholder": LangHelper.GetString("Dics", "30 days"),
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_FM_ATTACKS_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "DDoS attack logs lifetime in hours") + " (QOESTOR_FM_ATTACKS_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DDoS attack logs lifetime in hours") + ". <br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": "  + LangHelper.GetString("Dics", "Default value") + ": 2" + ".",
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_FM_ATTACKS_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "DDoS attack aggregated logs lifetime in days") + " (QOESTOR_FM_ATTACKS_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DDoS attack aggregated logs lifetime in days") + ". <br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": "  + LangHelper.GetString("Dics", "Default value") + ": 14" + ".",
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_FM_METRICS_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR",
            "group": "7",
            "value": LangHelper.GetString("Dics", "DDoS attack metrics logs lifetime in hours") + " (QOESTOR_FM_METRICS_MAIN_LOG_PARTITIONS_LIFE_TIME_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DDoS attack metrics logs lifetime in hours") + ". <br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": "  + LangHelper.GetString("Dics", "Default value") + ": 14" + ".",
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QOESTOR_FM_METRICS_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS",
            "group": "7",
            "value": LangHelper.GetString("Dics", "DDoS attack metrics aggregated logs lifetime in days") + " (QOESTOR_FM_METRICS_AGG_LOG_PARTITIONS_LIFE_TIME_DAYS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DDoS attack metrics aggregated logs lifetime in days") + ". <br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": "  + LangHelper.GetString("Dics", "Default value") + ": 14" + ".",
            "placeholder": "14",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltipWidth": 400
        },
        {
            "id": "QUERY_PAGE_SIZE",
            "group": "7",
            "value": LangHelper.GetString("Dics", "Default page size of QoE query") + " (QUERY_PAGE_SIZE)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Default page size of QoE query") + ".",
            "default": 100,
            "placeholder": "100",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QUERY_MAX_PAGE_SIZE",
            "group": "7",
            "value": LangHelper.GetString("Dics", "Max page size of QoE query") + " (QUERY_MAX_PAGE_SIZE)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Max page size of QoE query") + ".",
            "default": 10000,
            "placeholder": "10000",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        }
    ]);

    //Group 8
    clAddToDic(8, [
        {
            "id": "ULR_LOAD_LOG_LEVEL",
            "group": "8",
            "value": LangHelper.GetString("Dics", "Log level detalization") + " (ULR_LOAD_LOG_LEVEL)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Info")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Debug")},
                    "3": {"id": "2", "value": LangHelper.GetString("Dics", "Trace")}
                },
            "default": 0,
            "tooltip": LangHelper.GetString("Dics", "Log level detalization") + ". " + LangHelper.GetString("Dics", ".")
        },
        {
            id: "ULR_LOAD_LOGS_WRITE_TO",
            group: "8",
            value: LangHelper.GetString("Dics", "Place to store ulr logs") + " (ULR_LOAD_LOGS_WRITE_TO)",
            view: "multiselectBitMask",
            params:{
                maskFormat:"hex"
            },
            options:
                {
                    "0x2": {id: "0x2", value: "0x2 - " + LangHelper.GetString("Dics", "Ulr log file")},
                    "0x4": {id: "0x4", value: "0x4 - " + LangHelper.GetString("Dics", "Syslog")}
                },
            tooltip: LangHelper.GetString("Dics", "Place to store ulr logs") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x2" + "." + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "Ulr log file") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Syslog"),
            tooltipWidth:480,
            tooltipHeight:480
        },
        {
            id: "SYSLOG_FACILITY_ULR_LOAD_LOGS",
            group: "8",
            value: LangHelper.GetString("Dics", "Syslog facility of ulr logs") + " (SYSLOG_FACILITY_ULR_LOAD_LOGS)",
            "view": "richselect",
            "options": SyslogFacilityOptions,
            "tooltip":  LangHelper.GetString("Dics", "Syslog facility of ulr logs")
        },
        {
            id: "ULR_USER_ACTION_LOGS_WRITE_TO",
            group: "8",
            value: LangHelper.GetString("Dics", "Place to store user actions logs") + " (ULR_USER_ACTION_LOGS_WRITE_TO)",
            view: "multiselectBitMask",
            params:{
                maskFormat:"hex"
            },
            options:
                {
                    "0x1": {id: "0x1", value: "0x1 - " + LangHelper.GetString("Dics", "DB")},
                    "0x2": {id: "0x2", value: "0x2 - " + LangHelper.GetString("Dics", "Ulr log file")},
                    "0x4": {id: "0x4", value: "0x4 - " + LangHelper.GetString("Dics", "Syslog")}
                },
            tooltip: LangHelper.GetString("Dics", "Place to store user actions logs") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x1" + "." + "<br/><br/>" +
                "0x1 - " + LangHelper.GetString("Dics", "DB") + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "Ulr log file") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Syslog"),
            tooltipWidth:480,
            tooltipHeight:480
        },
        {
            id: "SYSLOG_FACILITY_ULR_USER_ACTION_LOGS",
            group: "8",
            value: LangHelper.GetString("Dics", "Syslog facility of user actions logs") + " (SYSLOG_FACILITY_ULR_USER_ACTION_LOGS)",
            "view": "richselect",
            "options": SyslogFacilityOptions,
            "tooltip":  LangHelper.GetString("Dics", "Syslog facility of user actions logs")
        },

        {
            "id": "ULR_QUEUE_DELETE_TASKS_DAYS_INTERVAL",
            "group": "8",
            "value": LangHelper.GetString("Dics", "Period of data clearing Ulr tasks in days") + " (ULR_QUEUE_DELETE_TASKS_DAYS_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Period of data clearing Ulr tasks in days"),
            "default": 1,
            "placeholder": "1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "ULR_IP_EXCLUDE_ASN",
            "group": "8",
            "value": LangHelper.GetString("Dics", "ASN for IP-exclude rules") + " (ULR_IP_EXCLUDE_ASN)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "ASN for IP-exclude rules") + ". ",
            "default": 64401,
            "placeholder": "64401",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },

        {
            "id": "ULR_LOGS_CLEARING_DAYS_INTERVAL",
            "group": "8",
            "value": LangHelper.GetString("Dics", "Period of clearing old Ulr logs in days") + " (ULR_LOGS_CLEARING_DAYS_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Period of clearing old Ulr logs in days") + ". ",
            "default": 5,
            "placeholder": "5",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "ULR_USERS_ACTIONS_LOGS_CLEARING_DAYS_INTERVAL",
            "group": "8",
            "value": LangHelper.GetString("Dics", "Period of clearing Ulr users actions log in days") + " (ULR_USERS_ACTIONS_LOGS_CLEARING_DAYS_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Period of clearing Ulr users actions log in days") + ". ",
            "default": 180,
            "placeholder": "180",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "ULR_SCHEDULE_ENABLE",
            "group": "8",
            "value": LangHelper.GetString("Dics", "Schedule mode for updating lists") + " (ULR_SCHEDULE_ENABLE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Don`t use")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Use")},
                    "3": {"id": "2", "value": LangHelper.GetString("Dics", "Use only when there is a category")}
                },
            "default": "0",
            "tooltip": LangHelper.GetString("Dics", "Schedule mode for updating lists") + "."
        },
        {
            "id": "ULR_SCHEDULE_HOURS",
            "group": "8",
            "value": LangHelper.GetString("Dics", "Updating the lists every YOUR_VALUE hours") + " (ULR_SCHEDULE_HOURS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Updating the lists every YOUR_VALUE hours") + ". ",
            "default": 48,
            "placeholder": "48",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "ULR_DSCP_PROTOCOL_BACKUP_ENABLED",
            "group": "8",
            "value": LangHelper.GetString("Dics", "DSCP Protocols backup mode") + " (ULR_DSCP_PROTOCOL_BACKUP_ENABLED)",
            "tooltip": LangHelper.GetString("Dics", "DSCP Protocols backup mode") + ". ",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "default": 0
        },
        {
            "id": "BGP_PREFIX_DUMP_ENABLED",
            "group": "21",
            "value": LangHelper.GetString("Dics", "BGP dumps loading") + " (BGP_PREFIX_DUMP_ENABLED)",
            "tooltip": LangHelper.GetString("Dics", "BGP dumps loading"),
            "view": "richselect",
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "BGP_WATCHER_ENABLED",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Enable BGP watcher") + " (BGP_WATCHER_ENABLED)",
            "tooltip": LangHelper.GetString("Dics", "Enable BGP watcher"),
            "view": "richselect",
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "BGP_PREFIX_EXPORT_DUMP_PATH",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Path to export prefix dump") + " (BGP_PREFIX_EXPORT_DUMP_PATH)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Path to export prefix dump") + "<br/><br/>" + LangHelper.GetString("Dics", "Default value") + ": /var/bgp_watcher/export_dumps/",
            "placeholder": "/var/bgp_watcher/export_dumps/"
        },
        {
            "id": "BGP_WATCHER_PATH",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Path to env for bgp_watcher") + " (BGP_WATCHER_PATH)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Path to env for bgp_watcher") + "<br/><br/>" + LangHelper.GetString("Dics", "Default value") + ": /var/bgp_watcher/",
            "placeholder": "/var/bgp_watcher/"
        },
        {
            "id": "ULR_IPCHANNELS_EXPORT_LIST_TYPE_ORDER",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Order of entries in the ipchannels file by network type") + " (ULR_IPCHANNELS_EXPORT_LIST_TYPE_ORDER)",
            "tooltip": LangHelper.GetString("Dics", "Order of entries in the ipchannels file by network type") + "<br>"
                        + LangHelper.GetString("Dics", "By default") + ": " + LangHelper.GetString("Dics", "first") + " " + LangHelper.GetString("Dics","BGP - dynamic prefix"),
            "view": "richselect",
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "first") + " " + LangHelper.GetString("Dics","BGP - dynamic prefix")},
                {id: "1", value: LangHelper.GetString("Dics", "first") + " " + LangHelper.GetString("Dics","CIDR - static prefix")}
            ]
        },
        {
            "id": "ULR_IPCHANNELS_EXPORT_LIST_MASK_ORDER",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Order of entries in the ipchannels file by the number of network hosts") + " (ULR_IPCHANNELS_EXPORT_LIST_MASK_ORDER)",
            "tooltip": LangHelper.GetString("Dics", "Order of entries in the ipchannels file by the number of network hosts") + "<br>"
                        + LangHelper.GetString("Dics", "By default") + ": " + LangHelper.GetString("Dics", "in descending"),
            "view": "richselect",
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "in descending")},
                {id: "1", value: LangHelper.GetString("Dics", "in ascending")}
            ]
        },
        {
            "id": "ULR_FASTRESOURCE_URL",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Import from QoE application URL") + " (ULR_FASTRESOURCE_URL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Link to the application. It`s used by scripts for import from QoE resources for custom protocols and web rules.") + "<br>"
                + LangHelper.GetString("Dics", "By default is using the APP_URL value") + "."
        }
    ]);

    //Group 9
    clAddToDic(9, [
        {
            "id": "BROADCAST_DRIVER",
            "group": "9",
            "value": LangHelper.GetString("Dics", "Broadcast driver for push notifications") + " (BROADCAST_DRIVER)",
            "view": "richselect",
            "options":
                {
                    "redis": {"id": "redis", "value": LangHelper.GetString("Dics", "Redis")}
                },
            "tooltip": LangHelper.GetString("Dics", "Broadcast driver for push notifications") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "REDIS_HOST", "group": "9", "value": LangHelper.GetString("Dics", "Redis host") + " (REDIS_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Redis host") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "REDIS_PORT", "group": "9", "value": LangHelper.GetString("Dics", "Redis port") + " (REDIS_PORT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Redis port") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior."),
            "default": 6379,
            "placeholder": "6379",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "REDIS_PASSWORD",
            "group": "9",
            "value": LangHelper.GetString("Dics", "Redis password") + " (REDIS_PASSWORD)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Redis password") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        }
    ]);

    //Group 10
    clAddToDic(10, [
        {
            "id": "CFG_ASN_SERVER_REQUIRE_AUTH",
            "group": "10",
            "value": LangHelper.GetString("Dics", "Require authorization on ASN (OIMS) server") + " (CFG_ASN_SERVER_REQUIRE_AUTH)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Require authorization on ASN (OIMS) server"),
            options: [
                {"value": LangHelper.GetString("All", "No"), "id": "0"},
                {"value": LangHelper.GetString("All", "Yes"), "id": "1"}
            ]
        },
        {
            "id": "CFG_ASN_SERVER",
            "group": "10",
            "value": LangHelper.GetString("Dics", "ASN (OIMS) server") + " (CFG_ASN_SERVER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "ASN (OIMS) server"),
            "default": "localhost:20000",
            "placeholder": "localhost:20000"
        },
        {
            "id": "CFG_ASN_USER_ID",
            "group": "10",
            "value": LangHelper.GetString("Dics", "ASN user ID") + " (CFG_ASN_USER_ID)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "ASN user ID") + "<br/><br/>" + LangHelper.GetString("Dics", "Do not change this setting unnecessarily")
        },
        {
            "id": "CFG_ASN_TOKEN",
            "group": "10",
            "value": LangHelper.GetString("Dics", "ASN token") + " (CFG_ASN_TOKEN)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "ASN token") + "<br/><br/>" + LangHelper.GetString("Dics", "Do not change this setting unnecessarily")
        },
        {
            "id": "CFG_ASN_VER",
            "group": "10",
            "value": LangHelper.GetString("Dics", "ASN version") + " (CFG_ASN_VER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "ASN version") + "<br/><br/>" + LangHelper.GetString("Dics", "Do not change this setting unnecessarily"),
            "default": "4"
        },
        {
            "id": "CFG_ASN_DPI_HW_ID",
            "group": "10",
            "value": LangHelper.GetString("Dics", "DPI hardware ID") + " (CFG_ASN_DPI_HW_ID)",
            "view": "richselect",
            "app_dic": "HardwaresDic",
            "tooltip": LangHelper.GetString("Dics", "DPI hardware ID"),
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "CFG_TRAGEN_RUN",
            "group": "10",
            "value": LangHelper.GetString("Dics", "Traffic generator executable path") + " (CFG_TRAGEN_RUN)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Traffic generator executable path"),
            "placeholder": "/usr/sbin/tragen"
        },
        {
            "id": "CFG_TRAGEN_ALLOWABLE_PORTS",
            "group": "10",
            "value": LangHelper.GetString("Dics", "PCI Ethernet controllers ports numbers") + " (CFG_TRAGEN_ALLOWABLE_PORTS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "PCI Ethernet controllers ports numbers"),
            "placeholder": "42:00.0,42:00.1,05:00.0,05:00.1"
        },
        {
            "id": "CFG_TRAGEN_PID_ADDITION",
            "group": "10",
            "value": LangHelper.GetString("Dics", "Traffic generator pid addition") + " (CFG_TRAGEN_PID_ADDITION)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Traffic generator pid addition"),
            "placeholder": "-1"
        },
        {
            "id": "LI_QUEUE_DELETE_TASKS_DAYS_INTERVAL",
            "group": "5",
            "value": LangHelper.GetString("Dics", "Period of clearing traffic decoding queue logs in days") + " (LI_QUEUE_DELETE_TASKS_DAYS_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Period of clearing traffic decoding queue logs in days"),
            "default": 10,
            "placeholder": "10",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        }
    ]);

    //Group 11
    clAddToDic(11, [
        {
            "id": "QOESTOR_MOVE_OLD_PARTITIONS_TO_HOT_DISK",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Enable moving data to HOT disk") + " (QOESTOR_MOVE_OLD_PARTITIONS_TO_HOT_DISK)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Enable moving data to HOT disk"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "QOESTOR_MOVE_OLD_PARTITIONS_TO_HOT_DISK_FROM_COLD",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Enable moving data to HOT disk from COLD disk") + " (QOESTOR_MOVE_OLD_PARTITIONS_TO_HOT_DISK_FROM_COLD)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Enable moving data to HOT disk from COLD disk"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "QOESTOR_LOGS_TO_MOVE_TO_HOT_DISK",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Logs list to move to HOT disk") + " (QOESTOR_LOGS_TO_MOVE_TO_HOT_DISK)",
            "view": "multiselect",
            "tooltip": LangHelper.GetString("Dics", "Logs list to move to HOT disk"),
            "default": 0,
            "options": [
                {id: "fullflow", value: LangHelper.GetString("Dics", "Raw fullflow")},
                {id: "fullflow_agg", value: LangHelper.GetString("Dics", "Agg fullflow")},
                {id: "clickstream", value: LangHelper.GetString("Dics", "Raw clickstream")},
                {id: "clickstream_agg", value: LangHelper.GetString("Dics", "Agg clickstream")},
                {id: "natflow", value: LangHelper.GetString("Dics", "Raw NAT flow")},
                {id: "natflow_agg", value: LangHelper.GetString("Dics", "Agg NAT flow")},
                {id: "gtpflow", value: LangHelper.GetString("Dics", "Raw GTP flow")},
                {id: "gtpflow_agg", value: LangHelper.GetString("Dics", "Agg GTP flow")},
                {id: "dnsflow", value: LangHelper.GetString("Dics", "Raw DNS flow")},
                {id: "dnsflow_agg", value: LangHelper.GetString("Dics", "Agg DNS flow")},
                {id: "cal_agg", value: LangHelper.GetString("Dics", "Agg custom logs")},
                {id: "subscribers_online_flow_agg", value: LangHelper.GetString("Dics", "Agg online flow")},
                {id: "aaaflow", value: LangHelper.GetString("Dics", "Raw aaaflow")},
                {id: "aaaflow_agg", value: LangHelper.GetString("Dics", "AAA UDR fullflow and clickstream")},

                {id: "fm_attacks", value: LangHelper.GetString("Dics", "Raw attacks log")},
                {id: "fm_attacks_agg", value: LangHelper.GetString("Dics", "Agg attacks log")},

                {id: "fm_attacks_metrics", value: LangHelper.GetString("Dics", "Raw attacks metrics log")},
                {id: "fm_attacks_metrics_agg", value: LangHelper.GetString("Dics", "Agg attacks metrics log")},

            ]
        },
        {
            "id": "QOESTOR_LOGS_LIFETIME_BEFORE_MOVING_TO_HOT_DISK",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor logs lifetime before moving to HOT disk, in hours") + " (QOESTOR_LOGS_LIFETIME_BEFORE_MOVING_TO_HOT_DISK)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor logs lifetime before moving to HOT disk, in hours") + ".",
            "placeholder": "24",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOESTOR_MOVE_OLD_PARTITIONS_TO_HOT_DISK_SCHEDULE_WEEK_DAYS",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Days of week to HOT disk") + " (QOESTOR_MOVE_OLD_PARTITIONS_TO_HOT_DISK_SCHEDULE_WEEK_DAYS)",
            "view": "multiselect",
            "tooltip": LangHelper.GetString("Dics", "Days of week when partitions movings to HOT disk are possible") + " (" + LangHelper.GetString("Dics", "All by default") + ")",
            "default": 0,
            "options": [
                {"value": LangHelper.GetString("Dics", "Mon"), "id": "1"},
                {"value": LangHelper.GetString("Dics", "Tue"), "id": "2"},
                {"value": LangHelper.GetString("Dics", "Wed"), "id": "3"},
                {"value": LangHelper.GetString("Dics", "Thu"), "id": "4"},
                {"value": LangHelper.GetString("Dics", "Fri"), "id": "5"},
                {"value": LangHelper.GetString("Dics", "Sat"), "id": "6"},
                {"value": LangHelper.GetString("Dics", "Sun"), "id": "7"}
            ]
        },
        {
            "id": "QOESTOR_MOVE_OLD_PARTITIONS_TO_HOT_DISK_SCHEDULE_HOURS",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Hours of day to HOT disk") + " (QOESTOR_MOVE_OLD_PARTITIONS_TO_HOT_DISK_SCHEDULE_HOURS)",
            "view": "multiselect",
            "tooltip": LangHelper.GetString("Dics", "Hours of day when partitions movings to HOT disk are possible") + " (" + LangHelper.GetString("Dics", "All by default") + ")",
            "default": 0,
            "options": [
                {"value": "0", "id": "0"},
                {"value": "1", "id": "1"},
                {"value": "2", "id": "2"},
                {"value": "3", "id": "3"},
                {"value": "4", "id": "4"},
                {"value": "5", "id": "5"},
                {"value": "6", "id": "6"},
                {"value": "7", "id": "7"},
                {"value": "8", "id": "8"},
                {"value": "9", "id": "9"},
                {"value": "10", "id": "10"},
                {"value": "11", "id": "11"},
                {"value": "12", "id": "12"},
                {"value": "13", "id": "13"},
                {"value": "14", "id": "14"},
                {"value": "15", "id": "15"},
                {"value": "16", "id": "16"},
                {"value": "17", "id": "17"},
                {"value": "18", "id": "18"},
                {"value": "19", "id": "19"},
                {"value": "20", "id": "20"},
                {"value": "21", "id": "21"},
                {"value": "22", "id": "22"},
                {"value": "23", "id": "23"}
            ]
        },
        {
            "id": "QOESTOR_MOVE_OLD_PARTITIONS_TO_COLD_DISK",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Enable moving data to COLD disk") + " (QOESTOR_MOVE_OLD_PARTITIONS_TO_COLD_DISK)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Enable moving data to COLD disk"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "QOESTOR_LOGS_TO_MOVE_TO_COLD_DISK",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Logs list to move to COLD disk") + " (QOESTOR_LOGS_TO_MOVE_TO_COLD_DISK)",
            "view": "multiselect",
            "tooltip": LangHelper.GetString("Dics", "Logs list to move to COLD disk"),
            "default": 0,
            "options": [
                {id: "fullflow", value: LangHelper.GetString("Dics", "Raw fullflow")},
                {id: "fullflow_agg", value: LangHelper.GetString("Dics", "Agg fullflow")},
                {id: "clickstream", value: LangHelper.GetString("Dics", "Raw clickstream")},
                {id: "clickstream_agg", value: LangHelper.GetString("Dics", "Agg clickstream")},
                {id: "natflow", value: LangHelper.GetString("Dics", "Raw NAT flow")},
                {id: "natflow_agg", value: LangHelper.GetString("Dics", "Agg NAT flow")},
                {id: "gtpflow", value: LangHelper.GetString("Dics", "Raw GTP flow")},
                {id: "gtpflow_agg", value: LangHelper.GetString("Dics", "Agg GTP flow")},
                {id: "dnsflow", value: LangHelper.GetString("Dics", "Raw DNS flow")},
                {id: "dnsflow_agg", value: LangHelper.GetString("Dics", "Agg DNS flow")},
                {id: "cal_agg", value: LangHelper.GetString("Dics", "Agg custom logs")},
                {id: "subscribers_online_flow_agg", value: LangHelper.GetString("Dics", "Agg online flow")},
                {id: "aaaflow", value: LangHelper.GetString("Dics", "Raw aaaflow")},
                {id: "aaaflow_agg", value: LangHelper.GetString("Dics", "AAA UDR fullflow and clickstream")},

                {id: "fm_attacks", value: LangHelper.GetString("Dics", "Raw attacks log")},
                {id: "fm_attacks_agg", value: LangHelper.GetString("Dics", "Agg attacks log")},

                {id: "fm_attacks_metrics", value: LangHelper.GetString("Dics", "Raw attacks metrics log")},
                {id: "fm_attacks_metrics_agg", value: LangHelper.GetString("Dics", "Agg attacks metrics log")},
            ]
        },
        {
            "id": "QOESTOR_LOGS_LIFETIME_BEFORE_MOVING_TO_COLD_DISK",
            "group": "7",
            "value": LangHelper.GetString("Dics", "QoE Stor logs lifetime before moving to COLD disk, in hours") + " (QOESTOR_LOGS_LIFETIME_BEFORE_MOVING_TO_COLD_DISK)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor logs lifetime before moving to COLD disk, in hours") + ".",
            "placeholder": "720",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOESTOR_MOVE_OLD_PARTITIONS_TO_COLD_DISK_SCHEDULE_WEEK_DAYS",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Days of week to COLD disk") + " (QOESTOR_MOVE_OLD_PARTITIONS_TO_COLD_DISK_SCHEDULE_WEEK_DAYS)",
            "view": "multiselect",
            "tooltip": LangHelper.GetString("Dics", "Days of week when partitions movings to COLD disk are possible") + " (" + LangHelper.GetString("Dics", "All by default") + ")",
            "default": 0,
            "options": [
                {"value": LangHelper.GetString("Dics", "Mon"), "id": "1"},
                {"value": LangHelper.GetString("Dics", "Tue"), "id": "2"},
                {"value": LangHelper.GetString("Dics", "Wed"), "id": "3"},
                {"value": LangHelper.GetString("Dics", "Thu"), "id": "4"},
                {"value": LangHelper.GetString("Dics", "Fri"), "id": "5"},
                {"value": LangHelper.GetString("Dics", "Sat"), "id": "6"},
                {"value": LangHelper.GetString("Dics", "Sun"), "id": "7"}
            ]
        },
        {
            "id": "QOESTOR_MOVE_OLD_PARTITIONS_TO_COLD_DISK_SCHEDULE_HOURS",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Hours of day to COLD disk") + " (QOESTOR_MOVE_OLD_PARTITIONS_TO_COLD_DISK_SCHEDULE_HOURS)",
            "view": "multiselect",
            "tooltip": LangHelper.GetString("Dics", "Hours of day when partitions movings to COLD disk are possible") + " (" + LangHelper.GetString("Dics", "All by default") + ")",
            "default": 0,
            "options": [
                {"value": "0", "id": "0"},
                {"value": "1", "id": "1"},
                {"value": "2", "id": "2"},
                {"value": "3", "id": "3"},
                {"value": "4", "id": "4"},
                {"value": "5", "id": "5"},
                {"value": "6", "id": "6"},
                {"value": "7", "id": "7"},
                {"value": "8", "id": "8"},
                {"value": "9", "id": "9"},
                {"value": "10", "id": "10"},
                {"value": "11", "id": "11"},
                {"value": "12", "id": "12"},
                {"value": "13", "id": "13"},
                {"value": "14", "id": "14"},
                {"value": "15", "id": "15"},
                {"value": "16", "id": "16"},
                {"value": "17", "id": "17"},
                {"value": "18", "id": "18"},
                {"value": "19", "id": "19"},
                {"value": "20", "id": "20"},
                {"value": "21", "id": "21"},
                {"value": "22", "id": "22"},
                {"value": "23", "id": "23"}
            ]
        },
        {
            "id": "QOESTOR_FORCE_MOVE_FROM_DEFAULT_DISK",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Enable force moving data") + " " + LangHelper.GetString("Dics", "for DEFAULT disk") + " (QOESTOR_FORCE_MOVE_FROM_DEFAULT_DISK)",
            "view": "richselect",
            "tooltip":  LangHelper.GetString("Dics", "Enable force moving data") + " " + LangHelper.GetString("Dics", "for DEFAULT disk") + ".<br/><br/>" + LangHelper.GetString("Dics", "Attention! By default, data deletion on this drive is enabled."),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enable data removing!")},
                {id: "2", value: LangHelper.GetString("Dics", "Enable move to") + " HOT " + LangHelper.GetString("Dics", "disk")}
            ]
        },
        {
            "id": "QOESTOR_FORCE_MOVE_FROM_DEFAULT_DISK_FACTOR",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Move factor") + " " + LangHelper.GetString("Dics", "for DEFAULT disk") + " (QOESTOR_FORCE_MOVE_FROM_DEFAULT_DISK_FACTOR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "The amount of free space before force moving enabled") + "." + "<br/>" + LangHelper.GetString("Dics", "Default value") + ": 0.1",
            "placeholder": "0.1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOESTOR_FORCE_MOVE_FROM_HOT_DISK",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Enable force moving data") + " " + LangHelper.GetString("Dics", "for HOT disk") + " (QOESTOR_FORCE_MOVE_FROM_HOT_DISK)",
            "view": "richselect",
            "tooltip":  LangHelper.GetString("Dics", "Enable force moving data") + " " + LangHelper.GetString("Dics", "for HOT disk"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enable data removing!")},
                {id: "2", value: LangHelper.GetString("Dics", "Enable move to") + " COLD " + LangHelper.GetString("Dics", "disk")}
            ]
        },
        {
            "id": "QOESTOR_FORCE_MOVE_FROM_HOT_DISK_FACTOR",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Move factor") + " " + LangHelper.GetString("Dics", "for HOT disk") + " (QOESTOR_FORCE_MOVE_FROM_HOT_DISK_FACTOR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "The amount of free space before force moving enabled") + "." + "<br/>" + LangHelper.GetString("Dics", "Default value") + ": 0.1",
            "placeholder": "0.1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOESTOR_FORCE_MOVE_FROM_COLD_DISK",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Enable force moving data") + " " + LangHelper.GetString("Dics", "for COLD disk") + " (QOESTOR_FORCE_MOVE_FROM_COLD_DISK)",
            "view": "richselect",
            "tooltip":  LangHelper.GetString("Dics", "Enable force moving data") + " " + LangHelper.GetString("Dics", "for COLD disk"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enable data removing!")}
            ]
        },
        {
            "id": "QOESTOR_FORCE_MOVE_FROM_COLD_DISK_FACTOR",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Move factor") + " " + LangHelper.GetString("Dics", "for COLD disk") + " (QOESTOR_FORCE_MOVE_FROM_COLD_DISK_FACTOR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "The amount of free space before force moving enabled") + "." + "<br/>" + LangHelper.GetString("Dics", "Default value") + ": 0.1",
            "placeholder": "0.1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
    ]);

    //Group 12
    clAddToDic(12, [
        {
            "id": "SSO_AUTHORIZATION_ENABLED",
            "group": "12",
            "value": LangHelper.GetString("Dics", "Enable SSO authorization") + " (SSO_AUTHORIZATION_ENABLED)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Enable SSO authorization"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "SSO_AUTHORIZATION_HOST",
            "group": "12",
            "value": LangHelper.GetString("Dics", "SSO authorization host") + " (SSO_AUTHORIZATION_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "SSO authorization host") + ". ",
            "default": "127.0.0.1",
            "placeholder": "127.0.0.1"
        },
        {
            "id": "SSO_AUTHORIZATION_USER",
            "group": "12",
            "value": LangHelper.GetString("Dics", "SSO authorization username") + " (SSO_AUTHORIZATION_USER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "SSO authorization username") + ".",
            "default": "default",
            "placeholder": "default"
        },
        {
            "id": "SSO_AUTHORIZATION_PASS",
            "group": "12",
            "value": LangHelper.GetString("Dics", "SSO authorization password") + " (SSO_AUTHORIZATION_PASS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "SSO authorization password") + "."
        }
    ]);

    //Group13
    clAddToDic(13, [
        {
            "id": "OSM_FILE_TIME_PERIOD",
            "group": "13",
            "value": LangHelper.GetString("Dics", "Map data storage period, days") + " (OSM_FILE_TIME_PERIOD)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Map data storage period, days") + ".<br/><br/>" + LangHelper.GetString("Dics", "Default value is") + " 365.",
            "placeholder": "365",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        }
    ]);

    //Group14
    clAddToDic(14,[

        {
            "id": "VAS_CLOUD_HOST",
            "group": "14",
            "value": LangHelper.GetString("Dics", "VAS Cloud host") + " (VAS_CLOUD_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "VAS Cloud host") + ".<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "VAS_CLOUD_API_TOKEN",
            "group": "14",
            "value": LangHelper.GetString("Dics", "VAS Cloud API token") + " (VAS_CLOUD_API_TOKEN)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "VAS Cloud API token") + ".<br/><br/>" + LangHelper.GetString("Dics", "If a token is specified, authorization is performed using the token. If not specified, by login and password.")
        },
        {
            "id": "VAS_CLOUD_CUSTOM_PRTCLS_QUEUE_DELETE_TASKS_DAYS_INTERVAL",
            "group": "14",
            "value": LangHelper.GetString("Dics", "Period of clearing custom protocols queue logs in days") + " (VAS_CLOUD_CUSTOM_PRTCLS_QUEUE_DELETE_TASKS_DAYS_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Period of clearing custom protocols queue logs in days"),
            "placeholder": "10",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "COLLECT_STATISTICS",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Share usage statistics with VAS Experts") + " (COLLECT_STATISTICS)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "By enabling this functionality, you help us improve the product. No confidential information is transferred. (enabled by default)"),
            "options":
                {
                    "0": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                }
        },
        {
            "id": "EXPORT_STATISTICS_QUEUE_DELETE_TASKS_DAYS_INTERVAL",
            "group": "14",
            "value": LangHelper.GetString("Dics", "Period of clearing statictics queue logs in days") + " (EXPORT_STATISTICS_QUEUE_DELETE_TASKS_DAYS_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Period of clearing statictics queue logs in days"),
            "placeholder": "1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "EXPORT_STATISTICS_DELETE_DAYS_INTERVAL",
            "group": "14",
            "value": LangHelper.GetString("Dics", "Period of clearing collected statistics logs in days") + " (EXPORT_STATISTICS_DELETE_DAYS_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Period of clearing collected statistics logs in days"),
            "placeholder": "1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        }
    ]);

    //Group15
    clAddToDic(15,[
        {
            "id": "GALERA_PEER_HOSTS",
            "group": "15",
            "value": LangHelper.GetString("Dics", "MariaDB Galera Cluster hosts") + " (GALERA_PEER_HOSTS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "MariaDB Galera Cluster hosts") + ".<br/><br/>" + LangHelper.GetString("Dics", "Comma separated IPs or hostsnames") + ".<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "CLUSTER_FS_PEER_HOSTS",
            "group": "15",
            "value": LangHelper.GetString("Dics", "GlusterFS hosts") + " (CLUSTER_FS_PEER_HOSTS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "GlusterFS hosts") + ".<br/><br/>" + LangHelper.GetString("Dics", "Comma separated IPs or hostsnames") + ".<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "CLUSTER_PRIMARY_HOST",
            "group": "15",
            "value": LangHelper.GetString("Dics", "Cluster primary host") + " (CLUSTER_PRIMARY_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Cluster primary host") + ".<br/><br/>" + LangHelper.GetString("Dics", "IP or hostname where data synchronization should be performed") + ".<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        }
    ]);

    //Group 16
    clAddToDic(16,[
        {
            "id": "BACKUP_DB_ENABLED",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Enable DB backup") + " (BACKUP_DB_ENABLED)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Enable DB backup"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "BACKUP_DB_INTERVAL_MINUTES",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Backup DB time interval, minutes") + " (BACKUP_DB_INTERVAL_MINUTES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Backup DB time interval, minutes") +
                ".<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is") + " 1440.",
            "placeholder": "1440",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "BACKUP_DB_PATH",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Backup DB save path") + " (BACKUP_DB_PATH)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Backup DB save path") + ".<br/><br/>" + LangHelper.GetString("Dics", "Default path is") + " /var/dpiui2_backup/db",
            "placeholder": "/var/dpiui2_backup/db"
        },
        {
            "id": "BACKUP_DB_DELETE_OLD_INTERVAL_MINUTES",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Delete old DB backups interval, minutes") + " (BACKUP_DB_DELETE_OLD_INTERVAL_MINUTES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Delete old DB backups interval, minutes") +
                ".<br/><br/>" + LangHelper.GetString("Dics", "Default value is") +
                " 0" +
                " (" +
                LangHelper.GetString("Dics", "0 - don`t delete") +
                ")."
            ,
            "placeholder": "0",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },

        {
            "id": "BACKUP_FS_ENABLED",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Enable FS backup") + " (BACKUP_FS_ENABLED)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Enable FS backup"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "BACKUP_FS_INTERVAL_MINUTES",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Backup FS time interval, minutes") + " (BACKUP_FS_INTERVAL_MINUTES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Backup FS time interval, minutes") +
                ".<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is") + " 1440.",
            "placeholder": "1440",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "BACKUP_FS_PATH",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Backup FS save path") + " (BACKUP_FS_PATH)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Backup FS save path") + ".<br/><br/>" + LangHelper.GetString("Dics", "Default path is") + " /var/dpiui2_backup/fs",
            "placeholder": "/var/dpiui2_backup/fs"
        },
        {
            "id": "BACKUP_FS_DELETE_OLD_INTERVAL_MINUTES",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Delete old FS backups interval, minutes") + " (BACKUP_FS_DELETE_OLD_INTERVAL_MINUTES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Delete old FS backups interval, minutes") +
                ".<br/><br/>" + LangHelper.GetString("Dics", "Default value is") +
                " 0" +
                " (" +
                LangHelper.GetString("Dics", "0 - don`t delete") +
                ")."
            ,
            "placeholder": "0",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "BACKUP_SCP_HOST",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Remote server host for storing backups") + " (BACKUP_SCP_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Remote server host for storing backups") + ". "
        },
        {
            "id": "BACKUP_SCP_PORT",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Remote server port for storing backups") + " (BACKUP_SCP_PORT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Remote server port for storing backups") + ". ",
            "placeholder": "22",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "BACKUP_SCP_USER",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Backup storage username") + " (BACKUP_SCP_USER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Backup storage username") + ". ",
            "default": "",
            "placeholder": ""
        },
        {
            "id": "BACKUP_SCP_PASSWORD",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Backup storage password") + " (BACKUP_SCP_PASSWORD)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Backup storage password") + ". "
                + "<br/><br/>"
                + "<span style='color: red'>"
                + LangHelper.GetString("Dics", "SCP will use public key for user authorization if password does not set!")
                + "</span>"
        },
        {
            "id": "BACKUP_SCP_DB_PATH",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Backup DB remote path") + " (BACKUP_SCP_DB_PATH)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Backup DB remote path")
                + ".<br/><br/>"
                + LangHelper.GetString("Dics", "Default path is")
                + " /var/dpiui2_backup/db"
                + "<br/></br>"
                + "<span style='color: red'>"
                + LangHelper.GetString("Dics", "Folder should be exist") + ". "
                + LangHelper.GetString("Dics", "User should have permissions for this folder") + "."
                + "</span>"

            ,
            "placeholder": "/var/dpiui2_backup/db"
        },
        {
            "id": "BACKUP_SCP_FS_PATH",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Backup FS remote path") + " (BACKUP_SCP_FS_PATH)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Backup FS remote path")
                + ".<br/><br/>"
                + LangHelper.GetString("Dics", "Default path is")
                + " /var/dpiui2_backup/fs"
                + "<br/></br>"
                + "<span style='color: red'>"
                + LangHelper.GetString("Dics", "Folder should be exist") + ". "
                + LangHelper.GetString("Dics", "User should have permissions for this folder") + "."
                + "</span>"
            ,
            "placeholder": "/var/dpiui2_backup/fs"
        },
    ]);

    //Group 17
    clAddToDic(17, [
        {
            "id": "BACKUP_RESTORATION_DB_ENABLED",
            "group": "17",
            "value": LangHelper.GetString("Dics", "Enable DB auto restoration from backup") + " (BACKUP_RESTORATION_DB_ENABLED)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Enable DB auto restoration from backup"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "BACKUP_RESTORATION_DB_FOLDER",
            "group": "17",
            "value": LangHelper.GetString("Dics", "DB backup folder") + " (BACKUP_RESTORATION_DB_FOLDER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB backup folder")
        },
        {
            "id": "BACKUP_RESTORATION_DB_DELETE_OLD_INTERVAL_MINUTES",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Delete old DB backups interval, minutes") + " (BACKUP_RESTORATION_DB_DELETE_OLD_INTERVAL_MINUTES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Delete old DB backups interval, minutes") +
                ".<br/><br/>" + LangHelper.GetString("Dics", "Default value is") +
                " 0" +
                " (" +
                LangHelper.GetString("Dics", "0 - don`t delete") +
                ")."
            ,
            "placeholder": "0",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "BACKUP_RESTORATION_FS_ENABLED",
            "group": "17",
            "value": LangHelper.GetString("Dics", "Enable FS auto restoration from backup") + " (BACKUP_RESTORATION_FS_ENABLED)",
            "view": "richselect",
            "tooltip": LangHelper.GetString("Dics", "Enable FS auto restoration from backup"),
            "default": 0,
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "BACKUP_RESTORATION_FS_FOLDER",
            "group": "17",
            "value": LangHelper.GetString("Dics", "FS backup folder") + " (BACKUP_RESTORATION_FS_FOLDER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "FS backup folder")
        },
        {
            "id": "BACKUP_RESTORATION_FS_DELETE_OLD_INTERVAL_MINUTES",
            "group": "16",
            "value": LangHelper.GetString("Dics", "Delete old FS backups interval, minutes") + " (BACKUP_RESTORATION_FS_DELETE_OLD_INTERVAL_MINUTES)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Delete old FS backups interval, minutes") +
                ".<br/><br/>" + LangHelper.GetString("Dics", "Default value is") +
                " 0" +
                " (" +
                LangHelper.GetString("Dics", "0 - don`t delete") +
                ")."
            ,
            "placeholder": "0",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        }
    ]);

    //Group 18
    clAddToDic(18, [
        {
            "id": "TELEGRAM_BOT_API_TOKEN",
            "group": "18",
            "value": LangHelper.GetString("Dics", "Telegram bot API token") + " (TELEGRAM_BOT_API_TOKEN)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Telegram bot API token"),
        },
    ]);

    clAddToDic(19, [
        {
            "id": "LANGUAGE_FOR_FILES_IN_TRIGGERS",
            "group": "19",
            "value": LangHelper.GetString("Dics", "Language for mailing") + " (LANGUAGE_FOR_FILES_IN_TRIGGERS)",
            "view": "richselect",
            "options": function()
            {
                var list  = {
                    "ru": {"id": "ru", "value": LangHelper.GetString("Dics", "Russian")},
                    "en": {"id": "en", "value": LangHelper.GetString("Dics", "English")}
                }

                if (vendor === 'cubro')
                    list =  { "en": {"id": "en", "value": LangHelper.GetString("Dics", "English")} }

                return list;

            }(),
            "default":"en",
            "tooltip": LangHelper.GetString("Dics", "Language for mailing") + "</br></br>" + LangHelper.GetString("All", "By default") + ": " + LangHelper.GetString("Dics", "English").toLowerCase() + "."
        },
        {
            "id": "FORMAT_UNITS_IN_TRIGGERS",
            "group": "19",
            "value": LangHelper.GetString("Dics", "Enable value formatting for export file in triggers") + " (FORMAT_UNITS_IN_TRIGGERS)",
            "view": "richselect",
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ],
            "default": "1",
            "tooltip": LangHelper.GetString("Dics", "Enable value formatting for export file in triggers") + "."
        },
        {
            "id": "HIDE_PROTOCOLS_NUMBER_IN_PDF",
            "group": "19",
            "value": LangHelper.GetString("Dics", "Hide display of protocol number in exported PDF format") + " (HIDE_PROTOCOLS_NUMBER_IN_PDF)",
            "view": "richselect",
            "options": [
                {id: "0", value: LangHelper.GetString("Dics", "Disabled")},
                {id: "1", value: LangHelper.GetString("Dics", "Enabled")}
            ],
            "default": "0",
            "tooltip": LangHelper.GetString("Dics", "Hide display of protocol number in exported PDF format") + "."
        },
    ])

    clAddToDic(20, [
        {
            "id": "QOE_COMPRESS_PART_INTERVAL_HOURS",
            "group": "20",
            "value": LangHelper.GetString("Dics", "QoE Stor aggregation time interval in hours") + " (QOE_COMPRESS_PART_INTERVAL_HOURS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "QoE Stor aggregation time interval in hours") + ".",
            "default": 2,
            "placeholder": "2",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOE_COMPRESS_PART_NUM",
            "group": "20",
            "value": LangHelper.GetString("Dics", "Parallel processing partitions number") + " (QOE_COMPRESS_PART_NUM)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Parallel processing partitions number") + ".",
            "default": 1,
            "placeholder": "1",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "QOE_COMPRESS_LOAD_LOG_LEVEL",
            "group": "20",
            "value": LangHelper.GetString("Dics", "Log level detalization") + " (QOE_COMPRESS_LOAD_LOG_LEVEL)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Info")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Debug")},
                    "3": {"id": "2", "value": LangHelper.GetString("Dics", "Trace")}
                },
            "default": 0,
            "tooltip": LangHelper.GetString("Dics", "Log level detalization") + "."
        }
    ]);

    clAddToDic(21, [
        {
            "id": "ULR_WHITE_LIST_REDIRECT_URL",
            "group": "21",
            "value": LangHelper.GetString("Dics", "White list redirect URL") + " (ULR_WHITE_LIST_REDIRECT_URL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "White list redirect URL"),
            //"default":"https://google.com",
            "placeholder": "https://google.com"
        },
        {
            "id": "ULR_BLACK_LIST_REDIRECT_URL",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Black list redirect URL") + " (ULR_BLACK_LIST_REDIRECT_URL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Black list redirect URL"),
            //"default":"https://google.com",
            "placeholder": "https://google.com"
        },
        {
            "id": "ULR_ADD_PORTS_TO_IP_ON_EXPORT",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Add default ports on export white/black lists") + " (ULR_ADD_PORTS_TO_IP_ON_EXPORT)",
            "tooltip": LangHelper.GetString("Dics", "Add default ports on export white/black lists") + ". <br/><br/>" +
                LangHelper.GetString("Dics", "For each IP or PREFIX the following ports will be added") + ":" +
                "<ul><li>80</li><li>443</li></ul>" +
                LangHelper.GetString("Dics", "Default value is") + " " + LangHelper.GetString("Dics", "Enabled"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "default": 1
        },
        {
            "id": "ULR_BLACK_LIST_DEPLOY_HOST",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Black list upload host") + " (ULR_BLACK_LIST_DEPLOY_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Black list upload host") + ". " + LangHelper.GetString("Dics", "To connect to the black list resources server."),
            "default": "vasexperts.ru",
            "placeholder": "vasexperts.ru"
        },
        {
            "id": "ULR_BLACK_LIST_DEPLOY_PORT",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Black list upload port") + " (ULR_BLACK_LIST_DEPLOY_PORT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Black list upload port") + ". " + LangHelper.GetString("Dics", "To connect to the black list resources server."),
            "default": 22,
            "placeholder": "22",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "ULR_BLACK_LIST_DEPLOY_USER",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Black list upload username") + " (ULR_BLACK_LIST_DEPLOY_USER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Black list upload username") + ". " + LangHelper.GetString("Dics", "To connect to the black list resources server."),
            "default": "default",
            "placeholder": "default"
        },
        {
            "id": "ULR_BLACK_LIST_DEPLOY_PASS",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Black list upload password") + " (ULR_BLACK_LIST_DEPLOY_PASS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Black list upload password") + ". " + LangHelper.GetString("Dics", "To connect to the black list resources server.")
        },
        {
            "id": "ULR_BLACK_LIST_DEPLOY_SUDO",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Black list upload use sudo") + " (ULR_BLACK_LIST_DEPLOY_SUDO)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Don`t use")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Use")}
                },
            "tooltip": LangHelper.GetString("Dics", "Black list upload use sudo") + "."
        },
        {
            "id": "ULR_BLACK_LIST_DEPLOY_PATH",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Black list upload path") + " (ULR_BLACK_LIST_DEPLOY_PATH)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Black list upload path") + ". " + LangHelper.GetString("Dics", ".")
        },
        {
            "id": "ULR_IPFIX_LISTS_DEPLOY_PATH",
            "group": "21",
            "value": LangHelper.GetString("Dics", "Ipfix lists upload path") + " (ULR_IPFIX_LISTS_DEPLOY_PATH)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Ipfix lists upload path") + ". " + LangHelper.GetString("Dics", ".")
        },
        {
            id: "ULR_SYSTEM_WEB_RULE_ID",
            group: "21",
            value: LangHelper.GetString("Dics", "System Web rule ID") + " (ULR_SYSTEM_WEB_RULE_ID)",
            view: "text",
            tooltip: LangHelper.GetString("Dics", "System Web rule ID") + ".<br/>"
                + LangHelper.GetString("Dics", "Chosen Web rule should be exist") + ".<br/>"
        },
        {
            id: "ULR_SYSTEM_WEB_RULE_RESOURCES_LIST_FILE_PATH",
            group: "21",
            value: LangHelper.GetString("Dics", "System Web rule resources list file path") + " (ULR_SYSTEM_WEB_RULE_RESOURCES_LIST_FILE_PATH)",
            view: "text",
            placeholder: "/var/www/html/blacklists/for_import_to_filterui/import.lst",
            tooltip: LangHelper.GetString("Dics", "System Web rule resources list file path") + ".<br/>"
                + LangHelper.GetString("Dics", "File will be loaded from hardware inputed in ULR_BLACK_LIST_DEPLOY_HOST option") + ".<br/>"
                + LangHelper.GetString("Dics", "Default value is") + " /var/www/html/blacklists/for_import_to_filterui/import.lst<br/>"
        },
        {
            "id": "ULR_EXPORT_LISTS_TO_BL_REVISOR",
            "group": "21",
            "value": `${LangHelper.GetString("Dics", "Export lists to BL Revisor")} (ULR_EXPORT_LISTS_TO_BL_REVISOR)`,
            "tooltip": `${LangHelper.GetString("Dics", "Export lists to BL Revisor")}. <br/><br/>
                ${LangHelper.GetString("Dics", "Default value is")} ${LangHelper.GetString("VasCloud", "Disabled")}.`,
            "view": "richselect",
            "default": 0,
            "options": [
                {"id": "0", "value": LangHelper.GetString("VasCloud", "Disabled")},
                {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
            ]
        },
        {
            "id": "ULR_RULES_EXPORT_TO_BL_REVISOR",
            "group": "21",
            "value": `${LangHelper.GetString("Dics", "Rules for export to BL Revisor")} (ULR_RULES_EXPORT_TO_BL_REVISOR)`,
            "view": "text",
            "tooltip": `${LangHelper.GetString("Dics", "Rules for export to BL Revisor")}.<br>
                ${LangHelper.GetString("Dics", "Enter a rule ID or a comma separated list of rule IDs")}.<br/><br/> 
                ${LangHelper.GetString("HotSpot", "Example")}: 24  |  1,2,3,4`,
            "placeholder": "1,2,3,4",
            "validate": function (Val) {
                let valid = true;

                if (Val)
                {
                    Val.split(",").forEach(function (rule_id) {
                        if (isNaN(rule_id * 1) || rule_id.includes("."))
                            valid = false;
                    });
                }

                return valid
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter a rule ID or a comma separated list of rule IDs")
        },
        {
            "id": "ULR_EXPORT_LISTS_TO_BL_REVISOR_FILE_PATH",
            "group": "21",
            "value": `${LangHelper.GetString("Dics", "Path to save lists in BL Revisor")} (ULR_EXPORT_LISTS_TO_BL_REVISOR_FILE_PATH)`,
            "view": "text",
            "tooltip": `${LangHelper.GetString("Dics", "Path to save lists in BL Revisor")}.<br>
                ${LangHelper.GetString("Dics", "Default path is")}: /var/lib/bl_revisor/bl_lists/`,
            "placeholder": "/var/lib/bl_revisor/bl_lists/"
        },
    ]);

    clAddToDic(22, [
        {
            "id": "EXPORT_FILES_LIFE_TIME_HOURS",
            "group": "22",
            "value": LangHelper.GetString("Dics", "Export files lifetime in hours") + " (EXPORT_FILES_LIFE_TIME_HOURS)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Export files lifetime in hours")
                + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 24" + ".",
            "default": 24,
            "placeholder": "24",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "LIMIT_LINES_IN_EXPORT_FILE",
            "group": "22",
            "value": LangHelper.GetString("Dics", "Limit lines in export file") + " (LIMIT_LINES_IN_EXPORT_FILE)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Limit lines in export file")
                + ". <br/>" + LangHelper.GetString("Dics", "Default value") + ": 100000" + ".",
            "default": 100000,
            "placeholder": "100000",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "LIMIT_EXPORT_FILES_COUNT",
            "group": "22",
            "value": LangHelper.GetString("Dics", "File limit for report export") + " (LIMIT_EXPORT_FILES_COUNT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "The maximum number of files created when exporting reports in each format.")
                + "<br/>" + LangHelper.GetString("Dics", "Default value") + ": 100" + ".",
            "default": 100,
            "placeholder": "100",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        }
    ]);

    return dic;
}();

var QoEStorEnvConfigGroupDic =
    {
        "1": {"id": "1", "order": 1, "value": LangHelper.GetString("Dics", "Receivers")},
        "2": {"id": "2", "order": 2, "value": LangHelper.GetString("Dics", "Filtration")},
        "3": {"id": "3", "order": 3, "value": LangHelper.GetString("Dics", "Common")},
        "4": {"id": "4", "order": 4, "value": LangHelper.GetString("Dics", "Ulr settings")},
        "5": {"id": "5", "order": 8, "value": LangHelper.GetString("Dics", "NAT log settings")},
        "6": {"id": "6", "order": 6, "value": LangHelper.GetString("Dics", "FULLFLOW AGG log settings")},
        "7": {"id": "7", "order": 7, "value": LangHelper.GetString("Dics", "CLICKSTREAM AGG log settings")},
        "8": {"id": "8", "order": 9, "value": LangHelper.GetString("Dics", "ONLINEFLOW log settings")},
        "9": {"id": "9", "order": 11, "value": LangHelper.GetString("Dics", "OpenCellID settings")},
        "10": {"id": "10", "order": 12, "value": LangHelper.GetString("Dics", "GTP settings")},
        "11": {"id": "11", "order": 13, "value": LangHelper.GetString("Dics", "UPLINK LOAD RATE settings")},
        "12": {"id": "12", "order": 14, "value": LangHelper.GetString("Dics", "Kaspersky list of infected hosts")},
        "13": {"id": "13", "order": 5, "value": LangHelper.GetString("Dics", "FULLFLOW log settings")},
        "14": {"id": "14", "order": 10, "value": LangHelper.GetString("Dics", "DNS AGG log settings")},
        "15": {"id": "15", "order": 15, "value": LangHelper.GetString("Dics", "Cluster settings")},
        "16": {"id": "16", "order": 16, "value": LangHelper.GetString("Dics", "AAA log settings")},
        "17": {"id": "17", "order": 17, "value": LangHelper.GetString("Dics", "DDoS attack log settings")}
    };

var QoEStorEnvConfigReceiverDic =
    {
        "1.0": {
            "id": "RECEIVER_TYPE", "value": LangHelper.GetString("Dics", "Receiver type"),
            "view": "richselect",
            "options": {
                "1": {"id": "IPFIX_FULLFLOW", "value": LangHelper.GetString("Dics", "Netflow")},
                "2": {"id": "IPFIX_CLICKSTREAM", "value": LangHelper.GetString("Dics", "Clickstream")},
                "3": {"id": "IPFIX_GTPFLOW", "value": LangHelper.GetString("Dics", "GTP flow")},
                "4": {"id": "IPFIX_NATFLOW", "value": LangHelper.GetString("Dics", "NAT flow")},
                "5": {"id": "IPFIX_NATFLOW_NETSTREAM", "value": LangHelper.GetString("Dics", "NAT flow") + " (Netstream)"},
                "6": {"id": "IPFIX_DNSFLOW", "value": LangHelper.GetString("Dics", "DNS flow")},
                "7": {"id": "IPFIX_AAAFLOW", "value": LangHelper.GetString("Dics", "AAA flow")}
            },
            default: "IPFIX_FULLFLOW",
            "tooltip": LangHelper.GetString("Dics", "Receiver type") + ": " + LangHelper.GetString("Dics", "Fullflow or Clickstream") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Fullflow is a receiver for fullflow data") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Clickstream is a receiver for clickstream data") + "<br/><br/>"
        },
        "1.1": {
            "id": "PORT_TYPE", "value": LangHelper.GetString("Dics", "Port type"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "tcp", "value": LangHelper.GetString("Dics", "tcp")},
                    "2": {"id": "udp", "value": LangHelper.GetString("Dics", "udp")}
                },
            default: "tcp",
            "tooltip": LangHelper.GetString("Dics", "Port type") + ": " + LangHelper.GetString("Dics", "tcp or udp") + "<br/><br/>" +
                LangHelper.GetString("Dics", "It`s recommended to use tcp") + "<br/><br/>"
        },
        "1.2": {
            "id": "PORT", "value": LangHelper.GetString("Dics", "Port"),
            "view": "text",
            "placeholder": "1500",
            "default": 1500,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Any port you wish. The main thing that would be different for each thread") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default values are 1500 for fullflow thread and 1501 for clickstream thread")
        },
        "1.3": {
            "id": "ROTATE_MINUTES", "value": LangHelper.GetString("Dics", "Rotate in minutes"),
            "view": "text",
            "placeholder": "10",
            "default": 10,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Receiver dump rotate period or data loading period into the database") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is 10 minutes for fullflow and 12 minutes for clickstream") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Dump rotate period for cliksteam should be greater or equal than the same period for fullflow. When fullflow dump rotates the HUP signal is sent to synchronize threads.") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily"),
            "tooltipHeight": 280
        },
        "1.4": {
            "id": "ROTATE_SECONDS", "value": LangHelper.GetString("Dics", "Rotate in seconds"),
            "view": "text",
            "placeholder": "600",
            "default": 0,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Receiver dump rotate in seconds. The same as the rotation in minutes, only in seconds.") + "<br/><br/><br/>" + LangHelper.GetString("Dics", "If this value is enabled the value in minutes is ignored."),
            "tooltipHeight": 280
        },
        "1.5": {
            "id": "ROTATE_FLOWS", "value": LangHelper.GetString("Dics", "Rotate by flows"),
            "view": "text",
            "placeholder": "600",
            "default": 0,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Rotation by flows records number. Works simultaneously with rotates in minutes or seconds."),
            "tooltipHeight": 280
        },
        "1.6": {
            "id": "ROTATE_DELAY_SECONDS", "value": LangHelper.GetString("Dics", "Delay in seconds"),
            "view": "text",
            "placeholder": "0",
            "default": 0,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Data loading delay into the database") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default values are 0 seconds for fullflow thread and 400 seconds for clickstream thread") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily")
        },
        "1.7": {
            "id": "FW_MAX_QUEUE_SIZE", "value": LangHelper.GetString("Dics", "Queue size"),
            "view": "text",
            "placeholder": "10",
            "default": 10,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Receiver dump loading queue size") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is 10") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily")
        },
        "1.8": {
            "id": "DUMP_INSERT_PROCESSES", "value": LangHelper.GetString("Dics", "Insert processes number"),
            "view": "text",
            "placeholder": "0",
            "default": 0,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Number of dump insert processes") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily")
        },
        "1.9": {
            "id": "EXPORT", "value": LangHelper.GetString("Dics", "Export"),
            "view": "text",
            "placeholder": "10.0.0.2/9920/tcp,10.0.0.3/3440/udp",
            "tooltip": LangHelper.GetString("Dics", "Reciver can export data to other receivers") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Format is") + " 10.0.0.2/9920/tcp,10.0.0.3/3440/udp"
        },
        "1.10": {
            "id": "DPI_ID", "value": LangHelper.GetString("Dics", "DPI ID"),
            "view": "text",
            "placeholder": "-1",
            "default": -1,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "PDI number. If the value is -1 or not specified, then the DPI number is determined by the order of the receiver in the list.") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is -1.") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily"),
            "tooltipHeight": 280
        },
        "1.11": {
            "id": "BALANCER", "value": LangHelper.GetString("Dics", "Balancer"),
            "view": "richselect",
            "options": {
                "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                "2": {"id": "roundrobin", "value": LangHelper.GetString("Dics", "RoundRobin")},
                "3": {"id": "all", "value": LangHelper.GetString("Dics", "All")}
            },
            default: "0",
            "tooltip": LangHelper.GetString("Dics", "Balancer type") + ": " + LangHelper.GetString("Dics", "RoundRobin or All") + "<br/><br/>" +
                LangHelper.GetString("Dics", "RoundRobin mode splits IPFIX flow") + "<br/><br/>" +
                LangHelper.GetString("Dics", "All mode replicate IPFIX flow") + "<br/><br/>"
        },
        "1.12": {
            "id": "BALANCER_SUB", "value": LangHelper.GetString("Dics", "Balancer subreceivers"),
            "view": "text",
            "placeholder": "10.0.0.2/9920,10.0.0.3/3440",
            "tooltip": LangHelper.GetString("Dics", "Balancer can split or replicate data to other receivers") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Format is") + " 10.0.0.2/9920,10.0.0.3/3440"
        },
        "1.13": {
            "id": "BALANCER_SUB_PROTO", "value": LangHelper.GetString("Dics", "Balancer subreceivers type"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "tcp", "value": LangHelper.GetString("Dics", "tcp")},
                    "2": {"id": "udp", "value": LangHelper.GetString("Dics", "udp")}
                },
            default: "tcp",
            "tooltip": LangHelper.GetString("Dics", "Port type") + ": " + LangHelper.GetString("Dics", "tcp or udp") + "<br/><br/>" +
                LangHelper.GetString("Dics", "It`s recommended to use tcp") + "<br/><br/>"
        },
        "1.14": {
            "id": "BALANCER_AUTO", "value": LangHelper.GetString("Dics", "Balancer auto"),
            "view": "richselect",
            "options": {
                "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
            },
            default: "0",
            "tooltip": LangHelper.GetString("Dics", "If Auto mode enabled it will create and start subreceivers automatic")
        },
        "1.15": {
            "id": "BALANCER_TASKSET", "value": LangHelper.GetString("Dics", "Balancer taskset"),
            "view": "text",
            "placeholder": "0",
            "validate": function (Val)
            {
                if(Val == null || Val === "")
                    return true;

                return Val >= 0 && !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "This parameter is responsible for determining which core QoE Stor is running on.") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is 0."),
            "tooltipHeight": 280
        },
    };

var QoEStorEnvConfigReceiversDic = function () {
    var dic = {};

    function AddDic(Type, Id, ReceiverDicId, Title) {
        dic[Id] =
            {
                "id": Type + "_" + QoEStorEnvConfigReceiverDic[ReceiverDicId].id + "[i]",
                "group": "1",
                "value": LangHelper.GetString("Dics", Title) + " (" + Type + "_" + QoEStorEnvConfigReceiverDic[ReceiverDicId].id + "[i])",
                "view": QoEStorEnvConfigReceiverDic[ReceiverDicId].view,
                "options": QoEStorEnvConfigReceiverDic[ReceiverDicId].options,
                "placeholder": QoEStorEnvConfigReceiverDic[ReceiverDicId].placeholder,
                "default": QoEStorEnvConfigReceiverDic[ReceiverDicId].default,
                "validate": QoEStorEnvConfigReceiverDic[ReceiverDicId].validate,
                "invalidMessage": QoEStorEnvConfigReceiverDic[ReceiverDicId].invalidMessage,
                "tooltip": QoEStorEnvConfigReceiverDic[ReceiverDicId].tooltip
            };
    }

    var index = 1;
    var options = [
        {ReceiverDicId: "1.1", Title: "Port type"},
        {ReceiverDicId: "1.2", Title: "Port number"},
        {ReceiverDicId: "1.3", Title: "Rotate in minutes"},
        {ReceiverDicId: "1.4", Title: "Rotate in seconds"},
        {ReceiverDicId: "1.5", Title: "Rotate by flows"},
        {ReceiverDicId: "1.6", Title: "Delay in seconds"},
        {ReceiverDicId: "1.7", Title: "Queue size"},
        {ReceiverDicId: "1.8", Title: "Insert processes number"},
        {ReceiverDicId: "1.9", Title: "Export"},
        {ReceiverDicId: "1.10", Title: "DPI ID"},
        {ReceiverDicId: "1.11", Title: "Balancer"},
        {ReceiverDicId: "1.12", Title: "Balancer subreceivers"},
        {ReceiverDicId: "1.13", Title: "Balancer subreceivers type"},
        {ReceiverDicId: "1.14", Title: "Balancer auto"},
        {ReceiverDicId: "1.15", Title: "Balancer taskset"},
    ];

    var process_rec = function(Type)
    {
        options.forEach(function(Val){
            AddDic(Type, "1." + String(index), Val.ReceiverDicId, Val.Title)
            index++;
        });
    }

    process_rec("IPFIX_FULLFLOW");
    process_rec("IPFIX_CLICKSTREAM");
    process_rec("IPFIX_GTPFLOW");
    process_rec("IPFIX_NATFLOW");
    process_rec("IPFIX_NATFLOW_NETSTREAM");
    process_rec("IPFIX_DNSFLOW");
    process_rec("IPFIX_AAAFLOW");

    return dic;
}();

const QoEStorEnvConfigClusterDic =
{
    "1.0": {
        "id": "CH_SHARD_REPLICAS", "value": LangHelper.GetString("Dics", "Replicas"),
        "view": "text",
        "placeholder": "127.0.0.1/9000/user/password,127.0.0.2/9000/user/password",
        "default": "",
        "validate": function (Val) {
            if (Val)
            {
                const shardReplicasSplit = Val.split(",");

                for (const item of shardReplicasSplit) {
                    const itemSplit = item.split("/");

                    if (itemSplit.length !== 4)
                        return false;

                    let [host, port, user, password] = itemSplit

                    if (!Helper.ValidateIPv4OrIPv6(host))
                        return false;

                    if (!Helper.isConvertibleToNumber(port))
                        return false;

                }
            }
            else
                return false;

            return true;
        },
        "invalidMessage": `${LangHelper.GetString("Dics", "Enter the correct IP address,port number, user and password")}.`,
        "tooltip": `${LangHelper.GetString("Dics", "In each shard, you can set multiple replicas, Use comma to add several items.")}<br/><br/>
            ${LangHelper.GetString("Dics", "The replica is set in host/port/user/password format")}.<br/><br/>
            ${LangHelper.GetString("HotSpot", "Example")}: 127.0.0.1/9000/user/password,<br/>127.0.0.2/9000/user/password.`
    },
};

var QoEStorEnvConfigDic = function () {
    var dic = {};

    var clAddToDic = function (Group, Arr) {
        Arr.forEach(function (Item, Index) {
            var key = Group + "." + (Index + 1);
            dic[key] = Item;
            dic[key].group = Group + "";
        });
    };

    //Group 2
    clAddToDic(2, [
        {
            "id": "TRAFFIC_DIR_DEF_MODE",
            "group": "2",
            "value": LangHelper.GetString("Dics", "Traffic direction definition") + " (TRAFFIC_DIR_DEF_MODE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "As is")},
                    "2": {
                        "id": "1",
                        "value": LangHelper.GetString("Dics", "By AS") + " (" + LangHelper.GetString("Dics", "For fullflow only") + ")"
                    },
                    "3": {
                        "id": "2",
                        "value": LangHelper.GetString("Dics", "By CIDR") + " (" + LangHelper.GetString("Dics", "For fullflow and clickstream") + ")"
                    },
                    "4": {"id": "3", "value": LangHelper.GetString("Dics", "By both: AS and CIDR")},
                    "5": {"id": "4", "value": LangHelper.GetString("Dics", "By any: AS or CIDR")}
                },
            "tooltip": LangHelper.GetString("Dics", "Traffic direction definition") + "<br/><br/>" +
                LangHelper.GetString("Dics", "0 - 'As is' - The direction of traffic does not change and is determined by the DPI") + "<br/><br/>" +
                LangHelper.GetString("Dics", "1 - 'By AS' - The direction of traffic is determined by the list of operator`s AS specified in the dictionary") + "<br/><br/>" +
                LangHelper.GetString("Dics", "2 - 'By CIDR' - The direction of traffic is determined by the CIDRs list specified in the dictionary") + "<br/><br/>" +
                LangHelper.GetString("Dics", "3 - 'By both: AS and CIDR'") + "<br/><br/>" +
                LangHelper.GetString("Dics", "4 - 'By any: AS or CIDR'"),
            "tooltipWidth":400,
            "tooltipHeight":400
        },
        {
            "id": "SUBSCRIBER_FILTER_MODE",
            "group": "2",
            "value": LangHelper.GetString("Dics", "Subscribers filter") + " (SUBSCRIBER_FILTER_MODE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "No filter")},
                    "2": {
                        "id": "1",
                        "value": LangHelper.GetString("Dics", "By AS") + " (" + LangHelper.GetString("Dics", "For fullflow only") + ")"
                    },
                    "3": {
                        "id": "2",
                        "value": LangHelper.GetString("Dics", "By CIDR") + " (" + LangHelper.GetString("Dics", "For fullflow and clickstream") + ")"
                    },
                    "4": {"id": "3", "value": LangHelper.GetString("Dics", "By both: AS and CIDR")},
                    "5": {"id": "4", "value": LangHelper.GetString("Dics", "By any: AS or CIDR")}
                },
            "tooltip": LangHelper.GetString("Dics", "Subscribers filter") + "<br/><br/>" +
                LangHelper.GetString("Dics", "0 - 'No filter' - No filtration applied, all flow data is saved") + "<br/><br/>" +
                LangHelper.GetString("Dics", "1 - 'By AS' - The flow data is filtering by the list of operator`s AS specified in the dictionary") + "<br/><br/>" +
                LangHelper.GetString("Dics", "2 - 'By CIDR' - The flow data is filtering by the CIDRs list specified in the dictionary") + "<br/><br/>" +
                LangHelper.GetString("Dics", "3 - 'By both: AS and CIDR'") + "<br/><br/>" +
                LangHelper.GetString("Dics", "4 - 'By any: AS or CIDR'"),
            "tooltipWidth":400,
            "tooltipHeight":400
        },
        {
            "id": "SUBSCRIBER_EXCLUDE_MODE",
            "group": "2",
            "value": LangHelper.GetString("Dics", "Exclusions from the subscribers filter") + " (SUBSCRIBER_EXCLUDE_MODE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "No exclude")},
                    "2": {
                        "id": "1",
                        "value": LangHelper.GetString("Dics", "By AS") + " (" + LangHelper.GetString("Dics", "For fullflow only") + ")"
                    },
                    "3": {
                        "id": "2",
                        "value": LangHelper.GetString("Dics", "By CIDR") + " (" + LangHelper.GetString("Dics", "For fullflow and clickstream") + ")"
                    },
                    "4": {"id": "3", "value": LangHelper.GetString("Dics", "By both: AS and CIDR")},
                    "5": {"id": "4", "value": LangHelper.GetString("Dics", "By any: AS or CIDR")}
                },
            "tooltip": LangHelper.GetString("Dics", "Exclusions from the subscribers filter") + "<br/><br/>" +
                LangHelper.GetString("Dics", "0 - 'No exclude' - No exclusion applied") + "<br/><br/>" +
                LangHelper.GetString("Dics", "1 - 'By AS' - Exclusions are applied to the AS list of the operator specified in the dictionary") + "<br/><br/>" +
                LangHelper.GetString("Dics", "2 - 'By CIDR' - Exclusions are applied to the CIDRs list of the operator specified in the dictionary") + "<br/><br/>" +
                LangHelper.GetString("Dics", "3 - 'By both: AS and CIDR'") + "<br/><br/>" +
                LangHelper.GetString("Dics", "4 - 'By any: AS or CIDR'"),
            "tooltipWidth":400,
            "tooltipHeight":400
        },
        {
            "id": "SUBSCRIBER_BIND_MODE",
            "group": "2",
            "value": LangHelper.GetString("Dics", "Subscribers bind mode") + " (SUBSCRIBER_BIND_MODE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Binding by LOGIN if not empty or IP (default)")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "By IP")},
                    "3": {"id": "2", "value": LangHelper.GetString("Dics", "By LOGIN")}
                },
            "tooltip": LangHelper.GetString("Dics", "Subscribers bind mode") + "<br/><br/>" +
                LangHelper.GetString("Dics", "0 - 'Default' - Binding by LOGIN if not empty or IP") + "<br/><br/>" +
                LangHelper.GetString("Dics", "1 - 'By IP'") + "<br/><br/>" +
                LangHelper.GetString("Dics", "2 - 'By LOGIN'"),
            "tooltipWidth":400,
            "tooltipHeight":400
        }
    ]);

    //Group 3
    clAddToDic(3, [
        {
            "id": "ENABLE_AUTOUPDATE",
            "group": "3",
            "value": LangHelper.GetString("Dics", "QoE Stor (fastor) autoupdate") + " (ENABLE_AUTOUPDATE)" + " " + LangHelper.GetString("Dics", "Under construction!"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables QoE Stor (fastor) autoupdate") + "." + " " + LangHelper.GetString("Dics", "Under construction!")
        },
        {
            "id": "VAS_CLOUD_HOST",
            "group": "14",
            "value": LangHelper.GetString("Dics", "VAS Cloud host") + " (VAS_CLOUD_HOST)",
            "view": "text",
            "placeholder": "cloud.vasexperts.ru",
            "tooltip": LangHelper.GetString("Dics", "VAS Cloud host") + ".<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "VAS_CLOUD_API_TOKEN",
            "group": "14",
            "value": LangHelper.GetString("Dics", "VAS Cloud API token") + " (VAS_CLOUD_API_TOKEN)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "VAS Cloud API token") + ".<br/><br/>" + LangHelper.GetString("Dics", "If a token is specified, authorization is performed using the token. If not specified, by login and password.")
        },
        {
            "id": "URLS_CATEGORIES_DIC_AUTOLOAD_ENABLED",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Autoload of hosts (urls) categories dictionaries") + " (URLS_CATEGORIES_DIC_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables autoload of hosts (urls) categories dictionaries") + "."
        },
        {
            "id": "URLS_CATEGORIES_DIC_URL",
            "group": "3",
            "value": LangHelper.GetString("Dics", "URL for downloading of hosts (urls) categories dictionaries") + " (URLS_CATEGORIES_DIC_URL)",
            "view": "text",
            "placeholder":"https://cloud.vasexperts.ru/api/clsfr",
            "tooltip": LangHelper.GetString("Dics", "URL for downloading of hosts (urls) categories dictionaries") + "<br/><br/>" + LangHelper.GetString("Dics", "Default value") + ": https://cloud.vasexperts.ru/api/clsfr"
        },
        {
            "id": "ASNUM_DIC_AUTOLOAD_ENABLED",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Autoload AS numbers dictionary") + " (ASNUM_DIC_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables autoload of AS numbers dictionary") + "."
        },
        {
            "id": "PRTCLS_DIC_AUTOLOAD_ENABLED",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Autoload protocols dictionary") + " (PRTCLS_DIC_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables autoload of applications protocols dictionary") + ".<br/><br/>" + LangHelper.GetString("Dics", "Enabled by default") + "."
        },
        {
            "id": "PRTCLS_DIC_URL",
            "group": "3",
            "value": LangHelper.GetString("Dics", "URL for downloading protocols dictionary") + " (PRTCLS_DIC_URL)",
            "view": "text",
            "placeholder":"https://cloud.vasexperts.ru/api/prtcls",
            "tooltip": LangHelper.GetString("Dics", "URL for downloading application protocols dictionary") + "<br/><br/>" + LangHelper.GetString("Dics", "Default value") + ": https://cloud.vasexperts.ru/api/prtcls"
        },
        {
            "id": "COMPANY_PRTCLS_DIC_AUTOLOAD_ENABLED",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Autoload company protocols dictionary") + " (COMPANY_PRTCLS_DIC_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables autoload of applications company protocols dictionary") + ".<br/><br/>" + LangHelper.GetString("Dics", "Enabled by default") + "."
        },
        {
            "id": "COMPANY_PRTCLS_DIC_URL",
            "group": "3",
            "value": LangHelper.GetString("Dics", "URL for downloading company protocols dictionary") + " (COMPANY_PRTCLS_DIC_URL)",
            "view": "text",
            "placeholder":"https://cloud.vasexperts.ru/api/company_prtcls/qoe/{YOUR_COMPANY_CODE}",
            "tooltip": LangHelper.GetString("Dics", "URL for downloading company protocols dictionary") + "<br/><br/>" + LangHelper.GetString("Dics", "Default value") + ": https://cloud.vasexperts.ru/api/company_prtcls/qoe/{YOUR_COMPANY_CODE}",
            "tooltipWidth": 600,
            "custom_helper":[
                {
                    view: "button",
                    id: "COMPANY_PRTCLS_DIC_URL_BUTTON",
                    type: "icon",
                    icon: "reply",
                    css: "toolbar_round_btn",
                    width: 32
                }
            ]
        },
        {
            "id": "COMPANY_PRTCLS_GROUPS_DIC_URL",
            "group": "3",
            "value": LangHelper.GetString("Dics", "URL for downloading company protocol groups dictionary") + " (COMPANY_PRTCLS_GROUPS_DIC_URL)",
            "view": "text",
            "placeholder":"https://cloud.vasexperts.ru/api/company_prtcls_groups/qoe/{YOUR_COMPANY_CODE}",
            "tooltip": LangHelper.GetString("Dics", "URL for downloading company protocol groups dictionary") + "<br/><br/>" + LangHelper.GetString("Dics", "Default value") + ": https://cloud.vasexperts.ru/api/company_prtcls_groups/qoe/{YOUR_COMPANY_CODE}",
            "tooltipWidth": 600,
            "custom_helper":[
                {
                    view: "button",
                    id: "COMPANY_PRTCLS_GROUPS_DIC_URL_BUTTON",
                    type: "icon",
                    icon: "reply",
                    css: "toolbar_round_btn",
                    width: 32
                }
            ]
        },
        {
            "id": "CUSTOM_PRTCLS_DIC_AUTOLOAD_ENABLED",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Autoload custom protocols dictionary") + " (CUSTOM_PRTCLS_DIC_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables autoload of custom applications protocols dictionary") + ".<br/><br/>" + LangHelper.GetString("Dics", "Enabled by default") + "."
        },
        {
            "id": "CUSTOM_PRTCLS_DIC_URL",
            "group": "3",
            "value": LangHelper.GetString("Dics", "URL for downloading custom protocols dictionary") + " (CUSTOM_PRTCLS_DIC_URL)",
            "view": "text",
            "placeholder":"https://cloud.vasexperts.ru/api/custom_prtcls/qoe/{YOUR_COMPANY_CODE}/prod",
            "tooltip": LangHelper.GetString("Dics", "URL for downloading custom application protocols dictionary") + "<br/><br/>" + LangHelper.GetString("Dics", "Default value") + ": https://cloud.vasexperts.ru/api/custom_prtcls/qoe/{YOUR_COMPANY_CODE}/prod",
            "tooltipWidth": 600,
            "custom_helper":[
                {
                    view: "button",
                    id: "CUSTOM_PRTCLS_DIC_URL_BUTTON",
                    type: "icon",
                    icon: "reply",
                    css: "toolbar_round_btn",
                    width: 32
                }
            ]
        },
        {
            "id": "CUSTOM_PRTCLS_GRPS_DIC_URL",
            "group": "3",
            "value": LangHelper.GetString("Dics", "URL for downloading custom protocol groups dictionary") + " (CUSTOM_PRTCLS_GRPS_DIC_URL)",
            "view": "text",
            "placeholder":"https://cloud.vasexperts.ru/api/custom_prtcls_groups/qoe/{YOUR_COMPANY_CODE}/prod",
            "tooltip": LangHelper.GetString("Dics", "URL for downloading custom application protocol groups dictionary") + "<br/><br/>" + LangHelper.GetString("Dics", "Default value") + ": https://cloud.vasexperts.ru/api/custom_prtcls_groups/qoe/{YOUR_COMPANY_CODE}/prod",
            "tooltipWidth": 600,
            "custom_helper":[
                {
                    view: "button",
                    id: "CUSTOM_PRTCLS_GRPS_DIC_URL_BUTTON",
                    type: "icon",
                    icon: "reply",
                    css: "toolbar_round_btn",
                    width: 32
                }
            ]
        },
        {
            "id": "MCC_MNC_DIC_AUTOLOAD_ENABLED",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Autoload MCC and MNC dictionaries") + " (MCC_MNC_DIC_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled") + " (" + LangHelper.GetString("Dics", "Default value") + ")"},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables autoload of MCC and MNC dictionaries") + ".<br/><br/>" + LangHelper.GetString("Dics", "Disabled by default") + "."
        },
        {
            "id": "PREFIX_ASNUM_DIC_AUTOLOAD_ENABLED",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Autoload AS numbers prefixes dictionary") + " (PREFIX_ASNUM_DIC_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables autoload of AS numbers prefixes dictionary") + "."
        },
        {
            "id": "PREFIX_ASNUM_DIC_URL",
            "group": "3",
            "value": LangHelper.GetString("Dics", "URL for downloading AS numbers prefixes dictionary") + " (PREFIX_ASNUM_DIC_URL)",
            "view": "text",
            "placeholder":"https://cloud.vasexperts.ru/api/asnum_bin",
            "tooltip": LangHelper.GetString("Dics", "URL for downloading AS numbers prefixes dictionary") + "<br/><br/>" + LangHelper.GetString("Dics", "Default value") + ": https://cloud.vasexperts.ru/api/asnum_bin",
            "tooltipWidth": 600
        },
        {
            "id": "USE_PREFIX_ASNUM_DIC_IN_INSERTS",
            "group": "3",
            "value": LangHelper.GetString("Dics", "Use AS number prefixes in inserts") + " (USE_PREFIX_ASNUM_DIC_IN_INSERTS)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Don`t use")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Use")}
                },
            "tooltip": LangHelper.GetString("Dics", "Use AS number prefixes in inserts") + "."
        }
    ]);

    //Group 4
    clAddToDic(4, [
        {
            "id": "ULR_REPLACE_LOGIN_WITH_VCHANNEL",
            "group": "4",
            "value": LangHelper.GetString("Dics", "Replacing Login with Vchannel") + " (ULR_REPLACE_LOGIN_WITH_VCHANNEL)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")},
                    "3": {"id": "2", "value": LangHelper.GetString("Dics", "Enabled if Login is empty")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enable auto replacing Login with vchannel on insert") + "."
        },
        {
            "id": "ULR_USE_DIC_WHEN_REPLACING_LOGIN",
            "group": "4",
            "value": LangHelper.GetString("Dics", "Use dictionary when replacing Login") + " (ULR_USE_DIC_WHEN_REPLACING_LOGIN)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Use dictionary when replacing Login") + "."
        },
        {
            "id": "ULR_VCHANNEL_NAME_DIC_AUTOLOAD_ENABLED",
            "group": "4",
            "value": LangHelper.GetString("Dics", "Vchannels names dic autoload") + " (ULR_VCHANNEL_NAME_DIC_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Vchannels names dic autoload") + "."
        },
        {
            "id": "ULR_VCHANNEL_NAME_DIC_URL",
            "group": "4",
            "value": LangHelper.GetString("Dics", "Vchannels names dic url") + " (ULR_VCHANNEL_NAME_DIC_URL)",
            "view": "text",
            "validate": function (Val) {
                return ConfigHelper.IsValidUrlOrFilePath(Val);
            },
            "tooltip": LangHelper.GetString("Dics", "Vchannels names dic url") + ".",
            "invalidMessage": LangHelper.GetString("Dics", "Enter the correct url")
        }
    ]);

    //Group 5
    clAddToDic(5, [
        {
            "id": "NAT_IMPORT_FROM_FULLFLOW",
            "value": LangHelper.GetString("Dics", "Import NAT events from fullflow") + " (NAT_IMPORT_FROM_FULLFLOW)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Import NAT events from fullflow")
        },
        {
            "id": "NAT_AGG_LOG_FIELDS_TO_SAVE_BITMASK",
            "value": LangHelper.GetString("Dics", "Fields to save when aggregating NAT log") + " (NAT_AGG_LOG_FIELDS_TO_SAVE_BITMASK)",
            "view": "multiselectBitMask",
            "params":{
                "maskFormat":"hex"
            },
            "options":
                {
                    "0x1": {"id": "0x1", "value": "0x1 - " + LangHelper.GetString("Dics", "Protocol ID")},
                    "0x2": {"id": "0x2", "value": "0x2 - " + LangHelper.GetString("Dics", "Event type")},
                    "0x4": {"id": "0x4", "value": "0x4 - " + LangHelper.GetString("Dics", "Source IPv4")},
                    "0x8": {"id": "0x8", "value": "0x8 - " + LangHelper.GetString("Dics", "Source port")},
                    "0x10": {"id": "0x10", "value": "0x10 - " + LangHelper.GetString("Dics", "Destination IPv4")},
                    "0x20": {"id": "0x20", "value": "0x20 - " + LangHelper.GetString("Dics", "Destination port")},
                    "0x40": {"id": "0x40", "value": "0x40 - " + LangHelper.GetString("Dics", "Post NAT source IPv4")},
                    "0x80": {"id": "0x80", "value": "0x80 - " + LangHelper.GetString("Dics", "Post NAT source port")},
                    "0x100": {"id": "0x100", "value": "0x100 - " + LangHelper.GetString("Dics", "Session ID")},
                    "0x200": {"id": "0x200", "value": "0x200 - " + LangHelper.GetString("Dics", "Login")},
                    "0x400": {"id": "0x400", "value": "0x400 - " + LangHelper.GetString("Dics", "DPI ID")}
                },
            "tooltip": LangHelper.GetString("Dics", "Fields to save when aggregating NAT log") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x654" + "." + "<br/><br/>" +
                //LangHelper.GetString("Dics", "0 - Don`t save ports") + "<br/><br/>" +
                "0x1 - " + LangHelper.GetString("Dics", "Protocol ID") + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "Event type") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Source IPv4") + "<br/><br/>" +
                "0x8 - " + LangHelper.GetString("Dics", "Source port") + "<br/><br/>" +
                "0x10 - " + LangHelper.GetString("Dics", "Destination IPv4") + "<br/><br/>" +
                "0x20 - " + LangHelper.GetString("Dics", "Destination port") + "<br/><br/>" +
                "0x40 - " + LangHelper.GetString("Dics", "Post NAT source IPv4") + "<br/><br/>" +
                "0x80 - " + LangHelper.GetString("Dics", "Post NAT source port") + "<br/><br/>" +
                "0x100 - " + LangHelper.GetString("Dics", "Session ID") + "<br/><br/>" +
                "0x200 - " + LangHelper.GetString("Dics", "Login") + "<br/><br/>" +
                "0x400 - " + LangHelper.GetString("Dics", "DPI ID"),
            "tooltipWidth":480,
            "tooltipHeight":480
        },
        {
            "id": "NAT_AGG_LOG_GROUP_TIME_INTERVAL",
            "value": LangHelper.GetString("Dics", "Time interval for aggregating NAT logs") + " (NAT_AGG_LOG_GROUP_TIME_INTERVAL)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "1 minute")},
                    "2": {"id": "5", "value": LangHelper.GetString("Dics", "5 minutes")},
                    "3": {"id": "10", "value": LangHelper.GetString("Dics", "10 minutes")},
                    "4": {"id": "15", "value": LangHelper.GetString("Dics", "15 minutes") + " ("+LangHelper.GetString("Dics", "By default")+")"},
                    "5": {"id": "30", "value": LangHelper.GetString("Dics", "30 minutes")},
                    "6": {"id": "60", "value": LangHelper.GetString("Dics", "60 minutes")}
                },
            "tooltip": LangHelper.GetString("Dics", "Time interval for aggregating NAT logs")
        },
        {
            "id": "FILL_IP_LOGIN_BINDING_FROM_FULLFLOW",
            "value": LangHelper.GetString("Dics", "Enable filling IP-LOGIN bind from fullflow") + " (FILL_IP_LOGIN_BINDING_FROM_FULLFLOW)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enable filling IP-LOGIN bind from fullflow")
        },
        {
            "id": "NAT_ADD_LOGIN_FROM_IP_LOGIN_BINDING",
            "value": LangHelper.GetString("Dics", "Enable adding LOGIN to NAT log from IP-LOGIN binding") + " (NAT_ADD_LOGIN_FROM_IP_LOGIN_BINDING)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")},
                    "3": {"id": "2", "value": LangHelper.GetString("Dics", "Enabled if Login is empty")}

                },
            "tooltip": LangHelper.GetString("Dics", "Enable adding LOGIN to NAT log from IP-LOGIN binding")
        },
        {
            "id": "NAT_USE_DISTR_IP_LOGIN_BINDING",
            "value": LangHelper.GetString("Dics", "Use distributed IP-LOGIN binding table") + " (NAT_USE_DISTR_IP_LOGIN_BINDING)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}

                },
            "tooltip": LangHelper.GetString("Dics", "Use distributed IP-LOGIN binding table")
        }
    ]);

    //Group 6
    clAddToDic(6, [
        {
            "id": "FULLFLOW_AGG_LOG_FIELDS_TO_SAVE_BITMASK",
            "value": LangHelper.GetString("Dics", "Fields to save when aggregating FULLFLOW log") + " (FULLFLOW_AGG_LOG_FIELDS_TO_SAVE_BITMASK)",
            "view": "multiselectBitMask",
            "params":{
                "maskFormat":"hex"
            },
            "options":
                {
                    "0x1": {"id": "0x1", "value": "0x1 - " + LangHelper.GetString("Dics", "Source IP")},
                    "0x2": {"id": "0x2", "value": "0x2 - " + LangHelper.GetString("Dics", "Destination IP")},
                    "0x4": {"id": "0x4", "value": "0x4 - " + LangHelper.GetString("Dics", "Source AS number")},
                    "0x8": {"id": "0x8", "value": "0x8 - " + LangHelper.GetString("Dics", "Destination AS number")},
                    "0x10": {"id": "0x10", "value": "0x10 - " + LangHelper.GetString("Dics", "Source AS title")},
                    "0x20": {"id": "0x20", "value": "0x20 - " + LangHelper.GetString("Dics", "Destination AS title")},
                    "0x40": {"id": "0x40", "value": "0x40 - " + LangHelper.GetString("Dics", "Subscriber")},
                    "0x80": {"id": "0x80", "value": "0x80 - " + LangHelper.GetString("Dics", "Subscriber login")},
                    "0x100": {"id": "0x100", "value": "0x100 - " + LangHelper.GetString("Dics", "Login")},
                    "0x200": {"id": "0x200", "value": "0x200 - " + LangHelper.GetString("Dics", "Host IP")},
                    "0x400": {"id": "0x400", "value": "0x400 - " + LangHelper.GetString("Dics", "Host")},
                    "0x800": {"id": "0x800", "value": "0x800 - " + LangHelper.GetString("Dics", "Protocol code")},
                    "0x1000": {"id": "0x1000", "value": "0x1000 - " + LangHelper.GetString("Dics", "Protocol identifier")},
                    "0x2000": {"id": "0x2000", "value": "0x2000 - " + LangHelper.GetString("Dics", "Post NAT source IPv4")},
                    "0x4000": {"id": "0x4000", "value": "0x4000 - " + LangHelper.GetString("Dics", "Post NAT port")},
                    "0x8000": {"id": "0x8000", "value": "0x8000 - " + LangHelper.GetString("Dics", "DPI ID")},
                    "0x10000": {"id": "0x10000", "value": "0x10000 - " + LangHelper.GetString("Dics", "Vchannel")},
                    "0x20000": {"id": "0x20000", "value": "0x20000 - " + LangHelper.GetString("Dics", "IP class of service")},
                    "0x40000": {"id": "0x40000", "value": "0x40000 - " + LangHelper.GetString("QoE", "MPLS labels")},
                    "0x80000": {"id": "0x80000", "value": "0x80000 - " + LangHelper.GetString("Dics", "Blocked traffic")},
                    "0x100000": {"id": "0x100000", "value": "0x100000 - " + LangHelper.GetString("Dics", "Tethering")}
                },
            "tooltip": LangHelper.GetString("Dics", "Fields to save when aggregating FULLFLOW log") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x1b9fff" + "." + "<br/><br/>" +
                "0x1 - " + LangHelper.GetString("Dics", "Source IP") + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "Destination IP") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Source AS number") + "<br/><br/>" +
                "0x8 - " + LangHelper.GetString("Dics", "Destination AS number") + "<br/><br/>" +
                "0x10 - " + LangHelper.GetString("Dics", "Source AS title") + "<br/><br/>" +
                "0x20 - " + LangHelper.GetString("Dics", "Destination AS title") + "<br/><br/>" +
                "0x40 - " + LangHelper.GetString("Dics", "Subscriber") + "<br/><br/>" +
                "0x80 - " + LangHelper.GetString("Dics", "Subscriber login") + "<br/><br/>" +
                "0x100 - " + LangHelper.GetString("Dics", "Login") + "<br/><br/>" +
                "0x200 - " + LangHelper.GetString("Dics", "Host IP") + "<br/><br/>" +
                "0x400 - " + LangHelper.GetString("Dics", "Host") + "<br/><br/>" +
                "0x800 - " + LangHelper.GetString("Dics", "Protocol code") + "<br/><br/>" +
                "0x1000 - " + LangHelper.GetString("Dics", "Protocol identifier") + "<br/><br/>" +
                "0x2000 - " + LangHelper.GetString("Dics", "Post NAT source IPv4") + "<br/><br/>" +
                "0x4000 - " + LangHelper.GetString("Dics", "Post NAT port") + "<br/><br/>" +
                "0x8000 - " + LangHelper.GetString("Dics", "DPI ID") + "<br/><br/>" +
                "0x10000 - " + LangHelper.GetString("Dics", "Vchannel") + "<br/><br/>" +
                "0x20000 - " + LangHelper.GetString("Dics", "IP class of service") + "<br/><br/>" +
                "0x40000 - " + LangHelper.GetString("QoE", "MPLS labels") + "<br/><br/>" +
                "0x80000 - " + LangHelper.GetString("Dics", "Blocked traffic") + "<br/><br/>" +
                "0x100000 - " + LangHelper.GetString("Dics", "Tethering"),
            "tooltipWidth":480,
            "tooltipHeight":800
        },
        {
            "id": "FULLFLOW_AGG_LOG_GROUP_TIME_INTERVAL",
            "value": LangHelper.GetString("Dics", "Time interval for aggregating FULLFLOW logs") + " (FULLFLOW_AGG_LOG_GROUP_TIME_INTERVAL)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "1 minute")},
                    "2": {"id": "5", "value": LangHelper.GetString("Dics", "5 minutes")},
                    "3": {"id": "10", "value": LangHelper.GetString("Dics", "10 minutes")},
                    "4": {"id": "15", "value": LangHelper.GetString("Dics", "15 minutes") + " ("+LangHelper.GetString("Dics", "By default")+")"},
                    "5": {"id": "30", "value": LangHelper.GetString("Dics", "30 minutes")},
                    "6": {"id": "60", "value": LangHelper.GetString("Dics", "60 minutes")}
                },
            "tooltip": LangHelper.GetString("Dics", "Time interval for aggregating FULLFLOW logs")
        },
    ]);

    //Group 7
    clAddToDic(7, [
        {
            "id": "CLICKSTREAM_AGG_LOG_FIELDS_TO_SAVE_BITMASK",
            "value": LangHelper.GetString("Dics", "Fields to save when aggregating CLICKSTREAM log") + " (CLICKSTREAM_AGG_LOG_FIELDS_TO_SAVE_BITMASK)",
            "view": "multiselectBitMask",
            "params":{
                "maskFormat":"hex"
            },
            "options":
                {
                    "0x1": {"id": "0x1", "value": "0x1 - " + LangHelper.GetString("Dics", "Subscriber")},
                    "0x2": {"id": "0x2", "value": "0x2 - " + LangHelper.GetString("Dics", "Subscriber login")},
                    "0x4": {"id": "0x4", "value": "0x4 - " + LangHelper.GetString("Dics", "Login")},
                    "0x8": {"id": "0x8", "value": "0x8 - " + LangHelper.GetString("Dics", "Host")},
                    "0x10": {"id": "0x10", "value": "0x10 - " + LangHelper.GetString("Dics", "Host IP")},
                    "0x20": {"id": "0x20", "value": "0x20 - " + LangHelper.GetString("Dics", "Device")},
                    "0x40": {"id": "0x40", "value": "0x40 - " + LangHelper.GetString("Dics", "Referal")},
                    "0x80": {"id": "0x80", "value": "0x80 - " + LangHelper.GetString("Dics", "User agent")},
                    "0x100": {"id": "0x100", "value": "0x100 - " + LangHelper.GetString("Dics", "Cookie")},
                    "0x200": {"id": "0x200", "value": "0x200 - " + LangHelper.GetString("Dics", "Method")},
                    "0x400": {"id": "0x400", "value": "0x400 - " + LangHelper.GetString("Dics", "Result code")},
                    "0x800": {"id": "0x800", "value": "0x800 - " + LangHelper.GetString("Dics", "Content type")},
                    "0x1000": {"id": "0x1000", "value": "0x1000 - " + LangHelper.GetString("Dics", "DPI ID")},
                    "0x2000": {"id": "0x2000", "value": "0x2000 - " + LangHelper.GetString("Dics", "Vchannel")},
                    "0x4000": {"id": "0x4000", "value": "0x4000 - " + LangHelper.GetString("Dics", "Locked")}
                },
            "tooltip": LangHelper.GetString("Dics", "Fields to save when aggregating CLICKSTREAM log") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x19fff" + "." + "<br/><br/>" +
                "0x1 - " + LangHelper.GetString("Dics", "Subscriber") + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "Subscriber login") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Login") + "<br/><br/>" +
                "0x8 - " + LangHelper.GetString("Dics", "Host") + "<br/><br/>" +
                "0x10 - " + LangHelper.GetString("Dics", "Host IP") + "<br/><br/>" +
                "0x20 - " + LangHelper.GetString("Dics", "Device") + "<br/><br/>" +
                "0x40 - " + LangHelper.GetString("Dics", "Referal") + "<br/><br/>" +
                "0x80 - " + LangHelper.GetString("Dics", "User agent") + "<br/><br/>" +
                "0x100 - " + LangHelper.GetString("Dics", "Cookie") + "<br/><br/>" +
                "0x200 - " + LangHelper.GetString("Dics", "Method") + "<br/><br/>" +
                "0x400 - " + LangHelper.GetString("Dics", "Result code") + "<br/><br/>" +
                "0x800 - " + LangHelper.GetString("Dics", "Content type") + "<br/><br/>" +
                "0x1000 - " + LangHelper.GetString("Dics", "DPI ID") + "<br/><br/>" +
                "0x2000 - " + LangHelper.GetString("Dics", "Vchannel") + "<br/><br/>" +
                "0x4000 - " + LangHelper.GetString("Dics", "Locked"),
            "tooltipWidth":480,
            "tooltipHeight":800
        },
        {
            "id": "CLICKSTREAM_AGG_LOG_GROUP_TIME_INTERVAL",
            "value": LangHelper.GetString("Dics", "Time interval for aggregating CLICKSTREAM logs") + " (CLICKSTREAM_AGG_LOG_GROUP_TIME_INTERVAL)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "1 minute")},
                    "2": {"id": "5", "value": LangHelper.GetString("Dics", "5 minutes")},
                    "3": {"id": "10", "value": LangHelper.GetString("Dics", "10 minutes")},
                    "4": {"id": "15", "value": LangHelper.GetString("Dics", "15 minutes") + " ("+LangHelper.GetString("Dics", "By default")+")"},
                    "5": {"id": "30", "value": LangHelper.GetString("Dics", "30 minutes")},
                    "6": {"id": "60", "value": LangHelper.GetString("Dics", "60 minutes")}
                },
            "tooltip": LangHelper.GetString("Dics", "Time interval for aggregating CLICKSTREAM logs")
        },
        {
            "id": "CLICKSTREAM_ADD_INFO_FROM_FULLFLOW",
            "value": LangHelper.GetString("Dics", "Add data from FULLFLOW") + " (CLICKSTREAM_ADD_INFO_FROM_FULLFLOW)",
            "view": "richselect",
            "options":
                {
                    "0": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled") + " ("+LangHelper.GetString("Dics", "By default")+")"}
                },
            "tooltip": LangHelper.GetString("Dics", "Add data from FULLFLOW")
        }
    ]);

    //Group 8
    clAddToDic(8, [
        {
            "id": "ONLINEFLOW_AGG_LOG_GROUP_TIME_INTERVAL",
            "value": LangHelper.GetString("Dics", "Time interval for aggregating ONLINEFLOW logs") + " (ONLINEFLOW_AGG_LOG_GROUP_TIME_INTERVAL)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "1 second") + " ("+LangHelper.GetString("Dics", "By default")+")"},
                    "2": {"id": "5", "value": LangHelper.GetString("Dics", "5 seconds")},
                    "3": {"id": "10", "value": LangHelper.GetString("Dics", "10 seconds")},
                    "4": {"id": "15", "value": LangHelper.GetString("Dics", "15 seconds")},
                    "5": {"id": "30", "value": LangHelper.GetString("Dics", "30 seconds")},
                    "6": {"id": "60", "value": LangHelper.GetString("Dics", "1 minute")},
                    "7": {"id": "300", "value": LangHelper.GetString("Dics", "5 minutes")},
                    "8": {"id": "600", "value": LangHelper.GetString("Dics", "10 minutes")}
                },
            "tooltip": LangHelper.GetString("Dics", "Time interval for aggregating ONLINEFLOW logs")
        }
    ]);

    //Group 9
    clAddToDic(9, [
        {
            "id": "CELL_TOWER_AUTOLOAD_ENABLED",
            "group": "9",
            "value": LangHelper.GetString("Dics", "Enables autoload of OpenCellID catalog") + " (CELL_TOWER_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enables autoload of OpenCellID catalog")
        },
        {
            "id": "CELL_TOWER_LOADER_API_TOKEN",
            "group": "9",
            "value": LangHelper.GetString("Dics", "Token in LocalAPI platform") + " (CELL_TOWER_LOADER_API_TOKEN)",
            "view": "text",
            "placeholder":"pk.xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
            "tooltip": LangHelper.GetString("Dics", "Token in LocalAPI platform") + "<br/><br/>" +
                "<a href='" + LangHelper.GetString("Dics", "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_components:qoestor:dictionaries:opencellid:start") + "'>" +
                LangHelper.GetString("Dics", "How to receive access token") +
                "</a>"
                // LangHelper.GetString("Dics", "How to get your access token")
                // LangHelper.GetString("Dics", "Default value") + ": pk.fce9af82655c117ef42c88d36885cc8b"
        },
        {
            "id": "CELL_TOWER_LOG",
            "group": "9",
            "value": LangHelper.GetString("Dics", "OpenCellID level of log") + " (CELL_TOWER_LOG)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Info")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Debug")}
                },
            "tooltip": LangHelper.GetString("Dics", "OpenCellID level of log")
        },
        {
            "id": "CELL_TOWER_RESPONSE_HOUR",
            "group": "9",
            "value": LangHelper.GetString("Dics", "Time interval to update empty data cell towers for report of geoposition") + " (CELL_TOWER_RESPONSE_HOUR)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "Time interval to update empty data cell towers for report of geoposition"),
            "placeholder": "24",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
    ]);

    //Group 10
    clAddToDic(10, [
        {
            "id": "GTP_LOAD_RATE_ADD_INFO_FROM_FULLFLOW",
            "group": "10",
            "value": LangHelper.GetString("Dics", "Import GTP LOAD RATE from fullflow") + " (GTP_LOAD_RATE_ADD_INFO_FROM_FULLFLOW)",
            "view": "richselect",
            "placeholder": LangHelper.GetString("Dics", "Disabled"),
            "options":
                {
                    "0": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enable a service for detecting anomalies in the load rate of base stations") + "."
        },
        {
            "id": "GTP_LOAD_RATE_AGG_LOG_FIELDS_TO_SAVE_BITMASK",
            "group": "10",
            "value": LangHelper.GetString("Dics", "Fields to save when aggregating GTP log") + " (GTP_LOAD_RATE_AGG_LOG_FIELDS_TO_SAVE_BITMASK)",
            "view": "multiselectBitMask",
            "params":{
                "maskFormat":"hex"
            },
            "options":
                {
                    "0x1": {"id": "0x1", "value": "0x1 - " + LangHelper.GetString("Dics", "Save traffic volume")},
                    "0x2": {"id": "0x2", "value": "0x2 - " + LangHelper.GetString("Dics", "Group by protocol code")},
                    "0x4": {"id": "0x4", "value": "0x4 - " + LangHelper.GetString("Dics", "Save subscribers")},
                },
            "default": "0x7",
            "tooltip": LangHelper.GetString("Dics", "Fields to save when aggregating GTP log tooltip") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x7" + "." + "<br/><br/>" +
                "0x1 - " + LangHelper.GetString("Dics", "Save traffic volume") + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "Group by protocol code") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Save subscribers"),
            "tooltipWidth":480,
            "tooltipHeight":800
        },
        {
            "id": "GTP_LOAD_RATE_AGG_LOG_GROUP_TIME_INTERVAL",
            "group": "10",
            "value": LangHelper.GetString("Dics", "Time interval for aggregating GTP LOAD RATE logs in minutes") + " (GTP_LOAD_RATE_AGG_LOG_GROUP_TIME_INTERVAL)",
            "view": "richselect",
            "placeholder": LangHelper.GetString("Dics", "1 day"),
            "options":
                {
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "1 minute")},
                    "2": {"id": "5", "value": LangHelper.GetString("Dics", "5 minutes")},
                    "3": {"id": "10", "value": LangHelper.GetString("Dics", "10 minutes")},
                    "4": {"id": "15", "value": LangHelper.GetString("Dics", "15 minutes")},
                    "5": {"id": "30", "value": LangHelper.GetString("Dics", "30 minutes")},
                    "6": {"id": "60", "value": LangHelper.GetString("Dics", "60 minutes")},
                    "7": {"id": "1440", "value": LangHelper.GetString("Dics", "1 day") + " ("+LangHelper.GetString("Dics", "By default")+")"},
                    "8": {"id": "10080", "value": LangHelper.GetString("Dics", "1 week")}
                },
            "tooltip": LangHelper.GetString("Dics", "Time interval for aggregating GTP LOAD RATE logs in minutes tooltip") + "." + "<br/><br/>" +
            LangHelper.GetString("Dics", "Default value") + ": " + "1440 "
            + "(" + LangHelper.GetString("Dics", "1 day") + ")" + ".",

        },

    ]);

    //Group 11
    clAddToDic(11, [
        {
            "id": "UPLINK_LOAD_RATE_ADD_INFO_FROM_FULLFLOW",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Import UPLINK LOAD RATE from fullflow") + " (UPLINK_LOAD_RATE_ADD_INFO_FROM_FULLFLOW)",
            "view": "richselect",
            "placeholder": LangHelper.GetString("Dics", "Disabled"),
            "options":
                {
                    "0": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enable a service for import UPLINK LOAD RATE info from fullflow") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + LangHelper.GetString("Dics", "Disabled") + "."
        },
        {
            "id": "UPLINK_LOAD_RATE_AGG_LOG_FIELDS_TO_SAVE_BITMASK",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Fields to save when aggregating UPLINK LOAD RATE log") + " (UPLINK_LOAD_RATE_AGG_LOG_FIELDS_TO_SAVE_BITMASK)",
            "view": "multiselectBitMask",
            "params":{
                "maskFormat":"hex"
            },
            "options":
                {
                    "0x1": {"id": "0x1", "value": "0x1 - " + LangHelper.GetString("Dics", "Save traffic volume")},
                    "0x2": {"id": "0x2", "value": "0x2 - " + LangHelper.GetString("Dics", "RTT")},
                    "0x4": {"id": "0x4", "value": "0x4 - " + LangHelper.GetString("Dics", "Group by protocol code")},
                },
            "default": "0x7",
            "tooltip": LangHelper.GetString("Dics", "Fields to save when aggregating UPLINK LOAD RATE log") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x7" + "." + "<br/><br/>" +
                "0x1 - " + LangHelper.GetString("Dics", "Save traffic volume") + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "RTT") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Group by protocol code"),
            "tooltipWidth":480,
            "tooltipHeight":800
        },
        {
            "id": "UPLINK_LOAD_RATE_AGG_LOG_GROUP_TIME_INTERVAL",
            "group": "11",
            "value": LangHelper.GetString("Dics", "Time interval for aggregating UPLINK LOAD RATE logs in minutes") + " (UPLINK_LOAD_RATE_AGG_LOG_GROUP_TIME_INTERVAL)",
            "view": "richselect",
            "placeholder": LangHelper.GetString("Dics", "15 minutes"),
            "options":
                {
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "1 minute")},
                    "2": {"id": "5", "value": LangHelper.GetString("Dics", "5 minutes")},
                    "3": {"id": "10", "value": LangHelper.GetString("Dics", "10 minutes")},
                    "4": {"id": "15", "value": LangHelper.GetString("Dics", "15 minutes") + " ("+LangHelper.GetString("Dics", "By default")+")"},
                    "5": {"id": "30", "value": LangHelper.GetString("Dics", "30 minutes")},
                    "6": {"id": "60", "value": LangHelper.GetString("Dics", "60 minutes")},
                    "7": {"id": "1440", "value": LangHelper.GetString("Dics", "1 day")},
                    "8": {"id": "10080", "value": LangHelper.GetString("Dics", "1 week")}
                },
            "tooltip": LangHelper.GetString("Dics", "Time interval for aggregating UPLINK LOAD RATE logs in minutes") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + LangHelper.GetString("Dics", "15 minutes") + ".",

        },
    ]);

    //Group 12
    clAddToDic(12, [
        {
            "id": "KASPERSKY_FEED_AUTOLOAD_ENABLED",
            "group": "12",
            "value": LangHelper.GetString("Dics", "Import Kaspersky list of infected hosts") + " (KASPERSKY_FEED_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "placeholder": LangHelper.GetString("Dics", "Disabled"),
            "options":
                {
                    "0": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enable a service for import Kaspersky list of infected hosts") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + LangHelper.GetString("Dics", "Disabled") + "."
        }
    ]);

    //Group 13
    clAddToDic(13, [
        {
            "id": "FULLFLOW_COMPRESS_ENABLE",
            "value": LangHelper.GetString("Dics", "Enable FULLFLOW log background compressing") + " (FULLFLOW_COMPRESS_ENABLE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enable FULLFLOW log background compressing")
        },
        {
            "id": "FULLFLOW_REPLACE_IP_CLASS_WHITH_ORIGINAL_TOS",
            "value": LangHelper.GetString("Dics", "Enable DSCP from original TOS") + " (FULLFLOW_REPLACE_IP_CLASS_WHITH_ORIGINAL_TOS)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enable DSCP from original TOS")
        },
        {
            "id": "IPFIX_FULLFLOW_ENBALE_BLOCKED_DATA",
            "value": LangHelper.GetString("Dics", "Enable collection of information about blocked traffic") + " (IPFIX_FULLFLOW_ENBALE_BLOCKED_DATA)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Enable collection of information about blocked traffic")
        },
        {
            "id": "IPFIX_FULLFLOW_BLOCKED_DROP_THRESHOLD",
            "value": LangHelper.GetString("Dics", "Threshold value for traffic detection as a drop") + " (IPFIX_FULLFLOW_BLOCKED_DROP_THRESHOLD)",
            "view": "text",
            "placeholder": "0.9",
            "validate": function (Val) {
                const val = parseFloat(Val);
                return (Val === "") || (!isNaN(val) && val >= 0 && val <= 1 && String(val) === Val);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter a number between 0 and 1, including floating point numbers"),
            "tooltip": LangHelper.GetString("Dics", "Threshold value for traffic detection as a drop") + "<br><br>" +
                LangHelper.GetString("Dics", "By default") + ": 0.9" + "<br><br>" +
                LangHelper.GetString("Dics", "Enter a number between 0 and 1, including floating point numbers") + "."
        },
        {
            "id": "IPFIX_FULLFLOW_BLOCKED_POLICING_THRESHOLD",
            "value": LangHelper.GetString("Dics", "Threshold value for traffic detection as a policing") + " (IPFIX_FULLFLOW_BLOCKED_POLICING_THRESHOLD)",
            "view": "text",
            "placeholder": "0.1",
            "validate": function (Val) {
                const val = parseFloat(Val);
                return (Val === "") || (!isNaN(val) && val >= 0 && val <= 1 && String(val) === Val);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter a number between 0 and 1, including floating point numbers"),
            "tooltip": LangHelper.GetString("Dics", "Threshold value for traffic detection as a policing") + "<br><br>" +
                LangHelper.GetString("Dics", "By default") + ": 0.1" + "<br><br>" +
                LangHelper.GetString("Dics", "Enter a number between 0 and 1, including floating point numbers") + "."
        },
        {
            "id": "FULLFLOW_VOIP_GROUP_FIELDS_ENABLE",
            "value": LangHelper.GetString("Dics", "Enable VOIP traffic data") + " (FULLFLOW_VOIP_GROUP_FIELDS_ENABLE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "default": 1,
            "tooltip": LangHelper.GetString("Dics", "Enable VOIP traffic data") + ".</br></br>"
                + LangHelper.GetString("Dics", "By default") + ": " + LangHelper.GetString("Dics", "Disabled")
        },
    ]);

    //Group 14
    clAddToDic(14, [
        {
            "id": "DNSFLOW_AGG_LOG_FIELDS_TO_SAVE_BITMASK",
            "value": LangHelper.GetString("Dics", "Fields to save when aggregating DNS flow log") + " (DNSFLOW_AGG_LOG_FIELDS_TO_SAVE_BITMASK)",
            "view": "multiselectBitMask",
            "params":{
                "maskFormat":"hex"
            },
            "options":
                {
                    "0x1": {"id": "0x1", "value": "0x1 - " + LangHelper.GetString("Dics", "Login")},
                    "0x2": {"id": "0x2", "value": "0x2 - " + LangHelper.GetString("Dics", "DNS IP")},
                    "0x4": {"id": "0x4", "value": "0x4 - " + LangHelper.GetString("Dics", "Subscriber IP")},
                    "0x8": {"id": "0x8", "value": "0x8 - " + LangHelper.GetString("Dics", "DNS port")},
                    "0x10": {"id": "0x10", "value": "0x10 - " + LangHelper.GetString("Dics", "Subscriber port")},
                    "0x20": {"id": "0x20", "value": "0x20 - " + LangHelper.GetString("Dics", "Session ID")},
                    "0x40": {"id": "0x40", "value": "0x40 - " + LangHelper.GetString("Dics", "DNS transport")},
                    "0x80": {"id": "0x80", "value": "0x80 - " + LangHelper.GetString("Dics", "DNS host")},
                    "0x100": {"id": "0x100", "value": "0x100 - " + LangHelper.GetString("Dics", "RRCLASS")},
                    "0x200": {"id": "0x200", "value": "0x200 - " + LangHelper.GetString("Dics", "RRTYPE")},
                    "0x400": {"id": "0x400", "value": "0x400 - " + LangHelper.GetString("QoE", "MPLS labels")},
                    "0x800": {"id": "0x800", "value": "0x800 - " + LangHelper.GetString("Dics", "DPI ID")},
                    "0x1000": {"id": "0x1000", "value": "0x1000 - " + LangHelper.GetString("Dics", "Vchannel")},
                    "0x2000": {"id": "0x2000", "value": "0x2000 - " + LangHelper.GetString("Dics", "Host IP")}
                },
            "tooltip": LangHelper.GetString("Dics", "Fields to save when aggregating DNS flow log") + "." + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value") + ": " + "0x1887" + "." + "<br/><br/>" +
                "0x1 - " + LangHelper.GetString("Dics", "Login") + "<br/><br/>" +
                "0x2 - " + LangHelper.GetString("Dics", "DNS IP") + "<br/><br/>" +
                "0x4 - " + LangHelper.GetString("Dics", "Subscriber IP") + "<br/><br/>" +
                "0x8 - " + LangHelper.GetString("Dics", "DNS port") + "<br/><br/>" +
                "0x10 - " + LangHelper.GetString("Dics", "Subscriber port") + "<br/><br/>" +
                "0x20 - " + LangHelper.GetString("Dics", "Session ID") + "<br/><br/>" +
                "0x40 - " + LangHelper.GetString("Dics", "DNS transport") + "<br/><br/>" +
                "0x80 - " + LangHelper.GetString("Dics", "DNS host") + "<br/><br/>" +
                "0x100 - " + LangHelper.GetString("Dics", "RRCLASS") + "<br/><br/>" +
                "0x200 - " + LangHelper.GetString("Dics", "RRTYPE") + "<br/><br/>" +
                "0x400 - " + LangHelper.GetString("Dics", "MPLS labels") + "<br/><br/>" +
                "0x800 - " + LangHelper.GetString("Dics", "DPI ID") + "<br/><br/>" +
                "0x1000 - " + LangHelper.GetString("Dics", "Vchannel")  + "<br/><br/>" +
                "0x2000 - " + LangHelper.GetString("Dics", "Host IP"),
            "tooltipWidth":480,
            "tooltipHeight":800
        },
        {
            "id": "DNSFLOW_AGG_LOG_GROUP_TIME_INTERVAL",
            "value": LangHelper.GetString("Dics", "Time interval for aggregating DNS flow logs") + " (DNSFLOW_AGG_LOG_GROUP_TIME_INTERVAL)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "1 minute")},
                    "2": {"id": "5", "value": LangHelper.GetString("Dics", "5 minutes")},
                    "3": {"id": "10", "value": LangHelper.GetString("Dics", "10 minutes")},
                    "4": {"id": "15", "value": LangHelper.GetString("Dics", "15 minutes") + " ("+LangHelper.GetString("Dics", "By default")+")"},
                    "5": {"id": "30", "value": LangHelper.GetString("Dics", "30 minutes")},
                    "6": {"id": "60", "value": LangHelper.GetString("Dics", "60 minutes")}
                },
            "tooltip": LangHelper.GetString("Dics", "Time interval for aggregating DNS flow logs")
        }
    ]);

    //Group 14
    clAddToDic(16, [
        {
            "id": "FILL_IP_LOGIN_BINDING_FROM_AAA",
            "value": LangHelper.GetString("Dics", "FILL_IP_LOGIN_BINDING_FROM_AAA_title") + " (FILL_IP_LOGIN_BINDING_FROM_AAA)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "FILL_IP_LOGIN_BINDING_FROM_AAA_descr")
        },
        {
            "id": "AAA_REPLACE_LOGIN_IP_LOGIN_BIND",
            "value": LangHelper.GetString("Dics", "AAA_REPLACE_LOGIN_IP_LOGIN_BIND_title") + " (AAA_REPLACE_LOGIN_IP_LOGIN_BIND)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Always replace")},
                    "3": {"id": "2", "value": LangHelper.GetString("Dics", "Replace only if the Login field is empty")}
                },
            "tooltip": LangHelper.GetString("Dics", "AAA_REPLACE_LOGIN_IP_LOGIN_BIND_descr")
        },
        {
            "id": "FILL_ACC_STATE_FROM_AAA",
            "value": LangHelper.GetString("Dics", "FILL_ACC_STATE_FROM_AAA_title") + " (FILL_ACC_STATE_FROM_AAA)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "FILL_ACC_STATE_FROM_AAA_descr")
        },
        {
            "id": "FILL_UDR_FULLFLOW",
            "value": LangHelper.GetString("Dics", "FILL_UDR_FULLFLOW_title") + " (FILL_UDR_FULLFLOW)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "FILL_UDR_FULLFLOW_descr")
        },
        {
            "id": "FILL_UDR_CLICKSTREAM",
            "value": LangHelper.GetString("Dics", "FILL_UDR_CLICKSTREAM_title") + " (FILL_UDR_CLICKSTREAM)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "FILL_UDR_CLICKSTREAM_descr")
        },
        {
            "id": "UDR_FULLFLOW_FILTER",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_FULLFLOW_FILTER_title") + " (UDR_FULLFLOW_FILTER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_FULLFLOW_FILTER_descr")
        },
        {
            "id": "UDR_CLICKSTREAM_FILTER",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_FILTER_title") + " (UDR_CLICKSTREAM_FILTER)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_FILTER_descr")
        },
        {
            "id": "UDR_FULLFLOW_TIME_INTERVAL",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_FULLFLOW_TIME_INTERVAL_title") + " (UDR_FULLFLOW_TIME_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_FULLFLOW_TIME_INTERVAL_descr"),
            "placeholder":"15"
        },
        {
            "id": "UDR_FULLFLOW_PERIOD_FROM",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_FULLFLOW_PERIOD_FROM_title") + " (UDR_FULLFLOW_PERIOD_FROM)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_PERIOD_descr"),
            "placeholder":"now()-30*60"
        },
        {
            "id": "UDR_FULLFLOW_PERIOD_TO",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_FULLFLOW_PERIOD_TO_title") + " (UDR_FULLFLOW_PERIOD_TO)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_PERIOD_descr"),
            "placeholder":"now()-15*60"
        },
        {
            "id": "UDR_CLICKSTREAM_TIME_INTERVAL",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_TIME_INTERVAL_title") + " (UDR_CLICKSTREAM_TIME_INTERVAL)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_TIME_INTERVAL_descr"),
            "placeholder":"15"
        },
        {
            "id": "UDR_CLICKSTREAM_PERIOD_FROM",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_PERIOD_FROM_title") + " (UDR_CLICKSTREAM_PERIOD_FROM)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_PERIOD_descr"),
            "placeholder":"now()-30*60"
        },
        {
            "id": "UDR_CLICKSTREAM_PERIOD_TO",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_PERIOD_TO_title") + " (UDR_CLICKSTREAM_PERIOD_TO)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_PERIOD_descr"),
            "placeholder":"now()-15*60"
        },

        {
            "id": "UDR_FULLFLOW_DATE_TIME_FORMAT",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_FULLFLOW_DATE_TIME_FORMAT_title") + " (UDR_FULLFLOW_DATE_TIME_FORMAT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_DATE_TIME_FORMAT_descr"),
            "placeholder":"%Y%m%d%H%i%S"
        },
        {
            "id": "UDR_CLICKSTREAM_DATE_TIME_FORMAT",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_DATE_TIME_FORMAT_title") + " (UDR_CLICKSTREAM_DATE_TIME_FORMAT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_DATE_TIME_FORMAT_descr"),
            "placeholder":"%Y%m%d%H%i%S"
        },

        {
            "id": "UDR_SCP",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_SCP_title") + " (UDR_SCP)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_SCP_descr"),
            "placeholder":"root@192.168.1.216"
        },
        {
            "id": "UDR_SCP_PORT",
            "group": "4",
            "value": LangHelper.GetString("Dics", "UDR_SCP_PORT_title") + " (UDR_SCP_PORT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "UDR_SCP_PORT_descr"),
            "placeholder":"22"
        },
        {
            "id": "UDR_FULLFLOW_FORMAT",
            "value": LangHelper.GetString("Dics", "UDR_FULLFLOW_FORMAT_title") + " (UDR_FULLFLOW_FORMAT)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "TabSeparated", "value": LangHelper.GetString("Dics", "TabSeparated")},
                    "2": {"id": "CSV", "value": LangHelper.GetString("Dics", "CSV")}
                },
            "tooltip": LangHelper.GetString("Dics", "UDR_FULLFLOW_FORMAT_descr")
        },
        {
            "id": "UDR_CLICKSTREAM_FORMAT",
            "value": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_FORMAT_title") + " (UDR_CLICKSTREAM_FORMAT)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "TabSeparated", "value": LangHelper.GetString("Dics", "TabSeparated")},
                    "2": {"id": "CSV", "value": LangHelper.GetString("Dics", "CSV")}
                },
            "tooltip": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_FORMAT_descr")
        },
        {
            "id": "UDR_FULLFLOW_DIST_MODE",
            "value": LangHelper.GetString("Dics", "UDR_FULLFLOW_DIST_MODE_title") + " (UDR_FULLFLOW_DIST_MODE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "UDR_FULLFLOW_DIST_MODE_descr")
        },
        {
            "id": "UDR_CLICKSTREAM_DIST_MODE",
            "value": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_DIST_MODE_title") + " (UDR_CLICKSTREAM_DIST_MODE)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "UDR_CLICKSTREAM_DIST_MODE_descr")
        },
    ]);

    //Group 15
    clAddToDic(17, [
        {
            "id": "FM_ATTACKS_AGG_LOG_GROUP_TIME_INTERVAL",
            "value": LangHelper.GetString("Dics", "Time interval for aggregating DDoS attack logs") + " (FM_ATTACKS_AGG_LOG_GROUP_TIME_INTERVAL)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "1", "value": LangHelper.GetString("Dics", "1 minute")},
                    "2": {"id": "5", "value": LangHelper.GetString("Dics", "5 minutes")},
                    "3": {"id": "10", "value": LangHelper.GetString("Dics", "10 minutes")},
                    "4": {"id": "15", "value": LangHelper.GetString("Dics", "15 minutes") + " ("+LangHelper.GetString("Dics", "By default")+")"},
                    "5": {"id": "30", "value": LangHelper.GetString("Dics", "30 minutes")},
                    "6": {"id": "60", "value": LangHelper.GetString("Dics", "60 minutes")}
                },
            "tooltip": LangHelper.GetString("Dics", "Time interval for aggregating DDoS attack logs")
        },
        {
            "id": "FM_ATTACKS_AGG_LOG_FIELDS_TO_SAVE_BITMASK",
            "value": LangHelper.GetString("Dics", "Fields to save when aggregating DDoS attack log") + " (FM_ATTACKS_AGG_LOG_FIELDS_TO_SAVE_BITMASK)",
            "view": "multiselectBitMask",
            "params":{
                "maskFormat":"hex"
            },
            "options":
                {
                    "0x1": {"id": "0x1", "value": "0x1 - " + LangHelper.GetString("QoE", "Event")},
                    "0x2": {"id": "0x2", "value": "0x2 - " + LangHelper.GetString("QoE", "Event type")},
                    "0x4": {"id": "0x4", "value": "0x4 - " + LangHelper.GetString("QoE", "Event action")},
                    "0x8": {"id": "0x8", "value": "0x8 - " + LangHelper.GetString("QoE", "DPI ID")},
                    "0x10": {"id": "0x10", "value": "0x10 - " + LangHelper.GetString("QoE", "Vchannel/Bridge")},
                    "0x20": {"id": "0x20", "value": "0x20 - " + LangHelper.GetString("Dics", "Protocol identifier")},
                    "0x40": {"id": "0x40", "value": "0x40 - " + LangHelper.GetString("Dics", "Protocol code")},
                    "0x80": {"id": "0x80", "value": "0x80 - " + LangHelper.GetString("QoE", "Source AS")},
                    "0x100": {"id": "0x100", "value": "0x100 - " + LangHelper.GetString("QoE", "Attacker IP address")},
                    "0x200": {"id": "0x200", "value": "0x200 - " + LangHelper.GetString("QoE", "Target IP address")},
                    "0x400": {"id": "0x400", "value": "0x400 - " + LangHelper.GetString("QoE", "Target port")},
                    "0x800": {"id": "0x800", "value": "0x800 - " + LangHelper.GetString("QoE", "Subscriber login")}
                },
            "tooltip": LangHelper.GetString("Dics", "Fields to save when aggregating DDoS attack log") + "." + "<br/><br/>" +
                    LangHelper.GetString("Dics", "Default value") + ": " + "0xFFF" + "." + "<br/><br/>" +
                    "0x1 - " + LangHelper.GetString("QoE", "Event") + "<br/><br/>" +
                    "0x2 - " + LangHelper.GetString("QoE", "Event type") + "<br/><br/>" +
                    "0x4 - " + LangHelper.GetString("QoE", "Event action") + "<br/><br/>" +
                    "0x8 - " + LangHelper.GetString("QoE", "DPI ID") + "<br/><br/>" +
                    "0x10 - " + LangHelper.GetString("QoE", "Vchannel/Bridge") + "<br/><br/>" +
                    "0x20 - " + LangHelper.GetString("Dics", "Protocol identifier") + "<br/><br/>" +
                    "0x40 - " + LangHelper.GetString("Dics", "Protocol code") + "<br/><br/>" +
                    "0x80 - " + LangHelper.GetString("QoE", "Source AS") + "<br/><br/>" +
                    "0x100 - " + LangHelper.GetString("QoE", "Attacker IP address") + "<br/><br/>" +
                    "0x200 - " + LangHelper.GetString("QoE", "Target IP address") + "<br/><br/>" +
                    "0x400 - " + LangHelper.GetString("QoE", "Target port") + "<br/><br/>" +
                    "0x800 - " + LangHelper.GetString("QoE", "Subscriber login") + "<br/><br/>",
            "tooltipWidth":480,
            "tooltipHeight":800
        },
        {
            "id": "GEO_IP_DIC_AUTOLOAD_ENABLED",
            "value": LangHelper.GetString("Dics", "Automatic update of the geodata dictionary") + " (GEO_IP_DIC_AUTOLOAD_ENABLED)",
            "view": "richselect",
            "options":
                {
                    "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                    "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
                },
            "tooltip": LangHelper.GetString("Dics", "Automatic update of the geodata dictionary")
        },
    ]);

    return dic;
}();

QoEStorEnvConfigFullflowCompressLogSettings = [
    {
        id: "FULLFLOW_AGG_COMPRESS_1_ENABLE",
        view: "switch",
        value: LangHelper.GetString("QoEStorConfig","Enable fullflow additional aggregation Stage") + " 1"
    },
    {
        id: "FULLFLOW_AGG_COMPRESS_LOG_GROUP_LIFETIME_1",
        view: "days-input",
        value: LangHelper.GetString("QoEStorConfig","After how many days to reaggregate logs") + " " +
            LangHelper.GetString("QoEStorConfig","Stage") + " 1",
        placeholder: LangHelper.GetString("QoEStorConfig", "After 7 days"),
        validate: webix.rules.isNotEmpty,
        invalidMessage: LangHelper.GetString("Dics", "Enter the number of days")
    },
    {
        id: "FULLFLOW_AGG_COMPRESS_LOG_GROUP_TIME_INTERVAL_1",
        view: "richselect",
        value: LangHelper.GetString("QoEStorConfig","Time interval for log aggregation") + " " +
            LangHelper.GetString("QoEStorConfig","Stage") + " 1",
        options: [
            {"id": "1", "value": LangHelper.GetString("Dics", "1 minute")},
            {"id": "5", "value": LangHelper.GetString("Dics", "5 minutes")},
            {"id": "10", "value": LangHelper.GetString("Dics", "10 minutes")},
            {"id": "15", "value": LangHelper.GetString("Dics", "15 minutes")},
            {"id": "30", "value": LangHelper.GetString("Dics", "30 minutes") + " ("+LangHelper.GetString("Dics", "By default")+")"},
            {"id": "60", "value": LangHelper.GetString("Dics", "60 minutes")}
        ],
        validate: webix.rules.isNotEmpty,
        invalidMessage: LangHelper.GetString("Dics", "Choose interval")
    },
    {
        id: "FULLFLOW_AGG_COMPRESS_2_ENABLE",
        view: "switch",
        value: LangHelper.GetString("QoEStorConfig","Enable fullflow additional aggregation Stage") + " 2"
    },
    {
        id: "FULLFLOW_AGG_COMPRESS_LOG_GROUP_LIFETIME_2",
        view: "days-input",
        value: LangHelper.GetString("QoEStorConfig","After how many days to reaggregate logs") + " " +
            LangHelper.GetString("QoEStorConfig","Stage") + " 2",
        placeholder: LangHelper.GetString("QoEStorConfig", "After 30 days"),
        validate: webix.rules.isNotEmpty,
        invalidMessage: LangHelper.GetString("Dics", "Enter the number of days")
    },
    {
        id: "FULLFLOW_AGG_COMPRESS_LOG_GROUP_TIME_INTERVAL_2",
        view: "richselect",
        value: LangHelper.GetString("QoEStorConfig","Time interval for log aggregation") + " " +
            LangHelper.GetString("QoEStorConfig","Stage") + " 2",
        options: [
            {"id": "1", "value": LangHelper.GetString("Dics", "1 minute")},
            {"id": "5", "value": LangHelper.GetString("Dics", "5 minutes")},
            {"id": "10", "value": LangHelper.GetString("Dics", "10 minutes")},
            {"id": "15", "value": LangHelper.GetString("Dics", "15 minutes")},
            {"id": "30", "value": LangHelper.GetString("Dics", "30 minutes")},
            {"id": "60", "value": LangHelper.GetString("Dics", "60 minutes") + " ("+LangHelper.GetString("Dics", "By default")+")"},
        ],
        validate: webix.rules.isNotEmpty,
        invalidMessage: LangHelper.GetString("Dics", "Choose interval")
    }
]


QoEStorEnvConfigDic = webix.extend(QoEStorEnvConfigReceiversDic, QoEStorEnvConfigDic);


var BalancerEnvConfigGroupDic =
    {
        "1": {"id": "1", "order": 1, "value": LangHelper.GetString("Dics", "Receivers")}
    };

var BalancerEnvConfigReceiverDic =
    {
        "1.0": {
            "id": "RECEIVER_TYPE", "value": LangHelper.GetString("Dics", "Receiver type"),
            "view": "richselect",
            "options": {
                "1": {"id": "IPFIX_FULLFLOW", "value": LangHelper.GetString("Dics", "Netflow")},
                "2": {"id": "IPFIX_CLICKSTREAM", "value": LangHelper.GetString("Dics", "Clickstream")},
                "3": {"id": "IPFIX_GTPFLOW", "value": LangHelper.GetString("Dics", "GTP flow")},
                "4": {"id": "IPFIX_NATFLOW", "value": LangHelper.GetString("Dics", "NAT flow")},
                "5": {"id": "IPFIX_NATFLOW_NETSTREAM", "value": LangHelper.GetString("Dics", "NAT flow") + " (Netstream)"},
                "6": {"id": "IPFIX_DNSFLOW", "value": LangHelper.GetString("Dics", "DNS flow")},
                "7": {"id": "IPFIX_AAAFLOW", "value": LangHelper.GetString("Dics", "AAA flow")}
            },
            default: "IPFIX_FULLFLOW",
            "tooltip": LangHelper.GetString("Dics", "Receiver type") + ": " + LangHelper.GetString("Dics", "Fullflow or Clickstream") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Fullflow is a receiver for fullflow data") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Clickstream is a receiver for clickstream data") + "<br/><br/>"
        },
        "1.1": {
            "id": "PORT_TYPE", "value": LangHelper.GetString("Dics", "Port type"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "tcp", "value": LangHelper.GetString("Dics", "tcp")},
                    "2": {"id": "udp", "value": LangHelper.GetString("Dics", "udp")}
                },
            default: "tcp",
            "tooltip": LangHelper.GetString("Dics", "Port type") + ": " + LangHelper.GetString("Dics", "tcp or udp") + "<br/><br/>" +
                LangHelper.GetString("Dics", "It`s recommended to use tcp") + "<br/><br/>"
        },
        "1.2": {
            "id": "PORT", "value": LangHelper.GetString("Dics", "Port"),
            "view": "text",
            "placeholder": "1500",
            "default": 1500,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Any port you wish. The main thing that would be different for each thread") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default values are 1500 for fullflow thread and 1501 for clickstream thread")
        },
        "1.3": {
            "id": "ROTATE_MINUTES", "value": LangHelper.GetString("Dics", "Rotate in minutes"),
            "view": "text",
            "placeholder": "10",
            "default": 10,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Receiver dump rotate period or data loading period into the database") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is 10 minutes for fullflow and 12 minutes for clickstream") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Dump rotate period for cliksteam should be greater or equal than the same period for fullflow. When fullflow dump rotates the HUP signal is sent to synchronize threads.") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily"),
            "tooltipHeight": 280
        },
        "1.4": {
            "id": "ROTATE_SECONDS", "value": LangHelper.GetString("Dics", "Rotate in seconds"),
            "view": "text",
            "placeholder": "600",
            "default": 0,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Receiver dump rotate in seconds. The same as the rotation in minutes, only in seconds.") + "<br/><br/><br/>" + LangHelper.GetString("Dics", "If this value is enabled the value in minutes is ignored."),
            "tooltipHeight": 280
        },
        "1.5": {
            "id": "ROTATE_FLOWS", "value": LangHelper.GetString("Dics", "Rotate by flows"),
            "view": "text",
            "placeholder": "600",
            "default": 0,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Rotation by flows records number. Works simultaneously with rotates in minutes or seconds."),
            "tooltipHeight": 280
        },
        "1.6": {
            "id": "EXPORT", "value": LangHelper.GetString("Dics", "Export"),
            "view": "text",
            "placeholder": "10.0.0.2/9920/tcp,10.0.0.3/3440/udp",
            "tooltip": LangHelper.GetString("Dics", "Reciver can export data to other receivers") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Format is") + " 10.0.0.2/9920/tcp,10.0.0.3/3440/udp"
        },
        "1.7": {
            "id": "DPI_ID", "value": LangHelper.GetString("Dics", "DPI ID"),
            "view": "text",
            "placeholder": "-1",
            "default": -1,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "PDI number. If the value is -1 or not specified, then the DPI number is determined by the order of the receiver in the list.") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is -1.") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily"),
            "tooltipHeight": 280
        },
        "1.8": {
            "id": "BALANCER", "value": LangHelper.GetString("Dics", "Balancer"),
            "view": "richselect",
            "options": {
                "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                "2": {"id": "roundrobin", "value": LangHelper.GetString("Dics", "RoundRobin")},
                "3": {"id": "all", "value": LangHelper.GetString("Dics", "All")}
            },
            default: "0",
            "tooltip": LangHelper.GetString("Dics", "Balancer type") + ": " + LangHelper.GetString("Dics", "RoundRobin or All") + "<br/><br/>" +
                LangHelper.GetString("Dics", "RoundRobin mode splits IPFIX flow") + "<br/><br/>" +
                LangHelper.GetString("Dics", "All mode replicate IPFIX flow") + "<br/><br/>"
        },
        "1.9": {
            "id": "BALANCER_SUB", "value": LangHelper.GetString("Dics", "Balancer subreceivers"),
            "view": "text",
            "placeholder": "10.0.0.2/9920,10.0.0.3/3440",
            "tooltip": LangHelper.GetString("Dics", "Balancer can split or replicate data to other receivers") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Format is") + " 10.0.0.2/9920,10.0.0.3/3440"
        },
        "1.10": {
            "id": "BALANCER_SUB_PROTO", "value": LangHelper.GetString("Dics", "Balancer subreceivers type"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "tcp", "value": LangHelper.GetString("Dics", "tcp")},
                    "2": {"id": "udp", "value": LangHelper.GetString("Dics", "udp")}
                },
            default: "tcp",
            "tooltip": LangHelper.GetString("Dics", "Port type") + ": " + LangHelper.GetString("Dics", "tcp or udp") + "<br/><br/>" +
                LangHelper.GetString("Dics", "It`s recommended to use tcp") + "<br/><br/>"
        },
        "1.11": {
            "id": "BALANCER_AUTO", "value": LangHelper.GetString("Dics", "Balancer auto"),
            "view": "richselect",
            "options": {
                "1": {"id": "0", "value": LangHelper.GetString("Dics", "Disabled")},
                "2": {"id": "1", "value": LangHelper.GetString("Dics", "Enabled")}
            },
            default: "0",
            "tooltip": LangHelper.GetString("Dics", "If Auto mode enabled it will create and start subreceivers automatic")
        },
        "1.12": {
            "id": "BALANCER_TASKSET", "value": LangHelper.GetString("Dics", "Balancer taskset"),
            "view": "text",
            "placeholder": "0",
            "validate": function (Val)
            {
                if(Val == null || Val === "")
                    return true;
                return Val >= -1 && !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "This parameter is responsible for determining which core ipfix-balancer is running on.") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is empty."),
            "tooltipHeight": 280
        },
    };

var BalancerEnvConfigReceiversDic = function () {
    var dic = {};

    function AddDic(Type, Id, ReceiverDicId, Title) {
        dic[Id] =
            {
                "id": Type + "_" + BalancerEnvConfigReceiverDic[ReceiverDicId].id + "[i]",
                "group": "1",
                "value": LangHelper.GetString("Dics", Title) + " (" + Type + "_" + BalancerEnvConfigReceiverDic[ReceiverDicId].id + "[i])",
                "view": BalancerEnvConfigReceiverDic[ReceiverDicId].view,
                "options": BalancerEnvConfigReceiverDic[ReceiverDicId].options,
                "placeholder": BalancerEnvConfigReceiverDic[ReceiverDicId].placeholder,
                "default": BalancerEnvConfigReceiverDic[ReceiverDicId].default,
                "validate": BalancerEnvConfigReceiverDic[ReceiverDicId].validate,
                "invalidMessage": BalancerEnvConfigReceiverDic[ReceiverDicId].invalidMessage,
                "tooltip": BalancerEnvConfigReceiverDic[ReceiverDicId].tooltip
            };
    }

    var index = 1;
    var options = [
        {ReceiverDicId: "1.1", Title: "Port type"},
        {ReceiverDicId: "1.2", Title: "Port number"},
        {ReceiverDicId: "1.3", Title: "Rotate in minutes"},
        {ReceiverDicId: "1.4", Title: "Rotate in seconds"},
        {ReceiverDicId: "1.5", Title: "Rotate by flows"},
        {ReceiverDicId: "1.6", Title: "Export"},
        {ReceiverDicId: "1.7", Title: "DPI ID"},
        {ReceiverDicId: "1.8", Title: "Balancer"},
        {ReceiverDicId: "1.9", Title: "Balancer subreceivers"},
        {ReceiverDicId: "1.10", Title: "Balancer subreceivers type"},
        {ReceiverDicId: "1.11", Title: "Balancer auto"},
        {ReceiverDicId: "1.12", Title: "Balancer taskset"}
    ];

    var process_rec = function(Type)
    {
        options.forEach(function(Val){
            AddDic(Type, "1." + String(index), Val.ReceiverDicId, Val.Title)
            index++;
        });
    }

    process_rec("IPFIX_FULLFLOW");
    process_rec("IPFIX_CLICKSTREAM");
    process_rec("IPFIX_GTPFLOW");
    process_rec("IPFIX_NATFLOW");
    process_rec("IPFIX_NATFLOW_NETSTREAM");
    process_rec("IPFIX_DNSFLOW");
    process_rec("IPFIX_AAAFLOW");

    return dic;
}();

var BalancerEnvConfigDic = function () {
    var dic = {};

    var clAddToDic = function (Group, Arr) {
        Arr.forEach(function (Item, Index) {
            var key = Group + "." + (Index + 1);
            dic[key] = Item;
            dic[key].group = Group + "";
        });
    };

    return dic;
}();

BalancerEnvConfigDic = webix.extend(BalancerEnvConfigReceiversDic, BalancerEnvConfigDic);

var PcrfTraceMaskDic = {
    "0x00000001": {id: "0x00000001", value: LangHelper.GetString("Dics", "Radius connections monitor")},
    "0x00000002": {id: "0x00000002", value: LangHelper.GetString("Dics", "Internal task scheduler")},
    "0x00000010": {id: "0x00000010", value: LangHelper.GetString("Dics", "Auth server")},
    "0x00000200": {id: "0x00000200", value: LangHelper.GetString("Dics", "radius_client connections")},
    "0x00000400": {id: "0x00000400", value: LangHelper.GetString("Dics", "radius_client monitor")},
    "0x00001000": {id: "0x00001000", value: LangHelper.GetString("Dics", "CoA-server events")},
    "0x00002000": {id: "0x00002000", value: LangHelper.GetString("Dics", "CoA-listener connects")},
    "0x00004000": {id: "0x00004000", value: LangHelper.GetString("Dics", "CoA-requests")},
    "0x00010000": {id: "0x00010000", value: LangHelper.GetString("Dics", "fastDPI sending data events")},
    "0x00020000": {id: "0x00020000", value: LangHelper.GetString("Dics", "Events queue from fastPCRF to fastDPI")},
    "0x00100000": {id: "0x00100000", value: LangHelper.GetString("Dics", "start/stop accounting requests")},
    "0x00200000": {id: "0x00200000", value: LangHelper.GetString("Dics", "interim update accounting requests")},
    "0x00400000": {id: "0x00400000", value: LangHelper.GetString("Dics", "Raw accounting data from fastDPI receiving")}
};

// var FastPcrfConfigGroupDic =
//     {
//         default: {
//             id: "default",
//             value: LangHelper.GetString("Dics","Default"),
//             data: {
//                 general: {
//                     id: "general",
//                     value: LangHelper.GetString("Dics","General settings")
//                 },
//                 auth: {
//                     id: "auth",
//                     value: LangHelper.GetString("Dics", "Authorization server")
//                 },
//                 radius:{
//                     id: "radius",
//                     value: LangHelper.GetString("Dics","Radius parameters")
//                 },
//                 radius_servers:{
//                     id: "radius_servers",
//                     value: LangHelper.GetString("Dics","Radius servers")
//                 },
//                 accounting: {
//                     id: "accounting",
//                     value: LangHelper.GetString("Dics","Accounting")
//                 },
//                 coa: {
//                     id: "coa",
//                     value: LangHelper.GetString("Dics","CoA parameters")
//                 },
//                 dhcp:{
//                     id:"dhcp",
//                     value: LangHelper.GetString("Dics", "DHCP parameters")
//                 },
//                 fifo: {
//                     id: "fifo",
//                     value: LangHelper.GetString("Dics", "Persistent FIFO")
//                 }
//             }
//         }
//     };
//
// var FastPcrfConfigDic =
//     {
//         daemon: {
//             id: "daemon",
//             title: LangHelper.GetString("Dics", "Startup fdpi_pcrf as daemon") + " (daemon)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "No")},
//                 "2": {"id": "1", "value": LangHelper.GetString("Dics", "Yes")}
//             },
//             tooltip: LangHelper.GetString("Dics", "Startup fdpi_pcrf as daemon") + ".",
//             default: 0,
//             groups: {
//                 default: "general"
//             }
//         },
//         verbose: {
//             id: "verbose",
//             title: LangHelper.GetString("Dics", "Detailed logging") + " (verbose)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "No")},
//                 "2": {"id": "1", "value": LangHelper.GetString("Dics", "Yes")}
//             },
//             tooltip: LangHelper.GetString("Dics", "Detailed logging") + ".",
//             default: 0,
//             groups: {
//                 default: "general"
//             }
//         },
//         trace: {
//             id: "trace",
//             title: LangHelper.GetString("Dics", "Trace flags by subsystems") + " (trace)",
//             view: "multiselectmask8",
//             options: [
//                 {id: "0x00000001", value: LangHelper.GetString("Dics", "Radius connections monitor")},
//                 {id: "0x00000002", value: LangHelper.GetString("Dics", "Internal task scheduler")},
//                 {id: "0x00000010", value: LangHelper.GetString("Dics", "Auth server")},
//                 {id: "0x00000200", value: LangHelper.GetString("Dics", "radius_client connections")},
//                 {id: "0x00000400", value: LangHelper.GetString("Dics", "radius_client monitor")},
//                 {id: "0x00001000", value: LangHelper.GetString("Dics", "CoA-server events")},
//                 {id: "0x00002000", value: LangHelper.GetString("Dics", "CoA-listener connects")},
//                 {id: "0x00004000", value: LangHelper.GetString("Dics", "CoA-requests")},
//                 {id: "0x00010000", value: LangHelper.GetString("Dics", "fastDPI sending data events")},
//                 {id: "0x00020000", value: LangHelper.GetString("Dics", "Events queue from fastPCRF to fastDPI")},
//                 {id: "0x00100000", value: LangHelper.GetString("Dics", "start/stop accounting requests")},
//                 {id: "0x00200000", value: LangHelper.GetString("Dics", "interim update accounting requests")},
//                 {id: "0x00400000", value: LangHelper.GetString("Dics", "Raw accounting data from fastDPI receiving")}
//             ],
//             tooltip: LangHelper.GetString("Dics", "Trace flags by subsystems") + ".<br/>" + LangHelper.GetString("Dics", "trace param ignoring if verbose=1."),
//             groups: {
//                 default: "general"
//             }
//         },
//         rlimit_fsize: {
//             id: "rlimit_fsize",
//             title: LangHelper.GetString("Dics", "Max filesize") + " (rlimit_fsize)",
//             view: "text",
//             tooltip: LangHelper.GetString("Dics", "Max filesize") + ". " + LangHelper.GetString("Dics", "Default value is 1G (1073741824 bytes)") + ".",
//             default: "1G",
//             groups: {
//                 default: "general"
//             }
//         },
//         print_stat_period: {
//             id: "print_stat_period",
//             title: LangHelper.GetString("Dics", "Statistics output period in seconds") + " (print_stat_period)",
//             view: "text",
//             tooltip: LangHelper.GetString("Dics", "Statistics output period in seconds") + ".<br/>" + LangHelper.GetString("Dics", "Default value is 300 seconds (every 5 minutes)."),
//             default: 300,
//             groups: {
//                 default: "general"
//             },
//             "validate": function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
//         },
//         work_thread_count: {
//             id: "work_thread_count",
//             title: LangHelper.GetString("Dics", "Working threads number") + " (work_thread_count)",
//             view: "text",
//             tooltip: LangHelper.GetString("Dics", "Working threads number") + ".<br/>" + LangHelper.GetString("Dics", "Every fdpi_pcrf component can live in separate thread.<br/>Setting threads number greater then 5 is pointless."),
//             default: 5,
//             groups: {
//                 default: "general"
//             },
//             "validate": function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
//         },
//         async_queue_size: {
//             id: "async_queue_size",
//             title: LangHelper.GetString("Dics", "Internal asynchronous message transfer queue size") + " (async_queue_size)",
//             view: "text",
//             tooltip: LangHelper.GetString("Dics", "Internal asynchronous message transfer queue size") +
//             ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 512*1024=524288.") +
//             "<br/>" +
//             LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior."),
//             default: 512 * 1024,
//             groups: {
//                 default: "general"
//             },
//             "validate": function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
//         },
//         default_reject_policing: {
//             id: "default_reject_policing",
//             title: LangHelper.GetString("Dics", "Policing profile name for unauthorized users") + "(default_reject_policing)",
//             view: "text",
//             tooltip: LangHelper.GetString("Dics", "Policing profile name for unauthorized users"),
//             groups: {
//                 default: "general"
//             }
//         },
//         default_reject_whitelist: {
//             id: "default_reject_whitelist",
//             title: LangHelper.GetString("Dics", "White list (service 5) profile name for unauthorized users") + "(default_reject_whitelist)",
//             view: "text",
//             tooltip: LangHelper.GetString("Dics", "White list (service 5) profile name for unauthorized users"),
//             groups: {
//                 default: "general"
//             }
//         },
//
//         fdpi_server: {
//             id: "fdpi_server",
//             title: LangHelper.GetString("Dics", "fastDPI server") + "(fdpi_server)",
//             view: "text",
//             placeholder: "127.0.0.1%lo:29000;attr_nas_ip=5.5.5.5",
//             groups: {
//                 default: "auth"
//             },
//             tooltip: LangHelper.GetString("Dics", "fastDPI server") + "<br/><br/>" +
//             LangHelper.GetString("Dics", "Format is") + " ip%dev:port[;name=value]*<br/>" +
//             LangHelper.GetString("Dics", "where:") + "<br/>" +
//             LangHelper.GetString("Dics", " - ip - fastDPI server ip-address") + ";<br/>" +
//             LangHelper.GetString("Dics", " - dev - interface name for connecting") + ";<br/>" +
//             LangHelper.GetString("Dics", " - port - port for fastpcrf->fastdpi connection (29000 - default fdpi_ctrl port)") + ";<br/>" +
//             LangHelper.GetString("Dics", " - name=value - additional server parameters") + ":<br/>" +
//             LangHelper.GetString("Dics", "   - attr_nas_ip  - IPv4 address for NAS-IP-Address attribute; using fastdpi IP-address if not set") + ";<br/>" +
//             LangHelper.GetString("Dics", "   - attr_nas_ipv6  - NAS-IPv6-Address attribute value for current fastdpi") + ";<br/>" +
//             LangHelper.GetString("Dics", "   - attr_nas_id  - NAS-Identifier attribute value for current fastdpi") + "."
//         },
//         fdpi_server_list: {
//             id: "fdpi_server_list",
//             title: LangHelper.GetString("Dics", "fastDPI server list") + "(fdpi_server_list)",
//             view: "text",
//             placeholder: "127.0.0.1%lo:29000,10.10.10.42%eth0:29000",
//             groups: {
//                 default: "auth"
//             },
//             tooltip: LangHelper.GetString("Dics", "fastDPI server list") + "<br/><br/>" +
//             LangHelper.GetString("Dics", "Format is") + " ip%dev:port{,ip%dev:port}*<br/>" +
//             LangHelper.GetString("Dics", "where:") + "<br/>" +
//             LangHelper.GetString("Dics", " - ip - fastDPI server ip-address") + ";<br/>" +
//             LangHelper.GetString("Dics", " - dev - interface name for connecting") + ";<br/>" +
//             LangHelper.GetString("Dics", " - port - port for fastpcrf->fastdpi connection (29000 - default fdpi_ctrl port)") + ";<br/>" +
//             LangHelper.GetString("Dics", "Using parameters fdpi_server allows you to set additional attributes for each fastdpi-server") + "."
//         },
//         auth_server_dev: {
//             id: "auth_server_dev",
//             title: LangHelper.GetString("Dics", "Connection listener interface(device) name") + "(auth_server_dev)",
//             view: "text",
//             placeholder: "eth0",
//             default: "eth0",
//             groups: {
//                 default: "auth"
//             },
//             tooltip: LangHelper.GetString("Dics", "Connection listener interface(device) name")
//         },
//         auth_server_port: {
//             id: "auth_server_port",
//             title: LangHelper.GetString("Dics", "Listen port") + "(auth_server_port)",
//             view: "text",
//             placeholder: "29002",
//             default: 29002,
//             groups: {
//                 default: "auth"
//             },
//             tooltip: LangHelper.GetString("Dics", "Listen port") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is") + " 29002.",
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             }
//         },
//         auth_server_max_connection: {
//             id: "auth_server_max_connection",
//             title: LangHelper.GetString("Dics", "Inbound connections max number") + "(auth_server_max_connection)",
//             view: "text",
//             placeholder: "16",
//             default: 16,
//             groups: {
//                 default: "auth"
//             },
//             tooltip: LangHelper.GetString("Dics", "Inbound connections max number") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is") + " 16.",
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             }
//         },
//
//         radius_server: {
//             id: "radius_server",
//             title: LangHelper.GetString("Dics", "Radius server configuration") + "(radius_server)",
//             view: "text",
//             placeholder: "radius_server=secret@10.10.3.5:1812;conf=radius-main.conf;msg_auth_attr=1",
//             groups: {
//                 default: "radius_servers"
//             },
//             tooltip: LangHelper.GetString("Dics", "Radius server configuration") + "<br/><br/>" +
//             LangHelper.GetString("Dics", "Format is") + " secret@ip%dev:port{;param=value}*<br/>" +
//             LangHelper.GetString("Dics", "where:") + "<br/>" +
//             LangHelper.GetString("Dics", " - secret - radius server secret") + ";<br/>" +
//             LangHelper.GetString("Dics", " - ip - radius server ip-address") + ";<br/>" +
//             LangHelper.GetString("Dics", " - dev(not required) - interface name for connecting") + ";<br/>" +
//             LangHelper.GetString("Dics", " - port - port") + ";<br/>" +
//             LangHelper.GetString("Dics", " - param=value - set of radius server configuration parameters") + "."
//         },
//         radius_revive_period: {
//             id: "radius_revive_period",
//             title: LangHelper.GetString("Dics", "Radius server revive period(in seconds)") + "(radius_revive_period)",
//             view: "text",
//             default: 120,
//             tooltip: LangHelper.GetString("Dics", "Radius server revive period(in seconds)") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 120 seconds") + ".<br/>"
//             ,
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_max_connect_count: {
//             id: "radius_max_connect_count",
//             title: LangHelper.GetString("Dics", "Max number of connections to server") + "(radius_max_connect_count)",
//             view: "text",
//             default: 16,
//             tooltip: LangHelper.GetString("Dics", "Max number of connections to server") + ".<br/>" +
//             LangHelper.GetString("Dics", "Each connection can serve less then 256 simultaneous requests") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 16") + ".<br/>" +
//             LangHelper.GetString("Dics", "Value 0 is unlimited; this opportunity should be used very carefully!")
//             ,
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_max_acct_connect_count: {
//             id: "radius_max_acct_connect_count",
//             title: LangHelper.GetString("Dics", "Accounting auth port connections max number") + "(radius_max_acct_connect_count)",
//             view: "text",
//             default: 2,
//             tooltip: LangHelper.GetString("Dics", "Accounting auth port connections max number") + ".<br/>" +
//             LangHelper.GetString("Dics", "Each connection can serve less then 256 simultaneous requests") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 2") + ".<br/>"
//             ,
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_response_timeout: {
//             id: "radius_response_timeout",
//             title: LangHelper.GetString("Dics", "Response time, seconds") + "(radius_response_timeout)",
//             view: "text",
//             default: 2,
//             tooltip: LangHelper.GetString("Dics", "Response time, seconds") + ".<br/>" +
//             LangHelper.GetString("Dics", "If will not received response for Access-Request for this time, the request will be repeated radius_resend_count times") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 30") + ".<br/>"
//             ,
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_resend_count: {
//             id: "radius_resend_count",
//             title: LangHelper.GetString("Dics", "Attempts to send request max number") + "(radius_resend_count)",
//             view: "text",
//             tooltip: LangHelper.GetString("Dics", "Attempts to send request max number") + ".<br/>" +
//             LangHelper.GetString("Dics", "0 - do not repeat") + "."
//             ,
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_dead_timeout: {
//             id: "radius_dead_timeout",
//             title: LangHelper.GetString("Dics", "Radius server dead timeout, seconds") + "(radius_dead_timeout)",
//             view: "text",
//             default: 2,
//             tooltip: LangHelper.GetString("Dics", "Response time, seconds") + ".<br/>" +
//             LangHelper.GetString("Dics", "Current radius server considered dead if will not received response for any request for this time") + "<br/>" +
//             LangHelper.GetString("Dics", "and fdpi_pcrf will try to switch to another radius server") + ".<br/>" +
//             LangHelper.GetString("Dics", "This parameter must be at least 2 times smaller than radius_revive_period") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 30") + ".<br/>",
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_status_server: {
//             id: "radius_status_server",
//             title: LangHelper.GetString("Dics", "Radius server Status-Server request") + " (radius_status_server)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "No")},
//                 "2": {"id": "1", "value": LangHelper.GetString("Dics", "Yes")}
//             },
//             tooltip: LangHelper.GetString("Dics", "Radius server Status-Server request") + ".",
//             default: 1,
//             groups: {
//                 default: "radius"
//             }
//         },
//         radius_msg_auth_attr: {
//             id: "radius_msg_auth_attr",
//             title: LangHelper.GetString("Dics", "Radius server Message-Authenticator attribute") + " (radius_msg_auth_attr)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "No")},
//                 "2": {"id": "1", "value": LangHelper.GetString("Dics", "Yes")}
//             },
//             tooltip: LangHelper.GetString("Dics", "Radius server Message-Authenticator attribute") + ".",
//             default: 1,
//             groups: {
//                 default: "radius"
//             }
//         },
//         radius_user_name_auth: {
//             id: "radius_user_name_auth",
//             title: LangHelper.GetString("Dics", "User-Name attribute for L3 auth-requests Accept-Request") + "(radius_user_name_auth)",
//             view: "text",
//             placeholder: "login,ip,qinq",
//             default: "login,ip,qinq",
//             groups: {
//                 default: "radius"
//             },
//             tooltip: LangHelper.GetString("Dics", "User-Name attribute for L3 auth-requests Accept-Request") + "<br/><br/>" +
//             LangHelper.GetString("Dics", "List of identifiers") + ".<br/>" +
//             LangHelper.GetString("Dics", "Valid values:") + "<br/>" +
//             LangHelper.GetString("Dics", " - login: User-Name=login, if login known") + ";<br/>" +
//             LangHelper.GetString("Dics", " - ip: User-Name=ip as string") + ";<br/>" +
//             LangHelper.GetString("Dics", " - qinq:User-Name=outerVlan.innerVlan, if web is QinQ(double VLAN, vlan-per-user)") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is") + " login,ip,qinq."
//         },
//         radius_user_name_dhcp: {
//             id: "radius_user_name_dhcp",
//             title: LangHelper.GetString("Dics", "User-Name attribute for DHCP-requests Accept-Request") + "(radius_user_name_dhcp)",
//             view: "text",
//             placeholder: "mac,qinq",
//             default: "mac,qinq",
//             groups: {
//                 default: "radius"
//             },
//             tooltip: LangHelper.GetString("Dics", "User-Name attribute for DHCP-requests Accept-Request") + "<br/><br/>" +
//             LangHelper.GetString("Dics", "List of identifiers") + ".<br/>" +
//             LangHelper.GetString("Dics", "Valid values:") + "<br/>" +
//             LangHelper.GetString("Dics", " - mac: User-Name=mac-address as string like \"XX:XX:XX:XX:XX:XX\"") + ";<br/>" +
//             LangHelper.GetString("Dics", " - qinq:User-Name=outerVlan.innerVlan, if web is QinQ(double VLAN, vlan-per-user)") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is") + " mac,qinq."
//         },
//         radius_user_name_arp: {
//             id: "radius_user_name_arp",
//             title: LangHelper.GetString("Dics", "User-Name attribute for ARP-requests Accept-Request") + "(radius_user_name_arp)",
//             view: "text",
//             placeholder: "mac,qinq",
//             default: "mac,qinq",
//             groups: {
//                 default: "radius"
//             },
//             tooltip: LangHelper.GetString("Dics", "User-Name attribute for ARP-request Accept-Request") + "<br/><br/>" +
//             LangHelper.GetString("Dics", "List of identifiers") + ".<br/>" +
//             LangHelper.GetString("Dics", "Valid values:") + "<br/>" +
//             LangHelper.GetString("Dics", " - mac: User-Name=mac-address as string like \"XX:XX:XX:XX:XX:XX\"") + ";<br/>" +
//             LangHelper.GetString("Dics", " - qinq:User-Name=outerVlan.innerVlan, if web is QinQ(double VLAN, vlan-per-user)") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is") + " mac,qinq."
//         },
//         radius_user_password: {
//             id: "radius_user_password",
//             title: LangHelper.GetString("Dics", "User-Password attribute for requests Accept-Request") + "(radius_user_password)",
//             view: "text",
//             placeholder: "VasExperts.FastDPI",
//             default: "VasExperts.FastDPI",
//             groups: {
//                 default: "radius"
//             },
//             tooltip: LangHelper.GetString("Dics", "User-Password attribute for request Accept-Request") + "<br/><br/>" +
//             LangHelper.GetString("Dics", "Default value is") + " VasExperts.FastDPI."
//         },
//         radius_attr_nas_port_type: {
//             id: "radius_attr_nas_port_type",
//             title: LangHelper.GetString("Dics", "NAS-Port-Type attribute value for request Access-Request") + "(radius_attr_nas_port_type)",
//             view: "text",
//             default: 5,
//             tooltip: LangHelper.GetString("Dics", "NAS-Port-Type attribute value for request Access-Request") + ".<br/>" +
//             LangHelper.GetString("Dics", "The list of valid values is given by RFC 2865") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 5 (Virtual)") + ".<br/>",
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_attr_service_type: {
//             id: "radius_attr_service_type",
//             title: LangHelper.GetString("Dics", "Service-Type attribute value for request Access-Request") + "(radius_attr_service_type)",
//             view: "text",
//             default: 2,
//             tooltip: LangHelper.GetString("Dics", "Service-Type attribute value for request Access-Request") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 2 (Framed)") + ".<br/>",
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_acct_port: {
//             id: "radius_acct_port",
//             title: LangHelper.GetString("Dics", "Accounting Radius-server port") + "(radius_acct_port)",
//             view: "text",
//             placeholder: "1813",
//             tooltip: LangHelper.GetString("Dics", "Accounting Radius-server port") + ".<br/>",
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_acct_interim_interval: {
//             id: "radius_acct_interim_interval",
//             title: LangHelper.GetString("Dics", "Time interval for sending intermediate accounting, in seconds") + "(radius_acct_interim_interval)",
//             view: "text",
//             default: 1800,
//             tooltip: LangHelper.GetString("Dics", "Time interval for sending intermediate accounting, in seconds") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 1800") + ".<br/>" +
//             LangHelper.GetString("Dics", "Minimum value is 60") + ".<br/>",
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_acct_interim_volume: {
//             id: "radius_acct_interim_volume",
//             title: LangHelper.GetString("Dics", "Interim update will sent if traffic amount greater then volume") + "(radius_acct_interim_volume)",
//             view: "text",
//             default: 0,
//             tooltip: LangHelper.GetString("Dics", "Interim update will sent if traffic amount greater then volume") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 0 (only by time)") + ".<br/>" +
//             LangHelper.GetString("Dics", "Set in bytes, kilobytes (65K), megabytes(65M), gigabytes(10G)") + ".<br/>",
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             }
//         },
//         radius_acct_idle_timeout: {
//             id: "radius_acct_idle_timeout",
//             title: LangHelper.GetString("Dics", "Accounting data persistence timeout, in seconds") + "(radius_acct_idle_timeout)",
//             view: "text",
//             default: 1800,
//             tooltip: LangHelper.GetString("Dics", "Accounting data persistence timeout, in seconds") + ".<br/>" +
//             LangHelper.GetString("Dics", "If during this timeout the subscriber statistics did not change, it is considered that the subscriber's session is timed out and sent Accounting Stop.") + ".<br/>",
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_coa_port: {
//             id: "radius_coa_port",
//             title: LangHelper.GetString("Dics", "CoA notifications receiving UDP-port") + "(radius_coa_port)",
//             view: "text",
//             default: 3799,
//             tooltip: LangHelper.GetString("Dics", "CoA notifications receiving UDP-port") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is") + " 3799(RFC 5176).<br/>" +
//             LangHelper.GetString("Dics", "Set this parameter value 0 if radius server not provides CoA") + ".",
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_coa_resend_timeout: {
//             id: "radius_coa_resend_timeout",
//             title: LangHelper.GetString("Dics", "CoA-response resending timeout, in seconds") + "(radius_coa_resend_timeout)",
//             view: "text",
//             default: 1,
//             tooltip: LangHelper.GetString("Dics", "CoA-response resending timeout, in seconds") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is") + " 1.<br/>" +
//             LangHelper.GetString("Dics", "Resend number is setting by radius_resend_count parameter") + ".",
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         acct_check_idle_mode: {
//             id: "acct_check_idle_mode",
//             title: LangHelper.GetString("Dics", "Stop occurrence control mode by data invariance") + " (acct_check_idle_mode)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "No changes in inbound and outbound traffic")},
//                 "2": {"id": "1", "value": LangHelper.GetString("Dics", "No changes in outbound traffic only")}
//             },
//             tooltip: LangHelper.GetString("Dics", "Stop occurrence control mode by data invariance") + ".",
//             default: 0,
//             groups: {
//                 default: "accounting"
//             }
//         },
//         acct_start_point: {
//             id: "acct_start_point",
//             title: LangHelper.GetString("Dics", "Accounting start point") + " (acct_start_point)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "From the last Stop event")},
//                 "2": {
//                     "id": "1",
//                     "value": LangHelper.GetString("Dics", "From the start of Start event. Ignore all traffic from the last Stop event")
//                 }
//             },
//             tooltip: LangHelper.GetString("Dics", "Accounting start point") + ".",
//             default: 0,
//             groups: {
//                 default: "accounting"
//             }
//         },
//         acct_auth_sync: {
//             id: "acct_auth_sync",
//             title: LangHelper.GetString("Dics", "Sign of compatibility with LanBilling") + " (acct_auth_sync)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "acct and auth are out of sync")},
//                 "2": {"id": "1", "value": LangHelper.GetString("Dics", "acct and auth synchronized")}
//             },
//             tooltip: LangHelper.GetString("Dics", "Sign of compatibility with LanBilling") + ".",
//             default: 0,
//             groups: {
//                 default: "accounting"
//             }
//         },
//         acct_framed_ip_address_nat: {
//             id: "acct_framed_ip_address_nat",
//             title: LangHelper.GetString("Dics", "Acct-Request attributes format") + " (acct_framed_ip_address_nat)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "Default")},
//                 "2": {"id": "1", "value": LangHelper.GetString("Dics", "NAT 1:1 and subscriber's white address known")}
//             },
//             tooltip: LangHelper.GetString("Dics", "Sign of compatibility with LanBilling") + ".",
//             default: 0,
//             groups: {
//                 default: "accounting"
//             }
//         },
//         acct_heartbeat: {
//             id: "acct_heartbeat",
//             title: LangHelper.GetString("Dics", "Frequency of sending ready accounting data, in seconds") + "(acct_heartbeat)",
//             view: "text",
//             default: 5,
//             tooltip: LangHelper.GetString("Dics", "Frequency of sending ready accounting data, in seconds") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is") + " 5.<br/>" +
//             LangHelper.GetString("Dics", "<b>Do not change this setting</b>."),
//             groups: {
//                 default: "accounting"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         acct_swap_dir: {
//             id: "acct_swap_dir",
//             title: LangHelper.GetString("Dics", "Swap traffic direction for accounting Radius-attributes") + " (acct_swap_dir)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "Do not change")},
//                 "2": {"id": "1", "value": LangHelper.GetString("Dics", "Swap inbound/uotbound traffic counters")}
//             },
//             tooltip: LangHelper.GetString("Dics", "Swap traffic direction for accounting Radius-attributes") + ".",
//             default: 0,
//             groups: {
//                 default: "accounting"
//             }
//         },
//         acct_disable_traffic_class: {
//             id: "acct_disable_traffic_class",
//             title: LangHelper.GetString("Dics", "Disable sending to Acct-Request traffic class breakdown") + " (acct_disable_traffic_class)",
//             view: "richselect",
//             options: {
//                 "1": {"id": "0", "value": LangHelper.GetString("Dics", "No")},
//                 "2": {"id": "1", "value": LangHelper.GetString("Dics", "Yes")}
//             },
//             tooltip: LangHelper.GetString("Dics", "Disable sending to Acct-Request traffic class breakdown") + ".",
//             default: 0,
//             groups: {
//                 default: "accounting"
//             }
//         },
//         acct_include_traffic_class: {
//             id: "acct_include_traffic_class",
//             title: LangHelper.GetString("Dics", "What traffic classes to include in accounting") + "(acct_include_traffic_class)",
//             view: "multiselect",
//             options: [
//                 {id: "cs0", value: "cs0"},
//                 {id: "cs1", value: "cs1"},
//                 {id: "cs2", value: "cs2"},
//                 {id: "cs3", value: "cs3"},
//                 {id: "cs4", value: "cs4"},
//                 {id: "cs5", value: "cs5"},
//                 {id: "cs6", value: "cs6"},
//                 {id: "cs7", value: "cs7"}
//             ],
//             default: "cs0,cs1,cs2,cs3,cs4,cs5,cs6,cs7",
//             groups: {
//                 default: "accounting"
//             },
//             tooltip: LangHelper.GetString("Dics", "What traffic classes to include in accounting") + "<br/><br/>" +
//             LangHelper.GetString("Dics", "List of classes") + ".<br/>"
//         },
//         coa_max_pending_requests: {
//             id: "coa_max_pending_requests",
//             title: LangHelper.GetString("Dics", "Pending CoA-requests from radius-servers max number") + "(radius_max_pending_requests)",
//             view: "text",
//             default: 100000,
//             tooltip: LangHelper.GetString("Dics", "Pending CoA-requests from radius-servers max number") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 100000") + ".<br/>"
//             ,
//             groups: {
//                 default: "coa"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         coa_client: {
//             id: "coa_client",
//             title: LangHelper.GetString("Dics", "CoA-client format") + "(coa_client)",
//             view: "text",
//             placeholder: "fastDPI@188.227.73.42%eth0:13799",
//             groups: {
//                 default: "coa"
//             },
//             tooltip: LangHelper.GetString("Dics", "CoA-client format") + "<br/><br/>" +
//             LangHelper.GetString("Dics", "Format is") + " secret@ip%dev:port<br/>" +
//             LangHelper.GetString("Dics", "where:") + "<br/>" +
//             LangHelper.GetString("Dics", " - secret - shared secret") + ";<br/>" +
//             LangHelper.GetString("Dics", " - ip - CoA-client ip-address") + ";<br/>" +
//             LangHelper.GetString("Dics", " - dev - interface for caching CoA-client alerts") + ";<br/>" +
//             LangHelper.GetString("Dics", " - port - UDP-port") + ";<br/>"
//         },
//         dhcp_netmask: {
//             id: "dhcp_netmask",
//             title: LangHelper.GetString("Dics", "DHCP Netmask") + "(dhcp_netmask)",
//             view: "text",
//             placeholder: "255.255.0.0",
//             groups: {
//                 default: "dhcp"
//             },
//             tooltip: LangHelper.GetString("Dics", "DHCP Netmask") + "."
//         },
//         dhcp_gateway: {
//             id: "dhcp_gateway",
//             title: LangHelper.GetString("Dics", "DHCP Gateway") + "(dhcp_gateway)",
//             view: "text",
//             placeholder: "192.168.1.1",
//             groups: {
//                 default: "dhcp"
//             },
//             tooltip: LangHelper.GetString("Dics", "DHCP Gateway") + "."
//         },
//         dhcp_mtu: {
//             id: "dhcp_mtu",
//             title: LangHelper.GetString("Dics", "MTU size") + "(dhcp_mtu)",
//             view: "text",
//             placeholder: "1500",
//             groups: {
//                 default: "dhcp"
//             },
//             tooltip: LangHelper.GetString("Dics", "MTU size") + ".",
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         dhcp_lease_time: {
//             id: "dhcp_lease_time",
//             title: LangHelper.GetString("Dics", "Ip address lease time, seconds") + "(dhcp_lease_time)",
//             view: "text",
//             placeholder: "86400",
//             groups: {
//                 default: "dhcp"
//             },
//             tooltip: LangHelper.GetString("Dics", "Ip address lease time, seconds") + ".",
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         dhcp_dns: {
//             id: "dhcp_dns",
//             title: LangHelper.GetString("Dics", "DNS address") + "(dhcp_dns)",
//             view: "text",
//             placeholder: "192.168.1.250",
//             groups: {
//                 default: "dhcp"
//             },
//             tooltip: LangHelper.GetString("Dics", "DNS address") + "."
//         },
//         dhcp_static_route: {
//             id: "dhcp_static_route",
//             title: LangHelper.GetString("Dics", "Static routing table") + "(dhcp_static_route)",
//             view: "text",
//             placeholder: "10.20.0.0/16 192.168.12.252",
//             groups: {
//                 default: "dhcp"
//             },
//             tooltip: LangHelper.GetString("Dics", "Static routing table") + "."
//         },
//         fdpi_pqueue_dir: {
//             id: "fdpi_pqueue_dir",
//             title: LangHelper.GetString("Dics", "Persistent FIFO folder") + "(fdpi_pqueue_dir)",
//             view: "text",
//             placeholder: "/var/spool/dpi/pcrf",
//             default: "/var/spool/dpi/pcrf",
//             groups: {
//                 default: "fifo"
//             },
//             tooltip: LangHelper.GetString("Dics", "Persistent FIFO folder") + "."
//         },
//         fdpi_pqueue_max_pagecount: {
//             id: "fdpi_pqueue_max_pagecount",
//             title: LangHelper.GetString("Dics", "Queue pages max number") + "(fdpi_pqueue_max_pagecount)",
//             view: "text",
//             placeholder: "0",
//             groups: {
//                 default: "fifo"
//             },
//             tooltip: LangHelper.GetString("Dics", "Queue pages max number") + ".<br/>" +
//             LangHelper.GetString("Dics", "Page size is 2M.") + "<br/>" +
//             LangHelper.GetString("Dics", "0 - pages number is unlimited.") + "<br/>" +
//             LangHelper.GetString("Dics", "Minimal value is 2.") + "<br/>" +
//             LangHelper.GetString("Dics", "Queue max files size is rlimit_fsize. Queue can not be greater then rlimit_fsize.")
//             ,
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         fdpi_reconnect_timeout: {
//             id: "fdpi_reconnect_timeout",
//             title: LangHelper.GetString("Dics", "Reconncet to fastdpi servers timeout, seconds") + "(fdpi_reconnect_timeout)",
//             view: "text",
//             placeholder: "2",
//             groups: {
//                 default: "fifo"
//             },
//             tooltip: LangHelper.GetString("Dics", "Reconncet to fastdpi servers timeout, seconds") + ".<br/>",
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         },
//         radius_max_pending_requests: {
//             id: "radius_max_pending_requests",
//             title: LangHelper.GetString("Dics", "Pending requests from fastdpi-servers max number") + "(radius_max_pending_requests)",
//             view: "text",
//             default: 1000000,
//             tooltip: LangHelper.GetString("Dics", "Pending requests from fastdpi-servers max number") + ".<br/>" +
//             LangHelper.GetString("Dics", "Default value is 1000000") + ".<br/>"
//             ,
//             groups: {
//                 default: "radius"
//             },
//             validate: function (Val) {
//                 return !isNaN(Val * 1);
//             },
//             invalidMessage: LangHelper.GetString("Dics", "Enter the number")
//         }
//     };

var LiRequestConnectionTypeDic =
    {
        "0": {"value": LangHelper.GetString("ConnectionsValidateData", "Connecting to data network"), "id": "0"},
        "1": {"value": LangHelper.GetString("ConnectionsValidateData", "Disconnecting from data network"), "id": "1"}
    };

var LiRequestHttpMethodDic =
    {
        "0": {"value": LangHelper.GetString("ConnectionsValidateData", "GET"), "id": "0"},
        "1": {"value": LangHelper.GetString("ConnectionsValidateData", "POST"), "id": "1"},
        "2": {"value": LangHelper.GetString("ConnectionsValidateData", "PUT"), "id": "2"},
        "3": {"value": LangHelper.GetString("ConnectionsValidateData", "DELETE"), "id": "3"}
    };

var HttpMethodDic = LiRequestHttpMethodDic;

var ImProtocolDic =
    {
        "0": {"value": "icq", "id": "0"},
        "1": {"value": "aol", "id": "1"},
        "2": {"value": "msn", "id": "2"},
        "3": {"value": "yahoo", "id": "3"},
        "4": {"value": "web-mail", "id": "4"},
        "5": {"value": "skype", "id": "5"},
        "6": {"value": "irc", "id": "6"},
        "7": {"value": "jabber", "id": "7"},
        "8": {"value": "mra", "id": "8"},
        "9": {"value": "tencent", "id": "9"},
        "10": {"value": "airway", "id": "10"},
        "98": {"value": "mms", "id": "98"},
        "99": {"value": "sms", "id": "99"},
        "100": {"value": "vk", "id": "100"},
        "101": {"value": "facebook", "id": "101"},
        "102": {"value": "myspace", "id": "102"},
        "103": {"value": "twitter", "id": "103"},
        "104": {"value": "odnoklassniki", "id": "104"},
        "105": {"value": "moymir", "id": "105"}
    };

var VoipProtocolDic =
    {
        "0": {"value": "sip", "id": "0"},
        "1": {"value": "h323", "id": "1"},
        "2": {"value": "iax", "id": "2"},
        "100": {"value": "skype", "id": "100"}
    };

var PstnPhoneAbonentTypeDic =
    {
        "0": {"value": LangHelper.GetString("ConnectionsValidateData", "Subscriber of this switch"), "id": "0"},
        "1": {
            "value": LangHelper.GetString("ConnectionsValidateData", "Subscriber of communication network"),
            "id": "1"
        },
        "2": {"value": LangHelper.GetString("ConnectionsValidateData", "Rowmer"), "id": "2"}
    };

var EmailProtocolDic =
    {
        "0": {"value": "smtp", "id": "0"},
        "1": {"value": "pop3", "id": "1"},
        "2": {"value": "imap", "id": "2"},
        "3": {"value": "web-mail", "id": "3"}
    };

var FtpServerModelDic =
    {
        "0": {"value": LangHelper.GetString("ConnectionsValidateData", "Active"), "id": "0"},
        "1": {"value": LangHelper.GetString("ConnectionsValidateData", "Passive"), "id": "1"}
    };

var TermProtocolDic =
    {
        "0": {"value": "telnet", "id": "0"},
        "1": {"value": "ssh", "id": "1"},
        "2": {"value": "scp", "id": "2"}
    };

var TaskStatusesDic =
    {
        "0": {"value": LangHelper.GetString("ConnectionsValidateData", "Data is not ready"), "id": "0"},
        "1": {"value": LangHelper.GetString("ConnectionsValidateData", "Data ready"), "id": "1"},
        "2": {"value": LangHelper.GetString("ConnectionsValidateData", "Data not found"), "id": "2"},
        "3": {"value": LangHelper.GetString("ConnectionsValidateData", "Error"), "id": "3"},
        "1000": {"value": LangHelper.GetString("ConnectionsValidateData", "Data canceled"), "id": "1000"},
        "1001": {"value": LangHelper.GetString("ConnectionsValidateData", "Data deleted"), "id": "1001"}
    };

var TragenTaskStatusesDic =
    {
        "0": {"value": LangHelper.GetString("TrafficManagementGenerator", "New"), "id": "0"},
        "1": {"value": LangHelper.GetString("TrafficManagementGenerator", "Launched"), "id": "1"},
        "2": {"value": LangHelper.GetString("TrafficManagementGenerator", "Stopped"), "id": "2"},
        "3": {"value": LangHelper.GetString("TrafficManagementGenerator", "Error"), "id": "3"}
    };

var TragenTaskGenerationStatusesDic =
    {
        "0": {"value": LangHelper.GetString("TrafficManagementGenerator", "New"), "id": "0"},
        "1": {"value": LangHelper.GetString("TrafficManagementGenerator", "Initialization"), "id": "1"},
        "2": {"value": LangHelper.GetString("TrafficManagementGenerator", "Generation"), "id": "2"},
        "3": {"value": LangHelper.GetString("TrafficManagementGenerator", "Stopped"), "id": "3"},
        "4": {"value": LangHelper.GetString("TrafficManagementGenerator", "Error"), "id": "4"}
    };

var TragenTypesDic =
    {
        "udp": {"value": LangHelper.GetString("TrafficManagementGenerator", "UDP flood generator"), "id": "udp"},
        "http2": {"value": LangHelper.GetString("TrafficManagementGenerator", "HTTP flood generator"), "id": "http2"},
        "tcp-syn": {
            "value": LangHelper.GetString("TrafficManagementGenerator", "TCP SYN flood generator"),
            "id": "tcp-syn"
        },
        "pcap-sample": {
            "value": LangHelper.GetString("TrafficManagementGenerator", "Pcap sample generator"),
            "id": "pcap-sample"
        }
    };

var TaskTypeEnum = {
    ui: "ui",
    udp: "udp",
    tcpsyn: "tcp-syn",
    http2: "http2",
    pcapsample: "pcap-sample"
};

var WgetTaskStatusesDic =
    {
        "0": {"value": LangHelper.GetString("TrafficManagementSiteClone", "NewTask"), "id": "0"},
        "1": {"value": LangHelper.GetString("TrafficManagementSiteClone", "Launched"), "id": "1"},
        "2": {"value": LangHelper.GetString("TrafficManagementSiteClone", "Stopped"), "id": "2"},
        "3": {"value": LangHelper.GetString("TrafficManagementSiteClone", "Error"), "id": "3"}
    };

var WgetTaskVhostStatusesDic =
    {
        "0": {"value": LangHelper.GetString("TrafficManagementSiteClone", "Disabled"), "id": "0"},
        "1": {"value": LangHelper.GetString("TrafficManagementSiteClone", "Enabled"), "id": "1"}
    };

var WgetTaskDataStatusesDic =
    {
        "0": {"value": LangHelper.GetString("TrafficManagementSiteClone", "NewFile"), "id": "0"},
        "1": {"value": LangHelper.GetString("TrafficManagementSiteClone", "Scanning"), "id": "1"},
        "2": {"value": LangHelper.GetString("TrafficManagementSiteClone", "Saved"), "id": "2"},
        "3": {"value": LangHelper.GetString("TrafficManagementSiteClone", "Not saved"), "id": "3"},
        "4": {"value": LangHelper.GetString("TrafficManagementSiteClone", "Error"), "id": "4"}
    };

var WgetSpoofingTemplatesDic =
    {
        "FacebookCredentialsCollect": {
            "value": LangHelper.GetString("TrafficManagementSiteClone", "Facebook passwords collect"),
            "id": "FacebookCredentialsCollect"
        }
    };

var ControlTaskStatusesDic =
    {
        "0": {"value": LangHelper.GetString("Dics", "Disabled"), "id": "0"},
        "1": {"value": LangHelper.GetString("Dics", "Enabled"), "id": "1"}
    };

var NetworkAuditStatusesDic =
    {
        "0": {"value": LangHelper.GetString("NetworkAudit", "New"), "id": "0"},
        "1": {"value": LangHelper.GetString("NetworkAudit", "Launched"), "id": "1"},
        "2": {"value": LangHelper.GetString("NetworkAudit", "Stopped"), "id": "2"},
        "3": {"value": LangHelper.GetString("NetworkAudit", "Error"), "id": "3"}
    };

var NetworkAuditTimingDic =
    {
        "0": {"value": LangHelper.GetString("NetworkAudit", "0 - paranoid"), "id": "0"},
        "1": {"value": LangHelper.GetString("NetworkAudit", "1 - sneaky"), "id": "1"},
        "2": {"value": LangHelper.GetString("NetworkAudit", "2 - polite"), "id": "2"},
        "3": {"value": LangHelper.GetString("NetworkAudit", "3 - normal"), "id": "3"},
        "4": {"value": LangHelper.GetString("NetworkAudit", "4 - aggressive"), "id": "4"},
        "5": {"value": LangHelper.GetString("NetworkAudit", "5 - insane"), "id": "5"}
    };

var NetworkAuditTemplatesDic =
    {
        "0": {"value": LangHelper.GetString("NetworkAudit", "Regular scan"), "id": "0"},
        "1": {"value": LangHelper.GetString("NetworkAudit", "Intense scan"), "id": "1"},
        "2": {"value": LangHelper.GetString("NetworkAudit", "Intense scan plus UDP"), "id": "2"},
        "3": {"value": LangHelper.GetString("NetworkAudit", "Intense scan, all TCP ports"), "id": "3"},
        "4": {"value": LangHelper.GetString("NetworkAudit", "Intense scan, no ping"), "id": "4"},
        "5": {"value": LangHelper.GetString("NetworkAudit", "Ping scan"), "id": "5"},
        "6": {"value": LangHelper.GetString("NetworkAudit", "Quick scan"), "id": "6"},
        "7": {"value": LangHelper.GetString("NetworkAudit", "Quick scan plus"), "id": "7"},
        "8": {"value": LangHelper.GetString("NetworkAudit", "Quick traceroute"), "id": "8"},
        "9": {"value": LangHelper.GetString("NetworkAudit", "Slow comprehensive scan"), "id": "9"}
    };

var ZoomLevelsDic = {
    "0": {id: 0, width: 360, tiles: 1},
    "1": {id: 1, width: 180, tiles: 4},
    "2": {id: 2, width: 90, tiles: Math.pow(4, 2)},
    "3": {id: 3, width: 45, tiles: Math.pow(4, 3)},
    "4": {id: 4, width: 22.5, tiles: Math.pow(4, 4)},
    "5": {id: 5, width: 11.25, tiles: Math.pow(4, 5)},
    "6": {id: 6, width: 5.625, tiles: Math.pow(4, 6)},
    "7": {id: 7, width: 2.813, tiles: Math.pow(4, 7)},
    "8": {id: 8, width: 1.406, tiles: Math.pow(4, 8)},
    "9": {id: 9, width: 0.703, tiles: Math.pow(4, 9)},
    "10": {id: 10, width: 0.352, tiles: Math.pow(4, 10)},
    "11": {id: 11, width: 0.176, tiles: Math.pow(4, 11)},
    "12": {id: 12, width: 0.088, tiles: Math.pow(4, 12)},
    "13": {id: 13, width: 0.044, tiles: Math.pow(4, 13)},
    "14": {id: 14, width: 0.022, tiles: Math.pow(4, 14)},
    "15": {id: 15, width: 0.011, tiles: Math.pow(4, 15)},
    "16": {id: 16, width: 0.005, tiles: Math.pow(4, 16)},
    "17": {id: 17, width: 0.003, tiles: Math.pow(4, 17)},
    "18": {id: 18, width: 0.001, tiles: Math.pow(4, 18)},
    "19": {id: 19, width: 0.0005, tiles: Math.pow(4, 19)},
    "20": {id: 20, width: 0.00025, tiles: Math.pow(4, 20)}
};

var SubscribersAuthStatusesDic = {
    "0" : {id: "0", value: LangHelper.GetString("Subscribers", "Unknown")},
    "1" : {id: "1", value: LangHelper.GetString("Subscribers", "In progress")},
    "2" : {id: "2", value: LangHelper.GetString("Subscribers", "In progress ajb")},
    "3" : {id: "3", value: LangHelper.GetString("Subscribers", "Authorized")},
    "4" : {id: "4", value: LangHelper.GetString("Subscribers", "Unauthorized")},
};

var SubscribersAuthStatusesSetDic = {
    "0" : {id: "0", value: LangHelper.GetString("Subscribers", "Unknown")},
    "3" : {id: "3", value: LangHelper.GetString("Subscribers", "Authorized")},
    "4" : {id: "4", value: LangHelper.GetString("Subscribers", "Unauthorized")},
};

var SubscriberAuthExpiredDic = {
    "n/a": {id: "n/a", value: LangHelper.GetString("Subscribers", "Not authorized")},
    "(0)": {id: "(0)", value: LangHelper.GetString("Subscribers", "Infinite")}
};

var SubscriberAuthSessionTypeDic = {
    "0": {id: "0", value: LangHelper.GetString("Subscribers", "Undefined")},
    "1": {id: "1", value: LangHelper.GetString("Subscribers", "DHCP")},
    "2": {id: "2", value: LangHelper.GetString("Subscribers", "PPPoE")},
    "3": {id: "3", value: LangHelper.GetString("Subscribers", "Gateway")},
    "4": {id: "4", value: LangHelper.GetString("Subscribers", "ARP")},
    "5": {id: "5", value: LangHelper.GetString("Subscribers", "L3")},
};

var SubscriberAuthSessionStatusDic = {
    "0": {id: "0", value: LangHelper.GetString("Subscribers", "Undefined")},
    "1": {id: "1", value: LangHelper.GetString("Subscribers", "Acquired")},
    "2": {id: "2", value: LangHelper.GetString("Subscribers", "Released")}
};

var HardwareDscpProtocolsDic = null;

var LiTrafficDecodeFilesStatuses = {
    "new": {id: "new", value: LangHelper.GetString("TrafficDecode", "New")},
    "downloading": {id: "downloading", value: LangHelper.GetString("TrafficDecode", "Downloading")},
    "preparing": {id: "preparing", value: LangHelper.GetString("TrafficDecode", "Preparing")},
    "decoding": {id: "decoding", value: LangHelper.GetString("TrafficDecode", "Decoding")},
    "finished": {id: "finished", value: LangHelper.GetString("TrafficDecode", "Finished")},
    "error": {id: "error", value: LangHelper.GetString("TrafficDecode", "Error")},
};

var HttpRequestMethodsDic = {
    "GET": {id: "GET", value: "GET"},
    "POST": {id: "POST", value: "POST"},
    "HEAD": {id: "HEAD", value: "HEAD"},
    "PUT": {id: "PUT", value: "PUT"},
    "DELETE": {id: "DELETE", value: "DELETE"},
    "CONNECT": {id: "CONNECT", value: "CONNECT"},
    "OPTIONS": {id: "OPTIONS", value: "OPTIONS"},
    "TRACE": {id: "TRACE", value: "TRACE"},
    "PATCH": {id: "PATCH", value: "PATCH"}
};

var DDoSSyncfProtectionEnum = {
    "0": {id: "0", value: LangHelper.GetString("DDoSProtectionService", "Protection is off")},
    "1": {id: "1", value: LangHelper.GetString("DDoSProtectionService", "Protection is activated automatically")},
    "2": {id: "2", value: LangHelper.GetString("DDoSProtectionService", "Protection is always on")}
}

var DDoSSyncfTraceEnum = {
    "0": {id: "0", value: LangHelper.GetString("DDoSProtectionService", "Alert logging is off")},
    "1": {id: "1", value: LangHelper.GetString("DDoSProtectionService", "Alert logging triggering on/off")}
}

var ConvertProtocolsToTableInputDic = function(DicArr)
{
    var res = [];

    DicArr.forEach(function(Val){
        res.push({
            group_id: Val.group_id,
            protocol: Val.protocol,
            value: Val.value,
            id: Val.protocol
        });
    });

    return res;
}

var UplinkProtoSeverityOptions = [
    {id: "0", value: LangHelper.GetString("QoE", "None (0 points)")},
    {id: "2", value: LangHelper.GetString("QoE", "First category (+2 points)")},
    {id: "1", value: LangHelper.GetString("QoE", "Second category (+1 point)")},
]

var defaultUplinkRttToVal = [
    {
        max_val: 10,
        points: 0
    },
    {
        max_val: 50,
        points: 1
    },
    {
        max_val: 100,
        points: 2
    },
    {
        max_val: 150,
        points: 3
    },
    {
        max_val: 200,
        points: 4
    },
    {
        max_val: 300,
        points: 5
    },
    {
        max_val: "none",
        points: 6
    }
]

var UplinkTrafficOptionsDic = {
    Speed: {id:"speed", value: LangHelper.GetString("Dics", "Speed")},
    Value: {id: "value", value: LangHelper.GetString("Dics", "Value")}
}

var defaultUplinkTrafficVal = [
    {
        max_val: 10,
        points: 0
    },
    {
        max_val: 30,
        points: 1
    },
    {
        max_val: "none",
        points: 2
    }
]

var QoEExportExtensionDic = {
    "toExcel": ".xlsx",
    "toCSV": ".csv",
    "toTabSeparated": ".tsv",
    "toPDF": ".pdf",
    "toChartPDF": ".pdf",
}

var QoECompressQueueStatusDic = {
    "new": {id: "new", value: LangHelper.GetString("QoE", "New")},
    "processing": {id: "processing", value: LangHelper.GetString("QoE", "Processing")},
    "skipped": {id: "skipped", value: LangHelper.GetString("QoE", "Skipped")},
    "waiting": {id: "waiting", value: LangHelper.GetString("QoE", "Waiting")},
    "waiting_processing": {id: "waiting_processing", value: LangHelper.GetString("QoE", "Waiting processing")},
    "success": {id: "success", value: LangHelper.GetString("SocketNotifications", "Success")},
    "error": {id: "error", value: LangHelper.GetString("QoE", "Error")}
}

var QoECompressQueueActionDic = {
    "MoveTo": {id: "MoveTo", value: LangHelper.GetString("QoE", "Move To")},
    "DropPartition": {id: "DropPartition", value: LangHelper.GetString("QoE", "Drop Partition")},
    "WaitMove": {id: "WaitMove", value: LangHelper.GetString("QoE", "Wait Move")},
    "WaitDropPartition": {id: "WaitDropPartition", value: LangHelper.GetString("QoE", "Wait Drop Partition")},
}

var QoECompressQueueTableDic = {
    "FFCA": {id: "FFCA", value: "fullflow_compressed_agg"},
    "FFC": {id: "FFC", value: "fullflow_compressed"},
    "FF": {id: "FF", value: "fullflow"},
    "FFAC1": {id: "FFAC1", value: ".inner.fullflow_agg_compressed_1"},
    "FFAC2": {id: "FFAC2", value: ".inner.fullflow_agg_compressed_2"},
    "FFA": {id: "FFA", value: ".inner.fullflow_agg"},
}

var UlrBgpDiffNotifications = {
    diff_created : {id: "diff_created", value: LangHelper.GetString("UlrModule", "Diff created")},
    diff_applied: {id: "diff_applied", value: LangHelper.GetString("UlrModule", "Diff applied")}
};

var UlrIpProtocolVersionDic = {
    IPv4: {id: "IPv4", value: LangHelper.GetString("UlrModule", "IPv4")},
    IPv6: {id: "IPv6", value: LangHelper.GetString("UlrModule", "IPv6")},
    BOTH: {id: "BOTH", value: LangHelper.GetString("UlrModule", "BOTH")}
};

var QoEClickstreamLockedOptionsDic = {
    "1": {id: "1", value: LangHelper.GetString("QoE", "Locked") + " - 1"},
    "2": {id: "2", value: LangHelper.GetString("QoE", "Redirected") + " - 2"},
    "3": {id: "3", value: LangHelper.GetString("QoE", "Both: locked + redirected") + " - 3"}
};

var EmptyCidrsEnum = {
    IPv4: '0.0.0.0/32',
    IPv6: '::ffff:0.0.0.0/128'
};

var UlrPcapRecordingProtoDic = {
    "0": {"id": "0", "value": ""},
    "tcp": {"id": "tcp", "value": LangHelper.GetString("Dics", "tcp")},
    "udp": {"id": "udp", "value": LangHelper.GetString("Dics", "udp")}
}

var OrientationDic =
{
    "auto": {"value": LangHelper.GetString("UlrModule", "Auto"), "id": "auto"},
    "P": {"value": LangHelper.GetString("UlrModule", "Portrait"), "id": "P"},
    "L": {"value": LangHelper.GetString("UlrModule", "Landscape"), "id": "L"}
};

var WifiAuthorizationType = {
    code: {id: "code", value: LangHelper.GetString("HotSpot","By auth code")},
    outgoing_call: {id: "outgoing_call", value: LangHelper.GetString("HotSpot","By outgoing call")}
};

var AuthType = {
    "password": {id: "password", value: LangHelper.GetString("Hardwares", "By password")},
    "key": {id: "key", value: LangHelper.GetString("Hardwares", "By key")}
};

var VoipProtocolsKey = "VoipProtocols";

var CustomQoEAggLogsReportsKey = "CustomQoEAggLogsReports";

var ProtocolTypeDic =
{
    "1": {"value": LangHelper.GetString("CustomProtocolsGroups","Cloudy"), "id": "1"},
    "2": {"value": LangHelper.GetString("CustomProtocolsGroups","Custom"), "id": "2"}
};

var SshKeyAlgorithmType = {
    "rsa": {id: "rsa", value: "rsa"},
    "ecdsa": {id: "ecdsa", value: "ecdsa"},
    "ed25519": {id: "ed25519", value: "ed25519"}
};

var SshKeyFormatType = {
    "default": {id: "default", value: LangHelper.GetString("All", "By default")},
    "PEM": {id: "PEM", value: "PEM"}
};


var CustomProtocolsItemTypeDic =
    {
        "ip": {"value": LangHelper.GetString("Protocols", "IP"), "id": "ip"},
        "sni": {"value": LangHelper.GetString("Protocols", "SNI"), "id": "sni"},
        "asn": {"value": LangHelper.GetString("Protocols", "ASN"), "id": "asn"}
        //,"template": {"value": LangHelper.GetString("Protocols", "Template"), "id": "template"}
    };
    
var CustomProtocolsItemWithAutoTypeDic =
    {
        "auto": {"value": LangHelper.GetString("Protocols", "Auto"), "id": "auto"},
        "ip": {"value": LangHelper.GetString("Protocols", "IP"), "id": "ip"},
        "sni": {"value": LangHelper.GetString("Protocols", "SNI"), "id": "sni"},
        "asn": {"value": LangHelper.GetString("Protocols", "ASN"), "id": "asn"}
        //,"template": {"value": LangHelper.GetString("Protocols", "Template"), "id": "template"}
    };

var CustomProtocolsSyncModeTypeDic =
    {
        "url": {"value": LangHelper.GetString("Protocols", "By URL"), "id": "url"},
        "dpiui2": {"value": LangHelper.GetString("Protocols", "By DPIUI2"), "id": "dpiui2"}
    };

var TypeListDic =
    {
        "0": {"value": LangHelper.GetString("Protocols", "Test"), "id": "0"},
        "1": {"value": LangHelper.GetString("Protocols", "Main"), "id": "1"}
    };

var TypeListTextIdDic =
    {
        "test": {"value": LangHelper.GetString("Protocols", "Test"), "id": "test"},
        "prod": {"value": LangHelper.GetString("Protocols", "Main"), "id": "prod"}
    };

var LogStatusTypesDic =
    {
        "new": {"value": LangHelper.GetString("Protocols", "New"), "id": "new"},
        "processing": {"value": LangHelper.GetString("Protocols", "Processing"), "id": "processing"},
        "success": {"value": LangHelper.GetString("Protocols", "Success"), "id": "success"},
        "error": {"value": LangHelper.GetString("Protocols", "Error"), "id": "error"},
        "skipped": {"value": LangHelper.GetString("Protocols", "Skipped"), "id": "skipped"}
    };

var HardwareSateEnumDic = {
    "ssh": {"value": LangHelper.GetString("Hardwares", "Ssh connection"), "id": "ssh"},
    "scp_command": {"value": LangHelper.GetString("Hardwares", "Scp command"), "id": "scp_command"},
    "send_file": {"value": LangHelper.GetString("Hardwares", "File sending"), "id": "send_file"},
    "internet": {"value": LangHelper.GetString("Hardwares", "Internet connection"), "id": "internet"},

};

var IdentityTypeFieldDic = {
    "company_code": {id: "company_code", value: LangHelper.GetString("Companies", "Company name")},
    "contact_id": {id: "contact_id", value: LangHelper.GetString("Companies", "Contact Id")}
}

var PrefixTypeMapEnum = {
    "CIDR":"5",
    "BGP":"9"
}

var PrefixTypeDic = {
    "5": {id: 5, value: LangHelper.GetString("UlrModule", "CIDR - static prefix")},
    "9": {id: 9, value: LangHelper.GetString("UlrModule", "BGP - dynamic prefix")},
}

var FilesStatusDic = {
    new: {id: 'new', value: LangHelper.GetString("UlrModule", "New")},
    uploading: {id: 'uploading', value: LangHelper.GetString("UlrModule", "Uploading")},
    uploaded: {id: 'uploaded', value: LangHelper.GetString("UlrModule", "Uploaded")},
    failed: {id: 'failed', value: LangHelper.GetString("UlrModule", "Failed")}
};
var IspNetworkLearningDic = {
    "0": {"value": LangHelper.GetString("UlrModule","Only manual"), "id": "0"},
    "1": {"value": LangHelper.GetString("UlrModule","Only auto"), "id": "1"}
    //,
    //"2": {"value": LangHelper.GetString("UlrModule","Manual + auto"), "id": "2"}
};

var UlrRecipientGroupContactTypeMapEnum = {
    "email": "email",
    "phone": "phone",
    "telegram": "telegram",
    "callback": "callback"
};

var UlrRecipientGroupContactTypeDic = {
    "email": {"value": LangHelper.GetString("UlrModule","E-Mail"), "id": "email"},
    // "phone": {"value": LangHelper.GetString("UlrModule","Phone"), "id": "phone"},
    // "telegram": {"value": LangHelper.GetString("UlrModule","Telegram"), "id": "telegram"},
    // "callback": {"value": LangHelper.GetString("UlrModule","URL Callback"), "id": "callback"}
};

var UlrRulesTypesCodesDic = {
    "web_ip_lock": {"value": LangHelper.GetString("UlrModule","Web filter"), "id": "web_ip_lock"},
    "app_protocol_lock": {"value": LangHelper.GetString("UlrModule","App DSCP"), "id": "app_protocol_lock"},
    "asn_lock": {"value": LangHelper.GetString("UlrModule","ASN DSCP"), "id": "asn_lock"},
    "ip_exclude": {"value": LangHelper.GetString("UlrModule","IP excludes"), "id": "ip_exclude"},
    "asn_exclude": {"value": LangHelper.GetString("UlrModule","ASN excludes"), "id": "asn_exclude"},
    "web_ip_white": {"value": LangHelper.GetString("UlrModule","Whitelist"), "id": "web_ip_white"},
    "isp": {"value": LangHelper.GetString("UlrModule","Channels management"), "id": "isp"},
    "subscriber": {"value": LangHelper.GetString("UlrModule","Subscribers list"), "id": "subscriber"},
    "as_number": {"value": LangHelper.GetString("UlrModule","AS resource list"), "id": "as_number"},
    "custom_protocols": {"value": LangHelper.GetString("UlrModule","Custom protocols"), "id": "custom_protocols"},
    "cloud_protocols": {"value": LangHelper.GetString("UlrModule","Cloud protocols"), "id": "cloud_protocols"},
    "excluded_resources": {"value": LangHelper.GetString("UlrModule","Exclusion list"), "id": "excluded_resources"},
    "spoof_dns": {"value": LangHelper.GetString("UlrModule","Spoof DNS"), "id": "spoof_dns"},
};

var UlrUsersActionsLogsCodesDic = {
    "web_ip_lock": {"value": LangHelper.GetString("UlrModule","Web filter"), "id": "web_ip_lock"},
    "app_protocol_lock": {"value": LangHelper.GetString("UlrModule","App DSCP"), "id": "app_protocol_lock"},
    "asn_lock": {"value": LangHelper.GetString("UlrModule","ASN DSCP"), "id": "asn_lock"},
    "ip_exclude": {"value": LangHelper.GetString("UlrModule","IP excludes"), "id": "ip_exclude"},
    "asn_exclude": {"value": LangHelper.GetString("UlrModule","ASN excludes"), "id": "asn_exclude"},
    "web_ip_white": {"value": LangHelper.GetString("UlrModule","Whitelist"), "id": "web_ip_white"},
    "igw_profile": {"value": LangHelper.GetString("UlrModule","IGW profile"), "id": "igw_profile"},
    "node": {"value": LangHelper.GetString("UlrModule","IGW node"), "id": "node"},
    "isp_profile": {"value": LangHelper.GetString("UlrModule","ISP profile"), "id": "isp_profile"},
    "isp_policing": {"value": LangHelper.GetString("UlrModule","ISP Policing"), "id": "isp_policing"},
    "category": {"value": LangHelper.GetString("UlrModule","Category"), "id": "category"},
    "regulator": {"value": LangHelper.GetString("UlrModule","Regulator"), "id": "regulator"},
    "white_list_global_state": {"value": LangHelper.GetString("UlrModule","Whitelist state"), "id": "white_list_global_state"},
    "as_number": {"value": LangHelper.GetString("UlrModule","AS resource list"), "id": "as_number"},
    "igw_policing": {"value": LangHelper.GetString("UlrModule","IGW policing"), "id": "igw_policing"},
    "vip_subscriber": {"value": LangHelper.GetString("UlrModule","VIP subscriber"), "id": "vip_subscriber"},
    "traffic_redirection": {"value": LangHelper.GetString("UlrModule","Traffic redirection"), "id": "traffic_redirection"},
    "subs_profile": {"value": LangHelper.GetString("UlrModule","Subscriber profile"), "id": "vip_subscriber"},
    "recipient_group": {"value": LangHelper.GetString("UlrModule","Recipient group"), "id": "recipient_group"},
    "recipient_contact": {"value": LangHelper.GetString("UlrModule","Recipient contact"), "id": "recipient_contact"},
    "mailing": {"value": LangHelper.GetString("UlrModule","Mailing"), "id": "mailing"},
    "mailing_templates": {"value": LangHelper.GetString("UlrModule","Mailing templates"), "id": "mailing_templates"},
    "subs_policing": {"value": LangHelper.GetString("UlrModule","Subscriber policing"), "id": "subs_policing"},
    "isp_session_policing": {"value": LangHelper.GetString("UlrModule","ISP session policing"), "id": "isp_session_policing"},
    "subs_session_policing": {"value": LangHelper.GetString("UlrModule","Subscribers session policing"), "id": "subs_session_policing"},
    "excluded_resources": {"value": LangHelper.GetString("UlrModule","Exclusion list"), "id": "excluded_resources"},
    "pcap_recording": {"value": LangHelper.GetString("UlrModule","PCAP recording"), "id": "pcap_recording"},
    "custom_groups_of_protocols": {"value": LangHelper.GetString("UlrModule","Users groups of protocols"), "id": "custom_groups_of_protocols"},
    "spoof_dns": {"value": LangHelper.GetString("UlrModule","Spoof DNS"), "id": "spoof_dns"},
    "ulr_fastresource_custom_prtcls": {"value":  LangHelper.GetString("UlrModule", "ULR_FASTRESOURCE"), "id": "ulr_fastresource_custom_prtcls"},
    "session_policing_template": {"value": LangHelper.GetString("UlrModule", "Session policings templates"), "id": "session_policing_template"},
    "policing_template": {"value": LangHelper.GetString("UlrModule", "Policings templates"), "id": "policing_template"},
};

var UlrAppDscpRuleTypeDic = {
    "protocol": {id: "protocol", value: LangHelper.GetString("UlrModule","Protocol")},
    "protocols_group": {id: "protocols_group", value: LangHelper.GetString("UlrModule","Protocols group")},
    "protocols_custom_group": {id: "protocols_custom_group", value: LangHelper.GetString("UlrModule", "Users groups of protocols")}
};

var UlrProtocolTypesDic = {
    protocol :{id: "protocol", value: LangHelper.GetString("UlrModule","Protocol")},
    group: {id: "group", value: LangHelper.GetString("UlrModule","Protocols group")},
    custom_group: {id: "custom_group", value: LangHelper.GetString("UlrModule", "Users groups of protocols")},
    template: {id: "template", value: LangHelper.GetString("UlrModule","Template")}
};

var UlrFilesStatusDic = {
    new: {id: 'new', value: LangHelper.GetString("UlrModule", "New")},
    uploading: {id: 'uploading', value: LangHelper.GetString("UlrModule", "Uploading")},
    uploaded: {id: 'uploaded', value: LangHelper.GetString("UlrModule", "Uploaded")},
    failed: {id: 'failed', value: LangHelper.GetString("UlrModule", "Failed")}
};

var UlrPolicingTemplatesTypesDic = {
    session: {id: "session", value: LangHelper.GetString("UlrModule", "Session policing")},
    isp: {id: "isp", value: LangHelper.GetString("UlrModule", "ISP policing")}
};

var UlrDnsRecordTypesDic = {
    ip: {id: "ip", value: LangHelper.GetString("UlrModule", "IP (A | AAAA)")},
    HTTPS: {id: "HTTPS", value: LangHelper.GetString("UlrModule", "HTTPS")},
    MX: {id: "MX", value: LangHelper.GetString("UlrModule", "MX")}
};

var UlrDnsResponseActionsDic = {
    spoof: {id: "spoof", value: LangHelper.GetString("UlrModule", "Spoof DNS")},
    drop: {id: "drop", value: LangHelper.GetString("UlrModule", "#drop")},
    nxdomain: {id: "nxdomain", value: LangHelper.GetString("UlrModule", "#nxdomain")},
};
if(typeof Number.prototype.split != "function")
{
    Number.prototype.split = function(separator,limit)
    {
        return (this + "").split(separator,limit);
    }
}

if(typeof Number.prototype.replace != "function")
{
    Number.prototype.replace = function(substr, newSubStr, flags)
    {
        return (this + "").replace(substr, newSubStr, flags);
    }
}

if(typeof  Array.prototype.findIndex != "function")
{
    Array.prototype.findIndex = function(callback)
    {
        var index = -1;
        this.forEach(function(val, i)
        {
           if( callback(val) ){
               index = i;
               return;
           }
        });

        return index;
    }
}

if (!Object.values)
    Object.values = function(obj)
    {
        var res = [];
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                res.push(obj[i]);
            }
        }
        return res;
    }

if(typeof String.prototype.startsWith != "function")
{
    String.prototype.startsWith = function(Search)
    {
        return this.lastIndexOf(Search, 0) === 0;
    }
}

function Helper() {}

Helper.RE_LOOKS_LIKE_CODE = /^\s*[A-Za-z_$][\w$.]*\(|^\s*\(\s*function\b/;

Helper.DictToArr = function (Dict)
{
    "use strict";

    var result = [];

    if(Dict)
    {
        Object.keys(Dict).forEach(function (Key) {
            result.push(Dict[Key]);
        });
    }

    return result;
};

Helper.ArrToDic = function (Arr)
{
    var result = {};

    if(Arr)
    {
        Arr.forEach(function (Item)
        {
            result[Item.id] = Item.value;
        });
    }

    return result;
};

Helper.EnumToArr = function (Enum, FromKey, ToKey, Translate)
{
    var result = [];

    var started = FromKey ? false : true;

    var ended = false;

    if(Enum)
    {
        Object.keys(Enum).forEach(function (Key)
        {
            if(FromKey && FromKey == Key)
                started = true;

            if(started && !ended)
                result.push({id:Key, value:Key});

            if(ToKey && ToKey == Key)
                ended = true;
        });
    }

    return result;
};

Helper.RandInt = function (min, max)
{
    "use strict";

    var rand = min + Math.random() * (max + 1 - min);
    rand = Math.floor(rand);
    return rand;
};

Helper.RandDouble = function(min, max)
{
    "use strict";

    return min + Math.random() * (max + 1 - min);
};

Helper.RandDate = function()
{
    "use strict";
    var startDate = new Date(2012,0,1).getTime();
    var endDate =  new Date(2015,0,1).getTime();
    var spaces = (endDate - startDate);
    var timestamp = Math.round(Math.random() * spaces);
    timestamp += startDate;
    return new Date(timestamp);
};

Helper.RandStr = function(length)
{
    "use strict";

    const
        characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
        charactersLength = characters.length;

    let
        resultStr = '';

    for (let i = 0; i < length; i++)
    {
        resultStr += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return resultStr;
}

Helper.RemoveAllWhiteSpaces = function (S)
{
    "use strict";
    return S.replace(/\s/g,'');
};

Helper.ReplaceMultipleWhiteSpacesWithOne = function (S)
{
    "use strict";
    return S.replace(/ +(?= )/g,'');
};

Helper.GetInitials = function(S)
{
    if(!S)
        return "";
    return S.replace(/(\S)\S*\s*/ig, "$1").toUpperCase();
};

Helper.GetFirstInitials = function(S)
{
    return this.GetInitials(S).substring(0,2);
};

Helper.CapitalizeFirst = function(S)
{
    return S.charAt(0).toUpperCase() + S.slice(1);
};

Helper.ExtendClass = function(Child, Parent)
{
    "use strict";
    var F = function() { };
    F.prototype = Parent.prototype;
    Child.prototype = new F();
    Child.prototype.constructor = Child;
    Child.superclass = Parent.prototype;
};

Helper.ArrayToMask32 = function(Arr)
{
    if(Arr && Array.isArray(Arr) && Arr.length)
    {
        var result = 0;
        Arr.forEach(function (Val)
        {
            result += parseInt(Val,10);
        });

        return result;
    }

    return null;
};

Helper.Mask32ToArray = function(Val)
{
    var result = [];

    for(var i = 0; i < 4; i++)
    {
        var val = Val & (1 << i);

        if(val)
        {
            result.push(Val & (1 << i));
        }

    }

    return result;
};

Helper.ArrayToBitMask = function(Arr, Format)
{
    var format = Format ? Format : "decimal";

    var res = 0;
    if(Arr && Array.isArray(Arr) && Arr.length)
    {
        Arr.forEach(function (Val) {
            res = (res | Val);
        });
    }

    return format == "hex" ? ("0x" + res.toString(16)) : res;
};

Helper.BitMaskToArray = function(Val, Arr, Format)
{
    var format = Format ? Format : "decimal";

    var res = [];

    if(Arr && Array.isArray(Arr) && Arr.length)
    {
        Arr.forEach(function(V){
            if(Val & V)
            {
                res.push(
                    format == "hex" ? ("0x" + V.toString(16)) : V
                );
            }
        });
    }

    return res;
};

Helper.ConvertToKMG = function (Val)
{
    var v = Val;
    var u = "";
    var devider = 10;

    var i = parseInt(Math.floor(Math.log(v) / Math.log(devider)));

    if(i)
    {
        v = Math.round(v / Math.pow(devider, i)* 10)/10;
        u = "10<sup><small>"+i+"</small></sup>"
    }

    return u ? (v + "&#215;" + u) : v;
};

Helper.BytesToSize = function(Bytes)
{
    if (Bytes == 0)
        return 0;

    var i = parseInt(Math.floor(Math.log(Bytes) / Math.log(1024)));

    return Math.round(Bytes / Math.pow(1024, i)* 10)/10 + ' ' + FileSizeUnits[i];
};

Helper.UnitPrefixToNumeric = function(Val, Devider, Units)
{
    if (Val == 0)
        return 0;

    var i = parseInt(Math.floor(Math.log(Val) / Math.log(Devider)));

    i = Units[i] ? i : 0;

    return Math.round(Val / Math.pow(Devider, i) * 10)/10 + ' ' + Units[i];
};

Helper.ConvertBoolStrToInt = function (Val)
{
    var result = Val;

    if(result === "true")
    {
        result = 1;
    }
    else if(result === "false")
    {
        result = 0;
    }

    return result;
};

Helper.ValidateIPv4 = function (Ip)
{
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(Ip))
    {
        return true;
    }

    return false;
};

Helper.ValidateIPv6 = function (Ip)
{
    if(/^(([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))$/.test(Ip))
    {
        return true;
    }

    return false;
};

Helper.ValidateIPaddress = function (Ip)
{
    if (Helper.ValidateIPv4(Ip))
        return true;
    else if(Helper.ValidateIPv6(Ip) && !Helper.ValidateIPv6Cidr(Ip))
        return true;

    return false;
};

Helper.ValidateIPv4Addresses = function (Ips)
{
    let valid = true;

    let ips = Ips.split(',');

    ips.forEach(ip => {
        if(valid && !Helper.ValidateIPv4(ip))
            valid = false
    })

    return valid;
};

Helper.ValidateIPv6Addresses = function (Ips)
{
    let valid = true;

    let ips = Ips.split(',');

    ips.forEach(ip => {
        if(valid && !Helper.ValidateIPv6(ip))
            valid = false
    })

    return valid;
};

Helper.ValidateIPaddressPlusPort = function (Ip)
{
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:[0-9]+)?$/.test(Ip))
    {
        return true;
    }
    return false;
};

Helper.ValidateIPv4IPv6AddressPlusPort = function (Ip)
{
    var ipParts = Ip.split(':');

    var isIPv6 = ipParts.length > 2;

    if(isIPv6 || ipParts.length == 1)
        ipParts = Ip.split(' ');

    var isIpValid = false;

    var isPortValid = false;

    if(isIPv6)
    {
        isIpValid = Helper.ValidateIPv6(ipParts[0]);
    }
    else
    {
        isIpValid = Helper.ValidateIPv4(ipParts[0]);
    }

    isPortValid = ipParts.length == 1 || (ipParts.length == 2  && /^[0-9]+$/.test(ipParts[1]))

    return isIpValid && isPortValid;
};

Helper.ValidateIPaddressSpacePort = function (Ip)
{
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)( [0-9]+)?$/.test(Ip))
    {
        return true;
    }
    return false;
};

Helper.ValidateIPv4OrCidr = function (Ip)
{
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/[0-9]+)?$/.test(Ip))
    {
        return true;
    }

    return false;
};

Helper.ValidateIPv6OrCidr = function (Ip)
{
    if(/^(([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))(\/[0-9]+)?$/.test(Ip))
    {
        return true;
    }

    return false;
};

Helper.ValidateCidrSpacePort = function(Ip)
{
    if(Ip)
    {
        var arr = Ip.split(" ");
        if(arr.length == 1)
        {
            return Helper.ValidateIPaddressOrCidr(arr[0]);
        }
        else if(arr.length == 2){
            var ip = arr[0];
            if(!ip)
            {
                return false;
            }
            var port = arr[1];
            if(!port)
            {
                return Helper.ValidateIPaddressOrCidr(ip);
            }
            return Helper.ValidateIPaddressOrCidr(ip) && /^[0-9]+$/.test(port);
        }
    }

    return false;
}


Helper.ValidateCidrIPv4OrIPv6 = function(Cidr)
{
    return Helper.ValidateIPv4Cidr(Cidr) || Helper.ValidateIPv6Cidr(Cidr);
};

Helper.ValidateIPv4OrIPv6 = function(Cidr)
{
    return Helper.ValidateIPv4(Cidr) || Helper.ValidateIPv6(Cidr);
};

Helper.ValidateIPv4Cidr = function(Cidr)
{
    if (/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))$/.test(Cidr))
    {
        return true;
    }

    return false;
};

Helper.ValidateIPv6Cidr = function(Cidr)
{
    if(/^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))$/.test(Cidr))
    {
        return true;
    }

    return false;
};

Helper.ValidateIPaddressOrCidr = function (Ip)
{
    if (Helper.ValidateIPv4OrCidr(Ip))
    {
        return true;
    }
    else if(Helper.ValidateIPv6OrCidr(Ip))
    {
        return true;
    }

    return false;
};

Helper.UlrValidateCidrIpv4 = function (Cidr, PrefixMandatory)
{
    let regex = /^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/;

    if(PrefixMandatory)
        regex = /^([0-9]{1,3}\.){3}[0-9]{1,3}\/([0-9]|[1-2][0-9]|3[0-2])$/;

    return regex.test(Cidr);


};

Helper.UlrValidateCidrIpv6 = function (Cidr, PrefixMandatory)
{
    let regex = /^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$/;

    if(PrefixMandatory)
        regex = /^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8])?$/;

    return regex.test(Cidr);
};

Helper.UlrValidateCidr = function (Cidr, PrefixMandatory)
{
    if (Helper.UlrValidateCidrIpv4(Cidr, PrefixMandatory))
    {
        return true;
    }
    else if(Helper.UlrValidateCidrIpv6(Cidr, PrefixMandatory))
    {
        return true;
    }

    return false;
};

Helper.IsIpRange = function (Ip)
{
    if(Helper.ValidateIPaddress(Ip))
        return false;

    var commaRange = Ip.split(",");
    if(commaRange.length > 1)
    {
        var commaRangeValid = true;
        commaRange.every(function (Val)
        {
            if(!Helper.ValidateIPaddress(Val))
            {
                commaRangeValid = false;
                return false;
            }

            return true;
        });

        if(commaRangeValid)
            return true;
    }

    var dashRange = Ip.split("-");
    if(dashRange.length == 2)
    {
        var dashRangeValid = true;

        dashRange.every(function (Val)
        {
            if(!Helper.ValidateIPaddress(Val))
            {
                dashRangeValid = false;
                return false;
            }

            return true;
        });

        if(dashRangeValid)
            return true;
    }

    return false;
};

/**
 * @return {boolean}
 */
Helper.IsUrlValid = function (Val)
{
    // return Val.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g) ? true : false;
    // return Val.match(/^(http(s)?\:\/\/)?[^\/\s]+(\/.*)?$/) ? true : false;
    //var pattern = /^((https|http)?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&A-Za-z\d%_.~+=-]*)?(\#[-A-Za-z\d_]*)?$/g;

    //return pattern.test(Val);

    // var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    //     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    //     '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    //     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    //     '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    //     '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

    var pattern = new RegExp('^(?:http(s)?:\\/\\/)?'+
        '[а-я\\w.-]+(?:\\.[а-я\\w\\.-]+)+'+
        '[а-я\\w\\-\\._~:/?#[\\]@!\\$&\'\\(\\)\\*\\+,;=.]+$','i');

    return !!pattern.test(Val);
};

Helper.IsFilePathValid = function (Val)
{
    return Val.match(/^\/[^\/].*/g) ? true : false;
};

Helper.IsFilePathOrUrlValid = function (Val)
{
    if(Helper.IsUrlValid(Val))
        return true;

    if(Helper.IsFilePathValid(Val))
        return true;

    return false;
};

Helper.IsBlackListItemUrlValid = function(Val)
{
  var pattern = /^((https|http)?:\/\/)?(\*(\.)?)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/g;

  return pattern.test(Val);
};

Helper.ValidateDnaArr = function (Str)
{
    // if (/^(dna[0-9]{1,2}([:|]{0,1})){0,50}$/.test(Str))
    // {
    //     return true;
    // }
    if (/^((([0-9a-zA-Z]+[\.\-\_]+)?[0-9a-zA-Z]+)+([:|]{0,1})){0,50}$/.test(Str))
    {
        return true;
    }

    return false;
};

Helper.ValidateDna = function (Str)
{
    // if (/^dna[0-9]{1,2}$/.test(Str))
    // {
    //     return true;
    // }
    if (/^(([0-9a-zA-Z]+[\.\-\_]+)?[0-9a-zA-Z]+)+$/.test(Str))
    {
        return true;
    }

    return false;
};

Helper.ValidateAnyInterface = function (Str)
{
    if (/^[a-z]{1,5}[0-9]{0,2}$/.test(Str))
    {
        return true;
    }

    return Helper.ValidateDna(Str);
};

Helper.ValidatePortsArr = function (Str)
{
    if (/^([0-9]{1,20}([:]{0,1})){0,50}$/.test(Str))
    {
        return true;
    }

    return false;
};

Helper.ValidateMacAddress = function (Str)
{
    if (/^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.test(Str))
    {
        return true;
    }

    return false;
};

Helper.FormatDateTimeForChartXAxes = function (DateStr, Format, UseOnlyMyFormat=false)
{
    var format = Format ? Format : "%Y-%m-%d %H:%i:%s";

    var outFormat = format;

    var date = webix.Date.strToDate("%Y-%m-%d %H:%i:%s")(DateStr);

    if(Format && UseOnlyMyFormat) {
        return webix.Date.dateToStr(outFormat)(date);
    }

    if(webix.Date.dateToStr("%Y-%m-%d %H:%i:%s")(date) != webix.Date.dateToStr("%Y-%m-%d %H:%i:00")(date))
    {
        outFormat = "%i:%s";
    }

    if(webix.Date.dateToStr("%Y-%m-%d %H:%i:%s")(date) == webix.Date.dateToStr("%Y-%m-%d %H:%i:00")(date))
    {
        outFormat = "%H:%i";
    }

    if(webix.Date.dateToStr("%Y-%m-%d %H:%i:%s")(date) == webix.Date.dateToStr("%Y-%m-%d %H:00:00")(date))
    {
        outFormat = "%d.%m %H:%i";
    }

    // if(webix.Date.dateToStr("%Y-%m-%d %H:%i:%s")(date) == webix.Date.dateToStr("%Y-%m-%d 00:00:00")(date))
    // {
    //     outFormat = "%m/%d";
    // }

    if(webix.Date.dateToStr("%Y-%m-%d %H:%i:%s")(date) == webix.Date.dateToStr("%Y-%m-%d 00:00:00")(date))
    {
        outFormat = "%d.%m.%y";
    }

    return webix.Date.dateToStr(outFormat)(date);
};

Helper.IsBase64 = function(Str)
{
    try
    {
        return btoa(atob(Str)) == Str || btoa(atob(Str)) == Str + "=" || btoa(atob(Str)) == Str + "==";
    }
    catch (Err)
    {
        return false;
    }
};

Helper.Utoa = function(Str)
{
    return window.btoa(unescape(encodeURIComponent(Str)));
};

Helper.Atou = function(Str)
{
    return decodeURIComponent(escape(window.atob(Str)));
};

Helper.UtoaWithoutEqual = function(Str)
{
    return Helper.ReplaceAll("=", "", Helper.Utoa(Str));
};

Helper.ReplaceAll = function(Search, Replacement, Subject)
{
    if(Array.isArray(Search) && Search.length)
    {
        var search = Search.pop();
        var subject = Subject.split(search).join(Replacement);

        if(Search.length)
            return Helper.ReplaceAll(Search, Replacement, subject);
        else
            return subject;

    }
    else
        return Subject.split(Search).join(Replacement);
};

// Helper.EncodeBase64Safe = function(Str)
// {
//     return Helper.ReplaceAll("+", "psign", Helper.ReplaceAll("=", "esign", Helper.Utoa(Str)));
// };
//
// Helper.DecodeBase64Safe = function(Str)
// {
//     return Helper.Atou(Helper.ReplaceAll("psign", "+", Helper.ReplaceAll("esign", "=", Str)));
// };

Helper.ReplaceDigitWithString = function(Str)
{
    var r = Str;

    var digitStr = {
        "0":"dzero",
        "1":"done",
        "2":"dtwo",
        "3":"dthree",
        "4":"dfour",
        "5":"dfive",
        "6":"dsix",
        "7":"dseven",
        "8":"deight",
        "9":"dnine"
    };

    Object.keys(digitStr).forEach(function (Key)
    {
        r = Helper.ReplaceAll(Key, digitStr[Key], r);
    });

    return r;
};

Helper.ReplaceStringWithDigit = function(Str)
{
    var r = Str;

    var strDigit = {
        "dzero":"0",
        "done":"1",
        "dtwo":"2",
        "dthree":"3",
        "dfour":"4",
        "dfive":"5",
        "dsix":"6",
        "dseven":"7",
        "deight":"8",
        "dnine":"9"
    };

    Object.keys(strDigit).forEach(function (Key)
    {
        r = Helper.ReplaceAll(Key, strDigit[Key], r);
    });

    return r;
};

Helper.EncodeBase64Safe = function(Str)
{
    var r = Helper.Utoa(Str);

    r = Helper.ReplaceAll("=", "esign", r);

    r = Helper.ReplaceAll("+", "psign", r);

    r = Helper.ReplaceAll("/", "ssign", r);

    r = Helper.ReplaceDigitWithString(r);

    return r;
};

Helper.DecodeBase64Safe = function(Str)
{
    var r = Helper.ReplaceAll("esign", "=", Str);

    r = Helper.ReplaceAll("psign", "+", r);

    r = Helper.ReplaceAll("ssign", "/", r);

    r = Helper.ReplaceStringWithDigit(r);

    r = Helper.Atou(r);

    return r;
};

Helper.IsBase64Safe = function(Str)
{
    try
    {
        return Helper.EncodeBase64Safe(Helper.DecodeBase64Safe(Str)) == Str;
    }
    catch (Err)
    {
        return false;
    }
};

Helper.RoundDateToSeconds = function(D)
{
    D.setHours(D.getHours());
    D.setMinutes(D.getMinutes());
    D.setSeconds(0);
    D.setMilliseconds(0);

    return D;
};

Helper.RoundDateToMinutes = function(D)
{
    D.setHours(D.getHours());
    D.setMinutes(0);
    D.setSeconds(0);
    D.setMilliseconds(0);

    return D;
};

Helper.RoundDateToDay = function(D)
{
    D.setHours(0);
    D.setMinutes(0);
    D.setSeconds(0);
    D.setMilliseconds(0);

    return D;
};

Helper.RoundDateToWeek = function(D)
{
    var diff = D.getDate() - D.getDay() + (D.getDay() === 0 ? -6 : 1);

    D.setDate(diff);
    D.setHours(0);
    D.setMinutes(0);
    D.setSeconds(0);
    D.setMilliseconds(0);

    return D;
};

Helper.RoundDateToMonth = function(D)
{
    var d = new Date(D.getFullYear(), D.getMonth(), 1);

    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    return d;
};

Helper.RoundDateToYear = function(D)
{
    var d = new Date(D.getFullYear(), 0, 1);

    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    return d;
};

Helper.HashCode = function(S)
{
    var hash = 0;
    if (S.length == 0) {
        return hash;
    }
    for (var i = 0; i < S.length; i++) {
        var char = S.charCodeAt(i);
        hash = ((hash<<5)-hash)+char;
        hash = hash & hash; // Convert to 32bit integer
    }


    return Math.abs(hash);
}

Helper.LocalDateTimeToUtc = function(D)
{
    var date = new Date(D);

    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

Helper.DateTimeToLocal = function(D, RemoteTimeZoneOffsetMinutes)
{
    var d = D && typeof D == "string" ? D.replace(" ", "T") : D;

    var rTimeZone = RemoteTimeZoneOffsetMinutes ? parseInt(RemoteTimeZoneOffsetMinutes,10) : 0;

    var lTimeZone = (new Date()).getTimezoneOffset();

    var utcDate = webix.Date.add(d,rTimeZone,"minute",true);

    return webix.Date.add(utcDate,-lTimeZone,"minute",true);
};

Helper.ConvertTimeUtcToLocal = function(utcTime) {
    const utcDate = new Date(`1970-01-01T${utcTime}:00Z`);

    const offsetMinutes = utcDate.getTimezoneOffset();

    const localDate = new Date(utcDate.getTime() - offsetMinutes * 60 * 1000);

    const localTime = localDate.toISOString().substr(11, 5);

    return localTime;
}

Helper.ConvertTimeLocalToUtc = function convertLocalToUtc(localTime) {
    const localDate = new Date(`1970-01-01T${localTime}:00`);

    return localDate.toISOString().substr(11, 5);
}

/**
 * Converts a time string between local and UTC time based on specified weekdays and direction.
 *
 * @param {string} Time - Time in the format "HH:mm" (24-hour clock, e.g., "14:30").
 * @param {string[]} WeekDays - Array of strings representing days of the week, from "1" (Monday) to "7" (Sunday).
 * @param {string} Direction - Conversion direction, either "localToUtc" or "UtcToLocal".
 * @returns {[string|string[]]} - Converted time string in the format "HH:mm" and week array.
 */
Helper.ConvertSchedule = function(Time, WeekDays, Direction)
{
    const convertFuncs = {
        'localToUtc': function(_time) {
            const [hours, minutes] = _time.split(":");
            const sourceDate = new Date();
            sourceDate.setHours(parseInt(hours), parseInt(minutes), 0, 0)

            const convertDate = Helper.LocalDateTimeToUtc(sourceDate);
            return [sourceDate, convertDate]
        },
        'UtcToLocal': function(_time) {
            const [hours, minutes] = _time.split(":");
            const sourceDate = new Date();
            sourceDate.setHours(parseInt(hours), parseInt(minutes), 0, 0)

            const convertDate = Helper.DateTimeToLocal(sourceDate);
            return [sourceDate, convertDate]
        }
    };

    const shiftNumbers = function(Arr, Direction) {
        return Arr.map(Num => {
            if(Direction === 'plus') {
                return Num === 7 ? 1 : Num + 1;
            } else if(Direction === 'minus') {
                return Num === 1 ? 7 : Num - 1;
            }
            return Num;
        });
    };

    const [sourceDate, convertDate] = convertFuncs[Direction](Time);

    let convertTime = convertDate.toTimeString().substr(0, 5);
    let weekDays = WeekDays.map(Val => parseInt(Val));

    if(sourceDate.getDay() > convertDate.getDay())
    {
        weekDays = shiftNumbers(weekDays, 'minus')
    }
    else if(sourceDate.getDay() < convertDate.getDay())
    {
        weekDays = shiftNumbers(weekDays, 'plus')
    }
    
    weekDays = weekDays.sort().map(Val => Val.toString());

    return [convertTime, weekDays];
};

Helper.IsInteger = Number.isInteger || function(value)
{
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};

Helper.ValidateNumber = function(Val, Min, Max)
{
  if(Number.isNaN(Val))
  {
      return false;
  }

  var n = Number.parseFloat(Val);

  return n >= Min && n <= Max;
};

Helper.isConvertibleToNumber = function(str) {
    return !isNaN(parseFloat(str)) && isFinite(str);
}

Helper.GetTrafficValAndUnitFromString = function(String)
{
    var obj = {
        val: "",
        unit: TrafficUnits[1].id
    };

    var str = "" + String + "";

    if(str)
    {
        var m = str.match(/\d+/);
        if(m && m.length)
        {
            obj.val = m[0];
            obj.unit = str.replace(obj.val,"");
        }
    }

    if(!obj.val)
    {
        obj.val = obj.unit == TrafficUnits[1].id ? 8 : 1;
    }

    return obj;
};

Helper.RefreshView = function(ViewObject)
{
    setTimeout(function()
    {
        if(ViewObject)
        {
            if(ViewObject.isEnabled())
            {
                ViewObject.disable();
                ViewObject.enable();
            }
            else
            {
                ViewObject.enable();
                ViewObject.disable();
            }

            if(ViewObject.refreshColumns && typeof ViewObject.refreshColumns === "function")
            {
                ViewObject.refreshColumns();
            }
            else
            {
                ViewObject.refresh();
            }
        }
    }, 500)
};

Helper.ViewFromDpiConfigDic = function (DicId, Dic)
{
    if(!DicId || !Dic)
        return null;

    var view = {}, hBtnView = null;

    var obj = Dic[DicId];

    view.view = obj.view?obj.view:"text";
    view.name = obj.id?obj.id:"";
    view.label = obj.value?obj.value:"";
    view.tooltip = obj.tooltip?obj.tooltip:obj.value?obj.value:"";
    view.placeholder = obj.placeholder?obj.placeholder:"";
    view.options = obj.options?Helper.DictToArr(obj.options):[];
    view.labelPosition = "top";
    view.invalidMessage = obj.invalidMessage?obj.invalidMessage:"";

    if(obj.app_dic)
    {
        if(window.DicsEnum && window.DicsEnum[obj.app_dic])
        {
            view.app_dic = obj.app_dic;
            view.options = window.App.DicsManager.GetDicAsArrayWithEmpty(obj.app_dic);
        }
    }

    if(obj.type)
    {
        view.type = obj.type?obj.type:null;
    }

    if(obj.validate)
    {
        view.validate = obj.validate;
        view.on = {
            "onChange": function(Newv, Oldv)
            {
                this.validate();
            }
        }
    }

    if(obj.tooltip)
        if(obj.custom_helper) {
            hBtnView = {
                cols: [
                        obj.custom_helper[0],
                    {
                        view: "button",
                        type: "icon",
                        icon: "question-circle",
                        css: "toolbar_round_btn",
                        width: 32,
                        popup: {
                            view: "popup",
                            height: obj.tooltipHeight ? obj.tooltipHeight : 0,
                            width: obj.tooltipWidth ? obj.tooltipWidth : 0,
                            body: {
                                borderless: true,
                                template: obj.tooltip
                            }
                        }
                    }
                ],
            };
        } else {
            hBtnView = {
                cols: [
                    {
                        view: "button",
                        type: "icon",
                        icon: "question-circle",
                        css: "toolbar_round_btn",
                        width: 32,
                        popup: {
                            view: "popup",
                            height: obj.tooltipHeight ? obj.tooltipHeight : 0,
                            width: obj.tooltipWidth ? obj.tooltipWidth : 0,
                            body: {
                                borderless: true,
                                template: obj.tooltip
                            }
                        }
                    }
                ],
            };
        }

    if(obj.params && typeof obj.params === "object")
    {
        Object.keys(obj.params).forEach(function (Key){
            view[Key] = obj.params[Key];
        });
    }

    return hBtnView ? {cols:[view,hBtnView]} : view;
};

Helper.ObjectValues = function(Obj)
{
    if(!Obj || typeof Obj != "object")
        return [];

    return Object.keys(Obj).map(function(Key)
    {
        return Obj[Key];
    });
};

Helper.ValidateCgNatCIDR = function(Val)
{
    if (/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))(\~)?$/.test(Val))
    {
        return true;
    }

    return false;
};

Helper.CapitalizeFirstLetter = function(Str)
{
    return Str.charAt(0).toUpperCase() + Str.slice(1);
};

Helper.ToUpperCaseFirstLetter = function (S)
{
    return S.charAt(0).toUpperCase() + S.slice(1);
};

Helper.HideRestrictedMenuItems = function (Items, MenuView)
{
    Items.forEach(function (Item)
    {
        if(Item.section && !App.SessionManager.CheckUserRoleSection(Item.section))
            MenuView.hideItem(Item.id);

        if(Item.submenu)
            Helper.HideRestrictedMenuItems(Item.submenu,MenuView);
    });
};

Helper.SetHtmlPageTitle = function (RootTitle, Title)
{
    try
    {
        document.title = (RootTitle ? RootTitle : LangHelper.GetString("AppView", "Title")) + (Title ? " / " + Title : "");
    }
    catch (e)
    {
        document.title = LangHelper.GetString("AppView", "Title");
    }
};

Helper.SplitDigitLetters = function (Str)
{
    if(!Str)
        return null;

    var arr = Str.match(/[a-zA-Z]+|[0-9\.]+/g);

    return arr;
};

Helper.StripHtml = function (Str)
{
    if(!Str)
        return Str;

    return Str.replace(/(<([^>]+)>)/ig,"");
};

Helper.ReplaceArrows = function(Str)
{
  return Str.replaceAll("<", "&lt").replaceAll(">", "&gt");
};

Helper.ViewFromHardwareConfigDic = function (DicId, Dic) {
    var view = {}, hBtnView = null;

    var obj = Dic ? Dic[DicId] : DpiConfigDic[DicId];

    view.view = obj.view ? obj.view : "text";
    view.name = obj.id ? obj.id : "";
    view.label = obj.value ? obj.value : "";
    view.tooltip = obj.tooltip ? obj.tooltip : obj.value ? obj.value : "";
    view.placeholder = obj.placeholder ? obj.placeholder : "";
    view.options = obj.options ? Helper.DictToArr(obj.options) : [];
    view.labelPosition = "top";
    view.invalidMessage = obj.invalidMessage ? obj.invalidMessage : "";

    if (obj.type) {
        view.type = obj.type ? obj.type : null;
    }

    if (obj.validate) {
        view.validate = obj.validate;
        view.on = {
            "onChange": function (Newv, Oldv) {
                this.validate();
            }
        }
    }

    if (obj.tooltip)
        hBtnView = {
            view: "button",
            type: "icon",
            icon: "question-circle",
            css: "toolbar_round_btn",
            width: 32,
            popup: {
                view: "popup",
                height: obj.tooltipHeight ? obj.tooltipHeight : 0,
                body: {
                    borderless: true,
                    template: obj.tooltip
                }
            }
        };

    return hBtnView ? {cols: [view, hBtnView]} : view;
};

Helper.ValidatePortRange = function (Str, Max)
{
    var max = Max ? Max : 65000;

    var _check = function (Str) {
        var range = Str.split("-");

        if(range.length <= 2)
        {
            var r = true;

            range.every(function (TestStr)
            {
                if(isNaN(TestStr))
                {
                    r = false;
                    return false;
                }

                if(parseInt(TestStr,10) < 0 || parseInt(TestStr,10) > max)
                {
                    r = false;
                    return false;
                }
                return true;
            });

            return r;
        }

        return false;
    };

    if(Str)
    {
        var r = true;
        Str.split(",").every(function (TestStr)
        {
            r = _check(TestStr);

            return r;
        });

        return r;
    }

    return false;
};

Helper.StrHash = function (Str)
{
    var h = 0, l = Str.length, i = 0;
    if ( l > 0 )
        while (i < l)
            h = (h << 5) - h + Str.charCodeAt(i++) | 0;
    return h;
};

Helper.ObjHash = function (Obj)
{
    return Helper.StrHash(JSON.stringify(Obj));
};

Helper.RangeToArray = function (Str)
{
    var arr = [];

    if(Str)
    {
        Str.split(",").forEach(function (Str)
        {
            Str.split("-").forEach(function (Str)
            {
                arr.push(Str);
            });
        });
    }

    return arr;
};

Helper.ConvertDateToLocalDate = function(DateTime)
{
    var diff = DateTime.getTimezoneOffset();
    var date = new Date(DateTime.getTime() + 2 * diff * 60 * 1000);

    return date;
};

Helper.ParseDateTime = function(DateTime)
{
    var dateString = DateTime ? DateTime.replace(/-/g, '/') : null;

    var date = Helper.ConvertDateToLocalDate(new Date(dateString))
    var result = "";
    date = new Date(date).toISOString();
    var split = date.split("T");

    date = split[0].split("-");

    result = date[2] + "." + date[1] + "." + date[0] + " ";

    var time = split[1].split(":");
    result += time[0] + ":" + time[1];

    return result;
};

Helper.ValidateFileSize = function(Val)
{
    if (/^[0-9]+[BKMG]$/.test(Val))
    {
        return true;
    }

    return false;
};

Helper.IsNumberNotNegative = function(Val)
{
   if(!isNaN(Val * 1))
   {
       return !!((Val * 1) >= 0);
   }
   return false;
};

Helper.ConcatObjects = function(Old, New)
{
    var result = Old ? Old : {};
    Object.keys(New).forEach(function(key){
        if(New[key])
        {
            var val = {};
            if(typeof New[key] == "object")
            {
                val = Helper.ConcatObjects(result[key], New[key]);
            }
            else{
                val = New[key];
            }

            result[key] = val;
        }
    });

    return result;
};


Helper.ConvertTariffConfigData = function(Obj, Inbound, TBF)
{
    var prefix = Inbound ? "inbound_" : "outbound_";

    var result = [];

    var isStatic = false;
    //
    result.push("rate " + Obj[prefix + "rate"]);

    //
    if(!TBF)
    {
        if(Obj[prefix + "ceil"])
        {
            var str = "";
            if(Obj[prefix + "ceil"] == "static")
            {
                isStatic = true;
            }
            else
            {
                str += "ceil ";
            }
            str += Obj[prefix + "ceil"];

            result.push(str);
        }
    }
    //
    if(!isStatic)
    {
        if(Obj[prefix + "burst"])
        {
            result.push("burst " + Obj[prefix + "burst"]);
        }

        if(!TBF && Obj[prefix + "cburst"])
        {
            result.push("cburst " + Obj[prefix + "cburst"]);
        }
    }

    var res = result.join("_ ");
    return res.split("_").join("");
};

Helper.ConvertTariffConfigStringToData = function(Str, Class, Inbound)
{
    var prefix = Inbound ? "inbound_" : "outbound_";

    var result = {
        "class": Class
    };

    result[prefix + "rate"] = "";
    result[prefix + "ceil"] = "";
    result[prefix + "burst"] = "";
    result[prefix + "cburst"] = "";

    var split = Str.split(" ");

    for(var i=0; i<split.length;i++)
    {
        if(split[i] && result.hasOwnProperty(prefix + split[i]))
        {
            if(split[i] == "static")
            {
                result[prefix + "ceil"] = "static";
                break;
            }
            else{
                var prop = prefix + split[i];
                while(i<split.length && !result[prop])
                {
                    i+=1;
                    if(split[i])
                    {
                        result[prop] = split[i];
                    }

                }

                if(!result[prop])
                {
                    result[prop] = "8bit";

                    break;
                }
            }
        }
    }

    return result;
};

Helper.GetDistanceBetween2PointsSphere = function(Point1, Point2)
{
    var r1 = Math.sqrt(Math.pow(Point1.x,2) + Math.pow(Point1.y, 2));
    var r2 = Math.sqrt(Math.pow(Point2.x,2) + Math.pow(Point2.y, 2));
    var a = Math.acos((Point1.x*Point2.x + Point1.y*Point2.y)/r1/r2);
    var b = Math.log(r1/r2);
    // var dist = Math.sqrt(Math.pow(MaxPoint.lon - MinPoint.lon,2) + Math.pow(MaxPoint.lat - MinPoint.lat,2));

    return Math.sqrt(a*a+b*b);
};

Helper.CalculateMapZoom = function(MinPoint, MaxPoint)
{
    // var dist = Helper.GetDistanceBetween2PointsSphere({x:MinPoint.lon,y:MinPoint.lat}, {x:MaxPoint.lon, y:MaxPoint.lat});

    var lonDiff = MaxPoint.lon - MinPoint.lon;
    var latDiff = MaxPoint.lat - MinPoint.lat;
    var zoom = 1;
    var value = lonDiff;
    if(value < latDiff)
    {
        value = 180*180/(latDiff*latDiff);
        Object.values(ZoomLevelsDic).some(function(Val){
            if(value <= Val.tiles)
            {
                zoom = Val.id - 1;
                return true;
            }
        });
    }else{
        Object.values(ZoomLevelsDic).some(function(Val){
            if(value >= Val.width)
            {
                zoom = Val.id - 1;
                return true;
            }
        });
    }

    return zoom > 0 ? zoom : 1;
};

Helper.ChangePropertiesInObject = function(Obj, Change)
{
    var result = {};

    Object.keys(Obj).forEach(function (kObj) {
        if(typeof Obj[kObj] === "object")
        {
            result[kObj] = Helper.ChangePropertiesInObject(Obj[kObj], Change);
        }
        else
        {
            result[kObj] = Obj[kObj];

            Object.keys(Change).forEach(function(kChange){
                if(kChange == kObj)
                {
                    result[kObj] = Change[kObj];
                }
            });
        }
    });

    return result;
};

Helper.CalculateMapFeatureHitBox = function(Stride, Zoom)
{
    return Stride*10*156412/Math.pow(2, Zoom);
};

Helper.GetLineLengthByPoints = function(A, B)
{
    var x = A[0]-B[0];
    var y = A[1]-B[1];
    return Math.sqrt(x*x + y*y);
};

Helper.SubscribeWidgetForProtocolsGroupsUpdatedIfNeeded = function(Widget)
{
    if(Widget.Name == "QoETableNetflowTopInfectedSubscribersWidget"){
        return null
    }
    if(Widget instanceof QoETableReportWidget)
    {
        return Helper.SubscribeWidgetForProtocolsGroupsUpdated(Widget);
    }
    else if(Widget.TableWidget && Widget.TableWidget instanceof QoETableReportWidget )
    {
        return Helper.SubscribeWidgetForProtocolsGroupsUpdated(Widget.TableWidget);
    }

    return null
};

Helper.SubscribeWidgetForProtocolsGroupsUpdated = function(Widget)
{
    return App.DicsManager.Signal[DicsEnum.ProtocolsGroupsDic].subscribe(function(Val){
        if(Val)
        {
            if(Widget.Views.Table && Widget.Views.Table.getColumnConfig && typeof Widget.Views.Table.getColumnConfig == 'function')
            {
                var config = Widget.Views.Table.getColumnConfig("app_protocol_group_id");
                if(config && config.header && (Array.isArray(config.header) && config.header[1]))
                {
                    config.header[1].options = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic);
                }
            }
        }
    });
};

Helper.SortArrayObjByOrderFieldAsc = function(Arr)
{
    return Arr.sort( (a, b) => a.order - b.order );
};

Helper.DateTimeToUTC = function(D)
{
    var date = new Date(D);
    var lTimeZone = date.getTimezoneOffset();


    return webix.Date.add(date, lTimeZone,"minute",true);
};

Helper.ValidateDateTimeInput = function(dateString) {
    let format =  webix.Date.dateToStr("%d.%m.%Y %H:%i");
    let currentFormatDate = format(dateString);
    let pattern = /^(\d{2})\.(\d{2})\.(\d{4})\s(\d{2}):(\d{2})$/;

    // Проверяем соответствие паттерну
    if (!pattern.test(currentFormatDate)) {
        return false; // Некорректный формат даты
    }

    // Разбиваем дату на компоненты
    let [, day, month, year, hours, minutes] = pattern.exec(currentFormatDate);

    // Проверяем, что дата является корректной
    let date = new Date(year, month - 1, day, hours, minutes);
    if (
        date.getFullYear() != year ||
        date.getMonth() + 1 != month ||
        date.getDate() != day ||
        date.getHours() != hours ||
        date.getMinutes() != minutes
    ) {
        return false; // Некорректная дата
    }

    return true; // Дата корректна
}

Helper.ParseTooltipTemplate = function(str)
{
    let pattern = /<span title='[^']*'>([^<]*)<\/span>/;

    if (str) {
        let match = str.match(pattern);
        if (match) {
            str = match[1];
        }
    }
    return str;
}

Helper.GetPeriodsDiffInMinutes = function(periodFrom, periodTo)
{
    let result = null;

    let timesStamps = [];

    for(let period of [periodFrom, periodTo])
    {
        if(period === "now")
        {
            timesStamps.push(new Date().getTime());
            continue;
        }

        let curDate = new Date();
        let calcDate = null;

        let periodArr = period.split(" ");
        let val = parseInt(periodArr[2]);
        let timeVal = periodArr[3];

        if (timeVal.endsWith("s")) {
            timeVal = timeVal.slice(0, -1);
        }

        switch (timeVal)
        {
            case "minute":
                calcDate = new Date(curDate.setMinutes(curDate.getMinutes() - val));
                break;
            case "hour":
                calcDate = new Date(curDate.setHours(curDate.getHours() - val));
                break;
            case "day":
                calcDate = new Date(curDate.setDate(curDate.getDate() - val));
                break;
            case "month":
                calcDate = new Date(curDate.setMonth(curDate.getMonth() - val));
                break;
            case "year":
                calcDate = new Date(curDate.setFullYear(curDate.getFullYear() - val));
                break;
            default:
                continue;
        }

        timesStamps.push(calcDate.getTime());
    }

    if(timesStamps.length == 2)
    {
        result = (timesStamps[1] - timesStamps[0]) / (1000 * 60);
    }

    return result;
}

Helper.CountReportSettingsStateChanges = function(State, CompareState)
{
    let result = {
        by_keys: 0,
        by_vals: 0
    }

    Object.keys(State).forEach(key => {
        if(Object.keys(CompareState).includes(key))
        {
            let val = State[key];
            let compareVal = CompareState[key];

            if(Array.isArray(val) && Array.isArray(compareVal))
            {
                let symDifference = val.filter(x => !compareVal.includes(x))
                    .concat(compareVal.filter(x => !val.includes(x)));

                if(symDifference.length)
                {
                    result.by_keys++;
                    result.by_vals += symDifference.length;
                }
            }
            else
            {
                if (val != compareVal)
                {
                    result.by_keys++;
                    result.by_vals++;
                }
            }
        }
        else
        {
            result.by_keys++;
        }
    });

    return result;
};


Helper.SwapObj = function(Obj)
{
    var ret = {};

    for(var key in Obj)
    {
        ret[Obj[key]] = key;
    }

    return ret;
};

Helper.GetDateTimeFormat = function(Format = null)
{
    let format = Format ? Format : "%d.%m.%Y %H:%i";

    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
        format = DateFormatDic[App.Locale].datetime_format

    return format
};

Helper.IsValidDateStr = function(StrVal, Format)
{
    let res = false;

    let parse = webix.Date.strToDate(Format);
    let unparse = webix.Date.dateToStr(Format);

    let date = parse(StrVal);

    if(webix.isDate(date))
    {
        let parseVal = parse(StrVal);
        let unParse = unparse(parseVal);

        if(unParse === StrVal)
            res = true;
    }

    return res;
};

Helper.FindObjById = function(IdToFind, Obj)
{
    let res = null;

    if(Obj && typeof Obj === "object")
    {
        if(!Array.isArray(Obj))
        {
            if(Obj.id === IdToFind)
                return Obj;

            res = Helper.FindObjById(IdToFind, Object.values(Obj));
        }
        else if(Array.isArray(Obj))
        {
            for(let item of Obj)
            {
                res = Helper.FindObjById(IdToFind, item);

                if(res)
                    break;
            }
        }
    }

    return res;
};

Helper.GetElementPluralForm = function(Count)
{
    const lastTwo = Count % 100;
    const lastOne = Count % 10;

    if (lastTwo >= 11 && lastTwo <= 19) {
        return LangHelper.GetString("Subscribers", "ElementsMany");
    }

    if (lastOne === 1) {
        return LangHelper.GetString("Subscribers", "Element");
    }

    if (lastOne >= 2 && lastOne <= 4) {
        return LangHelper.GetString("Subscribers", "Elements");
    }

    return LangHelper.GetString("Subscribers", "ElementsMany");
};

Helper.IsObject = function(Obj) {
    return Obj !== null && typeof Obj === "object" && !Array.isArray(Obj);
};

Helper.IsConfig = function(Obj) {
    return (
        Helper.IsObject(Obj) &&
        Helper.IsObject(Obj.config)
    )
};

Helper.HasCache = function(Config) {
    return (
        Helper.IsObject(Config) &&
        Helper.IsObject(Config.cache) &&
        Config.cache.enabled
    )
}

Helper.HasTable = function (Config) {
    return (
        Helper.IsObject(Config) &&
        typeof Config.table === "string" &&
        Config.table.length > 0
    )
};

Helper.HasCols = function (Config) {
    return (
        Helper.IsObject(Config) &&
        Array.isArray(Config.cols) &&
        Config.cols.length > 0
    );
};

Helper.HasRows = function (Config) {
    return (
        Helper.IsObject(Config) &&
        Array.isArray(Config.rows) &&
        Config.rows.length > 0
    );
};

Helper.HasColsValues = function (Config) {
    return (
        Helper.HasCols(Config) &&
        Helper.IsObject(Config.cols[0]) &&
        Array.isArray(Config.cols[0].values) &&
        Config.cols[0].values.length > 0
    );
};

Helper.HasValues = function (Config) {
    return (
        Helper.IsObject(Config) &&
        Array.isArray(Config.values) &&
        Config.values.length > 0
    );
};

Helper.HasColumns = function (Config) {
    return (
        Helper.IsObject(Config) &&
        Array.isArray(Config.columns) &&
        Config.columns.length > 0
    );
};

Helper.IsGetTopList = function (Config) {
    return (
        Helper.HasCols(Config) &&
        Helper.IsObject(Config.cols[0].values) &&
        Config.cols[0].values.func === "GetTopList" &&
        Helper.IsObject(Config.cols[0].values.params) &&
        typeof Config.cols[0].values.params.func === "string" &&
        Config.cols[0].values.params.func.length > 0
    );
};

Helper.IsGetTopListLimit = function (Config) {
    return (
        Helper.IsGetTopList(Config) &&
        Config.cols[0].values.params.limit > 0
    );
};

Helper.HasSort = function (Obj) {
    return (
        Helper.IsObject(Obj) &&
        Helper.IsObject(Obj.sort)
    )
};

Helper.HasSortId = function (Obj) {
    return (
        Helper.HasSort &&
        typeof Obj.sort.id === "string"
    );
};

Helper.HasSortDir = function (Obj) {
    return (
        Helper.HasSort &&
        typeof Obj.sort.dir === "string"
    );
};

Helper.IsTableWidget = function (Obj) {
    return Obj instanceof QoETableReportWidget;
};

Helper.IsChartWidget = function (Obj) {
    return Obj instanceof QoESeriesChartReportWidget;
};

Helper.IsPieChartWidget = function (Obj) {
    return Obj instanceof QoEPieChartReportWidget;
};

Helper.IsTableChartWidget = function (Obj) {
    return Obj instanceof QoETableChartWidget;
};

Helper.IsLookLikeCode = function (Str) {
    if(typeof Str !== "string")
        return false;

    return Helper.RE_LOOKS_LIKE_CODE.test(Str);
};

Helper.EvalProp = function (Prop) {
    try {
        Prop = eval(Prop);
    } catch(e) {
        Prop = "";
    }

    return Prop;
};

function ConfigHelper() {}

ConfigHelper.IsNumber = function (Val)
{
    return !isNaN(Val*1);
};

ConfigHelper.IsInterface = function (Val)
{
    if(Val)
        return Helper.ValidateAnyInterface(Val);
    else
        return true;
};

ConfigHelper.IsInterfacesArr = function (Val)
{
    if(Val)
        return Helper.ValidateDnaArr(Val);
    else
        return true;
};

ConfigHelper.IsValidUrl = function (Val)
{
    if(Val)
        return Helper.IsUrlValid(Val);
    else
        return true;
};

ConfigHelper.IsValidFilePath = function (Val)
{
    if(Val)
        return Helper.IsFilePathValid(Val);
    else
        return true;
};

ConfigHelper.IsValidUrlOrFilePath = function (Val)
{
    if(Val)
        return Helper.IsFilePathOrUrlValid(Val);
    else
        return true;
};

ConfigHelper.IsValidIpAndPort = function (Val)
{
    if(Val)
        return Helper.IsFilePathOrUrlValid(Val);
    else
        return true;
};

ConfigHelper.IsValidUrlOrIpAndPort = function (Val)
{
    if(Val)
    {
        if(Helper.IsUrlValid(Val))
            return true;

        if(Helper.ValidateIPaddressPlusPort(Val))
            return true;

        return false;
    }
    else
        return true;
};

ConfigHelper.IsValidIpAddress = function (Val)
{
    if(Val)
        return Helper.ValidateIPaddress(Val);
    else
        return true;
};

ConfigHelper.IsValidIPv4Addresses = function (Val)
{
    if(Val)
        return Helper.ValidateIPv4Addresses(Val);
    else
        return true;
};

ConfigHelper.IsValidIPv6Addresses = function (Val)
{
    if(Val)
        return Helper.ValidateIPv6Addresses(Val);
    else
        return true;
};

ConfigHelper.IsValidIpAddressOrCidr = function (Val)
{
    if(Val)
        return Helper.ValidateIPaddressOrCidr(Val);
    else
        return true;
};

ConfigHelper.IsValidPortArr = function (Val)
{
    if(Val)
        return Helper.ValidatePortsArr(Val);
    else
        return true;
};

ConfigHelper.IsMacAddress = function (Val)
{
    if(Val)
        return Helper.ValidateMacAddress(Val);
    else
        return true;
};

ConfigHelper.IsNumberNotNegative = function(Val)
{
    return Helper.IsNumberNotNegative(Val);
};

ConfigHelper.ValidateFdpiServer = function(Val)
{
    if(!Val)
    {
        return false;
    }

    var reg = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))\%([0-9a-zA-Z\-\_]+)\:([0-9]+)(\;(([a-zA-z\_\-])+([0-9\_\-]){0,}([0-9a-zA-z])+\=([0-9a-zA-z\_\-\.]+))){0,}$/;

    if(reg.test(Val))
    {
        return true;
    }

    return false;
};

ConfigHelper.ValidateRadiusServer = function(Val)
{
    if(!Val)
    {
        return false;
    }

    var reg = /^([0-9a-zA-Z\_\-\.]+)\@((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(\%[0-9a-zA-Z\-\_]+)?\:([0-9]+)(\;(([a-zA-z\_\-])+([0-9\_\-]){0,}([0-9a-zA-z])+\=([0-9a-zA-z\_\-]+))){0,}$/;

    if(reg.test(Val))
    {
        return true;
    }

    return false;
};

ConfigHelper.IsNumberLessThen256 = function(Val)
{
    if(Helper.IsNumberNotNegative(Val))
    {
        return !!(Val <= 256);
    }
    return false;
};
ConfigHelper.IsNumberGreaterThen60 = function(Val)
{
    if(Helper.IsNumberNotNegative(Val))
    {
        return !!(Val >= 60);
    }

    return false;
};

ConfigHelper.ValidateFileSize = function(Val)
{
    return !!(Val == 0 || Helper.ValidateFileSize(Val));
};

ConfigHelper.ValidateCoaClient = function(Val)
{
    if(!Val)
    {
        return true;
    }

    var reg = /^([0-9a-zA-Z\_\-\.]+)\@((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(\%[0-9a-zA-Z\-\_]+)\:([0-9]+)$/;

    if(reg.test(Val))
    {
        return true;
    }

    return false;
};

ConfigHelper.ValidateDHCPNetmask = function(Val)
{
    if(!Val)
    {
        return true;
    }

    return Helper.ValidateIPaddress(Val);
};

ConfigHelper.IsNumberNotNegativeNotRequered = function(Val)
{
    if(!Val)
    {
        return true;
    }

    return Helper.IsNumberNotNegative(Val);
};

ConfigHelper.ValidatePageCount = function(Val)
{
    if(Helper.IsNumberNotNegative(Val))
    {
        return !!(Val == 0 || Val > 1);
    }
    return false;
};

ConfigHelper.ValidateDHCPServer = function(Val)
{
    if(!Val)
    {
        return true;
    }

    var reg = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(\%[0-9a-zA-Z\-\_]+)$/;

    if(reg.test(Val))
    {
        return true;
    }

    return false;
};

ConfigHelper.ValidateDHCPServerV6 = function(Val)
{
    if(!Val)
    {
        return true;
    }

    var reg = /^\[(([0-9a-fA-F]){4})(\:([0-9a-fA-F]{0,4}))+\%([0-9a-zA-Z\_\-\.]+)\](\:[0-9]+)?(\;(([a-zA-z\_\-])+([0-9\_\-]){0,}([0-9a-zA-z])+\=((([0-9a-fA-F]){4})(\:([0-9a-fA-F]{0,4}))+))){0,}$/;

    if(reg.test(Val))
    {
        return true;
    }

    return false;
};

ConfigHelper.ValidateTrafficConfig = function(Val)
{
  if(!Val)
  {
      return true;
  }

    var reg = /^rate\s+([0-9]+[kmg]?bit)(\s+(static|((ceil\s+([0-9]+[kmg]?bit)))?(\s+burst\s+([0-9]+[kmg]?bit))?(\s+cburst\s+([0-9]+[kmg]?bit))?))?$/;

    if(reg.test(Val))
    {
        return true;
    }

    return false;
};

ConfigHelper.ValidatePortRange = function (Val)
{
    if(Val)
        return Helper.ValidatePortRange(Val);
    else
        return true;
};

ConfigHelper.ValidateCidrIpv4 = function (Cidr)
{
    if (/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/.test(Cidr))
    {
        return true;
    }

    return false;
};

ConfigHelper.ValidateCidrIpv4OrEmpty = function(Val)
{
    if(!Val)
    {
        return true;
    }

    return ConfigHelper.ValidateCidrIpv4(Val);
}

ConfigHelper.ValidateCidrIpv6 = function (Cidr)
{
    if(/^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$/.test(Cidr))
    {
        return true;
    }

    return false;
};

ConfigHelper.ValidateCidrIpv6OrEmpty = function(Val)
{
    if(!Val)
    {
        return true;
    }

    return ConfigHelper.ValidateCidrIpv6(Val);
}
/* global Helper */
/* global MeasureObjectsTypeDic */

function DataGens() {}

DataGens.Subscribers = {};

DataGens.Subscribers.GridData = function (Params) {
    "use strict";

    var serv_str = function (i,j) {
        var str = "";

        var sliced = Object.keys(ServicesDic).slice(i,j);

        if(i > j)
            sliced = Object.keys(ServicesDic).slice(j,i);

        sliced.forEach(function (key,index)
        {
            if(index > 0)
                str += ",";
            str += ServicesDic[key].id;
        });

        return str;
    }

    var obj = function (i,date) {

        var services_str = serv_str(Helper.RandInt(0, Object.keys(ServicesDic).length+1), Helper.RandInt(0, Object.keys(ServicesDic).length+1));
        var services = {
            black_list:{
                enabled:false,
                profile:null
            }
        };

        if(services_str.indexOf("black_list") >= 0)
        {
            services["black_list"] = {
                enabled:true,
                profile:Helper.RandInt(1, Object.keys(BlProfileDic).length+1)
            };
        }


        return {
            id:""+i,
            login:"Абонент "+i,
            services_str:services_str,
            service_black_list_enabled:services.black_list.enabled,
            service_black_list_profile:services.black_list.profile,
            ip:"192.168.1."+i,
            tariff:Object.keys(TariffProfileDic)[Helper.RandInt(0, Object.keys(TariffProfileDic).length-1)]
        };
    };

    var res = [];

    for (var L0 = 1; L0 <= (Params && Params.max ? Params.max : 100); L0++)
    {
        res.push(obj(L0));
    }

    return res;
};

DataGens.Services = {};

DataGens.Services.BlackList = {};

DataGens.Services.BlackList.Profiles = function(Params)
{
    return [
        {
            "id": "1",
            "name": "Блокировки",
            "open": true,
            "data": [
                {
                    "id": "1.1",
                    "profile": "Профиль 1"
                },
                {
                    "id": "1.2",
                    "profile": "Профиль 2"
                },
                {
                    "id": "1.3",
                    "profile": "Профиль 3"
                }
            ]
        },
        {
            "id": "2",
            "name": "Перенаправления",
            "open": true,
            "data": [
            {
                "id": "2.1",
                "profile": "Профиль 1"
            },
            {
                "id": "2.2",
                "profile": "Профиль 2"
            }
        ]
        }
    ];
}

DataGens.Services.BlackList.GridData = function(Params)
{
    var types = ['URL', 'IP', 'SNI', 'CN'];
    var uris = {"URL":'http://www.somedomen_%i%.ru',IP:'192.168.1.%i%',SNI:'somesni_%i%',CN:'somecn_%i%'};

    var obj = function (i) {

        var type = types[Helper.RandInt(0,types.length-1)];
        var uri = (uris[type]).replace("%i%", i);
        var block_type = ""+Helper.RandInt(1,2);
        var redirect_url = (block_type == "2" ? "http://www.someredirect_%i%.ru" : "").replace("%i%", i);

        return {
            "id":i,
            "uri":uri,
            "type":type,
            "direct":""+Helper.RandInt(1,3),
            "block_type":""+Helper.RandInt(1,2),
            "redirect_url":redirect_url,
            enabled:1
        }
    };

    var objs = [];
    for (var i = 0; i < 100; i++)
    {
        objs.push(obj(i));
    }

    return objs;
};

DataGens.Tariffs = {};

DataGens.Tariffs.Profiles = function(Params)
{
    return [
        {
            "id": "1",
            "tariff": "Тариф 1"
        },
        {
            "id": "2",
            "tariff": "Тариф 2"
        }
    ];
}

DataGens.Tariffs.GridData = function(Type)
{
    var obj = function (i) {

        return {
            class:i == 0 ? "root":"cs"+(i-1),

            inRateVal:Helper.RandInt(1,100),
            inRateUnit:TrafficUnits[Helper.RandInt(1, Object.keys(TrafficUnits).length)].id,

            inCeilVal:Helper.RandInt(1,100),
            inCeilUnit:TrafficUnits[Helper.RandInt(1, Object.keys(TrafficUnits).length)].id,

            inPeakRateVal:Helper.RandInt(1,100),
            inPeakRateUnit:TrafficUnits[Helper.RandInt(1, Object.keys(TrafficUnits).length)].id,

            inBurstVal:Helper.RandInt(1,100),
            inBurstUnit:TrafficUnits[Helper.RandInt(1, Object.keys(BufferUnits).length)].id,

            inCBurstVal:Helper.RandInt(1,100),
            inCBurstUnit:TrafficUnits[Helper.RandInt(1, Object.keys(BufferUnits).length)].id,

            outRateVal:Helper.RandInt(1,100),
            outRateUnit:TrafficUnits[Helper.RandInt(1, Object.keys(TrafficUnits).length)].id,
            outCeilVal:Helper.RandInt(1,100),
            outCeilUnit:TrafficUnits[Helper.RandInt(1, Object.keys(TrafficUnits).length)].id,

            outPeakRateVal:Helper.RandInt(1,100),
            outPeakRateUnit:TrafficUnits[Helper.RandInt(1, Object.keys(TrafficUnits).length)].id,

            outBurstVal:Helper.RandInt(1,100),
            outBurstUnit:TrafficUnits[Helper.RandInt(1, Object.keys(BufferUnits).length)].id,

            outCBurstVal:Helper.RandInt(1,100),
            outCBurstUnit:TrafficUnits[Helper.RandInt(1, Object.keys(BufferUnits).length)].id
        }
    };

    var objs = [];
    for (var i = (Type&&Type==="TBF"?1:0); i <= 8; i++)
    {
        objs.push(obj(i));
    }

    return objs;
}

DataGens.Advs = {};

DataGens.Advs.Profiles = function(Params)
{
    return [
        {
            "id": "1",
            "profile": "Общие",
            "open": true,
            "data": [
                {
                    "id": "1.1",
                    "profile": "Группа 1"
                },
                {
                    "id": "1.2",
                    "profile": "Группа 2"
                },
                {
                    "id": "1.3",
                    "profile": "Группа 3"
                }
            ]
        },
        {
            "id": "2",
            "profile": "Таргетинг",
            "open": true,
            "data": [
                {
                    "id": "2.1",
                    "profile": "Группа 1"
                },
                {
                    "id": "2.2",
                    "profile": "Группа 2"
                }
            ]
        }
    ];
}

DataGens.Advs.GridData = function(Params)
{
    var obj = function (i) {

        var date_from = Helper.RandDate();
        var date_to = Helper.RandDate();

        var total = Helper.RandInt(0,10000);
        var released = Helper.RandInt(0,total);

        var state = AdvsStatesDic[Helper.RandInt(1, Object.keys(AdvsStatesDic).length)].id;

        if(parseInt(state) < 3)
        {
            total = 0;
            released = 0;
        }

        return {
            name:"Кампания "+i,
            date_from:date_from<date_to?date_from:date_to,
            date_to:date_from>date_to?date_from:date_to,
            state:state,
            user:UsersDic[Helper.RandInt(1, Object.keys(UsersDic).length)].id,
            dpi_group:DpiGroupDic[Helper.RandInt(1, Object.keys(DpiGroupDic).length)].id,
            days_of_week:"1,2,3,4,5,6,7",
            progress:{total:total, done:released}
        }
    };

    var objs = [];
    for (var i = 0; i <= 100; i++)
    {
        objs.push(obj(i));
    }

    return objs;
}

DataGens.Performance = {};

DataGens.Performance.TraficObj = function (min,max,i) {
    return {
        id:i,
        trafic:parseInt(Math.random() * (max - min) + min),
        locked:parseInt(Math.random() * (max/3 - min/3) + min/3),
        time:(new Date(2014, 7, 7, i)).toISOString()
    }
}

DataGens.Performance.TraficIn = function () {
    r = [];
    for (var i = 0; i < 100; i++)
    {
        if(i > 70 && i < 80)
        {
            r.push(DataGens.Performance.TraficObj(500,1000,i));
        }
        else
        {
            r.push(DataGens.Performance.TraficObj(160,450,i));
        }

    }

    return r;
};

DataGens.Performance.TraficOut = function () {
    r = [];
    for (var i = 0; i < 100; i++)
    {
        if(i > 70 && i < 80)
        {
            r.push(DataGens.Performance.TraficObj(150,350,i));
        }
        else
        {
            r.push(DataGens.Performance.TraficObj(80,150,i));
        }

    }

    return r;
};
/* global webix */
/* global App */
var DicsEnum = {
    RolesDic:"RolesDic",
    UsersDic:"UsersDic",
    HardwaresDic:"HardwaresDic",
    HardwareSshKeysDic:"HardwareSshKeysDic",
    ProtocolsDic:"ProtocolsDic",
    HostCategoriesDic:"HostCategoriesDic",
    PolicingProfilesDic: "PolicingProfilesDic",
    BlackListsProfilesDic: "BlackListsProfilesDic",
    WhiteListsProfilesDic: "WhiteListsProfilesDic",
    DDOSProtectionProfilesDic: "DDOSProtectionProfilesDic",
    SessionPolicingProfilesDic: "SessionPolicingProfilesDic",
    CgNatProfilesDic: "CgNatProfilesDic",
    MiniFireWallProfilesDic: "MiniFireWallProfilesDic",
    UlrResourceTypesDic: "UlrResourceTypesDic",
    UlrCategoriesDic: "UlrCategoriesDic",
    UlrRegulatorsDic: "UlrRegulatorsDic",
    UlrIspsDic:"UlrIspsDic",
    UlrSubscribersDic:"UlrSubscribersDic",
    UlrIgwsDic:"UlrIgwsDic",
    UlrIgwsVchannelTypesDic:"UlrIgwsVchannelTypesDic",
    UlrNodesDic:"UlrNodesDic",
    UlrBridgesDic:"UlrBridgesDic",
    UlrIgwsModesDic:"UlrIgwsModesDic",
    UlrVchannelTypesDic: "UlrVchannelTypesDic",
    UlrPolicingTypesDic:"UlrPolicingTypesDic",
    UlrHardwaresDic:"UlrHardwaresDic",
    UlrLogTypesDic:"UlrLogTypesDic",
    UlrSubscribersTypesDic: "UlrSubscribersTypesDic",
    UlrSessionPolicingTemplatesDic: "UlrSessionPolicingTemplatesDic",

    CustomProtocolsDic: "CustomProtocolsDic",

    TelcosDic:"TelcosDic",
    PortsDic:"PortsDic",
    TermCausesDic:"TermCausesDic",
    IpDataPointsDic:"IpDataPointsDic",
    SwitchesDic:"SwitchesDic",
    BunchesDic:"BunchesDic",

    CardsDic:"CardsDic",
    CpuDic:"CpuDic",

    ClsfrCategoriesDic:"ClsfrCategoriesDic",
    ProtocolsGroupsDic: "ProtocolsGroupsDic",
    ProtocolsGroupsDicJson: "ProtocolsGroupsDicJson",

    ProtocolsCustomGroupsDic: "ProtocolsCustomGroupsDic",

    LiTrafficDecodeTasksDic: "LiTrafficDecodeTasksDic",
    CustomProtocolsTemplatesDic:"CustomProtocolsTemplatesDic",

    VaseListsDic:"VaseListsDic",

    InfectedHostCategoriesDic:"InfectedHostCategoriesDic",

    CustomPrtclsGroupsDic: "CustomPrtclsGroupsDic",
    VasCloudCustomPrtclsDic: "VasCloudCustomPrtclsDic"
};

var ServicesDicsEnum = {
    4: DicsEnum.BlackListsProfilesDic,
    5: DicsEnum.WhiteListsProfilesDic,
    10: DicsEnum.DDOSProtectionProfilesDic,
    11: DicsEnum.CgNatProfilesDic,
    13: DicsEnum.MiniFireWallProfilesDic,
    18: DicsEnum.SessionPolicingProfilesDic
};

function DicModel(Params)
{
    this.id = Params&&Params.dic_id?Params.dic_id:0;
    this.dic_id = Params&&Params.dic_id?Params.dic_id:0;
    this.value = Params&&Params.value?Params.value:"";
    this.status = Params&&Params.status?Params.status:"";
}

function DicHardwareModel(Params)
{
    "use strict";

    DicHardwareModel.superclass.constructor.call(this, Params);

    this.ip = Params&&Params.ip?Params.ip:"";
    this.port = Params&&Params.port?Params.port:"";
    this.login = Params&&Params.login?Params.login:"";

    this.ipfix_id = Params&&Params.ipfix_id?Params.ipfix_id:0;
    this.hardware_type = Params&&Params.hardware_type?Params.hardware_type:HardwareTypesEnum.dpi;
}
Helper.ExtendClass(DicHardwareModel,DicModel);


function UlrIspSubsDicModel(Params)
{
    UlrIspSubsDicModel.superclass.constructor.call(this, Params);

    this.igw_name = Params&&Params.igw_name?Params.igw_name:"";
}
Helper.ExtendClass(UlrIspSubsDicModel,DicModel);


function DicsManager(Params)
{
    "use strict";

    var _this = this;

    this.Dics = {};

    this.DicsUpdated = new Rx.BehaviorSubject(0);

    this.Signal = {};

    Object.keys(DicsEnum).forEach(function (Key) {
        _this.Signal[Key] = new Rx.BehaviorSubject(0);
    });

    this.Init();

    return this;
}

DicsManager.prototype.Init = function(Params)
{
    "use strict";
};

DicsManager.prototype.Refresh = function(Params)
{
    "use strict";
    var _this = this;
    var params =
        {
            method:"GetDics",
            callback:function (result) {
                if(result.success)
                {
                    Object.keys(result.data).forEach(function (key)
                    {
                        var dict = result.data[key];

                        var model = DicModel;

                        if(key === DicsEnum.HardwaresDic)
                        {
                            model = DicHardwareModel;
                        }

                        if(key === DicsEnum.UlrIspsDic || key === DicsEnum.UlrSubscribersDic)
                        {
                            model = UlrIspSubsDicModel;
                        }

                        Object.keys(dict).forEach(function (Key)
                        {
                            if(key == DicsEnum.UlrResourceTypesDic)
                            {
                                dict[Key].value = LangHelper.GetString("UlrModule", dict[Key].value)
                            }
                            dict[Key] = new model(dict[Key]);
                        });

                        if(key === DicsEnum.InfectedHostCategoriesDic)
                        {
                            let named_dic = {};
                            Object.keys(dict).forEach(function (key)
                            {
                                let cat_key = dict[key].id;
                                named_dic[cat_key] = dict[key];
                            });
                            dict = named_dic;
                        }

                        _this.Dics[key] = dict;

                        if(_this.Signal[key])
                        {
                            _this.Signal[key].next(1);
                        }
                    });
                    _this.DicsUpdated.next(1);
                }
            }
        };

    if(Params&&Params.data)
    {
        params.data = {DicsKeys:Params.data};

        if(Params.filter)
        {
            params.data.Filter = Params.filter + "";
        }
    }

    App.ServerManager.CallMethod(params);
};

DicsManager.prototype.GetDics = function()
{
    return this.Dics;
};

DicsManager.prototype.GetDic = function(Id)
{
    return this.Dics[Id];
};

DicsManager.prototype.SetDic = function(Id, Dict, CustomModel)
{
    if(!DicsEnum[Id] || !Dict)
        return;

    var dict = Dict;

    var model = CustomModel ? CustomModel : DicModel;

    Object.keys(dict).forEach(function (key)
    {
        if(Id === DicsEnum.UlrResourceTypesDic)
        {
            dict[key].value = LangHelper.GetString("UlrModule", dict[key].value)
        }
        dict[key] = new model(dict[key]);
    });

    this.Dics[Id] = dict;

    if(this.Signal[Id])
    {
        this.Signal[Id].next(1);
    }

    this.DicsUpdated.next(1);
};

DicsManager.prototype.GetDicAsArray = function(Id)
{
    return Helper.DictToArr(webix.copy(this.Dics[Id]));
};

DicsManager.prototype.GetDicAsArrayWithEmpty = function(Id)
{
    "use strict";

    var result = this.GetDicAsArray(Id);

    result.splice( 0, 0, {id:"",value:"",$empty:true} );

    return result;
};

DicsManager.prototype.GetDicAsArrayWithFilter = function(Id, FilterField, FilterValue)
{
    var dicArr = this.GetDicAsArray(Id);

    var result = [];

    dicArr.forEach(function (Obj) {
        if(Obj&&Obj[FilterField]&&Obj[FilterField]==FilterValue)
            result.push(Obj);
    });

    return result;
};
/* global webix */
/* global alert */

function ServerErrorModel(Params)
{
    this.code = Params&&Params.code? Params.code : 0;
    this.msg = Params&&Params.msg? Params.msg : "";
}

function ServerManager(Params)
{
    "use strict";
    this.server = "/api";
    this.urls = {
        jsonrpc:"/jsonrpc",
        file:"/file"
    };

    this.Loading = new Rx.BehaviorSubject(0);
    this.TotalConnects  = 0;

    this.Init();

    return this;
}

ServerManager.prototype.Init = function(Params)
{
    "use strict";
};

ServerManager.prototype.Request = function(Params)
{
    "use strict";
    
    var _this = this;

    var _request = {
        jsonrpc:"2.0",
        method: "Api",
        params: {},
        id: webix.uid()
    };

    var requests = [];

    if(Params.requests)
    {
        Params.requests.forEach(function (Request) {
            var request = webix.copy(_request);
            request.method += Request.method?(Request.method.indexOf("_") >= 0 ? Request.method : "_"+Request.method):"";
            request.params = Request.data?Request.data:{};
            request.id = Request.id?Request.id:webix.uid();
            requests.push(request);
        });
    }
    else
    {
        var request = webix.copy(_request);
        request.method += Params.method?(Params.method.indexOf("_") >= 0 ? Params.method : "_"+Params.method):"";
        request.params = Params.data?Params.data:{};
        request.id = Params.id?Params.id:webix.uid();

        requests.push(request);
    }


    var callback = function(text, data, XmlHttpRequest)
    {
        var _result = {
            id:0,
            success:true,
            error:{code:0,msg:""},
            data:null
        };

        var results = webix.copy(_result);

        if(XmlHttpRequest.status >= 200 && XmlHttpRequest.status < 400)
        {
            results.success = true;
        }
        else
        {
            results.success = false;
            results.error.code = XmlHttpRequest.status;
            results.error.msg = LangHelper.GetString("All", XmlHttpRequest.statusText);
        }

        if(results.success)
        {
            try
            {
                var _json = data.json();

                var parseData = function (json) {

                    var result = webix.copy(_result);

                    result.id = json.id;

                    if(json.error)
                    {
                        result.success = false;
                        result.error = {
                            code:json.error.code,
                            msg:json.error.message?json.error.message:(json.error.msg?json.error.msg:"")
                        };

                        if(result.error.code === 7000 && requests[0].method != "Api_Auth" && requests[0].method != "Api_Login" && requests[0].method != "Api_Logout")
                        {
                            webix.message({text:result.error.msg, type:"error"});
                            setTimeout(function () {
                                App.Logout();
                            },10);
                        }

                        if(result.error.code === 7001)
                        {
                            webix.message({text:result.error.msg, type:"error"});
                        }
                    }

                    if(result.success && json.result)
                    {
                        if(json.result.success)
                        {
                            result.data = json.result.data;
                        }
                        else
                        {
                            result.success = false;
                            result.error = {
                                code:json.result.error.code,
                                msg:json.result.error.msg
                            };
                        }
                    }

                    return result;
                }

                if(Array.isArray(_json))
                {
                    var _results = [];
                    _json.forEach(function (json) {
                        _results.push(parseData(json))
                    });

                    results = _results;
                }
                else
                {
                    results = parseData(_json);
                }
            }
            catch(e)
            {
                results.success = false;
                results.error.msg = LangHelper.GetString("All", "Parser error");
            }
        }

        if(Params.callback && typeof Params.callback === "function")
        {
            Params.callback(results);
        }
    };

    if(Params.method&&Params.method==="GET")
    {
        this.TotalConnects++;
        this.Loading.next(this.TotalConnects);

        webix.ajax().timeout(300000).headers({"Content-type":"application/json"}).get(Params.url, Params.data, {
            error:function(text, data, XmlHttpRequest)
            {
                _this.TotalConnects--;
                _this.Loading.next(_this.TotalConnects);

                callback(text, data, XmlHttpRequest);
            },
            success:function(text, data, XmlHttpRequest)
            {
                _this.TotalConnects--;
                _this.Loading.next(_this.TotalConnects);

                callback(text, data, XmlHttpRequest);
            }
        });
    }
    else
    {
        this.TotalConnects++;
        this.Loading.next(this.TotalConnects);

        webix.ajax().timeout(300000).headers({"Content-type":"application/json"}).post(Params.url, JSON.stringify(requests), {
            error:function(text, data, XmlHttpRequest)
            {
                _this.TotalConnects--;
                _this.Loading.next(_this.TotalConnects);

                callback(text, data, XmlHttpRequest);
            },
            success:function(text, data, XmlHttpRequest)
            {
                _this.TotalConnects--;
                _this.Loading.next(_this.TotalConnects);

                callback(text, data, XmlHttpRequest);
            }
        });
    }


};

ServerManager.prototype.CheckLoggedIn = function(Params)
{
    "use strict";
    var url = this.server+this.urls.jsonrpc;

    this.Request({url:url, method:"Auth", callback:function (R) {
        if(Params&&Params.callback && typeof Params.callback === "function")
        {
            Params.callback(R);
        }
    }});
};

ServerManager.prototype.Login = function(Params)
{
    "use strict";
    var url = this.server+this.urls.jsonrpc;

    var postData = {
        username:Params&&Params.username ? Params.username : "",
        password:Params&&Params.password ? Params.password : "",
        remember:Params&&Params.remember ? true : false
    };

    this.Request({url:url, method:"Login", data:postData, callback:function (R) {
        if(Params&&Params.callback && typeof Params.callback === "function")
        {
            Params.callback(R);
        }
    }});
};

ServerManager.prototype.Logout = function(Params)
{
    "use strict";
    var url = this.server+this.urls.jsonrpc;

    this.Request({url:url, method:"Logout", callback:function (R) {
        if(Params&&Params.callback && typeof Params.callback === "function")
        {
            Params.callback(R);
        }
    }});
};

ServerManager.prototype.CallMethod = function(Params)
{
    "use strict";
    var url = this.server+this.urls.jsonrpc;

    this.Request({id:Params.id, url:url,  method:Params.method, data:Params.data, requests:Params.requests, callback:function (R) {
        if(Params&&Params.callback && typeof Params.callback === "function")
        {
            Params.callback(R);
        }
    }});
};

ServerManager.prototype.RedirectToFileDownload = function(FileId, Params = "")
{
    var iframe = document.getElementById("hiddenDownloader");

    if (!iframe)
    {
        iframe = document.createElement('iframe');
        iframe.id = "hiddenDownloader";
        iframe.style.visibility = 'hidden';
        iframe.style.display = 'none';
        iframe.style.width = '0px;';
        iframe.style.height = '0px;';
        document.body.appendChild(iframe);
    }
    iframe.src = this.server + this.urls.file + "/" + FileId + Params;
};

ServerManager.prototype.UlrGenerateFileUploadId = function(Params)
{
    var _this = this;

    var fileName = Params && Params.fileName ? Params.fileName : null;
    var path = Params && Params.path ? Params.path : null;

    var params =
        {
            id: webix.uid(),
            method:"UlrGenerateFileUploadId",
            data: {
                File: fileName,
                Path: path
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

ServerManager.prototype.VasCloudGenerateFileUploadId = function(Params)
{
    var _this = this;

    var fileName = Params && Params.fileName ? Params.fileName : null;
    var path = Params && Params.path ? Params.path : null;

    var params =
        {
            id: webix.uid(),
            method:"VasCloudGenerateFileUploadId",
            data: {
                File: fileName,
                Path: path
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

ServerManager.prototype.GenerateFileUploadId = function(Params)
{
    var _this = this;

    var fileName = Params && Params.fileName ? Params.fileName : null;
    var path = Params && Params.path ? Params.path : null;

    var params =
        {
            id: webix.uid(),
            method:"GenerateFileUploadId",
            data: {
                File: fileName,
                Path: path
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

ServerManager.prototype.UploadFile = function(Params)
{
    var file = Params && Params.file ? Params.file : null;
    var key = Params && Params.key ? Params.key : null;

    var callback = Params && Params.callback && typeof Params.callback === "function" ? Params.callback : null;
    if(file && key)
    {
        var formData = new FormData();
        // formData.append("saveTo", path);
        formData.append("file", file);



        var request = new XMLHttpRequest();
        request.open("POST", "/api/upload_file/" + key);
        request.send(formData);

        var req_cl = function()
        {
            if(request.status != 200 && !callback)
            {
                webix.message({text:request.status + ": " + request.statusText,type:"error"});
            }

            if(callback && typeof callback === "function")
            {
                callback(request);
            }
        };

        request.onload = req_cl;

        request.onerror = req_cl;
    }
};

ServerManager.prototype.VasCloudUploadFile = function(Params)
{
    var file = Params && Params.file ? Params.file : null;
    var key = Params && Params.key ? Params.key : null;

    var callback = Params && Params.callback && typeof Params.callback === "function" ? Params.callback : null;
    if(file && key)
    {
        var formData = new FormData();
        formData.append("file", file);

        var request = new XMLHttpRequest();
        request.open("POST", "/api/vas_cloud_upload_file/" + key);
        request.send(formData);

        var req_cl = function()
        {
            if(request.status != 200 && !callback)
            {
                webix.message({text:request.status + ": " + request.statusText,type:"error"});
            }

            if(callback && typeof callback === "function")
            {
                callback(request);
            }
        };

        request.onload = req_cl;

        request.onerror = req_cl;
    }
};

ServerManager.prototype.DownloadFileFromLocalUrl = function(Url, Index)
{
    var iframe = document.getElementById("hiddenDownloader" + Index ? Index : '');

    if (!iframe)
    {
        iframe = document.createElement('iframe');
        iframe.id = "hiddenDownloader";
        iframe.style.visibility = 'hidden';
        iframe.style.display = 'none';
        iframe.style.width = '0px;';
        iframe.style.height = '0px;';
        document.body.appendChild(iframe);
    }
    iframe.src = this.server + Url;
};

ServerManager.prototype.RedirectToFilesDownload = function(FileIds, Params = "")
{
    var _this = this;

    FileIds.forEach(function(FileId, Index)
    {
        _this.DownloadFileFromLocalUrl(`${_this.urls.file}/${FileId.link}${Params}`, Index)
    });
};
var UserPrefrerencesEnum =
{
    HardwareIdDefault:"HardwareIdDefault"
};

function SessionManager(Params)
{
    "use strict";

    this.mode = module ? module : "dpiui2";

    this.IsModeDpiui2 = this.mode == "dpiui2";

    this.SignalIsLoggedIn = new Rx.BehaviorSubject(false);

    this.currentLogin = "";

    this.RoleSections = {};

    this.RoleSectionsPrams = {};

    this.Roles = {};

    this.RoleId = 0;

    this.MyProfileUpdatedSignal = new Rx.BehaviorSubject(0);

    this.CurrentHardwareId = new Rx.BehaviorSubject(0);
    this.PrevHardwareId = 0;
    this.HardwareChanged = new Rx.BehaviorSubject(false);

    this.CurrentHardwareConnected = new Rx.BehaviorSubject(0);

    this.AppVersion = new Rx.BehaviorSubject(0);

    this.SetPreferenceSignal = new Rx.BehaviorSubject(0);

    this.SignalMessagesNew = new Rx.BehaviorSubject(0);
    this.UnreadedMessageCount = new Rx.BehaviorSubject(0);

    this.Init();

    return this;
}

SessionManager.prototype.Init = function(Params)
{
    this.SetBackendLang();
    this.RefreshAppVersion();
};

SessionManager.prototype.IsLoggedIn = function()
{
    return this.SignalIsLoggedIn.getValue();
};

SessionManager.prototype.CheckLoggedIn = function(Params)
{
    "use strict";
    var _this  = this;
    App.ServerManager.CheckLoggedIn({
        callback: function (R)
        {
            if (!R.success && R.error.msg)
            {
                _this.SignalIsLoggedIn.next(false);

                if(_this.currentLogin)
                {
                    _this.ResetProfile();
                    _this.currentLogin = "";
                    _this.SetUserRoleSections("");
                    _this.SetUserRoleSectionsParams({});
                    _this.SetUserRoleId(0);
                }
            }

            if (R.success)
            {

                _this.currentLogin = R.data.username;
                _this.SetUserRoleSections(R.data.sections);
                _this.SetUserRoleSectionsParams(R.data.params);
                _this.SetUserRoleId(R.data.role_id);

                _this.SignalIsLoggedIn.next(true);

                _this.RefreshProfile();

                if(_this.mode == "dpiui2")
                    _this.SetCurrentHardwareIdFromPreference();
            }

            if(Params && Params.callback)
            {
                Params.callback(_this.SignalIsLoggedIn.getValue());
            }
        }
    });
};

SessionManager.prototype.Login = function(Params)
{
    "use strict";
    var _this  = this;
    App.ServerManager.Login({
        username:Params&&Params.username ? Params.username : "",
        password:Params&&Params.password ? Params.password : "",
        remember:Params&&Params.remember ? true : false,
        callback: function (R)
        {
            if (R.success)
            {
                _this.currentLogin = R.data.username;
                _this.SetUserRoleSections(R.data.sections);
                _this.SetUserRoleSectionsParams(R.data.params);
                _this.SetUserRoleId(R.data.role_id);

                _this.SignalIsLoggedIn.next(true);

                if(Params && Params.callback)
                {
                    Params.callback(R);
                }

                _this.RefreshProfile();

                if(_this.mode == "dpiui2")
                    _this.SetCurrentHardwareIdFromPreference();
            }
            else if (Params && Params.callback)
            {
                Params.callback(R);
            }
        }
    });
};

SessionManager.prototype.Logout = function(Params)
{
    "use strict";
    var _this  = this;
    App.ServerManager.Logout({
        callback: function (R)
        {
            if (R.success)
            {
                _this.SignalIsLoggedIn.next(false);

                _this.ResetProfile();
                _this.currentLogin = "";
                _this.SetUserRoleSections("");
                _this.SetUserRoleSectionsParams({});
                _this.SetUserRoleId(0);
                App.WebSocketManager.Destroy();
            }

            if(Params && Params.callback)
            {
                Params.callback(_this.SignalIsLoggedIn.getValue());
            }
        }
    });
};

SessionManager.prototype.RefreshProfile = function()
{
    "use strict";

    var _this = this;

    var params = {
        method:"GetMyProfile",
        callback: function (R)
        {
            if (R.success&&R.data)
            {
                var data = Array.isArray(R.data)?R.data[0]:R.data;

                _this.currentLogin = data.username;

                _this.SetProfile(data);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

SessionManager.prototype.SaveMyProfile = function(Params)
{
    "use strict";

    var _this = this;

    var params =
        {
            data:{MyProfile:Params.data},
            method:"SaveMyProfile",
            callback:function (R)
            {
                if (R.success)
                {
                    _this.SetProfile(R.data);
                }

                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionManager.prototype.ChangeMyPassword = function(Params)
{
    "use strict";

    var _this = this;

    var params =
        {
            data:Params.data,
            method:"ChangeMyPassword",
            callback:function (R)
            {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionManager.prototype.GetProfile = function()
{
    "use strict";

    if(this.currentLogin)
    {
        return JSON.parse(localStorage.getItem("profile_"+this.currentLogin));
    }
    else
    {
        return null;
    }
};

SessionManager.prototype.SetProfile = function(Profile)
{
    "use strict";

    localStorage.setItem("profile_"+this.currentLogin, JSON.stringify(Profile));

    this.MyProfileUpdatedSignal.next(1);
};

SessionManager.prototype.ResetProfile = function()
{
    "use strict";
    if(this.currentLogin)
    {
        return localStorage.setItem("profile_"+this.currentLogin, null);
    }
};

SessionManager.prototype.SetPreference = function(Id,Value,Object)
{
    localStorage.setItem(this.currentLogin+"_"+Id, Object?JSON.stringify(Value):Value);
    this.SetPreferenceSignal.next(Id);
};

SessionManager.prototype.GetPreference = function(Id,Object)
{
    var item = localStorage.getItem(this.currentLogin+"_"+Id);

    return Object?JSON.parse(item):item;
};

SessionManager.prototype.RemovePreference = function(Id)
{
    localStorage.removeItem(this.currentLogin+"_"+Id);
};

SessionManager.prototype.GetCurrentHardwareId = function()
{
    if(this.mode == "dpiui2")
        return this.CurrentHardwareId.getValue();
    else
        return 1;
};

SessionManager.prototype.IsCurrentHardwareConnected = function()
{
    return this.CurrentHardwareConnected.getValue();
};

SessionManager.prototype.SetCurrentHardwareIdFromPreference = function()
{
    var _this = this;

    var hardwareIdPreference = this.GetPreference(UserPrefrerencesEnum.HardwareIdDefault);
    if(hardwareIdPreference)
    {
        this.PrevHardwareId = this.GetCurrentHardwareId();
        this.CurrentHardwareId.next(hardwareIdPreference);

        if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.logs))
            setTimeout(function(){_this.RefreshCurrentHardwareState();},1);
    }
};

SessionManager.prototype.SetCurrentHardwareId = function(Id)
{
    var _this = this;

    if(Id)
    {
        this.PrevHardwareId = this.GetCurrentHardwareId();
        this.SetPreference(UserPrefrerencesEnum.HardwareIdDefault,Id);
        this.CurrentHardwareId.next(Id);
        this.HardwareChanged.next(true);

        if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.logs))
            setTimeout(function(){_this.RefreshCurrentHardwareState();},1);
    }
};

SessionManager.prototype.CheckCurrentHardwareConnection = function()
{
    var _this  = this;

    var hardwareId = this.GetCurrentHardwareId();

    var params =
        {
            method:"TestConnectToHardware",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (R)
            {
                if(R.success)
                {
                    _this.CurrentHardwareConnected.next(1);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                    _this.CurrentHardwareConnected.next(0);
                }

            }
        };

    App.ServerManager.CallMethod(params);
};

SessionManager.prototype.RefreshCurrentHardwareState = function()
{
    App.HardwaresManager.RefreshFastdpiState();
};

SessionManager.prototype.RestartHardware = function(Params)
{
    var _this  = this;

    var hardwareId = this.GetCurrentHardwareId();

    var params =
        {
            method:"RestartHardware",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (R)
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("All", "Restart was successful"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionManager.prototype.ReloadHardware = function(Params)
{
    var _this  = this;

    var hardwareId = this.GetCurrentHardwareId();

    var params =
        {
            method:"ReloadHardware",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (R)
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("All", "Hot options updated"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionManager.prototype.RefreshAppVersion = function()
{
    var _this  = this;

    var hardwareId = this.GetCurrentHardwareId();

    var params =
        {
            method:"GetAppVersionWithLicenceLevel",
            callback:function (R)
            {
                if(R.success)
                {
                    _this.AppVersion.next(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionManager.prototype.SetBackendLang = function()
{
    var _this  = this;

    var params =
        {
            method:"SetCurrentLocalLang",
            data:{Lang:LocalesEnum[LangHelper.GetLocale()].locale},
            callback:function (R)
            {
                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionManager.prototype.SetUserRoleId = function(Role)
{
    this.RoleId = Role.id;
}

SessionManager.prototype.GetUserRoleId = function()
{
  return this.RoleId;
};

SessionManager.prototype.GetUserRoles = function()
{
    return this.Roles;
};

SessionManager.prototype.SetUserRoleSections = function(SectionsStr)
{
    var _this = this;

    var sectionsArr = SectionsStr.split(",");

    this.RoleSections = {};

    sectionsArr.forEach(function (Item)
    {
        var itemArr = Item.split(".");

        if(itemArr.length == 2)
        {
            if(!_this.RoleSections[itemArr[0]])
                _this.RoleSections[itemArr[0]] = {};

            _this.RoleSections[itemArr[0]][itemArr[1]] = 1;
        }

    });
};

SessionManager.prototype.GetUserRoleSections = function()
{
    return this.RoleSections;
};

SessionManager.prototype.SetUserRoleSectionsParams = function(SectionsParams)
{
    this.RoleSectionsPrams = SectionsParams;
};

SessionManager.prototype.GetUserRoleSectionsParams = function()
{
    return this.RoleSectionsPrams;
};

SessionManager.prototype.CheckUserRoleSection = function(Section, ForWrite)
{
    if(!Section)
        return false;

    var sections = App.SessionManager.GetUserRoleSections();

    if(Section.indexOf("ulr_") >=0 || Section == RoleSectionsEnum.ulr)
    {
        var appV = this.AppVersion.getValue();
        if(!(appV && appV.ulr_licence == "standard"))
        {
            return false;
        }
    }

    if(Section.indexOf("li_") >=0 || Section == RoleSectionsEnum.li)
    {
        var appV = this.AppVersion.getValue();
        if(!(appV && appV.li_licence == "standard"))
        {
            return false;
        }
    }

    if(Section.indexOf("sites_clsfr_") >=0 || Section == RoleSectionsEnum.sites_clsfr)
    {
        var appV = this.AppVersion.getValue();
        if(!(appV && appV.sites_clsfr_licence == "standard"))
        {
            return false;
        }
    }

    if(Section.indexOf("ddos_attack") >= 0)
    {
        if(AppEnv.DDoSAttack_isVisible !== 1)
        {
            return false;
        }
    }

    if(Section.indexOf("antiddos") >= 0)
    {
        if(AppEnv.AntiDDoS_isVisible !== 1)
        {
            return false;
        }
    }

    if(sections && sections[Section] && (ForWrite ? sections[Section].write : sections[Section].read))
        return true;

    return false;
};

SessionManager.prototype.CheckUserRoleSectionAll = function(Section)
{
    let res = this.CheckUserRoleSection(Section);

    if(res)
        res = this.CheckUserRoleSection(Section, true);

    return res;
};

SessionManager.prototype.CheckLic = function(Lic, Level)
{
    var appV = this.AppVersion.getValue();
    if(!(appV && appV[Lic+"_licence"] == Level))
    {
        return false;
    }

    return true;
};

SessionManager.prototype.GetUserRoleSectionParams = function(Section, SectionParam)
{
    var params = App.SessionManager.GetUserRoleSectionsParams();

    if(Section)
    {
        if(!params[Section])
            return null;

        params = params[Section];

        if(SectionParam)
        {
            if(!params[SectionParam])
                return null;

            params = params[SectionParam];
        }
    }

    return params;
};

SessionManager.prototype.GetHardwareLicenseInfo = function(Params)
{
    var _this = this;

    var hId = App.SessionManager.GetCurrentHardwareId();
    if(hId)
    {
        hId = parseInt(hId);
    }

    var params =
        {
            id: webix.uid(),
            method:"GetDpiLicenseLevel",
            data: {
                HardwareId: hId
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionManager.prototype.HasUlrLic = function()
{
    var hasUrlLic = false, appV = this.AppVersion.getValue();

    if(appV && appV.ulr_licence == "standard")
    {
        hasUrlLic = true;
    }

    return hasUrlLic;
};

SessionManager.prototype.HasLiLic = function()
{
    var hasLiLic = false, appV = this.AppVersion.getValue();

    if(appV && appV.li_licence == "standard")
    {
        hasLiLic = true;
    }

    return hasLiLic;
};

SessionManager.prototype.HasSitesClsfrLic = function()
{
    var hasSitesClsfrLic = false, appV = this.AppVersion.getValue();

    if(appV && appV.sites_clsfr_licence == "standard")
    {
        hasSitesClsfrLic = true;
    }

    return hasSitesClsfrLic;
};

SessionManager.prototype.IsRoleAdmin = function()
{
    return this.CheckUserRoleSection(RoleSectionsEnum.administrator);
};

/* global webix */
/* global App */

var UserModelActionsEnum = {
    update:"update",
    insert:"insert",
    delete:"delete"
}

function UserModel(Params)
{
    this.id = webix.uid();
    this.user_id = Params&&Params.user_id?Params.user_id:0;
    this.username = Params&&Params.username?Params.username:"";
    this.name = Params&&Params.name?Params.name:"";
    this.email = Params&&Params.email?Params.email:"";
    this.phone = Params&&Params.phone?Params.phone:"";
    this.company = Params&&Params.company?Params.company:"";
    this.position = Params&&Params.position?Params.position:"";
    this.role = Params&&Params.role?Params.role:"";

    this.action = Params&&Params.action&&UserModelActionsEnum[Params.action]?Params.action:UserModelActionsEnum.update;

    this.valid = true;
}

function UsersManager(Params)
{
    "use strict";

    this.Users = [];

    this.UsersUpdated = new Rx.BehaviorSubject(0);

    this.Init();

    return this;
}

UsersManager.prototype.Init = function(Params)
{
    "use strict";
};

UsersManager.prototype.Refresh = function(Params)
{
    "use strict";
    var _this = this;
    var params =
        {
            method:"GetUsers",
            callback:function (result) {
                if(result.success)
                {
                    var users = [];
                    result.data.forEach(function (ServerUserModel) {
                        var userModel = new UserModel(ServerUserModel);
                        users.push(userModel);
                        _this.Users = users;
                        _this.UsersUpdated.next(1);
                    });
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

UsersManager.prototype.GetUsers = function()
{
    return webix.copy(this.Users);
};

UsersManager.prototype.SetUsers = function(Data)
{
    return this.Users = webix.copy(Data);
};

UsersManager.prototype.SaveUsers = function(Params)
{
    "use strict";
    var _this = this;

    var requests = [];

    if(Params&&Params.data)
    {
        Params.data.forEach(function (User) {
            if(User)
            {
                var request = {};

                request.id = User.id;
                request.method = "SaveUser";
                request.data = {user:User};

                if(User.action === UserModelActionsEnum.delete)
                {
                    request.method = "DeleteUser";
                }

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
/* global webix */
/* global App */

var RoleModelActionsEnum = {
    update:"update",
    insert:"insert",
    delete:"delete"
};

var RoleSectionsEnum = {
    hardware:"hardware",
    hardware_ssh_keys:"hardware_ssh_keys",
    performance:"performance",
    config:"config",
    logs:"logs",
    subscribers:"subscribers",
    services:"services",
    tariffs:"tariffs",
    advc:"advc",
    qoeanalytics:"qoeanalytics",
    qoeanalytics_dashboard:"qoeanalytics_dashboard",
    qoeanalytics_fullnetflow:"qoeanalytics_fullnetflow",
    qoeanalytics_clickstream:"qoeanalytics_clickstream",
    qoeanalytics_gtp:"qoeanalytics_gtp",
    qoeanalytics_nat:"qoeanalytics_nat",
    qoeanalytics_dns:"qoeanalytics_dns",
    qoeanalytics_ddos_attack:"qoeanalytics_ddos_attack",
    qoeanalytics_subscribers:"qoeanalytics_subscribers",
    qoeanalytics_rawfullnetflow:"qoeanalytics_rawfullnetflow",
    qoeanalytics_rawclickstream:"qoeanalytics_rawclickstream",
    qoeanalytics_rawgtp:"qoeanalytics_rawgtp",
    qoeanalytics_rawnat:"qoeanalytics_rawnat",
    qoeanalytics_rawdns:"qoeanalytics_rawdns",
    qoeanalytics_raw_ddos_attack:"qoeanalytics_raw_ddos_attack",
    qoeanalytics_online_reports:"qoeanalytics_online_reports",
    qoeanalytics_triggers:"qoeanalytics_triggers",
    qoeanalytics_customreports:"qoeanalytics_customreports",
    qoeanalytics_admin:"qoeanalytics_admin",
    qoeanalytics_reports_manager:"qoeanalytics_reports_manager",
    qoeanalytics_mailing_templates:"qoeanalytics_mailing_templates",

    administrator:"administrator",
    administrator_users:"administrator_users",
    administrator_roles:"administrator_roles",
    administrator_send_error:"administrator_send_error",
    administrator_dpiui2:"administrator_dpiui2",
    administrator_users_actions_log:"administrator_users_actions_log",

    vascloud:"vascloud",
    depricated:"depricated",
    websocket: "socket",

    ulr: "ulr",
    ulr_web_rules: "ulr_web_rules",
    ulr_hosts_list: "ulr_hosts_list",
    ulr_white_rules: "ulr_white_rules",
    ulr_policings: "ulr_policings",
    ulr_custom_prtcls: "ulr_custom_prtcls",
    ulr_as_rules: "ulr_as_rules",
    ulr_excludes: "ulr_excludes",
    ulr_dics: "ulr_dics",
    ulr_mailing: "ulr_mailing",
    ulr_system_state: "ulr_system_state",
    ulr_isp_igw_profiles:"ulr_isp_igw_profiles",
    ulr_db_search:"ulr_db_search",
    ulr_record_pcap:"ulr_record_pcap",
    ulr_spoof_dns:"ulr_spoof_dns",

    li: "li",
    li_connections: "li_connections",
    li_t_capture: "li_t_capture",
    li_t_generation: "li_t_generation",
    li_t_blocking: "li_t_blocking",
    li_site_clone: "li_site_clone",
    li_n_audit: "li_n_audit",
    li_health: "li_health",
    li_traffic_decode: "li_traffic_decode",

    sites_clsfr:"sites_clsfr",
    sites_clsfr_model:"sites_clsfr_model",
    sites_clsfr_admin:"sites_clsfr_admin",

    sso_auth: "sso_auth",
    ssh_terminal: "ssh_terminal",

    pcrf: "pcrf",
    pcrf_config: "pcrf_config",
    pcrf_logs: "pcrf_logs",

    antiddos:"antiddos"
};

var RoleLicsEnum = {
    app:"app",
    ulr:"ulr",
    li:"li",

    sites_clsfr:"sites_clsfr",
    sites_clsfr_model:"sites_clsfr_model",
    sites_clsfr_admin:"sites_clsfr_admin",

    aniddos:"aniddos"
};

var RoleLicsValsEnum = {
    lite:"lite",
    standard:"standard"
};

function RoleModel(Params)
{
    this.id = webix.uid();
    this.role_id = Params&&Params.role_id?Params.role_id:0;
    this.role = Params&&Params.role?Params.role:"";
    this.sections = Params&&Params.sections?Params.sections:"";
    this.params = Params&&Params.params?Params.params:"";

    this.action = Params&&Params.action&&RoleModelActionsEnum[Params.action]?Params.action:RoleModelActionsEnum.update;

    this.valid = true;
}

function RolesManager(Params)
{
    "use strict";

    this.Roles = [];

    this.RolesUpdated = new Rx.BehaviorSubject(0);

    this.Init();

    return this;
}

RolesManager.prototype.Init = function(Params)
{
    "use strict";
};

RolesManager.prototype.Refresh = function(Params)
{
    "use strict";
    var _this = this;
    var params =
        {
            method:"GetRoles",
            callback:function (result) {
                if(result.success)
                {
                    var roles = [];
                    result.data.forEach(function (ServerRoleModel)
                    {
                        var userModel = new RoleModel(ServerRoleModel);
                        roles.push(userModel);
                        _this.Roles = roles;
                    });

                    _this.RolesUpdated.next(1);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

RolesManager.prototype.GetRoles = function()
{
    return webix.copy(this.Roles);
};

RolesManager.prototype.SetRoles = function(Data)
{
    return this.Roles = webix.copy(Data);
};

RolesManager.prototype.SaveRoles = function(Params)
{
    "use strict";
    var _this = this;

    var requests = [];

    if(Params&&Params.data)
    {
        Params.data.forEach(function (Role) {
            if(Role)
            {
                var request = {};

                request.id = Role.id;
                request.method = "SaveRole";
                request.data = {role:Role};

                if(Role.action === RoleModelActionsEnum.delete)
                {
                    request.method = "DeleteRole";
                }

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
/* global webix */
/* global App */

var HardwareModelActionsEnum = {
    update:"update",
    insert:"insert",
    delete:"delete"
};

var HardwareTypesEnum = {
    "dpi":"dpi",
    "dpiui2":"dpiui2",
    "wifi_web":"wifi_web",
    "qoestor":"qoestor",
    "balancer":"balancer",
    "tragen":"tragen",
    "wget":"wget",
    "nmap":"nmap",
    "clsfr":"clsfr",
    "catalog": "catalog",
    "wiki": "wiki",
    "pcap": "pcap"
};

var AuthTypesEnum = {
    "password":"password",
    "key":"key"
};


function HardwareModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
    this.name = Params&&Params.name?Params.name:'';
    this.ip = Params&&Params.ip?Params.ip:'';
    this.port = Params&&Params.port?Params.port:22;
    this.login = Params&&Params.login?Params.login:'';
    this.password = Params&&Params.password?Params.password:'';
    this.ssl_key = Params&&Params.ssl_key?Params.ssl_key:'';
    this.sudocheck = Params&&Params.sudocheck?Params.sudocheck:0;
    this.load_cs = Params&&Params.load_cs?Params.load_cs:0;
    this.port_cs = Params&&Params.port_cs?Params.port_cs:80;
    this.protocol_cs = Params&&Params.protocol_cs?Params.protocol_cs:'';
    this.ip_cs = Params&&Params.ip_cs?Params.ip_cs:'';
    this.status_cs = Params&&Params.status_cs?Params.status_cs:0;
    this.dot_env = Params&&Params.dot_env?Params.dot_env:'';
    this.tool_version = Params&&Params.tool_version?Params.tool_version:'';
    this.ipfix_id = Params&&Params.ipfix_id?Params.ipfix_id:0;
    this.hardware_type = Params&&Params.hardware_type?Params.hardware_type:HardwareTypesEnum.dpi;
    this.deleted = Params&&Params.deleted?Params.deleted:0;
    this.enable_subs_sync = Params&&Params.enable_subs_sync?Params.enable_subs_sync:0;
    this.enable_subs_auth_status_sync = Params&&Params.enable_subs_auth_status_sync?Params.enable_subs_auth_status_sync:0;
    this.enable_logs_sync = Params&&Params.enable_logs_sync?Params.enable_logs_sync:0;
    this.enable_cgnat_sync = Params&&Params.enable_cgnat_sync?Params.enable_cgnat_sync:0;

    this.action = Params&&Params.action&&HardwareModelActionsEnum[Params.action]?Params.action:HardwareModelActionsEnum.update;

    this.auth_type = Params&&Params.auth_type?Params.auth_type:AuthTypesEnum.password;
    this.ssh_key_id = Params&&Params.ssh_key_id?Params.ssh_key_id:null;
    this.copy_hardware_id = Params&&Params.copy_hardware_id?Params.copy_hardware_id:0;

    this.valid = true;
}

function HardwareDpiui2StateModel(Params)
{
    this.has_new_version = Params&&Params.has_new_version?Params.has_new_version:0;
    this.has_hardware = Params&&Params.has_hardware?Params.has_hardware:0;
    this.error = Params&&Params.error?Params.error:0;
}

function HardwareFastdpiStateModel(Params)
{
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;

    this.has_new_version = Params&&Params.has_new_version?Params.has_new_version:0;
    this.available_version = Params&&Params.available_version?Params.available_version:0;
    this.fastdpi_is_running = Params&&Params.fastdpi_is_running?Params.fastdpi_is_running:0;

    this.ssh_connected = Params&&Params.ssh_connected?Params.ssh_connected:0;

    this.error = Params&&Params.error?Params.error:0;
}

function HardwaresManager(Params)
{
    this.Hardwares = [];

    this.HardwaresUpdated = new Rx.BehaviorSubject(0);

    this.FastDpiStatusChanged = new Rx.BehaviorSubject("");
    this.ConnectedUseByAnotherSource = new Rx.BehaviorSubject(false);

    this.Signals = {
        Dpiui2NewVersionState: new Rx.BehaviorSubject(null),
        FastdpiStateUpdated: new Rx.BehaviorSubject(0),
        FastdpiState: {},
        HardwareStateSignal: new Rx.BehaviorSubject(0)
    };

    this.Subscriptions = {};

    this.HardwareState = new HardwareFullStateModel();

    this.Init();

    return this;
}

HardwaresManager.prototype.Init = function(Params)
{
    this.BindAll();
};

HardwaresManager.prototype.BindAll = function(Params)
{
    var _this = this;

    if(module == "dpiui2")
    {
        this.Subscriptions.HardwareConnected = Rx.Observable.combineLatest
        (
            App.SessionManager.HardwareChanged,
            App.DicsManager.Signal[DicsEnum.HardwaresDic]
        ).subscribe(function (Val)
        {
            if(Val[0] || Val[1])
                _this.RefreshDpiui2State();
        });
    }
};

HardwaresManager.prototype.Destroy = function ()
{
    var _this = this;

    this.Active = false;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

HardwaresManager.prototype.Refresh = function(Params)
{
    "use strict";
    var _this = this;
    var params =
        {
            method:"GetHardwares",
            data: {
                HardwareType: Params&&Params.hardware_type?Params.hardware_type:"all"
            },
            callback:function (result) {
                if(result.success)
                {
                    var users = [];
                    result.data.forEach(function (ServerHardwareModel) {
                        var userModel = new HardwareModel(ServerHardwareModel);
                        users.push(userModel);
                        _this.Hardwares = users;
                        _this.HardwaresUpdated.next(1);
                    });
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

HardwaresManager.prototype.GetHardwares = function()
{
    return webix.copy(this.Hardwares);
};

HardwaresManager.prototype.SetHardwares = function(Data)
{
    return this.Hardwares = webix.copy(Data);
};

HardwaresManager.prototype.SaveHardwares = function(Params)
{
    "use strict";
    var _this = this;

    var requests = [];

    if(Params&&Params.data)
    {
        Params.data.forEach(function (Hardware) {
            if(Hardware)
            {
                var request = {};

                request.id = Hardware.id;
                request.method = "SaveHardware";
                request.data = {hardware:Hardware};

                if(Hardware.action === HardwareModelActionsEnum.delete)
                {
                    request.method = "DeleteHardware";
                }

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

HardwaresManager.prototype.SaveHardware = function(HardwareModel, CallBack)
{
    var _this = this;

    var params =
        {
            method:"SaveHardware",
            data: {
                hardware: HardwareModel
            },
            callback:function (R)
            {
                if(CallBack && typeof CallBack === "function")
                {
                    CallBack(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

HardwaresManager.prototype.SyncHardwareToolVersion = function(HardwareModel, CallBack)
{
    var _this = this;

    var params =
        {
            method:"SyncHardwareToolVersion",
            data: {
                hardware: HardwareModel
            },
            callback:function (R)
            {
                if(CallBack && typeof CallBack === "function")
                {
                    CallBack(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

HardwaresManager.prototype.DeleteHardware = function(HardwareModel, CallBack)
{
    var _this = this;

    var params =
        {
            method:"DeleteHardware",
            data: {
                hardware: HardwareModel
            },
            callback:function (R)
            {
                if(CallBack && typeof CallBack === "function")
                {
                    CallBack(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

HardwaresManager.prototype.RefreshDpiui2State = function (Params)
{
    if(!App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.hardware))
        return;

    var _this = this;

    var state = new HardwareDpiui2StateModel();

    var params = {
        id: webix.uid(),
        method:"GetDpiui2State",
        callback:function (R)
        {
            var hasNewVer = false;
            var hasHardware = true;
            if(R.success)
            {
                state.has_hardware = 1;

                if(R.data)
                    state.has_new_version = 1;
            }
            else
            {
                if(R.error && R.error.code)
                {
                    if(R.error.code != '-403')
                    {
                        state.error = R.error.msg;
                    }

                }
            }

            _this.Signals.Dpiui2NewVersionState.next(state);
        }
    };
    App.ServerManager.CallMethod(params);
};

HardwaresManager.prototype.RefreshFastdpiState = function (Params)
{
    var _this = this;

    var hwId = parseInt(App.SessionManager.GetCurrentHardwareId(),10);

    if(!hwId)
        return;

    if(!App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.hardware))
        return;

    var state = new HardwareFastdpiStateModel();

    var params = {
        id: webix.uid(),
        method:"GetFastdpiState",
        data:{Id:hwId},
        callback:function (R)
        {
            if(R.success)
            {
                if(R.data)
                {
                    state = new HardwareFastdpiStateModel(R.data);
                }
            }
            else
            {
                if(R.error && R.error.code)
                    state.error = R.error.msg;
            }

            if(_this.Signals.FastdpiState[hwId])
                _this.Signals.FastdpiState[hwId].next(state);
            else
                _this.Signals.FastdpiState[hwId] = new Rx.BehaviorSubject(state);

            _this.Signals.FastdpiStateUpdated.next(hwId);

            if(hwId === parseInt(App.SessionManager.GetCurrentHardwareId(),10))
                App.SessionManager.CurrentHardwareConnected.next(state.ssh_connected);
        }
    };
    App.ServerManager.CallMethod(params);
};

HardwaresManager.prototype.GetCurrentFastdpiState = function()
{
    var hwId = parseInt(App.SessionManager.GetCurrentHardwareId(),10);

    var state = this.Signals.FastdpiState[hwId] ? this.Signals.FastdpiState[hwId].getValue() : null;

    return state;
};


var HardwareStateOptionsEnum = {
    Ssh: "ssh",
    ScpCommand: "scp_command",
    SendFile: "send_file",
    Internet: "internet"
};

function HardwareFullStateModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();

    for(var prop in HardwareStateOptionsEnum)
    {
        this[HardwareStateOptionsEnum[prop]] = new HardwareSingleStateModel(Params && Params[HardwareStateOptionsEnum[prop]] ? Params[HardwareStateOptionsEnum[prop]] : {});
    }

    this.valid = true;
}

function HardwareSingleStateModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();

    this.ok = parseInt( Params&&Params.ok?Params.ok:0);
    this.msg = Params&&Params.msg?Params.msg:"";
    this.loading = Params&&Params.loading?Params.loading:0;

    this.valid = true;
}

HardwaresManager.prototype.GetHardwareState = function()
{
    return webix.copy(this.HardwareState);
}

HardwaresManager.prototype.ClearHardwareState = function()
{
    this.HardwareState = new HardwareFullStateModel();
    this.Signals.HardwareStateSignal.next(0);
};

HardwaresManager.prototype.RefreshHardwareState = function(Params)
{
    "use strict";
    var _this = this;
    var hardwareId = Params && Params.hardware_id ? parseInt(Params.hardware_id) : null;
    var options = Params && Params.options ? Params.options : [];
    var callback = Params && Params.callback ? Params.callback : null;
    var params =
        {
            method:"CheckHardwareState",
            data: {
                Id: hardwareId,
                Options: options
            },
            callback:function (R) {
                if(R.success)
                {
                    Object.keys(R.data).forEach(function(Key){
                        var data = R.data[Key];
                        var state = new HardwareSingleStateModel();
                        if(data.success)
                        {
                            state.ok = parseInt(data.data.ok);
                            state.msg = data.data.msg;
                        }
                        else{
                            state.ok = 0;
                            state.msg = data.error.msg;
                        }

                        _this.HardwareState[Key] = state;
                    });

                    _this.Signals.HardwareStateSignal.next(1);
                }

                if(R.error && R.error.msg)
                    webix.message({text:R.error.msg,type:"error"});

                if(callback && typeof callback === "function")
                {
                    callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
function HardwareSshKeysModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();
    this.ssh_key_id = Params&&Params.ssh_key_id?Params.ssh_key_id:0;
    this.name = Params&&Params.name?Params.name:'';
    this.public_key = Params&&Params.public_key?Params.public_key:'';
    this.private_key = Params&&Params.private_key?Params.private_key:'';
    this.passphrase = Params&&Params.passphrase?Params.passphrase:'';

    this.valid = true;
}

function HardwareSshKeysManager(Params)
{
    this.Signals = {};

    this.Subscriptions = {};

    this.Active = true;
}

HardwareSshKeysManager.prototype.Destroy = function ()
{
    var _this = this;

    this.Active = false;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

HardwareSshKeysManager.prototype.SaveHardwareSshKey = function(HardwareSshKeyModel, CallBack)
{
    var _this = this;

    var params =
        {
            method:"SaveHardwareSshKey",
            data: {
                hardware_ssh_key: HardwareSshKeyModel
            },
            callback:function (R)
            {
                if(CallBack && typeof CallBack === "function")
                {
                    CallBack(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

HardwareSshKeysManager.prototype.GenerateHardwareSshKey = function(Params, CallBack)
{
    var _this = this;

    var params =
        {
            method:"GenerateHardwareSshKey",
            data: {
                Filename: Params.name,
                Algorithm: Params.algorithm,
                Format: Params.format_key,
                Passphrase: Params.passphrase
            },
            callback:function (R)
            {
                if(CallBack && typeof CallBack === "function")
                {
                    CallBack(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

HardwareSshKeysManager.prototype.DeleteHardwareSshKey = function(HardwareSshKeyModel, CallBack)
{
    var _this = this;

    var params =
        {
            method:"DeleteHardwareSshKey",
            data: {
                hardware_ssh_key: HardwareSshKeyModel
            },
            callback:function (R)
            {
                if(CallBack && typeof CallBack === "function")
                {
                    CallBack(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

HardwareSshKeysManager.prototype.DownloadSshKeyFile = function (IdOrFilename)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"DownloadSshKeyFile",
            data:{
                IdOrFilename: String(IdOrFilename)
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    App.ServerManager.RedirectToFileDownload(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};
/* global webix */
/* global App */

function HardwareConfigModel(Params)
{
    var _this = this;

    HardwareConfigManager.GetSortedDpiConfigDicKeysArr().forEach(function(Key)
    {
        var id = DpiConfigDic[Key].id;

        var defaultVal = DpiConfigDic[Key].default?DpiConfigDic[Key].default:"";

        _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):defaultVal);
    });

    // Add params to model, wich not in dic
    Object.keys(Params).forEach(function(Key)
    {
        if(!_this[Key])
        {
            var id = Key;
            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
        }
    });
}

function HardwareConfigHistoryModel(Params)
{
    this.id = webix.uid();
    this.file_id = Params&&Params.file_id?Params.file_id:"";
    this.date = null;
    this.file_name = null;

    if(this.file_id)
    {
        var fileIdArr = this.file_id.split(".");
        var dateArr = fileIdArr.slice(0,5);

        var parser = webix.Date.strToDate("%Y.%m.%d.%H.%i.%s");
        this.date = parser(dateArr.join("."));

        this.file_name = fileIdArr[fileIdArr.length - 2] + "." + fileIdArr[fileIdArr.length - 1];
    }
}

function HardwareConfigManager(Params)
{
    this.Active = true;

    this.mode = module ? module : "dpiui2";

    this.Init();

    this.ConfigFile = {};

    this.ConfigModel = {};

    this.SignalConfigFileUpdated = new Rx.BehaviorSubject(0);

    this.History = {};

    this.SignalConfigHistoryUpdated = new Rx.BehaviorSubject(0);

    return this;
}

HardwareConfigManager.prototype.Init = function(Params)
{
    "use strict";
};

HardwareConfigManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

HardwareConfigManager.prototype.Refresh = function(Params,HardwareId)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var params =
        {
            method:"GetDpiConfig",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (result)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(result.success)
                {
                    _this.ConfigFile[hardwareId] = result.data;
                }
                else
                {
                    _this.ConfigFile[_this.GetCurrentHardwareId()] = "";
                }

                _this.ParseConfigToModel();
                _this.ParseModelToConfig();

                _this.SignalConfigFileUpdated.next(1);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareConfigManager.prototype.Save = function(Params,HardwareId)
{
    "use strict";

    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var params =
        {
            method:"SetDpiConfig",
            data:{
                Id:parseInt(hardwareId,10),
                Config:Params&&Params.configContents?Params.configContents:_this.GetConfig(hardwareId)
            },
            callback:function (result)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

HardwareConfigManager.prototype.Validate = function(Params,HardwareId)
{
    "use strict";

    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var params =
        {
            method:"ValidateDpiConfig",
            data:{
                Id:parseInt(hardwareId,10),
                Config:Params&&Params.configContents?Params.configContents:_this.GetConfig(hardwareId)
            },
            callback:function (result)
            {
                if(result.success && result.data)
                {
                    if(result.data.indexOf("ERROR") >= 0)
                    {
                        result.success = false;
                        result.error.msg = result.data;
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("All", "Verified"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

HardwareConfigManager.prototype.SetConfig = function(ConfigFile, HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    this.ConfigFile[hardwareId] = ConfigFile;

    this.ParseConfigToModel();

    this.SignalConfigFileUpdated.next(1);
};

HardwareConfigManager.prototype.GetConfig = function(HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    if(this.ConfigFile[hardwareId])
    {
        return this.ConfigFile[hardwareId];
    }

    return "";
};

HardwareConfigManager.prototype.SetConfigModel = function(ConfigModel, HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    if(this.ConfigModel[hardwareId])
    {
        this.ConfigModel[hardwareId] = webix.extend(this.ConfigModel[hardwareId], new HardwareConfigModel(ConfigModel), true);
    }
    else
    {
        this.ConfigModel[hardwareId] = new HardwareConfigModel(ConfigModel);
    }

    this.ParseModelToConfig();

    this.SignalConfigFileUpdated.next(1);
};

HardwareConfigManager.prototype.SetConfigParameterModel = function(ParameterKey, ParameterValue, HardwareId, Silent)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    if(!this.ConfigModel[hardwareId])
    {
        this.ConfigModel[hardwareId] = new HardwareConfigModel({});
    }

    this.ConfigModel[hardwareId][ParameterKey] = ParameterValue;
    this.ConfigModel[hardwareId] = webix.extend(this.ConfigModel[hardwareId], new HardwareConfigModel(this.ConfigModel[hardwareId]), true);

    this.ParseModelToConfig();

    this.SignalConfigFileUpdated.next(1);
};

HardwareConfigManager.prototype.GetConfigModel = function(HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    if(this.ConfigModel[hardwareId])
    {
        return this.ConfigModel[hardwareId];
    }

    return new HardwareConfigModel();
};

HardwareConfigManager.prototype.ParseConfigToModel = function(HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var config = this.GetConfig(hardwareId);

    var parser = new ConfigIniParser();
    parser.parse(config);

    this.ConfigModel[hardwareId] = new HardwareConfigModel(parser.itemsKeyVal());
};

HardwareConfigManager.prototype.ParseModelToConfig = function(HardwareId, ShowComments, ShowAllParams)
{
    var _this = this;

    var showComments = webix.storage.local.get("HardwareConfigManager:ShowComments") ? true : false;

    var showAllParams = webix.storage.local.get("HardwareConfigManager:ShowAllParams") ? true : false;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var configModel = this.GetConfigModel(hardwareId);
    var parser = new ConfigIniParser();

    var currentGroupId = 0;

    var processedIds = {};

    HardwareConfigManager.GetSortedDpiConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = DpiConfigDic[Key].group;
        var id = DpiConfigDic[Key].id;
        var comment = DpiConfigDic[Key].value;
        var tooltip = DpiConfigDic[Key].tooltip?DpiConfigDic[Key].tooltip:"";

        if(groupId !== currentGroupId)
        {
            currentGroupId = groupId;

            if(showComments && (configModel[id].length !== 0 || showAllParams))
            {
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, DpiConfigGroupDic[currentGroupId].value);
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, " ");
            }

        }

        if(showComments && (configModel[id].length !== 0 || showAllParams))
            parser.set("", webix.uid(), null, comment);

        if(tooltip&&tooltip!==comment)
        {
            if(showComments && (configModel[id].length !== 0 || showAllParams))
                parser.set("", webix.uid(), null, tooltip);
        }

        if(configModel[id].length !== 0)
        {
            parser.set("", id, configModel[id]);
            parser.set("", webix.uid(), null, " ");
        }
        else
        {
            if(showAllParams)
            {
                parser.set("", webix.uid(), null, id+"="+configModel[id]);
                parser.set("", webix.uid(), null, " ");
            }
        }

        processedIds[id] = id;
    });

    // Add params to config, wich not in dic
    if(Object.keys(processedIds).length != Object.keys(configModel).length)
    {
        if(showComments)
        {
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, LangHelper.GetString("Dics", "Unknown parameters"));
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, " ");
        }

        Object.keys(configModel).forEach(function(Key)
        {
            if(!processedIds[Key])
            {
                var id = Key;

                if(configModel[id].length !== 0)
                {
                    parser.set("", id, configModel[id]);
                }
                else
                {
                    parser.set("", webix.uid(), null, id+"="+configModel[id]);
                }

                parser.set("", webix.uid(), null, " ");
            }
        });
    }

    this.ConfigFile[hardwareId] = parser.stringify();
};

HardwareConfigManager.prototype.HistoryRefresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"GetDpiConfigHistory",
            data:{Id:parseInt(_this.GetCurrentHardwareId(),10)},
            callback:function (result)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(result.success && result.data)
                {
                    var data = [];

                    Object.keys(result.data).forEach(function (Key)
                    {
                        var obj = new HardwareConfigHistoryModel({file_id:result.data[Key]});

                        data.push(obj);
                    });

                    _this.History[_this.GetCurrentHardwareId()] = data;
                    _this.SignalConfigHistoryUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("All", "History loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareConfigManager.prototype.GetHistory = function(HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    if(this.History[hardwareId])
    {
        return this.History[hardwareId];
    }

    return [];
};

HardwareConfigManager.prototype.LoadHistoryFile = function(Params, HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var params =
        {
            method:"GetDpiConfigFile",
            data:{
                Id:parseInt(hardwareId,10),
                File:Params&&Params.configFile?Params.configFile:""
            },
            callback:function (result)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

HardwareConfigManager.prototype.GetCurrentHardwareId = function (HardwareId)
{
   return HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();
};

HardwareConfigManager.GetSortedDpiConfigDicKeysArr = function()
{
    var groupsArr = HardwareConfigManager.GetSortedDpiConfigGroupDicKeysArr();

    var arr = [];

    groupsArr.forEach(function (V)
    {
        Object.keys(DpiConfigDic).forEach(function (K)
        {
            if(DpiConfigDic[K].group == V)
            {
                arr.push(K);
            }
        });
    });

    return arr;
};

HardwareConfigManager.GetSortedDpiConfigGroupDicKeysArr = function()
{
    var arr = [];

    HardwareConfigManager.GetSortedDpiConfigGroupDicArr().forEach(function (V)
    {
        arr.push(V.id)
    });

    return arr;
};

HardwareConfigManager.GetSortedDpiConfigGroupDicArr = function()
{
    var groupsArr = Helper.DictToArr(DpiConfigGroupDic);

    groupsArr.sort(function(a, b) {
        return a.order - b.order;
    });

    return groupsArr;
};
/* global webix */
/* global App */
var ChartSettingUnitsDic = {
    "1":{"id":"1", "value":LangHelper.GetString("All", "Mbit/s")},
    "2":{"id":"2", "value":LangHelper.GetString("DpiPerformance", "Bytes")},
    "3":{"id":"3", "value":LangHelper.GetString("DpiPerformance", "Packets")}
};

var ChartSettingsUnitsDividersDic = {
    "1":"1000",
    "2":"1024",
    "3":"1000"
};

var ChartSettingsUnitsFactorDic = {
    "1":"1000000",
    "2":"1",
    "3":"1"
};

var ChartSettingsUnitsDictionariesDic = {
    "1":TrafficSpeedBitUnits,
    "2":FileSizeUnits,
    "3":PacketsUnits
};

var ChartSettingsUnitsSuffixesDic = {
    "1":"mbit_sec",
    "2":"bytes",
    "3":"pkts"
}

function HardwareResourcesUsageTickModel(Params)
{
    this.cpus_count = Params&&Params.cpus_count?Params.cpus_count:null;
    this.cpus_usage = Params&&Params.cpus_usage?Params.cpus_usage:null;
    this.cpus_cores_usage = Params&&Params.cpus_cores_usage?Params.cpus_cores_usage:null;
    this.mem_usage = Params&&Params.mem_usage?Params.mem_usage:null;
    this.swap_usage = Params&&Params.swap_usage?Params.swap_usage:null;
    this.top_processes = Params&&Params.top_processes?Params.top_processes:null;

    var __this = this;

    Object.keys(this).forEach(function (Key)
    {
        if(__this[Key] && __this[Key].date && __this[Key].timezone != undefined)
        {
            __this[Key].date = Helper.DateTimeToLocal(__this[Key].date, parseInt(__this[Key].timezone/60, 10));
        }
    });
}

function HardwareResourcesFastdpiUsageTickModel(Params)
{
    this.cpus_count = Params&&Params.cpus_count?Params.cpus_count:0;
    this.cpus_usage = Params&&Params.cpus_usage?Params.cpus_usage:0;
    this.mem_usage = Params&&Params.mem_usage?Params.mem_usage:0;
}

function HardwareResourcesStatsUsageTickModel(Params)
{
    this.cpus_usage = Params&&Params.cpus_usage?Params.cpus_usage:null;
    this.mem_usage = Params&&Params.mem_usage?Params.mem_usage:null;
    this.dnas_usage = Params&&Params.dnas_usage?Params.dnas_usage:null;
    this.http_usage = Params&&Params.http_usage?Params.http_usage:null;
}

function DpiDnaUsageTickModel(Params)
{
    this.date = Params&&Params.date?Params.date:null;
    this.index = Params&&Params.index?Params.index:0;
    this.act_rcvd_pkts = Params&&Params.act_rcvd_pkts?Params.act_rcvd_pkts:0;
    this.act_send_pkts = Params&&Params.act_send_pkts?Params.act_send_pkts:0;
    this.act_drop_pkts = Params&&Params.act_drop_pkts?Params.act_drop_pkts:0;
    this.act_esnd_pkts_err = Params&&Params.act_esnd_pkts_err?Params.act_esnd_pkts_err:0;
    this.act_rcvd_mbit_sec = Params&&Params.act_rcvd_mbit_sec?Params.act_rcvd_mbit_sec:0;
    this.act_send_mbit_sec = Params&&Params.act_send_mbit_sec?Params.act_send_mbit_sec:0;
    this.act_rcvd_bytes = Params&&Params.act_rcvd_bytes?Params.act_rcvd_bytes:0;
    this.act_send_bytes = Params&&Params.act_send_bytes?Params.act_send_bytes:0;
    this.act_drop_bytes = Params&&Params.act_drop_bytes?Params.act_drop_bytes:0;

    for(var i = 0; i <= 7; i++)
    {
        this["dscp_cs"+i+"_act_rcvd_mbit_sec"] = Params&&Params["dscp_cs"+i+"_act_rcvd_mbit_sec"]?Params["dscp_cs"+i+"_act_rcvd_mbit_sec"]:0;
        this["dscp_cs"+i+"_act_send_mbit_sec"] = Params&&Params["dscp_cs"+i+"_act_send_mbit_sec"]?Params["dscp_cs"+i+"_act_send_mbit_sec"]:0;

        this["dscp_cs"+i+"_act_rcvd_bytes"] = Params&&Params["dscp_cs"+i+"_act_rcvd_bytes"]?Params["dscp_cs"+i+"_act_rcvd_bytes"]:0;
        this["dscp_cs"+i+"_act_send_bytes"] = Params&&Params["dscp_cs"+i+"_act_send_bytes"]?Params["dscp_cs"+i+"_act_send_bytes"]:0;
        this["dscp_cs"+i+"_act_drop_bytes"] = Params&&Params["dscp_cs"+i+"_act_drop_bytes"]?Params["dscp_cs"+i+"_act_drop_bytes"]:0;

        this["dscp_cs"+i+"_act_rcvd_pkts"] = Params&&Params["dscp_cs"+i+"_act_rcvd_pkts"]?Params["dscp_cs"+i+"_act_rcvd_pkts"]:0;
        this["dscp_cs"+i+"_act_send_pkts"] = Params&&Params["dscp_cs"+i+"_act_send_pkts"]?Params["dscp_cs"+i+"_act_send_pkts"]:0;
        this["dscp_cs"+i+"_act_drop_pkts"] = Params&&Params["dscp_cs"+i+"_act_drop_pkts"]?Params["dscp_cs"+i+"_act_drop_pkts"]:0;
    }
}

function DpiHttpUsageTickModel(Params)
{
    this.date = Params&&Params.date?Params.date:null;
    this.index = Params&&Params.index?Params.index:0;

    this.url = Params&&Params.url?Params.url:0;
    this.url_lock = Params&&Params.url_lock?Params.url_lock:0;
    this.act_url = Params&&Params.act_url?Params.act_url:0;
    this.act_url_lock = Params&&Params.act_url_lock?Params.act_url_lock:0;

    this.ssl = Params&&Params.ssl?Params.ssl:0;
    this.ssl_lock = Params&&Params.ssl_lock?Params.ssl_lock:0;
    this.act_ssl = Params&&Params.act_ssl?Params.act_ssl:0;
    this.act_ssl_lock = Params&&Params.act_ssl_lock?Params.act_ssl_lock:0;

    this.cna = Params&&Params.cna?Params.cna:0;
    this.cna_lock = Params&&Params.cna_lock?Params.cna_lock:0;
    this.act_cna = Params&&Params.act_cna?Params.act_cna:0;
    this.act_cna_lock = Params&&Params.act_cna_lock?Params.act_cna_lock:0;

    this.sni = Params&&Params.sni?Params.sni:0;
    this.sni_lock = Params&&Params.sni_lock?Params.sni_lock:0;
    this.act_sni = Params&&Params.act_sni?Params.act_sni:0;
    this.act_sni_lock = Params&&Params.act_sni_lock?Params.act_sni_lock:0;

    this.ccheck = Params&&Params.ccheck?Params.ccheck:0;
    this.ccheck_lock = Params&&Params.ccheck_lock?Params.ccheck_lock:0;
    this.act_ccheck = Params&&Params.act_ccheck?Params.act_ccheck:0;
    this.act_ccheck_lock = Params&&Params.act_ccheck_lock?Params.act_ccheck_lock:0;

    this.quic = Params&&Params.quic?Params.quic:0;
    this.quic_lock = Params&&Params.quic_lock?Params.quic_lock:0;
    this.act_quic = Params&&Params.act_quic?Params.act_quic:0;
    this.act_quic_lock = Params&&Params.act_quic_lock?Params.act_quic_lock:0;
}

function FullNatPerformanceModel(Params)
{
    this.profile_id = Params&&Params.profile_id?Params.profile_id:null;
    this.proto = Params&&Params.proto?Params.proto:null;
    this.nthr = Params&&Params.nthr?Params.nthr:null;
    this.ip_mask = Params&&Params.ip_mask?Params.ip_mask:null;
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
    this.title = Params&&Params.title?Params.title:'';
    this.nat_type = Params&&Params.nat_type?Params.nat_type:0;
    this.total = Params&&Params.total?Params.total:0;
    this.used = Params&&Params.used?Params.used:0;
    this.load = Params&&Params.load?Params.load:0;
}

function AddressNatPerformanceModel(Params)
{
    this.profile_id = Params&&Params.profile_id?Params.profile_id:null;
    this.proto = Params&&Params.proto?Params.proto:CgNatStatusProtoEnum.TCP;
    this.nthr = Params&&Params.nthr?Params.nthr:0;
    this.ip_mask = Params&&Params.ip_mask?Params.ip_mask:CgNatStatusMaskEnum[0];
    this.whip = Params&&Params.whip?Params.whip:'';
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
    this.title = Params&&Params.title?Params.title:'';
    this.total = Params&&Params.total?Params.total:0;
    this.used = Params&&Params.used?Params.used:0;
    this.load = Params&&Params.load?Params.load:0;
}

function AddressNatPerformanceFilterModel(Params)
{
    this.paging = Params&&Params.paging?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.total?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.filter?Params.filter:{};
    this.sort = Params&&Params.sort?Params.sort:{order_by:"load", order_dir:"desc"};
};

function HardwarePerformanceManager(Params)
{
    "use strict";

    this.mode = module ? module : "dpiui2";

    this.Active = true;

    this.CapturePeriodInSec = 1;
    this.MaxTiksCapture = 60;
    this.CaptureTimer = null;

    this.ResourcesUsageTicks = {};
    this.SignalResourcesUsageTicksUpdated = new Rx.BehaviorSubject(0);

    this.StatCapturePeriodInSec = 60;
    this.StatCaptureTimer = null;
    this.StatUpdatePeriodInSec = 30;
    this.StatUpdateTimer = null;

    this.ResourcesStatsUsageTicks = {};
    this.SignalResourcesStatsUsageTicksUpdated = new Rx.BehaviorSubject(0);

    this.FullNatPerformance =[];
    this.SignalFullNatPerformanceUpdated = new Rx.BehaviorSubject(0);

    this.PoolNatPerformance =[];
    this.SingalPoolNatPerformanceUpdated = new Rx.BehaviorSubject(0);

    this.NatAddressPerformance = [];
    this.NatAddressPerformanceFilter = new AddressNatPerformanceFilterModel();
    this.SignalNatAddressPerformanceUpdated = new Rx.BehaviorSubject();

    this.ConfigInfo = {};
    this.SignalConfigInfoUpdated = new Rx.BehaviorSubject(0);

    this.HardwareDevicesStats = [];
    this.SignalHardwareDevicesStatsUpdated = new Rx.BehaviorSubject(0);

    this.Init();

    return this;
}

HardwarePerformanceManager.prototype.Init = function(Params)
{
    "use strict";
};

HardwarePerformanceManager.prototype.Refresh = function(Params,HardwareId)
{
    "use strict";

    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    clearTimeout(_this.CaptureTimer);
    clearTimeout(_this.StatUpdateTimer);

    if(!_this.ResourcesUsageTicks[hardwareId])
    {
        _this.ResourcesUsageTicks[hardwareId] = [];
    }

    var params =
        {
            method:"GetDpiResourcesUsageTick",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    if(!_this.ResourcesUsageTicks[hardwareId])
                    {
                        _this.ResourcesUsageTicks[hardwareId] = [];
                    }

                    _this.ResourcesUsageTicks[hardwareId].push(new HardwareResourcesUsageTickModel(R.data));

                    if(_this.ResourcesUsageTicks[hardwareId].length > _this.MaxTiksCapture)
                    {
                        _this.ResourcesUsageTicks[hardwareId].slice(0, _this.ResourcesUsageTicks[hardwareId].length - _this.MaxTiksCapture);
                    }

                    _this.SignalResourcesUsageTicksUpdated.next(1);

                    if(_this.CapturePeriodInSec)
                    {
                        _this.CaptureTimer = setTimeout(function ()
                        {
                            _this.Refresh();
                            _this.RefreshDevicesStats();
                        },_this.CapturePeriodInSec*1000)
                    }
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        }

        if(this.Active)
        {
            App.ServerManager.CallMethod(params);
        }
};

HardwarePerformanceManager.prototype.RefreshStats = function(Params,HardwareId)
{
    "use strict";

    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    clearTimeout(_this.StatCaptureTimer);

    var params =
        {
            method:"GetDpiResourcesStatsUsageForPeriod",
            data:{Id:parseInt(hardwareId,10), Period:Params&&Params.period?Params.period:null, PeriodType:Params&&Params.periodType?Params.periodType:null},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.ResourcesStatsUsageTicks[hardwareId] = {};

                    if(R.data)
                    {
                        Object.keys(R.data).forEach(function(Key)
                        {
                            _this.ResourcesStatsUsageTicks[hardwareId][Key] = new HardwareResourcesStatsUsageTickModel(R.data[Key]);
                        });
                    }

                    _this.SignalResourcesStatsUsageTicksUpdated.next(1);

                    if(_this.StatCapturePeriodInSec)
                    {
                        _this.StatUpdateTimer = setTimeout(function ()
                        {
                            _this.ProcessDpiStatLog();
                        },_this.StatUpdatePeriodInSec*1000);

                        _this.StatCaptureTimer = setTimeout(function ()
                        {
                            _this.RefreshStats({period:Params&&Params.period?Params.period:null, periodType:Params&&Params.periodType?Params.periodType:null});
                        },_this.StatCapturePeriodInSec*1000)
                    }
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwarePerformanceManager.prototype.GetDevicesStats = function(HardwareId)
{
    "use strict";
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    return this.HardwareDevicesStats[hardwareId];
};

HardwarePerformanceManager.prototype.RefreshDevicesStats = function(HardwareId)
{
    "use strict";

    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var params =
        {
            method:"GetDpiDevicesStatus",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    if(!_this.HardwareDevicesStats[hardwareId])
                    {
                        _this.HardwareDevicesStats[hardwareId] = [];
                    }

                    _this.HardwareDevicesStats[hardwareId] = R.data;

                }
                else
                {
                    _this.HardwareDevicesStats[hardwareId] = [];
                    webix.message({type:"error", text:R.error.msg});

                }

                _this.SignalHardwareDevicesStatsUpdated.next(1);

            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwarePerformanceManager.prototype.ProcessDpiStatLog = function(Params,HardwareId)
{
    "use strict";

    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    if(!_this.ResourcesUsageTicks[hardwareId])
    {
        _this.ResourcesUsageTicks[hardwareId] = [];
    }

    var params =
        {
            method:"ProcessDpiStatLog",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (R)
            {
                //debugger;
            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwarePerformanceManager.prototype.Destroy = function ()
{
    this.Active = false;

    this.CapturePeriodInSec = 0;
    clearTimeout(this.CaptureTimer);

    this.StatCapturePeriodInSec = 0;
    clearTimeout(this.StatCaptureTimer);
    clearTimeout(this.StatUpdateTimer);
};

HardwarePerformanceManager.prototype.Reset = function ()
{
    clearTimeout(this.CaptureTimer);
    clearTimeout(this.StatCaptureTimer);
    clearTimeout(this.StatUpdateTimer);

    this.ResourcesUsageTicks = {};
    this.SignalResourcesUsageTicksUpdated.next(0);

    this.ResourcesStatsUsageTicks = {};
    this.SignalResourcesStatsUsageTicksUpdated.next(0);
};

HardwarePerformanceManager.prototype.GetLastTick = function(Params,HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    if(this.ResourcesUsageTicks[hardwareId] && this.ResourcesUsageTicks[hardwareId].length)
    {
        return this.ResourcesUsageTicks[hardwareId][this.ResourcesUsageTicks[hardwareId].length - 1];
    }

    return null;
};

HardwarePerformanceManager.prototype.GetFastdpiPorocessUsageTick = function(Tick)
{
    if(Tick)
    {
        var obj = {};

        obj.cpus_count = Tick.cpus_count;

        Object.keys(Tick.top_processes).every(function (Key)
        {
            var process = Tick.top_processes[Key];

            if(process.command.indexOf("fastdpi") >= 0)
            {
                obj.cpus_usage = (process.cpu / obj.cpus_count).toFixed(1);
                obj.mem_usage = process.mem;
                return false;
            }

            return true;
        });

        return new HardwareResourcesFastdpiUsageTickModel(obj);
    }

    return null;
};

HardwarePerformanceManager.prototype.GetFastdpiPorocessUsageLastTick = function(Params,HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var lastTick = this.GetLastTick(null,hardwareId);

    if(lastTick)
    {
        return this.GetFastdpiPorocessUsageTick(lastTick);
    }

    return null;
};

HardwarePerformanceManager.prototype.GetCpusTicks = function(Params,HardwareId)
{
    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var ticks = [];

    if(this.ResourcesUsageTicks[hardwareId] && this.ResourcesUsageTicks[hardwareId].length)
    {
        this.ResourcesUsageTicks[hardwareId].forEach(function (Tick, Index)
        {
            var tick = Tick.cpus_usage;
            tick.fastdpi = _this.GetFastdpiPorocessUsageTick(Tick);
            tick.index = Index;
            ticks.push(tick);
        });
    }

    return ticks;
};

HardwarePerformanceManager.prototype.GetCpusCoresTicks = function(Params,HardwareId)
{
    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var ticks = [];

    if(this.ResourcesUsageTicks[hardwareId] && this.ResourcesUsageTicks[hardwareId].length)
    {
        this.ResourcesUsageTicks[hardwareId].forEach(function (Tick, Index)
        {
            var tick = {};

            Object.keys(Tick.cpus_cores_usage).forEach(function (Key)
            {
                tick[Key] = {
                    all:Math.round((100-Tick.cpus_cores_usage[Key].idle)*100)/100,
                    fastdpi:Tick.cpus_cores_usage[Key].fastdpi
                };
            });

            tick.index = Index;
            tick.date = Tick.cpus_cores_usage.date;

            ticks.push(tick);
        });
    }

    return ticks;
};

HardwarePerformanceManager.prototype.GetStatCpusTicks = function(Params,HardwareId)
{
    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var ticks = [];

    var ticksDates = this.ResourcesStatsUsageTicks[hardwareId] ? Object.keys(this.ResourcesStatsUsageTicks[hardwareId]) : null;

    if(ticksDates && ticksDates.length)
    {
        ticksDates.forEach(function (TickDate, Index)
        {
            if(_this.ResourcesStatsUsageTicks[hardwareId][TickDate].cpus_usage)
            {
                var tick = _this.ResourcesStatsUsageTicks[hardwareId][TickDate].cpus_usage;
                tick.index = Index;
                ticks.push(tick);
            }
        });
    }

    return ticks;
};

HardwarePerformanceManager.prototype.GetStatCpusCoresTicks = function(Params,HardwareId)
{
    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var ticks = [];

    var ticksDates = this.ResourcesStatsUsageTicks[hardwareId] ? Object.keys(this.ResourcesStatsUsageTicks[hardwareId]) : null;

    if(ticksDates && ticksDates.length)
    {
        ticksDates.forEach(function (TickDate, Index)
        {
            if(_this.ResourcesStatsUsageTicks[hardwareId][TickDate].cpus_usage)
            {
                var tick = _this.ResourcesStatsUsageTicks[hardwareId][TickDate].cpus_usage;

                var tick_prepared = {};

                Object.keys(tick).forEach(function (Key)
                {
                    tick_prepared[Key] = {
                        all:Math.round((100-tick[Key].idle)*100)/100
                    };
                });

                tick_prepared.index = Index;
                tick_prepared.date = tick.cpu.date;
                ticks.push(tick_prepared);
            }
        });
    }

    return ticks;
};

HardwarePerformanceManager.prototype.GetMemTicks = function(Params,HardwareId)
{
    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var ticks = [];

    if(this.ResourcesUsageTicks[hardwareId] && this.ResourcesUsageTicks[hardwareId].length)
    {
        this.ResourcesUsageTicks[hardwareId].forEach(function (Tick, Index)
        {
            var date = Tick.mem_usage.date;
            var mem_used = Math.round(Tick.mem_usage.used / Tick.mem_usage.total * 1000) / 10;
            var mem_free = Math.round(Tick.mem_usage.free / Tick.mem_usage.total * 1000) / 10;

            var swap_used = Math.round(Tick.swap_usage.used / Tick.swap_usage.total * 1000) / 10;
            var swap_free = Math.round(Tick.swap_usage.free / Tick.swap_usage.total * 1000) / 10;

            var fastdpi = _this.GetFastdpiPorocessUsageTick(Tick);

            ticks.push({mem_used:mem_used, mem_free:mem_free, swap_used:swap_used, swap_free:swap_free, fastdpi:fastdpi, date:date, index:Index});
        });
    }

    return ticks;
};

HardwarePerformanceManager.prototype.GetMemStatsTicks = function(Params,HardwareId)
{
    var _this = this;
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var ticks = [];

    var ticksDates = this.ResourcesStatsUsageTicks[hardwareId] ? Object.keys(this.ResourcesStatsUsageTicks[hardwareId]) : null;

    if(ticksDates && ticksDates.length)
    {
        ticksDates.forEach(function (TickDate, Index)
        {
            if(_this.ResourcesStatsUsageTicks[hardwareId][TickDate].mem_usage)
            {
                var tick = _this.ResourcesStatsUsageTicks[hardwareId][TickDate].mem_usage;

                var date = tick.date;
                var mem_virt = Math.round(tick.virt / 1000000000);
                var mem_res = Math.round(tick.res / 1000000000);

                ticks.push({virt:mem_virt, res:mem_res, date:date, index:Index});
            }
        });
    }

    return ticks;
};

HardwarePerformanceManager.prototype.GetLastTickTopProcesses = function(Params,HardwareId)
{
    var lastTick = this.GetLastTick(Params,HardwareId);
    if(lastTick && lastTick.top_processes)
    {
        return lastTick.top_processes;
    }

    return [];
};

HardwarePerformanceManager.prototype.GetDnaStatsTicks = function(Params,HardwareId)
{
    var _this = this;
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var ticks = [];

    var ticksDates = this.ResourcesStatsUsageTicks[hardwareId] ? Object.keys(this.ResourcesStatsUsageTicks[hardwareId]) : null;

    if(ticksDates && ticksDates.length)
    {
        ticksDates.forEach(function (TickDate, Index)
        {
            if(_this.ResourcesStatsUsageTicks[hardwareId][TickDate].dnas_usage)
            {
                var dnasUsage = _this.ResourcesStatsUsageTicks[hardwareId][TickDate].dnas_usage;

                var cluster = Params.cluster.split("_")[0];

                if(dnasUsage[cluster+"_"+Params.dna+"_"+Params.inOut])
                {
                    var tick = dnasUsage[cluster+"_"+Params.dna+"_"+Params.inOut];

                    var tickModel = new DpiDnaUsageTickModel(tick);

                    tickModel["date"] = tick.date;
                    tickModel["index"] = Index;

                    ticks.push(tickModel);
                }

                if(dnasUsage[cluster+"_"+Params.dna+"_"+Params.inOut+"_"+Params.inOutIndex])
                {
                    var tick = dnasUsage[cluster+"_"+Params.dna+"_"+Params.inOut+"_"+Params.inOutIndex];

                    var tickModel = new DpiDnaUsageTickModel(tick);

                    tickModel["date"] = tick.date;
                    tickModel["index"] = Index;

                    ticks.push(tickModel);
                }
            }
        });
    }

    return ticks;
};

HardwarePerformanceManager.prototype.GetStatHttpTicks = function(Params,HardwareId)
{
    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var ticks = [];

    var lastTick = null;

    var ticksDates = this.ResourcesStatsUsageTicks[hardwareId] ? Object.keys(this.ResourcesStatsUsageTicks[hardwareId]) : null;

    var prepareTick = function (Tick, HttpType)
    {
        Tick["act_"+HttpType] = Tick[HttpType];// - lastTick[HttpType];
        Tick["act_"+HttpType+"_lock"] = Tick[HttpType+"_lock"];// - lastTick[HttpType+"_lock"];
    };

    if(ticksDates && ticksDates.length)
    {
        ticksDates.forEach(function (TickDate, Index)
        {
            if(_this.ResourcesStatsUsageTicks[hardwareId][TickDate].http_usage)
            {
                var tick = _this.ResourcesStatsUsageTicks[hardwareId][TickDate].http_usage;
                tick.index = Index;

                tick = new DpiHttpUsageTickModel(tick);

                if(Index > 0)
                {
                    prepareTick(tick,"url");
                    prepareTick(tick,"ssl");
                    prepareTick(tick,"cna");
                    prepareTick(tick,"sni");
                    prepareTick(tick,"ccheck");
                    prepareTick(tick,"quic");

                    ticks.push(new DpiHttpUsageTickModel(tick));
                }

                lastTick = tick;
            }
        });
    }

    return ticks;
};

HardwarePerformanceManager.prototype.GetLastStatTick = function(HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var ticksDates = this.ResourcesStatsUsageTicks[hardwareId] ? Object.keys(this.ResourcesStatsUsageTicks[hardwareId]) : null;

    if(ticksDates && ticksDates.length)
    {
        var lastTick = ticksDates[ticksDates.length-1]
        return this.ResourcesStatsUsageTicks[hardwareId][lastTick];
    }

    return null;
};

HardwarePerformanceManager.prototype.GetStatClusterDnaInfo = function(Params,HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var lastTick = this.GetLastStatTick(hardwareId);

    var info = null;

    var dnaGroups = {};

    var currentGroup = -1;

    for (var i = 0; i < 100; i++)
    {
        if(i%2 == 0)
            currentGroup++;

        dnaGroups[i] = currentGroup;
    }

    if(lastTick && lastTick.dnas_usage)
    {
        var infoObj = {};

        Object.keys(lastTick.dnas_usage).forEach(function (Key,Index)
        {
            var keyArr = Key.split("_");

            var cluster = keyArr[0];
            var dna = keyArr.splice(1,keyArr.length - 3).join("_");
            var dev = keyArr[keyArr.length - 2];
            var index = keyArr[keyArr.length - 1] ? parseInt(keyArr[keyArr.length - 1],10) : 0;

            if(!infoObj[cluster+"_"+dnaGroups[index]])
                infoObj[cluster+"_"+dnaGroups[index]] = {in:null, out:null, in_index:0, out_index:0};

            if(!infoObj[cluster+"_"+dnaGroups[index]][dev])
                infoObj[cluster+"_"+dnaGroups[index]][dev] = dna;

            if(!infoObj[cluster+"_"+dnaGroups[index]][dev+"_index"])
                infoObj[cluster+"_"+dnaGroups[index]][dev+"_index"] = index;

        });

        info = infoObj;
    }
    return info;
};

HardwarePerformanceManager.prototype.GetCurrentHardwareId = function (HardwareId)
{
    return HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();
};

HardwarePerformanceManager.prototype.RefreshFullNatPerformance = function(Params)
{
    "use strict";

    var _this = this;

    var data = Params && Params.data ? Params.data : null;

    data.hardware_id = App.SessionManager.GetCurrentHardwareId();
    var params =
        {
            method:"GetFullNatPerformance",
            data:{
                Params: data
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.FullNatPerformance = [];
                    if(R.data)
                    {
                        Object.keys(R.data).forEach(function(Key)
                        {
                            _this.FullNatPerformance[Key] = new FullNatPerformanceModel(R.data[Key]);
                            // _this.FullNatPerformance[Key].load = parseInt((100 / _this.FullNatPerformance.length) - 1);// = new FullNatPerformanceModel(R.data[Key]);
                        });
                    }

                    _this.SignalFullNatPerformanceUpdated.next(1);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwarePerformanceManager.prototype.GetFullNatPerformance = function ()
{
    return this.FullNatPerformance;
};

HardwarePerformanceManager.prototype.RefreshPoolNatPerformance = function(Params)
{
    "use strict";

    var _this = this;

    var data = Params && Params.data ? Params.data : null;
    data.hardware_id = App.SessionManager.GetCurrentHardwareId();
    var params =
        {
            method:"GetPoolNatPerformance",
            data:{
                Params: data
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.PoolNatPerformance = [];
                    if(R.data)
                    {
                        Object.keys(R.data).forEach(function(Key)
                        {
                            _this.PoolNatPerformance[Key] = new FullNatPerformanceModel(R.data[Key]);
                            // _this.PoolNatPerformance[Key].load = parseInt((100 / _this.PoolNatPerformance.length) - 1);// = new FullNatPerformanceModel(R.data[Key]);
                        });
                    }

                    _this.SingalPoolNatPerformanceUpdated.next(1);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwarePerformanceManager.prototype.GetPoolNatPerformance = function ()
{
    return this.PoolNatPerformance;
};

HardwarePerformanceManager.prototype.RefreshNatAddressPerformance = function(Params)
{
    "use strict";

    var _this = this;

    if(Params&&Params.page >= 0)
    {
        this.NatAddressPerformanceFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.NatAddressPerformanceFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.NatAddressPerformanceFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.NatAddressPerformanceFilter.sort.order_by = Params.sort.id;
        this.NatAddressPerformanceFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.NatAddressPerformanceFilter.total.page,
        size:this.NatAddressPerformanceFilter.total.size,

        order_by:this.NatAddressPerformanceFilter.sort.order_by,
        order_dir:this.NatAddressPerformanceFilter.sort.order_dir
    };

    Object.keys(this.NatAddressPerformanceFilter.filter).forEach(function (Key)
    {
        if(_this.NatAddressPerformanceFilter.filter[Key])
            filterParams[Key] = _this.NatAddressPerformanceFilter.filter[Key];
    });

    if(Params && Params.profile_ids)
    {
        filterParams.profile_ids = Params.profile_ids;
    }

    filterParams.hardware_id = App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"GetNatAddressPerformance",
            data:{
                Params: filterParams
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.NatAddressPerformance = [];
                    _this.NatAddressPerformanceFilter.total.page = 0;
                    _this.NatAddressPerformanceFilter.total.count = 0;
                    if(R.data)
                    {
                        R.data.rows.forEach(function (Status)
                        {
                            _this.NatAddressPerformance.push(new AddressNatPerformanceModel(Status));
                        });

                        _this.NatAddressPerformanceFilter.total.page = parseInt(R.data.page,10);
                        _this.NatAddressPerformanceFilter.total.count = parseInt(R.data.count,10);
                    }
                    _this.SignalNatAddressPerformanceUpdated.next(1);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwarePerformanceManager.prototype.GetNatAddressPerformance = function ()
{
    return this.NatAddressPerformance;
};

HardwarePerformanceManager.prototype.RefreshConfigInfo = function(Params,HardwareId)
{
    var _this = this;

    var hardwareId = App.SessionManager.GetCurrentHardwareId();
    var key = "RefreshConfigInfo_"+hardwareId;

    if(this[key])
    {
        return;
    }

    this[key] = true;

    var params =
    {
        method:"GetDpiConfigObjByConfigKeys",
        data:{HwId:parseInt(hardwareId,10), ConfigKeys:{dbg_log_mask:1}},
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                _this.ConfigInfo[hardwareId] = {};

                if(R.data)
                {
                    _this.ConfigInfo[hardwareId] = R.data;
                }

                _this.SignalConfigInfoUpdated.next(1);
            }
            // else
            // {
            //     webix.message({type:"error", text:R.error.msg});
            // }

        }
    }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwarePerformanceManager.prototype.GetConfigInfo = function ()
{
    return this.ConfigInfo[this.GetCurrentHardwareId()];
};
function HardwareLogsFileModel(Params)
{
    var __this = this;

    this.path = Params&&Params.path?Params.path:null;
    this.filename = Params&&Params.filename?Params.filename:null;

    this.data = null;

    if(Params&&Params.data)
    {
        this.data = [];

        Params.data.forEach(function (Item)
        {
            __this.data.push(new HardwareLogsFileModel(Item));
        });
    }
}

function HardwareLogsFileTailContentModel(Params)
{
    this.path = Params&&Params.path?Params.path:null;
    this.filename = Params&&Params.filename?Params.filename:null;

    this.content = Params&&Params.content?Params.content:null;
}

function HardwareLogsManager(Params)
{
    this.mode = module ? module : "dpiui2";

    this.CurrentHwId = 0;

    this.Active = true;

    this.CapturePeriodInSec = 30;
    this.CaptureTimer = null;

    this.ConstLogsTail = 1000;

    this.StatLogTail = {};
    this.SignalStatLogTailUpdated = new Rx.BehaviorSubject(0);

    this.AlertLogTail = {};
    this.SignalAlertLogTailUpdated = new Rx.BehaviorSubject(0);

    this.Signals = {
        FilesListLoading: new Rx.BehaviorSubject(null),
        FilesListLoaded: new Rx.BehaviorSubject(null),
        FilesListLoadError: new Rx.BehaviorSubject(null),

        LogFileTailLoading: new Rx.BehaviorSubject(null),
        LogFileTailLoaded: new Rx.BehaviorSubject(null),
        LogFileTailLoadError: new Rx.BehaviorSubject(null)
    };

    this.ServerMethods =
    {
        RefreshLogsFilesList:Params&&Params.ServerMethods&&Params.ServerMethods.RefreshLogsFilesList?Params.ServerMethods.RefreshLogsFilesList:"",

        GetLogFileTail:Params&&Params.ServerMethods&&Params.ServerMethods.GetLogFileTail?Params.ServerMethods.GetLogFileTail:"",

        DownloadLogFile:Params&&Params.ServerMethods&&Params.ServerMethods.DownloadLogFile?Params.ServerMethods.DownloadLogFile:""
    };
}

HardwareLogsManager.prototype.Destroy = function ()
{
    this.Active = false;

    this.CapturePeriodInSec = 0;
    clearTimeout(this.CaptureTimer);
};

HardwareLogsManager.prototype.SetHwId = function(HwId)
{
    this.CurrentHwId = parseInt(HwId);
};

HardwareLogsManager.prototype.Refresh = function (Params,HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    this.RefreshStatLogTail(Params,HardwareId);

    this.RefreshAlertLogTail(Params,HardwareId);
};

HardwareLogsManager.prototype.RefreshStatLogTail = function (Params,HardwareId)
{
    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var params =
        {
            method:"GetStatLogTail",
            data:{Id:parseInt(hardwareId,10), Tail:Params&&Params.tail?Params.tail:_this.ConstLogsTail},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.StatLogTail[hardwareId] = "";

                    if(R.data)
                    {
                        _this.StatLogTail[hardwareId] = R.data;
                    }

                    _this.SignalStatLogTailUpdated.next(1);

                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }

                if(R.success)
                {
                    webix.message(LangHelper.GetString("DpiLogs", "Statistics log loaded"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareLogsManager.prototype.GetStatLogTail = function (Params,HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var logTail = "";

    if(this.StatLogTail[hardwareId])
    {
        logTail = this.StatLogTail[hardwareId];
    }

    return logTail;
};

HardwareLogsManager.prototype.DownloadLog = function (Params,HardwareId)
{
    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var params =
        {
            method:(Params&&Params.log?"Download"+Params.log:""),
            data:{Id:parseInt(hardwareId,10)},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    App.ServerManager.RedirectToFileDownload(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareLogsManager.prototype.RefreshAlertLogTail = function (Params,HardwareId)
{
    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var params =
        {
            method:"GetAlertLogTail",
            data:{Id:parseInt(hardwareId,10), Tail:Params&&Params.tail?Params.tail:_this.ConstLogsTail},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.AlertLogTail[hardwareId] = "";

                    if(R.data)
                    {
                        _this.AlertLogTail[hardwareId] = R.data;
                    }

                    _this.SignalAlertLogTailUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }

                if(R.success)
                {
                    webix.message(LangHelper.GetString("DpiLogs", "Message log loaded"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareLogsManager.prototype.GetAlertLogTail = function (Params,HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var logTail = "";

    if(this.AlertLogTail[hardwareId])
    {
        logTail =  this.AlertLogTail[hardwareId];
    }

    return logTail;
};

HardwareLogsManager.prototype.DownloadAlertLog = function (Params,HardwareId)
{
    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    //TODO
};

HardwareLogsManager.prototype.GetCurrentHardwareId = function (HardwareId)
{
    return HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();
};



HardwareLogsManager.prototype.RefreshLogsFilesList = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var data = {};

    if(Params && Params.hardware_id)
    {
        data.Id = Params.hardware_id;
    }

    if(this.CurrentHwId)
    {
        data.Id = this.CurrentHwId;
    }

    var params =
        {
            id: webix.uid(),
            method: this.ServerMethods.RefreshLogsFilesList,
            data:data,
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.FilesListLoading.next(0);

                if(R.success)
                {
                    var model = [];

                    R.data.forEach(function (Item)
                    {
                        model.push(new HardwareLogsFileModel(Item));
                    });

                    _this.Signals.FilesListLoaded.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.FilesListLoadError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.FilesListLoading.next(1);

    App.ServerManager.CallMethod(params);
};

HardwareLogsManager.prototype.GetLogFileTail = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:this.ServerMethods.GetLogFileTail,
            data:{
                Path:Params.path,
                File:Params.filename,
                Tail:Params.tail ? Params.tail : 0,
                Grep:Params.grep ? Params.grep : null,
                Lines:Params.lines ? Params.lines : 0,
                Id: Params.hardware_id ? Params.hardware_id : (this.CurrentHwId ? this.CurrentHwId : null)
            },
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.LogFileTailLoading.next(0);

                if(R.success)
                {
                    var model = new HardwareLogsFileTailContentModel(R.data);

                    _this.Signals.LogFileTailLoaded.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.LogFileTailLoadError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.LogFileTailLoading.next(1);

    App.ServerManager.CallMethod(params);
};

HardwareLogsManager.prototype.DownloadLogFile = function (Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var data = {
        Path:Params.path,
        File:Params.filename,
        Id: Params.hardware_id ? Params.hardware_id : (this.CurrentHwId ? this.CurrentHwId : null)
    };

    if(Params.zip_before_download)
        data.ZipBeforeDownload = Params.zip_before_download

    var params =
        {
            method:this.ServerMethods.DownloadLogFile,
            data:data,
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                if(R.success)
                {
                    App.ServerManager.RedirectToFileDownload(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
/* global webix */
/* global App */

function NotifModel(Params)
{
    this.notif_id = Params&&Params.notif_id?Params.notif_id:null;
    this.hardware_hardware_id = Params&&Params.hardware_hardware_id?Params.hardware_hardware_id:null;
    this.users_user_id = Params&&Params.users_user_id?Params.users_user_id:null;
    this.date = Params&&Params.date?Params.date:null;
    this.from = Params&&Params.from?Params.from:null;
    this.text = Params&&Params.text?Params.text:null;
    this.importance = Params&&Params.importance?Params.importance:null;
    this.readed = Params&&Params.readed?Params.readed:false;
    this.deleted = Params&&Params.deleted?Params.deleted:false;
}

function NotifReadedModel(Params)
{
    this.notif_id = Params&&Params.notif_id?Params.notif_id:null;
    this.readed = Params&&Params.readed?Params.readed:false;
}

function NotifDeletedModel(Params)
{
    this.notif_id = Params&&Params.notif_id?Params.notif_id:null;
    this.deleted = Params&&Params.deleted?Params.deleted:false;
}

function HardwareNotificationsManager(Params)
{
    this.Active = true;

    this.CapturePeriodInSec = 60;
    this.CaptureTimer = null;

    this.Notifications = [];

    this.Paging = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.Total = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };


    this.UnreadedCount = new Rx.BehaviorSubject(0);

    this.NotificationsSignal = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};
    this.Subscriptions.SignalIsLoggedIn = null;

    this.Init();
}

HardwareNotificationsManager.prototype.Init = function ()
{
    var _this = this;

    this.Subscriptions.SignalIsLoggedIn = App.SessionManager.SignalIsLoggedIn.subscribe(function (IsLoggedIn)
    {
        if (IsLoggedIn)
        {
            _this.Active = true;

            if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.logs))
                _this.RefreshLastNotificationsCount();
        }
        else
        {
            _this.Active = false;
        }
    });
};

HardwareNotificationsManager.prototype.RefreshLastNotifications = function (Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.Page >= 0)
    {
        this.Total.page = parseInt(Params.Page,10);
    }

    var params =
        {
            method:"GetLastNotifications",
            data:{Page:this.Total.page, Size:this.Total.size},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.Notifications = [];
                    _this.Total.page = 0;
                    _this.Total.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function (Notif)
                        {
                            Notif.date = new Date(Notif.date);

                            _this.Notifications.push(new NotifModel(Notif));
                        });

                        _this.Total.page = parseInt(R.data.page,10);
                        _this.Total.count = parseInt(R.data.count,10);
                    }

                    _this.NotificationsSignal.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(!R.success)
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }

    this.RefreshLastNotificationsCount();
};

HardwareNotificationsManager.prototype.RefreshLastNotificationsCount = function (Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    clearTimeout(this.CaptureTimer);

    var params =
        {
            method:"GetUnreadedNotificationsCount",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    var count = 0;

                    if(R.data)
                    {
                        count = parseInt(R.data, 10);
                    }

                    if(count !== _this.GetUnreadedCount())
                    {
                        _this.UnreadedCount.next(count);
                    }

                    if(_this.CapturePeriodInSec)
                    {
                        _this.CaptureTimer = setTimeout(function ()
                        {
                            _this.RefreshLastNotificationsCount();
                        },_this.CapturePeriodInSec*1000)
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(!R.success)
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareNotificationsManager.prototype.SetSelectedNotificationsReaded = function (Params)
{
    var notifs = [];

    if(Params&&Params.Notifs)
    {
        Params.Notifs.forEach(function (Notif)
        {
            if(!Notif.readed || Notif.readed != 1)
            {
                Notif.readed = 1;
                notifs.push(new NotifReadedModel(Notif));
            }
        });
    }

    var params = {};
    params.Notifs = notifs;
    if(Params&&Params.callback)
    {
        params.callback = Params.callback;
    }

    this.SetNotificationsReaded(params);
};

HardwareNotificationsManager.prototype.DeleteSelectedNotifications = function (Params)
{
    var notifs = [];

    if(Params&&Params.Notifs)
    {
        Params.Notifs.forEach(function (Notif)
        {
            Notif.deleted = 1;
            notifs.push(new NotifDeletedModel(Notif));
        });
    }

    var params = {};
    params.Notifs = notifs;
    if(Params&&Params.callback)
    {
        params.callback = Params.callback;
    }

    this.DeleteNotifications(params);
};

HardwareNotificationsManager.prototype.SetNotificationsReaded = function (Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"SetNotificationsReaded",
            data:{Notifs:Params&&Params.Notifs?Params.Notifs:[]},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(!R.success)
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareNotificationsManager.prototype.SetAllNotificationsReaded = function (Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"SetAllNotificationsReaded",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(!R.success)
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareNotificationsManager.prototype.DeleteNotifications = function (Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var notifs = Params&&Params.Notifs?Params.Notifs:[];

    var params =
        {
            method:"DeleteNotifications",
            data:{Notifs:notifs},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    if(notifs.length)
                    {
                        var Notifications = [];

                        _this.Notifications.forEach(function (Notif)
                        {
                            var found = false;

                            notifs.every(function (NotifDeleted)
                            {
                                if(Notif.notif_id == NotifDeleted.notif_id)
                                {
                                    found = true;
                                    return false;
                                }

                                return true;
                            });

                            if(!found)
                            {
                                Notifications.push(Notif);
                            }
                        });

                        _this.Notifications = Notifications;
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(!R.success)
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareNotificationsManager.prototype.DeleteAllNotifications = function (Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"DeleteAllNotifications",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(!R.success)
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareNotificationsManager.prototype.GetUnreadedCount = function ()
{
    return this.UnreadedCount.getValue();
};

HardwareNotificationsManager.prototype.GetNotifications = function ()
{
    return this.Notifications;
};

HardwareNotificationsManager.prototype.Destroy = function ()
{
    var _this = this;

    this.Active = false;

    this.CapturePeriodInSec = 0;
    clearTimeout(this.CaptureTimer);

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
        delete _this.Subscriptions[key];
    });
};
var SubscribersSyncStatusDic = {
    new: {value: LangHelper.GetString("Dics", "New"), id: 1},
    processing: {value: LangHelper.GetString("Dics", "Processing"), id: 2},
    success: {value: LangHelper.GetString("Dics", "Success"), id: 3},
    error: {value: LangHelper.GetString("Dics", "Error"), id: 4}
};

function SubscriberSyncStatusModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();

    this.task_id = Params && Params.task_id ? parseInt(Params.task_id) : 0;
    this.hardware_id = Params && Params.hardware_id ? parseInt(Params.hardware_id) : 0;
    this.process = Params && Params.process ? Params.process : '';
    this.status = Params && Params.status ? parseInt(Params.status) : SubscribersSyncStatusDic.new.id;
    this.start_date = Params && Params.start_date ? Params.start_date : null;
};

function SubscribersSyncStatusManager(Params)
{
    this.Active = true;

    this.Signals = {
        HardwareSyncStatusSignal: new Rx.BehaviorSubject(null),
        ForceSyncStarted: new Rx.BehaviorSubject(false)
    };
};

SubscribersSyncStatusManager.prototype.RefreshSyncStatus = function()
{
    var _this = this;

    var hardwareId = App.SessionManager.GetCurrentHardwareId();
    var params = {
        method: "GetSubscribersSyncStatus",
        data: {
            HardwareId: parseInt(hardwareId, 10)
        },
        callback: function(R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                if(R.data)
                {
                    var model = new SubscriberSyncStatusModel(R.data);
                    _this.Signals.HardwareSyncStatusSignal.next(model);
                }
            }
            else
            {
                webix.message({type:"error", text:R.error.msg});
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

SubscribersSyncStatusManager.prototype.ForceSyncSubscribers = function()
{
    var _this = this;
    var params = {
        method: "ForceSyncAdvCompanies",
        data:{
            HardwareId: parseInt(App.SessionManager.GetCurrentHardwareId())
        },
        callback: function(R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                _this.Signals.ForceSyncStarted.next(true);
            }
            else
            {
                webix.message({type:"error", text:R.error.msg});
            }
        }
    };
    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};
var SubscribersCliWikiUrls = function(){
    var dic = {
        ru: {
            ping: "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:cli:subs&s[]=fdpi&s[]=cli#subs_ping",
            auth: "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:cli:subs&s[]=fdpi&s[]=cli#subs_auth",
            prop: "https://wiki.vasexperts.ru/doku.php?id=dpi:dpi_options:cli:subs&s[]=fdpi&s[]=cli#subs_prop"
        },
        en: {
            ping: "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:cli:subs&s[]=fdpi&s[]=cli#subs_ping",
            auth: "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:cli:subs&s[]=fdpi&s[]=cli#subs_auth",
            prop: "https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:cli:subs&s[]=fdpi&s[]=cli#subs_prop"
        }
    };

    return dic[LangHelper.GetLocale()];
}();

var SubscribersIdentitiesDic = {
    login: {id: "login", value: LangHelper.GetString("Subscribers", "Login")},
    ip: {id: "ip", value: LangHelper.GetString("Subscribers", "IP")}
};

function SubscriberModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();

    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
    this.login = Params&&Params.login?Params.login:'';
    this.ip = Params&&Params.ip?Params.ip:'';
    this.bind_type = Params&&Params.bind_type != null?Params.bind_type.toString():"1";
    this.services = Params&&Params.services?Params.services:'';
    this.policing = Params&&Params.policing?Params.policing:'';
    this.services_profiles = Params&&Params.services_profiles?Params.services_profiles:'';
    this.auth_status = Params&&Params.auth_status?Params.auth_status.toString():'0';
    this.auth_expired = Params&&Params.auth_expired?Params.auth_expired.toString():'n/a';
    this.auth_props = Params&&Params.auth_props?Params.auth_props:JSON.stringify(new SubscriberPropsModel());
    this.identity_type = Params&&Params.identity_type?Params.identity_type:SubscribersIdentitiesDic.login.id;

    this.valid = true;
}

function SubscriberPropsModel(Params)
{
    this.props = Params&&Params.props?Params.props: {};
    this.error = Params&&Params.error?Params.error:'';
    this.update_date = Params&&Params.update_date?Helper.DateTimeToLocal(Params.update_date):'';
};

function SubscriberAuthStateModel(Params)
{
  this.state = Params && Params.state ? Params.state : "0";
  this.expired = Params && Params.expired ? Params.expired : null;
};

function SubscriberServiceProfileModel(Params)
{
    return {
        4: (Params && Params[4] ? Params[4] : 0),
        5: (Params && Params[5] ? Params[5] : 0),
        10: (Params && Params[10] ? Params[10] : 0),
        11: (Params && Params[11] ? Params[11] : 0),
        13: (Params && Params[13] ? Params[13] : 0),
        18: (Params && Params[18] ? Params[18] : 0)
    }
}

function VchannelsServiceProfileModel(Params)
{
    var model = new SubscriberServiceProfileModel(Params);

    delete model["11"];

    return model;
}

function L2AuthConfigModel(Params)
{
    this.bras_enable = Params&&Params.bras_enable?(Params.bras_enable=="0"?"":Params.bras_enable):"";
    this.bras_arp_ip = Params&&Params.bras_arp_ip?Params.bras_arp_ip:"";
    this.bras_arp_mac = Params&&Params.bras_arp_mac?Params.bras_arp_mac:"";
}

function HardwareSubscribersManager(Params)
{
    this.Active = true;

    this.Subscribers = [];
    this.MultiSubscribers = [];

    this.Paging = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.Total = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.Filter = {
        login:null,
        ip:null,
        services:null,
        policing: null
    };

    this.Sort = {
        id:null,
        dir:null
    };

    this.L2AuthState = null;

    this.SubscribersSignal = new Rx.BehaviorSubject(0);
    this.MultiSubscribersSignal = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};

    this.CurrentRequestId = 0;
}

HardwareSubscribersManager.prototype.RefreshSubscribers = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.CurrentRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.Total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.filter)
    {
        this.Filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.Sort = Params.sort;
    }

    var services_profiles = {};
    var filter = webix.copy(this.Filter);
    for(var i in  filter)
    {
        if(i.indexOf("service_") !== -1)
        {
            services_profiles[i.split("_")[1].toString()] = filter[i];
        }
    }

    let sectionLink = window.location.hash;

    var params =
        {
            id:this.CurrentRequestId,
            method:"GetSubscribers",
            data:{
                Params: {
                    hardware_id:hardwareId,
                    page:this.Total.page,
                    size:this.Total.size,
                    login:this.Filter.login,
                    ip:this.Filter.ip,
                    policings: this.Filter.policing,
                    bind_type:this.Filter.bind_type,
                    auth_status: this.Filter.auth_status ? this.Filter.auth_status : null,
                    services_profiles: Object.keys(services_profiles).length ? services_profiles : null,
                    services:this.Filter.services,
                    order_by:this.Sort.id?this.Sort.id:null,
                    order_dir:this.Sort.dir?this.Sort.dir:null
                },
                SectionLink: sectionLink
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(_this.CurrentRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    _this.Subscribers = [];
                    _this.Total.page = 0;
                    _this.Total.count = 0;


                    if(R.data)
                    {
                        R.data.rows.forEach(function (Subscriber)
                        {
                            _this.Subscribers.push(new SubscriberModel(Subscriber));
                        });

                        _this.Total.page = parseInt(R.data.page,10);
                        _this.Total.count = parseInt(R.data.count,10);
                    }

                    _this.SubscribersSignal.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(!R.success)
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.GetSubscribers = function ()
{
    return webix.copy(this.Subscribers);
};

HardwareSubscribersManager.prototype.GetAllMultiSubscribers = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(!_this.Active)
    {
        return;
    }

    let filter = {};
    let services_profiles = {};

    if(Params && Params.filter) {
        for (const filterKey in Params.filter) {
            if(Params.filter[filterKey] && filterKey == "policing") {
                filter["policings"] = Params.filter[filterKey];
            }

            if(Params.filter[filterKey] && filterKey != "policing" && filterKey.indexOf("service_") === -1){
                filter[filterKey] = Params.filter[filterKey];
            }

            if(Params.filter[filterKey] && filterKey != "policing" && filterKey.indexOf("service_") !== -1)
            {
                services_profiles[filterKey.split("_")[1].toString()] = Params.filter[filterKey];
            }
        }
    }

    if (Object.keys(services_profiles).length)
        filter.services_profiles = services_profiles;

    filter.hardware_id = hardwareId;

    filter.page = Params.page;


    var params =
        {
            id:webix.uid(),
            method:"GetMultiSubscribers",
            data:{
                Params: filter
            },
            callback:function (R)
            {
                if(R.success) {
                    _this.MultiSubscribers = [];
                    _this.Total.page = 0;
                    _this.Total.count = 0;

                    if(R.data) {
                        R.data.rows.forEach(function (multiSub)
                        {
                            _this.MultiSubscribers.push(new SubscriberModel(multiSub));
                        });

                        _this.Total.page = parseInt(R.data.page,10);
                        _this.Total.count = parseInt(R.data.count,10);
                    }

                    _this.MultiSubscribersSignal.next(1);
                }

                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.GetMultiSubscribers = function ()
{
    return webix.copy(this.MultiSubscribers);
};

HardwareSubscribersManager.prototype.GetSubscribersAsDic = function()
{
    var dic = {};

    var list = this.GetSubscribers();

    if(list && Array.isArray(list) && list.length)
    {
        list.forEach(function (Item)
        {
            dic[Item.login] = {id:Item.id, value:Item.login};
        });
    }

    return dic;
};

HardwareSubscribersManager.prototype.SaveSubscribers = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];

    if(Params&&Params.data)
    {
        Params.data.forEach(function (Subscriber)
        {
            if(Subscriber)
            {
                var request = {};

                request.id = Subscriber.newSubscriber.id ? Subscriber.newSubscriber.id : null;
                request.method = "SaveSubscriber";
                request.data = {Id:parseInt(hardwareId,10), Subscriber:Subscriber.newSubscriber, SubscriberOld:Subscriber.oldSubscriber};

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.DeleteSubscribers = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];

    if(Params&&Params.data)
    {
        Params.data.forEach(function (Subscriber)
        {
            if(Subscriber)
            {
                var request = {};

                request.id = Subscriber.id ? Subscriber.id : null;
                request.method = "DeleteSubscriber";
                request.data = {Id:parseInt(hardwareId,10), Subscriber:Subscriber};

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.SetPolicingsByFilter = function(Params)
{
    var _this = this;
    var data = {
        ProfileId: Params && Params.policing ? parseInt(Params.policing) : 0,
        Filter: Params && Params.filter ? Params.filter : {}
    };
    data.Filter.hardware_id = parseInt(App.SessionManager.GetCurrentHardwareId());
    var params = {
        id: this.CurrentProfileRequestId,
        method: "SetSubscribersPolicingsByFilter",
        data:data,
        callback: function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

HardwareSubscribersManager.prototype.SetSubscriberAuthState = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];

    var state = new SubscriberAuthStateModel(Params && Params.state ? Params.state : null);

    if(Params&&Params.subscribers)
    {
        Params.subscribers.forEach(function (Subscriber)
        {
            if(Subscriber)
            {
                var request = {};

                request.id = Subscriber.id ? Subscriber.id : null;
                request.method = "SetSubscriberAuthState";
                request.data = {
                    Id:parseInt(hardwareId,10),
                    Subscriber:Subscriber,
                    State:state
                };

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.ClearSubscriberAuthState = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];
    if(Params&&Params.subscribers)
    {
        Params.subscribers.forEach(function (Subscriber)
        {
            if(Subscriber)
            {
                var request = {};

                request.id = Subscriber.id ? Subscriber.id : null;
                request.method = "ClearSubscriberAuthState";
                request.data = {
                    Id:parseInt(hardwareId,10),
                    Subscriber:Subscriber
                };

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.SetAllSubscribersAuthState = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];

    var state = new SubscriberAuthStateModel(Params && Params.state ? Params.state : null);


    var request = {};
    request.id = webix.uid();
    request.method = "SetAllSubscribersAuthState";
    request.data = {
        Id:parseInt(hardwareId,10),
        State:state
    };

    requests.push(request);

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.ClearAllSubscriberAuthState = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];
    var request = {};

    request.id = webix.uid();
    request.method = "ClearAllSubscribersAuthState";
    request.data = {
        Id:parseInt(hardwareId,10)
    };

    requests.push(request);

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.SyncAuthProp = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];
    if(Params&&Params.subscribers)
    {
        Params.subscribers.forEach(function (Subscriber)
        {
            if(Subscriber)
            {
                var request = {};

                request.id = Subscriber.id ? Subscriber.id : null;
                request.method = "LoadSubscriberAuthProps";
                request.data = {
                    Id:parseInt(hardwareId,10),
                    Subscriber:Subscriber
                };

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.DeleteAuthProp = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];
    if(Params&&Params.subscribers)
    {
        Params.subscribers.forEach(function (Subscriber)
        {
            if(Subscriber)
            {
                var request = {};

                request.id = Subscriber.id ? Subscriber.id : null;
                request.method = "DropSubscriberAuthProps";
                request.data = {
                    Id:parseInt(hardwareId,10),
                    Subscriber:Subscriber
                };

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.SetAuthProp = function (Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];
    if(Params&&Params.subscribers)
    {
        Params.subscribers.forEach(function (Subscriber)
        {
            if(Subscriber)
            {
                var request = {};

                request.id = Subscriber.id ? Subscriber.id : null;
                request.method = "SetSubscriberAuthProps";
                request.data = {
                    Id:parseInt(hardwareId,10),
                    Subscriber:Subscriber,
                    Props: Params.props,
                    Memory: !!Params.memory
                };

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareSubscribersManager.prototype.GetL2AuthParams = function ()
{
    return webix.copy(this.L2AuthState);
};

HardwareSubscribersManager.prototype.RefreshL2AuthParams = function ()
{
    var _this = this;

    var hardwareId = App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"GetDpiConfigObjByConfigKeys",
            data:{HwId:parseInt(hardwareId,10), ConfigKeys:{bras_enable:1, bras_arp_ip:1, bras_arp_mac:1}},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    if(R.data)
                    {
                        var model = new L2AuthConfigModel(R.data);

                        _this.L2AuthState = {
                            macAddresses: {},
                            authParams: {}
                        }

                        Object.keys(model).forEach(configElement => {
                           if(configElement == "bras_arp_mac") {
                               _this.L2AuthState.macAddresses[configElement] = model[configElement];
                           }
                           else {
                               _this.L2AuthState.authParams[configElement] = model[configElement];
                           }
                        });
                    }
                }
            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};
/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */
/* global SubscribersComponentsTypeDic */
/* global HardwareSubscribersManager */

function VchannelModel(Params)
{
    "use strict"

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
    this.vchannel_name = Params&&Params.vchannel_name?Params.vchannel_name:'';
    this.vchannel_number = Params&&Params.vchannel_number?Params.vchannel_number:0;
    this.services = Params&&Params.services?Params.services:'';
    this.policing = Params&&Params.policing?Params.policing:'';
    this.services_profiles = Params&&Params.services_profiles?Params.services_profiles:'';

    this.valid = true;
}

function VchannelsSettingsConfigModel(Params) {
    this.id = Params&&Params.id?Params.id:webix.uid();
    this.cidr = Params&&Params.cidr?Params.cidr:"";
    this.vchannel = Params&&Params.vchannel?Params.vchannel:"";
}

function VchannelsManager ()
{
    "use strict"

    this.Active = true;

    this.Vchannels = [];

    this.Paging = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.Total = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.Filter = {
        vchannel_number:null,
        vchannel_name:null,
        hardware_id:null,
        services: null,
        policing:null,
        services_profiles:null
    };

    this.Sort = {
        id:null,
        dir:null
    };

    this.VchannelsSignal = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};

    this.CurrentRequestId = 0;
}

VchannelsManager.prototype.RefreshVchannels = function (Params, HardwareId)
{
    "use strict"

    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.CurrentRequestId = webix.uid();

    if (!_this.Active) return;

    if (Params&&Params.page >= 0)
        this.Total.page = parseInt(Params.page,10);

    if (Params&&Params.filter)
        this.Filter = Params.filter;

    if (Params&&Params.sort)
        this.Sort = Params.sort;

    var services_profiles = {};

    var filter = webix.copy(this.Filter);

    for (var i in filter)
    {
        if (i.indexOf("service_") !== -1)
            services_profiles[i.split("_")[1].toString()] = filter[i];
    }

    var params =
        {
            id:this.CurrentRequestId,
            method:"GetVchannels",
            data:{
                Params: {
                    hardware_id:hardwareId,
                    page:this.Total.page,
                    size:this.Total.size,
                    vchannel_number:this.Filter.vchannel_number,
                    vchannel_name:this.Filter.vchannel_name,
                    policings: this.Filter.policings,
                    sync_marker: this.Filter.sync_marker,
                    services_profiles: Object.keys(services_profiles).length ? services_profiles : null,
                    services:this.Filter.services,
                    order_by:this.Sort.id?this.Sort.id:null,
                    order_dir:this.Sort.dir?this.Sort.dir:null
                }
            },
            callback:function (R)
            {
                if (!_this.Active) return;

                if (_this.CurrentRequestId != R.id) return;

                if (R.success)
                {
                    _this.Vchannels = [];
                    _this.Total.page = 0;
                    _this.Total.count = 0;

                    if (R.data)
                    {
                        R.data.rows.forEach(function (Vchannel)
                        {
                            _this.Vchannels.push(new VchannelModel(Vchannel));
                        });

                        _this.Total.page = parseInt(R.data.page,10);
                        _this.Total.count = parseInt(R.data.count,10);
                    }

                    _this.VchannelsSignal.next(1);
                }

                if (Params && Params.callback && typeof Params.callback === "function")
                    Params.callback(R);
                else
                {
                    if (!R.success)
                        webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if (this.Active)
        App.ServerManager.CallMethod(params);
};

VchannelsManager.prototype.SaveVchannels = function (Params, HardwareId)
{
    "use strict"

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];

    if (Params&&Params.data)
    {
        Params.data.forEach(function (Vchannel)
        {
            if (Vchannel)
            {
                var request = {};

                request.id = Vchannel.newVchannel.id ? Vchannel.newVchannel.id : null;
                request.method = "SaveVchannel";
                request.data = {
                    Id:parseInt(hardwareId,10),
                    Vchannel:Vchannel.newVchannel,
                    VchannelOld:Vchannel.oldVchannel
                };
                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if (Params.callback && typeof Params.callback === "function")
                    Params.callback(result);
            }
        };

    if (this.Active)
        App.ServerManager.CallMethod(params);
};

VchannelsManager.prototype.DeleteVchannels = function (Params, HardwareId)
{
    "use strict"

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];

    if (Params&&Params.data)
    {
        Params.data.forEach(function (Vchannel)
        {
            if (Vchannel)
            {
                var request = {};

                request.id = Vchannel.id ? Vchannel.id : null;
                request.method = "DeleteVchannel";
                request.data = {Id:parseInt(hardwareId,10), Vchannel:Vchannel};

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if (Params.callback && typeof Params.callback === "function")
                    Params.callback(result);
            }
        };

    if (this.Active)
        App.ServerManager.CallMethod(params);
};

VchannelsManager.prototype.GetVchannels = function ()
{
    "use strict"

    return webix.copy(this.Vchannels);
};

VchannelsManager.prototype.SaveVchannelSettings = function(Params)
{
    var _this = this;
    let hardware_id = parseInt(App.SessionManager.GetCurrentHardwareId());

    var params = {
        // id: this.CurrentProfileRequestId,
        method: "SaveVchannelSettings",
        data:{
            Settings: Params.IPv4,
            SettingsIPv6: Params.IPv6,
            HardwareId: hardware_id
        },
        callback: function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

VchannelsManager.prototype.GetVchannelSettings = function(Params)
{
    var _this = this;
    let hardware_id = parseInt(App.SessionManager.GetCurrentHardwareId());

    var params = {
        // id: this.CurrentProfileRequestId,
        method: "GetVchannelSettings",
        data:{
            HardwareId: hardware_id
        },
        callback: function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

VchannelsManager.prototype.GetVchannelSettingsConfigHistory = function(Params)
{
    var _this = this;
    let hardware_id = parseInt(App.SessionManager.GetCurrentHardwareId());

    var params = {
        method: "GetVchannelSettingsConfigHistory",
        data:{
            HardwareId: hardware_id
        },
        callback: function(R)
        {
            if(R.success && R.data)
            {
                var data = [];

                Object.keys(R.data).forEach(function (Key)
                {
                    var obj = new HardwareConfigHistoryModel({file_id:R.data[Key]});

                    data.push(obj);
                });

                R.data = data;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

VchannelsManager.prototype.LoadVchannelSettingsHistoryFile = function(Params, HardwareId)
{
    var hardwareId = parseInt(App.SessionManager.GetCurrentHardwareId());;

    var params =
        {
            method:"GetVchannelSettingsConfigFile",
            data:{
                HardwareId:hardwareId,
                File:Params&&Params.configFile?Params.configFile:""
            },
            callback:function (result)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

var BlackListProfileModelActionsEnum = {
    update:"update",
    insert:"insert",
    delete:"delete"
}

function BlackListServiceProfileModel(Params, FirstPart, SecondPart)
{
    var firstPart = FirstPart?FirstPart:true;
    var secondPart = SecondPart?SecondPart:true;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.profile_id = Params&&Params.profile_id?Params.profile_id:0;

    if(firstPart)
    {
        this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
        this.service_id = Params&&Params.service_id?Params.service_id:0;

        this.name = Params&&Params.name?Params.name:"";

        this.created_at = Params&&Params.created_at?Params.created_at:null;
        this.updated_at = Params&&Params.updated_at?Params.updated_at:null;
    }

    if(secondPart)
    {
        this.redirect = Params&&Params.redirect?Params.redirect:"";
        this.federal = Params&&Params.federal?Params.federal:"";

        this.url_list = Params&&Params.url_list?Params.url_list:"";
        this.sni_list = Params&&Params.sni_list?Params.sni_list:"";
        this.ip_list = Params&&Params.ip_list?Params.ip_list:"";
        this.cn_list = Params&&Params.cn_list?Params.cn_list:"";

        this.enabled = Params&&Params.enabled?Params.enabled:true;
    }

    this.action = Params&&Params.action&&BlackListProfileModelActionsEnum[Params.action]?Params.action:BlackListProfileModelActionsEnum.update;

    this.valid = Params&&Params.valid?Params.valid:true;
};

function BlackListServiceManager(Params)
{
    this.Active = true;

    this.Profiles = [];

    this.ProfilesUpdatedSignal = new Rx.BehaviorSubject(0);

    this.CurrentProfileRequestId = 0;

};

BlackListServiceManager.prototype.RefreshProfiles = function(Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.CurrentProfileRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            id:this.CurrentProfileRequestId,
            method:"GetBlackListServiceProfiles",
            data: {
                Params: {
                    hardware_id: parseInt(hardwareId,10)
                }
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(_this.CurrentProfileRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    _this.Profiles = [];

                    if(R.data)
                    {
                        R.data.forEach(function (Profile)
                        {
                            _this.Profiles.push(new BlackListServiceProfileModel(Profile));
                        });
                    }

                    _this.ProfilesUpdatedSignal.next(1);
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

BlackListServiceManager.prototype.GetProfiles = function()
{
    return webix.copy(this.Profiles);
};

BlackListServiceManager.prototype.SaveProfiles = function(Params, HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var requests = [];

    if(Params&&Params.data)
    {
        Params.data.forEach(function (Profile) {
            if(Profile)
            {
                var request = {};

                request.id = Profile.id;
                request.method = "SaveBlackListServiceProfile";
                request.data = {HardwareId: parseInt(hardwareId,10), Profile:Profile};

                if(Profile.action === BlackListProfileModelActionsEnum.delete)
                {
                    request.method = "DeleteBlackListServiceProfile";
                }

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
/* global webix */
/* global App */

function DscpProrocolModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();
    this.protocol = Params&&Params.protocol?Params.protocol:"";
    this.dscp = Params&&Params.dscp?Params.dscp:"";

    this.group = Params && Params.group ? Params.group : (HardwareDscpProtocolsDic && HardwareDscpProtocolsDic[this.protocol] ? HardwareDscpProtocolsDic[this.protocol].group_id : null);
};

function DscpConfigModel(Params)
{
    var _this = this;

    if(Params)
    {
        Object.keys(Params).forEach(function (Key)
        {
            _this[Key] = new DscpProrocolModel(Params[Key]);
        });
    }
};

function HardwareDscpProrocolsManager(Params)
{
    //this.ProtocolsDic = JSON.parse(webix.ajax().sync().get("/app/data/protocols.json?v=4").responseText);
    //this.DscpDic = JSON.parse(webix.ajax().sync().get("/app/data/dscp.json?v=4").responseText);

    this.Active = true;

    this.DscpConfigFile = {};
    this.DscpConfigModel = {};
    this.SignalDscpFileUpdated = new Rx.BehaviorSubject(0);
    this.SignalModelUpdated = new Rx.BehaviorSubject(0);

    this.History = {};
    this.SignalConfigHistoryUpdated = new Rx.BehaviorSubject(0);

    this.SignalDicsReady = new Rx.BehaviorSubject(0);
    this.SignalConfigReady = new Rx.BehaviorSubject(0);

    this.Init();
};

HardwareDscpProrocolsManager.prototype.Init = function(Params)
{
    this.InitDicsIfNeed();
};

HardwareDscpProrocolsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

HardwareDscpProrocolsManager.prototype.Refresh = function(Params,HardwareId)
{
    var _this = this;

    if(!this.Active)
    {
        return;
    }

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"GetDscpProtocolsConfig",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (result)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(result.success)
                {
                    _this.DscpConfigFile[hardwareId] = result.data;
                }
                else
                {
                    _this.DscpConfigFile[hardwareId] = "";
                }

                _this.ParseConfigToModel();
                _this.ParseModelToConfig();

                _this.SignalDscpFileUpdated.next(1);
                _this.SignalConfigReady.next(result.success);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("DpiDscpConfig", "Dscp configuration loaded"));
                    }
                    else
                    {
                        webix.alert({
                            title: LangHelper.GetString("All", "Error"),
                            text: result.error.msg,
                            type:"alert-error",
                            width:600
                        });
                    }
                }
            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareDscpProrocolsManager.prototype.SetConfig = function(DscpConfigFile, HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.DscpConfigFile[hardwareId] = DscpConfigFile;

    this.ParseConfigToModel();

    this.SignalModelUpdated.next(1);
};

HardwareDscpProrocolsManager.prototype.GetConfig = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.DscpConfigFile[hardwareId])
    {
        return this.DscpConfigFile[hardwareId];
    }

    return "";
};

HardwareDscpProrocolsManager.prototype.SetConfigModel = function(ConfigModel, HardwareId, DontInitSignal)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.DscpConfigModel[hardwareId] = new DscpConfigModel(ConfigModel);

    this.ParseModelToConfig();

    if(!DontInitSignal)this.SignalModelUpdated.next(1);
};

HardwareDscpProrocolsManager.prototype.GetConfigModel = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.DscpConfigModel[hardwareId])
    {
        return webix.copy(this.DscpConfigModel[hardwareId]);
    }

    return new DscpConfigModel();
};

HardwareDscpProrocolsManager.prototype.ParseConfigToModel = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var config = this.GetConfig(hardwareId);

    var configLines = config.split("\n");

    var configModel = {};

    if(HardwareDscpProtocolsDic)
    {
        Object.keys(HardwareDscpProtocolsDic).forEach(function(Key){
            configModel[Key] = {
                protocol: Key,
                dscp: "",
                group: HardwareDscpProtocolsDic[Key].group_id
            };
        });
    }

    configLines.forEach(function (Line)
    {
        if(Line)
        {
            var parseLine = Helper.ReplaceMultipleWhiteSpacesWithOne(Line).trim().split(" ");

            if(parseLine.length >= 2)
            {
                var val = parseLine.pop().trim();

                var key = parseLine.join(" ").trim();

                val = {protocol:key, dscp:val};

                configModel[key] = val;
            }
        }
    });

    this.DscpConfigModel[hardwareId] = new DscpConfigModel(configModel);
};

HardwareDscpProrocolsManager.prototype.ParseModelToConfig = function(HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var configModel = this.GetConfigModel(hardwareId);

    var configLines = "";

    Object.keys(configModel).forEach(function (Key)
    {
        var model = configModel[Key];

        if(model.dscp)
        {
            configLines += model.protocol + " " + model.dscp + "\n";
        }
    });

    this.DscpConfigFile[hardwareId] = configLines;
};

HardwareDscpProrocolsManager.prototype.Save = function(Params,HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"SetDscpProtocolsConfig",
            data:{
                Id:parseInt(hardwareId,10),
                Config:Params&&Params.configContents?Params.configContents:_this.GetConfig(hardwareId)
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiDscpConfig", "Dscp configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

HardwareDscpProrocolsManager.prototype.HistoryRefresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"GetDscpProtocolsConfigHistory",
            data:{Id:parseInt(App.SessionManager.GetCurrentHardwareId(),10)},
            callback:function (result)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(result.success && result.data)
                {
                    var data = [];

                    Object.keys(result.data).forEach(function (Key)
                    {
                        var obj = new HardwareConfigHistoryModel({file_id:result.data[Key]});

                        data.push(obj);
                    });

                    _this.History[App.SessionManager.GetCurrentHardwareId()] = data;
                    _this.SignalConfigHistoryUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("All", "History loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareDscpProrocolsManager.prototype.GetHistory = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.History[hardwareId])
    {
        return this.History[hardwareId];
    }

    return [];
};

HardwareDscpProrocolsManager.prototype.LoadHistoryFile = function(Params, HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"GetDscpProtocolsConfigFile",
            data:{
                Id:parseInt(hardwareId,10),
                File:Params&&Params.configFile?Params.configFile:""
            },
            callback:function (result)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

HardwareDscpProrocolsManager.prototype.InitDicsIfNeed = function()
{
    this.RefreshDics();
    App.DicsManager.Refresh({data:[DicsEnum.ProtocolsGroupsDic]});
    // if(!HardwareDscpProtocolsDic)
    //     this.RefreshDics();
    // else{
    //     this.SignalDicsReady.next(1);
    // }
};

HardwareDscpProrocolsManager.prototype.RefreshDics = function(){
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method: "GetDscpProtocolsGroupDic",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                var protos = {};

                if(R.data)
                {
                    protos = R.data;
                }

                Object.keys(protos).forEach(function(Key){
                    protos[Key].value = protos[Key].protocol;
                });

                HardwareDscpProtocolsDic = protos;

            }
            else
            {
                webix.message({type:"error", text:R.error.msg});

                webix.alert({
                    title: LangHelper.GetString("All", "Error"),
                    text: LangHelper.GetString("All", "The protocols dics loaded") + ".<br/>" + LangHelper.GetString("All", "Error") + ":<br/>" + R.error.msg,
                    type:"alert-error",
                    width:600
                });
            }
            _this.SignalDicsReady.next(1);
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
}
function AsnModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();
    this.asn = Params&&Params.asn?Params.asn:"";
    this.ip = Params&&Params.ip?Params.ip:"";
    this.asn_name = Params&&Params.asn_name?Params.asn_name:"";
};

function AsnDscpModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();
    this.asn = Params&&Params.asn?Params.asn:"";
    this.dscp = Params&&Params.dscp?Params.dscp:"";
    this.asn_name = Params&&Params.asn_name?Params.asn_name:"";
};

function AsnConfigModel(Params)
{
    var _this = this;

    this.list = [];

    var paramsList = [];

    if(Params && Array.isArray(Params))
    {
        paramsList = Params;
    }
    else if(Params && Params.list)
    {
        paramsList = Params.list;
    }

    paramsList.forEach(function (Obj)
    {
        _this.list.push(new AsnModel(Obj));
    });
};

function AsnDscpConfigModel(Params)
{
    var _this = this;

    this.list = [];

    var paramsList = [];

    if(Params && Array.isArray(Params))
    {
        paramsList = Params;
    }
    else if(Params && Params.list)
    {
        paramsList = Params.list;
    }

    paramsList.forEach(function (Obj)
    {
        _this.list.push(new AsnDscpModel(Obj));
    });
};

function AllAsnDscpModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();
    this.asn = Params&&Params.asn?Params.asn:"";
    this.ips_obj = Params&&Params.ips_obj?Params.ips_obj:new AsnConfigModel();
    this.dscps_obj = Params&&Params.dscps_obj?Params.dscps_obj:new AsnDscpConfigModel();
    this.asn_name = Params&&Params.asn_name?Params.asn_name:"";
};

function AllAsnDscpConfigModel(Params)
{
    var _this = this;

    if(Params)
    {
        Object.keys(Params).forEach(function (Key)
        {
            _this[Key] = new AllAsnDscpModel(Params[Key]);
        });
    }
};

function HardwareAsnDscpConfigManager()
{
    //this.DscpDic = JSON.parse(webix.ajax().sync().get("/app/data/asn_dscp.json?v=4").responseText);

    this.Active = true;

    this.AsnConfigFile = {};
    this.AsnNamesFile = {};
    this.AsnConfigModel = {};
    this.SignalAsnFileUpdated = new Rx.BehaviorSubject(0);

    this.AsnV6ConfigFile = {};
    this.SignalAsnV6FileUpdated = new Rx.BehaviorSubject(0);

    this.AsnDscpConfigFile = {};
    this.AsnDscpConfigModel = {};
    this.SignalAsnDscpFileUpdated = new Rx.BehaviorSubject(0);

    this.AllAsnDscpConfigModel = {};

    this.SignalAllUpdated = new Rx.BehaviorSubject(0);
    this.SignalConfigReady = new Rx.BehaviorSubject(0);

    this.History = {};
    this.SignalConfigHistoryUpdated = new Rx.BehaviorSubject(0);
};

HardwareAsnDscpConfigManager.prototype.Destroy = function()
{
    this.Active = false;
};

HardwareAsnDscpConfigManager.prototype.SetAsnConfig = function(AsnConfigFile, HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.AsnConfigFile[hardwareId] = AsnConfigFile;

    this.ParseAsnConfigToModel();

    this.SignalAsnFileUpdated.next(1);
};

HardwareAsnDscpConfigManager.prototype.GetAsnConfig = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.AsnConfigFile[hardwareId])
    {
        return this.AsnConfigFile[hardwareId];
    }

    return "";
};

HardwareAsnDscpConfigManager.prototype.GetAsnNames = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.AsnNamesFile[hardwareId])
    {
        return this.AsnNamesFile[hardwareId];
    }

    return "";
};

HardwareAsnDscpConfigManager.prototype.SetAsnV6Config = function(AsnConfigFile, HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.AsnV6ConfigFile[hardwareId] = AsnConfigFile;

    this.ParseAsnV6ConfigToModel();

    this.SignalAsnV6FileUpdated.next(1);
};

HardwareAsnDscpConfigManager.prototype.GetAsnV6Config = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.AsnV6ConfigFile[hardwareId])
    {
        return this.AsnV6ConfigFile[hardwareId];
    }

    return "";
};

HardwareAsnDscpConfigManager.prototype.SetAsnConfigModel = function(Model, HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.AsnConfigModel[hardwareId] = new AsnConfigModel(Model);

    this.ParseAsnModelToConfig();

    this.SignalAsnFileUpdated.next(1);
};

HardwareAsnDscpConfigManager.prototype.GetAsnConfigModel = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.AsnConfigModel[hardwareId])
    {
        return this.AsnConfigModel[hardwareId];
    }

    return new AsnConfigModel();
};

HardwareAsnDscpConfigManager.prototype.ParseAsnConfigToModel = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var config = this.GetAsnConfig(hardwareId);

    var names = this.GetAsnNames(hardwareId);

    var configLines = config.split("\n");

    var configModel = {};

    configLines.forEach(function (Line)
    {
        if(Line)
        {
            var parseLine = Helper.ReplaceMultipleWhiteSpacesWithOne(Line).trim().split(" ");

            if(parseLine.length >= 2)
            {
                var key = parseLine[0].trim() + " " + parseLine[1].trim();

                var val = {ip:parseLine[0].trim(), asn:parseLine[1].trim(), asn_name: names[parseLine[1].trim()]};

                configModel[key] = val;
            }
        }

    });

    this.AsnConfigModel[hardwareId] = new AsnConfigModel(Helper.DictToArr(configModel));
};

HardwareAsnDscpConfigManager.prototype.ParseAsnV6ConfigToModel = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var config = this.GetAsnV6Config(hardwareId);

    var configLines = config.split("\n");

    var names = this.GetAsnNames(hardwareId);

    var configModel = {};

    configLines.forEach(function (Line)
    {
        if(Line)
        {
            var parseLine = Helper.ReplaceMultipleWhiteSpacesWithOne(Line).trim().split(" ");

            if(parseLine.length >= 2)
            {
                var key = parseLine[0].trim() + " " + parseLine[1].trim();

                var val = {ip:parseLine[0].trim(), asn:parseLine[1].trim(), asn_name: names[parseLine[1].trim()]};

                configModel[key] = val;
            }
        }

    });
    this.AsnConfigModel[hardwareId].list = this.AsnConfigModel[hardwareId].list.concat(Helper.DictToArr(configModel));
};

HardwareAsnDscpConfigManager.prototype.ParseAsnModelToConfig = function(HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var configModel = this.GetAsnConfigModel(hardwareId);

    var configLines = "";
    var configLinesV6 = "";

    configModel.list.forEach(function (Model)
    {
        if(Helper.ValidateIPv6OrCidr(Model.ip))
        {
            configLinesV6 += Model.ip + " " + Model.asn + "\n";
        }
        else if(Helper.ValidateIPv4OrCidr(Model.ip))
        {
            configLines += Model.ip + " " + Model.asn + "\n";
        }
    });

    this.AsnConfigFile[hardwareId] = configLines;
    this.AsnV6ConfigFile[hardwareId] = configLinesV6;
};

HardwareAsnDscpConfigManager.prototype.SetAsnDscpConfig = function(AsnDscpConfigFile, HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.AsnDscpConfigFile[hardwareId] = AsnDscpConfigFile;

    this.ParseAsnDscpConfigToModel();

    this.SignalAsnDscpFileUpdated.next(1);
};

HardwareAsnDscpConfigManager.prototype.GetAsnDscpConfig = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.AsnDscpConfigFile[hardwareId])
    {
        return this.AsnDscpConfigFile[hardwareId];
    }

    return "";
};

HardwareAsnDscpConfigManager.prototype.SetAsnDscpConfigModel = function(Model, HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    this.AsnDscpConfigModel[hardwareId] = new AsnDscpConfigModel(Model);

    this.ParseAsnDscpModelToConfig();

    this.SignalAsnDscpFileUpdated.next(1);
};

HardwareAsnDscpConfigManager.prototype.GetAsnDscpConfigModel = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.AsnDscpConfigModel[hardwareId])
    {
        return this.AsnDscpConfigModel[hardwareId];
    }

    return new AsnDscpConfigModel();
};

HardwareAsnDscpConfigManager.prototype.ParseAsnDscpConfigToModel = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var config = this.GetAsnDscpConfig(hardwareId);

    var configLines = config.split("\n");

    var names = this.GetAsnNames(hardwareId);

    var configModel = {};

    configLines.forEach(function (Line)
    {
        if(Line)
        {
            var parseLine = Helper.ReplaceMultipleWhiteSpacesWithOne(Line).trim().split(" ");

            if(parseLine.length >= 2)
            {
                var key = parseLine[0].trim() + " " + parseLine[1].trim();

                var val = {asn:parseLine[0].trim(), dscp:parseLine[1].trim(), asn_name: names[parseLine[0].trim()]};

                configModel[key] = val;
            }
        }

    });

    this.AsnDscpConfigModel[hardwareId] = new AsnDscpConfigModel(Helper.DictToArr(configModel));
};

HardwareAsnDscpConfigManager.prototype.ParseAsnDscpModelToConfig = function(HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var configModel = this.GetAsnDscpConfigModel(hardwareId);

    var configLines = "";

    configModel.list.forEach(function (Model)
    {
        configLines += Model.asn + " " + Model.dscp + "\n";
    });

    this.AsnDscpConfigFile[hardwareId] = configLines;
};

HardwareAsnDscpConfigManager.prototype.MakeAllModel = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var asnModel = this.GetAsnConfigModel(hardwareId);
    var dscpModel = this.GetAsnDscpConfigModel(hardwareId);

    var allModel = {};

    asnModel.list.forEach(function (Obj)
    {
        if(!allModel[Obj.asn])
        {
            allModel[Obj.asn] = new AllAsnDscpModel(Obj);
        }

        allModel[Obj.asn].ips_obj.list.push(Obj);
    });

    dscpModel.list.forEach(function (Obj)
    {
        if(!allModel[Obj.asn])
        {
            allModel[Obj.asn] = new AllAsnDscpModel(Obj);
        }

        allModel[Obj.asn].dscps_obj.list.push(Obj);
    });

    this.AllAsnDscpConfigModel[hardwareId] = new AllAsnDscpConfigModel(allModel);

    this.SignalAllUpdated.next(1);
};

HardwareAsnDscpConfigManager.prototype.GetAllModel = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.AllAsnDscpConfigModel[hardwareId])
    {
        return this.AllAsnDscpConfigModel[hardwareId];
    }

    return new AllAsnDscpConfigModel();
};

HardwareAsnDscpConfigManager.prototype.Refresh = function(Params,HardwareId)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"GetAsnDscpConfig",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (result)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(result.success)
                {
                    if(result.data && result.data.asn && result.data.asn.success && result.data.asn.data)
                    {
                        _this.AsnConfigFile[hardwareId] = result.data.asn.data;
                    }
                    else
                    {
                        _this.AsnConfigFile[hardwareId] = "";
                    }

                    if(result.data && result.data.asnv6 && result.data.asnv6.success && result.data.asnv6.data)
                    {
                        _this.AsnV6ConfigFile[hardwareId] = result.data.asnv6.data;
                    }
                    else
                    {
                        _this.AsnV6ConfigFile[hardwareId] = "";
                    }

                    if(result.data && result.data.asn_dscp && result.data.asn_dscp.success && result.data.asn_dscp.data)
                    {
                        _this.AsnDscpConfigFile[hardwareId] = result.data.asn_dscp.data;
                    }
                    else
                    {
                        _this.AsnDscpConfigFile[hardwareId] = "";
                    }

                    if(result.data && result.data.asn_names)
                    {
                        _this.AsnNamesFile[hardwareId] = result.data.asn_names;
                    }
                    else
                    {
                        _this.AsnNamesFile[hardwareId] = {};
                    }

                }
                else
                {
                    _this.AsnConfigFile[hardwareId] = "";
                    _this.AsnV6ConfigFile[hardwareId] = "";
                    _this.AsnDscpConfigFile[hardwareId] = "";
                    _this.AsnNamesFile[hardwareId] = {};
                }

                _this.ParseAsnConfigToModel();
                _this.ParseAsnV6ConfigToModel();
                _this.ParseAsnModelToConfig();
                _this.SignalAsnFileUpdated.next(1);
                _this.SignalAsnV6FileUpdated.next(1);

                _this.ParseAsnDscpConfigToModel();
                _this.ParseAsnDscpModelToConfig();
                _this.SignalAsnDscpFileUpdated.next(1);

                _this.MakeAllModel();

                _this.SignalConfigReady.next(result.success);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("Dics","The asn dscp configuration is loaded"));
                    }
                    else
                    {
                        webix.alert({
                            title: LangHelper.GetString("All", "Error"),
                            text: result.error.msg,
                            type:"alert-error",
                            width:600
                        });
                        // webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareAsnDscpConfigManager.prototype.Save = function(Params,HardwareId)
{
    var _this = this;

    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"SetAsnDscpConfig",
            data:{
                Id:parseInt(hardwareId,10),
                AsnConfig:Params&&Params.asnConfigContents?Params.asnConfigContents:_this.GetAsnConfig(hardwareId),
                AsnDscpConfig:Params&&Params.asnDscpConfigContents?Params.asnDscpConfigContents:_this.GetAsnDscpConfig(hardwareId),
                AsnV6Config: Params&&Params.asnV6ConfigContents?Params.asnV6ConfigContents:_this.GetAsnV6Config(hardwareId)
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        if(R.data && R.data.asn && !R.data.asn.success)
                        {
                            webix.message({type:"error", text:R.data.asn.error.msg});
                        }
                        else if(R.data && R.data.asn_dscp && !R.data.asn_dscp.success)
                        {
                            webix.message({type:"error", text:R.data.asn_dscp.error.msg});
                        }
                        else
                        {
                            webix.message(LangHelper.GetString("Dics","The asn dscp configuration is saved"));
                        }
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

HardwareAsnDscpConfigManager.prototype.HistoryRefresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"GetAsnDscpConfigHistory",
            data:{Id:parseInt(App.SessionManager.GetCurrentHardwareId(),10)},
            callback:function (result)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(result.success && result.data)
                {
                    var data = [];

                    Object.keys(result.data).forEach(function (Key)
                    {
                        var obj = new HardwareConfigHistoryModel({file_id:result.data[Key]});

                        data.push(obj);
                    });

                    _this.History[App.SessionManager.GetCurrentHardwareId()] = data;
                    _this.SignalConfigHistoryUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("Dics","History loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

HardwareAsnDscpConfigManager.prototype.GetHistory = function(HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    if(this.History[hardwareId])
    {
        return this.History[hardwareId];
    }

    return [];
};

HardwareAsnDscpConfigManager.prototype.LoadHistoryFile = function(Params, HardwareId)
{
    var hardwareId = HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"GetAsnDscpConfigFile",
            data:{
                Id:parseInt(hardwareId,10),
                File:Params&&Params.configFile?Params.configFile:""
            },
            callback:function (result)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        }

    App.ServerManager.CallMethod(params);
};
var AdvcModelActionsEnhum = {
    update:"update",
    insert:"insert",
    delete:"delete"
};

function AdvProfileModel(Params)
{
    var __this = this;
    this.id = webix.uid();
    this.profile_id = Params&&Params.profile_id?Params.profile_id:0;
    this.parent_id = Params&&Params.parent_id?Params.parent_id:null;
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:null;
    this.title = Params&&Params.title?Params.title:'';
    this.user_id = Params&&Params.user_id?Params.user_id:null;

    this.data = [];
    if(Params && Params.data)
    {
        Params.data.forEach(
            function (adv)
            {
                __this.data.push(new AdvProfileModel(adv));
            }
        )
    }

    this.valid = true;
    this.open = true;
}

function AdvCompanyModel(Params)
{
    var __this = this;
    this.id = webix.uid();
    this.adc_id = Params&&Params.adc_id?Params.adc_id:0;
    this.profile_id = Params&&Params.profile_id?Params.profile_id:0;
    this.title = Params&&Params.title?Params.title:"";
    this.user_id = Params&&Params.user_id?Params.user_id:0;
    this.from_date = Params&&Params.from_date?Params.from_date:null;
    this.to_date = Params&&Params.to_date?Params.to_date:null;
    this.from_time = Params&&Params.from_time?Params.from_time:null;
    this.to_time = Params&&Params.to_time?Params.to_time:null;
    this.total = Params&&Params.total?parseInt(Params.total):0;
    this.released = Params&&Params.released?parseInt(Params.released):0;
    this.redirect = Params&&Params.redirect?Params.redirect:"";
    this.pack = Params&&Params.pack?Params.pack:0;
    this.days_of_week = Params&&Params.days_of_week?Params.days_of_week:"";
    this.status = Params&&Params.status?Params.status:1;
    this.params = Params&&Params.params?Params.params:'';
    this.enabled = Params&&Params.enabled? parseInt(Params.enabled):0;

    this.valid = true;
};

function AdvCompanyParamModel(Params)
{
    var _this = this;
    this.id = webix.uid();
    this.data_name = Params&&Params.data_name?Params.data_name:"";
    this.data_type = Params&&Params.data_type?Params.data_type:"string";
    this.default_value = Params&&Params.default_value?Params.default_value:"";
}

function AdvCampaignDataModel(Params)
{
    var _this = this;
    this.id = webix.uid();
    this.adc_id = Params&&Params.adc_id?Params.adc_id:0;
    this.login = Params&&Params.login?Params.login:'';
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:null;
    this.params = Params&&Params.params?Params.params:'';
    this.status = Params&&Params.status?Params.status:1;
    this.notification_date = Params&&Params.notification_date?Params.notification_date:null;
}


function AdvcManager(Params)
{
    this.Active = true;

    this.AdvProfiles  = [];

    this.ProfilesTotal = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.ProfilesFilter = {
        title:null
    };

    this.ProfilesSort = {
        id:null,
        dir:null
    };



    this.AdvCompanies = [];

    this.CampaignTotal = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.CampaignFilter = {
        title:null,
        from_to_date: null,
        status: null
    };

    this.CampaignSort = {
        id:null,
        dir:null
    };

    this.AdvCompaniesUpdated = new Rx.BehaviorSubject(0);
    this.AdvProfilesUpdated = new Rx.BehaviorSubject(0);
    // this.AdvCompaniesUpdated = new Rx.BehaviorSubject(0);

    this.CurrentProfileRequestId = null;

    this.CurrentAdvcRequestId = null;

    this.Init();

    return this;
};

AdvcManager.prototype.Init = function(Params)
{
    "use strict";
};

AdvcManager.prototype.Destroy = function ()
{
    this.Active = false;
};

AdvcManager.prototype.Refresh = function(Params)
{
    var _this = this;
    
    this.CurrentProfileRequestId = webix.uid();

    if(Params&&Params.page >= 0)
    {
        this.ProfilesTotal.page = parseInt(Params.page,10);
    }

    if(Params&&Params.filter)
    {
        this.ProfilesFilter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.ProfilesSort = Params.sort;
    }

    var params =
        {
            id: this.CurrentProfileRequestId,
            method: "GetAdvProfiles",
            data:{
                Params: {
                    hardware_id:App.SessionManager.GetCurrentHardwareId(),
                    page:this.ProfilesTotal.page,
                    size:this.ProfilesTotal.size,
                    title:this.ProfilesFilter.title,
                    parent_id_is_null: this.ProfilesFilter.title ? null : true,
                    order_by:this.ProfilesSort.id?this.ProfilesSort.id:null,
                    order_dir:this.ProfilesSort.dir?this.ProfilesSort.dir:null
                }
            },
            callback: function(R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(_this.CurrentProfileRequestId != R.id)
                {
                    return;
                }
                
                if(R.success)
                {
                    var advProfiles = [];
                    _this.ProfilesTotal.page = 0;
                    _this.ProfilesTotal.count = 0;
                    
                    if(R.data)
                    {
                        R.data.rows.forEach(function(ServerAdvProfileModel)
                        {
                            advProfiles.push(new AdvProfileModel(ServerAdvProfileModel));
                        })
                        _this.AdvProfiles = advProfiles;
                        _this.ProfilesTotal.page = parseInt(R.data.page, 10);
                        _this.ProfilesTotal.count = parseInt(R.data.count,10);
                    }
                    
                    _this.AdvProfilesUpdated.next(1);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

AdvcManager.prototype.GetAdvProfiles = function()
{
    return webix.copy(this.AdvProfiles);
};

AdvcManager.prototype.GetAdvProfilesAsDic = function()
{
    var dic = {};

    var list = this.GetAdvProfiles();

    if(list && Array.isArray(list) && list.length)
    {
        list.forEach(function (Item)
        {
            dic[Item.profile_id] = {id:Item.profile_id, value:Item.title};
        });
    }

    return dic;
};

AdvcManager.prototype.GetAdvProfileById = function(Id)
{
    var profile = null;

    this.AdvProfiles.every(function (Item)
    {
        if(Item.profile_id == Id)
            profile = webix.copy(Item);

        return true;
    });

    return profile;
};

AdvcManager.prototype.SetAdvProfiles = function(Data)
{
    return this.AdvProfiles = webix.copy(Data);
};

AdvcManager.prototype.GetAdvCompanies = function()
{
    return webix.copy(this.AdvCompanies);
};

AdvcManager.prototype.GetAdvCampaignsAsDic = function()
{
    var dic = {};

    var list = this.GetAdvCompanies();

    if(list && Array.isArray(list) && list.length)
    {
        list.forEach(function (Item)
        {
            dic[Item.adc_id] = {id:Item.adc_id, value:Item.title};
        });
    }

    return dic;
};

AdvcManager.prototype.GetAdvCampaignById = function(Id)
{
    var campaign = null;

    this.AdvCompanies.every(function (Item)
    {
        if(Item.adc_id == Id)
            campaign = webix.copy(Item);

        return true;
    });

    return campaign;
};

AdvcManager.prototype.SetAdvCompanies = function(Data)
{
    return this.AdvCompanies = webix.copy(Data);
};

AdvcManager.prototype.SaveProfile = function(Params)
{
    var _this = this;

    var profile = new AdvProfileModel(Params && Params.profile ? Params.profile : null);

    var params =
        {
            id: profile.id,
            method: "SaveAdvProfile",
            data:{
                Profile: profile
            },
            callback: function(R)
            {
                if(Params && Params.callback && typeof Params.callback == "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdvcManager.prototype.DeleteProfile = function(Params)
{
    var _this = this;

    var profile = new AdvProfileModel(Params && Params.profile? Params.profile : null);

    var params =
        {
            id:profile.id,
            method: "DeleteAdvProfile",
            data:{
                Profile: profile
            },
            callback:function(R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdvcManager.prototype.RefreshAdvCompanies = function(Params)
{
    var _this = this;

    this.CurrentAdvcRequestId = webix.uid();

    if(Params&&Params.page >= 0)
    {
        this.CampaignTotal.page = parseInt(Params.page,10);
    }

    if(Params&&Params.filter)
    {
        this.CampaignFilter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.CampaignSort = Params.sort;
    }

    var requestParams = {
        profile_ids: Params.profile_ids,
        page:this.CampaignTotal.page,
        size:this.CampaignTotal.size,
        order_by:this.CampaignSort.id?this.CampaignSort.id:null,
        order_dir:this.CampaignSort.dir?this.CampaignSort.dir:null
    };


    if(this.CampaignFilter.days_of_week)
    {
        var days = this.CampaignFilter.days_of_week.split(",").sort();
        this.CampaignFilter.days_of_week = days.join(",");
    }
    for(var prop in this.CampaignFilter)
    {
        if(this.CampaignFilter[prop])
        {
            requestParams[prop] = this.CampaignFilter[prop];
        }
    }

    var params =
        {
            id: this.CurrentAdvcRequestId,
            method: "GetAdvCompanies",
            data:{
                Params: requestParams
            },
            callback: function(R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(_this.CurrentAdvcRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    var advCompanies = [];
                    _this.CampaignTotal.page = 0;
                    _this.CampaignTotal.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function(ServerAdvCompanyModel)
                        {
                            advCompanies.push(new AdvCompanyModel(ServerAdvCompanyModel));
                        });

                        _this.AdvCompanies = advCompanies;
                        _this.CampaignTotal.page = parseInt(R.data.page, 10);
                        _this.CampaignTotal.count = parseInt(R.data.count,10);
                    }
                    _this.AdvCompaniesUpdated.next(1);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

AdvcManager.prototype.SaveCompany = function(Params)
{
    var _this = this;

    var company = new AdvCompanyModel(Params && Params.company ? Params.company : null);

    var params =
        {
            id: company.id,
            method: "SaveAdvCompany",
            data:{
                Company: company
            },
            callback: function(R)
            {
                if(Params && Params.callback && typeof Params.callback == "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdvcManager.prototype.ResetCompany = function(Params)
{
    var _this = this;

    var company = new AdvCompanyModel(Params && Params.company ? Params.company : null);

    var params =
        {
            id: company.id,
            method: "ResetAdvCompany",
            data:{
                Company: company
            },
            callback: function(R)
            {
                if(Params && Params.callback && typeof Params.callback == "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdvcManager.prototype.DeleteCompany = function(Params)
{
    var _this = this;

    var company = new AdvCompanyModel(Params && Params.company? Params.company : null);

    var params =
        {
            id:company.id,
            method: "DeleteAdvCompany",
            data:{
                Company: company
            },
            callback:function(R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdvcManager.prototype.EnableCompany = function(Params)
{
    var _this = this;

    var company = new AdvCompanyModel(Params && Params.company ? Params.company : null);

    var params =
        {
            id: company.id,
            method: "EnableAdvCompany",
            data:{
                Company: company
            },
            callback: function(R)
            {
                if(Params && Params.callback && typeof Params.callback == "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdvcManager.prototype.DisableCompany = function(Params)
{
    var _this = this;

    var company = new AdvCompanyModel(Params && Params.company ? Params.company : null);

    var params =
        {
            id: company.id,
            method: "DisableAdvCompany",
            data:{
                Company: company
            },
            callback: function(R)
            {
                if(Params && Params.callback && typeof Params.callback == "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdvcManager.prototype.ForceSyncCompanies = function(Params)
{
    var params = {
        id: this.CurrentProfileRequestId,
        method: "ForceSyncAdvCompanies",
        data:{
            HardwareId: parseInt(App.SessionManager.GetCurrentHardwareId())
        },
        callback: function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};
function AdvcProcessedSubscriberModel(Params)
{
    var __this = this;
    this.id = webix.uid();
    this.adc_id = Params&&Params.adc_id?Params.adc_id:0;
    this.login = Params&&Params.login?Params.login:null;
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:null;
    this.status = Params&&Params.status?Params.status:1;
    this.params = Params&&Params.params?Params.params:'';
    this.notification_date = Params&&Params.notification_date?Params.notification_date:null;

    if(this.params){
        this.Params = JSON.parse(this.params);
    }
}

function AdvcProcessedSubscribersManager(Params)
{
    this.Active = true;

    this.Subscribers  = [];

    this.Total = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.Filter = {
        title:null
    };

    this.Sort = {
        id:null,
        dir:null
    };

    this.SubscribersUpdated = new Rx.BehaviorSubject(0);

    this.CurrentRequestId = null;

    this.Init();

    return this;
};

AdvcProcessedSubscribersManager.prototype.Init = function(Params)
{
    "use strict";
};

AdvcProcessedSubscribersManager.prototype.Destroy = function ()
{
    this.Active = false;
};

AdvcProcessedSubscribersManager.prototype.Refresh = function(Params)
{
    var _this = this;

    this.CurrentRequestId = webix.uid();

    if(Params&&Params.page >= 0)
    {
        this.Total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.filter)
    {
        this.Filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.Sort = Params.sort;
    }

    var requestParams = {
        hardware_id:App.SessionManager.GetCurrentHardwareId(),
        // adc_id: Params && Params.adc_id? Params.adc_id : 0,
        adc_ids: Params && Params.adc_ids? Params.adc_ids : null,
        page:this.Total.page,
        size:this.Total.size,
        order_by:this.Sort.id?this.Sort.id:null,
        order_dir:this.Sort.dir?this.Sort.dir:null
    };

    requestParams.params = {};
    for(var i in this.Filter)
    {
        if(i.indexOf("param_") < 0)
        {
            requestParams[i] = this.Filter[i];
        }
        else{
            requestParams.params[i.replace("param_","")] = this.Filter[i];
        }
    }

    var params =
        {
            id: this.CurrentRequestId,
            method: "GetAdvProcessedSubscribers",
            data:{
                Params: requestParams
            },
            callback: function(R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(_this.CurrentRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {

                    var subscribers = [];
                    _this.Total.page = 0;
                    _this.Total.count = 0;
                    if(R.data)
                    {
                        R.data.rows.forEach(function(ServerProcessedSubscriberModel)
                        {
                            subscribers.push(new AdvcProcessedSubscriberModel(ServerProcessedSubscriberModel));
                        });

                        _this.Subscribers = subscribers;
                        _this.Total.page = parseInt(R.data.page, 10);
                        _this.Total.count = parseInt(R.data.count,10);
                    }
                    _this.SubscribersUpdated.next(1);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };
    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

AdvcProcessedSubscribersManager.prototype.GetSubscribers = function()
{
    return webix.copy(this.Subscribers);
};

AdvcProcessedSubscribersManager.prototype.SetSubscribers = function(Data)
{
    return this.Subscribers = webix.copy(Data);
};

AdvcProcessedSubscribersManager.prototype.SaveProcessedSubscribers = function(Params)
{
    var _this = this;

    var subscribers = Params && Params.subscribers ? Params.subscribers: null;
    var params = {
        id: webix.uid(),
        method: "SaveAdvProcessedSubscribers",
        data:{
            Subscribers: subscribers
        },
        callback:function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };
    App.ServerManager.CallMethod(params);
};

AdvcProcessedSubscribersManager.prototype.SaveSubscriber = function (Params)
{
    var _this = this;

    var data = {
        NewSubscriber: Params && Params.newSubscriber? Params.newSubscriber : null,
        OldSubscriber: Params && Params.oldSubscriber? Params.oldSubscriber: null
    };

    var params = {
        id: webix.uid(),
        method: "SaveAdvProcessedSubscriber",
        data:data,
        callback:function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };
    App.ServerManager.CallMethod(params);
};

AdvcProcessedSubscribersManager.prototype.DeleteSubscriber = function(Params)
{
    var _this = this;

    var subscriber = new AdvcProcessedSubscriberModel(Params && Params.subscriber? Params.subscriber : null);

    var params =
        {
            id:subscriber.id,
            method: "DeleteAdvProcessedSubscriber",
            data:{
                Subscriber: subscriber
            },
            callback:function(R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdvcProcessedSubscribersManager.prototype.ResetAdvProcessedSubscriber = function (Params)
{
    var _this = this;

    var data = {
        Subscriber: Params && Params.subscriber? Params.subscriber : null
    };

    var params = {
        id: webix.uid(),
        method: "ResetAdvProcessedSubscriber",
        data:data,
        callback:function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };
    App.ServerManager.CallMethod(params);
};
var QoEReportConfigTypeEnum = {
    ServerPredefined:"ServerPredefined",
    ClientPredefined:"ClientPredefined"
};

var QoEReportTablesEnum = {
    ClickstreamRaw:"clickstream",
    ClickstreamRawWithFullflow:"clickstream_from_fullflow",
    ClickstreamAgg:"clickstream_agg",
    Clickstream:"clickstream_report",
    ClickstreamRtt:"clickstream_rtt_report",
    GtpFlowRaw:"gtpflow",
    GtpFlowAgg:"gtpflow_ul_agg",
    FullnetflowRaw:"fullflow",
    FullnetflowAgg:"fullflow_agg",
    Fullnetflow:"fullflow_report",
    FullnetflowMerged:"fullflow_report_merged",
    FullnetflowSubscriber:"fullflow_subscriber_report",
    FullnetflowSubscriberMerged:"fullflow_subscriber_report_merged",
    SubscribersFlow:"subscribers_flow_report",
    AsnumDic:"asnum_dic",
    AsnumLocalDic:"asnum_local_dic",
    AsnumExcludeDic:"asnum_exclude_dic",
    CrcDic:"crc_dic",
    NetProtocolsDic:"net_protocols_dic",
    AppProtocolsDic:"protocols_dic",
    SettingsDic:"settings_dic",
    SubnetsLocalDic:"subnets_local_dic",
    SubnetsExcludeDic:"subnets_exclude_dic",
    SubscribersDic:"subscribers_dic",
    SwitchesDic:"switches_dic",
    UrlcatsDic:"urlcats_dic",
    UrlcatsHostDic:"urlcats_host_dic",
    VchannelsNamesDic:"ulr_vchannel_name_dic",
    GtpCellsLocationsDic: "gtp_cells_locations_dic",
    GtpCellsLocationsExtendedDic: "gtp_cells_locations_extended_dic",
    GtpCountryDic: "gtp_mcc_dic",
    GtpNetworkDic: "gtp_mnc_dic",
    UplinkLoadRateDic: "uplink_importance_criteria_dic",
    NatFlowRaw:"natflow",
    NatFlowAgg:"natflow_agg",
    DnsFlowRaw:"dnsflow",
    DnsFlowAgg:"dnsflow_agg",
    DdosAttackFlowRaw:"fm_attacks",
    DdosAttackFlowAgg:"fm_attacks_agg",
    PrtclsWithGroupsDic: "protocols_with_groups_dic",
    PrtclsGroupsDic: "protocols_groups_dic",
    System:{
        Parts:"parts",
        Dictionaries:"dictionaries",
        Tables:"tables",
        Processes:"processes"
    }
};

QoEOnlineViewsPrefixesEnum = {
    OnlineNetflow: "subscribers_online_flow_agg_"
}

var QoEReportTplsFunctions =
    {
        AvgTrafficSpeedBitsPerSecond_Func:function (ForChartSerie)
        {
            var tpl1 = "maxMerge(flow_end_millisecond_max)", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumMerge(octet_delta_count_sum)),toUInt64("+tpl+"-minMerge(flow_start_millisecond_min))/8000)";
        },
        AvgTrafficSpeedBitsPerSecondIf_Func:function (ForChartSerie)
        {
            var tpl1 = "maxMergeIf(flow_end_millisecond_max, {condition})", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumMergeIf(octet_delta_count_sum, {condition})),toUInt64("+tpl+"-minMergeIf(flow_start_millisecond_min, {condition}))/8000)";
        },
        AvgTrafficSpeedFromSubsBitsPerSecond_Func:function (ForChartSerie)
        {
            var tpl1 = "maxIfMerge(flow_end_millisecond_from_subscriber_max_if)", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumIfMerge(octet_delta_count_from_subscriber_sum_if)),toUInt64("+tpl+"-minIfMerge(flow_start_millisecond_from_subscriber_min_if))/8000)";
        },
        AvgTrafficSpeedFromSubsBitsPerSecondIf_Func:function (ForChartSerie)
        {
            var tpl1 = "maxMergeIf(flow_end_millisecond_max, (from_subscriber = 1) and ({condition}))", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumMergeIf(octet_delta_count_sum, (from_subscriber = 1) and ({condition}) )),toUInt64("+tpl+"-minMergeIf(flow_start_millisecond_min, (from_subscriber = 1) and ({condition})))/8000)";
        },
        AvgTrafficSpeedToSubsBitsPerSecond_Func:function (ForChartSerie)
        {
            var tpl1 = "maxIfMerge(flow_end_millisecond_to_subscriber_max_if)", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumIfMerge(octet_delta_count_to_subscriber_sum_if)),toUInt64("+tpl+"-minIfMerge(flow_start_millisecond_to_subscriber_min_if))/8000)";
        },
        AvgTrafficSpeedToSubsBitsPerSecondIf_Func:function (ForChartSerie)
        {
            var tpl1 = "maxMergeIf(flow_end_millisecond_max, (from_subscriber = 0) and ({condition}))", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumMergeIf(octet_delta_count_sum, (from_subscriber = 0) and ({condition}) )),toUInt64("+tpl+"-minMergeIf(flow_start_millisecond_min, (from_subscriber = 0) and ({condition})))/8000)";

        },

        AvgTrafficSpeedPktsPerSecond_Func: function (ForChartSerie)
        {
            var tpl1 = "maxMerge(flow_end_millisecond_max)", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;
            
            return "intDivOrZero(toUInt64(sumMerge(packet_delta_count_sum)*1000),toUInt64("+tpl+"-minMerge(flow_start_millisecond_min)))";
        },

        AvgTrafficSpeedPktsPerSecondIf_Func:function (ForChartSerie)
        {
            var tpl1 = "maxMergeIf(flow_end_millisecond_max, {condition})", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumMergeIf(packet_delta_count_sum, {condition})*1000),toUInt64("+tpl+"-minMergeIf(flow_start_millisecond_min, {condition})))";
        },

        AvgTrafficSpeedFromSubsPktsPerSecond_Func:function (ForChartSerie)
        {
            var tpl1 = "maxIfMerge(flow_end_millisecond_from_subscriber_max_if)", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumIfMerge(packet_delta_count_from_subscriber_sum_if)*1000),toUInt64("+tpl+"-minIfMerge(flow_start_millisecond_from_subscriber_min_if)))";
        },

        AvgTrafficSpeedFromSubsPktsPerSecondIf_Func:function (ForChartSerie)
        {
            var tpl1 = "maxMergeIf(flow_end_millisecond_max, (from_subscriber = 1) and ({condition}))", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumMergeIf(packet_delta_count_sum, (from_subscriber = 1) and ({condition}))*1000),toUInt64("+tpl+"-minMergeIf(flow_start_millisecond_min, (from_subscriber = 1) and ({condition}))))";
        },

        AvgTrafficSpeedToSubsPktsPerSecond_Func:function (ForChartSerie)
        {
            var tpl1 = "maxIfMerge(flow_end_millisecond_to_subscriber_max_if)", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return "intDivOrZero(toUInt64(sumIfMerge(packet_delta_count_to_subscriber_sum_if)*1000),toUInt64("+tpl+"-minIfMerge(flow_start_millisecond_to_subscriber_min_if)))";
        },

        AvgTrafficSpeedToSubsPktsPerSecondIf_Func:function (ForChartSerie) {
            var tpl1 = "maxMergeIf(flow_end_millisecond_max, (from_subscriber = 0) and ({condition}))",
                tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            var tpl = ForChartSerie ? "(" + tpl1 + "<=" + tpl2 + "?" + tpl1 + ":" + tpl2 + ")" : tpl1;

            return "intDivOrZero(toUInt64(sumMergeIf(packet_delta_count_sum, (from_subscriber = 0) and ({condition}))*1000),toUInt64(" + tpl + "-minMergeIf(flow_start_millisecond_min, (from_subscriber = 0) and ({condition}))))";
        },

        DdosAvgTrafficSpeedBitsPerSecond_Func:function (IsDropped= false, IsChart= false)
        {
            let field = IsDropped ? "octets_dropped_sum" : "octets_sum"

            let tpl1 = "maxMerge(end_millisecond_max)", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            let tpl = IsChart ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return `intDivOrZero(toUInt64(sumMerge(${field})), toUInt64(${tpl} - minMerge(start_millisecond_min)) / 8000)`;
        },

        DdosAvgTrafficSpeedBitsPerSecondIf_Func:function (IsDropped= false, IsChart= false)
        {
            let field = IsDropped ? "octets_dropped_sum" : "octets_sum"

            let tpl1 = "maxMergeIf(end_millisecond_max, {condition})", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            let tpl = IsChart ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return `intDivOrZero(toUInt64(sumMergeIf(${field}, {condition})), toUInt64(${tpl} - minMergeIf(start_millisecond_min, {condition})) / 8000)`;

        },

        DdosAvgTrafficSpeedPktsPerSecond_Func:function (IsDropped= false, IsChart= false)
        {
            let field = IsDropped ? "packets_dropped_sum" : "packets_sum"

            let tpl1 = "maxMerge(end_millisecond_max)", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            let tpl = IsChart ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return `intDivOrZero(toUInt64(sumMerge(${field})) * 1000, toUInt64(${tpl} - minMerge(start_millisecond_min)))`;
        },

        DdosAvgTrafficSpeedPktsPerSecondIf_Func:function (IsDropped= false, IsChart= false)
        {
            let field = IsDropped ? "packets_dropped_sum" : "packets_sum"

            let tpl1 = "maxMergeIf(end_millisecond_max, {condition})", tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

            let tpl = IsChart ? "("+tpl1+"<="+tpl2+"?"+tpl1+":"+tpl2+")" : tpl1;

            return `intDivOrZero(toUInt64(sumMergeIf(${field}, {condition})) * 1000, toUInt64(${tpl} - minMergeIf(start_millisecond_min, {condition})))`;
        },

        GrowthRateIf_Func:function(Field = "subscriber")
        {
            const uniqExpr = `uniqIf(${Field}, {condition})`;
            const lagExpr = `lagInFrame(${uniqExpr}, 1, 0) over (order by time_step)`;

            return `if(${lagExpr} > 0, round(((${uniqExpr}) * 1.0 / (${lagExpr}) - 1) * 100, 2), 0)`;
        }
    };

var QoEReportFunctions =
    {
        Total:"countMerge(total_count)",

        SessionsUniq:"uniqMerge(session_id_uniq)",
        SessionsUniqIf:"uniqMergeIf(session_id_uniq, {condition})",

        LoginsUniq: "uniq(login)",
        LoginsUniqIf:"uniqIf(login, {condition})",

        SubscribersUniq: "uniq(subscriber)",
        SubscribersUniqIf: "uniqIf(subscriber, {condition})",

        ProtocolsUniq:"uniq(protocol)",
        ProtocolsUniqIf:"uniqIf(protocol, {condition})",

        ProtocolsGroupUniq:"uniq(app_protocol_group_id)",
        ProtocolsGroupUniqIf:"uniqIf(app_protocol_group_id, {condition})",

        AvgTrafficSpeedBitsPerSecond: QoEReportTplsFunctions.AvgTrafficSpeedBitsPerSecond_Func(),
        AvgTrafficSpeedBitsPerSecondIf: QoEReportTplsFunctions.AvgTrafficSpeedBitsPerSecondIf_Func(),
        AvgTrafficSpeedFromSubsBitsPerSecond: QoEReportTplsFunctions.AvgTrafficSpeedFromSubsBitsPerSecond_Func(),
        AvgTrafficSpeedToSubsBitsPerSecond: QoEReportTplsFunctions.AvgTrafficSpeedToSubsBitsPerSecond_Func(),

        AvgTrafficSpeedBitsPerSecond_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedBitsPerSecond_Func(true),
        AvgTrafficSpeedBitsPerSecondIf_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedBitsPerSecondIf_Func(true),
        AvgTrafficSpeedFromSubsBitsPerSecond_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedFromSubsBitsPerSecond_Func(true),
        AvgTrafficSpeedFromSubsBitsPerSecondIf_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedFromSubsBitsPerSecondIf_Func(true),
        AvgTrafficSpeedToSubsBitsPerSecond_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedToSubsBitsPerSecond_Func(true),
        AvgTrafficSpeedToSubsBitsPerSecondIf_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedToSubsBitsPerSecondIf_Func(true),

        AvgTrafficSpeedPktsPerSecond: QoEReportTplsFunctions.AvgTrafficSpeedPktsPerSecond_Func(),
        AvgTrafficSpeedPktsPerSecondIf: QoEReportTplsFunctions.AvgTrafficSpeedPktsPerSecondIf_Func(),
        AvgTrafficSpeedFromSubsPktsPerSecond: QoEReportTplsFunctions.AvgTrafficSpeedFromSubsPktsPerSecond_Func(),
        AvgTrafficSpeedToSubsPktsPerSecond: QoEReportTplsFunctions.AvgTrafficSpeedToSubsPktsPerSecond_Func(),

        AvgTrafficSpeedPktsPerSecond_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedPktsPerSecond_Func(true),
        AvgTrafficSpeedPktsPerSecondIf_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedPktsPerSecondIf_Func(true),
        AvgTrafficSpeedFromSubsPktsPerSecond_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedFromSubsPktsPerSecond_Func(true),
        AvgTrafficSpeedFromSubsPktsPerSecondIf_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedFromSubsPktsPerSecondIf_Func(true),
        AvgTrafficSpeedToSubsPktsPerSecond_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedToSubsPktsPerSecond_Func(true),
        AvgTrafficSpeedToSubsPktsPerSecondIf_ForChartSerie: QoEReportTplsFunctions.AvgTrafficSpeedToSubsPktsPerSecondIf_Func(true),

        TrafficVoumeBytes: "sumMerge(octet_delta_count_sum)",
        TrafficVoumeBytesIf: "sumMergeIf(octet_delta_count_sum, {condition})",
        TrafficVoumeFromSubsBytes: "sumIfMerge(octet_delta_count_from_subscriber_sum_if)",
        TrafficVoumeFromSubsBytesIf: "sumMergeIf(octet_delta_count_sum, (from_subscriber = 1) and ({condition}))",
        TrafficVoumeToSubsBytes: "sumIfMerge(octet_delta_count_to_subscriber_sum_if)",
        TrafficVoumeToSubsBytesIf: "sumMergeIf(octet_delta_count_sum, (from_subscriber = 0) and ({condition}))",

        AvgRetransmitsRate:"isNaN(round(avgIfMerge(retransmits_rate_avg_if)*100,2)) == 1 ? 0 : round(avgIfMerge(retransmits_rate_avg_if)*100,2)",
        AvgRetransmitsRateFromSubs:"isNaN(round(avgIfMerge(retransmits_rate_from_subscriber_avg_if)*100,2)) == 1 ? 0 : round(avgIfMerge(retransmits_rate_from_subscriber_avg_if)*100,2)",
        AvgRetransmitsRateToSubs:"isNaN(round(avgIfMerge(retransmits_rate_to_subscriber_avg_if)*100,2)) == 1 ? 0 : round(avgIfMerge(retransmits_rate_to_subscriber_avg_if)*100,2)",

        RawAvgTrafficSpeedBitsPerSecond: "intDivOrZero(toUInt64(sum(octet_delta_count)),toUInt64(max(flow_end_millisecond)-min(flow_start_millisecond))/8000)",
        RawAvgTrafficSpeedBitsPerSecondIf: "intDivOrZero(toUInt64(sumIf(octet_delta_count_sum, {condition})),toUInt64(maxIf(flow_end_millisecond, {condition})-minIf(flow_start_millisecond, {condition}))/8000)",
        RawAvgTrafficSpeedFromSubsBitsPerSecond: "intDivOrZero(toUInt64(sumIf(octet_delta_count,from_subscriber == 1)),toUInt64(maxIf(flow_end_millisecond,from_subscriber == 1)-minIf(flow_start_millisecond,from_subscriber == 1))/8000)",
        RawAvgTrafficSpeedToSubsBitsPerSecond: "intDivOrZero(toUInt64(sumIf(octet_delta_count,from_subscriber == 0)),toUInt64(maxIf(flow_end_millisecond,from_subscriber == 0)-minIf(flow_start_millisecond,from_subscriber == 0))/8000)",

        RawTrafficVoumeBytes: "sum(octet_delta_count)",
        RawTrafficVoumeBytesIf: "sumIf(octet_delta_count, {condition})",
        RawTrafficVoumeFromSubsBytes: "sumIf(octet_delta_count, from_subscriber == 1)",
        RawTrafficVoumeFromSubsBytesIf: "sumIf(octet_delta_count, {condition} and from_subscriber == 1)",
        RawTrafficVoumeToSubsBytes: "sumIf(octet_delta_count, from_subscriber == 0)",
        RawTrafficVoumeToSubsBytesIf: "sumIf(octet_delta_count, {condition} and from_subscriber == 0)",

        RawAvgTrafficSpeedPktsPerSecond: "intDivOrZero(toUInt64(sum(packet_delta_count)*1000),toUInt64(max(flow_end_millisecond)-min(flow_start_millisecond)))",
        RawAvgTrafficSpeedPktsPerSecondIf: "intDivOrZero(toUInt64(sumIf(packet_delta_count, {condition})*1000),toUInt64(maxIf(flow_end_millisecond, {condition})-minIf(flow_start_millisecond, {condition})))",
        RawAvgTrafficSpeedFromSubsPktsPerSecond: "intDivOrZero(toUInt64(sumIf(packet_delta_count,from_subscriber == 1)*1000),toUInt64(maxIf(flow_end_millisecond,from_subscriber == 1)-minIf(flow_start_millisecond,from_subscriber == 1)))",
        RawAvgTrafficSpeedToSubsPktsPerSecond: "intDivOrZero(toUInt64(sumIf(packet_delta_count,from_subscriber == 0)*1000),toUInt64(maxIf(flow_end_millisecond,from_subscriber == 0)-minIf(flow_start_millisecond,from_subscriber == 0)))",

        RawTrafficVoumePkts: "sum(packet_delta_count)",
        RawTrafficVoumePktsIf: "sumIf(packet_delta_count, {condition})",
        RawTrafficVoumeFromSubsPkts: "sumIf(packet_delta_count, from_subscriber == 1)",
        RawTrafficVoumeToSubsPkts: "sumIf(packet_delta_count, from_subscriber == 0)",

        RawClickstreamAvgTrafficSpeedBitsPerSecond: "intDivOrZero(toUInt64(traffic_vol),toUInt64(time_max-time_min)/8000)",
        RawClickstreamAvgTrafficSpeedFromSubsBitsPerSecond: "intDivOrZero(toUInt64(traffic_vol_from_subscriber),toUInt64(time_max_from_subscriber-time_min_from_subscriber)/8000)",
        RawClickstreamAvgTrafficSpeedToSubsBitsPerSecond: "intDivOrZero(toUInt64(traffic_vol_to_subscriber),toUInt64(time_max_to_subscriber-time_min_to_subscriber)/8000)",

        RawClickstreamAvgTrafficSpeedPkts: "intDivOrZero(toUInt64(flow_vol),toUInt64(time_max-time_min)/8000)",
        RawClickstreamAvgTrafficSpeedFromSubsPkts: "intDivOrZero(toUInt64(flow_vol_from_subscriber),toUInt64(time_max_from_subscriber-time_min_from_subscriber)/8000)",
        RawClickstreamAvgTrafficSpeedToSubsPkts: "intDivOrZero(toUInt64(flow_vol_to_subscriber),toUInt64(time_max_to_subscriber-time_min_to_subscriber)/8000)",

        ClickstreamAvgTrafficSpeedBitsPerSecond: "intDivOrZero(toUInt64(sumMerge(octet_delta_count_sum)),toUInt64(maxMerge(flow_end_millisecond_max)-minMerge(flow_start_millisecond_min))/8000)",
        ClickstreamAvgTrafficSpeedFromSubsBitsPerSecond: "intDivOrZero(toUInt64(sumMerge(octet_delta_count_from_subscriber_sum)),toUInt64(maxMerge(flow_end_millisecond_from_subscriber_max)-minMerge(flow_start_millisecond_from_subscriber_min))/8000)",
        ClickstreamAvgTrafficSpeedToSubsBitsPerSecond: "intDivOrZero(toUInt64(sumMerge(octet_delta_count_to_subscriber_sum)),toUInt64(maxMerge(flow_end_millisecond_to_subscriber_max)-minMerge(flow_start_millisecond_to_subscriber_min))/8000)",

        ClickstreamAvgTrafficSpeedPkts: "intDivOrZero(toUInt64(sumMerge(packet_delta_count_sum)),toUInt64(maxMerge(flow_end_millisecond_max)-minMerge(flow_start_millisecond_min))/8000)",
        ClickstreamAvgTrafficSpeedFromSubsPkts: "intDivOrZero(toUInt64(sumMerge(packet_delta_count_from_subscriber_sum)),toUInt64(maxMerge(flow_end_millisecond_from_subscriber_max)-minMerge(flow_start_millisecond_from_subscriber_min))/8000)",
        ClickstreamAvgTrafficSpeedToSubsPkts: "intDivOrZero(toUInt64(sumMerge(packet_delta_count_to_subscriber_sum)),toUInt64(maxMerge(flow_end_millisecond_to_subscriber_max)-minMerge(flow_start_millisecond_to_subscriber_min))/8000)",

        VchannelGetDic:"dictGetStringOrDefault('ulr_vchannel_name_dic', 'name', tuple(dpi_id,bridge_vchannel_num), toString(bridge_vchannel_num))",

        //Использована uniqOrDefault вместо uniq, т.к. SQL оптимизатор скрючивает, если 2 одинаковые функции в строке
        VoipProtocolsSubscribersUniq: "ifNull(uniqOrDefault(subscriber) + uniq(host_ip), 0)",
        //Использована uniqOrDefault вместо uniq, т.к. SQL оптимизатор скрючивает, если 2 одинаковые функции в строке
        VoipProtocolsSubscribersUniqIf: "ifNull(uniqOrDefaultIf(subscriber, {condition}) + uniqIf(host_ip, {condition}), 0)",

        VoipProtocolsCallsUniq: "uniqMerge(session_id_uniq)",
        VoipProtocolsCallsUniqIf: "ifNull(uniqMergeIf(session_id_uniq, {condition}), 0)",

        VoipProtocolsCallDurationPerMinutes: "ifNull(intDivOrZero(intDivOrZero(sumMerge(duration_sum), 2), 60000), 0)",
        VoipProtocolsCallDurationPerMinutesIf: "ifNull(intDivOrZero(intDivOrZero(sumMergeIf(duration_sum, {condition}), 2), 60000), 0)",

        //т.к. SQL оптимизатор скрючивает, если 2 одинаковые функции в строке. то же round(ifNull((sumMerge(octets_dropped_sum) / nullIf(sumMerge(octets_sum) + sumMerge(octets_dropped_sum), 0) * 100), 0), 2)
        DdosAttackMitigationPercent: "round(ifNull(divide(100, (1 + divide(sumMerge(octets_sum), nullIf(sumMergeIf(octets_dropped_sum, finalizeAggregation(octets_dropped_sum) != 0), 0)))), 0), 2)",

        // for tables
        DdosAvgTrafficSpeedBitsPerSecond: QoEReportTplsFunctions.DdosAvgTrafficSpeedBitsPerSecond_Func(),
        DdosAvgTrafficSpeedPktsPerSecond: QoEReportTplsFunctions.DdosAvgTrafficSpeedPktsPerSecond_Func(),
        // for charts
        DdosAvgTrafficSpeedBitsPerSecondChartSerie: QoEReportTplsFunctions.DdosAvgTrafficSpeedBitsPerSecond_Func(false, true),
        DdosAvgTrafficSpeedBitsPerSecondIfChartSerie: QoEReportTplsFunctions.DdosAvgTrafficSpeedBitsPerSecondIf_Func(false, true),

        DdosAttackerCountryCode: "if(isIPv4String(src_ip), dictGetStringOrDefault('geo_ip_dic', 'country_code', toIPv4(src_ip), 'Unknown'), dictGetStringOrDefault('geo_ip_dic', 'country_code', toIPv6(src_ip), 'Unknown'))",
        DdosAttackerState: "if(isIPv4String(src_ip), dictGetStringOrDefault('geo_ip_dic', 'state', toIPv4(src_ip), 'Unknown'), dictGetStringOrDefault('geo_ip_dic', 'state', toIPv6(src_ip), 'Unknown'))",
        DdosAttackerCity: "if(isIPv4String(src_ip), dictGetStringOrDefault('geo_ip_dic', 'city', toIPv4(src_ip), 'Unknown'), dictGetStringOrDefault('geo_ip_dic', 'city', toIPv6(src_ip), 'Unknown'))",
        DdosAttackerLatitude: "round(if(isIPv4String(src_ip), dictGetFloat64OrDefault('geo_ip_dic', 'latitude', toIPv4(src_ip), 0), dictGetFloat64OrDefault('geo_ip_dic', 'latitude', toIPv6(src_ip), 0)), 5)",
        DdosAttackerLongitude: "round(if(isIPv4String(src_ip), dictGetFloat64OrDefault('geo_ip_dic', 'longitude', toIPv4(src_ip), 0), dictGetFloat64OrDefault('geo_ip_dic', 'longitude', toIPv6(src_ip), 0)), 5)",

        SubscribersUniqGrowthRate:"if(first_interval_logins_uniq = 0 and last_interval_logins_uniq = 0, 0, if(first_interval_logins_uniq = 0, 100, round((last_interval_logins_uniq / first_interval_logins_uniq - 1) * 100, 2)))",
        LoginsUniqGrowthRate:"if(first_interval_subscribers_uniq = 0 and last_interval_subscribers_uniq = 0, 0, if(first_interval_subscribers_uniq = 0, 100, round((last_interval_subscribers_uniq / first_interval_subscribers_uniq - 1) * 100, 2)))",
        SubscribersUniqGrowthRateIf: QoEReportTplsFunctions.GrowthRateIf_Func("subscriber"),
        LoginsUniqGrowthRateIf: QoEReportTplsFunctions.GrowthRateIf_Func("login"),

        DurationSumInMinutes: "ifNull(intDivOrZero(sumMerge(duration_sum), 60000), 0)",
        DurationSumInMinutesIf: "ifNull(intDivOrZero(sumMergeIf(duration_sum, {condition}), 60000), 0)"
    };

// using aliases time_1 and time_2 to hack qoe optimizer
var QoEReportCustomAggLogsTpls = {
    VolumeFrom:"sumIfMerge(octet_delta_count_from_subscriber_sum_if)",
    VolumeTo: "sumIfMerge(octet_delta_count_to_subscriber_sum_if)",
    MinTimeMillisecond: "toUnixTimestamp(min(time_1)) * 1000",
    MaxTimeMillisecond: "toUnixTimestamp(max(time_2)) * 1000",
    VolumeFromIf:"sumIfMergeIf(octet_delta_count_from_subscriber_sum_if, {condition})",
    VolumeToIf: "sumIfMergeIf(octet_delta_count_to_subscriber_sum_if, {condition})",
    MinTimeMillisecondIf: "toUnixTimestamp(minIf(time_1, {condition})) * 1000",
    MaxTimeMillisecondIf: "toUnixTimestamp(maxIf(time_2, {condition})) * 1000",

    PrevTrafficVol: "lagInFrame(traffic_vol) over (order by quarter)",
    PrevTrafficVolFrom: "lagInFrame(traffic_vol_from_subscriber) over (order by quarter)",
    PrevTrafficVolTo: "lagInFrame(traffic_vol_to_subscriber) over (order by quarter)",

    PrevTrafficVolFromInline: "lagInFrame(sumIfMerge(octet_delta_count_from_subscriber_sum_if)) over (order by quarter_step)",
    PrevTrafficVolToInline: "lagInFrame(sumIfMerge(octet_delta_count_to_subscriber_sum_if)) over (order by quarter_step)"
};

var QoEReportCustomAggLogsTplsFunctions = {
        TrafficSpeedBitsPerSecond_Func: function (Direction, IsChartSerie, WithCondition) {
            let volumeFromTpl = WithCondition ? QoEReportCustomAggLogsTpls.VolumeFromIf : QoEReportCustomAggLogsTpls.VolumeFrom;
            let volumeToTpl = WithCondition ? QoEReportCustomAggLogsTpls.VolumeToIf : QoEReportCustomAggLogsTpls.VolumeTo;
            let startTimeTpl = WithCondition ? QoEReportCustomAggLogsTpls.MinTimeMillisecondIf : QoEReportCustomAggLogsTpls.MinTimeMillisecond;
            let endTimeTpl = WithCondition ? QoEReportCustomAggLogsTpls.MaxTimeMillisecondIf : QoEReportCustomAggLogsTpls.MaxTimeMillisecond;

            let volumeTpl = `${volumeFromTpl} + ${volumeToTpl}`;

            if(Direction === "from")
                volumeTpl = volumeFromTpl;

            if(Direction === "to")
                volumeTpl = volumeToTpl;

            if(IsChartSerie) {
                const tpl1 = endTimeTpl;
                const tpl2 = "(toUnixTimestamp(time_step)+{var_time_step})*1000";

                endTimeTpl = `(${tpl1} <= ${tpl2} ? ${tpl1} : ${tpl2})`;
            }

            return `intDivOrZero(toUInt64(${volumeTpl}), toUInt64(${endTimeTpl} - ${startTimeTpl}) / 8000)`;
        },

        TrafficVolumeBytes_func: function (Direction, WithCondition) {
            let volumeFromTpl = WithCondition ? QoEReportCustomAggLogsTpls.VolumeFromIf : QoEReportCustomAggLogsTpls.VolumeFrom;
            let volumeToTpl = WithCondition ? QoEReportCustomAggLogsTpls.VolumeToIf : QoEReportCustomAggLogsTpls.VolumeTo;

            let volumeTpl = `${volumeFromTpl} + ${volumeToTpl}`

            if(Direction === "from")
                volumeTpl = volumeFromTpl;

            if(Direction === "to")
                volumeTpl = volumeToTpl;

            return volumeTpl;
        },

        PrevTrafficVolumeBytes_func: function (Direction) {
            let volumeFromTpl = QoEReportCustomAggLogsTpls.PrevTrafficVolFromInline;
            let volumeToTpl = QoEReportCustomAggLogsTpls.PrevTrafficVolToInline;

            let volumeTpl = `${volumeFromTpl} + ${volumeToTpl}`

            if(Direction === "from")
                volumeTpl = volumeFromTpl;

            if(Direction === "to")
                volumeTpl = volumeToTpl;

            return volumeTpl;
        }
};

var QoEReportFunctionsCustomAggLogsSet_1 = {
    TrafficSpeedBitsPerSecond: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func(),
    TrafficSpeedBitsPerSecondFromSubscriber: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func("from"),
    TrafficSpeedBitsPerSecondToSubscriber: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func("to"),

    TrafficSpeedBitsPerSecondIf: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func(null, null, true),
    TrafficSpeedBitsPerSecondFromSubscriberIf: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func("from", null, true),
    TrafficSpeedBitsPerSecondToSubscriberIf: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func("to", null, true),

    TrafficSpeedBitsPerSecond_ForChartSerie: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func(null, true),
    TrafficSpeedBitsPerSecondFromSubscriber_ForChartSerie: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func("from", true),
    TrafficSpeedBitsPerSecondToSubscriber_ForChartSerie: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func("to", true),

    TrafficSpeedBitsPerSecondIf_ForChartSerie: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func(null, true, true),
    TrafficSpeedBitsPerSecondFromSubscriberIf_ForChartSerie: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func("from", true, true),
    TrafficSpeedBitsPerSecondToSubscriberIf_ForChartSerie: QoEReportCustomAggLogsTplsFunctions.TrafficSpeedBitsPerSecond_Func("to", true, true),

    TrafficVolumeBytes: QoEReportCustomAggLogsTplsFunctions.TrafficVolumeBytes_func(),
    TrafficVolumeBytesFromSubscriber: QoEReportCustomAggLogsTplsFunctions.TrafficVolumeBytes_func("from"),
    TrafficVolumeBytesToSubscriber: QoEReportCustomAggLogsTplsFunctions.TrafficVolumeBytes_func("to"),

    TrafficVolumeBytesIf: QoEReportCustomAggLogsTplsFunctions.TrafficVolumeBytes_func(null, true),
    TrafficVolumeBytesFromSubscriberIf: QoEReportCustomAggLogsTplsFunctions.TrafficVolumeBytes_func("from", true),
    TrafficVolumeBytesToSubscriberIf: QoEReportCustomAggLogsTplsFunctions.TrafficVolumeBytes_func("to", true)
};

var QoEReportFunctionsCustomAggLogsSet_2 = {
    VoipProtocolsSubscribersUniq: "uniqMerge(subscribers_uniq) + uniqMerge(hosts_uniq)",
    VoipProtocolsCallsUniq: "uniqMerge(session_id_uniq)",
    VoipProtocolsCallDurationPerMinutes: "intDiv(intDiv(sumMerge(duration_sum), 2), 60000)",
};

var QoEReportFunctionsCustomAggLogsSet_3 = {
    TrafficVolGrowthRate: `round(ifNull((traffic_vol - ${QoEReportCustomAggLogsTpls.PrevTrafficVol}) / nullIf(${QoEReportCustomAggLogsTpls.PrevTrafficVol}, 0) * 100, 0), 0)`,
    TrafficVolGrowthRateFrom: `round(ifNull((traffic_vol_from_subscriber - ${QoEReportCustomAggLogsTpls.PrevTrafficVolFrom}) / nullIf(${QoEReportCustomAggLogsTpls.PrevTrafficVolFrom}, 0) * 100, 0), 0)`,
    TrafficVolGrowthRateTo: `round(ifNull((traffic_vol_to_subscriber - ${QoEReportCustomAggLogsTpls.PrevTrafficVolTo}) / nullIf(${QoEReportCustomAggLogsTpls.PrevTrafficVolTo}, 0) * 100, 0), 0)`,

    TrafficVolGrowthRateInline: `round(ifNull(((${QoEReportCustomAggLogsTplsFunctions.TrafficVolumeBytes_func()}) - (${QoEReportCustomAggLogsTplsFunctions.PrevTrafficVolumeBytes_func()})) / nullIf(${QoEReportCustomAggLogsTplsFunctions.PrevTrafficVolumeBytes_func()}, 0) * 100, 0), 0)`,
    TrafficVolGrowthRateFromInline: `round(ifNull((${QoEReportCustomAggLogsTplsFunctions.TrafficVolumeBytes_func("from")} - ${QoEReportCustomAggLogsTplsFunctions.PrevTrafficVolumeBytes_func("from")}) / nullIf(${QoEReportCustomAggLogsTplsFunctions.PrevTrafficVolumeBytes_func("from")}, 0) * 100, 0), 0)`,
    TrafficVolGrowthRateToInline: `round(ifNull((${QoEReportCustomAggLogsTplsFunctions.TrafficVolumeBytes_func("to")} - ${QoEReportCustomAggLogsTplsFunctions.PrevTrafficVolumeBytes_func("to")}) / nullIf(${QoEReportCustomAggLogsTplsFunctions.PrevTrafficVolumeBytes_func("to")}, 0) * 100, 0), 0)`
};

var QoEReportViews =
    {
        ClickStream:
            {
                values:[
                    "time",
                    "subscriber",
                    "subscriber_login",
                    "from_subscriber",
                    "login",
                    "host",
                    "host_ip",
                    "device",
                    "referal",
                    "user_agent",
                    "cookie",
                    "method",
                    "result_code",
                    "content_type",
                    "total_count",
                    "session_id_uniq",
                    "content_length_avg",
                    {col:"", alias:"host_other", func:"empty(host) ? 'Unknown' : replaceOne(host, '*', 'www')"},
                    {col:"", alias:"device_other", func:"empty(device) ? 'Unknown' : device"},
                    {col:"", alias:"user_agent_other", func:"empty(user_agent) ? 'Unknown' : user_agent"},
                    {col:"", alias:"url", func:"empty(referal) ? 'Unknown' : referal"},
                    //{col:"", alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_other), toUInt64(0))"},
                    // {col:"", alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_other), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(replaceOne(host_other, 'www.', '')), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(concat('www.',host_other)), toUInt64(0))))"},
                    {col:"", alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_other), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(replaceOne(host_other, 'www.', '')), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(concat('www.',host_other)), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_ip), toUInt64(0)))))"},
                    {col:"", alias:"host_category_code", func:"dictGetStringOrDefault('urlcats_dic', 'description', toUInt64(host_category), 'Unknown')"},

                    {col:"octet_delta_count_from_subscriber_sum"},
                    {col:"octet_delta_count_to_subscriber_sum"},
                    {col:"octet_delta_count_sum"},

                    {col:"packet_delta_count_from_subscriber_sum"},
                    {col:"packet_delta_count_to_subscriber_sum"},
                    {col:"packet_delta_count_sum"},

                    {col:"flow_start_millisecond_min"},
                    {col:"flow_start_millisecond_from_subscriber_min"},
                    {col:"flow_start_millisecond_to_subscriber_min"},

                    {col:"flow_end_millisecond_max"},
                    {col:"flow_end_millisecond_from_subscriber_max"},
                    {col:"flow_end_millisecond_to_subscriber_max"},

                    {col:"rtt_from_subscriber_median"},
                    {col:"rtt_to_subscriber_median"},
                    {col:"rtt_median"},

                    {col:"bridge_vchannel_num", alias:"bridge_vchannel", func:QoEReportFunctions.VchannelGetDic},
                    {col:"dpi_id"},

                    {col:"locked"},
                ],
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    }
            },

        FullFlow:
            {
                values:[
                    "date",
                    "hour",
                    "time",
                    "source_ip",
                    "destination_ip",
                    "source_asnum",
                    "destination_asnum",
                    "source_astitle",
                    "destination_astitle",
                    "subscriber",
                    "subscriber_login",
                    "from_subscriber",
                    "login",
                    "host_ip",
                    "host",
                    "protocol_code",
                    "protocol_identifier",
                    "flow_start_millisecond_min",
                    "flow_start_millisecond_from_subscriber_min_if",
                    "flow_start_millisecond_to_subscriber_min_if",
                    "flow_end_millisecond_max",
                    "flow_end_millisecond_from_subscriber_max_if",
                    "flow_end_millisecond_to_subscriber_max_if",
                    "total_count",
                    "session_id_uniq",
                    "octet_delta_count_from_subscriber_sum_if",
                    "octet_delta_count_to_subscriber_sum_if",
                    "octet_delta_count_sum",
                    "packet_delta_count_from_subscriber_sum_if",
                    "packet_delta_count_to_subscriber_sum_if",
                    "packet_delta_count_sum",
                    "ip_class_of_service_any",
                    "rtt_from_subscriber_avg_if",
                    "rtt_to_subscriber_avg_if",
                    "rtt_avg_if",
                    "rtt_from_subscriber_median_if",
                    "rtt_to_subscriber_median_if",
                    "rtt_median_if",
                    "rtt_from_subscriber_any_heavy_if",
                    "rtt_to_subscriber_any_heavy_if",
                    "rtt_any_heavy_if",
                    "retransmits_from_subscriber_avg_if",
                    "retransmits_to_subscriber_avg_if",
                    "retransmits_avg_if",
                    "retransmits_rate_from_subscriber_avg_if",
                    "retransmits_rate_to_subscriber_avg_if",
                    "retransmits_rate_avg_if",
                    "fragments_avg_if",
                    {col:"", alias:"host_other", func:"empty(host) ? 'Unknown' : replaceOne(host, '*', 'www')"},
                    {col:"protocol_identifier", alias:"net_protocol_code"},
                    {col:"", alias:"net_protocol", func:"concat(dictGetStringOrDefault('net_protocols_dic', 'description', toUInt64(protocol_identifier), toString(protocol_identifier)),' ', toString(protocol_identifier))"},
                    {col:"", alias:"protocol", func:"concat(dictGetStringOrDefault('protocols_dic', 'description', toUInt64(protocol_code), toString(protocol_code)),' ', toString(protocol_code))"},
                    {col: "", alias: "app_protocol_group_id", func: "dictGetUInt64OrDefault('protocols_dic', 'group_id', toUInt64(protocol_code), toUInt64(protocol_code))"},
                    //{col:"", alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_other), toUInt64(0))"},
                    // {col:"", alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_other), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(replaceOne(host_other, 'www.', '')), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(concat('www.',host_other)), toUInt64(0))))"},
                    {col:"", alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_other), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(replaceOne(host_other, 'www.', '')), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(concat('www.',host_other)), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_ip), toUInt64(0)))))"},
                    {col:"", alias:"host_category_code", func:"dictGetStringOrDefault('urlcats_dic', 'description', toUInt64(host_category), 'Unknown')"},

                    // {col:"'0'", alias:"hw_chain"},
                    // {col:"'0'", alias:"hw_info_chain"},
                    // {col:"'0'", alias:"hw_info_uint_chain"},
                    // {col:"'0'", alias:"unit_vendor"},
                    // {col:"'0'", alias:"cabel"},
                    // {col:"'0'", alias:"contract"},
                    // {col:"'0'", alias:"services"},
                    // {col:"0", alias:"crc"}

                    // "hw_chain",
                    // "hw_info_chain",
                    // "hw_info_uint_chain",
                    // "unit_vendor",
                    // "cabel",
                    // "contract",
                    // "services",
                    // "crc",

                    {col:"bridge_vchannel_num", alias:"bridge_vchannel", func:QoEReportFunctions.VchannelGetDic},

                    {col:"ip_class_of_service", alias:"ip_class_of_service"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service_full"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service_class", func:"intDivOrZero(ip_class_of_service, 8)"},

                    {col:"mpls_labels"},

                    {col:"blocked"},
                    {col:"tethering"},

                    {col:"dropped_bytes_from_subscriber_sum_if"},
                    {col:"dropped_bytes_to_subscribers_sum_if"},
                    {col:"dropped_bytes_sum"},
                    {col:"dropped_packets_from_subscriber_sum_if"},
                    {col:"dropped_packets_to_subscribers_sum_if"},
                    {col:"dropped_packets_sum"},

                    {col:"dpi_id"},

                    {col:"duration_sum"},
                    {col:"duration_from_subscriber_sum_if"},
                    {col:"duration_to_subscriber_sum_if"}
                ],
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0,
                        use_where: {
                            "date":1,
                            "hour":1,
                            "time":1,
                            "source_ip":1,
                            "destination_ip":1,
                            "source_asnum":1,
                            "destination_asnum":1,
                            "source_astitle":1,
                            "destination_astitle":1,
                            "subscriber":1,
                            "subscriber_login":1,
                            "login":1,
                            "host_ip":1,
                            "host":1,
                            "protocol_code":1,
                            "host_other":1,
                            "protocol_identifier":1,
                            "net_protocol_code":1,
                            "net_protocol":1,
                            "protocol":1,
                            "app_protocol_group_id":1,
                            "host_category":1,
                            "bridge_vchannel_num":1,
                            "bridge_vchannel":1,
                            "ip_class_of_service":1,
                            "mpls_labels": 1,
                            "ip_class_of_service_class":1,
                            "ip_class_of_service_full":1,
                            "blocked":1,
                            "tethering":1,
                            "dpi_id":1
                        }
                    }
            },

        OnlineNetflow:
            {
                values:[
                    "date",
                    "hour",
                    "time",
                    "source_ip",
                    "destination_ip",
                    "source_asnum",
                    "destination_asnum",
                    "source_astitle",
                    "destination_astitle",
                    "subscriber",
                    "subscriber_login",
                    "from_subscriber",
                    "login",
                    "host_ip",
                    "host",
                    "protocol_code",
                    "protocol_identifier",
                    "flow_start_millisecond_min",
                    "flow_start_millisecond_from_subscriber_min_if",
                    "flow_start_millisecond_to_subscriber_min_if",
                    "flow_end_millisecond_max",
                    "flow_end_millisecond_from_subscriber_max_if",
                    "flow_end_millisecond_to_subscriber_max_if",
                    "total_count",
                    "session_id_uniq",
                    "octet_delta_count_from_subscriber_sum_if",
                    "octet_delta_count_to_subscriber_sum_if",
                    "octet_delta_count_sum",
                    "packet_delta_count_from_subscriber_sum_if",
                    "packet_delta_count_to_subscriber_sum_if",
                    "packet_delta_count_sum",
                    "ip_class_of_service_any",
                    "rtt_from_subscriber_avg_if",
                    "rtt_to_subscriber_avg_if",
                    "rtt_avg_if",
                    "rtt_from_subscriber_median_if",
                    "rtt_to_subscriber_median_if",
                    "rtt_median_if",
                    "rtt_from_subscriber_any_heavy_if",
                    "rtt_to_subscriber_any_heavy_if",
                    "rtt_any_heavy_if",
                    "retransmits_from_subscriber_avg_if",
                    "retransmits_to_subscriber_avg_if",
                    "retransmits_avg_if",
                    "retransmits_rate_from_subscriber_avg_if",
                    "retransmits_rate_to_subscriber_avg_if",
                    "retransmits_rate_avg_if",
                    "fragments_avg_if",
                    {col:"", alias:"host_other", func:"empty(host) ? 'Unknown' : replaceOne(host, '*', 'www')"},
                    {col:"protocol_identifier", alias:"net_protocol_code"},
                    {col:"", alias:"net_protocol", func:"concat(dictGetStringOrDefault('net_protocols_dic', 'description', toUInt64(protocol_identifier), toString(protocol_identifier)),' ', toString(protocol_identifier))"},
                    {col:"", alias:"protocol", func:"concat(dictGetStringOrDefault('protocols_dic', 'description', toUInt64(protocol_code), toString(protocol_code)),' ', toString(protocol_code))"},
                    {col: "", alias: "app_protocol_group_id", func: "dictGetUInt64OrDefault('protocols_dic', 'group_id', toUInt64(protocol_code), toUInt64(protocol_code))"},
                    // {col:"", alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_other), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(replaceOne(host_other, 'www.', '')), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(concat('www.',host_other)), toUInt64(0))))"},
                    {col:"", alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_other), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(replaceOne(host_other, 'www.', '')), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(concat('www.',host_other)), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_ip), toUInt64(0)))))"},


                    {col:"bridge_vchannel_num", alias:"bridge_vchannel", func:QoEReportFunctions.VchannelGetDic},

                    {col:"ip_class_of_service", alias:"ip_class_of_service"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service_full"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service_class", func:"intDivOrZero(ip_class_of_service, 8)"},

                    {col:"mpls_labels"},

                    {col:"dpi_id"}
                ],
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0,
                        use_where: {
                            "date":1,
                            "hour":1,
                            "time":1,
                            "source_ip":1,
                            "destination_ip":1,
                            "source_asnum":1,
                            "destination_asnum":1,
                            "source_astitle":1,
                            "destination_astitle":1,
                            "subscriber":1,
                            "subscriber_login":1,
                            "login":1,
                            "host_ip":1,
                            "host":1,
                            "protocol_code":1,
                            "host_other":1,
                            "protocol_identifier":1,
                            "net_protocol_code":1,
                            "net_protocol":1,
                            "protocol":1,
                            "app_protocol_group_id":1,
                            "host_category":1,
                            "bridge_vchannel_num":1,
                            "bridge_vchannel":1,
                            "ip_class_of_service":1,
                            "mpls_labels": 1,
                            "ip_class_of_service_class":1,
                            "ip_class_of_service_full":1,
                            "dpi_id":1
                        }
                    }
            },

        FullFlowSubsHwJoin:
            {
                view:{
                    values:[
                        {col:"hour", alias:"time"},

                        {col:"date"},
                        {col:"hour"},

                        {col:"subscriber_login"},
                        {col:"unit_vendor"},
                        {col:"cabel"},
                        {col:"contract"},
                        {col:"services"},
                        {col:"crc"},
                        {col:"hw_chain"},
                        {col:"hw_info_chain"},
                        {col:"hw_info_uint_chain"}
                    ],
                        flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0,
                        use_where:{
                            "time":1,
                            "date":1,
                            "hour":1,
                            "subscriber_login":1,
                            "unit_vendor":1,
                            "cabel":1,
                            "contract":1,
                            "services":1,
                            "crc":1,
                            "hw_chain":1,
                            "hw_info_chain":1,
                            "hw_info_uint_chain":1
                        }
                    },
                    table:QoEReportTablesEnum.SubscribersFlow
                },
                using:[
                    "date",
                    "hour",
                    "subscriber_login"
                ]
            },

        OnlineNetflowSubsHwJoin:
            {
                view:{
                    values:[
                        {col:"hour", alias:"time"},

                        {col:"date"},
                        {col:"hour"},

                        {col:"subscriber_login"},
                        {col:"unit_vendor"},
                        {col:"cabel"},
                        {col:"contract"},
                        {col:"services"},
                        {col:"crc"},
                        {col:"hw_chain"},
                        {col:"hw_info_chain"},
                        {col:"hw_info_uint_chain"}
                    ],
                    flags:
                        {
                            use_sort:0,
                            use_size:0,
                            use_having:0,
                            use_where:{
                                "time":1,
                                "date":1,
                                "hour":1,
                                "subscriber_login":1,
                                "unit_vendor":1,
                                "cabel":1,
                                "contract":1,
                                "services":1,
                                "crc":1,
                                "hw_chain":1,
                                "hw_info_chain":1,
                                "hw_info_uint_chain":1
                            }
                        },
                    table:QoEReportTablesEnum.SubscribersFlow
                },
                using:[
                    "date",
                    "hour",
                    "subscriber_login"
                ]
            },

        HostCategories:
            {
                values:[
                    "cat_id",
                    "host",
                    "description"
                ],
                table:QoEReportTablesEnum.UrlcatsHostDic,
                join:{
                    view:{
                        values:[
                            {col:"id", alias:"cat_id"},
                            {col:"description"},
                            {col:"", alias:"cluster_host", func:"hostName()"}
                        ],
                        table:QoEReportTablesEnum.UrlcatsDic,
                        flags:
                            {
                                use_sort:0,
                                use_size:0,
                                use_having:0,
                                use_where:0
                            }
                    },
                    using:[
                        "cat_id"
                    ]
                },
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    }
            },

        GtpCellsLocations:
            {
                values:[
                    "mcc",
                    "mnc",
                    "tac",
                    "eci",
                    "lat",
                    "lon",
                    "cell_id",
                    "cell_name",
                    "cell_description",
                    "col1",
                    "col2",
                    {col:"host", alias:"host", func:"hostName()"}
                ],
                table:QoEReportTablesEnum.GtpCellsLocationsDic,
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    },
                join:{
                    type: "left",
                    stringency: "",
                    view:{
                        values:[
                            {col:"mcc", alias:"mcc"},
                            {col:"mnc", alias:"mnc"},
                            {col:"tac", alias:"tac"},
                            {col:"eci", alias:"eci"},
                            {col:"col1", alias:"col1"},
                            {col:"col2", alias:"col2"}
                        ],
                        table:QoEReportTablesEnum.GtpCellsLocationsExtendedDic,
                        flags:
                            {
                                use_sort:0,
                                use_size:0,
                                use_having:0,
                                use_where:0
                            }
                    },
                    using:[
                        "mcc",
                        "mnc",
                        "tac",
                        "eci"
                    ]
                }
            },
        Subnets:
            {
                values:[
                    {col:"", alias:"ips", func:"arrayJoin(ips_arr)"}
                ],
                view:{
                    values:[
                        {col:"", alias:"nums_arr", func:"range(toUInt32(subnet_count))"},
                        {col:"", alias:"ips_arr", func:"arrayMap(y -> min_ip + y, nums_arr)"}
                    ],
                    view:{
                        values:[
                            {col:"cidr", alias:"network"},
                            {col:"", alias:"mask", func:"extract(network, '/(\\\\d+)$')"},
                            {col:"", alias:"cidr_mask", func:"bitShiftLeft(toUInt32(-1),toUInt32(32-toUInt8OrZero(mask)))"},
                            {col:"", alias:"wildcard_mask", func:"bitNot(cidr_mask)"},
                            {col:"", alias:"cidr_mask_", func:"IPv4NumToString(cidr_mask)"},
                            {col:"", alias:"wildcard_mask_", func:"IPv4NumToString(wildcard_mask)"},
                            {col:"", alias:"ip", func:"replaceRegexpOne(network, '/(\\\\d+)$', '')"},
                            {col:"", alias:"ipv6", func:"IPv6NumToString(IPv6StringToNum(ip)) == ip ? 1 : 0"},
                            {col:"", alias:"subnet_count", func:"notEmpty(mask) and ipv6 == 0 ? pow(2, 32 - toUInt8OrZero(mask)) : 0"},
                            {col:"", alias:"min_ip", func:"notEmpty(mask) ? bitAnd(toUInt32(IPv4StringToNum(ip)),cidr_mask) : toUInt32(IPv4StringToNum(ip))"},
                            {col:"", alias:"max_ip", func:"notEmpty(mask) ? toUInt32(min_ip + subnet_count - 1) : min_ip"},
                            {col:"", alias:"min_", func:"IPv4NumToString(min_ip)"},
                            {col:"", alias:"max_", func:"IPv4NumToString(max_ip)"}
                        ],

                        view:{
                            values:[
                                {col:"", alias:"cidr", func:"arrayJoin([CIDRS_ARRAY])"}
                            ],
                            flags:
                                {
                                    use_sort:0,
                                    use_size:0,
                                    use_having:0,
                                    use_where:0,
                                    use_from:0
                                }
                        },
                        flags:
                            {
                                use_sort:0,
                                use_size:0,
                                use_having:0,
                                use_where:0,
                                use_from:0
                            }
                    },
                    flags:
                        {
                            use_sort:0,
                            use_size:0,
                            use_having:0,
                            use_where:0,
                            use_from:0
                        }
                },
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0,
                        use_where:0,
                        use_from:0
                    }
            },

        RawFullFlow:
            {
                values:[
                    {col:"flow_start_time", alias:"time"},
                    {col:"flow_end_time"},
                    {col:"source_ip"},
                    {col:"destination_ip"},

                    {col:"session_id"},
                    {col:"source_ipv4"},
                    {col:"source_ipv6"},
                    {col:"source_port"},
                    {col:"bgp_source_as_number"},
                    {col:"destination_ipv4"},
                    {col:"destination_ipv6"},
                    {col:"destination_port"},
                    {col:"bgp_destination_as_number"},
                    {col:"login"},

                    {col:"source_asnum"},
                    {col:"destination_asnum"},
                    {col:"source_astitle"},
                    {col:"destination_astitle"},
                    {col:"subscriber"},
                    {col:"subscriber_port"},
                    {col:"host_ip"},
                    {col:"host_port"},
                    {col:"host"},

                    {col:"protocol_identifier", alias:"net_protocol", func:"concat(dictGetStringOrDefault('net_protocols_dic', 'description', toUInt64(protocol_identifier), toString(protocol_identifier)),' ', toString(protocol_identifier))"},
                    {col:"protocol_code", alias:"app_protocol", func:"concat(dictGetStringOrDefault('protocols_dic', 'description', toUInt64(protocol_code), toString(protocol_code)),' ', toString(protocol_code))"},
                    {col: "", alias: "app_protocol_group_id", func: "dictGetUInt64OrDefault('protocols_dic', 'group_id', toUInt64(protocol_code), toUInt64(protocol_code))"},
                    {col:"octet_delta_count"},
                    {col:"packet_delta_count"},
                    {col:"frgmt_delta_packs"},
                    {col:"repeat_delta_pack"},
                    {col:"packet_deliver_time"},

                    {col:"flow_start_millisecond"},
                    {col:"flow_end_millisecond"},
                    {col:"duration"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service_full"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service_class", func:"intDivOrZero(ip_class_of_service, 8)"},
                    {col:"input_snmp"},
                    {col:"output_snmp"},
                    {col:"ip_version"},
                    {col:"post_nat_source_ipv4"},
                    {col:"post_nat_source_port"},

                    {col:"from_subscriber"},
                    {col:"is_subscriber"},
                    {col:"is_excluded_subscriber"},

                    {col:"bridge_vchannel_num", alias:"bridge_vchannel", func:QoEReportFunctions.VchannelGetDic},

                    {col:"vlan_id"},
                    {col:"post_vlan_id"},
                    {col:"mpls_labels"},

                    {col:"blocked"},
                    {col:"dropped_bytes"},
                    {col:"dropped_packets"},

                    {col:"dpi_id"},

                    {col:"service_flags"},
                    {col:"detection_flags"},
                    {col:"action_flags"},

                    {col:"ttl"},
                    {col:"rating_group"}
                ],
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    }
            },

        OnlineRawFullFlow:
            {
                values:[
                    {col:"flow_start_time", alias:"time"},
                    {col:"flow_end_time"},
                    {col:"source_ip"},
                    {col:"destination_ip"},

                    {col:"session_id"},
                    {col:"source_ipv4"},
                    {col:"source_ipv6"},
                    {col:"source_port"},
                    {col:"bgp_source_as_number"},
                    {col:"destination_ipv4"},
                    {col:"destination_ipv6"},
                    {col:"destination_port"},
                    {col:"bgp_destination_as_number"},
                    {col:"login"},

                    {col:"source_asnum"},
                    {col:"destination_asnum"},
                    {col:"source_astitle"},
                    {col:"destination_astitle"},
                    {col:"subscriber"},
                    {col:"subscriber_port"},
                    {col:"host_ip"},
                    {col:"host_port"},
                    {col:"host"},

                    {col:"protocol_identifier", alias:"net_protocol", func:"concat(dictGetStringOrDefault('net_protocols_dic', 'description', toUInt64(protocol_identifier), toString(protocol_identifier)),' ', toString(protocol_identifier))"},
                    {col:"protocol_code", alias:"app_protocol", func:"concat(dictGetStringOrDefault('protocols_dic', 'description', toUInt64(protocol_code), toString(protocol_code)),' ', toString(protocol_code))"},
                    {col: "", alias: "app_protocol_group_id", func: "dictGetUInt64OrDefault('protocols_dic', 'group_id', toUInt64(protocol_code), toUInt64(protocol_code))"},
                    {col:"octet_delta_count"},
                    {col:"packet_delta_count"},
                    {col:"frgmt_delta_packs"},
                    {col:"repeat_delta_pack"},
                    {col:"packet_deliver_time"},

                    {col:"flow_start_millisecond"},
                    {col:"flow_end_millisecond"},
                    {col:"duration"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service_full"},
                    {col:"ip_class_of_service", alias:"ip_class_of_service_class", func:"intDivOrZero(ip_class_of_service, 8)"},
                    {col:"input_snmp"},
                    {col:"output_snmp"},
                    {col:"ip_version"},
                    {col:"post_nat_source_ipv4"},
                    {col:"post_nat_source_port"},

                    {col:"from_subscriber"},
                    {col:"is_subscriber"},
                    {col:"is_excluded_subscriber"},

                    {col:"bridge_vchannel_num", alias:"bridge_vchannel", func:QoEReportFunctions.VchannelGetDic},

                    {col:"vlan_id"},
                    {col:"post_vlan_id"},
                    {col:"mpls_labels"},

                    {col:"blocked"},
                    {col:"dropped_bytes"},
                    {col:"dropped_packets"},

                    {col:"dpi_id"},

                    {col:"service_flags"},
                    {col:"detection_flags"},
                    {col:"action_flags"},

                    {col:"ttl"},
                    {col:"rating_group"}
                ],
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    }
            },

        RawClickstream:
            {
                values:
                    [
                        {col:"date"},
                        {col:"time"},
                        {col:"time_fifteen"},
                        {col:"session_id"},
                        {col:"login"},
                        {col:"source_ipv4"},
                        {col:"source_ipv6"},
                        {col:"destination_ipv4"},
                        {col:"destination_ipv6"},
                        {col:"host"},
                        {col:"path"},
                        {col:"referal"},
                        {col:"user_agent"},
                        {col:"cookie"},
                        {col:"method"},
                        {col:"result_code"},
                        {col:"content_length"},
                        {col:"content_type"},
                        {col:"locked"},
                        {col:"host_type"},

                        {col:"from_subscriber"},
                        {col:"is_subscriber"},
                        {col:"is_excluded_subscriber"},

                        {col:"login"},
                        {col:"subscriber_login"},
                        {col:"subscriber"},

                        {col:"bridge_vchannel_num", alias:"bridge_vchannel", func:QoEReportFunctions.VchannelGetDic},

                        {col:"dpi_id"}
                    ],
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    }
            },

        RawClickstreamWithFullflow:
            {
                values:
                    [
                        {col:"date"},
                        {col:"time"},
                        {col:"time_fifteen"},
                        {col:"session_id"},
                        {col:"login"},
                        {col:"source_ipv4"},
                        {col:"source_ipv6"},
                        {col:"destination_ipv4"},
                        {col:"destination_ipv6"},
                        {col:"host"},
                        {col:"path"},
                        {col:"referal"},
                        {col:"user_agent"},
                        {col:"cookie"},
                        {col:"method"},
                        {col:"result_code"},
                        {col:"content_length"},
                        {col:"content_type"},
                        {col:"locked"},
                        {col:"host_type"},

                        {col:"from_subscriber"},
                        {col:"is_subscriber"},
                        {col:"is_excluded_subscriber"},

                        {col:"login", alias:"login", func:"notEmpty(login_fullflow)?login_fullflow:login"},
                        {col:"subscriber_login", alias:"notEmpty(login_fullflow)?login_fullflow:subscriber_login"},
                        {col:"subscriber"},

                        {col:"octet_delta_count_from_subscriber_sum", alias:"traffic_vol_from_subscriber"},
                        {col:"octet_delta_count_to_subscriber_sum", alias:"traffic_vol_to_subscriber"},
                        {col:"octet_delta_count_sum", alias:"traffic_vol"},

                        {col:"packet_delta_count_from_subscriber_sum", alias:"flow_vol_from_subscriber"},
                        {col:"packet_delta_count_to_subscriber_sum", alias:"flow_vol_to_subscriber"},
                        {col:"packet_delta_count_sum", alias:"flow_vol"},

                        {col:"flow_start_millisecond_min", alias:"time_min"},
                        {col:"flow_start_millisecond_from_subscriber_min", alias:"time_min_from_subscriber"},
                        {col:"flow_start_millisecond_to_subscriber_min", alias:"time_min_to_subscriber"},

                        {col:"flow_end_millisecond_max", alias:"time_max"},
                        {col:"flow_end_millisecond_from_subscriber_max", alias:"time_max_from_subscriber"},
                        {col:"flow_end_millisecond_to_subscriber_max", alias:"time_max_to_subscriber"},

                        {col:"rtt_from_subscriber_median"},
                        {col:"rtt_to_subscriber_median"},
                        {col:"rtt_median"},

                        {col:"bridge_vchannel_num", alias:"bridge_vchannel", func:QoEReportFunctions.VchannelGetDic},

                        {col:"dpi_id"}
                    ],
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    },
                join:{
                    view:{
                        values:[
                            {col:"time_fifteen", alias:"time"},
                            {col:"time_fifteen"},
                            {col:"session_id"},
                            {col:"login", alias:"login_fullflow"},
                            {col:"bridge_vchannel_num"},
                            {col:"dpi_id"},

                            {col:"octet_delta_count_from_subscriber_sum"},
                            {col:"octet_delta_count_to_subscriber_sum"},
                            {col:"octet_delta_count_sum"},

                            {col:"packet_delta_count_from_subscriber_sum"},
                            {col:"packet_delta_count_to_subscriber_sum"},
                            {col:"packet_delta_count_sum"},

                            {col:"rtt_from_subscriber_median"},
                            {col:"rtt_to_subscriber_median"},
                            {col:"rtt_median"},

                            {col:"flow_start_millisecond_min"},
                            {col:"flow_start_millisecond_from_subscriber_min"},
                            {col:"flow_start_millisecond_to_subscriber_min"},
                            {col:"flow_end_millisecond_max"},
                            {col:"flow_end_millisecond_from_subscriber_max"},
                            {col:"flow_end_millisecond_to_subscriber_max"}
                        ],
                        flags:
                            {
                                use_sort:0,
                                use_size:0,
                                use_having:0,
                                use_where:{time:1}
                            },
                        table:QoEReportTablesEnum.ClickstreamRawWithFullflow
                    },
                    using:[
                        "time_fifteen",
                        "session_id",
                        "dpi_id"
                    ]
                }
            },
        RawGtpFullFlow:
            {
                values:[
                    {col:"date", alias:"date"},
                    {col:"time"},
                    {col:"session_id"},
                    {col:"gtp_version"},

                    {col:"request_msg_id"},
                    {col:"response_msg_id"},
                    {col:"ie_cause"},
                    {col:"success"},
                    {col:"sgw_cp_ipv4"},
                    {col:"sgw_cp_teid"},
                    {col:"sgw_dp_ipv4"},
                    {col:"sgw_dp_teid"},
                    {col:"pgw_cp_ipv4"},
                    {col:"pgw_cp_teid"},

                    {col:"pgw_dp_ipv4"},
                    {col:"pgw_dp_teid"},
                    {col:"user_ipv4"},
                    {col:"user_ipv6"},
                    {col:"imsi"},
                    {col:"msisdn"},
                    {col:"imei"},
                    {col:"apn"},
                    {col:"uli_mcc"},
                    {col:"", alias:"country_description", func:"dictGetOrDefault('gtp_mcc_dic', 'description', tuple(uli_mcc),'')"},

                    {col:"uli_mnc"},
                    {col:"", alias:"network_description", func:"dictGetOrDefault('gtp_mnc_dic', 'description', tuple(uli_mcc, uli_mnc),'')"},
                    {col:"uli_tac"},
                    {col:"uli_eci"},
                    {col:"uli_time"},
                    {col:"nsapi"},
                    {col:"rat"},
                    {col:"dpi_id"}
                ],
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    }
            },
        GtpFullFlowAgg:{
            table:QoEReportTablesEnum.GtpFlowAgg,
            values:[
                {col:"", alias:"session_id_uniq", func: "uniqMerge(session_id_uniq)"},
                {col:"", alias:"total_count", func: "countMerge(total_count)"},
                {col:"", alias:"lat", func: "dictGetOrDefault('gtp_cells_locations_dic','lat', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),toFloat64(0))"},
                {col:"", alias:"lon", func: "dictGetOrDefault('gtp_cells_locations_dic','lon', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),toFloat64(0))"},
                {col:"", alias:"cell_id", func: "dictGetOrDefault('gtp_cells_locations_dic','cell_id', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),'')"},
                {col:"", alias:"cell_name", func: "dictGetOrDefault('gtp_cells_locations_dic','cell_name', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),'')"},
                {col:"", alias:"cell_description", func: "dictGetOrDefault('gtp_cells_locations_dic','cell_description', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),'')"},
                //{col:"", alias:"cgi", func: "concat(toString(uli_mcc), '-', toString(uli_mnc), '-', toString(uli_tac), '-', toString(uli_eci))"},
                {col:"", alias:"subscriber_login", func: "toString(imsi)"},
                {col:"", alias:"country_description", func:"dictGetOrDefault('gtp_mcc_dic', 'description', tuple(uli_mcc),'')"},
                {col:"", alias:"network_description", func:"dictGetOrDefault('gtp_mnc_dic', 'description', tuple(uli_mcc, uli_mnc),'')"}
            ],
            rows: [
                {col:"date", alias:"date"},
                {col:"hour", alias:"hour"},
                {col:"time", alias:"time"},

                {col:"imsi", alias:"imsi"},
                {col:"msisdn", alias:"msisdn"},
                {col:"imei", alias:"imei"},
                {col:"user_ipv4", alias:"user_ipv4"},
                {col:"user_ipv6", alias:"user_ipv6"},
                {col:"uli_time", alias:"uli_time"},
                {col:"uli_mcc", alias:"uli_mcc"},
                {col:"uli_mnc", alias:"uli_mnc"},
                {col:"uli_tac", alias:"uli_tac"},
                {col:"uli_eci", alias:"uli_eci"},
                {col:"dpi_id", alias:"dpi_id"}
            ],
            flags:{
                use_size:0,
                use_sort:0
            }
        },

        GtpSubscribersRoute:
            {
                values:[
                    {col:"date", alias:"date"},
                    {col:"hour", alias:"hour"},
                    {col:"time", alias:"time"},

                    {col:"imsi", alias:"imsi"},
                    {col:"msisdn", alias:"msisdn"},
                    {col:"imei", alias:"imei"},
                    {col:"dpi_id", alias:"dpi_id"},

                    {col:"user_ipv4", alias:"user_ipv4"},
                    {col:"user_ipv6", alias:"user_ipv6"},
                    {col:"uli_time", alias:"uli_time"},
                    {col:"uli_mcc", alias:"uli_mcc"},
                    {col:"uli_mnc", alias:"uli_mnc"},
                    {col:"uli_tac", alias:"uli_tac"},
                    {col:"uli_eci", alias:"uli_eci"},
                    {col:"session_id_uniq", alias:"session_id_uniq"},

                    {col:"lat", alias:"lat"},
                    {col:"lon", alias:"lon"},
                    {col:"cell_id", alias:"cell_id"},
                    {col:"cell_name", alias:"cell_name"},
                    {col:"cell_description", alias:"cell_description"}
                ],
                table:QoEReportTablesEnum.GtpFlowAgg,
                join:{
                    type: "",
                    stringency: "",
                    view:{
                        values:[
                            {col:"mcc", alias:"uli_mcc"},
                            {col:"mnc", alias:"uli_mnc"},
                            {col:"tac", alias:"uli_tac"},
                            {col:"eci", alias:"uli_eci"},
                            {col:"lat", alias:"lat"},
                            {col:"lon", alias:"lon"},
                            {col:"cell_id", alias:"cell_id"},
                            {col:"cell_name", alias:"cell_name"},
                            {col:"cell_description", alias:"cell_description"}
                        ],
                        table:QoEReportTablesEnum.GtpCellsLocationsDic,
                        flags:
                            {
                                use_sort:0,
                                use_size:0,
                                use_having:0,
                                use_where:0
                            }
                    },
                    using:[
                        "uli_mcc",
                        "uli_mnc",
                        "uli_tac",
                        "uli_eci"
                    ]
                },
                flags:
                    {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    }
            },

        DnsFlowRaw: {
            values:[
                {col:"flow_date"},
                {col:"flow_time", alias: "time"},
                {col:"flow_millisecond"},

                {col:"session_id"},
                {col:"login"},
                {col:"source_ipv4"},
                {col:"source_ipv6"},
                {col:"destination_ipv4"},
                {col:"destination_ipv6"},
                {col:"source_port"},
                {col:"destination_port"},

                {col:"dns_transport"},
                {col:"host"},
                {col:"host_ip_dns_data"},
                {col: "", alias: "host_ip", func: "if(from_subscriber = 1, if(destination_ipv6 = '::', destination_ipv4, destination_ipv6),if(source_ipv6 = '::', source_ipv4, source_ipv6))"},
                {col: "", alias: "host_port", func: "if(from_subscriber = 1, destination_port, source_port)"},
                {col: "", alias: "subscriber", func: "if(from_subscriber = 0, if(destination_ipv6 = '::', destination_ipv4, destination_ipv6), if(source_ipv6 = '::', source_ipv4, source_ipv6))"},
                {col: "", alias: "subscriber_port", func: "if(from_subscriber = 0, destination_port, source_port)"},

                {col:"rclass"},
                {col:"rtype"},
                {col:"ttl"},
                {col:"dns_data"},

                {col:"vlan_id"},
                {col:"post_vlan_id"},
                {col:"mpls_labels"},
                {col:"from_subscriber"},
                {col:"is_excluded_subscriber"},

                {col:"dpi_id"},

                {col:"bridge_vchannel_num", alias:"bridge_vchannel", func:QoEReportFunctions.VchannelGetDic}
            ],
            flags:
                {
                    use_sort:0,
                    use_size:0,
                    use_having:0
                }
        },
        DnsFlowAgg: {
            values: [
                {col:"date"},
                {col:"hour"},
                {col:"time"},

                {col:"session_id"},

                {col:"login"},
                {col:"subscriber"},
                {col:"subscriber_port"},

                {col:"host"},
                {col:"", alias:"host_other", func:"empty(host) ? 'Unknown' : replaceOne(host, '*', 'www')"},
                {col:"host_ip_dns_data"},
                {col:"", alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_other), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(replaceOne(host_other, 'www.', '')), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(concat('www.',host_other)), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(host_ip), toUInt64(0)))))"},
                {col:"", alias:"host_category_code", func:"dictGetStringOrDefault('urlcats_dic', 'description', toUInt64(host_category), 'Unknown')"},

                {col:"host_ip"},
                {col:"host_port"},

                {col:"dns_transport"},
                {col:"rclass"},
                {col:"rtype"},
                {col:"mpls_labels"},

                {col:"from_subscriber"},
                {col:"is_excluded_subscriber"},
                {col:"dpi_id"},

                {col:"bridge_vchannel_num", alias:"bridge_vchannel", func:QoEReportFunctions.VchannelGetDic},

                {col:"ttl_median"},
                {col:"ttl_avg"},
                {col:"dns_data_any_heavy"},
                {col:"total_count"},
                {col:"session_id_uniq"}
            ],
            flags: {
                use_sort:0,
                use_size:0,
                use_having:0
            }
        },
        DdosAttackFlowRaw: {
            values: [
                {col: "time"},
                {col: "end_time"},
                {col: "attack_type"},
                {col: "attack_direction"},
                {col: "dpi_id"},
                {col: "vchannel"},
                {col: "net_protocol"},
                {col: "app_protocol"},
                {col: "app_protocol_group_id"},
                {col: "src_asnum"},
                {col: "src_ip"},
                {col: "src_ports_arr"},
                {col: "dst_ip"},
                {col: "dst_ports_arr"},
                {col: "login"},
                {col: "start_millisecond"},
                {col: "end_millisecond"},
                {col: "octets"},
                {col: "octets_dropped"},
                {col: "packets"},
                {col: "packets_dropped"},
                {col: "flows"},
                {col: "sessions"},
                {col: "duration"},

                {col:"", alias:"src_ports", func:"arrayStringConcat(src_ports_arr, ', ')"},
                {col: "", alias:"event_object", func:"concat(net_protocol, ' from ', src_ip, ':[', arrayStringConcat(src_ports_arr, ', '), '] to ', dst_ip, ':[', arrayStringConcat(dst_ports_arr, ', '), ']')"}
            ],
            flags: {
                use_sort:0,
                use_size:0,
                use_having:0
            }
        },
        DdosAttackFlowAgg: {
            values: [
                {col: "date"},
                {col: "hour"},
                {col: "time"},
                {col: "attack_type"},
                {col: "attack_direction"},
                {col: "dpi_id"},
                {col: "vchannel"},
                {col: "protocol_identifier"},
                {col: "protocol_code"},
                {col: "src_asnum"},
                {col: "src_ip"},
                {col: "dst_ip"},

                {col: "login"},

                {col: "src_ports_uniq"},
                {col: "dst_ports_uniq"},

                {col: "start_millisecond_min"},
                {col: "end_millisecond_max"},
                {col: "octets_sum"},
                {col: "octets_dropped_sum" },
                {col: "packets_sum"},
                {col: "packets_dropped_sum"},
                {col: "flows_sum"},
                {col: "sessions_sum"},
                {col: "duration_sum"},
                {col: "duration_avg"},

                {col:"", alias:"net_protocol", func:"concat(dictGetStringOrDefault('net_protocols_dic', 'description', toUInt64(protocol_identifier), toString(protocol_identifier)),' ', toString(protocol_identifier))"},
                {col:"", alias:"app_protocol", func:"concat(dictGetStringOrDefault('protocols_dic', 'description', toUInt64(protocol_code), toString(protocol_code)),' ', toString(protocol_code))"},
                {col: "", alias: "app_protocol_group_id", func: "dictGetUInt64OrDefault('protocols_dic', 'group_id', toUInt64(protocol_code), toUInt64(protocol_code))"},

                {col: "", alias: "attacker_country_code", func: QoEReportFunctions.DdosAttackerCountryCode},
                {col: "", alias: "attacker_state", func: QoEReportFunctions.DdosAttackerState},
                {col: "", alias: "attacker_city", func: QoEReportFunctions.DdosAttackerCity},
                {col: "", alias: "attacker_latitude", func: QoEReportFunctions.DdosAttackerLatitude},
                {col: "", alias: "attacker_longitude", func: QoEReportFunctions.DdosAttackerLongitude},
                {col: "", alias: "attacker_coordinates", func: "concat(attacker_latitude, ',', attacker_longitude)"}
            ],
            flags: {
                use_sort:0,
                use_size:0,
                use_having:0
            }
        },
        FullnetflowAggSubscribersGrowthRateView:(Rows) => ({
            rows:Rows,
            values: [
                {col:"", alias:"first_interval_subscribers_uniq", func:"uniqIf(subscriber, time >= toDateTime('{period_from}') and time < toDateTime('{period_from}') + {to_interval_auto})"},
                {col:"", alias:"last_interval_subscribers_uniq", func:"uniqIf(subscriber, time > toDateTime('{period_to}') - {to_interval_auto} and time <= toDateTime('{period_to}'))"},
                {col:"", alias:"first_interval_logins_uniq", func:"uniqIf(login, time >= toDateTime('{period_from}') and time < toDateTime('{period_from}') + {to_interval_auto})"},
                {col:"", alias:"last_interval_logins_uniq", func:"uniqIf(login, time >= toDateTime('{period_to}') - {to_interval_auto} and time < toDateTime('{period_to}'))"}
            ],
            flags: {
                use_sort:0,
                use_size:0,
                use_having:0,
                use_where:0
            },
            view: {
                values: [
                    {col:"time"},
                    {col:"subscriber"},
                    {col:"login"},
                    {col:"protocol_code"},
                    {col:"", alias:"protocol", func:"concat(dictGetStringOrDefault('protocols_dic', 'description', toUInt64(protocol_code), toString(protocol_code)),' ', toString(protocol_code))"},
                    {col: "", alias: "app_protocol_group_id", func: "dictGetUInt64OrDefault('protocols_dic', 'group_id', toUInt64(protocol_code), toUInt64(protocol_code))"}
                ],
                flags: {
                    use_sort:0,
                    use_size:0,
                    use_having:0
                }
            }
        })
    };

QoEReportViews.Rtt = function (Params)
{
    var type = Params&&Params.type ? Params.type : "";

    return  {
        values: [
            {col:"", alias:"rtt"+type, func:"round(medianIfMerge(rtt"+type+"_median_if),0)"}
        ],

        rows:
            [
                "subscriber_login",
                "host"
            ],

        flags:
            {
                use_sort:0,
                use_size:0,
                use_where:0
            },

        view:function ()
        {
            var view = webix.copy(QoEReportViews.FullFlow);

            view.limit = 100000000;

            return view;
        }()
    };
};

QoEReportViews.OnlineRtt = function (Params)
{
    var type = Params&&Params.type ? Params.type : "";

    return  {
        values: [
            {col:"", alias:"rtt"+type, func:"round(medianIfMerge(rtt"+type+"_median_if),0)"}
        ],

        rows:
            [
                "subscriber_login",
                "host"
            ],

        flags:
            {
                use_sort:0,
                use_size:0,
                use_where:0
            },

        view:function ()
        {
            var view = webix.copy(QoEReportViews.OnlineNetflow);

            view.limit = 100000000;

            return view;
        }()
    };
};

QoEReportViews.RttForSubs = {
    values: [
        {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"},
        {col:"", alias:"rtt_from_subscriber", func:"round(medianIfMerge(rtt_from_subscriber_median_if),0)"},
        {col:"", alias:"rtt_to_subscriber", func:"round(medianIfMerge(rtt_to_subscriber_median_if),0)"}
    ],

    rows:
        [
            "subscriber_login"
        ],

    flags:
        {
            use_sort:0,
            use_size:0,
            use_where:0
        },

    view:QoEReportViews.FullFlow
};

QoEReportViews.RttDistribution = function(Params)
{
    var type = Params&&Params.type ? Params.type : "";

    var rtt_alias = Params&&Params.rtt_alias ? Params.rtt_alias : "";

    var subview =
        {
            values: [
                {col:"", alias:"rtt"+type+"_count", func:"countIf(rtt"+type+" > 0)"}
            ],
            rows:[
                {col:"rtt"+type, alias:"rtt", func:""}
            ],
            flags:
                {
                    use_where:0,
                    use_having:0,
                    use_size:0
                },
            sort:{id:"rtt",dir:"asc"},
            limit:1000,
            view:QoEReportViews.Rtt(Params)
        };

    var view = {
        values: [
            {col: "rtt", alias: rtt_alias ? rtt_alias : "rtt"},
            "rtt"+type+"_count"
        ],
        flags:
            {
                use_where:0,
                use_having:0,
                use_size:0
            },
        view:subview
    };

    return view;
};

QoEReportViews.OnlineRttDistribution = function(Params)
{
    var type = Params&&Params.type ? Params.type : "";

    var rtt_alias = Params&&Params.rtt_alias ? Params.rtt_alias : "";

    var subview =
        {
            values: [
                {col:"", alias:"rtt"+type+"_count", func:"countIf(rtt"+type+" > 0)"}
            ],
            rows:[
                {col:"rtt"+type, alias:"rtt", func:""}
            ],
            flags:
                {
                    use_where:0,
                    use_having:0,
                    use_size:0
                },
            sort:{id:"rtt",dir:"asc"},
            limit:1000,
            view:QoEReportViews.OnlineRtt(Params)
        };

    var view = {
        values: [
            {col: "rtt", alias: rtt_alias ? rtt_alias : "rtt"},
            "rtt"+type+"_count"
        ],
        flags:
            {
                use_where:0,
                use_having:0,
                use_size:0
            },
        view:subview
    };

    return view;
};


QoEReportViews.FullFlowJoinedWithSubsHw =
    {
        values: function ()
        {
            var values = [].concat(QoEReportViews.FullFlow.values);

            QoEReportViews.FullFlowSubsHwJoin.view.values.forEach(function (Index,Item)
            {
                if(Index > 2)
                    values.push(Item);
            });

            return values;
        }(),

        flags: function (){
            var flags = webix.copy(QoEReportViews.FullFlow.flags);

            flags.use_where = 1;

            return flags;

        }(),


        join: webix.copy(QoEReportViews.FullFlowSubsHwJoin)
    };

QoEReportViews.RawSessionLifetime =
    {
        values:
            [
                {col:"", alias:"session_lifetime", func:"max(flow_end_millisecond)-min(flow_start_millisecond)"}
            ],

        rows:
            [
                "session_id"
            ],

        flags:
            {
                use_sort:0,
                use_size:0,
                use_where:0
            },
        view:{
            values:
                [
                    {col:"flow_start_time", alias:"time"},
                    {col:"session_id"},
                    {col:"flow_start_millisecond"},
                    {col:"flow_end_millisecond"}
                ],
            flags:
                {
                    use_sort:0,
                    use_size:0,
                    use_where:{time:1}
                }
        }
    };

QoEReportViews.RawFullFlowWithSessionLifeTime = {
    values:function(){
        var arr = [];

        QoEReportViews.RawFullFlow.values.forEach(function (Val) {
            arr.push(Val.alias?Val.alias:Val.col);
        });

        arr.push({col:"session_lifetime"});

        return arr;
    }(),
    view:QoEReportViews.RawFullFlow,
    join:{
        view:QoEReportViews.RawSessionLifetime,
        using:[
            "session_id"
        ]
    },
    flags:
        {
            use_sort:0,
            use_size:0,
            use_having:0,
            use_where:{time:1}
        }
};


QoEReportViews.GtpFullFlowAggJoin =
{
    view:{
        values:[
            {col:"time"},

            {col:"date"},
            {col:"hour"},

            {col:"subscriber_login"},
            {col:"uli_mcc"},
            {col:"uli_mnc"},
            {col:"uli_tac"},
            {col:"uli_eci"},
            {col:"cell_id"},
            {col:"cell_name"}
        ],
        flags:{
            use_sort:0,
            use_size:0,
            use_having:0,
            use_where:0
        },
        view:function(){
            var view = webix.copy(QoEReportViews.GtpFullFlowAgg);

            view.flags = {
                use_sort:0,
                use_size:0,
                use_having:0,
                use_where:{
                    "time":1,
                    "date":1,
                    "hour":1,
                    "subscriber_login":1
                }
            };

            return view;
        }(),
        table:QoEReportTablesEnum.GtpFlowAgg,

    },
    using:[
        "date",
        "hour",
        "subscriber_login"
    ]
};

QoEReportViews.GtpOnlineFullFlowAggJoin =
    {
        view:{
            values:[
                {col:"time"},

                {col:"date"},
                {col:"hour"},

                {col:"subscriber_login"},
                {col:"uli_mcc"},
                {col:"uli_mnc"},
                {col:"uli_tac"},
                {col:"uli_eci"},
                {col:"cell_id"},
                {col:"cell_name"}
            ],
            flags:{
                use_sort:0,
                use_size:0,
                use_having:0,
                use_where:0
            },
            view:function(){
                var view = webix.copy(QoEReportViews.GtpFullFlowAgg);

                view.flags = {
                    use_sort:0,
                    use_size:0,
                    use_having:0,
                    use_where:{
                        "time":1,
                        "date":1,
                        "hour":1,
                        "subscriber_login":1
                    }
                };

                return view;
            }(),
            table:QoEReportTablesEnum.GtpFlowAgg,

        },
        using:[
            "date",
            "hour",
            "subscriber_login"
        ]
    };

QoEReportViews.FullFlowJoinedWithGTPAgg =
    {
        values: function ()
        {
            var values = [].concat(QoEReportViews.FullFlow.values);

            QoEReportViews.GtpFullFlowAggJoin.view.values.forEach(function (Index,Item)
            {
                if(Index > 2)
                    values.push(Item);
            });

            return values;
        }(),

        flags: function (){
            var flags = webix.copy(QoEReportViews.FullFlow.flags);

            flags.use_where = 1;

            return flags;

        }(),


        join: webix.copy(QoEReportViews.GtpFullFlowAggJoin)
    };

var QoEReportSwitchesTypesEnum = {
    AccessSwitch:"1",
    TrunkSwitch:"2"
};

var QoEReportSwitchesInfoFieldsEnum = {
    Name:"1",
    Type:"2",
    Region:"3",
    Address:"4",
    HwIp:"5",
    OperId:"6",
    LinkedFromPort:"7",
    BelongsTo:"8"
};

var QoEReportSwitchesInfoUnitFieldsEnum = {
    HwId:"1",
    HigherHw:"2",
    LinkedFromHw:"3",
    HwRcc:"4"
};

var QoEReportCacheSyncEnum = {
    CreatedError:-1,
    Created:0,
    Progress:1,
    Complete:2,
    Error:3,
    Cancel:4
};

var CustomReportsFormatUnitsColumnsIds = {
    TrafficSpeedBitUnits: [
        "traffic",
        "traffic_from_subscriber",
        "traffic_to_subscriber"
    ],
    FileSizeUnits: [
        "octet_delta_count_sum",
        "traffic_vol",
        "traffic_vol_from_subscriber",
        "traffic_vol_to_subscriber"
    ]
};

var QoEReportsSerieChartSqlTplBySortColMap = {
    traffic:                        QoEReportFunctions.AvgTrafficSpeedBitsPerSecondIf_ForChartSerie,
    traffic_from_subscriber:        QoEReportFunctions.AvgTrafficSpeedFromSubsBitsPerSecondIf_ForChartSerie,
    traffic_to_subscriber:          QoEReportFunctions.AvgTrafficSpeedToSubsBitsPerSecondIf_ForChartSerie,
    traffic_vol:                    QoEReportFunctions.TrafficVoumeBytesIf,
    traffic_vol_from_subscriber:    QoEReportFunctions.TrafficVoumeFromSubsBytesIf,
    traffic_vol_to_subscriber:      QoEReportFunctions.TrafficVoumeToSubsBytesIf,
    flow:                           QoEReportFunctions.AvgTrafficSpeedPktsPerSecondIf_ForChartSerie,
    flow_from_subscriber:           QoEReportFunctions.AvgTrafficSpeedFromSubsPktsPerSecondIf_ForChartSerie,
    flow_to_subscriber:             QoEReportFunctions.AvgTrafficSpeedToSubsPktsPerSecondIf_ForChartSerie,
    subscribers_uniq:               QoEReportFunctions.SubscribersUniqIf,
    logins_uniq:                    QoEReportFunctions.LoginsUniqIf,
    subscribers_growth_rate:        QoEReportFunctions.SubscribersUniqGrowthRateIf,
    logins_growth_rate:             QoEReportFunctions.LoginsUniqGrowthRateIf,
    sessons_uniq:                   QoEReportFunctions.SessionsUniqIf,
    protocol_uniq:                  QoEReportFunctions.ProtocolsUniqIf,
    app_protocol_group_uniq:        QoEReportFunctions.ProtocolsGroupUniqIf,
    duration_sum:                   QoEReportFunctions.DurationSumInMinutesIf
};

var QoEReportsSerieChartGetTopListFuncsBySortColMap = {
    traffic:                        QoEReportFunctions.AvgTrafficSpeedBitsPerSecond,
    traffic_from_subscriber:        QoEReportFunctions.AvgTrafficSpeedFromSubsBitsPerSecond,
    traffic_to_subscriber:          QoEReportFunctions.AvgTrafficSpeedToSubsBitsPerSecond,
    traffic_vol:                    QoEReportFunctions.TrafficVoumeBytes,
    traffic_vol_from_subscriber:    QoEReportFunctions.TrafficVoumeFromSubsBytes,
    traffic_vol_to_subscriber:      QoEReportFunctions.TrafficVoumeToSubsBytes,
    flow:                           QoEReportFunctions.AvgTrafficSpeedPktsPerSecond,
    flow_from_subscriber:           QoEReportFunctions.AvgTrafficSpeedFromSubsPktsPerSecond,
    flow_to_subscriber:             QoEReportFunctions.AvgTrafficSpeedToSubsPktsPerSecond,
    subscribers_uniq:               QoEReportFunctions.SubscribersUniq,
    logins_uniq:                    QoEReportFunctions.LoginsUniq,
    subscribers_growth_rate:        QoEReportFunctions.SubscribersUniqGrowthRate,
    logins_growth_rate:             QoEReportFunctions.LoginsUniqGrowthRate,
    sessons_uniq:                   QoEReportFunctions.SessionsUniq,
    protocol_uniq:                  QoEReportFunctions.ProtocolsUniq,
    app_protocol_group_uniq:        QoEReportFunctions.ProtocolsGroupUniq,
    duration_sum:                   QoEReportFunctions.DurationSumInMinutes
};

var QoEReportsSerieChartSqlTplBySortColMapCustomAggLogs_Set1 = {
    traffic:                        QoEReportFunctionsCustomAggLogsSet_1.TrafficSpeedBitsPerSecondIf_ForChartSerie,
    traffic_from_subscriber:        QoEReportFunctionsCustomAggLogsSet_1.TrafficSpeedBitsPerSecondFromSubscriberIf_ForChartSerie,
    traffic_to_subscriber:          QoEReportFunctionsCustomAggLogsSet_1.TrafficSpeedBitsPerSecondToSubscriberIf_ForChartSerie,
    traffic_vol:                    QoEReportFunctionsCustomAggLogsSet_1.TrafficVolumeBytesIf,
    traffic_vol_from_subscriber:    QoEReportFunctionsCustomAggLogsSet_1.TrafficVolumeBytesFromSubscriberIf,
    traffic_vol_to_subscriber:      QoEReportFunctionsCustomAggLogsSet_1.TrafficVolumeBytesToSubscriberIf,
};

var QoEReportsSerieChartGetTopListFuncsBySortColMapCustomAggLogs_Set1 = {
    traffic:                        QoEReportFunctionsCustomAggLogsSet_1.TrafficSpeedBitsPerSecond,
    traffic_from_subscriber:        QoEReportFunctionsCustomAggLogsSet_1.TrafficSpeedBitsPerSecondFromSubscriber,
    traffic_to_subscriber:          QoEReportFunctionsCustomAggLogsSet_1.TrafficSpeedBitsPerSecondToSubscriber,
    traffic_vol:                    QoEReportFunctionsCustomAggLogsSet_1.TrafficVolumeBytes,
    traffic_vol_from_subscriber:    QoEReportFunctionsCustomAggLogsSet_1.TrafficVolumeBytesFromSubscriber,
    traffic_vol_to_subscriber:      QoEReportFunctionsCustomAggLogsSet_1.TrafficVolumeBytesToSubscriber,
};

var QoEReportCustomAggLogsFunctions = {
    "default": {
        sql_tpl: QoEReportsSerieChartSqlTplBySortColMap,
        top_list: QoEReportsSerieChartGetTopListFuncsBySortColMap
    },
    "cal_ff_traffic_by_vchannels": {
        sql_tpl: QoEReportsSerieChartSqlTplBySortColMapCustomAggLogs_Set1,
        top_list: QoEReportsSerieChartGetTopListFuncsBySortColMapCustomAggLogs_Set1
    }
};

function GetQoEReportsSerieChartSqlTpl(ConditionCol, SortCol, EnumKey = "default")
{
    if(!ConditionCol || !SortCol)
        return null;

    let search, replacement, tpl;

    switch (ConditionCol)
    {
        case "bridge_vchannel":
            search = "{condition}"
            replacement = `${ConditionCol} == toString({col_value})`;
            break;
        case "login":
            search = "{condition}"
            replacement = `${ConditionCol} == toString({col_value})`;
            break;
        default:
            search = "{condition}"
            replacement = `${ConditionCol} == {col_value}`;
    }

    if(!QoEReportCustomAggLogsFunctions[EnumKey])
        EnumKey = "default";

    let tplEnum = QoEReportCustomAggLogsFunctions[EnumKey].sql_tpl;

    tpl = tplEnum[SortCol];

    if(search && replacement && tpl)
    {
        tpl = `${tpl} as \`{col_value_as_alias}\``;
        tpl = Helper.ReplaceAll(search, replacement, tpl);
    }

    return tpl;
}

function GetQoEReportsSerieChartGetTopListFunc(SortCol, EnumKey = "default")
{
    if(!QoEReportCustomAggLogsFunctions[EnumKey])
        EnumKey = "default";

    let tplEnum = QoEReportCustomAggLogsFunctions[EnumKey].top_list;

    return tplEnum[SortCol];
}

function QoEReportFilterModel(Params)
{
    this.table = Params&&Params.table?Params.table:null;

    this.database = Params&&Params.database?Params.database:null;

    this.page = Params&&Params.page?Params.page:0;

    this.size = Params&&Params.size?Params.size:0;

    this.period = Params&&Params.period?Params.period:null;

    this.filter = Params&&Params.filter?Params.filter:null;

    this.sort = Params&&Params.sort?Params.sort:null;

    this.max_execution_time = Params&&Params.max_execution_time?Params.max_execution_time:0;
}

function QoEReportConfigModel(Params)
{
    this.id = Params&&Params.id?Params.id:null;

    this.table = Params&&Params.table?Params.table:null;

    this.database = Params&&Params.database?Params.database:"qoestor";

    this.type = Params&&Params.type?Params.type:QoEReportConfigTypeEnum.ServerPredefined;

    this.config = Params&&Params.config?Params.config:null;

    this.data = Params&&Params.data?Params.data:null;

    this.error = Params&&Params.error?Params.error:null;

    this.signal = Params&&Params.signal?Params.signal:new Rx.BehaviorSubject(0);

    this.params = Params&&Params.params?new QoEReportFilterModel(Params.params):new QoEReportFilterModel();

    if(this.config)
    {
        if(this.config.type)
            this.type = this.config.type;

        if(this.config.table)
            this.table = this.config.table;

        if(this.config.database)
            this.database = this.config.database;
    }

    // Only for ServerPredefined
    this.method = Params && Params.method ? Params.method : null;

    this.widget_settings = Params && Params.widget_settings ? Params.widget_settings : null;
}

function QoEStoredReportBaseModel(Params)
{
    this._id = Params&&Params._id?Params._id:null;
    this.widget_code = Params&&Params.widget_code?Params.widget_code:"";
    this.widget_name = Params&&Params.widget_name?Params.widget_name:"";
    this.widget_func = Params&&Params.widget_func?Params.widget_func:"";
    this.widget_config_json = Params&&Params.widget_config_json?Params.widget_config_json:"";
    this.filter_config_json = Params&&Params.filter_config_json?Params.filter_config_json:"";
    this.report_settings_json = Params&&Params.report_settings_json?Params.report_settings_json:"";
    this.period_state_json = Params&&Params.period_state_json?Params.period_state_json:"";
}

function QoEStoredReportModel(Params)
{
    this._id = Params&&Params._id?Params._id:null;
    this.widget_code = Params&&Params.widget_code?Params.widget_code:"";
    this.widget_name = Params&&Params.widget_name?Params.widget_name:"";
    this.widget_func = Params&&Params.widget_func?Params.widget_func:"";
    this.widget_config_json = Params&&Params.widget_config_json?Params.widget_config_json:"";

    this.filter_config = Params&&Params.filter_config?Params.filter_config:null;
    this.filter_state = Params&&Params.filter_state?Params.filter_state:null;
    this.filter_config_json = Params&&Params.filter_config_json?Params.filter_config_json:"";

    this.report_settings_json = Params&&Params.report_settings_json?Params.report_settings_json:"";

    this.period_state = Params&&Params.period_state?Params.period_state:null;
    this.period_state_json = Params&&Params.period_state_json?Params.period_state_json:"";

    this.lifetime_sec = Params&&Params.lifetime_sec?Params.lifetime_sec:"";

    if(this.filter_config_json&&JSON.parse(this.filter_config_json));
    {
        var filter_config = JSON.parse(this.filter_config_json);

        if(filter_config.filter_config)
            this.filter_config = filter_config.filter_config;

        if(filter_config.filter_state)
            this.filter_state = filter_config.filter_state;
    }

    if(this.period_state_json&&JSON.parse(this.period_state_json))
    {
        this.period_state = JSON.parse(this.period_state_json);
    }

    if(this.report_settings_json&&JSON.parse(this.report_settings_json))
        this.report_settings_json = JSON.parse(this.report_settings_json);
}

function QoECustomReportModel(Params)
{
    this._id = Params&&Params._id?Params._id:null;

    this.code = Params&&Params.code?Params.code:"";
    this.widget = Params&&Params.widget?Params.widget:"";

    this.report_config = Params&&Params.report_config?Params.report_config:null;
    this.report_config_json = Params&&Params.report_config_json?Params.report_config_json:null;

    this.filters_config = Params&&Params.filters_config?Params.filters_config:null;
    this.filters_config_json = Params&&Params.filters_config_json?Params.filters_config_json:null;

    this.defaults = Params&&Params.defaults?Params.defaults:null;
    this.defaults_json = Params&&Params.defaults_json?Params.defaults_json:null;

    if(Helper.IsObject(this.report_config_json))
        this.report_config = this.report_config_json;
    else if(typeof this.report_config_json === "string" && JSON.parse(this.report_config_json))
        this.report_config = JSON.parse(this.report_config_json);

    if(Helper.IsObject(this.filters_config_json))
        this.filters_config = this.filters_config_json;
    else if(typeof this.filters_config_json === "string" && JSON.parse(this.filters_config_json))
        this.filters_config = JSON.parse(this.filters_config_json);

    if(Helper.IsObject(this.defaults_json))
        this.defaults = this.defaults_json;
    else if(typeof this.defaults_json === "string" && JSON.parse(this.defaults_json))
        this.defaults = JSON.parse(this.defaults_json);

    switch(this.widget)
    {
        case "QoETableReportWidget":
            this.report_config = new DefineQoECustomReportModelTableConfig(this.report_config);
            break;
        case "QoESeriesChartReportWidget":
            this.report_config = new DefineQoECustomReportModelChartConfig(this.report_config);
            break;
        case "QoETableChartWidget":
            if(this.report_config.table.widget) {
                const config = new QoECustomReportModel(this.report_config.table.widget);
                this.report_config.table.widget = config.report_config;
            }

            if(this.report_config.chart.widget) {
                const config = new QoECustomReportModel(this.report_config.chart.widget);
                this.report_config.chart.widget = config.report_config;
            }
            break;
        default:
            this.report_config = new DefineQoECustomReportModelTableConfig(this.report_config);
    }

    if(this.filters_config && Array.isArray(this.filters_config.filters)) {
        this.filters_config.filters.forEach(function (F){
            if(F && F.title)
                F.title = LangHelper.GetString("QoE", F.title);
        });
    }
}

function DefineQoECustomReportModelCommonConfig(Params)
{
    Params = Params || {};

    // init for IDE checker
    this.config = null;
    this.export_pdf_config = null;
    this.report_settings = null;

    for(let key in Params)
        this[key] = Params[key];

    if(this.title)
        this.title = LangHelper.GetString("QoE", this.title);

    if(Helper.HasValues(this.config)) {
        this.config.values.forEach(Item => {
            if(Item.func.startsWith("QoEReportFunctions"))
                Item.func = Helper.EvalProp(Item.func);
            if(Helper.IsLookLikeCode(Item.alias))
                Item.alias = Helper.EvalProp(Item.alias);
        });
    }

    if(Helper.HasCache(this.config) && Helper.HasValues(this.config.cache)) {
        this.config.cache.values = this.config.cache.values.map(Item => {
            return Helper.IsLookLikeCode(Item) ? Helper.EvalProp(Item) : Item;
        });
    }

    if(this.export_pdf_config) {
        let conf = this.export_pdf_config;
        conf.title = conf.title ? LangHelper.GetString("QoE", conf.title) : "";
        conf.units = conf.units ? Helper.EvalProp(conf.units) : "";
    }

    if(this.report_settings) {
        if(this.report_settings.custom_model && this.report_settings.custom_model.enable_series) {
            if(Array.isArray(this.report_settings.custom_model.enable_series))
                this.report_settings.custom_model.enable_series = this.report_settings.custom_model.enable_series.map(Item => {
                    return Helper.IsLookLikeCode(Item) ? Helper.EvalProp(Item) : Item;
                });
        }
    }
}

function DefineQoECustomReportModelTableConfig(Params)
{
    this.columns = null;

    DefineQoECustomReportModelCommonConfig.call(this, Params);

    if(Helper.HasColumns(this)) {
        this.columns.forEach((Col) => {
            if(Col.header && Col.header.length) {
                try {
                    if(Helper.IsLookLikeCode(Col.header[0]))
                        Col.header[0] = eval(Col.header[0]);
                    else
                        Col.header[0] = TooltipTemplate(LangHelper.GetString("QoE", Col.header[0]));
                } catch(e) {
                    Col.header[0] = TooltipTemplate(LangHelper.GetString("QoE", Col.header[0]));
                }

            }

            if(Col.template /*&& Col.template.indexOf("function") >= 0*/)
                Col.template = eval(Col.template);

            if(Col.format)
                Col.format = eval(Col.format);

            for (let key in CustomReportsFormatUnitsColumnsIds) {
                if (CustomReportsFormatUnitsColumnsIds[key].includes(Col.id)) {
                    Col.units_format_data = UnitsFormatData[key];
                }
            }
        });
    } else if (Helper.IsLookLikeCode(this.columns)) {
        try {
            this.columns = Helper.EvalProp(this.columns);
        } catch(r) {
            this.columns = [];
        }
    }
}

function DefineQoECustomReportModelChartConfig(Params)
{
    DefineQoECustomReportModelCommonConfig.call(this, Params);

    if(Helper.HasCols(this.config)) {
        this.config.cols = [
            new QoECustomReportModelSeriesChartConfigCols(this.config.cols[0])
        ];
    }

    if(this.xAxis)
        this.xAxis = {template: QoESeriesChartAxisTemplates[this.xAxis]}

    if(this.yAxis)
        this.yAxis = {template: QoESeriesChartAxisTemplates[this.yAxis]};
}

function QoECustomReportModelSeriesChartConfigCols(Params)
{
    this.col = Params && Params.col ? Params.col : "";
    this.alias = Params && Params.alias ? Params.alias : "";
    this.func = Params && Params.func ? Params.func : "";
    this.values = Params && Params.values ? Params.values : [];
    this.conditions = Params && Params.conditions ? Params.conditions : "";
    this.sql_tpl = Params && Params.sql_tpl ? Params.sql_tpl : "";

    if(Helper.IsObject(this.values) && this.values.params && this.values.params.func) {
        if(this.values.params.func.startsWith("QoEReportFunctions")) {
            try {
                this.values.params.func = Helper.EvalProp(this.values.params.func);
            } catch(e) {
                this.values.params.func = null;
            }
        }
    }

    if(Helper.IsLookLikeCode(this.sql_tpl)) {
        try {
            this.sql_tpl = Helper.EvalProp(this.sql_tpl);
        } catch(e) {
            this.sql_tpl = null;
        }
    }
}

function QoEOnlineViewModel(Params)
{
    this.view_id = Params&&Params.view_id?Params.view_id:"";
    this.created_time = Params&&Params.created_time?Params.created_time:"";
    this.lifetime_sec = Params&&Params.lifetime_sec?Params.lifetime_sec:0;
    this.filters = Params&&Params.filters?Params.filters:null;
    this.view = Params&&Params.view?Params.view:null;
    this.view_type = Params&&Params.view_type?Params.view_type:null;

    this.table_id = Params&&Params.table_id ? Params.table_id : this.view_id + "_" + Helper.RandInt(10000, 100000);
}

function QoEOnlineViewTimerModel(Params)
{
    this.id = Params&&Params.id?Params.id:null;
    this.button = Params&&Params.button?Params.button:null;
    this.cache_id = Params&&Params.cache_id?Params.cache_id:"";
}

function QoEReportsManager(Params)
{
    this.Active = true;

    this.Reports = {};

    this.CustomReportsConfigs = {};

    this.SignalStoredReportUpdated = new Rx.BehaviorSubject(null);
}

QoEReportsManager.prototype.Destroy = function ()
{
    this.Active = false;
};

QoEReportsManager.prototype.RegisterReport = function (ReportConfig)
{
    var reportConfig = new QoEReportConfigModel(ReportConfig);

    this.Reports[reportConfig.id] = reportConfig;
};

QoEReportsManager.prototype.UnRegisterReport = function (ReportId)
{
    delete this.Reports[ReportId];
};

QoEReportsManager.prototype.GetReportConfig = function (ReportId)
{
    return this.Reports[ReportId] ? this.Reports[ReportId] : null;
};
///
QoEReportsManager.prototype.GetReportDataExportFileData = function(ReportId, Params, IsLocal, ExportParams, ExportBtn)
{
    var _this = this;

    var reportConfig = this.GetReportConfig(ReportId);

    reportConfig.params = new QoEReportFilterModel(Params.params);

    reportConfig.params.table = reportConfig.params.table ? reportConfig.params.table : reportConfig.table;

    reportConfig.params.database = reportConfig.params.database ? reportConfig.params.database : reportConfig.database;

    reportConfig.params.filename = ExportParams.filename ? ExportParams.filename : "";

    reportConfig.params.exportType = QoEExportExtensionDic[ExportParams.type] ? QoEExportExtensionDic[ExportParams.type] : "";

    reportConfig.params.columns_table_name = Params.params.columns_table_name ? Params.params.columns_table_name : "";

    reportConfig.params.isQoE = Params.params.isQoE ? Params.params.isQoE : false;

    reportConfig.params.export_pdf_params = ExportParams;

    reportConfig.params.report_settings = Params && Params.report_settings ? Params.report_settings : null;

    var method, data;

    switch(reportConfig.type)
    {
        case QoEReportConfigTypeEnum.ClientPredefined:
            // TODO: Create method for generate file here
            method = "GetQoEClientPredefinedReportExportFile";
            data = {/*Id:reportConfig.id, */ Config:reportConfig.config, Params:reportConfig.params};
            break;

        default:
            // TODO: Create method for generate file here
            method = "GetQoEServerPredefinedReportExportFile";
            data = {Id:reportConfig.id, Params:reportConfig.params};
    }

    var params =
        {
            method:method,
            data:data,
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                ExportBtn.enable();

                if(R.success) {
                    reportConfig.error = null;

                    App.ServerManager.DownloadFileFromLocalUrl(`/qoe_export_file/${R.data.hash}${R.data.filename}${R.data.exportType}`);

                    // setTimeout(function () {
                    //     document.getElementById("hiddenDownloader").remove();
                    // },100);
                }
                else {
                    reportConfig.error = R.error;
                    webix.message({type:"error", text:R.error.msg});
                }

                if(R.data)
                    reportConfig.data = R.data;
                else
                    reportConfig.data = {};

                // reportConfig.signal.next(1);

            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};
///
QoEReportsManager.prototype.RefreshReportData = function (ReportId, Params)
{
    var _this = this;

    var reportConfig = this.GetReportConfig(ReportId);

    reportConfig.params = new QoEReportFilterModel(Params);

    reportConfig.params.table = reportConfig.params.table ? reportConfig.params.table : reportConfig.table;

    reportConfig.params.database = reportConfig.params.database ? reportConfig.params.database : reportConfig.database;

    reportConfig.params.report_settings = Params && Params.report_settings ? Params.report_settings : null;

    var method, data;

    if(Params.report_id)
    {
        if(!reportConfig.config)
        {
            reportConfig.config = {};
        }
        reportConfig.config.report_id = Params.report_id;
    }

    switch(reportConfig.type)
    {
        case QoEReportConfigTypeEnum.ClientPredefined:
            method = "GetQoEClientPredefinedReport";
            data = {/*Id:reportConfig.id, */ Config:reportConfig.config, Params:reportConfig.params};
            break;

        default:
            method = "GetQoEServerPredefinedReport";

            data = {};

            if(reportConfig.method)
            {
                data.Id = reportConfig.method;
            }
            else{
                data.Id = reportConfig.id;
            }

            if(reportConfig.widget_settings)
            {
                data.Params = {
                    widget_settings: reportConfig.widget_settings,
                    params: reportConfig.params
                };
            }
            else
            {
                data.Params = reportConfig.params
            }
    }

    var params =
        {
            method:method,
            data:data,
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    reportConfig.error = null;
                }
                else
                {
                    reportConfig.error = R.error;
                    webix.message({type:"error", text:R.error.msg});
                }

                if(R.data)
                    reportConfig.data = R.data;
                else
                    reportConfig.data = {};

                reportConfig.signal.next(1);

            }
        }
 
    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.ExpSubscribersToAdvc = function (Params, Callback)
{
    var _this = this;

    var params =
        {
            method:"StartExpQoESubscribersToAdvcJob",
            data:{Params:Params},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R);
                    return;
                }

                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.ClearCache = function (Callback, Params)
{
    var _this = this;

    var data = {};

    var method = "DropAllUserQoECaches";

    if(Params)
    {
        if(Params.caches_ids)
        {
            data.CachesIds = Params.caches_ids;
            method = "DropQoECaches"
        }

        if(Params.drop_all_caches)
        {
            method = "DropAllQoECaches";
        }
    }

    var params =
        {
            method:method,
            data:data,
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R);
                    return;
                }

                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.CheckQoEStorVersionCompatibility = function (Callback)
{
    var _this = this;

    var params =
        {
            method:"CheckQoEStorVersionCompatibility",
            data:{},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R);
                    return;
                }

                // if(!R.success)
                // {
                //     webix.message({type:"error", text:R.error.msg});
                // }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.DropPartitions = function (Params)
{
    var _this = this;

    var requests = [];

    if(Params&&Params.data)
    {
        Params.data.forEach(function (Partition)
        {
            if(Partition)
            {
                var request = {};

                request.id = Partition.id ? Partition.id : null;
                request.method = "DropQoEPartition";
                request.data = {Table:Partition.table, Name:Partition.partition};

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(!_this.Active)
                {
                    return;
                }

                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.KillProcesses = function (Params)
{
    var _this = this;

    var requests = [];

    if(Params&&Params.data)
    {
        Params.data.forEach(function (Process)
        {
            if(Process)
            {
                var request = {};

                request.id = Process.id ? Process.id : null;
                request.method = "KillQoEQueryProcess";
                request.data = {QID:Process.query_id};

                requests.push(request);
            }
        });
    }

    var params =
        {
            requests:requests,
            callback:function (result) {
                if(!_this.Active)
                {
                    return;
                }

                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.KillAllProcesses = function (Callback, Params)
{
    var _this = this;

    var data = {};

    var method = "KillAllUserQoEQueryProcesses";

    if(Params)
    {
        if(Params.processes_ids)
        {
            data.ProcessesIds = Params.processes_ids;
            method = "KillQoEQueryProcesses"
        }

        if(Params.kill_all_processes)
        {
            method = "KillAllQoEQueryProcesses";
        }
    }

    var params =
        {
            method:method,
            data:data,
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R);
                    return;
                }

                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.ReloadDics = function (Callback)
{
    var _this = this;

    var params =
        {
            method:"ReloadQoEDics",
            data:{},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R);
                    return;
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.GetStoredReport = function (ReportId, Callback)
{
    var _this = this;

    // Потому что в NavRouter-е зачем-то меняются _ на пробелы, скорее всего это где-то нужно
    var report_id = Helper.ReplaceAll(" ", "_", ReportId);

    var params =
        {
            method:"GetQoEStoredReport",
            data:{
                ReportId:report_id
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success && R.data)
                {
                    R.data = new QoEStoredReportModel(R.data)
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R);
                    return;
                }

                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.SaveStoredReport = function (StoredReportModel, Callback)
{
    var _this = this;

    var model = new QoEStoredReportBaseModel(StoredReportModel);

    var params =
        {
            method:"SaveQoEStoredReport",
            data:{
                StoredReportModel:model
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success && R.data)
                {
                    R.data = new QoEStoredReportModel(R.data)
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R);
                    return;
                }

                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.GetCustomReport = function (ReportId, GroupCode, Callback)
{
    var _this = this;

    if(this.CustomReportsConfigs[ReportId])
    {
        Callback(this.CustomReportsConfigs[ReportId], ReportId);
        return;
    }

    const _params = {
        filter: {
            _id: {
                id: "_id",
                operator: "=",
                value: ReportId
            },
            group_code: {
                id: "group_code",
                operator: "=",
                value: GroupCode
            }
        }
    };

    var params =
        {
            method:"GetQoECustomReportsList",
            data:{Params: _params},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success && R.data && Array.isArray(R.data.rows) && R.data.rows.length > 0)
                {
                    R.data = new QoECustomReportModel(R.data.rows[0]);

                    _this.CustomReportsConfigs[ReportId] = R;
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R, ReportId);
                    return;
                }

                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.EnableCustomAggLog = function (LogId, Enabled, Callback)
{
    var _this = this;

    var params =
        {
            method:"EnableQoECustomAggLog",
            data:{
                LogId:LogId.toString(),
                Enabled: Enabled
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R, LogId);
                    return ;
                }

                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.ReplaceUnAvailableAggPeriod = function(OnlineViewModel, AggPeriod, Callback)
{
    var _this = this;

    AggPeriod = AggPeriod?AggPeriod:0;

    var params = {
        method:"QoEOnlineViewReplaceUnavailableAggPeriod",
        data:{
            OnlineViewModel,
            AggPeriod
        },
        callback: function(R) {
            if(!_this.Active) {
                return;
            }

            if(Callback && typeof Callback == "function") {
                Callback(R);
            }
        }
    };

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.EnableOnlineView = function(OnlineViewModel, Enabled, Callback)
{
    var _this = this;

    var params = {
        method:"QoEEnableOnlineView",
        data:{
            OnlineViewModel,
            Enabled
        },
        callback: function(R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Callback && typeof Callback == "function")
            {
                Callback(R);
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.UpdateOnlineViewCreatedTime = function(OnlineViewModel, Callback)
{
    var _this = this;

    var params = {
        method:"QoEUpdateOnlineViewCreatedTime",
        data:{
            OnlineViewModel
        },
        callback: function(R) {
            if(!_this.Active) {
                return;
            }

            if(Callback && typeof Callback == "function") {
                Callback(R);
            }
        }
    };

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.ReplaceOnlineView = function(OnlineViewModel, Callback)
{
    var _this = this;

    var params = {
        method:"QoEReplaceOnlineView",
        data:{
            OnlineViewModel
        },
        callback: function(R) {
            if(!_this.Active) {
                return;
            }

            if(Callback && typeof Callback == "function") {
                Callback(R);
            }
        }
    };

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

QoEReportsManager.prototype.GetQoEStorServerTimezoneOffset = function(Callback)
{
    var _this = this;

    var params = {
        method: "GetQoEStorServerTimezoneOffset",
        data: {},
        callback: function(R) {
            if(!_this.Active) {
                return;
            }

            if(Callback && typeof Callback == "function") {
                Callback(R);
            }
        }
    };

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};
var QoESubscribersFilterListItemTypeEnum =
{
    subs_clickstream:"subs_clickstream",
    subs_fullnetflow:"subs_fullnetflow",
    subs_onlinenetflow:"subs_onlinenetflow",
    hist_netflow:"hist_nf",
    hist_clickstream:"hist_cs",
    hist_logs_netflow:"hist_logs_nf",
    hist_logs_clickstream:"hist_logs_cs",
    hist_subscribers_netflow:"hist_subs_nf",
    hist_subscribers_clickstream:"hist_subs_cs",
    hist_subscribers_online_netflow:"hist_subs_online_nf",
    vas_ads_statistics:"vas_ads_stats",
    vas_bill_history:"vas_bill_history",
    gtp_flow_history: "gtp_flow_history",
    gtp_raw_flow_history: "gtp_raw_flow_history",
    nat_raw_flow_history: "nat_raw_flow_history",
    dashboards_history: "dashboards_history",
    dns_raw_flow_history: "dns_raw_flow_history",
    dnsflow_history: "dnsflow_history",
    ddos_attack: "ddos_attack",
    raw_ddos_attack: "raw_ddos_attack"
};

function QoESubscribersFilterListItemModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.filter_id = Params&&Params.filter_id?Params.filter_id:0;
    this.parent_id = Params&&Params.parent_id?Params.parent_id:null;
    this.title = Params&&Params.title?Params.title:"";
    this.date = Params&&Params.date?Params.date:0;

    this.code = Params&&Params.code?Params.code:webix.uid().toString();
    this.expire_date = Params&&Params.expire_date?Params.expire_date:0;

    this.form_data = Params&&Params.form_data?Params.form_data:"";

    this.type = Params&&Params.type?Params.type:QoESubscribersFilterListItemTypeEnum.subs_clickstream;

    this.data = [];

    if(Params&&Params.data)
    {
        Params.data.forEach(function (ListItem)
        {
            __this.data.push(new QoESubscribersFilterListItemModel(ListItem));
        });
    }

    this.badge = 0;

    if (this.form_data) {

        var formData;

        try
        {
            formData = JSON.parse(this.form_data);
        }
        catch (error){}

        if (formData && formData.filter_state && formData.filter_state.length) {
            formData.filter_state.forEach(function (Obj) {
                if (Obj.f_enabled)
                    __this.badge++;
            });
        }
    }

    this.open = true;
    this.valid = true;
};

function QoEFiltersListFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"filter_id", order_dir:"desc"};
};

function QoEFilterFormModel(Params)
{
    this.filter_state = Params&&Params.filter_state?Params.filter_state:null;
    this.filter_dpi = Params&&Params.filter_dpi?Params.filter_dpi:null;
    this.filter_period = Params&&Params.filter_period?Params.filter_period:null;
};

function QoESavedFiltersListWidgetManager(Params)
{
    this.Active = true;

    this.FiltersList = [];
    this.FiltersListFilter = new QoEFiltersListFilterModel();

    this.SignalFiltersListUpdated = new Rx.BehaviorSubject(0);
    this.SignalFiltersListItemUpdated = new Rx.BehaviorSubject(0);

    this.FiltersByCode = {};
    this.SignalFiltersByCodeUpdated = new Rx.BehaviorSubject(0);
}

QoESavedFiltersListWidgetManager.prototype.Destroy = function ()
{
    this.Active = false;
};

QoESavedFiltersListWidgetManager.prototype.RefreshFiltersList = function(Params)
{
    var _this = this;

    var partial = Params&&Params.filters_ids ? true : false;

    if(!partial)
        this.CurrentFiltersListRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.FiltersListFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.FiltersListFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.FiltersListFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.FiltersListFilter.sort.order_by = Params.sort.id;
        this.FiltersListFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.FiltersListFilter.total.page,
        size:this.FiltersListFilter.total.size,

        order_by:this.FiltersListFilter.sort.order_by,
        order_dir:this.FiltersListFilter.sort.order_dir
    };

    Object.keys(this.FiltersListFilter.filter).forEach(function (Key)
    {
        if(_this.FiltersListFilter.filter[Key])
            filterParams[Key] = _this.FiltersListFilter.filter[Key];
    });

    var _params = filterParams;
    _params.filters_ids = partial?Params&&Params.filters_ids:null;

    if(!partial)
    {
        _params.parent_id_is_null = true;
    }

    var params =
        {
            id:this.CurrentFiltersListRequestId,
            method:"GetQoEFilters",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentFiltersListRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (Filter)
                            {
                                _this.SignalFiltersListItemUpdated.next(new QoESubscribersFilterListItemModel(Filter));
                            });
                        }
                    }
                    else
                    {
                        _this.FiltersList = [];
                        _this.FiltersListFilter.total.page = 0;
                        _this.FiltersListFilter.total.count = 0;

                        if(R.data)
                        {
                            R.data.rows.forEach(function (Filter)
                            {
                                _this.FiltersList.push(new QoESubscribersFilterListItemModel(Filter));
                            });

                            _this.FiltersListFilter.total.page = parseInt(R.data.page,10);
                            _this.FiltersListFilter.total.count = parseInt(R.data.count,10);
                        }

                        _this.SignalFiltersListUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoESavedFiltersListWidgetManager.prototype.GetFiltersList = function()
{
    return this.FiltersList;
};

QoESavedFiltersListWidgetManager.prototype.SaveFiltersListItem = function(Params)
{
    var _this = this;

    var filter = new QoESubscribersFilterListItemModel(Params&&Params.filter?Params.filter:null);
    var filterForm = new QoEFilterFormModel(Params&&Params.filter_form?Params.filter_form:null);

    var params =
        {
            id: filter.id,
            method:"SaveQoEFilter",
            data: {
                Filter: filter,
                Form: filterForm
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

QoESavedFiltersListWidgetManager.prototype.DeleteFiltersListItem = function(Params)
{
    var _this = this;

    var filter = new QoESubscribersFilterListItemModel(Params&&Params.filter?Params.filter:null);

    var params =
        {
            id: filter.id,
            method:"DeleteQoEFilter",
            data: {
                Filter: filter
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

QoESavedFiltersListWidgetManager.prototype.RefreshFiltersByCode = function(Params)
{
    var _this = this;

    if(!Params || !Params.code)
        return;

    this.CurrentFiltersByCodeRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    var _params =
    {
        code:Params.code
    };

    var params =
        {
            id:this.CurrentFiltersByCodeRequestId,
            method:"GetQoEFilters",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(_this.CurrentFiltersByCodeRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(R.data)
                    {
                        R.data.rows.forEach(function (Filter)
                        {
                            var filter = new QoESubscribersFilterListItemModel(Filter);

                            if(filter && filter.code)
                                _this.FiltersByCode[filter.code] = filter;
                        });
                    }
                }

                _this.SignalFiltersByCodeUpdated.next(_params.code);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoESavedFiltersListWidgetManager.prototype.GetFilterByCode = function(Code)
{
    return this.FiltersByCode[Code] ? webix.copy(this.FiltersByCode[Code]) : null;
};
function QoEWidgetModel(Params) {
    this.widget_id = Params&&Params.widget_id?parseInt(Params.widget_id):0;
    this.parent_id = Params&&Params.parent_id?parseInt(Params.parent_id):0;
    this.widget_icon = Params&&Params.widget_icon?Params.widget_icon:"";
    this.widget_code = Params&&Params.widget_code?Params.widget_code:"";
    this.widget_name = Params&&Params.widget_name?Params.widget_name:"";
    this.widget_settings = Params&&Params.widget_settings?Params.widget_settings:"";
    this.owner_id = Params&&Params.owner_id?Params.owner_id:0;
    this.available = Params&&Params.available?Params.available:"";
    this.available_for_roles = Params&&Params.available_for_roles?Params.available_for_roles:"";
    this.is_widget = Params&&Params.is_widget?parseInt(Params.is_widget):0;
    this.is_system = Params&&Params.is_system?parseInt(Params.is_system):0;
    this.func = Params&&Params.func?Params.func:"";
    this.dx = Params&&Params.dx?parseInt(Params.dx):0;
    this.dy = Params&&Params.dy?parseInt(Params.dy):0;
    this.form_config = Params&&Params.form_config?Params.form_config:"";
    this.filter_type = Params&&Params.filter_type?Params.filter_type:"";
    this.filter_config = Params&&Params.filter_config?Params.filter_config:"";

    if(Params&&Params.data) {
        this.data = [];
        Params.data.forEach(item => {
            this.data.push(new QoEWidgetModel(item));
        });
    }
};

function QoEWidgetGetModel(Params) {
    webix.extend(this, new QoEWidgetModel(Params), true);

    this.available_for_roles = Params && Params.available_for_roles ? (typeof Params.available_for_roles === "string" ? JSON.parse(Params.available_for_roles) : Params.available_for_roles) : "";
    this.widget_name = Params && Params.widget_name ? (typeof Params.widget_name === "string" ? JSON.parse(Params.widget_name) : Params.widget_name) : "";
    this.form_config = Params && Params.form_config ? (typeof Params.form_config === "string" ? JSON.parse(Params.form_config) : Params.form_config) : "";

    this.widget_settings = Params && Params.widget_settings ? Params.widget_settings : "";
    this.filter_config = Params && Params.filter_config ? Params.filter_config : "";

    if(this.widget_code.includes(CustomQoEAggLogsReportsKey)) {
        const m = new QoECustomReportModel({
            widget: Params.func,
            report_config_json: this.widget_settings ? this.widget_settings : null,
            filters_config_json: this.filter_config ? this.filter_config : null
        });
        this.widget_settings = m.report_config;
        this.filter_config = m.filters_config;
    } else {
        if(typeof this.widget_settings === "string" && this.widget_settings.length)
            this.widget_settings = JSON.parse(this.widget_settings);
        if(typeof this.filter_config === "string" && this.filter_config.length)
            this.filter_config = JSON.parse(this.filter_config);
    }
};

function QoEWidgetSaveModel(Params) {
    webix.extend(this, new QoEWidgetModel(Params), true);

    this.available_for_roles = Params && Params.available_for_roles ? (typeof Params.available_for_roles !== "string" ? JSON.stringify(Params.available_for_roles) : Params.available_for_roles) : "";
    this.widget_name = Params && Params.widget_name ? (typeof Params.widget_name !== "string" ? JSON.stringify(Params.widget_name) : Params.widget_name) : "";
    this.form_config = Params && Params.form_config ? (typeof Params.form_config !== "string" ? JSON.stringify(Params.form_config) : Params.form_config) : "";
    this.widget_settings = Params && Params.widget_settings ? (typeof Params.widget_settings !== "string" ? JSON.stringify(Params.widget_settings) : Params.widget_settings) : "";
};

function QoEWidgetValidateModel(Params) {
    this.func = Params && Params.func ? Params.func : null;
    this.value_priority = Params && Params.value_priority ? Params.value_priority : null;
    this.number_sign = Params && Params.number_sign ? Params.number_sign : null;
};

function QoEWidgetsSuggestWidgetManager () {
    this.Active = true;

    this.Widgets = [];

    this.SignalWidgetsUpdated = new Rx.BehaviorSubject(0);
};

QoEWidgetsSuggestWidgetManager.prototype.Destroy = function () {
    this.Active = false;
};

QoEWidgetsSuggestWidgetManager.prototype.GetWidgets = function() {
    return webix.copy(this.Widgets);
};

QoEWidgetsSuggestWidgetManager.prototype.GetWidgetModelArray = function(Array) {
    return Array.map(item => {
        const widget = new QoEWidgetGetModel(item);

        if(widget.data && widget.data.length) {
            widget.data = this.GetWidgetModelArray(widget.data);
        }

        return widget;
    });
};

QoEWidgetsSuggestWidgetManager.prototype.RefreshWidgets = function(Params) {
    const _this = this;

    if(!this.Active) {
        return;
    }

    const params = {
        method: "GetQoEWidgets",
        data: {},
        callback: function(R) {
            if(!R.success) {
                webix.message({type: "error", text: R.error.msg});
                return;
            }

            if(R.success) {
                if(R.data.rows) {
                    _this.Widgets = _this.GetWidgetModelArray(R.data.rows);
                    _this.FilterWidgets();
                    _this.SignalWidgetsUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback == "function") {
                    Params.callback();
                }
            }
        }
    };

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

QoEWidgetsSuggestWidgetManager.prototype.SaveWidget = function(Params) {
    if(!this.Active) {
        return;
    }

    const params = {
        method: "SaveQoEWidget",
        data: {
            WidgetModel: Params && Params.widget ? new QoEWidgetSaveModel(Params.widget) : null
        },
        callback: function(R) {
            if(Params && Params.callback && typeof Params.callback == "function") {
                Params.callback(R);
            }
        }
    };

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

QoEWidgetsSuggestWidgetManager.prototype.CopySettingsIntoNewWidget = function(Params) {
    if(!this.Active) {
        return;
    }

    let params = {
        method: "CopyQoEWidgetSettingsIntoNewWidget",
        data: {
            WidgetModel: Params && Params.widget ? new QoEWidgetSaveModel(Params.widget) : null
        },
        callback: function(R) {
            if(Params && Params.callback && typeof Params.callback == "function") {
                Params.callback(R);
            }
        }
    }

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

QoEWidgetsSuggestWidgetManager.prototype.DeleteWidget = function(Params) {
    let params = {
        method: "DeleteQoEWidget",
        data: {
            WidgetModel: Params && Params.widget ? new QoEWidgetSaveModel(Params.widget) : null
        },
        callback: function (R) {
            if(Params && Params.callback && typeof Params.callback === "function") {
                Params.callback(R);
            }
        }
    }

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

QoEWidgetsSuggestWidgetManager.prototype.FilterWidgets = function()
{
    let filterKeys = [];

    if(!AppEnv || !AppEnv.EnableVoipGroup)
        filterKeys.push(VoipProtocolsKey);

    let process = function(Arr, filterKeys)
    {
        let idxList = [];

        Arr.forEach((Item, Idx) => {
            if(Item && Item.data)
            {
                let resList = process(Item.data, filterKeys);

                if(resList.length > 0)
                    Item.data = Item.data.filter((_, Idx) => !resList.includes(Idx));

                if(Item.data.length === 0)
                    idxList.push(Idx);

            }
            else if(Item.func && filterKeys.map(Key => Item.func.includes(Key)).every(Boolean))
            {
                idxList.push(Idx);
            }
        });

        return idxList;
    }

    if(this.Widgets && filterKeys.length)
        process(this.Widgets, filterKeys);
};
var QoETriggerPeriodRangesEnum =
{
    "now":{start:"now", end:"now"},
    "now - 1 minute":{start:"now/-1 minute", end:"now"},
    "now - 5 minutes":{start:"now/-5 minute", end:"now"},
    "now - 10 minutes":{start:"now/-10 minute", end:"now"},
    "now - 15 minutes":{start:"now/-15 minute", end:"now"},
    "now - 20 minutes":{start:"now/-20 minute", end:"now"},
    "now - 30 minutes":{start:"now/-30 minute", end:"now"},
    "now - 45 minutes":{start:"now/-45 minute", end:"now"},

    "now - 1 hour":{start:"now/-1 hour", end:"now"},
    "now - 2 hours":{start:"now/-2 hour", end:"now"},
    "now - 3 hours":{start:"now/-3 hour", end:"now"},
    "now - 4 hours":{start:"now/-4 hour", end:"now"},
    "now - 5 hours":{start:"now/-5 hour", end:"now"},
    "now - 6 hours":{start:"now/-6 hour", end:"now"},
    "now - 12 hours":{start:"now/-12 hour", end:"now"},
    "now - 24 hours":{start:"now/-24 hour", end:"now"},

    "now - 2 days":{start:"now/-2 day", end:"now"},
    "now - 3 days":{start:"now/-3 day", end:"now"},
    "now - 4 days":{start:"now/-4 day", end:"now"},
    "now - 5 days":{start:"now/-5 day", end:"now"},
    "now - 6 days":{start:"now/-6 day", end:"now"},
    "now - 7 days":{start:"now/-7 day", end:"now"},
    "now - 15 days":{start:"now/-14 day", end:"now"},
    "now - 30 days":{start:"now/-30 day", end:"now"},
    "now - 90 days":{start:"now/-90 day", end:"now"},
    "now - 6 months":{start:"now/-6 month", end:"now"},
    "now - 1 year":{start:"now/-1 year", end:"now"},
    "now - 2 years":{start:"now/-2 year", end:"now"},
    "now - 5 years":{start:"now/-5 year", end:"now"}
};

var QoETriggerConditionFunctionsEnum =
{
    //"total":"total",
    "count":"count",
    "any":"any",
    "anyLast":"anyLast",
    "avg":"avg",
    "min":"min",
    "max":"max",
    "sum":"sum",
    "uniq":"uniq"
};

var QoETriggerConditionFunctionsCombinatorsEnum =
    {
        "isNotNaN":"isNotNaN",
        "isNotNull":"isNotNull",
        "isNaN":"isNaN",
        "isNull":"isNull"
    };

var QoETriggerConditionOperatorsEnum =
{
    "=":"=",
    "!=":"!=",
    ">":">",
    ">=":">=",
    "<":"<",
    "<=":"<=",
    "between":"between",
    "not between":"not between"
};

var QoETriggerAlertStateEnum =
{
    "alerting":"alerting",
    "no data":"no data",
    "keep last state":"keep last state",
    "ok":"ok"
};

var QoETriggerStateCodeEnum =
{
    "ready":"ready",
    "caching":"caching",
    "checking":"checking",
    "firing":"firing",
    "no_data":"no_data",
    "invalid":"invalid",
    "cache_error":"cache_error",
    "scheduled_ready": "scheduled_ready"
};

var QoETriggerSeverityEnum =
{
    "information":"information",
    "warning":"warning",
    "average":"average",
    "hight":"hight"
};

QoETriggerConditionWhereBindEnum = {
    and:"AND",
    or:"OR"
};

QoETriggerActionTypeEnum =
{
    "email":"email",
    "http":"http",
    "notification": "notification",
    "telegram": "telegram"
};

QoETriggerActionHttpMethodEnum =
{
    "GET":"GET",
    "POST":"POST"
};

QueryBodyTypesEnum = {
    "Raw": "Raw",
    "Form": "Form"
};

var QoETriggerAlertActionStateCodeEnum =
{
    "ready":"ready",
    "in progress":"in progress",
    "complete":"complete",
    "error":"error",
    "max attempts":"max attempts",
    "cancel":"cancel"
};

var QoETriggerTypeEnum = {
    "user": "user",
    "system" : "system",
    "report": "report",
    "scheduled": "scheduled"
};


function QoETriggerModel(Params)
{
    var __this = this;

    this._id = Params&&Params._id?Params._id:0;

    var common = new QoETriggerCommonModel(Params);
    Object.keys(common).forEach(function (Key)
    {
        __this[Key] = common[Key];
    });

    this.queries_json = Params&&Params.queries_json?Params.queries_json:"[]";

    this.conditions_json = Params&&Params.conditions_json?Params.conditions_json:"[]";

    this.when_nodata_or_error_json = Params&&Params.when_nodata_or_error_json?Params.when_nodata_or_error_json:"{}";

    this.actions_json = Params&&Params.actions_json?Params.actions_json:"[]";

    this.state = Params&&Params.state?Params.state:"{}";
    this.state_code = Params&&Params.state_code?Params.state_code:QoETriggerStateCodeEnum.ready;
    this.state_err = Params&&Params.state_err?Params.state_code:null;
    this.state_date = Params&&Params.state_date?Params.state_date:null;
    this.type = Params&&Params.type ? Params.type : QoETriggerTypeEnum.user;

    this.users_user_id = Params&&Params.users_user_id ? Params.users_user_id : 1;
    this.ulr_mailing_id = Params && Params.ulr_mailing_id ? Params.ulr_mailing_id : null;

    this.valid = true;
};

function QoETriggerCommonModel(Params)
{
    this.name = Params&&Params.name?Params.name:"";

    this.enabled = Params&&Params.enabled?parseInt(Params.enabled,10):0;
    this.severity = Params&&Params.severity?Params.severity:QoETriggerSeverityEnum.information;

    this.days_of_week = Params&&Params.days_of_week?Params.days_of_week.split(",").sort().join(","):"";
    this.date_from = Params&&Params.date_from?Params.date_from:null;
    this.date_to = Params&&Params.date_to?Params.date_to:null;
    this.time_from = Params&&Params.time_from?Params.time_from:null;
    this.time_to = Params&&Params.time_to?Params.time_to:null;
    this.evaluate_every_seconds = Params&&Params.evaluate_every_seconds?Params.evaluate_every_seconds:0;
    this.for_count = Params&&Params.for_count?Params.for_count:0;
};

function QoETriggerQueryModel(Params)
{
    var __this = this;

    this.id = webix.uid();

    this.enabled = Params&&Params.enabled?Params.enabled:0;

    this.name = Params&&Params.name?Params.name:"";
    this.report_name = Params&&Params.report_name?Params.report_name:"";

    this.widget_code = Params&&Params.widget_code?Params.widget_code:null;
    this.widget_name = Params&&Params.widget_name?Params.widget_name:null;
    this.widget_func = Params&&Params.widget_func?Params.widget_func:null;
    this.widget_config = Params&&Params.widget_config?Params.widget_config:null;
    this.widget_filter = Params&&Params.widget_filter?Params.widget_filter:null;
    this.widget_pdf_config = WidgetPdfConfigModel(Params);
    this.widget_max_execution_time = Params&&Params.widget_max_execution_time?Params.widget_max_execution_time:0;

    this.filter_config = Params&&Params.filter_config?Params.filter_config:null;
    this.filter_state = Params&&Params.filter_state?Params.filter_state:null;
    this.filter_type = Params&&Params.filter_type?Params.filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;

    if(this.filter_config && this.filter_config.type)
        this.filter_type = this.filter_config.type;

    this.badge = 0;

    if(this && this.filter_state && this.filter_state.length)
    {
        this.filter_state.forEach(function (Obj)
        {
            if(Obj.f_enabled)
                __this.badge++;
        });
    }

    this.period_from = Params&&Params.period_from?Params.period_from:null;
    this.period_to = Params&&Params.period_to?Params.period_to:null;

    this.valid = true;
};

function WidgetPdfConfigModel(Params)
{
    var model = Params?Params.widget_pdf_config:null;

    if(model)
    {
        switch(model.view_type)
        {
            case "chart":
                model.graph_line_type = model.graph_line_type ? model.graph_line_type : "stackedArea";
                model.series_config = model.series_config ? model.series_config : [];
                model.display_legend_stat = model.display_legend_stat ? model.display_legend_stat : 0;
                break;
            case "bar_chart":
                model.series_config = model.series_config ? model.series_config : [];
                model.display_legend_stat = model.display_legend_stat ? model.display_legend_stat : 0;
                break;
            case "table":
                let cols = model.columns_headers ? model.columns_headers.map(col => col.id) : [];
                model.columns_to_show = model.columns_to_show ? model.columns_to_show : cols;
                break;
        }

        model.page_orientation = model.page_orientation ? model.page_orientation : "auto";
        model.locales = model.locales ? model.locales : {};
    }

    return model;
};

function QoETriggerConditionModel(Params)
{
    var __this = this;

    this.id = webix.uid();

    this.enabled = Params&&Params.enabled?Params.enabled:0;

    this.where_bind = Params&&Params.where_bind?Params.where_bind:QoETriggerConditionWhereBindEnum.and;

    this.query_name = Params&&Params.query_name?Params.query_name:null;
    this.query_field = Params&&Params.query_field?Params.query_field:null;
    this.query_func = Params&&Params.query_func?Params.query_func:null;
    this.query_func_combinator = Params&&Params.query_func_combinator?Params.query_func_combinator:null;
    this.query_value = Params&&Params.query_value?Params.query_value:null;
    this.query_operator = Params&&Params.query_operator?Params.query_operator:null;

    this.valid = true;
};

function QoETriggerWhenNodataErrorModel(Params)
{
    this.no_data = Params&&Params.no_data?Params.no_data:QoETriggerAlertStateEnum["no data"];

    this.error = Params&&Params.error?Params.error:QoETriggerAlertStateEnum["keep last state"];
};

function QoETriggerActionModel(Params)
{
    this.type = Params&&Params.type?Params.type:QoETriggerActionTypeEnum.email;
    this.name = Params&&Params.name?Params.name:"";

    this.model = Params&&Params.model?Params.model:new QoETriggerActionEmailModel();
};

function QoETriggerActionEmailModel(Params)
{
    this.enabled = Params&&Params.enabled?parseInt(Params.enabled,10):0;

    this.to = Params&&Params.to?Params.to:"";
    this.subject = Params&&Params.subject?Params.subject:"";
    this.body = Params&&Params.body?Params.body:"";
    this.period_in_filename = Params&&Params.period_in_filename?Params.period_in_filename:0;
};

function QoETriggerActionHttpHeaderModel(Params)
{
    this.id = webix.uid();
    this.name = Params&&Params.name?Params.name:"";
    this.value = Params&&Params.value?Params.value:"";
};

function QoETriggerActionHttpModel(Params)
{
    this.enabled = Params&&Params.enabled?parseInt(Params.enabled,10):0;

    this.method = Params&&Params.method?Params.method:QoETriggerActionHttpMethodEnum.GET;
    this.url = Params&&Params.url?Params.url:"";
    this.body = Params&&Params.body?Params.body:"";
    this.headers = Params&&Params.headers?Params.headers:[];
};

function QoETriggerActionNotificationModel(Params)
{
    this.enabled = Params&&Params.enabled?parseInt(Params.enabled,10):0;

    this.title = Params&&Params.title?Params.title:"";
    this.subtitle = Params&&Params.subtitle?Params.subtitle:"";
    this.body = Params&&Params.body?Params.body:"";
    this.type = Params&&Params.type? Params.type : SocketNotificationsTypeEnum.warning;

};

function QoETriggerActionTelegramModel(Params)
{
    this.enabled = Params&&Params.enabled?parseInt(Params.enabled,10):0;

    this.chat_id = Params&&Params.chat_id?Params.chat_id:"";
    this.body = Params&&Params.body?Params.body:"";
    this.period_in_filename = Params&&Params.period_in_filename?Params.period_in_filename:0;
};

function QoETriggersFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"_id", order_dir:"desc"};
};



function QoETriggerAlertModel(Params)
{
    var __this = this;

    this._id = Params&&Params._id?Params._id:0;
    this.trigger_id = Params&&Params.trigger_id?Params.trigger_id:0;

    this.name = Params&&Params.name?Params.name:"";
    this.date = Params&&Params.date?Params.date:null;
    this.type = Params&&Params.type?Params.type:QoETriggerAlertStateEnum.ok;

    this.note = Params&&Params.note?Params.note:"";

    this.state = Params&&Params.state?Params.state:"{}";
    this.state_code = Params&&Params.state_code?Params.state_code:QoETriggerStateCodeEnum.ready;
    this.state_date = Params&&Params.state_date?Params.state_date:null;

    this.timezone = Params&&Params.timezone?Params.timezone:0;

    this.users_user_id = Params&&Params.users_user_id ? Params.users_user_id : 1;

    this.valid = true;
};

function QoETriggersAlertsFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"_id", order_dir:"desc"};
};



function QoETriggerAlertActionModel(Params)
{
    var __this = this;

    this._id = Params&&Params._id?Params._id:0;
    this.alert_id = Params&&Params.alert_id?Params.alert_id:0;

    this.date = Params&&Params.date?Params.date:null;
    this.type = Params&&Params.type?Params.type:QoETriggerAlertActionStateCodeEnum.email;

    this.note = Params&&Params.note?Params.note:"";

    this.model_json = Params&&Params.model_json?Params.model_json:"";

    this.state_json = Params&&Params.state_json?Params.state_json:"{}";
    this.state_code = Params&&Params.state_code?Params.state_code:QoETriggerStateCodeEnum.ready;
    this.state_date = Params&&Params.state_date?Params.state_date:null;

    this.timezone = Params&&Params.timezone?Params.timezone:0;

    this.users_user_id = Params&&Params.users_user_id ? Params.users_user_id : 1;

    this.valid = true;
};

function QoETriggersAlertsActionsFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"_id", order_dir:"desc"};
};


function QoETriggersManager()
{
    this.Active = true;

    this.QoETriggers = [];
    this.QoETriggersFilter = new QoETriggersFilterModel();
    this.SignalQoETriggersUpdated = new Rx.BehaviorSubject(0);
    this.CurrentQoETriggersRequestId = 0;

    this.QoETriggersAlerts = [];
    this.QoETriggersAlertsFilter = new QoETriggersAlertsFilterModel();
    this.SignalQoETriggersAlertsUpdated = new Rx.BehaviorSubject(0);
    this.CurrentQoETriggersAlertsRequestId = 0;

    this.QoETriggersAlertsActions = [];
    this.QoETriggersAlertsActionsFilter = new QoETriggersAlertsActionsFilterModel();
    this.SignalQoETriggersAlertsActionsUpdated = new Rx.BehaviorSubject(0);
    this.CurrentQoETriggersAlertsActionsRequestId = 0;
};

QoETriggersManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

QoETriggersManager.prototype.RefershQoETriggers = function(Params)
{
    var _this = this;

    this.CurrentQoETriggersRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.QoETriggersFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.QoETriggersFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.QoETriggersFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.QoETriggersFilter.sort.order_by = Params.sort.id;
        this.QoETriggersFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.QoETriggersFilter.total.page,
        size:this.QoETriggersFilter.total.size,

        order_by:this.QoETriggersFilter.sort.order_by,
        order_dir:this.QoETriggersFilter.sort.order_dir
    };

    Object.keys(this.QoETriggersFilter.filter).forEach(function (Key)
    {
        if(_this.QoETriggersFilter.filter[Key])
            filterParams[Key] = _this.QoETriggersFilter.filter[Key];
    });

    var params =
        {
            id:this.CurrentQoETriggersRequestId,
            method:"GetQoETriggers",
            data:{
                Params: filterParams
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(_this.CurrentQoETriggersRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    _this.QoETriggers = [];
                    _this.QoETriggersFilter.total.page = 0;
                    _this.QoETriggersFilter.total.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function (QoETrigger)
                        {
                            _this.QoETriggers.push(new QoETriggerModel(QoETrigger));
                        });

                        _this.QoETriggersFilter.total.page = parseInt(R.data.page,10);
                        _this.QoETriggersFilter.total.count = parseInt(R.data.count,10);
                    }

                    _this.SignalQoETriggersUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoETriggersManager.prototype.GetQoETriggers = function()
{
    return this.QoETriggers;
};

QoETriggersManager.prototype.GetQoETriggersAsDicArray = function()
{
    var r = [];

    if(this.QoETriggers)
    {
        this.QoETriggers.forEach(function (Item) {
            r.push({id: Item._id, value: Item.name});
        });
    }

    return r;
};

QoETriggersManager.prototype.SaveQoETrigger = function(Params)
{
    var _this = this;

    var QoETrigger = new QoETriggerModel(Params&&Params.QoETrigger?Params.QoETrigger:null);

    var params =
        {
            id: QoETrigger.id,
            method:"SaveQoETrigger",
            data: {
                QoETriggerModel: QoETrigger
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

QoETriggersManager.prototype.DeleteQoETrigger = function(Params)
{
    var _this = this;

    var QoETrigger = new QoETriggerModel(Params&&Params.QoETrigger?Params.QoETrigger:null);

    var params =
        {
            id: QoETrigger.id,
            method:"DeleteQoETrigger",
            data: {
                QoETriggerModel: QoETrigger
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};



QoETriggersManager.prototype.RefershQoETriggersAlerts = function(Params)
{
    var _this = this;

    this.CurrentQoETriggersAlertsRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.QoETriggersAlertsFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.QoETriggersAlertsFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.QoETriggersAlertsFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.QoETriggersAlertsFilter.sort.order_by = Params.sort.id;
        this.QoETriggersAlertsFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.QoETriggersAlertsFilter.total.page,
        size:this.QoETriggersAlertsFilter.total.size,

        order_by:this.QoETriggersAlertsFilter.sort.order_by,
        order_dir:this.QoETriggersAlertsFilter.sort.order_dir
    };

    Object.keys(this.QoETriggersAlertsFilter.filter).forEach(function (Key)
    {
        if(_this.QoETriggersAlertsFilter.filter[Key])
            filterParams[Key] = _this.QoETriggersAlertsFilter.filter[Key];
    });

    var params =
        {
            id:this.CurrentQoETriggersAlertsRequestId,
            method:"GetQoETriggersAlerts",
            data:{
                Params: filterParams
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(_this.CurrentQoETriggersAlertsRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    _this.QoETriggersAlerts = [];
                    _this.QoETriggersAlertsFilter.total.page = 0;
                    _this.QoETriggersAlertsFilter.total.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function (QoETriggerAlert)
                        {
                            _this.QoETriggersAlerts.push(new QoETriggerAlertModel(QoETriggerAlert));
                        });

                        _this.QoETriggersAlertsFilter.total.page = parseInt(R.data.page,10);
                        _this.QoETriggersAlertsFilter.total.count = parseInt(R.data.count,10);
                    }

                    _this.SignalQoETriggersAlertsUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoETriggersManager.prototype.GetQoETriggersAlerts = function()
{
    return this.QoETriggersAlerts;
};

QoETriggersManager.prototype.GetQoETriggersAlertsAsDicArray = function()
{
    var r = [];

    if(this.QoETriggersAlerts)
    {
        this.QoETriggersAlerts.forEach(function (Item) {
            r.push({id: Item._id, value: Item.name});
        });
    }

    return r;
};

QoETriggersManager.prototype.SaveQoETriggerAlert = function(Params)
{
    var _this = this;

    var QoETriggerAlert = new QoETriggerAlertModel(Params&&Params.QoETriggerAlert?Params.QoETriggerAlert:null);

    var params =
        {
            id: QoETriggerAlert.id,
            method:"SaveQoETriggerAlert",
            data: {
                QoETriggerAlertModel: QoETriggerAlert
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

QoETriggersManager.prototype.DeleteQoETriggerAlert = function(Params)
{
    var _this = this;

    var QoETriggerAlert = new QoETriggerAlertModel(Params&&Params.QoETriggerAlert?Params.QoETriggerAlert:null);

    var params =
        {
            id: QoETriggerAlert.id,
            method:"DeleteQoETriggerAlert",
            data: {
                QoETriggerAlertModel: QoETriggerAlert
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};



QoETriggersManager.prototype.RefershQoETriggersAlertsActions = function(Params)
{
    var _this = this;

    this.CurrentQoETriggersAlertsActionsRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.QoETriggersAlertsActionsFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.QoETriggersAlertsActionsFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.QoETriggersAlertsActionsFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.QoETriggersAlertsActionsFilter.sort.order_by = Params.sort.id;
        this.QoETriggersAlertsActionsFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.QoETriggersAlertsActionsFilter.total.page,
        size:this.QoETriggersAlertsActionsFilter.total.size,

        order_by:this.QoETriggersAlertsActionsFilter.sort.order_by,
        order_dir:this.QoETriggersAlertsActionsFilter.sort.order_dir
    };

    Object.keys(this.QoETriggersAlertsActionsFilter.filter).forEach(function (Key)
    {
        if(_this.QoETriggersAlertsActionsFilter.filter[Key])
            filterParams[Key] = _this.QoETriggersAlertsActionsFilter.filter[Key];
    });

    var params =
        {
            id:this.CurrentQoETriggersAlertsActionsRequestId,
            method:"GetQoETriggersAlertsActions",
            data:{
                Params: filterParams
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(_this.CurrentQoETriggersAlertsActionsRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    _this.QoETriggersAlertsActions = [];
                    _this.QoETriggersAlertsActionsFilter.total.page = 0;
                    _this.QoETriggersAlertsActionsFilter.total.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function (QoETriggerAlertAction)
                        {
                            _this.QoETriggersAlertsActions.push(new QoETriggerAlertActionModel(QoETriggerAlertAction));
                        });

                        _this.QoETriggersAlertsActionsFilter.total.page = parseInt(R.data.page,10);
                        _this.QoETriggersAlertsActionsFilter.total.count = parseInt(R.data.count,10);
                    }

                    _this.SignalQoETriggersAlertsActionsUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoETriggersManager.prototype.GetQoETriggersAlertsActions = function()
{
    return this.QoETriggersAlertsActions;
};

QoETriggersManager.prototype.GetQoETriggersAlertsActionsAsDicArray = function()
{
    var r = [];

    if(this.QoETriggersAlertsActions)
    {
        this.QoETriggersAlertsActions.forEach(function (Item) {
            r.push({id: Item._id, value: Item.name});
        });
    }

    return r;
};

QoETriggersManager.prototype.SaveQoETriggerAlertAction = function(Params)
{
    var _this = this;

    var QoETriggerAlertAction = new QoETriggerAlertActionModel(Params&&Params.QoETriggerAlertAction?Params.QoETriggerAlertAction:null);

    var params =
        {
            id: QoETriggerAlertAction.id,
            method:"SaveQoETriggerAlertAction",
            data: {
                QoETriggerAlertActionModel: QoETriggerAlertAction
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

QoETriggersManager.prototype.DeleteQoETriggerAlertAction = function(Params)
{
    var _this = this;

    var QoETriggerAlertAction = new QoETriggerAlertActionModel(Params&&Params.QoETriggerAlertAction?Params.QoETriggerAlertAction:null);

    var params =
        {
            id: QoETriggerAlertAction.id,
            method:"DeleteQoETriggerAlertAction",
            data: {
                QoETriggerAlertActionModel: QoETriggerAlertAction
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
let AvailableUsersEnum = {
    me_only: {id: "me_only", value: LangHelper.GetString("QoE", "To me only")},
    any_users: {id: "any_users", value: LangHelper.GetString("QoE", "To any users")},
    roles_users: {id: "roles_users", value: LangHelper.GetString("QoE", "To users with roles")}
};

let DashboardEditFormStatesEnum = {
    edit_template: "edit_template",
    edit_dashboard: "edit_dashboard",
    create_template: "create_template",
    create_dashboard: "create_dashboard"
};

function TableItemsChangeConfigModel(Params) {
    this.active = Params && Params.active ? Params.active : null;
    this.selectedId = Params && Params.selectedId ? Params.selectedId : null;
    this.changedId = Params && Params.changedId ? Params.changedId : null;
};

function QoEDashboardFilterModel(Params) {
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count: 0, page: 0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count: 0, page: 0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"dashboard_id", order_dir:"desc"};
};

function QoEDashboardModel(Params) {
    var ParseInt = function(Value) {
        var parsed = parseInt(Value, 10);

        return !isNaN(parsed) && isFinite(parsed) ? parsed : 0;
    }

    this.dashboard_id = Params&&Params.dashboard_id?ParseInt(Params.dashboard_id):0;
    this.dashboard_name = Params&&Params.dashboard_name?Params.dashboard_name:"";
    this.parent_dashboard_id = Params&&Params.parent_dashboard_id?ParseInt(Params.parent_dashboard_id):0;
    this.owner_id = Params&&Params.owner_id?ParseInt(Params.owner_id):0;
    this.is_template = Params&&Params.is_template?ParseInt(Params.is_template):0;
    this.is_system = Params&&Params.is_system?ParseInt(Params.is_system):0;
    this.available = Params&&Params.available?Params.available:"";
    this.available_for_roles = Params&&Params.available_for_roles?Params.available_for_roles:"";
    this.dashboard_state = Params&&Params.dashboard_state?Params.dashboard_state:"";
    this.filter_settings = Params&&Params.filter_settings?Params.filter_settings:"";

    if(Params&&Params.data) {
        this.data = [];
        Params.data.forEach(item => {
            this.data.push(new QoEDashboardModel(item));
        })
    }
};

function QoEDashboardGetModel(Params) {
    webix.extend(this, new QoEDashboardModel(Params), true);

    this.available_for_roles = Params && Params.available_for_roles ? (typeof Params.available_for_roles === "string" ? JSON.parse(Params.available_for_roles) : Params.available_for_roles) : "";
    this.dashboard_state = Params && Params.dashboard_state ? (typeof Params.dashboard_state === "string" ? JSON.parse(Params.dashboard_state) : Params.dashboard_state) : "";
};

function QoEDashboardSaveModel(Params) {
    webix.extend(this, new QoEDashboardModel(Params), true);

    this.available_for_roles = Params && Params.available_for_roles ? (typeof Params.available_for_roles !== "string" ? JSON.stringify(Params.available_for_roles) : Params.available_for_roles) : "";
    this.dashboard_state = Params && Params.dashboard_state ? (typeof Params.dashboard_state !== "string" ? JSON.stringify(Params.dashboard_state) : Params.dashboard_state) : "";
};

function QoEDashboardFilterSettingsModel(Params) {
    this.filter = Params&&Params.filter?Params.filter:null;
    this.filter_form = Params&&Params.filter_form?Params.filter_form:null;
};

function QoERoleModel(Params) {
    this.id = Params&&Params.id?Params.id:0;
    this.allow = Params&&Params.available_for_roles?(Params.available_for_roles.includes(this.id)?1:0):0;
    this.value = Params&&Params.value?Params.value:"";
};

function QoEDashboardManager(Params) {
    this.Active = true;

    this.Dashboards = [];
    this.Templates = [];

    this.DashboardsFilter = new QoEDashboardFilterModel();
    this.TemplatesFilter = new QoEDashboardFilterModel();

    let total = {
        size: 100,
        group: 5,
        count: 0,
        page: 0
    };

    this.TotalDashboards = webix.copy(total);
    this.TotalTemplates = webix.copy(total);

    this.SignalDashboardsUpdated = new Rx.BehaviorSubject(0);
    this.SignalTemplatesUpdated = new Rx.BehaviorSubject(0);
};

QoEDashboardManager.prototype.Destroy = function(Params) {
    this.Active = false;
};

QoEDashboardManager.prototype.SaveDashboard = function(DashboardModel, CallBack) {
    let params = {
        method: "SaveQoEDashboard",
        data: {
            DashboardModel: DashboardModel
        },
        callback: function (R) {
            if (CallBack && typeof CallBack === "function") {
                CallBack(R);
            }
        }
    };

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

QoEDashboardManager.prototype.Delete = function(Params) {
    let params = {
        method: "DeleteQoEDashboard",
        data: {
            DashboardModel: Params && Params.dashboard ? Params.dashboard : null
        },
        callback: function (R) {
            if(Params && Params.callback && typeof Params.callback === "function") {
                Params.callback(R);
            }
        }
    }

    if(this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

QoEDashboardManager.prototype.GetDashboards = function() {
    return webix.copy(this.Dashboards);
};

QoEDashboardManager.prototype.GetTemplates = function() {
    return webix.copy(this.Templates);
};

QoEDashboardManager.prototype.RefreshDashboards = function(Params) {
    let _this = this;

    this.Refresh({
        FilterObj: this.DashboardsFilter,
        TotalObj: this.TotalDashboards,
        Page: Params.page,
        Size: Params.size,
        Filter: Params.filter,
        Sort: Params.sort,
        is_template: 0,
        pagination_param: Params.pagination_param,
        PushFunc: function(Data) {
            _this.Dashboards = _this.GetDashboardModelArray(Data);
            _this.SignalDashboardsUpdated.next(1);
        }
    });
};

QoEDashboardManager.prototype.RefreshTemplates = function(Params) {
    let _this = this;

    this.Refresh({
       FilterObj: this.TemplatesFilter,
       TotalObj: this.TotalTemplates,
       Page: Params.page,
       Size: Params.size,
       Filter: Params.filter,
       Sort: Params.sort,
       is_template: 1,
       pagination_param: Params.pagination_param,
       PushFunc: function(Data) {
           _this.Templates = _this.GetDashboardModelArray(Data);
           _this.SignalTemplatesUpdated.next(1);
       }
    });
}

QoEDashboardManager.prototype.Refresh = function(Params) {
    let _this = this;

    if(!_this.Active) {
        return;
    }

    if(!(Params.PushFunc&& typeof Params.PushFunc=="function")) {
        return;
    }

    if(Params&&Params.Page >= 0) {
        Params.FilterObj.total.page = parseInt(Params.Page, 10);
    }

    if(Params&&Params.Size&&Params.Size >= 0) {
        Params.FilterObj.total.size = parseInt(Params.Size, 10);
    }

    if(Params&&Params.Sort) {
        Params.FilterObj.sort.order_by = Params.Sort.id;
        Params.FilterObj.sort.order_dir = Params.Sort.dir;
    }

    if(Params&&Params.Filter)
    {
        Params.FilterObj.filter = Params.Filter;
    }

    if(Params&&Params.Page >= 0) {
        Params.TotalObj.page = parseInt(Params.Page, 10);
    }

    let filterParams = {
        page: Params.TotalObj.page,
        size: Params.TotalObj.size,

        order_by: Params.FilterObj.sort.order_by,
        order_dir: Params.FilterObj.sort.order_dir
    };

    Object.keys(Params.FilterObj.filter).forEach(Key => {
       if(Params.FilterObj.filter[Key]) {
           filterParams[Key] = Params.FilterObj.filter[Key];
       }
    });

    let _params = filterParams;

    _params.is_template = Params&&Params.is_template>=0?Params.is_template:null;
    _params.pagination_param = Params&&Params.pagination_param>=0?Params.pagination_param:null;

    let params = {
        method: "GetQoEDashboards",
        data: {
            DashboardModel: _params
        },
        callback: function(R) {
            if(!R.success) {
                webix.message({type: "error", text: R.error.msg});
            }

            if(R.success) {
                Params.FilterObj.total.page = 0;
                Params.FilterObj.total.count = 0;

                if(R.data) {
                    Params.TotalObj.page = parseInt(R.data.page, 10);
                    Params.TotalObj.count = parseInt(R.data.count, 10);

                    Params.PushFunc(R.data.rows);
                }
            }

            if(Params && Params.callback && typeof Params.callback == "function") {
                Params.callback(R);
            }
        }
    }
     if(this.Active) {
         App.ServerManager.CallMethod(params);
     }
};

QoEDashboardManager.prototype.GetTemplateByName = function(Params) {
    let _this = this;

    let _params = {
        size: Params && Params.size ? Params.size : 25,
        is_template: 1
    }

    if(Params && Params.dashboard_name) {
        _params.dashboard_name = Params.dashboard_name;
    }

    if (!this.Active) {
        return;
    }

    var params =
        {
            method: "GetQoEDashboards",
            data: {
                DashboardModel: _params
            },
            callback: function (R) {
                if (R.success) {
                    if(R.data.rows) {
                        _this.Templates = _this.GetDashboardModelArray(R.data.rows);
                    }
                    if (Params && Params.callback && typeof Params.callback === "function") {
                        Params.callback();
                    }
                } else {
                    webix.message({type: "error", text: R.error.msg});
                }
            }
        };

    if (this.Active) {
        App.ServerManager.CallMethod(params);
    }
}

QoEDashboardManager.prototype.GetDashboardModelArray = function(Array) {
    return Array.map(item => {
        let dashboard = new QoEDashboardGetModel(item);
        dashboard.filter_settings = new QoESubscribersFilterListItemModel(dashboard.filter_settings);

        if(dashboard.data && dashboard.data.length) {
            dashboard.data = this.GetDashboardModelArray(dashboard.data);
        }

        return dashboard;
    });
};
const EditableSeriesChartSeriesWidgetList = [
    "QoESeriesChartTrafficWidget",
    "QoESeriesChartFlowWidget",
    "QoERttDistributionWidget",
    "QoERttByTimeWidget",
    "QoESeriesChartRetransmitsByTimeWidget"
];

const StackedAreaChartTypeWidgetList = [
    "QoESeriesChartTrafficByProtocolsWidget",
    "QoESeriesChartTrafficByAppProtocolsWidget",
    "QoESeriesChartTrafficByAppProtocolsGroupsWidget",
    "QoESeriesChartTrafficByASWidget",
    "QoESeriesChartTrafficByVchannelsWidget",
    "QoESeriesChartTrafficByClassesWidget",
    "QoETableQoETableSeriesChartTrafficByFullDscpClassesWidget",
    "QoESeriesChartFlowByProtocolsWidget",
    "QoESeriesChartFlowByAppProtocolsWidget",
    "QoESeriesChartFlowByAppProtocolsGroupsWidget",
    "QoESeriesChartFlowByVchannelsWidget",
    "QoESeriesChartFlowByClassesWidget",
    "QoETableChartFlowByFullDscpClassesWidget",
    "QoESeriesChartNetflowTrafficByVoipProtocolsWidget"
];

const AggPeriodOnlyAutoSeriesChartSeriesWidgetList = [
    "QoERttDistributionWidget"
];

const GeneralReportSettingsEnum = {
    reports_manual_refresh: {id:"reports_manual_refresh", value:LangHelper.GetString("AppView", "Manual refresh")},
    create_report_task: {id:"create_report_task", value:LangHelper.GetString("QoE", "Create report task")}
};

const SortDirectionSettingsEnum = {
    desc: {id: "desc", value: LangHelper.GetString("AppView", "Descending")},
    asc: {id: "asc", value: LangHelper.GetString("AppView", "Ascending")}
};

const ChartYScaleDetailsLevelDic = {
    auto: {id:"auto", value:LangHelper.GetString("AppView", "Auto")},
    low: {id:"low", value:LangHelper.GetString("AppView", "Low")},
    medium: {id:"medium", value:LangHelper.GetString("AppView", "Medium")},
    high: {id:"high", value:LangHelper.GetString("AppView", "High")}
};

const ReportSettingsEnum = {
    group_by: {id: "group_by", section_name: "GroupReportBy"},
    columns_to_show: {id: "columns_to_show", section_name: "EnableColumnsFormSection"},
    sort_id: {id: "sort_id", section_name: "SortId"},
    sort_dir: {id: "sort_dir", section_name: "SortDir"},
    enable_series: {id: "enable_series", section_name: "EnableSeriesFormSection"},
    agg_period: {id: "agg_period", section_name: "AggPeriodFormSection"},
    rows_limit: {id: "rows_limit", section_name: "RowsLimitFormSection"},
    graph_line_type: {id: "graph_line_type", section_name: "GraphLineTypeSection"},
    chart_scale_type: {id: "chart_scale_type", section_name: "ChartScaleType"},
    chart_order_by: {id: "chart_order_by", section_name: "ChartOrderReportBy"},
    chart_sort_dir: {id: "chart_sort_dir", section_name: "ChartSortDirection"},
    report_name: {id: "report_name", section_name: "ReportNameSection"},
    display_filter: {id: "display_filter", section_name: "DisplayFilterFormSection"},
    page_orientation: {id: "page_orientation", section_name: "PageOrientationFormSection"},
    y_axis_detail_level: {id: "y_axis_detail_level", section_name: "yAxisDetailLevel"},
    display_legend_stat: {id: "display_legend_stat", section_name: "displayLegendStat"}
};

DashboardReportSettingsDataModel = function(Params)
{
    this.settings_id = Params && Params.settings_id ? Params.settings_id : null;
    this.dashboard_id = Params && Params.dashboard_id ? Params.dashboard_id : null;
    this.cur_id = Params && Params.cur_id ? Params.cur_id : null;
    this.prev_id = Params && Params.prev_id ? Params.prev_id : null;
};

PdfReportSettingsOptionsModel = function(Params)
{
    this.report_name = Params && Params.report_name ? Params.report_name : "";
    this.display_filter = Params && Params.display_filter ? Params.display_filter : "0";
    this.page_orientation = Params && Params.page_orientation ? Params.page_orientation : OrientationDic.auto.id;
};

ChartPdfReportSettingsOptionsModel = function(Params)
{
    PdfReportSettingsOptionsModel.call(this, Params);

    this.y_axis_detail_level = Params && Params.y_axis_detail_level ? Params.y_axis_detail_level : ChartYScaleDetailsLevelDic.auto.id;
    this.display_legend_stat = Params && Params.display_legend_stat ? Params.display_legend_stat : YesNoDic["0"].id;
}

TableReportSettingsOptionsModel = function(Params)
{
    this.columns_to_show = Params && Params.columns_to_show ? Params.columns_to_show : [];
    this.rows_limit = Params && Params.rows_limit ? Params.rows_limit: 100000;
    this.sort_id = Params && Params.sort_id ? Params.sort_id : null;
    this.sort_dir = Params && Params.sort_dir ? Params.sort_dir : null;
};

TableReportSettingsWithGroupByOptionsModel = function(Params)
{
    TableReportSettingsOptionsModel.call(this, Params);

    this.group_by = Params && Params.group_by ? Params.group_by : [];
    this.group_by_required = Params && Params.group_by_required ? Params.group_by_required : [];
};

SeriesChartReportSettingsOptionsModel = function(Params)
{
    this.agg_period = Params && Params.agg_period ? Params.agg_period : ChartsTimeStepsDic.auto.id;
    this.graph_line_type = Params && Params.graph_line_type ? Params.graph_line_type : ChartTypesDic.splineArea.id;
    this.chart_scale_type = Params && Params.chart_scale_type ? Params.chart_scale_type : ChartScalesDic.linear.id;
    this.chart_order_by = Params && Params.chart_order_by ? Params.chart_order_by : null;
};

GetCustomSettingsOptionsModelClosure = function(DefaultParams)
{
    return function(Params) {
        for (let key in DefaultParams) {
            if (DefaultParams.hasOwnProperty(key)) {
                this[key] = (Params && Params[key] !== undefined)
                    ? Params[key]
                    : DefaultParams[key];
            }
        }
    }
}

RowsLimitSeriesChartReportSettingsOptionsModel = function(Params)
{
    SeriesChartReportSettingsOptionsModel.call(this, Params);
    this.rows_limit = Params && Params.rows_limit ? Params.rows_limit: 100000;
};

EditableSeriesChartReportSettingsOptionsModel = function(Params)
{
    SeriesChartReportSettingsOptionsModel.call(this, Params);
    this.enable_series = Params && Params.enable_series ? Params.enable_series : [];
};

RowsLimitSeriesChartReportSettingsOptionsModelMyReportExtend = function(Params)
{
    RowsLimitSeriesChartReportSettingsOptionsModel.call(this, Params)
    this.chart_sort_dir = Params && Params.chart_sort_dir ? Params.chart_sort_dir : null;
};

PieChartReportSettingsOptionsModel = function(Params)
{
    this.rows_limit = Params && Params.rows_limit ? Params.rows_limit: 10;
};

ReportSettingsModel = function(Params)
{
    this.id = Params && Params.id ? Params.id : null;

    this._id = Params && Params._id ? Params._id : null;
    this.widget_id = Params && Params.widget_id ? Params.widget_id : null;
    this.dashboard_id = Params && Params.dashboard_id ? Params.dashboard_id : null;
    this.title = Params && Params.title ? Params.title : null;
    this.config = Params && Params.config ? Params.config : null;
    this.create_time = Params && Params.create_time ? Params.create_time : null;
    this.update_time = Params && Params.update_time ? Params.update_time : null;
    this.create_user = Params && Params.create_user ? Params.create_user : null;
    this.update_user = Params && Params.update_user ? Params.update_user : null;
};

WidgetReportSettingsModel = function(Params)
{
    this.widget_id = Params && Params.widget_id ? Params.widget_id : null;

    this.widget_name = Params && Params.widget_name ? Params.widget_name : null;

    this.suggest_widget_code = Params && Params.suggest_widget_code ? Params.suggest_widget_code : null;
    this.suggest_widget_func = Params && Params.suggest_widget_func ? Params.suggest_widget_func : null;

    this.dashboard_id = Params && Params.dashboard_id ? Params.dashboard_id : null;

    this.widget = Params && Params.widget ? Params.widget : null;

    this.can_update_widget = Params && Params.can_update_widget ? true: false;

    // Blocks external model property changes
    // Used to prioritize sort settings in the tableChartWidget
    this.external_lock = true;

    this._exceptional_props = Params && Params.exceptional_props ? Params.exceptional_props : [];
    this._pdf_props = Params && Params.pdf_props ? Params.pdf_props : [];

    this.custom_options = Params && Params.custom_options ? Params.custom_options : null;

    if(this.custom_options)
        this.ReDefineExceptionalProps()

    this._cur_common_state = Params && Params.cur_common_state ? Params.cur_common_state : this.GetCurCommonState();
    this.prev_common_state = Params && Params.prev_common_state ? Params.prev_common_state : this.GetCurCommonState();
    this.default_common_state = Params && Params.default_common_state ? Params.default_common_state : this.GetCurCommonState();

    this.show_settings_btn = Params && Params.show_settings_btn ? Params.show_settings_btn : null;
    this.show_settings_btn_event_id = Params && Params.show_settings_btn_event_id ? Params.show_settings_btn_event_id : null;
    this.selected_saved_setting_id = Params && Params.selected_saved_setting_id ? Params.selected_saved_setting_id : null;

    this.exceptional_props_model_func = Params && Params.exceptional_props_model_func ? Params.exceptional_props_model_func : TableReportSettingsOptionsModel;
    this.pdf_props_model_func = Params && Params.pdf_props_model_func ? Params.pdf_props_model_func : PdfReportSettingsOptionsModel;

    Object.defineProperty(this, "cur_common_state", {
        get: function() {
            return this._cur_common_state;
        },
        set: function(newState) {
            this.prev_common_state = webix.copy(this._cur_common_state);
            this._cur_common_state = newState;

            this.Refresh();
        }
    });

    this.Refresh();
};

WidgetReportSettingsModel.prototype.Refresh = function()
{
    this.DefineSettingsBtnBadge();

    if(this.can_update_widget)
    {
        if(this.widget && typeof this.widget.RefreshUIByReportSettings === 'function')
            this.widget.RefreshUIByReportSettings(this);

        if(this.widget && typeof this.widget.RefreshPdfExportConfig === 'function')
            this.widget.RefreshPdfExportConfig(webix.copy(this.GetReportSettings(true)));
    }
}

WidgetReportSettingsModel.prototype.DefineSettingsBtnBadge = function()
{
    if(this.show_settings_btn)
    {
        let countDiff = Helper.CountReportSettingsStateChanges(this._cur_common_state, this.default_common_state).by_keys

        this.show_settings_btn.define("badge", countDiff);
        this.show_settings_btn.refresh();
    }
}

WidgetReportSettingsModel.prototype.SaveSettings = function()
{
    if(this.widget && this.widget.ReportsSettingsManager)
    {
        let manager = this.widget.ReportsSettingsManager;

        let model = new ReportSettingsModel({
            widget_id: this.widget_id,
            dashboard_id: this.dashboard_id,
            config: JSON.stringify(this.cur_common_state),
            create_user: manager.CurUserProfile.user_id,
            update_user: manager.CurUserProfile.user_id
        });

        manager.SaveReportSettings(model, true);
    }
}

WidgetReportSettingsModel.prototype.GetCurCommonState = function()
{
    let result = {};

    [this._exceptional_props, this._pdf_props].forEach((Prop) => {
        Object.entries(Prop).forEach(([key, value]) => {
            result[key] = value;
        });
    });

    return result;
};

WidgetReportSettingsModel.prototype.GetReportSettings = function(IsMap = true)
{
    let _this = this;
    let curState = webix.copy(this.cur_common_state);

    if(IsMap && this.widget && this.widget.SortMap)
    {
        if(curState.columns_to_show)
            Object.keys(this.widget.SortMap).forEach(function (Key)
            {
                if(!_this.default_common_state.columns_to_show.includes(_this.widget.SortMap[Key]))
                {
                    let idx = curState.columns_to_show.findIndex(item => item === Key);
                    if(idx > -1)
                        curState.columns_to_show[idx] = _this.widget.SortMap[Key];
                }
            });

        if(curState.sort_id && this.widget.SortMap[curState.sort_id])
            curState.sort_id = this.widget.SortMap[curState.sort_id];
    }

    curState.is_dashboard = this.dashboard_id ? 1 : 0;
    curState.widget_name = this.widget_name ? this.widget_name : null;
    curState.widget_id = this.widget_id ? this.widget_id : null;

    return curState;
};

WidgetReportSettingsModel.prototype.SetCurState = function(Params, IsMap = false)
{
    let _this = this;

    if(IsMap && Params.columns_to_show && this.widget.SortMap) {
        if(this.widget.CanUseSortMap && this.widget.CanUseSortMap.ReportsSettings)
        {
            Params.columns_to_show = Params.columns_to_show.map(colId => {
                let findFunc = (Obj) => {
                    return Object.entries(Obj).find(([Key, Val]) => Val === colId);
                };

                let found = findFunc(_this.widget.SortMap);

                if(!found && _this.widget.Views.Table) {
                    _this.widget.Views.Table.eachColumn(
                        function(ColId, ColConfig) {
                            if(found)
                                return;

                            if(ColConfig.sort_map)
                                found = findFunc(ColConfig.sort_map)
                        }
                    );
                }

                return found ? found[0] : colId;
            });
        }
    }
    
    Object.keys(this._exceptional_props).forEach(Key => {
        if(Key.endsWith("required"))
            Params[Key] = this._exceptional_props[Key];
    });

    if(Params && !Params["chart_order_by"] && this._cur_common_state.chart_order_by)
        Params["chart_order_by"] = this._cur_common_state.chart_order_by;

    if(Params && !Params["sort_id"] && this._cur_common_state.sort_id)
        Params["sort_id"] = this._cur_common_state.sort_id;

    if(Params && !Params["sort_dir"] && this._cur_common_state.sort_dir)
        Params["sort_dir"] = this._cur_common_state.sort_dir;

    this._exceptional_props = new this.exceptional_props_model_func(Params);
    this._pdf_props = new this.pdf_props_model_func(Params);
    this.cur_common_state = this.GetCurCommonState();
};

WidgetReportSettingsModel.prototype.IsDiffWithPrev = function(Mode = null)
{
    const checkUiRefresh = [
        "columns_to_show",
        "group_by",
        "enable_series",
        "graph_line_type",
        "chart_scale_type",
        "chart_order_by"
    ];

    const checkDataRefresh = checkUiRefresh.concat([
        "agg_period",
        "rows_limit",
        "sort_id",
        "sort_dir"
    ]);

    let checkLists = {
        checkUiRefresh: checkUiRefresh,
        checkDataRefresh: checkDataRefresh
    };

    let checkList = Mode && checkLists[Mode] ? checkLists[Mode] : null;

    let state = webix.copy(this.cur_common_state);
    let compareState = webix.copy(this.prev_common_state);

    if(checkList)
    {
        [state, compareState].forEach((Prop) => {
            Object.keys(Prop).forEach((key) => {
                if(!checkList.includes(key))
                {
                    delete Prop[key];
                }
            });
        });
    }

    let stateKeys = Object.keys(state);
    let compareKeysSet = new Set(Object.keys(compareState));

    let hasSameKeys =
        stateKeys.length === compareKeysSet.size &&
        stateKeys.every(key => compareKeysSet.has(key));

    if(!hasSameKeys) {
        return false;
    }

    return Boolean(
        Helper.CountReportSettingsStateChanges(state, compareState).by_vals
    );
};

WidgetReportSettingsModel.prototype.IsDiffWithDefault = function()
{
    return Helper.CountReportSettingsStateChanges(this.cur_common_state, this.default_common_state).by_keys ? true : false;
};

WidgetReportSettingsModel.prototype.GetCurSeriesStateByIdx = function()
{
    let result;

    if(this.default_common_state.enable_series && this.cur_common_state.enable_series)
    {
        result = [];

        this.default_common_state.enable_series.forEach(id => {
            if(this.cur_common_state.enable_series.includes(id))
            {
                result.push(1);
            }
            else
            {
                result.push(0);

            }
        });
    }

    return result;
};

WidgetReportSettingsModel.prototype.ResetShowBtnEvent = function()
{
    if(this.show_settings_btn && this.show_settings_btn_event_id)
    {
        this.show_settings_btn.detachEvent(this.show_settings_btn_event_id);
        this.show_settings_btn_event_id = null;
    }
};

WidgetReportSettingsModel.prototype.BindShowBtnEvent = function(Callback)
{
    if(Callback && this.show_settings_btn)
        this.show_settings_btn_event_id = this.show_settings_btn.attachEvent("onItemClick", Callback);
};

WidgetReportSettingsModel.prototype.GetPdfExportConfig = function(FilterWidget)
{
    let config = {};

    if(!this.can_update_widget)
        this.widget.DefineExportPdfConfig(webix.copy(this.cur_common_state));

    config = webix.copy(this.widget.PdfExportConfig);

    if(FilterWidget)
        config.locales.filter_section = FilterWidget.GetLocales();

    return config;
};

WidgetReportSettingsModel.prototype.ReconfigReportQuery = function(QueryConfig = null)
{
    if(!QueryConfig && this.widget.ViewModel) {
        let config = this.widget.ViewModel.GetReportConfig(this.widget.Id);
        QueryConfig = Helper.IsConfig(config) ? config.config : null;
    }

    if(!QueryConfig)
        return;

    const state = this.cur_common_state;

    if(Helper.IsTableWidget(this.widget))
    {
        let sort = QueryConfig.sort;

        if(!Helper.IsObject(sort))
            sort = {};

        sort.id = state.sort_id ? state.sort_id : sort.id;
        sort.dir = state.sort_dir ? state.sort_dir : sort.dir;

        if(sort.id && this.widget.SortMap[sort.id])
            sort.id = this.widget.SortMap[sort.id];

        if(!sort.dir)
            sort.dir = SortDirectionSettingsEnum.desc.id;

        if(sort.id && sort.dir)
            QueryConfig.sort = sort;

        if(state.rows_limit)
            QueryConfig.limit = state.rows_limit;
    }

    if(Helper.IsChartWidget(this.widget))
    {
        if(state.agg_period)
            QueryConfig.agg_period = state.agg_period;

        if(state.rows_limit) {
            let limit = parseInt(state.rows_limit);

            if(!limit || isNaN(limit) || limit > this.widget.DefaultGetTopListLimit)
                limit = this.widget.DefaultGetTopListLimit;

            if(Helper.HasColsValues(QueryConfig))
                QueryConfig.cols[0].values = QueryConfig.cols[0].values.slice(0, limit);

            if(Helper.IsGetTopList(QueryConfig))
                QueryConfig.cols[0].values.params.limit = limit;
        }

        if(state.chart_order_by) {
            let conditionCol, sqlTpl, getTopListFunc, enumKey;

            if(Helper.HasTable(QueryConfig)) {
                const parts = QueryConfig.table.split(".");
                enumKey = parts[parts.length - 1];
            }

            if(Helper.HasCols(QueryConfig) && Helper.IsObject(QueryConfig.cols[0])) {
                conditionCol = QueryConfig.cols[0].col;

                if(conditionCol)
                    sqlTpl = GetQoEReportsSerieChartSqlTpl(conditionCol, state.chart_order_by, enumKey);

                if(sqlTpl) {
                    QueryConfig.cols[0].sql_tpl = sqlTpl;

                    if(this.can_update_widget)
                        this.widget.DefineAxisTemplate("yAxis", state.chart_order_by);
                }
            }

            if(Helper.IsGetTopList(QueryConfig)) {
                getTopListFunc = GetQoEReportsSerieChartGetTopListFunc(state.chart_order_by, enumKey);

                if(getTopListFunc)
                    QueryConfig.cols[0].values.params.func = getTopListFunc;
            }
        }

        if(state.chart_sort_dir) {
            if(Helper.IsGetTopList(QueryConfig))
                QueryConfig.cols[0].values.params.dir = state.chart_sort_dir;
        }
    }

    if(Helper.IsPieChartWidget(this.widget))
    {
        if(state.rows_limit) {
            QueryConfig.limit = state.rows_limit;
            QueryConfig.size = state.rows_limit;
        }
    }

    return QueryConfig;
};

WidgetReportSettingsModel.prototype.ReDefineExceptionalProps = function()
{
    if(!this.custom_options)
        return;

    Object.keys(this.custom_options).forEach(Key => {
        if(Key === "allowed_chart_steps") {
            const options = this.custom_options["allowed_chart_steps"];
            const val = this._exceptional_props["agg_period"];

            if(val && Array.isArray(options) && !options.includes(val))
                this._exceptional_props["agg_period"] = options[0];
        }
    });
};


function QoEReportsSettingsManager()
{
    let _this = this;

    this.Active = true;

    this.CurUserProfile = App.SessionManager.GetProfile();

    this.ReportsSettings = {};

    this.Signals = {
        ReportSettingsBtnClick: new Rx.BehaviorSubject(0),

        Progress: new Rx.BehaviorSubject(0),

        SaveReportSettingsSuccess: new Rx.BehaviorSubject(0),
        SaveReportSettingsError: new Rx.BehaviorSubject(0),

        DeleteReportSettingsSuccess: new Rx.BehaviorSubject(0),
        DeleteReportSettingsError: new Rx.BehaviorSubject(0),

        GetLastAppliedReportsSettingsSuccess: new Rx.BehaviorSubject(0),
        GetLastAppliedReportsSettingsError: new Rx.BehaviorSubject(0),

        ServerError: new Rx.BehaviorSubject(0)
    };

    this.Subscriptions = {};

    this.Subscriptions.MyProfileUpdatedSignalSubscription = App.SessionManager.MyProfileUpdatedSignal.subscribe(function (MyProfileUpdated) {
        if(MyProfileUpdated)
        {
            let curUser = App.SessionManager.GetProfile();
            if(curUser && curUser.user_id)
            {
                _this.CurUserProfile = curUser;
            }
        }
    });
};

QoEReportsSettingsManager.prototype.GetSettingsModel = function(Id)
{
    return this.ReportsSettings[Id];
};

QoEReportsSettingsManager.prototype.Destroy = function ()
{
    let _this = this;

    this.Active = false;

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        _this.Subscriptions[Key].unsubscribe();
    });

    this.Signals = {};
    this.ReportsSettings = {};
};

QoEReportsSettingsManager.prototype.ReadFromStorage = function(Key)
{
    let state = webix.storage.local.get(Key);
    return state ? 1: 0;
};

QoEReportsSettingsManager.prototype.WriteToStorage = function(Key, State)
{
    webix.storage.local.put(Key, State);
};

QoEReportsSettingsManager.prototype.RefreshReportsSettingsCurState = function(Data, isDashboard)
{
    let _this = this;

    let findKey = function(id) {
        let res = null;
        Object.entries(_this.ReportsSettings).forEach(([key, value]) => {
            if(value.widget_id === id)
                res = key;
        });
        return res;
    }

    if(Data.length)
    {
        Data.forEach(item => {
            if(item.widget_id && item.config)
            {
                let key = isDashboard ? findKey(item.widget_id) : item.widget_id;
                let model = _this.ReportsSettings[key];

                if(key && model)
                {
                    let newConfig = {};
                    let oldConfig = model.cur_common_state;

                    let config = JSON.parse(item.config);
                    [model.exceptional_props_model_func, model.pdf_props_model_func].forEach(ModelFunc => {
                        let cfg = new ModelFunc(config);
                        newConfig = webix.extend(newConfig, cfg, true);
                    });

                    let countDiff = Helper.CountReportSettingsStateChanges(newConfig, oldConfig).by_vals;

                    if(countDiff)
                    {
                        _this.ReportsSettings[key].cur_common_state = newConfig;
                    }
                }
            }
        });
    }

    this.Signals.GetLastAppliedReportsSettingsSuccess.next(1);
};

QoEReportsSettingsManager.prototype.InitReportsSettingsModel = function(Widget, Params)
{
    let result;

    let params = {};
    let default_params = Widget && Widget.ReportSettings ? Widget.ReportSettings : {};
    params = webix.extend(params, default_params, true);

    const canUpdate = !!(Params && Params.can_update_widget);

    try
    {
        if(Widget && Widget.Id && Widget.Name)
        {
            let _this = this;

            let modelParams = {};

            switch(Widget.constructor.name)
            {
                case "QoETableReportWidget":
                    const showCols = Widget.GetTableHeaders().map(item => item.id);

                    if(!params.exceptional_props_model_func)
                        params.exceptional_props_model_func = TableReportSettingsOptionsModel;

                    if(!params.pdf_props_model_func)
                        params.pdf_props_model_func = PdfReportSettingsOptionsModel;

                    params = webix.extend(new params.exceptional_props_model_func(), params, true);
                    params.columns_to_show = showCols;

                    modelParams.exceptional_props_model_func = params.exceptional_props_model_func;
                    modelParams.exceptional_props = new params.exceptional_props_model_func(params);

                    if(!canUpdate) {
                        let sortId = Helper.HasSortId(Widget.Config)
                            ? Widget.Config.sort.id
                            : null;
                        let sortDir = Helper.HasSortDir(Widget.Config)
                            ? Widget.Config.sort.dir
                            : null;

                        if(!sortId)
                            sortId = showCols.length > 0 ? showCols[0] : null;

                        if(!sortDir)
                            sortDir = SortDirectionSettingsEnum.desc.id;

                        if(sortId) {
                            modelParams.exceptional_props.sort_id = sortId;
                            modelParams.exceptional_props.sort_dir = sortDir;
                        }
                    }

                    modelParams.pdf_props_model_func = params.pdf_props_model_func;
                    modelParams.pdf_props = new params.pdf_props_model_func(params);
                    break;

                case "QoESeriesChartReportWidget":
                    const isEditable = params.editable_chart
                                       || Widget.Name && EditableSeriesChartSeriesWidgetList.includes(Widget.Name);
                    const isStackedArea = Widget.ChartType && Widget.ChartType === ChartTypesDic.stackedArea.id
                                       || Widget.Name && StackedAreaChartTypeWidgetList.includes(Widget.Name);

                    let modelFunc = canUpdate
                        ? RowsLimitSeriesChartReportSettingsOptionsModel
                        : RowsLimitSeriesChartReportSettingsOptionsModelMyReportExtend;

                    let pdfModelFunc = ChartPdfReportSettingsOptionsModel;

                    if(isEditable)
                        modelFunc = EditableSeriesChartReportSettingsOptionsModel;

                    if(params.custom_model)
                        modelFunc = GetCustomSettingsOptionsModelClosure(params.custom_model);

                    modelParams.exceptional_props = new modelFunc();
                    modelParams.pdf_props = new pdfModelFunc();
                    modelParams.exceptional_props_model_func = modelFunc;
                    modelParams.pdf_props_model_func = pdfModelFunc;

                    if(isEditable)
                        modelParams.exceptional_props.enable_series = Widget.GetSeriesItems().map(item => item.id);

                    if(Helper.IsGetTopListLimit(Widget.Config))
                        modelParams.exceptional_props.rows_limit = Widget.Config.cols[0].values.params.limit;

                    if(isStackedArea)
                        modelParams.exceptional_props.graph_line_type = ChartTypesDic.stackedArea.id;

                    if(Widget.DefaultKeyOrderBy)
                        modelParams.exceptional_props.chart_order_by = Widget.DefaultKeyOrderBy;

                    // Chart sort direction is not applied to tablechart widget — it is controlled by table columns
                    // Only for My reports
                    if(!canUpdate && Widget.Config && Helper.IsGetTopList(Widget.Config))
                        modelParams.exceptional_props.chart_sort_dir = SortDirectionSettingsEnum.desc.id;
                    break;

                case "QoEPieChartReportWidget":
                    modelParams.exceptional_props = new PieChartReportSettingsOptionsModel();
                    modelParams.exceptional_props_model_func = PieChartReportSettingsOptionsModel;
                    modelParams.pdf_props = new PdfReportSettingsOptionsModel();
                    modelParams.pdf_props_model_func = PdfReportSettingsOptionsModel;
                    break;

                default:
                    return;
            }

            modelParams.widget_id = Widget.Id;
            modelParams.widget_name = Widget.Name;
            modelParams.widget = Widget;
            modelParams.pdf_props.report_name = Widget.Title ? Widget.Title : "";
            modelParams.show_settings_btn = Params && Params.show_settings_btn ? Params.show_settings_btn : null;
            modelParams.can_update_widget = canUpdate;
            modelParams.suggest_widget_code = Params && Params.suggest_widget_code ? Params.suggest_widget_code : "";
            modelParams.suggest_widget_func = Params && Params.suggest_widget_func ? Params.suggest_widget_func : "";
            modelParams.custom_options = params && params.custom_options ? params.custom_options : null;

            if(!this.Active && modelParams.show_settings_btn)
                modelParams.show_settings_btn.disable();

            if(Widget && Widget.ViewController && Widget.ViewController.constructor.name === "QoEDashboardViewController")
            {
                let findData = Widget.ViewController.GetDashboardReportSettingsData(Widget.Id);

                modelParams.widget_id = findData && findData.settings_id ? findData.settings_id : null;
                modelParams.dashboard_id = findData && findData.dashboard_id ? findData.dashboard_id : null;

                if(!modelParams.widget_id || ! modelParams.dashboard_id)
                    return;

                if(findData && findData.prev_id)
                {
                    let prevModel = this.ReportsSettings[findData.prev_id];

                    if(prevModel.widget_id === modelParams.widget_id)
                    {
                        prevModel.show_settings_btn = modelParams.show_settings_btn;
                        prevModel.widget = modelParams.widget;
                        modelParams = prevModel;
                        delete this.ReportsSettings[findData.prev_id];
                    }
                }
            }

            let model = new WidgetReportSettingsModel(modelParams);

            model.BindShowBtnEvent(function(){
                _this.Signals.ReportSettingsBtnClick.next(Widget.Id);
            });

            this.ReportsSettings[Widget.Id] = model;

            result = model;
        }
    }
    catch (e)
    {
        if(Widget && Widget.Id && this.ReportsSettings[Widget.Id])
            delete this.ReportsSettings[Widget.Id];
    }

    return result;
};

QoEReportsSettingsManager.prototype.GetLastAppliedReportsSettings = function(isDashboard = false)
{
    let _this = this;

    if(!this.CurUserProfile || !this.CurUserProfile.user_id)
        return

    if(!this.Active)
        return;

    let widgetIds = Object.values(this.ReportsSettings).map(item => item.widget_id);

    if(!widgetIds || !widgetIds.length)
        return;

    let Params = {
        widget_ids: widgetIds,
        create_user: this.CurUserProfile.user_id
    };

    let params = {
        id: webix.uid(),
        method:"GetLastAppliedReportsSettings",
        data: {Params: Params},
        callback:function (R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success && R.data)
            {
                _this.RefreshReportsSettingsCurState(R.data, isDashboard);
            }
            else if(!R.success && R.error)
            {
                webix.message(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
}

QoEReportsSettingsManager.prototype.SaveReportSettings = function(Model, Silence=false)
{
    let _this = this;

    if(!this.Active)
        return;

    let params = {
        id: webix.uid(),
        method:"SaveQoEReportSettings",
        data: {Params: Model},
        callback:function (R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success && R.data)
            {
                let model = new ReportSettingsModel(
                    webix.extend(Model, R.data, true)
                );

                _this.Signals.SaveReportSettingsSuccess.next({
                    model: model,
                    silence: Silence
                });
            }
            else if(!R.success && R.error)
            {
                _this.Signals.SaveReportSettingsError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

QoEReportsSettingsManager.prototype.DeleteReportSettings = function(Model)
{
    let _this = this;

    if(!this.Active)
        return;

    let params = {
        id: webix.uid(),
        method:"DeleteQoEReportSettings",
        data: {Params: Model},
        callback:function (R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success)
            {
                _this.Signals.DeleteReportSettingsSuccess.next(1);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.DeleteReportSettingsError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

QoEReportsSettingsManager.prototype.ResetWidget = function(DestroyReportWidgets = false)
{
    Object.values(this.ReportsSettings).forEach(model => {
        model.ResetShowBtnEvent();
    });

    if(DestroyReportWidgets)
        Object.values(this.ReportsSettings).forEach(model => {
            if(model.widget && Object.hasOwn(model.widget, "Destroy"))
                model.widget.Destroy();
        });

    this.ReportsSettings = {};
};
const ReportTasksStates = {
    new: {id: "new", color: "orange", value: LangHelper.GetString("QoE", "New")},
    preparing: {id: "preparing", color: "orange", value: LangHelper.GetString("QoE", "Preparing")},
    caching: {id: "caching", color: "orange", value: LangHelper.GetString("QoE", "Caching")},
    checking: {id: "checking", color: "orange", value: LangHelper.GetString("QoE", "Checking")},
    firing: {id: "firing", color: "orange", value: LangHelper.GetString("QoE", "Firing")},
    done: {id: "done", color: "green", value: LangHelper.GetString("QoE", "Done")},
    scheduled: {id: "scheduled", color: "orange", value: LangHelper.GetString("QoE", "Scheduled")},
    canceled: {id: "canceled", color: "grey", value: LangHelper.GetString("QoE", "Canceled")},
    invalid: {id: "invalid", color: "red", value: LangHelper.GetString("QoE", "Error")},
    error: {id: "error", color: "red", value: LangHelper.GetString("QoE", "Error")},
    cache_error: {id: "error", color: "red", value: LangHelper.GetString("QoE", "Cache error")},
    disabled: {id: "disabled", color: "", value: ""}
};

const EnabledReportTaskStates = [
    ReportTasksStates.new.id,
    ReportTasksStates.preparing.id,
    ReportTasksStates.caching.id,
    ReportTasksStates.checking.id,
    ReportTasksStates.firing.id,
    ReportTasksStates.scheduled.id
];

const WidgetTypesMap = {
    "QoETableReportWidget": {name: "QoETableReportWidget", type: "table", prop: "TableWidget"},
    "QoESeriesChartReportWidget": {name: "QoESeriesChartReportWidget", type: "chart-area", prop: "ChartWidget"},
    "QoEPieChartReportWidget": {name: "QoEPieChartReportWidget", type: "chart-pie", prop: "PieChartWidget"}
};

const ReportTasksRoleParams = {
    tasks_management: "tasks_management",
    max_task_priority: "max_task_priority",
    out_of_turn: "out_of_turn",
    see_all_users: "see_all_users"
};

const ReportTaskMaxExecTime = Array.from({ length: 24 }, (_, i) => i + 1);

const ReportTaskLifetime = Array.from({ length: 7 }, (_, i) => i + 1);

const ReportTaskPriorities = Array.from({ length: 10 }, (_, i) => i + 1);

function QoEReportTaskModel(Params)
{
    let model = {};

    model.id = Params && Params.id ? Params.id : "";
    model._id = Params && Params._id ? Params._id : "";
    model.name = Params && Params.name ? Params.name : "";
    model.max_exec_time_sec = Params && Params.max_exec_time_sec ? Params.max_exec_time_sec : "";
    model.lifetime_hours = Params && Params.lifetime_hours ? Params.lifetime_hours : "";
    model.priority = Params && Params.priority ? parseInt(Params.priority) : 1;
    model.query_cfg = Params && Params.query_cfg ? Params.query_cfg : {};
    model.out_of_turn = Params && Params.out_of_turn ? Params.out_of_turn : 0;
    model.mail_notify_enabled = Params && Params.mail_notify_enabled ? parseInt(Params.mail_notify_enabled) : 0;
    model.mail_notify_cfg = Params && Params.mail_notify_cfg ? Params.mail_notify_cfg : {};
    model.tg_notify_enabled = Params && Params.tg_notify_enabled ? parseInt(Params.tg_notify_enabled) : 0;
    model.tg_notify_cfg = Params && Params.tg_notify_cfg ? Params.tg_notify_cfg : {};
    model.split_report_enabled = Params && Params.split_report_enabled ? parseInt(Params.split_report_enabled) : 0;
    model.split_report_cfg = Params && Params.split_report_cfg ? Params.split_report_cfg : 0;
    model.state = Params && Params.state ? Params.state : "";
    model.state_data = Params && Params.state_data ? Params.state_data : {};
    model.user_id = Params && Params.user_id ? Params.user_id : "";
    model.trigger_id = Params && Params.trigger_id ? Params.trigger_id : "";
    model.start_after = Params && Params.start_after ? Params.start_after : "";
    model.is_scheduled = Params && Params.is_scheduled ? parseInt(Params.is_scheduled) : 0;
    model.schedule_cfg = Params && Params.schedule_cfg ? Params.schedule_cfg : "";
    model.report_id = Params && Params.report_id ? Params.report_id : {};
    model.cache_lifetime = Params && Params.cache_lifetime ? Params.cache_lifetime : "";
    model.create_time = Params && Params.create_time ? Params.create_time : "";
    model.update_time = Params && Params.update_time ? Params.update_time : "";

    ["query_cfg", "mail_notify_cfg", "tg_notify_cfg", "state_data",
        "split_report_cfg", "state_data", "report_id", "schedule_cfg"].forEach(Key => {
        if(model[Key] && typeof model[Key] === "string")
        {
            try
            {
                model[Key] = JSON.parse(model[Key]);
            }
            catch(e)
            {
                model[Key] = {};
            }
        }
    });

    model.query_cfg = QoEReportTaskQueryCfgModel(model.query_cfg);
    model.mail_notify_cfg = QoEReportTaskMailNotifyCfgModel(model.mail_notify_cfg);
    model.tg_notify_cfg = QoEReportTaskTgNotifyCfgModel(model.tg_notify_cfg);
    model.split_report_cfg = QoEReportTaskSplitReportCfgModel(model.split_report_cfg);
    model.schedule_cfg = Array.isArray(model.schedule_cfg) ? model.schedule_cfg.map(Item => QoEReportScheduleModel(Item)) : [];

    return model;
}

function QoEReportTaskQueryCfgModel(Params)
{
    let model = {};

    model.config = Params && Params.config ? Params.config : {};
    model.period_from = Params && Params.period_from ? Params.period_from : "";
    model.period_to = Params && Params.period_to ? Params.period_to : "";
    model.schedule_period_from = Params && Params.schedule_period_from ? Params.schedule_period_from : "";
    model.schedule_period_to = Params && Params.schedule_period_to ? Params.schedule_period_to : "";
    model.filter_type = Params && Params.filter_type ? Params.filter_type : "";
    model.filter_state = Params && Params.filter_state ? Params.filter_state : {};
    model.filter_settings = Params && Params.filter_settings ? Params.filter_settings : {};
    model.filter_settings_enabled = Params && Params.filter_settings_enabled ? Number(Params.filter_settings_enabled) : 0;
    model.report_settings = Params && Params.report_settings ? Params.report_settings : {};
    model.report_settings_enabled = Params && Params.report_settings_enabled ? Number(Params.report_settings_enabled) : 0;
    model.widget_pdf_config = Params && Params.widget_pdf_config ? Params.widget_pdf_config : {};
    model.widget_code = Params && Params.widget_code ? Params.widget_code : "";
    model.widget_name = Params && Params.widget_name ? Params.widget_name : "";
    model.widget_func = Params && Params.widget_func ? Params.widget_func : "";
    model.suggest_widget = Params && Params.suggest_widget ? Params.suggest_widget : {};
    model.widget_filter = Params && Params.widget_filter ? Params.widget_filter : {};

    return model;
}

function QoEReportTaskMailNotifyCfgModel(Params)
{
    let model = {};

    // backward
    model.template = Params && Params.template ? Params.template : "";
    model.template_id = Params && Params.template_id ? Params.template_id : "";

    model.type = MailingTemplatesTypesEnum.mail;
    model.mail_address = Params && Params.mail_address ? Params.mail_address : "";
    model.tpl_model = Params && Params.tpl_model ? new MailingTemplateModel(Params.tpl_model) : null;

    return model;
}

function QoEReportTaskTgNotifyCfgModel(Params)
{
    let model = {};

    // backward
    model.template = Params && Params.template ? Params.template : "";
    model.template_id = Params && Params.template_id ? Params.template_id : "";

    model.type = MailingTemplatesTypesEnum.telegram;
    model.tg_channel = Params && Params.tg_channel ? Params.tg_channel : "";
    model.tpl_model = Params && Params.tpl_model ? new MailingTemplateModel(Params.tpl_model) : null;

    return model;
}

function QoEReportTaskSplitReportCfgModel(Params)
{
    let model = {};

    model.split_per_days = Params && Params.split_per_days ? Params.split_per_days : "";
    model.split_by_lines = Params && Params.split_by_lines ? Params.split_by_lines : "";
    model.separate_delivery = Params && Params.separate_delivery ? Params.separate_delivery : "";

    return model;
}

function QoEReportCacheProgressViewModel(Params, Status)
{
    let model = {};

    model.caches = Params && Params.caches ? Params.caches : 1;

    model.read_rows = Params && Params.read_rows ? Params.read_rows : 0;
    model.total_rows_to_read = Params && Params.total_rows_to_read ? Params.total_rows_to_read : 0;

    model.total_percent = Params && Params.total_percent ? Params.total_percent : model.caches * 100;
    model.processing_percent = Params && Params.processing_percent ? Params.processing_percent : 0;

    model.written_rows = Params && Params.written_rows ? Params.written_rows : 0;

    if(!model.processing_percent)
    {
        if(model.total_rows_to_read && model.read_rows && model.total_rows_to_read > 0)
        {
            let progress = Math.round(model.read_rows / model.total_rows_to_read * 10) / 10;
            model.processing_percent = progress * 100;
        }

        if(parseInt(Status, 10) === 2)
            model.processing_percent = model.caches * 100;
    }

    return model;
}

function QoEReportCacheViewModel(Params)
{
    let model = {};

    model.cache_id = Params && Params.cache_id ? Params.cache_id : '';
    model.created_time = Params && Params.created_time ? Params.created_time : '';
    model.lifetime = Params && Params.lifetime ? Params.lifetime : '';
    model.status = Params && Params.status ? Params.status : 0;
    model.attempts = Params && Params.attempts ? Params.attempts : 0;

    model.progress_json = Params && Params.progress_json ? Params.progress_json : {};

    if(model.progress_json && typeof model.progress_json === "string")
    {
        try
        {
            model.progress_json = JSON.parse(model.progress_json);
        }
        catch(e)
        {
            model.progress_json = {};
        }
    }

    model.progress = QoEReportCacheProgressViewModel(model.progress_json, model.status);

    return model;

}

function QoEReportScheduleModel(Params)
{
    let model = {};

    model._id = Params && Params._id ? Params._id : webix.uid();
    model.client_timezone = Params && Params.client_timezone ? Params.client_timezone : "";
    model.start_time = Params && Params.start_time ? Params.start_time : "";
    model.state = Params && Params.state ? Params.state : "";
    model.state_data = Params && Params.state_data ? Params.state_data : "";
    model.trigger_id = Params && Params.trigger_id ? Params.trigger_id : "";
    model.update_time = Params && Params.update_time ? Params.update_time : "";

    Object.values(DaysOfWeekDic).forEach(Item => {
        if(Params && Array.isArray(Params.week_days))
            model[Item.id] = Params.week_days.includes(Item.id) ? 1 : 0;
        else
            model[Item.id] = Params && Params[Item.id] ? 1 : 0;
    });

    return model;
}

function QoEReportCacheReportViewModel(Params)
{
    let model = {};

    model.report_id = Params && Params.report_id ? Params.report_id : '';
    model.created_time = Params && Params.created_time ? Params.created_time : '';
    model.period_from = Params && Params.period_from ? Params.period_from : '';
    model.period_to = Params && Params.period_to ? Params.period_to : '';

    model.cache_id = Params && Params.cache_id ? Params.cache_id : '';
    model.cache_lifetime = Params && Params.cache_lifetime ? Params.cache_lifetime : '';
    model.cache_rows = Params && Params.cache_rows ? Params.cache_rows : 0;
    model.cache_progress = Params && Params.cache_progress ? Params.cache_progress : QoEReportCacheProgressViewModel();

    return model;

}

function QoEReportTaskViewModel(Params)
{
    let model = {};

    Object.entries(QoEReportTaskModel(Params)).forEach(([Key, Val])=> {
       model[Key] = Val;
    });

    // object with locale => title
    model.widget_name = Params && Params.widget_name ? Params.widget_name : {};
    model.period_from = Params && Params.period_from ? Params.period_from : "";
    model.period_to = Params && Params.period_to ? Params.period_to : "";
    model.schedule_period_from = Params && Params.schedule_period_from ? Params.schedule_period_from : "";
    model.schedule_period_to = Params && Params.schedule_period_to ? Params.schedule_period_to : "";
    model.filter_settings_enabled = Params && Params.filter_settings_enabled ? Number(Params.filter_settings_enabled) : 0;
    model.report_settings_enabled = Params && Params.report_settings_enabled ? Number(Params.report_settings_enabled) : 0;
    model.username = Params && Params.username ? Params.username : "";
    model.is_cache = Params && Params.is_cache ? Number(Params.is_cache) : 0;
    model.cache_json = Params && Params.cache_json ? Params.cache_json : [];
    model.report_json = Params && Params.report_json ? Params.report_json : [];
    model.report_cache_list = [];

    model.progress = QoEReportCacheProgressViewModel();

    ["widget_name", "cache_json", "report_json"].forEach(Key => {
        if(model[Key] && typeof model[Key] === "string")
        {
            try
            {
                model[Key] = JSON.parse(model[Key]);
            }
            catch(e)
            {
                model[Key] = {};
            }
        }
    });

    // Prepare caches models
    if(model.cache_json && Array.isArray(model.cache_json) && model.cache_json.length > 0)
    {
        // Calculate total progress

        var total_rows_to_read = 0
        var read_rows = 0
        var written_rows = 0
        var processing_percent = 0
        var _arr = [];

        model.cache_json.forEach(function (Item)
        {
            var item = QoEReportCacheViewModel(Item);

            _arr.push(item);

            total_rows_to_read += item.progress.total_rows_to_read;
            read_rows += item.progress.read_rows;
            written_rows += item.progress.written_rows;
            processing_percent += item.progress.processing_percent;
        });

        model.cache_json = _arr;

        model.progress = QoEReportCacheProgressViewModel({

            caches: _arr.length,
            total_rows_to_read: total_rows_to_read,
            read_rows: read_rows,
            written_rows: written_rows,
            processing_percent: processing_percent
        });
    }

    // Prepare report_cache_list
    model.report_json.forEach(function (ReportItem)
    {
        var report_idArr= []

        try
        {
            report_idArr = ReportItem.report_id.split("_");
        } catch (e){}

        if(report_idArr.length !== 5)
            return true;

        var r_item = QoEReportCacheReportViewModel(ReportItem);

        model.cache_json.forEach(function (CacheItem)
        {
            var cache_idArr= []

            try
            {
                cache_idArr = CacheItem.cache_id.split("_");
            } catch (e){}

            if(cache_idArr.length !== 5)
                return true;

            if(cache_idArr[2] === report_idArr[2])
            {
                r_item.cache_id = CacheItem.cache_id;
                r_item.cache_lifetime = CacheItem.lifetime;
                r_item.cache_progress = CacheItem.progress.processing_percent;
                r_item.cache_rows = CacheItem.progress.written_rows;

                return false;
            }

        });

        model.report_cache_list.push(r_item);
    });

    model.report_cache_list.sort((a,b) => a.period_from > b.period_from ? 1 : a.period_from < b.period_from ? -1 : 0);

    return model;
}

function QoEUserReportsManager()
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(0),

        SaveTaskSuccess: new Rx.BehaviorSubject(0),
        SaveTaskError: new Rx.BehaviorSubject(0),

        DeleteTaskSuccess: new Rx.BehaviorSubject(0),
        DeleteTaskError: new Rx.BehaviorSubject(0),

        GetTaskError: new Rx.BehaviorSubject(0),
        RunTaskError: new Rx.BehaviorSubject(0),
        CancelTaskError: new Rx.BehaviorSubject(0),

        GetCompletedScheduledReportsSuccess: new Rx.BehaviorSubject(0),
        GetCompletedScheduledReportsError: new Rx.BehaviorSubject(0),

        ServerError: new Rx.BehaviorSubject(0)
    }

    this.Subscriptions = {};
}

QoEUserReportsManager.prototype.Destroy = function()
{
    let _this = this;

    this.Active = false;

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        if(_this.Subscriptions[Key])
            _this.Subscriptions[Key].unsubscribe();
    });

    this.Signals = {};
};

QoEUserReportsManager.prototype.SaveTask = function(Params, IsTaskToRun = false)
{
    let _this = this;

    let params = {
        id: webix.uid(),
        method: "SaveQoEReportModel",
        data: {
            Params: Params,
            Run: IsTaskToRun
        },
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success && R.data)
            {
                let model = _this.ConvertTaskModelToViewModel(
                    webix.extend(Params, R.data, true)
                );
                _this.Signals.SaveTaskSuccess.next(model);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.SaveTaskError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

QoEUserReportsManager.prototype.RunTask = function(Params)
{
    let _this = this;

    let params = {
        id: webix.uid(),
        method: "RunQoEReportModel",
        data: {Params: Params},
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success) {}
            else if(!R.success && R.error)
            {
                _this.Signals.RunTaskError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

QoEUserReportsManager.prototype.CancelTask = function(Params)
{
    let _this = this;

    let params = {
        id: webix.uid(),
        method: "CancelQoEReportModel",
        data: {Params: Params},
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success) {}
            else if(!R.success && R.error)
            {
                _this.Signals.CancelTaskError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

QoEUserReportsManager.prototype.DeleteTask = function(Params)
{
    let _this = this;

    let params = {
        id: webix.uid(),
        method: "DeleteQoEReportModel",
        data: {Params: Params},
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success)
            {
                _this.Signals.DeleteTaskSuccess.next(Params);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.DeleteTaskError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

QoEUserReportsManager.prototype.GetCompletedScheduledReports = function(TaskId)
{
    let _this = this;

    let params = {
        id: webix.uid(),
        method: "GetCompletedScheduledReports",
        data: {
            TaskId: parseInt(TaskId)
        },
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success && R.data)
            {
                let idx = 1;
                let data = [];

                R.data.reverse().forEach(Item => {
                    let model = QoEReportTaskViewModel(Item);
                    model.report_cache_list.forEach(_Item => {
                        _Item.num = idx;
                        idx++;
                        data.push(_Item);
                    });
                });
                _this.Signals.GetCompletedScheduledReportsSuccess.next({rows: data, task_id: TaskId});
            }
            else if(!R.success && R.error)
            {
                _this.Signals.GetCompletedScheduledReportsError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);

}

QoEUserReportsManager.prototype.CanUserManageItem = function(Params)
{
    let res = false;

    let model = QoEReportTaskModel(Params);
    let userData = App.SessionManager.GetProfile();
    let roleParams = App.SessionManager.GetUserRoleSectionParams(RoleSectionsEnum.qoeanalytics_reports_manager);
    let roleProp = ReportTasksRoleParams.tasks_management;

    if(model.user_id === userData.user_id)
        res = true;
    else if(roleParams && roleParams[roleProp + "_enabled"] && roleParams[roleProp] === "all")
        res = true;

    return res;
};

QoEUserReportsManager.prototype.GetUserMaxPriority = function()
{
    let res = 1;
    let roleParams = App.SessionManager.GetUserRoleSectionParams(RoleSectionsEnum.qoeanalytics_reports_manager);
    let roleProp = ReportTasksRoleParams.max_task_priority;

    if(roleParams && roleParams[roleProp + "_enabled"] && roleParams[roleProp])
        res = Number(roleParams[roleProp]);

    return res;
};

QoEUserReportsManager.prototype.CanUserEnableOutOfTurn = function()
{
    let roleParams = App.SessionManager.GetUserRoleSectionParams(RoleSectionsEnum.qoeanalytics_reports_manager);
    let roleProp = ReportTasksRoleParams.out_of_turn;

    return roleParams && roleParams[roleProp + "_enabled"] ? true : false;
};

QoEUserReportsManager.prototype.ConvertTaskModelToViewModel = function(Params)
{
    let viewModel = QoEReportTaskViewModel(Params);

    viewModel.widget_name = viewModel.query_cfg.suggest_widget.widget_name;
    viewModel.period_from = viewModel.query_cfg.period_from;
    viewModel.period_to = viewModel.query_cfg.period_to;
    viewModel.schedule_period_from = viewModel.query_cfg.schedule_period_from;
    viewModel.schedule_period_to = viewModel.query_cfg.schedule_period_to;
    viewModel.filter_settings_enabled = viewModel.query_cfg.filter_settings_enabled;
    viewModel.report_settings_enabled = viewModel.query_cfg.report_settings_enabled;

    return viewModel;
};
const MailingTemplatesWidgetViewTypes = {
    popup: "popup",
    build_in: "build_in"
};

const MailingTemplatesWidgetContextTypes = {
    view_template: "view_template",
    edit_template: "edit_template"
};

const MailingTemplatesTypesEnum = {
    http: "http",
    mail: "mail",
    telegram: "telegram"
};

const MailingTemplatesVisibilityGroups = [
    {id: 1, value: LangHelper.GetString("MailingTemplates", "for user")},
    {id: 2, value: LangHelper.GetString("MailingTemplates", "for all users")}
];

const MailingTemplatesTypes = [
    {id: MailingTemplatesTypesEnum.http, value: "HTTP"},
    {id: MailingTemplatesTypesEnum.mail, value: LangHelper.GetString("MailingTemplates", "Email")},
    {id: MailingTemplatesTypesEnum.telegram, value: LangHelper.GetString("MailingTemplates", "Telegram")},
];

const MailingTemplatesRoleParams = {
    edit: "edit_all_users",
    visibility: "see_all_users"
};

function MailingTemplateModel(Params)
{
    this.id = Params && Params.id ? parseInt(Params.id) : webix.uid();

    this._id = Params && Params._id ? parseInt(Params._id) : null;
    this.name = Params && Params.name ? Params.name : "";
    this.type = Params && Params.type ? Params.type : "";
    this.template = Params && Params.template ? Params.template : "";
    this.visibility = Params && Params.visibility ? parseInt(Params.visibility) : 1;
    this.is_system = Params && Params.is_system ? parseInt(Params.is_system) : 0;
    this.user_id = Params && Params.user_id ? parseInt(Params.user_id) : null;
    this.username = Params && Params.username ? Params.username : "";
    this.options = Params && Params.options ? Params.options : null;
    this.create_time = Params && Params.create_time ? Params.create_time : "";
    this.update_time = Params && Params.update_time ? Params.update_time : "";

    if(this.options && typeof this.options === "string")
    {
        try
        {
            this.options = JSON.parse(this.options);
        }
        catch(e)
        {
            this.options = null;
        }
    }

    switch(this.type)
    {
        case MailingTemplatesTypesEnum.mail:
            this.options = new MailingTemplateMailOptionsModel(this.options);
            break;
        case MailingTemplatesTypesEnum.http:
            this.options = new MailingTemplateHttpOptionsModel(this.options);
            break;
        default:
            this.options = new CommonTemplatesOptionsModel(this.options);
    }

    if(this.is_system)
    {
        let line = this.options && this.options.subtype ? this.options.subtype + " " : "";
        this.name = `${line}${LangHelper.GetString("MailingTemplates", this.name)}`;
    }

    // if(this.is_system)
    //     this.ConvertToSystem();
}

// MailingTemplateModel.prototype.ConvertToSystem = function()
// {
//     const regex = /REPLACE_BY_LOCAL\[(.*?)\]/g;
//
//     let line = this.options && this.options.subtype ? this.options.subtype + " " : "";
//
//     this.name = `${line}${LangHelper.GetString("MailingTemplates", this.name)}`;
//
//     let execStrings = (match, content) => {
//         let res = "";
//
//         try
//         {
//             res = eval(content);
//         }
//         catch (e)
//         {
//             res = "";
//         }
//
//         return res;
//     };
//
//     this.template = this.template.replace(regex, execStrings);
//
//     if(this.options && this.options.subject)
//         this.options.subject = this.options.subject.replace(regex, execStrings);
// };

function CommonTemplatesOptionsModel(Params)
{
    this.template_id = Params && Params.template_id ? Params.template_id : "";
    this.backward_template_id = Params && Params.backward_template_id ? Params.backward_template_id : "";
    this.period_in_filename = Params && Params.period_in_filename ? parseInt(Params.period_in_filename) : 0;
}

function MailingTemplateMailOptionsModel(Params)
{
    let _this = this;

    Object.entries(new CommonTemplatesOptionsModel(Params)).forEach(([Key, Val]) => _this[Key] = Val);

    this.subject = Params && Params.subject ? Params.subject : "";
}

function MailingTemplateHttpOptionsModel(Params)
{
    let _this = this;

    Object.entries(new CommonTemplatesOptionsModel(Params)).forEach(([Key, Val]) => _this[Key] = Val);

    this.subtype = Params && Params.subtype ? Params.subtype : "";
    this.url = Params && Params.url ? Params.url : "";
    this.method = Params && Params.method ? Params.method : "";
    this.headers = Params && Params.headers ? Params.headers : {};
}

function MailingTemplatesManager()
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(0),

        SaveTemplateSuccess: new Rx.BehaviorSubject(0),
        SaveTemplateError: new Rx.BehaviorSubject(0),

        DeleteTemplateSuccess: new Rx.BehaviorSubject(0),
        DeleteTemplateError: new Rx.BehaviorSubject(0),

        RefreshTemplatesListSuccess: new Rx.BehaviorSubject(0),
        RefreshTemplatesListError: new Rx.BehaviorSubject(0),

        RefreshDefaultTemplatesListSuccess: new Rx.BehaviorSubject(0),
        RefreshDefaultTemplatesListError: new Rx.BehaviorSubject(0),

        ServerError: new Rx.BehaviorSubject(0)
    };

    this.TemplatesList = [];

    this.DefaultTemplatesList = [];

    this.Subscriptions = {};

    this.CurUserProfile = App.SessionManager.GetProfile();
}

MailingTemplatesManager.prototype.Destroy = function()
{
    let _this = this;

    this.Active = false;

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        if(_this.Subscriptions[Key])
            _this.Subscriptions[Key].unsubscribe();
    });

    this.Signals = {};
};

MailingTemplatesManager.prototype.SaveTemplate = function(Params)
{
    let _this = this;

    let params = {
        id: webix.uid(),
        method: "SaveMailingTemplate",
        data: {Params: Params},
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success && R.data)
            {
                let model = new MailingTemplateModel(
                    webix.extend(Params, R.data, true)
                );

                let idx = _this.TemplatesList.findIndex(item => item._id == model._id);

                if(idx >  -1)
                    _this.TemplatesList.splice(idx, 1, model);
                else
                    _this.TemplatesList.push(model);

                _this.Signals.RefreshTemplatesListSuccess.next(1);
                _this.Signals.SaveTemplateSuccess.next(model);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.SaveTemplateError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

MailingTemplatesManager.prototype.DeleteTemplate = function(Params)
{
    let _this = this;

    let params = {
        id: webix.uid(),
        method: "DeleteMailingTemplate",
        data: {Params: Params},
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success)
            {
                _this.Signals.DeleteTemplateSuccess.next(Params);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.DeleteTemplateError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

MailingTemplatesManager.prototype.RefreshTemplatesList = function(Params)
{
    let _this = this;

    let params = {
        id: webix.uid(),
        method: "GetMailingTemplatesViewList",
        data: {Params: Params},
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success && R.data)
            {
                _this.TemplatesList = R.data.rows.map(Item => new MailingTemplateModel(Item));
                _this.Signals.RefreshTemplatesListSuccess.next(1);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.RefreshTemplatesListError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

MailingTemplatesManager.prototype.RefreshDefaultTemplateList = function()
{
    let _this = this;

    if(this.TemplatesList.length)
    {
        this.DefaultTemplatesList = this.TemplatesList.filter(Item => !!Item.is_system)
        this.Signals.RefreshDefaultTemplatesListSuccess.next(1);
    }

    if(!this.DefaultTemplatesList.length)
    {
        let Params = {
            filter: {
                is_system: {
                    id: "is_system",
                    operator: "=",
                    value: 1
                }
            }
        };

        let params = {
            id: webix.uid(),
            method: "GetMailingTemplatesViewList",
            data: {Params: Params},
            callback: function(R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success && R.data)
                {
                    _this.DefaultTemplatesList = R.data.rows.map(Item => new MailingTemplateModel(Item));
                    _this.Signals.RefreshDefaultTemplatesListSuccess.next(1);
                }
                else if(!R.success && R.error)
                {
                    _this.Signals.RefreshDefaultTemplatesListError.next(R.error);
                }
                else
                {
                    _this.Signals.ServerError.next(1);
                }
            }
        };

        _this.Signals.Progress.next(1);

        App.ServerManager.CallMethod(params);
    }
};

MailingTemplatesManager.prototype.CanUserWrite = function()
{
    let sectionParam = App.SessionManager.GetUserRoleSections();

    if(
        sectionParam &&
        sectionParam[RoleSectionsEnum.qoeanalytics_mailing_templates] &&
        sectionParam[RoleSectionsEnum.qoeanalytics_mailing_templates].write
    )
    {
        return true;
    }

    return false;
};

MailingTemplatesManager.prototype.CanUserManageItem = function(Params)
{
    let res = false;

    if(this.CanUserWrite())
    {
        let model = new MailingTemplateModel(Params);

        if(!model.is_system)
        {
            let userData = App.SessionManager.GetProfile();

            let roleParams = App.SessionManager.GetUserRoleSectionParams(RoleSectionsEnum.qoeanalytics_mailing_templates);
            let roleProp = MailingTemplatesRoleParams.edit;

            if((model.user_id == userData.user_id) || !model._id)
                res = true;
            else if(roleParams && roleParams[roleProp + "_enabled"] && roleParams[roleProp] === "all")
                res = true;
        }
    }

    return res;
};


function BlTargetsFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"target", order_dir:"desc"};
};

function BlTargetModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();

    this.target = Params&&Params.target?Params.target:"";
    this.task_id = Params&&Params.task_id?Params.task_id:0;
    this.status = Params&&Params.status?Params.status: 1;
};

function BlTargetsManager(Params)
{
    this.Active = true;

    this.Targets = [];
    this.TargetsFilter = new BlTargetsFilterModel();


    this.SignalTargetsUpdated = new Rx.BehaviorSubject(0);
    this.SignalTargetUpdated = new Rx.BehaviorSubject(0);

    this.CurrentTargetsRequestId = 0;
};

BlTargetsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

BlTargetsManager.prototype.RefreshTargets = function(Params)
{
    var _this = this;

    this.CurrentTargetsRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.TargetsFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.TargetsFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.TargetsFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.TargetsFilter.sort.order_by = Params.sort.id;
        this.TargetsFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.TargetsFilter.total.page,
        size:this.TargetsFilter.total.size,

        order_by:this.TargetsFilter.sort.order_by,
        order_dir:this.TargetsFilter.sort.order_dir
    };

    Object.keys(this.TargetsFilter.filter).forEach(function (Key)
    {
        if(_this.TargetsFilter.filter[Key])
            filterParams[Key] = _this.TargetsFilter.filter[Key];
    });

    var _params = filterParams;
    _params.task_id = Params&&Params.task_id?Params.task_id:null;

    var params =
        {
            id:this.CurrentTargetsRequestId,
            method:"GetBlTargets",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                // if(!partial && _this.CurrentTargetsRequestId !== R.id)
                // {
                //     return;
                // }

                if(R.success)
                {
                    _this.Targets = [];
                    _this.TargetsFilter.total.page = 0;
                    _this.TargetsFilter.total.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function (Target)
                        {
                            _this.Targets.push(new BlTargetModel(Target));
                        });

                        _this.TargetsFilter.total.page = parseInt(R.data.page,10);
                        _this.TargetsFilter.total.count = parseInt(R.data.count,10);
                    }

                    _this.SignalTargetsUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BlTargetsManager.prototype.SaveTarget = function(Params)
{
  var _this = this;

  var index = this.Targets.findIndex(function(Val){
      return Val.id === Params.newTarget.id;
  });

    var data = {
        NewTarget: Params && Params.newTarget? Params.newTarget : null,
        OldTarget: index > -1 && this.Targets[index] ? this.Targets[index] : null
    };

    var params = {
        id: webix.uid(),
        method: "SaveBlTarget",
        data:data,
        callback:function(R)
        {
            if(R.success)
            {
                if(index > -1)
                {
                    _this.Targets[index] = new BlTargetModel(Params.newTarget);
                }
                else{
                    _this.Targets.unshift(new BlTargetModel(Params.newTarget));
                }

                _this.SignalTargetsUpdated.next(1);
            }
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };
    App.ServerManager.CallMethod(params);
};

BlTargetsManager.prototype.ImportTargets = function(Params)
{
    var _this = this;

    var targets = Params && Params.targets ? Params.targets: null;
    var params = {
        id: webix.uid(),
        method: "SaveBlTargets",
        data:{
            Targets: targets
        },
        callback:function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };
    App.ServerManager.CallMethod(params);
};

BlTargetsManager.prototype.DeleteTarget = function(Params)
{
    var _this = this;

    var target = this.Targets.find(function(Val){
       return Val.id === Params.target.id;
    });

    var params = {
        id: webix.uid(),
        method: "DeleteBlTarget",
        data:{
            Target: target
        },
        callback: function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

BlTargetsManager.prototype.GetTargets = function()
{
    return webix.copy(this.Targets);
}
var BlTaskStatusEnum = {
    disabled: 0,
    enabled: 1
};

var BlTaskTypeEnum = {
    black: 0,
    white: 1
};

var BlListItemTypeEnum = {
    url: "url",
    ip: "ip",
    sni: "sni",
    cn:"cn",
    clsfr:"clsfr",
    vase: "vase"
};

function BlTaskModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.task_id = Params&&Params.task_id?Params.task_id:0;
    this.parent_id = Params&&Params.parent_id?Params.parent_id:null;
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:null;
    this.user_id = Params&&Params.user_id?Params.user_id:null;
    this.title = Params&&Params.title?Params.title:"";
    this.date = Params&&Params.date?Params.date:0;
    this.status = Params&&Params.status?parseInt(Params.status):BlTaskStatusEnum.disabled;

    this.white = Params&&Params.white?parseInt(Params.white):0;

    this.form_data = Params&&Params.form_data?Params.form_data:"";
    this.remote = Params && Params.remote? parseInt(Params.remote):0;
    this.dpi_name = Params&&Params.dpi_name?Params.dpi_name:"";

    this.sync_time_hours = Params&&Params.sync_time_hours?parseInt(Params.sync_time_hours):"";
    this.sync_time_status = Params&&Params.sync_time_status?parseInt(Params.sync_time_status):0;
    this.sync_time_last_date = Params&&Params.sync_time_last_date?Params.sync_time_last_date:"";

    this.data = [];
    if(Params&&Params.data)
    {
        Params.data.forEach(function (Task)
        {
            __this.data.push(new BlTaskModel(Task));
        });
    }

    this.open = true;
    this.valid = true;
};

function BlSyncTimeModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();

    this.task_id = Params&&Params.task_id?Params.task_id:0;

    this.sync_time_hours = Params&&Params.sync_time_hours?parseInt(Params.sync_time_hours):"";
    this.sync_time_status = Params&&Params.sync_time_status?parseInt(Params.sync_time_status):0;
    //this.sync_time_last_date = Params&&Params.sync_time_last_date?Params.sync_time_last_date:"";
};

function BlTasksFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"task_id", order_dir:"desc"};
};

function BlTaskFormModel(Params)
{
    this.title = Params&&Params.title?Params.title:"";

    this.target = Params&&Params.target?Params.target:"";

    this.white = Params&&Params.white?Params.white:0;

    this.redirect_enabled = Params&&Params.redirect_enabled?Params.redirect_enabled:"";
    this.redirect = Params&&Params.redirect?Params.redirect:"";

    this.federal = Params&&Params.federal?Params.federal:false;
};

function BlListItemModel(Params, IsForm)
{
    if(!IsForm)
    {
        this.id = Params&&Params.id?Params.id:webix.uid();

        this.item_id = Params&&Params.item_id?Params.item_id:0;
        this.task_id = Params&&Params.task_id?Params.task_id:0;
    }

    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.type = Params&&Params.type?Params.type:BlListItemTypeEnum.url;
    this.uri = Params&&Params.uri?Params.uri:"";
};

function BlListItemsFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"item_id", order_dir:"desc"};
};

function BlManager()
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        //Clsfr Categories
        BlGetClsfrCategories: new Rx.BehaviorSubject(null),
        BlGetClsfrCategoriesError: new Rx.BehaviorSubject(null),

        //Task Time Sync
        BlSyncTime: new Rx.BehaviorSubject(null),
        BlSyncTimeError: new Rx.BehaviorSubject(null)
    }

    this.Tasks = [];
    this.TasksFilter = new BlTasksFilterModel();


    this.ListItems = [];
    this.ListItemsFilter = new BlListItemsFilterModel();

    this.SignalTasksUpdated = new Rx.BehaviorSubject(0);
    this.SignalTaskUpdated = new Rx.BehaviorSubject(0);

    this.SignalListItemsUpdated = new Rx.BehaviorSubject(0);
    this.SignalListItemUpdated = new Rx.BehaviorSubject(0);

    this.CurrentTasksRequestId = 0;
    this.CurrentListItemsRequestId = 0;
};

//Clsfr Categories
BlManager.prototype.GetClsfrCategories = function(Params, isLoad = true)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "GetCategoriesListReport",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    R.data.isLoad = isLoad;
                    _this.Signals.BlGetClsfrCategories.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.BlGetClsfrCategoriesError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.SetSyncTime = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"SetBlListSyncTime",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.BlSyncTime.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.BlSyncTimeError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

BlManager.prototype.RefershTasks = function(Params)
{
    var _this = this;

    var partial = Params&&Params.tasks_ids ? true : false;

    if(!partial)
        this.CurrentTasksRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.TasksFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.TasksFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.TasksFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.TasksFilter.sort.order_by = Params.sort.id;
        this.TasksFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.TasksFilter.total.page,
        size:this.TasksFilter.total.size,

        order_by:this.TasksFilter.sort.order_by,
        order_dir:this.TasksFilter.sort.order_dir
    };

    Object.keys(this.TasksFilter.filter).forEach(function (Key)
    {
        if(_this.TasksFilter.filter[Key])
            filterParams[Key] = _this.TasksFilter.filter[Key];
    });

    var _params = filterParams;
    _params.tasks_ids = partial?Params&&Params.tasks_ids:null;

    var hId = App.SessionManager.GetCurrentHardwareId();
    if(hId)
    {
        _params.hardware_id = parseInt(hId);
    }

    if(!partial)
    {
        _params.parent_id_is_null = true;
    }

    var params =
        {
            id:this.CurrentTasksRequestId,
            method:"GetBlTasks",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentTasksRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (Task)
                            {
                                _this.SignalTaskUpdated.next(new BlTaskModel(Task));
                            });
                        }
                    }
                    else
                    {
                        _this.Tasks = [];
                        _this.TasksFilter.total.page = 0;
                        _this.TasksFilter.total.count = 0;

                        if(R.data)
                        {
                            R.data.rows.forEach(function (Task)
                            {
                                _this.Tasks.push(new BlTaskModel(Task));
                            });

                            _this.TasksFilter.total.page = parseInt(R.data.page,10);
                            _this.TasksFilter.total.count = parseInt(R.data.count,10);
                        }

                        _this.SignalTasksUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BlManager.prototype.GetTasks = function()
{
    return this.Tasks;
};

BlManager.prototype.SaveTask = function(Params)
{
    var _this = this;

    var task = new BlTaskModel(Params&&Params.task?Params.task:null);
    var taskForm = new BlTaskFormModel(Params&&Params.task?Params.task_form:null);

    var params =
        {
            id: task.id,
            method:"SaveBlTask",
            data: {
                Task: task,
                Form: taskForm
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.DeleteTask = function(Params)
{
    var _this = this;

    var task = new BlTaskModel(Params&&Params.task?Params.task:null);

    var params =
        {
            id: task.id,
            method:"DeleteBlTask",
            data: {
                Task: task
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.RefreshListItems = function(Params)
{
    var _this = this;

    var partial = Params&&Params.items_ids ? true : false;

    if(!partial)
        this.CurrentListItemsRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.ListItemsFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.ListItemsFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.ListItemsFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.ListItemsFilter.sort.order_by = Params.sort.id;
        this.ListItemsFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.ListItemsFilter.total.page,
        size:this.ListItemsFilter.total.size,

        order_by:this.ListItemsFilter.sort.order_by,
        order_dir:this.ListItemsFilter.sort.order_dir
    };

    Object.keys(this.ListItemsFilter.filter).forEach(function (Key)
    {
        if(_this.ListItemsFilter.filter[Key])
            filterParams[Key] = _this.ListItemsFilter.filter[Key];
    });

    var _params = filterParams;

    _params.task_id = Params&&Params.task_id ? Params.task_id : null

    var params =
        {
            id:this.CurrentListItemsRequestId,
            method:"GetBlListItems",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentListItemsRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (ListItem)
                            {
                                _this.SignalListItemUpdated.next(new BlListItemModel(ListItem));
                            });
                        }
                    }
                    else
                    {
                        _this.ListItems = [];
                        _this.ListItemsFilter.total.page = 0;
                        _this.ListItemsFilter.total.count = 0;

                        if(R.data)
                        {
                            R.data.rows.forEach(function (ListItem)
                            {
                                _this.ListItems.push(new BlListItemModel(ListItem));
                            });

                            _this.ListItemsFilter.total.page = parseInt(R.data.page,10);
                            _this.ListItemsFilter.total.count = parseInt(R.data.count,10);
                        }

                        _this.SignalListItemsUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BlManager.prototype.GetListItems = function()
{
    return this.ListItems;
};

BlManager.prototype.SaveListItem = function(Params)
{
    var _this = this;

    var listItem = new BlListItemModel(Params&&Params.list_item?Params.list_item:null);

    var params =
        {
            id: listItem.id,
            method:"SaveBlListItem",
            data: {
                ListItem: listItem
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.DeleteListItem = function(Params)
{
    var _this = this;

    var listItem = new BlListItemModel(Params&&Params.list_item?Params.list_item:null);

    var params =
        {
            id: listItem.id,
            method:"DeleteBlListItem",
            data: {
                ListItem: listItem
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.RunTask = function(Params)
{
    var _this = this;

    var task = new BlTaskModel(Params&&Params.task?Params.task:null);

    var params =
        {
            id: task.id,
            method:"RunBlTask",
            data: {
                Task: task
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.StopTask = function(Params)
{
    var _this = this;

    var task = new BlTaskModel(Params&&Params.task?Params.task:null);

    var params =
        {
            id: task.id,
            method:"StopBlTask",
            data: {
                Task: task
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.ImportListItems = function(Params)
{
    var _this = this;

    var listItems = Params&&Params.list_items?Params.list_items:[];

    var params = {
        method:"ImportBlListItems",
        data: {
            Items: listItems
        },
        callback:function (result)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(result);
            }

        }
    };

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.ImportListItemsFromQoE = function(Params)
{
    var _this = this;

    var params = {
        method: 'ImportBlListItemsFromQoE',
        data: {
            Task: Params && Params.task ? Params.task : null,
            Categories: Params && Params.categories !== null ? Params.categories : null,
            Limit: Params && Params.limit !== null ? Params.limit : null
        },
        callback:function (R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

BlManager.prototype.ClearListItems = function(Params)
{
    var _this = this;

    var params = {
        method: "ClearBlListitems",
        data: {
            Task: Params && Params.task ? Params.task : null
        },
        callback: function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};
function PolicingProfilesFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"profile_id", order_dir:"desc"};
};

function PolicingProfileModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();

    this.profile_id = Params&&Params.profile_id?Params.profile_id:0;
    this.title = Params&&Params.title?Params.title:"";
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id: 0;
    this.user_id = Params&&Params.user_id?Params.user_id: 0;
    this.enabled = Params&&Params.enabled?Params.enabled: 0;
    this.config = Params&&Params.config?Params.config: "";
    this.subs_updated = Params&&Params.subs_updated?Params.subs_updated: 0;
    this.config_updated = Params&&Params.config_updated?Params.config_updated: 0;
    this.dpi_name = Params&&Params.dpi_name?Params.dpi_name: "";
    this.status = Params&&Params.status ? parseInt(Params.status) : 0;
    this.individual = Params && Params.individual ? parseInt(Params.individual) : 0;

    this.schedule_enable = Params && Params.schedule_enable ? parseInt(Params.schedule_enable) : 0;
    this.schedule_config_json = Params && Params.schedule_config_json ? Params.schedule_config_json : null;

    this.lock_ids = Params && Params.lock_ids ? Params.lock_ids: "";

    this.valid = true;
};

function PolicingConfigModel(Params)
{
    this.id = Params && Params.id ? Params.id : webix.uid();

    this.type = Params && Params.type ? Params.type : "";

    this.inbound = new PolicingConfigTrafficModel((Params && Params.inbound ? Params.inbound : null), this.type);
    this.outbound = new PolicingConfigTrafficModel((Params && Params.outbound ? Params.outbound : null), this.type);
};

function PolicingConfigTrafficModel(Params, Type = "HTB")
{
    var _this = this;
    this.id = Params && Params.id ? Params.id : webix.uid();

    this.root_rate = Params && Params.root_rate ? Params.root_rate : null;
    this.root_ceil = Params && Params.root_ceil ? Params.root_ceil : null;
    this.root_burst = Params && Params.root_burst ? Params.root_burst : null;
    this.root_cburst = Params && Params.root_cburst ? Params.root_cburst : null;

    this.classes = [];

    if(Params && Params.classes)
    {
        if(Array.isArray(Params.classes))
        {
            Params.classes.forEach(function(Val){

                var _class = new PolicingConfigClassModel(Val);

                if(Type == "HTB")
                {
                    _class.enabled = 1;
                }
                else if(!Val.hasOwnProperty("enabled")){
                    _class.enabled = 1;
                }

                _this.classes[_class.class] = _class;
            })
        }
        else if(typeof Params.classes === "object")
        {
            Object.values(Params.classes).forEach(function(Val){
                var _class = new PolicingConfigClassModel(Val);

                if(Type == "HTB")
                {
                    _class.enabled = 1;
                }
                else if(!Val.hasOwnProperty("enabled")){
                    _class.enabled = 1;
                }

                _this.classes[_class.class] = _class;
            });
        }
    }

    if(this.classes.length < 8)
    {
        for(var i =0; i<8; ++i)
        {
            if(!this.classes[i])
            {
                this.classes[i] = new PolicingConfigClassModel({"class":i, "enabled": Type == "HTB"});
            }
        }
    }
};

function PolicingConfigClassModel(Params)
{
    this.id = this.id = Params && Params.id ? Params.id : webix.uid();

    this.class = Params && Params.class ? Params.class : 0;

    this.rate = Params && Params.rate ? Params.rate : null;
    this.ceil = Params && Params.ceil ? Params.ceil : null;
    this.burst = Params && Params.burst ? Params.burst : null;
    this.cburst = Params && Params.cburst ? Params.cburst : null;
    this.peakrate = Params && Params.peakrate ? Params.peakrate : null;

    this.enabled = Params && Params.enabled ? Params.enabled : 0;
};

function TariffTimetableModel(Params)
{
    return {

        startTime: Params&&Params.startTime?Params.startTime:"",

        endTime : Params&&Params.endTime?Params.endTime:"",

        selectedTariff: Params&&Params.selectedTariff?Params.selectedTariff:"",

        weekday: Params&&Params.weekday?Params.weekday:0,

        1: Params&&Params.weekday?(Params.weekday.includes("1")?1:0):0,
        2: Params&&Params.weekday?(Params.weekday.includes("2")?1:0):0,
        3: Params&&Params.weekday?(Params.weekday.includes("3")?1:0):0,
        4: Params&&Params.weekday?(Params.weekday.includes("4")?1:0):0,
        5: Params&&Params.weekday?(Params.weekday.includes("5")?1:0):0,
        6: Params&&Params.weekday?(Params.weekday.includes("6")?1:0):0,
        7: Params&&Params.weekday?(Params.weekday.includes("7")?1:0):0

    }
};


function PolicingProfilesManager(Params)
{
    this.Active = true;

    this.Profiles = [];
    this.ProfilesFilter = new PolicingProfilesFilterModel();


    this.Paging = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.Total = {
        size: 100,
        group: 5,
        count:0,
        page:0
    };

    this.SignalProfilesUpdated = new Rx.BehaviorSubject(0);
//    this.SignalProfileUpdated = new Rx.BehaviorSubject(0);

    this.SignalTimetableConfigGet = new Rx.BehaviorSubject(0);
    this.SignalTimetableConfigError = new Rx.BehaviorSubject(0);

    this.CurrentProfilesRequestId = 0;
};

PolicingProfilesManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

PolicingProfilesManager.prototype.RefreshProfiles = function(Params)
{
    var _this = this;

    this.CurrentProfilesRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }



    if(Params&&Params.page >= 0)
    {
        this.ProfilesFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.ProfilesFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.ProfilesFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.ProfilesFilter.sort.order_by = Params.sort.id;
        this.ProfilesFilter.sort.order_dir = Params.sort.dir;
    }

    if(Params&&Params.page >= 0)
    {
        this.Total.page = parseInt(Params.page,10);
    }

    // if(Params&&Params.filter)
    // {
    //     this.Filter = Params.filter;
    // }

    // if(Params&&Params.sort)
    // {
    //     this.Sort = Params.sort;
    // }

    var filterParams = {
        page:this.Total.page,
        size:this.Total.size,

        order_by:this.ProfilesFilter.sort.order_by,
        order_dir:this.ProfilesFilter.sort.order_dir
    };

    Object.keys(this.ProfilesFilter.filter).forEach(function (Key)
    {
        if(_this.ProfilesFilter.filter[Key])
            filterParams[Key] = _this.ProfilesFilter.filter[Key];
    });

    var _params = filterParams;
    _params.profile_id = Params&&Params.profile_id?Params.profile_id:null;

    var hwId = App.SessionManager.GetCurrentHardwareId();
    if(hwId)
        _params.hardware_id = parseInt(hwId);

    var params =
        {
            id:this.CurrentProfilesRequestId,
            method:"GetPolicingProfiles",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                // if(!partial && _this.CurrentTargetsRequestId !== R.id)
                // {
                //     return;
                // }

                if(R.success)
                {
                    _this.Profiles = [];
                    _this.ProfilesFilter.total.page = 0;
                    _this.ProfilesFilter.total.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function (Profile)
                        {
                            _this.Profiles.push(new PolicingProfileModel(Profile));
                        });

                        _this.Total.page = parseInt(R.data.page,10);
                        _this.Total.count = parseInt(R.data.count,10);
                    }

                    _this.SignalProfilesUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

PolicingProfilesManager.prototype.GetProfilesById = function(Params)
{
    var _this = this;

    var _params = new PolicingProfileModel(Params);

    _params.is_not_individual = Params&&Params.is_not_individual?Params.is_not_individual:0;
    _params.size = Params&&Params.size?Params.size:100;

    this.CurrentProfilesRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    var hwId = App.SessionManager.GetCurrentHardwareId();
    if(hwId)
        _params.hardware_id = parseInt(hwId);

    var params =
        {
            id:this.CurrentProfilesRequestId,
            method:"GetPolicingProfiles",
            data:{
                Params:_params
            },
            callback:function (R)
            {
                if(R.success) {
                    if(Params && Params.callback && typeof Params.callback === "function") {
                        Params.callback(R.data.rows);
                    }
                }
                else {
                    _this.SignalTimetableConfigError.next(R.error);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

PolicingProfilesManager.prototype.SaveProfile = function(Params)
{
    var _this = this;

    var params = {
        id: webix.uid(),
        method: "SavePolicingProfile",
        data:{
            Profile: Params && Params.profile ? Params.profile : null,
            Config: Params && Params.config ? Params.config : null
        },
        callback:function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };
    App.ServerManager.CallMethod(params);
};

PolicingProfilesManager.prototype.SaveProfileConfig = function(Params)
{
  var _this = this;

  var _data = {
      Profile: Params && Params.profile ? Params.profile : null,
      Config: Params && Params.config ? Params.config : null
  };
  var params = {
      id: webix.uid(),
      method: "SavePolicingProfileConfig",
      data: _data,
      callback: function(R)
      {
          if(Params && Params.callback && typeof Params.callback === "function")
          {
              Params.callback(R);
          }
      }
  };

  App.ServerManager.CallMethod(params);
};

PolicingProfilesManager.prototype.DeleteProfile = function(Params)
{
    var _this = this;

    var params = {
        id: webix.uid(),
        method: "DeletePolicingProfile",
        data:{
            Profile : Params && Params.profile ? Params.profile : null
        },
        callback: function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

PolicingProfilesManager.prototype.GetProfiles = function()
{
    return webix.copy(this.Profiles);
};


PolicingProfilesManager.prototype.StopProfile = function(Params)
{
    var _this = this;

    var params = {
        id: webix.uid(),
        method: "StopPolicingProfile",
        data:{
            Profile: Params && Params.profile ? Params.profile : null
        },
        callback:function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };
    App.ServerManager.CallMethod(params);
};

PolicingProfilesManager.prototype.StartProfile = function(Params)
{
    var _this = this;

    var params = {
        id: webix.uid(),
        method: "StartPolicingProfile",
        data:{
            Profile: Params && Params.profile ? Params.profile : null
        },
        callback:function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };
    App.ServerManager.CallMethod(params);
};

PolicingProfilesManager.prototype.SaveTimetable = function(Params)
{
    var _this = this;

    var params = {
        id: webix.uid(),
        method: "SavePolicingTimetable",
        data:{Params: Params},
        callback:function(R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    _this.SignalTimetableConfigGet.next(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };
    App.ServerManager.CallMethod(params);
};
var AdBRLListItemStatusEnum = {
    disabled: 0,
    enabled: 1
};

function AdBRLListItemModel(Params, IsForm)
{
    if(!IsForm)
    {
        this.id = Params&&Params.id?Params.id:webix.uid();

        this.item_id = Params&&Params.item_id?Params.item_id:0;
        this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
    }

    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.uri = Params&&Params.uri?Params.uri:"";
};

function AdBRLListItemsFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"item_id", order_dir:"desc"};
};

function AdBRLManager()
{
    this.Active = true;

    this.ListItems = [];
    this.ListItemsFilter = new AdBRLListItemsFilterModel();

    this.SignalListItemsUpdated = new Rx.BehaviorSubject(0);
    this.SignalListItemUpdated = new Rx.BehaviorSubject(0);

    this.CurrentListItemsRequestId = 0;
};

AdBRLManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

AdBRLManager.prototype.RefreshListItems = function(Params)
{
    var _this = this;

    var partial = Params&&Params.items_ids ? true : false;

    if(!partial)
        this.CurrentListItemsRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.ListItemsFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.ListItemsFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.ListItemsFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.ListItemsFilter.sort.order_by = Params.sort.id;
        this.ListItemsFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.ListItemsFilter.total.page,
        size:this.ListItemsFilter.total.size,

        order_by:this.ListItemsFilter.sort.order_by,
        order_dir:this.ListItemsFilter.sort.order_dir
    };

    Object.keys(this.ListItemsFilter.filter).forEach(function (Key)
    {
        if(_this.ListItemsFilter.filter[Key])
            filterParams[Key] = _this.ListItemsFilter.filter[Key];
    });

    var _params = filterParams;

    _params.hardware_id = Params&&Params.hardware_id ? Params.hardware_id : null

    var params =
        {
            id:this.CurrentListItemsRequestId,
            method:"GetAdBRLListItems",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentListItemsRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (ListItem)
                            {
                                _this.SignalListItemUpdated.next(new AdBRLListItemModel(ListItem));
                            });
                        }
                    }
                    else
                    {
                        _this.ListItems = [];
                        _this.ListItemsFilter.total.page = 0;
                        _this.ListItemsFilter.total.count = 0;

                        if(R.data)
                        {
                            R.data.rows.forEach(function (ListItem)
                            {
                                _this.ListItems.push(new AdBRLListItemModel(ListItem));
                            });

                            _this.ListItemsFilter.total.page = parseInt(R.data.page,10);
                            _this.ListItemsFilter.total.count = parseInt(R.data.count,10);
                        }

                        _this.SignalListItemsUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

AdBRLManager.prototype.GetListItems = function()
{
    return this.ListItems;
};

AdBRLManager.prototype.SaveListItem = function(Params)
{
    var _this = this;

    var listItem = new AdBRLListItemModel(Params&&Params.list_item?Params.list_item:null);

    var params =
        {
            id: listItem.id,
            method:"SaveAdBRLListItem",
            data: {
                ListItem: listItem
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdBRLManager.prototype.DeleteListItem = function(Params)
{
    var _this = this;

    var listItem = new AdBRLListItemModel(Params&&Params.list_item?Params.list_item:null);

    var params =
        {
            id: listItem.id,
            method:"DeleteAdBRLListItem",
            data: {
                ListItem: listItem
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdBRLManager.prototype.EraseList = function(Params)
{
    var _this = this;

    var hwId = Params&&Params.hardware_id?parseInt(Params.hardware_id):null;

    var params =
        {
            id: webix.uid(),
            method:"ClearAdBRLListItems",
            data: {
                HwId: hwId
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdBRLManager.prototype.ImportListItems = function(Params)
{
    var _this = this;

    var listItems = Params&&Params.list_items?Params.list_items:null;

    var params =
        {
            method:"ImportAdBRLListItems",
            data: {
                Items: listItems
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

AdBRLManager.prototype.ImportListItemsFromQoE = function(Params)
{
    var _this = this;

    var params = {
        method: 'ImportAdBRLListItemsFromQoE',
        data: {
            HardwareId: Params && Params.hardware_id ? parseInt(Params.hardware_id, 10) : null,
            Categories: Params && Params.categories ? Params.categories : null,
            Max: Params && Params.max ? parseInt(Params.max) : 0
        },
        callback:function (R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

AdBRLManager.prototype.RefreshAdBRLConfig = function (Params)
{
    var _this = this;

    var params =
        {
            method:"GetAdBRLConfig",
            data:{HwId:this.GetCurrentHardwareId()},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

AdBRLManager.prototype.SaveAdBRLConfig = function (Params)
{
    var _this = this;

    var params =
        {
            method:"SaveAdBRLConfig",
            data:{HwId:this.GetCurrentHardwareId(), AdServer: Params.ad_server},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

AdBRLManager.prototype.GetCurrentHardwareId = function (HardwareId)
{
    return parseInt(HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId());
};
function VasCloudBalanceInfoModel(Params)
{
    this.currency = Params&&Params.currency?Params.currency:"EUR";

    if(SkinHelper.GetSkin() === SkinsEnum.dpiui2_inss || SkinHelper.IsCubroSkin())
    {
        this.currency = "EUR";
    }

    this.main_balance = Params&&Params.main_balance?Params.main_balance:0;
    this.available_balance = Params&&Params.available_balance?Params.available_balance:0;
    this.commission_hold_adv = Params&&Params.commission_hold_adv?Params.commission_hold_adv:0;
    this.commission_hold_city = Params&&Params.commission_hold_city?Params.commission_hold_city:0;
    this.earnings_on_payment = Params&&Params.earnings_on_payment?Params.earnings_on_payment:0;
    this.available_balance = Params&&Params.available_balance?Params.available_balance:0;

    this.title = this.available_balance + " " + this.currency;
};

var VasCloudLicProductTypeCodeEnum = {
    "dpiui2":"dpiui2"
};

var VasCloudLicLevelEnum = {
    "lite":"lite",
    "standard":"standard"
};

var VasCloudDPILicLevelEnum = {
    2:2,
    4:4,
    6:6,
    10:10,
    20:20,
    40:40,
    80:80,
    100:100
};

function VasCloudSessionManager(Params)
{
    "use strict";

    this.Active = true;

    this.mode = module ? module : "dpiui2";

    this.SignalIsLoggedIn = new Rx.BehaviorSubject(null);

    this.currentLogin = "";

    this.currentCompanyCode = "";

    this.MyProfileUpdatedSignal = new Rx.BehaviorSubject(0);

    this.MyCompanyProfileUpdatedSignal = new Rx.BehaviorSubject(0);

    this.MyLicsUpdatedSignal = new Rx.BehaviorSubject(0);

    this.AppVersion = new Rx.BehaviorSubject(0);

    this.BalanceInfoSignal = new Rx.BehaviorSubject(0);
    this.BalanceInfo  = new VasCloudBalanceInfoModel();

    this.Init();

    return this;
}

VasCloudSessionManager.prototype.Init = function(Params)
{
};

VasCloudSessionManager.prototype.Destroy = function ()
{
    this.Active = false;
};

VasCloudSessionManager.prototype.IsLoggedIn = function()
{
    return this.SignalIsLoggedIn.getValue();
};

VasCloudSessionManager.prototype.CheckLoggedIn = function(Params)
{
    var _this  = this;

    var params = {
        method:"VasCloudAuth",
        callback: function (R)
        {
            if (!R.success && R.error.msg)
            {
                _this.SignalIsLoggedIn.next(false);

                if(_this.currentLogin)
                {
                    _this.ResetProfile();
                    _this.currentLogin = "";
                }
            }

            if (R.success)
            {
                _this.SignalIsLoggedIn.next(true);
                _this.currentLogin = R.data.username;
            }

            if(Params && Params.callback)
            {
                Params.callback(_this.SignalIsLoggedIn.getValue());
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.Login = function(Params)
{
    var _this  = this;

    var params = {
        method:"VasCloudLogin",
        data:{
            username:Params&&Params.username ? Params.username : "",
            password:Params&&Params.password ? Params.password : "",
            remember:Params&&Params.remember ? true : false
        },
        callback: function (R)
        {
            if (R.success)
            {
                _this.SignalIsLoggedIn.next(true);
                _this.currentLogin = R.data.username;

                _this.RefreshMyUserProfile();

                if(Params && Params.callback)
                {
                    Params.callback(R);
                }
            }
            else if (Params && Params.callback)
            {
                Params.callback(R);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.Logout = function(Params)
{
    var _this  = this;

    var params = {
        method:"VasCloudLogout",
        callback: function (R)
        {
            if (R.success)
            {
                _this.SignalIsLoggedIn.next(false);

                _this.ResetProfile();
                _this.currentLogin = "";
            }

            if(Params && Params.callback)
            {
                Params.callback(_this.SignalIsLoggedIn.getValue());
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.RefreshMyUserProfile = function()
{
    var _this = this;

    var params = {
        method:"VasCloudGetMyUserProfile",
        callback: function (R)
        {
            if (R.success&&R.data)
            {
                var data = Array.isArray(R.data)?R.data[0]:R.data;

                _this.currentLogin = data.username;

                _this.SetProfile(data);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.SaveMyProfile = function(Params)
{
    "use strict";

    var _this = this;

    var params =
        {
            data:{MyProfile:Params.data},
            method:"VasCloudSaveMyUserProfile",
            callback:function (R)
            {
                if (R.success)
                {
                    _this.SetProfile(R.data);
                }

                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.ChangeMyPassword = function(Params)
{
    "use strict";

    var _this = this;

    var params =
        {
            data:Params.data,
            method:"VasCloudChangeMyPassword",
            callback:function (R)
            {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.GetMyUserProfile = function()
{
    "use strict";

    if(this.currentLogin)
    {
        return JSON.parse(localStorage.getItem("VasCloudProfile_"+this.currentLogin));
    }
    else
    {
        return null;
    }
};

VasCloudSessionManager.prototype.SetProfile = function(Profile)
{
    "use strict";

    localStorage.setItem("VasCloudProfile_"+this.currentLogin, JSON.stringify(Profile));

    this.MyProfileUpdatedSignal.next(1);
};

VasCloudSessionManager.prototype.ResetProfile = function()
{
    "use strict";
    if(this.currentLogin)
    {
        return localStorage.setItem("VasCloudProfile_"+this.currentLogin, null);
    }
};

VasCloudSessionManager.prototype.SetPreference = function(Id,Value,Object)
{
    localStorage.setItem("VasCloud"+this.currentLogin+"_"+Id, Object?JSON.stringify(Value):Value);
};

VasCloudSessionManager.prototype.GetPreference = function(Id,Object)
{
    var item = localStorage.getItem("VasCloud"+this.currentLogin+"_"+Id);

    return Object?JSON.parse(item):item;
};

VasCloudSessionManager.prototype.RefreshAppVersion = function()
{
    var _this  = this;

    var hardwareId = this.GetCurrentHardwareId();

    var params =
        {
            method:"VasCloudGetAppVersion",
            callback:function (R)
            {
                if(R.success)
                {
                    _this.AppVersion.next(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.SetBackendLang = function()
{
    var _this  = this;

    var params =
        {
            method:"VasCloudSetCurrentLocalLang",
            data:{Lang:LocalesEnum[LangHelper.GetLocale()].locale},
            callback:function (R)
            {
                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.RefreshMyCompanyProfile = function()
{
    "use strict";

    var _this = this;

    var params = {
        method:"VasCloudGetMyCompanyProfile",
        callback: function (R)
        {
            if (R.success&&R.data)
            {
                var data = Array.isArray(R.data)?R.data[0]:R.data;

                _this.SetCompanyProfile(data);
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.SetCompanyProfile = function(Profile)
{
    "use strict";
    localStorage.setItem("VasCloudCompanyProfile_"+this.currentLogin, JSON.stringify(Profile));

    this.MyCompanyProfileUpdatedSignal.next(1);
};

VasCloudSessionManager.prototype.GetMyCompanyProfile = function()
{
    "use strict";

    if(this.currentLogin)
    {
        return JSON.parse(localStorage.getItem("VasCloudCompanyProfile_"+this.currentLogin));
    }
    else
    {
        return null;
    }
};

VasCloudSessionManager.prototype.SaveMyCompanyProfile = function(Params)
{
    "use strict";

    var _this = this;

    var params =
        {
            data:{MyCompany:Params.data},
            method:"VasCloudSaveMyCompanyProfile",
            callback:function (R)
            {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.RefreshBalanceInfo = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"VasCloudAdsGetBalanceInfo",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success && R.data)
                {
                    _this.BalanceInfo = new VasCloudBalanceInfoModel(R.data);
                    _this.BalanceInfoSignal.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

VasCloudSessionManager.prototype.GetBalanceInfo = function()
{
    return this.BalanceInfo;
};

VasCloudSessionManager.prototype.SendCompanyRegistrationForm = function(Params)
{
    var _this = this;

    var params =
        {
            data:{RegForm:Params.data},
            method:"VasCloudSendCompanyRegistrationForm",
            callback:function (R)
            {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.VasCloudSendPasswordRestoreCode = function(Params)
{
    var _this = this;

    var params =
        {
            data:Params.data,
            method:"VasCloudSendPasswordRestoreCode",
            callback:function (R)
            {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.RefreshMyLics = function()
{
    var _this = this;

    var params = {
        method:"VasCloudGetMyLics",
        callback: function (R)
        {
            if (R.success)
            {
                _this.MyLicsUpdatedSignal.next(R.data.rows);
            }
            else
            {
                _this.MyLicsUpdatedSignal.next(0);
                webix.message({type:"error", text:R.error.msg});
            }
        }
    };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.SendLicenceRequest = function(Params)
{
    var _this = this;

    var params =
        {
            data:{ReqForm:Params.data},
            method:"VasCloudSendLicenceRequest",
            callback:function (R)
            {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.SendPaymentRequestForm = function(Params)
{
    var _this = this;

    var params =
        {
            data:{RequestForm:Params.data},
            method:"VasCloudSendPaymentRequestForm",
            callback:function (R)
            {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudSessionManager.prototype.SendHNYForm = function(Params)
{
    var _this = this;

    var params =
        {
            data:{RegForm:Params.data},
            method:"VasCloudSendHappyNewYearGiftForm",
            callback:function (R)
            {
                if(Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};



var VasCloudAdsHardwareSyncStatusEnum = {
    not_started:0,
    in_progress:1,
    completed_and_need_restart:2,
    completed:3,
    error:4,
    error_max_attempts:5
};

var VasCloudAdsHardwareSyncStatusesDic =
{
    "0": {"value": LangHelper.GetString("VasCloud", "Sync not started"), "id": "0"},
    "1": {"value": LangHelper.GetString("VasCloud", "Sync in progress"), "id": "1"},
    "2": {"value": LangHelper.GetString("VasCloud", "Sync comleted and neet restart"), "id": "2"},
    "3": {"value": LangHelper.GetString("VasCloud", "Sync comleted"), "id": "3"},
    "4": {"value": LangHelper.GetString("VasCloud", "Sync error"), "id": "4"},
    "5": {"value": LangHelper.GetString("VasCloud", "Sync error"), "id": "5"}
};

function VasCloudAdsHardwareSyncModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();

    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
    this.name = Params&&Params.name?Params.name:"";
    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.sync_status = Params&&Params.sync_status?Params.sync_status:0;
    this.sync_need = Params&&Params.sync_need?Params.sync_need:0;
    this.sync_attempt = Params&&Params.sync_attempt?Params.sync_attempt:0;
    this.sync_error = Params&&Params.sync_error?Params.sync_error:"";

    this.valid = true;
};

function VasCloudAdsManager(Params)
{
    "use strict";

    this.Active = true;

    this.HardwareSyncList = [];
    this.HardwareSyncListUpdatedSignal = new Rx.BehaviorSubject(0);
    this.HardwareSyncUpdatedSignal = new Rx.BehaviorSubject(0);
    this.CurrentHardwareSyncListRequestId = 0;

    this.AdsServiceEnabledSignal = new Rx.BehaviorSubject(0);

    this.Init();

    return this;
}

VasCloudAdsManager.prototype.Init = function(Params)
{
};

VasCloudAdsManager.prototype.Destroy = function ()
{
    this.Active = false;
};

VasCloudAdsManager.prototype.RefershHardwareSyncList = function(Params)
{
    var _this = this;

    var partial = Params&&Params.hardware_ids ? true : false;

    if(!partial)
        this.CurrentHardwareSyncListRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    var _params = 
    {
        hardware_ids:partial?Params&&Params.hardware_ids:null
    };

    var params =
        {
            id:this.CurrentHardwareSyncListRequestId,
            method:"VasCloudAdsGetHws",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentHardwareSyncListRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (HardwareSyncModel)
                            {
                                _this.HardwareSyncUpdatedSignal.next(new VasCloudAdsHardwareSyncModel(HardwareSyncModel));
                            });
                        }
                    }
                    else
                    {
                        _this.HardwareSyncList = [];

                        if(R.data)
                        {
                            R.data.rows.forEach(function (HardwareSyncModel)
                            {
                                _this.HardwareSyncList.push(new VasCloudAdsHardwareSyncModel(HardwareSyncModel));
                            });

                        }

                        _this.HardwareSyncListUpdatedSignal.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

VasCloudAdsManager.prototype.GetHardwareSyncList = function()
{
    return this.HardwareSyncList;
};

VasCloudAdsManager.prototype.EnableHardware = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            id: webix.uid(),
            method:"VasCloudAdsEnableOnHardware",
            data: {
                HwId: parseInt(Params.hardware_id,10),
                Enabled: parseInt(Params.enabled,10)
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

VasCloudAdsManager.prototype.RestartHardware = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"VasCloudAdsRestartHardware",
            data:{HwId: parseInt(Params.hardware_id,10)},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

VasCloudAdsManager.prototype.ForceListSyncOnHardware = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"VasCloudAdsForceListSyncOnHw",
            data:{HwId: parseInt(Params.hardware_id,10)},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

VasCloudAdsManager.prototype.IsAdsServiceEnabled = function()
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"VasCloudAdsIsAdsServiceEnabled",
            data:{CheckLocalOnly: 1},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                _this.AdsServiceEnabledSignal.next(R.success && R.data ? 1 : 0);
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

VasCloudAdsManager.prototype.EnableAdsService = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"VasCloudAdsEnableAdsService",
            data:{Enabled: Params.enabled ? 1 : 0},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};



function VasCloudProtocolsLogsManager(Params)
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null)
    };
}

VasCloudProtocolsLogsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

VasCloudProtocolsLogsManager.prototype.DeleteRow = function(Params)
{
    var _this = this;

    var Row = Params&&Params.Row?Params.Row:null;

    var params =
        {
            id: webix.uid(),
            method:"VasCloudCustomProtocolsSyncDeleteLogsRow",
            data: {Row},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsLogsManager.prototype.DeleteRows = function(Params)
{
    var _this = this;

    var Ids = Params&&Params.Ids?Params.Ids:[0];

    var params =
        {
            id: webix.uid(),
            method:"VasCloudCustomProtocolsSyncDeleteLogsRows",
            data: {Ids},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
function VasCloudProtocolsCustomManager(Params)
{
    this.Active = true;

    this.ProdEnabled = 1;
    this.ProdDisabled = 0;

    this.CustomNumberMin = 1;
    this.CustomNumberMax = 1024;

    this.TypeSNI = "sni";
    this.TypeCN = "cn";
    this.TypeIP = "ip";
    this.TypeURL = "url";

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        SaveHardware: new Rx.BehaviorSubject(null),
        SaveHardwareError: new Rx.BehaviorSubject(null),

        SaveProtocol: new Rx.BehaviorSubject(null),
        SaveProtocolError: new Rx.BehaviorSubject(null),

        DeleteProtocol: new Rx.BehaviorSubject(null),
        DeleteProtocolError: new Rx.BehaviorSubject(null),

        DeleteProtocols: new Rx.BehaviorSubject(null),
        DeleteProtocolsError: new Rx.BehaviorSubject(null),

        EnableProtocol: new Rx.BehaviorSubject(null),
        EnableProtocolError: new Rx.BehaviorSubject(null),

        DisableProtocol: new Rx.BehaviorSubject(null),
        DisableProtocolError: new Rx.BehaviorSubject(null),

        EnableProtocolItem: new Rx.BehaviorSubject(null),
        EnableProtocolItemError: new Rx.BehaviorSubject(null),

        DisableProtocolItem: new Rx.BehaviorSubject(null),
        DisableProtocolItemError: new Rx.BehaviorSubject(null),

        SaveProtocolItem: new Rx.BehaviorSubject(null),
        SaveProtocolItemError: new Rx.BehaviorSubject(null),

        DeleteProtocolItem: new Rx.BehaviorSubject(null),
        DeleteProtocolItemError: new Rx.BehaviorSubject(null),

        DeleteProtocolsItems: new Rx.BehaviorSubject(null),
        DeleteProtocolsItemsError: new Rx.BehaviorSubject(null),

        CopyProtocolsError: new Rx.BehaviorSubject(null),
        CopyProtocols: new Rx.BehaviorSubject(0),
        ProcessCopyProtocols: new Rx.BehaviorSubject(0),

        ProtocolsImportedItemsSaved: new Rx.BehaviorSubject(0),
        ProtocolsImportedItemsSaveError: new Rx.BehaviorSubject(0)
    };
}

VasCloudProtocolsCustomManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};



/* Hardware */
function CustomProtocolHardwareModel(Params)
{
    var _this = this;

    this.enabled = Params&&Params['enabled']?Params['enabled']:0;
    this.mode = Params&&Params['mode']?Params['mode']:_this.ProdDisabled;
    this.sync_mode = Params&&Params['sync_mode']?Params['sync_mode']:"";
}

VasCloudProtocolsCustomManager.prototype.SaveHardware = function(Params)
{
    var _this = this;

    var HardwareId = Params&&Params['hardware_id']?parseInt(Params['hardware_id']):0;
    var model = new CustomProtocolHardwareModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"VasCloudCustomProtocolsSaveHardware",
            data: {HardwareId, Params: model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.SaveHardware.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.SaveHardwareError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};



/* Protocol */
function ProtocolModel(Params)
{
    var _this = this;

    this._id = Params&&Params['_id']?Params['_id']:0;
    this.companies_company_id = Params&&Params['companies_company_id']?Params['companies_company_id']:null;
    this.public_alias = Params&&Params['public_alias']?Params['public_alias']:"";
    this.custom_number = Params&&Params['custom_number']?Params['custom_number']:_this.CustomNumberMin;
    this.prod_enabled = Params&&Params['prod_enabled']?Params['prod_enabled']:_this.ProdDisabled;
    this.description = Params&&Params['description']?Params['description']:"";
}

VasCloudProtocolsCustomManager.prototype.SaveProtocol = function(Params)
{
    var _this = this;

    var model = new ProtocolModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"SaveCustomProtocol",
            data: {Protocol: model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.SaveProtocol.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.SaveProtocolError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.DeleteProtocol = function(Params)
{
    var _this = this;

    var model = new ProtocolModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"DeleteCustomProtocol",
            data: {Protocol: model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DeleteProtocol.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.DeleteProtocolError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.DeleteProtocols = function(Protocols, RowIds = [])
{
    var _this = this;

    var params =
        {
            id: webix.uid(),
            method:"DeleteMyCustomsProtocols",
            data: {Protocols},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DeleteProtocols.next(RowIds);
                }
                else if(!R.success && R.error)
                    _this.Signals.DeleteProtocolsError.next(R.error);

                if(Protocols && Protocols.callback && typeof Protocols.callback === "function")
                {
                    Protocols.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.EnableProtocol = function(Params)
{
    var _this = this;

    var Protocol = Params&&Params.Protocol?Params.Protocol:null;

    var params =
        {
            id: webix.uid(),
            method:"EnableCustomProtocol",
            data: {Protocol},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.EnableProtocol.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.EnableProtocolError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.DisableProtocol = function(Params)
{
    var _this = this;

    var Protocol = Params&&Params.Protocol?Params.Protocol:null;

    var params =
        {
            id: webix.uid(),
            method:"DisableCustomProtocol",
            data: {Protocol},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DisableProtocol.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.DisableProtocolError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.EnableDisableProtocols = function(Params)
{
    var _this = this;

    var Enable = Params&&Params.Enable?Params.Enable:false;

    var ProtocolsIds = Params&&Params.ProtocolsIds?Params.ProtocolsIds:[];

    var params =
        {
            id: webix.uid(),
            method:Enable?"EnableCustomProtocols":"DisableCustomProtocols",
            data: {ProtocolsIds},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.ImportProtocolList = function(Params)
{
    var _this = this;

    var Protocols = Params&&Params.Protocols?Params.Protocols:null;
    var CompanyId = Params&&Params.CompanyId?parseInt(Params.CompanyId):null;

    var params =
        {
            method: "SaveCustomProtocols",
            data: {Protocols, CompanyId},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.GetBusyCustomNumber = function(Params)
{
    var _this = this;

    var CompanyId = Params&&Params.CompanyId?parseInt(Params.CompanyId):null;

    var params =
        {
            method: "GetCustomProtocolsBusyCustomNumbers",
            data: {CompanyId},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.CopyProtocols = function(Params)
{
    var _this = this;
    var company_id = parseInt(Params && Params.company_id ? Params.company_id : 0);
    var protocols = Params && Params.protocols ? Params.protocols : [];

    if(!Array.isArray(protocols))
    {
        protocols = [protocols];
    }

    var params =
        {
            id: webix.uid(),
            method:"CopyCustomProtocols",
            data: {
                CompanyId: company_id,
                Protocols: protocols
            },
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.ProcessCopyProtocols.next(0);

                if(R.success)
                {
                    _this.Signals.CopyProtocols.next(1);
                }
                else if(!R.success && R.error)
                    _this.Signals.CopyProtocolsError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.ProcessCopyProtocols.next(1);

    App.ServerManager.CallMethod(params);
};



/* Protocol Item */
function ProtocolItemModel(Params)
{
    var _this = this;

    this._id = Params&&Params['_id']?Params['_id']:0;
    this.protocol_id = Params&&Params['protocol_id']?Params['protocol_id']:null;
    this.type = Params&&Params['type']?Params['type']:_this.TypeSNI;
    this.uri = Params&&Params['uri']?Params['uri']:"";
    this.validation_error = Params&&Params['validation_error']?Params['validation_error']:"";
}

VasCloudProtocolsCustomManager.prototype.SaveProtocolItem = function(Params)
{
    var _this = this;

    var model = new ProtocolItemModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"SaveCustomProtocolItem",
            data: {Item: model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.SaveProtocolItem.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.SaveProtocolItemError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.DeleteProtocolItem = function(Params)
{
    var _this = this;

    var model = new ProtocolItemModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"DeleteCustomProtocolItem",
            data: {Item: model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DeleteProtocolItem.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.DeleteProtocolItemError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.DeleteProtocolsItems = function(Protocols, Items, RowIds = [])
{
    var _this = this;

    var params =
        {
            id: webix.uid(),
            method:"DeleteMyCustomsProtocolsItems",
            data: {Protocols, Items},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DeleteProtocolsItems.next(RowIds);
                }
                else if(!R.success && R.error)
                    _this.Signals.DeleteProtocolsItemsError.next(R.error);

                if(Protocols && Protocols.callback && typeof Protocols.callback === "function")
                {
                    Protocols.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.EnableProtocolItem = function(Params)
{
    var _this = this;

    var Item = Params&&Params.Item?Params.Item:null;

    var params =
        {
            id: webix.uid(),
            method:"EnableCustomProtocolItem",
            data: {Item},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.EnableProtocolItem.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.EnableProtocolItemError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.DisableProtocolItem = function(Params)
{
    var _this = this;

    var Item = Params&&Params.Item?Params.Item:null;

    var params =
        {
            id: webix.uid(),
            method:"DisableCustomProtocolItem",
            data: {Item},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DisableProtocolItem.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.DisableProtocolItemError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.EnableDisableProtocolItems = function(Params)
{
    var _this = this;

    var Enable = Params&&Params.Enable?Params.Enable:false;

    var ItemsIds = Params&&Params.ItemsIds?Params.ItemsIds:[];

    var params =
        {
            id: webix.uid(),
            method:Enable?"EnableCustomProtocolItems":"DisableCustomProtocolItems",
            data: {ItemsIds},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.ImportProtocolItemList = function(Params)
{
    var _this = this;

    var ProtocolId = Params&&Params.ProtocolId?parseInt(Params.ProtocolId):null;
    var ProtocolItems = Params&&Params.Items?Params.Items:null;
    var Items = [];

    ProtocolItems.forEach(function (item){
        Items.push(new ProtocolItemModel(item));
    });

    var params =
        {
            method: "SaveCustomProtocolItems",
            data: {ProtocolId, Items, CheckDuplicates: true},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.GetSniResources = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    this.Signals.Progress.next(1);

    var params =
        {
            id: webix.uid(),
            method:"GetSniResources",
            data: {Resource:Params.resource},
            callback:function (R)
            {
                _this.Signals.Progress.next(0);

                if(!_this.Active)
                    return;

                if(R.success)
                {
                    if(Params && Params.callback && typeof Params.callback === "function")
                    {
                        Params.callback(R.data);
                    }
                }
                else if(!R.success && R.error)
                    _this.Signals.Progress.next(R.error);
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.ForcedUploadCustomPrtclsAndDefaultLists = function (Params)
{
    var _this = this;

    var params =
        {
            id: webix.uid(),
            method:"ForcedUploadCustomPrtclsAndDefaultLists",
            data: {Params: Params.data},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.SaveProtocolsImportedItems = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"SaveCustomProtocolImportedItems",
            data: {
                ProtocolId:parseInt(Params.protocolId),
                ImportFiles: Params.importFiles,
                CheckDuplicates: true
            },
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ProtocolsImportedItemsSaved.next(R);
                }
                else if(!R.success && R.error)
                    _this.Signals.ProtocolsImportedItemsSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudProtocolsCustomManager.prototype.CheckResourcesItemsIntersection = function(Params)
{
    var _this = this;

    var ProtocolItems = Params&&Params.Items?Params.Items:null;
    var Items = [];

    ProtocolItems.forEach(function (item){
        Items.push(new ProtocolItemModel(item));
    });

    var params =
        {
            method: "CheckResourcesItemsIntersection",
            data: {
                Items,
                SectionCheck: Params.SectionCheck
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

function VasCloudCustomProtocolGroupsFormModel(Params)
{
    var _this = this;

    this._id = Params&&Params._id?Params._id:0;
    this.company_id = Params&&Params.company_id?Params.company_id:null;
    this.code = Params&&Params.code?Params.code:null;
    this.name = Params&&Params.name?Params.name:null;
    this.name_json = Params&&Params.name_json?Params.name_json:null;
    this.create_time = Params&&Params.create_time?Params.create_time:null;
    this.update_time = Params&&Params.update_time?Params.update_time:null;
    this.create_user = Params&&Params.create_user?Params.create_user:null;
    this.update_user = Params&&Params.update_user?Params.update_user:null;
}

function VasCloudCustomProtocolGroupNameFormModel(Params)
{
    var _this = this;

    this._id = Params&&Params._id?Params._id:0;
    this.protocol_id = Params&&Params.protocol_id?Params.protocol_id:null;
    this.custom_protocol_id = Params&&Params.custom_protocol_id?Params.custom_protocol_id:null;
    this.group_id = Params&&Params.group_id?Params.group_id:null;
    this.create_time = Params&&Params.create_time?Params.create_time:null;
    this.update_time = Params&&Params.update_time?Params.update_time:null;
    this.create_user = Params&&Params.create_user?Params.create_user:null;
    this.update_user = Params&&Params.update_user?Params.update_user:null;
}


function VasCloudCustomProtocolGroupsManager(Params)
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null)
    };
}

VasCloudCustomProtocolGroupsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

VasCloudCustomProtocolGroupsManager.prototype.Save = function(Params)
{
    const _this = this;
    var Model = new VasCloudCustomProtocolGroupsFormModel(Params.data);

    var params =
        {
            id: webix.uid(),
            method:"SaveCustomProtocolGroup",
            data: {
                Group: Model,
                GroupCode: Model.code ? Number(Model.code) : null
            },
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudCustomProtocolGroupsManager.prototype.Delete = function(Params)
{
    const _this = this;
    var Model = new VasCloudCustomProtocolGroupsFormModel(Params.data);

    var params =
        {
            id: webix.uid(),
            method:"DeleteCustomProtocolsGroup",
            data: {Group: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudCustomProtocolGroupsManager.prototype.SaveGroupName = function(Params)
{
    const _this = this;
    var Model = new VasCloudCustomProtocolGroupNameFormModel(Params.data);

    var params =
        {
            id: webix.uid(),
            method:"SaveCustomProtocolGroupName",
            data: {
                Name: Model
            },
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

VasCloudCustomProtocolGroupsManager.prototype.DeleteGroupName = function(Params)
{
    const _this = this;
    var Model = new VasCloudCustomProtocolGroupNameFormModel(Params.data);

    var params =
        {
            id: webix.uid(),
            method:"DeleteCustomProtocolsGroupName",
            data: {Name: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
function VasCloudProtocolsHardwaresManager(Params)
{
    this.Active = true;

    this.HardwareModeTest = "test";
    this.HardwareModeProd = "prod";

    this.Signals = {};
};

VasCloudProtocolsHardwaresManager.prototype.Destroy = function()
{
    this.Active = false;
};

VasCloudProtocolsHardwaresManager.prototype.Enable = function(Params)
{
    var _this = this;

    var api_method = Params.enabled?"VasCloudCustomProtocolsEnableHardware":"VasCloudCustomProtocolsDisableHardware";

    var params =
        {
            id: webix.uid(),
            method: api_method,
            data: {HardwareId: parseInt(Params.hardware_id)},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

VasCloudProtocolsHardwaresManager.prototype.ChangeMode = function(HardwareId, Mode = "test", CallBack)
{
    var _this = this;

    var params =
        {
            id: webix.uid(),
            method:"VasCloudCustomProtocolsChangeHardwareMode",
            data: {HardwareId: parseInt(HardwareId), Mode},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(CallBack && CallBack.callback && typeof CallBack.callback === "function")
                {
                    CallBack.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};
var CgNatProfileStatusEnum = {
    disabled: 0,
    enabled: 1
};

var CgNatProfileTypeEnum = {
    default: 0,
    one: 1
};

function CgNatProfileModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.profile_id = Params&&Params.profile_id?Params.profile_id:0;
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:null;
    this.title = Params&&Params.title?Params.title:"";
    this.date = Params&&Params.date?Params.date:0;
    this.status = Params&&Params.status?parseInt(Params.status):CgNatProfileStatusEnum.disabled;

    this.nat_type = Params&&Params.nat_type?parseInt(Params.nat_type):CgNatProfileTypeEnum.default;

    this.form_data = Params&&Params.form_data?Params.form_data:"";
    this.subscribers_updated = Params && Params.subscribers_updated? parseInt(Params.subscribers_updated):0;
    this.sync_marker = Params&&Params.sync_marker?Params.sync_marker:0;

    this.valid = true;
};

function CgNatFormModel(Params)
{
    var __this = this;

    this.title = Params&&Params.title?Params.title:"";
    this.nat_ip_pool = Params&&Params.nat_ip_pool?Params.nat_ip_pool:"";
    this.nat_type = Params&&Params.nat_type?parseInt(Params.nat_type):CgNatProfileTypeEnum.default;
    this.nat_tcp_max_sessions = Params&&Params.nat_tcp_max_sessions?parseInt(Params.nat_tcp_max_sessions):0;
    this.nat_udp_max_sessions = Params&&Params.nat_udp_max_sessions?parseInt(Params.nat_udp_max_sessions):0;

    this.valid = true;
}

function CgNatProfileFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"profile_id", order_dir:"desc"};
};

function CgNatManager()
{
    this.Active = true;

    this.Profiles = [];
    this.ProfilesFilter = new CgNatProfileFilterModel();

    this.SignalProfilesUpdated = new Rx.BehaviorSubject(0);
    this.SignalProfileUpdated = new Rx.BehaviorSubject(0);

    this.CurrentProfileRequestId = 0;
};

CgNatManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

CgNatManager.prototype.RefreshProfiles = function(Params)
{
    var _this = this;

    var partial = Params&&Params.profiles_ids ? true : false;

    if(!partial)
        this.CurrentTasksRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.ProfilesFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.ProfilesFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.ProfilesFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.ProfilesFilter.sort.order_by = Params.sort.id;
        this.ProfilesFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.ProfilesFilter.total.page,
        size:this.ProfilesFilter.total.size,

        order_by:this.ProfilesFilter.sort.order_by,
        order_dir:this.ProfilesFilter.sort.order_dir
    };

    Object.keys(this.ProfilesFilter.filter).forEach(function (Key)
    {
        if(_this.ProfilesFilter.filter[Key])
            filterParams[Key] = _this.ProfilesFilter.filter[Key];
    });

    var _params = filterParams;
    _params.profiles_ids = partial?Params&&Params.profiles_ids:null;

    var hId = App.SessionManager.GetCurrentHardwareId();
    if(hId)
    {
        _params.hardware_id = parseInt(hId);
    }
    var params =
        {
            id:this.CurrentTasksRequestId,
            method:"GetCgNatProfiles",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentTasksRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (Profile)
                            {
                                _this.SignalProfileUpdated.next(new CgNatProfileModel(Profile));
                            });
                        }
                    }
                    else
                    {
                        _this.Profiles = [];
                        _this.ProfilesFilter.total.page = 0;
                        _this.ProfilesFilter.total.count = 0;

                        if(R.data)
                        {
                            R.data.rows.forEach(function (Profile)
                            {
                                _this.Profiles.push(new CgNatProfileModel(Profile));
                            });

                            _this.ProfilesFilter.total.page = parseInt(R.data.page,10);
                            _this.ProfilesFilter.total.count = parseInt(R.data.count,10);
                        }

                        _this.SignalProfilesUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

CgNatManager.prototype.GetProfiles = function()
{
    return this.Profiles;
};

CgNatManager.prototype.SaveProfile = function(Params)
{
    var _this = this;

    var profile = new CgNatProfileModel(Params&&Params.profile?Params.profile:null);
    var profile_form = new CgNatFormModel(Params&&Params.profile_form?Params.profile_form:null);

    var params =
        {
            id: profile.id,
            method:"SaveCgNatProfile",
            data: {
                Profile: profile,
                Form: profile_form
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

CgNatManager.prototype.DeleteProfile = function(Params)
{
    var _this = this;

    var profile = new CgNatProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"DeleteCgNatProfile",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

CgNatManager.prototype.RunProfile = function(Params)
{
    var _this = this;

    var profile = new CgNatProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"RunCgNatProfile",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

CgNatManager.prototype.StopProfile = function(Params)
{
    var _this = this;

    var profile = new CgNatProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"StopCgNatProfile",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
CgNatStatusProtoEnum = {
    UDP: "UDP",
    TCP: "TCP"
};

CgNatStatusMaskEnum = {
    0: "0x0",
    1 : "0x1"
};


function CgNatStatusModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();
    this.profile_id = Params&&Params.profile_id?Params.profile_id : 0;
    this.proto = Params&&Params.proto?Params.proto : CgNatStatusProtoEnum.TCP;
    this.nthr = Params&&Params.nthr?Params.nthr : 0;
    this.ip_mask = Params&&Params.ip_mask?Params.ip_mask : CgNatStatusMaskEnum[0];
    this.whip = Params&&Params.whip?Params.whip : '';
    this.title = Params&&Params.title?Params.title : '';
    this.num_port = Params&&Params.num_port?Params.num_port : 0;
    this.use_port = Params&&Params.use_port?Params.use_port : 0;
    this.sync_marker = Params&&Params.sync_marker?Params.sync_marker : 0;

    this.valid = true;
};

function DetailStatusFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"profile_id", order_dir:"desc"};
};

function CgNatFullStatusModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();
    this.profile_id = Params&&Params.profile_id?Params.profile_id : 0;
    this.proto = Params&&Params.proto?Params.proto : null;
    this.nthr = Params&&Params.nthr?Params.nthr : null;
    this.title = Params&&Params.title?Params.title : '';
    this.ip_mask = Params&&Params.ip_mask?Params.ip_mask : CgNatStatusMaskEnum[0];
    this.num_addr = Params&&Params.num_addr?Params.num_addr : 0;
    this.use_addr = Params&&Params.use_addr?Params.use_addr : 0;
    this.num_port = Params&&Params.num_port?Params.num_port : 0;
    this.use_port = Params&&Params.use_port?Params.use_port : 0;

    this.valid = true;
};

function FullStatusFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"profile_id", order_dir:"desc"};
};

function CgNatSubscriberStatusModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();
    this.profile_id = Params&&Params.profile_id?Params.profile_id : 0;
    this.ipv4 = Params&&Params.ipv4?Params.ipv4 : '';
    this.whiteip = Params&&Params.whiteip?Params.whiteip : '';
    this.title = Params&&Params.title?Params.title : '';
    this.sess_tcp = Params&&Params.sess_tcp?Params.sess_tcp : 0;
    this.sess_udp = Params&&Params.sess_udp?Params.sess_udp : 0;

    this.valid = true;
};

function SubscriberStatusFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"profile_id", order_dir:"desc"};
};


function CgNatStatusManager()
{
    this.FullStatus = [];
    this.FullStatusFilter = new FullStatusFilterModel();

    this.DetailedStatus = [];
    this.DetailedStatusFilter = new DetailStatusFilterModel();

    this.SubscribersStatus = [];
    this.SubscribersStatusFilter = new SubscriberStatusFilterModel();

    this.FullStatusUpdated = new Rx.BehaviorSubject(0);
    this.DetailedStatusUpdated = new Rx.BehaviorSubject(0);
    this.SubscribersStatusUpdated = new Rx.BehaviorSubject(0);

    this.CurrentProfileRequestId = 0;
};

CgNatStatusManager.prototype.Destroy = function(Params)
{
};

CgNatStatusManager.prototype.RefreshDetailedStatus = function(Params)
{
    var _this = this;

    this.CurrentTasksRequestId = webix.uid();

    if(Params&&Params.page >= 0)
    {
        this.DetailedStatusFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.DetailedStatusFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.DetailedStatusFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.DetailedStatusFilter.sort.order_by = Params.sort.id;
        this.DetailedStatusFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.DetailedStatusFilter.total.page,
        size:this.DetailedStatusFilter.total.size,

        order_by:this.DetailedStatusFilter.sort.order_by,
        order_dir:this.DetailedStatusFilter.sort.order_dir
    };

    Object.keys(this.DetailedStatusFilter.filter).forEach(function (Key)
    {
        if(_this.DetailedStatusFilter.filter[Key])
            filterParams[Key] = _this.DetailedStatusFilter.filter[Key];
    });

    if(Params && Params.profile_ids)
    {
        filterParams.profile_ids = Params.profile_ids;
    }

    filterParams.hardware_id = App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            id:this.CurrentTasksRequestId,
            method:"GetCgNatDetailStatus",
            data:{
                Params: filterParams
            },
            callback:function (R)
            {
                // if(_this.CurrentTasksRequestId != R.id)
                // {
                //     return;
                // }

                if(R.success)
                {
                    _this.DetailedStatus = [];
                    _this.DetailedStatusFilter.total.page = 0;
                    _this.DetailedStatusFilter.total.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function (Status)
                        {
                            _this.DetailedStatus.push(new CgNatStatusModel(Status));
                        });

                        _this.DetailedStatusFilter.total.page = parseInt(R.data.page,10);
                        _this.DetailedStatusFilter.total.count = parseInt(R.data.count,10);
                    }
                    _this.DetailedStatusUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };
     App.ServerManager.CallMethod(params);
};

CgNatStatusManager.prototype.GetDetailedStatus = function()
{
    return this.DetailedStatus;
};

CgNatStatusManager.prototype.RefreshFullStatus = function(Params)
{
    var _this = this;

    this.CurrentTasksRequestId = webix.uid();

    if(Params&&Params.page >= 0)
    {
        this.FullStatusFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.FullStatusFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.FullStatusFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.FullStatusFilter.sort.order_by = Params.sort.id;
        this.FullStatusFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.FullStatusFilter.total.page,
        size:this.FullStatusFilter.total.size,

        order_by:this.FullStatusFilter.sort.order_by,
        order_dir:this.FullStatusFilter.sort.order_dir
    };

    Object.keys(this.FullStatusFilter.filter).forEach(function (Key)
    {
        if(_this.FullStatusFilter.filter[Key])
            filterParams[Key] = _this.FullStatusFilter.filter[Key];
    });

    if(Params && Params.profile_ids)
    {
        filterParams.profile_ids = Params.profile_ids;
    }

    filterParams.hardware_id = App.SessionManager.GetCurrentHardwareId();
    var params =
        {
            id:this.CurrentTasksRequestId,
            method:"GetCgNatFullStatus",
            data:{
                Params: filterParams
            },
            callback:function (R)
            {
                if(R.success)
                {
                    _this.FullStatus = [];
                    _this.FullStatusFilter.total.page = 0;
                    _this.FullStatusFilter.total.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function (Status)
                        {
                            _this.FullStatus.push(new CgNatFullStatusModel(Status));
                        });

                        _this.FullStatusFilter.total.page = parseInt(R.data.page,10);
                        _this.FullStatusFilter.total.count = parseInt(R.data.count,10);
                    }

                    _this.FullStatusUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };
    App.ServerManager.CallMethod(params);
};

CgNatStatusManager.prototype.GetFullStatus = function()
{
    return this.FullStatus;
};

CgNatStatusManager.prototype.RefreshSubscribersStatus = function(Params)
{
    var _this = this;

    this.CurrentTasksRequestId = webix.uid();

    if(Params&&Params.page >= 0)
    {
        this.SubscribersStatusFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.SubscribersStatusFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.SubscribersStatusFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.SubscribersStatusFilter.sort.order_by = Params.sort.id;
        this.SubscribersStatusFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.SubscribersStatusFilter.total.page,
        size:this.SubscribersStatusFilter.total.size,

        order_by:this.SubscribersStatusFilter.sort.order_by,
        order_dir:this.SubscribersStatusFilter.sort.order_dir
    };

    Object.keys(this.SubscribersStatusFilter.filter).forEach(function (Key)
    {
        if(_this.SubscribersStatusFilter.filter[Key])
            filterParams[Key] = _this.SubscribersStatusFilter.filter[Key];
    });

    if(Params && Params.profile_ids)
    {
        filterParams.profile_ids = Params.profile_ids;
    }

    filterParams.hardware_id = App.SessionManager.GetCurrentHardwareId();
    var params =
        {
            id:this.CurrentTasksRequestId,
            method:"GetCgNatSubscribersStatus",
            data:{
                Params: filterParams
            },
            callback:function (R)
            {
                if(R.success)
                {
                    _this.SubscribersStatus = [];
                    _this.SubscribersStatusFilter.total.page = 0;
                    _this.SubscribersStatusFilter.total.count = 0;

                    if(R.data)
                    {
                        R.data.rows.forEach(function (Status)
                        {
                            _this.SubscribersStatus.push(new CgNatSubscriberStatusModel(Status));
                        });

                        _this.SubscribersStatusFilter.total.page = parseInt(R.data.page,10);
                        _this.SubscribersStatusFilter.total.count = parseInt(R.data.count,10);
                    }

                    _this.SubscribersStatusUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };
    App.ServerManager.CallMethod(params);
};

CgNatStatusManager.prototype.GetSubscribersStatus = function()
{
    return this.SubscribersStatus;
};
var WifiSettingsStatus = {
    disabled: 0,
    enabled: 1
};

function WifiSettingsModel(Params)
{
    var _this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
    this.wifi_hardware_id = Params&&Params.wifi_hardware_id?Params.wifi_hardware_id:'';
    this.dhcp_hardware_id = Params&&Params.dhcp_hardware_id?Params.dhcp_hardware_id:0;
    this.cp_url = Params&&Params.cp_url?Params.cp_url:'';
    this.session_livetime = Params&&Params.session_livetime?parseInt(Params.session_livetime):3600;

    this.sms_enabled = Params&& Params.hasOwnProperty('sms_enabled')?parseInt(Params.sms_enabled):WifiSettingsStatus.enabled;
    this.sms_params = Params&&Params.sms_params?Params.sms_params:'';

    this.call_enabled = Params&&Params.hasOwnProperty('call_enabled')?parseInt(Params.call_enabled):WifiSettingsStatus.enabled;
    this.call_params = Params&&Params.call_params?Params.call_params:'';
    this.services = Params && Params.services ? Params.services: '';

    this.auth_policing = Params&&Params.auth_policing?Params.auth_policing:'';
    this.wifi_policing = Params&&Params.wifi_policing?Params.wifi_policing:'';
    this.payed_wifi_policing = Params&&Params.payed_wifi_policing?Params.payed_wifi_policing:'';

    this.logo = Params&&Params.logo?Params.logo:'';
    this.icon = Params&&Params.icon?Params.icon:'';
    this.loading_gif = Params&&Params.loading_gif?Params.loading_gif:'';

    this.base_lang_code = Params&&Params.base_lang_code?Params.base_lang_code:'';
    this.langs = Params&&Params.langs?Params.langs:'';
    this.redirect_url = Params&&Params.redirect_url?Params.redirect_url:'';

    this.wifi_auth_enabled = Params&&Params.hasOwnProperty('wifi_auth_enabled')?parseInt(Params.wifi_auth_enabled):0;
    this.click_wrap_enabled = Params&&Params.hasOwnProperty('click_wrap_enabled')?parseInt(Params.click_wrap_enabled):0;
    this.debug_mode = Params&&Params.hasOwnProperty('debug_mode')?parseInt(Params.debug_mode):0;
    this.sequential_authorization = Params&&Params.hasOwnProperty('sequential_authorization')?parseInt(Params.sequential_authorization):0;

    // TODO: New settings
    this.session_management_enabled = Params && Params.hasOwnProperty('session_management_enabled') ? parseInt(Params.session_management_enabled) : 1;
    this.session_init_params = Params && Params.session_init_params ? Params.session_init_params:'';
    this.auth_type = Params && Params.auth_type ? Params.auth_type : WifiAuthorizationType.code.id;
    this.outgoing_call_params = Params && Params.outgoing_call_params ? Params.outgoing_call_params:'';
    this.outgoing_call_phones = Params && Params.outgoing_call_phones ? Params.outgoing_call_phones:'';
    this.hash_key = Params && Params.hash_key ? Params.hash_key:'';

    this.delete_phone_lead_7_8 = Params && Params.delete_phone_lead_7_8 ? parseInt(Params.delete_phone_lead_7_8) : 0;

    this.valid = true;
};

function LangModel(Params)
{
    var _this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.code = Params && Params.code ? Params.code : "";
    this.name = Params && Params.name ? Params.name : "";
    this.icon = Params && Params.icon ? Params.icon : "";
    this.vals = Params && Params.vals ? Params.vals : [];

    for(var i in this.vals)
    {
        this.vals[i] = new TranslateModel(this.vals[i]);
    }

    this.valid = true;
}


function TranslateModel(Params)
{
    var _this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.str_key = Params && Params.str_key ? Params.str_key : "";
    this.value = Params && Params.value ? Params.value : "";

    this.valid = true;
}

function WifiSettingsManager(Params)
{
    var _this = this;

    this.Settings = new WifiSettingsModel();

    this.SignalSettingUpdated = new Rx.BehaviorSubject(0);

    this.CurrentRequestId = 0;
}

WifiSettingsManager.prototype.RefreshSettings = function(Params)
{
    var _this = this;

    var params =
        {
            id:webix.uid(),
            method:"GetWifiSettings",
            data:{
                HardwareId: parseInt(App.SessionManager.GetCurrentHardwareId())
            },
            callback:function (R)
            {
                if(R.success)
                {
                    if(R.data)
                    {
                        _this.Settings = new WifiSettingsModel(R.data);
                        _this.SignalSettingUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

WifiSettingsManager.prototype.GetSettings = function(Params)
{
    return this.Settings;
};

WifiSettingsManager.prototype.SaveSettings = function(Params)
{
    var _this = this;

    var params =
        {
            id:webix.uid(),
            method:"SaveWifiSettings",
            data:{
                HardwareId: parseInt(App.SessionManager.GetCurrentHardwareId()),
                Model: Params && Params.model ? Params.model : null
            },
            callback:function (R)
            {
                // if(R.success)
                // {
                //     if(R.data)
                //     {
                //         _this.Settings = new WifiSettingsModel(R.data);
                //         _this.SignalSettingUpdated.next(1);
                //     }
                // }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

WifiSettingsManager.prototype.GetClickWrapLogTail = function(Params)
{
    var _this = this;

    var params =
        {
            id:webix.uid(),
            method:"GetWifiSettingsClickWrapLogTail",
            data:{
                HardwareId: Params && Params.hardware_id ? parseInt(Params.hardware_id) : 0
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

WifiSettingsManager.prototype.GetInterfaceLogTail = function(Params)
{
    var _this = this;

    var params =
        {
            id:webix.uid(),
            method:"GetWifiSettingsInterfaceLogTail",
            data:{
                HardwareId: Params && Params.hardware_id ? parseInt(Params.hardware_id) : 0
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

WifiSettingsManager.prototype.GetLangDefaultVals = function(LangCode)
{
    var dic = {
        en: [
            {
                str_key: "info_label",
                value: "To gain access to the Internet, log in using your phone number."
            },
            {
                str_key: "phone_label",
                value: "Phone number"
            },
            {
                str_key: "wrong_phone_number",
                value: "Wrong phone number"
            },
            {
                str_key: "wrong_email",
                value: "Wrong email"
            },
            {
                str_key: "get_code_button",
                value: "Get code via SMS"
            },
            {
                str_key: "call_button",
                value: "Enter"
            },
            {
                str_key: "make_call_button",
                value: "Make call"
            },
            {
                str_key: "call_text",
                value: "To access the network <span>call</span> from the phone number you specified <span>to number</span> <a></a>"
            },
            {
                str_key: "click_wrap_auth_checkbox",
                value: "I accept <a>terms of provision</a> of service"
            },
            {
                str_key: "non_residents_link",
                value: "<a href=\"https://vasexperts.ru\">for non-residents</a>"
            },
            {
                str_key: "call_additional_text",
                value: "The call is free"
            },
            {
                str_key: "sms_code_input_label",
                value: "Auth code"
            },
            {
                str_key: "wrong_code_text",
                value: "Wrong code"
            },
            {
                str_key: "auth_code_button",
                value: "Login"
            },
            {
                str_key: "resend_code_button",
                value: "Get another code"
            },
            {
                str_key: "back_button",
                value: "Back"
            },
            {
                str_key: "success_text_header",
                value: "Welcome"
            },
            {
                str_key: "success_text",
                value: "You have successfully logged in"
            },
            {
                str_key: "success_button_text",
                value: "Continue"
            },
            {
                str_key: "click_wrap_popup_close_button",
                value: "Close"
            },
            {
                str_key: "click_wrap_text",
                value: "Click wrap text. html avalable"
            },
            {
                str_key: "click_wrap_checkbox",
                value: "I accept terms of provision of service"
            },
            {
                str_key: "click_wrap_button",
                value: "Continue"
            },
            {
                str_key: "click_wrap_button_cancel",
                value: "Decline"
            },
            {
                str_key: "close_window_label",
                value: "Close the page?"
            }
        ],
        ru: [
            {
                str_key: "info_label",
                value: "Для получения доступ в интернет авторизуйтесь используя свой номер телефона."
            },
            {
                str_key: "phone_label",
                value: "Номер телфона"
            },
            {
                str_key: "wrong_phone_number",
                value: "Некорректный номер телефона"
            },
            {
                str_key: "wrong_email",
                value: "Некорректный email"
            },
            {
                str_key: "get_code_button",
                value: "Получить код через SMS"
            },
            {
                str_key: "call_button",
                value: "Войти"
            },
            {
                str_key: "make_call_button",
                value: "Позвонить"
            },
            {
                str_key: "call_text",
                value: "Для доступа к сети <span>позвоните</span> с указанного Вами номера телефона <span>на номер</span> <a></a>"
            },
            {
                str_key: "click_wrap_auth_checkbox",
                value: "Принимаю <a>условия предоставления</a> услуги"
            },
            {
                str_key: "non_residents_link",
                value: "<a href=\"https://vasexperts.ru\">for non-residents</a>"
            },
            {
                str_key: "call_additional_text",
                value: "Звонок бесплатный"
            },
            {
                str_key: "sms_code_input_label",
                value: "Код авторизации"
            },
            {
                str_key: "wrong_code_text",
                value: "Некорректный код"
            },
            {
                str_key: "auth_code_button",
                value: "Авторизоваться"
            },
            {
                str_key: "resend_code_button",
                value: "Получить другой код"
            },
            {
                str_key: "back_button",
                value: "Назад"
            },
            {
                str_key: "success_text_header",
                value: "Добро пожаловать"
            },
            {
                str_key: "success_text",
                value: "Вы успешно авторизовались"
            },
            {
                str_key: "success_button_text",
                value: "Продолжить"
            },
            {
                str_key: "click_wrap_popup_close_button",
                value: "Закрыть"
            },
            {
                str_key: "click_wrap_text",
                value: "Текст клик-оферты. Доступен html"
            },
            {
                str_key: "click_wrap_checkbox",
                value: "Принимаю условия предоставления услуги"
            },
            {
                str_key: "click_wrap_button",
                value: "Продолжить"
            },
            {
                str_key: "click_wrap_button_cancel",
                value: "Отказываюсь"
            },
            {
                str_key: "close_window_label",
                value: "Закрыть страницу?"
            }
        ]
    };


    return LangCode && dic[LangCode] ? dic[LangCode] : dic.en;
};

WifiSettingsManager.prototype.DeleteSettings = function(Params)
{
    var _this = this;

    var params =
        {
            id:webix.uid(),
            method:"DeleteWifiSettings",
            data:{
                HardwareId: parseInt(App.SessionManager.GetCurrentHardwareId())
            },
            callback:function (R)
            {
                if(R.success)
                {
                    _this.Settings = new WifiSettingsModel();
                    _this.SignalSettingUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
function UniReportsManager(Params)
{
    this.Active = true;

    this.Reports = {};
}

UniReportsManager.ReportFilterModel = function(Params)
{
    this.page = Params&&Params.page?Params.page:0;

    this.size = Params&&Params.size?Params.size:0;

    this.period = Params&&Params.period?Params.period:null;

    this.filter = Params&&Params.filter?Params.filter:null;

    this.sort = Params&&Params.sort?Params.sort:null;

    this.sphinx_search = Params&&Params.sphinx_search?Params.sphinx_search:null;
};

UniReportsManager.UniReportConfigModel = function(Params)
{
    this.id = Params&&Params.id?Params.id:null;

    this.config = Params&&Params.config?Params.config:null;

    this.data = Params&&Params.data?Params.data:null;

    this.error = Params&&Params.error?Params.error:null;

    this.signal = Params&&Params.signal?Params.signal:new Rx.BehaviorSubject(0);

    this.params = Params&&Params.params?new UniReportsManager.ReportFilterModel(Params.params):new UniReportsManager.ReportFilterModel();
};

UniReportsManager.prototype.Destroy = function ()
{
    this.Active = false;
};

UniReportsManager.prototype.RegisterReport = function (ReportConfig)
{
    var reportConfig = new UniReportsManager.UniReportConfigModel(ReportConfig);

    this.Reports[reportConfig.id] = reportConfig;
};

UniReportsManager.prototype.UnRegisterReport = function (ReportId)
{
    delete this.Reports[ReportId];
};

UniReportsManager.prototype.GetReportConfig = function (ReportId)
{
    return this.Reports[ReportId] ? this.Reports[ReportId] : null;
};


UniReportsManager.prototype.GetReportDataExportFileData = function(ReportId, Params, IsLocal)
{
    var _this = this;

    var reportConfig = this.Reports[ReportId];

    if(!reportConfig)
        return;

    var data = new UniReportsManager.ReportFilterModel(Params);

    var method = reportConfig.config.method ? (typeof reportConfig.config.method === "function" ? reportConfig.config.method() : reportConfig.config.method) : null;

    var model = reportConfig.config.model ? (typeof reportConfig.config.model === "function" ? new reportConfig.config.model() : reportConfig.config.model) : null;

    return;
    if(IsLocal)
    {
        // if(reportConfig.config.dataSource)
        // {
        //
        //     var data = reportConfig.config.dataSource({Params:data, Config:{model:model}});
        //
        //     if(data)
        //         reportConfig.data = data;
        //     else
        //         reportConfig.data = {};
        //
        //     reportConfig.signal.next(1);
        // }
    }
    else
    {
        var params =
            {
                method:method,
                data:{Params:data, Config:webix.extend(reportConfig.config, {model:model}, true)},
                callback:function (R)
                {
                    if(!_this.Active)
                    {
                        return;
                    }

                    if(R.success)
                    {
                        reportConfig.error = null;
                    }
                    else
                    {
                        reportConfig.error = R.error;
                        webix.message({type:"error", text:R.error.msg});
                    }

                    if(R.data)
                        reportConfig.data = R.data;
                    else
                        reportConfig.data = {};

                    reportConfig.signal.next(1);

                }
            };

        if(this.Active)
        {
            App.ServerManager.CallMethod(params);
        }
    }
};

UniReportsManager.prototype.RefreshReportData = function (ReportId, Params, IsLocal)
{
    var _this = this;

    var reportConfig = this.Reports[ReportId];

    if(!reportConfig)
        return;

    var data = new UniReportsManager.ReportFilterModel(Params);

    var method = reportConfig.config.method ? (typeof reportConfig.config.method === "function" ? reportConfig.config.method() : reportConfig.config.method) : null;

    var model = reportConfig.config.model ? (typeof reportConfig.config.model === "function" ? new reportConfig.config.model() : reportConfig.config.model) : null;

    if(IsLocal)
    {
        if(reportConfig.config.dataSource)
        {

            var data = reportConfig.config.dataSource({Params:data, Config:{model:model}});

            if(data)
                reportConfig.data = data;
            else
                reportConfig.data = {};

            reportConfig.signal.next(1);
        }
    }
    else
    {
        var params =
            {
                method:method,
                data:{Params:data, Config:webix.extend(reportConfig.config, {model:model}, true)},
                callback:function (R)
                {
                    if(!_this.Active)
                    {
                        return;
                    }

                    if(R.success)
                    {
                        reportConfig.error = null;
                    }
                    else
                    {
                        reportConfig.error = R.error;
                        webix.message({type:"error", text:R.error.msg});
                    }

                    if(R.data)
                        reportConfig.data = R.data;
                    else
                        reportConfig.data = {};

                    reportConfig.signal.next(1);

                }
            };

        if(this.Active)
        {
            App.ServerManager.CallMethod(params);
        }
    }
};

UniReportsManager.prototype.SetReportData = function (ReportId, Data)
{
    var reportConfig = this.Reports[ReportId];

    reportConfig.data = Data;

    reportConfig.signal.next(1);
};
var MiniFirewallProfileStatusEnum = {
    disabled: 0,
    enabled: 1
};

function MiniFirewallProfileModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.profile_id = Params&&Params.profile_id?Params.profile_id:0;
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:null;
    this.title = Params&&Params.title?Params.title:"";
    this.date = Params&&Params.date?Params.date:0;
    this.status = Params&&Params.status?parseInt(Params.status):MiniFirewallProfileStatusEnum.disabled;

    this.form_data = Params&&Params.form_data?Params.form_data:"";
    this.sync_marker = Params&&Params.sync_marker?Params.sync_marker:0;

    this.valid = true;
};

function MiniFirewallProfileFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"profile_id", order_dir:"desc"};
};

function MiniFirewallFormModel(Params)
{
    var __this = this;

    this.title = Params&&Params.title?Params.title:"";
    this.max_port = Params&&Params.max_port?parseInt(Params.max_port):0;
    this.port_holes = Params&&Params.port_holes?Params.port_holes:[];
    this.out_port = Params&&Params.out_port?Params.out_port:[];

    if(this.port_holes.length)
    {
        for(var i in this.port_holes)
        {
            this.port_holes[i] = parseInt(this.port_holes[i]);
        }
    }

    if(this.out_port.length)
    {
        for(var i in this.out_port)
        {
            this.out_port[i] = parseInt(this.out_port[i]);
        }
    }
    this.valid = true;
};

function MiniFirewallManager(Params)
{
    this.Active = true;

    this.Profiles = [];
    this.ProfilesFilter = new MiniFirewallProfileFilterModel();

    this.SignalProfilesUpdated = new Rx.BehaviorSubject(0);
    this.SignalProfileUpdated = new Rx.BehaviorSubject(0);

    this.CurrentProfileRequestId = 0;
};

MiniFirewallManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

MiniFirewallManager.prototype.RefreshProfiles = function(Params)
{
    var _this = this;

    var partial = Params&&Params.profiles_ids ? true : false;

    if(!partial)
        this.CurrentTasksRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.ProfilesFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.ProfilesFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.ProfilesFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.ProfilesFilter.sort.order_by = Params.sort.id;
        this.ProfilesFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.ProfilesFilter.total.page,
        size:this.ProfilesFilter.total.size,

        order_by:this.ProfilesFilter.sort.order_by,
        order_dir:this.ProfilesFilter.sort.order_dir
    };

    Object.keys(this.ProfilesFilter.filter).forEach(function (Key)
    {
        if(_this.ProfilesFilter.filter[Key])
            filterParams[Key] = _this.ProfilesFilter.filter[Key];
    });

    var _params = filterParams;
    _params.profiles_ids = partial?Params&&Params.profiles_ids:null;

    var hId = App.SessionManager.GetCurrentHardwareId();
    if(hId)
    {
        _params.hardware_id = parseInt(hId);
    }
    var params =
        {
            id:this.CurrentTasksRequestId,
            method:"GetMiniFirewallProfiles",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentTasksRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (Profile)
                            {
                                _this.SignalProfileUpdated.next(new MiniFirewallProfileModel(Profile));
                            });
                        }
                    }
                    else
                    {
                        _this.Profiles = [];
                        _this.ProfilesFilter.total.page = 0;
                        _this.ProfilesFilter.total.count = 0;

                        if(R.data)
                        {
                            R.data.rows.forEach(function (Profile)
                            {
                                _this.Profiles.push(new MiniFirewallProfileModel(Profile));
                            });

                            _this.ProfilesFilter.total.page = parseInt(R.data.page,10);
                            _this.ProfilesFilter.total.count = parseInt(R.data.count,10);
                        }

                        _this.SignalProfilesUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

MiniFirewallManager.prototype.GetProfiles = function()
{
    return this.Profiles;
};

MiniFirewallManager.prototype.SaveProfile = function(Params)
{
    var _this = this;

    var profile = new MiniFirewallProfileModel(Params&&Params.profile?Params.profile:null);
    var profile_form = new MiniFirewallFormModel(Params&&Params.profile_form?Params.profile_form:null);

    var params =
        {
            id: profile.id,
            method:"SaveMiniFirewallProfile",
            data: {
                Profile: profile,
                Form: profile_form
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

MiniFirewallManager.prototype.DeleteProfile = function(Params)
{
    var _this = this;

    var profile = new MiniFirewallProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"DeleteMiniFirewallProfile",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

MiniFirewallManager.prototype.RunProfile = function(Params)
{
    var _this = this;

    var profile = new MiniFirewallProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"RunMiniFirewallProfile",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

MiniFirewallManager.prototype.StopProfile = function(Params)
{
    var _this = this;

    var profile = new MiniFirewallProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"StopMiniFirewallProfile",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
var DDoSProtectionProfileStatusEnum =
{
    disabled: 0,
    enabled: 1
};

function DDoSProtectionProfileModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.profile_id = Params&&Params.profile_id?Params.profile_id:0;
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:null;
    this.title = Params&&Params.title?Params.title:"";
    this.date = Params&&Params.date?Params.date:0;
    this.status = Params&&Params.status?parseInt(Params.status):DDoSProtectionProfileStatusEnum.disabled;

    this.form_data = Params&&Params.form_data?Params.form_data:"";
    this.sync_marker = Params&&Params.sync_marker?Params.sync_marker:0;

    this.valid = true;
}

function DDoSProtectionFormModel(Params)
{
    var __this = this;

    this.title = Params&&Params.title?Params.title:"";

    this.syncf_protection = Params&&Params.syncf_protection?Params.syncf_protection:0;
    this.syncf_trace = Params&&Params.syncf_trace?Params.syncf_trace:0;
    this.syncf_threshold = Params&&Params.syncf_threshold?Params.syncf_threshold:50;
    this.syncf_check_tmout = Params&&Params.syncf_check_tmout?Params.syncf_check_tmout:100;
    this.syncf_tracking_packs_time = Params&&Params.syncf_tracking_packs_time?Params.syncf_tracking_packs_time:60;
    this.syncf_ports = Params&&Params.syncf_ports?Params.syncf_ports:80;
    this.syncf_unconfirmed_percent = Params&&Params.syncf_unconfirmed_percent?Params.syncf_unconfirmed_percent:5;

    this.ddos_check_server = Params&&Params.ddos_check_server?Params.ddos_check_server:"";
    this.ddos_security_key = Params&&Params.ddos_security_key?Params.ddos_security_key:"";
    this.ddos_trace = Params&&Params.ddos_trace?Params.ddos_trace:0;
    this.ddos_reqsec_threshold = Params&&Params.ddos_reqsec_threshold?Params.ddos_reqsec_threshold:"";
    this.ddos_reqsec_variation = Params&&Params.ddos_reqsec_variation?Params.ddos_reqsec_variation:5;
    this.ddos_pktsec_threshold = Params&&Params.ddos_pktsec_threshold?Params.ddos_pktsec_threshold:"";
    this.ddos_pktsec_variation = Params&&Params.ddos_pktsec_variation?Params.ddos_pktsec_variation:5;
}

function DDoSProtectionProfileFiltersModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"profile_id", order_dir:"desc"};
}

function DDoSProtectionManager(Params)
{
    this.Active = true;

    this.Profiles = [];
    this.ProfilesFilter = new DDoSProtectionProfileFiltersModel();

    this.SignalProfilesUpdated = new Rx.BehaviorSubject(0);
    this.SignalProfileUpdated = new Rx.BehaviorSubject(0);

    this.CurrentProfileRequestId = 0;
}

DDoSProtectionManager.prototype.RefreshProfiles = function(Params)
{
    var _this = this;

    var partial = Params&&Params.profiles_ids ? true : false;

    if(!partial)
        this.CurrentTasksRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.ProfilesFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.ProfilesFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.ProfilesFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.ProfilesFilter.sort.order_by = Params.sort.id;
        this.ProfilesFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.ProfilesFilter.total.page,
        size:this.ProfilesFilter.total.size,

        order_by:this.ProfilesFilter.sort.order_by,
        order_dir:this.ProfilesFilter.sort.order_dir
    };

    Object.keys(this.ProfilesFilter.filter).forEach(function (Key)
    {
        if(_this.ProfilesFilter.filter[Key])
            filterParams[Key] = _this.ProfilesFilter.filter[Key];
    });

    var _params = filterParams;
    _params.profiles_ids = partial?Params&&Params.profiles_ids:null;

    var hId = App.SessionManager.GetCurrentHardwareId();
    if(hId)
    {
        _params.hardware_id = parseInt(hId);
    }
    var params =
        {
            id:this.CurrentTasksRequestId,
            method:"GetDdosProtectionProfiles",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentTasksRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (Profile)
                            {
                                _this.SignalProfileUpdated.next(new DDoSProtectionProfileModel(Profile));
                            });
                        }
                    }
                    else
                    {
                        _this.Profiles = [];
                        _this.ProfilesFilter.total.page = 0;
                        _this.ProfilesFilter.total.count = 0;

                        if(R.data)
                        {
                            R.data.rows.forEach(function (Profile)
                            {
                                _this.Profiles.push(new DDoSProtectionProfileModel(Profile));
                            });

                            _this.ProfilesFilter.total.page = parseInt(R.data.page,10);
                            _this.ProfilesFilter.total.count = parseInt(R.data.count,10);
                        }

                        _this.SignalProfilesUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

DDoSProtectionManager.prototype.GetProfiles = function()
{
    return this.Profiles;
};

DDoSProtectionManager.prototype.SaveProfile = function(Params)
{
    var _this = this;

    var profile = new DDoSProtectionProfileModel(Params&&Params.profile?Params.profile:null);
    var profile_form = new DDoSProtectionFormModel(Params&&Params.profile_form?Params.profile_form:null);

    var params =
        {
            id: profile.id,
            method:"SaveDdosProtectionProfile",
            data: {
                Profile: profile,
                Form: profile_form
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

DDoSProtectionManager.prototype.DeleteProfile = function(Params)
{
    var _this = this;

    var profile = new DDoSProtectionProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"DeleteDdosProtectionProfile",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

DDoSProtectionManager.prototype.RunProfile = function(Params)
{
    var _this = this;

    var profile = new DDoSProtectionProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"RunDdosProtectionProfile",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

DDoSProtectionManager.prototype.StopProfile = function(Params)
{
    var _this = this;

    var profile = new DDoSProtectionProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"StopDdosProtectionProfile",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

DDoSProtectionManager.prototype.GetCaptchaIp = function(Params)
{
    var _this = this;

    var params =
        {
            method:"GetCaptchaHardwareIp",
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
DDoSProtectionManager.prototype.GetCaptchaSecurityKey = function(Params)
{
    var _this = this;

    var params =
        {
            method:"GetCaptchaEnvConfig",
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
DDoSProtectionManager.prototype.GetCaptchaHardwareIpAndSecurityKey = function(Params)
{
    var _this = this;

    var params =
        {
            method:"GetCaptchaHardwareIpAndSecurityKey",
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
var SessionPolicingsProfileStatusEnum =
    {
        disabled: 0,
        enabled: 1
    };

function SessiongPolicingsProfileModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.profile_id = Params&&Params.profile_id?Params.profile_id:0;
    this.parent_id = Params&&Params.parent_id?Params.parent_id:0;
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:null;
    this.title = Params&&Params.title?Params.title:"";
    this.date = Params&&Params.date?Params.date:0;
    this.status = Params&&Params.status?parseInt(Params.status):DDoSProtectionProfileStatusEnum.disabled;

    this.form_data = Params&&Params.form_data?Params.form_data:"";
    this.sync_marker = Params&&Params.sync_marker?Params.sync_marker:0;
    this.sync_last_date = Params&&Params.sync_last_date?Params.sync_last_date:"";
    this.sync_time_enabled = Params&&Params.sync_time_enabled?Params.sync_time_enabled:0;
    this.sync_time_hours = Params&&Params.sync_time_hours?Params.sync_time_hours:0;

    this.valid = true;
}

function SessiongPolicingsProtocolModel(Params, IsForm = false)
{
    if(!IsForm)
    {
        this.id = Params&&Params.id?Params.id:webix.uid();

        this.protocol_id = Params&&Params.protocol_id?Params.protocol_id:0;
        this.title = Params&&Params.title?Params.title:"";
        this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:0;
    }

    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.type = Params&&Params.type?Params.type:"";
    this.value = Params&&Params.value ? Params.value : "";

    this.priority = Params&&Params.priority?Params.priority:"";

    this.inbound = Params&&Params.inbound?Params.inbound:0;
    this.inbound_unit = Params&&Params.inbound_unit ? Params.inbound_unit : "mbit";

    this.outbound = Params&&Params.outbound?Params.outbound:0;
    this.outbound_unit = Params&&Params.outbound_unit ? Params.outbound_unit : "mbit";

    this.burst_inbound = Params&&Params.burst_inbound?Params.burst_inbound:0;
    this.burst_inbound_unit = Params&&Params.burst_inbound_unit ? Params.burst_inbound_unit : "mbit";

    this.burst_outbound = Params&&Params.burst_outbound?Params.burst_outbound:0;
    this.burst_outbound_unit = Params&&Params.burst_outbound_unit ? Params.burst_outbound_unit : "mbit";

    this.sync_marker = Params&&Params.sync_marker ? Params.sync_marker : 0;
}

function SessionPolicingsFormModel(Params)
{
    var __this = this;

    this.title = Params&&Params.title?Params.title:"";
}

function SessionPolicingsProfileFiltersModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"title", order_dir:"desc"};
}

function SessionPolicingsManager(Params)
{
    this.Active = true;

    this.Profiles = [];
    this.ProfilesFilter = new SessionPolicingsProfileFiltersModel();

    this.SignalProfilesUpdated = new Rx.BehaviorSubject(0);
    this.SignalProfileUpdated = new Rx.BehaviorSubject(0);

    this.Protocols = [];
    this.ProtocolsFilter = new SessionPolicingsProfileFiltersModel();

    this.SignalProtocolsUpdated = new Rx.BehaviorSubject(0);
    this.SignalProtocolUpdated = new Rx.BehaviorSubject(0);

    this.SignalSupportServiceValueUpdated = new Rx.BehaviorSubject(0);

    this.CurrentProtocolsRequestId = 0;

    this.CurrentProfileRequestId = 0;
}

SessionPolicingsManager.prototype.RefreshProfiles = function(Params)
{
    var _this = this;

    var partial = Params&&Params.profiles_ids ? true : false;

    if(!partial)
        this.CurrentProtocolsRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.ProfilesFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.ProfilesFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.ProfilesFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.ProfilesFilter.sort.order_by = Params.sort.id;
        this.ProfilesFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.ProfilesFilter.total.page,
        size:this.ProfilesFilter.total.size,

        order_by:this.ProfilesFilter.sort.order_by,
        order_dir:this.ProfilesFilter.sort.order_dir
    };

    Object.keys(this.ProfilesFilter.filter).forEach(function (Key)
    {
        if(_this.ProfilesFilter.filter[Key])
            filterParams[Key] = _this.ProfilesFilter.filter[Key];
    });

    var _params = filterParams;
    _params.profiles_ids = partial?Params&&Params.profiles_ids:null;

    var hId = App.SessionManager.GetCurrentHardwareId();
    if(hId)
    {
        _params.hardware_id = parseInt(hId);
    }
    var params =
        {
            id:this.CurrentProtocolsRequestId,
            method:"GetSessionPolicings",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentProtocolsRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (Profile)
                            {
                                _this.SignalProfileUpdated.next(new SessiongPolicingsProfileModel(Profile));
                            });
                        }
                    }
                    else
                    {
                        _this.Profiles = [];
                        _this.ProfilesFilter.total.page = 0;
                        _this.ProfilesFilter.total.count = 0;

                        if(R.data)
                        {
                            R.data.rows.forEach(function (Profile)
                            {
                                _this.Profiles.push(new SessiongPolicingsProfileModel(Profile));
                            });

                            _this.ProfilesFilter.total.page = parseInt(R.data.page,10);
                            _this.ProfilesFilter.total.count = parseInt(R.data.count,10);
                        }

                        _this.SignalProfilesUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

SessionPolicingsManager.prototype.GetProfiles = function()
{
    return this.Profiles;
};

SessionPolicingsManager.prototype.SaveProfile = function(Params)
{
    var _this = this;

    var profile = new SessiongPolicingsProfileModel(Params&&Params.profile?Params.profile:null);
    var profile_form = new SessionPolicingsFormModel(Params&&Params.profile_form?Params.profile_form:null);

    var params =
        {
            id: profile.id,
            method:"SaveSessionPolicing",
            data: {
                Profile: profile,
                Form: profile_form
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionPolicingsManager.prototype.DeleteProfile = function(Params)
{
    var _this = this;

    var profile = new SessiongPolicingsProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"DeleteSessionPolicing",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionPolicingsManager.prototype.RunProfile = function(Params)
{
    var _this = this;

    var profile = new SessiongPolicingsProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"RunSessionPolicing",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionPolicingsManager.prototype.StopProfile = function(Params)
{
    var _this = this;

    var profile = new SessiongPolicingsProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            id: profile.id,
            method:"StopSessionPolicing",
            data: {
                Profile: profile
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionPolicingsManager.prototype.RefreshProtocols = function(Params)
{
    var _this = this;

    var partial = Params&&Params.protocols_ids ? true : false;

    if(!partial)
        this.CurrentProtocolsRequestId = webix.uid();

    if(!_this.Active)
    {
        return;
    }

    if(Params&&Params.page >= 0)
    {
        this.ProtocolsFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.ProtocolsFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.ProtocolsFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.ProtocolsFilter.sort.order_by = Params.sort.id;
        this.ProtocolsFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.ProtocolsFilter.total.page,
        size:this.ProtocolsFilter.total.size,

        order_by:this.ProtocolsFilter.sort.order_by,
        order_dir:this.ProtocolsFilter.sort.order_dir
    };

    Object.keys(this.ProtocolsFilter.filter).forEach(function (Key)
    {
        if(_this.ProtocolsFilter.filter[Key])
            filterParams[Key] = _this.ProtocolsFilter.filter[Key];
    });

    var _params = filterParams;

    _params.title = Params&&Params.title ? Params.title : null;
    _params.hardware_id = App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            id:this.CurrentProtocolsRequestId,
            method:"GetSessionPolicingProtocols",
            data:{
                Params: _params
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(!partial && _this.CurrentProtocolsRequestId != R.id)
                {
                    return;
                }

                if(R.success)
                {
                    if(partial)
                    {
                        if(R.data)
                        {
                            R.data.rows.forEach(function (Protocol)
                            {
                                _this.SignalProtocolUpdated.next(new SessiongPolicingsProtocolModel(Protocol));
                            });
                        }
                    }
                    else
                    {
                        _this.Protocols = [];
                        _this.ProtocolsFilter.total.page = 0;
                        _this.ProtocolsFilter.total.count = 0;

                        if(R.data)
                        {
                            R.data.rows.forEach(function (Protocol)
                            {
                                _this.Protocols.push(new SessiongPolicingsProtocolModel(Protocol));
                            });

                            _this.ProtocolsFilter.total.page = parseInt(R.data.page,10);
                            _this.ProtocolsFilter.total.count = parseInt(R.data.count,10);
                        }

                        _this.SignalProtocolsUpdated.next(1);
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

SessionPolicingsManager.prototype.GetProtocols = function()
{
    return this.Protocols;
};

SessionPolicingsManager.prototype.SaveProtocol = function(Params)
{
    var _this = this;

    var protocol = new SessiongPolicingsProtocolModel(Params&&Params.protocol?Params.protocol:null);

    protocol.hardware_id = App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            id: protocol.id,
            method:"SaveSessionPolicingProtocol",
            data: {
                Protocol: protocol
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionPolicingsManager.prototype.DeleteProtocol = function(Params)
{
    var _this = this;

    var protocol_ids = Params&&Array.isArray(Params.protocol_ids)?Params.protocol_ids:[];
    var profile = new SessiongPolicingsProfileModel(Params&&Params.profile?Params.profile:null);

    var params =
        {
            method:"DeleteSessionPolicingProtocols",
            data: {
                Profile: profile,
                ProtocolIds: protocol_ids
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

SessionPolicingsManager.prototype.GetSupportServiceValue = function()
{
    var _this = this;

    var hardwareId = App.SessionManager.GetCurrentHardwareId();

    var params =
    {
        method:"GetDpiConfigObjByConfigKeys",
        data:{HwId:parseInt(hardwareId,10), ConfigKeys:{support_service_18:1}},
        callback:function (R)
        {
            if(!_this.Active)
                return;

            if(R.success && R.data)
                _this.SignalSupportServiceValueUpdated.next(R.data);
        }
    }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

var SocketNotificationsTypeEnum = {
    info: "info",
    success: "success",
    warning: "warning",
    error: "error",
    other: "other"
};

var SocketNotificationsEventEnum = {
    news: "news",
    subscribers: "subscribers",
    messages: "messages",
    connection: "connection",
    triggers: "triggers",
    qoe_report: "qoe_report",
    qoe:"qoe"
};

function SocketNotificationModel(Params)
{
    var __this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.notify_id = Params&&Params.notify_id?Params.notify_id:0;
    this.room_id = Params&&Params.room_id?Params.room_id:null;
    this.status = Params&&Params.status?Params.status:"new";
    this.type = Params&&Params.type?Params.type:"info";
    this.lifetime = Params && Params.lifetime ? Params.lifetime : "-1";
    this.event = Params && Params.event ? Params.event : "news";
    this.notification_date = Params && Params.notification_date ? Params.notification_date : null;
    this.payload = new SocketNotificationPayloadModel(Params && Params.payload ? Params.payload : null);

    this.valid = true;
};

function SocketNotificationPayloadModel(Params)
{
    var __this = this;
    this.expire_time = Params && Params.expire_time ? Params.expire_time : 4000;
    this.data = Params && Params.data ? Params.data : {};
};

function SocketNotificationsFilterModel(Params)
{
    this.paging = Params&&Params.id?Params.paging:{size: 100, group: 5, count:0, page:0};
    this.total = Params&&Params.id?Params.total:{size: 100, group: 5, count:0, page:0};
    this.filter = Params&&Params.id?Params.filter:{};
    this.sort = Params&&Params.id?Params.filter:{order_by:"notify_id", order_dir:"desc"};
};

function SocketNotificationsManager(Params)
{
    "use strict";
    var _this = this;
    this.Active = true;

    this.Notifications = [];
    this.NotificationsFilter = new SocketNotificationsFilterModel();
    this.SignalNotificationsUpdated = new Rx.BehaviorSubject(0);

    this.SignalNotificationsCount = new Rx.BehaviorSubject(0);


}

SocketNotificationsManager.prototype.BindEvent = function()
{
    var _this = this;
    App.WebSocketManager.Connect('App');

    App.WebSocketManager.Connections['App'].on("connect", function(){
        _this.GetNotificationsCount();
    });

    App.WebSocketManager.Connections['App'].on(SocketNotificationsEventEnum.messages, function(Data){
        var data = JSON.parse(Data);

        _this.UnreadNotificationsHandler(data);
    });

}

SocketNotificationsManager.prototype.RefreshNotifications = function(Params)
{
    var _this = this;

    if(Params&&Params.page >= 0)
    {
        this.NotificationsFilter.total.page = parseInt(Params.page,10);
    }

    if(Params&&Params.size&&Params.size >= 0)
    {
        this.NotificationsFilter.total.size = parseInt(Params.size,10);
    }

    if(Params&&Params.filter)
    {
        this.NotificationsFilter.filter = Params.filter;
    }

    if(Params&&Params.sort)
    {
        this.NotificationsFilter.sort.order_by = Params.sort.id;
        this.NotificationsFilter.sort.order_dir = Params.sort.dir;
    }

    var filterParams = {
        page:this.NotificationsFilter.total.page,
        size:this.NotificationsFilter.total.size,

        order_by:this.NotificationsFilter.sort.order_by,
        order_dir:this.NotificationsFilter.sort.order_dir
    };

    Object.keys(this.NotificationsFilter.filter).forEach(function (Key)
    {
        if(_this.NotificationsFilter.filter[Key])
            filterParams[Key] = _this.NotificationsFilter.filter[Key];
    });

    var params =
        {
            id:webix.uid(),
            method:"GetSocketNotifications",
            data:{
                Params: filterParams
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                _this.Notifications = [];
                _this.NotificationsFilter.total.page = 0;
                _this.NotificationsFilter.total.count = 0;

                if(R.data)
                {
                    R.data.rows.forEach(function (Model)
                    {
                        _this.Notifications.push(new SocketNotificationModel(Model));
                    });

                    _this.NotificationsFilter.total.page = parseInt(R.data.page,10);
                    _this.NotificationsFilter.total.count = parseInt(R.data.count,10);
                }

                _this.SignalNotificationsUpdated.next(1);
                // if(!partial && _this.CurrentTasksRequestId != R.id)
                // {
                //     return;
                // }

                if(R.success)
                {

                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

SocketNotificationsManager.prototype.GetNotifications = function(Params)
{
    return webix.copy(this.Notifications);
};


SocketNotificationsManager.prototype.SetNotificationsReaded = function(Params)
{
    var _this = this;
    var params =
        {
            id:webix.uid(),
            method:"MarkSocketNotificationsAsRead",
            data:{
                Notifs: Params && Params.Notifs ? Params.Notifs : []
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

SocketNotificationsManager.prototype.ReadAllNotifications = function(Params)
{
    var _this = this;
    var params =
        {
            id:webix.uid(),
            method:"MarkAllSocketNotificationsAsRead",
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

SocketNotificationsManager.prototype.DeleteSelectedNotifications = function(Params)
{
    var _this = this;
    var params =
        {
            id:webix.uid(),
            method:"DeleteSocketNotifications",
            data:{
                Notifs: Params && Params.Notifs ? Params.Notifs : []
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

SocketNotificationsManager.prototype.DeleteAllNotifications = function(Params)
{
    var _this = this;
    var params =
        {
            id:webix.uid(),
            method:"DeleteAllSocketNotifications",
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

SocketNotificationsManager.prototype.GetNotificationsCount = function(Params)
{
    var _this = this;
    var params =
        {
            id:webix.uid(),
            method:"GetNumberOfSocketNotifications",
            callback:function (R)
            {
                _this.UnreadNotificationsHandler(R);
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

SocketNotificationsManager.prototype.UnreadNotificationsHandler = function(Data)
{
    if(Data.success)
    {
        this.SignalNotificationsCount.next(Data.data ? Data.data : 0);
    }
};
function WebSocketManager(Params)
{
    "use strict";
    this.Connections = {};
    this.ConnectionsUsers = {};

    this.Init(Params);

    return this;
}

WebSocketManager.prototype.Init = function(Params)
{
    "use strict";
    // this.Connect('App');
};

WebSocketManager.prototype.Connect = function(RoomId)
{
    var room = RoomId ? RoomId : null;

    if(room)
    {
        this.Connections[room] = io('/' + room);

        this.Connections[room].on("news", function(data){
            console.log(data);
        });
    }
};

WebSocketManager.prototype.Disconnect = function(RoomId)
{
    var room = RoomId  ? RoomId : null;

    if(room && this.Connections[room])
    {
        this.Connections[room].disconnect();
        delete this.Connections[room];
    }
};

WebSocketManager.prototype.ConnectAsUser = function(RoomId)
{
    var room = RoomId ? RoomId : null;

    if(room)
    {
        if(!this.Connections[room])
        {
            this.Connect(room);
        }

        if(!this.ConnectionsUsers.hasOwnProperty(room))
        {
            this.ConnectionsUsers[room] = 0;
        }

        this.ConnectionsUsers[room]++;
    }
};

WebSocketManager.prototype.DisconnectAsUser = function (RoomId)
{
    var room = RoomId  ? RoomId : null;
    if(room)
    {
        if(this.ConnectionsUsers[room])
        {
            this.ConnectionsUsers[room]--;
        }

        if(this.ConnectionsUsers[room] === 0)
        {
            this.Disconnect(room);
            delete this.ConnectionsUsers[room];
        }
    }
};

WebSocketManager.prototype.Destroy = function()
{
    for(var i in this.Connections)
    {
        this.Disconnect(i);
    }

    for(var i in this.ConnectionsUsers)
    {
        this.ConnectionsUsers[i] = 0;
    }
};
function BaseHardwareConfigModel(Params, KeyValArr, Dic)
{
    var _this = this;

    if(Dic)
    {
        Object.keys(Dic).forEach(function(Key)
        {
            var id = Dic[Key].id;

            var defaultVal = "";
            if(Dic[Key].gui && Dic[Key].gui.default)
            {
                defaultVal = Dic[Key].gui.default.use_conf_value && Dic[Key].default ? Dic[Key].default : (Dic[Key].gui.default.value ? Dic[Key].gui.default.value : "");
            }

            if(Params && Params[id])
            {

                _this[id] = Array.isArray(Params[id]) ? Params[id] : Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id])
            }
            else{
                _this[id] = defaultVal;
            }



            // _this[id] = ( Params && Params[id] ? Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]) : defaultVal );
        });
    }

    // Add params to model, wich not in dic
    Object.keys(Params).forEach(function(Key)
    {
        if(!_this[Key])
        {
            var id = Key;
            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
        }
    });
};

function BaseHardwareConfigManager(Params)
{
    var _this = this;

    window.Test = this;

    this.Active = true;

    this.ConfigFile = "";

    this.ConfigModel = null;

    this.Prefix = Params && Params.prefix ? Params.prefix : "";

    this.DicStr = this.Prefix + "Dic";
    this.GroupDicStr = this.Prefix + "GroupDic";

    this.Dic = null;
    this.GroupDic = null;

    this.ConfigType = Params && Params.dic ? Params.dic : "";

    this.History = [];

    this.Signals = {
        ConfigFileUpdated: new Rx.BehaviorSubject(0),
        SignalConfigHistoryUpdated: new Rx.BehaviorSubject(0),
        SignalDicsUpdated: new Rx.BehaviorSubject(0),
        ConfigRefreshed: new Rx.BehaviorSubject(0)
    };

    this.DontShowErrorCodesWhenUpdating = [0,503,2002,-403];
};

BaseHardwareConfigManager.prototype.InitDicsIfNeed = function()
{
    if(!window[this.DicStr] || !window[this.GroupDicStr])
        this.RefreshConfigDics();
    else{
        this.Dic = window[this.DicStr];

        this.GroupDic = window[this.GroupDicStr];

        this.Signals.SignalDicsUpdated.next(1);
    }
};

BaseHardwareConfigManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

BaseHardwareConfigManager.prototype.Refresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:_this.Prefix + "Get",
        data:{HardwareId:parseInt(this.GetCurrentHardwareId(),10)},
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                _this.ConfigFile = R.data;
            }
            else
            {
                _this.ConfigFile = "";
            }

            _this.ParseConfigToModel();
            _this.ParseModelToConfig();

            _this.Signals.ConfigFileUpdated.next(1);
            _this.Signals.ConfigRefreshed.next(R.success);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("Dics", "Configuration loaded."));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        _this.Signals.ConfigRefreshed.next(0);
        App.ServerManager.CallMethod(params);
    }
};

BaseHardwareConfigManager.prototype.GetConfig = function()
{
    return this.ConfigFile
};

BaseHardwareConfigManager.prototype.SetConfig = function(ConfigFile)
{
    this.ConfigFile = ConfigFile;

    this.ParseConfigToModel();

    this.Signals.ConfigFileUpdated.next(1);
};

BaseHardwareConfigManager.prototype.GetConfigModel = function()
{
    return this.ConfigModel ? this.ConfigModel : new BaseHardwareConfigModel({}, this.GetSortedConfigDicKeysArr(), this.Dic);
};

BaseHardwareConfigManager.prototype.SetConfigModel = function(ConfigModel)
{
    if(this.ConfigModel)
    {
        this.ConfigModel = new BaseHardwareConfigModel(webix.extend(this.ConfigModel, ConfigModel, true), this.GetSortedConfigDicKeysArr(), this.Dic);
    }
    else
    {
        this.ConfigModel = new BaseHardwareConfigModel(ConfigModel, this.GetSortedConfigDicKeysArr(), this.Dic);
    }

    this.ParseModelToConfig();

    this.Signals.ConfigFileUpdated.next(1);
};

BaseHardwareConfigManager.prototype.ParseConfigToModel = function()
{
    var _this = this;
    var config = this.GetConfig();

    var parser = new ConfigIniCustomParser();
    parser.parse(config);

    this.ConfigModel = new BaseHardwareConfigModel(parser.itemsKeyVal(), this.GetSortedConfigDicKeysArr(), this.Dic);
};

BaseHardwareConfigManager.prototype.ParseModelToConfig = function(ShowComments, ShowAllParams)
{
    var _this = this;

    var showComments = parseInt(App.SessionManager.GetPreference(this.Prefix + ":ShowComments")) ? true : false;

    var showAllParams = parseInt(App.SessionManager.GetPreference(this.Prefix + ":ShowAllParams")) ? true : false;

    var configModel = this.GetConfigModel();
    var parser = new ConfigIniCustomParser();

    var currentGroupId = 0;

    var processedIds = {};

    // var groupDic = this.GroupDic.default;
    //
    // if(groupDic && groupDic.data)
    // {
    //     Object.keys(groupDic).forEach(function(GroupdId){
    //
    //     });
    // }

    var locale = LangHelper.GetLocale();
    this.GetSortedConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = _this.Dic[Key].groups.default;
        // if(Array.isArray(groupId))
        // {
        //     groupId = groupId[0];
        // }
        var id = _this.Dic[Key].id;
        var comment = _this.Dic[Key].title[locale];
        var tooltip = _this.Dic[Key].description && _this.Dic[Key].description[locale] ? _this.Dic[Key].description[locale]:"";

        if(groupId !== currentGroupId)
        {
            currentGroupId = groupId;

            if(showComments && (configModel[id].length !== 0 || showAllParams))
            {
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, _this.GroupDic.default.subgroups[currentGroupId].title[locale]);
                if(_this.GroupDic.default.subgroups[currentGroupId].description[locale])
                {
                    parser.set("", webix.uid(), null, "\t");
                    var desc = _this.GroupDic.default.subgroups[currentGroupId].description[locale].split("<br/>");

                    desc.forEach(function(Val)
                    {
                        if(Val)
                        {
                            parser.set("", webix.uid(), null, Val);
                        }
                    })
                    // parser.set("", webix.uid(), null, _this.GroupDic.default.subgroups[currentGroupId].description[locale]);
                }
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, " ");
            }

        }

        if(showComments && (configModel[id].length !== 0 || showAllParams))
        {
            parser.set("", webix.uid(), null, comment);
        }


        if(tooltip&&tooltip!==comment)
        {
            if(showComments && (configModel[id].length !== 0 || showAllParams))
            {
                parser.set("", webix.uid(), null, "\t");
                var lines = tooltip.split("<br/>");
                lines.forEach(function(Val)
                {
                    if(Val)
                    {
                        parser.set("", webix.uid(), null, Val);
                    }
                })
                // parser.set("", webix.uid(), null, tooltip);
            }

        }

        if(configModel[id].length !== 0)
        {
            parser.set("", id, configModel[id]);
            parser.set("", webix.uid(), null, " ");
        }
        else
        {
            if(showAllParams)
            {
                parser.set("", webix.uid(), null, id+"="+configModel[id]);
                parser.set("", webix.uid(), null, " ");
            }
        }

        processedIds[id] = id;
    });

    // Add params to config, wich not in dic
    if(Object.keys(processedIds).length != Object.keys(configModel).length)
    {
        if(showComments)
        {
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, LangHelper.GetString("Dics", "Unknown parameters"));
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, " ");
        }

        Object.keys(configModel).forEach(function(Key)
        {
            if(!processedIds[Key])
            {
                var id = Key;

                if(configModel[id].length !== 0)
                {
                    parser.set("", id, configModel[id]);
                    parser.set("", webix.uid(), null, " ");
                }
                else if(showAllParams)
                {
                    parser.set("", webix.uid(), null, id+"="+configModel[id]);
                    parser.set("", webix.uid(), null, " ");
                }
            }
        });
    }

    this.ConfigFile = parser.stringify();
};

BaseHardwareConfigManager.prototype.Save = function(Params)
{
    var _this = this;
    var params =
        {
            method: _this.Prefix + "Save",
            data:{
                Config:Params&&Params.configContents?Params.configContents:_this.GetConfig(),
                HardwareId:parseInt(this.GetCurrentHardwareId(),10)
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

BaseHardwareConfigManager.prototype.Restart = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }
    //
    var params = {
        method: _this.Prefix + "Restart",
        data:{HardwareId:parseInt(this.GetCurrentHardwareId(),10)},
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString(_this.Prefix, "Service restarted successfully"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BaseHardwareConfigManager.prototype.Reload = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }
    //
    var params = {
        method: _this.Prefix + "Reload",
        data:{HardwareId:parseInt(this.GetCurrentHardwareId(),10)},
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString(_this.Prefix, "Service reloaded successfully"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BaseHardwareConfigManager.prototype.GetSortedConfigDicKeysArr = function()
{
    var _this = this;
    var groupsArr = this.GetSortedConfigGroupDicKeysArr();

    var arr = [];

    groupsArr.forEach(function (V)
    {
        Object.keys(_this.Dic).forEach(function (K)
        {
            // if(_this.Dic[K].group == V)
            // {
            //     arr.push(K);
            // }
            //
            var elem = _this.Dic[K];

            if(typeof elem.groups.default == "string")
            {
                if(elem.groups.default == V)
                {
                    arr.push(K);
                }
            }
            else if (Array.isArray(elem.groups.default))
            {
                elem.groups.default.forEach(function(Val){
                    if(Val == V)
                    {
                        arr.push(K);
                    }
                })
            }
        });
    });

    return arr;
};

BaseHardwareConfigManager.prototype.GetSortedConfigGroupDicKeysArr = function()
{
    var _this = this;

    var arr = [];

    this.GetSortedConfigGroupDicArr().forEach(function (V)
    {
        arr.push(V.id)
    });

    return arr;
};

BaseHardwareConfigManager.prototype.GetSortedConfigGroupDicArr = function()
{
    var _this = this;

    if(this.GroupDic)
    {
        var group = "default";

        var groupsArr = Helper.DictToArr(this.GroupDic[group] && this.GroupDic[group].subgroups ? this.GroupDic[group].subgroups : {});
        //
        // groupsArr.sort(function(a, b) {
        //     return a.order - b.order;
        // });

        return groupsArr;
    }
    return [];
};

BaseHardwareConfigManager.prototype.GetStoredConfigPropertiesByGroupId = function(Params)
{
    var _this = this;

    var arr = [];

    if(this.Dic)
    {
        if(Params && Params.id && Params.parent_id)
        {
            Object.keys(_this.Dic).forEach(function (K)
            {
                var elem = _this.Dic[K];
                if(typeof elem.groups[Params.parent_id] == "string")
                {
                    if(elem.groups[Params.parent_id] == Params.id)
                    {
                        arr.push(elem);
                    }
                }
                else if (Array.isArray(elem.groups[Params.parent_id]))
                {
                    elem.groups[Params.parent_id].forEach(function(Val){
                        if(Val == Params.id)
                        {
                            arr.push(elem);
                        }
                    })
                }

            });
        }
        else
        {
            Object.keys(_this.Dic).forEach(function(K){
                arr.push(_this.Dic[K]);
            });
        }
    }

    return arr;
};

BaseHardwareConfigManager.prototype.GetStoredConfigPropertiesByParamsOrder = function(Params)
{
    var _this = this;

    var arr = [];

    if(this.Dic)
    {
        if(Params && Params.params)
        {
            Params.params.forEach(function(K){
                if(_this.Dic[K])
                {
                    arr.push((_this.Dic[K]));
                }
            });
        }
        else
        {
            Object.keys(_this.Dic).forEach(function(K){
                arr.push(_this.Dic[K]);
            });
        }
    }

    return arr;
};

BaseHardwareConfigManager.prototype.GetStoredConfigPropertiesBySearchString = function(String)
{
  var _this = this;

  var arr = [];

  if(String)
  {
      var str = String.toLowerCase();
      var locale = LangHelper.GetLocale();
      Object.keys(_this.Dic).forEach(function(K){
          var elem = _this.Dic[K];

          if(elem.title && elem.title[locale] && elem.title[locale].toLowerCase().indexOf(str) !== -1)
          {
              arr.push(elem);
          }
          else if(elem.description && elem.description[locale] && elem.description[locale].toLowerCase().indexOf(str) !== -1)
          {
              arr.push(elem);
          }else if(elem.id && elem.id.toLowerCase().indexOf(str) !== -1)
          {
              arr.push(elem);
          }
      });
  }

  return arr;
};

BaseHardwareConfigManager.prototype.GetGroupDicAsDataForTreeTable = function()
{
    var _this = this;
    var dic = _this.GroupDic;
    var arr = [];
    var arr = [];
    if(dic)
    {
        var locale = LangHelper.GetLocale();
        Object.keys(dic).forEach(function(K){
            var parent = {
                id: dic[K].id,
                value: dic[K].title && dic[K].title[locale] ? dic[K].title[locale] : '',
                open: dic[K].gui && dic[K].gui.open,
                wiki: dic[K].wiki && dic[K].wiki[locale] ? dic[K].wiki[locale] : '',
                data: []
            };
            if(dic[K].subgroups)
            {
                Object.keys(dic[K].subgroups).forEach(function(I){
                    var child = {
                        id: dic[K].subgroups[I].id,
                        value: dic[K].subgroups[I].title && dic[K].subgroups[I].title[locale] ? dic[K].subgroups[I].title[locale] : '',
                        parent_id: dic[K].id,
                        wiki: dic[K].subgroups[I].wiki && dic[K].subgroups[I].wiki[locale] ? dic[K].subgroups[I].wiki[locale] : '',
                        params: dic[K].subgroups[I].params,

                    };

                    if(dic[K].subgroups[I].gui)
                    {
                        child.info = dic[K].subgroups[I].gui.use_description && dic[K].subgroups[I].description[locale] ? dic[K].subgroups[I].description[locale] : '';
                        child.infoHeight = dic[K].subgroups[I].gui.height;
                        child.show_info = dic[K].subgroups[I].gui.show;
                        child.custom_controls = dic[K].subgroups[I].gui.custom_controls ? dic[K].subgroups[I].gui.custom_controls : null;
                    }
                    parent.data.push(child);
                });
            }

            arr.push(parent);
        });
    }


    return arr;
};

BaseHardwareConfigManager.prototype.HistoryRefresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"Get" + this.Prefix + "History",
            data:{Id:parseInt(this.GetCurrentHardwareId(),10)},
            callback:function (result)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(result.success && result.data)
                {
                    var data = [];

                    Object.keys(result.data).forEach(function (Key)
                    {
                        var obj = new HardwareConfigHistoryModel({file_id:result.data[Key]});

                        data.push(obj);
                    });

                    _this.History = data;
                    _this.Signals.SignalConfigHistoryUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("All", "History loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BaseHardwareConfigManager.prototype.GetHistory = function()
{
    if(this.History)
    {
        return this.History;
    }

    return [];
};

BaseHardwareConfigManager.prototype.LoadHistoryFile = function(Params)
{
    var params =
        {
            method:"Get" + this.Prefix + "File",
            data:{
                File:Params&&Params.configFile?Params.configFile:"",
                Id:parseInt(this.GetCurrentHardwareId(),10)
            },
            callback:function (result)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

BaseHardwareConfigManager.prototype.RefreshConfigDics = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method: "GetJSONConfigFromModels",
        data: {
            Type: this.ConfigType
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                var group = R.data.groups.content;
                group = Helper.ConcatObjects(group, R.data.groups_ui.content);

                var params = Helper.ConcatObjects(R.data.params.content, R.data.params_ui.content);

                window[_this.DicStr] = params;

                window[_this.GroupDicStr] = group;

                _this.Dic = window[_this.DicStr];

                _this.GroupDic = window[_this.GroupDicStr];
            }
            else
            {
                webix.message({type:"error", text:R.error.msg});

                webix.alert({
                    title: LangHelper.GetString("All", "Error"),
                    text: LangHelper.GetString("All", "The configuration model could not be loaded") + ".<br/>" + LangHelper.GetString("All", "Error") + ":<br/>" + R.error.msg,
                    type:"alert-error",
                    width:600
                });
            }


            _this.ParseConfigToModel();
            _this.ParseModelToConfig();

            _this.Signals.SignalDicsUpdated.next(1);
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BaseHardwareConfigManager.prototype.Validate = function(Params,HardwareId)
{
    "use strict";

    var _this = this;

    var hardwareId = this.GetCurrentHardwareId(HardwareId);

    var params =
        {
            method:_this.Prefix + "Validate",
            data:{
                HardwareId:parseInt(hardwareId,10),
                Config:Params&&Params.configContents?Params.configContents:_this.GetConfig(hardwareId)
            },
            callback:function (result)
            {
                if(result.success && result.data)
                {
                    if(result.data.indexOf("ERROR") >= 0 || result.data.indexOf("CRITICAL") >= 0)
                    {
                        result.success = false;
                        result.error.msg = result.data;
                    }
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("All", "Verified"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

BaseHardwareConfigManager.prototype.GetCurrentHardwareId = function (HardwareId)
{
    return HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();
};

function Dpiui2EnvConfigModel(Params)
{
    var _this = this;

    Dpiui2ConfigManager.GetSortedDpiui2EnvConfigDicKeysArr().forEach(function(Key)
    {
        var id = Dpiui2EnvConfigDic[Key].id;

        var defaultVal = Dpiui2EnvConfigDic[Key].default?Dpiui2EnvConfigDic[Key].default:"";

        _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):defaultVal);
    });

    // Add params to model, wich not in dic
    Object.keys(Params).forEach(function(Key)
    {
        if(!_this[Key])
        {
            var id = Key;
            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
        }
    });
}

function Dpiui2ConfigHistoryModel(Params)
{
    this.id = webix.uid();
    this.file_id = Params&&Params.file_id?Params.file_id:"";
    this.date = null;
    this.file_name = null;

    if(this.file_id)
    {
        var fileIdArr = this.file_id.split(".");
        var dateArr = fileIdArr.slice(0,5);

        var parser = webix.Date.strToDate("%Y.%m.%d.%H.%i.%s");
        this.date = parser(dateArr.join("."));

        this.file_name = fileIdArr[fileIdArr.length - 2] + "." + fileIdArr[fileIdArr.length - 1];
    }
}

function Dpiui2UpdateStatusModel(Params)
{
    this.current_version = Params&&Params.current_version?Params.current_version:null;
    this.new_version = Params&&Params.new_version?Params.new_version:null;
    this.has_new_version = Params&&Params.has_new_version?Params.has_new_version:0;
    this.date_of_install = Params&&Params.date_of_install?Params.date_of_install:null;
    this.update_last_check = Params&&Params.update_last_check?Params.update_last_check:null;
    this.autoupdate = Params&&Params.autoupdate?Params.autoupdate:0;

    this.is_runnig = Params&&Params.is_runnig?Params.is_runnig:0;
    this.is_runnig_before = Params&&Params.is_runnig_before?Params.is_runnig_before:0;

    this.undefined = Params&&Params.undefined?Params.undefined:0;


    this.service_unavailable = Params&&Params.service_unavailable?Params.service_unavailable:0;
    this.service_unavailable_count = Params&&Params.service_unavailable_count?Params.service_unavailable_count:0;
}

function Dpiui2ConfigManager(Params)
{
    this.Active = true;

    this.ConfigFile = "";

    this.ConfigModel = null;

    this.Signals = {
        ConfigFileUpdated: new Rx.BehaviorSubject(0),
        ConfigHistoryUpdated: new Rx.BehaviorSubject(0),
        UpdateStatusProcess: new Rx.BehaviorSubject(0),
        UpdateStatus: new Rx.BehaviorSubject(new Dpiui2UpdateStatusModel({undefined:1})),
        UpdateLogTail: new Rx.BehaviorSubject(null),
        CheckForUpdateLogTail: new Rx.BehaviorSubject(null)
    };

    this.History = {};

    this.DontShowErrorCodesWhenUpdating = [0,503,2002,-403];
}

Dpiui2ConfigManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

Dpiui2ConfigManager.prototype.Refresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"GetDpiui2EnvConfig",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                _this.ConfigFile = R.data;
            }
            else
            {
                _this.ConfigFile = "";
            }

            _this.ParseConfigToModel();
            _this.ParseModelToConfig();

            _this.Signals.ConfigFileUpdated.next(1);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("Dpiui2Config", "Configuration loaded."));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

Dpiui2ConfigManager.prototype.GetConfig = function()
{
    return this.ConfigFile
};

Dpiui2ConfigManager.prototype.SetConfig = function(ConfigFile)
{
    this.ConfigFile = ConfigFile;

    this.ParseConfigToModel();

    this.Signals.ConfigFileUpdated.next(1);
};

Dpiui2ConfigManager.prototype.GetConfigModel = function()
{
    return this.ConfigModel ? this.ConfigModel : new Dpiui2EnvConfigModel();
};

Dpiui2ConfigManager.prototype.SetConfigModel = function(ConfigModel)
{
    if(this.ConfigModel)
    {
        this.ConfigModel = webix.extend(this.ConfigModel, new Dpiui2EnvConfigModel(ConfigModel), true);
    }
    else
    {
        this.ConfigModel = new Dpiui2EnvConfigModel(ConfigModel);
    }

    this.ParseModelToConfig();

    this.Signals.ConfigFileUpdated.next(1);
};

Dpiui2ConfigManager.prototype.ParseConfigToModel = function()
{
    var config = this.GetConfig();

    var parser = new ConfigIniParser();
    parser.parse(config);

    this.ConfigModel = new Dpiui2EnvConfigModel(parser.itemsKeyVal());
};

Dpiui2ConfigManager.prototype.ParseModelToConfig = function(ShowComments, ShowAllParams)
{
    var _this = this;

    var showComments = parseInt(App.SessionManager.GetPreference("Dpiui2ConfigManager:ShowComments")) ? true : false;

    var showAllParams = parseInt(App.SessionManager.GetPreference("Dpiui2ConfigManager:ShowAllParams")) ? true : false;

    var configModel = this.GetConfigModel();
    var parser = new ConfigIniParser();

    var currentGroupId = 0;

    var processedIds = {};

    Dpiui2ConfigManager.GetSortedDpiui2EnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = Dpiui2EnvConfigDic[Key].group;
        var id = Dpiui2EnvConfigDic[Key].id;
        var comment = Dpiui2EnvConfigDic[Key].value;
        var tooltip = Dpiui2EnvConfigDic[Key].tooltip?Dpiui2EnvConfigDic[Key].tooltip:"";

        if(groupId !== currentGroupId)
        {
            currentGroupId = groupId;

            if(showComments && (configModel[id].length !== 0 || showAllParams))
            {
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, Dpiui2EnvConfigGroupDic[currentGroupId].value);
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, " ");
            }

        }

        if(showComments && (configModel[id].length !== 0 || showAllParams))
            parser.set("", webix.uid(), null, comment);

        if(tooltip&&tooltip!==comment)
        {
            if(showComments && (configModel[id].length !== 0 || showAllParams))
                parser.set("", webix.uid(), null, tooltip);
        }

        if(configModel[id].length !== 0)
        {
            parser.set("", id, configModel[id]);
            parser.set("", webix.uid(), null, " ");
        }
        else
        {
            if(showAllParams)
            {
                parser.set("", webix.uid(), null, id+"="+configModel[id]);
                parser.set("", webix.uid(), null, " ");
            }
        }

        processedIds[id] = id;
    });

    // Add params to config, wich not in dic
    if(Object.keys(processedIds).length != Object.keys(configModel).length)
    {
        if(showComments)
        {
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, LangHelper.GetString("Dics", "Unknown parameters"));
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, " ");
        }

        Object.keys(configModel).forEach(function(Key)
        {
            if(!processedIds[Key])
            {
                var id = Key;

                if(configModel[id].length !== 0)
                {
                    parser.set("", id, configModel[id]);
                }
                else
                {
                    parser.set("", webix.uid(), null, id+"="+configModel[id]);
                }

                parser.set("", webix.uid(), null, " ");
            }
        });
    }

    this.ConfigFile = parser.stringify();
};

Dpiui2ConfigManager.prototype.Save = function(Params)
{
    var _this = this;

    var params =
    {
        method:"SetDpiui2EnvConfig",
        data:{
            Config:Params&&Params.configContents?Params.configContents:_this.GetConfig()
        },
        callback:function (R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                }
                else
                {
                    webix.message({type:"error", text:result.error.msg});
                }
            }
        }
    };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

Dpiui2ConfigManager.prototype.RestartQueue = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"Dpiui2RestartQueue",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("Dpiui2Config", "Hot options updated!"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

Dpiui2ConfigManager.prototype.RestartWorkers = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"Dpiui2RestartWorkers",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("Dpiui2Config", "Queue restarted successfully"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

Dpiui2ConfigManager.prototype.HistoryRefresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"GetDpiui2ConfigHistory",
            callback:function (result)
            {

                if(!_this.Active)
                {
                    return;
                }

                if(result.success && result.data)
                {
                    var data = [];

                    Object.keys(result.data).forEach(function (Key)
                    {
                        var obj = new Dpiui2ConfigHistoryModel({file_id:result.data[Key]});

                        data.push(obj);
                    });

                    _this.History = data;
                    _this.Signals.ConfigHistoryUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("All", "History loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

Dpiui2ConfigManager.prototype.GetHistory = function(HardwareId)
{
    if(this.History)
    {
        return this.History;
    }

    return [];
};

Dpiui2ConfigManager.prototype.LoadHistoryFile = function(Params)
{
    var params =
        {
            method:"GetDpiui2ConfigFromHistory",
            data:{
                File:Params&&Params.configFile?Params.configFile:""
            },
            callback:function (result)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

Dpiui2ConfigManager.GetSortedDpiui2EnvConfigDicKeysArr = function()
{
    var groupsArr = Dpiui2ConfigManager.GetSortedDpiui2EnvConfigGroupDicKeysArr();

    var arr = [];

    groupsArr.forEach(function (V)
    {
        Object.keys(Dpiui2EnvConfigDic).forEach(function (K)
        {
            if(Dpiui2EnvConfigDic[K].group == V)
            {
                arr.push(K);
            }
        });
    });

    return arr;
};

Dpiui2ConfigManager.GetSortedDpiui2EnvConfigGroupDicKeysArr = function()
{
    var arr = [];

    Dpiui2ConfigManager.GetSortedDpiui2EnvConfigGroupDicArr().forEach(function (V)
    {
        arr.push(V.id)
    });

    return arr;
};

Dpiui2ConfigManager.GetSortedDpiui2EnvConfigGroupDicArr = function()
{
    var _groupsArr = Helper.DictToArr(Dpiui2EnvConfigGroupDic), groupsArr = [];

    _groupsArr.forEach(function (Item)
    {
        if(!Item.lic)
        {
            groupsArr.push(Item);
            return;
        }

        if(App.SessionManager.CheckLic(Item.lic, Item.lic_level))
            groupsArr.push(Item);
    });

    groupsArr.sort(function(a, b) {
        return a.order - b.order;
    });

    return groupsArr;
};


Dpiui2ConfigManager.prototype.RefreshUpdateFullStatus = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    _this.Signals.UpdateStatusProcess.next(1);

    var params = {
        method:"Dpiui2UpdateFullStatus",
        callback:function (R)
        {
            _this.Signals.UpdateStatusProcess.next(0);

            if(!_this.Active)
            {
                return;
            }

            var currentData = _this.Signals.UpdateStatus.getValue();

            var data = R.data ? R.data : null;

            var isRunnig = currentData ? currentData.is_runnig : 0;

            if(!R.success && _this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)
            {
                if(currentData.is_runnig)
                {
                    data = currentData;

                    data.service_unavailable = 1;
                    data.service_unavailable_count += 1;

                    if(data.service_unavailable_count >= 30)
                        data = null;
                }
            }

            if(data)
                data.is_runnig_before = isRunnig;

            _this.Signals.UpdateStatus.next(new Dpiui2UpdateStatusModel(data));

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(!R.success)
                {
                    if(!(data && data.is_runnig && (_this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)))
                        webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

Dpiui2ConfigManager.prototype.SetAutoupdateEnabled = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"Dpiui2SetAutoupdateEnabled",
        data:{
            Enabled: Params&&Params.enabled ? 1 : 0
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

Dpiui2ConfigManager.prototype.CheckForUpdates = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    _this.Signals.UpdateStatusProcess.next(1);

    var params = {
        method:"Dpiui2CheckForUpdates",
        callback:function (R)
        {
            _this.Signals.UpdateStatusProcess.next(0);

            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};


Dpiui2ConfigManager.prototype.StartUpdate = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"StartDpiui2Update",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};


Dpiui2ConfigManager.prototype.RefreshDpiui2UpdateLogTail = function (Params)
{
    var _this = this;

    var params =
        {
            method:"GetDpiui2UpdateLogTail",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                var text = R.success ? R.data : R.error.msg;

                var data = _this.Signals.UpdateStatus.getValue();

                if(!R.success && _this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)
                {
                    text = _this.Signals.UpdateLogTail.getValue();
                }

                _this.Signals.UpdateLogTail.next(text);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }

                if(!R.success)
                {
                    if(!(data.is_runnig && (_this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)))
                        webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};


Dpiui2ConfigManager.prototype.DownloadUpdateLog = function (Params)
{
    var _this = this;

    var params =
        {
            method:"DownloadDpiui2UpdateLog",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    App.ServerManager.RedirectToFileDownload(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

Dpiui2ConfigManager.prototype.RefreshDpiui2CheckForUpdateLogTail = function (Params)
{
    var _this = this;

    var params =
        {
            method:"GetDpiui2CheckForUpdateLogTail",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                var text = R.success ? R.data : R.error.msg ;

                var data = _this.Signals.UpdateStatus.getValue();

                if(!R.success && _this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)
                {
                    text = _this.Signals.CheckForUpdateLogTail.getValue();
                }

                _this.Signals.CheckForUpdateLogTail.next(text);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }

                if(!R.success)
                {
                    if(!(data.is_runnig && (_this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)))
                        webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};


Dpiui2ConfigManager.prototype.DownloadCheckForUpdateLog = function (Params)
{
    var _this = this;

    var params =
        {
            method:"DownloadDpiui2CheckForUpdateLog",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    App.ServerManager.RedirectToFileDownload(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

function QoEStorEnvConfigModel(Params)
{
    var _this = this;

    QoEStorConfigManager.GetSortedQoEStorEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = QoEStorEnvConfigDic[Key].group;

        var id = QoEStorEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            function ParseRecieversParams(ReceiverType)
            {
                var i = 0;

                while (Params[ReceiverType + "_PORT_TYPE[" + i + "]"])
                {
                    var model = new QoEStorIpfixReceiverConfigModel({RECEIVER_TYPE:ReceiverType}, i);

                    Object.keys(model).forEach(function (Key)
                    {
                        var id = Key;

                        _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
                    });

                    i++;
                }
            }

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW);
        }
        else if (groupId == "15")
        {
            {
                function ParseClusterParams(ClusterOptName)
                {
                    var i = 0;

                    while (Params[`${ClusterOptName}[${i}]`])
                    {
                        var model = new QoEStorClusterConfigModel({CH_SHARD_REPLICAS:ClusterOptName}, i);

                        Object.keys(model).forEach(function (Key)
                        {
                            var id = Key;

                            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
                        });

                        i++;
                    }
                }

                if(id == QoEStorClusterTypesEnum.CH_SHARD_REPLICAS + "[i]")
                    ParseRecieversParams(QoEStorClusterTypesEnum.CH_SHARD_REPLICAS);
            }
        }
        else
        {
            //var defaultVal = QoEStorEnvConfigDic[Key].default?QoEStorEnvConfigDic[Key].default:"";

            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
        }
    });

    // Add params to model, wich not in dic
    Object.keys(Params).forEach(function(Key)
    {

        if(!_this[Key])
        {
            var id = Key;
            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
        }
    });
}

function QoEStorUpdateStatusModel(Params)
{
    this.current_version = Params&&Params.current_version?Params.current_version:null;
    this.new_version = Params&&Params.new_version?Params.new_version:null;
    this.has_new_version = Params&&Params.has_new_version?Params.has_new_version:0;
    this.date_of_install = Params&&Params.date_of_install?Params.date_of_install:null;
    this.update_last_check = Params&&Params.update_last_check?Params.update_last_check:null;
    this.autoupdate = Params&&Params.autoupdate?Params.autoupdate:0;

    this.is_runnig = Params&&Params.is_runnig?Params.is_runnig:0;
    this.is_runnig_before = Params&&Params.is_runnig_before?Params.is_runnig_before:0;

    this.undefined = Params&&Params.undefined?Params.undefined:0;


    this.service_unavailable = Params&&Params.service_unavailable?Params.service_unavailable:0;
    this.service_unavailable_count = Params&&Params.service_unavailable_count?Params.service_unavailable_count:0;
}

function QoEStorConfigHistoryModel(Params)
{
    this.id = webix.uid();
    this.file_id = Params&&Params.file_id?Params.file_id:"";
    this.date = null;
    this.file_name = null;

    if(this.file_id)
    {
        var fileIdArr = this.file_id.split(".");
        var dateArr = fileIdArr.slice(0,5);

        var parser = webix.Date.strToDate("%Y.%m.%d.%H.%i.%s");
        this.date = parser(dateArr.join("."));

        this.file_name = fileIdArr[fileIdArr.length - 2] + "." + fileIdArr[fileIdArr.length - 1];
    }
}

var QoEStorClusterTypesEnum =
    {
        CH_SHARD_REPLICAS:"CH_SHARD_REPLICAS",
    };

var QoEStorIpfixReceiverTypesEnum =
{
    IPFIX_FULLFLOW:"IPFIX_FULLFLOW",
    IPFIX_CLICKSTREAM:"IPFIX_CLICKSTREAM",
    IPFIX_GTPFLOW:"IPFIX_GTPFLOW",
    IPFIX_NATFLOW:"IPFIX_NATFLOW",
    IPFIX_NATFLOW_NETSTREAM:"IPFIX_NATFLOW_NETSTREAM",
    IPFIX_DNSFLOW: "IPFIX_DNSFLOW",
    IPFIX_AAAFLOW: "IPFIX_AAAFLOW"
};

var QoEStorIpfixReceiverRotateDefaultsEnum = {};
QoEStorIpfixReceiverRotateDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW] = 10;
QoEStorIpfixReceiverRotateDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 12;
QoEStorIpfixReceiverRotateDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW] = 10;
QoEStorIpfixReceiverRotateDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW] = 10;
QoEStorIpfixReceiverRotateDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM] = 10;
QoEStorIpfixReceiverRotateDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW] = 10;
QoEStorIpfixReceiverRotateDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW] = 10;

var QoEStorIpfixReceiverRotateDelayDefaultsEnum = {};
QoEStorIpfixReceiverRotateDelayDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW] = 0;
QoEStorIpfixReceiverRotateDelayDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 400;
QoEStorIpfixReceiverRotateDelayDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW] = 0;
QoEStorIpfixReceiverRotateDelayDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW] = 0;
QoEStorIpfixReceiverRotateDelayDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM] = 0;
QoEStorIpfixReceiverRotateDelayDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW] = 0;
QoEStorIpfixReceiverRotateDelayDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW] = 0;

var QoEStorIpfixReceiverQueueSizeDefaultsEnum = {};
QoEStorIpfixReceiverQueueSizeDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW] = 10;
QoEStorIpfixReceiverQueueSizeDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 10;
QoEStorIpfixReceiverQueueSizeDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW] = 10;
QoEStorIpfixReceiverQueueSizeDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW] = 10;
QoEStorIpfixReceiverQueueSizeDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM] = 10;
QoEStorIpfixReceiverQueueSizeDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW] = 10;
QoEStorIpfixReceiverQueueSizeDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW] = 10;

var QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum = {};
QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW] = 0;
QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 0;
QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW] = 0;
QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW] = 0;
QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM] = 0;
QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW] = 0;
QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum[QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW] = 0;

function QoEStorIpfixReceiverConfigRowModel(Params)
{
    this.id = Params&&Params.id ? Params.id : webix.uid();

    this.RECEIVER_TYPE = Params&&Params.RECEIVER_TYPE?Params.RECEIVER_TYPE:QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW;
    this.PORT_TYPE = Params&&Params.PORT_TYPE?Params.PORT_TYPE:"tcp";

    this.PORT = Params&&Params.PORT?Params.PORT:0;
    this.ROTATE_MINUTES = Params&&Params.ROTATE_MINUTES?Params.ROTATE_MINUTES:QoEStorIpfixReceiverRotateDefaultsEnum[this.RECEIVER_TYPE];
    this.ROTATE_SECONDS = Params&&Params.ROTATE_SECONDS?Params.ROTATE_SECONDS:0;
    this.ROTATE_FLOWS = Params&&Params.ROTATE_FLOWS?Params.ROTATE_FLOWS:0;
    this.ROTATE_DELAY_SECONDS = Params&&Params.ROTATE_DELAY_SECONDS?Params.ROTATE_DELAY_SECONDS:QoEStorIpfixReceiverRotateDelayDefaultsEnum[this.RECEIVER_TYPE];
    this.FW_MAX_QUEUE_SIZE = Params&&Params.FW_MAX_QUEUE_SIZE?Params.FW_MAX_QUEUE_SIZE:QoEStorIpfixReceiverQueueSizeDefaultsEnum[this.RECEIVER_TYPE];

    this.DUMP_INSERT_PROCESSES = Params&&Params.DUMP_INSERT_PROCESSES?Params.DUMP_INSERT_PROCESSES:QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum[this.RECEIVER_TYPE];

    this.EXPORT = Params&&Params.EXPORT?Params.EXPORT:null;

    this.DPI_ID = Params&&Params.DPI_ID?Params.DPI_ID:-1;

    this.BALANCER = Params&&Params.BALANCER?Params.BALANCER:0;
    this.BALANCER_SUB = Params&&Params.BALANCER_SUB?Params.BALANCER_SUB:null;
    this.BALANCER_SUB_PROTO = Params&&Params.BALANCER_SUB_PROTO?Params.BALANCER_SUB_PROTO:"tcp";
    this.BALANCER_AUTO = Params&&Params.BALANCER_AUTO?Params.BALANCER_AUTO:0;

    this.BALANCER_TASKSET = Params&&Params.BALANCER_TASKSET?Params.BALANCER_TASKSET:null;
}

function QoEStorIpfixReceiverConfigModel(Params, Index)
{
    var type = Params&&Params.RECEIVER_TYPE?Params.RECEIVER_TYPE:QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW;

    this[type + "_PORT_TYPE[" + Index + "]"]  = Params&&Params.PORT_TYPE?Params.PORT_TYPE:"tcp";

    this[type + "_PORT[" + Index + "]"] = Params&&Params.PORT?Params.PORT:0;
    this[type + "_ROTATE_MINUTES[" + Index + "]"] = Params&&parseInt(Params.ROTATE_MINUTES)?Params.ROTATE_MINUTES:QoEStorIpfixReceiverRotateDefaultsEnum[type];
    this[type + "_ROTATE_SECONDS[" + Index + "]"] = Params&&parseInt(Params.ROTATE_SECONDS)?Params.ROTATE_SECONDS:0;
    this[type + "_ROTATE_FLOWS[" + Index + "]"] = Params&&parseInt(Params.ROTATE_FLOWS)?Params.ROTATE_FLOWS:0;
    this[type + "_ROTATE_DELAY_SECONDS[" + Index + "]"] = Params&&Params.ROTATE_DELAY_SECONDS?Params.ROTATE_DELAY_SECONDS:QoEStorIpfixReceiverRotateDelayDefaultsEnum[type];
    this[type + "_FW_MAX_QUEUE_SIZE[" + Index + "]"] = Params&&Params.FW_MAX_QUEUE_SIZE?Params.FW_MAX_QUEUE_SIZE:QoEStorIpfixReceiverQueueSizeDefaultsEnum[type];

    this[type + "_DUMP_INSERT_PROCESSES[" + Index + "]"] = Params&&Params.DUMP_INSERT_PROCESSES?Params.DUMP_INSERT_PROCESSES:QoEStorIpfixReceiverDumpInsertProcessesDefaultsEnum[type];

    this[type + "_EXPORT[" + Index + "]"] = Params&&Params.EXPORT?Params.EXPORT:null;

    this[type + "_DPI_ID[" + Index + "]"] = Params&&Params.DPI_ID?Params.DPI_ID:-1;


    this[type + "_BALANCER[" + Index + "]"] = Params&&Params.BALANCER?Params.BALANCER:0;
    this[type + "_BALANCER_SUB[" + Index + "]"] = Params&&Params.BALANCER_SUB?Params.BALANCER_SUB:null;
    this[type + "_BALANCER_SUB_PROTO[" + Index + "]"] = Params&&Params.BALANCER_SUB_PROTO?Params.BALANCER_SUB_PROTO:"tcp";
    this[type + "_BALANCER_AUTO[" + Index + "]"] = Params&&Params.BALANCER_AUTO?Params.BALANCER_AUTO:0;
    this[type + "_BALANCER_TASKSET[" + Index + "]"] = Params&&Params.BALANCER_TASKSET?Params.BALANCER_TASKSET:null;
}

function QoEStorClusterConfigRowModel(Params)
{
    this.id = Params&&Params.id ? Params.id : webix.uid();

    this.CH_SHARD_REPLICAS = Params&&Params.CH_SHARD_REPLICAS?Params.CH_SHARD_REPLICAS:null;
}

function QoEStorClusterConfigModel(Params, Index)
{
    this["CH_SHARD_REPLICAS[" + Index + "]"]  = Params&&Params.CH_SHARD_REPLICAS?Params.CH_SHARD_REPLICAS:null;
}

function QoEStorMergedConfig(ExistConfig, AddConfig)
{
    this.MergeActions = {
        add: "add",
        delete: "delete"
    };

    this.MergeActionsChars = {
        add: "+",
        delete: "-"
    };

    this.existConfig = ExistConfig.map(Item => new QoEStorIpfixReceiverConfigRowModel(Item));
    this.addConfig = AddConfig.map(Item => new QoEStorIpfixReceiverConfigRowModel(Item));

    [this.existConfig, this.addConfig].forEach(ConfigArr => {
        ConfigArr.forEach(Config => {
            delete Config.id;
        });
    });

    this._rawMergedConfig = null;

    this._mergedConfigText = null;
    this._mergedConfig = null;

    Object.defineProperty(this, "rawMergedConfig", {
        get: function() {
            if(!this._rawMergedConfig)
                this.DefineRawMergedConfig();
            return this._rawMergedConfig;
        },
        set: function(Val) {
            this._rawMergedConfig = Val;
        }
    });

    Object.defineProperty(this, "mergedConfigText", {
        get: function() {
            if(!this._mergedConfigText)
                this.DefineMergedConfigText();
            return this._mergedConfigText;
        },
        set: function(Val) {
            this._mergedConfigText = Val;
        }
    });

    Object.defineProperty(this, "mergedConfig", {
        get: function() {
            if(!this._mergedConfig)
                this.DefineMergedConfig();
            return this._mergedConfig;
        },
        set: function(Val) {
            this._mergedConfig = Val;
        }
    });
}

QoEStorMergedConfig.prototype.SortConfig = function(Arr)
{
    let stringIdxMap = {};

    Object.values(QoEStorIpfixReceiverTypesEnum).forEach((str, idx) => {
        stringIdxMap[str] = idx;
    });

    Arr.sort((a, b) => {
        return stringIdxMap[a.RECEIVER_TYPE] - stringIdxMap[b.RECEIVER_TYPE];
    });

    return Arr;
};

QoEStorMergedConfig.prototype.DefineRawMergedConfig = function()
{
    let _this = this;

    let isSpecPropsEqual = function(Obj1, Obj2)
    {
        let props = ["RECEIVER_TYPE", "PORT"];
        return props.every(Prop => Obj1[Prop] == Obj2[Prop]);
    }

    this._rawMergedConfig = Object.values(QoEStorIpfixReceiverTypesEnum).reduce((Data, Key) => {
        Data[Key] = [];
        return Data;
    }, {});

    let addData = webix.copy(this.addConfig);

    this.existConfig.forEach(ExitsConfig => {
        let objsToMerge = [ExitsConfig, null];

        let findIdx = addData.findIndex(AddConfig => isSpecPropsEqual(ExitsConfig, AddConfig));

        if(findIdx !== -1)
            objsToMerge[1] = addData.splice(findIdx, 1)[0];

        _this._rawMergedConfig[ExitsConfig.RECEIVER_TYPE].push(objsToMerge);
    });

    addData.forEach(AddConfig => {
        let objsToMerge = [null, AddConfig];
        _this._rawMergedConfig[AddConfig.RECEIVER_TYPE].push(objsToMerge);
    });
};

QoEStorMergedConfig.prototype.DefineMergedConfigText = function()
{
    let _this = this;

    let lines = [];

    let getLine = function(Idx, Key, Val, Type, MergeType = null)
    {
        let line = MergeType && _this.MergeActionsChars[MergeType] ? `${_this.MergeActionsChars[MergeType]} ` : "";

        line += `${Type}_${Key}[${Idx}]=${Val}`;

        return line;
    }

    let getLines = function(Idx, Obj, MergeType = null)
    {
        let lines = [];

        Object.keys(Obj).forEach(Key => {
            lines.push(getLine(Idx, Key, Obj[Key], Obj.RECEIVER_TYPE, MergeType));
        });

        lines.push("");

        return lines;
    }

    let getMergeLines = function(Idx, ObjsToMerge)
    {
        let lines = [];

        let keys = [];

        ObjsToMerge.forEach(Obj => {
            keys = keys.concat(Object.keys(Obj))
        });

        keys = new Set(keys);

        const [existConf, addConf] = ObjsToMerge;

        keys.forEach(Key => {
            if(Object.keys(existConf).includes(Key) && Object.keys(addConf).includes(Key))
            {
                if(existConf[Key] == addConf[Key])
                {
                    lines.push(getLine(Idx, Key, existConf[Key], existConf.RECEIVER_TYPE))
                }
                else
                {
                    lines.push(getLine(Idx, Key, existConf[Key], existConf.RECEIVER_TYPE, _this.MergeActions.delete));
                    lines.push(getLine(Idx, Key, addConf[Key], existConf.RECEIVER_TYPE, _this.MergeActions.add));
                }
            }
            else if(Object.keys(existConf).includes(Key) && !Object.keys(addConf).includes(Key))
            {
                lines.push(getLine(Idx, Key, existConf[Key], existConf.RECEIVER_TYPE))
            }
            else if(!Object.keys(existConf).includes(Key) && Object.keys(addConf).includes(Key))
            {
                lines.push(getLine(Idx, Key, addConf[Key], existConf.RECEIVER_TYPE, _this.MergeActions.add));
            }
        });

        lines.push("");

        return lines;
    }

    Object.values(QoEStorIpfixReceiverTypesEnum).forEach(Type => {
        _this.rawMergedConfig[Type].forEach((ObjsToMerge, Idx) => {
            if(ObjsToMerge[0] && ObjsToMerge[1])
            {
                lines = lines.concat(getMergeLines(Idx, ObjsToMerge))
            }
            else if(ObjsToMerge[0])
            {
                lines = lines.concat(getLines(Idx, ObjsToMerge[0]));
            }
            else if(ObjsToMerge[1])
            {
                lines = lines.concat(getLines(Idx, ObjsToMerge[1], _this.MergeActions.add));
            }
        });
    });

    this._mergedConfigText = lines.join("\n");
};

QoEStorMergedConfig.prototype.DefineMergedConfig = function()
{
    let _this = this;

    this._mergedConfig = [];

    Object.values(QoEStorIpfixReceiverTypesEnum).forEach(Type => {
        _this.rawMergedConfig[Type].forEach(ObjsToMerge => {
            let item = ObjsToMerge[1] ? ObjsToMerge[1] : ObjsToMerge[0];
            _this._mergedConfig.push(new QoEStorIpfixReceiverConfigRowModel(item));
        });
    });
};

function QoEStorConfigManager(Params)
{
    this.CurrentHwId = 0;

    this.Active = true;

    this.ConfigFile = "";

    this.ConfigModel = null;

    this.Signals = {
        ConfigFileUpdated: new Rx.BehaviorSubject(0),
        ConfigHistoryUpdated: new Rx.BehaviorSubject(0),
        UpdateStatusProcess: new Rx.BehaviorSubject(0),
        UpdateStatus: new Rx.BehaviorSubject(new QoEStorUpdateStatusModel({undefined:1})),
        UpdateLogTail: new Rx.BehaviorSubject(null),
        CheckForUpdateLogTail: new Rx.BehaviorSubject(null),

        RestartReceiversSuccess: new Rx.BehaviorSubject(0),
        RestartReceiversError: new Rx.BehaviorSubject(0),
        StopReceiversSuccess: new Rx.BehaviorSubject(0),
        StopReceiversError: new Rx.BehaviorSubject(0),

        ServerError: new Rx.BehaviorSubject(0)
    };

    this.History = {};

    this.DontShowErrorCodesWhenUpdating = [0,503,2002,-403];
}

QoEStorConfigManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

QoEStorConfigManager.prototype.SetHwId = function(HwId)
{
    this.CurrentHwId = parseInt(HwId);
};

QoEStorConfigManager.prototype.Refresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"GetQoEStorEnvConfig",
        data:{
            HwId:this.CurrentHwId
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                _this.ConfigFile = R.data;
            }
            else
            {
                _this.ConfigFile = "";
            }

            _this.ParseConfigToModel();
            _this.ParseModelToConfig();

            _this.Signals.ConfigFileUpdated.next(1);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    if(!Params.silent)
                    {
                        webix.message(LangHelper.GetString("QoEStorConfig", "Configuration loaded."));
                    }
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.prototype.GetConfig = function()
{
    return this.ConfigFile
};

QoEStorConfigManager.prototype.SetConfig = function(ConfigFile)
{
    this.ConfigFile = ConfigFile;

    this.ParseConfigToModel();

    this.Signals.ConfigFileUpdated.next(1);
};

QoEStorConfigManager.prototype.GetConfigModel = function()
{
    return this.ConfigModel ? this.ConfigModel : new QoEStorEnvConfigModel();
};

QoEStorConfigManager.prototype.RemoveReceiversParamsFromConfigModel = function()
{
    var _this = this;

    if(this.ConfigModel)
    {
        Object.keys(this.ConfigModel).forEach(function (Key) {
            if(
                Key.indexOf(QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW) >= 0 ||
                Key.indexOf(QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM) >= 0 ||
                Key.indexOf(QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW) >= 0 ||
                Key.indexOf(QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW) >= 0 ||
                Key.indexOf(QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM) >= 0 ||
                Key.indexOf(QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW) >= 0 ||
                Key.indexOf(QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW) >= 0
            )
                delete _this.ConfigModel[Key];
        });
    }
};

QoEStorConfigManager.prototype.RemoveClustersParamsFromConfigModel = function()
{
    var _this = this;

    if(this.ConfigModel)
    {
        Object.keys(this.ConfigModel).forEach(function (Key) {
            if(Key.indexOf(QoEStorClusterTypesEnum.CH_SHARD_REPLICAS) >= 0)
                delete _this.ConfigModel[Key];
        });
    }
};

QoEStorConfigManager.prototype.SetConfigModel = function(ConfigModel)
{
    if(this.ConfigModel)
    {
        this.RemoveReceiversParamsFromConfigModel();
        this.RemoveClustersParamsFromConfigModel()
        this.ConfigModel = webix.extend(this.ConfigModel, new QoEStorEnvConfigModel(ConfigModel), true);
    }
    else
    {
        this.ConfigModel = new QoEStorEnvConfigModel(ConfigModel);
    }

    this.ParseModelToConfig();

    this.Signals.ConfigFileUpdated.next(1);
};

QoEStorConfigManager.prototype.ParseConfigToModel = function(Config)
{
    var config = Config ? Config : this.GetConfig();

    var parser = new ConfigIniParser();

    parser.parse(config);

    if(Config)
        return new QoEStorEnvConfigModel(parser.itemsKeyVal());

    this.ConfigModel = new QoEStorEnvConfigModel(parser.itemsKeyVal());
};

QoEStorConfigManager.prototype.ParseModelToConfig = function(ShowComments, ShowAllParams, Model)
{
    var _this = this;

    var showComments = !Model && parseInt(App.SessionManager.GetPreference("QoEStorConfigManager:ShowComments")) ? true : false;

    var showAllParams = !Model && parseInt(App.SessionManager.GetPreference("QoEStorConfigManager:ShowAllParams")) ? true : false;

    var configModel = Model ? Model : this.GetConfigModel();

    var parser = new ConfigIniParser();

    var currentGroupId = 0;

    var processedIds = {};

    function ProcessDicParameter(Key, ConfigModelId, CustomParams)
    {
        if (CustomParams) {
            // Process params to config, wich not in dic
            var groupId = CustomParams.GroupId;
            var id = CustomParams.id;
            var comment = CustomParams.value;
            var tooltip = CustomParams.tooltip?CustomParams.tooltip:"";

        } else {
            // Process params to config, which in dic
            var groupId = QoEStorEnvConfigDic[Key].group;
            var id = ConfigModelId ? ConfigModelId : QoEStorEnvConfigDic[Key].id;
            var comment = QoEStorEnvConfigDic[Key].value;
            var tooltip = QoEStorEnvConfigDic[Key].tooltip?QoEStorEnvConfigDic[Key].tooltip:"";

        }

        if(groupId !== currentGroupId)
        {
            currentGroupId = groupId;

            if(showComments && ((configModel[id] && configModel[id].length !== 0) || showAllParams))
            {
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, QoEStorEnvConfigGroupDic[currentGroupId].value);
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, " ");
            }

        }

        if(showComments && ((configModel[id] && configModel[id].length !== 0) || showAllParams))
            parser.set("", webix.uid(), null, comment);

        if(tooltip&&tooltip!==comment)
        {
            if(showComments && ((configModel[id] && configModel[id].length !== 0) || showAllParams))
            {
                var tt = tooltip.split('<br/>');
                tt.forEach(function (Val)
                {
                    if(Val)
                        parser.set("", webix.uid(), null, Val);
                });
            }
        }

        if(configModel[id] && configModel[id].length !== 0)
        {
            parser.set("", id, configModel[id]);
            parser.set("", webix.uid(), null, " ");
        }
        else
        {
            if(showAllParams)
            {
                parser.set("", webix.uid(), null, id+"="+(configModel[id] ? configModel[id] : ""));
                parser.set("", webix.uid(), null, " ");
            }
        }

        processedIds[id] = id;
    }

    QoEStorConfigManager.GetSortedQoEStorEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = QoEStorEnvConfigDic[Key].group;
        var id = QoEStorEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            function ParseRecieversParams(ReceiverType)
            {
                var i = 0;

                var map = QoEStorConfigManager.QoEStorIpfixReceiverDicIdToParamIdMap(ReceiverType)

                while (configModel[ReceiverType + "_PORT_TYPE[" + i + "]"])
                {
                    var model = new QoEStorIpfixReceiverConfigModel({RECEIVER_TYPE:ReceiverType}, i);

                    Object.keys(map).forEach(function (Key)
                    {
                        ProcessDicParameter(Key, map[Key].replace("[i]", "[" + i + "]"));
                    });

                    i++;
                }

                if(!i)
                {
                    Object.keys(map).forEach(function (Key)
                    {
                        ProcessDicParameter(Key);
                    });
                }
            }

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW);

            if(id == QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW);
        }
        else if (groupId == "6" && id == "FULLFLOW_AGG_LOG_GROUP_TIME_INTERVAL")
        {
            ProcessDicParameter(Key);

            let customFields = QoEStorEnvConfigFullflowCompressLogSettings.reduce((acc, setting) => {
                acc[setting.id] = setting;
                return acc;
            }, {});

            Object.values(customFields).forEach(function (Item) {
                Item.GroupId = "6";
                ProcessDicParameter(Item.id, _, Item);
            })
        }
        else if(groupId == "15")
        {
            function ParseClustersParams(ClusterOptName)
            {
                var i = 0;

                var map = QoEStorConfigManager.QoEStorClustersDicIdToParamIdMap(ClusterOptName)

                while (configModel[`${ClusterOptName}[${i}]`])
                {
                    Object.keys(map).forEach(function (Key)
                    {
                        ProcessDicParameter(Key, map[Key].replace("[i]", "[" + i + "]"));
                    });

                    i++;
                }

                if(!i)
                {
                    Object.keys(map).forEach(function (Key)
                    {
                        ProcessDicParameter(Key);
                    });
                }
            }

            if(id == QoEStorClusterTypesEnum.CH_SHARD_REPLICAS + "[i]")
                ParseClustersParams(QoEStorClusterTypesEnum.CH_SHARD_REPLICAS);
        }
        else
        {
            ProcessDicParameter(Key);
        }
    });

    // Add params to config, wich not in dic
    if(Object.keys(processedIds).length != Object.keys(configModel).length)
    {
        if(showComments)
        {
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, LangHelper.GetString("Dics", "Unknown parameters"));
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, " ");
        }

        Object.keys(configModel).forEach(function(Key)
        {
            if(!processedIds[Key])
            {
                var id = Key;

                if(configModel[id].length !== 0)
                {
                    parser.set("", id, configModel[id]);
                }
                else
                {
                    parser.set("", webix.uid(), null, id+"="+configModel[id]);
                }

                parser.set("", webix.uid(), null, " ");
            }
        });
    }

    if(Model)
        return parser.stringify();

    this.ConfigFile = parser.stringify();
};

QoEStorConfigManager.prototype.Save = function(Params)
{
    var _this = this;

    var params =
    {
        method:"SetQoEStorEnvConfig",
        data:{
            Config:Params&&Params.configContents?Params.configContents:_this.GetConfig(),
            HwId:this.CurrentHwId
        },
        callback:function (R)
        {
            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                }
                else
                {
                    webix.message({type:"error", text:result.error.msg});
                }
            }
        }
    };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

QoEStorConfigManager.prototype.RestartConfig = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"QoEStorRestartConfig",
        data:{
            HwId:this.CurrentHwId
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("QoEStorConfig", "Queue restarted successfully"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.prototype.RestartOptions = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"QoEStorRestartOptions",
        data:{
            HwId:this.CurrentHwId
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.GetSortedQoEStorEnvConfigDicKeysArr = function()
{
    var groupsArr = QoEStorConfigManager.GetSortedQoEStorEnvConfigGroupDicKeysArr();

    var arr = [];

    groupsArr.forEach(function (V)
    {
        Object.keys(QoEStorEnvConfigDic).forEach(function (K)
        {
            if(QoEStorEnvConfigDic[K].group == V)
            {
                arr.push(K);
            }
        });
    });

    return arr;
};

QoEStorConfigManager.GetSortedQoEStorEnvConfigGroupDicKeysArr = function()
{
    var arr = [];

    QoEStorConfigManager.GetSortedQoEStorEnvConfigGroupDicArr().forEach(function (V)
    {
        arr.push(V.id)
    });

    return arr;
};

QoEStorConfigManager.GetSortedQoEStorEnvConfigGroupDicArr = function()
{
    var groupsArr = Helper.DictToArr(QoEStorEnvConfigGroupDic);

    groupsArr.sort(function(a, b) {
        return a.order - b.order;
    });

    return groupsArr;
};

QoEStorConfigManager.QoEStorClustersDicIdToParamIdMap = function(ClusterOptName)
{
    var map = {};

    QoEStorConfigManager.GetSortedQoEStorEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = QoEStorEnvConfigDic[Key].group;
        var id = QoEStorEnvConfigDic[Key].id;

        if(groupId == "15")
        {
            if(id.indexOf(ClusterOptName) >= 0)
                map[Key] = id;
        }
    });

    return map;
};

QoEStorConfigManager.QoEStorIpfixReceiverDicIdToParamIdMap = function(ReceiverType)
{
    var map = {};

    QoEStorConfigManager.GetSortedQoEStorEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = QoEStorEnvConfigDic[Key].group;
        var id = QoEStorEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            if(id.indexOf(ReceiverType) >= 0)
                map[Key] = id;
        }
    });

    return map;
};

QoEStorConfigManager.QoEStorIpfixReceiverParamIdToDicIdMap = function(ReceiverType)
{
    var map = {};

    QoEStorConfigManager.GetSortedQoEStorEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = QoEStorEnvConfigDic[Key].group;
        var id = QoEStorEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            if(id.indexOf(ReceiverType) >= 0)
                map[id] = Key;
        }
    });

    return map;
};


QoEStorConfigManager.prototype.RefreshUpdateFullStatus = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    _this.Signals.UpdateStatusProcess.next(1);

    var params = {
        method:"QoEStorUpdateFullStatus",
        callback:function (R)
        {
            _this.Signals.UpdateStatusProcess.next(0);

            if(!_this.Active)
            {
                return;
            }

            var currentData = _this.Signals.UpdateStatus.getValue();

            var data = R.data ? R.data : null;

            var isRunnig = currentData ? currentData.is_runnig : 0;

            if(!R.success && _this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)
            {
                if(currentData.is_runnig)
                {
                    data = currentData;

                    data.service_unavailable = 1;
                    data.service_unavailable_count += 1;

                    if(data.service_unavailable_count >= 30)
                        data = null;
                }
            }

            if(data)
                data.is_runnig_before = isRunnig;

            _this.Signals.UpdateStatus.next(new QoEStorUpdateStatusModel(data));

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(!R.success)
                {
                    if(!(data && data.is_runnig && (_this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)))
                        webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.prototype.SetAutoupdateEnabled = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"QoEStorSetAutoupdateEnabled",
        data:{
            Enabled: Params&&Params.enabled ? 1 : 0
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.prototype.CheckForUpdates = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    _this.Signals.UpdateStatusProcess.next(1);

    var params = {
        method:"QoEStorCheckForUpdates",
        callback:function (R)
        {
            _this.Signals.UpdateStatusProcess.next(0);

            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};


QoEStorConfigManager.prototype.StartUpdate = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"StartQoEStorUpdate",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(!R.success)
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};


QoEStorConfigManager.prototype.RefreshQoEStorUpdateLogTail = function (Params)
{
    var _this = this;

    var params =
        {
            method:"GetQoEStorUpdateLogTail",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                var text = R.success ? R.data : R.error.msg;

                var data = _this.Signals.UpdateStatus.getValue();

                if(!R.success && _this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)
                {
                    text = _this.Signals.UpdateLogTail.getValue();
                }

                _this.Signals.UpdateLogTail.next(text);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }

                if(!R.success)
                {
                    if(!(data.is_runnig && (_this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)))
                        webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};


QoEStorConfigManager.prototype.DownloadUpdateLog = function (Params)
{
    var _this = this;

    var params =
        {
            method:"DownloadQoEStorUpdateLog",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    App.ServerManager.RedirectToFileDownload(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.prototype.RefreshQoEStorCheckForUpdateLogTail = function (Params)
{
    var _this = this;

    var params =
        {
            method:"GetQoEStorCheckForUpdateLogTail",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                var text = R.success ? R.data : R.error.msg ;

                var data = _this.Signals.UpdateStatus.getValue();

                if(!R.success && _this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)
                {
                    text = _this.Signals.CheckForUpdateLogTail.getValue();
                }

                _this.Signals.CheckForUpdateLogTail.next(text);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }

                if(!R.success)
                {
                    if(!(data.is_runnig && (_this.DontShowErrorCodesWhenUpdating.indexOf(R.error.code) >= 0)))
                        webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};


QoEStorConfigManager.prototype.DownloadCheckForUpdateLog = function (Params)
{
    var _this = this;

    var params =
        {
            method:"DownloadQoEStorCheckForUpdateLog",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    App.ServerManager.RedirectToFileDownload(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.prototype.ParseReceiverRows = function(ReceiverTypes, ConfigModel)
{
    var configModel = ConfigModel ? ConfigModel : this.GetConfigModel();

    var rows = [];

    ReceiverTypes.forEach(receiverType => {
        var i = 0;

        while (configModel[receiverType + "_PORT_TYPE[" + i + "]"]) {
            var row = new QoEStorIpfixReceiverConfigRowModel({RECEIVER_TYPE: receiverType});

            Object.keys(row).forEach(function (Key) {
                var id = receiverType + "_" + Key + "[" + i + "]";

                if (configModel[id])
                    row[Key] = configModel[id];
            });

            rows.push(row);

            i++;
        }
    });

    return rows;
};

QoEStorConfigManager.prototype.ParseClusterRows = function(ClusterOptTypes)
{
    var configModel = this.GetConfigModel();

    var rows = [];

    ClusterOptTypes.forEach(ClusterOptType => {
        var i = 0;

        while (configModel[`${ClusterOptType}[${i}]`]) {
            var row = new QoEStorClusterConfigRowModel({CH_SHARD_REPLICAS: ClusterOptType});

            Object.keys(row).forEach(function (Key) {
                var id = `${Key}[${i}]`;

                if (configModel[id])
                    row[Key] = configModel[id];
            });

            rows.push(row);

            i++;
        }
    });

    return rows;
};

QoEStorConfigManager.prototype.ForcedDownloadReferenceBook = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"QoEStorForcedDownloadReferenceBook",
        data:{
            HwId:this.CurrentHwId
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.prototype.GetMyCompanyProfile = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"VasCloudGetMyCompanyProfile",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.prototype.HistoryRefresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"GetQoEStorConfigHistory",
            callback:function (result)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(result.success && result.data)
                {
                    var data = [];

                    Object.keys(result.data).forEach(function (Key)
                    {
                        var obj = new QoEStorConfigHistoryModel({file_id:result.data[Key]});

                        data.push(obj);
                    });

                    _this.History = data;
                    _this.Signals.ConfigHistoryUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("All", "History loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

QoEStorConfigManager.prototype.GetCurrentHardwareId = function (HardwareId)
{
    return HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();
};

QoEStorConfigManager.prototype.GetHistory = function(HardwareId)
{
    if(this.History)
    {
        return this.History;
    }

    return [];
};

QoEStorConfigManager.prototype.LoadHistoryFile = function(Params)
{
    var params =
        {
            method:"GetQoEStorConfigFromHistory",
            data:{
                File:Params&&Params.configFile?Params.configFile:""
            },
            callback:function (result)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

QoEStorConfigManager.prototype.RestartAllReceivers = function(HwId)
{
    let _this = this;

    if(!this.Active)
        return;

    let params = {
        id: webix.uid(),
        method:"RestartQoEReceivers",
        data: {HwId: parseInt(HwId)},
        callback:function (R)
        {
            if(!_this.Active)
                return;

            if(R.success && R.data)
            {
                _this.Signals.RestartReceiversSuccess.next(R.data);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.RestartReceiversError.next(R.error)
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    App.ServerManager.CallMethod(params);
};

QoEStorConfigManager.prototype.StopAllReceivers = function(HwId)
{
    let _this = this;

    if(!this.Active)
        return;

    let params = {
        id: webix.uid(),
        method:"StopQoEReceivers",
        data: {HwId: parseInt(HwId)},
        callback:function (R)
        {
            if(!_this.Active)
                return;

            if(R.success && R.data)
            {
                _this.Signals.StopReceiversSuccess.next(R.data);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.StopReceiversError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    App.ServerManager.CallMethod(params);
};

QoEStorConfigManager.prototype.LocalDownloadFile = function(Content, MimiType, Filename)
{
    const a = document.createElement('a');
    const blob = new Blob([Content], {type: MimiType});
    const url = URL.createObjectURL(blob);

    a.setAttribute('href', url);
    a.setAttribute('download', Filename);

    a.click();
};

QoEStorConfigManager.prototype.ParseReceiversConfigFile = function(FileObj, Reader)
{
    let _this = this;

    return new Promise((resolve, reject) => {
        let result = [];

        let separators = {
            csv: ",",
            tsv: "\t"
        };

        let processData = function(Arr)
        {
            let headers = Arr.shift();

            return Arr.map(item => {
                let data = headers.reduce((obj, key, idx) => {
                    obj[key] = item[idx];
                    return obj
                }, {});

                return new QoEStorIpfixReceiverConfigRowModel(data);
            });
        }

        switch(FileObj.type)
        {
            case "txt":
                if(Reader && Reader.result)
                    result = _this.ParseReceiverRows(
                        Object.values(QoEStorIpfixReceiverTypesEnum),
                        _this.ParseConfigToModel(Reader.result)
                    );

                resolve(result);
                break;
            case "xlsx":
                let driver = webix.DataDriver["excel"];

                driver.toObject(FileObj.file)
                    .then((res) => {
                        result = res && res.data ? processData(res.data) : [];
                        resolve(result);
                    })
                    .catch((error) => {
                        reject(error);
                    });
                break
            default:
                let sep = separators[FileObj.type] ? separators[FileObj.type] : ",";

                if(Reader && Reader.result)
                {
                    let parseData = Reader.result
                        .split("\n")
                        .map(line => line.split(sep));

                    result = processData(parseData)
                }

                resolve(result);
        }
    });
};


function BalancerEnvConfigModel(Params)
{
    var _this = this;

    BalancerConfigManager.GetSortedBalancerEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = BalancerEnvConfigDic[Key].group;

        var id = BalancerEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            function ParseRecieversParams(ReceiverType)
            {
                var i = 0;

                while (Params[ReceiverType + "_PORT_TYPE[" + i + "]"])
                {
                    var model = new BalancerReceiverConfigModel({RECEIVER_TYPE:ReceiverType}, i);

                    Object.keys(model).forEach(function (Key)
                    {
                        var id = Key;

                        _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
                    });

                    i++;
                }
            }

            if(id == BalancerReceiverTypesEnum.IPFIX_FULLFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_FULLFLOW);

            if(id == BalancerReceiverTypesEnum.IPFIX_CLICKSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_CLICKSTREAM);

            if(id == BalancerReceiverTypesEnum.IPFIX_GTPFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_GTPFLOW);

            if(id == BalancerReceiverTypesEnum.IPFIX_NATFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_NATFLOW);

            if(id == BalancerReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM);

            if(id == BalancerReceiverTypesEnum.IPFIX_DNSFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_DNSFLOW);

            if(id == BalancerReceiverTypesEnum.IPFIX_AAAFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_AAAFLOW);
        }
        else
        {
            //var defaultVal = QoEStorEnvConfigDic[Key].default?QoEStorEnvConfigDic[Key].default:"";

            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
        }
    });

    // Add params to model, wich not in dic
    Object.keys(Params).forEach(function(Key)
    {

        if(!_this[Key])
        {
            var id = Key;
            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
        }
    });
}

function BalancerUpdateStatusModel(Params)
{
    this.current_version = Params&&Params.current_version?Params.current_version:null;
    this.new_version = Params&&Params.new_version?Params.new_version:null;
    this.has_new_version = Params&&Params.has_new_version?Params.has_new_version:0;
    this.date_of_install = Params&&Params.date_of_install?Params.date_of_install:null;
    this.update_last_check = Params&&Params.update_last_check?Params.update_last_check:null;
    this.autoupdate = Params&&Params.autoupdate?Params.autoupdate:0;

    this.is_runnig = Params&&Params.is_runnig?Params.is_runnig:0;
    this.is_runnig_before = Params&&Params.is_runnig_before?Params.is_runnig_before:0;

    this.undefined = Params&&Params.undefined?Params.undefined:0;


    this.service_unavailable = Params&&Params.service_unavailable?Params.service_unavailable:0;
    this.service_unavailable_count = Params&&Params.service_unavailable_count?Params.service_unavailable_count:0;
}

function BalancerConfigHistoryModel(Params)
{
    this.id = webix.uid();
    this.file_id = Params&&Params.file_id?Params.file_id:"";
    this.date = null;
    this.file_name = null;

    if(this.file_id)
    {
        var fileIdArr = this.file_id.split(".");
        var dateArr = fileIdArr.slice(0,5);

        var parser = webix.Date.strToDate("%Y.%m.%d.%H.%i.%s");
        this.date = parser(dateArr.join("."));

        this.file_name = fileIdArr[fileIdArr.length - 2] + "." + fileIdArr[fileIdArr.length - 1];
    }
}

const BalancerReceiverTypesEnum =
    {
        IPFIX_FULLFLOW:"IPFIX_FULLFLOW",
        IPFIX_CLICKSTREAM:"IPFIX_CLICKSTREAM",
        IPFIX_GTPFLOW:"IPFIX_GTPFLOW",
        IPFIX_NATFLOW:"IPFIX_NATFLOW",
        IPFIX_NATFLOW_NETSTREAM:"IPFIX_NATFLOW_NETSTREAM",
        IPFIX_DNSFLOW: "IPFIX_DNSFLOW",
        IPFIX_AAAFLOW: "IPFIX_AAAFLOW"
    };

const BalancerReceiverRotateDefaultsEnum = {};
BalancerReceiverRotateDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_FULLFLOW] = 10;
BalancerReceiverRotateDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_CLICKSTREAM] = 12;
BalancerReceiverRotateDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_GTPFLOW] = 10;
BalancerReceiverRotateDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_NATFLOW] = 10;
BalancerReceiverRotateDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM] = 10;
BalancerReceiverRotateDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_DNSFLOW] = 10;
BalancerReceiverRotateDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_AAAFLOW] = 10;

const BalancerReceiverDumpInsertProcessesDefaultsEnum = {};
BalancerReceiverDumpInsertProcessesDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_FULLFLOW] = 0;
BalancerReceiverDumpInsertProcessesDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_CLICKSTREAM] = 0;
BalancerReceiverDumpInsertProcessesDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_GTPFLOW] = 0;
BalancerReceiverDumpInsertProcessesDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_NATFLOW] = 0;
BalancerReceiverDumpInsertProcessesDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM] = 0;
BalancerReceiverDumpInsertProcessesDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_DNSFLOW] = 0;
BalancerReceiverDumpInsertProcessesDefaultsEnum[BalancerReceiverTypesEnum.IPFIX_AAAFLOW] = 0;

function BalancerReceiverConfigRowModel(Params)
{
    this.id = Params&&Params.id ? Params.id : webix.uid();

    this.RECEIVER_TYPE = Params&&Params.RECEIVER_TYPE?Params.RECEIVER_TYPE:BalancerReceiverTypesEnum.IPFIX_FULLFLOW;
    this.PORT_TYPE = Params&&Params.PORT_TYPE?Params.PORT_TYPE:"tcp";

    this.PORT = Params&&Params.PORT?Params.PORT:0;
    this.ROTATE_MINUTES = Params&&Params.ROTATE_MINUTES?Params.ROTATE_MINUTES:BalancerReceiverRotateDefaultsEnum[this.RECEIVER_TYPE];
    this.ROTATE_SECONDS = Params&&Params.ROTATE_SECONDS?Params.ROTATE_SECONDS:0;
    this.ROTATE_FLOWS = Params&&Params.ROTATE_FLOWS?Params.ROTATE_FLOWS:0;

    this.EXPORT = Params&&Params.EXPORT?Params.EXPORT:null;

    this.DPI_ID = Params&&Params.DPI_ID?Params.DPI_ID:-1;

    this.BALANCER = Params&&Params.BALANCER?Params.BALANCER:0;
    this.BALANCER_SUB = Params&&Params.BALANCER_SUB?Params.BALANCER_SUB:null;
    this.BALANCER_SUB_PROTO = Params&&Params.BALANCER_SUB_PROTO?Params.BALANCER_SUB_PROTO:"tcp";
    this.BALANCER_AUTO = Params&&Params.BALANCER_AUTO?Params.BALANCER_AUTO:0;

    this.BALANCER_TASKSET = Params&&Params.BALANCER_TASKSET?Params.BALANCER_TASKSET:null;
}

function BalancerReceiverConfigModel(Params, Index)
{
    var type = Params&&Params.RECEIVER_TYPE?Params.RECEIVER_TYPE:BalancerReceiverTypesEnum.IPFIX_FULLFLOW;

    this[type + "_PORT_TYPE[" + Index + "]"]  = Params&&Params.PORT_TYPE?Params.PORT_TYPE:"tcp";

    this[type + "_PORT[" + Index + "]"] = Params&&Params.PORT?Params.PORT:0;
    this[type + "_ROTATE_MINUTES[" + Index + "]"] = Params&&parseInt(Params.ROTATE_MINUTES)?Params.ROTATE_MINUTES:BalancerReceiverRotateDefaultsEnum[type];
    this[type + "_ROTATE_SECONDS[" + Index + "]"] = Params&&parseInt(Params.ROTATE_SECONDS)?Params.ROTATE_SECONDS:0;
    this[type + "_ROTATE_FLOWS[" + Index + "]"] = Params&&parseInt(Params.ROTATE_FLOWS)?Params.ROTATE_FLOWS:0;

    this[type + "_EXPORT[" + Index + "]"] = Params&&Params.EXPORT?Params.EXPORT:null;

    this[type + "_DPI_ID[" + Index + "]"] = Params&&Params.DPI_ID?Params.DPI_ID:-1;


    this[type + "_BALANCER[" + Index + "]"] = Params&&Params.BALANCER?Params.BALANCER:0;
    this[type + "_BALANCER_SUB[" + Index + "]"] = Params&&Params.BALANCER_SUB?Params.BALANCER_SUB:null;
    this[type + "_BALANCER_SUB_PROTO[" + Index + "]"] = Params&&Params.BALANCER_SUB_PROTO?Params.BALANCER_SUB_PROTO:"tcp";
    this[type + "_BALANCER_AUTO[" + Index + "]"] = Params&&Params.BALANCER_AUTO?Params.BALANCER_AUTO:0;
    this[type + "_BALANCER_TASKSET[" + Index + "]"] = Params&&Params.BALANCER_TASKSET?Params.BALANCER_TASKSET:null;
}

function BalancerConfigManager(Params)
{
    this.CurrentHwId = 0;

    this.Active = true;

    this.ConfigFile = "";

    this.ConfigModel = null;

    this.Signals = {
        ConfigFileUpdated: new Rx.BehaviorSubject(0),
        ConfigHistoryUpdated: new Rx.BehaviorSubject(0),
        UpdateStatusProcess: new Rx.BehaviorSubject(0),
        UpdateStatus: new Rx.BehaviorSubject(new BalancerUpdateStatusModel({undefined:1})),
        UpdateLogTail: new Rx.BehaviorSubject(null),
        CheckForUpdateLogTail: new Rx.BehaviorSubject(null)
    };

    this.History = {};

    this.DontShowErrorCodesWhenUpdating = [0,503,2002,-403];
}

BalancerConfigManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

BalancerConfigManager.prototype.SetHwId = function(HwId)
{
    this.CurrentHwId = parseInt(HwId);
};

BalancerConfigManager.prototype.Refresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"GetBalancerEnvConfig",
        data:{
            HwId:this.CurrentHwId
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                _this.ConfigFile = R.data;
            }
            else
            {
                _this.ConfigFile = "";
            }

            _this.ParseConfigToModel();
            _this.ParseModelToConfig();

            _this.Signals.ConfigFileUpdated.next(1);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    if(!Params.silent)
                    {
                        webix.message(LangHelper.GetString("QoEStorConfig", "Configuration loaded."));
                    }
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BalancerConfigManager.prototype.GetConfig = function()
{
    return this.ConfigFile
};

BalancerConfigManager.prototype.SetConfig = function(ConfigFile)
{
    this.ConfigFile = ConfigFile;

    this.ParseConfigToModel();

    this.Signals.ConfigFileUpdated.next(1);
};

BalancerConfigManager.prototype.GetConfigModel = function()
{
    return this.ConfigModel ? this.ConfigModel : new BalancerEnvConfigModel();
};

BalancerConfigManager.prototype.RemoveReceiversParamsFromConfigModel = function()
{
    var _this = this;

    if(this.ConfigModel)
    {
        Object.keys(this.ConfigModel).forEach(function (Key) {
            if(
                Key.indexOf(BalancerReceiverTypesEnum.IPFIX_FULLFLOW) >= 0 ||
                Key.indexOf(BalancerReceiverTypesEnum.IPFIX_CLICKSTREAM) >= 0 ||
                Key.indexOf(BalancerReceiverTypesEnum.IPFIX_GTPFLOW) >= 0 ||
                Key.indexOf(BalancerReceiverTypesEnum.IPFIX_NATFLOW) >= 0 ||
                Key.indexOf(BalancerReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM) >= 0 ||
                Key.indexOf(BalancerReceiverTypesEnum.IPFIX_DNSFLOW) >= 0 ||
                Key.indexOf(BalancerReceiverTypesEnum.IPFIX_AAAFLOW) >= 0
            )
                delete _this.ConfigModel[Key];
        });
    }
};

BalancerConfigManager.prototype.SetConfigModel = function(ConfigModel)
{
    if(this.ConfigModel)
    {
        this.RemoveReceiversParamsFromConfigModel();
        this.ConfigModel = webix.extend(this.ConfigModel, new BalancerEnvConfigModel(ConfigModel), true);
    }
    else
    {
        this.ConfigModel = new BalancerEnvConfigModel(ConfigModel);
    }

    this.ParseModelToConfig();

    this.Signals.ConfigFileUpdated.next(1);
};

BalancerConfigManager.prototype.ParseConfigToModel = function()
{
    var config = this.GetConfig();

    var parser = new ConfigIniParser();

    parser.parse(config);

    this.ConfigModel = new BalancerEnvConfigModel(parser.itemsKeyVal());
};

BalancerConfigManager.prototype.ParseModelToConfig = function(ShowComments, ShowAllParams)
{
    var _this = this;

    var showComments = parseInt(App.SessionManager.GetPreference("BalancerConfigManager:ShowComments")) ? true : false;

    var showAllParams = parseInt(App.SessionManager.GetPreference("BalancerConfigManager:ShowAllParams")) ? true : false;

    var configModel = this.GetConfigModel();
    var parser = new ConfigIniParser();

    var currentGroupId = 0;

    var processedIds = {};

    function ProcessDicParameter(Key, ConfigModelId, CustomParams)
    {
        if (CustomParams) {
            // Process params to config, wich not in dic
            var groupId = CustomParams.GroupId;
            var id = CustomParams.id;
            var comment = CustomParams.value;
            var tooltip = CustomParams.tooltip?CustomParams.tooltip:"";

        } else {
            // Process params to config, which in dic
            var groupId = BalancerEnvConfigDic[Key].group;
            var id = ConfigModelId ? ConfigModelId : BalancerEnvConfigDic[Key].id;
            var comment = BalancerEnvConfigDic[Key].value;
            var tooltip = BalancerEnvConfigDic[Key].tooltip?BalancerEnvConfigDic[Key].tooltip:"";

        }

        if(groupId !== currentGroupId)
        {
            currentGroupId = groupId;

            if(showComments && ((configModel[id] && configModel[id].length !== 0) || showAllParams))
            {
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, BalancerEnvConfigGroupDic[currentGroupId].value);
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, " ");
            }

        }

        if(showComments && ((configModel[id] && configModel[id].length !== 0) || showAllParams))
            parser.set("", webix.uid(), null, comment);

        if(tooltip&&tooltip!==comment)
        {
            if(showComments && ((configModel[id] && configModel[id].length !== 0) || showAllParams))
            {
                var tt = tooltip.split('<br/>');
                tt.forEach(function (Val)
                {
                    if(Val)
                        parser.set("", webix.uid(), null, Val);
                });
            }
        }

        if(configModel[id] && configModel[id].length !== 0)
        {
            parser.set("", id, configModel[id]);
            parser.set("", webix.uid(), null, " ");
        }
        else
        {
            if(showAllParams)
            {
                parser.set("", webix.uid(), null, id+"="+(configModel[id] ? configModel[id] : ""));
                parser.set("", webix.uid(), null, " ");
            }
        }

        processedIds[id] = id;
    }

    BalancerConfigManager.GetSortedBalancerEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = BalancerEnvConfigDic[Key].group;
        var id = BalancerEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            function ParseRecieversParams(ReceiverType)
            {
                var i = 0;

                var map = BalancerConfigManager.BalancerReceiverDicIdToParamIdMap(ReceiverType)

                while (configModel[ReceiverType + "_PORT_TYPE[" + i + "]"])
                {
                    var model = new BalancerReceiverConfigModel({RECEIVER_TYPE:ReceiverType}, i);

                    Object.keys(map).forEach(function (Key)
                    {
                        ProcessDicParameter(Key, map[Key].replace("[i]", "[" + i + "]"));
                    });

                    i++;
                }

                if(!i)
                {
                    Object.keys(map).forEach(function (Key)
                    {
                        ProcessDicParameter(Key);
                    });
                }
            }

            if(id == BalancerReceiverTypesEnum.IPFIX_FULLFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_FULLFLOW);

            if(id == BalancerReceiverTypesEnum.IPFIX_CLICKSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_CLICKSTREAM);

            if(id == BalancerReceiverTypesEnum.IPFIX_GTPFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_GTPFLOW);

            if(id == BalancerReceiverTypesEnum.IPFIX_NATFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_NATFLOW);

            if(id == BalancerReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM);

            if(id == BalancerReceiverTypesEnum.IPFIX_DNSFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_DNSFLOW);

            if(id == BalancerReceiverTypesEnum.IPFIX_AAAFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(BalancerReceiverTypesEnum.IPFIX_AAAFLOW);
        }
        else
        {
            ProcessDicParameter(Key);
        }
    });

    // Add params to config, wich not in dic
    if(Object.keys(processedIds).length != Object.keys(configModel).length)
    {
        if(showComments)
        {
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, LangHelper.GetString("Dics", "Unknown parameters"));
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, " ");
        }

        Object.keys(configModel).forEach(function(Key)
        {
            if(!processedIds[Key])
            {
                var id = Key;

                if(configModel[id].length !== 0)
                {
                    parser.set("", id, configModel[id]);
                }
                else
                {
                    parser.set("", webix.uid(), null, id+"="+configModel[id]);
                }

                parser.set("", webix.uid(), null, " ");
            }
        });
    }

    this.ConfigFile = parser.stringify();
};

BalancerConfigManager.prototype.Save = function(Params)
{
    var _this = this;

    var params =
        {
            method:"SetBalancerEnvConfig",
            data:{
                Config:Params&&Params.configContents?Params.configContents:_this.GetConfig(),
                HwId:this.CurrentHwId
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

BalancerConfigManager.prototype.Restart = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"BalancerRestart",
        data:{
            HwId:this.CurrentHwId
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("QoEStorConfig", "Queue restarted successfully"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BalancerConfigManager.GetSortedBalancerEnvConfigDicKeysArr = function()
{
    var groupsArr = BalancerConfigManager.GetSortedBalancerEnvConfigGroupDicKeysArr();

    var arr = [];

    groupsArr.forEach(function (V)
    {
        Object.keys(BalancerEnvConfigDic).forEach(function (K)
        {
            if(BalancerEnvConfigDic[K].group == V)
            {
                arr.push(K);
            }
        });
    });

    return arr;
};

BalancerConfigManager.GetSortedBalancerEnvConfigGroupDicKeysArr = function()
{
    var arr = [];

    BalancerConfigManager.GetSortedBalancerEnvConfigGroupDicArr().forEach(function (V)
    {
        arr.push(V.id)
    });

    return arr;
};

BalancerConfigManager.GetSortedBalancerEnvConfigGroupDicArr = function()
{
    var groupsArr = Helper.DictToArr(BalancerEnvConfigGroupDic);

    groupsArr.sort(function(a, b) {
        return a.order - b.order;
    });

    return groupsArr;
};

BalancerConfigManager.BalancerReceiverDicIdToParamIdMap = function(ReceiverType)
{
    var map = {};

    BalancerConfigManager.GetSortedBalancerEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = BalancerEnvConfigDic[Key].group;
        var id = BalancerEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            if(id.indexOf(ReceiverType) >= 0)
                map[Key] = id;
        }
    });

    return map;
};

BalancerConfigManager.BalancerReceiverParamIdToDicIdMap = function(ReceiverType)
{
    var map = {};

    BalancerConfigManager.GetSortedBalancerEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = BalancerEnvConfigDic[Key].group;
        var id = BalancerEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            if(id.indexOf(ReceiverType) >= 0)
                map[id] = Key;
        }
    });

    return map;
};

BalancerConfigManager.prototype.ParseReceiverRows = function(ReceiverTypes)
{
    var configModel = this.GetConfigModel();

    var rows = [];

    ReceiverTypes.forEach(receiverType => {
        var i = 0;

        while (configModel[receiverType + "_PORT_TYPE[" + i + "]"]) {
            var row = new BalancerReceiverConfigRowModel({RECEIVER_TYPE: receiverType});

            Object.keys(row).forEach(function (Key) {
                var id = receiverType + "_" + Key + "[" + i + "]";

                if (configModel[id])
                    row[Key] = configModel[id];
            });

            rows.push(row);

            i++;
        }
    });

    return rows;
};

BalancerConfigManager.prototype.HistoryRefresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"GetBalancerConfigHistory",
            data:{
                HwId: this.CurrentHwId
            },
            callback:function (result)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(result.success && result.data)
                {
                    var data = [];

                    Object.keys(result.data).forEach(function (Key)
                    {
                        var obj = new BalancerConfigHistoryModel({file_id:result.data[Key]});

                        data.push(obj);
                    });

                    _this.History = data;
                    _this.Signals.ConfigHistoryUpdated.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
                else
                {
                    if(result.success)
                    {
                        webix.message(LangHelper.GetString("All", "History loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        }

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

BalancerConfigManager.prototype.GetCurrentHardwareId = function (HardwareId)
{
    return HardwareId?HardwareId:App.SessionManager.GetCurrentHardwareId();
};

BalancerConfigManager.prototype.GetHistory = function(HardwareId)
{
    if(this.History)
    {
        return this.History;
    }

    return [];
};

BalancerConfigManager.prototype.LoadHistoryFile = function(Params)
{
    var params =
        {
            method:"GetBalancerConfigFromHistory",
            data:{
                File:Params&&Params.configFile?Params.configFile:"",
                HwId:this.CurrentHwId
            },
            callback:function (result)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(result);
                }
            }
        }

    App.ServerManager.CallMethod(params);
};

function FastPcrfConfigManager(Params)
{
    // var params = webix.extend(Params,{
    //     Id:"FastPcrfConfig",
    //     PageTitle:{
    //         RootTitle: LangHelper.GetString("AppView", "Administrator"),
    //         Title: LangHelper.GetString("AppView", "FastPcrf Config")
    //     },
    //     DicName: "FastPcrf"
    //     // ServerMethods:
    //     //     {
    //     //         RefreshLogsFilesList:"GetQoEStorLogsFilesList",
    //     //
    //     //         GetLogFileTail:"GetQoEStorLogFileTail",
    //     //
    //     //         DownloadLogFile:"DownloadQoEStorLogFile"
    //     //     },
    //     // PathsNamesMap:
    //     //     {
    //     //         "/var/log/clickhouse-server":"Clickhouse",
    //     //         "/var/qoestor/backend/logs":"Receivers"
    //     //     }
    // },true);

    BaseHardwareConfigManager.superclass.constructor.call(this, Params);

}

Helper.ExtendClass(FastPcrfConfigManager,BaseHardwareConfigManager);
function CaptchaConfigModel(Params)
{
    var _this = this;

    CaptchaConfigManager.GetSortedCaptchaEnvConfigDicKeysArr().forEach(function(Key)
    {
        var id = CaptchaEnvConfigDic[Key].id;

        var defaultVal = CaptchaEnvConfigDic[Key].default?CaptchaEnvConfigDic[Key].default:"";

        _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):defaultVal);
    });

    // Add params to model, wich not in dic
    Object.keys(Params).forEach(function(Key)
    {
        if(!_this[Key])
        {
            var id = Key;
            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
        }
    });
}

function CaptchaConfigManager(Params)
{
    this.Active = true;

    this.ConfigFile = "";

    this.ConfigModel = null;

    this.TemplateFile = "";

    this.TemplateCode = "";

    this.CurrentOpenedFile = "";

    this.CaptchaSrc = "";

    this.Signals = {
        ConfigFileUpdated: new Rx.BehaviorSubject(0),
        TemplateFileUpdated: new Rx.BehaviorSubject(0),
        TemplateFilesUpdated: new Rx.BehaviorSubject(0),
        TemplatesUpdated: new Rx.BehaviorSubject(0),
        TemplateFontsUpdated: new Rx.BehaviorSubject(0)
    };
}

CaptchaConfigManager.GetSortedCaptchaEnvConfigDicKeysArr = function()
{
    var groupsArr = CaptchaConfigManager.GetSortedCaptchaEnvConfigGroupDicKeysArr();

    var arr = [];

    groupsArr.forEach(function (V)
    {
        Object.keys(CaptchaEnvConfigDic).forEach(function (K)
        {
            if(CaptchaEnvConfigDic[K].group == V)
            {
                arr.push(K);
            }
        });
    });

    return arr;
};

CaptchaConfigManager.GetSortedCaptchaEnvConfigGroupDicKeysArr = function()
{
    var arr = [];

    CaptchaConfigManager.GetSortedCaptchaEnvConfigGroupDicArr().forEach(function (V)
    {
        arr.push(V.id)
    });

    return arr;
};

CaptchaConfigManager.GetSortedCaptchaEnvConfigGroupDicArr = function()
{
    var _groupsArr = Helper.DictToArr(CaptchaEnvConfigGroupDic), groupsArr = [];

    _groupsArr.forEach(function (Item)
    {
        if(!Item.lic)
        {
            groupsArr.push(Item);
            return;
        }

        if(App.SessionManager.CheckLic(Item.lic, Item.lic_level))
            groupsArr.push(Item);
    });

    groupsArr.sort(function(a, b) {
        return a.order - b.order;
    });

    return groupsArr;
};

CaptchaConfigManager.prototype.GetConfig = function()
{
    return this.ConfigFile;
};

CaptchaConfigManager.prototype.GetTemplate = function()
{
    return this.TemplateFile;
};

CaptchaConfigManager.prototype.GetCaptchaSrc = function()
{
    return this.CaptchaSrc;
};

CaptchaConfigManager.prototype.SetCaptchaSrc = function(Src)
{
    this.CaptchaSrc = Src;
};

CaptchaConfigManager.prototype.GetTemplateCode = function()
{
    return this.TemplateCode;
};

CaptchaConfigManager.prototype.GetConfigModel = function()
{
    return this.ConfigModel ? this.ConfigModel : new CaptchaConfigModel();
};

CaptchaConfigManager.prototype.GetCurrentOpenedFile = function()
{
    return this.CurrentOpenedFile;
};

CaptchaConfigManager.prototype.SetCurrentOpenedFile = function(File)
{
    this.CurrentOpenedFile = File;
};

CaptchaConfigManager.prototype.ParseConfigToModel = function()
{
    var config = this.GetConfig();

    var parser = new ConfigIniParser();
    parser.parse(config);

    this.ConfigModel = new CaptchaConfigModel(parser.itemsKeyVal());
};

CaptchaConfigManager.prototype.ParseModelToConfig = function(ShowComments, ShowAllParams)
{
    var _this = this;

    var showComments = parseInt(App.SessionManager.GetPreference("CaptchaConfigManager:ShowComments")) ? true : false;

    var showAllParams = parseInt(App.SessionManager.GetPreference("CaptchaConfigManager:ShowAllParams")) ? true : false;

    var configModel = this.GetConfigModel();
    var parser = new ConfigIniParser();

    var currentGroupId = 0;

    var processedIds = {};

    CaptchaConfigManager.GetSortedCaptchaEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = CaptchaEnvConfigDic[Key].group;
        var id = CaptchaEnvConfigDic[Key].id;
        var comment = CaptchaEnvConfigDic[Key].value;
        var tooltip = CaptchaEnvConfigDic[Key].tooltip?CaptchaEnvConfigDic[Key].tooltip:"";

        if(groupId !== currentGroupId)
        {
            currentGroupId = groupId;

            if(showComments && (configModel[id].length !== 0 || showAllParams))
            {
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, CaptchaEnvConfigGroupDic[currentGroupId].value);
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, " ");
            }

        }

        if(showComments && (configModel[id].length !== 0 || showAllParams))
            parser.set("", webix.uid(), null, comment);

        if(tooltip&&tooltip!==comment)
        {
            if(showComments && (configModel[id].length !== 0 || showAllParams))
                parser.set("", webix.uid(), null, tooltip);
        }

        if(configModel[id].length !== 0)
        {
            parser.set("", id, configModel[id]);
            parser.set("", webix.uid(), null, " ");
        }
        else
        {
            if(showAllParams)
            {
                parser.set("", webix.uid(), null, id+"="+configModel[id]);
                parser.set("", webix.uid(), null, " ");
            }
        }

        processedIds[id] = id;
    });

    // Add params to config, wich not in dic
    if(Object.keys(processedIds).length != Object.keys(configModel).length)
    {
        if(showComments)
        {
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, LangHelper.GetString("Dics", "Unknown parameters"));
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, " ");
        }

        Object.keys(configModel).forEach(function(Key)
        {
            if(!processedIds[Key])
            {
                var id = Key;

                if(configModel[id].length !== 0)
                {
                    parser.set("", id, configModel[id]);
                }
                else
                {
                    parser.set("", webix.uid(), null, id+"="+configModel[id]);
                }

                parser.set("", webix.uid(), null, " ");
            }
        });
    }

    this.ConfigFile = parser.stringify();
};

CaptchaConfigManager.prototype.Refresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"GetCaptchaEnvConfig",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                _this.ConfigFile = R.data;
            }
            else
            {
                _this.ConfigFile = "";
            }

            _this.ParseConfigToModel();
            _this.ParseModelToConfig();

            _this.Signals.ConfigFileUpdated.next(1);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("Dpiui2Config", "Configuration loaded"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

CaptchaConfigManager.prototype.RefreshTemplates = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"GetCaptchaTemplate",
        data:{
            CurrentTemplate:Params ? Params : "",
            CurrentFile: _this.GetCurrentOpenedFile()
        },
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                _this.TemplateFile = R.data.template;
                _this.TemplateCode = R.data.code;
                _this.CaptchaSrc = R.data.ip;
            }
            else
            {
                _this.TemplateFile = "";
                _this.TemplateCode = "";
                _this.CaptchaSrc = "";
            }

            _this.Signals.TemplateFileUpdated.next(1);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("Dpiui2Config", "Configuration loaded"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

CaptchaConfigManager.prototype.SetConfigModel = function(ConfigModel)
{
    if(this.ConfigModel)
    {
        this.ConfigModel = webix.extend(this.ConfigModel, new CaptchaConfigModel(ConfigModel), true);
    }
    else
    {
        this.ConfigModel = new CaptchaConfigModel(ConfigModel);
    }

    this.ParseModelToConfig();

    this.Signals.ConfigFileUpdated.next(1);
};

CaptchaConfigManager.prototype.SetConfig = function(ConfigFile)
{
    this.ConfigFile = ConfigFile;

    this.ParseConfigToModel();

    this.Signals.ConfigFileUpdated.next(1);
};

CaptchaConfigManager.prototype.SetTemplate = function(TemplateFile)
{
    this.TemplateFile = TemplateFile;

    this.Signals.TemplateFileUpdated.next(1);
};

CaptchaConfigManager.prototype.Save = function(Params)
{
    var _this = this;

    var params =
        {
            method:"SetCaptchaEnvConfig",
            data:{
                Config:Params&&Params.configContents?Params.configContents:_this.GetConfig()
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

CaptchaConfigManager.prototype.SaveTemplate = function(Params)
{
    var _this = this;

    var params =
        {
            method:"SetCaptchaTemplate",
            data:{
                Template:Params&&Params.configContents?Params.configContents:_this.GetTemplate(),
                CurrentTemplateFile: _this.GetCurrentOpenedFile(),
                CurrentTemplate: Params.template ? Params.template : ""
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

CaptchaConfigManager.prototype.ResetTemplate = function(Params)
{
    var _this = this;

    var params =
        {
            method:"ResetCaptchaTemplate",
            data:{
                CurrentTemplateFile: _this.GetCurrentOpenedFile(),
                CurrentTemplate: Params.template ? Params.template : ""
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

CaptchaConfigManager.prototype.GetCurrentTemplateFonts = function(Params)
{
    var _this = this;

    var params =
        {
            method:"GetCaptchaCurrentTemplateFonts",
            data:{
                CurrentTemplate:_this.ConfigModel.APP_TEMPLATE
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.Signals.TemplateFontsUpdated.next(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("Dpiui2Config", "Configuration loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

CaptchaConfigManager.prototype.GetCaptchaTemplates = function(Params)
{
    var _this = this;

    var params =
        {
            method:"GetCaptchaTemplates",
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.Signals.TemplatesUpdated.next({data:R.data, Params: Params});
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("Dpiui2Config", "Configuration loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

CaptchaConfigManager.prototype.GetCaptchaTemplateFiles = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params =
        {
            method:"GetCaptchaTemplateFiles",
            data:{
                CurrentTemplate:Params.template ? Params.template : _this.ConfigModel.APP_TEMPLATE
            },
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(R.success)
                {
                    _this.Signals.TemplateFilesUpdated.next(R.data);
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("Dpiui2Config", "Configuration loaded"));
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

CaptchaConfigManager.prototype.CreateCaptchaTemplate = function(Params)
{
    var _this = this;

    var params =
        {
            method:"SaveCaptchaTemplate",
            data:{
                TemplateName:Params.template ? Params.template : "",
                TemplateClone: Params.templateClone ? Params.templateClone : ""
            },

            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

CaptchaConfigManager.prototype.DeleteCaptchaTemplate = function(Params)
{
    var _this = this;

    var params =
        {
            method:"DeleteCaptchaTemplate",
            data:{
                TemplateName:Params.template ? Params.template : ""
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

CaptchaConfigManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};


var UlrRulesTypesCodesEnum = {
    web_ip_lock:"web_ip_lock",
    app_protocol_lock:"app_protocol_lock",
    asn_lock:"asn_lock",
    ip_exclude:"ip_exclude",
    asn_exclude:"asn_exclude",
    web_ip_white:"web_ip_white",
    vip_subscribers: "vip_subscribers",
    traffic_redirection: "traffic_redirection",
    excluded_resources: "excluded_resources",
    spoof_dns: "spoof_dns",
    pcap_recording: "pcap_recording"
};

var UlrRulesTypesCodesTypeIdMap = {
    web_ip_lock:1,
    app_protocol_lock:2,
    asn_lock:3,
    ip_exclude:4,
    asn_exclude:5,
    web_ip_white:6,
    pcap_recording:12,
    vip_subscribers: 15,
    traffic_redirection: 17,
    spoof_dns: 19,
    excluded_resources: 28
};

var UlrRulesTypesCodesTypeIdMapSwapped = Helper.SwapObj(UlrRulesTypesCodesTypeIdMap);

var UlrRulesTypesCodesControllersMap = {
    web_ip_lock:"UlrEditWebIpFilterRule",
    app_protocol_lock:"UlrAppDscpRules",
    asn_lock:"UlrAsnDscpRules",
    ip_exclude:"UlrIpExcludesRules",
    asn_exclude:"UlrAsnExcludesRules",
    web_ip_white:"UlrEditWhiteListRule",
    vip_subscribers: "UlrVipSubscribersRules",
    traffic_redirection: "UlrTrafficRedirectionRules",
    isp: "UlrEditIsp",
    subscriber: "UlrEditSubs",
    as_number: "UlrEditAsnDscpRule",
    pcap_recording: "UlrRecordPCAP",
    excluded_resources: "UlrExcludedResources",
    spoof_dns:"UlrEditSpoofDnsRule"
};

var UlrRulesTypesCodesListsControllersMap = {
    web_ip_lock:"UlrWebIpFilterRules",
    web_rules_statistics:"UlrWebRulesStatistics",
    app_protocol_lock:"UlrAppDscpRules",
    asn_lock:"UlrAsnDscpRules",
    ip_exclude:"UlrIpExcludesRules",
    asn_exclude:"UlrAsnExcludesRules",
    web_ip_white:"UlrWhiteList",
    vip_subscribers: "UlrVipSubscribersRules",
    traffic_redirection: "UlrTrafficRedirectionRules",
    isp: "UlrIspsList",
    subscriber: "UlrSubsList",
    as_number: "UlrAsnRuleList",
    custom_protocols:"UlrAppCustomProtocols",
    cloud_protocols:"UlrAppProtocols",
    pcap_recording: "UlrRecordPCAP",
    excluded_resources: "UlrExcludedResources",
    spoof_dns:"UlrSpoofDnsRules"
};

var UlrStateValidEnum = {
    undefined:0,
    invalid:1,
    valid:2
};

var UlrStateErrorEnum = {
    ok:0,
    error:1
};

var UlrWebRuleModesEnum = {
    all_isps:1,
    only_isps_in_list:2
};

var UlrWebRuleResourcesTypesEnum = {
    url:"url",
    sni:"sni",
    cn:"cn",
    ip:"ip",
    cidr:"cidr",
    clsfr:"category",
    login: "login",
    ulr_fastresource: "ulr_fastresource"
};

var UlrWebRuleResourcesTypesMapEnum = {
    url:1,
    sni:2,
    cn:3,
    ip:4,
    cidr:5,
    empty: 6,
    clsfr:7,
    login: 8,
    ulr_fastresource: 10,
    ech: 11
};

var UlrWebRuleResourcesTypesMapListKeys = {
    ip: "ips",
    url: "urls",
    cn: "cns",
    sni: "snis",
    // ulr_fastresource: "ulr_fastresource"
};

const UlrWebRuleResourcesListTypes = {
    "global": {"value": LangHelper.GetString("UlrModule", "Global"), "id": "global"},
    "isp": {"value": LangHelper.GetString("UlrModule", "Channels"), "id": "isp"},
    "subscriber": {"value": LangHelper.GetString("UlrModule", "Subscribers"), "id": "subscriber"}
};

const UlrWebRuleTypeModeListTypes = {
    "global": {"value": LangHelper.GetString("UlrModule", "Globals"), "id": "global"},
    "isp": {"value": LangHelper.GetString("UlrModule", "For channels"), "id": "isp"},
    "subscriber": {"value": LangHelper.GetString("UlrModule", "For subscribers"), "id": "subscriber"},
    "isp_subs": {"value": LangHelper.GetString("UlrModule", "For channels and subscribers"), "id": "isp_subs"}
};



function UlrWebRuleModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.enabled = Params&&Params.enabled ? Params.enabled : 0;
    
    this.hard_blocking = Params&&Params.hard_blocking ? parseInt(Params.hard_blocking) : 0;
    this.ech_enabled = Params&&Params.ech_enabled ? parseInt(Params.ech_enabled) : 0;
    this.ech_redirect_ipv4 = Params && Params.ech_redirect_ipv4 ? Params.ech_redirect_ipv4 : '';
    this.ech_redirect_ipv6 = Params && Params.ech_redirect_ipv6 ? Params.ech_redirect_ipv6 : '';

    this.type_id = Params&&Params.type_id ? Params.type_id : 0;
    this.mode_id = Params&&Params.mode_id ? Params.mode_id : 0;
    this.subs_mode_id = Params&&Params.subs_mode_id ? Params.subs_mode_id : 0;
    this.regulator_id = Params&&Params.regulator_id ? Params.regulator_id : 0;
    this.category_id = Params&&Params.category_id ? Params.category_id : 0;

    this.name = Params&&Params.name ? Params.name : null;
    this.description_public = Params&&Params.description_public ? Params.description_public.trim() : null;
    this.description_private = Params&&Params.description_private ? Params.description_private.trim() : null;

}

function UlrWebRuleResourceModel(Params) 
{
    this._id = Params && Params._id ? Params._id : 0;
    this.type_id = Params&&Params.type_id?Params.type_id:1;
    this.rule_id = Params&&Params.rule_id?Params.rule_id:null;
    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.resource_raw = Params&&Params.resource_raw?Params.resource_raw:null;
    this.resource_validated = Params&&Params.resource_validated?Params.resource_validated:null;
    this.exclusion = Params&&Params.exclusion?Params.exclusion:0;
    this.state_valid = Params&&Params.state_valid?Params.state_valid:0;
    this.state_error = Params&&Params.state_error?Params.state_error:0;
    this.state = Params&&Params.state?Params.state:"";

    this.imported = Params && Params.imported ? parseInt(Params.imported) : 0;
    this.lifetime = Params && Params.lifetime ? Params.lifetime : null;
    this.fastresource_config = Params && Params.fastresource_config ? Params.fastresource_config : null;
}

function UlrWebRuleViewModel(Params)
{
    this.profile = Params&&Params.profile ? Params.profile : null;
    this.resources = Params&&Params.resources ? Params.resources : null;
    this.isps = Params&&Params.isps ? Params.isps : null;
    this.dics = Params&&Params.dics ? Params.dics : 0;
    this.is_system = Params && Params.is_system ? parseInt(Params.is_system) : 0;
}

function UlrValuedResourceViewModel(Params)
{
    this.type_id = Params&&Params.type_id ? Params.type_id : 1;
    this.resource_raw = Params&&Params.resource_raw ? (this.type_id == UlrWebRuleResourcesTypesMapEnum.clsfr ? Params.resource_raw : Params.resource_raw.trim()) : "";
    this.validation_success = Params&&Params.validation_success ? true : false;
    this.try_validate = Params&&Params.try_validate ? true : false;
    this.snis = Params&&Params.snis ? Params.snis : [];
    this.cns = Params&&Params.cns ? Params.cns : [];
    this.urls = Params&&Params.urls ? Params.urls : [];
    this.ips = Params&&Params.ips ? Params.ips : [];
    this.cidrs = Params&&Params.cidrs ? Params.cidrs : [];

    this.isHttp = Params&&Params.http ? Params.http : 0;
    this.http = Params&&Params.http ? Params.http : "";

    this.isHttps = Params&&Params.isHttps ? Params.isHttps : 0;
}

function SearchRulesModel(Params)
{
    this.rule_id = Params&&Params.rule_id ? Params.rule_id : null;
    this.rule_type_mode = Params&&Params.rule_type_mode ? Params.rule_type_mode : null;
    this.rule_type_id = Params&&Params.rule_type_id ? Params.rule_type_id : null;
}

function UlrWebRuleResourceValidationResultModel(Params)
{
    var __this = this;

    this.https = {
        url:{value:"", valid:0},
        cn:{value:"", valid:0},
        sni:{value:"", valid:0},

        cns:[],
        snis:[]
    };

    this.https_with_www = {
        url:{value:"", valid:0},
        cn:{value:"", valid:0},
        sni:{value:"", valid:0},

        cns:[],
        snis:[]
    };

    this.http = {
        url:{value:"", valid:0}
    };

    this.http_with_www = {
        url:{value:"", valid:0}
    };

    this.http_with_path = {
        url:{value:"", valid:0}
    };

    this.http_with_www_path = {
        url:{value:"", valid:0}
    };

    if(Params)
    {
        Object.keys(Params).forEach(function (Key)
        {
            if(__this[Key])
            {
                if(Params[Key].url)
                {
                    __this[Key].url = webix.extend(__this[Key].url, Params[Key].url, true);
                }

                if(Params[Key].cn)
                {
                    __this[Key].cn = webix.extend(__this[Key].cn, new UlrCheckDomainCnSniModel(Params[Key].cn), true);
                }

                if(Params[Key].sni)
                {
                    __this[Key].sni = webix.extend(__this[Key].sni, new UlrCheckDomainCnSniModel(Params[Key].sni), true);
                }
            }
        });
    }

    function FillCNs(Key)
    {
        __this[Key].cns = [];

        if(__this[Key].cn && __this[Key].cn.value && __this[Key].cn.valid)
        {
            var cn = __this[Key].cn.value.replace("*.","");

            __this[Key].cns.push(new UlrCheckDomainCnSniModel({value:cn, valid:1}));
            __this[Key].cns.push(new UlrCheckDomainCnSniModel({value:"*."+cn, valid:1}));
        }
    }

    function FillSNIs(Key)
    {
        __this[Key].snis = [];

        if(__this[Key].sni && __this[Key].sni.value && __this[Key].sni.valid)
        {
            var sni =  __this[Key].sni.value.replace("*.","");

            if(sni.charAt(0) === ".")
                sni = sni.substring(1);

            __this[Key].snis.push(new UlrCheckDomainCnSniModel({value:sni, valid:1}));
            __this[Key].snis.push(new UlrCheckDomainCnSniModel({value:"*."+sni, valid:1}));
        }
        else if(__this[Key].cn && __this[Key].cn.value && __this[Key].cn.valid)
        {
            var cn =  __this[Key].cn.value.replace("*.","");

            __this[Key].snis.push(new UlrCheckDomainCnSniModel({value:cn, valid:1}));
            __this[Key].snis.push(new UlrCheckDomainCnSniModel({value:"*."+cn, valid:1}));
        }
    }

    FillCNs("https");

    FillCNs("https_with_www");

    FillSNIs("https");

    FillSNIs("https_with_www");
}

function UlrWebIpFilterRulesManager()
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        RuleProfileUpdated: new Rx.BehaviorSubject(null),
        RuleProfileError: new Rx.BehaviorSubject(null),
        RuleProfileSaved: new Rx.BehaviorSubject(null),
        RuleProfileSaveError: new Rx.BehaviorSubject(null),
        RuleEnableStateUpdated: new Rx.BehaviorSubject(null),
        RuleEnableStateError: new Rx.BehaviorSubject(null),
        RuleProfileDeleted: new Rx.BehaviorSubject(null),
        RuleProfileDeleteError: new Rx.BehaviorSubject(null),

        WebRuleResourceValidationProgress: new Rx.BehaviorSubject(0),
        WebRuleResourceValidated: new Rx.BehaviorSubject(null),
        WebRuleResourceValidatedError: new Rx.BehaviorSubject(null),

        GlobalWhitelistState:new Rx.BehaviorSubject(0),
        GlobalWhitelistStateError:new Rx.BehaviorSubject(null),
        GlobalWhitelistStateSaved:new Rx.BehaviorSubject(null),
        GlobalWhitelistStateSaveError:new Rx.BehaviorSubject(null),

        IspWhitelistStateSaved:new Rx.BehaviorSubject(null),
        IspWhitelistStateSaveError:new Rx.BehaviorSubject(null),

        SearchRulesByRawResourceDone: new Rx.BehaviorSubject(null),
        SearchRulesByRawResourceError: new Rx.BehaviorSubject(null)
    };

}

UlrWebIpFilterRulesManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrWebIpFilterRulesManager.prototype.ResfreshWebRuleProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var ruleId = Params&&Params._id ? Params._id : 0;

    var defaultTypeId = Params&&Params.type_id ? Params.type_id : null;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetWebRuleById",
            data: {Id:ruleId, DefaultTypeId:defaultTypeId},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrWebRuleViewModel(R.data);
                    model.profile = new UlrWebRuleModel(model.profile);

                    Object.keys(model.dics).forEach(function (Key)
                    {
                        if(Key === DicsEnum.UlrIspsDic || Key === DicsEnum.UlrSubscribersDic)
                        {
                            App.DicsManager.SetDic(Key, model.dics[Key], UlrIspSubsDicModel);
                        }
                        else
                            App.DicsManager.SetDic(Key, model.dics[Key]);
                    });

                    _this.Signals.RuleProfileUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleProfileError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrWebIpFilterRulesManager.prototype.SaveWebRuleProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveWebRule",
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrWebRuleViewModel(R.data);

                    _this.Signals.RuleProfileSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleProfileSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrWebIpFilterRulesManager.prototype.ValidateWebRuleResource = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    this.Signals.WebRuleResourceValidationProgress.next(1);

    var params =
        {
            id: webix.uid(),
            method:"CheckDomainInfo",
            data: {Resource:Params.resource},
            callback:function (R)
            {
                _this.Signals.WebRuleResourceValidationProgress.next(0);

                if(!_this.Active)
                    return;

                if(R.success)
                {
                    var model = new UlrWebRuleResourceValidationResultModel(R.data);

                    _this.Signals.WebRuleResourceValidated.next(model);

                    if(Params && Params.callback && typeof Params.callback === "function")
                    {
                        Params.callback(model);
                    }
                }
                else if(!R.success && R.error)
                    _this.Signals.WebRuleResourceValidatedError.next(R.error);
            }
        };

    App.ServerManager.CallMethod(params);
};

UlrWebIpFilterRulesManager.prototype.EnableDisableWebRule = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableWebRule" : "UlrDisableWebRule";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrWebRuleModel(R.data);

                    _this.Signals.RuleEnableStateUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrWebIpFilterRulesManager.prototype.DeleteWebRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var model = Params&&Params.profile ? Params.profile : Params;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteWebRule",
            data: {Rule:model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrWebRuleModel(R.data);

                    _this.Signals.RuleProfileDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleProfileDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrWebIpFilterRulesManager.prototype.ResfreshGlobalWhiteListState = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetGlobalWhiteListState",
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.GlobalWhitelistState.next(R.data.state ? 1 : 0);
                }
                else if(!R.success && R.error)
                    _this.Signals.GlobalWhitelistStateError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrWebIpFilterRulesManager.prototype.SaveGlobalWhiteListState = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var state = Params&&Params.state ? 1 : 0;

    var params =
        {
            id: webix.uid(),
            method:"UlrSetGlobalWhiteListState",
            data:{State:state},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.GlobalWhitelistStateSaved.next(R.data.state ? 1 : 0);
                }
                else if(!R.success && R.error)
                {
                    _this.Signals.GlobalWhitelistStateSaveError.next(new ServerErrorModel(R.error));
                    _this.Signals.GlobalWhitelistState.next(state ? 0 : 1);
                }


                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};


UlrWebIpFilterRulesManager.prototype.UlrChangeIspWhiteListState = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrChangeIspWhiteListState",
            data: {Isp:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspViewModel(R.data);

                    _this.Signals.IspWhitelistStateSaved.next(model.profile);
                }
                else if(!R.success && R.error)
                    _this.Signals.IspWhitelistStateSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrWebIpFilterRulesManager.prototype.SearchRulesByRawResource = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    if(!Params || !Params.resource_raw)
        return;

    var params =
        {
            id: webix.uid(),
            method:"SearchRulesByRawResource",
            data: {Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    let models = [];
                    for (let item of R.data){
                        models.push(new SearchRulesModel(item));
                    }

                    _this.Signals.SearchRulesByRawResourceDone.next(models);
                }
                else if(!R.success && R.error)
                    _this.Signals.SearchRulesByRawResourceError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrWebIpFilterRulesManager.prototype.GetWebIpRuleExportFileData = function(Params, Callback)
{
    var _this = this;

    if(!this.Active)
        return;

    var params = {
        method: "UlrGetWebIpRuleExportFileData",
        data: {
            Params: Params
        },
        callback: function(R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                App.ServerManager.DownloadFileFromLocalUrl(`/ulr_export_file/${R.data.filename}`);
            }
            else
            {
                webix.message({type:"error", text:R.error.msg});
            }

            if(Callback && typeof Callback === 'function')
            {
                Callback(R);
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

UlrWebIpFilterRulesManager.prototype.EnableDisableRules = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params = {
        id: webix.uid(),
        method: "UlrEnableDisableWebRules",
        data: {
            Rules: Params.rules
        },
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrWebIpFilterRulesManager.prototype.GetImportTemplateFile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params = {
        id: webix.uid(),
        method: "GetUlrWebRulesImportTemplateFile",
        data: {
            FormatList: Params.FormatList,
            FormatFile: Params.FormatFile
        },
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
function UlrExcludedResourcesManager()
{
    this.Active = true;

    this.RuleModel = null;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        SaveExcludedResourcesSuccess: new Rx.BehaviorSubject(null),
        SaveExcludedResourcesError: new Rx.BehaviorSubject(null),

        UpdateExcludedResourceSuccess: new Rx.BehaviorSubject(null),
        UpdateExcludedResourceError: new Rx.BehaviorSubject(null),

        DeleteExcludedResourceSuccess: new Rx.BehaviorSubject(null),
        DeleteExcludedResourceError: new Rx.BehaviorSubject(null),

        DeleteAllExcludedResourceSuccess: new Rx.BehaviorSubject(null),
        DeleteAllExcludedResourceError: new Rx.BehaviorSubject(null),

        ParseImportFileDone: new Rx.BehaviorSubject(null),
        ParseImportFileError: new Rx.BehaviorSubject(null),

        ServerError: new Rx.BehaviorSubject(null)
    };
};

UlrExcludedResourcesManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrExcludedResourcesManager.prototype.SaveResources = function(Resources)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveJustAddedExcludedResources",
            data: {Resources:Resources},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.SaveExcludedResourcesSuccess.next(1);
                }
                else if(!R.success && R.error)
                {
                    _this.Signals.SaveExcludedResourcesError.next(1);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrExcludedResourcesManager.prototype.UpdateResource = function(Resource)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrUpdateExcludedResource",
            data: {Resource:Resource},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.UpdateExcludedResourceSuccess.next(1);
                }
                else if(!R.success && R.error)
                {
                    _this.Signals.UpdateExcludedResourceError.next(R.error);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrExcludedResourcesManager.prototype.DeleteResource = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteExcludedResource",
            data: {Resource:Params.data},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DeleteExcludedResourceSuccess.next(1);
                }
                else if(!R.success && R.error)
                {
                    _this.Signals.DeleteExcludedResourceError.next(R.error);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrExcludedResourcesManager.prototype.DeleteAllResources = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteAllExcludedResources",
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DeleteAllExcludedResourceSuccess.next(1);
                }
                else if(!R.success && R.error)
                {
                    _this.Signals.DeleteAllExcludedResourceError.next(1);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrExcludedResourcesManager.prototype.SaveResourcesFromFiles = function(Data)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveExcludedResourcesFromFiles",
            data: {Data:Data},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success && R.data)
                {
                    R.data.forEach((item) => {
                        if (item.result && item.result.success)
                        {
                            UlrShowMessage(
                                "success",
                                LangHelper.GetString("UlrModule","Success"),
                                LangHelper.GetString("UlrModule","File [FILE] successfully imported.".replace(
                                    "[FILE]", (item.file_data && item.file_data.name ? item.file_data.name : ""))),
                            );
                        } else {

                            if (item.file_data)
                                _this.Signals.ParseImportFileError.next(item.file_data);

                            UlrShowMessage(
                                "error",
                                LangHelper.GetString("UlrModule","Error"),
                                LangHelper.GetString("UlrModule","File [FILE] not imported.".replace(
                                    "[FILE]", (item.file_data && item.file_data.name ? item.file_data.name : ""))),
                            );
                        }
                    })
                    _this.Signals.ParseImportFileDone.next(1);
                }
                else if(!R.success && R.error)
                {
                    _this.Signals.ServerError.next(R.error);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);

};

UlrExcludedResourcesManager.prototype.GetExcludedResourcesExportFileData = function(Params, Callback)
{
    var _this = this;

    if(!this.Active)
        return;

    var params = {
        method: "UlrGetExcludedResourcesExportFileData",
        data: {
            Params: Params
        },
        callback: function(R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                App.ServerManager.DownloadFileFromLocalUrl(`/ulr_export_file/${R.data.filename}`);
            }
            else
            {
                webix.message({type:"error", text:R.error.msg});
            }

            if(Callback && typeof Callback === 'function')
            {
                Callback(R);
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

function UlrSubscribersRulesManager(Params)
{
    this.Active = true;

    this.Methods = Params && Params.Methods ? Params.Methods : {
        SaveRule: "UlrSaveVipSubscriberRule",
        DeleteRule: "UlrDeleteVipSubscriberRule",
        EnableRule: "UlrEnableVipSubscriberRule",
        DisableRule: "UlrDisableVipSubscriberRule"
    }

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        RuleProfileUpdated: new Rx.BehaviorSubject(null),
        RuleProfileError: new Rx.BehaviorSubject(null),
        RuleProfileSaved: new Rx.BehaviorSubject(null),
        RuleProfileSaveError: new Rx.BehaviorSubject(null),
        RuleEnableStateUpdated: new Rx.BehaviorSubject(null),
        RuleEnableStateError: new Rx.BehaviorSubject(null),
        RuleProfileDeleted: new Rx.BehaviorSubject(null),
        RuleProfileDeleteError: new Rx.BehaviorSubject(null)
    };
}

UlrSubscribersRulesManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrSubscribersRulesManager.prototype.SaveRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method: _this.Methods.SaveRule,
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = R.data;

                    _this.Signals.RuleProfileSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleProfileSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrSubscribersRulesManager.prototype.DeleteRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var model = Params&&Params.profile ? Params.profile : Params;

    var params =
        {
            id: webix.uid(),
            method:_this.Methods.DeleteRule,
            data: {Rule:model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = R.data;

                    _this.Signals.RuleProfileDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleProfileDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrSubscribersRulesManager.prototype.EnableDisableRule = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? _this.Methods.EnableRule : _this.Methods.DisableRule;

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = R.data;

                    _this.Signals.RuleEnableStateUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

const UlrAsnRuleListTypes = {
    "global": {"value": LangHelper.GetString("UlrModule", "Global"), "id": "1"},
    "isps": {"value": LangHelper.GetString("UlrModule", "Channels"), "id": "2"}
};

function UlrASModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.rule_id = Params&&Params.rule_id ? Params.rule_id : 0;
    this.enabled = Params&&Params.enabled ? Params.enabled : 0;
    this.as_number = Params&&Params.as_number ? Params.as_number : 0;
    this.name = Params&&Params.name ? Params.name : null;
    this.description_public = Params&&Params.description_public ? Params.description_public.trim() : null;
    this.mode = Params&&Params.mode ? Params.mode : null;
    this.mode_id = Params&&Params.mode_id ? Params.mode_id : 0;
    this.isps = Params&&Params.isps ? Params.isps : '';
    this.update_time = Params&&Params.update_time ? Params.update_time : null;
    this.create_time = Params&&Params.create_time ? Params.create_time : null;
}

function UlrASResourceModel(Params)
{
    this._id = Params && Params._id ? parseInt(Params._id) : 0;
    this.rule_id = Params&&Params.rule_id?Params.rule_id:null;
    this.enabled = Params&&Params.hasOwnProperty('enabled')?Params.enabled:1;
    this.resource = Params&&Params.resource?Params.resource:null;
    this.type_id = Params && Params.type_id ? Params.type_id : null;
    this.bgp_diff_autoapply = Params && Params.hasOwnProperty("bgp_diff_autoapply") ? parseInt(Params.bgp_diff_autoapply) : 1;
    this.bgp_send_notification = Params && Params.bgp_send_notification ? Params.bgp_send_notification : "";
    this.protocol_version = Params && Params.protocol_version && UlrIpProtocolVersionDic[Params.protocol_version] ? Params.protocol_version : UlrIpProtocolVersionDic.BOTH.id;

}

function UlrASDSCPModel(Params)
{
    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.priority = Params&&Params.priority?Params.priority:null;
}

function UlrASViewModel(Params)
{
    this.profile = Params&&Params.profile ? Params.profile : null;
    this.dics = Params && Params.dics ? Params.dics : {};
    this.insert_stat = new IspInsertStatModel(Params && Params.insert_stat ? Params.insert_stat : null);
}

function UlrEditAsnDscpRuleManager()
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        ASProfileUpdated: new Rx.BehaviorSubject(null),
        ASProfileUpdateError: new Rx.BehaviorSubject(null),
        ASProfileError: new Rx.BehaviorSubject(null),
        ASProfileSaved: new Rx.BehaviorSubject(null),
        ASProfileSaveError: new Rx.BehaviorSubject(null),
        ASProfileDeleted: new Rx.BehaviorSubject(null),
        ASProfileDeleteError: new Rx.BehaviorSubject(null)
    };
}

UlrEditAsnDscpRuleManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrEditAsnDscpRuleManager.prototype.RefreshASProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var Id = Params&&Params._id ? Params._id : 0;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetASById",
            data: {Id},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    let model = new UlrASViewModel(R.data);
                    model.profile = new UlrASModel(model.profile);

                    Object.keys(model.dics).forEach(function (Key)
                    {
                        if(Key === DicsEnum.UlrIspsDic)
                        {
                            App.DicsManager.SetDic(Key, model.dics[Key], UlrIspSubsDicModel);
                        }
                        else
                            App.DicsManager.SetDic(Key, model.dics[Key]);
                    });

                    _this.Signals.ASProfileUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ASProfileUpdateError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrEditAsnDscpRuleManager.prototype.SaveASProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveAS",
            data: {AS:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrASViewModel(R.data);

                    _this.Signals.ASProfileSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ASProfileSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrEditAsnDscpRuleManager.prototype.DeleteAS = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var model = Params&&Params.profile ? Params.profile : Params;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteAS",
            data: {AS:model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrASModel(R.data);

                    _this.Signals.ASProfileDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ASProfileDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
function UlrCheckDomainCnSniModel(Params)
{
    this.value = Params&&Params.value ? Params.value : "";
    this.valid = Params&&Params.valid ? Params.valid : 0;
}

function UlrCheckDomainDnsModel(Params)
{
    this.host = Params&&Params.host ? Params.host : "";
    this.class = Params&&Params.class ? Params.class : "";
    this.ttl = Params&&Params.ttl ? Params.ttl : 0;
    this.type = Params&&Params.type ? Params.type : "";
    this.addr = Params&&Params.addr ? Params.addr : "";
}

function UlrCheckDomainSanModel(Params)
{
    this.type = Params&&Params.type ? Params.type : "";
    this.val = Params&&Params.val ? Params.val : "";
}

function UlrCheckDomainModel(Params)
{
    this.resource_raw = Params&&Params.resource_raw ? Params.resource_raw : 0;
    this.valid = Params&&Params.valid ? Params.valid : 0;
    this.host = Params&&Params.host ? Params.host : "";
    this.ssl = Params&&Params.ssl ? Params.ssl : 0;
    this.sans = function ()
    {
        var arr = [];

        Params && Params.sans && Array.isArray(Params.sans)  && Params.sans.length
        {
            Params.sans.forEach(function (Item)
            {
                arr.push(new UlrCheckDomainSanModel(Item));
            });
        }

        return arr;
    }();
    this.algorithm = Params&&Params.algorithm ? Params.algorithm : "";
    this.key_type = Params&&Params.key_type ? Params.key_type : "";
    this.key_size = Params&&Params.key_size ? Params.key_size : "";
    this.serial_number = Params&&Params.serial_number ? Params.serial_number : "";
    this.not_before = Params&&Params.not_before ? Params.not_before : "";
    this.not_after = Params&&Params.not_after ? Params.not_after : "";
    this.cert_num = Params&&Params.cert_num ? Params.cert_num : 0;
    this.dns_part = function ()
    {
        var arr = [];

        Params && Params.dns_part && Array.isArray(Params.dns_part)  && Params.dns_part.length
        {
            Params.dns_part.forEach(function (Item)
            {
                arr.push(new UlrCheckDomainDnsModel(Item));
            });
        }

        return arr;
    }();
    this.dns_recursive = Params&&Params.dns_recursive ? Params.dns_recursive : 0;
    this.cn = Params&&Params.cn ? new UlrCheckDomainCnSniModel(Params.cn) : null;
    this.sni = Params&&Params.sni ? new UlrCheckDomainCnSniModel(Params.sni) : null;

    this.cns = [];
    if(this.cn && this.cn.value && this.cn.valid)
    {
        var cn =  this.cn.value.replace("*.", "");

        this.cns.push(new UlrCheckDomainCnSniModel({value:cn, valid:1}));
        this.cns.push(new UlrCheckDomainCnSniModel({value:"*."+cn, valid:1}));
    }

    this.snis = [];
    if(this.sni && this.sni.value && this.sni.valid)
    {
        var sni =  this.sni.value.replace("*.", "");

        if(sni.charAt(0) === ".")
            sni = sni.substring(1);

        this.snis.push(new UlrCheckDomainCnSniModel({value:sni, valid:1}));
        this.snis.push(new UlrCheckDomainCnSniModel({value:"*."+sni, valid:1}));
    }
    else if(this.cn && this.cn.value && this.cn.valid)
    {
        var cn =  this.cn.value.replace("*.", "");

        this.snis.push(new UlrCheckDomainCnSniModel({value:cn, valid:1}));
        this.snis.push(new UlrCheckDomainCnSniModel({value:"*."+cn, valid:1}));
    }
    this.urls = Params&&Params.urls ? Params.urls : [];
}

function UlrCheckDomainManager()
{
    this.Active = true;

    this.Signals =
    {
        Progress: new Rx.BehaviorSubject(0),
        CheckResultUpdated: new Rx.BehaviorSubject(null),
        CheckResultError: new Rx.BehaviorSubject(null)
    };
}

UlrCheckDomainManager.prototype.Destroy = function (Params)
{
    this.Active = false;
};

UlrCheckDomainManager.prototype.GetDomainInfo = function (Params)
{
    var _this = this;

    if (!this.Active)
        return;

    var params = {
        id: webix.uid(),
        method: "CheckDomainFullInfo",
        data: {Resource: Params.resource},
        callback: function (R)
        {
            if (!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if (R.success)
            {
                var model = new UlrCheckDomainModel(R.data);

                model.resource_raw = Params.resource;

                _this.Signals.CheckResultUpdated.next(model);

                if (Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R.data);
                }

            }
            else if(!R.success && R.error)
                _this.Signals.CheckResultError.next(new ServerErrorModel(R.error));

        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);

};

function UlrCheckResourcesIntersectionItemModel(Params)
{
    this.rowsCount = Params&&Params.rowsCount ? Params.rowsCount : 0;
    this.intersectionCount = Params&&Params.intersectionCount ? Params.intersectionCount : 0;
    this.intersectionUrl = Params&&Params.intersectionUrl ? Params.intersectionUrl : '';
    this.intersectionRows = Params&&Params.intersectionRows ? Params.intersectionRows : [];
}

function UlrCheckResourcesIntersectionAllProtocolsItemModel(Params)
{
    this.cloud_protocols = Params&&Params.cloud_protocols ? new UlrCheckResourcesIntersectionItemModel(Params.cloud_protocols) : new UlrCheckResourcesIntersectionItemModel();
    this.custom_protocols = Params&&Params.custom_protocols ? new UlrCheckResourcesIntersectionItemModel(Params.custom_protocols) : new UlrCheckResourcesIntersectionItemModel();
    this.custom_prtocols_asn = Params&&Params.custom_prtocols_asn ? new UlrCheckResourcesIntersectionItemModel(Params.custom_prtocols_asn) : new UlrCheckResourcesIntersectionItemModel();
}


function UlrCheckResourcesIntersectionManager()
{
    this.Active = true;

    this.Signals =
        {
            Progress: new Rx.BehaviorSubject(0)
        };
}

UlrCheckResourcesIntersectionManager.prototype.Destroy = function (Params)
{
    this.Active = false;
};

UlrCheckResourcesIntersectionManager.prototype.GetInfoResourceIntersection = function (Params)
{
    var _this = this;

    if (!this.Active)
        return;

    var params = {
        id: webix.uid(),
        method: "CheckResourcesItemsIntersection",
        data: {
            Items: Params.Items,
            SectionCheck: true
        },
        callback: function (R)
        {
            if (!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if (Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);

};

UlrCheckResourcesIntersectionManager.prototype.GetInfoResourceAllProtocolsIntersection = function (Params)
{
    var _this = this;

    if (!this.Active)
        return;

    var params = {
        id: webix.uid(),
        method: "CheckResourcesItemsAllProtocolsIntersection",
        data: {
            Items: Params.Items,
            SectionCheck: true
        },
        callback: function (R)
        {
            if (!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success)
            {
                R.data = new UlrCheckResourcesIntersectionAllProtocolsItemModel(R.data);
            }

            if (Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);

};

function UlrCustomGroupsProtocolModel(Params)
{
    this._id = Params && Params._id ? Params._id : 0;
    this.custom_group_id = Params && Params.custom_group_id ? Params.custom_group_id : 0;
    this.prtcl_name = Params && Params.prtcl_name ? Params.prtcl_name : 0;
    this.create_time = Params && Params.create_time ? Params.create_time : "";
    this.update_time = Params && Params.update_time ? Params.update_time : "";
    this.create_user = Params && Params.create_user ? Params.create_user : "";
    this.update_user = Params && Params.update_user ? Params.update_user : "";
};

function UlrCustomGroupsProtocolViewModel(Params)
{
    this._id = Params && Params._id ? Params._id : 0;
    this.name = Params && Params.name ? Params.name : "";
    this.group_id = Params && Params.group_id ? Params.group_id : 0;
    this.group_name_json = Params && Params.group_name_json ? Params.group_name_json : "{}";
    this.full_text_search = Params && Params.full_text_search ? Params.full_text_search : "";
};

function UlrCustomGroupModel(Params)
{
    this.id = Params && Params.id ? Params.id : 0;

    this._id = Params && Params._id ? Params._id : 0;
    this.name = Params && Params.name ? Params.name : "";
    this.create_time = Params && Params.create_time ? Params.create_time : "";
    this.update_time = Params && Params.update_time ? Params.update_time : "";
    this.create_user = Params && Params.create_user ? Params.create_user : "";
    this.update_user = Params && Params.update_user ? Params.update_user : "";

    this.group_protocols = Params && Params.group_protocols ? Params.group_protocols.map(item => new UlrCustomGroupsProtocolModel(item)) : [];
    this.view_protocols = Params && Params.view_protocols ? Params.view_protocols.map(item => new UlrCustomGroupsProtocolViewModel(item)) : [];
};

UlrCustomGroupModel.prototype.IsChanged = function()
{
    let oldProtocolsNames = this.group_protocols.map(model => model.prtcl_name);
    let newProtocolsNames = this.view_protocols.map(model => model.name);

    let addedNames = this.view_protocols.filter(model => !oldProtocolsNames.includes(model.name)).map(model => model.name);
    let deletedNames = this.group_protocols.filter(model => !newProtocolsNames.includes(model.prtcl_name)).map(model => model.prtcl_name);

    return addedNames.length || deletedNames.length ? true : false;
};

function UlrCustomGroupsOfProtocolsManager(Params)
{
    this.Active = true;

    this.Signals =
        {
            Progress: new Rx.BehaviorSubject(0),

            SaveCustomGroupSuccess: new Rx.BehaviorSubject(null),
            SaveCustomGroupError: new Rx.BehaviorSubject(null),

            DeleteCustomGroupSuccess: new Rx.BehaviorSubject(null),
            DeleteCustomGroupError: new Rx.BehaviorSubject(null),

            GetProtocolsByCustomGroupSuccess: new Rx.BehaviorSubject(null),
            GetProtocolsByCustomGroupError: new Rx.BehaviorSubject(null),

            ServerError: new Rx.BehaviorSubject(null)
        };
};

UlrCustomGroupsOfProtocolsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrCustomGroupsOfProtocolsManager.prototype.SaveCustomGroup = function(GroupModel)
{
    let _this = this;

    if(!this.Active)
        return;

    let params = {
        id: webix.uid(),
        method:"UlrCustomGroupsSaveCustomGroup",
        data: {Params: GroupModel},
        callback:function (R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success && R.data)
            {
                let model = new UlrCustomGroupModel(webix.extend(GroupModel, R.data, true));
                _this.Signals.SaveCustomGroupSuccess.next(model);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.SaveCustomGroupError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrCustomGroupsOfProtocolsManager.prototype.DeleteCustomGroup = function(GroupModel)
{
    let _this = this;

    if(!this.Active)
        return;

    let params = {
        id: webix.uid(),
        method:"UlrCustomGroupsDeleteGroup",
        data: {Params: GroupModel},
        callback:function (R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success && R.data)
            {
                _this.Signals.DeleteCustomGroupSuccess.next(GroupModel);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.DeleteCustomGroupError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrCustomGroupsOfProtocolsManager.prototype.GetProtocolsByCustomGroup = function(GroupModel)
{
    let _this = this;

    if(!this.Active)
        return;

    let params = {
        id: webix.uid(),
        method:"UlrCustomGroupsGetProtocolsByGroup",
        data: {Params:GroupModel},
        callback:function (R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success && R.data)
            {
                let model = new UlrCustomGroupModel(webix.extend(GroupModel, R.data, true));
                _this.Signals.GetProtocolsByCustomGroupSuccess.next(model);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.GetProtocolsByCustomGroupError.next(R.error);
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    }

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
var UlrIspNetworkLearningEnum =
    {
        manual:0,
        only_auto: 1,
        manual_auto:2
    };

var UlrIspNetworkCreateTypesEnum =
    {
        manual:0,
        auto: 1
    };

function UlrIspModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.igw_id = Params&&Params.igw_id?Params.igw_id:null;
    this.igw_name = Params&&Params.igw_name?Params.igw_name:null;
    this.name = Params&&Params.name?Params.name:"";
    this.network_learning = Params&&Params.network_learning?Params.network_learning:0;
    this.enabled = Params && Params.hasOwnProperty('enabled') ? Params.enabled : 1;
    this.state_running = Params&&Params.state_running?Params.state_running:1;
    this.state_error = Params&&Params.state_error?Params.state_error:0;
    this.state = Params&&Params.state?Params.state:"";
    this.login = Params&&Params.login?Params.login:"";
    this.prefix = Params&&Params.prefix?Params.prefix:"";
    this.type = Params&&Params.type?Params.type:"";
    this.federal_bl = Params && Params.hasOwnProperty('federal_bl') ? parseInt(Params.federal_bl) : 1;
    this.web_rule_exclude = Params && Params.hasOwnProperty('web_rule_exclude') ? parseInt(Params.web_rule_exclude) : 1;
    this.block_ipv6 = Params && Params.hasOwnProperty('block_ipv6') ? parseInt(Params.block_ipv6) : 0;
    this.spoof_dns = Params && Params.hasOwnProperty('spoof_dns') ? parseInt(Params.spoof_dns) : 0;
    this.white_list_enabled = Params && Params.hasOwnProperty('white_list_enabled') ? parseInt(Params.white_list_enabled) : 0;
    this.vchannel_number = Params && Params.hasOwnProperty('vchannel_number') ? parseInt(Params.vchannel_number) : null;
}

function IspInsertStatModel(Params)
{
    this.total = Params && Params.total ? parseInt(Params.total) : 0;
    this.inserted = Params && Params.inserted ? parseInt(Params.inserted) : 0;
    this.duplicate = Params && Params.duplicate ? parseInt(Params.duplicate) : 0;
    this.duplicate_url = Params && Params.duplicate_url ? Params.duplicate_url : '';
}

function UlrIspViewModel(Params)
{
    this.profile = Params&&Params.profile ? Params.profile : null;
    this.networks = Params&&Params.networks ? Params.networks : null;
    this.bridges = Params&&Params.bridges ? Params.bridges : null;
    this.vchannels = Params && Params.vchannels ? Params.vchannels : null;
    this.min_vchannel = Params && Params.min_vchannel ? Params.min_vchannel : null;
    this.dics = Params&&Params.dics ? Params.dics : 0;
    this.insert_stat = new IspInsertStatModel(Params && Params.insert_stat ? Params.insert_stat : null);
}

function UlrNodesDicDic(Params)
{
    var __this = this;

    this.id = Params&&Params.dic_id?Params.dic_id:0;
    this.dic_id = Params&&Params.dic_id?Params.dic_id:0;
    this.value = Params&&Params.value?Params.value:"";

    this.UlrBridgesDic = null;

    if(Params&&Params.UlrBridgesDic)
    {
        this.UlrBridgesDic = {};

        Object.keys(Params.UlrBridgesDic).forEach(function (Key)
        {
            __this.UlrBridgesDic[Key] = new DicModel(Params.UlrBridgesDic[Key]);
        });
    }
}

function UlrIgwsDicModel(Params)
{
    var __this = this;

    this.id = Params&&Params.dic_id?Params.dic_id:0;
    this.dic_id = Params&&Params.dic_id?Params.dic_id:0;
    this.value = Params&&Params.value?Params.value:"";

    this.UlrNodesDic = null;

    if(Params&&Params.UlrNodesDic)
    {
        this.UlrNodesDic = {};

        Object.keys(Params.UlrNodesDic).forEach(function (Key)
        {
            __this.UlrNodesDic[Key] = new UlrNodesDicDic(Params.UlrNodesDic[Key]);
        });
    }
}

function UlrIspNetworkModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.isp_id = Params&&Params.isp_id?Params.isp_id:null;
    this.cidr_ipv4 = Params&&Params.cidr_ipv4?Params.cidr_ipv4:null;
    this.cidr_ipv6 = Params&&Params.cidr_ipv6?Params.cidr_ipv6:null;
    this.create_type = Params&&Params.create_type?Params.create_type:0;
    this.description = Params&&Params.description?Params.description:"";
    this.enabled = Params&&Params.enabled?parseInt(Params.enabled):0;
    this.state_bind = Params&&Params.state_bind?parseInt(Params.state_bind):0;
    this.state_valid = Params&&Params.state_valid?parseInt(Params.state_valid):0;
    this.state = Params&&Params.state?Params.state:"";

    this.is_added = Params&&Params.is_added ? Params.is_added : 0;
    this.is_deleted = Params&&Params.is_deleted ? Params.is_deleted : 0;
    this.is_modified = Params&&Params.is_modified ? Params.is_modified : 0;
    this.regex = Params&&Params.regex ? Params.regex : "";
    this.type_id = Params&&Params.type_id ? Params.type_id : "";
    this.bgp_diff_autoapply = Params && Params.hasOwnProperty("bgp_diff_autoapply") ? parseInt(Params.bgp_diff_autoapply) : 1;
    this.bgp_send_notification = Params && Params.bgp_send_notification ? Params.bgp_send_notification : "";
    this.protocol_version = Params && Params.protocol_version && UlrIpProtocolVersionDic[Params.protocol_version] ? Params.protocol_version : UlrIpProtocolVersionDic.BOTH.id;
}

function UlrIspsManager(Params)
{
    this.Active = true;

    this.FreeVchannels = null;
    this.MinVchannel = null;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        IspProfileUpdated: new Rx.BehaviorSubject(null),
        IspProfileError: new Rx.BehaviorSubject(null),
        IspProfileSaved: new Rx.BehaviorSubject(null),
        IspProfileSaveError: new Rx.BehaviorSubject(null),
        IspProfileDeleted: new Rx.BehaviorSubject(null),
        IspProfileDeleteError: new Rx.BehaviorSubject(null),

        IspProfileEnableStateUpdated: new Rx.BehaviorSubject(null),
        IspProfileEnableStateError: new Rx.BehaviorSubject(null),

        FreeVchannelsUpdated: new Rx.BehaviorSubject(null),
        MinVchannelsUpdated: new Rx.BehaviorSubject(null),

        SessionPolicingProfileEnableStateUpdated: new Rx.BehaviorSubject(null),
        SessionPolicingProfileEnableStateError: new Rx.BehaviorSubject(null),

        PolicingProfileEnableStateUpdated: new Rx.BehaviorSubject(null),
        PolicingProfileEnableStateError: new Rx.BehaviorSubject(null),

        FederalListStateUpdated: new Rx.BehaviorSubject(null),
        FederalListStateError: new Rx.BehaviorSubject(null),

        ExcludedResourcesStateUpdated: new Rx.BehaviorSubject(null),
        ExcludedResourcesStateError: new Rx.BehaviorSubject(null),

        BlockIPv6StateUpdated: new Rx.BehaviorSubject(null),
        BlockIPv6StateError: new Rx.BehaviorSubject(null),

        SpoofDnsStateUpdated: new Rx.BehaviorSubject(null),
        SpoofDnsStateError: new Rx.BehaviorSubject(null),

        SessionPolicingScheduleStateUpdated: new Rx.BehaviorSubject(null),
        SessionPolicingScheduleStateError: new Rx.BehaviorSubject(null),

        SessionPolicingScheduleCleared: new Rx.BehaviorSubject(null),
        SessionPolicingScheduleClearError: new Rx.BehaviorSubject(null)
    };
}

UlrIspsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrIspsManager.prototype.ResfreshIspProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var id = Params&&Params._id ? Params._id : 0;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetIspProfileById",
            data: {Id:id},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspViewModel(R.data);
                    model.profile = new UlrIspModel(model.profile);

                    Object.keys(model.dics).forEach(function (Key)
                    {
                        App.DicsManager.SetDic(Key, model.dics[Key], (Key === DicsEnum.UlrIgwsDic ? UlrIgwsDicModel : null));
                    });

                    _this.FreeVchannels = model.vchannels;
                    _this.Signals.FreeVchannelsUpdated.next(1);
                    _this.MinVchannel = model.min_vchannel;
                    _this.Signals.MinVchannelsUpdated.next(1);

                    _this.Signals.IspProfileUpdated.next(model);

                    if(model.profile.igw_id)
                    {
                        _this.RefreshNodesDic(parseInt(model.profile.igw_id));
                    }
                }
                else if(!R.success && R.error)
                    _this.Signals.IspProfileError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.SaveIspProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveIsp",
            data: {Isp:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspViewModel(R.data);

                    _this.Signals.IspProfileSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.IspProfileSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.DeleteIspProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteIsp",
            data: {Isp:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspModel(R.data);

                    _this.Signals.IspProfileDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.IspProfileDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.EnableDisableIspProfile = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIsp" : "UlrDisableIsp";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Isp:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspViewModel(R.data);

                    _this.Signals.IspProfileEnableStateUpdated.next(model.profile);
                }
                else if(!R.success && R.error)
                    _this.Signals.IspProfileEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.EnableDisableSessionPolicingProfile = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIspSessionPolicing" : "UlrDisableIspSessionPolicing";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Policing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.SessionPolicingProfileEnableStateUpdated.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.SessionPolicingProfileEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.EnableDisableAppPolicingProfile = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIspPolicing" : "UlrDisableIspPolicing";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Policing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.PolicingProfileEnableStateUpdated.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.PolicingProfileEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.EnableDisableFederalLists = function(Params, Enable, Callback)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIspGlobalLists" : "UlrDisableIspGlobalLists";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Isp:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspViewModel(R.data);

                    _this.Signals.FederalListStateUpdated.next(model.profile);
                }
                else if(!R.success && R.error)
                    _this.Signals.FederalListStateError.next(R.error);

                if(Callback && typeof Callback === "function")
                {
                    Callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.EnableDisableExcludedResources = function(Params, Enable, Callback)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIspExcludedResources" : "UlrDisableIspExcludedResources";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Isp:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspViewModel(R.data);

                    _this.Signals.ExcludedResourcesStateUpdated.next(model.profile);
                }
                else if(!R.success && R.error)
                    _this.Signals.ExcludedResourcesStateError.next(R.error);

                if(Callback && typeof Callback === "function")
                {
                    Callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
}

UlrIspsManager.prototype.EnableDisableBlockIPv6 = function(Params, Enable, Callback)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIspBlockIPv6" : "UlrDisableIspBlockIPv6";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Isp:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspViewModel(R.data);

                    _this.Signals.BlockIPv6StateUpdated.next(model.profile);
                }
                else if(!R.success && R.error)
                    _this.Signals.BlockIPv6StateError.next(R.error);

                if(Callback && typeof Callback === "function")
                {
                    Callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.EnableDisableSpoofDns = function(Params, Enable, Callback)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIspSpoofDns" : "UlrDisableIspSpoofDns";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Isp:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspViewModel(R.data);

                    _this.Signals.SpoofDnsStateUpdated.next(model.profile);
                }
                else if(!R.success && R.error)
                    _this.Signals.SpoofDnsStateError.next(R.error);

                if(Callback && typeof Callback === "function")
                {
                    Callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.RefreshNodesDic = function(IgwId)
{
    var igwsDic = App.DicsManager.GetDic(DicsEnum.UlrIgwsDic);

    if(igwsDic&&igwsDic[IgwId])
    {
        var nodesDic = igwsDic[IgwId].UlrNodesDic;

        App.DicsManager.SetDic(DicsEnum.UlrNodesDic, nodesDic, UlrNodesDicDic);
    }
};

UlrIspsManager.prototype.IspNetworksArrToDic = function(NetArr)
{
    var dic = {};

    if(NetArr)
    {
        NetArr.forEach(function (IspNetworkModel)
        {
            dic[IspNetworkModel._id] = new UlrIspNetworkModel(IspNetworkModel);
        });
    }

    return dic;
};

UlrIspsManager.prototype.IspNetworksArrDicToArr = function(NetDic)
{
    var arr = [];

    if(NetDic)
    {
        Object.keys(NetDic).forEach(function (Key)
        {
            arr.push(NetDic[Key]);
        });
    }

    return arr;
};

UlrIspsManager.prototype.GetMinFreeVchannelNumber = function (Params) {
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetMinFreeVchannelNumber",
            data: {
                IgwId: Params.IgwId,
                IspId: Params.IspId
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
}

UlrIspsManager.prototype.GetFreeVchannelsNumber = function (Params) {
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetFreeVchannelsNumber",
            data: {
                IgwId: Params.IgwId,
                IspId: Params.IspId,
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
}

UlrIspsManager.prototype.EnableDisableSessionPolicingSchedule = function(Params, Enable, Callback)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIspSessionPolicingSchedule" : "UlrDisableIspSessionPolicingSchedule";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Policing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.SessionPolicingScheduleStateUpdated.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.SessionPolicingScheduleStateError.next(R.error);

                if(Callback && typeof Callback === "function")
                {
                    Callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspsManager.prototype.ClearSessionPolicingSchedule = function(Params, Callback)
{
    var _this = this;

    if (!this.Active)
        return;

    var params = {
        id: webix.uid(),
        method: "UlrClearIspSessionPolicingSchedule",
        data: {Policing: Params},
        callback: function (R) {
            if (!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if (R.success) {
                _this.Signals.SessionPolicingScheduleCleared.next(R.data);
            } else if (!R.success && R.error) {
                _this.Signals.SessionPolicingScheduleClearError.next(R.error);
            }

            if (Callback && typeof Callback === "function") {
                Callback(R);
            }
        }
    };

    if (this.Active) {
        App.ServerManager.CallMethod(params);
    }
};

UlrIspsManager.prototype.GetIspExportFileData = function(Params, Callback)
{
    var _this = this;

    if(!this.Active)
        return;

    var params = {
        method: "UlrIspRuleExportFileData",
        data: {
            Params: Params
        },
        callback: function(R)
        {
            if(!_this.Active)
                return;

            if(R.success)
            {
                App.ServerManager.DownloadFileFromLocalUrl(`/ulr_export_file/${R.data.filename}`);
            }
            else
            {
                webix.message({type: "error", text: R.error.msg});
            }

            if(Callback && typeof Callback === "function")
            {
                Callback(R);
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};
var UlrMaxNodesBridgesNum = 4;

function UlrIgwModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.name = Params&&Params.name?Params.name:"";
    this.mode_id = Params&&Params.mode_id?Params.mode_id:0;
    this.dpiui2_dest = Params&&Params.dpiui2_dest?Params.dpiui2_dest:"";

    this.vchannel_type = Params&&Params.vchannel_type?parseInt(Params.vchannel_type):1;
}

function UlrIspBridgeModel(Params)
{
    var __this = this;

    this._id = Params&&Params._id ? Params._id : 0;
    this.isp_id = Params&&Params.isp_id?Params.isp_id:0;
    this.bridge_id = Params&&Params.bridge_id?Params.bridge_id:0;

    this.is_added = Params&&Params.is_added ? Params.is_added : 0;
    this.is_deleted = Params&&Params.is_deleted ? Params.is_deleted : 0;
    this.is_modified = Params&&Params.is_modified ? Params.is_modified : 0;
}

function UlrIgwNodeBridgeModel(Params)
{
    var __this = this;

    this._id = Params&&Params._id ? Params._id : 0;
    this.node_id = Params&&Params.node_id?Params.node_id:0;

    this.isps_bridges = [];

    if(Params&&Params.isps_bridges)
    {
        Params.isps_bridges.forEach(function (Bridge)
        {
            __this.isps_bridges.push(new UlrIspBridgeModel(Bridge));
        });
    }

    this.removeable = 1;

    if(this.isps_bridges.length)
        this.removeable = 0;

    this.is_added = Params&&Params.is_added ? Params.is_added : 0;
    this.is_deleted = Params&&Params.is_deleted ? Params.is_deleted : 0;
    this.is_modified = Params&&Params.is_modified ? Params.is_modified : 0;
}

function UlrIgwNodeModel(Params)
{
    var __this = this;

    this._id = Params&&Params._id ? Params._id : 0;
    this.name = Params&&Params.name?Params.name:"";
    this.igw_id = Params&&Params.igw_id?Params.igw_id:0;
    this.hardware_id = Params&&Params.hardware_id?Params.hardware_id:null;

    this.enabled = Params&&Params.enabled ? Params.enabled : 0;
    this.ipfix_number = Params&&Params.ipfix_number ? Params.ipfix_number : null;

    this.bridges = [];
    this.bridgeNotRemoveableIndex = -1;

    if(Params&&Params.bridges)
    {
        Params.bridges.forEach(function (Bridge, Index)
        {
            var bridge = new UlrIgwNodeBridgeModel(Bridge);

            __this.bridges.push(bridge);

            if(!bridge.removeable)
                __this.bridgeNotRemoveableIndex = Index
        });
    }

    this.bridges_num = Params&&Params.bridges_num ? Params.bridges_num : this.bridges.length;

    this.removeable = this.bridgeNotRemoveableIndex < 0 ? 1 : 0;

    this.is_added = Params&&Params.is_added ? Params.is_added : 0;
    this.is_deleted = Params&&Params.is_deleted ? Params.is_deleted : 0;
    this.is_modified = Params&&Params.is_modified ? Params.is_modified : 0;
}

function UlrIgwViewModel(Params)
{
    this.profile = Params&&Params.profile ? Params.profile : null;
    this.nodes = Params&&Params.nodes ? Params.nodes : null;
    this.dics = Params&&Params.dics ? Params.dics : null;
}

function UlrIgwsManager(Params)
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        IgwProfileUpdated: new Rx.BehaviorSubject(null),
        IgwProfileError: new Rx.BehaviorSubject(null),
        IgwProfileSaved: new Rx.BehaviorSubject(null),
        IgwProfileSaveError: new Rx.BehaviorSubject(null),
        IgwProfileDeleted: new Rx.BehaviorSubject(null),
        IgwProfileDeleteError: new Rx.BehaviorSubject(null),

        NodesInitialDataDicUpdated: new Rx.BehaviorSubject(0),

        TokenForExtAuth: new Rx.BehaviorSubject(null),
        TokenForExtAuthError: new Rx.BehaviorSubject(null)
    };

    this.IgwNodesDics =
    {
        InitialDataDic:{},
        AddedDataDic:{},
        RemovedDataDic:{}
    };
}

UlrIgwsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrIgwsManager.prototype.ResfreshIgwProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var id = Params&&Params._id ? Params._id : 0;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetIgwById",
            data: {Id:id},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {

                    var model = new UlrIgwViewModel(R.data);
                    model.profile = new UlrIgwModel(model.profile);

                    Object.keys(model.dics).forEach(function (Key)
                    {
                        App.DicsManager.SetDic(Key, model.dics[Key]);
                    });

                    _this.Signals.IgwProfileUpdated.next(model);

                    _this.IgwNodesDics.InitialDataDic = _this.IgwNodesArrToDic(model.nodes);
                    _this.Signals.NodesInitialDataDicUpdated.next(1);
                }
                else if(!R.success && R.error)
                    _this.Signals.IgwProfileError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsManager.prototype.SaveIgwProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveIgw",
            data: {Igw:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIgwModel(R.data);

                    _this.Signals.IgwProfileSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.IgwProfileSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsManager.prototype.DeleteIgwProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteIgw",
            data: {Igw:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIgwModel(R.data);

                    _this.Signals.IgwProfileDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.IgwProfileDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsManager.prototype.IgwNodesArrToDic = function(NodesArr)
{
    var dic = {};

    if(NodesArr)
    {
        NodesArr.forEach(function (IgwNodeModel)
        {
            dic[IgwNodeModel._id] = new UlrIgwNodeModel(IgwNodeModel);
        });
    }

    return dic;
};

UlrIgwsManager.prototype.IgwNodesArrDicToArr = function(NodeDic)
{
    var arr = [];

    if(NodeDic)
    {
        Object.keys(NodeDic).forEach(function (Key)
        {
            arr.push(NodeDic[Key]);
        });
    }

    return arr;
};

UlrIgwsManager.prototype.UlrGetTokenForExtAuth = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var id = Params&&Params._id ? Params._id : 0;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetTokenForExtAuth",
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.TokenForExtAuth.next(R.data.token);
                }
                else if(!R.success && R.error)
                    _this.Signals.TokenForExtAuthError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
function UlrIgwNodeViewModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.igw_id = Params&&Params.igw_id ? Params.igw_id : 0;

    this.name = Params&&Params.name ? Params.name : "";
    this.igw_name = Params&&Params.igw_name ? Params.igw_name : "";

    this.hardware_id = Params&&Params.hardware_id ? Params.hardware_id : 0;

    this.enabled = Params&&Params.enabled ? Params.enabled : 0;

    this.update_time = Params&&Params.update_time ? Params.update_time : null;
}

function UlrActionTaskInfoViewModel(Params)
{
    this.title = Params && Params.title ? Params.title : "";
    this.description = Params && Params.description ? Params.description : "";
    this.wiki = Params && Params.wiki ? Params.wiki : "";
}

function UlrIgwsNodesManager(Params)
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        IgwNodeEnableStateUpdated: new Rx.BehaviorSubject(null),
        IgwNodeEnableStateError: new Rx.BehaviorSubject(null),

        ActionsTasksDeleteSuccess: new Rx.BehaviorSubject(null),
        ActionsTasksDeleteError: new Rx.BehaviorSubject(null),

        NodeSyncByPassStatusSuccess: new Rx.BehaviorSubject(null),
        NodeSyncByPassStatusError: new Rx.BehaviorSubject(null),

        NodeEnableBypassSuccess: new Rx.BehaviorSubject(null),
        NodeEnableBypassError: new Rx.BehaviorSubject(null),

        NodeDisableBypassSuccess: new Rx.BehaviorSubject(null),
        NodeDisableBypassError: new Rx.BehaviorSubject(null),

        NotesBgTaskStartedSuccess: new Rx.BehaviorSubject(null),
        NotesBgTaskStartedError: new Rx.BehaviorSubject(null),

        NotesBgTaskFinishedSuccess: new Rx.BehaviorSubject(null),
        NotesBgTaskFinishedError: new Rx.BehaviorSubject(null),

        NodeEnableNonStandardModeSuccess: new Rx.BehaviorSubject(null),
        NodeEnableNonStandardModeError: new Rx.BehaviorSubject(null),

        NodeDisableNonStandardModeSuccess: new Rx.BehaviorSubject(null),
        NodeDisableNonStandardModeError: new Rx.BehaviorSubject(null),

        NodeSyncInfoSuccess: new Rx.BehaviorSubject(null),
        NodeSyncInfoError: new Rx.BehaviorSubject(null),

        CreateNodeTasksSuccess: new Rx.BehaviorSubject(0),
        CreateNodeTasksError: new Rx.BehaviorSubject(null),

        NodeCheckTraceIpStatusSuccess: new Rx.BehaviorSubject(null),
        NodeCheckTraceIpStatusError: new Rx.BehaviorSubject(null),

        NodeSetTraceIpSuccess: new Rx.BehaviorSubject(null),
        NodeSetTraceIpError: new Rx.BehaviorSubject(null)
    };

    this.MonitorTasks = {};

    this.MonitorTasksTimeoutInSecs = 5;
}

UlrIgwsNodesManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrIgwsNodesManager.prototype.EnableDisableIgwNode = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIgwNode" : "UlrDisableIgwNode";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Node:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIgwNodeViewModel(R.data.node);

                    _this.Signals.IgwNodeEnableStateUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.IgwNodeEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.DeleteActionsTasks = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var _params =
    {
        _id: Params&&Params._id ? Params._id : null,
        _ids: Params&&Params._ids ? Params._ids : null,
        node_id: Params&&Params.node_id ? Params.node_id : null
    };

    var params =
        {
            id: webix.uid(),
            method:"UrlDeleteActionTasks",
            data: {Params:_params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ActionsTasksDeleteSuccess.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ActionsTasksDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.CheckNodeBypassStatus = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodeSyncByPassStatus",
            data: {Node:Params&&Params.node ? Params.node : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NodeSyncByPassStatusSuccess.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.NodeSyncByPassStatusError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.CheckNodesBypassStatus = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodesSyncByPassStatus",
            data: {Nodes:Params&&Params.nodes ? Params.nodes : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NotesBgTaskStartedSuccess.next(R.data.task);

                    _this.AddTaskToMonitor(R.data.task);
                }
                else if(!R.success && R.error)
                    _this.Signals.NotesBgTaskStartedError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.EnableBypass = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodeEnableByPass",
            data: {Node:Params&&Params.node ? Params.node : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NodeEnableBypassSuccess.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.NodeEnableBypassError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.DisableBypass = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodeDisableByPass",
            data: {Node:Params&&Params.node ? Params.node : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NodeDisableBypassSuccess.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.NodeDisableBypassError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.AddTaskToMonitor = function(TaskModel)
{
    var _this = this;

    if(!this.Active)
        return;

    if(!TaskModel || !TaskModel._id || !TaskModel.status)
        return;

    if(this.MonitorTasks[TaskModel._id])
        return;

    this.MonitorTasks[parseInt(TaskModel._id)] = TaskModel;

    setTimeout(function ()
    {
        _this.CheckTaskStatus({task_id: parseInt(TaskModel._id)});
    }, _this.MonitorTasksTimeoutInSecs * 1000);

};

UlrIgwsNodesManager.prototype.CheckTaskStatus = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetActionTaskById",
            data: {Id:Params&&Params.task_id ? Params.task_id : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                if(R.success)
                {
                    if(R.data.status == "success" || R.data.status == "error")
                    {
                        _this.Signals.NotesBgTaskFinishedSuccess.next(R.data);
                    }
                    else
                    {
                        setTimeout(function ()
                        {
                            _this.CheckTaskStatus({task_id: parseInt(R.data._id)});
                        }, _this.MonitorTasksTimeoutInSecs * 1000);
                    }

                }
                else if(!R.success && R.error)
                    _this.Signals.NotesBgTaskFinishedError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.EnableNonStandardMode = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodeEnableByPassMode",
            data: {Node:Params&&Params.node ? Params.node : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NodeEnableNonStandardModeSuccess.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.NodeEnableNonStandardModeError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.DisableNonStandardMode = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodeDisableByPassMode",
            data: {Node:Params&&Params.node ? Params.node : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NodeDisableNonStandardModeSuccess.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.NodeDisableNonStandardModeError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.ChangeNodesByPassState = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodesChangeByPassState",
            data: {Nodes:Params&&Params.nodes ? Params.nodes : null, Enable:Params.enable ? 1 : 0},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NotesBgTaskStartedSuccess.next(R.data.task);

                    _this.AddTaskToMonitor(R.data.task);
                }
                else if(!R.success && R.error)
                    _this.Signals.NotesBgTaskStartedError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.ChangeNodesNonStandardMode = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodesChangeByPassMode",
            data: {Nodes:Params&&Params.nodes ? Params.nodes : null, Enable:Params.enable ? 1 : 0},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NotesBgTaskStartedSuccess.next(R.data.task);

                    _this.AddTaskToMonitor(R.data.task);
                }
                else if(!R.success && R.error)
                    _this.Signals.NotesBgTaskStartedError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.SyncNodeInfo = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodeSyncInfo",
            data: {Node:Params&&Params.node ? Params.node : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NodeSyncInfoSuccess.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.NodeSyncInfoError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.SyncNodesInfo = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodesSyncByVchannels",
            data: {Nodes:Params&&Params.nodes ? Params.nodes : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NotesBgTaskStartedSuccess.next(R.data.task);

                    _this.AddTaskToMonitor(R.data.task);
                }
                else if(!R.success && R.error)
                    _this.Signals.NotesBgTaskStartedError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.LoadActionTasksInfoJsonDic = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    if(window["UlrActionTasksInfoDic"] && !(Params && Params.force))
    {
        return;
    }

    var params =
        {
            id: webix.uid(),
            method:"UlrGetActionTasksInfoJsonDic",
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    window["UlrActionTasksInfoDic"] = R.data;
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.GetActionTaskInfoFromDicByKey = function(Key)
{
    var r = new UlrActionTaskInfoViewModel();

    if(window["UlrActionTasksInfoDic"] && window["UlrActionTasksInfoDic"][Key])
    {
        r = new UlrActionTaskInfoViewModel(window["UlrActionTasksInfoDic"][Key]);
    }

    return r;
};

UlrIgwsNodesManager.prototype.CreateNodeTasks = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrCreateNodeTasks",
            data: {Nodes:Params&&Params.nodes ? Params.nodes : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.CreateNodeTasksSuccess.next(1);
                }
                else if(!R.success && R.error)
                    _this.Signals.CreateNodeTasksError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.SyncNodeTraceIpStatus = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodeSyncTraceIpStatus",
            data: {Node:Params&&Params.node ? Params.node : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.NodeCheckTraceIpStatusSuccess.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.NodeCheckTraceIpStatusError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.SyncNodesTraceIpStatuses = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodesSyncTraceIpStatuses",
            data: {Nodes:Params&&Params.nodes ? Params.nodes : null},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    if(R.data && R.data.task)
                    {
                        _this.Signals.NotesBgTaskStartedSuccess.next(R.data.task);

                        _this.AddTaskToMonitor(R.data.task);
                    }
                }
                else if(!R.success && R.error)
                    _this.Signals.NotesBgTaskStartedError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIgwsNodesManager.prototype.NodesSetSheduleTraceIp = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var nodes = Params&&Params.nodes ? Params.nodes : [];
    var params =
        {
            id: webix.uid(),
            method:"UlrIgwNodesSetSheduleTraceIp",
            data: {
                Nodes:nodes,
                IpLst:Params.iplst ? Params.iplst : '',
                StateShedule: Params.state_shedule
            },
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    if(R.data)
                    {
                        if (nodes.length)
                        {
                            R.data.forEach(nodeData => {
                                _this.Signals.NodeSetTraceIpSuccess.next(nodeData);
                            })
                        }
                    }
                }
                else if(!R.success && R.error)
                {
                    if(nodes.length)
                    {
                        _this.Signals.NodeSetTraceIpError.next(R.error);
                    }
                    else
                    {
                        _this.Signals.NotesBgTaskStartedError.next(R.error);
                    }
                }


                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
var UlrPolicingTypeEnum = {
    isp: "isp",
    igw: "igw",
    subs: "subs"
};

var UlrPolicingClassesTypeEnum = {
    htb:"htb",
    tbf:"tbf"
};

function UlrPolicingClassModel(Params, Type)
{
    var type = Type ? Type : null;

    this.class = Params&&Params.class?parseInt(Params.class):0;
    this.rate = Params&&Params.rate?Params.rate:"";
    if(type == "htb")
    {
        this.enabled = 1;
    }
    else{
        if(!Params || !Params.hasOwnProperty("enabled"))
        {
            this.enabled = 1;
        }
        else{
            this.enabled = Params && Params.enabled ? 1 : 0;
        }
    }

    if(type == UlrPolicingClassesTypeEnum.htb)
    {
        this.ceil = Params&&Params.ceil?Params.ceil:"";
        this.ceil_static = Params&&Params.ceil_static?Params.ceil_static:0;
    }
}

function UlrPolicingClassesModel(Params, Type)
{
    var __this = this;

    var type = Type ? Type : null;

    this.classes = [];

    if(Params&&Params.classes&&Array.isArray(Params.classes))
    {
        Params.classes.forEach(function (Item)
        {
            __this.classes.push(new UlrPolicingClassModel(Item, type))
        });
    }
    else
    {
        for (var i = 0; i < 8; i++)
        {
            __this.classes.push(new UlrPolicingClassModel(null, type));
        }
    }
}

function UlrPolicingClassesProfileModel(Params, Type)
{
    var __this = this;

    var type = Type ? Type : null;

    this.inbound = null;
    this.outbound = null;

    function parse(Direction)
    {
        __this[Direction] = {};

        if(type == UlrPolicingClassesTypeEnum.htb)
        {
            __this[Direction].root_rate = Params&&Params[Direction]&&Params[Direction].root_rate ? Params[Direction].root_rate : "";
            __this[Direction].root_ceil = Params&&Params[Direction]&&Params[Direction].root_ceil ? Params[Direction].root_ceil : "";
            __this[Direction].root_ceil_enabled = Params&&Params[Direction]&&Params[Direction].root_ceil_enabled ? Params[Direction].root_ceil_enabled : 0;
        }


        __this[Direction].classes = new UlrPolicingClassesModel(Params&&Params[Direction] ? Params[Direction] : null, type).classes;
    }

    parse("inbound");

    parse("outbound");
}

function UlrPolicingClassesProfileViewModel(Params, Type)
{
    var __this = this;

    var type = Type ? Type : null;

    function parse(Direction)
    {
        if(type == UlrPolicingClassesTypeEnum.htb)
        {
            __this[Direction+"_root_rate"] = Params&&Params[Direction+"_root_rate"] ? Params[Direction+"_root_rate"] : "";
            __this[Direction+"_root_rate_unit"] = Params&&Params[Direction+"_root_rate_unit"] ? Params[Direction+"_root_rate_unit"] : "";

            __this[Direction+"_root_ceil"] = Params&&Params[Direction+"_root_ceil"] ? Params[Direction+"_root_ceil"] : "";
            __this[Direction+"_root_ceil_unit"] = Params&&Params[Direction+"_root_ceil_unit"] ? Params[Direction+"_root_ceil_unit"] : "";
            __this[Direction+"_root_ceil_enabled"] = Params&&Params[Direction+"_root_ceil_enabled"] ? Params[Direction+"_root_ceil_enabled"] : 0;
        }

        for (var i = 0; i < 8; i++)
        {
            __this[Direction+"_class_"+i+"_rate"] = Params&&Params[Direction+"_class_"+i+"_rate"] ? Params[Direction+"_class_"+i+"_rate"] : "";
            __this[Direction+"_class_"+i+"_rate_unit"] = Params&&Params[Direction+"_class_"+i+"_rate_unit"] ? Params[Direction+"_class_"+i+"_rate_unit"] : "";

            if(type == UlrPolicingClassesTypeEnum.htb)
            {
                __this[Direction+"_class_"+i+"_ceil"] = Params&&Params[Direction+"_class_"+i+"_ceil"] ? Params[Direction+"_class_"+i+"_ceil"] : "";
                __this[Direction+"_class_"+i+"_ceil_unit"] = Params&&Params[Direction+"_class_"+i+"_ceil_unit"] ? Params[Direction+"_class_"+i+"_ceil_unit"] : "";
                __this[Direction+"_class_"+i+"_ceil_static"] = Params&&Params[Direction+"_class_"+i+"_ceil_static"] ? Params[Direction+"_class_"+i+"_ceil_static"] : "";
                __this[Direction+"_class_"+i+"_enabled"] = 1;
            }
            else{
                __this[Direction+"_class_"+i+"_enabled"] = Params&&Params[Direction+"_class_"+i+"_enabled"] ? Params[Direction+"_class_"+i+"_enabled"] : 0;
            }

        }
    }

    parse("inbound");

    parse("outbound");
}

function UlrHtbPolicingClassesProfileValidModel(Params)
{
    this.valid = Params&&Params.valid ? Params.valid : false;

    this.inbound_root = Params&&Params.inbound_root ? Params.inbound_root : false;
    this.outbound_root = Params&&Params.outbound_root ? Params.outbound_root : false;

    this.inbound_classes = Params&&Params.inbound_classes ? Params.inbound_classes : false;
    this.outbound_classes = Params&&Params.outbound_classes ? Params.outbound_classes : false;
}

function UlrIspPolicingModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.isp_id = Params&&Params.isp_id?Params.isp_id:null;
    this.igw_id = Params&&Params.igw_id?Params.igw_id:null;
    this.type_id = Params&&Params.type_id?Params.type_id:0;
    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.description = Params&&Params.description?Params.description:"";
    this.state_load = Params&&Params.state_load?Params.state_load:0;
    this.state_error = Params&&Params.state_error?Params.state_error:0;
    this.state = Params&&Params.state?Params.state:"";

    this.config = Params&&Params.config?Params.config:"";

    this.config_model = null;

    if(this.config && JSON.parse(this.config))
    {
        var dic = App.DicsManager.GetDic(DicsEnum.UlrPolicingTypesDic);
        var type_code = dic&&dic[this.type_id ] ? dic[this.type_id ].value : null;
        this.config_model = new UlrPolicingClassesProfileModel(JSON.parse(this.config), type_code);
    }
}

function UlrIspPolicingViewModel(Params)
{
    this.policing = Params&&Params.policing ? Params.policing : null;
    this.isp = Params&&Params.isp ? Params.isp : null;
    this.igw = Params&&Params.igw ? Params.igw : null;
    this.dics = Params&&Params.dics ? Params.dics : null;
}


function UlrAppPolicingsManager(Params)
{
    this.Active = true;

    this.ProfilePolicingType = Params && Params.profile_type ? Params.profile_type : UlrPolicingTypeEnum.isp;

    this.ParentModel = UlrIspModel

    if(this.ProfilePolicingType == UlrPolicingTypeEnum.igw)
    {
        this.ParentModel = UlrIgwModel
    }

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        ParentUpdated: new Rx.BehaviorSubject(null),
        PolicingProfileUpdated: new Rx.BehaviorSubject(null),
        PolicingProfileError: new Rx.BehaviorSubject(null),
        PolicingProfileSaved: new Rx.BehaviorSubject(null),
        PolicingProfileSaveError: new Rx.BehaviorSubject(null),
        PolicingProfileDeleted: new Rx.BehaviorSubject(null),
        PolicingProfileDeleteError: new Rx.BehaviorSubject(null),

        PolicingProfileEnableStateUpdated: new Rx.BehaviorSubject(null),
        PolicingProfileEnableStateError: new Rx.BehaviorSubject(null)
    };
}

UlrAppPolicingsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrAppPolicingsManager.prototype.ResfreshAppPolicingProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var id = Params&&Params._id ? Params._id : 0;

    var method = this.ProfilePolicingType == UlrPolicingTypeEnum.igw ? "UlrGetIgwPolicingByIgwId" : "UlrGetIspPolicingByIspId";

    var params =
        {
            id: webix.uid(),
            method: method,
            data: {Id:id},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspPolicingViewModel(R.data);

                    Object.keys(model.dics).forEach(function (Key)
                    {
                        App.DicsManager.SetDic(Key, model.dics[Key]);
                    });

                    var typeDic = App.DicsManager.GetDic(DicsEnum.UlrPolicingTypesDic);
                    var type = typeDic&&typeDic[model.policing.type_id]?typeDic[model.policing.type_id].value : null;

                    model.policing = new UlrIspPolicingModel(model.policing, type);


                    model[_this.ProfilePolicingType] = new _this.ParentModel(model[_this.ProfilePolicingType]);

                    _this.Signals.ParentUpdated.next(model[_this.ProfilePolicingType]);
                    _this.Signals.PolicingProfileUpdated.next(model.policing);
                }
                else if(!R.success && R.error)
                    _this.Signals.PolicingProfileError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrAppPolicingsManager.prototype.SaveAppPolicingProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveIspPolicing",
            data: {Policing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspPolicingViewModel(R.data);

                    _this.Signals.PolicingProfileSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.PolicingProfileSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrAppPolicingsManager.prototype.DeleteAppPolicingProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteIspPolicing",
            data: {Policing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);
                
                if(R.success)
                {
                   _this.Signals.PolicingProfileDeleted.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.AppPolicingProfileDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrAppPolicingsManager.prototype.EnableDisableAppPolicingProfile = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIspPolicing" : "UlrDisableIspPolicing";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Policing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.PolicingProfileEnableStateUpdated.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.PolicingProfileEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrAppPolicingsManager.prototype.MapPolicngClassesProfileToViewModel = function(InModel, Type)
{
    var __this = this;

    var type = Type ? Type : null;

    var inModel = new UlrPolicingClassesProfileModel(InModel, type);

    var outModel = {};

    function parse(Direction)
    {
        if(inModel[Direction])
        {
            if(type === UlrPolicingClassesTypeEnum.htb)
            {
                var val = Helper.SplitDigitLetters(inModel[Direction].root_rate);

                if(val && val.length == 2 && parseInt(val[0]) >=0 && TrafficVals[val[1]])
                {
                    outModel[Direction+"_root_rate"] = parseInt(val[0]);
                    outModel[Direction+"_root_rate_unit"] = TrafficVals[val[1]].id;
                }
                else
                {
                    outModel[Direction+"_root_rate"] = 8;
                    outModel[Direction+"_root_rate_unit"] = TrafficVals.bit.id;
                }

                var val = Helper.SplitDigitLetters(inModel[Direction].root_ceil);

                if(val && val.length == 2 && parseInt(val[0]) >=0 && TrafficVals[val[1]])
                {
                    outModel[Direction+"_root_ceil"] = parseInt(val[0]);
                    outModel[Direction+"_root_ceil_unit"] = TrafficVals[val[1]].id;
                }
                else
                {
                    outModel[Direction+"_root_ceil"] = 8;
                    outModel[Direction+"_root_ceil_unit"] = TrafficVals.bit.id;
                }

                outModel[Direction+"_root_ceil_enabled"] = inModel[Direction].root_ceil_enabled ? inModel[Direction].root_ceil_enabled : 0;
            }

            inModel[Direction].classes.forEach(function (Item, Index)
            {
                var val = Helper.SplitDigitLetters(Item.rate);

                if(val && val.length == 2 && parseInt(val[0]) >=0 && TrafficVals[val[1]])
                {
                    outModel[Direction+"_class_"+Index+"_rate"] = parseInt(val[0]);
                    outModel[Direction+"_class_"+Index+"_rate_unit"] = TrafficVals[val[1]].id;
                }
                else
                {
                    outModel[Direction+"_class_"+Index+"_rate"] = 8;
                    outModel[Direction+"_class_"+Index+"_rate_unit"] = TrafficVals.bit.id;
                }

                if(type === UlrPolicingClassesTypeEnum.htb)
                {
                    var val = Helper.SplitDigitLetters(Item.ceil);

                    if(val && val.length == 2 && parseInt(val[0]) >=0 && TrafficVals[val[1]])
                    {
                        outModel[Direction+"_class_"+Index+"_ceil"] = parseInt(val[0]);
                        outModel[Direction+"_class_"+Index+"_ceil_unit"] = TrafficVals[val[1]].id;
                    }
                    else
                    {
                        outModel[Direction+"_class_"+Index+"_ceil"] = 8;
                        outModel[Direction+"_class_"+Index+"_ceil_unit"] = TrafficVals.bit.id;
                    }

                    outModel[Direction+"_class_"+Index+"_ceil_static"] = Item.ceil_static;
                    outModel[Direction+"_class_"+Index+"_enabled"] = 1;
                }
                else{
                    outModel[Direction  +"_class_" + Index + "_enabled"] = Item.enabled;
                }
            });
        }
    }

    parse("inbound");

    parse("outbound");

    return new UlrPolicingClassesProfileViewModel(outModel, type);
};

UlrAppPolicingsManager.prototype.MapViewPolicngClassesProfileToModel = function(InViewModel, Type)
{
    var __this = this;

    var type = Type ? Type : null;

    var inModel = new UlrPolicingClassesProfileViewModel(InViewModel, type);

    var outModel = {};

    function parse(Direction)
    {
        outModel[Direction] = {};

        if(type === UlrPolicingClassesTypeEnum.htb)
        {
            outModel[Direction].root_rate = parseInt(inModel[Direction+"_root_rate"]) >= 0 ? parseInt(inModel[Direction+"_root_rate"])+inModel[Direction+"_root_rate_unit"] : "";
            outModel[Direction].root_ceil = parseInt(inModel[Direction+"_root_ceil_enabled"])&&parseInt(inModel[Direction+"_root_ceil"]) >= 0 ? parseInt(inModel[Direction+"_root_ceil"])+inModel[Direction+"_root_ceil_unit"] : "";
            outModel[Direction].root_ceil_enabled = parseInt(inModel[Direction+"_root_ceil_enabled"]) ? 1 : 0;
        }

        outModel[Direction].classes = [];

        for(var i = 0; i < 8; i++)
        {
            var cs = {
                class:i,
                rate:parseInt(inModel[Direction+"_class_"+i+"_rate"]) >= 0 ? parseInt(inModel[Direction+"_class_"+i+"_rate"])+inModel[Direction+"_class_"+i+"_rate_unit"] : "",
                enabled: type == "htb" ? 1 : parseInt(inModel[Direction + "_class_" + i + "_enabled"])
            };

            if(type === UlrPolicingClassesTypeEnum.htb)
            {
                cs.ceil = parseInt(inModel[Direction+"_class_"+i+"_ceil"]) >= 0 ? parseInt(inModel[Direction+"_class_"+i+"_ceil"])+inModel[Direction+"_class_"+i+"_ceil_unit"] : "";

                if(parseInt(inModel[Direction+"_class_"+i+"_ceil_static"]))
                {
                    cs.ceil = "static";
                    cs.ceil_static = 1;
                }
                else
                    cs.ceil_static = 0;

            }

            outModel[Direction].classes.push(cs);
        }
    }

    parse("inbound");

    parse("outbound");

    return new UlrPolicingClassesProfileModel(outModel, type);
};

UlrAppPolicingsManager.prototype.ValidatePolicingClassesProfileModel = function(InModel, Type)
{
    var __this = this;

    var validModel = new UlrHtbPolicingClassesProfileValidModel();

    var type = Type ? Type : null;

    var inModel = new UlrPolicingClassesProfileModel(InModel, type);

    if(type !== UlrPolicingClassesTypeEnum.htb)
    {
        validModel.valid = true;
        return validModel;
    }

    function SumClassesInBps (Direction)
    {
        var sumBps = 0;

        inModel[Direction].classes.forEach(function (Item)
        {
            var uval = Helper.GetTrafficValAndUnitFromString(Item.rate);

            if(Item.rate !== 8+TrafficVals.bit.id && Item.ceil !== "static")
            {
                sumBps += uval.val * (TrafficVals[uval.unit] ? TrafficVals[uval.unit].value : 1);
            }
        });

        return sumBps
    }

    var RootRateBps = function (Direction)
    {
        var uval = Helper.GetTrafficValAndUnitFromString(inModel[Direction].root_rate);

        if(inModel[Direction].root_rate !== 8+TrafficVals.bit.id)
        {
            return uval.val * (TrafficVals[uval.unit] ? TrafficVals[uval.unit].value : 1);
        }

        return 0;
    };

    function MaxRatioRootCeilClassesInBps (Direction)
    {
        var max = 0;

        inModel[Direction].classes.forEach(function (Item)
        {
            if(Item.rate !== 8+TrafficVals.bit.id && Item.ceil !== "static")
            {
                var uvalRate = Helper.GetTrafficValAndUnitFromString(Item.rate);
                var uvalCeil = Helper.GetTrafficValAndUnitFromString(Item.ceil);

                var valRate = uvalRate.val * (TrafficVals[uvalRate.unit] ? TrafficVals[uvalRate.unit].value : 1);
                var valCeil = uvalCeil.val * (TrafficVals[uvalCeil.unit] ? TrafficVals[uvalCeil.unit].value : 1);

                var ratio = valCeil/valRate;

                max = ratio > max ? ratio : max;
            }
        });

        return max;
    }

    if(SumClassesInBps("inbound") <= RootRateBps("inbound"))
        validModel.inbound_root = true;

    if(SumClassesInBps("outbound") <= RootRateBps("outbound"))
        validModel.outbound_root = true;

    //class_[0.7] => ceils/rate <= 65535

    //if(MaxRatioRootCeilClassesInBps("inbound") <= 65535)
        validModel.inbound_classes = true;

    //if(MaxRatioRootCeilClassesInBps("outbound") <= 65535)
        validModel.outbound_classes = true;

    var isValid = true;

    Object.keys(validModel).forEach(function (Key)
    {
        if(Key !== "valid" && !validModel[Key])
            isValid = false;
    });

    validModel.valid = isValid;

    return validModel;
};
var SessionPolicingProtocolTypeEnum = {
    protocol: "protocol",
    group: "group"
};

var SessionPolicingActionsEnum = {
    "disable_profile": {id: "disable_profile", value: LangHelper.GetString("UlrModule", "Disable profile")},
    "enable_template": {id: "enable_template", value: LangHelper.GetString("UlrModule", "Replace configuration by template")},
    "add_template_to_config": {id: "add_template_to_config", value: LangHelper.GetString("UlrModule", "Add template to configuration")},
    "disable_template": {id: "disable_template", value: LangHelper.GetString("UlrModule", "Apply profile configuration")}
};

function SessionPolicingProtocolModel(Params)
{
    this.type = Params && Params.type ? Params.type : "";
    this.value = Params && Params.value ? Params.value : "";
    this.priority = Params && Params.priority ? Params.priority : (this.type === UlrProtocolTypesDic.template.id ? '' : 'keep');
    this.inbound_rate = Params && Params.inbound_rate ? Params.inbound_rate : "";
    this.rate = Params && Params.rate ? Params.rate : "";
    this.enabled = Params && Params.enabled ? parseInt(Params.enabled) : 0;
}

function UlrIspSessionPolicingModel(Params)
{
    this._id = Params && Params._id ? parseInt(Params._id) : 0;
    this.isp_id = Params && Params.isp_id ? parseInt(Params.isp_id) : 0;
    this.enabled = Params && Params.enabled ? parseInt(Params.enabled) : 0;
    this.description = Params && Params.description ? Params.description : "";
    this.state_load = Params && Params.state_load ? parseInt(Params.state_load) : 0;
    this.state_error = Params && Params.state_error ? parseInt(Params.state_error):0;
    this.state = Params && Params.state ? Params.state : "";
    this.config = Params && Params.config ? Params.config : "";
    this.schedule_enabled = Params && Params.schedule_enabled ? Params.schedule_enabled : 0;

    this.config_model = [];

    if(this.config && JSON.parse(this.config))
    {
        var arr = JSON.parse(this.config);

        if(arr && Array.isArray(arr))
        {
            arr.forEach(obj => {
                this.config_model.push(new SessionPolicingProtocolModel(obj));
            });
        }
    }
}

function UlrIspSessionPolicingViewModel(Params)
{
    this.policing = Params&&Params.policing ? Params.policing : null;
    this.isp = Params&&Params.isp ? Params.isp : null;
    this.igw = Params&&Params.igw ? Params.igw : null;
    this.dics = Params&&Params.dics ? Params.dics : null;
}

function UlrPolicingTemplateModel(Params)
{
    this._id = Params && Params._id ? parseInt(Params._id) : 0;
    this.policing_type = Params && Params.policing_type ? Params.policing_type :UlrPolicingTemplatesTypesDic.session.id;
    this.title = Params && Params.title ? Params.title : "";
    this.description = Params && Params.description ? Params.description : "";
    this.config = Params && Params.config ? Params.config : "";

    this.config_model = [];

    if(this.config && JSON.parse(this.config))
    {
        var arr = JSON.parse(this.config);

        if(arr && Array.isArray(arr))
        {
            arr.forEach(obj => {
                this.config_model.push(new SessionPolicingProtocolModel(obj));
            });
        }
    }
}

function UlrPolicingTemplateViewModel(Params)
{
    this.template = Params && Params.template ? Params.template : null;
    this.dics = Params&&Params.dics ? Params.dics : null;
}

function UlrSessionPolicingScheduleModel(Params)
{
    this._id = Params && Params._id ?  parseInt(Params._id) : 0;
    this.enabled = Params && Params.enabled ? parseInt(Params.enabled) : 0;
    this.prfl_id = Params && Params.prfl_id ? parseInt(Params.prfl_id) : null;
    this.tpl_id = Params && Params.tpl_id ? parseInt(Params.tpl_id) : null;
    this.action = Params && Params.action ? Params.action : "";
    this.start_time = Params && Params.start_time ? Params.start_time : "";
    this.week_days = Params && Params.week_days ? Params.week_days : "";
    this.update_user = Params && Params.update_user ? Params.update_user : "";
    this.create_user = Params && Params.create_user ? Params.create_user : "";
    this.update_time = Params && Params.update_time ? Params.update_time : "";
    this.create_time = Params && Params.create_time ? Params.create_time : "";

    if(Array.isArray(this.week_days))
        this.week_days = this.week_days.sort().join(",");
}

function UlrSessionPolicingScheduleViewModel(Params)
{
    let _this = this;
    let model = new UlrSessionPolicingScheduleModel(Params);

    Object.keys(model).forEach(Key => {
        _this[Key] = model[Key];
    });

    this.id = Params && Params.id ? Params.id : webix.uid();
    this.tpl_name = Params && Params.tpl_name ? Params.tpl_name : "";
}

function UlrIspSessionPolicingsManager(Params)
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        ParentUpdated: new Rx.BehaviorSubject(null),
        PolicingProfileUpdated: new Rx.BehaviorSubject(null),
        PolicingProfileError: new Rx.BehaviorSubject(null),
        PolicingProfileSaved: new Rx.BehaviorSubject(null),
        PolicingProfileSaveError: new Rx.BehaviorSubject(null),
        PolicingProfileDeleted: new Rx.BehaviorSubject(null),
        PolicingProfileDeleteError: new Rx.BehaviorSubject(null),

        PolicingProfileEnableStateUpdated: new Rx.BehaviorSubject(null),
        PolicingProfileEnableStateError: new Rx.BehaviorSubject(null),

        GetSessionPolicingsByIspIdsSuccess: new Rx.BehaviorSubject(null),
        GetSessionPolicingsByIspIdsNotFound: new Rx.BehaviorSubject(null),

        PolicingMultiplySetSuccess: new Rx.BehaviorSubject(null),

        RefreshSchedulesSuccess: new Rx.BehaviorSubject(null),
        RefreshSchedulesError: new Rx.BehaviorSubject(null),

        ServerError: new Rx.BehaviorSubject(null),

        SessionPolicingSchedulesSuccess: new Rx.BehaviorSubject(null),
        SessionPolicingSchedulesNotFound: new Rx.BehaviorSubject(null),
        SessionPolicingSchedulesError: new Rx.BehaviorSubject(null),
        SessionPolicingScheduleMultipleSuccess: new Rx.BehaviorSubject(null)

    };
}

UlrIspSessionPolicingsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrIspSessionPolicingsManager.prototype.RefreshProfile = function(Params)
{
    if(!this.Active)
        return;

    var _this = this;

    var id = Params && Params.id ? Params.id : 0;

    var params = {
        id: webix.uid(),
        method: "UlrGetIspSessionPolicingByIspId",
        data: {
            Id: id
        },
        callback: function(R)
        {
            if(!_this.Active)
            {
                return;
            }

            _this.Signals.Progress.next(0);

            if(R.success)
            {
                var model = new UlrIspSessionPolicingViewModel(R.data);

                Object.keys(model.dics).forEach(function(Key){
                    App.DicsManager.SetDic(Key, model.dics[Key]);
                });

                _this.Signals.ParentUpdated.next(new UlrIspModel(model.isp));
                _this.Signals.PolicingProfileUpdated.next(new UlrIspSessionPolicingModel(model.policing));
            }
            else if(R.error)
            {
                _this.Signals.PolicingProfileError.next(new ServerErrorModel(R.error));
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.GetSessionPolicingSchedulesByProfileId = function(ProfileId)
{
    if(!this.Active)
        return;

    var _this = this;

    var params = {
        id: webix.uid(),
        method: "UlrGetSessionPolicingSchedulesByProfileId",
        data: {
            ProfileId: parseInt(ProfileId)
        },
        callback: function(R)
        {
            if(!_this.Active)
            {
                return;
            }

            _this.Signals.Progress.next(0);

            if(R.success && R.data && R.data.rows)
            {
                let data = R.data.rows.map(Item => new UlrSessionPolicingScheduleViewModel(Item));

                _this.Signals.RefreshSchedulesSuccess.next(data);
            }
            else if(!R.success && R.error)
            {
                _this.Signals.RefreshSchedulesError.next(new ServerErrorModel(R.error));
            }
            else
            {
                _this.Signals.ServerError.next(1);
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.SavePolicingProfile = function(Params, ScheduleData = null)
{
    var _this = this;

    if(!this.Active)
        return;

    if(!ScheduleData)
        ScheduleData = {};

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveIspSessionPolicing",
            data: {Policing:Params, ScheduleData:ScheduleData},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIspSessionPolicingViewModel(R.data);
                    _this.Signals.PolicingProfileSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.PolicingProfileSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.DeleteProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteIspSessionPolicing",
            data: {Policing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.PolicingProfileDeleted.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.PolicingProfileDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.EnableDisableProfile = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIspSessionPolicing" : "UlrDisableIspSessionPolicing";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Policing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.PolicingProfileEnableStateUpdated.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.PolicingProfileEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.GetSessionPolicingsByIspIds = function(IdsList, Type = "common")
{
    let _this = this;

    const methods = {
        "common": "GetCommonSessionPolicingsByIspIds",
        "uniq": "GetUniqSessionPolicingsByIspIds"
    };

    if(!this.Active)
        return;

    if(!methods[Type])
        return

    let params = {
        id: webix.uid(),
        method: methods[Type],
        data: {Data:IdsList},
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(R.success)
            {
                let models = [];

                for(let item of R.data)
                    models.push(new SessionPolicingProtocolModel(item));

                _this.Signals.GetSessionPolicingsByIspIdsSuccess.next(models);
            }
            else if(R.error)
            {
                if(R.error.code == 404)
                {
                    _this.Signals.GetSessionPolicingsByIspIdsNotFound.next(1)
                }
                else
                {
                    _this.Signals.ServerError.next(R.error);
                }
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.MultiplySetIspSessionPolicing = function(Params, Enabled)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"MultiplySetIspSessionPolicing",
            data: {Data:Params, Enabled: Enabled},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.PolicingMultiplySetSuccess.next(1)
                }
                else if(!R.success && R.error)
                {
                    _this.Signals.ServerError.next(R.error);
                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.RefreshTemplate = function(Params)
{
    if(!this.Active)
        return;

    var _this = this;

    var id = Params && Params.id ? Params.id : 0;
    var template_type = Params && Params.template_type ?  Params.template_type : UlrPolicingTemplatesTypesDic.session.id;
    var params = {
        id: webix.uid(),
        method: "UlrGetPolicingTemplateById",
        data: {
            Id: id,
            TemplateType: template_type
        },
        callback: function(R)
        {
            if(!_this.Active)
            {
                return;
            }

            _this.Signals.Progress.next(0);
            if(R.success)
            {
                var model = new UlrPolicingTemplateViewModel(R.data);

                Object.keys(model.dics).forEach(function(Key){
                    App.DicsManager.SetDic(Key, model.dics[Key]);
                });

                _this.Signals.PolicingProfileUpdated.next(new UlrPolicingTemplateModel(model.template));
            }
            else if(R.error)
            {
                _this.Signals.PolicingProfileError.next(new ServerErrorModel(R.error));
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.SaveTemplate = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSavePolicingTemplate",
            data: {Template:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrPolicingTemplateViewModel(R.data);
                    _this.Signals.PolicingProfileSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.PolicingProfileSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.DeleteTemplate = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeletePolicingTemplate",
            data: {Template:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.PolicingProfileDeleted.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.PolicingProfileDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.GetCommonSessionPolicingsScheduleByIspIds = function(Params)
{
    if(!this.Active)
        return;

    var _this = this;

    var Data = Params.data;

    var params = {
        id: webix.uid(),
        method: "UlrGetCommonSessionPolicingsScheduleByIspIds",
        data: {Data:Data},
        callback: function(R)
        {
            if(!_this.Active)
            {
                return;
            }

            _this.Signals.Progress.next(0);

            if(R.success)
            {
                let models = [];

                var enabled = parseInt(R.data.enabled);

                for (let item of R.data.rows)
                {
                    models.push(new UlrSessionPolicingScheduleViewModel(item));
                }

                _this.Signals.SessionPolicingSchedulesSuccess.next({rows: models, enabled: enabled});
            }
            else if(R.error)
            {
                if(R.error.code == 404)
                {
                    _this.Signals.SessionPolicingSchedulesNotFound.next(1)
                }
                else
                {
                    _this.Signals.SessionPolicingSchedulesError.next(R.error);
                }
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrIspSessionPolicingsManager.prototype.MultiplySetIspSessionPolicingSchedule = function(Profiles, Schedule, Enabled, DeleteSchedule, Callback)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrMultiplySetIspSessionPolicingSchedule",
            data: {Profiles:Profiles, Schedule: Schedule, Enabled: parseInt(Enabled), DeleteSchedule: parseInt(DeleteSchedule)},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.SessionPolicingScheduleMultipleSuccess.next(1)
                }
                else if(!R.success && R.error)
                {
                    _this.Signals.ServerError.next(R.error);
                }

                if(Callback && typeof Callback === "function")
                {
                    Callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
function UlrDscpRuleModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.type_id = Params&&Params.type_id?Params.type_id:1;
    this.rule_id = Params&&Params.rule_id?Params.rule_id:0;
    this.dscp_id = Params&&Params.dscp_id?Params.dscp_id:0;
    this.dscp_value = Params&&Params.dscp_value?Params.dscp_value:null;
    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.create_time = Params&&Params.create_time?Params.create_time:null;
}

function UlrAppDscpRuleModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.rule_id = Params&&Params.rule_id?Params.rule_id:null;
    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.protocol = Params&&Params.protocol?Params.protocol:"";
    this.priority = Params&&Params.priority?Params.priority:"";
    this.name = Params&&Params.name?Params.name:null;
    this.is_group = Params && Params.is_group ? Number.parseInt(Params.is_group) : 0;
    this.group_id = Params && Params.group_id ? Number.parseInt(Params.group_id) : 0;
    this.group_name_json = Params && Params.group_name_json ? Params.group_name_json : "{}";
    this.is_custom_group = Params && Params.is_custom_group ? Number.parseInt(Params.is_custom_group) : 0;
    this.custom_group_id = Params && Params.custom_group_id ? Params.custom_group_id : 0;
    this.custom_group_name = Params && Params.custom_group_name ? Params.custom_group_name : "";
    this.regulator_id = Params&&Params.regulator_id?Params.regulator_id:null;
    this.regulator = Params&&Params.regulator?Params.regulator:null;
    this.create_time = Params&&Params.create_time?Params.create_time:null;
    this.update_time = Params&&Params.update_time?Params.update_time:null;

    this.isps = Params&&Params.isps ? Params.isps : '';
    this.mode_id = Params&&Params.mode_id ? Params.mode_id : 1;
    this.mode = Params&&Params.mode ? Params.mode : "";
}

function UlrAsnDscpRuleModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.rule_id = Params&&Params.rule_id?Params.rule_id:null;
    this.rule_type_id = Params&&Params.rule_type_id ? Params.rule_type_id : 0;
    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.isps = Params&&Params.isps?Params.isps:"";
    this.mode = Params&&Params.mode?Params.mode:"";
    this.mode_id = Params&&Params.mode_id?Params.mode_id:0;
    this.protocol = Params&&Params.protocol?Params.protocol:"";
    this.priority = Params&&Params.priority?Params.priority:"";
    this.name = Params&&Params.name?Params.name:null;
    this.is_group = Params && Params.is_group ? Number.parseInt(Params.is_group) : 0;
    this.regulator_id = Params&&Params.regulator_id?Params.regulator_id:null;
    this.regulator = Params&&Params.regulator?Params.regulator:null;
    this.description = Params&&Params.description?Params.description:null;
    this.create_time = Params&&Params.create_time?Params.create_time:null;
    this.update_time = Params&&Params.update_time?Params.update_time:null;
}

function UrlAsnDscpWithIspsRuleMode(Params) {
    let model = new UlrAsnDscpRuleModel(Params);
    model.isps = Params&&Params.isps ? Params.isps : '';
    model.mode_id = Params&&Params.mode_id ? Params.mode_id : 1;
    return model;
}

function UlrASEditDscpRuleModel(Params)
{
    this.rule_type_id = Params&&Params.rule_type_id ? Params.rule_type_id : UlrRulesTypesCodesTypeIdMap.asn_lock;
    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.protocol = Params&&Params.number?Params.number:"";
    this.priority = Params&&Params.priority?Params.priority:"";
    this.name = Params&&Params.name?Params.name:null;
}

var UlrIpDscpRuleModel = UlrAsnDscpRuleModel;

function UlrAppProtocolExistCheckModel(Params)
{
    this.protocol_exists = Params&&Params.protocol_exists ? parseInt(Params.protocol_exists) : 0;
    this.protocol = Params&&Params.protocol ? Params.protocol : "";

    this.model = Params&&Params.model ? Params.model : null;
}

function UlrAppProtocolRuleExistCheckModel(Params)
{
    this.rule_exists = Params&&Params.rule_exists ? parseInt(Params.rule_exists) : 0;
    this.protocol = Params&&Params.protocol ? Params.protocol : "";

    this.rule = Params&&Params.rule ? new UlrAppDscpRuleModel(Params.rule) : null;
}

function UlrAsnProtocolRuleExistCheckModel(Params)
{

    this.protocol = Params&&Params.protocol ? Params.protocol : "";
    this.name = Params&&Params.protocol ? Params.protocol : "";

    this.by_protocol = {
        rule_exists:0,
        rule:null
    };

    this.by_name = {
        rule_exists:0,
        rule:null
    };

    if(Params&&Params.by_protocol)
    {
        this.by_protocol.rule_exists = Params&&Params.by_protocol.rule_exists ? parseInt(Params.by_protocol.rule_exists) : 0;
        this.by_protocol.rule = Params&&Params.by_protocol.rule ? new UlrAppDscpRuleModel(Params.by_protocol.rule) : null;
    }

    if(Params&&Params.by_name)
    {
        this.by_name.rule_exists = Params&&Params.by_name.rule_exists ? parseInt(Params.by_name.rule_exists) : 0;
        this.by_name.rule = Params&&Params.by_name.rule ? new UlrAppDscpRuleModel(Params.by_name.rule) : null;
    }
}

var UlrIpProtocolRuleExistCheckModel = UlrAsnProtocolRuleExistCheckModel;

function UlrAppProtocolRuleCheckModel(Params)
{
    this.protocol = Params&&Params.protocol ? new UlrAppProtocolExistCheckModel(Params.protocol) : null;
    this.rule = Params&&Params.rule ? new UlrAppProtocolRuleExistCheckModel(Params.rule) : null;
}

function UlrDscpRulesManager(Params)
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        AppDscpRuleSaved: new Rx.BehaviorSubject(null),
        AppDscpRuleSaveError: new Rx.BehaviorSubject(null),
        AppDscpRuleDeleted: new Rx.BehaviorSubject(null),
        AppDscpRuleDeleteError: new Rx.BehaviorSubject(null),
        AppDscpRuleEnableStateUpdated: new Rx.BehaviorSubject(null),
        AppDscpRuleEnableStateError: new Rx.BehaviorSubject(null),

        ProtocolCheckResult: new Rx.BehaviorSubject(null),
        ProtocolCheckError: new Rx.BehaviorSubject(null),

        AsnDscpRuleSaved: new Rx.BehaviorSubject(null),
        AsnDscpRuleSaveError: new Rx.BehaviorSubject(null),
        AsnDscpRuleDeleted: new Rx.BehaviorSubject(null),
        AsnDscpRuleDeleteError: new Rx.BehaviorSubject(null),
        AsnDscpRuleEnableStateUpdated: new Rx.BehaviorSubject(null),
        AsnDscpRuleEnableStateError: new Rx.BehaviorSubject(null),

        AsnCheckResult: new Rx.BehaviorSubject(null),
        AsnCheckError: new Rx.BehaviorSubject(null),


        IpDscpRuleSaved: new Rx.BehaviorSubject(null),
        IpDscpRuleSaveError: new Rx.BehaviorSubject(null),
        IpDscpRuleDeleted: new Rx.BehaviorSubject(null),
        IpDscpRuleDeleteError: new Rx.BehaviorSubject(null),
        IpDscpRuleEnableStateUpdated: new Rx.BehaviorSubject(null),
        IpDscpRuleEnableStateError: new Rx.BehaviorSubject(null),

        IpCheckResult: new Rx.BehaviorSubject(null),
        IpCheckError: new Rx.BehaviorSubject(null),

        DscpAppBackupModeUpdated: new Rx.BehaviorSubject(null),
        DscpAppBackupModeError: new Rx.BehaviorSubject(null),
        DscpAppBackupModeSaved: new Rx.BehaviorSubject(null),
        DscpAppBackupModeSaveError: new Rx.BehaviorSubject(null),

    };
}

UlrDscpRulesManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrDscpRulesManager.prototype.CheckProtocol = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var protocol = typeof Params == "string" ? Params : (Params&&Params.protocol?("" + Params.protocol):"");

    var params =
        {
            id: webix.uid(),
            method:"UlrCheckDscpAppProtocol",
            data: {Protocol:protocol},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrAppProtocolRuleCheckModel(R.data);

                    _this.Signals.ProtocolCheckResult.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ProtocolCheckError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.SaveAppDscpRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var ruleModel = new UlrAppDscpRuleModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveDscpAppRule",
            data: {Rule:ruleModel},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrAppDscpRuleModel(R.data);

                    _this.Signals.AppDscpRuleSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.AppDscpRuleSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.DeleteAppDscpRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteDscpAppRule",
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrAppDscpRuleModel(R.data);

                    _this.Signals.AppDscpRuleDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.AppDscpRuleDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.EnableDisableAppDscpRule = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableDscpAppRule" : "UlrDisableDscpAppRule";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrAppDscpRuleModel(R.data);

                    _this.Signals.AppDscpRuleEnableStateUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.AppDscpRuleEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};



UlrDscpRulesManager.prototype.CheckAsn = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var protocol = Params&&Params.protocol?Params.protocol:"";

    var name = Params&&Params.name?Params.name:"";

    var rule_type_id = Params&&Params.rule_type_id?Params.rule_type_id:0;

    var params =
        {
            id: webix.uid(),
            method:"UlrCheckAsnDscpProtocol",
            data: {Protocol:protocol, Name:name, Type:rule_type_id},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrAsnProtocolRuleExistCheckModel(R.data);

                    _this.Signals.AsnCheckResult.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.AsnCheckError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.SaveAsnDscpRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var Rule = new UrlAsnDscpWithIspsRuleMode(Params);

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveAsnDscpRule",
            data: {Rule},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrAsnDscpRuleModel(R.data);

                    _this.Signals.AsnDscpRuleSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.AsnDscpRuleSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.DeleteAsnDscpRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteAsnDscpRule",
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrAsnDscpRuleModel(R.data);

                    _this.Signals.AsnDscpRuleDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.AsnDscpRuleDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.EnableDisableAsnDscpRule = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableAsnDscpRule" : "UlrDisableAsnDscpRule";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrAsnDscpRuleModel(R.data);

                    _this.Signals.AsnDscpRuleEnableStateUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.AsnDscpRuleEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};



UlrDscpRulesManager.prototype.CheckIp = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var protocol = Params&&Params.protocol?Params.protocol:"";

    var name = Params&&Params.name?Params.name:"";

    var rule_type_id = Params&&Params.rule_type_id?Params.rule_type_id:0;

    var params =
        {
            id: webix.uid(),
            method:"UlrCheckIpExcludeAsnRule",
            data: {Protocol:protocol, Name:name, Type:rule_type_id},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIpProtocolRuleExistCheckModel(R.data);

                    _this.Signals.IpCheckResult.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.IpCheckError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.SaveIpDscpRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var ruleModel = new UlrIpDscpRuleModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveIpExcludeAsnRule",
            data: {Rule:ruleModel},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIpDscpRuleModel(R.data);

                    _this.Signals.IpDscpRuleSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.IpDscpRuleSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.DeleteIpDscpRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteIpExcludeAsnRule",
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIpDscpRuleModel(R.data);

                    _this.Signals.IpDscpRuleDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.IpDscpRuleDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.EnableDisableIpDscpRule = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableIpExcludeAsnRule" : "UlrDisableIpExcludeAsnRule";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrIpDscpRuleModel(R.data);

                    _this.Signals.IpDscpRuleEnableStateUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.IpDscpRuleEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDscpRulesManager.prototype.UlrChangeDscpAppRulesEditMode = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrChangeDscpAppRulesEditMode",
            data: {Mode:parseInt(Params && Params.mode ? Params.mode : 0)},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DscpAppBackupModeSaved.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.DscpAppBackupModeSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
UlrDscpRulesManager.prototype.UlrGetDspAppModeEnabled = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetDspAppModeEnabled",
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.DscpAppBackupModeUpdated.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.DscpAppBackupModeError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

var UlrDicsEnum = {
    Categories:"Categories",
    Regulators:"Regulators"
};

function UlrDicModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.name = Params&&Params.name?Params.name:"";
    this.description = Params&&Params.description?Params.description:"";
    this.create_time = Params&&Params.create_time?Params.create_time:null;
    this.update_time = Params&&Params.update_time?Params.update_time:null;
}

function UlrDicsManager(Params)
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        DicItemSaved: new Rx.BehaviorSubject(null),
        DicItemSaveError: new Rx.BehaviorSubject(null),
        DicItemDeleted: new Rx.BehaviorSubject(null),
        DicItemDeleteError: new Rx.BehaviorSubject(null)
    };
}

UlrDicsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrDicsManager.prototype.SaveItem = function(Dic, Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var model = new UlrDicModel(Params);

    var method = "UlrSaveRuleCategory";

    if(Dic == UlrDicsEnum.Regulators)
        method = "UlrSaveRegulator";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Model:model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrDicModel(R.data);

                    _this.Signals.DicItemSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.DicItemSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrDicsManager.prototype.DeleteItem = function(Dic, Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var model = new UlrDicModel(Params);

    var method = "UlrDeleteRuleCategory";

    if(Dic == UlrDicsEnum.Regulators)
        method = "UlrDeleteRegulator";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Model:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrDicModel(R.data);

                    _this.Signals.DicItemDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.DicItemDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
var UlrUsersActionsLogCodesControllersMap = {
    web_ip_lock:"UlrEditWebIpFilterRule",
    //app_protocol_lock:"UlrAppDscpRules",
    //asn_lock:"UlrAsnDscpRules",
    //ip_exclude:"UlrIpExcludesRules",
    //asn_exclude:"UlrAsnExcludesRules",
    web_ip_white:"UlrEditWhiteListRule",
    igw_profile:"UlrEditIgw",
    subs_profile:"UlrEditSubs",
    mailing:"UlrEditMailing",
    mailing_templates:"UlrEditTemplateMailing",
    recipient_group:"UlrEditRecipientGroup",
    //node:"UlrIgwsNodesList",
    isp_profile:"UlrEditIsp",
    isp_policing:"UlrEditAppPolicing",
    //category:"UrlCategoriesDic",
    //regulator:"UrlRegulatorsDic"
    as_number:"UlrEditAsnDscpRule",
    igw_policing: "UlrEditIgwPolicing",
    subs_policing: "UlrEditSubscriberPolicing",
    subs_session_policing: "UlrEditSubscriberSessionPolicing",
    isp_session_policing: "UlrEditIspSessionPolicing",
    excluded_resources: "UlrExcludedResources",
    custom_groups_of_protocols: "UlrCustomGroupsOfProtocols",
    spoof_dns: "UlrEditSpoofDnsRule",
    session_policing_template: "UlrEditSessionPolicingTemplate",
    policing_template: ""
};

var UlrUsersActionsLogTypesCodesListsControllersMap =
{
    web_ip_lock:"UlrWebIpFilterRules",
    spoof_dns:"UlrSpoofDnsRules",
    app_protocol_lock:"UlrAppDscpRules",
    asn_lock:"UlrAsnDscpRules",
    ip_exclude:"UlrIpExcludesRules",
    asn_exclude:"UlrAsnExcludesRules",
    web_ip_white:"UlrAsnExcludesRules",
    igw_profile:"UlrIgwsList",
    subs_profile:"UlrSubsList",
    node:"UlrIgwsNodesList",
    isp_profile:"UlrIspsList",
    isp_policing:"UlrAppPolicings",
    mailing:"UlrMailingList",
    mailing_templates:"UlrMailingTemplatesList",
    recipient_group:"UlrRecipientGroupList",
    category:"UrlCategoriesDic",
    regulator:"UrlRegulatorsDic",
    white_list_global_state:"UlrWhiteListMode",
    as_number:"UlrAsnRuleList",
    vip_subscriber: "UlrVipSubscribersRules",
    traffic_redirection: "UlrTrafficRedirectionRules",
    pcap_recording: "UlrRecordPCAP",
    igw_policing: "UlrIgwPolicings",
    subs_policing: "UlrSubscribersPolicings",
    subs_session_policing: "UlrSubscribersSessionPolicings",
    isp_session_policing: "UlrIspSessionPolicings",
    excluded_resources: "UlrExcludedResources",
    custom_groups_of_protocols: "UlrCustomGroupsOfProtocols",
    ulr_fastresource_custom_prtcls: "UlrFastresourceCustomPrtcls",
    session_policing_template: "UlrSessionPolicingsTemplates",
    policing_template: ""
};

function UlrUsersActionsLogManager(Params)
{
    this.Active = true;

    this.Signals = {};
}

UlrUsersActionsLogManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};


function UlrMailingManager (Params){
    this.Active = true;

    this.QueriesData = [];

    this.RecipientGroupDics = {
        InitialDataDic:{},
        AddedDataDic:{},
        RemovedDataDic:{},
        GroupIdsArr:[],
    };

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        MailingUpdated: new Rx.BehaviorSubject(null),
        MailingError: new Rx.BehaviorSubject(null),
        MailingSaved: new Rx.BehaviorSubject(null),
        MailingSaveError: new Rx.BehaviorSubject(null),
        MailingDeleted: new Rx.BehaviorSubject(null),
        MailingDeleteError: new Rx.BehaviorSubject(null),

        MailingEnableStateUpdated: new Rx.BehaviorSubject(null),
        MailingEnableStateError: new Rx.BehaviorSubject(null),

        RecipientGroupGet: new Rx.BehaviorSubject(null),
        RecipientGroupGetError: new Rx.BehaviorSubject(null),

        MailingForceRunSuccess: new Rx.BehaviorSubject(null),
        MailingForceRunError: new Rx.BehaviorSubject(null)
    };

}

function UlrMailingModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.name = Params&&Params.name?Params.name:"";
    this.subject = Params&&Params.subject?Params.subject:"";
    this.email_tpl = Params&&Params.email_tpl?Params.email_tpl:"";
    this.telegram_tpl = Params&&Params.telegram_tpl?Params.telegram_tpl:"";
    this.queries_json = Params&&Params.queries_json?Params.queries_json:"";
    this.schedule_config_json = Params&&Params.schedule_config_json?Params.schedule_config_json:"";
    this.group_ids = Params&&Params.group_ids?Params.group_ids:"";
    this.enabled = Params&&Params.enabled?Params.enabled:0;
}

function UlrMailingViewModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.name = Params&&Params.name?Params.name:"";
    this.subject = Params&&Params.subject?Params.subject:"";
    this.email_tpl = Params&&Params.email_tpl?Params.email_tpl:"";
    this.telegram_tpl = Params&&Params.telegram_tpl?Params.telegram_tpl:"";
    this.queries_json = Params&&Params.queries_json?Params.queries_json:"";
    this.schedule_config_json = Params&&Params.schedule_config_json?Params.schedule_config_json:"";
    this.group_ids = Params&&Params.group_ids?Params.group_ids:"";
    this.enabled = Params&&Params.enabled?Params.enabled:0;

    this.state_code = Params && Params.state_code ? Params.state_code : "";
    this.state_date = Params && Params.state_date ? Params.state_date : "";
    this.state_err = Params && Params.state_err ? Params.state_err : "";
    this.state_progress = Params && Params.state_progress ? Params.state_progress : "";
}

function UlrRichSelectRecipientGroupModel(Params)
{
    this.id = Params&&Params._id ? Params._id : 0;
    this.value = Params&&Params.name?Params.name:"";
}

UlrMailingManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrMailingManager.prototype.ResfreshMailing = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var id = Params&&Params._id ? Params._id : 0;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetMailingById",
            data: {Id:id},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrMailingModel(R.data);

                    if (model.queries_json)
                        _this.QueriesData = JSON.parse(model.queries_json);

                    _this.Signals.MailingUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.MailingError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrMailingManager.prototype.SaveMailing = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveMailing",
            data: {Mailing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrMailingModel(R.data);

                    _this.Signals.MailingSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.MailingSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrMailingManager.prototype.DeleteMailing = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteMailing",
            data: {Mailing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrMailingModel(R.data);

                    _this.Signals.MailingDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.MailingDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrMailingManager.prototype.EnableDisableMailing = function(Params, Enable)
{
    var _this = this;

    if(!this.Active)
        return;

    var method = Enable ? "UlrEnableMailing" : "UlrDisableMailing";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Mailing:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrMailingModel(R.data);

                    _this.Signals.MailingEnableStateUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.MailingEnableStateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrMailingManager.prototype.ForceRunMailing = function(Params, ReportTime = "")
{
    var _this = this;

    if(!this.Active)
        return;

    var method = "UlrForceRunMailing";

    var params =
        {
            id: webix.uid(),
            method:method,
            data: {Mailing:Params, ReportTime:ReportTime},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrMailingViewModel(R.data);

                    _this.Signals.MailingForceRunSuccess.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.MailingForceRunError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrMailingManager.prototype.GetRecipientGroups = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetRecipientGroupList",
            data: {Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.RecipientGroupGet.next(R.data.rows);
                }
                else if(!R.success && R.error)
                    _this.Signals.RecipientGroupError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrMailingManager.prototype.RecipientGroupsParseToRichSelectModel = function (Arr)
{
    "use strict";

    var result = [];

    if(Arr)
    {
        Object.keys(Arr).forEach(function (Key) {
            result.push(new UlrRichSelectRecipientGroupModel(Arr[Key]));
        });
    }

    return result;
};

UlrMailingManager.prototype.RecipientGroupsArrDicToArr = function(GroupDic)
{
    var arr = [];

    if(GroupDic)
    {
        Object.keys(GroupDic).forEach(function (Key)
        {
            arr.push(GroupDic[Key]);
        });
    }

    return arr;
};
function UlrMailingTemplateManager(Params)
{
    this.Active = true;

    this.Signals =
    {
        Progress: new Rx.BehaviorSubject(null),

        MailingTemplateUpdated: new Rx.BehaviorSubject(null),
        MailingTemplateError: new Rx.BehaviorSubject(null),
        MailingTemplateSaved: new Rx.BehaviorSubject(null),
        MailingTemplateSaveError: new Rx.BehaviorSubject(null),
        MailingTemplateDeleted: new Rx.BehaviorSubject(null),
        MailingTemplateDeleteError: new Rx.BehaviorSubject(null),
    };
}

function UlrMailingTemplateModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.name = Params&&Params.name ? Params.name : "";
    this.template = Params&&Params.template ? Params.template : "";
}

UlrMailingTemplateManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrMailingTemplateManager.prototype.RefreshMailingTemplate = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var id = Params&&Params._id ? Params._id : 0;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetMailingTemplateById",
            data: {Id:id},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrMailingTemplateModel(R.data);

                    _this.Signals.MailingTemplateUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.MailingTemplateError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrMailingTemplateManager.prototype.SaveMailingTemplate = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveMailingTemplate",
            data: {MailingTemplate:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrMailingTemplateModel(R.data);

                    _this.Signals.MailingTemplateSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.MailingTemplateSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrMailingTemplateManager.prototype.DeleteMailingTemplate = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteMailingTemplate",
            data: {MailingTemplate:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrMailingTemplateModel(R.data);

                    _this.Signals.MailingTemplateDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.MailingTemplateDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
function UlrRecipientGroupManager (Params){
    this.Active = true;

    this.ContactsDics = {
        InitialDataDic:{},
        AddedDataDic:{},
        RemovedDataDic:{}
    };

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        RecipientGroupUpdated: new Rx.BehaviorSubject(null),
        RecipientGroupError: new Rx.BehaviorSubject(null),
        RecipientGroupSaved: new Rx.BehaviorSubject(null),
        RecipientGroupSaveError: new Rx.BehaviorSubject(null),
        RecipientGroupDeleted: new Rx.BehaviorSubject(null),
        RecipientGroupDeleteError: new Rx.BehaviorSubject(null),
        ContactsInitialDataDicUpdated: new Rx.BehaviorSubject(null)
    };

}

UlrRecipientGroupManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrRecipientGroupManager.prototype.SaveRecipientGroup = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveRecipientGroup",
            data: {RecipientGroup:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrRecipientGroupModel(R.data);

                    _this.Signals.RecipientGroupSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RecipientGroupSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrRecipientGroupManager.prototype.DeleteRecipientGroup = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteRecipientGroup",
            data: {RecipientGroup:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrRecipientGroupModel(R.data);

                    _this.Signals.RecipientGroupDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RecipientGroupDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

function UlrRecipientGroupModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.name = Params&&Params.name ? Params.name : "";
    this.description = Params&&Params.description ? Params.description : "";
    this.contacts_json = Params&&Params.contacts_json ? Params.contacts_json : "";
}

function UlrRecipientContactViewModel(Params)
{
    this._id = Params&&Params._id ? Params._id : "";
    this.type = Params&&Params.type ? Params.type : "";
    this.value = Params&&Params.value ? Params.value : "";
}

function UlrRecipientContactModel(Params)
{
    this.type = Params&&Params.type ? Params.type : "";
    this.value = Params&&Params.value ? Params.value : "";
}

UlrRecipientGroupManager.prototype.RefreshRecipientGroup = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var id = Params&&Params._id ? Params._id : 0;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetRecipientGroupById",
            data: {Id:id},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrRecipientGroupModel(R.data);

                    _this.Signals.RecipientGroupUpdated.next(model);

                    if (model._id)
                    {
                        _this.ContactsDics.InitialDataDic = _this.ContactsArrToDic(JSON.parse(model.contacts_json));
                        _this.Signals.ContactsInitialDataDicUpdated.next(1);
                    }
                }
                else if(!R.success && R.error)
                    _this.Signals.RecipientGroupError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrRecipientGroupManager.prototype.ContactsArrDicToArr = function(GroupDic)
{
    var arr = [];

    if(GroupDic)
    {
        Object.keys(GroupDic).forEach(function (Key)
        {
            arr.push(GroupDic[Key]);
        });
    }

    return arr;
};

UlrRecipientGroupManager.prototype.ContactsArrToDic = function(ContactsArr)
{
    var dic = {};
    
    if(ContactsArr)
    {
        let i = 0;
        ContactsArr.forEach(function (ContactModel)
        {
            dic[i] = new UlrRecipientContactModel(ContactModel);
            i = i+1;
        });
    }

    return dic;
};
function DatetimePickerManager() {

    let scheduleConfigJson = "";
}

DatetimePickerManager.prototype.SetScheduleConfigJson = function (scheduleConfigJson){

    var _this = this;

    _this.scheduleConfigJson = scheduleConfigJson;
}

DatetimePickerManager.prototype.GetScheduleConfigJson = function (){

    var _this = this;

    return _this.scheduleConfigJson;
}

DatetimePickerManager.prototype.ClearScheduleConfigJson = function (){

    var _this = this;

    _this.scheduleConfigJson = "";
}

function DateTimePickerCheckWeekday(Params, Value)
{
    return Params&&Params.weekday?(Params.weekday.some(day => day == Value)?1:0):0;
}

function DateTimePickerCheckWeekdays(Params, Start = 1, End = 7)
{
    let result = [];

    for (Start; Start <= End; Start++)
    {
        result[Start] = DateTimePickerCheckWeekday(Params, Start);
    }

    return result;
}

function DatetimePickerDateModel(Params)
{
    return {
        weekday: Params&&Params.weekday?Params.weekday:[],

        ...DateTimePickerCheckWeekdays(Params)
    }
};

function DatetimePickerModel(Params)
{
    return {
        startTime: Params&&Params.startTime?Params.startTime:"",

        endTime : Params&&Params.endTime?Params.endTime:"",

        reportTime : Params&&Params.reportTime?Params.reportTime:"",

        ...DatetimePickerDateModel(Params)
    }
};

function DatetimePickerLocalTimeModel(Params)
{
    return {
        startTime: Params&&Params.startTime?Helper.ConvertTimeUtcToLocal(Params.startTime):"",

        endTime : Params&&Params.endTime?Helper.ConvertTimeUtcToLocal(Params.endTime):"",

        reportTime : Params&&Params.reportTime?Helper.ConvertTimeUtcToLocal(Params.reportTime):"",

        ...DatetimePickerDateModel(Params)
    }
};
function PCAPFileTableContentModel(Params)
{
    this.id = webix.uid();
    this.time = Params&&Params.time?Params.time:"";
    this.source = Params&&Params.source?Params.source:"";
    this.destination = Params&&Params.destination?Params.destination:"";
    this.info = Params&&Params.info?Params.info:"";
}

function UlrPCAPRecordFileModel(Params)
{
    var __this = this;

    this.path = Params&&Params.path?Params.path:null;
    this.filename = Params&&Params.filename?Params.filename:null;
    this.size = Params && Params.size ? Params.size:0;
    this.hardware_id =  Params && Params.hardware_id ? Params.hardware_id:null;

    if(Params && Params.atime)
    {
        this.atime = new Date(Params.atime*1000);
    }

    if(Params && Params.mtime)
    {
        this.mtime = new Date(Params.mtime*1000);
    }

    this.data = null;

    if(Params&&Params.data)
    {
        this.data = [];

        if (Array.isArray(Params.data)) {
            Params.data.forEach(function (Item)
            {
                __this.data.push(new UlrPCAPRecordFileModel(Item));
            });
        } else {
            for (const key in Params.data) {
                __this.data.push(new UlrPCAPRecordFileModel(Params.data[key]));
            }
        }
    }
}

function UlrPCAPRecordDirModel(Params)
{
    var __this = this;

    this.path = Params&&Params.path?Params.path:null;
    this.filename = Params&&Params.filename?Params.filename:null;
    this.hardware_id =  Params && Params.hardware_id ? Params.hardware_id:null;
    this.error =  Params && Params.error ? Params.error:null;
    this.count_files = Params && Params.count_files ? Params.count_files : 0;

    if(Params && Params.atime)
    {
        this.atime = new Date(Params.atime*1000);
    }

    if(Params && Params.mtime)
    {
        this.mtime = new Date(Params.mtime*1000);
    }

    this.data = null;

    if(Params&&Params.data)
    {
        this.data = [];

        for (const key in Params.data) {
            __this.data.push(new UlrPCAPRecordDirModel(Params.data[key]));
        }
    }
}

function UlrPCAPRecordManager(Params)
{
    this.CurrentHwId = 0;

    this.Active = true;

    this.Signals = {
        FilesListLoading: new Rx.BehaviorSubject(null),
        FilesListLoaded: new Rx.BehaviorSubject(null),
        FilesListLoadError: new Rx.BehaviorSubject(null),
        DirListLoading: new Rx.BehaviorSubject(null),
        DirListLoaded: new Rx.BehaviorSubject(null),
        DirListLoadError: new Rx.BehaviorSubject(null)
    };

    this.SignalStatLogTailUpdated = new Rx.BehaviorSubject(0);

    this.ConstPCAPFileTail = 1000;
    this.PCAPFileTailData = "";
    this.PCAPFileTailTableData = "";
}

UlrPCAPRecordManager.prototype.Destroy = function ()
{
    this.Active = false;
};

UlrPCAPRecordManager.prototype.RefreshFilesList = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method: "GetPCAPFilesList",
            data: {
                Id: parseInt(Params.hardware_id),
                Dir: Params.dir
            },
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.FilesListLoading.next(0);

                if(R.success)
                {
                    var model = [];

                    for (const item in R.data) {
                        model.push(new UlrPCAPRecordFileModel(R.data[item]));
                    }

                    _this.Signals.FilesListLoaded.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.FilesListLoadError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.FilesListLoading.next(1);

    App.ServerManager.CallMethod(params);
};

UlrPCAPRecordManager.prototype.RefreshDirList = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method: "GetPCAPDirList",
            data: {},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.DirListLoading.next(0);

                if(R.success)
                {
                    var model = [];

                    for (const item in R.data) {
                        model.push(new UlrPCAPRecordDirModel(R.data[item]));
                    }

                    _this.Signals.DirListLoaded.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.DirListLoadError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.FilesListLoading.next(1);

    App.ServerManager.CallMethod(params);
};

UlrPCAPRecordManager.prototype.DownloadPCAPFile = function (Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            method:"DownloadPCAPResultFile",
            data:{
                Filenames:Params.filenames,
                Id: Params.hardware_id
            },
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                if(R.success)
                {
                    App.ServerManager.RedirectToFilesDownload(R.data, "?need_hash=false");
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

UlrPCAPRecordManager.prototype.DeletePCAPFile = function(Params)
{
    if(!this.Active)
        return;

    var params =
        {
            method:"DeletePCAPFile",
            data: {
                FileNames: Params.filenames,
                HwId: Params.hardware_id
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

UlrPCAPRecordManager.prototype.ClearPCAPDir = function(Params)
{
    if(!this.Active)
        return;

    var params =
        {
            method:"ClearPCAPDir",
            data: {
                DirNames: Params.dirnames,
                HwId: Params.hardware_id
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

UlrPCAPRecordManager.prototype.DeletePCAPDir = function(Params)
{
    if(!this.Active)
        return;

    var params =
        {
            method:"DeletePCAPDir",
            data: {
                DirNames: Params.dirnames,
                HwId: Params.hardware_id
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

UlrPCAPRecordManager.prototype.RefreshPCAPFileTail = function (Params)
{
    var _this = this;

    if(!_this.Active)
        return;

    var params =
        {
            method:"GetPCAPFileTail",
            data: {
                FileName: Params.filename,
                Tail:Params&&Params.tail?Params.tail:_this.ConstPCAPFileTail,
                HwId: parseInt(Params.hardware_id)
            },
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                if(R.success)
                {
                    _this.PCAPFileTailData = "";

                    if(R.data)
                    {
                        _this.PCAPFileTailData = R.data;
                    }

                    _this.SignalStatLogTailUpdated.next(1);

                }

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(!R.success)
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

UlrPCAPRecordManager.prototype.GetPCAPFileTableTail = function()
{
    this.ParsePCAPFileTail();
    return this.PCAPFileTailTableData;
};

UlrPCAPRecordManager.prototype.ParsePCAPFileTail = function()
{
    var _this = this;

    var lines = this.PCAPFileTailData.split("\n");

    this.PCAPFileTailTableData = [];

    lines.forEach(function (Line)
    {
        try
        {
            var infoSplit = Line.split(": ");
            var info = infoSplit[1];
            var cols = infoSplit[0].split(" ");

            var obj =
                {
                    time: cols[0],
                    source: cols[2],
                    destination: cols[4],
                    info: info
                };

            _this.PCAPFileTailTableData.push(new PCAPFileTableContentModel(obj));
        }
        catch(e)
        {}

    });
};
function UlrSpoofDnsRuleModel(Params)
{
    this._id = Params&&Params._id ? Params._id : 0;
    this.enabled = Params&&Params.enabled ? Params.enabled : 0;

    this.type_id = Params&&Params.type_id ? Params.type_id : 0;
    this.mode_id = Params&&Params.mode_id ? Params.mode_id : 0;
    this.subs_mode_id = Params&&Params.subs_mode_id ? Params.subs_mode_id : 0;
    this.regulator_id = Params&&Params.regulator_id ? Params.regulator_id : 0;
    this.category_id = Params&&Params.category_id ? Params.category_id : 0;

    this.name = Params&&Params.name ? Params.name : null;
    this.description_public = Params&&Params.description_public ? Params.description_public.trim() : null;
    this.description_private = Params&&Params.description_private ? Params.description_private.trim() : null;
}

function UlrSpoofDnsRuleResourceModel(Params)
{
    this.type_id = Params&&Params.type_id?Params.type_id:1;
    this.rule_id = Params&&Params.rule_id?Params.rule_id:null;
    this.enabled = Params&&Params.enabled?Params.enabled:0;
    this.resource_raw = Params&&Params.resource_raw?Params.resource_raw:null;
    this.resource_validated = Params&&Params.resource_validated?Params.resource_validated:null;
    this.exclusion = Params&&Params.exclusion?Params.exclusion:0;
    this.state_valid = Params&&Params.state_valid?Params.state_valid:0;
    this.state_error = Params&&Params.state_error?Params.state_error:0;
    this.state = Params&&Params.state?Params.state:"";
}

function UlrSpoofDnsRuleViewModel(Params)
{
    this.profile = Params&&Params.profile ? Params.profile : null;
    this.resources = Params&&Params.resources ? Params.resources : null;
    this.isps = Params&&Params.isps ? Params.isps : null;
    this.dics = Params&&Params.dics ? Params.dics : 0;
}

function UlrSpoofDnsRulesManager()
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),

        RuleProfileUpdated: new Rx.BehaviorSubject(null),
        RuleProfileError: new Rx.BehaviorSubject(null),
        RuleProfileSaved: new Rx.BehaviorSubject(null),
        RuleProfileSaveError: new Rx.BehaviorSubject(null),
        RuleEnableStateUpdated: new Rx.BehaviorSubject(null),
        RuleEnableStateError: new Rx.BehaviorSubject(null),
        RuleProfileDeleted: new Rx.BehaviorSubject(null),
        RuleProfileDeleteError: new Rx.BehaviorSubject(null)
    };

}

UlrSpoofDnsRulesManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrSpoofDnsRulesManager.prototype.ResfreshSpoofDnsProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var ruleId = Params&&Params._id ? Params._id : 0;

    var defaultTypeId = Params&&Params.type_id ? Params.type_id : null;

    var params =
        {
            id: webix.uid(),
            method:"UlrGetWebRuleById",
            data: {Id:ruleId, DefaultTypeId:defaultTypeId},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrSpoofDnsRuleViewModel(R.data);
                    model.profile = new UlrSpoofDnsRuleModel(model.profile);

                    Object.keys(model.dics).forEach(function (Key)
                    {
                        if(Key === DicsEnum.UlrIspsDic || Key === DicsEnum.UlrSubscribersDic)
                        {
                            App.DicsManager.SetDic(Key, model.dics[Key], UlrIspSubsDicModel);
                        }
                        else
                            App.DicsManager.SetDic(Key, model.dics[Key]);
                    });

                    _this.Signals.RuleProfileUpdated.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleProfileError.next(new ServerErrorModel(R.error));

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrSpoofDnsRulesManager.prototype.SaveSpoofDnsRuleProfile = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var params =
        {
            id: webix.uid(),
            method:"UlrSaveSpoofDnsRule",
            data: {Rule:Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrSpoofDnsRuleViewModel(R.data);

                    _this.Signals.RuleProfileSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleProfileSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrSpoofDnsRulesManager.prototype.DeleteSpoofDnsRule = function(Params)
{
    var _this = this;

    if(!this.Active)
        return;

    var model = Params&&Params.profile ? Params.profile : Params;

    var params =
        {
            id: webix.uid(),
            method:"UlrDeleteSpoofDnsRule",
            data: {Rule:model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new UlrSpoofDnsRuleModel(R.data);

                    _this.Signals.RuleProfileDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.RuleProfileDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
function SshTerminalManager(Params)
{
    "use strict";
    this.Dic = null;
    this.HardwareType = Params && Params.hardware_type ? Params.hardware_type : "system";
    this.DicStr = this.HardwareType + "SshTerminalCommandsDic";
    this.Signals = {
        SignalDicsUpdated: new Rx.BehaviorSubject(0)
    };

    return this;
}

SshTerminalManager.prototype.InitDicsIfNeed = function()
{
    if(!window[this.DicStr])
        this.RefreshDics();
    else{
        this.Dic = window[this.DicStr];

        this.Signals.SignalDicsUpdated.next(1);
    }
};

SshTerminalManager.prototype.GetDic = function()
{
  return webix.copy(window[this.DicStr]);
};

SshTerminalManager.prototype.RefreshDics = function()
{
    var _this = this;

    var params = {
        method: "GetHardwareSshCommandsDic",
        data: {
            HardwareType: this.HardwareType
        },
        callback:function (R)
        {
            if(R.success)
            {
                var dic = [];
                var groups = R.data.groups;
                var groups_ui = R.data.groups_ui;
                var commands = R.data.commands;
                var commands_ui = R.data.commands_ui;
                var locale = LangHelper.GetLocale();

                var parse_gui = function(gui)
                {
                    var result = gui ? gui : {};

                    if(result && result.popup)
                    {
                        if(result.popup.text && result.popup.text[locale])
                        {
                            result.popup.text = result.popup.text[locale];
                        }
                        else{
                            result.popup.text = "";
                        }
                    }

                    return result;
                }

                Object.keys(groups).forEach(function(GroupKey){
                    var gr = {
                        id: GroupKey,
                        title: groups[GroupKey].title[locale],
                        description: groups[GroupKey].description[locale],
                        gui: parse_gui(groups_ui[GroupKey] && groups_ui[GroupKey].gui ? groups_ui[GroupKey].gui : (groups[GroupKey].gui ? groups[GroupKey].gui : {})),
                        data: [],
                        wiki: groups[GroupKey].wiki &&  groups[GroupKey].wiki[locale] ? groups[GroupKey].wiki[locale] : ""
                    };

                    groups[GroupKey].commands.forEach(function(Command){
                        if(commands && commands[Command])
                        {
                            var cmd = {
                                id: commands[Command].id,
                                command: commands[Command].command,
                                title: commands[Command].title[locale],
                                description: commands[Command].description[locale],
                                gui: parse_gui(commands_ui[Command] && commands_ui[Command].gui ? commands_ui[Command].gui : (commands[Command].gui ? commands[Command].gui : {})),
                                wiki: commands[Command].wiki &&  commands[Command].wiki[locale] ? commands[Command].wiki[locale] : ""
                            };

                            gr.data.push(cmd);
                        }
                    });

                    dic.push(gr);
                });
                window[_this.DicStr] = dic;
                _this.Dic = dic;
            }
            else
            {
                webix.message({type:"error", text:R.error.msg});

                webix.alert({
                    title: LangHelper.GetString("All", "Error"),
                    text: LangHelper.GetString("All", "Commands dictionaries  could not be loaded") + ".<br/>" + LangHelper.GetString("All", "Error") + ":<br/>" + R.error.msg,
                    type:"alert-error",
                    width:600
                });
            }

            _this.Signals.SignalDicsUpdated.next(1);
        }
    };

    App.ServerManager.CallMethod(params);
};

SshTerminalManager.prototype.ConnectToTerminal = function(HardwareId, RoomId)
{
    var _this = this;

    var hId = HardwareId ? HardwareId : App.SessionManager.GetCurrentHardwareId();
    if(hId)
    {
        hId = parseInt(hId);
    }
    var params ={
        id:webix.uid(),
        method:"HardwareSshConnect",
        data:{
            HardwareId: hId,
            Room: RoomId
        },
        callback:function (R)
        {
            if(!R.success)
            {
                webix.message({type:"error", text:R.error.msg});

                webix.alert({
                    title: LangHelper.GetString("All", "Error"),
                    text: LangHelper.GetString("All", "Can not connect to hardware") + ".<br/>" + LangHelper.GetString("All", "Error") + ":<br/>" + R.error.msg,
                    type:"alert-error",
                    width:600
                });
            }
        }
    };

    App.ServerManager.CallMethod(params);
};
function UlrFastresourceCustomPrtclModel(Params)
{
    this._id = Params && Params._id ? parseInt(Params._id) : 0;

    this.custom_protocol_port = Params && Params.custom_protocol_port ? parseInt(Params.custom_protocol_port) : 0;
    this.qoe_table = Params && Params.qoe_table ? Params.qoe_table : "";
    this.config_json = Params && Params.config_json ? Params.config_json : null;
    this.enabled = Params && Params.enabled ? parseInt(Params.enabled ) : 0;

    this.create_time = Params && Params.create_time ? Params.create_time : null;
    this.create_user = Params && Params.create_user ? Params.create_user : null;

    this.update_time = Params && Params.update_time ? Params.update_time : null;
    this.update_user = Params && Params.update_user ? Params.update_user : null;
}

function UlrFastresourceCustomPrtclsManager(Params)
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null)
    };
}

UlrFastresourceCustomPrtclsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

UlrFastresourceCustomPrtclsManager.prototype.SaveRule = function(Params)
{
    var _this = this;
    if(!this.Active)
        return;

    var params = {
        id: webix.uid(),
        method: "UlrFastresourceCustomPrtclsSave",
        data: {Rule: Params.rule},
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrFastresourceCustomPrtclsManager.prototype.DeleteRule = function(Params)
{
    var _this = this;
    if(!this.Active)
        return;

    var params =  {
        id: webix.uid(),
        method: "UlrFastresourceCustomPrtclsDelete",
        data: {Rule: Params.rule},
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

UlrFastresourceCustomPrtclsManager.prototype.EnableDisableRule = function(Params)
{
    var _this = this;
    if(!this.Active)
        return;

    var params = {
        id: webix.uid(),
        method: "UlrFastresourceCustomPrtclsEnabledDisable",
        data: {
            Rule: Params.rule,
            Enable: parseInt(Params.enable)
        },
        callback: function(R)
        {
            if(!_this.Active)
                return;

            _this.Signals.Progress.next(0);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }
    };

    this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};



function ClassifierCategoriesFormModel(Params)
{
    var __this = this;

    this._id = Params&&Params._id?Params._id:0;
    this.name = Params&&Params.name?Params.name:"";
    this.name_json = Params&&Params.name_json?Params.name_json:"";
    this.code = Params&&Params.code?Params.code:"";
}

function ClassifierCategoriesManager(Params)
{
    this.Categories = {};

    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),
        ClassifierSaved: new Rx.BehaviorSubject(null),
        ClassifierSaveError: new Rx.BehaviorSubject(null),
        ClassifierDeleted: new Rx.BehaviorSubject(null),
        ClassifierDeleteError: new Rx.BehaviorSubject(null),
        ClassifierRecheckCategory: new Rx.BehaviorSubject(null),
        ClassifierRecheckCategoryError: new Rx.BehaviorSubject(null)
    };
}

ClassifierCategoriesManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

ClassifierCategoriesManager.prototype.Save = function(Params)
{
    _this = this;
    var Model = new ClassifierCategoriesFormModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_SaveCategory",
            data: {Params: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new ClassifierCategoriesFormModel(R.data);

                    model['name_json'] = JSON.stringify(Model['name']);

                    _this.Signals.ClassifierSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierCategoriesManager.prototype.Delete = function(Params)
{
    _this = this;
    var Model = new ClassifierCategoriesFormModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_DeleteCategory",
            data: {Params: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    var model = new ClassifierCategoriesFormModel(R.data);

                    _this.Signals.ClassifierDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierCategoriesManager.prototype.RecheckCategory = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_RecheckCategory",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                if(R.success)
                    _this.Signals.ClassifierRecheckCategory.next(R.success);
                else if(!R.success && R.error)
                    _this.Signals.ClassifierRecheckCategoryError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};



function ClassifierHostsFormModel(Params)
{
    var __this = this;

    this._id = Params&&Params._id?Params._id:0;
    this.cat_id = Params&&Params.cat_id?Params.cat_id:0;
    this.host = Params&&Params.host?Params.host:"";
    this.name = Params&&Params.name?Params.name:"";
    this.name_json = Params&&Params.name_json?Params.name_json:"";
}

function ClassifierHostsManager(Params)
{
    this.Active = true;

    this.Signals = {
        ProgressHosts: new Rx.BehaviorSubject(null),
        ClassifierHostsSaved: new Rx.BehaviorSubject(null),
        ClassifierHostsSaveError: new Rx.BehaviorSubject(null),
        ClassifierHostsDeleted: new Rx.BehaviorSubject(null),
        ClassifierHostsDeleteError: new Rx.BehaviorSubject(null),
        ClassifierHostsErased: new Rx.BehaviorSubject(null),
        ClassifierHostsEraseError: new Rx.BehaviorSubject(null),
        ClassifierHostsGetHtmlText: new Rx.BehaviorSubject(null),
        ClassifierHostsGetHtmlTextError: new Rx.BehaviorSubject(null),
        ClassifierHostsGetHtmlTextFile: new Rx.BehaviorSubject(null),
        ClassifierHostsGetHtmlTextFileError: new Rx.BehaviorSubject(null),
        ClassifierHostsMachineLearningSaved: new Rx.BehaviorSubject(null),
        ClassifierHostsMachineLearningSaveError: new Rx.BehaviorSubject(null),
        ClassifierHostsCheck: new Rx.BehaviorSubject(null),
        ClassifierHostsCheckError: new Rx.BehaviorSubject(null),
        ClassifierHostsRecheck: new Rx.BehaviorSubject(null),
        ClassifierHostsRecheckError: new Rx.BehaviorSubject(null)
    };
}

ClassifierHostsManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

ClassifierHostsManager.prototype.Save = function(Params)
{
    _this = this;
    var Model = new ClassifierHostsFormModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_SaveHost",
            data: {Params: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.ProgressHosts.next(0);

                if(R.success)
                {
                    var model = new ClassifierHostsFormModel(R.data);

                    _this.Signals.ClassifierHostsSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierHostsSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.ProgressHosts.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierHostsManager.prototype.SetCategoryHost = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_SetCategoryHost",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.ProgressHosts.next(0);

                if(R.success)
                {
                    var model = new ClassifierHostsFormModel(R.data);

                    _this.Signals.ClassifierHostsSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierHostsSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.ProgressHosts.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierHostsManager.prototype.Delete = function(Params)
{
    _this = this;

    var Model = new ClassifierHostsFormModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_DeleteHost",
            data: {Params: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.ProgressHosts.next(0);

                if(R.success)
                {
                    var model = new ClassifierHostsFormModel(R.data);

                    _this.Signals.ClassifierHostsDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierHostsDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.ProgressHosts.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierHostsManager.prototype.DeleteSelect = function(Params)
{
    _this = this;

    //var Model = new ClassifierHostsFormModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_DeleteSelectHost",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.ProgressHosts.next(0);

                if(R.success)
                {
                    var model = new ClassifierHostsFormModel(R.data);

                    _this.Signals.ClassifierHostsDeleted.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierHostsDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.ProgressHosts.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierHostsManager.prototype.Erase = function(Params)
{
    var _this = this;

    var Model = new ClassifierHostsFormModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_EraseHost",
            data: {Params: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.ProgressHosts.next(0);

                if(R.success)
                {
                    var model = new ClassifierHostsFormModel(R.data);

                    _this.Signals.ClassifierHostsErased.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierHostsEraseError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

ClassifierHostsManager.prototype.Import = function(Params)
{
    var _this = this;

    var listItems = Params&&Params.list_items?Params.list_items:null;

    var params =
        {
            method:"Clsfr_ImportHosts",
            data: {
                Items: listItems
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};



ClassifierHostsManager.prototype.Check = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_Check",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.ProgressHosts.next(0);

                if(R.success)
                    _this.Signals.ClassifierHostsCheck.next(R.data);
                else if(!R.success && R.error)
                    _this.Signals.ClassifierHostsCheckError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.ProgressHosts.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierHostsManager.prototype.GetHtmlText = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_GetHtmlText",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.ProgressHosts.next(0);

                if(R.success)
                    _this.Signals.ClassifierHostsGetHtmlText.next(R.data);
                else if(!R.success && R.error)
                    _this.Signals.ClassifierHostsGetHtmlTextError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.ProgressHosts.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierHostsManager.prototype.GetHtmlTextFile = function(Params)
{
    __this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_GetHtmlTextFile",
            data: {Params: Params},
            callback:function (R)
            {
                if(!__this.Active)
                    return;

                __this.Signals.ProgressHosts.next(0);

                if(R.success)
                    __this.Signals.ClassifierHostsGetHtmlTextFile.next(R.data);
                else if(!R.success && R.error)
                    __this.Signals.ClassifierHostsGetHtmlTextFileError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    __this.Signals.ProgressHosts.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierHostsManager.prototype.SetCategory = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_SetCategory",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.ProgressHosts.next(0);

                if(R.success)
                {
                    var model = new ClassifierHostsFormModel(R.data);

                    _this.Signals.ClassifierHostsMachineLearningSaved.next(model);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierHostsMachineLearningSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.ProgressHosts.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierHostsManager.prototype.RecheckHosts = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_RecheckHosts",
            data: {Ids: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                if(R.success)
                    _this.Signals.ClassifierHostsRecheck.next(R.success);
                else if(!R.success && R.error)
                    _this.Signals.ClassifierHostsRecheckError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
function ClassifierModelManager(Params)
{
    this.Active = true;

    this.Signals = {
        Progress: new Rx.BehaviorSubject(null),



        //GetConfig
        ClassifierGetConfig: new Rx.BehaviorSubject(null),
        ClassifierGetConfigError: new Rx.BehaviorSubject(null),



        //Models
        ClassifierModelModelsSaved: new Rx.BehaviorSubject(null),
        ClassifierModelModelsSaveError: new Rx.BehaviorSubject(null),

        ClassifierModelModelsDuplicate: new Rx.BehaviorSubject(null),
        ClassifierModelModelsDuplicateError: new Rx.BehaviorSubject(null),

        ClassifierModelModelsSetDefault: new Rx.BehaviorSubject(null),
        ClassifierModelModelsSetDefaultError: new Rx.BehaviorSubject(null),

        ClassifierModelModelsDeleted: new Rx.BehaviorSubject(null),
        ClassifierModelModelsDeleteError: new Rx.BehaviorSubject(null),

        ClassifierModelModelsGet: new Rx.BehaviorSubject(null),
        ClassifierModelModelsGetError: new Rx.BehaviorSubject(null),



        //Folders
        ClassifierModelFoldersSaved: new Rx.BehaviorSubject(null),
        ClassifierModelFoldersSaveError: new Rx.BehaviorSubject(null),

        ClassifierModelFoldersDeleted: new Rx.BehaviorSubject(null),
        ClassifierModelFoldersDeleteError: new Rx.BehaviorSubject(null),

        ClassifierModelFoldersGet: new Rx.BehaviorSubject(null),
        ClassifierModelFoldersGetError: new Rx.BehaviorSubject(null),



        //Files
        ClassifierModelFilesSaved: new Rx.BehaviorSubject(null),
        ClassifierModelFilesSaveError: new Rx.BehaviorSubject(null),

        ClassifierModelFilesDeleted: new Rx.BehaviorSubject(null),
        ClassifierModelFilesDeleteError: new Rx.BehaviorSubject(null),

        ClassifierModelFilesErased: new Rx.BehaviorSubject(null),
        ClassifierModelFilesEraseError: new Rx.BehaviorSubject(null),

        ClassifierModelFilesSetFolder: new Rx.BehaviorSubject(null),
        ClassifierModelFilesSetFolderError: new Rx.BehaviorSubject(null),



        //FileEditor
        ClassifierModelGetFileText: new Rx.BehaviorSubject(null),
        ClassifierModelGetFileTextError: new Rx.BehaviorSubject(null),

        ClassifierModelFileEditorSaved: new Rx.BehaviorSubject(null),
        ClassifierModelFileEditorSaveError: new Rx.BehaviorSubject(null)
    };
}

function FileEditorModel(Params, ColumnsName = null)
{
    var usedModel = ColumnsName&&ColumnsName.usedModel?ColumnsName.usedModel:"usedModel";
    var folder = ColumnsName&&ColumnsName.folder?ColumnsName.folder:"folder";
    var file = ColumnsName&&ColumnsName.file?ColumnsName.file:"file";
    var text = ColumnsName&&ColumnsName.text?ColumnsName.text:"text";

    this.idRow = Params&&Params['id']?Params['id']:0;
    this.usedModel = Params&&Params[usedModel]?Params[usedModel]:"";
    this.folder = Params&&Params[folder]?Params[folder]:(Params&&Params.code?Params.code:"");
    this.file = Params&&Params[file]?Params[file]:"";
    this.text = Params&&Params[text]?Params[text]:"";
}

ClassifierModelManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};



//GetConfig
ClassifierModelManager.prototype.GetConfig = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "GetConfig",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierGetConfig.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierGetConfigError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};



//Models
ClassifierModelManager.prototype.ModelsSave = function(Params)
{
    _this = this;
    var Model = new FileEditorModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Models" + "Save",
            data: {Params: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelModelsSaved.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelModelsSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.ModelsDuplicate = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Models" + "Duplicate",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelModelsDuplicate.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelModelsDuplicateError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.ModelsSetDefault = function(Params)
{
    _this = this;
    var Model = new FileEditorModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Models" + "SetDefault",
            data: {Params: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelModelsSetDefault.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelModelsSetDefaultError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.ModelsDelete = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Models" + "Delete",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelModelsDeleted.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelModelsDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.ModelsGet = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "GetModelsListReport",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelModelsGet.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelModelsGetError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};



//Folders
ClassifierModelManager.prototype.FoldersGet = function(Params, Form = null)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Folders" + "Get",
            data: {Params: Params, Form: Form},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelFoldersGet.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelFoldersGetError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.FoldersSave = function(Params)
{
    _this = this;
    var Model = new FileEditorModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Folders" + "Save",
            data: {Params: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelFoldersSaved.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelFoldersSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.FoldersDelete = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Folders" + "Delete",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelFoldersDeleted.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelFoldersDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};



//Files
ClassifierModelManager.prototype.FilesSave = function(Params)
{
    _this = this;
    var Model = new FileEditorModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Files" + "Save",
            data: {Params: Model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelFilesSaved.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelFilesSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.FilesDelete = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Files" + "Delete",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelFilesDeleted.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelFilesDeleteError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.FilesErase = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Files" + "Erase",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelFilesErased.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelFilesEraseError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.FilesSetFolder = function(Params)
{
    _this = this;

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "Files" + "SetFolder",
            data: {Params: Params},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelFilesSetFolder.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelFilesSetFolderError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};



//FileEditor
ClassifierModelManager.prototype.SetFileEditor = function(Params)
{
    _this = this;

    var model = new FileEditorModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_GetFileText",
            data: {Params: model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelGetFileText.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelGetFileTextError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};

ClassifierModelManager.prototype.FileEditorSave = function(Params)
{
    _this = this;

    var model = new FileEditorModel(Params);

    var params =
        {
            id: webix.uid(),
            method:"Clsfr_" + "FileEditor" + "Save",
            data: {Params: model},
            callback:function (R)
            {
                if(!_this.Active)
                    return;

                _this.Signals.Progress.next(0);

                if(R.success)
                {
                    _this.Signals.ClassifierModelFileEditorSaved.next(R.data);
                }
                else if(!R.success && R.error)
                    _this.Signals.ClassifierModelFileEditorSaveError.next(R.error);

                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    _this.Signals.Progress.next(1);

    App.ServerManager.CallMethod(params);
};
function EnvConfigModel(Params)
{
    var _this = this;

    ClassifierConfigManager.GetSortedEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = ClassifierEnvConfigDic[Key].group;

        var id = ClassifierEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            function ParseRecieversParams(ReceiverType)
            {
                var i = 0;

                while (Params[ReceiverType + "_PORT_TYPE[" + i + "]"])
                {
                    var model = new IpfixReceiverConfigModel({RECEIVER_TYPE:ReceiverType}, i);

                    Object.keys(model).forEach(function (Key)
                    {
                        var id = Key;

                        _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
                    });

                    i++;
                }
            }

            if(id == ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM);
        }
        else
        {
            //var defaultVal = ClassifierEnvConfigDic[Key].default?ClassifierEnvConfigDic[Key].default:"";

            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");

            if(id == "CFG_SITES_CLSFR_MODEL")
                _this[id] = Helper.ReplaceAll("'","", _this[id]);
        }
    });

    // Add params to model, wich not in dic
    Object.keys(Params).forEach(function(Key)
    {
        if(!_this[Key])
        {
            var id = Key;
            _this[id] = (Params&&Params[id]?Helper.ConvertBoolStrToInt(typeof Params[id] === "string" ? Params[id].trim() : Params[id]):"");
        }
    });
}

function UpdateStatusModel(Params)
{
    this.current_version = Params&&Params.current_version?Params.current_version:null;
    this.new_version = Params&&Params.new_version?Params.new_version:null;
    this.has_new_version = Params&&Params.has_new_version?Params.has_new_version:0;
    this.date_of_install = Params&&Params.date_of_install?Params.date_of_install:null;
    this.update_last_check = Params&&Params.update_last_check?Params.update_last_check:null;
    this.autoupdate = Params&&Params.autoupdate?Params.autoupdate:0;

    this.is_runnig = Params&&Params.is_runnig?Params.is_runnig:0;
    this.is_runnig_before = Params&&Params.is_runnig_before?Params.is_runnig_before:0;

    this.undefined = Params&&Params.undefined?Params.undefined:0;


    this.service_unavailable = Params&&Params.service_unavailable?Params.service_unavailable:0;
    this.service_unavailable_count = Params&&Params.service_unavailable_count?Params.service_unavailable_count:0;
}

var ClassifierEnvConfigReceiverDic =
    {
        "1.0": {
            "id": "PORT_TYPE", "value": LangHelper.GetString("Dics", "Port type"),
            "view": "richselect",
            "options":
                {
                    "1": {"id": "tcp", "value": LangHelper.GetString("Dics", "tcp")},
                    "2": {"id": "udp", "value": LangHelper.GetString("Dics", "udp")}
                },
            default: "tcp",
            "tooltip": LangHelper.GetString("Dics", "Port type") + ": " + LangHelper.GetString("Dics", "tcp or udp") + "<br/><br/>" +
                LangHelper.GetString("Dics", "It`s recommended to use tcp") + "<br/><br/>"
        },
        "1.1": {
            "id": "PORT", "value": LangHelper.GetString("Dics", "Port"),
            "view": "text",
            "placeholder": "1500",
            "default": 1500,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Any port you wish. The main thing that would be different for each thread") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default values are 1500 for fullflow thread and 1501 for clickstream thread")
        },
        "1.2": {
            "id": "COMPANY_CODE", "value": LangHelper.GetString("Dics", "Company code"),
            "view": "text",
            "placeholder": "Company code",
            "default": "Company",
            "invalidMessage": LangHelper.GetString("Dics", "Enter the company code"),
            "tooltip": LangHelper.GetString("Dics", "You can receive clickstream from multiple operators and provide a Company Code for convenience")
        },
        "1.3": {
            "id": "ROTATE_BASH", "value": LangHelper.GetString("Dics", "Rotate bash"),
            "view": "text",
            "placeholder": "run_dump_process.sh",
            "default": "run_dump_process.sh",
            "invalidMessage": LangHelper.GetString("Dics", "Enter the rotate bash"),
            "tooltip": LangHelper.GetString("Dics", "Bash script for processing dumps. By default run_dump_process.sh") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily"),
            "tooltipHeight": 280
        },
        "1.4": {
            "id": "ROTATE_MINUTES", "value": LangHelper.GetString("Dics", "Rotate in minutes"),
            "view": "text",
            "placeholder": "10",
            "default": 10,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Receiver dump rotate period or data loading period into the database") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is 10 minutes for fullflow and 12 minutes for clickstream") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Dump rotate period for cliksteam should be greater or equal than the same period for fullflow. When fullflow dump rotates the HUP signal is sent to synchronize threads.") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily"),
            "tooltipHeight": 280
        },
        "1.5": {
            "id": "ROTATE_DELAY_SECONDS", "value": LangHelper.GetString("Dics", "Delay in seconds"),
            "view": "text",
            "placeholder": "0",
            "default": 0,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Data loading delay into the database") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default values are 0 seconds for fullflow thread and 400 seconds for clickstream thread") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily")
        },
        "1.6": {
            "id": "FW_MAX_QUEUE_SIZE", "value": LangHelper.GetString("Dics", "Queue size"),
            "view": "text",
            "placeholder": "10",
            "default": 10,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Receiver dump loading queue size") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Default value is 10") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily")
        },
        "1.7": {
            "id": "DUMP_PROCESSES", "value": LangHelper.GetString("Dics", "Processing processes number"),
            "view": "text",
            "placeholder": "0",
            "default": 0,
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number"),
            "tooltip": LangHelper.GetString("Dics", "Number of dump processing processes") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Do not change this setting unnecessarily")
        },
        "1.8": {
            "id": "EXPORT", "value": LangHelper.GetString("Dics", "Export"),
            "view": "text",
            "placeholder": "10.0.0.2/9920/tcp,10.0.0.3/3440/udp",
            "tooltip": LangHelper.GetString("Dics", "Reciver can export data to other receivers") + "<br/><br/>" +
                LangHelper.GetString("Dics", "Format is") + " 10.0.0.2/9920/tcp,10.0.0.3/3440/udp"
        }
    };

var ClassifierEnvConfigReceiversDic = function () {
    var dic = {};

    function AddDic(Type, Id, ReceiverDicId, Title) {
        dic[Id] =
            {
                "id": Type + "_" + ClassifierEnvConfigReceiverDic[ReceiverDicId].id + "[i]",
                "group": "1",
                "value": LangHelper.GetString("Dics", Title) + " (" + Type + "_" + ClassifierEnvConfigReceiverDic[ReceiverDicId].id + "[i])",
                "view": ClassifierEnvConfigReceiverDic[ReceiverDicId].view,
                "options": ClassifierEnvConfigReceiverDic[ReceiverDicId].options,
                "placeholder": ClassifierEnvConfigReceiverDic[ReceiverDicId].placeholder,
                "default": ClassifierEnvConfigReceiverDic[ReceiverDicId].default,
                "validate": ClassifierEnvConfigReceiverDic[ReceiverDicId].validate,
                "invalidMessage": ClassifierEnvConfigReceiverDic[ReceiverDicId].invalidMessage,
                "tooltip": ClassifierEnvConfigReceiverDic[ReceiverDicId].tooltip
            };
    }

    AddDic("IPFIX_CLICKSTREAM", "1.1", "1.1", "Clickstream port type");
    AddDic("IPFIX_CLICKSTREAM", "1.2", "1.2", "Clickstream port number");
    AddDic("IPFIX_CLICKSTREAM", "1.3", "1.3", "Rotate in minutes");
    AddDic("IPFIX_CLICKSTREAM", "1.4", "1.4", "Delay in seconds");
    AddDic("IPFIX_CLICKSTREAM", "1.5", "1.5", "Queue size");
    AddDic("IPFIX_CLICKSTREAM", "1.6", "1.6", "Export");


    return dic;
}();

var ClassifierEnvConfigGroupDic =
    {
        "1": {"id": "1", "order": 1, "value": LangHelper.GetString("Dics", "Receivers clickstream")},
        "2": {"id": "2", "order": 2, "value": LangHelper.GetString("Dics", "DB (MySql) connection")},
        "3": {"id": "3", "order": 3, "value": LangHelper.GetString("Dics", "Model settings")},
        "4": {"id": "4", "order": 4, "value": LangHelper.GetString("Dics", "Nudes images and videos")},
        "5": {"id": "5", "order": 5, "value": LangHelper.GetString("Dics", "Hosts recheck")},
        "6": {"id": "6", "order": 6, "value": LangHelper.GetString("Dics", "General")},
    };

var ClassifierEnvConfigDic = function () {
    var dic = {};

    var clAddToDic = function (Group, Arr) {
        Arr.forEach(function (Item, Index) {
            var key = Group + "." + (Index + 1);
            dic[key] = Item;
            dic[key].group = Group + "";
        });
    };

    //Group 2
    clAddToDic(2, [
        {
            "id": "DB_CONNECTION",
            "group": "2",
            "value": LangHelper.GetString("Dics", "DB connection type") + " (DB_CONNECTION)",
            "view": "richselect",
            "options":
                {
                    "mysql": {"id": "mysql", "value": LangHelper.GetString("Dics", "MySql")}
                },
            "tooltip": LangHelper.GetString("Dics", "DB connection type") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "DB_HOST", "group": "2", "value": LangHelper.GetString("Dics", "DB host") + " (DB_HOST)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB host") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "DB_PORT", "group": "2", "value": LangHelper.GetString("Dics", "DB port") + " (DB_PORT)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB port") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior."),
            "default": 3306,
            "placeholder": "3306",
            "validate": function (Val) {
                return !isNaN(Val * 1);
            },
            "invalidMessage": LangHelper.GetString("Dics", "Enter the number")
        },
        {
            "id": "DB_DATABASE", "group": "2", "value": LangHelper.GetString("Dics", "DB name") + " (DB_DATABASE)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB name") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "DB_USERNAME", "group": "2", "value": LangHelper.GetString("Dics", "DB username") + " (DB_USERNAME)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB username") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "DB_PASSWORD", "group": "2", "value": LangHelper.GetString("Dics", "DB password") + " (DB_PASSWORD)",
            "view": "text",
            "tooltip": LangHelper.GetString("Dics", "DB password") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        }
    ]);

    //Group 3
    clAddToDic(3, [
        {
            "id": "CFG_SITES_CLSFR_MODEL",
            "group": "3",
            "view": "multiselect",
            "options": [],
            "value": LangHelper.GetString("Dics", "Default models") + " (CFG_SITES_CLSFR_MODEL)",
            "tooltip": LangHelper.GetString("Dics", "Default models (to specify multiple models, list them via ',').") + "<br/><br/>" + LangHelper.GetString("Dics", "<b>Do not change this setting</b>. This can lead to unpredictable behavior.")
        },
        {
            "id": "CFG_TEXT_MIN_LENGTH",
            "group": "3",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Minimum text length") + " (CFG_TEXT_MIN_LENGTH)",
            "tooltip": LangHelper.GetString("Dics", "This field allows you to set the minimum number of characters for the text classifier.</br>If there are not enough characters in the text, the site will be placed in the category 'unknown'.</br></br>Default is 150")
        }/*,
        {
            "id": "CFG_RECHECK_CATEGORY_CODE",
            "group": "3",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Recheck category") + " (CFG_RECHECK_CATEGORY_CODE)",
            "tooltip": LangHelper.GetString("Dics", "Category code to recheck.</br></br>Default is 'unknown'")
        }*/
    ]);

    //Group 4
    clAddToDic(4, [
        {
            "id": "CFG_SITES_CLSFR_IMG_ENABLED",
            "group": "4",
            "view": "richselect",
            "options": Helper.DictToArr(OnOffDic),
            "value": LangHelper.GetString("Dics", "Enabled image processing") + " (CFG_SITES_CLSFR_IMG_ENABLED)",
            "tooltip": LangHelper.GetString("Dics", "Enables/disables image processing for the presence of porn in them")
        },
        {
            "id": "CFG_SITES_CLSFR_IMG_THRESHOLD",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Threshold") + " (CFG_SITES_CLSFR_IMG_THRESHOLD)",
            "tooltip": LangHelper.GetString("Dics", "Adjusts the probability of recognition from 0 to 1. The higher the value, the more likely the image will NOT fall into the category of pornography.")
        },
        {
            "id": "CFG_SITES_CLSFR_PORN_CAT_CODE",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Porn Category Code") + " (CFG_SITES_CLSFR_PORN_CAT_CODE)",
            "tooltip": LangHelper.GetString("Dics", "The category to which the recognized pornography will be moved")
        },
        {
            "id": "CFG_SITES_CLSFR_IMG_LIMIT",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Limit") + " (CFG_SITES_CLSFR_IMG_LIMIT)",
            "tooltip": LangHelper.GetString("Dics", "Number of images uploading from the host")
        },
        {
            "id": "CFG_SITES_CLSFR_IMG_TIMEOUT",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Timeout") + " (CFG_SITES_CLSFR_IMG_TIMEOUT)",
            "tooltip": LangHelper.GetString("Dics", "Waiting time if the picture is not loaded")
        },
        {
            "id": "CFG_SITES_CLSFR_IMG_ONLY_MARK",
            "group": "4",
            "view": "richselect",
            "options": Helper.DictToArr(OnOffDic),
            "value": LangHelper.GetString("Dics", "Mark only") + " (CFG_SITES_CLSFR_IMG_ONLY_MARK)",
            "tooltip": LangHelper.GetString("Dics", "Hosts on which pornographic images have been recognized, if this option is enabled, will only be marked, otherwise these hosts will be automatically moved to the porn category")
        },
        {
            "id": "CFG_DL_IMG_PROCESS_NUM",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Amount of threads") + " (CFG_DL_IMG_PROCESS_NUM)",
            "tooltip": LangHelper.GetString("Dics", "This field allows you to configure amount of processor threads that will be used to downloading images.</br></br>Default is 1")
        },
        {
            "id": "CFG_SITES_CLSFR_VIDEO_ENABLED",
            "group": "4",
            "view": "richselect",
            "options": Helper.DictToArr(OnOffDic),
            "value": LangHelper.GetString("Dics", "Enabled video processing") + " (CFG_SITES_CLSFR_VIDEO_ENABLED)",
            "tooltip": LangHelper.GetString("Dics", "Enables/disables video processing for the presence of porn in them")
        },
        {
            "id": "CFG_SITES_CLSFR_VIDEO_THRESHOLD",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Threshold") + " (CFG_SITES_CLSFR_VIDEO_THRESHOLD)",
            "tooltip": LangHelper.GetString("Dics", "Adjusts the probability of recognition from 0 to 1. The higher the value, the more likely the video will NOT fall into the category of pornography.") + "<br/><br/>" + LangHelper.GetString("Dics", "Default is 0.5")
        },
        {
            "id": "CFG_SITES_CLSFR_VIDEO_DL_LIMIT",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Limit") + " (CFG_SITES_CLSFR_VIDEO_DL_LIMIT)",
            "tooltip": LangHelper.GetString("Dics", "Number of videos uploading from the host")
        },
        {
            "id": "CFG_SITES_CLSFR_VIDEO_TIMEOUT",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Timeout") + " (CFG_SITES_CLSFR_VIDEO_TIMEOUT)",
            "tooltip": LangHelper.GetString("Dics", "Waiting time if the video is not loaded")
        },
        {
            "id": "CFG_SITES_CLSFR_VIDEO_ONLY_MARK",
            "group": "4",
            "view": "richselect",
            "options": Helper.DictToArr(OnOffDic),
            "value": LangHelper.GetString("Dics", "Mark only") + " (CFG_SITES_CLSFR_VIDEO_ONLY_MARK)",
            "tooltip": LangHelper.GetString("Dics", "Hosts on which pornographic videos have been recognized, if this option is enabled, will only be marked, otherwise these hosts will be automatically moved to the porn category")
        },
        {
            "id": "CFG_DL_VIDEO_PROCESS_NUM",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Amount of threads") + " (CFG_DL_VIDEO_PROCESS_NUM)",
            "tooltip": LangHelper.GetString("Dics", "This field allows you to configure amount of processor threads that will be used to downloading videos.</br></br>Default is 1")
        },
        {
            "id": "CFG_SITES_CLSFR_VIDEO_MAX_FILESIZE",
            "group": "4",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Maximum video size") + " (CFG_SITES_CLSFR_VIDEO_MAX_FILESIZE)",
            "tooltip": LangHelper.GetString("Dics", "Maximum video size in megabytes</br></br>Default is 50")
        }
    ]);

    //Group 5
    clAddToDic(5,[
        {
            "id": "CFG_RECHECK_DUMP_SIZE",
            "group": "5",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Dump size for category recheck") + " (CFG_RECHECK_DUMP_SIZE)",
            "tooltip": LangHelper.GetString("Dics", "" + LangHelper.GetString("Dics", "This field allows you to configure dump size for category recheck</br></br>Default is 1000"))
        },
        {
            "id": "CFG_RECHECK_PROCESS_NUM",
            "group": "5",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Amount of threads for category recheck process") + " (CFG_RECHECK_PROCESS_NUM)",
            "tooltip": LangHelper.GetString("Dics", "" + LangHelper.GetString("Dics", "This field allows you to configure amount of threads for category recheck</br>"))
        }
    ]);

    //Group 6
    clAddToDic(6,[
        {
            "id": "CFG_SCRIPTS_LOG_LEVEL",
            "group": "5",
            "view": "richselect",
            "options": Helper.DictToArr(InfoDebugDic),
            "value": LangHelper.GetString("Dics", "Logs level") + " (CFG_SCRIPTS_LOG_LEVEL)",
            "tooltip": LangHelper.GetString("Dics", "" + LangHelper.GetString("Dics", "Logs level"))
        },
        {
            "id": "CFG_NETIFY_URL",
            "group": "5",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Netify URL") + " (CFG_NETIFY_URL)",
            "tooltip": LangHelper.GetString("Dics", "" + LangHelper.GetString("Dics", "Netify URL"))
        },
        {
            "id": "CFG_NETIFY_API_KEY",
            "group": "5",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Netify API key") + " (CFG_NETIFY_API_KEY)",
            "tooltip": LangHelper.GetString("Dics", "" + LangHelper.GetString("Dics", "Netify API key"))
        },
        {
            "id": "CFG_NETIFY_NET_UUID",
            "group": "5",
            "view": "text",
            "value": LangHelper.GetString("Dics", "Netify Net uuid") + " (CFG_NETIFY_NET_UUID)",
            "tooltip": LangHelper.GetString("Dics", "" + LangHelper.GetString("Dics", "Netify Net uuid"))
        },
    ]);

    return dic;
}();

ClassifierEnvConfigDic = webix.extend(ClassifierEnvConfigReceiversDic, ClassifierEnvConfigDic);

var ClassifierIpfixReceiverTypesEnum =
    {
        IPFIX_CLICKSTREAM:"IPFIX_CLICKSTREAM"
    };

var ClassifierIpfixReceiverRotateDefaultsEnum = {};
ClassifierIpfixReceiverRotateDefaultsEnum[ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 12;

var ClassifierIpfixReceiverRotateDelayDefaultsEnum = {};
ClassifierIpfixReceiverRotateDelayDefaultsEnum[ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 400;

var ClassifierIpfixReceiverQueueSizeDefaultsEnum = {};
ClassifierIpfixReceiverQueueSizeDefaultsEnum[ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 10;

var ClassifierIpfixReceiverDumpInsertProcessesDefaultsEnum = {};
ClassifierIpfixReceiverDumpInsertProcessesDefaultsEnum[ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 0;

function IpfixReceiverConfigRowModel(Params)
{
    this.id = Params&&Params.id ? Params.id : webix.uid();

    this.RECEIVER_TYPE = ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM;
    this.PORT_TYPE = Params&&Params.PORT_TYPE?Params.PORT_TYPE:"tcp";

    this.PORT = Params&&Params.PORT?Params.PORT:0;
    this.COMPANY_CODE = Params&&Params.COMPANY_CODE?Params.COMPANY_CODE:null;
    this.ROTATE_BASH = Params&&Params.ROTATE_BASH?Params.ROTATE_BASH:null;
    this.ROTATE_MINUTES = Params&&Params.ROTATE_MINUTES?Params.ROTATE_MINUTES:ClassifierIpfixReceiverRotateDefaultsEnum[this.RECEIVER_TYPE];
    this.ROTATE_DELAY_SECONDS = Params&&Params.ROTATE_DELAY_SECONDS?Params.ROTATE_DELAY_SECONDS:ClassifierIpfixReceiverRotateDelayDefaultsEnum[this.RECEIVER_TYPE];
    this.FW_MAX_QUEUE_SIZE = Params&&Params.FW_MAX_QUEUE_SIZE?Params.FW_MAX_QUEUE_SIZE:ClassifierIpfixReceiverQueueSizeDefaultsEnum[this.RECEIVER_TYPE];

    this.DUMP_PROCESSES = Params&&Params.DUMP_PROCESSES?Params.DUMP_PROCESSES:ClassifierIpfixReceiverDumpInsertProcessesDefaultsEnum[this.RECEIVER_TYPE];

    this.EXPORT = Params&&Params.EXPORT?Params.EXPORT:null;
}

function IpfixReceiverConfigModel(Params, Index)
{
    var type = ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM;

    this[type + "_PORT_TYPE[" + Index + "]"]  = Params&&Params.PORT_TYPE?Params.PORT_TYPE:"tcp";

    this[type + "_PORT[" + Index + "]"] = Params&&Params.PORT?Params.PORT:0;
    this[type + "_COMPANY_CODE[" + Index + "]"] = Params&&Params.COMPANY_CODE?Params.COMPANY_CODE:null;
    this[type + "_ROTATE_BASH[" + Index + "]"] = Params&&Params.ROTATE_BASH?Params.ROTATE_BASH:null;
    this[type + "_ROTATE_MINUTES[" + Index + "]"] = Params&&parseInt(Params.ROTATE_MINUTES)?Params.ROTATE_MINUTES:ClassifierIpfixReceiverRotateDefaultsEnum[type];
    this[type + "_ROTATE_DELAY_SECONDS[" + Index + "]"] = Params&&Params.ROTATE_DELAY_SECONDS?Params.ROTATE_DELAY_SECONDS:ClassifierIpfixReceiverRotateDelayDefaultsEnum[type];
    this[type + "_FW_MAX_QUEUE_SIZE[" + Index + "]"] = Params&&Params.FW_MAX_QUEUE_SIZE?Params.FW_MAX_QUEUE_SIZE:ClassifierIpfixReceiverQueueSizeDefaultsEnum[type];

    this[type + "_DUMP_PROCESSES[" + Index + "]"] = Params&&Params.DUMP_PROCESSES?Params.DUMP_PROCESSES:ClassifierIpfixReceiverDumpInsertProcessesDefaultsEnum[type];

    this[type + "_EXPORT[" + Index + "]"] = Params&&Params.EXPORT?Params.EXPORT:null;
}

function ClassifierConfigManager(Params)
{
    this.Active = true;

    this.ConfigFile = "";

    this.ConfigModel = null;

    this.Signals = {
        ConfigFileUpdated: new Rx.BehaviorSubject(0),
        UpdateStatusProcess: new Rx.BehaviorSubject(0),
        UpdateStatus: new Rx.BehaviorSubject(new UpdateStatusModel({undefined:1})),
        UpdateLogTail: new Rx.BehaviorSubject(null),
        CheckForUpdateLogTail: new Rx.BehaviorSubject(null)
    };

    this.DontShowErrorCodesWhenUpdating = [0,503,2002,-403];
}

ClassifierConfigManager.prototype.Destroy = function(Params)
{
    this.Active = false;
};

ClassifierConfigManager.prototype.Refresh = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"Clsfr_GetEnvConfig",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(R.success)
            {
                _this.ConfigFile = R.data;
            }
            else
            {
                _this.ConfigFile = "";
            }

            _this.ParseConfigToModel();
            _this.ParseModelToConfig();

            _this.Signals.ConfigFileUpdated.next(1);

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("ClassifierConfig", "Configuration loaded."));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

ClassifierConfigManager.prototype.GetConfig = function()
{
    return this.ConfigFile
};

ClassifierConfigManager.prototype.SetConfig = function(ConfigFile)
{
    this.ConfigFile = ConfigFile;

    this.ParseConfigToModel();

    this.Signals.ConfigFileUpdated.next(1);
};

ClassifierConfigManager.prototype.GetConfigModel = function()
{
    return this.ConfigModel ? this.ConfigModel : new EnvConfigModel();
};

ClassifierConfigManager.prototype.RemoveReceiversParamsFromConfigModel = function()
{
    var _this = this;

    if(this.ConfigModel)
    {
        Object.keys(this.ConfigModel).forEach(function (Key) {
            if(
                Key.indexOf(ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM) >= 0
            )
                delete _this.ConfigModel[Key];
        });
    }
};

ClassifierConfigManager.prototype.SetConfigModel = function(ConfigModel)
{
    if(this.ConfigModel)
    {
        this.RemoveReceiversParamsFromConfigModel();
        this.ConfigModel = webix.extend(this.ConfigModel, new EnvConfigModel(ConfigModel), true);
    }
    else
    {
        this.ConfigModel = new EnvConfigModel(ConfigModel);
    }

    this.ParseModelToConfig();

    this.Signals.ConfigFileUpdated.next(1);
};

ClassifierConfigManager.prototype.ParseConfigToModel = function()
{
    var config = this.GetConfig();

    var parser = new ConfigIniParser();
    parser.parse(config);

    this.ConfigModel = new EnvConfigModel(parser.itemsKeyVal());
};

ClassifierConfigManager.prototype.ParseModelToConfig = function(ShowComments, ShowAllParams)
{
    var _this = this;

    var showComments = parseInt(App.SessionManager.GetPreference("ClassifierConfigManager:ShowComments")) ? true : false;

    var showAllParams = parseInt(App.SessionManager.GetPreference("ClassifierConfigManager:ShowAllParams")) ? true : false;

    var configModel = this.GetConfigModel();
    var parser = new ConfigIniParser();

    var currentGroupId = 0;

    var processedIds = {};

    function ProcessDicParameter(Key, ConfigModelId)
    {
        var groupId = ClassifierEnvConfigDic[Key].group;
        var id = ConfigModelId ? ConfigModelId : ClassifierEnvConfigDic[Key].id;
        var comment = ClassifierEnvConfigDic[Key].value;
        var tooltip = ClassifierEnvConfigDic[Key].tooltip?ClassifierEnvConfigDic[Key].tooltip:"";

        if(groupId !== currentGroupId)
        {
            currentGroupId = groupId;

            if(showComments && ((configModel[id] && configModel[id].length !== 0) || showAllParams))
            {
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, ClassifierEnvConfigGroupDic[currentGroupId].value);
                parser.set("", webix.uid(), null, "================");
                parser.set("", webix.uid(), null, " ");
            }

        }

        if(showComments && ((configModel[id] && configModel[id].length !== 0) || showAllParams))
            parser.set("", webix.uid(), null, comment);

        if(tooltip&&tooltip!==comment)
        {
            if(showComments && ((configModel[id] && configModel[id].length !== 0) || showAllParams))
            {
                var tt = tooltip.split('<br/>');
                tt.forEach(function (Val)
                {
                    if(Val)
                        parser.set("", webix.uid(), null, Val);
                });
            }
        }

        if(configModel[id] && configModel[id].length !== 0)
        {
            var value = configModel[id];

            if(id == "CFG_SITES_CLSFR_MODEL")
                value = "'" + value + "'";

            parser.set("", id, value);
            parser.set("", webix.uid(), null, " ");
        }
        else
        {
            if(showAllParams)
            {
                parser.set("", webix.uid(), null, id+"="+(configModel[id] ? configModel[id] : ""));
                parser.set("", webix.uid(), null, " ");
            }
        }

        processedIds[id] = id;
    }

    ClassifierConfigManager.GetSortedEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = ClassifierEnvConfigDic[Key].group;
        var id = ClassifierEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            function ParseRecieversParams(ReceiverType)
            {
                var i = 0;

                var map = ClassifierConfigManager.IpfixReceiverDicIdToParamIdMap(ReceiverType)

                while (configModel[ReceiverType + "_PORT_TYPE[" + i + "]"])
                {
                    var model = new IpfixReceiverConfigModel({RECEIVER_TYPE:ReceiverType}, i);

                    Object.keys(map).forEach(function (Key)
                    {
                        ProcessDicParameter(Key, map[Key].replace("[i]", "[" + i + "]"));
                    });

                    i++;
                }

                if(!i)
                {
                    Object.keys(map).forEach(function (Key)
                    {
                        ProcessDicParameter(Key);
                    });
                }
            }

            if(id == ClassifierIpfixReceiverTypesEnum.IPFIX_FULLFLOW + "_PORT_TYPE[i]")
                ParseRecieversParams(ClassifierIpfixReceiverTypesEnum.IPFIX_FULLFLOW);

            if(id == ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM + "_PORT_TYPE[i]")
                ParseRecieversParams(ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM);
        }
        else
        {
            ProcessDicParameter(Key);
        }
    });

    // Add params to config, wich not in dic
    if(Object.keys(processedIds).length != Object.keys(configModel).length)
    {
        if(showComments)
        {
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, LangHelper.GetString("Dics", "Unknown parameters"));
            parser.set("", webix.uid(), null, "================");
            parser.set("", webix.uid(), null, " ");
        }

        Object.keys(configModel).forEach(function(Key)
        {
            if(!processedIds[Key])
            {
                var id = Key;

                if(configModel[id].length !== 0)
                {
                    parser.set("", id, configModel[id]);
                }
                else
                {
                    parser.set("", webix.uid(), null, id+"="+configModel[id]);
                }

                parser.set("", webix.uid(), null, " ");
            }
        });
    }

    this.ConfigFile = parser.stringify();
};

ClassifierConfigManager.prototype.Save = function(Params)
{
    var _this = this;

    var params =
        {
            method:"Clsfr_SetEnvConfig",
            data:{
                Config:Params&&Params.configContents?Params.configContents:_this.GetConfig()
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
                    }
                    else
                    {
                        webix.message({type:"error", text:result.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

ClassifierConfigManager.prototype.SetGrantAllPrivileges = function(Params)
{
    var _this = this;

    var params =
        {
            method:"Clsfr_SetGrantAllPrivileges",
            data:{
                Config:Params&&Params.configContents?Params.configContents:_this.GetConfig()
            },
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
                else
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("DpiConfig", "Granted all privileges successfully"));
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});
                    }
                }
            }
        };

    if(this.Active)
        App.ServerManager.CallMethod(params);
};

ClassifierConfigManager.prototype.Restart = function(Params)
{
    var _this = this;

    if(!_this.Active)
    {
        return;
    }

    var params = {
        method:"Clsfr_Restart",
        callback:function (R)
        {
            if(!_this.Active)
            {
                return;
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
            else
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("ClassifierConfig", "Queue restarted successfully"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        }
    };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

ClassifierConfigManager.prototype.CheckClsfrVersionCompatibility = function (Callback)
{
    var _this = this;

    var params =
        {
            method:"Clsfr_CheckClsfrVersionCompatibility",
            data:{},
            callback:function (R)
            {
                if(!_this.Active)
                {
                    return;
                }

                if(Callback && typeof Callback == "function")
                {
                    Callback(R);
                    return;
                }

            }
        };

    if(this.Active)
    {
        App.ServerManager.CallMethod(params);
    }
};

ClassifierConfigManager.GetSortedEnvConfigDicKeysArr = function()
{
    var groupsArr = ClassifierConfigManager.GetSortedEnvConfigGroupDicKeysArr();

    var arr = [];

    groupsArr.forEach(function (V)
    {
        Object.keys(ClassifierEnvConfigDic).forEach(function (K)
        {
            if(ClassifierEnvConfigDic[K].group == V)
            {
                arr.push(K);
            }
        });
    });

    return arr;
};

ClassifierConfigManager.GetSortedEnvConfigGroupDicKeysArr = function()
{
    var arr = [];

    ClassifierConfigManager.GetSortedEnvConfigGroupDicArr().forEach(function (V)
    {
        arr.push(V.id)
    });

    return arr;
};

ClassifierConfigManager.GetSortedEnvConfigGroupDicArr = function()
{
    var groupsArr = Helper.DictToArr(ClassifierEnvConfigGroupDic);

    groupsArr.sort(function(a, b) {
        return a.order - b.order;
    });

    return groupsArr;
};

ClassifierConfigManager.IpfixReceiverDicIdToParamIdMap = function(ReceiverType)
{
    var map = {};

    ClassifierConfigManager.GetSortedEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = ClassifierEnvConfigDic[Key].group;
        var id = ClassifierEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            if(id.indexOf(ReceiverType) >= 0)
                map[Key] = id;
        }
    });

    return map;
};

ClassifierConfigManager.IpfixReceiverParamIdToDicIdMap = function(ReceiverType)
{
    var map = {};

    ClassifierConfigManager.GetSortedEnvConfigDicKeysArr().forEach(function(Key)
    {
        var groupId = ClassifierEnvConfigDic[Key].group;
        var id = ClassifierEnvConfigDic[Key].id;

        if(groupId == "1")
        {
            if(id.indexOf(ReceiverType) >= 0)
                map[id] = Key;
        }
    });

    return map;
}
/* global UiRouter*/
/* global webix*/

var App = null;

function AppManager(Params)
{
    "use strict";
    this.NavRouter = null;
    this.ServerManager = null;
    this.SessionManager = null;
    this.DicsManager = null;
    this.UserManager = null;
    this.NotificationsManager = null;
    this.WebSocketManager = null;
    this.SocketNotificationsManager = null;

    this.Locale = LocalesEnum.en.code;
    this.Subscriptions = {};
}

AppManager.prototype.InitManagers = function(Params)
{
    var _this = this;
    this.ServerManager = new ServerManager();
    this.SessionManager = new SessionManager();
    this.DicsManager = new DicsManager();
    this.UserManager = new UsersManager();
    this.NotificationsManager = new HardwareNotificationsManager();
    this.WebSocketManager = new WebSocketManager();

    this.HardwaresManager = new HardwaresManager();

    this.Subscriptions.LoginChange = App.SessionManager.SignalIsLoggedIn.subscribe(function(val){
       if(val)
       {
           _this.SocketNotificationsManager = new SocketNotificationsManager();
       }
       else{
           _this.SocketNotificationsManager = null;
       }
    });

};

AppManager.prototype.Init = function(Params)
{
    var _this = this;

    window.onerror = function myErrorHandler(errorMsg, url, lineNumber)
    {
        var errText = "url: "+url+"\r\n";
        errText += "line: "+lineNumber+"\r\n";
        errText += "err: "+errorMsg+"\r\n";

        webix.alert({
            title: LangHelper.GetString("All", "Unhandled error"),
            text: errText,
            type:"alert-error",
            buttons:[LangHelper.GetString("All", "Send error")],
            width:400,
            callback: function(result)
            {
                switch(result)
                {
                    case "0":
                        _this.NavRouter.views["AppView"].CreateTicketContextShow(errText);
                        break;
                }
            }
        });

        //webix.message({type:"error", text:errorMsg, expire:-1});

        _this.LogError({content:errorMsg});

        return false;
    };

    webix.ui.zIndexBase += 100;

    //webix.i18n.setLocale("ru-RU");
    //webix.i18n.setLocale("en-US");

    if(SkinHelper.GetDefaultSkin() === SkinsEnum.dpiui2_inss)
    {
        LangHelper.SetLocale(LocalesEnum.en.code);
    }

    if(SkinHelper.IsCubroSkin())
    {
        LangHelper.SetLocale(LocalesEnum.en.code);
    }

    if(vendor === 'cubro')
    {
        LangHelper.SetLocale(LocalesEnum.en.code);
    }

    this.Locale = LangHelper.GetLocale();

    this.NavRouter = new UiRouter({App:this});

    var _this = this;

    webix.ready(function()
    {
        if (!webix.env.touch && webix.ui.scrollSize)
        {
            webix.CustomScroll.init();
        }

        _this.NavRouter.Start();

    });
};

AppManager.prototype.Login = function(Params)
{
    var _this = this;

    function goAheadAfterSkinLoaded()
    {
        _this.HideSplash();
        _this.DicsManager.Refresh({data:[DicsEnum.RolesDic, DicsEnum.UsersDic, DicsEnum.HardwaresDic, DicsEnum.HostCategoriesDic, DicsEnum.ProtocolsGroupsDic, DicsEnum.ClsfrCategoriesDic, DicsEnum.InfectedHostCategoriesDic]});
        _this.NavRouter.ShowMainView({App:_this});

        if(Params)
        {
            _this.NavRouter.PresentView(Params);
        }
        else if(App.SessionManager.currentLogin != "admin" && App.SessionManager.HasUlrLic() && App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.ulr))
        {
            var menuId = "UlrWebIpFilterRules";

            Object
            .keys(ControllersSections)
            .filter
            (
                function(Key)
                {
                    return Key && Key.startsWith("Ulr");
                }
            )
            .every
            (
                function (Key)
                {
                    var section = ControllersSections[Key];

                    if(App.SessionManager.CheckUserRoleSection(section))
                    {
                        menuId = Key;
                        return false;
                    }

                    return true;
                }
            );

            _this.NavRouter.PresentView({id:menuId, topMenuId:menuId});
        }
        else
        {
            var menuId = "DpiPerformance";

            Object.keys(ControllersSections).every(function (Key)
            {
                var section = ControllersSections[Key];

                if(App.SessionManager.CheckUserRoleSection(section))
                {
                    menuId = Key;
                    return false;
                }

                return true;
            });

            _this.NavRouter.PresentView({id:menuId, topMenuId:menuId});
        }
    }

    function setSkin()
    {
        if(App.SessionManager.currentLogin != "admin" && App.SessionManager.HasUlrLic() && App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.ulr))
        {
            SkinHelper.SetSkin(SkinHelper.GetDefaultFilterUiSkin(), goAheadAfterSkinLoaded);

            _this.NavRouter.EnableHistory();
        }
        else
        {
            var defaultSkin = SkinHelper.GetDefaultSkin();

            if(defaultSkin == SkinHelper.GetDefaultFilterUiSkin())
                defaultSkin = SkinsEnum.dpiui2;

            SkinHelper.SetSkin(defaultSkin, goAheadAfterSkinLoaded);
        }
    }

    if(this.Subscriptions.AppVersion)
        this.Subscriptions.AppVersion.unsubscribe();

    this.Subscriptions.AppVersion = this.SessionManager.AppVersion.subscribe(function (Value)
    {
        if(Value)
            this.unsubscribe();

        if(Value)
            setSkin();

    });

    _this.setCustomWebixMessage();
};

AppManager.prototype.Logout = function(Params)
{
    "use strict";
    var _this = this;
    this.SessionManager.Logout({
        callback:function (IsLoggedIn)
        {
            if(!IsLoggedIn)
            {

                _this.NavRouter.DestroyAllViews();
                App.WebSocketManager.Disconnect("App");
                _this.NavRouter.Navigate("login");
            }

        }
    });
};

AppManager.prototype.LogError = function(Params)
{
    var _this = this;

    var params =
        {
            method:"LogError",
            data:{Content:Params.content}
        };

    App.ServerManager.CallMethod(params);
};

AppManager.prototype.HideSplash = function ()
{
    var splash = document.getElementById('splash');

    if(splash)
        document.getElementsByTagName('body')[0].removeChild(splash);
}

AppManager.prototype.setCustomWebixMessage = function()
{
    const _this = this;

    webix.message.expire = 10000;
    webix.message.position = "bottom";

    const originalMessage = webix.message;

    _this.DeleteOldMessages();

    function customWebixMessage() {
        let text, type;
        if (typeof arguments[0] === 'object') {
            text = arguments[0].text || '';
            type = arguments[0].type || '';
        } else {
            text = arguments[0];
            type = arguments[1] || '';
        }

        const savedMessages = App.SessionManager.GetPreference('SavedMessages', true);
        _this.messages = savedMessages ? savedMessages : [];

        if (_this.messages.length > 100) {
            _this.messages.pop();
        }

        text = text.replace(/<div[^>]*class=['"][^'"]*notif-body[^'"]*['"][^>]*>(.*?)<\/div>/gs, '$1');

        const index = _this.messages.findIndex(msg =>
            msg.hash === Helper.EncodeBase64Safe(text) &&
            new Date(msg.date).setSeconds(0, 0) === new Date().setSeconds(0, 0)
        );

        let message_params = {
            id: Helper.RandStr(10),
            hash: Helper.EncodeBase64Safe(text),
            text,
            type: type === "" ? "success" : type,
            date: new Date(),
            status_read: "new"
        }

        if (index !== -1)
        {
            _this.messages[index] = message_params;
        } else
        {
            _this.messages.unshift(message_params);
        }

        App.SessionManager.SetPreference("SavedMessages", _this.messages, true);

        App.SessionManager.SignalMessagesNew.next(1);

        let unreadMessage = _this.messages.filter(item => item.status_read === "new").length;
        App.SessionManager.UnreadedMessageCount.next(unreadMessage);

        const messageContextElem = $$('MessagesBtnMessageContext');

        if (messageContextElem.isVisible())
            return;

        originalMessage.hideAll();
        return originalMessage.apply(originalMessage, arguments);
    }

    for (let prop in originalMessage) {
        if (originalMessage.hasOwnProperty(prop)) {
            customWebixMessage[prop] = originalMessage[prop];
        }
    }

    webix.message = customWebixMessage;
}

AppManager.prototype.DeleteOldMessages = function()
{
    const _this = this;
    const savedMessages = App.SessionManager.GetPreference('SavedMessages', true);
    _this.savedMessages = savedMessages ? savedMessages : [];

    let currentMessages = [];
    let currentDate = new Date();
    let oneDayMs = 24 * 60 * 60 * 1000;

    _this.savedMessages.forEach(item => {
        let diffDays = Math.round(Math.abs((currentDate - new Date(item.date)) / oneDayMs));
        if (diffDays < 1)
        {
            currentMessages.push(item);
        }
    })

    App.SessionManager.SetPreference("SavedMessages", currentMessages, true);

    let unreadMessage = currentMessages.filter(item => item.status_read === "new").length;
    App.SessionManager.UnreadedMessageCount.next(unreadMessage);
}

App = new AppManager();
App.InitManagers();

var LeftSideBarView = function (Data, TopMenuId, Params)
{
    var id = Params.id+"LeftSideBar";

    var prefId = "LeftSideBar" + TopMenuId + "Collapsed";

    var collapsed = parseInt(App.SessionManager.GetPreference(prefId),10);

    var data = [];

    webix.copy(Data).forEach(function (Item, Index)
    {
        if(Item.section && App.SessionManager.CheckUserRoleSection(Item.section))
        {
            delete Item.href;
            data.push(Item);
        }

    });

    var view =
    {
        gravity: 0,
        rows:[
            {},
            {},
            {
                view: "button",
                hidden: true,
                css: "app_sidebar_collapse_button",
                type: "icon",
                icon: collapsed ? "arrow-to-right" : "arrow-to-left",
                align:"right",
                padding: 0,
                margin: 0,
                width: 40,
                click: function ()
                {
                    var collapsed = parseInt(App.SessionManager.GetPreference(prefId));

                    if(collapsed)
                    {
                        $$(id).expand();
                        this.define("icon", "arrow-to-left");
                    }
                    else
                    {
                        $$(id).collapse();
                        this.define("icon", "arrow-to-right");
                    }

                    this.refresh();

                    App.SessionManager.SetPreference(prefId, collapsed ? 0 : 1);
                }
            },
            {
                view: "sidebar",
                hidden: true,
                width:320,
                id: id,
                data: data,
                collapsed: collapsed ? true : false,
                on: {
                    onAfterSelect: function (id)
                    {
                        if (id.replace("_","") !== Params.id)
                        {
                            var __this = this;
                            setTimeout(function () {
                                //__this.unselectAll();
                                App.NavRouter.PresentView({id: id.replace("_",""), topMenuId: TopMenuId});
                            }, 1);
                        }
                    }
                }
            }
        ]
    };

    return view;
};

var ServicesLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "Subscribers", icon: "users", value: LangHelper.GetString("AppView", "Subscribers and services"), section:RoleSectionsEnum.subscribers},
        {id: "Services", icon: "cogs", value: LangHelper.GetString("AppView", "Services"), section:RoleSectionsEnum.services},
        {id: "Tariffs", icon: "dollar", value: LangHelper.GetString("AppView", "Tariff plans"), section:RoleSectionsEnum.tariffs},
        {id: "Advc", icon: "bullhorn", value: LangHelper.GetString("AppView", "Adv control"), section:RoleSectionsEnum.advc},
        {id: "HotSpot", icon: "wifi", value: LangHelper.GetString("AppView", "HotSpot"), section:RoleSectionsEnum.services}
    ], "Subscribers", Params);
};

var DpiConfigLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {
            id: "DpiPerformance", icon: "tachometer", value: LangHelper.GetString("AppView", "Performance"), section:RoleSectionsEnum.performance
        },
        {
            id: "DpiConfig", icon: "server", value: LangHelper.GetString("AppView", "Configuration"), section:RoleSectionsEnum.config
        },
        {
            id: "DpiDscpConfig", icon: "sort-numeric-asc", value: LangHelper.GetString("AppView", "Protocol prioritization (DSCP)"), section:RoleSectionsEnum.config
        },
        {
            id: "DpiAsnDscpConfig", icon: "sort-alpha-asc", value: LangHelper.GetString("AppView", "Priority for ASN"), section:RoleSectionsEnum.config
        },
        {
            id: "DpiLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Logs"), section:RoleSectionsEnum.logs
        },
        // {
        //     id: "Test", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Test"), section:RoleSectionsEnum.performance
        // }
    ], "DpiPerformance", Params);
};

var UsersLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "Users", icon: "users", value: LangHelper.GetString("AppView", "Users"), section:RoleSectionsEnum.administrator_users},
        {id: "Roles", icon: "user-secret", value: LangHelper.GetString("AppView", "Roles"), section:RoleSectionsEnum.administrator_roles},
        {id: "UsersActionsLog", icon: "user", value: LangHelper.GetString("AppView", "Users actions log"), section:RoleSectionsEnum.administrator_users_actions_log}
    ], "", Params);
};

var HardwaresLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "Hardwares", icon: "list", value: LangHelper.GetString("Hardwares", "Equipment"), section:RoleSectionsEnum.hardware}
    ], "", Params);
};

var QoELeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "QoEDashboard", icon: "braille", value: LangHelper.GetString("AppView", "QoE dashboard"), section:RoleSectionsEnum.qoeanalytics_dashboard},
        {id: "QoEFullNetFlow", icon: "fullflow", value: LangHelper.GetString("AppView", "Netflow"), section:RoleSectionsEnum.qoeanalytics_fullnetflow},
        {id: "QoERawFullNetFlow", icon: "rawfullflow", value: LangHelper.GetString("AppView", "Raw full netflow"), href:"#QoERawFullNetFlow", section:RoleSectionsEnum.qoeanalytics_rawfullnetflow},
        {id: "QoEClickStream", icon: "clickstream", value: LangHelper.GetString("AppView", "Clickstream"), section:RoleSectionsEnum.qoeanalytics_clickstream},
        {id: "QoERawClickstream", icon: "rawclickstream", value: LangHelper.GetString("AppView", "Raw clickstream"), href:"#QoERawClickstream", section:RoleSectionsEnum.qoeanalytics_rawclickstream},
        {id: "QoEFullGtpFlow", icon: "broadcast-tower", value: LangHelper.GetString("AppView", "Gtp flow"), section:RoleSectionsEnum.qoeanalytics_gtp},
        {id: "QoERawFullGtpFlow", icon: "broadcast-tower", value: LangHelper.GetString("AppView", "Raw Gtp flow"), href:"#QoERawFullGtpFlow", section:RoleSectionsEnum.qoeanalytics_rawgtp},
        {id: "QoEFullNatFlow", icon: "exchange", value: LangHelper.GetString("AppView", "NAT flow"), href:"#QoEFullNatFlow", section:RoleSectionsEnum.qoeanalytics_nat},
        {id: "QoERawFullNatFlow", icon: "exchange", value: LangHelper.GetString("AppView", "Raw NAT flow"), href:"#QoERawFullNatFlow", section:RoleSectionsEnum.qoeanalytics_rawnat},
        {id: "QoERawFullDnsFlow", icon: "globe", value: LangHelper.GetString("AppView", "Raw DNS flow"), href:"#QoERawFullDnsFlow", section:RoleSectionsEnum.qoeanalytics_rawdns},
        {id: "QoEFullDnsFlow", icon: "globe", value: LangHelper.GetString("AppView", "DNS flow"), href:"#QoEFullDnsFlow", section:RoleSectionsEnum.qoeanalytics_dns},
        {id: "QoEFullDdosAttackFlow", icon: "shield-check", value: LangHelper.GetString("AppView", "DDoS attacks"), href:"#QoEFullDdosAttackFlow", section:RoleSectionsEnum.qoeanalytics_ddos_attack},
        {id: "QoERawFullDdosAttackFlow", icon: "shield-check", value: LangHelper.GetString("AppView", "DDoS attacks log"), href:"#QoERawFullDdosAttackFlow", section:RoleSectionsEnum.qoeanalytics_raw_ddos_attack},
        {id: "QoESubscribers", icon: "qoesubscribers", value: LangHelper.GetString("AppView", "Subscribers"), href:"#QoESubscribers", section:RoleSectionsEnum.qoeanalytics_subscribers},
        {id: "QoEOnlineReports", icon: "signal-alt", value: LangHelper.GetString(this.Id, "Online reports"), href:"#QoEOnlineReports", section:RoleSectionsEnum.qoeanalytics_online_reports},
        {id: "QoETriggers", icon: "bell", value: LangHelper.GetString("AppView", "Triggers & Alerts"), href:"#QoETriggers", section:RoleSectionsEnum.qoeanalytics_triggers},
        {id: "QoECustomReports", icon: "user-tag", value: LangHelper.GetString("AppView", "Custom reports"), href:"#QoEFullNatFlow", section:RoleSectionsEnum.qoeanalytics_customreports},
        {id: "QoEUserReports", icon: "plus", value: LangHelper.GetString("AppView", "My reports"), href:"#QoEUserReports", section:RoleSectionsEnum.qoeanalytics_reports_manager},
        {id: "QoEMailingTemplates", icon: "plus", value: LangHelper.GetString("AppView", "Mailing templates"), href:"#QoEMailingTemplates", section:RoleSectionsEnum.qoeanalytics_mailing_templates},
        {id: "QoEAdmin", icon: "cogs", value: LangHelper.GetString("AppView", "Administrator"), href:"#QoEAdmin", section:RoleSectionsEnum.qoeanalytics_admin}
    ], "QoEDashboard", Params);
};

var VasCloudShopLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "VasCloudShop", icon: "shopping-bag", value: LangHelper.GetString("Shop", "Shop")},
        {id: "VasCloudShopCompanyProfile", icon: "user", value: LangHelper.GetString("Shop", "Company profile")},
        {id: "VasCloudShopMyOrders", icon: "clipboard-list", value: LangHelper.GetString("Shop", "My orders")}
    ], "", Params);
};

var VasCloudPersonalAreaLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "VasCloudPersonalArea", icon: "user", value: LangHelper.GetString("VasCloud", "Account"), href:"#VasCloudPersonalArea", section:RoleSectionsEnum.vascloud},
        {id: "VasCloudAds", icon: "bullhorn", value: LangHelper.GetString("VasCloud", "Vas Ads"), href:"#VasCloudAds", section:RoleSectionsEnum.vascloud},
        {id: "VasCloudAdsStatistics", icon: "chart-bar", value: LangHelper.GetString("AppView", "Statistics"), href:"#VasCloudAdsStatistics", section:RoleSectionsEnum.vascloud},
        {id: "VasCloudAccrualsAndPayments", icon: "file-invoice", value: LangHelper.GetString("AppView", "Accruals and payments"), href:"#VasCloudAccrualsAndPayments", section:RoleSectionsEnum.vascloud}
        // ,
        // {id: "VasCloudBillingInfo", icon: "money-check-alt", value: LangHelper.GetString("VasCloud", "Billing information"), href:"#VasCloudBillingInfo", section:RoleSectionsEnum.vascloud}
    ], "VasCloudPersonalArea", Params);
};

var VasCloudAdsSideBarView = function (Params) {
    var view = {
        view: "sidebar",
        id: Params.id+"LeftSideBar",
        data: [
            {id: "VasCloudAds", icon: "bullhorn", value: LangHelper.GetString("VasCloud", "Vas Ads"), href:"#VasCloudAds"}
        ],
        collapsed: true,
        on: {
            onAfterSelect: function (id)
            {
                if (id.replace("_","") !== Params.id)
                {
                    var __this = this;
                    setTimeout(function () {
                        //__this.unselectAll();
                        App.NavRouter.PresentView({id: id.replace("_","")});
                    }, 10);
                }
            }
        }
    };

    return view;
};

var VasCloudProtocolsLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "VasCloudProtocolsCustom", icon: "network-wired", value: LangHelper.GetString("Protocols", "Custom Protocols"), href:"#VasCloudProtocolsCustom", section:RoleSectionsEnum.vascloud},
        {id: "VasCloudCustomProtocolsGroups", icon: "network-wired", value: LangHelper.GetString("CustomProtocolsGroups", "Custom protocols groups"), href:"#VasCloudCustomProtocolsGroups", section:RoleSectionsEnum.vascloud},
        {id: "VasCloudProtocolsLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Logs"), href:"#VasCloudProtocolsLogs", section:RoleSectionsEnum.vascloud}
    ], "VasCloudProtocolsCustom", Params);
};

var AdministratorLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "Hardwares", icon: "list", value: LangHelper.GetString("Hardwares", "Equipment"), section:RoleSectionsEnum.hardware},
        {id: "HardwareSshKeys", icon: "key", value: LangHelper.GetString("Hardwares", "SSH keys"), section:RoleSectionsEnum.hardware_ssh_keys},
        {id: "Users", icon: "users", value: LangHelper.GetString("AppView", "Users"), section:RoleSectionsEnum.administrator_users},
        {id: "Roles", icon: "user-secret", value: LangHelper.GetString("AppView", "Roles"), section:RoleSectionsEnum.administrator_roles},
        {id: "UsersActionsLog", icon: "users", value: LangHelper.GetString("AppView", "Users actions log"), section:RoleSectionsEnum.administrator_users_actions_log},
        {id: "Dpiui2Config", icon: "server", value: LangHelper.GetString("AppView", "DPIUI2 (GUI) server configuration"), section:RoleSectionsEnum.administrator_dpiui2},
        {id: "Dpiui2Logs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "DPIUI2 logs"), href:"#Dpiui2Logs", section:RoleSectionsEnum.administrator_dpiui2},
        {id: "Dpiui2Update", icon: "scrubber", value: LangHelper.GetString("AppView", "DPIUI2 (GUI) update"), href:"#Dpiui2Update", section:RoleSectionsEnum.administrator_dpiui2},
        {id: "QoEStorConfig", icon: "server", value: LangHelper.GetString("AppView", "QoE Stor (fastor) server configuration"), section:RoleSectionsEnum.administrator_dpiui2},
        {id: "QoEStorLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "QoE Stor (fastor) logs"), href:"#QoEStorLogs", section:RoleSectionsEnum.administrator_dpiui2},
        {id: "BalancerConfig", icon: "server", value: LangHelper.GetString("AppView", "Balancer server configuration"), section:RoleSectionsEnum.administrator_dpiui2},
        {id: "BalancerLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Balancer logs"), href:"#BalancerLogs", section:RoleSectionsEnum.administrator_dpiui2},
        {id: "FastPcrfConfig", icon: "server", value: LangHelper.GetString("AppView", "Fast PCRF (fastpcrf) server configuration"), href:"#FastPcrfConfig", section:RoleSectionsEnum.administrator_dpiui2},
        {id: "FastPcrfLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Fast PCRF (fastpcrf) logs"), href:"#FastPcrfLogs", section:RoleSectionsEnum.administrator_dpiui2},
        {id: "CaptchaConfig", icon: "server", value: LangHelper.GetString("AppView", "Captcha configuration"), href:"#CaptchaConfig", section:RoleSectionsEnum.administrator_dpiui2},
        {id: "CaptchaTemplates", value: LangHelper.GetString("AppView", "Captcha template"), href:"#CaptchaTemplates", section:RoleSectionsEnum.administrator_dpiui2},
        {id: "CaptchaLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Captcha logs"), href:"#CaptchaLogs", section:RoleSectionsEnum.administrator_dpiui2},
    ], "Hardwares", Params);
};

var LiSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "ConnectionsValidateData", icon: "plug", value: LangHelper.GetString("AppView","Connections"), href:"#ConnectionsValidateData", section:RoleSectionsEnum.li_connections},
        {id: "TrafficManagementGenerator", icon: "bolt", value: LangHelper.GetString("AppView","Traffic generation"), href:"#TrafficManagementGenerator", section:RoleSectionsEnum.li_t_generation},
        {id: "TrafficManagementCapture", icon: "camera", value: LangHelper.GetString("AppView", "Traffic capture"), href:"#TrafficManagementCapture", section:RoleSectionsEnum.li_t_capture},
        {id: "TrafficManagementSiteClone", icon: "clone", value: LangHelper.GetString("AppView", "Cloning a website"), href:"#TrafficManagementSiteClone", section:RoleSectionsEnum.li_site_clone},
        {id: "NetworkAudit", icon: "sitemap", value: LangHelper.GetString("AppView", "Network audit"), href:"#NetworkAudit", section:RoleSectionsEnum.li_n_audit},
        {id: "TrafficDecode", icon: "router", value: LangHelper.GetString("AppView", "Traffic decode"), href:"#TrafficDecode", section:RoleSectionsEnum.li_traffic_decode},
        {id: "TrafficDecodeLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Traffic decode logs"), href:"#TrafficDecodeLogs", section:RoleSectionsEnum.li_traffic_decode},
        {id: "LiHealth", icon: "heartbeat", value: LangHelper.GetString("AppView", "Health map"), href:"#LiHealth", section:RoleSectionsEnum.li_health}
    ], "ConnectionsValidateData", Params);
};

var HardwareSshTerminalLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "HardwareSshTerminal", icon: "terminal", value: LangHelper.GetString("AppView", "Hardware ssh terminal"), section:RoleSectionsEnum.subscribers}
    ], "HardwareSshTerminal", Params);
};

webix.protoUI(
    {
        name: "multiselectmask32",

        setValue: function(value)
        {
            var val = Helper.Mask32ToArray(value).join();

            webix.ui.multiselect.prototype.setValue.apply(this,[val?val:value]);
        },

        getValue: function()
        {
            var val = webix.ui.multiselect.prototype.getValue.apply(this,[]);

            val = Helper.ArrayToMask32(val.split(","));

            return val;
        }
    },
    webix.ui.multiselect);

webix.protoUI(
    {

        name: "multiselectBitMask",
        $init: function(Config)
        {
            var opts = [];
            Config.options.forEach(function(Val){
                opts.push(parseInt(Val.id));
            });
            this._Options = opts;

            this._maskFormat = Config.maskFormat ? Config.maskFormat : "decimal";
        },
        setValue: function(value)
        {

            var val = Helper.BitMaskToArray(value, this._Options, this._maskFormat).join();

            webix.ui.multiselect.prototype.setValue.apply(this,[val ? val : value]);
        },

        getValue: function()
        {
            var val = webix.ui.multiselect.prototype.getValue.apply(this,[]);

            if(val === "")
                return val;

            val = Helper.ArrayToBitMask(val.split(","), this._maskFormat);

            return val;
        }
    },
    webix.ui.multiselect);



webix.protoUI(
    {
        name: "QoETableReportWidget",

        Bind:function(ViewController)
        {
            var _this = this;

            if(!ViewController || !ViewController.ViewModel)
                return;

            this.ViewModel = ViewController.ViewModel;

            this.ViewModel.RegisterReport({
                id:this.config.id,
                config:this.config.config
            });

            this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.config.id).signal.subscribe(function (Updated)
            {
                _this.DataSignal(Updated);
            });
        },

        Destroy:function ()
        {
        },

        DataSignal:function (Updated)
        {
            if(!Updated)
                return;

            var config = this.ViewModel.GetReportConfig(this.config.id);

            this.clearAll();
            this.parse(config.data.rows);
        },

        RefreshData:function ()
        {
            this.ViewModel.RefreshReportData(this.config.id);
        }
    },
    webix.ui.datatable);

webix.protoUI(
    {
        name: "inputlist",
        $init: function(config){
            config.body = {
                margin:5, rows:[this._getForm("plus", config)]
            };

            var _this = this;
            this.$ready.push(function(){

                this._inputs = [_this.queryView({view: "form"}).config.id];
            })
        },
        _getForm:function(mode, config){
            var id = webix.uid();
            var _this = this;
            return {
                view:"form", id:id, borderless:true, padding:0, cols:[
                    {
                        view:"text",
                        name: "value",
                        placeholder: config && config.placeholder ? config.placeholder : this.config.placeholder,
                        validate: function (Val) {
                            var validate = config && config.validate ? config.validate : _this.config.validate;

                            if(validate && typeof validate == "function")
                            {
                                return validate(Val);
                            }

                            return true;
                        },
                        invalidMessage: config && config.invalidMessage ? config.invalidMessage : this.config.invalidMessage,
                        on:{
                            onChange: function(Newv, Oldv)
                            {
                                this.validate();
                            }
                        }
                    },
                    this._getIcon(mode,id)
                ]
            }
        },
        _getIcon:function(mode,id){
            var _this = this;
            return {
                view:"button",
                type: "icon",
                icon:mode +"-circle",
                width: 32,
                css:"toolbar_round_btn",
                click:function() {
                    if (mode == "plus") _this.addInput();
                    else  _this.removeInput(id);
                }
            };
        },
        addInput:function(){
            var maxInputs = this.config.maxInputs;
            if(!maxInputs || this._inputs.length < maxInputs)
            {
                var section = this.getBody().addView(this._getForm("minus"));
                this._inputs.push(section);
            }
        },
        removeInput:function(id){
            for (var i = 0; i < this._inputs.length; i++){
                if (this._inputs[i] == id){
                    this._inputs.splice(i, 1);
                    break;
                }
            }
            this.getBody().removeView(id);
        },
        setValue:function(value){
            var valArr = [];
            if(typeof value == "string")
            {
                valArr = [value];
            }
            else if(Array.isArray(value))
            {
                valArr = value;
            }
            var dataLines = valArr.length;
            var inputs = this._inputs.length;

            var delta = dataLines - inputs;

            if (delta > 0){
                for (var i = 0; i < delta; i++)
                    this.addInput(this);
            }
            else if (delta < 0){
                for (var i = 1; i <= (-1)*delta; i++)
                {
                    this.removeInput(this._inputs[inputs-i-1]);
                }
            }

            if(this._inputs.length == 1)
            {
                this.removeInput(this._inputs[0]);
                this._inputs = [this.getBody().addView(this._getForm("plus"))];
            }

            this._inputs.forEach(function(view, i){
                $$(view).setValues({value: valArr[i]});
            });
        },
        getValue:function(){
            var values = [];
            var _this = this;
            this._inputs.forEach(function(view){
                var vs = $$(view).getValues();
                if (!_this._isEmpty(vs))
                    values.push(vs.value);
            });
            return values;
        },
        _isEmpty:function(obj){
            return !(obj && obj.value);
        }
    },
    webix.ui.forminput);

webix.protoUI(
    {
        name: "object-inputlist",
        $init: function(config){
            this.cfgproperties = config && config.cfgproperties ? config.cfgproperties : [];
            config.body = {
                margin:5, rows:[this._getForm("plus", config)]
            };

            var _this = this;
            this.$ready.push(function(){

                this._inputs = [_this.queryView({view: "form"}).config.id];
            })
        },
        _getForm:function(mode, config){
            var id = webix.uid();
            var _this = this;
            return {
                view:"form",
                id:id,
                borderless:true,
                padding:0,
                rows: [
                    {
                        cols:[
                            {
                                view:"object-input",
                                name: "value",
                                placeholder: config && config.placeholder ? config.placeholder : this.config.placeholder,
                                cfgproperties: _this.cfgproperties,
                                validate: function (Val) {
                                    var validate = config && config.validate ? config.validate : _this.config.validate;

                                    if(validate && typeof validate == "function")
                                    {
                                        return validate(Val);
                                    }

                                    return true;
                                },
                                invalidMessage: config && config.invalidMessage ? config.invalidMessage : this.config.invalidMessage,
                                on:{
                                    onChange: function(Newv, Oldv)
                                    {
                                        this.validate();
                                    }
                                }
                            },
                            this._getIcon(mode,id)
                        ]
                    },
                    {
                        height: 1,
                        css: "bottom-border-class",
                    }
                ]

            }
        },
        _getIcon:function(mode,id){
            var _this = this;
            return {
                view:"button",
                type: "icon",
                icon:mode +"-circle",
                width: 32,
                css:"toolbar_round_btn",
                click:function() {
                    if (mode == "plus") _this.addInput();
                    else  _this.removeInput(id);
                }
            };
        },
        addInput:function(){
            var maxInputs = this.config.maxInputs;
            if(!maxInputs || this._inputs.length < maxInputs)
            {
                var section = this.getBody().addView(this._getForm("minus"));
                this._inputs.push(section);
            }
        },
        removeInput:function(id){
            for (var i = 0; i < this._inputs.length; i++){
                if (this._inputs[i] == id){
                    this._inputs.splice(i, 1);
                    break;
                }
            }
            this.getBody().removeView(id);
        },
        setValue:function(value){
            var valArr = [];
            if(typeof value == "string")
            {
                valArr = [value];
            }
            else if(Array.isArray(value))
            {
                valArr = value;
            }
            var dataLines = valArr.length;
            var inputs = this._inputs.length;

            var delta = dataLines - inputs;

            if (delta > 0){
                for (var i = 0; i < delta; i++)
                    this.addInput(this);
            }
            else if (delta < 0){
                for (var i = 1; i <= (-1)*delta; i++)
                {
                    this.removeInput(this._inputs[inputs-i-1]);
                }
            }

            if(this._inputs.length == 1)
            {
                this.removeInput(this._inputs[0]);
                this._inputs = [this.getBody().addView(this._getForm("plus"))];
            }

            this._inputs.forEach(function(view, i){
                $$(view).setValues({value: valArr[i]});
            });
        },
        getValue:function(){
            var values = [];
            var _this = this;
            this._inputs.forEach(function(view){
                var vs = $$(view).getValues();
                if (!_this._isEmpty(vs))
                    values.push(vs.value);
            });
            return values;
        },
        _isEmpty:function(obj){
            return !(obj && obj.value);
        }
    },
    webix.ui.forminput);

webix.protoUI(
    {
        name: "object-input",
        $init: function(config){
            var _this = this;
            this.Form = null;
            this.FormId = "object-input-" + webix.uid();
            config.paddingX = 48;
            config.body = {
                margin:5, rows:[this._getForm(config)]
            };


            this.$ready.push(function(){
                _this.Form = $$(_this.FormId);
            })
        },
        _getForm:function(config){
            var _this = this;
            var rows = [];
            if(config && config.cfgproperties)
            {
                var arr = [];
                if(typeof config.cfgproperties == "object")
                {
                    arr = Object.values(config.cfgproperties);
                }
                else if(Array.isArray(config.cfgproperties)){
                    arr = config.cfgproperties;
                }
                var locale = LangHelper.GetLocale();
                arr.forEach(function(V){
                    var hBtnView = null, view = {name: V.id};
                    view.label =  V.title && V.title[locale] ? V.title[locale] : "";
                    view.labelPosition = "top";

                    view.view = V.view ? V.view : "text";
                    view.invalidMessage = "";
                    view.placeholder = "";
                    view.tooltip = V.description && V.description[locale] ? V.description[locale] : "";
                    // view.name = V.description && V.description[locale] ? V.description[locale] : "";

                    if(V.gui)
                    {
                        view.invalidMessage = V.gui.invalidMessage && V.gui.invalidMessage[locale] ? V.gui.invalidMessage[locale] : "";
                        view.placeholder = V.gui.placeholder ? V.gui.placeholder : "";

                        if(V.gui.validate)
                        {
                            view.validate = function(Val)
                            {
                                return ConfigHelper[V.gui.validate](Val);
                            };
                        }

                        if(V.gui.tooltip && V.gui.tooltip.use_description && V.gui.tooltip.show)
                        {
                            var description = V.description && V.description[locale] ? V.description[locale] : "";

                            if(V.wiki && V.wiki[locale])
                            {
                                description += "<br/><a href='" + V.wiki[locale] + "' target='blank'>" + LangHelper.GetString("Dics", "More...") + "</a>";
                            }

                            hBtnView = {
                                view: "button",
                                type: "icon",
                                icon: "question-circle",
                                css:"toolbar_round_btn",
                                width:32,
                                popup:{
                                    view:"popup",
                                    height:V.gui.tooltip.height ? V.gui.tooltip.height : 0,
                                    width: V.gui.tooltip.width ? V.gui.tooltip.width : 320,
                                    body:{
                                        borderless:true,
                                        template: description
                                    }
                                }
                            };
                        }

                        if(V.gui.params)
                        {
                            var prms = V.gui.params;
                            Object.keys(prms).forEach(function(K){
                                view[K] = prms[K];
                            });
                        }

                        if(V.gui.cfgproperties)
                        {
                            view.cfgproperties = V.gui.cfgproperties;
                        }
                    }


                    if(V.options)
                    {
                        var arr = [];
                        Object.keys(V.options).forEach(function(Val){
                            arr.push({
                                id: V.options[Val].id,
                                value: V.options[Val].title && V.options[Val].title[locale] ? V.options[Val].title[locale] : ""
                            });
                        });
                        view.options = arr;
                    }

                    if(view.validate)
                    {
                        view.on = {
                            "onChange": function(Newv, Oldv)
                            {
                                this.validate();
                            }
                        }
                    }

                    if(view.view == "inputlist")
                    {
                        var lbl = {
                            cols:[
                                {
                                    view: "label",
                                    label: view.label
                                }
                            ]
                        };

                        view.label = null;
                        view.labelWidth = 0;
                        rows.push({
                            cols:[
                                {
                                    rows:[
                                        lbl,
                                        view
                                    ]
                                },
                                hBtnView
                            ]
                        });
                    }
                    else{
                        rows.push(hBtnView ? {cols:[view,hBtnView]} : view);
                    }

                });
            }


            return {
                rows: [
                    {view:"form", id:this.FormId, borderless:true, padding:0, elements: [{rows: rows}]}
                ]
            }
        },
        setValue:function(value){
            var _this = this;
            var vals = {};
            if(Array.isArray(value))
            {
                value.forEach(function(V){
                    vals[V.name] = V.value;
                });
            }else if(typeof value == "object")
            {
                vals[value.name] = value.value;
            }
            this.Form.setValues(vals);
        },
        getValue:function(){
            var _this = this;
            if(this.Form)
            {
                var vals = this.Form.getValues();
                var values = [];
                Object.keys(vals).forEach(function(Key){
                    if(Key && vals[Key])
                    {
                        values.push({
                            name: Key,
                            value: vals[Key]
                        });
                    }
                });

                return values;
            }else{
                return [];
            }

        },
        _isEmpty:function(obj){
            return !(obj && obj.value);
        }
    },
    webix.ui.forminput);

webix.protoUI(
    {
        name: "InputLocal",
        $init: function(config){
            config.body = {
                margin:0, rows:[this._getForm("plus", config)]
            };

            var _this = this;
            this.$ready.push(function(){

                this._inputs = [_this.queryView({view: "form"}).config.id];
            })
        },
        _getForm:function(mode, config){
            var id = webix.uid();
            var _this = this;
            return {
                view:"form", id:id, borderless:true, padding:0,
                cols: function(){
                    const cols = [];

                    cols.push({
                            view:"richselect",
                            id: "Locales" + id,
                            name: "lang",
                            minWidth:80,
                            value:"en",
                            options:function (){
                                var r = [];
                                var arr = Helper.DictToArr(FlagsDic);
                                arr.forEach(function (Item){
                                    r.push({id:Item.id, value: Item.value});
                                });
                                return r;
                            }(),
                            disabled:true,
                            on: {
                                onAfterRender:function()
                                {
                                    //$$("Locales" + id).setValue("en");
                                },
                                onChange:function(newId, oldId){
                                    if (this.getList().getItem(newId).disabled){
                                        // prevents re-calling onChange from itself
                                        this.blockEvent();
                                        oldId ? this.setValue(oldId) : this.setValue("");
                                        this.unblockEvent();
                                    }
                                }
                            }
                        },
                        {
                            view:"text",
                            name: "value",
                            placeholder: config && config.placeholder ? config.placeholder : _this.config.placeholder,
                            validate: function (Val) {
                                var validate = config && config.validate ? config.validate : _this.config.validate;

                                if(validate && typeof validate == "function")
                                {
                                    return validate(Val);
                                }

                                return true;
                            },
                            invalidMessage: config && config.invalidMessage ? config.invalidMessage : _this.config.invalidMessage,
                            on:{
                                onChange: function(Newv, Oldv)
                                {
                                    this.validate();
                                }
                            },
                            required:true
                        },);

                    if (vendor !== 'cubro')
                        cols.push(_this._getIcon(mode,id))
                    return cols;
                }()
            }
        },
        _getIcon: function(mode,id){
            var _this = this;
            return {
                view:"button",
                type: "icon",
                icon:mode +"-circle",
                width: 32,
                css:"toolbar_round_btn",
                click:function() {
                    if (mode == "plus") _this.addInput();
                    else  _this.removeInput(id);
                }
            };
        },
        addInput: function(){
            var maxInputs = this.config.maxInputs;
            if(!maxInputs || this._inputs.length < maxInputs)
            {
                if (vendor !== 'cubro')
                {
                    var section = this.getBody().addView(this._getForm("minus"));
                    this._inputs.push(section);

                    if (LangHelper.GetLocale() != "en" && this._inputs.length == 2)
                    {
                        $$("Locales"+section).setValue(LangHelper.GetLocale());
                    }else{
                        $$("Locales"+section).enable();
                    }
                }
            }
        },
        removeInput:function(id){
            for (var i = 0; i < this._inputs.length; i++){
                if (this._inputs[i] == id){
                    this._inputs.splice(i, 1);
                    break;
                }
            }
            this.getBody().removeView(id);
        },
        setValue: function(value){
            var count = Object.keys(value).length;
            var valArr = {};
            if (count){
                valArr = value;
            }

            var dataLines = count;
            var inputs = this._inputs.length;

            var delta = dataLines - inputs;

            if (delta > 0){
                for (var i = 0; i < delta; i++)
                    this.addInput(this);
            }
            else if (delta < 0){
                for (var i = 1; i <= (-1)*delta; i++)
                {
                    this.removeInput(this._inputs[inputs-i-1]);
                }
            }

            if(this._inputs.length == 1)
            {
                this.removeInput(this._inputs[0]);
                this._inputs = [this.getBody().addView(this._getForm("plus"))];
            }

            this._inputs.forEach(function(view, i){
                $$(view).setValues({value: Object.values(valArr)[i], lang: Object.keys(valArr)[i]});
            });
        },
        getValue: function(){
            var values = {};
            var _this = this;
            this._inputs.forEach(function(view){
                var vs = $$(view).getValues();
                if (!_this._isEmpty(vs))
                    values[vs.lang] = vs.value;
            });
            return values;
        },
        _isEmpty: function(obj){
            return !(obj && obj.value);
        }
    },
    webix.ui.forminput);

webix.protoUI(
    {
        name: "trafficConfig",
        $init: function(config){
            var _this = this;

            this._PopupConfig = {
                advanced:config.advanced,
                tbf:config.tbf,
                dpiConfig: config.dpiConfig,
                "class": config.class,
                onlyInbound: config.onlyInbound,
                onlyOutbound: config.onlyOutbound
            };

            config.body = {
                margin:5, cols:[this._getForm(config)]
            };

            _this.Subscriptions = {};

            this.$ready.push(function(){

                this._input = _this.queryView({view: "form"}).config.id;

                // _this.Subscriptions.ClassEditFormSaveDataSinal = _this._PopupConfig.SaveDataSinal.subscribe(function (DataToSave)
                // {
                //     if(DataToSave)
                //     {
                //         _this.setValue(_this._PopupConfig.GetDataAsString());
                //     }
                // });
            })
        },
        _getForm:function(config){
            var id = webix.uid();
            var _this = this;
            return {
                view:"form", id:id, borderless:true, padding:0, cols:[
                    {
                        view:"text",
                        name: "value",
                        placeholder: config && config.placeholder ? config.placeholder : this.config.placeholder,
                        validate: function (Val) {
                            var validate = config && config.validate ? config.validate : _this.config.validate;

                            if(validate && typeof validate == "function")
                            {
                                return validate(Val);
                            }

                            return true;
                        },
                        invalidMessage: config && config.invalidMessage ? config.invalidMessage : this.config.invalidMessage,
                        on:{
                            onChange: function(Newv, Oldv)
                            {
                                this.validate();
                            }
                        }
                    },
                    this._getIcon(id)
                ]
            }
        },
        _getIcon:function(id){
            var _this = this;
            return {
                view:"button",
                type: "icon",
                icon:"edit",
                width: 32,
                css:"toolbar_round_btn",
                click:function() {

                    App.NavRouter.PresentModalView({
                        id: "TariffsClassConfigFormView",
                        data: Helper.ConvertTariffConfigStringToData(_this.getValue(),_this._PopupConfig.class, _this._PopupConfig.onlyInbound),
                        advanced:_this._PopupConfig.advanced,
                        tbf:_this._PopupConfig.tbf,
                        dpiConfig: _this._PopupConfig.dpiConfig,
                        onlyInbound: _this._PopupConfig.onlyInbound,
                        onlyOutbound: _this._PopupConfig.onlyOutbound
                    });
                    App.NavRouter.views.TariffClassConfigForm.Show(this.getNode(), "left");

                    _this.Subscriptions.ClassEditFormSaveDataSinal = App.NavRouter.views.TariffClassConfigForm.SaveDataSinal.subscribe(function (DataToSave)
                    {
                        if(DataToSave)
                        {
                            _this.setValue(Helper.ConvertTariffConfigData(DataToSave, _this._PopupConfig.onlyInbound, _this._PopupConfig.tbf));
                        }
                    });
                }
            };
        },
        setValue:function(value){

            $$(this._input).setValues({value: value});
        },
        getValue:function(){

            return Helper.ReplaceMultipleWhiteSpacesWithOne($$(this._input).getValues().value);
        },
        _isEmpty:function(obj){
            return !(obj && obj.value);
        }
    },
    webix.ui.forminput);

webix.protoUI(
    {
        name: "table-input",
        $init: function(config){
            this.Id = webix.uid();
            config.body = {
                margin:0, rows:[this._getTable(config)]
            };
        },
        // _getForm:function() {
        //     var _this = this;
        //     return {
        //         view: "toolbar",
        //         elements: [
        //             {},
        //             {
        //                 view: "button",
        //                 id: this.Id + "AddTaskBtn",
        //                 type: "icon",
        //                 icon: "plus",
        //                 width: 32,
        //                 css: "toolbar_round_btn",
        //                 tooltip: LangHelper.GetString(this.Id, "Add profile"),
        //                 click: function (id, e, node) {
        //                     $$(_this.Id +"QoeUplinkProtocols").add({});
        //                 }
        //             }
        //         ]
        //     }
        // },
        _getTable:function(config){
            var _this = this;
            return {
                view: "form",
                id: _this.Id,
                borderless: true,
                padding: 0,
                elements:[
                    {
                        rows:[
                            {
                                view: "toolbar",
                                elements: function(){
                                    var elements = [];

                                    if(config && config.toolbar_elements && Array.isArray(config.toolbar_elements))
                                    {
                                        config.toolbar_elements.forEach(function(item){
                                            var elem = {};
                                            Object.keys(item).forEach(function(Key){
                                                elem[Key] = item[Key];
                                            });
                                            if(elem.tooltip && typeof elem.tooltip !== "string")
                                            {
                                                elem.tooltip = LangHelper.GetLocale() === "ru" ? elem.tooltip.ru : elem.tooltip.en;
                                            }

                                            if(elem.click_action_fn && _this[elem.click_action_fn] && typeof _this[elem.click_action_fn] == "function")
                                            {
                                                elem.click = function(id,e,node)
                                                {
                                                    _this[elem.click_action_fn](id,e,node);
                                                };
                                            }
                                            elements.push(elem);
                                        });
                                    }

                                    return elements;
                                }()
                            },
                            {
                                view:"datatable",
                                id: _this.Id + "Table",
                                editable: true,
                                select: true,
                                width: config.width,
                                columns:function(){
                                    var cols = [];

                                    if(config.columns && Array.isArray(config.columns))
                                    {
                                        config.columns.forEach(function(column){
                                            var col = webix.copy(column);

                                            if(col.header && typeof col.header != "string")
                                            {
                                                col.header = LangHelper.GetLocale() === "ru" ? col.header.ru : col.header.en;
                                            }

                                            if(col.options_dic && window[col.options_dic])
                                            {
                                                col.options = Helper.DictToArr(window[col.options_dic]);

                                                if(col.options_dic_convert && window[col.options_dic_convert]
                                                    && typeof window[col.options_dic_convert] == "function")
                                                {
                                                    col.options = window[col.options_dic_convert](col.options);
                                                }
                                            }

                                            if(col.template && window[col.template])
                                            {
                                                col.template = window[col.template];
                                            }

                                            cols.push(col);
                                        });
                                    }

                                    return cols;
                                }(),
                                on: {
                                    onItemClick: function (id, e, node)
                                    {
                                        if(config.on_item_click_column_actions && config.on_item_click_column_actions[id.column])
                                        {
                                            var fn = config.on_item_click_column_actions[id.column];
                                            if(_this[fn] && typeof _this[fn] == "function")
                                            {
                                                _this[fn](id, e, node);
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        _addRow: function(id, e, node)
        {
            $$(this.Id +"Table").add({});
        },
        _removeRow: function(id, e, node)
        {
            $$(this.Id +"Table").remove(id);
        },
        setValue:function(value){
            $$(this.Id + "Table").clearAll();
            $$(this.Id + "Table").parse(value);
        },
        getValue:function(){
            return $$(this.Id + "Table").serialize();
        },
        _isEmpty:function(obj){
            return !(obj && obj.value);
        }
    },
    webix.ui.forminput);

webix.protoUI(
    {
        name: "uplink-monitor",
        $init: function(config){
            this.Id = webix.uid();
            config.body = {
                margin:0, rows:[this._getForm("plus", config)]
            };

            var _this = this;
            this.TabBarElems = {};

            this.ProtocolsArr = Helper.DictToArr(HardwareDscpProtocolsDic);

            this.$ready.push(function(){

                this._inputs = [_this.queryView({view: "form"}).config.id];
            })
        },
        _getForm:function(mode, config){
            var _this = this;
            return {
                view:"form", id:_this.Id, borderless:true, padding:0, rows:[
                    {
                        view: "toolbar",
                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                        elements: [
                            {
                                view:"tabbar",
                                id:this.Id + "GroupProtocolsTabBar",
                                close:true,
                                optionWidth:160,
                                multiview:true,
                                options:[],
                                on:{
                                    onOptionRemove: function (Id, Val)
                                    {
                                        _this._RemoveTabView(Id);
                                    }
                                }
                            },
                            {width: 32},
                            {
                                view: "button",
                                id:this.Id + "AddProtocol",
                                type: "icon",
                                icon: "plus",
                                align: "right",
                                width: 32,
                                css:"toolbar_round_btn",
                                tooltip:LangHelper.GetString("QoE","Add protocol"),
                                click: function (id, e, node)
                                {
                                    _this._AddTabView()
                                }
                            }
                        ]
                    },
                    {
                        animate:false,
                        id: this.Id + "GroupTabBarViews",
                        cells:[
                            {}
                        ]
                    }
                ]
            }
        },
        _ItemsLengthChanged: function()
        {
            let len = Object.keys(this.TabBarElems).length;

            if(len == 1)
            {
                $$(this.Id + "GroupProtocolsTabBar").disable();
            }
            else{
                $$(this.Id + "GroupProtocolsTabBar").enable();
            }

            if(len >9)
            {
                $$(this.Id + "AddProtocol").disable();
            }
            else{
                $$(this.Id + "AddProtocol").enable();
            }
        },
        _RemoveTabView: function(id){
            $$(this.Id + "GroupProtocolsTabBar").blockEvent()
            $$(this.Id + "GroupProtocolsTabBar").removeOption(id);
            $$(this.Id + "GroupProtocolsTabBar").unblockEvent();

            $$(this.Id + "GroupTabBarViews").removeView(id);
            delete this.TabBarElems[id];

            this._ItemsLengthChanged();
        },
        _updateSuggestListData: async function(suggest)
        {
            await new Promise((resolve) => {
                let list = suggest.getList();
                list.clearAll();
                list.parse(this.ProtocolsArr)
                resolve(1)
            });
        },
        _AddTabView: function(Config)
        {
            var _this = this;
            var id = Config && Config.id ? Config.id : webix.uid();

            var suggest = webix.ui({
                id: id + "ProtocolsSuggest",
                view: "suggest",
                template:function(obj){
                    return obj.protocol;
                },
                data: [], //Helper.DictToArr(HardwareDscpProtocolsDic),
                filter: function(obj, value){
                    return obj && obj.protocol && (obj.protocol.toLowerCase()).indexOf(value.toLowerCase()) !== -1;
                }
            });
            $$(this.Id + "GroupTabBarViews").addView({
                id: id,
                rows: [
                    {height: 2},
                    {
                        id: id + "Form",
                        view: "form",
                        borderless: true,
                        elements: [
                            {
                                view: "text",
                                name: "protocol",
                                label: LangHelper.GetString("QoE", "Protocol"),
                                tooltip: LangHelper.GetString("QoE", "Protocol"),
                                validate: function(Val)
                                {
                                    var proto = HardwareDscpProtocolsDic[Val];
                                    if(!proto)
                                    {
                                        return false;
                                    }

                                    $$(id + "Form").elements.protocol_code.setValue(parseInt(proto.port));

                                    return Val && Val != "";
                                },
                                suggest: suggest,
                                on: {
                                    onChange: function(){
                                        var __this = this;
                                        setTimeout(function(){
                                            var protoName = __this.getValue();
                                            var index = $$(_this.Id + "GroupProtocolsTabBar").optionIndex(id);
                                            if(protoName)
                                            {
                                                $$(_this.Id + "GroupProtocolsTabBar").config.options[index].value = __this.getValue();
                                            }
                                            else{
                                                $$(_this.Id + "GroupProtocolsTabBar").config.options[index].value = "Protocol";
                                            }

                                            $$(_this.Id + "GroupProtocolsTabBar").render();
                                        }, 1);
                                    }
                                }
                            },
                            {
                                view: "text",
                                name: "protocol_code",
                                hidden: true,
                                label: LangHelper.GetString("QoE", "Protocol"),
                                tooltip: LangHelper.GetString("QoE", "Protocol"),
                                validate: function(Val){return true;}
                            },
                            {
                                view: "richselect",
                                name: "severity",
                                label: LangHelper.GetString("QoE", "Severity"),
                                tooltip: LangHelper.GetString("QoE", "Severity"),
                                value: 0,
                                options: UplinkProtoSeverityOptions
                            },
                            BlockHeaderTemplate({title: LangHelper.GetString("QoE", "Metrics"), icon:"list"}),
                            {
                                cols: [
                                    {
                                        borderless: true,
                                        rows: [
                                            {
                                                view: "label",
                                                label: LangHelper.GetString("QoE", "Traffic volume delta")
                                            },
                                            {
                                                borderless: true,
                                                view: "uplink-lvl-table",
                                                name: "delta",
                                                labelWidth: 0,
                                                label: null,
                                                labelPosition: null,
                                                defaultValue: defaultUplinkTrafficVal,
                                                value: defaultUplinkTrafficVal,
                                                max_val: {
                                                    header: LangHelper.GetString("QoE", "Delta with normal"),
                                                    template: function(obj)
                                                    {
                                                        if(obj.max_val == "none")
                                                        {
                                                            return LangHelper.GetString("QoE", "Other");
                                                        }

                                                        return "&#60 " + obj.max_val + "%";
                                                    },
                                                    validate: function(Val){
                                                        return Val == "none" || (Helper.IsNumberNotNegative(Val) && Val >= 0 && Val < 100);
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        width: 8
                                    },
                                    {
                                        rows: [
                                            {
                                                view: "uplink-lvl-table",
                                                name: "rtt_to",
                                                // borderless: true,
                                                labelWidth: 0,
                                                label: null,
                                                labelPosition: null,
                                                defaultValue: defaultUplinkRttToVal,
                                                value: defaultUplinkRttToVal,
                                                max_val: {
                                                    header: LangHelper.GetString("QoE", "RTT to, median"),
                                                    template: function(obj)
                                                    {
                                                        if(obj.max_val == "none")
                                                        {
                                                            return LangHelper.GetString("QoE", "Other");
                                                        }

                                                        return "&#60 " + obj.max_val;
                                                    },
                                                    validate: function(Val){
                                                        return Val == "none" || Helper.IsNumberNotNegative(Val);
                                                    }
                                                }
                                            }
                                    ]}
                                ]
                            }
                        ]
                    }
                ]
            })
            $$(this.Id + "GroupProtocolsTabBar").addOption(id, Config && Config.title ? Config.title : "Protocol", true);

            this.TabBarElems[id] = {
                id:id,
                view:$$(id),
                form:$$(id+"Form")
            };
            this.TabBarElems[id].view.show();

            this._updateSuggestListData(suggest);
            this._ItemsLengthChanged();
        },
        setValue: function(value){
            var _this = this;
            var valArr = [];
            if(typeof value == "string")
            {
                valArr = [value];
            }
            else if(Array.isArray(value))
            {
                valArr = value;
            }
            var protocols = valArr.length;
            var inputs = Object.keys(this.TabBarElems).length;

            var delta = protocols - inputs;

            var elems = Object.keys(this.TabBarElems)
            if (delta > 0){
                for (var i = 0; i < delta; i++)
                    this._AddTabView(this);
            }
            else if (delta < 0){
                for (var i = 1; i <= (-1)*delta; i++)
                {
                    this._RemoveTabView(elems[inputs-i-1]);
                }
            }

            if(Object.keys(this.TabBarElems).length == 1)
            {
                this._RemoveTabView(Object.keys(this.TabBarElems)[0]);
                this._AddTabView(this);
            }

            valArr.forEach(function(v, i){
                var key = Object.keys(_this.TabBarElems)[i];
                _this.TabBarElems[key].form.setValues(v);
            });

        },
        getValue: function(){
            var _this = this;
            var res = [];

            Object.keys(this.TabBarElems).forEach(function(Key){
                _this.TabBarElems[Key].form.validate()
                res.push(_this.TabBarElems[Key].form.getValues())
            });


            return res;
        },
        _isEmpty: function(obj){
            return !(obj && obj.value);
        }
    },
    webix.ui.forminput
)

webix.protoUI({
    name: "uplink-lvl-table",
    $init: function(config){
        var _this = this;
        this.Id = webix.uid();
        config.body = {
            margin:0, rows:[
                {
                    borderless: true,
                    view: "datatable",
                    id: this.Id + "Table",
                    select: "row",
                    editable: true,
                    editaction:"dblclick",
                    columns: function(){
                       var res = [];

                       var editBtn = {
                           id: "edit",
                           header: "",
                           width: 32,
                           template: function(obj)
                           {
                               if(obj.max_val == "none")
                               {
                                   return "";
                               }

                               return CellEditBtnTemplate(obj);
                           },
                           headermenu: false
                       };

                       var mx_val = {
                           id: "max_val",
                           fillspace: true,
                           header: LangHelper.GetString("Dics", "Max value"),
                           editor: "text"
                       }

                       if(config && config.max_val)
                       {
                           var cfg = config.max_val;
                           if(cfg.header)
                           {
                               mx_val.header = cfg.header;
                           }

                           if(cfg.template)
                           {
                               mx_val.template = cfg.template
                           }
                       }

                       res.push(editBtn);
                       res.push(mx_val);
                       res.push({
                           id: "points",
                           // fillspace: true,
                           header: LangHelper.GetString("QoE", "Points"),
                           editor: null,
                           width: 80
                       });

                       return res;

                    }(),
                    rules: function(){
                        var res = {};

                        if(config && config.max_val)
                        {
                            var val = config.max_val.validate;
                            if(val && typeof val === "function")
                            {
                                res['max_val'] = val;
                            }
                        }

                        return res;
                    }(),
                    on: {
                        onBeforeEditStart: function (id)
                        {
                            if(id.column == "max_val")
                            {
                                var item = this.getItem(id.row);

                                if(item && item.max_val == "none")
                                {
                                    return false;
                                }
                            }
                            else if(id.column == "points")
                            {
                                return false;
                            }
                            // else if(id.column == "points")
                            // {
                            //     return false;
                            // }
                            return true;
                        },
                        onItemClick: function(id)
                        {
                            if(id.column == "edit")
                            {
                                this.editCell(id.row, "max_val");
                            }
                        }
                    }
                }
            ]
        };
        this.defaultValue = config.defaultValue;
        this.$ready.push(function(){
            _this.Table = $$(_this.Id + "Table");
            _this.setValue()
        })
    },
    setValue: function(value){
        var val = [];
        if(value)
        {
            val = value;
        }
        else{
            val = this.defaultValue;
        }
        this.last_value = val;

        if(this.Table)
        {
            this.Table.clearAll();
            this.Table.parse(val);
        }

    },
    getValue: function(){
        this.Table.validate();
        return this.Table.serialize();
    }

}, webix.ui.forminput)

webix.protoUI({
    name: "hotspot-http-req-input",
    $init: function(config)
    {
        var _this = this;
        this.Id = webix.uid();
        this.Views = {
            Form: null,
            MethodSelect: null,
            FormPostParamsSection: null,
            HeadersTable: null,
            BodyType: null,
            BodyRow: null,
            BodyForm: null,
            BodyFormTable: null
        };

        this.ParamsContext = webix.ui({
            view: "popup",
            id: this.Id + "ParamsContext",
            maxWidth: 480,
            height: 200,
            body: {
                rows:[
                    {
                        borderless:true,
                        template:LangHelper.GetString("HotSpot" , "Add parameters to the request body or url for the request to be processed correctly")
                    },
                    {
                        borderless:true,
                        id:this.Id + "ParamsContextTable",
                        name: "headers",
                        view: "datatable",
                        select:"cell",
                        multiselect:true,
                        clipboard:"selection",
                        resizeColumn:true,
                        tooltip:true,
                        scroll:false,
                        checkboxRefresh:true,
                        autoheight:true,
                        columns:
                            [
                                {
                                    id: "name",
                                    header: [TooltipTemplate(LangHelper.GetString("QoE", "Name"))],
                                    fillspace: 1
                                },
                                {
                                    id: "example",
                                    header: [TooltipTemplate(LangHelper.GetString("HotSpot", "Example"))],
                                    fillspace: 1
                                }
                            ],
                        data:function(){
                            var res = [
                                {
                                    "name": LangHelper.GetString("HotSpot","Phone"),
                                    "example": "[PHONE]"
                                }
                            ];

                            if(!config.only_phone)
                            {
                                res.push({
                                    "name": LangHelper.GetString("HotSpot","Code"),
                                    "example": "[CODE]"
                                })
                            }
                            else
                            {
                                res.push({
                                    "name": LangHelper.GetString("HotSpot","IP address"),
                                    "example": "[IP]"
                                });
                            }

                            return res;
                        }()
                    }
                ]
            }
        });

        config.body = {
            margin: 0,
            rows: [
                {
                    view: "form",
                    id: this.Id + "Form",
                    borderless: true,
                    elements: [
                        {
                            cols: [
                                {
                                    id: this.Id + "MethodSelect",
                                    view: "richselect",
                                    name: "method",
                                    label: LangHelper.GetString("QoE","Method"),
                                    labelPosition: "top",

                                    options: function () {
                                        var arr = [];

                                        Object.keys(QoETriggerActionHttpMethodEnum).forEach(function (Key) {
                                            arr.push({id: Key, value: Key});
                                        });

                                        return arr;
                                    }()
                                },
                                {
                                    view: "text",
                                    name: "url",
                                    label: LangHelper.GetString("QoE", "Url"),
                                    labelPosition: "top",
                                    tooltip: "http://www.exmple.com",
                                    placeholder: "http://www.exmple.com",
                                    attributes: {maxlength: 1000},
                                    gravity: 3,
                                    on: {
                                        "onChange": function () {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "button",
                                    type: "icon",
                                    icon: "code",
                                    width: 32,
                                    css: "toolbar_round_btn",
                                    tooltip: LangHelper.GetString("QoE", "Tepmplate parameters"),
                                    borderless: true,
                                    click: function (id, e, node) {
                                        var node = this.getNode(id);
                                        _this.ParamsContext.show(node, {pos: "bottom"});
                                        console.log('Template params');
                                    }
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    rows: [
                                        BlockHeaderTemplate({title:LangHelper.GetString('QoE', "Headers")}),
                                        {
                                            view: "toolbar",
                                            height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "plus",
                                                    width: 32,
                                                    css:"toolbar_round_btn",
                                                    tooltip:LangHelper.GetString("QoE","Add header"),
                                                    click: function (id, e, node)
                                                    {
                                                        var model = new QoETriggerActionHttpHeaderModel();

                                                        _this.Views.HeadersTable.add(model);
                                                        _this.Views.HeadersTable.editRow(model.id);
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            id:this.Id + "HeadersTable",
                                            name: "headers",
                                            view: "datatable",
                                            select: "row",
                                            minWidth: 200,
                                            height:232,
                                            scrollY: true,
                                            tooltip:true,
                                            editable:true,
                                            columns:
                                                [
                                                    {
                                                        id: "name",
                                                        header: [TooltipTemplate(LangHelper.GetString("QoE", "Name"))],
                                                        fillspace: 1,
                                                        editor: "text"
                                                    },
                                                    {
                                                        id: "value",
                                                        header: [TooltipTemplate(LangHelper.GetString("QoE", "Value"))],
                                                        fillspace: 1,
                                                        editor: "text"
                                                    },
                                                    {
                                                        id: "trash",
                                                        header: "",
                                                        width: 32,
                                                        template: CellTrashBtnTemplate,
                                                        headermenu: false,
                                                        align:"right"
                                                    }
                                                ],
                                            data:[],
                                            on:
                                                {
                                                    onItemClick: function (id,e,node)
                                                    {
                                                        if (id.column === 'trash')
                                                        {
                                                            this.remove(id);
                                                        }
                                                    }
                                                }
                                        }
                                    ]
                                },
                                {
                                    id: this.Id + "FormPostParamsSection",
                                    cols: [
                                        {view: "resizer"},
                                        {
                                            rows: [
                                                BlockHeaderTemplate({title:LangHelper.GetString('QoE', "Body")}),
                                                {
                                                    rows:[
                                                        {
                                                            view: "richselect",
                                                            id: this.Id + "BodyType",
                                                            name: "body_type",
                                                            label: LangHelper.GetString("HotSpot", "Body type"),
                                                            labelPosition: "left",
                                                            labelWidth: 200,
                                                            options:function () {
                                                                var arr = [];

                                                                Object.keys(QueryBodyTypesEnum).forEach(function (Key) {
                                                                    arr.push({id:Key, value:Key});
                                                                });

                                                                return arr;
                                                            }()
                                                        },
                                                        {
                                                            id: this.Id + "BodyRow",
                                                            view:"codemirror-editor",
                                                            name: "body"
                                                        },
                                                        {
                                                            id:this.Id + "BodyForm",
                                                            rows:[
                                                                {
                                                                    view: "toolbar",
                                                                    height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                                    elements: [
                                                                        {
                                                                            view: "button",
                                                                            type: "icon",
                                                                            icon: "plus",
                                                                            width: 32,
                                                                            css:"toolbar_round_btn",
                                                                            tooltip:LangHelper.GetString("QoE","Add form data"),
                                                                            click: function (id, e, node)
                                                                            {
                                                                                var model = new QoETriggerActionHttpHeaderModel();

                                                                                _this.Views.BodyFormTable.add(model);
                                                                                _this.Views.BodyFormTable.editRow(model.id);
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "BodyFormTable",
                                                                    name: "body_form",
                                                                    view: "datatable",
                                                                    select: "row",
                                                                    tooltip:true,
                                                                    editable:true,
                                                                    scrollY: true,
                                                                    height:200,
                                                                    columns:
                                                                        [
                                                                            {
                                                                                id: "name",
                                                                                header: [TooltipTemplate(LangHelper.GetString("QoE", "Name"))],
                                                                                fillspace: 1,
                                                                                editor: "text"
                                                                            },
                                                                            {
                                                                                id: "value",
                                                                                header: [TooltipTemplate(LangHelper.GetString("QoE", "Value"))],
                                                                                fillspace: 1,
                                                                                editor: "text"
                                                                            },
                                                                            {
                                                                                id: "trash",
                                                                                header: "",
                                                                                width: 32,
                                                                                template: CellTrashBtnTemplate,
                                                                                headermenu: false,
                                                                                align:"right"
                                                                            }
                                                                        ],
                                                                    data:[],
                                                                    on:
                                                                        {
                                                                            onItemClick: function (id,e,node)
                                                                            {
                                                                                if (id.column === 'trash')
                                                                                {
                                                                                    this.remove(id);
                                                                                }
                                                                            }
                                                                        }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        };

        this.defaultValue = config.defaultValue;
        this.$ready.push(() => {
            Object.keys(this.Views).forEach(Key => {
                this.Views[Key] = $$(this.Id + Key);
            });

            this.Views.MethodSelect.attachEvent("onChange", function(Val){
                if(Val == QoETriggerActionHttpMethodEnum.POST)
                {
                    _this.Views.FormPostParamsSection.show();
                }
                else{
                    _this.Views.FormPostParamsSection.hide();
                }
            });

            this.Views.BodyType.attachEvent("onChange", function(Val){
                if(Val == QueryBodyTypesEnum.Form)
                {
                    _this.Views.BodyRow.hide();
                    _this.Views.BodyForm.show();
                }
                else{
                    _this.Views.BodyRow.show();
                    _this.Views.BodyForm.hide();
                }
            });

            this.setValue();
        });
    },
    setValue: function(Value)
    {
        var _this = this;
        var obj = {};

        try{
            obj = JSON.parse(Value);
        }
        catch(e){}

        if(!obj.method)
        {
            obj.method = QoETriggerActionHttpMethodEnum.GET;
        }
        
        if(!obj.headers)
        {
            obj.headers = [];
        }
        this.Views.HeadersTable.clearAll();
        this.Views.HeadersTable.parse(obj.headers);


        var body_type = obj.body_type ? obj.body_type : QueryBodyTypesEnum.Form;
        this.Views.BodyType.setValue(body_type);

        if(!obj.body_form)
        {
            obj.body_form = [];
        }
        this.Views.BodyFormTable.clearAll();
        this.Views.BodyFormTable.parse(obj.body_form);

        var body_row = "";
        try{
            body_row = obj.body ? JSON.stringify(obj.body, null, 2) : "";
        }
        catch(e)
        {
            body_row = obj.body;
        }

        this.Views.BodyRow.setValue(body_row);

        if(typeof obj.body == "object")
        {
            obj.body = JSON.stringify(obj.body, null, 2);
        }

        this.Views.Form.setValues(obj);
    },
    getValue: function()
    {
        var obj = {};

        obj.headers = this.Views.HeadersTable.serialize();
        var form_data = this.Views.Form.getValues();
        obj.method = form_data.method;
        obj.url = form_data.url;
        obj.body_type = this.Views.BodyType.getValue();
        obj.body_form = this.Views.BodyFormTable.serialize();
        var body_val = this.Views.BodyRow.getValue();
        try{
            obj.body = body_val ? JSON.parse(body_val) : "";
        }
        catch(e)
        {
            obj.body = body_val;
        }

        return JSON.stringify(obj);
    }
}, webix.ui.forminput);

webix.protoUI({
    name: "image-with-preview-input",
    $init: function(config)
    {
        var _this = this;
        this.Id = webix.uid();
        this.Views = {
            ImagePreview: null,
            Uploader: null
        };

        this.url = "";

        config.body = {
            marin: 0,
            cols: [
                {
                    view: "template",
                    id: this.Id + "ImagePreview",
                    height: 120,
                    template: function(Val)
                    {
                        var res = "<div style='height:120px;background: url("+ Val.url + ") center center;background-repeat: no-repeat;background-size: contain;'></div>";

                        return res;
                    }
                },
                {
                    rows: [
                        {},
                        {
                            height: 64,
                            id: this.Id + "Uploader",
                            view: "uploader",
                            multiple: false,
                            autosend: false,
                            accept: config.accept,
                            label: LangHelper.GetString(this.Id, "Click to download or drag a file"),
                            value: LangHelper.GetString(this.Id, "Click to download or drag a file")
                        },
                        {}
                    ]
                }
            ]
        };

        this.defaultValue = config.defaultValue;
        this.$ready.push(() => {
            Object.keys(this.Views).forEach(Key => {
                this.Views[Key] = $$(this.Id + Key);
            });

            _this.Views.Uploader.attachEvent("onAfterFileAdd", function(file)
            {
                if(file.size > 750 * 1024)
                {
                    webix.message({text: LangHelper.GetString(_this.Id, "Image file max size is 750kb"),type:"error"});
                    return;
                }

                var reader = new FileReader();

                reader.onload = function(event){
                    _this.url = event.target && event.target.result ? event.target.result : "";
                    _this._loadImage();

                };
                reader.onerror = function(error)
                {
                };

                reader.readAsDataURL(file.file);
            });

            this.setValue();
        });
    },
    _loadImage: function()
    {
        var _this = this;
        var img = new Image();

        img.onload = function()
        {
            _this.Views.ImagePreview.setValues({url: _this.url, height: img.height});

            _this.Views.ImagePreview.define("height", 120);
            _this.Views.ImagePreview.refresh();
        };

        img.src = _this.url;
    },
    setValue: function(Value)
    {
        var _this = this;

        _this.url = Value;

        if(_this.url)
        {
            _this._loadImage();
        }
    },
    getValue: function()
    {
        return this.url ? this.url : "";
    }
}, webix.ui.forminput);


webix.editors.textarea = {
    focus:function(){
        this.getInputNode(this.node).focus();
        this.getInputNode(this.node).select();
    },
    getValue:function(){
        return this.getInputNode(this.node).value;
    },
    setValue:function(value){
        this.getInputNode(this.node).value = value;
    },
    getInputNode:function(){
        return this.node.firstChild;
    },
    render:function(){
        return webix.html.create("div", {
            "class":"webix_dt_editor"
        }, "<textarea class='textarea webix_view'></textarea>");
    }
};


webix.protoUI({
    name:"qoedashboard",
    $dragCreate:function(source, event)
    {
        var target = $$(event);

        if(target && target.config && (target.config.css === "app_block__header" || target.config.view === "dataview" || target.config.view === "template"))
        {
            return webix.ui.dashboard.prototype.$dragCreate.apply(this, arguments);
        }

        return false;
    },
    $dragIn:function(s,t,event)
    {
        var sourceViewId = s && webix.html.locate(s, "view_id") ? webix.html.locate(s, "view_id") : "";

        if(sourceViewId === "QoEDashboardDashboard" || sourceViewId === "QoEDashboardWidgetsSuggestWidgetsList")
        {
            return webix.ui.dashboard.prototype.$dragIn.apply(this, arguments);
        }

        return false;

    }

}, webix.ui.dashboard);

var QoESingleStatTotalsWidget = function (Params, Online)
{
    var params = {
        //title:LangHelper.GetString("QoE", "Totals"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoE" + (Online ? "Online" : "") + "SingleStatTotalsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:[
                {col:"", alias:"total", func:QoEReportFunctions.Total},
                {col:"", alias:"sessons_uniq", func:QoEReportFunctions.SessionsUniq},
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond},
                {col:"", alias:"traffic_from_subscriber", func:QoEReportFunctions.AvgTrafficSpeedFromSubsBitsPerSecond},
                {col:"", alias:"traffic_to_subscriber", func:QoEReportFunctions.AvgTrafficSpeedToSubsBitsPerSecond}
            ],
            sort:{id:"total",dir:"desc"},
            flags:{
                use_where:0,
                use_size:0
            },
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        columns:[
            {
                id:"total",
                header:LangHelper.GetString("QoE", "Connections"),
                icon:"plug",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                }
            },
            {
                id:"sessons_uniq",
                header:LangHelper.GetString("QoE", "Sessions"),
                icon:"arrows-h",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                }
            },
            {
                id:"traffic",
                header:LangHelper.GetString("QoE", "Traffic"),
                icon:"arrows-v",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
                }
            },
            {
                id:"traffic_from_subscriber",
                header:LangHelper.GetString("QoE", "Traffic from subscribers"),
                icon:"cloud-upload",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
                }
            },
            {
                id:"traffic_to_subscriber",
                header:LangHelper.GetString("QoE", "Traffic to subscribers"),
                icon:"cloud-download",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
                }
            }
        ],
        compact:Params&&Params.compact,
        xCount:Params&&Params.xCount?Params.xCount:5,
        yCount:Params&&Params.yCount?Params.yCount:1,
        type:
        {
            width: "auto",
            height: "auto"
        }
    };

    params.config.values.forEach(function (Col)
    {
        params.config.cache.values.push({col:(Col.alias ? Col.alias : Col.col)});
    });

    return new QoESingleStatWidget(params);
};

var QoESingleStatTotalsVertWidget = function (Params, Online)
{
    var params = webix.extend({xCount:1, yCount:5, name:"QoESingleStatTotalsVertWidget"}, Params, true);

    return QoESingleStatTotalsWidget(params, Online);
};

var QoEUplinkMonitor = function (Params) {
    "use strict";

    const id = Params && Params.id ? Params.id : webix.uid();

    const params = {
        id: id,
        name: "QoEUplinkMonitor",
        widget_settings: Params.widget_settings,
        config: {},
        chart_type: "line",
        chart_serie: "traffic",
        // xCount: xCount,
        // yCount: yCount,
        type: {
            width: "auto",
            height: "auto"
        }
    };

    return new QoEMonitorWidget(params);
}

var QoeThreatsMonitorWidgetNetflow = function (Params)
{
    let Config = {};
    Config.title = "Threats monitor Widget (Netfow)"
    Config.name = "QoeThreatsMonitorWidgetNetflow";
    Config.type = QoEReportConfigTypeEnum.ClientPredefined;
    Config.table = QoEReportTablesEnum.FullnetflowAgg;
    Config.view = QoEReportViews.FullFlow;
    Config.clickable = true;
    Config.infected_categories = App.DicsManager.GetDicAsArray(DicsEnum.InfectedHostCategoriesDic)

    return QoeThreatsMonitorWidget(Params, Config)
}

var QoeThreatsMonitorWidgetClickstream = function (Params)
{
    let Config = {};
    Config.title = "Threats monitor Widget (Clickstream)"
    Config.name = "QoeThreatsMonitorWidgetClickstream";
    Config.type = QoEReportConfigTypeEnum.ClientPredefined;
    Config.table = QoEReportTablesEnum.ClickstreamAgg;
    Config.view = QoEReportViews.ClickStream;
    Config.clickable = true;
    Config.infected_categories = App.DicsManager.GetDicAsArray(DicsEnum.InfectedHostCategoriesDic)

    return QoeThreatsMonitorWidget(Params, Config)
}

var QoeThreatsMonitorWidget = function (Params, Config)
{
    var params = {
        title:LangHelper.GetString("QoE", Config.title) + " - powered by <span style='background: url(assets/imgs/kaspersky_logo.svg) center center; background-repeat: no-repeat; background-size: cover; color:transparent;'>....................</span>",
        icon:"siren-on",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Config.name,
        clickable: Config.clickable,
        cell_template_params:{na: "0"},
        config:{
            type: Config.type,
            table:Config.table,
            view: Config.view,
            values: function()
            {
                let values = [];

                let CodesString = Config.infected_categories.map(item => `'${item.id}'`).join(", ");

                values.push({col:"", alias: "uniq_infected_subscribers", func: `uniqIf(subscriber, host_category_code IN (${CodesString}))`})

                for (let item of Config.infected_categories) {
                    let value = {col:"", alias: item.id, func: `uniqIf(subscriber, host_category_code='${item.id}')`}
                    values.push(value);
                }

                return values
            }(),
            sort:{id: "uniq_infected_subscribers", dir:"desc"},
            flags:{
                use_where:0,
                use_size:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        columns: function () {

            let cols = []

            cols.push({
                id: "uniq_infected_subscribers",
                header: LangHelper.GetString("QoE", "Infected subscribers"),
                icon:"users",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                }
            })

            for (let item of Config.infected_categories) {
                let col =
                    {
                        id: item.id,
                        header: QoeThreatsWidgetDic[item.id].sub_value,
                        icon:"users",
                        template: function (Val)
                        {
                            return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                        }
                    };
                cols.push(col);
            }

            return cols;
        }(),
        compact:Params&&Params.compact,
        xCount:Params&&Params.xCount?Params.xCount:4,
        yCount:Params&&Params.yCount?Params.yCount:1,
        type:
            {
                width: "auto",
                height: "auto"
            }
    };

    params.config.values.forEach(function (Col)
    {
        params.config.cache.values.push({col:(Col.alias ? Col.alias : Col.col)});
    });

    return new QoESingleStatWidget(params);
}

var QoETableFullNetflowTopInfectedSubscribersConfig = function ()
{
    let Config = {};
    Config.type = QoEReportConfigTypeEnum.ClientPredefined;
    Config.table = QoEReportTablesEnum.FullnetflowAgg;
    Config.view = QoEReportViews.FullFlow;

    return Config;
}

var QoETableFullNetflowTopInfectedSubscribersWidget = function(Params)
{
    let Config = QoETableFullNetflowTopInfectedSubscribersConfig();
    Config.title = LangHelper.GetString("QoE", "Top infected subscribers (Netflow)");
    Config.name = "QoETableFullNetflowTopInfectedSubscribersWidget";
    Config.infected_categories = ["kaspersky_botnet_hosts", "kaspersky_malicious_hosts", "kaspersky_phishing_hosts"]

    return QoETableTopInfectedSubscribersWidget(Params, Config);
}

var QoETableFullNetflowTopInfectedSubscribersMaliciousTrafficWidget = function(Params)
{
    let Config = QoETableFullNetflowTopInfectedSubscribersConfig();
    Config.title = LangHelper.GetString("QoE", "Top infected subscribers with malicious traffic (Netflow)");
    Config.name = "QoETableFullNetflowTopInfectedSubscribersMaliciousTrafficWidget";
    Config.infected_categories = ["kaspersky_malicious_hosts"]

    return QoETableTopInfectedSubscribersWidget(Params, Config);
}

var QoETableFullNetflowTopInfectedSubscribersBotnetTrafficWidget = function(Params)
{
    let Config = QoETableFullNetflowTopInfectedSubscribersConfig();
    Config.title = LangHelper.GetString("QoE", "Top infected subscribers with botnet traffic (Netflow)");
    Config.name = "QoETableFullNetflowTopInfectedSubscribersBotnetTrafficWidget";
    Config.infected_categories = ["kaspersky_botnet_hosts"]

    return QoETableTopInfectedSubscribersWidget(Params, Config);
}

var QoETableFullNetflowTopInfectedSubscriberPhishingTrafficWidget = function(Params)
{
    let Config = QoETableFullNetflowTopInfectedSubscribersConfig();
    Config.title = LangHelper.GetString("QoE", "Top infected subscribers with phishing traffic (Netflow)");
    Config.name = "QoETableFullNetflowTopInfectedSubscriberPhishingTrafficWidget";
    Config.infected_categories = ["kaspersky_phishing_hosts"]

    return QoETableTopInfectedSubscribersWidget(Params, Config);
}

var QoETableClickstreamTopInfectedSubscribersConfig = function()
{
    let Config = {};
    Config.type = QoEReportConfigTypeEnum.ClientPredefined;
    Config.table = QoEReportTablesEnum.ClickstreamAgg;
    Config.view = QoEReportViews.ClickStream;

    return Config;
}

var QoETableClickstreamTopInfectedSubscribersWidget = function(Params)
{
    let Config = QoETableClickstreamTopInfectedSubscribersConfig();
    Config.title = LangHelper.GetString("QoE", "Top infected subscribers (Clickstream)");
    Config.name = "QoETableClickstreamTopInfectedSubscribersWidget";
    Config.infected_categories = ["kaspersky_botnet_hosts", "kaspersky_malicious_hosts", "kaspersky_phishing_hosts"]

    return QoETableTopInfectedSubscribersWidget(Params, Config);
}

var QoETableClickstreamTopInfectedSubscribersMaliciousTrafficWidget = function(Params)
{
    let Config = QoETableClickstreamTopInfectedSubscribersConfig();
    Config.title = LangHelper.GetString("QoE", "Top infected subscribers with malicious traffic (Clickstream)");
    Config.name = "QoETableClickstreamTopInfectedSubscribersMaliciousTrafficWidget";
    Config.infected_categories = ["kaspersky_malicious_hosts"]

    return QoETableTopInfectedSubscribersWidget(Params, Config);
}

var QoETableClickstreamTopInfectedSubscribersBotnetTrafficWidget = function(Params)
{
    let Config = QoETableClickstreamTopInfectedSubscribersConfig();
    Config.title = LangHelper.GetString("QoE", "Top infected subscribers with botnet traffic (Clickstream)");
    Config.name = "QoETableClickstreamTopInfectedSubscribersBotnetTrafficWidget";
    Config.infected_categories = ["kaspersky_botnet_hosts"]

    return QoETableTopInfectedSubscribersWidget(Params, Config);
}

var QoETableClickstreamTopInfectedSubscriberPhishingTrafficWidget = function(Params)
{
    let Config = QoETableClickstreamTopInfectedSubscribersConfig();
    Config.title = LangHelper.GetString("QoE", "Top infected subscribers with phishing traffic (Clickstream)");
    Config.name = "QoETableClickstreamTopInfectedSubscriberPhishingTrafficWidget";
    Config.infected_categories = ["kaspersky_phishing_hosts"]

    return QoETableTopInfectedSubscribersWidget(Params, Config);
}

var QoETableTopInfectedSubscribersWidget = function(Params, Config)
{
    var params = {
        title: Config.title,
        icon:"table",
        id: Params&&Params.id?Params.id:webix.uid(),
        name: Config.name,
        config: {
            type: Config.type,
            table: Config.table,
            view: Config.view,
            values: [
                {col:"login", alias:"login_any",func:"any"},
                {col:"host", alias:"hosts_uniq", func:"uniq"},
                {col:"host_category", alias:"host_category_uniq", func:"uniq"},
                {col:"host_ip", alias:"host_ip_uniq", func:"uniq"}
            ],
            rows:[
                "subscriber"
            ],
            sort: {id: "hosts_uniq", dir: "desc"},
            flags: {
                use_size: 0,
                use_where: 0
            },
            limit:1000000,
            cache:{
                enabled: 1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        filter: {
            "host_category_code_filter": function () {
                let values = [];
                for (let item of Config.infected_categories) {
                    values.push(item);
                }
                return {id:"host_category_code", operator:"in", value: values}
            }()
        },
        columns: [
            {
                id:"subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            },
            {
                id:"login",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                template:function(Obj)
                {
                    return Obj.login_any;
                },
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            },
            {
                id:"hosts_uniq",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts")), ""],
                format:webix.i18n.intFormat,
                footer:{content:"totalColumn"},
                sort:"string"
            },
            {
                id:"host_ip_uniq",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), ""],
                format:webix.i18n.intFormat,
                footer:{content:"totalColumn"},
                sort:"string"
            },
            {
                id:"host_category_uniq",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host categories")), ""],
                format:webix.i18n.intFormat,
                footer:{content:"totalColumn"},
                sort:"string"
            },
            {
                id:"empty",
                header:"",
                fillspace:1
            }
        ],
        leftSplit:2,
        sort_map:{"login":"login_any"},
        can_use_sort_map:{
            "ReportsSettings": 1
        }
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
}

var QoESingleStatSubscribersRttWidget = function (Params)
{
    var widgetSettings = Params && Params.widget_settings ? Params.widget_settings : null;
    var bigRTT = widgetSettings && widgetSettings.subscribers_big_rtt ? widgetSettings.subscribers_big_rtt : 1000;
    var smallRTT = widgetSettings && widgetSettings.subscribers_small_rtt ? widgetSettings.subscribers_small_rtt : 500;

    var params = {
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name : "QoESingleStatSubscribersRttWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view:QoEReportViews.RttForSubs,
            values:[
                {col:"", alias:"subscribers_uniq", func:"uniq(subscriber_login)"},
                {col:"", alias:"subscribers_big_rtt", func:"uniqIf(subscriber_login, rtt > " + bigRTT + ")"},
                {col:"", alias:"subscribers_medium_rtt", func:"uniqIf(subscriber_login, rtt <= "+ bigRTT +" and rtt >= "+ smallRTT +" )"},
                {col:"", alias:"subscribers_small_rtt", func:"uniqIf(subscriber_login, rtt < "+ smallRTT +" and rtt > 0)"},
                {col:"", alias:"subscribers_defined_rtt", func:"uniqIf(subscriber_login, rtt > 0)"},
                {col:"", alias:"subscribers_undef_rtt", func:"minus(subscribers_uniq, subscribers_defined_rtt)"}
            ],
            sort:{id:"subscribers_uniq",dir:"desc"},
            flags:{
                use_where:0,
                use_size:0
            },
            cache:{
                enabled:1,
                values:[],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        columns:
            [
                {
                    id:"subscribers_uniq",
                    header:LangHelper.GetString("QoE", "Subscribers"),
                    icon:"users",
                    template: function (Val)
                    {
                        return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                    }
                },
                {
                    id:"subscribers_undef_rtt",
                    header:LangHelper.GetString("QoE", "Subscribers with undefined RTT"),
                    icon:"users",
                    template: function (Val)
                    {
                        return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                    }
                },
                {
                    id:"subscribers_big_rtt",
                    header:LangHelper.GetString("QoE", "Subscribers with big RTT"),
                    icon:"users",
                    template: function (Val)
                    {
                        return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                    }
                },
                {
                    id:"subscribers_medium_rtt",
                    header:LangHelper.GetString("QoE", "Subscribers with medium RTT"),
                    icon:"users",
                    template: function (Val)
                    {
                        return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                    }
                },
                {
                    id:"subscribers_small_rtt",
                    header:LangHelper.GetString("QoE", "Subscribers with small RTT"),
                    icon:"users",
                    template: function (Val)
                    {
                        return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                    }
                }
            ],
        compact:false,
        xCount:Params&&Params.xCount?Params.xCount:5,
        yCount:Params&&Params.yCount?Params.yCount:1,
        type:
            {
                width: "auto",
                height: "auto"
            }
    };

    params.config.values.forEach(function (Col)
    {
        params.config.cache.values.push({col:(Col.alias ? Col.alias : Col.col)});
    });

    return new QoESingleStatWidget(params);
};

var QoESingleStatSubscribersRttVertWidget = function (Params)
{
    var params = webix.extend({xCount:1, yCount:4, name:"QoESingleStatSubscribersRttVertWidget"}, Params, true);

    return QoESingleStatSubscribersRttWidget(params);
};

var QoESingleStatRttWidget = function (Params)
{
    var params = {
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name : "QoESingleStatRttWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"rtt_median_if", alias:"rtt_median", func:"round(medianIfMerge(rtt_median_if),0)"},
                {col:"rtt_from_subscriber_median_if", alias:"rtt_from_subscriber_median", func:"round(medianIfMerge(rtt_from_subscriber_median_if),0)"},
                {col:"rtt_to_subscriber_median_if", alias:"rtt_to_subscriber_median", func:"round(medianIfMerge(rtt_to_subscriber_median_if),0)"},

                {col:"retransmits_avg_rate", alias:"retransmits_avg_rate", func:QoEReportFunctions.AvgRetransmitsRate},
                {col:"retransmits_from_subscriber_avg_rate", alias:"retransmits_from_subscriber_avg_rate", func:QoEReportFunctions.AvgRetransmitsRateFromSubs},
                {col:"retransmits_to_subscriber_avg_rate", alias:"retransmits_to_subscriber_avg_rate", func:QoEReportFunctions.AvgRetransmitsRateToSubs}
            ],
            sort:{id:"rtt_median",dir:"desc"},
            flags:{
                use_where:0,
                use_size:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        columns:
            [
                {
                    id:"rtt_median",
                    header:LangHelper.GetString("QoE", "RTT"),
                    icon:"stopwatch",
                    template: function (Val)
                    {
                        return Helper.UnitPrefixToNumeric(Val / 1000, 1000, TimeUnits);
                    }
                },
                {
                    id:"rtt_from_subscriber_median",
                    header:LangHelper.GetString("QoE", "RTT from subscriber"),
                    icon:"stopwatch",
                    template: function (Val)
                    {
                        return Helper.UnitPrefixToNumeric(Val / 1000, 1000, TimeUnits);
                    }
                },
                {
                    id:"rtt_to_subscriber_median",
                    header:LangHelper.GetString("QoE", "RTT to subscriber"),
                    icon:"stopwatch",
                    template: function (Val)
                    {
                        return Helper.UnitPrefixToNumeric(Val / 1000, 1000, TimeUnits);
                    }
                },
                {
                    id:"retransmits_avg_rate",
                    header:LangHelper.GetString("QoE", "Retransmits"),
                    icon:"repeat",
                    template: function (Val)
                    {
                        return (Val ? Val :"0")+" %";
                    }
                },
                {
                    id:"retransmits_from_subscriber_avg_rate",
                    header:LangHelper.GetString("QoE", "Retransmits from subscriber"),
                    icon:"repeat",
                    template: function (Val)
                    {
                        return (Val ? Val :"0")+" %";
                    }
                },
                {
                    id:"retransmits_to_subscriber_avg_rate",
                    header:LangHelper.GetString("QoE", "Retransmits to subscriber"),
                    icon:"repeat",
                    template: function (Val)
                    {
                        return (Val ? Val :"0")+" %";
                    }
                }
            ],
        compact:false,
        xCount:Params&&Params.xCount?Params.xCount:6,
        yCount:Params&&Params.yCount?Params.yCount:1,
        type:
            {
                width: "auto",
                height: "auto"
            }
    };

    params.config.values.forEach(function (Col)
    {
        params.config.cache.values.push({col:(Col.alias ? Col.alias : Col.col)});
    });

    return new QoESingleStatWidget(params);
};

var QoESingleStatRttVertWidget = function (Params)
{
    var params = webix.extend({xCount:1, yCount:6, name:"QoESingleStatRttVertWidget"}, Params, true);

    return QoESingleStatRttWidget(params);
};

var QoESingleStatClickstreamTotalsWidget = function (Params)
{
    var params = {
        //title:LangHelper.GetString("QoE", "Totals"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoESingleStatClickstreamTotalsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"},
                {col:"session_id_uniq", alias:"sessons_uniq", func:"uniqMerge"},
                {col:"host", alias:"hosts_uniq", func:"uniq"},
                {col:"user_agent", alias:"user_agent_uniq", func:"uniq"},
                {col:"device_other", alias:"device_other_uniq", func:"uniq"},
                {col:"host_ip", alias:"host_ip_uniq", func:"uniq"}
            ],
            sort:{id:"total",dir:"desc"},
            flags:{
                use_where:0,
                use_size:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        columns:[
            {
                id:"total",
                header:LangHelper.GetString("QoE", "Connections"),
                icon:"plug",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                }
            },
            {
                id:"sessons_uniq",
                header:LangHelper.GetString("QoE", "Sessions"),
                icon:"arrows-h",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                }
            },
            {
                id:"hosts_uniq",
                header:LangHelper.GetString("QoE", "Hosts"),
                icon:"server",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                }
            },
            {
                id:"device_other_uniq",
                header:LangHelper.GetString("QoE", "Devices"),
                icon:"desktop",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                }
            },
            {
                id:"user_agent_uniq",
                header:LangHelper.GetString("QoE", "User agents"),
                icon:"tablet-rugged",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                }
            },
            {
                id:"host_ip_uniq",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), ""],
                footer:{content:"totalColumn"},
                sort:"string",
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
                }
            }
        ],
        compact:false,
        xCount:5,
        yCount:1,
        type:
            {
                width: "auto",
                height: "auto"
            }
    };

    params.config.values.forEach(function (Col)
    {
        params.config.cache.values.push({col:(Col.alias ? Col.alias : Col.col)});
    });


    return new QoESingleStatWidget(params);
};

var QoERttDistributionWidget = function (Params, Online)
{
    var params = {
        title:LangHelper.GetString("QoE", "RTT distribution"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name: "QoE" + (Online ? "Online" : "") + "RttDistributionWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                alias:"v1",
                view:Online ? QoEReportViews.OnlineRttDistribution() : QoEReportViews.RttDistribution(),
                yAxisUnits: {
                    units: null,
                    divider: 10
                },
                values: [
                    // {col:"rtt", alias:"rtt"},

                    // {col:"rtt_count", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "RTT distribution"))},
                    // {col:"rtt_from_subscriber_count", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "RTT distribution from subscriber"))},
                    // {col:"rtt_to_subscriber_count", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "RTT distribution to subscriber"))}

                    {col:"rtt_count", func:"sum", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "RTT distribution"))},
                    {col:"rtt_from_subscriber_count", func:"sum", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "RTT distribution from subscriber"))},
                    {col:"rtt_to_subscriber_count", func:"sum", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "RTT distribution to subscriber"))}
                ],
                rows:[{col:"rtt", alias:"rtt"}],
                flags:
                {
                    use_where:0,
                    use_having:0,
                    use_size:0
                },
                sort:{id:"rtt",dir:"asc"},
                limit:1000,
                size:1000,
                join:[
                    {
                        type:"full",
                        values:[
                            {col:"rttv2", alias:"rttv2"},
                            {col:"rtt_from_subscriber_count", alias:"rtt_from_subscriber_count"}
                        ],
                        view:Online ? QoEReportViews.OnlineRttDistribution({type:"_from_subscriber", rtt_alias: "rttv2"}) : QoEReportViews.RttDistribution({type:"_from_subscriber", rtt_alias: "rttv2"}),
                        alias:"v2",
                        on:["v2.rttv2 = v1.rtt"],
                        stringency:" "
                    },
                    {
                        type:"full",
                        values:[
                            {col:"rttv3", alias:"rttv3"},
                            {col:"rtt_to_subscriber_count", alias:"rtt_to_subscriber_count"}
                        ],
                        view:Online ? QoEReportViews.OnlineRttDistribution({type:"_to_subscriber", rtt_alias: "rttv3"}) : QoEReportViews.RttDistribution({type:"_to_subscriber", rtt_alias: "rttv3"}),
                        alias:"v3",
                        on:["v3.rttv3 = v1.rtt"],
                        stringency:" "
                    }
                ],
                // _join:{
                //     view:{
                //         view:QoEReportViews.RttDistribution({type:"_from_subscriber"}),
                //         values:[
                //             {col:"rtt", alias:"rtt"},
                //             {col:"rtt_from_subscriber_count", alias:"rtt_from_subscriber_count"},
                //             {col:"rtt_to_subscriber_count", alias:"rtt_to_subscriber_count"}
                //         ],
                //         flags:
                //             {
                //                 use_where:0,
                //                 use_having:0,
                //                 use_size:0
                //             },
                //         sort:{id:"rtt",dir:"asc"},
                //         limit:100,
                //         join:{
                //             view:QoEReportViews.RttDistribution({type:"_to_subscriber"}),
                //             using:["rtt"]
                //         }
                //     },
                //     using:["rtt"]
                // },
                online: Online,
                cache:{
                    enabled:1,
                    values: [],
                    flags:{
                        use_where:0,
                        use_having:0
                    }
                }
            },
        chart_range: {
            frameId:"rtt",
            height: 80
        },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Helper.UnitPrefixToNumeric(Val / 1000, 1000, TimeUnits);
                }
            }
        ,
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.ConvertToKMG(Val);
                }
            },
        legend:
            {
                height:40,
                align: "left",
                valign: "bottom",
                layout:"x",
                toggle: true,
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "RTT distribution"),
                chart_area_width: 750,
                chart_area_height: 400,
                graph_area_x: 50,
                graph_area_y: 15,
                graph_area_width: 715,
                graph_area_height: 350,
                abscise_key: "rtt",
                abscise_units: SimpleTimeUnits,
                abscise_divider: 1000
            }
    };

    params.config.rows.forEach(function (Row)
    {
        var alias = Row.alias ? Row.alias : Row.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoESeriesChartReportWidget(params);
};

var QoERttByTimeWidget = function (Params, Online)
{
    var params = {
        title:LangHelper.GetString("QoE", "RTT by time"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoE" + (Online ? "Online" : "") + "RttByTimeWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values: [
                    {col:"rtt_median_if", alias:LangHelper.GetString("QoE", "RTT"), func:"round(medianIfMerge(rtt_median_if),0)"},
                    {col:"rtt_from_subscriber_median_if", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "RTT from subscriber")), func:"round(medianIfMerge(rtt_from_subscriber_median_if),0)"},
                    {col:"rtt_to_subscriber_median_if", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "RTT to subscriber")), func:"round(medianIfMerge(rtt_to_subscriber_median_if),0)"}
                    //,
                    //{col:"rtt_median_if", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "RTT median")), func:"round(medianIfMerge(rtt_median_if),0)"}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: [],
                    flags:{
                        use_where:0,
                        use_having:0
                    }
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val / 1000, 1000, TimeUnits);
                }
            },
        legend:
            {
                height:40,
                align: "left",
                valign: "bottom",
                layout:"x",
                toggle: true,
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "RTT by time"),
                abscise_key: "time_step",
                units: SimpleTimeUnits,
                divider: 1000
            }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoESeriesChartReportWidget(params);
};

var QoESeriesChartRetransmitsByTimeWidget = function (Params, Online)
{
    var params = {
        title:LangHelper.GetString("QoE", "Retransmits by time"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name: "QoE" + (Online ? "Online" : "") + "SeriesChartRetransmitsByTimeWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values: [
                    {col:"retransmits_rate_avg_if", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Retransmits")), func:QoEReportFunctions.AvgRetransmitsRate},
                    {col:"retransmits_rate_from_subscriber_avg_if", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Retransmits from subscriber")), func:QoEReportFunctions.AvgRetransmitsRateFromSubs},
                    {col:"retransmits_rate_to_subscriber_avg_if", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Retransmits to subscriber")), func:QoEReportFunctions.AvgRetransmitsRateToSubs}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: [],
                    flags:{
                        use_where:0,
                        use_having:0
                    }
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Val + " %";
                }
            },
        legend:
            {
                height:40,
                align: "left",
                valign: "bottom",
                layout:"x",
                toggle: true,
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Retransmits by time"),
                abscise_key: "time_step",
                units: ["%"],
            }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoESeriesChartReportWidget(params);
};

var QoESeriesChartTrafficWidget = function (Params, Online)
{
    var params = {
        title:LangHelper.GetString("QoE", "Traffic"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name: "QoE" + (Online ? "Online" : "") + "SeriesChartTrafficWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Traffic")), func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond_ForChartSerie},
                    {col:"", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Traffic from subscribers")), func:QoEReportFunctions.AvgTrafficSpeedFromSubsBitsPerSecond_ForChartSerie},
                    {col:"", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Traffic to subscribers")), func:QoEReportFunctions.AvgTrafficSpeedToSubsBitsPerSecond_ForChartSerie}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online: Online,
                cache:{
                    enabled:1,
                    values: [],
                    flags:{
                        use_where:0,
                        use_having:0
                    }
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
                }
            },
        legend:
            {
                height:40,
                align: "left",
                valign: "bottom",
                layout:"x",
                toggle: true,
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Traffic"),
                abscise_key: "time_step",
                units: TrafficSpeedBitUnits,
                divider: 1000,
            }

    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoESeriesChartReportWidget(params);
};

var QoESeriesChartTrafficByProtocolsWidget = function (Params, Online)
{
    return new QoESeriesChartReportWidget({
        title:LangHelper.GetString("QoE", "Traffic by protocols"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartTrafficByProtocolsWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"traffic_speed_bps", alias:"speed", func:"avg"}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                cols:[
                    //{col:"protocol", alias:"protocol_{col_value}", func:"", values:["dns 53", "https 443"], condition:"=="}
                    {
                        col:"net_protocol",
                        alias:"{col_value}",
                        func:"",
                        //values:[],
                        values:{
                            func:"GetTopList",
                            params:{
                                table:QoEReportTablesEnum.FullnetflowAgg,
                                view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
                                row:"net_protocol",
                                func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond,
                                limit:100
                            }
                        },
                        condition:"==",
                        sql_tpl:Helper.ReplaceAll("{condition}", "net_protocol == {col_value}", QoEReportFunctions.AvgTrafficSpeedBitsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
                    }
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:"net_protocol",
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    }
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
                }
            },
        legend:
            {
                height:40,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Traffic by protocols"),
                abscise_key: "time_step",
                units: TrafficSpeedBitUnits,
                divider: 1000,
                locales: {
                    "legend_title": "protocol"
                }
            }
    });
};

var QoESeriesChartTrafficByAppProtocolsWidget = function (Params, Online)
{
    var filter = {};
    var title = LangHelper.GetString("QoE", "Traffic by application protocols");
    var name = "QoE" + (Online ? "Online" : "") + "SeriesChartTrafficByAppProtocolsWidget";
    var values = [
        {col:"traffic_speed_bps", alias:"speed", func:"avg"}
    ];
    var cols = [
        //{col:"protocol", alias:"protocol_{col_value}", func:"", values:["dns 53", "https 443"], condition:"=="}
        //{col:"protocol", alias:"{col_value}", func:"", values:{func:"GetTopList", params:{table:QoEReportTablesEnum.FullnetflowSubscriberMerged, row:"protocol", val:"traffic_speed_bps", limit:50}}, condition:"=="},
        {
            col:"protocol",
            alias:"{col_value}",
            func:"",
            //values:[],
            //values:["http 80", "https 443"],
            values:{
                func: "GetTopList",
                params: {
                    table: QoEReportTablesEnum.FullnetflowAgg,
                    view: Params && Params.view ? Params.view : QoEReportViews.FullFlow,
                    row: "protocol",
                    func: QoEReportFunctions.AvgTrafficSpeedBitsPerSecond,
                    limit: 50
                }
            },
            condition:"==",
            sql_tpl:Helper.ReplaceAll("{condition}", "protocol == {col_value}", QoEReportFunctions.AvgTrafficSpeedBitsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
        }
    ];
    var yAxis = {
        template: function (Val) {
            return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
        }
    };
    var exportPdfConfig = {
        view_type: "chart",
        title: title,
        abscise_key: "time_step",
        units: TrafficSpeedBitUnits,
        divider: 1000,
        locales: {
            "legend_title": "protocol"
        }
    };

    let keys = ["by_voip", "apps_by_subscribers"];
    if (Params && keys.some(k => k in Params))
    {
        filter = Params && Params.filter ? Params.filter : filter;
        title = Params && Params.title ? Params.title : title;
        name = Params && Params.name ? Params.name : name;
        values = Params && Params.values ? Params.values : values;
        cols = Params && Params.cols ? Params.cols : cols;
        yAxis = Params && Params.y_axis ? Params.y_axis : yAxis;
        exportPdfConfig = Params && Params.export_pdf_config ? Params.export_pdf_config : exportPdfConfig;
    }

    return new QoESeriesChartReportWidget({
        title:title,
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:values,
                rows:
                    [
                        {col:"time", alias:"time_step", func:"toStartOfAuto"}
                    ],
                cols:cols,
                sort:{id:"time_step",dir:"asc"},
                flags:{
                    use_size:0,
                    use_where:0
                },
                limit:1000,
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:"protocol",
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    },
                    limit:1000
                }
            },
        filter:filter,
        type:"splineArea",
        xAxis:{
            template:function(Val)
            {
                return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
            }
        },
        yAxis:yAxis,
        legend:
            {
                height:160,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:exportPdfConfig
    });
};

var QoESeriesChartTrafficByAppProtocolsGroupsWidget = function (Params, Online)
{
    var filter = {};
    var title = LangHelper.GetString("QoE", "Traffic by application protocols groups");
    var name = "QoE" + (Online ? "Online" : "") + "SeriesChartTrafficByAppProtocolsGroupsWidget";
    var values = [
        {col:"traffic_speed_bps", alias:"speed", func:"avg"}
    ];
    var cols = [
        //{col:"protocol", alias:"protocol_{col_value}", func:"", values:["dns 53", "https 443"], condition:"=="}
        //{col:"protocol", alias:"{col_value}", func:"", values:{func:"GetTopList", params:{table:QoEReportTablesEnum.FullnetflowSubscriberMerged, row:"protocol", val:"traffic_speed_bps", limit:50}}, condition:"=="},
        {
            col:"app_protocol_group_id",
            alias:"{col_value}",
            func:"",
            values:{
                func:"GetTopList",
                params:{
                    table:QoEReportTablesEnum.FullnetflowAgg,
                    view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
                    row:"app_protocol_group_id",
                    func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond,
                    limit:50
                }
            },
            condition:"==",
            sql_tpl:Helper.ReplaceAll("{condition}", "app_protocol_group_id == {col_value}", QoEReportFunctions.AvgTrafficSpeedBitsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
        }
    ];
    var yAxis = {
        template: function (Val) {
            return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
        }
    };
    var exportPdfConfig = {
        view_type: "chart",
        title: LangHelper.GetString("QoE", "Traffic by application protocols groups"),
        values_dics: {
            "app_protocol_group_id": "ProtocolsGroupsDic"
        },
        abscise_key: "time_step",
        units: TrafficSpeedBitUnits,
        divider: 1000,
        locales: {
            "legend_title": "group"
        }
    };

    let keys = ["apps_by_subscribers"];
    if (Params && keys.some(k => k in Params))
    {
        filter = Params && Params.filter ? Params.filter : filter;
        title = Params && Params.title ? Params.title : title;
        name = Params && Params.name ? Params.name : name;
        values =  Params && Params.values ? Params.values : values;
        cols = Params && Params.cols ? Params.cols : cols;
        yAxis = Params && Params.y_axis ? Params.y_axis : yAxis;
        exportPdfConfig = Params && Params.export_pdf_config ? Params.export_pdf_config : exportPdfConfig;
    }

    return new QoESeriesChartReportWidget({
        title:title,
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:values,
                rows:
                    [
                        {col:"time", alias:"time_step", func:"toStartOfAuto"}
                    ],
                cols:cols,
                sort:{id:"time_step",dir:"asc"},
                flags:{
                    use_size:0,
                    use_where:0
                },
                limit:1000,
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:"app_protocol_group_id",
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    },
                    limit:1000
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:yAxis,
        legend:
            {
                height:160,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:exportPdfConfig
    });
};

var QoESeriesChartTrafficByASWidget = function (Params, Online)
{
    var type = Params&&Params.type ? Params.type : "destination";

    var params = {
        title:LangHelper.GetString("QoE", "Traffic by " + (type == "source" ? "subscriber`s " : "") + "AS"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartTrafficByASWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"traffic_speed_bps", alias:"speed", func:"avg"}
                ],
                rows:
                    [
                        {col:"time", alias:"time_step", func:"toStartOfAuto"}
                    ],
                cols:[
                    {
                        col:type + "_asnum",
                        alias:"{col_value}",
                        func:"",
                        values:{func:"GetTopList", params:{table:QoEReportTablesEnum.FullnetflowAgg, view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow, row:type + "_asnum", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond, limit:50}},
                        condition:"==",
                        sql_tpl:Helper.ReplaceAll("{condition}", type + "_asnum == {col_value}", QoEReportFunctions.AvgTrafficSpeedBitsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
                    }
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:type + "_asnum",
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    }
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
                }
            },
        legend:
            {
                height:160,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Traffic by " + (type == "source" ? "subscriber`s " : "") + "AS"),
                abscise_key: "time_step",
                units: TrafficSpeedBitUnits,
                divider: 1000,
                locales: {
                    "legend_title": "as_number"
                }
            }
    };

    return new QoESeriesChartReportWidget(params);
};

var QoESeriesChartFlowWidget = function (Params, Online)
{
    var params = {
        title:LangHelper.GetString("QoE", "Flow"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Flow")), func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond_ForChartSerie},
                    {col:"", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Flow from subscriber")), func:QoEReportFunctions.AvgTrafficSpeedFromSubsPktsPerSecond_ForChartSerie},
                    {col:"", alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Flow to subscriber")), func:QoEReportFunctions.AvgTrafficSpeedToSubsPktsPerSecond_ForChartSerie}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: [],
                    flags:{
                        use_where:0,
                        use_having:0
                    }
                },
                yAxisUnits: {
                    units: NetFlowSpeedUnits,
                    divider: 1000
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, NetFlowSpeedUnits);
                }
            },
        legend:
            {
                height:40,
                align: "left",
                valign: "bottom",
                layout:"x",
                toggle: true,
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Flow"),
                abscise_key: "time_step",
                units: NetFlowSpeedUnits,
                divider: 1000
            }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoESeriesChartReportWidget(params);
};

var QoESeriesChartFlowByProtocolsWidget = function (Params, Online)
{
    var params = {
        title:LangHelper.GetString("QoE", "Flow by protocols"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByProtocolsWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"flow_speed_pkts", alias:"speed", func:"avg"}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                cols:[
                    {
                        col:"net_protocol",
                        alias:"{col_value}",
                        func:"",
                        values:{func:"GetTopList", params:{table:QoEReportTablesEnum.FullnetflowAgg, view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow, row:"net_protocol", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond, limit:100}},
                        condition:"==",
                        sql_tpl:Helper.ReplaceAll("{condition}", "net_protocol == {col_value}", QoEReportFunctions.AvgTrafficSpeedPktsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
                    }
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:"net_protocol",
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    }
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, NetFlowSpeedUnits);
                }
            },
        legend:
            {
                height:40,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Flow by protocols"),
                abscise_key: "time_step",
                units: NetFlowSpeedUnits,
                divider: 1000,
                locales: {
                    "legend_title": "protocol"
                }
            }
    };

    return new QoESeriesChartReportWidget(params);
};

var QoESeriesChartFlowByAppProtocolsWidget = function (Params, Online)
{
    var params = {
        title:LangHelper.GetString("QoE", "Flow by application protocols"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByAppProtocolsWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"flow_speed_pkts", alias:"speed", func:"avg"}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                cols:[
                    {
                        col:"protocol",
                        alias:"{col_value}",
                        func:"",
                        values:{func:"GetTopList", params:{table:QoEReportTablesEnum.FullnetflowAgg, view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow, row:"protocol", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond, limit:100}},
                        condition:"==",
                        sql_tpl:Helper.ReplaceAll("{condition}", "protocol == {col_value}", QoEReportFunctions.AvgTrafficSpeedPktsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
                    }
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:"protocol",
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    }
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, NetFlowSpeedUnits);
                }
            },
        legend:
            {
                height:160,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Flow by application protocols"),
                abscise_key: "time_step",
                units: NetFlowSpeedUnits,
                divider: 1000,
                locales: {
                    "legend_title": "protocol"
                }
            }
    };

    return new QoESeriesChartReportWidget(params);
};

var QoESeriesChartFlowByAppProtocolsGroupsWidget = function (Params, Online)
{
    var params = {
        title:LangHelper.GetString("QoE", "Flow by application protocols groups"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByAppProtocolsGroupsWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"flow_speed_pkts", alias:"speed", func:"avg"}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                cols:[
                    {
                        col:"app_protocol_group_id",
                        alias:"{col_value}",
                        func:"",
                        values:{
                            func:"GetTopList",
                            params:{
                                table:QoEReportTablesEnum.FullnetflowAgg,
                                view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
                                row:"app_protocol_group_id",
                                func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond,
                                limit:50
                            }
                        },
                        condition:"==",
                        sql_tpl:Helper.ReplaceAll("{condition}", "app_protocol_group_id == {col_value}", QoEReportFunctions.AvgTrafficSpeedBitsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
                    }
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:"app_protocol_group_id",
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    }
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, NetFlowSpeedUnits);
                }
            },
        legend:
            {
                height:160,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Flow by application protocols groups"),
                values_dics: {
                    "app_protocol_group_id": "ProtocolsGroupsDic"
                },
                abscise_key: "time_step",
                units: NetFlowSpeedUnits,
                divider: 1000,
                locales: {
                    "legend_title": "group"
                }
            }
    };

    return new QoESeriesChartReportWidget(params);
};

var  QoETableNetflowTopCommonConfig = function (Params)
{
    var config =
    {
        values:
            [
                {col:"rtt_median_if", alias:"rtt_median", func:"round(medianIfMerge(rtt_median_if),0)"},
                {col:"rtt_from_subscriber_median_if", alias:"rtt_from_subscriber_median", func:"round(medianIfMerge(rtt_from_subscriber_median_if),0)"},
                {col:"rtt_to_subscriber_median_if", alias:"rtt_to_subscriber_median", func:"round(medianIfMerge(rtt_to_subscriber_median_if),0)"},
                {col:"retransmits_rate_avg_if", alias:"retransmits_avg", func:QoEReportFunctions.AvgRetransmitsRate},
                {col:"retransmits_rate_from_subscriber_avg_if", alias:"retransmits_from_subscriber_avg", func:QoEReportFunctions.AvgRetransmitsRateFromSubs},
                {col:"retransmits_rate_to_subscriber_avg_if", alias:"retransmits_to_subscriber_avg", func:QoEReportFunctions.AvgRetransmitsRateToSubs},
                {col:"fragments_avg_if", alias:"fragments_avg", func:"round(avgIfMerge(fragments_avg_if),0)"},

                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond},
                {col:"", alias:"traffic_from_subscriber", func:QoEReportFunctions.AvgTrafficSpeedFromSubsBitsPerSecond},
                {col:"", alias:"traffic_to_subscriber", func:QoEReportFunctions.AvgTrafficSpeedToSubsBitsPerSecond},

                {col:"", alias:"traffic_vol", func:QoEReportFunctions.TrafficVoumeBytes},
                {col:"", alias:"traffic_vol_from_subscriber", func:QoEReportFunctions.TrafficVoumeFromSubsBytes},
                {col:"", alias:"traffic_vol_to_subscriber", func:QoEReportFunctions.TrafficVoumeToSubsBytes},

                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond},
                {col:"", alias:"flow_from_subscriber", func:QoEReportFunctions.AvgTrafficSpeedFromSubsPktsPerSecond},
                {col:"", alias:"flow_to_subscriber", func:QoEReportFunctions.AvgTrafficSpeedToSubsPktsPerSecond},

                {col:"subscriber", alias:"subscribers_uniq", func:"uniq"},
                {col:"login", alias:"logins_uniq", func:"uniq"},

                {col:"total_count", alias:"total", func:"countMerge"},
                {col:"session_id_uniq", alias:"sessons_uniq", func:"uniqMerge"},
                {col:"host", alias:"hosts_uniq", func:"uniq"},
                {col:"host_category", alias:"host_category_uniq", func:"uniq"},
                {col:"host_ip", alias:"host_ip_uniq", func:"uniq"},
                {col:"net_protocol_code", alias:"net_protocol_uniq", func:"uniq"},
                {col:"protocol_code", alias:"protocol_uniq", func:"uniq"},
                {col:"app_protocol_group_id", alias:"app_protocol_group_uniq", func:"uniq"},

                {col:"bridge_vchannel", alias:"bridge_vchannel_uniq", func:"uniq"},
            ],

        values_cache:
            [
                {col:"rtt_median_if", alias:"rtt_median", func:"medianIfMergeState", func_cache:"round(medianIfMerge(rtt_median),0)"},
                {col:"rtt_from_subscriber_median_if", alias:"rtt_from_subscriber_median", func:"medianIfMergeState", func_cache:"round(medianIfMerge(rtt_from_subscriber_median_if),0)"},
                {col:"rtt_to_subscriber_median_if", alias:"rtt_to_subscriber_median", func:"medianIfMergeState", func_cache:"round(medianIfMerge(rtt_to_subscriber_median_if),0)"},
                {col:"retransmits_rate_avg_if", alias:"retransmits_avg", func:"avgIfMergeState", func_cache:"round(avgIfMerge(retransmits_avg)*100,2)"},
                {col:"fragments_avg_if", alias:"fragments_avg", func:"avgIfMergeState", func_cache:"round(avgIfMerge(fragments_avg),0)"},

                {col:"subscriber", alias:"subscribers_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"login", alias:"logins_uniq", func:"uniq"},

                {col:"total_count", alias:"total", func:"countMergeState", func_cache:"countMerge"},
                {col:"session_id_uniq", alias:"sessons_uniq", func:"uniqMergeState", func_cache:"uniqMerge"},
                {col:"host", alias:"hosts_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"host_ip", alias:"host_ip_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"net_protocol_code", alias:"net_protocol_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"protocol_code", alias:"protocol_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"app_protocol_group_id", alias:"app_protocol_group_uniq", func:"uniqState", func_cache:"uniqMerge"},

                {col:"bridge_vchannel", alias:"bridge_vchannel_uniq", func:"uniqState", func_cache:"uniqMerge"}
            ],

        columns:
            [
                {
                    id:"rtt_median",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT")+", "+LangHelper.GetString("QoE", "ms")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.SimpleTimeUnits
                },
                {
                    id:"rtt_from_subscriber_median",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT from subscriber")+", "+LangHelper.GetString("QoE", "ms")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.SimpleTimeUnits
                },
                {
                    id:"rtt_to_subscriber_median",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT to subscriber")+", "+LangHelper.GetString("QoE", "ms")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.SimpleTimeUnits
                },
                {
                    id:"retransmits_avg",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits")+", %"), ""],
                    format:webix.i18n.numberFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"retransmits_from_subscriber_avg",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits from subscriber")+", %"), ""],
                    format:webix.i18n.numberFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"retransmits_to_subscriber_avg",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits to subscriber")+", %"), ""],
                    format:webix.i18n.numberFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"fragments_avg",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Fragments")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },

                {
                    id:"traffic",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic from subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic to subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },

                {
                    id:"traffic_vol",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits
                },
                {
                    id:"traffic_vol_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume from subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits
                },
                {
                    id:"traffic_vol_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume to subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits
                },
                {
                    id:"flow",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow from subscriber")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow to subscriber")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.NetFlowSpeedUnits
                },

                {
                    id:"subscribers_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"logins_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Logins")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },

                {
                    id:"total",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Total")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"sessons_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Sessions")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"hosts_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"host_ip_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"host_category_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Host categories")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"net_protocol_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Protocols")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"protocol_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Application protocols")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"app_protocol_group_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("DpiDscpConfig", "Groups")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },

                {
                    id:"bridge_vchannel_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannels")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                }
            ]
    };

    if(Params)
    {
        if(Params.by_subscribers)
        {
            config.values = [
                {col:"subscriber", alias:"subscribers_uniq", func:"uniq"},
                {col:"", alias:"subscribers_percent", func:"round(multiply(divide(subscribers_uniq, sum(subscribers_uniq) over()), 100), 2)"},
                {col:"login", alias:"logins_uniq", func:"uniq"},
                {col:"", alias:"logins_percent", func:"round(multiply(divide(logins_uniq, sum(logins_uniq) over()), 100), 2)"},
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond},
                {col:"", alias:"traffic_vol", func:QoEReportFunctions.TrafficVoumeBytes},
            ];

            config.columns = [
                {
                    id:"subscribers_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"subscribers_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.subscribers_percent);
                    }
                },
                {
                    id:"logins_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Logins")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"logins_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Logins")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.logins_percent);
                    }
                },
                {
                    id:"traffic",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_vol",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits
                }
            ];

            config.sparkline_columns = [
                "subscribers_percent",
                "logins_percent"
            ];
        }

        if(Params.rtt_percent)
        {
            config.values = [
                {col:"rtt_median_if", alias:"rtt_median", func:"round(medianIfMerge(rtt_median_if),0)"},
                {col:"rtt_from_subscriber_median_if", alias:"rtt_from_subscriber_median", func:"round(medianIfMerge(rtt_from_subscriber_median_if),0)"},
                {col:"rtt_to_subscriber_median_if", alias:"rtt_to_subscriber_median", func:"round(medianIfMerge(rtt_to_subscriber_median_if),0)"},
                {col:"", alias:"rtt_median_percent", func:"round(multiply(divide(rtt_median, sumIf(rtt_median, isFinite(rtt_median)) over()), 100), 2)"},
                {col:"", alias:"rtt_from_subscriber_median_percent", func:"round(multiply(divide(rtt_from_subscriber_median, sumIf(rtt_from_subscriber_median, isFinite(rtt_from_subscriber_median)) over()), 100), 2)"},
                {col:"", alias:"rtt_to_subscriber_median_percent", func:"round(multiply(divide(rtt_to_subscriber_median, sumIf(rtt_to_subscriber_median, isFinite(rtt_to_subscriber_median)) over()), 100), 2)"}
            ];

            config.columns = [
                {
                    id:"rtt_median",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT")+", "+LangHelper.GetString("QoE", "ms")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.SimpleTimeUnits
                },
                {
                    id:"rtt_median_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.rtt_median_percent);
                    }
                },
                {
                    id:"rtt_from_subscriber_median",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT from subscriber")+", "+LangHelper.GetString("QoE", "ms")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.SimpleTimeUnits
                },
                {
                    id:"rtt_from_subscriber_median_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT from subscriber")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.rtt_from_subscriber_median_percent);
                    }
                },
                {
                    id:"rtt_to_subscriber_median",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT to subscriber")+", "+LangHelper.GetString("QoE", "ms")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.SimpleTimeUnits
                },
                {
                    id:"rtt_to_subscriber_median_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT to subscriber")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.rtt_to_subscriber_median_percent);
                    }
                }
            ];
            config.sparkline_columns = [
                "rtt_median_percent",
                "rtt_from_subscriber_median_percent",
                "rtt_to_subscriber_median_percent"
            ];
        }

        if(Params.traffic_speed_percent)
        {
            config.values = [
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond},
                {col:"", alias:"traffic_from_subscriber", func:QoEReportFunctions.AvgTrafficSpeedFromSubsBitsPerSecond},
                {col:"", alias:"traffic_to_subscriber", func:QoEReportFunctions.AvgTrafficSpeedToSubsBitsPerSecond},
                {col:"", alias:"traffic_percent", func:"round(multiply(divide(traffic, sumIf(traffic, isFinite(traffic)) over()), 100), 2)"},
                {col:"", alias:"traffic_from_subscriber_percent", func:"round(multiply(divide(traffic_from_subscriber, sumIf(traffic_from_subscriber, isFinite(traffic_from_subscriber)) over()), 100), 2)"},
                {col:"", alias:"traffic_to_subscriber_percent", func:"round(multiply(divide(traffic_to_subscriber, sumIf(traffic_to_subscriber, isFinite(traffic_to_subscriber)) over()), 100), 2)"}
            ];

            config.columns = [
                {
                    id:"traffic",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.traffic_percent);
                    }
                },
                {
                    id:"traffic_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic from subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_from_subscriber_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic from subscribers")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.traffic_from_subscriber_percent);
                    }
                },
                {
                    id:"traffic_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic to subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_to_subscriber_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic to subscribers")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.traffic_to_subscriber_percent);
                    }
                },
            ];
            config.sparkline_columns = [
                "traffic_percent",
                "traffic_from_subscriber_percent",
                "traffic_to_subscriber_percent"
            ];
        }

        if(Params.traffic_volume_percent)
        {
            config.values = [
                {col:"", alias:"traffic_vol", func:QoEReportFunctions.TrafficVoumeBytes},
                {col:"", alias:"traffic_vol_from_subscriber", func:QoEReportFunctions.TrafficVoumeFromSubsBytes},
                {col:"", alias:"traffic_vol_to_subscriber", func:QoEReportFunctions.TrafficVoumeToSubsBytes},
                {col:"", alias:"traffic_vol_percent", func:"round(multiply(divide(traffic_vol, sumIf(traffic_vol, isFinite(traffic_vol)) over()), 100), 2)"},
                {col:"", alias:"traffic_vol_from_subscriber_percent", func:"round(multiply(divide(traffic_vol_from_subscriber, sumIf(traffic_vol_from_subscriber, isFinite(traffic_vol_from_subscriber)) over()), 100), 2)"},
                {col:"", alias:"traffic_vol_to_subscriber_percent", func:"round(multiply(divide(traffic_vol_to_subscriber, sumIf(traffic_vol_to_subscriber, isFinite(traffic_vol_to_subscriber)) over()), 100), 2)"}
            ];

            config.columns = [
                {
                    id:"traffic_vol",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits

                },
                {
                    id:"traffic_vol_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.traffic_vol_percent);
                    }
                },
                {
                    id:"traffic_vol_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume from subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits
                },
                {
                    id:"traffic_vol_from_subscriber_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume from subscribers")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.traffic_vol_from_subscriber_percent);
                    }
                },
                {
                    id:"traffic_vol_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume to subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits
                },
                {
                    id:"traffic_vol_to_subscriber_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume to subscribers")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.traffic_vol_to_subscriber_percent);
                    }
                }
            ];
            config.sparkline_columns = [
                "traffic_vol_percent",
                "traffic_vol_from_subscriber_percent",
                "traffic_vol_to_subscriber_percent"
            ];
        }

        if(Params.retransmits_percent)
        {
            config.values = [
                {col:"retransmits_rate_avg_if", alias:"retransmits_avg", func:QoEReportFunctions.AvgRetransmitsRate},
                {col:"retransmits_rate_from_subscriber_avg_if", alias:"retransmits_from_subscriber_avg", func:QoEReportFunctions.AvgRetransmitsRateFromSubs},
                {col:"retransmits_rate_to_subscriber_avg_if", alias:"retransmits_to_subscriber_avg", func:QoEReportFunctions.AvgRetransmitsRateToSubs},
                {col:"", alias:"retransmits_rate_percent", func:"round(multiply(divide(retransmits_avg, sumIf(retransmits_avg, isFinite(retransmits_avg)) over()), 100), 2)"},
                {col:"", alias:"retransmits_rate_from_subscriber_percent", func:"round(multiply(divide(retransmits_from_subscriber_avg, sumIf(retransmits_from_subscriber_avg, isFinite(retransmits_from_subscriber_avg)) over()), 100), 2)"},
                {col:"", alias:"retransmits_rate_to_subscriber_percent", func:"round(multiply(divide(retransmits_to_subscriber_avg, sumIf(retransmits_to_subscriber_avg, isFinite(retransmits_to_subscriber_avg)) over()), 100), 2)"}
            ];

            config.columns = [
                {
                    id:"retransmits_avg",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits")+", %"), ""],
                    format:webix.i18n.numberFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"retransmits_rate_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits")+" "+LangHelper.GetString("QoE", "Distribution").toLowerCase()+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.retransmits_rate_percent);
                    }
                },
                {
                    id:"retransmits_from_subscriber_avg",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits from subscriber")+", %"), ""],
                    format:webix.i18n.numberFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"retransmits_rate_from_subscriber_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits")+" "+LangHelper.GetString("QoE", "Distribution").toLowerCase()+" "+LangHelper.GetString("QoE", "From subscriber").toLowerCase()+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.retransmits_rate_from_subscriber_percent);
                    }
                },
                {
                    id:"retransmits_to_subscriber_avg",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits to subscriber")+", %"), ""],
                    format:webix.i18n.numberFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"retransmits_rate_to_subscriber_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits")+" "+LangHelper.GetString("QoE", "Distribution").toLowerCase()+" "+LangHelper.GetString("QoE", "To subscriber").toLowerCase()+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.retransmits_rate_to_subscriber_percent);
                    }
                },
            ];
            config.sparkline_columns = [
                "retransmits_rate_percent",
                "retransmits_rate_from_subscriber_percent",
                "retransmits_rate_to_subscriber_percent"
            ];
        }

        if(Params.flow_percent)
        {
            config.values = [
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond},
                {col:"", alias:"flow_from_subscriber", func:QoEReportFunctions.AvgTrafficSpeedFromSubsPktsPerSecond},
                {col:"", alias:"flow_to_subscriber", func:QoEReportFunctions.AvgTrafficSpeedToSubsPktsPerSecond},
                {col:"", alias:"flow_percent", func:"round(multiply(divide(flow, sumIf(flow, isFinite(flow)) over()), 100), 2)"},
                {col:"", alias:"flow_from_subscriber_percent", func:"round(multiply(divide(flow_from_subscriber, sumIf(flow_from_subscriber, isFinite(flow_from_subscriber)) over()), 100), 2)"},
                {col:"", alias:"flow_to_subscriber_percent", func:"round(multiply(divide(flow_to_subscriber, sumIf(flow_to_subscriber, isFinite(flow_to_subscriber)) over()), 100), 2)"}
            ];

            config.columns = [
                {
                    id:"flow",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.flow_percent);
                    }
                },
                {
                    id:"flow_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow from subscriber")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_from_subscriber_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow from subscribers")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.flow_from_subscriber_percent);
                    }
                },
                {
                    id:"flow_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow to subscriber")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_to_subscriber_percent",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow to subscribers")+", %"), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    width:145,
                    template:function(Value) {
                        return QoETopProtocolsPercentColumnWidget(null, null, false, Value.flow_to_subscriber_percent);
                    }
                },
            ];
            config.sparkline_columns = [
                "flow_percent",
                "flow_from_subscriber_percent",
                "flow_to_subscriber_percent"
            ];
        }

        if(Params.columns_order)
        {
            var columns = [];

            var values = [];

            var findColIndex = function(Id)
            {
                var i = -1;

                config.columns.every(function (V, I)
                {
                    if(V && V.id == Id)
                    {
                        i = I;

                        return false;
                    }
                    return true;
                });

                return i;
            };

            var findValIndex = function(Id)
            {
                var i = -1;

                config.values.every(function (V, I)
                {
                    if(V && V.alias == Id)
                    {
                        i = I;

                        return false;
                    }
                    return true;
                });

                return i;
            };

            Params.columns_order.forEach(function (Id)
            {
                var i = findColIndex(Id);

                if(i >= 0)
                {
                    var items = config.columns.splice(i,1);

                    columns = columns.concat(items);
                }

                var j = findValIndex(Id);

                if(j >= 0)
                {
                    var items = config.values.splice(i,1);

                    values = values.concat(items);
                }
            });

            config.columns = columns.concat(config.columns);
            config.values = values.concat(config.values);
        }

        if(Params.custom_filter)
        {
            if(config.columns && config.columns.length)
                config.columns = config.columns.filter(Item => Params.custom_filter.includes(Item.id));

            if(config.values && config.columns.values)
                config.values = config.values.filter(Item => Params.custom_filter.includes(Item.alias ? Item.alias : Items.col));

            if(config.values_cache && config.values_cache.values)
                config.values_cache = config.values_cache.filter(Item => Params.custom_filter.includes(Item.alias ? Item.alias : Items.col));
        }
    }

    return config;
};

var QoETableNetflowTopCommonConfigGetColumns= function(Params)
{
    const expandColumns = {
        app_protocol_group_id: {
            id: "app_protocol_group_id",
            width: 160,
            header: [
                LangHelper.GetString("DpiDscpConfig", "Group"),
                {
                    content: "multiSelectFilter",
                    options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                    inputConfig: {suggest: {fitMaster: false}}
                }
            ],
            filterMap: {
                id: "app_protocol_group_id",
                operator: "in",
                value: function(Val)
                {
                    if(Val)
                    {
                        var arr = Val.split(",");

                        return arr;
                    }
                    return null;
                }
            },
            template: function(obj){

                var str = "";

                if(obj && obj.app_protocol_group_id != null)
                {
                    var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.app_protocol_group_id});

                    if(group)
                    {
                        str = group.value;
                    }
                }
                return str;
            }
        },
        bridge_vchannel: {
            id:"bridge_vchannel",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Vchannel/Bridge")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string",
            fillspace:2,
            minWidth:160,
            footer:{content:"totalRows"}
        },
        protocol: {
            id: "protocol",
            header: [TooltipTemplate(LangHelper.GetString("QoE", "Protocol")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            fillspace:true,
            minWidth:160,
            sort: "string",
            footer: {content: "totalRows"}
        },
        calls_uniq: {
            id: "calls_uniq",
            header: [TooltipTemplate(LangHelper.GetString("QoE", "Calls")), ""],
            format:webix.i18n.intFormat,
            sort: "string",
            footer: {content:"totalColumn"}
        },
        duration_sum: {
            id: "duration_sum",
            header: [TooltipTemplate(LangHelper.GetString("QoE", "Minutes")), ""],
            format:webix.i18n.intFormat,
            sort: "string",
            footer: {content:"totalColumn"}
        },
        quarter: {
            id:"quarter",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Quarter")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        traffic_vol_grow_rate: {
            id: "traffic_vol_grow_rate",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume growth rate")+", %"), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            width:140,
            template:(Val) => QoECellGrowthRateWidget(Val.traffic_vol_grow_rate)
        },
        traffic_vol_from_grow_rate: {
            id: "traffic_vol_from_grow_rate",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume from subscriber growth rate")+", %"), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            width:140,
            template:(Val) => QoECellGrowthRateWidget(Val.traffic_vol_from_grow_rate)
        },
        traffic_vol_to_grow_rate: {
            id: "traffic_vol_to_grow_rate",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume to subscriber growth rate")+", %"), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            width:140,
            template:(Val) => QoECellGrowthRateWidget(Val.traffic_vol_to_grow_rate)
        },
    };

    let resCols = [];
    let config = QoETableNetflowTopCommonConfig();
    let commonCols = config && Array.isArray(config.columns) ? config.columns : [];

    if(Params && Array.isArray(Params.columns)) {
        Params.columns.forEach(ColId => {
            let col = expandColumns[ColId];

            if(!col)
                col = commonCols.find(Item => Item.id === ColId);

            if(col)
                resCols.push(col);
        });
    }

    return resCols;
};

var QoETopProtocolsPercentColumnWidget = function (
    CurrentValue = null,
    Sum = null,
    PercentageСalculation = true,
    PercentageValue = null,
    Colors = ["red", "green"],
    TotalPercent = 100
)
{
    if(PercentageСalculation)
    {
        var percent = (CurrentValue / Sum * TotalPercent).toFixed(2);
    }
    else
    {
        var percent = PercentageValue ? Math.round(PercentageValue * 100 / TotalPercent * 100) / 100 : "0.00";
    }

    var title = " ("+percent+"%);";

    var html = "<div class='progress_bar_element' title='" + title + "' >";
    html += "<div class='progress_result progress_result_" + (percent >= 90 ? Colors[0] : Colors[1]) + "' style='width:" + (percent + "%") + "'></div>";
    html += "</div> <span style='display:inline-block;'>" + percent + "%" + "</span>";
    return html;
}

var QoECellGrowthRateWidget = function (Value)
{
    let val = Number.isFinite(Number(Value)) ? parseFloat(Value) : 0;

    if(Number.isNaN(val))
        return "";

    let fixedVal = val.toFixed(2);

    let template;

    if(val > 0)
        template = CellArrowTemplate({
            direction: "up",
            value: " " + fixedVal + "%"
        });

    else if(val < 0)
        template = CellArrowTemplate({
            direction: "down",
            value: fixedVal + "%"
        });

    else
        template = CellArrowTemplate({
            transparent: true,
            value: " " + fixedVal + "%"
        });

    return template;
};

var QoEPieChartTopRttSubscribersWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top subscribers with high RTT"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopRttSubscribersWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                "subscriber"
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "rtt":LangHelper.GetString("QoE", "RTT"),
                "subscriber":LangHelper.GetString("QoE", "Subscriber")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top subscribers with high RTT"),
            pie_chart_key: "subscriber",
            locales: {
                "legend_title": "subscriber"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopSubscribersWidget = function (Params, Online)
{
    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top subscribers with high RTT");

    var name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopRttSubscribersWidget";

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top subscribers with high traffic");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopTrafficSubscribersWidget";

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title = LangHelper.GetString("QoE", "Top subscribers with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopRetransmitsSubscribersWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top subscribers with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopFlowSubscribersWidget";

        sort =  "flow";
    }

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:
                [
                    //{col:"login", alias:"login_any",func:"anyState(login)", func_cache:"anyMerge(login_any)"}
                    {col:"login", alias:"login_any",func:"any"}
                ].concat(common.values),
            rows:[
                "subscriber"
            ],
            sort:{id:sort, dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            remember_field:(Online ? {alias:"subscriber", func:"subscriber"} : Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                },
                {
                    id:"login",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    template:function(Obj)
                    {
                        return Obj.login_any;
                    },
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                }
            ].concat(common.columns),
        leftSplit:2,
        sort_map:{"login":"login_any"},
        can_use_sort_map:{
            "ReportsSettings": 1
        }
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,8);
            params.columns = params.columns.slice(0,8);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }
        else if(Params.to_flow)
        {
            params.config.values = params.config.values.slice(0,3);
            params.columns = params.columns.slice(0,3);
        }
        else
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:1
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableTopSubscriberLoginsWidget = function (Params, Online)
{
    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top logins with high RTT");

    var name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopRttSubscriberLoginsWidget";

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top logins with high traffic");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopTrafficSubscriberLoginsWidget";

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title = LangHelper.GetString("QoE", "Top logins with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopRetransmitsSubscriberLoginsWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top logins with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopFlowSubscriberLoginsWidget";

        sort =  "flow";
    }

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:
                [
                    {col:"subscriber", alias:"subscriber_any",func:"any"}
                ].concat(common.values),
            rows:[
                "login"
            ],
            sort:{id:sort, dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            remember_field:(Online ? {alias:"login", func:"login"} : Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"login",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                },
                {
                    id:"subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    template:function(Obj)
                    {
                        return Obj.subscriber_any;
                    },
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                }
            ].concat(common.columns),
        leftSplit:2,
        sort_map:{"subscriber":"subscriber_any"},
        can_use_sort_map:{
            "ReportsSettings": 1
        }
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,8);
            params.columns = params.columns.slice(0,8);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }
        else if(Params.to_flow)
        {
            params.config.values = params.config.values.slice(0,3);
            params.columns = params.columns.slice(0,3);
        }
        else
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:1
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableTopRttSubscribersWidget = function (Params, Online)
{
    return QoETableTopSubscribersWidget(Params, Online);
};

var QoETableTopRttSubscribersShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopRttSubscribersShortWidget", short:true}, Params, true);

    return QoETableTopRttSubscribersWidget(params, Online);
};

var QoEPieChartTopTrafficSubscribersWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top subscribers with high traffic"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopTrafficSubscribersWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                "subscriber"
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "traffic":LangHelper.GetString("QoE", "Traffic"),
                "subscriber":LangHelper.GetString("QoE", "Subscriber")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top subscribers with high traffic"),
            pie_chart_key: "subscriber",
            locales: {
                "legend_title": "subscriber"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopTrafficSubscribersWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableTopSubscribersWidget(params, Online);
};

var QoETableTopTrafficSubscribersShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopTrafficSubscribersShortWidget", short:true}, Params, true);

    return QoETableTopTrafficSubscribersWidget(params, Online);
};

var QoEPieChartNetflowTopProtocolsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top protocols with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopProtocolsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                "protocol"
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "rtt":LangHelper.GetString("QoE", "RTT"),
                "protocol":LangHelper.GetString("QoE", "Protocol")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top protocols with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "protocol",
            locales: {
                "legend_title": "protocol"
            }
        }

    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopProtocolsGroupsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top application protocols groups with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopProtocolsGroupsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                // { col: "app_protocol_group_id", gui_dic: DicsEnum.ProtocolsGroupsDic }
                {col:"app_protocol_group_id", alias:"app_protocol_group_id", gui_dic:DicsEnum.ProtocolsGroupsDic}
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "rtt":LangHelper.GetString("QoE", "RTT"),
                "app_protocol_group_id":LangHelper.GetString("QoE", "Group")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top application protocols groups with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            },
            pie_chart_key: "app_protocol_group_id",
            locales: {
                "legend_title": "group"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopTrafficProtocolsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top protocols with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopTrafficProtocolsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                "protocol"
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "traffic":LangHelper.GetString("QoE", "Traffic"),
                "protocol":LangHelper.GetString("QoE", "Protocol")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top protocols with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "protocol",
            locales: {
                "legend_title": "protocol"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopTrafficProtocolsBySubscribersWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top application protocols with high traffic") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase()+ " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopTrafficProtocolsBySubscribersWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col: "subscriber", alias: "subscribers_uniq", func: "uniq"}
            ],
            rows:[
                "protocol"
            ],
            sort:{id:"subscribers_uniq",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "subscribers_uniq":LangHelper.GetString("QoE", "Subscribers"),
                "protocol":LangHelper.GetString("QoE", "Protocol")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top application protocols with high traffic") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase()+ " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "protocol",
            locales: {
                "legend_title": "protocol"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopTrafficProtocolsGroupsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top application protocols groups with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopTrafficProtocolsGroupsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                {col:"app_protocol_group_id", alias:"app_protocol_group_id", gui_dic:DicsEnum.ProtocolsGroupsDic}
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "traffic":LangHelper.GetString("QoE", "Traffic"),
                "app_protocol_group_id":LangHelper.GetString("QoE", "Group")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top application protocols groups with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            },
            pie_chart_key: "app_protocol_group_id",
            locales: {
                "legend_title": "group"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopTrafficProtocolsGroupsBySubscribersWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top application protocols groups with high traffic") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase()+ " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopTrafficProtocolsGroupsBySubscribersWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col: "subscriber", alias: "subscribers_uniq", func: "uniq"}
            ],
            rows:[
                {col:"app_protocol_group_id", alias:"app_protocol_group_id", gui_dic:DicsEnum.ProtocolsGroupsDic}
            ],
            sort:{id:"subscribers_uniq",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "subscribers_uniq":LangHelper.GetString("QoE", "Subscribers"),
                "app_protocol_group_id":LangHelper.GetString("QoE", "Groups")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top application protocols groups with high traffic") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase()+ " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            },
            pie_chart_key: "app_protocol_group_id",
            locales: {
                "legend_title": "group"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};



var QoETableTopRttSubscriberLoginsWidget = function (Params, Online)
{
    return QoETableTopSubscriberLoginsWidget(Params, Online);
};

var QoETableTopRttSubscriberLoginsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopRttSubscriberLoginsShortWidget", short:true}, Params, true);

    return QoETableTopRttSubscriberLoginsWidget(params, Online);
};

var QoEPieChartTopRttSubscriberLoginsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top logins with high RTT"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopRttSubscriberLoginsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                "login"
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "rtt":LangHelper.GetString("QoE", "RTT"),
                "login":LangHelper.GetString("QoE", "Login")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top logins with high RTT"),
            pie_chart_key: "login",
            locales: {
                "legend_title": "login"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopTrafficSubscriberLoginsWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableTopSubscriberLoginsWidget(params, Online);
};

var QoETableTopTrafficSubscriberLoginsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopTrafficSubscriberLoginsShortWidget", short:true}, Params, true);

    return QoETableTopTrafficSubscriberLoginsWidget(params, Online);
};

var QoEPieChartTopTrafficSubscriberLoginsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top logins with high traffic"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopTrafficSubscriberLoginsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                "login"
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "traffic":LangHelper.GetString("QoE", "Traffic"),
                "login":LangHelper.GetString("QoE", "Login")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top logins with high traffic"),
            pie_chart_key: "login",
            locales: {
                "legend_title": "login"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopFlowSubscriberLoginsWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableTopSubscriberLoginsWidget(params, Online);
};

var QoETableTopFlowSubscriberLoginsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopFlowSubscriberLoginsShortWidget", short:true}, Params, true);

    return QoETableTopFlowSubscriberLoginsWidget(params, Online);
};

var QoEPieChartTopFlowSubscriberLoginsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top logins with high flow"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopFlowSubscriberLoginsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                "login"
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "flow":LangHelper.GetString("QoE", "Flow"),
                "login":LangHelper.GetString("QoE", "Login")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top logins with high flow"),
            pie_chart_key: "login",
            locales: {
                "legend_title": "login"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopRetransmitsSubscriberLoginsWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableTopSubscriberLoginsWidget(params, Online);
};

var QoETableTopRetransmitsSubscriberLoginsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopRetransmitsSubscriberLoginsShortWidget", short:true}, Params, true);

    return QoETableTopRetransmitsSubscriberLoginsWidget(params, Online);
};

var QoEPieChartTopRetransmitsSubscriberLoginsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top logins with high retransmits"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopRetransmitsSubscriberLoginsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                "login"
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top logins with high retransmits"),
            pie_chart_key: "login",
            locales: {
                "legend_title": "login"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopProtocolsWidget = function (Params, Online)
{
    var netProtocol = Params&&Params.net_protocol;

    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols with high RTT");

    var name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTop" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

    var sort =  "rtt_median";

    var sortMap = null;

    var filter = {};

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols with high traffic");

        name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopTraffic" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

        sort =  "traffic";

        if(Params.by_subscribers)
        {
            commonParams = {by_subscribers: true};

            title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols with high traffic") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase();

            name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopTraffic" + (netProtocol ? "Net" : "") + "ProtocolsBySubscribersWidget");
        }

        if(Params.apps_by_subscribers)
        {
            commonParams = {by_subscribers: true};
            title = Params.title ? Params.title : LangHelper.GetString("QoE", "Top applications protocols by subscribers");
            sort = Params.sort ? Params.sort : "logins_uniq";
        }
    }
    else if(Params && Params.percent)
    {
        commonParams = {rtt_percent:true};
        
        name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopPercent" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

        sort = "rtt_median";

        sortMap = {"rtt_median_percent":"rtt_median","rtt_from_subscriber_median_percent":"rtt_from_subscriber_median","rtt_to_subscriber_median_percent":"rtt_to_subscriber_median"};

        if(Params.traffic_speed)
        {
            commonParams = {traffic_speed_percent:true};

            title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols with high traffic");

            name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopPercentTraffic" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

            sort = "traffic";
            
            sortMap = {"traffic_percent":"traffic","traffic_from_subscriber_percent":"traffic_from_subscriber","traffic_to_subscriber_percent":"traffic_to_subscriber"};
        }

        if(Params.traffic_volume)
        {
            commonParams = {traffic_volume_percent:true};

            title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols with high traffic volume");

            name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopPercentTrafficVolume" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

            sort = "traffic_vol";

            sortMap = {"traffic_vol_percent":"traffic_vol","traffic_vol_from_subscriber_percent":"traffic_vol_from_subscriber","traffic_vol_to_subscriber_percent":"traffic_vol_to_subscriber"};
        }

        if(Params.retransmits)
        {
            commonParams = {retransmits_percent:true};

            title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols with high retransmits");

            name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopPercentRetransmits" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

            sort = "retransmits_avg";

            sortMap = {"retransmits_rate_percent":"retransmits_avg", "retransmits_rate_from_subscriber_percent":"retransmits_from_subscriber_avg", "retransmits_rate_to_subscriber_percent":"retransmits_to_subscriber_avg"};
        }

        if(Params.flow)
        {
            commonParams = {flow_percent:true};

            title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols with high flow");

            name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopFlowRetransmits" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

            sort = "flow";

            sortMap = {"flow_percent":"flow", "flow_from_subscriber_percent":"flow_from_subscriber", "flow_to_subscriber_percent":"flow_to_subscriber"};
        }
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols with high retransmits");

        name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmits" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols with high flow");

        name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopFlow" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

        sort =  "flow";
    }

    if(Params && Params.by_voip)
    {
        title = Params && Params.title ? Params.title : title;
        name = Params && Params.name ? Params.name : name;
        filter = Params && Params.filter ? Params.filter : filter;
    }

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view:Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values: !netProtocol ? [
                    {col:"", alias:"app_protocol_group_description", func:"dictGetString('protocols_groups_dic', 'description', app_protocol_group_id)"}
                ].concat(common.values) : common.values,
            rows: function(){
                var result = [netProtocol ? "net_protocol" : "protocol"];

                if(!netProtocol)
                {
                    result.push("app_protocol_group_id")
                }

                return result;
            }(),
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            with_totals:true,
            limit:1000000,
            remember_field:(Online ? (netProtocol ? {alias:"net_protocol", func:"net_protocol"} : {alias:"protocol", func:"app_protocol"}) : Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                limit:1000000,
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        filter:filter,
        footer:true,
        columns: function(){
            var result = [{
                id:netProtocol ? "net_protocol" : "protocol",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Protocol")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                minWidth:160,
                sort:"string",
                footer:{content:"totalRows"}
            }];

            if(!netProtocol)
            {
                result.push({
                    id: "app_protocol_group_id",
                    width: 160,
                    header: [
                        LangHelper.GetString("DpiDscpConfig", "Group"),
                        {
                            content: "multiSelectFilter",
                            options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }
                    ],
                    filterMap: {
                        id: "app_protocol_group_id",
                        operator: "in",
                        value: function(Val)
                        {
                            if(Val)
                            {
                                var arr = Val.split(",");

                                return arr;
                            }
                            return null;
                        }
                    },
                    template: function(obj){

                        var str = "";

                        if(obj && obj.app_protocol_group_id != null)
                        {
                            var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.app_protocol_group_id});

                            if(group)
                            {
                                str = group.value;
                            }
                        }
                        return str;
                    }
                });
            }
            return result;
        }().concat(common.columns),
        leftSplit:1,
        sort_map:sortMap,
        export_pdf_config: {
            sparkline_columns: common.sparkline_columns ? common.sparkline_columns : [],
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            }
        }
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            if(netProtocol)
            {
                params.config.values = params.config.values.slice(0,6);
                params.columns = params.columns.slice(0,7);
            }
            else
            {
                params.config.values = params.config.values.slice(0,7);
                params.columns = params.columns.slice(0,8);
            }

        }
        else if(Params.top_retransmits)
        {
            if(netProtocol)
            {
                params.config.values = params.config.values.slice(0,3);
                params.columns = params.columns.slice(0,4);
            }
            else
            {
                params.config.values = params.config.values.slice(0,4);
                params.columns = params.columns.slice(0,5);
            }
        }
        else if(Params.top_flow)
        {
            var colsCount = netProtocol ? 4 : 5
            params.config.values = params.config.values.slice(0,colsCount);
            params.columns = params.columns.slice(0,colsCount);
        }
        else if(Params.percent)
        {
            params.config.values = params.config.values.slice(0,8);
            params.columns = params.columns.slice(0,8);
        }
        else
        {
            if(netProtocol)
            {
                params.config.values = params.config.values.slice(0,3);
                params.columns = params.columns.slice(0,4);
            }
            else
            {
                params.config.values = params.config.values.slice(0,4);
                params.columns = params.columns.slice(0,5);
            }
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:6
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = ""; //Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetflowTopProtocolsGroupsWidget = function (Params, Online)
{
    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top application protocols groups with high RTT");

    var name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopProtocolsGroupsWidget";

    var sort =  "rtt_median";

    var sortMap = null;

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top application protocols groups with high traffic");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficProtocolsGroupsWidget";

        sort =  "traffic";

        if(Params.by_subscribers)
        {
            commonParams = {by_subscribers: true};

            title = LangHelper.GetString("QoE", "Top application protocols groups with high traffic") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase();

            name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficProtocolsGroupsBySubscribersWidget";
        }

        if(Params.apps_by_subscribers)
        {
            commonParams = {by_subscribers: true};
            title = Params.title ? Params.title : LangHelper.GetString("QoE", "Top applications protocols groups by subscribers");
            sort = Params.sort ? Params.sort : "logins_uniq";
        }
    }
    else if(Params && Params.percent)
    {
        commonParams = {rtt_percent:true};

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopPercentProtocolsGroupsWidget";

        sort = "rtt_median";

        sortMap = {"rtt_median_percent":"rtt_median","rtt_from_subscriber_median_percent":"rtt_from_subscriber_median","rtt_to_subscriber_median_percent":"rtt_to_subscriber_median"};

        if(Params.traffic_speed)
        {
            commonParams = {traffic_speed_percent:true};

            title = LangHelper.GetString("QoE", "Top application protocols groups with high traffic");

            name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopPercentTrafficProtocolsGroupsWidget";

            sort = "traffic";

            sortMap = {"traffic_percent":"traffic","traffic_from_subscriber_percent":"traffic_from_subscriber","traffic_to_subscriber_percent":"traffic_to_subscriber"};
        }

        if(Params.traffic_volume)
        {
            commonParams = {traffic_volume_percent:true};

            title = LangHelper.GetString("QoE", "Top application protocols groups with high traffic volume");

            name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopPercentTrafficVolumeProtocolsGroupsWidget";

            sort = "traffic_vol";

            sortMap = {"traffic_vol_percent":"traffic_vol","traffic_vol_from_subscriber_percent":"traffic_vol_from_subscriber","traffic_vol_to_subscriber_percent":"traffic_vol_to_subscriber"};
        }

        if(Params.retransmits)
        {
            commonParams = {retransmits_percent:true};

            title = LangHelper.GetString("QoE", "Top application protocols groups with high retransmits");

            name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopPercentRetransmitsProtocolsGroupsWidget";

            sort = "retransmits_avg";

            sortMap = {"retransmits_rate_percent":"retransmits_avg", "retransmits_rate_from_subscriber_percent":"retransmits_from_subscriber_avg", "retransmits_rate_to_subscriber_percent":"retransmits_to_subscriber_avg"};
        }

        if(Params.flow)
        {
            commonParams = {flow_percent:true};

            title = LangHelper.GetString("QoE", "Top application protocols groups with high flow");

            name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowProtocolsGroupsWidget";

            sort = "flow";

            sortMap = {"flow_percent":"flow", "flow_from_subscriber_percent":"flow_from_subscriber", "flow_to_subscriber_percent":"flow_to_subscriber"};
        }
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title = LangHelper.GetString("QoE", "Top application protocols groups with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsProtocolsGroupsWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top application protocols groups with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowProtocolsGroupsWidget";

        sort =  "flow";
    }

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:[
                {col:"", alias:"app_protocol_group_description", func:"dictGetString('protocols_groups_dic', 'description', app_protocol_group_id)"}
            ].concat(common.values),
            rows: ["app_protocol_group_id"],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            with_totals:true,
            limit:1000000,
            remember_field:(Online ? {alias:"app_protocol_group_id", func:"app_protocol_group_id"} : Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                limit:1000000,
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns: [
            {
                id: "app_protocol_group_id",
                width: 160,
                header: [
                    LangHelper.GetString("DpiDscpConfig", "Group"),
                    {
                        content: "multiSelectFilter",
                        options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }
                ],
                filterMap: {
                    id: "app_protocol_group_id",
                    operator: "in",
                    value: function(Val)
                    {
                        if(Val)
                        {
                            var arr = Val.split(",");

                            return arr;
                        }
                        return null;
                    }
                },
                template: function(obj){

                    var str = "";

                    if(obj && obj.app_protocol_group_id != null)
                    {
                        var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.app_protocol_group_id});

                        if(group)
                        {
                            str = group.value;
                        }
                    }
                    return str;
                }
            }
        ].concat(common.columns),
        leftSplit:1,
        sort_map:sortMap,
        export_pdf_config: {
            sparkline_columns: common.sparkline_columns ? common.sparkline_columns : [],
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            }
        }

    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,7);
            params.columns = params.columns.slice(0,7);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }
        else if(Params.top_flow)
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }
        else if(Params.percent)
        {
            params.config.values = params.config.values.slice(0,7);
            params.columns = params.columns.slice(0,7);
        }
        else
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:6
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = ""; //Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetflowTopProtocolsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopProtocolsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params, Online);
};

var QoETableNetflowTopProtocolsPercentShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopProtocolsPercentShortWidget", short:true, percent:true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params)
}

var QoETableNetflowTopProtocolsGroupsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopProtocolsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params, Online);
};

var QoETableNetflowTopProtocolsGroupsPercentShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopProtocolsPercentShortWidget", short:true, percent:true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params);
}

var QoETableNetflowTopTrafficProtocolsWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params, Online);
};

var QoETableNetflowTopTrafficProtocolsPercentSpeedWidget = function (Params)
{
    var params = webix.extend({percent:true, traffic_speed:true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params);
}

var QoETableNetflowTopTrafficProtocolsPercentVolumeWidget = function (Params)
{
    var params = webix.extend({percent:true, traffic_volume:true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params);
}

var QoETableNetflowTopTrafficProtocolsBySubscribersWidget = function (Params)
{
    var params = webix.extend({top_traffic:true, by_subscribers: true, short: true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params);
};

var QoETableNetflowTopTrafficProtocolsGroupsWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params, Online);
};

var QoETableNetflowTopTrafficProtocolsGroupsPercentSpeedWidget = function (Params)
{
    var params = webix.extend({percent:true, traffic_speed:true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params);
}

var QoETableNetflowTopTrafficProtocolsGroupsPercentVolumeWidget = function (Params)
{
    var params = webix.extend({percent:true, traffic_volume:true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params);
}

var QoETableNetflowTopTrafficProtocolsGroupsBySubscribersWidget = function (Params)
{
    var params = webix.extend({top_traffic:true, short: true, by_subscribers: true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params);
};

var QoETableNetflowTopTrafficProtocolsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficProtocolsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficProtocolsWidget(params, Online);
};

var QoETableNetflowTopTrafficProtocolsPercentSpeedShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficProtocolsPercentSpeedShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficProtocolsPercentSpeedWidget(params);
}

var QoETableNetflowTopTrafficProtocolsPercentVolumeShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficProtocolsPercentVolumeShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficProtocolsPercentVolumeWidget(params);
}

var QoETableNetflowTopTrafficProtocolsGroupsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficProtocolsGroupsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficProtocolsGroupsWidget(params, Online);
};

var QoETableNetflowTopTrafficProtocolsGroupsPercentSpeedShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficProtocolsGroupsPercentSpeedShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficProtocolsGroupsPercentSpeedWidget(params);
}

var QoETableNetflowTopTrafficProtocolsGroupsPercentVolumeShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficProtocolsGroupsPercentVolumeShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficProtocolsGroupsPercentVolumeWidget(params);
}

var QoETableNetflowTopTrafficProtocolsTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficProtocolsTableChartWidget",
        table:{
            widget: QoETableNetflowTopTrafficProtocolsShortWidget({id:id + "TrafficByAppProtocolsTable", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartTrafficByAppProtocolsWidget({id:id + "TrafficByAppProtocolsChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopTrafficProtocolsGroupsTableChartWidget = function(Params, Online)
{
    var id = Params && Params.id ? Params.id : webix.uid();
    var table = Params && Params.table ? Params.table : null;
    var view = Params && Params.view ? Params.view : null;

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficProtocolsGroupsTableChartWidget",
        table:{
            widget: QoETableNetflowTopTrafficProtocolsGroupsShortWidget({id:id + "TrafficByAppProtocolsGroupsTable", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartTrafficByAppProtocolsGroupsWidget({id:id + "TrafficByAppProtocolsGroupsChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopTrafficNetProtocolsTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name: "QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficNetProtocolsTableChartWidget",
        table:{
            widget: QoETableNetflowTopTrafficProtocolsShortWidget({id:id + "TrafficByNetProtocolsTable", net_protocol:true, table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartTrafficByProtocolsWidget({id:id + "TrafficByNetProtocolsChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopFlowProtocolsWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params, Online);
};

var QoETableNetflowTopFlowProtocolsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowProtocolsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowProtocolsWidget(params, Online);
};

var QoETableNetflowTopFlowProtocolsPercentShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopFlowProtocolsPercentShortWidget", percent:true, flow:true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params)
}

var QoETableNetflowTopFlowProtocolsGroupsWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params, Online);
};

var QoETableNetflowTopFlowProtocolsGroupsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowProtocolsGroupsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowProtocolsGroupsWidget(params, Online);
};

var QoETableNetflowTopFlowProtocolsGroupsPercentShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopFlowPercentShortWidget", percent:true, flow:true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params)
}

var QoESeriesChartFlowByNetProtocolsTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByNetProtocolsTableChartWidget",
        table:{
            widget: QoETableNetflowTopFlowProtocolsShortWidget({id:id + "FlowByNetProtocolsTable", net_protocol:true, table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartFlowByProtocolsWidget({id:id + "FlowByNetProtocolsChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopAppProtocolsBySubscribersTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsBySubscribersTableChartWidget",
        table:{
            widget: QoETableNetflowTopAppProtocolsBySubscribersWidget({id:id + "TopAppProtocolsBySubscribers", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartNetflowTopAppProtocolsBySubscribersWidget({id:id + "TopAppProtocolsBySubscribersChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopAppProtocolsByGrowthRateTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsByGrowthRateTableChartWidget",
        table:{
            widget: QoETableNetflowTopAppProtocolsByGrowthRateWidget({
                id:id + "TopAppProtocolsByGrowthRate",
                title:LangHelper.GetString("QoE", "Top applications protocols by growth rate"),
                name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsByGrowthRateWidget",
            }, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartNetflowTopAppProtocolsByGrowthRateWidget({
                id:id + "TopAppProtocolsByGrowthRateChart",
                title:LangHelper.GetString("QoE", "Top applications protocols by growth rate"),
                name:"QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopAppProtocolsByGrowthRateWidget",
            }, Online)
        }
    });
};

var QoETableNetflowTopAppProtocolsGroupsBySubscribersTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsGroupsBySubscribersTableChartWidget",
        table:{
            widget: QoETableNetflowTopAppProtocolsGroupsBySubscribersWidget({id:id + "TopAppProtocolsGroupsBySubscribers", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartNetflowTopAppProtocolsGroupsBySubscribersWidget({id:id + "TopAppProtocolsGroupBySubscribersChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopAppProtocolsGroupsByGrowthRateTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsGroupsByGrowthRateTableChartWidget",
        table:{
            widget: QoETableNetflowTopAppProtocolsGroupsByGrowthRateWidget({
                id:id + "TopAppProtocolsGroupsByGrowthRate",
                title:LangHelper.GetString("QoE", "Top applications protocols groups by growth rate"),
                name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsGroupsByGrowthRateWidget",
                protocol_groups:true
                }, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartNetflowTopAppProtocolsGroupsByGrowthRateWidget({
                id:id + "TopAppProtocolsGroupByGrowthRateChart",
                title:LangHelper.GetString("QoE", "Top applications protocols groups by growth rate"),
                name:"QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopAppProtocolsGroupsByGrowthRateWidget",
                protocol_groups:true
            }, Online)
        }
    });
};

var QoETableNetflowTopAppProtocolsBySubscribersWidget = function (Params, Online)
{
    var params = webix.extend({
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsBySubscribersWidget",
        title:LangHelper.GetString("QoE", "Top applications protocols by subscribers"),
        sort:"logins_uniq",
        apps_by_subscribers:true
    },Params, true);

    return QoETableNetflowTopTrafficProtocolsWidget(params, Online);
};

var QoETableNetflowTopAppProtocolsByGrowthRateWidget = function (Params, Online)
{
    var params = webix.extend({
        title:LangHelper.GetString("QoE", "Top applications protocols by growth rate"),
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsByGrowthRateWidget",
    },Params, true);

    return QoETableNetflowTopProtocolsByGrowthRateWidget(params, Online);
};

var QoETableNetflowTopProtocolsByGrowthRateWidget = function(Params, Online)
{
    let title = Params && Params.title ? Params.title : "";
    let id = Params && Params.id ? Params.id : webix.uid();
    let name = Params && Params.name ? Params.name : "";

    let rows = [
        {col:"protocol"},
        {col:"app_protocol_group_id"}
    ];

    let subqueryRows = [
        {col:"protocol"},
        {col:"app_protocol_group_id"}
    ];

    let values = [
        {col:"", alias:"subscribers_growth_rate", func:"if(first_interval_logins_uniq = 0 and last_interval_logins_uniq = 0, 0, if(first_interval_logins_uniq = 0, 100, round((last_interval_logins_uniq / first_interval_logins_uniq - 1) * 100, 2)))"},
        {col:"", alias:"logins_growth_rate", func:"if(first_interval_subscribers_uniq = 0 and last_interval_subscribers_uniq = 0, 0, if(first_interval_subscribers_uniq = 0, 100, round((last_interval_subscribers_uniq / first_interval_subscribers_uniq - 1) * 100, 2)))"}
    ];

    let columns = [
        {
            id:"protocol",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Protocol")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            fillspace:true,
            minWidth:160,
            sort:"string",
            footer:{content:"totalRows"}
        },
        {
            id: "app_protocol_group_id",
            width: 160,
            header: [
                LangHelper.GetString("DpiDscpConfig", "Group"),
                {
                    content: "multiSelectFilter",
                    options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                    inputConfig: {suggest: {fitMaster: false}}
                }
            ],
            filterMap: {
                id: "app_protocol_group_id",
                operator: "in",
                value: function(Val)
                {
                    if(Val)
                    {
                        var arr = Val.split(",");

                        return arr;
                    }
                    return null;
                }
            },
            template: function(obj){

                var str = "";

                if(obj && obj.app_protocol_group_id != null)
                {
                    var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.app_protocol_group_id});

                    if(group)
                    {
                        str = group.value;
                    }
                }
                return str;
            }
        },
        {
            id:"subscribers_growth_rate",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers growth rate")+", %"), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            width:145,
            template:(Value) => QoECellGrowthRateWidget(Value.subscribers_growth_rate)
        },
        {
            id:"logins_growth_rate",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Logins growth rate")+", %"), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            width:145,
            template:(Value) => QoECellGrowthRateWidget(Value.logins_growth_rate)
        }
    ];

    if(Params.protocol_groups) {
        subqueryRows = subqueryRows.filter(Item => Item.col !== "protocol")
        rows = rows.filter(Item => Item.col !== "protocol")
        values = values.filter(Item => Item.col !== "protocol");
        columns = columns.filter(Item => Item.id !== "protocol");
    }

    let params = {
        title: title,
        icon:"table",
        id:id,
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view:QoEReportViews.FullnetflowAggSubscribersGrowthRateView(subqueryRows),
            rows:rows,
            values:values,
            sort:{id:"logins_growth_rate", dir:"desc"},
            flags:{
                use_size:0,
                use_where:0,
                use_group_by:0
            },
            limit:1000000,
            cache:{
                enabled:1,
                values: [],
                limit:1000000,
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:columns,
        leftSplit:1,
        export_pdf_config: {
            percent_columns: [
                "subscribers_growth_rate",
                "logins_growth_rate"
            ],
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            }
        }
    };

    params.config.cache.values = [].concat(params.config.rows);
    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = ""; //Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    return new QoETableReportWidget(params);
};

var QoESeriesChartNetflowTopAppProtocolsBySubscribersWidget = function (Params, Online)
{
    var params = webix.extend({
        name:"QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopAppProtocolsBySubscribersWidget",
        title:LangHelper.GetString("QoE", "Top applications protocols by subscribers"),
        values:[
            {col:"", alias:"logins_uniq", func:QoEReportFunctions.LoginsUniq}
        ],
        cols:[
            {
                col:"protocol",
                alias:"{col_value}",
                func:"",
                values:{
                    func: "GetTopList",
                    params: {
                        table: QoEReportTablesEnum.FullnetflowAgg,
                        view: Params && Params.view ? Params.view : QoEReportViews.FullFlow,
                        row: "protocol",
                        func: QoEReportFunctions.LoginsUniq,
                        limit: 50
                    }
                },
                condition:"==",
                sql_tpl:Helper.ReplaceAll("{condition}", "protocol == {col_value}", QoEReportFunctions.LoginsUniqIf)+" as `{col_value_as_alias}`"
            }
        ],
        y_axis: {},
        export_pdf_config:{
            view_type: "chart",
            title: LangHelper.GetString("QoE", "Top applications protocols by subscribers"),
            abscise_key: "time_step",
            locales: {
                "legend_title": "protocol"
            }
        },
        apps_by_subscribers:true
    }, Params, true);

    return QoESeriesChartTrafficByAppProtocolsWidget(params, Online);
}

QoESeriesChartNetflowTopAppProtocolsByGrowthRateWidget = function (Params, Online)
{
    var params = webix.extend({
        title:LangHelper.GetString("QoE", "Top applications protocols by growth rate"),
        name:"QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopAppProtocolsByGrowthRateWidget",
    },Params, true);

    return QoESeriesChartNetflowProtocolsByGrowthRateWidget(params, Online);
}

QoESeriesChartNetflowTopAppProtocolsGroupsByGrowthRateWidget = function (Params, Online)
{
    var params = webix.extend({
        title:LangHelper.GetString("QoE", "Top applications protocols groups by growth rate"),
        name:"QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopAppProtocolsGroupsByGrowthRateWidget",
        protocol_groups:true
    },Params, true);

    return QoESeriesChartNetflowProtocolsByGrowthRateWidget(params, Online);
}

var QoESeriesChartNetflowProtocolsByGrowthRateWidget = function (Params, Online)
{
    let id = Params && Params.id ? Params.id : webix.uid();
    let title = Params && Params.title ? Params.title : "";
    let name = Params && Params.name ? Params.name : "";

    let subqueryRows = [
        {col:"protocol"},
        {col:"app_protocol_group_id"}
    ];

    let values = [
        {col:"protocol"},
        {col:"app_protocol_group_id"},
        {col:"", alias:"subscribers_growth_rate", func:QoEReportFunctions.SubscribersUniqGrowthRate},
        {col:"", alias:"logins_growth_rate", func:QoEReportFunctions.LoginsUniqGrowthRate}
    ];

    let sqlTplCol = "protocol";

    let exportPdfConfig = {
        view_type: "chart",
        title: LangHelper.GetString("QoE", "Top applications protocols by subscribers"),
        abscise_key: "time_step",
        locales: {
            "legend_title": "protocol"
        }
    };

    if(Params.protocol_groups) {
        subqueryRows = subqueryRows.filter(Item => Item.col !== "protocol");
        values = values.filter(Item => Item.col !== "protocol");
        sqlTplCol = "app_protocol_group_id";
        exportPdfConfig.values_dics = {"app_protocol_group_id": "ProtocolsGroupsDic"};
        exportPdfConfig.locales = {"legend_title": "protocol group"};
    }

    let params = {
        id:id,
        title:title,
        name:name,
        icon:"area-chart",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:[
                {col:"", alias:"logins_growth_rate", func:QoEReportFunctions.LoginsUniqGrowthRate}
            ],
            rows:[
                {col:"time", alias:"time_step", func:"toStartOfAuto"}
            ],
            cols:[
                {
                    col:sqlTplCol,
                    alias:"{col_value}",
                    func:"",
                    values:{
                        func: "GetTopList",
                        params:{
                            table:QoEReportTablesEnum.FullnetflowAgg,
                            view:QoEReportViews.FullnetflowAggSubscribersGrowthRateView([{col:sqlTplCol}]),
                            row:sqlTplCol,
                            func:QoEReportFunctions.LoginsUniqGrowthRate,
                            limit: 50,
                            flags:{
                                use_group_by:0
                            }
                        }
                    },
                    condition:"==",
                    sql_tpl:Helper.ReplaceAll("{condition}", `${sqlTplCol} == toString({col_value})`, QoEReportFunctions.LoginsUniqGrowthRateIf)+" as `{col_value_as_alias}`"
                }
            ],
            sort:{id:"time_step",dir:"asc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000,
            online:Online,
            cache:{
                enabled:1,
                values: ["time_step"],
                cols:[
                    {
                        col:sqlTplCol,
                        alias:"{col_value}"
                    }
                ],
                flags:{
                    use_where:0,
                    use_having:0,
                    use_cache_saved_cols:1
                },
                limit:1000
            },
        },
        type:"splineArea",
        xAxis: {
            template:(Val) => (Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val))
        },
        yAxis: {},
        legend: {
            height:160,
            align: "left",
            valign: "bottom",
            layout:"x",
            values:[]
        },
        export_pdf_config:exportPdfConfig
    };

    return new QoESeriesChartReportWidget(params);
}

var QoETableNetflowTopAppProtocolsGroupsBySubscribersWidget = function (Params, Online)
{
    var params = webix.extend({
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsGroupsBySubscribersWidget",
        title:LangHelper.GetString("QoE", "Top applications protocols groups by subscribers"),
        sort:"logins_uniq",
        apps_by_subscribers:true,
    }, Params, true);

    return QoETableNetflowTopTrafficProtocolsGroupsWidget(params, Online);
};

var QoETableNetflowTopAppProtocolsGroupsByGrowthRateWidget = function (Params, Online)
{
    var params = webix.extend({
        title:LangHelper.GetString("QoE", "Top applications protocols groups by growth rate"),
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopAppProtocolsGroupsByGrowthRateWidget",
        protocol_groups:true
    }, Params, true);

    return QoETableNetflowTopProtocolsByGrowthRateWidget(params, Online);
};

var QoESeriesChartNetflowTopAppProtocolsGroupsBySubscribersWidget = function (Params, Online)
{
    var params = webix.extend({
        name:"QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopAppProtocolsGroupsBySubscribersWidget",
        title:LangHelper.GetString("QoE", "Top applications protocols groups by subscribers"),
        values:[
            {col:"", alias:"logins_uniq", func:QoEReportFunctions.LoginsUniq}
        ],
        cols:[
            {
                col:"app_protocol_group_id",
                alias:"{col_value}",
                func:"",
                values:{
                    func: "GetTopList",
                    params: {
                        table: QoEReportTablesEnum.FullnetflowAgg,
                        view: Params && Params.view ? Params.view : QoEReportViews.FullFlow,
                        row: "app_protocol_group_id",
                        func: QoEReportFunctions.LoginsUniq,
                        limit: 50
                    }
                },
                condition:"==",
                sql_tpl:Helper.ReplaceAll("{condition}", "app_protocol_group_id == {col_value}", QoEReportFunctions.LoginsUniqIf)+" as `{col_value_as_alias}`"
            }
        ],
        y_axis: {},
        export_pdf_config:{
            view_type: "chart",
            title: LangHelper.GetString("QoE", "Top applications protocols groups by subscribers"),
            abscise_key: "time_step",
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            },
            locales: {
                "legend_title": "protocol group"
            }
        },
        apps_by_subscribers:true
    }, Params, true);

    return QoESeriesChartTrafficByAppProtocolsGroupsWidget(params, Online);
};

var QoESeriesChartFlowByProtocolsTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByProtocolsTableChartWidget",
        table:{
            widget: QoETableNetflowTopFlowProtocolsShortWidget({id:id + "FlowByProtocolsTable", net_protocol:false, table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartFlowByAppProtocolsWidget({id:id + "FlowByProtocolsChart", table, view}, Online)
        }
    });
};

var QoESeriesChartFlowByProtocolsGroupsTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByProtocolsGroupsTableChartWidget",
        table:{
            widget: QoETableNetflowTopFlowProtocolsGroupsShortWidget({id:id + "FlowByProtocolsGroupsTable", net_protocol:false, table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartFlowByAppProtocolsGroupsWidget({id:id + "FlowByProtocolsGroupsChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopSubscribersByAppProtocolsTableChartWidget = function (Params, Online)
{
    const id = Params && Params.id ? Params.id : webix.uid();

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopSubscribersByAppProtocolsTableChartWidget",
        table:{
            widget: QoETableNetflowTopSubscribersByAppProtocolsWidget({
                id:id + "TopSubscribersByAppProtocolsTable",
                title:LangHelper.GetString("QoE", "Top subscribers by applications"),
                name:"QoETable" + (Online ? "Online" : "") + "NetflowTopSubscribersByAppProtocolsWidget"
            }, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartNetflowTopSubscribersByAppProtocolsWidget({
                id:id + "TopSubscribersByAppProtocolsSeriesChart",
                title:LangHelper.GetString("QoE", "Top subscribers by applications"),
                name:"QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopSubscribersByAppProtocolsWidget",
                protocol_groups:true
            }, Online)
        }
    });
};

var QoETableNetflowTopLoginsByAppProtocolsTableChartWidget = function (Params, Online)
{
    const id = Params && Params.id ? Params.id : webix.uid();

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopLoginsByAppProtocolsTableChartWidget",
        table:{
            widget: QoETableNetflowTopLoginsByAppProtocolsWidget({
                id:id + "TopLoginsByAppProtocolsTable",
                title:LangHelper.GetString("QoE", "Top logins by applications"),
                name:"QoETable" + (Online ? "Online" : "") + "NetflowTopLoginsByAppProtocolsWidget"
            }, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartNetflowTopLoginsByAppProtocolsWidget({
                id:id + "TopLoginsByAppProtocolsSeriesChart",
                title:LangHelper.GetString("QoE", "Top logins by applications"),
                name:"QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopAppProtocolsGroupsByGrowthRateWidget",
                protocol_groups:true
            }, Online)
        }
    });
};

var QoETableNetflowTopSubscribersByAppProtocolsWidget = function (Params, Online)
{
    const title = Params && Params.title
        ? Params.title
        : LangHelper.GetString("QoE", "Top subscribers by applications");
    const id = Params && Params.id
        ? Params.id
        : webix.uid() + "TopSubscribersByAppProtocolsTable";
    const name = Params && Params.name
        ? Params.name
        : "QoETable" + (Online ? "Online" : "") + "NetflowTopSubscribersByAppProtocolsWidget";

    const params = webix.extend({id:id, title:title, name:name, by_subscriber:true}, Params, true);

    return QoETableNetflowSubscribersAndAppProtocolsWidget(params, Online);
};

var QoETableNetflowTopLoginsByAppProtocolsWidget = function (Params, Online)
{
    const title = Params && Params.title
        ? Params.title
        : LangHelper.GetString("QoE", "Top logins by applications");
    const id = Params && Params.id
        ? Params.id
        : webix.uid() + "TopLoginsByAppProtocolsTable";
    const name = Params && Params.name
        ? Params.name
        : "QoETable" + (Online ? "Online" : "") + "NetflowTopLoginsByAppProtocolsWidget";

    const params = webix.extend({id:id, title:title, name:name, by_login:true}, Params, true);

    return QoETableNetflowSubscribersAndAppProtocolsWidget(params, Online);
};

var QoESeriesChartNetflowTopSubscribersByAppProtocolsWidget = function (Params, Online)
{
    const title = Params && Params.title
        ? Params.title
        : LangHelper.GetString("QoE", "Top subscribers by applications");
    const id = Params && Params.id
        ? Params.id
        : webix.uid() + "TopSubscribersByAppProtocolsSeriesChart";
    const name = Params && Params.name
        ? Params.name
        : "QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopSubscribersByAppProtocolsWidget";

    const params = webix.extend({id:id, title:title, name:name, by_subscriber:true}, Params, true);

    return QoESeriesChartNetflowSubscribersAndAppProtocolsWidget(params, Online);
};

var QoESeriesChartNetflowTopLoginsByAppProtocolsWidget = function (Params, Online)
{
    const title = Params && Params.title
        ? Params.title
        : LangHelper.GetString("QoE", "Top logins by applications");
    const id = Params && Params.id
        ? Params.id
        : webix.uid() + "TopLoginsByAppProtocolsSeriesChart";
    const name = Params && Params.name
        ? Params.name
        : "QoESeriesChart" + (Online ? "Online" : "") + "NetflowTopLoginsByAppProtocolsWidget";

    const params = webix.extend({id:id, title:title, name:name, by_login:true}, Params, true);

    return QoESeriesChartNetflowSubscribersAndAppProtocolsWidget(params, Online);
};

var QoETableNetflowSubscribersAndAppProtocolsWidget = function (Params, Online)
{
    const title = Params && Params.title ? Params.title : "";
    const id = Params && Params.id ? Params.id : webix.uid();
    const name = Params && Params.name ? Params.name : "";

    let rows, values, columns, sortMap;

    if(Params && Params.by_subscriber) {
        rows = [{col:"subscriber"}];
        values = [{col:"login", alias: "login_any", func: "anyLast"}];
        columns = [
            {
                id:"subscriber",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")),
                    {content: "textFilter", placeholder:"&#xf002 " + LangHelper.GetString("All","Filter")}
                ],
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            },
            {
                id:"login",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Login")),
                    {content: "textFilter", placeholder:"&#xf002 " + LangHelper.GetString("All","Filter")}
                ],
                template:function(Obj) {
                    return Obj.login_any;
                },
                fillspace:2,
                minWidth:160,
                sort:"string"
            }
        ];

        sortMap = {"login":"login_any"};
    }

    if(Params && Params.by_login) {
        rows = [{col:"login"}];
        values = [{col:"subscriber", alias: "subscriber_any", func: "anyLast"}];
        columns = [
            {
                id:"login",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Login")),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            },
            {
                id:"subscriber",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                template:function(Obj) {
                    return Obj.subscriber_any;
                },
                fillspace:2,
                minWidth:160,
                sort:"string"
            }
        ];

        sortMap = {"subscriber":"subscriber_any"};
    }

    const order = [
        "sessons_uniq",
        "protocol_uniq",
        "protocols_percent",
        "protocol_top_k",
        "app_protocol_group_uniq",
        "app_protocol_group_percent",
        "protocol_group_top_k",
        "duration_sum",
        "traffic",
        "traffic_vol"
    ];

    const common = QoETableNetflowTopCommonConfig({
        custom_filter:[
            "sessons_uniq",
            "protocol_uniq",
            "app_protocol_group_uniq",
            "traffic",
            "traffic_vol"
        ]
    });

    common.values = common.values.concat([
        {col:"", alias:"protocols_percent", func:"round(multiply(divide(protocol_uniq, sum(protocol_uniq) over()), 100), 2)"},
        {col:"", alias:"app_protocol_group_percent", func:"round(multiply(divide(app_protocol_group_uniq, sum(app_protocol_group_uniq) over()), 100), 2)"},
        {col:"", alias:"protocol_top_k", func:"topK(protocol)[1]"},
        {col:"", alias:"protocol_group_top_k", func:"topK(app_protocol_group_id)[1]"},
        {col:"", alias:"duration_sum", func:QoEReportFunctions.DurationSumInMinutes}
    ]);

    common.columns = common.columns.concat([
        {
            id: "protocol_top_k",
            header: [TooltipTemplate(LangHelper.GetString("QoE", "Top protocol")), ""],
            width:125,
            filterMap: {id: "protocol", operator: "like"},
            sort: "string"
        },
        {
            id:"protocols_percent",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Application protocols")+", %"), ""],
            width:125,
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            template:function(Obj) {
                return QoETopProtocolsPercentColumnWidget(
                    null,
                    null,
                    false,
                    Obj.protocols_percent
                );
            }
        },
        {
            id: "protocol_group_top_k",
            header: [LangHelper.GetString("QoE", "Top group"), ""],
            adjust: true,
            filterMap: {
                id: "protocol_group_top_k",
                operator: "in",
                value: function(Val) {
                    const arr = String(Val).split(",");
                    return arr.length ? arr : null;
                }
            },
            template: function(Obj) {
                const dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic);
                const val = Obj && Obj.protocol_group_top_k
                    ? Obj.protocol_group_top_k
                    : null;
                const group = dic.find(i => String(i.dic_id) === val);
                return group && group.value ? group.value : "";
            }
        },
        {
            id:"app_protocol_group_percent",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Groups")+", %"), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            template:function(Obj) {
                return QoETopProtocolsPercentColumnWidget(
                    null,
                    null,
                    false,
                    Obj.app_protocol_group_percent
                );
            }
        },
        {
            id: "duration_sum",
            header: [TooltipTemplate(LangHelper.GetString("QoE", "Duration")), ""],
            format:webix.i18n.intFormat,
            sort: "string",
            footer: {content:"totalColumn"}
        }
    ]);

    common.values.sort((a, b) => order.indexOf(a.alias) - order.indexOf(b.alias));
    common.columns.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));

    values = values.concat(common.values);
    columns = columns.concat(common.columns)

    let params = {
        title: title,
        icon:"table",
        id:id,
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view:QoEReportViews.FullFlow,
            rows:rows,
            values:values,
            sort:{id:"sessons_uniq", dir:"desc"},
            flags:{
                use_size:0,
                use_where:0,
            },
            limit:1000000,
            cache:{
                enabled:1,
                values: [],
                limit:1000000,
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:columns,
        leftSplit:1,
        sort_map:sortMap,
        export_pdf_config: {
            percent_columns: [
                "protocols_percent",
                "app_protocol_group_percent"
            ],
            values_dics: {
                "protocol_group_top_k": "ProtocolsGroupsDic"
            }
        }
    };

    params.config.cache.values = [].concat(params.config.rows);
    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = ""; //Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    return new QoETableReportWidget(params);
};

var QoESeriesChartNetflowSubscribersAndAppProtocolsWidget = function (Params, Online)
{
    const title = Params && Params.title ? Params.title : "";
    const id = Params && Params.id ? Params.id : webix.uid();
    const name = Params && Params.name ? Params.name : "";

    let col = "";

    if(Params && Params.by_subscriber)
        col = "subscriber";

    if(Params && Params.by_login)
        col = "login";

    const params = {
        title:title,
        icon:"area-chart",
        id:id,
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view:QoEReportViews.FullFlow,
            values:[{col:"", alias:"sessons_uniq", func:QoEReportFunctions.SessionsUniqIf}],
            rows:[{col:"time", alias:"time_step", func:"toStartOfAuto"}],
            cols:[
                {
                    col:col,
                    alias:"{col_value}",
                    func:"",
                    values:{
                        func: "GetTopList",
                        params: {
                            table: QoEReportTablesEnum.FullnetflowAgg,
                            view: Params && Params.view ? Params.view : QoEReportViews.FullFlow,
                            row: col,
                            func: QoEReportFunctions.SessionsUniq,
                            limit: 50
                        }
                    },
                    condition:"==",
                    sql_tpl:Helper.ReplaceAll(
                        "{condition}",
                        `${col} == {col_value}`,
                        QoEReportFunctions.SessionsUniqIf
                    ) + " as `{col_value_as_alias}`"
                }
            ],
            sort:{id:"time_step",dir:"asc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000,
            online:Online,
            cache:{
                enabled:1,
                values:["time_step"],
                cols:[{col:col, alias:"{col_value}"}],
                flags:{
                    use_where:0,
                    use_having:0,
                    use_cache_saved_cols:1
                },
                limit:1000
            }
        },
        type:"splineArea",
        xAxis:{
            template:function(Val) {
                return Online
                    ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true)
                    : Helper.FormatDateTimeForChartXAxes(Val);
            }
        },
        yAxis:{},
        legend:{
            height:160,
            align:"left",
            valign:"bottom",
            layout:"x",
            values:[]
        },
        export_pdf_config:{
            view_type:"chart",
            title:title,
            locales: {
                "legend_title": "subscriber"
            },
            abscise_key:"time_step",
        }
    };

    return new QoESeriesChartReportWidget(params);
};

var QoEPieChartNetflowTopFlowProtocolsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top application protocols with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopFlowProtocolsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view: QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                "protocol"
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "flow":LangHelper.GetString("QoE", "Flow"),
                "protocol":LangHelper.GetString("QoE", "Protocol")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top application protocols with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "protocol",
            locales: {
                "legend_title": "protocol"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopFlowProtocolsGroupsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top application protocols groups with high flow"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopFlowProtocolsGroupsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                {col:"app_protocol_group_id", alias:"app_protocol_group_id", gui_dic:DicsEnum.ProtocolsGroupsDic}
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top application protocols groups with high flow"),
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            },
            pie_chart_key: "app_protocol_group_id",
            locales: {
                "legend_title": "group"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTotalTrafficTableChartWidget = function (Params)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    return new QoETableChartWidget({
        id:id,
        serie_column:"traffic_type",
        table:{
            widget: QoETableTotalTrafficWidget({id:id + "TrafficTable"})
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartTrafficWidget({id:id + "TrafficChart"})
        }
    });
};

var QoETableNetflowTopTrafficASTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    var type = Params&&Params.type ? Params.type : "destination";
    var table = Params&&Params.table ? Params.table : null;
    var view = Params&&Params.view ? Params.view : null;

    return new QoETableChartWidget({
        id:id,
        name:"QoE" + (Online ? "Online" : "") + "TableNetflowTopTrafficASTableChartWidget",
        table:{
            widget: QoETableNetflowTopTrafficASsShortWidget({id:id + "TrafficByASTable", type:type, table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartTrafficByASWidget({id:id + "TrafficByAppASChart", type:type, table, view}, Online)
        }
    });
};

var QoETableNetflowTopTrafficSubscribersASTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    var type = Params&&Params.type ? Params.type : "source";
    var table = Params&&Params.table ? Params.table : null;
    var view = Params&&Params.view ? Params.view : null;

    return new QoETableChartWidget({
        id:id,
        name:"QoE" + (Online ? "Online" : "") + "TableNetflowTopTrafficSubscribersASTableChartWidget",
        table:{
            widget: QoETableNetflowTopTrafficASsShortWidget({id:id + "TrafficBySubscribersASTable", type:type, table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartTrafficByASWidget({id:id + "TrafficByAppSubscribersASChart", type:type, table, view}, Online)
        }
    });
};

var QoEPieChartNetflowTopHostsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopHostsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                "host_other"
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "host_other":LangHelper.GetString("QoE", "Host"),
                "rtt":LangHelper.GetString("QoE", "RTT")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top hosts with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "host_other",
            locales: {
                "legend_title": "host"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopTrafficHostsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopTrafficHostsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                "host_other"
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "host_other":LangHelper.GetString("QoE", "Host"),
                "traffic":LangHelper.GetString("QoE", "Traffic")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top hosts with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "host_other",
            locales: {
                "legend_title": "host"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopHostsWidget = function (Params, Online)
{
    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top hosts with high RTT");

    var name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopHostsWidget";

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top hosts with high traffic");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficHostsWidget";

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title = LangHelper.GetString("QoE", "Top hosts with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsHostsWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.percent)
    {
        if(Params.traffic_speed)
        {
            commonParams = {traffic_speed_percent:true};

            title = LangHelper.GetString("QoE", "Top hosts with high traffic");

            name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopPercentTrafficHostsWidget");

            sort = "traffic";

            sortMap = {"traffic_percent":"traffic","traffic_from_subscriber_percent":"traffic_from_subscriber","traffic_to_subscriber_percent":"traffic_to_subscriber"};
        }

        if(Params.traffic_volume)
        {
            commonParams = {traffic_volume_percent:true};

            title = LangHelper.GetString("QoE", "Top hosts with high traffic volume");

            name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopPercentTrafficVolumeHostsWidget");

            sort = "traffic_vol";

            sortMap = {"traffic_vol_percent":"traffic_vol","traffic_vol_from_subscriber_percent":"traffic_vol_from_subscriber","traffic_vol_to_subscriber_percent":"traffic_vol_to_subscriber"};
        }
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top hosts with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowHostsWidget";

        sort =  "flow";
    }

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:[
                {col:"host_category", alias:"host_category_any", func:"anyLast"},
                {col:"", alias:"host_category_description", func:"dictGetString('urlcats_dic', 'description', host_category_any)"}
            ].concat(common.values),
            rows:[
                "host_other"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            remember_field:(Online ? {alias:"host_other", func:"empty(host) ? 'Unknown' : replaceOne(host, '*', 'www')"} : Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:[
            {
                id:"host_other",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                minWidth:160,
                sort:"string",
                footer:{content:"totalRows"}
            },
            {
                id:"host_category_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host category")), ""],
                template:function(Obj)
                {
                    var dic = App.DicsManager.GetDic(DicsEnum.HostCategoriesDic);

                    return dic && dic[Obj.host_category_any] ? LangHelper.GetString("QoE", dic[Obj.host_category_any].value) : LangHelper.GetString("QoE", "hcn_undefined");
                },
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            }
        ].concat(common.columns),
        leftSplit:2,
        export_pdf_config: {
            sparkline_columns: common.sparkline_columns ? common.sparkline_columns : [],
            values_dics: {
                "host_category_any": "HostCategoriesDic"
            }
        }
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,8);
            params.columns = params.columns.slice(0,8);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }
        else if(Params.top_flow)
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }
        else if(Params.percent)
        {
            params.config.values = params.config.values.slice(0,8);
            params.columns = params.columns.slice(0,8);
        }
        else
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:6
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetflowTopHostsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopHostsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopHostsWidget(params, Online);
};

var QoETableNetflowTopTrafficHostsWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableNetflowTopHostsWidget(params, Online);
};

var QoETableNetflowTopTrafficHostsPercentSpeedWidget = function (Params)
{
    var params = webix.extend({percent:true, traffic_speed:true}, Params, true);

    return QoETableNetflowTopHostsWidget(params);
}

var QoETableNetflowTopTrafficHostsPercentVolumeWidget = function (Params)
{
    var params = webix.extend({percent:true, traffic_volume:true}, Params, true);

    return QoETableNetflowTopHostsWidget(params);
}

var QoETableNetflowTopTrafficHostsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficHostsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficHostsWidget(params, Online);
};

var QoETableNetflowTopTrafficHostsPercentSpeedShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficHostsPercentSpeedShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficHostsPercentSpeedWidget(params);
}

var QoETableNetflowTopTrafficHostsPercentVolumeShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficHostsPercentVolumeShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficHostsPercentVolumeWidget(params);
}

var QoEPieChartNetflowTopHostCategoriesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top host categories with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopHostCategoriesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                {col:"host_category", alias:"host_category", gui_dic:DicsEnum.HostCategoriesDic}
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "host_category":LangHelper.GetString("QoE", "Host category"),
                "traffic":LangHelper.GetString("QoE", "Traffic")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top host categories with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            values_dics: {
                "host_category": "HostCategoriesDic"
            },
            pie_chart_key: "host_category",
            locales: {
                "legend_title": "host_category"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopTrafficHostCategoriesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top host categories with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopTrafficHostCategoriesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                {col:"host_category", alias:"host_category", gui_dic:DicsEnum.HostCategoriesDic}
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top host categories with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            values_dics: {
                "host_category": "HostCategoriesDic"
            },
            pie_chart_key: "host_category",
            locales: {
                "legend_title": "host_category"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopHostCategoriesWidget = function (Params, Online)
{
    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top host categories with high RTT");

    var name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopHostCategoriesWidget";

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top host categories with high traffic");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficHostCategoriesWidget";

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title = LangHelper.GetString("QoE", "Top host categories with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsHostCategoriesWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top host categories with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowHostCategoriesWidget";

        sort =  "flow";
    }

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:[
                {col:"", alias:"host_category_description", func:"dictGetString('urlcats_dic', 'description', host_category)"}
            ].concat(common.values),
            rows:[
                "host_category"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            remember_field:(Online ? {alias:"host_category", func:"dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(empty(host) ? 'Unknown' : replaceOne(host, '*', 'www')), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(replaceOne(empty(host) ? 'Unknown' : replaceOne(host, '*', 'www'), 'www.', '')), dictGetUInt64OrDefault('urlcats_host_dic', 'cat_id', tuple(concat('www.',empty(host) ? 'Unknown' : replaceOne(host, '*', 'www'))), toUInt64(0))))"} : Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:[
            {
                id:"host_category",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host category")), ""],
                template:function(Obj)
                {
                    var dic = App.DicsManager.GetDic(DicsEnum.HostCategoriesDic);

                    return dic && dic[Obj.host_category] ? LangHelper.GetString("QoE", dic[Obj.host_category].value) : LangHelper.GetString("QoE", "hcn_undefined");
                },
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            }
        ].concat(common.columns),
        leftSplit:1,
        export_pdf_config: {
            values_dics: {
                "host_category": "HostCategoriesDic"
            }
        }
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,7);
            params.columns = params.columns.slice(0,7);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }
        else if(Params.top_flow)
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }
        else
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:6
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetflowTopHostCategoriesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopHostCategoriesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopHostCategoriesWidget(params, Online);
};

var QoETableNetflowTopTrafficHostCategoriesWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableNetflowTopHostCategoriesWidget(params, Online);
};

var QoETableNetflowTopTrafficHostCategoriesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficHostCategoriesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficHostCategoriesWidget(params, Online);
};

var QoEPieChartNetflowTopHostsIPsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name ? Params.name : "QoEPieChartNetflowTopHostsIPsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                "host_ip"
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "host_ip",
            locales: {
                "legend_title": "host_ips"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopTrafficHostsIPsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name ? Params.name : "QoEPieChartNetflowTopTrafficHostsIPsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                "host_ip"
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "host_ip",
            locales: {
                "legend_title": "host_ips"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopHostsIPsWidget = function (Params, Online)
{
    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high RTT");

    var name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopHostsIPsWidget";

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high traffic");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficHostsIPsWidget";

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title = LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopRetransmitsHostsIPsWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowHostsIPsWidget";

        sort =  "flow";
    }

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:[
                {col:"host", alias:"host_any",func:"any"}
            ].concat(common.values),
            rows:[
                "host_ip"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            remember_field:(Online ? {alias:"host_ip", func:"host_ip"} : Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:[
            {
                id:"host_ip",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                minWidth:160,
                sort:"string",
                footer:{content:"totalRows"}
            },
            {
                id:"host_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                minWidth:160,
                sort:"string",
                footer:{content:"totalRows"}
            }
        ].concat(common.columns),
        leftSplit:2
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,8);
            params.columns = params.columns.slice(0,8);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }
        else if(Params.top_flow)
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }
        else
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:6
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetflowTopHostsIPsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopHostsIPsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopHostsIPsWidget(params, Online);
};

var QoETableNetflowTopTrafficHostsIPsWidget = function (Params)
{
    var params = webix.extend({top_traffic:true, name:"QoETableNetflowTopTrafficHostsIPsWidget"}, Params, true);

    return QoETableNetflowTopHostsIPsWidget(params);
};

var QoETableNetflowTopTrafficHostsIPsShortWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true, name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficHostsIPsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopHostsIPsWidget(params, Online);
};

var QoEPieChartNetflowTopASsWidget = function (Params)
{
    var type = Params&&Params.type ? Params.type : "destination";

    var params = {
        title:LangHelper.GetString("QoE", "Top "+(type == "source" ? "subscriber`s " : "")+"AS with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopASsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                type+"_asnum"
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top "+(type == "source" ? "subscriber`s " : "")+"AS with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: type+"_asnum",
            locales: {
                "legend_title": "as_number"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopTrafficASsWidget = function (Params)
{
    var type = Params&&Params.type ? Params.type : "destination";

    var params = {
        title:LangHelper.GetString("QoE", "Top "+(type == "source" ? "subscriber`s " : "")+"AS with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopTrafficASsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                type+"_asnum"
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top "+(type == "source" ? "subscriber`s " : "")+"AS with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: type+"_asnum",
            locales: {
                "legend_title": "as_number"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopSubscriberASsWidget = function (Params)
{
    var params = webix.extend(Params, {type:"source", name:"QoEPieChartNetflowTopSubscriberASsWidget"}, true);
    return QoEPieChartNetflowTopASsWidget(params);
};

var QoEPieChartNetflowTopTrafficSubscriberASsWidget = function (Params)
{
    var params = webix.extend(Params, {type:"source", name:"QoEPieChartNetflowTopTrafficSubscriberASsWidget"}, true);
    return QoEPieChartNetflowTopTrafficASsWidget(params);
};

var QoETableNetflowTopASsWidget = function (Params, Online)
{
    var commonParams = null;

    var type = Params&&Params.type ? Params.type : "destination";

    var title = LangHelper.GetString("QoE", "Top "+(type == "source" ? "subscriber`s " : "")+"AS");

    var name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTop" + (type == "source" ? "Subscribers" : "") + "ASsWidget";

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title +=  " " + LangHelper.GetString("QoE","with high traffic");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopTraffic" + (type == "source" ? "Subscribers" : "")+"ASsWidget";

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title +=  " " + LangHelper.GetString("QoE","with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmits" + (type == "source" ? "Subscribers" : "")+"ASsWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title +=  " " + LangHelper.GetString("QoE","with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopFlow" + (type == "source" ? "Subscribers" : "")+"ASsWidget";

        sort =  "flow";
    }

    title += " (" + LangHelper.GetString("AppView", "Netflow") + ")";

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:[
                {col:type+"_astitle", alias:"astitle_any", func:"any"}
            ].concat(common.values),
            rows:[
                type+"_asnum"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            remember_field:(Online ? {alias:type+"_asnum", func:type+"_asnum"} : Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:[
            {
                id:type+"_asnum",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "AS number")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                footer:{content:"totalRows"},
                sort:"string",
                fillspace:2,
                minWidth:160
            },
            {
                id: type+"_astitle",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "AS title")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                template:function(Obj)
                {
                    return Obj.astitle_any;
                },
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            }
        ].concat(common.columns),
        leftSplit:2,
        sort_map:function ()
        {
            var obj = {};
            obj[type+"_astitle"] = "astitle_any";

            return obj;

        }(),
        can_use_sort_map:{
            "ReportsSettings":1
        }
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,8);
            params.columns = params.columns.slice(0,8);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }
        else if(Params.top_flow)
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }
        else
        {
            params.config.values = params.config.values.slice(0,5);
            params.columns = params.columns.slice(0,5);
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:6
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetflowTopASsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopASsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopASsWidget(params, Online);
};

var QoETableNetflowTopSubscriberASsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopSubscriberASsWidget", type:"source"}, Params, true);

    return QoETableNetflowTopASsWidget(params);
};

var QoETableNetflowTopSubscriberASsShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopSubscriberASsShortWidget", type:"source", short:true}, Params, true);

    return QoETableNetflowTopASsWidget(params);
};

var QoETableNetflowTopTrafficASsWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableNetflowTopASsWidget(params, Online);
};

var QoETableNetflowTopTrafficASsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficASsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficASsWidget(params, Online);
};

var QoETableNetflowTopTrafficSubscriberASsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficSubscriberASsWidget", type:"source", top_traffic:true}, Params, true);

    return QoETableNetflowTopASsWidget(params);
};

var QoETableNetflowTopTrafficSubscriberASsShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficSubscriberASsShortWidget", type:"source", top_traffic:true, short:true}, Params, true);

    return QoETableNetflowTopASsWidget(params);
};

var QoEPieChartNetflowTopSwitchesWidget = function (Params)
{
    var type = Params&&Params.type ? Params.type : 1;

    var params = {
        title:LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopSwitchesWidget_"+type,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            join:QoEReportViews.FullFlowSubsHwJoin,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.HwIp+"]", alias:"hw_ip"}],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where: {
                    "hw_ip":1
                }
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "hw_ip",
            locales: {
                "legend_title": "switch_ip_address"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopAccessSwitchesWidget = function (Params)
{
    var params = webix.extend(Params, {type:1, name:"QoEPieChartNetflowTopAccessSwitchesWidget"}, true);

    return QoEPieChartNetflowTopSwitchesWidget(params);
};

var QoEPieChartNetflowTopTrunkSwitchesWidget = function (Params)
{
    var params = webix.extend(Params, {type:2, name:"QoEPieChartNetflowTopTrunkSwitchesWidget"}, true);

    return QoEPieChartNetflowTopSwitchesWidget(params);
};

var QoEPieChartNetflowTopTrafficSwitchesWidget = function (Params)
{
    var type = Params&&Params.type ? Params.type : 1;

    var params = {
        title:LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopTrafficSwitchesWidget_"+type,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            join:QoEReportViews.FullFlowSubsHwJoin,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.HwIp+"]", alias:"hw_ip"}],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where: {
                    "hw_ip":1
                }
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "hw_ip",
            locales: {
                "legend_title": "switch_ip_address"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopTrafficAccessSwitchesWidget = function (Params)
{
    var params = webix.extend(Params, {type:1, name:"QoEPieChartNetflowTopTrafficAccessSwitchesWidget"}, true);

    return QoEPieChartNetflowTopTrafficSwitchesWidget(params);
};

var QoEPieChartNetflowTopTrafficTrunkSwitchesWidget = function (Params)
{
    var params = webix.extend(Params, {type:2, name:"QoEPieChartNetflowTopTrafficTrunkSwitchesWidget"}, true);

    return QoEPieChartNetflowTopTrafficSwitchesWidget(params);
};

var QoETableNetflowTopSwitchesWidget = function (Params, Online)
{
    var commonParams = null;

    var type = Params&&Params.type ? Params.type : 1;

    var title = LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high RTT");

    var name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTop" + (type == 1 ? "" : "Trunk")+"SwitchesWidget";

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title =  LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high traffic");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopTraffic" + (type == 1 ? "" : "Trunk")+"SwitchesWidget";

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title =  LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmits" + (type == 1 ? "" : "Trunk")+"SwitchesWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title =  LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "NetflowTopFlow" + (type == 1 ? "" : "Trunk")+"SwitchesWidget";

        sort =  "flow";
    }

    title += " (" + LangHelper.GetString("AppView", "Netflow") + ")";

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var hw_name = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Name+"]";

    var hw_type = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Type+"]";

    var hw_region = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Region+"]";

    var hw_address = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Address+"]";

    var hw_oper_id = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.OperId+"]";

    var hw_belongs_to = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.BelongsTo+"]";

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            join:Online ? QoEReportViews.OnlineNetflowSubsHwJoin : QoEReportViews.FullFlowSubsHwJoin,
            values:
            [
                {col:hw_name, alias:"hw_name_any", func:"anyHeavyIf("+hw_name+", "+hw_name+" <> '')"},
                {col:hw_type, alias:"hw_type_any", func:"anyHeavyIf("+hw_type+", "+hw_type+" <> '')"},
                {col:hw_region, alias:"hw_region_any", func:"anyHeavyIf("+hw_region+", "+hw_region+" <> '')"},
                {col:hw_address, alias:"hw_address_any", func:"anyHeavyIf("+hw_address+", "+hw_address+" <> '')"},
                {col:hw_oper_id, alias:"hw_oper_id_any", func:"anyHeavyIf("+hw_oper_id+", "+hw_oper_id+" <> '')"},
                {col:hw_belongs_to, alias:"hw_belongs_to_any", func:"anyHeavyIf("+hw_belongs_to+", "+hw_belongs_to+" <> '')"}
            ].concat(common.values),

            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.HwIp+"]", alias:"hw_ip"}],

            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where: {
                    "hw_ip":1
                }
            },
            limit:1000000,
            with_totals:true,
            remember_field:(Online ? {alias:"hw_ip", func:"hw_ip"} : Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                rows:[],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
        [
            {
                id:"hw_ip",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch IP-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:1,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            },
            {
                id:"hw_name_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch name")), ""],
                footer:{content:"totalColumn"},
                sort:"string"
            },
            {
                id:"hw_type_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch type")), ""],
                footer:{content:"totalColumn"},
                sort:"string"
            },
            {
                id:"hw_region_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Region")), ""],
                footer:{content:"totalColumn"},
                sort:"string"
            },
            {
                id:"hw_address_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch address")), ""],
                footer:{content:"totalColumn"},
                sort:"string"
            },
            {
                id:"hw_oper_id_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Operator")), ""],
                footer:{content:"totalColumn"},
                sort:"string"
            },
            {
                id:"hw_belongs_to_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Owner")), ""],
                footer:{content:"totalColumn"},
                sort:"string"
            }
        ].concat(common.columns),
        leftSplit:1
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,13);
            params.columns = params.columns.slice(0,13);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,9);
            params.columns = params.columns.slice(0,10);
        }
        else if(Params.top_flow)
        {
            params.config.values = params.config.values.slice(0,10);
            params.columns = params.columns.slice(0,10);
        }
        else
        {
            params.config.values = params.config.values.slice(0,9);
            params.columns = params.columns.slice(0,10);
        }


        params.columns.push({
            id:"empty",
            header:"",
            fillspace:6
        });
    }

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = Col.func_cache ? Col.func_cache : "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetflowTopSwitchesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopSwitchesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopSwitchesWidget(params, Online);
};

var QoETableNetflowTopAccessSwitchesWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopAccessSwitchesWidget"}, Params, true);

    return QoETableNetflowTopSwitchesWidget(params);
};

var QoETableNetflowTopAccessSwitchesShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopAccessSwitchesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopSwitchesWidget(params);
};

var QoETableNetflowTopTrunkSwitchesWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrunkSwitchesWidget", type:2}, Params, true);

    return QoETableNetflowTopSwitchesWidget(params);
};

var QoETableNetflowTopTrunkSwitchesShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrunkSwitchesShortWidget", short:true, type:2}, Params, true);

    return QoETableNetflowTopSwitchesWidget(params);
};

var QoETableNetflowTopTrafficSwitchesWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableNetflowTopSwitchesWidget(params, Online);
};

var QoETableNetflowTopTrafficSwitchesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficSwitchesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficSwitchesWidget(params, Online);
};

var QoETableNetflowTopTrafficAccessSwitchesWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficAccessSwitchesWidget"}, Params, true);

    return QoETableNetflowTopTrafficSwitchesWidget(params);
};

var QoETableNetflowTopTrafficAccessSwitchesShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficAccessSwitchesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficSwitchesWidget(params);
};

var QoETableNetflowTopTrafficTrunkSwitchesWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficTrunkSwitchesWidget", type:2}, Params, true);

    return QoETableNetflowTopTrafficSwitchesWidget(params);
};

var QoETableNetflowTopTrafficTrunkSwitchesShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopTrafficTrunkSwitchesShortWidget", short:true, type:2}, Params, true);

    return QoETableNetflowTopTrafficSwitchesWidget(params);
};

var QoEPieChartTopRetransmitsSubscribersWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top subscribers with high retransmits"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopRetransmitsSubscribersWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                "subscriber"
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top subscribers with high retransmits"),
            pie_chart_key: "subscriber",
            locales: {
                "legend_title": "subscriber"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopRetransmitsSubscribersWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableTopSubscribersWidget(params, Online);
};

var QoETableTopRetransmitsSubscribersShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopRetransmitsSubscribersShortWidget", short:true}, Params, true);

    return QoETableTopRetransmitsSubscribersWidget(params, Online);
};

var QoEPieChartNetflowTopRetransmitsProtocolsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top application protocols with high retransmits"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopRetransmitsProtocolsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                "protocol"
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top application protocols with high retransmits"),
            pie_chart_key: "protocol",
            locales: {
                "legend_title": "protocol"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopRetransmitsProtocolsGroupsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top application protocols groups with high retransmits"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopRetransmitsProtocolsGroupsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                {col:"app_protocol_group_id", alias:"app_protocol_group_id", gui_dic:DicsEnum.ProtocolsGroupsDic}
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top application protocols groups with high retransmits"),
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            },
            pie_chart_key: "app_protocol_group_id",
            locales: {
                "legend_title": "group"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopRetransmitsProtocolsWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params, Online);
};

var QoETableNetflowTopRetransmitsProtocolsPercentWidget = function (Params)
{
    var params = webix.extend({percent:true, retransmits:true}, Params, true);

    return QoETableNetflowTopProtocolsWidget(params);
};

var QoETableNetflowTopRetransmitsProtocolsGroupsWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params, Online);
};

var QoETableNetflowTopRetransmitsProtocolsGroupsPercentWidget = function (Params)
{
    var params = webix.extend({percent:true, retransmits:true}, Params, true);

    return QoETableNetflowTopProtocolsGroupsWidget(params);
}

var QoETableNetflowTopRetransmitsProtocolsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsProtocolsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsProtocolsWidget(params, Online);
};

var QoETableNetflowTopRetransmitsProtocolsPercentShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopRetransmitsProtocolsPercentShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsProtocolsPercentWidget(params);
};

var QoETableNetflowTopRetransmitsProtocolsGroupsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsProtocolsGroupsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsProtocolsGroupsWidget(params, Online);
};

var QoETableNetflowTopRetransmitsProtocolsGroupsPercentShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopRetransmitsProtocolsGroupsPercentShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsProtocolsGroupsPercentWidget(params);
}

var QoEPieChartNetflowTopRetransmitsHostsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopRetransmitsHostsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                "host_other"
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top hosts with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "host_other",
            locales: {
                "legend_title": "host"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopRetransmitsHostsWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableNetflowTopHostsWidget(params, Online);
};

var QoETableNetflowTopRetransmitsHostsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsHostsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsHostsWidget(params, Online);
};

var QoETableNetflowTopRetransmitsHostsIPsWidget = function (Params)
{
    var params = webix.extend({top_retransmits:true, name:"QoETableNetflowTopRetransmitsHostsIPsWidget"}, Params, true);

    return QoETableNetflowTopHostsIPsWidget(params);
};

var QoETableNetflowTopRetransmitsHostsIPsShortWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true, name:"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsHostsIPsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopHostsIPsWidget(params, Online);
};

var QoEPieChartNetflowTopRetransmitsHostsIPsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name ? Params.name : "QoEPieChartNetflowTopRetransmitsHostsIPsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                "host_ip"
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "host_ip",
            locales: {
                "legend_title": "host_ips"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopRetransmitsHostCategoriesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top host categories with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopRetransmitsHostCategoriesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                {col:"host_category", alias:"host_category", gui_dic:DicsEnum.HostCategoriesDic}
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top host categories with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            values_dics: {
                "host_category": "HostCategoriesDic"
            },
            pie_chart_key: "host_category",
            locales: {
                "legend_title": "host_category"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopRetransmitsHostCategoriesWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableNetflowTopHostCategoriesWidget(params, Online);
};

var QoETableNetflowTopRetransmitsHostCategoriesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsHostCategoriesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsHostCategoriesWidget(params, Online);
};









var QoEPieChartNetflowTopRetransmitsSwitchesWidget = function (Params)
{
    var type = Params&&Params.type ? Params.type : 1;

    var params = {
        title:LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopRetransmitsSwitchesWidget_"+type,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            join:QoEReportViews.FullFlowSubsHwJoin,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.HwIp+"]", alias:"hw_ip"}],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where: {
                    "hw_ip":1
                }
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "hw_ip",
            locales: {
                "legend_title": "switch_ip_address"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopRetransmitsAccessSwitchesWidget = function (Params)
{
    var params = webix.extend(Params, {type:1, name:"QoEPieChartNetflowTopRetransmitsAccessSwitchesWidget"}, true);

    return QoEPieChartNetflowTopRetransmitsSwitchesWidget(params);
};

var QoEPieChartNetflowTopRetransmitsTrunkSwitchesWidget = function (Params)
{
    var params = webix.extend(Params, {type:2, name:"QoEPieChartNetflowTopRetransmitsTrunkSwitchesWidget"}, true);

    return QoEPieChartNetflowTopRetransmitsSwitchesWidget(params);
};

var QoETableNetflowTopRetransmitsSwitchesWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableNetflowTopSwitchesWidget(params, Online);
};

var QoETableNetflowTopRetransmitsSwitchesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsSwitchesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsSwitchesWidget(params, Online);
};

var QoETableNetflowTopRetransmitsAccessSwitchesWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopRetransmitsAccessSwitchesWidget"}, Params, true);

    return QoETableNetflowTopRetransmitsSwitchesWidget(params);
};

var QoETableNetflowTopRetransmitsAccessSwitchesShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopRetransmitsAccessSwitchesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsSwitchesWidget(params);
};

var QoETableNetflowTopRetransmitsTrunkSwitchesWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopRetransmitsTrunkSwitchesWidget", type:2}, Params, true);

    return QoETableNetflowTopRetransmitsSwitchesWidget(params);
};

var QoETableNetflowTopRetransmitsTrunkSwitchesShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopRetransmitsTrunkSwitchesShortWidget", short:true, type:2}, Params, true);

    return QoETableNetflowTopRetransmitsSwitchesWidget(params);
};


// TopFlow

var QoETableTopFlowSubscribersWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableTopSubscribersWidget(params, Online);
};

var QoETableTopFlowSubscribersShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopFlowSubscribersShortWidget", short:true}, Params, true);

    return QoETableTopFlowSubscribersWidget(params, Online);
};

var QoEPieChartTopFlowSubscribersWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top subscribers with high flow"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopFlowSubscribersWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                "subscriber"
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "flow":LangHelper.GetString("QoE", "Flow"),
                "subscriber":LangHelper.GetString("QoE", "Subscriber")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top subscribers with high flow"),
            pie_chart_key: "subscriber",
            locales: {
                "legend_title": "subscriber"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopFlowHostsWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableNetflowTopHostsWidget(params, Online);
};

var QoETableNetflowTopFlowHostsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowHostsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowHostsWidget(params, Online);
};

var QoEPieChartNetflowTopFlowHostsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopFlowHostsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                "host_other"
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top hosts with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "host_other",
            locales: {
                "legend_title": "host"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopFlowHostsIPsWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableNetflowTopHostsIPsWidget(params, Online);
};

var QoETableNetflowTopFlowHostsIPsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowHostsIPsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowHostsIPsWidget(params, Online);
};

var QoEPieChartNetflowTopFlowHostsIPsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopFlowHostsIPsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                "host_ip"
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "host_ip",
            locales: {
                "legend_title": "host_ips"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopFlowHostCategoriesWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableNetflowTopHostCategoriesWidget(params, Online);
};

var QoETableNetflowTopFlowHostCategoriesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowHostCategoriesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowHostCategoriesWidget(params, Online);
};

var QoEPieChartNetflowTopFlowHostCategoriesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top host categories with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartNetflowTopFlowHostCategoriesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                {col:"host_category", alias:"host_category", gui_dic:DicsEnum.HostCategoriesDic}
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top host categories with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            values_dics: {
                "host_category": "HostCategoriesDic"
            },
            pie_chart_key: "host_category",
            locales: {
                "legend_title": "host_category"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopFlowASsWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableNetflowTopASsWidget(params, Online);
};

var QoETableNetflowTopFlowASsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowASsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowASsWidget(params, Online);
};

var QoETableNetflowTopFlowSubscriberASsWidget = function (Params)
{
    var name = Params&&Params.name ? Params.name : "QoETableNetflowTopFlowSubscriberASsWidget"

    var params = webix.extend({name: name, type:"source", top_flow:true}, Params, true);

    return QoETableNetflowTopASsWidget(params);
};

var QoETableNetflowTopFlowSubscriberASsShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopFlowSubscriberASsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowSubscriberASsWidget(params);
};

var QoEPieChartNetflowTopFlowASsWidget = function (Params)
{
    var type = Params&&Params.type ? Params.type : "destination";

    var params = {
        title:LangHelper.GetString("QoE", "Top "+(type == "source" ? "subscriber`s " : "")+"AS with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopFlowASsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                type+"_asnum"
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top "+(type == "source" ? "subscriber`s " : "")+"AS with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: type+"_asnum",
            locales: {
                "legend_title": "as_number"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopFlowSubscribersASsWidget = function (Params)
{
    var params = webix.extend({type: "source"}, Params, true);

    return QoEPieChartNetflowTopFlowASsWidget(params);
}

var QoETableNetflowTopFlowSwitchesWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableNetflowTopSwitchesWidget(params, Online);
};

var QoETableNetflowTopFlowSwitchesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowSwitchesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowSwitchesWidget(params, Online);
};

var QoETableNetflowTopFlowTrunkSwitchesWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopFlowTrunkSwitchesWidget", type:2}, Params, true);

    return QoETableNetflowTopFlowSwitchesWidget(params);
};

var QoETableNetflowTopFlowTrunkSwitchesShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopFlowTrunkSwitchesShortWidget", short:true, type:2}, Params, true);

    return QoETableNetflowTopFlowSwitchesWidget(params);
};

var QoEPieChartNetflowTopFlowSwitchesWidget = function (Params)
{
    var type = Params&&Params.type ? Params.type : 1;

    var params = {
        title:LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopFlowSwitchesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            join:QoEReportViews.FullFlowSubsHwJoin,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.HwIp+"]", alias:"hw_ip"}],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where: {
                    "hw_ip":1
                }
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", type == 1 ? "Top switches" : "Top trunk switches") + " " + LangHelper.GetString("QoE","with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "hw_ip",
            locales: {
                "legend_title": "switch_ip_address"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopFlowTrunkSwitchesWidget = function (Params)
{
    var params = webix.extend({name: "QoEPieChartNetflowTopFlowTrunkSwitchesWidget", type:2}, Params, true);
    return QoEPieChartNetflowTopFlowSwitchesWidget(params);
}

var QoETableTopFlowClassesWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableTopClassesWidget(params, Online);
};

var QoETableTopFlowClassesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopFlowClassesShortWidget", short:true}, Params, true);

    return QoETableTopFlowClassesWidget(params, Online);
};

var QoETableTopFlowFullDscpClassesShortWidget = function (Params, Online)
{
    var params = webix.extend({
        name:"QoETable" + (Online ? "Online" : "") + "TopFlowFullDscpClassesShortWidget",
        title: LangHelper.GetString("QoE", "Top DSCP classes with high flow"),
        short:true,
        full_dscp:true
    }, Params, true);

    return QoETableTopFlowClassesWidget(params, Online);
};

var QoEPieChartTopFlowClassesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top classes with high flow"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopFlowClassesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                "ip_class_of_service_class"
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top classes with high flow"),
            pie_chart_key: "ip_class_of_service_class",
            locales: {
                "legend_title": "class"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopFlowGTPCellsWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableNetflowTopGTPCellsWidget(params, Online);
};

var QoETableNetflowTopFlowGTPCellsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowGTPCellsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowGTPCellsWidget(params, Online);
};

var QoEPieChartNetflowTopFlowGTPCellsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopFlowGTPCellsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            join:QoEReportViews.GtpFullFlowAggJoin,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:["cell_id"],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where: {
                    "cell_id":1,
                    "uli_eci":1,
                    "uli_mcc":1,
                    "uli_mnc":1,
                    "uli_tac":1
                }
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        filter:{
            "uli_mcc_filter":{id:"uli_mcc", operator:">", value:0, type:"UInt16"},
            "uli_mnc_filter":{id:"uli_mnc", operator:">", value:0, type:"UInt16"},
            "uli_tac_filter":{id:"uli_tac", operator:">", value:0, type:"UInt32"},
            "uli_eci_filter":{id:"uli_eci", operator:">", value:0, type:"UInt32"}
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high flow") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "cell_id",
            locales: {
                "legend_title": "id"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};








var QoEPieChartNetflowTopRetransmitsASsWidget = function (Params)
{
    var type = Params&&Params.type ? Params.type : "destination";

    var params = {
        title:LangHelper.GetString("QoE", "Top "+(type == "source" ? "subscriber`s " : "")+"AS with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopRetransmitsASsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                type+"_asnum"
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top "+(type == "source" ? "subscriber`s " : "")+"AS with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: type+"_asnum",
            locales: {
                "legend_title": "as_number"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoEPieChartNetflowTopRetransmitsSubscriberASsWidget = function (Params)
{
    var params = webix.extend(Params, {type:"source", name:"QoEPieChartNetflowTopRetransmitsSubscriberASsWidget"}, true);
    return QoEPieChartNetflowTopRetransmitsASsWidget(params);
};

var QoETableNetflowTopRetransmitsASsWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableNetflowTopASsWidget(params, Online);
};

var QoETableNetflowTopRetransmitsASsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsASsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsASsWidget(params, Online);
};

var QoETableNetflowTopRetransmitsSubscriberASsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopRetransmitsSubscriberASsWidget", type:"source", top_retransmits:true}, Params, true);

    return QoETableNetflowTopASsWidget(params);
};

var QoETableNetflowTopRetransmitsSubscriberASsShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableNetflowTopRetransmitsSubscriberASsShortWidget", type:"source", top_retransmits:true, short:true}, Params, true);

    return QoETableNetflowTopASsWidget(params);
};






var QoETableClickstreamTopCommonConfig = function (Params)
{
    return {
        values:
            [
                {col:"total_count", alias:"total", func:"countMerge"},
                {col:"session_id_uniq", alias:"sessons_uniq", func:"uniqMerge"},
                {col:"host", alias:"hosts_uniq", func:"uniq"},
                {col:"device_other", alias:"device_other_uniq", func:"uniq"},
                {col:"user_agent", alias:"user_agent_uniq", func:"uniq"},
                {col:"host_ip", alias:"host_ip_uniq", func:"uniq"},
                {col:"url", alias:"url_uniq", func:"uniq"},
                {col:"subscriber", alias:"subscribers_uniq", func:"uniq"},
                {col:"host_category", alias:"host_category_uniq", func:"uniq"},
                {col:"bridge_vchannel", alias:"bridge_vchannel_uniq", func:"uniq"},
                {col:"locked", alias:"locked_total", func:"countIf(locked, locked = 1)"}
            ],

        values_cache_old:
            [
                {col:"total_count", alias:"total", func:"countMergeState", func_cache:"countMerge"},
                {col:"session_id_uniq", alias:"sessons_uniq", func:"uniqMergeState", func_cache:"uniqMerge"},
                {col:"host", alias:"hosts_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"device_other", alias:"device_other_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"user_agent", alias:"user_agent_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"host_ip", alias:"host_ip_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"url", alias:"url_uniq", func:"uniqState", func_cache:"uniqMerge"},
                {col:"subscriber", alias:"subscribers_uniq", func:"uniqState", func_cache:"uniqMerge"}
            ],

        values_cache:
            [
                {col:"total_count", alias:"total", func:"countMerge", func_cache:"sum"},
                {col:"session_id_uniq", alias:"sessons_uniq", func:"uniqMerge", func_cache:"sum"},
                {col:"host", alias:"hosts_uniq", func:"uniq", func_cache:"sum"},
                {col:"device_other", alias:"device_other_uniq", func:"uniq", func_cache:"sum"},
                {col:"user_agent", alias:"user_agent_uniq", func:"uniq", func_cache:"sum"},
                {col:"host_ip", alias:"host_ip_uniq", func:"uniq", func_cache:"sum"},
                {col:"url", alias:"url_uniq", func:"uniq", func_cache:"sum"},
                {col:"subscriber", alias:"subscribers_uniq", func:"uniq", func_cache:"sum"},
                {col:"host_category", alias:"host_category_uniq", func:"sum"},
                {col:"bridge_vchannel", alias:"bridge_vchannel_uniq", func:"sum"},
                {col:"locked", alias:"locked_total", func:"countIf(locked, locked = 1)"}
            ],

        columns:
            [
                {
                    id:"total",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Total")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"sessons_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Sessions")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"hosts_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"device_other_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Devices")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"user_agent_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "User agents")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"host_ip_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"subscribers_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"url_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "URLs")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"host_category_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Host categories")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"bridge_vchannel_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannels")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"locked_total",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Locked total")), ""],
                    footer:{content:"totalColumn"},
                    sort:"string"
                }
            ],

        values_netflow:{
            fullflow_traffic:[
                {col:"octet_delta_count_from_subscriber_sum", alias:"traffic_vol_from_subscriber", func:"sumMerge"},
                {col:"octet_delta_count_to_subscriber_sum", alias:"traffic_vol_to_subscriber", func:"sumMerge"},
                {col:"octet_delta_count_sum", alias:"traffic_vol", func:"sumMerge"},

                {col:"", alias:"traffic_from_subscriber", func:QoEReportFunctions.ClickstreamAvgTrafficSpeedFromSubsBitsPerSecond},
                {col:"", alias:"traffic_to_subscriber", func:QoEReportFunctions.ClickstreamAvgTrafficSpeedToSubsBitsPerSecond},
                {col:"", alias:"traffic", func:QoEReportFunctions.ClickstreamAvgTrafficSpeedBitsPerSecond}
            ],
            fullflow_flow:[
                {col:"packet_delta_count_from_subscriber_sum", alias:"flow_vol_from_subscriber", func:"sumMerge"},
                {col:"packet_delta_count_to_subscriber_sum", alias:"flow_vol_to_subscriber", func:"sumMerge"},
                {col:"packet_delta_count_sum", alias:"flow_vol", func:"sumMerge"},

                {col:"", alias:"flow_from_subscriber", func:QoEReportFunctions.ClickstreamAvgTrafficSpeedFromSubsPkts},
                {col:"", alias:"flow_to_subscriber", func:QoEReportFunctions.ClickstreamAvgTrafficSpeedToSubsPkts},
                {col:"", alias:"flow", func:QoEReportFunctions.ClickstreamAvgTrafficSpeedPkts}
            ],
            fullflow_rtt:[
                {col:"rtt_from_subscriber_median", alias:"rtt_from_subscriber_median", func:"medianMerge"},
                {col:"rtt_to_subscriber_median", alias:"rtt_to_subscriber_median", func:"medianMerge"},
                {col:"rtt_median", alias:"rtt_median", func:"medianMerge"}
            ]
        },

        columns_netflow:{
            fullflow_traffic:[
                {
                    id:"traffic",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic from subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic to subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_vol",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.FileSizeUnits
                },
                {
                    id:"traffic_vol_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume from subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.FileSizeUnits
                },
                {
                    id:"traffic_vol_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume to subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.FileSizeUnits
                }
            ],
            fullflow_flow:[
                {
                    id:"flow",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow from subscribers")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow to subscribers")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_vol",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow volume")+", "+LangHelper.GetString("Dics", "Pkts")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.PacketsUnits
                },
                {
                    id:"flow_vol_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow volume from subscribers")+", "+LangHelper.GetString("Dics", "Pkts")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.PacketsUnits
                },
                {
                    id:"flow_vol_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow volume to subscribers")+", "+LangHelper.GetString("Dics", "Pkts")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.PacketsUnits
                }
            ],
            fullflow_rtt:[
                {
                    id:"rtt_median",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT")+", "+LangHelper.GetString("QoE", "ms")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.SimpleTimeUnits
                },
                {
                    id:"rtt_from_subscriber_median",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT from subscriber")+", "+LangHelper.GetString("QoE", "ms")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.SimpleTimeUnits
                },
                {
                    id:"rtt_to_subscriber_median",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT to subscriber")+", "+LangHelper.GetString("QoE", "ms")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data: UnitsFormatData.SimpleTimeUnits
                }
            ]
        }
    };
};

var QoEPieChartClickstreamTopHostsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartClickstreamTopHostsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"}
            ],
            rows:[
                "host_other"
            ],
            sort:{id:"total",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top hosts") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
            pie_chart_key: "host_other",
            locales: {
                "legend_title": "host"
            }
        }

    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableClickstreamTopHostsWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top hosts") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostsBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top hosts") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostsByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top hosts") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostsByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top hosts") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostsByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top hosts") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostsWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top hosts") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostsWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:view,
            values:[
                {col:"host_category", alias:"host_category_any", func:"anyLast"},
                {col:"", alias:"host_category_description", func:"dictGetString('urlcats_dic', 'description', host_category_any)"}
            ].concat(values),
            rows:[
                "host_other"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_where:0,
                use_size:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:[
            {
                id:"host_other",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            },
            {
                id:"host_category_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host category")), ""],
                template:function(Obj)
                {
                    var dic = App.DicsManager.GetDic(DicsEnum.HostCategoriesDic);

                    return dic && dic[Obj.host_category_any] ? LangHelper.GetString("QoE", dic[Obj.host_category_any].value) : LangHelper.GetString("QoE", "hcn_undefined");
                },
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            }
        ].concat(columns),
        leftSplit:2,
        enableRowContextMenu:true,
        export_pdf_config: {
            values_dics: {
                "host_category_any": "HostCategoriesDic",
                "host_category_description": "ClsfrCategoriesDic"
            }
        }
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopHostsBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostsBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopHostsWidget(params);
};

var QoETableClickstreamTopHostsByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostsByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopHostsWidget(params);
};

var QoETableClickstreamTopHostsByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostsByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopHostsWidget(params);
};

var QoETableClickstreamTopHostsByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostsByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopHostsWidget(params);
};

var QoEPieChartClickstreamTopSubscribersWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top subscribers") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartClickstreamTopSubscribersWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"}
            ],
            rows:[
                "subscriber"
            ],
            sort:{id:"total",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top subscribers") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
            pie_chart_key: "subscriber",
            locales: {
                "legend_title": "subscriber"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableClickstreamTopSubscribersWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top subscribers") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopSubscribersBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top subscribers") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopSubscribersByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top subscribers") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopSubscribersByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top subscribers") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopSubscribersByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top subscribers") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopSubscribersWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top subscribers") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopSubscribersWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:
            [
                //{col:"login", alias:"login_any",func:"anyState(login)", func_cache:"anyMerge(login_any)"}
                {col:"login", alias:"login_any",func:"any"}
            ].concat(values),
            rows:[
                "subscriber"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                },
                {
                    id:"login",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    template:function(Obj)
                    {
                        return Obj.login_any;
                    },
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                }
            ].concat(columns),
        leftSplit:2,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        sort_map:{"login":"login_any"},
        can_use_sort_map:{
            "ReportsSettings": 1
        }
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopSubscribersBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopSubscribersBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopSubscribersWidget(params);
};

var QoETableClickstreamTopSubscribersByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopSubscribersByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopSubscribersWidget(params);
};

var QoETableClickstreamTopSubscribersByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopSubscribersByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopSubscribersWidget(params);
};

var QoETableClickstreamTopSubscribersByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopSubscribersByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopSubscribersWidget(params);
};

var QoEPieChartClickstreamTopDevicesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top devices") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartClickstreamTopDevicesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"}
            ],
            rows:[
                "device_other"
            ],
            sort:{id:"total",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top devices") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
            pie_chart_key: "device_other",
            locales: {
                "legend_title": "device"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableClickstreamTopDevicesWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top devices") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopDevicesBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top devices") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopDevicesByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top devices") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopDevicesByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top devices") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopDevicesByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top devices") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopDevicesWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top devices") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopDevicesWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:values,
            rows:[
                "device_other"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"device_other",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Device")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:true,
                    sort:"string",
                    minWidth:160,
                    footer:{content:"totalRows"}
                }
            ].concat(columns),
        leftSplit:1,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopDevicesBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopDevicesBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopDevicesWidget(params);
};

var QoETableClickstreamTopDevicesByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopDevicesByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopDevicesWidget(params);
};

var QoETableClickstreamTopDevicesByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopDevicesByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopDevicesWidget(params);
};

var QoETableClickstreamTopDevicesByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopDevicesByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopDevicesWidget(params);
};

var QoEPieChartClickstreamTopHostIpsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top hosts IPs") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartClickstreamTopHostIpsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"}
            ],
            rows:[
                "host_ip"
            ],
            sort:{id:"total",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top hosts IPs") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
            pie_chart_key: "host_ip",
            locales: {
                "legend_title": "host_ips"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableClickstreamTopHostIpsWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostIpsBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostIpsByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostIpsByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostIpsByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top hosts IPs") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostIpsWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top hosts IPs") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostIpsWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:values,
            rows:[
                "host_ip"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"host_ip",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Host IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:true,
                    sort:"string",
                    minWidth:160,
                    footer:{content:"totalRows"}
                }
            ].concat(columns),
        leftSplit:1,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopHostIpsBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostIpsBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopHostIpsWidget(params);
};

var QoETableClickstreamTopHostIpsByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostIpsByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopHostIpsWidget(params);
};

var QoETableClickstreamTopHostIpsByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostIpsByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopHostIpsWidget(params);
};

var QoETableClickstreamTopHostIpsByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostIpsByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopHostIpsWidget(params);
};

var QoEPieChartClickstreamTopUrlsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top URLs") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartClickstreamTopUrlsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"}
            ],
            rows:[
                "url"
            ],
            sort:{id:"total",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top URLs") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
            pie_chart_key: "url",
            locales: {
                "legend_title": "url"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableClickstreamTopUrlsWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top URLs") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopUrlsBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top URLs") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopUrlsByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top URLs") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopUrlsByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top URLs") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopUrlsByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top URLs") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopUrlsWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top URLs") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopUrlsWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:values,
            rows:[
                "url"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"url",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Url")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:true,
                    sort:"string",
                    minWidth:160,
                    footer:{content:"totalRows"}
                }
            ].concat(columns),
        leftSplit:1,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopUrlsBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopUrlsBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopUrlsWidget(params);
};

var QoETableClickstreamTopUrlsByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopUrlsByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopUrlsWidget(params);
};

var QoETableClickstreamTopUrlsByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopUrlsByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopUrlsWidget(params);
};

var QoETableClickstreamTopUrlsByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopUrlsByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopUrlsWidget(params);
};

var QoEPieChartClickstreamTopHostCategoriesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top host categories") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartClickstreamTopHostsCategoriesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"}
            ],
            rows:[
                {col:"host_category", alias:"host_category", gui_dic:DicsEnum.HostCategoriesDic}
            ],
            sort:{id:"total",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top host categories") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
            values_dics: {
                "host_category": "HostCategoriesDic"
            },
            pie_chart_key: "host_category",
            locales: {
                "legend_title": "host_category"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableClickstreamTopHostCategoriesWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top host categories") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostCategoriesBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top host categories") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostCategoriesByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top host categories") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostCategoriesByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top host categories") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostCategoriesByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top host categories") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostCategoriesWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top host categories") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopHostCategoriesWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"", alias:"host_category_description", func:"dictGetString('urlcats_dic', 'description', host_category)"}
            ].concat(values),
            rows:[
                "host_category"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"host_category",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Host category")), ""],
                    template:function(Obj)
                    {
                        var dic = App.DicsManager.GetDic(DicsEnum.HostCategoriesDic);

                        return dic && dic[Obj.host_category] ? LangHelper.GetString("QoE", dic[Obj.host_category].value) : LangHelper.GetString("QoE", "hcn_undefined");
                    },
                    fillspace:true,
                    sort:"string",
                    minWidth:160,
                    footer:{content:"totalRows"}
                }
            ].concat(columns),
        leftSplit:1,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        export_pdf_config: {
            values_dics: {
                "host_category": "HostCategoriesDic"
            }
        }
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopHostCategoriesBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostCategoriesBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopHostCategoriesWidget(params);
};

var QoETableClickstreamTopHostCategoriesByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostCategoriesByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopHostCategoriesWidget(params);
};

var QoETableClickstreamTopHostCategoriesByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostCategoriesByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopHostCategoriesWidget(params);
};

var QoETableClickstreamTopHostCategoriesByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopHostCategoriesByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopHostCategoriesWidget(params);
};





var QoETableClickstreamTopAgentsWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top user agents") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopAgentsBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top user agents") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopAgentsByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top user agents") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopAgentsByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top user agents") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopAgentsByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top user agents") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopAgentsWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top user agents") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopAgentsWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:values,
            rows:[
                "user_agent_other"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"user_agent_other",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "User agent")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:true,
                    sort:"string",
                    minWidth:160,
                    footer:{content:"totalRows"}
                }
            ].concat(columns),
        leftSplit:1,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopAgentsBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopAgentsBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopAgentsWidget(params);
};

var QoETableClickstreamTopAgentsByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopAgentsByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopAgentsWidget(params);
};

var QoETableClickstreamTopAgentsByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopAgentsByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopAgentsWidget(params);
};

var QoETableClickstreamTopAgentsByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopAgentsByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopAgentsWidget(params);
};







var QoETableClickstreamRawLogWidget = function (Params)
{
    var values = {
        time_part:[
            {col:"date"},
            {col:"time"}
        ],
        main_part:[
            {col:"session_id"},
            {col:"login"},
            {col:"source_ipv4"},
            {col:"source_ipv6"},
            {col:"destination_ipv4"},
            {col:"destination_ipv6"},
            {col:"host"},
            {col:"bridge_vchannel"},
            {col:"dpi_id"}
        ],
        meta_part:[
            {col:"path"},
            {col:"referal"},
            {col:"user_agent"},
            {col:"cookie"}
        ],
        http_headers_part:[
            {col:"method"},
            {col:"result_code"},
            {col:"content_length"},
            {col:"content_type"},
            {col:"locked"},
            {col:"host_type"}
        ],
        fullflow_traffic:[
            {col:"traffic_vol_from_subscriber"},
            {col:"traffic_vol_to_subscriber"},
            {col:"traffic_vol"},

            {col:"", alias:"traffic_from_subscriber", func:QoEReportFunctions.RawClickstreamAvgTrafficSpeedFromSubsBitsPerSecond},
            {col:"", alias:"traffic_to_subscriber", func:QoEReportFunctions.RawClickstreamAvgTrafficSpeedToSubsBitsPerSecond},
            {col:"", alias:"traffic", func:QoEReportFunctions.RawClickstreamAvgTrafficSpeedBitsPerSecond},
        ],
        fullflow_flow:[
            {col:"flow_vol_from_subscriber"},
            {col:"flow_vol_to_subscriber"},
            {col:"flow_vol"},

            {col:"", alias:"flow_from_subscriber", func:QoEReportFunctions.RawClickstreamAvgTrafficSpeedFromSubsPkts},
            {col:"", alias:"flow_to_subscriber", func:QoEReportFunctions.RawClickstreamAvgTrafficSpeedToSubsPkts},
            {col:"", alias:"flow", func:QoEReportFunctions.RawClickstreamAvgTrafficSpeedPkts}
        ],
        fullflow_rtt:[
            {col:"rtt_from_subscriber_median"},
            {col:"rtt_to_subscriber_median"},
            {col:"rtt_median"}
        ]
    };

    var columns = {
        time_part:[
            {
                id:"date", header:[TooltipTemplate(LangHelper.GetString("QoE", "Date")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"time", header:[TooltipTemplate(LangHelper.GetString("QoE", "Time")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            }
        ],
        main_part:[
            {
                id:"session_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Session ID")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"login", header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"source_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source IPv4-address")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"source_ipv6", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source IPv6-address")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"destination_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination IPv4-address")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"destination_ipv6", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination IPv6-address")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"bridge_vchannel", header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannel/Bridge")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"dpi_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            }
        ],
        meta_part:[
            {
                id:"path", header:[TooltipTemplate(LangHelper.GetString("QoE", "Path")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"referal", header:[TooltipTemplate(LangHelper.GetString("QoE", "Referer")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"user_agent", header:[TooltipTemplate(LangHelper.GetString("QoE", "User agent")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"cookie", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cookie")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            }
        ],
        http_headers_part:[
            {
                id:"method", header:[TooltipTemplate(LangHelper.GetString("QoE", "Method")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"result_code", header:[TooltipTemplate(LangHelper.GetString("QoE", "Result code")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"content_length", header:[TooltipTemplate(LangHelper.GetString("QoE", "Content length")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"content_type", header:[TooltipTemplate(LangHelper.GetString("QoE", "Content type")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"locked", header:[TooltipTemplate(LangHelper.GetString("QoE", "Locked")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"host_type", header:[TooltipTemplate(LangHelper.GetString("QoE", "Host type")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            }
        ],
        fullflow_traffic:[
            {
                id:"traffic",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                format:webix.i18n.intFormat,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.TrafficSpeedBitUnits
            },
            {
                id:"traffic_from_subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic from subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.TrafficSpeedBitUnits
            },
            {
                id:"traffic_to_subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic to subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.TrafficSpeedBitUnits
            },
            {
                id:"traffic_vol",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                format:webix.i18n.intFormat,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.FileSizeUnits
            },
            {
                id:"traffic_vol_from_subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume from subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.FileSizeUnits
            },
            {
                id:"traffic_vol_to_subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume to subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.FileSizeUnits
            }
        ],
        fullflow_flow:[
            {
                id:"flow",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                format:webix.i18n.intFormat,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.NetFlowSpeedUnits
            },
            {
                id:"flow_from_subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow from subscribers")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.NetFlowSpeedUnits
            },
            {
                id:"flow_to_subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow to subscribers")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.NetFlowSpeedUnits
            },
            {
                id:"flow_vol",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow volume")+", "+LangHelper.GetString("Dics", "Pkts")), ""],
                format:webix.i18n.intFormat,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.PacketsUnits
            },
            {
                id:"flow_vol_from_subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow volume from subscribers")+", "+LangHelper.GetString("Dics", "Pkts")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.PacketsUnits
            },
            {
                id:"flow_vol_to_subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow volume to subscribers")+", "+LangHelper.GetString("Dics", "Pkts")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.PacketsUnits
            }
        ],
        fullflow_rtt:[
            {
                id:"rtt_median",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT")+", "+LangHelper.GetString("QoE", "ms")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.SimpleTimeUnits
            },
            {
                id:"rtt_from_subscriber_median",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT from subscriber")+", "+LangHelper.GetString("QoE", "ms")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.SimpleTimeUnits
            },
            {
                id:"rtt_to_subscriber_median",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT to subscriber")+", "+LangHelper.GetString("QoE", "ms")), ""],
                format:webix.i18n.intFormat,
                //fillspace:1,
                footer:{content:"totalColumn"},
                sort:"string",
                units_format_data: UnitsFormatData.SimpleTimeUnits
            }
        ]
    };

    var title, name, sort;

    var view = QoEReportViews.RawClickstream;

    if(Params&&Params.with_fullflow)
    {
        view = QoEReportViews.RawClickstreamWithFullflow;

        values = [].concat.apply([], [values.time_part, values.main_part, values.meta_part, values.http_headers_part, values.fullflow_rtt, values.fullflow_traffic, values.fullflow_flow]);

        columns = [].concat.apply([], [columns.time_part, columns.main_part, columns.meta_part, columns.http_headers_part, columns.fullflow_rtt, columns.fullflow_traffic, columns.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Raw clickstream") + " " + LangHelper.GetString("QoE", "With netflow").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableClickstreamRawLogAsIsWidget");

        sort =  "time";
    }
    else
    {
        values = [].concat.apply([], [values.time_part, values.main_part, values.meta_part, values.http_headers_part]);

        columns = [].concat.apply([], [columns.time_part, columns.main_part, columns.meta_part, columns.http_headers_part]);

        title = LangHelper.GetString("QoE", "Raw clickstream");

        name = Params&&Params.name?Params.name : ("QoETableClickstreamRawLogAsIsWidget");

        sort =  "time";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamRaw,
            view:view,
            values:values,
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_sort:0
            },
            limit:1000000,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:false,
        columns:columns,
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamRawLogAsIsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamRawLogAsIsWidget", as_is:true}, Params, true);

    return QoETableClickstreamRawLogWidget(params);
};

var QoETableClickstreamRawLogWithFullflowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamRawLogWithFullflowWidget", with_fullflow:true}, Params, true);

    return QoETableClickstreamRawLogWidget(params);
};

var QoETableFullflowRawLogWidget = function (Params, Online)
{
    var values = {
       time_part:[
           {col:"time"},
           {col:"flow_end_time"}
       ],
       main_part:[
           {col:"session_id"},
           {col:"source_ipv4"},
           {col:"source_ipv6"},
           {col:"source_port"},
           {col:"bgp_source_as_number"},
           {col:"destination_ipv4"},
           {col:"destination_ipv6"},
           {col:"destination_port"},
           {col:"bgp_destination_as_number"},
           {col:"login"}
       ],
       subscriber_part:[
           {col:"source_asnum"},
           {col:"destination_asnum"},
           {col:"source_astitle"},
           {col:"destination_astitle"},
           {col:"subscriber"},
           {col:"host_ip"},
           {col:"host"}
       ],
       usefull_data_part:[
           {col:"net_protocol"},
           {col:"app_protocol_group_id"},
           {col:"", alias:"app_protocol_group_description", func:"dictGetString('protocols_groups_dic', 'description', app_protocol_group_id)"},
           {col:"app_protocol"},
           {col:"octet_delta_count"},
           {col:"packet_delta_count"},
           {col:"frgmt_delta_packs"},
           {col:"repeat_delta_pack"},
           {col:"packet_deliver_time"}
       ],
       blocked_data_part:[
           {col:"blocked"},
           {col:"dropped_bytes"},
           {col:"dropped_packets"},
       ],
       other_data_part:[
           {col:"flow_start_millisecond"},
           {col:"flow_end_millisecond"},
           {col:"ip_class_of_service_class"},
           {col:"ip_class_of_service_full"},
           {col:"input_snmp"},
           {col:"output_snmp"},
           {col:"ip_version"},
           {col:"post_nat_source_ipv4"},
           {col:"post_nat_source_port"},
           {col:"bridge_vchannel"},
           {col:"vlan_id"},
           {col:"post_vlan_id"},
           {col:"dpi_id"},
           {col:"mpls_labels"},
           {col:"duration"},

           {col:"service_flags"},
           {col:"detection_flags"},
           {col:"action_flags"},

           {col:"ttl"},
           {col:"rating_group"}
       ]
   };

    var columns = {
       time_part:[
           {
               id:"time", header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow start time")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"flow_end_time", header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow end time")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           }
       ],
       main_part:[
           {
               id:"session_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Session ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"source_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source IPv4-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"source_ipv6", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source IPv6-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"source_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"bgp_source_as_number", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source AS")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"destination_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination IPv4-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"destination_ipv6", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination IPv6-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"destination_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"bgp_destination_as_number", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination AS")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"login", header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           }
       ],
       subscriber_part:[
           {
               id:"subscriber", header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"source_asnum", header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber`s AS number")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"host_ip", header:[TooltipTemplate(LangHelper.GetString("QoE", "Host IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"destination_asnum", header:[TooltipTemplate(LangHelper.GetString("QoE", "Host`s AS number")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"net_protocol", header:[TooltipTemplate(LangHelper.GetString("QoE", "Net protocol")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"app_protocol", header:[TooltipTemplate(LangHelper.GetString("QoE", "Application protocol")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id: "app_protocol_group_id",
               width: 160,
               header: [
                   LangHelper.GetString("DpiDscpConfig", "Group"),
                   {
                       content: "multiSelectFilter",
                       options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                       inputConfig: {suggest: {fitMaster: false}}
                   }
               ],
               filterMap: {
                   id: "app_protocol_group_id",
                   operator: "in",
                   value: function(Val)
                   {
                       if(Val)
                       {
                           var arr = Val.split(",");

                           return arr;
                       }
                       return null;
                   }
               },
               template: function(obj){

                   var str = "";

                   if(obj && obj.app_protocol_group_id != null)
                   {
                       var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.app_protocol_group_id});

                       if(group)
                       {
                           str = group.value;
                       }
                   }
                   return str;
               }
           }
       ],
       usefull_data_part:[
           {
               id:"octet_delta_count", header:[TooltipTemplate(LangHelper.GetString("QoE", "Octet delta")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"packet_delta_count", header:[TooltipTemplate(LangHelper.GetString("QoE", "Packet delta")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"frgmt_delta_packs", header:[TooltipTemplate(LangHelper.GetString("QoE", "Fragmented packets delta")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"repeat_delta_pack", header:[TooltipTemplate(LangHelper.GetString("QoE", "Repeated packets delta")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"packet_deliver_time", header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           }
       ],
       blocked_data_part:[
           {
               id:"blocked", header:[TooltipTemplate(LangHelper.GetString("QoE", "Locked")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"dropped_bytes", header:[TooltipTemplate(LangHelper.GetString("QoE", "Dropped bytes")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"dropped_packets", header:[TooltipTemplate(LangHelper.GetString("QoE", "Dropped packets")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
       ],
       other_data_part:[
           {
               id:"flow_start_millisecond", header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow start time in milliseconds")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string",
           },
           {
               id:"flow_end_millisecond", header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow end time in milliseconds")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string",
           },
           {
               id:"duration", header:[TooltipTemplate(LangHelper.GetString("QoE", "Duration in milliseconds")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"ip_class_of_service_class", header:[TooltipTemplate(LangHelper.GetString("QoE", "Service class")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"ip_class_of_service_full", header:[TooltipTemplate(LangHelper.GetString("QoE", "DSCP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"input_snmp", header:[TooltipTemplate(LangHelper.GetString("QoE", "Input SNMP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"output_snmp", header:[TooltipTemplate(LangHelper.GetString("QoE", "Output SNMP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"ip_version", header:[TooltipTemplate(LangHelper.GetString("QoE", "IP version")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"post_nat_source_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Post nat source IPv4-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"post_nat_source_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Post nat source port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"bridge_vchannel", header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannel/Bridge")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"vlan_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Vlan ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"post_vlan_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Post vlan ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"dpi_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"mpls_labels", header:[TooltipTemplate(LangHelper.GetString("QoE", "MPLS labels")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },

           {
               id:"service_flags", header:[TooltipTemplate(LangHelper.GetString("QoE", "Service flags")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"detection_flags", header:[TooltipTemplate(LangHelper.GetString("QoE", "Detection flags")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"action_flags", header:[TooltipTemplate(LangHelper.GetString("QoE", "Action flags")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },

           {
               id:"ttl", header:[TooltipTemplate(LangHelper.GetString("QoE", "TTL")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           },
           {
               id:"rating_group", header:[TooltipTemplate(LangHelper.GetString("QoE", "Rating group")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
           }
       ]
   };

    var title, name, sort;

    if(Params&&Params.short)
    {
        values = [].concat.apply([], [values.time_part, values.main_part, values.usefull_data_part]);

        columns = [].concat.apply([], [columns.time_part, columns.main_part, columns.usefull_data_part]);

        title = LangHelper.GetString("QoE", "Short raw log");

        name = Params&&Params.name?Params.name : (Online ? "QoETableOnlineFullflowRawLogShortWidget" : "QoETableFullflowRawLogShortWidget");

        sort =  "time";
    }
    else if(Params&&Params.subscriber)
    {
        values = [].concat.apply([], [values.time_part, values.subscriber_part, values.usefull_data_part]);

        columns = [].concat.apply([], [columns.time_part, columns.subscriber_part, columns.usefull_data_part]);

        title = LangHelper.GetString("QoE", "Subscriber raw log");

        name = Params&&Params.name?Params.name : (Online ? "QoETableOnlineFullflowRawLogSubscriberWidget" : "QoETableFullflowRawLogSubscriberWidget");

        sort =  "time";
    }
    else
    {
        values = [].concat.apply([], [values.time_part, values.main_part, values.subscriber_part, values.usefull_data_part, values.other_data_part, values.blocked_data_part]);

        columns = [].concat.apply([], [columns.time_part, columns.main_part, columns.subscriber_part, columns.usefull_data_part, columns.other_data_part, columns.blocked_data_part]);

        title = LangHelper.GetString("QoE", "Full raw log");

        name = Params&&Params.name?Params.name : (Online ? "QoETableOnlineFullflowRawLogWidget" : "QoETableFullflowRawLogWidget");

        sort =  "time";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowRaw,
            view:Online ? QoEReportViews.OnlineRawFullFlow : QoEReportViews.RawFullFlow,
            values:values,
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_sort:0
            },
            limit:1000000,
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:false,
        columns:columns,
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        export_pdf_config: {
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            }
        }
    };

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableFullflowRawLogShortWidget = function (Params)
{
    var params = webix.extend({name:"QoETableFullflowRawLogShortWidget", short:true}, Params, true);

    return QoETableFullflowRawLogWidget(params);
};

var QoETableFullflowRawLogSubscriberWidget = function (Params)
{
    var params = webix.extend({name:"QoETableFullflowRawLogSubscriberWidget", subscriber:true}, Params, true);

    return QoETableFullflowRawLogWidget(params);
};

var QoETableFullflowRawCommon = function ()
{
    return {
        values:{
            top_subscribers_hosts:[
                {col:"", alias:"sessions_uniq", func:"uniq(session_id)"},
                {col:"", alias:"subscribers_uniq", func:"uniq(subscriber)"},
                {col:"", alias:"logins_uniq", func:"uniq(login)"},
                {col:"", alias:"host_ips_uniq", func:"uniq(host_ip)"},
                {col:"", alias:"hosts_uniq", func:"uniq(host)"}
            ],
            top_session_lifetime:[

                {col:"", alias:"avg_ses_lifetime", func:"avg(session_lifetime)"},
                {col:"", alias:"avg_ses_lifetime_from_subscriber", func:"avgIf(session_lifetime, from_subscriber == 1)"},
                {col:"", alias:"avg_ses_lifetime_to_subscriber", func:"avgIf(session_lifetime, from_subscriber == 0)"},
                {col:"", alias:"min_ses_lifetime", func:"min(session_lifetime)"},
                {col:"", alias:"max_ses_lifetime", func:"max(session_lifetime)"}
            ],
            top_traffic:[
                {col:"", alias:"traffic", func:QoEReportFunctions.RawAvgTrafficSpeedBitsPerSecond},
                {col:"", alias:"traffic_from_subscriber", func:QoEReportFunctions.RawAvgTrafficSpeedFromSubsBitsPerSecond},
                {col:"", alias:"traffic_to_subscriber", func:QoEReportFunctions.RawAvgTrafficSpeedToSubsBitsPerSecond},
                {col:"", alias:"traffic_vol", func:QoEReportFunctions.RawTrafficVoumeBytes},
                {col:"", alias:"traffic_vol_from_subscriber", func:QoEReportFunctions.RawTrafficVoumeFromSubsBytes},
                {col:"", alias:"traffic_vol_to_subscriber", func:QoEReportFunctions.RawTrafficVoumeToSubsBytes}
            ],
            top_flow:[
                {col:"", alias:"flow", func:QoEReportFunctions.RawAvgTrafficSpeedPktsPerSecond},
                {col:"", alias:"flow_from_subscriber", func:QoEReportFunctions.RawAvgTrafficSpeedFromSubsPktsPerSecond},
                {col:"", alias:"flow_to_subscriber", func:QoEReportFunctions.RawAvgTrafficSpeedToSubsPktsPerSecond},
                {col:"", alias:"flow_vol", func:QoEReportFunctions.RawTrafficVoumePkts},
                {col:"", alias:"flow_vol_from_subscriber", func:QoEReportFunctions.RawTrafficVoumeFromSubsPkts},
                {col:"", alias:"flow_vol_to_subscriber", func:QoEReportFunctions.RawTrafficVoumeToSubsPkts}
            ]
        },
        columns:{
            top_subscribers_hosts:[
                {
                    id:"sessions_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Sessions")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"subscribers_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"logins_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Logins")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"host_ips_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"hosts_uniq",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                }
            ],
            top_session_lifetime:[
                {
                    id:"avg_ses_lifetime",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Session lifetime")+", "+LangHelper.GetString("Dics", "ms")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"avg_ses_lifetime_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Session lifetime") + " " + LangHelper.GetString("QoE", "From subscriber").toLowerCase() +", "+LangHelper.GetString("Dics", "ms")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"avg_ses_lifetime_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Session lifetime") + " " + LangHelper.GetString("QoE", "To subscriber").toLowerCase() +", "+LangHelper.GetString("Dics", "ms")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"min_ses_lifetime",
                    header:[TooltipTemplate("Min " + LangHelper.GetString("QoE", "Session lifetime").toLowerCase()+", "+LangHelper.GetString("Dics", "ms")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                },
                {
                    id:"max_ses_lifetime",
                    header:[TooltipTemplate("Max " + LangHelper.GetString("QoE", "Session lifetime").toLowerCase()+", "+LangHelper.GetString("Dics", "ms")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string"
                }
            ],
            top_traffic:[
                {
                    id:"traffic",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic from subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic to subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                },
                {
                    id:"traffic_vol",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits
                },
                {
                    id:"traffic_vol_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume from subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits
                },
                {
                    id:"traffic_vol_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic volume to subscribers")+", "+LangHelper.GetString("Dics", "Bytes")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.FileSizeUnits
                }
            ],
            top_flow:[
                {
                    id:"flow",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow from subscribers")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow to subscribers")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.NetFlowSpeedUnits
                },
                {
                    id:"flow_vol",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow volume")+", "+LangHelper.GetString("Dics", "Pkts")), ""],
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.PacketsUnits
                },
                {
                    id:"flow_vol_from_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow volume from subscribers")+", "+LangHelper.GetString("Dics", "Pkts")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.PacketsUnits
                },
                {
                    id:"flow_vol_to_subscriber",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow volume to subscribers")+", "+LangHelper.GetString("Dics", "Pkts")), ""],
                    format:webix.i18n.intFormat,
                    //fillspace:1,
                    footer:{content:"totalColumn"},
                    sort:"string",
                    units_format_data:UnitsFormatData.PacketsUnits
                }
            ]
        }
    };
};

var QoETableFullflowRawTopProtocolsWidget = function (Params)
{
    var netProtocol = Params&&Params.net_protocol;

    var common = QoETableFullflowRawCommon();

    var values = common.values;

    var columns = common.columns;

    var title, name, sort;

    var view = QoEReportViews.RawFullFlow;

    if(Params && Params.top_subscribers_hosts)
    {
        values = [].concat(values.top_subscribers_hosts); columns = [].concat(columns.top_subscribers_hosts);

        title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols") + " " + LangHelper.GetString("QoE", "By subscribers and hosts").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopSubsHosts" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

        sort =  "subscribers_uniq";
    }
    else if(Params && Params.top_traffic)
    {
        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_traffic); columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_traffic);

        title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopTraffic" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

        sort =  "traffic";
    }
    else if(Params && Params.top_flow)
    {
        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_flow); columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_flow);

        title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopFlow" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

        sort =  "flow";
    }
    else if(Params && Params.top_session_lifetime)
    {
        view = QoEReportViews.RawFullFlowWithSessionLifeTime;

        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_session_lifetime); columns = columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_session_lifetime);

        title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols") + " " + LangHelper.GetString("QoE", "By session lifetime").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopSesLifetime" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

        sort =  "avg_ses_lifetime";
    }
    else
    {
        view = QoEReportViews.RawFullFlowWithSessionLifeTime;

        var v = [], c = [];

        Object.keys(values).forEach(function (Key)
        {
            v = v.concat(values[Key]);
        });

        Object.keys(columns).forEach(function (Key)
        {
            c = c.concat(columns[Key]);
        });

        values = v; columns = c;

        title = LangHelper.GetString("QoE", "Top" + (!netProtocol ? " application" : "") + " protocols") + " (maxi)";

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTop" + (netProtocol ? "Net" : "") + "ProtocolsWidget");

        sort =  "avg_ses_lifetime";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowRaw,
            view:view,
            values:[
                {col:"", alias:"app_protocol_group_description", func:"dictGetString('protocols_groups_dic', 'description', app_protocol_group_id)"},
            ].concat(values),
            rows:netProtocol ? (["net_protocol"]):(["app_protocol" , "app_protocol_group_id"]),
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:function(){
            var result = [{
                id:netProtocol ? "net_protocol" : "app_protocol",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Protocol")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                minWidth:160,
                sort:"string",
                footer:{content:"totalRows"}
            }];

            if(!netProtocol)
            {
                result.push({
                    id: "app_protocol_group_id",
                    width: 160,
                    header: [
                        LangHelper.GetString("DpiDscpConfig", "Group"),
                        {
                            content: "multiSelectFilter",
                            options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }
                    ],
                    filterMap: {
                        id: "app_protocol_group_id",
                        operator: "in",
                        value: function(Val)
                        {
                            if(Val)
                            {
                                var arr = Val.split(",");

                                return arr;
                            }
                            return null;
                        }
                    },
                    template: function(obj){

                        var str = "";

                        if(obj && obj.app_protocol_group_id != null)
                        {
                            var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.app_protocol_group_id});

                            if(group)
                            {
                                str = group.value;
                            }
                        }
                        return str;
                    }
                });
            }
            return result;
        }().concat(columns),
        leftSplit:1,
        export_pdf_config: {
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            }
        }
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableFullflowRawTopProtocolsGroupsWidget = function (Params)
{
    var common = QoETableFullflowRawCommon();

    var values = common.values;

    var columns = common.columns;

    var title, name, sort;

    var view = QoEReportViews.RawFullFlow;

    if(Params && Params.top_subscribers_hosts)
    {
        values = [].concat(values.top_subscribers_hosts); columns = [].concat(columns.top_subscribers_hosts);

        title = LangHelper.GetString("QoE", "Top application protocols groups") + " " + LangHelper.GetString("QoE",  "By subscribers and hosts").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopSubsHostsProtocolsGroupsWidget");

        sort =  "subscribers_uniq";
    }
    else if(Params && Params.top_traffic)
    {
        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_traffic); columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_traffic);

        title = LangHelper.GetString("QoE", "Top application protocols groups") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopTrafficProtocolsGroupsWidget");

        sort =  "traffic";
    }
    else if(Params && Params.top_flow)
    {
        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_flow); columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_flow);

        title = LangHelper.GetString("QoE", "Top application protocols groups") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopFlowProtocolsGroupsWidget");

        sort =  "flow";
    }
    else if(Params && Params.top_session_lifetime)
    {
        view = QoEReportViews.RawFullFlowWithSessionLifeTime;

        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_session_lifetime); columns = columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_session_lifetime);

        title = LangHelper.GetString("QoE", "Top application protocols groups") + " " + LangHelper.GetString("QoE", "By session lifetime").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopSesLifetimeProtocolsGroupsWidget");

        sort =  "avg_ses_lifetime";
    }
    else
    {
        view = QoEReportViews.RawFullFlowWithSessionLifeTime;

        var v = [], c = [];

        Object.keys(values).forEach(function (Key)
        {
            v = v.concat(values[Key]);
        });

        Object.keys(columns).forEach(function (Key)
        {
            c = c.concat(columns[Key]);
        });

        values = v; columns = c;

        title = LangHelper.GetString("QoE", "Top application protocols groups") + " (maxi)";

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopProtocolsGroupsWidget");

        sort =  "avg_ses_lifetime";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowRaw,
            view:view,
            values:[
                {col:"", alias:"app_protocol_group_description", func:"dictGetString('protocols_groups_dic', 'description', app_protocol_group_id)"},
            ].concat(values),
            rows:[
                {col:"app_protocol_group_id", alias:"app_protocol_group_id", gui_dic:DicsEnum.ProtocolsGroupsDic}
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:[
            {
                id: "app_protocol_group_id",
                minWidth: 160,
                fillspace:true,
                header: [
                    LangHelper.GetString("DpiDscpConfig", "Group"),
                    {
                        content: "multiSelectFilter",
                        options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }
                ],
                filterMap: {
                    id: "app_protocol_group_id",
                    operator: "in",
                    value: function(Val)
                    {
                        if(Val)
                        {
                            var arr = Val.split(",");

                            return arr;
                        }
                        return null;
                    }
                },
                template: function(obj){

                    var str = "";

                    if(obj && obj.app_protocol_group_id != null)
                    {
                        var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.app_protocol_group_id});

                        if(group)
                        {
                            str = group.value;
                        }
                    }
                    return str;
                }
            }
        ].concat(columns),
        leftSplit:1,
        export_pdf_config: {
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            }
        }
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableFullflowRawTopTrafficProtocolsWidget = function (Params)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableFullflowRawTopProtocolsWidget(params);
};

var QoETableFullflowRawTopTrafficProtocolsGroupsWidget = function (Params)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableFullflowRawTopProtocolsGroupsWidget(params);
};

var QoETableFullflowRawTopFlowProtocolsWidget = function (Params)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableFullflowRawTopProtocolsWidget(params);
};

var QoETableFullflowRawTopFlowProtocolsGroupsWidget = function (Params)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableFullflowRawTopProtocolsGroupsWidget(params);
};

var QoETableFullflowRawTopSesLifetimeProtocolsWidget = function (Params)
{
    var params = webix.extend({top_session_lifetime:true}, Params, true);

    return QoETableFullflowRawTopProtocolsWidget(params);
};

var QoETableFullflowRawTopSesLifetimeProtocolsGroupsWidget = function (Params)
{
    var params = webix.extend({top_session_lifetime:true}, Params, true);

    return QoETableFullflowRawTopProtocolsGroupsWidget(params);
};

var QoETableFullflowRawTopSubsHostsProtocolsWidget = function (Params)
{
    var params = webix.extend({top_subscribers_hosts:true}, Params, true);

    return QoETableFullflowRawTopProtocolsWidget(params);
};

var QoETableFullflowRawTopSubsHostsProtocolsGroupsWidget = function (Params)
{
    var params = webix.extend({top_subscribers_hosts:true}, Params, true);

    return QoETableFullflowRawTopProtocolsGroupsWidget(params);
};

var QoETableFullflowRawTopSubscribersWidget = function (Params)
{
    var common = QoETableFullflowRawCommon();

    var values = common.values;

    var columns = common.columns;

    var title, name, sort;

    var view = QoEReportViews.RawFullFlow;

    if(Params && Params.top_subscribers_hosts)
    {
        values = [].concat(values.top_subscribers_hosts); columns = [].concat(columns.top_subscribers_hosts);

        title = LangHelper.GetString("QoE", "Top" + " subscribers") + " " + LangHelper.GetString("QoE", "By subscribers and hosts").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopSubsHosts" + "SubscribersWidget");

        sort =  "subscribers_uniq";
    }
    else if(Params && Params.top_traffic)
    {
        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_traffic); columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_traffic);

        title = LangHelper.GetString("QoE", "Top" + " subscribers") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopTraffic" + "SubscribersWidget");

        sort =  "traffic";
    }
    else if(Params && Params.top_flow)
    {
        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_flow); columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_flow);

        title = LangHelper.GetString("QoE", "Top" + " subscribers") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopFlow" + "SubscribersWidget");

        sort =  "flow";
    }
    else if(Params && Params.top_session_lifetime)
    {
        view = QoEReportViews.RawFullFlowWithSessionLifeTime;

        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_session_lifetime); columns = columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_session_lifetime);

        title = LangHelper.GetString("QoE", "Top" + " subscribers") + " " + LangHelper.GetString("QoE", "By session lifetime").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopSesLifetime" + "SubscribersWidget");

        sort =  "avg_ses_lifetime";
    }
    else
    {
        view = QoEReportViews.RawFullFlowWithSessionLifeTime;

        var v = [], c = [];

        Object.keys(values).forEach(function (Key)
        {
            v = v.concat(values[Key]);
        });

        Object.keys(columns).forEach(function (Key)
        {
            c = c.concat(columns[Key]);
        });

        values = v; columns = c;

        title = LangHelper.GetString("QoE", "Top" + " subscribers") + " (maxi)";

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTop" + "SubscribersWidget");

        sort =  "avg_ses_lifetime";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowRaw,
            view:view,
            values:[
                {col:"login", alias:"login_any",func:"any"}
            ].concat(values),
            rows:[
                "subscriber"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:[
            {
                id:"subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            },
            {
                id:"login",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                template:function(Obj)
                {
                    return Obj.login_any;
                },
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            }
        ].concat(columns),
        sort_map:{"login":"login_any"},
        can_use_sort_map:{
            "ReportsSettings": 1
        },
        leftSplit:1
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableFullflowRawTopTrafficSubscribersWidget = function (Params)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableFullflowRawTopSubscribersWidget(params);
};

var QoETableFullflowRawTopFlowSubscribersWidget = function (Params)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableFullflowRawTopSubscribersWidget(params);
};

var QoETableFullflowRawTopSesLifetimeSubscribersWidget = function (Params)
{
    var params = webix.extend({top_session_lifetime:true}, Params, true);

    return QoETableFullflowRawTopSubscribersWidget(params);
};

var QoETableFullflowRawTopSubsHostsSubscribersWidget = function (Params)
{
    var params = webix.extend({top_subscribers_hosts:true}, Params, true);

    return QoETableFullflowRawTopSubscribersWidget(params);
};



var QoETableFullflowRawTopHostsIpsWidget = function (Params)
{
    var common = QoETableFullflowRawCommon();

    var values = common.values;

    var columns = common.columns;

    var title, name, sort;

    var view = QoEReportViews.RawFullFlow;

    if(Params && Params.top_subscribers_hosts)
    {
        values = [].concat(values.top_subscribers_hosts); columns = [].concat(columns.top_subscribers_hosts);

        title = LangHelper.GetString("QoE", "Top" + " hosts IPs") + " " + LangHelper.GetString("QoE", "By subscribers and hosts").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopSubsHosts" + "HostsIpsWidget");

        sort =  "subscribers_uniq";
    }
    else if(Params && Params.top_traffic)
    {
        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_traffic); columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_traffic);

        title = LangHelper.GetString("QoE", "Top" + " hosts IPs") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopTraffic" + "HostsIpsWidget");

        sort =  "traffic";
    }
    else if(Params && Params.top_flow)
    {
        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_flow); columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_flow);

        title = LangHelper.GetString("QoE", "Top" + " hosts IPs") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopFlow" + "HostsIpsWidget");

        sort =  "flow";
    }
    else if(Params && Params.top_session_lifetime)
    {
        view = QoEReportViews.RawFullFlowWithSessionLifeTime;

        values = [].concat([values.top_subscribers_hosts[0]]).concat(values.top_session_lifetime); columns = columns = [].concat([columns.top_subscribers_hosts[0]]).concat(columns.top_session_lifetime);

        title = LangHelper.GetString("QoE", "Top" + " hosts IPs") + " " + LangHelper.GetString("QoE", "By session lifetime").toLowerCase();

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTopSesLifetime" + "HostsIpsWidget");

        sort =  "avg_ses_lifetime";
    }
    else
    {
        view = QoEReportViews.RawFullFlowWithSessionLifeTime;

        var v = [], c = [];

        Object.keys(values).forEach(function (Key)
        {
            v = v.concat(values[Key]);
        });

        Object.keys(columns).forEach(function (Key)
        {
            c = c.concat(columns[Key]);
        });

        values = v; columns = c;

        title = LangHelper.GetString("QoE", "Top" + " hosts IPs") + " (maxi)";

        name = Params&&Params.name?Params.name : ("QoETableFullflowRawTop" + "HostsIpsWidget");

        sort =  "avg_ses_lifetime";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowRaw,
            view:view,
            values:[
                {col:"host", alias:"host_any",func:"any"}
            ].concat(values),
            rows:[
                "host_ip"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:[
            {
                id:"host_ip",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                minWidth:160,
                sort:"string",
                footer:{content:"totalRows"}
            },
            {
                id:"host_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                minWidth:160,
                sort:"string",
                footer:{content:"totalRows"}
            }
        ].concat(columns),
        leftSplit:1
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableFullflowRawTopTrafficHostsIpsWidget = function (Params)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableFullflowRawTopHostsIpsWidget(params);
};

var QoETableFullflowRawTopFlowHostsIpsWidget = function (Params)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableFullflowRawTopHostsIpsWidget(params);
};

var QoETableFullflowRawTopSesLifetimeHostsIpsWidget = function (Params)
{
    var params = webix.extend({top_session_lifetime:true}, Params, true);

    return QoETableFullflowRawTopHostsIpsWidget(params);
};

var QoETableFullflowRawTopSubsHostsHostsIpsWidget = function (Params)
{
    var params = webix.extend({top_subscribers_hosts:true}, Params, true);

    return QoETableFullflowRawTopHostsIpsWidget(params);
};


var QoEPieChartSpaceReportWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Tablespace info"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartSpaceReportWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.System.Parts,
            database:"system",
            values:[
                {col:"bytes_on_disk", alias:"bytes", func:"sum"}
            ],
            rows:[
                "table"
            ],
            sort:{id:"bytes",dir:"desc"},
            size:10
        }
    };

    return new QoEPieChartReportWidget(params);
};

var QoETableSpaceReportWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Tablespace info"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableSpaceReportWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.System.Parts,
            database:"system",
            values:
                [
                    {col:"partition", alias:"partition_max", func:"max"},
                    {col:"partition", alias:"partition_min", func:"min"},
                    {col:"bytes_on_disk", alias:"bytes", func:"sum"}
                ],
            rows:[
                "table",
                "disk_name",
                {col:"host", alias:"host", func:"hostName()"}
            ],
            sort:{id:"bytes",dir:"desc"},
            limit:100,
            with_totals:true
        },
        footer:true,
        columns:
            [
                {
                    id:"table", header:[TooltipTemplate(LangHelper.GetString("QoE", "Table")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    footer:{content:"totalRows"},
                    fillspace:true
                },
                {
                    id:"disk_name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Disk name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    footer:{content:"totalRows"},
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"partition_min", header:[TooltipTemplate(LangHelper.GetString("QoE", "Min partition")), ""],
                    sort:"string",
                    footer:{content:"totalStrColumn"},
                    fillspace:true
                },
                {
                    id:"partition_max", header:[TooltipTemplate(LangHelper.GetString("QoE", "Max partition")), ""],
                    sort:"string",
                    footer:{content:"totalStrColumn"},
                    fillspace:true
                },
                {
                    id:"bytes", header:[TooltipTemplate(LangHelper.GetString("QoE", "On disk") + ", " + LangHelper.GetString("QoE", "Bytes").toLowerCase()), ""],
                    sort:"string",
                    format:webix.i18n.intFormat,
                    footer:{content:"totalColumn"},
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETablePartitionsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Partitions info"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETablePartitionsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.System.Parts,
            database:"system",
            values:
            [
                {col:"bytes_on_disk", alias:"bytes", func:"sum"},
                {col:"1", alias:"valid"}
            ],
            rows:[
                "partition",
                "table",
                "disk_name",
                {col:"host", alias:"host", func:"hostName()"}
            ],
            sort:{id:"partition",dir:"desc"},
            limit:100000,
            with_totals:true
        },
        footer:true,
        multiselect:true,
        columns:
            [
                {
                    id:"partition", header:[TooltipTemplate(LangHelper.GetString("QoE", "Partition")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"table", header:[TooltipTemplate(LangHelper.GetString("QoE", "Table")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"disk_name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Disk name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"bytes", header:[TooltipTemplate(LangHelper.GetString("QoE", "On disk") + ", " + LangHelper.GetString("QoE", "Bytes").toLowerCase()), ""],
                    sort:"string",
                    footer:{content:"totalColumn"},
                    format:webix.i18n.intFormat,
                    fillspace:true
                },
                {
                    id: "trash",
                    header: "",
                    width: 32,
                    template: CellTrashBtnTemplate,
                    headermenu: false
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        on: {}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id)
        {
            Params.onItemClick(Id);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableCachesListWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Caches info"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableCachesListWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.System.Parts,
            database:"system",
            values:
                [
                    {col:"bytes_on_disk", alias:"bytes", func:"sum"},
                    {col:"1", alias:"valid"}
                ],
            rows:[
                "partition",
                "table"
            ],
            sort:{id:"partition",dir:"desc"},
            limit:100000,
            with_totals:true
        },
        footer:true,
        multiselect:true,
        columns:
            [
                {
                    id:"partition", header:[TooltipTemplate(LangHelper.GetString("QoE", "Partition")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"table", header:[TooltipTemplate(LangHelper.GetString("QoE", "Table")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"bytes", header:[TooltipTemplate(LangHelper.GetString("QoE", "On disk") + ", " + LangHelper.GetString("QoE", "Bytes").toLowerCase()), ""],
                    sort:"string",
                    footer:{content:"totalColumn"},
                    format:webix.i18n.intFormat,
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        on: {}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id)
        {
            Params.onItemClick(Id);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableFullflowAggregationRawLogsWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoETableFullflowAggregationRawLogsWidget",
        title:LangHelper.GetString("QoE", "Aggregation raw logs fullflow info"),
        icon:"table",
        sortDisabledColumns:["checkbox", "trash", "edit"],
        enableCheckboxRefresh:true,
        showProgressWhenDataLoading:true,
        config:{
            method:function ()
            {
                return "GetQoECompressQueueReport";
            },
            sort:{id:"update_time", dir:"desc"}
        },
        columns: function() {
            let cols = [];

            cols.push.apply(cols, [
                { id:"checked", header:["",{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}], template: CellColoredCheckBoxTemplate, width:32 },
                {
                    id:"task_type_from", header:[TooltipTemplate(LangHelper.GetString("QoE", "Task type from")), {
                        content: "multiSelectFilter",
                        options: Helper.DictToArr(QoECompressQueueTableDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }],
                    sort:"string",
                    fillspace:true,
                    template: function (obj) {
                        const val = QoECompressQueueTableDic[obj.task_type_from];
                        let tableStr = "";

                        if(val)
                        {
                            tableStr += val.value;
                        }

                        return tableStr;
                    }
                },
                {
                    id:"action", header:[TooltipTemplate(LangHelper.GetString("QoE", "Action")), {
                        content: "multiSelectFilter",
                        options: Helper.DictToArr(QoECompressQueueActionDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }],
                    sort:"string",
                    fillspace:true,
                    template: function (obj) {
                        const val = QoECompressQueueActionDic[obj.action];
                        let actionStr = "";

                        if(val)
                        {
                            actionStr += val.value;
                        }

                        return actionStr;
                    }
                },
                {
                    id:"task_type_to", header:[TooltipTemplate(LangHelper.GetString("QoE", "Task type to")), {
                        content: "multiSelectFilter",
                        options: Helper.DictToArr(QoECompressQueueTableDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }],
                    sort:"string",
                    fillspace:true,
                    template: function (obj) {
                        const val = QoECompressQueueTableDic[obj.task_type_to];
                        let tableStr = "";

                        if(val)
                        {
                            tableStr += val.value;
                        }

                        return tableStr;
                    }
                },
                {
                    id:"partition_name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Partition name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"node",
                    header:[
                        TooltipTemplate(LangHelper.GetString("QoE", "Node")), {
                        content: "multiSelectFilter",
                        options: [],
                        inputConfig: {suggest: {fitMaster: false}}
                        }
                    ],
                    sort:"string",
                    fillspace:true,
                    template: function(obj)
                    {
                        let result = "";

                        if(obj && obj.node)
                        {
                            let find = null;
                            let dicArr = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

                            if(dicArr && dicArr.length)
                            {
                                find = dicArr.find(item => item.hardware_type === HardwareTypesEnum.qoestor && item.ip === obj.node);
                            }

                            result = find && find.value ? find.value : obj.node
                        }

                        return result;
                    }
                },
                {
                    id:"status", header:[TooltipTemplate(LangHelper.GetString("QoE", "Status")), {
                        content: "multiSelectFilter",
                        options: Helper.DictToArr(QoECompressQueueStatusDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }],
                    sort:"string",
                    fillspace:true,
                    template: function (obj) {
                        const val = QoECompressQueueStatusDic[obj.status];
                        let statusStr = "";

                        if(val)
                        {
                            statusStr += val.value;
                        }

                        return statusStr;
                    }
                },
                {
                    id:"status_description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Status description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"attempts", header:[TooltipTemplate(LangHelper.GetString("QoE", "Attempts")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"data", header:[TooltipTemplate(LangHelper.GetString("QoE", "Data")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true,
                    template: function(Obj) {
                        return Obj && Obj.data ? CellEyeBtnTemplate() : "";
                    }
                },
                {
                    id:"create_time", header:[TooltipTemplate(LangHelper.GetString("QoE", "Create time")), ""],
                    template: LocalTimeZone,
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"update_time", header:[TooltipTemplate(LangHelper.GetString("QoE", "Update time")), ""],
                    template: LocalTimeZone,
                    sort:"string",
                    fillspace:true
                },
                {
                    id: "trash",
                    width: 32,
                    header: "",
                    headermenu: false,
                    template: function (Obj) {
                        return "<span class=\"webix_icon fa-trash\" style=\"cursor:pointer;\"></span>";
                    }
                }
            ]);

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.onAfterFilterCustomHandler)
    {
        params.on.onAfterFilterCustomHandler = function ()
        {
            Params.onAfterFilterCustomHandler();
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableDictionariesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Dictionaries info"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableDictionariesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.System.Dictionaries,
            database:"system",
            values:
            [
                {col:"name", alias:"name"},
                //{col:"origin", alias:"origin"},
                {col:"source", alias:"source"},
                {col:"element_count", alias:"element_count"},
                {col:"loading_start_time", alias:"creation_time"},
                {col:"last_exception", alias:"last_exception"},
                {col:"host", alias:"host", func:"hostName()"}
            ],
            sort:{id:"name",dir:"asc"},
            limit:10000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                // {
                //     id:"origin", header:[TooltipTemplate(LangHelper.GetString("QoE", "Origin")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                //     sort:"string",
                //     fillspace:true
                // },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"source", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:2
                },
                {
                    id:"element_count", header:[TooltipTemplate(LangHelper.GetString("QoE", "Count")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"creation_time", header:[TooltipTemplate(LangHelper.GetString("QoE", "Creation time")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"last_exception", header:[TooltipTemplate(LangHelper.GetString("QoE", "Last exception")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableAsnumDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "AS numbers dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableAsnumDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.AsnumDic,
            values:
                [
                    {col:"id", alias:"_id"},
                    {col:"description", alias:"description"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Id")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableAsnumLocalDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Local AS numbers dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableAsnumDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.AsnumLocalDic,
            values:
                [
                    {col:"id", alias:"_id"},
                    {col:"description", alias:"description"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Id")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableAsnumExcludeDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Excluded AS numbers dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableAsnumExcludeDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.AsnumExcludeDic,
            values:
                [
                    {col:"id", alias:"_id"},
                    {col:"description", alias:"description"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Id")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableCRCDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "CRC dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableCRCDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.CrcDic,
            values:
                [
                    {col:"hw_id"},
                    {col:"hw_port"},
                    {col:"crc"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"hw_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"hw_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Hardware ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"hw_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Hardware port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"crc", header:[TooltipTemplate(LangHelper.GetString("QoE", "CRC value")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetProtocolsDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Net protocols dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableNetProtocolsDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.NetProtocolsDic,
            values:
                [
                    {col:"id", alias:"_id"},
                    {col:"description", alias:"description"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Id")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableAppProtocolsDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "App protocols dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableAppProtocolsDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.AppProtocolsDic,
            values:
            [
                {col:"id", alias:"_id"},
                {col:"description", alias:"description"},
                {col:"group_id", alias:"group_id"},
                {col:"host", alias:"host", func:"hostName()"}
            ],
            join:{
                type: "left",
                stringency: "",
                view:{
                    values:[
                        {col:"group_id", alias:"group_id"},
                        {col: "id", alias: "_id"}
                    ],
                    table:QoEReportTablesEnum.PrtclsWithGroupsDic,
                    flags:{
                        use_sort:0,
                        use_size:0,
                        use_having:0,
                        use_where:0
                    }
                },
                using:[
                    "_id"
                ]
            },
            sort:{id:"_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Id")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id: "group_id",
                    fillspace:true,
                    header: [
                        LangHelper.GetString("DpiDscpConfig", "Group"),
                        {
                            content: "multiSelectFilter",
                            options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }
                    ],
                    filterMap: {
                        id: "group_id",
                        operator: "in",
                        value: function(Val)
                        {
                            if(Val)
                            {
                                var arr = Val.split(",");

                                return arr;
                            }
                            
                            return null;
                        }
                    },
                    template: function(obj){

                        var result = "";

                        if(obj && obj.group_id != null)
                        {
                            var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.group_id});

                            if(group)
                            {
                                result = group.value;
                            }
                        }
                        return result;
                    }
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableAppProtocolsGroupsDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "App protocols groups dictionary"),
        icon:"table",
        id:Params && Params.id? Params.id : webix.uid(),
        name:"QoETableAppProtocolsGroupsDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.PrtclsGroupsDic,
            values:
            [
                {col:"id", alias:"_id"},
                {col: "description", alias: "description"},
                {col:"host", alias:"host", func:"hostName()"}
            ],
            sort:{id:"_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Id")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description",
                    header:[
                        TooltipTemplate(LangHelper.GetString("QoE", "Description")),
                        {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                    ],
                    sort:"string",
                    fillspace:true,
                    template: function(obj){
                        var result = obj.description;

                        if(obj && obj._id != null)
                        {
                            var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj._id});

                            if(group)
                            {
                                result += " (" + group.value + ")";
                            }
                        }
                        return result;
                    }
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableSettingsDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Settings dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableSettingsDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.SettingsDic,
            values:
                [
                    {col:"id", alias:"_id"},
                    {col:"value", alias:"value"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Id")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"value", header:[TooltipTemplate(LangHelper.GetString("QoE", "Value")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableSubnetsLocalDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Local subnets dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableSubnetsLocalDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.SubnetsLocalDic,
            values:
                [
                    {col:"cidr"},
                    {col:"description"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"cidr",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"cidr", header:[TooltipTemplate(LangHelper.GetString("QoE", "CIDR or IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableSubnetsExcludeDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Excluded subnets dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableSubnetsExcludelDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.SubnetsExcludeDic,
            values:
                [
                    {col:"cidr"},
                    {col:"description"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"cidr",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"cidr", header:[TooltipTemplate(LangHelper.GetString("QoE", "CIDR or IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableSubscribersDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Subscribers dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableSubscribersDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.SubscribersDic,
            values:
                [
                    {col:"ip"},
                    {col:"login"},
                    {col:"hw_id"},
                    {col:"hw_port"},
                    {col:"unit_vendor"},
                    {col:"cabel"},
                    {col:"contract"},
                    {col:"services"},
                    {col:"mac"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"ip",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"ip", header:[TooltipTemplate(LangHelper.GetString("QoE", "IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"login", header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"hw_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Hardware ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"hw_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Hardware port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"unit_vendor", header:[TooltipTemplate(LangHelper.GetString("QoE", "Unit vendor")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"cabel", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cabel")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"contract", header:[TooltipTemplate(LangHelper.GetString("QoE", "Contract")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"services", header:[TooltipTemplate(LangHelper.GetString("QoE", "Services")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"mac", header:[TooltipTemplate(LangHelper.GetString("QoE", "MAC")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableSwitchesDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Switches dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableSwitchesDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.SwitchesDic,
            values:
                [
                    {col:"hw_id"},
                    {col:"name"},
                    {col:"type"},
                    {col:"region"},
                    {col:"address"},
                    {col:"ip"},
                    {col:"oper_id"},
                    //{col:"higher_hw"},
                    {col:"linked_from_hw"},
                    {col:"linked_from_port"},
                    {col:"belongs_to"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"hw_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"hw_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Hardware ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"type", header:[TooltipTemplate(LangHelper.GetString("QoE", "Type")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"region", header:[TooltipTemplate(LangHelper.GetString("QoE", "Region")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"address", header:[TooltipTemplate(LangHelper.GetString("QoE", "Address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"ip", header:[TooltipTemplate(LangHelper.GetString("QoE", "IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"oper_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Operator")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                // {
                //     id:"higher_hw", header:[TooltipTemplate(LangHelper.GetString("QoE", "Higher hardware")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                //     sort:"string",
                //     fillspace:true
                // },
                {
                    id:"linked_from_hw", header:[TooltipTemplate(LangHelper.GetString("QoE", "Linked from hardware")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"linked_from_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Linked from port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"belongs_to", header:[TooltipTemplate(LangHelper.GetString("QoE", "Belongs to")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableUrlcatsDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Host categories dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableUrlcatsDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.UrlcatsDic,
            values:
                [
                    {col:"id", alias:"_id"},
                    {col:"description", alias:"description"},
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Id")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    template:function(Obj)
                    {
                        var dic = App.DicsManager.GetDic(DicsEnum.HostCategoriesDic);

                        return dic && dic[Obj._id] ? Obj.description + " (" + LangHelper.GetString("QoE", dic[Obj._id].value) + ")" : LangHelper.GetString("QoE", "hcn_undefined");
                    },
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableUrlcatsHostDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Hosts in categories dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableUrlcatsHostDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.UrlcatsHostDic,
            view:QoEReportViews.HostCategories,
            values:
                [
                    "cat_id",
                    "host",
                    "description",
                    {col:"cluster_host", alias:"cluster_host", func:"hostName()"}
                ],
            sort:{id:"cat_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"cat_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Category ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    template:function(Obj)
                    {
                        var dic = App.DicsManager.GetDic(DicsEnum.HostCategoriesDic);

                        return dic && dic[Obj.cat_id] ? Obj.description + " (" + LangHelper.GetString("QoE", dic[Obj.cat_id].value) + ")" : LangHelper.GetString("QoE", "hcn_undefined");
                    },
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"cluster_host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableUlrVchanNameDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Vchannels names dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableUlrVchanNameDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.VchannelsNamesDic,
            values:
                [
                    "dpi_id",
                    "bridge_vchannel_num",
                    "name",
                    {col:"host", alias:"host", func:"hostName()"}
                ],
            sort:{id:"dpi_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"dpi_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"bridge_vchannel_num", header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannel ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableGtpCountryDicWidget = function(Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Gtp country dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableGtpCountryDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.GtpCountryDic,
            values:
                [
                    "mcc",
                    "description"
                ],
            sort:{id:"mcc",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"mcc", header:[TooltipTemplate(LangHelper.GetString("QoE", "Mobile country code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Country name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
}

var QoETableGtpNetworkDicWidget = function(Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Gtp network (operator) dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableGtpNetworkDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.GtpNetworkDic,
            values:
                [
                    "mcc",
                    "mnc",
                    "description"
                ],
            sort:{id:"mcc",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"mcc", header:[TooltipTemplate(LangHelper.GetString("QoE", "Mobile country code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"mnc", header:[TooltipTemplate(LangHelper.GetString("QoE", "Mobile network (operator) code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Network (operator) name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
}

var QoeTableUplinkLoadRateDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "UPLINK LOAD RATE protocols dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoeTableUplinkLoadRateDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.UplinkLoadRateDic,
            values:
                [
                    "protocol_code",
                    "num_category"
                ],
            sort:{id:"protocol_code",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [
                {
                    id:"protocol_code", header:[TooltipTemplate(LangHelper.GetString("QoE", "Protocol code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"num_category", header:[TooltipTemplate(LangHelper.GetString("QoE", "Protocol category")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
}

var QoETableQueriesProcessesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Queries processes list"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableQueriesProcessesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.System.Processes,
            database:"system",
            values:
            [
                {col:"query_id"},
                {col:"memory_usage"},
                {col:"peak_memory_usage"},
                {col:"user"},
                {col:"address"},
                {col:"http_user_agent"},
                {col:"elapsed"},
                {col:"read_rows"},
                {col:"read_bytes"},
                {col:"total_rows_approx"},
                {col:"query"},
                {col:"host", alias:"host", func:"hostName()"}
            ],
            sort:{id:"elapsed",dir:"desc"},
            limit:100000,
            with_totals:false
        },
        footer:true,
        multiselect:true,
        columns:
            [
                {
                    id:"query_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Query ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"user", header:[TooltipTemplate(LangHelper.GetString("QoE", "User")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"address", header:[TooltipTemplate(LangHelper.GetString("QoE", "Address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"http_user_agent", header:[TooltipTemplate(LangHelper.GetString("QoE", "User agent")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"query", header:[TooltipTemplate(LangHelper.GetString("QoE", "Query")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true
                },
                {
                    id:"elapsed", header:[TooltipTemplate(LangHelper.GetString("QoE", "Elapsed") + ", " + LangHelper.GetString("QoE", "Seconds").toLowerCase()), ""],
                    sort:"string",
                    footer:{content:"totalColumn"},
                    format:webix.i18n.intFormat,
                    fillspace:true
                },
                {
                    id:"memory_usage", header:[TooltipTemplate(LangHelper.GetString("QoE", "Memory usage") + ", " + LangHelper.GetString("QoE", "Bytes").toLowerCase()), ""],
                    sort:"string",
                    footer:{content:"totalColumn"},
                    format:webix.i18n.intFormat,
                    fillspace:true
                },
                {
                    id:"peak_memory_usage", header:[TooltipTemplate(LangHelper.GetString("QoE", "Peak memory usage") + ", " + LangHelper.GetString("QoE", "Bytes").toLowerCase()), ""],
                    sort:"string",
                    footer:{content:"totalColumn"},
                    format:webix.i18n.intFormat,
                    fillspace:true
                },
                {
                    id:"read_rows", header:[TooltipTemplate(LangHelper.GetString("QoE", "Rows read")), ""],
                    sort:"string",
                    footer:{content:"totalColumn"},
                    format:webix.i18n.intFormat,
                    fillspace:true
                },
                {
                    id:"read_bytes", header:[TooltipTemplate(LangHelper.GetString("QoE", "Bytes read")), ""],
                    sort:"string",
                    footer:{content:"totalColumn"},
                    format:webix.i18n.intFormat,
                    fillspace:true
                },
                {
                    id:"total_rows_approx", header:[TooltipTemplate(LangHelper.GetString("QoE", "Total rows")), ""],
                    sort:"string",
                    footer:{content:"totalColumn"},
                    format:webix.i18n.intFormat,
                    fillspace:true
                },
                {
                    id: "kill",
                    header: "",
                    width: 32,
                    template: CellKillBtnTemplate,
                    headermenu: false
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        on: {}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id)
        {
            Params.onItemClick(Id);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableFullnetflowRawSshBruteForceWidget = function (Params)
{
    var common = QoETableFullflowRawCommon();

    var values = [
        {col:"", alias:"sessions_uniq", func:"uniq(session_id)"},
        {col:"", alias:"subscribers_uniq", func:"uniq(subscriber)"},
        {col:"", alias:"sess_subscribers", func: "divide(sessions_uniq, subscribers_uniq)"},
        // {col:"", alias:"logins_uniq", func:"uniq(login)"},
        // {col:"", alias:"host_ips_uniq", func:"uniq(host_ip)"},
        // {col:"", alias:"hosts_uniq", func:"uniq(host)"},
        // {col:"", alias:"avg_ses_lifetime_from_subscriber", func:"avgIf(session_lifetime, from_subscriber == 1)"},
        {col:"", alias:"avg_ses_lifetime_to_subscriber", func:"avgIf(session_lifetime, from_subscriber == 0)"},
        {col:"", alias:"min_ses_lifetime", func:"minIf(session_lifetime, from_subscriber == 0)"},
        {col:"", alias:"max_ses_lifetime", func:"maxIf(session_lifetime, from_subscriber == 0)"}
    ];

    var columns = [
        {
            id:"sessions_uniq",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Sessions")), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"subscribers_uniq",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"sess_subscribers",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Sessions per subscriber")), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            sort:"string"
        },
        // {
        //     id:"logins_uniq",
        //     header:[TooltipTemplate(LangHelper.GetString("QoE", "Logins")), ""],
        //     format:webix.i18n.intFormat,
        //     footer:{content:"totalColumn"},
        //     sort:"string"
        // },
        // {
        //     id:"host_ips_uniq",
        //     header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), ""],
        //     format:webix.i18n.intFormat,
        //     footer:{content:"totalColumn"},
        //     sort:"string"
        // },
        // {
        //     id:"hosts_uniq",
        //     header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts")), ""],
        //     format:webix.i18n.intFormat,
        //     footer:{content:"totalColumn"},
        //     sort:"string"
        // },
        // {
        //     id:"avg_ses_lifetime_from_subscriber",
        //     header:[TooltipTemplate(LangHelper.GetString("QoE", "Session lifetime") + " " + LangHelper.GetString("QoE", "From subscriber").toLowerCase()+", "+LangHelper.GetString("Dics", "ms")), ""],
        //     format:webix.i18n.intFormat,
        //     footer:{content:"totalColumn"},
        //     sort:"string"
        // },
        // {
        //     id:"avg_ses_lifetime_from_subscriber",
        //     header:[TooltipTemplate(LangHelper.GetString("QoE", "Session lifetime") + " " + LangHelper.GetString("QoE", "From subscriber").toLowerCase() +", "+LangHelper.GetString("Dics", "ms")), ""],
        //     format:webix.i18n.intFormat,
        //     footer:{content:"totalColumn"},
        //     sort:"string"
        // },
        {
            id:"avg_ses_lifetime_to_subscriber",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Session lifetime") + " " + LangHelper.GetString("QoE", "To subscriber").toLowerCase() +", "+LangHelper.GetString("Dics", "ms")), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"min_ses_lifetime",
            header:[TooltipTemplate("Min " + LangHelper.GetString("QoE", "Session lifetime").toLowerCase()+", "+LangHelper.GetString("Dics", "ms")), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"max_ses_lifetime",
            header:[TooltipTemplate("Max " + LangHelper.GetString("QoE", "Session lifetime").toLowerCase()+", "+LangHelper.GetString("Dics", "ms")), ""],
            format:webix.i18n.intFormat,
            footer:{content:"totalColumn"},
            sort:"string"
        }
    ];
    var title, name, sort;

    var view = QoEReportViews.RawFullFlowWithSessionLifeTime;

    // var v = [], c = [];

    // Object.keys(values).forEach(function (Key)
    // {
    //     v = v.concat(values[Key]);
    // });
    //
    // Object.keys(columns).forEach(function (Key)
    // {
    //     c = c.concat(columns[Key]);
    // });
    //
    // values = v; columns = c;

    title = LangHelper.GetString("QoE", "Ssh bruteforce");

    name = Params&&Params.name?Params.name : ("QoETableFullnetflowRawSshBruteForceWidget");

    sort =  "sessions_uniq";

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowRaw,
            view:view,
            values:[
                {col:"host", alias:"host_any",func:"any"}
            ].concat(values),
            rows:[
                "host_ip"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:[
            {
                id:"host_ip",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                minWidth:160,
                sort:"string",
                footer:{content:"totalRows"}
            },
            {
                id:"host_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                minWidth:160,
                sort:"string",
                footer:{content:"totalRows"}
            }
        ].concat(columns),
        leftSplit:2
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    params.filter = {};
    params.filter[webix.uid()] = {
        id: "app_protocol",
        operator: "like",
        sql_type: "where",
        type: "String",
        value: "ssh",
        view: ""
    };

    return new QoETableReportWidget(params);
};

var QoEClearCacheBtnWidgetStatesEnum = {
    ClearCurrentReportCache:"ClearCurrentReportCache",
    ClearAllSectionReports:"ClearAllSectionReports",
    ClearAllMyCache:"ClearAllMyCache",
    ClearAllUsersCache:"ClearAllUsersCache"
};

var QoEClearCacheBtnWidget = function (Params)
{
    var id = Params&&Params.id ? Params.id : webix.uid();
    var popupId = id+"_popup";

    var data = [];

    if(!(Params && Params.restricted && Params.restricted[QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache]))
        data.push({id:QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache, value:LangHelper.GetString("QoE", "Clear current report cache")});

    if(!(Params && Params.restricted && Params.restricted[QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports]))
        data.push({id:QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports, value:LangHelper.GetString("QoE", "Clear cache for all reports in section")});

    if(!(Params && Params.restricted && Params.restricted[QoEClearCacheBtnWidgetStatesEnum.ClearAllMyCache]))
        data.push({id:QoEClearCacheBtnWidgetStatesEnum.ClearAllMyCache, value:LangHelper.GetString("QoE", "Clear all my cache")});

    if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.qoeanalytics_admin, true))
    {
        data.push({id:QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache, value:LangHelper.GetString("QoE", "Clear cache for all users")});
    }

    var view = {
        view: "button",
        id:id,
        type: "icon",
        icon: "broom",
        css: "toolbar_round_btn toolbar_btn_with_menu",
        width: 40,
        tooltip: LangHelper.GetString("QoE", "Clear cache"),
        popup:{
            id: popupId,
            view:"submenu",
            width:400,
            data:data,
            template:"#value#",
            autoheight:true,
            select:false,
            on:
            {
                onMenuItemClick: function (id)
                {
                    if(Params)
                    {
                        if(Params.callback)
                            Params.callback(id);
                    }

                    $$(popupId).hide();
                }
            }
        }
    };

    return view;
};

var QoEKillProcessesBtnWidgetStatesEnum = {
    KillCurrentReportProcesses:"KillCurrentReportProcesses",
    KillAllSectionReportsProcesses:"KillAllSectionReportsProcesses",
    KillAllMyProcesses:"KillAllMyProcesses",
    KillAllUsersProcesses:"KillAllUsersProcesses"
};

var QoEKillProcessesBtnWidget = function (Params)
{
    var id = Params&&Params.id ? Params.id : webix.uid();
    var popupId = id+"_popup";

    var data = [];

    if(!(Params && Params.restricted && Params.restricted[QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses]))
        data.push({id:QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses, value:LangHelper.GetString("QoE", "Kill current report processes")});

    if(!(Params && Params.restricted && Params.restricted[QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses]))
        data.push({id:QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses, value:LangHelper.GetString("QoE", "Kill processes for all reports in section")});

    if(!(Params && Params.restricted && Params.restricted[QoEKillProcessesBtnWidgetStatesEnum.KillAllMyProcesses]))
        data.push({id:QoEKillProcessesBtnWidgetStatesEnum.KillAllMyProcesses, value:LangHelper.GetString("QoE", "Kill all my processes")});


    if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.qoeanalytics_admin, true))
    {
        data.push({id:QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses, value:LangHelper.GetString("QoE", "Kill processes for all users")});
    }

    var view = {
        view: "button",
        id:id,
        type: "icon",
        icon: "hand-paper",
        css: "toolbar_round_btn toolbar_btn_with_menu",
        width: 40,
        tooltip: LangHelper.GetString("QoE", "Kill processes"),
        popup:{
            id: popupId,
            view:"submenu",
            width:400,
            data:data,
            template:"#value#",
            autoheight:true,
            select:false,
            on:
                {
                    onMenuItemClick: function (id)
                    {
                        if(Params)
                        {
                            if(Params.callback)
                                Params.callback(id);
                        }

                        $$(popupId).hide();
                    }
                }
        }
    };

    return view;
};

var QoETableFullGtpFlowRawLogWidget = function (Params)
{
    var values = {
        time_part:[
            {col: "date"},
            {col:"time"}
        ],
        main_part:[
            {col:"session_id"},
            {col:"gtp_version"},
            {col:"request_msg_id"},
            {col:"response_msg_id"},
            {col:"ie_cause"},
            {col:"success"},
            {col:"sgw_cp_ipv4"},
            {col:"sgw_cp_teid"},
            {col:"sgw_dp_ipv4"},
            {col:"sgw_dp_teid"},
            {col:"pgw_cp_ipv4"},
            {col:"pgw_cp_teid"},
            {col:"pgw_dp_ipv4"},
            {col:"pgw_dp_teid"},
            {col:"user_ipv4"},
            {col:"user_ipv6"},
            {col:"imsi"},
            {col:"msisdn"},
            {col:"imei"},
            {col:"apn"},
            {col:"uli_mcc"},
            {col:"country_description"},
            {col:"uli_mnc"},
            {col:"network_description"},
            {col:"uli_tac"},
            {col:"uli_eci"},
            {col:"uli_time"},
            {col:"nsapi"},
            {col:"rat"},
            {col:"dpi_id"}
        ]
    };

    var columns = {
        time_part:[

            {
                id:"date",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Date")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:96,
                fillspace:true
            },
            {
                id:"time",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Time")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:96,
                fillspace:true,
                template: function(Obj)
                {
                    if(Obj && Obj.time)
                    {
                        var time = Obj.time.split(" ");

                        if(time.length > 1)
                        {
                            return time[1];
                        }
                    }
                    return "";
                }
            }
        ],
        main_part:[
            {
                id:"session_id",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Session ID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"gtp_version",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "GTP version")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:96,
                fillspace:true
            },
            {
                id:"request_msg_id",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Request message ID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"response_msg_id",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Response message ID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"ie_cause",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Result code")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"success",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Success")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"sgw_cp_ipv4",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "SGW control plane IP")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"sgw_cp_teid",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "SGW control plane TEID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"sgw_dp_ipv4",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "SGW data plane IP")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string"
            },
            {
                id:"sgw_dp_teid",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "SGW data plane TEID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"pgw_cp_ipv4",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "PGW control plane IP")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"pgw_cp_teid",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "PGW control plane TEID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"pgw_dp_ipv4",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "PGW data plane IP")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort: "string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"pgw_dp_teid",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "PGW data plane TEID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"user_ipv4",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Subscriber ipv4 address")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"user_ipv6",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Subscriber ipv6 address")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"imsi",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "SIM card number")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"msisdn",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Phone number")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"imei",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "IMEI")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"apn",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Access Point Name")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"uli_time",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Time of ULI")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"uli_mcc",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Mobile country code")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id: "country_description",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "Country name")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true,
            },
            {
                id:"uli_mnc",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Mobile network (operator) code")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id: "network_description",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "Network (operator) name")),
                    {
                        content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true,
            },
            {
                id:"uli_tac",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Service/Tracking area code")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"uli_eci",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Base station code")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"rat",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Rat")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"dpi_id",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            }
        ]
    };

    var title, name, sort;

    // if(Params&&Params.short)
    // {
        values = [].concat.apply([], [values.time_part, values.main_part]);

        columns = [].concat.apply([], [columns.time_part, columns.main_part]);

        title = LangHelper.GetString("QoE", "Full raw log");

        name = Params&&Params.name?Params.name : ("QoETableFullGtpFlowRawLogWidget");

        sort =  "time";
    // }
    // else if(Params&&Params.subscriber)
    // {
    //     values = [].concat.apply([], [values.time_part, values.subscriber_part, values.usefull_data_part]);
    //
    //     columns = [].concat.apply([], [columns.time_part, columns.subscriber_part, columns.usefull_data_part]);
    //
    //     title = LangHelper.GetString("QoE", "Subscriber raw log");
    //
    //     name = Params&&Params.name?Params.name : ("QoETableFullflowRawLogSubscriberWidget");
    //
    //     sort =  "time";
    // }
    // else
    // {
    //     values = [].concat.apply([], [values.time_part, values.main_part, values.subscriber_part, values.usefull_data_part, values.other_data_part]);
    //
    //     columns = [].concat.apply([], [columns.time_part, columns.main_part, columns.subscriber_part, columns.usefull_data_part, columns.other_data_part]);
    //
    //     title = LangHelper.GetString("QoE", "Full raw log");
    //
    //     name = Params&&Params.name?Params.name : ("QoETableFullflowRawLogWidget");
    //
    //     sort =  "time";
    // }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.GtpFlowRaw,
            view:QoEReportViews.RawGtpFullFlow,
            values:values,
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_sort:0
            },
            limit:1000000,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:false,
        columns:columns,
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableFullGtpFlowAggLogWidget = function (Params)
{
    var title, name, sort;
    title = LangHelper.GetString("QoE", "Aggregated log");

    name = Params&&Params.name?Params.name : ("QoETableFullGtpFlowAggLogWidget");

    sort =  "time";

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.GtpFlowAgg,
            view:QoEReportViews.GtpFullFlowAgg,
            enableRowContextMenu: true,
            values:[
                {col:"date", alias:"date"},
                {col:"hour", alias:"hour"},
                {col:"time", alias:"time"},

                {col:"imsi", alias:"imsi"},
                {col:"msisdn", alias:"msisdn"},
                {col:"imei", alias:"imei"},
                {col:"user_ipv4", alias:"user_ipv4"},
                {col:"user_ipv6", alias:"user_ipv6"},
                {col:"uli_time", alias:"uli_time"},
                {col:"uli_mcc", alias:"uli_mcc"},
                {col:"country_description", alias:"country_description"},
                {col:"uli_mnc", alias:"uli_mnc"},
                {col:"network_description", alias:"network_description"},
                {col:"uli_tac", alias:"uli_tac"},
                {col:"uli_eci", alias:"uli_eci"},
                {col:"dpi_id", alias:"dpi_id"},
                {col:"session_id_uniq", alias:"session_id_uniq"},
                {col:"total_count", alias:"total_count"},
                {col:"lat", alias:"lat"},
                {col:"lon", alias:"lon"},
                {col:"cell_id", alias:"cell_id"},
                {col:"cell_name", alias:"cell_name"},
                {col:"cell_description", alias:"cell_description"}
            ],
            rows:[
            ],
            // values:[
            //     {col:"", alias:"session_id_uniq", func: "uniqMerge(session_id_uniq)"},
            //     {col:"", alias:"total_count", func: "countMerge(total_count)"},
            //     {col:"", alias:"lat", func: "dictGetOrDefault('gtp_cells_locations_dic','lat', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),toFloat64(0))"},
            //     {col:"", alias:"lon", func: "dictGetOrDefault('gtp_cells_locations_dic','lon', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),toFloat64(0))"},
            //     {col:"", alias:"cell_id", func: "dictGetOrDefault('gtp_cells_locations_dic','cell_id', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),'')"},
            //     {col:"", alias:"cell_name", func: "dictGetOrDefault('gtp_cells_locations_dic','cell_name', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),'')"},
            //     {col:"", alias:"cell_description", func: "dictGetOrDefault('gtp_cells_locations_dic','cell_description', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),'')"}
            // ],
            // rows: [
            //     {col:"date", alias:"date"},
            //     {col:"hour", alias:"hour"},
            //     {col:"time", alias:"time"},
            //
            //     {col:"imsi", alias:"imsi"},
            //     {col:"msisdn", alias:"msisdn"},
            //     {col:"imei", alias:"imei"},
            //     {col:"user_ipv4", alias:"user_ipv4"},
            //     {col:"user_ipv6", alias:"user_ipv6"},
            //     {col:"uli_time", alias:"uli_time"},
            //     {col:"uli_mcc", alias:"uli_mcc"},
            //     {col:"uli_mnc", alias:"uli_mnc"},
            //     {col:"uli_tac", alias:"uli_tac"},
            //     {col:"uli_eci", alias:"uli_eci"},
            //     {col:"dpi_id", alias:"dpi_id"}
            // ],
            flags:{
                use_size:0,
                use_sort:0
            },
            sort:{id:sort,dir:"desc"},
            limit:1000000,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:false,
        columns:[
            {
                id:"date",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Date")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:96,
                fillspace:true
            },
            {
                id:"time",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Time")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:96,
                fillspace:true,
                template: function(Obj)
                {
                    if(Obj && Obj.time)
                    {
                        var time = Obj.time.split(" ");

                        if(time.length > 1)
                        {
                            return time[1];
                        }
                    }
                    return "";
                }
            },
            {
                id:"imsi",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "SIM card number")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"msisdn",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Phone number")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"imei",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "IMEI")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"user_ipv4",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Subscriber ipv4 address")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"user_ipv6",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Subscriber ipv6 address")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"uli_time",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Time of ULI")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"uli_mcc",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Mobile country code")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id: "country_description",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "Country name")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true,
            },
            {
                id:"uli_mnc",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Mobile network (operator) code")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id: "network_description",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "Network (operator) name")),
                    {
                        content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true,
            },
            {
                id:"uli_tac",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Service/Tracking area code")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"uli_eci",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Base station code")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"dpi_id",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"total_count",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Total")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"session_id_uniq",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Sessions")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"lat", header:[TooltipTemplate(LangHelper.GetString("QoE", "Latitude")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"lon", header:[TooltipTemplate(LangHelper.GetString("QoE", "Longitude")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"cell_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                sort:"string",
                fillspace:true,
                minWidth:160
            },
            {
                id:"cell_name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                sort:"string",
                fillspace:true,
                minWidth:160
            },
            {
                id:"cell_description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                sort:"string",
                minWidth:160,
                fillspace:true
            }
        ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableGtpCellsLocationsDicWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Gtp cells locations dictionary"),
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoETableGtpCellsLocationsDicWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.GtpCellsLocationsDic,
            view:QoEReportViews.GtpCellsLocations,
            values:
                [
                    "cell_id",
                    "cell_name",
                    "cell_description",
                    "lat",
                    "lon",
                    "mcc",
                    {col:"country_description", alias:"country_description", func:"dictGetOrDefault('gtp_mcc_dic', 'description', tuple(mcc),'')"},
                    "mnc",
                    {col:"network_description", alias:"network_description", func:"dictGetOrDefault('gtp_mnc_dic', 'description', tuple(mcc, mnc),'')"},
                    "tac",
                    "eci",
                    {col:"host", alias:"host", func:"hostName()"},
                    "col1",
                    "col2"

                ],
            sort:{id:"cell_id",dir:"asc"},
            limit:100000,
            with_totals:false
        },
        footer:false,
        columns:
            [

                {
                    id:"cell_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true,
                    minWidth:160
                },
                {
                    id:"cell_name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true,
                    minWidth:160
                },
                {
                    id:"cell_description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id:"lat", header:[TooltipTemplate(LangHelper.GetString("QoE", "Latitude")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id:"lon", header:[TooltipTemplate(LangHelper.GetString("QoE", "Longitude")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id:"mcc", header:[TooltipTemplate(LangHelper.GetString("QoE", "Mobile country code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id: "country_description",
                    minWidth:160,
                    fillspace:true,
                    header: [TooltipTemplate(LangHelper.GetString("QoE", "Country name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                },
                {
                    id:"mnc", header:[TooltipTemplate(LangHelper.GetString("QoE", "Mobile network (operator) code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id: "network_description",
                    minWidth:160,
                    fillspace:true,
                    header: [TooltipTemplate(LangHelper.GetString("QoE", "Network (operator) name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                },
                {
                    id:"tac", header:[TooltipTemplate(LangHelper.GetString("QoE", "Service/Tracking area code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id:"eci", header:[TooltipTemplate(LangHelper.GetString("QoE", "Base station code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cluster host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id: "col1",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Radius")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id: "col2",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                }
            ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETowersWidget = function (Params)
{
    return new QoEMapsReportWidget({
        id:Params&&Params.id?Params.id:webix.uid(),
        layers: {
            "TowersLayer": new QoEPointsLayerWidget({
                id: webix.uid(),
                title:LangHelper.GetString("QoE", "Towers locations"),
                icon:"broadcast-tower",
                name:"TowersLayer",
                config:{
                    type:QoEReportConfigTypeEnum.ClientPredefined,
                    table:QoEReportTablesEnum.GtpCellsLocationsDic,
                    view:QoEReportViews.GtpCellsLocations,
                    values:[
                        "cell_id",
                        "cell_name",
                        "cell_description",
                        "lat",
                        "lon",
                        "mcc",
                        "mnc",
                        "tac",
                        "eci"
                    ],
                    sort:{id:"cell_id",dir:"asc"},
                    limit:100000
                },
                layer_config:{
                    type: "Vector",
                    item_style: new ol.style.Style({
                        text: new ol.style.Text({
                            text: '\uf519',     //  fa-tower
                            font: '900 24px "Font Awesome 5 Pro"',
                            textBaseline: 'bottom',
                            fill: new ol.style.Fill({
                                color: 'red',
                            })
                        })
                    }),
                    item_config: {
                        type: "Point",
                        data_transform:{
                            id: {value: "cell_id"},
                            name: {value: "cell_name"},
                            description: {value: "cell_description"},
                            lat: {value: "lat"},
                            lon: {value: "lon"},
                            data: [
                                {
                                    value: "eci",
                                    title: LangHelper.GetString("QoE", "Base station code")
                                },
                                {
                                    value: "mcc",
                                    title: LangHelper.GetString("QoE", "Mobile country code")
                                },
                                {
                                    value: "mnc",
                                    title: LangHelper.GetString("QoE", "Mobile network (operator) code")
                                },
                                {
                                    value: "tac",
                                    title: LangHelper.GetString("QoE", "Service/Tracking area code")
                                }
                            ]
                        }
                    }
                }
            })
        }
    });
};

var QoETableLayerGtpCellsLocationsDicWidget = function (Params)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    return new QoETableLayerWidget({
        id:id,
        name:"QoETableLayerGtpCellsLocationsDicWidget",
        table:{
            widget: QoETableGtpCellsLocationsDicWidget({id:id + "TowersTable"})
        },
        map:{
            gravity:2,
            widget: new QoEMapsReportWidget({
                id:id + "Map",
                noRefresh: true,
                layers: {
                    TowersLayer: new QoEPointsLayerWidget({
                        id: id + "MapTowersLayer",
                        title:LangHelper.GetString("QoE", "Towers locations"),
                        icon:"broadcast-tower",
                        name:"TowersLayer",
                        layer_config:{
                            type: "Vector",
                            default_style: {point: webix.skin.$active.defaultMapTowersStyle},
                            item_config: {
                                type: "Point",
                                get_feature_by_id: "point_data_transform",
                                point_data_transform:{
                                    id: {value: "cell_id"},
                                    name: {value: "cell_name"},
                                    description: {value: "cell_description"},
                                    lat: {value: "lat"},
                                    lon: {value: "lon"},
                                    data: [
                                        {
                                            value: "eci",
                                            title: LangHelper.GetString("QoE", "Base station code")
                                        },
                                        {
                                            value: "mcc",
                                            title: LangHelper.GetString("QoE", "Mobile country code")
                                        },
                                        {
                                            value: "mnc",
                                            title: LangHelper.GetString("QoE", "Mobile network (operator) code")
                                        },
                                        {
                                            value: "tac",
                                            title: LangHelper.GetString("QoE", "Service/Tracking area code")
                                        },
                                        {
                                            value: "col1",
                                            title: LangHelper.GetString("QoE", "Radius")
                                        },
                                        {
                                            value: "col2",
                                            title: LangHelper.GetString("QoE", "Address")
                                        }
                                    ]
                                }
                            }
                        }
                    })
                }
            })
        }
    });
    //
    // return new QoEMapsReportWidget({
    //     id:Params&&Params.id?Params.id:webix.uid(),
    //     layers: {
    //         "TowersLayer": new QoEPointsLayerWidget({
    //             id: webix.uid(),
    //             title:LangHelper.GetString("QoE", "Towers locations"),
    //             icon:"broadcast-tower",
    //             name:"TowersLayer",
    //             config:{
    //                 type:QoEReportConfigTypeEnum.ClientPredefined,
    //                 table:QoEReportTablesEnum.GtpCellsLocationsDic,
    //                 view:QoEReportViews.GtpCellsLocations,
    //                 values:[
    //                     "cell_id",
    //                     "cell_name",
    //                     "cell_description",
    //                     "lat",
    //                     "lon",
    //                     "mcc",
    //                     "mnc",
    //                     "tac",
    //                     "eci"
    //                 ],
    //                 sort:{id:"cell_id",dir:"asc"},
    //                 limit:100000
    //             },
    //             layer_config:{
    //                 type: "Vector",
    //                 item_style: new ol.style.Style({
    //                     text: new ol.style.Text({
    //                         text: '\uf519',     //  fa-tower
    //                         font: '900 24px "Font Awesome 5 Pro"',
    //                         textBaseline: 'bottom',
    //                         fill: new ol.style.Fill({
    //                             color: 'red',
    //                         })
    //                     })
    //                 }),
    //                 item_config: {
    //                     type: "Point",
    //                     data_transform:{
    //                         id: {value: "cell_id"},
    //                         name: {value: "cell_name"},
    //                         description: {value: "cell_description"},
    //                         lat: {value: "lat"},
    //                         lon: {value: "lon"},
    //                         data: [
    //                             {
    //                                 value: "eci",
    //                                 title: LangHelper.GetString("QoE", "Base station code")
    //                             },
    //                             {
    //                                 value: "mcc",
    //                                 title: LangHelper.GetString("QoE", "Mobile country code")
    //                             },
    //                             {
    //                                 value: "mnc",
    //                                 title: LangHelper.GetString("QoE", "Mobile network (operator) code")
    //                             },
    //                             {
    //                                 value: "tac",
    //                                 title: LangHelper.GetString("QoE", "Service/Tracking area code")
    //                             }
    //                         ]
    //                     }
    //                 }
    //             }
    //         })
    //     }
    // });
};

var QoETableGtpFlowAggSubscribersLocationsLogWidget = function (Params)
{
    var values = {
        time_part:[
            {col: "date"},
            {col: "hour"},
            {col:"time"}
        ],
        main_part:[
            {col:"imsi"},
            {col:"msisdn"},
            {col:"imei"},
            // {col:"user_ipv4"},
            // {col:"user_ipv6"},
            // {col:"uli_time"},
            // {col:"uli_mcc"},
            // {col:"uli_mnc"},
            // {col:"uli_tac"},
            // {col:"uli_eci"},
            {col:"dpi_id"},
            // {col:"session_id_uniq"}
        ],
        cell_part: [
            // {col:"lat", alias:"lat"},
            // {col:"lon", alias:"lon"},
            // {col:"cell_id", alias:"cell_id"},
            // {col:"cell_name", alias:"cell_name"},
            // {col:"cell_description", alias:"cell_description"}
        ]
    };

    var columns = {
        time_part:[
            // {
            //     id:"date",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Date")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:96,
            //     fillspace:true
            // },
            // {
            //     id:"time",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Time")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:96,
            //     fillspace:true,
            //     template: function(Obj)
            //     {
            //         if(Obj && Obj.time)
            //         {
            //             var time = Obj.time.split(" ");
            //
            //             if(time.length > 1)
            //             {
            //                 return time[1];
            //             }
            //         }
            //         return "";
            //     }
            // }
        ],
        main_part:[
            {
                id:"imsi",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "SIM card number")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"msisdn",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Phone number")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            {
                id:"imei",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "IMEI")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            // {
            //     id:"user_ipv4",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Subscriber ipv4 address")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // },
            // {
            //     id:"user_ipv6",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Subscriber ipv6 address")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // },
            //
            // {
            //     id:"uli_time",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Time of ULI")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // },
            // {
            //     id:"uli_mcc",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Mobile country code")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // },
            // {
            //     id:"uli_mnc",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Mobile network (operator) code")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // },
            // {
            //     id:"uli_tac",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Service/Tracking area code")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // },
            // {
            //     id:"uli_eci",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Base station code")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // },
            {
                id:"dpi_id",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")),
                    {
                        content: "textFilter",
                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                    }
                ],
                sort:"string",
                minWidth:160,
                fillspace:true
            },
            // {
            //     id:"session_id_uniq",
            //     header:[
            //         TooltipTemplate(LangHelper.GetString("QoE", "Session unique ID")),
            //         {
            //             content: "textFilter",
            //             placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            //         }
            //     ],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // }
        ],

        cell_part: [
            // {
            //     id:"cell_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            //     sort:"string",
            //     fillspace:true,
            //     minWidth:160
            // },
            // {
            //     id:"cell_name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            //     sort:"string",
            //     fillspace:true,
            //     minWidth:160
            // },
            // {
            //     id:"cell_description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // },
            // {
            //     id:"lat", header:[TooltipTemplate(LangHelper.GetString("QoE", "Latitude")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // },
            // {
            //     id:"lon", header:[TooltipTemplate(LangHelper.GetString("QoE", "Longitude")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            //     sort:"string",
            //     minWidth:160,
            //     fillspace:true
            // }
        ]
    };

    var title, name, sort;

    // if(Params&&Params.short)
    // {
    values = [].concat.apply([], [values.time_part, values.main_part, values.cell_part]);

    columns = [].concat.apply([], [columns.time_part, columns.main_part, columns.cell_part]);

    title = LangHelper.GetString("QoE", "Short raw log");

    name = Params&&Params.name?Params.name : ("QoETableGtpFlowAggSubscribersLocationsLogWidget");

    sort =  "time";

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.GtpFlowAgg,
            view:QoEReportViews.GtpSubscribersRoute,
            values:values,
            sort:{id:sort,dir:"desc"},
            // distinct: 1,
            flags:{
                use_size:0,
                use_sort:0
            },
            limit:1000000,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:false,
        columns:columns,
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableLayerGtpSubscribersRoutescWidget = function (Params)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    var name = "QoETableLayerGtpSubscribersRoutescWidget";

    return new QoETableLayerWidget({
        id:id,
        name:name,
        table:{
            widget: new QoETableReportWidget({
                title: LangHelper.GetString("QoE", "Subscribers routes"),
                icon:"table",
                id: id + "SubscribersTable",
                name: Params&&Params.name?Params.name : name,
                config:{
                    distinct: 1,
                    // type:QoEReportConfigTypeEnum.ServerPredefined,
                    type:QoEReportConfigTypeEnum.ClientPredefined,
                    values:[
                        {col:"", alias:"id", func:"concat(toString(imsi),'_', toString(msisdn),'_', toString(imei),'_', toString(dpi_id))"},
                        {col:"", alias:"total", func:QoEReportFunctions.Total}
                    ],
                    rows: [
                        {col:"imsi", alias:"imsi"},
                        {col:"msisdn", alias:"msisdn"},
                        {col:"imei", alias:"imei"},
                        {col:"dpi_id", alias:"dpi_id"},
                        {col:"uli_mcc", alias:"uli_mcc"},
                        {col:"uli_mnc", alias:"uli_mnc"}
                    ],
                    table:QoEReportTablesEnum.GtpFlowAgg,
                    join:{
                        type: "",
                        stringency: "",
                        view:{
                            values:[
                                {col:"mcc", alias:"uli_mcc"},
                                {col:"", alias:"country_description", func:"dictGetOrDefault('gtp_mcc_dic', 'description', tuple(uli_mcc), '')"},
                                {col:"mnc", alias:"uli_mnc"},
                                {col:"", alias:"network_description", func:"dictGetOrDefault('gtp_mnc_dic', 'description', tuple(uli_mcc, uli_mnc), '')"},
                                {col:"tac", alias:"uli_tac"},
                                {col:"eci", alias:"uli_eci"},
                                {col:"lat", alias:"lat"},
                                {col:"lon", alias:"lon"},
                                {col:"cell_id", alias:"cell_id"},
                                {col:"cell_name", alias:"cell_name"},
                                {col:"cell_description", alias:"cell_description"}
                            ],
                            table:QoEReportTablesEnum.GtpCellsLocationsDic,
                            flags:{
                                use_sort:0,
                                use_size:0,
                                use_having:0,
                                use_where:0
                            }
                        },
                        using:[
                            "uli_mcc",
                            "uli_mnc",
                            "uli_tac",
                            "uli_eci"
                        ]
                    },
                    flags: {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    },
                    sort: {id:"id", dir:"desc"},
                    limit:100000,
                    cache:{
                        enabled:1,
                        values: [
                            {col:"", alias:"id", func:"concat(toString(imsi),'_', toString(msisdn),'_', toString(imei),'_', toString(dpi_id))"},
                            {col:"imsi", alias:"imsi", func: ""},
                            {col:"msisdn", alias:"msisdn", func: ""},
                            {col:"imei", alias:"imei", func: ""},
                            {col:"dpi_id", alias:"dpi_id", func: ""},
                        ],
                        flags:{
                            use_where:0,
                            use_having:0
                        }
                    },
                    not_disable_cols: ["id", "total"]
                },
                footer:false,
                enableRowContextMenu: true,
                columns:[
                    {
                        id:"imsi",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "SIM card number")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"msisdn",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Phone number")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"imei",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "IMEI")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"dpi_id",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    }
                ],
                leftSplit:0,
                export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
            })
        },
        map:{
            gravity:2,
            widget: new QoEMapsReportWidget({
                id:id + "Map",
                name:name,
                noRefresh: true,
                layers: {
                    RoutesLayer: new QoEStrokesLayerWidget({
                        id: "QoEFullGtpFlowReportCellsSubscribersRoutesReportRoutesLayer",
                        title:LangHelper.GetString("QoE", "Subscribers routes"),
                        icon:"man",
                        name:"RoutesLayer",
                        dataByParentReport: true,
                        parseFilterFromParentReport: function(Data)
                        {
                            var ids = [];
                            if(Data && Data.rows && Array.isArray(Data.rows))
                            {
                                Data.rows.forEach(function(Val){
                                    ids.push(Val.id);
                                });

                            }
                            return ids.length > 0 ? {
                                sub_ids: {
                                    id : "sub_id",
                                    operator: "in",
                                    sql_type: "where",
                                    type: "String",
                                    value: ids
                                }
                            } : {};

                        },
                        config:{
                            distinct: 1,
                            type:QoEReportConfigTypeEnum.ServerPredefined,
                            // type:QoEReportConfigTypeEnum.ClientPredefined,
                            values:[
                                {col:"", alias:"sub_id", func:"concat(toString(imsi),'_', toString(msisdn),'_', toString(imei),'_', toString(dpi_id))"},
                                {col:"", alias:"id", func:"concat(toString(imsi),'_', toString(msisdn),'_', toString(imei),'_', toString(dpi_id),'_', user_ipv4,'_', user_ipv6,'_', toString(uli_time),'_', toString(time))"},
                                {col:"", alias:"country_description", func:"dictGetOrDefault('gtp_mcc_dic', 'description', tuple(uli_mcc), '')"},
                                {col:"", alias:"network_description", func:"dictGetOrDefault('gtp_mnc_dic', 'description', tuple(uli_mcc, uli_mnc), '')"},
                                // {col:"date", alias:"date"},
                                // {col:"hour", alias:"hour"},
                                // {col:"time", alias:"time"},
                                //
                                // {col:"imsi", alias:"imsi"},
                                // {col:"msisdn", alias:"msisdn"},
                                // {col:"imei", alias:"imei"},
                                // {col:"dpi_id", alias:"dpi_id"},
                                //
                                // {col:"user_ipv4", alias:"user_ipv4"},
                                // {col:"user_ipv6", alias:"user_ipv6"},
                                // {col:"uli_time", alias:"uli_time"},
                                // {col:"uli_mcc", alias:"uli_mcc"},
                                // {col:"uli_mnc", alias:"uli_mnc"},
                                // {col:"uli_tac", alias:"uli_tac"},
                                // {col:"uli_eci", alias:"uli_eci"},
                                {col:"", alias:"session_id_uniq", func: "uniqMerge(session_id_uniq)"},
                                // {col:"", alias:"lat", func: "dictGetOrDefault('gtp_cells_locations_dic','lat', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),toFloat64(0))"},
                                // {col:"", alias:"lon", func: "dictGetOrDefault('gtp_cells_locations_dic','lon', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),toFloat64(0))"},
                                // {col:"", alias:"cell_id", func: "dictGetOrDefault('gtp_cells_locations_dic','cell_id', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),'')"},
                                // {col:"", alias:"cell_name", func: "dictGetOrDefault('gtp_cells_locations_dic','cell_name', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),'')"},
                                // {col:"", alias:"cell_description", func: "dictGetOrDefault('gtp_cells_locations_dic','cell_description', tuple(uli_mcc,uli_mnc,uli_tac,uli_eci),'')"}
                                // {col:"lat", alias:"lat"},
                                // {col:"lon", alias:"lon"},
                                // {col:"cell_id", alias:"cell_id"},
                                // {col:"cell_name", alias:"cell_name"},
                                // {col:"cell_description", alias:"cell_description"}
                            ],
                            rows: [
                                {col:"date", alias:"date"},
                                {col:"hour", alias:"hour"},
                                {col:"time", alias:"time"},

                                {col:"imsi", alias:"imsi"},
                                {col:"msisdn", alias:"msisdn"},
                                {col:"imei", alias:"imei"},
                                {col:"dpi_id", alias:"dpi_id"},

                                {col:"user_ipv4", alias:"user_ipv4"},
                                {col:"user_ipv6", alias:"user_ipv6"},
                                {col:"uli_time", alias:"uli_time"},
                                {col:"uli_mcc", alias:"uli_mcc"},
                                {col:"uli_mnc", alias:"uli_mnc"},
                                {col:"uli_tac", alias:"uli_tac"},
                                {col:"uli_eci", alias:"uli_eci"},
                                {col:"lat", alias:"lat"},
                                {col:"lon", alias:"lon"},
                                {col:"cell_id", alias:"cell_id"},
                                {col:"cell_name", alias:"cell_name"},
                                {col:"cell_description", alias:"cell_description"}


                            ],
                            table:QoEReportTablesEnum.GtpFlowAgg,
                            join:{
                                type: "",
                                stringency: "",
                                view:{
                                    values:[
                                        {col:"mcc", alias:"uli_mcc"},
                                        {col:"mnc", alias:"uli_mnc"},
                                        {col:"tac", alias:"uli_tac"},
                                        {col:"eci", alias:"uli_eci"},
                                        {col:"lat", alias:"lat"},
                                        {col:"lon", alias:"lon"},
                                        {col:"cell_id", alias:"cell_id"},
                                        {col:"cell_name", alias:"cell_name"},
                                        {col:"cell_description", alias:"cell_description"}
                                    ],
                                    table:QoEReportTablesEnum.GtpCellsLocationsDic,
                                    flags:{
                                        use_sort:0,
                                        use_size:0,
                                        use_having:0,
                                        use_where:0
                                    }
                                },
                                using:[
                                    "uli_mcc",
                                    "uli_mnc",
                                    "uli_tac",
                                    "uli_eci"
                                ]
                            },
                            flags: {
                                use_sort:1,
                                use_size:0,
                                use_having:0
                            },
                            sort:{id:"uli_time",dir:"asc"},
                            limit:100000
                        },
                        layer_config:{
                            type: "Vector",
                            default_style: {
                                line: webix.skin.$active.defaultMapStrokesStyle,
                                end_points: webix.skin.$active.defaultMapHumanStyle,
                                direction: {
                                    type: "Text",
                                    text: "\uf0da",
                                    anchor: [0.75, 0.5],
                                    use_rotation: true
                                }
                            },
                            item_config: {
                                type: "LineString",
                                get_feature_by_id: "line_data_transform",
                                line_data_transform:{
                                    id: {value: "id"},
                                    data: [
                                        {
                                            value: "imsi",
                                            title: LangHelper.GetString("QoE", "SIM card number")
                                        },
                                        {
                                            value: "msisdn",
                                            title: LangHelper.GetString("QoE", "Phone number")
                                        },
                                        {
                                            value: "imei",
                                            title: LangHelper.GetString("QoE", "IMEI")
                                        },
                                        {
                                            value: "dpi_id",
                                            title: LangHelper.GetString("QoE", "DPI ID")
                                        }
                                    ]
                                },
                                point_data_transform: {
                                    id: {value: "id"},
                                    lat: {value: "subscr_lat"},
                                    // lat: {value: "lat"},
                                    lon: {value: "subscr_lon"},
                                    // lon: {value: "lon"},
                                    data: [
                                        {
                                            value: "session_id_uniq",
                                            title: LangHelper.GetString("QoE", "Sessions")
                                        },
                                        {
                                            "value": "uli_time",
                                            title: LangHelper.GetString("QoE", "Time")
                                        },
                                        // {
                                        //     value: "imsi",
                                        //     title: LangHelper.GetString("QoE", "SIM card number")
                                        // },
                                        // {
                                        //     value: "msisdn",
                                        //     title: LangHelper.GetString("QoE", "Phone number")
                                        // },
                                        // {
                                        //     value: "imei",
                                        //     title: LangHelper.GetString("QoE", "IMEI")
                                        // },
                                        // {
                                        //     value: "dpi_id",
                                        //     title: LangHelper.GetString("QoE", "DPI ID")
                                        // },
                                        {
                                            value: "uli_eci",
                                            title: LangHelper.GetString("QoE", "Base station code")
                                        },
                                        {
                                            value: "uli_mcc",
                                            title: LangHelper.GetString("QoE", "Mobile country code")
                                        },
                                        {
                                            value: "uli_mnc",
                                            title: LangHelper.GetString("QoE", "Mobile network (operator) code")
                                        },
                                        {
                                            value: "uli_tac",
                                            title: LangHelper.GetString("QoE", "Service/Tracking area code")
                                        }
                                    ]
                                }
                            }
                        }
                    })
                }
            })
        }
    });
};

var QoETableLayerSubscribersLocationsWidget = function (Params)
{
    //
    var id = Params&&Params.id?Params.id:webix.uid();

    var name = "QoETableLayerSubscribersLocationsWidget";

    return new QoETableLayerWidget({
        id:id,
        name:name,
        table:{
            widget: new QoETableReportWidget({
                title: LangHelper.GetString("QoE", "Subscribers location"),
                icon:"street-view",
                id: "QoEFullGtpFlowReportCellsSubscribersLocationsReportSubscribersTable",
                name: Params&&Params.name?Params.name : name,
                enableRowContextMenu: true,
                config:{
                    distinct: 1,
                    type:QoEReportConfigTypeEnum.ServerPredefined,
                    // type:QoEReportConfigTypeEnum.ClientPredefined,
                    table: QoEReportTablesEnum.GtpFlowAgg,
                    values:[
                        {col:"", alias:"id", func:"concat(toString(imsi),'_', toString(msisdn),'_', toString(imei),'_', toString(dpi_id),'_', user_ipv4,'_', user_ipv6,'_', toString(uli_time),'_', toString(time))"},
                        {col:"time"},
                        {col:"date"},
                        {col:"imsi", alias:"imsi"},
                        {col:"msisdn", alias:"msisdn"},
                        {col:"imei", alias:"imei"},
                        {col:"dpi_id", alias:"dpi_id"},
                        {col:"user_ipv4", alias:"user_ipv4"},
                        {col:"user_ipv6", alias:"user_ipv6"},
                        {col:"uli_mcc", alias:"uli_mcc"},
                        {col:"country_description", alias:"country_description"},
                        {col:"uli_mnc", alias:"uli_mnc"},
                        {col:"network_description", alias:"network_description"},
                        {col:"uli_tac", alias:"uli_tac"},
                        {col:"uli_eci", alias:"uli_eci"},
                        {col:"uli_time", alias:"uli_time"},
                        {col:"lat", alias:"lat"},
                        {col:"lon", alias:"lon"},
                        {col:"cell_id", alias:"cell_id"},
                        {col:"cell_name", alias:"cell_name"},
                        {col:"cell_description", alias:"cell_description"},
                        {col:"session_id_uniq", alias:"session_id_uniq"},
                        {col:"total_count", alias:"total_count"},
                        {col:"total_count", alias:"total"},
                    ],
                    rows:[

                    ],
                    view:QoEReportViews.GtpFullFlowAgg,
                    join:{
                        type: "",
                        stringency: "",
                        view:{
                            values:[
                                {col:"", alias:"uli_time", func: "max(uli_time)"},
                                {col:"", alias:"time", func: "max(time)"},
                                {col:"", alias:"date", func: "max(date)"}

                            ],
                            rows:[
                                {col:"imsi", alias:"imsi"},
                                {col:"msisdn", alias:"msisdn"},
                                {col:"imei", alias:"imei"},
                                {col:"dpi_id", alias:"dpi_id"}
                            ],
                            table:QoEReportTablesEnum.GtpFlowAgg,
                            flags:{
                                use_sort:0,
                                use_size:0,
                                use_having:0,
                                use_where:0
                            }
                        },
                        using:[
                            "imsi",
                            "msisdn",
                            "imei",
                            "uli_time",
                            "dpi_id",
                            "time",
                            "date"
                        ]
                    },
                    flags: {
                        use_sort:0,
                        use_size:0,
                        use_having:0
                    },
                    limit:100000,
                    cache:{
                        enabled:1,
                        values: [
                            {col:"", alias:"id", func:"concat(toString(imsi),'_', toString(msisdn),'_', toString(imei),'_', toString(dpi_id),'_', user_ipv4,'_', user_ipv6,'_', toString(uli_time),'_', toString(time))"},
                            {col:"time", alias:"time", func: ""},
                            {col:"date", alias:"date", func: ""},
                            {col:"imsi", alias:"imsi", func: ""},
                            {col:"msisdn", alias:"msisdn", func: ""},
                            {col:"imei", alias:"imei", func: ""},
                            {col:"dpi_id", alias:"dpi_id", func: ""},
                            {col:"user_ipv4", alias:"user_ipv4", func: ""},
                            {col:"user_ipv6", alias:"user_ipv6", func: ""},
                            {col:"uli_mcc", alias:"uli_mcc", func: ""},
                            {col:"country_description", alias:"country_description", func: ""},
                            {col:"uli_mnc", alias:"uli_mnc", func: ""},
                            {col:"network_description", alias:"network_description", func: ""},
                            {col:"uli_tac", alias:"uli_tac", func: ""},
                            {col:"uli_eci", alias:"uli_eci", func: ""},
                            {col:"uli_time", alias:"uli_time", func: ""},
                            {col:"lat", alias:"lat", func: ""},
                            {col:"lon", alias:"lon", func: ""},
                            {col:"cell_id", alias:"cell_id", func: ""},
                            {col:"cell_name", alias:"cell_name", func: ""},
                            {col:"cell_description", alias:"cell_description", func: ""},
                            {col:"session_id_uniq", alias:"session_id_uniq", func: ""},
                            {col:"total_count", alias:"total_count", func: ""}
                        ],
                        flags:{
                            use_where:0,
                            use_having:0
                        }
                    }
                },
                footer:false,
                columns:[
                    {
                        id:"date",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Date")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:96,
                        fillspace:true
                    },
                    {
                        id:"last_fixed_time",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Time")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:96,
                        fillspace:true,
                        template: function(Obj)
                        {
                            if(Obj && Obj.last_fixed_time)
                            {
                                var time = Obj.last_fixed_time.split(" ");

                                if(time.length > 1)
                                {
                                    return time[1];
                                }
                            }
                            return "";
                        }
                    },
                    {
                        id:"uli_time",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Time of ULI")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"imsi",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "SIM card number")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"msisdn",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Phone number")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"imei",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "IMEI")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"user_ipv4",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Subscriber ipv4 address")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"user_ipv6",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Subscriber ipv6 address")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },

                    {
                        id:"uli_mcc",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Mobile country code")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id: "country_description",
                        header: [
                            TooltipTemplate(LangHelper.GetString("QoE", "Country name")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true,
                    },
                    {
                        id:"uli_mnc",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Mobile network (operator) code")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id: "network_description",
                        header: [
                            TooltipTemplate(LangHelper.GetString("QoE", "Network (operator) name")),
                            {
                                content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true,
                    },
                    {
                        id:"uli_tac",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Service/Tracking area code")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"uli_eci",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Base station code")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"dpi_id",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"total_count",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Total")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"session_id_uniq",
                        header:[
                            TooltipTemplate(LangHelper.GetString("QoE", "Sessions")),
                            {
                                content: "textFilter",
                                placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                            }
                        ],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"cell_lat", header:[TooltipTemplate(LangHelper.GetString("QoE", "Latitude")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"cell_lon", header:[TooltipTemplate(LangHelper.GetString("QoE", "Longitude")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    },
                    {
                        id:"cell_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        sort:"string",
                        fillspace:true,
                        minWidth:160
                    },
                    {
                        id:"cell_name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        sort:"string",
                        fillspace:true,
                        minWidth:160
                    },
                    {
                        id:"cell_description", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        sort:"string",
                        minWidth:160,
                        fillspace:true
                    }
                ],
                leftSplit:0,
                export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
            })
        },
        map:{
            gravity:2,
            widget: new QoEMapsReportWidget({
                id:id + "Map",
                name:name,
                noRefresh: true,
                layers: {
                    SubscribersLocationLayer: new QoEPointsLayerWidget({
                        id: id + "MapSubscribersLocationLayer",
                        title:LangHelper.GetString("QoE", "Subscribers location"),
                        icon:"street-view",
                        name:"SubscribersLocationLayer",
                        layer_config:{
                            type: "Vector",
                            default_style: {point: webix.skin.$active.defaultMapHumanStyle},
                            item_config: {
                                type: "Point",
                                get_feature_by_id: "point_data_transform",
                                point_data_transform:{
                                    id: {value: "id"},
                                    lat: {value: "cell_lat"},
                                    // lat: {value: "lat"},
                                    lon: {value: "cell_lon"},
                                    // lon: {value: "lon"},
                                    data: [
                                        {
                                            value: "session_id_uniq",
                                            title: LangHelper.GetString("QoE", "Sessions")
                                        },
                                        {
                                            "value": "uli_time",
                                            title: LangHelper.GetString("QoE", "Time")
                                        },
                                        {
                                            value: "imsi",
                                            title: LangHelper.GetString("QoE", "SIM card number")
                                        },
                                        {
                                            value: "msisdn",
                                            title: LangHelper.GetString("QoE", "Phone number")
                                        },
                                        {
                                            value: "imei",
                                            title: LangHelper.GetString("QoE", "IMEI")
                                        },
                                        {
                                            value: "dpi_id",
                                            title: LangHelper.GetString("QoE", "DPI ID")
                                        },
                                        {
                                            value: "uli_eci",
                                            title: LangHelper.GetString("QoE", "Base station code")
                                        },
                                        {
                                            value: "uli_mcc",
                                            title: LangHelper.GetString("QoE", "Mobile country code")
                                        },
                                        {
                                            value: "uli_mnc",
                                            title: LangHelper.GetString("QoE", "Mobile network (operator) code")
                                        },
                                        {
                                            value: "uli_tac",
                                            title: LangHelper.GetString("QoE", "Service/Tracking area code")
                                        }
                                    ]
                                }
                            }
                        }
                    })
                }
            })
        }
    });
};

var QoETableNatWidget = function (Params)
{
    var values = {
        time_part:[
            {col:"time", alias:"time"}
        ],
        main_part:[
            {col:"protocol_identifier", alias:"net_protocol_code"},
            {col:"", alias:"net_protocol", func:"protocol_identifier ? concat(dictGetStringOrDefault('net_protocols_dic', 'description', toUInt64(protocol_identifier), toString(protocol_identifier)),' ', toString(protocol_identifier)) : '0'"},
            {col:"event_type", alias:"event_type"},
            {col:"source_ipv4", alias:"source_ipv4"},
            {col:"source_port", alias:"source_port"},
            {col:"destination_ipv4", alias:"destination_ipv4"},
            {col:"destination_port", alias:"destination_port"},
            {col:"post_nat_source_ipv4", alias:"post_nat_source_ipv4"},
            {col:"post_nat_source_port", alias:"post_nat_source_port"},
            {col:"session_id", alias:"session_id"},
            {col:"login", alias:"login"},
            {col:"dpi_id", alias:"dpi_id"}
        ],
        agg_part:[
            {col:"", alias:"total", func:QoEReportFunctions.Total},
            {col:"", alias:"sessions_uniq", func:QoEReportFunctions.SessionsUniq}
        ]
    };

    var rows = {
        time_part:[
            {col:"time", alias:"time"}
        ],
        main_part:[
            {col:"protocol_identifier", alias:"protocol_identifier"},
            {col:"event_type", alias:"event_type"},
            {col:"source_ipv4", alias:"source_ipv4"},
            {col:"source_port", alias:"source_port"},
            {col:"destination_ipv4", alias:"destination_ipv4"},
            {col:"destination_port", alias:"destination_port"},
            {col:"post_nat_source_ipv4", alias:"post_nat_source_ipv4"},
            {col:"post_nat_source_port", alias:"post_nat_source_port"},
            {col:"session_id", alias:"session_id"},
            {col:"login", alias:"login"},
            {col:"dpi_id", alias:"dpi_id"}
        ]
    };

    var columns = {
        time_part:[
            {
                id:"time", header:[TooltipTemplate(LangHelper.GetString("QoE", "Time")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            }
        ],
        main_part:[
            {
                id:"source_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source IPv4-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"source_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"destination_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination IPv4-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"destination_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"post_nat_source_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Post nat source IPv4-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"post_nat_source_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Post nat source port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"login", header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string",
                template:function (Obj){return Obj.login_any ? Obj.login_any : Obj.login;}
            },
            {
                id:"session_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Session ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"net_protocol", header:[TooltipTemplate(LangHelper.GetString("QoE", "Net protocol")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"event_type", header:[TooltipTemplate(LangHelper.GetString("QoE", "Event type")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"dpi_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string", fillspace:true, minWidth:80
            }
        ],
        agg_part:[
            {
                id:"total",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Total")),null
                ],
                sort:"string",
                minWidth:160
            },
            {
                id:"sessions_uniq",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Sessions")),null
                ],
                sort:"string",
                minWidth:160
            }
        ]
    };

    wgTypesEnum = {
        raw:"raw",
        agg:"agg",
        top_subs:"top_subs",
        top_hosts:"top_hosts",
        top_post_nat_ips:"top_post_nat_ips",
    };

    wgType = Params&&Params.wg_type?Params.wg_type : wgTypesEnum.raw;

    var title, name, sort, wgType, wgTypesEnum, table;

    sort =  "time";

    if(wgType == wgTypesEnum.raw)
    {
        table = QoEReportTablesEnum.NatFlowRaw;

        name = Params&&Params.name?Params.name : ("QoETableNatflowRawLogWidget");

        title = LangHelper.GetString("QoE", "NAT flow raw log");

        values = [].concat.apply([], [values.time_part, values.main_part]);

        columns = [].concat.apply([], [columns.time_part, columns.main_part]);

        rows = [];
    }

    else if(wgType == wgTypesEnum.agg)
    {
        table = QoEReportTablesEnum.NatFlowAgg;

        name = Params&&Params.name?Params.name : ("QoETableNatflowAggLogWidget");

        title = LangHelper.GetString("QoE", "NAT flow aggregated log");

        columns = [].concat.apply([], [columns.time_part, columns.main_part, columns.agg_part]);

        rows = [].concat.apply([], [rows.time_part, rows.main_part]);

        values = [].concat.apply([], [values.time_part, values.main_part, values.agg_part]);
    }

    else if(wgType == wgTypesEnum.top_subs)
    {
        table = QoEReportTablesEnum.NatFlowAgg;

        name = Params&&Params.name?Params.name : ("QoETableNatflowAggTopSubscribersWidget");

        title = LangHelper.GetString("QoE", "Top subscribers");

        var loginColumn = columns.main_part[6]; loginColumn.sort_map = {"login":"login_any"}; loginColumn.fillspace = true;

        var subsColumn = columns.main_part[0]; subsColumn.fillspace = true;

        columns = [].concat.apply([], [[columns.main_part[0],loginColumn], columns.agg_part]);

        rows = [].concat.apply([], [rows.main_part[2], rows.main_part[9]]);

        values = [].concat.apply([], [rows, [{col:"login", alias:"login_any",func:"any"}], values.agg_part]);

        sort =  "total";
    }

    else if(wgType == wgTypesEnum.top_hosts)
    {
        table = QoEReportTablesEnum.NatFlowAgg;

        name = Params&&Params.name?Params.name : ("QoETableNatflowAggTopHostsIpsWidget");

        title = LangHelper.GetString("QoE", "Top hosts IPs");

        var destinationColumn = columns.main_part[2]; destinationColumn.fillspace = true;

        columns = [].concat.apply([], [[destinationColumn], columns.agg_part]);

        rows = [].concat.apply([], [rows.main_part[4]]);

        values = [].concat.apply([], [rows, values.agg_part]);

        sort =  "total";
    }

    else if(wgType == wgTypesEnum.top_post_nat_ips)
    {
        table = QoEReportTablesEnum.NatFlowAgg;

        name = Params&&Params.name?Params.name : ("QoETableNatflowAggTopPostNatIpsWidget");

        title = LangHelper.GetString("QoE", "Top post NAT IPs");

        var postNatColumn = columns.main_part[4]; postNatColumn.fillspace = true;

        columns = [].concat.apply([], [[postNatColumn], columns.agg_part]);

        rows = [].concat.apply([], [rows.main_part[6]]);

        values = [].concat.apply([], [rows, values.agg_part]);

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:table,
            values:values,
            rows:rows,
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_sort:0
            },
            limit:1000000,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:false,
        columns:columns,
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        enableRowContextMenu: true,
        can_use_sort_map:{
            "ReportsSettings": 1
        }
    };

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNatflowRawLogWidget= function (Params)
{
    var params = webix.extend({wg_type:"raw"}, Params, true);

    return QoETableNatWidget(params);
};

var QoETableNatflowAggLogWidget= function (Params)
{
    var params = webix.extend({wg_type:"agg"}, Params, true);

    return QoETableNatWidget(params);
};

var QoETableNatflowAggTopSubscribersWidget= function (Params)
{
    var params = webix.extend({wg_type:"top_subs"}, Params, true);

    return QoETableNatWidget(params);
};

var QoETableNatflowAggTopHostsIpsWidget= function (Params)
{
    var params = webix.extend({wg_type:"top_hosts"}, Params, true);

    return QoETableNatWidget(params);
};

var QoETableNatflowAggTopPostNatIpsWidget= function (Params)
{
    var params = webix.extend({wg_type:"top_post_nat_ips"}, Params, true);

    return QoETableNatWidget(params);
};

var QoETableTopVchannelsWidget = function (Params, Online)
{
    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top vchannels with high RTT");

    var name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopRttVchannelsWidget";

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top vchannels with high traffic");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopTrafficVchannelsWidget";

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title = LangHelper.GetString("QoE", "Top vchannels with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopRetransmitsVchannelsWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top vchannels with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopFlowVchannelsWidget";

        sort =  "flow";
    }

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:
                [].concat(common.values),
            rows:[
                "bridge_vchannel"
            ],
            sort:{id:sort, dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            remember_field:(Online ? {alias:"bridge_vchannel", func:"bridge_vchannel"}: Online),
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"bridge_vchannel",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannel/Bridge")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"}
                }
            ].concat(common.columns),
        leftSplit:1
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,7);
            params.columns = params.columns.slice(0,7);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }
        else if(Params.top_flow)
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }
        else
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:1
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoEPieChartTopRttVchannelsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top vchannels with high RTT"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopRttVchannelsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                "bridge_vchannel"
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "rtt":LangHelper.GetString("QoE", "RTT"),
                "bridge_vchannel":LangHelper.GetString("QoE", "Vchannel/Bridge")
            }
        },
        export_pdf_config:{
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top vchannels with high RTT"),
            pie_chart_key:"bridge_vchannel",
            locales: {
                "legend_title": "vchannel_bridge"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopRttVchannelsWidget = function (Params, Online)
{
    return QoETableTopVchannelsWidget(Params, Online);
};

var QoETableTopRttVchannelsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopRttVchannelsShortWidget", short:true}, Params, true);

    return QoETableTopRttVchannelsWidget(params, Online);
};

var QoEPieChartTopTrafficVchannelsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top vchannels with high traffic"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopTrafficVchannelsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                "bridge_vchannel"
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "traffic":LangHelper.GetString("QoE", "Traffic"),
                "bridge_vchannel":LangHelper.GetString("QoE", "Vchannel/Bridge")
            }
        },
        export_pdf_config:{
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top vchannels with high traffic"),
            pie_chart_key:"bridge_vchannel",
            locales: {
                "legend_title": "vchannel_bridge"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopTrafficVchannelsWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableTopVchannelsWidget(params, Online);
};

var QoETableTopTrafficVchannelsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopTrafficVchannelsShortWidget", short:true}, Params, true);

    return QoETableTopTrafficVchannelsWidget(params, Online);
};

var QoEPieChartTopRetransmitsVchannelsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top vchannels with high retransmits"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopRetransmitsVchannelsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                "bridge_vchannel"
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config:{
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top vchannels with high retransmits"),
            pie_chart_key:"bridge_vchannel",
            locales: {
                "legend_title": "vchannel_bridge"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopRetransmitsVchannelsWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableTopVchannelsWidget(params, Online);
};

var QoETableTopRetransmitsVchannelsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopRetransmitsVchannelsShortWidget", short:true}, Params, true);

    return QoETableTopRetransmitsVchannelsWidget(params, Online);
};

var QoESeriesChartTrafficByVchannelsWidget = function (Params, Online)
{
    return new QoESeriesChartReportWidget({
        title:LangHelper.GetString("QoE", "Traffic by vchannels"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name: "QoE" + (Online ? "Online" : "") + "SeriesChartTrafficByVchannelsWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"traffic_speed_bps", alias:"speed", func:"avg"}
                ],
                rows:
                    [
                        {col:"time", alias:"time_step", func:"toStartOfAuto"}
                    ],
                cols:[
                    {
                        col:"bridge_vchannel",
                        alias:"{col_value}",
                        func:"",
                        values:{func:"GetTopList", params:{table:QoEReportTablesEnum.FullnetflowAgg, view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow, row:"bridge_vchannel", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond, limit:50}},
                        condition:"==",
                        sql_tpl:Helper.ReplaceAll("{condition}", "bridge_vchannel == toString({col_value})", QoEReportFunctions.AvgTrafficSpeedBitsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
                    }
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:"bridge_vchannel",
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    }
                },
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
                }
            },
        legend:
            {
                height:160,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Traffic by vchannels"),
                abscise_key: "time_step",
                units: TrafficSpeedBitUnits,
                divider: 1000,
                locales: {
                    "legend_title": "vchannel_bridge"
                }
            }
    });
};

var QoETableNetflowTopTrafficVchannelsTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficVchannelsTableChartWidget",
        table:{
            widget: QoETableTopTrafficVchannelsShortWidget({id:id + "TrafficByVchannelsTable", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartTrafficByVchannelsWidget({id:id + "TrafficByVchannelsChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopFlowVchannelsWidget = function (Params, Online)
{
    var name = Params&&Params.name?Params.name:"QoETableNetflowTopFlowVchannelsWidget";

    var params = webix.extend({name:name, top_flow:true}, Params, true);

    return QoETableTopVchannelsWidget(params, Online);
};

var QoETableNetflowTopFlowVchannelsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETableNetflowTopFlowVchannelsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowVchannelsWidget(params, Online);
};

var QoEPieChartTopFlowVchannelsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top vchannels with high flow"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopFlowVchannelsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view?Params.view:QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"flow", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond}
            ],
            rows:[
                "bridge_vchannel"
            ],
            sort:{id:"flow",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config:{
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top vchannels with high flow"),
            pie_chart_key:"bridge_vchannel",
            locales: {
                "legend_title": "vchannel_bridge"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoESeriesChartFlowByVchannelsWidget = function (Params, Online)
{
    var params = {
        title:LangHelper.GetString("QoE", "Flow by vchannels"),
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByVchannelsWidget",
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"flow_speed_pkts", alias:"speed", func:"avg"}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                cols:[
                    {
                        col:"bridge_vchannel",
                        alias:"{col_value}",
                        func:"",
                        values:{func:"GetTopList", params:{table:QoEReportTablesEnum.FullnetflowAgg, view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow, row:"bridge_vchannel", func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond, limit:100}},
                        condition:"==",
                        sql_tpl:Helper.ReplaceAll("{condition}", "bridge_vchannel == toString({col_value})", QoEReportFunctions.AvgTrafficSpeedPktsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
                    }
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:"bridge_vchannel",
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    }
                },
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, NetFlowSpeedUnits);
                }
            },
        legend:
            {
                height:160,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Flow by vchannels"),
                abscise_key: "time_step",
                units: NetFlowSpeedUnits,
                divider: 1000,
                locales: {
                    "legend_title": "vchannel_bridge"
                }
            }
    };

    return new QoESeriesChartReportWidget(params);
};

var QoESeriesChartFlowByVchannelsTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByVchannelsTableChartWidget",
        table:{
            widget: QoETableNetflowTopFlowVchannelsShortWidget({id:id + "FlowByVchannelsTable", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartFlowByVchannelsWidget({id:id + "FlowByVchannelsChart", table, view}, Online)
        }
    });
};

var QoEPieChartClickstreamTopVchannelsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top vchannels") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartClickstreamTopVchannelsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"}
            ],
            rows:[
                "bridge_vchannel"
            ],
            sort:{id:"total",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top vchannels") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
            pie_chart_key: "bridge_vchannel",
            locales: {
                "legend_title": "vchannel_bridge"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableClickstreamTopVchannelsWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top vchannels") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopVchannelsBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top vchannels") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopVchannelsByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top vchannels") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopVchannelsByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top vchannels") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopVchannelsByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top vchannels") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopVchannelsWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top vchannels") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopVchannelsWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:
                [].concat(values),
            rows:[
                "bridge_vchannel"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"bridge_vchannel",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannel/Bridge")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                }
            ].concat(columns),
        leftSplit:1,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        sort_map:{"login":"login_any"},
        can_use_sort_map:{
            "ReportsSettings": 1
        }
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopVchannelsBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopVchannelsBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopVchannelsWidget(params);
};

var QoETableClickstreamTopVchannelsByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopVchannelsByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopVchannelsWidget(params);
};

var QoETableClickstreamTopVchannelsByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopVchannelsByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopVchannelsWidget(params);
};

var QoETableClickstreamTopVchannelsByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopVchannelsByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopVchannelsWidget(params);
};

var QoEPieChartClickstreamTopLoginsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top logins") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartClickstreamTopLoginsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"}
            ],
            rows:[
                "login"
            ],
            sort:{id:"total",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top logins") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
            pie_chart_key: "login",
            locales: {
                "legend_title": "login"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableClickstreamTopLoginsWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top logins") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopLoginsBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top logins") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopLoginsByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top logins") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopLoginsByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top logins") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopLoginsByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top logins") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopLoginsWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top logins") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopLoginsWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:
                [].concat(values),
            rows:[
                "login"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"login",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                }
            ].concat(columns),
        leftSplit:1,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopLoginsBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopLoginsBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopLoginsWidget(params);
};

var QoETableClickstreamTopLoginsByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopLoginsByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopLoginsWidget(params);
};

var QoETableClickstreamTopLoginsByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopLoginsByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopLoginsWidget(params);
};

var QoETableClickstreamTopLoginsByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopLoginsByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopLoginsWidget(params);
};


var QoETableTopClassesWidget = function (Params, Online)
{
    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top classes with high RTT");

    var name = Params&&Params.name?Params.name : "QoETable" + (Online ? "Online" : "") + "TopRttClassesWidget";

    var remember_field = (Online ? {alias:"ip_class_of_service_class", func:"ip_class_of_service_class"}: Online);

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top classes with high traffic");

        name = Params&&Params.name?Params.name : "QoETable" + (Online ? "Online" : "") + "TopTrafficClassesWidget";

        if(Params.full_dscp)
        {
            title = LangHelper.GetString("QoE", "Top DSCP classes with high traffic");
            name = Params&&Params.name?Params.name : "QoETable" + (Online ? "Online" : "") + "TopTrafficFullDscpClassesShortWidget";
            remember_field = (Online ? {alias:"ip_class_of_service_full", func:"ip_class_of_service_full"}: Online);
        }

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title = LangHelper.GetString("QoE", "Top classes with high retransmits");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopRetransmitsClassesWidget";

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title = LangHelper.GetString("QoE", "Top classes with high flow");

        name = Params&&Params.name?Params.name :"QoETable" + (Online ? "Online" : "") + "TopFlowClassesWidget";

        if(Params.full_dscp)
        {
            title = LangHelper.GetString("QoE", "Top DSCP classes with high flow");
            name = Params&&Params.name?Params.name : "QoETable" + (Online ? "Online" : "") + "TopFlowFullDscpClassesShortWidget";
            remember_field = (Online ? {alias:"ip_class_of_service_full", func:"ip_class_of_service_full"}: Online);
        }

        sort =  "flow";
    }

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            values:
                [].concat(common.values),
            rows: Params&&Params.full_dscp ? ["ip_class_of_service_full"] : ["ip_class_of_service_class"],
            sort:{id:sort, dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            remember_field:remember_field,
            online:Online,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:Params&&Params.full_dscp ? "ip_class_of_service_full" : "ip_class_of_service_class",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", Params&&Params.full_dscp ? "DSCP" : "Class")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"}
                }
            ].concat(common.columns),
        leftSplit:1
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,7);
            params.columns = params.columns.slice(0,7);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }
        else if(Params.top_flow)
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }
        else
        {
            params.config.values = params.config.values.slice(0,4);
            params.columns = params.columns.slice(0,4);
        }

        params.columns.push({
            id:"empty",
            header:"",
            fillspace:1
        });
    }

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoEPieChartTopRttClassesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top classes with high RTT"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopRttClassesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:[
                "ip_class_of_service_class"
            ],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "rtt":LangHelper.GetString("QoE", "RTT"),
                "ip_class_of_service_class":LangHelper.GetString("QoE", "Class")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top classes with high RTT"),
            pie_chart_key: "ip_class_of_service_class",
            locales: {
                "legend_title": "vchannel_bridge"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopRttClassesWidget = function (Params, Online)
{
    return QoETableTopClassesWidget(Params, Online);
};

var QoETableTopRttClassesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopRttClassesShortWidget", short:true}, Params, true);

    return QoETableTopRttClassesWidget(params, Online);
};

var QoEPieChartTopTrafficClassesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top classes with high traffic"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopTrafficClassesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:[
                "ip_class_of_service_class"
            ],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "traffic":LangHelper.GetString("QoE", "Traffic"),
                "ip_class_of_service_class":LangHelper.GetString("QoE", "Class")
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top classes with high traffic"),
            pie_chart_key: "ip_class_of_service_class",
            locales: {
                "legend_title": "class"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopTrafficClassesWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableTopClassesWidget(params, Online);
};

var QoETableTopTrafficClassesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopTrafficClassesShortWidget", short:true}, Params, true);

    return QoETableTopTrafficClassesWidget(params, Online);
};

var QoETableTopTrafficFullDscpClassesShortWidget = function (Params, Online)
{
    var params = webix.extend({
        name:"QoETable" + (Online ? "Online" : "") + "TopTrafficFullDscpClassesShortWidget",
        title: LangHelper.GetString("QoE", "Top DSCP classes with high traffic"),
        short:true,
        full_dscp:true
    }, Params, true);

    return QoETableTopTrafficClassesWidget(params, Online);
};

var QoEPieChartTopRetransmitsClassesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top classes with high retransmits"),
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartTopRetransmitsClassesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:[
                "ip_class_of_service_class"
            ],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title:LangHelper.GetString("QoE", "Top classes with high retransmits"),
            pie_chart_key: "ip_class_of_service_class",
            locales: {
                "legend_title": "class"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableTopRetransmitsClassesWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableTopClassesWidget(params, Online);
};

var QoETableTopRetransmitsClassesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "TopRetransmitsClassesShortWidget", short:true}, Params, true);

    return QoETableTopRetransmitsClassesWidget(params, Online);
};

var QoESeriesChartTrafficByFullDscpClassesWidget = function (Params, Online)
{
    var params = webix.extend({
        title:LangHelper.GetString("QoE", "Traffic by DSCP"),
        name:"QoESeriesChart" + (Online ? "Online" : "") + "TrafficByFullDscpClassesWidget",
        col:"ip_class_of_service_full",
        short:true,
        full_dscp:true
        }, Params, true);

    return QoESeriesChartTrafficByClassesWidget(params, Online);
};

var QoESeriesChartTrafficByClassesWidget = function (Params, Online)
{
    var title = LangHelper.GetString("QoE", "Traffic by classes");
    var name = "QoE" + (Online ? "Online" : "") + "SeriesChartTrafficByClassesWidget";
    var col = "ip_class_of_service_class";

    if(Params&&Params.full_dscp)
    {
        title = Params.title?Params.title:LangHelper.GetString("QoE", "Traffic by DSCP");
        name = Params.name?Params.name:"QoESeriesChart" + (Online ? "Online" : "") + "TrafficByFullDscpClassesWidget";
        col = Params.col?Params.col:"ip_class_of_service_full"
    }

    return new QoESeriesChartReportWidget({
        title:title,
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"traffic_speed_bps", alias:"speed", func:"avg"}
                ],
                rows:
                    [
                        {col:"time", alias:"time_step", func:"toStartOfAuto"}
                    ],
                cols:[
                    {
                        col:col,
                        alias:"{col_value}",
                        func:"",
                        values:{func:"GetTopList", params:{table:QoEReportTablesEnum.FullnetflowAgg, view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow, row:col, func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond, limit:50}},
                        condition:"==",
                        sql_tpl:Helper.ReplaceAll("{condition}", `${col} == toString({col_value})`, QoEReportFunctions.AvgTrafficSpeedBitsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
                    }
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:col,
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    }
                },
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
                }
            },
        legend:
            {
                height:160,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Traffic by classes"),
                abscise_key: "time_step",
                units: TrafficSpeedBitUnits,
                divider: 1000,
                locales: {
                    "legend_title": "class"
                }
            }
    });
};

var QoETableNetflowTopTrafficClassesTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficClassesTableChartWidget",
        table:{
            widget: QoETableTopTrafficClassesShortWidget({id:id + "TrafficByClassesTable", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartTrafficByClassesWidget({id:id + "TrafficByClassesChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopFullDscpTrafficClassesTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null;

    return new QoETableChartWidget({
        id:id,
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFullDscpTrafficClassesTableChartWidget",
        table:{
            widget: QoETableTopTrafficFullDscpClassesShortWidget({id:id + "TrafficByFullDscpClassesTable", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartTrafficByFullDscpClassesWidget({id:id + "TrafficByFullDscpClassesChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopFlowClassesWidget = function (Params, Online)
{
    var params = webix.extend({top_flow:true}, Params, true);

    return QoETableTopClassesWidget(params, Online);
};

var QoETableNetflowTopFlowClassesShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowClassesShortWidget", short:true}, Params, true);

    return QoETableNetflowTopFlowClassesWidget(params, Online);
};

var QoESeriesChartFlowByClassesWidget = function (Params, Online)
{
    var title = LangHelper.GetString("QoE", "Flow by classes");
    var name = "QoE" + (Online ? "Online" : "") + "SeriesChartFlowByClassesWidget";
    var col = "ip_class_of_service_class";

    if(Params&&Params.full_dscp)
    {
        title = Params.title?Params.title:LangHelper.GetString("QoE", "Flow by DSCP");
        name = Params.name?Params.name:"QoESeriesChart" + (Online ? "Online" : "") + "FlowByFullDscpClassesWidget";
        col = Params.col?Params.col:"ip_class_of_service_full"
    }

    var params = {
        title:title,
        icon:"area-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:
            {
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
                view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
                values:[
                    {col:"flow_speed_pkts", alias:"speed", func:"avg"}
                ],
                rows:[
                    {col:"time", alias:"time_step", func:"toStartOfAuto"}
                ],
                cols:[
                    {
                        col:col,
                        alias:"{col_value}",
                        func:"",
                        values:{func:"GetTopList", params:{table:QoEReportTablesEnum.FullnetflowAgg, view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow, row:col, func:QoEReportFunctions.AvgTrafficSpeedPktsPerSecond, limit:100}},
                        condition:"==",
                        sql_tpl:Helper.ReplaceAll("{condition}", `${col} == toString({col_value})`, QoEReportFunctions.AvgTrafficSpeedPktsPerSecondIf_ForChartSerie)+" as `{col_value_as_alias}`"
                    }
                ],
                sort:{id:"time_step",dir:"asc"},
                limit:1000,
                flags:{
                    use_size:0,
                    use_where:0
                },
                online:Online,
                cache:{
                    enabled:1,
                    values: ["time_step"],
                    cols:[
                        {
                            col:col,
                            alias:"{col_value}"
                        }
                    ],
                    flags:{
                        use_where:0,
                        use_having:0,
                        use_cache_saved_cols:1
                    }
                }
            },
        type:"splineArea",
        xAxis:
            {
                template:function(Val)
                {
                    return Online ? Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true) : Helper.FormatDateTimeForChartXAxes(Val);
                }
            },
        yAxis:
            {
                template: function (Val)
                {
                    return Helper.UnitPrefixToNumeric(Val, 1000, NetFlowSpeedUnits);
                }
            },
        legend:
            {
                height:160,
                align: "left",
                valign: "bottom",
                layout:"x",
                values:[]
            },
        export_pdf_config:
            {
                view_type: "chart",
                title: LangHelper.GetString("QoE", "Flow by classes"),
                abscise_key: "time_step",
                units: NetFlowSpeedUnits,
                divider: 1000,
                locales: {
                    "legend_title": "class"
                }
            }
    };
    return new QoESeriesChartReportWidget(params);
};

var QoESeriesChartFlowByClassesTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null

    return new QoETableChartWidget({
        id:id,
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByClassesTableChartWidget",
        table:{
            widget: QoETableNetflowTopFlowClassesShortWidget({id:id + "FlowByClassesTable", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartFlowByClassesWidget({id:id + "FlowByClassesChart", table, view}, Online)
        }
    });
};

var QoESeriesChartFlowByFullDscpClassesTableChartWidget = function (Params, Online)
{
    var id = Params&&Params.id?Params.id:webix.uid();
    var table = Params&&Params.table?Params.table:null;
    var view = Params&&Params.view?Params.view:null

    return new QoETableChartWidget({
        id:id,
        name:"QoE" + (Online ? "Online" : "") + "SeriesChartFlowByFullDscpClassesTableChartWidget",
        table:{
            widget: QoETableNetflowTopFlowByFullDscpClassesShortWidget({id:id + "FlowByFullDscpClassesTable", table, view}, Online)
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartFlowByFullDscpClassesWidget({id:id + "FlowByFullDscpClassesChart", table, view}, Online)
        }
    });
};

var QoETableNetflowTopFlowByFullDscpClassesShortWidget = function (Params, Online)
{
    var params = webix.extend({
        name:"QoETable" + (Online ? "Online" : "") + "NetflowTopFlowByFullDscpClassesShortWidget",
        title: LangHelper.GetString("QoE", "Top DSCP classes with high traffic"),
        short:true,
        full_dscp:true
    }, Params, true);

    return QoETableNetflowTopFlowClassesWidget(params, Online);
};

var QoESeriesChartFlowByFullDscpClassesWidget = function (Params, Online)
{
    var params = webix.extend({
        title:LangHelper.GetString("QoE", "Flow by DSCP"),
        name:"QoESeriesChart" + (Online ? "Online" : "") + "FlowByFullDscpClassesWidget",
        col:"ip_class_of_service_full",
        short:true,
        full_dscp:true
    }, Params, true);

    return QoESeriesChartFlowByClassesWidget(params, Online);
};

var QoEPieChartClickstreamTopClassesWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top classes") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoEPieChartClickstreamTopClassesWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:[
                {col:"total_count", alias:"total", func:"countMerge"}
            ],
            rows:[
                "ip_class_of_service_class"
            ],
            sort:{id:"total",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableClickstreamTopClassesWidget = function (Params)
{
    var common = QoETableClickstreamTopCommonConfig();

    var title, name, sort = "total", values = [], columns = [];

    var view = QoEReportViews.ClickStream;

    if(Params&&Params.by_sessions)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]]]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]]]);

        title = LangHelper.GetString("QoE", "Top classes") + " " + LangHelper.GetString("QoE", "By sessions").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopClassesBySessionsWidget");

        sort =  "sessons_uniq";
    }
    else if(Params&&Params.by_traffic)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_traffic]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_traffic]);

        title = LangHelper.GetString("QoE", "Top classes") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopClassesByTrafficWidget");

        sort =  "traffic";
    }
    else if(Params&&Params.by_flow)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_flow]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_flow]);

        title = LangHelper.GetString("QoE", "Top classes") + " " + LangHelper.GetString("QoE", "By flow").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopClassesByFlowWidget");

        sort =  "flow";
    }
    else if(Params&&Params.by_rtt)
    {
        values = [].concat.apply([], [[common.values[0], common.values[1]], common.values_netflow.fullflow_rtt]);

        columns = [].concat.apply([], [[common.columns[0], common.columns[1]], common.columns_netflow.fullflow_rtt]);

        title = LangHelper.GetString("QoE", "Top classes") + " " + LangHelper.GetString("QoE", "By RTT").toLowerCase() + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopClassesByFlowWidget");

        sort =  "rtt_median";
    }
    else if(Params&&Params.full)
    {
        values = [].concat.apply([], [
            common.values,
            common.values_netflow.fullflow_rtt,
            common.values_netflow.fullflow_traffic,
            common.values_netflow.fullflow_flow
        ]);

        columns = [].concat.apply([], [
            common.columns,
            common.columns_netflow.fullflow_rtt,
            common.columns_netflow.fullflow_traffic,
            common.columns_netflow.fullflow_flow
        ]);

        title = LangHelper.GetString("QoE", "Top classes") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopClassesWidget");

        sort =  "total";
    }
    else
    {
        values = [].concat.apply([], [common.values]);

        columns = [].concat.apply([], [common.columns]);

        title = LangHelper.GetString("QoE", "Top classes") + " (" + LangHelper.GetString("AppView", "Clickstream") + ")";

        name = Params&&Params.name?Params.name : ("QoETableClickstreamTopClassesWidget");

        sort =  "total";
    }

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.ClickstreamAgg,
            view:QoEReportViews.ClickStream,
            values:
                [].concat(values),
            rows:[
                "ip_class_of_service_class"
            ],
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where:0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"ip_class_of_service_class",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Class")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                }
            ].concat(columns),
        leftSplit:1,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        sort_map:{"login":"login_any"},
        can_use_sort_map:{
            "ReportsSettings": 1
        }
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableClickstreamTopClassesBySessionsWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopClassesBySessionsWidget", by_sessions:true}, Params, true);

    return QoETableClickstreamTopClassesWidget(params);
};

var QoETableClickstreamTopClassesByTrafficWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopClassesByTrafficWidget", by_traffic:true}, Params, true);

    return QoETableClickstreamTopClassesWidget(params);
};

var QoETableClickstreamTopClassesByFlowWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopClassesByFlowWidget", by_flow:true}, Params, true);

    return QoETableClickstreamTopClassesWidget(params);
};

var QoETableClickstreamTopClassesByRttWidget = function (Params)
{
    var params = webix.extend({name:"QoETableClickstreamTopClassesByRttWidget", by_rtt:true}, Params, true);

    return QoETableClickstreamTopClassesWidget(params);
};



var QoETableNetflowTopGTPCellsWidget = function (Params, Online)
{
    var commonParams = null;

    var title = LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high RTT");

    var name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopGTPCellsWidget");

    var sort =  "rtt_median";

    if(Params && Params.top_traffic)
    {
        commonParams = {columns_order:["traffic", "traffic_from_subscriber", "traffic_to_subscriber", "traffic_vol", "traffic_vol_from_subscriber", "traffic_vol_to_subscriber"]};

        title =  LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high traffic");

        name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficGTPCellsWidget");

        sort =  "traffic";
    }
    else if(Params && Params.top_retransmits)
    {
        commonParams = {columns_order:["retransmits_avg", "retransmits_from_subscriber_avg", "retransmits_to_subscriber_avg"]};

        title =  LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high retransmits");

        name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsGTPCellsWidget");

        sort =  "retransmits_avg";
    }
    else if(Params && Params.top_flow)
    {
        commonParams = {columns_order:["flow", "flow_from_subscriber", "flow_to_subscriber"]};

        title =  LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high flow");

        name = Params&&Params.name?Params.name : ("QoETable" + (Online ? "Online" : "") + "NetflowTopFlowGTPCellsWidget");

        sort =  "flow";
    }

    title += " (" + LangHelper.GetString("AppView", "Netflow") + ")";

    var common = QoETableNetflowTopCommonConfig(commonParams);

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:Online && Params && Params.table ? Params.table : QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view : (Online ? QoEReportViews.OnlineNetflow : QoEReportViews.FullFlow),
            join:Online ? QoEReportViews.GtpOnlineFullFlowAggJoin : QoEReportViews.GtpFullFlowAggJoin,
            values:
                [].concat(common.values),

            rows:[
                "uli_mcc",
                "uli_mnc",
                "uli_tac",
                "uli_eci",
                "cell_id",
                "cell_name"
            ],

            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_where: {
                    "uli_mcc":1,
                    "uli_mnc":1,
                    "uli_tac":1,
                    "uli_eci":1,
                    "cell_id":1,
                    "cell_name":1
                }
            },
            limit:1000000,
            with_totals:true,
            remember_field:false,
            online:Online,
            cache:{
                enabled:1,
                values: [],
                rows:[],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:
            [
                {
                    id:"cell_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true,
                    minWidth:160
                },
                {
                    id:"cell_name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort:"string",
                    fillspace:true,
                    minWidth:160
                },
                {
                    id:"uli_mcc",
                    header:[
                        TooltipTemplate(LangHelper.GetString("QoE", "Mobile country code")),
                        {
                            content: "textFilter",
                            placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                        }
                    ],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id:"uli_mnc",
                    header:[
                        TooltipTemplate(LangHelper.GetString("QoE", "Mobile network (operator) code")),
                        {
                            content: "textFilter",
                            placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                        }
                    ],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id:"uli_tac",
                    header:[
                        TooltipTemplate(LangHelper.GetString("QoE", "Service/Tracking area code")),
                        {
                            content: "textFilter",
                            placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                        }
                    ],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
                {
                    id:"uli_eci",
                    header:[
                        TooltipTemplate(LangHelper.GetString("QoE", "Base station code")),
                        {
                            content: "textFilter",
                            placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                        }
                    ],
                    sort:"string",
                    minWidth:160,
                    fillspace:true
                },
            ].concat(common.columns),
        leftSplit:1,
        filter:{
            "uli_mcc_filter":{id:"uli_mcc", operator:">", value:0, type:"UInt16"},
            "uli_mnc_filter":{id:"uli_mnc", operator:">", value:0, type:"UInt16"},
            "uli_tac_filter":{id:"uli_tac", operator:">", value:0, type:"UInt32"},
            "uli_eci_filter":{id:"uli_eci", operator:">", value:0, type:"UInt32"}
        }
    };

    if(Params&&Params.short)
    {
        if(Params.top_traffic)
        {
            params.config.values = params.config.values.slice(0,12);
            params.columns = params.columns.slice(0,12);
        }
        else if(Params.top_retransmits)
        {
            params.config.values = params.config.values.slice(0,3);
            params.columns = params.columns.slice(0,9);
        }
        else if(Params.top_flow)
        {
            params.config.values = params.config.values.slice(0,9);
            params.columns = params.columns.slice(0,9);
        }
        else
        {
            params.config.values = params.config.values.slice(0,3);
            params.columns = params.columns.slice(0,9);
        }


        params.columns.push({
            id:"empty",
            header:"",
            fillspace:6
        });
    }

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = Col.func_cache ? Col.func_cache : "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetflowTopGTPCellsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopGTPCellsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopGTPCellsWidget(params, Online);
};

var QoEPieChartNetflowTopGTPCellsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopGTPCellsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            join:QoEReportViews.GtpFullFlowAggJoin,
            values:[
                {col:"", alias:"rtt", func:"round(medianIfMerge(rtt_median_if),0)"}
            ],
            rows:["cell_id"],
            sort:{id:"rtt",dir:"desc"},
            size:10,
            flags:{
                use_where: {
                    "cell_id":1,
                    "uli_eci":1,
                    "uli_mcc":1,
                    "uli_mnc":1,
                    "uli_tac":1
                }
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        filter:{
            "uli_mcc_filter":{id:"uli_mcc", operator:">", value:0, type:"UInt16"},
            "uli_mnc_filter":{id:"uli_mnc", operator:">", value:0, type:"UInt16"},
            "uli_tac_filter":{id:"uli_tac", operator:">", value:0, type:"UInt32"},
            "uli_eci_filter":{id:"uli_eci", operator:">", value:0, type:"UInt32"}
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high RTT") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "cell_id",
            locales: {
                "legend_title": "id"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopTrafficGTPCellsWidget = function (Params, Online)
{
    var params = webix.extend({top_traffic:true}, Params, true);

    return QoETableNetflowTopGTPCellsWidget(params, Online);
};

var QoETableNetflowTopTrafficGTPCellsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopTrafficGTPCellsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopTrafficGTPCellsWidget(params, Online);
};

var QoEPieChartNetflowTopTrafficGTPCellsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopTrafficGTPCellsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            join:QoEReportViews.GtpFullFlowAggJoin,
            values:[
                {col:"", alias:"traffic", func:QoEReportFunctions.AvgTrafficSpeedBitsPerSecond}
            ],
            rows:["cell_id"],
            sort:{id:"traffic",dir:"desc"},
            size:10,
            flags:{
                use_where: {
                    "cell_id":1,
                    "uli_eci":1,
                    "uli_mcc":1,
                    "uli_mnc":1,
                    "uli_tac":1
                }
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        filter:{
            "uli_mcc_filter":{id:"uli_mcc", operator:">", value:0, type:"UInt16"},
            "uli_mnc_filter":{id:"uli_mnc", operator:">", value:0, type:"UInt16"},
            "uli_tac_filter":{id:"uli_tac", operator:">", value:0, type:"UInt32"},
            "uli_eci_filter":{id:"uli_eci", operator:">", value:0, type:"UInt32"}
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high traffic") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "cell_id",
            locales: {
                "legend_title": "id"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableNetflowTopRetransmitsGTPCellsWidget = function (Params, Online)
{
    var params = webix.extend({top_retransmits:true}, Params, true);

    return QoETableNetflowTopGTPCellsWidget(params, Online);
};

var QoETableNetflowTopRetransmitsGTPCellsShortWidget = function (Params, Online)
{
    var params = webix.extend({name:"QoETable" + (Online ? "Online" : "") + "NetflowTopRetransmitsGTPCellsShortWidget", short:true}, Params, true);

    return QoETableNetflowTopRetransmitsGTPCellsWidget(params, Online);
};

var QoEPieChartNetflowTopRetransmitsGTPCellsWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
        icon:"pie-chart",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoEPieChartNetflowTopRetransmitsGTPCellsWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view: Params&&Params.view ? Params.view :  QoEReportViews.FullFlow,
            join:QoEReportViews.GtpFullFlowAggJoin,
            values:[
                {col:"", alias:"retransmits", func:QoEReportFunctions.AvgRetransmitsRate}
            ],
            rows:["cell_id"],
            sort:{id:"retransmits",dir:"desc"},
            size:10,
            flags:{
                use_where: {
                    "cell_id":1,
                    "uli_eci":1,
                    "uli_mcc":1,
                    "uli_mnc":1,
                    "uli_tac":1
                }
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        filter:{
            "uli_mcc_filter":{id:"uli_mcc", operator:">", value:0, type:"UInt16"},
            "uli_mnc_filter":{id:"uli_mnc", operator:">", value:0, type:"UInt16"},
            "uli_tac_filter":{id:"uli_tac", operator:">", value:0, type:"UInt32"},
            "uli_eci_filter":{id:"uli_eci", operator:">", value:0, type:"UInt32"}
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: LangHelper.GetString("QoE", "Top GTP cells") + " " + LangHelper.GetString("QoE","with high retransmits") + " (" + LangHelper.GetString("AppView", "Netflow") + ")",
            pie_chart_key: "cell_id",
            locales: {
                "legend_title": "id"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

webix.protoUI({
    name: "days-input",
    $cssName: "text",
    $init: function(config) {

        this.attachEvent("onFocus", function() {
            let item = this.getValue();
            webix.ui.text.prototype.setValue.call(this, item);
            setTimeout(() => this.getInputNode().select(), 10);
        });

        this.attachEvent("onBlur", function() {
            let item = this.getValue();
            this.setValue(item);
        });

    },
    setValue: function(item) {
        webix.ui.text.prototype.setValue.call(this, []);
        if (item) {
            item = item.replace(/\D/g, "");
            if (item) {
                webix.ui.text.prototype.setValue.call(this, LangHelper.GetAfterDaysString(item));
            } else {
                webix.ui.text.prototype.setValue.call(this, []);
            }
        }
    },
    getValue: function() {
        let item = webix.ui.text.prototype.getValue.call(this);
        if (typeof item === "string") {
            if (item) {
                item = item.replace(/\D/g, "");
                this.setValue(item);
                return item;
            }
        }
        return item;
    },
}, webix.ui.text);

var AppPolicingPopup = function (Params,table)
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"form_modal form_modal_policings",
        id:id,
        maxWidth:800,
        maxHeight:830,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: Params && Params.modal_title ? Params.modal_title : "Application list", height:68},
                { view:"button", css:"toolbar_round_btn", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        autofit:true,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        table.ViewConfig
                    ]
                }

            ]
        }
    };
    return webix.ui(view).show();
};


var QoETableRawDnsFlowWidget = function (Params)
{
    var params = {
        title:LangHelper.GetString("QoE", "Raw DNS log"),
        icon:"table",
        id: Params && Params.id ? Params.id : webix.uid(),
        name:Params && Params.name ? Params.name : "QoETableRawDnsFlowWidget",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.DnsFlowRaw,
            view:QoEReportViews.DnsFlowRaw,
            values:[
                {col:"flow_date"},
                {col:"time", alias: "time"},
                {col:"flow_millisecond"},

                {col:"session_id"},
                {col:"login"},
                {col:"source_ipv4"},
                {col:"source_ipv6"},
                {col:"destination_ipv4"},
                {col:"destination_ipv6"},
                {col:"source_port"},
                {col:"destination_port"},

                {col:"dns_transport"},
                {col:"host"},
                {col:"host_ip_dns_data"},
                {col: "host_ip"},
                {col: "host_port"},
                {col: "subscriber"},
                {col: "subscriber_port"},
                {col:"rclass"},
                {col:"rtype"},
                {col:"ttl"},
                {col:"dns_data"},

                {col:"vlan_id"},
                {col:"post_vlan_id"},
                {col:"bridge_vchannel"},
                {col:"mpls_labels"},
                {col:"from_subscriber"},
                {col:"is_excluded_subscriber"},

                {col:"dpi_id"}
            ],
            sort:{id:"time",dir:"desc"},
            flags:{
                use_size:0,
                use_sort:0
            },
            limit:1000000,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:false,
        columns:[
            {
                id:"time", header:[TooltipTemplate(LangHelper.GetString("QoE", "Time")),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },

            {
                id:"session_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Session ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"login", header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"source_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source IPv4-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"source_ipv6", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source IPv6-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"source_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Source port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"destination_ipv4", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination IPv4-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"destination_ipv6", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination IPv6-address")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"destination_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Destination port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },

            {
                id:"dns_transport",
                header:[
                    LangHelper.GetString("QoE", "DNS transport"),
                    {
                        content: "richSelectFilter",
                        options: Helper.DictToArr(DnsTransportDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }
                ],
                sort:"string",
                template: function(Obj)
                {
                    if(Obj && typeof Obj.dns_transport !== 'undefined')
                    {
                        return DnsTransportDic && DnsTransportDic[Obj.dns_transport] ? DnsTransportDic[Obj.dns_transport].value : Obj.dns_transport;
                    }

                    return '';
                }
            },
            {
                id:"host", header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"host_ip_dns_data", header:[TooltipTemplate(LangHelper.GetString("QoE", "Host IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"host_ip", header:[TooltipTemplate(LangHelper.GetString("QoE", "DNS server IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"host_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "DNS server port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"subscriber", header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"subscriber_port", header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"rclass", header:[TooltipTemplate(LangHelper.GetString("QoE", "Rrclass")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"rtype",
                header: [
                    LangHelper.GetString("QoE", "Rrtype"),
                    {
                        content: "multiSelectFilter",
                        options: Helper.DictToArr(DnsRtypeDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }
                ],
                filterMap: {
                    id: "rtype",
                    operator: "in",
                    value: function(Val)
                    {
                        if(Val)
                        {
                            var arr = Val.split(",");

                            return arr;
                        }

                        return null;
                    }
                },
                sort:"string",
                template: function(Obj)
                {
                    if(Obj && Obj.rtype)
                    {
                        return DnsRtypeDic && DnsRtypeDic[Obj.rtype] ? DnsRtypeDic[Obj.rtype].value : Obj.rtype;
                    }

                    return '';
                }
            },
            {
                id:"ttl", header:[TooltipTemplate(LangHelper.GetString("QoE", "TTL")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"dns_data", header:[TooltipTemplate(LangHelper.GetString("QoE", "DNS data")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },

            {
                id:"vlan_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Vlan ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"post_vlan_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Post vlan ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"dpi_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"bridge_vchannel", header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannel/Bridge")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            },
            {
                id:"mpls_labels", header:[TooltipTemplate(LangHelper.GetString("QoE", "MPLS labels")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}], sort:"string"
            }
        ],
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        enableRowContextMenu: true
    };

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableDnsFlowAggTopWidget = function(Params)
{
    var values = [
        {col:"total_count", alias:"total", func:"countMerge"},
        {col:"session_id_uniq", alias:"sessons_uniq", func:"uniqMerge"},
        {col:"host", alias:"hosts_uniq", func:"uniq"},
        {col:"host_ip", alias:"host_ip_uniq", func:"uniq"},
        {col:"login", alias:"login_uniq", func:"uniq"},
        {col:"subscriber", alias:"subscribers_uniq", func:"uniq"},
        {col:"host_category", alias:"host_category_uniq", func:"uniq"},
        {col:"bridge_vchannel", alias:"bridge_vchannel_uniq", func:"uniq"}
    ];

    var columns = [
        {
            id:"total",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Total")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"sessons_uniq",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Sessions")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"hosts_uniq",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"host_category_uniq",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Host categories")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"host_ip_uniq",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "DNS hosts IPs")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"login_uniq",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Logins")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"subscribers_uniq",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"bridge_vchannel_uniq",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannels")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        }
    ];
    var leftSplit, enableRowContextMenu = true, export_pdf_config = {};
    var title = "";

    var rows = ["host_other"];
    var sort_map = null;
    var sort = "total";
    var name = Params && Params.name ? Params.name : "";

    if(Params && Params.host_ip)
    {
        // Top DNS servers ip
        rows = ["host_ip"];
        columns = [
            {
                id:"host_ip",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "DNS server IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            }
        ].concat(columns);
        leftSplit = 1;
        title = LangHelper.GetString("QoE", "Top DNS servers IPs") + " (" + LangHelper.GetString("AppView", "DNS flow") + ")";

        if(!name)
        {
            name = "QoETableDnsFlowTopHostIpsWidget";
        }
    }
    else if(Params && Params.host_ip_dns_data)
    {
        // Top hosts ip
        rows = ["host_ip_dns_data"];
        columns = [
            {
                id:"host_ip_dns_data",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            },
        ].concat(columns);
        leftSplit = 1;
        title = LangHelper.GetString("QoE", "Top hosts IPs") + " (" + LangHelper.GetString("AppView", "DNS flow") + ")";

        if(!name)
        {
            name = "QoETableDnsFlowTopHostIpsDnsDataWidget";
        }

    }
    else if(Params && Params.vchannel)
    {
        rows = ["bridge_vchannel"];
        columns = [
                {
                    id:"bridge_vchannel",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "Vchannel/Bridge")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace:2,
                    minWidth:160,
                    footer:{content:"totalRows"},
                    sort:"string"
                }
        ].concat(columns)
        leftSplit = 1;
        title = LangHelper.GetString("QoE", "Top vchannels") + " (" + LangHelper.GetString("AppView", "DNS flow") + ")";

        if(!name)
        {
            name = "QoETableDnsFlowTopVchannelsWidget";
        }
    }
    else if(Params && Params.subscriber)
    {
        rows = ["subscriber"];
        columns = [
            {
                id:"subscriber",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscriber")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            },
            {
                id:"login",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                template:function(Obj)
                {
                    return Obj.login_any;
                },
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            }
        ].concat(columns);

        values = [{col: "login", alias: "login_any", func: "any"}].concat(values);
        sort_map = {"login": "login_any"};
        leftSplit = 2;
        title = LangHelper.GetString("QoE", "Top subscribers") + " (" + LangHelper.GetString("AppView", "DNS flow") + ")";

        if(!name)
        {
            name = "QoETableDnsFlowTopSubscribersWidget";
        }

    }
    else if(Params && Params.login)
    {
        rows = ["login"];
        columns = [
            {
                id:"login",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Login")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:2,
                minWidth:160,
                footer:{content:"totalRows"},
                sort:"string"
            }
        ].concat(columns);
        leftSplit = 1;
        sort_map = {"login":"login_any"};
        title = LangHelper.GetString("QoE", "Top logins") + " (" + LangHelper.GetString("AppView", "DNS flow") + ")";

        if(!name)
        {
            name = "QoETableDnsFlowTopLoginsWidget";
        }
    }
    else if(Params && Params.host_category)
    {
        rows = ["host_category"];
        values = [{col:"", alias:"host_category_description", func:"dictGetString('urlcats_dic', 'description', host_category)"}].concat(values);
        columns = [
            {
                id:"host_category",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host category")), ""],
                template:function(Obj)
                {
                    var dic = App.DicsManager.GetDic(DicsEnum.HostCategoriesDic);

                    return dic && dic[Obj.host_category] ? LangHelper.GetString("QoE", dic[Obj.host_category].value) : LangHelper.GetString("QoE", "hcn_undefined");
                },
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            }
        ].concat(columns);
        leftSplit = 1;
        export_pdf_config = {
            values_dics: {
                "host_category": "HostCategoriesDic"
            }
        };
        title = LangHelper.GetString("QoE", "Top host categories") + " (" + LangHelper.GetString("AppView", "DNS flow") + ")";
        if(!name)
        {
            name = "QoETableDnsFlowTopHostCategoriesWidget";
        }
    }
    else
    {
        rows = ["host_other", "host_ip_dns_data"];
        values = [
            {col:"host_category", alias:"host_category_any", func:"anyLast"},
            {col:"", alias:"host_category_description", func:"dictGetString('urlcats_dic', 'description', host_category_any)"},
        ].concat(values);

        columns = [
            {
                id:"host_other",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            },
            {
                id:"host_ip_dns_data",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host IP")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            },
            {
                id:"host_category_any",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Host category")), ""],
                template:function(Obj)
                {
                    var dic = App.DicsManager.GetDic(DicsEnum.HostCategoriesDic);

                    return dic && dic[Obj.host_category_any] ? LangHelper.GetString("QoE", dic[Obj.host_category_any].value) : LangHelper.GetString("QoE", "hcn_undefined");
                },
                fillspace:true,
                sort:"string",
                minWidth:160,
                footer:{content:"totalRows"}
            }
        ].concat(columns);

        leftSplit = 2;
        export_pdf_config = {
            values_dics: {
                "host_category_any": "HostCategoriesDic",
                "host_category_description": "ClsfrCategoriesDic"
            }
        };

        title = LangHelper.GetString("QoE", "Top hosts") + " (" + LangHelper.GetString("AppView", "DNS flow") + ")";


        if(!name)
        {
            name = "QoETableDnsFlowTopHostsWidget";
        }
    }

    var params = {
        title: title,
        icon: "table",
        id: Params && Params.id ? Params.id : webix.uid(),
        name: name,
        config: {
            type: QoEReportConfigTypeEnum.ClientPredefined,
            table: QoEReportTablesEnum.DnsFlowAgg,
            view: QoEReportViews.DnsFlowAgg,
            values: values,
            rows: rows,
            sort: {id: sort, dir: "desc"},
            flags: {
                use_size: 0,
                use_where: 0
            },
            limit: 1000000,
            with_totals: true,
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer: true,
        columns: columns,
        leftSplit: leftSplit,
        export_title_callback: Params && Params.export_title_callback ? Params.export_title_callback : null,
        sort_map: sort_map,
        can_use_sort_map:{
            "ReportsSettings": 1
        },
        export_pdf_config: export_pdf_config,
        enableRowContextMenu: enableRowContextMenu
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableDnsFlowAggTopHostsWidget = function(Params, Online)
{
    let name  = "QoETable" + (Online ? "Online" : "") + "DnsFlowAggTopHostsWidget";
    return QoETableDnsFlowAggTopWidget(webix.extend(Params, {name: name, hosts: 1}, true));
};

var QoETableDnsFlowAggTopHostsIpsDnsDataWidget = function(Params, Online)
{
    // Top Hosts Ip
    let name  = "QoETable" + (Online ? "Online" : "") + "DnsFlowAggTopHostsIpsDnsDataWidget";
    return QoETableDnsFlowAggTopWidget(webix.extend(Params, {name: name, host_ip_dns_data: 1}, true));
};

var QoETableDnsFlowAggTopHostsIpsWidget = function(Params, Online)
{
    // Top DNS servers ip
    let name  = "QoETable" + (Online ? "Online" : "") + "DnsFlowAggTopHostsIpsWidget";
    return QoETableDnsFlowAggTopWidget(webix.extend(Params, {name: name, host_ip: 1}, true));
};

var QoETableDnsFlowAggTopHostCategoriesWidget = function(Params, Online)
{
    let name  = "QoETable" + (Online ? "Online" : "") + "DnsFlowAggTopHostCategoriesWidget";
    return QoETableDnsFlowAggTopWidget(webix.extend(Params, {name: name, host_category: 1}, true));
};

var QoETableDnsFlowAggTopSubscribersWidget = function(Params, Online)
{
    let name  = "QoETable" + (Online ? "Online" : "") + "DnsFlowAggTopSubscribersWidget";
    return QoETableDnsFlowAggTopWidget(webix.extend(Params, {name: name, subscriber: 1}, true));
};

var QoETableDnsFlowAggTopLoginsWidget = function(Params, Online)
{
    let name  = "QoETable" + (Online ? "Online" : "") + "DnsFlowAggTopLoginsWidget";
    return QoETableDnsFlowAggTopWidget(webix.extend(Params, {name: name, login: 1}, true));
};

var QoETableDnsFlowAggTopVchannelsWidget = function(Params, Online)
{
    let name  = "QoETable" + (Online ? "Online" : "") + "DnsFlowAggTopVchannelsWidget";
    return QoETableDnsFlowAggTopWidget(webix.extend(Params, {name: name, vchannel: 1}, true));
};

var QoETableNetflowTopVoipProtocolsWidget = function(Params)
{
    let VOIPGroup = AppEnv.voip_group ? AppEnv.voip_group : 6;

    let id = Params && Params.id ? Params.id : webix.uid();
    let title = Params && Params.title ? Params.title : LangHelper.GetString("QoE", "Top VOIP protocols");
    let name = Params && Params.name ? Params.name : "QoETableNetflowTopVoipProtocolsWidget";

    let VoipProtocolsSubscribersUniq = AppEnv && AppEnv.VoipProtocolsSubscribersUniq
        ? AppEnv.VoipProtocolsSubscribersUniq
        : QoEReportFunctions.VoipProtocolsSubscribersUniq;

    let VoipProtocolsCallsUniq = AppEnv && AppEnv.VoipProtocolsCallsUniq
        ? AppEnv.VoipProtocolsCallsUniq
        : QoEReportFunctions.VoipProtocolsCallsUniq;

    let VoipProtocolsCallDurationPerMinutes = AppEnv && AppEnv.VoipProtocolsCallDurationPerMinutes
        ? AppEnv.VoipProtocolsCallDurationPerMinutes
        : QoEReportFunctions.VoipProtocolsCallDurationPerMinutes;

    let rows = ["protocol"];
    let values = [
        {col: "", alias: "subscribers_uniq", func: VoipProtocolsSubscribersUniq},
        {col: "", alias: "calls_uniq", func: VoipProtocolsCallsUniq},
        {col: "", alias: "duration_sum", func: VoipProtocolsCallDurationPerMinutes}
    ];
    let columns = [
        {
            id: "protocol",
            header: [TooltipTemplate(LangHelper.GetString("QoE", "Protocol")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            fillspace:true,
            minWidth:160,
            sort: "string",
            footer: {content: "totalRows"}
        },
        {
            id: "subscribers_uniq",
            header: [TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
            adjust: true,
            format:webix.i18n.intFormat,
            sort: "string",
            footer: {content:"totalColumn"}
        },
        {
            id: "calls_uniq",
            header: [TooltipTemplate(LangHelper.GetString("QoE", "Calls")), ""],
            format:webix.i18n.intFormat,
            sort: "string",
            footer: {content:"totalColumn"}
        },
        {
            id: "duration_sum",
            header: [TooltipTemplate(LangHelper.GetString("QoE", "Minutes")), ""],
            format:webix.i18n.intFormat,
            sort: "string",
            footer: {content:"totalColumn"}
        }
    ];

    if(!Params || !Params.short)
    {
        let common = QoETableNetflowTopCommonConfig({
            custom_filter:["traffic", "traffic_vol"]
        });

        columns = columns.concat(common.columns);
        values = values.concat(common.values);
    }

    let sort = Params && Params.sort ? Params.sort : {id: "subscribers_uniq", dir: "desc"};

    let leftSplit = 1;
    let export_title_callback = Params && Params.export_title_callback ? Params.export_title_callback : null;
    let sort_map = {};
    let export_pdf_config = {};

    let params = {
        title: title,
        icon: "table",
        id: id,
        name: name,
        config: {
            type: QoEReportConfigTypeEnum.ClientPredefined,
            table: QoEReportTablesEnum.FullnetflowAgg,
            view: QoEReportViews.FullFlow,
            values: values,
            rows: rows,
            sort: sort,
            flags: {
                use_size: 0,
                use_where: 0
            },
            limit: 1000000,
            with_totals: true,
            cache: {
                enabled: 1,
                values: [],
                flags: {
                    use_where: 0,
                    use_having: 0
                }
            },
        },
        filter: {
            "app_protocol_group_id": {id: "app_protocol_group_id", operator: "=", value: VOIPGroup, type: "UInt64"}
        },
        footer: true,
        columns: columns,
        leftSplit: leftSplit,
        export_title_callback: export_title_callback,
        sort_map: sort_map,
        export_pdf_config: export_pdf_config,
        enableRowContextMenu: true
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoETableNetflowTopVoipProtocolsShortWidget = function(Params)
{
    return QoETableNetflowTopVoipProtocolsWidget(webix.extend(Params, {short: true}, true));
}

var QoEPieChartNetflowTopVoipProtocolsWidget = function(Params)
{
    let VOIPGroup = AppEnv.voip_group ? AppEnv.voip_group : 6;

    let id = Params && Params.id ? Params.id : webix.uid();
    let title = Params && Params.title ? Params.title : LangHelper.GetString("QoE", "Top VOIP protocols by numbers of calls");
    let name = Params && Params.name ? Params.name : "QoEPieChartNetflowTopVoipProtocolsWidget";

    let VoipProtocolsCallsUniq = AppEnv && AppEnv.VoipProtocolsCallsUniq
        ? AppEnv.VoipProtocolsCallsUniq
        : QoEReportFunctions.VoipProtocolsCallsUniq;

    let params = {
        title: title,
        icon: "pie-chart",
        id: id,
        name: name,
        config: {
            type: QoEReportConfigTypeEnum.ClientPredefined,
            table: QoEReportTablesEnum.FullnetflowAgg,
            view: QoEReportViews.FullFlow,
            values: [{col: "", alias: "calls_uniq", func: VoipProtocolsCallsUniq}],
            rows: ["protocol"],
            sort: {id: "calls_uniq", dir: "desc"},
            size: 10,
            flags:{
                use_where: 0
            },
            cache: {
                enabled: 1,
                values: [],
                flags: {
                    use_where: 0,
                    use_having: 0
                }
            }
        },
        filter: {
            "app_protocol_group_id": {id: "app_protocol_group_id", operator: "=", value: VOIPGroup, type: "UInt64"}
        },
        export_pdf_config: {
            view_type: "pie_chart",
            title: title,
            pie_chart_key: "protocol"
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoESeriesChartNetflowUsersByVoipProtocolsWidget = function(Params)
{
    let title = LangHelper.GetString("QoE", "Top VOIP Protocols by number of users");

    let VoipProtocolsSubscribersUniq = AppEnv && AppEnv.VoipProtocolsSubscribersUniq
        ? AppEnv.VoipProtocolsSubscribersUniq
        : QoEReportFunctions.VoipProtocolsSubscribersUniq;

    let VoipProtocolsSubscribersUniqIf = AppEnv && AppEnv.VoipProtocolsSubscribersUniqIf
        ? AppEnv.VoipProtocolsSubscribersUniqIf
        : QoEReportFunctions.VoipProtocolsSubscribersUniqIf;

    return QoESeriesChartNetflowVoipProtocolsWidget({
        title: title,
        name: "QoESeriesChartNetflowUsersByVoipProtocolsWidget",
        values: [{col: "", alias: "subscribers_uniq"}],
        sql_tpl: Helper.ReplaceAll("{condition}", " protocol = {col_value}", VoipProtocolsSubscribersUniqIf)+" as `{col_value_as_alias}`",
        top_list_func: VoipProtocolsSubscribersUniq,
        export_pdf_config: {
            view_type: "chart",
            graph_line_type: "splineArea",
            title: title,
            abscise_key: "time_step"
        }
    });
};

var QoESeriesChartNetflowCallsByVoipProtocolsWidget = function(Params)
{
    let title = LangHelper.GetString("QoE", "Top VOIP protocols by numbers of calls");

    let VoipProtocolsCallsUniq = AppEnv && AppEnv.VoipProtocolsCallsUniq
        ? AppEnv.VoipProtocolsCallsUniq
        : QoEReportFunctions.VoipProtocolsCallsUniq;

    let VoipProtocolsCallsUniqIf = AppEnv && AppEnv.VoipProtocolsCallsUniqIf
        ? AppEnv.VoipProtocolsCallsUniqIf
        : QoEReportFunctions.VoipProtocolsCallsUniqIf;

    return QoESeriesChartNetflowVoipProtocolsWidget({
        id: Params && Params.id ? Params.id : null,
        title: title,
        name: "QoESeriesChartNetflowCallsByVoipProtocolsWidget",
        values: [{col: "", alias: "calls_uniq"}],
        sql_tpl: Helper.ReplaceAll("{condition}", " protocol = {col_value}", VoipProtocolsCallsUniqIf)+" as `{col_value_as_alias}`",
        top_list_func: VoipProtocolsCallsUniq,
        export_pdf_config: {
            view_type: "chart",
            graph_line_type: "splineArea",
            title: title,
            abscise_key: "time_step"
        }
    });
};

var QoESeriesChartNetflowMinutesByVoipProtocolsWidget = function(Params)
{
    let title = LangHelper.GetString("QoE", "Top VOIP Protocols by total call duration");

    let VoipProtocolsCallDurationPerMinutes = AppEnv && AppEnv.VoipProtocolsCallDurationPerMinutes
        ? AppEnv.VoipProtocolsCallDurationPerMinutes
        : QoEReportFunctions.VoipProtocolsCallDurationPerMinutes;

    let VoipProtocolsCallDurationPerMinutesIf = AppEnv && AppEnv.VoipProtocolsCallDurationPerMinutesIf
        ? AppEnv.VoipProtocolsCallDurationPerMinutesIf
        : QoEReportFunctions.VoipProtocolsCallDurationPerMinutesIf;

    return QoESeriesChartNetflowVoipProtocolsWidget({
        title: title,
        name: "QoESeriesChartNetflowMinutesByVoipProtocolsWidget",
        values: [{col: "", alias: "minutes_count"}],
        sql_tpl: Helper.ReplaceAll("{condition}", " protocol = {col_value}", VoipProtocolsCallDurationPerMinutesIf)+" as `{col_value_as_alias}`",
        top_list_func: VoipProtocolsCallDurationPerMinutes,
        y_axis_func: function(Val) {return Val + " " + LangHelper.GetString("All", "min")},
        export_pdf_config: {
            view_type: "chart",
            graph_line_type: "splineArea",
            title: title,
            abscise_key: "time_step",
            units: [LangHelper.GetString("All", "min")],
        }
    });
};

var QoESeriesChartNetflowVoipProtocolsWidget = function(Params)
{
    let VOIPGroup = AppEnv.voip_group ? AppEnv.voip_group : 6;

    let id = Params && Params.id ? Params.id : webix.uid();
    let title = Params && Params.title ? Params.title : null;
    let name = Params && Params.name ? Params.name : null;

    let values = Params && Params.values ? Params.values : null;
    let sql_tpl = Params && Params.sql_tpl ? Params.sql_tpl : null;
    let top_list_func = Params && Params.top_list_func ? Params.top_list_func : null;

    let y_axis_func = Params && Params.y_axis_func ? Params.y_axis_func : null;
    let export_pdf_config = Params && Params.export_pdf_config ? Params.export_pdf_config : null;

    let params = {
        title: title,
        icon: "area-chart",
        id: id,
        name: name,
        config: {
            type: QoEReportConfigTypeEnum.ClientPredefined,
            table: QoEReportTablesEnum.FullnetflowAgg,
            view: QoEReportViews.FullFlow,
            values: values,
            rows: [
                {col: "time", alias: "time_step", func: "toStartOfAuto"}
            ],
            cols: [
                {
                    col: "protocol",
                    alias: "{col_value}",
                    func: "",
                    values: {
                        func: "GetTopList",
                        params: {
                            table: QoEReportTablesEnum.FullnetflowAgg,
                            view: QoEReportViews.FullFlow,
                            row: "protocol",
                            func: top_list_func,
                            limit: 50
                        }
                    },
                    condition: "==",
                    sql_tpl: sql_tpl,
                }
            ],
            sort: {id: "time_step", dir: "asc"},
            limit: 1000,
            flags: {
                use_size: 0,
                use_where: 0
            },
            cache:{
                enabled: 1,
                values: ["time_step"],
                cols: [
                    {
                        col: "protocol",
                        alias: "{col_value}"
                    }
                ],
                flags:{
                    use_where: 0,
                    use_having: 0,
                    use_cache_saved_cols: 1
                },
                limit: 1000
            }
        },
        filter: {
            "app_protocol_group_id": {id: "app_protocol_group_id", operator: "=", value: VOIPGroup, type: "UInt64"}
        },
        type: "splineArea",
        xAxis: {
            template: function(Val)
            {
                return Helper.FormatDateTimeForChartXAxes(Val);
            }
        },
        yAxis: y_axis_func ? {template: y_axis_func} : undefined,
        export_pdf_config: export_pdf_config,
        legend: {
            height: 160,
            align: "left",
            valign: "bottom",
            layout: "x",
            values: []
        },
    };

    return new QoESeriesChartReportWidget(params);
};

var QoETableNetflowUsersByVoipProtocolsTableChartWidget = function (Params)
{
    let id = Params && Params.id ? Params.id : webix.uid();
    let sort = {id: "subscribers_uniq", dir: "desc"};

    return new QoETableChartWidget({
        id: id,
        name: "QoETableNetflowUsersByVoipProtocolsTableChartWidget",
        table: {
            widget: QoETableNetflowTopVoipProtocolsWidget({id: id + "UsersByVoipProtocolsTable", short: true, sort: sort})
        },
        chart: {
            gravity: 2,
            widget: QoESeriesChartNetflowUsersByVoipProtocolsWidget({id: id + "UsersByVoipProtocolsChart"})
        },
        suggest_type: "chart-area"
    });
};

var QoETableNetflowCallsByVoipProtocolsTableChartWidget = function (Params)
{
    let id = Params && Params.id ? Params.id : webix.uid();
    let sort = {id: "calls_uniq", dir: "desc"};

    return new QoETableChartWidget({
        id: id,
        name: "QoETableNetflowCallsByVoipProtocolsTableChartWidget",
        table: {
            widget: QoETableNetflowTopVoipProtocolsWidget({id: id + "CallsByVoipProtocolsTable", short: true, sort: sort})
        },
        chart: {
            gravity: 2,
            widget: QoESeriesChartNetflowCallsByVoipProtocolsWidget({id: id + "CallsByVoipProtocolsChart"})
        },
        suggest_type: "chart-area"
    });
};

var QoETableNetflowMinutesByVoipProtocolsTableChartWidget = function (Params)
{
    let id = Params && Params.id ? Params.id : webix.uid();
    let sort = {id: "duration_sum", dir: "desc"};

    return new QoETableChartWidget({
        id: id,
        name: "QoETableNetflowMinutesByVoipProtocolsTableChartWidget",
        table: {
            widget: QoETableNetflowTopVoipProtocolsWidget({id: id + "MinutesByVoipProtocolsTable", short: true, sort: sort})
        },
        chart: {
            gravity: 2,
            widget: QoESeriesChartNetflowMinutesByVoipProtocolsWidget({id: id + "MinutesByVoipProtocolsChart"})
        },
        suggest_type: "chart-area"
    });
};

var QoETableNetflowTrafficByVoipProtocolsWidget = function(Params)
{
    let VOIPGroup = AppEnv.voip_group ? AppEnv.voip_group : 6;

    let params = {
        id: Params && Params.id ? Params.id : "TrafficByVoipProtocolsTable",
        name: Params && Params.name ? Params.name : "QoETableNetflowTrafficByVoipProtocolsWidget",
        title: Params && Params.title ? Params.title : LangHelper.GetString("QoE", "Top VOIP protocols with high traffic"),
        filter: Params && Params.filter ? Params.filter : {"app_protocol_group_id": {id: "app_protocol_group_id", operator: "=", value: VOIPGroup, type: "UInt64"}},
        by_voip: true
    };

    return QoETableNetflowTopTrafficProtocolsShortWidget(params);
};

var QoESeriesChartNetflowTrafficByVoipProtocolsWidget = function(Params)
{
    let VOIPGroup = AppEnv.voip_group ? AppEnv.voip_group : 6;

    let params = {
        id: Params && Params.id ? Params.id : "TrafficByByVoipProtocolsChart",
        name: Params && Params.name ? Params.name : "QoESeriesChartNetflowTrafficByVoipProtocolsWidget",
        title: Params && Params.title ? Params.title : LangHelper.GetString("QoE", "Traffic by VOIP protocols"),
        filter: Params && Params.filter ? Params.filter : {"app_protocol_group_id": {id: "app_protocol_group_id", operator: "=", value: VOIPGroup, type: "UInt64"}},
        by_voip: true
    };

    return QoESeriesChartTrafficByAppProtocolsWidget(params);
};

var QoETableNetflowTopTrafficByVoipProtocolsTableChartWidget = function (Params)
{
    let VOIPGroup = AppEnv.voip_group ? AppEnv.voip_group : 6;

    let id = Params && Params.id ? Params.id : webix.uid();

    return new QoETableChartWidget({
        id: id,
        name: "QoETableNetflowTopTrafficByVoipProtocolsTableChartWidget",
        table:{
            widget: QoETableNetflowTrafficByVoipProtocolsWidget({id: id + "TrafficByVoipProtocolsTable"})
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartNetflowTrafficByVoipProtocolsWidget({id :id + "TrafficByByVoipProtocolsChart"})
        },
        suggest_type: "chart-area"
    });
};

var QoETableDdosAttackFlowAggTopAttackWidget = function(Params)
{
    let name, title, cols, report_settings;
    let id = Params && Params.id ? Params.id : webix.uid();
    let icon = Params && Params.icon ? Params.icon : "table";

    let rows = [];

    let values = [
        {col: "attack_type", alias: "attack_count", func: "count"},
        {col: "attack_type", alias: "attack_type_count", func: "uniq"},
        {col: "sessions_sum", alias: "sessions", func: "sumMerge"},
        {col: "flows_sum", alias: "flows", func: "sumMerge"},
        {col: "duration_avg", alias: "duration", func: "avgMerge"},
        {col: "", alias: "intensity_bits_sec", func: QoEReportFunctions.DdosAvgTrafficSpeedBitsPerSecond},
        {col: "", alias: "intensity_packets_sec", func: QoEReportFunctions.DdosAvgTrafficSpeedPktsPerSecond}
    ];

    let columns = [
        {
            id:"attack_count",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Number of attacks")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"attack_type_count",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Number of attack types")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"sessions",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Sessions")), ""],
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"duration",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Average duration")+", "+LangHelper.GetString("QoE", "ms")), ""],
            format:webix.i18n.intFormat,
            units_format_data:UnitsFormatData.SimpleTimeUnits,
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"intensity_bits_sec",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic speed")+", "+LangHelper.GetString("Dics", "Bps")), ""],
            format:webix.i18n.intFormat,
            units_format_data:UnitsFormatData.TrafficSpeedBitUnits,
            footer:{content:"totalColumn"},
            sort:"string"
        },
        {
            id:"intensity_packets_sec",
            header:[TooltipTemplate(LangHelper.GetString("QoE", "Flow speed")+", "+LangHelper.GetString("Dics", "Pkts/s")), ""],
            format:webix.i18n.intFormat,
            units_format_data:UnitsFormatData.NetFlowSpeedUnits,
            footer:{content:"totalColumn"},
            sort:"string"
        }
    ];

    let sort = "intensity_bits_sec";
    let leftSplit = 2;
    let export_title_callback = Params&&Params.export_title_callback?Params.export_title_callback:null;
    let sort_map = null;
    let export_pdf_config = {};
    let enableRowContextMenu = true;

    if(Params && Params.by_as)
    {
        name = "QoETableDdosAttackFlowAggTopAttackByAsWidget";
        title = LangHelper.GetString("QoE", "Top attacks by AS") + " (" + LangHelper.GetString("AppView", "DDoS attacks") + ")";

        cols = [
            {
                id:"src_asnum",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Source AS")),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                fillspace:true,
                minWidth:160,
                sort:"string"
            }
        ];
    }
    else if(Params && Params.by_protocols)
    {
        name = "QoETableDdosAttackFlowAggTopAttackByProtocolsWidget";
        title = LangHelper.GetString("QoE", "Top attacks by protocols") + " (" + LangHelper.GetString("AppView", "DDoS attacks") + ")";

        cols = [
            {
                id:"net_protocol",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Net protocol")),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                fillspace:true,
                minWidth:160,
                sort:"string"
            }
        ];
    }
    else if(Params && Params.by_app_protocols)
    {
        name = "QoETableDdosAttackFlowAggTopAttackByAppProtocolsWidget";
        title = LangHelper.GetString("QoE", "Top attacks by application protocols") + " (" + LangHelper.GetString("AppView", "DDoS attacks") + ")";

        cols = [
            {
                id:"app_protocol",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Application protocol")),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                fillspace:true,
                minWidth:160,
                sort:"string"
            },
            {
                id: "app_protocol_group_id",
                minWidth: 160,
                fillspace:true,
                header: [
                    LangHelper.GetString("DpiDscpConfig", "Group"),
                    {
                        content: "multiSelectFilter",
                        options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }
                ],
                filterMap: {
                    id: "app_protocol_group_id",
                    operator: "in",
                    value: function(Val)
                    {
                        if(Val)
                        {
                            var arr = Val.split(",");

                            return arr;
                        }
                        return null;
                    }
                },
                template: function(obj){

                    var str = "";

                    if(obj && obj.app_protocol_group_id != null)
                    {
                        var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.app_protocol_group_id});

                        if(group)
                        {
                            str = group.value;
                        }
                    }
                    return str;
                }
            }
        ];
    }
    else if(Params && Params.by_attacker_locations)
    {
        leftSplit = 4;

        name = "QoETableDdosAttackFlowAggTopAttackByAttackerLocationsWidget"
        title = LangHelper.GetString("QoE", "Top attacker locations") + " (" + LangHelper.GetString("AppView", "DDoS attacks") + ")";

        cols = [
            {
                id: "attacker_country_code",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "Country code")),
                    {content: "textFilter", placeholder: "&#xf002 " + LangHelper.GetString("All", "Filter")}
                ],
                sort: "string"
            },
            {
                id: "attacker_state",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "GeoState")),
                    {content: "textFilter", placeholder: "&#xf002 " + LangHelper.GetString("All", "Filter")}
                ],
                sort: "string"
            },
            {
                id: "attacker_city",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "City")),
                    {content: "textFilter", placeholder: "&#xf002 " + LangHelper.GetString("All", "Filter")}
                ],
                sort: "string"
            }
        ];

        values = [
            {col: "", alias: "attacker_latitude", func: "toFloat64OrZero(splitByChar(',', min(attacker_coordinates))[1])"},
            {col: "", alias: "attacker_longitude", func: "toFloat64OrZero(splitByChar(',', min(attacker_coordinates))[2])"},
            {col: "", alias: "attacker_uniq", func: "uniq(src_ip)"}
        ].concat(values);

        columns = [
            {
                id:"attacker_latitude",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Latitude")),
                    {content: "textFilter", placeholder:"&#xf002 " + LangHelper.GetString("All","Filter")}
                ],
                sort:"string"
            },
            {
                id:"attacker_longitude",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Longitude")),
                    {content: "textFilter", placeholder:"&#xf002 " + LangHelper.GetString("All","Filter")}
                ],
                sort:"string"
            },
            {
                id:"attacker_uniq",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Number of attackers")), ""],
                footer:{content:"totalColumn"},
                sort:"string"
            }
        ].concat(columns);

        report_settings = {
            group_by: [
                "attacker_country_code",
                "attacker_state",
                "attacker_city"
            ],
            group_by_required: [],
            exceptional_props_model_func: TableReportSettingsWithGroupByOptionsModel
        };
    }
    else if(Params && Params.by_attacker_ip_locations)
    {
        name = "QoETableDdosAttackFlowAggTopAttackBypAttackerIpAddressesLocationsWidget"
        title = LangHelper.GetString("QoE", "Top attacker Ip addresses") + " (" + LangHelper.GetString("AppView", "DDoS attacks") + ")";
        leftSplit = 5;

        cols = [
            {
                id:"src_ip",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Attacker IP address")),
                    {content: "textFilter", placeholder:"&#xf002 " + LangHelper.GetString("All","Filter")}
                ],
                sort:"string"
            },
            {
                id: "attacker_country_code",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "Country code")),
                    {content: "textFilter", placeholder: "&#xf002 " + LangHelper.GetString("All", "Filter")}
                ],
                sort: "string"
            },
            {
                id: "attacker_state",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "GeoState")),
                    {content: "textFilter", placeholder: "&#xf002 " + LangHelper.GetString("All", "Filter")}
                ],
                sort: "string"
            },
            {
                id: "attacker_city",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "City")),
                    {content: "textFilter", placeholder: "&#xf002 " + LangHelper.GetString("All", "Filter")}
                ],
                sort: "string"
            },
            {
                id:"attacker_latitude",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Latitude")),
                    {content: "textFilter", placeholder:"&#xf002 " + LangHelper.GetString("All","Filter")}
                ],
                sort:"string"
            },
            {
                id:"attacker_longitude",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Longitude")),
                    {content: "textFilter", placeholder:"&#xf002 " + LangHelper.GetString("All","Filter")}
                ],
                sort:"string"
            }
        ];
    }
    else if(Params && Params.by_attacker_countries)
    {
        name = "QoETableDdosAttackFlowAggTopAttackByAttackerCountriesWidget"
        title = LangHelper.GetString("QoE", "Top attacker countries") + " (" + LangHelper.GetString("AppView", "DDoS attacks") + ")";
        sort = "attacker_coordinates_uniq";
        leftSplit = 1;

        cols = [
            {
                id: "attacker_country_code",
                header: [
                    TooltipTemplate(LangHelper.GetString("QoE", "Country code")),
                    {content: "textFilter", placeholder: "&#xf002 " + LangHelper.GetString("All", "Filter")}
                ],
                sort: "string"
            }
        ];

        values = [
            {col: "", alias: "attacker_coordinates_uniq", func: "uniq(attacker_coordinates)"},
            {col: "", alias: "attacker_uniq", func: "uniq(src_ip)"}
        ].concat(values);

        columns = [
            {
                id:"attacker_coordinates_uniq",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Number of locations")), ""],
                footer:{content:"totalColumn"},
                sort:"string"
            },
            {
                id:"attacker_uniq",
                header:[TooltipTemplate(LangHelper.GetString("QoE", "Number of attackers")), ""],
                footer:{content:"totalColumn"},
                sort:"string"
            }
        ].concat(columns);
    }
    else
    {
        name = "QoETableDdosAttackFlowAggTopAttackWidget";
        title = LangHelper.GetString("QoE", "Top attacks") + " (" + LangHelper.GetString("AppView", "DDoS attacks") + ")";

        cols = [
            {
                id:"dst_ip",
                header:[
                    TooltipTemplate(LangHelper.GetString("QoE", "Target IP address")),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                fillspace:true,
                minWidth:160,
                sort:"string"
            }
        ]
    }

    cols.forEach((Col) => {
        rows.push(Col.id);
    });

    columns = cols.concat(columns);

    let params = {
        title:title,
        icon:icon,
        id:id,
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.DdosAttackFlowAgg,
            view:QoEReportViews.DdosAttackFlowAgg,
            values:values,
            rows:rows,
            sort:{id: sort, dir: "desc"},
            flags:{
                use_size: 0,
                use_where: 0
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values:[],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:true,
        columns:columns,
        leftSplit:leftSplit,
        export_title_callback:export_title_callback,
        sort_map:sort_map,
        export_pdf_config:export_pdf_config,
        report_settings:report_settings,
        enableRowContextMenu:enableRowContextMenu
    };

    params.config.cache.values = [].concat(params.config.rows);

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";//Col.func_cache ? Col.func_cache : Col.func;

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoESeriesChartDdosAttackFlowAggTopAttackIntensityWidget = function(Params)
{
    let title, name, col_value, serie_column, legend_title;
    let id = Params && Params.id ? Params.id : webix.uid();

    if(Params && Params.by_as)
    {
        title = LangHelper.GetString("QoE", "Attack intensity by source AS");
        name = "QoESeriesChartDdosAttackFlowAggTopAttackByAsWidget";
        serie_column = Params.serie_column ? Params.serie_column : "src_asnum";
        legend_locale = Params.legend_locale ? Params.legend_locale : "as_number";
    }
    else if(Params && Params.by_protocols)
    {
        title = LangHelper.GetString("QoE", "Attack intensity by protocols");
        name = "QoESeriesChartDdosAttackFlowAggTopAttackByProtocolsWidget";
        serie_column = Params.serie_column ? Params.serie_column : "net_protocol";
        legend_locale = Params.legend_locale ? Params.legend_locale : "protocol";
    }
    else if(Params && Params.by_app_protocols)
    {
        title = LangHelper.GetString("QoE", "Attack intensity by application protocols");
        name = "QoESeriesChartDdosAttackFlowAggTopAttackByAppProtocolsWidget";
        serie_column = Params.serie_column ? Params.serie_column : "app_protocol";
        legend_locale = Params.legend_locale ? Params.legend_locale : "app_protocol";
    }
    else
    {
        return QoESeriesChartDdosAttackFlowAggAttackIntensityWidget(Params);
    }

    let tpl = Helper.ReplaceAll(
        "{condition}",
        `${serie_column} == {col_value}`,
        QoEReportFunctions.DdosAvgTrafficSpeedBitsPerSecondIfChartSerie
    );

    let sqlTpl = tpl + " as `{col_value_as_alias}`";

    let params = {
        title:title,
        icon:"area-chart",
        id:id,
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.DdosAttackFlowAgg,
            view: QoEReportViews.DdosAttackFlowAgg,
            values:[
                // It needs a list of objects to run, but the objects themselves don’t do anything. (gui export | optimize dist)
                {col:"traffic_speed_bps", alias:"speed", func:"avg"}
            ],
            rows:[
                {col:"time", alias:"time_step", func:"toStartOfAuto"}
            ],
            cols:[
                {
                    col:serie_column,
                    alias:"{col_value}",
                    func:"",
                    values:{
                        func:"GetTopList",
                        params:{
                            table:QoEReportTablesEnum.DdosAttackFlowAgg,
                            view:QoEReportViews.DdosAttackFlowAgg,
                            row:serie_column,
                            func:QoEReportFunctions.DdosAvgTrafficSpeedBitsPerSecond,
                            limit:50
                        }
                    },
                    condition:"==",
                    sql_tpl:sqlTpl
                }
            ],
            sort:{id:"time_step",dir:"asc"},
            limit:1000,
            flags:{
                use_size:0,
                use_where:0
            },
            cache:{
                enabled:1,
                values: ["time_step"],
                cols:[
                    {
                        col:serie_column,
                        alias:"{col_value}"
                    }
                ],
                flags:{
                    use_where:0,
                    use_having:0,
                    use_cache_saved_cols:1
                }
            }
        },
        type:"splineArea",
        xAxis:{
            template:function(Val)
            {
                return Helper.FormatDateTimeForChartXAxes(Val);
            }
        },
        yAxis:{
            template:function(Val)
            {
                return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
            }
        },
        legend:{
            height:160,
            align:"left",
            valign:"bottom",
            layout:"x",
            values:[]
        },
        export_pdf_config:{
            view_type:"chart",
            title:`${title} (${LangHelper.GetString("AppView", "DDoS attacks")})`,
            abscise_key:"time_step",
            units:TrafficSpeedBitUnits,
            divider:1000,
            locales:{
                "legend_title":legend_locale
            }
        }
    };

    return new QoESeriesChartReportWidget(params);
};

var QoETableRawDdosAttackFlowWidget = function (Params)
{
    var title = LangHelper.GetString("QoE", "Raw DDoS attack log");
    var name = Params && Params.name ? Params.name : "QoETableRawDdosAttackFlowWidget"

    var values = [
        {col: "time"},
        {col: "end_time"},
        {col: "attack_type"},
        {col: "attack_direction"},
        {col: "event_object"},
        {col: "dpi_id"},
        {col: "vchannel"},
        {col: "net_protocol"},
        {col: "app_protocol"},
        {col: "app_protocol_group_id"},
        {col: "src_asnum"},
        {col: "src_ip"},
        {col: "src_ports_arr"},
        {col: "dst_ip"},
        {col: "dst_ports_arr"},
        {col: "login"},
        {col: "start_millisecond"},
        {col: "end_millisecond"},
        {col: "octets"},
        {col: "octets_dropped"},
        {col: "packets"},
        {col: "packets_dropped"},
        {col: "flows"},
        {col: "sessions"},
        {col: "duration"}
    ];

    var columns = [
        {
            id:"time",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Start time")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"end_time",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "End time")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"start_millisecond",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Start time in milliseconds")),
                {content: "textFilter",placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            sort:"string"
        },
        {
            id:"end_millisecond",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "End time in milliseconds")),
                {content: "textFilter",placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            sort:"string"
        },
        {
            id:"attack_type",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Attack type")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"attack_direction",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Attack direction")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"event_object",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Event object")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"dpi_id",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "DPI ID")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"vchannel",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Vchannel/Bridge")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"net_protocol",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Net protocol")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"app_protocol",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Application protocol")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id: "app_protocol_group_id",
            minWidth: 160,
            fillspace:true,
            header: [
                LangHelper.GetString("DpiDscpConfig", "Group"),
                {
                    content: "multiSelectFilter",
                    options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                    inputConfig: {suggest: {fitMaster: false}}
                }
            ],
            filterMap: {
                id: "app_protocol_group_id",
                operator: "in",
                value: function(Val)
                {
                    if(Val)
                    {
                        var arr = Val.split(",");

                        return arr;
                    }
                    return null;
                }
            },
            template: function(obj){

                var str = "";

                if(obj && obj.app_protocol_group_id != null)
                {
                    var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.app_protocol_group_id});

                    if(group)
                    {
                        str = group.value;
                    }
                }
                return str;
            }
        },
        {
            id:"src_asnum",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Source AS")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"src_ip",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Attacker IP address")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"src_ports_arr",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Attacker ports")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"dst_ip",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Target IP address")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"dst_ports_arr",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Target port")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"login",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Subscriber login")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"octets",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Octet delta")),
                {content: "textFilter",placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            sort:"string"
        },
        {
            id:"octets_dropped",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Dropped bytes")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"packets",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Packet delta")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"packets_dropped",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Dropped packets")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"flows",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Flows records")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"sessions",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Sessions")),
                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
            ],
            sort:"string"
        },
        {
            id:"duration",
            header:[
                TooltipTemplate(LangHelper.GetString("QoE", "Duration")+", "+LangHelper.GetString("QoE", "ms")),
                ""
            ],
            format:webix.i18n.intFormat,
            units_format_data:UnitsFormatData.SimpleTimeUnits,
            sort:"string"
        }
    ];

    var sort = "time";

    var params = {
        title:title,
        icon:"table",
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.DdosAttackFlowRaw,
            view:QoEReportViews.DdosAttackFlowRaw,
            values:values,
            sort:{id:sort,dir:"desc"},
            flags:{
                use_size:0,
                use_sort:0
            },
            limit:1000000,
            cache:{
                enabled:1,
                values:[],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        footer:false,
        columns:columns,
        leftSplit:0,
        export_title_callback:Params&&Params.export_title_callback?Params.export_title_callback:null,
        export_pdf_config: {
            values_dics: {
                "app_protocol_group_id": "ProtocolsGroupsDic"
            }
        }
    };

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = "";

        params.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoESeriesChartDdosAttackFlowAggAttackIntensityWidget = function(Params)
{
    let title = LangHelper.GetString("QoE", "Attack intensity");

    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        icon:"area-chart",
        title:title,
        name:"QoESeriesChartDdosAttackFlowAggAttackIntensityWidget",
        config: {
            type: QoEReportConfigTypeEnum.ClientPredefined,
            table: QoEReportTablesEnum.DdosAttackFlowAgg,
            view: QoEReportViews.DdosAttackFlowAgg,
            values: [
                {
                    col:"bits_sec_max",
                    alias:Helper.EncodeBase64Safe(LangHelper.GetString("QoE", "Intensity")),
                    func:QoEReportFunctions.DdosAvgTrafficSpeedBitsPerSecondChartSerie
                }
            ],
            rows: [
                {col: "time", alias: "time_step", func: "toStartOfAuto"}
            ],
            sort: {id: "time_step", dir: "asc"},
            limit: 1000,
            flags: {
                use_size: 0,
                use_where: 0
            },
            cache: {
                enabled: 1,
                values: [],
                flags: {
                    use_where: 0,
                    use_having: 0
                }
            }
        },
        type:"splineArea",
        xAxis:{
            template:function(Val) {
                return Helper.FormatDateTimeForChartXAxes(Val);
            }
        },
        yAxis:{
            template:function(Val) {
                return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
            }
        },
        legend:{
            height:40,
            align:"left",
            valign:"bottom",
            layout:"x",
            toggle:true,
            values:[]
        },
        export_pdf_config:{
            view_type:"chart",
            title:`${title} (${LangHelper.GetString("AppView", "DDoS attacks")})`,
            abscise_key:"time_step",
            units:TrafficSpeedBitUnits,
            divider:1000
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoESeriesChartReportWidget(params);
};

var QoETableDdosAttackFlowAggByAsTableChartWidget = function (Params)
{
    let id = Params&&Params.id?Params.id:webix.uid();

    return new QoETableChartWidget({
        id:id,
        name:"QoETableDdosAttackFlowAggByAsTableChartWidget",
        serie_column:"src_asnum",
        table:{
            widget: QoETableDdosAttackFlowAggTopAttackByAsWidget({id:id + "TopAttackByAsTable"})
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartDdosAttackFlowAggTopAttackByAsWidget({id:id + "TopAttackByAsSeriesChart"})
        }
    });
};

var QoETableDdosAttackFlowAggTopAttackByAsWidget = function(Params)
{
    let params = webix.extend({by_as:true}, Params, true);
    return QoETableDdosAttackFlowAggTopAttackWidget(params);
};

var QoESeriesChartDdosAttackFlowAggTopAttackByAsWidget = function(Params)
{
    let params = webix.extend({by_as:true}, Params, true);
    return QoESeriesChartDdosAttackFlowAggTopAttackIntensityWidget(params);
};

var QoETableDdosAttackFlowAggByProtocolsTableChartWidget = function (Params)
{
    let id = Params&&Params.id?Params.id:webix.uid();

    return new QoETableChartWidget({
        id:id,
        name:"QoETableDdosAttackFlowAggByProtocolsTableChartWidget",
        serie_column:"net_protocol",
        table:{
            widget: QoETableDdosAttackFlowAggTopAttackByProtocolsWidget(
                {id:id + "TopAttackByProtocolsTable"}
            )
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartDdosAttackFlowAggTopAttackByProtocolsWidget(
                {id:id + "TopAttackByProtocolsSeriesChart"}
            )
        }
    });
};

var QoETableDdosAttackFlowAggTopAttackByProtocolsWidget = function(Params)
{
    let params = webix.extend({by_protocols:true}, Params, true);
    return QoETableDdosAttackFlowAggTopAttackWidget(params);
};

var QoESeriesChartDdosAttackFlowAggTopAttackByProtocolsWidget = function(Params)
{
    let params = webix.extend({by_protocols:true}, Params, true);
    return QoESeriesChartDdosAttackFlowAggTopAttackIntensityWidget(params);
};

var QoETableDdosAttackFlowAggByAppProtocolsTableChartWidget = function (Params)
{
    let id = Params&&Params.id?Params.id:webix.uid();

    return new QoETableChartWidget({
        id:id,
        name:"QoETableDdosAttackFlowAggByAppProtocolsTableChartWidget",
        serie_column:"app_protocol",
        table:{
            widget: QoETableDdosAttackFlowAggTopAttackByAppProtocolsWidget(
                {id:id + "TopAttackByProtocolsTable"}
            )
        },
        chart:{
            gravity:2,
            widget: QoESeriesChartDdosAttackFlowAggTopAttackByAppProtocolsWidget(
                {id:id + "TopAttackByProtocolsSeriesChart"}
            )
        }
    });
};

var QoETableDdosAttackFlowAggTopAttackByAppProtocolsWidget = function(Params)
{
    let params = webix.extend({by_app_protocols:true}, Params, true);
    return QoETableDdosAttackFlowAggTopAttackWidget(params);
};

var QoESeriesChartDdosAttackFlowAggTopAttackByAppProtocolsWidget = function(Params)
{
    let params = webix.extend({by_app_protocols: true}, Params, true);
    return QoESeriesChartDdosAttackFlowAggTopAttackIntensityWidget(params);
};

var QoESingleStatTotalsDdosAttackFlowAggAttackIntensityVertWidget = function (Params)
{
    let params = webix.extend({xCount:1, yCount:5, name:"QoESingleStatTotalsDdosAttackFlowAggAttackIntensityVertWidget"}, Params, true);
    return QoESingleStatTotalsDdosAttackFlowAggAttackIntensityWidget(params);
};

var QoESingleStatTotalsDdosAttackFlowAggAttackIntensityWidget = function (Params)
{
    let id = Params && Params.id ? Params.id : webix.uid();
    let name = Params && Params.name ? Params.name : "QoESingleStatTotalsDdosAttackFlowAggAttackIntensityWidget"

    let values = [
        {col: "attack_type", alias: "attack_count", func: "count"},
        {col: "", alias: "intensity_bits_sec", func: QoEReportFunctions.DdosAvgTrafficSpeedBitsPerSecond},
        {col: "octets_sum", alias: "octets", func:"sumMerge"},
        {col: "octets_dropped_sum", alias: "octets_dropped", func:"sumMerge"},
        {co: "", alias: "mitigation", func: QoEReportFunctions.DdosAttackMitigationPercent}
    ];

    let columns = [
        {
            id:"attack_count",
            header:LangHelper.GetString("QoE", "Incidents"),
            icon:"exclamation-triangle",
            template:function(Val)
            {
                return Helper.UnitPrefixToNumeric(Val, 1000, CountUnits);
            }
        },
        {
            id:"intensity_bits_sec",
            header:LangHelper.GetString("QoE", "Average intensity"),
            icon:"tachometer",
            template:function(Val)
            {
                return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);
            }
        },
        {
            id:"octets",
            header:LangHelper.GetString("QoE", "Traffic volume"),
            icon:"arrows-alt-h",
            template:function(Val)
            {
                return Helper.UnitPrefixToNumeric(Val, 1024, FileSizeUnits);
            }
        },
        {
            id:"octets_dropped",
            header:LangHelper.GetString("QoE", "Blocked traffic volume"),
            icon:"trash-alt",
            template:function(Val)
            {
                return Helper.UnitPrefixToNumeric(Val, 1024, FileSizeUnits);
            }
        },
        {
            id:"mitigation",
            header:LangHelper.GetString("QoE", "Mitigation"),
            icon:"shield-check",
            template:function(Val)
            {
                return Val + " %";
            }
        }
    ];

    let params = {
        icon:"tables",
        id:id,
        name:name,
        config:{
            type: QoEReportConfigTypeEnum.ClientPredefined,
            table: QoEReportTablesEnum.DdosAttackFlowAgg,
            view: QoEReportViews.DdosAttackFlowAgg,
            values:values,
            sort:{id: "attack_count", dir: "desc"},
            flags:{
                use_where:0,
                use_size:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        columns:columns,
        compact:Params&&Params.compact,
        xCount:Params&&Params.xCount?Params.xCount:5,
        yCount:Params&&Params.yCount?Params.yCount:1,
        type:{
                width: "auto",
                height: "auto"
        }
    };

    params.config.values.forEach(function (Col)
    {
        params.config.cache.values.push({col:(Col.alias ? Col.alias : Col.col)});
    });

    return new QoESingleStatWidget(params);
};

var QoETableDdosAttackFlowAggTopAttackByAttackerCountriesWidget = function (Params)
{
    let params = webix.extend({by_attacker_countries:true}, Params, true);
    return QoETableDdosAttackFlowAggTopAttackWidget(params);
};

var QoEPieChartDdosAttackTopAttackerCountriesWidget = function (Params)
{
    let id = Params && Params.id ? Params.id : webix.uid();
    let name = "QoEPieChartDdosAttackTopAttackerCountriesWidget";
    let title = LangHelper.GetString("QoE", "Top attacker countries");

    let params = {
        id:id,
        name:name,
        title:title,
        icon:"pie-chart",
        config:{
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.DdosAttackFlowAgg,
            view:QoEReportViews.DdosAttackFlowAgg,
            values:[
                {col: "", alias: "attacker_coordinates_uniq", func: "uniq(attacker_coordinates)"}
            ],
            rows:[
                "attacker_country_code"
            ],
            sort:{id:"attacker_coordinates_uniq",dir:"desc"},
            size:10,
            flags:{
                use_where:0
            },
            cache:{
                enabled:1,
                values: [],
                flags:{
                    use_where:0,
                    use_having:0
                }
            },
            headers_dic:{
                "attacker_coordinates_uniq":LangHelper.GetString("QoE", "Number of locations"),
                "attacker_country_code":LangHelper.GetString("QoE", "Country code")
            }
        },
        export_pdf_config: {
            view_type:"pie_chart",
            title:title,
            pie_chart_key:"attacker_country_code",
            locales: {
                "legend_title":"attacker_country_code"
            }
        }
    };

    params.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    params.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        params.config.cache.values.push({col:alias, alias:alias});
    });

    return new QoEPieChartReportWidget(params);
};

var QoETableLayerDdosAttackTopAttackerLocationsWidget = function (Params)
{
    let id = Params&&Params.id?Params.id:webix.uid();
    let icon = "street-view";

    let name = "QoETableLayerDdosAttackTopAttackerLocationsWidget";

    return new QoETableLayerWidget({
        id:id,
        name:name,
        table:{
            widget: new QoETableDdosAttackFlowAggTopAttackByAttackerLocationsWidget({id: id + "Table", icon: icon})
        },
        map:{
            gravity: 2,
            widget: new QoEMapsReportWidget({
                id: id + "Map",
                name: name,
                noRefresh: true,
                layers: {
                    AtttackerLocationsLayer: new QoEPointsLayerWidget({
                            id: id + "LocationLayer",
                            icon: icon,
                            name: "AtttackerLocationsLayer",
                            layer_config: {
                                type: "Vector",
                                default_style: {point: webix.skin.$active.defaultCirclesStyle},
                                item_config: {
                                    type: "Point",
                                    get_feature_by_id: "point_data_transform",
                                    point_data_transform: {
                                        id: {value: "id"},
                                        lat: {value: "attacker_latitude"},
                                        lon: {value: "attacker_longitude"},
                                        data: [
                                            {
                                                value: "attacker_country_code",
                                                title: LangHelper.GetString("QoE", "Country code")
                                            },
                                            {
                                                value: "attacker_state",
                                                title: LangHelper.GetString("QoE", "GeoState")
                                            },
                                            {
                                                value: "attacker_city",
                                                title: LangHelper.GetString("QoE", "City")
                                            },
                                            {
                                                value: "attacker_uniq",
                                                title: LangHelper.GetString("QoE", "Number of attackers")
                                            },
                                            {
                                                value: "attack_count",
                                                title: LangHelper.GetString("QoE", "Number of attacks")
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    )
                }
            })
        }
    });
};

var QoETableDdosAttackFlowAggTopAttackByAttackerLocationsWidget = function (Params)
{
    let params = webix.extend({by_attacker_locations:true}, Params, true);
    return QoETableDdosAttackFlowAggTopAttackWidget(params);
};

var QoETableLayerDdosAttackTopAttackerIpAddressesLocationsWidget = function (Params)
{
    let id = Params&&Params.id?Params.id:webix.uid();
    let icon = "street-view";

    let name = "QoETableLayerDdosAttackTopAttackerIpAddressesLocationsWidget";

    return new QoETableLayerWidget({
        id:id,
        name:name,
        table:{
            widget: new QoETableDdosAttackFlowAggTopAttackBypAttackerIpAddressesLocationsWidget({id: id + "Table", icon: icon})
        },
        map:{
            gravity: 2,
            widget: new QoEMapsReportWidget({
                id: id + "Map",
                name :name,
                noRefresh: true,
                layers: {
                    AtttackerLocationsLayer: new QoEPointsLayerWidget({
                            id: id + "LocationLayer",
                            icon: icon,
                            name: "AtttackerLocationsLayer",
                            layer_config: {
                                type: "Vector",
                                default_style: {point: webix.skin.$active.defaultCirclesStyle},
                                item_config: {
                                    type: "Point",
                                    get_feature_by_id: "point_data_transform",
                                    point_data_transform: {
                                        id: {value: "id"},
                                        lat: {value: "attacker_latitude"},
                                        lon: {value: "attacker_longitude"},
                                        data: [
                                            {
                                                value: "attacker_country_code",
                                                title: LangHelper.GetString("QoE", "Country code")
                                            },
                                            {
                                                value: "attacker_state",
                                                title: LangHelper.GetString("QoE", "GeoState")
                                            },
                                            {
                                                value: "attacker_city",
                                                title: LangHelper.GetString("QoE", "City")
                                            },
                                            {
                                                value: "src_ip",
                                                title: LangHelper.GetString("QoE", "Attacker IP address")
                                            },
                                            {
                                                value: "attack_count",
                                                title: LangHelper.GetString("QoE", "Number of attacks")
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    )
                }
            })
        }
    });
};

var QoETableDdosAttackFlowAggTopAttackBypAttackerIpAddressesLocationsWidget = function (Params)
{
    let params = webix.extend({by_attacker_ip_locations:true}, Params, true);
    return QoETableDdosAttackFlowAggTopAttackWidget(params);
};
var BlockHeaderTemplate = function (Params) {
    var tpl = {
        name: "blockHeader",
        id:Params&&Params.id?Params.id:webix.uid(),
        template: function (obj)
        {
            return (obj.icon?"<span class='webix_icon fa-"+obj.icon+" app_chart_block__header_icon'></span>":"")+"<span class='app_chart_block__header_title'>"+obj.title+"</span>";
        },
        css: function(){
            var std_class = 'app_block__header';
            if(Params && Params.css){
                return Params.css + " " + std_class;
            }
            return std_class;
        }(),
        hidden: Params && Params.hidden ? Params.hidden : false,
        height: Params && Params.height ? Params.height : (SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? 22 : 24),
        data:Params,
        borderless: Params && Params.borderless ? Params.borderless : false
    };

    if(Params&&Params.no_id)
    {
        delete tpl.id;
    }

    return tpl;
};

var PageHeaderTemplate = function (Params)
{
    // var hasConnect = !(App.SessionManager.CurrentHardwareConnected['hasError']);
    var tpl = {
        id:Params&&Params.id ? Params.id : webix.uid(),
        css: "app_view_title",
        template: function (Obj)
        {
            var html = (Obj.root_title ? Obj.root_title : "") + (Obj.root_title && Obj.title ? " / " : "") + (Obj.title ? "<span class='app_view_title__highlight'>" + Obj.title + "</span>" : "");

            //return SkinHelper.GetSkin() == SkinsEnum.dpiui2_vulkan ? "<div>" + html + "</div>" : html;

            return html;
        },
        height: 48,
        data:Params
    };

    if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
    {
        tpl.borderless = true;
        tpl.height = 28;
    }

    else if(SkinHelper.GetSkin() == SkinsEnum.dpiui2_vulkan)
    {
        tpl.borderless = true;
        //tpl.height = 64;
    }

    if(SkinHelper.GetSkin() != SkinHelper.GetDefaultFilterUiSkin())
    {
        tpl.hidden = true;
    }

    Helper.SetHtmlPageTitle(Params.root_title, Params.title);

    return tpl;
};

var VasCloudPageHeaderTemplate = function (Params)
{
    var tpl = {
        type: "clean",
        view: "toolbar",
        css: "app_top_header vas-cloud_top-header",
        height: 48,
        elements:
            [
                {},
                {
                    id: Params.id + "HeaderBalanceInfoMenu",
                    width: 180,
                    css: "header_wallet",
                    borderless: true,
                    data: Params.balance_data,
                    hidden:true,
                    template: function (obj) {
                        var html = "<div style='height:100%;width:100%;' onclick='webix.$$(\""+Params.balance_popup_id+"\").show(this)'>";
                        html += "<span class='webix_icon fa-angle-down'></span>";
                        html += "<span class='name'>" + obj.title + "</span>";
                        html += "<span class='webix_icon fa-wallet'></span>";
                        html += "</div>";
                        return html;
                    }
                },
                {
                    id: Params.id+"ProfileTitle",
                    width: 180,
                    css: "header_person",
                    borderless: true,
                    data: Params.profile_data,
                    template: function (obj)
                    {
                        var html = "<div style='height:100%;width:100%;' onclick='webix.$$(\""+Params.profile_popup_id+"\").show(this)'>";
                        html += "<span class='webix_icon fa-angle-down'></span>";
                        html += "<span class='name'>" + obj.name + "</span>";
                        html += "<span class='avatar'>"+Helper.GetInitials(obj.name)+"</span>";
                        html += "</div>";
                        return html;
                    }
                }
            ]
    };

    if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
    {
        tpl.borderless = true;
        tpl.height = 28;
    }

    else if(SkinHelper.GetSkin() == SkinsEnum.dpiui2_vulkan)
    {
        tpl.borderless = true;
        //tpl.height = 64;
    }

    return tpl;
};

var VasCloudLicencePageHeaderTemplate = function (Params)
{
    var tpl = {
        type: "clean",
        view: "toolbar",
        css: "app_top_header vas-cloud_top-header",
        height: 48,
        elements:
            [
                {
                    id: Params.id + "LicStateTitle",
                    css: "app_view_title",
                    borderless: true,
                    data: Params.data,
                    template: function (Obj)
                    {
                        var html = "<span class='app_view_title_shop_licence' onclick='webix.$$(\""+Params.id + "InfoContext"+"\").show(this)'>" + LangHelper.GetString("VasCloud", "Subscription status") + ": <span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__no_active'>" + LangHelper.GetString("VasCloud", "Not active") + "</span>" + "<span class='webix_icon fa-angle-down'></span>"+ "</span>";
                        switch (Obj.state)
                        {
                            case "active":
                                html = "<span class='app_view_title_shop_licence'>" + LangHelper.GetString("VasCloud", "Subscription status") + ": <span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__active'>" + LangHelper.GetString("VasCloud", "Active") + "</span>" + "</span>";
                                break;
                            case "active_expire":
                                html = "<span class='app_view_title_shop_licence'>" + LangHelper.GetString("VasCloud", "Subscription status") + ": <span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__active_expire'>" + (LangHelper.GetString("VasCloud", "remain %s days")).replace("%s", Obj.days_left) + "</span>" + "<span class='webix_icon fa-angle-down'></span>"+ "</span>";
                                break;
                            default:
                                break;
                        }


                        //    html += hasConnect === false  ? "<span class='app_view_title_shop_licence'><span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__no_active'>"+LangHelper.GetString("AppView","Start fastdpi error")+"</span></span>" : "";

                        //html += " <span class='app_view_title_shop_licence'>" + "Состояние подписки: <span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__active'>Активна</span>" + "<span class='webix_icon fa-angle-down'></span>"+ "</span>";
                        //html += " <span class='app_view_title_shop_licence'>" + "Состояние подписки: <span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__active_expire'>Активна (осталось 8 дней)</span>" + "<span class='webix_icon fa-angle-down'></span>"+ "</span>";
                        //html += " <span class='app_view_title_shop_licence'>" + "Состояние подписки: <span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__active_expire'>Пробный период (осталось 8 дней)</span>" + "<span class='webix_icon fa-angle-down'></span>"+ "</span>";
                        //html += " <span class='app_view_title_shop_licence'>" + "Состояние подписки: <span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__no_active'>Неактивна</span>" + "<span class='webix_icon fa-angle-down'></span>"+ "</span>";

                        return html;
                    }
                }
            ]
    };

    if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
    {
        tpl.borderless = true;
        tpl.height = 28;
    }

    else if(SkinHelper.GetSkin() == SkinsEnum.dpiui2_vulkan)
    {
        tpl.borderless = true;
        //tpl.height = 64;
    }

    return tpl;
};

var CellQuestionBtnTemplate = function(Params)
{
    return "<span class=\"webix_icon fa-question-circle\" style=\"cursor:pointer;\"></span>";
};

var CellEnvelopeBtnTemplate = function(Params)
{
    return "<span class=\"webix_icon fa-envelope\" style=\"cursor:pointer;\"></span>";
};

var CellListBtnTemplate = function(Params)
{
    return "<span class=\"webix_icon fa-list-alt\" style=\"cursor:pointer;\"></span>";
};

var CellEditBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-pencil-square\" style=\"cursor:pointer;\"></span>";
};

var CellEditPencilBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-pencil\" style=\"cursor:pointer;\"></span>";
};

var CellToolsBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-tools\" style=\"cursor:pointer;\"></span>";
};

var CellMonitorBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-monitor-heart-rate\" style=\"cursor:pointer;\"></span>";
};

var CellLogsBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-stack-overflow\" style=\"cursor:pointer;\"></span>";
};

var CellHostButtonTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-list hosts_button\" style=\"cursor:pointer;\"></span>";
};

var CellFilterBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-filter\" style=\"cursor:pointer;\"></span>" + (Params && Params.badge ? "<span class=\"webix_badge webix_cell_badge\">" + (Params.badge > 99 ? "99+" : Params.badge) + "</span>" : "");
};

var CellTrashBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-trash\" style=\"cursor:pointer;\"></span>";
};

var CellBroomBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-broom\" style=\"cursor:pointer;\"></span>";
};

var CellCodeBranchBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-code-branch\" style=\"cursor:pointer;\"></span>";
};

var CellKillBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-hand-paper\" style=\"cursor:pointer;\"></span>";
};

var CellDownloadBtnTemplate = function (Params)
{
    if(Params && Params.default_cursor)
    {
        return "<span class=\"webix_icon fa-download\"></span>";
    }

    return "<span class=\"webix_icon fa-download\" style=\"cursor:pointer;\"></span>";
};

var CellFileCodeBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-file-code\" style=\"cursor:pointer;\"></span>";
};

var CellArrowToRightBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-angle-right\" style=\"cursor:pointer;\"></span>";
};

var CellArrowToLeftBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-angle-left\" style=\"cursor:pointer;\"></span>";
};

var CellArrowTemplate = function (Params)
{
    // up, down, left, right
    let direction   = Params && Params.direction ? Params.direction : "up";
    let cellValue   = Params && Params.value ? Params.value : "";
    let transparent = Params && Params.transparent ? Params.transparent : false;

    let style = transparent ? ' style="opacity:0"' : "";
    let html = `<span class="webix_icon fa-angle-${direction}"${style}></span>`;

    if (cellValue)
        html = `<div>${html}${cellValue}</div>`;

    return html;
};

var CellProgressTemplate = function (obj)
{
    var percent = obj.total&&obj.done?Math.floor(obj.done/obj.total*100):0
    var title = LangHelper.GetString("All", "Total")+": "+obj.total+"; "+LangHelper.GetString("All", "Done")+": "+obj.done+" ("+percent+"%)";

    var html = "<div class='progress_bar_element'>";
    html += "<div title='" + title + "' class='progress_result ' style='width:" + (percent + "%") + "'></div>";
    html += "</div> <span style='display:inline-block;'>" + percent + "%" + "</span>";
    return html;
};

var DnaIfTemplate = function (Params) {
    var tpl = {
        css:"if_dna",
        template: "<div class='if_dna_#dev_in_out#'><div class='if_dna_title'>#dev_in_out#: #if_title#</div><div class='if_dna_connector_bottom'></div><div class='if_dna_connector_top'></div></div>",
        data:Params
    };

    return tpl;
};

var TooltipTemplate = function (Text, TooltipText, IconAfterText, IconBeforeText)
{
    var tooltip = TooltipText ? TooltipText : Text;
    return "<span title='" + tooltip + "'>" + (IconBeforeText ? ' <span class="webix_icon webix_el_icon fa-' + IconBeforeText + '"></span>' : '') + Text + (IconAfterText ? ' <span class="webix_icon webix_el_icon fa-' + IconAfterText + '"></span>' : '') + "</span>";
};

var CellPlayStopBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-play-circle-o\"></span>";
};

var CellOnOffTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<div class='webix_table_checkbox checked' style=\"cursor:pointer;\"><span class=\"webix_icon fa-check-square\"></span> " + OnOffDic["1"].value + "</div>";
    else
        return "<div class='webix_table_checkbox notchecked' style=\"cursor:pointer;\"><span class=\"webix_icon fa-square-o\"></span> " + OnOffDic["0"].value + "</div>";
};

var CellOnOffDisabledTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<span style=\"color:#1A84D8\"><input disabled class='webix_table_checkbox' type='checkbox' checked> " + OnOffDic["1"].value +" </span>";
    else
        return "<span style=\"color:#1A84D8\"><input disabled class='webix_table_checkbox' type='checkbox'> " + OnOffDic["0"].value +" </span>";
};

var CellOnOffCheckboxTemplate = function(Obj, Common, Value)
{
    if(parseInt(Value,10))
        return "<span class=\"webix_icon fa-check-square\" style=\"color:#1A84D8\"> " + OnOffDic["1"].value +" </span>";
    else
        return "<span class=\"webix_icon fa-square-o\"> " + OnOffDic["0"].value +" </span>";
};

var CellCalendarTemplate = function (Value)
{
    if(parseInt(Value, 10))
        return "<span class=\"webix_icon fa-calendar\" style=\"cursor:pointer; color:#1A84D8;\"></span>";
    else
        return "<span class=\"webix_icon fa-calendar\" style=\"cursor:pointer; color:#2b303a;\"></span>";
};

var CellYesNoTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<div class='webix_table_checkbox checked'><span class=\"webix_icon fa-check-square\"></span> "+LangHelper.GetString("All", "Yes")+"</div>";
    else
        return "<div class='webix_table_checkbox notchecked'><span class=\"webix_icon fa-square\"></span> "+LangHelper.GetString("All", "No")+"</div>";
};

var CellYesNoDisabledTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<div><span class=\"webix_icon fa-check-square\"></span> "+LangHelper.GetString("All", "Yes")+"</div>";
    else
        return "<div><span class=\"webix_icon fa-square\"></span> "+LangHelper.GetString("All", "No")+"</div>";
};

var CellSwitchOnOffTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<span class=\"webix_icon fa-toggle-on\" style='color: #1A84D8; cursor:pointer;'></span>";
    else
        return "<span class=\"webix_icon fa-toggle-off\" style='cursor:pointer;'></span>";
};

var CellCheckboxSwitchOnOffTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<span class=\"webix_table_checkbox webix_icon fa-toggle-on\" style='color: #1A84D8; cursor:pointer;'></span>";
    else
        return "<span class=\"webix_table_checkbox webix_icon fa-toggle-off\" style='cursor:pointer;'></span>";
};

var CellCheckboxSwitchOnOffCanDisabledTemplate = function (Obj, Common, Value, IsDisabled = false) {
    const buildStyle = (StyleObj) =>
        Object.entries(StyleObj)
            .filter(([, val]) => val != null && val !== "")
            .map(([key, val]) => `${key}:${val}`)
            .join("; ");

    const style = {
        color: parseInt(Value,10) ? "#1A84D8" : "",
        opacity: IsDisabled ? "0.45" : "",
        cursor: IsDisabled ? "default" : "pointer"
    };

    const cssClass = IsDisabled ? "webix_icon" : "webix_table_checkbox webix_icon";
    const iconClass = parseInt(Value,10) ? "fa-toggle-on" : "fa-toggle-off";
    const styleStr = buildStyle(style);

    return `<span class="${cssClass} ${iconClass}" style="${styleStr}"></span>`;
};

var CellCheckBoxDisabledTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<span class=\"webix_icon fa-check-square\"></span>";
    else
        return "<span class=\"webix_icon fa-square-o\"></span>";
};

var CellCheckBoxTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<div class='webix_table_checkbox checked' style=\"cursor:"+(Obj&&Obj.cursor?Obj.cursor+";":"pointer;")+"\"><span class=\"webix_icon fa-check-square\"></span></div>";
    else
        return "<div class='webix_table_checkbox notchecked' style=\"cursor:"+(Obj&&Obj.cursor?Obj.cursor+";":"pointer;")+"\"><span class=\"webix_icon fa-square-o\"></span></div>";
};

var CellColoredCheckBoxTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<div class='webix_table_checkbox checked' style=\"cursor:pointer; color:"+Obj.color+" !important;\"><span class=\"webix_icon fa-check-square\"></span></div>";
    else
        return "<div class='webix_table_checkbox notchecked' style=\"cursor:pointer; color:"+Obj.color+" !important;\"><span class=\"webix_icon fa-square-o\"></span></div>";
};

var DateTimePickerCellColoredCheckBoxTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return "<div style='width: 20px' class='dpiui2_filterui_checkbox checked'><span class=\"webix_icon fa-check-square\"></span></div>";
    else
        return "<div style='width: 20px' class='dpiui2_filterui_checkbox notchecked'><span class=\"webix_icon fa-square-o\"></span></div>";
};

var CellSwitchBoxTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value,10))
        return '<div class="webix_table_checkbox webix_switch_box webix_switch_on" style="width:48px"><span class="webix_switch_text"></span><button class="webix_switch_handle" aria-label="Vas cloud Ads" role="checkbox" tabindex="0" style="right:0px;"><input class="webix_switch_toggle" type="checkbox"></button></div>';
    else
        return '<div class="webix_table_checkbox webix_switch_box" style="width:48px"><span class="webix_switch_text"></span><button class="webix_switch_handle" aria-label="Vas cloud Ads" role="checkbox" tabindex="0" style="left:0px;"><input class="webix_switch_toggle" type="checkbox"></button></div>';
};

var QoESingleStatCellTemplate = function (Params)
{
    var html = "";

    var na = Params.template_params && Params.template_params.na ? Params.template_params.na : "N/A";

    if (Params.clickable) {
        html += "<div class='qoe_single_stat clickable'>";
        html += Params.icon ? "<div class='webix_icon icon fa-"+ Params.icon+"'></div>" : "";
        html += "<div class='details'><div class='value'>"+(Params.value?Params.value:na)+"</div><div class='text'>"+(Params.text?Params.text:"")+"</div></div>";
        html += "</div>";
    } else {
        html += "<div class='qoe_single_stat " + (Params.compact ? "compact" : "") + "'>";
        html += Params.icon ? "<div class='webix_icon icon fa-"+ Params.icon+"'></div>" : "";
        html += "<div class='details'><div class='value'>"+(Params.value?Params.value:na)+"</div><div class='text'>"+(Params.text?Params.text:"")+"</div></div>";
        html += "</div>";
    }

    return html;
};

var QoESingleStatTemplate = function (Params) {
    var tpl = {
        name: "QoESingleStatTemplate",
        id:Params&&Params.id?Params.id:webix.uid(),
        template: function (Obj)
        {
            return QoESingleStatCellTemplate(Obj);
        },
        height: Params.compact ? 80 : 160,
        data:Params
    };

    return tpl;
};

var QoEMonitorStatCellTemplate = function (Params, AlertColor)
{
    const bcColor = (Params && Params.color) && Params.color === AlertColor ? Params.color : "";
    const tColor = (Params && Params.color) && Params.color === AlertColor ? "#fff" : "";

    let html = "";

    html += "<div class='qoe_single_stat monitor_stat' style='background-color: "+bcColor+";" +
        "color: "+tColor+"'>";

    html += Params.icon ?
        "<div class='monitor_details'>" +

            "<div class='monitor_details_wrapper'>" +
                "<div class='webix_icon icon fa-"+ Params.icon+"' style='color: "+tColor+"'></div>" +
                "<div class='text'>"+(Params.title?Params.title:"")+"</div>" +
            "</div>" +

            "<div class='stat_value' title='" + LangHelper.GetString("QoE", "Protocol health mark") + "'>"+(Params.stat)+"</div>" +

            "<div class='monitor_values_wrapper'>" +
                "<div class='monitor_values_wrapper__left_side'>" +
                    "<div class='monitor_param__traffic_volume' title='" + LangHelper.GetString("QoE", "Traffic volume") + "'>" + (Params.value1)+"</div>" +
                    "<div class='monitor_param__traffic_delta' title='" + LangHelper.GetString("QoE", "Traffic volume delta") + "'>"+(Params.value3)+"</div>" +
                "</div>" +
                "<div class='monitor_values_wrapper__right_side'>" +
                    "<div class='monitor_param__rtt' title='" + LangHelper.GetString("QoE", "RTT to, median") + "'>"+(Params.value2)+"</div>" +
                "</div>" +
            "</div>" +

        "</div>"
        :
        "<div class='monitor_details'>" +
            "<div class='text'>"+(Params.title?Params.title:"")+"</div>" +
            "<div class='value'>"+(Params.value1?Params.value1:"N/A")+"</div>" +
        "</div>";

    html += "</div>";

    return html;
};

var CellBoltBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-bolt\" title='"+(Params && Params.title ? Params.title : "")+"' style='cursor:pointer'></span>";
};

var CellTerminalBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-terminal\"></span>";
};

var CellCassetteBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-cassette-tape\" style='cursor:pointer'></span>";
};

var CellPlayBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-play-circle\"></span>";
};

var CellStopBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-stop-circle\" style='cursor:pointer;'></span>";
};

var CellBoltBtnTemplate = function(Params)
{
  return "<span class=\"webix_icon fa-bolt-circle\" title='"+(Params && Params.title ? Params.title : "")+"' style='cursor:pointer'></span>";
};

var CellDpiRestartBtnTemplate = function(Params)
{
    return "<span class=\"webix_icon fa-retweet blink\" title='"+(Params && Params.title ? Params.title : "")+"' style='cursor:pointer;'></span>";
};

var CellForceSyncBtnTemplate = function(Params)
{
    return "<span class=\"webix_icon fa-cloud-download-alt\" title='"+(Params && Params.title ? Params.title : "")+"' style='cursor:pointer;'></span>";
};

var CellSettingsBtnTemplate = function (Params)
{
    return '<span class="webix_icon fa-cog" style="cursor:pointer;"></span>';
};

var CellMenuBtnTemplate = function (Params)
{
    return '<span class="webix_icon fa-ellipsis-v-alt" style="cursor:pointer;"></span>';
};

var CellHelpBtnTemplate = function (Params)
{
    return '<span class="webix_icon fa-question-circle" style="cursor:pointer;"></span>';
};

var CellLinkTemplate = function (Text)
{
    return '<span class="webix_cell_link">'+Text+'</span>';

};

var CellTextLinkTemplate = function (Text)
{
    var color = vendor == "cubro" ? "var(--color-red)" : "#1A84D8";
    return '<span class="webix_cell_link" style=\'color: '+color+'; cursor:pointer;\'>'+Text+'</span>';

};

var CellOnOffColoredTemplate = function (Params)
{
    if (Params) {
        return '<span style=\'color: #1A84D8; cursor:pointer;\'>'+OnOffDic["1"].value+'</span>';
    } else {
        return '<span style=\'color: #1A84D8; cursor:pointer;\'>'+OnOffDic["0"].value+'</span>';
    }
}

var CellSpectreDateTemplate = function (Date)
{
    if(Date)
    {

        var format =  webix.Date.dateToStr(`%H:%i <span class='text_style_grey_light_middle2i'>${DateFormatDic[App.Locale].date_format}</span>`);
        return format(Date);
    }

    return "";
};

var CellOnlyDateTemplate = function(Date)
{
    if(Date)
    {

        var format =  webix.Date.dateToStr(`%H:%i ${DateFormatDic[App.Locale].date_format}`);
        return format(Date);
    }

    return "";
}

var CellEyeBtnTemplate = function (Params)
{
    return '<span class="webix_icon fa-eye" style="cursor:pointer;"></span>';
};

var CellInfoBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-info\"></span>";
};

var AppButtonBadgeTemplate = function (Params)
{
    if(Params != 0)
        return `<div class=\"badge_inner\">${Params}</div>`;
    else
        return Params;
}

var UlrButtonBadgeTemplate = function(Params)
{
    if(Params != 0)
        return `<div class=\"badge_inner ulr_badge\">${Params}</div>`;
    else
        return Params;
};

var UlrButtonBadgeAlertTemplate = function()
{
    return `<div class=\"badge_inner\">!</div>`;
};

var CellBypassStatusTemplate = function (Params)
{
    var statuses =
    {
        unknown:"unknown",
        notavail:"notavail",
        enabled:"enabled",
        disabled:"disabled",
        some_enabled:"some_enabled",
        error:"error"
    };

    var status = statuses.unknown;

    var text = LangHelper.GetString("UlrModule","Unknown");

    var params = {
        status:"unknown"
    };

    if(Params.bypass_error)
    {
        status = statuses.error;
        text = Params.bypass_error;
    }
    else
    {
        if(parseInt(Params.bypass_available))
        {
            if(Params.bypass_status)
            {
                var statusesObj = JSON.parse(Params.bypass_status);

                var statusesArr = statusesObj ? Object.values(statusesObj) : null;

                if(statusesArr && Array.isArray(statusesArr) && statusesArr.length)
                {
                    text = "";

                    var enabledArr = statusesArr.filter(function (Obj)
                    {
                        return Obj.state === "on";
                    });

                    var standardModeArr = statusesArr.filter(function (Obj)
                    {
                        return Obj.mode === "standard";
                    });

                    var slaveArr = statusesArr.filter(function (Obj)
                    {
                        return Obj.state === "slave";
                    });
                    if(enabledArr.length === 0)
                    {
                        status = statuses.disabled;
                        text = LangHelper.GetString("UlrModule","Disabled");
                    }

                    if(enabledArr.length > 0)
                    {
                        status = statuses.some_enabled;
                        text = LangHelper.GetString("UlrModule","Some IFs in bypass mode");
                    }

                    if(enabledArr.length > 0 && enabledArr.length === (statusesArr.length - slaveArr.length))
                    {
                        status = statuses.enabled;
                        text = LangHelper.GetString("UlrModule","All IFs in bypass mode");
                    }

                    if(standardModeArr.length > 0)
                    {
                        status = statuses.error;
                        text = LangHelper.GetString("UlrModule","Some IFs works in standard mode!");
                    }

                    if(standardModeArr.length > 0 && standardModeArr.length === (statusesArr.length - slaveArr.length))
                    {
                        status = statuses.error;
                        text = LangHelper.GetString("UlrModule","All IFs works in standard mode!");
                    }
                }
            }
        }
        else
        {
            status = statuses.notavail;
            text = LangHelper.GetString("UlrModule","Not available");
        }
    }

    //exclamation-triangle

    return '<span class="webix_icon fa-lightbulb webix_icon_bypass webix_icon_bypass_' + status + '" style="cursor:pointer;"></span> ' + text;
};

var CellAnyIconBtnTemplate = function (Icon, Color = null)
{
    var icon = Icon && typeof Icon === "string" ? Icon : "";
    var color = Color && typeof Color === "string" ? Color : "";

    var style = "cursor:pointer;" + (color ? "color:" + color + ";" : "");

    if(icon)
        return "<span class=\"webix_icon fa-"+icon+"\" style=\""+style+"\"></span>";
    else
        return "";
};

var AlertErrorTemplate = function (Obj, Common, Value)
{
    if (Value)
        return "<span title=\"" + Value + "\" class=\"webix_icon fa-exclamation-triangle\" style='color: red; cursor:pointer;'></span>";
    else
        return "";
};

var AlertWarningTemplate = function (Obj, Common, Value)
{
    if (Value)
        return "<span title=\"" + Value + "\" class=\"webix_icon fa-exclamation-triangle\" style='color: orange; cursor:pointer;'></span>";
    else
        return "";
};

var CellDragAndDropBtnTemplate = function (Params)
{
    return '<span class="webix_icon fa-arrows" style="cursor:pointer;"></span>';
};

var CellCopyBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-copy\" style=\"cursor:pointer;\"></span>";
};

var CellDownloadFileBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-file-download\" style=\"cursor:pointer;\"></span>";
};

var CellStopWatchBtnTemplate = function (Params)
{
    var style = 'cursor:pointer;';
    if(Params && Params.style)
    {
        style += Params.style;
    }
    return "<span class=\"webix_icon fa-stopwatch\" style='" + style + "'></span>";
};

if(typeof Helper != "function")
{
    function Helper() {}
}

if(typeof Helper.Table != "function")
{
    Helper.Table = function(){};
}

/*
* Function Name: ActivateCheckBox
* @content = this.Views.ReportsWidgets._NAME_Report.Views.Table
* @select = name of column by which applied selected (optional)
* @column = column name being a check => [V] (optional)
* */
Helper.Table.ActivateCheckBox = function (content, select = null, column = "checked")
{
    content.attachEvent("onAfterLoad", function()
    {
        var _this = this;

        this.getHeaderContent("mc").uncheck();

        var data = this.serialize();

        if (select) {
            var selectedCount = 0;

            data.find(function(obj){
                if (obj[select]){
                    _this.select(obj.id, true);
                    selectedCount++;
                }
            });

            if (data.length && data.length == selectedCount)
                this.getHeaderContent("mc").check();
        }
    });

    content.attachEvent("onItemClick",function(id, e, node)
    {
        var checkBtn = this.getHeaderContent("mc");
        if (checkBtn.isChecked())
        {
            checkBtn.uncheck();
            this.select(id, true);
        }
    });

    content.attachEvent("onHeaderClick",function(id, e, target)
    {
        if(id.column == column)
        {
            var checkBtn = this.getHeaderContent("mc");
            if(checkBtn.isChecked())
            {
                this.selectAll();
            }
            else
            {
                this.unselectAll();
            }

            return false;
        }
    });

    content.attachEvent("onCheck", function(Row, Column, State)
    {
        if(Column == column)
        {
            if(State)
                this.select(Row, true);
            else
                this.unselect(Row, true);
        }
    });

    content.attachEvent("onAfterSelect",function(Data, Preserve)
    {
        var item = this.getItem(Data.id);
        if(item)
        {
            if(!item[column])
            {
                item[column] = 1;
            }
            this.updateItem(Data.id, item);
        }
    });

    content.attachEvent("onAfterUnSelect",function(Data)
    {
        var id = Data.row;
        var item = this.getItem(id);
        if(item && item[column])
        {
            if(item[column])
            {
                item[column] = 0;
            }
            this.updateItem(id, item);
        }
    });
}

Helper.Table.ShowModalForm = function (Id, Action, Params, Node, Type = null, Title = null, Pos = null)
{
    let title = LangHelper.GetString("All","Are you sure you want to delete the selected records?");
    let btnText = LangHelper.GetString("All","Delete");
    let type = Type?Type:"Trash";

    switch (type) {
        case 'Erase':
            title = LangHelper.GetString("All","Are you sure you want to remove all list items?");
            btnText = LangHelper.GetString("All","Remove all");
            break;
    }

    let pos = Pos?Pos:"bottom";

    let context = webix.ui({
            view:"popup",
            id: Id + type + "Context",
            width:300,
            height:180,
            body:{
                id: Id + type + "ContextForm",
                view:"form",
                borderless:true,
                elements:[
                    {
                        template:title
                    },
                    {
                        cols:[
                            {},
                            {
                                view:"button",
                                label:LangHelper.GetString("All","Cancel"),
                                click:function ()
                                {
                                    context.hide();
                                }
                            },
                            {
                                view:"button",
                                id: Id + type + "ContextFormActionBtn",
                                type:"form",
                                label:btnText,
                                click:function ()
                                {
                                    context.hide();

                                    Action(Params);
                                }
                            }
                        ]
                    }
                ]
            }
        });

    context.show(Node, {pos});
}

/*
* Function Name: OnItemClickTrash
* @Id = _this.Id
* @Obj
* @Action = _this.ViewModal.DeleteRow
* @Table = _this.Views.ReportsWidgets._NAME_Report.Views.Table
* @Message = Success notification text (optional)
* @Column = column node (mandatory if column name != "trash")
* @Pos = "bottom" (optional)
* */
Helper.Table.OnItemClickTrash = function (Id, Obj, Action, Table, Message = null, Column = null, Pos = null)
{
    let column = Column?Column:"trash";

    if (Obj.column === column)
    {
        let message = Message?Message:LangHelper.GetString("All", "Row deleted successfully");
        let pos = Pos?Pos:"bottom";

        let item = Table.getSelectedItem();
        let node = Table.getItemNode(Obj);

        let params = {
            Row:item, callback:function (R)
            {
                if(R.success) {
                    Table.remove([item.id]);
                    webix.message(message);
                } else {
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }};

        this.ShowModalForm(Id, Action, params, node, "Trash", null, pos);
    }
}

/*
* Function Name: ShowEraseForm
* */
Helper.Table.ShowEraseForm = function (Id, Action, Table, Node, Message = null, Pos = null)
{
    let message = Message?Message:LangHelper.GetString("All", "Rows deleted successfully");
    let pos = Pos?Pos:"bottom";

    let params = {
        Ids:[], callback:function (R)
        {
            if(R.success) {
                Table.clearAll();
                Table.showOverlay(LangHelper.GetString("QoE","Data not found"));
                webix.message(message);
            } else {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }};

    this.ShowModalForm(Id, Action, params, Node, "Erase", null, pos);
}

/*
* Function Name: ShowTrashForm
* */
Helper.Table.ShowTrashForm = function (Id, Action, Table, Node, Message = null, Pos = null, Column = "_id")
{
    let message = Message?Message:LangHelper.GetString("All", "Rows deleted successfully");
    let pos = Pos?Pos:"bottom";

    let rowsIds = [];
    let tableRowsIds = [];

    let selectedItem = Table.getSelectedItem();

    if (!Array.isArray(selectedItem))
        selectedItem = selectedItem?[selectedItem]:[];

    selectedItem.map(function (item) {
        rowsIds.push(item[Column]);
        tableRowsIds.push(item.id);
    });

    let params = {
        Ids:rowsIds.length?rowsIds:null, callback:function (R)
        {
            if(R.success) {
                Table.remove(tableRowsIds);
                webix.message(message);
            } else {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }};

    this.ShowModalForm(Id, Action, params, Node, null, null, pos);
}

/*
* Function Name: GetTableSelectedIds
* */
Helper.Table.GetTableSelectedIds = function (Table)
{
    let rowsIds = [];
    let tableRowsIds = [];

    let selectedItem = Table.getSelectedItem();

    if (!Array.isArray(selectedItem))
        selectedItem = selectedItem?[selectedItem]:[];

    selectedItem.map(function (item) {
        rowsIds.push(item._id);
        tableRowsIds.push(item.id);
    });

    return {rowsIds, tableRowsIds};
}

/*
* Function Name: GetDateFilter
* */
Helper.Table.GetDateFilter = function (Widget, Column, Filter = null, UTC0 = true)
{
    let filter = (typeof Filter === "object" && Filter !== null)?Filter:{};

    let format = webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    let header = Widget.Views.Table.getHeaderContent(Column)

    if(typeof header == "undefined")
        return filter;

    let date = header.getValue();

    if(date.start || date.end)
    {
        let start = '';
        let end = '';

        if (date.start)
            start = UTC0?date.start.toISOString():format(date.start);

        if (date.end)
        {
            end = new Date(date.end.setHours(23,59,59,999));
            end = UTC0?end.toISOString():format(end);
        }

        let period = {
            id: Column,
            operator: "between",
            value: [start, end]
        };

        if (!start)
        {
            period.operator = "<=";
            period.value = end;
        }

        if (!end)
        {
            period.operator = ">=";
            period.value = start;
        }

        filter["period_" + Column] = period;
    }

    return filter;
}

/*
* Function Name: GetDateFiltersWithRefresh
* */
Helper.Table.GetDateFiltersWithRefresh = function (Widget, ColumnsArr, Filter = null, Refresh = true)
{
    let _this = this;

    let filter = Filter?Filter:{};

    ColumnsArr.forEach(function (column){
        filter = _this.GetDateFilter(Widget, column, filter);
    });

    if (!Refresh)
        return filter;

    Widget.RefreshData(0, {filter});
}

/*
* Function Name: ShowProgressButton
* */
Helper.Table.ShowProgressButton = function (Btn, Show = true, Icon = "")
{
    if(Show && Btn.config.icon == "spinner-third" || !Show && Btn.config.icon != "spinner-third")
        return;

    if (Show)
    {
        Btn.disable();
        Btn.config.type_was = Btn.config.type ? Btn.config.type : "";
        Btn.define("icon","spinner-third");
        Btn.define("type","icon");
        Btn.define("css","btn_icon_spin");
        Btn.refresh();
    }else {
        Btn.enable();
        Btn.define("icon",Icon);
        this.WebixTypeSetterCustom(Btn);
        Btn.define("css","");
        webix.html.removeCss(Btn.getNode(), "btn_icon_spin");
        Btn.refresh();
    }
};

/*
* Function Name: WebixTypeSetterCustom
* */
Helper.Table.WebixTypeSetterCustom = function (Btn, Type = null)
{
    let type = Type?Type:(Btn.config.type_was ? Btn.config.type_was : "");

    let types = {
            form: "<button type='button' class='webixtype_form'>#label#</button>"
        };

    if (types[type])
    {
        Btn.$renderInput = webix.template(types[type]);
        Btn.config.type = type;
    }else
        Btn.define("type", type);

    return type;
};

/*
* Function Name: FullDateFormatToLocal
* */
Helper.Table.FullDateFormatToLocal = function (Value)
{
    if(!Value)
        return "";

    let date = new Date(Value + ".000Z");
    let format = webix.i18n.fullDateFormatStr;

    return format(date);
};

/*
* Function Name: ClsfrIdToNameTemplate
* */
Helper.Table.ClsfrIdToNameTemplate = function (Value, Сondition = false)
{
    if (Сondition)
    {
        let lang = LangHelper.GetLocale();

        let category = App.DicsManager.GetDic(DicsEnum.ClsfrCategoriesDic)[Value];

        let name = "<span style='color:#29b6f6;font-style:italic'>" + LangHelper.GetString("BlackListService", "Category removed") + "</span>";

        if (category)
        {
            let name_json = category.value;
            name = name_json[lang]?name_json[lang]:(name_json.en?name_json.en:name_json[Object.keys(name_json)[0]]);
        }

        return name;
    }

    return Value;
};

/*
* Function Name: ClearTableFilters
* */
Helper.Table.ClearTableFilters = function (Table)
{
    Table.eachColumn(function(id, col)
    {
        var filter = this.getFilter(id);

        if (filter)
        {
            if (filter.setValue) filter.setValue("");
            else filter.value = "";
        }
    });

    Table.filterByAll();
};

/*
* Function Name: NumbersOnly
* */
Helper.Table.NumbersOnly = function (Value)
{
    return Value == parseInt(Value);
};


////////////////////////////////////////
///              COMBO               ///
////////////////////////////////////////


webix.protoUI(
    {
        name: "serverCombo",

        CurrSearchTimeout:null,
        CurrSearchText:"",
        CurrSearchQueryId:webix.uid(),

        $init: function (config)
        {
            let _this = this;

            this.SetConfig(config);

            this.attachEvent("onChange", function (nVal, oVal)
            {
                if (nVal !== "" && !this.GetList().getItem(nVal))
                {
                    _this.GetRows(null, nVal, true);
                }
            });

            this.attachEvent("onKeyPress", function (code, e)
            {
                setTimeout(function ()
                {
                    if(_this.CurrSearchText != _this.getText())
                    {
                        _this.ShowPopupIfFocused();

                        _this.CurrSearchText = _this.getText();

                        clearTimeout(_this.CurrSearchTimeout);

                        _this.CurrSearchTimeout = setTimeout(function ()
                        {
                            _this.GetRows(_this.getText());
                        }, _this.config.keyPressTimeout);
                    }

                },1);
            });

            setTimeout(function ()
            {
                if(_this.getValue() === "")
                {
                    _this.setValue(0);
                }
            },1);
        },
        SetConfig: function (config){
            config.method = config.method?config.method:"";

            config.serverId = config.serverId?config.serverId:"_id";
            config.serverValue = config.serverValue?config.serverValue:"name";

            config.size = config.size?config.size:25;
            config.filter = config.filter?config.filter:{};
            config.order_by = config.order_by?config.order_by:config.serverValue;
            config.order_dir = config.order_dir?config.order_dir:"asc";

            config.keyPressTimeout = config.keyPressTimeout?config.keyPressTimeout:500;

            config.isDisabled = config.disabled?config.disabled:false;

            config.attributes = { autocomplete:"off" };
        },
        SetOptions: function (rows = []){

            let _this = this;

            let list = this.GetList();
            list.clearAll();

            rows.forEach(row => {
                list.add({id: row[_this.config.serverId], value: row[_this.config.serverValue]});
            });
        },
        GetServerFilter: function (config){
            this.size = config.size;
            this.filter = config.filter;
            this.order_by = config.order_by;
            this.order_dir = config.order_dir;
        },
        GetRows: function (text = null, id = null, overlay = false){
            let _this = this;

            if (overlay)
                this.disable();

            let _params = new this.GetServerFilter(this.config);
            _params[this.config.serverValue] = text;
            _params[this.config.serverId] = id;


            this.CurrSearchQueryId = webix.uid();

            let params =
                {
                    id:this.CurrSearchQueryId,
                    method:this.config.method,
                    data:{Params: _params},
                    callback:function (R)
                    {
                        if(_this.CurrSearchQueryId != R.id)
                            return ;

                        if(R.success)
                        {
                            _this.SetOptions(R.data.rows);

                            _this.ShowPopupIfFocused();

                            if (overlay)
                            {
                                if(!_this.config.isDisabled)
                                    _this.enable();

                                _this.refresh();
                            }
                        }
                    }
                };

            App.ServerManager.CallMethod(params);
        },

        ShowPopupIfFocused: function ()
        {
            if(webix.UIManager.hasFocus(this))
                this.getPopup().show(this.getInputNode());
        },

        GetList:function ()
        {
            return this.getPopup().getList();
        }
    },
    webix.ui.combo);

webix.protoUI(
    {
        name: "serverComboReport",

        CurrSearchTimeout:null,
        CurrSearchText:"",
        CurrSearchQueryId:webix.uid(),

        $init: function (config)
        {
            let _this = this;

            this.SetConfig(config);

            this.attachEvent("onChange", function (nVal, oVal)
            {
                if (nVal !== "" && !this.GetList().getItem(nVal))
                {
                    _this.GetRows(null, nVal, true);
                }
            });

            this.attachEvent("onKeyPress", function (code, e)
            {
                setTimeout(function ()
                {
                    if(_this.CurrSearchText != _this.getText())
                    {
                        _this.ShowPopupIfFocused();

                        _this.CurrSearchText = _this.getText();

                        clearTimeout(_this.CurrSearchTimeout);

                        _this.CurrSearchTimeout = setTimeout(function ()
                        {
                            _this.GetRows(_this.getText());
                        }, _this.config.keyPressTimeout);
                    }

                },1);
            });

            setTimeout(function ()
            {
                if(_this.getValue() === "")
                {
                    _this.setValue(0);
                }
            },1);
        },
        SetConfig: function (config){
            config.method = config.method?config.method:"";

            config.serverId = config.serverId?config.serverId:"_id";
            config.serverValue = config.serverValue?config.serverValue:"name";

            config.size = config.size?config.size:25;
            config.filter = config.filter?config.filter:{};
            config.filter_name = config.filter_name?config.filter_name:config.serverValue;
            config.order_by = config.order_by?config.order_by:config.serverValue;
            config.order_dir = config.order_dir?config.order_dir:"asc";

            config.keyPressTimeout = config.keyPressTimeout?config.keyPressTimeout:500;

            config.isDisabled = config.disabled?config.disabled:false;

            config.attributes = { autocomplete:"off" };
        },
        SetOptions: function (rows = []){

            let _this = this;

            let list = this.GetList();
            list.clearAll();

            rows.forEach(row => {
                list.add({id: row[_this.config.serverId], value: row[_this.config.serverValue]});
            });
        },
        GetServerFilter: function (config){
            this.size = config.size;
            this.filter = config.filter;
            this.order_by = config.order_by;
            this.order_dir = config.order_dir;
        },
        GetRows: function (text = null, id = null, overlay = false){
            let _this = this;

            if (overlay)
                this.disable();

            let _params = new this.GetServerFilter(this.config);
            _params.filter = {};
            _params.filter[this.config.filter_name] = text;

            this.CurrSearchQueryId = webix.uid();

            let params =
                {
                    id:this.CurrSearchQueryId,
                    method:this.config.method,
                    data:{Params: _params},
                    callback:function (R)
                    {
                        if(_this.CurrSearchQueryId != R.id)
                            return ;

                        if(R.success)
                        {
                            _this.SetOptions(R.data.rows);

                            _this.ShowPopupIfFocused();

                            if (overlay)
                            {
                                if(!_this.config.isDisabled)
                                    _this.enable();

                                _this.refresh();
                            }
                        }
                    }
                };

            App.ServerManager.CallMethod(params);
        },

        ShowPopupIfFocused: function ()
        {
            if(webix.UIManager.hasFocus(this))
                this.getPopup().show(this.getInputNode());
        },

        GetList:function ()
        {
            return this.getPopup().getList();
        }
    },
    webix.ui.combo);

webix.protoUI({
    name: "custom_overlay_datatable",
    $init: function (config) {
        webix.ui.datatable.prototype.$init.call(this, config);

        this._datatable_overlay = null;
    },
    showOverlay: function (message) {
        if(!this._datatable_overlay)
        {
            let t;
            if (
                message === LangHelper.GetString("QoE","Query was cancelled")
                || message === LangHelper.GetString("QoE","Data not found")
            )
            {
                t = webix.html.create("DIV", { "class": "webix_custom_overlay" }, "");
            }
            else
            {
                t = webix.html.create("DIV", { "class":"webix_overlay" }, "");
            }

            let childrens = this.$view.children;
            for (const children of childrens)
            {
                if(children.classList.contains('webix_ss_body'))
                {
                    children.appendChild(t);
                    break;
                }
            }

            this._datatable_overlay = t;
        }
        this._datatable_overlay.innerHTML = message;
    },
    hideOverlay:function(){
        if (this._datatable_overlay){
            webix.html.remove(this._datatable_overlay);
            this._datatable_overlay = null;
        }
    },
}, webix.ui.datatable);
var TextTemplate = function (Value, TextTrue, TextFalse, SelectColor = "#1A84D8")
{
    if (parseInt(Value,10))
        return "<span style=\"color:" + SelectColor + "\">" + TextTrue + "</span>";
    else
        return "<span>" + TextFalse + "</span>";
};

var LocalTimeZone = function (Obj, Common, Value)
{
    return Helper.Table.FullDateFormatToLocal(Value);
};

var CellSwitchBoxTemplateWithText = function (Obj, Common, Value, Config, RowIndex, TextOn = "Вкл", TextOff = "Выкл", Width=70, Disabled = false)
{
    var bool = parseInt(Value, 10);
    var div_class = (Disabled?"":"webix_table_checkbox ") + "webix_switch_box" + (bool?" webix_switch_on":"");
    var style = "width:" + Width + "px;" + (Disabled?" color: #fff !important; background-color: #848484 !important":"");
    var text_top = !bool?"-11":"-10";

    return '<div class="' + div_class + '" style="' + style + '"><span class="webix_switch_text" style="font-size: 13px; position: absolute; top: ' + text_top + 'px; left:0;">' + (bool?TextOn:TextOff) + '</span><button class="webix_switch_handle" aria-label="Switch" role="checkbox" tabindex="0" style="' + (bool?"right":"left") + ':0px;"><input class="webix_switch_toggle" type="checkbox"></button></div>';
};

var CellStatOnOffTemplate = function (Obj, Common, Value)
{
    if (parseInt(Value, 10))
        return "<div class='checked' style=\"cursor:pointer; color:#1A84D8;\"><span class=\"webix_icon fa-check-square\"></span> " + OnOffDic["1"].value + "</div>";
    else
        return "<div class='notchecked' style=\"cursor:pointer;\"><span class=\"webix_icon fa-square\"></span> " + OnOffDic["0"].value + "</div>";
};

var CellFormatTemplate = function (Value, Latin = false, Numbers = false, Special = false, LowerCase = false, UpperCase = false, Prefix = "")
{
    let latin = Latin?"a-zA-Z":"";
    let numbers = Numbers?"0-9":"";
    let special = Special?Special:"";

    let params = "[^" + latin + numbers + special + "]+";
    let pattern = new RegExp(params);

    Value = Value.replace(pattern,'');

    if (LowerCase)
        Value = Value.toLowerCase();

    if (UpperCase)
        Value = Value.toLowerCase();

    if (Prefix != Value.substr(0, Prefix.length))
        return Prefix+Value;

    return Value;
};

var CellLinkExternalIdTemplate = function (Obj, Common, Value) {
    var href = "https://bt.vasexperts.ru/contacts/" + Value;
    if(!Value)
        return "";

    return "<a href=\""+ href +"\" target=\"_blank\" style=\"cursor:pointer;\"><span class=\"webix_cell_link\">"+ Value +"</span></a>";
}
var CellLinkTicketTemplate = function (Obj, Common, Value) {
    var href = "https://bt.vasexperts.ru/issues/" + Value;
    if(!Value)
        return "";

    return "<a href=\""+ href +"\" target=\"_blank\" style=\"cursor:pointer;\"><span class=\"webix_cell_link\">"+ Value +"</span></a>";
}


var CellRefreshBtnTemplate = function(Params)
{
    return '<span class="webix_icon fa-sync" style="cursor:pointer;"></span>';
};

var CellThermBtnTemplate = function (Params)
{
    return "<span class=\"webix_icon fa-thermometer-half\" style=\"cursor:pointer;\"></span>";
};

var AppButtonBadgeTemplate = function (Params)
{
    if(Params != 0)
        return `<div class=\"badge_inner\">${Params}</div>`;
    else
        return Params;
}

var CellBlockBtnTemplate = function (isBanned = false)
{
    if (isBanned)
        return "<span class=\"webix_icon fa-exclamation-triangle\" style=\"cursor:pointer; color: #fd7272;\"></span>";

    return "<span class=\"webix_icon fa-ban\" style=\"cursor:pointer; color: #fd7272;\"></span>";
};

var TemplateColumnBlock = function (ColumnId, Width = 40, Template = null, Tooltip = null) {
    const column =
    {
        id: ColumnId,
        header: "",
        width: Width,
        headermenu: false,
    }

    if (typeof Template == "function")
    {
        column.template = Template;
    }

    if (Tooltip)
    {
        column.tooltip = Tooltip;
    }

    return column;
}
function QoEWidgetCacheMonitor(Widget, WidgetView, ViewModel)
{
    var _this = this;

    this.Widget = Widget;

    this.WidgetView = WidgetView;

    this.ViewModel = ViewModel;

    webix.extend(this.WidgetView , webix.OverlayBox);
    webix.extend(this.WidgetView , webix.ProgressBar);

    this.RefreshSilenceSignal = new Rx.BehaviorSubject(0);

    this.LastCacheId = null;

    this.SentProgressMsgs = [];

    this.TimoutSec = 3;
    this.Timer = null;
}

QoEWidgetCacheMonitor.prototype.Destroy = function (Data)
{
    this.StopTimer();

    this.Widget = null;
    this.WidgetView = null;
    this.ViewModel = null;
};

QoEWidgetCacheMonitor.prototype.DataSignal = function (Data, Error)
{
    var _this = this;

    this.WidgetView.hideOverlay();
    this.WidgetView.hideProgress();

    var cache_id = "";
    if(Data) {
        cache_id = Data.cache_id ? Data.cache_id : (Data.cache && Data.cache.cache_id ? Data.cache.cache_id : "");
    }

    var report = _this.Widget.GetReportConfig();

    if(Error)
    {
        this.StopTimer();
        this.RefreshSilenceSignal.next({cache_id: cache_id, enabled:0});
        this.WidgetView.showOverlay(Error.msg);

        return;
    }

    if(Data && Data.cache)
    {
        var cache = Data.cache;

        var sync = parseInt(cache.sync, 10);

        var progress = 0;

        this.LastCacheId = cache.cache_id;

        cache.total_rows_to_read = cache.total_rows ? cache.total_rows : cache.total_rows_to_read;

        if(cache.total_rows_to_read && cache.read_rows)
        {
            progress = Math.round(cache.read_rows / cache.total_rows_to_read * 10) / 10;
        }

        var progressText = LangHelper.GetString("QoE","Processing")+": " + (progress * 100) + " %" + "<br/>";

        progressText += this.GetCacheProgressLines(cache, " / ");

        if(sync == QoEReportCacheSyncEnum.Created)
        {
            progressText = LangHelper.GetString("QoE","Waiting queue")+"...";
        }

        progressText += '<div style="margin: 0 auto; width:160px;" id="'+this.Widget.Id+"OverlayToolbar"+'"></div>';

        switch(sync)
        {
            case QoEReportCacheSyncEnum.Created:
            case QoEReportCacheSyncEnum.Progress:
                this.WidgetView.hideOverlay();

                if(!report.config.online) {
                    this.WidgetView.showOverlay(progressText);
                }

                try
                {
                    webix.ui({
                        view:"button",
                        label:LangHelper.GetString("QoE", "Cancel query"),
                        container:this.Widget.Id+"OverlayToolbar",
                        icon:"hand-paper",
                        type:"icon",
                        click:function ()
                        {
                            _this.ViewModel.KillProcesses({data:[{query_id:cache.cache_id}], callback:function (R)
                                {
                                    var processResult = function (R)
                                    {
                                        if(R.success)
                                        {
                                            webix.message(LangHelper.GetString("QoE","Canceled"));
                                        }
                                        else
                                        {
                                            webix.message({type:"error", text:R.error.msg});
                                        }
                                    };

                                    if(R)
                                    {
                                        if(Array.isArray(R))
                                        {
                                            R.forEach(function (R)
                                            {
                                                processResult(R);
                                            });
                                        }
                                        else
                                        {
                                            processResult(R);
                                        }
                                    }
                                }});
                        }
                    });
                }
                catch (e) {}

                if(!report.config.online) {
                    this.WidgetView.showProgress({
                        type:"icon"
                    });
                    this.WidgetView.refresh();
                }
                this.RefreshSilenceSignal.next({cache_id: cache_id, enabled:1});
                this.RestartTimer();
                break;

            case QoEReportCacheSyncEnum.CreatedError:
            case QoEReportCacheSyncEnum.Error:
                this.StopTimer();
                this.RefreshSilenceSignal.next({cache_id: cache_id, enabled:0});

                if(cache.error && cache.error.indexOf("Code: 394") > -1 && cache.error.indexOf("Query was cancelled") > -1)
                {
                    this.WidgetView.showOverlay(LangHelper.GetString("QoE","Query was cancelled"));
                    break;
                }

                this.WidgetView.showOverlay(LangHelper.GetString("All","Error") + (cache.error ? ": " + cache.error : ""));
                break;

            case QoEReportCacheSyncEnum.Cancel:
                this.StopTimer();
                this.WidgetView.showOverlay(LangHelper.GetString("QoE","Query was cancelled"));
                this.RefreshSilenceSignal.next({cache_id: cache_id, enabled:0});
                break;

            default:
                this.StopTimer();
                this.WidgetView.hideProgress();
                this.WidgetView.hideOverlay();
                this.RefreshSilenceSignal.next({cache_id: cache_id, enabled:0});
                break;
        }
    }
    else
    {
        if(Data && Data.rows && Data.rows.length == 0  && ((!Data.series || Data.series && Data.series.length == 0)))
        {
            this.WidgetView.showOverlay(LangHelper.GetString("QoE","Data not found"));
        }

        if(Data && Data.cache_id)
            this.LastCacheId = Data.cache_id;

        if(Data && Data.cache_id && Data.cache_progress) {
            this.SendProgressMsg(Data.cache_id, Data.cache_progress);
        }

        this.StopTimer();
        this.RefreshSilenceSignal.next({cache_id: cache_id, enabled:0});
    }
};

QoEWidgetCacheMonitor.prototype.StopTimer = function ()
{
    clearTimeout(this.Timer);
};

QoEWidgetCacheMonitor.prototype.RestartTimer = function ()
{
    var _this = this;

    this.StopTimer();
//return;
    if(!this.Widget.RefreshData)
        return;

    this.Timer = setTimeout(function ()
    {
        var reportConfig = _this.Widget.GetReportConfig();
        _this.Widget.RefreshData(reportConfig.params?reportConfig.params.page:0);
    }, this.TimoutSec * 1000);
};

QoEWidgetCacheMonitor.prototype.SendProgressMsg = function(CacheId, CacheProgress)
{
    if(this.SentProgressMsgs.includes(CacheId))
        return;

    if(window.AppEnv && window.AppEnv.DisableQoESendProgressMsg)
    {
        return;
    }

    let progressMsg = LangHelper.GetString("QoE", "Cache report stat");
    progressMsg += this.Widget.Title ? " " + this.Widget.Title + ":\n" : ":\n";
    progressMsg += this.GetCacheProgressLines(CacheProgress);
    webix.message(progressMsg);
    this.SentProgressMsgs.push(CacheId);
};

QoEWidgetCacheMonitor.prototype.GetCacheProgressLines = function(Params, Sep)
{
    Sep = Sep === undefined ? "\n" : Sep;

    var formatters = {
        read_rows: function(Val) { return LangHelper.GetString("QoE", "Read rows") + ": " + Helper.UnitPrefixToNumeric(Val, 1000, CountUnits); },
        read_bytes: function(Val) { return LangHelper.GetString("QoE", "Read bytes") + ": " + Helper.UnitPrefixToNumeric(Val, 1024, CountUnits); },
        total_rows_to_read: function(Val) { return LangHelper.GetString("QoE", "Total rows") + ": " + Helper.UnitPrefixToNumeric(Val, 1000, CountUnits); },
        elapsed_ns: function(Val) { return LangHelper.GetString("QoE", "Elapsed") + ": " + Helper.UnitPrefixToNumeric(Val / 1000000000, 1000, TimeUnits); }
    };

    var lines = [];

    Object.keys(formatters).forEach(function(Key) {
        var val = Params[Key];

        if(val)
            lines.push(formatters[Key](val));
    });

    return lines.join(Sep);
};


function QoEExcelExportWidget(Widget, ExportBtn, Title, WidgetType)
{
    var _this = this;

    this.Id = webix.uid();
    this.Widget = Widget;
    this.ExportBtn = ExportBtn;
    this.Title = Title;
    this.WidgetType = WidgetType ? WidgetType : "Table";

    this.isQoE = typeof this.Widget.Id === "string" &&  (this.Widget.Id.indexOf("QoE") < 0 ||
                                                            this.Widget.Id.indexOf("NotQoE") >= 0) ? false: true;

    if(this.isQoE){
        this.ExportOptions = [
            {id:"toExcel", value:"Excel"},
            {id:"toTabSeparated", value:"TabSeparated"},
            {id:"toCSV", value:"CSV"},
            {id:"toPDF", value:"PDF"},
            {id:"toPNG", value:"PNG"}
        ];
    } else {
        this.ExportOptions = [
            {id:"toExcel", value:"Excel"},
            {id:"toCSV", value:"CSV"},
            {id:"toPDF", value:"PDF"},
            {id:"toPNG", value:"PNG"}
        ];
    }

    if(App.NavRouter.currentViewId == "QoEDashboard")
    {
        this.ExportOptions = [
            {id:"toExcel", value:"Excel"},
            {id:"toTabSeparated", value:"TabSeparated"},
            {id:"toCSV", value:"CSV"},
            {id:"toPDF", value:"PDF"}
        ];
    }

    this.ExportDefaultValue = "toExcel";

    if(WidgetType == "Chart")
    {
        this.ExportOptions = [
            {id:"toPNG", value:"PNG"},
            {id:"toChartPDF", value:"PDF"}
        ];

        this.ExportDefaultValue = "toChartPDF";

        if(App.NavRouter.currentViewId == "QoEDashboard")
        {
            this.ExportOptions = [
                {id:"toChartPDF", value:"PDF"}
            ];
        }

        if (!this.Widget.PdfExportConfig) {
            this.ExportBtn.disable();
        }
    }

    this.Views = {
        Form: this.Id + "Form"
    };

    this.ContextConfig = {
        view: "popup",
        id:this.Id + "Context",
        maxWidth: 400,
        maxHeight: 320,
        resize: true,
        body: {
            borderless:true,
            rows:
                [
                    {
                        view:"form",
                        id:this.Id + "Form",
                        elements:[
                            {
                                view: "text",
                                name: "filename",
                                label: LangHelper.GetString("QoE", "File name"),
                                labelPosition: "top"
                            },
                            {
                                view: "richselect",
                                name: "export_type",
                                label: LangHelper.GetString("QoE","Export format"),
                                labelPosition: "top",
                                options: this.ExportOptions,
                                value:this.ExportDefaultValue
                            }
                            // ,
                            // {
                            //     cols:[
                            //         {
                            //             view: "text",
                            //             name: "page_from",
                            //             label: LangHelper.GetString("QoE", "Page from"),
                            //             labelPosition: "top",
                            //             attributes:{ type:"number", min:"1", max:"100" }
                            //         },
                            //         {
                            //             view: "text",
                            //             name: "page_to",
                            //             label: LangHelper.GetString("QoE", "Page to"),
                            //             labelPosition: "top",
                            //             attributes:{ type:"number", min:"1", max:"100" }
                            //         }
                            //     ]
                            // }
                        ]
                    },
                    {
                        view:"form",
                        elements:[
                            {
                                cols:[
                                    {
                                        gravity:2
                                    },
                                    {
                                        view: "button",
                                        label: LangHelper.GetString("All", "Cancel"),
                                        click: function ()
                                        {
                                            _this.Context.hide();
                                        }
                                    },
                                    {
                                        view: "button",
                                        type: "form",
                                        label: LangHelper.GetString("All", "Export"),
                                        click: function ()
                                        {
                                            _this.Export();

                                            _this.Context.hide();
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
        }
    };

    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
    {
        this.ContextConfig = {
            view: "window",
            id:this.Id + "Context",
            css:"spectre-alert form_modal",
            modal:true,
            position:"center",
            padding:0,
            marging:0,
            head:{
                view:"toolbar", cols:[
                    {
                        view:"label",
                        id: this.Id + "ExportRulePopupHeadLabel",
                        label: LangHelper.GetString("UlrModule","Export"),
                        height:68
                    },
                    { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.Context.hide(); }}
                ]
            },
            body: {
                type:"space",
                borderless:true,
                rows:[
                    {
                        type:"clean",
                        borderless:true,
                        rows:[
                            {
                                view: "form",
                                id: this.Id + "Form",
                                type: "wide",
                                elements: [
                                    {
                                        cols:[
                                            {
                                                view:"spectre_text",
                                                name: "filename",
                                                label: LangHelper.GetString("QoE", "File name")
                                            }
                                        ]
                                    },
                                    {
                                        cols:[
                                            {
                                                view:"spectre_richselect",
                                                name: "export_type",
                                                label:LangHelper.GetString("UlrModule","Export format"),
                                                options: this.ExportOptions,
                                                value:this.ExportDefaultValue
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height:20},
                            {
                                type:"wide",
                                cols:[
                                    {
                                        view:"spectre_button",
                                        css:"form_button main_action",
                                        label: LangHelper.GetString("All", "Export"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            setTimeout(function ()
                                            {
                                                _this.Export();
                                                _this.Context.hide();
                                            },1);

                                        }
                                    },
                                    {}
                                ]
                            }
                        ]
                    }
                ]
            }
        };
    }

    this.Context = null;

    this.BindAll();
}

QoEExcelExportWidget.prototype.Destroy = function ()
{
    this.Widget = null;
    this.ExportBtn = null;
    this.Title = null;
};

QoEExcelExportWidget.prototype.BindAll = function ()
{
    var _this = this;

    this.Context = webix.ui(this.ContextConfig);

    this.Views.Form = $$(this.Id + "Form");

    if(this.ExportBtn && this.Widget && this.Widget.Views[this.WidgetType])
    {
        this.ExportBtn.attachEvent("onItemClick", function(id)
        {
            _this.Show();
        });
    }
};

QoEExcelExportWidget.prototype.Show = function ()
{
    var title = this.Widget.GetExportTitle();

    var filename =  title ? title : LangHelper.GetString("AppView","Title");

    filename = Helper.ReplaceAll(" ", "_", filename);

    //var page = this.Widget.Views.Paging.data.page + 1;

    this.Views.Form.setValues({filename:filename, export_type:this.ExportDefaultValue /*, page_from:page, page_to:page*/});


    typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? this.Context.show() : this.Context.show(this.ExportBtn.getNode(),{pos:"top"});
};

QoEExcelExportWidget.prototype.Export = function ()
{
    var _this = this;
    //Без этого глючит!
    if(document.getElementById("hiddenDownloader"))
        document.getElementById("hiddenDownloader").remove();

    var filename = this.Views.Form.elements.filename.getValue();

    var type = this.Views.Form.elements.export_type.getValue();



    this.ExportBtn.disable();

    if(type != "toPNG" && this.Widget.OnExport && typeof this.Widget.OnExport == "function")
    {
        this.Widget.OnExport(filename, type, function(R){
            _this.ExportBtn.enable();
        });
        return;
    }

    if(this.isQoE){
        if(type == 'toPNG')
        {
            var params = {
                filename: filename,
                name: filename,
                filterHTML:true,
                orientation:"landscape",
                autowidth:true
            };

            if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
            {
                params.header = {
                    textAlign:"left",
                    fontSize:12,
                    backgroundColor:0xEFF4F5,
                    color:0x4F4F4F,
                    borderWidth:0,
                    paddingLeft:16,
                    paddingRight:16
                };
                params.table = {
                    textAlign:"left",
                    fontSize:12,
                    backgroundColor:0xFFFFFF,
                    color:0x4F4F4F,
                    paddingLeft:16,
                    paddingRight:16
                };
                params.footer = {
                    textAlign:"left",
                    fontSize:12,
                    backgroundColor:0xFFFFFF,
                    color:0x4F4F4F,
                    paddingLeft:16,
                    paddingRight:16,
                    filterHTML:true
                };
            }

            webix[type](this.Widget.Views[this.WidgetType],params);

            this.ExportBtn.enable();

            if(this.Widget.ReportsSettingsManager && this.Widget.ReportsSettingsManager.ReportsSettings[this.Widget.Id])
            {
                let exportParams;
                let widgetSettingsModel = this.Widget.ReportsSettingsManager.ReportsSettings[this.Widget.Id];

                if(this.Widget.PdfExportConfig.view_type === "table" && type !== ".pdf")
                {
                    exportParams = this.Widget.GetRefreshDataConfig();
                }
                else
                {
                    exportParams = this.Widget.GetReportConfig();
                }

                let params = {
                    "report_settings": widgetSettingsModel.GetReportSettings(),
                    "filter": exportParams && exportParams.params && exportParams.params.filter ? exportParams.params.filter : null
                };
                
                this.MakePNGQoEReportExportUsersActionsLog(params);
            }
        }
        else
        {
            let exportParams;

            if (this.Widget.PdfExportConfig.view_type === "table" && type !== ".pdf") {
                exportParams = this.Widget.GetRefreshDataConfig();
            } else {
                exportParams = this.Widget.GetReportConfig();
            }

            this.Widget.PdfExportConfig.type = type;
            this.Widget.PdfExportConfig.filename = filename;
            this.Widget.PdfExportConfig.locale = LangHelper.GetLocale();
            this.Widget.PdfExportConfig.title = this.Widget.Title ? this.Widget.Title : "";

            if (exportParams.params.filter && exportParams.params.filter.period) {
                this.Widget.PdfExportConfig.subtitle = exportParams.params.filter.period.value.join(" - ");
            }

            if(this.Widget.PdfExportConfig.view_type === "chart")
            {

                this.Widget.RefreshPdfExportConfig();

                if (this.Widget.Views.ChartRange)
                    this.Widget.PdfExportConfig.data = this.Widget.Views.ChartRange.getFrameData();

            }

            if(this.Widget.ViewController && this.Widget.ViewController)
            {
                if
                (
                    this.Widget.ViewController.constructor.name === "QoEDashboardViewController" &&
                    this.Widget.ViewController.DashboardViews && this.Widget.ViewController.DashboardViews.extendedFilter
                )
                {
                    this.Widget.PdfExportConfig.locales.filter_section = this.Widget.ViewController.DashboardViews.extendedFilter.GetLocales();
                }
                else if (this.Widget.ViewController.Views.Widgets.ExtendedFillter)
                {
                    this.Widget.PdfExportConfig.locales.filter_section = this.Widget.ViewController.Views.Widgets.ExtendedFillter.GetLocales();
                }
            }

            if(this.Widget.ReportsSettingsManager && this.Widget.ReportsSettingsManager.ReportsSettings[this.Widget.Id])
            {
                let widgetSettingsModel = this.Widget.ReportsSettingsManager.ReportsSettings[this.Widget.Id];
                exportParams.report_settings = widgetSettingsModel.GetReportSettings();
            }

            this.Widget.ViewModel.GetReportDataExportFileData(this.Widget.Id, exportParams, this.Widget.EnableLocalDataSource, this.Widget.PdfExportConfig, this.ExportBtn);
        }
    } else {
        if(type == "toPDF")
        {
            var size = this.Widget.Views.Paging.data.size;

            if(size > 100)
            {
                webix.message({type:"error", text:LangHelper.GetString("QoE", "We can`t process export to PDF when page size is more then 100")});

                this.ExportBtn.enable();

                return;
            }
        }

        var params = {
            filename: filename,
            name: filename,
            filterHTML:true,
            orientation:"landscape",
            autowidth:true
        };

        if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
        {
            params.header = {
                textAlign:"left",
                fontSize:12,
                backgroundColor:0xEFF4F5,
                color:0x4F4F4F,
                borderWidth:0,
                paddingLeft:16,
                paddingRight:16
            };
            params.table = {
                textAlign:"left",
                fontSize:12,
                backgroundColor:0xFFFFFF,
                color:0x4F4F4F,
                paddingLeft:16,
                paddingRight:16
            };
            params.footer = {
                textAlign:"left",
                fontSize:12,
                backgroundColor:0xFFFFFF,
                color:0x4F4F4F,
                paddingLeft:16,
                paddingRight:16,
                filterHTML:true
            };
        }

        webix[type](this.Widget.Views[this.WidgetType],params);

        this.ExportBtn.enable();
    }
};

QoEExcelExportWidget.prototype.DataSignal = function (Data, Error)
{
    if(Error)
    {
        return;
    }

    if(Data && Data.cache)
    {
        return;
    }
};

QoEExcelExportWidget.prototype.MakePNGQoEReportExportUsersActionsLog = function (Params)
{
    let params = {
        method: "MakePNGQoEReportExportUsersActionsLog",
        data: {Params: Params}
    };

    App.ServerManager.CallMethod(params);
};

webix.ui.datafilter.totalColumn = webix.extend({
    refresh:function(master, node, value){

        var totals = master.data.totals;

        if(totals)
        {
            var v = Number(totals[value.columnId] || "");

            var t = Helper.IsInteger(v) ? webix.i18n.intFormat(v) : webix.i18n.numberFormat(v);

            node.firstChild.innerHTML = t;
        }
        else
        {
            node.firstChild.innerHTML = "";
        }

    }
}, webix.ui.datafilter.summColumn);

webix.ui.datafilter.totalStrColumn = webix.extend({
    refresh:function(master, node, value){

        var totals = master.data.totals;

        if(totals)
        {
            var v = totals[value.columnId] || "";

            node.firstChild.innerHTML = v;
        }
        else
        {
            node.firstChild.innerHTML = "";
        }

    }
}, webix.ui.datafilter.summColumn);

webix.ui.datafilter.totalRows = webix.extend({
    refresh:function(master, node, value){

        var count = master.data.rows_count;

        if(count)
        {
            var v = Number(count || "");

            var t = Helper.IsInteger(v) ? webix.i18n.intFormat(v) : webix.i18n.numberFormat(v);

            node.firstChild.innerHTML = t;
        }
    }
}, webix.ui.datafilter.summColumn);

const NotProcessedColumnsIds = ["menu", "empty", "enabled", "edit", "delete", "space"];

function QoeTableColumnStorageConfigModel(Params)
{
    let model = {};

    model.id = Params && Params.id ? Params.id : "";
    model.width = Params && Params.width ? Params.width : "";
    model.fillspace = Params && Params.fillspace ? Params.fillspace : false;

    return model;
}

function QoETableStorageConfigModel(Params)
{
    let model = {
        columns: []
    };

    if(Params && Params.columns.length)
    {
        Params.columns.forEach(col => {
           model.columns.push(QoeTableColumnStorageConfigModel(col));
        });
    }

    return model;
};

function QoETableReportWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ReportId = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.Views = {
        Table:null,
        TablePaginatorToolbar:null,
        Paging:null,
        Size:null,
        SizeInfo:null,
        ExcelExport:null,
        RowContextMenu:null,
        TextSearch:null,

        ReportSettingsBtn:null
    };

    this.ExternalFilter = {};

    this.TableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.CacheMonitor = null;

    this.ExcelExportWidget = null;

    this.OnExport = null;

    this.ReportsSettingsManager = null;

    this.Title = "";

    this.GetExportTitleCallback = null;

    this.DataAdapter = function (Data)
    {
        return Data;
    };

    this.ViewController = null;

    this.PdfExportConfig = null;

    this.ReportSettings = null;

    this.Init(ViewConfig);
}

QoETableReportWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Name = ViewConfig.name ? ViewConfig.name : null;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.Title = ViewConfig.title ? ViewConfig.title : "";

    this.GetExportTitleCallback = ViewConfig.export_title_callback ? ViewConfig.export_title_callback : null;

    this.SortMap = ViewConfig.sort_map ? ViewConfig.sort_map : {};

    this.CanUseSortMap = ViewConfig.can_use_sort_map ? ViewConfig.can_use_sort_map : {};

    this.Filter = ViewConfig.filter ? ViewConfig.filter : null;

    this.SphinxSearch = ViewConfig.sphinx_search ? ViewConfig.sphinx_search : null;

    this.EnableRowContextMenu = ViewConfig.enableRowContextMenu ? true : false;

    this.HideExportWidget = ViewConfig.hideExport ? true : false;

    this.EnableTextSearch = ViewConfig.enableTextSearch ? true : false;

    this.HidePaginatorToolbar = ViewConfig.hidePaginatorToolbar ? true : false;

    this.AutoHeight = ViewConfig.enableAutoHeight ? true : false;

    this.EnableCheckboxRefresh = ViewConfig.enableCheckboxRefresh ? true : false;

    this.EnableLocalSort = ViewConfig.enableLocalSort ? true : false;

    this.EnableLocalDataSource = ViewConfig.enableLocalDataSource ? true : false;

    this.RowAutoHeight = ViewConfig.rowAutoHeight ? ViewConfig.rowAutoHeight : null;

    this.SortDisabledColumns = ViewConfig.sortDisabledColumns ? ViewConfig.sortDisabledColumns : null;

    this.OnExport = ViewConfig.onExport && typeof ViewConfig.onExport == "function" ? ViewConfig.onExport : null;

    this.DefaultPageSize = this.GetStoredPageSize() ? this.GetStoredPageSize() : ViewConfig.defaultPageSize ? ViewConfig.defaultPageSize : 100;

    this.GetExportPdfConfig(ViewConfig);

    this.ReportSettings = ViewConfig.report_settings ? ViewConfig.report_settings : null;

    this.DisableSaveColumnsSize = ViewConfig.disableSaveColumnsSize ? true : false;

    this.GetReportConfigKey = ViewConfig.getReportKeyCallback ? ViewConfig.getReportKeyCallback : null;

    this.DefaultTableConfigs = {};
    this.DefaultTableColsOrder = [];

    if(!this.EnableRowContextMenu && this.Config && this.Config.table && QoEReportTablesEnum && !this.Config.online)
    {
        Object.keys(QoEReportTablesEnum).every(function (K, I)
        {
            if(I > 11)
                return false;

            if(QoEReportTablesEnum[K] == _this.Config.table)
            {
                _this.EnableRowContextMenu = true;

                return false;
            }

            return true;
        });
    }

    this.ShowProgressWhenDataLoading = ViewConfig.showProgressWhenDataLoading ? ViewConfig.showProgressWhenDataLoading : false;

    this.ViewConfig =
    {
        id:this.Id,
        rows:function ()
        {
            var rows = [];

            if(ViewConfig.title)
                rows.push(BlockHeaderTemplate({title:ViewConfig.title ? ViewConfig.title : "", icon:ViewConfig.icon ? ViewConfig.icon : ""}));

            if(_this.EnableTextSearch)
                rows.push({
                    cols:[
                        {
                            css:"datatable_search_icon",
                            template:'<span class="webix_icon fa-search"></span>',
                            width:40,
                            borderless:true
                        },
                        {
                            view:"text",
                            css:"datatable_search_input",
                            id:_this.Id + "TextSearch",
                            placeholder:LangHelper.GetString("UlrModule","Datatable search..."),
                            keyPressTimeout:1000,
                            borderless:true
                        },
                        {
                            css:"datatable_toolbar",
                            cols:[
                                {
                                    view:"button",
                                    type:"icon",
                                    icon:"refresh",
                                    width:32,
                                    padding:0,
                                    align:"center",
                                    click:function ()
                                    {
                                        _this.RefreshData();
                                    }
                                },
                                {
                                    width:8
                                }
                            ]
                        }
                    ]
                });

            var datatable = {
                view:"datatable",
                id:_this.Id + "Table",
                css:ViewConfig.tableCss ? ViewConfig.tableCss : "",
                autoheight:_this.AutoHeight,
                checkboxRefresh:_this.EnableCheckboxRefresh,
                columns:function ()
                {
                    var c = ViewConfig.columns ? ViewConfig.columns : [];

                    if(_this.EnableRowContextMenu && c && c.length)
                    {
                        c = [
                            {
                                id:"menu",
                                header:"",
                                sort:false,
                                width:16,
                                tooltip:LangHelper.GetString("QoE", "Menu"),
                                template:CellMenuBtnTemplate
                            }
                        ].concat(c);
                    }

                    _this.DefaultTableColsOrder = c.map(a => a.id);

                    _this.PrepareColumnsFormat(c);

                    return c;
                }(),
                header:ViewConfig.hideHeader ? false : true,
                footer:ViewConfig.footer ? true : false,
                select: "row",
                editable: ViewConfig.editable ? true : false,
                editaction: ViewConfig.editaction ? ViewConfig.editaction : "custom",
                multiselect:ViewConfig.multiselect ? ViewConfig.multiselect : false,
                resizeColumn:true,
                tooltip:true,
                scroll:"xy",
                dragColumn:true,
                drag: ViewConfig.drag ? ViewConfig.drag : false,
                navigation:false,
                hidden:ViewConfig.hidden ? true : false,
                leftSplit:ViewConfig.leftSplit ? ViewConfig.leftSplit + (_this.EnableRowContextMenu ? 1 : 0 ) : 0,
                rightSplit:ViewConfig.rightSplit ? ViewConfig.rightSplit : 0,
                headermenu: {
                    width: 320,
                    autoheight: false,
                    scroll: true
                },
                on: {
                    onHeaderClick:function(id, e, target)
                    {
                        if(_this.EnableLocalSort)
                            return true;

                        const disabledHeaders = [
                            "enabled",
                            "edit",
                            "delete",
                            "space",
                            "checked",
                            "run_stop",
                            "copy",
                            "empty",
                            "menu"
                        ];

                        if(disabledHeaders.includes(id.column))
                            return false;

                        if(_this.SortDisabledColumns && Array.isArray(_this.SortDisabledColumns))
                        {
                            if(_this.SortDisabledColumns.indexOf(id.column) >= 0)
                                return false;
                        }

                        var sortState = this.getState().sort;

                        var dir = "desc";

                        if(sortState && sortState.id == id.column)
                        {
                            dir = sortState.dir == "desc" ? "asc" : "desc";
                        }

                        this.markSorting(id.column, dir);

                        _this.RefreshData();

                        return false;
                    },
                    onBeforeFilter:function(id, value, config)
                    {
                        if(!_this.EnableLocalDataSource)
                            return false;

                        return true;
                    },
                    onAfterFilter:function()
                    {
                        if(_this.FilterEscPressed)
                        {
                            _this.FilterEscPressed = false;
                            return false;
                        }

                        if(ViewConfig && ViewConfig.on && ViewConfig.on.onAfterFilterCustomHandler)
                        {
                            ViewConfig.on.onAfterFilterCustomHandler();
                        }
                        else if(!_this.EnableLocalDataSource)
                            _this.RefreshData();
                    },
                    onBeforeSort:function(by, dir, as)
                    {
                        if(_this.EnableLocalSort)
                            return true;

                        _this.RefreshData();

                        return false;
                    },
                    onAfterSelect:function ()
                    {
                        _this.OnTableRowSelect();
                    },
                    onAfterUnSelect:function ()
                    {
                        _this.OnTableRowUnSelect();
                    },
                    onItemClick: function (Id, E, Node)
                    {
                        if(Id.column == "menu")
                        {
                            if(!_this.ViewController)
                                return;

                            if(!_this.Views.RowContextMenu)
                            {
                                _this.Views.RowContextMenu = new QoEAnyReportSelectorWidget(_this, {id:_this.Id + "AnyReportSelector", name: _this.Name});

                                _this.Views.RowContextMenu.Bind(_this.ViewController);
                            }


                            _this.Views.RowContextMenu.Show(this.getItemNode({column:"menu", row:Id.row}),"right");
                        }

                        else if(ViewConfig && ViewConfig.on && ViewConfig.on.onItemClick)
                        {
                            ViewConfig.on.onItemClick(Id, E, Node);
                        }
                    },
                    onCheck:function(Row, Column, State)
                    {
                        if(ViewConfig && ViewConfig.on && ViewConfig.on.onCheck)
                        {
                            ViewConfig.on.onCheck(Row, Column, State);
                        }
                    },
                    onAfterEditStop:function (State, Editor, IgnoreUpdate)
                    {
                        if(ViewConfig && ViewConfig.on && ViewConfig.on.onAfterEditStop)
                        {
                            ViewConfig.on.onAfterEditStop(State, Editor, IgnoreUpdate);
                        }
                    },
                    onKeyPress:function(code, e)
                    {
                        if(e && e.code && e.code === "Enter")
                        {
                            if(_this.Views.Table.getEditState())
                            {
                                _this.Views.Table.editStop();
                                return;
                            }
                        }

                        if(e && e.code && e.code === "Escape")
                        {
                            if(_this.Views.Table.getEditState())
                            {
                                _this.Views.Table.editCancel();
                                return;
                            }

                            let activeEl = document.activeElement;
                            for (let col of this.config.columns)
                            {
                                let filter = this.getFilter(col.id);
                                if (filter === activeEl)
                                {
                                    activeEl.blur();

                                    let firstRow = this.getFirstId();

                                    if (firstRow)
                                    {
                                        this.select(firstRow);
                                    }

                                    _this.FilterEscPressed = filter;

                                    return false;
                                }
                            }
                        }

                        if(e && e.code && ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown", "PageDown", "PageUp"].includes(e.code))
                        {
                            let activeEl = document.activeElement;
                            for (let col of this.config.columns)
                            {
                                let filter = this.getFilter(col.id);
                                if (filter === activeEl) {
                                    return;
                                }
                            }

                            let selectedRow = this.getSelectedId();
                            let firstRow = this.getFirstId();

                            if (!selectedRow && firstRow) {
                                this.select(firstRow);
                            }

                            let step = 100;
                            let state = this.getScrollState();

                            switch (e.code)
                            {
                                case "ArrowRight":
                                    state.x += step;
                                    this.scrollTo(state.x, state.y);
                                    break;
                                case "ArrowLeft":
                                    state.x -= step;
                                    this.scrollTo(state.x, state.y);
                                    break;
                                case "ArrowUp":
                                    this.moveSelection("up")
                                    break;
                                case "ArrowDown":
                                    this.moveSelection("down")
                                    break;
                                case "PageUp":
                                    this.moveSelection("pgup")
                                    break;
                                case "PageDown":
                                    this.moveSelection("pgdown")
                                    break;
                            }
                        }
                    }
                },
                rules:ViewConfig.rules ? ViewConfig.rules :{
                    "valid":function (value)
                    {
                        return value;
                    }
                }
            };

            // if(ViewConfig && ViewConfig.on && ViewConfig.on.onresize)
            // {
            //     datatable.on.onresize = webix.once(function()
            //     {
            //         this.adjustRowHeight("resource_raw", true);
            //     });
            // }

            if(typeof ViewConfig.fixedRowHeight !== "undefined")
                datatable.fixedRowHeight = ViewConfig.fixedRowHeight;

            if(typeof ViewConfig.rowLineHeight !== "undefined")
                datatable.rowLineHeight = ViewConfig.rowLineHeight;

            if(typeof ViewConfig.rowHeight !== "undefined")
                datatable.rowHeight = ViewConfig.rowHeight;

            if(typeof ViewConfig.minHeight !== "undefined")
                datatable.minHeight = ViewConfig.minHeight;

            rows.push(datatable);

            var tableToDefaultBtn = {
                view:"button",
                id:_this.Id + "TableToDefaultBtn",
                type:"icon",
                icon:"rotate-left",
                css:"toolbar_round_btn",
                width:38,
                tooltip:LangHelper.GetString("QoE", "Set table properties to default"),
                hidden: true,
                click: function()
                {
                    _this.SetTableToDefault();
                }
            };

            var reportSettingsBtn = {
                view:"button",
                id:_this.Id + "ReportSettingsBtn",
                type:"icon",
                icon:"gear",
                css:"toolbar_round_btn",
                width:38,
                tooltip:LangHelper.GetString("QoE", "Report Settings"),
                badge:0,
                hidden: true
            };

            var excelBtn = {
                view: "button",
                id:_this.Id+"ExcelExport",
                type: "icon",
                icon: "file-export",
                label:LangHelper.GetString("All","Export"),
                css: "toolbar_round_btn",
                width: 110,
                tooltip: LangHelper.GetString("QoE", "Export to excel, csv, pdf, png"),
                hidden:_this.HideExportWidget ? true : false
            };

            rows.push({
                view: "toolbar",
                id:_this.Id + "TablePaginatorToolbar",
                css:"webix_pager_paginator_toolbar",
                padding: 0,
                margin: 0,
                height:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? 40 : 32,
                hidden:_this.HidePaginatorToolbar ? true : false,
                elements: function ()
                {
                    var sizeInfo =
                        {
                            id:_this.Id + "SizeInfo",
                            css:"webix_pager_size_info",
                            view:"label",
                            label:"",
                            minWidth:170
                        };

                    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
                    {
                        delete sizeInfo.minWidth;
                        sizeInfo.width = 75
                    }

                    if(_this.DefaultPageSize < 0)
                        _this.DefaultPageSize = _this.DefaultPageSize * -1;

                    var rowsPerPage = {
                        view:"richselect",
                        id: _this.Id + "Size",
                        css:"webix_pager_page_size_selector",
                        icon:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? "sort-down" : "arrow-down",
                        tooltip:LangHelper.GetString("QoE", "Page size"),
                        value: _this.DefaultPageSize ? _this.DefaultPageSize : 100,
                        width:80,
                        options:{
                            fitMaster:false,
                            width:80,
                            data:[
                                {id:10, value:"10"},
                                {id:50, value:"50"},
                                {id:100, value:"100"},
                                {id:200, value:"200"},
                                {id:500, value:"500"},
                                {id:1000, value:"1 000"},
                                {id:10000, value:"10 000"}
                            ]
                        },
                        on: {
                            onChange:function(Value)
                            {
                                if(!_this.HidePaginatorToolbar)
                                {
                                    _this.SetStoredPageSize(Value);
                                    _this.RefreshData();
                                }
                            }
                        }
                    };

                    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
                    {
                        rowsPerPage.label = LangHelper.GetString("UlrModule", "Show");
                        rowsPerPage.labelAlign = "right";
                        rowsPerPage.labelWidth = 60;
                        rowsPerPage.width = 100;
                    }

                    var paginator = {
                        view: "pager",
                        id: _this.Id + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master:false,
                        gravity:4,
                        on: {
                            onAfterPageChange:function(Page)
                            {
                                if(!_this.HidePaginatorToolbar)
                                    _this.RefreshData(Page);
                            }
                        }
                    };

                    var els = [
                        sizeInfo,
                        {},
                        paginator,
                        {},
                        tableToDefaultBtn,
                        reportSettingsBtn,
                        excelBtn,
                        rowsPerPage
                    ];

                    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
                    {
                        els = [
                            {
                                width:20
                            },
                            sizeInfo,
                            {},
                            paginator,
                            rowsPerPage,
                            {
                                width:20
                            }
                        ];
                    }

                    return els;
                }()
            });

            if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
            {
                var excelBtn = {
                        view:"spectre_button",
                        id: _this.Id+"ExcelExport",
                        css:"form_button spec_action",
                        label:LangHelper.GetString("UlrModule","Export"),
                        tooltip: LangHelper.GetString("QoE", "Export to excel, csv, pdf, png"),
                        autowidth:true,
                        hidden:_this.HideExportWidget ? true : false
                    };

                rows.push({
                    hidden:_this.HideExportWidget ? true : false,
                    height: 71,
                    rows:[
                        {height:20},
                        {
                            cols:[
                                excelBtn,{}
                            ]
                        }
                    ]
                });
            }

            return rows;
        }()
    };

    this.FilterEscPressed = false;
};

QoETableReportWidget.prototype.Bind = function (ViewController, ViewModel)
{
    var _this = this;

    if(!ViewController || !(ViewController.ViewModel || ViewModel))
        return;

    this.ViewController = ViewController;

    this.ViewModel = ViewModel ? ViewModel : ViewController.ViewModel;

    this.Views.Table = $$(this.Id + "Table");

    this.Views.TablePaginatorToolbar = $$(this.Id + "TablePaginatorToolbar");
    this.Views.Paging = $$(this.Id + "Paging");
    this.Views.Size = $$(this.Id + "Size");
    this.Views.SizeInfo = $$(this.Id + "SizeInfo");

    this.Views.ExcelExport = $$(this.Id + "ExcelExport");

    if(this.Views.ExcelExport && this.HideExportWidget)
        this.Views.ExcelExport.hide();

    this.Views.TableToDefaultBtn = $$(this.Id + "TableToDefaultBtn");

    this.CacheMonitor = new QoEWidgetCacheMonitor(this, this.Views.Table, this.ViewModel);

    this.ExcelExportWidget = new QoEExcelExportWidget(this, this.Views.ExcelExport, this.Title);

    if(this.Views.RowContextMenu)
        this.Views.RowContextMenu.Bind(ViewController);

    this.ViewModel.RegisterReport({
        id:this.Id,
        config:this.Config
    });

    this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.Id).signal.subscribe(function (Updated)
    {
        _this.DataSignal(Updated);
    });

    if(_this.EnableTextSearch)
    {
        this.Views.TextSearch = $$(this.Id + "TextSearch");
        this.Views.TextSearch.attachEvent("onTimedKeyPress", function()
        {
            _this.RefreshData();
        });
    }

    this.Views.ReportSettingsBtn = $$(this.Id + "ReportSettingsBtn");

    if(this.ViewController && this.ViewController.ReportsSettings)
    {
        let model = this.ViewController.ReportsSettings.ViewModel.InitReportsSettingsModel(this, {
            show_settings_btn: this.Views.ReportSettingsBtn,
            can_update_widget: true
        });

        if(model)
        {
            this.ReportsSettingsManager = this.ViewController.ReportsSettings.ViewModel;
            if(this.Views.ReportSettingsBtn)
                this.Views.ReportSettingsBtn.show();
        }
    }

    if(this.ViewController && this.ViewController.Id && this.ViewController.Id === "QoEDashboard")
    {
        let storedPageSize = this.GetStoredPageSize();

        if(storedPageSize)
            this.Views.Size.setValue(storedPageSize)
    }

    if(this.IsQoE() && !this.IsDashboard() && !this.DisableSaveColumnsSize && this.Views.TableToDefaultBtn)
    {
        if(this.ViewConfig && this.ViewConfig.rows && this.ViewConfig.rows.length)
        {
            let find = this.ViewConfig.rows.find(conf => conf.view === "datatable" && conf.columns);

            if(find)
            {
                let key = this.GetStorageReportKey();
                this.DefaultTableConfigs[key] = QoETableStorageConfigModel(find);

                this.SetColumnsSizeFromStorage();
            }
        }

        this.Views.Table.attachEvent("onColumnResize", function(id, newWidth, oldWidth, userAction)
        {
            if(userAction && Object.keys(_this.DefaultTableConfigs).length)
            {
                _this.SetStoredTableConfig(_this.Views.Table.config, _this.Views.Table.getState().order);
                if (_this.Views.TableToDefaultBtn)
                    _this.Views.TableToDefaultBtn.show();
            }
        });

        this.Views.Table.attachEvent("onAfterColumnDrop", function(ourceId, targetId, event)
        {
            if(Object.keys(_this.DefaultTableConfigs).length)
            {
                _this.SetStoredTableConfig(_this.Views.Table.config, _this.Views.Table.getState().order);
                if (_this.Views.TableToDefaultBtn)
                    _this.Views.TableToDefaultBtn.show();
            }
        });
    }
};

QoETableReportWidget.prototype.GetDataSignal = function ()
{
    return this.ViewModel.GetReportConfig(this.Id).signal;
};

QoETableReportWidget.prototype.Destroy = function ()
{
    if(this.DataSignalSubscription)
        this.DataSignalSubscription.unsubscribe();

    if(this.ViewModel){
        this.ViewModel.UnRegisterReport(this.Id);
        this.ViewModel = null;
    }

    if(this.CacheMonitor)
        this.CacheMonitor.Destroy();

    if(this.ExcelExportWidget)
        this.ExcelExportWidget.Destroy();

    if(this.Views.RowContextMenu)
        this.Views.RowContextMenu.Destroy();

    this.ViewController = null;
    this.Views.Table = null;
};

QoETableReportWidget.prototype.DataSignal = function (Updated)
{
    if(!Updated)
        return;

    var config = this.ViewModel.GetReportConfig(this.Id);

    config.data = this.DataAdapter(config.data);

    if(this.LastSelectedConfig && this.LastSelectedConfig.remember_params === null) {
        if(config.data && config.data.cache_id) {
            var storageData = this.LastSelectedConfig.remember_data.rows;

            if(config.data.rows.length === 0) {
                var emptyRecord = {};
                this.Views.Table.eachColumn(columnId => {
                   emptyRecord[columnId] = 0;
                });

                emptyRecord[config.config.remember_field.alias] = this.LastSelectedConfig.remember_field;

                storageData.unshift(emptyRecord);
            }
            else {
                config.data.rows.forEach(row => {
                    storageData.unshift(row);
                });
            }

            var scroll = this.Views.Table.getScrollState();

            this.LastSelectedConfig.remember_data.rows = storageData;
            this.RefreshUIElements(this.LastSelectedConfig.remember_data);

            this.Views.Table.scrollTo(scroll.x, scroll.y);

            this.CacheMonitor.DataSignal(config.data, config.error);
            this.CacheMonitor.WidgetView.hideOverlay();

            this.LastSelectedConfig = null;
            this.Views.Table.unblockEvent();
            return;
        }
    }
    else {
        if(config.config.online && config.data && config.data.cache_id) {
            var scroll = this.Views.Table.getScrollState();
            this.RefreshUIElements(config.data);
            this.Views.Table.scrollTo(scroll.x, scroll.y);
            this.Views.Table.unblockEvent();
        }
        else if(!config.config.online) {
            this.RefreshUIElements(config.data);
        }
    }

    this.CacheMonitor.DataSignal(config.data, config.error);

    if(this.LastSelectedConfig && config.data && config.data.cache_id) {
        this.LastSelectedConfig.remember_params.filter[config.config.remember_field.alias] = this.LastSelectedConfig.remember_field;

        this.LastSelectedConfig.remember_data = webix.copy(config.data);
        this.LastSelectedConfig.remember_params = null;
        this.Views.Table.blockEvent();

        this.RefreshData(config.data.page, this.LastSelectedConfig.remember_params);
    }
};

QoETableReportWidget.prototype.RefreshUIElements = function (Config)
{
    if(Config.totals)
        this.Views.Table.data.totals = Config.totals;

    if(Config.count)
        this.Views.Table.data.rows_count = Config.count;

    const scrollState = this.Views.Table.getScrollState();

    this.Views.Table.clearAll();
    this.Views.Table.parse(Config.rows);

    this.Views.Table.scrollTo(scrollState.x, scrollState.y);
    this.Views.Size.setValue(Config.size);

    var countRows = parseInt(Config.count, 10);
    var pageNumber = parseInt(Config.page, 10);
    var sizePage = parseInt(Config.size, 10);

    var rowsFrom = countRows ? sizePage*pageNumber + 1 : 0;

    var rowsTo = sizePage*(pageNumber + 1);

    rowsTo = countRows < rowsTo ? countRows : rowsTo;

    var sizeInfoLabel = ""+rowsFrom+"-"+rowsTo+" "+LangHelper.GetString("QoE", "Of").toLowerCase()+" "+countRows;
    this.Views.SizeInfo.define("label", sizeInfoLabel);
    this.Views.SizeInfo.define("tooltip", sizeInfoLabel);

    this.Views.Paging.define({
        page:Config.page,
        size:Config.size,
        count:Config.count
    });

    this.Views.Paging.refresh();

    this.Views.SizeInfo.refresh();

    if(this.RowAutoHeight)
        this.Views.Table.adjustRowHeight(this.RowAutoHeight);

    this.SelectRememberedRow();
};

QoETableReportWidget.prototype.SelectRememberedRow = function ()
{
    var config = this.ViewModel.GetReportConfig(this.Id);

    if(this.LastSelectedConfig) {
        var tableData = this.Views.Table.serialize();

        var selectedRow = tableData.find(row => row[config.config.remember_field.alias] === this.LastSelectedConfig.remember_field);

        if(selectedRow) {
            this.Views.Table.select(selectedRow.id);
            this.LastSelectedConfig = null;
        }
    }
};

QoETableReportWidget.prototype.GetFilterSortState = function (Params)
{
    var _this = this;

    var config = this.ViewModel.GetReportConfig(this.Id);

    var state = this.Views.Table.getState();

    var sort = state.sort ? state.sort:(config.config.sort ? config.config.sort : null);

    var size = this.Views.Size.getValue();

    if(sort)
    {
        this.Views.Table.markSorting(sort.id, sort.dir);
    }

    if (!size)
    {
        const defaultPageSizeStorId = _this.Id + "Size" + "defaultPageSize";
        let storagePageSize = parseInt(localStorage.getItem(defaultPageSizeStorId));

        size = storagePageSize ? storagePageSize : (_this.DefaultPageSize ? _this.DefaultPageSize : 100);
    }

    var filter = {};

    if(Params&&Params.filter)
    {
        this.ExternalFilter = webix.copy(Params.filter);
    }

    webix.extend(filter, this.ExternalFilter, true);

    if(state.filter)
    {
        var colFilter = {};

        Object.keys(state.filter).forEach(function (Key)
        {
            var colExists = false;

            _this.Views.Table.config.columns.every(function (Col)
            {
                if(Col && Col.id == Key)
                {
                    colExists = true;

                    if(Col.filterMap && state.filter[Key])
                    {
                        state.filter[Key] = {
                            id: Col.filterMap.id ? Col.filterMap.id : Col.id,
                            operator: Col.filterMap.operator ? Col.filterMap.operator : "like",
                            value: Col.filterMap.value && typeof Col.filterMap.value == "function" ? Col.filterMap.value(state.filter[Key]) : state.filter[Key]
                        };
                    }
                    else
                    {
                        if(state.filter[Key] && typeof state.filter[Key] === 'object' && state.filter[Key].hasOwnProperty("start") && state.filter[Key].hasOwnProperty("end"))
                        {
                            if(Col.enableDateRangeFilter)
                            {
                                state.filter[Key] = Helper.Table.GetDateFilter(_this, Col.id)["period_"+Key];
                            }
                        }
                    }

                    return false;
                }

                return true;
            });

            if(colExists && state.filter[Key])
                colFilter[Key] = state.filter[Key];
        });

        webix.extend(filter, colFilter, true);
    }

    return {filter:filter, sort:sort, size:size};
};
///
QoETableReportWidget.prototype.RefreshData = function (Page, Params)
{
    var _this = this;

    var settingsModel = this.ReportsSettingsManager ? this.ReportsSettingsManager.GetSettingsModel(this.Id) : null;

    if(settingsModel)
        settingsModel.ReconfigReportQuery();

    var state = this.GetFilterSortState(Params);

    var sort = state.sort ? webix.extend({}, state.sort) : null;

    var filter = webix.extend({}, state.filter);

    var columns = this.Views.Table.config.columns;

    var page = Page !== null && Page >= 0 ? Page : (this.Views.Paging ? this.Views.Paging.config.page : 0);

    if(sort)
    {
        var finded = false;

        columns.forEach(function (Col) {
            if(Col.id == sort.id)
                finded = true;
        });

        if(!finded)
        {
            const hasCols = Boolean(
                settingsModel &&
                Array.isArray(settingsModel.cur_common_state.columns_to_show) &&
                settingsModel.cur_common_state.columns_to_show.length
            );

            sort.id = hasCols
                ? settingsModel.cur_common_state.columns_to_show[0]
                : this.Config.sort.id;

            this.Views.Table.markSorting(sort.id, sort.dir);
        }

        if(this.SortMap)
        {
            Object.keys(this.SortMap).forEach(function (Key)
            {
                if(sort.id == Key)
                    sort.id = _this.SortMap[Key];
            });
        }
    }

    if(this.Filter)
    {
        for(var i in this.Filter)
        {
            filter[i] = _this.Filter[i];
        }
    }
    
    if(_this.EnableTextSearch)
    {
        var fullTextSearch = this.Views.TextSearch.getValue();

        if(fullTextSearch)
            filter["full_text_search"] = {
                id:"full_text_search",
                operator:"like",
                value:fullTextSearch
            };
    }

    if(this.ShowProgressWhenDataLoading)
        this.Views.Table.showProgress({type:"icon"});

    var params = {
        page:page,
        filter:filter,
        sort:sort,
        size:state.size,
        report_settings: settingsModel ? settingsModel.GetReportSettings() : null,
        sphinx_search:this.SphinxSearch?this.SphinxSearch:null,
        max_execution_time:Params&&Params.max_execution_time?Params.max_execution_time:0
    };

    var selectedData = this.GetSelectedData();
    var report = this.GetReportConfig();
    if(selectedData && report.config.online && report.config.remember_field) {
        this.LastSelectedConfig = {};
        this.LastSelectedConfig.remember_field = selectedData[report.config.remember_field.alias];
        this.LastSelectedConfig.remember_params = params;
    }


    if(Params && Params.report_id)
    {
        this.ReportId = Params.report_id;
    }

    if(this.ReportId)
    {
        params.report_id = this.ReportId;
    }

    this.ViewModel.RefreshReportData(this.Id, params, _this.EnableLocalDataSource);
};
///
QoETableReportWidget.prototype.GetRefreshDataConfig = function (Page, Params)
{
    var _this = this;

    var state = this.GetFilterSortState(Params);

    var sort = state.sort ? webix.extend({}, state.sort) : null;

    var filter = webix.extend({}, state.filter);

    var columns = this.Views.Table.config.columns;

    var allColumns;

    this.ViewConfig.rows.forEach(item => {
        if(item.hasOwnProperty("view") && item.view == "datatable" || item.view == "custom_overlay_datatable"){
            allColumns = item.columns;
        }
    });

    if(sort)
    {
        var finded = false;

        columns.forEach(function (Col) {
            if(Col.id == sort.id)
                finded = true;
        });

        if(!finded)
        {
            sort.id = this.Config.sort.id;

            this.Views.Table.markSorting(sort.id, sort.dir);
        }

        if(this.SortMap)
        {
            Object.keys(this.SortMap).forEach(function (Key)
            {
                if(sort.id == Key)
                    sort.id = _this.SortMap[Key];
            });
        }
    }

    if(this.Filter)
    {
        for(var i in this.Filter)
        {
            filter[i] = _this.Filter[i];
        }
    }

    if(_this.EnableTextSearch)
    {
        var fullTextSearch = this.Views.TextSearch.getValue();

        if(fullTextSearch)
            filter["full_text_search"] = {
                id:"full_text_search",
                operator:"like",
                value:fullTextSearch
            };
    }

    if(this.ShowProgressWhenDataLoading)
        this.Views.Table.showProgress({type:"icon"});

    var params = {
        page:Page,
        columns_table_name: {allColumns, columns},
        filter:filter,
        sort:sort,
        size:state.size,
        sphinx_search:this.SphinxSearch?this.SphinxSearch:null,
        max_execution_time:Params&&Params.max_execution_time?Params.max_execution_time:0
    };

    var selectedData = this.GetSelectedData();
    var report = this.GetReportConfig();
    if(selectedData && report.config.online && report.config.remember_field) {
        this.LastSelectedConfig = {};
        this.LastSelectedConfig.remember_field = selectedData[report.config.remember_field.alias];
        this.LastSelectedConfig.remember_params = params;
    }

    return {
        id: this.Id,
        params: params,
        enableLocalDataSource: _this.EnableLocalDataSource
    };
};
///
QoETableReportWidget.prototype.GetSelectedData = function ()
{
    return this.Views.Table.getSelectedItem();
};

QoETableReportWidget.prototype.OnTableRowSelect = function ()
{
    var data = this.GetSelectedData();

    this.TableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoETableReportWidget.prototype.OnTableRowUnSelect = function ()
{
    var data = this.GetSelectedData();

    this.TableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoETableReportWidget.prototype.Reconfig = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.DataSignalSubscription.unsubscribe();
    this.ViewModel.UnRegisterReport(this.Id);

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.SortMap = ViewConfig.sort_map ? ViewConfig.sort_map : null;

    this.Filter = ViewConfig.filter ? ViewConfig.filter : null;

    //this.FilterMap = ViewConfig.filter_map ? ViewConfig.filter_map : null;

    this.ViewModel.RegisterReport({
        id:this.Id,
        config:this.Config
    });

    var c = ViewConfig.columns ? ViewConfig.columns : [];

    if(_this.EnableRowContextMenu && c && c.length)
    {
        c = [
            {
                id:"menu",
                header:"",
                sort:false,
                width:16,
                tooltip:LangHelper.GetString("QoE", "Menu"),
                template:CellMenuBtnTemplate
            }
        ].concat(c);
    }

    this.DefaultTableColsOrder = c.map(a => a.id);

    this.PrepareColumnsFormat(c);


    this.Views.Table.config.columns = c;
    this.Views.Table.config.leftSplit = ViewConfig.leftSplit ? ViewConfig.leftSplit + (_this.EnableRowContextMenu ? 1 : 0 ) : 0;

    let key = this.GetStorageReportKey();
    let tableConfig = QoETableStorageConfigModel(ViewConfig);

    tableConfig.columns.forEach(col => col.width = "");

    this.DefaultTableConfigs[key] = tableConfig;
    this.SetColumnsSizeFromStorage(false);

    this.Views.Table.clearSelection();
    this.Views.Table.refreshColumns();

    this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.Id).signal.subscribe(function (Updated)
    {
        _this.DataSignal(Updated);
    });
};

QoETableReportWidget.prototype.GetExportTitle = function ()
{
    if(this.GetExportTitleCallback)
        return this.GetExportTitleCallback();

    return this.Title;
};

QoETableReportWidget.prototype.GetExportPdfConfig = function (Config)
{
    let _this = this;

    this.PdfExportConfig = Config.export_pdf_config ? Config.export_pdf_config : {};

    this.PdfExportConfig.view_type = this.PdfExportConfig.view_type ? _this.PdfExportConfig.view_type : "table";
    this.PdfExportConfig.name = this.PdfExportConfig.name ? this.PdfExportConfig.name : Config.name;
    this.PdfExportConfig.format_units = typeof AppEnv !== "undefined" && AppEnv.QoEUnitsFormatter ? 1 : 0;
    this.PdfExportConfig.locales = this.PdfExportConfig.locales ? _this.PdfExportConfig.locales : {};


    if (!this.PdfExportConfig.columns_headers && Config.columns)
    {
        this.PdfExportConfig.columns_headers = [];

        for (let Col of Config.columns)
        {
            if (NotProcessedColumnsIds.includes(Col.id))
                continue;

            let curLang = LangHelper.GetLocale();
            let header_name =  (Col.header && typeof Col.header[0] === "string") ? Col.header[0] : "";

            let columnHeader = {};

            columnHeader.id = Col.id
            columnHeader.header_name = {[curLang]: Helper.ParseTooltipTemplate(header_name)};

            if(Col.units_format_data) {
                columnHeader.units_format_data = Col.units_format_data;
            }

            if (this.PdfExportConfig.sparkline_columns) {
                columnHeader.is_sparkline = this.PdfExportConfig.sparkline_columns.includes(columnHeader.id);
            }

            if (this.PdfExportConfig.percent_columns) {
                columnHeader.is_percent = this.PdfExportConfig.percent_columns.includes(columnHeader.id);
            }

            if (Config.config) {
                if (Config.config.rows && Config.config.rows.includes(columnHeader.id)) {
                    this.PdfExportConfig.columns_headers.push(columnHeader);
                    continue;
                }
                if (Config.config.values) {
                    Config.config.values.forEach(function (value) {
                        if (value.col && value.alias && (value.col === columnHeader.id)) {
                            columnHeader.id = value.alias;
                        }
                    })
                }
            }

            this.PdfExportConfig.columns_headers.push(columnHeader);
        }
    }
};

QoETableReportWidget.prototype.RefreshPdfExportConfig = function (Params)
{
    this.PdfExportConfig = webix.extend(this.PdfExportConfig, Params, true);

    let reportConfig = this.ViewModel ? this.ViewModel.GetReportConfig(this.Id) : this.Config;

    if(!Params || !Params.columns_to_show || !Params.columns_to_show.length)
    {
        let idx = 0;

        this.PdfExportConfig.columns_to_show.forEach(ColId => {
            if(reportConfig && reportConfig.config && reportConfig.config.values)
            {
                let find = reportConfig.config.values.find(item => item.col === ColId);

                if(find && find.alias)
                    this.PdfExportConfig.columns_to_show[idx] = find.alias;

                idx++;
            }
        });
    }

    this.SetColumnsSizeFromStorage();
};

QoETableReportWidget.prototype.DefineExportPdfConfig = function(Params)
{
    this.RefreshPdfExportConfig(Params);
    this.AddAllColumnLocales();
};

QoETableReportWidget.prototype.GetTableHeaders = function()
{
    let _this = this;

    let result = [];

    if(this.Views.Table)
    {
        this.Views.Table.eachColumn(function (colId) {
            if (NotProcessedColumnsIds.includes(colId))
                return;

            let colConfig = _this.Views.Table.getColumnConfig(colId)

            if(colConfig)
            {
                let header = colConfig.header && Array.isArray(colConfig.header) && colConfig.header[0] ? colConfig.header[0] : null;
                let headerValue = header && header.text ? header.text : header;

                if(headerValue)
                {
                    result.push({
                        id: colId,
                        value: Helper.ParseTooltipTemplate(headerValue)
                    });
                }
            }
        }, true);
    }
    else
    {
        result = webix.copy(this.PdfExportConfig.columns_headers);
    }

    return result;
};

QoETableReportWidget.prototype.AddAllColumnLocales = function ()
{
    let unitsDic = {};

    let langCode = LangHelper.GetLocale();
    let reverseDic = LangHelper.GetReverseLangDic(langCode);

    this.PdfExportConfig.columns_headers.forEach((columnHeader) => {
        let existsLocales = Object.keys(columnHeader.header_name);
        let header_name = columnHeader.header_name[langCode];
        let langKeys = LangHelper.SearchLangKeys(header_name, reverseDic);

        for(let code in LocalesEnum)
        {
            if(!existsLocales.includes(code))
            {
                columnHeader.header_name[code] = LangHelper.GetStringByLangKeys(code, langKeys);
            }
        }

        if(columnHeader.units_format_data)
        {
            unitsDic[columnHeader.units_format_data.id] = columnHeader.units_format_data.units;
        }
    })

    for(let unitDicKey in unitsDic)
    {
        let curUnitsArr = unitsDic[unitDicKey][langCode];
        let unitsLangKeys = [];

        curUnitsArr.forEach((unitName) => {
            unitsLangKeys.push(LangHelper.SearchLangKeys(unitName, reverseDic));
        })

        for(let code in LocalesEnum)
        {
            if(code !== langCode)
            {
                unitsDic[unitDicKey][code] = []
                unitsLangKeys.forEach((unitKey) => {
                    unitsDic[unitDicKey][code].push(LangHelper.GetStringByLangKeys(code, unitKey));
                });
            }
        }
    }

    this.PdfExportConfig.columns_headers.forEach((columnHeader) => {
        if(columnHeader.units_format_data)
        {
            let unitsDataId = columnHeader.units_format_data.id;
            columnHeader.units_format_data.units = unitsDic[unitsDataId];
        }
    });
};

QoETableReportWidget.prototype.GetReportConfig = function ()
{
    return this.ViewModel.GetReportConfig(this.Id);
};

QoETableReportWidget.prototype.SetReportConfig = function (ReportConfig)
{
    return this.ViewModel.RegisterReport(ReportConfig);
};

QoETableReportWidget.prototype.GetCachesIds = function ()
{
    return this.CacheMonitor && this.CacheMonitor.LastCacheId ? [this.CacheMonitor.LastCacheId] : null;
};

QoETableReportWidget.prototype.IfRowContextMenuApplicable = function()
{
    if(!this.ViewController || !this.ViewController.GetFilterStateConfig || !this.ViewController.GetPeriodState)
    {
        return false;
    }

    return true;
};

QoETableReportWidget.prototype.GetFilterStateConfig = function()
{
    if(this.ViewController)
    {
        return this.ViewController.GetFilterStateConfig();
    }

    return null;
};

QoETableReportWidget.prototype.GetPeriodState = function()
{
    if(this.ViewController)
    {
        return this.ViewController.GetPeriodState();
    }

    return null;
};

QoETableReportWidget.prototype.SetSphinxSearch = function(SphinxSearchModel)
{
    this.SphinxSearch = SphinxSearchModel;
};

QoETableReportWidget.prototype.PrepareColumnsFormat = function(Cols)
{
    if (typeof AppEnv !== "undefined" && AppEnv.QoEUnitsFormatter)
    {
        c = Cols;

        let langCode = LangHelper.GetLocale();

        c.forEach(col => {
            if (col && col.units_format_data) {
                if (typeof col.header === "object" && 0 in col.header && typeof col.header[0] === 'string')
                {
                    let header = Helper.ParseTooltipTemplate(col.header[0]);
                    header = header.split(",")[0];
                    col.header[0] = TooltipTemplate(header);
                }

                col.format = function(val)
                {
                    let value = Helper.UnitPrefixToNumeric(
                        val,
                        col.units_format_data.divider,
                        col.units_format_data.units[langCode],
                    );
                    return value == 0 ? value + " " + col.units_format_data.units[langCode][0] : value;
                }
            }
        });
    }
}

QoETableReportWidget.prototype.HideColumns = function(Cols)
{
    if(Array.isArray(Cols))
    {
        Cols.forEach(col => {
            this.Views.Table.hideColumn(col);
        });
    }
};

QoETableReportWidget.prototype.RefreshUIByReportSettings = function(SettingsModel)
{
    let _this = this;

    let settingsModel;

    if(this.ReportsSettingsManager && this.ReportsSettingsManager.ReportsSettings[this.Id])
    {
        settingsModel = this.ReportsSettingsManager.ReportsSettings[this.Id];
    }

    settingsModel = SettingsModel ? SettingsModel : settingsModel;

    if(settingsModel && settingsModel.cur_common_state)
    {
        if(settingsModel.cur_common_state.columns_to_show)
        {
            this.Views.Table.eachColumn(function (colId) {

                if (NotProcessedColumnsIds.includes(colId)) {
                    return;
                } else if ((settingsModel.cur_common_state.columns_to_show).includes(colId)) {
                    _this.Views.Table.showColumn(colId);
                } else {
                    _this.Views.Table.hideColumn(colId);
                }
            }, true);
        }
    }
};

QoETableReportWidget.prototype.IsQoE = function()
{
    return typeof this.Id === "string" &&  (this.Id.indexOf("QoE") < 0 || this.Id.indexOf("NotQoE") >= 0) ? false: true;
}

QoETableReportWidget.prototype.IsDashboard = function()
{
    if(this.ViewController && this.ViewController.Id && this.ViewController.Id === "QoEDashboard")
        return true;
    return false;
}

QoETableReportWidget.prototype.GetStoredPageSize = function()
{
    let value = null;

    let oldPostfix = "SizedefaultPageSize";
    let newPostfix = "StoredTablePageSize";

    let isDashboard = this.Name && this.ViewController && this.ViewController.Id && this.ViewController.Id === "QoEDashboard" ? true : false;

    let key = this.Id + newPostfix;

    if(isDashboard)
    {
        let dashboardId = this.ViewController.GetSelectedDashboardId();

        if(dashboardId)
            key = "Dashboard" + dashboardId + this.Name + newPostfix;
    }

    let storedData = App.SessionManager.GetPreference(key, false)

    if(isNaN(parseInt(storedData)) && !isDashboard)
        storedData = localStorage.getItem(this.Id + oldPostfix);

    if(!isNaN(parseInt(storedData)))
        value = parseInt(storedData);

    if(value && value < 0)
        value = value * -1;

    return value;
};

QoETableReportWidget.prototype.SetStoredPageSize = function(Value)
{
    let value = Value;
    let postfix = "StoredTablePageSize";

    let key = this.Id + postfix;

    if(this.Name && this.ViewController && this.ViewController.Id && this.ViewController.Id === "QoEDashboard")
    {
        let dashboardId = this.ViewController.GetSelectedDashboardId();

        if(dashboardId)
            key = "Dashboard" + dashboardId + this.Name + postfix;
    }

    if(!isNaN(parseInt(value)))
    {
        App.SessionManager.SetPreference(key, value, false)
    }
};

QoETableReportWidget.prototype.SetTableToDefault = function()
{
    let key = this.GetStorageReportKey();

    this.SetColumnsSize(this.DefaultTableConfigs[key], this.DefaultTableColsOrder);
    App.SessionManager.RemovePreference(key + "StoredTableConfig");
    if (this.Views.TableToDefaultBtn)
        this.Views.TableToDefaultBtn.hide();
};

QoETableReportWidget.prototype.SetColumnsSizeFromStorage = function(Refresh = true)
{
    let showBtn = true;
    let [config, col_order] = this.GetStoredTableConfig();

    if(config.columns.length === 0)
    {
        let key = this.GetStorageReportKey();
        config = this.DefaultTableConfigs[key];
        showBtn = false
        col_order = this.DefaultTableColsOrder;
    }

    this.SetColumnsSize(config, col_order,  Refresh);

    if(showBtn && this.Views.TableToDefaultBtn)
        this.Views.TableToDefaultBtn.show();
    else if (this.Views.TableToDefaultBtn)
        this.Views.TableToDefaultBtn.hide();
};

QoETableReportWidget.prototype.SetColumnsSize = function(Config =  null, ColOrder = [], Refresh = true)
{
    if(Config && Config.columns && Config.columns.length)
    {
        this.Views.Table.config.columns.forEach(col => {
            let findCol = Config.columns.find(config => config.id === col.id);

            if(findCol)
            {
                col.width = findCol.width ? findCol.width : "";
                col.fillspace = findCol.fillspace ? findCol.fillspace : false;
            }
        });

        if(ColOrder && ColOrder.length)
        {
            var cols_ordered = [];
            var cols_unordered = [];
            var all_colls = this.Views.Table.config.columns

            ColOrder.forEach(k => {

                // because find dosent work correct
                // let found = all_colls.find(obj => obj.id === k)

                var found = false;

                all_colls.forEach(obj => {

                    if(found)
                        return;

                    found = obj.id === k ? obj : false;
                })

                if (found)
                {
                    cols_ordered.push(found);
                }

            });

            all_colls.forEach(obj =>
            {
                // because find dosent work correct
                // let found = ColOrder.find(k => obj.id === k)

                var found = false;

                ColOrder.forEach(k => {

                    if(found)
                        return;

                    found = obj.id === k ? obj : false;
                })

                if (!found)
                {
                    cols_unordered.push(obj);
                }

            });

            this.Views.Table.config.columns = cols_unordered.concat(cols_ordered)

            this.Views.Table.config.columns = this.Views.Table.config.columns.filter(item => typeof item !== 'undefined')
        }

        if(Refresh)
            this.Views.Table.refreshColumns();
    }
};

QoETableReportWidget.prototype.GetStorageReportKey = function()
{
    let key = this.GetReportConfigKey ? this.GetReportConfigKey() : "";
    key = key ? key : this.ViewController && this.ViewController.Id ? this.ViewController.Id : "";
    key += this.Id;
    return key;
};

QoETableReportWidget.prototype.GetStoredTableConfig = function()
{
    let key = this.GetStorageReportKey() + "StoredTableConfig"
    let col_order_key = this.GetStorageReportKey() + "StoredTableColOrder"
    let config = App.SessionManager.GetPreference(key, true);
    let col_order = App.SessionManager.GetPreference(col_order_key, true);

    return [QoETableStorageConfigModel(config), col_order];
};

QoETableReportWidget.prototype.SetStoredTableConfig = function(Config = null, ColumnsOrder = null)
{
    let key = this.GetStorageReportKey() + "StoredTableConfig"
    let col_order_key = this.GetStorageReportKey() + "StoredTableColOrder"
    let config = QoETableStorageConfigModel(Config);

    if(key.includes("QoEAnyReport"))
        return;

    App.SessionManager.SetPreference(key, config, true)
    App.SessionManager.SetPreference(col_order_key, ColumnsOrder, true)
};


function QoEMapLayerWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.Layer = null;

    this.ExternalFilter = {};

    this.CacheMonitor = null;

    this.Title = "";

    this.DataPrepare = null;

    this.ParentReportData = null;
    this.ReportData = null;
    this.ParseFilterFromParentReport = null;

    this.GetFeatureStyle = null;

    this.DataAdapter = function (Data)
    {
        return Data;
    };

    this.OnLayerUpdated = new Rx.BehaviorSubject(0);

    this.MapViewArea = {
        minLat: null,
        maxLat: null,
        minLon: null,
        maxLon: null
    };

    this.ViewController = null;

    this.Init(ViewConfig);
}

QoEMapLayerWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Name = ViewConfig.name ? ViewConfig.name : null;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.Title = ViewConfig.title ? ViewConfig.title : "";

    this.GetExportTitleCallback = ViewConfig.export_title_callback ? ViewConfig.export_title_callback : null;

    this.SortMap = ViewConfig.sort_map ? ViewConfig.sort_map : {};

    this.Filter = ViewConfig.filter ? ViewConfig.filter : null;

    this.RowAutoHeight = ViewConfig.rowAutoHeight ? ViewConfig.rowAutoHeight : null;
    this.LayerConfig = ViewConfig.layer_config ? ViewConfig.layer_config : {};
    this.GetDataByParentReport = ViewConfig.dataByParentReport ? ViewConfig.dataByParentReport : false;
    this.ParseFilterFromParentReport = ViewConfig.parseFilterFromParentReport && typeof ViewConfig.parseFilterFromParentReport == "function" ? ViewConfig.parseFilterFromParentReport : function(Data){return {};};

    this.DataPrepare = ViewConfig.data_prepare && typeof ViewConfig.data_prepare == "function" ? ViewConfig.data_prepare : function(Data){return Data;};
    this.GetFeatureStyle = ViewConfig.get_feature_style && typeof ViewConfig.get_feature_style == "function" ? ViewConfig.get_feature_style : function(Data){return Data;};

    this.Layer = new ol.layer[this.LayerConfig.type]({
        source: new ol.source[_this.LayerConfig.type]({}),
        style: new ol.style.Style({})
    });

    this.ViewConfig = null;
};

QoEMapLayerWidget.prototype.Bind = function (ViewController, ViewModel)
{
    var _this = this;

    if(!ViewController || !(ViewController.ViewModel || ViewModel))
        return;

    this.ViewController = ViewController;

    this.ViewModel = ViewModel ? ViewModel : ViewController.ViewModel;

    this.CacheMonitor = new QoEWidgetCacheMonitor(this, this.Layer, this.ViewModel);

    this.ViewModel.RegisterReport({
        id:this.Id,
        config:this.Config
    });

    this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.Id).signal.subscribe(function (Updated)
    {
        _this.DataSignal(Updated);
    });
};

QoEMapLayerWidget.prototype.Destroy = function ()
{
    this.DataSignalSubscription.unsubscribe();
    this.ViewModel.UnRegisterReport(this.Id);
    this.ViewModel = null;
    // this.CacheMonitor.Destroy();

    this.ViewController = null;
};

QoEMapLayerWidget.prototype.DataSignal = function (Updated)
{
    if(!Updated)
        return;

    var _this = this;

    this.UpdateData(this.ViewModel.GetReportConfig(this.Id).data);
};

QoEMapLayerWidget.prototype.UpdateDataByParent = function(Data)
{
    if(!Data)
    {
        return;
    }
    var _this = this;

    this.ParentReportData = Data;

    if(this.GetDataByParentReport)
    {
        _this.RefreshDataByParentReport(Data);
    }
    else
    {
        this.UpdateData(Data);
    }
};

QoEMapLayerWidget.prototype.UpdateData = function(Data)
{
    if(!Data)
    {
      return;
    }

    var _this = this;

    var data = this.DataPrepare(Data);

    Object.keys(this.MapViewArea).forEach(function(Key){
        if(data[Key] !== null)
        {
            _this.MapViewArea[Key] = data[Key];
        }
    });

    this.Layer.set('name', this.Name);
    this.Layer.setSource(new ol.source[_this.LayerConfig.type]({
        features: data.data
    }));

    this.OnLayerUpdated.next(this.Layer);
};

QoEMapLayerWidget.prototype.ShowHideFeature = function(Item, State)
{
    var _this = this;

    var transform = this.LayerConfig.item_config.data_transform;
    if(!transform && this.LayerConfig.item_config.get_feature_by_id)
    {
        transform = this.LayerConfig.item_config[this.LayerConfig.item_config.get_feature_by_id];
    }

    var feature = this.Layer.getSource().getFeatureById(Item[transform.id.value]);

    if(State)
    {
        feature.setStyle(this.GetFeatureStyle(feature));
    }
    else{
        feature.setStyle(new ol.style.Style({}));
    }
};

QoEMapLayerWidget.prototype.GetStyle = function(Data)
{
  var _this = this;

  var result = {};

  if(Data && Data.params)
  {
      Object.keys(Data.params).forEach(function(Key)
      {
          if(typeof Data.params[Key] !== "object")
          {
              result[Key] = Data.params[Key];
          }
          else{
              result[Key] = _this.GetStyle(Data.params[Key]);
          }
      });
  }

  return Data && Data.type ? new ol.style[Data.type](result) : result;
};

QoEMapLayerWidget.prototype.GetFilterSortState = function (Params)
{
    return {filter:{}, sort:{}, size:10000};
};

QoEMapLayerWidget.prototype.RefreshDataByParentReport = function(Params)
{
    var config = this.ViewModel.GetReportConfig(this.Id);

    var sort = config.config.sort ? config.config.sort : null;

    var size = config.config.size ? config.config.size : 0;

    var filter = {};

    webix.extend(filter, this.ExternalFilter, true);

    if(Params&&Params.filter)
    {
        webix.extend(filter, Params.filter, true);
    }

    webix.extend(filter, this.ParseFilterFromParentReport(this.ParentReportData), true);

    this.ViewModel.RefreshReportData(this.Id, {
        filter:filter,
        sort:sort,
        size:size
    });
};

QoEMapLayerWidget.prototype.RefreshData = function (Page, Params)
{
    var _this = this;

    var state = this.GetFilterSortState(Params);

    var sort = state.sort ? webix.extend({}, state.sort) : null;

    var filter = webix.extend({}, state.filter);


    if(sort)
    {
        var finded = false;

        if(!finded)
        {
            sort.id = this.Config.sort.id;
            sort.dir = this.Config.sort.dir;
        }

        if(this.SortMap)
        {
            Object.keys(this.SortMap).forEach(function (Key)
            {
                if(sort.id == Key)
                    sort.id = _this.SortMap[Key];
            });
        }
    }

    if(this.Filter)
    {
        for(var i in this.Filter)
        {
            filter[i] = _this.Filter[i];
        }
    }

    this.ViewModel.RefreshReportData(this.Id,
        {
            page:Page,
            filter:filter,
            sort:sort,
            size:state.size,
            sphinx_search:this.SphinxSearch ? this.SphinxSearch : null
        },_this.EnableLocalDataSource);
};

QoEMapLayerWidget.prototype.Reconfig = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.DataSignalSubscription.unsubscribe();
    this.ViewModel.UnRegisterReport(this.Id);

    this.ViewModel.RegisterReport({
        id:this.Id,
        config:this.Config
    });

    this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.Id).signal.subscribe(function (Updated)
    {
        _this.DataSignal(Updated);
    });
};

QoEMapLayerWidget.prototype.GetExportTitle = function ()
{
    if(this.GetExportTitleCallback)
        return this.GetExportTitleCallback();

    return this.Title;
};

QoEMapLayerWidget.prototype.GetReportConfig = function ()
{
    return this.ViewModel.GetReportConfig(this.Id);
};

QoEMapLayerWidget.prototype.GetCachesIds = function ()
{
    return this.CacheMonitor && this.CacheMonitor.LastCacheId ? [this.CacheMonitor.LastCacheId] : null;
};

QoEMapLayerWidget.prototype.IfRowContextMenuApplicable = function()
{
    if(!this.ViewController || !this.ViewController.GetFilterStateConfig || !this.ViewController.GetPeriodState)
    {
        return false;
    }

    return true;
};

QoEMapLayerWidget.prototype.GetFilterStateConfig = function()
{
    if(this.ViewController)
    {
        return this.ViewController.GetFilterStateConfig();
    }

    return null;
};

QoEMapLayerWidget.prototype.GetPeriodState = function()
{
    if(this.ViewController)
    {
        return this.ViewController.GetPeriodState();
    }

    return null;
};

QoEMapLayerWidget.prototype.SetSphinxSearch = function(SphinxSearchModel)
{
    this.SphinxSearch = SphinxSearchModel;
};
function QoEPointsLayerWidget(ViewConfig)
{
    var _this = this;

    var params = webix.extend(ViewConfig,{
        data_prepare: function(Data){
            var result = {
                minLat: null,
                maxLat: null,
                minLon: null,
                maxLon: null,
                data: []
            };

            var transform = _this.LayerConfig.item_config.point_data_transform;
            var colors = Helper.DictToArr(ColorsDic);
            if(Data && Data.rows && Array.isArray(Data.rows))
            {
                Data.rows.forEach(function(Val){

                    var lon = Val[transform.lon.value];
                    // var lon = Val[transform.lon.value] + Helper.RandInt(-15, 15);
                    var lat = Val[transform.lat.value];
                    // var lat = Val[transform.lat.value] + Helper.RandInt(-10, 10);
                    var item = {
                        geometry: new ol.geom.Point(ol.proj.fromLonLat([lon,lat])),
                        lon: lon,
                        lat: lat,
                        name: null,
                        description: null,
                        id: Val[transform.id.value],
                        info: "",
                        color: Val && Val.color ? Val.color : colors[Val.index].value
                    };

                    if(transform.name && transform.name.value)
                    {
                        item.name = Val[transform.name.value];
                    }

                    if(transform.description && transform.description.value)
                    {
                        item.description = Val[transform.description.value];
                    }
                    transform.data.forEach(function(D){
                        let _val = Val[D.value] ? Val[D.value] : ""
                        item.info += D.title + ": " + _val + "<br/>";
                    });

                    var feature = new ol.Feature(item);

                    feature.setId(Val[transform.id.value]);

                    feature.setStyle(_this.GetFeatureStyle);

                    result.data.push(feature);

                    if(lon > result.maxLon || !result.maxLon)
                    {
                        result.maxLon = lon;
                    }
                    if(lon < result.minLon || !result.minLon)
                    {
                        result.minLon = lon;
                    }

                    if(lat > result.maxLat || !result.maxLat)
                    {
                        result.maxLat = lat;
                    }
                    if(lat < result.minLat || !result.minLat)
                    {
                        result.minLat = lat;
                    }
                });
            }

            return result;
        },
        get_feature_style: function(Feature){
            var color = Feature.get('color');

            var styles = [_this.GetStyle(Helper.ChangePropertiesInObject(_this.LayerConfig.default_style.point, {color: color}))];

            // var geometry = Feature.getGeometry();
            //
            // geometry.forEachSegment(function(start, end){
            //     var dx = end[0] - start[0];
            //     var dy = end[1] - start[1];
            //     var rotation = Math.atan2(dy, dx);
            //     // arrows
            //     var st = _this.GetStyle(Helper.ChangePropertiesInObject(_this.LayerConfig.default_style.point, {color: color.value}));
            //
            //     st.setGeometry(new ol.geom.Point(end));
            //     styles.push(st);
            // });
            return styles;
        }
    },true);

    QoEPointsLayerWidget.superclass.constructor.call(this, params);
};

Helper.ExtendClass(QoEPointsLayerWidget,QoEMapLayerWidget);
function QoEStrokesLayerWidget(ViewConfig)
{
    var _this = this;

    var params = webix.extend(ViewConfig,{
        data_prepare: function(Data){
            var result = {
                minLat: null,
                maxLat: null,
                minLon: null,
                maxLon: null,
                data: []
            };

            var subscribers = _this.ParentReportData && _this.ParentReportData.rows ? _this.ParentReportData.rows : [];
            var points = Data && Data.rows ? Data.rows : [];
            var line_transform = _this.LayerConfig.item_config.line_data_transform;
            var point_transform = _this.LayerConfig.item_config.point_data_transform;

            var colors = Helper.DictToArr(ColorsDic);
            subscribers.forEach(function(Sub){
                var lineParams = {
                    id: Sub[line_transform.id.value],
                    color: Sub && Sub.color ? Sub.color : colors[Sub.index].value,
                    info: "",
                    items: [],
                    points: []
                };

                line_transform.data.forEach(function(D){
                    lineParams.info += D.title + ": " + Sub[D.value] + "<br/>";
                });

                var sub_points = points.filter(function(Point){return Point.sub_id == lineParams.id});

                sub_points.forEach(function(P){
                    var lon = P[point_transform.lon.value];
                    // var lon = Val[transform.lon.value] + Helper.RandInt(-15, 15);
                    var lat = P[point_transform.lat.value];
                    lineParams.points.push(ol.proj.transform([lon, lat],'EPSG:4326', 'EPSG:3857'));
                    var item = {
                        geometry: new ol.geom.Point(ol.proj.fromLonLat([lon,lat])),
                        lon: lon,
                        lat: lat,
                        id: P[point_transform.id.value],
                        info: lineParams.info
                    };
                    point_transform.data.forEach(function(D){
                        item.info += D.title + ": " + P[D.value] + "<br/>";
                    });

                    var feature = new ol.Feature(item);

                    feature.setId(P[point_transform.id.value]);
                    lineParams.items.push(feature);

                    if(lon > result.maxLon || !result.maxLon)
                    {
                        result.maxLon = lon;
                    }
                    if(lon < result.minLon || !result.minLon)
                    {
                        result.minLon = lon;
                    }

                    if(lat > result.maxLat || !result.maxLat)
                    {
                        result.maxLat = lat;
                    }
                    if(lat < result.minLat || !result.minLat)
                    {
                        result.minLat = lat;
                    }
                });

                var line = new ol.Feature({
                    id: lineParams.id,
                    color: lineParams.color,
                    info: lineParams.info,
                    geometry: new ol.geom.LineString(lineParams.points),
                    items: lineParams.items,
                    points: lineParams.points
                });
                line.setStyle(_this.GetFeatureStyle);
                line.setId(lineParams.id);
                result.data.push(line);

            });

            return result;
        },
        get_feature_style: function(Feature){
            var color = Feature.get('color');

            var styles = [_this.GetStyle(Helper.ChangePropertiesInObject(_this.LayerConfig.default_style.line, {color: color}))];

            var geometry = Feature.getGeometry();
            var i = 0;
            var line_start = [];
            var line_end = [];
            geometry.forEachSegment(function(start, end){
                if(i == 0)
                {
                    line_start = start;
                    i++;
                }
                line_end = end;
                var dx = end[0] - start[0];
                var dy = end[1] - start[1];
                var rotation = Math.atan2(dy, dx);

                var cfg = _this.LayerConfig.default_style.direction;
                var text_cfg = {
                    text: cfg.text,
                    font: '900 20px "Font Awesome 5 Pro"',
                    // textBaseline: 'bottom',
                    anchor: cfg.anchor,
                    fill: new ol.style.Fill({
                        color: color
                    })
                };

                if(cfg.use_rotation)
                {
                    text_cfg.rotateWithView = true;
                    text_cfg.rotation = -rotation;
                }

                styles.push(new ol.style.Style({
                    geometry: new ol.geom.Point(end),
                    text: new ol.style.Text(text_cfg)
                }));
            });
            if(line_start && line_start.length)
            {
                var s = _this.GetStyle(Helper.ChangePropertiesInObject(_this.LayerConfig.default_style.end_points, {color: color}));
                s.setGeometry(new ol.geom.Point(line_start));
                styles.push(s);
            }

            if(line_end && line_end.length)
            {
                var end = _this.GetStyle(Helper.ChangePropertiesInObject(_this.LayerConfig.default_style.end_points, {color: color}));
                end.setGeometry(new ol.geom.Point(line_end));
                styles.push(end);
            }

            return styles;
        }
    },true);

    QoEStrokesLayerWidget.superclass.constructor.call(this, params);
};

Helper.ExtendClass(QoEStrokesLayerWidget,QoEMapLayerWidget);
function QoEMapsReportWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.Map = null;

    this.ItemType = null;

    this.ItemStyle = null;

    this.ItemDataConfig = null;

    this.Views = {
        Map: null
    };

    this.MapViews = {
        Map1: null,
        Tooltip: null,
        Popup: null,
        PopupCloser: null,
        PopupContent: null
    };

    this.Overlays = {
        Tooltip : null,
        Popup: null
    };

    this.LayersConfig = {};
    this.Layers = {};

    this.NoRefresh = false;

    this.Subscriptions = {};

    this.ExternalFilter = {};

    this.CacheMonitor = null;

    this.Title = "";

    this.MapViewArea = {
        minLat: null,
        maxLat: null,
        minLon: null,
        maxLon: null
    };

    this.DataAdapter = function (Data)
    {
        return Data;
    };

    this.ViewController = null;

    this.Init(ViewConfig);
}

QoEMapsReportWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    //ViewConfig.enableRowContextMenu = true;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Name = ViewConfig.name ? ViewConfig.name : null;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.Title = ViewConfig.title ? ViewConfig.title : "";

    this.GetExportTitleCallback = ViewConfig.export_title_callback ? ViewConfig.export_title_callback : null;

    this.SortMap = ViewConfig.sort_map ? ViewConfig.sort_map : {};

    this.Filter = ViewConfig.filter ? ViewConfig.filter : null;

    this.RowAutoHeight = ViewConfig.rowAutoHeight ? ViewConfig.rowAutoHeight : null;

    this.Layers = ViewConfig.layers ? ViewConfig.layers : {};

    this.LayersConfig = ViewConfig.layers_config ? ViewConfig.layers_config : {};

    this.NoRefresh = ViewConfig.noRefresh ? ViewConfig.noRefresh : false;

    if(ViewConfig.item_config)
    {
        this.ItemType = ViewConfig.item_config.type ? ViewConfig.item_config.type : null;

        this.ItemStyle = ViewConfig.item_config.style ? ViewConfig.item_config.style : null;

        this.ItemDataConfig = ViewConfig.item_config.data_transform ? ViewConfig.item_config.data_transform : null;
    }

    this.ViewConfig =
        {
            id:this.Id,
            view: "scrollview",
            body: {
                rows:function ()
                {
                    var rows = [];

                    if(ViewConfig.title)
                        rows.push(BlockHeaderTemplate({title:ViewConfig.title ? ViewConfig.title : "", icon:ViewConfig.icon ? ViewConfig.icon : ""}));

                    rows.push({
                        id: _this.Id + "Map",
                        template: "<div id=\""+_this.Id + "Map1"+"\" style=\"height:inherit\" class='map'>" +
                            "<div id=\""+_this.Id + "Tooltip\" class=\"map-tooltip\"></div>" +
                            "<div id=\""+_this.Id + "Popup\" class=\"ol-popup\">" +
                            "<a href=\"#\" id=\"" + _this.Id + "PopupCloser\" class=\"ol-popup-closer\"></a>" +
                            "<div id=\""+ _this.Id + "PopupContent\"></div>" +
                            "</div>" +
                            "</div>"
                    });
                    rows.push({gravity: 0});

                    return rows;
                }()
            }
        };
};

QoEMapsReportWidget.prototype.Bind = function (ViewController, ViewModel)
{
    var _this = this;

    if(!ViewController || !(ViewController.ViewModel || ViewModel))
        return;

    this.ViewController = ViewController;

    this.ViewModel = ViewModel ? ViewModel : ViewController.ViewModel;



    this.Views.Map = $$(this.Id + "Map");
    this.Views.Map.attachEvent("onViewShow", function(){
        Object.keys(_this.MapViews).forEach(function (View)
        {
            _this.MapViews[View] = document.getElementById(_this.Id + View);
        });



        _this.SetupMap();
        _this.SetUpTooltip();
        _this.SetupPopup();

        _this.MapViews.PopupCloser.onclick = function () {
            _this.Overlays.Popup.setPosition(undefined);
            _this.MapViews.PopupCloser.blur();
            return false;
        };
    });

    Object.keys(_this.Layers).forEach(function(Key)
    {
        _this.Layers[Key].Bind(_this);

        _this.Subscriptions[Key + "LayerUpdated"] = _this.Layers[Key].OnLayerUpdated.subscribe(function(Layer){

            if(Layer){
                _this.LayersUpdated(Layer);
            }
        });
    });

    this.CacheMonitor = new QoEWidgetCacheMonitor(this, this.Views.Map, this.ViewModel);

    // this.ViewModel.RegisterReport({
    //     id:this.Id,
    //     config:this.Config
    // });

    // this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.Id).signal.subscribe(function (Updated)
    // {
    //     _this.DataSignal(Updated);
    // });
};

QoEMapsReportWidget.prototype.Destroy = function ()
{
    // this.DataSignalSubscription.unsubscribe();
    this.ViewModel.UnRegisterReport(this.Id);
    this.ViewModel = null;
    this.CacheMonitor.Destroy();

    this.ViewController = null;
};

QoEMapsReportWidget.prototype.DestroyMap = function()
{
    var _this = this;
    if(this.Map)
    {
        Object.keys(this.Layers).forEach(function(Key){
            _this.Map.removeLayer(_this.Layers[Key]);
        });

        this.Layers = {};

        var controls = this.Map.getControls();
        controls.forEach(function(Val){
            _this.Map.removeControl(Val);
        });
        // this.Map.layers.forEach(function(Val, i){
        //     _this.Map.removeLayer(Val);
        // });

        // this.Map = null;
    }
};

QoEMapsReportWidget.prototype.LayersUpdated = function(Layer)
{
    var _this = this;

    if(Layer)
    {
        var name = Layer.get('name');

        var layerFounded = false;
        var layers = _this.Map.getLayers();

        layers.forEach(function(L){
            if(L.get('name') == name)
            {
                layerFounded = true;
            }
        });

        var viewArea = this.Layers[name].MapViewArea;

        _this.MapViewArea.maxLon = viewArea.maxLon > this.MapViewArea.maxLon || !this.MapViewArea.maxLon ? viewArea.maxLon : this.MapViewArea.maxLon;
        _this.MapViewArea.maxLat = viewArea.maxLat > this.MapViewArea.maxLat || !this.MapViewArea.maxLat ? viewArea.maxLat : this.MapViewArea.maxLat;
        _this.MapViewArea.minLon = viewArea.minLon < this.MapViewArea.minLon || !this.MapViewArea.minLon ? viewArea.minLon : this.MapViewArea.minLon;
        _this.MapViewArea.minLat = viewArea.minLat < this.MapViewArea.minLat || !this.MapViewArea.minLat ? viewArea.minLat : this.MapViewArea.minLat;

        var view = _this.Map.getView();
        view.animate({
            center: ol.proj.fromLonLat([_this.MapViewArea.minLon + (_this.MapViewArea.maxLon-_this.MapViewArea.minLon)/2, _this.MapViewArea.minLat + (_this.MapViewArea.maxLat - _this.MapViewArea.minLat)/2]),
            zoom: Helper.CalculateMapZoom({lon: _this.MapViewArea.minLon, lat: _this.MapViewArea.minLat}, {lon: _this.MapViewArea.maxLon, lat: _this.MapViewArea.maxLat})
        });

        if(!layerFounded)
        {
            _this.Map.addLayer(Layer);
        }
    }

};

QoEMapsReportWidget.prototype.DataSignal = function (Data)
{
    if(!Data)
        return;
    //
    //
    return;
    var _this = this;
    var config = this.ViewModel.GetReportConfig(this.Id);

    var minLat=0, maxLat=0,minLon=0,maxLon=0;
    var data = [];

    config.data.rows.forEach(function(Val){
        _this.LayersConfig.forEach(function(Layer){
            // var lon = Val[Layer.item_config.data_transform.lon.value] + Helper.RandInt(-10, 10);
            var lon = Val[Layer.item_config.data_transform.lon.value];
            // var lat = Val[Layer.item_config.data_transform.lat.value] + Helper.RandInt(-10, 10);
            var lat = Val[Layer.item_config.data_transform.lat.value];
            var item = {
                geometry: new ol.geom[Layer.item_config.type](ol.proj.fromLonLat([lon,lat])),
                name: Val[Layer.item_config.data_transform.name.value],
                description: Val[Layer.item_config.data_transform.description.value],
                id: Val[Layer.item_config.data_transform.id.value],
                info: ""
            };
            Layer.item_config.data_transform.data.forEach(function(D){
                item.info += D.title + ": " + Val[D.value] + "<br/>";
            });
            data.push(new ol.Feature(item));

            if(lon > maxLon || !maxLon)
            {
                maxLon = lon;
            }
            if(lon < minLon || !minLon)
            {
                minLon = lon;
            }

            if(lat > maxLat || !maxLat)
            {
                maxLat = lat;
            }
            if(lat < minLat || !minLat)
            {
                minLat = lat;
            }
        })

    });

    _this.LayersConfig.forEach(function(Layer){
        _this.UpdateLayer(Layer, data);
    });

    var view = this.Map.getView();
    view.animate({
        center: ol.proj.fromLonLat([minLon + (maxLon-minLon)/2, minLat + (maxLat - minLat)/2]),
        zoom: Helper.CalculateMapZoom({lon: minLon, lat: minLat}, {lon: maxLon, lat: maxLat})
    });
};

QoEMapsReportWidget.prototype.UpdateLayersData = function(Data)
{
    if(!Data)
    {
        return;
    }

    var _this = this;
    Object.keys(this.Layers).forEach(function (Key) {
        _this.Layers[Key].UpdateDataByParent(Data);
    });
};

QoEMapsReportWidget.prototype.UpdateExternalFilter = function(Params)
{
    var _this = this;
    Object.keys(this.Layers).forEach(function (Key) {
        _this.Layers[Key].ExternalFilter = Params.filter;
    });
};

QoEMapsReportWidget.prototype.ShowHideFeature = function(Item, State)
{
    var _this = this;
    Object.keys(this.Layers).forEach(function (Key) {
        _this.Layers[Key].ShowHideFeature(Item, State);
    });
};

QoEMapsReportWidget.prototype.GetFilterSortState = function (Params)
{
    return {filter:{}, sort:{}, size:10000};
};

QoEMapsReportWidget.prototype.RefreshData = function (Page, Params)
{
    var _this = this;


    if(this.NoRefresh)
        return;

    Object.values(this.Layers).forEach(function(Layer){
        Layer.RefreshData(Page, Params);
    });
};

QoEMapsReportWidget.prototype.Reconfig = function (ViewConfig)
{
    var _this = this;

    Object.keys(_this.MapViews).forEach(function (View)
    {
        _this.MapViews[View] = document.getElementById(_this.Id + View);
    });

    _this.SetupMap();
    _this.SetUpTooltip();
    _this.SetupPopup();

    _this.MapViews.PopupCloser.onclick = function () {
        _this.Overlays.Popup.setPosition(undefined);
        _this.MapViews.PopupCloser.blur();
        return false;
    };

    Object.keys(_this.Layers).forEach(function(Key)
    {
        _this.Layers[Key].Reconfig(_this);

        _this.Subscriptions[Key + "LayerUpdated"] = _this.Layers[Key].OnLayerUpdated.subscribe(function(Layer){

            if(Layer){
                _this.LayersUpdated(Layer);
            }
        });
    });


};

QoEMapsReportWidget.prototype.GetExportTitle = function ()
{
    if(this.GetExportTitleCallback)
        return this.GetExportTitleCallback();

    return this.Title;
};

QoEMapsReportWidget.prototype.GetReportConfig = function ()
{
    return this.ViewModel.GetReportConfig(this.Id);
};

QoEMapsReportWidget.prototype.GetCachesIds = function ()
{
    return this.CacheMonitor && this.CacheMonitor.LastCacheId ? [this.CacheMonitor.LastCacheId] : null;
};

QoEMapsReportWidget.prototype.IfRowContextMenuApplicable = function()
{
    if(!this.ViewController || !this.ViewController.GetFilterStateConfig || !this.ViewController.GetPeriodState)
    {
        return false;
    }

    return true;
};

QoEMapsReportWidget.prototype.GetFilterStateConfig = function()
{
    if(this.ViewController)
    {
        return this.ViewController.GetFilterStateConfig();
    }

    return null;
};

QoEMapsReportWidget.prototype.GetPeriodState = function()
{
    if(this.ViewController)
    {
        return this.ViewController.GetPeriodState();
    }

    return null;
};

QoEMapsReportWidget.prototype.SetSphinxSearch = function(SphinxSearchModel)
{
    this.SphinxSearch = SphinxSearchModel;
};

QoEMapsReportWidget.prototype.SetupMap = function()
{
    var layer = new ol.layer.Tile({
        // source: new ol.source.OSM()
        source: AppEnv.LocalMaps ?  new ol.source.XYZ({
            url: (typeof AppEnv.LocalMaps === "string") ? AppEnv.LocalMaps : "api/osm?z={z}&x={x}&y={y}&r=mapnik",
            maxZoom: 19
        }) : new ol.source.OSM()
    });
    layer.set('name', this.Id + "OSM");
    this.Map = new ol.Map({
        target: this.Id + "Map1",
        layers: [
            layer
        ],
        view: new ol.View({
            center: ol.proj.fromLonLat([0,0]),
            zoom: 2,
            maxZoom: 19
        })
    });

    this.Map.addControl(new ol.control.FullScreen());
    this.Map.addControl(new ol.control.OverviewMap({
        className: 'ol-overviewmap ol-custom-overviewmap',
        layers: [
            new ol.layer.Tile({
                // source: new ol.source.OSM()
                source : AppEnv.LocalMaps ? new ol.source.XYZ({
                    url: (typeof AppEnv.LocalMaps === "string") ? AppEnv.LocalMaps : "api/osm?z={z}&x={x}&y={y}&r=mapnik",
                    maxZoom: 18
                }) : new ol.source.OSM()
            })
        ],
        autoPan: true,
        size: {h:150, w:500},
        collapsed: false
    }));
    this.Map.addControl(new ol.control.ScaleLine());
    this.Map.addControl(new ol.control.Zoom());
    this.Map.addControl(new ol.control.ZoomSlider({
        maxZoom: 19
    }));
    this.Map.updateSize();
    this.Map.render();
};

QoEMapsReportWidget.prototype.SetUpTooltip = function()
{
    var _this = this;
    this.Overlays.Tooltip = new ol.Overlay({
        element: _this.MapViews.Tooltip,
        offset: [10, -10],
        autoPan: true,
        autoPanAnimation: {
            duration: 250,
        }
    });

    this.Map.addOverlay(this.Overlays.Tooltip);

    this.Map.on('pointermove', function(evt)
    {

        var pixel = evt.pixel;
        var feature = _this.Map.forEachFeatureAtPixel(pixel, function(feature) {
            return feature;
        });
        _this.MapViews.Tooltip.style.display = feature ? '' : 'none';
        if (feature) {
            _this.Overlays.Tooltip.setPosition(evt.coordinate);
            _this.MapViews.Tooltip.innerHTML = feature.get('name') ? feature.get('name') : "";
        }
    })
};

QoEMapsReportWidget.prototype.SetupPopup = function()
{
    var _this = this;
    this.Overlays.Popup = new ol.Overlay({
        element: _this.MapViews.Popup,
        autoPan: true,
        autoPanAnimation: {
            duration: 250,
        }
    });

    this.Map.addOverlay(this.Overlays.Popup);

    this.Map.on('singleclick', function(evt)
    {
        var pixel = evt.pixel;
        var feature = _this.Map.forEachFeatureAtPixel(pixel, function(feature) {
            return feature;
        });

        if(feature)
        {
            var coordinate = evt.coordinate;
            var items = feature.get('items');
            if(items && items.length)
            {

                var hitbox = Helper.CalculateMapFeatureHitBox(feature.getGeometry().stride, _this.Map.getView().getZoom());

                items.forEach(function(Item){
                    if(Item && Item.getGeometry())
                    {
                        if(Helper.GetLineLengthByPoints(coordinate, Item.getGeometry().getCoordinates()) < hitbox)
                        {
                            feature = Item;
                        }
                    }
                });
            }
            var content = [];
            if(feature.get("name"))
            {
                content.push(feature.get("name"));
            }

            if(feature.get("description"))
            {
                content.push(feature.get("description"));
            }

            if(feature.get("lon") && feature.get("lat"))
            {
                content.push(LangHelper.GetString("Dics", "Coordinates") + ": { " + feature.get("lon") + ", " + feature.get("lat") + " }");
            }

            if(feature.get("info"))
            {
                content.push(feature.get("info"));
            }

            _this.MapViews.PopupContent.innerHTML = content.join("<br/>");
            _this.Overlays.Popup.setPosition(coordinate);
        }
    })
};

QoEMapsReportWidget.prototype.SetupLayers = function()
{
    var _this = this;

    this.LayersConfig.forEach(function(Layer){
        _this.Layers[Layer.name] = new ol.layer[Layer.type]({
            source: new ol.source[Layer.type]({}),
            style: Layer.item_style
        });

        _this.Map.addLayer(_this.Layers[Layer.name]);
    });
};

QoEMapsReportWidget.prototype.UpdateLayer = function(Layer, Data)
{
    var _this = this;

    if(this.Layers[Layer.name])
        this.Map.removeLayer(this.Layers[Layer.name]);

    _this.Layers[Layer.name] = new ol.layer[Layer.type]({
        source: new ol.source[Layer.type]({
            features: Data
        }),
        style: Layer.item_style
    });

    _this.Map.addLayer(_this.Layers[Layer.name]);

};
function QoETableLayerWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.TableWidget = null;

    this.MapWidget = null;

    this.Subscriptions = {};

    this.RefreshPage = 0;

    this.RefreshParams = 0;

    this.SerieColumnId = null;

    this.Init(ViewConfig);
}

QoETableLayerWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig || !ViewConfig.table || !ViewConfig.map)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Name = ViewConfig.name ? ViewConfig.name : null;

    this.TableWidget = ViewConfig.table.widget;

    this.MapWidget = ViewConfig.map.widget;

    this.SerieColumnId = ViewConfig.serie_column ? ViewConfig.serie_column : null;

    this.ViewConfig =
        {
            id: this.Id,
            cols:[
                {
                    gravity:ViewConfig.table.gravity ? ViewConfig.table.gravity : 1,
                    rows:[
                        this.TableWidget.ViewConfig
                    ]
                },
                {view:"resizer"},
                {
                    gravity:ViewConfig.map.gravity ? ViewConfig.map.gravity : 1,
                    rows:[
                        this.MapWidget.ViewConfig
                    ]
                }
            ]
        }

};

QoETableLayerWidget.prototype.Bind = function (ViewController)
{
    var _this = this;

    this.MapWidget.Bind(ViewController);

    this.TableWidget.Bind(ViewController);

    var columns = webix.toArray(this.TableWidget.Views.Table.config.columns);

    columns.insertAt({
        id:"enabled",
        header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:this.TableWidget.Views.Table.config.id+"MasterCheckBox" },""],
        template: CellColoredCheckBoxTemplate,
        width:32
    },0);

    this.TableWidget.DataAdapter = function (Data)
    {
        var colorIndex = 0;

        var colors = Helper.DictToArr(ColorsDic);

        if(Data && Data.rows)
        {
            Data.rows.forEach(function (Row, Index)
            {
                Row.color = colors[colorIndex].value;

                Row.enabled = 1;

                Row.valid = 1;

                Row.index = Index;

                colorIndex++;

                if(colorIndex > colors.length - 1)
                    colorIndex = 0;
            });
        }

        return Data;
    };

    this.TableWidget.Views.Table.config.checkboxRefresh = true;
    this.TableWidget.Views.Table.refreshColumns();

    this.TableWidget.Views.Table.attachEvent("onCheck", function(id, column, state)
    {
        if(column == "enabled")
        {
            var item = _this.TableWidget.Views.Table.getItem(id);

            _this.MapWidget.ShowHideFeature(item, state);
        }
    });

    this.Subscriptions.TableDataSignalSubscription = this.TableWidget.GetReportConfig().signal.subscribe(function (Updated)
    {
        if(Updated)
        {
            var mapConfig = _this.MapWidget.GetReportConfig();

            var tableConfig = _this.TableWidget.GetReportConfig();

            var data = tableConfig &&  tableConfig.data && tableConfig.data.rows ? tableConfig.data.rows : [];

            if(!_this.MapWidget.Map)
            {
                _this.MapWidget.Reconfig(mapConfig);
            }

            _this.TableWidget.Views.Table.blockEvent();
            _this.TableWidget.Views.Table.getHeaderContent(_this.TableWidget.Views.Table.config.id+"MasterCheckBox").check();
            _this.TableWidget.Views.Table.unblockEvent();

            setTimeout(function () {
                    if (_this.TableWidget.Views.Table) {
                        _this.MapWidget.UpdateLayersData({rows: _this.TableWidget.Views.Table.serialize()});
                    }
                }, 250
            );

        }
    });
};

QoETableLayerWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (Key) {
        _this.Subscriptions[Key].unsubscribe();
    });

    this.TableWidget.Destroy();
    this.MapWidget.Destroy();
};

QoETableLayerWidget.prototype.RefreshData = function (Page, Params)
{
    this.RefreshPage = Page;

    this.RefreshParams = Params;

    this.MapWidget.UpdateExternalFilter(Params);

    this.TableWidget.RefreshData(Page, Params);
};

QoETableLayerWidget.prototype.GetCachesIds = function ()
{
    var tableCacheId = this.TableWidget.GetCachesIds();
    var chartCacheId = this.MapWidget.GetCachesIds();

    var cacheIds = [];

    if(tableCacheId)
        cacheIds.push(tableCacheId[0]);

    if(chartCacheId)
        cacheIds.push(chartCacheId[0]);

    return cacheIds.length ? cacheIds : null;
};
function QoEPieChartReportWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ReportId = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.Views = {
        Chart:null,
        ExcelExport:null,

        ReportSettingsBtn:null
    };

    this.CacheMonitor = null;

    this.PdfExportConfig = null;

    this.ReportsSettingsManager = null;

    this.Init(ViewConfig);
}

QoEPieChartReportWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Name = ViewConfig.name ? ViewConfig.name : null;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.Title = ViewConfig.title ? ViewConfig.title : "";

    this.Filter = ViewConfig.filter ? ViewConfig.filter : null;

    this.GetExportPdfConfig(ViewConfig);

    var valueKey = this.Config.values[0].alias;

    var labelKey = typeof this.Config.rows[0] === "object" ? this.Config.rows[0].alias : this.Config.rows[0];

    var guiDicKey = typeof this.Config.rows[0] === "object" && this.Config.rows[0].gui_dic ? this.Config.rows[0].gui_dic  : "";

    this.MaxUiChartElements = 30;

    this.ViewConfig =
    {
        id:this.Id,
        rows:[
            BlockHeaderTemplate({title:ViewConfig.title ? ViewConfig.title : "", icon:ViewConfig.icon ? ViewConfig.icon : ""}),
            {
                view:"chart",
                id:this.Id + "Chart",
                type:"pie",
                value: "#"+valueKey+"#",
                // color: "#color#",
                tooltip: {
                    template:function (Obj)
                    {
                        var val = Obj[labelKey];

                        if(guiDicKey)
                        {
                            var dic = App.DicsManager.GetDic(guiDicKey);

                            if(dic && dic[val])
                                val = LangHelper.GetString("QoE",dic[val].value);

                        }

                        return val;
                    }
                },
                label:function(obj)
                {
                    var html = obj[valueKey];
                    if(totalValue)
                        html += "<br/><b>"+Math.ceil(obj[valueKey]/totalValue*100)+"%</b>";
                    return "<div style='text-align: center;'>"+html+"</div>"
                },
                legend: {
                    height:160,
                    align: "left",
                    valign: "bottom",
                    layout:"x",
                    template:function (Obj)
                    {
                        var val = Obj[labelKey];

                        if(guiDicKey)
                        {
                            var dic = App.DicsManager.GetDic(guiDicKey);

                            if(dic && dic[val])
                                val = LangHelper.GetString("QoE",dic[val].value);

                        }

                        return val;
                    }
                },
                on:{
                    onBeforeRender: function(){
                        var data = this.data.getRange();
                        var propertyFunc = webix.template("#"+valueKey+"#");
                        totalValue = webix.GroupMethods.sum(propertyFunc, data);
                    }
                },
                data: []
            },
            {
                view: "toolbar",
                padding: 0,
                margin: 0,
                height:32,
                elements: [
                    {},
                    {
                        view:"button",
                        id:_this.Id + "ReportSettingsBtn",
                        type:"icon",
                        icon:"gear",
                        css:"toolbar_round_btn",
                        width:38,
                        tooltip:LangHelper.GetString("QoE", "Report Settings"),
                        badge:0,
                        hidden: true
                    },
                    {
                        view: "button",
                        id:this.Id+"ExcelExport",
                        type: "icon",
                        icon: "file-export",
                        label:LangHelper.GetString("All","Export"),
                        css: "toolbar_round_btn",
                        width: 110,
                        tooltip: LangHelper.GetString("QoE", "Export to png")
                    }
                ]
            }
        ]
    };
};

QoEPieChartReportWidget.prototype.Bind = function (ViewController)
{
    var _this = this;

    if(!ViewController || !ViewController.ViewModel)
        return;

    this.ViewController = ViewController;

    this.ViewModel = ViewController.ViewModel;

    this.Views.Chart = $$(this.Id + "Chart");

    this.Views.ExcelExport = $$(this.Id + "ExcelExport");

    this.CacheMonitor = new QoEWidgetCacheMonitor(this, this.Views.Chart, this.ViewModel);

    this.ExcelExportWidget = new QoEExcelExportWidget(this, this.Views.ExcelExport, this.Title, "Chart");

    this.ViewModel.RegisterReport({
        id:this.Id,
        config:this.Config
    });

    this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.Id).signal.subscribe(function (Updated)
    {
        _this.DataSignal(Updated);
    });

    this.Views.ReportSettingsBtn = $$(this.Id + "ReportSettingsBtn");

    if(this.ViewController && this.ViewController.ReportsSettings)
    {
        let model = this.ViewController.ReportsSettings.ViewModel.InitReportsSettingsModel(this, {
            show_settings_btn: this.Views.ReportSettingsBtn,
            can_update_widget: true
        });

        if(model)
        {
            this.ReportsSettingsManager = this.ViewController.ReportsSettings.ViewModel;
            if(this.Views.ReportSettingsBtn)
                this.Views.ReportSettingsBtn.show();
        }
    }
};

QoEPieChartReportWidget.prototype.Destroy = function ()
{
    if(this.DataSignalSubscription)
        this.DataSignalSubscription.unsubscribe();

    if(this.ViewModel) {
        this.ViewModel.UnRegisterReport(this.Id);
        this.ViewModel = null;
    }

    if(this.CacheMonitor)
        this.CacheMonitor.Destroy();

    if(this.ExcelExportWidget)
        this.ExcelExportWidget.Destroy();
};

QoEPieChartReportWidget.prototype.DataSignal = function (Updated)
{
    if(!Updated)
        return;

    var config = this.ViewModel.GetReportConfig(this.Id);

    this.Views.Chart.clearAll();

    this.Views.Chart.parse(config.data && config.data.rows ? config.data.rows.slice(0, this.MaxUiChartElements) : []);

    this.CacheMonitor.DataSignal(config.data, config.error);
};

QoEPieChartReportWidget.prototype.RefreshData = function (Page, Params)
{
    var settingsModel = this.ReportsSettingsManager ? this.ReportsSettingsManager.GetSettingsModel(this.Id) : null;

    if(settingsModel)
        settingsModel.ReconfigReportQuery();

    var config = this.ViewModel.GetReportConfig(this.Id);

    var sort = config.config.sort ? config.config.sort : null;

    var size = config.config.size ? config.config.size : 0;

    var filter = {};

    if(Params&&Params.filter)
    {
        this.ExternalFilter = webix.copy(Params.filter);
    }

    webix.extend(filter, this.ExternalFilter, true);

    if(Params&&Params.filter)
    {
        webix.extend(filter, Params.filter, true);
    }

    if(this.Filter)
    {
        for(var i in this.Filter)
        {
            filter[i] = this.Filter[i];
        }
    }

    if(Params && Params.report_id)
    {
        this.ReportId = Params.report_id;
    }

    this.ViewModel.RefreshReportData(this.Id, {
        page:Page,
        filter:filter,
        sort:sort,
        size:size,
        report_settings: settingsModel ? settingsModel.GetReportSettings() : null,
        max_execution_time: Params&&Params.max_execution_time ? Params.max_execution_time : 0,
        report_id: this.ReportId ? this.ReportId : null
    });
};

QoEPieChartReportWidget.prototype.Refresh = function ()
{
    if(this.Views.Chart)
        this.Views.Chart.refresh();
};

QoEPieChartReportWidget.prototype.GetExportTitle = function ()
{
    if(this.GetExportTitleCallback)
        return this.GetExportTitleCallback();

    return this.Title;
};

QoEPieChartReportWidget.prototype.GetCachesIds = function ()
{
    return this.CacheMonitor && this.CacheMonitor.LastCacheId ? [this.CacheMonitor.LastCacheId] : null;
}

QoEPieChartReportWidget.prototype.GetReportConfig = function ()
{
    return this.ViewModel.GetReportConfig(this.Id);
};

QoEPieChartReportWidget.prototype.GetExportPdfConfig = function (Config)
{
    this.PdfExportConfig = Config.export_pdf_config ? Config.export_pdf_config : {};

    this.PdfExportConfig.view_type = this.PdfExportConfig.view_type ? this.PdfExportConfig.view_type : "pie_chart";
    this.PdfExportConfig.name = this.PdfExportConfig.name ? this.PdfExportConfig.name : Config.name;
    this.PdfExportConfig.locales = this.PdfExportConfig.locales ? this.PdfExportConfig.locales : {};
};

QoEPieChartReportWidget.prototype.RefreshPdfExportConfig = function (Params)
{
    this.PdfExportConfig = webix.extend(this.PdfExportConfig, Params, true);
};

QoEPieChartReportWidget.prototype.DefineExportPdfConfig = function(Params)
{
    this.RefreshPdfExportConfig(Params);
};

QoEPieChartReportWidget.prototype.SetReportConfig = function (ReportConfig)
{
    return this.ViewModel.RegisterReport(ReportConfig);
};

function QoESeriesChartSerieItemModel(Params)
{
    let model = {};

    model.value = Params && Params.value ? Params.value : null;
    model.name = Params && Params.name ? Params.name : null;
    model.color = Params && Params.color ? Params.color : null;
    model.isEnable = Params && Params.isEnable ? Params.isEnable : null;

    return model;
}

const QoESeriesChartAxisTemplates = {
    TrafficSpeedBit:          (Val) => {return Helper.UnitPrefixToNumeric(Val, 1000, TrafficSpeedBitUnits);},
    NetFlowSpeed:             (Val) => {return Helper.UnitPrefixToNumeric(Val, 1000, NetFlowSpeedUnits);},
    FileSize:                 (Val) => {return Helper.UnitPrefixToNumeric(Val, 1024, FileSizeUnits);},
    TimeUnits:                (Val) => {return Helper.UnitPrefixToNumeric(Val / 1000, 1000, TimeUnits);},
    DateTimeForChartXAxes:    (Val) => {return Helper.FormatDateTimeForChartXAxes(Val, "%H:%i:%s", true);},
    Percents:                 (Val) => {return Val + " %";}
};

const QoESeriesChartAxisTemplatesMap = {
    traffic:                        {template: QoESeriesChartAxisTemplates.TrafficSpeedBit, units: TrafficSpeedBitUnits, divider: 1000},
    traffic_from_subscriber:        {template: QoESeriesChartAxisTemplates.TrafficSpeedBit, units: TrafficSpeedBitUnits, divider: 1000},
    traffic_to_subscriber:          {template: QoESeriesChartAxisTemplates.TrafficSpeedBit, units: TrafficSpeedBitUnits, divider: 1000},
    traffic_vol:                    {template: QoESeriesChartAxisTemplates.FileSize, units: FileSizeUnits, divider: 1024},
    traffic_vol_from_subscriber:    {template: QoESeriesChartAxisTemplates.FileSize, units: FileSizeUnits, divider: 1024},
    traffic_vol_to_subscriber:      {template: QoESeriesChartAxisTemplates.FileSize, units: FileSizeUnits, divider: 1024},
    flow:                           {template: QoESeriesChartAxisTemplates.NetFlowSpeed, units: NetFlowSpeedUnits, divider: 1000},
    flow_from_subscriber:           {template: QoESeriesChartAxisTemplates.NetFlowSpeed, units: NetFlowSpeedUnits, divider: 1000},
    flow_to_subscriber:             {template: QoESeriesChartAxisTemplates.NetFlowSpeed, units: NetFlowSpeedUnits, divider: 1000}
};

function QoESeriesChartReportWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ReportId = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.Views = {
        Chart:null,
        ChartPaginatorToolbar:null,
        ChartRange:null,
        Paging:null,
        Size:null,
        SizeInfo:null,
        ExcelExport:null,
        ChartType:null,

        ReportSettingsBtn:null,
    };

    this.CacheMonitor = null;

    this.PdfExportConfig = null;

    this.ReportsSettingsManager = null;

    this.ReportSettings = null;

    this.SignalChartTypeChanged = null;

    this.SeriesItems = [];

    this.DefaultGetTopListLimit = 50;

    this.OptionsOrderBy = {};

    this.DefaultKeyOrderBy = null;

    this.Init(ViewConfig);
}

QoESeriesChartReportWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Name = ViewConfig.name ? ViewConfig.name : null;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.Filter = ViewConfig.filter ? ViewConfig.filter : null;

    this.Title = ViewConfig.title ? ViewConfig.title : "";

    this.ChartType = ViewConfig.type ? ViewConfig.type : "stackedArea";

    // if need know how work webix scale see _calculateScale proto chart
    this.ChartScale = ViewConfig.scale ? ViewConfig.scale : "linear";

    // Log scale requires positive values: zero entries are replaced
    // with a configured minimum or, if MinChartValue is 0, with the dataset minimum.
    this.MinChartValue = ViewConfig.min_chart_value ? ViewConfig.min_chart_value : 1;

    this.ChartRange = ViewConfig.chart_range ? ViewConfig.chart_range : null;

    this.HidePaginatorToolbar = ViewConfig.hidePaginatorToolbar ? true : false;

    this.DefaultPageSize = this.GetStoredPageSize() ? this.GetStoredPageSize() : ViewConfig.defaultPageSize ? ViewConfig.defaultPageSize : 2000

    this.GetExportPdfConfig(ViewConfig);

    this.ReportSettings = ViewConfig.report_settings ? ViewConfig.report_settings : null;

    this.xAxisStep = 4;

    this.xAxisIndex = 0;

    //var valueKey = this.Config.values[0].alias;

    this.labelKey = this.Config.rows&&this.Config.rows[0] ? this.Config.rows[0] : this.Config.values[0];

    if(typeof this.labelKey == "object")
    {
        this.labelKey = this.labelKey.alias ? this.labelKey.alias : this.labelKey.row
    }

    this.xAxisTemplate = ViewConfig.xAxis ?
    {
        lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
        color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined,
        template:function(obj)
        {
            var val = obj[_this.labelKey];
            return _this.xAxisIndex++%_this.xAxisStep == 0 ? (ViewConfig.xAxis.template ? ViewConfig.xAxis.template(val) : val) : "";
        }
    }
    :
    {
        lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
        color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined,
        template:function(obj)
        {
            var val = obj[_this.labelKey];

            return _this.xAxisIndex++%_this.xAxisStep == 0 ? val : "";
        }
    };

    this.yAxisTemplate = ViewConfig.yAxis ?
    webix.extend(ViewConfig.yAxis,{
        lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().yAxis.lineColor : undefined,
        color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().yAxis.color : undefined
    })
    :
    {
        lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().yAxis.lineColor : undefined,
        color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().yAxis.color : undefined
    };

    this.ViewConfig =
    {
        id:this.Id,
        rows:function (){

            var rows = [];

            rows.push({
                view:"chart",
                id:_this.Id + "Chart",
                type: _this.ChartType,
                scale: _this.ChartScale,
                alpha: ViewConfig.alpha ? ViewConfig.alpha : 0.7,
                origin: ViewConfig.origin,
                xAxis: _this.xAxisTemplate,
                yAxis: _this.yAxisTemplate,
                padding: ViewConfig.padding ? ViewConfig.padding : {left:80},
                legend: ViewConfig.legend ? ViewConfig.legend :
                    {
                        height:160,
                        align: "left",
                        valign: "bottom",
                        layout:"x",
                        values:[]
                    },
                data: ViewConfig.data ? ViewConfig.data : []
            });

            if(_this.ChartRange)
            {
                rows.push({
                    view:"rangechart",
                    id:_this.Id + "ChartRange",
                    height: _this.ChartRange.height ? _this.ChartRange.height : 80,
                    type:_this.ChartType,
                    data:[],
                    on:{
                        onAfterRangeChange:function(){
                            $$(_this.Id + "Chart").clearAll();
                            $$(_this.Id + "Chart").parse(this.getFrameData());
                        }
                    },
                    frameId:_this.ChartRange.frameId ? _this.ChartRange.frameId : "",
                    padding: ViewConfig.padding ? ViewConfig.padding : {left:80, bottom:0, top:0, right:0},
                    item: { radius :0 },
                    legend: ViewConfig.legend ? ViewConfig.legend :
                        {
                            height:160,
                            align: "left",
                            valign: "bottom",
                            layout:"x",
                            values:[]
                        },
                    //,
                    // ready:function(){
                    //     this.setFrameRange({start:30, end:40});
                    // }
                });
            }

            if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin()) {
                var excelBtn = {
                    view: "spectre_button",
                    id: _this.Id + "ExcelExport",
                    css: "form_element form_button spec_action",
                    label: LangHelper.GetString("UlrModule", "Export"),
                    tooltip: LangHelper.GetString("QoE", "Export to excel, csv, pdf, png"),
                    autowidth: true,
                    height:40,
                    hidden: _this.HideExportWidget ? true : false
                };
            }
            else
            {
                var excelBtn = {
                    view: "button",
                    id:_this.Id+"ExcelExport",
                    type: "icon",
                    icon: "file-export",
                    label:LangHelper.GetString("All","Export"),
                    css: "toolbar_round_btn",
                    width: 128,
                    tooltip: LangHelper.GetString("QoE", "Export to excel, csv, pdf, png"),
                    hidden:_this.HideExportWidget ? true : false
                };
            }

            var reportSettingsBtn = {
                view:"button",
                id:_this.Id + "ReportSettingsBtn",
                type:"icon",
                icon:"gear",
                css:"toolbar_round_btn",
                width:38,
                tooltip:LangHelper.GetString("QoE", "Report Settings"),
                badge:0,
                hidden: true
            };

            var chartType = {
                view:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? "spectre_richselect" : "richselect",
                id: _this.Id + "ChartType",
                tooltip:LangHelper.GetString("QoE", "Chart type"),
                width:160,
                css:"form_element",
                options:Helper.DictToArr(ChartTypesDic),
                suggest: {fitMaster: false, data:Helper.DictToArr(ChartTypesDic)},
                value:_this.ChartType,
                hidden:true,
                on: {
                    onChange:function()
                    {
                        _this.SetChartType();
                    }
                }
            };

            var paginatorToolbar = {
                view: "toolbar",
                id:_this.Id + "ChartPaginatorToolbar",
                css:"webix_pager_paginator_toolbar",
                padding: 0,
                margin: 0,
                height:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? 40 : 32,
                hidden:_this.HidePaginatorToolbar ? true : false,
                elements: function ()
                {
                    var sizeInfo =
                        {
                            id:_this.Id + "SizeInfo",
                            css:"webix_pager_size_info",
                            view:"label",
                            label:"",
                            minWidth:170
                        };

                    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
                    {
                        delete sizeInfo.minWidth;
                        sizeInfo.width = 75
                    }

                    if(_this.DefaultPageSize < 0)
                        _this.DefaultPageSize = _this.DefaultPageSize * -1;

                    var rowsPerPage = {
                        view:"richselect",
                        id: _this.Id + "Size",
                        css:"webix_pager_page_size_selector",
                        icon:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? "sort-down" : "arrow-down",
                        tooltip:LangHelper.GetString("QoE", "Slide size"),
                        value: _this.DefaultPageSize ? _this.DefaultPageSize : 2000,
                        width:80,
                        options:{
                            fitMaster:false,
                            width:80,
                            data:[
                                {id:10, value:"10"},
                                {id:50, value:"50"},
                                {id:100, value:"100"},
                                {id:200, value:"200"},
                                {id:500, value:"500"},
                                {id:1000, value:"1 000"},
                                {id:2000, value:"2 000"},
                                {id:5000, value:"5 000"},
                                {id:10000, value:"10 000"}
                            ]
                        },
                        on: {
                            onChange:function(Value)
                            {
                                if(!_this.HidePaginatorToolbar)
                                {
                                    _this.SetStoredPageSize(Value);
                                    _this.RefreshData();
                                }
                            }
                        }
                    };

                    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
                    {
                        rowsPerPage.label = LangHelper.GetString("UlrModule", "Show");
                        rowsPerPage.labelAlign = "right";
                        rowsPerPage.labelWidth = 60;
                        rowsPerPage.width = 100;
                    }

                    var paginator = {
                        view: "pager",
                        id: _this.Id + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master:false,
                        gravity:4,
                        on: {
                            onAfterPageChange:function(Page)
                            {
                                if(!_this.HidePaginatorToolbar)
                                    _this.RefreshData(Page);
                            }
                        }
                    };

                    var els = [
                        sizeInfo,
                        {},
                        paginator,
                        {},
                        reportSettingsBtn,
                        chartType,
                        excelBtn,
                        rowsPerPage
                    ];

                    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
                    {
                        els = [
                            {width: 20},
                            sizeInfo,
                            {},
                            paginator,
                            {},
                            chartType,
                            rowsPerPage,
                            {width: 20}
                        ];
                    }

                    return els;
                }()
            }

            rows.push(paginatorToolbar)

            if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
            {
                var excelBtn = {
                    view:"spectre_button",
                    id: _this.Id+"ExcelExport",
                    css:"form_button spec_action",
                    label:LangHelper.GetString("UlrModule","Export"),
                    tooltip: LangHelper.GetString("QoE", "Export to excel, csv, pdf, png"),
                    autowidth:true,
                    hidden:_this.HideExportWidget ? true : false
                };

                rows.push({
                    hidden:_this.HideExportWidget ? true : false,
                    height: 71,
                    rows:[
                        {height:20},
                        {
                            cols: [
                                {width: 20},
                                excelBtn,{}
                            ]
                        }
                    ]
                });
            }

            return rows;
        }()
    };

    if(ViewConfig.title)
    {
        this.ViewConfig.rows.splice(0, 0, BlockHeaderTemplate({title:ViewConfig.title ? ViewConfig.title : "", icon:ViewConfig.icon ? ViewConfig.icon : ""}));
    }

    this.LegendIsVisible = true;

    this.SignalChartTypeChanged = new Rx.BehaviorSubject(null);
};

QoESeriesChartReportWidget.prototype.Bind = function (ViewController)
{
    var _this = this;

    if(!ViewController || !ViewController.ViewModel)
        return;

    this.ViewController = ViewController;

    this.ViewModel = ViewController.ViewModel;

    this.Views.Chart = $$(this.Id + "Chart");

    this.Views.ChartPaginatorToolbar = $$(this.Id + "ChartPaginatorToolbar");
    this.Views.Paging = $$(this.Id + "Paging");
    this.Views.Size = $$(this.Id + "Size");
    this.Views.SizeInfo = $$(this.Id + "SizeInfo");

    if(_this.ChartRange)
    {
        this.Views.ChartRange = $$(this.Id + "ChartRange");
    }

    this.Views.ExcelExport = $$(this.Id + "ExcelExport");

    this.Views.ChartType = $$(this.Id + "ChartType");

    this.CacheMonitor = new QoEWidgetCacheMonitor(this, this.Views.Chart, this.ViewModel);

    this.ExcelExportWidget = new QoEExcelExportWidget(this, this.Views.ExcelExport, this.Title, "Chart");

    this.ViewModel.RegisterReport({
        id:this.Id,
        config:this.Config
    });

    this.Views.Chart.attachEvent("onBeforeRender", function(data)
    {
        _this.xAxisIndex = 0; _this.xAxisStep = 1;

        if(data.length && _this.Views.Chart.$width)
        {
            var l = data.length;

            var w = _this.Views.Chart.$width;

            for (var i = 1; i <= l; i++)
            {
                if(w/l*_this.xAxisStep >= 100)
                {
                    break;
                }

                _this.xAxisStep++;
            }
        }

        return true;
    });

    this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.Id).signal.subscribe(function (Updated)
    {
        _this.DataSignal(Updated);
    });

    this.Views.Chart.attachEvent("onLegendClick",function(e,serieItemIdx,node) {
        if(_this.ReportsSettingsManager)
        {
            let enableSeries = _this.SeriesItems.filter(item => item.isEnable);
            let item = _this.SeriesItems[serieItemIdx];
            let state = item.isEnable ? 0 : 1;

            if(enableSeries.length <= 1 && !state)
                return false;

            item.isEnable = state;
            _this.DefineReportSettings();
        }
    });

    this.Views.Chart.attachEvent("onAfterLoad", function(){
        _this.ExcelExportWidget.ExportBtn.enable();
    });

    this.Views.ReportSettingsBtn = $$(this.Id + "ReportSettingsBtn");

    if(this.ViewController && this.ViewController.ReportsSettings)
    {
        let model = this.ViewController.ReportsSettings.ViewModel.InitReportsSettingsModel(this, {
            show_settings_btn: this.Views.ReportSettingsBtn,
            can_update_widget: true
        });

        if(model)
        {
            this.ReportsSettingsManager = this.ViewController.ReportsSettings.ViewModel;
            if(this.Views.ReportSettingsBtn)
                this.Views.ReportSettingsBtn.show();
        }
    }

    if(this.ViewController && this.ViewController.Id && this.ViewController.Id === "QoEDashboard")
    {
        let storedPageSize = this.GetStoredPageSize();

        if(storedPageSize)
            this.Views.Size.setValue(storedPageSize)
    }
};

QoESeriesChartReportWidget.prototype.Destroy = function ()
{
    if(this.DataSignalSubscription)
        this.DataSignalSubscription.unsubscribe();

    if(this.ViewModel)
        this.ViewModel.UnRegisterReport(this.Id);

    this.ViewModel = null;

    if(this.CacheMonitor)
        this.CacheMonitor.Destroy();

    if(this.ExcelExportWidget)
        this.ExcelExportWidget.Destroy();
};

QoESeriesChartReportWidget.prototype.DataSignal = function (Updated)
{
    if(!Updated)
        return;

    if(this.ReportsSettingsManager && this.ReportsSettingsManager.ReportsSettings[this.Id])
    {
        this.DefineChartType(true);
        this.DefineChartScale();
    }

    var _this = this;

    var config = this.ViewModel.GetReportConfig(this.Id);

    var conf = config.config;

    var series = [];

    let seriesItems = [];

    var colors = Helper.DictToArr(ColorsDic);

    var colorIndex = 0;

    if(config.data && config.data.rows && config.data.rows.length)
    {
        if(this.ChartScale === ChartScalesDic.logarithmic.id)
            config.data.rows = this.NormalizeForLog(config.data.rows, this.labelKey, this.MinChartValue);

        var cols = Object.keys(config.data.rows[0]);

        if(cols && cols.length)
        {
            cols.forEach(function (Key, I)
            {
                if(Key == _this.labelKey)
                    return;

                var alias = Key;

                var textAlias = Helper.IsBase64Safe(alias) ? Helper.DecodeBase64Safe(alias) : (Helper.IsBase64(alias) ? Helper.Atou(alias) : alias);

                series.push({
                    value:"#"+alias+"#",
                    text:textAlias,
                    color:colors[colorIndex].value,
                    line:{
                        color:colors[colorIndex].value
                    },
                    item:{
                        radius:0
                    },
                    tooltip:
                        {
                        template: function (Obj)
                        {
                            var x = _this.yAxisTemplate.template ? _this.xAxisTemplate.template(Obj) : "";

                            var r = textAlias + ": ";
                            r += x ? x + " - " : "";
                            r += _this.yAxisTemplate.template ? _this.yAxisTemplate.template(Obj[alias]) : Obj[alias];
                            return r;
                        }
                    }
                });

                seriesItems.push(QoESeriesChartSerieItemModel({
                    value: alias,
                    name: textAlias,
                    color: colors[colorIndex].value,
                    isEnable: 1
                }));

                colorIndex++;

                if(colorIndex > colors.length - 1)
                    colorIndex = 0;
            });
        }
    }

    if(!conf.online || (config.data && config.data.cache_id)) {
        this.Views.Chart.removeAllSeries();
        this.RefreshUIElements(config.data);
    }

    if(this.Views.ChartRange)
        this.Views.ChartRange.removeAllSeries();

    series.forEach(function (Serie)
    {
        _this.Views.Chart.addSeries(Serie);

        if(_this.Views.ChartRange)
            _this.Views.ChartRange.addSeries(Serie);

    });

    var legend;

    if(this.LegendIsVisible)
    {
        try
        {
            let view = this.ViewConfig.rows.find(Row => Row.view && Row.view === "chart");


            legend = webix.extend({}, view.legend, true);

            legend.values = series;

            this.Views.Chart.define("legend", legend);
        }
        catch (e) {
            legend = null;
        }
    }
    else
    {
        this.Views.Chart.define("legend", null);
    }

    if(!conf.online || (config.data && config.data.cache_id)) {
        this.Views.Chart.refresh();
        this.Views.Chart.clearAll();
        this.Views.Chart.parse(config.data.rows);
    }

    var refreshChartRange = function ()
    {
        if(!_this.Views.ChartRange.isVisible())
            return;

        try
        {
            _this.Views.ChartRange.setFrameRange({sindex: 0, eindex: 0, start:0, end:0});
        }
        catch(e){}

        _this.Views.ChartRange.clearAll();

        try
        {
            _this.Views.ChartRange.parse(config.data.rows);
        }
        catch(e)
        {

            if(e.name !== 'TypeError')
                throw e;

        }

        if(config.data && config.data.rows && config.data.rows.length)
        {
            var maxFrameIdIndex = 0;

            config.data.rows.forEach(function (Item,Index)
            {
                if(Item.hasOwnProperty(_this.ChartRange.frameId))
                {
                    maxFrameIdIndex = Index;
                }

            });

            _this.Views.ChartRange.setFrameRange({sindex: 0, eindex: maxFrameIdIndex <= 100 ? maxFrameIdIndex : 100, start:0, end:0});
            _this.Views.ChartRange.refresh();
        }
    }

    if(this.Views.ChartRange)
    {
        if(this.Views.ChartRange.isVisible())
            refreshChartRange();
        else
            setTimeout(refreshChartRange, 300);
    }

    this.CacheMonitor.DataSignal(config.data, config.error);

    this.DefineSeriesItems(seriesItems);

    this.RefreshPdfExportConfig();
};

QoESeriesChartReportWidget.prototype.RefreshData = function (Page, Params)
{
    var _this = this;

    var settingsModel = this.ReportsSettingsManager ? this.ReportsSettingsManager.GetSettingsModel(this.Id) : null;

    if(settingsModel)
        settingsModel.ReconfigReportQuery();

    var config = this.ViewModel.GetReportConfig(this.Id);

    var sort = config.config.sort ? config.config.sort : null;

    // var size = config.config.size ? config.config.size : 0;

    var size = this.Views.Size.getValue();

    if (!size)
    {
        const defaultPageSizeStorId = _this.Id + "Size" + "defaultPageSize";
        let storagePageSize = parseInt(localStorage.getItem(defaultPageSizeStorId));

        size = storagePageSize ? storagePageSize : (_this.DefaultPageSize ? _this.DefaultPageSize : 100);
    }

    var page = Page !== null && Page >= 0 ? Page : (this.Views.Paging ? this.Views.Paging.config.page : 0);

    var filter = {};

    if(this.Filter)
    {
        for(var i in this.Filter)
        {
            filter[i] = _this.Filter[i];
        }
    }

    if(Params&&Params.filter)
    {
        this.ExternalFilter = webix.copy(Params.filter);
    }

    webix.extend(filter, this.ExternalFilter, true);

    if(Params&&Params.filter)
    {
        webix.extend(filter, Params.filter, true);
    }

    if(Params && Params.report_id)
    {
        this.ReportId = Params.report_id;
    }

    this.ViewModel.RefreshReportData(this.Id, {
        page:Page,
        filter:filter,
        sort:sort,
        size:size,
        report_settings: settingsModel ? settingsModel.GetReportSettings() : null,
        max_execution_time: Params&&Params.max_execution_time ? Params.max_execution_time : 0,
        report_id: this.ReportId ? this.ReportId : null
    });
};

QoESeriesChartReportWidget.prototype.Refresh = function ()
{
    if(this.Views.Chart)
        this.Views.Chart.refresh();

    if(this.Views.ChartRange)
        this.Views.ChartRange.refresh();
};

QoESeriesChartReportWidget.prototype.DefineChartType = function (ByReportSettings = false)
{
    this.ChartType = this.Views.ChartType.getValue();

    if(ByReportSettings && this.ReportsSettingsManager && this.ReportsSettingsManager.ReportsSettings[this.Id])
    {
        let settingModel = this.ReportsSettingsManager.ReportsSettings[this.Id];

        if(settingModel && settingModel.cur_common_state.graph_line_type)
        {
            if(this.ChartType === settingModel.cur_common_state.graph_line_type)
                return;

            this.Views.ChartType.blockEvent();
            this.Views.ChartType.setValue(settingModel.cur_common_state.graph_line_type);
            this.Views.ChartType.unblockEvent();

            this.ChartType = settingModel.cur_common_state.graph_line_type;
        }
    }

    this.Views.Chart.config.type = this.ChartType;
    this.Views.Chart.define("type", this.ChartType);

    if(this.Views.ChartRange&&this.ChartType!=="stackedBar")
    {
        this.Views.ChartRange.config.type = this.ChartType;
        this.Views.ChartRange.define("type", this.ChartType);
    }

    this.Refresh();
};

QoESeriesChartReportWidget.prototype.DefineChartScale = function()
{
    if(this.ReportsSettingsManager && this.ReportsSettingsManager.ReportsSettings[this.Id])
    {
        let settingModel = this.ReportsSettingsManager.ReportsSettings[this.Id];

        if(this.ChartScale === settingModel.cur_common_state.chart_scale_type)
            return;

        this.ChartScale = settingModel.cur_common_state.chart_scale_type;

        this.Views.Chart.config.scale = this.ChartScale;
        this.Views.Chart.define("scale", this.ChartScale);

        this.PdfExportConfig.chart_scale_type = this.ChartScale;
        this.Refresh();
    }
};

QoESeriesChartReportWidget.prototype.SetChartType = function ()
{
    this.DefineChartType();

    this.DefineReportSettings();

    this.RefreshData();

    this.SignalChartTypeChanged.next(1);
};

QoESeriesChartReportWidget.prototype.GetExportTitle = function ()
{
    if(this.GetExportTitleCallback)
        return this.GetExportTitleCallback();

    return this.Title;
};

QoESeriesChartReportWidget.prototype.GetExportPdfConfig = function (Config)
{
    this.PdfExportConfig = Config.export_pdf_config ? Config.export_pdf_config : {};

    this.PdfExportConfig.view_type = this.PdfExportConfig.view_type ? this.PdfExportConfig.view_type : "chart";
    this.PdfExportConfig.name = this.PdfExportConfig.name ? this.PdfExportConfig.name : Config.name;
    this.PdfExportConfig.series_config = this.PdfExportConfig.series_config ? this.PdfExportConfig.series_config : [];
    this.PdfExportConfig.locales = this.PdfExportConfig.locales ? this.PdfExportConfig.locales : {};
    this.PdfExportConfig.chart_scale_type = this.PdfExportConfig.chart_scale_type ? this.PdfExportConfig.chart_scale_type : this.ChartScale;
};

QoESeriesChartReportWidget.prototype.RefreshPdfExportConfig = function (Params = null)
{
    let chartType = this.Views.ChartType.getValue();

    this.PdfExportConfig.chart_type = chartType;
    this.PdfExportConfig.view_type = ["stackedBar", "bar"].indexOf(chartType) !== -1 ? "bar_chart" : "chart";
    this.PdfExportConfig.series_config = this.SeriesItems;
    this.PdfExportConfig.chart_scale_type = this.ChartScale;

    if(Params)
        this.PdfExportConfig = webix.extend(this.PdfExportConfig, Params, true);
};

QoESeriesChartReportWidget.prototype.DefineExportPdfConfig = function(Params)
{
    let curLangCode = LangHelper.GetLocale();
    let reverseDic = LangHelper.GetReverseLangDic(curLangCode);

    let chartType = Params && Params.graph_line_type
        ? Params.graph_line_type
        : this.ChartType;
    let scaleType = Params && Params.chart_scale_type ? Params.chart_scale_type : this.ChartScale;
    let chartOrderBy = Params && Params.chart_order_by ? Params.chart_order_by : this.DefaultKeyOrderBy;
    let seriesConfig = [];

    if(this.Config && this.Config.values)
    {
        this.Config.values.forEach(item => {

            let value = item.alias ? item.alias : item;

            if(Helper.IsBase64Safe(value))
                value = Helper.DecodeBase64Safe(value)

            let langKeys = LangHelper.SearchLangKeys(value, reverseDic);

            if(langKeys.length)
                value = LangHelper.GetStringByLangKeys(curLangCode, langKeys);

            seriesConfig.push({id: item.alias, name: value, value: item.alias, isEnable: 1});
        });

        if(Params.enable_series)
        {
            seriesConfig.map((item, idx) => {
                item.isEnable = Params.enable_series.includes(item.value) ? 1 : 0;
            });
        }
    }

    let params = {
        series_config: seriesConfig,
        chart_type: chartType,
        view_type: ["stackedBar", "bar"].indexOf(chartType) !== -1 ? "bar_chart" : "chart",
        chart_scale_type: scaleType
    }

    if(chartOrderBy)
    {
        let axisParams = QoESeriesChartAxisTemplatesMap[chartOrderBy];

        if(axisParams && axisParams.template) {
            params.units = axisParams.units;
            params.divider = axisParams.divider;
        }
    }

    params = webix.extend(Params, params, true);
    this.PdfExportConfig = webix.extend(this.PdfExportConfig, params, true);
};

QoESeriesChartReportWidget.prototype.Reconfig = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.DataSignalSubscription.unsubscribe();
    this.ViewModel.UnRegisterReport(this.Id);

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.ViewModel.RegisterReport({
        id:this.Id,
        config:this.Config
    });

    this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.Id).signal.subscribe(function (Updated)
    {
        _this.DataSignal(Updated);
    });
};

QoESeriesChartReportWidget.prototype.GetCachesIds = function ()
{
    return this.CacheMonitor && this.CacheMonitor.LastCacheId ? [this.CacheMonitor.LastCacheId] : null;
};

QoESeriesChartReportWidget.prototype.GetReportConfig = function ()
{
    return this.ViewModel.GetReportConfig(this.Id);
};

QoESeriesChartReportWidget.prototype.SetReportConfig = function (ReportConfig)
{
    return this.ViewModel.RegisterReport(ReportConfig);
};

QoESeriesChartReportWidget.prototype.RefreshUIByReportSettings = function()
{
    if(this.ReportsSettingsManager && this.ReportsSettingsManager.ReportsSettings[this.Id])
    {
        this.DefineSeriesItems();
        this.DefineChartType(true);
    }
};

QoESeriesChartReportWidget.prototype.DefineSeriesItems = function(SeriesItems = null)
{
    if(SeriesItems)
    {
        this.SeriesItems = this.SeriesItems.length ? this.SeriesItems : SeriesItems;
        this.SeriesItems = this.SeriesItems.filter(item => SeriesItems.map(item => item.value).includes(item.value));
    }

    if(this.ReportsSettingsManager && this.ReportsSettingsManager.ReportsSettings[this.Id])
    {
        let settingModel = this.ReportsSettingsManager.ReportsSettings[this.Id];

        if(settingModel && settingModel.cur_common_state.enable_series)
        {
            let enableSeries = settingModel.cur_common_state.enable_series;

            this.SeriesItems.map((item, idx) => {
                item.isEnable = enableSeries.includes(item.value) ? 1 : 0;
            });
        }
    }

    this.SeriesItems.map((item, idx) => {
        if(this.Views.Chart.isVisible())
        {
            if(item.isEnable)
                this.Views.Chart.showSeries(idx);
            else
                this.Views.Chart.hideSeries(idx);
        }
    });
};

QoESeriesChartReportWidget.prototype.GetSeriesItems = function()
{
    let result = [];

    if (this.Config && this.Config.values)
    {
        this.Config.values.forEach(item => {
            let serieId = item.alias ? item.alias : item.col;
            result.push({
                id: serieId,
                value: Helper.IsBase64Safe(serieId) ? Helper.DecodeBase64Safe(serieId) : serieId
            });
        });
    }

    return result;
};

QoESeriesChartReportWidget.prototype.DefineReportSettings = function()
{
    if(this.ReportsSettingsManager && this.ReportsSettingsManager.ReportsSettings[this.Id])
    {
        let settingModel = this.ReportsSettingsManager.ReportsSettings[this.Id];

        let curSettingsState = webix.copy(settingModel.cur_common_state);

        if(curSettingsState.hasOwnProperty("enable_series"))
            curSettingsState.enable_series = this.SeriesItems
                .filter(item => item.isEnable)
                .map(item => item.value)

        if(curSettingsState.hasOwnProperty("graph_line_type"))
            curSettingsState.graph_line_type = this.Views.ChartType.getValue();

        settingModel.cur_common_state = curSettingsState;
        settingModel.SaveSettings();
    }
};

QoESeriesChartReportWidget.prototype.RefreshUIElements = function (Config)
{
    if(Config.totals)
        this.Views.Chart.data.totals = Config.totals;

    if(Config.count)
        this.Views.Chart.data.rows_count = Config.count;

    this.Views.Size.setValue(Config.size);

    var countRows = parseInt(Config.count, 10);
    var pageNumber = parseInt(Config.page, 10);
    var sizePage = parseInt(Config.size, 10);

    var rowsFrom = countRows ? sizePage*pageNumber + 1 : 0;

    var rowsTo = sizePage*(pageNumber + 1);

    rowsTo = countRows < rowsTo ? countRows : rowsTo;

    var sizeInfoLabel = ""+rowsFrom+"-"+rowsTo+" "+LangHelper.GetString("QoE", "Of").toLowerCase()+" "+countRows;
    this.Views.SizeInfo.define("label", sizeInfoLabel);
    this.Views.SizeInfo.define("tooltip", sizeInfoLabel);

    this.Views.Paging.define({
        page:Config.page,
        size:Config.size,
        count:Config.count
    });

    this.Views.Paging.refresh();

    this.Views.SizeInfo.refresh();
};

QoESeriesChartReportWidget.prototype.GetStoredPageSize = function()
{
    let value = null;

    let oldPostfix = "SizedefaultPageSize";
    let newPostfix = "StoredChartPageSize";

    let isDashboard = this.Name && this.ViewController && this.ViewController.Id && this.ViewController.Id === "QoEDashboard" ? true : false;

    let key = this.Id + newPostfix;

    if(isDashboard)
    {
        let dashboardId = this.ViewController.GetSelectedDashboardId();

        if(dashboardId)
            key = "Dashboard" + dashboardId + this.Name + newPostfix;
    }

    let storedData = App.SessionManager.GetPreference(key, false)

    if(isNaN(parseInt(storedData)) && !isDashboard)
        storedData = localStorage.getItem(this.Id + oldPostfix);

    if(!isNaN(parseInt(storedData)))
        value = parseInt(storedData);

    if(value && value < 0)
        value = value * -1;

    return value;
};

QoESeriesChartReportWidget.prototype.SetStoredPageSize = function(Value)
{
    let value = Value;
    let postfix = "StoredChartPageSize";

    let key = this.Id + postfix;

    if(this.Name && this.ViewController && this.ViewController.Id && this.ViewController.Id === "QoEDashboard")
    {
        let dashboardId = this.ViewController.GetSelectedDashboardId();

        if(dashboardId)
            key = "Dashboard" + dashboardId + this.Name + postfix;
    }

    if(!isNaN(parseInt(value)))
    {
        App.SessionManager.SetPreference(key, value, false)
    }
};

QoESeriesChartReportWidget.prototype.NormalizeForLog = function(Rows, LabelKey, ValueIfZero = null)
{
    if(!Array.isArray(Rows) || !Rows.length)
        return Rows;

    let minVal = (Number.isFinite(ValueIfZero) && ValueIfZero > 0) ? ValueIfZero : Infinity;

    if(minVal === Infinity)
    {
        Rows.forEach(Item => {
            Object.keys(Item).forEach(Key => {
                if(Key === LabelKey || Key === "time_step")
                    return;

                const value = Number(Item[Key]);
                if(Number.isFinite(value) && value > 0 && value < minVal)
                    minVal = value;
            });
        });

        if(!Number.isFinite(minVal))
            minVal = 1;
    }

    Rows.forEach(Item => {
        Object.keys(Item).forEach(Key => {
            if(Key === LabelKey || Key === "time_step")
                return;

            const value = Number(Item[Key]);

            if(!Number.isFinite(value) || value <= 0)
                Item[Key] = minVal;
            else
                Item[Key] = value;
        });
    });

    return Rows;
};

QoESeriesChartReportWidget.prototype.DefineAxisTemplate = function(Axis = "yAxis", Key = null)
{
    let params = QoESeriesChartAxisTemplatesMap[Key];

    if(params && params.template)
    {
        if(this.Views && this.Views.Chart) {
            this.Views.Chart.define(Axis, {template: params.template});
            this.Views.Chart.refresh();
        }

        if(Axis === "yAxis" && params.units && params.divider)
            this.RefreshPdfExportConfig({units: params.units, divider: params.divider});
    }
    else
    {
        if(this.Views && this.Views.Chart) {
            this.Views.Chart.define(Axis, {template: undefined});
            this.Views.Chart.refresh();
        }

        if(Axis === "yAxis")
            this.RefreshPdfExportConfig({units: null, divider: null});
    }
};

QoESeriesChartReportWidget.prototype.DefineOptionsOrderBy = function(TableWidget)
{
    if(Object.values(this.OptionsOrderBy).length)
        return;

    this.OptionsOrderBy = {};

    let _this = this;
    let sortCols = [];
    let conditionCol, tableHeaders, enumKey;

    if(Helper.HasCols(this.Config)) {
        if(this.Config.cols[0].col)
            conditionCol = this.Config.cols[0].col;
    }

    if(Helper.IsTableWidget(TableWidget))
    {
        if(Helper.HasValues(TableWidget.Config))
            TableWidget.Config.values.forEach(Item => {
                let key = Item.alias ? Item.alias : Item.col;
                sortCols.push(key);
            });

        if(Helper.HasCols(TableWidget.Config))
            TableWidget.Config.cols.forEach(Item => {
                let key = Item.alias ? Item.alias : Item.col;
                sortCols.push(key);
            });

        tableHeaders = TableWidget.GetTableHeaders();
    }

    if(Helper.HasTable(TableWidget.Config)) {
        const parts = TableWidget.Config.table.split(".");
        enumKey = parts[parts.length - 1];
    }

    if(conditionCol && Array.isArray(tableHeaders))
    {
        let locale = LangHelper.GetLocale();

        sortCols.forEach(Key => {
            let item = tableHeaders.find(i => i.id === Key);
            let sqlTpl = GetQoEReportsSerieChartSqlTpl(conditionCol, Key, enumKey);
            let getTopListFunc = GetQoEReportsSerieChartGetTopListFunc(Key, enumKey);
            if(item && item.header_name && item.header_name[locale] && sqlTpl && getTopListFunc)
                _this.OptionsOrderBy[Key] = {id:Key, value:item.header_name[locale].split(",")[0]};
        });
    }
};

QoESeriesChartReportWidget.prototype.DefineDefaultKeyOrderBy = function(TableWidget)
{
    // already defined — do not recompute
    if(this.DefaultKeyOrderBy)
        return;

    // 1st fallback: try to resolve from table widget sort config
    if(!this.DefaultKeyOrderBy)
    {
        if(Helper.IsTableWidget(TableWidget)) {
            if(Helper.HasSortId(TableWidget.Config))
                this.DefaultKeyOrderBy = TableWidget.Config.sort.id;
        }
    }

    // 2nd fallback: derive from first chart value definition
    if(!this.DefaultKeyOrderBy)
    {
        if(Helper.HasValues(this.Config)) {
            let sortItem = this.Config.values[0];
            let key = sortItem.alias ? sortItem.alias : sortItem.col;

            if(key)
                this.DefaultKeyOrderBy = key;
        }
    }
};
var QoEDateRangePickerRangesEnum =
    {

        "Last 5 minutes":{start:"now/-5 minute", end:"now"},
        "Last 15 minutes":{start:"now/-15 minute", end:"now"},
        "Last 30 minutes":{start:"now/-30 minute", end:"now"},

        "This hour":{start:"now/h", end:"now/h/+1 hour/-1 minute"},
        "This hour so far":{start:"now/h", end:"now"},
        "This 2 hours":{start:"now/h/-1 hour", end:"now/h/+1 hour/-1 minute"},
        "This 2 hours so far":{start:"now/h/-1 hour", end:"now"},
        "This 3 hours":{start:"now/h/-2 hour", end:"now/h/+1 hour/-1 minute"},
        "This 3 hours so far":{start:"now/h/-2 hour", end:"now"},

        "Last 1 hour":{start:"now/-1 hour", end:"now"},
        "Last 2 hours":{start:"now/-2 hour", end:"now"},
        "Last 3 hours":{start:"now/-3 hour", end:"now"},
        "Last 4 hours":{start:"now/-4 hour", end:"now"},
        "Last 5 hours":{start:"now/-5 hour", end:"now"},
        "Last 6 hours":{start:"now/-6 hour", end:"now"},
        "Last 12 hours":{start:"now/-12 hour", end:"now"},
        "Last 24 hours":{start:"now/-24 hour", end:"now"},


        "Last 2 days":{start:"now/-2 day", end:"now"},
        "Last 3 days":{start:"now/-3 day", end:"now"},
        "Last 4 days":{start:"now/-4 day", end:"now"},
        "Last 5 days":{start:"now/-5 day", end:"now"},
        "Last 6 days":{start:"now/-6 day", end:"now"},
        "Last 7 days":{start:"now/-7 day", end:"now"},
        "Last 15 days":{start:"now/-14 day", end:"now"},
        "Last 30 days":{start:"now/-30 day", end:"now"},
        "Last 90 days":{start:"now/-90 day", end:"now"},
        "Last 6 months":{start:"now/-6 month", end:"now"},
        "Last 1 year":{start:"now/-1 year", end:"now"},
        "Last 2 years":{start:"now/-2 year", end:"now"},
        "Last 5 years":{start:"now/-5 year", end:"now"},

        "Yesterday":{start:"now/-1 day/d", end:"now/d/-1 minute"},
        "Day before yesterday":{start:"now/-2 day/d", end:"now/-1 day/d/-1 minute"},
        "This day last week":{start:"now/-7 day/d", end:"now/-6 day/d/-1 minute"},
        "Previous week":{start:"now/-1 week/w", end:"now/w/-1 minute"},
        "Previous month":{start:"now/-1 month/m", end:"now/m/-1 minute"},
        "Previous year":{start:"now/-1 year/y", end:"now/y/-1 minute"},

        "Today":{start:"now/d", end:"now/d/+1 day/-1 minute"},
        "Today so far":{start:"now/d", end:"now"},
        "This week":{start:"now/w", end:"now/w/+1 week/-1 minute"},
        "This week so far":{start:"now/w", end:"now"},
        "This month":{start:"now/m", end:"now/m/+1 month/-1 minute"},
        "This month so far":{start:"now/m", end:"now"},
        "This year":{start:"now/y", end:"now/y/+1 year/-1 minute"},
        "This year so far":{start:"now/y", end:"now"}
    };

function QoEDateRangePickerValueModel(Params)
{
    this.id = Params&&Params.id?Params.id:"";

    this.start = Params&&Params.start?Params.start:"";

    this.end = Params&&Params.end?Params.end:"";
};

function QoEDateRangePickerWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.ContextConfig = null;

    this.Context = null;

    this.Views =
        {
            DateRangePicker:null,
            DateRangePanel:null,
            DateFromPicker:null,
            DateToPicker:null,
            DatePickerForm:null,
            QuickRanges:{}

        };

    this.ApplyStateSignal = new Rx.BehaviorSubject(0);

    this.DefaultValue = "This 2 hours";

    this.IsWidgetEnabled = true;

    this.Init(ViewConfig);
}

QoEDateRangePickerWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    var dateFrom = {
        view:"datepicker",
        name: "date_from_picker",
        id:_this.Id+"DateFromPicker",
        label:LangHelper.GetString("QoE", "Start"),
        labelPosition:"top",
        timepicker:true,
        editable: true,
        format: this.GetDateTimeFormat(),
        placeholder: webix.Date.dateToStr(this.GetDateTimeFormat())(new Date(new Date().getTime() - (1 * 60 * 60 * 1000))),
        validate: function (Value) {
            return Helper.ValidateDateTimeInput(Value);
        },
        invalidMessage: LangHelper.GetString("QoE", "Enter valid date, example: ") +
            webix.Date.dateToStr(this.GetDateTimeFormat())(new Date(new Date().getTime() - (1 * 60 * 60 * 1000)))
    };

    var dateTo = {
        view:"datepicker",
        name: "date_to_picker",
        id:_this.Id+"DateToPicker",
        label:LangHelper.GetString("QoE", "End"),
        labelPosition:"top",
        timepicker:true,
        editable: true,
        format: this.GetDateTimeFormat(),
        placeholder: webix.Date.dateToStr(this.GetDateTimeFormat())(new Date()),
        validate: function (Value) {
            return Helper.ValidateDateTimeInput(Value);
        },
        invalidMessage: LangHelper.GetString("QoE", "Enter valid date, example: ") +
            webix.Date.dateToStr(this.GetDateTimeFormat())(new Date())
    };

    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
    {
        dateFrom.view = "spectre_datepicker";
        dateTo.view = "spectre_datepicker";

        delete dateFrom.labelPosition;
        delete dateTo.labelPosition;
    }

    this.ContextConfig = function () 
    {
        var config;

        var datepickerForm = function ()
        {
            var form = {
                view:"form",
                id: _this.Id + "DatePickerForm",
                //borderless:true,
                elements:[
                    dateFrom,
                    dateTo,
                    {}
                ]
            };

            if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
            {
                form.type = "wide";
                form.height = 115;
            }

            return form;
        }();

        var quickSelectForm = function()
        {
            var form = {
                view:"form",
                //borderless:true,
                elements:[
                    {
                        rows:[
                            {
                                cols:[
                                    {
                                        view:"list",
                                        id:_this.Id + "Last 5 minutes - Last 24 hours",
                                        css:"height24",
                                        type:{height:24},
                                        data:function (){
                                            var arr = Helper.EnumToArr(QoEDateRangePickerRangesEnum, "Last 5 minutes", "Last 24 hours");

                                            arr.forEach(function (Val) {
                                                Val.value = LangHelper.GetString("QoE", Val.value);
                                            });

                                            return arr;
                                        }(),
                                        select:true,
                                        tooltip: function(obj, common) {
                                            return obj.value;
                                        }
                                    },
                                    {
                                        view:"list",
                                        id:_this.Id + "Last 2 days - Last 5 years",
                                        css:"height24",
                                        type:{height:24},
                                        data:function (){
                                            var arr = Helper.EnumToArr(QoEDateRangePickerRangesEnum, "Last 2 days", "Last 5 years");

                                            arr.forEach(function (Val) {
                                                Val.value = LangHelper.GetString("QoE", Val.value);
                                            });

                                            return arr;
                                        }(),
                                        select:true,
                                        tooltip: function(obj, common) {
                                            return obj.value;
                                        }
                                    },
                                    {
                                        view:"list",
                                        id:_this.Id + "Yesterday - Previous year",
                                        css:"height24",
                                        type:{height:24},
                                        data:function (){
                                            var arr = Helper.EnumToArr(QoEDateRangePickerRangesEnum, "Yesterday", "Previous year");

                                            arr.forEach(function (Val) {
                                                Val.value = LangHelper.GetString("QoE", Val.value);
                                            });

                                            return arr;
                                        }(),
                                        select:true,
                                        tooltip: function(obj, common) {
                                            return obj.value;
                                        }
                                    },
                                    {
                                        view:"list",
                                        id:_this.Id + "Today - This year so far",
                                        css:"height24",
                                        type:{height:24},
                                        data:function (){
                                            var arr = Helper.EnumToArr(QoEDateRangePickerRangesEnum, "Today", "This year so far");

                                            arr.forEach(function (Val) {
                                                Val.value = LangHelper.GetString("QoE", Val.value);
                                            });

                                            return arr;
                                        }(),
                                        select:true,
                                        tooltip: function(obj, common) {
                                            return obj.value;
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            };

            return form;
        }();

        var cancelBtn = function(){
            var btn = {
                view: "button",
                label: LangHelper.GetString("All", "Cancel"),
                click: function ()
                {
                    _this.ResetState();

                    _this.Context.hide();
                }
            };

            if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
            {
                btn.view = "spectre_button";
                btn.css = "form_button third_action";
            }

            return btn;
        }();

        var applyBtn = function(){
            var btn = {
                view: "button",
                label: LangHelper.GetString("All", "Apply"),
                click: function ()
                {
                    _this.ApplyState();

                    _this.Context.hide();
                }
            };

            if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
            {
                btn.view = "spectre_button";
                btn.css = "form_button main_action";
            }
            else
            {
                btn.type = "form";
            }

            return btn;
        }();

        var layout = function()
        {

            var layout = {
                borderless:true,
                rows:[
                    {
                        cols:[
                            {
                                rows:[
                                    BlockHeaderTemplate({title: LangHelper.GetString("QoE","Custom range"), icon: "calendar"}),
                                    datepickerForm
                                ]
                            },
                            {view:"resizer"},
                            {
                                gravity:4,
                                rows:[
                                    BlockHeaderTemplate({title: LangHelper.GetString("QoE","Quick ranges"), icon: "list"}),
                                    quickSelectForm
                                ]
                            }
                        ]
                    },
                    {
                        view:"form",
                        elements:[
                            {
                                cols:[
                                    {
                                        gravity:2
                                    },
                                    cancelBtn,
                                    applyBtn
                                ]
                            }
                        ]
                    }
                ]
            };

            if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
            {
                // layout = {
                //     view:"scrollview",
                //     scroll:"y",
                //     borderless:true,
                //     body:
                // };

                layout = {
                    borderless:true,
                    type:"space",
                    rows:[
                        {
                            type:"clean",
                            borderless:true,
                            rows:[
                                BlockHeaderTemplate({
                                    title: LangHelper.GetString("QoE","Custom range"), icon: "",
                                    borderless:true
                                }),
                                {height:20},
                                datepickerForm,
                                {height:20},
                                BlockHeaderTemplate({
                                    title: LangHelper.GetString("QoE","Quick ranges"), icon: "",
                                    borderless:true
                                }),
                                quickSelectForm,
                                {
                                    type:"wide",
                                    cols:[
                                        applyBtn,
                                        cancelBtn,
                                        {}
                                    ]
                                }
                            ]
                        }
                    ]
                };
            }

            return layout;
        }();

        config = {
            view: "popup",
            id:_this.Id + "Context",
            maxWidth: 1244,
            maxHeight: 800,
            //autoHeight:true,
            resize: true,
            modal:true,
            body: layout
        };

        return config;
    }();

    this.ViewConfig =
        {
            view:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? "spectre_text" : "search",
            id:this.Id + "DateRangePicker",
            label:LangHelper.GetString("QoE", "Period"),
            icon:"calendar",
            value:"",
            readonly:true
        };

    this.Value = null;
    this.AppliedValue = null;

    this.DefaultValue = ViewConfig.default_value ? ViewConfig.default_value : this.DefaultValue;

};

QoEDateRangePickerWidget.prototype.Bind = function (ViewController)
{
    var _this = this;

    this.Context = webix.ui(this.ContextConfig);

    this.Views.DateFromPicker = $$(this.Id + "DateFromPicker");
    this.Views.DateToPicker = $$(this.Id + "DateToPicker");

    this.Views.DateRangePicker = $$(this.Id + "DateRangePicker");
    this.Views.DatePickerForm = $$(this.Id + "DatePickerForm");

    this.Views.QuickRanges["Last 5 minutes - Last 24 hours"] = $$(this.Id + "Last 5 minutes - Last 24 hours");
    this.Views.QuickRanges["Last 2 days - Last 5 years"] = $$(this.Id + "Last 2 days - Last 5 years");
    this.Views.QuickRanges["Yesterday - Previous year"] = $$(this.Id + "Yesterday - Previous year");
    this.Views.QuickRanges["Today - This year so far"] = $$(this.Id + "Today - This year so far");


    Object.keys(this.Views.QuickRanges).forEach(function (Key) {
        _this.Views.QuickRanges[Key].attachEvent("onAfterSelect", function (Id)
        {

            _this.SetValue(new QoEDateRangePickerValueModel({id:Id}));

        });
    });

    this.Views.DateRangePicker.attachEvent("onItemClick", function(Cv, Pv)
    {
        _this.SetValue(_this.AppliedValue);
        _this.Show();
    });

    this.Views.DateFromPicker.attachEvent("onChange", function(Val)
    {
        _this.ValidateEnteredInput('DateFromPicker');
    });

    this.Views.DateFromPicker.attachEvent("onBlur", function(Val)
    {
        _this.ValidateEnteredInput('DateFromPicker');
    });

    this.Views.DateToPicker.attachEvent("onChange", function(Val)
    {
        _this.ValidateEnteredInput('DateToPicker');
    });

    this.Views.DateToPicker.attachEvent("onBlur", function(Val)
    {
        _this.ValidateEnteredInput('DateToPicker');
    });

    // var date_from = Helper.RoundDateToMinutes(new Date());
    // var date_to = Helper.RoundDateToMinutes(new Date());
    // this.Views.DateRangePicker.setValue({start:webix.Date.add(date_from,-6,"hour"), end:webix.Date.add(date_to,1,"hour")});
};

QoEDateRangePickerWidget.prototype.Destroy = function ()
{

};

QoEDateRangePickerWidget.prototype.ApplyState = function (Silent)
{
    var changed = JSON.stringify(this.AppliedValue) !== JSON.stringify(this.Value) ? true : false;

    this.AppliedValue = this.Value;

    var format =  webix.Date.dateToStr(webix.i18n.fullDateFormat);

    this.Views.DateRangePicker.setValue(format(this.AppliedValue.start) + " - " + format(this.AppliedValue.end));

    if(!Silent && changed)
        this.ApplyStateSignal.next(1);
};

QoEDateRangePickerWidget.prototype.ResetState = function ()
{

};

QoEDateRangePickerWidget.prototype.PrepereQuickRange = function (RangeId)
{
    var range = QoEDateRangePickerRangesEnum[RangeId];
    var dateFrom = this.ParseRangeDate(range.start);
    var dateTo = this.ParseRangeDate(range.end);

    return new QoEDateRangePickerValueModel({id:RangeId, start:dateFrom, end:dateTo});
};

QoEDateRangePickerWidget.prototype.ParseRangeDate = function (Str)
{
    var date = null;

    var parts = Str.split("/");

    parts.forEach(function (part)
    {
        if(part == "now")
        {
            date = Helper.RoundDateToSeconds(new Date());
        }
        else if(part.charAt(0) == "-" || part.charAt(0) == "+")
        {
            var partsParts = part.split(" ");

            date = webix.Date.add(date,parseInt(partsParts[0],10),partsParts[1]);
        }
        else if(part == "h")
        {
            date = Helper.RoundDateToMinutes(date);
        }
        else if(part == "d")
        {
            date = Helper.RoundDateToDay(date);
        }
        else if(part == "w")
        {
            date = Helper.RoundDateToWeek(date);
        }
        else if(part == "m")
        {
            date = Helper.RoundDateToMonth(date);
        }
        else if(part == "y")
        {
            date = Helper.RoundDateToYear(date);
        }
    });

    return date;
};

QoEDateRangePickerWidget.prototype.UnselectQuickRange = function (RangeId)
{
    var _this = this;

    Object.keys(this.Views.QuickRanges).forEach(function (Key)
    {
        if(!_this.Views.QuickRanges[Key].exists(RangeId))
        {
            _this.Views.QuickRanges[Key].blockEvent();
            _this.Views.QuickRanges[Key].unselectAll();
            _this.Views.QuickRanges[Key].unblockEvent();
        }

    });
};

QoEDateRangePickerWidget.prototype.SelectQuickRange = function (RangeId)
{
    var _this = this;

    Object.keys(this.Views.QuickRanges).forEach(function (Key)
    {
        if(_this.Views.QuickRanges[Key].exists(RangeId))
        {
            if(!_this.Views.QuickRanges[Key].isSelected(RangeId))
            {
                _this.Views.QuickRanges[Key].blockEvent();
                _this.Views.QuickRanges[Key].select (RangeId);
                _this.Views.QuickRanges[Key].unblockEvent();
            }
        }
    });
};

QoEDateRangePickerWidget.prototype.SetValue = function (ValueModel, AutoApply, DefaultValue)
{
    var model = ValueModel;

    if(!model)
    {
        model = new QoEDateRangePickerValueModel({id: DefaultValue ? DefaultValue : this.DefaultValue, start:null, end:null});
    }

    this.UnselectQuickRange(model.id);
    this.SelectQuickRange(model.id);

    if(QoEDateRangePickerRangesEnum[model.id])
    {
        var model = this.PrepereQuickRange(model.id);

        this.Views.DateFromPicker.blockEvent();
        this.Views.DateFromPicker.setValue(model.start);
        this.Views.DateFromPicker.unblockEvent();

        this.Views.DateToPicker.blockEvent();
        this.Views.DateToPicker.setValue(model.end);
        this.Views.DateToPicker.unblockEvent();
    }
    else
    {
        if(model.start)
        {
            this.Views.DateFromPicker.blockEvent();
            this.Views.DateFromPicker.setValue(model.start);
            this.Views.DateFromPicker.unblockEvent();
        }

        if(model.end)
        {
            this.Views.DateToPicker.blockEvent();
            this.Views.DateToPicker.setValue(model.end);
            this.Views.DateToPicker.unblockEvent();
        }
    }

    this.Value = model;

    if(AutoApply)
        this.ApplyState(true);
};

QoEDateRangePickerWidget.prototype.GetValue = function (ToUtc)
{
    if(ToUtc)
    {
        var value = webix.copy(this.AppliedValue);
        if(value.start)
        {
            value.start = Helper.LocalDateTimeToUtc(value.start);
        }
        if(value.end)
        {
            value.end = Helper.LocalDateTimeToUtc(value.end);
        }
        return new QoEDateRangePickerValueModel(value);
    }
    return new QoEDateRangePickerValueModel(this.AppliedValue);
};

QoEDateRangePickerWidget.prototype.Show = function (Node, Pos)
{
    var node = Node ? Node : this.Views.DateRangePicker.getNode();
    var pos = Pos ? Pos : "bottom";

    this.Context.show(node,{pos:pos});
};

QoEDateRangePickerWidget.prototype.ValidateEnteredInput = function (Input) {
    let _this = this;

    let params = {
        id:"custom",
        start:_this.Value.start,
        end:_this.Value.end
    }

    let inputValue = _this.Views[Input].getValue();

    if (Input === 'DateFromPicker')
        params.start = inputValue
    else if (Input === 'DateToPicker')
        params.end = inputValue

    if(_this.Views[Input].validate(inputValue))
        _this.SetValue(new QoEDateRangePickerValueModel(params));
}

QoEDateRangePickerWidget.prototype.GetDateTimeFormat = function()
{
    let format = "%d.%m.%Y %H:%i";

    if(typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin())
        format = DateFormatDic[App.Locale].datetime_format

    return format
}

QoEDateRangePickerWidget.prototype.DisableWidget = function()
{
    this.IsWidgetEnabled = false;

    if(this.Views.DateRangePicker)
        this.Views.DateRangePicker.disable();
};
var QoEFilterOperatorsEnum =
{
    "=":"=",
    "!=":"!=",
    "like":"like",
    "ilike":"ilike",
    "not like":"not like",
    "match":"match",
    "not match":"not match",
    ">":">",
    ">=":">=",
    "<":"<",
    "<=":"<=",
    "in":"in",
    "not in":"not in",
    "between":"between",
    "not between":"not between",
    "in CIDRs":"in CIDRs",
    "not in CIDRs":"not in CIDRs"
};

var QoEFilterOperatorsTypesEnum =
{
    bitwise:"bitwise",
    appproto:"appproto"
};

var QoEFilterSqlType =
{
    where:"where",
    having:"having"
};

var QoEFilterValueType =
{
    String:"String",
    UInt8:"UInt8",
    UInt16:"UInt16",
    UInt32:"UInt32",
    UInt64:"UInt64",
    Float32:"Float32",
    Float64:"Float64"
};

var QoEPopupFilterWidgetConfigTypeEnum =
    {
        QoEFullNetFlow:"QoEFullNetFlow",
        QoEClickstream:"QoEClickstream",
        QoEFullnetflowLogs:"QoEFullnetflowLogs",
        QoERawClickstreamLogs:"QoERawClickstreamLogs",
        QoERawFullNetFlow:"QoERawFullNetFlow",
        QoERawFullGtpFlow: "QoERawFullGtpFlow",
        QoEFullGtpFlow: "QoEFullGtpFlow",
        QoERawFullNatFlow:"QoERawFullNatFlow",
        QoEOnlineNetFlow:"QoEOnlineNetFlow",
        QoEDashboards:"QoEDashboards",
        QoERawFullDnsFlow: "QoERawFullDnsFlow",
        QoEFullDnsFlow: "QoEFullDnsFlow",
        QoEFullDdosAttackFlow: "QoEFullDdosAttackFlow",
        QoERawFullDdosAttackFlow: "QoERawFullDdosAttackFlow",
    };

var QoEPopupFilterBitMaskEditorConfig = {
    setValue: function(Val) {
        const options = this.config.collection.serialize().map(Item => parseInt(Item.id));
        let val;

        if(Val === '0' && options.includes(parseInt(Val))) {
            val = '0x0';
        } else {
            val = Helper.BitMaskToArray(Val, options, "hex").join(",");
        }

        webix.editors.multiselect.setValue.call(this, val);
    },
    getValue: function() {
        const val = webix.editors.multiselect.getValue.call(this);
        return val ? val.split(",")
            .map(Item => parseInt(Item))
            .filter(Item => !isNaN(Item))
            .reduce((Acc, Item) => Acc | Item, 0)
            .toString(10) : "";
    }
};

function QoEFilterModel(Params)
{
    this.id = Params&&Params.id?Params.id:"";

    this.operator = Params&&Params.operator?Params.operator:"=";

    this.operator_type = Params&&Params.operator_type?Params.operator_type:"";

    this.value = Params&&Params.value?Params.value:"";

    this.sql_type =  Params&&Params.sql_type?Params.sql_type:QoEFilterSqlType.where;

    this.type =  Params&&Params.type?Params.type:QoEFilterValueType.String;

    this.view = Params&&Params.view?Params.view:"";
};

function QoEPopupFilterWidgetFilterRowModel(Params)
{
    this.id = webix.uid();

    this.f_enabled = Params&&Params.f_enabled?Params.f_enabled:0;

    this.f_id = Params&&Params.f_id?Params.f_id:"";

    this.f_operator = Params&&Params.f_operator?Params.f_operator:"";

    this.f_value = Params&&Params.f_value?Params.f_value:"";

    this.f_value_type = Params&&Params.f_value_type?Params.f_value_type:QoEFilterValueType.String;

    this.f_value_editor = Params&&Params.f_value_editor?Params.f_value_editor:"text";
};

function QoEPopupFilterWidgetDefaultConfig(Type, Strict = false)
{
    let type;

    if(Strict)
        type = Type;
    else
        type = Type ? Type : QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;

    var config = {
        QoEFullNetFlow:{
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow,
            type:QoESubscribersFilterListItemTypeEnum.hist_netflow,
            filters:[
                {
                    id:"host",
                    title:LangHelper.GetString("QoE", "Host"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"subscriber",
                    title:LangHelper.GetString("QoE", "Subscriber"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"login",
                    title:LangHelper.GetString("QoE", "Login"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"host_ip",
                    title:LangHelper.GetString("QoE", "Host IP"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"net_protocol",
                    title:LangHelper.GetString("QoE", "Protocol"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"app_protocol_group_id",
                    title:LangHelper.GetString("QoE", "App protocols groups"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic:DicsEnum.ProtocolsGroupsDic
                },
                {
                    id:"protocol",
                    title:LangHelper.GetString("QoE", "Application protocol"),
                    operator_type: QoEFilterOperatorsTypesEnum.appproto,
                    type:QoEFilterValueType.String
                },
                {
                    id:"source_asnum",
                    title:LangHelper.GetString("QoE", "Subscriber`s AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"destination_asnum",
                    title:LangHelper.GetString("QoE", "Host`s AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"host_category",
                    title:LangHelper.GetString("QoE", "Host category"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic:DicsEnum.HostCategoriesDic
                },
                {
                    id:"host_category_code",
                    title:LangHelper.GetString("QoE", "Infected traffic category"),
                    type:"string",
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic: DicsEnum.InfectedHostCategoriesDic
                },
                {
                    id:"bridge_vchannel",
                    title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                    type:"string"
                },
                {
                    id:"post_nat_source_ipv4",
                    title:LangHelper.GetString("QoE", "Post nat source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"post_nat_source_port",
                    title:LangHelper.GetString("QoE", "Post nat source port"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"ip_class_of_service_class",
                    title:LangHelper.GetString("QoE", "Class"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"ip_class_of_service_full",
                    title:LangHelper.GetString("QoE", "DSCP"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"from_subscriber",
                    title:LangHelper.GetString("QoE", "Traffic direction"),
                    editor:"richselect",
                    options: Helper.DictToArr(TrafficDirectionDic),
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"mpls_labels",
                    title:LangHelper.GetString("QoE", "MPLS labels"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"blocked",
                    title:LangHelper.GetString("QoE", "Locked"),
                    type:QoEFilterValueType.UInt8,
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    editor:"richselect",
                    options:Helper.DictToArr(YesNoDic)
                },
                {
                    id:"tethering",
                    title:LangHelper.GetString("QoE", "Tethering"),
                    type:QoEFilterValueType.UInt8,
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    editor:"richselect",
                    options:Helper.DictToArr(YesNoDic)
                }
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"host",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"subscriber",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"login",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_ip",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"net_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol_group_id",
                    f_operator:QoEFilterOperatorsEnum.in
                },
                {
                    f_enabled:0,
                    f_id:"protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_asnum",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_asnum",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_category",
                    f_operator:QoEFilterOperatorsEnum.in
                },
                {
                    f_enabled:0,
                    f_id:"host_category_code",
                    f_operator:QoEFilterOperatorsEnum.in
                }
                // {
                //     f_enabled:0,
                //     f_id:"rtt_avg",
                //     f_operator:QoEFilterOperatorsEnum[">="]
                // }
            ]
        },
        QoEOnlineNetFlow:{
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoEOnlineNetFlow,
            type:QoESubscribersFilterListItemTypeEnum.hist_subscribers_online_netflow,
            filters:[
                {
                    id:"session_id",
                    title:LangHelper.GetString("QoE", "Session ID"),
                    type:"string"
                },
                {
                    id:"source_ipv4",
                    title:LangHelper.GetString("QoE", "Source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"source_ipv6",
                    title:LangHelper.GetString("QoE", "Source IPv6-address"),
                    type:"string"
                },
                {
                    id:"source_port",
                    title:LangHelper.GetString("QoE", "Source port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"bgp_source_as_number",
                    title:LangHelper.GetString("QoE", "Subscriber`s AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"destination_ipv4",
                    title:LangHelper.GetString("QoE", "Destination IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"destination_ipv6",
                    title:LangHelper.GetString("QoE", "Destination IPv6-address"),
                    type:"string"
                },
                {
                    id:"destination_port",
                    title:LangHelper.GetString("QoE", "Destination port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"bgp_destination_as_number",
                    title:LangHelper.GetString("QoE", "Host`s AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"net_protocol",
                    title:LangHelper.GetString("QoE", "Net protocol"),
                    type:"string"
                },
                {
                    id:"app_protocol",
                    title:LangHelper.GetString("QoE", "Application protocol"),
                    operator_type: QoEFilterOperatorsTypesEnum.appproto,
                    type:"string"
                },
                {
                    id:"app_protocol_group_id",
                    title:LangHelper.GetString("QoE", "App protocols groups"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic:DicsEnum.ProtocolsGroupsDic
                },
                {
                    id:"login",
                    title:LangHelper.GetString("QoE", "Login"),
                    type:"string"
                },
                {
                    id:"subscriber",
                    title:LangHelper.GetString("QoE", "Subscriber"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"source_asnum",
                    title:LangHelper.GetString("QoE", "Subscriber`s AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"subscriber_port",
                    title:LangHelper.GetString("QoE", "Subscriber`s port"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"host",
                    title:LangHelper.GetString("QoE", "Host"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"destination_asnum",
                    title:LangHelper.GetString("QoE", "Host`s AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"host_port",
                    title:LangHelper.GetString("QoE", "Host`s port"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"host_ip",
                    title:LangHelper.GetString("QoE", "Host IP"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"bridge_vchannel",
                    title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                    type:"string"
                },
                {
                    id:"post_nat_source_ipv4",
                    title:LangHelper.GetString("QoE", "Post nat source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"post_nat_source_port",
                    title:LangHelper.GetString("QoE", "Post nat source port"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"mpls_labels",
                    title:LangHelper.GetString("QoE", "MPLS labels"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"ip_class_of_service_class",
                    title:LangHelper.GetString("QoE", "Class"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"ip_class_of_service_full",
                    title:LangHelper.GetString("QoE", "DSCP"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"blocked",
                    title:LangHelper.GetString("QoE", "Locked"),
                    type:QoEFilterValueType.UInt8,
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    editor:"richselect",
                    options:Helper.DictToArr(YesNoDic)
                }
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"session_id",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"bgp_source_as_number",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"bgp_destination_as_number",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"net_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol_group_id",
                    f_operator:QoEFilterOperatorsEnum.in
                },
                {
                    f_enabled:0,
                    f_id:"login",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"subscriber",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_asnum",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"subscriber_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_asnum",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_ip",
                    f_operator:QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoEClickstream:{
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoEClickstream,
            type:QoESubscribersFilterListItemTypeEnum.hist_clickstream,
            filters:[
                {
                    id:"host",
                    title:LangHelper.GetString("QoE", "Host"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"subscriber",
                    title:LangHelper.GetString("QoE", "Subscriber"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"login",
                    title:LangHelper.GetString("QoE", "Login"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"device",
                    title:LangHelper.GetString("QoE", "Device"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"host_ip",
                    title:LangHelper.GetString("QoE", "Host IP"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"url",
                    title:LangHelper.GetString("QoE", "Url"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"host_category",
                    title:LangHelper.GetString("QoE", "Host category"),
                    type:QoEFilterValueType.String,
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic:DicsEnum.HostCategoriesDic
                },
                {
                    id:"host_category_code",
                    title:LangHelper.GetString("QoE", "Infected traffic category"),
                    type:"string",
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic: DicsEnum.InfectedHostCategoriesDic
                },
                {
                    id:"bridge_vchannel",
                    title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                    type:"string"
                },
                {
                    id:"locked",
                    title:LangHelper.GetString("QoE", "Locked"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    editor:"richselect",
                    options:Helper.DictToArr(YesNoDic)
                },
                {
                    id:"from_subscriber",
                    title:LangHelper.GetString("QoE", "Traffic direction"),
                    editor:"richselect",
                    options: Helper.DictToArr(TrafficDirectionDic),
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    type:QoEFilterValueType.UInt8
                }
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"host",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"subscriber",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"login",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"device",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_ip",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"url",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_category",
                    f_operator:QoEFilterOperatorsEnum.in
                },
                {
                    f_enabled:0,
                    f_id:"host_category_code",
                    f_operator:QoEFilterOperatorsEnum.in
                },
                {
                    f_enabled:0,
                    f_id:"locked",
                    f_operator:QoEFilterOperatorsEnum["="]
                }
            ]
        },
        QoEFullnetflowLogs:{
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoEFullnetflowLogs,
            type:QoESubscribersFilterListItemTypeEnum.hist_logs_netflow,
            filters:[
                {
                    id:"login",
                    title:LangHelper.GetString("QoE", "Login"),
                    type:"string"
                },
                {
                    id:"source_ipv4",
                    title:LangHelper.GetString("QoE", "Source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"source_ipv6",
                    title:LangHelper.GetString("QoE", "Source IPv6-address"),
                    type:"string"
                },
                {
                    id:"source_port",
                    title:LangHelper.GetString("QoE", "Source port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"destination_ipv4",
                    title:LangHelper.GetString("QoE", "Destination IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"destination_ipv6",
                    title:LangHelper.GetString("QoE", "Destination IPv6-address"),
                    type:"string"
                },
                {
                    id:"destination_port",
                    title:LangHelper.GetString("QoE", "Destination port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"host",
                    title:LangHelper.GetString("QoE", "Host"),
                    type:"string"
                },
                {
                    id:"session_id",
                    title:LangHelper.GetString("QoE", "Session ID"),
                    type:"string"
                },
                {
                    id:"net_protocol",
                    title:LangHelper.GetString("QoE", "Net protocol"),
                    type:"string"
                },
                {
                    id:"app_protocol",
                    title:LangHelper.GetString("QoE", "Application protocol"),
                    operator_type: QoEFilterOperatorsTypesEnum.appproto,
                    type:"string"
                },
                {
                    id:"bgp_source_as_number",
                    title:LangHelper.GetString("QoE", "Source AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"bgp_destination_as_number",
                    title:LangHelper.GetString("QoE", "Destination AS number"),
                    type:QoEFilterValueType.UInt32
                }
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"login",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"session_id",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"net_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"bgp_source_as_number",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"bgp_destination_as_number",
                    f_operator:QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoERawClickstreamLogs:{
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoERawClickstreamLogs,
            type:QoESubscribersFilterListItemTypeEnum.hist_logs_clickstream,
            filters:[
                {
                    id:"session_id",
                    title:LangHelper.GetString("QoE", "Session ID"),
                    type:"string"
                },
                {
                    id:"source_ipv4",
                    title:LangHelper.GetString("QoE", "Source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"destination_ipv4",
                    title:LangHelper.GetString("QoE", "Destination IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"source_ipv6",
                    title:LangHelper.GetString("QoE", "Source IPv6-address"),
                    type:"string"
                },
                {
                    id:"destination_ipv6",
                    title:LangHelper.GetString("QoE", "Destination IPv6-address"),
                    type:"string"
                },
                {
                    id:"login",
                    title:LangHelper.GetString("QoE", "Login"),
                    type:"string"
                },
                {
                    id:"host",
                    title:LangHelper.GetString("QoE", "Host"),
                    type:"string"
                },
                {
                    id:"path",
                    title:LangHelper.GetString("QoE", "Path"),
                    type:"string"
                },
                {
                    id:"referal",
                    title:LangHelper.GetString("QoE", "Referer"),
                    type:"string"
                },
                {
                    id:"user_agent",
                    title:LangHelper.GetString("QoE", "User agent"),
                    type:"string"
                },
                {
                    id:"bridge_vchannel",
                    title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                    type:"string"
                },
                {
                    id:"locked",
                    title:LangHelper.GetString("QoE", "Locked"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    editor:"richselect",
                    options:Helper.DictToArr(YesNoDic)
                },
                {
                    id:"from_subscriber",
                    title:LangHelper.GetString("QoE", "Traffic direction"),
                    editor:"richselect",
                    options: Helper.DictToArr(TrafficDirectionDic),
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    type:QoEFilterValueType.UInt8
                }
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"session_id",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"login",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"path",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"referal",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"user_agent",
                    f_operator:QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoERawFullNetFlow:{
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNetFlow,
            type:QoESubscribersFilterListItemTypeEnum.hist_logs_netflow,
            filters:[
                {
                    id:"session_id",
                    title:LangHelper.GetString("QoE", "Session ID"),
                    type:"string"
                },
                {
                    id:"source_ipv4",
                    title:LangHelper.GetString("QoE", "Source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"source_ipv6",
                    title:LangHelper.GetString("QoE", "Source IPv6-address"),
                    type:"string"
                },
                {
                    id:"source_port",
                    title:LangHelper.GetString("QoE", "Source port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"bgp_source_as_number",
                    title:LangHelper.GetString("QoE", "Source AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"destination_ipv4",
                    title:LangHelper.GetString("QoE", "Destination IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"destination_ipv6",
                    title:LangHelper.GetString("QoE", "Destination IPv6-address"),
                    type:"string"
                },
                {
                    id:"destination_port",
                    title:LangHelper.GetString("QoE", "Destination port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"bgp_destination_as_number",
                    title:LangHelper.GetString("QoE", "Destination AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"net_protocol",
                    title:LangHelper.GetString("QoE", "Net protocol"),
                    type:"string"
                },
                {
                    id:"app_protocol",
                    title:LangHelper.GetString("QoE", "Application protocol"),
                    operator_type: QoEFilterOperatorsTypesEnum.appproto,
                    type:"string"
                },
                {
                    id:"app_protocol_group_id",
                    title:LangHelper.GetString("QoE", "App protocols groups"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic:DicsEnum.ProtocolsGroupsDic
                },
                {
                    id:"login",
                    title:LangHelper.GetString("QoE", "Login"),
                    type:"string"
                },
                {
                    id:"subscriber",
                    title:LangHelper.GetString("QoE", "Subscriber"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"source_asnum",
                    title:LangHelper.GetString("QoE", "Subscriber`s AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"subscriber_port",
                    title:LangHelper.GetString("QoE", "Subscriber`s port"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"host",
                    title:LangHelper.GetString("QoE", "Host"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"destination_asnum",
                    title:LangHelper.GetString("QoE", "Host`s AS number"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"host_port",
                    title:LangHelper.GetString("QoE", "Host`s port"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"host_ip",
                    title:LangHelper.GetString("QoE", "Host IP"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"bridge_vchannel",
                    title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                    type:"string"
                },
                {
                    id:"post_nat_source_ipv4",
                    title:LangHelper.GetString("QoE", "Post nat source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"post_nat_source_port",
                    title:LangHelper.GetString("QoE", "Post nat source port"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"from_subscriber",
                    title:LangHelper.GetString("QoE", "Traffic direction"),
                    editor:"richselect",
                    options: Helper.DictToArr(TrafficDirectionDic),
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"vlan_id",
                    title:LangHelper.GetString("QoE", "Vlan ID"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"post_vlan_id",
                    title:LangHelper.GetString("QoE", "Post vlan ID"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id: "mpls_labels",
                    title: LangHelper.GetString("QoE", "MPLS labels"),
                    type: QoEFilterValueType.String
                },
                {
                    id:"ip_class_of_service_class",
                    title:LangHelper.GetString("QoE", "Class"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"ip_class_of_service_full",
                    title:LangHelper.GetString("QoE", "DSCP"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"octet_delta_count",
                    title:LangHelper.GetString("QoE", "Octet delta"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"packet_delta_count",
                    title:LangHelper.GetString("QoE", "Packet delta"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"blocked",
                    title:LangHelper.GetString("QoE", "Locked"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum["in"], QoEFilterOperatorsEnum["not in"]],
                    operator_type:QoEFilterOperatorsTypesEnum.bitwise,
                    editor:"bitmask_editor",
                    options: Object.values(FullflowBlockedTrafficDataTypesDic).reduce((Acc, Val) => {
                        Acc.push({id: Val.id, value: Val.value});
                        return Acc;
                    }, [])
                },
                {
                    id:"dropped_bytes",
                    title:LangHelper.GetString("QoE", "Dropped bytes"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"dropped_packets",
                    title:LangHelper.GetString("QoE", "Dropped packets"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"duration",
                    title:LangHelper.GetString("QoE", "Duration in milliseconds"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"ttl",
                    title:LangHelper.GetString("QoE", "TTL"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"rating_group",
                    title:LangHelper.GetString("QoE", "Rating group"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"service_flags",
                    title:LangHelper.GetString("QoE", "Service flags"),
                    type:QoEFilterValueType.UInt64,
                    operators:[QoEFilterOperatorsEnum["in"], QoEFilterOperatorsEnum["not in"]],
                    operator_type:QoEFilterOperatorsTypesEnum.bitwise,
                    editor:"bitmask_editor",
                    options: Object.values(FullflowServiceFlagsTrafficDataTypesDic).reduce((Acc, Val) => {
                        Acc.push({id: Val.id, value: Val.value});
                        return Acc;
                    }, [])
                },
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"session_id",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"bgp_source_as_number",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"bgp_destination_as_number",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"net_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol_group_id",
                    f_operator:QoEFilterOperatorsEnum.in
                },
                {
                    f_enabled:0,
                    f_id:"login",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"subscriber",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_asnum",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"subscriber_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_asnum",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_ip",
                    f_operator:QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoERawFullGtpFlow: {
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoERawFullGtpFlow,
            type:QoESubscribersFilterListItemTypeEnum.gtp_raw_flow_history,
            filters:[
                {
                    id:"session_id",
                    title:LangHelper.GetString("QoE", "Session ID"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"gtp_version",
                    title:LangHelper.GetString("QoE", "GTP version"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"request_msg_id",
                    title:LangHelper.GetString("QoE", "Request message ID"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"response_msg_id",
                    title:LangHelper.GetString("QoE", "Response message ID"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"ie_cause",
                    title:LangHelper.GetString("QoE", "Result code"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"success",
                    title:LangHelper.GetString("QoE", "Success"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"sgw_cp_ipv4",
                    title:LangHelper.GetString("QoE", "SGW control plane IP"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"sgw_cp_teid",
                    title:LangHelper.GetString("QoE", "SGW control plane TEID"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"sgw_dp_ipv4",
                    title:LangHelper.GetString("QoE", "SGW data plane IP"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"sgw_dp_teid",
                    title:LangHelper.GetString("QoE", "SGW data plane TEID"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"pgw_cp_ipv4",
                    title:LangHelper.GetString("QoE", "PGW control plane IP"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"pgw_cp_teid",
                    title:LangHelper.GetString("QoE", "PGW control plane TEID"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"pgw_dp_ipv4",
                    title:LangHelper.GetString("QoE", "PGW data plane IP"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"pgw_dp_teid",
                    title:LangHelper.GetString("QoE", "PGW data plane TEID"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"user_ipv4",
                    title:LangHelper.GetString("QoE", "Subscriber ipv4 address"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"user_ipv6",
                    title:LangHelper.GetString("QoE", "Subscriber ipv6 address"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"imsi",
                    title:LangHelper.GetString("QoE", "SIM card number"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"msisdn",
                    title:LangHelper.GetString("QoE", "Phone number"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"imei",
                    title:LangHelper.GetString("QoE", "IMEI"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"apn",
                    title:LangHelper.GetString("QoE", "Access Point Name"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"uli_time",
                    title:LangHelper.GetString("QoE", "Time of ULI"),
                    type:"Datetime"
                },
                {
                    id:"uli_mcc",
                    title:LangHelper.GetString("QoE", "Mobile country code"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"uli_mnc",
                    title:LangHelper.GetString("QoE", "Mobile network (operator) code"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"country_description",
                    title:LangHelper.GetString("QoE", "Country name"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"network_description",
                    title:LangHelper.GetString("QoE", "Network (operator) name"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"uli_tac",
                    title:LangHelper.GetString("QoE", "Service/Tracking area code"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"uli_eci",
                    title:LangHelper.GetString("QoE", "Base station code"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"rat",
                    title:LangHelper.GetString("QoE", "Rat"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"dpi_id",
                    title:LangHelper.GetString("QoE", "DPI ID"),
                    type:QoEFilterValueType.UInt8
                }
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"dpi_id",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"rat",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_eci",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_tac",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_mcc",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_mnc",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"country_description",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"network_description",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_time",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"apn",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"imei",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"msisdn",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"imsi",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"session_id",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"gtp_version",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"request_msg_id",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"response_msg_id",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"ie_cause",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"success",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"sgw_cp_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"sgw_cp_teid",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"sgw_dp_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"sgw_dp_teid",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"pgw_cp_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"pgw_cp_teid",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"pgw_dp_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"user_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"user_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoEFullGtpFlow: {
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoEFullGtpFlow,
            type:QoESubscribersFilterListItemTypeEnum.gtp_flow_history,
            filters:[
                {
                    id:"imsi",
                    title:LangHelper.GetString("QoE", "SIM card number"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"msisdn",
                    title:LangHelper.GetString("QoE", "Phone number"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"imei",
                    title:LangHelper.GetString("QoE", "IMEI"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"user_ipv4",
                    title:LangHelper.GetString("QoE", "Subscriber ipv4 address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"user_ipv6",
                    title:LangHelper.GetString("QoE", "Subscriber ipv6 address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"uli_time",
                    title:LangHelper.GetString("QoE", "Time of ULI"),
                    type:"DateTime"
                },
                {
                    id:"uli_mcc",
                    title:LangHelper.GetString("QoE", "Mobile country code"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"uli_mnc",
                    title:LangHelper.GetString("QoE", "Mobile network (operator) code"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"country_description",
                    title:LangHelper.GetString("QoE", "Country name"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"network_description",
                    title:LangHelper.GetString("QoE", "Network (operator) name"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"uli_tac",
                    title:LangHelper.GetString("QoE", "Service/Tracking area code"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"uli_eci",
                    title:LangHelper.GetString("QoE", "Base station code"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"lat",
                    title:LangHelper.GetString("QoE", "Latitude"),
                    type:QoEFilterValueType.Float64
                },
                {
                    id:"lon",
                    title:LangHelper.GetString("QoE", "Longitude"),
                    type:QoEFilterValueType.Float64
                },
                {
                    id:"cell_id",
                    title:LangHelper.GetString("QoE", "Cell ID"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"cell_name",
                    title:LangHelper.GetString("QoE", "Cell name"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"cell_description",
                    title:LangHelper.GetString("QoE", "Cell description"),
                    type:QoEFilterValueType.String
                }
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"cell_description",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"cell_name",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"cell_id",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"lon",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"lat",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_eci",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_tac",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_mcc",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_mnc",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"country_description",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"network_description",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"uli_time",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"user_ipv6",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"user_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"imei",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"msisdn",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"imsi",
                    f_operator:QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoERawFullNatFlow:{
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNatFlow,
            type:QoESubscribersFilterListItemTypeEnum.nat_raw_flow_history,
            filters:[
                {
                    id:"session_id",
                    title:LangHelper.GetString("QoE", "Session ID"),
                    type:"string"
                },
                {
                    id:"source_ipv4",
                    title:LangHelper.GetString("QoE", "Source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"source_port",
                    title:LangHelper.GetString("QoE", "Source port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"destination_ipv4",
                    title:LangHelper.GetString("QoE", "Destination IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"destination_port",
                    title:LangHelper.GetString("QoE", "Destination port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"post_nat_source_ipv4",
                    title:LangHelper.GetString("QoE", "Post nat source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"post_nat_source_port",
                    title:LangHelper.GetString("QoE", "Post nat source port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"login",
                    title:LangHelper.GetString("QoE", "Login"),
                    type:"string"
                },
                {
                    id:"net_protocol",
                    title:LangHelper.GetString("QoE", "Protocol"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"event_type",
                    title:LangHelper.GetString("QoE", "Event type"),
                    type:QoEFilterValueType.String
                },
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"source_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"post_nat_source_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"post_nat_source_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"login",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"net_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"event_type",
                    f_operator:QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoEDashboards:{
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoEDashboards,
            type:QoESubscribersFilterListItemTypeEnum.dashboards_history,
            filters:[],
            default:[],
            shared_filters:[
                {
                    f_id:"login",
                    filter_owner_types: [QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow, QoEPopupFilterWidgetConfigTypeEnum.QoEClickstream],
                    shared_types: {
                        [QoEPopupFilterWidgetConfigTypeEnum.QoERawFullGtpFlow]: "imsi",
                        [QoEPopupFilterWidgetConfigTypeEnum.QoEFullGtpFlow]: "imsi"
                    }
                }
            ]
        },
        QoERawFullDnsFlow: {
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDnsFlow,
            type:QoESubscribersFilterListItemTypeEnum.dns_raw_flow_history,
            filters:[
                {
                    id:"session_id",
                    title:LangHelper.GetString("QoE", "Session ID"),
                    type:"string"
                },
                {
                    id:"source_ipv4",
                    title:LangHelper.GetString("QoE", "Source IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"source_ipv6",
                    title:LangHelper.GetString("QoE", "Source IPv6-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"source_port",
                    title:LangHelper.GetString("QoE", "Source port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"destination_ipv4",
                    title:LangHelper.GetString("QoE", "Destination IPv4-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"destination_ipv6",
                    title:LangHelper.GetString("QoE", "Destination IPv6-address"),
                    type:"string",
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"destination_port",
                    title:LangHelper.GetString("QoE", "Destination port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"login",
                    title:LangHelper.GetString("QoE", "Login"),
                    type:"string"
                },
                {
                    id:"dns_transport",
                    title:LangHelper.GetString("QoE", "DNS transport"),
                    editor:"richselect",
                    options: Helper.DictToArr(DnsTransportDic),
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    type:QoEFilterValueType.UInt8
                },
                {
                    id: "rtype",
                    title: LangHelper.GetString("QoE", "DNS type"),
                    editor: "multiselect",
                    options: Helper.DictToArr(DnsRtypeDic),
                    operators: [QoEFilterOperatorsEnum["in"], QoEFilterOperatorsEnum["not in"]],
                    type: QoEFilterValueType.UInt16
                },
                {
                    id:"host",
                    title:LangHelper.GetString("QoE", "Host"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"host_ip_dns_data",
                    title:LangHelper.GetString("QoE", "Host IP"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"host_ip",
                    title:LangHelper.GetString("QoE", "DNS server IP"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"host_port",
                    title:LangHelper.GetString("QoE", "DNS server port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"subscriber",
                    title:LangHelper.GetString("QoE", "Subscriber"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"subscriber_port",
                    title:LangHelper.GetString("QoE", "Subscriber port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"vlan_id",
                    title:LangHelper.GetString("QoE", "Vlan ID"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"post_vlan_id",
                    title:LangHelper.GetString("QoE", "Post vlan ID"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id: "mpls_labels",
                    title: LangHelper.GetString("QoE", "MPLS labels"),
                    type: QoEFilterValueType.String
                },
                {
                    id:"from_subscriber",
                    title:LangHelper.GetString("QoE", "Traffic direction"),
                    editor:"richselect",
                    options: Helper.DictToArr(TrafficDirectionDic),
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"bridge_vchannel",
                    title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                    type:"string"
                },
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"source_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"source_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_ipv4",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"destination_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"login",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled: 0,
                    f_id: "host",
                    f_operator: QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoEFullDnsFlow: {
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoEFullDnsFlow,
            type:QoESubscribersFilterListItemTypeEnum.dnsflow_history,
            filters:[
                {
                    id:"host",
                    title:LangHelper.GetString("QoE", "Host"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"host_ip_dns_data",
                    title:LangHelper.GetString("QoE", "Host IP"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"subscriber",
                    title:LangHelper.GetString("QoE", "Subscriber"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"subscriber_port",
                    title:LangHelper.GetString("QoE", "Subscriber port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"login",
                    title:LangHelper.GetString("QoE", "Login"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"host_ip",
                    title:LangHelper.GetString("QoE", "DNS server IP"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"host_port",
                    title:LangHelper.GetString("QoE", "DNS server port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"host_category",
                    title:LangHelper.GetString("QoE", "Host category"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic:DicsEnum.HostCategoriesDic
                },
                {
                    id:"dns_transport",
                    title:LangHelper.GetString("QoE", "DNS transport"),
                    editor:"richselect",
                    options: Helper.DictToArr(DnsTransportDic),
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    type:QoEFilterValueType.UInt8
                },
                {
                    id: "rtype",
                    title: LangHelper.GetString("QoE", "DNS type"),
                    editor: "multiselect",
                    options: Helper.DictToArr(DnsRtypeDic),
                    operators: [QoEFilterOperatorsEnum["in"], QoEFilterOperatorsEnum["not in"]],
                    type: QoEFilterValueType.UInt16
                },
                {
                    id:"vlan_id",
                    title:LangHelper.GetString("QoE", "Vlan ID"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"post_vlan_id",
                    title:LangHelper.GetString("QoE", "Post vlan ID"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"from_subscriber",
                    title:LangHelper.GetString("QoE", "Traffic direction"),
                    editor:"richselect",
                    options: Helper.DictToArr(TrafficDirectionDic),
                    operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"mpls_labels",
                    title:LangHelper.GetString("QoE", "MPLS labels"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"bridge_vchannel",
                    title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                    type:"string"
                },
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"host",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_ip",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"subscriber",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"login",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"host_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled: 0,
                    f_id: "subscriber_port",
                    f_operator: QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoEFullDdosAttackFlow: {
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoEFullDdosAttackFlow,
            type:QoESubscribersFilterListItemTypeEnum.ddos_attack,
            filters:[
                {
                    id:"event",
                    title:LangHelper.GetString("QoE", "Event"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"event_type",
                    title:LangHelper.GetString("QoE", "Event type"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"event_action",
                    title:LangHelper.GetString("QoE", "Event action"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"dpi_id",
                    title:LangHelper.GetString("QoE", "DPI ID"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"vchannel",
                    title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                    type:"string"
                },
                {
                    id:"net_protocol",
                    title:LangHelper.GetString("QoE", "Net protocol"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"app_protocol",
                    title:LangHelper.GetString("QoE", "Application protocol"),
                    operator_type: QoEFilterOperatorsTypesEnum.appproto,
                    type:QoEFilterValueType.String
                },
                {
                    id:"app_protocol_group_id",
                    title:LangHelper.GetString("QoE", "App protocols groups"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic:DicsEnum.ProtocolsGroupsDic
                },
                {
                    id:"src_asnum",
                    title:LangHelper.GetString("QoE", "Source AS"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"src_ip",
                    title:LangHelper.GetString("QoE", "Attacker IP address"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"dst_ip",
                    title:LangHelper.GetString("QoE", "Target IP address"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"dst_port",
                    title:LangHelper.GetString("QoE", "Target port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"dst_login",
                    title:LangHelper.GetString("QoE", "Subscriber login"),
                    type:QoEFilterValueType.String
                }
            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"event",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"event_type",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"event_action",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"net_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol_group_id",
                    f_operator:QoEFilterOperatorsEnum.in
                },
                {
                    f_enabled:0,
                    f_id:"src_asnum",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"src_ip",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"dst_ip",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"dst_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"dst_login",
                    f_operator:QoEFilterOperatorsEnum.like
                }
            ]
        },
        QoERawFullDdosAttackFlow: {
            filter_type:QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDdosAttackFlow,
            type:QoESubscribersFilterListItemTypeEnum.raw_ddos_attack,
            filters:[
                {
                    id:"event",
                    title:LangHelper.GetString("QoE", "Event"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"event_type",
                    title:LangHelper.GetString("QoE", "Event type"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"event_action",
                    title:LangHelper.GetString("QoE", "Event action"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"dpi_id",
                    title:LangHelper.GetString("QoE", "DPI ID"),
                    type:QoEFilterValueType.UInt8
                },
                {
                    id:"vchannel",
                    title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                    type:"string"
                },
                {
                    id:"net_protocol",
                    title:LangHelper.GetString("QoE", "Net protocol"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"app_protocol",
                    title:LangHelper.GetString("QoE", "Application protocol"),
                    operator_type: QoEFilterOperatorsTypesEnum.appproto,
                    type:QoEFilterValueType.String
                },
                {
                    id:"app_protocol_group_id",
                    title:LangHelper.GetString("QoE", "App protocols groups"),
                    type:QoEFilterValueType.UInt32,
                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                    editor:"multiselect",
                    dic:DicsEnum.ProtocolsGroupsDic
                },
                {
                    id:"src_asnum",
                    title:LangHelper.GetString("QoE", "Source AS"),
                    type:QoEFilterValueType.UInt32
                },
                {
                    id:"src_ip",
                    title:LangHelper.GetString("QoE", "Attacker IP address"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"src_ports",
                    title:LangHelper.GetString("QoE", "Attacker ports"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"dst_ip",
                    title:LangHelper.GetString("QoE", "Target IP address"),
                    type:QoEFilterValueType.String,
                    opertor_view:
                        {
                            "in CIDRs":QoEReportViews.Subnets,
                            "not in CIDRs":QoEReportViews.Subnets
                        },
                    can_cidr:true
                },
                {
                    id:"dst_port",
                    title:LangHelper.GetString("QoE", "Target port"),
                    type:QoEFilterValueType.UInt16
                },
                {
                    id:"dst_login",
                    title:LangHelper.GetString("QoE", "Subscriber login"),
                    type:QoEFilterValueType.String
                },
                {
                    id:"octets",
                    title:LangHelper.GetString("QoE", "Octet delta"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"octets_dropped",
                    title:LangHelper.GetString("QoE", "Dropped bytes"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"packets",
                    title:LangHelper.GetString("QoE", "Packet delta"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"packets_dropped",
                    title:LangHelper.GetString("QoE", "Dropped packets"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"flows",
                    title:LangHelper.GetString("QoE", "Flows records"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"sessions",
                    title:LangHelper.GetString("QoE", "Sessions"),
                    type:QoEFilterValueType.UInt64
                },
                {
                    id:"duration",
                    title:LangHelper.GetString("QoE", "Duration in milliseconds"),
                    type:QoEFilterValueType.UInt64
                },

            ],
            default:[
                {
                    f_enabled:0,
                    f_id:"event",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"event_type",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"event_action",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"net_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"app_protocol_group_id",
                    f_operator:QoEFilterOperatorsEnum.in
                },
                {
                    f_enabled:0,
                    f_id:"src_asnum",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"src_ip",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"src_ports",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"dst_ip",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"dst_port",
                    f_operator:QoEFilterOperatorsEnum.like
                },
                {
                    f_enabled:0,
                    f_id:"dst_login",
                    f_operator:QoEFilterOperatorsEnum.like
                }
            ]
        }
    };

    return config[type];
}

function QoEPopupFilterWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.Embedded = false;

    this.ViewModel = null;

    this.SavedFiltersViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.ContextConfig = null;

    this.Context = null;

    this.HotkeysDic = (() => {
        let hotkeys  = {};
        for (let key in QoeFilterWidgetHotKeysDic)
        {
            let item = QoeFilterWidgetHotKeysDic[key];
            item.code = key;
            item.tooltip = LangHelper.GetString("QoEPopupFilterWidget", "Hotkey") + ": " + key;
            hotkeys[key] = item;
        }
        return hotkeys;
    })();

    this.SavedFilterDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("QoEPopupFilterWidget","Are you sure you want to delete the filter?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            tooltip: _this.HotkeysDic["Esc"].tooltip,
                            click:function () {
                                _this.SavedFilterDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            tooltip: _this.HotkeysDic["Enter"].tooltip,
                            click:function ()
                            {
                                var selected = _this.GetSavedFiltersTableSelectedData();

                                if(selected)
                                    _this.DeleteSavedFilter(selected.id);

                                _this.SavedFiltersUnselect();
                                _this.SavedFilterDeleteContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.FilterWidgetHelpContext = webix.ui({
        view:"popup",
        width: LangHelper.GetLocale() === "en" ? 320 : 425,
        height: Object.keys(_this.HotkeysDic).length * 28,
        body:{
            borderless:true,
            template:function()
            {
                let text = "<table>";
                for (let key in _this.HotkeysDic)
                {
                    let item = _this.HotkeysDic[key];
                    let colWidth = LangHelper.GetLocale() === "en" ? 35 : 25;
                    text += `<tr><td width="${colWidth}%" height="20">${item.code}</td><td>${item.help}</td></tr>`
                }
                text += "</tabel>";
                return text;
            }
        }
    });

    this.Views = {
        FilterBtn:null,
        Popup:null,
        Table:null,

        Tabbar:null,
        SavedFiltersTab:null,
        HistoryFiltersTab:null,

        HistoryTable:null,
        HistoryTablePaging:null,

        SavedFiltersTable:null,
        SavedFiltersTablePaging:null,

        SaveFilterBtn:null,
        SavedFilterLabel:null,

        HelpContextBody:null,

        FilterApplyBtn:null,
        FilterCancelBtn:null,

        FilterHelpBtn:null
    };

    this.LastState = [];

    this.State = [];

    this.ApplyStateSignal = new Rx.BehaviorSubject(0);

    this.ResetStateSignal = new Rx.BehaviorSubject(0);

    this.FilterReadySignal = new Rx.BehaviorSubject(0);

    this.HistoryTableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.SavedFiltersTableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.RestoreSavedStateSignal = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};

    this.LastFilterCode = null;

    this.CurrentFilterCode = null;

    this.CurrentSelectedFilter = null;

    this.HelpContextConfig = null;

    this.HelpContext = null;
    
    this.PopupEditorIsOpen = false;

    this.Init(ViewConfig);
}

QoEPopupFilterWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Embedded = ViewConfig.embedded ? ViewConfig.embedded : false;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    var tabbar = {
        view: "tabbar",
        id: _this.Id + "Context" + "Tabbar",
        borderless: false,
        multiview: true,
        options: [
            {
                value: BlockHeaderTemplate().template({
                    title: LangHelper.GetString("QoEPopupFilterWidget", "Saved"),
                    icon: "save"
                }),
                id: _this.Id + "Context" + "SavedFiltersTab"
            },
            {
                value: BlockHeaderTemplate().template({
                    title: LangHelper.GetString("QoEPopupFilterWidget", "History"),
                    icon: "history"
                }),
                id: _this.Id + "Context" + "HistoryFiltersTab"
            }
        ]
    };

    var tabbarCells = {
        view: "multiview",
        cells: [
            {
                id: _this.Id + "Context" + "SavedFiltersTab",
                rows: [
                    {
                        view: "toolbar",
                        height: 42,
                        elements: [
                            {
                                view: "button",
                                id: _this.Id + "Context" + "AddItemToSavedFiltersBtn",
                                type: "icon",
                                icon: "plus",
                                align: "right",
                                width: 32,
                                css: "toolbar_round_btn",
                                tooltip: LangHelper.GetString("QoEPopupFilterWidget", "Add filter") + "\n" + _this.HotkeysDic["Ctrl+f"].tooltip,
                                click: function (id, e, node) {
                                    _this.AddItemToSavedFilters();
                                }
                            },
                            {},
                            {
                                view: "button",
                                id: _this.Id + "Context" + "RefreshSavedFiltersListBtn",
                                type: "icon",
                                icon: "refresh",
                                css: "toolbar_round_btn",
                                width: 32,
                                tooltip: LangHelper.GetString("QoE", "Refresh") + "\n" + _this.HotkeysDic["Ctrl+r"].tooltip,

                                click: function (id, e, node) {
                                    _this.SavedFiltersUnselect();
                                    _this.SavedFiltersRefresh();
                                }
                            }
                        ]
                    },
                    {
                        view: "datatable",
                        id: _this.Id + "Context" + "SavedFiltersTable",
                        select: "row",
                        editable: true,
                        tooltip: true,
                        editaction: "custom",
                        columns: [
                            {
                                id: "edit",
                                header: "",
                                width: 32,
                                template: CellEditBtnTemplate,
                                tooltip: LangHelper.GetString("UsersActionsLog", "Edit"),
                                headermenu: false
                            },
                            {
                                id: "title",
                                header: [LangHelper.GetString("QoEPopupFilterWidget", "Title"), {
                                    content: "textFilter",
                                    placeholder: "&#xf002 " + LangHelper.GetString("All", "Filter")
                                }],
                                fillspace: true,
                                sort: "date",
                                editor: "text"
                            },
                            {
                                id: "trash",
                                header: "",
                                width: 32,
                                template: CellTrashBtnTemplate,
                                tooltip: LangHelper.GetString("UsersActionsLog", "Delete") + "<br>" + _this.HotkeysDic["delete"].tooltip,
                                headermenu: false
                            }
                        ],
                        on: {
                            onItemDblClick: function (id) {
                                _this.Views.SavedFiltersTable.editCell(id, "title");
                            },
                            onItemClick: function (id) {
                                if (id.column === 'edit') {
                                    _this.Views.SavedFiltersTable.editCell(id, "title");
                                }

                                if (id.column === 'trash') {
                                    var __this = this;

                                    var data = this.getItem(id);

                                    if (!data.filter_id) {
                                        _this.DeleteSavedFilter(id);
                                        return;
                                    }

                                    setTimeout(function () {
                                        var node = __this.getItemNode(id);
                                        _this.SavedFilterDeleteContext.show(node, {pos: "bottom"});
                                    }, 10);
                                }
                            },
                            onBeforeFilter: function () {
                                return false;
                            },
                            onAfterFilter: function () {
                                _this.SavedFiltersUnselect();
                                _this.SavedFiltersRefresh();
                            },
                            onBeforeSort: function () {
                                _this.SavedFiltersRefresh();
                                return false;
                            },
                            onAfterSelect: function (id) {
                                _this.CurrentSelectedFilter = this.getItem(id);
                                _this.DefineFilterLabel(_this.CurrentSelectedFilter);

                                if (_this.CurrentSelectedFilter&&_this.CurrentSelectedFilter.form_data) {
                                    _this.SetState(_this.ParseStateFromFilter(_this.CurrentSelectedFilter).filter_state);
                                } else {
                                    _this.SetState(_this.State);
                                }
                                _this.RestoreSavedStateSignal.next(1);

                            },
                            onAfterUnSelect: function () {
                                _this.CurrentSelectedFilter = null;
                                _this.OnSavedFiltersTableRowUnSelect();
                            },
                            onAfterEditStop: function () {
                                _this.DefineFilterLabel(_this.CurrentSelectedFilter);
                            },
                            onFocus: function () {
                                let selectedId = this.getSelectedId();
                                let firstId = this.getFirstId();
                                if(!selectedId&&firstId) {
                                    this.select(firstId);
                                }
                            },
                            onKeyPress(code, e)
                            {
                                if(e.key === "ArrowRight"&&!e.shiftKey)
                                    _this.KeyPressHandler(e.key);
                            }
                        },
                        data: []
                    },
                    {
                        view: "pager",
                        id: this.Id + "Context" + "SavedFiltersTable" + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master: false,
                        on: {
                            onAfterPageChange: function (Page) {
                                _this.SavedFiltersUnselect();
                                _this.SavedFiltersRefresh(Page);
                            }
                        }
                    }
                ]
            },
            {
                id: _this.Id + "Context" + "HistoryFiltersTab",
                rows: [
                    {
                        view: "toolbar",
                        height: 42,
                        elements: [
                            {},
                            {
                                view: "button",
                                id: _this.Id + "Context" + "RefresHistoryFiltersListBtn",
                                type: "icon",
                                icon: "refresh",
                                css: "toolbar_round_btn",
                                width: 32,
                                tooltip: LangHelper.GetString("UsersActionsLog", "Refresh") + "\n" + _this.HotkeysDic["Ctrl+r"].tooltip,
                                click: function (id, e, node) {
                                    _this.HistoryRefresh();
                                    _this.SavedFiltersUnselect();
                                }
                            }
                        ]
                    },
                    {
                        view: "datatable",
                        id: this.Id + "Context" + "HistoryTable",
                        select: "row",
                        columns: [
                            {
                                id: "date",
                                header: [LangHelper.GetString("DpiConfig", "Date"), {content: "dateRangeFilter"}],
                                format: webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"),
                                fillspace: true,
                                sort: "date"
                            }
                        ],
                        on: {
                            // onAfterLoad:function(){
                            //     this.sort("date", "desc", "date");
                            //     this.markSorting("date", "desc");
                            // },
                            onBeforeFilter: function () {
                                return false;
                            },
                            onAfterFilter: function () {
                                _this.HistoryRefresh();
                            },
                            onBeforeSort: function () {
                                _this.HistoryRefresh();

                                return false;
                            },
                            onAfterSelect: function () {
                                _this.OnHistoryTableRowSelect();
                                _this.SavedFiltersUnselect();
                                _this.Views.SaveFilterBtn.show();
                            },
                            onAfterUnSelect: function () {
                                _this.OnHistoryTableRowUnSelect();
                            },
                            onFocus: function () {
                                let selectedId = this.getSelectedId();
                                let firstId = this.getFirstId();
                                if(!selectedId&&firstId) {
                                    this.select(firstId);
                                }
                            },
                            onKeyPress(code, e)
                            {
                                if(e.key === "ArrowRight"&&!e.shiftKey)
                                    _this.KeyPressHandler(e.key);
                            }
                        },
                        data: []
                    },
                    {
                        view: "pager",
                        id: this.Id + "Context" + "HistoryTable" + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master: false,
                        on: {
                            onAfterPageChange: function (Page) {
                                _this.HistoryRefresh(Page);
                            }
                        }
                    }
                ]
            }
        ]
    };

    this.actionBtnsContext = function(Obj) {
        let modal = webix.ui({
            view:"popup",
            width:300,
            height:180,
            body:{
                view:"form",
                borderless:true,
                elements:[
                    {
                        template:LangHelper.GetString("QoEPopupFilterWidget", Obj.text)
                    },
                    {
                        cols:[
                            {},
                            {
                                view:"button",
                                label:LangHelper.GetString(this.Id, "Cancel"),
                                click:function ()
                                {
                                    modal.hide();
                                }
                            },
                            {
                                view:"button",
                                type:"form",
                                label:LangHelper.GetString(this.Id, "Ok"),
                                click:function ()
                                {
                                    modal.hide();
                                    Obj.func();
                                }
                            }
                        ]
                    }
                ]
            }
        });
        modal.show(Obj.node, {pos:"right"})
    };

    var filterTable = [
        BlockHeaderTemplate({title:LangHelper.GetString("QoEPopupFilterWidget", "Filters"), icon:"list", height: 40}),
        {
            view: "toolbar",
            id: _this.Id + "Context" + "TableToolbar",
            height: 42,
            elements: [
                {
                    view: "button",
                    type: "icon",
                    icon: "plus",
                    css: "toolbar_round_btn",
                    width: 32,
                    tooltip: LangHelper.GetString("QoEPopupFilterWidget", "Add filter"),
                    click: function () {
                        var model = new QoEPopupFilterWidgetFilterRowModel({f_enabled: 1});

                        _this.Views.Table.add(model, 0);
                        _this.Views.Table.select(model.id, false);
                    }
                },
                {
                    view: "button",
                    type: "icon",
                    icon: "repeat",
                    css: "toolbar_round_btn",
                    width: 32,
                    tooltip: LangHelper.GetString("QoEPopupFilterWidget", "Set default filter state"),
                    click: function () {
                        let node = this.getNode();
                        _this.actionBtnsContext({node: node, text: "Are you sure you want to set filter settings to default?", func:() => _this.SetDefaultState()})
                    }
                },
                {
                    view: "button",
                    type: "icon",
                    icon: "trash-alt",
                    align: "right",
                    width: 32,
                    css: "toolbar_round_btn",
                    tooltip: LangHelper.GetString("QoEPopupFilterWidget", "Delete all filter settings"),
                    click: function () {
                        let node = this.getNode();
                        _this.actionBtnsContext({node: node, text: "Are you sure you want to delete all filter settings?", func:() => _this.DeleteAllFilterSettings()})
                    }
                },
                {
                    id: _this.Id + "Context" + "SavedFilterLabel",
                    view: "label",
                    align: "left",
                    autoWidth: true,
                    label: ""
                },
                {},
                {
                    id: _this.Id + "Context" + "SaveFilterBtn",
                    view: "button",
                    icon: "save",
                    width: 190,
                    hidden: true,
                    type: "form",
                    labelPosition: "center",
                    label: LangHelper.GetString("QoEPopupFilterWidget", "Save filter"),
                    click: function () {
                        _this.FilterSave();
                        this.hide();
                    }
                }
            ]
        },
        {
            view: "datatable",
            id: _this.Id + "Context" + "Table",
            select: "row",
            resizeColumn: true,
            tooltip: true,
            scroll: "xy",
            editable: true,
            checkboxRefresh: true,
            columns:
                [
                    {
                        id: "f_enabled",
                        header: "",
                        template: CellOnOffTemplate,
                        width: 80,
                        tooltip: LangHelper.GetString("QoEPopupFilterWidget", "Enable/Disable") + "<br>" + _this.HotkeysDic["Shift+Enter"].tooltip,
                        headermenu: false
                    },
                    {
                        id: "f_id",
                        header: [TooltipTemplate(LangHelper.GetString("QoEPopupFilterWidget", "Filter"))],
                        fillspace: 1,
                        editor: "richselect",
                        suggest: {fitMaster: false, width: 200},
                        options: this.GetFiltersDic()
                    },
                    {
                        id: "f_operator",
                        header: [TooltipTemplate(LangHelper.GetString("QoEPopupFilterWidget", "Operator"))],
                        //fillspace:true,
                        editor: "richselect",
                        options: Helper.EnumToArr(QoEFilterOperatorsEnum)
                    },
                    {
                        id: "f_value",
                        header: [TooltipTemplate(LangHelper.GetString("QoEPopupFilterWidget", "Value"))],
                        fillspace: 2,
                        editor: "text",
                        template: function (obj) {
                            var r = obj.f_value;

                            var filterConfig = _this.GetFilterConfigById(obj.f_id);

                            if(filterConfig)
                            {
                                if(filterConfig.dic && App.DicsManager.GetDic(filterConfig.dic))
                                {
                                    rArr = obj.f_value.split(",");

                                    if (rArr && rArr.length > 1) {
                                        r = "";

                                        rArr.forEach(function (Item, Index) {

                                            var item = App.DicsManager.GetDic(filterConfig.dic)[Item];

                                            item = item ? LangHelper.GetString("QoE", item.value) : Item;

                                            r += (Index > 0 ? ", " : "") + item;
                                        });
                                    } else {
                                        r = App.DicsManager.GetDic(filterConfig.dic)[obj.f_value];

                                        r = r ? LangHelper.GetString("QoE", r.value) : obj.f_value;
                                    }
                                }
                                else if(r && filterConfig.options)
                                {
                                    let _r = r.split(",")

                                    if(filterConfig.editor === "bitmask_editor") {
                                        if(_r && _r.length === 1) {
                                            const options = filterConfig.options.map(Item => parseInt(Item.id));

                                            if(_r[0] === '0' && options.includes(parseInt(_r[0]))) {
                                                _r = ['0x0'];
                                            } else {
                                                _r = Helper.BitMaskToArray(parseInt(_r[0]), options, "hex");
                                            }
                                        }
                                    }

                                    _r = filterConfig.options.reduce((Acc, Opt) => {
                                        if(_r.includes(Opt.id))
                                            Acc.push(Opt.value);
                                        return Acc;
                                    }, []);

                                    if(_r && _r.length)
                                        r = _r.join(",");
                                }
                            }

                            return r;
                        },
                        tooltip: function (obj, common) {
                            var hText = _this.GetHelpTextByFilterConfig(obj);

                            return hText ? hText : obj.f_value;
                        }
                    },
                    {
                        id: "help",
                        header: "",
                        width: 32,
                        tooltip: LangHelper.GetString("QoEPopupFilterWidget", "Details"),
                        template: function (obj) {
                            var hText = _this.GetHelpTextByFilterConfig(obj);

                            return hText ? CellHelpBtnTemplate() : "";
                        },
                        headermenu: false,
                        align: "right"
                    },
                    {
                        id:"clear",
                        width:32,
                        header:"",
                        headermenu:false,
                        tooltip: function(Obj)
                        {
                            return Obj.f_value ? LangHelper.GetString("QoEPopupFilterWidget", "Clear value") : "";
                        },
                        template: function(Obj)
                        {
                            return Obj.f_value ? CellBroomBtnTemplate() : "";
                        }
                    },
                    {
                        id: "trash",
                        header: "",
                        width: 32,
                        template: CellTrashBtnTemplate,
                        headermenu: false,
                        tooltip: LangHelper.GetString("UsersActionsLog", "Delete") + "<br>" + _this.HotkeysDic["delete"].tooltip,
                        align: "right"
                    }
                ],
            on:
                {
                    onItemClick: function (id, e, node) {
                        if (id.column === "clear") {
                            let item = this.getItem(id)
                            if(item.f_value)
                            {
                                item.f_value = "";
                                this.updateItem(item);
                            }
                        }

                        if (id.column === 'trash') {
                            this.editStop();
                            this.remove(id);
                        }

                        if (id.column === 'help') {
                            var obj = this.getItem(id);

                            var hText = _this.GetHelpTextByFilterConfig(obj);

                            if (hText)
                                _this.ShowHelpContext(this.getItemNode(id), "bottom", hText);
                        }
                    },
                    onBeforeEditStart: function (id) {
                        this._lastEditColumn = id.column;

                        var config = this.getColumnConfig(id.column);

                        var item = this.getItem(id.row);

                        var editor = item.f_value_editor;

                        var operator = item.f_operator;

                        var f_id = item.f_id;

                        var filterConfig = _this.GetFilterConfigById(f_id);

                        if (id.column === "f_id") {
                            this._fIdColVal = item.f_id;
                        }

                        if (id.column == "f_value") {
                            config.collection = null;
                            config.popup = null;
                            config.$popup = null;

                            if (editor == "text" && (
                                operator == QoEFilterOperatorsEnum.in ||
                                operator == QoEFilterOperatorsEnum["not in"] ||
                                operator == QoEFilterOperatorsEnum["in CIDRs"] ||
                                operator == QoEFilterOperatorsEnum["not in CIDRs"] ||
                                operator == QoEFilterOperatorsEnum.between ||
                                operator == QoEFilterOperatorsEnum["not between"])) {
                                editor = "popup";
                            }

                            if (filterConfig && filterConfig.editor) {
                                editor = filterConfig.editor;

                            }

                            if (filterConfig && filterConfig.dic) {
                                config.collection = new webix.DataCollection(
                                    {
                                        data: App.DicsManager.GetDicAsArray(filterConfig.dic).map(function (Val) {
                                            return {
                                                id: Val.id,
                                                dic_id: Val.dic_id,
                                                value: LangHelper.GetString("QoE", Val.value)
                                            }
                                        })
                                            .sort(function (a, b) {
                                                if (a.value > b.value) {
                                                    return 1;
                                                }
                                                if (a.value < b.value) {
                                                    return -1;
                                                }
                                                return 0;
                                            })
                                    }
                                );
                            }

                            if (filterConfig && filterConfig.options) {
                                config.collection = new webix.DataCollection({data: filterConfig.options});
                            }

                            config.editor = editor;

                            if(editor === "popup")
                                _this.PopupEditorIsOpen = true;
                        }

                        if (id.column == "f_operator") {
                            var list = config.collection;

                            if (filterConfig && filterConfig.operators && filterConfig.operators.length) {
                                list.filter(function (obj) {
                                    return filterConfig.operators.indexOf(obj.id) != -1;
                                });
                            } else if (filterConfig && !filterConfig.can_cidr) {
                                list.filter(function (obj) {
                                    return obj.id != "in CIDRs" && obj.id != "not in CIDRs";
                                });
                            } else {
                                list.filter("id", null);
                            }
                        }
                    },
                    // onAfterEditStart: function (id) {
                    //
                    // },
                    // onBeforeEditStop: function (state, id, ignore) {
                    // },
                    onAfterEditStop: function (state, id, ignore) {
                        var item = this.getItem(id.row);

                        var filterConfig = _this.GetFilterConfigById(item.f_id);

                        if (filterConfig && filterConfig.operators && filterConfig.operators.length) {
                            if (filterConfig.operators.indexOf(item.f_operator) < 0) {
                                item.f_operator = filterConfig.operators[0];
                            }
                        } else if (filterConfig && !filterConfig.can_cidr) {
                            if (item.f_operator == "in CIDRs" || item.f_operator == "not in CIDRs") {
                                item.f_operator = QoEFilterOperatorsEnum.like;
                            }
                        }

                        if (!item.f_operator)
                            item.f_operator = QoEFilterOperatorsEnum.like;

                        if (id.column === "f_id") {
                            if (item.f_id !== this._fIdColVal)
                            {
                                item.f_value = "";
                            }
                        }
                    },
                    onKeyPress(code, e)
                    {
                        if(e.key === "ArrowLeft" && !e.shiftKey)
                            _this.KeyPressHandler(e.key);

                        if(e.code === "Enter" && e.ctrlKey)
                        {
                            webix.delay(function(){
                                let firstRowId = this.getFirstId()
                                let selectedRowId = this.getSelectedId();
                                let editableColIds = ["f_id", "f_operator", "f_value"];
                                let lastColIdx = null;
                                let nextColIdx = null;

                                if (!selectedRowId && firstRowId) {
                                    this.select(firstRowId);
                                    selectedRowId = this.getSelectedId();
                                }
                                else if (!firstRowId)
                                {
                                    return;
                                }

                                if (this._lastEditColumn)
                                {
                                    lastColIdx = editableColIds.indexOf(this._lastEditColumn);
                                    if (lastColIdx > -1) {
                                        nextColIdx = lastColIdx === editableColIds.length - 1 ? 0 : lastColIdx + 1;
                                        if (lastColIdx === editableColIds.length - 1) {
                                            selectedRowId = this.getNextId(selectedRowId);
                                            if (!selectedRowId) {
                                                selectedRowId = firstRowId
                                            }
                                            this.select(selectedRowId)
                                        }
                                    }
                                }

                                if (nextColIdx === null)
                                    nextColIdx = 0;

                                this.editCell(selectedRowId, editableColIds[nextColIdx]);
                            }, this);
                        }
                    },
                    onAfterUnSelect: function ()
                    {
                        this._lastEditColumn = null;
                    }
                }
        }
    ]

    var filterViewConfig = {
        rows: [
            {
                cols: [
                    {
                        width: 300,
                        minWidth: 300,
                        rows: [
                            tabbar,
                            tabbarCells,
                        ]
                    },
                    {
                        view: "resizer"
                    },
                    {
                        minWidth: 400,
                        rows: filterTable
                    },
                ]
            }
        ]
    }

    if(!this.Embedded)
    {
        filterViewConfig.rows.push({
            view:"form",
            elements:[
                {
                    cols:[
                        {
                            view: "button",
                            id: _this.Id + "Context" + "Filter" + "ShowHelpBtn",
                            type:"icon",
                            icon:"question-circle",
                            css: "toolbar_round_btn",
                            label: LangHelper.GetString("QoEPopupFilterWidget","Help"),
                            click: function ()
                            {
                                if (_this.FilterWidgetHelpContext.isVisible()) {
                                    _this.FilterWidgetHelpContext.hide();
                                } else {
                                    _this.FilterWidgetHelpContext.show(this.getNode(), {pos:"right"});
                                }
                            }
                        },
                        {
                            gravity: 4
                        },
                        {
                            view: "button",
                            id: _this.Id + "Context" + "Filter" + "CancelBtn",
                            label: LangHelper.GetString("All", "Cancel"),
                            tooltip: _this.HotkeysDic["Esc"].tooltip,
                            click: function ()
                            {
                                _this.FilterCancel();
                            }
                        },
                        {
                            view: "button",
                            type: "form",
                            id: _this.Id + "Context" + "Filter" + "ApplyBtn",
                            label: LangHelper.GetString("All", "Apply"),
                            tooltip: _this.HotkeysDic["Enter"].tooltip,
                            click: function ()
                            {
                                _this.FilterApply();
                            }
                        },
                    ]
                }
            ]
        });
        filterViewConfig.borderless = true;
    }

    var btnViewConfig = {
        view: "button",
        id:this.Id+"FilterBtn",
        type: "icon",
        icon: "filter",
        css: "toolbar_round_btn",
        width: 48,
        tooltip: LangHelper.GetString("QoEPopupFilterWidget", "Filter"),
        badge: 0,
        click: function (id, e, node)
        {
            _this.Show(this.getNode(),"bottom");
        }
    };

    if(this.Embedded)
    {
        this.ViewConfig = filterViewConfig;
    }
    else
    {
        this.ContextConfig = {
            view: "popup",
            id:this.Id + "Context",
            maxWidth: 920,
            maxHeight: 640,
            modal: true,
            position: {
                my: "center",
                at: "center",
                of: webix.viewport
            },
            body: filterViewConfig
        };

        this.ViewConfig = btnViewConfig;
    }

    this.HelpContextConfig = {
        view: "popup",
        id:this.Id + "HelpContext",
        body:{
            borderless:true,
            rows:[
                {
                    id:this.Id + "HelpContextBody",
                    rows:[{}]
                }
            ]
        }
    };

    this.EnableShowHotkey = ViewConfig.enable_show_hotkey ? ViewConfig.enable_show_hotkey : 0;

    this.KeyEventsIds = {
        BrowserHotkeysEventId: null,
        ShowFilterKeyEvent: null
    };

    this.IsWidgetEnabled = true;

    webix.editors.bitmask_editor = webix.extend(QoEPopupFilterBitMaskEditorConfig, webix.editors.multiselect);
};

QoEPopupFilterWidget.prototype.Bind = function (ViewController, ViewModel)
{
    var _this = this;

    this.ViewModel = ViewModel ? ViewModel : new QoESavedFiltersListWidgetManager();

    this.SavedFiltersViewModel = new QoESavedFiltersListWidgetManager();

    if(!this.Embedded)
        this.Context = webix.ui(this.ContextConfig);

    if(!this.Embedded)
        this.Views.FilterBtn = $$(this.Id + "FilterBtn");
        this.Views.FilterApplyBtn = $$(this.Id + "Context" + "Filter" + "ApplyBtn")
        this.Views.FilterCancelBtn = $$(this.Id + "Context" + "Filter" + "CancelBtn")

    this.Views.Tabbar = $$(this.Id + "Context" + "Tabbar")
    this.Views.SavedFiltersTab = $$(this.Id + "Context" + "SavedFiltersTab")
    this.Views.HistoryFiltersTab = $$(this.Id + "Context" + "HistoryFiltersTab")

    this.Views.TableToolbar = $$(this.Id + "Context" + "TableToolbar");
    this.Views.Table = $$(this.Id + "Context" + "Table");

    this.Views.HistoryTable = $$(this.Id + "Context" + "HistoryTable");
    this.Views.HistoryTablePaging = $$(this.Id + "Context" + "HistoryTable" + "Paging");

    this.Views.SavedFiltersTable = $$(this.Id + "Context" + "SavedFiltersTable");
    this.Views.SavedFiltersTablePaging = $$(this.Id + "Context" + "SavedFiltersTable" + "Paging");

    this.Views.SaveFilterBtn = $$(_this.Id + "Context" + "SaveFilterBtn");
    this.Views.SavedFilterLabel = $$(_this.Id + "Context" + "SavedFilterLabel");

    this.Views.FilterHelpBtn = $$(_this.Id + "Context" + "Filter" + "ShowHelpBtn");

    this.HelpContext = webix.ui(this.HelpContextConfig);

    this.Views.HelpContextBody = $$(this.Id + "HelpContextBody");

    this.Subscriptions.ResetStateSignalSubscription = this.ResetStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.SetFilterBtnBage();
        }
    });

    this.Subscriptions.SignalFiltersUpdatedSubscription = this.ViewModel.SignalFiltersListUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateHistoryTable();
        }
    });

    this.Subscriptions.SignalSavedFiltersViewModelUpdatedSubscription = this.SavedFiltersViewModel.SignalFiltersListUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateSavedFiltersTable();
        }
    });

    this.Subscriptions.HistoryTableRowsSelectedCountSubscription = this.HistoryTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.HistoryTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.SavedFiltersTableRowsSelectedCountSubscription = this.SavedFiltersTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.SavedFiltersTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.SignalFiltersByCodeUpdatedSubscription = this.ViewModel.SignalFiltersByCodeUpdated.subscribe(function (Code)
    {
        _this.UpdateFilterStateByCode(Code);
    });

    this.Subscriptions.SaveFilterSubscription = this.RestoreSavedStateSignal.subscribe(function (Updated)
    {
        if (Updated)
        {
            if (_this.Views.SaveFilterBtn.isVisible())
                _this.Views.SaveFilterBtn.hide();
        }
    });

    this.Views.SavedFiltersTable.attachEvent("onAfterEditStop", function(state, editor, ignoreUpdate)
    {
        if (ignoreUpdate)
        {
            this.editCancel();
            return;
        } else {
            var max = this.config.columns.length;
            var now = this.getColumnIndex(editor.column);

            for (var i=now+1; i<max; i++)
                if (this.config.columns[i].editor)
                    return false;
        }

        _this.SaveSavedFilters(editor.row);

        return false;
    });

    this.Views.Table.attachEvent("onDataUpdate", function ()
    {
        if (!_this.Views.SaveFilterBtn.isVisible())
            _this.Views.SaveFilterBtn.show();
    })

    if(!this.State.length)
        this.SetDefaultState();

    if(this.EnableShowHotkey)
    {
        this.KeyEventsIds.ShowFilterKeyEvent = webix.uid();

        webix.event(window, "keydown", function(e){
            if(e.keyCode == 70 && e.ctrlKey && e.shiftKey)
            {
                e.cancelBubble = true;
                e.returnValue = false;

                if (e.stopPropagation) {
                    e.stopPropagation();
                    e.preventDefault();
                }

                if(_this.Context && _this.Views.FilterBtn.isVisible() && _this.Views.FilterBtn.isEnabled()) {
                    if(_this.Context.isVisible()) {
                        _this.Hide();
                    } else {
                        _this.Show();
                    }
                }

                return false;
            }
        }, {id:_this.KeyEventsIds.ShowFilterKeyEvent});
    }
};

QoEPopupFilterWidget.prototype.BindPopupHotKeys = function ()
{
    let _this = this;

    for (let item in _this.HotkeysDic)
    {
        let keyCode = _this.HotkeysDic[item].code;
        let bind = _this.HotkeysDic[item].bind;

        if (!bind)
            continue;

        webix.UIManager.addHotKey(keyCode, function() {
            _this.KeyPressHandler(keyCode);
        })
    }

    this.KeyEventsIds.BrowserHotkeysEventId = webix.uid();

    webix.event(window, "keydown", function(e){
        if (
            (e.keyCode == 83 && e.ctrlKey) ||   // disable Ctrl+s
            (e.keyCode == 82 && e.ctrlKey) ||   // disable Ctrl+r
            (e.keyCode == 70 && e.ctrlKey) ||   // disable Ctrl+f
            (e.keyCode == 72 && e.ctrlKey)      // disable Ctrl+h

        )
        {
            e.cancelBubble = true;
            e.returnValue = false;

            if (e.stopPropagation) {
                e.stopPropagation();
                e.preventDefault();
            }

            return false;
        }
    }, {id:_this.KeyEventsIds.BrowserHotkeysEventId});
};

QoEPopupFilterWidget.prototype.UnbindHotKeys = function ()
{
    let _this = this;

    for (let item in _this.HotkeysDic)
    {
        let keyCode = _this.HotkeysDic[item].code;
        let bind = _this.HotkeysDic[item].bind;

        if (!bind)
            continue;

        webix.UIManager.removeHotKey(keyCode);
    }
    if (_this.KeyEventsIds.BrowserHotkeysEventId) {
        webix.eventRemove(_this.KeyEventsIds.BrowserHotkeysEventId);
        _this.KeyEventsIds.BrowserHotkeysEventId = null;
    }
};

QoEPopupFilterWidget.prototype.KeyPressHandler = function (key)
{
    let _this = this;

    if (_this.HelpContext.isVisible()) {
        _this.HelpContext.hide();
        webix.UIManager.setFocus(_this.Views.Table);
        return;
    }
    if (_this.FilterWidgetHelpContext.isVisible()) {
        _this.FilterWidgetHelpContext.hide();
        webix.UIManager.setFocus(_this.Views.Table);
        return;
    }

    let view = webix.UIManager.getFocus();

    if (_this.SavedFilterDeleteContext.isVisible())
    {
        switch (key)
        {
            case "Enter":
                let selectedId = _this.Views.SavedFiltersTable.getSelectedId();
                let prevId = _this.Views.SavedFiltersTable.getPrevId(selectedId);
                let nexId = _this.Views.SavedFiltersTable.getNextId(selectedId);
                let idToSelect = prevId ? prevId : nexId;
                if(selectedId) {
                    _this.DeleteSavedFilter(selectedId.id);
                    webix.UIManager.setFocus(_this.Views.SavedFiltersTable);
                    if (idToSelect)
                        _this.Views.SavedFiltersTable.select(idToSelect);
                }
                _this.SavedFilterDeleteContext.hide();
                break;
            case "Esc":
                _this.SavedFilterDeleteContext.hide();
                webix.UIManager.setFocus(_this.Views.SavedFiltersTable);
                break;
        }
        return;
    }

    switch (key)
    {
        case "ArrowLeft":

            if(_this.Views.Table.getEditor())
                break;

            if(_this.Views.Table.getSelectedId()) {
                _this.Views.Table.editStop();
                _this.Views.Table.unselectAll();
            }
            if(_this.Views.SavedFiltersTable.isVisible()) {
                view = _this.Views.SavedFiltersTable;
            } else if (_this.Views.HistoryTable.isVisible()) {
                view = _this.Views.HistoryTable;
            }
            webix.UIManager.setFocus(view);
            break;
        case "ArrowRight":
            webix.UIManager.setFocus(_this.Views.Table);
            break;
        case "Enter":
            if(this.PopupEditorIsOpen)
            {
                this.PopupEditorIsOpen = false;
                break;
            }
            if ([_this.Views.SavedFiltersTable, _this.Views.Table].includes(view) && view.getEditState())
            {
                view.editStop();
            }
            else
            {
                _this.FilterApply();
            }
            break;
        case "Shift+Enter":
            if(_this.Views.Table.getEditState())
                break;

            let selectedId = _this.Views.Table.getSelectedId();
            if (selectedId)
            {
                let item = _this.Views.Table.getItem(selectedId);
                item.f_enabled = item.f_enabled ? 0 : 1;
                _this.Views.Table.updateItem(selectedId, item);
            }
            break;
        case "Esc":
            if ([_this.Views.SavedFiltersTable, _this.Views.Table].includes(view) && view.getEditState()) {
                view.editStop();
            } else {
                _this.FilterCancel();
            }
            break;
        case "delete":
            if ([_this.Views.SavedFiltersTable, _this.Views.Table].includes(view) && !view.getEditState())
            {
                let selectedId = view.getSelectedId();
                if (selectedId)
                {
                    if (view === _this.Views.Table) {
                        _this.Views.Table.remove(selectedId);
                    } else {
                        let node = _this.Views.SavedFiltersTable.getItemNode(selectedId)
                        _this.SavedFilterDeleteContext.show(node, {pos: "bottom"});
                    }
                }
            }
            break;
        case "Ctrl+s":
            if (_this.Views.SaveFilterBtn.isVisible()) {
                _this.FilterSave();
                _this.Views.SaveFilterBtn.hide();
            }
            break;
        case "Ctrl+r":
            _this.SavedFiltersUnselect();
            _this.Views.HistoryTable.unselectAll();
            _this.Views.Table.unselectAll();
            _this.HistoryRefresh();
            _this.SavedFiltersRefresh();
            break;
        case "Ctrl+f":
            if (!_this.Views.SavedFiltersTable.isVisible()) {
                _this.FocusToSavedFiltersTable();
            }
            _this.SavedFiltersUnselect();
            _this.Views.HistoryTable.unselectAll();
            _this.AddItemToSavedFilters();
            break;
        case "Ctrl+h":
            _this.FilterWidgetHelpContext.show(_this.Views.FilterHelpBtn.getNode(), {pos:"right"});
            break;
    }
};

QoEPopupFilterWidget.prototype.FilterApply = function ()
{
    let _this = this;

    _this.ApplyState();
    _this.Hide();
};

QoEPopupFilterWidget.prototype.DeleteAllFilterSettings = function()
{
    this.Views.Table.clearAll();
    this.State = [];

    if(this.Views.SavedFiltersTable && this.Views.SavedFiltersTable.getSelectedItem())
    {
        this.Views.SaveFilterBtn.show();
    }
    else
    {
        this.Views.SaveFilterBtn.hide();
    }
};

QoEPopupFilterWidget.prototype.FilterCancel = function ()
{
    let _this = this;

    _this.RestoreCurrentFilterState();
    _this.ResetState();
    _this.SavedFiltersUnselect();
    _this.Views.SaveFilterBtn.hide();
    _this.Hide();
};

QoEPopupFilterWidget.prototype.SavedFiltersUnselect = function ()
{
    let _this = this;

    _this.Views.SavedFiltersTable.unselectAll();
    _this.CurrentSelectedFilter = null;
    _this.DefineFilterLabel();
};

QoEPopupFilterWidget.prototype.FilterSave = function ()
{
    let _this = this;

    let selectedRow = _this.Views.SavedFiltersTable.getSelectedId();

    if (selectedRow) {
        _this.SaveSavedFilters(selectedRow);
    } else {
        _this.SetCurrentState();
        _this.Views.Tabbar.setValue(_this.Id + "Context" + "SavedFiltersTab");
        _this.Views.SavedFiltersTab.show();
        _this.AddItemToSavedFilters();
    }
};

QoEPopupFilterWidget.prototype.FocusToSavedFiltersTable = function ()
{
    let _this = this;

    let idToSelect = _this.CurrentSelectedFilter ? _this.CurrentSelectedFilter.id : _this.Views.SavedFiltersTable.getFirstId();

    _this.Views.Tabbar.setValue(_this.Id + "Context" + "SavedFiltersTab");
    _this.Views.SavedFiltersTab.show();
    if(idToSelect)
        _this.Views.SavedFiltersTable.select(idToSelect);
        webix.UIManager.setFocus(_this.Views.SavedFiltersTable);
};

QoEPopupFilterWidget.prototype.FocusHistoryTable = function ()
{
    let _this = this;

    let selectedId = _this.Views.HistoryTable.getSelectedId();
    let idToSelect = selectedId ? selectedId : _this.Views.HistoryTable.getFirstId();

    _this.Views.Tabbar.setValue(_this.Id + "Context" + "HistoryFiltersTab");
    _this.Views.HistoryTable.show();
    if(idToSelect)
        _this.Views.HistoryTable.select(idToSelect);
        webix.UIManager.setFocus(_this.Views.HistoryTable);
};

QoEPopupFilterWidget.prototype.FocusToFilterTable = function ()
{
    let _this = this;

    let selectedId = _this.Views.Table.getSelectedId();
    let idToSelect = selectedId ? selectedId : _this.Views.Table.getFirstId();

    if(idToSelect)
        _this.Views.Table.select(idToSelect);

    webix.UIManager.setFocus(_this.Views.Table);
};


QoEPopupFilterWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.UnbindHotKeys();

    if (_this.KeyEventsIds.ShowFilterKeyEvent) {
        webix.eventRemove(_this.KeyEventsIds.ShowFilterKeyEvent);
        _this.KeyEventsIds.ShowFilterKeyEvent = null;
    }

    this.ViewModel = null;

    this.SavedFiltersViewModel = null;
};

QoEPopupFilterWidget.prototype.GetFiltersDic = function ()
{
    var filters = [];

    if(this.Config && this.Config.filters)
    {
        this.Config.filters.forEach(function (Filter)
        {
            filters.push({id:Filter.id, value:Filter.title});
        });
    }

    return filters;
};

QoEPopupFilterWidget.prototype.GetFilterConfigById = function (FilterId)
{
    var config = null;

    if(this.Config && this.Config.filters && FilterId)
    {
        this.Config.filters.every(function (Filter)
        {
            if(Filter.id == FilterId)
            {
                config = webix.copy(Filter);
                return false;
            }

            return true;
        });
    }

    return config;
};

QoEPopupFilterWidget.prototype.SetDefaultState = function ()
{
    var data = [];

    if(this.Config && this.Config.default)
    {
        this.Config.default.forEach(function (Default)
        {
            data.push(new QoEPopupFilterWidgetFilterRowModel(Default));
        });
    }

    this.State = data;

    this.ResetState();
};

QoEPopupFilterWidget.prototype.ApplyState = function (Silent)
{
    this.Views.Table.editStop();

    var rows = this.Views.Table.serialize();

    var data = [];

    rows.forEach(function (Row)
    {
        var model = new QoEPopupFilterWidgetFilterRowModel(Row);

        if(model.f_id && model.f_operator)
            data.push(model);
    });

    this.State = data;

    if(Silent)
        return;

    this.SavedFiltersUnselect();

    this.ResetState();

    this.SaveHistory();

    this.ApplyStateSignal.next(1);
};

QoEPopupFilterWidget.prototype.ResetState = function ()
{
    this.Views.Table.editStop();

    this.Views.Table.clearAll();

    this.Views.Table.parse(webix.copy(this.State));

    if(this.Views.SavedFiltersTable.getSelectedItem())
    {
        this.Views.SaveFilterBtn.show();
    }

    this.ResetStateSignal.next(1);
};

QoEPopupFilterWidget.prototype.GetState = function ()
{
    return webix.copy(this.State);
};

QoEPopupFilterWidget.prototype.SetCurrentState = function ()
{
    var rows = this.Views.Table.serialize();

    var data = [];

    rows.forEach(function (Row)
    {
        var model = new QoEPopupFilterWidgetFilterRowModel(Row);

        if(model.f_id && model.f_operator)
            data.push(model);
    });

    this.State = data;
};

QoEPopupFilterWidget.prototype.SetState = function (State)
{
    this.State = State && Array.isArray(State) && State.length ? webix.copy(State) : [];

    this.ResetState();
};

QoEPopupFilterWidget.prototype.GetFilters = function ()
{
    var _this = this;

    var data = webix.copy(this.State);

    var filters = {};

    data.forEach(function (Data)
    {
        if(Data.f_enabled)
        {
            var filterConfig = _this.GetFilterConfigById(Data.f_id);

            var id = Data.f_id

            var value = Data.f_value;

            if(
                Data.f_operator == QoEFilterOperatorsEnum.in ||
                Data.f_operator == QoEFilterOperatorsEnum["not in"] ||
                Data.f_operator == QoEFilterOperatorsEnum["in CIDRs"] ||
                Data.f_operator == QoEFilterOperatorsEnum["not in CIDRs"] ||
                Data.f_operator == QoEFilterOperatorsEnum.between ||
                Data.f_operator == QoEFilterOperatorsEnum["not between"])
            {
                if(filterConfig && (filterConfig.dic || filterConfig.options))
                {
                    value = value.split(",");

                    value.forEach(function (Value, Index)
                    {
                        // value[Index] = parseInt(Value,10);

                        let val = parseInt(Value, 10);
                        if (!isNaN(val))
                        {
                            value[Index] = parseInt(Value,10);
                        }
                    });
                }
                else
                {
                    value = value.split("\n");
                }
            }

            if(filterConfig && filterConfig.operator_type === "bitwise" && Array.isArray(value) && value.length)
                value = value[0]

            var sql_type = QoEFilterSqlType.where;

            var type = QoEFilterValueType.String;

            var view = "";

            var operator_type = "";

            var filterConfig = _this.GetFilterConfigById(Data.f_id);

            if(filterConfig && filterConfig.sql_type && QoEFilterSqlType[filterConfig.sql_type])
                sql_type = filterConfig.sql_type;

            if(filterConfig && filterConfig.type && QoEFilterValueType[filterConfig.type])
                type = filterConfig.type;

            if(filterConfig && filterConfig.view)
                view = filterConfig.view;

            if(filterConfig && filterConfig.operator_type && QoEFilterOperatorsTypesEnum[filterConfig.operator_type])
                operator_type = filterConfig.operator_type;

            if(filterConfig && filterConfig.opertor_view && filterConfig.opertor_view[Data.f_operator])
            {
                view = filterConfig.opertor_view[Data.f_operator];
            }

            if(Data.f_operator == QoEFilterOperatorsEnum.between || Data.f_operator == QoEFilterOperatorsEnum["not between"])
            {
                value = [
                    value[0] ? value[0] : "",
                    value[1] ? value[1] : ""
                ]
            }

            if(type == QoEFilterValueType.UInt8 || type == QoEFilterValueType.UInt16 || type == QoEFilterValueType.UInt32 || type == QoEFilterValueType.UInt64)
            {
                if(Array.isArray(value))
                {
                    value.forEach(function (V, I)
                    {
                        value[I] = V == parseInt(V) ? parseInt(V) : 0;
                    });
                }
                else
                {
                    value = value == parseInt(value) ? parseInt(value) : 0;
                }
            }

            if(type == QoEFilterValueType.Float32 || type == QoEFilterValueType.Float64)
            {
                if(Array.isArray(value))
                {
                    value.forEach(function (V, I)
                    {
                        value[I] = V == parseFloat(V) ? parseFloat(V) : 0;
                    });
                }
                else
                {
                    value = value == parseFloat(value) ? parseFloat(value) : 0;
                }
            }

            if((Data.f_operator == QoEFilterOperatorsEnum["in CIDRs"] || Data.f_operator == QoEFilterOperatorsEnum["not in CIDRs"]) && view)
            {
                id = "toUInt64(IPv4StringToNum("+id+"))";
            }

            filters[Data.id] = new QoEFilterModel({
                id:id,
                operator:Data.f_operator,
                operator_type:operator_type,
                value:value, sql_type:sql_type,
                type:type,
                view:view
            });
        }

    });

    return filters;
};

QoEPopupFilterWidget.prototype.SetFilterBtnBage = function ()
{
    if(!this.Embedded && this.Views.FilterBtn)
    {
        var filters = this.GetFilters();

        var count = Object.keys(filters).length;

        count = count >= 100 ? "99+":count;

        this.Views.FilterBtn.define({badge:count});
        this.Views.FilterBtn.refresh();
    }
};

QoEPopupFilterWidget.prototype.Show = function (Node, Pos)
{
    if(!this.Embedded)
    {
        this.Context.show();
    }

    this.HistoryRefresh();

    this.SavedFiltersRefresh();

    this.SaveCurrentFilterState();

    // webix.UIManager.setFocus(this.Views.Table);

    this.FocusToFilterTable();

    this.BindPopupHotKeys();
};

QoEPopupFilterWidget.prototype.Hide = function ()
{
    if(!this.Embedded) {
        this.Context.hide();
        if(this.Views.FilterBtn)
            this.Views.FilterBtn.blur();
    }

    [this.Views.SavedFiltersTable, this.Views.Table].forEach(function(view) {
        view.editStop();
    })

    this.UnbindHotKeys();
};

QoEPopupFilterWidget.prototype.EnableBtn = function ()
{
    if (!this.Embedded && this.Views.FilterBtn)
        this.Views.FilterBtn.enable();
};

QoEPopupFilterWidget.prototype.DisableBtn = function ()
{
    if(!this.Embedded && this.Views.FilterBtn)
        this.Views.FilterBtn.disable();
};

QoEPopupFilterWidget.prototype.HistoryRefresh = function (Page)
{
    var _this = this;

    var state = this.Views.HistoryTable.getState();

    var filter =  webix.copy(state.filter);

    if(this.Config && this.Config.type)
        filter = webix.extend(filter, {type: this.Config.type}, true);

    this.ViewModel.RefreshFiltersList({page:Page, filter:filter, sort:state.sort ? state.sort:null, callback:function () {}})
};

QoEPopupFilterWidget.prototype.GetHistoryTableSelectedData = function ()
{
    return this.Views.HistoryTable.getSelectedItem();
};

QoEPopupFilterWidget.prototype.UpdateHistoryTable = function (Params)
{
    var _this = this;

    this.Views.HistoryTable.clearAll();
    this.Views.HistoryTable.parse(_this.ViewModel.GetFiltersList());

    this.Views.HistoryTablePaging.define(this.ViewModel.FiltersListFilter.total);
    this.Views.HistoryTablePaging.refresh();
};

QoEPopupFilterWidget.prototype.OnHistoryTableRowSelect = function ()
{
    var data = this.GetHistoryTableSelectedData();

    this.HistoryTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEPopupFilterWidget.prototype.OnHistoryTableRowUnSelect = function ()
{
    var data = this.GetHistoryTableSelectedData();

    this.HistoryTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEPopupFilterWidget.prototype.HistoryTableRowsSelectedCountSubscriptionHandler = function (Value)
{
    if(!Value)
        return;

    var _this = this;

    var selectedData = _this.GetHistoryTableSelectedData();

    if(!selectedData || !selectedData.form_data)
        return;

    var data;

    try
    {
        data = JSON.parse(selectedData.form_data);
    }
    catch (e)
    {
        return;
    }

    if(!data || !data.filter_state)
        return;

    this.SetState(data.filter_state);

    this.RestoreSavedStateSignal.next(1);
};

QoEPopupFilterWidget.prototype.SaveHistory = function ()
{
    var _this = this;

    this.CurrentFilterCode = webix.uid().toString();

    var filterData = new QoESubscribersFilterListItemModel({type: this.Config.type, code: this.CurrentFilterCode});

    var formData = new QoEFilterFormModel({filter_state:this.GetState()});

    this.ViewModel.SaveFiltersListItem({filter:filterData, filter_form:formData, callback:function (R)
        {
            if(!R.success && R.error)
                webix.message({text:R.error.msg,type:"error"});
        }});
};

QoEPopupFilterWidget.prototype.GetFilterCode = function ()
{
    return this.CurrentFilterCode ? this.CurrentFilterCode : null;
};

QoEPopupFilterWidget.prototype.SetFilterCode = function (Code, JustSet)
{
    this.CurrentFilterCode = Code ? Code : null;

    if(JustSet)
    {
        return;
    }

    if(this.CurrentFilterCode)
    {
        this.FilterReadySignal.next(0);
        this.ViewModel.RefreshFiltersByCode({
            code:this.CurrentFilterCode,
            callback:function (R) {
                if(!R.success && R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        });
    }
    else
    {
        this.FilterReadySignal.next(1);
    }
};

QoEPopupFilterWidget.prototype.UpdateFilterStateByCode = function (Code)
{
    var _this = this;

    var code = Code ? Code : this.CurrentFilterCode

    if(code)
    {
        var filter = _this.ViewModel.GetFilterByCode(code);

        if(filter && filter.form_data)
        {
            var data;

            try
            {
                data = JSON.parse(filter.form_data);
            }
            catch (e)
            {
                return;
            }

            if(!data || !data.filter_state)
                return;

            _this.SetState(data.filter_state);
        }

        _this.FilterReadySignal.next(1);
    }
};

QoEPopupFilterWidget.prototype.SaveCurrentFilterState = function ()
{
    this.LastState = webix.copy(this.State);

    this.LastFilterCode = this.CurrentFilterCode;
};

QoEPopupFilterWidget.prototype.RestoreCurrentFilterState = function ()
{
    this.State = webix.copy(this.LastState);

    this.CurrentFilterCode = this.LastFilterCode;
};

QoEPopupFilterWidget.prototype.SavedFiltersRefresh = function (Page)
{
    var _this = this;

    var state = this.Views.SavedFiltersTable.getState();

    var filter =  webix.copy(state.filter);

    if(this.Config && this.Config.type)
        filter = webix.extend(filter, {type: this.Config.type, saved:true}, true);

    this.SavedFiltersViewModel.RefreshFiltersList({page:Page, filter:filter, sort:state.sort ? state.sort:null, callback:function () {}})
};

QoEPopupFilterWidget.prototype.GetSavedFiltersTableSelectedData = function ()
{
    return this.Views.SavedFiltersTable.getSelectedItem();
};

QoEPopupFilterWidget.prototype.UpdateSavedFiltersTable = function (Params)
{
    let _this = this;

    let data = _this.SavedFiltersViewModel.GetFiltersList();

    _this.Views.SavedFiltersTable.clearAll();
    _this.Views.SavedFiltersTable.parse(data);

    _this.CurrentSelectedFilter = _this.UpdateFilterItem(_this.CurrentSelectedFilter)

    if (_this.CurrentSelectedFilter)
    {
        _this.Views.SavedFiltersTable.select(_this.CurrentSelectedFilter.id)
    }

    _this.Views.SavedFiltersTablePaging.define(_this.SavedFiltersViewModel.FiltersListFilter.total);
    _this.Views.SavedFiltersTablePaging.refresh();
};

QoEPopupFilterWidget.prototype.OnSavedFiltersTableRowSelect = function ()
{
    var data = this.GetSavedFiltersTableSelectedData();

    this.SavedFiltersTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEPopupFilterWidget.prototype.OnSavedFiltersTableRowUnSelect = function ()
{
    var data = this.GetSavedFiltersTableSelectedData();

    this.SavedFiltersTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEPopupFilterWidget.prototype.SavedFiltersTableRowsSelectedCountSubscriptionHandler = function (Value)
{
    if(!Value)
        return;

    var _this = this;

    var selectedData = _this.GetSavedFiltersTableSelectedData();

    if(!selectedData || !selectedData.form_data)
        return;

    var data;

    try
    {
        data = JSON.parse(selectedData.form_data);
    }
    catch (e)
    {
        return;
    }

    if(!data || !data.filter_state)
        return;

    this.SetState(data.filter_state);

    this.RestoreSavedStateSignal.next(1);
};

QoEPopupFilterWidget.prototype.SaveSavedFilters = function (RowId)
{
    var _this = this;

    this.ApplyState(true);

    var filterData;

    this.CurrentFilterCode = webix.uid().toString();

    if(RowId)
        filterData = this.Views.SavedFiltersTable.getItem(RowId);
    else
        filterData = this.GetSavedFiltersTableSelectedData();

    if (!filterData)
        return;

    filterData.valid = true;

    filterData = new QoESubscribersFilterListItemModel(webix.extend(filterData,{type: this.Config.type, code: this.CurrentFilterCode}, true));

    var formData = new QoEFilterFormModel({filter_state:this.GetState()});

    this.SavedFiltersViewModel.SaveFiltersListItem({filter:filterData, filter_form:formData, callback:function (R)
        {
            if(R.success && R.data && R.data.filter)
            {
                _this.Views.SavedFiltersTable.updateItem(filterData.id,  new QoESubscribersFilterListItemModel(R.data.filter));
                _this.Views.SaveFilterBtn.hide();

                webix.message(LangHelper.GetString("QoEPopupFilterWidget","Filter is saved"));
            }
            else
            {
                filterData.valid = false;

                _this.Views.SavedFiltersTable.validate(filterData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});

};

QoEPopupFilterWidget.prototype.AddItemToSavedFilters = function ()
{
    var model = new QoESubscribersFilterListItemModel({type:this.Config.type});

    model.title = LangHelper.GetString("QoEPopupFilterWidget", "New filter");
    this.Views.SavedFiltersTable.add(model, 0);
    this.Views.SavedFiltersTable.select(model.id, false);
    this.Views.SavedFiltersTable.editCell(model.id, "title");
};

QoEPopupFilterWidget.prototype.DeleteSavedFilter = function (RowId)
{
    var _this = this;

    var filterData = this.Views.SavedFiltersTable.getItem(RowId);
    filterData.valid = true;

    if(filterData.filter_id > 0)
    {
        this.SavedFiltersViewModel.DeleteFiltersListItem({filter:filterData, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.SavedFiltersTable.remove(RowId);

                    webix.message(LangHelper.GetString("All","Deleted"));
                }
                else
                {
                    filterData.valid = false;
                    _this.Views.SavedFiltersTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
    else
    {
        this.Views.SavedFiltersTable.remove(RowId);
    }
};

QoEPopupFilterWidget.prototype.SetConfig = function (Config, RefreshSavedFiltersTable = true)
{
    this.Config = Config;

    var columnConfig = this.Views.Table.getColumnConfig("f_id");

    if(columnConfig.collection) {
        var options = columnConfig.collection;
        options.clearAll();
        options.parse(this.GetFiltersDic());
    }
    else {
        this.Views.Table.config.columns = this.Views.Table.config.columns.map(column => {
            if(column.id === "f_id") {
                return {
                    id:"f_id",
                    header:[TooltipTemplate(LangHelper.GetString("QoEPopupFilterWidget", "Filter"))],
                    fillspace:1,
                    editor:"richselect",
                    suggest:{fitMaster:false, width:200},
                    options:this.GetFiltersDic()
                };
            }
            return column;
        });

        this.Views.Table.refreshColumns();
    }

    this.SetDefaultState();

    if (RefreshSavedFiltersTable)
        this.SavedFiltersRefresh();

    this.HistoryRefresh();
};

QoEPopupFilterWidget.prototype.SetHelpContextBodyText = function (Text)
{
    this.Views.HelpContextBody.define("rows",[{template:Text}]);
    this.Views.HelpContextBody.reconstruct();
};

QoEPopupFilterWidget.prototype.ShowHelpContext = function (Node, Pos, Text)
{
    if(Text)
        this.SetHelpContextBodyText(Text);

    this.HelpContext.show(Node, {pos:Pos});

};

QoEPopupFilterWidget.prototype.ShowFiltersOverlay = function()
{
    this.Views.TableToolbar.disable();
    this.Views.Table.showOverlay('<div class="of-empty-folder">' +
        ' <div class="of-empty-pad">' +
        '     <div class="of-empty-cloud-txt">'+LangHelper.GetString("QoEPopupFilterWidget", "There are no common filters")+'</div>' +
        ' </div>' +
        '</div>');
};

QoEPopupFilterWidget.prototype.HideFiltersOverlay = function()
{
    this.Views.TableToolbar.enable();
    this.Views.Table.hideOverlay();
};

QoEPopupFilterWidget.prototype.GetHelpTextByFilterConfig = function (FRow)
{
    var filterConfig = this.GetFilterConfigById(FRow.f_id);

    var noHelpFilters = ["locked", "blocked"];

    if(noHelpFilters.includes(FRow.f_id))
        return null;

    if((
        FRow.f_operator == QoEFilterOperatorsEnum.in ||
        FRow.f_operator == QoEFilterOperatorsEnum["not in"] ||
        FRow.f_operator == QoEFilterOperatorsEnum["in CIDRs"] ||
        FRow.f_operator == QoEFilterOperatorsEnum["not in CIDRs"] ||
        FRow.f_operator == QoEFilterOperatorsEnum.between ||
        FRow.f_operator == QoEFilterOperatorsEnum["not between"]) && !(filterConfig && filterConfig.dic))
    {
        return LangHelper.GetString("QoEPopupFilterWidget", "Values are separated by a new line. Use Shift + Enter to make new line.");
    }

    if(FRow.f_operator == QoEFilterOperatorsEnum.match || FRow.f_operator == QoEFilterOperatorsEnum["not match"])
    {
        return LangHelper.GetString("QoEPopupFilterWidget", "Use regular expression with RE2 syntax.") +
            "<br/>" +
            "<a href='https://support.google.com/a/answer/1371417?hl=" + LangHelper.GetLocale() + "' target='_blank'>" + LangHelper.GetString("QoE", "Link") + " 1</a>" +
            "<br/>" +
            "<a href='https://github.com/google/re2/wiki/Syntax' target='_blank'>" + LangHelper.GetString("QoE", "Link") + " 2</a>" +
            "<br/>" +
            "<a href='https://github.com/google/re2' target='_blank'>" + LangHelper.GetString("QoE", "Link") + " 3</a>";
    }

    if(FRow.f_operator == QoEFilterOperatorsEnum.like || FRow.f_operator == QoEFilterOperatorsEnum["not like"])
    {
        return LangHelper.GetString("QoEPopupFilterWidget", "Checks whether a string matches a simple regular expression.");
    }

    return null;
};

QoEPopupFilterWidget.prototype.DefineFilterLabel = function (Item)
{
    let _this = this;

    let label = Item&&Item.title ? Item.title : "";
    _this.Views.SavedFilterLabel.define({label: label});
    _this.Views.SavedFilterLabel.refresh();
};

QoEPopupFilterWidget.prototype.UpdateFilterItem = function (Filter)
{
    let _this = this;

    let updatedFilter;

    if (Filter&&Filter.filter_id)
    {
        let data = _this.SavedFiltersViewModel.GetFiltersList();
        updatedFilter = data.find(obj => obj.filter_id === Filter.filter_id);
    }
    return updatedFilter;
}

QoEPopupFilterWidget.prototype.ParseStateFromFilter = function (Filter)
{
    let _this = this;

    let data;

    try
    {
        data = JSON.parse(Filter.form_data);
    }
    catch (e)
    {
        data = [];
    }

    return data;
};

QoEPopupFilterWidget.prototype.GetLocales = function (filterIds = null)
{
    let result = {};

    if(!filterIds)
    {
        let filterItems = this.Views.Table.serialize();
        filterItems = filterItems.filter(item => item.f_enabled);
        filterIds = filterItems.map(item => item.f_id);
    }

    let langCode = LangHelper.GetLocale();
    let reverseDic = LangHelper.GetReverseLangDic(langCode);

    filterIds.forEach(filterId => {
        let find = null;
        let langKeys = [];
        let locales = {};

        for(let key in QoEPopupFilterWidgetConfigTypeEnum)
        {
            let type = QoEPopupFilterWidgetConfigTypeEnum[key];
            let filterConfigs = QoEPopupFilterWidgetDefaultConfig(type).filters;
            find = filterConfigs.find(item => item.id === filterId)

            if(find)
                break;
        }

        if(find)
        {
            langKeys = LangHelper.SearchLangKeys(find.title, reverseDic);

            for(let code in LocalesEnum)
            {
                locales[code] = LangHelper.GetStringByLangKeys(code, langKeys)
            }

            result[filterId] = locales;
        }
    });

    return result;
};

QoEPopupFilterWidget.prototype.DisableWidget = function()
{
    this.IsWidgetEnabled = false;

    if(this.Views.FilterBtn)
        this.Views.FilterBtn.disable();
};
function QoESavedFiltersListWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.Views = {
        Table:null,
        Paging:null,
        AddFilterBtn:null,
        AddSubfilterBtn:null,
        Widgets:
        {
            ExtendedFillter:null,
            Wizard:ViewConfig.wizard?ViewConfig.wizard:null,
        }
    };

    this.FilterDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("QoEPopupFilterWidget","Are you sure you want to delete the filter?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.FilterDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            //id: this.Id + "FilterDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.FilterDeleteContext.hide();

                                var selected = _this.GetTableSelectedData();

                                if(selected)
                                    _this.DeleteFilter(selected.id);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.TableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.FilterId = 0;

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

QoESavedFiltersListWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.ViewConfig = {
        rows:[
            {
                view: "toolbar",
                height: 32,
                padding: 0,
                margin: 0,
                elements: function() {
                    const buttons = [
                        {
                            view: "button",
                            id:_this.Id + "AddFilterBtn",
                            type: "icon",
                            icon: "plus",
                            width: 32,
                            css:"toolbar_round_btn",
                            tooltip:LangHelper.GetString(this.Id,"Add filter"),
                            click: function (id, e, node)
                            {
                                _this.AddItem();
                            }
                        },
                        {
                            view: "button",
                            id:_this.Id + "AddSubFilterBtn",
                            type: "icon",
                            icon: "plus-square",
                            width: 32,
                            css:"toolbar_round_btn",
                            tooltip:LangHelper.GetString(this.Id,"Add subfilter"),
                            click: function (id, e, node)
                            {
                                _this.AddSubItem();
                            }
                        },
                        {},
                        {
                            view: "button",
                            id:_this.Id+"RefreshFiltersListBtn",
                            type: "icon",
                            icon: "refresh",
                            css: "toolbar_round_btn",
                            width: 32,
                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                            click: function (id, e, node)
                            {
                                _this.RefreshTable();
                            }
                        }
                    ];
                    if(ViewConfig.wizard) {
                        buttons.splice(0, 0, {
                            view: "button",
                            id: _this.Id + "WizardBtn",
                            type: "icon",
                            icon: "magic",
                            css: "toolbar_round_btn",
                            width: 32,
                            tooltip: LangHelper.GetString("QoE", "Flow capture"),
                            click: function()
                            {
                                _this.Views.Widgets.Wizard.Show(this.getNode(), {pos:"button"});
                            }
                        });
                        buttons.splice(1, 0, {width:16});
                    }

                    return buttons;
                }(),
            },
            BlockHeaderTemplate({title:ViewConfig.title ? ViewConfig.title : "", icon:ViewConfig.icon ? ViewConfig.icon : ""}),
            {
                view:"treetable",
                id:this.Id + "Table",
                select: "row",
                scroll:"xy",
                editable:true,
                editaction: "custom",
                columns:ViewConfig.columns ? ViewConfig.columns : [
                    {
                        id: "edit",
                        header: "",
                        width: 32,
                        template: CellEditBtnTemplate,
                        headermenu: false
                    },
                    {
                        id: "filter",
                        header: "",
                        width: 40,
                        template: CellFilterBtnTemplate,
                        headermenu: false
                    },
                    {
                        id:"title",
                        header:[LangHelper.GetString("QoEPopupFilterWidget", "Filter"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        fillspace:true,
                        sort:"string",
                        editor:"text",
                        template:function(obj, common, value, config)
                        {
                            return common.treetable(obj, common, value, config) + (obj.title?obj.title:"");
                        }
                    },
                    {
                        id: "trash",
                        header: "",
                        width: 32,
                        template: CellTrashBtnTemplate,
                        headermenu: false
                    }
                ],
                on: {
                    onItemDblClick: function(id)
                    {
                        this.editRow(id);
                    },
                    onItemClick: function (id)
                    {
                        if(id.column === 'edit')
                        {
                            this.editRow(id);
                        }
                        if(id.column === 'filter')
                        {
                            var node = this.getItemNode(id);
                            _this.Views.Widgets.ExtendedFillter.Show(node, "right");
                        }
                        else if(id.column === 'trash')
                        {
                            var __this = this;

                            var data = this.getItem(id);

                            if(!data.filter_id)
                            {
                                _this.DeleteFilter(id);
                                return;
                            }

                            setTimeout(function ()
                            {
                                var node = __this.getItemNode(id);
                                _this.FilterDeleteContext.show(node, {pos:"bottom"});
                            }, 10);
                        }
                    },
                    onBeforeFilter:function()
                    {
                        return false;
                    },
                    onAfterFilter:function()
                    {
                        _this.RefreshTable();
                    },
                    onBeforeSort:function()
                    {
                        _this.RefreshTable();

                        return false;
                    },
                    onAfterSelect:function ()
                    {
                        _this.OnTableRowSelect();
                    },
                    onAfterUnSelect:function ()
                    {
                        _this.OnTableRowUnSelect();
                    }
                }
            },
            {
                view: "pager",
                id: this.Id + "Paging",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                master:false,
                on: {
                    onAfterPageChange:function(Page)
                    {
                        _this.RefreshTable(Page);
                    }
                }
            }
        ]
    };
};

QoESavedFiltersListWidget.prototype.Bind = function (ViewController, ViewModel, ExtendedFillter)
{
    var _this = this;

    if(!ViewController || !ViewController.ViewModel)
        return;

    this.ViewModel = ViewModel ? ViewModel : new QoESavedFiltersListWidgetManager();

    this.Views.Widgets.ExtendedFillter = ExtendedFillter ? ExtendedFillter :  null;

    if(this.Views.Widgets.ExtendedFillter && this.Views.Widgets.Wizard) {
        this.Views.Widgets.Wizard.Bind();

        this.Subscriptions.WizardApplyStateSignal = this.Views.Widgets.Wizard.ApplySignal.subscribe(function(Val) {
            if(Val) {
                _this.WizardApplySignalHandler();
            }
        });
    }

    this.Views.Table = $$(this.Id + "Table");
    this.Views.Paging = $$(this.Id + "Paging");
    this.Views.AddFilterBtn = $$(this.Id + "AddFilterBtn");
    this.Views.AddSubFilterBtn = $$(this.Id + "AddSubFilterBtn");

    this.Views.Table.attachEvent("onAfterEditStop", function(state, editor, ignoreUpdate)
    {
        if (ignoreUpdate)
        {
            this.editCancel();
            return;
        } else {
            var max = this.config.columns.length;
            var now = this.getColumnIndex(editor.column);

            for (var i=now+1; i<max; i++)
                if (this.config.columns[i].editor)
                    return false;
        }

        _this.SaveFilter(editor.row);

        return false;
    });

    this.Subscriptions.TableRowsSelectedCountSubscription = this.TableRowsSelectedCount.subscribe(function (Value)
    {
        _this.TableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.SignalFiltersUpdatedSubscription = this.ViewModel.SignalFiltersListUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateTable();

            _this.Select(_this.FilterId);

            _this.FilterId = 0;
        }
    });
};

QoESavedFiltersListWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.ViewModel = null;

    this.Views.Widgets.ExtendedFillter = null;
};

QoESavedFiltersListWidget.prototype.AddItem = function ()
{
    var model = new QoESubscribersFilterListItemModel({type:this.Config.type});

    this.Views.Table.add(model, 0);
    this.Views.Table.select(model.id, false);

    this.Views.Widgets.ExtendedFillter.SetState();
};

QoESavedFiltersListWidget.prototype.AddSubItem = function ()
{
    var selectedModel = this.GetTableSelectedData();

    if(!selectedModel || !selectedModel.filter_id)
        return;

    var model = new QoESubscribersFilterListItemModel({parent_id:selectedModel.filter_id, type:this.Config.type});

    this.Views.Table.add(model,0,selectedModel.id);
    this.Views.Table.open(selectedModel.id);
    this.Views.Table.select(model.id, false);

    this.Views.Widgets.ExtendedFillter.SetState();
};

QoESavedFiltersListWidget.prototype.UpdateTable = function (Params)
{
    var _this = this;

    this.Views.Table.clearAll();
    this.Views.Table.parse(_this.ViewModel.GetFiltersList());

    this.Views.Paging.define(this.ViewModel.FiltersListFilter.total);
    this.Views.Paging.refresh();
};

QoESavedFiltersListWidget.prototype.RefreshTable = function (Page)
{
    var _this = this;

    var state = this.Views.Table.getState();

    var filter =  webix.copy(state.filter);

    if(this.Config) {
        if(this.Config.type)
            filter = webix.extend(filter, {type: this.Config.type}, true);
        if(this.Config.user_id)
            filter = webix.extend(filter, {user_id: this.Config.user_id}, true);
    }

    this.ViewModel.RefreshFiltersList({page:Page, filter:filter, sort:state.sort ? state.sort:null, callback:function () {}})
};

QoESavedFiltersListWidget.prototype.GetTableSelectedData = function ()
{
    return this.Views.Table.getSelectedItem();
};

QoESavedFiltersListWidget.prototype.OnTableRowSelect = function ()
{
    var data = this.GetTableSelectedData();

    this.TableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoESavedFiltersListWidget.prototype.OnTableRowUnSelect = function ()
{
    var data = this.GetTableSelectedData();

    this.TableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoESavedFiltersListWidget.prototype.TableRowsSelectedCountSubscriptionHandler = function (Value)
{
    var _this = this;

    var _disableAll = function ()
    {
        _this.Views.AddSubFilterBtn.disable();
        _this.Views.Widgets.ExtendedFillter.DisableBtn();
    };

    if(Value != 1)
    {
        _disableAll();
        return;
    }

    var selectedData = _this.GetTableSelectedData();

    if(!selectedData)
    {
        _disableAll();
        return;
    }

    if(selectedData.filter_id)
    {
        _this.Views.Widgets.ExtendedFillter.EnableBtn();
        _this.Views.AddSubFilterBtn.enable();

        if(selectedData.form_data)
        {
            var formData = JSON.parse(selectedData.form_data);

            if(formData.filter_state)
            {
                _this.Views.Widgets.ExtendedFillter.SetState(formData.filter_state);
            }
            else
            {
                _this.Views.Widgets.ExtendedFillter.SetState();
            }
        }
    }
    else {
        _this.Views.Widgets.ExtendedFillter.SetDefaultState();
    }
};

QoESavedFiltersListWidget.prototype.SaveFilter = function (RowId, CallBack)
{
    var _this = this;

    var filterData;

    if(RowId)
        filterData = this.Views.Table.getItem(RowId);
    else
        filterData = this.GetTableSelectedData();

    filterData.valid = true;

    var params = {};

    params.filter_state = this.Views.Widgets.ExtendedFillter.GetState();

    var formData = new QoEFilterFormModel(params);

    this.ViewModel.SaveFiltersListItem({filter:filterData, filter_form:formData, callback:function (R)
        {
            if(R.success && R.data && R.data.filter)
            {
                _this.Views.Table.updateItem(filterData.id,  new QoESubscribersFilterListItemModel(R.data.filter));

                webix.message(LangHelper.GetString("QoEPopupFilterWidget","Filter is saved"));

                if(CallBack && typeof CallBack === "function") {
                    CallBack();
                }
            }
            else
            {
                filterData.valid = false;

                _this.Views.Table.validate(filterData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.OnTableRowSelect();
        }});

    this.Views.Table.validate(filterData.id);
};

QoESavedFiltersListWidget.prototype.DeleteFilter = function (RowId)
{
    var _this = this;

    var filterData = this.Views.Table.getItem(RowId);
    filterData.valid = true;

    if(filterData.filter_id > 0)
    {
        this.ViewModel.DeleteFiltersListItem({filter:filterData, callback:function (R)
            {
                if(R.success)
                {
                    if(_this.Views.Table.getItem(RowId)) {
                        _this.Views.Table.remove(RowId);
                    }

                    webix.message(LangHelper.GetString("All","Deleted"));
                }
                else
                {
                    filterData.valid = false;
                    _this.Views.Table.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
    else
    {
        this.Views.Table.remove(RowId);
    }
};

QoESavedFiltersListWidget.prototype.Select = function (FilterId)
{
    if(!FilterId)
        return;

    if(!this.ViewModel.SignalFiltersListUpdated.getValue())
    {
        this.FilterId = FilterId;
        return
    }

    var rows = this.Views.Table.find(function (Obj)
    {
        return Obj.filter_id == FilterId;
    });

    if(rows && rows.length)
    {
        this.Views.Table.select(rows[0].id);
    }
};

QoESavedFiltersListWidget.prototype.GetSelectedFilterId = function ()
{
    var data = this.GetTableSelectedData();

    return data && data.filter_id ? data.filter_id : 0;
};

QoESavedFiltersListWidget.prototype.WizardApplySignalHandler = function ()
{
    var wizardState = this.Views.Widgets.Wizard.GetState();

    var model = new QoESubscribersFilterListItemModel({type:this.Config.type, title: wizardState.title});

    this.Views.Table.add(model, 0);
    this.Views.Table.select(model.id, false);

    var data = [];
    if (this.Views.Widgets.ExtendedFillter.Config && this.Views.Widgets.ExtendedFillter.Config.default) {
        this.Views.Widgets.ExtendedFillter.Config.default.forEach(Default => {
            if(Object.keys(wizardState.values).includes(Default.f_id)) {
                data.push(new QoEPopupFilterWidgetFilterRowModel(webix.extend(webix.copy(Default), {f_enabled:1, f_operator:"like", f_value:wizardState.values[Default.f_id]}, true)));
            }
        });
    }

    this.Views.Widgets.ExtendedFillter.SetState(data);
    this.Views.Widgets.ExtendedFillter.ApplyState();
};

QoESavedFiltersListWidget.prototype.GetWizardState = function ()
{
    return this.Views.Widgets.Wizard.GetState();
};

QoESavedFiltersListWidget.prototype.ResetWizardState = function ()
{
    this.Views.Widgets.Wizard.ResetState();
    this.TableRowsSelectedCountSubscriptionHandler(1);
};
function QoESingleStatWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ReportId = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.ItemsMap = {};

    this.Views = {
        DataView:null,
        Paging:null
    };

    this.ExternalFilter = {};

    this.ExtendedFilter = null;

    this.TableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.Compact = false;

    this.Clikable = false;

    this.CacheMonitor = null;

    this.CellTemplateParams = null;

    this.Init(ViewConfig);
}

QoESingleStatWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Name = ViewConfig.name ? ViewConfig.name : null;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    if(ViewConfig.columns && Array.isArray(ViewConfig.columns))
    {
        ViewConfig.columns.forEach(function (Item)
        {
            _this.ItemsMap[Item.id]  =
            {
                id:Item.id,
                text:Item.header ? Item.header : Item.id,
                icon:Item.icon ? Item.icon : "",
                template:Item.template ? Item.template : function (Val) {return Val}
            };
        });
    }

    this.Compact = ViewConfig.compact ? ViewConfig.compact : false;

    _this.Clikable =  ViewConfig.clickable ? ViewConfig.clickable : false;

    this.CellTemplateParams =  ViewConfig.cell_template_params ? ViewConfig.cell_template_params : null;

    this.ViewConfig = {
        id:this.Id,
        rows:[
            {
                view:"dataview",
                id:this.Id + "DataView",
                scroll:false,
                //borderless:true,
                template:function(Obj)
                {
                    var obj = {icon:Obj.icon, value:Obj.value, text:Obj.text, compact:_this.Compact, clickable:_this.Clikable, template_params: _this.CellTemplateParams};
                    return QoESingleStatCellTemplate(obj);
                },
                xCount:ViewConfig.xCount ? ViewConfig.xCount : 4,
                yCount:ViewConfig.yCount ? ViewConfig.yCount : 1,
                type:ViewConfig.type ? ViewConfig.type :
                {
                    width: "auto",
                    height: "auto"
                },
                on: {
                    onItemClick: function(id) {
                        if (_this.Name === "QoeThreatsMonitorWidgetNetflow" || _this.Name === "QoeThreatsMonitorWidgetClickstream")
                            _this.RedirectToQoeThreatsTableWidget(id)
                    }
                }
                // ,
                // on: {
                //     onBeforeFilter:function()
                //     {
                //         return false;
                //     },
                //     onAfterFilter:function()
                //     {
                //         _this.RefreshData();
                //     },
                //     onBeforeSort:function()
                //     {
                //         _this.RefreshData();
                //
                //         return false;
                //     },
                //     onAfterSelect:function ()
                //     {
                //         _this.OnTableRowSelect();
                //     },
                //     onAfterUnSelect:function ()
                //     {
                //         _this.OnTableRowUnSelect();
                //     }
                // }
            }
        ]
    };

    if(ViewConfig.title)
    {
        this.ViewConfig.rows.splice(0, 0, BlockHeaderTemplate({title:ViewConfig.title ? ViewConfig.title : "", icon:ViewConfig.icon ? ViewConfig.icon : ""}));
    }
};

QoESingleStatWidget.prototype.Bind = function (ViewController)
{
    var _this = this;

    if(!ViewController || !ViewController.ViewModel)
        return;

    this.ExtendedFilter = ViewController.Views.DashboardsExtendedFilter;

    this.ViewModel = ViewController.ViewModel;

    this.Views.DataView = $$(this.Id + "DataView");

    this.CacheMonitor = new QoEWidgetCacheMonitor(this, this.Views.DataView, this.ViewModel);

    this.ViewModel.RegisterReport({
        id:this.Id,
        config:this.Config
    });

    this.DataSignalSubscription = this.ViewModel.GetReportConfig(this.Id).signal.subscribe(function (Updated)
    {
        _this.DataSignal(Updated);
    });
};

QoESingleStatWidget.prototype.Destroy = function ()
{
    this.DataSignalSubscription.unsubscribe();
    this.ViewModel = null;
    this.CacheMonitor.Destroy();
};

QoESingleStatWidget.prototype.DataSignal = function (Updated)
{
    if(!Updated)
        return;

    var _this = this;

    var config = this.ViewModel.GetReportConfig(this.Id);

    var data = [];

    if(config.data.rows && config.data.rows.length)
    {
        config.data.rows.forEach(function (Data)
        {
            data = [];

            Object.keys(_this.ItemsMap).forEach(function (Key)
            {
                data.push({
                    text: _this.ItemsMap[Key].text ? _this.ItemsMap[Key].text : "",
                    icon:_this.ItemsMap[Key].icon ? _this.ItemsMap[Key].icon : "",
                    value: _this.ItemsMap[Key].template(Data[Key] ? Data[Key] : ""),
                    item_id: _this.ItemsMap[Key].id ? _this.ItemsMap[Key].id : "",
                });
            });
        });
    }

    if(!config.config.online || (config.data && config.data.cache_id)) {
        this.Views.DataView.clearAll();
    }

    this.Views.DataView.parse(data);

    this.CacheMonitor.DataSignal(config.data, config.error);
};

QoESingleStatWidget.prototype.RefreshData = function (Page, Params)
{
    var config = this.ViewModel.GetReportConfig(this.Id);

    var sort = config.config.sort ? config.config.sort : null;

    var size = config.config.size ? config.config.size : 0;

    var filter = {};

    if(Params&&Params.filter)
    {
        this.ExternalFilter = webix.copy(Params.filter);
    }

    webix.extend(filter, this.ExternalFilter, true);

    if(Params && Params.report_id)
    {
        this.ReportId = Params.report_id;
    }

    this.ViewModel.RefreshReportData(this.Id, {
        page:Page,
        filter:filter,
        sort:sort,
        size:size,
        max_execution_time: Params&&Params.max_execution_time ? Params.max_execution_time : 0,
        report_id: this.ReportId ? this.ReportId : null
    });
};

QoESingleStatWidget.prototype.GetSelectedData = function ()
{
    return this.Views.DataView.getSelectedItem();
};

QoESingleStatWidget.prototype.OnTableRowSelect = function ()
{
    var data = this.GetSelectedData();

    this.TableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoESingleStatWidget.prototype.OnTableRowUnSelect = function ()
{
    var data = this.GetSelectedData();

    this.TableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoESingleStatWidget.prototype.GetCachesIds = function ()
{
    return this.CacheMonitor && this.CacheMonitor.LastCacheId ? [this.CacheMonitor.LastCacheId] : null;
};

QoESingleStatWidget.prototype.GetReportConfig = function ()
{
    return this.ViewModel.GetReportConfig(this.Id);
};

QoESingleStatWidget.prototype.SetReportConfig = function (ReportConfig)
{
    return this.ViewModel.RegisterReport(ReportConfig);
};

QoESingleStatWidget.prototype.RedirectToQoeThreatsTableWidget = function (ItemId)
{
    let _this = this;

    let itemId = _this.Views.DataView.getItem(ItemId).item_id;

    let InfectedCatDic = App.DicsManager.GetDic(DicsEnum.InfectedHostCategoriesDic);

    let stateData = [];

    for (let item of _this.ExtendedFilter.GetState()) {
        if (item.f_id !== "host_category_code") {
            stateData.push(item);
        }
    }

    if (InfectedCatDic.hasOwnProperty(itemId))
    {
        stateData.push(new QoEPopupFilterWidgetFilterRowModel(
            {f_enabled: 1, f_id: 'host_category_code', f_operator: 'in', f_value: String(itemId), f_value_editor: "text", f_value_type: "String"}
        ));
    } else {
        let values = Object.keys(InfectedCatDic).join(",");
        stateData.push(new QoEPopupFilterWidgetFilterRowModel(
            {f_enabled: 1, f_id: 'host_category_code', f_operator: 'in', f_value: String(values), f_value_editor: "text", f_value_type: "String"}
        ));
    }

    let filterStateConfig =
    {
        filter_state: stateData,
        filter_config: _this.ExtendedFilter.GetFilters()
    };

    let period = _this.ExternalFilter.period;
    let format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    let periodState = {
        period_from:format(period.value[0]),
        period_to:format(period.value[1]),
    };

    let storedReport = new QoEStoredReportBaseModel({
        _id: webix.uid(),
        widget_name: _this.Name === "QoeThreatsMonitorWidgetNetflow" ? "QoETableFullNetflowTopInfectedSubscribersWidget" : "QoETableClickstreamTopInfectedSubscribersWidget",
        filter_config_json: JSON.stringify(filterStateConfig),
        period_state_json: JSON.stringify(periodState)
    });

    _this.ViewModel.SaveStoredReport(storedReport, function (R) {
        if(R && R.success && R.data)
        {
            window.open("/#QoEAnyReport/report_id=" + R.data._id, "_blank");
        }
    });
};

function QoEMonitorWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ReportId = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.Views = {
        Stats: [],
        Charts: []
    };

    this.StatIds = [];
    this.ChartsIds = [];

    this.StatsCacheMonitors = [];
    this.ChartsCacheMonitors = [];

    this.ExternalFilter = {};

    this.Subscriptions = {};

    this.SignalingColors = {
        green: "rgba(126, 158, 86, 0.6)",
        red: "rgba(183, 38, 36, 0.6)"
    };

    this.ReportsMethod = "QoEUplinkProtocolsReport";
    this.ChartsMethod = "QoEUplinkChartData";

    this.WidgetSettings = null;

    this.Reports = [];

    this.Init(ViewConfig);
}

QoEMonitorWidget.prototype.Init = function (ViewConfig) {
    if (!ViewConfig)
        return;

    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Name = ViewConfig.name ? ViewConfig.name : null;

    if(ViewConfig.report_method)
        this.ReportsMethod = ViewConfig.report_method;

    if(ViewConfig.charts_method)
        this.ChartsMethod = ViewConfig.charts_method;

    this.WidgetSettings = ViewConfig.widget_settings ? ViewConfig.widget_settings : null;
    if(!this.WidgetSettings)
        return;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.GroupingId = this.Config.grouping_id ? this.Config.grouping_id : "protocol";

    this.GroupingValues = this.Config.grouping_values ? this.Config.grouping_values : [];

    this.ChartType = ViewConfig.chart_type ? ViewConfig.chart_type : "line";

    this.ChartSerie = ViewConfig.chart_serie ? ViewConfig.chart_serie : "traffic";

    this.NormalizeValues = AppEnv.qoe_monitor_signaling_values ? AppEnv.qoe_monitor_signaling_values : [];

    this.ReconfigViewConfig();

};

QoEMonitorWidget.prototype.Bind = function (ViewController) {
    "use strict";

    if (!ViewController)
        return;

    let _this = this;

    this.ViewModel = ViewController.ViewModel;

    this.StatIds.forEach((Id, index) => {
        this.Views.Stats.push($$(Id));
    });

    this.ChartsIds.forEach(ChartId => {
        this.Views.Charts.push($$(ChartId));
    });

    this.Views.Stats.forEach(Stat => {
        this.StatsCacheMonitors.push(new QoEWidgetCacheMonitor(this, Stat, this.ViewModel));
    });

    this.Views.Charts.forEach(Chart => {
        this.ChartsCacheMonitors.push(new QoEWidgetCacheMonitor(this, Chart, this.ViewModel));
    });

    this.Reports = {
        chart:{
            id: this.Id + "ChartReport",
                method: this.ChartsMethod,
            type: QoEReportConfigTypeEnum.ServerPredefined,
            widget_settings: this.WidgetSettings
        },
        mark:{
            id: this.Id + "StatReport",
                method: this.ReportsMethod,
            type: QoEReportConfigTypeEnum.ServerPredefined,
            widget_settings: this.WidgetSettings
        }
    }


    Object.values(this.Reports).forEach(Report => {
        this.ViewModel.RegisterReport(Report);
    });

    this.Subscriptions.AllDataReady = Rx.Observable.combineLatest(
        this.ViewModel.GetReportConfig(this.Reports.chart.id).signal,
        this.ViewModel.GetReportConfig(this.Reports.mark.id).signal,
    ).subscribe((Val) => {

        let upd = 1;
        Val.forEach(V => {
            if(!V)
                upd = V;
        });
        if(upd)
            _this.DataSignal(upd);
    });
};

QoEMonitorWidget.prototype.DataSignal = function (Updated) {

    if (!Updated)
        return;

    let parsed_data = [];
    const markCfg = this.ViewModel.GetReportConfig(this.Reports.mark.id);

    if(markCfg && markCfg.data && Array.isArray(markCfg.data))
    {
        markCfg.data.forEach(proto => {
            let item = proto;
            item.chart_data = [];
            parsed_data.push(item);
        });
    }

    if(parsed_data.length == 0)
    {
        return;
    }

    const chartCfg = this.ViewModel.GetReportConfig(this.Reports.chart.id);

    if(!chartCfg || !chartCfg.data)
    {
        return;
    }

    chartCfg.data.forEach(proto => {
        let item = proto;
        const index = parsed_data.findIndex(x => x.protocol == item.protocol && x.protocol_code == item.protocol_code);

        let chart_data = [];
        let i = 0;
        if (item.data) {
            item.data.forEach(ch => {
                chart_data.push({x: i, y: ch.total});
            });
        }

        if (index === -1) {
            item.chart_data = chart_data;
            parsed_data.push(item);
        } else {
            parsed_data[index].chart_data = chart_data;
        }
    });


    const serie = {
        value: "#y#",
        item: {radius:0},
        tooltip:{
            template: LangHelper.GetString("QoE", "Protocol health mark") + ": #y#",
            delay: 100
        }
    };
    parsed_data.forEach((item, index) => {
        var traffic_vol_diff = item.traffic_vol_diff && typeof item.traffic_vol_diff != "undefined" ? parseInt(item.traffic_vol_diff) : 0;
        const stat_data = {
            icon: "thermometer-half",
            title: item.protocol + " " + item.protocol_code,
            stat: typeof  item.total == "undefined" ? LangHelper.GetString("QoE", "No data") : item.total,
            value1: item.traffic_vol && typeof item.traffic_vol != "undefined" ? this.GetBytesToSize(item.traffic_vol) : 0 + " " + LangHelper.GetString("QoEMonitorWidget", "Mb"),
            value2: (item.sum_rtt_current && typeof item.sum_rtt_current != "undefined" ? parseInt(item.sum_rtt_current) : 0) + "ms" + " (" +  LangHelper.GetString("QoEMonitorWidget", "median") + ")",
            value3: "(" + (traffic_vol_diff >= 0 ? "+" : "") + traffic_vol_diff + "%" + ")"
        };

        const Stat = this.Views.Stats[index];

        const Chart = this.Views.Charts[index];

        if(!Stat || !Chart)
            return;

        Stat.parse(stat_data);

        Chart.removeAllSeries();
        Chart.addSeries(serie);
        Chart.refresh();
        Chart.clearAll();

        if(item.chart_data && item.chart_data.length)
        {
            this.PaintChart(Chart, item);
            Chart.parse(item.chart_data);
        }else{
            this.ClearChartCss(Chart);
        }
    });




    // if (this.XCount * this.YCount < this.GroupingValues.length) {
    //     for (let i = 0; i < this.GroupingValues.length - this.XCount * this.YCount; i++)
    //         data.pop();
    // }

    // data.forEach((dataItem, Index) => {
    //
    //
    //
    //
    //     if (Rows && Rows.length) {
    //
    //         Rows.forEach(Row => {
    //             if (dataItem.titleStr === Row[this.GroupingId]) parseRows.push(Row);
    //         });
    //     }
    //
    // });

    // data.forEach((dataItem, Index) => {
    //     const ChartCacheMonitor = this.ChartsCacheMonitors[Index];
    //
    //     if (dataItem.titleStr)
    //         ChartCacheMonitor.DataSignal(Config.data, Config.error);
    //     else
    //         ChartCacheMonitor.DataSignal({rows:[],series:[]}, Config.error);
    // });
    //
    // this.StatsCacheMonitors[0].DataSignal(Config.data, Config.error);
};

QoEMonitorWidget.prototype.ReconfigViewConfig = function()
{
    var protocols = this.WidgetSettings.protocols ? this.WidgetSettings.protocols : [];

    if(!protocols || protocols.length == 0)
    {
        return;
    }

    this.ProtoRows = [];

    if(protocols.length <= 5)
    {
        this.ProtoRows.push(protocols.length);
    }
    else
    {
        if(protocols.length % 2 === 0)
        {
            var cols = protocols.length / 2;
            this.ProtoRows.push(cols);
            this.ProtoRows.push(cols);
        }
        else
        {
            this.ProtoRows.push(protocols.length == 7 ? 4 : 5);
            this.ProtoRows.push(protocols.length == 7 ? 3 : 4);
        }
    }

    const markIds = [];
    const chartIds = [];
    const rows = [];
    this.ProtoRows.forEach((cols, i) => {

        const markId = this.Id + "MarksDataLayout" + i;
        const chartId = this.Id + "ChartsDatalayout" + i;


        markIds.push(markId);
        chartIds.push(chartId);

        let markLayout = new this.DatalayoutModel(markId);
        let chartLayout = new this.DatalayoutModel(chartId);

        for(let j = 0; j < cols; ++j)
        {
            const stat = this.GetMonitorElement(markId, j, "_Stat", 0);
            markLayout.data.push(stat);
            this.StatIds.push(stat.id);


            const chart = this.GetMonitorElement(markId, j, "_Chart", 1);
            chartLayout.data.push(chart);
            this.ChartsIds.push(chart.id);
        }

        rows.push({gravity: 2.5,rows:[markLayout]})
        rows.push(chartLayout);
    });

    this.ViewConfig = {
        id: this.Id,
        rows: rows
    };
};

QoEMonitorWidget.prototype.DatalayoutModel = function (Id) {
    "use strict";

    this.view = "datalayout";
    this.id = Id;
    this.cols = [];
    this.data = [];
};

QoEMonitorWidget.prototype.GetMonitorElement = function(RowId, Index, IdString, isChart)
{

    const Id = RowId + IdString + Index;

    if(isChart){
        return new this.ChartModel(Id, this.ChartType);
    }else{
        return new this.StatModel(Id, this.SignalingColors.red);
    }
};

QoEMonitorWidget.prototype.AddMonitorElement = function (Row, Itr, IdsArr, IdString, isChart) {
    "use strict";

    const rowId = IdsArr[Itr];

    for (let i = 0; i < this.XCount; i++) {
        const Id = rowId + IdString + i;

        if (isChart) {
            this.ChartsIds.push(Id);
            Row.data.push(new this.ChartModel(Id, this.ChartType));
        }
        else {
            this.StatIds.push(Id);
            Row.rows[0].data.push(new this.StatModel(Id, this.SignalingColors.red));
        }
    }
};


QoEMonitorWidget.prototype.GetReportConfig = function () {
    return this.ViewModel.GetReportConfig(this.Id);
};

QoEMonitorWidget.prototype.SetReportConfig = function(ReportConfig) {
    return this.ViewModel.RegisterReport(ReportConfig);
};


QoEMonitorWidget.prototype.RefreshData = function (Page, Params) {
    "use strict";

    let filter = {};

    if (Params && Params.filter)
        this.ExternalFilter = webix.copy(Params.filter);

    webix.extend(filter, this.ExternalFilter, true);

    if (Params && Params.filter)
        webix.extend(filter, Params.filter, true);


    filter.grouping_values = this.FillGroupingFilter();

    if(Params && Params.report_id)
    {
        this.ReportId = Params.report_id;
    }

    if(this.ReportId)
    {
        Params.report_id = this.ReportId;
    }

    Object.values(this.Reports).forEach(Report => {
        this.ViewModel.RefreshReportData(Report.id, Params);
    });
};

QoEMonitorWidget.prototype.Destroy = function () {
    "use strict";

    let _this = this;

    Object.keys(this.Subscriptions).forEach(Key => {
        _this.Subscriptions[Key].unsubscribe();
    });

    Object.values(this.Reports).forEach(Report => {
        this.ViewModel.UnRegisterReport(Report.id);
    });

    this.GroupingValues.forEach((Value, Index) => {
        this.ViewModel.UnRegisterReport(this.Id + "Chart" + Index);
    });

    this.ViewModel = null;

    this.StatsCacheMonitors.forEach(StatCacheMonitor => {
        StatCacheMonitor.Destroy();
    });

    this.ChartsCacheMonitors.forEach(ChartCacheMonitor => {
        ChartCacheMonitor.Destroy();
    });
};

QoEMonitorWidget.prototype.GetObjectItemValueByOrder = function (Obj, OrderNum) {
    "use strict";

    return Object.keys(Obj)[Object.keys(Obj).length-OrderNum] ? Obj[Object.keys(Obj)[Object.keys(Obj).length-OrderNum]] : "";
};

QoEMonitorWidget.prototype.RemoveDuplicatesBy = function (keyFn, array) {
    "use strict";

    let mySet = new Set();

    return array.filter(x => {
        let key = keyFn(x), isNew = !mySet.has(key);
        if (isNew) mySet.add(key);
        return isNew;
    });
};

QoEMonitorWidget.prototype.isNumber = function (Number) {
    "use strict";

    return (!isNaN(parseFloat(Number)) && isFinite(Number)) ? Number : 0;
};

QoEMonitorWidget.prototype.CalculateStat = function (Value1, Value2, Value3) {
    "use strict";

    return Math.round((Value1 + Value2 + Value3) / 10000);
};

QoEMonitorWidget.prototype.GetIconByTitleString = function (Name) {
    "use strict";

    let icon;

    this.GroupingValues.forEach(Item => {
        if (Item.value === Name) icon = Item.icon
    });

    return icon;
};

QoEMonitorWidget.prototype.FillGroupingFilter = function () {
    "use strict";

    let groupingFilter = {};

    if (this.GroupingValues.length) {
        groupingFilter = {
            id: this.GroupingId,
            operator: "in",
            sql_type: "where",
            type: "String",
            value: [],
            view: ""
        };

        this.GroupingValues.forEach(Value => {
            groupingFilter.value.push(Value.value);
        });
    }

    return groupingFilter;
};

QoEMonitorWidget.prototype.FindTitle = function (titleString, isTitleNumber) {
    "use strict";

    let Title;

    if (isTitleNumber) {
        this.GroupingValues.forEach(Value => {
            const title = Value.value ? Value.value : "";
            if (titleString === title) Title = Value.title
        });
    }
    else {
        this.GroupingValues.forEach(Value => {
            const title = Value.title ? Value.title : Value.value;
            if (titleString.includes(title)) Title = title
        });
    }

    return Title;
};

QoEMonitorWidget.prototype.GetDataFromRows = function (SortedRows) {
    "use strict";

    let data = [];

    SortedRows.forEach(Row => {
        const titleStr = this.GetObjectItemValueByOrder(Row, 6);
        const index = this.GetObjectItemValueByOrder(Row, 1);
        const value1 = this.isNumber(parseFloat(this.GetObjectItemValueByOrder(Row, 4)));
        const value2 = this.isNumber(parseFloat(this.GetObjectItemValueByOrder(Row, 3)));
        const value3 = this.isNumber(parseFloat(this.GetObjectItemValueByOrder(Row, 2)));

        const title = this.FindTitle(String(titleStr), typeof titleStr==="number"?1:0);

        data.push({
            icon: this.GetIconByTitleString(String(titleStr)),
            title: title,
            color: this.AddSignalingColor(index, title),
            titleStr: titleStr,
            stat: index === null ? 0 : index,
            value1: value1,
            value2: value2,
            value3: value3
        });
    });

    return data;
};

QoEMonitorWidget.prototype.AddSignalingColor = function (Stat, Title) {
    "use strict"

    let color;

    this.NormalizeValues.forEach(Value => {
        if (Value.id === Title) {
            if (Stat >= Value.value) color = this.SignalingColors.green;
            if (Stat < Value.value) color = this.SignalingColors.red;
        }
    });

    return color;
};

QoEMonitorWidget.prototype.ClearChartCss = function(Chart)
{
    webix.html.removeCss(Chart.getNode(), "monitor_chart_white");
    webix.html.removeCss(Chart.getNode(), "monitor_chart_green");
    webix.html.removeCss(Chart.getNode(), "monitor_chart_yellow");
    webix.html.removeCss(Chart.getNode(), "monitor_chart_red");
};

QoEMonitorWidget.prototype.PaintChart = function (Chart, DataItem) {
    "use strict";

    this.ClearChartCss(Chart);

    const color = DataItem.total < 4 ? "green" : (DataItem.total < 8 ? "yellow" : "red");
    Chart.define("css", "monitor_chart_" + color);
};


QoEMonitorWidget.prototype.StatModel = function (Id, AlertColor) {
    this.view = "template";
    this.id = Id;
    this.template = Obj => {
        let obj = {
            icon: Obj.icon,
            title: Obj.title,
            color: Obj.color,
            stat: Obj.stat,
            value1: Obj.value1,
            value2: Obj.value2,
            value3: Obj.value3
        };
        return QoEMonitorStatCellTemplate(obj, AlertColor);
    };
}

QoEMonitorWidget.prototype.ChartModel = function (Id, Type) {
    "use strict";

    this.view = "chart";
    this.id = Id;
    this.type = Type;
    this.padding = {
        top: 15, bottom: 5,
        left:1, right:1,
    };
    this.data = [];
    this.line = {color: "#fff"}
    this.color = "#fff";
    this.eventRadius = 10;

    // this.yAxis = {
    //     start: 0,
    //     end: 10,
    //     step: 1,
    //     title: null
    // };
};

QoEMonitorWidget.prototype.GetBytesToSize = function(Bytes)
{
    if (Bytes == 0)
        return 0;

    var i = parseInt(Math.floor(Math.log(Bytes) / Math.log(1024)));

    return Math.round(Bytes / Math.pow(1024, i)* 10)/10 + ' ' + QoeMonitorWidgetFileSizeUnits[i];
};

function QoETableChartWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewModel = null;

    this.Config = null;

    this.ViewConfig = null;

    this.TableWidget = null;

    this.ChartWidget = null;

    this.WidgetsOrder = []

    this.Subscriptions = {};

    this.RefreshPage = 0;

    this.RefreshParams = 0;

    this.SerieColumnId = null;

    this.SuggestType = null

    this.Init(ViewConfig);
}

QoETableChartWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig || !ViewConfig.table || !ViewConfig.chart)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Name = ViewConfig.name ? ViewConfig.name : null;

    this.TableWidget = Helper.IsTableWidget(ViewConfig.table.widget)
        ? ViewConfig.table.widget
        : this.InitSubWidget(QoETableReportWidget, ViewConfig.table.widget);

    this.ChartWidget = Helper.IsChartWidget(ViewConfig.chart.widget)
        ? ViewConfig.chart.widget
        : this.InitSubWidget(QoESeriesChartReportWidget, ViewConfig.chart.widget);

    this.SerieColumnId = ViewConfig.serie_column ? ViewConfig.serie_column : null;

    this.SuggestType = ViewConfig.suggest_type ? ViewConfig.suggest_type : null;

    this.ViewConfig =
    {
        id: this.Id,
        cols:[
            {
                gravity:ViewConfig.table.gravity ? ViewConfig.table.gravity : 1,
                rows:[
                    this.TableWidget.ViewConfig
                ]
            },
            {view:"resizer"},
            {
                gravity:ViewConfig.chart.gravity ? ViewConfig.chart.gravity : 1,
                rows:[
                    this.ChartWidget.ViewConfig
                ]
            }
        ]
    }

    this.WidgetOrderIds = [
        this.TableWidget.Id,
        this.ChartWidget.Id
    ];

    this.ChartWidget.DefineOptionsOrderBy(this.TableWidget);
    this.ChartWidget.DefineDefaultKeyOrderBy(this.TableWidget);
};

QoETableChartWidget.prototype.Bind = function (ViewController)
{
    var _this = this;

    this.TableWidget.Bind(ViewController);

    this.ChartWidget.Bind(ViewController);
    this.ChartWidget.LegendIsVisible = false;
    this.ChartWidget.Views.Chart.define("legend", null);
    this.ChartWidget.Views.Chart.refresh();

    var columns = webix.toArray(this.TableWidget.Views.Table.config.columns);

    columns.insertAt({
        id:"enabled",
        header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:this.TableWidget.Views.Table.config.id+"MasterCheckBox" },""],
        template: CellColoredCheckBoxTemplate,
        width:32
    },0);

    this.TableWidget.DataAdapter = function (Data)
    {
        var colorIndex = 0;

        var colors = Helper.DictToArr(ColorsDic);

        if(Data && Data.rows)
        {
            Data.rows.forEach(function (Row, Index)
            {
                Row.color = colors[colorIndex].value;

                Row.enabled = 1;

                Row.valid = 1;

                Row.index = Index;

                colorIndex++;

                if(colorIndex > colors.length - 1)
                    colorIndex = 0;
            });
        }

        return Data;
    };

    this.TableWidget.Views.Table.config.checkboxRefresh = true;
    this.TableWidget.Views.Table.refreshColumns();

    this.TableWidget.Views.Table.attachEvent("onCheck", function(id, column, state)
    {
        if(id && column === "enabled" && !isNaN(parseInt(state)))
        {
            let enableSeries = _this.ChartWidget.SeriesItems.filter(item => item.isEnable);

            let tableItem = this.getItem(id);
            let chartItem = _this.ChartWidget.SeriesItems[tableItem.index];

            if(enableSeries.length <= 1 && !state)
            {
                tableItem.enabled = 1;
                return;
            }

            if(chartItem)
            {
                if(state)
                {
                    _this.ChartWidget.Views.Chart.showSeries(tableItem.index);
                }
                else
                {
                    _this.ChartWidget.Views.Chart.hideSeries(tableItem.index);
                }

                chartItem.isEnable = state;
            }
            else
            {
                tableItem.enabled = 1;
            }
        }
    });

    this.Subscriptions.TableDataSignalSubscription = this.TableWidget.GetReportConfig().signal.subscribe(function (Updated)
    {
        if(Updated)
        {
            var chartConfig = _this.ChartWidget.GetReportConfig();

            var tableConfig = _this.TableWidget.GetReportConfig();

            var data = tableConfig && tableConfig.data && tableConfig.data.rows ? tableConfig.data.rows : [];

            _this.GetExportPdfLegendSortedList(chartConfig, data);

            if(Helper.HasCols(chartConfig.config))
            {
                chartConfig.config.cols[0].values = [];

                let colName = _this.SerieColumnId;

                if(!colName && Helper.HasRows(tableConfig.config))
                    colName = tableConfig.config.rows[0];

                if(Helper.IsObject(colName) && colName.col)
                    colName = colName.col;

                if(!colName)
                    return;

                data.forEach(function(Row) {
                    chartConfig.config.cols[0].values.push(Row[colName]);
                });

                // Set values for SQL
                if(chartConfig.config.cols[0].values.length)
                    _this.ChartWidget.Reconfig(chartConfig);
            }
            else
            {
                var colName = _this.SerieColumnId;

                chartConfig.config.cache.values = [];

                data.forEach(function(Row) {
                    chartConfig.config.cache.values.push({col:Row[colName], alias:Row[colName]});
                });

                if(chartConfig.config.cache.values.length)
                    _this.ChartWidget.Reconfig(chartConfig);
            }

            const settingsManager = _this.ChartWidget.ReportsSettingsManager;

            let settingsModel = settingsManager
                ? settingsManager.GetSettingsModel(_this.ChartWidget.Id)
                : null;

            if(settingsModel) {
                const sortOptions = Helper.IsObject(_this.ChartWidget.OptionsOrderBy)
                    ? Object.values(_this.ChartWidget.OptionsOrderBy).map(item => item.id)
                    : [];

                const sortId = Helper.HasSortId(tableConfig.params)
                    ? tableConfig.params.sort.id
                    : null;

                if(!settingsModel.external_lock && sortOptions.includes(sortId)) {
                    settingsModel.cur_common_state.chart_order_by = sortId;
                    settingsModel.Refresh();
                }

                settingsModel.external_lock = false;
            }

            if(data && data.length)
                _this.ChartWidget.RefreshData(_this.RefreshPage, _this.RefreshParams);

            _this.TableWidget.Views.Table.blockEvent();
            var hc = _this.TableWidget.Views.Table.getHeaderContent(_this.TableWidget.Views.Table.config.id+"MasterCheckBox");
            if(hc)
                hc.check();
            _this.TableWidget.Views.Table.unblockEvent();
        }
    });
};

QoETableChartWidget.prototype.Destroy = function (WidgetIdList = null)
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (Key) {
        _this.Subscriptions[Key].unsubscribe();
    });

    [this.TableWidget, this.ChartWidget].forEach(W => {
        if(!WidgetIdList || !WidgetIdList.includes(W.Id))
            W.Destroy();
    });
};

QoETableChartWidget.prototype.RefreshData = function (Page, Params)
{
    this.RefreshPage = Page;

    this.RefreshParams = Params;

    this.TableWidget.RefreshData(Page, Params);
};

QoETableChartWidget.prototype.GetCachesIds = function ()
{
    var tableCacheId = this.TableWidget.GetCachesIds();
    var chartCacheId = this.ChartWidget.GetCachesIds();

    var cacheIds = [];

    if(tableCacheId)
        cacheIds.push(tableCacheId[0]);

    if(chartCacheId)
        cacheIds.push(chartCacheId[0]);

    return cacheIds.length ? cacheIds : null;
};

QoETableChartWidget.prototype.GetExportPdfLegendSortedList = function (chartConfig, tableData)
{
    let _this = this;

    if (chartConfig.config && chartConfig.config.cols)
    {
        let colKey = chartConfig.config.cols[0].col;

        _this.ChartWidget.PdfExportConfig.legend_sorted_list = []

        tableData.forEach(el => {
            _this.ChartWidget.PdfExportConfig.legend_sorted_list.push(el[colKey]);
        })
    }
};

QoETableChartWidget.prototype.InitSubWidget = function(FuncModel, Params)
{
    Params.id = Params.id ? Params.id : webix.uid();
    Params.id = this.Id + Params.id;

    return new FuncModel(Params);
};

QoETableChartWidget.prototype.GetSubWidget = function(Type = null)
{
    if(Type === "chart-area")
        return this.ChartWidget;

    // if(Type === "chart-pie")
    //     return this.PieChartWidget;

    if(Type === "table")
        return this.TableWidget;

    return null;
};

function QoEWidgetEditViewController() {
    this.Id = "QoEWidgetEditForm";

    this.Views = {
        Form: null,
        FormLayout: null,
        NameFieldEn: null,
        NameFieldRu: null,
        RadioLayout: null,
        Radio: null,
        RolesTable: null,
        RolesTableInvalidMessage: null,
        ButtonsLayout: null
    };

    this.ContextEditWidgetConfig = null;
    this.ContextEditWidget = null;

    this.Subscription = {};

    this.Signals = {
        Save: new Rx.BehaviorSubject(null)
    }

    this.Init();
}

QoEWidgetEditViewController.prototype.Init = function() {
    const _this = this;

    this.ContextEditWidgetConfig = {
        view: "popup",
        modal: true,
        maxWidth: 450,
        maxHeight: 660,
        on: {
            onHide: function() {
                _this.Clear();
            }
        },
        body: {
            view: "form",
            id: this.Id + "Form",
            borderless: true,
            elements: [
                {
                    id: this.Id + "FormLayout",
                    rows: [
                        {
                            view: "text",
                            id: this.Id + "NameFieldEn",
                            name: "widget_name_en",
                            label: LangHelper.GetString("QoE", "Widget name") + " (En)",
                            labelPosition: "top",
                            bottomPadding: 20,
                            validate: function(Value) {
                                return webix.rules.isNotEmpty(_this.Views.NameFieldRu.getValue()) || webix.rules.isNotEmpty(Value);
                            },
                            invalidMessage: LangHelper.GetString("QoE", "Enter widget name")
                        },
                        {
                            view: "text",
                            id: this.Id + "NameFieldRu",
                            name: "widget_name_ru",
                            label: LangHelper.GetString("QoE", "Widget name") + " (Ru)",
                            labelPosition: "top",
                            bottomPadding: 10,
                            validate: function(Value) {
                                return webix.rules.isNotEmpty(_this.Views.NameFieldEn.getValue()) || webix.rules.isNotEmpty(Value);
                            },
                            invalidMessage: LangHelper.GetString("QoE", "Enter widget name")
                        },
                        {
                            id: this.Id + "RadioLayout",
                            paddingY: 10,
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    view: "radio",
                                    id: this.Id + "Radio",
                                    name: "available",
                                    labelPosition: "top",
                                    height: 70,
                                    vertical: true,
                                    options: Object.values(AvailableUsersEnum),
                                    on: {
                                        "onChange": function(Id) {
                                            Id !== AvailableUsersEnum.roles_users.id
                                                ? _this.ResetRoles()
                                                : _this.Views.RolesTable.enable();
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            view: "datatable",
                            id: this.Id + "RolesTable",
                            selected: "row",
                            height: 280,
                            columns: [
                                {
                                    id: "allow",
                                    header: "",
                                    width: 60,
                                    headermenu: false,
                                    template: function(Obj, Common, Value) {
                                        return CellOnOffCheckboxTemplate(Obj, Common, Value);
                                    }
                                },
                                {
                                    id: "role",
                                    header: LangHelper.GetString("QoE", "Role"),
                                    width: "auto",
                                    template: function(Value) {
                                        return Value.value;
                                    }
                                }
                            ],
                            on: {
                                onItemClick: function(Obj) {
                                    if(Obj.column == "allow") {
                                        const item = _this.Views.RolesTable.getItem(Obj.row);

                                        item.allow = item.allow ? 0 : 1;

                                        _this.Views.RolesTable.updateItem(Obj.row, item);
                                    }
                                }
                            }
                        },
                        {
                            view: "label",
                            id: this.Id + "RolesTableInvalidMessage",
                            height: 25,
                            css: {
                                "color":"#fd595f !important",
                                "font_size":"13px"
                            },
                            template: function(Obj, Common, Value) {
                                if(Value) {
                                    return `<div>${Value}</div>`;
                                }
                                return `<div></div>`;
                            }
                        },
                        {
                            id: this.Id + "ButtonsLayout",
                            cols: [
                                {
                                    view: "button",
                                    value: LangHelper.GetString("All", "Cancel"),
                                    click: function() {
                                        _this.Hide();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    value: LangHelper.GetString("All", "Save"),
                                    click: function() {
                                        _this.SaveWidget();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    }
};

QoEWidgetEditViewController.prototype.Bind = function() {
    this.ContextEditWidget = webix.ui(this.ContextEditWidgetConfig);

    Object.keys(this.Views).forEach(View => {
       this.Views[View] = $$(this.Id + View);
    });

    this.Subscription.SignalRolesUpdate = App.DicsManager.Signal[DicsEnum.RolesDic].subscribe(Value => {
        if(Value) {
            this.RefreshRoles();
        }
    });
};

QoEWidgetEditViewController.prototype.Destroy = function() {
    Object.keys(this.Subscription).forEach(Key => {
       if(this.Subscription[Key])
           this.Subscription[Key].unsubscribe();
    });
};

QoEWidgetEditViewController.prototype.Show = function(Node, Pos) {
    this.ContextEditWidget.show(Node, {pos: Pos});
};

QoEWidgetEditViewController.prototype.Hide = function() {
    this.ContextEditWidget.hide();
};

QoEWidgetEditViewController.prototype.Clear = function() {
    this.Views.Form.clear();
    this.ClearValidation();
};

QoEWidgetEditViewController.prototype.ClearValidation = function() {
    this.Views.Form.clearValidation();
    this.Views.RolesTableInvalidMessage.setValue("");
};

QoEWidgetEditViewController.prototype.SetData = function(Data) {
    this.Data = new QoEWidgetGetModel(Data);

    this.Data.widget_name_en = this.Data.widget_name.en;
    this.Data.widget_name_ru = this.Data.widget_name.ru;

    this.Views.Form.setValues(this.Data);

    this.SetRoles();
};

QoEWidgetEditViewController.prototype.SetRoles = function() {
    const roles = this.Views.RolesTable.serialize();

    const data = [];
    roles.forEach(role => {
       role.available_for_roles = this.Data.available_for_roles;
       data.push(new QoERoleModel(role));
    });

    this.Views.RolesTable.parse(data);
};

QoEWidgetEditViewController.prototype.RefreshRoles = function() {
    const roles = App.DicsManager.GetDicAsArray(DicsEnum.RolesDic);

    const rolesTableData = this.Views.RolesTable.serialize();

    const data = [];
    roles.forEach(role => {
       const newRole = new QoERoleModel(role);

       const foundRow = rolesTableData.find(row => row.id == role.id);

       if(foundRow) {
           newRole.allow = foundRow.allow;
       }

       data.push(newRole);
    });

    this.Views.RolesTable.parse(data);
};

QoEWidgetEditViewController.prototype.ResetRoles = function() {
    this.Views.RolesTable.disable();

    this.Views.RolesTable.eachRow(row => {
       const record = this.Views.RolesTable.getItem(row);

       record.allow = 0;
       this.Views.RolesTable.updateItem(row, record);
    });
};

QoEWidgetEditViewController.prototype.GetData = function() {
    return new QoEWidgetSaveModel(this.Data);
};

QoEWidgetEditViewController.prototype.SaveWidget = function() {
    this.ClearValidation();

    this.Data = null;

    this.Data = this.Views.Form.getValues();

    const rolesTableData = this.Views.RolesTable.serialize();

    if(this.Validate(rolesTableData)) {
        this.PushRolesToSave(rolesTableData);

        const en = this.Data.widget_name_en ? this.Data.widget_name_en : this.Data.widget_name_ru;
        const ru = this.Data.widget_name_ru ? this.Data.widget_name_ru : this.Data.widget_name_en;

        this.Data.widget_name = {en, ru};

        this.Data.owner_id = App.SessionManager.GetProfile().user_id;

        this.Signals.Save.next(1);
    }
};

QoEWidgetEditViewController.prototype.PushRolesToSave = function(Roles) {
    if(this.Data && this.Data.available === AvailableUsersEnum.roles_users.id) {
        const roleIds = [];
        Roles.forEach(role => {
           if(role.allow) {
               roleIds.push(role.id);
           }
        });
        this.Data.available_for_roles = roleIds;
    }
    else {
        this.Data.available_for_roles = "";
    }
};

QoEWidgetEditViewController.prototype.Validate = function(Roles) {
    const result = [];
    result.push(this.Views.Form.validate());
    result.push(this.ValidateRolesTable(Roles));
    return result.every(res => res);
};

QoEWidgetEditViewController.prototype.ValidateRolesTable = function(Roles) {
    if(this.Data && this.Data.available === AvailableUsersEnum.roles_users.id) {
        const result = Roles.filter(role=>role.allow);
        if(!result.length) {
            this.Views.RolesTableInvalidMessage.setValue(LangHelper.GetString("QoE", "Select roles"));
            return false;
        }
        return true;
    }
    else {
        return true;
    }
};


function QoEWidgetsSuggestListData(WigetName)
{
    var r =
        [
            {
                value: LangHelper.GetString("AppView", "Netflow"),
                //open:true,
                filter_type: QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow,
                data:
                    [
                        {
                            icon:"th",
                            value:LangHelper.GetString("QoE", "Panels"),
                            data:
                                [
                                    {
                                        value:LangHelper.GetString("QoE", "Traffic"),
                                        icon:"th",
                                        widget:"QoESingleStatTotalsWidget",
                                        dx: 12, dy: 2,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Subscribers RTT"),
                                        icon:"th",
                                        widget:"QoESingleStatSubscribersRttWidget",
                                        dx: 12, dy: 2,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Subscribers RTT") + " (" + LangHelper.GetString("QoE", "Vert.") + ")",
                                        icon:"th",
                                        widget:"QoESingleStatSubscribersRttVertWidget",
                                        dx: 2, dy: 8,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "RTT"),
                                        icon:"th",
                                        widget:"QoESingleStatRttWidget",
                                        dx: 12, dy: 2,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "RTT") + " (" + LangHelper.GetString("QoE", "Vert.") + ")",
                                        icon:"th",
                                        widget:"QoESingleStatRttVertWidget",
                                        dx: 2, dy: 12,
                                        dragable:1
                                    }
                                ]
                        },
                        {
                            icon:"chart-area",
                            value:LangHelper.GetString("QoE", "Series charts"),
                            data:
                                [
                                    {
                                        value:LangHelper.GetString("QoE", "RTT distribution"),
                                        icon:"chart-area",
                                        widget:"QoERttDistributionWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "RTT by time"),
                                        icon:"chart-area",
                                        widget:"QoERttByTimeWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Retransmits"),
                                        icon:"chart-area",
                                        widget:"QoESeriesChartRetransmitsByTimeWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Traffic"),
                                        icon:"chart-area",
                                        widget:"QoESeriesChartTrafficWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Traffic by protocols"),
                                        icon:"chart-area",
                                        widget:"QoETableNetflowTopTrafficNetProtocolsTableChartWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Traffic by application protocols"),
                                        icon:"chart-area",
                                        widget:"QoETableNetflowTopTrafficProtocolsTableChartWidget",
                                        dx: 12, dy: 8,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Traffic by application protocols groups"),
                                        icon:"chart-area",
                                        widget:"QoETableNetflowTopTrafficProtocolsGroupsTableChartWidget",
                                        dx: 12, dy: 8,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Traffic by vchannels"),
                                        icon:"chart-area",
                                        widget:"QoETableNetflowTopTrafficVchannelsTableChartWidget",
                                        dx: 12, dy: 8,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Traffic by classes"),
                                        icon:"chart-area",
                                        widget:"QoETableNetflowTopTrafficClassesTableChartWidget",
                                        dx: 12, dy: 8,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Flow"),
                                        icon:"chart-area",
                                        widget:"QoESeriesChartFlowWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Flow by protocols"),
                                        icon:"chart-area",
                                        widget:"QoESeriesChartFlowByNetProtocolsTableChartWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Flow by application protocols"),
                                        icon:"chart-area",
                                        widget:"QoESeriesChartFlowByProtocolsTableChartWidget",
                                        dx: 12, dy: 8,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Flow by application protocols groups"),
                                        icon:"chart-area",
                                        widget:"QoESeriesChartFlowByProtocolsGroupsTableChartWidget",
                                        dx: 12, dy: 8,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Flow by vchannels"),
                                        icon:"chart-area",
                                        widget:"QoESeriesChartFlowByVchannelsTableChartWidget",
                                        dx: 12, dy: 8,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Flow by classes"),
                                        icon:"chart-area",
                                        widget:"QoESeriesChartFlowByClassesTableChartWidget",
                                        dx: 12, dy: 8,
                                        dragable:1
                                    }
                                ]
                        },
                        {
                            icon:"chart-pie",
                            value:LangHelper.GetString("QoE", "Pie charts"),
                            data:
                                [
                                    {
                                        value:LangHelper.GetString("QoE", "Top subscribers"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscribers with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartTopRttSubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscribers with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartTopTrafficSubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscribers with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartTopRetransmitsSubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top protocols"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopProtocolsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficProtocolsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopRetransmitsProtocolsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase(),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficProtocolsBySubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top protocols groups"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopProtocolsGroupsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficProtocolsGroupsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopRetransmitsProtocolsGroupsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase(),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficProtocolsGroupsBySubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top hosts"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopHostsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficHostsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopRetransmitsHostsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top hosts IPs"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopHostsIPsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficHostsIPsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopRetransmitsHostsIPsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top host categories"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top host categories with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopHostCategoriesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top host categories with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficHostCategoriesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top host categories") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopRetransmitsHostCategoriesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top AS"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top AS with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top AS with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top AS") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopRetransmitsASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value: LangHelper.GetString("QoE", "Top subscriber`s AS"),
                                        icon: "chart-pie",
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscriber`s AS with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopSubscriberASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscriber`s AS with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficSubscriberASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscriber`s AS") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopRetransmitsSubscriberASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top switches"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top switches with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopAccessSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top switches") + " " + LangHelper.GetString("QoE", "with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficAccessSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top switches") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopRetransmitsAccessSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value: LangHelper.GetString("QoE", "Top trunk switches"),
                                        icon: "chart-pie",
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top trunk switches with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrunkSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top trunk switches") + " " + LangHelper.GetString("QoE", "with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopTrafficTrunkSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top trunk switches") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartNetflowTopRetransmitsTrunkSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top vchannels"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top vchannels with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartTopRttVchannelsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top vchannels with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartTopTrafficVchannelsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top vchannels with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartTopRetransmitsVchannelsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top classes"),
                                        icon:"chart-pie",
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top classes with high RTT"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartTopRttClassesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top classes with high traffic"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartTopTrafficClassesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top classes with high retransmits"),
                                                icon:"chart-pie",
                                                widget:"QoEPieChartTopRetransmitsClassesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    }
                                ]
                        },
                        {
                            icon:"table",
                            value:LangHelper.GetString("QoE", "Tables"),
                            data:
                                [
                                    {
                                        icon:"table",
                                        value:LangHelper.GetString("QoE", "Top subscribers"),
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscribers with high RTT"),
                                                icon:"table",
                                                widget:"QoETableTopRttSubscribersShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscribers with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableTopRttSubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscribers with high traffic"),
                                                icon:"table",
                                                widget:"QoETableTopTrafficSubscribersShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscribers with high traffic")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableTopTrafficSubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscribers") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableTopRetransmitsSubscribersShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscribers") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableTopRetransmitsSubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }

                                        ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Top protocols"),
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols with high RTT"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopProtocolsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopProtocolsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols with high traffic"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficProtocolsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols with high traffic") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase(),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficProtocolsBySubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols with high traffic")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficProtocolsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsProtocolsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top protocols") + " " + LangHelper.GetString("QoE", "with high retransmits") +" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsProtocolsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Top protocols groups"),
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high RTT"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopProtocolsGroupsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopProtocolsGroupsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high traffic"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficProtocolsGroupsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high traffic") + " " + LangHelper.GetString("QoE", "By subscribers").toLowerCase(),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficProtocolsGroupsBySubscribersWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high traffic")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficProtocolsGroupsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsProtocolsGroupsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top application protocols groups with high retransmits") +" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsProtocolsGroupsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Top hosts"),
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts with high RTT"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopHostsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopHostsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts with high traffic"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficHostsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts with high traffic")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficHostsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsHostsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsHostsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Top hosts IPs"),
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high RTT"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopHostsIPsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts IPs")  + " " + LangHelper.GetString("QoE", "with high RTT") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopHostsIPsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high traffic"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficHostsIPsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high traffic") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficHostsIPsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsHostsIPsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top hosts IPs") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsHostsIPsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Top host categories"),
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top host categories with high RTT"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopHostCategoriesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top host categories with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopHostCategoriesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top host categories with high traffic"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficHostCategoriesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top host categories with high traffic")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficHostCategoriesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top host categories") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsHostCategoriesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top host categories") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsHostCategoriesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Top AS"),
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top AS with high RTT"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopASsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top AS with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top AS with high traffic"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficASsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top AS with high traffic")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top AS") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsASsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top AS") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Top subscriber`s AS"),
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscriber`s AS with high RTT"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopSubscriberASsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscriber`s AS with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopSubscriberASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscriber`s AS with high traffic"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficSubscriberASsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscriber`s AS with high traffic")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficSubscriberASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscriber`s AS") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsSubscriberASsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top subscriber`s AS") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsSubscriberASsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Top switches"),
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top switches with high RTT"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopAccessSwitchesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top switches with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopAccessSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top switches") + " " + LangHelper.GetString("QoE", "with high traffic"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficAccessSwitchesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top switches") + " " + LangHelper.GetString("QoE", "with high traffic") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficAccessSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top switches") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsAccessSwitchesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top switches") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsAccessSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Top trunk switches"),
                                        data: [
                                            {
                                                value:LangHelper.GetString("QoE", "Top trunk switches with high RTT"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrunkSwitchesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top trunk switches with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrunkSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top trunk switches") + " " + LangHelper.GetString("QoE", "with high traffic"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficTrunkSwitchesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top trunk switches") + " " + LangHelper.GetString("QoE", "with high traffic") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopTrafficTrunkSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top trunk switches") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsTrunkSwitchesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top trunk switches") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableNetflowTopRetransmitsTrunkSwitchesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }
                                        ]
                                    },
                                    {
                                        icon:"table",
                                        value:LangHelper.GetString("QoE", "Top vchannels"),
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top vchannels with high RTT"),
                                                icon:"table",
                                                widget:"QoETableTopRttVchannelsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top vchannels with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableTopRttVchannelsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top vchannels with high traffic"),
                                                icon:"table",
                                                widget:"QoETableTopTrafficVchannelsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top vchannels with high traffic")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableTopTrafficVchannelsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top vchannels") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableTopRetransmitsVchannelsShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top vchannels") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableTopRetransmitsVchannelsWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }

                                        ]
                                    },
                                    {
                                        icon:"table",
                                        value:LangHelper.GetString("QoE", "Top classes"),
                                        data:[
                                            {
                                                value:LangHelper.GetString("QoE", "Top classes with high RTT"),
                                                icon:"table",
                                                widget:"QoETableTopRttClassesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top classes with high RTT")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableTopRttClassesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top classes with high traffic"),
                                                icon:"table",
                                                widget:"QoETableTopTrafficClassesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top classes with high traffic")+" ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableTopTrafficClassesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top classes") + " " + LangHelper.GetString("QoE", "with high retransmits"),
                                                icon:"table",
                                                widget:"QoETableTopRetransmitsClassesShortWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            },
                                            {
                                                value:LangHelper.GetString("QoE", "Top classes") + " " + LangHelper.GetString("QoE", "with high retransmits") + " ("+LangHelper.GetString("QoE","Maxi")+")",
                                                icon:"table",
                                                widget:"QoETableTopRetransmitsClassesWidget",
                                                dx: 6, dy: 5,
                                                dragable:1
                                            }

                                        ]
                                    }
                                ]
                        }
                    ]
            },
            {
                value: LangHelper.GetString("AppView", "Clickstream"),
                filter_type: QoEPopupFilterWidgetConfigTypeEnum.QoEClickstream,
                data:
                    [
                        {
                            icon:"th",
                            value:LangHelper.GetString("QoE", "Panels"),
                            data:
                                [
                                    {
                                        value:LangHelper.GetString("QoE", "Totals"),
                                        icon:"th",
                                        widget:"QoESingleStatClickstreamTotalsWidget",
                                        dx: 12, dy: 2,
                                        dragable:1
                                    }
                                ]
                        },
                        {
                            icon:"chart-pie",
                            value:LangHelper.GetString("QoE", "Pie charts"),
                            data:
                                [
                                    {
                                        value:LangHelper.GetString("QoE", "Top hosts"),
                                        icon:"chart-pie",
                                        widget:"QoEPieChartClickstreamTopHostsWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top subscribers"),
                                        icon:"chart-pie",
                                        widget:"QoEPieChartClickstreamTopSubscribersWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top devices"),
                                        icon:"chart-pie",
                                        widget:"QoEPieChartClickstreamTopDevicesWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top hosts IPs"),
                                        icon:"chart-pie",
                                        widget:"QoEPieChartClickstreamTopHostIpsWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top vchannels"),
                                        icon:"chart-pie",
                                        widget:"QoEPieChartClickstreamTopVchannelsWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    }
                                    // ,
                                    // {
                                    //     value:LangHelper.GetString("QoE", "Top classes"),
                                    //     icon:"chart-pie",
                                    //     widget:"QoEPieChartClickstreamTopClassesWidget",
                                    //     dx: 6, dy: 5,
                                    //     dragable:1
                                    // }
                                ]
                        },
                        {
                            icon:"table",
                            value:LangHelper.GetString("QoE", "Tables"),
                            data:
                                [
                                    {
                                        value:LangHelper.GetString("QoE", "Top hosts"),
                                        icon:"table",
                                        widget:"QoETableClickstreamTopHostsWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top subscribers"),
                                        icon:"table",
                                        widget:"QoETableClickstreamTopSubscribersWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top devices"),
                                        icon:"table",
                                        widget:"QoETableClickstreamTopDevicesWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top user agents"),
                                        icon:"table",
                                        widget:"QoETableClickstreamTopAgentsWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top hosts IPs"),
                                        icon:"table",
                                        widget:"QoETableClickstreamTopHostIpsWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top host categories"),
                                        icon:"table",
                                        widget:"QoETableClickstreamTopHostCategoriesWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top URLs"),
                                        icon:"table",
                                        widget:"QoETableClickstreamTopUrlsWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Top vchannels"),
                                        icon:"table",
                                        widget:"QoETableClickstreamTopVchannelsWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    }
                                ]
                        }
                    ]
            },
            {
                value: LangHelper.GetString("AppView", "Raw full netflow"),
                filter_type: QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNetFlow,
                data:
                    [
                        {
                            icon: "table",
                            value: LangHelper.GetString("QoE", "Tables"),
                            data:
                                [
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Raw log"),
                                        data:
                                            [
                                                {
                                                    value:LangHelper.GetString("QoE", "Short raw log"),
                                                    icon:"table",
                                                    widget:"QoETableFullflowRawLogShortWidget",
                                                    dx: 6, dy: 5,
                                                    dragable:1
                                                },
                                                {
                                                    value:LangHelper.GetString("QoE", "Subscriber raw log"),
                                                    icon:"table",
                                                    widget:"QoETableFullflowRawLogSubscriberWidget",
                                                    dx: 6, dy: 5,
                                                    dragable:1
                                                },
                                                {
                                                    value:LangHelper.GetString("QoE", "Full raw log"),
                                                    icon:"table",
                                                    widget:"QoETableFullflowRawLogWidget",
                                                    dx: 12, dy: 5,
                                                    dragable:1
                                                }
                                            ]
                                    },
                                    {
                                        icon: "table",
                                        value: LangHelper.GetString("QoE", "Attacks detection"),
                                        data:
                                            [
                                                {
                                                    icon: "table",
                                                    value: LangHelper.GetString("QoE", "Ssh bruteforce"),
                                                    widget: "QoETableFullnetflowRawSshBruteForceWidget",
                                                    dx: 6, dy: 5,
                                                    dragable:1
                                                },
                                                {
                                                    icon: "table",
                                                    value: LangHelper.GetString("QoE", "Top application protocols"),
                                                    data:[
                                                        {
                                                            value:LangHelper.GetString("QoE", "By traffic"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopTrafficProtocolsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By flow"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopFlowProtocolsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By session lifetime"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopSesLifetimeProtocolsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By subscribers and hosts"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopSubsHostsProtocolsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "Maxi"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopProtocolsWidget",
                                                            dx: 12, dy: 5,
                                                            dragable:1
                                                        }
                                                    ]
                                                },
                                                {
                                                    icon: "table",
                                                    value: LangHelper.GetString("QoE", "Top application protocols groups"),
                                                    data:[
                                                        {
                                                            value:LangHelper.GetString("QoE", "By traffic"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopTrafficProtocolsGroupsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By flow"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopFlowProtocolsGroupsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By session lifetime"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopSesLifetimeProtocolsGroupsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By subscribers and hosts"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopSubsHostsProtocolsGroupsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "Maxi"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopProtocolsGroupsWidget",
                                                            dx: 12, dy: 5,
                                                            dragable:1
                                                        }
                                                    ]
                                                },
                                                {
                                                    icon: "table",
                                                    value: LangHelper.GetString("QoE", "Top subscribers"),
                                                    data:[
                                                        {
                                                            value:LangHelper.GetString("QoE", "By traffic"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopTrafficSubscribersWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By flow"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopFlowSubscribersWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By session lifetime"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopSesLifetimeSubscribersWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By subscribers and hosts"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopSubsHostsSubscribersWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "Maxi"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopSubscribersWidget",
                                                            dx: 12, dy: 5,
                                                            dragable:1
                                                        }
                                                    ]
                                                },
                                                {
                                                    icon: "table",
                                                    value: LangHelper.GetString("QoE", "Top hosts IPs"),
                                                    data:[
                                                        {
                                                            value:LangHelper.GetString("QoE", "By traffic"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopTrafficHostsIpsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By flow"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopFlowHostsIpsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By session lifetime"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopSesLifetimeHostsIpsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "By subscribers and hosts"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopSubsHostsHostsIpsWidget",
                                                            dx: 6, dy: 5,
                                                            dragable:1
                                                        },
                                                        {
                                                            value:LangHelper.GetString("QoE", "Maxi"),
                                                            icon:"table",
                                                            widget:"QoETableFullflowRawTopHostsIpsWidget",
                                                            dx: 12, dy: 5,
                                                            dragable:1
                                                        }
                                                    ]
                                                }
                                            ]
                                    }
                                ]
                        }
                    ]
            },
            {
                value: LangHelper.GetString("AppView", "Raw clickstream"),
                filter_type: QoEPopupFilterWidgetConfigTypeEnum.QoERawClickstreamLogs,
                data:
                    [
                        {
                            icon: "table",
                            value: LangHelper.GetString("QoE", "Tables"),
                            data:
                                [
                                    {
                                        value:LangHelper.GetString("QoE", "Raw clickstream"),
                                        icon:"table",
                                        widget:"QoETableClickstreamRawLogAsIsWidget",
                                        dx: 6, dy: 5,
                                        dragable:1
                                    },
                                    {
                                        value:LangHelper.GetString("QoE", "Raw clickstream") + " " + LangHelper.GetString("QoE", "With netflow").toLowerCase(),
                                        icon:"table",
                                        widget:"QoETableClickstreamRawLogWithFullflowWidget",
                                        dx: 12, dy: 5,
                                        dragable:1
                                    }
                                ]
                        }
                    ]
            },
            {
                value: LangHelper.GetString("AppView","Raw Gtp flow"),
                filter_type: QoEPopupFilterWidgetConfigTypeEnum.QoERawFullGtpFlow,
                data: [
                    {
                        icon: "table",
                        value: LangHelper.GetString("QoE", "Tables"),
                        data:[
                            {
                                value:LangHelper.GetString("QoE", "Full raw log"),
                                icon:"table",
                                widget:"QoETableFullGtpFlowRawLogWidget",
                                dx: 12, dy: 5,
                                dragable:1
                            }
                        ]
                    }
                ]
            },
            {
                value: LangHelper.GetString("AppView","Gtp flow"),
                filter_type: QoEPopupFilterWidgetConfigTypeEnum.QoEFullGtpFlow,
                data: [
                    {
                        icon: "table",
                        value: LangHelper.GetString("QoE", "Tables"),
                        data:[
                            {
                                value:LangHelper.GetString("QoE", "Aggregated log"),
                                icon:"table",
                                widget:"QoETableFullGtpFlowAggLogWidget",
                                dx: 12, dy: 5,
                                dragable:1
                            }
                        ]
                    },
                    {
                        icon: "map-marked",
                        value: LangHelper.GetString("QoE", "Map reports"),
                        data:[
                            {
                                value:LangHelper.GetString("QoE", "Subscribers routes"),
                                icon:"directions",
                                widget:"QoETableLayerGtpSubscribersRoutescWidget",
                                dx: 12, dy: 5,
                                dragable:1
                            },
                            {
                                value:LangHelper.GetString("QoE", "Subscribers location"),
                                icon:"map-marked-alt",
                                widget:"QoETableLayerSubscribersLocationsWidget",
                                dx: 12, dy: 5,
                                dragable:1
                            }
                        ]
                    }
                ]
            },
            {
                value: LangHelper.GetString("AppView","Raw NAT flow"),
                filter_type: QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNatFlow,
                data: [
                    {
                        icon: "table",
                        value: LangHelper.GetString("QoE", "Tables"),
                        data:[
                            {
                                value:LangHelper.GetString("QoE", "Full raw log"),
                                icon:"table",
                                widget:"QoETableNatflowRawLogWidget",
                                dx: 12, dy: 5,
                                dragable:1
                            }
                        ]
                    }
                ]
            },
            {
                value: LangHelper.GetString("AppView","NAT flow"),
                filter_type: QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNatFlow,
                data: [
                    {
                        icon: "table",
                        value: LangHelper.GetString("QoE", "Tables"),
                        data:[
                            {
                                value:LangHelper.GetString("QoE", "NAT flow aggregated log"),
                                icon:"table",
                                widget:"QoETableNatflowAggLogWidget",
                                dx: 12, dy: 5,
                                dragable:1
                            },
                            {
                                value:LangHelper.GetString("QoE", "Top subscribers"),
                                icon:"table",
                                widget:"QoETableNatflowAggTopSubscribersWidget",
                                dx: 6, dy: 5,
                                dragable:1
                            },
                            {
                                value:LangHelper.GetString("QoE", "Top hosts IPs"),
                                icon:"table",
                                widget:"QoETableNatflowAggTopHostsIpsWidget",
                                dx: 6, dy: 5,
                                dragable:1
                            },
                            {
                                value:LangHelper.GetString("QoE", "Top post NAT IPs"),
                                icon:"table",
                                widget:"QoETableNatflowAggTopPostNatIpsWidget",
                                dx: 6, dy: 5,
                                dragable:1
                            }
                        ]
                    }
                ]
            }
        ];

    if(WigetName)
    {
        var item;
        function FindItem(R)
        {
            if(Array.isArray(R))
            {
                R.forEach(function (Item)
                {
                    if(typeof Item == "object" && Item.data)
                    {
                        FindItem(Item.data);
                    }
                    else if(typeof Item == "object" && Item.widget && Item.widget == WigetName && Item.value)
                    {
                        item = Item;
                    }
                });
            }
        }

        FindItem(r);

        return item;
    }

    return r;
}

const ExceptWidgetCodes = {
    // Delete widgets with settings from suggest list everywhere except dashboard #77159.12
    // TODO: Change back after #77504 complete
    with_settings: [
        "NetflowPanelsSubscribers RTTQoESingleStatSubscribersRttWidget",
        "NetflowPanelsUplink monitorQoEUplinkMonitor"
    ],
    panels_maps: [
        "NetflowPanels",
        "ClickstreamPanels",
        "DDoS attacksPanels",
        "DDoS attacksMap reports"
    ],
    voip: [
        "NetflowSeries charts VOIP protocols QoETableNetflowUsersByVoipProtocolsTableChartWidget",
        "NetflowSeries charts VOIP protocols QoETableNetflowCallsByVoipProtocolsTableChartWidget",
        "NetflowSeries charts VOIP protocols QoETableNetflowMinutesByVoipProtocolsTableChartWidget",
        "NetflowSeries charts VOIP protocols QoETableNetflowTopTrafficByVoipProtocolsTableChartWidget",
        "NetflowPie charts Top VOIP protocols QoEPieChartNetflowTopVoipProtocolsWidget",
        "NetflowTables Top VOIP protocols QoETableNetflowTopVoipProtocolsWidget"
    ],
    ddos: [
        "DDoS attacks",
        "Raw DDoS attacks"
    ],
    custom_agg: [
        "CustomQoEAggLogsReports"
    ]
};

function QoEWidgetsSuggestWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.Embedded = false;

    this.Borderless = false;

    this.Dragable = false;

    this.Editable = false;

    this.IsDashboard = false;

    this.ViewModel = null;

    this.QoEWidgetEditFormContext = new QoEWidgetEditViewController();

    this.WebSocketRoom = null;

    this.isUpdatedWidgets = false;

    this.Views = {};

    this.ViewConfig = null;

    this.ContextConfig = null;

    this.Context = null;

    this.Subscriptions = {};

    this.WidgetsByFilterType = {};

    this.Signals = {
        Select: new Rx.BehaviorSubject(null),
        WidgetsUpdated: new Rx.BehaviorSubject(null),
        WidgetRemove: new Rx.BehaviorSubject(null)
    };

    this.ExceptWidgetCodes = [];

    this.Init(ViewConfig);
}

QoEWidgetsSuggestWidget.prototype.Init = function (ViewConfig, ViewModel)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.ViewModel = ViewModel ? ViewModel : new QoEWidgetsSuggestWidgetManager();

    this.Embedded = ViewConfig.embedded ? ViewConfig.embedded : false;

    this.Borderless = ViewConfig.borderless ? ViewConfig.borderless : false;

    this.Dragable = ViewConfig.dragable ? ViewConfig.dragable : false;

    this.Editable = ViewConfig.editable ? ViewConfig.editable : false;

    this.IsDashboard = ViewConfig.isDashboard ? ViewConfig.isDashboard : false;

    this.ExceptWidgetCodes = this.BuildExceptWidgetCodesList(ViewConfig.exceptWidgetCodes);

    this.WebSocketRoom = "QoEWidgetsSuggestWidget";

    this.CurrentLocale = LangHelper.GetLocale();

    this.ViewConfig = {
        rows:[
            {
                view: "search",
                id: this.Id + "Search",
                placeholder: LangHelper.GetString("All", "Search"),
                on: {
                    onTimedKeyPress: function () {
                        var searchValue = this.getValue().toLowerCase();

                        _this.Views.WidgetsList.filter(function(widget) {
                            return widget.widget_name[_this.CurrentLocale].toLowerCase().includes(searchValue);
                        });
                    }
                }
            },
            {
                view:"treetable",
                id:this.Id + "WidgetsList",
                select:"row",//_this.Embedded ? false : "row",
                drag:_this.Dragable ? "source" : false,
                header:false,
                borderless:function(){
                    if(_this.Borderless)
                        return true;

                    return _this.Embedded ? false : true;
                }(),
                columns: function(){
                    var columns = [
                        {
                            id:"value",
                            fillspace:true,
                            template: function(obj, common, value, config)
                            {
                                var locale = LangHelper.GetLocale();
                                var str = common.treetable(obj, common, value, config) + (obj.widget_icon ? "<span class='webix_icon fa-" + obj.widget_icon + "'></span>" : "") + (obj.widget_name && obj.widget_name[locale] ? obj.widget_name[locale] : obj.widget_name.en);

                                if(_this.Dragable && obj.is_widget)
                                    str = "<div class='webix_tree_none webix_tree_drag'><span class='webix_icon fa-arrows'></span></div>" + str;

                                return str;
                            }
                        }
                    ];

                    if(_this.Editable)
                    {
                        columns.push(
                            {
                                id:"edit",
                                header: "",
                                width: 32,
                                template: function(Obj) {
                                    if(!Obj.is_system && Obj.is_widget && Obj.widget_settings) {
                                        return CellEditBtnTemplate();
                                    }
                                    return "";
                                },
                                headermenu: false
                            }
                        );

                        columns.push(
                            {
                                id:"trash",
                                header: "",
                                width: 32,
                                template: function(Obj) {
                                    if(!Obj.is_system && Obj.is_widget && Obj.widget_settings) {
                                        return CellTrashBtnTemplate();
                                    }
                                    return ""
                                },
                                headermenu: false
                            }
                        );
                    }

                    return columns;
                }(),
                data: [],
                on:function()
                {
                    var on = {
                        onItemDblClick:function(id, e, node)
                        {
                            var data = _this.GetSelectedItem();

                            if(data.$count > 0)
                            {
                                this.open(id);
                                return;
                            }

                            if(data && data.widget)
                                _this.Signals.Select.next(data.widget);

                            _this.Hide();
                        },

                        onItemClick:function(id, e, node)
                        {
                            var data = _this.GetSelectedItem();

                            if(!data.is_widget) {
                                return;
                            }
                            if(data.is_widget && !data.is_system)
                            {
                                if(id.column === "edit") {
                                    _this.ShowEditForm(this.getItem(id.row), this.getItemNode(id.row), "left");
                                }

                                if(id.column === "trash") {
                                    Helper.Table.ShowTrashForm(id.row, function() {
                                        _this.DeleteWidget();
                                    }, _this.Views.WidgetsList, this.getItemNode(id.row));
                                }
                            }

                            // if(data.$count > 0)
                            // {
                            //     return;
                            // }

                            if(data)
                                _this.Signals.Select.next(data);

                            _this.Hide();
                        }
                    };

                    if(_this.Dragable){
                        on.onBeforeDrag = function(context, native_event)
                        {
                            var item = this.getItem(context.start);
                            return !!(item.is_widget);
                            // return item.$count ? !!(item.is_widget) : true;
                        };
                    }

                    return on;
                }()
            }
        ]};

    if(!this.Embedded)
    {
        // this.ViewConfig.rows.push(
        //     {
        //         view:"button",
        //         value:LangHelper.GetString("All","Select"),
        //         click:function()
        //         {
        //             var data = _this.GetSelectedItem();
        //
        //             if(data && data.widget)
        //                 _this.Signals.Select.next(data.widget);
        //
        //             _this.Hide();
        //         }
        //     }
        // );

        this.ContextConfig = {
            view: "popup",
            id:this.Id + "Context",
            maxWidth: 400,
            maxHeight: 400,
            resize: true,
            body: this.ViewConfig
        };
    }
};

QoEWidgetsSuggestWidget.prototype.Bind = function (ViewController)
{
    var _this = this;

    if(!this.Embedded)
        this.Context = webix.ui(this.ContextConfig);

    this.Views.WidgetsList = $$(this.Id + "WidgetsList");

    this.QoEWidgetEditFormContext.Bind();

    this.Subscriptions.SignalWidgetsUpdated = this.ViewModel.SignalWidgetsUpdated.subscribe(function(Data) {
        if(Data) {
            _this.UpdateWidgets();
        }
    });

    this.Subscriptions.SignalSaveWidget = this.QoEWidgetEditFormContext.Signals.Save.subscribe(function(Value) {
        if(Value) {
            _this.WidgetEditFormSignalSaveHandler();
        }
    });

    App.WebSocketManager.Connect(this.WebSocketRoom);

    App.WebSocketManager.Connections[this.WebSocketRoom].on("qoe_widget_saved", R => {
        var response = JSON.parse(R);

        if(response.success) {
            this.AddWidget(new QoEWidgetGetModel(response.data));
        }
    });

    App.WebSocketManager.Connections[this.WebSocketRoom].on("qoe_widget_updated", R => {
        var response = JSON.parse(R);

        if(response.success) {
            this.UpdateWidget(new QoEWidgetGetModel(response.data));
        }
    });

    App.WebSocketManager.Connections[this.WebSocketRoom].on("qoe_widget_deleted", R => {
        var response = JSON.parse(R);

        if(response.success) {
            this.RemoveWidget(new QoEWidgetGetModel(response.data));
        }
    });
};

QoEWidgetsSuggestWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.QoEWidgetEditFormContext.Destroy();

    App.WebSocketManager.Disconnect(this.WebSocketRoom);

    if(this.ViewModel) {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEWidgetsSuggestWidget.prototype.Show = function (Node, Pos)
{
    if(!this.Embedded)
        this.Context.show(Node,{pos:Pos});
};

QoEWidgetsSuggestWidget.prototype.Hide = function ()
{
    if(!this.Embedded)
        this.Context.hide();
};

QoEWidgetsSuggestWidget.prototype.GetItem = function (Id)
{
    return this.Views.WidgetsList.getItem(Id);
};

QoEWidgetsSuggestWidget.prototype.GetSelectedItem = function ()
{
    return this.Views.WidgetsList.getSelectedItem();
};

QoEWidgetsSuggestWidget.prototype.SelectItem = function (Id)
{
    this.Views.WidgetsList.clearSelection();
    this.Views.WidgetsList.closeAll();

    this.Views.WidgetsList.select(Id);

    this.Views.WidgetsList.open(this.Views.WidgetsList.getParentId(Id), true);
};

QoEWidgetsSuggestWidget.prototype.UnselectAll = function()
{
    this.Views.WidgetsList.clearSelection();
};

QoEWidgetsSuggestWidget.prototype.ScrollToSelectedItem = function ()
{
    var item = this.GetSelectedItem();

    if(item)
        this.Views.WidgetsList.showItem(item.id);
};

QoEWidgetsSuggestWidget.prototype.SelectItemByWidgetName = function (WidgetName)
{
    var item = this.FindItemByWidgetName({func: WidgetName});

    if(item && item.id)
    {
        this.SelectItem(item.id);
    }
};

QoEWidgetsSuggestWidget.prototype.FindItemByConfig = function (FindConfig)
{
    var res = this.Views.WidgetsList.find(
        widget => {
            if(typeof widget == "object")
            {
                return Object.keys(FindConfig).every(
                    key => {
                        return widget[key] && widget[key] == FindConfig[key];
                    }
                );
            }
            return false;
        },
        true);

    return Array.isArray(res) && res.length === 0 ? null : res;
};

QoEWidgetsSuggestWidget.prototype.FindItem = function (
    WidgetCode = null,
    WidgetName = null,
    WidgetFunc = null
)
{
    let find;

    if(WidgetCode)
        find = this.FindItemByConfig({
            widget_code: WidgetCode
        });

    if(!find && WidgetName)
        find = this.FindItemByConfig({
            func: WidgetName
        });

    if(!find && WidgetFunc)
        find = this.FindItemByConfig({
            func: WidgetFunc
        });

    return find;
};

QoEWidgetsSuggestWidget.prototype.FindItemByParams = function (Params)
{
    const widget_code = Params.widget_code ? Params.widget_code : null;
    const widget_name = Params.widget_name ? Params.widget_name : null;
    const widget_func = Params.widget_func
        ? Params.widget_func
        : widget_name ? widget_name : null;

    return this.FindItem(
        widget_code,
        widget_name,
        widget_func
    );
};

QoEWidgetsSuggestWidget.prototype.RefreshWidgets = function()
{
    this.ViewModel.RefreshWidgets();
};

QoEWidgetsSuggestWidget.prototype.ParseWidgetsList = function(Arr)
{
    let result = [];

    Arr.forEach( w => {
        if(this.ExceptWidgetCodes.includes(w.widget_code))
            return;

        if(w.widget_code.includes(CustomQoEAggLogsReportsKey))
            if(!this.IsValidCustomReportsWidget(w))
                return;

        if(w.data && w.data.length) {
            w.data = this.ParseWidgetsList(w.data);

            if(!w.data.length)
                return;
        }

        result.push(w);
    });

    return result;
};

QoEWidgetsSuggestWidget.prototype.UpdateWidgets = function()
{
    var widgets = this.ViewModel.GetWidgets();

    let res = this.ParseWidgetsList(widgets);

    this.Views.WidgetsList.clearAll();

    this.Views.WidgetsList.parse(res);

    this.isUpdatedWidgets = true;

    this.Signals.WidgetsUpdated.next(1);
};

QoEWidgetsSuggestWidget.prototype.AddWidget = function(Widget)
{
    var _this = this;

    var role = App.SessionManager.GetUserRoleId();

    var addFunction = function()
    {
        var parentWidget = _this.FindItemByConfig({widget_id: Widget.parent_id});

        if(parentWidget) {
            _this.Views.WidgetsList.add(Widget, 0, parentWidget.id);
        }
    };

    if(Widget.available === AvailableUsersEnum.any_users.id || Widget.owner_id === App.SessionManager.GetProfile().user_id)
    {
        addFunction();
    }
    else if(Widget.available === AvailableUsersEnum.roles_users.id)
    {
        if(Array.isArray(Widget.available_for_roles)
            && Widget.available_for_roles.find(roleId => role == roleId)
        ){
            addFunction();
        }
    }
};

QoEWidgetsSuggestWidget.prototype.UpdateWidget = function(Widget)
{
    var _this = this;

    var role = App.SessionManager.GetUserRoleId();

    var updatedWidget = _this.FindItemByConfig({widget_id: Widget.widget_id});
    var parentWidget = _this.FindItemByConfig({widget_id: Widget.parent_id});

    var updateWidget = function() {
        if(updatedWidget) {
            _this.Views.WidgetsList.updateItem(updatedWidget.id, Widget);
        }
        else if(parentWidget) {
            _this.Views.WidgetsList.add(Widget, 0, parentWidget.id);
        }
    }

    if(Widget.available === AvailableUsersEnum.any_users.id || Widget.owner_id === App.SessionManager.GetProfile().user_id) {
        updateWidget();
    }
    else if(Widget.available === AvailableUsersEnum.roles_users.id) {
        if(Array.isArray(Widget.available_for_roles) && Widget.available_for_roles.find(roleId => role == roleId)) {
            updateWidget();
        }
        else {
            this.RemoveWidgetFromTable(updatedWidget);
        }
    }
    else {
        this.RemoveWidgetFromTable(updatedWidget);
    }
};

QoEWidgetsSuggestWidget.prototype.RemoveWidget = function(Widget)
{
    this.RemoveWidgetFromTable(this.FindItemByConfig({widget_id: Widget.widget_id}));
};

QoEWidgetsSuggestWidget.prototype.RemoveWidgetFromTable = function(DeletedWidget)
{
    if(DeletedWidget) {
        this.Views.WidgetsList.remove(DeletedWidget.id);
        this.Signals.WidgetRemove.next(1);
    }
};

QoEWidgetsSuggestWidget.prototype.DeleteWidget = function(Id)
{
    var item = this.GetSelectedItem();

    if(item.widget_id) {
        this.ViewModel.DeleteWidget({
            widget: item,
            callback: function(R) {
                if(R.success) {
                    webix.message(LangHelper.GetString("QoE", "Widget deleted"));
                }
                else {
                    if(R.error) {
                        webix.message({type: "error", text:R.error.msg});
                    }
                }
            }
        });
    }
};

QoEWidgetsSuggestWidget.prototype.CopySettingsIntoNewWidget = function(Params)
{
    this.ViewModel.CopySettingsIntoNewWidget(Params);
};

QoEWidgetsSuggestWidget.prototype.ShowEditForm = function(Model, Node, Pos)
{
    this.QoEWidgetEditFormContext.SetData(Model);
    this.QoEWidgetEditFormContext.Show(Node, Pos);
};

QoEWidgetsSuggestWidget.prototype.WidgetEditFormSignalSaveHandler = function()
{
    var widget = this.QoEWidgetEditFormContext.GetData();

    if (widget) {
        this.ViewModel.SaveWidget({widget, callback: (R) => {
                this.QoEWidgetEditFormContext.Hide();
            }
        });
    }
};

QoEWidgetsSuggestWidget.prototype.FindItemByWidgetName = function (WigetName)
{
    var data = this.Views.WidgetsList.serialize();

    var item;

    function FindItem(R)
    {
        if(Array.isArray(R))
        {
            R.forEach(function (Item)
            {
                if(typeof Item == "object" && Item.data)
                {
                    FindItem(Item.data);
                }
                else if(typeof Item == "object" && Item.widget && Item.widget == WigetName && Item.value)
                {
                    item = Item;
                }
            });
        }
    }

    FindItem(data);

    return item;
};

QoEWidgetsSuggestWidget.prototype.GetWidgetFilterType = function(Widget)
{
    var _this = this;

    if(!Object.keys(_this.WidgetsByFilterType).length) {
        var data = this.Views.WidgetsList.serialize();

        var currentType = null;
        function FindItem(Params) {
            Params.forEach(item => {
                if(item.hasOwnProperty("filter_type")) {
                    currentType = item.filter_type;
                    if(!Object.keys(_this.WidgetsByFilterType).includes(currentType)) {
                        _this.WidgetsByFilterType[currentType] = [];
                    }
                }
                if(item.hasOwnProperty("data")) {
                    FindItem(item.data);
                }
                else {
                    _this.WidgetsByFilterType[currentType].push(item.widget);
                }
            });
        };

        FindItem(data);
    }

    return Object.keys(_this.WidgetsByFilterType).find(Key => _this.WidgetsByFilterType[Key].find(elem => elem === Widget.widget));
};

QoEWidgetsSuggestWidget.prototype.BuildExceptWidgetCodesList = function(CodesList = null)
{
    let exceptList = Array.isArray(CodesList) && CodesList.length > 0 ? CodesList : [];

    if(!AppEnv || !AppEnv.EnableVoipGroup)
        exceptList = exceptList.concat(ExceptWidgetCodes.voip);

    if(!AppEnv || !AppEnv.DDoSAttack_isVisible)
        exceptList = exceptList.concat(ExceptWidgetCodes.ddos);

    if(!AppEnv || !AppEnv.CustomReportsGroupCode)
        exceptList = exceptList.concat(ExceptWidgetCodes.custom_agg);

    return exceptList;
};

QoEWidgetsSuggestWidget.prototype.IsValidCustomReportsWidget = function(Widget)
{
    const widgetCode = Widget.widget_code ? Widget.widget_code : "";

    if(!widgetCode)
        return false

    const widgetSettings = Widget.widget_settings ? Widget.widget_settings : {};

    const widgetFunc = Widget.func ? Widget.func : "";
    const customGroup = AppEnv ? AppEnv.CustomReportsGroupCode : "";
    const widgetName = widgetSettings.name ? widgetSettings.name : "";

    let code = CustomQoEAggLogsReportsKey;

    if(Widget.is_widget)
        code = code + customGroup + widgetName + widgetFunc;

    return widgetCode === code;
};
function QoEAnyReportSelectorWidget(Widget, ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.Widget = Widget;

    this.WidgetName = null;

    this.Views = {};

    this.ViewConfig = null;

    this.ContextConfig = null;

    this.Context = null;

    this.Subscriptions = {};

    this.Signals = {
        Select: new Rx.BehaviorSubject(null)
    };

    this.Init(ViewConfig);
}

QoEAnyReportSelectorWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.WidgetName = ViewConfig.name ? ViewConfig.name : null;

    this.Views.WidgetsList = new QoEWidgetsSuggestWidget({
        id:this.Id + "WidgetsList",
        embedded:true,
        borderless:false,
        exceptWidgetCodes: ExceptWidgetCodes.with_settings
    });

    this.Views.ExtendedFillter = new QoEPopupFilterWidget({id:this.Id + "ExtendedFillter", config:QoEPopupFilterWidgetDefaultConfig()});

    this.Views.DateRangePicker = new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"});

    this.ViewConfig = {
        cols:[
            {
                type: "space",
                borderless: true,
                rows:[
                    {
                        type: "clear",
                        borderless: true,
                        rows:[
                            {
                                //view:"label",
                                //borderless:true,
                                height:40,
                                template:LangHelper.GetString("QoE", "Select a report and options to get another report")
                            },
                            {
                                height:2
                            },
                            this.Views.WidgetsList.ViewConfig,
                            {
                                view: "toolbar",
                                //height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                elements: [
                                    this.Views.DateRangePicker.ViewConfig,
                                    this.Views.ExtendedFillter.ViewConfig
                                ]
                            },
                            {
                                view:"form",
                                elements:[
                                    {
                                        cols:[
                                            {},
                                            {
                                                view:"button",
                                                value:LangHelper.GetString("All","Cancel"),
                                                click:function()
                                                {
                                                    _this.Hide();
                                                }
                                            },
                                            {
                                                view:"button",
                                                value:LangHelper.GetString("QoE","Open report"),
                                                type:"form",
                                                click:function()
                                                {
                                                    var data = _this.GetSelectedItem();

                                                    if(data && data.func)
                                                        _this.Signals.Select.next(data.func);

                                                    _this.Hide();
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };

    this.ContextConfig = {
        view: "popup",
        id:this.Id + "Context",
        maxWidth: 480,
        maxHeight: 480,
        resize: true,
        modal:true,
        body: this.ViewConfig
    };
};

QoEAnyReportSelectorWidget.prototype.Bind = function (ViewController)
{
    var _this = this;

    this.Context = webix.ui(this.ContextConfig);

    this.Views.WidgetsList.Bind(ViewController);

    this.Views.ExtendedFillter.Bind(ViewController);

    this.Views.DateRangePicker.Bind(ViewController);

    this.Subscriptions.WidgetsListSignal = this.Views.WidgetsList.Signals.Select.subscribe(function (SelectedWidgetName)
    {
        if(SelectedWidgetName)
            _this.PrepareFilters(SelectedWidgetName);
    });

    this.Subscriptions.Signal = this.Signals.Select.subscribe(function (SelectedWidgetName)
    {
        if(SelectedWidgetName)
        {
            _this.Hide();

            var filterStateConfig =
                {
                    filter_state:_this.Views.ExtendedFillter.GetState(),
                    filter_config: _this.Views.ExtendedFillter.GetFilters()
                };


            var period = _this.Views.DateRangePicker.GetValue();

            var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

            var periodState = {
                period_from:format(period.start),
                period_to:format(period.end)
            };

            var storedReport = new QoEStoredReportBaseModel({
                _id: webix.uid(),
                widget_name:SelectedWidgetName,
                filter_config_json: JSON.stringify(filterStateConfig),
                period_state_json: JSON.stringify(periodState)
            });

            _this.Widget.ViewModel.SaveStoredReport(storedReport, function (R) {
                if(R && R.success && R.data)
                {
                    window.open("/#QoEAnyReport/report_id=" + R.data._id, "_blank");
                }
            });
        }
    });

    this.Views.WidgetsList.RefreshWidgets();
};

QoEAnyReportSelectorWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.Views.WidgetsList.Destroy();

    this.Views.ExtendedFillter.Destroy();

    this.Views.DateRangePicker.Destroy();

    this.Widget = null;
};

QoEAnyReportSelectorWidget.prototype.Show = function (Node, Pos)
{
    if(!this.Widget.IfRowContextMenuApplicable())
    {
        webix.message(LangHelper.GetString("QoE", "Not applicable"));
        return;
    }

    this.Views.WidgetsList.SelectItemByWidgetName(this.WidgetName);

    this.PrepareFilters();

    this.Context.show(Node,{pos:Pos});

    this.Views.WidgetsList.ScrollToSelectedItem();
};

QoEAnyReportSelectorWidget.prototype.Hide = function ()
{
    this.Context.hide();
};

QoEAnyReportSelectorWidget.prototype.GetItem = function (Id)
{
    return this.Views.WidgetsList.GetItem(Id);
};

QoEAnyReportSelectorWidget.prototype.GetSelectedItem = function ()
{
    return this.Views.WidgetsList.GetSelectedItem();
};

QoEAnyReportSelectorWidget.prototype.PrepareFilters = function (WidgetName)
{
    var filterStateConfig = this.Widget.GetFilterStateConfig();

    var periodState = this.Widget.GetPeriodState();

    var type = QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;
    
    if(this.WidgetName || WidgetName)
    {
        var wn = WidgetName ? WidgetName.toLowerCase() : this.WidgetName.toLowerCase();

        if(wn.indexOf("clickstream") >= 0)
        {
            type = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawClickstreamLogs : QoEPopupFilterWidgetConfigTypeEnum.QoEClickstream;
        }

        else if(wn.indexOf("fullnetflow") >= 0 || wn.indexOf("fullflow") >= 0 || wn.indexOf("netflow") >= 0)
        {
            type = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNetFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;
        }

        else if(wn.indexOf("gtp") >= 0 || wn.indexOf("location") >= 0)
        {
            if(wn.indexOf("raw") >= 0)
            {
                type = QoEPopupFilterWidgetConfigTypeEnum.QoERawFullGtpFlow;
            }
            else{
                type = QoEPopupFilterWidgetConfigTypeEnum.QoEFullGtpFlow
            }
        }
        else if(wn.indexOf("nat") >= 0)
        {
            type = QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNatFlow;
        }
        else if(wn.indexOf("vchannels") >= 0 || wn.indexOf("classes") >= 0)
        {
            type = QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;
        }
        else if(wn.indexOf("dns") >= 0)
        {
            if(wn.indexOf("raw") >= 0)
            {
                type = QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDnsFlow;
            }
            else{
                type = QoEPopupFilterWidgetConfigTypeEnum.QoEFullDnsFlow;
            }
        }
    }

    var defaultConfig = QoEPopupFilterWidgetDefaultConfig(type);

    var availFiltersIds = {};

    defaultConfig.filters.forEach(function (F)
    {
        if(F.id)
            availFiltersIds[F.id] = F.operators && F.operators.length ? F.operators[0] : "like";
    });

    var finalState = [];

    filterStateConfig.filter_state.forEach(function (S)
    {
        if(availFiltersIds[S.f_id])
        {
            finalState.push(webix.extend({}, S, true));
        }
    });

    var tableSelectedRow = this.Widget.GetSelectedData();

    var availValues = [];

    if(this.Widget.Config.cache && this.Widget.Config.cache.values)
    {
        this.Widget.Config.cache.values.forEach(function (V)
        {
            if(typeof V == "object")
                availValues.push(V.alias ? V.alias : V.col);
            else
                availValues.push(V);
        });
    }

    if(tableSelectedRow )
    {
        availValues.forEach(function (V)
        {
            var preparedV = Helper.ReplaceAll(["_other", "_any"], "", V);

            if(preparedV == "protocol" && availFiltersIds["app_protocol"])
                preparedV = "app_protocol";
            else if(preparedV == "app_protocol" && availFiltersIds["protocol"])
                preparedV = "protocol";

            if(tableSelectedRow[V] && availFiltersIds[preparedV])
            {
                finalState.push(new QoEPopupFilterWidgetFilterRowModel({
                    f_enabled: 1,
                    f_id: preparedV,
                    f_operator: availFiltersIds[preparedV],
                    f_value: tableSelectedRow[V]
                }));
            }
        });
    }

    this.Views.ExtendedFillter.SetConfig(defaultConfig);

    this.Views.ExtendedFillter.SetState(finalState);

    var format = webix.Date.strToDate("%Y-%m-%d %H:%i:%s");

    this.Views.DateRangePicker.SetValue({start: format(periodState.period_from), end: format(periodState.period_to)}, true);
};
var ControllersEnum = {

    DpiPerformance:"DpiPerformance",
    DpiConfig:"DpiConfig",
    DpiDscpConfig:"DpiDscpConfig",
    DpiAsnDscpConfig:"DpiAsnDscpConfig",
    DpiLogs:"DpiLogs",

    Hardwares:"Hardwares",
    HardwareSshKeys:"HardwareSshKeys",

    Subscribers:"Subscribers",
    Services:"Services",
    Tariffs:"Tariffs",
    Advc:"Advc",
    HotSpot: "HotSpot",

    QoEDashboard:"QoEDashboard",
    QoEClickStream:"QoEClickStream",
    QoEFullNetFlow:"QoEFullNetFlow",
    QoEFullGtpFlow:"QoEFullGtpFlow",
    QoERawFullGtpFlow:"QoERawFullGtpFlow",
    QoEFullNatFlow:"QoEFullNatFlow",
    QoERawFullNatFlow:"QoERawFullNatFlow",
    QoESubscribers:"QoESubscribers",
    QoEOnlineReports:"QoEOnlineReports",
    QoERawFullNetFlow:"QoERawFullNetFlow",
    QoERawClickstream:"QoERawClickstream",
    QoERawFullDnsFlow:"QoERawFullDnsFlow",
    QoEFullDnsFlow:"QoEFullDnsFlow",
    QoEFullDdosAttackFlow:"QoEFullDdosAttackFlow",
    QoERawFullDdosAttackFlow:"QoERawFullDdosAttackFlow",
    QoELogs:"QoELogs",
    QoEAdmin:"QoEAdmin",
    QoETriggers:"QoETriggers",
    QoEAnyReport:"QoEAnyReport",
    QoECustomReports:"QoECustomReports",
    QoEUserReports:"QoEUserReports",
    QoEMailingTemplates:"QoEMailingTemplates",

    Users:"Users",
    Roles:"Roles",
    UsersActionsLog:"UsersActionsLog",
    Health:"Health",
    Dpiui2Config:"Dpiui2Config",
    Dpiui2Logs:"Dpiui2Logs",
    Dpiui2Update:"Dpiui2Update",
    QoEStorConfig:"QoEStorConfig",
    QoEStorLogs:"QoEStorLogs",
    BalancerConfig:"BalancerConfig",
    BalancerLogs:"BalancerLogs",
    FastPcrfConfig: "FastPcrfConfig",
    FastPcrfLogs: "FastPcrfLogs",
    CaptchaConfig:"CaptchaConfig",
    CaptchaTemplates:"CaptchaTemplates",
    CaptchaLogs:"CaptchaLogs",

    VasCloud:"VasCloud",
    VasCloudShop:"VasCloudShop",
    VasCloudPersonalArea:"VasCloudPersonalArea",
    VasCloudAds:"VasCloudAds",
    VasCloudAdsStatistics:"VasCloudAdsStatistics",
    VasCloudAccrualsAndPayments:"VasCloudAccrualsAndPayments",
    VasCloudLogin:"VasCloudLogin",
    VasCloudProtocolsCustom:"VasCloudProtocolsCustom",
    VasCloudCustomProtocolsGroups:"VasCloudCustomProtocolsGroups",
    VasCloudProtocolsLogs:"VasCloudProtocolsLogs",

    NoFound:"NoFound",

    UlrWebIpFilterRules:"UlrWebIpFilterRules",
    UlrAddWebIpFilterRule:"UlrAddWebIpFilterRule",
    UlrEditWebIpFilterRule:"UlrEditWebIpFilterRule",
    UlrCheckDomain:"UlrCheckDomain",
    UlrExcludedResources:"UlrExcludedResources",
    UlrWebSearchDatabase:"UlrWebSearchDatabase",
    UlrHostCategories:"UlrHostCategories",
    UlrWebRulesStatistics:"UlrWebRulesStatistics",

    UlrSpoofDnsRules:"UlrSpoofDnsRules",
    UlrAddSpoofDnsRule:"UlrAddSpoofDnsRule",
    UlrEditSpoofDnsRule:"UlrEditSpoofDnsRule",

    UlrAppPolicings:"UlrAppPolicings",
    UlrEditAppPolicing:"UlrEditAppPolicing",
    UlrIgwPolicings: "UlrIgwPolicings",
    UlrEditIgwPolicing:"UlrEditIgwPolicing",
    UlrSubscribersPolicings: "UlrSubscribersPolicings",
    UlrEditSubscriberPolicing:"UlrEditSubscriberPolicing",
    UlrAppDscpRules:"UlrAppDscpRules",
    UlrAppProtocols:"UlrAppProtocols",
    UlrIspSessionPolicings: "UlrIspSessionPolicings",
    UlrEditIspSessionPolicing: "UlrEditIspSessionPolicing",

    UlrSubscribersSessionPolicings: "UlrSubscribersSessionPolicings",
    UlrEditSubscriberSessionPolicing: "UlrEditSubscriberSessionPolicing",

    UlrAppCustomProtocols:"UlrAppCustomProtocols",
    UlrAppGroupsCustomProtocols:"UlrAppGroupsCustomProtocols",
    UlrCheckResourcesIntersection:"UlrCheckResourcesIntersection",
    UlrAppPrtclsCustomLogs:"UlrAppPrtclsCustomLogs",
    UlrFastresourceCustomPrtcls: "UlrFastresourceCustomPrtcls",

    UlrAsnDscpRules:"UlrAsnDscpRules",
    UlrAddAsnDscpRule:"UlrAddAsnDscpRule",
    UlrEditAsnDscpRule:"UlrEditAsnDscpRule",
    UlrAsnRuleList:"UlrAsnRuleList",

    UlrIgwsList:"UlrIgwsList",
    UlrSubsList:"UlrSubsList",
    UlrEditSubs:"UlrEditSubs",
    UlrAddSubs:"UlrAddSubs",
    UlrIspsList:"UlrIspsList",
    UlrAddIsp:"UlrAddIsp",
    UlrEditIsp:"UlrEditIsp",
    UlrAddIgw:"UlrAddIgw",
    UlrEditIgw:"UlrEditIgw",

    UlrRecordPCAP: "UlrRecordPCAP",
    UlrPCAPFiles: "UlrPCAPFiles",
    UlrPCAPLogs: "UlrPCAPLogs",

    UlrSearchDatabase:"UlrSearchDatabase",

    UlrSytemGlobalState:"UlrSytemGlobalState",
    UlrIgwsNodesList:"UlrIgwsNodesList",
    UlrIgwsQoEsList:"UlrIgwsQoEsList",
    UlrIgwNodePerformance:"UlrIgwNodePerformance",
    UlrIgwNodeLogs:"UlrIgwNodeLogs",
    UlrUsersActionsLog:"UlrUsersActionsLog",
    UlrTrafficRedirectionRules:"UlrTrafficRedirectionRules",

    UlrWhiteList:"UlrWhiteList",
    UlrAddWhiteListRule:"UlrAddWhiteListRule",
    UlrEditWhiteListRule:"UlrEditWhiteListRule",
    UlrWhiteListMode:"UlrWhiteListMode",

    UlrIpExcludesRules:"UlrIpExcludesRules",
    UlrAsnExcludesRules:"UlrAsnExcludesRules",
    UlrVipSubscribersRules:"UlrVipSubscribersRules",

    UlrTest:"UlrTest",

    UrlCategoriesDic:"UrlCategoriesDic",
    UlrCustomGroupsOfProtocols:"UlrCustomGroupsOfProtocols",
    UrlRegulatorsDic:"UrlRegulatorsDic",
    UlrSessionPolicingsTemplates: "UlrSessionPolicingsTemplates",
    UlrEditSessionPolicingTemplate: "UlrEditSessionPolicingTemplate",
    UlrAddSessionPolicingTemplate: "UlrAddSessionPolicingTemplate",

    UlrRecipientGroupList:"UlrRecipientGroupList",
    UlrEditRecipientGroup:"UlrEditRecipientGroup",
    UlrAddRecipientGroup:"UlrAddRecipientGroup",

    UlrMailingList:"UlrMailingList",
    UlrEditMailing:"UlrEditMailing",
    UlrAddMailing:"UlrAddMailing",
    UlrMailingTemplatesList:"UlrMailingTemplatesList",
    UlrEditTemplateMailing:"UlrEditTemplateMailing",
    UlrAddTemplateMailing:"UlrAddTemplateMailing",
    UlrQoEAnyReport:"UlrQoEAnyReport",

    ConnectionsValidateData:"ConnectionsValidateData",
    TrafficManagementGenerator:"TrafficManagementGenerator",
    TrafficManagementCapture:"TrafficManagementCapture",
    TrafficManagementSiteClone:"TrafficManagementSiteClone",
    NetworkAudit:"NetworkAudit",
    LiHealth:"LiHealth",
    TrafficDecodeLogs: "TrafficDecodeLogs",
    TrafficDecode: "TrafficDecode",

    // Test: "Test",
    HardwareSshTerminal: "HardwareSshTerminal",
    Classifier:"Classifier",
    ClassifierModel:"ClassifierModel",
    ClassifierConfig:"ClassifierConfig",
    ClassifierLogs:"ClassifierLogs",

    AntiDDoSNetworks:"AntiDDoSNetworks",
    AntiDDoSThreats:"AntiDDoSThreats",
    AntiDDoSProtection:"AntiDDoSProtection",

};

var UiModulesFiles = {
    li: "li",
    users_actions_ui: "users_actions_ui"
};

var UiControllersModules = {};
UiControllersModules[ControllersEnum.ConnectionsValidateData] = UiModulesFiles.li;
UiControllersModules[ControllersEnum.TrafficManagementGenerator] = UiModulesFiles.li;
UiControllersModules[ControllersEnum.TrafficManagementCapture] = UiModulesFiles.li;
UiControllersModules[ControllersEnum.TrafficManagementSiteClone] = UiModulesFiles.li;
UiControllersModules[ControllersEnum.NetworkAudit] = UiModulesFiles.li;
UiControllersModules[ControllersEnum.LiHealth] = UiModulesFiles.li;
UiControllersModules[ControllersEnum.TrafficDecodeLogs] = UiModulesFiles.li;
UiControllersModules[ControllersEnum.TrafficDecode] = UiModulesFiles.li;

UiControllersModules[ControllersEnum.UsersActionsLog] = UiModulesFiles.users_actions_ui;

var RoutesValsEnum = {};
RoutesValsEnum[""] = "index";
RoutesValsEnum["index"] = "index";
RoutesValsEnum["login"] = "login";

RoutesValsEnum[ControllersEnum.DpiPerformance+"(*path)"] = ControllersEnum.DpiPerformance;
RoutesValsEnum[ControllersEnum.DpiConfig+"(*path)"] = ControllersEnum.DpiConfig;
RoutesValsEnum[ControllersEnum.DpiDscpConfig+"(*path)"] = ControllersEnum.DpiDscpConfig;
RoutesValsEnum[ControllersEnum.DpiAsnDscpConfig+"(*path)"] = ControllersEnum.DpiAsnDscpConfig;
RoutesValsEnum[ControllersEnum.DpiLogs+"(*path)"] = ControllersEnum.DpiLogs;
// RoutesValsEnum[ControllersEnum.Test+"(*path)"] = ControllersEnum.Test;

RoutesValsEnum[ControllersEnum.Hardwares+"(*path)"] = ControllersEnum.Hardwares;
RoutesValsEnum[ControllersEnum.HardwareSshKeys+"(*path)"] = ControllersEnum.HardwareSshKeys;

RoutesValsEnum[ControllersEnum.Subscribers+"(*path)"] = ControllersEnum.Subscribers;
RoutesValsEnum[ControllersEnum.Services+"(*path)"] = ControllersEnum.Services;
RoutesValsEnum[ControllersEnum.Tariffs+"(*path)"] = ControllersEnum.Tariffs;
RoutesValsEnum[ControllersEnum.Advc+"(*path)"] = ControllersEnum.Advc;
RoutesValsEnum[ControllersEnum.HotSpot+"(*path)"] = ControllersEnum.HotSpot;

RoutesValsEnum[ControllersEnum.QoEDashboard+"(*path)"] = ControllersEnum.QoEDashboard;
RoutesValsEnum[ControllersEnum.QoEClickStream+"(*path)"] = ControllersEnum.QoEClickStream;
RoutesValsEnum[ControllersEnum.QoEFullNetFlow+"(*path)"] = ControllersEnum.QoEFullNetFlow;
RoutesValsEnum[ControllersEnum.QoEFullGtpFlow+"(*path)"] = ControllersEnum.QoEFullGtpFlow;
RoutesValsEnum[ControllersEnum.QoERawFullGtpFlow+"(*path)"] = ControllersEnum.QoERawFullGtpFlow;
RoutesValsEnum[ControllersEnum.QoEFullNatFlow+"(*path)"] = ControllersEnum.QoEFullNatFlow;
RoutesValsEnum[ControllersEnum.QoERawFullNatFlow+"(*path)"] = ControllersEnum.QoERawFullNatFlow;
RoutesValsEnum[ControllersEnum.QoERawFullDnsFlow+"(*path)"] = ControllersEnum.QoERawFullDnsFlow;
RoutesValsEnum[ControllersEnum.QoEFullDnsFlow+"(*path)"] = ControllersEnum.QoEFullDnsFlow;
RoutesValsEnum[ControllersEnum.QoEFullDdosAttackFlow+"(*path)"] = ControllersEnum.QoEFullDdosAttackFlow;
RoutesValsEnum[ControllersEnum.QoERawFullDdosAttackFlow+"(*path)"] = ControllersEnum.QoERawFullDdosAttackFlow;
RoutesValsEnum[ControllersEnum.QoESubscribers+"(*path)"] = ControllersEnum.QoESubscribers;
RoutesValsEnum[ControllersEnum.QoEOnlineReports+"(*path)"] = ControllersEnum.QoEOnlineReports;
RoutesValsEnum[ControllersEnum.QoERawFullNetFlow+"(*path)"] = ControllersEnum.QoERawFullNetFlow;
RoutesValsEnum[ControllersEnum.QoERawClickstream+"(*path)"] = ControllersEnum.QoERawClickstream;
RoutesValsEnum[ControllersEnum.QoELogs+"(*path)"] = ControllersEnum.QoELogs;
RoutesValsEnum[ControllersEnum.QoEAdmin+"(*path)"] = ControllersEnum.QoEAdmin;
RoutesValsEnum[ControllersEnum.QoETriggers+"(*path)"] = ControllersEnum.QoETriggers;
RoutesValsEnum[ControllersEnum.QoEAnyReport+"(*path)"] = ControllersEnum.QoEAnyReport;
RoutesValsEnum[ControllersEnum.QoECustomReports+"(*path)"] = ControllersEnum.QoECustomReports;
RoutesValsEnum[ControllersEnum.QoEUserReports+"(*path)"] = ControllersEnum.QoEUserReports;
RoutesValsEnum[ControllersEnum.QoEMailingTemplates+"(*path)"] = ControllersEnum.QoEMailingTemplates;

RoutesValsEnum[ControllersEnum.UsersActionsLog+"(*path)"] = ControllersEnum.UsersActionsLog;
RoutesValsEnum[ControllersEnum.Users+"(*path)"] = ControllersEnum.Users;
RoutesValsEnum[ControllersEnum.Roles+"(*path)"] = ControllersEnum.Roles;
RoutesValsEnum[ControllersEnum.Health+"(*path)"] = ControllersEnum.Health;
RoutesValsEnum[ControllersEnum.Dpiui2Config+"(*path)"] = ControllersEnum.Dpiui2Config;
RoutesValsEnum[ControllersEnum.Dpiui2Logs+"(*path)"] = ControllersEnum.Dpiui2Logs;
RoutesValsEnum[ControllersEnum.Dpiui2Update+"(*path)"] = ControllersEnum.Dpiui2Update;
RoutesValsEnum[ControllersEnum.QoEStorConfig+"(*path)"] = ControllersEnum.QoEStorConfig;
RoutesValsEnum[ControllersEnum.QoEStorLogs+"(*path)"] = ControllersEnum.QoEStorLogs;
RoutesValsEnum[ControllersEnum.BalancerConfig+"(*path)"] = ControllersEnum.BalancerConfig;
RoutesValsEnum[ControllersEnum.BalancerLogs+"(*path)"] = ControllersEnum.BalancerLogs;
RoutesValsEnum[ControllersEnum.FastPcrfConfig+"(*path)"] = ControllersEnum.FastPcrfConfig;
RoutesValsEnum[ControllersEnum.FastPcrfLogs+"(*path)"] = ControllersEnum.FastPcrfLogs;
RoutesValsEnum[ControllersEnum.CaptchaConfig+"(*path)"] = ControllersEnum.CaptchaConfig;
RoutesValsEnum[ControllersEnum.CaptchaTemplates+"(*path)"] = ControllersEnum.CaptchaTemplates;
RoutesValsEnum[ControllersEnum.CaptchaLogs+"(*path)"] = ControllersEnum.CaptchaLogs;

//RoutesValsEnum[ControllersEnum.VasCloud+"(*path)"] = ControllersEnum.VasCloud;
RoutesValsEnum[ControllersEnum.VasCloudLogin+"(*path)"] = ControllersEnum.VasCloudLogin;
RoutesValsEnum[ControllersEnum.VasCloudShop+"(*path)"] = ControllersEnum.VasCloudShop;
RoutesValsEnum[ControllersEnum.VasCloudPersonalArea+"(*path)"] = ControllersEnum.VasCloudPersonalArea;
RoutesValsEnum[ControllersEnum.VasCloudAdsStatistics+"(*path)"] = ControllersEnum.VasCloudAdsStatistics;
RoutesValsEnum[ControllersEnum.VasCloudAds+"(*path)"] = ControllersEnum.VasCloudAds;
RoutesValsEnum[ControllersEnum.VasCloudAccrualsAndPayments+"(*path)"] = ControllersEnum.VasCloudAccrualsAndPayments;
RoutesValsEnum[ControllersEnum.VasCloudProtocolsCustom+"(*path)"] = ControllersEnum.VasCloudProtocolsCustom;
RoutesValsEnum[ControllersEnum.VasCloudCustomProtocolsGroups+"(*path)"] = ControllersEnum.VasCloudCustomProtocolsGroups;
RoutesValsEnum[ControllersEnum.VasCloudProtocolsLogs+"(*path)"] = ControllersEnum.VasCloudProtocolsLogs;

RoutesValsEnum[ControllersEnum.UlrAddWebIpFilterRule+"(*path)"] = ControllersEnum.UlrAddWebIpFilterRule;
RoutesValsEnum[ControllersEnum.UlrEditWebIpFilterRule+"(*path)"] = ControllersEnum.UlrEditWebIpFilterRule;

RoutesValsEnum[ControllersEnum.UlrWebIpFilterRules+"(*path)"] = ControllersEnum.UlrWebIpFilterRules;
RoutesValsEnum[ControllersEnum.UlrCheckDomain+"(*path)"] = ControllersEnum.UlrCheckDomain;
RoutesValsEnum[ControllersEnum.UlrExcludedResources+"(*path)"] = ControllersEnum.UlrExcludedResources;
RoutesValsEnum[ControllersEnum.UlrWebSearchDatabase+"(*path)"] = ControllersEnum.UlrWebSearchDatabase;

RoutesValsEnum[ControllersEnum.UlrHostCategories+"(*path)"] = ControllersEnum.UlrHostCategories;

RoutesValsEnum[ControllersEnum.UlrWebRulesStatistics+"(*path)"] = ControllersEnum.UlrWebRulesStatistics;

RoutesValsEnum[ControllersEnum.UlrSpoofDnsRules+"(*path)"] = ControllersEnum.UlrSpoofDnsRules;
RoutesValsEnum[ControllersEnum.UlrAddSpoofDnsRule+"(*path)"] = ControllersEnum.UlrAddSpoofDnsRule;
RoutesValsEnum[ControllersEnum.UlrEditSpoofDnsRule+"(*path)"] = ControllersEnum.UlrEditSpoofDnsRule;


RoutesValsEnum[ControllersEnum.UlrAppPolicings+"(*path)"] = ControllersEnum.UlrAppPolicings;
RoutesValsEnum[ControllersEnum.UlrEditAppPolicing+"(*path)"] = ControllersEnum.UlrEditAppPolicing;

RoutesValsEnum[ControllersEnum.UlrIspSessionPolicings+"(*path)"] = ControllersEnum.UlrIspSessionPolicings;
RoutesValsEnum[ControllersEnum.UlrEditIspSessionPolicing+"(*path)"] = ControllersEnum.UlrEditIspSessionPolicing;

RoutesValsEnum[ControllersEnum.UlrSubscribersSessionPolicings+"(*path)"] = ControllersEnum.UlrSubscribersSessionPolicings;
RoutesValsEnum[ControllersEnum.UlrEditSubscriberSessionPolicing+"(*path)"] = ControllersEnum.UlrEditSubscriberSessionPolicing;

RoutesValsEnum[ControllersEnum.UlrIgwPolicings+"(*path)"] = ControllersEnum.UlrIgwPolicings;
RoutesValsEnum[ControllersEnum.UlrEditIgwPolicing+"(*path)"] = ControllersEnum.UlrEditIgwPolicing;

RoutesValsEnum[ControllersEnum.UlrSubscribersPolicings+"(*path)"] = ControllersEnum.UlrSubscribersPolicings;
RoutesValsEnum[ControllersEnum.UlrEditSubscriberPolicing+"(*path)"] = ControllersEnum.UlrEditSubscriberPolicing;

RoutesValsEnum[ControllersEnum.UlrAppDscpRules+"(*path)"] = ControllersEnum.UlrAppDscpRules;
RoutesValsEnum[ControllersEnum.UlrAppProtocols+"(*path)"] = ControllersEnum.UlrAppProtocols;

RoutesValsEnum[ControllersEnum.UlrAppCustomProtocols+"(*path)"] = ControllersEnum.UlrAppCustomProtocols;
RoutesValsEnum[ControllersEnum.UlrAppGroupsCustomProtocols+"(*path)"] = ControllersEnum.UlrAppGroupsCustomProtocols;
RoutesValsEnum[ControllersEnum.UlrCheckResourcesIntersection+"(*path)"] = ControllersEnum.UlrCheckResourcesIntersection;
RoutesValsEnum[ControllersEnum.UlrAppPrtclsCustomLogs+"(*path)"] = ControllersEnum.UlrAppPrtclsCustomLogs;
RoutesValsEnum[ControllersEnum.UlrFastresourceCustomPrtcls+"(*path)"] = ControllersEnum.UlrFastresourceCustomPrtcls;

RoutesValsEnum[ControllersEnum.UlrAsnDscpRules+"(*path)"] = ControllersEnum.UlrAsnDscpRules;

RoutesValsEnum[ControllersEnum.UlrAddAsnDscpRule+"(*path)"] = ControllersEnum.UlrAddAsnDscpRule;
RoutesValsEnum[ControllersEnum.UlrEditAsnDscpRule+"(*path)"] = ControllersEnum.UlrEditAsnDscpRule;

RoutesValsEnum[ControllersEnum.UlrAsnRuleList+"(*path)"] = ControllersEnum.UlrAsnRuleList;

RoutesValsEnum[ControllersEnum.UlrIgwsList+"(*path)"] = ControllersEnum.UlrIgwsList;
RoutesValsEnum[ControllersEnum.UlrSubsList+"(*path)"] = ControllersEnum.UlrSubsList;
RoutesValsEnum[ControllersEnum.UlrEditSubs+"(*path)"] = ControllersEnum.UlrEditSubs;
RoutesValsEnum[ControllersEnum.UlrAddSubs+"(*path)"] = ControllersEnum.UlrAddSubs;
RoutesValsEnum[ControllersEnum.UlrIspsList+"(*path)"] = ControllersEnum.UlrIspsList;
RoutesValsEnum[ControllersEnum.UlrAddIsp+"(*path)"] = ControllersEnum.UlrAddIsp;
RoutesValsEnum[ControllersEnum.UlrEditIsp+"(*path)"] = ControllersEnum.UlrEditIsp;
RoutesValsEnum[ControllersEnum.UlrAddIgw+"(*path)"] = ControllersEnum.UlrAddIgw;
RoutesValsEnum[ControllersEnum.UlrEditIgw+"(*path)"] = ControllersEnum.UlrEditIgw;

RoutesValsEnum[ControllersEnum.UlrIpExcludesRules+"(*path)"] = ControllersEnum.UlrIpExcludesRules;
RoutesValsEnum[ControllersEnum.UlrAsnExcludesRules+"(*path)"] = ControllersEnum.UlrAsnExcludesRules;
RoutesValsEnum[ControllersEnum.UlrVipSubscribersRules+"(*path)"] = ControllersEnum.UlrVipSubscribersRules;

RoutesValsEnum[ControllersEnum.UlrRecordPCAP+"(*path)"] = ControllersEnum.UlrRecordPCAP;
RoutesValsEnum[ControllersEnum.UlrPCAPFiles+"(*path)"] = ControllersEnum.UlrPCAPFiles;
RoutesValsEnum[ControllersEnum.UlrPCAPLogs+"(*path)"] = ControllersEnum.UlrPCAPLogs;

RoutesValsEnum[ControllersEnum.UlrSearchDatabase+"(*path)"] = ControllersEnum.UlrSearchDatabase;

RoutesValsEnum[ControllersEnum.UlrSytemGlobalState+"(*path)"] = ControllersEnum.UlrSytemGlobalState;
RoutesValsEnum[ControllersEnum.UlrIgwsNodesList+"(*path)"] = ControllersEnum.UlrIgwsNodesList;
RoutesValsEnum[ControllersEnum.UlrIgwsQoEsList+"(*path)"] = ControllersEnum.UlrIgwsQoEsList;
RoutesValsEnum[ControllersEnum.UlrIgwNodePerformance+"(*path)"] = ControllersEnum.UlrIgwNodePerformance;
RoutesValsEnum[ControllersEnum.UlrIgwNodeLogs+"(*path)"] = ControllersEnum.UlrIgwNodeLogs;
RoutesValsEnum[ControllersEnum.UlrUsersActionsLog+"(*path)"] = ControllersEnum.UlrUsersActionsLog;
RoutesValsEnum[ControllersEnum.UlrTrafficRedirectionRules+"(*path)"] = ControllersEnum.UlrTrafficRedirectionRules;

RoutesValsEnum[ControllersEnum.UlrWhiteListMode+"(*path)"] = ControllersEnum.UlrWhiteListMode;
RoutesValsEnum[ControllersEnum.UlrWhiteList+"(*path)"] = ControllersEnum.UlrWhiteList;
RoutesValsEnum[ControllersEnum.UlrAddWhiteListRule+"(*path)"] = ControllersEnum.UlrAddWhiteListRule;
RoutesValsEnum[ControllersEnum.UlrEditWhiteListRule+"(*path)"] = ControllersEnum.UlrEditWhiteListRule;

RoutesValsEnum[ControllersEnum.UrlCategoriesDic+"(*path)"] = ControllersEnum.UrlCategoriesDic;
RoutesValsEnum[ControllersEnum.UlrCustomGroupsOfProtocols+"(*path)"] = ControllersEnum.UlrCustomGroupsOfProtocols;
RoutesValsEnum[ControllersEnum.UrlRegulatorsDic+"(*path)"] = ControllersEnum.UrlRegulatorsDic;
RoutesValsEnum[ControllersEnum.UlrSessionPolicingsTemplates + "(*path)"] = ControllersEnum.UlrSessionPolicingsTemplates;
RoutesValsEnum[ControllersEnum.UlrEditSessionPolicingTemplate + "(*path)"] = ControllersEnum.UlrEditSessionPolicingTemplate;
RoutesValsEnum[ControllersEnum.UlrAddSessionPolicingTemplate + "(*path)"] = ControllersEnum.UlrAddSessionPolicingTemplate;

RoutesValsEnum[ControllersEnum.UlrRecipientGroupList+"(*path)"] = ControllersEnum.UlrRecipientGroupList;
RoutesValsEnum[ControllersEnum.UlrEditRecipientGroup+"(*path)"] = ControllersEnum.UlrEditRecipientGroup;
RoutesValsEnum[ControllersEnum.UlrAddRecipientGroup+"(*path)"] = ControllersEnum.UlrAddRecipientGroup;

RoutesValsEnum[ControllersEnum.UlrEditMailing+"(*path)"] = ControllersEnum.UlrEditMailing;
RoutesValsEnum[ControllersEnum.UlrAddMailing+"(*path)"] = ControllersEnum.UlrAddMailing;
RoutesValsEnum[ControllersEnum.UlrMailingList+"(*path)"] = ControllersEnum.UlrMailingList;
RoutesValsEnum[ControllersEnum.UlrMailingTemplatesList+"(*path)"] = ControllersEnum.UlrMailingTemplatesList;
RoutesValsEnum[ControllersEnum.UlrAddTemplateMailing+"(*path)"] = ControllersEnum.UlrAddTemplateMailing;
RoutesValsEnum[ControllersEnum.UlrEditTemplateMailing+"(*path)"] = ControllersEnum.UlrEditTemplateMailing;
RoutesValsEnum[ControllersEnum.UlrQoEAnyReport+"(*path)"] = ControllersEnum.UlrQoEAnyReport;

// RoutesValsEnum[ControllersEnum.UlrTest+"(*path)"] = ControllersEnum.UlrTest;

RoutesValsEnum[ControllersEnum.ConnectionsValidateData+"(*path)"] = ControllersEnum.ConnectionsValidateData;
RoutesValsEnum[ControllersEnum.TrafficManagementGenerator+"(*path)"] = ControllersEnum.TrafficManagementGenerator;
RoutesValsEnum[ControllersEnum.TrafficManagementCapture+"(*path)"] = ControllersEnum.TrafficManagementCapture;
RoutesValsEnum[ControllersEnum.TrafficManagementSiteClone+"(*path)"] = ControllersEnum.TrafficManagementSiteClone;
RoutesValsEnum[ControllersEnum.NetworkAudit+"(*path)"] = ControllersEnum.NetworkAudit;
RoutesValsEnum[ControllersEnum.LiHealth+"(*path)"] = ControllersEnum.LiHealth;
RoutesValsEnum[ControllersEnum.TrafficDecodeLogs+"(*path)"] = ControllersEnum.TrafficDecodeLogs;
RoutesValsEnum[ControllersEnum.TrafficDecode+"(*path)"] = ControllersEnum.TrafficDecode;
RoutesValsEnum[ControllersEnum.HardwareSshTerminal+"(*path)"] = ControllersEnum.HardwareSshTerminal;

RoutesValsEnum[ControllersEnum.ClassifierLogs+"(*path)"] = ControllersEnum.ClassifierLogs;
RoutesValsEnum[ControllersEnum.ClassifierConfig+"(*path)"] = ControllersEnum.ClassifierConfig;
RoutesValsEnum[ControllersEnum.ClassifierModel+"(*path)"] = ControllersEnum.ClassifierModel;
RoutesValsEnum[ControllersEnum.Classifier+"(*path)"] = ControllersEnum.Classifier;

RoutesValsEnum[ControllersEnum.AntiDDoSNetworks+"(*path)"] = ControllersEnum.AntiDDoSNetworks;
RoutesValsEnum[ControllersEnum.AntiDDoSThreats+"(*path)"] = ControllersEnum.AntiDDoSThreats;
RoutesValsEnum[ControllersEnum.AntiDDoSProtection+"(*path)"] = ControllersEnum.AntiDDoSProtection;

RoutesValsEnum["*notFound"] = "notFound";

var ControllersSections = {};

ControllersSections[ControllersEnum.DpiPerformance] = RoleSectionsEnum.performance;
ControllersSections[ControllersEnum.DpiConfig] = RoleSectionsEnum.config;
ControllersSections[ControllersEnum.DpiDscpConfig] = RoleSectionsEnum.config;
ControllersSections[ControllersEnum.DpiAsnDscpConfig] = RoleSectionsEnum.config;
ControllersSections[ControllersEnum.DpiLogs] = RoleSectionsEnum.performance;
// ControllersSections[ControllersEnum.Test] = RoleSectionsEnum.performance;

ControllersSections[ControllersEnum.Subscribers] = RoleSectionsEnum.subscribers;
ControllersSections[ControllersEnum.Services] = RoleSectionsEnum.services;
ControllersSections[ControllersEnum.Tariffs] = RoleSectionsEnum.tariffs;
ControllersSections[ControllersEnum.Advc] = RoleSectionsEnum.advc;
ControllersSections[ControllersEnum.HotSpot] = RoleSectionsEnum.services;
ControllersSections[ControllersEnum.QoEDashboard] = RoleSectionsEnum.qoeanalytics_dashboard;
ControllersSections[ControllersEnum.QoEClickStream] = RoleSectionsEnum.qoeanalytics_clickstream;
ControllersSections[ControllersEnum.QoEFullNetFlow] = RoleSectionsEnum.qoeanalytics_fullnetflow;
ControllersSections[ControllersEnum.QoEFullGtpFlow] = RoleSectionsEnum.qoeanalytics_gtp;
ControllersSections[ControllersEnum.QoERawFullGtpFlow] = RoleSectionsEnum.qoeanalytics_rawgtp;
ControllersSections[ControllersEnum.QoEFullNatFlow] = RoleSectionsEnum.qoeanalytics_nat;
ControllersSections[ControllersEnum.QoERawFullNatFlow] = RoleSectionsEnum.qoeanalytics_rawnat;
ControllersSections[ControllersEnum.QoERawFullDnsFlow] = RoleSectionsEnum.qoeanalytics_rawdns;
ControllersSections[ControllersEnum.QoEFullDnsFlow] = RoleSectionsEnum.qoeanalytics_dns;
ControllersSections[ControllersEnum.QoEFullDdosAttackFlow] = RoleSectionsEnum.qoeanalytics_ddos_attack;
ControllersSections[ControllersEnum.QoERawFullDdosAttackFlow] = RoleSectionsEnum.qoeanalytics_raw_ddos_attack;
ControllersSections[ControllersEnum.QoESubscribers] = RoleSectionsEnum.qoeanalytics_subscribers;
ControllersSections[ControllersEnum.QoEOnlineReports] = RoleSectionsEnum.qoeanalytics_online_reports;
ControllersSections[ControllersEnum.QoERawFullNetFlow] = RoleSectionsEnum.qoeanalytics_rawfullnetflow;
ControllersSections[ControllersEnum.QoERawClickstream] = RoleSectionsEnum.qoeanalytics_rawclickstream;
ControllersSections[ControllersEnum.QoEAdmin] = RoleSectionsEnum.qoeanalytics_admin;
ControllersSections[ControllersEnum.QoETriggers] = RoleSectionsEnum.qoeanalytics_triggers;
ControllersSections[ControllersEnum.QoEAnyReport] = RoleSectionsEnum.qoeanalytics;
ControllersSections[ControllersEnum.QoECustomReports] = RoleSectionsEnum.qoeanalytics_customreports;
ControllersSections[ControllersEnum.QoEUserReports] = RoleSectionsEnum.qoeanalytics_reports_manager;
ControllersSections[ControllersEnum.QoEMailingTemplates] = RoleSectionsEnum.qoeanalytics_mailing_templates;

ControllersSections[ControllersEnum.VasCloud] = RoleSectionsEnum.vascloud;
ControllersSections[ControllersEnum.VasCloudLogin] = RoleSectionsEnum.vascloud;
ControllersSections[ControllersEnum.VasCloudShop] = RoleSectionsEnum.vascloud;
ControllersSections[ControllersEnum.VasCloudPersonalArea] = RoleSectionsEnum.vascloud;
ControllersSections[ControllersEnum.VasCloudAds] = RoleSectionsEnum.depricated;
ControllersSections[ControllersEnum.VasCloudAdsStatistics] = RoleSectionsEnum.depricated;
ControllersSections[ControllersEnum.VasCloudAccrualsAndPayments] = RoleSectionsEnum.depricated;
ControllersSections[ControllersEnum.VasCloudProtocolsCustom] = RoleSectionsEnum.vascloud;
ControllersSections[ControllersEnum.VasCloudCustomProtocolsGroups] = RoleSectionsEnum.vascloud;
ControllersSections[ControllersEnum.VasCloudProtocolsLogs] = RoleSectionsEnum.vascloud;

ControllersSections[ControllersEnum.Hardwares] = RoleSectionsEnum.hardware;
ControllersSections[ControllersEnum.Health] = RoleSectionsEnum.hardware;

ControllersSections[ControllersEnum.HardwareSshKeys] = RoleSectionsEnum.hardware_ssh_keys;

ControllersSections[ControllersEnum.Users] = RoleSectionsEnum.administrator_users;
ControllersSections[ControllersEnum.Roles] = RoleSectionsEnum.administrator_roles;
ControllersSections[ControllersEnum.UsersActionsLog] = RoleSectionsEnum.administrator_users_actions_log;

ControllersSections[ControllersEnum.Dpiui2Config] = RoleSectionsEnum.administrator_dpiui2;
ControllersSections[ControllersEnum.Dpiui2Logs] = RoleSectionsEnum.administrator_dpiui2;
ControllersSections[ControllersEnum.Dpiui2Update] = RoleSectionsEnum.administrator_dpiui2;

ControllersSections[ControllersEnum.QoEStorConfig] = RoleSectionsEnum.administrator_dpiui2;
ControllersSections[ControllersEnum.QoEStorLogs] = RoleSectionsEnum.administrator_dpiui2;
ControllersSections[ControllersEnum.BalancerConfig] = RoleSectionsEnum.administrator_dpiui2;
ControllersSections[ControllersEnum.BalancerLogs] = RoleSectionsEnum.administrator_dpiui2;

ControllersSections[ControllersEnum.FastPcrfConfig] = RoleSectionsEnum.pcrf_config;
ControllersSections[ControllersEnum.FastPcrfLogs] = RoleSectionsEnum.pcrf_logs;
ControllersSections[ControllersEnum.CaptchaConfig] = RoleSectionsEnum.depricated;
ControllersSections[ControllersEnum.CaptchaTemplates] = RoleSectionsEnum.depricated;
ControllersSections[ControllersEnum.CaptchaLogs] = RoleSectionsEnum.depricated;

ControllersSections[ControllersEnum.UlrWebIpFilterRules] = RoleSectionsEnum.ulr_web_rules;
ControllersSections[ControllersEnum.UlrAddWebIpFilterRule] = RoleSectionsEnum.ulr_web_rules;
ControllersSections[ControllersEnum.UlrEditWebIpFilterRule] = RoleSectionsEnum.ulr_web_rules;
ControllersSections[ControllersEnum.UlrCheckDomain] = RoleSectionsEnum.ulr_web_rules;
ControllersSections[ControllersEnum.UlrExcludedResources] = RoleSectionsEnum.ulr_web_rules;
ControllersSections[ControllersEnum.UlrWebSearchDatabase] = RoleSectionsEnum.ulr_web_rules;

ControllersSections[ControllersEnum.UlrHostCategories] = RoleSectionsEnum.ulr_hosts_list;

ControllersSections[ControllersEnum.UlrWebRulesStatistics] = RoleSectionsEnum.ulr_web_rules;

ControllersSections[ControllersEnum.UlrSpoofDnsRules] = RoleSectionsEnum.ulr_spoof_dns;
ControllersSections[ControllersEnum.UlrAddSpoofDnsRule] = RoleSectionsEnum.ulr_spoof_dns;
ControllersSections[ControllersEnum.UlrEditSpoofDnsRule] = RoleSectionsEnum.ulr_spoof_dns;


ControllersSections[ControllersEnum.UlrAppPolicings] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrEditAppPolicing] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrIgwPolicings] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrEditIgwPolicing] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrSubscribersPolicings] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrEditSubscriberPolicing] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrAppDscpRules] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrAppProtocols] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrIspSessionPolicings] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrEditIspSessionPolicing] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrSubscribersSessionPolicings] = RoleSectionsEnum.ulr_policings;
ControllersSections[ControllersEnum.UlrEditSubscriberSessionPolicing] = RoleSectionsEnum.ulr_policings;

ControllersSections[ControllersEnum.UlrAppCustomProtocols] = RoleSectionsEnum.ulr_custom_prtcls;
ControllersSections[ControllersEnum.UlrAppGroupsCustomProtocols] = RoleSectionsEnum.ulr_custom_prtcls;
ControllersSections[ControllersEnum.UlrCheckResourcesIntersection] = RoleSectionsEnum.ulr_custom_prtcls;
ControllersSections[ControllersEnum.UlrAppPrtclsCustomLogs] = RoleSectionsEnum.ulr_custom_prtcls;
ControllersSections[ControllersEnum.UlrFastresourceCustomPrtcls] = RoleSectionsEnum.ulr_custom_prtcls;

ControllersSections[ControllersEnum.UlrAsnDscpRules] = RoleSectionsEnum.ulr_as_rules;
ControllersSections[ControllersEnum.UlrAddAsnDscpRule] = RoleSectionsEnum.ulr_as_rules;
ControllersSections[ControllersEnum.UlrEditAsnDscpRule] = RoleSectionsEnum.ulr_as_rules;
ControllersSections[ControllersEnum.UlrAsnRuleList] = RoleSectionsEnum.ulr_as_rules;

ControllersSections[ControllersEnum.UlrIgwsList] = RoleSectionsEnum.ulr_isp_igw_profiles;
ControllersSections[ControllersEnum.UlrSubsList] = RoleSectionsEnum.ulr_isp_igw_profiles;
ControllersSections[ControllersEnum.UlrEditSubs] = RoleSectionsEnum.ulr_isp_igw_profiles;
ControllersSections[ControllersEnum.UlrAddSubs] = RoleSectionsEnum.ulr_isp_igw_profiles;
ControllersSections[ControllersEnum.UlrIspsList] = RoleSectionsEnum.ulr_isp_igw_profiles;
ControllersSections[ControllersEnum.UlrAddIsp] = RoleSectionsEnum.ulr_isp_igw_profiles;
ControllersSections[ControllersEnum.UlrEditIsp] = RoleSectionsEnum.ulr_isp_igw_profiles;
ControllersSections[ControllersEnum.UlrAddIgw] = RoleSectionsEnum.ulr_isp_igw_profiles;
ControllersSections[ControllersEnum.UlrEditIgw] = RoleSectionsEnum.ulr_isp_igw_profiles;

ControllersSections[ControllersEnum.UlrIpExcludesRules] = RoleSectionsEnum.ulr_excludes;
ControllersSections[ControllersEnum.UlrAsnExcludesRules] = RoleSectionsEnum.ulr_excludes;
ControllersSections[ControllersEnum.UlrVipSubscribersRules] = RoleSectionsEnum.ulr_excludes;

ControllersSections[ControllersEnum.UlrRecordPCAP] = RoleSectionsEnum.ulr_record_pcap;
ControllersSections[ControllersEnum.UlrPCAPFiles] = RoleSectionsEnum.ulr_record_pcap;
ControllersSections[ControllersEnum.UlrPCAPLogs] = RoleSectionsEnum.ulr_record_pcap;

ControllersSections[ControllersEnum.UlrSearchDatabase] = RoleSectionsEnum.ulr_db_search;

ControllersSections[ControllersEnum.UlrSytemGlobalState] = RoleSectionsEnum.ulr_system_state;
ControllersSections[ControllersEnum.UlrIgwsNodesList] = RoleSectionsEnum.ulr_system_state;
ControllersSections[ControllersEnum.UlrIgwsQoEsList] = RoleSectionsEnum.ulr_system_state;
ControllersSections[ControllersEnum.UlrIgwNodePerformance] = RoleSectionsEnum.ulr_system_state;
ControllersSections[ControllersEnum.UlrIgwNodeLogs] = RoleSectionsEnum.ulr_system_state;
ControllersSections[ControllersEnum.UlrUsersActionsLog] = RoleSectionsEnum.ulr_system_state;
ControllersSections[ControllersEnum.UlrTrafficRedirectionRules] = RoleSectionsEnum.ulr_system_state;

ControllersSections[ControllersEnum.UlrWhiteList] = RoleSectionsEnum.ulr_white_rules;
ControllersSections[ControllersEnum.UlrAddWhiteListRule] = RoleSectionsEnum.ulr_white_rules;
ControllersSections[ControllersEnum.UlrEditWhiteListRule] = RoleSectionsEnum.ulr_white_rules;
ControllersSections[ControllersEnum.UlrWhiteListMode] = RoleSectionsEnum.ulr_white_rules;

ControllersSections[ControllersEnum.UrlCategoriesDic] = RoleSectionsEnum.ulr_dics;
ControllersSections[ControllersEnum.UlrCustomGroupsOfProtocols] = RoleSectionsEnum.ulr_dics;
ControllersSections[ControllersEnum.UrlRegulatorsDic] = RoleSectionsEnum.ulr_dics;
ControllersSections[ControllersEnum.UlrSessionPolicingsTemplates] = RoleSectionsEnum.ulr_dics;
ControllersSections[ControllersEnum.UlrEditSessionPolicingTemplate] = RoleSectionsEnum.ulr_dics;
ControllersSections[ControllersEnum.UlrAddSessionPolicingTemplate] = RoleSectionsEnum.ulr_dics;

ControllersSections[ControllersEnum.UlrRecipientGroupList] = RoleSectionsEnum.ulr_mailing;
ControllersSections[ControllersEnum.UlrEditRecipientGroup] = RoleSectionsEnum.ulr_mailing;
ControllersSections[ControllersEnum.UlrAddRecipientGroup] = RoleSectionsEnum.ulr_mailing;

ControllersSections[ControllersEnum.UlrEditMailing] = RoleSectionsEnum.ulr_mailing;
ControllersSections[ControllersEnum.UlrAddMailing] = RoleSectionsEnum.ulr_mailing;
ControllersSections[ControllersEnum.UlrMailingList] = RoleSectionsEnum.ulr_mailing;
ControllersSections[ControllersEnum.UlrMailingTemplatesList] = RoleSectionsEnum.ulr_mailing;
ControllersSections[ControllersEnum.UlrAddTemplateMailing] = RoleSectionsEnum.ulr_mailing;
ControllersSections[ControllersEnum.UlrEditTemplateMailing] = RoleSectionsEnum.ulr_mailing;

ControllersSections[ControllersEnum.UlrQoEAnyReport] = RoleSectionsEnum.ulr_mailing;

ControllersSections[ControllersEnum.UlrTest] = RoleSectionsEnum.ulr;

ControllersSections[ControllersEnum.ConnectionsValidateData] = RoleSectionsEnum.li_connections;
ControllersSections[ControllersEnum.TrafficManagementGenerator] = RoleSectionsEnum.li_t_generation;
ControllersSections[ControllersEnum.TrafficManagementCapture] = RoleSectionsEnum.li_t_capture;
ControllersSections[ControllersEnum.TrafficManagementSiteClone] = RoleSectionsEnum.li_site_clone;
ControllersSections[ControllersEnum.NetworkAudit] = RoleSectionsEnum.li_n_audit;
ControllersSections[ControllersEnum.LiHealth] = RoleSectionsEnum.li_health;
ControllersSections[ControllersEnum.TrafficDecodeLogs] = RoleSectionsEnum.li_traffic_decode;
ControllersSections[ControllersEnum.TrafficDecode] = RoleSectionsEnum.li_traffic_decode;

ControllersSections[ControllersEnum.Classifier] = RoleSectionsEnum.sites_clsfr;
ControllersSections[ControllersEnum.ClassifierModel] = RoleSectionsEnum.sites_clsfr_model;
ControllersSections[ControllersEnum.ClassifierConfig] = RoleSectionsEnum.sites_clsfr_admin;
ControllersSections[ControllersEnum.ClassifierLogs] = RoleSectionsEnum.sites_clsfr_admin;

ControllersSections[ControllersEnum.HardwareSshTerminal] = RoleSectionsEnum.ssh_terminal;

ControllersSections[ControllersEnum.AntiDDoSNetworks] = RoleSectionsEnum.antiddos;
ControllersSections[ControllersEnum.AntiDDoSThreats] = RoleSectionsEnum.antiddos;
ControllersSections[ControllersEnum.AntiDDoSProtection] = RoleSectionsEnum.antiddos;

var ControllersModulesRequirements = {};
//ControllersModulesRequirements[".Gtp."] = [RequireModuleEnum.ol];

var SectionsToLogNavigate = [
    ControllersEnum.QoEDashboard,
    ControllersEnum.QoEFullNetFlow,
    ControllersEnum.QoERawFullNetFlow,
    ControllersEnum.QoEClickStream,
    ControllersEnum.QoERawClickstream,
    ControllersEnum.QoEFullGtpFlow,
    ControllersEnum.QoERawFullGtpFlow,
    ControllersEnum.QoEFullNatFlow,
    ControllersEnum.QoERawFullNatFlow,
    ControllersEnum.QoEFullDnsFlow,
    ControllersEnum.QoERawFullDnsFlow,
    ControllersEnum.QoEFullDdosAttackFlow,
    ControllersEnum.QoERawFullDdosAttackFlow,
    ControllersEnum.QoESubscribers,
    ControllersEnum.QoEOnlineReports,
    ControllersEnum.QoETriggers,
    ControllersEnum.QoEAdmin,
    ControllersEnum.QoECustomReports,
    ControllersEnum.QoEUserReports,
    ControllersEnum.QoEMailingTemplates,
];

function UiRouter(Params)
{
    "use strict";
    var _this = this;

    this.BodyLayoutId = "BodyLayout";

    this.views = {};

    this.currentViewId = null;

    this.router = new (Backbone.Router.extend({
        routes:RoutesValsEnum,
        index:function()
        {
            _this.CheckAuthAndPresentView();
        },
        login:function ()
        {
            _this.ShowLoginView();
        },
        notFound:function ()
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.NoFound});
        },
        DpiPerformance:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.DpiPerformance, topMenuId:ControllersEnum.DpiPerformance, path:Path});
        },
        DpiConfig:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.DpiConfig, topMenuId:ControllersEnum.DpiPerformance, path:Path});
        },
        DpiDscpConfig:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.DpiDscpConfig, topMenuId:ControllersEnum.DpiPerformance, path:Path});
        },
        DpiAsnDscpConfig:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.DpiAsnDscpConfig, topMenuId:ControllersEnum.DpiPerformance, path:Path});
        },
        DpiLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.DpiLogs, topMenuId:ControllersEnum.DpiPerformance, path:Path});
        },
        Hardwares:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Hardwares, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        HardwareSshKeys:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.HardwareSshKeys, topMenuId:ControllersEnum.HardwareSshKeys, path:Path});
        },
        Subscribers:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Subscribers, topMenuId:ControllersEnum.Subscribers, path:Path});
        },
        Services:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Services, topMenuId:ControllersEnum.Subscribers, path:Path});
        },
        Tariffs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Tariffs, topMenuId:ControllersEnum.Subscribers, path:Path});
        },
        Advc:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Advc, topMenuId:ControllersEnum.Subscribers, path:Path});
        },
        HotSpot:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.HotSpot, topMenuId:ControllersEnum.Subscribers, path:Path});
        },
        QoEDashboard:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEDashboard, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEClickStream:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEClickStream, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEFullNetFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEFullNetFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEFullGtpFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEFullGtpFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoERawFullGtpFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoERawFullGtpFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEFullNatFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEFullNatFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoERawFullNatFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoERawFullNatFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoERawFullDnsFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoERawFullDnsFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEFullDnsFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEFullDnsFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEFullDdosAttackFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEFullDdosAttackFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoERawFullDdosAttackFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoERawFullDdosAttackFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoESubscribers:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoESubscribers, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEOnlineReports:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEOnlineReports, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoERawFullNetFlow:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoERawFullNetFlow, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoERawClickstream:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoERawClickstream, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoELogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoELogs, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEAdmin:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEAdmin, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoETriggers:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoETriggers, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEAnyReport:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEAnyReport, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoECustomReports:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoECustomReports, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEUserReports:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEUserReports, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        QoEMailingTemplates:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEMailingTemplates, topMenuId:ControllersEnum.QoEDashboard, path:Path});
        },
        Users:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Users, topMenuId:ControllersEnum.Users, path:Path});
        },
        Roles:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Roles, topMenuId:ControllersEnum.Roles, path:Path});
        },
        UsersActionsLog:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UsersActionsLog, topMenuId:ControllersEnum.UsersActionsLog, path:Path});
        },
        Health:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Health, topMenuId:ControllersEnum.Health, path:Path});
        },
        VasCloud:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloud, topMenuId:ControllersEnum.VasCloud, path:Path});
        },
        VasCloudLogin:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloudLogin, topMenuId:ControllersEnum.VasCloudPersonalArea, path:Path});
        },
        VasCloudShop:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloudShop, topMenuId:ControllersEnum.VasCloudPersonalArea, path:Path});
        },
        VasCloudPersonalArea:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloudPersonalArea, topMenuId:ControllersEnum.VasCloudPersonalArea, path:Path});
        },
        VasCloudAds:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloudAds, topMenuId:ControllersEnum.VasCloudPersonalArea, path:Path});
        },
        VasCloudAdsStatistics:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloudAdsStatistics, topMenuId:ControllersEnum.VasCloudPersonalArea, path:Path});
        },
        VasCloudAccrualsAndPayments:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloudAccrualsAndPayments, topMenuId:ControllersEnum.VasCloudPersonalArea, path:Path});
        },
        VasCloudProtocolsCustom:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloudProtocolsCustom, topMenuId:ControllersEnum.VasCloudProtocolsCustom, path:Path});
        },
        VasCloudCustomProtocolsGroups:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloudCustomProtocolsGroups, topMenuId:ControllersEnum.VasCloudCustomProtocolsGroups, path:Path});
        },
        VasCloudProtocolsLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.VasCloudProtocolsLogs, topMenuId:ControllersEnum.VasCloudProtocolsLogs, path:Path});
        },
        Dpiui2Config:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Dpiui2Config, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        Dpiui2Logs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Dpiui2Logs, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        Dpiui2Update:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Dpiui2Update, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        QoEStorConfig:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEStorConfig, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        QoEStorLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.QoEStorLogs, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        BalancerConfig:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.BalancerConfig, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        BalancerLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.BalancerLogs, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        FastPcrfConfig:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.FastPcrfConfig, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        FastPcrfLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.FastPcrfLogs, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        CaptchaConfig:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.CaptchaConfig, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        CaptchaTemplates:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.CaptchaTemplates, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        CaptchaLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.CaptchaLogs, topMenuId:ControllersEnum.Hardwares, path:Path});
        },
        UlrWebIpFilterRules:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrWebIpFilterRules, topMenuId:ControllersEnum.UlrWebIpFilterRules, path:Path});
        },
        UlrAddWebIpFilterRule:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddWebIpFilterRule, topMenuId:ControllersEnum.UlrWebIpFilterRules, path:Path});
        },
        UlrEditWebIpFilterRule:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditWebIpFilterRule, topMenuId:ControllersEnum.UlrWebIpFilterRules, path:Path});
        },
        UlrCheckDomain:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrCheckDomain, topMenuId:ControllersEnum.UlrWebIpFilterRules, path:Path});
        },
        UlrExcludedResources:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrExcludedResources, topMenuId:ControllersEnum.UlrWebIpFilterRules, path:Path});
        },
        UlrWebSearchDatabase:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrWebSearchDatabase, topMenuId:ControllersEnum.UlrWebIpFilterRules, path:Path});
        },

        UlrHostCategories:function (Path) {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrHostCategories, topMenuId:ControllersEnum.UlrWebIpFilterRules, path:Path});
        },
        UlrWebRulesStatistics:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrWebRulesStatistics, topMenuId:ControllersEnum.UlrWebIpFilterRules, path:Path});
        },
        UlrSpoofDnsRules:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrSpoofDnsRules, topMenuId:ControllersEnum.UlrSpoofDnsRules, path:Path});
        },
        UlrAddSpoofDnsRule:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddSpoofDnsRule, topMenuId:ControllersEnum.UlrSpoofDnsRules, path:Path});
        },
        UlrEditSpoofDnsRule:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditSpoofDnsRule, topMenuId:ControllersEnum.UlrSpoofDnsRules, path:Path});
        },
        UlrAppPolicings:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAppPolicings, topMenuId:ControllersEnum.UlrAppPolicings, path:Path});
        },
        UlrEditAppPolicing:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditAppPolicing, topMenuId:ControllersEnum.UlrEditAppPolicing, path:Path});
        },
        UlrIgwPolicings:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrIgwPolicings, topMenuId:ControllersEnum.UlrIgwPolicings, path:Path});
        },
        UlrEditIgwPolicing:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditIgwPolicing, topMenuId:ControllersEnum.UlrEditIgwPolicing, path:Path});
        },
        UlrSubscribersPolicings:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrSubscribersPolicings, topMenuId:ControllersEnum.UlrSubscribersPolicings, path:Path});
        },
        UlrEditSubscriberPolicing:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditSubscriberPolicing, topMenuId:ControllersEnum.UlrEditSubscriberPolicing, path:Path});
        },
        UlrIspSessionPolicings:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrIspSessionPolicings, topMenuId:ControllersEnum.UlrIspSessionPolicings, path:Path});
        },
        UlrEditIspSessionPolicing:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditIspSessionPolicing, topMenuId:ControllersEnum.UlrEditIspSessionPolicing, path:Path});
        },
        UlrSubscribersSessionPolicings:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrSubscribersSessionPolicings, topMenuId:ControllersEnum.UlrSubscribersSessionPolicings, path:Path});
        },
        UlrEditSubscriberSessionPolicing:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditSubscriberSessionPolicing, topMenuId:ControllersEnum.UlrEditSubscriberSessionPolicing, path:Path});
        },
        UlrAppDscpRules:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAppDscpRules, topMenuId:ControllersEnum.UlrAppPolicings, path:Path});
        },
        UlrAppProtocols:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAppProtocols, topMenuId:ControllersEnum.UlrAppPolicings, path:Path});
        },
        UlrAppCustomProtocols:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAppCustomProtocols, topMenuId:ControllersEnum.UlrAppCustomProtocols, path:Path});
        },
        UlrAppGroupsCustomProtocols:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAppGroupsCustomProtocols, topMenuId:ControllersEnum.UlrAppGroupsCustomProtocols, path:Path});
        },
        UlrCheckResourcesIntersection:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrCheckResourcesIntersection, topMenuId:ControllersEnum.UlrCheckResourcesIntersection, path:Path});
        },
        UlrAppPrtclsCustomLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAppPrtclsCustomLogs, topMenuId:ControllersEnum.UlrAppPrtclsCustomLogs, path:Path});
        },
        UlrFastresourceCustomPrtcls: function(Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrFastresourceCustomPrtcls, topMenuId:ControllersEnum.UlrFastresourceCustomPrtcls, path:Path});
        },
        UlrAsnDscpRules:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAsnDscpRules, topMenuId:ControllersEnum.UlrAsnDscpRules, path:Path});
        },
        UlrAddAsnDscpRule:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddAsnDscpRule, topMenuId:ControllersEnum.UlrAsnDscpRules, path:Path});
        },
        UlrEditAsnDscpRule:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditAsnDscpRule, topMenuId:ControllersEnum.UlrAsnDscpRules, path:Path});
        },
        UlrAsnRuleList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAsnRuleList, topMenuId:ControllersEnum.UlrAsnRuleList, path:Path});
        },
        UlrIgwsList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrIgwsList, topMenuId:ControllersEnum.UlrIspsList, path:Path});
        },
        UlrSubsList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrSubsList, topMenuId:ControllersEnum.UlrIspsList, path:Path});
        },
        UlrEditSubs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditSubs, topMenuId:ControllersEnum.UlrEditSubs, path:Path});
        },
        UlrAddSubs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddSubs, topMenuId:ControllersEnum.UlrAddSubs, path:Path});
        },
        UlrIspsList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrIspsList, topMenuId:ControllersEnum.UlrIspsList, path:Path});
        },
        UlrAddIsp:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddIsp, topMenuId:ControllersEnum.UlrAddIsp, path:Path});
        },
        UlrEditIsp:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditIsp, topMenuId:ControllersEnum.UlrEditIsp, path:Path});
        },
        UlrAddIgw:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddIgw, topMenuId:ControllersEnum.UlrAddIgw, path:Path});
        },
        UlrEditIgw:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditIgw, topMenuId:ControllersEnum.UlrEditIgw, path:Path});
        },
        UlrIpExcludesRules:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrIpExcludesRules, topMenuId:ControllersEnum.UlrIpExcludesRules, path:Path});
        },
        UlrVipSubscribersRules:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrVipSubscribersRules, topMenuId:ControllersEnum.UlrIpExcludesRules, path:Path});
        },
        UlrAsnExcludesRules:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAsnExcludesRules, topMenuId:ControllersEnum.UlrAsnExcludesRules, path:Path});
        },
        UlrRecordPCAP:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrRecordPCAP, topMenuId:ControllersEnum.UlrRecordPCAP, path:Path});
        },
        UlrPCAPFiles:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrPCAPFiles, topMenuId:ControllersEnum.UlrPCAPFiles, path:Path});
        },
        UlrPCAPLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrPCAPLogs, topMenuId:ControllersEnum.UlrPCAPLogs, path:Path});
        },
        UlrSearchDatabase:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrSearchDatabase, topMenuId:ControllersEnum.UlrSearchDatabase, path:Path});
        },
        UlrSytemGlobalState:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrSytemGlobalState, topMenuId:ControllersEnum.UlrSytemGlobalState, path:Path});
        },
        UlrIgwsNodesList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrIgwsNodesList, topMenuId:ControllersEnum.UlrSytemGlobalState, path:Path});
        },
        UlrIgwsQoEsList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrIgwsQoEsList, topMenuId:ControllersEnum.UlrSytemGlobalState, path:Path});
        },
        UlrIgwNodePerformance:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrIgwNodePerformance, topMenuId:ControllersEnum.UlrSytemGlobalState, path:Path});
        },
        UlrIgwNodeLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrIgwNodeLogs, topMenuId:ControllersEnum.UlrSytemGlobalState, path:Path});
        },
        UlrUsersActionsLog:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrUsersActionsLog, topMenuId:ControllersEnum.UlrSytemGlobalState, path:Path});
        },
        UlrTrafficRedirectionRules:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrTrafficRedirectionRules, topMenuId:ControllersEnum.UlrSytemGlobalState, path:Path});
        },
        UlrWhiteList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrWhiteList, topMenuId:ControllersEnum.UlrWhiteList, path:Path});
        },
        UlrAddWhiteListRule:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddWhiteListRule, topMenuId:ControllersEnum.UlrAddWhiteListRule, path:Path});
        },
        UlrEditWhiteListRule:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditWhiteListRule, topMenuId:ControllersEnum.UlrEditWhiteListRule, path:Path});
        },
        UlrWhiteListMode:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrWhiteListMode, topMenuId:ControllersEnum.UlrWhiteListMode, path:Path});
        },
        UlrTest:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrTest, topMenuId:ControllersEnum.UlrWebIpFilterRules, path:Path});
        },
        UrlCategoriesDic:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UrlCategoriesDic, topMenuId:ControllersEnum.UrlCategoriesDic, path:Path});
        },
        UlrSessionPolicingsTemplates: function(Path)
        {
            _this.CheckAuthAndPresentView({id: ControllersEnum.UlrSessionPolicingsTemplates, topMenuId: ControllersEnum.UlrSessionPolicingsTemplates, path: Path});
        },
        UlrEditSessionPolicingTemplate: function(Path)
        {
            _this.CheckAuthAndPresentView({id: ControllersEnum.UlrEditSessionPolicingTemplate, topMenuId: ControllersEnum.UlrEditSessionPolicingTemplate, path: Path});
        },
        UlrAddSessionPolicingTemplate: function(Path)
        {
            _this.CheckAuthAndPresentView({id: ControllersEnum.UlrAddSessionPolicingTemplate, topMenuId: ControllersEnum.UlrAddSessionPolicingTemplate, path: Path});
        },
        UlrCustomGroupsOfProtocols:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrCustomGroupsOfProtocols, topMenuId:ControllersEnum.UlrCustomGroupsOfProtocols, path:Path});
        },
        UlrMailingList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrMailingList, topMenuId:ControllersEnum.UlrMailingList, path:Path});
        },
        UlrRecipientGroupList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrRecipientGroupList, topMenuId:ControllersEnum.UlrRecipientGroupList, path:Path});
        },
        UlrEditRecipientGroup:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditRecipientGroup, topMenuId:ControllersEnum.UlrEditRecipientGroup, path:Path});
        },
        UlrAddRecipientGroup:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddRecipientGroup, topMenuId:ControllersEnum.UlrAddRecipientGroup, path:Path});
        },
        UlrEditMailing:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditMailing, topMenuId:ControllersEnum.UlrEditMailing, path:Path});
        },
        UlrAddMailing:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddMailing, topMenuId:ControllersEnum.UlrAddMailing, path:Path});
        },
        UlrMailingTemplatesList:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrMailingTemplatesList, topMenuId:ControllersEnum.UlrMailingTemplatesList, path:Path});
        },
        UlrEditTemplateMailing:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrEditTemplateMailing, topMenuId:ControllersEnum.UlrEditTemplateMailing, path:Path});
        },
        UlrAddTemplateMailing:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrAddTemplateMailing, topMenuId:ControllersEnum.UlrAddTemplateMailing, path:Path});
        },
        UlrQoEAnyReport:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UlrQoEAnyReport, topMenuId:ControllersEnum.UlrEditMailing, path:Path});
        },
        UrlRegulatorsDic:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.UrlRegulatorsDic, topMenuId:ControllersEnum.UrlRegulatorsDic, path:Path});
        },
        ConnectionsValidateData:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.ConnectionsValidateData, topMenuId:ControllersEnum.ConnectionsValidateData, path:Path});
        },
        TrafficManagementGenerator:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.TrafficManagementGenerator, topMenuId:ControllersEnum.TrafficManagementGenerator, path:Path});
        },
        TrafficManagementCapture:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.TrafficManagementCapture, topMenuId:ControllersEnum.TrafficManagementCapture, path:Path});
        },
        TrafficManagementSiteClone:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.TrafficManagementSiteClone, topMenuId:ControllersEnum.TrafficManagementSiteClone, path:Path});
        },
        NetworkAudit:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.NetworkAudit, topMenuId:ControllersEnum.NetworkAudit, path:Path});
        },
        LiHealth:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.LiHealth, topMenuId:ControllersEnum.LiHealth, path:Path});
        },
        TrafficDecodeLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.TrafficDecodeLogs, topMenuId:ControllersEnum.TrafficDecode, path:Path});
        },
        TrafficDecode:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.TrafficDecode, topMenuId:ControllersEnum.TrafficDecode, path:Path});
        },
        // Test: function(Path) {
        //     // _this.CheckAuthAndPresentView({id:ControllersEnum.Test});
        //     _this.CheckAuthAndPresentView({
        //         id: ControllersEnum.Test,
        //         topMenuId: ControllersEnum.DpiPerformance,
        //         path: Path
        //     });
        // },
        HardwareSshTerminal:function (Path) {
            _this.CheckAuthAndPresentView({
                id: ControllersEnum.HardwareSshTerminal,
                topMenuId: ControllersEnum.HardwareSshTerminal,
                path: Path
            });
        },
        Classifier:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.Classifier, topMenuId:ControllersEnum.Classifier, path:Path});
        },
        ClassifierModel:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.ClassifierModel, topMenuId:ControllersEnum.ClassifierModel, path:Path});
        },
        ClassifierConfig:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.ClassifierConfig, topMenuId:ControllersEnum.ClassifierConfig, path:Path});
        },
        ClassifierLogs:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.ClassifierLogs, topMenuId:ControllersEnum.ClassifierLogs, path:Path});
        },

        AntiDDoSNetworks:function (Path)
        {
            _this.CheckAuthAndPresentView({id:ControllersEnum.AntiDDoSNetworks, topMenuId:ControllersEnum.AntiDDoSNetworks, path:Path});
        },
        AntiDDoSThreats:function (Path)
        {
            debugger
            _this.CheckAuthAndPresentView({id:ControllersEnum.AntiDDoSThreats, topMenuId:ControllersEnum.AntiDDoSNetworks, path:Path});
        },
        AntiDDoSProtection:function (Path)
        {
            debugger
            _this.CheckAuthAndPresentView({id:ControllersEnum.AntiDDoSProtection, topMenuId:ControllersEnum.AntiDDoSNetworks, path:Path});
        },
    }))();

    this.History = false;

    this.Init(Params);
}

UiRouter.prototype.Init = function(Params)
{
    "use strict";
};

UiRouter.prototype.Start = function(Params)
{
    "use strict";
    Backbone.history.start();
};

UiRouter.prototype.ShowMainView = function(Params)
{
    "use strict";
    this.DestroyAllViews();

    this.views.AppView = new AppViewController({BodyLayoutId:this.BodyLayoutId});

    webix.extend($$(this.BodyLayoutId), webix.ProgressBar);

    this.views.AppView.ViewDidLoad();
};

UiRouter.prototype.ShowLoginView = function(Params)
{
    "use strict";
    this.DestroyAllViews();

    this.views.LoginView = new LoginViewController();
    this.views.LoginView.ViewDidLoad();
};

UiRouter.prototype.PresentView = function(Params)
{
    if(!Params || !Params.id)
        return;

    if(this.CurrentPresentingViewId)
    {
        this.NextViewToPresentParams = Params;
        return;
    }

    this.CurrentPresentingViewId = Params.id;
    this._PresentView(Params);

    this.MakeUiNavigationUsersActionsLog(Params);
};

UiRouter.prototype._PresentView = function(Params)
{
    var _this = this;

    var loadControllerRequirements = function (Id,Callback)
    {
        var modules = {};

        Object.keys(ControllersModulesRequirements)
            .filter(function (Key)
            {
                return (new RegExp(Key)).test(Id)
            })
            .forEach(function (Key)
            {
                ControllersModulesRequirements[Key].forEach(function (Item)
                {
                    modules[Item] = 1;
                });
            });

        RequireHelper.RequireModule(Object.keys(modules), Callback);
    };

    var setupController = function (Id, Callback)
    {
        var r = false;

        if(_this.currentViewId&&_this.views[_this.currentViewId])
        {
            if(_this.views[_this.currentViewId].Destroy)
            {
                _this.views[_this.currentViewId].Destroy();
            }

            if($$(_this.currentViewId))
            {
                $$(_this.currentViewId).destructor();
            }

            delete _this.views[_this.currentViewId];
        }

        var controllerFn = window[Id+"ViewController"];

        if(typeof controllerFn === 'function')
        {
            _this.views[Id] = new controllerFn(Params);
            $$(_this.BodyLayoutId).define("rows", webix.copy(_this.views[Id].ViewConfig?_this.views[Id].ViewConfig:_this.views[Id].view));
            $$(_this.BodyLayoutId).reconstruct();
            _this.currentViewId = Id;

            setTimeout(function () {
                _this.views[Id].ViewDidLoad(_this.PathToParams(Params.path));

                _this.CurrentPresentingViewId = null;

                if(_this.NextViewToPresentParams)
                {
                    var next = webix.copy(_this.NextViewToPresentParams);
                    _this.NextViewToPresentParams = null;

                    _this.PresentView(next);
                }
            },1);

            r = true;
        }

        if(Callback)
        {
            Callback(r);
        }

        return r;
    };

    var afterSetupController = function ()
    {
        //_this.views.AppView.SelectAppMenuItem((Params.topMenuId ? Params.topMenuId : Params.id) + "_");
        _this.views.AppView.SelectAppMenuSidebarItem((Params.id ? Params.id : Params.topMenuId) + "_");
        _this.views.AppView.SelectAppSideBarItem(Params.id);

        if(_this.views[_this.currentViewId] && _this.views[_this.currentViewId].GetPageTitle)
        {
            var pageTitle = _this.views[_this.currentViewId].GetPageTitle();

            if(pageTitle)
                _this.views.AppView.SetPageHeaderTitle(pageTitle.RootTitle, pageTitle.Title);
            else
                _this.views.AppView.SetPageHeaderTitle('', '');
        }
        else if(_this.currentViewId.indexOf("Ulr") == 0)
            _this.views.AppView.SetPageHeaderTitle('', '');

        var navigate = ControllersEnum[Params.id] ? ControllersEnum[Params.id] : "index";
        navigate += Params.path ? Params.path : "";

        _this.JustNavigate(navigate);
    };

    var setupAll = function ()
    {
        var section = ControllersSections[Params.id];

        if(Params.id != ControllersEnum.NoFound && !App.SessionManager.CheckUserRoleSection(section))
        {
            setupController("Forbiten");
            afterSetupController();
            return;
        }

        loadControllerRequirements(Params.id, function ()
        {
            setupController(Params.id, function (R)
            {
                if(!R)
                    setupController("NoFound");

                afterSetupController();

            });
        });
    };

    this.RequireViewController(Params.id+"ViewController", function ()
    {
        setTimeout(function () {
            setupAll();
        },1);
    });
};

UiRouter.prototype.CheckAuthAndPresentView = function(Params)
{
    var _this = this;
    App.SessionManager.CheckLoggedIn({
        callback:function (IsLoggedIn)
        {
            if(IsLoggedIn)
            {
                App.Login(Params);
            }
            else
            {
                _this.Navigate("login", { trigger:true });
            }
        }
    });
};

UiRouter.prototype.PresentModalView = function(Params)
{
    if(Params.id === "SubscriberEditForm")
    {
        this.views.SubscriberEditForm = new SubscriberEditFormViewController(Params);
        this.views.SubscriberEditForm.ViewDidLoad();
    }

    if(Params.id === "TariffsClassConfigFormView")
    {
        this.views.TariffClassConfigForm = new TariffClassConfigFormViewController(Params);
        this.views.TariffClassConfigForm.ViewDidLoad();
    }

    if(Params.id === "HttpRequestViewController")
    {
        this.views.HttpRequestViewController = new HttpRequestViewController(Params);
        this.views.HttpRequestViewController.ViewDidLoad();
    }

    if(Params.id === "VasCloudLogin")
    {
        var _this = this;

        this.RequireViewController("VasCloudLoginViewController", function ()
        {
            if(_this.views.VasCloudLogin)
            {
                _this.views.VasCloudLogin.Hide();
                _this.views.VasCloudLogin.Destroy();

                delete _this.views.VasCloudLogin;
            }

            _this.views.VasCloudLogin = new VasCloudLoginViewController(Params);
            _this.views.VasCloudLogin.ViewDidLoad();
            _this.views.VasCloudLogin.Show();
        });
    }

    if(Params.id === "VchannelEditForm")
    {
        this.views.VchannelEditForm = new VchannelEditFormViewController(Params);
        this.views.VchannelEditForm.ViewDidLoad();
    }
};

UiRouter.prototype.Navigate = function(Route)
{
    "use strict";
    this.router.navigate(Route?Route:"", {replace:!this.History,trigger:true});
};

UiRouter.prototype.JustNavigate = function(Route, PathParams)
{
    var route = Route?Route:"";
    route += PathParams ? this.ParamsToPath(PathParams) : "";

    this.router.navigate(route, {replace:!this.History,trigger:false});
};

UiRouter.prototype.DestroyAllViews = function (Params)
{
    "use strict";
    var _this = this;
    Object.keys(this.views).forEach(function (key)
    {
        if(_this.views[key]&&_this.views[key].Destroy)
        {
            _this.views[key].Destroy();
        }

        if($$(key))
        {
            $$(key).destructor();
        }
    });

    this.views = {};
};

UiRouter.prototype.ShowProgress = function ()
{
    if(this.views.AppView)
    {
        $$(this.BodyLayoutId).showProgress({type: "icon"});
    }
};

UiRouter.prototype.HideProgress = function ()
{
    if(this.views.AppView && $$(this.BodyLayoutId))
    {
        $$(this.BodyLayoutId).hideProgress({type: "icon"});
    }
};

UiRouter.prototype.PathToParams = function (Path)
{
    var PathObj = {};

    if(Path)
    {
        var path = Path;
        while(path.charAt(0) === "/")
        {
            path = path.substr(1);
        }

        var PathArr = path.split("/");

        PathArr.forEach(function (ObjStr, I)
        {
            if(ObjStr.indexOf("=")>0)
            {
                var arr = ObjStr.split("=");
                PathObj[arr[0]] = arr[1];
            }
            else if(ObjStr)
            {
                PathObj[I.toString()] = ObjStr;
            }
        });
    }

    Object.keys(PathObj).forEach(function (Key)
    {
        PathObj[Key] = Helper.ReplaceAll("_", " ", PathObj[Key]);
    });

    return PathObj;
};

UiRouter.prototype.ParamsToPath = function (Params)
{
    var path = "";

    if(Params)
    {
        Object.keys(Params).forEach(function (Key, I)
        {
            if(parseInt(Key, 10) == I)
                path += "/" + Params[Key];
            else
                path += "/" + Key + "=" + Params[Key];
        });
    }

    return Helper.ReplaceAll(" ", "_", path);
};

UiRouter.prototype.SetPathParam = function(Key, Val, ViewController)
{
    var val = Val;

    if(Key.indexOf("period") >= 0)
    {
        var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

        val = val.id + "," + format(val.start) + "," + format(val.end);
    }

    if(val)
    {
        sessionStorage.setItem(ViewController.Id + "SPP_"+Key, val);
    }

    ViewController.PathParams[Key] = val;
};

UiRouter.prototype.GetPathParam = function(Key, ViewController)
{
    var val =  ViewController.PathParams[Key];

    if(!val && sessionStorage.getItem(ViewController.Id + "SPP_"+Key))
        val = sessionStorage.getItem(ViewController.Id + "SPP_"+Key);

    if(Key.indexOf("period") >= 0 && val)
    {
        var format =  webix.Date.strToDate("%Y-%m-%d %H:%i:%s");

        var valArr = val.split(",");

        val = new QoEDateRangePickerValueModel({id:valArr[0], start:format(valArr[1]), end:format(valArr[2])});
    }

    return val;
};

UiRouter.prototype.RequireViewController = function(Id, CallBack)
{
    var arr = Id.split("/");

    var module = arr.length == 2 ? arr[0] : "";

    var subfolder = module ? module + "/" : "";

    var id = arr.length == 2 ? arr[1] : arr[0];



    if((module && (!window[module] || !window[module][id])) || !window[id])
    {
        var filepath="../../";
        const _id = id.replace("ViewController", "");
        const module = UiControllersModules[_id];

        if(module && ModulesMap[module])
        {
            filepath += ModulesMap[module];
        }
        else{
            filepath += "app/ui/" + subfolder + id+ ".js";
        }

        webix.require([
            filepath
        ], function()
        {
            LangHelper.LoadModule(module);
            setTimeout(function () {
                CallBack();
            },1);
        });
    }
    else
    {
        CallBack();
    }
};

UiRouter.prototype.EnableHistory = function ()
{
    this.History = true;
};

UiRouter.prototype.DisableHistory = function ()
{
    this.History = false;
};

UiRouter.prototype.MakeUiNavigationUsersActionsLog = function (Params)
{
    let sectionId = Params && Params.id ? Params.id : "";

    if(SectionsToLogNavigate.includes(sectionId))
    {
        let params = {
            method: "MakeUiNavigationUsersActionsLog",
            data: {SectionId: Params && Params.id ? Params.id : ""}
        };

        App.ServerManager.CallMethod(params);
    }
};
/* global webix*/
/* global App */
/* global $$ */
/* global Rx */
/* global Helper */
/* global SessionManager */

function LoginViewController(Params) {
    "use strict";

    var _this = this;

    this.Id = "LoginView";

    this.LangSwitchViewPopupId = this.Id + "LangSwitchViewPopup";
    this.LangSwitchViewPopupConfig = {
        view: "submenu",
        id: this.LangSwitchViewPopupId,
        width: 200,
        autowidth: true,
        padding: 0,
        data: function (){
            var list = [
                {id: _this.LangSwitchViewPopupId+"En", icon: "en", value: LangHelper.GetString(_this.Id, "English")},
                {id: _this.LangSwitchViewPopupId+"Ru", icon: "ru", value: LangHelper.GetString(_this.Id, "Russian")}
            ];

            if(SkinHelper.GetSkin() === SkinsEnum.dpiui2_inss || SkinHelper.IsCubroSkin())
            {
                list.pop();
            }

            return list;
        }(),
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span>" + obj.icon .toUpperCase()+ "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                if(id == _this.LangSwitchViewPopupId+"En")
                {
                    LangHelper.SetLocale(LocalesEnum.en.code);
                }

                if(id == _this.LangSwitchViewPopupId+"Ru")
                {
                    LangHelper.SetLocale(LocalesEnum.ru.code);
                }

                location.reload();
            }
        }

    };
    this.LangSwitchViewPopup = null;

    this.view = {
        id: this.Id,
        type: "clear",
        rows: [
            {},
            {
                cols: [
                    {},
                    {
                        rows: [
                            {
                                view: "form",
                                id: this.Id + "LoginForm",
                                width: 350,
                                elements: [
                                    {
                                        cols:[
                                            {
                                                type: "clear",
                                                css: "app_logo_login",
                                                borderless: true,
                                                template: function() {
                                                    if(webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_inss") {
                                                        return "<img style='background:#f6f6f6' src='assets/imgs/" + (AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg") + "'/>";
                                                    }
                                                    return"<img src='assets/imgs/" + (AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg") + "'/>";
                                                },
                                                height: 40,
                                                width: function()
                                                {
                                                    var w = 131;

                                                    if(webix.skin.$name == "dpiui2_vulkan")
                                                    {
                                                        var logo = AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg";

                                                        if(!logo.includes("vas_experts"))
                                                        {
                                                            w = 92;
                                                        }
                                                    }

                                                    return w;
                                                }()
                                            },
                                            {},
                                            {
                                                height: 40,
                                                id: this.Id + "HeaderLangSwitch",
                                                css: "header_lang login",
                                                borderless: true,
                                                gravity: 2,
                                                data: {title: LangHelper.GetString(this.Id, "Eng."), icon:"en"},
                                                template: function (obj) {
                                                    var html = "<div style='height:100%;width:100%; text-align: right;' onclick='webix.$$(\""+_this.LangSwitchViewPopupId+"\").show(this)'>";
                                                    html += "<img class='lang' src='assets/imgs/flags/"+obj.icon+".svg'/><span class='name'>" + obj.title + "</span>";
                                                    html += "<span class='webix_icon fa-angle-down'></span></div>";
                                                    return html;
                                                }
                                            }
                                        ]
                                    },
                                    {height:6},
                                    {
                                        view: "label",
                                        css: "h1_label",
                                        label: LangHelper.GetString(this.Id, "Sign in to control panel CKAT DPI")
                                    },
                                    {
                                        view: "text",
                                        label: LangHelper.GetString(this.Id, "Login"),
                                        name: "username",
                                        tooltip: LangHelper.GetString(this.Id, "Login"),
                                        "labelPosition": "top",
                                        invalidMessage: LangHelper.GetString(this.Id, "Enter login"),
                                        validate: webix.rules.isNotEmpty,
                                        attributes:{maxlength:50},
                                        on: {
                                            "onChange": function ()
                                            {
                                                this.validate();
                                            },
                                            "onKeyPress": function(code, e)
                                            {
                                                if(code === 13)
                                                {
                                                    var form = this.getParentView();
                                                    var passEl = form.elements.password.focus();
                                                }
                                            }
                                        }

                                    },
                                    {
                                        view: "text",
                                        label: LangHelper.GetString(this.Id, "Password"),
                                        name: "password",
                                        type: "password",
                                        tooltip: LangHelper.GetString(this.Id, "Password"),
                                        "labelPosition": "top",
                                        invalidMessage: LangHelper.GetString(this.Id, "Enter password"),
                                        validate: webix.rules.isNotEmpty,
                                        attributes:{maxlength:30},
                                        on: {
                                            "onChange": function ()
                                            {
                                                this.validate();
                                            },
                                            "onKeyPress": function(code, e)
                                            {
                                                if(code === 13)
                                                {
                                                    _this.LoginProcess();
                                                }
                                            }
                                        }
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "checkbox",
                                                name: "remember",
                                                labelRight: LangHelper.GetString(this.Id, "Remember me"),
                                                value: 1,
                                                labelWidth: 0
                                            },
                                            {
                                                view: "button",
                                                id: this.Id + "loginBtn",
                                                type: "form",
                                                value: LangHelper.GetString(this.Id, "Sign in"),
                                                click: function () {
                                                    //App.Login();
                                                    _this.LoginProcess();
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        cols:[

                                            {},
                                            {
                                                view:"label",
                                                id:this.Id+"AppVersionLabel",
                                                align:"right",
                                                label:"test"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        css:{"margin-left":"0 !important"}
                    }
                ]
            },
            {}
        ]
    };

    if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
    {
        this.view = {
            id: this.Id,
            type: "clear",
            rows: [
                {},
                {
                    cols: [
                        {},
                        {
                            rows: [
                                {
                                    view: "form",
                                    css:"login",
                                    id: this.Id + "LoginForm",
                                    width: 480,
                                    type:"space",
                                    elements: [
                                        {
                                            type:"wide",
                                            rows:[
                                                {
                                                    cols:[
                                                        BlockHeaderTemplate({
                                                            title:LangHelper.GetString(this.Id, "Sign in to control panel CKAT DPI"),
                                                            borderless:true,
                                                            css:'login'
                                                        }),
                                                        {
                                                            width: 32,
                                                            id: this.Id + "HeaderLangSwitch",
                                                            css: "header_lang login",
                                                            borderless: true,
                                                            data: {title: LangHelper.GetString(this.Id, "Eng."), icon:"en"},
                                                            template: function (obj)
                                                            {
                                                                var html = "<div style='height:100%;width:100%; text-align: right;' onclick='webix.$$(\""+_this.LangSwitchViewPopupId+"\").show(this)'>";
                                                                html += "<span class='name'>" + obj.icon.toUpperCase() + "</span>";
                                                                html += "<span class='webix_icon fa-sort-down'></span></div>";
                                                                return html;
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    height:0
                                                },
                                                {
                                                    cols:[
                                                        {
                                                            view: "spectre_text",
                                                            label: LangHelper.GetString(this.Id, "Login"),
                                                            name: "username",
                                                            tooltip: LangHelper.GetString(this.Id, "Login"),
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter login"),
                                                            validate: webix.rules.isNotEmpty,
                                                            attributes:{maxlength:50},
                                                            on: {
                                                                "onChange": function ()
                                                                {
                                                                    this.validate();
                                                                },
                                                                "onKeyPress": function(code, e)
                                                                {
                                                                    if(code === 13)
                                                                    {
                                                                        var form = this.getParentView().getParentView().getParentView();
                                                                        var passEl = form.elements.password.focus();
                                                                    }
                                                                }
                                                            }

                                                        }
                                                    ]
                                                },
                                                {
                                                    cols:[
                                                        {
                                                            view: "spectre_text",
                                                            label: LangHelper.GetString(this.Id, "Password"),
                                                            name: "password",
                                                            type: "password",
                                                            tooltip: LangHelper.GetString(this.Id, "Password"),
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter password"),
                                                            validate: webix.rules.isNotEmpty,
                                                            attributes:{maxlength:30},
                                                            on: {
                                                                "onChange": function ()
                                                                {
                                                                    this.validate();
                                                                },
                                                                "onKeyPress": function(code, e)
                                                                {
                                                                    if(code === 13)
                                                                    {
                                                                        _this.LoginProcess();
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: "checkbox",
                                                            name: "remember",
                                                            labelRight: LangHelper.GetString(this.Id, "Remember me"),
                                                            value: 1,
                                                            labelWidth: 0
                                                        },
                                                        {
                                                            view: "spectre_button",
                                                            css:"form_button main_action",
                                                            id: this.Id + "loginBtn",
                                                            value: LangHelper.GetString(this.Id, "Sign in"),
                                                            autowidth:true,
                                                            click: function () {
                                                                //App.Login();
                                                                _this.LoginProcess();
                                                            }
                                                        },
                                                        {width:5}
                                                    ]
                                                },
                                                {
                                                    cols:[
                                                        {},
                                                        {
                                                            view:"label",
                                                            id:this.Id+"AppVersionLabel",
                                                            align:"right",
                                                            label:"test"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {}
                    ]
                },
                {}
            ]
        };
    }

    this.btns = {
        loginBtn: null
    };

    this.loginForm = null;
    this.loginField = null;
    this.passField = null;

    this.loginInProcess = new Rx.BehaviorSubject(0);
    this.valid = new Rx.BehaviorSubject(1);

    this.regInProcess = new Rx.BehaviorSubject(0);
    this.regFormValid = new Rx.BehaviorSubject(1);

    this.Subscriptions = {};

    this.Init(Params);
}

LoginViewController.prototype.Init = function (Params) {
    "use strict";

    webix.ui(this.view);
};

LoginViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    this.BindAll(Params);
    App.HideSplash();
};

LoginViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.AppVersion = $$(this.Id+"AppVersionLabel");

    this.loginForm = $$(this.Id + "LoginForm");
    webix.extend(this.loginForm, webix.ProgressBar);
    this.loginForm.attachEvent("onAfterValidation", function (result, value) {
        _this.valid.next(result ? 1 : 0);
    });

    this.btns.loginBtn = $$(this.Id + "loginBtn");

    this.LangSwitchViewPopup = webix.ui(this.LangSwitchViewPopupConfig);
    this.HeaderLangSwitch = $$(this.Id+"HeaderLangSwitch");
    this.DefineLang();

    this.Subscriptions.LoginInProcess = this.loginInProcess.subscribe(function (value) {
        var loginInProcess = value;

        if (loginInProcess) {
            _this.btns.loginBtn.disable();
            _this.loginForm.showProgress({type: "icon"});
        }
        else {
            _this.btns.loginBtn.enable();
            _this.loginForm.hideProgress();
        }
    });

    this.Subscriptions.AppVersion = App.SessionManager.AppVersion.subscribe(function (Value)
    {
        var ver = "";
        var tip = "";

        if(Value)
        {
            ver = "v." + Value.version + "&nbsp;" + Value.licence.charAt(0).toUpperCase();
            tip = "v." + Value.version + " " + Value.licence.charAt(0).toUpperCase() + Value.licence.slice(1);
        }

        _this.AppVersion.define({label: ver, tooltip: tip});
        _this.AppVersion.refresh();
    });
};

LoginViewController.prototype.LoginProcess = function () {
    "use strict";
    var _this = this;

    var formData = this.loginForm.getValues();
    this.loginForm.setValues({
        username: Helper.RemoveAllWhiteSpaces(formData.username),
        password: Helper.RemoveAllWhiteSpaces(formData.password),
        remember: formData.remember
    });

    if (this.loginForm.validate()) {
        this.valid.next(1);
        this.loginInProcess.next(1);

        formData = this.loginForm.getValues();

        App.SessionManager.Login({
            username: formData.username,
            password: formData.password,
            remember: formData.remember,
            callback: function (R) {
                _this.loginInProcess.next(0);

                if (!R.success && R.error.msg)
                {
                    webix.message({type: "error", text: R.error.msg});
                }

                if (R.success)
                {
                    App.Login();
                }
            }
        });
    }
    else {
        this.valid.next(0);
    }
};

LoginViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

LoginViewController.prototype.DefineLang = function ()
{
    this.HeaderLangSwitch.define("data",{icon:App.Locale, title:LocalesEnum[App.Locale].title_short});
};

function LoadingIndicatorWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        Indicator:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

LoadingIndicatorWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "LoadingIndicator";

    this.ViewConfig =
    {
        type: "clean",
        id:this.Id + "Indicator",
        height: SkinHelper.GetDefaultFilterUiSkin() == SkinsEnum.dpiui2_cubro ? 1 : 2,
        borderless: true,
        padding: 0,
        marging: 0,
        css: "app_header__border_bottom",
        template: '<div class="break dot1"></div><div class="break dot2"></div><div class="break dot3"></div>'
    };
};

LoadingIndicatorWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    this.Subscriptions.Loading = App.ServerManager.Loading.subscribe(function (Loading)
    {
        if(Loading > 0)
        {
            webix.html.addCss(_this.Views.Indicator.getNode(), "loading");
        }
        else
        {
            webix.html.removeCss(_this.Views.Indicator.getNode(), "loading");
        }
    });
};

LoadingIndicatorWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};
function LoadingBarWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        Indicator:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

LoadingBarWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "LoadingIndicator";

    this.ViewConfig =
        {
            type: "clean",
            id:this.Id + "Indicator",
            height: 2,
            borderless: true,
            padding: 0,
            marging: 0,
            css: "app_header__loading_indicator",
            template: '<div class="indicator"></div>'
        };
};

LoadingBarWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    this.Subscriptions.Loading = App.ServerManager.Loading.subscribe(function (Loading)
    {
        if(Loading > 0)
        {
            webix.html.addCss(_this.Views.Indicator.getNode(), "loading");
        }
        else
        {
            webix.html.removeCss(_this.Views.Indicator.getNode(), "loading");
        }
    });
};

LoadingBarWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};
function AppMainMenuSidebarWidget(ViewConfig) {
    "use strict";

    this.Id = null;

    this.ViewConfig = null;

    this.SessionManager = App.SessionManager;

    this.MenuData = [
        {
            id: "DpiPerformance_",
            icon: "server",
            value: LangHelper.GetString(this.Id, "DPI control"), /*href:"#DpiPerformance",*/ section:RoleSectionsEnum.performance,
            data:[
                {id: "DpiPerformance", value: LangHelper.GetString(this.Id, "Performance"), href:"#DpiPerformance", section:RoleSectionsEnum.performance},
                {id: "DpiConfig", value: LangHelper.GetString(this.Id, "Configuration"), href:"#DpiConfig", section:RoleSectionsEnum.config},
                {id: "DpiDscpConfig", value: LangHelper.GetString(this.Id, "Protocol prioritization (DSCP)"), href:"#DpiDscpConfig", section:RoleSectionsEnum.config},
                {id: "DpiAsnDscpConfig", value: LangHelper.GetString(this.Id, "Priority for ASN"), href:"#DpiAsnDscpConfig", section:RoleSectionsEnum.config},
                {id: "DpiLogs", value: LangHelper.GetString(this.Id, "Logs"), href:"#DpiLogs", section:RoleSectionsEnum.logs},
                {id: "SidebarSeparator_DpiPerformance_1", value: "", section:RoleSectionsEnum.performance},
                {id: "Subscribers", value: LangHelper.GetString(this.Id, "Subscribers and services"), href:"#Subscribers", section:RoleSectionsEnum.subscribers},
                {id: "Services", value: LangHelper.GetString(this.Id, "Services"), href:"#Services", section:RoleSectionsEnum.services},
                {id: "Tariffs", value: LangHelper.GetString(this.Id, "Tariff plans"), href:"#Tariffs", section:RoleSectionsEnum.tariffs},
                {id: "SidebarSeparator_DpiPerformance_2", value: "", section:RoleSectionsEnum.performance},
                {id: "Advc", value: LangHelper.GetString(this.Id, "Adv control"), href:"#Advc", section:RoleSectionsEnum.advc},
                {id: "HotSpot", value: LangHelper.GetString(this.Id, "HotSpot"), href:"#HotSpot", section: RoleSectionsEnum.services}
            ]
        },
        {
            id: "FastPcrfConfig_",
            icon: "poll-people",
            value: LangHelper.GetString(this.Id, "PCRF control"),
            section: RoleSectionsEnum.pcrf,
            data: [
                {id: "FastPcrfConfig", value: LangHelper.GetString("AppView", "Configuration"), href:"#FastPcrfConfig", section:RoleSectionsEnum.pcrf_config},
                {id: "FastPcrfLogs", value: LangHelper.GetString("AppView", "Logs"), href:"#FastPcrfLogs", section:RoleSectionsEnum.pcrf_logs}
            ]
        },
        {
            id: "QoEDashboard_", icon: "monitor-heart-rate", value: LangHelper.GetString(this.Id, "QoE analytics"), /*href:"#QoEDashboard",*/ section:RoleSectionsEnum.qoeanalytics,
            data: [
                {id: "QoEDashboard", value: LangHelper.GetString(this.Id, "QoE dashboard"), href:"#QoEDashboard", section:RoleSectionsEnum.qoeanalytics_dashboard},
                {id: "SidebarSeparator_QoE_1", value: "", section:RoleSectionsEnum.qoeanalytics},
                {id: "QoEFullNetFlow", value: LangHelper.GetString(this.Id, "Netflow"), href:"#QoEFullNetFlow", section:RoleSectionsEnum.qoeanalytics_fullnetflow},
                {id: "QoERawFullNetFlow", value: LangHelper.GetString("AppView", "Raw full netflow"), href:"#QoERawFullNetFlow", section:RoleSectionsEnum.qoeanalytics_rawfullnetflow},
                {id: "SidebarSeparator_QoE_2", value: "", section:RoleSectionsEnum.qoeanalytics},
                {id: "QoEClickStream", value: LangHelper.GetString(this.Id, "Clickstream"), href:"#QoEClickStream", section:RoleSectionsEnum.qoeanalytics_clickstream},
                {id: "QoERawClickstream", value: LangHelper.GetString("AppView", "Raw clickstream"), href:"#QoERawClickstream", section:RoleSectionsEnum.qoeanalytics_rawclickstream},
                {id: "SidebarSeparator_QoE_3", value: "", section:RoleSectionsEnum.qoeanalytics},
                {id: "QoEFullGtpFlow", value: LangHelper.GetString(this.Id, "Gtp flow"), href:"#QoEFullGtpFlow", section:RoleSectionsEnum.qoeanalytics_gtp},
                {id: "QoERawFullGtpFlow", value: LangHelper.GetString("AppView", "Raw Gtp flow"), href:"#QoERawFullGtpFlow", section:RoleSectionsEnum.qoeanalytics_rawgtp},
                {id: "SidebarSeparator_QoE_4", value: "", section:RoleSectionsEnum.qoeanalytics},
                {id: "QoEFullNatFlow", value: LangHelper.GetString(this.Id, "NAT flow"), href:"#QoEFullNatFlow", section:RoleSectionsEnum.qoeanalytics_nat},
                {id: "QoERawFullNatFlow", value: LangHelper.GetString("AppView", "Raw NAT flow"), href:"#QoERawFullNatFlow", section:RoleSectionsEnum.qoeanalytics_rawnat},
                {id: "SidebarSeparator_QoE_5", value: "", section:RoleSectionsEnum.qoeanalytics},
                {id: "QoEFullDnsFlow", value: LangHelper.GetString("AppView", "DNS flow"), href:"#QoEFullDnsFlow", section:RoleSectionsEnum.qoeanalytics_dns },
                {id: "QoERawFullDnsFlow", value: LangHelper.GetString("AppView", "Raw DNS flow"), href:"#QoERawFullDnsFlow", section:RoleSectionsEnum.qoeanalytics_rawdns },
                {id: "SidebarSeparator_QoE_6", value: "", section:RoleSectionsEnum.qoeanalytics},
                {id: "QoEFullDdosAttackFlow", value: LangHelper.GetString("AppView", "DDoS attacks"), href:"#QoEFullDdosAttackFlow", section:RoleSectionsEnum.qoeanalytics_ddos_attack },
                {id: "QoERawFullDdosAttackFlow", value: LangHelper.GetString("AppView", "DDoS attacks log"), href:"#QoERawFullDdosAttackFlow", section:RoleSectionsEnum.qoeanalytics_raw_ddos_attack },

                {id: "SidebarSeparator_QoE_7", value: "", section:RoleSectionsEnum.qoeanalytics},
                {id: "QoESubscribers", value: LangHelper.GetString(this.Id, "Subscribers"), href:"#QoESubscribers", section:RoleSectionsEnum.qoeanalytics_subscribers},
                {id: "QoEOnlineReports", value: LangHelper.GetString(this.Id, "Online reports"), href:"#QoEOnlineReports", section:RoleSectionsEnum.qoeanalytics_online_reports},
                {id: "QoETriggers", value: LangHelper.GetString("AppView", "Triggers & Alerts"), href:"#QoETriggers", section:RoleSectionsEnum.qoeanalytics_triggers},
                {id: "QoECustomReports", value: LangHelper.GetString("AppView", "Custom reports"), href:"#QoEFullNatFlow", section:RoleSectionsEnum.qoeanalytics_customreports},
                {id: "QoEUserReports", value: LangHelper.GetString("AppView", "My reports"), href:"#QoEUserReports", section:RoleSectionsEnum.qoeanalytics_reports_manager},
                {id: "QoEMailingTemplates", value: LangHelper.GetString("AppView", "Mailing templates"), href:"#QoEMailingTemplates", section:RoleSectionsEnum.qoeanalytics_mailing_templates},
                {id: "SidebarSeparator_QoE_8", value: "", section:RoleSectionsEnum.qoeanalytics},
                {id: "QoEAdmin", value: LangHelper.GetString("AppView", "Administrator"), href:"#QoEAdmin", section:RoleSectionsEnum.qoeanalytics_admin}
            ]
        },
        {
            id: "VasCloudPersonalArea_", icon: "cloud", value: LangHelper.GetString("VasCloud", "Vas cloud services"), /*href:"#VasCloudPersonalArea",*/ section:RoleSectionsEnum.vascloud,
            data: [
                {id: "VasCloudPersonalArea", value: LangHelper.GetString("VasCloud", "Personal area"), href:"#VasCloudPersonalArea", section:RoleSectionsEnum.vascloud},
                {id: "SidebarSeparator_VasCloudPersonalArea_1", value: "", section:RoleSectionsEnum.vascloud},
                {id: "VasCloudProtocolsCustom", value: LangHelper.GetString("Protocols", "Custom Protocols"), href:"#VasCloudProtocolsCustom", section:RoleSectionsEnum.vascloud},
                {id: "VasCloudCustomProtocolsGroups", value: LangHelper.GetString("CustomProtocolsGroups", "Protocols groups"), href:"#VasCloudCustomProtocolsGroups", section:RoleSectionsEnum.vascloud},
                {id: "VasCloudProtocolsLogs", value: LangHelper.GetString("VasCloud", "Logs"), href:"#VasCloudProtocolsLogs", section:RoleSectionsEnum.vascloud},
                {id: "SidebarSeparator_VasCloudPersonalArea_2", value: "", section:RoleSectionsEnum.depricated},
                {id: "VasCloudAds", value: LangHelper.GetString("VasCloud", "Vas Ads"), href:"#VasCloudAds", section:RoleSectionsEnum.depricated},
                {id: "VasCloudAdsStatistics", value: LangHelper.GetString("AppView", "Statistics"), href:"#VasCloudAdsStatistics", section:RoleSectionsEnum.depricated},
                {id: "VasCloudAccrualsAndPayments", value: LangHelper.GetString("AppView", "Accruals and payments"), href:"#VasCloudAccrualsAndPayments", section:RoleSectionsEnum.depricated}
            ]
        },
        {
            id: "ConnectionsValidateData_", icon: "code-commit", value: LangHelper.GetString("AppView","Lawful interception"), /*href:"#ConnectionsValidateData",*/ section:RoleSectionsEnum.li,
            data:[
                {id: "ConnectionsValidateData", value: LangHelper.GetString("AppView","Connections"), href:"#ConnectionsValidateData", section:RoleSectionsEnum.li_connections},
                {id: "SidebarSeparator_ConnectionsValidateData", value: "", section:RoleSectionsEnum.li},
                {id: "TrafficManagementGenerator", value: LangHelper.GetString("AppView","Traffic generation"), href:"#TrafficManagementGenerator", section:RoleSectionsEnum.li_t_generation},
                {id: "TrafficManagementCapture", value: LangHelper.GetString("AppView", "Traffic capture"), href:"#TrafficManagementCapture", section:RoleSectionsEnum.li_t_capture},
                {id: "TrafficDecode", value: LangHelper.GetString("AppView", "Traffic decode"), href:"#TrafficDecode", section:RoleSectionsEnum.li_traffic_decode},
                {id: "TrafficDecodeLogs", value: LangHelper.GetString("AppView", "Traffic decode logs"), href:"#TrafficDecodeLogs", section:RoleSectionsEnum.li_traffic_decode},
                {id: "SidebarSeparator_TrafficManagementGenerator", value: "", section:RoleSectionsEnum.li},
                {id: "TrafficManagementSiteClone", value: LangHelper.GetString("AppView", "Cloning a website"), href:"#TrafficManagementSiteClone", section:RoleSectionsEnum.li_site_clone},
                {id: "NetworkAudit", value: LangHelper.GetString("AppView", "Network audit"), href:"#NetworkAudit", section:RoleSectionsEnum.li_n_audit},
                {id: "SidebarSeparator_NetworkAudit", value: "", section:RoleSectionsEnum.li},
                {id: "LiHealth", value: LangHelper.GetString("AppView", "Health map"), href:"#LiHealth", section:RoleSectionsEnum.li_health}
            ]
        },
        {
            id: "_Classifier", icon: "sitemap", value: LangHelper.GetString("AppView", "Classifier"), /*href:"#Classifier",*/ section:RoleSectionsEnum.sites_clsfr,
            data:[
                {id: "Classifier", value: LangHelper.GetString("Classifier", "Hosts Categories"), href:"#Classifier", section:RoleSectionsEnum.sites_clsfr},
                {id: "ClassifierModel", value: LangHelper.GetString("Classifier", "Classifier model"), href:"#ClassifierModel", section:RoleSectionsEnum.sites_clsfr_model},
                {id: "ClassifierConfig", value: LangHelper.GetString(this.id, "Configuration"), href:"#ClassifierConfig", section:RoleSectionsEnum.sites_clsfr_admin},
                {id: "ClassifierLogs", value: LangHelper.GetString(this.Id, "Logs"), href:"#ClassifierLogs", section:RoleSectionsEnum.sites_clsfr_admin}
            ]
        },
        {
            id: "Hardwares_", icon: "user-cog", value: LangHelper.GetString(this.Id, "Administrator"), /*href:"#Hardwares",*/ section:RoleSectionsEnum.administrator,
            data:[
                {id: "Hardwares", value: LangHelper.GetString("Hardwares", "Equipment"), href:"#Hardwares", section:RoleSectionsEnum.hardware},
                {id: "HardwareSshKeys", value: LangHelper.GetString("HardwareSshKeys", "SSH keys"), href:"#HardwareSshKeys", section:RoleSectionsEnum.hardware_ssh_keys},
                {id: "SidebarSeparator_Administrator_0", value: "", section:RoleSectionsEnum.administrator},
                {id: "Users", value: LangHelper.GetString("AppView", "Users"), href:"#Users", section:RoleSectionsEnum.administrator_users},
                {id: "Roles", value: LangHelper.GetString("AppView", "Roles"), href:"#Roles", section:RoleSectionsEnum.administrator_roles},
                {id: "UsersActionsLog", value: LangHelper.GetString("AppView", "Users actions log"), href:"#UsersActionsLog", section:RoleSectionsEnum.administrator_users_actions_log},
                {id: "SidebarSeparator_Administrator_1", value: "", section:RoleSectionsEnum.administrator},
                {id: "Dpiui2Config", value: LangHelper.GetString("AppView", "DPIUI2 (GUI) server configuration"), href:"#Dpiui2Config", section:RoleSectionsEnum.administrator_dpiui2},
                {id: "Dpiui2Logs", value: LangHelper.GetString("AppView", "DPIUI2 logs"), href:"#Dpiui2Logs", section:RoleSectionsEnum.administrator_dpiui2},
                {id: "Dpiui2Update", value: LangHelper.GetString("AppView", "DPIUI2 (GUI) update"), href:"#Dpiui2Update", section:RoleSectionsEnum.administrator_dpiui2},
                {id: "SidebarSeparator_Administrator_2", value: "", section:RoleSectionsEnum.administrator},
                {id: "QoEStorConfig", value: LangHelper.GetString("AppView", "QoE Stor (fastor) server configuration"), href:"#QoEStorConfig", section:RoleSectionsEnum.administrator_dpiui2},
                {id: "QoEStorLogs", value: LangHelper.GetString("AppView", "QoE Stor (fastor) logs"), href:"#QoEStorLogs", section:RoleSectionsEnum.administrator_dpiui2},
                // {id: "SidebarSeparator_Administrator_3", value: "", section:RoleSectionsEnum.administrator},
                {id: "BalancerConfig", value: LangHelper.GetString("AppView", "Balancer server configuration"), href:"#BalancerConfig", section:RoleSectionsEnum.administrator_dpiui2},
                {id: "BalancerLogs", value: LangHelper.GetString("AppView", "Balancer logs"), href:"#BalancerLogs", section:RoleSectionsEnum.administrator_dpiui2},
                {id: "SidebarSeparator_Administrator_4", value: "", section:RoleSectionsEnum.administrator},
                {id: "CaptchaConfig", value: LangHelper.GetString("AppView", "Captcha configuration"), href:"#CaptchaConfig", section:RoleSectionsEnum.depricated},
                {id: "CaptchaTemplates", value: LangHelper.GetString("AppView", "Captcha template"), href:"#CaptchaTemplates", section:RoleSectionsEnum.depricated},
                {id: "CaptchaLogs", value: LangHelper.GetString("AppView", "Captcha logs"), href:"#CaptchaLogs", section:RoleSectionsEnum.depricated}
            ]
        },
        {
            id: "HardwareSshTerminal_", icon: "terminal", value: LangHelper.GetString(this.Id, "Hardware ssh terminal"), section:RoleSectionsEnum.ssh_terminal,
            data:[
                {id: "HardwareSshTerminal", value: LangHelper.GetString(this.Id, "Hardware ssh terminal"), href:"#HardwareSshTerminal", section:RoleSectionsEnum.ssh_terminal},
            ]
        },
        {
            id: "AntiDDoSNetworks_", icon: "shield", value: LangHelper.GetString(this.Id, "AntiDDoS"), section:RoleSectionsEnum.antiddos,
            data:[
                {id: "AntiDDoSNetworks", value: LangHelper.GetString(this.Id, "Networks"), href:"#AntiDDoSNetworks", section:RoleSectionsEnum.antiddos},
                {id: "AntiDDoSThreats", value: LangHelper.GetString(this.Id, "Threats"), href:"#AntiDDoSThreats", section:RoleSectionsEnum.antiddos},
                {id: "AntiDDoSProtection", value: LangHelper.GetString(this.Id, "Protection"), href:"#AntiDDoSProtection", section:RoleSectionsEnum.antiddos}
            ]
        }
    ];

    this.Views =
    {
        Menu:null,
        LeftSideBar:null,
        AppVersionLabel:null,
    };

    this.Widgets = function(){
        let widgets = {};

        widgets.AppVersion = new AppVersionLabelWidget({id:"AppVersionWidget"});
        widgets.CollapseButton = new SidebarCollapseButtonWidget({id:"SidebarCollapseBtn"});

        return widgets;
    }();

    this.Subscriptions = {};

    this.State = null;

    this.LastOpened = null;

    this.CurrentMenuItemId = null;

    this.Init(ViewConfig);
}

AppMainMenuSidebarWidget.prototype.Init = function (ViewConfig) {
    "use strict";

    let _this = this;

    this.Id = ViewConfig.id;

    let id = ViewConfig.id + "LeftSideBar";

    let data = [];

    this.Id = ViewConfig.id ? ViewConfig.id : "AppMainMenu";

    webix.copy(this.MenuData).forEach(function (Item, Index)
    {
        var subItemsSections = [];

        delete Item.href;

        if(Item.data && Item.data.length)
        {
            var itemData = [];

            Item.data.forEach(function (SubItem, Index)
            {
                if(SubItem.id.indexOf("SidebarSeparator") == 0)
                {
                    if(!(itemData.length == 0 || itemData[itemData.length - 1].id.indexOf("SidebarSeparator") == 0))
                    {
                        subItemsSections.push(SubItem.section);
                        itemData.push(SubItem);
                    }
                }
                else if(SubItem.section && App.SessionManager.CheckUserRoleSection(SubItem.section))
                {
                    subItemsSections.push(SubItem.section);
                    itemData.push(SubItem);
                }
            });

            Item.data = itemData;
        }

        subItemsSections.every(Section =>
        {
            if(Section && App.SessionManager.CheckUserRoleSection(Section))
            {
                data.push(Item);
                return false;
            }
        });

    });

    this.ViewConfig =
        {
            type: "clean",
            id: "SidebarMain",
            css: "main_menu_sidebar font_stolzl_regular",
            borderless: true,
            rows: [
                {
                    id: "SidebarHeader",
                    height: 64,
                    cols: [
                        {
                            type: "clean",
                            css: "app_logo",
                            borderless: true,
                            template: "<img src='assets/imgs/" + (AppEnv.UrlUiLogo ? AppEnv.UrlUiLogo : "vas_experts_logo_b.svg") + "'/>",
                        }
                    ]
                },
                {
                    cols: [
                        {
                            view: "search",
                            id: "search",
                            placeholder: LangHelper.GetString("All", "Search"),
                            css: "app_sidebar_search_input",
                            on: {
                                onTimedKeyPress: function () {
                                    let searchValue = this.getValue().toLowerCase();

                                    let sidebar = $$(id);

                                    if (!searchValue)
                                    {
                                        sidebar.filter();
                                        sidebar.closeAll();

                                        if(_this.CurrentMenuItemId)
                                        {
                                            _this.Select(_this.CurrentMenuItemId);
                                        }
                                    }
                                    else
                                    {
                                        let res = sidebar.filter(function (obj) {
                                            return obj.value.toLowerCase().indexOf(searchValue) != -1;
                                        });
                                    }
                                }
                            }
                        },
                        {
                            view: "button",
                            id: "searchClearBtn",
                            type: "icon",
                            icon: "times",
                            css: "app_sidebar_search_clear_btn",
                            margin: 0,
                            padding: 0,
                            width: 11,
                            click: function () {
                                let sidebar = $$(id);
                                $$("search").setValue("");
                                sidebar.filter();

                                sidebar.closeAll();
                                if(_this.CurrentMenuItemId)
                                {
                                    _this.Select(_this.CurrentMenuItemId);
                                }


                            }
                        }
                    ]
                },

                {
                    view: "sidebar",
                    width:320,
                    id: id,
                    scroll: "y",
                    data: data,
                    css: "app_main_menu_sidebar",
                    template: function (item) {
                        return  _this.SidebarItemsTemplate(item);
                    }
                },
                {
                    cols: [this.Widgets.AppVersion.ViewConfig]
                }
            ]
        }
};

AppMainMenuSidebarWidget.prototype.BindAll = function (ViewConfig) {
    "use strict";

    let _this = this;

    Object.keys(this.Views).forEach(function (View) {
        _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Widgets).forEach(function (WidgetKey)
    {
        let w = _this.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, null);
    });
};

AppMainMenuSidebarWidget.prototype.Destroy = function () {
    "use strict";

    let _this = this;

    Object.keys(this.Widgets).forEach(function (Widget)
    {
        let w = _this.Widgets[Widget];

        if(w.Destroy)
            w.Destroy();
    });
};

AppMainMenuSidebarWidget.prototype.Select = function (MenuItemId)
{
    this.CurrentMenuItemId = MenuItemId;

    this.OpenSidebarBranch(MenuItemId);

    return this.SelectSidebarMenuItem(MenuItemId.replace("_", ""));
}

AppMainMenuSidebarWidget.prototype.UnselectAll = function () {
    "use strict";

    this.Views.LeftSideBar.unselectAll();
}

AppMainMenuSidebarWidget.prototype.OpenSidebarBranch = function (Id) {
    try
    {
        this.MenuData.forEach(menuBranch => {
            if(menuBranch.id === Id)
                this.Views.LeftSideBar.open(Id);

            const menuBranchItem = menuBranch.data.find(item => item.id === Id.replace("_", ""));

            if(menuBranchItem)
                this.Views.LeftSideBar.open(menuBranch.id);
        });
    }
    catch (e){}
}

AppMainMenuSidebarWidget.prototype.SelectSidebarMenuItem = function (Id) {
    "use strict";

    let flatData = this.MenuData.slice();
    this.MenuData.forEach(item => flatData.push(item.data));
    flatData = [].concat(...flatData);

    const selectedItem = flatData.find(menuItem => menuItem.id === Id);

    if(selectedItem && selectedItem.section && App.SessionManager.CheckUserRoleSection(selectedItem.section))
        this.Views.LeftSideBar.select(selectedItem.id);

    return selectedItem;
}

AppMainMenuSidebarWidget.prototype.SidebarItemsTemplate = function (item) {
    "use strict";

    if (!item.href)
        var tpl = `<span class="webix_sidebar_dir_icon webix_icon fa-angle-down"></span>`;
    else
        var tpl = ``;

    if (item.icon)
        tpl += `<span class="webix_icon webix_sidebar_icon fa-${item.icon}"></span>`;

    tpl += `<span>${item.value}</span>`;

    if (item.href)
        tpl = `<a href="${item.href}" onclick="return false" style="text-decoration:none">${tpl}</a>`;

    return tpl;
}
function BreadCrumbsWidget(ViewConfig)
{
    "use strict";

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
            BreadCrumbsLeftResizer: null,
            LeftSideBar: null,
            BreadCrumbsPopupWindow: null,
            BreadCrumbsPopupWrapper: null,
            BreadCrumbsContainer: null,
            BreadCrumbsPopupListChapter: null,
            BreadCrumbsPopupContentList: null
    };

    this.Widgets = function() {
        let widgets = {};

        widgets.HwSwitch = new HardwareSwitchWidget({id:"HwSwitch"});

        return widgets;
    }();

    this.Data = {
      LeftSideBarData: null,
      ClickedCrumbId: null
    };

    this.Dictionaries = {
        CrumbDictionaryId: null,
        PopupListDictionaryId: null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

BreadCrumbsWidget.prototype.Init = function(ViewConfig)
{
    "use strict";

    const _this = this;

    this.Id = ViewConfig.id;

    const id = ViewConfig.id + "BreadCrumbs";

    this.MenuPopupConfig = {
        id: id + "PopupWindow",
        view: "popup",
        point: false,
        css: "bread_crumbs_popup",
        body: {
            id: id + "PopupWrapper",
            css: "bread_crumbs_popup_content_wrapper",
            cols: [
                {
                    id: id + "LeftResizer",
                },
                {
                    css: "bread_crumbs_popup_content",
                    rows: [
                        {
                            id: id + "PopupListChapter",
                            css: "crumb_chapter bread_crumbs_popup__chapter",
                            borderless: true,
                            template: function(Value) {
                                return _this.ChapterItemTemplate(Value);
                            }
                        },
                        {
                            id: id + "PopupContentList",
                            css: "crumb_list bread_crumbs_popup__list",
                            rows: []
                        }
                    ]
                }
            ]
        },
        on: {
            onShow: function() {
              _this.DeleteSelectCrumbClass();
              webix.html.addCss(this.getNode(), "bread_crumbs_popup_show");
            },
            onHide: function() {
                _this.DeleteSelectCrumbClass();
                _this.Data.ClickedCrumbId = null;
                webix.html.removeCss(_this.Views.BreadCrumbsPopupWindow.getNode(), "bread_crumbs_popup_show");
            }
        }
    };

    this.MenuPopup = webix.ui(this.MenuPopupConfig);

    this.ViewConfig = {
        id: id + "Container",
        view: "layout",
        type: "clean",
        borderless: true,
        css: "bread_crumbs_container",
        cols: []
    }
}

BreadCrumbsWidget.prototype.BindAll = function()
{
    "use strict";

    Object.keys(this.Views).forEach(View => {
        this.Views[View] = $$(this.Id + View)
    });

    Object.keys(this.Dictionaries).forEach(Dictionary => {
        this.Dictionaries[Dictionary] = new Map();
    });

    this.Data.LeftSideBarData = this.Views.LeftSideBar.serialize();

    this.Data.LeftSideBarData.forEach(branch => {
        branch.data = branch.data.filter(item => !item.id.includes("SidebarSeparator"));
    });

    this.Views.LeftSideBar.attachEvent("onItemClick", Id => {
        this.RenderPage(Id);
    })
    this.Subscriptions.HardwaresDicUpdated = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(Value => {
        if(Value) {
            this.SubscriptionsRenderCrumbs();
        }
    });

    this.Subscriptions.CurrentHardwareChanged = App.SessionManager.CurrentHardwareId.subscribe(Value => {
        if(Value) {
            this.SubscriptionsRenderCrumbs();
        }
    });
}

BreadCrumbsWidget.prototype.Destroy = function()
{
    "use strict";

    Object.keys(this.Widgets).forEach(Widget => {
        const w = this.Widgets[Widget];
        if(w.Destroy) {
            w.Destroy();
        }
    });

    Object.keys(this.Subscriptions).forEach(Key => {
        this.Subscriptions[Key].unsubscribe();
    });
}

BreadCrumbsWidget.prototype.SubscriptionsRenderCrumbs = function()
{
    "use strict";

    const nodeHardwareId = "DpiPerformance_";

    const selectedId = this.Views.LeftSideBar.getSelectedId();
    if(selectedId) {
        const selectedNodeId = this.Views.LeftSideBar.getParentId(selectedId);
        if(selectedNodeId == nodeHardwareId) {
            this.RenderCrumbs(selectedId);
        }
    }
}

BreadCrumbsWidget.prototype.GetFlatLeftSideBarData = function()
{
    "use strict";

    let flatData = this.Data.LeftSideBarData.slice();

    this.Data.LeftSideBarData.forEach(item => flatData.push(item.data));

    return [].concat(...flatData);
}

BreadCrumbsWidget.prototype.GetDisplayedCrumbs = function(Data, SelectedId)
{
    const selectedId = this.Views.LeftSideBar.getSelectedId();

    if(!selectedId)
        return [];

    const parentId = this.Views.LeftSideBar.getParentId(SelectedId);

    let crumbs = Data.filter(item => [SelectedId, parentId].includes(item.id));

    const hardware = this.GetSelectedHardware(SelectedId);

    if(hardware) {
        crumbs.splice(1, 0, hardware);
    }

    return crumbs;
}

BreadCrumbsWidget.prototype.GetSelectedHardware = function(SelectedId)
{
    "use strict";

    const nodeHardwareId = "DpiPerformance_";
    const dicId = "HardwaresDic";
    const hardwareDicFilterField = "dic_id";

    const selectedNodeId = this.Views.LeftSideBar.getParentId(SelectedId);

    if(selectedNodeId == nodeHardwareId) {
        const currentHardwareId = App.SessionManager.GetCurrentHardwareId();

        const hardware = App.DicsManager.GetDicAsArrayWithFilter(dicId, hardwareDicFilterField, currentHardwareId)[0];

        if(hardware) {
            hardware.widget = this.Widgets.HwSwitch;
            return hardware;
        }

        return {id: webix.uid(), value: LangHelper.GetString(this.Id, "Device not selected"), widget: this.Widgets.HwSwitch};
    }
    return 0;
}

BreadCrumbsWidget.prototype.RenderCrumbs = function(SelectedId)
{
    "use strict";

    let cols = [];

    this.DestroyHwSwitchWidget();

    const displayedCrumbs = this.GetDisplayedCrumbs(this.GetFlatLeftSideBarData(), SelectedId);

    this.Dictionaries.CrumbDictionaryId.clear();

    displayedCrumbs.forEach((item, index) => {
        const uniqueId = webix.uid();

        cols.push(this.GetCrumbContainerWrapper(item, uniqueId, item.widget));

        if(index != displayedCrumbs.length - 1) {
            cols.push(this.GetDelimiter());
        }

        this.Dictionaries.CrumbDictionaryId.set(uniqueId, item.id);
    });

    webix.ui(cols, this.Views.BreadCrumbsContainer);

    this.BindHwSwitchWidget();
}

BreadCrumbsWidget.prototype.GetHwSwitchView = function()
{
    "use strict";

    return this.Views.BreadCrumbsContainer.queryView({id: "HwSwitchCols"}, "self");
}

BreadCrumbsWidget.prototype.DestroyHwSwitchWidget = function()
{
    "use strict";

    const hwSwitchView = this.GetHwSwitchView();
    if(hwSwitchView) {
       this.Widgets.HwSwitch.Destroy();
    }
}

BreadCrumbsWidget.prototype.BindHwSwitchWidget = function()
{
    "use strict";

    const hwSwitchView = this.GetHwSwitchView();
    if(hwSwitchView) {
        this.Widgets.HwSwitch.BindAll();
    }
}

BreadCrumbsWidget.prototype.GetCrumbContainerWrapper = function(Data, Id, Widget)
{
    "use strict";

    if(Widget) {
        return {
            view: "layout",
            css: "crumb_container_wrapper",
            cols: [
                Widget.DpiIconViewConfig,
                this.GetCrumbContainer(Data, Id),
                Widget.ActionMenuViewConfig
            ]
        }
    }

    return {
        view: "layout",
        css: "crumb_container_wrapper",
        cols: [
            this.GetCrumbContainer(Data, Id)
        ]
    }
}

BreadCrumbsWidget.prototype.GetCrumbContainer = function(Data, Id)
{
    "use strict";

    const _this = this;

    return {
        view: "button",
        id: Id,
        css: "crumb_container",
        type: "image",
        label: this.CrumbTemplate(Data),
        click: function (idCrumb) {
            _this.CrumbClickHandler.call(_this, this, idCrumb);
        }
    }
}

BreadCrumbsWidget.prototype.GetDelimiter = function()
{
    "use strict";

    return {
        css: "delimiter",
        borderless: true,
        template: `<span class="fa fa-chevron-right delimiter__item"></span>`
    }
}

BreadCrumbsWidget.prototype.RenderPopupListItems = function(Data)
{
    "use strict";

    const _this = this;

    let cols = [];

    this.Dictionaries.PopupListDictionaryId.clear();

    Data.forEach(item => {
        const uniqueId = webix.uid();

        cols.push({
            view: "button",
            id: uniqueId,
            type: "image",
            label: this.GetPopupListItemTemplate(item),
            click: function(id) {
                let node = this.getInputNode();
                webix.html.addCss(node, "webix_img_btn_click");

                setTimeout(function() {
                    _this.SelectPopupListItem(_this.Dictionaries.PopupListDictionaryId.get(id));
                    _this.Views.BreadCrumbsPopupWindow.hide();
                }, 200);
            }
        });
        this.Dictionaries.PopupListDictionaryId.set(uniqueId, item.id);
    });

    webix.ui(cols, this.Views.BreadCrumbsPopupContentList);
}

BreadCrumbsWidget.prototype.DeleteSelectCrumbClass = function()
{
    "use strict";

    let CrumbContainerElements = this.Views.BreadCrumbsContainer.getChildViews();

    CrumbContainerElements.forEach(element => {
        webix.html.removeCss(element.getNode(), "crumb_container_select");
    });
}

BreadCrumbsWidget.prototype.CrumbClickHandler = function(Crumb, IdCrumb)
{
    "use strict";

     if(this.Data.ClickedCrumbId != IdCrumb) {
         this.Data.ClickedCrumbId = IdCrumb;

         const headerBlock = this.Views.BreadCrumbsContainer.getParentView().getNode();

         const clickedCrumb = Crumb.getNode(IdCrumb);

         this.SetLeftResizerWidth(headerBlock, clickedCrumb);

         this.RefreshPopupList(this.Dictionaries.CrumbDictionaryId.get(IdCrumb));

         this.ShowPopupWindow(headerBlock);

         webix.html.addCss(Crumb.getParentView().getNode(), "crumb_container_select");
     }
}
BreadCrumbsWidget.prototype.SetLeftResizerWidth = function(HeaderBlock, ClickedCrumb)
{
    "use strict";

    this.Views.BreadCrumbsLeftResizer.define("width", ClickedCrumb.offsetLeft - HeaderBlock.clientLeft);
    this.Views.BreadCrumbsLeftResizer.resize();
}

BreadCrumbsWidget.prototype.ShowPopupWindow = function(HeaderBlock)
{
    "use strict";

    this.Views.BreadCrumbsPopupWindow.define("maxWidth", document.documentElement.clientWidth - this.Views.LeftSideBar.getNode().clientWidth);
    this.Views.BreadCrumbsPopupWindow.setPosition(this.Views.LeftSideBar.getNode().clientWidth, HeaderBlock.clientHeight);

    this.Views.BreadCrumbsPopupWindow.resize();
    this.Views.BreadCrumbsPopupWindow.show();
}

BreadCrumbsWidget.prototype.SelectPopupListItem = function(Id)
{
    "use strict";

    let selectedItem = null;

    this.Data.LeftSideBarData.forEach(sideBarNode => {
        const sideBarItem = sideBarNode.data.find(item => item.id == Id);

        if (sideBarNode.id == Id) {
            selectedItem = sideBarNode.data[0].id;
        } else if (sideBarItem) {
            selectedItem = sideBarItem.id;
        }
    });

    selectedItem?this.RenderPage(selectedItem):App.SessionManager.SetCurrentHardwareId(Id);
}

BreadCrumbsWidget.prototype.RefreshPopupList = function (IdCrumb)
{
    "use strict";

    let popupListItems = null;

    this.Data.LeftSideBarData.forEach(sideBarNode => {
        const sideBarItem = sideBarNode.data.find(item => item.id == IdCrumb);

        if (sideBarNode.id == IdCrumb) {
            popupListItems = this.GetDataForPopupList(this.Data.LeftSideBarData, IdCrumb);
        } else if (sideBarItem) {
            popupListItems = this.GetDataForPopupList(sideBarNode.data, IdCrumb);
        }
    });

    if (popupListItems) {
        this.SetPopupListData(popupListItems, "Go to the section");
    } else {
        const dicId = "HardwaresDic";
        const displayedHardwareType = "dpi";

        const dpiList = App.DicsManager.GetDicAsArray(dicId).filter(item => item.hardware_type == displayedHardwareType);
        this.SetPopupListData(this.GetDataForPopupList(dpiList, IdCrumb), "Choose device");
    }
}

BreadCrumbsWidget.prototype.RenderPage = function(Id)
{
    "use strict";

    if (!this.Data.LeftSideBarData.some(sideBarNode => sideBarNode.id == Id) && Id.replace("_", "") !== this.Id) {
        setTimeout(function () {
            App.NavRouter.PresentView({id: Id.replace("_", ""), topMenuId: Id.replace("_", "")});
        }, 1);
    }
}

BreadCrumbsWidget.prototype.SetPopupListData = function(Items, ChapterCaption)
{
    "use strict";

    this.Views.BreadCrumbsPopupListChapter.setValues(LangHelper.GetString(this.Id, ChapterCaption));

    this.RenderPopupListItems(Items);
}

BreadCrumbsWidget.prototype.GetDataForPopupList = function(Data, IdCrumb)
{
    "use strict";

    let data = [];

    Data.forEach(item => {
        item.isSelected = false;

        if(item.id == IdCrumb) {
            item.isSelected = true;
        }

        data.push(item);
    });
    return data;
}

BreadCrumbsWidget.prototype.GetPopupListItemTemplate = function(Item)
{
    "use strict";

    const href = this.GetItemHref(Item);

    if(Item.isSelected) {
        if(href) {
            return `<div class=\"crumb_list__item crumb_list__item_selected font_stolzl_regular\"><a href="${href}" onclick="return false" class=\"crumb_list__caption\">${Item.value}</a><span class=\"fa fa-check\"></span><div class="crumb_list__semi_transparent_background"></div></div>`;
        }
        return `<div class=\"crumb_list__item crumb_list__item_selected font_stolzl_regular\"><span class=\"crumb_list__caption\">${Item.value}</span><span class=\"fa fa-check\"></span><div class="crumb_list__semi_transparent_background"></div></div>`;
    }
    else {
        if(href) {
            return `<div class=\"crumb_list__item font_stolzl_book\"><a href="${href}" onclick="return false" class=\"crumb_list__caption\">${Item.value}</a><div class="crumb_list__semi_transparent_background"></div></div>`;
        }
        return `<div class=\"crumb_list__item font_stolzl_book\"><span class=\"crumb_list__caption\">${Item.value}</span><div class="crumb_list__semi_transparent_background"></div></div>`;
    }
}

BreadCrumbsWidget.prototype.GetItemHref = function(Item)
{
    if(Item.href) {
        return Item.href;
    }

    if(Item.data) {
        return Item.data[0].href;
    }

    return null;
}

BreadCrumbsWidget.prototype.ChapterItemTemplate = function(Value)
{
    "use strict";

    return `<div class=\"crumb_chapter__item font_stolzl_regular\"><span class=\"crumb_chapter__caption\">${Value}</span></div>`;
}

BreadCrumbsWidget.prototype.CrumbTemplate = function(Data)
{
    "use strict";

    return `<span class=\"crumb_container__caption font_stolzl_regular\">${Data.value}</span>`;
}
function SidebarCollapseButtonWidget(ViewConfig)
{
    "use strict";

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
      SidebarMain: null,
      SidebarHeader: null,
      TopHeader: null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}
SidebarCollapseButtonWidget.prototype.Init = function(ViewConfig) {
    "use strict";

    const _this = this;

    this.Id = ViewConfig.id;

    this.SidebarCollapsePreferenceId = "Collapsed";

    this.ViewConfig = {
        view: "button",
        id: this.Id,
        css: "app_sidebar_collapse_button",
        type: "icon",
        icon: "bars",
        align: "right",
        padding: 0,
        margin: 0,
        width: 40,
        click: function () {
            _this.SetSidebarState();
        }
    }
}

SidebarCollapseButtonWidget.prototype.BindAll = function ()
{
    "use strict";

    Object.keys(this.Views).forEach(View => {
        this.Views[View] = $$(View);
    });

    this.Subscriptions.SessionManagerCollpsedPreferenseChange = App.SessionManager.SetPreferenceSignal.subscribe(Val => {
        this.SetPreferenceHandler(Val);
    });

    this.SetSidebarInitialState();
}

SidebarCollapseButtonWidget.prototype.Destroy = function ()
{
    Object.keys(this.Subscriptions).forEach(Key => {
       this.Subscriptions[Key].unsubscribe();
    });
}

SidebarCollapseButtonWidget.prototype.SetSidebarInitialState = function ()
{
    "use strict";

    let collapsed = parseInt(App.SessionManager.GetPreference(this.SidebarCollapsePreferenceId));
    collapsed?this.CollapseSidebar():this.ExpandSidebar();
}

SidebarCollapseButtonWidget.prototype.SetSidebarState = function ()
{
    "use strict";

    let collapsed = parseInt(App.SessionManager.GetPreference(this.SidebarCollapsePreferenceId));

    App.SessionManager.SetPreference(this.SidebarCollapsePreferenceId, collapsed ? 0 : 1);
}

SidebarCollapseButtonWidget.prototype.ExpandSidebar = function ()
{
    "use strict";

    this.Views.TopHeader.removeView(this.Id);
    this.Views.SidebarMain.show();

    let numberInLayout = this.Views.SidebarHeader.getChildViews().length;
    this.Views.SidebarHeader.addView(this.ViewConfig, numberInLayout);
}

SidebarCollapseButtonWidget.prototype.CollapseSidebar = function ()
{
    "use strict";

    this.Views.SidebarHeader.removeView(this.Id);
    this.Views.TopHeader.addView(this.ViewConfig, 0);
    this.Views.SidebarMain.hide();
}

SidebarCollapseButtonWidget.prototype.SetPreferenceHandler = function (Id)
{
    "use strict";

    if (Id && Id == this.SidebarCollapsePreferenceId) {
        let collapsed = parseInt(App.SessionManager.GetPreference(Id));

        collapsed ? this.CollapseSidebar():this.ExpandSidebar();
    }
}
function AppMainMenuWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.MenuData = [
        {
            id: "TopMenu", $css:"top_root_item", icon: "bars", value: "",
            submenu:[
                {
                    id: "DpiPerformance_",
                    icon: "server",
                    value: LangHelper.GetString(this.Id, "DPI control"), /*href:"#DpiPerformance",*/ section:RoleSectionsEnum.performance,
                    submenu:[
                        {
                            id: "DpiPerformance", icon: "tachometer", value: LangHelper.GetString(this.Id, "Performance"), href:"#DpiPerformance", section:RoleSectionsEnum.performance
                        },
                        {
                            id: "DpiConfig", icon: "server", value: LangHelper.GetString(this.Id, "Configuration"), href:"#DpiConfig", section:RoleSectionsEnum.config
                        },
                        {
                            id: "DpiDscpConfig", icon: "sort-numeric-asc", value: LangHelper.GetString(this.Id, "Protocol prioritization (DSCP)"), href:"#DpiDscpConfig", section:RoleSectionsEnum.config
                        },
                        {
                            id: "DpiAsnDscpConfig", icon: "sort-alpha-asc", value: LangHelper.GetString(this.Id, "Priority for ASN"), href:"#DpiAsnDscpConfig", section:RoleSectionsEnum.config
                        },
                        {
                            id: "DpiLogs", icon: "stack-overflow", value: LangHelper.GetString(this.Id, "Logs"), href:"#DpiLogs", section:RoleSectionsEnum.logs
                        },
                        // {
                        //     id: "Test", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Test"), section:RoleSectionsEnum.performance
                        // }
                    ]
                },
                {
                    id: "Subscribers_", icon: "cogs", value: LangHelper.GetString(this.Id, "Services control"), /*href:"#Subscribers",*/ section:RoleSectionsEnum.subscribers,
                    submenu: [
                        {id: "Subscribers", icon: "users", value: LangHelper.GetString(this.Id, "Subscribers and services"), href:"#Subscribers", section:RoleSectionsEnum.subscribers},
                        {id: "Services", icon: "cogs", value: LangHelper.GetString(this.Id, "Services"), href:"#Services", section:RoleSectionsEnum.services},
                        {id: "Tariffs", icon: "dollar", value: LangHelper.GetString(this.Id, "Tariff plans"), href:"#Tariffs", section:RoleSectionsEnum.tariffs},
                        {id: "Advc", icon: "bullhorn", value: LangHelper.GetString(this.Id, "Adv control"), href:"#Advc", section:RoleSectionsEnum.advc},
                        {id: "HotSpot", icon: "wifi", value: LangHelper.GetString(this.Id, "HotSpot"), href:"#HotSpot", section: RoleSectionsEnum.services}
                    ]},
                {
                    id: "QoEDashboard_", icon: "monitor-heart-rate", value: LangHelper.GetString(this.Id, "QoE analytics"), /*href:"#QoEDashboard",*/ section:RoleSectionsEnum.qoeanalytics,
                    submenu: [
                        {id: "QoEDashboard", icon: "braille", value: LangHelper.GetString(this.Id, "QoE dashboard"), href:"#QoEDashboard", section:RoleSectionsEnum.qoeanalytics_dashboard},
                        {id: "QoEFullNetFlow_", icon: "fullflow", value: LangHelper.GetString(this.Id, "Netflow"), href:"#QoEFullNetFlow", section:RoleSectionsEnum.qoeanalytics_fullnetflow,
                            submenu: [
                                {id: "QoEFullNetFlow", icon: "fullflow", value: LangHelper.GetString(this.Id, "Netflow"), href:"#QoEFullNetFlow", section:RoleSectionsEnum.qoeanalytics_fullnetflow},
                                {id: "QoERawFullNetFlow", icon: "rawfullflow", value: LangHelper.GetString("AppView", "Raw full netflow"), href:"#QoERawFullNetFlow", section:RoleSectionsEnum.qoeanalytics_rawfullnetflow}
                            ]
                        },
                        {id: "QoEClickStream_", icon: "clickstream", value: LangHelper.GetString(this.Id, "Clickstream"), href:"#QoEClickStream", section:RoleSectionsEnum.qoeanalytics_clickstream,
                            submenu: [
                                {id: "QoEClickStream", icon: "clickstream", value: LangHelper.GetString(this.Id, "Clickstream"), href:"#QoEClickStream", section:RoleSectionsEnum.qoeanalytics_clickstream},
                                {id: "QoERawClickstream", icon: "rawclickstream", value: LangHelper.GetString("AppView", "Raw clickstream"), href:"#QoERawClickstream", section:RoleSectionsEnum.qoeanalytics_rawclickstream}
                            ]
                        },
                        {id: "QoEFullGtpFlow_", icon: "broadcast-tower", value: LangHelper.GetString(this.Id, "Gtp flow"), href:"#QoEFullGtpFlow", section:RoleSectionsEnum.qoeanalytics_gtp,
                            submenu: [
                                {id: "QoEFullGtpFlow", icon: "broadcast-tower", value: LangHelper.GetString(this.Id, "Gtp flow"), href:"#QoEFullGtpFlow", section:RoleSectionsEnum.qoeanalytics_gtp},
                                {id: "QoERawFullGtpFlow", icon: "broadcast-tower", value: LangHelper.GetString("AppView", "Raw Gtp flow"), href:"#QoERawFullGtpFlow", section:RoleSectionsEnum.qoeanalytics_rawgtp}
                            ]
                        },
                        {id: "QoEFullNatFlow_", icon: "exchange", value: LangHelper.GetString(this.Id, "NAT flow"), href:"#QoEFullGtpFlow", section:RoleSectionsEnum.qoeanalytics_gtp,
                            submenu: [
                                {id: "QoEFullNatFlow", icon: "exchange", value: LangHelper.GetString(this.Id, "NAT flow"), href:"#QoEFullNatFlow", section:RoleSectionsEnum.qoeanalytics_nat},
                                {id: "QoERawFullNatFlow", icon: "exchange", value: LangHelper.GetString("AppView", "Raw NAT flow"), href:"#QoERawFullNatFlow", section:RoleSectionsEnum.qoeanalytics_rawnat}
                            ]
                        },
                        {id: "QoEFullDnsFlow_", icon: "globe", value: LangHelper.GetString(this.Id, "DNS flow"), href:"#QoEFullDnsFlow", section:RoleSectionsEnum.qoeanalytics_dns,
                            submenu: [
                                {id: "QoEFullDnsFlow", icon: "globe", value: LangHelper.GetString("AppView", "DNS flow"), href:"#QoEFullDnsFlow", section:RoleSectionsEnum.qoeanalytics_dns},
                                {id: "QoERawFullDnsFlow", icon: "globe", value: LangHelper.GetString("AppView", "Raw DNS flow"), href:"#QoERawFullDnsFlow", section:RoleSectionsEnum.qoeanalytics_rawdns}
                            ]
                        },
                        {id: "QoEFullDdosAttackFlow_", icon: "shield-check", value: LangHelper.GetString(this.Id, "DDoS attacks"), href:"#QoEFullDnsFlow", section:RoleSectionsEnum.qoeanalytics_dns,
                            submenu: [
                                {id: "QoEFullDdosAttackFlow", icon: "shield-check", value: LangHelper.GetString("AppView", "DDoS attacks"), href:"#QoEFullDdosAttackFlow", section:RoleSectionsEnum.qoeanalytics_ddos_attack},
                                {id: "QoERawFullDdosAttackFlow", icon: "shield-check", value: LangHelper.GetString("AppView", "DDoS attacks log"), href:"#QoERawFullDdosAttackFlow", section:RoleSectionsEnum.qoeanalytics_raw_ddos_attack}
                            ]
                        },
                        {id: "QoESubscribers", icon: "qoesubscribers", value: LangHelper.GetString(this.Id, "Subscribers"), href:"#QoESubscribers", section:RoleSectionsEnum.qoeanalytics_subscribers},
                        {id: "QoEOnlineReports", value: LangHelper.GetString(this.Id, "Online reports"), href:"#QoEOnlineReports", section:RoleSectionsEnum.qoeanalytics_online_reports},
                        {id: "QoETriggers", icon: "bell", value: LangHelper.GetString("AppView", "Triggers & Alerts"), href:"#QoETriggers", section:RoleSectionsEnum.qoeanalytics_triggers},
                        {id: "QoECustomReports", icon: "user-tag", value: LangHelper.GetString("AppView", "Custom reports"), href:"#QoEFullNatFlow", section:RoleSectionsEnum.qoeanalytics_customreports},
                        {id: "QoEUserReports", icon: "plus", value: LangHelper.GetString("AppView", "My reports"), href:"#QoEUserReports", section:RoleSectionsEnum.qoeanalytics_reports_manager},
                        {id: "QoEMailingTemplates", icon: "plus", value: LangHelper.GetString("AppView", "Mailing templates"), href:"#QoEMailingTemplates", section:RoleSectionsEnum.qoeanalytics_mailing_templates},
                        {id: "QoEAdmin", icon: "cogs", value: LangHelper.GetString("AppView", "Administrator"), href:"#QoEAdmin", section:RoleSectionsEnum.qoeanalytics_admin}
                    ]
                },
                {
                    id: "VasCloudPersonalArea_", icon: "cloud", value: LangHelper.GetString("VasCloud", "Vas cloud services"), /*href:"#VasCloudPersonalArea",*/ section:RoleSectionsEnum.vascloud,
                    submenu: [
                        {id: "VasCloudPersonalArea", icon: "user", value: LangHelper.GetString("VasCloud", "Personal area"), href:"#VasCloudPersonalArea", section:RoleSectionsEnum.vascloud
                            // ,
                            // data:[
                            //     {id: "VasCloudPersonalArea", icon: "user", value: LangHelper.GetString("VasCloud", "Account"), href:"#VasCloudPersonalArea"},
                            //     {id: "VasCloudBillingInfo", icon: "money-check-alt", value: LangHelper.GetString("VasCloud", "Billing information"), href:"#VasCloudBillingInfo"}
                            // ]
                        },
                        {id: "VasCloudAds_", icon: "bullhorn", value: LangHelper.GetString("VasCloud", "Vas Ads"), href:"#VasCloudAds", section:RoleSectionsEnum.vascloud,
                            submenu:[
                                {id: "VasCloudAds", icon: "bullhorn", value: LangHelper.GetString("VasCloud", "Vas Ads"), href:"#VasCloudAds", section:RoleSectionsEnum.vascloud},
                                {id: "VasCloudAdsStatistics", icon: "chart-bar", value: LangHelper.GetString("AppView", "Statistics"), href:"#VasCloudAdsStatistics", section:RoleSectionsEnum.vascloud},
                                {id: "VasCloudAccrualsAndPayments", icon: "file-invoice", value: LangHelper.GetString("AppView", "Accruals and payments"), href:"#VasCloudAccrualsAndPayments", section:RoleSectionsEnum.vascloud}
                            ]
                        },
                        {id: "VasCloudProtocols_", icon: "network-wired", value: LangHelper.GetString("Protocols", "Protocols"), href:"#VasCloudProtocols", section:RoleSectionsEnum.vascloud,
                            submenu:[
                                {id: "VasCloudProtocolsCustom", icon: "network-wired", value: LangHelper.GetString("Protocols", "Custom Protocols"), href:"#VasCloudProtocolsCustom", section:RoleSectionsEnum.vascloud},
                                {id: "VasCloudCustomProtocolsGroups", icon: "network-wired", value: LangHelper.GetString("CustomProtocolsGroups", "Custom protocols groups"), href:"#VasCloudCustomProtocolsGroups", section:RoleSectionsEnum.vascloud},
                                {id: "VasCloudProtocolsLogs", icon: "stack-overflow", value: LangHelper.GetString("VasCloud", "Logs"), href:"#VasCloudProtocolsLogs", section:RoleSectionsEnum.vascloud}
                            ]
                        }
                        // ,
                        // {id: "VasCloudShop", icon: "shopping-bag", value: LangHelper.GetString("VasCloud", "License shop"), href:"#VasCloudShop",
                        //     data:[
                        //         {id: "VasCloudShop", icon: "shopping-bag", value: LangHelper.GetString("VasCloud", "Catalog")},
                        //         {id: "VasCloudShopMyOrders", icon: "clipboard-list", value: LangHelper.GetString("VasCloud", "My orders")}
                        //     ]
                        // }
                    ]
                },
                {
                    id: "ConnectionsValidateData_", icon: "plug", value: LangHelper.GetString("AppView","Lawful interception"), /*href:"#ConnectionsValidateData",*/ section:RoleSectionsEnum.li,
                    submenu:[
                        {id: "ConnectionsValidateData", icon: "plug", value: LangHelper.GetString("AppView","Connections"), href:"#ConnectionsValidateData", section:RoleSectionsEnum.li_connections},
                        {id: "TrafficManagementGenerator", icon: "bolt", value: LangHelper.GetString("AppView","Traffic generation"), href:"#TrafficManagementGenerator", section:RoleSectionsEnum.li_t_generation},
                        {id: "TrafficManagementCapture", icon: "camera", value: LangHelper.GetString("AppView", "Traffic capture"), href:"#TrafficManagementCapture", section:RoleSectionsEnum.li_t_capture},
                        {id: "TrafficManagementSiteClone", icon: "clone", value: LangHelper.GetString("AppView", "Cloning a website"), href:"#TrafficManagementSiteClone", section:RoleSectionsEnum.li_site_clone},
                        {id: "NetworkAudit", icon: "sitemap", value: LangHelper.GetString("AppView", "Network audit"), href:"#NetworkAudit", section:RoleSectionsEnum.li_n_audit},
                        {
                            id: "TrafficDecode_",
                            icon: "router",
                            value: LangHelper.GetString("AppView", "Traffic decode"),
                            href:"#TrafficDecode", section:RoleSectionsEnum.li_traffic_decode,
                            submenu: [
                                {id: "TrafficDecode", icon: "router", value: LangHelper.GetString("AppView", "Traffic decode"), href:"#TrafficDecode", section:RoleSectionsEnum.li_traffic_decode},
                                {id: "TrafficDecodeLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Traffic decode logs"), href:"#TrafficDecodeLogs", section:RoleSectionsEnum.li_traffic_decode}
                            ]
                        },
                        {id: "LiHealth", icon: "heartbeat", value: LangHelper.GetString("AppView", "Health map"), href:"#LiHealth", section:RoleSectionsEnum.li_health}
                    ]
                },
                {
                    id: "_Classifier", icon: "list", value: LangHelper.GetString("AppView", "Classifier"), /*href:"#Classifier",*/ section:RoleSectionsEnum.sites_clsfr,
                    submenu:[
                        {id: "Classifier", icon: "sitemap", value: LangHelper.GetString("Classifier", "Hosts Categories"), href:"#Classifier", section:RoleSectionsEnum.sites_clsfr},
                        {id: "ClassifierModel", icon: "hexagon", value: LangHelper.GetString("Classifier", "Classifier model"), href:"#ClassifierModel", section:RoleSectionsEnum.sites_clsfr_model},
                        {id: "ClassifierConfig", icon: "server", value: LangHelper.GetString(this.id, "Configuration"), href:"#ClassifierConfig", section:RoleSectionsEnum.sites_clsfr_admin},
                        {id: "ClassifierLogs", icon: "stack-overflow", value: LangHelper.GetString(this.Id, "Logs"), href:"#ClassifierLogs", section:RoleSectionsEnum.sites_clsfr_admin}
                    ]
                },
                {
                    id: "Hardwares_", icon: "user-cog", value: LangHelper.GetString(this.Id, "Administrator"), /*href:"#Hardwares",*/ section:RoleSectionsEnum.administrator,
                    submenu:[
                        {id: "Hardwares", icon: "list", value: LangHelper.GetString("Hardwares", "Equipment"), href:"#Hardwares", section:RoleSectionsEnum.hardware},
                        {id: "HardwareSshKeys", icon: "key", value: LangHelper.GetString("HardwareSshKeys", "SSH keys"), href:"#HardwareSshKeys", section:RoleSectionsEnum.hardware_ssh_keys},
                        {$template: "Separator", section:RoleSectionsEnum.administrator_users},
                        {id: "Users", icon: "users", value: LangHelper.GetString("AppView", "Users"), href:"#Users", section:RoleSectionsEnum.administrator_users},
                        {id: "Roles", icon: "user-secret", value: LangHelper.GetString("AppView", "Roles"), href:"#Roles", section:RoleSectionsEnum.administrator_roles},
                        {id: "UsersActionsLog", value: LangHelper.GetString("AppView", "Users actions log"), href:"#UsersActionsLog", section:RoleSectionsEnum.administrator_users_actions_log},
                        {$template: "Separator", section:RoleSectionsEnum.administrator_dpiui2},
                        {
                            id: "Dpiui2Config_", icon: "server", value: LangHelper.GetString("AppView", "DPIUI2 (GUI) server configuration"), /*href:"#Dpiui2Config",*/ section:RoleSectionsEnum.administrator_dpiui2,
                            submenu: [
                                {id: "Dpiui2Config", icon: "server", value: LangHelper.GetString("AppView", "DPIUI2 (GUI) server configuration"), href:"#Dpiui2Config", section:RoleSectionsEnum.administrator_dpiui2},
                                {id: "Dpiui2Logs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "DPIUI2 logs"), href:"#Dpiui2Logs", section:RoleSectionsEnum.administrator_dpiui2},
                                {id: "Dpiui2Update", icon: "scrubber", value: LangHelper.GetString("AppView", "DPIUI2 (GUI) update"), href:"#Dpiui2Update", section:RoleSectionsEnum.administrator_dpiui2},
                            ]

                        },
                        {$template: "Separator", section:RoleSectionsEnum.administrator_dpiui2},
                        {
                            id: "QoEStorConfig_", icon: "server", value: LangHelper.GetString("AppView", "QoE Stor (fastor) server configuration"), /*href:"#QoEStorConfig",*/ section:RoleSectionsEnum.administrator_dpiui2,
                            submenu: [
                                {id: "QoEStorConfig", icon: "server", value: LangHelper.GetString("AppView", "QoE Stor (fastor) server configuration"), href:"#QoEStorConfig", section:RoleSectionsEnum.administrator_dpiui2},
                                {id: "QoEStorLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "QoE Stor (fastor) logs"), href:"#QoEStorLogs", section:RoleSectionsEnum.administrator_dpiui2}
                            ]
                        },
                        {$template: "Separator", section:RoleSectionsEnum.administrator_dpiui2},
                        {
                            id: "FastPcrfConfig_", icon: "server", value: LangHelper.GetString("AppView", "Fast PCRF (fastpcrf) server configuration"), /*href:"#FastPcrfConfig",*/ section:RoleSectionsEnum.administrator_dpiui2,
                            submenu:[
                                {id: "FastPcrfConfig", icon: "server", value: LangHelper.GetString("AppView", "Fast PCRF (fastpcrf) server configuration"), href:"#FastPcrfConfig", section:RoleSectionsEnum.administrator_dpiui2},
                                {id: "FastPcrfLogs", icon: "stack-overflow", value: LangHelper.GetString("AppView", "Fast PCRF (fastpcrf) logs"), href:"#FastPcrfLogs", section:RoleSectionsEnum.administrator_dpiui2}
                            ]
                        }
                    ]
                },
                {
                    id: "HardwareSshTerminal_", icon: "terminal", value: LangHelper.GetString(this.Id, "Hardware ssh terminal"), section:RoleSectionsEnum.ssh_terminal,
                    submenu:[
                        {
                            id: "HardwareSshTerminal", icon: "terminal", value: LangHelper.GetString(this.Id, "Hardware ssh terminal"), href:"#HardwareSshTerminal", section:RoleSectionsEnum.ssh_terminal
                        }
                    ]
                }
            ]
        }
    ];

    this.Views =
    {
        Menu:null
    };

    this.Subscriptions = {};

    this.State = null;

    this.LastOpened = null;

    this.Init(ViewConfig);
}

AppMainMenuWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "AppMainMenu";

    this.ViewConfig =
    {
        view: "menu",
        css: "app_top_menu",
        id: this.Id + "Menu",
        padding: 0,
        borderless: true,
        data: webix.copy(this.MenuData),
        autowidth: true,
        width: 67,
        //height: 60,
        //openAction:"click",
        type: {
            subsign: true
        },
        on: {
            onMenuItemClick: function (Id, E)
            {
                //E.stopPropagation();
                E.preventDefault();

                var sub = this.getSubMenu(Id);
                var menu = this.getMenu(Id);

                if (sub && !sub.isVisible())
                {
                    setTimeout(function ()
                    {
                        if(Id != "TopMenu")
                        {
                            if(_this.LastOpened && _this.LastOpened.config.id != menu.config.id)
                            {
                                _this.LastOpened.hide();
                            }

                            _this.LastOpened = sub;
                        }

                        sub.show(E.target, {pos:"right"});
                    },1);
                }

                if(Id == "TopMenu")
                    return false;

                if(Id && Id.indexOf("_") >= 0)
                    return false;

                if (Id === "SubscribersNew")
                {
                    App.NavRouter.PresentModalView({
                        id: "SubscriberEditForm"
                    })
                }
                else {

                    var params = Id.split("/");

                    var id = params[0];

                    id = id.replace("_","");

                    var path = null;

                    if(params.length > 1)
                    {
                        params.shift();

                        path = "/" + params.join("/");
                    }

                    App.NavRouter.PresentView({id: id, topMenuId: this.Qc.replace("_",""), path:path});
                }

                this.getSubMenu("TopMenu").hide();

                return false;

            },

            onItemClick: function (Id, E)
            {
                E.stopPropagation();
                E.preventDefault();

                return false;
            }
        }
    };
};

AppMainMenuWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    this.HideRestrictedMenuItems();
};

AppMainMenuWidget.prototype.Destroy = function ()
{
    var _this = this;

    this.LastOpened = null;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

AppMainMenuWidget.prototype.HideRestrictedMenuItems = function ()
{
    Helper.HideRestrictedMenuItems(this.MenuData, this.Views.Menu);
};

AppMainMenuWidget.prototype.Select = function (MenuItemId)
{
    this.Views.Menu.select(MenuItemId);
};

AppMainMenuWidget.prototype.UnselectAll = function ()
{
    this.Views.Menu.unselectAll();
};
var HardwareSwitchWidgetIndicatorActionsEnum =
{
    OpenHardwaresSection:"OpenHardwaresSection",
    OpenWiki:"OpenWiki",
    NoAction:"NoAction",
    RestartFastDPI:"RestartFastDPI",
    OpenMessagesPopup:"OpenMessagesPopup"
};

var HardwareSwitchWidgetIndicatorColorsEnum =
    {
        "label_vas_color":"label_vas_color",
        "label_warning_color":"label_warning_color",
        "label_error_color":"label_error_color"
    };

var HardwareSwitchWidgetIndicatorColorsDic =
{
    "1":"label_vas_color",
    "2":"label_warning_color",
    "3":"label_error_color"
};

var HardwareSwitchWidgetIndicatorIconsEnum = {
    "scrubber":"scrubber",
    "exclamation-circle":"exclamation-circle"
};

var HardwareSwitchWidgetIndicatorIconsDic = {
    "1":"scrubber",
    "2":"exclamation-circle",
    "3":"exclamation-circle"
};

function HardwareSwitchWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        TitleLabel:null,
        ActionMenu:null,
        IndicatorLabel:null,
        Tooltip:null,
        Cols:null,
        HardwaresTable:null,
        Msgs:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

HardwareSwitchWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "HardwareSwitch";

    this.DpiMenuViewPopupId = this.Id + "DpiMenuViewPopup";
    this.DpiMenuViewPopupConfig = {
        view: "submenu",
        id: this.DpiMenuViewPopupId,
        width: 200,
        autowidth: true,
        padding: 0,
        data: [
            {id: "RestartDpi", icon: "retweet", value: LangHelper.GetString(this.Id, "Restart fastdpi")},
            {id: "ReloadDpi", icon: "bolt", value: LangHelper.GetString(this.Id, "Updating hot options")},
            {id: "DpiInfo", icon: "info-circle", value: LangHelper.GetString(this.Id, "Device information")},
            {id: "LicenseInfo", icon: "file-certificate", value: LangHelper.GetString(this.Id, "License information")},
            {$template: "Separator"},
            {id: "HardwaresSearch", icon: "search", value: LangHelper.GetString(this.Id, "Select from list")},
            {$template: "Separator"},
            {id: "Hardwares", icon: "list", value: LangHelper.GetString(this.Id, "Managing the list of devices")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();
                if(id === "Hardwares")
                {
                    App.NavRouter.PresentView({id: id});
                }
                else if(id === "HardwaresSearch")
                {
                    setTimeout(function ()
                    {
                        //var node = _this.Views.TitleLabel.getNode();
                        var node = _this.Views.ActionMenu.getNode();
                        _this.HardwareSearchContext.show(node, {pos: "bottom"});
                    }, 10);
                }
                else if(id === "RestartDpi")
                {
                    setTimeout(function ()
                    {
                        //var node = _this.Views.TitleLabel.getNode();
                        var node = _this.Views.ActionMenu.getNode();
                        _this.HardwareRestartContext.show(node, {pos: "bottom"});
                    }, 10);
                }
                else if(id === "ReloadDpi")
                {
                    setTimeout(function ()
                    {
                        //var node = _this.Views.TitleLabel.getNode();
                        var node = _this.Views.ActionMenu.getNode();
                        _this.HardwareReloadContext.show(node, {pos: "bottom"});
                    }, 10);
                }
                else if(id === "DpiInfo")
                {
                    setTimeout(function ()
                    {
                        _this.DpiInfoContext = new DpiInfoViewController({InContext:true, HasNewFastDPIVersion: _this.NewVersionFastDPI});
                        _this.DpiInfoContext.ViewDidLoad();
                        //var node = _this.Views.TitleLabel.getNode();
                        var node = _this.Views.ActionMenu.getNode();
                        _this.DpiInfoContext.Show(node, {pos: "bottom"});
                    }, 10);


                }
                else if(id === "LicenseInfo")
                {
                    setTimeout(function ()
                    {
                        _this.LicenseInfoContext = new LicenseInfoViewController({InContext:true});
                        _this.LicenseInfoContext.ViewDidLoad();
                        //var node = _this.Views.TitleLabel.getNode();
                        var node = _this.Views.ActionMenu.getNode();
                        _this.LicenseInfoContext.Show(node, {pos: "bottom"});
                    }, 10);


                }
                else
                {
                    webix.message(LangHelper.GetString(_this.Id, "In developing"));
                }
            }
        }
    };
    this.DpiMenuViewPopup = webix.ui(this.DpiMenuViewPopupConfig);

    this.HardwareSearchContextId = this.Id + "HardwareSearchContext";
    this.HardwareSearchContextConfig = {
        view: "popup",
        width: 640,
        height: 320,
        id:this.HardwareSearchContextId,
        body: {
            rows:[
                {
                    view: "datatable",
                    borderless:true,
                    id:this.Id + "HardwaresTable",
                    editable: true,
                    editaction: "custom",
                    select: "row",
                    on: {
                        onItemClick: function (Id)
                        {
                            var __this = this;
                            setTimeout(function ()
                            {
                                var data = __this.getItem(Id);
                                App.SessionManager.SetCurrentHardwareId(data.dic_id);
                            }, 1);

                            _this.HardwareSearchContext.hide();
                        }
                    },
                    columns: [
                        {
                            id: "value",
                            header: [LangHelper.GetString("AppView", "Name"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            editor:"text",
                            fillspace: true
                        },
                        {
                            id: "ip",
                            header: ["Ip",{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            editor:"text",
                            fillspace: true
                        },
                        {
                            id: "port",
                            header: [LangHelper.GetString("AppView", "Port"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            editor:"text",
                            fillspace: true
                        },
                        {
                            id: "login",
                            header: [LangHelper.GetString("AppView", "Login"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            editor:"text",
                            fillspace: true
                        }
                    ],
                    data:[]
                }
            ]
        }
    };
    this.HardwareSearchContext = webix.ui(this.HardwareSearchContextConfig);

    this.HardwareRestartContext = webix.ui({
        view:"popup",
        width:420,
        height:160,
        zIndex:105,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("AppView", "Are you sure you want to restart the fastdpi process?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("AppView", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("AppView", "Restart"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                                App.SessionManager.RestartHardware();
                            }
                        }
                    ]
                }
            ]
        }
    });
    this.HardwareReloadContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("AppView", "Are you sure you want to update the hot settings?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("AppView", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("AppView", "Refresh"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                                App.SessionManager.ReloadHardware();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.MsgsPopupId = this.Id + "MsgsPopup";
    this.MsgsPopupConfig = {
        view: "popup",
        width: 300,
        id:this.MsgsPopupId,
        body: {
            rows:[
                {
                    view: "datatable",
                    borderless:true,
                    id:this.Id + "Msgs",
                    header: false,
                    columns: [
                        {
                            id: "icon",
                            width:32,
                            template:function (Obj)
                            {
                                return '<span class="webix_icon fa-' + Obj.icon + ' ' + Obj.color + '"></span>';
                            }
                        },
                        {
                            id: "value",
                            fillspace: true
                        },
                        {
                            id: "action",
                            width:32,
                            template:function (Obj)
                            {
                                return '<span class="webix_icon webix_el_icon fa-arrow-right"></span>';
                            }
                        }
                    ],
                    data:[],
                    on:
                    {
                        onItemClick: function (Id)
                        {
                            if(Id.column != "action")
                                return;

                            var rowData = this.getItem(Id);

                            if(rowData.action)
                            {
                                if(_this[rowData.action + "Action"])
                                    _this[rowData.action + "Action"]();
                            }
                        }
                    }
                }
            ]
        }
    };
    this.MsgsPopup = webix.ui(this.MsgsPopupConfig);

    this.DpiIconViewConfig =
    {
        id: this.Id + "Cols",
        css:"hw_switch_wrapper",
        cols:[
            // {
            //     id: this.Id + "TitleLabel",
            //     view:"template",
            //     css: "header_dpi app_title_header",
            //     borderless: true,
            //     data: {hw_title:""},
            //     template: function (Data)
            //     {
            //         var html = "";
            //
            //         html += "<div style='height:100%;width:100%; white-space: nowrap;'>";
            //
            //         html += "<span class='app_title'>" + LangHelper.GetString("AppView", "Title") + "</span>";
            //
            //         if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.hardware))
            //         {
            //             html += "<span class='splitter'>:</span>";
            //             html += "<span class='dpi_title' onclick='webix.$$(\"" + _this.DpiMenuViewPopupId+"\").show(this)'>" + Data.hw_title + "<span class='webix_icon fa-angle-down'></span>" + "</span>";
            //         }
            //
            //         html += "</div>";
            //
            //         return html;
            //     }
            // },
            /*{
                view:"label",
                id:this.Id + "IndicatorLabel",
                label:"",
                //hidden:true,
                width:26,
                css:"hw-switch-container__label",
                click:function (Id)
                {
                    _this.OnIndicatorClick();
                }
            }*/
            {
                css: "hw_switch",
                cols: [
                    {
                        css: "hw_switch__dpi_icon hw_switch_icon fa-server",
                        width: 16,
                        cols: [
                            {
                                view: "label",
                                id: this.Id + "IndicatorLabel",
                                type: "icon",
                                label: "",
                                width: 16,
                                css: "hw_switch__label",
                                click: function (Id) {
                                    _this.OnIndicatorClick();
                                }
                            }
                        ]
                    },
                ]
            },
            {
                id: this.Id + "Tooltip",
                view: "template",
                css: "hw_switch__tooltip font_stolzl_book",
                borderless: true,
                hidden:true,
                template: function(Value) {
                    return Value;
                }
            }
    ]};

    this.ActionMenuViewConfig = {
        id: this.Id + "ActionMenu",
        view: "template",
        css: "hw_switch__action_menu_icon hw_switch_icon ",
        borderless: true,
        template: function () {
            return "<span class='webix_icon fa-ellipsis-v' onclick='webix.$$(\"" + _this.DpiMenuViewPopupId + "\").show(this)'></span>";
        }
    }
};

HardwareSwitchWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    this.Subscriptions.HardwareStateUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged()
    ).subscribe(function (Val)
    {
        if(Val[0] || Val[1])
            _this.SetTitle();
    });

    this.Subscriptions.HardwareStateUpdated = App.HardwaresManager.Signals.FastdpiStateUpdated.distinctUntilChanged().subscribe(function (Val)
    {
        if(Val)
            _this.SetIndicatorState();
    });
};

HardwareSwitchWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

HardwareSwitchWidget.prototype.CalcTitleLabelWidth = function (Text)
{
    var width = webix.html.getTextSize(LangHelper.GetString("AppView", "Title"), "header_dpi-app_title").width
        + webix.html.getTextSize(Text, "header_dpi-dpi_title header_dpi-span").width
        + webix.html.getTextSize(":", "header_dpi-splitter header_dpi-span").width
        + webix.html.getTextSize("^", "webix_icon header_dpi-span").width
        + 4;

    return width;
};

HardwareSwitchWidget.prototype.DefineTitleLabel = function (Text)
{
    try
    {
        if(this.Views.TitleLabel && !this.Views.TitleLabel.$destructed)
        {
            var width = this.CalcTitleLabelWidth(Text);

            this.Views.TitleLabel.define("data",{hw_title: Text});
            this.Views.TitleLabel.define("width",width);
            this.Views.TitleLabel.resize();

            this.Views.Cols.define("width",width + 32);
            this.Views.Cols.resize();
        }

    }catch (e) {}
};

HardwareSwitchWidget.prototype.SetTitle = function ()
{
    var _this = this;

    var title = "";

    var width = 0;

    var hardwares = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

    var hardwaresArr = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hardwaresArr = hardwaresArr.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    if(hardwares&&hardwares[App.SessionManager.GetCurrentHardwareId()])
    {
        var hardware = hardwares[App.SessionManager.GetCurrentHardwareId()];

        title = hardware.value;
    }
    else
    {
        if(hardwaresArr.length)
        {
            var hardware = hardwaresArr[0];

            title = hardware.value;

            App.SessionManager.SetCurrentHardwareId(hardware.dic_id);
        }
        else
        {
            title = LangHelper.GetString("AppView", "No equipment selected");
        }
    }

    this.DefineTitleLabel(title);

    this.Views.HardwaresTable.clearAll();
    this.Views.HardwaresTable.parse(hardwaresArr);
};

HardwareSwitchWidget.prototype.DefineIndicatorLabel = function (Icon, Tip, Css)
{
    var css = "webix_el_icon " + Css;


   // this.Views.IndicatorLabel.define({label: "<span class='webix_icon fa-" + Icon + "'></span>", tooltip: Tip});
    //this.Views.IndicatorLabel.refresh();

    var node = this.Views.IndicatorLabel.getNode();

    this.Views.Tooltip.setValues(Tip);
    this.Views.Tooltip.show();

    webix.html.removeCss(node, 'webix_el_icon');
    webix.html.removeCss(node, 'label_vas_color');
    webix.html.removeCss(node, 'label_error_color');
    webix.html.removeCss(node, 'label_warning_color');

    webix.html.addCss(node, css);
};

HardwareSwitchWidget.prototype.SetIndicatorState = function ()
{
    var state = App.HardwaresManager.GetCurrentFastdpiState(); //HardwareFastdpiStateModel

    if(!state)
    {
        this.Views.IndicatorLabel.hide();
        return;
    }

    var colorLevel = 0;

    var msgs = [];

    if(!state.ssh_connected)
    {
        colorLevel = colorLevel < 3 ? 3 : colorLevel;

        msgs.push({
            msg:LangHelper.GetString("AppView", "No connection"),
            action:HardwareSwitchWidgetIndicatorActionsEnum.OpenHardwaresSection,
            icon:HardwareSwitchWidgetIndicatorIconsEnum["exclamation-circle"],
            color:HardwareSwitchWidgetIndicatorColorsEnum.label_error_color
        });
    }

    if(state.ssh_connected && !state.fastdpi_is_running)
    {
        colorLevel = colorLevel < 3 ? 3 : colorLevel;

        msgs.push({
            msg:LangHelper.GetString("AppView", "FastDPI is stopped"),
            action:HardwareSwitchWidgetIndicatorActionsEnum.RestartFastDPI,
            icon:HardwareSwitchWidgetIndicatorIconsEnum["exclamation-circle"],
            color:HardwareSwitchWidgetIndicatorColorsEnum.label_error_color
        });
    }

    if(state.ssh_connected && state.error)
    {
        colorLevel = colorLevel < 3 ? 3 : colorLevel;

        msgs.push({
            msg:LangHelper.GetString("AppView", state.error),
            action:HardwareSwitchWidgetIndicatorActionsEnum.NoAction,
            icon:HardwareSwitchWidgetIndicatorIconsEnum["exclamation-circle"],
            color:HardwareSwitchWidgetIndicatorColorsEnum.label_error_color
        });
    }

    if(state.has_new_version && state.available_version)
    {
        colorLevel = colorLevel < 1 ? 1 : colorLevel;

        msgs.push({
            msg:LangHelper.GetString("AppView", "New version FastDPI is available"),
            action:HardwareSwitchWidgetIndicatorActionsEnum.OpenWiki,
            icon:HardwareSwitchWidgetIndicatorIconsEnum.scrubber,
            color:HardwareSwitchWidgetIndicatorColorsEnum.label_vas_color
        });
    }

    if(msgs.length)
    {
        this.DefineIndicatorLabel(HardwareSwitchWidgetIndicatorIconsDic[colorLevel+""], (msgs.length > 1 ? LangHelper.GetString("AppView", "Several messages") : msgs[0].msg), HardwareSwitchWidgetIndicatorColorsDic[colorLevel+""]);
        this.Views.IndicatorLabel.show();
    }
    else
    {
        this.Views.IndicatorLabel.hide();
    }

    this.IndicatorState =
    {
        msgs:msgs
    };

};

HardwareSwitchWidget.prototype.OnIndicatorClick = function ()
{
    if(this.IndicatorState)
    {
        if(this.IndicatorState.msgs.length == 1)
        {
            var action = (this.IndicatorState.msgs[0].action);

            if(this[action + "Action"])
                this[action + "Action"]();
        }
        else
            this.OpenMsgsPopupAction();
    }
};

HardwareSwitchWidget.prototype.OpenWikiAction = function ()
{
    window.open('https://wiki.vasexperts.ru', '_blank');
};

HardwareSwitchWidget.prototype.OpenHardwaresSectionAction = function ()
{
    App.NavRouter.PresentView({id: ControllersEnum.Hardwares, topMenuId: ControllersEnum.Hardwares});
};

HardwareSwitchWidget.prototype.OpenMsgsPopupAction = function ()
{
    var _this = this;

    this.Views.Msgs.clearAll();
    this.Views.Msgs.parse(function () {
        var data = [];

        _this.IndicatorState.msgs.forEach(function (V) {
            data.push({
                id:webix.uid(),
                icon:V.icon,
                color:V.color,
                value:V.msg,
                action:V.action
            });
        });

        return data;
    }());

    this.MsgsPopup.show(this.Views.IndicatorLabel.getNode());
};

HardwareSwitchWidget.prototype.RestartFastDPIAction = function ()
{
    //var node = this.Views.TitleLabel.getNode();
    var node = this.Views.IndicatorLabel.getNode();
    this.HardwareRestartContext.show(node, {pos: "bottom"});
};
function AppVersionLabelWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        AppVersionLabel:null,
        IndicatorLabel:null
    };

    this.Subscriptions = {};

    this.State = null;

    this.Init(ViewConfig);
}

AppVersionLabelWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "AppVersionLabel";

    let collapsed = parseInt(App.SessionManager.GetPreference("Collapsed"),10);

    this.ViewConfig = {
        css:"app_top_version_container",
        width: 180,
        // hidden: collapsed ? true : false,
        cols:[
            {
                view:"label",
                css:"app_top_version",
                id:this.Id + "AppVersionLabel",
                align:"left",
                label:""
            },
            {
                view:"label",
                css:"app_top_version",
                id:this.Id + "IndicatorLabel",
                align:"right",
                label:"",
                hidden:true,
                width:16,
                click:function (Id)
                {
                    _this.OnIndicatorClick(this);
                }
            }
        ]
    };
};

AppVersionLabelWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    this.Subscriptions.AppVersion = App.SessionManager.AppVersion.subscribe(function (Value)
    {
        var text = "";
        var tip = "";

        if(Value)
        {
            text = "Version " + Value.version + "&nbsp;" + Value.licence.charAt(0).toUpperCase();
            tip = "Version " + Value.version + " " + Value.licence.charAt(0).toUpperCase() + Value.licence.slice(1);
        }

        _this.DefineVersionLabel(text, tip);
    });

    this.Subscriptions.Dpiui2NewVersionState = App.HardwaresManager.Signals.Dpiui2NewVersionState.subscribe(function (State)
    {
        _this.SetIndicatorState(State);
    });
};

AppVersionLabelWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

AppVersionLabelWidget.prototype.DefineVersionLabel = function (Text, Tip)
{
    this.Views.AppVersionLabel.define({label: Text, tooltip: Tip});
    this.Views.AppVersionLabel.refresh();
};

AppVersionLabelWidget.prototype.DefineIndicatorLabel = function (Icon, Tip, Css)
{
    var css = "app_top_version webix_el_icon " + Css;

    this.Views.IndicatorLabel.define({label: "<span class='webix_icon fa-" + Icon + "'></span>", tooltip: Tip, css: css});
    this.Views.IndicatorLabel.refresh();

    var node = this.Views.IndicatorLabel.getNode();

    webix.html.removeCss(node, 'webix_el_icon');
    webix.html.removeCss(node, 'label_vas_color');
    webix.html.removeCss(node, 'label_error_color');
    webix.html.removeCss(node, 'label_warning_color');

    webix.html.addCss(node, css);
};

AppVersionLabelWidget.prototype.SetIndicatorState = function (/*HardwareDpiui2StateModel*/ State)
{
    if(!State)
    {
        this.Views.IndicatorLabel.hide();
        return;
    }

    this.State = State;

    if(State.has_new_version)
    {
        this.DefineIndicatorLabel("scrubber", LangHelper.GetString("AppView", "New GUI version is available"), "label_vas_color");
        this.Views.IndicatorLabel.show();
    }
    else if(State.error)
    {
        this.DefineIndicatorLabel("exclamation-circle", State.error, "label_error_color");
        this.Views.IndicatorLabel.show();
    }
    else if(!State.has_hardware)
    {
        this.DefineIndicatorLabel("exclamation-circle", LangHelper.GetString("AppView", "Need to add dpui2 hardware"), "label_warning_color");
        this.Views.IndicatorLabel.show();
    }
    else
    {
        this.Views.IndicatorLabel.hide();
    }
};

AppVersionLabelWidget.prototype.OnIndicatorClick = function (Btn)
{
    if(this.State)
    {
        if(this.State.has_new_version)
        {
            App.NavRouter.PresentView({id: ControllersEnum.Dpiui2Update, topMenuId: ControllersEnum.Hardwares});
        }
        else if(this.State.error)
        {
            App.NavRouter.PresentView({id: ControllersEnum.Hardwares, topMenuId: ControllersEnum.Hardwares});
        }
        else if(!this.State.has_hardware)
        {
            var AddForm = new HardwareEditFormViewController();
            AddForm.ViewDidLoad();

            var node = Btn.getNode();

            AddForm.SetData({
                name: LangHelper.GetString("Dics", "DPIUI2 server (GUI)"),
                hardware_type: HardwareTypesEnum.dpiui2
            });

            AddForm.Show(node,"bottom");
        }
    }
};
function LoggedInUserProfileWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        TitleLabel:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

LoggedInUserProfileWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "LoggedInUserProfile";

    this.ProfileFormContextId = this.Id + "ProfileFormContext";
    this.ProfileFormContextConfig = {
        view: "popup",
        width: 480,
        modal: true,
        id:this.ProfileFormContextId,
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    view: "multiview",
                    id: this.ProfileFormContextId+"Wizard",
                    cells:[
                        {
                            id: this.ProfileFormContextId+"Wizard"+"ViewProfile",
                            rows: [
                                {
                                    view: "toolbar",
                                    borderless:true,
                                    elements: [
                                        {},
                                        {
                                            view: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "spectre_button" : "button",
                                            css: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "form_button spec_action with_icon" : "",
                                            type: "icon",
                                            icon: "pencil",
                                            width: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? 48 : 45,
                                            click:function ()
                                            {
                                                $$(_this.ProfileFormContextId+"Wizard"+"EditProfile"+"Profile").setValues(App.SessionManager.GetProfile());
                                                $$(_this.ProfileFormContextId+"Wizard"+"EditProfile").show();
                                            }
                                        }
                                    ]
                                },
                                {

                                    css:"profile-person",
                                    rows:[
                                        {
                                            height: 148,
                                            cols:[
                                                {},
                                                {
                                                    width:148,
                                                    borderless: true,
                                                    id:this.ProfileFormContextId+"Wizard"+"ViewProfile"+"Avatar",
                                                    template: function (obj) {
                                                        var html =
                                                            "<div class=\"profile-person__avatar-placeholder\"><div class=\"profile-person__avatar\">" + obj.avatar + "</div></div>";
                                                        return html;
                                                    }
                                                },
                                                {}
                                            ]
                                        },
                                        {
                                            borderless: true,
                                            id: this.ProfileFormContextId+"Wizard"+"ViewProfile"+"Profile",
                                            minHeight:116,
                                            template: function (obj) {
                                                var html =
                                                    "<div class=\"profile-person__name\">" + obj.name + "</div>"+
                                                    "<div class=\"profile-person__position\">" + obj.position + "</div>"+
                                                    "<div class=\"profile-person__company\">" + obj.company + "</div>";
                                                return html;
                                            }
                                        },
                                        {
                                            type: "clean",
                                            height: 2,
                                            borderless: true,
                                            padding: 0,
                                            marging: 0,
                                            css: "app_header__border_bottom",
                                            template: ""
                                        },
                                        {
                                            borderless: true,
                                            id: this.ProfileFormContextId+"Wizard"+"ViewProfile"+"Contacts",
                                            height:116,
                                            template: function (obj) {
                                                var html =
                                                    "<div class=\"profile-person__phone\"><span class='webix_icon fa-phone'></span> <span>" + obj.phone + "</span></div>"+
                                                    "<div class=\"profile-person__email\"><span class='webix_icon fa-envelope'></span> <span>" + obj.email + "</span></div>";
                                                return html;
                                            }
                                        },
                                        {}
                                    ]
                                },
                                {

                                },
                                {

                                    type:SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "wide" : "line",
                                    cols: function ()
                                    {
                                        var cols = [
                                            {
                                                gravity:2
                                            }
                                        ];

                                        var okBtn = {
                                            view: "button",
                                            type: "form",
                                            label: "Ok",
                                            click: function () {
                                                _this.ProfileFormContext.hide();
                                            }
                                        };

                                        if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
                                        {
                                            delete okBtn.type;
                                            okBtn.view = "spectre_button";
                                            okBtn.css = "form_button third_action";
                                        }

                                        cols.push(okBtn);

                                        return cols;
                                    }()
                                }
                            ]
                        },
                        {
                            id: this.ProfileFormContextId+"Wizard"+"EditProfile",
                            rows: [
                                {
                                    view: "form",
                                    id: this.ProfileFormContextId+"Wizard"+"EditProfile"+"Profile",
                                    type: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "wide" : "form",
                                    borderless:true,
                                    elements: function ()
                                    {
                                        var els = [
                                            {view: "label", css: "title", label: LangHelper.GetString(_this.Id, "Edit profile")},
                                            {
                                                view: "text",
                                                label: LangHelper.GetString(_this.Id, "Username"),
                                                name: "username",
                                                labelPosition: "top",
                                                required: true,
                                                invalidMessage: LangHelper.GetString(_this.Id, "Enter user name"),
                                                validate: webix.rules.isNotEmpty,
                                                disabled:true,
                                                attributes:{maxlength:50},
                                                on: {
                                                    "onChange": function () {
                                                        this.validate();
                                                    }
                                                }
                                            },
                                            {
                                                view: "text",
                                                label: LangHelper.GetString(_this.Id, "Full name"),
                                                name: "name",
                                                tooltip: LangHelper.GetString(_this.Id, "Last name First name Middle name"),
                                                labelPosition: "top",
                                                required: true,
                                                invalidMessage: LangHelper.GetString(_this.Id, "Enter your full name"),
                                                validate: webix.rules.isNotEmpty,
                                                attributes:{maxlength:50},
                                                on: {
                                                    "onChange": function () {
                                                        this.validate();
                                                    }
                                                }
                                            },
                                            {
                                                view: "text",
                                                label: LangHelper.GetString(_this.Id, "Position"),
                                                name: "position",
                                                tooltip: LangHelper.GetString(_this.Id, "Position"),
                                                labelPosition: "top",
                                                required: true,
                                                invalidMessage: LangHelper.GetString(_this.Id, "Enter your position"),
                                                validate: webix.rules.isNotEmpty,
                                                attributes:{maxlength:50},
                                                on: {
                                                    "onChange": function () {
                                                        this.validate();
                                                    }
                                                }
                                            },
                                            {
                                                view: "text",
                                                label: LangHelper.GetString(_this.Id, "Organization"),
                                                name: "company",
                                                tooltip: LangHelper.GetString(_this.Id, "Name of the organization"),
                                                labelPosition: "top",
                                                required: true,
                                                invalidMessage: LangHelper.GetString(_this.Id, "Enter the name of the organization"),
                                                validate: webix.rules.isNotEmpty,
                                                attributes:{maxlength:50},
                                                on: {
                                                    "onChange": function () {
                                                        this.validate();
                                                    }
                                                }
                                            },
                                            {
                                                view: "text",
                                                label: "E-mail",
                                                name: "email",
                                                labelPosition: "top",
                                                required: true,
                                                invalidMessage: LangHelper.GetString(_this.Id, "Enter your e-mail"),
                                                validate: webix.rules.isEmail,
                                                attributes:{maxlength:50},
                                                on: {
                                                    "onChange": function () {
                                                        this.validate();
                                                    }
                                                }
                                            },
                                            {
                                                view: "text",
                                                label: LangHelper.GetString(_this.Id, "Phone"),
                                                name: "phone",
                                                tooltip: LangHelper.GetString(_this.Id, "Contact number"),
                                                labelPosition: "top",
                                                required: true,
                                                invalidMessage: LangHelper.GetString(_this.Id, "Enter phone number"),
                                                validate: webix.rules.isNotEmpty,
                                                attributes:{maxlength:50},
                                                on: {
                                                    "onChange": function () {
                                                        this.validate();
                                                    }
                                                }
                                            }
                                        ];

                                        if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
                                        {
                                            var newEls = [];

                                            els.forEach(function (View)
                                            {
                                                if(View.view == "label")
                                                {
                                                    newEls.push(
                                                        BlockHeaderTemplate({
                                                            title:View.label,
                                                            borderless:true
                                                        })
                                                    );
                                                }

                                                if(View.view == "text")
                                                {
                                                    View.view = "spectre_" + View.view;

                                                    newEls.push({type:"wide", height:51, cols:[View]});
                                                }
                                            });

                                            els = newEls;
                                        }

                                        return els;
                                    }()
                                },
                                {
                                    height:SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? 20 : 0
                                },
                                {
                                    type: "clean",
                                    height: 2,
                                    borderless: true,
                                    padding: 0,
                                    marging: 0,
                                    css: "app_header__border_bottom",
                                    template: ""
                                },
                                {
                                    height:SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? 20 : 0
                                },
                                {
                                    view: "form",
                                    id: this.ProfileFormContextId+"Wizard"+"EditProfile"+"Password",
                                    type: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "wide" : "form",
                                    borderless: true,
                                    elements:function ()
                                    {
                                        var els = [
                                            {view: "label", css: "title", label: LangHelper.GetString(_this.Id, "Change password")},
                                            {
                                                view: "text",
                                                label: LangHelper.GetString(_this.Id, "Old password"),
                                                name: "password_old",
                                                type: "password",
                                                tooltip: LangHelper.GetString(_this.Id, "Old password"),
                                                labelPosition: "top",
                                                invalidMessage: LangHelper.GetString(_this.Id, "Enter password"),
                                                validate: webix.rules.isNotEmpty,
                                                attributes:{maxlength:30},
                                                on: {
                                                    "onChange": function () {
                                                        this.validate();
                                                    }
                                                }
                                            },
                                            {
                                                cols:[
                                                    {
                                                        view: "text",
                                                        label: LangHelper.GetString(_this.Id, "New password"),
                                                        name: "password_new",
                                                        type: "password",
                                                        tooltip: LangHelper.GetString(_this.Id, "New password"),
                                                        labelPosition: "top",
                                                        invalidMessage: LangHelper.GetString(_this.Id, "Enter password"),
                                                        validate: webix.rules.isNotEmpty,
                                                        attributes:{maxlength:30}
                                                    },
                                                    {
                                                        view: "text",
                                                        label: LangHelper.GetString(_this.Id, "Confirm password"),
                                                        name: "password_new_confirm",
                                                        type: "password",
                                                        tooltip: LangHelper.GetString(_this.Id, "Confirm password"),
                                                        labelPosition: "top",
                                                        invalidMessage: LangHelper.GetString(_this.Id, "Enter password"),
                                                        validate: webix.rules.isNotEmpty,
                                                        attributes:{maxlength:30}
                                                    }
                                                ]
                                            }
                                        ];

                                        if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
                                        {
                                            var newEls = [];

                                            els.forEach(function (View)
                                            {
                                                if(View.view == "label")
                                                {
                                                    newEls.push(
                                                        BlockHeaderTemplate({
                                                            title:View.label,
                                                            borderless:true
                                                        })
                                                    );
                                                }

                                                if(View.view == "text")
                                                {
                                                    View.view = "spectre_" + View.view;

                                                    newEls.push({type:"wide", height:51, cols:[View]});
                                                }

                                                if(View.cols)
                                                {
                                                    View.cols.forEach(function (View)
                                                    {
                                                        View.view = "spectre_" + View.view;

                                                    });

                                                    View.type = "wide";
                                                    View.height = 51;

                                                    newEls.push(View);
                                                }
                                            });

                                            els = newEls;
                                        }

                                        return els;
                                    }(),
                                    rules:{
                                        $obj:function(data)
                                        {
                                            if (data.password_new_confirm != data.password_new){
                                                webix.message({type:"error", text:LangHelper.GetString(_this.Id, "Passwords do not match")});
                                                return false;
                                            }
                                            return true;
                                        }
                                    }
                                },
                                {
                                    height:SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? 20 : 0
                                },
                                {
                                    type:SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "wide" : "line",
                                    cols: [
                                        {},
                                        {
                                            view: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "spectre_button" : "button",
                                            css: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "form_button third_action" : "",
                                            label: LangHelper.GetString(_this.Id, "Cancel"),
                                            click: function ()
                                            {
                                                $$(_this.ProfileFormContextId+"Wizard"+"ViewProfile").show();

                                                $$(_this.ProfileFormContextId+"Wizard"+"EditProfile"+"Profile").clear();
                                                $$(_this.ProfileFormContextId+"Wizard"+"EditProfile"+"Profile").clearValidation();

                                                $$(_this.ProfileFormContextId+"Wizard"+"EditProfile"+"Password").clear();
                                                $$(_this.ProfileFormContextId+"Wizard"+"EditProfile"+"Password").clearValidation();
                                            }
                                        },
                                        {
                                            view: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "spectre_button" : "button",
                                            css: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "form_button main_action" : "",
                                            type: "form",
                                            label: LangHelper.GetString(_this.Id, "Save"),
                                            click: function ()
                                            {
                                                var form = $$(_this.ProfileFormContextId+"Wizard"+"EditProfile"+"Profile");

                                                if (form.validate())
                                                {
                                                    var formPanel = $$(_this.ProfileFormContextId+"Wizard"+"EditProfile");
                                                    var thisBtn = this;

                                                    thisBtn.disable();
                                                    formPanel.showProgress({type: "icon"});

                                                    var request = {};
                                                    request.data = form.getValues();
                                                    request.callback = function (R)
                                                    {
                                                        thisBtn.enable();
                                                        formPanel.hideProgress({type: "icon"});

                                                        if (!R.success && R.error.msg)
                                                        {
                                                            webix.message({type: "error", text: R.error.msg});
                                                        }

                                                        if (R.success)
                                                        {
                                                            var passwordForm = $$(_this.ProfileFormContextId+"Wizard"+"EditProfile"+"Password");
                                                            var passwordFormVals = passwordForm.getValues();

                                                            if(passwordFormVals.password_old || passwordFormVals.password_new || passwordFormVals.password_new_confirm)
                                                            {
                                                                if (passwordForm.validate())
                                                                {
                                                                    var passChangeRequest = {};
                                                                    passChangeRequest.data = {
                                                                        OldPassword:passwordFormVals.password_old,
                                                                        NewPassword:passwordFormVals.password_new
                                                                    };

                                                                    passChangeRequest.callback = function (R)
                                                                    {
                                                                        if (!R.success && R.error.msg)
                                                                        {
                                                                            webix.message({type: "error", text: R.error.msg});
                                                                        }

                                                                        if (R.success)
                                                                        {
                                                                            $$(_this.ProfileFormContextId+"Wizard"+"ViewProfile").show();
                                                                        }
                                                                    };

                                                                    App.SessionManager.ChangeMyPassword(passChangeRequest);
                                                                }
                                                            }
                                                            else
                                                            {
                                                                $$(_this.ProfileFormContextId+"Wizard"+"ViewProfile").show();
                                                            }
                                                        }
                                                    };

                                                    App.SessionManager.SaveMyProfile(request);
                                                }
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };
    this.ProfileFormContext = webix.ui(this.ProfileFormContextConfig);

    this.ProfileViewPopupId = this.Id + "ProfileViewPopup";
    this.ProfileViewPopupMenuData = [
        {id: this.ProfileViewPopupId+"MyProfile", icon: "user", value: LangHelper.GetString(_this.Id, "My profile")},
        {$template: "Separator", section:RoleSectionsEnum.administrator_users},
        {
            id: "Users", icon: "users", value: LangHelper.GetString(_this.Id, "Users"), section:RoleSectionsEnum.administrator_users, submenu: [
                {id: "Users", icon: "users", value: LangHelper.GetString(_this.Id, "Users"), section:RoleSectionsEnum.administrator_users},
                {id: "Roles", icon: "user-secret", value: LangHelper.GetString(_this.Id, "Roles"), section:RoleSectionsEnum.administrator_roles}
            ]
        },
        {$template: "Separator"},
        {id: this.ProfileViewPopupId+"Logout", icon: "sign-out", value: LangHelper.GetString(_this.Id, "Log out")}
    ];
    this.ProfileViewPopupConfig = {
        view: "submenu",
        id: this.ProfileViewPopupId,
        width: 200,
        autowidth: true,
        padding: 0,
        data: this.ProfileViewPopupMenuData,
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();
                if (id === _this.ProfileViewPopupId+"Logout")
                {
                    setTimeout(function () {
                        App.Logout();
                    },10);
                }
                else if(id === _this.ProfileViewPopupId+"MyProfile")
                {
                    setTimeout(function () {
                        var node = _this.Views.TitleLabel.getNode();
                        _this.ProfileFormContext.show(node, {pos: "bottom"});
                    }, 10);
                }
                else if(id === "Users" || id === "Roles")
                {
                    App.NavRouter.PresentView({id: id});
                }
            }
        }

    };
    this.ProfileViewPopup = webix.ui(this.ProfileViewPopupConfig);

    this.ViewConfig =
    {
        height:40,
        id: this.Id + "TitleLabel",
        css: "header_person",
        borderless: true,
        width:SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? 180 : 32,
        data: {name: ""},
        template: function (obj) {
            var html = "<div style='height:100%;width:100%;' onclick='webix.$$(\""+_this.ProfileViewPopupId+"\").show(this)'>";

            if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
            {
                html += "<span class='webix_icon fa-"+(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "sort" : "angle")+"-down'></span><span class='name'>" + obj.name + "</span>";
                html += "<span class='avatar font_stolzl_regular'><span class='webix_icon fa-user-circle'></span></span>";
            }
            else
                html += "<span class='avatar font_stolzl_regular'>"+Helper.GetInitials(obj.name)+"</span>";

            html += "</div>";
            return html;
        }
    };
};

LoggedInUserProfileWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    webix.extend($$(this.ProfileFormContextId+"Wizard"+"EditProfile"), webix.ProgressBar);

    this.Subscriptions.MyProfileUpdatedSignalSubscription = App.SessionManager.MyProfileUpdatedSignal.subscribe(function (MyProfileUpdated)
    {
        if (MyProfileUpdated)
        {
            _this.SetProfile();
        }
    });

    this.SetProfile();

    this.HideRestrictedMenuItems();
};

LoggedInUserProfileWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

LoggedInUserProfileWidget.prototype.DefineTitleLabel = function (Name)
{
    this.Views.TitleLabel.define("data",{name:Name});
};

LoggedInUserProfileWidget.prototype.DefineProfile = function (Profile)
{
    $$(this.ProfileFormContextId+"Wizard"+"ViewProfile"+"Avatar").define("data",{avatar:Helper.GetInitials(Profile.name)});
    $$(this.ProfileFormContextId+"Wizard"+"ViewProfile"+"Profile").define("data",Profile);
    $$(this.ProfileFormContextId+"Wizard"+"ViewProfile"+"Contacts").define("data",Profile);
};

LoggedInUserProfileWidget.prototype.SetProfile = function ()
{
    if(App.SessionManager.GetProfile())
    {
        var profile = App.SessionManager.GetProfile();

        this.DefineTitleLabel(profile.name);

        this.DefineProfile(profile);
    }
};

LoggedInUserProfileWidget.prototype.HideRestrictedMenuItems = function ()
{
    Helper.HideRestrictedMenuItems(this.ProfileViewPopupMenuData, this.ProfileViewPopup);
};
function LangSwitchWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        TitleLabel:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

LangSwitchWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "LangSwitch";

    this.LangSwitchViewPopupId = this.Id + "LangSwitchViewPopup";
    this.LangSwitchViewPopupConfig = {
        view: "submenu",
        id: this.LangSwitchViewPopupId,
        width: 200,
        autowidth: true,
        padding: 0,
        data: function (){
            var list = [
                {id: _this.LangSwitchViewPopupId+"En", icon: "en", value: LangHelper.GetString(_this.Id, "English")},
                {id: _this.LangSwitchViewPopupId+"Ru", icon: "ru", value: LangHelper.GetString(_this.Id, "Russian")}
            ];

            if(SkinHelper.GetSkin() === SkinsEnum.dpiui2_inss || SkinHelper.IsCubroSkin())
            {
                list.pop();
            }

            return list;
        }(),
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
                    return "<span>" + obj.icon.toUpperCase() + "</span>";

                return "<span class='webix_icon'><img src='assets/imgs/flags/"+obj.icon+".svg' style='width: 16px;'/></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                if(id == _this.LangSwitchViewPopupId+"En")
                {
                    LangHelper.SetLocale(LocalesEnum.en.code);
                }

                if(id == _this.LangSwitchViewPopupId+"Ru")
                {
                    LangHelper.SetLocale(LocalesEnum.ru.code);
                }

                location.reload();
            }
        }

    };
    this.LangSwitchViewPopup = webix.ui(this.LangSwitchViewPopupConfig);

    this.ViewConfig =
    {
        height:40,
        id: this.Id + "TitleLabel",
        css:"header_lang",
        borderless: true,
        width: SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? 30 : 22,
        data: {title: LangHelper.GetLocale().toUpperCase(), icon:"en"},
        template: function (obj) {
            var html = "<div style='height:100%;width:100%;' onclick='webix.$$(\""+_this.LangSwitchViewPopupId+"\").show(this)'>";

            if(SkinHelper.GetSkin() != SkinHelper.GetDefaultFilterUiSkin())
            {
                html += "<div class='header_lang__wrapper'>"
                html += "<img class='lang' src='assets/imgs/flags/"+obj.icon+".svg'/>";
                html += "</div>";
            }

            if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
            {
                html += "<span class='name'>" + obj.title + "</span>";
                html += "<span class='webix_icon fa-"+(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin() ? "sort" : "angle")+"-down'></span></div>";
            }
            return html;
        }
    };
};

LangSwitchWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    this.DefineTitleLabel();
};

LangSwitchWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

LangSwitchWidget.prototype.DefineTitleLabel = function ()
{
    this.Views.TitleLabel.define("data",{icon:App.Locale, title:LangHelper.GetLocale().toUpperCase()});
};
function CreateTicketWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        Btn:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

CreateTicketWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "CreateTicket";

    this.ViewConfig =
    {
        view: "button",
        id: this.Id + "Btn",
        type: "icon",
        width: 24,
        css: "app_button app_button_bug",
       // icon: "bug",
        badge: 0,
        click:function ()
        {
            _this.CreateTicketContextShow();
        }
    };
};

CreateTicketWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.administrator_send_error))
    {
        this.CreateTicketContext = new CreateTicketViewController({InContext:true});
        this.CreateTicketContext.ViewDidLoad();
    }
    else
        this.Views.Btn.hide();
};

CreateTicketWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

CreateTicketWidget.prototype.CreateTicketContextShow = function (Message)
{
    if(this.CreateTicketContext && this.Views.Btn)
    {
        this.CreateTicketContext.Show(this.Views.Btn.getNode(),"bottom", Message);
    }
};
function HardwaresLogNotifiationsWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        Btn:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

HardwaresLogNotifiationsWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "HardwaresLogNotifiations";

    this.ViewConfig =
    {
        view: "button",
        id: this.Id + "Btn",
        type: "icon",
        width:24,
        css: "app_button socket_notif font_stolzl_regular app_button_envelope",
       // icon: "envelope",
        badge: 0,
        click:function ()
        {
            _this.HeaderNotifContext.Show(this.getNode(),"top");
        }
    };
};

HardwaresLogNotifiationsWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.logs))
    {
        this.HeaderNotifContext = new HardwareNotificationsViewController({InContext:true});
        this.HeaderNotifContext.ViewDidLoad();
    }
    else
        this.Views.Btn.hide();

    this.Subscriptions.NotifUnreadedCount = App.NotificationsManager.UnreadedCount.subscribe(function (Count)
    {
        _this.DefineBtnBadge(Count);
    });
};

HardwaresLogNotifiationsWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

HardwaresLogNotifiationsWidget.prototype.DefineBtnBadge = function (Count)
{
    var count = Count >= 100 ? "99+":Count;
    this.Views.Btn.define({badge:AppButtonBadgeTemplate(count)});
    this.Views.Btn.refresh();
};
function WebsocketNotificationsWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        Btn:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

WebsocketNotificationsWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "WebsocketNotifications";

    this.ViewConfig =
        {
            view: "button",
            id: this.Id + "Btn",
            type: "icon",
            width:24,
            css: "app_button socket_notif font_stolzl_regular app_button_bell",
           // icon: "bell",
            badge: 0,
            click:function ()
            {
                _this.HeaderNotifContext.Show(this.getNode(),"top");
            }
        };
};

WebsocketNotificationsWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.websocket))
    {
        this.HeaderNotifContext = new SocketNotificationsViewController({InContext:true});
        this.HeaderNotifContext.ViewDidLoad();
    }
    else
        this.Views.Btn.hide();

    this.Subscriptions.NotifUnreadedCount = App.SocketNotificationsManager.SignalNotificationsCount.subscribe(function (Count)
    {
        _this.DefineBtnBadge(Count);
    });
};

WebsocketNotificationsWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

WebsocketNotificationsWidget.prototype.DefineBtnBadge = function (Count)
{
    var count = Count >= 100 ? "99+":Count;
    this.Views.Btn.define({badge:AppButtonBadgeTemplate(count)});
    this.Views.Btn.refresh();
};
function PageHeaderWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        Title:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

PageHeaderWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "PageHeader";

    this.ViewConfig =
    {
        id:this.Id + "Title",
        css: "app_view_title",
        view:"template",
        template:"",
        height:28,
        borderless:true
    };
};

PageHeaderWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });
};

PageHeaderWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

PageHeaderWidget.prototype.DefineTitle = function (RootTitle, Title)
{
    this.Views.Title.define("template", (RootTitle ? RootTitle : "") + (RootTitle && Title ? " / " : "") + (Title ? "<span class='app_view_title__highlight'>" + Title + "</span>" : ""));
    this.Views.Title.refresh();
};

function AppViewController(Params)
{
    var _this = this;

    this.Id = "AppView";

    this.BodyLayoutId = Params.BodyLayoutId;

    this.Views =
    {
        Widgets:function ()
        {
            var widgets = {};

            if(SkinHelper.GetSkin() != SkinHelper.GetDefaultFilterUiSkin())
            {
                widgets.AppMenuSidebar = new AppMainMenuSidebarWidget({id:_this.Id});
                widgets.BreadCrumbs = new BreadCrumbsWidget({id:_this.Id});

                //widgets.HwSwitch = new HardwareSwitchWidget({id:"HwSwitch"});
                //widgets.AppVersion = new AppVersionLabelWidget({id:"AppVersionWidget"});
                // widgets.AppMenu = new AppMainMenuWidget({id:"AppMenuWidget"});
                widgets.CreateTicket = new CreateTicketWidget({id:"CreateTicket"});
                widgets.HwNotifications = new HardwaresLogNotifiationsWidget({id:"HwNotifications"});
                widgets.SocketNotifications = new WebsocketNotificationsWidget({id: "SocketNotifications"});
                widgets.LoadingBar = new LoadingBarWidget({id:"LoadingIndicator"});
            }

            if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
            {
                widgets.AppSideBar = new UlrSideBarWidget();
                widgets.PageHeader = new PageHeaderWidget({id:_this.Id + "AppMenuWidget"});
            }

            widgets.UserProfile = new LoggedInUserProfileWidget({id:"UserProfile"});
            widgets.LangSwitch = new LangSwitchWidget({id:"LangSwitch"});
            widgets.LoadingIndicator = new LoadingIndicatorWidget({id:"LoadingIndicator"});
            widgets.MessagesBtn = new MessagesWidget({id:"MessagesBtn"});

            return widgets;
        }()
    };

    if(SkinHelper.GetSkin() != SkinHelper.GetDefaultFilterUiSkin()){
        this.ViewConfig =
            {
                id:this.Id,
                cols: [
                    _this.Views.Widgets.AppMenuSidebar.ViewConfig,
                    {
                        type: "clean",
                        css:"main_container",
                        rows: this.AppHeaderTpl()
                    },
                ],
            };
    }
    else {
        this.ViewConfig =
            {
                id:this.Id,
                type: "clean",
                css:"main_container",
                rows: this.AppHeaderTpl()
            };
    }

    this.Subscriptions = {};

    this.Init(Params);
}

AppViewController.prototype.Init = function (Params)
{
    webix.ui(this.ViewConfig);
};

AppViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll();
};

AppViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, null);
    });
};

AppViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });
};

AppViewController.prototype.CreateTicketContextShow = function (Message)
{
    this.Views.Widgets.CreateTicket.CreateTicketContextShow(Message);
};

AppViewController.prototype.AppHeaderTpl = function ()
{
    var _this = this;

    var tpl = [];

    if(SkinHelper.GetSkin() == SkinsEnum.dpiui2 ||
        SkinHelper.GetSkin() == SkinsEnum.dpiui2_dark ||
        SkinHelper.GetSkin() == SkinsEnum.dpiui2_cubro_main)
    {
        tpl = [
            {
               // type: "clean",
              //  css:"app_top_header_container",
               // cols: [
                    // {
                    //     type: "clean",
                    //     css: "app_logo",
                    //     borderless: true,
                    //     template: "<img src='assets/imgs/logo.png'/>",
                    //     width: 73
                    // },
                    // _this.Views.Widgets.AppMenu.ViewConfig,
                    //    {
                       // type: "clean",
                      //  height: 56,
                       // css:"app_top_header_container",
                      //  rows: [
                        //    {
                                id: "TopHeader",
                                type: "clean",
                                view: "toolbar",
                                css: "app_top_header bread_crumbs_header",
                                height: 56,
                                borderless: true,
                                elements:
                                    [
                                        //_this.Views.Widgets.HwSwitch.ViewConfig,
                                        _this.Views.Widgets.BreadCrumbs.ViewConfig,
                                        //{},
                                        {
                                            type: "clean",
                                            css: "top_icons_container",
                                            rows: [
                                                {
                                                    type: "section",
                                                    css: "top_icons",
                                                    cols: [
                                                        _this.Views.Widgets.LangSwitch.ViewConfig,
                                                        _this.Views.Widgets.HwNotifications.ViewConfig,
                                                        _this.Views.Widgets.SocketNotifications.ViewConfig,
                                                        _this.Views.Widgets.CreateTicket.ViewConfig,
                                                        _this.Views.Widgets.UserProfile.ViewConfig,
                                                        _this.Views.Widgets.MessagesBtn.ViewConfig,
                                                    ]
                                                }
                                            ]
                                        },
                                        // _this.Views.Widgets.AppVersion.ViewConfig
                                    ]
                          //  },
                            // ,
                            // {
                            //     cols: [
                            //         {},
                            //         //_this.Views.Widgets.AppMenu.ViewConfig,
                            //         _this.Views.Widgets.AppVersion.ViewConfig
                            //
                            //     ]
                            // }
                      //  ]
                   // }
             //   ]
            },
            _this.Views.Widgets.LoadingBar.ViewConfig,
            {
                id: this.BodyLayoutId,
                rows: []
            },
            // _this.Views.Widgets.MessagesBtn.ViewConfig
        ];
    }


    if(SkinHelper.GetSkin() == SkinsEnum.dpiui2_vulkan)
    {
        tpl = [
            {
                id: "TopHeader",
                type: "clean",
                view: "toolbar",
                css: "app_top_header bread_crumbs_header",
                height: 56,
                borderless: true,
                elements:
                    [
                        //_this.Views.Widgets.HwSwitch.ViewConfig,
                        _this.Views.Widgets.BreadCrumbs.ViewConfig,
                        //{},
                        {
                            type: "clean",
                            css: "top_icons_container",
                            rows: [
                                {
                                    type: "section",
                                    css: "top_icons",
                                    cols: [
                                        _this.Views.Widgets.LangSwitch.ViewConfig,
                                        _this.Views.Widgets.HwNotifications.ViewConfig,
                                        _this.Views.Widgets.SocketNotifications.ViewConfig,
                                        _this.Views.Widgets.CreateTicket.ViewConfig,
                                        _this.Views.Widgets.UserProfile.ViewConfig,
                                        _this.Views.Widgets.MessagesBtn.ViewConfig,
                                    ]
                                }
                            ]
                        },
                        // _this.Views.Widgets.AppVersion.ViewConfig
                    ]
                //  },
                // ,
                // {
                //     cols: [
                //         {},
                //         //_this.Views.Widgets.AppMenu.ViewConfig,
                //         _this.Views.Widgets.AppVersion.ViewConfig
                //
                //     ]
                // }
                //  ]
                // }
                //   ]
            },
            _this.Views.Widgets.LoadingBar.ViewConfig,
            {
                id: this.BodyLayoutId,
                rows: []
            },
            // _this.Views.Widgets.MessagesBtn.ViewConfig
        ];
    }


    if(SkinHelper.GetSkin() == SkinHelper.GetDefaultFilterUiSkin())
    {
        tpl = [
            {
                type: "clean",
                height:SkinHelper.GetSkin() == SkinsEnum.dpiui2_cubro ? 72 : 64,
                css: "app_top_header spectre",
                cols: [
                    {
                        type: "clean",
                        css: "app_logo",
                        borderless: true,
                        template: "<img src='assets/imgs/" + (AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg") + "'/>",

                        width:320
                    },
                    {
                        type: "clean",
                        borderless:SkinHelper.GetSkin() == SkinsEnum.dpiui2_cubro,
                        cols:[
                            _this.Views.Widgets.PageHeader.ViewConfig
                        ]
                    },
                    {
                        type: "clean",
                        view: "toolbar",
                        css: "app_top_header",
                        borderless:SkinHelper.GetSkin() == SkinsEnum.dpiui2_cubro,
                        elements:
                            [
                                {},
                                {
                                    cols:[
                                        _this.Views.Widgets.LangSwitch.ViewConfig,
                                        _this.Views.Widgets.UserProfile.ViewConfig,
                                        _this.Views.Widgets.MessagesBtn.ViewConfig,
                                    ]
                                },
                                {
                                    width:SkinHelper.GetSkin() == SkinsEnum.dpiui2_cubro ? 28 : 20
                                }
                            ]
                    }
                ]
            },
            _this.Views.Widgets.LoadingIndicator.ViewConfig,
            {
                cols:[
                    this.Views.Widgets.AppSideBar.ViewConfig,
                    {
                        id: this.BodyLayoutId,
                        rows: []
                    }
                ]
            },
            // _this.Views.Widgets.MessagesBtn.ViewConfig
        ];
    }

    return tpl;
};

/*AppViewController.prototype.SelectAppMenuItem = function (MenuItemId)
{
    if(this.Views.Widgets.AppMenu)
        this.Views.Widgets.AppMenu.Select(MenuItemId);
};

AppViewController.prototype.UnselectAllAppMenuItems = function ()
{
    if(this.Views.Widgets.AppMenu)
        this.Views.Widgets.AppMenu.UnselectAll();
};*/

AppViewController.prototype.SelectAppMenuSidebarItem = function (MenuItemId)
{
    if (this.Views.Widgets.AppMenuSidebar) {
        const selectedItem = this.Views.Widgets.AppMenuSidebar.Select(MenuItemId);
        if (selectedItem) {
            this.Views.Widgets.BreadCrumbs.RenderCrumbs(selectedItem.id);
        }
    }
};

AppViewController.prototype.UnselectAllAppMenuSidebarItems = function ()
{
    if(this.Views.Widgets.AppMenuSidebar) {
        this.Views.Widgets.AppMenuSidebar.UnselectAll();
    }
};

AppViewController.prototype.SelectAppSideBarItem = function (Id)
{
    if(this.Views.Widgets.AppSideBar)
        this.Views.Widgets.AppSideBar.Select(Id);
};

AppViewController.prototype.UnselectAppSideBarItem = function ()
{
    if(this.Views.Widgets.AppSideBar)
        this.Views.Widgets.AppSideBar.UnselectAll();
};

AppViewController.prototype.SetPageHeaderTitle = function (RootTitle, Title)
{
    if(this.Views.Widgets.PageHeader)
        this.Views.Widgets.PageHeader.DefineTitle(RootTitle, Title);

    Helper.SetHtmlPageTitle(RootTitle, Title);
};

function MessagesWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.Views = {
        MessagesBtn:null,
        MessagesTable:null,

        Messages:null,
        MoreInfoMessages:null,

        MessageStatus:null,
        MessageDate:null,
        MessageType:null,
        MessageContent:null
    };

    this.Subscriptions = {};

    this.MessagesTableSelectedCount = new Rx.BehaviorSubject(0);
    this.MessagesCount = 0;

    this.Init(ViewConfig);
}

MessagesWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "MessagesBtn";

    this.DeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Messages", "Are you sure you want to delete the selected messages?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function ()
                            {
                                _this.DeleteContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Delete"),
                            click:function ()
                            {
                                _this.DeleteMessages(_this.DeleteContext);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.DeleteAllContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Messages", "Are you sure you want to delete all messages?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function ()
                            {
                                _this.DeleteAllContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Delete"),
                            click:function ()
                            {
                                _this.DeleteMessages(_this.DeleteAllContext, true);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.OptionsContext = webix.ui({
        view:"popup",
        width:120,
        point: false,
        css: "messages-suggest",
        body:{
            height:96,
            rows:[
                {
                    view: "button",
                    css: "messages-button",
                    width:120,
                    height: 32,
                    label: LangHelper.GetString("QoE", "Details"),
                    click: function () {
                        setTimeout(function(){
                            _this.ShowMoreInfo();

                        }, 10);
                        _this.OptionsContext.hide();
                    }
                },
                {
                    view: "button",
                    css: "messages-button",
                    width:120,
                    height: 32,
                    label: LangHelper.GetString("SocketNotifications", "Mark as read"),
                    click: function () {
                        setTimeout(function(){
                            _this.ReadMessages();
                        }, 10);
                        _this.OptionsContext.hide();
                    }
                },
                {
                    view: "button",
                    css: "messages-button",
                    width:120,
                    height: 32,
                    label: LangHelper.GetString(_this.Id, "Delete"),
                    click: function () 
                    {
                        setTimeout(function()
                        {
                            _this.DeleteMessages();
                        }, 10);
                        
                        _this.OptionsContext.hide();
                    }
                }
            ]
        }
    });

    this.MessageContext = webix.ui({
        view: "popup",
        maxWidth: 480,
        height: 500,
        id:this.Id + "MessageContext",
        body: {
            borderless:true,
            rows:[
                {
                    borderless: true,
                    cols:[
                        BlockHeaderTemplate({title:LangHelper.GetString("Notifications", "Messages"), icon:"rectangle-history",borderless: true}),
                        {
                            borderless: true,
                            view: "button",
                            id:this.Id+"CloseMessagesBtn",
                            type: "icon",
                            icon: "times",
                            css: "toolbar_round_btn",
                            width: 32,
                            height: 32,
                            tooltip: LangHelper.GetString(_this.Id, "Close"),
                            click: function (id, e, node)
                            {
                                _this.MessageContext.hide();
                            }
                        }
                    ]
                },
                {
                    view: "multiview",
                    cells:[
                        {
                            id: _this.Id + "Messages",
                            rows:[
                                {
                                    view: "toolbar",
                                    elements: [
                                        {
                                            view: "button",
                                            id:this.Id+"SelectAll",
                                            type: "icon",
                                            icon: "check-square",
                                            css: "toolbar_round_btn",
                                            width: 32,
                                            tooltip: LangHelper.GetString("Messages", "Select all messages"),
                                            click: function (id, e, node)
                                            {
                                                if(_this.Views.MessagesTable.count() > _this.MessagesTableSelectedCount.value)
                                                {
                                                    _this.Views.MessagesTable.selectAll();
                                                }
                                                else{
                                                    _this.Views.MessagesTable.unselectAll();
                                                }
                                            }
                                        },
                                        {},
                                        {
                                            view: "button",
                                            id:this.Id+"ReadSelectedBtn",
                                            type: "icon",
                                            icon: "book-open",
                                            css: "toolbar_round_btn toolbar_btn_with_menu",
                                            width: 40,
                                            tooltip: LangHelper.GetString("Messages", "Read messages"),
                                            popup:{
                                                id: _this.Id + "ReadPopup",
                                                view:"submenu",
                                                width:240,
                                                data:[
                                                    {
                                                        id: _this.Id + "ReadOnlySelectedMessagesBtn",
                                                        value: LangHelper.GetString("SocketNotifications", "Read selected"),
                                                        callback: function()
                                                        {
                                                            _this.ReadMessages();
                                                        }
                                                    },
                                                    {
                                                        id: _this.Id + "ReadAllMessagesBtn",
                                                        value: LangHelper.GetString("SocketNotifications", "Read all"),
                                                        callback: function()
                                                        {
                                                            _this.ReadMessages(true);
                                                        }
                                                    }
                                                ],
                                                template:"#value#",
                                                autoheight:true,
                                                select:false,
                                                on:
                                                    {
                                                        onMenuItemClick: function (id)
                                                        {
                                                            var item = this.getItem(id);
                                                            if(item && item.callback)
                                                            {
                                                                item.callback();
                                                            }
                                                            $$(_this.Id + "ReadPopup").hide();
                                                        }
                                                    }
                                            }
                                        },
                                        {width: 16},
                                        {
                                            view: "button",
                                            id: this.Id + "DeleteSelectedBtn",
                                            type: "icon",
                                            icon: "trash",
                                            css: "toolbar_round_btn toolbar_btn_with_menu",
                                            width: 40,
                                            tooltip: LangHelper.GetString("Messages", "Delete messages"),
                                            popup: {
                                                id: _this.Id + "DeletePopup",
                                                view: "submenu",
                                                width: 240,
                                                data: [
                                                    {
                                                        id: _this.Id + "DeleteOnlySelectedMessagesBtn",
                                                        value: LangHelper.GetString("SocketNotifications", "Delete selected"),
                                                        callback: function (node) {
                                                            _this.DeleteContext.show(node, {pos: "bottom"});
                                                        }
                                                    },
                                                    {
                                                        id: _this.Id + "DeleteAllMessagesBtn",
                                                        value: LangHelper.GetString("SocketNotifications", "Delete all"),
                                                        callback: function (node) {
                                                            _this.DeleteAllContext.show(node, {pos: "bottom"});
                                                        }
                                                    }
                                                ],
                                                template: "#value#",
                                                autoheight: true,
                                                select: false,
                                                on:
                                                    {
                                                        onMenuItemClick: function (id) {
                                                            var item = this.getItem(id);
                                                            var node = this.getItemNode(id);
                                                            if (item && item.callback) {
                                                                item.callback(node);
                                                            }
                                                        }
                                                    }
                                            }
                                        }
                                    ]
                                },
                                {
                                    view: "list",
                                    id:this.Id+"MessagesTable",
                                    css: "messages-list",
                                    type: { height: "auto" },
                                    select: true,
                                    multiselect: true,
                                    template: function(Obj)
                                    {
                                        return _this.ParseMessages(Obj);
                                    },
                                    scroll: true,
                                    onClick: {
                                        "messages-body-buttons": function(ev, id)
                                        {
                                            _this.Views.MessagesTable.select(id);
                                            setTimeout(function(){
                                                _this.OptionsContext.show({x:ev.clientX-80, y: ev.clientY});
                                            }, 10);

                                            return false;
                                        },
                                        "messages": function(ev, id)
                                        {
                                            _this.Views.MessagesTable.select(id);
                                            var __this = this;
                                            setTimeout(function()
                                            {
                                                var data = __this.getItem(id);
                                                _this.ShowMoreInfo(data);
                                            }, 10);
                                            return false;
                                        }
                                    },
                                    on: {
                                        onSelectChange:function()
                                        {
                                            _this.OnTableSelectChanged();
                                            return false;
                                        },
                                    }
                                }
                            ]
                        },
                        {
                            view: "scrollview",
                            id: _this.Id + "MoreInfoMessages",
                            scroll: "auto",
                            body:{
                                rows:[
                                    {
                                        view: "toolbar",
                                        height: 32,
                                        padding: 0,
                                        margin: 0,
                                        elements: [
                                            {
                                                view: "button",
                                                id:this.Id+"MessageBack",
                                                type: "icon",
                                                icon: "arrow-left",
                                                css: "toolbar_round_btn",
                                                width: 72,
                                                tooltip: LangHelper.GetString(_this.Id, "Back"),
                                                click: function (id, e, node)
                                                {
                                                    _this.Views.Messages.show();
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        height: 32,
                                        cols:[
                                            {
                                                width: 136,
                                                view: "label",
                                                label: LangHelper.GetString("SocketNotifications", "Status")
                                            },
                                            {
                                                view: "label",
                                                id: _this.Id + "MessageStatus",
                                                template: ""
                                            }
                                        ]
                                    },
                                    {
                                        height: 32,
                                        cols:[
                                            {
                                                width: 136,
                                                view: "label",
                                                label: LangHelper.GetString("Messages", "Message date")
                                            },
                                            {
                                                view: "label",
                                                id: _this.Id + "MessageDate",
                                                template: ""
                                            }
                                        ]
                                    },
                                    {
                                        height: 32,
                                        cols:[
                                            {
                                                width: 136,
                                                view: "label",
                                                label: LangHelper.GetString("Messages", "Message type")
                                            },
                                            {
                                                view: "label",
                                                id: _this.Id + "MessageType",
                                                template: ""
                                            }
                                        ]
                                    },
                                    {
                                        view: "toolbar",
                                        height: 32,
                                        padding: 0,
                                        margin: 0,
                                        elements: [
                                            {
                                                view:"label",
                                                css: "message-content-label",
                                                label: LangHelper.GetString("Messages", "Message content")
                                            },
                                            {}
                                        ]
                                    },
                                    {
                                        view: "label",
                                        id: _this.Id + "MessageContent",
                                        height:0,
                                        css: "message-content-info",
                                        template: ""
                                    }
                                ]
                            }
                        }
                    ]
                }
            ]
        }
    });
    this.Count = 1;

    this.ViewConfig =
    {
        view: "button",
        id: this.Id + "MessagesBtn",
        type: "icon",
        width:24,
        css: "app_button font_stolzl_regular message_notif messages-container messages-btn",
        icon: "rectangle-history",
        badge: 0,
        click:function (id, e, node)
        {
            var __this = this;
            node = __this.getNode(id);
            webix.message.hideAll();

            _this.MessageContext.show(
                node,
                {
                    type: "slide",
                    subtype: "t",
                    duration: 500,
                    pos: "bottom",
                    x: -6,
                    y: SkinHelper.IsFilterUiSkin() || SkinHelper.IsVulkanSkin() ? -5 : -10
                }
            )
        }
    }

};

MessagesWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    _this.Subscriptions.SignalMessagesNew = App.SessionManager.SignalMessagesNew.subscribe(function (New)
    {
        if (New)
        {
            _this.Refresh();
        }
    });

    this.Subscriptions.UnreadedMessageCount = App.SessionManager.UnreadedMessageCount.subscribe(function (Count)
    {
        _this.DefineBtnBadge(Count);
    });

    this.MessageContext.attachEvent("onShow", function()
    {
        _this.Refresh();
    });
};

MessagesWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

MessagesWidget.prototype.ParseMessages = function(Obj)
{
    var _this = this;
    var params = {
        icon: "",
        message_date: _this.ParseDateTime(Obj.date),
        title: "",
        textMessage: Obj.text,
        type: Obj.type
    };

    switch(params.type)
    {
        case SocketNotificationsTypeEnum.success:
            params.icon = "fa-check-circle";
            break;
        default:
            params.icon = "fa-exclamation-circle";
            break;
    }

    params.icon += " icon-" + params.type;

    return this.MessageTemplate(params);
};

MessagesWidget.prototype.ParseDateTime = function(DateTime)
{
    return (webix.Date.dateToStr("%d.%m.%Y %H:%i"))(new Date(DateTime));
};

MessagesWidget.prototype.MessageTemplate = function(Params)
{
    return "<div class='messages'>" +
        "<div class='messages-header'>" +
        "<div class='messages-icon'><span class=\"webix_icon " + Params.icon + "\"></span></div>" +
        "<div class='messages-date'>" + Params.message_date + "</div>" +
        "</div>" +
        "<div class='messages-body'>" +
        "<div class='messages-body-content'>" +
        "<div class='messages-content'>" + Params.textMessage + "</div>" +
        "</div>" +
        "<div class='messages-body-buttons'>" +
        "<span class='webix_icon fa-angle-right'></span>" +
        "</div>" +
        "</div>" +
        "" +
        "</div>";
};

MessagesWidget.prototype.Refresh = function()
{
    var _this = this;
    const savedMessages = App.SessionManager.GetPreference('SavedMessages', true);

    this.Views.MessagesTable.unselectAll();
    this.Views.MessagesTable.clearAll();
    this.Views.MessagesTable.parse(savedMessages);
};

MessagesWidget.prototype.GetTableSelectedData = function ()
{
    return this.Views.MessagesTable.getSelectedItem();
};

MessagesWidget.prototype.OnTableSelectChanged = function ()
{
    var data = this.GetTableSelectedData();
    this.MessagesTableSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

MessagesWidget.prototype.DeleteSelectedMessage = function()
{
    const _this = this;

    let
        selectedData = this.GetTableSelectedData(),
        savedMessages = App.SessionManager.GetPreference('SavedMessages', true);

    if(selectedData)
    {
        if(!Array.isArray(selectedData))
        {
            selectedData = [selectedData];
        }

        let messages = [];

        for (const savedMessage of savedMessages) {
            if (savedMessage.id !== selectedData[0].id)
                messages.push(savedMessage);
        }

        App.SessionManager.SetPreference("SavedMessages", messages, true);

        _this.Views.MessagesTable.remove(selectedData[0].id);
    }
};

MessagesWidget.prototype.ShowMoreInfo = function(Data)
{
    var _this = this;

    var data = Data;

    if(!Data)
    {
        var item = this.Views.MessagesTable.getSelectedItem();

        if(item)
        {
            data = item;
        }
    }

    var icon = "";
    switch(data.type)
    {
        case SocketNotificationsTypeEnum.success:
            icon = "fa-check-circle";
            break;
        default:
            icon = "fa-exclamation-circle";
            break;
    }

    this.Views.MessageType.define("template", "<b class='icon-" + data.type +"'><span class=\"webix_icon " + icon + "\"></span>" + SocketNotificationsTypeDic[data.type].value + "</b>");
    this.Views.MessageType.refresh();

    this.Views.MessageStatus.define("template","<b>" + SocketNotificationsStatusDic[data.status_read].value + "</b>");
    this.Views.MessageStatus.refresh();

    this.Views.MessageDate.define("template", "<b>" +  _this.ParseDateTime(data.date) + "</b>");
    this.Views.MessageDate.refresh();

    var content = "<div style=\"height:inherit;width:100%;overflow-y:auto\">";

    content += data.text.replace(/\n/g, "<br>");

    content += "</div>";
    this.Views.MessageContent.define("template", content);
    this.Views.MessageContent.refresh();

    this.Views.MoreInfoMessages.show();

    if (data.status_read === "new")
    {
        _this.ReadMessages();
    }
};

MessagesWidget.prototype.DeleteMessages = function(ContextHide = "", DeleteAll = false)
{
    const _this = this;

    if (ContextHide)
    {
        ContextHide.hide();
        $$(_this.Id + "DeletePopup").hide();
    }

    let messages = [];

    if(DeleteAll)
    {
        App.SessionManager.SetPreference("SavedMessages", [], true);
    }
    else
    {
        let
            selectedData = this.GetTableSelectedData(),
            savedMessages = App.SessionManager.GetPreference('SavedMessages', true),
            selectedDataIds = [];

        if (!selectedData)
        {
            return;
        }

        if(!Array.isArray(selectedData))
        {
            selectedDataIds.push(selectedData.id);
        }
        else
        {
            for (const elem in selectedData)
            {
                selectedDataIds.push(selectedData[elem].id);
            }
        }

        for (const savedMessage of savedMessages) {
            if (!selectedDataIds.includes(savedMessage.id))
            {
                messages.push(savedMessage);
            }
        }

        App.SessionManager.SetPreference("SavedMessages", messages, true);

        _this.Views.MessagesTable.remove(selectedDataIds);
    }

    let unreadMessage = messages.filter(item => item.status_read === "new").length;
    App.SessionManager.UnreadedMessageCount.next(unreadMessage);
    _this.Refresh();
}

MessagesWidget.prototype.ReadMessages = function(ReadAll = false)
{
    const _this = this;

    let
        selectedData = ReadAll ? _this.Views.MessagesTable.serialize() : this.GetTableSelectedData(),
        savedMessages = App.SessionManager.GetPreference('SavedMessages', true),
        selectedDataIds = [];

    if (!selectedData)
    {
        return;
    }

    if(!Array.isArray(selectedData))
    {
        selectedDataIds.push(selectedData.id);
        selectedData = [selectedData];
    }
    else
    {
        for (const elem in selectedData)
        {
            selectedDataIds.push(selectedData[elem].id);
        }
    }

    let messages = [];

    for (const savedMessage of savedMessages) {
        if (selectedDataIds.includes(savedMessage.id))
        {
            savedMessage.status_read = "read";
            messages.push(savedMessage);
            continue;
        }

        messages.push(savedMessage);
    }

    App.SessionManager.SetPreference("SavedMessages", messages, true);

    for (const selData in selectedData)
    {
        if (selectedDataIds.includes(selectedData[selData].id))
        {
            selectedData[selData].status_read = "read";
            _this.Views.MessagesTable.updateItem(selectedData[selData].id, selectedData);
        }
    }

    let unreadMessage = messages.filter(item => item.status_read === "new").length;
    App.SessionManager.UnreadedMessageCount.next(unreadMessage);
}

MessagesWidget.prototype.DefineBtnBadge = function (Count)
{
    var count = Count >= 100 ? "99+" : Count;
    this.Views.MessagesBtn.define({badge:AppButtonBadgeTemplate(count)});
    this.Views.MessagesBtn.refresh();
};
/* global App */
/* global webix */
/* global $$ */

function NoFoundViewController(Params)
{
    "use strict";

    this.view = [
        {},
        {
            cols:[
                {},
                {
                    view:"label",
                    label: LangHelper.GetString("All", "No found"),
                    align:"center"
                },
                {}
            ]

        },
        {}
    ];

    this.Init(Params);
}

NoFoundViewController.prototype.Init = function(Params)
{
    "use strict";
};

NoFoundViewController.prototype.ViewDidLoad = function(Params)
{
    "use strict";

    App.NavRouter.views.AppView.UnselectAllAppMenuSidebarItems();

};
/* global App */
/* global webix */
/* global $$ */

function ForbitenViewController(Params)
{
    "use strict";

    this.view = [
        {},
        {
            cols:[
                {},
                {
                    view:"label",
                    label: LangHelper.GetString("All", "Access denied"),
                    align:"center"
                },
                {}
            ]

        },
        {}
    ];

    this.Init(Params);
}

ForbitenViewController.prototype.Init = function(Params)
{
    "use strict";
};

ForbitenViewController.prototype.ViewDidLoad = function(Params)
{
    "use strict";

    App.NavRouter.views.AppView.UnselectAllAppMenuSidebarItems();

};
function HardwareLogsViewController(Params)
{
    var _this = this;

    //window.Test = this;

    this.IdsEnum =
    {
        HardwareLogs:"HardwareLogs",
        UlrIgwNodeLogs:"UlrIgwNodeLogs",
        UlrPCAPLogs:"UlrPCAPLogs",
        BalancerLogs:"BalancerLogs",
        HotspotLogs: "HotspotLogs"
    };

    this.Id = Params&&Params.Id?Params.Id:this.IdsEnum .HardwareLogs;

    this.mode = module ? module : "dpiui2";

    this.Embedded = Params && Params.Embedded ? Params.Embedded : false;
    this.DontGetLogsListsBeforeHardwareIdSet = Params && Params.DontGetLogsListsBeforeHardwareIdSet ? Params.DontGetLogsListsBeforeHardwareIdSet : false;

    this.PageTitle = Params&&Params.PageTitle?Params.PageTitle:{
        RootTitle: LangHelper.GetString("AppView", "Administrator"),
        Title: LangHelper.GetString("AppView", "Hardware logs")
    };

    this.ViewModel = new HardwareLogsManager({
        ServerMethods:Params&&Params.ServerMethods?Params.ServerMethods:null
    });

    this.UseCurrentHardwareId = Params && Params.UseCurrentHardwareId ? Params.UseCurrentHardwareId : false;

    this.HardwareIdToUse = 0;

    this.HwListSidebar = Params && Params.HwListSidebar ? Params.HwListSidebar : null;

    this.PathsNamesMap = Params&&Params.PathsNamesMap?Params.PathsNamesMap:{};
    this.FileNamesInfoMap = Params&&Params.FileNamesInfoMap?Params.FileNamesInfoMap:{};

    this.Views = {
        FilesTree:null,
        RefreshFilesList:null,

        FileLabel:null,
        TailSelect:null,
        TailCountSelect:null,
        Search:null,
        FilePad:null,
        FileBlock:null,
        FileContent:null,

        Widgets:{},
        ReportsWidgets:{},

        HardwareList:null,
        Body:null
    };

    this.isUlrIgwNodeLogs = _this.Id === _this.IdsEnum.UlrIgwNodeLogs;
    this.isUlrPCAPLogs = _this.Id === _this.IdsEnum.UlrPCAPLogs;

    if(this.isUlrIgwNodeLogs)
    {
        this.ReportsModel = new UniReportsManager();

        this.Views.ReportsWidgets.IgwsNodesSelectReport = UrlIgwsNodesListSelectWidget({
            id:this.Id + "IgwsNodesSelectReport",
            enableTextSearch:1,
            enableAutoHeight:0
        });
    }

    if(this.isUlrPCAPLogs)
    {
        this.ReportsModel = new UniReportsManager();

        this.Views.ReportsWidgets.PCAPHwListSelectReport = UrlPCAPHwListSelectWidget({
            id:this.Id + "PCAPHwListSelectReport",
            enableAutoHeight:0
        });
    }

    this.ViewConfig = function ()
    {
        var config = [
            {
                cols:function ()
                {
                    var cols = [];

                    if(!_this.Embedded)
                    {
                        if(_this.Id !== _this.IdsEnum.UlrIgwNodeLogs && _this.Id !== _this.IdsEnum.UlrPCAPLogs)
                        {
                            cols.push(Params && Params.LeftSideBar ? Params.LeftSideBar : AdministratorLeftSideBarView({id:_this.Id}));
                        }

                        if(_this.isUlrIgwNodeLogs)
                        {
                            cols.push({
                                header:LangHelper.GetString("UlrModule","Hardware list"),
                                body:{
                                    width:240,
                                    rows:[
                                        _this.Views.ReportsWidgets.IgwsNodesSelectReport.ViewConfig
                                    ]
                                }
                            });
                            cols.push({view:"resizer"});
                        }

                        if(_this.isUlrPCAPLogs)
                        {
                            cols.push({
                                header:LangHelper.GetString("UlrModule","PCAP Servers"),
                                body:{
                                    width:240,
                                    rows:[
                                        _this.Views.ReportsWidgets.PCAPHwListSelectReport.ViewConfig
                                    ]
                                }
                            });
                            cols.push({view:"resizer"});
                        }
                    }

                    cols.push({
                        type: "space",
                        rows: [
                            {
                                type: "clear",
                                borderless: true,
                                rows:function ()
                                {
                                    var rows = [];

                                    var header = PageHeaderTemplate({
                                        id:_this.Id + "PageTitle",
                                        root_title: _this.isUlrIgwNodeLogs || _this.isUlrPCAPLogs ? _this.PageTitle.Title : _this.PageTitle.RootTitle,
                                        title: _this.isUlrIgwNodeLogs || _this.isUlrPCAPLogs ? "" : _this.PageTitle.Title
                                    });

                                    var body = {
                                        id:_this.Id+"Body",
                                        cols:function ()
                                        {
                                            var cols = [];

                                            cols.push({
                                                width:240,
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        elements:[
                                                            {},
                                                            {
                                                                view: "button",
                                                                id:_this.Id + "RefreshFilesList",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("HardwareLogs", "Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.RefreshFilesList();
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    BlockHeaderTemplate({title:LangHelper.GetString("HardwareLogs","Files"), icon:"list"}),
                                                    {
                                                        view: "treetable",
                                                        id:_this.Id + "FilesTree",
                                                        select: "row",
                                                        columns:[
                                                            {
                                                                id: "filename",
                                                                header: [LangHelper.GetString("HardwareLogs","File"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                template: function(obj, common, value, config)
                                                                {
                                                                    return common.treetable(obj, common, value, config) + (obj.filename ? obj.filename : _this.PathsNamesMap[obj.path]);
                                                                },
                                                                fillspace: true,
                                                                sort: "string"
                                                            },
                                                            {
                                                                id: "info",
                                                                header:"",
                                                                width: 40,
                                                                template: function(obj, common, value, config)
                                                                {
                                                                    if(_this.FileNamesInfoMap && obj && obj.filename && _this.FileNamesInfoMap[obj.filename])
                                                                    {
                                                                        return CellQuestionBtnTemplate();
                                                                    }
                                                                    return "";
                                                                }
                                                            }
                                                        ],
                                                        on:{
                                                            onAfterSelect: function (Data, Preserve)
                                                            {
                                                                var data = this.getItem(Data.id);

                                                                _this.Signals.FileSelected.next(data);
                                                            },
                                                            onAfterUnSelect: function(Data, Preserve)
                                                            {
                                                                _this.Signals.FileSelected.next(null);
                                                            }
                                                        },
                                                        onClick: {
                                                            "fa-question-circle": function(ev, id)
                                                            {
                                                                var __this = this;

                                                                setTimeout(function ()
                                                                {
                                                                    var item = __this.getItem(id);
                                                                    var node = __this.getItemNode(id);

                                                                    var popup = webix.ui({
                                                                        view:"popup",
                                                                        height:80,
                                                                        width:320,
                                                                        body:{
                                                                            borderless:true,
                                                                            template:_this.FileNamesInfoMap[item.filename]
                                                                        }
                                                                    });
                                                                    popup.show(node);
                                                                },1);
                                                            }
                                                        },
                                                    }
                                                ]
                                            });
                                            cols.push({view:"resizer"});
                                            cols.push({
                                                minWidth:1,
                                                id:_this.Id + "FilePad",
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:40,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "download",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("HardwareLogs","Download the complete file"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var __this = this;
                                                                    __this.disable();
                                                                    _this.DownloadFile();
                                                                    setTimeout(() => {__this.enable();}, 500);
                                                                }
                                                            },{
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "file-archive",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("HardwareLogs","Download zipped file"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var __this = this;
                                                                    __this.disable();
                                                                    _this.DownloadFile(null, true);
                                                                    setTimeout(() => {__this.enable();}, 500);
                                                                }
                                                            },
                                                            {
                                                                view:"label",
                                                                id:_this.Id + "FileLabel",
                                                                label:""
                                                            },
                                                            {},
                                                            {
                                                                view:"search",
                                                                id:_this.Id+"Search",
                                                                placeholder:LangHelper.GetString("HardwareLogs","Search (Grep)"),
                                                                label:"",
                                                                labelWidth:0,
                                                                keyPressTimeout:1000,
                                                                on:{
                                                                    onTimedKeyPress:function ()
                                                                    {
                                                                        _this.RefreshFileContent();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view:"richselect",
                                                                id:_this.Id+"TailSelect",
                                                                label:LangHelper.GetString("HardwareLogs","Tail"),
                                                                tooltip: LangHelper.GetString("HardwareLogs","Tail"),
                                                                options:[
                                                                    {id:"10", value:"10"},
                                                                    {id:"100", value:"100"},
                                                                    {id:"1000", value:"1000"},
                                                                    {id:"10000", value:"10000"}
                                                                ],
                                                                value:"1000",
                                                                width:LangHelper.GetLocale() === LocalesEnum.ru.code?130:120,
                                                                labelWidth:LangHelper.GetLocale() === LocalesEnum.ru.code?50:40,
                                                                on:{
                                                                    onChange:function (Nv, Ov)
                                                                    {
                                                                        _this.RefreshFileContent();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view:"richselect",
                                                                id:_this.Id+"TailCountSelect",
                                                                label:LangHelper.GetString("HardwareLogs","Lines"),
                                                                tooltip: LangHelper.GetString("HardwareLogs","Lines before and after the match"),
                                                                options:[
                                                                    {id:"0", value:"0"},
                                                                    {id:"1", value:"1"},
                                                                    {id:"2", value:"2"},
                                                                    {id:"3", value:"3"},
                                                                    {id:"4", value:"4"},
                                                                    {id:"5", value:"5"},
                                                                    {id:"6", value:"6"},
                                                                    {id:"7", value:"7"},
                                                                    {id:"8", value:"8"},
                                                                    {id:"9", value:"9"},
                                                                    {id:"10", value:"10"}
                                                                ],
                                                                value:"0",
                                                                width:LangHelper.GetLocale() === LocalesEnum.ru.code?125:110,
                                                                labelWidth:LangHelper.GetLocale() === LocalesEnum.ru.code?65:50,
                                                                on:{
                                                                    onChange:function (Nv, Ov)
                                                                    {
                                                                        _this.RefreshFileContent();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("HardwareLogs","Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.RefreshFileContent();
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        id:_this.Id + "FileBlock",
                                                        rows:[
                                                            BlockHeaderTemplate({title: LangHelper.GetString("HardwareLogs","Log file content"), icon: "file"}),
                                                            {
                                                                view:"codemirror-editor",
                                                                id:_this.Id + "FileContent"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            });

                                            return cols;
                                        }()
                                    };

                                    if(_this.HwListSidebar)
                                    {
                                        body = {
                                            view: "accordion",
                                            multi: "mixed",
                                            on:{
                                                onAfterExpanded: function()
                                                {
                                                    return true;
                                                }
                                            },
                                            cols:
                                                [
                                                    {
                                                        header: _this.HwListSidebar.Title ? _this.HwListSidebar.Title : "",
                                                        gravity: _this.Id == _this.IdsEnum.BalancerLogs ? 1.2 : 1,
                                                        body:{
                                                            view: "datatable",
                                                            id: _this.Id + "HardwareList",
                                                            header:false,
                                                            select: "row",
                                                            tooltip:true,
                                                            columns: [
                                                                {
                                                                    id: "value",
                                                                    header: LangHelper.GetString(_this.Id,"Hardware"),
                                                                    width: 120,
                                                                    fillspace: true,
                                                                    sort: "string"
                                                                },
                                                            ],
                                                            on: {
                                                                onAfterLoad:function()
                                                                {
                                                                    if (!this.count())
                                                                    {
                                                                        this.showOverlay(_this.HwListSidebar.EmptyText ? _this.HwListSidebar.EmptyText : "");
                                                                    }
                                                                },
                                                                onAfterSelect: function(id)
                                                                {
                                                                    var item = this.getItem(id);
                                                                    setTimeout(function()
                                                                    {
                                                                        _this.ViewModel.SetHwId(item.id);
                                                                        _this.RefreshFilesList();
                                                                    }, 1);
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {view:"resizer"},
                                                    {
                                                        header: LangHelper.GetString(_this.Id,"Logs"),
                                                        gravity: 6,
                                                        body:body
                                                    }
                                                ]
                                        };
                                    }

                                    if(_this.Embedded)
                                    {
                                        rows = [body]
                                    }
                                    else
                                    {
                                        if(_this.isUlrIgwNodeLogs || _this.isUlrPCAPLogs)
                                        {
                                            rows = [
                                                {
                                                    //type: "clean",
                                                    //borderless:true,
                                                    rows: [
                                                        {height:6},
                                                        header,
                                                        {height:32},
                                                        body
                                                    ]
                                                }
                                            ];
                                        }
                                        else
                                        {
                                            rows = [
                                                header,
                                                body
                                            ];
                                        }
                                    }

                                    return rows;
                                }()
                            }
                        ]
                    });

                    return cols;
                }()
            }
        ];

        return config;
    }();

    this.Subscriptions = {};

    this.Signals =
    {
        FileSelected: new Rx.BehaviorSubject(null)
    };
}

HardwareLogsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    webix.extend(this.Views.FilePad, webix.OverlayBox);
    webix.extend(this.Views.Body, webix.OverlayBox);

    this.Subscriptions.FilesListLoaded = this.ViewModel.Signals.FilesListLoaded.subscribe(function (FilesListModel)
    {
        if(FilesListModel)
        {
            _this.UpdateFilesList(FilesListModel);
        }
    });

    this.Subscriptions.FilesListLoadError = this.ViewModel.Signals.FilesListLoadError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.FileSelected = this.Signals.FileSelected.subscribe(function (FileSelected)
    {
        if(FileSelected)
        {
            _this.Views.FileLabel.define("label", (FileSelected.filename ? FileSelected.filename : _this.PathsNamesMap[FileSelected.path]));
            _this.Views.FileLabel.refresh();

            if(FileSelected.filename)
            {
                _this.HideFileContentOverflow();
                _this.RefreshFileContent(FileSelected);
            }
            else
                _this.ShowFileContentOverflow("Folder");
        }
        else
        {
            _this.Views.FileLabel.define("label", "");
            _this.Views.FileLabel.refresh();
            _this.Views.FileContent.setValue("");
            _this.ShowFileContentOverflow();
        }
    });

    this.Subscriptions.LogFileTailLoaded = Rx.Observable.combineLatest
    (
        this.ViewModel.Signals.LogFileTailLoaded,
        this.Signals.FileSelected
    ).subscribe(function(Val)
        {
            var fileTailModel = Val[0];
            var fileSelectedModel = Val[1];

            if(fileTailModel && fileSelectedModel && fileTailModel.filename && fileTailModel.filename == fileSelectedModel.filename)
            {
                _this.Views.FileContent.setValue(fileTailModel.content);

                var editor = _this.Views.FileContent.getEditor();
                if(editor)
                {
                    var scrollInfo = editor.getScrollInfo();

                    if(scrollInfo && scrollInfo.height)
                    {
                        editor.scrollTo(0, scrollInfo.height);
                    }
                }
                // setTimeout(function(){
                //
                // }, 10);
            }
        }
    );

    this.Subscriptions.LogFileTailLoadError = this.ViewModel.Signals.LogFileTailLoadError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    if(this.UseCurrentHardwareId)
    {

        if(_this.isUlrIgwNodeLogs || _this.isUlrPCAPLogs)
        {
            var hwId = App.NavRouter.GetPathParam("_id", this);

            if(hwId)
            {
                App.SessionManager.SetCurrentHardwareId(hwId);
                App.SessionManager.CurrentHardwareConnected.next(1);
            }

            if (_this.isUlrIgwNodeLogs)
                this.Views.ReportsWidgets.IgwsNodesSelectReport.RefreshData();
            else if (_this.isUlrPCAPLogs)
                this.Views.ReportsWidgets.PCAPHwListSelectReport.RefreshData();
        }
        else
        {
            this.Subscriptions.CurrentHardwareChanged = App.SessionManager.CurrentHardwareId.subscribe(function(Val){

                _this.RefreshFilesList();
            });
        }
    }
    else if(!this.HwListSidebar)
    {
        this.RefreshFilesList();
    }

    if(this.Views.ReportsWidgets.IgwsNodesSelectReport || this.Views.ReportsWidgets.PCAPHwListSelectReport)
    {
        let prefix = _this.Id === _this.IdsEnum.UlrIgwNodeLogs ? "IgwsNodesSelectReport" : "PCAPHwListSelectReport";
        this.Subscriptions[`${prefix}DataSignalSubscription`] = this.Views.ReportsWidgets[prefix].GetReportConfig().signal.subscribe(function (Updated)
        {
            if(Updated)
            {
                var table = _this.Views.ReportsWidgets[prefix].Views.Table;

                var hwId = parseInt(App.SessionManager.GetCurrentHardwareId());

                if(hwId)
                {
                    var data = table.find(function(Obj)
                    {
                        return parseInt(Obj.hardware_id) === hwId;
                    });
                }

                if(data && Array.isArray(data) && data.length)
                {
                    table.select(data[0].id);
                }
                else
                {
                    var first = table.getFirstId();

                    if(first)
                        table.select(first);
                }

                if(table.serialize().length)
                {
                    if(!_this.Subscriptions.CurrentHardwareChanged)
                    {
                        _this.Subscriptions.CurrentHardwareChanged = App.SessionManager.CurrentHardwareId.subscribe(function(Val){

                            _this.RefreshFilesList();
                        });
                    }
                }

                //var hwId = data.hardware_id ? data.hardware_id : 0;
            }
        });

        var table = _this.Views.ReportsWidgets[prefix].Views.Table;

        table.attachEvent("onAfterSelect", function(Selection, Preserve)
        {
            var table = this;

            var data = table.getItem(Selection);

            var hwId = data&&data.hardware_id ? data.hardware_id : 0;

            App.SessionManager.SetCurrentHardwareId(hwId);
            App.SessionManager.CurrentHardwareConnected.next(1);
        });
    }

    if(this.HwListSidebar)
    {
        this.ShowBodyOverlay();
        this.Subscriptions.SignalHardwaresDicUpdatedSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (Updated)
        {
            if (Updated)
            {
                var hardwares = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

                hardwares = hardwares.filter(function (Obj)
                {
                    return Obj.hardware_type == _this.HwListSidebar.ListType;
                });

                _this.Views.HardwareList.clearAll();
                _this.Views.HardwareList.parse(hardwares);

                if(hardwares.length)
                {
                    _this.Views.HardwareList.select(hardwares[0].id);
                    _this.HideBodyOverlay();
                }

            }
        });
    }
};

HardwareLogsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.PathParams = Params;

    if(!_this.Embedded)
    {
        webix.ready(function () {
            if($$(_this.Id+"LeftSideBar"))
                $$(_this.Id+"LeftSideBar").select(_this.Id);
        });
    }

    this.BindAll(Params);
};

HardwareLogsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

};

HardwareLogsViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};

HardwareLogsViewController.prototype.RefreshFilesList = function ()
{
    var params = {};

    if(this.UseCurrentHardwareId)
    {
        params.hardware_id = parseInt(App.SessionManager.GetCurrentHardwareId());
    }

    if(this.HardwareIdToUse)
    {
        params.hardware_id = parseInt(this.HardwareIdToUse);
    }

    if(this.DontGetLogsListsBeforeHardwareIdSet && !params.hardware_id)
    {
        return;
    }

    this.ViewModel.RefreshLogsFilesList(params);
};

HardwareLogsViewController.prototype.RefreshFileContent = function (FileModel)
{
    var fileModel = FileModel ? FileModel : this.Signals.FileSelected.getValue();

    if(fileModel && fileModel.filename)
    {
        var params = webix.extend(fileModel, {
            tail:parseInt(this.Views.TailSelect.getValue()),
            lines:parseInt(this.Views.TailCountSelect.getValue()),
            grep:this.Views.Search.getValue()
        }, true);

        if(this.UseCurrentHardwareId)
        {
            params.hardware_id = parseInt(App.SessionManager.GetCurrentHardwareId());
        }

        if(this.HardwareIdToUse)
        {
            params.hardware_id = parseInt(this.HardwareIdToUse);
        }

        if(this.DontGetLogsListsBeforeHardwareIdSet && !params.hardware_id)
        {
            return;
        }

        this.ViewModel.GetLogFileTail(params);
    }
};

HardwareLogsViewController.prototype.DownloadFile = function (FileModel, Zip)
{
    var params = FileModel ? FileModel : this.Signals.FileSelected.getValue();

    if(params && params.filename)
    {
        if(this.UseCurrentHardwareId)
        {
            params.hardware_id = parseInt(App.SessionManager.GetCurrentHardwareId());
        }

        if(this.HardwareIdToUse)
        {
            params.hardware_id = parseInt(this.HardwareIdToUse);
        }

        if(this.DontGetLogsListsBeforeHardwareIdSet && !params.hardware_id)
        {
            return;
        }

        if(Zip)
            params.zip_before_download = true;
        else
            delete params.zip_before_download;

        this.ViewModel.DownloadLogFile(params);
    }

};

HardwareLogsViewController.prototype.UpdateFilesList = function (FilesListModel)
{
    var table = this.Views.FilesTree;

    table.clearAll();
    table.parse(FilesListModel);
};

HardwareLogsViewController.prototype._GetOverflowTemplateFolder = function ()
{
    var tpl = '<div class="of-empty-folder">' +
              ' <div class="of-empty-pad">' +
              '     <div class="of-empty-folder-bg webix_icon fa-folder"></div>' +
              ' </div>' +
              '</div>';

    return tpl;
};

HardwareLogsViewController.prototype._GetOverflowTemplateSelectFile = function ()
{
    var tpl = '<div class="of-empty-folder">' +
        ' <div class="of-empty-pad">' +
        '     <div class="of-empty-cloud-txt">'+LangHelper.GetString("All", "Select file")+'</div>' +
        ' </div>' +
        '</div>';

    return tpl;
};

HardwareLogsViewController.prototype.ShowFileContentOverflow = function (Template)
{
    var _this = this;

    var template = Template ? Template : "SelectFile";

    _this.Views.FilePad.showOverlay(_this["_GetOverflowTemplate"+template]());
    //_this.Views.FileBlock.hide();

    // var editorPromise = _this.Views.FileContent.getEditor(true);
    //
    // editorPromise.then(function(Editor)
    // {
    //     _this.Views.FileContent.showOverlay(_this._GetOverflowTemplateFolder());
    // });
};

HardwareLogsViewController.prototype.HideFileContentOverflow = function ()
{
    this.Views.FilePad.hideOverlay();
    //this.Views.FileBlock.show();
};

HardwareLogsViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

HardwareLogsViewController.prototype.ShowBodyOverlay = function ()
{
    this.Views.Body.showOverlay("");
}

HardwareLogsViewController.prototype.HideBodyOverlay = function ()
{
    this.Views.Body.hideOverlay();
}

function SubscriberEditFormDisplayConfig(Params, DefaultValues)
{
    this.profile = new SubscriberEditFormProfileDisplayConfig(Params && Params.profile ? Params.profile : null, DefaultValues);
    this.ping = Params && Params.ping ? Params.ping : DefaultValues;
    this.auth = Params && Params.auth ? Params.auth : DefaultValues;
    this.props = Params && Params.props ? Params.props : DefaultValues;
};

function SubscriberEditFormProfileDisplayConfig(Params, DefaultValues)
{
    this.show = Params && Params.show ? Params.show : DefaultValues;
    this.services = Params && Params.services ? Params.services : DefaultValues;
    this.tariffs = Params && Params.tariffs ? Params.tariffs : DefaultValues;
    this.login = Params && Params.login ? Params.login : DefaultValues;
};

function SubscriberEditFormViewController(Params)
{
    var _this = this;

    this.Id = "SubscriberEditForm";

    this.Data = null;

    this.Rows = null;
    this.ShowSubscriberItems = true;
    this.ShowServicesItems = true;
    this.ShowTariffItems = true;

    this.ShowAsModalForm = true;

    this.PolicingManager = new PolicingProfilesManager();

    this.DisplayConfig = new SubscriberEditFormDisplayConfig();

    this.ViewConfig = null;

    // this.window = {
    //     view: "window",
    //     id: this.Id,
    //     maxWidth: 1200,
    //     maxHeight: 600,
    //     position: "center",
    //     modal: true,
    //     body: {
    //     },
    //     head: {
    //         view: "toolbar", cols: [
    //             {view: "label", label: "Карточка абонента"},
    //             {},
    //             {view: "button", label: 'Закрыть', width: 100, click: "$$('"+_this.Id+"').hide();"},
    //             {view: "button", type:"form", label: "Сохранить", width: 115, click: "$$('"+_this.Id+"').hide();"}
    //         ]
    //     }
    // };

    this.ClearAuthStateContext = webix.ui({
        view:"popup",
        width:300,
        // height:240,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    height: 48,
                    borderless: true,
                    template:LangHelper.GetString("Subscribers","Are you sure you want to reset the authorization status of subscribers?")
                },
                {
                    height: 72,
                    borderless: true,
                    template: LangHelper.GetString("Subscribers", "The authorization status is set to \"unknown\", which will lead to L3-authorization request as the packet from the subscriber arrives.")
                },
                {
                    borderless: true,
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ClearAuthStateContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Reset"),
                            click:function ()
                            {
                                _this.ResetAuthState();
                                _this.ClearAuthStateContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.DeleteAuthPropContext = webix.ui({
        view:"popup",
        width:300,
        // height:240,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    height: 48,
                    borderless: true,
                    template:LangHelper.GetString("Subscribers","Are you sure you want to delete the L2-props of subscribers?")
                },
                {
                    borderless: true,
                    height: 72,
                    template: LangHelper.GetString("Subscribers", "This command actually removes the IP address from the internal database. To remove a specific subscriber property, use subs prop set.")
                },
                {
                    borderless: true,
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.DeleteAuthPropContext.hide();
                            }
                        },
                        {
                            view:"button",
                            // id: this.Id + "DeleteAuthPropContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.DeleteAuthProps();
                                _this.DeleteAuthPropContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ContextConfig = {
        view: "popup",
        maxWidth: 720,
        maxHeight: 720,
        id:this.Id + "Context",
        modal: true,
        body: {
            borderless:true,
            rows:[]
        }
    };

    this.Context = null;

    this.Views = {
        Self:null,
        ServicesTable:null,
        LoginField:null,
        IpField:null,
        BindType:null,
        PolicingField: null,
        SubscriberForm:null,
        SubscriberFormTitle:null,
        SubscriberFormPolicing: null,
        PingForm: null,
        AuthStateInfoPanel: null,
        AuthStateForm: null,
        Ping: null,
        L2PropsInfoLabel: null,
        L2PropsForm: null,
        Tabbar: null
    };

    this.Widgets = {
        Ping: null
    };

    this.SaveDataSinal = new Rx.BehaviorSubject(null);
    this.SetAuthStateSignal = new Rx.BehaviorSubject(null);
    this.ResetAuthStateSignal = new Rx.BehaviorSubject(null);
    this.SetAuthPropSignal = new Rx.BehaviorSubject(null);
    this.DeleteAuthPropSignal = new Rx.BehaviorSubject(null);
    this.SyncAuthPropSignal = new Rx.BehaviorSubject(null);
    this.OnHide = new Rx.BehaviorSubject(null);

    this.OverlayVisible = false;

    this.onClose = null;

    this.Subscriptions = {};

    this.Init(Params);

    return this;
}

SubscriberEditFormViewController.prototype.Init = function (Params)
{
    if(Params)
    {
        if (Params.data)
        {
            this.Data = Params.data;
        }

        if (Params.embedded)
        {
            this.ShowAsModalForm = false;
        }

        if (Params.servicesOnly)
        {
            this.ShowSubscriberItems = false;
            this.ShowServicesItems = true;
            this.ShowTariffItems = false;
        }

        if (Params.tariffOnly)
        {
            this.ShowSubscriberItems = false;
            this.ShowServicesItems = false;
            this.ShowTariffItems = true;
        }

        if(Params.hideServices)
        {
            this.ShowServicesItems = false;
        }

        if(Params.displayConfig)
        {
            this.DisplayConfig = new SubscriberEditFormDisplayConfig(Params.displayConfig);
        }

        if(Params.onClose && typeof Params.onClose === "function")
        {
            this.onClose = Params.onClose;
        }
    }

    this.Id += this.ShowAsModalForm ? "" : "Embedded";

    if(this.DisplayConfig.ping)
    {
        this.Widgets.Ping = new SshTerminalWidget({
            // id: this.Id + "PingTerminal",
            hardware: App.SessionManager.GetCurrentHardwareId(),
            model: {
                hardware_id: App.SessionManager.GetCurrentHardwareId(),
                hardware_type: HardwareTypesDic.dpiui2.id
            },
            useDics: false,
            onViewShow: true
        });
    }

    this.ConfigRows();
    // this.DicsManager = Params && Params.DicsManager ? Params.DicsManager : App.DicsManager;

    if(this.ShowAsModalForm)
    {
        this.ContextConfig.body.rows = this.Rows;
        this.Context = webix.ui(this.ContextConfig);
    }
    else
    {
        this.ViewConfig = {
            id:this.Id,
            rows:this.Rows
        };
    }
};

SubscriberEditFormViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);


    if(this.Data)
        this.SetData(this.Data);
};

SubscriberEditFormViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.Self = $$(this.Id);
    this.Views.ServicesTable = $$(this.Id + "ServicesTable");

    this.Views.LoginField = $$(this.Id + "LoginField");
    this.Views.IpField = $$(this.Id + "IpField");
    this.Views.BindType = $$(this.Id + "BindTypeField");
    this.Views.IdentityType = $$(this.Id + "IdentityTypeField");
    this.Views.PolicingField = $$(this.Id + "PolicingField");

    this.Views.SubscriberForm = $$(this.Id+"_subscriber_form");
    this.Views.SubscriberFormTitle = $$(this.Id+"_subscriber_form_title");
    this.Views.SubscriberFormPolicing = $$(this.Id + "_tariff_form");
    this.Views.PingForm = $$(this.Id + "PingForm");
    this.Views.L2PropsStateLabel = $$(this.Id + "L2PropsStateLabel");
    this.Views.L2PropsStateLayout = $$(this.Id + "L2PropsStateLayout");
    this.Views.PingExecuteButton = $$(this.Id + "PingExecuteButton");
    this.Views.AuthStateInfoPanel = $$(this.Id + "AuthStateInfoPanel");
    this.Views.AuthStateForm = $$(this.Id + "AuthStateForm");
    this.Views.Ping = $$(this.Id + "Ping");
    this.Views.Prop = $$(this.Id + "Prop");
    this.Views.L2PropsInfoLabel = $$(this.Id + "L2PropsInfoLabel");
    this.Views.L2PropsForm = $$(this.Id + "L2PropsForm");
    this.Views.PingMainLayout = $$(this.Id + "PingMainLayout");
    this.Views.AuthMainLayout = $$(this.Id + "AuthMainLayout");
    this.Views.AuthResetBtn = $$(this.Id + "AuthResetBtn");
    this.Views.AuthSaveBtn = $$(this.Id + "AuthSaveBtn");
    this.Views.PropMainLayout = $$(this.Id + "PropMainLayout");
    this.Views.PropDeleteBtn = $$(this.Id + "PropDeleteBtn");
    this.Views.PropSaveBtn = $$(this.Id + "PropSaveBtn");
    this.Views.Tabbar = $$(this.Id + "Tabbar");

    if(!this.ShowAsModalForm)
    {
        webix.extend(this.Views.Self, webix.OverlayBox);
        this.Views.Self.showOverlay();
        this.OverlayVisible = true;
    }

    if(this.Context)
    {
        this.Context.attachEvent("onHide", function()
        {
            _this.Destroy();
        });
    }

    // Object.keys(this.Widgets).forEach(function(Key){
    //     _this.Widgets[Key].Bind(_this);
    // });

    if(this.Views.BindType)
    {
        this.Views.BindType.attachEvent("onChange", function(Val)
        {
            if(_this.Views.IdentityType)
            {
                if(Val == -1)
                {
                    _this.Views.IdentityType.show();
                    if(_this.Views.IdentityType.getValue() == SubscribersIdentitiesDic.login.id)
                    {
                        _this.Views.LoginField.show();
                        _this.Views.IpField.hide();
                    }
                    else{
                        _this.Views.IpField.show();
                        _this.Views.LoginField.hide();
                    }
                }
                else{
                    _this.Views.IdentityType.hide();
                    _this.Views.LoginField.show();
                    _this.Views.IpField.show();
                }
            }
        });
    }

    if(this.Views.IdentityType)
    {
        this.Views.IdentityType.attachEvent("onChange", function(Val){
            if(_this.Views.LoginField && _this.Views.IpField)
            {
                if(_this.Views.BindType.getValue() == -1)
                {
                    if(Val == SubscribersIdentitiesDic.login.id)
                    {
                        _this.Views.LoginField.show();
                        _this.Views.IpField.hide();
                    }
                    else{
                        _this.Views.IpField.show();
                        _this.Views.LoginField.hide();
                    }
                }
                else{
                    _this.Views.LoginField.show();
                    _this.Views.IpField.show();
                }
            }
        });
    }

    this.Subscriptions.OnPolicingProfilesChanged = App.DicsManager.Signal[DicsEnum.PolicingProfilesDic].subscribe(function(Val)
        {
            if(Val)
            {
                _this.UpdatePolicings();
            }
        }
    );

    if(this.Views.ServicesTable)
    {
        this.Views.ServicesTable.attachEvent("onCheck", function(id, column, state)
        {
            if(column == "enabled")
            {
                if(!state)
                {
                    var data = _this.Views.ServicesTable.getItem(id);
                    data.profile = 0;

                    _this.Views.ServicesTable.updateItem(id, data);
                }

            }
        });
    }

    if(this.Widgets.Ping)
    {
        if(this.Views.PingExecuteButton)
        {
            this.Subscriptions.TerminalReady = this.Widgets.Ping.Signals.TerminalReady.subscribe(function(Val){
                if(Val)
                {
                    _this.Views.PingExecuteButton.enable();
                }
                else{
                    _this.Views.PingExecuteButton.disable();
                }
            });
        }

        _this.Widgets.Ping.Bind(this);
    }
};

SubscriberEditFormViewController.prototype.ServicesTabsFromDic = function (Params)
{
    "use strict";

    var _this = this;

    var arr = Helper.DictToArr(ServicesDic);

    var tabs = [];

    arr.forEach(function (v,i) {
        var tab = {
            value:v.value,
            id:_this.GetServicesTabsIdByIndex(i)
        }
        tabs.push(tab);
    });

    return tabs;
};

SubscriberEditFormViewController.prototype.GetServicesTabsIdByIndex = function (Index)
{
    "use strict";

    var _this = this;

    var arr = Helper.DictToArr(ServicesDic);

    var id = "";

    if(arr[Index])
        id = _this.Id+"_service_tab_"+arr[Index].id;

    return id;
};

SubscriberEditFormViewController.prototype.GetSubscriberForm = function ()
{
    var _this = this;

    return [
        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "Profile"), icon:"user", id:this.Id+"_subscriber_form_title"}),
        {
            id:this.Id+"_subscriber_form",
            view:"form",
            elements:[
                {
                    view:"richselect",
                    id:this.Id+"BindTypeField",
                    name:"bind_type",
                    placeholder:LangHelper.GetString("Subscribers", "Bind type"),
                    tooltip:LangHelper.GetString("Subscribers", "Bind type"),
                    label:LangHelper.GetString("Subscribers", "Bind type"),
                    labelWidth: 160,
                    options:function(){
                        var options = [];
                        Helper.DictToArr(BindTypesDic).forEach(function (Option)
                        {
                            options.push({id:Option.id, value:Option.tooltip});
                        });

                        return options;
                    }()
                },
                {
                    view:"richselect",
                    id:this.Id+"IdentityTypeField",
                    name:"identity_type",
                    placeholder:LangHelper.GetString("Subscribers", "Identity type"),
                    tooltip:LangHelper.GetString("Subscribers", "Identity type"),
                    label:LangHelper.GetString("Subscribers", "Identity type"),
                    labelWidth: 160,
                    options:function(){
                        var options = [];
                        Helper.DictToArr(SubscribersIdentitiesDic).forEach(function (Option)
                        {
                            options.push({id:Option.id, value:Option.value});
                        });

                        return options;
                    }()
                },
                {
                    view:"text",
                    id:this.Id+"LoginField",
                    name:"login",
                    placeholder:LangHelper.GetString("Subscribers", "Login"),
                    tooltip:LangHelper.GetString("Subscribers", "Login"),
                    label:LangHelper.GetString("Subscribers", "Login"),
                    validate: function(Val){
                        return _this.LoginFieldValidatorRule(Val)
                    },
                    labelWidth: 160,
                    required: true,
                    invalidMessage: LangHelper.GetString("Subscribers", "Enter login")
                },
                {
                    view:"text",
                    id:this.Id+"IpField",
                    name:"ip",
                    placeholder:LangHelper.GetString("Subscribers", "IP-address or IP-addresss range"),
                    tooltip:LangHelper.GetString("Subscribers", "IP-address or IP-addresss range"),
                    label:LangHelper.GetString("Subscribers", "IP-address"),
                    validate: function(Val){
                        return _this.IpFieldValidatorRule(Val)
                    },
                    labelWidth: 160,
                    required: true,
                    invalidMessage: LangHelper.GetString("Subscribers", "IP-address or IP-addresss range")
                }

            ]
        }
    ];
}

SubscriberEditFormViewController.prototype.GetServicesForm = function ()
{
    var _this = this;

    return [
        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "Services"), icon:"cogs"}),
        {
            view:"datatable",
            // editable:true,
            // editaction: "click",
            id:this.Id+"ServicesTable",
            borderless:false,
            checkboxRefresh:true,
            select:"row",
            on:{
                onItemClick: function(Id)
                {
                    if(Id.column == "profile")
                    {
                        var node = this.getItemNode(Id);
                        var data = this.getItem(Id);
                        _this.EditServiceProfile({
                            node: node,
                            data: data
                        });
                    }
                    else{
                        return false;
                    }
                }
            },
            columns:[
                {
                    id:"id",
                    header:LangHelper.GetString("Subscribers", "Id"),
                    width:32
                },
                {
                    id:"value",
                    header:LangHelper.GetString("Subscribers", "Service"),
                    fillspace:true
                },
                {
                    id:"enabled",
                    header:LangHelper.GetString("Subscribers", "Enabled"),
                    template: function(obj, common, value){
                        if (value == 1)
                            return "<div class='webix_table_checkbox checked'><span class=\"webix_icon fa-check-square\"></span> " + LangHelper.GetString("All", "Yes") + "</div>";
                        else
                            return "<div class='webix_table_checkbox notchecked'><span class=\"webix_icon fa-square\"></span> " + LangHelper.GetString("All", "No") + "</div>";
                    },
                    width: 120,
                    headermenu: false

                },
                {
                    id:"profile",
                    width:200,
                    header:LangHelper.GetString("Subscribers", "Profile"),
                    template:_this.GetServiceTemplate
                }
            ],
            data:this.GetServicesData()
        }
    ]
}

SubscriberEditFormViewController.prototype.GetServicesFormOld = function ()
{
    var _this = this;

    return [
        BlockHeaderTemplate({title:"Услуги", icon:"cogs"}),
        {
            view:"tabbar",
            borderless:false,
            multiview:true,
            value:_this.GetServicesTabsIdByIndex(0),
            options: _this.ServicesTabsFromDic()
        },
        {
            view:"multiview",
            animate:false,
            cells:[
                {
                    view:"form",
                    id:_this.GetServicesTabsIdByIndex(0),
                    elements:[
                        {
                            view:"combo",
                            name:"service_black_list_profile",
                            label: 'Профиль',
                            options:Helper.DictToArr(BlProfileDic)
                        },
                        {
                            view:"checkbox",
                            name:"service_black_list_enabled",
                            labelRight:"Услуга подключена",
                            labelWidth:0
                        }
                    ]
                },
                {
                    id:_this.GetServicesTabsIdByIndex(1),
                    template:"В разработке"
                },
                {
                    id:_this.GetServicesTabsIdByIndex(2),
                    template:"В разработке"
                },
                {
                    id:_this.GetServicesTabsIdByIndex(3),
                    template:"В разработке"
                },
                {
                    id:_this.GetServicesTabsIdByIndex(4),
                    template:"В разработке"
                },
                {
                    id:_this.GetServicesTabsIdByIndex(5),
                    template:"В разработке"
                },
                {
                    id:_this.GetServicesTabsIdByIndex(6),
                    template:"В разработке"
                },
                {
                    id:_this.GetServicesTabsIdByIndex(7),
                    template:"В разработке"
                },
                {
                    id:_this.GetServicesTabsIdByIndex(8),
                    template:"В разработке"
                },
                {
                    id:_this.GetServicesTabsIdByIndex(9),
                    template:"В разработке"
                },
                {
                    id:_this.GetServicesTabsIdByIndex(10),
                    template:"В разработке"
                }
            ]
        }
    ]
}

SubscriberEditFormViewController.prototype.GetFormBtns = function ()
{
    var _this = this;

    var form = [
        {
            id:this.Id+"_btns_form",
            view:"form",
            elements:[
                {
                    cols:[
                        {
                            gravity:2
                        }
                    ]
                }
            ]
        }
    ];

    if(this.ShowAsModalForm)
    {
        form[0].elements[0].cols.push({
            view: "button",
            label: LangHelper.GetString("All", "Close"),
            click: function ()
            {
                _this.Hide();

                if(_this.onClose && typeof _this.onClose === "function")
                {
                    _this.onClose();
                }
            }
        });
    }

    form[0].elements[0].cols.push({
        view: "button",
        type: "form",
        label: LangHelper.GetString("All", "Save"),
        click: function ()
        {
            _this.Save();
        }
    });

    return form;
};

SubscriberEditFormViewController.prototype.GetTariffForm = function ()
{
    var _this = this;
    return [
        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "Tariff"), icon:"dollar"}),
        {
            id:this.Id+"_tariff_form",
            view:"form",
            elements:[
                {
                    id: _this.Id + "PolicingField",
                    view:"combo",
                    name:"policing",
                    label: LangHelper.GetString("Subscribers", "Tariff"),
                    options:[]
                }
            ]
        },
    ]
}

SubscriberEditFormViewController.prototype.ConfigRows = function ()
{
    var _this = this;

    // if(this.ShowSubscriberItems)
    //     rows = rows.concat(this.GetSubscriberForm());
    //
    // if(this.ShowServicesItems)
    //     rows = rows.concat(this.GetServicesForm());
    //
    // if(this.ShowTariffItems)
    //     rows = rows.concat(this.GetTariffForm());
    //
    // rows = rows.concat(this.GetFormBtns());

    var tabbarOptions = [];
    var tabbarViews = [];

    if(this.DisplayConfig.profile && this.DisplayConfig.profile.show)
    {
        tabbarOptions.push({
            id: this.Id + "Profile",
            value: LangHelper.GetString("Subscribers", "Profile")
        });

        var rows = [];
        if(this.DisplayConfig.profile.login)
        {
            rows = rows.concat(this.GetSubscriberForm());
        }

        if(this.DisplayConfig.profile.services)
        {
            rows = rows.concat(this.GetServicesForm());
        }

        if(this.DisplayConfig.profile.tariffs)
        {
            rows = rows.concat(this.GetTariffForm());
        }

        rows = rows.concat(this.GetFormBtns());

        tabbarViews.push({
            id: this.Id + "Profile",
            rows: rows
        })
    }

    if(this.DisplayConfig.ping)
    {
        tabbarOptions.push({
            id: this.Id + "Ping",
            value: LangHelper.GetString("Subscribers", "Ping")
        });
        tabbarViews.push({
            id: this.Id + "Ping",
            rows: _this.GetPingFormTemplate()
        })
    }

    if(this.DisplayConfig.auth)
    {
        tabbarOptions.push({
            id: this.Id + "Auth",
            value: LangHelper.GetString("Subscribers", "Authorization")
        });
        tabbarViews.push({
            id: this.Id + "Auth",
            rows: _this.GetAuthTemplate()
        })
    }

    if(this.DisplayConfig.props)
    {
        tabbarOptions.push({
            id: this.Id + "Prop",
            value: LangHelper.GetString("Subscribers", "L2-props")
        });
        tabbarViews.push({
            id: this.Id + "Prop",
            rows: _this.GetPropTemplate()
        })
    }

    var vConfig = [
        {
            view: "toolbar",
            height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 48,
            elements:[
                {
                    view: "tabbar",
                    id: this.Id + "Tabbar",
                    close: false,
                    multiview: true,
                    options:tabbarOptions,
                    on: {
                        onChange: function(Id) {
                            if(Id == _this.Id + "Ping")
                                _this.SetL2PropsStateLabel();
                        }
                    }
                }
            ]
        },
        {
            animate: false,
            id: this.Id + "TabbarViews",
            cells: tabbarViews
        }
    ];

    this.Rows = vConfig;
}

SubscriberEditFormViewController.prototype.GetPingFormTemplate = function()
{
    var _this = this;

    var buttons = [
        {gravity:2}
    ];
    if(this.ShowAsModalForm)
    {
        buttons.push({
            view: "button",
            label: LangHelper.GetString("All", "Close"),
            click: function ()
            {
                _this.Hide();
            }
        });
    }

    buttons.push({
        id: _this.Id + "PingExecuteButton",
        view: "button",
        type: "form",
        label: LangHelper.GetString("Subscribers", "Execute"),
        click: function(){
            setTimeout(function(){
                _this.Ping();
            },1);
        }
    });

    return [
        {
            id: this.Id + "PingMainLayout",
            rows:[
                BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "Ping") , icon:"terminal"}),
                {
                    id: _this.Id + "L2PropsStateLayout",
                    paddingX:8,
                    cols:[
                        {
                            id: this.Id + "L2PropsStateLabel",
                            view:"label",
                            css: {"color":"red"},
                            label: LangHelper.GetString("Subscribers", "Ping")+ " " + LangHelper.GetString("Subscribers", "Unavailable").toLowerCase()+". "+LangHelper.GetString("Subscribers", "L2-props are not set")
                        },
                        {
                            id: this.Id + "SetL2PropsButton",
                            view:"button",
                            width:180,
                            value:LangHelper.GetString("DpiPerformance", "Open the Configuration section"),
                            click:function() {
                                App.NavRouter.PresentView({id: ControllersEnum.DpiConfig});
                                if(_this.ShowAsModalForm) {
                                    _this.Hide();
                                }
                            }
                        }
                    ]
                },
                this.Widgets.Ping.ViewConfig,
                {
                    id: _this.Id + "PingForm",
                    view: "form",
                    // borderless: true,
                    scroll: "y",
                    elements:[
                        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "Ping command options form"), icon:"terminal"}),
                        {
                            cols:[
                                {
                                    view: "text",
                                    name: "address",
                                    requred: true,
                                    value: "127.0.0.1",
                                    validate: function(Val){
                                        if(!Val)
                                        {
                                            return false;
                                        }

                                        return Helper.ValidateIPaddress(Val);
                                    },
                                    invalidMessage: LangHelper.GetString("BlackListService", "Input correct IP addresses!"),
                                    label: LangHelper.GetString("Subscribers", "Address")
                                },
                                {
                                    view: "button",
                                    type: "icon",
                                    icon: "question-circle",
                                    css:"toolbar_round_btn",
                                    tooltip: LangHelper.GetString(this.Id, "?"),
                                    width: 32,
                                    click: function()
                                    {
                                        window.open(SubscribersCliWikiUrls.ping, '_blank');
                                    }
                                }
                            ]
                        },
                        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "L2-settings"), icon:"cogs"}),
                        {
                            view: "text",
                            name:"mac",
                            validate: function(Val){
                                if(!Val || Val == "undef")
                                    return true;

                                return Helper.ValidateMacAddress(Val);
                            },
                            on:{
                                "onChange":function(Val){
                                    _this.SetL2PropsStateLabel();
                                }
                            },
                            invalidMessage: LangHelper.GetString("Subscribers", "Input valid MAC-address"),
                            label: LangHelper.GetString("Subscribers", "Subscriber`s MAC-address"),
                            labelPosition: "top"
                        },
                        {
                            cols: [
                                {
                                    view: "text",
                                    name: "vlan",
                                    label: LangHelper.GetString("Subscribers", "Subscriber`s VLAN or QinQ"),
                                    labelPosition: "top"
                                },
                                {
                                    view: "text",
                                    name: "iface",
                                    label: LangHelper.GetString("Subscribers", "DNA-interface index"),
                                    labelPosition: "top",
                                    validate: function(Val){
                                        if(!Val)
                                        {
                                            return true;
                                        }

                                        return Helper.ValidateNumber(Val,-1, Number.MAX_SAFE_INTEGER);
                                    },
                                    invalidMessage: LangHelper.GetString("Dics", "Enter the number")
                                }
                            ]
                        },
                        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "Ping settings"), icon:"cogs"}),
                        {
                            cols: [
                                {
                                    view: "text",
                                    name: "n",
                                    value: 4,
                                    label: LangHelper.GetString("Subscribers", "Ping number"),
                                    labelPosition: "top",
                                    validate: function(Val){
                                        if(!Val)
                                        {
                                            return false;
                                        }

                                        return Helper.ValidateNumber(Val,1, Number.MAX_SAFE_INTEGER);
                                    },
                                    invalidMessage: LangHelper.GetString("Tariffs", "Value should be positive integer number!")
                                },
                                {
                                    view: "text",
                                    name: "ttl",
                                    label: LangHelper.GetString("Subscribers", "TTL value"),
                                    labelPosition: "top",
                                    validate: function(Val){
                                        if(!Val)
                                        {
                                            return true;
                                        }

                                        return Helper.ValidateNumber(Val,1, Number.MAX_SAFE_INTEGER);
                                    },
                                    invalidMessage: LangHelper.GetString("Tariffs", "Value should be positive integer number!")
                                }
                            ]
                        },
                        {
                            view: "text",
                            name: "len",
                            label: LangHelper.GetString("Subscribers", "Payload length"),
                            labelPosition: "top",
                            validate: function(Val){
                                if(!Val)
                                {
                                    return true;
                                }

                                return Helper.ValidateNumber(Val,1, 1400);
                            },
                            invalidMessage: LangHelper.GetString("Tariffs", "Value should be positive integer number!")
                        }
                    ]
                },
            ]
        },
        {
            id:_this.Id + "PingForm"+"_btns_form",
            view:"form",
            elements:[
                {
                    cols:buttons
                }
            ]
        }
    ];
};

SubscriberEditFormViewController.prototype.GetAuthTemplate = function()
{
    var _this = this;
    var state = "";

    // LangHelper.GetString(_this.Id, "Auth status")
    return [
        {
            id: this.Id + "AuthMainLayout",
            rows: [
                BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "Auth status") , icon:"man-alt"}),
                {
                    view: "toolbar",
                    height: webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 48,
                    padding: 0,
                    margin: 0,
                    elements: [
                        {
                            view: "label",
                            id: this.Id + "AuthStateInfoPanel"
                        },
                        {
                            view: "button",
                            type: "icon",
                            icon: "question-circle",
                            css:"toolbar_round_btn",
                            tooltip: LangHelper.GetString(this.Id, "?"),
                            width: 32,
                            click: function()
                            {
                                window.open(SubscribersCliWikiUrls.auth, '_blank');
                            }
                        }
                    ]
                },
                {
                    view: "form",
                    id: _this.Id + "AuthStateForm",
                    // borderless: true,
                    scroll: "y",
                    elements:[
                        {
                            view: "richselect",
                            name: "state",
                            label: LangHelper.GetString("Subscribers", "Auth status"),
                            labelPosition: "top",
                            options: Helper.DictToArr(SubscribersAuthStatusesSetDic)
                        },
                        {
                            view: "datepicker",
                            name: "expired",
                            label: LangHelper.GetString("Subscribers", "Expire at"),
                            labelPosition: "top",
                            format: "%d.%m.%Y %H:%i:%s",
                            stringResult: true,
                            // suggest:{
                            //     type: "calendar",
                            //     body: {
                            //         minDate: new Date()
                            //     }
                            // }
                        },
                    ]
                },

            ]
        },
        {
            view: "form",
            elements: [
                {},
                {
                    cols:function(){
                        var res = [{}];

                        if(_this.ShowAsModalForm)
                        {
                            res.push({
                                view: "button",
                                label: LangHelper.GetString("All", "Close"),
                                click: function ()
                                {
                                    _this.Hide();
                                }
                            });
                        }

                        res.push({
                            view: "button",
                            id: _this.Id + "AuthResetBtn",
                            label: LangHelper.GetString("Subscribers", "Reset"),
                            click: function(){
                                _this.ClearAuthStateContext.show(this.getNode(), {pos: "right"});
                            }
                        });
                        res.push({
                            view: "button",
                            id: _this.Id + "AuthSaveBtn",
                            label: LangHelper.GetString("Subscribers", "Save"),
                            type: "form",
                            click: function(){
                                setTimeout(function(){
                                    _this.SaveAuthState()
                                }, 1);
                            }
                        });

                        return res;
                    }()
                }
            ]
        }
    ]
};

SubscriberEditFormViewController.prototype.SetAuthState = function()
{
    var _this = this;

    var result = "";

    var state = "", expired = "", processState = true, processExpired = true;

    if(this.Data)
    {
      if(Array.isArray(this.Data))
      {
          this.Data.forEach(function(Val){
              if(!state)
              {
                  state = Val.auth_status;
              }
              var exp = "";
              if(Val.auth_expired)
              {
                  exp = Val.auth_expired;
                  // if(Val.auth_expired && SubscriberAuthExpiredDic[Val.auth_expired])
                  // {
                  //     exp = Val.auth_expired;
                  // }
                  // else{
                  //     var date = new Date(Val.auth_expired);
                  //     exp = webix.Date.dateToStr("%d.%m.%Y %H:%i:%s")(date);
                  // }
              }

              if(!expired)
              {
                  expired = exp;
              }

              if(state && state != SubscribersAuthStatusesDic[Val.auth_status].id)
              {
                  processState = false;
              }

              if(expired && expired != exp)
              {
                  processExpired = false;
              }
          });
      }
      else{
          state = this.Data.auth_status;

          if(this.Data.auth_status != SubscribersAuthStatusesDic["0"].id)
          {
              expired = this.Data.auth_expired;
          }
      }
    }
    if(this.Views.AuthStateForm)
    {
        this.Views.AuthStateForm.elements.state.setValue(null);
        this.Views.AuthStateForm.elements.expired.setValue("");
    }
    if(processState && state !== "")
    {
        result +=  LangHelper.GetString("Subscribers", "Auth status") + ": " + SubscribersAuthStatusesDic[state].value;

        if(this.Views.AuthStateForm){
            this.Views.AuthStateForm.clearValidation();
            if(SubscribersAuthStatusesSetDic[state])
            {
                this.Views.AuthStateForm.elements.state.setValue(state);
            }
        }
        if(processExpired && expired !== "")
        {
            result += "; " + LangHelper.GetString("Subscribers", "Expired at") + ": ";

            if(expired && SubscriberAuthExpiredDic[expired])
            {
                result += SubscriberAuthExpiredDic[expired].value;
            }
            else if(expired)
            {
                var date = new Date(expired);
                result += webix.Date.dateToStr("%d.%m.%Y %H:%i:%s")(date);
                if(this.Views.AuthStateForm)
                    this.Views.AuthStateForm.elements.expired.setValue(date);
            }
        }
    }

    if(this.Views.AuthStateInfoPanel)
    {
        this.Views.AuthStateInfoPanel.setValue(result);
        this.Views.AuthStateInfoPanel.resize();
    }
};

SubscriberEditFormViewController.prototype.GetPropTemplate = function()
{
    var _this = this;

    return [
        {
            id: this.Id + "PropMainLayout",
            rows: [
                BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "L2-props") , icon:"man-alt"}),
                {
                    view: "toolbar",
                    height: webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 48,
                    padding: 0,
                    margin: 0,
                    elements: [
                        {
                            view: "label",
                            id: this.Id + "L2PropsInfoLabel"
                        },
                        {
                            view: "button",
                            type: "icon",
                            icon: "sync-alt",
                            css:"toolbar_round_btn",
                            tooltip: LangHelper.GetString("Subscribers", "Sync L2-props"),
                            width: 32,
                            click: function()
                            {
                                _this.SyncAuthPropSignal.next(1);
                            }
                        },
                        {
                            view: "button",
                            type: "icon",
                            icon: "question-circle",
                            css:"toolbar_round_btn",
                            tooltip: LangHelper.GetString(this.Id, "?"),
                            width: 32,
                            click: function()
                            {
                                window.open(SubscribersCliWikiUrls.prop, '_blank');
                            }
                        }
                    ]
                },
                {
                    borderless: false,
                    rows:[
                        {
                            view: "form",
                            id: _this.Id + "L2PropsForm",
                            // borderless: true,
                            scroll: "y",
                            elements:[

                                {
                                    // borderless: true,
                                    rows:[
                                        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "Options") , icon:"cogs"})
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            view: "richselect",
                                            name: "type",
                                            label: LangHelper.GetString("Subscribers", "Session type"),
                                            labelPosition: "top",
                                            options: Helper.DictToArr(SubscriberAuthSessionTypeDic)
                                        },
                                        {
                                            view: "richselect",
                                            name: "status",
                                            label: LangHelper.GetString("Subscribers", "Session status"),
                                            labelPosition: "top",
                                            options: Helper.DictToArr(SubscriberAuthSessionStatusDic)
                                        },
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            view: "text",
                                            name: "mac",
                                            label: LangHelper.GetString("Subscribers", "MAC address"),
                                            labelPosition: "top",
                                            validate: function(Val){
                                                if(!Val)
                                                    return true;

                                                return Helper.ValidateMacAddress(Val);
                                            },
                                            invalidMessage: LangHelper.GetString("Subscribers", "Input valid MAC-address"),
                                        },
                                        {
                                            view: "text",
                                            name: "vlan",
                                            label: LangHelper.GetString("Subscribers", "VLAN or QinQ"),
                                            labelPosition: "top"
                                        }
                                    ]
                                },
                                {
                                    view: "text",
                                    name: "iface",
                                    label: LangHelper.GetString("Subscribers", "in_dev interface index"),
                                    labelPosition: "top",
                                    validate: function(Val){
                                        if(!Val)
                                            return true;

                                        return Helper.ValidateNumber(Val, -1, Number.MAX_SAFE_INTEGER);
                                    },
                                    invalidMessage: LangHelper.GetString("Dics", "Enter the number")
                                },
                                {
                                    view: "datepicker",
                                    name: "expired",
                                    label: LangHelper.GetString("Subscribers", "Expiration time"),
                                    labelPosition: "top",
                                    format: "%d.%m.%Y %H:%i:%s",
                                    stringResult: true,
                                    invalidMessage: "123"
                                },
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            name: "out_mac",
                                            label: LangHelper.GetString("Subscribers", "Output MAC address"),
                                            labelPosition: "top",
                                            validate: function(Val){
                                                if(!Val || Val == "undef")
                                                    return true;

                                                return Helper.ValidateMacAddress(Val);
                                            },
                                            invalidMessage: LangHelper.GetString("Subscribers", "Input valid MAC-address"),
                                        },
                                        {
                                            view: "text",
                                            name: "out_vlan",
                                            label: LangHelper.GetString("Subscribers", "Output VLAN=NN"),
                                            labelPosition: "top"
                                        },
                                    ]
                                },
                                {
                                    view: "richselect",
                                    name: "disable_local_connect",
                                    label: LangHelper.GetString("Subscribers", "Disable local connect for subscriber"),
                                    labelPosition: "top",
                                    options: Helper.DictToArr(YesNoDic),
                                    invalidMessage: "123"
                                },
                                {
                                    // borderless: true,
                                    rows:[
                                        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "IP options") , icon:"cogs"})
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            name: "route_via",
                                            label: LangHelper.GetString("Subscribers", "'route via' property"),
                                            labelPosition: "top",
                                            validate: function(Val){
                                                if(!Val)
                                                    return true;

                                                return Helper.ValidateIPv4(Val) || Helper.ValidateIPv6(Val);
                                            },
                                            invalidMessage: LangHelper.GetString("BlackListService", "Input correct IP addresses!")
                                        },
                                        {
                                            view: "text",
                                            name: "subnet_mask",
                                            label: LangHelper.GetString("Subscribers", "IPv4 subnet mask"),
                                            labelPosition: "top",
                                            validate: function(Val){
                                                if(!Val)
                                                    return true;

                                                return Helper.ValidateIPv4(Val);
                                            },
                                            invalidMessage: LangHelper.GetString("BlackListService", "Input correct IP addresses!")
                                        }
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            view: "text",
                                            name: "opt82_circuit_id",
                                            label: LangHelper.GetString("Subscribers", "Opt82 CircuitId"),
                                            labelPosition: "top",
                                            invalidMessage: "123"
                                        },
                                        {
                                            view: "text",
                                            name: "opt82_remote_id",
                                            label: LangHelper.GetString("Subscribers", "Opt82 RemoteId"),
                                            labelPosition: "top",
                                            invalidMessage: "123"
                                        }
                                    ]
                                },
                                {
                                    // borderless: true,
                                    rows:[
                                        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "UDR") , icon:"cogs"})
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            view: "checkbox",
                                            name: "memory",
                                            label: "",
                                            // label: LangHelper.GetString("Subscribers","Do not save changes parameters in UDR"),
                                            labelPosition: "right",
                                            tooltip:LangHelper.GetString("Subscribers","Do not save changes parameters in UDR"),
                                            value:0,
                                            width: 32
                                            // labelWidth:256
                                        },
                                        {
                                            view: "label",
                                            label: LangHelper.GetString("Subscribers","Do not save changes parameters in UDR"),
                                            tooltip:LangHelper.GetString("Subscribers","Do not save changes parameters in UDR")

                                        }
                                    ]
                                }

                            ]
                        }

                    ]
                },
            ]
        },
        {
            id:_this.Id + "L2PropsForm"+"_btns_form",
            view:"form",
            elements:[
                {
                    cols:function(){
                        var res = [{}];

                        if(_this.ShowAsModalForm)
                        {
                            res.push({
                                view: "button",
                                label: LangHelper.GetString("All", "Close"),
                                click: function ()
                                {
                                    _this.Hide();
                                }
                            });
                        }

                        res.push({
                            view: "button",
                            id: _this.Id + "PropDeleteBtn",
                            label: LangHelper.GetString("Subscribers", "Delete"),
                            click: function(){
                                _this.DeleteAuthPropContext.show(this.getNode(), {pos: "right"});
                            }
                        });
                        res.push({
                            view: "button",
                            id: _this.Id + "PropSaveBtn",
                            label: LangHelper.GetString("Subscribers", "Save"),
                            type: "form",
                            click: function(){
                                setTimeout(function(){
                                    _this.SaveAuthProps()
                                }, 1);
                            }
                        });

                        return res;
                    }()
                }
            ]
        }
    ]
};

SubscriberEditFormViewController.prototype.SetAuthPropsState = function()
{
    var _this = this;

    var state = "";
    var props = {};
    if(this.Data)
    {
        if(Array.isArray(this.Data))
        {
            this.Data.forEach(function(Val){
                var prop = new SubscriberPropsModel(JSON.parse(Val.auth_props));

                if(prop && prop.props)
                {
                    Object.keys(prop.props).forEach(function(Key){

                        if(typeof props[Key] === "undefined")
                        {
                            props[Key] = prop.props[Key];
                        }
                        else if(props[Key] != prop.props[Key])
                        {
                            props[Key] = "";
                        }
                    });
                }
            });
        }
        else{
            var prop = new SubscriberPropsModel(JSON.parse(this.Data.auth_props));

            if(prop.error)
            {
                state += "<span class=\"error_span\">" + prop.error + "</span>";
            }

            if(prop.update_date)
            {
                state += (state.length > 0 ? "; " : "") + LangHelper.GetString("Subscribers", "Last update") + ": " + (webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"))(prop.update_date);
            }

            props = prop.props;
        }
    }

    if(this.Views.L2PropsInfoLabel)
    {
        this.Views.L2PropsInfoLabel.setValue(state);
        this.Views.L2PropsInfoLabel.resize();
    }

    if(this.Views.L2PropsForm)
    {
        this.Views.L2PropsForm.clearValidation();
        this.Views.L2PropsForm.clear();
        this.Views.L2PropsForm.setValues(props, true);
        if(props.expired)
        {
            var date = new Date(props.expired);
            this.Views.L2PropsForm.elements.expired.setValue(date);
        }
    }
};

SubscriberEditFormViewController.prototype.SetData = function (data)
{
    var _this = this;
    this.Data = data;

    if(this.Data)
    {
        if(this.ShowSubscriberItems && this.Views.SubscriberForm)
            this.Views.SubscriberForm.setValues(data);

        if(this.ShowServicesItems && this.Views.ServicesTable)
        {
            this.Views.ServicesTable.parse(this.GetServicesData());
            this.Views.ServicesTable.refresh();
        }

        if(this.ShowTariffItems && $$(this.Id+"_tariff_form"))
            $$(this.Id+"_tariff_form").setValues(data);



        // _this.PolicingManager.RefreshProfiles();
    }

    if(!this.ShowAsModalForm && this.Data)
    {
        this.Views.Self.hideOverlay();
        this.OverlayVisible = false;
    }


    if(!this.ShowAsModalForm && !this.Data)
    {
        if(!this.OverlayVisible)
            this.Views.Self.showOverlay();

        this.OverlayVisible = true;
    }

    if(this.Views.BindType)
    {
        if(this.Data && !this.Data.login && !this.Data.ip)
        {
            this.Views.BindType.enable();
        }
        else
        {
            this.Views.BindType.disable();
        }
    }

    if(this.ShowSubscriberItems && this.Views.SubscriberForm)
        this.Views.SubscriberForm.clearValidation();

    if(_this.Views.AuthStateForm)
        _this.ChangeStateFormComponents([_this.Views.AuthMainLayout, _this.Views.AuthResetBtn, _this.Views.AuthSaveBtn], false);

    if(_this.Views.Ping)
        _this.ChangeStateFormComponents([_this.Views.PingMainLayout, _this.Views.PingExecuteButton], false);

    if(_this.Views.Prop)
    {
        _this.ChangeStateFormComponents([_this.Views.PropMainLayout, _this.Views.PropDeleteBtn, _this.Views.PropSaveBtn], false);
    }

    if(this.Data && Array.isArray(this.Data))
    {
        if(this.ShowSubscriberItems && this.Views.SubscriberForm && this.Views.SubscriberFormTitle)
        {
            this.Views.SubscriberForm.hide();
            this.Views.SubscriberFormTitle.hide();
        }

        if(_this.Views.Ping)
            _this.ChangeStateFormComponents([_this.Views.PingMainLayout, _this.Views.PingExecuteButton]);

        if(_this.Views.Prop)
            _this.ChangeStateFormComponents([_this.Views.PropMainLayout, _this.Views.PropDeleteBtn, _this.Views.PropSaveBtn]);

        if(this.Views.AuthStateForm)
        {
            this.Data.forEach(function(D){
                if((!D.ip && !D.login) || (D.bind_type == -1 && !Helper.ValidateIPaddress(D.login)))
                {
                    _this.ChangeStateFormComponents([_this.Views.AuthMainLayout, _this.Views.AuthResetBtn, _this.Views.AuthSaveBtn]);
                }
            });
        }

    }
    else
    {
        if(this.ShowSubscriberItems && this.Views.SubscriberForm && this.Views.SubscriberFormTitle)
        {
            this.Views.SubscriberForm.show();
            this.Views.SubscriberFormTitle.show();
        }
        if(!this.Data ||
            (!this.Data.ip && !this.Data.login) ||
            (this.Data.bind_type == -1 && this.Data.identity_type == SubscribersIdentitiesDic.login.id)
        )
        {
            if(_this.Views.Ping)
                _this.ChangeStateFormComponents([_this.Views.PingMainLayout, _this.Views.PingExecuteButton]);

            if(_this.Views.AuthStateForm)
                _this.ChangeStateFormComponents([_this.Views.AuthMainLayout, _this.Views.AuthResetBtn, _this.Views.AuthSaveBtn]);

            if(_this.Views.Prop)
                _this.ChangeStateFormComponents([_this.Views.PropMainLayout, _this.Views.PropDeleteBtn, _this.Views.PropSaveBtn]);
        }
    }

    this.UpdatePolicings();
    this.SetAuthState();
    this.SetAuthPropsState();
    this.SetL2PropsStateLabel();
};

SubscriberEditFormViewController.prototype.GetServicesData = function ()
{
    var data = [];

    var enabledServices = [];
    var servicesProfiles = new SubscriberServiceProfileModel();

    if(this.Data && !Array.isArray(this.Data) && this.Data.services)
    {
        enabledServices = this.Data.services.split(",");
        enabledServices.forEach(function (Val, Index)
        {
            enabledServices[Index] = parseInt(Val,10);
        });

    }

    if(this.Data && this.Data.services_profiles)
    {
        servicesProfiles = new SubscriberServiceProfileModel(JSON.parse(this.Data.services_profiles));
    }

    if(this.Data && Array.isArray(this.Data))
    {
        var crossServices = {};

        this.Data.forEach(function (Data)
        {
            var services = Data.services.split(",");

            services.forEach(function (Val, Index)
            {
                if(Val)
                {
                    if(crossServices[parseInt(Val,10)])
                    {
                        crossServices[parseInt(Val,10)] += 1;
                    }
                    else
                    {
                        crossServices[parseInt(Val,10)] = 1;
                    }
                }
            });

            if(Data.services_profiles)
            {
                var sp = new SubscriberServiceProfileModel(JSON.parse(Data.services_profiles));
                for(var i in sp)
                {
                    if(servicesProfiles[i] === 0)
                    {
                        servicesProfiles[i] = sp[i];
                    }
                    else if(servicesProfiles[i] !== null && servicesProfiles[i] !== sp[i])
                    {
                        servicesProfiles[i] = null;
                    }
                    else
                    {
                       break;
                    }
                }
            }
        });

        var count = this.Data.length;

        Object.keys(crossServices).forEach(function (Key)
        {
            if(crossServices[Key] == count)
            {
                enabledServices.push(parseInt(Key,10));
            }
        });
    }

    var row = function (Params)
    {
        this.id = Params&&Params.id?Params.id:0;
        this.value = Params&&Params.value?Params.value:'';
        this.enabled = Params&&Params.enabled?Params.enabled:0;
        this.profile = Params&&Params.profile?Params.profile:'';
    };

    Helper.SortArrayObjByOrderFieldAsc(Helper.DictToArr(ServicesDic)).forEach(function (Service)
    {
        var obj = new row(Service);

        if(enabledServices.indexOf(obj.id) >= 0)
        {
            obj.enabled = 1;

        }
        if(servicesProfiles && Object.keys(servicesProfiles).length && servicesProfiles[Service.id])
        {
            obj.profile = servicesProfiles[Service.id];
        }

        data.push(obj);
    });


    return data;
};

SubscriberEditFormViewController.prototype.GetServicesSerializedData = function ()
{
    if(this.Views && this.Views.ServicesTable)
    {
        var data = this.Views.ServicesTable.serialize();
        var result = {
            services: "",
            services_profiles:{}
        };
        // var services = "";

        data.forEach(function (Service)
        {
            if(Service.enabled)
            {
                result.services += ""+Service.id+",";
                if(Service.profile && Service.profile !== "0")
                {
                    result.services_profiles[Service.id] = Service.profile;
                }
            }

        });

        return result;
    }
    return null;
};

SubscriberEditFormViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node, {pos:Pos});
};

SubscriberEditFormViewController.prototype.Hide = function()
{
    if(this.ShowAsModalForm)
    {
        this.Context.hide();
    }

    this.OnHide.next(true);
};

SubscriberEditFormViewController.prototype.Validate = function()
{
    var valid = true;

    if(this.Views.LoginField)
    {
        if(!this.Views.LoginField.validate())
        {
            valid = false;
        }
    }

    if(this.Views.IpField)
    {
        if(!this.Views.IpField.validate())
        {
            valid = false;
        }
    }

    return valid;
};

SubscriberEditFormViewController.prototype.LoginFieldValidatorRule = function(Val)
{
    var _this = this;

    if(_this.Views.BindType.getValue() == -1 && _this.Views.IdentityType.getValue() == SubscribersIdentitiesDic.ip.id)
    {
        return true;
    }

    if(!Val)
        return false;
    // if(this.Views.BindType && this.Views.BindType.getValue() == -1)
    // {
    //     return Helper.ValidateIPaddress(Val);
    // }

    return true;
};

SubscriberEditFormViewController.prototype.IpFieldValidatorRule = function(Val)
{
    if(this.Views.BindType.getValue() == -1 && this.Views.IdentityType.getValue() == SubscribersIdentitiesDic.login.id)
    {
        return true;
    }

    if(!Val)
        return false;

    if(Helper.ValidateIPaddress(Val))
    {
        return true;
    }
    else if(Helper.ValidateIPaddressOrCidr(Val))
    {
        return true;
    }
    else if(Helper.IsIpRange(Val))
    {
        return true;
    }
    else
    {
        return false;
    }
};

SubscriberEditFormViewController.prototype.Save = function()
{
    if(this.Data && !Array.isArray(this.Data))
    {
        if(!this.Validate())
            return;

        if(!this.Data.oldSubscriber)
        {
            this.Data.oldSubscriber = new SubscriberModel(this.Data);
        }

        this.Data.login = this.Views.LoginField ? Helper.RemoveAllWhiteSpaces(this.Views.LoginField.getValue()) : "";
        this.Data.ip = this.Views.IpField ? this.Views.IpField.getValue() : "";
        this.Data.bind_type = this.Views.BindType ? this.Views.BindType.getValue() : 1;
        this.Data.policing = this.Views.PolicingField ? this.Views.PolicingField.getValue() : "";

        var identity = this.Views.IdentityType ? this.Views.IdentityType.getValue() : SubscribersIdentitiesDic.login.id;

        this.Data.identity_type = this.Data.bind_type == -1 ? identity : SubscribersIdentitiesDic.login.id;

        if(this.Data.identity_type == SubscribersIdentitiesDic.login.id && this.Data.bind_type == -1)
        {
            this.Data.ip = "n/a";
        }
        else if(this.Data.identity_type == SubscribersIdentitiesDic.ip.id && this.Data.bind_type == -1)
        {
            this.Data.login = "n/a";
        }

        var services = this.GetServicesSerializedData();
        if(services !== null)
        {
            this.Data.services = services.services;

            this.Data.services_profiles = JSON.stringify(services.services_profiles);
        }

        if(this.Data.bind_type == -1 && !this.Data.services && !this.Data.policing)
        {
            webix.message({type:"error", text:LangHelper.GetString("Subscribers", "There are no services or policing for subscriber!")});
            return;
        }

        this.SaveDataSinal.next(this.Data);
    }

    if(this.Data && Array.isArray(this.Data))
    {
        var services = this.GetServicesSerializedData();

        var policing = this.GetSelectedPolicing();

        this.Data.forEach(function (Subscriber)
        {
            if(!Subscriber.oldSubscriber)
            {
                Subscriber.oldSubscriber = new SubscriberModel(Subscriber);
            }

            if(services !== null)
            {
                Subscriber.services = services.services;
                Subscriber.services_profiles = JSON.stringify(services.services_profiles);
            }

            if(policing !== null)
            {
                Subscriber.policing = policing;
            }
        });

        this.SaveDataSinal.next(this.Data);
    }

    this.Hide();
};

SubscriberEditFormViewController.prototype.GetSelectedPolicing = function()
{
    if(this.Views && this.Views.SubscriberFormPolicing && this.Views.PolicingField)
    {
        return this.Views.PolicingField.getValue();
    }
    return null;
};

SubscriberEditFormViewController.prototype.Destroy = function ()
{
    var _this = this;

    if(this.Widgets.Ping)
        _this.Widgets.Ping.Destroy();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

SubscriberEditFormViewController.prototype.EditServiceProfile = function(Params)
{
    var _this = this;

    if(Params && Params.data)
    {
        if(!ServicesDicsEnum[Params.data.id])
            return;
    }
    var editor = new SubscribersServiceProfilesEditorViewController({data: Params.data});
    editor.ViewDidLoad();

    editor.Show(Params.node, "bottom");

    this.Subscriptions.ServiceProfileUpdated = editor.SaveDataSinal.subscribe(function (DataToSave)
    {
        if(DataToSave)
        {
            if(_this.Views.ServicesTable)
            {
                _this.Views.ServicesTable.updateItem(DataToSave.id, DataToSave);
            }
        }
    });
};

SubscriberEditFormViewController.prototype.GetServiceTemplate = function(Obj)
{
    var _this = this;
    var value = "";

    var dicEnum = ServicesDicsEnum[Obj.id];
    if(dicEnum)
    {
        var dic = App.DicsManager.GetDic(dicEnum);

        // if(dic && Obj.profile)
        //     value += dic[Obj.profile] && dic[Obj.profile].value ? dic[Obj.profile].value : "";

        if (dic && Obj.profile)
        {
            value += dic[Obj.profile] && dic[Obj.profile].value ? dic[Obj.profile].value  : "";

            if (dic[Obj.profile] && dic[Obj.profile].status == 0)
                value += " <span style='color: red;'>("+ LangHelper.GetString("Vchannels", "Disabled") +")</span>";
        }

        value += "<span style=\"height:24px;padding-top:12px;\" class=\"webix_input_icon fa-angle-down\"></span>";
    }

    return "<div class='set-service-profile'>" + value + "</div>";
};

SubscriberEditFormViewController.prototype.UpdatePolicings = function()
{
    var _this = this;

    if(_this.Views.SubscriberFormPolicing)
    {

        _this.Views.SubscriberFormPolicing.elements.policing.getList().clearAll();

        // var profiles = _this.PolicingManager.GetProfiles();
        var arr = [
            {"id": "0", "value":""}
        ];

        Helper.DictToArr(App.DicsManager.GetDic(DicsEnum.PolicingProfilesDic)).forEach(function (val) {
            var model = webix.copy(val);

            if (model.status == 0)
                model.value += " <span style='color: red;'>("+ LangHelper.GetString("Vchannels", "Disabled") +")</span>";

            arr.push(model);
        });

        // arr = arr.concat(Helper.DictToArr(App.DicsManager.GetDic(DicsEnum.PolicingProfilesDic)));
        if(_this.Data && _this.Data.policing)
        {
            var index = arr.findIndex(function(obj)
            {
                return obj == _this.Data.policing;
            });

            if(index === -1)
            {
                arr.splice(1,0, {
                    "id": _this.Data.policing,
                    "dic_id": _this.Data.policing,
                    "value": LangHelper.GetString("Dics", "Personal tariff")
                });
            }
        }

        _this.Views.SubscriberFormPolicing.elements.policing.getList().parse(arr);
    }
};

SubscriberEditFormViewController.prototype.Ping = function()
{
  var _this = this;

  if(_this.Views.PingForm.validate())
  {
      var values = _this.Views.PingForm.getValues();

      var cmd = "fdpi_cli -r " + values.address + " ping";

      var ip = "";

      if(this.Data.ip)
      {
          ip = this.Data.ip;
      }
      else if(this.Data.login && Helper.ValidateIPaddress(this.Data.login)){
          ip = this.Data.login;
      }

      if(ip)
      {
          cmd += " ip=" + ip;
      }
      else{
          return false;
      }

      Object.keys(values).forEach(function(Key){
          if(Key != "address" && values[Key])
          {
              cmd += " " + Key + "=" + values[Key];
          }
      });

      _this.Widgets.Ping.ProcessCommand(cmd);

      _this.Views.PingExecuteButton.disable();
      setTimeout(function(){
          _this.Views.PingExecuteButton.enable();
      },5000);
  }
};

SubscriberEditFormViewController.prototype.SaveAuthState = function()
{
  var _this = this;

  if(this.Views.AuthStateForm.validate())
  {
      this.SetAuthStateSignal.next(this.Views.AuthStateForm.getValues());
      this.Hide();
  }
  else
  {
      webix.message({type:"error", text:LangHelper.GetString("Subscribers", "Not valid form")});
  }
};

SubscriberEditFormViewController.prototype.SaveAuthProps = function()
{
    var _this = this;

    if(this.Views.L2PropsForm.validate())
    {
        var vals = this.Views.L2PropsForm.getValues();

        if(vals.expired)
        {
            var date = new Date(vals.expired);
            vals.expired = webix.Date.dateToStr("%Y-%m-%dT%H:%i:%s")(date);
        }

        this.SetAuthPropSignal.next({props: vals, memory: vals.memory});

        this.Hide();
    }
    else
    {
        webix.message({type:"error", text:LangHelper.GetString("Subscribers", "Not valid form")});
    }

};

SubscriberEditFormViewController.prototype.ResetAuthState = function()
{
    var _this = this;

    this.ResetAuthStateSignal.next(1);

    this.Hide();
};

SubscriberEditFormViewController.prototype.DeleteAuthProps = function()
{
    var _this = this;

    this.DeleteAuthPropSignal.next(1);

    this.Hide();
};

SubscriberEditFormViewController.prototype.SetL2PropsStateLabel = function()
{
    if(this.Views.L2PropsStateLayout) {
        if(this.Data && this.Data.L2AuthState && Object.keys(this.Data.L2AuthState).length > 0) {
            var authState = webix.copy(this.Data.L2AuthState);
            var authParams = authState.authParams;
            var macAddresses = authState.macAddresses;

            var result = Object.values(authParams).some(configElem => configElem.trim() == "");

            result?this.SetProhibitedL2PropsStateLayout():this.CheckL2MacAddresses(macAddresses);
        }
        else {
            this.SetProhibitedL2PropsStateLayout();
        }
    }
};

SubscriberEditFormViewController.prototype.CheckL2MacAddresses = function(Params)
{
    var macAddresses = Params;
    macAddresses.props_form_mac = this.Views.L2PropsForm.getValues().mac||"";
    macAddresses.ping_form_mac = this.Views.PingForm.getValues().mac||"";

    var result = Object.values(macAddresses).every(configElem => configElem.trim() == "" || !Helper.ValidateMacAddress(configElem));

    result?this.SetProhibitedL2PropsStateLayout():this.SetAllowedL2PropsStateLayout();
};

SubscriberEditFormViewController.prototype.SetProhibitedL2PropsStateLayout = function()
{
    this.Views.L2PropsStateLayout.show();
    this.Views.PingExecuteButton.disable();
};

SubscriberEditFormViewController.prototype.SetAllowedL2PropsStateLayout = function()
{
    this.Views.L2PropsStateLayout.hide();
    this.Views.PingExecuteButton.enable();
};

SubscriberEditFormViewController.prototype.ChangeStateFormComponents = function(Components, Disable=true)
{
    if(Components &&  Array.isArray(Components) && Components.length) {
        Components.forEach(component => {
           if(Disable && component.disable) {
               component.disable();
           }
           if(!Disable && component.enable) {
               component.enable();
           }
        });
    }
};
function SubscribersServiceProfilesEditorViewController(Params)
{
  var _this = this;

    this.Id = "SubscribersServiceProfilesEditorViewController";

    this.Data = null;

    this.ContextConfig = {
        view: "popup",
        minWidth: 240,
        // maxHeight: 50,
        id:this.Id + "Context",
        body: {
            view: "form",
            id: this.Id + "Form",
            borderless: true,
            height: 112,
            elements:[
                {
                    name: "profile",
                    view:"richselect",
                    options: []
                },
                {
                    cols:[
                        // {},
                        {
                            view: "button",
                            label: LangHelper.GetString("All", "Close"),
                            click: function ()
                            {
                                _this.Hide();
                            }
                        },
                        {
                            view: "button",
                            type: "form",
                            label: LangHelper.GetString("All", "Apply"),
                            click: function ()
                            {
                                _this.Save();
                                _this.Hide();
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.Views = {};

    this.SaveDataSinal = new Rx.BehaviorSubject(0);

    this.OverlayVisible = false;

    this.Subscriptions = {};

    this.Init(Params);

    return this;
};

SubscribersServiceProfilesEditorViewController.prototype.Init = function (Params)
{
    var _this = this;
    if(Params.data)
    {
        this.Data = Params.data;

        var dicEnum = ServicesDicsEnum[this.Data.id]

        if(dicEnum)
        {
            var arr = [
                {"id": "0", "value":""}
            ];

            Helper.DictToArr(App.DicsManager.GetDic(dicEnum)).forEach(function (val) {
                var model = webix.copy(val);

                if (model.status == 0)
                    model.value += " <span style='color: red;'>("+ LangHelper.GetString("Vchannels", "Disabled") +")</span>";

                arr.push(model);
            });
            // arr = arr.concat(Helper.DictToArr(App.DicsManager.GetDic(dicEnum)))
            // var dic = ;

            this.ContextConfig.body.elements[0].options = arr;
        }
    }
    this.Context = webix.ui(this.ContextConfig);
};

SubscribersServiceProfilesEditorViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);

    if(this.Data)
        this.SetData(this.Data);
};

SubscribersServiceProfilesEditorViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.Form = $$(this.Id + "Form");

    this.Context.attachEvent("onHide", function()
    {
        _this.Destroy();
    });

    this.SetData();
};

SubscribersServiceProfilesEditorViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node, {pos:Pos});
};

SubscribersServiceProfilesEditorViewController.prototype.Hide = function()
{
    this.Context.hide();
};

SubscribersServiceProfilesEditorViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

SubscribersServiceProfilesEditorViewController.prototype.SetData = function ()
{
  var _this = this;
  if(this.Data)
  {
      this.Views.Form.setValues(this.Data);
  }
};
SubscribersServiceProfilesEditorViewController.prototype.Save = function()
{
    var _this = this;

    var vals = this.Views.Form.getValues();

    if(!vals.enabled && vals.profile !== "0")
    {
        vals.enabled = 1;
    }

    this.SaveDataSinal.next(vals);
};
function SubscriberSyncStatusWidget(ViewConfig)
{
    var _this = this;

    this.LocaleId = null;

    this.Id = null;

    this.Views = {
        SyncBtn: null,
        StatusLabel: null,
        IndicatorLabel: null
    };

    this.Signals = {
        SyncSubscribersSuccess: new Rx.BehaviorSubject(0)
    };
    this.Subscriptions = {};

    this.ViewModel = null;

    this.ViewConfig = null;

    this.Init(ViewConfig);
}

SubscriberSyncStatusWidget.prototype.Init = function(ViewConfig)
{
    var _this = this;

    var viewConfig = ViewConfig ? ViewConfig : {};

    this.LocaleId = viewConfig.localeId ? viewConfig.localeId : "Subscribers";

    this.Id = viewConfig.id ? viewConfig.id : ("SubscriberSyncStatusWidget" + webix.uid());

    this.ViewModel = new SubscribersSyncStatusManager();

    this.ViewConfig = [
        {
            view:"label",
            id:this.Id+"StatusLabel",
            width:160
        },
        {
            view: "button",
            id:this.Id + "SyncBtn",
            type: "icon",
            icon: "cloud-download-alt",
            align: "right",
            width: 32,
            css:"toolbar_round_btn sync_subs_btn",
            tooltip:LangHelper.GetString(this.LocaleId, "Forced " + (_this.LocaleId == "Subscribers" ? "subscribers" : "vchannels") + " synchronization"),
            badge:" ",
            click: function (id, e, node)
            {
                _this.ForceSyncSubscribers();
            }
        }

    ];
};

SubscriberSyncStatusWidget.prototype.BindAll = function(ViewController)
{
    var _this = this;

    Object.keys(this.Views).forEach((View) => {
        this.Views[View] = $$(this.Id + View);
    });

    // var node = this.Views.SyncBtn.getNode();
    // node.addEventListener('click', function()
    // {
    //     if(_this.Views.SyncBtn.isEnabled())
    //     {
    //         _this.ForceSyncSubscribers();
    //     }
    // });

    this.Subscriptions.HardwareConnected = App.SessionManager.CurrentHardwareId.subscribe(function (CurrentHardwareId)
    {
        if (CurrentHardwareId)
        {
            _this.ViewModel.RefreshSyncStatus();
        }
    });

    this.Subscriptions.ForceSyncSubscribersStartedSubscription = this.ViewModel.Signals.ForceSyncStarted.subscribe((Val) => {
        if(Val)
        {
            var item = _this.LocaleId == "Subscribers" ? "subscribers" : "vchannels";
            webix.message(LangHelper.GetString(_this.LocaleId,
                "Forced synchronization " + item + " running in the background"));
        }
    });

    this.Subscriptions.HardwareSyncStatusSubscription = this.ViewModel.Signals.HardwareSyncStatusSignal.subscribe(function(Val){
        _this.UpdateSyncStatus(Val);
    });


    App.WebSocketManager.ConnectAsUser('SyncSubs');

    App.WebSocketManager.Connections['SyncSubs'].on("connect", function(){});

    App.WebSocketManager.Connections['SyncSubs'].on(SocketNotificationsEventEnum.messages, function(Data){});

    App.WebSocketManager.Connections['SyncSubs'].on(SocketNotificationsEventEnum.subscribers, function(Data){
        var data = JSON.parse(Data);
        _this.ViewModel.Signals.HardwareSyncStatusSignal.next(data);
    });
};

SubscriberSyncStatusWidget.prototype.Destroy = function()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach((Key) => {
        this.Subscriptions[Key].unsubscribe();
    });

    App.WebSocketManager.DisconnectAsUser('SyncSubs');
};

SubscriberSyncStatusWidget.prototype.ForceSyncSubscribers = function()
{
    this.ViewModel.ForceSyncSubscribers();
};

SubscriberSyncStatusWidget.prototype.UpdateSyncStatus = function(Data)
{
    if(Data)
    {
        var model = new SubscriberSyncStatusModel(Data);
        var current_hw = parseInt(App.SessionManager.GetCurrentHardwareId(), 10);

        if(model.hardware_id !== current_hw)
        {
            return;
        }

        var text = "";
        var date_txt = "";
        if(Data.start_date)
        {
            var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

            date_txt = format(Helper.DateTimeToLocal(Data.start_date));
        }

        this.Views.SyncBtn.enable();
        var css = "";
        switch (Data.status)
        {
            case SubscribersSyncStatusDic.new.id:
                break;
            case SubscribersSyncStatusDic.processing.id:
                text = TooltipTemplate(date_txt, LangHelper.GetString("Dics", "Sync is running. Started at") + " " + date_txt + ".")
                this.Views.SyncBtn.disable();
                css = 'label_vas_color';
                break;
            case SubscribersSyncStatusDic.success.id:
                var tooltip_text = LangHelper.GetString("Dics", (this.LocaleId == "Subscribers" ? "Subscribers" : "Vchannels") + " is loaded at") + " " + date_txt + ".";
                text = TooltipTemplate(date_txt, tooltip_text)
                css = 'label_ok_color';
                this.Signals.SyncSubscribersSuccess.next(1);
                break;
            case SubscribersSyncStatusDic.error.id:
                var tooltip_text = LangHelper.GetString("Dics", (this.LocaleId == "Subscribers" ? "Subscribers" : "Vchannels") + " sync is failed. Last started at") + " " + date_txt + ".";
                text = TooltipTemplate(date_txt, tooltip_text)
                css = 'label_error_color';
                break;
            default:
                text = "";
        }

        this.ApplyStatusIndicator(css);

        this.Views.StatusLabel.setValue(text);
    }
};

SubscriberSyncStatusWidget.prototype.ApplyStatusIndicator = function(Class)
{
    var _this = this;
    // return;

    var node = this.Views.SyncBtn.getNode();

    // this.Views.Tooltip.setValues(Tip);
    // this.Views.Tooltip.show();

    // webix.html.removeCss(node, 'webix_el_icon');
    webix.html.removeCss(node, 'label_vas_color');
    webix.html.removeCss(node, 'label_error_color');
    webix.html.removeCss(node, 'label_ok_color');

    if(Class)
    {
        webix.html.addCss(node, Class);
    }
};
/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */
/* global SubscribersComponentsTypeDic */
/* global HardwareSubscribersManager */
var MultiSubscribersTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"MultiSubscribersTableWidget",
        sortDisabledColumns:["ip", "auth_status"],
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "GetMultiSubscribersReport";
            },
            sort:{id:"ip",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [
                {
                    id: "ip",
                    header: [LangHelper.GetString("Subscribers","IP-address"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace: true,
                    // sort: "string",
                },
                {
                    id:"auth_status",
                    header: [TooltipTemplate(LangHelper.GetString("Subscribers", "Auth status")), {
                        content: "richSelectFilter",
                        options: function(){
                            return Helper.DictToArr(SubscribersAuthStatusesDic);
                        }(),
                        inputConfig: {suggest: {fitMaster: false}},
                        compare:function (value, filter)
                        {
                            var res = true;
                            var valueStr = "";

                            if(value)
                            {
                                valueStr = value;
                            }

                            if(filter)
                            {
                                Object.keys(filter).forEach(function (key) {
                                    if(filter[key] && valueStr.indexOf(key) === -1)
                                    {
                                        res = false;
                                        return false;
                                    }
                                });
                            }



                            return res;
                        }
                    }],
                    width: 120,
                    template: function (obj)
                    {
                        var value = LangHelper.GetString("Subscribers", "Unknown");
                        if(obj.auth_status !== null && SubscribersAuthStatusesDic[obj.auth_status])
                        {
                            value = SubscribersAuthStatusesDic[obj.auth_status].value;
                        }
                        return "<span>"+value+"</span>";
                    },
                    tooltip: function (obj)
                    {
                        var value = LangHelper.GetString("Subscribers", "Unknown");
                        if(obj.auth_status !== null && SubscribersAuthStatusesDic[obj.auth_status])
                        {
                            value = SubscribersAuthStatusesDic[obj.auth_status].value;
                        }
                        return "<span>"+value+"</span>";
                    },
                    sort: "string"
                }
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterFilterCustomHandler)
    {
        params.on.onAfterFilterCustomHandler = function ()
        {
            Params.onAfterFilterCustomHandler();
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

function SubscribersViewController(Params)
{
    "use strict";
    var _this = this;

    this.ViewModel = new HardwareSubscribersManager();

    this.ReportsModel = new UniReportsManager();

    this.AdvcManager = new AdvcManager();
    //
    // this.DicsManager = Params && Params.DicsManager ? Params.DicsManager : App.DicsManager;

    this.embedded = Params&& Params.embedded?true:false;

    this.tariffOnly = Params && Params.tariffOnly? true : false;

    this.servicesOnly = Params && Params.servicesOnly? Params.servicesOnly : false;

    this.services = Params && Params.services ? Params.services : null;

    this.id = "Subscribers"+(this.embedded?"Embedded":"");
    this.Id = this.id;
    this.id += Params && Params.Id ? Params.Id : "";

    this.VchannelsEmbedded = new VchannelsViewController(webix.extend(Params, {id:this.id}, true));

    this.tableId = this.id+"Table";
    this.table = null;
    this.paging = null;

    this.SubscriberEditFormEmbedded = new SubscriberEditFormViewController({embedded:true, tariffOnly: this.tariffOnly, displayConfig: new SubscriberEditFormDisplayConfig({
            profile: {
                show: true,
                services: !this.tariffOnly,
                login: !(this.servicesOnly || this.tariffOnly),
                tariffs: !this.servicesOnly
            }
        }, !(this.servicesOnly || this.tariffOnly))});

    this.deleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id, "Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id, "Cancel"),
                            click:function ()
                            {
                                _this.deleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id, "Delete"),
                            click:function ()
                            {
                                _this.deleteContext.hide();
                                _this.DeleteTableSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.view = [];

    this.sideBarTemplate = ServicesLeftSideBarView({id:this.id});

    this.subscribersTableLognColTemplate = {
        id: "login",
        header: [LangHelper.GetString(this.Id, "Login"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
        fillspace: true,
        sort: "string",
        editor: "text"
    };
    this.subscribersTableIpColTemplate = {
        id: "ip",
        header: [LangHelper.GetString(this.Id,"IP-address"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
        fillspace: true,
        sort: "string",
        editor: "text",
        template: function (obj, common, value, config) {
            let getMultiTabbarValue = App.SessionManager.GetPreference('multiSubscribersTabbar');

            if(obj.bind_type == "1" && getMultiTabbarValue.indexOf("GroupSubscribersTab") !== -1){
                return CellEyeBtnTemplate();
            }

            return obj.ip
        }
    };
    this.subscribersTableServicesColTemplate = {
        id: "services",
        header: [LangHelper.GetString(this.Id, "Services"), {
            content: "multiComboFilter",
            options: _this.GetServicesOptions(),
            inputConfig: {
                suggest: {
                    fitMaster: false,
                    width: 300
                },
                tagTemplate: function (values)
                {
                    const local = Helper.GetElementPluralForm(values.length);
                    return `${values.length} ${local}`;
                }
            },
            compare:function (value, filter)
            {
                var res = true;
                var valueStr = "";

                if(value)
                {
                    valueStr = value;
                }

                if(filter)
                {
                    Object.keys(filter).forEach(function (key) {
                        if(filter[key] && valueStr.indexOf(key) === -1)
                        {
                            res = false;
                            return false;
                        }
                    });
                }



                return res;
            }
        }],
        fillspace: 3,
        sort: "string",
        template: function (obj)
        {
            var services = [];
            var services_str = '';

            services = obj.services.split(",");

            if (services) {
                services.forEach(function (service) {
                    if(service&&ServicesDic[service])
                        services_str += '<span class="service ' + ServicesDic[service].code + '" title="'+ServicesDic[service].value+'"><span class="fa fa-square"></span><span class="title">' + Helper.GetInitials(ServicesDic[service].value) + '</span></span>';
                });
            }

            //services_str = '<div class="cell services">' + services_str + '<button class="btn btn-round btn-default" type="button"><i class="fa fa-plus"></i></button></div>';
            services_str = '<div class="cell services">' + services_str + '</div>';

            return services_str;
        }
    };

    this.subscribersTableTariffColTemplate = {
        id: "policing",
        header: [LangHelper.GetString(this.Id, "Tariffs"), {
//            id: _this.Id + "PolicingSuggestList",
//             content: "multiSelectFilter",
            content: "multiComboFilter",
            options: _this.GetPolicingsProfiles(),
            inputConfig: {
                suggest: {
                    fitMaster: false,
                    width: 300
                },
                tagTemplate: function (values)
                {
                    const local = Helper.GetElementPluralForm(values.length);
                    return `${values.length} ${local}`;
                }
            },
        }],
        // fillspace: true,
        width: 240,
        sort: "string",
        template:function(obj)
        {
            if(!obj.policing || obj.policing == "0")
                return "";
            var dic = App.DicsManager.GetDic(DicsEnum.PolicingProfilesDic);

            if(!dic || dic.length == 0)
            {
                return LangHelper.GetString("Dics","Personal tariff");
            }
            return dic[obj.policing] && dic[obj.policing].value ? dic[obj.policing].value : LangHelper.GetString("Dics","Personal tariff");
        }
    };
    this.subscribersTableAuthColTemplate = {
        id:"auth_status",
        header: [TooltipTemplate(LangHelper.GetString(_this.Id, "Auth status")), {
            content: "richSelectFilter",
            options: function(){
                /*
                var opts = [];
                Helper.DictToArr(BindTypesDic).forEach(function (Opt)
                {
                    opts.push({id:Opt.id, value:Helper.GetFirstInitials(Opt.value)});
                    opts.push({id:Opt.id, value:Opt.value});
                });

                return opts;
                */
                return Helper.DictToArr(SubscribersAuthStatusesDic);
            }(),
            inputConfig: {suggest: {fitMaster: false}},
            compare:function (value, filter)
            {
                var res = true;
                var valueStr = "";

                if(value)
                {
                    valueStr = value;
                }

                if(filter)
                {
                    Object.keys(filter).forEach(function (key) {
                        if(filter[key] && valueStr.indexOf(key) === -1)
                        {
                            res = false;
                            return false;
                        }
                    });
                }



                return res;
            }
        }],
        width: 120,
        template: function (obj)
        {
            var value = LangHelper.GetString("Subscribers", "Unknown");
            if(obj.auth_status !== null && SubscribersAuthStatusesDic[obj.auth_status])
            {
                value = SubscribersAuthStatusesDic[obj.auth_status].value;
            }
            return "<span>"+value+"</span>";
        },
        tooltip: function (obj)
        {
            var value = LangHelper.GetString("Subscribers", "Unknown");
            if(obj.auth_status !== null && SubscribersAuthStatusesDic[obj.auth_status])
            {
                value = SubscribersAuthStatusesDic[obj.auth_status].value;
            }
            return "<span>"+value+"</span>";
        },
        sort: "string"
    };


    this.SyncStatusWidget = new SubscriberSyncStatusWidget();

    this.subscribersTableTemplate =
        {
            gravity:2,
            rows: [
                {
                    view: "toolbar",
                    elements: _this.GetToolbarButtons()
                },
                BlockHeaderTemplate({title:LangHelper.GetString(this.Id, "List of subscribers"), icon:"users"}),
                {
                    view: "datatable",
                    id:this.tableId,
                    resizeColumn: true,
                    select: "row",
                    multiselect:true,
                    editaction: "custom",
                    tooltip:true,
                    scroll: "y",
                    headermenu: {
                        width: 350,
                        autoheight: true,
                        scroll: false
                    },
                    on:{
                        onItemClick: function (id,e,node)
                        {
                            var rowData = this.getItem(id);
                            let getMultiTabbarValue = App.SessionManager.GetPreference('multiSubscribersTabbar');

                            if (id.column === 'edit')
                            {
                                rowData.L2AuthState = _this.ViewModel.GetL2AuthParams();
                                var profileEdit = new SubscriberEditFormProfileDisplayConfig(null, true);
                                _this.ShowSubscriberEditForm(
                                    rowData,
                                    this.getItemNode(id),
                                    "right",
                                    false,
                                    false,
                                    new SubscriberEditFormDisplayConfig({profile: profileEdit}, rowData.login || rowData.ip));
                            }
                            else if(id.column === 'trash')
                            {
                                var __this = this;

                                var data = _this.table.getItem(id);

                                if(!data.login && !data.ip)
                                {
                                    _this.DeleteTableSelectedRows();
                                    return;
                                }

                                setTimeout(function ()
                                {
                                    var node = __this.getItemNode(id);
                                    _this.deleteContext.show(node, {pos:"bottom"});
                                }, 10);
                            }
                            else if(id.column === "ip" && rowData.bind_type == "1" && getMultiTabbarValue.indexOf("GroupSubscribersTab") !== -1) {
                                let __this = this;

                                _this.Views.ReportsWidgets[_this.MultiSubscribersWidgetName].Views.Table.getFilter("ip").value = "";
                                _this.Views.ReportsWidgets[_this.MultiSubscribersWidgetName].Views.Table.getFilter("auth_status").config.value = "";

                                let params = {
                                    filter: {
                                        login_equal: rowData.login
                                    }
                                };

                                _this.Views.ReportsWidgets[_this.MultiSubscribersWidgetName].RefreshData(0, params);

                                setTimeout(function ()
                                {
                                    var node = __this.getItemNode(id);
                                    _this.MultiSubscribersIpTable.show(node, {pos:"right"});
                                }, 10);
                            }
                        },
                        // onAfterLoad:function()
                        // {
                        //
                        //     for (var i in this.config.columns) {
                        //         this.config.columns[i].adjust = false;
                        //     }
                        // },
                        onAfterSelect:function(data, preserve)
                        {
                            var item = this.getItem(data.id);
                            if(item)
                            {
                                if(!item.checked)
                                {
                                    item.checked = 1;
                                }
                                _this.table.updateItem(data.id, item);
                            }
                            _this.onTableRowSelect();
                        },
                        onAfterUnSelect:function(data)
                        {
                            var item = this.getItem(data.id);
                            if(item && item.checked)
                            {
                                if(item.checked)
                                {
                                    item.checked = 0;
                                }
                                _this.table.updateItem(data.id, item);
                            }
                            _this.onTableRowUnSelect();
                        },
                        onBeforeFilter:function()
                        {
                            return false;
                        },
                        onAfterFilter:function()
                        {
                            _this.Refresh();
                            // return false;
                        },
                        onBeforeSort:function()
                        {
                            _this.Refresh();
                            return false;
                        },
                        onHeaderClick:function(id, e, target)
                        {
                            if(id.column == "checked")
                            {
                                var cb = _this.table.getHeaderContent("mc");
                                if(cb.isChecked())
                                {
                                    _this.table.selectAll();
                                }
                                else{
                                    _this.table.unselectAll();
                                }
                            }
                            return false;
                        }
                    },
                    columns:function () {
                        var cols = [];

                        cols.push({
                            id:"checked",
                            header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                            template: CellColoredCheckBoxTemplate,
                            width:32
                        });
                        cols.push({
                            id: "edit",
                            header: "",
                            width: 32,
                            template: "<span class=\"webix_icon fa-pencil-square\" style='cursor: pointer'></span>",
                            headermenu: false
                        });
                        cols.push(_this.subscribersTableLognColTemplate);
                        cols.push(_this.subscribersTableIpColTemplate);
                        cols.push({
                            id:"bind_type",
                            header: [LangHelper.GetString(_this.Id, "Bind type"), {
                                content: "richSelectFilter",
                                options: function(){
                                    /*
                                    var opts = [];
                                    Helper.DictToArr(BindTypesDic).forEach(function (Opt)
                                    {
                                        opts.push({id:Opt.id, value:Helper.GetFirstInitials(Opt.value)});
                                        opts.push({id:Opt.id, value:Opt.value});
                                    });

                                    return opts;
                                    */
                                    return Helper.DictToArr(BindTypesDic);
                                }(),
                                inputConfig: {suggest: {fitMaster: false}},
                                compare:function (value, filter)
                                {
                                    var res = true;
                                    var valueStr = "";

                                    if(value)
                                    {
                                        valueStr = value;
                                    }

                                    if(filter)
                                    {
                                        Object.keys(filter).forEach(function (key) {
                                            if(filter[key] && valueStr.indexOf(key) === -1)
                                            {
                                                res = false;
                                                return false;
                                            }
                                        });
                                    }

                                    return res;
                                }
                            }],
                            width: 80,
                            template: function (obj)
                            {
                                return "<span title='"+BindTypesDic[obj.bind_type].tooltip+"'>"+Helper.GetFirstInitials(BindTypesDic[obj.bind_type].value)+"</span>";
                            },
                            sort: "string"
                        });
                        if(!_this.embedded)
                        {
                            cols.push(_this.subscribersTableServicesColTemplate);
                            cols.push(_this.subscribersTableTariffColTemplate);
                        }
                        else if(_this.tariffOnly)
                        {
                            cols.push(_this.subscribersTableTariffColTemplate);
                        }
                        else if(_this.servicesOnly)
                        {
                            cols.push(_this.subscribersTableServicesColTemplate);

                            if(_this.services)
                            {
                                _this.services.forEach(function(Val)
                                {
                                    cols.push(_this.GetServiceColumnTemplate(Val));
                                });
                            }
                        }
                        cols.push(_this.subscribersTableAuthColTemplate);
                        cols.push({
                            id: "trash",
                            header: "",
                            width: 32,
                            template: "<span class=\"webix_icon fa-trash\"  style='cursor: pointer'></span>",
                            headermenu: false,
                            align:"right"
                        });
                        cols.push({header: {content: "headerMenu"}, headermenu: false, width: 32});

                        return cols;
                    }(),
                    data:[],
                    rules:{
                        "valid":function (value)
                        {
                            return value;
                        }
                    }
                },
                {
                    view: "toolbar",
                    id: this.id + "PagerToolbar",
                    padding: 0,
                    margin: 0,
                    height:32,
                    elements: [
                        {
                            view: "label",
                            id: this.id + "SizeInfo",
                            label: "",
                            minWidth:170
                        },
                        {},
                        {
                            view: "pager",
                            id: this.tableId + "Paging",
                            template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                            master: false,
                            gravity:4,
                            on: {
                                onAfterPageChange: function (Page) {
                                    _this.Refresh(Page);
                                }
                            }
                        },
                        {}
                    ]
                }
            ]
        };

    this.mainTemplate = [
        {
            cols: [
                this.sideBarTemplate,
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title:LangHelper.GetString("AppView", "Services control"),title:LangHelper.GetString("AppView", "Subscribers and services")}),
                                {
                                    view: "tabbar",
                                    id: this.id + "SubscrubersVchannelsTabbar",
                                    value: this.id + "SubscribersTab",
                                    optionWidth: 240,
                                    height: 55,
                                    bottomOffset: 15,
                                    options: [
                                        {
                                            id: this.id + "SubscribersTab",
                                            value: LangHelper.GetString(this.Id,"Subscribers"),
                                        },
                                        {
                                            id: this.id + "VchannelsTab",
                                            value: LangHelper.GetString(this.Id,"Vchannels"),
                                        }
                                    ],
                                    on: {
                                        onChange: function (Id) {
                                            $$(Id).show();

                                            setTimeout(function (){
                                                if ((_this.Id + "VchannelsTab") == Id)
                                                    _this.VchannelsEmbedded.RefreshAll();
                                                else
                                                    _this.Refresh();
                                            }, 10);
                                        }
                                    },
                                },
                                {
                                    view: "multiview",
                                    animate:false,
                                    cells: [
                                        {
                                            id: this.id + "SubscribersTab",
                                            cols: [
                                                this.subscribersTableTemplate,
                                                {view:"resizer"},
                                                _this.SubscriberEditFormEmbedded.ViewConfig,
                                            ]
                                        },
                                        {
                                            id: this.id + "VchannelsTab",
                                            cols: [
                                                this.VchannelsEmbedded.view
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.embeddedTemplate = {
        rows: [
            {
                view: "tabbar",
                id: this.id + "SubscrubersVchannelsTabbar",
                value: this.id + "SubscribersTab",
                multiview: true,
                height: 40,
                bottomOffset: 5,
                options: [
                    {
                        id: this.id + "SubscribersTab",
                        value: LangHelper.GetString(this.Id,"Subscribers"),
                    },
                    {
                        id: this.id + "VchannelsTab",
                        value: LangHelper.GetString(this.Id,"Vchannels"),
                    }
                ],
                on: {
                    onChange: function (Id) {
                        $$(Id).show();

                        if ((_this.id + "VchannelsTab") == Id)
                            _this.VchannelsEmbedded.RefreshAll();
                        else
                            _this.Refresh();
                    }
                },
            },
            {
                view: "multiview",
                cells: [
                    {
                        id: this.id + "SubscribersTab",
                        cols: [
                            this.subscribersTableTemplate,
                        ]
                    },
                    {
                        id: this.id + "VchannelsTab",
                        rows: this.VchannelsEmbedded.view,
                    }
                ],
            },
        ],
    };

    this.tabelRowsSelectedCount = new Rx.Subject();

    this.btns = {
        servicesBtn:null,
        tariffBtn:null,
        deleteBtn:null,
        refreshBtn:null,
        AuthStatusBtn: null
    };

    this.MultiSubscribersWidgetName = Params && Params.MultiSubscribers && Params.MultiSubscribers.WidgetName ? Params.MultiSubscribers.WidgetName : "MultiSubscribersReport";

    this.Views = {
        AuthStatusBtnSelectPopup : null,
        SubscrubersVchannelsTabbar: null,

        MultiSubscribersTabbar: null,
        MultiSubscribersIpTable: null,


        ReportsWidgets:{},
        Widgets: {}
    };

    let refreshIpMultiSubscribersMethod = this.RefreshIpMultiSubscribers;
    this.Views.ReportsWidgets[this.MultiSubscribersWidgetName] = Params && Params.MultiSubscribers && Params.MultiSubscribers.Widget && Params.MultiSubscribers.WidgetName
        ? Params.MultiSubscribers.Widget : MultiSubscribersTableWidget({
        id: this.Id + "MultiSubscribersReport",
    });

    this.Views.ReportsWidgets[this.MultiSubscribersWidgetName].onAfterFilterCustomHandler = function () {
        refreshIpMultiSubscribersMethod();
    };


    this.MultiSubscribersIpTable = webix.ui({
        view: "popup",
        width: 700,
        height: 450,
        modal: true,
        id: this.Id + "MultiSubscribersIpPopup",
        body: {
            view: "form",
            id:this.Id + "Form",
            borderless:true,
            elements:[
                {
                    rows: [
                        BlockHeaderTemplate({title: LangHelper.GetString("Subscribers", "List IP"), icon: "users"}),
                        this.Views.ReportsWidgets[_this.MultiSubscribersWidgetName].ViewConfig,
                    ],
                },
                {
                    cols: [
                        {},
                        {
                            view: "button",
                            label: LangHelper.GetString("All", "Close"),
                            click: function () {
                                _this.MultiSubscribersIpTable.hide();
                            }
                        },
                    ]
                }
            ]
        }
    });

    this.Subscriptions = {};
    this.NotificationsCount = 0;

    this.Init(Params);

    return this;
}

SubscribersViewController.prototype.Init = function (Params) {
    "use strict";

    if(this.embedded)
    {
        this.view = this.embeddedTemplate;
    }
    else
    {
        this.view = this.mainTemplate;
    }
};

SubscribersViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.SyncStatusWidget.BindAll(_this);

    this.PathParams = Params;

    this.table = $$(this.tableId);
    webix.extend(this.table, webix.ProgressBar);

    this.paging = $$(this.tableId+"Paging");

    this.btns.servicesBtn = $$(this.id+"servicesBtn");
    this.btns.tariffBtn = $$(this.id+"tariffBtn");
    this.btns.deleteBtn = $$(this.id+"deleteBtn");
    this.btns.refreshBtn = $$(this.id+"refreshBtn");
    this.btns.AuthStatusBtn = $$(this.id+"AuthStatusBtn");
    this.Views.AuthStatusBtnSelectPopup = $$(this.id+"AuthStatusBtn" + "SelectPopup");

    this.Views.SubscrubersVchannelsTabbar = $$(this.id + "SubscrubersVchannelsTabbar");
    this.Views.MultiSubscribersTabbar = $$(this.id + "MultiSubscribersTabbar");
    this.Views.MultiSubscribersIpTable = $$(this.id + "MultiSubscribersIpTable");

    this.Views.SizeInfo = $$(this.id + "SizeInfo");

    var autoWidthCssRule = {
        width:"auto !important"
    };

    this.paging.define("css", autoWidthCssRule);
    this.Views.SizeInfo.define("css", autoWidthCssRule);

    let getMultiTabbarValue = App.SessionManager.GetPreference('multiSubscribersTabbar');

    if(!getMultiTabbarValue){
        App.SessionManager.SetPreference('multiSubscribersTabbar', "ExtendedSubscribersTab");
        getMultiTabbarValue = App.SessionManager.GetPreference('multiSubscribersTabbar');
    }

    if(getMultiTabbarValue.indexOf("GroupSubscribersTab") !== -1){
        _this.Views.MultiSubscribersTabbar.setValue("GroupSubscribersTab");
        if(_this.btns.AuthStatusBtn)
            _this.btns.AuthStatusBtn.disable();
    }

    _this.Views.MultiSubscribersTabbar.attachEvent("onChange", function(id, column, state)
    {
        if(id.indexOf("ExtendedSubscribersTab") !== -1){
            App.SessionManager.SetPreference('multiSubscribersTabbar', "ExtendedSubscribersTab");
            if(_this.btns.AuthStatusBtn)
                _this.btns.AuthStatusBtn.enable();
        }
        else {
            App.SessionManager.SetPreference('multiSubscribersTabbar', "GroupSubscribersTab");
            if(_this.btns.AuthStatusBtn)
                _this.btns.AuthStatusBtn.disable();
        }

        _this.Refresh();
    });

    this.Subscriptions.SyncStatusSuccess = this.SyncStatusWidget.Signals.SyncSubscribersSuccess.subscribe(function(Val){
        if(Val)
        {
            _this.Refresh();
        }
    });

    this.tabelRowsSelectedCount.subscribe(function (value) {
        if(value > 1)
        {
            if(_this.btns.servicesBtn)
                _this.btns.servicesBtn.enable();
            if(_this.btns.tariffBtn)
                _this.btns.tariffBtn.enable();

            _this.btns.deleteBtn.enable();
        }
        else
        {
            if(_this.btns.servicesBtn)
                _this.btns.servicesBtn.disable();
            if(_this.btns.tariffBtn)
                _this.btns.tariffBtn.disable();

            _this.btns.deleteBtn.disable();
        }
    });

    this.Subscriptions.SubscribersSignalSubscription = this.ViewModel.SubscribersSignal.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.Update();
        }
    });

    this.Subscriptions.MultiSubscribersSignalSubscription = this.ViewModel.MultiSubscribersSignal.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.Update();
        }
    });

    this.Subscriptions.HardwareConnected = App.SessionManager.CurrentHardwareId.subscribe(function (CurrentHardwareId)
    {
        if (CurrentHardwareId)
        {
            _this.RefreshAll();
        }
    });

    this.Subscriptions.SubscriberEditFormEmbeddedSaveDataSignal = this.SubscriberEditFormEmbedded.SaveDataSinal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.SaveSubscribers(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditFormEmbeddedSaveAuthStateSignal = this.SubscriberEditFormEmbedded.SetAuthStateSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.SaveSubscribersAuthState(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditFormEmbeddedResetAuthStateSignal = this.SubscriberEditFormEmbedded.ResetAuthStateSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.ClearSubscribersAuthState(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditFormEmbeddedSyncAuthPropSignal = this.SubscriberEditFormEmbedded.SyncAuthPropSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.SyncAuthProp(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditFormEmbeddedDeleteAuthPropSignal = this.SubscriberEditFormEmbedded.DeleteAuthPropSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.DeleteAuthProp(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditFormEmbeddedSetAuthPropSignal = this.SubscriberEditFormEmbedded.SetAuthPropSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.SetAuthProp(DataToSave);
        }
    });

    this.Subscriptions.PolicingProfilesDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.PolicingProfilesDic].subscribe(function(Val)
    {
        if (Val)
        {
            var profiles = _this.GetPolicingsProfiles();

            if(_this.table)
            {
                var column = _this.table.getColumnConfig(_this.subscribersTableTariffColTemplate.id);

                if(column)
                {
                    column.header[1].options = [];
                    _this.table.refreshColumns();
                    column.header[1].options = profiles;

                    var state = _this.table.getState();
                    var resultArr = [];
                    if(state.filter && state.filter.policing)
                    {
                        var arr = state.filter.policing.split(",");
                        arr.forEach(function(Val)
                        {

                            var index = column.header[1].options.findIndex(function(obj){
                                return obj.id == Val;
                            });

                            if(index > -1)
                            {
                                resultArr.push(Val);
                            }
                        });

                        column.header[1].value = resultArr.join(",");
                    }


                    _this.table.refreshColumns();
                    _this.table.refresh();

                }
            }

            _this.VchannelsEmbedded.UpdatePolicingProfiles(profiles);
        }

    });

    this.Subscriptions.BlackProfilesDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.BlackListsProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(4);
        }

    });

    this.Subscriptions.WhiteProfilesDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.WhiteListsProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(5);
        }

    });

    this.Subscriptions.DDOSProtectionDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.DDOSProtectionProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(10);
        }
    });

    this.Subscriptions.SessionPolicingDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.SessionPolicingProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(18);
        }
    });

    this.Subscriptions.CgNatDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.CgNatProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(11);
        }
    });

    this.Subscriptions.MiniFirewallDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.MiniFireWallProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(13);
        }
    });


    this.table.attachEvent("onCheck", function(id, column, state)
    {
        if(column == "checked")
        {
            if(state)
                _this.table.select(id, true);
            else
                _this.table.unselect(id, true);

        }
    });

    if (!_this.embedded)
    {
        this.Views.SubscrubersVchannelsTabbar.attachEvent("onChange", function(NewVal, OldVal)
        {
            _this.SetAllPathParam();
        });
    }
    // _this.VchannelsEmbedded.BindAll(_this);
};

SubscribersViewController.prototype.GetServiceColumnTemplate = function(Service)
{
    var _this = this;

    return {
            id: "service_" + Service,
            header: [ServicesDic[Service].value, {
            content: "multiComboFilter",
            options: _this.GetServicesProfilesOptions(Service),
            inputConfig: {
                suggest: {
                    fitMaster: false,
                    width: 300
                },
                tagTemplate: function (values)
                {
                    const local = Helper.GetElementPluralForm(values.length);
                    return `${values.length} ${local}`;
                }
            },
        }],
        fillspace: true,
        sort: false,
        template:function(obj)
        {
            if(!obj.services_profiles)
                return "";

            var params = JSON.parse(obj.services_profiles);
            if(!params || !Object.keys(params).length)
                return "";

            var dicEnum = ServicesDicsEnum[Service];

            if(!dicEnum)
                return "";

            var dic = App.DicsManager.GetDic(dicEnum);

            if(!dic || !dic[params[Service]])
            {
                return "";
            }

            return dic[params[Service]] && dic[params[Service]].value ? dic[params[Service]].value : "";
        }
    }
};

SubscribersViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    var _this = this;

    if(!this.embedded)
    {
        webix.ready(function () {
            $$(_this.id+"LeftSideBar").select("Subscribers");
        });

        this.SubscriberEditFormEmbedded.ViewDidLoad();
    }

    this.VchannelsEmbedded.ViewDidLoad();

    this.BindAll(Params);

    if (!_this.embedded)
    {
        this.GetAllPathParam();

        this.SetAllPathParam();
    }
};

SubscribersViewController.prototype.ServicesTabsFromDic = function (Params)
{
    "use strict";

    var _this = this;

    var arr = Helper.DictToArr(ServicesDic);

    var tabs = [];

    arr.forEach(function (v,i) {
        var tab = {
            value:v.value,
            id:_this.GetServicesTabsIdByIndex(i)
        }
        tabs.push(tab);
    });

    return tabs;
};

SubscribersViewController.prototype.GetServicesTabsIdByIndex = function (Index)
{
    "use strict";

    var _this = this;

    var arr = Helper.DictToArr(ServicesDic);

    var id = "";

    if(arr[Index])
        id = _this.id+"_service_tab_"+arr[Index].id;

    return id;
};

SubscribersViewController.prototype.GetTableSelectedData = function ()
{
    var selected = this.table.getSelectedItem();
    return selected;
};

SubscribersViewController.prototype.onTableRowSelect = function ()
{
    var data = this.GetTableSelectedData();
    this.tabelRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);

    if(!this.embedded && data)
    {
        data.L2AuthState = this.ViewModel.GetL2AuthParams();
        this.SubscriberEditFormEmbedded.SetData(data);

        this.MultiSubscribersSelectConfigOptions(data);

        if(this.SubscriberEditFormEmbedded.Widgets.Ping)
            this.SubscriberEditFormEmbedded.Widgets.Ping.SendTerminalClearCommand();
        
        if(App.NavRouter.views.SubscriberEditForm)
        {
            App.NavRouter.views.SubscriberEditForm.SetData(data);
        }
    }
};

SubscribersViewController.prototype.onTableRowUnSelect = function ()
{
    var data = this.GetTableSelectedData();
    this.tabelRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);

    if(!this.embedded)
    {
        this.SubscriberEditFormEmbedded.SetData(data);

        this.MultiSubscribersSelectConfigOptions(data);

        if(this.SubscriberEditFormEmbedded.Widgets.Ping)
            this.SubscriberEditFormEmbedded.Widgets.Ping.SendTerminalClearCommand();
    }
};

SubscribersViewController.prototype.SetData = function (Data)
{
    //this.table.clearAll();
    //this.table.parse(DataGens.Subscribers.GridData());
};

SubscribersViewController.prototype.Refresh = function(Page)
{
    var _this = this;

    var state = this.table.getState();

    let getMultiTabbarValue = App.SessionManager.GetPreference('multiSubscribersTabbar');

    if(getMultiTabbarValue.indexOf("GroupSubscribersTab") !== -1) {
        this.ViewModel.GetAllMultiSubscribers({
            sort: state ? state.sort : null,
            page:Page,
            filter: state ? state.filter : null,
            callback: function () {}})
    } else {
        this.ViewModel.RefreshSubscribers({
            page:Page,
            filter:state ? state.filter : null,
            sort: state ? state.sort : null,
            callback:function ()
            {}});
    }
};

SubscribersViewController.prototype.RefreshAll = function(Page)
{
    this.ViewModel.RefreshL2AuthParams();
    this.Refresh(Page);
    App.DicsManager.Refresh({data: [DicsEnum.WhiteListsProfilesDic, DicsEnum.BlackListsProfilesDic, DicsEnum.DDOSProtectionProfilesDic, DicsEnum.SessionPolicingProfilesDic, DicsEnum.CgNatProfilesDic, DicsEnum.PolicingProfilesDic, DicsEnum.MiniFireWallProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});
};

SubscribersViewController.prototype.Update = function()
{
    if(!this.table.$destructed)
    {
        this.table.clearAll();

        let getMultiTabbarValue = App.SessionManager.GetPreference('multiSubscribersTabbar');

        if(getMultiTabbarValue.indexOf("GroupSubscribersTab") !== -1){
            this.table.parse(this.ViewModel.GetMultiSubscribers());
        } else {
            this.table.parse(this.ViewModel.GetSubscribers());
        }
        this.table.refresh();


        this.paging.define(this.ViewModel.Total);
        this.paging.refresh();

        var config = this.ViewModel.Total;

        var countRows = parseInt(config.count, 10);
        var pageNumber = parseInt(config.page, 10);
        var sizePage = parseInt(config.size, 10);

        var rowsFrom = countRows ? sizePage * pageNumber + 1 : 0;
        var rowsTo = sizePage*(pageNumber + 1);

        rowsTo = countRows < rowsTo ? countRows : rowsTo;

        var sizeInfoLabel = `${rowsFrom} - ${rowsTo} ${LangHelper.GetString(this.id, "Of").toLowerCase()} ${countRows}`;

        this.Views.SizeInfo.setValue(sizeInfoLabel);
        this.Views.SizeInfo.define("tooltip", sizeInfoLabel);
    }
};

SubscribersViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;
    //
    // if(this.table)
    // {
    //     this.table.config.columns = [];
    //     this.table.refreshColumns();
    // }

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    this.SyncStatusWidget.Destroy();

    // this.Subscriptions.MiniFirewallDicUpdatedSignal.unsubscribe();

    if(this.SubscriberEditFormEmbedded)
        this.SubscriberEditFormEmbedded.Destroy();

    if(this.VchannelsEmbedded)
        this.VchannelsEmbedded.Destroy();
};

SubscribersViewController.prototype.ShowSubscriberEditForm = function (Data, Node, Pos, ServicesOnly, TariffOnly, CustomParams, All, OnClose)
{
    var _this = this;

    App.NavRouter.PresentModalView({
        id: "SubscriberEditForm",
        data: Data,
        servicesOnly:ServicesOnly?true:false,
        tariffOnly:TariffOnly?true:false,
        hideServices: _this.tariffOnly,
        displayConfig: new SubscriberEditFormDisplayConfig(CustomParams ? CustomParams : {
            profile: {
                show: true,
                services: !TariffOnly,
                login: !(TariffOnly || ServicesOnly),
                tariffs: !ServicesOnly
            }
        },  CustomParams ? false : !(TariffOnly || ServicesOnly)),
        onClose: OnClose
    });

    App.NavRouter.views.SubscriberEditForm.Show(Node,Pos);

    let getMultiTabbarValue = App.SessionManager.GetPreference('multiSubscribersTabbar');
    let tabbar = App.NavRouter.views.SubscriberEditForm.Views.Tabbar;
    let options = tabbar.config.options;

    if(App.NavRouter.views.SubscriberEditForm.Views.LoginField && App.NavRouter.views.SubscriberEditForm.Views.IpField)
    {
        if(Data && (Data.login || Data.ip) && Data.bind_type == "1" && getMultiTabbarValue.indexOf("GroupSubscribersTab") !== -1)
        {
            App.NavRouter.views.SubscriberEditForm.Views.LoginField.disable();
            App.NavRouter.views.SubscriberEditForm.Views.IpField.hide();
            options.forEach((item) => {
                if(item.id.indexOf("Profile") === -1)
                    tabbar.hideOption(item.id);
            })
        }
        else {
            App.NavRouter.views.SubscriberEditForm.Views.LoginField.enable();
        }
        tabbar.refresh();
    }


    this.Subscriptions.SubscriberEditFormSaveDataSinal = App.NavRouter.views.SubscriberEditForm.SaveDataSinal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.SaveSubscribers(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditSetAuthStateSinal = App.NavRouter.views.SubscriberEditForm.SetAuthStateSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            All ? _this.SaveAllSubscribersAuthState(DataToSave) : _this.SaveSubscribersAuthState(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditResetAuthStateSinal = App.NavRouter.views.SubscriberEditForm.ResetAuthStateSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            All ? _this.ClearAllSubscribersAuthState(DataToSave) : _this.ClearSubscribersAuthState(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditSyncAuthPropSignal = App.NavRouter.views.SubscriberEditForm.SyncAuthPropSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.SyncAuthProp(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditDeleteAuthPropSignal = App.NavRouter.views.SubscriberEditForm.DeleteAuthPropSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.DeleteAuthProp(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditSetuthPropSignal = App.NavRouter.views.SubscriberEditForm.SetAuthPropSignal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.SetAuthProp(DataToSave);
        }
    });

    this.Subscriptions.SubscriberEditOnHideSignal = App.NavRouter.views.SubscriberEditForm.OnHide.subscribe(function(Hide){
        if(Hide)
        {
            if(_this.Views.AuthStatusBtnSelectPopup)
                _this.Views.AuthStatusBtnSelectPopup.hide();
        }
    });
};

SubscribersViewController.prototype.ShowSubscribersPolicingCustomForm = function (Node, Pos)
{
    var _this = this;

    var data = this.table.getState();

    App.NavRouter.PresentModalView({
        id: "SubscribersPolicingCustomFormView"
    });

    App.NavRouter.views.SubscribersPolicingCustomForm.Show(data.filter,Node,Pos);

    this.Subscriptions.SubscribersPolicingCustomFormSaveDataSinal = App.NavRouter.views.SubscribersPolicingCustomForm.SaveDataSinal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.SetPolicingsByFilter(DataToSave);
        }
    });
};

SubscribersViewController.prototype.SetPolicingsByFilter = function(Params)
{
    var _this = this;

    _this.ViewModel.SetPolicingsByFilter({
        policing: Params.policing,
        filter: Params.filter,
        callback: function(R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString(_this.Id, "Tariff for filtered subscribers will be set up in the background"));
            }
            else{
                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

SubscribersViewController.prototype.SaveSubscribers = function (Subscribers)
{
    var _this = this;

    var subscribersToSaveObj = {};

    if(Array.isArray(Subscribers))
    {
        Subscribers.forEach(function (Subscriber)
        {
            subscribersToSaveObj[Subscriber.id] = Subscriber;
        });
    }
    else
    {
        subscribersToSaveObj[Subscribers.id] = Subscribers;
    }

    var isValid = true;
    var tableRow = {};

    Object.keys(subscribersToSaveObj).forEach(function (Key)
    {
        var id = subscribersToSaveObj[Key].id;

        tableRow[Key] = _this.table.getItem(id);

        if(tableRow[Key])
        {
            tableRow[Key].valid = true;

            if(!_this.table.validate(id))
            {
                isValid = false;
            }
        }
        else
            isValid = false;


    });

    if(isValid)
    {
        var data = [];

        Object.keys(subscribersToSaveObj).forEach(function (Key)
        {
            data.push({newSubscriber:subscribersToSaveObj[Key], oldSubscriber:subscribersToSaveObj[Key].oldSubscriber});
        });

        this.ViewModel.SaveSubscribers({data:data, callback:function (R)
        {
            var processResult = function (R)
            {
                if(R.success)
                {
                    var success = true;
                    var services = true;
                    var bind = true;
                    var policing = false;

                    var sub = new SubscriberModel(subscribersToSaveObj[R.id]);
                    var subName = sub.identity_type == SubscribersIdentitiesDic.login.id ? sub.login : sub.ip;
                    var message = LangHelper.GetString(_this.Id,"Subscriber")+" "+"<strong>" + subName + "</strong>";


                    var errMessage = "";

                    if(R.data.bind)
                    {
                        if(R.data.bind.success)
                        {
                            if(R.data.bind.data.bind_result)
                            {
                                var bindResult = R.data.bind.data.bind_result;

                                if(bindResult.fail > 0 || bindResult.data.length)
                                {
                                    success = false;
                                    bind = false;

                                    if(bindResult.data.length)
                                    {
                                        bindResult.data.forEach(function (Line)
                                        {
                                            if(typeof(Line) === "object")
                                            {
                                                errMessage += JSON.stringify(Line)+"<br/>";
                                            }
                                            else
                                                errMessage += Line+"<br/>";
                                        });
                                    }
                                }
                            }

                            if(R.data.bind.data.unbind_result)
                            {
                                var unbindResult = R.data.bind.data.unbind_result;

                                if(unbindResult.fail > 0 || unbindResult.data.length)
                                {
                                    success = false;
                                    bind = false;

                                    if(unbindResult.data.length)
                                    {
                                        unbindResult.data.forEach(function (Line)
                                        {
                                            if(typeof(Line) === "object")
                                            {
                                                errMessage += JSON.stringify(Line)+"<br/>";
                                            }
                                            else
                                                errMessage += Line+"<br/>";
                                        });
                                    }
                                }
                            }
                        }
                        else
                        {
                            success = false;
                            bind = false;

                            errMessage = R.data.bind.error.msg;
                        }
                    }

                    if(R.data.services)
                    {
                        if(R.data.services.success)
                        {
                            if(R.data.services.data.bind_result)
                            {
                                var bindResult = R.data.services.data.bind_result;

                                if(bindResult.fail > 0 || (bindResult.data && bindResult.data.length))
                                {
                                    success = false;
                                    services = false;

                                    if(bindResult.data.length)
                                    {
                                        bindResult.data.forEach(function (Line)
                                        {
                                            if(typeof(Line) === "object")
                                            {
                                                errMessage += JSON.stringify(Line)+"<br/>";
                                            }
                                            else
                                                errMessage += Line+"<br/>";
                                        });
                                    }
                                }
                            }

                            if(R.data.services.data.services_profiles)
                            {
                                var sp = R.data.services.data.services_profiles;
                                for(var i in sp)
                                {
                                    if(sp[i] && sp[i].success)
                                    {
                                        if(sp[i].data)
                                        {
                                            var spdata = sp[i].data
                                            for(var j in spdata)
                                            {
                                                if(!spdata[j].success)
                                                {
                                                    errMessage += Helper.CapitalizeFirstLetter(j) + " of service " + i + " failed <br/>";
                                                }
                                            }
                                        }
                                    }
                                    else
                                    {
                                        errMessage += "Binding of service " + i + " failed:" + JSON.stringify(sp[i]) + "<br/";
                                    }
                                }
                            }

                            if(R.data.services.data.unbind_result)
                            {
                                var unbindResult = R.data.services.data.unbind_result;

                                if(unbindResult.fail > 0 || unbindResult.data.length)
                                {
                                    success = false;
                                    services = false;

                                    if(unbindResult.data.length)
                                    {
                                        unbindResult.data.forEach(function (Line)
                                        {
                                            if(typeof(Line) === "object")
                                            {
                                                errMessage += JSON.stringify(Line)+"<br/>";
                                            }
                                            else
                                                errMessage += Line+"<br/>";
                                        });
                                    }
                                }
                            }
                        }
                        else
                        {
                            success = false;
                            bind = false;

                            errMessage = R.data.services.error.msg;
                        }
                    }

                    if(R.data.policing)
                    {
                        if(R.data.policing.success)
                        {
                            if(R.data.policing.data.bind)
                            {
                                var bindResult = R.data.policing.data.bind;

                                if(!bindResult.success)
                                {
                                    success = false;
                                    policing = false;

                                    if(bindResult.error && bindResult.error.msg)
                                    {
                                        errMessage += bindResult.error.msg;
                                    }
                                }
                            }

                            if(R.data.policing.data.unbind)
                            {
                                var unbindResult = R.data.policing.data.unbind;

                                if(!unbindResult.success)
                                {
                                    success = false;
                                    policing = false;

                                    if(unbindResult.error && unbindResult.error.msg)
                                    {
                                        errMessage += unbindResult.error.msg;
                                    }
                                }
                            }
                        }
                        else
                        {
                            success = false;
                            policing = false;

                            errMessage = R.data.policing.error.msg;
                        }
                    }

                    if(success)
                    {
                        webix.message(message + " - "+LangHelper.GetString(_this.Id,"Saved"));

                        delete subscribersToSaveObj[R.id].oldSubscriber;

                        if(R.data.bind && R.data.bind.data.bind_result && R.data.bind.data.bind_result.total > 1)
                        {
                            _this.Refresh();
                        }
                    }
                    else
                    {
                        if(errMessage)
                        {
                            webix.message({type:"error", text:message + " - "+LangHelper.GetString(_this.Id,"Error")+". <br/>"+errMessage});
                        }
                        else
                        {
                            webix.message({type:"error", text:message + " - "+LangHelper.GetString(_this.Id,"Error")+". <br/> "+LangHelper.GetString(_this.Id,"See logs")});
                        }

                        if(!tableRow[R.id].oldSubscriber.ip && !tableRow[R.id].oldSubscriber.login) {
                            _this.table.remove([R.id]);
                        } else {
                            tableRow[R.id].valid = false;
                            _this.table.validate(R.id);
                        }
                    }
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});

                    if(tableRow && tableRow[R.id])
                    {
                        if(!tableRow[R.id].oldSubscriber.ip && !tableRow[R.id].oldSubscriber.login) {
                            _this.table.remove([R.id]);
                        } else {
                            tableRow[R.id].valid = false;
                            _this.table.validate(R.id);
                        }
                    }
                }
            }

            if(R)
            {
                if(Array.isArray(R))
                {
                    R.forEach(function (R)
                    {
                        processResult(R);
                    });
                }
                else
                {
                    processResult(R);
                }
                App.DicsManager.Refresh({data:[DicsEnum.PolicingProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});

            }

            _this.onTableRowSelect();
        }});
    }
};

SubscribersViewController.prototype.DeleteTableSelectedRows = function (RowId)
{
    var _this = this;

    var selectedRows = this.GetTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    var rowsToUnbind = [];
    var rowsToJustDelete = [];

    selectedRows.forEach(function (Row)
    {
        if(Row.login)
        {
            rowsToUnbind.push(Row);
        }
        else
        {
            rowsToJustDelete.push(Row);
        }
    });

    rowsToJustDelete.forEach(function (Row)
    {
        _this.table.remove(Row.id)
    });

    if(rowsToUnbind.length)
    {
        this.ViewModel.DeleteSubscribers({data:rowsToUnbind, callback:function (R)
        {
            var processResult = function (R)
            {
                var tableRow = _this.table.getItem(R.id);

                if(R.success)
                {
                    var success = true;
                    var services = true;
                    var bind = true;

                    var errMessage = "";

                    if(R.data.unbind)
                    {
                        if(R.data.unbind.success)
                        {
                            if(R.data.unbind.data.fail > 0)
                            {
                                success = false;
                                bind = false;
                            }
                        }
                        else
                        {
                            success = false;
                            bind = false;

                            errMessage = R.data.unbind.error.msg;
                        }
                    }

                    if(R.data.services)
                    {
                        if(R.data.services.success)
                        {
                            if(R.data.services.data.bind_result)
                            {
                                var bindResult = R.data.services.data.bind_result;

                                if(bindResult.fail > 0)
                                {
                                    success = false;
                                    services = false;
                                }
                            }

                            if(R.data.services.data.unbind_result)
                            {
                                var unbindResult = R.data.services.data.unbind_result;

                                if(unbindResult.fail > 0)
                                {
                                    success = false;
                                    services = false;
                                }
                            }
                        }
                        else
                        {
                            success = false;
                            bind = false;

                            errMessage = R.data.services.error.msg;
                        }
                    }


                    if(success)
                    {
                        webix.message(LangHelper.GetString(_this.Id,"Deleted"));

                        _this.table.remove(R.id);
                    }
                    else
                    {
                        if(errMessage)
                        {
                            webix.message({type:"error", text:LangHelper.GetString(_this.Id,"Error")+". <br/>"+errMessage});
                        }
                        else
                        {
                            webix.message({type:"error", text:LangHelper.GetString(_this.Id,"Error")+". <br/> "+LangHelper.GetString(_this.Id,"See logs")});
                        }

                        if(tableRow)
                        {
                            tableRow.valid = false;
                            _this.table.validate(R.id);
                        }

                    }
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});

                    if(tableRow)
                    {
                        tableRow.valid = false;
                        _this.table.validate(R.id);
                    }
                }
            };

            if(R)
            {
                if(Array.isArray(R))
                {
                    R.forEach(function (R)
                    {
                        processResult(R);
                    });
                }
                else
                {
                    processResult(R);
                }
            }

            _this.onTableRowUnSelect();
        }});
    }
};

SubscribersViewController.prototype.ForceSyncSubscribers = function(Params)
{
    var _this = this;

    _this.AdvcManager.ForceSyncCompanies({
        callback: function(R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString(_this.Id, "Forced synchronization subscribers running in the background"));
            }
            else{
                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

SubscribersViewController.prototype.GetPolicingsProfiles = function()
{
    var _this = this;

    var options = [
        {value:LangHelper.GetString(_this.Id, "No tariff"), id: "0", dic_id: "0"}
    ];
    options = options.concat(Helper.DictToArr(App.DicsManager.GetDic(DicsEnum.PolicingProfilesDic)));

    return options;
};

SubscribersViewController.prototype.GetServicesOptions = function()
{
    var _this = this;

    var options = [
        {value:LangHelper.GetString(_this.Id, "No services"), id: "is_null", dic_id: "is_null"}
    ];
    options = options.concat(Helper.DictToArr(ServicesDic));

    return options;
};

SubscribersViewController.prototype.GetToolbarButtons = function()
{
    var _this = this;
    var arr = [
        {
            view: "button",
            type: "icon",
            icon: "plus",
            css:"toolbar_round_btn",
            width:32,
            tooltip:LangHelper.GetString(_this.Id, "Add subscriber"),
            click:function ()
            {
                // App.NavRouter.PresentModalView({
                //     id: "SubscriberEditForm"
                // });
                // App.NavRouter.views.SubscriberEditForm.Show(this.getNode(),"bottom");

                var model = new SubscriberModel();
                _this.table.add(model);
                _this.table.select(model.id, false);
                _this.table.showItem(model.id);
                _this.ShowSubscriberEditForm(
                    model,
                    _this.table.getItemNode(model.id),
                    "right",
                    false,
                    false,
                    new SubscriberEditFormDisplayConfig({profile: new SubscriberEditFormProfileDisplayConfig(null, true)}, false),
                    false,
                    function(){
                        _this.table.remove(model.id);
                    }
                );

            }
        },
        {
            width:24
        }
    ];

    if(!_this.tariffOnly)
    {
        arr.push({
            view: "button",
            id:_this.id+"servicesBtn",
            type: "icon",
            icon: "cogs",
            css:"toolbar_round_btn",
            width:32,
            tooltip:LangHelper.GetString(_this.Id, "Services"),
            disabled:true,
            click:function ()
            {
                var data = _this.GetTableSelectedData();
                if(data)
                {
                    _this.ShowSubscriberEditForm(
                        data,
                        this.getNode(),
                        "bottom",
                        true,
                        false,
                        {
                            profile: {
                                show: true,
                                services: true
                            }
                        }
                    );
                }
            }
        })
    }

    if(!_this.servicesOnly)
    {
        arr.push({
            view: "button",
            id:_this.id+"tariffBtn",
            type: "icon",
            icon: "dollar",
            css:"toolbar_round_btn",
            width:32,
            tooltip:LangHelper.GetString(_this.Id, "Tariffs"),
            disabled:true,
            click:function ()
            {
                var data = _this.GetTableSelectedData();
                if(data)
                {
                    //_this.ShowSubscriberEditForm(Array.isArray(data)?data[0]:data,this.getNode(),"bottom",false,true);
                    _this.ShowSubscriberEditForm(
                        data,this.getNode(),
                        "bottom",
                        false,
                        true,
                        {
                            profile: {
                                show: true,
                                tariffs: true
                            }
                        }
                    );
                }
            }
        });
    }

    if(!_this.tariffOnly && !_this.servicesOnly)
    {
        arr.push({
            view: "button",
            id:_this.id+"AuthStatusBtn",
            type: "icon",
            icon: "user-alt",
            css:"toolbar_round_btn",
            width:32,
            tooltip:LangHelper.GetString(_this.Id, "Auth status"),
            popup:{
                id: _this.id+ "AuthStatusBtn" + "SelectPopup",
                view:"submenu",
                width:240,
                data:[
                    {
                        id: _this.id+ "AuthStatusBtn" + "SelectPopup" + "Selected",
                        value: LangHelper.GetString("Subscribers", "Set for selected"),
                        callback: function(node)
                        {
                            _this.ShowSubscriberAuthEditFormIfNeed(node);

                        }
                    },
                    {
                        id: _this.id+ "AuthStatusBtn" + "SelectPopup" + "All",
                        value: LangHelper.GetString("Subscribers", "Set for all"),
                        callback: function(node)
                        {
                            _this.ShowSubscriberEditForm(null,node,"bottom",false,false, {
                                profile: {
                                    show: false
                                },
                                ping: false,
                                auth: true,
                                props: false
                            }, true);
                        }
                    }
                ],
                template:"#value#",
                autoheight:true,
                select:false,
                on:
                    {
                        onMenuItemClick: function (id)
                        {
                            var item = this.getItem(id);
                            if(item && item.callback)
                            {
                                var node = this.getNode();
                                setTimeout(function(){item.callback(node);}, 10);

                            }
                            // if(Params)
                            // {
                            //     if(Params.callback)
                            //         Params.callback(id);
                            // }
                            //
                            // $$(_this.Id + "ReadPopup").hide();
                        }
                    }
            }
            // disabled:true,
            // click:function ()
            // {
            //     var data = _this.GetTableSelectedData();
            //     // if(data)
            //     // {
            //         //_this.ShowSubscriberEditForm(Array.isArray(data)?data[0]:data,this.getNode(),"bottom",false,true);

            //     // }
            // }
        });

        // arr.push({
        //     view: "button",
        //     id:_this.id+"AuthPropsBtn",
        //     type: "icon",
        //     icon: "list-alt",
        //     css:"toolbar_round_btn",
        //     width:32,
        //     tooltip:LangHelper.GetString("Subscribers", "L2-props"),
        //     disabled:true,
        //     click:function ()
        //     {
        //         var data = _this.GetTableSelectedData();
        //         if(data)
        //         {
        //             _this.ShowSubscriberEditForm(data,this.getNode(),"bottom",false,false, {
        //                 profile: {
        //                     show: false
        //                 },
        //                 ping: false,
        //                 auth: false,
        //                 props: true
        //             });
        //         }
        //     }
        // });
    }

    arr.push({
        view: "button",
        id:_this.id+"deleteBtn",
        type: "icon",
        icon: "trash",
        css:"toolbar_round_btn",
        width:32,
        tooltip:LangHelper.GetString(_this.Id, "Delete"),
        disabled:true,
        click:function (id,e,node)
        {
            var __this = this;
            setTimeout(function () {
                var node = __this.getNode(id);
                _this.deleteContext.show(node, {pos:"bottom"});
            }, 10);
        }
    });

    arr.push({});


    arr = arr.concat(this.SyncStatusWidget.ViewConfig);

    arr.push({
        view: "button",
        id:_this.id+"refreshBtn",
        type: "icon",
        icon: "refresh",
        css: "toolbar_round_btn",
        width: 32,
        tooltip: LangHelper.GetString(_this.Id, "Refresh"),
        click: function (id, e, node)
        {
            _this.RefreshAll();
        }
    });

    arr.push({
        view: "tabbar",
        id: this.id + "MultiSubscribersTabbar",
        height: 40,
        gravity:2,
        options: [
            {
                id: "ExtendedSubscribersTab",
                value: "<span class='webix_icon fa-object-ungroup' title='" + LangHelper.GetString("Subscribers","Extended") + "'></span> " + LangHelper.GetString("Subscribers","Extended"),
            },
            {
                id: "GroupSubscribersTab",
                value: "<span class='webix_icon fa-object-group' title='" + LangHelper.GetString("Subscribers","Group") + "'></span> " + LangHelper.GetString("Subscribers","Group"),
            }
        ]
    })

    return arr;

};

SubscribersViewController.prototype.GetServicesProfilesOptions = function(Service)
{
    var _this = this;

    var options = [
        {value:LangHelper.GetString(_this.Id, "No profile"), id: "0", dic_id: "0"}
    ];

    var dicEnum = ServicesDicsEnum[Service];

    if(dicEnum)
    {
        options = options.concat(Helper.DictToArr(App.DicsManager.GetDic(dicEnum)));
        options.forEach(function(Val,i){
            if(Val.value == "noname")
            {
                Val.value = LangHelper.GetString("MiniFirewallService", "noname");
            }
        });
    }
    return options;
};

SubscribersViewController.prototype.UpdateServiceProfilesOptions = function(Service)
{
    var _this = this;

    var columnName = "service_" + Service;
    var column = _this.table.getColumnConfig(columnName);

    if(column && column.attached)
    {
        column.header[1].options = [];
        _this.table.refreshColumns();
        column.header[1].options = _this.GetServicesProfilesOptions(Service);


        var state = _this.table.getState();
        var resultArr = [];
        if(state.filter && state.filter[columnName])
        {
            var arr = state.filter[columnName].split(",");
            arr.forEach(function(Val)
            {

                var index = column.header[1].options.findIndex(function(obj){
                    return obj.id == Val;
                });

                if(index > -1)
                {
                    resultArr.push(Val);
                }
            });

            column.header[1].value = resultArr.join(",");
        }


        _this.table.refreshColumns();
        _this.table.refresh();
    }
};

SubscribersViewController.prototype.SaveSubscribersAuthState = function(State)
{
  var _this = this;

  var subs = [];

  var data = this.GetTableSelectedData();

  if(Array.isArray(data))
  {
      subs = data;
  }
  else{
      subs.push(data);
  }

  this.ViewModel.SetSubscriberAuthState({
      subscribers: subs,
      state: State,
      callback: function(R){
        var processResult = function(D)
        {
            if(D.success)
            {
                var sub = new SubscriberModel(D.data);

                _this.table.updateItem(D.id, sub);

                webix.message(LangHelper.GetString(_this.Id,"Subscriber")+" "+"<strong>"+(sub.login && sub.login != "n/a" ? sub.login : sub.ip)+"</strong> - "+LangHelper.GetString(_this.Id,"Auth state saved"));
            }
            else{
                webix.message({type:"error", text:D.error.msg});
            }
        }

        if(R)
        {
            if(Array.isArray(R))
            {
                R.forEach(function(D){
                    processResult(D);
                });
            }
            else{
                processResult(R);
            }
        }
        _this.onTableRowSelect();
      }
  });
};

SubscribersViewController.prototype.ClearSubscribersAuthState = function(State)
{
    var _this = this;

    var subs = [];

    var data = this.GetTableSelectedData();

    if(Array.isArray(data))
    {
        subs = data;
    }
    else{
        subs.push(data);
    }

    this.ViewModel.ClearSubscriberAuthState({
        subscribers: subs,
        callback: function(R){
            var processResult = function(D)
            {
                if(D.success)
                {
                    var sub = new SubscriberModel(D.data);

                    _this.table.updateItem(D.id, sub);

                    webix.message(LangHelper.GetString(_this.Id,"Subscriber")+" "+"<strong>"+(sub.login && sub.login != "n/a" ? sub.login : sub.ip)+"</strong> - "+LangHelper.GetString(_this.Id,"Auth state cleared"));
                }
                else{
                    webix.message({type:"error", text:D.error.msg});
                }
            }

            if(R)
            {
                if(Array.isArray(R))
                {
                    R.forEach(function(D){
                        processResult(D);
                    });
                }
                else{
                    processResult(R);
                }
            }
            _this.onTableRowSelect();
        }
    });
};

SubscribersViewController.prototype.SaveAllSubscribersAuthState = function(State)
{
    var _this = this;

    this.ViewModel.SetAllSubscribersAuthState({
        state: State,
        callback: function(R){
            var processResult = function(D)
            {
                if(D.success)
                {
                    webix.message(LangHelper.GetString(_this.Id,"Auth state saved"));
                }
                else{
                    webix.message({type:"error", text:D.error.msg});
                }

                _this.Refresh();
            }

            if(R)
            {
                if(Array.isArray(R))
                {
                    R.forEach(function(D){
                        processResult(D);
                    });
                }
                else{
                    processResult(R);
                }
            }
            _this.onTableRowSelect();
        }
    });
};

SubscribersViewController.prototype.ClearAllSubscribersAuthState = function(State)
{
    var _this = this;

    this.ViewModel.ClearAllSubscriberAuthState({
        callback: function(R){
            var processResult = function(D)
            {
                if(D.success)
                {
                    webix.message(LangHelper.GetString(_this.Id,"Auth state cleared"));
                }
                else{
                    webix.message({type:"error", text:D.error.msg});
                }
                _this.Refresh();
            }

            if(R)
            {
                if(Array.isArray(R))
                {
                    R.forEach(function(D){
                        processResult(D);
                    });
                }
                else{
                    processResult(R);
                }
            }
            _this.onTableRowSelect();
        }
    });
};

SubscribersViewController.prototype.SyncAuthProp = function(Params)
{
    var _this = this;

    var subs = [];

    var data = this.GetTableSelectedData();

    if(Array.isArray(data))
    {
        subs = data;
    }
    else{
        subs.push(data);
    }

    this.ViewModel.SyncAuthProp({
        subscribers: subs,
        callback: function(R){
            var processResult = function(D)
            {
                if(D.success)
                {
                    var sub = new SubscriberModel(D.data);

                    _this.table.updateItem(D.id, sub);

                    webix.message(LangHelper.GetString(_this.Id,"Subscriber")+" "+"<strong>"+(sub.login && sub.login != "n/a" ? sub.login : sub.ip)+"</strong> - "+LangHelper.GetString(_this.Id,"L2-props loaded"));
                }
                else{
                    webix.message({type:"error", text:D.error.msg});
                }
            }

            if(R)
            {
                if(Array.isArray(R))
                {
                    R.forEach(function(D){
                        processResult(D);
                    });
                }
                else{
                    processResult(R);
                }
            }
            _this.onTableRowSelect();
        }
    });
};

SubscribersViewController.prototype.DeleteAuthProp = function(Params)
{
    var _this = this;

    var subs = [];

    var data = this.GetTableSelectedData();

    if(Array.isArray(data))
    {
        subs = data;
    }
    else{
        subs.push(data);
    }

    this.ViewModel.DeleteAuthProp({
        subscribers: subs,
        callback: function(R){
            var processResult = function(D)
            {
                if(D.success)
                {
                    var sub = new SubscriberModel(D.data);

                    _this.table.updateItem(D.id, sub);

                    webix.message(LangHelper.GetString(_this.Id,"Subscriber")+" "+"<strong>"+(sub.login && sub.login != "n/a" ? sub.login : sub.ip)+"</strong> - "+LangHelper.GetString(_this.Id,"L2-props deleted"));
                }
                else{
                    webix.message({type:"error", text:D.error.msg});
                }
            }

            if(R)
            {
                if(Array.isArray(R))
                {
                    R.forEach(function(D){
                        processResult(D);
                    });
                }
                else{
                    processResult(R);
                }
            }
            _this.onTableRowSelect();
        }
    });
};

SubscribersViewController.prototype.SetAuthProp = function(Params)
{
    var _this = this;

    var subs = [];

    var data = this.GetTableSelectedData();

    if(Array.isArray(data))
    {
        subs = data;
    }
    else{
        subs.push(data);
    }

    this.ViewModel.SetAuthProp({
        subscribers: subs,
        props: Params.props,
        memory: Params.memory,
        callback: function(R){
            var processResult = function(D)
            {
                if(D.success)
                {
                    var sub = new SubscriberModel(D.data);

                    _this.table.updateItem(D.id, sub);

                    webix.message(LangHelper.GetString(_this.Id,"Subscriber")+" "+"<strong>"+(sub.login && sub.login != "n/a" ? sub.login : sub.ip)+"</strong> - "+LangHelper.GetString(_this.Id,"L2-props saved"));

                    try{
                        var prop = JSON.parse(sub.auth_props);

                        if(prop && prop.error)
                        {
                            webix.message({
                                type: "error",
                                text: LangHelper.GetString(_this.Id,"Subscriber")+" "+"<strong>"+(sub.login && sub.login != "n/a" ? sub.login : sub.ip)+"</strong> - "+ prop.error
                            });
                        }
                    }
                    catch(e)
                    {

                    }
                }
                else{
                    webix.message({type:"error", text:D.error.msg});
                }
            }

            if(R)
            {
                if(Array.isArray(R))
                {
                    R.forEach(function(D){
                        processResult(D);
                    });
                }
                else{
                    processResult(R);
                }
            }
            _this.onTableRowSelect();
        }
    });
};

SubscribersViewController.prototype.ShowSubscriberAuthEditFormIfNeed = function(Node)
{
    var _this = this;

    var data = _this.GetTableSelectedData();
    var show = true;
    if(data)
    {
        if(Array.isArray(data))
        {
            data.forEach(function(D){
                if((!D.ip && !D.login) || (D.bind_type == -1 && !Helper.ValidateIPaddress(D.login)))
                {
                    show = false;
                }
            });
        }
        else{
            if((!data.ip && !data.login) || (data.bind_type == -1 && !Helper.ValidateIPaddress(data.login)))
            {
                show = false;
            }
        }
    }else{
        show = false;
    }

    if(show)
    {
        _this.ShowSubscriberEditForm(null,Node,"bottom",false,false, {
            profile: {
                show: false
            },
            ping: false,
            auth: true,
            props: false
        }, false);
    }
    else{
        $$(_this.id+ "AuthStatusBtn" + "SelectPopup").hide();
    }

};

SubscribersViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

SubscribersViewController.prototype.SetAllPathParam = function()
{
    var tabId = this.Views.SubscrubersVchannelsTabbar.getValue(),
        tab = tabId.replace(this.id,"");

    if(tab)
    {
        this.SetPathParam("sv_tab", tab);
    }

    this.JustNavigate();
};

SubscribersViewController.prototype.GetAllPathParam = function()
{
    var tabId = this.GetPathParam("sv_tab");

    tabId = tabId ? (this.id+tabId) : "";

    this.Views.SubscrubersVchannelsTabbar.setValue(tabId ? tabId : (this.id + "SubscribersTab"));
};

SubscribersViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

SubscribersViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

SubscribersViewController.prototype.RefreshIpMultiSubscribers = function ()
{
    let _this = this;

    let selected = _this.GetTableSelectedData();
    var state = _this.Views.ReportsWidgets[_this.MultiSubscribersWidgetName].Views.Table.getState();

    state.filter.login_equal = selected.login;

    let params = state ? state.filter : null;
    _this.Views.ReportsWidgets[_this.MultiSubscribersWidgetName].RefreshData(0, params);
};

SubscribersViewController.prototype.MultiSubscribersSelectConfigOptions = function (Data) {
    let _this = this;

    let getMultiTabbarValue = App.SessionManager.GetPreference('multiSubscribersTabbar');
    let tabbar = _this.SubscriberEditFormEmbedded.Views.Tabbar;
    let options = tabbar.config.options;

    let multiSub = false;

    if (Data && Array.isArray(Data)){
        Data.forEach(item => {
            if (item.bind_type == "1")
                multiSub = true;
        })
    } else {
        if(Data && Data.bind_type == "1")
            multiSub = true;
    }

    if(multiSub && getMultiTabbarValue.indexOf("GroupSubscribersTab") !== -1){
        this.SubscriberEditFormEmbedded.Views.LoginField.disable();
        this.SubscriberEditFormEmbedded.Views.IpField.hide();
        options.forEach((item) => {
            if(item.id.indexOf("Profile") === -1)
                tabbar.hideOption(item.id);
        })
    } else {
        this.SubscriberEditFormEmbedded.Views.LoginField.enable();
        this.SubscriberEditFormEmbedded.Views.IpField.show();
        options.forEach((item) => {
            if(item.id.indexOf("Profile") === -1)
                this.SubscriberEditFormEmbedded.Views.Tabbar.showOption(item.id);
        })
    }
    tabbar.refresh();
};


function VchannelEditFormDisplayConfig(Params)
{
    "use strict"

    this.ShowVchannel = Params && Params.ShowVchannel ? Params.ShowVchannel : false;
    this.ShowServices = Params && Params.ShowServices ? Params.ShowServices : false;
    this.ShowTariffs = Params && Params.ShowTariffs ? Params.ShowTariffs : false;
    this.vchannel_number = Params && Params.vchannel_number ? Params.vchannel_number: "";
    this.vchannel_name = Params && Params.vchannel_name ? Params.vchannel_name: "";
};

function VchannelEditFormViewController(Params)
{
    "use strict"

    this.Id = "VchannelEditForm";
    this.localeId = "Vchannels";

    this.Data = null;

    this.Rows = null;

    this.FormEmbedded = Params.FormEmbedded;

    this.DisplayConfig = new VchannelEditFormDisplayConfig(null);

    this.ShowServicesItems = true;
    this.ShowTariffItems = true;
    this.ShowAsModalForm = true;

    this.ViewConfig = null;

    this.ContextConfig = {
        view: "popup",
        maxWidth: 720,
        maxHeight: 720,
        id: this.Id + "Context",
        modal: true,
        body: {
            borderless:true,
            rows:[]
        }
    };
    this.Context = null;

    this.Views = {
        Self: null,
        vchannelNumber: null,
        vchannelName: null,
        ServicesTable: null,
        PolicingField: null,
        VchannelFormPolicing: null,
    };

    this.SaveDataSinal = new Rx.BehaviorSubject(null);
    this.OnHide = new Rx.BehaviorSubject(null);

    this.OverlayVisible = false;

    this.Subscriptions = {};

    this.Init(Params);

    return this;
}

VchannelEditFormViewController.prototype.Init = function (Params)
{
    "use strict"

    this.ViewConfig = {};

    this.Data = Params.data;

    if (Params && Params.displayConfig)
        this.DisplayConfig = Params.displayConfig;

    if (Params.embedded && !this.FormEmbedded)
        this.ShowAsModalForm = false;
    else if (this.FormEmbedded)
        this.ShowAsModalForm = true;

    this.Id += this.ShowAsModalForm ? "" : "Embedded";

    this.ConfigRows();

    if (this.ShowAsModalForm)
    {
        this.ContextConfig.body.rows = this.Rows;
        this.Context = webix.ui(this.ContextConfig);
    }
    else
    {
        this.ViewConfig = {
            id: this.Id,
            width: 630,
            rows: this.Rows
        };
    }
};

VchannelEditFormViewController.prototype.ViewDidLoad = function (Params)
{
    "use strict"

    this.BindAll(Params);

    if (this.Data) this.SetData(this.Data);
};

VchannelEditFormViewController.prototype.BindAll = function (Params)
{
    "use strict"

    var _this = this;

    this.Views.Self = $$(this.Id);
    this.Views.vchannelForm = $$(this.Id + "_vchannel_form");
    this.Views.vchannelFormTitle = $$(this.Id + "_vchannel_form_title");
    this.Views.vchannelNumber = $$(this.Id + "_NumberField");
    this.Views.vchannelName = $$(this.Id + "_NameField");
    this.Views.ServicesTable = $$(this.Id + "ServicesTable");
    this.Views.PolicingField = $$(this.Id + "PolicingField");
    this.Views.VchannelFormPolicing = $$(this.Id + "_tariff_form");

    if (!this.ShowAsModalForm)
    {
        webix.extend(this.Views.Self, webix.OverlayBox);
        this.Views.Self.showOverlay();
        this.OverlayVisible = true;
    }

    if (this.Context)
        this.Context.attachEvent("onHide", function() { _this.Destroy(); });

    if (this.Views.ServicesTable)
    {
        this.Views.ServicesTable.attachEvent("onCheck", function(id, column, state)
        {
            if (column == "enabled")
            {
                if (!state)
                {
                    var data = _this.Views.ServicesTable.getItem(id);
                    data.profile = 0;

                    _this.Views.ServicesTable.updateItem(id, data);
                }
            }
        });
    }
};

VchannelEditFormViewController.prototype.Destroy = function ()
{
    "use strict"

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

VchannelEditFormViewController.prototype.Show = function(Node, Pos)
{
    "use strict"

    this.Context.show(Node, {pos:Pos});
};

VchannelEditFormViewController.prototype.Hide = function()
{
    "use strict"

    if (this.ShowAsModalForm) this.Context.hide();

    this.OnHide.next(true);
};

VchannelEditFormViewController.prototype.SetData = function (data)
{
    "use strict"

    this.Data = data;

    if (this.Data)
    {
        if (this.Views.vchannelNumber && this.Views.vchannelName)
        {
            this.Views.vchannelNumber.setValue(data.vchannel_number);
            this.Views.vchannelName.setValue(data.vchannel_name);
        }

        if (this.ShowServicesItems && this.Views.ServicesTable)
        {
            this.Views.ServicesTable.parse(this.GetServicesData());
            this.Views.ServicesTable.refresh();
        }

        if (this.ShowTariffItems && $$(this.Id+"_tariff_form"))
            $$(this.Id+"_tariff_form").setValues(data);
    }

    if (!this.ShowAsModalForm && this.Data)
    {
        this.Views.Self.hideOverlay();
        this.OverlayVisible = false;
    }

    if (!this.ShowAsModalForm && !this.Data)
    {
        if (!this.OverlayVisible)
            this.Views.Self.showOverlay();

        this.OverlayVisible = true;
    }

    if (this.Data &&
        Array.isArray(this.Data) &&
        !this.ShowAsModalForm)
    {
        this.Views.vchannelFormTitle.hide();
        this.Views.vchannelForm.hide();
    }
    else if (this.Data &&
        !Array.isArray(this.Data) &&
        !this.ShowAsModalForm)
    {
        this.Views.vchannelFormTitle.show();
        this.Views.vchannelForm.show();
    }

    this.UpdatePolicings();
};

VchannelEditFormViewController.prototype.GetVchannelForm = function ()
{
    "use strict"

    return [
        BlockHeaderTemplate({title:LangHelper.GetString("Vchannels", "Params"), icon:"cogs", id:this.Id+"_vchannel_form_title"}),
        {
            id: this.Id+"_vchannel_form",
            view: "form",
            elements: [
                {
                    view: "text",
                    id: this.Id+"_NumberField",
                    name: "number",
                    placeholder: LangHelper.GetString("Vchannels", "Vchannel number"),
                    tooltip: LangHelper.GetString("Vchannels", "Vchannel number"),
                    label: LangHelper.GetString("Vchannels", "Vchannel number"),
                    labelWidth: 136,
                    invalidMessage: LangHelper.GetString("Vchannels", "Vchannel number"),
                    disabled: true
                },
                {
                    view: "text",
                    id: this.Id+"_NameField",
                    name: "name",
                    placeholder: LangHelper.GetString("Vchannels", "Vchannel name"),
                    tooltip: LangHelper.GetString("Vchannels", "Vchannel name"),
                    label: LangHelper.GetString("Vchannels", "Vchannel name"),
                    labelWidth: 136,
                    invalidMessage: LangHelper.GetString("Vchannel", "Enter Vchannel name"),
                    disabled: true
                }
            ]
        }
    ];
}

VchannelEditFormViewController.prototype.GetServicesForm = function ()
{
    "use strict"

    var _this = this;

    return [
        BlockHeaderTemplate({title:LangHelper.GetString("Vchannels", "Services"), icon:"cogs", borderless: false}),
        {
            view: "datatable",
            id: this.Id+"ServicesTable",
            checkboxRefresh: true,
            select: "row",
            on: {
                onItemClick: function(Id)
                {
                    if (Id.column == "profile")
                    {
                        var node = this.getItemNode(Id);
                        var data = this.getItem(Id);
                        _this.EditServiceProfile({
                            node: node,
                            data: data
                        });
                    }
                    else return false;
                }
            },
            columns: [
                {
                    id: "id",
                    header: LangHelper.GetString(this.localeId, "Id"),
                    width: 32
                },
                {
                    id: "value",
                    header: LangHelper.GetString(this.localeId, "Service"),
                    fillspace: true
                },
                {
                    id: "enabled",
                    header: LangHelper.GetString(this.localeId, "Enabled"),
                    template: function(obj, common, value){
                        if (value == 1)
                            return "<div class='webix_table_checkbox checked'><span class=\"webix_icon fa-check-square\"></span> " + LangHelper.GetString("All", "Yes") + "</div>";
                        else
                            return "<div class='webix_table_checkbox notchecked'><span class=\"webix_icon fa-square\"></span> " + LangHelper.GetString("All", "No") + "</div>";
                    },
                    width: 120,
                    headermenu: false

                },
                {
                    id: "profile",
                    width: 200,
                    header: LangHelper.GetString(this.localeId, "Profile"),
                    template: _this.GetServiceTemplate
                }
            ],
            data: this.GetServicesData()
        }
    ]
};

VchannelEditFormViewController.prototype.GetServicesData = function ()
{
    "use strict"

    var data = [];

    var enabledServices = [];
    var servicesProfiles = new VchannelsServiceProfileModel();

    if (this.Data &&
        !Array.isArray(this.Data) &&
        this.Data.services)
    {
        enabledServices = this.Data.services.split(",");
        enabledServices.forEach(function (Val, Index)
        {
            enabledServices[Index] = parseInt(Val,10);
        });
    }

    if (this.Data && this.Data.services_profiles)
        servicesProfiles = new VchannelsServiceProfileModel(JSON.parse(this.Data.services_profiles));


    if (this.Data && Array.isArray(this.Data))
    {
        var crossServices = {};

        this.Data.forEach(function (Data)
        {
            var services = Data.services.split(",");

            services.forEach(function (Val, Index)
            {
                if (Val)
                {
                    if (crossServices[parseInt(Val,10)])
                        crossServices[parseInt(Val,10)] += 1;
                    else
                        crossServices[parseInt(Val,10)] = 1;
                }
            });

            if (Data.services_profiles)
            {
                var sp = new SubscriberServiceProfileModel(JSON.parse(Data.services_profiles));
                for (var i in sp)
                {
                    if (servicesProfiles[i] === 0)
                        servicesProfiles[i] = sp[i];
                    else if (servicesProfiles[i] !== null && servicesProfiles[i] !== sp[i])
                        servicesProfiles[i] = null;
                    else
                        break;
                }
            }
        });

        var count = this.Data.length;

        Object.keys(crossServices).forEach(function (Key)
        {
            if (crossServices[Key] == count)
                enabledServices.push(parseInt(Key,10));
        });
    }

    var row = function (Params)
    {
        this.id = Params&&Params.id?Params.id:0;
        this.value = Params&&Params.value?Params.value:'';
        this.enabled = Params&&Params.enabled?Params.enabled:0;
        this.profile = Params&&Params.profile?Params.profile:'';
    };

    Helper.SortArrayObjByOrderFieldAsc(Helper.DictToArr(ServicesDic)).forEach(function (Service)
    {
        if(Service.id == 4 || Service.id == 5 || Service.id == 18 || Service.id == 49 || Service.id == 19)
        {
            var obj = new row(Service);
            if (enabledServices.indexOf(obj.id) >= 0)
                obj.enabled = 1;
            if (servicesProfiles && Object.keys(servicesProfiles).length && servicesProfiles[Service.id])
                obj.profile = servicesProfiles[Service.id];

            data.push(obj);
        }
    });

    return data;
};

VchannelEditFormViewController.prototype.EditServiceProfile = function(Params)
{
    "use strict"

    var _this = this;

    if (Params && Params.data)
        if (!ServicesDicsEnum[Params.data.id]) return;

    var editor = new SubscribersServiceProfilesEditorViewController({data: Params.data});
    editor.ViewDidLoad();

    editor.Show(Params.node, "bottom");

    this.Subscriptions.ServiceProfileUpdated = editor.SaveDataSinal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            if (_this.Views.ServicesTable)
                _this.Views.ServicesTable.updateItem(DataToSave.id, DataToSave);
        }
    });
};

VchannelEditFormViewController.prototype.GetServiceTemplate = function(Obj)
{
    "use strict"

    var value = "";

    var dicEnum = ServicesDicsEnum[Obj.id];

    if (dicEnum)
    {
        var dic = App.DicsManager.GetDic(dicEnum);

        if (dic && Obj.profile)
        {
            value += dic[Obj.profile] && dic[Obj.profile].value ? dic[Obj.profile].value  : "";

            if (dic[Obj.profile] && dic[Obj.profile].status == 0)
                value += " <span style='color: red;'>("+ LangHelper.GetString("Vchannels", "Disabled") +")</span>";
        }


        value += "<span style=\"height:24px;padding-top:12px;\" class=\"webix_input_icon fa-angle-down\"></span>";
    }

    return "<div class='set-service-profile'>" + value + "</div>";
};

VchannelEditFormViewController.prototype.GetTariffForm = function ()
{
    "use strict"

    var _this = this;
    return [
        BlockHeaderTemplate({title:LangHelper.GetString(this.localeId, "Tariff"), icon:"dollar", borderless: false}),
        {
            id: this.Id+"_tariff_form",
            view: "form",
            elements: [
                {
                    id: _this.Id + "PolicingField",
                    view: "combo",
                    name: "policing",
                    label: LangHelper.GetString(this.localeId, "Tariff"),
                    options: []
                }
            ]
        },
    ]
};

VchannelEditFormViewController.prototype.UpdatePolicings = function()
{
    "use strict"

    var _this = this;

    if (_this.Views.VchannelFormPolicing)
    {
        _this.Views.VchannelFormPolicing.elements.policing.getList().clearAll();

        var arr = [{"id": "0", "value":""}];

        Helper.DictToArr(App.DicsManager.GetDic(DicsEnum.PolicingProfilesDic)).forEach(function (val) {
            var model = webix.copy(val);

            if (model.status == 0)
                model.value += " <span style='color: red;'>("+ LangHelper.GetString(_this.localeId, "Disabled") +")</span>";

            arr.push(model);
        });

        // arr = arr.concat(Helper.DictToArr(App.DicsManager.GetDic(DicsEnum.PolicingProfilesDic)));

        if (_this.Data && _this.Data.policing)
        {
            var index = arr.findIndex(function(obj)
            {
                return obj == _this.Data.policing;
            });

            if (index === -1)
            {
                arr.splice(1,0, {
                    "id": _this.Data.policing,
                    "dic_id": _this.Data.policing,
                    "value": LangHelper.GetString("Dics", "Personal tariff")
                });
            }
        }

        _this.Views.VchannelFormPolicing.elements.policing.getList().parse(arr);
    }
};

VchannelEditFormViewController.prototype.GetFormBtns = function ()
{
    "use strict"

    var _this = this;

    var form = [
        {
            id: this.Id+"_btns_form",
            view: "form",
            borderless: false,
            elements: [
                {
                    cols: [
                        {gravity:2}
                    ]
                }
            ]
        }
    ];

    if (this.ShowAsModalForm)
    {
        form[0].elements[0].cols.push({
            view: "button",
            label: LangHelper.GetString("All", "Close"),
            click: function () { _this.Hide(); }});
    }

    form[0].elements[0].cols.push({
        view: "button",
        type: "form",
        label: LangHelper.GetString("All", "Save"),
        click: function () { _this.Save(); }});

    return form;
};

VchannelEditFormViewController.prototype.Save = function()
{
    "use strict"

    if (this.Data && !Array.isArray(this.Data))
    {
        if (!this.Validate()) return;

        if (!this.Data.oldVchannel)
            this.Data.oldVchannel = new VchannelModel(this.Data);

        this.Data.policing = this.Views.PolicingField ? this.Views.PolicingField.getValue() : "";

        var services = this.GetServicesSerializedData();

        if (services !== null)
        {
            this.Data.services = services.services;
            this.Data.services_profiles = JSON.stringify(services.services_profiles);
        }
        this.SaveDataSinal.next(this.Data);
    }

    if (this.Data && Array.isArray(this.Data))
    {
        var services = this.GetServicesSerializedData();

        var policing = this.GetSelectedPolicing();

        this.Data.forEach(function (Vchannel)
        {
            if (!Vchannel.oldVchannel)
                Vchannel.oldVchannel = new VchannelModel(Vchannel);

            if (services !== null)
            {
                Vchannel.services = services.services;
                Vchannel.services_profiles = JSON.stringify(services.services_profiles);
            }

            if (policing !== null)
            {
                Vchannel.policing = policing;
            }
        });

        this.SaveDataSinal.next(this.Data);
    }

    this.Hide();
};

VchannelEditFormViewController.prototype.Validate = function()
{
    "use strict"

    var valid = true;

    if (this.Views.vchannelNumber)
    {
        if (!this.Views.vchannelNumber.validate())
            valid = false;
    }

    if (this.Views.vchannelName)
    {
        if (!this.Views.vchannelName.validate())
            valid = false;
    }

    return valid;
};

VchannelEditFormViewController.prototype.GetServicesSerializedData = function ()
{
    "use strict"

    if (this.Views && this.Views.ServicesTable)
    {
        var data = this.Views.ServicesTable.serialize();
        var result = {
            services: "",
            services_profiles: {}
        };

        data.forEach(function (Service)
        {
            if (Service.enabled)
            {
                result.services += ""+Service.id+",";

                if (Service.profile && Service.profile !== "0")
                    result.services_profiles[Service.id] = Service.profile;
            }
        });
        return result;
    }
    return null;
};

VchannelEditFormViewController.prototype.GetSelectedPolicing = function()
{
    "use strict"

    if (this.Views &&
        this.Views.VchannelFormPolicing &&
        this.Views.PolicingField)
        return this.Views.PolicingField.getValue();

    return null;
};

VchannelEditFormViewController.prototype.ConfigRows = function ()
{
    "use strict"

    var vConfig = [];

    if (this.DisplayConfig.ShowVchannel)
        vConfig = vConfig.concat(this.GetVchannelForm());

    if (this.DisplayConfig.ShowServices)
        vConfig = vConfig.concat(this.GetServicesForm());

    if (this.DisplayConfig.ShowTariffs)
        vConfig = vConfig.concat(this.GetTariffForm());

    vConfig = vConfig.concat(this.GetFormBtns());

    this.Rows = vConfig;
}
/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */
/* global SubscribersComponentsTypeDic */
/* global HardwareSubscribersManager */

function VchannelsViewController(Params)
{
    "use strict"

    var _this = this;

    this.ViewModel = new VchannelsManager();

    this.AdvcManager = new AdvcManager();

    this.tariffOnly = Params && Params.tariffOnly? true : false;
    this.servicesOnly = Params && Params.servicesOnly? Params.servicesOnly : false;
    this.services = Params && Params.services ? Params.services : null;

    this.embedded = Params.embedded?true:false;
    this.VchannelEditFormEmbedded = new VchannelEditFormViewController({
        embedded:true,
        FormEmbedded: this.embedded,
        displayConfig: new VchannelEditFormDisplayConfig({
            ShowVchannel: true,
            ShowServices: true,
            ShowTariffs: true
        })
    });

    this.localeId = "Vchannels";
    this.id = "Vchannels"+(this.embedded?"Embedded":"");
    this.Id = this.id;
    this.id += Params && Params.Id ? Params.Id : "";

    this.tableId = this.id+"Table";
    this.table = null;
    this.paging = null;

    this.vchannelsTableNumberColTemplate = {
            id: "vchannel_number",
            header: [LangHelper.GetString(this.localeId, "Vchannel number"),
                {
                    content: "textFilter",
                    placeholder: "&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
            fillspace: 0.4,
            sort: "string",
            editor: "text"
        };
    this.vchannelsTableNameColTemplate = {
            id: "vchannel_name",
            header: [LangHelper.GetString(this.localeId, "Vchannel name"),
                {
                    content: "textFilter",
                    placeholder: "&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
            fillspace: 0.5,
            sort: "string",
            editor: "text"
        };
    this.vchannelsTableServicesColTemplate = {
            id: "services",
            header: [LangHelper.GetString(this.localeId, "Services"), {
                content: "multiComboFilter",
                options: _this.GetServicesOptions(),
                inputConfig: {
                    suggest: {
                        fitMaster: false,
                        width: 300
                    },
                    tagTemplate: function (values)
                    {
                        const local = Helper.GetElementPluralForm(values.length);
                        return `${values.length} ${local}`;
                    }
                },
                compare: function (value, filter)
                {
                    var res = true;
                    var valueStr = "";

                    if (value) valueStr = value;

                    if (filter)
                    {
                        Object.keys(filter).forEach(function (key) {
                            if (filter[key] && valueStr.indexOf(key) === -1)
                            {
                                res = false;
                                return false;
                            }
                        });
                    }
                    return res;
                }
            }],
            fillspace: true,
            sort: "string",
            template: function (obj)
            {
                var services = [];
                var services_str = '';
                services =  obj.services.split(",");

                if (services) {
                    services.forEach(function (service) {
                        if (service&&ServicesDic[service])
                            services_str += '<span class="service ' + ServicesDic[service].code + '" title="'+ServicesDic[service].value+'"><span class="fa fa-square"></span><span class="title">' + Helper.GetInitials(ServicesDic[service].value) + '</span></span>';
                    });
                }
                services_str = '<div class="cell services">' + services_str + '</div>';

                return services_str;
            }
    };
    this.vchannelsTableTariffColTemplate = {
        id: "policings",
        header: [LangHelper.GetString(this.localeId, "Tariffs"), {
            content: "multiComboFilter",
            options: _this.GetPolicingsProfiles(),
            inputConfig: {
                suggest: {
                    fitMaster: false,
                    width: 300
                },
                tagTemplate: function (values)
                {
                    const local = Helper.GetElementPluralForm(values.length);
                    return `${values.length} ${local}`;
                }
            }
        }],
        fillspace: true,
        sort: "string",
        template:function(obj)
        {
            if (!obj.policing || obj.policing == "0") return "";

            var dic = App.DicsManager.GetDic(DicsEnum.PolicingProfilesDic);

            if (!dic || dic.length == 0)
                return LangHelper.GetString("Dics","Personal tariff");

            return dic[obj.policing] && dic[obj.policing].value ? dic[obj.policing].value : LangHelper.GetString("Dics","Personal tariff");
        }
    };
    this.deleteContext = webix.ui({
        view: "popup",
        width: 300,
        height: 180,
        body:{
            view: "form",
            borderless: true,
            elements:[
                {
                    template: LangHelper.GetString(this.localeId, "Are you sure you want to delete services and tariffs in the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view: "button",
                            label: LangHelper.GetString(this.localeId, "Cancel"),
                            click: function () { _this.deleteContext.hide(); }
                        },
                        {
                            view: "button",
                            type: "form",
                            label: LangHelper.GetString(this.localeId, "Delete"),
                            click: function ()
                            {
                                _this.deleteContext.hide();
                                _this.DeleteTableSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.SyncStatusWidget = new SubscriberSyncStatusWidget({localeId: this.localeId});

    this.vchannelsTableTemplate = {
            rows: [
                {
                    view: "toolbar",
                    elements: _this.GetToolbarButtons()
                },
                BlockHeaderTemplate({title:LangHelper.GetString(this.localeId, "List of vchannels"), icon:"cogs"}),
                {
                    view: "datatable",
                    id: this.tableId,
                    resizeColumn: true,
                    select: "row",
                    multiselect: true,
                    editaction: "custom",
                    tooltip: true,
                    scroll: "y",
                    headermenu: {
                        width: 350,
                        autoheight: true,
                        scroll: false
                    },
                    on: {
                        onItemClick: function (id,e,node)
                        {
                            var rowData = this.getItem(id);

                            _this.VchannelEditFormEmbedded.Data.vchannel_number =
                                rowData.vchannel_number ? rowData.vchannel_number : "";
                            _this.VchannelEditFormEmbedded.Data.vchannel_name =
                                rowData.vchannel_name ? rowData.vchannel_name : "";

                            if (id.column === 'edit')
                            {
                                _this.ShowVchannelEditForm(
                                    rowData,
                                    this.getItemNode(id),
                                    "right",
                                    false,
                                    false,
                                    new VchannelEditFormDisplayConfig({
                                        vchannel_number: rowData.vchannel_number,
                                        vchannel_name: rowData.vchannel_name,
                                        ShowVchannel: true,
                                        ShowServices: true,
                                        ShowTariffs: true,
                                    }));
                            }
                            else if (id.column === 'trash')
                            {
                                var __this = this;

                                var data = _this.table.getItem(id);

                                if (!data.vchannel_name && !data.vchannel_number)
                                {
                                    _this.DeleteTableSelectedRows();
                                    return;
                                }

                                setTimeout(function ()
                                {
                                    var node = __this.getItemNode(id);
                                    _this.deleteContext.show(node, {pos:"bottom"});
                                }, 10);
                            }
                        },
                        onAfterSelect: function(data, preserve)
                        {
                            var item = this.getItem(data.id);
                            if (item)
                            {
                                if (!item.checked) item.checked = 1;

                                _this.table.updateItem(data.id, item);
                            }
                            _this.onTableRowSelect();
                        },
                        onAfterUnSelect: function(data)
                        {
                            var item = this.getItem(data.id);
                            if (item && item.checked)
                            {
                                if (item.checked) item.checked = 0;

                                _this.table.updateItem(data.id, item);
                            }
                            _this.onTableRowUnSelect();
                        },
                        onBeforeFilter: function() { return false; },
                        onAfterFilter: function() { _this.Refresh(); },
                        onBeforeSort: function()
                        {
                            _this.Refresh();
                            return false;
                        },
                        onHeaderClick: function(id, e, target)
                        {
                            if (id.column == "checked")
                            {
                                var cb = _this.table.getHeaderContent("mc");

                                if (cb.isChecked()) _this.table.selectAll();
                                else _this.table.unselectAll();
                            }
                            return false;
                        }
                    },
                    columns: function () {
                        var cols = [];

                        cols.push({
                            id:"checked",
                            header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                            template: CellColoredCheckBoxTemplate,
                            width:32
                        });
                        cols.push({
                            id: "edit",
                            header: "",
                            width: 32,
                            template: "<span class=\"webix_icon fa-pencil-square\" style='cursor: pointer'></span>",
                            headermenu: false
                        });
                        cols.push(_this.vchannelsTableNumberColTemplate);
                        cols.push(_this.vchannelsTableNameColTemplate);

                        if (!_this.tariffOnly &&
                            !_this.servicesOnly &&
                            !_this.embedded)
                        {
                            cols.push(_this.vchannelsTableServicesColTemplate);
                            cols.push(_this.vchannelsTableTariffColTemplate);
                        }
                        else if (_this.tariffOnly)
                            cols.push(_this.vchannelsTableTariffColTemplate);
                        else if (_this.servicesOnly)
                        {
                            cols.push(_this.vchannelsTableServicesColTemplate);

                            if (_this.services)
                            {
                                _this.services.forEach(function(Val)
                                {
                                    cols.push(_this.GetServiceColumnTemplate(Val));
                                });
                            }
                        }
                        cols.push({
                            id: "trash",
                            header: "",
                            width: 32,
                            template: "<span class=\"webix_icon fa-align-slash\" style='cursor: pointer'></span>",
                            headermenu: false,
                            align: "right"
                        });
                        cols.push({header: {content: "headerMenu"}, headermenu: false, width: 32});

                        return cols;
                    }(),
                    data:[],
                    rules:{
                        "valid":function (value) { return value; }
                    }
                },
                {
                    view: "pager",
                    id: this.tableId+"Paging",
                    template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                    master: false,
                    height: 32,
                    on: {
                        onAfterPageChange:function(Page) { _this.Refresh(Page); }
                    }
                }
            ]
        };

    this.mainTemplate = {
        cols: [
            this.vchannelsTableTemplate,
            {view:"resizer"},
            this.VchannelEditFormEmbedded.ViewConfig
        ]
    };
    this.embeddedTemplate = [
        {
            rows: this.vchannelsTableTemplate.rows
        }
    ];

    this.tabelRowsSelectedCount = new Rx.Subject();

    this.btns = {
        servicesBtn: null,
        tariffBtn: null,
        deleteBtn: null,
        refreshBtn: null,
    };

    this.Subscriptions = {};

    this.Init(Params);

    return this;
};

VchannelsViewController.prototype.Init = function (Params)
{
    "use strict";

    if (this.embedded)
        this.view = this.embeddedTemplate;
    else
        this.view = this.mainTemplate;
};

VchannelsViewController.prototype.BindAll = function (Params)
{
    "use strict"

    var _this = this;

    this.table = $$(this.tableId);

    this.paging = $$(this.tableId+"Paging");

    this.btns.servicesBtn = $$(this.id+"servicesBtn");
    this.btns.tariffBtn = $$(this.id+"tariffBtn");
    this.btns.deleteBtn = $$(this.id+"deleteBtn");
    this.btns.refreshBtn = $$(this.id+"refreshBtn");

    this.SyncStatusWidget.BindAll(_this);

    this.tabelRowsSelectedCount.subscribe(function (value) {
        if (value > 1)
        {
            if (_this.btns.servicesBtn)
                _this.btns.servicesBtn.enable();
            if (_this.btns.tariffBtn)
                _this.btns.tariffBtn.enable();

            _this.btns.deleteBtn.enable();
        }
        else
        {
            if (_this.btns.servicesBtn)
                _this.btns.servicesBtn.disable();
            if (_this.btns.tariffBtn)
                _this.btns.tariffBtn.disable();

            _this.btns.deleteBtn.disable();
        }
    });

    this.Subscriptions.VchannelsSignalSubscription = this.ViewModel.VchannelsSignal.subscribe(function (Updated)
    {
        if (Updated) _this.Update();
    });

    this.Subscriptions.HardwareConnected = App.SessionManager.CurrentHardwareId.subscribe(function (CurrentHardwareId)
    {
        if (CurrentHardwareId) _this.RefreshAll();
    });

    this.Subscriptions.SyncStatusSuccess = this.SyncStatusWidget.Signals.SyncSubscribersSuccess.subscribe(function(Val){
        if(Val)
        {
            _this.Refresh();
        }
    });

    this.Subscriptions.VchannelEditFormEmbeddedSaveDataSignal = this.VchannelEditFormEmbedded.SaveDataSinal.subscribe(function (DataToSave)
    {
        if (DataToSave) _this.SaveVchannels(DataToSave);
    });

    this.Subscriptions.PolicingProfilesDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.PolicingProfilesDic].subscribe(function(Val)
    {
        if (Val)
        {
            var profiles = _this.GetPolicingsProfiles();

            if(_this.table)
            {
                var column = _this.table.getColumnConfig(_this.vchannelsTableTariffColTemplate.id);

                if(column)
                {
                    column.header[1].options = [];
                    _this.table.refreshColumns();
                    column.header[1].options = profiles;

                    var state = _this.table.getState();
                    var resultArr = [];
                    if(state.filter && state.filter.policing)
                    {
                        var arr = state.filter.policing.split(",");
                        arr.forEach(function(Val)
                        {

                            var index = column.header[1].options.findIndex(function(obj){
                                return obj.id == Val;
                            });

                            if(index > -1)
                            {
                                resultArr.push(Val);
                            }
                        });

                        column.header[1].value = resultArr.join(",");
                    }


                    _this.table.refreshColumns();
                    _this.table.refresh();

                }
            }

            _this.UpdatePolicingProfiles(profiles);
        }

    });

    this.Subscriptions.BlackProfilesDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.BlackListsProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(4);
        }

    });

    this.Subscriptions.WhiteProfilesDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.WhiteListsProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(5);
        }

    });

    this.Subscriptions.DDOSProtectionDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.DDOSProtectionProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(10);
        }
    });

    this.Subscriptions.SessionPolicingDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.SessionPolicingProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(18);
        }
    });

    this.Subscriptions.CgNatDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.CgNatProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(11);
        }
    });

    this.Subscriptions.MiniFirewallDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.MiniFireWallProfilesDic].subscribe(function(Val)
    {
        if(Val && _this.table)
        {
            _this.UpdateServiceProfilesOptions(13);
        }
    });

    this.table.attachEvent("onCheck", function(id, column, state)
    {
        if (column == "checked")
        {
            if (state)
                _this.table.select(id, true);
            else
                _this.table.unselect(id, true);
        }
    });
};

VchannelsViewController.prototype.Refresh = function(Page)
{
    "use strict"

    var _this = this;

    var state = this.table.getState();

    this.ViewModel.RefreshVchannels({
        page: Page,
        filter: state ? state.filter : null,
        sort: state ? state.sort : null,
        callback: function () {}});
};

VchannelsViewController.prototype.RefreshAll = function(Page)
{
    "use strict"

    this.Refresh(Page);
};

VchannelsViewController.prototype.Update = function()
{
    "use strict"

    if (!this.table.$destructed)
    {
        this.table.clearAll();
        this.table.parse(this.ViewModel.GetVchannels());
        this.table.refresh();

        this.paging.define(this.ViewModel.Total);
        this.paging.refresh();
    }
};

VchannelsViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.SyncStatusWidget.Destroy();

    if (!this.embedded)
        this.VchannelEditFormEmbedded.Destroy();
};

VchannelsViewController.prototype.ViewDidLoad = function (Params)
{
    "use strict";

    var _this = this;

    if (!this.embedded)
        this.VchannelEditFormEmbedded.ViewDidLoad();

    this.BindAll(Params);
};

VchannelsViewController.prototype.GetServicesOptions = function()
{
    "use strict"

    var _this = this;

    var options = [
        {value:LangHelper.GetString(_this.localeId, "No services"), id: "is_null", dic_id: "is_null"}
    ];

    options = options.concat(Helper.DictToArr(ServicesDic));

    return options;
};

VchannelsViewController.prototype.GetPolicingsProfiles = function()
{
    "use strict"

    var _this = this;

    var options = [
        {value:LangHelper.GetString(_this.localeId, "No tariff"), id: "0", dic_id: "0"}
    ];

    options = options.concat(Helper.DictToArr(App.DicsManager.GetDic(DicsEnum.PolicingProfilesDic)));

    return options;
};

VchannelsViewController.prototype.GetToolbarButtons = function()
{
    "use strict"

    var _this = this;

    var arr = [];

    if (!_this.tariffOnly)
    {
        arr.push({
            view: "button",
            id :_this.id+"servicesBtn",
            type: "icon",
            icon: "cogs",
            css: "toolbar_round_btn",
            width: 32,
            tooltip: LangHelper.GetString(_this.localeId, "Services"),
            disabled: true,
            click: function ()
            {
                var data = _this.GetTableSelectedData();
                if (data)
                {
                    _this.ShowVchannelEditForm(
                        data,
                        this.getNode(),
                        "bottom",
                        true,
                        false,
                        { ShowServices: true }
                    );
                }
            },
        })
    }

    if (!_this.servicesOnly)
    {
        arr.push({
            view: "button",
            id: _this.id+"tariffBtn",
            type: "icon",
            icon: "dollar",
            css: "toolbar_round_btn",
            width: 32,
            tooltip: LangHelper.GetString(_this.localeId, "Tariffs"),
            disabled: true,
            click: function ()
            {
                var data = _this.GetTableSelectedData();
                if (data)
                {
                    _this.ShowVchannelEditForm(
                        data,this.getNode(),
                        "bottom",
                        false,
                        true,
                        { ShowTariffs: true }
                    );
                }
            }
        });
    }

    arr.push({
        view: "button",
        id: _this.id+"deleteBtn",
        type: "icon",
        icon: "align-slash",
        css: "align-slash",
        width: 32,
        tooltip: LangHelper.GetString(_this.localeId, "Delete"),
        disabled: true,
        click: function (id,e,node)
        {
            var __this = this;
            setTimeout(function () {
                var node = __this.getNode(id);
                _this.deleteContext.show(node, {pos:"bottom"});
            }, 10);
        }
    });
    arr.push({});

    arr = arr.concat(this.SyncStatusWidget.ViewConfig);

    // arr.push({
    //     view: "button",
    //     id: _this.id + "ForceSyncVchannels",
    //     type: "icon",
    //     icon: "cloud-download-alt",
    //     align: "right",
    //     width: 32,
    //     css: "toolbar_round_btn",
    //     tooltip: LangHelper.GetString(_this.localeId,"Forced vchannels synchronization"),
    //     click: function (id, e, node) { _this.ForceSyncVchannels(); }});
    arr.push({
        view: "button",
        id: _this.id+"refreshBtn",
        type: "icon",
        icon: "refresh",
        css: "toolbar_round_btn",
        width: 32,
        tooltip: LangHelper.GetString(_this.localeId, "Refresh"),
        click: function (id, e, node) { _this.RefreshAll(); }});

    return arr;
};

VchannelsViewController.prototype.ShowVchannelEditForm = function (Data, Node, Pos, ServicesOnly, TariffOnly, CustomParams, All)
{
    "use strict"

    var _this = this;

    App.NavRouter.PresentModalView({
        id: "VchannelEditForm",
        data: Data,
        servicesOnly: ServicesOnly?true:false,
        tariffOnly: TariffOnly?true:false,
        hideServices: _this.tariffOnly,
        displayConfig: new VchannelEditFormDisplayConfig(CustomParams ? CustomParams : {
            profile: {
                show: true,
                services: !TariffOnly,
                vchannel_name: !(TariffOnly || ServicesOnly),
                tariffs: !ServicesOnly
            }
        },  CustomParams ? false : !(TariffOnly || ServicesOnly))
    });

    App.NavRouter.views.VchannelEditForm.Show(Node,Pos);

    this.Subscriptions.VchannelEditFormSaveDataSignal = App.NavRouter.views.VchannelEditForm.SaveDataSinal.subscribe(function (DataToSave)
    {
        if (DataToSave) _this.SaveVchannels(DataToSave);
    });
};

VchannelsViewController.prototype.UpdatePolicingProfiles = function (ProfileList)
{
    "use strict"

    var _this = this;

    if (_this.table)
    {
        var column = _this.table.getColumnConfig(_this.vchannelsTableTariffColTemplate.id);

        if (column)
        {
            column.header[1].options = [];
            _this.table.refreshColumns();
            column.header[1].options = ProfileList;

            var state = _this.table.getState();

            var resultArr = [];

            if (state.filter && state.filter.policing)
            {
                var arr = state.filter.policing.split(",");

                arr.forEach(function(Val)
                {
                    var index = column.header[1].options.findIndex(function(obj){
                        return obj.id == Val;
                    });

                    if (index > -1) resultArr.push(Val);
                });
                column.header[1].value = resultArr.join(",");
            }
            _this.table.refreshColumns();
            _this.table.refresh();
        }
    }
};

VchannelsViewController.prototype.GetServiceColumnTemplate = function(Service)
{
    "use strict"

    var _this = this;

    return {
        id: "service_" + Service,
        header: [ServicesDic[Service].value, {
            content: "multiComboFilter",
            options: _this.GetServicesProfilesOptions(Service),
            inputConfig: {
                suggest: {
                    fitMaster: false,
                    width: 300
                },
                tagTemplate: function (values)
                {
                    const local = Helper.GetElementPluralForm(values.length);
                    return `${values.length} ${local}`;
                }
            },
        }],
        fillspace: true,
        sort: false,
        template:function(obj)
        {
            if (!obj.services_profiles) return "";

            var params = JSON.parse(obj.services_profiles);
            if (!params || !Object.keys(params).length) return "";

            var dicEnum = ServicesDicsEnum[Service];
            if (!dicEnum) return "";

            var dic = App.DicsManager.GetDic(dicEnum);
            if (!dic || !dic[params[Service]]) return "";

            return dic[params[Service]] && dic[params[Service]].value ? dic[params[Service]].value : "";
        }
    }
};

VchannelsViewController.prototype.GetServicesProfilesOptions = function(Service)
{
    "use strict"

    var _this = this;

    var options = [
        {value:LangHelper.GetString(_this.localeId, "No profile"), id: "0", dic_id: "0"}
    ];

    var dicEnum = ServicesDicsEnum[Service];

    if (dicEnum)
    {
        options = options.concat(Helper.DictToArr(App.DicsManager.GetDic(dicEnum)));

        options.forEach(function(Val,i){
            if (Val.value == "noname")
                Val.value = LangHelper.GetString("MiniFirewallService", "noname");
        });
    }
    return options;
};

VchannelsViewController.prototype.GetTableSelectedData = function ()
{
    "use strict"

    var selected = this.table.getSelectedItem();
    return selected;
};

VchannelsViewController.prototype.onTableRowSelect = function ()
{
    "use strict"

    var data = this.GetTableSelectedData();
    this.tabelRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);

    this.VchannelEditFormEmbedded.SetData(data);

    if (!this.embedded)
    {
        if (App.NavRouter.views.VchannelEditForm)
            App.NavRouter.views.VchannelEditForm.SetData(data);
    }
};

VchannelsViewController.prototype.onTableRowUnSelect = function ()
{
    "use strict"

    var data = this.GetTableSelectedData();
    this.tabelRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);

    if (!this.embedded)
        this.VchannelEditFormEmbedded.SetData(data);
};

VchannelsViewController.prototype.ForceSyncVchannels = function(Params)
{
    "use strict"

    var _this = this;

    _this.AdvcManager.ForceSyncCompanies({
        callback: function(R)
        {
            if (R.success)
                webix.message(LangHelper.GetString(_this.localeId, "Forced synchronization vchannels running in the background"));
            else
            {
                if (R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

VchannelsViewController.prototype.DeleteTableSelectedRows = function (RowId)
{
    "use strict"

    var _this = this;

    var selectedRows = this.GetTableSelectedData();

    if (!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    var rowsToUnbind = [];
    var rowsToJustDelete = [];

    selectedRows.forEach(function (Row)
    {
        if (Row.vchannel_number)
            rowsToUnbind.push(Row);
        else
            rowsToJustDelete.push(Row);
    });

    // rowsToJustDelete.forEach(function (Row)
    // {
    //     _this.table.remove(Row.id)
    // });

    if (rowsToUnbind.length)
    {
        this.ViewModel.DeleteVchannels({data:rowsToUnbind, callback:function (R)
            {
                var processResult = function (R)
                {
                    var tableRow = _this.table.getItem(R.id);

                    if (R.success)
                    {
                        var success = true;
                        var errMessage = "";

                        if (R.data.unbind)
                        {
                            if (R.data.unbind.success)
                            {
                                if (R.data.unbind.data.fail > 0)
                                    success = false;
                            }
                            else
                            {
                                success = false;
                                errMessage = R.data.unbind.error.msg;
                            }
                        }

                        if (R.data.services)
                        {
                            if (R.data.services.success)
                            {
                                if (R.data.services.data.bind_result)
                                {
                                    var bindResult = R.data.services.data.bind_result;

                                    if (bindResult.fail > 0)
                                        success = false;
                                }

                                if (R.data.services.data.unbind_result)
                                {
                                    var unbindResult = R.data.services.data.unbind_result;

                                    if (unbindResult.fail > 0)
                                        success = false;
                                }
                            }
                            else
                            {
                                success = false;
                                errMessage = R.data.services.error.msg;
                            }
                        }

                        if (success)
                        {
                            webix.message(LangHelper.GetString(_this.localeId,"Deleted"));
                            tableRow.policing = 0;
                            tableRow.services = "";
                            tableRow.services_profiles = "";

                            _this.table.updateItem(tableRow.id, tableRow);

                            // _this.table.remove(R.id);
                        }
                        else
                        {
                            if (errMessage)
                                webix.message({type:"error", text:LangHelper.GetString(_this.localeId,"Error")+". <br/>"+errMessage});
                            else
                                webix.message({type:"error", text:LangHelper.GetString(_this.localeId,"Error")+". <br/> "+LangHelper.GetString(_this.localeId,"See logs")});

                            if (tableRow)
                            {
                                tableRow.valid = false;
                                _this.table.validate(R.id);
                            }

                        }
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});

                        if (tableRow)
                        {
                            tableRow.valid = false;
                            _this.table.validate(R.id);
                        }
                    }
                };

                if (R)
                {
                    if (Array.isArray(R))
                        R.forEach(function (R) { processResult(R); });
                    else
                        processResult(R);
                }

                _this.onTableRowUnSelect();
            }});
    }
};

VchannelsViewController.prototype.SaveVchannels = function (Vchannels)
{
    "use strict"

    var _this = this;

    var vchannelsToSaveObj = {};

    if (Array.isArray(Vchannels))
    {
        Vchannels.forEach(function (Vchannel)
        {
            vchannelsToSaveObj[Vchannel.id] = Vchannel;
        });
    }
    else
        vchannelsToSaveObj[Vchannels.id] = Vchannels;

    var isValid = true;
    var tableRow = {};

    Object.keys(vchannelsToSaveObj).forEach(function (Key)
    {
        var id = vchannelsToSaveObj[Key].id;

        tableRow[Key] = _this.table.getItem(id);
        tableRow[Key].valid = true;

        if (!_this.table.validate(id))
            isValid = false;
    });

    if (isValid)
    {
        var data = [];

        Object.keys(vchannelsToSaveObj).forEach(function (Key)
        {
            data.push({newVchannel:vchannelsToSaveObj[Key], oldVchannel:vchannelsToSaveObj[Key].oldVchannel});
        });

        this.ViewModel.SaveVchannels({data:data, callback:function (R)
            {
                var processResult = function (R)
                {
                    if (R.success)
                    {
                        var success = true;
                        var services = true;
                        var bind = true;
                        var policing = false;

                        var message = LangHelper.GetString(_this.localeId,"Vchannel")+" "+"<strong>"+vchannelsToSaveObj[R.id].vchannel_number+"</strong>";
                        var errMessage = "";

                        if (R.data.bind)
                        {
                            if (R.data.bind.success)
                            {
                                if (R.data.bind.data.bind_result)
                                {
                                    var bindResult = R.data.bind.data.bind_result;

                                    if (bindResult.fail > 0 || bindResult.data.length)
                                    {
                                        success = false;
                                        bind = false;

                                        if (bindResult.data.length)
                                        {
                                            bindResult.data.forEach(function (Line)
                                            {
                                                if (typeof(Line) === "object")
                                                    errMessage += JSON.stringify(Line)+"<br/>";
                                                else
                                                    errMessage += Line+"<br/>";
                                            });
                                        }
                                    }
                                }

                                if (R.data.bind.data.unbind_result)
                                {
                                    var unbindResult = R.data.bind.data.unbind_result;

                                    if (unbindResult.fail > 0 || unbindResult.data.length)
                                    {
                                        success = false;
                                        bind = false;

                                        if (unbindResult.data.length)
                                        {
                                            unbindResult.data.forEach(function (Line)
                                            {
                                                if (typeof(Line) === "object")
                                                    errMessage += JSON.stringify(Line)+"<br/>";
                                                else
                                                    errMessage += Line+"<br/>";
                                            });
                                        }
                                    }
                                }
                            }
                            else
                            {
                                success = false;
                                bind = false;

                                errMessage = R.data.bind.error.msg;
                            }
                        }

                        if (R.data.services)
                        {
                            if (R.data.services.success)
                            {
                                if (R.data.services.data.bind_result)
                                {
                                    var bindResult = R.data.services.data.bind_result;

                                    if (bindResult.fail > 0 || (bindResult.data && bindResult.data.length))
                                    {
                                        success = false;
                                        services = false;

                                        if (bindResult.data.length)
                                        {
                                            bindResult.data.forEach(function (Line)
                                            {
                                                if (typeof(Line) === "object")
                                                    errMessage += JSON.stringify(Line)+"<br/>";
                                                else
                                                    errMessage += Line+"<br/>";
                                            });
                                        }
                                    }
                                }

                                if (R.data.services.data.services_profiles)
                                {
                                    var sp = R.data.services.data.services_profiles;
                                    for (var i in sp)
                                    {
                                        if (sp[i] && sp[i].success)
                                        {
                                            if (sp[i].data)
                                            {
                                                var spdata = sp[i].data
                                                for (var j in spdata)
                                                {
                                                    if (!spdata[j].success)
                                                        errMessage += Helper.CapitalizeFirstLetter(j) + " of service " + i + " failed <br/>";
                                                }
                                            }
                                        }
                                        else
                                        {
                                            errMessage += "Binding of service " + i + " failed:" + JSON.stringify(sp[i]) + "<br/";
                                        }
                                    }
                                }

                                if (R.data.services.data.unbind_result)
                                {
                                    var unbindResult = R.data.services.data.unbind_result;

                                    if (unbindResult.fail > 0 || unbindResult.data.length)
                                    {
                                        success = false;
                                        services = false;

                                        if (unbindResult.data.length)
                                        {
                                            unbindResult.data.forEach(function (Line)
                                            {
                                                if (typeof(Line) === "object")
                                                    errMessage += JSON.stringify(Line)+"<br/>";
                                                else
                                                    errMessage += Line+"<br/>";
                                            });
                                        }
                                    }
                                }
                            }
                            else
                            {
                                success = false;
                                bind = false;

                                errMessage = R.data.services.error.msg;
                            }
                        }

                        if (R.data.policing)
                        {
                            if (R.data.policing.success)
                            {
                                if (R.data.policing.data.bind)
                                {
                                    var bindResult = R.data.policing.data.bind;

                                    if (!bindResult.success)
                                    {
                                        success = false;
                                        policing = false;

                                        if (bindResult.error && bindResult.error.msg)
                                            errMessage += bindResult.error.msg;
                                    }
                                }

                                if (R.data.policing.data.unbind)
                                {
                                    var unbindResult = R.data.policing.data.unbind;

                                    if (!unbindResult.success)
                                    {
                                        success = false;
                                        policing = false;

                                        if (unbindResult.error && unbindResult.error.msg)
                                            errMessage += unbindResult.error.msg;
                                    }
                                }
                            }
                            else
                            {
                                success = false;
                                policing = false;

                                errMessage = R.data.policing.error.msg;
                            }
                        }

                        if (success)
                        {
                            webix.message(message + " - "+LangHelper.GetString(_this.localeId,"Saved"));

                            delete vchannelsToSaveObj[R.id].oldVchannel;

                            if (R.data.bind &&
                                R.data.bind.data.bind_result &&
                                R.data.bind.data.bind_result.total > 1)
                                _this.Refresh();
                        }
                        else
                        {
                            if (errMessage)
                                webix.message({type:"error", text:message + " - "+LangHelper.GetString(_this.localeId,"Error")+". <br/>"+errMessage});
                            else
                                webix.message({type:"error", text:message + " - "+LangHelper.GetString(_this.localeId,"Error")+". <br/> "+LangHelper.GetString(_this.localeId,"See logs")});

                            tableRow[R.id].valid = false;
                            _this.table.validate(R.id);
                        }
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});

                        if (tableRow && tableRow[R.id])
                        {
                            tableRow[R.id].valid = false;
                            _this.table.validate(R.id);
                        }
                    }
                }

                if (R)
                {
                    if (Array.isArray(R))
                    {
                        R.forEach(function (R) { processResult(R); });
                    }
                    else processResult(R);

                    App.DicsManager.Refresh({data:[DicsEnum.PolicingProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});
                }

                _this.onTableRowSelect();
            }});
    }
};

VchannelsViewController.prototype.UpdateServiceProfilesOptions = function(Service)
{
    var _this = this;

    var columnName = "service_" + Service;
    var column = _this.table.getColumnConfig(columnName);

    if(column && !_this.table.$destructed)
    {
        column.header[1].options = [];
        _this.table.refreshColumns();
        column.header[1].options = _this.GetServicesProfilesOptions(Service);


        var state = _this.table.getState();
        var resultArr = [];
        if(state.filter && state.filter[columnName])
        {
            var arr = state.filter[columnName].split(",");
            arr.forEach(function(Val)
            {

                var index = column.header[1].options.findIndex(function(obj){
                    return obj.id == Val;
                });

                if(index > -1)
                {
                    resultArr.push(Val);
                }
            });

            column.header[1].value = resultArr.join(",");
        }


        _this.table.refreshColumns();
        _this.table.refresh();
    }
};
function BlackListServiceProfileEditViewController(Params)
{
    var _this = this;

    this.Id = "BlackListServiceProfileEdit";

    this._Id = "BlackListService";

    this.Data = null;

    this.ContextConfig = {
        view: "popup",
        modal:true,
        maxWidth: 400,
        maxHeight: 640,
        id: this.Id + "Context",
        body:null
    };

    this.Context = null;

    this.Views = {
        Form:null,
        IpTable: null,
        Suggest: null,
        ProfileType: null
    };

    this.SaveDataSinal = new Rx.BehaviorSubject(null);

    this.Subscriptions = {};

    this.Init(Params);
}

BlackListServiceProfileEditViewController.prototype.Init = function (Params)
{
    this.ContextConfig.body = this.GetFormTemplate();
    this.Context = webix.ui(this.ContextConfig);
};

BlackListServiceProfileEditViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

BlackListServiceProfileEditViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.Form = $$(this.Id + "CreateTaskContextForm");
    this.Views.ProfileType = $$(this.Id + "ProfileType");

    this.Views.ProfileType.attachEvent("onChange", function(Val)
    {
        if(Val == 1)
        {
            _this.Views.Form.elements.federal.hide();
        }
        else
        {
            _this.Views.Form.elements.federal.show();
        }
        // if(_this.Views.LoginField && _this.Views.IpField)
        // {
        //     if(Val == -1)
        //     {
        //         _this.Views.IpField.hide();
        //         _this.Views.LoginField.define({label:LangHelper.GetString("Subscribers", "IP-address"), tooltip:LangHelper.GetString("Subscribers", "IP-address"), placeholder:LangHelper.GetString("Subscribers", "IP-address"), invalidMessage:LangHelper.GetString("Subscribers", "Enter IP-address")});
        //         _this.Views.LoginField.refresh();
        //     }
        //     else
        //     {
        //         _this.Views.IpField.show();
        //         _this.Views.LoginField.define({label:LangHelper.GetString("Subscribers", "Login"), tooltip:LangHelper.GetString("Subscribers", "Login"), placeholder:LangHelper.GetString("Subscribers", "Login"), invalidMessage:LangHelper.GetString("Subscribers", "Enter login")});
        //         _this.Views.LoginField.refresh();
        //
        //         if(Val == 1)
        //         {
        //             _this.Views.IpField.define({tooltip:LangHelper.GetString("Subscribers", "IP-address or IP-addresss range"), placeholder:LangHelper.GetString("Subscribers", "IP-address or IP-addresss range")});
        //         }
        //         else
        //         {
        //             _this.Views.IpField.define({tooltip:LangHelper.GetString("Subscribers", "IP-address"), placeholder:LangHelper.GetString("Subscribers", "IP-address")});
        //         }
        //
        //         _this.Views.IpField.refresh();
        //     }
        // }
    });

    // this.Context.attachEvent("onHide", function()
    // {
    //     _this.Views.Form.clear();
    //     _this.Views.Form.clearValidation();
    // });
};

/**
 * @return {string}
 */

BlackListServiceProfileEditViewController.prototype.GetFormTemplate = function()
{
    var _this = this;


    var elements = this.GetDefaultFormFields();

    elements.push(this.GetFormButtons());

    var form = {
        rows: [
            {
                id: this.Id + "CreateTaskContextForm",
                view: "form",
                borderless: true,
                margin: 0,
                padding: 0,
                elements: elements
            }
        ]
    };
    return form;
};

BlackListServiceProfileEditViewController.prototype.GetDefaultFormFields = function()
{
    var _this = this;

    return [
        BlockHeaderTemplate({title:LangHelper.GetString(this._Id,"Black or white profile"), icon:"file"}),
        {
            view: "text",
            name: "title",
            labelWidth:200,
            required:true,
            label: LangHelper.GetString(this._Id,"Description"),
            tooltip:LangHelper.GetString(this._Id,"Task title / description"),
            invalidMessage:LangHelper.GetString(this._Id,"Required field"),
            validate: function(Val)
            {
                return Val ? true : false;
            }
        },
        {
            id: this.Id + "ProfileType",
            view: "richselect",
            name: "white",
            labelWidth:200,
            label:LangHelper.GetString(this._Id,"Type"),
            tooltip:LangHelper.GetString(this._Id,"Type: black or white"),
            options: Helper.DictToArr(BlTypesDic),
            value:BlTypesDic["0"].id
        },
        {
            view: "text",
            name: "redirect",
            label: LangHelper.GetString(this._Id,"URL to redirect"),
            labelWidth:200,
            tooltip:LangHelper.GetString(this._Id,"URL to redirect"),
            invalidMessage:LangHelper.GetString(this._Id,"URL to redirect"),
            validate: function(Val)
            {
                let isWhite = _this.Views.ProfileType.getValue() == 1;

                return Val ? Helper.IsFilePathOrUrlValid(Val) : !isWhite;
            }
        },
        {
            view: "checkbox",
            name: "federal",
            label: LangHelper.GetString(this._Id,"Use federal"),
            tooltip:LangHelper.GetString(this._Id,"Use federal lists"),
            value:0,
            labelWidth:200
        },
        {
            view: "text",
            name: "dpi_name",
            css: "readonly-disabled",
            label: LangHelper.GetString(this._Id,"Code"),
            labelWidth:200,
            tooltip: LangHelper.GetString(this._Id,"Profile name using on DPI"),
            readonly: true,
            // disabled:true
        }
    ];
};

BlackListServiceProfileEditViewController.prototype.GetFormButtons = function ()
{
    var _this = this;

    return {
        cols:[
            {},
            {
                view:"button",
                label:LangHelper.GetString(this._Id,"Cancel"),
                click:function ()
                {
                    _this.Hide();
                    // _this.Views.CreateTaskContext.hide();
                }
            },
            {
                view:"button",
                type:"form",
                label:LangHelper.GetString(this._Id,"Save"),
                hotkey: "enter",
                click:function ()
                {
                    setTimeout(function()
                    {
                        _this.Save();
                    }, 10);
                }
            }
        ]
    };
};

BlackListServiceProfileEditViewController.prototype.SetData = function (FormData, TaskData)
{
    var _this = this;

    this.Data = FormData;

    if(TaskData && TaskData.title)
    {
        this.Data.title = TaskData.title;
    }

    this.Views.Form.setValues(this.Data);

    this.Views.Form.elements.dpi_name.setValue(TaskData.dpi_name);

    if(TaskData.status == 1)
    {
        this.Views.Form.elements.white.disable();

        if(TaskData.remote)
        {
            this.Views.Form.elements.redirect.disable();
            if(this.Views.Form.elements.federal)
            {
                this.Views.Form.elements.federal.disable();
            }
        }
        else
        {
            this.Views.Form.elements.redirect.enable();
            if(this.Views.Form.elements.federal)
            {
                this.Views.Form.elements.federal.enable();
            }
        }
    }
    else
    {
        this.Views.Form.elements.redirect.enable();
        this.Views.Form.elements.white.enable();
        if(this.Views.Form.elements.federal)
        {
            this.Views.Form.elements.federal.enable();
        }
    }

};

BlackListServiceProfileEditViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node, {pos:Pos});

};

BlackListServiceProfileEditViewController.prototype.Hide = function()
{
    this.Context.hide();
};

BlackListServiceProfileEditViewController.prototype.Validate = function()
{
    return this.Views.Form.validate();
};

BlackListServiceProfileEditViewController.prototype.Save = function()
{
    var _this = this;
    if(this.Validate())
    {
        var newData = this.Views.Form.getValues();

        for(var k in newData) this.Data[k]=newData[k];

        this.Hide();

        this.SaveDataSinal.next(this.Data);
    }
};

BlackListServiceProfileEditViewController.prototype.Destroy = function()
{
    var _this = this;
}
/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */
function BlackListServiceViewController(Params)
{
    var _this = this;

    this.Id = "BlackListService";

    this.ViewModel = new BlManager();
    this.BlTargetsManager = new BlTargetsManager();
    this.SubscribersManager = new HardwareSubscribersManager();



    this.BlClsfrCategories = [];



    this.TaskDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the profile?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.TaskDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "TaskDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.TaskDeleteContext.hide();

                                var selected = _this.GetTasksTableSelectedData();

                                if(selected)
                                    _this.DeleteTask(selected.id);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.RemoteTaskStopContext = webix.ui({
        view:"popup",
        width:344,
        height:162,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"This profile loaded from hardware. Profile will be deleted if you stop it. Delete profile?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.RemoteTaskStopContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "RemoteTaskStopContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.RemoteTaskStopContext.hide();

                                var selected = _this.GetTasksTableSelectedData();

                                if(selected)
                                    _this.DeleteTask(selected.id);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateTaskContextFormConfig = new BlackListServiceProfileEditViewController(Params);
    this.SubscriberEmbedded = new SubscribersViewController({
        Id: this.Id,
        embedded:true,
        servicesOnly: true,
        services: ["4", "5"],
        MultiSubscribers: {
            Widget: new MultiSubscribersTableWidget({
                id: this.Id + "MultiSubscribersBlackListServiceReport",
            }),
            WidgetName: "MultiSubscribersBlackListServiceWidget"
        }
    });

    this.ListItemDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete this record?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ListItemDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ListItemDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function () {
                                _this.ListItemDeleteContext.hide();

                                var selected = _this.GetListItemsTableSelectedData();

                                if(selected)
                                    _this.DeleteListItem(selected.id);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ListItemClearContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete all records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ListItemClearContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ListItemClearContext" + "ClearBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function () {
                                _this.ClearListItems();
                                _this.ListItemClearContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ListItemsDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ListItemsDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ListItemsDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ListItemsDeleteContext.hide();

                                _this.DeleteListItemsSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateListItemContextFormConfig = {
        view: "popup",
        modal:true,
        id: this.Id + "CreateListItemContext",
        width: 440,
        height: 480,
        body:{
            rows:[
                {
                    id:this.Id + "CreateListItemContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "richselect",
                            on:{
                                onChange(newVal){
                                    var id = _this.Id + "CreateListItemContextForm";
                                    var form = $$(id);

                                    var richselect = {
                                        view: "richselect",
                                        id: id + "Uri",
                                        name: "uri",
                                        labelWidth:104,
                                        label: LangHelper.GetString(_this.Id,"Resource"),
                                        tooltip:LangHelper.GetString(_this.Id,"Resource"),
                                        invalidMessage: LangHelper.GetString(_this.Id, "Resource field should be valid"),
                                        options: {
                                            body: {
                                                scheme: {
                                                    $sort: {
                                                        by: "value",
                                                        dir: "asc",
                                                        as: "string"
                                                    }
                                                },
                                                data: []
                                            }
                                        },
                                        disabled: true,
                                        validate: function(Val)
                                        {
                                            if(!Val)
                                                return false;

                                            var valid = true;

                                            return valid;
                                        }
                                    };

                                    var text = {
                                        view: "text",
                                        id: id + "Uri",
                                        name: "uri",
                                        labelWidth:104,
                                        label: LangHelper.GetString(_this.Id,"Resource"),
                                        tooltip:LangHelper.GetString(_this.Id,"Resource"),
                                        invalidMessage: LangHelper.GetString(_this.Id, "Resource field should be valid"),
                                        validate: function(Val)
                                        {
                                            if(!Val)
                                                return false;

                                            var valid = true;


                                            var form = _this.Views.CreateListItemContextForms.CreateListItemContextForm;
                                            var el = form.elements;

                                            var type = el.type.getValue();

                                            if(type == BlListItemTypeEnum.ip)
                                            {
                                                if(!Val || Val.split(" ").length != 2)
                                                    return false;

                                                //-----
                                                //IPv6 is not valid for ip2bin!
                                                //-----

                                                return Helper.ValidateIPaddressSpacePort(Val);
                                            }
                                            else if(type == BlListItemTypeEnum.url)
                                            {
                                                valid = Helper.IsBlackListItemUrlValid(Val);

                                                return valid;
                                            }

                                            return valid;
                                        }
                                    };

                                    if (newVal == BlListItemTypeEnum.clsfr)
                                    {
                                        webix.ui(richselect, form, $$(id + "Uri"));

                                        _this.ViewModel.GetClsfrCategories(null);
                                    }
                                    else if (newVal == BlListItemTypeEnum.vase){
                                        webix.ui(richselect, form, $$(id + "Uri"));

                                        _this.SetRichselectVaseList();
                                    }
                                    else
                                    {
                                        webix.ui(text, form, $$(id + "Uri"));
                                    }
                                }
                            },
                            name: "type",
                            labelWidth:104,
                            label:LangHelper.GetString(this.Id,"Type"),
                            tooltip:LangHelper.GetString(this.Id,"Type"),
                            options: Helper.DictToArr(BlListItemTypeDic),
                            value:0
                        },
                        {
                            view: "text",
                            id: this.Id + "CreateListItemContextForm" + "Uri",
                            name: "uri",
                            labelWidth:104,
                            label: LangHelper.GetString(this.Id,"Resource"),
                            tooltip:LangHelper.GetString(this.Id,"Resource"),
                            invalidMessage: LangHelper.GetString(this.Id, "Resource field should be valid"),
                            validate: function(Val)
                            {
                                if(!Val)
                                    return false;

                                var valid = true;


                                var form = _this.Views.CreateListItemContextForms.CreateListItemContextForm;
                                var el = form.elements;

                                var type = el.type.getValue();

                                if(type == BlListItemTypeEnum.ip)
                                {
                                    valid = Helper.ValidateIPaddressPlusPort(Val);

                                    return valid;
                                }
                                else if(type == BlListItemTypeEnum.url)
                                {
                                    // valid = Helper.IsFilePathOrUrlValid(Val);

                                    valid = Helper.IsBlackListItemUrlValid(Val);

                                    return valid;
                                }

                                return valid;
                            }
                        },
                        {
                            view: "checkbox",
                            name: "enabled",
                            label: LangHelper.GetString(this.Id,"Enabled"),
                            tooltip:LangHelper.GetString(this.Id,"Enabled"),
                            value:0,
                            labelWidth:104
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString(this.Id,"Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.CreateListItemContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "CreateListItemContextFormSaveBtn",
                                    type:"form",
                                    label:LangHelper.GetString(this.Id,"Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.SaveListItem();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ListItemsImportContext = webix.ui({
        view:"popup",
        width:720,
        height:720,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"ListItemsImportContextForm",
            borderless:true,
            elements:[
                {
                    view: "uploader",
                    value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                    id: this.Id+"ListItemsImportContext" + "Uploader",
                    css:"upload_area",
                    autosend:false,
                    height:64
                },
                {
                    view:"datatable",
                    id:this.Id+"ListItemsImportContext" + "Table",
                    checkboxRefresh:true,
                    columns:[
                        {
                            id: "enabled",
                            header: ["", {
                                content: "richSelectFilter",
                                options: Helper.DictToArr(OnOffDic),
                                inputConfig: {suggest: {fitMaster: false}}
                            }],
                            template: CellOnOffTemplate,
                            width: 72,
                            headermenu: false
                        },
                        {
                            id: "type",
                            header: [LangHelper.GetString(this.Id,"Type"), {
                                content: "richSelectFilter",
                                options: Helper.DictToArr(BlListItemTypeDic),
                                inputConfig: {suggest: {fitMaster: false}}
                            }],
                            sort: "string",
                            editor: "text",
                            template:function (Obj, X, Val)
                            {
                                if(Val && BlListItemTypeDic[Val])
                                    return BlListItemTypeDic[Val].value;

                                return Val;
                            }
                        },
                        {
                            id: "uri",
                            header: [LangHelper.GetString(_this.Id,"Resource"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            editor: "text",
                            fillspace: true,
                            template:function(obj){
                                if (obj.type == BlListItemTypeEnum.clsfr)
                                {
                                    var lang = LangHelper.GetLocale();
                                    var categories = _this.BlClsfrCategories;

                                    var name = LangHelper.GetString(_this.Id, "Category removed");
                                    var color = true;

                                    var find = categories.find(item => item.id == obj.uri);

                                    if (find)
                                    {
                                        var name_json = JSON.parse(find.name_json);
                                        name = name_json[lang]?name_json[lang]:(name_json.en?name_json.en:name_json[Object.keys(name_json)[0]]);
                                        color = false;
                                    }

                                    return color?"<span style='color:#1A84D8;font-style:italic'>" + name + "</span>":name;
                                }
                                else if (obj.type == BlListItemTypeEnum.vase){
                                    var dics = App.DicsManager.GetDic(DicsEnum.VaseListsDic);

                                    var lang = LangHelper.GetLocale();

                                    var name = LangHelper.GetString(_this.Id, "Category removed");
                                    var color = true;

                                    var find = dics[obj.uri];

                                    if (find)
                                    {
                                        var name_json = JSON.parse(find.value);
                                        name = name_json[lang]?name_json[lang]:(name_json.en?name_json.en:name_json[Object.keys(name_json)[0]]);
                                        color = false;
                                    }

                                    return color?"<span style='color:#1A84D8;font-style:italic'>" + name + "</span>":name;
                                }

                                return obj.uri;
                            }
                        },
                        {
                            id: "trash",
                            header: "",
                            width: 32,
                            template: CellTrashBtnTemplate,
                            headermenu: false
                        }
                    ],
                    scheme:{
                        $init:function(obj){
                            obj.enabled = obj.data0;
                            obj.type = obj.data1;
                            obj.uri = obj.data2;
                        }
                    },
                    on: {
                        onItemClick: function (id, e, node)
                        {
                            if (id.column === 'trash')
                            {
                                this.remove(id);
                            }
                        }
                    }
                },
                {
                    cols:[
                        {
                            view: "button",
                            label: LangHelper.GetString(_this.Id, "Get template"),
                            click: function()
                            {
                                _this.GetListItemsImportTemplate();
                            }
                        },
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ListItemsImportContext.hide();
                                _this.Views.ListItemsImportContextTable.clearAll();
                                // _this.Views.ImportContextCodeEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            id:this.Id + "ListItemsImportContext" + "ImportBtn",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Import"),
                            click:function ()
                            {
                                _this.ListItemsImportContext.hide();

                                _this.SaveImportedExceldata();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.SubsImportContext = webix.ui({
        view:"popup",
        width:720,
        height:720,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"SubsImportContextForm",
            borderless:true,
            elements:[
                {
                    view: "uploader",
                    value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                    id: this.Id+"SubsImportContextForm" + "Uploader",
                    css:"upload_area",
                    autosend:false,
                    height:64
                },
                {
                    view:"datatable",
                    id:this.Id+"SubsImportContextForm" + "Table",
                    checkboxRefresh:true,
                    columns:[
                        {
                            id: "target",
                            header: [LangHelper.GetString(_this.Id,"Subscribers"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            editor: "text",
                            fillspace: true
                        },
                        {
                            id: "trash",
                            header: "",
                            width: 32,
                            template: CellTrashBtnTemplate,
                            headermenu: false
                        }
                    ],
                    scheme:{
                        $init:function(obj){
                            obj.target = obj.data0;
                        }
                    },
                    on: {
                        onItemClick: function (id, e, node)
                        {
                            if (id.column === 'trash')
                            {
                                this.remove(id);
                            }
                        }
                    }
                },
                {
                    cols:[
                        {
                            view: "button",
                            label: LangHelper.GetString(_this.Id, "Get template"),
                            click: function()
                            {
                                _this.GetSubsImportTemplate();
                            }
                        },
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.SubsImportContext.hide();
                                _this.Views.SubsImportContextTable.clearAll();
                                // _this.Views.ImportContextCodeEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            id:this.Id + "SubsImportContextForm" + "ImportBtn",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Import"),
                            click:function ()
                            {
                                _this.SubsImportContext.hide();

                                _this.SaveImportedSubs();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.SubsDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.SubsDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "SubsDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.SubsDeleteContext.hide();

                                _this.DeleteSubsSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.SetSyncTimeContext = webix.ui({
        view:"popup",
        width:360,
        height:180,
        body:{
            view:"form",
            id: this.Id + "SetSyncTimeContextForm",
            borderless:true,
            elements:[
                {
                    view: "text",
                    id: this.Id + "SetSyncTimeContextForm" + "Hours",
                    name: "sync_time_hours",
                    labelWidth:240,
                    label: LangHelper.GetString(this.Id,"Synchronization period in hours"),
                    tooltip:LangHelper.GetString(this.Id,"Synchronization period in hours"),
                    invalidMessage: LangHelper.GetString(this.Id, "Resource field should be valid"),
                    format:{
                        parse: function(a){ return a.replace(/[^0-9]*/g,""); },
                        edit: function(a){
                            return a ? a : 1;
                        },
                    },
                    validate: function (Val) {
                        return !isNaN(Val * 1);
                    }
                },
                {
                    view: "checkbox",
                    name: "sync_time_status",
                    label: LangHelper.GetString(this.Id,"Enabled"),
                    tooltip:LangHelper.GetString(this.Id,"Enabled"),
                    value:0,
                    labelWidth:74
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.SetSyncTimeContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "SetSyncTimeContext" + "SaveBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Save"),
                            click:function (id,e,node)
                            {
                                _this.SetSyncTimeContext.hide();

                                _this.ViewModel.SetSyncTime(_this.Views.SetSyncTimeContextForm.getValues());
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols:[

                // {
                //     type: "space",
                //     rows: [
                        {
                            type: "clear",
                            borderless: false,
                            rows: [
                                // PageHeaderTemplate({root_title: LangHelper.GetString("AppView","Traffic control"), title:LangHelper.GetString("AppView","Blocking and redirection")}),
                                {
                                    view:"accordion",
                                    multi:"mixed",
                                    cols:[
                                        {
                                            header:LangHelper.GetString(this.Id,"Profiles"),
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height: 40,
                                                        padding: 0,
                                                        margin: 0,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id:this.Id + "AddTaskBtn",
                                                                type: "icon",
                                                                icon: "plus",
                                                                align: "right",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString(this.Id,"Add profile"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.AddTaskToTasksTable();
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "AddSubTaskBtn",
                                                                type: "icon",
                                                                icon: "plus-square",
                                                                align: "right",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString(this.Id,"Add subprofile"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.AddSubTaskToTasksTable();
                                                                }
                                                            },
                                                            {
                                                                width:16
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "PlayBtn",
                                                                type: "icon",
                                                                icon: "play-circle",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString(this.Id,"Enable profile"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.RunTask();
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "StopBtn",
                                                                type: "icon",
                                                                icon: "stop-circle",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString(this.Id,"Disable profile"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.StopTask();
                                                                }
                                                            },
                                                            {},
                                                            {
                                                                view: "button",
                                                                id:this.Id+"TasksRefreshBtn",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("All","Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.RefreshTasksTable(0);
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"List of black and white profiles"), icon:"file"}),
                                                    {
                                                        view: "treetable",
                                                        id: this.Id + "TasksTable",
                                                        select: "row",
                                                        editable: true,
                                                        editaction:"custom",
                                                        resizeColumn: true,
                                                        tooltip:true,
                                                        form:this.Id + "CreateTaskContextForm",
                                                        on: {
                                                            onItemClick: function (id,e,node)
                                                            {
                                                                var rowData = this.getItem(id);

                                                                if(id.column === 'run')
                                                                {
                                                                    var data = _this.Views.TasksTable.getItem(id);

                                                                    if(!data.task_id)
                                                                    {
                                                                        return;
                                                                    }

                                                                    if(data.status == BlTaskStatusEnum.enabled)
                                                                    {
                                                                        var __this = this;
                                                                        setTimeout(function ()
                                                                        {
                                                                            if(data.remote)
                                                                            {
                                                                                _node = __this.getItemNode(id);
                                                                                _this.RemoteTaskStopContext.show(_node, {pos: "right"});
                                                                            }
                                                                            else
                                                                            {
                                                                                _this.StopTask();
                                                                            }
                                                                        }, 10);
                                                                    }
                                                                    else
                                                                    {
                                                                        setTimeout(function ()
                                                                        {
                                                                            _this.RunTask();
                                                                        }, 10);
                                                                    }
                                                                }

                                                                else if (id.column === 'edit')
                                                                {
                                                                    _this.ShowTasksEditForm(rowData, this.getItemNode(id), "right");
                                                                }

                                                                else if(id.column === 'trash')
                                                                {
                                                                    var __this = this;

                                                                    var data = _this.Views.TasksTable.getItem(id);

                                                                    if(!data.task_id)
                                                                    {
                                                                        _this.DeleteTask(id);
                                                                        return;
                                                                    }

                                                                    setTimeout(function () {
                                                                        var node = __this.getItemNode(id);
                                                                        _this.TaskDeleteContext.show(node, {pos:"bottom"});
                                                                    }, 10);
                                                                }

                                                                else if(id.column === 'sync_time')
                                                                {
                                                                    var __this = this;

                                                                    if(rowData)
                                                                    {
                                                                        _this.Views.SetSyncTimeContextForm.setValues(new BlSyncTimeModel(rowData));
                                                                    }

                                                                    _this.SetSyncTimeContext.show(__this.getItemNode(id), {pos:"bottom"});
                                                                }
                                                            },
                                                            onItemDblClick: function(id, e, node)
                                                            {
                                                                var rowData = this.getItem(id);
                                                                if(id.column !== "run" && id.column !== "edit" && id.column !== "trash")
                                                                {
                                                                  _this.ShowTasksEditForm(rowData, this.getItemNode(id), "right");
                                                                }
                                                            },
                                                            onBeforeFilter:function()
                                                            {
                                                                return false;
                                                            },
                                                            onAfterFilter:function()
                                                            {
                                                                _this.RefreshTasksTable();
                                                            },
                                                            onBeforeSort:function()
                                                            {
                                                                _this.RefreshTasksTable();
                                                                return false;
                                                            },
                                                            onAfterSelect:function ()
                                                            {
                                                                _this.OnTasksTableRowSelect();
                                                            },
                                                            onAfterUnSelect:function ()
                                                            {
                                                                _this.OnTasksTableRowUnSelect();
                                                            }
                                                        },
                                                        columns: [
                                                            {
                                                                id: "run",
                                                                header: "",
                                                                width: 32,
                                                                template: function (obj, common)
                                                                {
                                                                    if(obj.status == BlTaskStatusEnum.enabled && obj.task_id)
                                                                    {
                                                                        return CellStopBtnTemplate();
                                                                    }

                                                                    if(obj.task_id)
                                                                    {
                                                                        return CellPlayBtnTemplate();
                                                                    }

                                                                    return "";
                                                                },
                                                                headermenu: false
                                                            },
                                                            {
                                                                id: "edit",
                                                                header: "",
                                                                width: 32,
                                                                template: function(obj)
                                                                {
                                                                    // if(obj.remote == 1)
                                                                    // {
                                                                    //     return "";
                                                                    // }
                                                                    return CellEditBtnTemplate(obj);
                                                                },
                                                                headermenu: false
                                                            },
                                                            {
                                                                id: "sync_time",
                                                                header: "",
                                                                width: 32,
                                                                template: function (item)
                                                                {
                                                                    return '<span class="webix_icon fa-clock" style="cursor:pointer;' + (item.sync_time_status?' color: #1A84D8;':'') + '"></span>';
                                                                },
                                                                headermenu: false
                                                            },
                                                            {
                                                                id:"task_id",
                                                                header:[LangHelper.GetString("Subscribers","Id"),""],
                                                                width:40
                                                            },
                                                            {
                                                                id: "title",
                                                                header: [LangHelper.GetString(this.Id,"Profile"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                template:function(obj, common, value, config)
                                                                {
                                                                    var tmp = common.treetable(obj, common, value, config) + (obj.title?obj.title:LangHelper.GetString(_this.Id,"Profile")+" "+obj.task_id);

                                                                    // if(obj.status && obj.title && obj.title !== obj.dpi_name)
                                                                    // {
                                                                    //     tmp += " (" + obj.dpi_name + ")";
                                                                    // }
                                                                    return tmp;
                                                                },
                                                                tooltip: function(obj, common)
                                                                {
                                                                    var tmp = (obj.title?obj.title:LangHelper.GetString(_this.Id,"Profile")+" "+obj.task_id);

                                                                    if(obj.status && obj.title && obj.title !== obj.dpi_name)
                                                                    {
                                                                        tmp += " (" + obj.dpi_name + ")";
                                                                    }
                                                                    return tmp;
                                                                },
                                                                fillspace: true,
                                                                sort: "string"
                                                            },
                                                            {
                                                                id: "date",
                                                                header: [LangHelper.GetString(this.Id,"Date"), {content: "dateRangeFilter"}],
                                                                width:72,
                                                                //format: webix.Date.dateToStr("%d.%m.%Y"),
                                                                template:function(obj, common){
                                                                    if(obj.date)
                                                                    {
                                                                        var format =  webix.Date.dateToStr("%d.%m.%Y");
                                                                        return format(obj.date);
                                                                    }

                                                                    return "";
                                                                },
                                                                // fillspace: true,
                                                                sort: "date"
                                                            },
                                                            {
                                                                id: "user_id",
                                                                header: [LangHelper.GetString(this.Id,"User"), {
                                                                    content: "multiSelectFilter",
                                                                    options: App.DicsManager.GetDicAsArray(DicsEnum.UsersDic),
                                                                    inputConfig: {suggest: {fitMaster: false}}
                                                                }],
                                                                // fillspace: true,
                                                                width:80,
                                                                template: function (obj)
                                                                {
                                                                    var dic = App.DicsManager.GetDic("UsersDic");
                                                                    if(dic && dic[obj.user_id])
                                                                        return App.DicsManager.GetDic("UsersDic")[obj.user_id].value;
                                                                    else
                                                                        return "";
                                                                },
                                                                sort: "string"
                                                            },
                                                            {
                                                                id: "white",
                                                                header: [LangHelper.GetString(this.Id,"Type"), {
                                                                    content: "richSelectFilter",
                                                                    options: Helper.DictToArr(BlTypesDic),
                                                                    inputConfig: {suggest: {fitMaster: false}}}],
                                                                width:72,
                                                                template: function (obj, common)
                                                                {
                                                                    var statusStr = "";

                                                                    if(BlTypesDic[obj.white])
                                                                    {
                                                                        statusStr += BlTypesDic[obj.white].value;
                                                                    }

                                                                    return statusStr;
                                                                },
                                                                // fillspace: true,
                                                                sort: "string"
                                                            },
                                                            {
                                                                id: "status",
                                                                header: [LangHelper.GetString(this.Id,"Status"), {
                                                                    content: "richSelectFilter",
                                                                    options: Helper.DictToArr(BlStatusesDic),
                                                                    inputConfig: {suggest: {fitMaster: false}}
                                                                }],
                                                                width:72,
                                                                template: function (obj, common)
                                                                {
                                                                    var statusStr = "";

                                                                    if(BlStatusesDic[obj.status])
                                                                    {
                                                                        statusStr += "<span class=\"status status_" + obj.status + "\">" + BlStatusesDic[obj.status].value + "</span>";
                                                                    }

                                                                    return statusStr;
                                                                },
                                                                // fillspace: true,
                                                                sort: "string"
                                                            },
                                                            {
                                                                id: "trash",
                                                                header: "",
                                                                width: 32,
                                                                template: CellTrashBtnTemplate,
                                                                headermenu: false
                                                            }
                                                        ],
                                                        data:[]
                                                    },
                                                    {
                                                        view: "toolbar",
                                                        padding: 0,
                                                        margin: 0,
                                                        height:32,
                                                        elements: [
                                                            {
                                                                view: "pager",
                                                                gravity:3,
                                                                id: this.Id + "TasksTable" + "Paging",
                                                                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                                master:false,
                                                                on: {
                                                                    onAfterPageChange:function(Page)
                                                                    {
                                                                        _this.RefreshTasksTable(Page);
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view:"richselect",
                                                                id: this.Id + "TasksTable" + "Paging" + "Size",
                                                                label:LangHelper.GetString(_this.Id, "On page"),
                                                                labelWidth:120,
                                                                minWidth:220,
                                                                value:100,
                                                                options:PagingSizeOptions,
                                                                on: {
                                                                    onChange:function()
                                                                    {
                                                                        _this.RefreshTasksTable();
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }

                                        },
                                        // {view:"resizer"},
                                        // {
                                        //     header: LangHelper.GetString(this.Id, "Subscribers"),
                                        //     minWidth: 424,
                                        //     gravity: 1/2,
                                        //     body:{
                                        //         id: this.Id + "SubsPanel",
                                        //         rows:[
                                        //             {
                                        //                 view: "toolbar",
                                        //                 height: 32,
                                        //                 padding: 0,
                                        //                 margin: 0,
                                        //                 elements: [
                                        //                     {
                                        //                         view: "button",
                                        //                         id:this.Id + "AddSubBtn",
                                        //                         type: "icon",
                                        //                         icon: "plus",
                                        //                         align: "right",
                                        //                         width: 32,
                                        //                         css:"toolbar_round_btn",
                                        //                         tooltip:LangHelper.GetString(this.Id,"Add subscriber"),
                                        //                         click: function (id, e, node)
                                        //                         {
                                        //                             _this.AddSubToSubsTable();
                                        //                         }
                                        //                     },
                                        //                     {
                                        //                         view: "button",
                                        //                         id:this.Id+"DelSubBtn",
                                        //                         type: "icon",
                                        //                         icon: "trash",
                                        //                         css:"toolbar_round_btn",
                                        //                         width:32,
                                        //                         tooltip:LangHelper.GetString(this.Id, "Delete"),
                                        //                         disabled:true,
                                        //                         click:function (id,e,node)
                                        //                         {
                                        //                             var __this = this;
                                        //                             setTimeout(function () {
                                        //                                 var node = __this.getNode(id);
                                        //                                 _this.SubsDeleteContext.show(node, {pos:"bottom"});
                                        //                             }, 10);
                                        //                         }
                                        //                     },
                                        //                     {
                                        //                         width:24
                                        //                     },
                                        //                     {
                                        //                         view: "button",
                                        //                         id:this.Id + "ImportSubsBtn",
                                        //                         type: "icon",
                                        //                         icon: "upload",
                                        //                         css:"toolbar_round_btn",
                                        //                         width:32,
                                        //                         tooltip:LangHelper.GetString(this.Id,"Import from file"),
                                        //                         click:function (id,e,node)
                                        //                         {
                                        //                             var __this = this;
                                        //                             setTimeout(function () {
                                        //                                 var node = __this.getNode(id);
                                        //                                 _this.SubsImportContext.show(node, {pos: "bottom"});
                                        //                                 _this.Views.SubsImportContextTable.clearAll();
                                        //                             }, 10);
                                        //                         }
                                        //                     },
                                        //                     {
                                        //                         view: "button",
                                        //                         id:this.Id + "ExcelExportSubBtn",
                                        //                         type: "icon",
                                        //                         icon: "file-excel",
                                        //                         css:"toolbar_round_btn",
                                        //                         width:32,
                                        //                         tooltip:LangHelper.GetString(this.Id,"Export to Excel"),
                                        //                         click:function (id,e,node)
                                        //                         {
                                        //                             _this.ExportSubsToExcel();
                                        //                         }
                                        //                     },
                                        //                     {},
                                        //                     {
                                        //                         view: "button",
                                        //                         id:this.Id+"SubsRefreshBtn",
                                        //                         type: "icon",
                                        //                         icon: "refresh",
                                        //                         css: "toolbar_round_btn",
                                        //                         width: 32,
                                        //                         tooltip: LangHelper.GetString("All","Refresh"),
                                        //                         click: function (id, e, node)
                                        //                         {
                                        //                             _this.RefreshSubs(0);
                                        //                         }
                                        //                     }
                                        //                 ]
                                        //             },
                                        //             BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Subscribers"), icon:"users"}),
                                        //             {
                                        //                 view: "datatable",
                                        //                 id: this.Id + "SubsTable",
                                        //                 select: "row",
                                        //                 multiselect:true,
                                        //                 editable: true,
                                        //                 editaction:"dblclick",
                                        //                 resizeColumn: true,
                                        //                 tooltip:true,
                                        //                 on: {
                                        //                     onItemClick: function (id,e,node)
                                        //                     {
                                        //                         var rowData = this.getItem(id);
                                        //
                                        //                         if (id.column === 'edit')
                                        //                         {
                                        //                             this.editRow(id);
                                        //                         }
                                        //
                                        //                         else if(id.column === 'trash')
                                        //                         {
                                        //                             var __this = this;
                                        //
                                        //                             this.select(id); //reset if multiple rows selected
                                        //
                                        //                             var data = _this.Views.SubsTable.getItem(id);
                                        //
                                        //                             var model = _this.BlTargetsManager.Targets.find(function(Val){
                                        //                                return Val.id === data.id;
                                        //                             });
                                        //
                                        //                             if(!data.target || !model || !model.target)
                                        //                             {
                                        //                                 _this.DeleteSubscriber(id);
                                        //                                 return;
                                        //                             }
                                        //
                                        //                             setTimeout(function ()
                                        //                             {
                                        //                                 var node = __this.getItemNode(id);
                                        //                                 _this.SubsDeleteContext.show(node, {pos:"bottom"});
                                        //                             }, 10);
                                        //                         }
                                        //                     },
                                        //                     onBeforeFilter:function()
                                        //                     {
                                        //                         return false;
                                        //                     },
                                        //                     onAfterFilter:function()
                                        //                     {
                                        //                         _this.RefreshSubs();
                                        //                     },
                                        //                     onBeforeSort:function()
                                        //                     {
                                        //                         _this.RefreshSubs();
                                        //                         return false;
                                        //                     },
                                        //                     onAfterSelect:function ()
                                        //                     {
                                        //                         _this.OnSubsTableRowSelect();
                                        //                     },
                                        //                     onAfterUnSelect:function ()
                                        //                     {
                                        //                         _this.OnSubsTableRowSelect();
                                        //                     },
                                        //
                                        //                     onAfterEditStart: function(Id)
                                        //                     {
                                        //                         // var
                                        //                         // this.
                                        //                         var editor = this.getEditor(Id.row, Id.column);
                                        //                         _this.UpdateSubsSuggestList(editor);
                                        //                     }
                                        //                 },
                                        //                 columns: [
                                        //                     {
                                        //                         id: "edit",
                                        //                         header: "",
                                        //                         width: 32,
                                        //                         template: CellEditBtnTemplate,
                                        //                         headermenu: false
                                        //                     },
                                        //                     {
                                        //                         id: "target",
                                        //                         name: "target",
                                        //                         header: [LangHelper.GetString(_this.Id,"Subscribers"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        //                         sort: "string",
                                        //                         editor: "text",
                                        //                         fillspace: true,
                                        //                         suggest: {
                                        //                             data:[]
                                        //                         }
                                        //                     },
                                        //                     {
                                        //                         id: "status",
                                        //                         header: [
                                        //                             LangHelper.GetString(this.Id,"Status"), {
                                        //                                 content: "richSelectFilter",
                                        //                                 options: Helper.DictToArr(BlTargetsStateDic),
                                        //                                 inputConfig: {suggest: {fitMaster: false}}
                                        //                             }
                                        //                         ],
                                        //                         template: function (obj, common) {
                                        //                             var res = "";
                                        //
                                        //                             var profile = _this.GetTasksTableSelectedData();
                                        //                             // if(profile && profile.task_id)
                                        //                             // {
                                        //                             //     if(profile.status == 0)
                                        //                             //     {
                                        //                             //         return "<span class=\"bl_state bl_target_" + profile.status + "\">" + '<span class="fa fa-square"></span> ' + BlTargetsStateDic[profile.status].value + "</span>"
                                        //                             //     }
                                        //                             // }
                                        //                             res = "<span class=\"bl_state bl_target_" + obj.status + "\">" + '<span class="fa fa-square"></span> ' + BlTargetsStateDic[obj.status].value + "</span>";
                                        //
                                        //                             return res;
                                        //                         },
                                        //                         // fillspace: true,
                                        //                         sort: "int"
                                        //                     },
                                        //                     {
                                        //                         id: "trash",
                                        //                         header: "",
                                        //                         width: 32,
                                        //                         template: CellTrashBtnTemplate,
                                        //                         headermenu: false
                                        //                     }
                                        //                 ],
                                        //                 data:[],
                                        //                 // rules:{
                                        //                 //     "target": Helper.ValidateIPaddressOrCidr
                                        //                 // }
                                        //             },
                                        //             {
                                        //                 view: "toolbar",
                                        //                 padding: 0,
                                        //                 margin: 0,
                                        //                 height:32,
                                        //                 elements: [
                                        //                     {
                                        //                         view: "pager",
                                        //                         gravity:3,
                                        //                         id: this.Id + "SubsTable" + "Paging",
                                        //                         template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                        //                         master:false,
                                        //                         on: {
                                        //                             onAfterPageChange:function(Page)
                                        //                             {
                                        //                                 _this.RefreshSubs(Page);
                                        //                             }
                                        //                         }
                                        //                     },
                                        //                     {
                                        //                         view:"richselect",
                                        //                         id: this.Id + "SubsTable" + "Paging" + "Size",
                                        //                         label:LangHelper.GetString(_this.Id, "On page"),
                                        //                         labelWidth:120,
                                        //                         minWidth:220,
                                        //                         value:100,
                                        //                         options:PagingSizeOptions,
                                        //                         on: {
                                        //                             onChange:function()
                                        //                             {
                                        //                                 _this.RefreshSubs();
                                        //                             }
                                        //                         }
                                        //                     }
                                        //                 ]
                                        //             }
                                        //         ]
                                        //     }
                                        // },
                                        {view: "resizer"},
                                        {
                                            header:LangHelper.GetString(this.Id,"Black and white lists"),
                                            body:{
                                                id:this.Id + "ListsPanel",
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height: 40,
                                                        padding: 0,
                                                        margin: 0,
                                                        elements: [
                                                            {
                                                                view:"label",
                                                                id:this.Id+"TaskDataInfoLabel",
                                                                width:300
                                                            },
                                                            {
                                                                width:32
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "AddListItemBtn",
                                                                type: "icon",
                                                                icon: "plus",
                                                                align: "right",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString(this.Id,"Add list item"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.AddListItemToListsTable();
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id+"DelListItemBtn",
                                                                type: "icon",
                                                                icon: "trash",
                                                                css:"toolbar_round_btn",
                                                                width:32,
                                                                tooltip:LangHelper.GetString(this.Id, "Delete"),
                                                                disabled:true,
                                                                click:function (id,e,node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.ListItemsDeleteContext.show(node, {pos:"bottom"});
                                                                    }, 10);
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id+"ClearListItemBtn",
                                                                type: "icon",
                                                                icon: "eraser",
                                                                css:"toolbar_round_btn",
                                                                width:32,
                                                                tooltip:LangHelper.GetString(this.Id, "Clear list"),
                                                                disabled:true,
                                                                click:function (id,e,node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.ListItemClearContext.show(node, {pos:"bottom"});
                                                                    }, 10);
                                                                }
                                                            },
                                                            {
                                                                width:16
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "ImportListFromQoEBtn",
                                                                type: "icon",
                                                                icon: "cloud-upload",
                                                                css:"toolbar_round_btn",
                                                                // template:"<span class='fas fa-cloud-download-alt'></span>",
                                                                width:32,
                                                                tooltip:LangHelper.GetString(this.Id,"Import categories from QoE"),
                                                                click:function (id,e,node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);

                                                                        _this.ShowCategoriesImportContext(node, {});
                                                                    }, 10);
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "ImportListBtn",
                                                                type: "icon",
                                                                icon: "upload",
                                                                css:"toolbar_round_btn",
                                                                width:32,
                                                                tooltip:LangHelper.GetString(this.Id,"Import from file"),
                                                                click:function (id,e,node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.ListItemsImportContext.show(node, {pos: "bottom"});
                                                                        _this.Views.ListItemsImportContextTable.clearAll();
                                                                    }, 10);
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "ExcelExportListBtn",
                                                                type: "icon",
                                                                icon: "file-excel",
                                                                css:"toolbar_round_btn",
                                                                width:32,
                                                                tooltip:LangHelper.GetString(this.Id,"Export to Excel"),
                                                                click:function (id,e,node)
                                                                {
                                                                    _this.ExportToExcel();
                                                                }
                                                            },
                                                            {
                                                                width:16
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id+"ListItemsRefreshBtn",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("All","Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.RefreshListItems(0);
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Black and white lists"), icon:"file"}),
                                                    {
                                                        view: "datatable",
                                                        id: this.Id + "ListItemsTable",
                                                        select: "row",
                                                        multiselect:true,
                                                        editable: true,
                                                        editaction:"custom",
                                                        resizeColumn: true,
                                                        tooltip:true,
                                                        checkboxRefresh:true,
                                                        form:this.Id + "CreateListItemContextForm",
                                                        on: {
                                                            onItemClick: function (id,e,node)
                                                            {
                                                                var rowData = this.getItem(id);

                                                                if (id.column === 'edit')
                                                                {
                                                                    this.select(id); //reset if multiple rows selected

                                                                    _this.ShowListItemsEditForm(rowData, this.getItemNode(id), "right");
                                                                }

                                                                else if(id.column === 'trash')
                                                                {
                                                                    var __this = this;

                                                                    this.select(id); //reset if multiple rows selected

                                                                    var data = _this.Views.ListItemsTable.getItem(id);

                                                                    if(!data.item_id)
                                                                    {
                                                                        _this.DeleteListItem(id);
                                                                        return;
                                                                    }

                                                                    setTimeout(function ()
                                                                    {
                                                                        var node = __this.getItemNode(id);
                                                                        _this.ListItemDeleteContext.show(node, {pos:"bottom"});
                                                                    }, 10);
                                                                }
                                                            },
                                                            onItemDblClick: function(id, e, node)
                                                            {
                                                                var rowData = this.getItem(id);
                                                                if(id.column == "type" || id.column == "uri")
                                                                {
                                                                    _this.ShowListItemsEditForm(rowData, this.getItemNode(id), "right");
                                                                }
                                                            },
                                                            onBeforeFilter:function()
                                                            {
                                                                return false;
                                                            },
                                                            onAfterFilter:function()
                                                            {
                                                                _this.RefreshListItems();
                                                            },
                                                            onBeforeSort:function()
                                                            {
                                                                _this.RefreshListItems();
                                                                return false;
                                                            },
                                                            onAfterSelect:function ()
                                                            {
                                                                _this.OnListItemsTableRowSelect();
                                                            },
                                                            onAfterUnSelect:function ()
                                                            {
                                                                _this.OnListItemsTableRowUnSelect();
                                                            },
                                                            onCheck:function(row, column, state)
                                                            {
                                                                var rowData = this.getItem(row);

                                                                var taskData = _this.GetTasksTableSelectedData();

                                                                rowData.enabled = state;
                                                                _this.JustSaveListItem(rowData, rowData);

                                                                // if(taskData&&taskData.task_id&&taskData.status != BlTaskStatusEnum.enabled)
                                                                // {
                                                                //     rowData.enabled = state;
                                                                //     _this.JustSaveListItem(rowData, rowData);
                                                                // }
                                                                // else
                                                                // {
                                                                //     this.blockEvent();
                                                                //     rowData.enabled = rowData.enabled?0:1;
                                                                //     this.updateItem(row, rowData);
                                                                //     this.unblockEvent();
                                                                // }
                                                            }
                                                        },
                                                        columns: [
                                                            {
                                                                id: "edit",
                                                                header: "",
                                                                width: 32,
                                                                template: CellEditBtnTemplate,
                                                                headermenu: false
                                                            },
                                                            {
                                                                id: "enabled",
                                                                header: ["", {
                                                                    content: "richSelectFilter",
                                                                    options: Helper.DictToArr(OnOffDic),
                                                                    inputConfig: {suggest: {fitMaster: false}}
                                                                }],
                                                                template: CellOnOffTemplate,
                                                                width: 72,
                                                                headermenu: false
                                                            },
                                                            {
                                                                id: "type",
                                                                width:160,
                                                                header: [LangHelper.GetString(this.Id,"Type"), {
                                                                    content: "richSelectFilter",
                                                                    options: Helper.DictToArr(BlListItemTypeDic),
                                                                    inputConfig: {suggest: {fitMaster: false}}
                                                                }],
                                                                sort: "string",
                                                                editor: "text",
                                                                template:function (Obj, X, Val)
                                                                {
                                                                    if(Val && BlListItemTypeDic[Val])
                                                                        return BlListItemTypeDic[Val].value;

                                                                    return Val;
                                                                }
                                                            },
                                                            {
                                                                id: "uri",
                                                                header: [LangHelper.GetString(_this.Id,"Resource"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                sort: "string",
                                                                editor: "text",
                                                                fillspace: true,
                                                                width:128,
                                                                template:function(obj){
                                                                    if (obj.type == BlListItemTypeEnum.clsfr)
                                                                    {
                                                                        var lang = LangHelper.GetLocale();
                                                                        var categories = _this.BlClsfrCategories;

                                                                        var name = LangHelper.GetString(_this.Id, "Category removed");
                                                                        var color = true;

                                                                        var find = categories.find(item => item.id == obj.uri);

                                                                        if (find)
                                                                        {
                                                                            var name_json = JSON.parse(find.name_json);
                                                                            name = name_json[lang]?name_json[lang]:(name_json.en?name_json.en:name_json[Object.keys(name_json)[0]]);
                                                                            color = false;
                                                                        }

                                                                        return color?"<span style='color:#1A84D8;font-style:italic'>" + name + "</span>":name;
                                                                    }
                                                                    else if (obj.type == BlListItemTypeEnum.vase){
                                                                        var dics = App.DicsManager.GetDic(DicsEnum.VaseListsDic);

                                                                        var lang = LangHelper.GetLocale();

                                                                        var name = LangHelper.GetString(_this.Id, "Category removed");
                                                                        var color = true;

                                                                        var find = dics[obj.uri];

                                                                        if (find)
                                                                        {
                                                                            var name_json = JSON.parse(find.value);
                                                                            name = name_json[lang]?name_json[lang]:(name_json.en?name_json.en:name_json[Object.keys(name_json)[0]]);
                                                                            color = false;
                                                                        }

                                                                        return color?"<span style='color:#1A84D8;font-style:italic'>" + name + "</span>":name;
                                                                    }

                                                                    return obj.uri;
                                                                }
                                                            },
                                                            {
                                                                id: "trash",
                                                                header: "",
                                                                width: 32,
                                                                template: CellTrashBtnTemplate,
                                                                headermenu: false
                                                            }
                                                        ],
                                                        data:[]
                                                    },
                                                    {
                                                        view: "toolbar",
                                                        padding: 0,
                                                        margin: 0,
                                                        height:32,
                                                        elements: [
                                                            {
                                                                view: "pager",
                                                                // gravity:2.5,
                                                                minWidth:240,
                                                                id: this.Id + "ListItemsTable" + "Paging",
                                                                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                                master:false,
                                                                on: {
                                                                    onAfterPageChange:function(Page)
                                                                    {
                                                                        _this.RefreshListItems(Page);
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view:"richselect",
                                                                id: this.Id + "ListItemsTable" + "Paging" + "Size",
                                                                label:LangHelper.GetString(_this.Id, "On page"),
                                                                labelWidth:120,
                                                                width:200,
                                                                value:100,
                                                                options:PagingSizeOptions,
                                                                on: {
                                                                    onChange:function()
                                                                    {
                                                                        _this.RefreshListItems();
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        {view:"resizer"},
                                        {
                                            header: LangHelper.GetString(this.Id,"Subscribers"),
                                            id: this.Id + "SubsAccord",
                                            body:this.SubscriberEmbedded.view,
                                            gravity: 1
                                        },
                                        {gravity: 0}
                                    ]
                                }
                            ]
                        }
                    // ]
                // }
            ]
        }
    ];

    this.Views = {
        AddTaskBtn: null,
        AddSubTaskBtn: null,

        PlayBtn: null,
        StopBtn: null,

        TasksTable:null,
        TasksTablePaging:null,
        TasksTablePagingSize:null,

        SetSyncTimeContext:null,
        SetSyncTimeContextForm:null,

        CreateTaskContext:null,
        // CreateTaskContextForms:{
        //     CreateTaskContextForm:null
        // },

        ListsPanel:null,
        TaskDataInfoLabel:null,

        AddListItemBtn: null,
        DelListItemBtn:null,
        ImportListBtn: null,

        ListItemsTable:null,
        ListItemsTablePaging:null,
        ListItemsTablePagingSize:null,

        CreateListItemContext:null,
        CreateListItemContextForms:{
            CreateListItemContextForm:null
        },
        CreateListItemContextFormSaveBtn:null,

        ListItemsImportContextUploader:null,
        ListItemsImportContextTable:null,

        ListItemsImportContextImportBtn:null,
        TaskDeleteContextDeleteBtn:null,
        ListItemDeleteContextDeleteBtn:null,

        // SubsPanel: null,
        // AddSubBtn: null,
        // DelSubBtn: null,
        // ImportSubsBtn: null,
        // ExcelExportSubBtn: null,
        // SubsRefreshBtn: null,
        // SubsTable: null,
        // SubsTablePagingSize: null,
        // SubsTablePaging:null,
        // SubsImportContextTable: null,
        // SubsImportContextFormUploader: null,
        ClearListItemBtn:null
    };

    this.TasksTableRowsSelectedCount = new Rx.BehaviorSubject(0);
    this.ListItemsTableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};
}

BlackListServiceViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.ViewModel.Destroy();
    delete this.ViewModel;
    this.SubscriberEmbedded.Destroy();
    this.CreateTaskContextFormConfig.Destroy();
};

BlackListServiceViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    // webix.ready(function () {
    //     $$(_this.Id + "LeftSideBar").select(_this.Id);
    // });

    this.SubscriberEmbedded.ViewDidLoad(Params);
    this.CreateTaskContextFormConfig.ViewDidLoad(Params);


    this.BindAll();

    // this.CheckHealth();
};

BlackListServiceViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.AddTaskBtn = $$(this.Id + "AddTaskBtn");
    this.Views.AddSubTaskBtn = $$(this.Id + "AddSubTaskBtn");

    this.Views.PlayBtn = $$(this.Id + "PlayBtn");
    this.Views.StopBtn = $$(this.Id + "StopBtn");

    this.Views.TasksTable = $$(this.Id + "TasksTable");
    this.Views.TasksTablePaging = $$(this.Id + "TasksTable" + "Paging");
    this.Views.TasksTablePagingSize = $$(this.Id + "TasksTable" + "Paging" + "Size");

    this.Views.SetSyncTimeContext = webix.ui(this.SetSyncTimeContext);
    this.Views.SetSyncTimeContextForm = $$(this.Id+"SetSyncTimeContextForm");

    // this.Views.CreateTaskContext = webix.ui(this.CreateTaskContextFormConfig);
    // this.Views.CreateTaskContextForms.CreateTaskContextForm = $$(this.Id+"CreateTaskContextForm");

    this.Views.ListsPanel = $$(this.Id+"ListsPanel");
    this.Views.TaskDataInfoLabel = $$(this.Id + "TaskDataInfoLabel");

    this.Views.AddListItemBtn = $$(this.Id + "AddListItemBtn");
    this.Views.DelListItemBtn = $$(this.Id + "DelListItemBtn");
    this.Views.ImportListBtn = $$(this.Id + "ImportListBtn");

    this.Views.ListItemsTable = $$(this.Id + "ListItemsTable");
    this.Views.ListItemsTablePaging = $$(this.Id + "ListItemsTable" + "Paging");
    this.Views.ListItemsTablePagingSize = $$(this.Id + "ListItemsTable" + "Paging" + "Size");

    this.Views.CreateListItemContext = webix.ui(this.CreateListItemContextFormConfig);
    this.Views.CreateListItemContextForms.CreateListItemContextForm = $$(this.Id+"CreateListItemContextForm");
    this.Views.CreateListItemContextFormSaveBtn = $$(this.Id+"CreateListItemContextFormSaveBtn");

    this.Views.ListItemsImportContextUploader = $$(this.Id + "ListItemsImportContextUploader");
    this.Views.ListItemsImportContextTable = $$(this.Id + "ListItemsImportContextTable");

    this.Views.ListItemsImportContextImportBtn = $$(this.Id + "ListItemsImportContextImportBtn");
    this.Views.TaskDeleteContextDeleteBtn = $$(this.Id + "TaskDeleteContextDeleteBtn");
    this.Views.ListItemDeleteContextDeleteBtn = $$(this.Id + "ListItemDeleteContextDeleteBtn");

    // this.Views.SubsPanel = $$(this.Id + "SubsPanel");
    this.Views.AddSubBtn = $$(this.Id + "AddSubBtn");
    this.Views.DelSubBtn = $$(this.Id + "DelSubBtn");
    this.Views.ImportSubsBtn = $$(this.Id + "ImportSubsBtn");
    this.Views.ExcelExportSubBtn = $$(this.Id + "ExcelExportSubBtn");
    this.Views.ClearListItemBtn = $$(this.Id + "ClearListItemBtn");
    // this.Views.SubsRefreshBtn = $$(this.Id + "SubsRefreshBtn");
    // this.Views.SubsTable = $$(this.Id + "SubsTable");
    // this.Views.SubsTablePaging = $$(this.Id + "SubsTable" + "Paging");
    // this.Views.SubsTablePagingSize = $$(this.Id + "SubsTable" + "Paging" + "Size");

    // this.Views.SubsImportContextTable = $$(this.Id + "SubsImportContextForm" + "Table");
    // this.Views.SubsImportContextFormUploader = $$(this.Id+"SubsImportContextForm" + "Uploader");




    // this.Views.SubsTable.attachEvent("onAfterEditStop", function(state, editor, ignoreUpdate)
    // {
    //     if (ignoreUpdate)
    //     {
    //         this.editCancel();
    //         return;
    //     }
    //     else if (state.value === state.old) {
    //         this.editCancel();
    //         return;
    //     }
    //     else{
    //         var max = this.config.columns.length;
    //         var now = this.getColumnIndex(editor.column);
    //
    //         for (var i=now+1; i<max; i++)
    //         {
    //             if (this.config.columns[i].editor)
    //             {
    //                 return false;
    //             }
    //
    //         }
    //
    //     }
    //
    //     _this.SaveSubscriber(editor.row);
    //
    //     return false;
    // });

    // this.Subscriptions.SignalDicUpdatedSubscription = App.DicsManager.Signal[DicsEnum.UsersDic].subscribe(function (Updated)
    // {
    //     if (Updated)
    //     {
    //         _this.RefreshTasksTable(0);
    //     }
    // });



    //Clsfr Categories
    this.Subscriptions.BlGetClsfrCategories = this.ViewModel.Signals.BlGetClsfrCategories.subscribe(function (Model) {
        if (Model)
        {
            var Categories = [];

            Model.rows.forEach(function(Category)
            {
                Category.id = Category._id;
                delete Category._id;

                var lang = LangHelper.GetLocale();

                if (Category && Category.name_json)
                {
                    var name = JSON.parse(Category.name_json);
                    Category.value = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
                }else{
                    Category.value = Category.name;
                }

                Categories.push(Category);
            });

            if (Model.isLoad)
            {
                var elements = _this.Views.CreateListItemContextForms.CreateListItemContextForm.elements;
                var uri = elements.uri;

                var list = uri.getList();
                list.clearAll();
                list.parse(Categories);

                uri.enable();
            }

            _this.BlClsfrCategories = Categories;
        }
    });
    this.Subscriptions.BlGetClsfrCategoriesError = this.ViewModel.Signals.BlGetClsfrCategoriesError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.SignalClsfrCategoriesDic = App.DicsManager.Signal[DicsEnum.ClsfrCategoriesDic].subscribe(function (Value)
    {
        if(Value)
        {
            var arr = App.DicsManager.GetDicAsArray(DicsEnum.ClsfrCategoriesDic);

            arr.forEach(function (item)
            {
                item.name_json = JSON.stringify(item.value);
                delete item.value;
            });

            _this.BlClsfrCategories = arr;
        }
    });

    //Task Sync Time
    this.Subscriptions.BlSyncTime = this.ViewModel.Signals.BlSyncTime.subscribe(function (Model) {
        if (Model)
        {
            _this.Views.TasksTable.updateItem(Model.id, Model);

            webix.message(LangHelper.GetString(_this.Id, "Task sync time update success"));
        }
    });
    this.Subscriptions.BlSyncTimeError = this.ViewModel.Signals.BlSyncTimeError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    App.DicsManager.Refresh({data:[DicsEnum.ClsfrCategoriesDic, DicsEnum.VaseListsDic]});

    //this.ViewModel.GetClsfrCategories(null, false);

    this.Subscriptions.SignalTasksUpdatedSubscription = this.ViewModel.SignalTasksUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateTasksTable();
        }
    });

    this.Subscriptions.TasksTableRowsSelectedCountSubscription = this.TasksTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.TasksTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.SignalTaskUpdatedSubscription = this.ViewModel.SignalTaskUpdated.subscribe(function (Task)
    {
        if(Task)
        {
            var selectedData = _this.GetTasksTableSelectedData();

            var rows = _this.Views.TasksTable.find(function(obj)
            {
                return obj.task_id == Task.task_id;
            });

            if(rows && rows.length == 1)
            {
                _this.Views.TasksTable.updateItem(rows[0].id,  Task);

                if(selectedData && selectedData.task_id == Task.task_id && Task.status != 0)
                {
                    _this.OnTasksTableRowSelect();
                }
            }

        }
    });

    this.Subscriptions.SignalListItemsUpdatedSubscription = this.ViewModel.SignalListItemsUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateListItemsTable();
        }
    });

    this.Subscriptions.SignalListItemUpdatedSubscription = this.ViewModel.SignalListItemUpdated.subscribe(function (ListItem)
    {
        if(ListItem)
        {
            var selectedData = _this.GetListItemsTableSelectedData();

            var rows = _this.Views.ListItemsTable.find(function(obj)
            {
                return obj.item_id == ListItem.item_id;
            });

            if(rows && rows.length == 1)
            {
                _this.Views.ListItemsTable.updateItem(rows[0].id,  ListItem);

                if(selectedData && selectedData.item_id == ListItem.item_id && ListItem.status != 0)
                {
                    _this.OnListItemsTableRowSelect();
                }
            }
        }
    });


    this.Views.ListItemsImportContextUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        _this.ImportExcelToListItemsImportContextTable(FileObj.file);
    });


    this.Subscriptions.ListItemsTableRowsSelectedCountSubscription = this.ListItemsTableRowsSelectedCount.subscribe(function (Value)
    {
        if(Value > 1)
        {
            _this.Views.DelListItemBtn.enable();
        }
        else
        {
            _this.Views.DelListItemBtn.disable();
        }
    });


    this.Subscriptions.SignalSaveProfile = this.CreateTaskContextFormConfig.SaveDataSinal.subscribe(
        function(Val)
        {
            if(Val)
            {
                _this.SaveTask(Val);
            }
        }
    );

    this.Subscriptions.SignalSubsUpdate = this.BlTargetsManager.SignalTargetsUpdated.subscribe(
        function(Val)
        {
            if(Val)
            {
                _this.UpdateSubscribersTable();
            }
        }
    );

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshTasksTable();
        }
    });
};

BlackListServiceViewController.prototype.AddTaskToTasksTable = function ()
{
    var _this = this;

    var model = new BlTaskModel({hardware_id: App.SessionManager.GetCurrentHardwareId()});
    model.form_data = JSON.stringify(new BlTaskFormModel());

    _this.Views.TasksTable.add(model,0);

    _this.Views.TasksTable.select(model.id, false);
    _this.Views.TasksTable.showItem(model.id);

    _this.ShowTasksEditForm(model, _this.Views.TasksTable.getItemNode(model.id), "right");
};

BlackListServiceViewController.prototype.GetTasksTableSelectedData = function ()
{
    return this.Views.TasksTable.getSelectedItem();
};

BlackListServiceViewController.prototype.OnTasksTableRowSelect = function ()
{
    var data = this.GetTasksTableSelectedData();

    this.TasksTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

BlackListServiceViewController.prototype.OnTasksTableRowUnSelect = function ()
{
    var data = this.GetTasksTableSelectedData();
    this.TasksTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

BlackListServiceViewController.prototype.SetTasksEditFormValues = function (FormData, TaskData)
{
    if(FormData)
    {
        this.CreateTaskContextFormConfig.SetData(new BlTaskFormModel(FormData), TaskData);
        // this.Views.CreateTaskContextForms.CreateTaskContextForm.setValues(new BlTaskFormModel(FormData));
    }
};

BlackListServiceViewController.prototype.ShowTasksEditForm = function (Data, Node, Pos)
{
    this.ClearForms();

    if(Data && Data.form_data)
    {
        var formParams = new BlTaskFormModel(JSON.parse(Data.form_data));

        this.SetTasksEditFormValues(formParams, Data);
    }

    this.CreateTaskContextFormConfig.Show(Node,{pos:Pos});
};

BlackListServiceViewController.prototype.ClearForms = function ()
{
    var _this = this;

    // Object.keys(this.Views.CreateTaskContextForms).forEach(function (Key)
    // {
    //     _this.Views.CreateTaskContextForms[Key].clear();
    //     _this.Views.CreateTaskContextForms[Key].clearValidation();
    // });
};

BlackListServiceViewController.prototype.ValidateForms = function ()
{
    // var _this = this;
    //
    // var valid = true;
    //
    // var form = this.Views.CreateTaskContextForms.CreateTaskContextForm;
    //
    // var el = form.elements;
    //
    // if(!el.target.validate())
    // {
    //     var text = LangHelper.GetString(this.Id,"You should set ip addresses or CIDRs");
    //     webix.message({text:text, type:"debug"});
    //     valid = false;
    //     return false;
    // }
    //
    // // if(el.redirect_enabled.getValue())
    // // {
    // //     valid = el.redirect.validate();
    // // }
    //
    // if(!el.redirect.validate())
    // {
    //     var text = LangHelper.GetString(this.Id,"You should set url to redirect");
    //     webix.message({text:text, type:"debug"});
    //     valid = false;
    //     return false;
    // }
    //
    // // if(el.white.getValue() == BlTaskTypeEnum.white)
    // // {
    // //     valid = el.redirect_enabled.validate();
    // // }
    //
    // // if(!redirect_enabled.validate())
    // // {
    // //     var text = LangHelper.GetString(this.Id,"You should set url to redirect when white list is enabled");
    // //     webix.message({text:text, type:"debug"});
    // //     valid = false;
    // //     return false;
    // // }
    //
    // return valid;
};

BlackListServiceViewController.prototype.SaveTask = function (FormData)
{
    var _this = this;

    var taskData = this.GetTasksTableSelectedData();

    taskData.valid = true;

    var formData = new BlTaskFormModel(FormData);

    this.ViewModel.SaveTask(
        {
            task:taskData,
            task_form:formData,
            callback:function (R)
            {
                if(R.success && R.data && R.data.task)
                {
                    _this.Views.TasksTable.updateItem(taskData.id,  new BlTaskModel(R.data.task));

                    webix.message(LangHelper.GetString(_this.Id,"Profile saved"));
                }
                else
                {
                    taskData.valid = false;

                    _this.Views.TasksTable.validate(taskData.id);

                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
                _this.UpdateDics(taskData.white ? "5" : "4");
                _this.OnTasksTableRowSelect();
            }
        }
    );

    this.Views.TasksTable.validate(taskData.id);
};

BlackListServiceViewController.prototype.DeleteTask = function (RowId)
{
    var _this = this;

    var taskData = this.Views.TasksTable.getItem(RowId);
    taskData.valid = true;

    if(taskData.task_id > 0)
    {
        this.ViewModel.DeleteTask({task:taskData, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.TasksTable.remove(RowId);

                    webix.message(LangHelper.GetString("All","Deleted"));
                }
                else
                {
                    taskData.valid = false;
                    _this.Views.TasksTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
                _this.UpdateDics(taskData.white ? "5" : "4");
            }});
    }
    else
    {
        this.Views.TasksTable.remove(RowId);
    }
};

BlackListServiceViewController.prototype.UpdateTasksTable = function (Params)
{
    var _this = this;

    var dic = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);

    this.Views.TasksTable.getColumnConfig("user_id").header[1].options = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);

    this.Views.TasksTable.clearAll();
    this.Views.TasksTable.parse(_this.ViewModel.GetTasks());

    this.Views.TasksTablePagingSize.setValue(this.ViewModel.TasksFilter.total.size);

    this.Views.TasksTablePaging.define(this.ViewModel.TasksFilter.total);
    this.Views.TasksTablePaging.refresh();
};

BlackListServiceViewController.prototype.RefreshTasksTable = function (Page)
{
    var _this = this;

    var state = this.Views.TasksTable.getState();

    var size = this.Views.TasksTablePagingSize.getValue();

    this.ViewModel.RefershTasks({page:Page, filter:state.filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}})

    this.RefreshDics();
};

BlackListServiceViewController.prototype.RefreshDics = function()
{
    App.DicsManager.Refresh({data: [DicsEnum.WhiteListsProfilesDic, DicsEnum.BlackListsProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});
};

BlackListServiceViewController.prototype.AddSubTaskToTasksTable = function ()
{
    var _this = this;

    var selectedModel = _this.GetTasksTableSelectedData();

    if(!selectedModel || !selectedModel.task_id)
        return;

    var model = new BlTaskModel({parent_id:selectedModel.task_id, hardware_id: selectedModel.hardware_id});

    _this.Views.TasksTable.add(model,0,selectedModel.id);
    _this.Views.TasksTable.open(selectedModel.id);

    _this.Views.TasksTable.select(model.id, false);
    _this.Views.TasksTable.showItem(model.id);

    _this.ShowTasksEditForm(model, _this.Views.TasksTable.getItemNode(model.id), "right");
};

BlackListServiceViewController.prototype.TasksTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    var _this = this;

    var _disableAll = function ()
    {
        _this.Views.ListsPanel.disable();

        _this.Views.AddSubTaskBtn.disable();
        _this.Views.PlayBtn.disable();
        _this.Views.StopBtn.disable();

        _this.Views.AddListItemBtn.disable();
        _this.Views.ImportListBtn.disable();

        _this.Views.ListItemsImportContextImportBtn.disable();
        _this.Views.ListItemDeleteContextDeleteBtn.disable();
        _this.Views.ClearListItemBtn.disable();

        _this.SetTaskDataInfoLabel();
        _this.Views.ListItemsTable.clearAll();
    };

    if(Value != 1)
    {
        _disableAll();
        return;
    }

    var selectedData = _this.GetTasksTableSelectedData();

    if(!selectedData || selectedData.remote)
    {
        _disableAll();
        return;
    }

    if(selectedData.task_id)
    {
        _this.Views.ListsPanel.enable();
        // _this.Views.SubsPanel.enable();
        _this.Views.ClearListItemBtn.enable();
        this.SetTaskDataInfoLabel();

        if(!NoRefresh)
        {
            this.RefreshListItems();
            // this.RefreshSubs();
        }

    }
    else
    {
        _this.Views.ListsPanel.disable();
    }

    _this.Views.AddSubTaskBtn.enable();

    switch (parseInt(selectedData.status))
    {
        case BlTaskStatusEnum.disabled:
            if(selectedData.task_id)
            {
                _this.Views.PlayBtn.enable();

                if(!selectedData.remote)
                {
                    _this.Views.AddListItemBtn.enable();
                    _this.Views.ImportListBtn.enable();

                    _this.Views.ListItemsImportContextImportBtn.enable();
                    _this.Views.ListItemDeleteContextDeleteBtn.enable();
                }
            }
            else
            {
                _this.Views.PlayBtn.disable();

                _this.Views.AddListItemBtn.disable();
                _this.Views.ImportListBtn.disable();

                _this.Views.ListItemsImportContextImportBtn.disable();
                _this.Views.ListItemDeleteContextDeleteBtn.disable();
            }
            _this.Views.ClearListItemBtn.enable();
            _this.Views.StopBtn.disable();

            break;

        case BlTaskStatusEnum.enabled:
            _this.Views.PlayBtn.disable();
            _this.Views.StopBtn.enable();

            if(!selectedData.remote)
            {
                _this.Views.AddListItemBtn.enable();
                _this.Views.ImportListBtn.enable();

                _this.Views.ListItemsImportContextImportBtn.enable();
                _this.Views.ListItemDeleteContextDeleteBtn.enable();
            }
            break;
        default:
            break;
    }
};

BlackListServiceViewController.prototype.SetTaskDataInfoLabel = function()
{
    var taskData = this.GetTasksTableSelectedData();

    if(!taskData)
    {
        this.Views.TaskDataInfoLabel.setValue("");
        return;
    }


    var format =  webix.Date.dateToStr("%d.%m.%Y %H:%i");
    var date =  format(taskData.date);

    var status = "";

    if(BlStatusesDic[taskData.status])
    {
        status = "<span class=\"status status_" + taskData.status + "\">" + BlStatusesDic[taskData.status].value + "</span>";
        // status = BlStatusesDic[taskData.status].value;
    }


    var title = taskData.title?taskData.title:LangHelper.GetString(this.Id,"Profile") + " "+taskData.task_id;

    var text = title + " "+LangHelper.GetString(this.Id,"from")+" " + date + ". "+LangHelper.GetString(this.Id,"Status")+": " + status + ".";

    this.Views.TaskDataInfoLabel.setValue(text);
};

BlackListServiceViewController.prototype.RefreshListItems = function (Page)
{
    var _this = this;

    var task = this.GetTasksTableSelectedData();

    if(!task || !task.task_id)
        return;

    var state = this.Views.ListItemsTable.getState();

    var size = this.Views.ListItemsTablePagingSize.getValue();

    this.ViewModel.RefreshListItems({task_id:task.task_id, page:Page, filter:state.filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}})
};

BlackListServiceViewController.prototype.UpdateListItemsTable = function (Params)
{
    var _this = this;

    this.Views.ListItemsTable.clearAll();
    this.Views.ListItemsTable.parse(_this.ViewModel.GetListItems());

    this.Views.ListItemsTablePagingSize.setValue(this.ViewModel.ListItemsFilter.total.size);

    this.Views.ListItemsTablePaging.define(this.ViewModel.ListItemsFilter.total);
    this.Views.ListItemsTablePaging.refresh();
};

BlackListServiceViewController.prototype.AddListItemToListsTable = function ()
{
    var _this = this;

    var task = this.GetTasksTableSelectedData();

    if(!task)
        return;

    var model = new BlListItemModel();

    model.enabled = 1;
    model.task_id = task.task_id;

    _this.Views.ListItemsTable.add(model,0);

    _this.Views.ListItemsTable.select(model.id, false);
    _this.Views.ListItemsTable.showItem(model.id);

    _this.ShowListItemsEditForm(model, _this.Views.ListItemsTable.getItemNode(model.id), "right");
};

BlackListServiceViewController.prototype.GetListItemsTableSelectedData = function ()
{
    return this.Views.ListItemsTable.getSelectedItem();
};

BlackListServiceViewController.prototype.OnListItemsTableRowSelect = function ()
{
    var data = this.GetListItemsTableSelectedData();

    this.ListItemsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

BlackListServiceViewController.prototype.OnListItemsTableRowUnSelect = function ()
{
    var data = this.GetListItemsTableSelectedData();
    this.ListItemsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

BlackListServiceViewController.prototype.ClearListItemsForms = function ()
{
    var _this = this;

    Object.keys(this.Views.CreateListItemContextForms).forEach(function (Key)
    {
        _this.Views.CreateListItemContextForms[Key].clear();
        _this.Views.CreateListItemContextForms[Key].clearValidation();
    });
};

BlackListServiceViewController.prototype.ValidateListItemsForms = function ()
{
    var _this = this;

    var valid = true;

    var form = this.Views.CreateListItemContextForms.CreateListItemContextForm;
    var el = form.elements;

    valid = el.uri.validate();

    return valid;
};

BlackListServiceViewController.prototype.SetListItemsEditFormValues = function (FormData)
{
    if(FormData)
    {
        this.Views.CreateListItemContextForms.CreateListItemContextForm.setValues(new BlListItemModel(FormData, true));
    }
};

BlackListServiceViewController.prototype.ShowListItemsEditForm = function (Data, Node, Pos)
{
    this.ClearListItemsForms();

    if(Data)
    {
        var formParams = new BlListItemModel(Data, true);

        this.SetListItemsEditFormValues(formParams);
    }

    var task = this.GetTasksTableSelectedData();

    // if(task && task.status == BlTaskStatusEnum.enabled)
    // {
    //     this.Views.CreateListItemContextFormSaveBtn.disable();
    // }
    // else
    // {
    //     this.Views.CreateListItemContextFormSaveBtn.enable();
    // }

    this.Views.CreateListItemContext.show(Node, {pos:Pos});
};

BlackListServiceViewController.prototype.DeleteListItem = function (RowId)
{
    var _this = this;

    var listItemData = this.Views.ListItemsTable.getItem(RowId);
    listItemData.valid = true;

    if(listItemData.item_id > 0)
    {
        this.ViewModel.DeleteListItem({list_item:listItemData, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.ListItemsTable.remove(RowId);

                    webix.message(LangHelper.GetString("All","Deleted"));
                }
                else
                {
                    listItemData.valid = false;
                    _this.Views.ListItemsTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
    else
    {
        this.Views.ListItemsTable.remove(RowId);
    }
};

BlackListServiceViewController.prototype.JustSaveListItem = function (ListItemData, Params)
{
    var _this = this;

    ListItemData.valid = true;

    var newListItemData = webix.extend(new BlListItemModel(Params, true), new BlListItemModel(ListItemData));

    this.ViewModel.SaveListItem({list_item:newListItemData, callback:function (R)
        {
            if(R.success && R.data && R.data.list_item)
            {
                _this.Views.ListItemsTable.updateItem(ListItemData.id,  new BlListItemModel(R.data.list_item));

                webix.message(LangHelper.GetString(_this.Id,"List item saved"));
            }
            else
            {
                ListItemData.valid = false;

                _this.Views.ListItemsTable.validate(ListItemData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.OnListItemsTableRowSelect();
        }});
};

BlackListServiceViewController.prototype.SaveListItem = function ()
{
    var _this = this;

    var listItemData = this.GetListItemsTableSelectedData();

    if(this.ValidateListItemsForms())
    {
        this.Views.CreateListItemContext.hide();

        var params = {};

        Object.keys(this.Views.CreateListItemContextForms).forEach(function (Key)
        {
            webix.extend(params, _this.Views.CreateListItemContextForms[Key].getValues());
        });

        this.JustSaveListItem(listItemData, params);

        this.ClearForms();
    }
    else
    {
        listItemData.valid = false;
    }

    this.Views.ListItemsTable.validate(listItemData.id);
};

BlackListServiceViewController.prototype.RunTask = function ()
{
    var _this = this;

    var taskData = this.GetTasksTableSelectedData();

    taskData.valid = true;

    this.ViewModel.RunTask({task:taskData, callback:function (R)
        {
            if(R.success && R.data)
            {
                _this.Views.TasksTable.updateItem(taskData.id,  new BlTaskModel(R.data));

                if(R.data.status == BlTaskStatusEnum.enabled)
                {
                    if (!R.data.file_exists)
                        webix.message({
                            text:LangHelper.GetString(_this.Id,"Classifier categories not applied"),
                            type:"warning"
                        });

                    webix.message(LangHelper.GetString(_this.Id,"Profile enabled"));
                }
                else
                {
                    webix.message({text:LangHelper.GetString(this.Id,"Profile not enabled"), type:"debug"});
                }
            }
            else
            {
                taskData.valid = false;

                _this.Views.TasksTable.validate(taskData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.UpdateDics(taskData.white ? "5" : "4");

            _this.OnTasksTableRowSelect();
        }});
};

BlackListServiceViewController.prototype.StopTask = function ()
{
    var _this = this;

    var taskData = this.GetTasksTableSelectedData();

    taskData.valid = true;

    this.ViewModel.StopTask({task:taskData, callback:function (R)
        {
            if(R.success)
            {
                if(R.data)
                {
                    _this.Views.TasksTable.updateItem(taskData.id,  new BlTaskModel(R.data));

                    webix.message(LangHelper.GetString(_this.Id,"Profile disabled"));
                }
                else
                {
                    webix.message(LangHelper.GetString(_this.Id,"Profile not disabled"));
                }

            }
            else
            {
                taskData.valid = false;

                _this.Views.TasksTable.validate(taskData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.UpdateDics(taskData.white ? ServicesEnum.white_list : ServicesEnum.black_list);

            _this.OnTasksTableRowSelect();
        }});
};

BlackListServiceViewController.prototype.ExportToExcel = function()
{
    webix.toExcel(this.Views.ListItemsTable, {
        filename: LangHelper.GetString(this.Id,"Black and white lists"),
        name: LangHelper.GetString(this.Id,"Black and white lists"),
        filterHTML:true,
        columns:{
            enabled:true,
            type:true,
            uri:true
        }
    });
};

BlackListServiceViewController.prototype.GetListItemsImportTemplate = function()
{
    webix.toExcel(this.Views.ListItemsImportContextTable, {
        filename: LangHelper.GetString(this.Id,"Black and white lists"),
        name: LangHelper.GetString(this.Id,"Black and white lists"),
        filterHTML:true,
        columns:{
            enabled:true,
            type:true,
            uri:true
        }
    });
};

BlackListServiceViewController.prototype.ImportExcelToListItemsImportContextTable = function(ExcelFile)
{
    var _this = this;

    var table = this.Views.ListItemsImportContextTable;

    var ev = table.attachEvent("onAfterLoad",function()
    {
        table.detachEvent(ev);

        var data = table.serialize();

        var dataPrepared = [];

        var lang = LangHelper.GetLocale();
        var types_dic = Helper.DictToArr(BlListItemTypeDic);
        var host_categories = _this.BlClsfrCategories;

        host_categories = host_categories.map(function(dic){
            var name_json = JSON.parse(dic.name_json);
            var name = name_json[lang]?name_json[lang]:(name_json.en?name_json.en:name_json[Object.keys(name_json)[0]]);
            return {id: dic.dic_id ? dic.dic_id : dic.id, value: name};
        });

        var vas_lst = App.DicsManager.GetDicAsArray(DicsEnum.VaseListsDic);

        vas_lst = vas_lst.map(function(dic) {
            var name_json = JSON.parse(dic.value);
            var name = name_json[lang]?name_json[lang]:(name_json.en?name_json.en:name_json[Object.keys(name_json)[0]]);
            return {id: dic.dic_id, value: name};
        })

        data.forEach(function (Row)
        {
            if(Row.type == LangHelper.GetString(_this.Id,"Type") || Row.uri == LangHelper.GetString(_this.Id,"Resource"))
                return;

            if(Row.type == "" && Row.uri == "")
                return;

            var enabled = 1;

            if(Row.enabled == "0" || Row.enabled == OnOffDic["0"])
                enabled = 0;

            var type = BlListItemTypeEnum.url;

            if(BlListItemTypeEnum[Row.type.toLowerCase()])
                type = BlListItemTypeEnum[Row.type.toLowerCase()];
            else{
                if(Row.type.toLowerCase())
                var dicType = types_dic.find(x => x.value.toLowerCase() == Row.type.toLowerCase());
                if(dicType && dicType.id)
                {
                    type = dicType.id
                }

                if(type == BlListItemTypeEnum.clsfr)
                {
                    var host = host_categories.find(x => x.value.toLowerCase() == Row.uri.toLowerCase());
                    if(host && host.id)
                    {
                        Row.uri = host.id;
                    }
                }
                else if(type == BlListItemTypeEnum.vase)
                {
                    var vase_item = vas_lst.find(x => x.value.toLowerCase() == Row.uri.toLowerCase());
                    if(vase_item && vase_item.id)
                    {
                        Row.uri = vase_item.id;
                    }
                }
            }

            var row = {
                data0:enabled,
                data1:type,
                data2:Row.uri
            };

            dataPrepared.push(row);
        });

        table.clearAll();
        table.parse(dataPrepared);

    });

    table.clearAll();
    table.parse(ExcelFile, "excel");

    setTimeout(function ()
    {
        if(table.hasEvent)
        {
            table.detachEvent(ev);
        }
    },3000);
};

BlackListServiceViewController.prototype.SaveImportedExceldata = function()
{
    var _this = this;

    var table = this.Views.ListItemsImportContextTable;

    var taskData = this.GetTasksTableSelectedData();

    var listItems = table.serialize();

    var newListItems = [];

    taskData.valid = true;

    listItems.forEach(function (Item)
    {
        var item = new BlListItemModel(Item);

        item.task_id = taskData.task_id;

        newListItems.push(item);
    });

    const length = listItems.length;
    const chunkSize = 10000;
    var totalImported = 0;
    var fn = function(startIndex)
    {
        if(startIndex >= length)
        {
            _this.OnTasksTableRowSelect();
            return;
        }

        const nextIndex = chunkSize + startIndex;
        const chunk = newListItems.slice(startIndex, nextIndex);

        if(chunk.length > 0)
        {
            _this.ViewModel.ImportListItems({list_items:chunk, callback:function (R)
                {
                    if(R.success)
                    {
                        totalImported += chunk.length;
                        webix.message(LangHelper.GetString(_this.Id,"Successfully imported  rows: ") + totalImported + "/" + length);
                        fn(nextIndex);
                    }
                    else
                    {
                        taskData.valid = false;

                        _this.Views.TasksTable.validate(taskData.id);

                        if(R.error)
                            webix.message({text:R.error.msg,type:"error"});

                        _this.OnTasksTableRowSelect();
                    }
                }});
        }
    }

    fn(0);

    table.clearAll();

    this.Views.TasksTable.validate(taskData.id);
};

BlackListServiceViewController.prototype.DeleteListItemsSelectedRows = function (RowId)
{
    var _this = this;

    var selectedRows = this.GetListItemsTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    selectedRows.forEach(function (Row)
    {
        _this.DeleteListItem(Row.id);
    });
};

BlackListServiceViewController.prototype.ImportListItemsFromQoE = function(Params)
{
  var _this = this;

    var categories = Params && Params.categories ? Params.categories : null;

  if(categories && categories.length > 0)
  {


      var task = _this.GetTasksTableSelectedData();

      this.ViewModel.ImportListItemsFromQoE({
          task: task,
          categories: categories,
          limit: Params && Params.limit ? Params.limit : null,
          callback: function(R)
          {
              if(R.success)
              {
                  webix.message(LangHelper.GetString(_this.Id,"Import of resources from QoE running in background"));
              }
              else
              {
                  task.valid = false;

                  _this.Views.TasksTable.validate(task.id);

                  if(R.error)
                      webix.message({text:R.error.msg,type:"error"});
              }

              _this.OnTasksTableRowSelect();
          }
      });

      return true;
  }
  return false;
};

BlackListServiceViewController.prototype.ImportExcelToSubsImportContextTable = function(ExcelFile)
{
    var _this = this;

    var table = this.Views.SubsImportContextTable;

    var ev = table.attachEvent("onAfterLoad",function()
    {
        table.detachEvent(ev);

        var prepared = [];
        var data = table.serialize();
        data.forEach(function(v,i)
        {
            if(i > 0 && v.target)
            {
                prepared.push(v);
            }
        });
        table.clearAll();
        table.parse(prepared);

    });

    table.clearAll();
    table.parse(ExcelFile, "excel");

    setTimeout(function ()
    {
        if(table.hasEvent)
        {
            table.detachEvent(ev);
        }
    },3000);
};

BlackListServiceViewController.prototype.SaveImportedSubs = function()
{
    var _this = this;

    var table = this.Views.SubsImportContextTable;

    var taskData = this.GetTasksTableSelectedData();

    var subs = table.serialize();

    var newSubs = [];

    taskData.valid = true;

    subs.forEach(function (Item)
    {
        var item = new BlTargetModel(Item);

        item.task_id = taskData.task_id;

        newSubs.push(item);
    });

    this.BlTargetsManager.ImportTargets({targets:newSubs, callback:function (R)
    {
        if(R.success)
        {
            webix.message(LangHelper.GetString(_this.Id,"Imported successfully"));
        }
        else
        {
            taskData.valid = false;

            _this.Views.TasksTable.validate(taskData.id);

            if(R.error)
                webix.message({text:R.error.msg,type:"error"});
        }

        _this.OnTasksTableRowSelect();
    }});

    table.clearAll();

    this.Views.TasksTable.validate(taskData.id);
};

BlackListServiceViewController.prototype.GetSubsImportTemplate = function()
{
    var _this = this;

    webix.toExcel(this.Views.SubsImportContextTable, {
        filename: LangHelper.GetString(this.Id,"Black and white lists subscribers"),
        name: LangHelper.GetString(this.Id,"Black and white lists subscribers"),
        filterHTML:true,
        header: true,
        footer: false,
        columns:{
            target:true
        }
    });
};

BlackListServiceViewController.prototype.UpdateSubsSuggestList = function(Editor)
{
  var list = $$(Editor.config.suggest).getList();

  list.clearAll();

  var subs = Helper.DictToArr(this.SubscribersManager.GetSubscribersAsDic());

  list.parse(subs);
};

BlackListServiceViewController.prototype.RefreshHardwareSubscribers = function(Params)
{
    var _this = this;

    this.SubscribersManager.RefreshSubscribers(Params, App.SessionManager.GetCurrentHardwareId());
};

BlackListServiceViewController.prototype.UpdateDics = function(Service)
{
    var dicEnum = ServicesDicsEnum[Service];

    App.DicsManager.Refresh({data: [dicEnum], filter:App.SessionManager.GetCurrentHardwareId()});
};

BlackListServiceViewController.prototype.ShowCategoriesImportContext = function (Node, Params)
{
    var _this = this;

    var context = new BlackListsQoeImportFromViewController(Params);
    context.ViewDidLoad(Params);

    context.Show(Node, {pos: "bottom"});

    this.Subscriptions.CategoriesImportSaveSignal = context.SaveDataSinal.subscribe(function(Val){
        if(Val)
        {
            _this.ImportListItemsFromQoE(Val);
        }
    });

};

BlackListServiceViewController.prototype.ClearListItems = function()
{
  var _this = this;

  var task = this.GetTasksTableSelectedData();

  if(task && task.task_id)
  {
      this.ViewModel.ClearListItems({
          task: task,
          callback: function(R)
          {
              if(R.success)
              {
                  webix.message(LangHelper.GetString(_this.Id,"All records have been deleted!"));
              }
              else
              {
                  task.valid = false;

                  _this.Views.TasksTable.validate(task.id);

                  if(R.error)
                      webix.message({text:R.error.msg,type:"error"});
              }

              _this.RefreshListItems();
          }
      });
  }
};

BlackListServiceViewController.prototype.SetRichselectVaseList = function()
{
    var _this = this;

    var elements = _this.Views.CreateListItemContextForms.CreateListItemContextForm.elements;
    var uri = elements.uri;

    var dics = App.DicsManager.GetDicAsArray(DicsEnum.VaseListsDic);

    var lang = LangHelper.GetLocale();

    var arr = dics.map(function(dic) {
        var name_json = JSON.parse(dic.value);
        var name = name_json[lang]?name_json[lang]:(name_json.en?name_json.en:name_json[Object.keys(name_json)[0]]);
        return {id: dic.dic_id, value: name};
    })

    var list = uri.getList();
    list.clearAll();
    list.parse(arr);

    uri.enable();
};
function BlackListsQoeImportFromViewController(Params)
{
    var _this = this;

    this.Id = "BlackListService";

    this.id = this.Id + "BlackListsQoeImportFromViewController";

    this.Data = null;

    this.Rows = null;

    this.ShowAsModalForm = true;

    // this.DicsManager = null;

    this.ViewConfig = null;


    this.Context = webix.ui({
        view: "popup",
        width:440,
        height:560,
        body: {
            view: "form",
            id: this.id + "Form",
            borderless: true,
            elements: [
                {
                    template: LangHelper.GetString(this.Id, "Import list items from QoE"),
                    height: 40
                },
                {
                    view:"multiview",
                    id: this.id + "Multiview",
                    cells:[
                        {
                            id: this.id + "TableTab",
                            rows:[
                                {
                                    view:"datatable",
                                    id:this.id+"CategoriesTable",
                                    borderless:true,
                                    checkboxRefresh:true,
                                    columns:[
                                        {
                                            id:"value",
                                            header:[LangHelper.GetString(this.Id, "Category"),""],
                                            fillspace:true,
                                            template: function(obj, common, value)
                                            {
                                                return LangHelper.GetString('QoE', obj.value);
                                            }
                                        },
                                        {
                                            id:"enabled",
                                            // header:LangHelper.GetString(this.Id, "CategoryEnabled"),
                                            header:[LangHelper.GetString(this.Id, "CategoryEnabled"),{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}],
                                            template: function(obj, common, value){
                                                if (value == 1)
                                                    return "<div class='webix_table_checkbox checked'><span class=\"webix_icon fa-check-square\"></span> " + LangHelper.GetString("All", "Yes") + "</div>";
                                                else
                                                    return "<div class='webix_table_checkbox notchecked'><span class=\"webix_icon fa-square\"></span> " + LangHelper.GetString("All", "No") + "</div>";
                                            },
                                            width: 120,
                                            headermenu: false

                                        }
                                    ],
                                    data:App.DicsManager.GetDicAsArray(DicsEnum.HostCategoriesDic)
                                },
                                {
                                    cols:[
                                        {},
                                        {
                                            view:"button",
                                            label:LangHelper.GetString(this.Id,"Cancel"),
                                            click:function ()
                                            {
                                                _this.Hide();
                                            }
                                        },
                                        {
                                            view:"button",
                                            type:"form",
                                            label:LangHelper.GetString(this.Id,"Next"),
                                            click:function()
                                            {
                                                _this.Next();
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: this.id + "LimitTab",
                            rows:[
                                {},
                                {
                                    view:"richselect",
                                    name:"limit",
                                    label:LangHelper.GetString(this.Id, "Number of resources"),
                                    labelPosition: "top",
                                    tooltip:LangHelper.GetString(this.Id, "Number of resources"),
                                    required: true,
                                    value:"10000",
                                    options:
                                        [
                                            {id:"10000", value:LangHelper.GetString(this.Id,"% resources").replace("%","10 000")},
                                            {id:"100000", value:LangHelper.GetString(this.Id,"% resources").replace("%","100 000")},
                                            {id:"1000000", value:LangHelper.GetString(this.Id,"% resources").replace("%","1 000 000")}
                                            // {id:"All", value:LangHelper.GetString(this.Id,"All resources")}
                                        ]
                                },
                                {},
                                {
                                    cols:[
                                        {
                                            view:"button",
                                            label:LangHelper.GetString(this.Id,"Cancel"),
                                            click:function ()
                                            {
                                                _this.Hide();
                                            }
                                        },
                                        {
                                            view:"button",
                                            label:LangHelper.GetString(this.Id,"Back"),
                                            click:function ()
                                            {
                                                _this.Back();
                                            }
                                        },
                                        {
                                            view:"button",
                                            id: this.Id + "ListItemsImportFromQoEBtn",
                                            type:"form",
                                            label:LangHelper.GetString(this.Id,"Import"),
                                            click:function ()
                                            {
                                                if(_this.Save())
                                                    _this.Hide();
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }

            ]
        }
    });

    this.Views = {
        Form: null,
        Table: null,
        Multiview: null,
        TableTab: null,
        LimitTab: null
    };

    this.SaveDataSinal = new Rx.BehaviorSubject(null);

    this.OverlayVisible = false;

    this.Subscriptions = {};

    this.Init(Params);

    return this;
}

BlackListsQoeImportFromViewController.prototype.Init = function (Params)
{
};

BlackListsQoeImportFromViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

BlackListsQoeImportFromViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.Form = $$(this.id + "Form");
    this.Views.Table = $$(this.id + "CategoriesTable");
    this.Views.Multiview = $$(this.id + "Multiview");
    this.Views.TableTab = $$(this.id + "TableTab");
    this.Views.LimitTab = $$(this.id + "LimitTab");

    if(this.Context)
    {
        this.Context.attachEvent("onHide", function()
        {
            _this.Destroy();
        });
    }
};

BlackListsQoeImportFromViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node, {pos:Pos});
};

BlackListsQoeImportFromViewController.prototype.Hide = function()
{
    this.Context.hide();
};

BlackListsQoeImportFromViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

BlackListsQoeImportFromViewController.prototype.Save = function()
{
    var _this = this;

    var val = this.Views.Form.getValues();

    var categories = this.Views.Table.serialize();

    categories = categories.filter(
        function(Obj){
            return Obj.enabled == 1;
        }
    );

    if(categories && categories.length > 0)
    {
        var arr = [];
        categories.forEach(
            function(Val)
            {
                arr.push(Val.dic_id);
            }
        );

        this.SaveDataSinal.next({
            categories: arr.join(','),
            limit: val.limit ? val.limit : "All"
        });
        return true;
    }
    webix.message({text:LangHelper.GetString(this.Id, "Please select at least one category."),type:"error"});
    this.Back();
    return false;
};

BlackListsQoeImportFromViewController.prototype.Next = function()
{
    var _this = this;
    // var parent = this.Views.Multiview.getValue();
    // var index = this.Views.Multiview.index(parent);
    var next = this.Views.Multiview.getChildViews()[1];

    if(next)
        next.show();
};
BlackListsQoeImportFromViewController.prototype.Back = function()
{
    var _this = this;

    var next = this.Views.Multiview.getChildViews()[0];

    if(next)
        next.show();

};

/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */
function AdBlockRedirectServiceViewController(Params)
{
    var _this = this;

    this.Id = "AdBlockRedirectService";

    this.ViewModel = new AdBRLManager();

    this.ListItemsDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ListItemsDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ListItemsDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ListItemsDeleteContext.hide();

                                _this.DeleteListItemsSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.EraseListContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to remove all list items?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.EraseListContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "EraseListContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Remove all"),
                            click:function ()
                            {
                                _this.EraseListContext.hide();

                                _this.EraseList();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateListItemContextFormConfig = {
        view: "popup",
        id: this.Id + "CreateListItemContext",
        width: 440,
        height: 480,
        body:{
            rows:[
                {
                    id:this.Id + "CreateListItemContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "text",
                            name: "uri",
                            labelWidth:104,
                            label: LangHelper.GetString(this.Id,"Resource"),
                            tooltip:LangHelper.GetString(this.Id,"Resource"),
                            invalidMessage: LangHelper.GetString(this.Id, "Resource field should be valid"),
                            validate: function(Val)
                            {
                                if(!Val)
                                    return false;

                                return Helper.IsBlackListItemUrlValid(Val);
                            }
                        },
                        {
                            view: "checkbox",
                            name: "enabled",
                            label: LangHelper.GetString(this.Id,"Enabled"),
                            tooltip:LangHelper.GetString(this.Id,"Enabled"),
                            value:0,
                            labelWidth:104
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString(this.Id,"Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.CreateListItemContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "CreateListItemContextFormSaveBtn",
                                    type:"form",
                                    label:LangHelper.GetString(this.Id,"Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.SaveListItem();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };


    this.ListItemsImportContext = webix.ui({
        view:"popup",
        width:720,
        height:720,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"ListItemsImportContextForm",
            borderless:true,
            elements:[
                {
                    view: "uploader",
                    value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                    id: this.Id+"ListItemsImportContext" + "Uploader",
                    css:"upload_area",
                    autosend:false,
                    height:64
                },
                {
                    view:"datatable",
                    id:this.Id+"ListItemsImportContext" + "Table",
                    checkboxRefresh:true,
                    columns:[
                        {
                            id: "enabled",
                            header: ["", {
                                content: "richSelectFilter",
                                options: Helper.DictToArr(OnOffDic),
                                inputConfig: {suggest: {fitMaster: false}}
                            }],
                            template: CellOnOffTemplate,
                            width: 72,
                            headermenu: false
                        },
                        {
                            id: "uri",
                            header: [LangHelper.GetString(_this.Id,"Resource"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            editor: "text",
                            fillspace: true
                        },
                        {
                            id: "trash",
                            header: "",
                            width: 32,
                            template: CellTrashBtnTemplate,
                            headermenu: false
                        }
                    ],
                    scheme:{
                        $init:function(obj){
                            obj.enabled = obj.data0;
                            obj.uri = obj.data1;
                        }
                    },
                    on: {
                        onItemClick: function (id, e, node)
                        {
                            if (id.column === 'trash')
                            {
                                this.remove(id);
                            }
                        }
                    }
                },
                {
                    cols:[
                        {
                            view: "button",
                            label: LangHelper.GetString(_this.Id, "Get template"),
                            click: function()
                            {
                                _this.GetListItemsImportTemplate();
                            }
                        },
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ListItemsImportContext.hide();
                                _this.Views.ListItemsImportContextTable.clearAll();
                                // _this.Views.ImportContextCodeEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            id:this.Id + "ListItemsImportContext" + "ImportBtn",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Import"),
                            click:function ()
                            {
                                _this.ListItemsImportContext.hide();

                                _this.SaveImportedExcelData();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.UpdateParamsContextId = this.Id + "UpdateParamsContext";
    this.UpdateParamsContext = webix.ui({
        view:"submenu",
        id:this.UpdateParamsContextId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.UpdateParamsContextId+"RestartDpi", icon: "retweet", value: LangHelper.GetString("AppView", "Restart fastdpi")},
            {id: this.UpdateParamsContextId+"ReloadDpi", icon: "bolt", value: LangHelper.GetString("AppView","Updating hot options")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                if(id === _this.UpdateParamsContextId+"RestartDpi")
                {
                    setTimeout(function ()
                    {
                        var node = _this.Views.OptionsUpdateBtn.getNode();
                        _this.HardwareRestartContext.show(node, {pos: "bottom"});
                    }, 10);
                }
                else if(id === _this.UpdateParamsContextId+"ReloadDpi")
                {
                    var node = _this.Views.OptionsUpdateBtn.getNode();
                    _this.HardwareReloadContext.show(node, {pos: "bottom"});
                }
            }
        }
    });

    this.HardwareRestartContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("AppView", "Are you sure you want to restart the fastdpi process?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("AppView", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("AppView", "Restart"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                                App.SessionManager.RestartHardware();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HardwareReloadContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("AppView", "Are you sure you want to update the hot settings?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("AppView", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("AppView", "Refresh"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                                App.SessionManager.ReloadHardware();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ValidationDataContext = webix.ui({
        view:"popup",
        width:800,
        height:600,
        body:{
            id:this.Id + "ValidationDataContext",
            borderless:true,
            rows:[
                {
                    view:"codemirror-editor",
                    id:this.Id + "ValidationDataContext" + "CodeEditor",
                    value:""
                },
                {
                    view:"toolbar",
                    borderless:true,
                    elements:[
                        {
                            gravity:2
                        },
                        {
                            view:"button",
                            label:LangHelper.GetString("DpiConfig","Close"),
                            click:function ()
                            {
                                _this.ValidationDataContext.hide();
                                _this.Views.ValidationDataContextCodeEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            label:LangHelper.GetString("DpiConfig","Save without verification"),
                            type:"form",
                            click:function ()
                            {
                                _this.ValidationDataContext.hide();
                                _this.Views.ValidationDataContextCodeEditor.setValue("");
                                _this.ConfigSave();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols:[
                {
                    id:this.Id + "ListsPanel",
                    rows:[
                        {
                            view: "toolbar",
                            height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                            padding: 0,
                            margin: 0,
                            elements: [
                                {
                                    view: "button",
                                    id:this.Id + "AddListItemBtn",
                                    type: "icon",
                                    icon: "plus",
                                    align: "right",
                                    width: 32,
                                    css:"toolbar_round_btn",
                                    tooltip:LangHelper.GetString(this.Id,"Add list item"),
                                    click: function (id, e, node)
                                    {
                                        _this.AddListItemToListsTable();
                                    }
                                },
                                {
                                    width:24
                                },
                                {
                                    view: "button",
                                    id:this.Id+"DelListItemBtn",
                                    type: "icon",
                                    icon: "trash",
                                    css:"toolbar_round_btn",
                                    width:32,
                                    tooltip:LangHelper.GetString(this.Id, "Delete"),
                                    disabled:true,
                                    click:function (id,e,node)
                                    {
                                        var __this = this;
                                        setTimeout(function () {
                                            var node = __this.getNode(id);
                                            _this.ListItemsDeleteContext.show(node, {pos:"bottom"});
                                        }, 10);
                                    }
                                },
                                {
                                    view: "button",
                                    id:this.Id+"EraseListBtn",
                                    type: "icon",
                                    icon: "eraser",
                                    css:"toolbar_round_btn",
                                    width:32,
                                    tooltip:LangHelper.GetString(this.Id, "Remove all"),
                                    click:function (id,e,node)
                                    {
                                        var __this = this;
                                        setTimeout(function () {
                                            var node = __this.getNode(id);
                                            _this.EraseListContext.show(node, {pos:"bottom"});
                                        }, 10);
                                    }
                                },
                                {
                                    width:24
                                },
                                {
                                    view: "button",
                                    id:this.Id + "ImportListFromQoEBtn",
                                    type: "icon",
                                    icon: "cloud-upload",
                                    css:"toolbar_round_btn",
                                    // template:"<span class='fas fa-cloud-download-alt'></span>",
                                    width:32,
                                    tooltip:LangHelper.GetString(this.Id,"Import categories from QoE"),
                                    click:function (id,e,node)
                                    {
                                        var __this = this;
                                        setTimeout(function () {
                                            var node = __this.getNode(id);
                                            _this.ShowCategoriesImportContext(node, {pos: "bottom"});
                                        }, 10);
                                    }
                                },
                                {
                                    view: "button",
                                    id:this.Id + "ImportListBtn",
                                    type: "icon",
                                    icon: "upload",
                                    css:"toolbar_round_btn",
                                    width:32,
                                    tooltip:LangHelper.GetString(this.Id,"Import from file"),
                                    click:function (id,e,node)
                                    {
                                        var __this = this;
                                        setTimeout(function () {
                                            var node = __this.getNode(id);
                                            _this.ListItemsImportContext.show(node, {pos: "bottom"});
                                            _this.Views.ListItemsImportContextTable.clearAll();
                                        }, 10);
                                    }
                                },
                                {
                                    view: "button",
                                    id:this.Id + "ExcelExportListBtn",
                                    type: "icon",
                                    icon: "file-excel",
                                    css:"toolbar_round_btn",
                                    width:32,
                                    tooltip:LangHelper.GetString(this.Id,"Export to Excel"),
                                    click:function (id,e,node)
                                    {
                                        _this.ExportToExcel();
                                    }
                                },
                                {},
                                {
                                    view: "button",
                                    id:this.Id+"ListItemsRefreshBtn",
                                    type: "icon",
                                    icon: "refresh",
                                    css: "toolbar_round_btn",
                                    width: 32,
                                    tooltip: LangHelper.GetString("All","Refresh"),
                                    click: function (id, e, node)
                                    {
                                        _this.RefreshListItems(0);
                                    }
                                }
                            ]
                        },
                        BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Advertising & Ad blocking lists"), icon:"file"}),
                        {
                            view: "datatable",
                            id: this.Id + "ListItemsTable",
                            select: "row",
                            multiselect:true,
                            editable: true,
                            editaction:"custom",
                            resizeColumn: true,
                            tooltip:true,
                            checkboxRefresh:true,
                            form:this.Id + "CreateListItemContextForm",
                            on: {
                                onItemClick: function (id,e,node)
                                {
                                    var rowData = this.getItem(id);

                                    if (id.column === 'edit')
                                    {
                                        this.select(id); //reset if multiple rows selected

                                        _this.ShowListItemsEditForm(rowData, this.getItemNode(id), "right");
                                    }

                                    else if(id.column === 'trash')
                                    {
                                        var __this = this;

                                        this.select(id); //reset if multiple rows selected

                                        var data = _this.Views.ListItemsTable.getItem(id);

                                        if(!data.item_id)
                                        {
                                            _this.DeleteListItem(id);
                                            return;
                                        }

                                        setTimeout(function ()
                                        {
                                            var node = __this.getItemNode(id);
                                            _this.ListItemsDeleteContext.show(node, {pos:"bottom"});
                                        }, 10);
                                    }
                                },
                                onItemDblClick: function (id)
                                {
                                    this.select(id); //reset if multiple rows selected

                                    var rowData = this.getItem(id);
                                    _this.ShowListItemsEditForm(rowData, this.getItemNode({column:"edit", row:id.row}), "right");
                                },
                                onBeforeFilter:function()
                                {
                                    return false;
                                },
                                onAfterFilter:function()
                                {
                                    _this.RefreshListItems();
                                },
                                onBeforeSort:function()
                                {
                                    _this.RefreshListItems();
                                    return false;
                                },
                                onAfterSelect:function ()
                                {
                                    _this.OnListItemsTableRowSelect();
                                },
                                onAfterUnSelect:function ()
                                {
                                    _this.OnListItemsTableRowUnSelect();
                                },
                                onCheck:function(row, column, state)
                                {
                                    var rowData = this.getItem(row);

                                    rowData.enabled = state;

                                    _this.JustSaveListItem(rowData, rowData);
                                }
                            },
                            columns: [
                                {
                                    id: "edit",
                                    header: "",
                                    width: 32,
                                    template: CellEditBtnTemplate,
                                    headermenu: false
                                },
                                {
                                    id: "enabled",
                                    header: ["", {
                                        content: "richSelectFilter",
                                        options: Helper.DictToArr(OnOffDic),
                                        inputConfig: {suggest: {fitMaster: false}}
                                    }],
                                    template: CellOnOffTemplate,
                                    width: 72,
                                    headermenu: false
                                },
                                {
                                    id: "uri",
                                    header: [LangHelper.GetString(_this.Id,"Resource"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                    sort: "string",
                                    editor: "text",
                                    fillspace: true
                                },
                                {
                                    id: "trash",
                                    header: "",
                                    width: 32,
                                    template: CellTrashBtnTemplate,
                                    headermenu: false
                                }
                            ],
                            data:[]
                        },
                        {
                            view: "toolbar",
                            padding: 0,
                            margin: 0,
                            height:32,
                            elements: [
                                {
                                    view: "pager",
                                    gravity:3,
                                    id: this.Id + "ListItemsTable" + "Paging",
                                    template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                    master:false,
                                    on: {
                                        onAfterPageChange:function(Page)
                                        {
                                            _this.RefreshListItems(Page);
                                        }
                                    }
                                },
                                {
                                    view:"richselect",
                                    id: this.Id + "ListItemsTable" + "Paging" + "Size",
                                    label:LangHelper.GetString(_this.Id, "On page"),
                                    labelWidth:120,
                                    minWidth:220,
                                    value:100,
                                    options:PagingSizeOptions,
                                    on: {
                                        onChange:function()
                                        {
                                            _this.RefreshListItems();
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    id: this.Id + "Group_6",
                    rows:[
                        {
                            view: "toolbar",
                            height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                            elements: [
                                {
                                    view: "button",
                                    type: "icon",
                                    icon: "floppy-o",
                                    label: LangHelper.GetString("AppView", "Save"),
                                    css: "toolbar_round_btn",
                                    width: 128,
                                    tooltip: LangHelper.GetString("AppView", "Save"),
                                    click: function (id, e, node)
                                    {
                                        var __this = this;
                                        setTimeout(function () {
                                            //var node = __this.getNode(id);
                                            //_this.SaveContext.show(node, {pos: "bottom"});
                                            _this.SaveAdBRLConfig();
                                        }, 1);
                                    }
                                },
                                {
                                    view: "button",
                                    id:this.Id + "OptionsUpdateBtn",
                                    type: "icon",
                                    icon: "retweet",
                                    css: "toolbar_round_btn",
                                    width: 32,
                                    tooltip: LangHelper.GetString("AppView", "Updating options"),
                                    click: function (id, e, node)
                                    {
                                        var __this = this;
                                        setTimeout(function () {
                                            var node = __this.getNode(id);
                                            _this.UpdateParamsContext.show(node, {pos: "bottom"});
                                        }, 1);
                                    }
                                },
                                {},
                                {
                                    view: "button",
                                    type: "icon",
                                    icon: "refresh",
                                    css: "toolbar_round_btn",
                                    width: 32,
                                    tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                    click: function (id, e, node)
                                    {
                                        var hConnected = App.SessionManager.IsCurrentHardwareConnected();

                                        if(hConnected)
                                        {
                                            //App.NavRouter.ShowProgress();
                                            _this.RefreshAdBRLConfig();
                                        }
                                        else
                                        {
                                            webix.message({type:"error", text:LangHelper.GetString(_this.Id, "No connection")});
                                        }
                                    }
                                }
                            ]
                        },
                        BlockHeaderTemplate({
                            title: LangHelper.GetString(this.Id,"Config"),
                            icon: "cog"
                        }),
                        {
                            id:this.Id + "ConfigForm",
                            view:"form",
                            elements:[
                                {

                                    "cols":[
                                        {
                                            "view":"text",
                                            "name":"ad_server",
                                            "label":LangHelper.GetString("Dics","The content server (ad_server)"),
                                            "tooltip":LangHelper.GetString("Dics","The name or address of the server from which new content is delivered (ad_server)"),
                                            "placeholder":"www.someserver.com",
                                            "labelPosition":"top",
                                            "invalidMessage": LangHelper.GetString("Dics","Enter the server name or address")
                                        },
                                        {
                                            "view":"button",
                                            "type":"icon",
                                            "icon":"question-circle",
                                            "css":"toolbar_round_btn",
                                            "width":32,
                                            "popup":{
                                                "view":"popup",
                                                "height":0,
                                                "body":{
                                                    "borderless":true,
                                                    "template":LangHelper.GetString("Dics","The name or address of the server from which new content is delivered (ad_server)")
                                                }
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {}
                    ]
                }
            ]
        }
    ];

    this.Views = {

        ListsPanel:null,

        AddListItemBtn: null,
        DelListItemBtn:null,
        ImportListBtn: null,

        ListItemsTable:null,
        ListItemsTablePaging:null,
        ListItemsTablePagingSize:null,

        CreateListItemContext:null,
        CreateListItemContextForms:{
            CreateListItemContextForm:null
        },
        CreateListItemContextFormSaveBtn:null,

        ListItemsImportContextUploader:null,
        ListItemsImportContextTable:null,

        ListItemsImportContextImportBtn:null,
        ListItemsDeleteContextDeleteBtn:null,

        ConfigForm:null,
        ValidationDataContextCodeEditor:null,
        OptionsUpdateBtn:null

    };

    this.ListItemsTableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};
}

AdBlockRedirectServiceViewController.prototype.Destroy = function ()
{
    var _this = this;

    //App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.ViewModel.Destroy();
    delete this.ViewModel;
};

AdBlockRedirectServiceViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    // webix.ready(function () {
    //     $$(_this.Id + "LeftSideBar").select(_this.Id);
    // });

    this.BindAll();

    // this.CheckHealth();
};

AdBlockRedirectServiceViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ListsPanel = $$(this.Id+"ListsPanel");

    this.Views.AddListItemBtn = $$(this.Id + "AddListItemBtn");
    this.Views.DelListItemBtn = $$(this.Id + "DelListItemBtn");
    this.Views.EraseListBtn = $$(this.Id + "EraseListBtn");
    this.Views.ImportListBtn = $$(this.Id + "ImportListBtn");

    this.Views.ListItemsTable = $$(this.Id + "ListItemsTable");
    this.Views.ListItemsTablePaging = $$(this.Id + "ListItemsTable" + "Paging");
    this.Views.ListItemsTablePagingSize = $$(this.Id + "ListItemsTable" + "Paging" + "Size");

    this.Views.CreateListItemContext = webix.ui(this.CreateListItemContextFormConfig);
    this.Views.CreateListItemContextForms.CreateListItemContextForm = $$(this.Id+"CreateListItemContextForm");
    this.Views.CreateListItemContextFormSaveBtn = $$(this.Id+"CreateListItemContextFormSaveBtn");

    this.Views.ListItemsImportContextUploader = $$(this.Id + "ListItemsImportContextUploader");
    this.Views.ListItemsImportContextTable = $$(this.Id + "ListItemsImportContextTable");

    this.Views.ListItemsImportContextImportBtn = $$(this.Id + "ListItemsImportContextImportBtn");
    this.Views.ListItemsDeleteContextDeleteBtn = $$(this.Id + "ListItemsDeleteContextDeleteBtn");

    this.Views.ValidationDataContextCodeEditor = $$(this.Id + "ValidationDataContext" + "CodeEditor");

    this.Views.OptionsUpdateBtn = $$(this.Id + "OptionsUpdateBtn");

    this.Views.ConfigForm = $$(this.Id + "ConfigForm");

    this.Subscriptions.SignalListItemsUpdatedSubscription = this.ViewModel.SignalListItemsUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateListItemsTable();
        }
    });

    this.Subscriptions.SignalListItemUpdatedSubscription = this.ViewModel.SignalListItemUpdated.subscribe(function (ListItem)
    {
        if(ListItem)
        {
            var selectedData = _this.GetListItemsTableSelectedData();

            var rows = _this.Views.ListItemsTable.find(function(obj)
            {
                return obj.item_id == ListItem.item_id;
            });

            if(rows && rows.length == 1)
            {
                _this.Views.ListItemsTable.updateItem(rows[0].id,  ListItem);

                if(selectedData && selectedData.item_id == ListItem.item_id && ListItem.status != 0)
                {
                    _this.OnListItemsTableRowSelect();
                }
            }
        }
    });

    this.Views.ListItemsImportContextUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        _this.ImportExcelToListItemsImportContextTable(FileObj.file);
    });

    this.Subscriptions.ListItemsTableRowsSelectedCountSubscription = this.ListItemsTableRowsSelectedCount.subscribe(function (Value)
    {
        if(Value > 1)
        {
            _this.Views.DelListItemBtn.enable();
        }
        else
        {
            _this.Views.DelListItemBtn.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshListItems();
        }
    });

    this.Subscriptions.HardwareConnected = App.SessionManager.CurrentHardwareConnected.subscribe(function (CurrentHardwareConnected)
    {
        if (CurrentHardwareConnected)
        {
            //App.NavRouter.ShowProgress();
            _this.RefreshAdBRLConfig();
        }
    });

};

AdBlockRedirectServiceViewController.prototype.RefreshListItems = function (Page)
{
    var _this = this;

    var state = this.Views.ListItemsTable.getState();

    var size = this.Views.ListItemsTablePagingSize.getValue();

    this.ViewModel.RefreshListItems({hardware_id: App.SessionManager.GetCurrentHardwareId(), page:Page, filter:state.filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}})
};

AdBlockRedirectServiceViewController.prototype.UpdateListItemsTable = function (Params)
{
    var _this = this;

    this.Views.ListItemsTable.clearAll();
    this.Views.ListItemsTable.parse(_this.ViewModel.GetListItems());

    this.Views.ListItemsTablePagingSize.setValue(this.ViewModel.ListItemsFilter.total.size);

    this.Views.ListItemsTablePaging.define(this.ViewModel.ListItemsFilter.total);
    this.Views.ListItemsTablePaging.refresh();
};

AdBlockRedirectServiceViewController.prototype.AddListItemToListsTable = function ()
{
    var _this = this;

    var model = new AdBRLListItemModel();

    model.enabled = 1;
    model.hardware_id = App.SessionManager.GetCurrentHardwareId();

    _this.Views.ListItemsTable.add(model,0);

    _this.Views.ListItemsTable.select(model.id, false);
    _this.Views.ListItemsTable.showItem(model.id);

    _this.ShowListItemsEditForm(model, _this.Views.ListItemsTable.getItemNode(model.id), "right");
};

AdBlockRedirectServiceViewController.prototype.GetListItemsTableSelectedData = function ()
{
    return this.Views.ListItemsTable.getSelectedItem();
};

AdBlockRedirectServiceViewController.prototype.OnListItemsTableRowSelect = function ()
{
    var data = this.GetListItemsTableSelectedData();

    this.ListItemsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

AdBlockRedirectServiceViewController.prototype.OnListItemsTableRowUnSelect = function ()
{
    var data = this.GetListItemsTableSelectedData();
    this.ListItemsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

AdBlockRedirectServiceViewController.prototype.ClearListItemsForms = function ()
{
    var _this = this;

    Object.keys(this.Views.CreateListItemContextForms).forEach(function (Key)
    {
        _this.Views.CreateListItemContextForms[Key].clear();
        _this.Views.CreateListItemContextForms[Key].clearValidation();
    });
};

AdBlockRedirectServiceViewController.prototype.ValidateListItemsForms = function ()
{
    var _this = this;

    var valid = true;

    var form = this.Views.CreateListItemContextForms.CreateListItemContextForm;
    var el = form.elements;

    valid = el.uri.validate();

    return valid;
};

AdBlockRedirectServiceViewController.prototype.SetListItemsEditFormValues = function (FormData)
{
    if(FormData)
    {
        this.Views.CreateListItemContextForms.CreateListItemContextForm.setValues(new AdBRLListItemModel(FormData, true));
    }
};

AdBlockRedirectServiceViewController.prototype.ShowListItemsEditForm = function (Data, Node, Pos)
{
    this.ClearListItemsForms();

    if(Data)
    {
        var formParams = new AdBRLListItemModel(Data, true);

        this.SetListItemsEditFormValues(formParams);
    }

    this.Views.CreateListItemContext.show(Node, {pos:Pos});
};

AdBlockRedirectServiceViewController.prototype.DeleteListItem = function (RowId)
{
    var _this = this;

    var listItemData = this.Views.ListItemsTable.getItem(RowId);
    listItemData.valid = true;

    if(listItemData.item_id > 0)
    {
        this.ViewModel.DeleteListItem({list_item:listItemData, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.ListItemsTable.remove(RowId);

                    webix.message(LangHelper.GetString("All","Deleted"));
                }
                else
                {
                    listItemData.valid = false;
                    _this.Views.ListItemsTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
    else
    {
        this.Views.ListItemsTable.remove(RowId);
    }
};

AdBlockRedirectServiceViewController.prototype.JustSaveListItem = function (ListItemData, Params)
{
    var _this = this;

    ListItemData.valid = true;

    var newListItemData = webix.extend(new AdBRLListItemModel(Params, true), new AdBRLListItemModel(ListItemData));

    this.ViewModel.SaveListItem({list_item:newListItemData, callback:function (R)
        {
            if(R.success && R.data && R.data.list_item)
            {
                _this.Views.ListItemsTable.updateItem(ListItemData.id,  new AdBRLListItemModel(R.data.list_item));

                webix.message(LangHelper.GetString(_this.Id,"List item saved"));
            }
            else
            {
                ListItemData.valid = false;

                _this.Views.ListItemsTable.validate(ListItemData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.OnListItemsTableRowSelect();
        }});
};

AdBlockRedirectServiceViewController.prototype.SaveListItem = function ()
{
    var _this = this;

    var listItemData = this.GetListItemsTableSelectedData();

    if(this.ValidateListItemsForms())
    {
        this.Views.CreateListItemContext.hide();

        var params = {};

        Object.keys(this.Views.CreateListItemContextForms).forEach(function (Key)
        {
            webix.extend(params, _this.Views.CreateListItemContextForms[Key].getValues());
        });

        this.JustSaveListItem(listItemData, params);
    }
    else
    {
        listItemData.valid = false;
    }

    this.Views.ListItemsTable.validate(listItemData.id);
};

AdBlockRedirectServiceViewController.prototype.ExportToExcel = function()
{
    webix.toExcel(this.Views.ListItemsTable, {
        filename: LangHelper.GetString(this.Id,"Advertising & Ad blocking lists"),
        name: LangHelper.GetString(this.Id,"Advertising & Ad blocking lists"),
        filterHTML:true,
        columns:{
            enabled:true,
            uri:true
        }
    });
};

AdBlockRedirectServiceViewController.prototype.GetListItemsImportTemplate = function()
{
    webix.toExcel(this.Views.ListItemsImportContextTable, {
        filename: LangHelper.GetString(this.Id,"Advertising & Ad blocking lists"),
        name: LangHelper.GetString(this.Id,"Advertising & Ad blocking lists"),
        filterHTML:true,
        columns:{
            enabled:true,
            uri:true
        }
    });
};

AdBlockRedirectServiceViewController.prototype.ImportExcelToListItemsImportContextTable = function(ExcelFile)
{
    var _this = this;

    var table = this.Views.ListItemsImportContextTable;

    var ev = table.attachEvent("onAfterLoad",function()
    {
        table.detachEvent(ev);

        var data = table.serialize();

        var dataPrepared = [];

        data.forEach(function (Row)
        {
            if(Row.uri == LangHelper.GetString(_this.Id,"Resource"))
                return;

            if(Row.uri == "")
                return;

            var enabled = 1;

            if(Row.enabled == "0" || Row.enabled == OnOffDic["0"])
                enabled = 0;

            var row = {
                data0:enabled,
                data1:Row.uri
            };

            dataPrepared.push(row);
        });

        table.clearAll();
        table.parse(dataPrepared);

    });

    table.clearAll();
    table.parse(ExcelFile, "excel");

    setTimeout(function ()
    {
        if(table.hasEvent)
        {
            table.detachEvent(ev);
        }
    },3000);
};

AdBlockRedirectServiceViewController.prototype.SaveImportedExcelData = function()
{
    var _this = this;

    var table = this.Views.ListItemsImportContextTable;

    var listItems = table.serialize();

    var newListItems = [];

    var hardware_id = App.SessionManager.GetCurrentHardwareId();

    listItems.forEach(function (Item)
    {
        var item = new AdBRLListItemModel(Item);

        item.hardware_id = hardware_id;

        newListItems.push(item);
    });

    this.ViewModel.ImportListItems({list_items:newListItems, callback:function (R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString(_this.Id,"Imported successfully"));
                _this.RefreshListItems();
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});

    table.clearAll();
};

AdBlockRedirectServiceViewController.prototype.DeleteListItemsSelectedRows = function (RowId)
{
    var _this = this;

    var selectedRows = this.GetListItemsTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    selectedRows.forEach(function (Row)
    {
        _this.DeleteListItem(Row.id);
    });
};

AdBlockRedirectServiceViewController.prototype.EraseList = function ()
{
    var _this = this;

    this.ViewModel.EraseList({hardware_id: App.SessionManager.GetCurrentHardwareId(), callback:function (R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString("All","Removed"));
                _this.RefreshListItems();
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
};

AdBlockRedirectServiceViewController.prototype.ImportListItemsFromQoE = function(Params)
{
  var _this = this;

  var categories = Params && Params.categories ? Params.categories : null;

  if(categories && categories.length > 0)
  {
      this.ViewModel.ImportListItemsFromQoE({
          hardware_id: App.SessionManager.GetCurrentHardwareId(),
          categories: categories,
          max: Params && Params.limit ? Params.limit : null,
          callback: function(R)
          {
              if(R.success)
              {
                  webix.message(LangHelper.GetString(_this.Id,"The task of importing successfully launched"));
              }
              else
              {
                  if(R.error)
                      webix.message({text:R.error.msg,type:"error"});
              }
          }
      });

      return true;
  }
  return false;
};

AdBlockRedirectServiceViewController.prototype.ShowCategoriesImportContext = function (Node, Params)
{
    var _this = this;

    var context = new BlackListsQoeImportFromViewController(Params);
    context.ViewDidLoad(Params);

    context.Show(Node, {pos: "bottom"});

    this.Subscriptions.CategoriesImportSaveSignal = context.SaveDataSinal.subscribe(function(Val){
        if(Val)
        {
            _this.ImportListItemsFromQoE(Val);
        }
    });

};

AdBlockRedirectServiceViewController.prototype.RefreshAdBRLConfig = function ()
{
    var _this = this;

    this.ViewModel.RefreshAdBRLConfig({callback:function (R)
    {
        if(!R.success)
        {
            webix.message({type:"error", text:R.error.msg});
            return;
        }

        _this.Views.ConfigForm.setValues(R.data);

    }});
};

AdBlockRedirectServiceViewController.prototype.SaveAdBRLConfig = function ()
{
    var _this = this;

    var form = this.Views.ConfigForm;

    if(!form.validate())
        return;


    var fValues = form.getValues();

    this.ViewModel.SaveAdBRLConfig({ad_server:fValues.ad_server, callback:function (R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig", "Configuration saved"));
            }
            else
            {
                webix.message({type:"error", text:R.error.msg});
            }

        }});
};

/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */
function ServicesViewController(Params) {
    "use strict";
    var _this = this;
    this.Id = "Services";

    this.TabsViews = {};

    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.adv)] = new AdBlockRedirectServiceViewController();
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.black_white_list)] = new BlackListServiceViewController({subs: 1});
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.ddos_guard)] = new DDoSProtectionViewController();
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.cgnat)] = new CgNatServiceViewController();
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.firewall)] = new MiniFirewallViewController();
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.session_policings)] = new SessionPolicingsViewController();

    this.TabsViewsDidLoaded = {};

    this.LicenseInfo = null;

    this.ViewConfig = [
        {
            id:this.Id,
            cols: [
                ServicesLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                {
                                    borderless: true,
                                    cols: [
                                        PageHeaderTemplate({root_title:LangHelper.GetString("AppView", "Services control"),title:LangHelper.GetString("AppView","Services")}),
                                        {
                                            gravity: 3,
                                            borderless: true,
                                            rows:[
                                                {
                                                    borderless:true,
                                                    type: "clean",
                                                    view: "toolbar",
                                                    css: "app_top_header vas-cloud_top-header",
                                                    height: 48,
                                                    elements:
                                                        [
                                                            {
                                                                id: _this.Id + "LicStateTitle",
                                                                css: "app_view_title",
                                                                borderless: true,
                                                                data: {},
                                                                template: function (Obj)
                                                                {
                                                                    var html = "<span class='app_view_title_shop_licence' title='"+ (Obj.available ? "" : LangHelper.GetString(_this.Id, "Functions of this service will not work on DPI")) +"'>" + LangHelper.GetString(_this.Id, "License status") + ": ";

                                                                    if(Obj.available)
                                                                    {
                                                                        if(Obj.days_left < 90)
                                                                        {
                                                                            html += "<span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__active_expire'>" + Obj.lic_level + ", " + (LangHelper.GetString("VasCloud", "remain %s days")).replace("%s", Obj.days_left);
                                                                        }
                                                                        else
                                                                        {
                                                                            html += "<span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__active'>" + Obj.lic_level;
                                                                        }
                                                                    }
                                                                    else
                                                                    {
                                                                        if(Obj.lic_level == VasCloudLicenecePageHeaderWidgetStateEnum.no_active)
                                                                        {
                                                                            html += "<span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__no_active'>" + LangHelper.GetString("VasCloud", "Not active");
                                                                        }
                                                                        else{
                                                                            html += "<span class='app_view_title_shop_licence_state app_view_title_shop_licence_state__no_active'>" + Obj.lic_level;
                                                                        }

                                                                    }
                                                                    html += "</span>";

                                                                    return html;
                                                                }
                                                            }
                                                        ]
                                                }
                                            ]
                                        }
                                    ]
                                },

                                {
                                    id:_this.Id + "UnderConstruction",
                                    rows:function ()
                                    {
                                        var arr = [];

                                        arr.push({
                                            view:"tabbar",
                                            id:_this.Id+"ServicesTabs",
                                            multiview:true,
                                            height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : 40,
                                            value:_this.Id+"BlankTab",
                                            options: _this.ServicesTabsFromDic()
                                        });

                                        if(SkinHelper.GetSkin() != SkinsEnum.dpiui2_vulkan)
                                            arr.push({height: 16});

                                        arr.push({
                                            view:"multiview",
                                            animate:false,
                                            cells:[
                                                {
                                                    id:_this.Id+"BlankTab"
                                                },
                                                {
                                                    id:_this.GetServicesTabsIdById(ServicesEnum.adv),
                                                    rows: _this.TabsViews[_this.GetServicesTabsIdById(ServicesEnum.adv)].ViewConfig
                                                },
                                                {
                                                    id:_this.GetServicesTabsIdById(ServicesEnum.black_white_list),
                                                    rows: _this.TabsViews[_this.GetServicesTabsIdById(ServicesEnum.black_white_list)].ViewConfig
                                                },
                                                {
                                                    id:_this.GetServicesTabsIdById(ServicesEnum.ddos_guard),
                                                    rows: _this.TabsViews[_this.GetServicesTabsIdById(ServicesEnum.ddos_guard)].ViewConfig
                                                },
                                                {
                                                    id:_this.GetServicesTabsIdById(ServicesEnum.cgnat),
                                                    rows: _this.TabsViews[_this.GetServicesTabsIdById(ServicesEnum.cgnat)].ViewConfig
                                                },
                                                {
                                                    id:_this.GetServicesTabsIdById(ServicesEnum.firewall),
                                                    rows: _this.TabsViews[_this.GetServicesTabsIdById(ServicesEnum.firewall)].ViewConfig
                                                },
                                                {
                                                    id:_this.GetServicesTabsIdById(ServicesEnum.session_policings),
                                                    rows: _this.TabsViews[_this.GetServicesTabsIdById(ServicesEnum.session_policings)].ViewConfig
                                                }
                                            ]
                                        });

                                        return arr;
                                    }()
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Views = {
        ServicesTabs:null
    };

    this.Subscriptions = {};

    this.Init(Params);

    return this;
}

ServicesViewController.prototype.Init = function (Params)
{

};

ServicesViewController.prototype.BindAll = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.Views.Self = $$(this.Id);

    this.Views.UnderConstruction = $$(this.Id + "UnderConstruction");

    this.Views.ServicesTabs = $$(this.Id + "ServicesTabs");

    this.Views.LicStateTitle = $$(this.Id + "LicStateTitle");
    this.Views.LicLevel = $$(this.Id + "LicLevel");
    this.Views.IsServiceAvailable = $$(this.Id + "IsServiceAvailable");

    webix.extend(this.Views.UnderConstruction, webix.OverlayBox);
    // this.Views.UnderConstruction.showOverlay("<br/><br/><br/><br/><br/><br/><br/><br/>В разработке.");

    this.Subscriptions.CurrentHardwareId = App.SessionManager.CurrentHardwareId.subscribe(
        function(Val)
        {
            if(Val)
            {
                App.SessionManager.GetHardwareLicenseInfo({
                    callback: function(R) {
                        if (R && R.success)
                        {
                            _this.LicenseInfo = R.data;
                        }
                        else{
                            _this.LicenseInfo = null;
                        }
                        _this.UpdateLicenseTitle();
                    }
                })
            }
        }
    );

    this.Views.ServicesTabs.attachEvent("onChange", function(NewVal, OldVal)
    {
        if(!_this.TabsViewsDidLoaded[NewVal] && _this.TabsViews[NewVal])
        {
            _this.TabsViews[NewVal].ViewDidLoad(_this.PathParams);
            _this.TabsViewsDidLoaded[NewVal] = true;
        }
        _this.UpdateLicenseTitle();
        _this.SetAllPathParam();
    });

};

ServicesViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;
    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select("Services");
    });

    this.BindAll(Params);

    this.GetAllPathParam();

    this.SetAllPathParam();
};

ServicesViewController.prototype.ServicesTabsFromDic = function (Params)
{
    "use strict";

    var _this = this;

    var arr = Helper.DictToArr(ServicesTabsDic);
    
    var tabs = [
        {
            value: _this.GetServicesTabNameById(ServicesEnum.adv) + " & " + _this.GetServicesTabNameById(ServicesEnum.adv_block),
            id: _this.GetServicesTabsIdById(ServicesEnum.adv),
            width:240
        },
        {
            value: _this.GetServicesTabNameById(ServicesEnum.black_white_list),
            id: _this.GetServicesTabsIdById(ServicesEnum.black_white_list),
            width:240
        },
        {
            value: _this.GetServicesTabNameById(ServicesEnum.ddos_guard),
            id: _this.GetServicesTabsIdById(ServicesEnum.ddos_guard),
            width:240
        },
        {
            value: _this.GetServicesTabNameById(ServicesEnum.cgnat),
            id: _this.GetServicesTabsIdById(ServicesEnum.cgnat),
            width:240
        },
        {
            value: _this.GetServicesTabNameById(ServicesEnum.firewall),
            id: _this.GetServicesTabsIdById(ServicesEnum.firewall),
            width:240
        },
        {
            value: _this.GetServicesTabNameById(ServicesEnum.session_policings),
            id: _this.GetServicesTabsIdById(ServicesEnum.session_policings),
            width:240
        }

    ];

    return tabs;
};

ServicesViewController.prototype.GetServicesTabsIdById = function (Id)
{
    var _this = this;

    var id = "";

    if(ServicesTabsDic[Id])
        id = _this.Id+"TabId"+ServicesTabsDic[Id].id;

    return id;
};

ServicesViewController.prototype.GetServicesTabNameById = function (Id)
{
    var _this = this;

    var name = "";

    if(ServicesTabsDic[Id])
        name = ServicesTabsDic[Id].value;

    return name;
};

ServicesViewController.prototype.Destroy = function ()
{
    var _this = this;

    this.Views.ServicesTabs.detachEvent("onChange");

    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.adv)].Destroy();
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.black_white_list)].Destroy();
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.ddos_guard)].Destroy();
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.cgnat)].Destroy();
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.firewall)].Destroy();
    this.TabsViews[this.GetServicesTabsIdById(ServicesEnum.session_policings)].Destroy();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

ServicesViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

ServicesViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

ServicesViewController.prototype.SetAllPathParam = function()
{
    var tabId = this.Views.ServicesTabs.getValue(),
        tab = tabId.replace(this.Id+"TabId","");

    if(tab)
    {
        this.SetPathParam("tab", tab);
    }

    this.JustNavigate();
};

ServicesViewController.prototype.GetAllPathParam = function()
{
    var tabId = this.GetPathParam("tab");

    tabId = tabId ? (this.Id+"TabId"+tabId) : "";

    this.Views.ServicesTabs.setValue(tabId ? tabId : this.GetServicesTabsIdById(ServicesEnum.adv));
};

ServicesViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

ServicesViewController.prototype.UpdateServiceAvailability = function(Data)
{
    var _this = this;
    if(this.LicenseInfo)
    {
        _this.UpdateLicenseTitle(this.LicenseInfo);
        var tabId = this.Views.ServicesTabs.getValue(),
            tab = tabId.replace(this.Id+"TabId","");

        var available = false;
        var service = ServicesLicLevelsDic[tab];
        if(service.lic_level)
        {
            service.lic_level.forEach(function(Val){
                if(_this.LicenseInfo.lic_level == Val)
                {
                    available = true;
                    return;
                }
            });
        }


        if(this.LicenseInfo.lic_options && !available)
        {
            this.LicenseInfo.lic_options.forEach(function(Val){
                if(Val == service.lic_options)
                {
                    available = true;
                    return;
                }
            });
        }

        this.Views.IsServiceAvailable.define("data", {available: available});
    }
};

ServicesViewController.prototype.UpdateLicenseTitle = function(Data)
{
    var _this = this;
    var data = {
        available: false,
        lic_level: VasCloudLicenecePageHeaderWidgetStateEnum.no_active,
        days_left: 0
    };


    if(this.LicenseInfo)
    {
        var tabId = this.Views.ServicesTabs.getValue(),
            tab = tabId.replace(this.Id+"TabId","");

        var available = false;
        var service = ServicesLicLevelsDic[tab];
        if(service.lic_level)
        {
            service.lic_level.forEach(function(Val){
                if(_this.LicenseInfo.lic_level == Val)
                {
                    available = true;
                    return;
                }
            });
        }


        if(this.LicenseInfo.lic_options && !available)
        {
            available = this.LicenseInfo.lic_options.indexOf(service.lic_options) !== -1;
            // this.LicenseInfo.lic_options.forEach(function(Val){
            //     if(Val == service.lic_options)
            //     {
            //         available = true;
            //         return;
            //     }
            // });
        }

        data.available = available;
        data.lic_level = this.LicenseInfo.lic_level;

        if(_this.LicenseInfo.expiration_date)
        {
            var date = new Date(this.LicenseInfo.expiration_date.substr(0, 4) + "-" + this.LicenseInfo.expiration_date.substr(4, 2) + "-" + this.LicenseInfo.expiration_date.substr(6, 2));
            data.days_left = Math.ceil((date - (new Date())) / (1000 * 60 * 60 * 24));
        }
    }

    if(this.Views.LicStateTitle && !this.Views.LicStateTitle.$destructed)
        this.Views.LicStateTitle.define("data", data);
};

/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */
/* global SubscribersViewController */
function TariffsViewController(Params) {
    "use strict";
    var _this = this;
    this.Id = "Tariffs";

    this.ProfilesManager = new PolicingProfilesManager();

    this.DicsManager = App.DicsManager;

    this.SubscriberEmbedded = new SubscribersViewController({embedded:true, tariffOnly: true, DicsManager: this.DicsManager});

    this.ConfigForm = new TariffConfigFormViewController();

    this.PolicingCreateContext = webix.ui({
        view:"popup",
        width: 448,
        body:{
            view:"form",
            id:this.Id+"PolicingCreateForm",
            borderless:true,
            elements: [
                {
                    "view": "text",
                    "name": "title",
                    "label": LangHelper.GetString(_this.Id, "Tariff name"),
                    "labelPosition": "top",
                    required: true,
                    invalidMessage: LangHelper.GetString(_this.Id, "Required field")
                },
                BlockHeaderTemplate({title:LangHelper.GetString(_this.Id,"Tariff plan configuration"), icon:"cogs"}),
                {
                    cols:[
                        {
                            view:"text",
                            name: "inbound_root_rate",
                            label: LangHelper.GetString(this.Id, "Inbound"),
                            labelPosition: "left",
                            value: "8",
                            // labelWidth: 196,
                            // width: 276,
                            validate: function(Val)
                            {
                                if(!Val)
                                    return false;

                                var val = parseInt(Val);
                                return Helper.IsInteger(val) && val > 0;
                            },
                            invalidMessage: LangHelper.GetString(this.Id, "Value should be positive integer number!"),
                        },
                        {
                            view: "richselect",
                            name: "inbound_root_rate_unit",
                            value: TrafficUnits[1].id,
                            width: 80,
                            label: "",
                            labelPosition: false,
                            suggest:{
                                data: Helper.DictToArr(TrafficUnits),
                                fitMaster:false
                            }
                        }
                    ]
                },
                {
                    cols:[
                        {
                            view:"text",
                            name: "outbound_root_rate",
                            label: LangHelper.GetString(this.Id, "Outbound"),
                            labelPosition: "left",
                            value: "8",
                            // labelWidth: 196,
                            // width: 276,
                            validate: function(Val)
                            {
                                if(!Val)
                                    return false;

                                var val = parseInt(Val);
                                return Helper.IsInteger(val) && val > 0;
                            },
                            invalidMessage: LangHelper.GetString(this.Id, "Value should be positive integer number!"),
                        },
                        {
                            view: "richselect",
                            name: "outbound_root_rate_unit",
                            width: 80,
                            label: "",
                            value: TrafficUnits[1].id,
                            labelPosition: false,
                            suggest:{
                                data: Helper.DictToArr(TrafficUnits),
                                fitMaster:false
                            }
                        }
                    ]
                },
                {
                    cols:[
                        // {},
                        {
                            view:"button",
                            width: 80,
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function () {
                                _this.PolicingCreateContext.hide();
                            }
                        },
                        {},
                        {
                            view:"button",
                            type:"form",
                            width: 88,
                            label:LangHelper.GetString(_this.Id, "Save"),
                            click:function () {
                                if(_this.SaveProfile({create:true}))
                                    _this.PolicingCreateContext.hide();
                            }
                        },
                        {},
                        {
                            view:"button",
                            type:"form",
                            width:176,
                            label:LangHelper.GetString(_this.Id, "Save and continue"),
                            click:function () {
                                if(_this.SaveProfile({create:true}))
                                {
                                    _this.PolicingCreateContext.hide();
                                    _this.AddProfileToListTable();
                                }

                            }
                        }
                    ]
                }
            ]
        }
    });

    this.PolicingEditContext = webix.ui({
        view:"popup",
        body:{
            view:"form",
            id:this.Id+"PolicingEditForm",
            borderless:true,
            elements: [
                {
                    "view": "text",
                    "name": "title",
                    "label": LangHelper.GetString(_this.Id, "Tariff name"),
                    "labelPosition": "top",
                    required: true,
                    invalidMessage: LangHelper.GetString(_this.Id, "Required field")
                },
                {
                    view: "text",
                    name: "dpi_name",
                    label: LangHelper.GetString(this.Id,"Code"),
                    labelPosition: "top",
                    tooltip: LangHelper.GetString(this.Id,"Profile name using on DPI"),
                    readonly: true
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            width: 80,
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function () {
                                _this.PolicingEditContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            width: 88,
                            label:LangHelper.GetString(_this.Id, "Save"),
                            click:function () {
                                if(_this.SaveProfile({create:false}))
                                    _this.PolicingEditContext.hide();
                            }
                        },
                        {},
                        {
                            view:"button",
                            type:"form",
                            width:176,
                            label:LangHelper.GetString(_this.Id, "Copy tariff"),
                            click:function () {
                                _this.CopyProfile();
                                _this.PolicingEditContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });
    this.PolicingDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Are you sure you want to delete this tariff?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function () {
                                _this.PolicingDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Delete"),
                            click:function () {
                                _this.PolicingDeleteContext.hide();

                                var selected = _this.GetSelectedProfile();
                                if(selected)
                                {
                                    _this.DeleteProfile(selected.id);
                                }
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.tariffConfigImportContext = webix.ui({
        view:"popup",
        width:600,
        height:600,
        body:{
            view:"form",
            id:_this.Id+"TariffImportConfigForm",
            borderless:true,
            elements:[
                {
                    view: "uploader",
                    value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                    name: _this.Id + "TariffImportConfigForm" + "Uploader",
                    css:"upload_area",
                    height:64,
                    on:{
                        onAfterFileAdd: function(FileObj)
                        {
                            _this.LoadConfigFromFile(FileObj);
                        }
                    }
                },
                {
                    view:"textarea",
                    name:  "import_config_text",
                    placeholder: "htb_inbound_root=rate 180mbit\n"+
                        "htb_inbound_class0=rate 100mbit ceil 180mbit\n"+
                        "htb_inbound_class1=rate 50mbit ceil 180mbit\n"+
                        "htb_inbound_class2=rate 8bit ceil 180mbit\n"+
                        "htb_inbound_class3=rate 8bit ceil 180mbit\n"+
                        "htb_inbound_class4=rate 8bit ceil 180mbit\n"+
                        "htb_inbound_class5=rate 8bit ceil 180mbit\n"+
                        "htb_inbound_class6=rate 8bit ceil 180mbit\n"+
                        "htb_inbound_class7=rate 10mbit ceil 100mbit\n"+
                        "htb_root=rate 180mbit\n"+
                        "htb_class0=rate 100mbit ceil 180mbit\n"+
                        "htb_class1=rate 50mbit ceil 180mbit\n"+
                        "htb_class2=rate 8bit ceil 180mbit\n"+
                        "htb_class3=rate 8bit ceil 180mbit\n"+
                        "htb_class4=rate 8bit ceil 180mbit\n"+
                        "htb_class5=rate 8bit ceil 180mbit\n"+
                        "htb_class6=rate 8bit ceil 180mbit\n"+
                        "htb_class7=rate 10mbit ceil 100mbit",
                    required: true,
                    invalidMessage: LangHelper.GetString(_this.Id, "Config field must not be empty!")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function () {
                                _this.tariffConfigImportContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Continue"),
                            click:function ()
                            {
                                if(_this.Views.TariffImportConfigForm.validate() && _this.SetLoadedConfigToSaveForm())
                                {
                                    _this.tariffConfigImportContext.hide();
                                }
                                else{
                                    _this.Views.TariffImportConfigForm.markInvalid("import_config_text",LangHelper.GetString(_this.Id, "Config field must not be empty!") );
                                }
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.TariffTimetableSetDataForm = webix.ui({
        view:"popup",
        modal:true,
        body:{
            view:"form",
            id:this.Id + "TimetableSetDataForm",
            borderless:true,
            elementsConfig:{
                bottomPadding:16
            },
            elements:[
                {
                    view: "datepicker",
                    type: "time",
                    name: "startTime",
                    tooltip: LangHelper.GetString(_this.Id, "Start time"),
                    labelPosition: "top",
                    label: LangHelper.GetString(_this.Id, "Start time"),
                    required: true,
                    stringResult: true,
                    validate: function(Val)
                    {
                        var datepicker = _this.Views.TariffTimetableSetDataForm.elements["startTime"];

                        if(!Val){
                            datepicker.define("invalidMessage",LangHelper.GetString(_this.Id, "Required field"));
                            return false;
                        }

                        var endTime = _this.Views.TariffTimetableSetDataForm.elements["endTime"].getValue();

                        datepicker.define("invalidMessage",LangHelper.GetString(_this.Id, "Invalid time"));

                        if(endTime)
                            return (Val != endTime);

                        return true;
                    }
                },
                {
                    view: "datepicker",
                    type: "time",
                    name: "endTime",
                    tooltip: LangHelper.GetString(_this.Id, "End time"),
                    labelPosition: "top",
                    label: LangHelper.GetString(_this.Id, "End time"),
                    required: true,
                    stringResult: true,
                    validate: function(Val)
                    {
                        var datepicker = _this.Views.TariffTimetableSetDataForm.elements["endTime"];

                        if(!Val){
                            datepicker.define("invalidMessage",LangHelper.GetString(_this.Id, "Required field"));
                            return false;
                        }
                        var startTime = _this.Views.TariffTimetableSetDataForm.elements["startTime"].getValue();

                        datepicker.define("invalidMessage",LangHelper.GetString(_this.Id, "Invalid time"));

                        if(startTime)
                            return(Val != startTime)

                        return true;
                    }
                },
                {
                    view: "combo",
                    id: this.Id + "SelectedTariffCombo",
                    name:"selectedTariff",
                    label:LangHelper.GetString(_this.Id, "Tariff"),
                    labelPosition: "top",
                    required: true,
                    invalidMessage: LangHelper.GetString(_this.Id, "Required field"),
                    options:[],
                    keyPressTimeout:100,
                    on:{
                        "onTimedKeyPress":function() {
                            _this.RequestSelectedTariffCombo(this.getText());
                        },
                        "onFocus":function() {
                            var text = this.getText();

                            if(!text)
                                _this.RequestSelectedTariffCombo(text);
                        }
                    }
                },
                {
                    view: "multiselect",
                    name: "weekday",
                    label:LangHelper.GetString(_this.Id, "Days of the week"),
                    labelPosition: "top",
                    tooltip:LangHelper.GetString(_this.Id, "Days of the week"),
                    required: true,
                    invalidMessage: LangHelper.GetString(_this.Id, "Required field"),
                    options: Helper.DictToArr(DaysOfWeekDic),
                },
                {
                    cols:[
                        {
                            view: "button",
                            value: LangHelper.GetString(_this.Id, "Cancel"),
                            click: function(){
                                _this.ClearAndHideTimetableSetDataForm();
                            }
                        },
                        {
                            view: "button",
                            type: "form",
                            value: LangHelper.GetString(_this.Id, "Apply"),
                            click:function(){
                                var form = _this.Views.TariffTimetableSetDataForm;

                                var values = form.getValues();

                                var selectedTariff = form.elements.selectedTariff.getList().getSelectedItem();

                                _this.selectedTariffsData.push(selectedTariff);

                                values.weekday = typeof(values.weekday) === "string" ? values.weekday.split(",") : values.weekday;

                                _this.SetDataToTimetable(values);
                            }
                        }
                    ]

                }
            ]
        }
    });

    this.TariffTimetable = webix.ui({
        view:"popup",
        id:this.Id + "TimetablePopup",
        width:780,
        height:300,
        modal:true,
        body:{
            rows:[
                {
                    view:"toolbar",
                    borderless:true,
                    cols:[
                        {
                            view:"button",
                            id:this.Id + "TimetableAddRow",
                            type:"icon",
                            icon:"plus",
                            css:"toolbar_round_btn",
                            width:30,
                            tooltip:LangHelper.GetString(_this.Id, "Add"),
                            click: function(){

                                _this.Views.TariffTimetableSetDataForm.setValues({
                                    startTime:"00-00",
                                    endTime:"00-00",
                                    weekday:Helper.DictToArr(DaysOfWeekDic).map(currentValue => currentValue.id)
                                });

                                _this.ShowTimetableSetDataForm(null, this.getNode(),{pos:"right"});
                            }
                        },
                        {},
                        {
                            view:"button",
                            id:this.Id + "TimetableRefresh",
                            type:"icon",
                            icon:"refresh",
                            css:"toolbar_round_btn",
                            width:30,
                            tooltip:LangHelper.GetString(_this.Id,"Refresh"),
                            click: function(){
                                _this.ShowTimetable();
                            }
                        }

                    ]
                },
                {
                    id:this.Id + "Timetable",
                    view: "datatable",
                    columnWidth:70,
                    select:"row",
                    tooltip:true,
                    on:{
                        onItemClick:function(id,event,node){
                            if(id.column === "Delete"){
                                _this.TimetableDeleteRow(_this.Views.Timetable.getSelectedItem());
                            }
                            else if(id.column ==="Edit"){
                                var selectedItem = _this.Views.Timetable.getSelectedItem();
                                var title = _this.Views.Timetable.getText(selectedItem.id, "Tariff");

                                var profile = {
                                    id:selectedItem.selectedTariff,
                                    value:title
                                };

                                _this.Views.TariffTimetableSetDataForm.setValues(selectedItem);
                                _this.ShowTimetableSetDataForm(profile,this.getItemNode(id),{pos:"right"});
                            }
                        },
                        onAfterRender:function(){
                            if(!this.count())
                                this.showOverlay("<br/><br/><br/>" + LangHelper.GetString(_this.Id,"Click + to add a schedule"));
                            else
                                this.hideOverlay();
                        }
                    },
                    columns: function (){
                        var cols = [];

                        cols.push({
                            id:"Edit",
                            header:[""],
                            template:CellEditBtnTemplate(),
                            width:30,
                            tooltip:false,
                        });
                        cols.push({
                            id:"Time",
                            header:[LangHelper.GetString(_this.Id,"Time")],
                            width:90,
                            tooltip:false,
                            template: function(Obj, Common, Value)
                            {
                                return Obj.startTime + "-" + Obj.endTime;
                            }
                        });
                        cols.push({
                            id:"Tariff",
                            header:[LangHelper.GetString(_this.Id,"Tariff")],
                            fillspace:true,
                            template: function(Obj, Common, Value)
                            {
                                var title = _this.selectedTariffsData.find(tariff => tariff.id === Obj.selectedTariff);

                                return (title&&title.value?title.value:LangHelper.GetString(_this.Id,"Profile")+" "+Obj.selectedTariff);
                            }
                        });
                        cols.push({
                            id: 1,
                            header: [LangHelper.GetString(_this.Id,"Mon")],
                            tooltip:false,
                            template: function(Obj, Common, Value)
                            {
                                if(typeof Obj[this.id] !== "undefined")
                                    return CellOnOffCheckboxTemplate(Obj,Common,Value);

                                return "";
                            }
                        });
                        cols.push({
                            id:2,
                            header:[LangHelper.GetString(_this.Id,"Tue")],
                            tooltip:false,
                            template:function (Obj, Common, Value)
                            {
                                if(typeof Obj[this.id] !== "undefined")
                                    return CellOnOffCheckboxTemplate(Obj, Common, Value);

                                return "";
                            }
                        });
                        cols.push({
                            id:3,
                            header:[LangHelper.GetString(_this.Id,"Wed")],
                            tooltip:false,
                            template:function (Obj, Common, Value)
                            {
                                if(typeof Obj[this.id] !== "undefined")
                                    return CellOnOffCheckboxTemplate(Obj, Common, Value);

                                return "";
                            }
                        });
                        cols.push({
                            id:4,
                            header:[LangHelper.GetString(_this.Id,"Thu")],
                            tooltip:false,
                            template:function (Obj, Common, Value)
                            {
                                if(typeof Obj[this.id] !== "undefined")
                                    return CellOnOffCheckboxTemplate(Obj, Common, Value);

                                return "";
                            }
                        });
                        cols.push({
                            id:5,
                            header:[LangHelper.GetString(_this.Id,"Fri")],
                            tooltip:false,
                            template:function (Obj, Common, Value)
                            {
                                if(typeof Obj[this.id] !== "undefined")
                                    return CellOnOffCheckboxTemplate(Obj, Common, Value);

                                return "";
                            }
                        });
                        cols.push({
                            id:6,
                            header:[LangHelper.GetString(_this.Id,"Sat")],
                            tooltip:false,
                            template:function (Obj, Common, Value)
                            {
                                if(typeof Obj[this.id] !== "undefined")
                                    return CellOnOffCheckboxTemplate(Obj, Common, Value);

                                return "";
                            }
                        });
                        cols.push({
                            id:7,
                            header:[LangHelper.GetString(_this.Id,"Sun")],
                            tooltip:false,
                            template:function (Obj, Common, Value)
                            {
                                if(typeof Obj[this.id] !== "undefined")
                                    return CellOnOffCheckboxTemplate(Obj, Common, Value);

                                return "";
                            }
                        })
                        cols.push({
                            id:"Delete",
                            header:[""],
                            template:CellTrashBtnTemplate(),
                            width:30,
                            tooltip:false
                        });

                        return cols;

                    }()
                },
                {
                    cols:[
                        {
                            view: "toolbar",
                            borderless: true,
                            cols:[
                                {
                                    id: _this.Id + "TimetableEnabledCheckbox",
                                    view: "checkbox",
                                    label: LangHelper.GetString(_this.Id,"Enable"),
                                    labelPosition: "left",
                                    labelWidth: 80
                                },
                                {},
                                {
                                    view: "button",
                                    id: "CancelTableButton",
                                    value: LangHelper.GetString(_this.Id,"Cancel"),
                                    maxWidth:100,
                                    click: function(id){
                                        _this.TariffTimetable.hide();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    id: "SaveTableButton",
                                    value: LangHelper.GetString(_this.Id,"Save"),
                                    maxWidth:100,
                                    click: function(id){
                                        var scheduleConfig_json = _this.Views.Timetable.serialize();

                                        var uniqueIdTariffs = new Set();

                                        _this.Views.Timetable.eachRow(function(row){
                                            var currentRow = _this.Views.Timetable.getItem(row);
                                            uniqueIdTariffs.add(currentRow.selectedTariff);
                                        });

                                        var lock_ids = Array.from(uniqueIdTariffs).join(",");

                                        var schedule_enable = _this.Views.TimetableEnableCheckbox.getValue();
                                        var tableItem = _this.Views.PolicingProfilesTable.getSelectedItem();

                                        _this.ProfilesManager.SaveTimetable({
                                            schedule_enable: schedule_enable,
                                            schedule_config_json:scheduleConfig_json,
                                            lock_ids: lock_ids,
                                            profile_id: tableItem.profile_id
                                        });

                                        _this.TariffTimetable.hide();
                                    }
                                }
                            ]
                        }

                    ]
                }
            ]
        }
    });


    this.view = [{
        id:this.Id,
        cols: [
            ServicesLeftSideBarView({id:this.Id}),
            {
                type: "space",
                rows: [
                    {
                        type: "clear",
                        borderless: true,
                        rows:[
                            PageHeaderTemplate({root_title:LangHelper.GetString(_this.Id,"Service Management"),title:LangHelper.GetString(_this.Id,"Tariffs")}),
                            {
                                id:this.Id + "UnderConstruction",
                                view: "accordion",
                                multi: "mixed",
                                on: {
                                    onAfterExpand: function(id) {
                                        _this.RefreshViews();
                                        return true;
                                    },
                                    onAfterCollapse: function(id)
                                    {
                                        _this.RefreshViews();
                                        return true;
                                    }
                                },
                                cols:[
                                    {
                                        header: LangHelper.GetString(_this.Id,"Tariffs"),
                                        id: this.Id + "ProfileAccord",
                                        // gravity: 2/3,
                                        body:{
                                            cols:[

                                                {
                                                    // width:296,
                                                    rows:[
                                                        {
                                                            view: "toolbar",
                                                            elements: [
                                                                {
                                                                    view: "button",
                                                                    type: "icon",
                                                                    icon: "plus",
                                                                    css:"toolbar_round_btn",
                                                                    width:32,
                                                                    tooltip:LangHelper.GetString(_this.Id, "Add tariff"),
                                                                    click:function ()
                                                                    {
                                                                        _this.AddProfileToListTable();
                                                                    }
                                                                },
                                                                {},
                                                                {
                                                                    view: "button",
                                                                    id:this.Id+"refreshProfilesBtn",
                                                                    type: "icon",
                                                                    icon: "refresh",
                                                                    css: "toolbar_round_btn",
                                                                    width: 32,
                                                                    tooltip: LangHelper.GetString(this.Id, "Refresh"),
                                                                    click: function (id, e, node)
                                                                    {
                                                                        _this.RefreshProfiles();
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        BlockHeaderTemplate({title:LangHelper.GetString(_this.Id,"Tariffs"), icon:"file"}),
                                                        {
                                                            id: this.Id + "PolicingProfilesTable",
                                                            view: "treetable",
                                                            resizeColumn: true,
                                                            width:296,
                                                            select: "row",
                                                            editaction: "custom",
                                                            scroll: "y",
                                                            rules:{
                                                                "valid":function (value)
                                                                {
                                                                    return value;
                                                                }
                                                            },
                                                            headermenu: {
                                                                width: 296,
                                                                autoheight: true,
                                                                scroll: false
                                                            },
                                                            tooltip:true,
                                                            on: {
                                                                onAfterLoad:function()
                                                                {
                                                                },
                                                                onBeforeFilter:function()
                                                                {
                                                                    return false;
                                                                },
                                                                onAfterFilter:function()
                                                                {
                                                                    _this.RefreshProfiles();
                                                                },
                                                                onBeforeSort:function()
                                                                {
                                                                    _this.RefreshProfiles();
                                                                    return false;
                                                                },
                                                                onItemClick: function (id)
                                                                {
                                                                    if(id.column === 'edit')
                                                                    {
                                                                        var __this = this;
                                                                        var rowData = this.getItem(id);
                                                                        if(rowData.individual == 0)
                                                                        {
                                                                            setTimeout(function () {
                                                                                if(rowData && rowData.profile_id)
                                                                                {
                                                                                    _this.ShowProfileEditForm(rowData,_this.Views.PolicingProfilesTable.getItemNode(rowData.id), "right");
                                                                                }
                                                                                else
                                                                                {
                                                                                    _this.ShowCreateProfileForm(rowData,_this.Views.PolicingProfilesTable.getItemNode(rowData.id), "right");
                                                                                }

                                                                            }, 10);
                                                                        }
                                                                    }
                                                                    else if(id.column === 'trash')
                                                                    {
                                                                        var __this = this;
                                                                        setTimeout(function () {
                                                                            var node = __this.getItemNode(id);
                                                                            var rowData = __this.getItem(id);
                                                                            if(rowData && rowData.profile_id)
                                                                            {
                                                                                _this.PolicingDeleteContext.show(node, {pos:"bottom"});
                                                                            }
                                                                            else{
                                                                                _this.DeleteProfile(id.row);
                                                                            }

                                                                        }, 10);
                                                                    }
                                                                    else if (id.column == "run")
                                                                    {
                                                                        var __this = this;
                                                                        setTimeout(function(){
                                                                            var rowData = __this.getItem(id);

                                                                            if(rowData && rowData.profile_id)
                                                                            {
                                                                                if(rowData.individual)
                                                                                {
                                                                                    var node = __this.getItemNode(id);
                                                                                    _this.PolicingDeleteContext.show(node, {pos:"bottom"});
                                                                                }
                                                                                else{
                                                                                    if(rowData.status)
                                                                                    {
                                                                                        _this.StopProfile();
                                                                                    }
                                                                                    else{
                                                                                        _this.StartProfile();
                                                                                    }
                                                                                }
                                                                            }
                                                                        }, 10);
                                                                    }
                                                                    else if (id.column === "schedule_enable")
                                                                    {
                                                                        var rowData = this.getItem(id);
                                                                        if(rowData.individual == 0 && rowData.profile_id != 0)
                                                                            _this.ShowTimetable(this.getItemNode(id), {pos:"bottom"});
                                                                    }
                                                                },
                                                                onBeforeUnselect: function(data, preserve)
                                                                {
                                                                    return true;
                                                                },
                                                                onBeforeSelect: function(data, preserve)
                                                                {
                                                                    return true;
                                                                },
                                                                onAfterSelect: function (data, preserve)
                                                                {
                                                                    _this.OnSelectedProfileChange();

                                                                },
                                                                onAfterUnselect: function( data, preserve)
                                                                {
                                                                    _this.OnSelectedProfileChange();
                                                                }
                                                            },
                                                            columns: [
                                                                {
                                                                    id: "run",
                                                                    header: "",
                                                                    width: 32,
                                                                    template: function (obj, common)
                                                                    {
                                                                        if(obj.status == 1 && obj.profile_id)
                                                                        {
                                                                            return CellStopBtnTemplate();
                                                                        }

                                                                        if(obj.profile_id)
                                                                        {
                                                                            return CellPlayBtnTemplate();
                                                                        }

                                                                        return "";
                                                                    },
                                                                    headermenu: false
                                                                },
                                                                {
                                                                    id: "edit",
                                                                    header: "",
                                                                    width: 40,
                                                                    template: function(obj)
                                                                    {
                                                                        return obj.individual == 0 ? CellEditBtnTemplate() : "";
                                                                    },
                                                                    headermenu: false
                                                                },
                                                                {
                                                                    id: "schedule_enable",
                                                                    header: "",
                                                                    width: 40,
                                                                    template: function(Obj,Common,Value)
                                                                    {
                                                                        return Obj.individual == 0 && Obj.profile_id != 0 ? CellCalendarTemplate(Value) : "";
                                                                    },
                                                                    headermenu: false
                                                                },
                                                                {
                                                                    id: "title",
                                                                    header: [LangHelper.GetString(_this.Id, "Tariff"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                    // template: "{common.treetable()} #title#",
                                                                    fillspace: true,
                                                                    width:108,
                                                                    sort: "string",
                                                                    template:function(obj)
                                                                    {
                                                                        var tmp = (obj.title?obj.title:LangHelper.GetString(_this.Id,"Profile")+" "+obj.profile_id);

                                                                        return tmp;
                                                                    },
                                                                    tooltip: function(obj)
                                                                    {
                                                                        var tmp = (obj.title?obj.title:LangHelper.GetString(_this.Id,"Profile")+" "+obj.profile_id);

                                                                        if(obj.title && obj.title !== obj.dpi_name)
                                                                        {
                                                                            tmp += " (" + obj.dpi_name + ")";
                                                                        }
                                                                        return tmp;
                                                                    }
                                                                },
                                                                // {
                                                                //     id: "status",
                                                                //     header: [LangHelper.GetString(_this.Id, "Status"), {
                                                                //         content: "richSelectFilter",
                                                                //         options: Helper.DictToArr(PolicingStatusesDic),
                                                                //         inputConfig: {suggest: {fitMaster: false}}
                                                                //     }],
                                                                //     template: function (obj, common)
                                                                //     {
                                                                //
                                                                //         var res = "";
                                                                //         res = "<span class=\"policing_state policing_status_" + obj.status + "\">" + '<span class="fa fa-square"></span> ' + PolicingStatusesDic[obj.status].value + "</span>";
                                                                //
                                                                //         return res;
                                                                //     }
                                                                // },
                                                                {
                                                                    id: "individual",
                                                                    header: [LangHelper.GetString(_this.Id, "Type"), {
                                                                        content: "richSelectFilter",
                                                                        options: Helper.DictToArr(TariffTypes),
                                                                        inputConfig: {suggest: {fitMaster: false}}
                                                                    }],
                                                                    fillspace:true,
                                                                    width:108,
                                                                    sort: "number",
                                                                    template: function(obj)
                                                                    {
                                                                        return "<span title=\"" + TariffTypesTooltip[obj.individual].value + "\">" + TariffTypes[obj.individual].value + "</span>"
                                                                    }
                                                                },
                                                                {
                                                                    id: "status",
                                                                    header: [LangHelper.GetString(this.Id,"Status"), {
                                                                        content: "richSelectFilter",
                                                                        options: Helper.DictToArr(BlStatusesDic),
                                                                        inputConfig: {suggest: {fitMaster: false}}
                                                                    }],
                                                                    width:80,
                                                                    template: function (obj, common)
                                                                    {
                                                                        var statusStr = "";

                                                                        if(BlStatusesDic[obj.status])
                                                                        {
                                                                            statusStr += "<span class=\"status status_" + obj.status + "\">" + BlStatusesDic[obj.status].value + "</span>";
                                                                        }

                                                                        return statusStr;
                                                                    },
                                                                    sort: "string"
                                                                },
                                                                {
                                                                    id: "trash",
                                                                    header: "",
                                                                    width: 40,
                                                                    template: CellTrashBtnTemplate,
                                                                    headermenu: false
                                                                }
                                                            ],
                                                            data:[]
                                                        },
                                                        // {
                                                        //     gravity: 0.00001
                                                        // },
                                                        {
                                                            view: "pager",
                                                            id: this.Id + "PolicingProfilesTable" +"Paging",
                                                            template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                            master:false,
                                                            on: {
                                                                onAfterPageChange:function(Page)
                                                                {
                                                                    _this.RefreshProfiles(Page);
                                                                }
                                                            }
                                                        }
                                                    ]
                                                },
                                                {view:"resizer"},
                                                {
                                                    id: this.Id + "ConfigSpace",
                                                    minWidth:656,
                                                    rows:[
                                                        {
                                                            view: "toolbar",
                                                            elements: [
                                                                // {
                                                                //     view: "button",
                                                                //     type: "icon",
                                                                //     icon: "upload",
                                                                //     css:"toolbar_round_btn",
                                                                //     width:32,
                                                                //     tooltip:LangHelper.GetString(_this.Id, "Load from file"),
                                                                //     click:function (id,e,node)
                                                                //     {
                                                                //         var __this = this;
                                                                //         setTimeout(function () {
                                                                //             var node = __this.getNode(id);
                                                                //             _this.Views.TariffImportConfigForm.elements.import_config_text.setValue("");
                                                                //             _this.tariffConfigImportContext.show(node, {pos:"bottom"});
                                                                //         }, 10);
                                                                //     }
                                                                // },
                                                                {
                                                                    view: "button",
                                                                    type: "icon",
                                                                    icon: "download",
                                                                    css:"toolbar_round_btn",
                                                                    width:32,
                                                                    tooltip:LangHelper.GetString(_this.Id, "Export config to file"),
                                                                    click:function (id,e,node)
                                                                    {
                                                                        var __this = this;
                                                                        setTimeout(function () {
                                                                            _this.ExportConfigToFile();
                                                                        }, 10);
                                                                    }
                                                                },
                                                                {},
                                                                {
                                                                    view: "button",
                                                                    id:this.Id+"refreshConfigBtn",
                                                                    type: "icon",
                                                                    icon: "redo",
                                                                    css: "toolbar_round_btn",
                                                                    width: 32,
                                                                    tooltip: LangHelper.GetString(this.Id, "Cancel changes"),
                                                                    click: function (id, e, node)
                                                                    {
                                                                        var __this = this;

                                                                        var data = _this.GetSelectedProfile();
                                                                        if(data && data.profile_id)
                                                                        {
                                                                            _this.ParseProfileConfig(data);
                                                                        }
                                                                    }
                                                                },
                                                                {
                                                                    view: "button",
                                                                    id:this.Id+"TimetableBtn",
                                                                    type: "icon",
                                                                    icon: "calendar",
                                                                    css: "toolbar_round_btn",
                                                                    width:128,
                                                                    label: LangHelper.GetString(this.Id, "Timetable"),
                                                                    tooltip: LangHelper.GetString(this.Id, "Timetable"),
                                                                    click: function (id)
                                                                    {
                                                                        _this.ShowTimetable(this.getNode(),{pos:"bottom"});
                                                                    }
                                                                },
                                                                {
                                                                    view: "button",
                                                                    type: "icon",
                                                                    icon: "floppy-o",
                                                                    label:LangHelper.GetString(_this.Id, "Save"),
                                                                    css:"toolbar_round_btn",
                                                                    width:128,
                                                                    tooltip:LangHelper.GetString(_this.Id, "Save"),
                                                                    click:function ()
                                                                    {
                                                                        _this.ConfigForm.Save();
                                                                        // webix.message("В разработке")
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        BlockHeaderTemplate({title:LangHelper.GetString(_this.Id, "Tariff plan configuration"), icon:"cog"}),
                                                        {
                                                            id: _this.Id + "ConfigForm",
                                                            body: this.ConfigForm.view
                                                        }
                                                    ]
                                                },
                                                {gravity:0}
                                            ]
                                        }
                                    },
                                    {view:"resizer"},
                                    {
                                        header: LangHelper.GetString(this.Id,"Subscribers"),
                                        id: this.Id + "SubsAccord",
                                        body:this.SubscriberEmbedded.view,
                                        gravity: 1
                                    },
                                    {gravity: 0}
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }];

    this.Views = {
        TariffImportConfigForm: null,
        TariffImportConfigFormUploader : null,
        TariffImportConfigFormText: null
    };

    this.btns = {
        subscribersDeleteBtn:null
    };

    this.Subscriptions = {};

    this.Init(Params);

    return this;
}

TariffsViewController.prototype.Init = function (Params) {
    "use strict";
};

TariffsViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    var _this = this;
    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select("Tariffs");
    });

    this.SubscriberEmbedded.ViewDidLoad();
    this.ConfigForm.ViewDidLoad();

    this.BindAll(Params);
};

TariffsViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

//    this.Views.CampaignDataImportContextUploader.detachEvent("onAfterFileAdd");
    this.SubscriberEmbedded.Destroy();
    this.ConfigForm.Destroy();
};

TariffsViewController.prototype.BindAll = function (Params) {
    "use strict";
    var _this = this;

    this.Views.Self = $$(this.Id);


    this.Views.UnderConstruction = $$(this.Id + "UnderConstruction");

    this.Views.PolicingProfilesTable = $$(this.Id + "PolicingProfilesTable");
    // webix.extend(this.Views.PolicingProfilesTable, webix.ProgressBar);

    this.Views.Timetable = $$(this.Id + "Timetable");
    this.Views.TariffTimetableSetDataForm = $$(this.Id + "TimetableSetDataForm");
    this.Views.TimetableAddRowButton = $$(this.Id + "TimetableAddRow");
    this.Views.TimetableRefreshButton = $$(this.Id + "TimetableRefresh");
    this.Views.TimetableSaveButton = $$("SaveTableButton");
    this.Views.TimetableEnableCheckbox = $$(this.Id + "TimetableEnabledCheckbox");
    this.Views.SelectedTariffCombo = $$(this.Id + "SelectedTariffCombo");
    this.Views.TimetableButton = $$(this.Id+"TimetableBtn");

    webix.extend(this.Views.Timetable, webix.ProgressBar);

    this.Views.ConfigSpace = $$(this.Id + "ConfigSpace");
    this.Views.ConfigSpace.disable();

    // this.Views.ConfigTable = $$(this.Id + "ConfigTable");

    this.Views.PolicingEditForm = $$(this.Id + "PolicingEditForm");
    this.Views.PolicingCreateForm = $$(this.Id + "PolicingCreateForm");

    this.Views.TariffImportConfigForm = $$(this.Id + "TariffImportConfigForm");
    this.Views.Paging = $$(this.Id + "PolicingProfilesTable" +"Paging");

    /*
    this.Views.TariffImportConfigFormUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        _this.LoadConfigFromFile(FileObj.file);
    });
    */
    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshProfiles();
            _this.UpdateProfilesDics();
        }
    });

    this.Subscriptions.SignalProfilesUpdated = this.ProfilesManager.SignalProfilesUpdated.subscribe(function(Val)
    {
        if(Val)
        {
            _this.UpdateProfilesTable();
        }
    });

    this.Subscriptions.SignalSaveConfig = this.ConfigForm.OnSaveSignal.subscribe(function(DataToSave){
        if(DataToSave)
        {
            _this.SaveProfileConfig(DataToSave);
        }

    });

    this.Subscriptions.SignalTimetableConfigGet = this.ProfilesManager.SignalTimetableConfigGet.subscribe(function(Val){
        if(Val)
        {
            var profileData = Val.data;

            var table = _this.Views.PolicingProfilesTable;

            var currentProfile = table.find(function(row)
            {
                return row.profile_id == profileData.profile_id;
            },true);

            currentProfile.schedule_enable = profileData.schedule_enable;
            currentProfile.schedule_config_json = profileData.schedule_config_json;
            currentProfile.lock_ids = profileData.lock_ids;

            table.updateItem(currentProfile.id, currentProfile);

            webix.message(LangHelper.GetString("Tariffs", "Schedule saved successfully"));
        }
    });

    this.Subscriptions.SignalTimetableConfigError = this.ProfilesManager.SignalTimetableConfigError.subscribe(function(Error){
       if(Error)
       {
           _this.Views.Timetable.hideProgress();
           _this.Views.Timetable.showOverlay(LangHelper.GetString("All", "Error")+ ": " + Error.msg);
       }
    });
    // webix.extend(this.Views.UnderConstruction, webix.OverlayBox);
    // this.Views.UnderConstruction.showOverlay("<br/><br/><br/><br/><br/><br/><br/><br/>В разработке.");
};

TariffsViewController.prototype.RefreshProfiles = function(Page)
{
    var _this = this;

    var state = this.Views.PolicingProfilesTable.getState();

    this.ProfilesManager.RefreshProfiles({
        page:Page,
        filter:state.filter,
        sort:state.sort,
        callback:function ()
        {
            //_this.table.hideProgress();
        }
    });
};

TariffsViewController.prototype.UpdateProfilesTable = function()
{
    var _this = this;

    this.Views.PolicingProfilesTable.clearAll();
    this.Views.PolicingProfilesTable.parse(_this.ProfilesManager.GetProfiles());
    this.Views.PolicingProfilesTable.refresh();
    this.Views.Paging.define(this.ProfilesManager.Total);
    this.Views.Paging.refresh();

};

TariffsViewController.prototype.GetSelectedProfile = function()
{
    return this.Views.PolicingProfilesTable.getSelectedItem();
};

TariffsViewController.prototype.OnSelectedProfileChange = function()
{
    var _this = this;

    var data = this.GetSelectedProfile();

    if(data && data.profile_id)
    {
        // this.Views.ConfigTable.parse(DataGens.Tariffs.GridData());

        _this.SubscriberEmbedded.SetData();

        this.Views.ConfigSpace.enable();

        this.ParseProfileConfig(data);
    }
    else{
        this.Views.ConfigSpace.disable();
    }

    if(data && data.individual == 0)
        this.Views.TimetableButton.show();
    else
        this.Views.TimetableButton.hide();
};

TariffsViewController.prototype.AddProfileToListTable = function()
{
    var _this = this;
    var model = new PolicingProfileModel({hardware_id: App.SessionManager.GetCurrentHardwareId()});
    _this.Views.PolicingProfilesTable.add(model,0);
    _this.Views.PolicingProfilesTable.select(model.id,false);
    _this.Views.PolicingProfilesTable.showItem(model.id);

    _this.ShowCreateProfileForm(model,_this.Views.PolicingProfilesTable.getItemNode(model.id), "right");
};

TariffsViewController.prototype.CopyProfile = function()
{
    var _this = this;
    var model = webix.copy(_this.GetSelectedProfile());

    model.id = null;
    model.profile_id = 0;
    model.title += " " + LangHelper.GetString(this.Id, "Copy");
    model.dpi_name = "";

    model = new PolicingProfileModel(model);
    var config = JSON.stringify(new PolicingConfigModel(model.config ? JSON.parse(model.config) : null ));

    _this.Views.PolicingProfilesTable.add(model,0);
    _this.Views.PolicingProfilesTable.select(model.id,false);
    _this.Views.PolicingProfilesTable.showItem(model.id);

    this.ProfilesManager.SaveProfile({
        profile: model,
        config: config,
        callback: function(R)
        {
            if(R.success && R.data && R.data.profile)
            {

                _this.Views.PolicingProfilesTable.updateItem(model.id, new PolicingProfileModel(R.data.profile));
                _this.OnSelectedProfileChange();
                webix.message(LangHelper.GetString(_this.Id, "Tariff saved"));
            }
            else{
                model.valid = false;
                _this.Views.PolicingProfilesTable.validate(model.id);

                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }

            _this.UpdateProfilesDics();
        }
    })
};

TariffsViewController.prototype.ShowCreateProfileForm = function(Data, Node, Pos)
{
    var _this = this;

    if(Data)
    {
        var data = new PolicingProfileModel(Data);
        this.Views.PolicingCreateForm.elements.title.setValue(data.title);
    }
    //TODO: CLEAR FORM

    this.PolicingCreateContext.show(Node, {pos:Pos});
};

TariffsViewController.prototype.ShowProfileEditForm = function(Data, Node, Pos)
{
    var _this = this;

    if(Data)
    {
        var data = new PolicingProfileModel(Data);
        this.Views.PolicingEditForm.elements.title.setValue(data.title);
        this.Views.PolicingEditForm.elements.dpi_name.setValue(data.dpi_name);
    }
    //TODO: CLEAR FORM

    this.PolicingEditContext.show(Node, {pos:Pos});
};

TariffsViewController.prototype.DeleteProfile = function( RowId )
{
    var _this = this;
    var profileData = this.Views.PolicingProfilesTable.getItem(RowId);
    profileData.valid = true;

    if(profileData.profile_id > 0)
    {
        this.ProfilesManager.DeleteProfile({
            profile: profileData,
            callback: function(R)
            {
                if(R.success)
                {
                    _this.Views.PolicingProfilesTable.remove(RowId);

                    webix.message(LangHelper.GetString(_this.Id,"Tariff deleted"));
                }
                else
                {
                    profileData.valid = false;
                    _this.Views.PolicingProfilesTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }

                _this.UpdateProfilesDics();
            }
        });
    }
    else
    {
        this.Views.PolicingProfilesTable.remove(RowId);
    }
};

TariffsViewController.prototype.SaveProfile = function(Params)
{
    var _this = this;
    var profileData = this.GetSelectedProfile();

    var config = null;
    if(!Params.create)
    {
        if(this.Views.PolicingEditForm.validate())
        {
            if (profileData.profile_id > 0)
            {
                var formVals = _this.Views.PolicingEditForm.getValues();
                Object.keys(formVals).forEach(function (Key) {
                    profileData[Key] = formVals[Key];
                });

            }
        }
        else return false;
    }
    else
    {
        if(this.Views.PolicingCreateForm.validate())
        {
            var formVals = _this.Views.PolicingCreateForm.getValues();
            profileData.title = formVals.title;

            var parsed = new PolicingConfigModel({
                type: "HTB",
                inbound: {
                    root_rate: formVals.inbound_root_rate + formVals.inbound_root_rate_unit
                },
                outbound: {
                    root_rate: formVals.outbound_root_rate + formVals.outbound_root_rate_unit
                }
            });
            for(var p in parsed)
            {
                if(typeof parsed[p] === "object")
                {
                    parsed[p].classes.forEach(function(Class)
                    {
                        Class.rate= "8bit";
                        Class.ceil = parsed[p].root_rate;
                    });
                }
            }
            config = JSON.stringify(this.ConfigForm.DeleteShitFromConfig(parsed));
        }
        else return false;
    }

    profileData.hardware_id = App.SessionManager.GetCurrentHardwareId();
    profileData.valid = true;
    this.ProfilesManager.SaveProfile({
        profile: profileData,
        config: config,
        callback: function(R)
        {
            //_this.Views.PolicingProfilesTable
            if(R.success && R.data && R.data.profile)
            {

                _this.Views.PolicingProfilesTable.updateItem(profileData.id, new PolicingProfileModel(R.data.profile));
                _this.OnSelectedProfileChange();
                webix.message(LangHelper.GetString(_this.Id, "Tariff saved"));
            }
            else{
                profileData.valid = false;
                _this.Views.PolicingProfilesTable.validate(profileData.id);

                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }

            _this.UpdateProfilesDics();
        }
    });
    return true;
};

TariffsViewController.prototype.ParseProfileConfig = function(Data)
{
    var _this = this;

    // this.Views.ConfigTable.clearAll();
    var configModel = new PolicingConfigModel( Data.config ? JSON.parse(Data.config) : null);

    this.ConfigForm.SetData(configModel);
};

TariffsViewController.prototype.SaveProfileConfig = function(Params)
{
    var _this = this;



    var profile = this.GetSelectedProfile();
    if(profile && profile.profile_id)
    {
        var config = JSON.stringify(Params.config);

        this.ProfilesManager.SaveProfileConfig({
            profile: profile,
            config: config,
            callback: function(R){
                if(R.success && R.data && R.data.profile)
                {

                    _this.Views.PolicingProfilesTable.updateItem(profile.id, new PolicingProfileModel(R.data.profile));
                    webix.message(LangHelper.GetString(_this.Id, "Tariff saved"));
                    _this.OnSelectedProfileChange();

                }
                else{
                    // profile.status = 4;
                    profile.valid = false;
                    _this.Views.PolicingProfilesTable.validate(profile.id);

                    if(R.error)
                        webix.message({text: R.error.msg,type:"error"});
                }
            }
        });
    }
};

TariffsViewController.prototype.UpdateProfilesDics = function()
{
    App.DicsManager.Refresh({data: [DicsEnum.PolicingProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});
};

TariffsViewController.prototype.LoadConfigFromFile = function(FileObj)
{
    var _this = this;
    var file = FileObj.file;
    var read = new FileReader();

    read.onloadend = function()
    {
        _this.Views.TariffImportConfigForm.elements.import_config_text.setValue(read.result);
    };

    read.readAsText(file);
};

TariffsViewController.prototype.SetLoadedConfigToSaveForm = function()
{
    var _this = this;

    var config = _this.Views.TariffImportConfigForm.elements.import_config_text.getValue();

    if(!config || config.length == 0)
        return false;

    var profile = _this.GetSelectedProfile();

    if(!profile || !profile.profile_id)
        return false;

    config = _this.ParseConfigFromStr(config);

    // _this.Views.ConfigTable.clearAll();
    // _this.Views.ConfigTable.parse(config);

    return true;
};

TariffsViewController.prototype.ParseConfigFromStr = function(String)
{
    var _this = this;


    var findValUnit = function(IsRate, Str)
    {
        var res = {
            val: 0,
            unit: TrafficUnits["1"].id
        };
        var regEx = null;
        if(IsRate)
        {
            regEx = /(rate [0-9\.]+[a-zA-Z]+)/;
        }
        else
        {
            regEx = /(ceil [0-9\.]+[a-zA-Z]+)/;
        }

        if(Str)
        {
            var valStr = Str.match(regEx);
            if(valStr)
            {
                valStr = valStr.index > -1? valStr[0] : null;

                if(valStr)
                {
                    valStr = valStr.split(" ")[1];

                    res.val = valStr.match(/[0-9\.]+/)[0];
                    res.unit = valStr.match(/[a-zA-Z]+/)[0];
                }
            }
        }

        return res;
    };

    var cfgModel = GetPolicingConfigModel();

    var lines = String.split("\n");

    lines.forEach(function(line, i)
    {
        line = line.replace("htb_","");

        var vals = line.split("=");

        var _class = vals[0].replace("inbound_", "");

        var classIndex = cfgModel.findIndex(function(Val)
        {
            return Val.class == _class;
        });

        if(classIndex !== -1)
        {
            if(vals[0].indexOf("inbound_") > -1)
            {
                var rateVals = findValUnit(true, vals[1]);

                cfgModel[classIndex].inRateVal = rateVals.val;
                cfgModel[classIndex].inRateUnit = rateVals.unit;


                var ceilVals = findValUnit(false, vals[1]);
                cfgModel[classIndex].inCeilVal = ceilVals.val;
                cfgModel[classIndex].inCeilUnit = ceilVals.unit;
            }
            else
            {
                var rateVals = findValUnit(true, vals[1]);

                cfgModel[classIndex].outRateVal = rateVals.val;
                cfgModel[classIndex].outRateUnit = rateVals.unit;


                var ceilVals = findValUnit(false, vals[1]);
                cfgModel[classIndex].outCeilVal = ceilVals.val;
                cfgModel[classIndex].outCeilUnit = ceilVals.unit;
            }
        }
    });

    return cfgModel;
};

TariffsViewController.prototype.ExportConfigToFile = function()
{
    var _this = this;

    var profile = this.GetSelectedProfile();

    if(profile && profile.profile_id)
    {
        var getContent = this.ConfigForm.GetConfigText();

        var blob = new Blob([getContent], {type: "application/cfg"});

        webix.html.download(blob, profile.title + "_config.cfg");
    }

};

TariffsViewController.prototype.RefreshViews = function()
{
    var _this = this;

    Helper.RefreshView(this.Views.PolicingProfilesTable);

    this.ConfigForm.RefreshViews();
};

TariffsViewController.prototype.StartProfile = function()
{
    var _this = this;
    var profileData = this.GetSelectedProfile();

    if(profileData)
    {
        this.ProfilesManager.StartProfile({
            profile: profileData,
            callback: function(R)
            {
                if(R.success && R.data && R.data.profile)
                {

                    _this.Views.PolicingProfilesTable.updateItem(profileData.id, new PolicingProfileModel(R.data.profile));
                    _this.OnSelectedProfileChange();
                    webix.message(LangHelper.GetString(_this.Id, "Profile enabled"));
                }
                else{
                    profileData.valid = false;
                    _this.Views.PolicingProfilesTable.validate(profileData.id);

                    if(R.error)
                        webix.message({text: R.error.msg,type:"error"});
                }
            }
        })
    }
};

TariffsViewController.prototype.StopProfile = function()
{
    var _this = this;
    var profileData = this.GetSelectedProfile();

    if(profileData)
    {
        this.ProfilesManager.StopProfile({
            profile: profileData,
            callback: function(R)
            {
                if(R.success && R.data && R.data.profile)
                {

                    _this.Views.PolicingProfilesTable.updateItem(profileData.id, new PolicingProfileModel(R.data.profile));
                    _this.OnSelectedProfileChange();
                    webix.message(LangHelper.GetString(_this.Id, "Profile disabled"));
                }
                else{
                    profileData.valid = false;
                    _this.Views.PolicingProfilesTable.validate(profileData.id);

                    if(R.error)
                        webix.message({text: R.error.msg,type:"error"});
                }
            }
        })
    }
};

TariffsViewController.prototype.ShowTimetableSetDataForm = function(Data, Node, Pos)
{
    if(Data)
        this.Views.SelectedTariffCombo.getList().parse(Data);

    this.TariffTimetableSetDataForm.show(Node,Pos);
};

TariffsViewController.prototype.AddDataToSelectTariffCombo = function()
{
    var _this = this;

    var selectedItem = this.Views.PolicingProfilesTable.getSelectedItem();

    var schedule_config = JSON.parse(selectedItem.schedule_config_json);

    if(schedule_config) {
        var selectedTariffs = []
        schedule_config.forEach(configItem => {
            if(configItem.selectedTariff) {
                selectedTariffs.push(configItem.selectedTariff);
            }
        });
        this.Views.TimetableAddRowButton.disable();
        this.Views.TimetableRefreshButton.disable();
        this.Views.TimetableSaveButton.disable();
        this.Views.TimetableEnableCheckbox.disable();

        this.ProfilesManager.GetProfilesById({profile_ids:selectedTariffs, callback:this.ConfigureTimetable.bind(this)});
    }
    else {
        this.ConfigureTimetable();
    }
};

TariffsViewController.prototype.ConfigureTimetable = function(Models = null)
{
    var _this = this;
    var items = [];

    if(Models) {
        Models.forEach(model => {
            items.push({
                id:model.profile_id,
                value:model.title
            })
        });
    }
    this.selectedTariffsData = items;

    this._LoadDataToTimetable();
};

TariffsViewController.prototype.DefineOptionsTariffsCombo = function(tariffs)
{
    var selectedTariffCombo = this.Views.TariffTimetableSetDataForm.elements.selectedTariff;

    var list = selectedTariffCombo.getList();
    list.clearAll();

    tariffs.forEach(tariff => {
        var title = (tariff.title?tariff.title:LangHelper.GetString(this.Id,"Profile")+" "+ tariff.profile_id);

        list.add({id: tariff.profile_id, value: title});
    });
};

TariffsViewController.prototype.RequestSelectedTariffCombo = function(Text)
{
    this.ProfilesManager.GetProfilesById({title: Text, size:25, order_by:"title", order_dir: "asc", is_not_individual:1, callback:this.DefineOptionsTariffsCombo.bind(this)});
};

TariffsViewController.prototype.LoadDataToTimetable = function ()
{
    this.Views.Timetable.clearAll();
    this.Views.Timetable.hideOverlay();
    this.Views.Timetable.showProgress({type:"icon"});
    this.AddDataToSelectTariffCombo();
};

TariffsViewController.prototype._LoadDataToTimetable = function()
{
    var selectedTariff = this.Views.PolicingProfilesTable.getSelectedItem();

    this.Views.Timetable.parse(JSON.parse(selectedTariff.schedule_config_json));

    this.Views.TimetableEnableCheckbox.setValue(selectedTariff.schedule_enable);

    this.Views.TimetableAddRowButton.enable();
    this.Views.TimetableRefreshButton.enable();
    this.Views.TimetableSaveButton.enable();
    this.Views.TimetableEnableCheckbox.enable();

    this.Views.Timetable.refresh();
};

TariffsViewController.prototype.ShowTimetable = function (Node, Pos)
{
    this.TariffTimetable.show(Node,Pos);

    this.LoadDataToTimetable();
}

TariffsViewController.prototype.SetDataToTimetable = function(values)
{
    if(this.ValidateSetDataForm()){
        values.hasOwnProperty('id')?
            this.Views.Timetable.updateItem(this.Views.Timetable.getSelectedId().row, new TariffTimetableModel(values)):
            this.Views.Timetable.add(new TariffTimetableModel(values), this.Views.Timetable.count());
        this.ClearAndHideTimetableSetDataForm();
    }
}

TariffsViewController.prototype.ValidateSetDataForm = function()
{
    return this.Views.TariffTimetableSetDataForm.validate();
};

TariffsViewController.prototype.TimetableDeleteRow = function(deleteRow)
{
    this.Views.Timetable.remove(deleteRow.id);
};

TariffsViewController.prototype.ClearAndHideTimetableSetDataForm = function()
{
    this.Views.TariffTimetableSetDataForm.clear();
    this.Views.TariffTimetableSetDataForm.clearValidation();
    this.TariffTimetableSetDataForm.hide();

};




var classProps = [
    "rate",
    "ceil",
    "burst",
    "cburst"
];

function TariffConfigFormViewController(Params) {
    "use strict";

    var _this = this;
    this.Id = "Tariffs";

    this.id = this.Id + "ConfigFormView";

    this.id += Params && Params.Id ? Params.Id : "";

    this.IsHotspot = false;

    this.onlyAdvanced = false;

    this.DpiConfig = false;
    this.FormViews = [
        this.id + "Simple",
        this.id + "Common",
        this.id + "Advanced",
        this.id + "Editor"
    ];

    this.GetFormDataFunctions = [];
    this.GetFormDataFunctions[this.FormViews[0]] = "GetSimpleFormData";
    this.GetFormDataFunctions[this.FormViews[1]] = "GetCommonFormData";
    this.GetFormDataFunctions[this.FormViews[2]] = "GetAdvancedFormData";
    this.GetFormDataFunctions[this.FormViews[3]] = "GetEditorFormData";

    this.SetFormDataFunctions = [];
    this.SetFormDataFunctions[this.FormViews[0]] = "SetSimpleFormData";
    this.SetFormDataFunctions[this.FormViews[1]] = "SetCommonFormData";
    this.SetFormDataFunctions[this.FormViews[2]] = "SetAdvancedFormData";
    this.SetFormDataFunctions[this.FormViews[3]] = "SetEditorFormData";

    this.view = null;

    this.ClickedTabbarId = null;


    this.SwitchPopup = webix.ui({
        view: "popup",
        width: 400,
        height:144,
        id:this.id + "SwitchPopup",
        body: {
            view:"form",
            width: 400,
            id: this.id + "SwitchPopup" + "Form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("All", "There are unsaved changes. Are you sure you want to switch form?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("All", "Cancel"),
                            click:function () {
                                _this.SwitchPopup.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("All", "Switch"),
                            click:function () {
                                _this.SwitchPopup.hide();
                                if(_this.ClickedTabbarId)
                                {
                                    _this.Views.Tabbar.setValue(_this.ClickedTabbarId);
                                }
                                _this.SetData(_this.Data);
                            }
                        }
                    ]
                }
            ]
        }
    });


    this.Views = {};
    this.Subscriptions = {};

    this.OnSaveSignal = new Rx.BehaviorSubject(0);

    this.OnDataUpdated = new Rx.BehaviorSubject(0);

    this.Data = null;
    this.DataUpdated = false;

    this.Init(Params);
    return this;
};

TariffConfigFormViewController.prototype.Init = function (Params) {
    "use strict";
    var _this = this;

    if(Params && Params.onlyAdvanced)
    {
        this.onlyAdvanced = Params.onlyAdvanced;
    }

    if(Params && Params.dpiConfig)
    {
        this.DpiConfig = Params.dpiConfig;
    }

    if(Params && Params.hotspot)
    {
        this.IsHotspot = Params.hotspot;
    }

    this.view = {
        id: this.id + "ConfigFormView",
        rows: []
    };

    if(!this.onlyAdvanced)
    {
        this.view.rows.push(this.GetTabbarTemplate());

        var formViews = {
            view: "multiview",
            cells:[
                _this.GetSimpleFormTemplate(),
                _this.GetCommonFormTemplate(),
                _this.GetAdvancedFormTemplate(),
                _this.GetEditorFormTemplate()
            ]
        };

        this.view.rows.push(formViews);
    }
    else
    {
        this.view.rows.push(_this.GetAdvancedFormTemplate());
    }

};

TariffConfigFormViewController.prototype.GetTabbarTemplate = function()
{
    var _this = this;
  return   {
      view: "tabbar",
      id: this.id + "Tabbar",
      multiview: true,

      borderless: false,
      value: this.FormViews[0],
      options:[
          {
              id: this.FormViews[0],
              value: LangHelper.GetString(this.Id, "Simple form"),
          },
          {
              id: this.FormViews[1],
              value: LangHelper.GetString(this.Id, "Common form"),
          },
          {
              id: this.FormViews[2],
              value: LangHelper.GetString(this.Id, "Advanced form"),
          },
          {
              id: this.FormViews[3],
              value: LangHelper.GetString(this.Id, "Editor"),
          }
      ],
      on:{
          onBeforeTabClick: function(id, e)
          {
              var current = _this.GetSelectedView();
              if(current == _this.FormViews[0])
              {
                  _this.DataUpdated = $$(_this.FormViews[0]).isDirty();
              }
              else if(current == _this.FormViews[3])
              {
                  _this.DataUpdated = $$(_this.FormViews[3]).isDirty();
              }


              if(_this.DataUpdated)
              {
                  if(_this.IsHotspot)
                  {
                      var data = _this.GetFormDataJSON();
                      if(data.config)
                      {
                          _this.SetData(data.config);
                          return true;
                      }
                  }
                  else
                  {
                      var node = e.toElement;

                      _this.ClickedTabbarId = id;
                      _this.SwitchPopup.show(node, {pos:"bottom"});
                      return false;
                  }
              }
              else
              {
                  return true;
              }

              // _this.DataUpdated = false;
          },
          onChange: function()
          {
              if($$(_this.FormViews[3]))
              {
                  var edit = $$(_this.FormViews[3]).elements['config_text'].getEditor();
                  if(edit && edit.refresh && typeof edit.refresh == "function")
                  {
                      edit.refresh();
                  }
              }
          }
      }
  }
};

TariffConfigFormViewController.prototype.GetSimpleFormTemplate = function()
{
    var _this = this;
    return {
        id: this.FormViews[0],
        view: "form",
        elements:[
            {
                cols:[
                    {
                        view:"text",
                        name: "inbound_root_rate",
                        label: LangHelper.GetString(this.Id, "Inbound rate"),
                        labelPosition: "left",
                        labelWidth: 196,
                        // width: 276,
                        validate: function(Val)
                        {
                            if(!Val)
                                return false;

                            var val = parseInt(Val);
                            return Helper.IsInteger(val) && val > 0;
                        },
                        invalidMessage: LangHelper.GetString(this.Id, "Value should be positive integer number!"),
                    },
                    {
                        view: "richselect",
                        name: "inbound_root_rate_unit",
                        width: 80,
                        label: "",
                        labelPosition: false,
                        suggest:{
                            data: Helper.DictToArr(TrafficUnits),
                            fitMaster:false
                        }
                    }
                ]
            },
            {
                cols:[
                    {
                        view:"text",
                        name: "outbound_root_rate",
                        label: LangHelper.GetString(this.Id, "Outbound rate"),
                        labelPosition: "left",
                        labelWidth: 196,
                        // width: 276,
                        validate: function(Val)
                        {
                            if(!Val)
                                return false;

                            var val = parseInt(Val);
                            return Helper.IsInteger(val) && val > 0;
                        },
                        invalidMessage: LangHelper.GetString(this.Id, "Value should be positive integer number!"),
                    },
                    {
                        view: "richselect",
                        name: "outbound_root_rate_unit",
                        width: 80,
                        label: "",
                        labelPosition: false,
                        suggest:{
                            data: Helper.DictToArr(TrafficUnits),
                            fitMaster:false
                        }
                    }
                ]
            },
            {}
        ],
        on: {
            onChange: function(Val, OldVal)
            {
            }
        }
    };
};

TariffConfigFormViewController.prototype.GetCommonFormTemplate = function()
{
    var _this = this;
    return {
        id: this.FormViews[1],
        rows:[
            // this.GetHierarchyFormTemplate(this.FormViews[1]),
            BlockHeaderTemplate({title: LangHelper.GetString(this.Id, "Classes"), icon: "cogs"}),
            {
                id: this.id + "CommonClassesTable",
                view: "datatable",
                headermenu: false,
                select: "row",
                columns:[

                ],
                on: {
                    onItemClick: function (id)
                    {
                        var item = this.getItem(id);
                        var node = this.getItemNode(id);
                        // var tbf = _this.Views[_this.FormViews[1] + "Hierarchy"].elements.type.getValue() === "TBF";

                        _this.ShowConfigClassEditForm(item, node, "right", false, false);
                    }
                },
                data:[]
            }
        ]
    };
};

TariffConfigFormViewController.prototype.GetAdvancedFormTemplate = function()
{
    var _this = this;
    return {
        id: this.FormViews[2],
        rows:[
            this.GetHierarchyFormTemplate(this.FormViews[2]),
            BlockHeaderTemplate({title: LangHelper.GetString(this.Id, "Classes"), icon: "cogs"}),
            {
                id: this.id + "AdvancedClassesTable",
                view: "datatable",
                headermenu: false,
                select: "row",
                sort: false,
                columns:[
                ],
                on: {
                    onItemClick: function (id)
                    {
                        var item = this.getItem(id);
                        var node = this.getItemNode(id);
                        var tbf = _this.Views[_this.FormViews[2] + "Hierarchy"].elements.type.getValue() === "TBF";

                        _this.ShowConfigClassEditForm(item, node, "right", true, tbf);
                    }
                },
                data:[]
            }
        ]
    };
};
TariffConfigFormViewController.prototype.GetEditorFormTemplate = function()
{
    var _this = this;

    return {
        id: this.FormViews[3],
        view:"form",
        borderless:false,
        elements:[
            {
                borderless:true,
                view:"codemirror-editor",
                name:  "config_text",
                placeholder: "htb_inbound_root=rate 180mbit\n"+
                "htb_inbound_class0=rate 100mbit ceil 180mbit\n"+
                "htb_inbound_class1=rate 50mbit ceil 180mbit\n"+
                "htb_inbound_class2=rate 8bit ceil 180mbit\n"+
                "htb_inbound_class3=rate 8bit ceil 180mbit\n"+
                "htb_inbound_class4=rate 8bit ceil 180mbit\n"+
                "htb_inbound_class5=rate 8bit ceil 180mbit\n"+
                "htb_inbound_class6=rate 8bit ceil 180mbit\n"+
                "htb_inbound_class7=rate 10mbit ceil 100mbit\n"+
                "htb_root=rate 180mbit\n"+
                "htb_class0=rate 100mbit ceil 180mbit\n"+
                "htb_class1=rate 50mbit ceil 180mbit\n"+
                "htb_class2=rate 8bit ceil 180mbit\n"+
                "htb_class3=rate 8bit ceil 180mbit\n"+
                "htb_class4=rate 8bit ceil 180mbit\n"+
                "htb_class5=rate 8bit ceil 180mbit\n"+
                "htb_class6=rate 8bit ceil 180mbit\n"+
                "htb_class7=rate 10mbit ceil 100mbit",
                required: true,
                invalidMessage: LangHelper.GetString(_this.Id, "Config field must not be empty!")
            }
        ],
        on: {
            onChange: function(Val, OldVal)
            {
            }
        }
    };
};

TariffConfigFormViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    var _this = this;

    this.BindAll(Params);
};

TariffConfigFormViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

TariffConfigFormViewController.prototype.BindAll = function (Params) {
    "use strict";
    var _this = this;

    this.Views.Tabbar = $$(this.id + "Tabbar");
    this.Views.CommonClassesTable = $$(this.id + "CommonClassesTable");
    this.Views.AdvancedClassesTable = $$(this.id + "AdvancedClassesTable");
    this.Views[this.FormViews[1] + "Hierarchy"] = $$(this.FormViews[1] + "Hierarchy");
    this.Views[this.FormViews[2] + "Hierarchy"] = $$(this.FormViews[2] + "Hierarchy");

    this.Views[this.FormViews[1] + "Hierarchy" + "Field"] = $$(this.FormViews[1] + "Hierarchy" + "Field");
    this.Views[this.FormViews[2] + "Hierarchy" + "Field"] = $$(this.FormViews[2] + "Hierarchy" + "Field");

    // this.Views[this.FormViews[1] + "Hierarchy" + "Field"].attachEvent("onChange", function(Val)
    // {
        _this.ConfigClassesCommonTable("HTB");
    // });

    if(this.Views[this.FormViews[2] + "Hierarchy" + "Field"])
    {
        this.Views[this.FormViews[2] + "Hierarchy" + "Field"].attachEvent("onChange", function(Val, OldVal)
        {
            if(!Val || Val == "0")
            {
                _this.Views.AdvancedClassesTable.clearAll();
                _this.Views.AdvancedClassesTable.disable();
            }
            else{
                _this.Views.AdvancedClassesTable.enable();
            }

            _this.ConfigClassesAdvancedTable(Val && Val != "0" ? Val : "HTB");

            // if(OldVal)
            // {
                _this.DataUpdated = true;
                setTimeout(function(){
                    _this.OnDataUpdated.next(1);
                    if(Val == "HTB")
                    {
                        _this.Views.Tabbar.showOption(_this.id + "Simple")
                        _this.Views.Tabbar.showOption(_this.id + "Common")
                    }
                    else{
                        _this.Views.Tabbar.hideOption(_this.id + "Simple")
                        _this.Views.Tabbar.hideOption(_this.id + "Common")
                    }
                },10);



            // }
        });
    }



    if(this.Views.CommonClassesTable)
    {
        this.Views.CommonClassesTable.attachEvent("onDataUpdate", function(id, data)
        {
            return true;
        });
    }

};

TariffConfigFormViewController.prototype.ConfigClassesCommonTable = function(Template)
{
    var _this = this;
    var table = this.Views.CommonClassesTable;

    if(!table)
        return;

    table.filter(function(obj)
    {
        return Template == "TBF" ?  (obj.class != "root") : true;
    });

    var data = table.serialize();

    // table.clearAll();
    table.config.columns = [];
    table.refreshColumns();
    var columns = webix.toArray(table.config.columns);

    var templateFunction = function(Obj, common, Val)
    {
        if(!Val)
            return "";

        if(Val == "static")
            return Val;

        var model = Helper.GetTrafficValAndUnitFromString(Val);


        var unit = Helper.DictToArr(TrafficUnits).find(function(obj)
        {
            return obj.id == model.unit;
        });
        return model.val + " " + unit.value;
    };

    columns = columns.concat([
        {
            id: "edit",
            header: "",
            width: 40,
            template: CellEditBtnTemplate,
            headermenu: false
        },
        {
            id:"class",
            header:{text:LangHelper.GetString(_this.Id, "Class"),rowspan:2},
            width:112,
            fillspace:true

        },
        {
            id:"inbound_rate",
            header:[
                {
                    text:LangHelper.GetString(_this.Id,"Inbound"),
                    colspan:Template != "TBF"? 2:1,
                    css:"cell_align_center"
                },
                {
                    text:"Rate",
                    css:"cell_align_center"
                }
            ],
            css:"cell_highlited cell_align_center",
            width:Template != "TBF"?108:216,
            template: templateFunction
        }
    ]);

    if(Template != "TBF")
    {
        columns = columns.concat([
            {
                id:"inbound_ceil",
                header:[
                    {text:"",colspan:1},
                    {text:"Ceil",colspan:1,css:"cell_align_center"}],
                css:"cell_highlited cell_align_center",
                width:108,
                template: templateFunction
            }
        ]);
    }

    columns = columns.concat([
        {
            id:"outbound_rate",
            header:[
                {
                    text:LangHelper.GetString(_this.Id,"Outbound"),
                    colspan:Template != "TBF"? 2:1,
                    css:{"text-align":"center"}
                },
                {
                    text:"Rate",
                    css:{"text-align":"center"}
                }
            ],
            css:{"text-align":"center"},
            width:Template != "TBF"?108:216,
            template: templateFunction
        }
    ]);

    if(Template != "TBF")
    {
        columns = columns.concat([
            {
                id:"outbound_ceil",
                header:[
                    {text:"",colspan:1},
                    {text:"Ceil",colspan:1,css:{"text-align":"center"}}
                ],
                css:{"text-align":"center"},
                width:108,
                template: templateFunction
            }
        ]);
    }

    table.config.columns = columns;
    table.refreshColumns();
    table.parse(data);

    table.filter(function(obj)
    {
       return Template == "TBF" ?  (obj.class != "root") : true;
    });
};

TariffConfigFormViewController.prototype.ConfigClassesAdvancedTable = function(Template)
{
    var _this = this;
    var table = this.Views.AdvancedClassesTable;


    table.filter(function(obj)
    {
        return Template == "TBF" ?  (obj.class != "root") : true;
    });

    var data = table.serialize();


    table.config.columns = [];
    table.refreshColumns();
    var columns = webix.toArray(table.config.columns);

    var templateFunction = function(Obj, common, Val, CommonUnit)
    {
        if(!Val)
            return "";
        if(Val == "static")
            return Val;

        var model = Helper.GetTrafficValAndUnitFromString(Val);

        var unit = Helper.DictToArr(CommonUnit ? TrafficUnits : BufferUnits).find(function(obj)
        {
            return obj.id == model.unit;
        });


        return model.val + " " + unit.value;
    };

    var columnTemplate = function(Type, Label)
    {

        return {
            id: Type + "_" + Label.toLowerCase(),
            header:[
                {text:"",colspan:1},
                {text:Label,colspan:1,css:"cell_align_center"}],
            css:(Type == "inbound" ? "cell_highlited " : "") + "cell_align_center",
            width:72,
            template: function(Obj, common, Val)
            {
                return templateFunction(Obj, common, Val, (Label == "Burst" || Label == "Cburst" ? 0 : 1));
            }
        }
    };

    var inbound = [
        {
            id: "edit",
            header: "",
            width: 40,
            template: CellEditBtnTemplate,
            headermenu: false
        },
        {
            id:"class",
            header:{text:LangHelper.GetString(_this.Id, "Class"),rowspan:2},
            minWidth:56,
            fillspace:true

        },

    ];

    var outbound = [];

    if(Template == "TBF" && !this.DpiConfig)
    {
        inbound.push({
            id: "inbound_enabled",
            header: "",
            template: CellCheckBoxDisabledTemplate,
            width:32,
            disabled: true
        });

        outbound.push({
            id: "outbound_enabled",
            header: "",
            template: CellCheckBoxDisabledTemplate,
            width:32,
            disabled: true
        });
    }

    inbound.push({
        id:"inbound_rate",
        header:[
            {
                text:LangHelper.GetString(_this.Id,"Inbound"),
                colspan:Template != "TBF"? 4:2,
                css:"cell_align_center"
            },
            {
                text:"Rate",
                css:"cell_align_center"
            }
        ],
        css:"cell_highlited cell_align_center",
        width:64,
        template: templateFunction
    });
    outbound.push({
        id:"outbound_rate",
        header:[
            {
                text:LangHelper.GetString(_this.Id,"Outbound"),
                colspan:Template != "TBF"? 4:2,
                css:{"text-align":"center"}
            },
            {
                text:"Rate",
                css:{"text-align":"center"}
            }
        ],
        css:{"text-align":"center"},
        width:64,
        template: templateFunction
    });

    if(Template != "TBF")
    {
        inbound.push(columnTemplate("inbound", "Ceil"));
        outbound.push(columnTemplate("outbound", "Ceil"));
    }
    else if(Template == "TBF" && this.DpiConfig)
    {
        inbound.push(columnTemplate("inbound", "Peakrate"));
        outbound.push(columnTemplate("outbound", "Peakrate"));
    }

    inbound.push(columnTemplate("inbound", "Burst"));
    outbound.push(columnTemplate("outbound", "Burst"));



    if(Template != "TBF" || this.DpiConfig)
    {
        inbound.push(columnTemplate("inbound", "Cburst"));
        outbound.push(columnTemplate("outbound", "Cburst"));
    }
    columns = columns.concat(inbound).concat(outbound);

    table.config.columns = columns;
    table.refreshColumns();


    table.parse(data);

    if(Template == "HTB" && data.length < 9)
    {
        table.add(this.GetRootDataAsTableObject(), 0);
    }

    table.filter(function(obj)
    {
        return Template == "TBF" ?  (obj.class != "root") : true;
    });

    table.refresh();
};

TariffConfigFormViewController.prototype.GetHierarchyFormTemplate = function(Form)
{
    var _this = this;
    return {
        id: Form + "Hierarchy",
        view: "form",
        height: 56,
        elements:[
            {
                id: Form + "HierarchyField",
                view: "richselect",
                name: "type",
                label: LangHelper.GetString(this.Id,"Policing type"),
                labelPosition: "left",
                labelWidth: 98,
                options: Helper.DictToArr( _this.DpiConfig ? HardwareConfigPolicingsConfigTypesDic : PolicingsConfigTypesDic),
                tooltip: LangHelper.GetString(this.Id, "Policing types: \"HTB\" or \"TBF\"")
            }
        ]
    }
};

TariffConfigFormViewController.prototype.GetSelectedView = function()
{
    return this.Views.Tabbar.getValue();
}

TariffConfigFormViewController.prototype.Save = function(Params)
{
    var _this = this;

    var dataToSave = null;
    var formType = this.GetSelectedView();

    switch (formType)
    {
        case this.FormViews[0]:
            dataToSave = _this.GetSimpleFormDataJSON();
            break;
        case this.FormViews[1]:
            dataToSave = _this.GetCommonFormDataJSON();
            break;
        case this.FormViews[2]:
            dataToSave = _this.GetAdvancedFormDataJSON();
            break;
        case this.FormViews[3]:
            dataToSave = _this.GetEditorFormDataJSON();
            break;
    }

    if(dataToSave)
    {
        this.OnSaveSignal.next({
            data: this.Data,
            config: _this.DeleteShitFromConfig(dataToSave)
        });
    }
    else
    {
        webix.message({text: LangHelper.GetString(this.Id, "Class rate summ should be less then root rate!"),type:"error"});
    }
};

TariffConfigFormViewController.prototype.SetData = function(Data)
{
    var _this = this;
    this.Data = webix.copy(Data ? Data : new PolicingConfigModel());
    this.FormViews.forEach(function(Val)
    {
        _this[_this.SetFormDataFunctions[Val]]();
    });
    this.DataUpdated = false;

    if(this.Data.type != "HTB")
    {
        var selTab = this.Views.Tabbar.getValue();
        if(selTab == this.id + "Simple" || selTab == this.id + "Common")
        {
            this.Views.Tabbar.setValue(this.id + "Advanced");
        }
    }
};

TariffConfigFormViewController.prototype.SetSimpleFormData = function()
{
  var _this = this;
  var form = $$(this.FormViews[0]);
  if(!form)
      return;

  var obj = {};
  var prop = "root_rate";

  for(var i in this.Data)
  {
      if(typeof this.Data[i] == "object")
      {
         var model = this.GetValAndUnitFromString(this.Data[i][prop]);
         obj[i + "_" + prop] = model.val;
         obj[i + "_" + prop + "_unit"] = model.unit;
      }
  }

  form.setValues(obj);
};

TariffConfigFormViewController.prototype.GetSimpleFormData = function()
{
    var _this = this;
    var form = $$(this.FormViews[0]);

    if(form.validate())
    {
        var data = form.getValues();
        var parsed = new PolicingConfigModel({
            type: "htb",
            inbound: {
                root_rate: data.inbound_root_rate + data.inbound_root_rate_unit
            },
            outbound: {
                root_rate: data.outbound_root_rate + data.outbound_root_rate_unit
            }
        });
        var text = "";
        var type = parsed.type.toLowerCase();
        for(var p in parsed)
        {
            if(typeof parsed[p] === "object")
            {
                var typeStr = type + (p === "inbound"? ("_" + p) : "") + "_";
                var rate = parsed[p].root_rate;

                text += typeStr + "root=rate " + rate +"\n";

                parsed[p].classes.forEach(function(Class)
                {
                    text += typeStr + "class" + Class.class + "=rate 8bit ceil " + rate + "\n";
                });
            }
        }
        return text;
        // parsed.inbound ={};
    }

    return null;
};

TariffConfigFormViewController.prototype.GetSimpleFormDataJSON = function()
{
    var _this = this;
    var form = $$(this.FormViews[0]);

    if(form.validate())
    {
        var data = form.getValues();
        var parsed = new PolicingConfigModel({
            type: "HTB",
            inbound: {
                root_rate: data.inbound_root_rate + data.inbound_root_rate_unit
            },
            outbound: {
                root_rate: data.outbound_root_rate + data.outbound_root_rate_unit
            }
        });
        // var text = "";
        // var type = parsed.type.toLowerCase();

        for(var p in parsed)
        {
            if(typeof parsed[p] === "object")
            {
                parsed[p].classes.forEach(function(Class)
                {
                    Class.rate= "8bit";
                    Class.ceil = parsed[p].root_rate;
                    Class.enabled = 1;
                });
            }
        }
        return parsed;
        // parsed.inbound ={};
    }

    return null;
};

TariffConfigFormViewController.prototype.SetCommonFormData = function()
{
    var _this = this;
    // var hierarchy = this.Views[this.FormViews[1] + "Hierarchy"];
    // hierarchy.setValues(this.Data);

    var table = this.Views.CommonClassesTable;

    if(!table)
        return;
    table.clearAll();


    var arr = [];
    // if(hierarchy.elements.type.getValue() == "HTB")
    // {
        arr[0] = this.GetRootDataAsTableObject();
    // }

    arr = arr.concat(this.GetClassesDataAsTableObjects());

    table.parse(arr);
};

TariffConfigFormViewController.prototype.GetCommonFormData = function()
{
    var _this = this;
    // var type = this.Views[this.FormViews[1] + "Hierarchy"].elements.type.getValue().toLowerCase();
    var inbound = "";
    var outbound = "";

    var type = "htb";
    var data = this.Views.CommonClassesTable.serialize(false);
    if(type != "tbf")
    {
        var valid = this.ValidateForm(data);
        if(!valid)
        {
            return null;
        }
    }
    var getConfigString = function(Direction, Object)
    {
        var str = type + (Direction === "inbound"? ("_" + Direction) : "") + "_";
        str += (Object.class !== "root" ?  "class": "") + Object.class + "=";
        str += "rate " + Object[Direction + "_rate"] + " ";
        if(type !== "tbf")
        {
            str += (Object[Direction + "_ceil"] !== "static" ? "ceil " : "") + Object[Direction + "_ceil"];
        }
        str += "\n";

        return str;
    };
    data.forEach(function(Val)
    {
        inbound += getConfigString("inbound", Val);
        outbound += getConfigString("outbound", Val);
    });


    return inbound + outbound;
};

TariffConfigFormViewController.prototype.GetCommonFormDataJSON = function()
{
    var _this = this;
    // var type = this.Views[this.FormViews[1] + "Hierarchy"].elements.type.getValue().toLowerCase();
    var inbound = "";
    var outbound = "";

    var type = "htb";
    var data = this.Views.CommonClassesTable.serialize(false);
    var result = new PolicingConfigModel({
        type: "HTB"
    });
    if(type != "tbf")
    {
        var valid = this.ValidateForm(data);
        if(!valid)
        {
            return null;
        }
    }
    var SetConfig = function(Direction, Object)
    {
        if(Object.class == "root")
        {
            result[Direction].root_rate = Object[Direction + "_rate"];
            result[Direction].root_ceil = Object[Direction + "_ceil"];
        }
        else
        {
            result[Direction].classes[Object.class].rate = Object[Direction + "_rate"];
            result[Direction].classes[Object.class].ceil = Object[Direction + "_ceil"];
            result[Direction].classes[Object.class].enabled = 1;
        }
    };
    data.forEach(function(Val)
    {
        SetConfig("inbound", Val);
        SetConfig("outbound", Val);
        // outbound += getConfigString("outbound", Val);
    });

    return result;
};

TariffConfigFormViewController.prototype.SetAdvancedFormData = function()
{
    var _this = this;

    var form = $$(this.FormViews[2]);

    var hierarchy = this.Views[this.FormViews[2] + "Hierarchy"];

    if(!hierarchy)
    {
        return;
    }

    if(!this.Data)
    {
        this.Data = new PolicingConfigModel();
    }

    hierarchy.setValues(this.Data);
    // this.ConfigClassesAdvancedTable(this.Data.type);

    var table = this.Views.AdvancedClassesTable;
    table.clearAll();


    var arr = [];
    if(hierarchy.elements.type.getValue() == "TBF")
    {
        table.filter(function(obj)
        {
            return obj.class != "root";
        });
        table.refresh();
    }
    else{
        arr[0] = this.GetRootDataAsTableObject();
    }


    arr = arr.concat(this.GetClassesDataAsTableObjects());

    table.parse(arr);

};

TariffConfigFormViewController.prototype.GetPolicingTypeFormData = function()
{
    var type = this.Views[this.FormViews[2] + "Hierarchy"].elements.type.getValue();
    return type && type != "0" ? type : "";
};

TariffConfigFormViewController.prototype.GetAdvancedFormData = function(NeedToValidate)
{
    var _this = this;
    var type = this.Views[this.FormViews[2] + "Hierarchy"].elements.type.getValue().toLowerCase();
    if(!type || type == "0")
    {
        type = "htb";
    }
    var inbound = "";
    var outbound = "";

    var data = this.Views.AdvancedClassesTable.serialize(false);

    if(type != "tbf" && NeedToValidate)
    {
        var valid = this.ValidateForm(data);
        if(!valid)
            return null;
    }


    var getConfigString = function(Direction, Object)
    {
        var isStatic = false;
        var str = type + (Direction === "inbound"? ("_" + Direction) : "") + "_";
        str += (Object.class !== "root" ?  "class": "") + Object.class + "=";

        if(Object[Direction + "_rate"])
            str += "rate " + Object[Direction + "_rate"];

        if(type !== "tbf" && Object[Direction + "_ceil"])
        {
            str += " ";
            if(Object[Direction + "_ceil"] !== "static")
            {
                str += "ceil ";
            }
            else
            {
                isStatic = true;
            }
            str += Object[Direction + "_ceil"];
        }

        if(!isStatic)
        {
            if(Object[Direction + "_burst"])
                str += " burst " + Object[Direction + "_burst"];

            if(Object[Direction + "_cburst"])
                str += " cburst " + Object[Direction + "_cburst"];

            if(type === "tbf" && _this.DpiConfig)
            {
                if(Object[Direction + "_peakrate"])
                    str += " peakrate " + Object[Direction + "_peakrate"];
            }
        }
        str += "\n";

        return str;
    };
    data.forEach(function(Val)
    {
        inbound += getConfigString("inbound", Val);
        outbound += getConfigString("outbound", Val);
    });

    return inbound + outbound;
};

TariffConfigFormViewController.prototype.GetAdvancedFormDataJSON = function(NeedToValidate)
{
    var _this = this;
    var type = this.Views[this.FormViews[2] + "Hierarchy"].elements.type.getValue().toLowerCase();
    if(!type || type == "0")
    {
        type = "htb";
    }
    var inbound = "";
    var outbound = "";

    var data = this.Views.AdvancedClassesTable.serialize(false);

    if(type != "tbf" && NeedToValidate)
    {
        var valid = this.ValidateForm(data);
        if(!valid)
            return null;
    }

    var result = new PolicingConfigModel({
        type: type.toUpperCase()
    });

    var SetConfig = function(Direction, Object)
    {
        var isStatic = Object[Direction + "_ceil"] == "static";
        if(Object.class == "root")
        {
            result[Direction].root_rate = Object[Direction + "_rate"];
            result[Direction].root_burst = Object[Direction + "_burst"];
            if(type == "htb")
            {
                result[Direction].root_cburst = Object[Direction + "_cburst"];
                result[Direction].root_ceil = Object[Direction + "_ceil"];
            }
        }
        else
        {
            result[Direction].classes[Object.class].rate = Object[Direction + "_rate"];
            if(!isStatic)
                result[Direction].classes[Object.class].burst = Object[Direction + "_burst"];

            if(type == "htb")
            {
                result[Direction].classes[Object.class].ceil = Object[Direction + "_ceil"];

                if(!isStatic)
                    result[Direction].classes[Object.class].cburst = Object[Direction + "_cburst"];
            }

            result[Direction].classes[Object.class].enabled = type == "htb" ? 1 : Object[Direction + "_enabled"];
        }
    };
    data.forEach(function(Val)
    {
        SetConfig("inbound", Val);
        SetConfig("outbound", Val);
    });
    // var getConfigString = function(Direction, Object)
    // {
    //     var isStatic = false;
    //     var str = type + (Direction === "inbound"? ("_" + Direction) : "") + "_";
    //     str += (Object.class !== "root" ?  "class": "") + Object.class + "=";
    //
    //     if(Object[Direction + "_rate"])
    //         str += "rate " + Object[Direction + "_rate"];
    //
    //     if(type !== "tbf" && Object[Direction + "_ceil"])
    //     {
    //         str += " ";
    //         if(Object[Direction + "_ceil"] !== "static")
    //         {
    //             str += "ceil ";
    //         }
    //         else
    //         {
    //             isStatic = true;
    //         }
    //         str += Object[Direction + "_ceil"];
    //     }
    //
    //     if(!isStatic)
    //     {
    //         if(Object[Direction + "_burst"])
    //             str += " burst " + Object[Direction + "_burst"];
    //
    //         if(type !== "tbf")
    //         {
    //             if(Object[Direction + "_cburst"])
    //                 str += " cburst " + Object[Direction + "_cburst"];
    //         }
    //     }
    //     str += "\n";
    //
    //     return str;
    // };
    // data.forEach(function(Val)
    // {
    //     inbound += getConfigString("inbound", Val);
    //     outbound += getConfigString("outbound", Val);
    // });

    return result;
};

TariffConfigFormViewController.prototype.SetEditorFormData = function()
{
    var _this = this;
    var form = $$(this.FormViews[3]);
    if(!form)
        return;
    // form.elements['config_text'].setValue('');
    form.elements['config_text'].setValue(this.GetConfigText());
    form.setDirty(0);
    Helper.RefreshView(form);

};

TariffConfigFormViewController.prototype.GetConfigText = function(Data)
{
  var _this = this;
    var text = "";

    var data = webix.copy(Data ? Data : this.Data);
    var type = data.type.toLowerCase();
    for(var i in data)
    {
        if(typeof data[i] === "object")
        {
            var typeStr = type + (i == "inbound" ? ("_" + i) : "")
            if(data.type != "TBF")
            {
                text += typeStr + "_root=";
                text += "rate " + data[i].root_rate;
                if(data[i].root_ceil)
                {
                    text += " ceil " + data[i].root_ceil;
                }
                if(data[i].root_burst)
                {
                    text += " burst " + data[i].root_burst;
                }
                if(data[i].root_cburst)
                {
                    text += " cburst " + data[i].root_cburst;
                }

                text += "\n";
            }
            var classes = data[i].classes

            data[i].classes.forEach(function(Class, n){
                if(!(data.type == "TBF" && !Class.enabled))
                {
                    text += typeStr + "_class" + Class.class + "=";
                    var isStatic = false;
                    text += "rate " + Class.rate;

                    if(data.type != "TBF")
                    {
                        if(Class.ceil)
                        {
                            text += " ";
                            if(Class.ceil == "static")
                            {
                                isStatic = true;

                            }
                            else
                            {
                                text += "ceil "
                            }
                            text += " " + Class.ceil;
                        }
                    }

                    if(!isStatic)
                    {
                        if(Class.burst)
                        {
                            text += " " + "burst " + Class.burst;
                        }

                        if(data.type != "TBF" && Class.cburst)
                        {
                            text += " " + "cburst " + Class.cburst;
                        }
                    }


                    text += "\n";
                }

            });
        }
    }

    return text;
};

TariffConfigFormViewController.prototype.GetEditorFormData = function()
{
    var _this = this;
    var form = $$(this.FormViews[3]);
    if(form.validate())
    {
        return form.elements.config_text.getValue();
    }

    return null;
};

TariffConfigFormViewController.prototype.GetEditorFormDataJSON = function()
{
    var _this = this;
    var form = $$(this.FormViews[3]);
    if(form.validate())
    {
        var result = new PolicingConfigModel({});
        var data = form.elements.config_text.getValue();

        var split = data.split("\n");
        split.forEach(function(Val) {
           var parts = Val.split("=");
           if(parts.length == 2)
           {
               var part = parts[0].split("_");
               result.type = part[0].toUpperCase();
               var direction = "outbound";
               var cl = "root";
               if(part.length == 3)
               {
                   var direction = part[1];
                   cl = part[2] == "root" ? part[2] : parseInt(part[2].replace("class", ""));
               }
               else{
                   cl = part[1] == "root" ? part[1] : parseInt(part[1].replace("class", ""));
               }

               var valArr = parts[1].match(/[a-zA-Z]+|[0-9\.]+/g);
               if(valArr && Array.isArray(valArr) && valArr.length)
               {
                   for (var i = 0; i < valArr.length; i = i + 3)
                   {
                       if(cl == "root")
                       {
                           result[direction]["root_" + valArr[i]] = valArr[i+1] + valArr[i+2];
                       }
                       else{
                           if(valArr[i] == "static")
                           {
                               result[direction].classes[cl].ceil = valArr[i];
                           }
                           else
                           {
                               result[direction].classes[cl][valArr[i]] = valArr[i+1] + valArr[i+2];
                           }
                       }
                   }

                   if(cl != "root")
                   {
                       result[direction].classes[cl].enabled = 1;
                   }

               }
           }
        });

    }

    return result;
};

TariffConfigFormViewController.prototype.SetRootAndClassesVals = function(Data, Traffic)
{
  var _this = this;

    var getRootVals = function(Model)
    {
        var obj = {};
        for(var i in Model)
        {
            if(i.indexOf("root_") !== -1)
            {
                var vunit = _this.GetValAndUnitFromString(Model[i]);
                obj[i] = vunit.val;
                obj[i + "_unit"] = vunit.unit;
            }
        }

        return obj;
    };

    var root = getRootVals(Data);
    this.Views["ConfigFormView" + Traffic + "Root"].clearAll();
    this.Views["ConfigFormView" + Traffic + "Root"].parse(root);

    var classes = [];


    Data.classes.forEach(function(Val, i)
    {
        var obj = {};
        obj.class = Val.class;

        classProps.forEach(function(Prop){
            var vunit = _this.GetValAndUnitFromString(Val[Prop]);
            obj[Prop] = vunit.val;
            obj[Prop + "_unit"] = vunit.unit;
        });
        classes[i] = obj;
    });

    this.Views["ConfigFormView" + Traffic + "Classes"].clearAll();
    this.Views["ConfigFormView" + Traffic + "Classes"].parse(classes);
};

TariffConfigFormViewController.prototype.GetValAndUnitFromString = function(String)
{
    var obj = {
        val: 8,
        unit: TrafficUnits[1].id
    };

    if(!String)
    {
        return obj;
    }

    var match = String.match(/\d+/);
    if(match && match[0])
    {
        obj.val = match[0];
        obj.unit = String.replace(obj.val,"");
    }

    return obj;
};

TariffConfigFormViewController.prototype.GetClassesDataAsTableObjects = function()
{
    var _this = this;
    var arr = [];
    var data = webix.copy(this.Data);

    for(var i in data)
    {
      if(typeof data[i] === "object")
      {
          data[i].classes.forEach(function(Val)
          {
             if(!arr[Val.class])
             {
                 arr[Val.class] = {};
                 arr[Val.class].class = Val.class;
             }

             for(var prop in Val)
             {
                 if(prop !== "id" && prop !== "class")
                 {
                     arr[Val.class][i + "_" + prop] = Val[prop];
                     // var model = _this.GetValAndUnitFromString(Val[prop]);
                     // arr[Val.class][i + "_" + prop] = model.val;
                     // arr[Val.class][i + "_" + prop + "_unit"] = model.unit;
                 }
             }
          });
      }
    }
    return arr;
};

TariffConfigFormViewController.prototype.GetRootDataAsTableObject = function()
{
    var obj = {};
    var data = webix.copy(this.Data);
    obj.class = "root";
    for(var i in data)
    {
        if(typeof  data[i] === "object")
        {
            for(var prop in data[i])
            {
                if(prop !== "classes" && prop !== "id")
                {
                    var _prop = prop.replace("root", "");

                    obj[i + _prop] = data[i][prop];
                }
            }
        }
    }

    return obj;
};

TariffConfigFormViewController.prototype.ShowConfigClassEditForm = function (Data, Node, Pos, Advanced, IsTBF)
{
    "use strict";
    var _this = this;

    App.NavRouter.PresentModalView({
        id: "TariffsClassConfigFormView",
        data: Data,
        advanced:Advanced,
        tbf:IsTBF,
        dpiConfig: this.DpiConfig
    });

    App.NavRouter.views.TariffClassConfigForm.Show(Node,Pos);

    this.Subscriptions.ClassEditFormSaveDataSinal = App.NavRouter.views.TariffClassConfigForm.SaveDataSinal.subscribe(function (DataToSave)
    {
        if(DataToSave)
        {
            _this.DataUpdated = true;
            if(Advanced)
            {
                _this.Views.AdvancedClassesTable.updateItem(DataToSave.id, DataToSave);

            }
            else
            {
                _this.Views.CommonClassesTable.updateItem(DataToSave.id, DataToSave);
            }
            _this.OnDataUpdated.next(1);

        }
    });
};

TariffConfigFormViewController.prototype.GetFormData = function()
{
    var _this = this;

    var dataToSave = null;
    var formType = this.GetSelectedView();

    switch (formType)
    {
        case this.FormViews[0]:
            dataToSave = _this.GetSimpleFormData();
            break;
        case this.FormViews[1]:
            dataToSave = _this.GetCommonFormData();
            break;
        case this.FormViews[2]:
            dataToSave = _this.GetAdvancedFormData();
            break;
        case this.FormViews[3]:
            dataToSave = _this.GetEditorFormData();
            break;
    }

    return {
        success: dataToSave ? 1 : 0,
        data: dataToSave
    };
};

TariffConfigFormViewController.prototype.ValidateForm = function(Data)
{
    var _this = this;

    var check = function(Direction)
    {
        var maxSumm = 0;
        var summ = 0;
        Data.forEach(function(Val)
        {
            var uval = Helper.GetTrafficValAndUnitFromString(Val[Direction + "_rate"]);
            if(Val.class == "root")
            {
                maxSumm = uval.val * TrafficVals[uval.unit].value;
            }
            else if(Val[Direction + "_rate"] != "8bit")
            {
                if(Val[Direction + "_ceil"] != "static")
                    summ += uval.val * TrafficVals[uval.unit].value;
            }
        });

        return maxSumm >= summ;
        // if(summ > maxSumm)
        // {
        //     return false;
        // }
        //
        // return true;
    };

    if(!check("inbound"))
        return false;

    if(!check("outbound"))
        return false;

    // return false;
    return true;
};

TariffConfigFormViewController.prototype.RefreshViews = function()
{
    var _this = this;

    Helper.RefreshView(this.Views.CommonClassesTable);
    Helper.RefreshView(this.Views.AdvancedClassesTable);
};

TariffConfigFormViewController.prototype.DeleteShitFromConfig = function(Data)
{
  var _this = this;
  var result = {};

  for(var i in Data)
  {
      if(i != "id" && (Data[i] || i == "class"))
      {
          if (Array.isArray(Data[i]))
          {
              result[i] = [];
              for(var j in Data[i])
              {
                  result[i][parseInt(j)] = _this.DeleteShitFromConfig(Data[i][j])
                  // result[i].push();
              }
          }
          else if(typeof Data[i] == "object")
          {
            result[i] = _this.DeleteShitFromConfig(Data[i]);
          }
          else{
              result[i] = Data[i];
          }

      }
  }

  return result;
};

TariffConfigFormViewController.prototype.GetFormDataJSON = function(Params)
{
    var _this = this;

    var dataToSave = null;
    var formType = this.GetSelectedView();

    switch (formType)
    {
        case this.FormViews[0]:
            dataToSave = _this.GetSimpleFormDataJSON();
            break;
        case this.FormViews[1]:
            dataToSave = _this.GetCommonFormDataJSON();
            break;
        case this.FormViews[2]:
            dataToSave = _this.GetAdvancedFormDataJSON();
            break;
        case this.FormViews[3]:
            dataToSave = _this.GetEditorFormDataJSON();
            break;
    }

    if(dataToSave)
    {
        return ({
            data: this.Data,
            config: _this.DeleteShitFromConfig(dataToSave)
        });
    }
    else
    {
        webix.message({text: LangHelper.GetString(this.Id, "Class rate summ should be less then root rate!"),type:"error"});
    }

    return;
};
function TariffClassConfigFormViewController(Params) {
    "use strict";

    var _this = this;
    this.Id = "Tariffs";

    this.id = this.Id + "ClassConfigFormView";

    this.Data = null;

    this.Views = {};

    this.Subscriptions = {};

    this.SaveDataSinal = new Rx.BehaviorSubject(null);

    this.Rows = [];

    this.OnlyInbound = Params  && Params.onlyInbound ? Params.onlyInbound : false;
    this.OnlyOutbound = Params  && Params.onlyOutbound ? Params.onlyOutbound : false;

    this.DontDestroyOnHide = Params && Params.DontDestroyOnHide ? Params.DontDestroyOnHide : false;

    this.ContextConfig = {
        view: "popup",
        minWidth: 240,
        minHeight: 240,
        id:this.id + "Context",
        body: {
            view:"form",
            minWidth: 400,
            id: this.id + "Context" + "Form",
            borderless:true,
            elements:[]
        }
    };

    this.Context = null;

    this.Advanced = false;
    this.TBF = false;
    this.DpiConfig = false;

    this.Init(Params);

    return this;
}

TariffClassConfigFormViewController.prototype.Init = function (Params) {
    "use strict";


    var _this = this;
    if(Params && Params.advanced)
    {
        this.Advanced = Params.advanced;
    }

    if(Params && Params.tbf)
    {
        this.TBF = Params.tbf;
    }

    if(Params && Params.dpiConfig)
    {
        this.DpiConfig = Params.dpiConfig;
    }

    if(Params && Params.data)
    {
        this.Data = Params.data;
    }

    this.ConfigRows();

    this.ContextConfig.body.elements = this.Rows;
    this.Context = webix.ui(this.ContextConfig);
};

TariffClassConfigFormViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    var _this = this;

    this.BindAll(Params);

    if(this.Data)
    {
        this.SetData();
    }
};

TariffClassConfigFormViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

TariffClassConfigFormViewController.prototype.BindAll = function (Params) {
    "use strict";
    var _this = this;
    
    this.Views.Form = $$(this.id + "Context" + "Form");

    this.Views.InboundStaticCeilCb = $$(this.id + "StaticCeilInbound");
    this.Views.OutboundStaticCeilCb = $$(this.id + "StaticCeilOutbound");

    this.Views.EnabledOutbound = $$(this.id + "EnabledOutbound");
    this.Views.EnabledInbound = $$(this.id + "EnabledInbound");

    if(this.Views.EnabledOutbound)
    {
        this.Views.EnabledOutbound.attachEvent("onChange", function(newv)
        {
            if(newv)
            {
                _this.Views.Form.elements.outbound_rate.enable();
                _this.Views.Form.elements.outbound_rate_unit.enable();
                _this.Views.Form.elements.outbound_burst.enable();
                _this.Views.Form.elements.outbound_burst_unit.enable();
            }
            else{
                _this.Views.Form.elements.outbound_rate.disable();
                _this.Views.Form.elements.outbound_rate_unit.disable();
                _this.Views.Form.elements.outbound_burst.disable();
                _this.Views.Form.elements.outbound_burst_unit.disable();
            }
        });
    }

    if(this.Views.EnabledInbound)
    {
        this.Views.EnabledInbound.attachEvent("onChange", function(newv)
        {
            if(newv)
            {
                _this.Views.Form.elements.inbound_rate.enable();
                _this.Views.Form.elements.inbound_rate_unit.enable();
                _this.Views.Form.elements.inbound_burst.enable();
                _this.Views.Form.elements.inbound_burst_unit.enable();
            }
            else{
                _this.Views.Form.elements.inbound_rate.disable();
                _this.Views.Form.elements.inbound_rate_unit.disable();
                _this.Views.Form.elements.inbound_burst.disable();
                _this.Views.Form.elements.inbound_burst_unit.disable();
            }
        });
    }

    if(this.Views.InboundStaticCeilCb)
    {
        this.Views.InboundStaticCeilCb.attachEvent("onChange", function(newv)
        {
            if(newv)
            {
                 _this.Views.Form.elements.inbound_ceil.setValue("static");
                 _this.Views.Form.elements.inbound_ceil.disable();
                 _this.Views.Form.elements.inbound_ceil_unit.disable();

                if(_this.Views.Form.elements.inbound_burst)
                {
                    _this.Views.Form.elements.inbound_burst.disable();
                    _this.Views.Form.elements.inbound_burst_unit.disable();
                }
                if(_this.Views.Form.elements.inbound_cburst)
                {
                    _this.Views.Form.elements.inbound_cburst.disable();
                    _this.Views.Form.elements.inbound_cburst_unit.disable();
                }
            }
            else
            {

                _this.Views.Form.elements.inbound_ceil.enable();
                _this.Views.Form.elements.inbound_ceil_unit.enable();

                if(_this.Views.Form.elements.inbound_ceil.getValue() == "static")
                    _this.Views.Form.elements.inbound_ceil.setValue("8");

                if(_this.Views.Form.elements.inbound_burst)
                {
                    _this.Views.Form.elements.inbound_burst.enable();
                    _this.Views.Form.elements.inbound_burst_unit.enable();
                }
                if(_this.Views.Form.elements.inbound_cburst)
                {
                    _this.Views.Form.elements.inbound_cburst.enable();
                    _this.Views.Form.elements.inbound_cburst_unit.enable();
                }
            }
        });
    }
    if(this.Views.OutboundStaticCeilCb)
    {
        this.Views.OutboundStaticCeilCb.attachEvent("onChange", function(newv, oldv){
            if(newv)
            {
                _this.Views.Form.elements.outbound_ceil.setValue("static");
                _this.Views.Form.elements.outbound_ceil.disable();
                _this.Views.Form.elements.outbound_ceil_unit.disable();

                if(_this.Views.Form.elements.outbound_burst)
                {
                    _this.Views.Form.elements.outbound_burst.disable();
                    _this.Views.Form.elements.outbound_burst_unit.disable();
                }
                if(_this.Views.Form.elements.outbound_cburst)
                {
                    _this.Views.Form.elements.outbound_cburst.disable();
                    _this.Views.Form.elements.outbound_cburst_unit.disable();
                }
            }
            else
            {

                _this.Views.Form.elements.outbound_ceil.enable();
                _this.Views.Form.elements.outbound_ceil_unit.enable();

                if(_this.Views.Form.elements.outbound_ceil.getValue() == "static")
                    _this.Views.Form.elements.outbound_ceil.setValue("8");

                if(_this.Views.Form.elements.outbound_burst)
                {
                    _this.Views.Form.elements.outbound_burst.enable();
                    _this.Views.Form.elements.outbound_burst_unit.enable();
                }
                if(_this.Views.Form.elements.outbound_cburst)
                {
                    _this.Views.Form.elements.outbound_cburst.enable();
                    _this.Views.Form.elements.outbound_cburst_unit.enable();
                }
            }
        });
    }

    if(this.Context && !this.DontDestroyOnHide)
    {
        this.Context.attachEvent("onHide", function()
        {
            _this.Destroy();
        });
    }
};

TariffClassConfigFormViewController.prototype.ConfigRows = function()
{
    var _this = this;

    var getInputTemplate = function(Type, Label, Required, Static)
    {
        var result = {
            cols:[
            ]
        };

        result.cols = result.cols.concat([
            {
                view: "text",
                name: Type + "_" + Label.toLowerCase(),
                label: Label,
                labelPosition: "top",
                required: Required,
                validate: function(Val)
                {
                    if(!Val && Required)
                    {
                        return false;
                    }
                    else if(!Val && !Required)
                    {
                        return true;
                    }

                    var val = parseInt(Val);
                    return Helper.IsInteger(val) && val > 0;
                },
                invalidMessage: LangHelper.GetString(_this.Id, "Value should be positive integer number!")
            },
            {
                view: "richselect",
                name: Type + "_" + Label.toLowerCase() + "_unit",
                width: 80,
                label: "",
                labelPosition: false,
                options: Helper.DictToArr(Label == "Burst" || Label == "Cburst" ? BufferUnits : TrafficUnits)
            }
        ]);

        if(Static)
        {
            result.cols.push(
                {
                    view: "checkbox",
                    name: Type + "_" + Label.toLowerCase() + "_static",
                    label: "Static",
                    labelPosition: "left",
                    id: _this.id + "Static" + Label + Type[0].toUpperCase() + Type.substr(1, Type.length - 1)
                }
            );
        }

        return result;
    };
    var inbound = [
        {
            cols:[
                {
                    view: "label",
                    label: LangHelper.GetString(this.Id, "Inbound")
                }
            ]
        },
        getInputTemplate("inbound", "Rate", true)
    ];

    var outbound = [
        {
            cols:[
                {
                    view: "label",
                    label: LangHelper.GetString(this.Id, "Outbound")
                }
            ]
        },
        getInputTemplate("outbound", "Rate", true)
    ];

    if(!this.TBF)
    {
        inbound.push(getInputTemplate("inbound", "Ceil",this.Data.class !== "root", this.Data.class !== "root"));
        outbound.push(getInputTemplate("outbound", "Ceil",this.Data.class !== "root", this.Data.class !== "root"));
    }

    if(this.Advanced)
    {
        if(this.TBF)
        {
            var colsIn = [getInputTemplate("inbound", "Burst")];
            var colsOut = [getInputTemplate("outbound", "Burst")];
            if (this.DpiConfig)
            {
                inbound.push(getInputTemplate("inbound", "Peakrate"));
                outbound.push(getInputTemplate("outbound", "Peakrate"));

                colsIn.push(getInputTemplate("inbound", "Cburst"));
                colsOut.push(getInputTemplate("outbound", "Cburst"));
            }
            else{
                inbound[0].cols.splice(0,0,{
                    view: "checkbox",
                    name: "inbound_enabled",
                    width:32,
                    label: "", //LangHelper.GetString("Dics", "Enabled"),
                    labelPosition: "left",
                    id: _this.id + "EnabledInbound"
                });
                // inbound.splice(1, 0, {
                //     view: "checkbox",
                //     name: "inbound_enabled",
                //     label: "", //LangHelper.GetString("Dics", "Enabled"),
                //     labelPosition: "left",
                //     id: _this.id + "EnabledInbound"
                // });
                outbound[0].cols.splice(0,0,{
                    view: "checkbox",
                    width:32,
                    name: "outbound_enabled",
                    label: "",//LangHelper.GetString("Dics", "Enabled"),
                    labelPosition: "left",
                    id: _this.id + "EnabledOutbound"
                });
                // outbound.splice(1, 0, {
                //     view: "checkbox",
                //     name: "outbound_enabled",
                //     label: "",//LangHelper.GetString("Dics", "Enabled"),
                //     labelPosition: "left",
                //     id: _this.id + "EnabledOutbound"
                // });
            }

            inbound.push({
                cols: colsIn
            });
            outbound.push({
                cols: colsOut
            });


        }
        else
        {
            inbound.push({
                cols:[
                    getInputTemplate("inbound", "Burst"),
                    getInputTemplate("inbound", "Cburst")
                ]
            });
            outbound.push({
                cols:[
                    getInputTemplate("outbound", "Burst"),
                    getInputTemplate("outbound", "Cburst")
                ]
            });
        }
    }

    var res = [];

    if(!this.OnlyOutbound)
    {
        res = res.concat(inbound);
    }

    if(!this.OnlyInbound)
    {
        res = res.concat(outbound);
    }

    res.push(this.GetButtonsTemplate());

    // outbound.push(this.GetButtonsTemplate());
    // this.Rows = inbound.concat(outbound);
    this.Rows = res;
};

TariffClassConfigFormViewController.prototype.GetButtonsTemplate = function()
{
  var _this = this;
  return {
      cols: [
          {},
          {
              view: "button",
              id: _this.id + "CancelButton",
              label: LangHelper.GetString("All", "Close"),
              click: function ()
              {
                  _this.Hide();
              }
          },
          {
              view: "button",
              type: "form",
              label: LangHelper.GetString("All", "Apply"),
              click: function ()
              {
                  if(_this.Save())
                      _this.Hide();
              }
          }
      ]
  };
};

TariffClassConfigFormViewController.prototype.SetData = function()
{
  var _this = this;
  var obj = {};
  for(var i in this.Data)
  {
      if(i !== "id" && i !== "class")
      {
          if(!this.Data[i])
          {
              obj[i] = this.Data[i];
              obj[i + "_unit"] = TrafficUnits[1].id;
          }
          else if(this.Data[i] !== "static")
          {
              var model = Helper.GetTrafficValAndUnitFromString(this.Data[i]);
              obj[i] = model.val;
              obj[i + "_unit"] = model.unit;
          }
          else{
              obj[i] = this.Data[i];
              obj[i + "_static"] = 1;
              obj[i + "_unit"] = TrafficUnits[1].id;
          }

      }
  }
  this.Views.Form.setValues(obj);
};

TariffClassConfigFormViewController.prototype.Save = function()
{
    var _this = this;

    if(this.Views.Form.validate())
    {
        var static = false;

        for(var i in this.Views.Form.elements)
        {
            if(this.Data.hasOwnProperty(i) || (this.OnlyInbound || this.OnlyOutbound))
            {
                var val = this.Views.Form.elements[i].getValue();
                this.Data[i] = val;
                if(val)
                {
                    if(val != "static" && this.Views.Form.elements[i + "_unit"])
                    {
                        this.Data[i] += this.Views.Form.elements[i + "_unit"].getValue();
                    }
                    else
                    {
                        static = true;
                    }
                }
            }
        };

        if(static)
        {
            for(var i in this.Data)
            {
                if(this.Data[i] == "static")
                {
                    var dir = i.split("_")[0];

                    this.Data[dir + "_burst"] = "";
                    this.Data[dir + "_cburst"] = "";
                }
            }
        }

        this.SaveDataSinal.next(this.Data);
        return true;
    }
    return false;
};

TariffClassConfigFormViewController.prototype.Show = function(Node, Pos)
{
    if(this.Context)
    {
        this.Context.show(Node, {pos:Pos});
    }
};

TariffClassConfigFormViewController.prototype.Hide = function()
{
    this.Context.hide();
};

TariffClassConfigFormViewController.prototype.SetDataFromStr = function(Str)
{
    var _this = this;

    var split = Str.split(" ");

    var prefix = this.OnlyInbound ? "inbound_" : "outbound_";

    for(var i=0; i < split.length; i=i+2)
    {
        var next = i+1;

        if(split[i] != "static")
        {
            _this.Data[prefix + split[i]] = split[next];

        }
        else
        {
            _this.Data[prefix + "ceil"] = "static";
            break;
        }
    }
    _this.SetData();
};

TariffClassConfigFormViewController.prototype.GetDataAsString = function()
{
    var _this = this;

    var data = webix.copy(this.Data);

    var prefix = this.OnlyInbound ? "inbound_" : "outbound_";

    var result = "";

    var isStatic = false;
    //
    result += "rate " + data[prefix + "rate"];

    //
    if(!this.TBF)
    {
        if(data[prefix + "ceil"])
        {
            result += " ";
            if(data[prefix + "ceil"] == "static")
            {
                isStatic = true;
            }
            else
            {
                result += "ceil "
            }
            result += data[prefix + "ceil"];
        }
    }
    //
    if(!isStatic)
    {
        if(data[prefix + "burst"])
        {
            result += " " + "burst " + data[prefix + "burst"];
        }

        if(!this.TBF && data[prefix + "cburst"])
        {
            result += " " + "cburst " + data[prefix + "cburst"];
        }
    }

    return result;
};
/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */
function AdvcViewController(Params) {
    "use strict";
    var _this = this;
    this.Id = "Advc";

    this.Advs = [];
    this.AdvcManager = new AdvcManager();

    this.AdvcProcessedSubscribersManager = new AdvcProcessedSubscribersManager();


    this.ProfilesPaging = null;
    this.CampaignPaging = null;
    this.SubscribersPaging = null;

    this.Users = [];
    this.Hardwares = [];

    this.Subscriptions = {};
    this.Subscriptions.SignalUsersDicUpdatedSubscription = null;
    this.Subscriptions.SignalCurrentHardwareUpdated = null;
    this.Subscriptions.SignalSaveCompany = null;
    this.Subscriptions.SignalSelectedCampaignsCountChange = null;
    this.Subscriptions.SignalSelectedProfilesCountChange = null;
    this.Subscriptions.SignalSelectedSubscribersCountChange = null;

    this.ProfileSelectedCountChange = new Rx.BehaviorSubject(0);
    // this.CompanySelectedChanges = new Rx.BehaviorSubject(0);
    this.CampaignSelectedDataCount = new Rx.BehaviorSubject(0);
    this.SubscribersSelectedCountChange = new Rx.BehaviorSubject(0);

    this.Views = {
        ProfileAddContext:null,
        ProfilesListTable: null,
        ProfileEditForm: null,
        AddSubProfileBtn: null,
        CampaignListTable: null,
        CompanyListAddBtn: null,
        CompanyEditForm: null,
        CompanyDeleteContext: null,
        CompanyParamsListTable: null,
        CampaignDataDeleteContext: null,
        CampaignDataImportContextUploader: null,
        CampaignDataImportContextTable: null,
        SubscribersParamsView: null,
        SubscribersParamsViewResizer: null,
        SubscribersParamsTable: null,
        RefreshCampaignsBtn: null,
        SubscriberEditForm: null,
        VchannelEditForm: null,
        CompanyPlayBtn: null,
        CompanyStopBtn: null,
        SubscriberParamsAddBtn: null,
        ImportSubscribersListBtn: null,
        CampaignDataImportContextImportBtn: null,
        SubscribersParamsViewResetSubscriber: null,
        CompanyResetButton: null

    };

    this.CampaignDataImportContext = webix.ui({
        view:"popup",
        modal:true,
        width:800,
        height:600,
        body:{
            view:"form",
            id:this.Id + "CampaignDataImportContextForm",
            borderless: true,
            elements:[
                {
                    view:"uploader",
                    value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                    id:this.Id + "CampaignDataImportContextUploader",
                    css:"upload_area",
                    autosend:false,
                    height:64
                },
                {
                    view:"datatable",
                    id:this.Id + "CampaignDataImportContextTable",
                    checkboxRefresh: true,
                    on:{
                        onItemClick: function(id)
                        {
                            if(id.column === 'trash')
                            {
                                var __this = this;
                                setTimeout(function () {
                                    _this.Views.CampaignDataImportContextTable.remove(id.row);
                                    _this.OnSubscribersToImportChange(_this.Views.CampaignDataImportContextTable.count());
                                }, 10);
                            }
                        }
                    },
                    columns:[
                        {
                            id: "subscriber",
                            header: "subscriber"
                        }

                    ]
                },
                {
                    cols:[
                        {
                            view: "button",
                            label: LangHelper.GetString(_this.Id, "Get template"),
                            click: function()
                            {
                                _this.GetImportFileTemplate();
                            }
                        },
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.Views.CampaignDataImportContextTable.clearAll();
                                _this.CampaignDataImportContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id:this.Id + "CampaignDataImportContext" + "ImportBtn",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Import"),
                            click:function ()
                            {
                                _this.CampaignDataImportContext.hide();
                                _this.SaveImportedExceldata();
                                // _this.ClearImportCampaignData();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.SubscriberDeleteContext = webix.ui(
        {
            view:"popup",
            width:300,
            height:200,
            id: this.Id + "SubscriberDeleteContext",
            body:{
                view:"form",
                borderless:true,
                elements:[
                    {
                        template:LangHelper.GetString(this.Id,"Are you sure you want to delete this subscriber from campaign?")
                    },
                    {
                        cols:[
                            {},
                            {
                                view:"button",
                                label:LangHelper.GetString(this.Id,"Cancel"),
                                click:function () {
                                    _this.SubscriberDeleteContext.hide();
                                }
                            },
                            {
                                view:"button",
                                type:"form",
                                label:LangHelper.GetString(this.Id,"Delete"),
                                click:function () {
                                    _this.SubscriberDeleteContext.hide();

                                    var selected = _this.Views.SubscribersParamsTable.getSelectedItem();
                                    if(selected)
                                        _this.DeleteSubscriber(selected.id);
                                }
                            }
                        ]
                    }
                ]
            }
        }
    );

    this.ProfileDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete this group? All advertising campaigns associated with this group will be deleted.")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ProfileDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function () {
                                _this.ProfileDeleteContext.hide();

                                var selected = _this.GetProfilesTableSelectedData();

                                if(selected)
                                {
                                    if(Array.isArray(selected))
                                    {
                                        selected.forEach(
                                            function(Val)
                                            {
                                                _this.DeleteProfile(Val.id);
                                            }
                                        )
                                    }
                                    else{
                                        _this.DeleteProfile(selected.id);
                                    }
                                }
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ProfileEditContext = webix.ui({
        view: "popup",
        body: {
            view: "form",
            id: this.Id + "ProfileEditForm",
            borderless: true,
            width: 400,
            elements: [
                {
                    view: "text",
                    name: "title",
                    label: LangHelper.GetString(this.Id,"Title"),
                    labelPosition: "top",
                    invalidMessage: LangHelper.GetString(this.Id, "Title can not be empty"),
                    required: true
                },
                {

                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ProfileEditContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Save"),
                            click:function () {
                                if(_this.SaveProfile())
                                    _this.ProfileEditContext.hide();
                            }
                        }
                    ]
                }
            ],
            rules:{
                "title" : webix.rules.isNotEmpty
            }
        }
    });

    this.SubscribersEditContext = webix.ui({
        view: "popup",
        body:{
            view: "form",
            id: this.Id + "SubscriberEditForm",
            borderless: true,
            width: 400,
            elements:[
                {
                    view: "text",
                    name: "login",
                    label: LangHelper.GetString(this.Id,"Subscriber"),
                    labelPosition: "top",
                    required: true,
                    invalidMessage: LangHelper.GetString(this.Id, "Subscriber should be filled!")
                    //suggest: []
                },
                {
                    cols:[
                        {},
                        {
                            view: "button",
                            label: LangHelper.GetString(this.Id, "Cancel"),
                            click: function()
                            {
                                _this.SubscribersEditContext.hide();
                            }
                        },
                        {
                            view: "button",
                            type: "form",
                            label: LangHelper.GetString(this.Id, "Save"),
                            click: function()
                            {
                                if(_this.Views.SubscriberEditForm.validate())
                                {
                                    _this.SaveSubscriberData();
                                    _this.SubscribersEditContext.hide();
                                }
                            }
                        }
                    ]
                }
            ],
            rules: {
                "login": webix.rules.isNotEmpty
            }

        }
    });

    this.CampaignEditContext = new AdvcCampaignEditViewController();

    this.CampaignDeleteContext = webix.ui({
        id: this.Id + "CompanyDeleteContext",
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete this campaign?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.CampaignDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function () {
                                _this.CampaignDeleteContext.hide();
                                var selected = _this.GetCompanyTableSeletedData();
                                if(selected)
                                {
                                    if(Array.isArray(selected))
                                    {
                                        selected.forEach(
                                            function(Val)
                                            {
                                                _this.DeleteCompany(Val.id);
                                            }
                                        )
                                    }
                                    else{
                                        _this.DeleteCompany(selected.id);
                                    }
                                }

                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols: [
                ServicesLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                PageHeaderTemplate({root_title:LangHelper.GetString(this.Id,"Service Management"),title:LangHelper.GetString(this.Id,"Advertising")}),
                                {
                                    view: "accordion",
                                    multi: "mixed",
                                    on: {
                                        onAfterExpand: function(id) {
                                            _this.RefreshViews();
                                            return true;
                                        },
                                        onAfterCollapse: function(id)
                                        {
                                            _this.RefreshViews();
                                            return true;
                                        }
                                    },
                                    cols: [
                                        {
                                            header: LangHelper.GetString(this.Id,"Groups and campaigns"),
                                            id: this.Id + "ProfileAccord",
                                            gravity: 2/3,
                                            body: {
                                                cols: [
                                                    {
                                                        width:300,
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                elements: [
                                                                    {
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "plus",
                                                                        css:"toolbar_round_btn",
                                                                        width:32,
                                                                        tooltip:LangHelper.GetString(this.Id,"Add new adv group"),
                                                                        click:function (id)
                                                                        {
                                                                            _this.AddProfileToListTable();
                                                                        }
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "AddSubProfileBtn",
                                                                        type: "icon",
                                                                        icon: "plus-square",
                                                                        align: "right",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString(this.Id,"Add adv sub group"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.AddSubProfileToListTable();
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "HardSyncCompanies",
                                                                        type: "icon",
                                                                        icon: "cloud-download-alt",
                                                                        align: "right",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString(this.Id,"Forced campaign synchronization"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ForceSyncCompaies();
                                                                        }
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id+"refreshProfilesBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString(this.Id, "Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshProfiles();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Groups"), icon:"file"}),
                                                            {
                                                                id: _this.Id + "ProfileListTable",
                                                                view: "treetable",
                                                                select: "row",
                                                                multiselect:true,
                                                                on: {
                                                                    onItemClick: function (id)
                                                                    {
                                                                        if(id.column === 'edit')
                                                                        {
                                                                            if(Array.isArray(_this.GetProfilesTableSelectedData()))
                                                                            {
                                                                                return;
                                                                            }
                                                                            var rowData = this.getItem(id);
                                                                            _this.ShowProfileEditForm(rowData,_this.Views.ProfilesListTable.getItemNode(rowData.id), "right");
                                                                        }
                                                                        else if(id.column === 'trash')
                                                                        {
                                                                            var __this = this;
                                                                            setTimeout(function () {
                                                                                var model = _this.Views.ProfilesListTable.getItem(id.row);
                                                                                if(model && model.profile_id)
                                                                                {
                                                                                    var node = __this.getItemNode(id);
                                                                                    _this.ProfileDeleteContext.show(node, {pos:"bottom"});
                                                                                }
                                                                                else{
                                                                                    _this.DeleteProfile(id.row);
                                                                                }

                                                                            }, 10);
                                                                        }
                                                                    },
                                                                    onAfterSelect: function (data, preserve)
                                                                    {
                                                                        _this.OnSelectedProfileChange();
                                                                    },
                                                                    onAfterUnSelect: function(){
                                                                        _this.OnSelectedProfileChange();
                                                                    },
                                                                    onBeforeFilter:function()
                                                                    {
                                                                        return false;
                                                                    },
                                                                    onAfterFilter: function ()
                                                                    {
                                                                        _this.RefreshProfiles();
                                                                    },
                                                                    onBeforeSort:function()
                                                                    {
                                                                        _this.RefreshProfiles();
                                                                        return false;
                                                                    }
                                                                },
                                                                columns: [
                                                                    {
                                                                        id: "edit",
                                                                        header: "",
                                                                        width: 40,
                                                                        template: CellEditBtnTemplate,
                                                                        headermenu: false
                                                                    },
                                                                    {
                                                                        id: "title",
                                                                        header: [LangHelper.GetString(this.Id,"Group"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                        template: function(obj, common, value, config)
                                                                        {
                                                                            return common.treetable(obj, common, value, config) + (obj.title?obj.title:LangHelper.GetString(_this.Id,"Group")+" "+obj.adv_id);
                                                                        },
                                                                        fillspace: true,
                                                                        sort: "string"
                                                                    },
                                                                    {
                                                                        id: "trash",
                                                                        header: "",
                                                                        width: 40,
                                                                        template: CellTrashBtnTemplate,
                                                                        headermenu: false
                                                                    }
                                                                ],
                                                                data:[]
                                                            },
                                                            {

                                                                view: "pager",
                                                                id: this.Id+"ProfilesPaging",
                                                                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                                master:false,
                                                                on: {
                                                                    onAfterPageChange:function(Page)
                                                                    {
                                                                        _this.RefreshProfiles(Page);
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        view:"resizer"
                                                    },
                                                    {
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                elements: [
                                                                    {
                                                                        id: _this.Id + "CompanyListAddBtn",
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "plus",
                                                                        css:"toolbar_round_btn",
                                                                        width:32,
                                                                        tooltip:LangHelper.GetString(this.Id,"Add campaign"),
                                                                        click:function ()
                                                                        {
                                                                            // var __this = this;
                                                                            _this.AddCompanyToCompanyListTable();
                                                                        }
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "CompanyPlayBtn",
                                                                        type: "icon",
                                                                        icon: "play-circle",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString(_this.Id,"Start campaign"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            var data = _this.GetCompanyTableSeletedData();
                                                                            if(Array.isArray(data))
                                                                            {
                                                                                data.forEach(function(Val)
                                                                                {
                                                                                    _this.EnableCompany(Val);
                                                                                });
                                                                            }
                                                                            else{
                                                                                _this.EnableCompany(data);
                                                                            }

                                                                        }
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "CompanyStopBtn",
                                                                        type: "icon",
                                                                        icon: "stop-circle",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString(_this.Id,"Stop campaign"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            var data = _this.GetCompanyTableSeletedData();
                                                                            if(Array.isArray(data))
                                                                            {
                                                                                data.forEach(function(Val)
                                                                                {
                                                                                    _this.DisableCompany(Val);
                                                                                });
                                                                            }
                                                                            else{
                                                                                _this.DisableCompany(data);
                                                                            }
                                                                        }
                                                                    },
                                                                    {
                                                                        id: this.Id + "CompanyResetButton",
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "bolt",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString(_this.Id,"Restart campaign"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ResetCompany();
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id+"RefreshCampaignsBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString(this.Id, "Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshCompanies();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Campaigns"), icon:"bullhorn"}),
                                                            {
                                                                view: "datatable",
                                                                id:this.Id+"CampaignListTable",
                                                                resizeColumn: true,
                                                                select: "row",
                                                                multiselect:true,
                                                                // editable: true,
                                                                // editaction:"custom",
                                                                headermenu: {
                                                                    width: 350,
                                                                    autoheight: true,
                                                                    scroll: false
                                                                },
                                                                on: {
                                                                    onItemClick: function (id)
                                                                    {
                                                                        if(id.column === 'run')
                                                                        {
                                                                            var data = _this.Views.CampaignListTable.getItem(id);

                                                                            if(!data.adc_id)
                                                                            {
                                                                                return;
                                                                            }

                                                                            if(data.enabled)
                                                                            {
                                                                                setTimeout(function ()
                                                                                {
                                                                                    _this.DisableCompany(data);
                                                                                }, 10);
                                                                            }
                                                                            else if (data.status == AdvsStatesDic["4"].id)
                                                                            {
                                                                                setTimeout(function ()
                                                                                {
                                                                                    _this.ResetCompany();
                                                                                }, 10);
                                                                            }
                                                                            else
                                                                            {
                                                                                setTimeout(function ()
                                                                                {
                                                                                    _this.EnableCompany(data);
                                                                                }, 10);
                                                                            }
                                                                        }

                                                                        if(id.column === 'edit')
                                                                        {

                                                                            var rowData = this.getItem(id);
                                                                            _this.ShowCompanyEditForm(rowData,this.getItemNode(rowData.id), "right");
                                                                        }
                                                                        else if(id.column === 'trash')
                                                                        {
                                                                            var __this = this;
                                                                            setTimeout(function () {
                                                                                var model = _this.Views.CampaignListTable.getItem(id.row);
                                                                                if(model && model.adc_id)
                                                                                {
                                                                                    var node = __this.getItemNode(id);
                                                                                    _this.CampaignDeleteContext.show(node, {pos:"bottom"});
                                                                                }
                                                                                else{
                                                                                    _this.DeleteCompany(id.row);
                                                                                }
                                                                            }, 10);
                                                                        }
                                                                    },
                                                                    onAfterSelect: function (data, preserve)
                                                                    {
                                                                        _this.OnSelectedCampaignChange();
                                                                    },
                                                                    onAfterUnSelect: function(){
                                                                        _this.OnSelectedCampaignChange();
                                                                    },
                                                                    onBeforeFilter:function()
                                                                    {
                                                                        return false;
                                                                    },
                                                                    onAfterFilter: function ()
                                                                    {
                                                                        _this.RefreshCompanies();
                                                                    },
                                                                    onBeforeSort: function()
                                                                    {
                                                                        _this.RefreshCompanies();
                                                                    }
                                                                },
                                                                columns: [
                                                                    {
                                                                        id: "run",
                                                                        header: "",
                                                                        width: 32,
                                                                        template: function (obj, common)
                                                                        {
                                                                            if(obj.enabled === 1 && obj.adc_id)
                                                                            {
                                                                                return CellStopBtnTemplate();
                                                                            }

                                                                            if(obj.status == AdvsStatesDic["4"].id)
                                                                            {
                                                                                return CellBoltBtnTemplate();
                                                                            }

                                                                            if(obj.adc_id)
                                                                            {
                                                                                return CellPlayBtnTemplate();
                                                                            }

                                                                            return "";
                                                                        },
                                                                        headermenu: false
                                                                    },
                                                                    {
                                                                        id: "edit",
                                                                        header: "",
                                                                        width: 40,
                                                                        template: CellEditBtnTemplate,
                                                                        headermenu: false
                                                                    },
                                                                    {
                                                                        width: 190,
                                                                        id: "title",
                                                                        header: [LangHelper.GetString(this.Id,"Campaign"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                        sort: "string",
                                                                        editor: "text",
                                                                        fillspace: true
                                                                    },
                                                                    {
                                                                        minWidth: 170,
                                                                        id: "from_to_date",
                                                                        header: [LangHelper.GetString(this.Id,"Period"), {content: "dateRangeFilter"}],
                                                                        template:function(obj, common){
                                                                            var format =  webix.Date.dateToStr("%d.%m.%y");
                                                                            var result = "";
                                                                            if(obj.from_date)
                                                                            {

                                                                                result += format(obj.from_date);
                                                                            }

                                                                            if(obj.to_date)
                                                                            {
                                                                                if(result.length > 0)
                                                                                {
                                                                                    result += " - ";
                                                                                }
                                                                                result += format(obj.to_date);
                                                                            }
                                                                            return result;
                                                                        },
                                                                        fillspace: true,
                                                                        sort: "date"
                                                                    },
                                                                    {
                                                                        id: "from_to_time",
                                                                        header: [LangHelper.GetString(this.Id, "Campaign time"), ""],
                                                                        sort: "string",
                                                                        fillspace: true,
                                                                        template: function(obj, common){
                                                                            return (obj.from_time? obj.from_time.slice(0,5) : "00:00") + " - " + (obj.to_time? obj.to_time.slice(0,5) : "23:59");
                                                                        }
                                                                    },
                                                                    {
                                                                        id: "days_of_week",
                                                                        header: [LangHelper.GetString(this.Id, "Days of the week"),{
                                                                            content: "multiSelectFilter",
                                                                            options: Helper.DictToArr(DaysOfWeekDic),
                                                                            inputConfig: {suggest: {fitMaster: false}}
                                                                        }],
                                                                        sort: "string",
                                                                        fillspace: true,
                                                                        template: function(obj, common)
                                                                        {
                                                                            var result = Array();
                                                                            var days = obj.days_of_week.split(',').sort();
                                                                            for(var i in days)
                                                                            {
                                                                                if(i && days[i])
                                                                                {
                                                                                    result.push(DaysOfWeekDic[days[i]].value);
                                                                                }
                                                                            }
                                                                            return result.join(',');
                                                                        }
                                                                    },
                                                                    {
                                                                        width: 120,
                                                                        id: "status",
                                                                        header: [LangHelper.GetString(this.Id,"Status"), {
                                                                            content: "richSelectFilter",
                                                                            options: Helper.DictToArr(AdvsStatesDic),
                                                                            inputConfig: {suggest: {fitMaster: false}}
                                                                        }],
                                                                        template: function (obj, common) {
                                                                            var res = "";

                                                                            // if(!obj.enabled && obj.status == 3)
                                                                            // {
                                                                            //     return "<span class=\"adv_state adv_state_2\">" + '<span class="fa fa-square"></span> ' + (AdvsStatesDic[2] ? AdvsStatesDic[2].value : 2) + "</span>"
                                                                            // }

                                                                            res = "<span class=\"adv_state adv_state_" + obj.status + "\">" + '<span class="fa fa-square"></span> ' + (AdvsStatesDic[obj.status] ? AdvsStatesDic[obj.status].value : obj.status) + "</span>";

                                                                            return res;
                                                                        },
                                                                        fillspace: true,
                                                                        sort: "int"
                                                                    },
                                                                    {
                                                                        width: 120,
                                                                        id: "progress",
                                                                        header: [LangHelper.GetString(this.Id,"Done"),""],
                                                                        template: function (obj, common) {
                                                                            var percent = 0;
                                                                            if(obj.total !== 0 && obj.released !== 0)
                                                                            {
                                                                                percent = Math.floor(100*obj.released/obj.total);
                                                                            }
                                                                            var title = "Всего: "+obj.total+"; Выполнено: "+obj.released+" ("+percent+"%)";

                                                                            var html = "<div class='progress_bar_element'>";
                                                                            html += "<div title='" + title + "' class='progress_result ' style='width:" + (percent + "%") + "'></div>";
                                                                            html += "</div> <span style='display:inline-block;'>" + percent + "%" + "</span>";
                                                                            return html;
                                                                            // return AdvCellProgressTemplate(obj);
                                                                        },
                                                                        css: {'text-align': 'right'}
                                                                    },
                                                                    {
                                                                        id: "trash",
                                                                        header: "",
                                                                        width: 40,
                                                                        template: CellTrashBtnTemplate,
                                                                        headermenu: false
                                                                    },
                                                                    {header: {content: "headerMenu"}, headermenu: false, width: 32}

                                                                ],
                                                                data: []
                                                            },
                                                            {

                                                                view: "pager",
                                                                id: this.Id+"CampaignPaging",
                                                                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                                master:false,
                                                                on: {
                                                                    onAfterPageChange:function(Page)
                                                                    {
                                                                        _this.RefreshCompanies(Page);
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            view:"resizer"
                                        },
                                        {
                                            header: LangHelper.GetString(this.Id,"Campaign subscribers"),
                                            id: this.Id + "CampaignSubscribersAccord",
                                            gravity: 1/3,
                                            body: {
                                                cols: [
                                                    {
                                                        id: this.Id + "SubscribersParamsView",
                                                        minWidth: 600,
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                elements: [
                                                                    {
                                                                        id: _this.Id + "SubscriberParamsAddBtn",
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "plus",
                                                                        css:"toolbar_round_btn",
                                                                        width:32,
                                                                        tooltip:LangHelper.GetString(this.Id,"Add campaign data"),
                                                                        click:function ()
                                                                        {
                                                                            _this.AddSubscriberToTable();
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"button",
                                                                        id:this.Id + "ImportSubscribersListBtn",
                                                                        type:"icon",
                                                                        icon:"upload",
                                                                        css:"toolbar_round_btn",
                                                                        width:32,
                                                                        tooltip:LangHelper.GetString(this.Id,"Import campaign data from file"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            var __this = this;
                                                                            var nNode = __this.getNode(id);
                                                                            _this.CampaignDataImportContext.show(nNode,{pos:"bottom"});
                                                                        }
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "download",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString(_this.Id,"Download the subscirbers file"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ExportSubscribers();
                                                                        }
                                                                    },
                                                                    {
                                                                        id: this.Id + "SubscribersParamsViewResetSubscriber",
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "bolt",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString(_this.Id,"Restart campaign for subscriber"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ResetSubscriber();
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id+"refreshSubscribersBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString(this.Id, "Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshSubscribers();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Campaign subscribers"), icon:"users"}),
                                                            {
                                                                view: "datatable",
                                                                id: this.Id + "SubscribersParamsTable",
                                                                resizeColumn: true,
                                                                select: "row",
                                                                headermenu: {
                                                                    width: 350,
                                                                    autoheight: true,
                                                                    scroll: false

                                                                },
                                                                on: {
                                                                    onAfterSelect: function (data, preserve)
                                                                    {
                                                                        _this.OnSelectedSubscriberChange();
                                                                    },
                                                                    onAfterUnSelect: function(){
                                                                        _this.OnSelectedSubscriberChange();
                                                                    },
                                                                    onItemClick: function (id)
                                                                    {
                                                                        if(id.column === 'edit')
                                                                        {
                                                                            if(Array.isArray(_this.GetCompanyTableSeletedData()))
                                                                            {
                                                                                return;
                                                                            }
                                                                            var rowData = this.getItem(id);
                                                                            _this.ShowSubscriberEditForm(rowData,_this.Views.SubscribersParamsTable.getItemNode(rowData.id), "right");
                                                                        }
                                                                        else if(id.column === 'trash')
                                                                        {
                                                                            var __this = this;
                                                                            setTimeout(function () {
                                                                                var model = _this.Views.SubscribersParamsTable.getItem(id.row);
                                                                                if(model && model.login && model.adc_id && model.hardware_id)
                                                                                {
                                                                                    var node = __this.getItemNode(id);
                                                                                    _this.SubscriberDeleteContext.show(node, {pos:"bottom"});
                                                                                }
                                                                                else{
                                                                                    _this.DeleteSubscriber(id.row);
                                                                                }

                                                                            }, 10);
                                                                        }
                                                                    },
                                                                    onBeforeFilter:function()
                                                                    {
                                                                        return false;
                                                                    },
                                                                    onAfterFilter: function ()
                                                                    {
                                                                        _this.RefreshSubscribers();
                                                                    },
                                                                    onBeforeSort:function()
                                                                    {
                                                                        _this.RefreshSubscribers();
                                                                        return false;
                                                                    }
                                                                },
                                                                columns: []
                                                            },
                                                            {

                                                                view: "pager",
                                                                id: _this.Id+"SubscribersPaging",
                                                                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                                master:false,
                                                                on: {
                                                                    onAfterPageChange:function(Page)
                                                                    {
                                                                        _this.RefreshSubscribers(Page);
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }//,
                                                    //{view:"resizer"}
                                                ]
                                            }
                                        },
                                        {
                                            gravity: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.btns = {};

    this.Init(Params);

    return this;
}

AdvcViewController.prototype.Init = function (Params) {
    "use strict";
};

AdvcViewController.prototype.BindAll = function (Params) {
    "use strict";
    var _this = this;

    this.ProfilesPaging = $$(this.Id+"ProfilesPaging");
    this.CampaignPaging = $$(this.Id+"CampaignPaging");
    this.SubscribersPaging = $$(this.Id+"SubscribersPaging");

    this.Views.ProfileAddContext = $$(this.Id + "ListAddForm");
    this.Views.ProfilesListTable = $$(this.Id + "ProfileListTable");
    this.Views.ProfileEditForm = $$(this.Id + "ProfileEditForm");
    this.Views.AddSubProfileBtn = $$(this.Id + "AddSubProfileBtn");
    this.Views.AddSubProfileBtn.disable();
    this.Views.CampaignListTable = $$(this.Id+"CampaignListTable");

    this.Views.CompanyListAddBtn = $$(this.Id + "CompanyListAddBtn");
    this.Views.CompanyPlayBtn = $$(this.Id + "CompanyPlayBtn");
    this.Views.CompanyStopBtn = $$(this.Id + "CompanyStopBtn");
    // this.Views.CompanyListAddBtn.disable();

    this.Views.CompanyEditForm = $$(this.Id+"CompanyEditForm");
    this.Views.CompanyDeleteContext = $$(this.Id + "CompanyDeleteContext");
    this.Views.CompanyParamsListTable = $$(this.Id + "CampaignDataTable");
    this.Views.CampaignDataImportContextUploader = $$(this.Id + "CampaignDataImportContextUploader");
    this.Views.CampaignDataImportContextTable = $$(this.Id + "CampaignDataImportContextTable");
    this.Views.SubscribersParamsTable = $$(this.Id + "SubscribersParamsTable");
    this.Views.SubscribersParamsView = $$(this.Id + "SubscribersParamsView");
    this.Views.SubscribersParamsViewResizer = $$(this.Id + "SubscribersParamsViewResizer");

    this.Views.RefreshCampaignsBtn = $$(this.Id + "RefreshCampaignsBtn");

    this.Views.SubscriberEditForm = $$(this.Id + "SubscriberEditForm");
    this.Views.SubscriberParamsAddBtn = $$(this.Id + "SubscriberParamsAddBtn");
    this.Views.ImportSubscribersListBtn = $$(this.Id + "ImportSubscribersListBtn");

    this.Views.CampaignDataImportContextImportBtn = $$(this.Id + "CampaignDataImportContextImportBtn");
    this.Views.SubscribersParamsViewResetSubscriber = $$(this.Id + "SubscribersParamsViewResetSubscriber");

    this.Views.CompanyResetButton = $$(this.Id + "CompanyResetButton");

    // this.Views.SubscribersParamsView.hide();
    // this.Views.SubscribersParamsViewResizer.hide();


    this.Subscriptions.SignalSelectedCampaignsCountChange = this.CampaignSelectedDataCount.subscribe(
        function(value)
        {
            _this.OnCampaignSelectedDataCountChange(value);
        }
    );

    this.Subscriptions.SignalSelectedProfilesCountChange = this.ProfileSelectedCountChange.subscribe(
        function (value) {
            _this.OnSelectedProfilesCountChange(value);
        }
    );

    this.Subscriptions.SignalSelectedSubscribersCountChange = this.SubscribersSelectedCountChange.subscribe(
        function(value)
        {
            _this.OnSelectedSubscribersCountChange(value);
        }
    );


    this.Subscriptions.AdvProfilesUpdated = this.AdvcManager.AdvProfilesUpdated.subscribe(
        function(value)
        {
            var updated = value;

            if(updated)
            {
                _this.UpdateProfilesTables();
            }
        }
    );

    this.Subscriptions.AdvCompaniesUpdated = this.AdvcManager.AdvCompaniesUpdated.subscribe(
        function(value)
        {
            var updated = value;

            if(updated)
            {
                _this.UpdateCompaniesTable();
            }
        }
    );

    this.Subscriptions.SubscribersUpdated = this.AdvcProcessedSubscribersManager.SubscribersUpdated.subscribe(
        function(value)
        {
            if(value)
                _this.UpdateSubscribersTable();
        }
    );

    this.Subscriptions.SignalUsersDicUpdatedSubscription = App.DicsManager.Signal[DicsEnum.UsersDic].subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.Users = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);
            _this._UpdateUsersDics();
        }
    });

    // this.Subscriptions.ProfileSelectedChanges = this.ProfileSelectedChanges.subscribe(function(Val)
    // {
    //     _this.OnSelectedItemChange(Val);
    // });

    this.Views.CampaignDataImportContextUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        _this.ImportExcelToListCampaignParams(FileObj.file);
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshProfiles();
        }
    });

    this.Subscriptions.SignalSaveCompany = this.CampaignEditContext.SaveCampaignSignal.subscribe(
        function(Val)
        {
            if(Val)
            {
                _this.SaveCompany(Val);
            }
        }
    );
};

AdvcViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select("Advc");
    });


    this.CampaignEditContext.ViewDidLoad(Params);

    this.BindAll(Params);
};

AdvcViewController.prototype._UpdateUsersDics = function()
{
    // var _this = this;
    // this.Views.CompanyEditForm.elements.user_id.getList().clearAll();
    // this.Views.CompanyEditForm.elements.user_id.getList().parse(_this.Users);
    // var me = App.SessionManager.GetProfile();
    // if(!this.Views.CompanyEditForm.elements.user_id.getValue() && me && me.user_id)
    // {
    //     this.Views.CompanyEditForm.elements.user_id.setValue(me.user_id);
    // }
};

AdvcViewController.prototype.AddProfileToListTable = function()
{
    var _this = this;
    var model = new AdvProfileModel({hardware_id: App.SessionManager.GetCurrentHardwareId()});
    _this.Views.ProfilesListTable.add(model,0);
    _this.Views.ProfilesListTable.select(model.id,false);
    _this.Views.ProfilesListTable.showItem(model.id);

    _this.ShowProfileEditForm(model,_this.Views.ProfilesListTable.getItemNode(model.id), "right");
};

AdvcViewController.prototype.AddSubProfileToListTable = function()
{
    var _this = this;
    var selectedModel = _this.GetProfilesTableSelectedData();

    if(!selectedModel || !selectedModel.profile_id)
        return;

    var model = new AdvProfileModel({parent_id:selectedModel.profile_id, hardware_id:selectedModel.hardware_id});

    _this.Views.ProfilesListTable.add(model,0,selectedModel.id);
    _this.Views.ProfilesListTable.open(selectedModel.id);

    _this.Views.ProfilesListTable.select(model.id,false);
    _this.Views.ProfilesListTable.showItem(model.id);

    _this.ShowProfileEditForm(model,_this.Views.ProfilesListTable.getItemNode(model.id), "right");
};

AdvcViewController.prototype.ShowProfileEditForm = function(Data, Node, Pos)
{
    var _this = this;

    if(Data)
    {
        var data = new AdvProfileModel(Data);
        this.Views.ProfileEditForm.elements.title.setValue(data.title);
    }
    //TODO: CLEAR FORM

    this.ProfileEditContext.show(Node, {pos:Pos});
};

AdvcViewController.prototype.UpdateProfilesTables = function(Params)
{
    var _this = this;

    this.Views.ProfilesListTable.clearAll();
    this.Views.ProfilesListTable.parse(_this.AdvcManager.GetAdvProfiles());
    this.Views.ProfilesListTable.refresh();

    this.ProfilesPaging.define(this.AdvcManager.ProfilesTotal);
    this.ProfilesPaging.refresh();
};

AdvcViewController.prototype.OnSelectedProfilesCountChange = function(Val)
{
    var _this = this;
    _this.Views.CampaignListTable.clearAll();

    if(Val > 0)
    {
        _this.Views.CampaignListTable.enable();

        _this.Views.RefreshCampaignsBtn.enable();
        _this.RefreshCompanies();
        if(Val > 1)
        {
            _this.Views.AddSubProfileBtn.disable();
            _this.Views.CompanyListAddBtn.disable();
        }
        else if (Val === 1){
            var selected = _this.GetProfilesTableSelectedData();
            if(selected.profile_id > 0)
            {
                _this.Views.AddSubProfileBtn.enable();
                _this.Views.CompanyListAddBtn.enable();
            }
            else{
                _this.Views.CompanyListAddBtn.disable();
            }
        }
        else{
            _this.Views.AddSubProfileBtn.enable();
            _this.Views.CompanyListAddBtn.enable();
        }



    }
    else{
        _this.Views.CampaignListTable.disable();
        _this.Views.AddSubProfileBtn.disable();
        _this.Views.CompanyListAddBtn.disable();
        _this.Views.RefreshCampaignsBtn.disable();
    }
};

AdvcViewController.prototype.OnSelectedProfileChange = function()
{
    var _this = this;

    var data = _this.GetProfilesTableSelectedData();
    _this.ProfileSelectedCountChange.next(data?(Array.isArray(data)?data.length:1):0);
};

AdvcViewController.prototype.SaveProfile = function()
{
    var _this = this;
    var profileData = this.GetProfilesTableSelectedData();
    if(this.Views.ProfileEditForm.validate())
    {
        var formVals = _this.Views.ProfileEditForm.getValues();
        Object.keys(formVals).forEach(function(Key)
        {
            profileData[Key] = formVals[Key];
        });
        profileData.hardware_id = App.SessionManager.GetCurrentHardwareId();
        profileData.valid = true;

        this.AdvcManager.SaveProfile({
            profile: profileData,
            callback: function(R)
            {
                if(R.success && R.data && R.data.profile)
                {

                    _this.Views.ProfilesListTable.updateItem(profileData.id, new AdvProfileModel(R.data.profile));
                    _this.OnSelectedProfileChange();
                    webix.message(LangHelper.GetString(_this.Id, "Group saved"));

                }
                else{
                    profileData.valid = false;
                    _this.Views.ProfilesListTable.validate(profileData.id);

                    if(R.error)
                        webix.message({text: R.error.msg,type:"error"});
                }
            }
        });
        return true;
    }
    return false;
};

AdvcViewController.prototype.DeleteProfile = function( RowId )
{
    var _this = this;

    var profileData = this.Views.ProfilesListTable.getItem(RowId);
    profileData.valid = true;

    if(profileData.profile_id > 0)
    {
        this.AdvcManager.DeleteProfile({
            profile: profileData,
            callback: function(R)
            {
                if(R.success)
                {
                    _this.Views.ProfilesListTable.remove(RowId);

                    webix.message(LangHelper.GetString(_this.Id,"Deleted"));
                }
                else
                {
                    profileData.valid = false;
                    _this.Views.ProfilesListTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }
        });
    }
    else
    {
        this.Views.ProfilesListTable.remove(RowId);
    }
};

AdvcViewController.prototype.GetProfilesTableSelectedData = function()
{
    return this.Views.ProfilesListTable.getSelectedItem();
};

AdvcViewController.prototype.GetAdvProfileCompanies =  function()
{
    var _this = this;
    var model = _this.GetProfilesTableSelectedData();
    if(model && model.profile_id)
    {
        var params = {};
        var state = this.Views.CampaignListTable.getState();
        for(var prop in state.filter)
        {
            if(state.filter[prop])
            {
                params[prop] = state.filter[prop];
            }
        }
        params.profile_id = model.profile_id;
        // var filter = state.filter;
        this.AdvcManager.RefreshAdvCompanies({
            searchParams: params
        });
    }
};

AdvcViewController.prototype.RefreshProfiles = function(Page)
{
    var _this = this;

    var state = this.Views.ProfilesListTable.getState();

    this.AdvcManager.Refresh({page:Page, filter:state.filter, sort:state.sort, callback:function ()
        {
            //_this.table.hideProgress();
        }});
};

AdvcViewController.prototype.AddCompanyToCompanyListTable = function()
{
    var _this = this;
    var selectedProfile = _this.GetProfilesTableSelectedData();
    if(selectedProfile && selectedProfile.profile_id)
    {
        var model = new AdvCompanyModel({profile_id: selectedProfile.profile_id});
        model.from_time = '00:00';
        model.to_time = '23:59';
        model.days_of_week = '1,2,3,4,5,6,7';
        _this.Views.CampaignListTable.add(model,0);
        _this.Views.CampaignListTable.select(model.id,false);
        _this.Views.CampaignListTable.showItem(model.id);

        _this.ShowCompanyEditForm(model, _this.Views.CampaignListTable.getItemNode(model.id),"right");
    }
};

AdvcViewController.prototype.ShowCompanyEditForm = function(Data, Node, Pos)
{
    var _this = this;

    this.CampaignEditContext.SetData(Data);
    this.CampaignEditContext.Show(Node, {pos:Pos});
};

AdvcViewController.prototype.SaveCompany = function(Data)
{
    var _this = this;
    // var model = this.GetCompanyTableSeletedData();
    // var companyData = this.GetCompanyTableSeletedData();
    // if(this.Views.CompanyEditForm.validate())
    // {
    //     var formVals = _this.Views.CompanyEditForm.getValues();
    //     Object.keys(formVals).forEach(
    //         function(Key){
    //             if(companyData.hasOwnProperty(Key) && Key !== "id"){
    //                 companyData[Key] = formVals[Key];
    //             }
    //         }
    //     );
    //
    //
    //     if(formVals.date_time)
    //     {
    //         if(formVals.date_time.start)
    //         {
    //             var start = formVals.date_time.start;
    //             companyData.from_date = start;
    //             companyData.from_time = start.getHours()+":"+start.getMinutes()+":"+start.getSeconds();
    //
    //         }
    //
    //         if(formVals.date_time.end)
    //         {
    //             var end = formVals.date_time.end;
    //             companyData.to_date = end;
    //             companyData.to_time = end.getHours()+":"+end.getMinutes()+":"+end.getSeconds();
    //         }
    //     }
    //
    //     if(formVals.days_of_week.length > 1)
    //     {
    //         var days = formVals.days_of_week.split(",").sort();
    //         companyData.days_of_week = days.join(",");
    //     }
    //
    //     var companyParams = this.Views.CompanyParamsListTable.serialize();
    //     if(companyParams.length > 0)
    //     {
    //         companyParams.forEach(function(v)
    //         {
    //             if(v.id)
    //             {
    //                 delete v.id;
    //             }
    //         })
    //     }
    //     companyData.params = JSON.stringify(companyParams);
    //     companyData.valid = true;
    this.AdvcManager.SaveCompany({
        company: Data,
        callback: function(R)
        {
            if(R.success && R.data && R.data.adc)
            {
                _this.Views.CampaignListTable.updateItem(Data.id, new AdvCompanyModel(R.data.adc));

                _this.OnSelectedCampaignChange();
                webix.message(LangHelper.GetString(_this.Id, "Campaign saved"));

                _this.ResetSubscribersTable(new AdvCompanyModel(R.data.adc));
            }
            else{
                Data.valid = false;
                _this.Views.CampaignListTable.validate(Data.id);

                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
    // }
};

AdvcViewController.prototype.EnableCompany = function(Data)
{
    var _this = this;
    this.AdvcManager.EnableCompany({
        company: Data,
        callback: function(R)
        {
            if(R.success && R.data)
            {
                Data.enabled = 1;
                _this.Views.CampaignListTable.updateItem(Data.id, new AdvCompanyModel(Data));

                _this.OnSelectedCampaignChange(Data);
                webix.message(LangHelper.GetString(_this.Id, "Campaign enabled"));
            }
            else{
                Data.valid = false;
                _this.Views.CampaignListTable.validate(Data.id);

                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

AdvcViewController.prototype.DisableCompany = function(Data)
{
    var _this = this;
    this.AdvcManager.DisableCompany({
        company: Data,
        callback: function(R)
        {
            if(R.success && R.data)
            {
                Data.enabled = 0;
                _this.Views.CampaignListTable.updateItem(Data.id, new AdvCompanyModel(Data));

                _this.OnSelectedCampaignChange(Data);
                webix.message(LangHelper.GetString(_this.Id, "Campaign disabled"));
            }
            else{
                Data.valid = false;
                _this.Views.CampaignListTable.validate(Data.id);

                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

AdvcViewController.prototype.DeleteCompany = function( RowId )
{
    var _this = this;
    var companyData = this.Views.CampaignListTable.getItem(RowId);
    companyData.valid = true;
    if(companyData.adc_id > 0)
    {
        this.AdvcManager.DeleteCompany({
            company: companyData,
            callback: function(R)
            {
                if(R.success)
                {
                    _this.Views.CampaignListTable.remove(RowId);

                    webix.message(LangHelper.GetString(_this.Id,"Campaign deleted"));
                }
                else
                {
                    companyData.valid = false;
                    _this.Views.CampaignListTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }
        });
    }
    else
    {
        this.Views.CampaignListTable.remove(RowId);
    }
};

AdvcViewController.prototype.GetCompanyTableSeletedData = function()
{
    return this.Views.CampaignListTable.getSelectedItem();
};

AdvcViewController.prototype.OnSelectedCampaignChange = function()
{
    var _this = this;
    var data = _this.GetCompanyTableSeletedData();
    this.CampaignSelectedDataCount.next(data?(Array.isArray(data)?data.length:1):0);

};

AdvcViewController.prototype.OnCampaignSelectedDataCountChange = function(Val)
{
    var _this = this;
    _this.Views.SubscribersParamsTable.clearAll();
    _this.Views.CompanyPlayBtn.disable();
    _this.Views.CompanyStopBtn.disable();
    if(Val)
    {
        _this.Views.SubscribersParamsView.enable();
        var data = this.GetCompanyTableSeletedData();
        if(Array.isArray(data) && Val > 0)
        {
            var enable = true;
            var disable = true;
            data.forEach(function (v, i) {
                if (v.enabled) {
                    enable = false;
                }
                else {
                    disable = false;
                }
            });

            if (enable) {
                _this.Views.CompanyPlayBtn.enable();
            }

            if (disable) {
                _this.Views.CompanyStopBtn.enable();
            }

            _this.RefreshSubscribers();
            _this.ResetSubscribersTable(data);
            _this.Views.SubscriberParamsAddBtn.disable();
            _this.Views.ImportSubscribersListBtn.disable();

            this.Views.CompanyResetButton.disable();
        }
        else{
            _this.ResetSubscribersTable(data);
            _this.ResetImportFormTable(data);
            _this.RefreshSubscribers();
            _this.GenerateEditSubscriberForm(data);

            this.Views.CompanyResetButton.enable();
            if(data.enabled)
            {
                _this.Views.CompanyStopBtn.enable();
            }
            else{
                _this.Views.CompanyPlayBtn.enable();
            }
            if(data.adc_id)
            {
                // _this.Views.SubscribersParamsView.enable();
                _this.Views.SubscriberParamsAddBtn.enable();
                _this.Views.ImportSubscribersListBtn.enable();
            }
            else{
                // _this.Views.SubscribersParamsView.disable();
                _this.Views.SubscriberParamsAddBtn.disable();
                _this.Views.ImportSubscribersListBtn.disable();
            }

        }
    }
    else{
        _this.Views.SubscribersParamsView.disable();
        _this.ResetSubscribersTable(null);
        _this.GenerateEditSubscriberForm(null);
        this.Views.CompanyResetButton.disable();
    }
};

AdvcViewController.prototype.UpdateCompaniesTable = function()
{
    var _this = this;

    _this.Views.CampaignListTable.clearAll();
    _this.Views.CampaignListTable.parse(_this.AdvcManager.GetAdvCompanies());
    _this.Views.CampaignListTable.refresh();

    this.CampaignPaging.define(this.AdvcManager.CampaignTotal);
    this.CampaignPaging.refresh();
};

AdvcViewController.prototype.RefreshCompanies = function(Page)
{
    var _this = this;

    var state = this.Views.CampaignListTable.getState();
    var profile_ids = '';
    var data = this.GetProfilesTableSelectedData();
    if(Array.isArray(data))
    {
        var ids = [];
        data.forEach(
            function(Val)
            {
                if(Val && Val.profile_id)
                {
                    ids.push(Val.profile_id);
                }
            }
        );
        profile_ids = ids.join(',');
    }
    else if(data){
        profile_ids = data.profile_id;
    }


    if(profile_ids)
    {
        this.AdvcManager.RefreshAdvCompanies({
            page: Page,
            filter: state.filter,
            sort: state.sort,
            profile_ids: profile_ids,
            callback: function(){}
        });
    }

};

AdvcViewController.prototype.ForceSyncCompaies = function(Params)
{
    var _this = this;

    _this.AdvcManager.ForceSyncCompanies({
        callback: function(R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString(_this.Id, "Forced synchronization campaigns running in the background"));
            }
            else{
                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

AdvcViewController.prototype.ResetCompany = function(Params)
{
    var _this = this;
    var model = this.GetCompanyTableSeletedData();

    if(model && model.adc_id)
    {
        this.AdvcManager.ResetCompany({
            company: model,
            callback: function(R)
            {
                if(R.success && R.data && R.data.adc)
                {
                    _this.Views.CampaignListTable.updateItem(model.id, new AdvCompanyModel(R.data.adc));

                    _this.OnSelectedCampaignChange();
                    webix.message(LangHelper.GetString(_this.Id, "Campaign restarted"));

                    _this.ResetSubscribersTable(new AdvCompanyModel(R.data.adc));
                }
                else{
                    model.valid = false;
                    _this.Views.CampaignListTable.validate(model.id);

                    if(R.error)
                        webix.message({text: R.error.msg,type:"error"});
                }
            }
        });
    }

};

AdvcViewController.prototype.ShowSubscriberEditForm = function(Data, Node, Pos)
{
    var _this = this;

    this.Views.SubscriberEditForm.clear();
    this.Views.SubscriberEditForm.parse(Data);
    if(Data && Data.Params)
    {
        for(var prop in Data.Params)
        {
            if(this.Views.SubscriberEditForm.elements["param_" + prop])
            {
                this.Views.SubscriberEditForm.elements["param_" + prop].setValue(Data.Params[prop]);
            }
        }
    }

    this.SubscribersEditContext.show(Node, {pos:Pos});
};

AdvcViewController.prototype.AddSubscriberToTable = function()
{
    var _this = this;
    var model = new AdvcProcessedSubscriberModel({
        hardware_id: App.SessionManager.GetCurrentHardwareId(),
        adc_id: _this.GetCompanyTableSeletedData().adc_id,
        status: 1
    });
    _this.Views.SubscribersParamsTable.add(model,0);
    _this.Views.SubscribersParamsTable.select(model.id,false);
    _this.Views.SubscribersParamsTable.showItem(model.id);

    _this.ShowSubscriberEditForm(model, _this.Views.SubscribersParamsTable.getItemNode(model.id), "right");

};

AdvcViewController.prototype.GetSubscribersTableSelectedData = function ()
{
    return this.Views.SubscribersParamsTable.getSelectedItem();
};

AdvcViewController.prototype.ResetImportFormTable = function( Campaign)
{
    var _this = this;
    var table = this.Views.CampaignDataImportContextTable;
    table.clearAll();
    _this.ClearImportCampaignData();
    var columns = webix.toArray(table.config.columns);

    columns.insertAt({
        id: "subscriber",
        header: [LangHelper.GetString(this.Id, "Subscriber"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
        sort: "string",
        fillspace: true
    }, columns.length);
    var params = null;
    if(Campaign && Campaign.params)
    {
        params = JSON.parse(Campaign.params);
    }

    if(params)
    {
        params.forEach(function(Val, i)
        {
            columns.insertAt({
                id: Val.data_name,
                header: [Val.data_name + " (" + AdvCampaignParamTypes[Val.data_type].value + ")", {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                sort: Val.data_type == "string" ? "string": "int",
                fillspace: true
            }, columns.length);
        })
    }

    columns.insertAt({
        id: "trash",
        header: "",
        width: 40,
        template: CellTrashBtnTemplate,
        headermenu: false
    }, columns.length);
    table.refreshColumns();
};

AdvcViewController.prototype.ImportExcelToListCampaignParams = function(ExcelFile)
{
    var _this = this;
    var table = this.Views.CampaignDataImportContextTable;
    var ev = table.attachEvent("onAfterLoad",function(){
        table.detachEvent(ev);

        var data = table.serialize();
        var dataPrepared = [];
        var model = {};


        // _this.ClearImportCampaignData();
        var columns = webix.toArray(table.config.columns);
        data.forEach(function(Row,i){
            if(i === 0)
            {
                for(var prop in Row)
                {
                    if(prop !== "id")
                    {
                        if(prop !== "data0")
                        {
                            model[prop] = Row[prop];
                        }
                        else{
                            model[prop] = "subscriber";
                        }

                        // columns.insertAt({
                        //     id: Row[prop],
                        //     header: Row[prop]
                        // }, columns.length);
                        // table.refreshColumns();
                    }
                    else{

                        model[prop] = prop;
                    }
                }
            }
            else{
                var prepModel = {};
                for(var prop in model)
                {
                    prepModel[model[prop]] = "" + Row[prop];
                }

                dataPrepared.push(prepModel);
            }

        });
        table.clearAll();
        table.parse(dataPrepared);
        _this.OnSubscribersToImportChange(table.count());

    });
    table.clearAll();
    table.parse(ExcelFile,"excel");

    setTimeout(function(){
        if(table.hasEvent)
        {
            table.detachEvent(ev);
        }
    },3000);
};

AdvcViewController.prototype.OnSubscribersToImportChange = function(Val)
{
    if(Val > 0)
    {
        this.Views.CampaignDataImportContextImportBtn.enable();
    }
    else{
        this.Views.CampaignDataImportContextImportBtn.disable();
    }
};

AdvcViewController.prototype.ClearImportCampaignData = function()
{
    var _this = this;
    this.Views.CampaignDataImportContextTable.clearAll();
    this.Views.CampaignDataImportContextTable.config.columns = [];
    this.Views.CampaignDataImportContextTable.refreshColumns();
    this.OnSubscribersToImportChange(0);
};

AdvcViewController.prototype.SaveImportedExceldata = function()
{
    var _this = this;

    var table = this.Views.CampaignDataImportContextTable;

    var campaign = this.GetCompanyTableSeletedData();
    var hId = App.SessionManager.GetCurrentHardwareId();

    var listItems = table.serialize();

    var saveData = [];

    listItems.forEach(function(Item)
    {

        var params = {};
        for(var prop in Item)
        {
            if(prop !== "id" && prop !== "subscriber")
            {
                params[prop] = Item[prop];
            }
        }

        var model = new AdvCampaignDataModel({
            adc_id: campaign.adc_id,
            login: Item.subscriber,
            hardware_id: hId,
            params: JSON.stringify(params),
            status: 1
        });

        saveData.push(model);
    });

    this.AdvcProcessedSubscribersManager.SaveProcessedSubscribers({
        subscribers: saveData,
        callback: function(R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString(_this.Id, "Campaign data saved"));
                _this.RefreshSubscribers();
                table.clearAll();
            }
            else{

                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

AdvcViewController.prototype.ExportSubscribers = function()
{
    var _this = this;




    var company = _this.GetCompanyTableSeletedData();

    var params = null;
    if(Array.isArray(company))
    {
        params = [];
        company.forEach(
            function(Val)
            {
                if(Val && Val.params)
                {
                    var param = JSON.parse(Val.params);
                    param.forEach(
                        function(v)
                        {
                            var index = params.findIndex(function(obj){ return obj.data_name == v.data_name});
                            if(index === -1)
                            {
                                params.push(v);
                            }
                        }
                    )
                }
            }
        );
    }
    else if(company.params)
    {
        params = JSON.parse(company.params);
    }

    var columns = [
        {
            id:"login", header:LangHelper.GetString(_this.Id, "Subscriber")
        }
    ];

    if(params)
    {
        params.forEach(
            function(Val)
            {
                if(Val && Val.data_name)
                {
                    columns.push(
                        {
                            id: "param_" + Val.data_name,
                            header: Val.data_name,
                            exportType: Val.data_type == "string"? Val.data_type : "number"
                        }
                    );
                }
            }
        )
    }

    columns.push({
        id: "notification_date",
        header: LangHelper.GetString(this.Id,"Notification date"),
        template:function(obj, common){
            if(obj.notification_date)
            {
                var date = new Date(obj.notification_date);
                var format =  webix.Date.dateToStr("%d.%m.%Y %H:%i:%s");
                return format(date);
            }

            return "";
        },
        exportType: "string"
    });

    columns.push({
        id: "status",
        header: LangHelper.GetString(this.Id,"Status"),
        template: function (obj, common) {
            var res = "";
            res = "<span class=\"adv_state adv_state_" + obj.status + "\">" + '<span class="fa fa-square"></span> ' + AdvcProcessedSubscribersStatesDic[obj.status].value + "</span>";

            return res;
        },
        exportType: "string"
    });

    var data = webix.toExcel(this.Views.SubscribersParamsTable,{
        filename: "advc_subscribers",
        filterHTML: true,
        // header: false,
        columns: columns
        // ignore: {
        //     "edit":true,
        //     "notification_date":true,
        //     "trash":true,
        //     "status":true
        // }
    });
};

AdvcViewController.prototype.GetImportFileTemplate = function ()
{
    var _this = this;

    var company = _this.GetCompanyTableSeletedData();
    var params = null;
    if(company.params)
    {
        params = JSON.parse(company.params);
    }

    var columns = [
        {
            id:"subscriber", header:LangHelper.GetString(_this.Id, "Subscriber")
        }
    ];
    if(params)
    {
        params.forEach(
            function(Val)
            {
                if(Val && Val.data_name)
                {
                    columns.push(
                        {
                            id: Val.data_name,
                            header: Val.data_name,
                            exportType: Val.data_type == "string"? Val.data_type : "number"
                        }
                    );
                }
            }
        )
    }

    var data = webix.toExcel(this.Views.CampaignDataImportContextTable,{
        filename: company.title + "_import_subscribers_template",
        columns: columns,
        rawValues:false//,
        // download:false
    });
};

AdvcViewController.prototype.ResetSubscribersTable = function(Data)
{
    var _this = this;
    var table = this.Views.SubscribersParamsTable;
    table.clearAll();
    table.config.columns = [];
    table.refreshColumns();
    var columns = webix.toArray(table.config.columns);

    columns.insertAt(
        {
            id: "edit",
            header: "",
            width: 40,
            template: CellEditBtnTemplate,
            headermenu: false
        }, columns.length
    );
    //[LangHelper.GetString(this.Id,"Profile"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
    columns.insertAt(
        {
            id: "login",
            header: [LangHelper.GetString(this.Id,"Subscriber"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            fillspace: true,
            sort: "string"
        }, columns.length
    );
    columns.insertAt(
        {
            id: "notification_date",
            header: [LangHelper.GetString(this.Id,"Notification date"),{content: "dateRangeFilter"}],
            template:function(obj, common){
                if(obj.notification_date)
                {
                    var date = new Date(obj.notification_date);
                    var format =  webix.Date.dateToStr("%d.%m.%Y %H:%i:%s");
                    return format(date);
                }

                return "";
            },
            fillspace: true,
            sort: "date"
        }, columns.length
    );
    var params = null;
    if(Array.isArray(Data))
    {
        params = [];
        Data.forEach(
            function(Val)
            {
                if(Val && Val.params)
                {
                    var param = JSON.parse(Val.params);
                    param.forEach(
                        function(v)
                        {
                            var index = params.findIndex(function(obj){ return obj.data_name == v.data_name});
                            if(index === -1)
                            {
                                params.push(v);
                            }
                        }
                    )
                }
            }
        );
    }
    else if( Data && Data.params ){
        params = JSON.parse(Data.params);
    }

    if(params)
    {
        params.forEach(function(Val){
            if(Val && Val.data_name){
                columns.insertAt({
                    id: "param_" + Val.data_name,
                    header: [Val.data_name,{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort: Val.data_type === "string"? Val.data_type : "int",
                    fillspace: true,
                    template: function(obj, common)
                    {
                        return (obj.Params && obj.Params[Val.data_name])? obj.Params[Val.data_name] : (Val.default_value ? Val.default_value : "");
                        // if(obj.Params && obj.Params)
                        //     return obj.Params[Val.data_name];
                        // return Val.default_value ? Val.default_value : "";
                    }
                })
            }
        });
    }

    columns.insertAt({
            id: "status",
            header: [
                LangHelper.GetString(this.Id,"Status"), {
                    content: "richSelectFilter",
                    options: Helper.DictToArr(AdvcProcessedSubscribersStatesDic),
                    inputConfig: {suggest: {fitMaster: false}}
                }
            ],
            template: function (obj, common) {
                var res = "";
                res = "<span class=\"adv_state adv_state_" + obj.status + "\">" + '<span class="fa fa-square"></span> ' + AdvcProcessedSubscribersStatesDic[obj.status].value + "</span>";

                return res;
            },
            fillspace: true,
            sort: "int"
        }, columns.length
    )

    columns.insertAt({
            id: "trash",
            header: "",
            width: 40,
            template: CellTrashBtnTemplate,
            headermenu: false
        }, columns.length
    );
    // columns.insertAt({
    //     header: {content: "headerMenu"}, headermenu: false, width: 32
    // }, columns.length);
    table.refreshColumns();
};

AdvcViewController.prototype.UpdateSubscribersTable = function()
{
    var _this = this;
    _this.Views.SubscribersParamsTable.clearAll();
    _this.Views.SubscribersParamsTable.parse(_this.AdvcProcessedSubscribersManager.GetSubscribers());

    _this.SubscribersPaging.define(_this.AdvcProcessedSubscribersManager.Total);
    _this.SubscribersPaging.refresh();
};

AdvcViewController.prototype.RefreshSubscribers = function(Page)
{
    var _this = this;
    var state = this.Views.SubscribersParamsTable.getState();

    var companies = _this.GetCompanyTableSeletedData();
    var adc_ids = '';
    if(Array.isArray(companies))
    {
        var ids = [];
        companies.forEach(
            function(Val)
            {
                ids.push(Val.adc_id);
            }
        )
        adc_ids = ids.join(',');
    }
    else{
        adc_ids = companies.adc_id;
    }
    if(adc_ids)
    {
        this.AdvcProcessedSubscribersManager.Refresh(
            {
                page: Page,
                filter: state.filter,
                sort: state.sort,
                adc_ids: adc_ids,
                callback: function(){}
            }
        );
    }

};

AdvcViewController.prototype.GenerateEditSubscriberForm = function(Model)
{
    var _this = this;



    for(var prop in _this.Views.SubscriberEditForm.elements)
    {
        if(prop != "login")
        {
            delete _this.Views.SubscriberEditForm.elements[prop];
            // _this.Views.SubscriberEditForm.removeView(prop);


        }
    }
    _this.Views.SubscriberEditForm.reconstruct();
    var elements = _this.Views.SubscriberEditForm.elements;

    var params = Model && Model.params ? JSON.parse(Model.params) : null;
    if(params)
    {
        var rows = new Array();
        for(var i in params)
        {
            rows.push(
                {
                    view: "text",
                    name: "param_" + params[i].data_name,
                    label: params[i].data_name,
                    labelPosition: "top",
                    validate: function()
                    {
                        var validators = [webix.rules.isNotEmpty()];
                        if(params[i].data_type == "enum")
                        {
                            validators.push(webix.rules.isNumber());
                        }
                        return validators;
                    }
                }
            );
        }
        if(rows.length > 0)
        {
            _this.Views.SubscriberEditForm.addView({
                rows:rows
            },1);
        }

    }
    _this.Views.SubscriberEditForm.refresh();
};

AdvcViewController.prototype.SaveSubscriberData = function()
{
    var _this = this;

    var newModel = this.Views.SubscriberEditForm.getValues();
    var oldModel = this.GetSubscribersTableSelectedData();
    var adc = this.GetCompanyTableSeletedData();
    var adcParams = adc && adc.params ? JSON.parse(adc.params) : null;
    var params = {};
    for(var i in adcParams)
    {
        var modelProp = "param_" + adcParams[i].data_name;
        if(newModel.hasOwnProperty(modelProp))
        {
            params[adcParams[i].data_name] = newModel[modelProp];
        }
    }
    newModel.params = JSON.stringify(params);

    this.AdvcProcessedSubscribersManager.SaveSubscriber({
        newSubscriber: newModel,
        oldSubscriber: oldModel,
        callback: function(R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString(_this.Id, "Campaign data saved"));
                _this.RefreshSubscribers();
                // _this.AdvcProcessedSubscribersManager.Refresh(_this.GetCompanyTableSeletedData());
            }
            else{
                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });



};

AdvcViewController.prototype.DeleteSubscriber = function( RowId )
{
    var _this = this;

    var subscriber = this.Views.SubscribersParamsTable.getItem(RowId);
    subscriber.valid = true;
    if(subscriber.adc_id > 0 && subscriber.hardware_id && subscriber.login)
    {
        this.AdvcProcessedSubscribersManager.DeleteSubscriber({
            subscriber: subscriber,
            callback: function(R)
            {
                if(R.success)
                {
                    _this.Views.SubscribersParamsTable.remove(RowId);

                    webix.message(LangHelper.GetString(_this.Id,"Deleted"));
                }
                else
                {
                    subscriber.valid = false;
                    _this.Views.SubscribersParamsTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }
        });
    }
    else
    {
        this.Views.SubscribersParamsTable.remove(RowId);
    }
};

AdvcViewController.prototype.OnSelectedSubscriberChange = function()
{
    var _this = this;

    var data = _this.GetSubscribersTableSelectedData();
    _this.SubscribersSelectedCountChange.next(data?(Array.isArray(data)?data.length:1):0);
};

AdvcViewController.prototype.OnSelectedSubscribersCountChange = function(Val)
{
    var _this = this;

    if(Val === 1)
    {
        _this.Views.SubscribersParamsViewResetSubscriber.enable();
    }
    else{
        _this.Views.SubscribersParamsViewResetSubscriber.disable();
    }
};

AdvcViewController.prototype.ResetSubscriber = function(Params)
{
    var _this = this;
    var model = _this.GetSubscribersTableSelectedData();

    if(model)
    {
        this.AdvcProcessedSubscribersManager.ResetAdvProcessedSubscriber({
            subscriber:model,
            callback:function(R)
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString(_this.Id, "Campaign data saved"));
                    _this.RefreshSubscribers();
                    // _this.AdvcProcessedSubscribersManager.Refresh(_this.GetCompanyTableSeletedData());
                }
                else{
                    if(R.error)
                        webix.message({text: R.error.msg,type:"error"});
                }
            }
        });
    }
};

AdvcViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.Views.CampaignDataImportContextUploader.detachEvent("onAfterFileAdd");
    this.CampaignEditContext.Destroy();
};

AdvcViewController.prototype.RefreshViews = function()
{
    var _this = this;

    Helper.RefreshView(_this.Views.ProfilesListTable);
    Helper.RefreshView(_this.Views.CampaignListTable);
};





function AdvcCampaignEditViewController(Params)
{
    var _this = this;

    this.FormId = Params && Params.form_id ? Params.form_id : "AdvCampaignEdit";

    this.Id = Params && Params.id ? Params.id : "Advc";

    this.Data = null;

    this.Rows = null;
    this.ViewConfig = null;
    this.ShowAsModalForm = true;
    this.ShowSaveBtn = true;

    this.Users = [];
    this.Subscriptions = {};
    this.Subscriptions.SignalUsersDicUpdatedSubscription = null;


    this.ContextConfig = {
        view:"popup",
        maxWidth: 960,
        maxHeight: 720,
        id: this.FormId + "Context",
        body:{
            borderless:true,
            rows:[]
        }
    };

    this.Context = null;

    this.Views = {
        Form: null,
        ParamsTable: null
    };

    this.View = null;

    this.SaveCampaignSignal = new Rx.BehaviorSubject(null);
    //this.CancelSaveCampaignSignal = new Rx.BehaviorSubject(0);
    this.Init(Params);

    return this;
}

AdvcCampaignEditViewController.prototype.Init = function(Params)
{
    if(Params)
    {
        if(Params.embedded){
            this.ShowAsModalForm = false;
        }

        if(Params.hide_save_btn)
        {
            this.ShowSaveBtn = false;
        }
    }

    if(this.ShowAsModalForm)
    {
        this.ConfigRows();

        this.ContextConfig.body.rows = this.Rows;
        this.Context = webix.ui(this.ContextConfig);
    }
    else
    {
        this.FormId += "Embedded";

        this.ConfigRows();

        this.ViewConfig = {
            id:this.Id,
            rows:this.Rows
        };
    }

    // this.ContextConfig.body = this.ViewConfig;
    // this.Context = webix.ui(this.ContextConfig);
};

AdvcCampaignEditViewController.prototype.ConfigRows = function()
{
    var rows = [];

    rows = rows.concat(this.GetFormRows());

    rows = rows.concat(this.GetFormButtons());

    this.Rows = rows;
}

AdvcCampaignEditViewController.prototype.GetFormButtons = function()
{
    var _this = this;

    var form = []

    if(this.ShowAsModalForm || this.ShowSaveBtn)
    {
        form = [{
            view:"form",
            elements:
                [
                    {
                        cols:[
                            {
                                gravity:2
                            }
                        ]
                    }
                ]
        }];
    }


    if(this.ShowAsModalForm)
    {
        form[0].elements[0].cols.push({
            view:"button",
            label:LangHelper.GetString("Advc","Cancel"),
            click:function () {
                _this.Hide();
            }
        });
    }

    if(this.ShowSaveBtn)
    {
        form[0].elements[0].cols.push({
            view:"button",
            type:"form",
            label:LangHelper.GetString("Advc","Save"),
            click:function () {
                setTimeout(function()
                {
                    if(_this.Validate())
                    {
                        _this.Save();
                        _this.Hide();
                    }
                },10)
            }
        });
    }

    return form;
}

AdvcCampaignEditViewController.prototype.GetFormRows = function()
{
    var _this = this;

    return {
        cols:
            [
                {
                    rows:
                        [
                            BlockHeaderTemplate({title:LangHelper.GetString("Advc","Campaign settings"), icon:"bullhorn"}),
                            {
                                view:"form",
                                id:this.FormId+"Form",
                                elements:
                                    [
                                        {
                                            view: "text",
                                            name: "title",
                                            label: LangHelper.GetString("Advc","Title"),
                                            labelPosition: "top",
                                            tooltip: LangHelper.GetString("Advc", "Campaign title"),
                                            required: true,
                                            invalidMessage: LangHelper.GetString("Advc", "Title can not be empty")
                                        },
                                        {
                                            view: "richselect",
                                            name: "user_id",
                                            label: LangHelper.GetString("Advc","Responsible"),
                                            options: Helper.DictToArr(_this.Users),
                                            tooltip: LangHelper.GetString("Advc", "User responsible for the campaign"),
                                            labelPosition: "top"
                                        },
                                        {
                                            view: "daterangepicker",
                                            name: "date_time",
                                            tooltip: LangHelper.GetString("Advc", "Dates of the advertising campaign"),
                                            label: LangHelper.GetString("Advc","Campaign period"),
                                            labelPosition: "top",
                                            required: true,
                                            invalidMessage: LangHelper.GetString("Advc", "Date of campaign should be filled"),
                                            validate: function(Val){
                                                return (Val && Val.start && Val.end);
                                            }
                                        },
                                        {
                                            // rows:[
                                                // {
                                                //     view: "label",
                                                //     label: LangHelper.GetString("Advc", "Campaign show time")
                                                // },
                                                // {
                                                    cols:[
                                                        {
                                                            view: "datepicker",
                                                            type: "time",
                                                            name:"from_time",
                                                            tooltip: LangHelper.GetString("Advc", "Campaign show time (DPI local time)"),
                                                            labelPosition: "top",
                                                            label: LangHelper.GetString("Advc", "Time from"),
                                                            required: true,
                                                            stringResult: true,
                                                            invalidMessage: LangHelper.GetString("Advc", "Required field"),
                                                            validate: function(Val)
                                                            {
                                                                if(!Val)
                                                                    return false;
                                                                var to_time = _this.Views.Form.elements["to_time"].getValue();
                                                                if(to_time)
                                                                {
                                                                    return (Val < to_time);
                                                                }
                                                                return true;
                                                            }
                                                        },
                                                        {
                                                            view: "datepicker",
                                                            type: "time",
                                                            name:"to_time",
                                                            labelPosition: "top",
                                                            label: LangHelper.GetString("Advc", "Time to"),
                                                            tooltip: LangHelper.GetString("Advc", "Campaign show time (DPI local time)"),
                                                            stringResult: true,
                                                            required: true,
                                                            invalidMessage: LangHelper.GetString("Advc", "Required field"),
                                                            validate: function(Val)
                                                            {
                                                                if(!Val)
                                                                    return false;
                                                                var from_time = _this.Views.Form.elements["from_time"].getValue();
                                                                if(from_time)
                                                                {
                                                                    return Val > from_time;
                                                                }
                                                                return true;
                                                            }
                                                        }
                                                    ]
                                                // }
                                            // ]

                                        },
                                        {
                                            view: "multiselect",
                                            name: "days_of_week",
                                            label: LangHelper.GetString("Advc","Days of the week"),
                                            options: Helper.DictToArr(DaysOfWeekDic),
                                            tooltip: LangHelper.GetString("Advc", "Days of the advertising campaign"),
                                            labelPosition: "top",
                                            required: true,
                                            invalidMessage: LangHelper.GetString("Advc", "Should be selected at least one day of week")
                                        },
                                        {
                                            view: "text",
                                            name: "redirect",
                                            label: LangHelper.GetString("Advc","Redirect URL"),
                                            tooltip: LangHelper.GetString("Advc","Redirect URL"),
                                            labelPosition: "top",
                                            required: true,
                                            invalidMessage: LangHelper.GetString("Advc", "Input correct URL address"),
                                            validate:function(Val)
                                            {
                                                if(Val)
                                                    return Helper.IsUrlValid(Val);
                                                else
                                                    return false;
                                            }
                                        },
                                        {
                                            view: "richselect",
                                            name: "enabled",
                                            label: LangHelper.GetString("Advc","Campaign state"),
                                            labelPosition: "top",
                                            options: Helper.DictToArr(EnableDic),
                                            tooltip: LangHelper.GetString("Advc", "Enable campaign after saving?")
                                        }
                                    ],
                                rules:{
                                    "title" : webix.rules.isNotEmpty,
                                    "days_of_week": webix.rules.isNotEmpty
                                }
                            }
                        ]
                },
                {view:"resizer"},
                {
                    rows:[
                        BlockHeaderTemplate({title:LangHelper.GetString("Advc","Campaign data"), icon:"file"}),
                        {
                            view: "toolbar",
                            elements: [
                                {
                                    view: "button",
                                    type: "icon",
                                    icon: "plus",
                                    css:"toolbar_round_btn",
                                    width:32,
                                    tooltip:LangHelper.GetString("Advc","Add new campaign data"),
                                    click:function (id)
                                    {
                                        _this.AddCampaignDataToTable();
                                    }
                                }
                            ]
                        },
                        {
                            id: this.FormId + "ParamsTable",
                            view:"datatable",
                            editable:true,
                            editaction:"dblclick",
                            select:"row",
                            on:{
                                onItemClick: function (id)
                                {
                                    if(id.column === 'trash')
                                    {
                                        var __this = this;
                                        setTimeout(function ()
                                        {
                                            var selected = _this.Views.ParamsTable.getSelectedItem();
                                            if(selected)
                                                _this.Views.ParamsTable.remove(selected.id);
                                        }, 10);
                                    }
                                }
                            },
                            columns:[
                                {
                                    id:"data_name",
                                    fillspace:true,
                                    header:LangHelper.GetString("Advc","Data name"),
                                    editor:"text"
                                },
                                {
                                    id:"data_type",
                                    header: LangHelper.GetString("Advc","Data type"),
                                    editor:"richselect",
                                    fillspace:true,
                                    options: [
                                        {
                                            id:"string",
                                            value:LangHelper.GetString("Advc","String")
                                        },
                                        {
                                            id:"enum",
                                            value:LangHelper.GetString("Advc","Enumeration")
                                        }
                                    ]
                                },
                                {
                                    id:"default_value",
                                    header: LangHelper.GetString("Advc","Default value"),
                                    fillspace:true,
                                    editor:"text"
                                },
                                {
                                    id: "trash",
                                    header: "",
                                    width: 32,
                                    //template: "<span class=\"webix_icon fa-trash\"></span>",
                                    template:CellTrashBtnTemplate,
                                    headermenu: false
                                }
                            ],
                            data:[]
                        }
                    ]
                }
            ]
    };
}

AdvcCampaignEditViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

AdvcCampaignEditViewController.prototype.Show = function(Node, Pos)
{
    //this.Views.Form.clearValidation();
    this.Context.show(Node, {pos:Pos});
};

AdvcCampaignEditViewController.prototype.Hide = function()
{
    if(this.Context)
        this.Context.hide();
};

AdvcCampaignEditViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.Form = $$(this.FormId+"Form");
    this.Views.ParamsTable = $$(this.FormId + "ParamsTable");

    this.Subscriptions.SignalUsersDicUpdatedSubscription = App.DicsManager.Signal[DicsEnum.UsersDic].subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.Users = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);
            _this._UpdateUsersDics();
        }
    });

    App.UserManager.Refresh();

    if(this.Context)
    {
        this.Context.attachEvent("onHide", function()
        {
            // _this.Views.ParamsTable.clearAll();
            _this.Views.Form.clear();
            _this.Views.Form.clearValidation();
        });
    }

};

AdvcCampaignEditViewController.prototype.SetData = function (Data)
{
    var _this = this;

    if(Data)
    {
        var data = new AdvCompanyModel(Data);

        this.Views.Form.setValues(data);

        var dateObj = {
            start: null,
            end: null
        };
        // var startStr = "";
        // startStr += data.from_date? data.from_date : "";
        // startStr += ((startStr?" ":"") + (data.from_time?data.from_time:""));
        dateObj.start = new Date(data.from_date? data.from_date : "");

        // var endStr = "";
        // endStr += data.to_date? data.to_date : "";
        // endStr += ((endStr?" ":"") + (data.to_time?data.to_time:""));
        dateObj.end = new Date(data.to_date? data.to_date : "");
        this.Views.Form.elements.date_time.setValue(dateObj);

        this.Views.ParamsTable.clearAll();
        if(data.params)
        {
            var params = JSON.parse(data.params);
            this.Views.ParamsTable.parse(params);
        }
    }

    this.Data = Data;

    //this.Views.Form.setValues(this.Data);
};

AdvcCampaignEditViewController.prototype.Validate = function()
{
    return this.Views.Form.validate();
};

AdvcCampaignEditViewController.prototype.Save = function()
{
    var _this = this;
    if(this.Validate())
    {
        var companyData = this.Data;
        var formVals = _this.Views.Form.getValues();
        Object.keys(formVals).forEach(
            function(Key){
                if(companyData.hasOwnProperty(Key) && Key !== "id"){
                    companyData[Key] = formVals[Key];
                }
            }
        );


        if(formVals.date_time)
        {
            if(formVals.date_time.start)
            {
                var start = formVals.date_time.start;
                companyData.from_date = start;
                // companyData.from_time = start.getHours()+":"+start.getMinutes()+":"+start.getSeconds();

            }

            if(formVals.date_time.end)
            {
                var end = formVals.date_time.end;
                companyData.to_date = end;
                // companyData.to_time = end.getHours()+":"+end.getMinutes()+":"+end.getSeconds();
            }
        }

        if(formVals.days_of_week.length > 1)
        {
            var days = formVals.days_of_week.split(",").sort();
            companyData.days_of_week = days.join(",");
        }

        var tableData = this.Views.ParamsTable.serialize();
        var params = [];
        if(tableData.length > 0)
        {
            tableData.forEach(function(v)
            {
                if(v.data_name && v.data_type)
                {
                    params.push(v);
                }
            })
        }
        companyData.params = JSON.stringify(params);
        companyData.valid = true;

        this.Data = companyData;

        this.SaveCampaignSignal.next(this.Data);
    }
};

AdvcCampaignEditViewController.prototype.GetCampaignDataTypes = function()
{
    return [
        {
            id:"string",
            value:LangHelper.GetString("Advc","String")
        },
        {
            id:"enum",
            value:LangHelper.GetString("Advc","Enumeration")
        }
    ];
};

AdvcCampaignEditViewController.prototype._UpdateUsersDics = function()
{
    var _this = this;
    this.Views.Form.elements.user_id.getList().clearAll();
    this.Views.Form.elements.user_id.getList().parse(_this.Users);
    var me = App.SessionManager.GetProfile();
    if(!this.Views.Form.elements.user_id.getValue() && me && me.user_id)
    {
        this.Views.Form.elements.user_id.setValue(me.user_id);
    }
}

AdvcCampaignEditViewController.prototype.AddCampaignDataToTable = function()
{
    var _this = this;
    var model = new AdvCompanyParamModel({});
    this.Views.ParamsTable.add(model);
}

AdvcCampaignEditViewController.prototype.Destroy = function()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
}
function DpiConfigViewController(Params)
{
    var _this = this;
    this.Id = "DpiConfig";
    this.ViewModel = new BaseHardwareConfigManager({
        prefix: _this.Id,
        dic: "fastdpi"
    });

    this.VchannelModel = new VchannelsManager();

    this.DdosViewModel = new DDoSProtectionManager();

    this.PolicingAutoFillPopupConfig = webix.ui({
        view: "popup",
        width:400,
        position:"center",
        padding:0,
        marging:0,
        modal:true,
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "PolicingAutoFillPopupForm",
                            minWidth:400,
                            elements: [
                                {
                                    view: "richselect",
                                    name: "policing_type",
                                    label: LangHelper.GetString("Tariffs", "Policing type"),
                                    labelPosition: "top",
                                    value: "HTB",
                                    options: Helper.DictToArr(PolicingsConfigTypesDic),
                                    tooltip: LangHelper.GetString(this.Id, "Policing types: \"HTB\" or \"TBF\"")
                                },
                                {
                                    cols:[
                                        {
                                            view: "text",
                                            name: "inbound_root_rate",
                                            label: LangHelper.GetString("UlrModule", "Inbound profile"),
                                            labelPosition: "top",
                                            gravity: 2,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                            validate: function (Val)
                                            {
                                                return !isNaN(Val * 1);
                                            },
                                            value:"100",
                                            on: {
                                                onChange: function (Nv, Ov)
                                                {
                                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }
                                                    this.validate();
                                                }
                                            }
                                        },
                                        {
                                            view: "richselect",
                                            name: "inbound_root_rate_unit",
                                            label: LangHelper.GetString("UlrModule", "Unit"),
                                            labelPosition: "top",
                                            options:{
                                                point:false,
                                                data:Helper.DictToArr(TrafficUnits)
                                            },
                                            value:"mbit"
                                        }
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            view: "text",
                                            name: "outbound_root_rate",
                                            label: LangHelper.GetString("UlrModule", "Outbound profile"),
                                            labelPosition: "top",
                                            gravity: 2,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                            validate: function (Val)
                                            {
                                                return !isNaN(Val * 1);
                                            },
                                            value:"100",
                                            on: {
                                                onChange: function (Nv, Ov)
                                                {
                                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }
                                                    this.validate();
                                                }
                                            }
                                        },
                                        {
                                            view: "richselect",
                                            name: "outbound_root_rate_unit",
                                            label: LangHelper.GetString("UlrModule", "Unit"),
                                            labelPosition: "top",
                                            options:{
                                                point:false,
                                                data:Helper.DictToArr(TrafficUnits)
                                            },
                                            value:"mbit"
                                        }
                                    ]
                                }
                            ]
                        },
                        {height:20},
                        {
                            cols:[
                                {},
                                {
                                    view: "button",
                                    label: LangHelper.GetString("Dics", "Cancel"),
                                    click: function(){
                                        setTimeout(function () {
                                            _this.PolicingAutoFillPopupConfig.hide();
                                        },1);
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "PolicingAutoFillPopupApplyBtn",
                                    label:LangHelper.GetString("UlrModule","Apply"),
                                    type: "form",
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function () {
                                            _this.ApplyPolicingAutoFillForm();
                                        },1);

                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });

    this.ScenarioQoEStorAutoFillPopupConfig = webix.ui({
        view: "popup",
        width:400,
        position:"center",
        padding:0,
        marging:0,
        modal:true,
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ScenarioQoEStorAutoFillPopupForm",
                            minWidth:400,
                            elements: [
                                {
                                    view: "text",
                                    name: "dev",
                                    label: LangHelper.GetString("Dics", "Network interface name"),
                                    labelPosition: "top",
                                    invalidMessage: LangHelper.GetString("UlrModule", "Enter the interface"),
                                    validate: function (Val)
                                    {
                                        return ConfigHelper.IsInterface(Val);
                                    },
                                    value:"eth0",
                                    on: {
                                        onChange: function (Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "text",
                                    name: "collector",
                                    label: LangHelper.GetString("Dics", "IP address of QoE Stor"),
                                    labelPosition: "top",
                                    invalidMessage: LangHelper.GetString("UlrModule", "Enter the IP address"),
                                    validate: function (Val)
                                    {
                                        return ConfigHelper.IsValidIpAddress(Val);
                                    },
                                    value:"192.168.1.10",
                                    on: {
                                        onChange: function (Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "richselect",
                                    name: "collector_type",
                                    label: LangHelper.GetString("Dics", "Type"),
                                    labelPosition: "top",
                                    value:"tcp",
                                    options:[
                                        {id:"tcp", value:"TCP"},
                                        {id:"udp", value:"UDP"}
                                    ]
                                }
                            ]
                        },
                        {height:20},
                        {
                            cols:[
                                {},
                                {
                                    view: "button",
                                    label: LangHelper.GetString("Dics", "Cancel"),
                                    click: function(){
                                        setTimeout(function () {
                                            _this.ScenarioQoEStorAutoFillPopupConfig.hide();
                                        },1);
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "ScenarioQoEStorAutoFillPopupApplyBtn",
                                    label:LangHelper.GetString("UlrModule","Apply"),
                                    type: "form",
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function () {
                                            _this.ApplyScenarioQoEStorAutoFillForm();
                                        },1);

                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });

    this.onRestart = function(R)
    {
        if(R.success)
        {
            webix.message(LangHelper.GetString(_this.Id, "Service reloaded successfully"));
        }
        else{
            webix.message({type:"error", text:R.error.msg});
        }
    };

    this.HardwareRestartContext = webix.ui({
        view:"popup",
        width:400,
        height:200,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Are you sure you want to restart the DPI process?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Dics", "Restart"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                                _this.ViewModel.Restart({
                                    callback: _this.onRestart
                                });
                                _this.OnSaveContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HardwareReloadContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Dics", "Are you sure you want to update the hot settings?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Dics", "Refresh"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                                _this.ViewModel.Reload();
                                _this.OnSaveContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.UpdateParamsContextId = this.Id + "UpdateParamsContext";
    this.UpdateParamsContext = webix.ui({
        view:"submenu",
        id:this.UpdateParamsContextId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.UpdateParamsContextId+"RestartDpi", icon: "retweet", value: LangHelper.GetString(_this.Id, "Restart DPI")},
            {id: this.UpdateParamsContextId+"ReloadDpi", icon: "bolt", value: LangHelper.GetString(_this.Id,"Updating hot options")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                var node = $$(_this.Id + "OptionsUpdateBtn").getNode();
                if(id === _this.UpdateParamsContextId+"RestartDpi")
                {
                    setTimeout(function ()
                    {
                        _this.HardwareRestartContext.show(node, {pos: "bottom"});
                    }, 10);
                }
                else if(id === _this.UpdateParamsContextId+"ReloadDpi")
                {
                    _this.HardwareReloadContext.show(node, {pos: "bottom"});
                }
            }
        }
    });

    this.OnSaveContext = webix.ui({
        view:"popup",
        modal: true,
        width:480,
        height:200,
        left: (window.innerWidth / 2 ) - 240,
        top: (window.innerHeight / 2) - 100,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Fast DPI config saved!") + "<br/>" +
                    "<span style='color: red'>" +
                    LangHelper.GetString(_this.Id, "Update the hot parameters or restart Fast DPI for applying the changes!") +
                    "</span>"
                },
                {
                    cols:[
                        {
                            view: "button",
                            height: 40,
                            label: LangHelper.GetString("Dics", "Cancel"),
                            click: function()
                            {
                                _this.OnSaveContext.hide();
                            }
                        },
                        {
                            view:"button",
                            height: 40,
                            type:"form",
                            // label:LangHelper.GetString("Dics", "Restart"),
                            icon: "bolt",
                            label: LangHelper.GetString("Dics","Update"),
                            click:function ()
                            {
                                var node = this.getNode();
                                setTimeout(function ()
                                {
                                    _this.HardwareReloadContext.show(node, {pos: "bottom"});
                                }, 10);
                            }
                        },
                        {width: 8},
                        {
                            height: 40,
                            view:"button",
                            icon: "retweet",
                            type:"form",
                            label: LangHelper.GetString("Dics", "Restart"),
                            click:function ()
                            {
                                var node = this.getNode();
                                setTimeout(function ()
                                {
                                    _this.HardwareRestartContext.show(node, {pos: "top"});
                                }, 10);
                            }
                        }


                    ]
                }
            ]
        }
    });

    var params = webix.extend(Params,{
        Id:_this.Id,
        PageTitle:{
            RootTitle: LangHelper.GetString("AppView", "DPI control"),
            Title: LangHelper.GetString("AppView", "Configuration")
        },
        LeftSideBar: DpiConfigLeftSideBarView({id: this.Id}),
        ViewModel: _this.ViewModel,
        VchannelModel: _this.VchannelModel,
        UseValidateOnSave: true,
        UseCurrentHardwareId: true,
        Buttons: [
            {
                view: "button",
                id:this.Id + "OptionsUpdateBtn",
                type: "icon",
                icon: "retweet",
                css: "toolbar_round_btn",
                width: 32,
                tooltip: LangHelper.GetString("Dics", "Updating options"),
                click: function (id, e, node)
                {
                    var __this = this;
                    setTimeout(function () {
                        var node = __this.getNode(id);
                        _this.UpdateParamsContext.show(node, {pos: "bottom"});
                    }, 1);
                }
            }
        ],
        onSave: function()
        {
            _this.OnSaveContext.show();
            return;
        }
    },true);

    DpiConfigViewController.superclass.constructor.call(this, params);

    this.Views.PolicingAutoFillPopupForm = $$(this.Id + "PolicingAutoFillPopupForm");
    this.Views.ScenarioQoEStorAutoFillPopupForm = $$(this.Id + "ScenarioQoEStorAutoFillPopupForm");
    // this.OnSaveContext.show();
}

Helper.ExtendClass(DpiConfigViewController,HardwareConfigViewController);

DpiConfigViewController.prototype.PolicingAutoConfigButtonClick = function(Node)
{
    this.PolicingAutoFillPopupConfig.show(Node);
};

DpiConfigViewController.prototype.ApplyPolicingAutoFillForm = function()
{
    var _this = this;

    if (!this.Views.PolicingAutoFillPopupForm.validate())
    {
        return;
    }

    var formVals = this.Views.PolicingAutoFillPopupForm.getValues();

    var inbound = formVals.inbound_root_rate+formVals.inbound_root_rate_unit;
    var outbound = formVals.outbound_root_rate+formVals.outbound_root_rate_unit;
    var policing = formVals.policing_type;
    var prefix = policing.toLowerCase();
    var getValue = function(Val, Type, Class)
    {
      if(Type == "htb" && Class != "root")
      {
          return "rate 8bit ceil " + Val;
      }
      return "rate " + Val;
    };

    Object.keys(this.Views.ParamsForm.elements).forEach(function(Key){

        if(Key.indexOf(prefix) >= 0)
        {
            _this.Views.ParamsForm.elements[Key].setValue(getValue(
                Key.indexOf("inbound") >= 0 ? inbound : outbound,
                Key.indexOf("htb") >= 0 ? "htb" : "",
                Key.indexOf("htb") >= 0 && Key.indexOf("root") >= 0 ? "root" : ""
            ));
        }
        else{
            _this.Views.ParamsForm.elements[Key].setValue("");
        }
    });

    if(_this.Views.ParamsForm.elements.policing_type)
    {
        _this.Views.ParamsForm.elements.policing_type.setValue(policing);
    }

    this.PolicingAutoFillPopupConfig.hide();
};

DpiConfigViewController.prototype.ClearCurrentFormButtonClick = function(Node)
{
    var _this = this;

    Object.keys(this.Views.ParamsForm.elements).forEach(function(Key){
        _this.Views.ParamsForm.elements[Key].setValue("");
    });
};

DpiConfigViewController.prototype.ScenarioQoeStorAutoFillButtonClick = function(Node)
{
    this.ScenarioQoEStorAutoFillPopupConfig.show(Node);
};

DpiConfigViewController.prototype.DdosAutoFillButtonClick = function(Node)
{
    var _this = this;

    this.DdosViewModel.GetCaptchaHardwareIpAndSecurityKey(
        {
            callback:function (R)
            {
                if(R.success && R.data)
                {
                    if(R.data.ip.error && !R.data.ip.error.success){
                        _this.ShowServerError({msg: LangHelper.GetString("DDoSProtectionService", "The CAPTCHA server is not connected. Connect in the Hardware section")});
                        return;
                    }
                    if(R.data.env.error && !R.data.env.error.success){
                        _this.ShowServerError({msg: R.data.env.error.msg});
                        return;
                    }

                    var parser = new ConfigIniParser();
                    if(R.data.env.data)
                        parser.parse(R.data.env.data);

                    var configModel = new CaptchaConfigModel(parser.itemsKeyVal());
                    _this.Views.ParamsForm.elements.ddos_security_key.setValue(configModel.captcha_key)
                    _this.Views.ParamsForm.elements.ddos_check_server.setValue(`${R.data.ip.data}/?`)
                }
                else
                {
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }
        }
    );

    return true;
};

DpiConfigViewController.prototype.ApplyScenarioQoEStorAutoFillForm = function()
{
    var _this = this;

    if (!this.Views.ScenarioQoEStorAutoFillPopupForm.validate())
    {
        return;
    }

    var formVals = this.Views.ScenarioQoEStorAutoFillPopupForm.getValues();
    var oldFormVals = this.Views.ParamsForm.getValues();

    var oldNetflow = isNaN(parseInt(oldFormVals.netflow)) ? 0 : parseInt(oldFormVals.netflow);

    var valsToSet = {
        netflow: oldNetflow >= 8 ? oldNetflow : (oldNetflow + 8),
        netflow_dev: formVals.dev,
        netflow_full_collector_type: formVals.collector_type == 'udp' ? 1 : 2,
        netflow_full_collector: formVals.collector + ":1500",
        ipfix_dev: formVals.dev,
        ipfix_tcp_collectors: formVals.collector_type == 'tcp' ? formVals.collector + ":1501" : "",
        ipfix_udp_collectors: formVals.collector_type == 'udp' ? formVals.collector + ":1501" : "",
        netflow_full_port_swap:0
    };

    Object.keys(valsToSet).forEach(function(Key)
    {
        if(_this.Views.ParamsForm.elements[Key])
            _this.Views.ParamsForm.elements[Key].setValue(valsToSet[Key]);
    });

    this.ScenarioQoEStorAutoFillPopupConfig.hide();
};

DpiConfigViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};
function DpiDscpConfigViewController(Params)
{
    var _this = this;

    this.Id = "DpiDscpConfig";

    this.ViewModel = new HardwareDscpProrocolsManager();

    this.OnSaveContext = webix.ui({
        view:"popup",
        modal: true,
        width:480,
        height:200,
        left: (window.innerWidth / 2 ) - 240,
        top: (window.innerHeight / 2) - 100,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id,"Dscp configuration saved") + "<br/>" +
                    "<span style='color: red'>" +
                    LangHelper.GetString("DpiConfig", "Update the hot parameters or restart Fast DPI for applying the changes!") +
                    "</span>"
                },
                {
                    cols:[
                        {
                            view: "button",
                            height: 40,
                            label: LangHelper.GetString("Dics", "Cancel"),
                            click: function()
                            {
                                _this.OnSaveContext.hide();
                            }
                        },
                        {
                            view:"button",
                            height: 40,
                            type:"form",
                            // label:LangHelper.GetString("Dics", "Restart"),
                            icon: "bolt",
                            label: LangHelper.GetString("Dics","Update"),
                            click:function ()
                            {
                                var node = this.getNode();
                                setTimeout(function ()
                                {
                                    _this.HardwareReloadContext.show(node, {pos: "bottom"});
                                }, 10);
                            }
                        },
                        {width: 8},
                        {
                            height: 40,
                            view:"button",
                            icon: "retweet",
                            type:"form",
                            label: LangHelper.GetString("Dics", "Restart"),
                            click:function ()
                            {
                                var node = this.getNode();
                                setTimeout(function ()
                                {
                                    _this.HardwareRestartContext.show(node, {pos: "top"});
                                }, 10);
                            }
                        }


                    ]
                }
            ]
        }
    });

    this.HardwareRestartContext = webix.ui({
        view:"popup",
        width:400,
        height:200,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("DpiConfig", "Are you sure you want to restart the DPI process?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Dics", "Restart"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                                App.SessionManager.RestartHardware();
                                _this.OnSaveContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HardwareReloadContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Dics", "Are you sure you want to update the hot settings?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Dics", "Refresh"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                                App.SessionManager.ReloadHardware();
                                _this.OnSaveContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.UpdateParamsContextId = this.Id + "UpdateParamsContext";
    this.UpdateParamsContext = webix.ui({
        view:"submenu",
        id:this.UpdateParamsContextId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.UpdateParamsContextId+"RestartDpi", icon: "retweet", value: LangHelper.GetString("DpiConfig", "Restart DPI")},
            {id: this.UpdateParamsContextId+"ReloadDpi", icon: "bolt", value: LangHelper.GetString(_this.Id,"Updating hot options")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                var node = _this.Views.OptionsUpdateBtn.getNode();
                if(id === _this.UpdateParamsContextId+"RestartDpi")
                {
                    setTimeout(function ()
                    {
                        _this.HardwareRestartContext.show(node, {pos: "bottom"});
                    }, 10);
                }
                else if(id === _this.UpdateParamsContextId+"ReloadDpi")
                {
                    _this.HardwareReloadContext.show(node, {pos: "bottom"});
                }
            }
        }
    });

    this.ConfigImportContext = webix.ui({
        view:"popup",
        width:720,
        height:720,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"ConfigImportContextForm",
            borderless:true,
            elements:[
                {
                    view: "uploader",
                    value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                    id: this.Id+"ConfigImportContextForm" + "Uploader",
                    css:"upload_area",
                    autosend:false,
                    height:64
                },
                {
                    view:"codemirror-editor",
                    id:this.Id+"ConfigImportContextForm" + "Text",
                    value:""
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ConfigImportContext.hide();
                                _this.Views.ImportContextCodeEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Apply"),
                            click:function () {
                                _this.ConfigImportContext.hide();

                                _this.ViewModel.SetConfig(_this.Views.ImportContextCodeEditor.getValue());

                                webix.message(LangHelper.GetString(_this.Id,"Applied"));

                                _this.Views.ImportContextCodeEditor.setValue("");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HistoryImportContext = webix.ui({
        view:"popup",
        width:800,
        height:720,
        id:this.Id+"HistoryImportContext",
        modal:true,
        body:{
            rows:[
                {
                    borderless:true,
                    cols:[
                        {
                            width:240,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"History"), icon: "history"}),
                                {
                                    view:"datatable",
                                    id:this.Id + "HistoryImportContext" + "HistoryTable",
                                    select: "row",
                                    columns: [
                                        {
                                            id: "date",
                                            header: [LangHelper.GetString(_this.Id,"Date"), {content: "dateRangeFilter"}],
                                            format: webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"),
                                            fillspace: true,
                                            sort: "date"
                                        }
                                    ],
                                    on:{
                                        onAfterLoad:function(){
                                            this.sort("date", "desc", "date");
                                            this.markSorting("date", "desc");
                                        },
                                        onAfterSelect: function (data, preserve)
                                        {
                                            var rowData = this.getItem(data);

                                            _this.Views.HistoryEditor.showProgress({type: "icon"});

                                            _this.ViewModel.LoadHistoryFile({configFile:rowData.file_id, callback:function (R)
                                            {
                                                _this.Views.HistoryEditor.hideProgress({type: "icon"});
                                                if(R.success)
                                                {
                                                    _this.Views.HistoryEditor.setValue(R.data);
                                                }
                                                else
                                                {
                                                    webix.message({type:"error",text:LangHelper.GetString(_this.Id,"Could not upload file")})
                                                }
                                            }});
                                        }
                                    },
                                    data:[]
                                }
                            ]
                        },
                        {view:"resizer"},
                        {
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"Config"), icon: "code"}),
                                {
                                    view:"codemirror-editor",
                                    id:this.Id + "HistoryImportContext" + "Editor",
                                    value:""
                                }
                            ]
                        }
                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.HistoryImportContext.hide();
                                _this.Views.HistoryEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Apply"),
                            click:function () {
                                _this.HistoryImportContext.hide();

                                _this.ViewModel.SetConfig(_this.Views.HistoryEditor.getValue());

                                webix.message(LangHelper.GetString(_this.Id,"Applied"));

                                _this.Views.HistoryEditor.setValue("");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ProtocolsSuggest = webix.ui({
        id: this.Id + "ProtocolsSuggest",
        view: "suggest",
        template:function(obj){
            return obj.protocol;
        },
        data: Helper.DictToArr(HardwareDscpProtocolsDic),
        filter: function(obj, value){
            return obj && obj.protocol && (obj.protocol.toLowerCase()).indexOf(value.toLowerCase()) !== -1;
        }
    });

    this.AddProtoContext = webix.ui({
        view:"popup",
        width:400,
        height:320,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"AddProtoContextForm",
            borderless:true,
            elements:[
                {
                    view: "text",
                    name: "protocol",
                    id: this.Id + "AddProtoContextFormProtocolInput",
                    label: LangHelper.GetString(this.Id, "Protocol"),
                    labelPosition: "top",
                    validate: function(Val)
                    {
                        return Val && Val != "";
                    },
                    suggest: this.ProtocolsSuggest
                },
                {
                    view: "richselect",
                    name: "dscp",
                    required: false,
                    label: LangHelper.GetString(this.Id,"The value of dscp"),
                    labelPosition: "top",
                    invalidMessage: LangHelper.GetString("Advc", "Required field"),
                    suggest:{
                        view:"gridsuggest",
                        body:{
                            autoheight:false,
                            scroll:true,
                            maxHeight:400,
                            width:720,
                            borderless:true,
                            columns:[
                                { id:"value", header:LangHelper.GetString(_this.Id,"DSCP name") },
                                { id:"binary", header:LangHelper.GetString(_this.Id,"Binary value") },
                                { id:"decimal", header:LangHelper.GetString(_this.Id,"Decimal value") },
                                { id:"priority", header:LangHelper.GetString(_this.Id,"Priority") },
                                { id:"class", header:LangHelper.GetString(_this.Id,"Policing class") },
                                { id:"class_order_1", header:"class_order=1" }
                            ],
                            data:Helper.DictToArr(DscpDic)
                        }
                    }
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.AddProtoContext.hide();
                                _this.ClearAddProtocolForm();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Apply"),
                            click:function () {
                                setTimeout(function(){
                                    if(_this.AddProtocol())
                                    {
                                        webix.message(LangHelper.GetString(_this.Id,"Applied"));
                                        _this.AddProtoContext.hide();
                                        _this.ClearAddProtocolForm();
                                    }
                                }, 1);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.SetDscpForGroupsContext = webix.ui({
        view:"popup",
        width:400,
        height:320,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"SetDscpForGroupsContextForm",
            borderless:true,
            elements:[
                {
                    view: "richselect",
                    name: "dscp",
                    required: false,
                    label: LangHelper.GetString(this.Id,"The value of dscp"),
                    labelPosition: "top",
                    invalidMessage: LangHelper.GetString("Advc", "Required field"),
                    suggest:{
                        view:"gridsuggest",
                        body:{
                            autoheight:false,
                            scroll:true,
                            maxHeight:400,
                            width:720,
                            borderless:true,
                            columns:[
                                { id:"value", header:LangHelper.GetString(_this.Id,"DSCP name") },
                                { id:"binary", header:LangHelper.GetString(_this.Id,"Binary value") },
                                { id:"decimal", header:LangHelper.GetString(_this.Id,"Decimal value") },
                                { id:"priority", header:LangHelper.GetString(_this.Id,"Priority") },
                                { id:"class", header:LangHelper.GetString(_this.Id,"Policing class") },
                                { id:"class_order_1", header:"class_order=1" }
                            ],
                            data:Helper.DictToArr(DscpDic)
                        }
                    }
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.SetDscpForGroupsContext.hide();
                                _this.Views.SetDscpForGroupsContextForm.setValues({dscp: ""});
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Apply"),
                            click:function () {
                                if(_this.SetDscpForGroups())
                                {
                                    webix.message(LangHelper.GetString(_this.Id,"Applied"));
                                    _this.SetDscpForGroupsContext.hide();
                                    _this.Views.SetDscpForGroupsContextForm.setValues({dscp: ""});
                                }
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.SetDscpForProtocolsContext = webix.ui({
        view:"popup",
        width:400,
        height:320,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"SetDscpForProtocolsContextForm",
            borderless:true,
            elements:[
                {
                    view: "richselect",
                    name: "dscp",
                    required: false,
                    label: LangHelper.GetString(this.Id,"The value of dscp"),
                    labelPosition: "top",
                    invalidMessage: LangHelper.GetString("Advc", "Required field"),
                    suggest:{
                        view:"gridsuggest",
                        body:{
                            autoheight:false,
                            scroll:true,
                            maxHeight:400,
                            width:720,
                            borderless:true,
                            columns:[
                                { id:"value", header:LangHelper.GetString(_this.Id,"DSCP name") },
                                { id:"binary", header:LangHelper.GetString(_this.Id,"Binary value") },
                                { id:"decimal", header:LangHelper.GetString(_this.Id,"Decimal value") },
                                { id:"priority", header:LangHelper.GetString(_this.Id,"Priority") },
                                { id:"class", header:LangHelper.GetString(_this.Id,"Policing class") },
                                { id:"class_order_1", header:"class_order=1" }
                            ],
                            data:Helper.DictToArr(DscpDic)
                        }
                    }
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.SetDscpForProtocolsContext.hide();
                                _this.Views.SetDscpForProtocolsContextForm.setValues({dscp: ""});
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Apply"),
                            click:function () {
                                if(_this.SetDscpForProtocols())
                                {
                                    webix.message(LangHelper.GetString(_this.Id,"Applied"));
                                    _this.SetDscpForProtocolsContext.hide();
                                    _this.Views.SetDscpForProtocolsContextForm.setValues({dscp: ""});
                                }
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols: [
                DpiConfigLeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","DPI control"), title: LangHelper.GetString("AppView","Protocol prioritization (DSCP)")}),
                                {
                                    view:"accordion",
                                    multi:"mixed",
                                    on: {
                                        onAfterExpand: function(id) {
                                            Helper.RefreshView(_this.Views.Table);
                                            return true;
                                        },
                                        onAfterCollapse: function(id)
                                        {
                                            Helper.RefreshView(_this.Views.Table);
                                            return true;
                                        }
                                    },
                                    cols: [
                                        {
                                            header:LangHelper.GetString(this.Id,"Priority configuration"),
                                            body:{
                                                rows: [
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.dpiui2.tabbarHeight,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "floppy-o",
                                                                id: this.Id + "SaveBtn",
                                                                label: LangHelper.GetString("All","Save"),
                                                                css: "toolbar_round_btn",
                                                                width: 128,
                                                                tooltip: LangHelper.GetString("All","Save"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.ConfigSave();
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "OptionsUpdateBtn",
                                                                type: "icon",
                                                                icon: "retweet",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("Dics", "Updating options"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.UpdateParamsContext.show(node, {pos: "bottom"});
                                                                    }, 1);
                                                                }
                                                            },
                                                            {
                                                                id: this.Id + "UploadBtn",
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "upload",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip:  LangHelper.GetString("All","Upload from file"),
                                                                click: function (id, e, node) {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.ConfigImportContext.show(node, {pos: "bottom"});
                                                                        _this.Views.ImportContextCodeEditor.setValue("");
                                                                    }, 10);
                                                                }
                                                            },
                                                            {
                                                                id: this.Id + "HistoryBtn",
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "history",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("All","Download from history"),
                                                                click: function (id, e, node) {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.HistoryImportContext.show(node, {pos: "bottom"});
                                                                        _this.DefineHistoryForms();
                                                                    }, 10);
                                                                }
                                                            },
                                                            {},
                                                            {
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    App.NavRouter.ShowProgress();
                                                                    _this.ViewModel.Refresh();
                                                                    _this.ViewModel.HistoryRefresh();
                                                                }
                                                            },
                                                            {
                                                                width:16
                                                            },
                                                            {
                                                                view:"tabbar",
                                                                id:this.Id + "Editor" + "Tabs",
                                                                tabMoreWidth:0,
                                                                value:this.Id + "Editor",
                                                                multiview:true,
                                                                options: [
                                                                    {
                                                                        id: this.Id + "Editor",
                                                                        "value": "<span class='webix_icon fa-trello'></span> "+LangHelper.GetString("All","The form")
                                                                    },
                                                                    {
                                                                        id: this.Id + "Editor" + "Code",
                                                                        "value": "<span class='webix_icon fa-code'></span> "+LangHelper.GetString("All","Editor")
                                                                    }
                                                                ],
                                                                on:{
                                                                    "onAfterTabClick":function(Id)
                                                                    {
                                                                        if(Id == _this.Id + "Editor" + "Code")
                                                                        {
                                                                            setTimeout(function ()
                                                                            {
                                                                                _this.SetConfigModel();
                                                                                _this.Views.CodeEditor.setValue(_this.ViewModel.GetConfig());
                                                                            },1);
                                                                        }
                                                                    },

                                                                    "onChange":function(Id, OldId)
                                                                    {
                                                                        if(Id == _this.Id + "Editor" + "Code")
                                                                        {
                                                                            setTimeout(function ()
                                                                            {
                                                                                _this.Views.CodeEditor.setValue(_this.ViewModel.GetConfig());
                                                                            },1);
                                                                        }

                                                                        if(Id == _this.Id + "Editor")
                                                                        {
                                                                            setTimeout(function ()
                                                                            {
                                                                                _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                            },1);
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        id: this.Id + "FormsWrapper",
                                                        rows:[
                                                            {
                                                                cells:[
                                                                    {
                                                                        id: this.Id + "Editor",
                                                                        rows: [
                                                                            {
                                                                                view: "accordion",
                                                                                multi:true,
                                                                                cols:[
                                                                                    {
                                                                                        header: LangHelper.GetString(this.Id, "List of protocols groups"),
                                                                                        collapsed:true,
                                                                                        body:{
                                                                                            rows:[
                                                                                                {
                                                                                                    view:"toolbar",
                                                                                                    borderless:true,
                                                                                                    height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.dpiui2.tabbarHeight,
                                                                                                    elements:[
                                                                                                        {
                                                                                                            id: this.Id + "SetDscpForSelectedGroupsBtn",
                                                                                                            view: "button",
                                                                                                            type: "icon",
                                                                                                            icon: "cogs",
                                                                                                            css:"toolbar_round_btn",
                                                                                                            width:32,
                                                                                                            tooltip:LangHelper.GetString(_this.Id,"Set dscp value"),
                                                                                                            click: function (id, e, node) {
                                                                                                                var __this = this;
                                                                                                                setTimeout(function () {
                                                                                                                    var node = __this.getNode(id);
                                                                                                                    _this.SetDscpForGroupsContext.show(node, {pos: "bottom"});
                                                                                                                }, 10);
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    view: "datatable",
                                                                                                    id: this.Id + "GroupsTable",
                                                                                                    editable: true,
                                                                                                    select: "row",
                                                                                                    multiselect: true,
                                                                                                    columns: [
                                                                                                        {
                                                                                                            id:"checked",
                                                                                                            header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                                                                                                            template: CellColoredCheckBoxTemplate,
                                                                                                            width:32
                                                                                                        },
                                                                                                        {
                                                                                                            id: "value",
                                                                                                            header: [
                                                                                                                LangHelper.GetString(this.Id,"Group"),
                                                                                                                {
                                                                                                                    content: "textFilter",
                                                                                                                    // placeholder:"&#xf002 "+LangHelper.GetString("All","Filter"),
                                                                                                                    placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                                                                                                                }
                                                                                                            ],
                                                                                                            fillspace: 2
                                                                                                        },
                                                                                                        {
                                                                                                            id: "dscp",
                                                                                                            header: [
                                                                                                                LangHelper.GetString(this.Id,"The value of dscp"),
                                                                                                                {
                                                                                                                    content: "textFilter",
                                                                                                                    placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                                                                                                                }
                                                                                                            ],
                                                                                                            editor:"combo",
                                                                                                            fillspace: 1,
                                                                                                            template: function(Obj)
                                                                                                            {
                                                                                                              var tpl = CellEditBtnTemplate();

                                                                                                              if(Obj && Obj.dscp)
                                                                                                              {
                                                                                                                  tpl += " " + Obj.dscp;
                                                                                                              }

                                                                                                              return tpl;
                                                                                                            },
                                                                                                            suggest:{
                                                                                                                view:"gridsuggest",
                                                                                                                body:{
                                                                                                                    autoheight:false,
                                                                                                                    scroll:true,
                                                                                                                    maxHeight:400,
                                                                                                                    width:720,
                                                                                                                    borderless:true,
                                                                                                                    columns:[
                                                                                                                        { id:"value", header:LangHelper.GetString(_this.Id,"DSCP name") },
                                                                                                                        { id:"binary", header:LangHelper.GetString(_this.Id,"Binary value") },
                                                                                                                        { id:"decimal", header:LangHelper.GetString(_this.Id,"Decimal value") },
                                                                                                                        { id:"priority", header:LangHelper.GetString(_this.Id,"Priority") },
                                                                                                                        { id:"class", header:LangHelper.GetString(_this.Id,"Policing class") },
                                                                                                                        { id:"class_order_1", header:"class_order=1" }
                                                                                                                    ],
                                                                                                                    data:Helper.DictToArr(DscpDic)
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                    ],
                                                                                                    on:{
                                                                                                        onAfterSelect:function(data, preserve)
                                                                                                        {
                                                                                                            _this.Views.Table.editStop();
                                                                                                            var item = this.getItem(data.id);
                                                                                                            if(item)
                                                                                                            {
                                                                                                                if(!item.checked)
                                                                                                                {
                                                                                                                    item.checked = 1;
                                                                                                                }
                                                                                                                _this.Views.GroupsTable.updateItem(data.id, item);
                                                                                                            }
                                                                                                            _this.GroupsTableSelectionHandler();
                                                                                                        },
                                                                                                        onAfterUnSelect:function(data)
                                                                                                        {
                                                                                                            var item = this.getItem(data.id);
                                                                                                            if(item && item.checked)
                                                                                                            {
                                                                                                                if(item.checked)
                                                                                                                {
                                                                                                                    item.checked = 0;
                                                                                                                }
                                                                                                                _this.Views.GroupsTable.updateItem(data.id, item);
                                                                                                            }
                                                                                                            _this.GroupsTableSelectionHandler();
                                                                                                        },
                                                                                                        onBeforeUnselect: function(data)
                                                                                                        {
                                                                                                            _this.Views.Table.editStop();
                                                                                                            _this.SetConfigModel();
                                                                                                        },
                                                                                                        onHeaderClick:function(id, e, target)
                                                                                                        {
                                                                                                            if(id.column == "checked")
                                                                                                            {
                                                                                                                var cb = _this.Views.GroupsTable.getHeaderContent("mc");
                                                                                                                if(cb.isChecked())
                                                                                                                {
                                                                                                                    _this.Views.GroupsTable.selectAll();
                                                                                                                }
                                                                                                                else{
                                                                                                                    _this.Views.GroupsTable.unselectAll();
                                                                                                                }
                                                                                                            }
                                                                                                            return false;
                                                                                                        },
                                                                                                        onAfterEditStop: function(state, editor, ignore){
                                                                                                            if(state.old != state.value && !ignore)
                                                                                                            {
                                                                                                                _this.SetDscpForGroup(this.getItem(editor.row), state.value);
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            ]

                                                                                        },
                                                                                        gravity: 2
                                                                                    },
                                                                                    {view: "resizer"},
                                                                                    {
                                                                                        header: LangHelper.GetString(this.Id , "List of protocols and priorities"),
                                                                                        id: this.Id + "ProtocolsWrapper",
                                                                                        body: {
                                                                                            rows: [

                                                                                                {
                                                                                                    view:"toolbar",
                                                                                                    borderless:true,
                                                                                                    height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.dpiui2.tabbarHeight,
                                                                                                    elements:[
                                                                                                        {
                                                                                                            id: this.Id + "AddProtoBtn",
                                                                                                            view: "button",
                                                                                                            type: "icon",
                                                                                                            icon: "plus",
                                                                                                            css:"toolbar_round_btn",
                                                                                                            width:32,
                                                                                                            tooltip:LangHelper.GetString("All","Add value"),
                                                                                                            click: function (id, e, node) {
                                                                                                                var __this = this;
                                                                                                                setTimeout(function () {
                                                                                                                    var node = __this.getNode(id);
                                                                                                                    _this.AddProtoContext.show(node, {pos: "bottom"});
                                                                                                                }, 10);
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "SetDscpForSelectedProtocolsBtn",
                                                                                                            view: "button",
                                                                                                            type: "icon",
                                                                                                            icon: "cogs",
                                                                                                            css:"toolbar_round_btn",
                                                                                                            width:32,
                                                                                                            tooltip:LangHelper.GetString("All","Set dscp value"),
                                                                                                            click: function (id, e, node) {
                                                                                                                var __this = this;
                                                                                                                setTimeout(function () {
                                                                                                                    var node = __this.getNode(id);
                                                                                                                    _this.SetDscpForProtocolsContext.show(node, {pos: "bottom"});
                                                                                                                }, 10);
                                                                                                            }
                                                                                                        },
                                                                                                        {width: 16},
                                                                                                        {
                                                                                                            view:"checkbox",
                                                                                                            id:this.Id + "ShowAllProtocols",
                                                                                                            labelRight:LangHelper.GetString(_this.Id, "Show all protocols"),
                                                                                                            labelWidth:0,
                                                                                                            on:
                                                                                                                {
                                                                                                                    "onChange":function(NewVal, OldVal)
                                                                                                                    {
                                                                                                                        App.SessionManager.SetPreference(_this.Id + ":ShowAllProtocols",NewVal);
                                                                                                                        setTimeout(function(){
                                                                                                                            _this.SetConfigModel();
                                                                                                                        }, 1);
                                                                                                                        // _this.GroupsTableSelectionHandler();
                                                                                                                    }
                                                                                                                }
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    view: "datatable",
                                                                                                    id:this.Id + "Table",
                                                                                                    editable: true,
                                                                                                    multiselect: true,
                                                                                                    select: "row",
                                                                                                    on: {
                                                                                                        onItemClick: function (id)
                                                                                                        {
                                                                                                            if(id.column === 'trash')
                                                                                                            {
                                                                                                                var item = this.getItem(id);
                                                                                                                setTimeout(function(){
                                                                                                                    _this.DeleteDscpForProtocol([item]);
                                                                                                                }, 1);
                                                                                                            }
                                                                                                        },
                                                                                                        onTimedKeyPress: function(code, e)
                                                                                                        {
                                                                                                            var editor = this.getEditor();

                                                                                                            if(editor && editor.column && editor.column == "protocol")
                                                                                                            {
                                                                                                                var value = editor.getValue();

                                                                                                                App.DicsManager.Refresh({data:[DicsEnum.ProtocolsDic], filter:value});
                                                                                                            }
                                                                                                        },
                                                                                                        onAfterSelect:function(data, preserve)
                                                                                                        {
                                                                                                            var item = this.getItem(data.id);
                                                                                                            if(item)
                                                                                                            {
                                                                                                                if(!item.checked)
                                                                                                                {
                                                                                                                    item.checked = 1;
                                                                                                                }
                                                                                                                _this.Views.Table.updateItem(data.id, item);
                                                                                                            }
                                                                                                            _this.ProtocolsTableSelectionHandler();
                                                                                                        },
                                                                                                        onAfterUnSelect:function(data)
                                                                                                        {
                                                                                                            var item = this.getItem(data.id);
                                                                                                            if(item && item.checked)
                                                                                                            {
                                                                                                                if(item.checked)
                                                                                                                {
                                                                                                                    item.checked = 0;
                                                                                                                }
                                                                                                                _this.Views.Table.updateItem(data.id, item);
                                                                                                            }
                                                                                                            _this.ProtocolsTableSelectionHandler();
                                                                                                        },
                                                                                                        onHeaderClick:function(id, e, target)
                                                                                                        {
                                                                                                            if(id.column == "checked")
                                                                                                            {
                                                                                                                var cb = _this.Views.Table.getHeaderContent("mc");
                                                                                                                if(cb.isChecked())
                                                                                                                {
                                                                                                                    _this.Views.Table.selectAll();
                                                                                                                }
                                                                                                                else{
                                                                                                                    _this.Views.Table.unselectAll();
                                                                                                                }
                                                                                                            }
                                                                                                            return false;
                                                                                                        },
                                                                                                        onAfterEditStop: function(state, editor, ignore){
                                                                                                            if(state.old != state.value && !ignore)
                                                                                                            {
                                                                                                                setTimeout(function(){
                                                                                                                    _this.OnProtocolChangedInsideTableHandler(state.value);
                                                                                                                }, 1);
                                                                                                            }

                                                                                                            return true;
                                                                                                        }
                                                                                                    },
                                                                                                    keyPressTimeout:500,
                                                                                                    columns: [
                                                                                                        {
                                                                                                            id:"checked",
                                                                                                            header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                                                                                                            template: CellColoredCheckBoxTemplate,
                                                                                                            width:32
                                                                                                        },
                                                                                                        {
                                                                                                            id: "protocol",
                                                                                                            header: [
                                                                                                                LangHelper.GetString(this.Id,"Protocol"),
                                                                                                                {
                                                                                                                    content: "textFilter",
                                                                                                                    // placeholder:"&#xf002 "+LangHelper.GetString("All","Filter"),
                                                                                                                    placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                                                                                                                }
                                                                                                            ],
                                                                                                            fillspace: 1
                                                                                                        },
                                                                                                        {
                                                                                                            id: "dscp",
                                                                                                            header: [
                                                                                                                LangHelper.GetString(this.Id,"The value of dscp"),
                                                                                                                {
                                                                                                                    content: "textFilter",
                                                                                                                    placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                                                                                                                }
                                                                                                            ],
                                                                                                            editor:"combo",
                                                                                                            fillspace: 1,
                                                                                                            template: function(Obj)
                                                                                                            {
                                                                                                                var tpl = CellEditBtnTemplate();

                                                                                                                if(Obj && Obj.dscp)
                                                                                                                {
                                                                                                                    tpl += " " + Obj.dscp;
                                                                                                                }

                                                                                                                return tpl;
                                                                                                            },
                                                                                                            suggest:{
                                                                                                                view:"gridsuggest",
                                                                                                                body:{
                                                                                                                    autoheight:false,
                                                                                                                    scroll:true,
                                                                                                                    maxHeight:400,
                                                                                                                    width:720,
                                                                                                                    borderless:true,
                                                                                                                    columns:[
                                                                                                                        { id:"value", header:LangHelper.GetString(_this.Id,"DSCP name") },
                                                                                                                        { id:"binary", header:LangHelper.GetString(_this.Id,"Binary value") },
                                                                                                                        { id:"decimal", header:LangHelper.GetString(_this.Id,"Decimal value") },
                                                                                                                        { id:"priority", header:LangHelper.GetString(_this.Id,"Priority") },
                                                                                                                        { id:"class", header:LangHelper.GetString(_this.Id,"Policing class") },
                                                                                                                        { id:"class_order_1", header:"class_order=1" }
                                                                                                                    ],
                                                                                                                    data:Helper.DictToArr(DscpDic)
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            id: "group",
                                                                                                            fillspace: 2,
                                                                                                            header: [
                                                                                                                LangHelper.GetString(this.Id, "Group"),
                                                                                                                {
                                                                                                                    content: "multiSelectFilter",
                                                                                                                    options: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic),
                                                                                                                    inputConfig: {suggest: {fitMaster: false}}
                                                                                                                }
                                                                                                            ],
                                                                                                            template: function(obj){

                                                                                                                var result = "";

                                                                                                                if(obj && obj.group != null)
                                                                                                                {
                                                                                                                    var group = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic).find(function(val){return val.dic_id == obj.group});

                                                                                                                    if(group)
                                                                                                                    {
                                                                                                                        result = group.value;
                                                                                                                    }
                                                                                                                }
                                                                                                                return result;
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            id: "trash",
                                                                                                            header: "",
                                                                                                            width: 40,
                                                                                                            template: CellTrashBtnTemplate,
                                                                                                            headermenu: false
                                                                                                        }
                                                                                                    ],
                                                                                                    data:[]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        gravity: 3
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        id:this.Id + "Editor" + "Code",
                                                                        rows:[
                                                                            {
                                                                                view:"codemirror-editor",
                                                                                id:this.Id + "Editor" + "Code" + "Codetree",
                                                                                value:""
                                                                            }
                                                                            // ,
                                                                            // {
                                                                            //     view:"toolbar",
                                                                            //     borderless:true,
                                                                            //     elements:[
                                                                            //         {
                                                                            //             gravity:2
                                                                            //         },
                                                                            //         {
                                                                            //             view:"button",
                                                                            //             label:LangHelper.GetString(_this.Id,"Apply"),
                                                                            //             click:function ()
                                                                            //             {
                                                                            //                 _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                            //                 webix.message(LangHelper.GetString(_this.Id,"Applied"));
                                                                            //             }
                                                                            //         }
                                                                            //     ]
                                                                            // }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            gravity: 2
                                        },
                                        {view: "resizer"},
                                        {
                                            header:"WiKi",
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id:this.Id + "WiKi"+"HistoryBackBtn",
                                                                type: "icon",
                                                                icon: "arrow-left",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString(_this.Id,"Back"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var histLength = _this.WikiHistoryLength.getValue();

                                                                    if(histLength > 1)
                                                                    {
                                                                        _this.WikiHistoryLength.next(histLength - 2);
                                                                        window.history.back();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "WiKi"+"HistoryForwardBtn",
                                                                type: "icon",
                                                                icon: "arrow-right",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString(_this.Id,"Forward"),
                                                                click: function (id, e, node)
                                                                {
                                                                    window.history.forward();
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        view:"iframe",
                                                        id:this.Id + "WiKi",
                                                        src:LangHelper.GetString("Dics","https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:priority_config:start")
                                                    }
                                                ]
                                            },
                                            gravity: 1
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Views = {
        Table:null,
        CodeEditor:null,
        GroupsTable: null,
        ShowAllProtocols: null,
        ProtocolsWrapper: null,
        AddProtoBtn: null,
        SetDscpForSelectedProtocolsBtn: null,
        SetDscpForSelectedGroupsBtn: null,
        AddProtoContextFormProtocolInput: null,
        AddProtoContextForm: null,
        SetDscpForGroupsContextForm: null,
        SetDscpForProtocolsContextForm: null,
        SaveBtn: null,
        OptionsUpdateBtn : null,
        UploadBtn: null,
        HistoryBtn: null,
        FormsWrapper: null
    };

    this.Subscriptions = {};

    this.Signals = {
        GroupsTableSelectedCount: new Rx.BehaviorSubject(0),
        ProtocolsTableSelectedCount: new Rx.BehaviorSubject(0),
        EditableSignal: new Rx.BehaviorSubject(0)
    };

    this.WikiHistoryLength = new Rx.BehaviorSubject(0);

    this.ProtocolToSelect = null;

    this.Init(Params);

    return this;
};

DpiDscpConfigViewController.prototype.Init = function (Params)
{

};

DpiDscpConfigViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select(_this.Id);
    });

    this.BindAll();
};

DpiDscpConfigViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.Table = $$(this.Id + "Table");

    this.Views.CodeEditor = $$(this.Id + "Editor" + "Code" + "Codetree");

    this.Views.EditorTabs = $$(this.Id + "Editor" + "Tabs");

    this.Views.ImportContextUploader = $$(this.Id+"ConfigImportContextForm" + "Uploader");

    this.Views.ImportContextCodeEditor = $$(this.Id+"ConfigImportContextForm" + "Text");

    this.Views.HistoryTable = $$(this.Id + "HistoryImportContext" + "HistoryTable");

    this.Views.HistoryEditor = $$(this.Id + "HistoryImportContext" + "Editor");
    this.Views.GroupsTable = $$(this.Id + "GroupsTable");
    this.Views.ShowAllProtocols = $$(this.Id + "ShowAllProtocols");
    this.Views.ProtocolsWrapper = $$(this.Id + "ProtocolsWrapper");
    this.Views.AddProtoBtn = $$(this.Id + "AddProtoBtn");
    this.Views.SetDscpForSelectedProtocolsBtn = $$(this.Id + "SetDscpForSelectedProtocolsBtn");
    this.Views.SetDscpForSelectedGroupsBtn = $$(this.Id + "SetDscpForSelectedGroupsBtn");
    this.Views.AddProtoContextFormProtocolInput = $$(this.Id + "AddProtoContextFormProtocolInput");
    this.Views.AddProtoContextForm = $$(this.Id + "AddProtoContextForm");
    this.Views.SetDscpForGroupsContextForm = $$(this.Id + "SetDscpForGroupsContextForm");
    this.Views.SetDscpForProtocolsContextForm = $$(this.Id + "SetDscpForProtocolsContextForm");
    this.Views.SaveBtn = $$(this.Id + "SaveBtn");
    this.Views.OptionsUpdateBtn = $$(this.Id + "OptionsUpdateBtn");
    this.Views.UploadBtn = $$(this.Id + "UploadBtn");
    this.Views.HistoryBtn = $$(this.Id + "HistoryBtn");
    this.Views.FormsWrapper = $$(this.Id + "FormsWrapper");

    webix.extend(this.Views.HistoryEditor, webix.ProgressBar);

    this.Views.ShowAllProtocols.blockEvent();
    this.Views.ShowAllProtocols.setValue(App.SessionManager.GetPreference(_this.Id + ":ShowAllProtocols"));
    this.Views.ShowAllProtocols.unblockEvent();

    this.Views.WiKi = $$(this.Id + "WiKi");
    this.Views.HistoryBackBtn = $$(this.Id + "WiKi"+"HistoryBackBtn");
    this.Views.HistoryForwardBtn = $$(this.Id + "WiKi"+"HistoryForwardBtn");
    this.Views.WiKi.attachEvent("onAfterLoad",function()
    {
        _this.WikiHistoryLength.next(_this.WikiHistoryLength.getValue()+1);
    });


    this.Subscriptions.ConfigUpdated = this.ViewModel.SignalDscpFileUpdated.subscribe(function (Value)
    {
        if (Value)
        {
            App.NavRouter.HideProgress();
            _this.DefineForms();
            _this.DefineGroupsTable();
        }
    });

    this.Subscriptions.ModelUpdated = this.ViewModel.SignalModelUpdated.subscribe(function(Value){
        if(Value)
        {
            _this.GroupsTableSelectionHandler();
            _this.UpdateDscpValueForSelectedGroups();
            _this.Views.CodeEditor.setValue(_this.ViewModel.GetConfig());
        }
    });

    this.Subscriptions.CurrentHardwareChanged = App.SessionManager.CurrentHardwareId.subscribe(function(HardwareId){

        if (HardwareId)
        {
            App.NavRouter.ShowProgress();
            _this.ViewModel.Refresh();
            _this.ViewModel.HistoryRefresh();
        }
    });

    this.Subscriptions.SignalsDicsAndConfigReady = Rx.Observable.combineLatest
    (
        this.ViewModel.SignalDscpFileUpdated,
        this.ViewModel.SignalConfigReady
    ).subscribe(function (Val)
    {
        if(Val[0] == 1 && Val[1] == 1)
            _this.Signals.EditableSignal.next(1);
        else
            _this.Signals.EditableSignal.next(0);
    });

    this.Subscriptions.EditableChange = this.Signals.EditableSignal.subscribe(function(Editable){
        var f = Editable ? "enable" : "disable";

        _this.Views.SaveBtn[f]();
        _this.Views.OptionsUpdateBtn[f]();
        _this.Views.UploadBtn[f]();
        _this.Views.HistoryBtn[f]();
        _this.Views.EditorTabs[f]();
        _this.Views.FormsWrapper[f]();
    });

    // this.Subscriptions.HardwareConnected = App.SessionManager.CurrentHardwareConnected.subscribe(function (CurrentHardwareConnected)
    // {
    //     if (CurrentHardwareConnected)
    //     {
    //         App.NavRouter.ShowProgress();
    //         _this.ViewModel.Refresh();
    //         _this.ViewModel.HistoryRefresh();
    //     }
    // });

    this.Views.ImportContextUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        var reader = new FileReader();

        reader.onload = function(e)
        {
            _this.Views.ImportContextCodeEditor.setValue(reader.result);
        };

        reader.readAsText(FileObj.file, "utf-8");

    });

    this.Subscriptions.ConfigHistoryUpdated = this.ViewModel.SignalConfigHistoryUpdated.subscribe(function (Value)
    {
        if (Value)
        {
            _this.DefineHistoryForms();
        }
    });

    this.Subscriptions.WikiHistoryLength = this.WikiHistoryLength.subscribe(function (Length)
    {
        if (Length > 1)
        {
            _this.Views.HistoryBackBtn.enable();
        }
        else
        {
            _this.Views.HistoryBackBtn.disable();
        }

        if (Length > 0)
        {
            _this.Views.HistoryForwardBtn.enable();
        }
        else
        {
            _this.Views.HistoryForwardBtn.disable();
        }
    });

    this.Subscriptions.SignalDicsReadySubscription = this.ViewModel.SignalDicsReady.subscribe(function(Updated){
        if(Updated)
        {
            var list = _this.ProtocolsSuggest.getList();
            list.clearAll();
            list.parse(Helper.DictToArr(HardwareDscpProtocolsDic));
            _this.DefineForms();
        }
    });

    this.Subscriptions.SignalDicProtocolsGroupsUpdatedSubscription = App.DicsManager.Signal[DicsEnum.ProtocolsGroupsDic].subscribe(function(Updated){
        if(Updated)
        {
            _this.DefineGroupsTable();
        }
    });

    this.Subscriptions.SignalGroupsTableSelectedCountSubscription = this.Signals.GroupsTableSelectedCount.subscribe(function(Count){
        _this.DefineProtocolsTable(Count);

        if(_this.Views.ShowAllProtocols.getValue())
        {
            _this.Views.AddProtoBtn.disable();
            _this.Views.Table.hideColumn("trash");
        }
        else{
            _this.Views.AddProtoBtn.enable();
            _this.Views.Table.showColumn("trash");
        }

        if(Count > 1)
        {
            _this.Views.SetDscpForSelectedGroupsBtn.enable();
        }
        else{
            _this.Views.SetDscpForSelectedGroupsBtn.disable();
        }
    });

    this.Subscriptions.SignalProtocolsTableSelectedCountSubscription = this.Signals.ProtocolsTableSelectedCount.subscribe(function(Count){
        if(Count > 1)
        {
            _this.Views.SetDscpForSelectedProtocolsBtn.enable();
        }
        else{
            _this.Views.SetDscpForSelectedProtocolsBtn.disable();
        }
    });

    this.Views.GroupsTable.attachEvent("onCheck", function(id, column, state)
    {
        if(column == "checked")
        {
            if(state)
                _this.Views.GroupsTable.select(id, true);
            else
                _this.Views.GroupsTable.unselect(id, true);

        }
    });

    this.Views.Table.attachEvent("onCheck", function(id, column, state)
    {
        if(column == "checked")
        {
            if(state)
                _this.Views.Table.select(id, true);
            else
                _this.Views.Table.unselect(id, true);

        }
    });

    window.onbeforeunload = function()
    {
        _this.WikiHistoryLength.next(0);
        return "You work will be lost.";
    };
};

DpiDscpConfigViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.ViewModel.Destroy();
    delete this.ViewModel;

    window.onbeforeunload = null;
};

DpiDscpConfigViewController.prototype.DefineForms = function ()
{
    var _this = this;

    this.Views.CodeEditor.setValue(this.ViewModel.GetConfig());

    _this.DefineProtocolsTable();
};

DpiDscpConfigViewController.prototype.DefineProtocolsTable = function(Count)
{
    var _this = this;
    this.Views.Table.clearAll();

    var protocols = [];
    var model = Helper.DictToArr(this.ViewModel.GetConfigModel());

    var showAll = _this.Views.ShowAllProtocols.getValue();

    var AddProtocols = function(Group)
    {
        var protos = Group ? model.filter(function(Val){return Val.group == Group.dic_id}) : model;

        protos.forEach(function(Proto){
            if(showAll || Proto.dscp)
            {
                protocols.push(Proto);
            }
        });
    };

    this.Views.GroupsTable.getSelectedItem()

    if(Count)
    {
        var groups = this.Views.GroupsTable.getSelectedItem();
        if(groups)
        {
            if(Array.isArray(groups))
            {
                groups.forEach(AddProtocols);
            }
            else{
                AddProtocols(groups);
            }
        }
    }
    else{
        AddProtocols(null);
    }

    if(protocols.length)
    {
        this.Views.Table.hideOverlay();
    }
    else{
        this.Views.Table.showOverlay(this.GetOverflowTemplateAddProto());
    }

    this.Views.Table.parse(protocols);

    // setTimeout(function(){
        if(_this.ProtocolToSelect)
        {
            _this.Views.Table.eachRow(function(Row){
                var item = this.getItem(Row);
                if(item && item.protocol == _this.ProtocolToSelect.protocol)
                {
                    _this.Views.Table.select(Row);
                    _this.Views.Table.showItem(Row);
                }
            });
            _this.ProtocolToSelect = null;
        }
    // }, 100);
};

DpiDscpConfigViewController.prototype.SetConfigModel = function ()
{
    var _this = this;

    var data = [],  datatable = this.Views.Table;

    datatable.eachRow(function(Id) {data.push(datatable.getItem(Id));}, true);

    var model = this.ViewModel.GetConfigModel();

    data.forEach(function (Obj)
    {
        model[Obj.protocol] = Obj;
    });

    this.ViewModel.SetConfigModel(model);
};

DpiDscpConfigViewController.prototype.ConfigSave = function (Params)
{
    var _this = this;

    if(_this.Views.EditorTabs.getValue() == _this.Id + "Editor" + "Code")
    {
        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
    }

    App.NavRouter.ShowProgress();

    this.SetConfigModel();

    this.ViewModel.Save({callback:function (R)
    {
        App.NavRouter.HideProgress();

        if(R.success)
        {
            webix.message(LangHelper.GetString(_this.Id,"Dscp configuration saved"));
            _this.OnSaveContext.show();
        }
        else
        {
            webix.message({type:"error", text:R.error.msg});
        }
    }});
};

DpiDscpConfigViewController.prototype.DefineHistoryForms = function (Params)
{
    this.Views.HistoryTable.clearAll();
    this.Views.HistoryTable.parse(this.ViewModel.GetHistory());
    this.Views.HistoryEditor.setValue("");
};

DpiDscpConfigViewController.prototype.DefineGroupsTable = function()
{
    var _this = this;
    var dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic);

    dic = dic.sort(function(a,b){
        return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
    });

    var model = Helper.DictToArr(_this.ViewModel.GetConfigModel());

    dic.forEach(function(Val){
        Val.dscp = null;
        var vals = model.filter(function(Obj){return Obj.group == Val.id});

        if(vals && vals.length > 0)
        {
            vals.forEach(function(Protocol){
                if(Val.dscp === null && Protocol.dscp)
                {
                    Val.dscp = Protocol.dscp;
                }
                else if(Val.dscp !== null && Val.dscp != Protocol.dscp)
                    Val.dscp = LangHelper.GetString(_this.Id, "mixed");
            });
        }
    });

    _this.Views.Table.getColumnConfig("group").header[1].options = dic;

    _this.Views.GroupsTable.clearAll();
    _this.Views.GroupsTable.parse(dic);
};

DpiDscpConfigViewController.prototype.GroupsTableSelectionHandler = function()
{
    var _this = this;

    var count = 0;

    _this.Views.GroupsTable.eachRow(function(Id) {
        var item = _this.Views.GroupsTable.getItem(Id);
        if(item.checked)
            count++;
    }, true);
    this.Signals.GroupsTableSelectedCount.next(count);
};

DpiDscpConfigViewController.prototype.ProtocolsTableSelectionHandler = function()
{
  var selected = this.Views.Table.getSelectedItem();

  this.Signals.ProtocolsTableSelectedCount.next(selected ? (Array.isArray(selected) ? selected.length : 1) : 0);
};

DpiDscpConfigViewController.prototype.GetOverflowTemplateAddProto = function ()
{
    var tpl = '<div class="of-empty-folder">' +
        ' <div class="of-empty-pad">' +
        '     <div class="of-empty-cloud-txt">'+LangHelper.GetString(this.Id, "Add protocol or show all protocols")+'</div>' +
        ' </div>' +
        '</div>';
    return tpl;
};

DpiDscpConfigViewController.prototype.AddProtocol = function()
{
  var _this = this;

  if(_this.Views.AddProtoContextForm.validate())
  {
      var values = _this.Views.AddProtoContextForm.getValues();
      var model = _this.ViewModel.GetConfigModel();

      if(!model[values.protocol])
      {
          model[values.protocol] = {};
      }
      model[values.protocol].dscp = values.dscp;

      _this.ViewModel.SetConfigModel(model, null, 1);

      var selectedGroup = this.Views.GroupsTable.getSelectedItem();
      var needToSelectGroup = false;
      if(selectedGroup)
      {
          if(Array.isArray(selectedGroup))
          {
              needToSelectGroup = true;
              selectedGroup.forEach(function(Group){
                  if(Group.dic_id == model[values.protocol].group)
                  {
                      needToSelectGroup = false;
                  }
              });
          }
          else{
              if(selectedGroup.dic_id != model[values.protocol].group)
              {
                  needToSelectGroup = true;
              }
          }
      }



      this.ProtocolToSelect = model[values.protocol]

      if(needToSelectGroup)
      {
          this.Views.GroupsTable.select(model[values.protocol].group);
      }
      else{
          this.GroupsTableSelectionHandler();
      }

      return true;
  }
  return false;
};

DpiDscpConfigViewController.prototype.ClearAddProtocolForm = function()
{
  var _this = this;

  this.Views.AddProtoContextForm.setValues({protocol: "", dscp: ""});
};

DpiDscpConfigViewController.prototype.SetDscpForGroup = function(Group, Dscp, DontSave)
{
    var _this = this;

    var model = this.ViewModel.GetConfigModel();

    Object.keys(model).forEach(function(Key){
        if(model[Key].group == Group.id)
        {
            model[Key].dscp = Dscp;
        }
    });

    if(!DontSave)
        this.ViewModel.SetConfigModel(model);
};

DpiDscpConfigViewController.prototype.SetDscpForGroups = function()
{
    var _this = this;

    var values = this.Views.SetDscpForGroupsContextForm.getValues();
    var model = this.ViewModel.GetConfigModel();
    var groups = this.Views.GroupsTable.getSelectedItem();

    var setDscp = function(Group)
    {
      var protos = Object.values(model).filter(function(Val){return Val.group == Group.dic_id});
      protos.forEach(function(Proto){
          model[Proto.protocol].dscp = values.dscp;
      });
    };

    if(groups)
    {
        if(Array.isArray(groups))
        {
            groups.forEach(function(Group){
                Group.dscp = values.dscp;
                _this.Views.GroupsTable.updateItem(Group.id, Group);
                setDscp(Group);
            });
        }
        else{
            setDscp(groups);
        }
    }

    this.ViewModel.SetConfigModel(model);

    return true;
};

DpiDscpConfigViewController.prototype.SetDscpForProtocols = function()
{
    var _this = this;

    var values = this.Views.SetDscpForProtocolsContextForm.getValues();
    var model = this.ViewModel.GetConfigModel();
    var protocols = this.Views.Table.getSelectedItem();

    protocols.forEach(function(Protocol){
        model[Protocol.protocol].dscp = values.dscp;
    });

    this.ViewModel.SetConfigModel(model);

    return true;
};

DpiDscpConfigViewController.prototype.DeleteDscpForProtocol = function(Data)
{
    var _this = this;

    var model = this.ViewModel.GetConfigModel();

    Data.forEach(function(Proto){
        model[Proto.protocol].dscp = "";
    });

    this.ViewModel.SetConfigModel(model);
};

DpiDscpConfigViewController.prototype.UpdateDscpValueForSelectedGroups = function()
{
  var _this = this;

    _this.Views.GroupsTable.eachRow(function(Id) {
        var item = _this.Views.GroupsTable.getItem(Id);
        _this.UpdateGroupsTableRow(item);
    }, true);
};

DpiDscpConfigViewController.prototype.UpdateGroupsTableRow = function(TableItem)
{
    var _this = this;

    var model = Helper.DictToArr(this.ViewModel.GetConfigModel());
    TableItem.dscp = null;
    var vals = model.filter(function(Obj){return Obj.group == TableItem.id});

    if(vals && vals.length > 0)
    {
        vals.forEach(function(Protocol){
            if(TableItem.dscp === null && Protocol.dscp)
            {
                TableItem.dscp = Protocol.dscp;
            }
            else if(TableItem.dscp !== null && TableItem.dscp != Protocol.dscp)
                TableItem.dscp = LangHelper.GetString(_this.Id, "mixed");
        });
    }

    _this.Views.GroupsTable.updateItem(TableItem.id, TableItem);
};

DpiDscpConfigViewController.prototype.OnProtocolChangedInsideTableHandler = function(DscpVal)
{
  var _this = this;

  var proto = this.Views.Table.getSelectedItem();

  if(proto && !Array.isArray(proto))
  {
      var model = this.ViewModel.GetConfigModel();
      model[proto.protocol].dscp = DscpVal;

      this.ViewModel.SetConfigModel(model, null, 1);

      var groupRow = this.Views.GroupsTable.getItem(proto.group);

      if(groupRow)
      {
          this.UpdateGroupsTableRow(groupRow);
      }
  }
};
function DpiAsnDscpConfigViewController(Params)
{

    var _this = this;

    this.Id = "DpiAsnDscpConfig";

    this.ViewModel = new HardwareAsnDscpConfigManager();

    this.OnSaveContext = webix.ui({
        view:"popup",
        modal: true,
        width:480,
        height:200,
        left: (window.innerWidth / 2 ) - 240,
        top: (window.innerHeight / 2) - 100,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id,"Asn dscp configuration saved") + "<br/>" +
                    "<span style='color: red'>" +
                    LangHelper.GetString("DpiConfig", "Update the hot parameters or restart Fast DPI for applying the changes!") +
                    "</span>"
                },
                {
                    cols:[
                        {
                            view: "button",
                            height: 40,
                            label: LangHelper.GetString("Dics", "Cancel"),
                            click: function()
                            {
                                _this.OnSaveContext.hide();
                            }
                        },
                        {
                            view:"button",
                            height: 40,
                            type:"form",
                            // label:LangHelper.GetString("Dics", "Restart"),
                            icon: "bolt",
                            label: LangHelper.GetString("Dics","Update"),
                            click:function ()
                            {
                                var node = this.getNode();
                                setTimeout(function ()
                                {
                                    _this.HardwareReloadContext.show(node, {pos: "bottom"});
                                }, 10);
                            }
                        },
                        {width: 8},
                        {
                            height: 40,
                            view:"button",
                            icon: "retweet",
                            type:"form",
                            label: LangHelper.GetString("Dics", "Restart"),
                            click:function ()
                            {
                                var node = this.getNode();
                                setTimeout(function ()
                                {
                                    _this.HardwareRestartContext.show(node, {pos: "top"});
                                }, 10);
                            }
                        }


                    ]
                }
            ]
        }
    });

    this.HardwareRestartContext = webix.ui({
        view:"popup",
        width:400,
        height:200,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("DpiConfig", "Are you sure you want to restart the DPI process?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Dics", "Restart"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                                App.SessionManager.RestartHardware();
                                _this.OnSaveContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HardwareReloadContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Dics", "Are you sure you want to update the hot settings?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Dics", "Refresh"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                                App.SessionManager.ReloadHardware();
                                _this.OnSaveContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.UpdateParamsContextId = this.Id + "UpdateParamsContext";
    this.UpdateParamsContext = webix.ui({
        view:"submenu",
        id:this.UpdateParamsContextId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.UpdateParamsContextId+"RestartDpi", icon: "retweet", value: LangHelper.GetString("DpiConfig", "Restart DPI")},
            {id: this.UpdateParamsContextId+"ReloadDpi", icon: "bolt", value: LangHelper.GetString(_this.Id,"Updating hot options")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                // var node = $$(_this.Id + "OptionsUpdateBtn").getNode();
                var node = _this.Views.OptionsUpdateBtn.getNode();
                if(id === _this.UpdateParamsContextId+"RestartDpi")
                {
                    setTimeout(function ()
                    {
                        _this.HardwareRestartContext.show(node, {pos: "bottom"});
                    }, 10);
                }
                else if(id === _this.UpdateParamsContextId+"ReloadDpi")
                {
                    _this.HardwareReloadContext.show(node, {pos: "bottom"});
                }
            }
        }
    });


    this.ConfigImportContext = webix.ui({
        view:"popup",
        width:1080,
        height:720,
        modal:true,
        body:{
            rows:[
                {
                    cols:[
                        {
                            gravity:1,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"List of AS and DSCP"), icon: "code"}),
                                {
                                    view:"form",
                                    id:this.Id+"ConfigImportContextAsnDscpForm",
                                    elements:[
                                        {
                                            view: "uploader",
                                            value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                                            id: this.Id+"ConfigImportContextAsnDscpForm" + "Uploader",
                                            css:"upload_area",
                                            autosend:false,
                                            height:64
                                        },
                                        {
                                            view:"codemirror-editor",
                                            id:this.Id+"ConfigImportContextAsnDscpForm" + "Text",
                                            value:""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            gravity:1,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"List of IPv4 and AS"), icon: "code"}),
                                {
                                    view:"form",
                                    id:this.Id+"ConfigImportContextAsnForm",
                                    elements:[
                                        {
                                            view: "uploader",
                                            value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                                            id: this.Id+"ConfigImportContextAsnForm" + "Uploader",
                                            css:"upload_area",
                                            autosend:false,
                                            height:64
                                        },
                                        {
                                            view:"codemirror-editor",
                                            id:this.Id+"ConfigImportContextAsnForm" + "Text",
                                            value:""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            gravity:2,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"List of IPv6 and AS"), icon: "code"}),
                                {
                                    view:"form",
                                    id:this.Id+"ConfigImportContextAsnV6Form",
                                    elements:[
                                        {
                                            view: "uploader",
                                            value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                                            id: this.Id+"ConfigImportContextAsnV6Form" + "Uploader",
                                            css:"upload_area",
                                            autosend:false,
                                            height:64
                                        },
                                        {
                                            view:"codemirror-editor",
                                            id:this.Id+"ConfigImportContextAsnV6Form" + "Text",
                                            value:""
                                        }
                                    ]
                                }
                            ]
                        },

                    ]
                },
                {
                    view:"form",
                    borderless:true,
                    elements:[
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString(_this.Id,"Cancel"),
                                    click:function ()
                                    {
                                        _this.ConfigImportContext.hide();
                                        _this.Views.ImportContextAsnCodeEditor.setValue("");
                                        _this.Views.ImportContextAsnV6CodeEditor.setValue("");
                                        _this.Views.ImportContextAsnDscpCodeEditor.setValue("");
                                    }
                                },
                                {
                                    view:"button",
                                    type:"form",
                                    label:LangHelper.GetString(_this.Id,"Apply"),
                                    click:function () {
                                        _this.ConfigImportContext.hide();

                                        if(_this.Views.ImportContextAsnCodeEditor.getValue())
                                        {
                                            _this.ViewModel.SetAsnConfig(_this.Views.ImportContextAsnCodeEditor.getValue());
                                        }

                                        if(_this.Views.ImportContextAsnV6CodeEditor.getValue())
                                        {
                                            _this.ViewModel.SetAsnV6Config(_this.Views.ImportContextAsnV6CodeEditor.getValue());
                                        }

                                        if(_this.Views.ImportContextAsnDscpCodeEditor.getValue())
                                        {
                                            _this.ViewModel.SetAsnDscpConfig(_this.Views.ImportContextAsnDscpCodeEditor.getValue());
                                        }

                                        _this.ViewModel.MakeAllModel();

                                        webix.message(LangHelper.GetString(_this.Id,"Applied"));

                                        _this.Views.ImportContextAsnCodeEditor.setValue("");
                                        _this.Views.ImportContextAsnDscpCodeEditor.setValue("");
                                        _this.Views.ImportContextAsnV6CodeEditor.setValue("");
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });

    this.HistoryImportContext = webix.ui({
        view:"popup",
        width:1024,
        height:720,
        id:this.Id+"HistoryImportContext",
        modal:true,
        body:{
            rows:[
                {
                    borderless:true,
                    cols:[
                        {
                            width:320,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"History"), icon: "history"}),
                                {
                                    view:"datatable",
                                    id:this.Id + "HistoryImportContext" + "HistoryTable",
                                    select: "row",
                                    columns: [
                                        {
                                            id: "date",
                                            header: [LangHelper.GetString(_this.Id,"Date"), {content: "dateRangeFilter"}],
                                            format: webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"),
                                            fillspace: true,
                                            sort: "date"
                                        },
                                        {
                                            id: "file_name",
                                            header: [LangHelper.GetString(this.Id,"File name"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                            fillspace: true,
                                            sort: "string"
                                        }
                                    ],
                                    on:{
                                        onAfterLoad:function(){
                                            this.sort("date", "desc", "date");
                                            this.markSorting("date", "desc");
                                        },
                                        onAfterSelect: function (data, preserve)
                                        {
                                            var rowData = this.getItem(data);

                                            var dscp = rowData.file_id.indexOf(".dscp") > 0;

                                            var v6 = rowData.file_id.indexOf("aslocal6") >= 0;
                                            if(dscp)
                                            {
                                                _this.Views.HistoryAsnDscpEditor.showProgress({type: "icon"});
                                            }
                                            else
                                            {
                                                if(v6)
                                                {
                                                    _this.Views.HistoryAsnEditorV6.showProgress({type: "icon"});
                                                }else{
                                                    _this.Views.HistoryAsnEditor.showProgress({type: "icon"});
                                                }
                                            }

                                            _this.ViewModel.LoadHistoryFile({configFile:rowData.file_id, callback:function (R)
                                            {
                                                if(dscp)
                                                {
                                                    _this.Views.HistoryAsnDscpEditor.hideProgress();
                                                }
                                                else
                                                {
                                                    if(v6)
                                                    {
                                                        _this.Views.HistoryAsnEditorV6.hideProgress();
                                                    }else{
                                                        _this.Views.HistoryAsnEditor.hideProgress();
                                                    }
                                                }

                                                if(R.success)
                                                {
                                                    if(dscp)
                                                    {
                                                        _this.Views.HistoryAsnDscpEditor.setValue(R.data);
                                                    }
                                                    else
                                                    {
                                                        if(v6)
                                                        {
                                                            _this.Views.HistoryAsnEditorV6.setValue(R.data);
                                                        }else{
                                                            _this.Views.HistoryAsnEditor.setValue(R.data);
                                                        }
                                                    }
                                                }
                                                else
                                                {
                                                    webix.message({type:"error",text:LangHelper.GetString(_this.Id,"Could not upload file")})
                                                }
                                            }});
                                        }
                                    },
                                    data:[]
                                }
                            ]
                        },
                        {view:"resizer"},
                        {
                            gravity: 1,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"List of AS and DSCP"), icon: "code"}),
                                {
                                    view:"codemirror-editor",
                                    id:this.Id + "HistoryImportContext" + "AsnDscpEditor",
                                    value:""
                                }
                            ]
                        },
                        {
                            gravity: 2,
                            rows:[
                                {
                                    rows:[
                                        BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"List of IPv4 and AS"), icon: "code"}),
                                        {
                                            view:"codemirror-editor",
                                            id:this.Id + "HistoryImportContext" + "AsnEditor",
                                            value:""
                                        }
                                    ]
                                },
                                {view:"resizer"},
                                {
                                    rows:[
                                        BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"List of IPv6 and AS"), icon: "code"}),
                                        {
                                            view:"codemirror-editor",
                                            id:this.Id + "HistoryImportContext" + "AsnEditorV6",
                                            value:""
                                        }
                                    ]
                                }
                            ]
                        }

                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.HistoryImportContext.hide();
                                _this.Views.HistoryAsnEditor.setValue("");
                                _this.Views.HistoryAsnEditorV6.setValue("");
                                _this.Views.HistoryAsnDscpEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Apply"),
                            click:function () {
                                _this.HistoryImportContext.hide();

                                if(_this.Views.HistoryAsnEditor.getValue())
                                {
                                    _this.ViewModel.SetAsnConfig(_this.Views.HistoryAsnEditor.getValue());
                                }

                                if(_this.Views.HistoryAsnDscpEditor.getValue())
                                {
                                    _this.ViewModel.SetAsnDscpConfig(_this.Views.HistoryAsnDscpEditor.getValue());
                                }

                                if(_this.Views.HistoryAsnEditorV6.getValue())
                                {
                                    _this.ViewModel.SetAsnV6Config(_this.Views.HistoryAsnEditorV6.getValue());
                                }

                                _this.ViewModel.MakeAllModel();

                                webix.message(LangHelper.GetString(_this.Id,"Applied"));

                                _this.Views.HistoryAsnEditor.setValue("");
                                _this.Views.HistoryAsnEditorV6.setValue("");
                                _this.Views.HistoryAsnDscpEditor.setValue("");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols: [
                DpiConfigLeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","DPI control"), title: LangHelper.GetString("AppView","Prioritization for autonomous systems (AS)")}),
                                {
                                    view:"accordion",
                                    multi:"mixed",
                                    on: {
                                        onAfterExpand: function(id) {
                                            _this.RefreshViews();
                                            return true;
                                        },
                                        onAfterCollapse: function(id)
                                        {
                                            _this.RefreshViews();
                                            return true;
                                        }
                                    },
                                    cols: [
                                        {
                                            header:LangHelper.GetString(this.Id,"Configuration of AS and DSCP priorities"),
                                            gravity:2,
                                            body:{
                                                rows: [
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.dpiui2.tabbarHeight,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "floppy-o",
                                                                id: this.Id + "SaveBtn",
                                                                label: LangHelper.GetString("All","Save"),
                                                                css: "toolbar_round_btn",
                                                                width: 128,
                                                                tooltip: LangHelper.GetString("All","Save"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.ConfigSave();
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "OptionsUpdateBtn",
                                                                type: "icon",
                                                                icon: "retweet",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("Dics", "Updating options"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.UpdateParamsContext.show(node, {pos: "bottom"});
                                                                    }, 1);
                                                                }
                                                            },
                                                            {
                                                                id: this.Id + "UploadBtn",
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "upload",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("All","Upload from file"),
                                                                click: function (id, e, node) {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.ConfigImportContext.show(node, {pos: "bottom"});
                                                                        _this.Views.ImportContextAsnCodeEditor.setValue("");
                                                                        _this.Views.ImportContextAsnDscpCodeEditor.setValue("");
                                                                    }, 10);
                                                                }
                                                            },
                                                            {
                                                                id: this.Id + "HistoryBtn",
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "history",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("All","Download from history"),
                                                                click: function (id, e, node) {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.HistoryImportContext.show(node, {pos: "bottom"});
                                                                        _this.DefineHistoryForms();
                                                                    }, 10);
                                                                }
                                                            },
                                                            {},
                                                            {
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    App.NavRouter.ShowProgress();
                                                                    _this.ViewModel.Refresh();
                                                                    _this.ViewModel.HistoryRefresh();
                                                                }
                                                            },
                                                            {
                                                                view:"tabbar",
                                                                id:this.Id + "Editor" + "Tabs",
                                                                tabMoreWidth:0,
                                                                value:this.Id + "Editor",
                                                                multiview:true,
                                                                options: [
                                                                    {
                                                                        id: this.Id + "Editor",
                                                                        "value": "<span class='webix_icon fa-trello'></span> "+LangHelper.GetString("All","The form")
                                                                    },
                                                                    {
                                                                        id: this.Id + "Editor" + "Code",
                                                                        "value": "<span class='webix_icon fa-code'></span> "+LangHelper.GetString("All","Editor")
                                                                    }
                                                                ],
                                                                on:{
                                                                    "onAfterTabClick":function(Id)
                                                                    {
                                                                        if(Id == _this.Id + "Editor" + "Code")
                                                                        {
                                                                            setTimeout(function ()
                                                                            {
                                                                                _this.SetConfigModel();
                                                                                _this.Views.AsnCodeEditor.setValue(_this.ViewModel.GetAsnConfig());
                                                                                _this.Views.AsnV6CodeEditor.setValue(_this.ViewModel.GetAsnV6Config());
                                                                                _this.Views.AsnDscpCodeEditor.setValue(_this.ViewModel.GetAsnDscpConfig());
                                                                            },1);
                                                                        }else{
                                                                            setTimeout(function ()
                                                                            {
                                                                                _this.ViewModel.SetAsnConfig(_this.Views.AsnCodeEditor.getValue());
                                                                                _this.ViewModel.SetAsnV6Config(_this.Views.AsnV6CodeEditor.getValue());
                                                                                _this.ViewModel.SetAsnDscpConfig(_this.Views.AsnDscpCodeEditor.getValue());
                                                                                _this.ViewModel.MakeAllModel();
                                                                            },1);
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        id: this.Id + "FormsWrapper",
                                                        rows:[
                                                            {
                                                                cells:[
                                                                    {
                                                                        id: this.Id + "Editor",
                                                                        cols: [
                                                                            {
                                                                                rows:[
                                                                                    {
                                                                                        view: "toolbar",
                                                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.dpiui2.tabbarHeight,
                                                                                        elements: [
                                                                                            {
                                                                                                view: "button",
                                                                                                type: "icon",
                                                                                                icon: "plus",
                                                                                                css:"toolbar_round_btn",
                                                                                                width:32,
                                                                                                tooltip:LangHelper.GetString(_this.Id,"Add AS"),
                                                                                                click:function ()
                                                                                                {
                                                                                                    _this.Views.AsTable.add(new AllAsnDscpModel());
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    BlockHeaderTemplate({title: LangHelper.GetString(this.Id,"AS resource list"), icon: "list-ol"}),
                                                                                    {
                                                                                        view: "datatable",
                                                                                        id:this.Id + "AsTable",
                                                                                        editable: true,
                                                                                        select: "row",
                                                                                        editaction: "custom",
                                                                                        on: {
                                                                                            onItemClick: function (id)
                                                                                            {
                                                                                                if (id.column === 'edit')
                                                                                                {
                                                                                                    this.editRow(id);
                                                                                                }
                                                                                                else if(id.column === 'trash')
                                                                                                {
                                                                                                    this.remove(id);
                                                                                                }
                                                                                            },
                                                                                            onItemDblClick: function (id)
                                                                                            {
                                                                                                this.editRow(id);
                                                                                            },
                                                                                            onAfterSelect:function(data, preserve)
                                                                                            {
                                                                                                _this.OnAsTableRowSelect();
                                                                                            },
                                                                                            onAfterUnSelect:function(data)
                                                                                            {
                                                                                                _this.OnAsTableRowUnSelect();
                                                                                            },
                                                                                            onAfterEditStop:function (state, editor, ignoreUpdate) {
                                                                                                if (editor.column == "asn" && state.value != state.old)
                                                                                                {
                                                                                                    let id = this.getSelectedId();
                                                                                                    let item = this.getSelectedItem();
                                                                                                    item["asn_name"] = "";
                                                                                                    this.updateItem(id.row, item);
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        columns: [
                                                                                            {
                                                                                                id: "edit",
                                                                                                header: "",
                                                                                                width: 32,
                                                                                                template: "<span class=\"webix_icon fa-pencil-square\"></span>",
                                                                                                headermenu: false
                                                                                            },
                                                                                            {
                                                                                                id: "asn",
                                                                                                header: [LangHelper.GetString(this.Id,"AS number"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                                                editor:"text",
                                                                                                fillspace: true,
                                                                                                template: function (obj) {
                                                                                                    let result = obj.asn;

                                                                                                    if (obj.asn_name != "")
                                                                                                        result += ` (${obj.asn_name})`;

                                                                                                    return result;
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                id: "trash",
                                                                                                header: "",
                                                                                                width: 40,
                                                                                                template: CellTrashBtnTemplate,
                                                                                                headermenu: false
                                                                                            }
                                                                                        ],
                                                                                        data:[],
                                                                                        rules:{
                                                                                            "asn":function(Val)
                                                                                            {
                                                                                                return !isNaN(Val*1);
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {view:"resizer"},
                                                                            {
                                                                                rows:[
                                                                                    {
                                                                                        view: "toolbar",
                                                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.dpiui2.tabbarHeight,
                                                                                        elements: [
                                                                                            {
                                                                                                view: "button",
                                                                                                id:this.Id + "IpTableAddBtn",
                                                                                                type: "icon",
                                                                                                icon: "plus",
                                                                                                css:"toolbar_round_btn",
                                                                                                width:32,
                                                                                                tooltip:LangHelper.GetString(_this.Id,"Add CIDR"),
                                                                                                click:function ()
                                                                                                {
                                                                                                    _this.AddNewAsnTableRow();
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    BlockHeaderTemplate({title: LangHelper.GetString(this.Id,"CIDR list for AS"), icon: "list-ol"}),
                                                                                    {
                                                                                        view: "datatable",
                                                                                        id:this.Id + "IpTable",
                                                                                        editable: true,
                                                                                        select: "row",
                                                                                        editaction: "custom",
                                                                                        on: {
                                                                                            onItemClick: function (id)
                                                                                            {
                                                                                                if (id.column === 'edit')
                                                                                                {
                                                                                                    this.editRow(id);
                                                                                                }
                                                                                                else if(id.column === 'trash')
                                                                                                {
                                                                                                    _this.DeleteAsnTableRow(id);
                                                                                                }
                                                                                            },
                                                                                            onItemDblClick: function (id)
                                                                                            {
                                                                                                this.editRow(id);
                                                                                            }
                                                                                        },
                                                                                        columns: [
                                                                                            {
                                                                                                id: "edit",
                                                                                                header: "",
                                                                                                width: 32,
                                                                                                template: "<span class=\"webix_icon fa-pencil-square\"></span>",
                                                                                                headermenu: false
                                                                                            },
                                                                                            {
                                                                                                id: "ip",
                                                                                                header: [
                                                                                                    "CIDR",
                                                                                                    {
                                                                                                        content: "textFilter",
                                                                                                        placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                                                                                                    }
                                                                                                ],
                                                                                                editor:"text",
                                                                                                fillspace: true
                                                                                            },
                                                                                            {
                                                                                                id: "trash",
                                                                                                header: "",
                                                                                                width: 40,
                                                                                                template: CellTrashBtnTemplate,
                                                                                                headermenu: false
                                                                                            }
                                                                                        ],
                                                                                        data:[],
                                                                                        rules:{
                                                                                            "ip":function(Val)
                                                                                            {
                                                                                                return Helper.ValidateCidrIPv4OrIPv6(Val);
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                rows:[
                                                                                    {
                                                                                        view: "toolbar",
                                                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.dpiui2.tabbarHeight,
                                                                                        elements: [
                                                                                            {
                                                                                                view: "button",
                                                                                                id:this.Id + "DscpTableAddBtn",
                                                                                                type: "icon",
                                                                                                icon: "plus",
                                                                                                css:"toolbar_round_btn",
                                                                                                width:32,
                                                                                                tooltip:LangHelper.GetString(_this.Id,"Add DSCP"),
                                                                                                click:function ()
                                                                                                {
                                                                                                    _this.AddNewAsnDscpTableRow();
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"DSCP list for AS"), icon: "sort-alpha-asc"}),
                                                                                    {
                                                                                        view: "datatable",
                                                                                        id:this.Id + "DscpTable",
                                                                                        editable: true,
                                                                                        select: "row",
                                                                                        editaction: "custom",
                                                                                        on: {
                                                                                            onItemClick: function (id)
                                                                                            {
                                                                                                if (id.column === 'edit')
                                                                                                {
                                                                                                    this.editRow(id);
                                                                                                }
                                                                                                else if(id.column === 'trash')
                                                                                                {
                                                                                                    _this.DeleteAsnDscpTableRow(id);
                                                                                                }
                                                                                            },
                                                                                            onItemDblClick: function (id)
                                                                                            {
                                                                                                this.editRow(id);
                                                                                            }
                                                                                        },
                                                                                        columns: [
                                                                                            {
                                                                                                id: "edit",
                                                                                                header: "",
                                                                                                width: 32,
                                                                                                template: "<span class=\"webix_icon fa-pencil-square\"></span>",
                                                                                                headermenu: false
                                                                                            },
                                                                                            {
                                                                                                id: "dscp",
                                                                                                header: ["DSCP",{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                                                editor:"combo",
                                                                                                fillspace: true,
                                                                                                suggest:{
                                                                                                    view:"gridsuggest",
                                                                                                    body:{
                                                                                                        autoheight:false,
                                                                                                        scroll:true,
                                                                                                        maxHeight:400,
                                                                                                        width:720,
                                                                                                        borderless:true,
                                                                                                        columns:[
                                                                                                            { id:"value", header:LangHelper.GetString(_this.Id,"DSCP name") },
                                                                                                            { id:"binary", header:LangHelper.GetString(_this.Id,"Binary value") },
                                                                                                            { id:"decimal", header:LangHelper.GetString(_this.Id,"Decimal value") },
                                                                                                            { id:"priority", header:LangHelper.GetString(_this.Id,"Priority") },
                                                                                                            { id:"class", header:LangHelper.GetString(_this.Id,"Policing class") },
                                                                                                            { id:"class_order_1", header:"class_order=1" }
                                                                                                        ],
                                                                                                        data:Helper.DictToArr(AsnDscpDic)
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                id: "trash",
                                                                                                header: "",
                                                                                                width: 40,
                                                                                                template: CellTrashBtnTemplate,
                                                                                                headermenu: false
                                                                                            }
                                                                                        ],
                                                                                        data:[]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        id:this.Id + "Editor" + "Code",
                                                                        rows:[
                                                                            {
                                                                                cols:[
                                                                                    {
                                                                                        gravity:1,
                                                                                        rows:[
                                                                                            BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"List of AS and DSCP"), icon: "sort-alpha-asc"}),
                                                                                            {
                                                                                                view:"codemirror-editor",
                                                                                                id:this.Id + "Editor" + "Code" + "AsnDscpLst",
                                                                                                value:""
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {view: "resizer"},
                                                                                    {
                                                                                        gravity:1,
                                                                                        rows:[
                                                                                            BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"List of IPv4 and AS"), icon: "list-ol"}),
                                                                                            {
                                                                                                view:"codemirror-editor",
                                                                                                id:this.Id + "Editor" + "Code" + "AsnLst",
                                                                                                value:""
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {view: "resizer"},
                                                                                    {
                                                                                        gravity:2,
                                                                                        rows:[
                                                                                            BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"List of IPv6 and AS"), icon: "list-ol"}),
                                                                                            {
                                                                                                view:"codemirror-editor",
                                                                                                id:this.Id + "Editor" + "Code" + "AsnLstV6",
                                                                                                value:""
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    // {view: "resizer"},

                                                                                ]
                                                                            },
                                                                            // {
                                                                            //     view:"toolbar",
                                                                            //     borderless:true,
                                                                            //     height: 24,
                                                                            //     elements:[
                                                                            //         {
                                                                            //             gravity:2
                                                                            //         },
                                                                            //         {
                                                                            //             view:"button",
                                                                            //             label:LangHelper.GetString(_this.Id,"Apply"),
                                                                            //             click:function ()
                                                                            //             {
                                                                            //                 _this.ViewModel.SetAsnConfig(_this.Views.AsnCodeEditor.getValue());
                                                                            //                 _this.ViewModel.SetAsnV6Config(_this.Views.AsnV6CodeEditor.getValue());
                                                                            //                 _this.ViewModel.SetAsnDscpConfig(_this.Views.AsnDscpCodeEditor.getValue());
                                                                            //                 _this.ViewModel.MakeAllModel();
                                                                            //                 webix.message(LangHelper.GetString(_this.Id,"Applied"));
                                                                            //             }
                                                                            //         }
                                                                            //     ]
                                                                            // }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            header:"WiKi",
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id:this.Id + "WiKi"+"HistoryBackBtn",
                                                                type: "icon",
                                                                icon: "arrow-left",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString(_this.Id,"Back"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var histLength = _this.WikiHistoryLength.getValue();

                                                                    if(histLength > 1)
                                                                    {
                                                                        _this.WikiHistoryLength.next(histLength - 2);
                                                                        window.history.back();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "WiKi"+"HistoryForwardBtn",
                                                                type: "icon",
                                                                icon: "arrow-right",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString(_this.Id,"Forward"),
                                                                click: function (id, e, node)
                                                                {
                                                                    window.history.forward();
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        view:"iframe",
                                                        id:this.Id + "WiKi",
                                                        src:LangHelper.GetString("Dics","https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_priority:priority_config_as:start")
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Views = {
        AsTable:null,
        IpTable:null,
        DscpTable:null,
        AsnCodeEditor:null,
        AsnV6CodeEditor:null,
        DscpAsnCodeEditor:null,

        IpTableAddBtn:null,
        DscpTableAddBtn:null,

        ImportContextAsnUploader:null,
        ImportContextAsnCodeEditor:null,

        ImportContextAsnDscpUploader:null,
        ImportContextAsnDscpCodeEditor:null,

        HistoryTable:null,
        HistoryAsnEditor:null,
        HistoryAsnEditorV6:null,
        HistoryAsnDscpEditor:null,

        SaveBtn: null,
        OptionsUpdateBtn : null,
        UploadBtn: null,
        HistoryBtn: null,
        FormsWrapper: null,
        EditorTabs: null

    };

    this.Subscriptions = {};

    this.WikiHistoryLength = new Rx.BehaviorSubject(0);

    this.AsTabelRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.EditableSignal = new Rx.BehaviorSubject(0);

    this.Init(Params);

    return this;
};

DpiAsnDscpConfigViewController.prototype.Init = function (Params)
{

};

DpiAsnDscpConfigViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select(_this.Id);
    });


    this.BindAll();
};

DpiAsnDscpConfigViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.AsTable = $$(this.Id + "AsTable");
    this.Views.IpTable = $$(this.Id + "IpTable");
    this.Views.DscpTable = $$(this.Id + "DscpTable");
    this.Views.EditorTabs = $$(this.Id + "Editor" + "Tabs");

    this.Views.IpTableAddBtn = $$(this.Id + "IpTableAddBtn");
    this.Views.DscpTableAddBtn = $$(this.Id + "DscpTableAddBtn");

    this.Views.AsnCodeEditor = $$(this.Id + "Editor" + "Code" + "AsnLst");
    this.Views.AsnV6CodeEditor = $$(this.Id + "Editor" + "Code" + "AsnLstV6");
    this.Views.AsnDscpCodeEditor = $$(this.Id + "Editor" + "Code" + "AsnDscpLst");

    this.Views.ImportContextAsnUploader = $$(this.Id+"ConfigImportContextAsnForm" + "Uploader");
    this.Views.ImportContextAsnCodeEditor = $$(this.Id+"ConfigImportContextAsnForm" + "Text");
    this.Views.ImportContextAsnUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        var reader = new FileReader();

        reader.onload = function(e)
        {
            _this.Views.ImportContextAsnCodeEditor.setValue(reader.result);
        }

        reader.readAsText(FileObj.file, "utf-8");

    });

    this.Views.ImportContextAsnV6Uploader = $$(this.Id+"ConfigImportContextAsnV6Form" + "Uploader");
    this.Views.ImportContextAsnV6CodeEditor = $$(this.Id+"ConfigImportContextAsnV6Form" + "Text");
    this.Views.ImportContextAsnV6Uploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        var reader = new FileReader();

        reader.onload = function(e)
        {
            _this.Views.ImportContextAsnV6CodeEditor.setValue(reader.result);
        }

        reader.readAsText(FileObj.file, "utf-8");

    });

    this.Views.ImportContextAsnDscpUploader = $$(this.Id+"ConfigImportContextAsnDscpForm" + "Uploader");
    this.Views.ImportContextAsnDscpCodeEditor = $$(this.Id+"ConfigImportContextAsnDscpForm" + "Text");
    this.Views.ImportContextAsnDscpUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        var reader = new FileReader();

        reader.onload = function(e)
        {
            _this.Views.ImportContextAsnDscpCodeEditor.setValue(reader.result);
        }

        reader.readAsText(FileObj.file, "utf-8");

    });

    this.Views.HistoryTable = $$(this.Id + "HistoryImportContext" + "HistoryTable");

    this.Views.HistoryAsnEditor = $$(this.Id + "HistoryImportContext" + "AsnEditor");
    webix.extend(this.Views.HistoryAsnEditor, webix.ProgressBar);

    this.Views.HistoryAsnEditorV6 = $$(this.Id + "HistoryImportContext" + "AsnEditorV6");
    webix.extend(this.Views.HistoryAsnEditorV6, webix.ProgressBar);

    this.Views.HistoryAsnDscpEditor = $$(this.Id + "HistoryImportContext" + "AsnDscpEditor");
    webix.extend(this.Views.HistoryAsnDscpEditor, webix.ProgressBar);


    this.Views.WiKi = $$(this.Id + "WiKi");
    this.Views.HistoryBackBtn = $$(this.Id + "WiKi"+"HistoryBackBtn");
    this.Views.HistoryForwardBtn = $$(this.Id + "WiKi"+"HistoryForwardBtn");

    this.Views.SaveBtn = $$(this.Id + "SaveBtn");
    this.Views.OptionsUpdateBtn = $$(this.Id + "OptionsUpdateBtn");
    this.Views.UploadBtn = $$(this.Id + "UploadBtn");
    this.Views.HistoryBtn = $$(this.Id + "HistoryBtn");
    this.Views.FormsWrapper = $$(this.Id + "FormsWrapper");
    this.Views.EditorTabs = $$(this.Id + "EditorTabs");

    this.Views.WiKi.attachEvent("onAfterLoad",function()
    {
        _this.WikiHistoryLength.next(_this.WikiHistoryLength.getValue()+1);
    });

    this.Subscriptions.AsTabelRowsSelectedCount = this.AsTabelRowsSelectedCount.subscribe(function (V) {
        if(V)
        {
            _this.Views.IpTableAddBtn.enable();
            _this.Views.DscpTableAddBtn.enable();
        }
        else
        {
            _this.Views.IpTableAddBtn.disable();
            _this.Views.DscpTableAddBtn.disable();
        }
    });

    this.Subscriptions.ConfigUpdated = this.ViewModel.SignalAllUpdated.subscribe(function (Value)
    {
        if (Value)
        {
            App.NavRouter.HideProgress();

            _this.DefineForms();
        }
    });

    this.Subscriptions.ConfigHistoryUpdated = this.ViewModel.SignalConfigHistoryUpdated.subscribe(function (Value)
    {
        if (Value)
        {
            _this.DefineHistoryForms();
        }
    });

    this.Subscriptions.CurrentHardwareChanged = App.SessionManager.CurrentHardwareId.subscribe(function(HardwareId){

        if (HardwareId)
        {
            App.NavRouter.ShowProgress();
            _this.ViewModel.Refresh();
            _this.ViewModel.HistoryRefresh();
        }
    });

    // this.Subscriptions.HardwareConnected = App.SessionManager.CurrentHardwareConnected.subscribe(function (CurrentHardwareConnected)
    // {
    //     if (CurrentHardwareConnected)
    //     {
    //         App.NavRouter.ShowProgress();
    //         _this.ViewModel.Refresh();
    //         _this.ViewModel.HistoryRefresh();
    //     }
    // });

    this.Subscriptions.WikiHistoryLength = this.WikiHistoryLength.subscribe(function (Length)
    {
        if (Length > 1)
        {
            _this.Views.HistoryBackBtn.enable();
        }
        else
        {
            _this.Views.HistoryBackBtn.disable();
        }

        if (Length > 0)
        {
            _this.Views.HistoryForwardBtn.enable();
        }
        else
        {
            _this.Views.HistoryForwardBtn.disable();
        }
    });

    this.Subscriptions.SignalsDicsAndConfigReady = Rx.Observable.combineLatest
    (
        this.ViewModel.SignalAllUpdated,
        this.ViewModel.SignalConfigReady
    ).subscribe(function (Val)
    {
        if(Val[0] == 1 && Val[1] == 1)
            _this.EditableSignal.next(1);
        else
            _this.EditableSignal.next(0);
    });

    this.Subscriptions.EditableChange = this.EditableSignal.subscribe(function(Editable){
        var f = Editable ? "enable" : "disable";

        _this.Views.SaveBtn[f]();
        _this.Views.OptionsUpdateBtn[f]();
        _this.Views.UploadBtn[f]();
        _this.Views.HistoryBtn[f]();
        _this.Views.EditorTabs[f]();
        _this.Views.FormsWrapper[f]();
    });

    window.onbeforeunload = function()
    {
        _this.WikiHistoryLength.next(0);
        return "You work will be lost.";
    };
};

DpiAsnDscpConfigViewController.prototype.DefineForms = function ()
{
    var _this = this;

    this.Views.AsnCodeEditor.setValue(this.ViewModel.GetAsnConfig());
    this.Views.AsnV6CodeEditor.setValue(this.ViewModel.GetAsnV6Config());
    this.Views.AsnDscpCodeEditor.setValue(this.ViewModel.GetAsnDscpConfig());

    this.Views.AsTable.clearAll();
    this.Views.AsTable.parse(Helper.DictToArr(this.ViewModel.GetAllModel()));

    // this.Views.IpTable.clearAll();
    // this.Views.IpTable.parse(Helper.DictToArr(this.ViewModel.GetAsnConfigModel()));
    //
    // this.Views.DscpTable.clearAll();
    // this.Views.DscpTable.parse(Helper.DictToArr(this.ViewModel.GetAsnDscpConfigModel()));
};

DpiAsnDscpConfigViewController.prototype.GetAsTableSelectedData = function ()
{
    return this.Views.AsTable.getSelectedItem();
};

DpiAsnDscpConfigViewController.prototype.OnAsTableRowSelect = function ()
{
    var data = this.GetAsTableSelectedData();

    this.AsTabelRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);

    this.Views.IpTable.clearAll();
    this.Views.IpTable.parse(data.ips_obj.list);

    this.Views.DscpTable.clearAll();
    this.Views.DscpTable.parse(data.dscps_obj.list);
};

DpiAsnDscpConfigViewController.prototype.OnAsTableRowUnSelect = function ()
{
    var data = this.GetAsTableSelectedData();

    this.AsTabelRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);

    this.Views.IpTable.clearAll();
    this.Views.IpTable.parse([]);

    this.Views.DscpTable.clearAll();
    this.Views.DscpTable.parse([]);
};

DpiAsnDscpConfigViewController.prototype.DefineHistoryForms = function ()
{
    var _this = this;

    this.Views.HistoryTable.clearAll();
    this.Views.HistoryTable.parse(this.ViewModel.GetHistory());
    this.Views.HistoryAsnEditor.setValue("");
    this.Views.HistoryAsnEditorV6.setValue("");
    this.Views.HistoryAsnDscpEditor.setValue("");
};

DpiAsnDscpConfigViewController.prototype.SetConfigModel = function ()
{
    var _this = this;

    var data = [],  datatable = this.Views.AsTable;

    datatable.eachRow(function(Id) {data.push(datatable.getItem(Id));}, true);

    var asnModel = [];
    var asnDscpModel = [];

    data.forEach(function (Obj)
    {
        Obj.ips_obj.list.forEach(function (IpObj)
        {
            asnModel.push({asn:Obj.asn, ip:IpObj.ip});
        });

        Obj.dscps_obj.list.forEach(function (DscpObj)
        {
            asnDscpModel.push({asn:Obj.asn, dscp:DscpObj.dscp});
        });
    });

    this.ViewModel.SetAsnConfigModel(asnModel);
    this.ViewModel.SetAsnDscpConfigModel(asnDscpModel);
};

DpiAsnDscpConfigViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.ViewModel.Destroy();
    delete this.ViewModel;

    window.onbeforeunload = null;
};

DpiAsnDscpConfigViewController.prototype.AddNewAsnTableRow = function ()
{
    var newModel = new AsnModel();

    var data = this.GetAsTableSelectedData();
    data.ips_obj.list.push(newModel);

    this.Views.IpTable.add(newModel);
};

DpiAsnDscpConfigViewController.prototype.DeleteAsnTableRow = function (RowId)
{
    var index = -1;

    var data = this.GetAsTableSelectedData();

    data.ips_obj.list.every(function (Obj, Index)
    {
        if(Obj.id == RowId)
        {
            index = Index;
            return false;
        }
        return true;
    });

    if(index >= 0)
    {
        data.ips_obj.list.splice(index, 1);
        this.Views.IpTable.remove(RowId);
    }
};

DpiAsnDscpConfigViewController.prototype.AddNewAsnDscpTableRow = function ()
{
    var newModel = new AsnDscpModel();

    var data = this.GetAsTableSelectedData();
    data.dscps_obj.list.push(newModel);

    this.Views.DscpTable.add(newModel);
};

DpiAsnDscpConfigViewController.prototype.DeleteAsnDscpTableRow = function (RowId)
{
    var index = -1;

    var data = this.GetAsTableSelectedData();

    data.dscps_obj.list.every(function (Obj, Index)
    {
        if(Obj.id == RowId)
        {
            index = Index;
            return false;
        }
        return true;
    });

    if(index >= 0)
    {
        data.dscps_obj.list.splice(index, 1);
        this.Views.DscpTable.remove(RowId);
    }
};

DpiAsnDscpConfigViewController.prototype.ConfigSave = function (Params)
{
    var _this = this;

    App.NavRouter.ShowProgress();

    if(_this.Views.EditorTabs.getValue() == _this.Id + "Editor" + "Code")
    {
        _this.ViewModel.SetAsnConfig(_this.Views.AsnCodeEditor.getValue());
        _this.ViewModel.SetAsnV6Config(_this.Views.AsnV6CodeEditor.getValue());
        _this.ViewModel.SetAsnDscpConfig(_this.Views.AsnDscpCodeEditor.getValue());
        _this.ViewModel.MakeAllModel();
    }else{
        _this.SetConfigModel();
    }

    this.ViewModel.Save({callback:function (R)
    {
        App.NavRouter.HideProgress();

        if(R.success)
        {
            var errors = [];
            if(R.data && R.data.asn && !R.data.asn.success)
            {
                errors.push(R.data.asn.error.msg);
                // webix.message({type:"error", text:R.data.asn.error.msg});
            }

            if(R.data && R.data.asn_dscp && !R.data.asn_dscp.success)
            {
                errors.push(R.data.asn_dscp.error.msg);
                // webix.message({type:"error", text:R.data.asn_dscp.error.msg});
            }

            if(R.data && R.data.asnv6)
            {
                if(!R.data.asnv6.success)
                    errors.push(R.data.asnv6.error.msg);
                else if(R.data.asnv6.data && R.data.asnv6.data.convert_error){
                    if(typeof R.data.asnv6.data.convert_error == "string")
                    {
                        webix.message({type:"error", text:R.data.asnv6.data.convert_error});
                    }else if (typeof R.data.asnv6.data.convert_error == "object"){
                        if(R.data.asnv6.data.convert_error.msg)
                        {
                            webix.message({type:"error", text: R.data.asnv6.data.convert_error.msg});
                        }
                    }

                }
                // webix.message({type:"error", text:R.data.asn_dscp.error.msg});
            }

            if(errors.length > 0)
            {
                errors.forEach(function(error){
                    webix.message({type:"error", text:error});
                });
            }
            else
            {
                webix.message(LangHelper.GetString(_this.Id,"Asn dscp configuration saved"));
                _this.OnSaveContext.show();
            }
        }
        else
        {
            webix.message({type:"error", text:R.error.msg});
        }
    }});
};

DpiAsnDscpConfigViewController.prototype.RefreshViews = function (Params)
{
    var _this = this;

    Helper.RefreshView(this.Views.AsTable);
    Helper.RefreshView(this.Views.IpTable);
    Helper.RefreshView(this.Views.DscpTable);

};
/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */
function DpiPerformanceViewController(Params)
{
    "use strict";

    var _this = this;

    this.IdsEnum =
    {
        DpiPerformance:"DpiPerformance",
        UlrIgwNodePerformance:"UlrIgwNodePerformance"
    };

    this.Id = Params&&Params.Id ? Params.Id : this.IdsEnum .DpiPerformance;

    this.PageTitle = Params&&Params.PageTitle?Params.PageTitle:{
        RootTitle: LangHelper.GetString("AppView", "DPI control"),
        Title: LangHelper.GetString("AppView", "Performance")
    };

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new HardwarePerformanceManager();

    this.NatTabEnabled = this.Id === this.IdsEnum.DpiPerformance;

    if(this.NatTabEnabled)
        this.NatStatusView = new CgNatStatusViewController({isQoE: true});

    if(this.mode == "li")
        this.Health = new LiHealthManager();

    this.Views = {
        CpuUsGage:null,
        CpuFastdpiGage:null,
        MemFastDpiGage:null,
        CpuSyGage:null,
        CpuIdGage:null,
        CpuMemGage:null,
        CpuSwapGage:null,
        CpusChart:null,
        CpusCoresChart:null,
        CpusCoresFastdpiChart:null,
        CpusCoresBarChart:null,
        MemChart:null,
        TopProcesses:null,

        PeriodType:null,
        CpusStatChart:null,
        CpusCoresStatChart:null,
        MemStatChart:null,
        DnaStatCharts:{},
        DnaStatChartsLegends:{},
        HttpStatChart:{},

        StatsAccordion:null,
        StatsAccordionDnasItems:{},
        NatFullPoolUsage: null,
        NatPoolUsage: null,
        NatAddressPerformanceTable: null,
        NatAddressPerformanceTablePaging: null,
        NatAddressPerformanceTablePagingSize: null,
        StatsDevicesTable: null,
        ReportsWidgets:{}
    };

    this.Views.Widgets = {
        DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"})
    };

    if(_this.Id === _this.IdsEnum.UlrIgwNodePerformance)
    {
        this.ReportsModel = new UniReportsManager();
        this.Views.ReportsWidgets.IgwsNodesSelectReport = UrlIgwsNodesListSelectWidget({
            id:this.Id + "IgwsNodesSelectReport",
            enableTextSearch:1,
            enableAutoHeight:0
        });
    }

    this.ChartSettingsContext = webix.ui({
        view:"popup",
        width:LangHelper.GetLocale() === LocalesEnum.ru.code?350:250,
        height:120,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    rows:[
                        {
                            view:"combo",
                            id:this.Id + "UnitsCombo",
                            name:"Units",
                            label:LangHelper.GetString("DpiPerformance", "Units"),
                            labelPosition: "left",
                            labelWidth: LangHelper.GetLocale() === LocalesEnum.ru.code?170:70,
                            labelAlign: "left",
                            required: true,
                            invalidMessage: LangHelper.GetString("DpiPerformance", "Required field"),
                            options: Helper.DictToArr(ChartSettingUnitsDic),
                        },
                        {
                            view: "toolbar",
                            borderless:true,
                            cols:[
                                {
                                    view:"button",
                                    value:LangHelper.GetString("All", "Cancel"),
                                    click: function() {
                                        _this.ChartSettingsContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    type:"form",
                                    value:LangHelper.GetString("All", "Apply"),
                                    click: function() {
                                        _this.SetChartUnitValue(_this.Views.UnitsCombo.getValue());
                                        _this.DefineDnaStatCharts(true);
                                        _this.ChartSettingsContext.hide();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = function ()
    {
        var config = [
            {
                cols: function ()
                {
                    var cols = [];

                    if(_this.Id === _this.IdsEnum.DpiPerformance)
                        cols.push(DpiConfigLeftSideBarView({id: _this.Id}));

                    if(_this.Id === _this.IdsEnum.UlrIgwNodePerformance)
                    {
                        cols.push({
                            header:LangHelper.GetString("UlrModule","Hardware list"),
                            body:{
                                width:240,
                                rows:[
                                    _this.Views.ReportsWidgets.IgwsNodesSelectReport.ViewConfig
                                ]
                            }
                        });
                        cols.push({view:"resizer"});
                    }

                    cols.push({
                        type: "space",
                        rows: [
                            {
                                type: "clear",
                                borderless: webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? false : true,
                                rows: function ()
                                {
                                    var header = PageHeaderTemplate({id:_this.Id + "PageTitle", root_title: _this.Id === _this.IdsEnum.UlrIgwNodePerformance ? _this.PageTitle.Title : _this.PageTitle.RootTitle, title: _this.Id === _this.IdsEnum.UlrIgwNodePerformance ? "" : _this.PageTitle.Title});

                                    var tabbar = {
                                        view:"tabbar",
                                        id:_this.Id + "Tabs",
                                        value:_this.Id + "Tabs"+"Online",
                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : 40,
                                        borderless:true,
                                        multiview:true,
                                        options: function ()
                                        {
                                            var opts = [
                                                {
                                                    id: _this.Id + "Tabs"+"Online",
                                                    value: LangHelper.GetString("DpiPerformance", "Online"),
                                                    width:_this.Id === _this.IdsEnum.UlrIgwNodePerformance ? 0: 200
                                                },
                                                {
                                                    id: _this.Id + "Tabs"+"Stats",
                                                    value: LangHelper.GetString("DpiPerformance", "Statistics"),
                                                    width:_this.Id === _this.IdsEnum.UlrIgwNodePerformance ? 0 : 200
                                                }
                                            ];

                                            if(_this.NatTabEnabled)
                                                opts.push(
                                                    {
                                                        id: _this.Id + "Tabs"+"Nat",
                                                        value: LangHelper.GetString("DpiPerformance", "Nat statistics"),
                                                        width:200
                                                    }
                                                );

                                            return opts;
                                        }()
                                    };

                                    var cells = {
                                        cells:function () {
                                            var cells = [
                                                {
                                                    id: _this.Id + "Tabs"+"Online",
                                                    rows:[
                                                        function ()
                                                        {
                                                            if(webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan")
                                                            {
                                                                return {height: 1};
                                                            }

                                                            return {height: 16};
                                                        }(),
                                                        {
                                                            view:"accordion",
                                                            multi:false,
                                                            cols:[
                                                                {
                                                                    header:LangHelper.GetString("DpiPerformance", "Processors and memory"),
                                                                    gravity:2,
                                                                    body:{
                                                                        view:"scrollview",
                                                                        scroll:"y",
                                                                        body:{
                                                                            rows:[
                                                                                {
                                                                                    view:"accordion",
                                                                                    //multi:false,
                                                                                    cols:[
                                                                                        {
                                                                                            header:BlockHeaderTemplate().template({title: LangHelper.GetString("DpiPerformance", "CPU usage (%)"), icon: "tachometer"}),
                                                                                            body:{
                                                                                                rows:[
                                                                                                    //BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "CPU usage (%)"), icon: "tachometer"}),
                                                                                                    {
                                                                                                        cols: [
                                                                                                            {
                                                                                                                rows:
                                                                                                                    [
                                                                                                                        {
                                                                                                                            cols:[
                                                                                                                                {
                                                                                                                                    id:_this.Id + "CpuFastdpiGage",
                                                                                                                                    width: 150,
                                                                                                                                    view: "gage",
                                                                                                                                    value: 0,
                                                                                                                                    minRange: 0,
                                                                                                                                    maxRange: 100,
                                                                                                                                    label: LangHelper.GetString("DpiPerformance", "Process<br/>fastdpi"),
                                                                                                                                    placeholder: "%"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    id:_this.Id + "CpuIdGage",
                                                                                                                                    width: 150,
                                                                                                                                    view: "gage",
                                                                                                                                    value: 0,
                                                                                                                                    minRange: 0,
                                                                                                                                    maxRange: 100,
                                                                                                                                    label: LangHelper.GetString("DpiPerformance", "Status<br/>idle (id)"),
                                                                                                                                    placeholder: "%",
                                                                                                                                    color:function (Val)
                                                                                                                                    {
                                                                                                                                        return "hsl(" + (Math.round(this.gradientLength * 120)) + ", 100%, 50%)";
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            cols:[
                                                                                                                                {
                                                                                                                                    id:_this.Id + "CpuUsGage",
                                                                                                                                    width: 150,
                                                                                                                                    view: "gage",
                                                                                                                                    value: 0,
                                                                                                                                    minRange: 0,
                                                                                                                                    maxRange: 100,
                                                                                                                                    label: LangHelper.GetString("DpiPerformance", "User's<br/>processes (us)"),
                                                                                                                                    placeholder: "%"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    id:_this.Id + "CpuSyGage",
                                                                                                                                    width: 150,
                                                                                                                                    view: "gage",
                                                                                                                                    value: 0,
                                                                                                                                    minRange: 0,
                                                                                                                                    maxRange: 100,
                                                                                                                                    label: LangHelper.GetString("DpiPerformance", "System<br/>processes (sy)"),
                                                                                                                                    placeholder: "%"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                            },
                                                                                                            {
                                                                                                                view: "chart",
                                                                                                                id:_this.Id + "CpusCoresBarChart",
                                                                                                                type:"stackedBar",
                                                                                                                xAxis: {
                                                                                                                    template:function(obj)
                                                                                                                    {
                                                                                                                        if(obj.stat_key && obj.stat_key.indexOf("cpu") >= 0)
                                                                                                                        {
                                                                                                                            var chart = $$(_this.Id + "CpusCoresBarChart");
                                                                                                                            var index = obj.stat_key == "cpu" ? -1 : parseInt(obj.stat_key.replace("cpu",""),10);

                                                                                                                            index+=1;

                                                                                                                            return index%chart.xAxisStep == 0 ? obj.stat_key: "";
                                                                                                                        }
                                                                                                                        else
                                                                                                                        {
                                                                                                                            return obj.stat_key;
                                                                                                                        }
                                                                                                                    },
                                                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                                },
                                                                                                                yAxis: {
                                                                                                                    start: 0,
                                                                                                                    end: 100,
                                                                                                                    step: 10,
                                                                                                                    template: function (value)
                                                                                                                    {
                                                                                                                        return value + " %";
                                                                                                                    },
                                                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                                },
                                                                                                                series: [
                                                                                                                    {
                                                                                                                        value: "#sy#",
                                                                                                                        color: "#ba68c8",
                                                                                                                        alpha:0.7,
                                                                                                                        tooltip: {
                                                                                                                            template: "#stat_key#: " + LangHelper.GetString("DpiPerformance", "System processes (sy)").toLowerCase() + ": #sy#%"
                                                                                                                        }
                                                                                                                    },
                                                                                                                    {
                                                                                                                        value: "#us#",
                                                                                                                        color: "#aed581",
                                                                                                                        alpha:0.7,
                                                                                                                        tooltip: {
                                                                                                                            template: "#stat_key#: " + LangHelper.GetString("DpiPerformance", "User processes (us)").toLowerCase() + ": #us#%"
                                                                                                                        }
                                                                                                                    },
                                                                                                                    {
                                                                                                                        value: "#fastdpi#",
                                                                                                                        color: "#ffb74d",
                                                                                                                        alpha:0.7,
                                                                                                                        tooltip: {
                                                                                                                            template: "#stat_key#: " + LangHelper.GetString("DpiPerformance", "Fastdpi process").toLowerCase() + ": #fastdpi#%"
                                                                                                                        }
                                                                                                                    },
                                                                                                                    {
                                                                                                                        value: "#idle#",
                                                                                                                        color: "#4fc3f7",
                                                                                                                        alpha:0.3,
                                                                                                                        tooltip: {
                                                                                                                            template: "#stat_key#: " + LangHelper.GetString("DpiPerformance", "Idle state").toLowerCase() + ": #idle#%"
                                                                                                                        }
                                                                                                                    }
                                                                                                                ],
                                                                                                                legend: {
                                                                                                                    values: [
                                                                                                                        {text: "sy", color: "#ba68c8"},
                                                                                                                        {text: "us", color: "#aed581"},
                                                                                                                        {text: "fastdpi", color: "#ffb74d"},
                                                                                                                        {text: "id", color: "#4fc3f7"}
                                                                                                                    ],
                                                                                                                    valign: "middle",
                                                                                                                    align: "right",
                                                                                                                    width: 90,
                                                                                                                    layout: "y"
                                                                                                                },
                                                                                                                //offset: 0,
                                                                                                                data:[],
                                                                                                                on:{
                                                                                                                    onBeforeRender:function (data)
                                                                                                                    {
                                                                                                                        var chart = $$(_this.Id + "CpusCoresBarChart");

                                                                                                                        chart.xAxisStep = 1;

                                                                                                                        if(data.length && chart.$width)
                                                                                                                        {
                                                                                                                            var l = data.length;

                                                                                                                            var w = this.$width;

                                                                                                                            for (var i = 1; i <= 20; i++)
                                                                                                                            {
                                                                                                                                if(w/l*chart.xAxisStep >= 120)
                                                                                                                                {
                                                                                                                                    break;
                                                                                                                                }

                                                                                                                                chart.xAxisStep++;
                                                                                                                            }
                                                                                                                        }

                                                                                                                        return true;
                                                                                                                    }
                                                                                                                }
                                                                                                            }

                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        },
                                                                                        //{view:"resizer"},
                                                                                        {
                                                                                            header:BlockHeaderTemplate().template({title: LangHelper.GetString("DpiPerformance", "CPU usage (%)"), icon: "area-chart"}),
                                                                                            collapsed:true,
                                                                                            body:{
                                                                                                rows: [
                                                                                                    //BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "CPU usage (%)"), icon: "area-chart"}),
                                                                                                    {
                                                                                                        cols:[
                                                                                                            {
                                                                                                                view: "chart",
                                                                                                                id:_this.Id + "CpusChart",
                                                                                                                type:"splineArea",
                                                                                                                dynamic: true,
                                                                                                                xAxis: {
                                                                                                                    template:function(obj)
                                                                                                                    {
                                                                                                                        var chart = $$(_this.Id + "CpusChart");
                                                                                                                        return obj.index%chart.xAxisStep == 0 ? Helper.FormatDateTimeForChartXAxes(obj.date) : "";
                                                                                                                    },
                                                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                                },
                                                                                                                yAxis: {
                                                                                                                    start: 0,
                                                                                                                    end: 100,
                                                                                                                    step: 10,
                                                                                                                    template: function (value) {
                                                                                                                        return value + " %";
                                                                                                                    },
                                                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                                },
                                                                                                                legend: {
                                                                                                                    values: [
                                                                                                                        {text: "id", color: "#4fc3f7"},
                                                                                                                        {text: "fastdpi", color: "#ffb74d"},
                                                                                                                        {text: "us", color: "#aed581"},
                                                                                                                        {text: "sy", color: "#ba68c8"}
                                                                                                                    ],
                                                                                                                    valign: "middle",
                                                                                                                    align: "right",
                                                                                                                    width: 90,
                                                                                                                    layout: "y"
                                                                                                                },
                                                                                                                series: [
                                                                                                                    {
                                                                                                                        value: "#idle#",
                                                                                                                        color: "#4fc3f7",
                                                                                                                        alpha:0.3,
                                                                                                                        tooltip: {
                                                                                                                            template: LangHelper.GetString("DpiPerformance", "Idle state") + ": #idle#%"
                                                                                                                        }
                                                                                                                    },
                                                                                                                    {
                                                                                                                        value: "#fastdpi.cpus_usage#",
                                                                                                                        color: "#ffb74d",
                                                                                                                        alpha:0.7,
                                                                                                                        tooltip: {
                                                                                                                            template: LangHelper.GetString("DpiPerformance", "Fastdpi process") + ": #fastdpi.cpus_usage#%"
                                                                                                                        }
                                                                                                                    },
                                                                                                                    {
                                                                                                                        value: "#us#",
                                                                                                                        color: "#aed581",
                                                                                                                        alpha:0.7,
                                                                                                                        tooltip: {
                                                                                                                            template: LangHelper.GetString("DpiPerformance", "User processes (us)") + ": #us#%"
                                                                                                                        }
                                                                                                                    },
                                                                                                                    {
                                                                                                                        value: "#sy#",
                                                                                                                        color: "#ba68c8",
                                                                                                                        alpha:0.7,
                                                                                                                        tooltip: {
                                                                                                                            template: LangHelper.GetString("DpiPerformance", "System processes (sy)") + ": #sy#%"
                                                                                                                        }
                                                                                                                    }

                                                                                                                ],
                                                                                                                offset: 0,
                                                                                                                data:[],
                                                                                                                on:{
                                                                                                                    onBeforeRender:function (data)
                                                                                                                    {
                                                                                                                        var chart = $$(_this.Id + "CpusChart");

                                                                                                                        chart.xAxisStep = 2;

                                                                                                                        if(data.length && chart.$width)
                                                                                                                        {
                                                                                                                            var l = data.length;

                                                                                                                            var w = this.$width;

                                                                                                                            for (var i = 1; i <= 20; i++)
                                                                                                                            {
                                                                                                                                if(w/l*chart.xAxisStep >= 120)
                                                                                                                                {
                                                                                                                                    break;
                                                                                                                                }

                                                                                                                                chart.xAxisStep++;
                                                                                                                            }
                                                                                                                        }

                                                                                                                        return true;
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                view: "chart",
                                                                                                                id:_this.Id + "CpusCoresChart",
                                                                                                                type:"splineArea",
                                                                                                                dynamic: true,
                                                                                                                xAxis: {
                                                                                                                    template:function(obj)
                                                                                                                    {
                                                                                                                        var chart = $$(_this.Id + "CpusCoresChart");
                                                                                                                        return obj.index%chart.xAxisStep == 0 ? Helper.FormatDateTimeForChartXAxes(obj.date) : "";
                                                                                                                    },
                                                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                                },
                                                                                                                yAxis: {
                                                                                                                    start: 0,
                                                                                                                    end: 100,
                                                                                                                    step: 10,
                                                                                                                    template: function (value) {
                                                                                                                        return value + " %";
                                                                                                                    },
                                                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                                },
                                                                                                                legend: {
                                                                                                                    values: [],
                                                                                                                    valign: "middle",
                                                                                                                    align: "right",
                                                                                                                    width: 90,
                                                                                                                    layout: "y"
                                                                                                                },
                                                                                                                series: [

                                                                                                                ],
                                                                                                                offset: 0,
                                                                                                                data:[],
                                                                                                                on:{
                                                                                                                    onBeforeRender:function (data)
                                                                                                                    {
                                                                                                                        var chart = $$(_this.Id + "CpusCoresChart");

                                                                                                                        chart.xAxisStep = 2;

                                                                                                                        if(data.length && chart.$width)
                                                                                                                        {
                                                                                                                            var l = data.length;

                                                                                                                            var w = this.$width;

                                                                                                                            for (var i = 1; i <= 20; i++)
                                                                                                                            {
                                                                                                                                if(w/l*chart.xAxisStep >= 120)
                                                                                                                                {
                                                                                                                                    break;
                                                                                                                                }

                                                                                                                                chart.xAxisStep++;
                                                                                                                            }
                                                                                                                        }

                                                                                                                        return true;
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                view: "chart",
                                                                                                                id:_this.Id + "CpusCoresFastdpiChart",
                                                                                                                type:"splineArea",
                                                                                                                dynamic: true,
                                                                                                                xAxis: {
                                                                                                                    template:function(obj)
                                                                                                                    {
                                                                                                                        var chart = $$(_this.Id + "CpusCoresFastdpiChart");
                                                                                                                        return obj.index%chart.xAxisStep == 0 ? Helper.FormatDateTimeForChartXAxes(obj.date) : "";
                                                                                                                    },
                                                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                                },
                                                                                                                yAxis: {
                                                                                                                    start: 0,
                                                                                                                    end: 100,
                                                                                                                    step: 10,
                                                                                                                    template: function (value) {
                                                                                                                        return value + " %";
                                                                                                                    },
                                                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                                },
                                                                                                                legend: {
                                                                                                                    values: [],
                                                                                                                    valign: "middle",
                                                                                                                    align: "right",
                                                                                                                    width: 90,
                                                                                                                    layout: "y"
                                                                                                                },
                                                                                                                series: [

                                                                                                                ],
                                                                                                                offset: 0,
                                                                                                                data:[],
                                                                                                                on:{
                                                                                                                    onBeforeRender:function (data)
                                                                                                                    {
                                                                                                                        var chart = $$(_this.Id + "CpusCoresFastdpiChart");

                                                                                                                        chart.xAxisStep = 2;

                                                                                                                        if(data.length && chart.$width)
                                                                                                                        {
                                                                                                                            var l = data.length;

                                                                                                                            var w = this.$width;

                                                                                                                            for (var i = 1; i <= 20; i++)
                                                                                                                            {
                                                                                                                                if(w/l*chart.xAxisStep >= 120)
                                                                                                                                {
                                                                                                                                    break;
                                                                                                                                }

                                                                                                                                chart.xAxisStep++;
                                                                                                                            }
                                                                                                                        }

                                                                                                                        return true;
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {view:"resizer"},
                                                                                {
                                                                                    cols:[
                                                                                        {
                                                                                            rows:[
                                                                                                BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "Memory usage (%)"), icon: "tachometer"}),
                                                                                                {
                                                                                                    cols:[
                                                                                                        {
                                                                                                            id:_this.Id + "MemFastDpiGage",
                                                                                                            width: 150,
                                                                                                            view: "gage",
                                                                                                            value: 0,
                                                                                                            minRange: 0,
                                                                                                            maxRange: 100,
                                                                                                            label: LangHelper.GetString("DpiPerformance", "The process<br/>fastdpi (mem)"),
                                                                                                            placeholder: "%"
                                                                                                        },
                                                                                                        {
                                                                                                            id:_this.Id + "CpuMemGage",
                                                                                                            width: 150,
                                                                                                            view: "gage",
                                                                                                            value: 0,
                                                                                                            minRange: 0,
                                                                                                            maxRange: 100,
                                                                                                            label: LangHelper.GetString("DpiPerformance", "Operative<br/>memory (mem)"),
                                                                                                            placeholder: "%"
                                                                                                        },
                                                                                                        {
                                                                                                            id:_this.Id + "CpuSwapGage",
                                                                                                            width: 150,
                                                                                                            view: "gage",
                                                                                                            value: 0,
                                                                                                            minRange: 0,
                                                                                                            maxRange: 100,
                                                                                                            label: LangHelper.GetString("DpiPerformance", "Swap<br/>file"),
                                                                                                            placeholder: "%"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {view:"resizer"},
                                                                                        {
                                                                                            rows: [
                                                                                                BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "Memory usage (%)"), icon: "area-chart"}),
                                                                                                {
                                                                                                    view: "chart",
                                                                                                    id:_this.Id + "MemChart",
                                                                                                    type:"splineArea",
                                                                                                    dynamic: true,
                                                                                                    xAxis: {
                                                                                                        template:function(obj)
                                                                                                        {
                                                                                                            var chart = $$(_this.Id + "MemChart");
                                                                                                            return obj.index%chart.xAxisStep == 0 ? Helper.FormatDateTimeForChartXAxes(obj.date) : "";
                                                                                                        },
                                                                                                        lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                        color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                    },
                                                                                                    yAxis: {
                                                                                                        start: 0,
                                                                                                        end: 100,
                                                                                                        step: 10,
                                                                                                        template: function (value) {
                                                                                                            return value + " %";
                                                                                                        },
                                                                                                        lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                                        color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                                    },
                                                                                                    legend: {
                                                                                                        values: [
                                                                                                            {text: "mem", color: "#aed581"},
                                                                                                            {text: "fastdpi", color: "#ffb74d"},
                                                                                                            {text: "swap", color: "#ba68c8"}
                                                                                                        ],
                                                                                                        valign: "middle",
                                                                                                        align: "right",
                                                                                                        width: 90,
                                                                                                        layout: "y"
                                                                                                    },
                                                                                                    series: [
                                                                                                        {
                                                                                                            value: "#mem_used#",
                                                                                                            color: "#aed581",
                                                                                                            alpha:0.7,
                                                                                                            tooltip: {
                                                                                                                template: LangHelper.GetString("DpiPerformance", "Operative memory (mem)") + ": #mem_used#%"
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            value: "#fastdpi.mem_usage#",
                                                                                                            color: "#ffb74d",
                                                                                                            alpha:0.7,
                                                                                                            tooltip: {
                                                                                                                template: LangHelper.GetString("DpiPerformance", "Process fastdpi (mem)") + ": #fastdpi.mem_usage#%"
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            value: "#swap_used#",
                                                                                                            color: "#ba68c8",
                                                                                                            alpha:0.7,
                                                                                                            tooltip: {
                                                                                                                template: LangHelper.GetString("DpiPerformance", "Swap file") + ": #swap_used#%"
                                                                                                            }
                                                                                                        }
                                                                                                    ],
                                                                                                    offset: 0,
                                                                                                    data:[],
                                                                                                    on:{
                                                                                                        onBeforeRender:function (data)
                                                                                                        {
                                                                                                            var chart = $$(_this.Id + "MemChart");

                                                                                                            chart.xAxisStep = 2;

                                                                                                            if(data.length && chart.$width)
                                                                                                            {
                                                                                                                var l = data.length;

                                                                                                                var w = this.$width;

                                                                                                                for (var i = 1; i <= 20; i++)
                                                                                                                {
                                                                                                                    if(w/l*chart.xAxisStep >= 120)
                                                                                                                    {
                                                                                                                        break;
                                                                                                                    }

                                                                                                                    chart.xAxisStep++;
                                                                                                                }
                                                                                                            }

                                                                                                            return true;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                },
                                                                {
                                                                    header:LangHelper.GetString("DpiPerformance", "Top 30 processes"),
                                                                    collapsed:true,
                                                                    body:{
                                                                        rows:[
                                                                            BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "Top 30 processes"), icon: "table"}),
                                                                            {
                                                                                view:"datatable",
                                                                                id:_this.Id + "TopProcesses",
                                                                                columns:[
                                                                                    {
                                                                                        id:"pid",
                                                                                        header:LangHelper.GetString("DpiPerformance", "Process Id"),
                                                                                        sort:"text"
                                                                                    },
                                                                                    {
                                                                                        id:"command",
                                                                                        header:LangHelper.GetString("DpiPerformance", "Process"),
                                                                                        sort:"text",
                                                                                        fillspace:true
                                                                                    },
                                                                                    {
                                                                                        id:"cpu",
                                                                                        header:"CPU %",
                                                                                        sort:"text"
                                                                                    },
                                                                                    {
                                                                                        id:"mem",
                                                                                        header:"RAM %",
                                                                                        sort:"text"
                                                                                    },
                                                                                    {
                                                                                        id:"res",
                                                                                        header:"Res",
                                                                                        sort:"text"
                                                                                    },
                                                                                    {
                                                                                        id:"virt",
                                                                                        header:"Virt",
                                                                                        sort:"text"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    header: LangHelper.GetString("DpiPerformance", "Devices"),
                                                                    id: _this.Id + "StatsDevices",
                                                                    collapsed:true,
                                                                    body:{
                                                                        rows:[
                                                                            {
                                                                                view: "treetable",
                                                                                css: "performance-stat-devices-table",
                                                                                id: _this.Id + "StatsDevicesTable",
                                                                                columns: [
                                                                                    {
                                                                                        id: "device",
                                                                                        header: LangHelper.GetString("DpiPerformance", "Device"),
                                                                                        sort: "string",
                                                                                        template: function(obj, common, value, config)
                                                                                        {
                                                                                            return common.treetable(obj, common, value, config) + obj.device;
                                                                                        },
                                                                                        width: 320
                                                                                    },
                                                                                    {
                                                                                        id: "status",
                                                                                        header: LangHelper.GetString("DpiPerformance", "Status"),
                                                                                        sort: "string",
                                                                                        width: 80,
                                                                                        template: function(Obj)
                                                                                        {
                                                                                            if(!Obj || !Obj.status)
                                                                                            {
                                                                                                return "";
                                                                                            }

                                                                                            return "<span class=\"status status_" + Obj.status + "\">" + Obj.status.toUpperCase() + "</span>"
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        id: "down",
                                                                                        header: LangHelper.GetString("DpiPerformance", "Down"),
                                                                                        sort: "string",
                                                                                        fillspace: true
                                                                                    },
                                                                                    {
                                                                                        id: "up",
                                                                                        header: LangHelper.GetString("DpiPerformance", "Up"),
                                                                                        sort: "string",
                                                                                        fillspace: true
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    id: _this.Id + "Tabs"+"Stats",
                                                    rows:[
                                                        function ()
                                                        {
                                                            if(webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan")
                                                            {
                                                                return {height: 1};
                                                            }

                                                            return {height: 16};
                                                        }(),
                                                        {
                                                            view: "toolbar",
                                                            elements: [
                                                                _this.Views.Widgets.DateRangePicker.ViewConfig,
                                                                {
                                                                    view:"richselect",
                                                                    id:_this.Id + "PeriodType",
                                                                    label:LangHelper.GetString("DpiPerformance", "Interval"),
                                                                    value:"15i",
                                                                    options:[
                                                                        {id:"i", value:LangHelper.GetString("DpiPerformance", "1 minute")},
                                                                        {id:"15i", value:LangHelper.GetString("DpiPerformance", "15 minutes")},
                                                                        {id:"30i", value:LangHelper.GetString("DpiPerformance", "30 minutes")},
                                                                        {id:"H", value:LangHelper.GetString("DpiPerformance", "1 hour")},
                                                                        {id:"d", value:LangHelper.GetString("DpiPerformance", "1 day")},
                                                                        {id:"m", value:LangHelper.GetString("DpiPerformance", "1 month")}
                                                                    ]
                                                                },
                                                                {
                                                                    gravity:2
                                                                },
                                                                {
                                                                    view:"button",
                                                                    id:_this.Id + "ChartSettings",
                                                                    type:"icon",
                                                                    icon:"gear",
                                                                    css:"toolbar_round_btn",
                                                                    width:30,
                                                                    tooltip:LangHelper.GetString(_this.Id,"Settings"),
                                                                    click: function() {
                                                                        _this.ShowChartSettingsForm(this.getNode(), {pos:"bottom"});
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            view:"accordion",
                                                            id:_this.Id + "Tabs"+"Stats"+"Accordion",
                                                            multi:false,
                                                            cols:[
                                                                {
                                                                    header:LangHelper.GetString("DpiPerformance", "Processors and memory"),
                                                                    id:_this.Id + "CpusMemStatChartAi",
                                                                    body:{
                                                                        rows: [
                                                                            BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "Processors usage (%)"), icon: "area-chart"}),
                                                                            {
                                                                                cols:[
                                                                                    {
                                                                                        view: "chart",
                                                                                        id:_this.Id + "CpusStatChart",
                                                                                        type:"splineArea",
                                                                                        xAxis: {
                                                                                            lines:false,
                                                                                            template:function(obj)
                                                                                            {
                                                                                                var chart = $$(_this.Id + "CpusStatChart");
                                                                                                return obj.index%chart.xAxisStep == 0 ? Helper.FormatDateTimeForChartXAxes(obj.cpu.date) : "";
                                                                                            },
                                                                                            lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                            color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                        },
                                                                                        yAxis: {
                                                                                            start: 0,
                                                                                            end: 100,
                                                                                            step: 10,
                                                                                            template: function (value) {
                                                                                                return value + " %";
                                                                                            },
                                                                                            lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                            color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                        },
                                                                                        legend: {
                                                                                            values: [
                                                                                                {text: "id", color: "#4fc3f7"},
                                                                                                {text: "us", color: "#aed581"},
                                                                                                {text: "sy", color: "#ba68c8"}],
                                                                                            valign: "middle",
                                                                                            align: "right",
                                                                                            width: 120,
                                                                                            layout: "y"
                                                                                        },
                                                                                        series: [
                                                                                            {
                                                                                                value: "#cpu.idle#",
                                                                                                color: "#4fc3f7",
                                                                                                alpha:0.3,
                                                                                                tooltip: {
                                                                                                    template: function(Obj){return LangHelper.GetString(_this.Id, "Idle state") + ": "+Math.round(Obj.cpu.idle*10)/10+"%";}
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                value: "#cpu.us#",
                                                                                                color: "#aed581",
                                                                                                alpha:0.7,
                                                                                                tooltip: {
                                                                                                    template: function(Obj){return LangHelper.GetString(_this.Id, "User processes (us)") + ": "+Math.round(Obj.cpu.us*10)/10+"%";}
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                value: "#cpu.sy#",
                                                                                                color: "#ba68c8",
                                                                                                alpha:0.7,
                                                                                                tooltip: {
                                                                                                    template: function(Obj){return LangHelper.GetString(_this.Id, "System processes (sy)") + ": "+Math.round(Obj.cpu.sy*10)/10+"%";}
                                                                                                }
                                                                                            }

                                                                                        ],
                                                                                        data:[],
                                                                                        on:{
                                                                                            onBeforeRender:function (data)
                                                                                            {
                                                                                                var chart = $$(_this.Id + "CpusStatChart");

                                                                                                chart.xAxisStep = 2;

                                                                                                if(data.length && chart.$width)
                                                                                                {
                                                                                                    var l = data.length;

                                                                                                    var w = this.$width;

                                                                                                    for (var i = 1; i <= 20; i++)
                                                                                                    {
                                                                                                        if(w/l*chart.xAxisStep >= 120)
                                                                                                        {
                                                                                                            break;
                                                                                                        }

                                                                                                        chart.xAxisStep++;
                                                                                                    }
                                                                                                }

                                                                                                return true;
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {view:"resizer"},
                                                                                    {
                                                                                        view: "chart",
                                                                                        id:_this.Id + "CpusCoresStatChart",
                                                                                        type:"splineArea",
                                                                                        xAxis: {
                                                                                            template:function(obj)
                                                                                            {
                                                                                                var chart = $$(_this.Id + "CpusCoresStatChart");
                                                                                                return obj.index%chart.xAxisStep == 0 ? Helper.FormatDateTimeForChartXAxes(obj.date) : "";
                                                                                            },
                                                                                            lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                            color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                        },
                                                                                        yAxis: {
                                                                                            start: 0,
                                                                                            end: 100,
                                                                                            step: 10,
                                                                                            template: function (value) {
                                                                                                return value + " %";
                                                                                            },
                                                                                            lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                            color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                        },
                                                                                        legend: {
                                                                                            values: [],
                                                                                            valign: "middle",
                                                                                            align: "right",
                                                                                            width: 90,
                                                                                            layout: "y"
                                                                                        },
                                                                                        series: [

                                                                                        ],
                                                                                        offset: 0,
                                                                                        data:[],
                                                                                        on:{
                                                                                            onBeforeRender:function (data)
                                                                                            {
                                                                                                var chart = $$(_this.Id + "CpusCoresStatChart");

                                                                                                chart.xAxisStep = 2;

                                                                                                if(data.length && chart.$width)
                                                                                                {
                                                                                                    var l = data.length;

                                                                                                    var w = this.$width;

                                                                                                    // if(l <= 12)
                                                                                                    //     chart.xAxisStep = 6;

                                                                                                    for (var i = 1; i <= 20; i++)
                                                                                                    {
                                                                                                        if(w/l*chart.xAxisStep >= 120)
                                                                                                        {
                                                                                                            break;
                                                                                                        }

                                                                                                        chart.xAxisStep++;
                                                                                                    }
                                                                                                }

                                                                                                return true;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            },
                                                                            BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "Memory usage (GB)"), icon: "area-chart"}),
                                                                            {
                                                                                view: "chart",
                                                                                id:_this.Id + "MemStatChart",
                                                                                type:"splineArea",
                                                                                xAxis: {
                                                                                    lines:false,
                                                                                    template:function(obj)
                                                                                    {
                                                                                        var chart = $$(_this.Id + "MemStatChart");
                                                                                        return obj.index%chart.xAxisStep == 0 ? Helper.FormatDateTimeForChartXAxes(obj.date) : "";
                                                                                    },
                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                },
                                                                                yAxis: {
                                                                                    template: function (value) {
                                                                                        return value+" "+LangHelper.GetString("All", "Gb");
                                                                                    },
                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                },
                                                                                legend: {
                                                                                    values: [
                                                                                        {text: "virt", color: "#aed581"},
                                                                                        {text: "res", color: "#ba68c8"}
                                                                                    ],
                                                                                    valign: "middle",
                                                                                    align: "right",
                                                                                    width: 120,
                                                                                    layout: "y"
                                                                                },
                                                                                series: [
                                                                                    {
                                                                                        value: "#virt#",
                                                                                        color: "#aed581",
                                                                                        alpha:0.7,
                                                                                        tooltip: {
                                                                                            template: LangHelper.GetString("DpiPerformance", "Virtual memory (virt)") + ": #virt# Гб"
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        value: "#res#",
                                                                                        color: "#ba68c8",
                                                                                        alpha:0.7,
                                                                                        tooltip: {
                                                                                            template: LangHelper.GetString("DpiPerformance", "Physical memory (res)") + ": #res# Гб"
                                                                                        }
                                                                                    }
                                                                                ],
                                                                                data:[],
                                                                                on:{
                                                                                    onBeforeRender:function (data)
                                                                                    {
                                                                                        var chart = $$(_this.Id + "MemStatChart");

                                                                                        chart.xAxisStep = 2;

                                                                                        if(data.length && chart.$width)
                                                                                        {
                                                                                            var l = data.length;

                                                                                            var w = this.$width;

                                                                                            for (var i = 1; i <= 20; i++)
                                                                                            {
                                                                                                if(w/l*chart.xAxisStep >= 120)
                                                                                                {
                                                                                                    break;
                                                                                                }

                                                                                                chart.xAxisStep++;
                                                                                            }
                                                                                        }

                                                                                        return true;
                                                                                    }
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    header:LangHelper.GetString("DpiPerformance", "HTTP statistics"),
                                                                    id:_this.Id + "HttpStatChartAi",
                                                                    collapsed:true,
                                                                    body:{
                                                                        rows:[
                                                                            BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "HTTP statistics (number of processed)"), icon: "area-chart"}),
                                                                            _this.HttpStatChartConfig(["url","ssl","cna","sni","quic"],false),
                                                                            BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "HTTP statistics (number of blocked)"), icon: "area-chart"}),
                                                                            _this.HttpStatChartConfig(["url","ssl","cna","sni","quic"],true)
                                                                        ]
                                                                    }
                                                                }
                                                            ],
                                                            on:{
                                                                'onAfterExpand': function(id)
                                                                {
                                                                    if(id == _this.Id + "CpusMemStatChartAi")
                                                                    {
                                                                        if(_this.Views.CpusStatChart && _this.Views.MemStatChart && _this.Views.CpusCoresStatChart)
                                                                        {
                                                                            _this.Views.CpusStatChart.refresh();
                                                                            _this.Views.MemStatChart.refresh();
                                                                            _this.Views.CpusCoresStatChart.refresh();
                                                                        }
                                                                    }
                                                                    else if(id == _this.Id + "HttpStatChartAi")
                                                                    {
                                                                        if(_this.Views.HttpStatChart && Object.keys(_this.Views.HttpStatChart).length)
                                                                        {
                                                                            Object.keys(_this.Views.HttpStatChart).forEach(function (Key)
                                                                            {
                                                                                _this.Views.HttpStatChart[Key].refresh();
                                                                            });
                                                                        }
                                                                    }
                                                                    else if(id.indexOf("Dna") !== false)
                                                                    {
                                                                        //_this.RefreshChartsSeriesVisibility();

                                                                        // Object.keys(_this.Views.DnaStatCharts).forEach(function (Key)
                                                                        // {
                                                                        //     if(_this.Views.DnaStatCharts[Key])
                                                                        //     {
                                                                        //         _this.Views.DnaStatCharts[Key].refresh();
                                                                        //     }
                                                                        // });
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            ];

                                            if(_this.NatTabEnabled)
                                            {
                                                cells.push({
                                                    id: _this.Id + "Tabs" + "Nat",
                                                    rows: [
                                                        {
                                                            height: 16
                                                        },
                                                        {
                                                            view:"accordion",
                                                            id:_this.Id + "Tabs"+"Nat"+"Accordion",
                                                            multi:false,
                                                            cols:[
                                                                {
                                                                    header: LangHelper.GetString("DpiPerformance", "Top pools"),
                                                                    body:{
                                                                        rows:[
                                                                            BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "Top profiles"), icon: "cogs"}),
                                                                            {
                                                                                view: "chart",
                                                                                id:_this.Id + "NatFullPoolUsage",
                                                                                type:"stackedBar",
                                                                                xAxis: {
                                                                                    template:function(obj)
                                                                                    {
                                                                                        return obj.title + "<br/>" +
                                                                                            "(" + CgNatTypesDic[obj.nat_type].value + ")";
                                                                                        // if(obj.stat_key && obj.stat_key.indexOf("cpu") >= 0)
                                                                                        // {
                                                                                        //     var chart = $$(_this.Id + "NatFullPoolUsage");
                                                                                        //     var index = obj.stat_key == "cpu" ? -1 : parseInt(obj.stat_key.replace("cpu",""),10);
                                                                                        //
                                                                                        //     index+=1;
                                                                                        //
                                                                                        //     return index%chart.xAxisStep == 0 ? obj.stat_key: "";
                                                                                        // }
                                                                                        // else
                                                                                        // {
                                                                                        //     return obj.stat_key;
                                                                                        // }
                                                                                    },
                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                },
                                                                                yAxis: {
                                                                                    start: 0,
                                                                                    end: 100,
                                                                                    step: 10,
                                                                                    template: function (value)
                                                                                    {
                                                                                        return value + " %";
                                                                                    },
                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                },
                                                                                series: [
                                                                                    {
                                                                                        value: function(obj)
                                                                                        {
                                                                                            return obj.load;
                                                                                        },
                                                                                        color: "#ba68c8",
                                                                                        alpha:0.7,
                                                                                        tooltip: {
                                                                                            template: function(obj)
                                                                                            {
                                                                                                return LangHelper.GetString("CgNatService","Nat type") + ": " + CgNatTypesDic[obj.nat_type].value + " <br/>" +
                                                                                                    LangHelper.GetString("CgNatService", obj.nat_type == 0 ? "Ports number" : "Addresses number") + ": " + obj.total + "<br/>" +
                                                                                                    LangHelper.GetString("CgNatService", obj.nat_type == 0 ? "Ports in use" : "Addresses in use") + ": " + obj.used + " (" + obj.load + "%)";
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        value: 100,
                                                                                        color: "#4fc3f7",
                                                                                        alpha:0.3,
                                                                                        tooltip: {
                                                                                            template: function(obj)
                                                                                            {

                                                                                                return LangHelper.GetString("CgNatService","Nat type") + ": " + CgNatTypesDic[obj.nat_type].value + "<br/>" +
                                                                                                    LangHelper.GetString("CgNatService", obj.nat_type == 0 ? "Ports number" : "Addresses number") + ": " + obj.total;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ],
                                                                                legend: {
                                                                                    values: [
                                                                                        {text: LangHelper.GetString(_this.Id, "Used"), color: "#ba68c8"},
                                                                                        {text: LangHelper.GetString(_this.Id, "Total"), color: "#4fc3f7"}
                                                                                    ],
                                                                                    valign: "middle",
                                                                                    align: "right",
                                                                                    width: 108,
                                                                                    layout: "y"
                                                                                },
                                                                                //offset: 0,
                                                                                data:[],
                                                                                on:{
                                                                                    onBeforeRender:function (data)
                                                                                    {
                                                                                        var chart = _this.Views.NatFullPoolUsage;

                                                                                        chart.xAxisStep = 1;

                                                                                        if(data.length && chart.$width)
                                                                                        {
                                                                                            var l = data.length;

                                                                                            var w = this.$width;

                                                                                            for (var i = 1; i <= 20; i++)
                                                                                            {
                                                                                                if(w/l*chart.xAxisStep >= 120)
                                                                                                {
                                                                                                    break;
                                                                                                }

                                                                                                chart.xAxisStep++;
                                                                                            }
                                                                                        }

                                                                                        return true;
                                                                                    }
                                                                                }
                                                                            },
                                                                            BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "Top pool/s"), icon: "cogs"}),
                                                                            {
                                                                                view: "chart",
                                                                                // minHeight: 400,
                                                                                id:_this.Id + "NatPoolUsage",
                                                                                type:"stackedBar",
                                                                                xAxis: {
                                                                                    template:function(obj)
                                                                                    {
                                                                                        var res = obj.title + "<br/>";

                                                                                        res += "(" + obj.proto + ", "+ obj.nthr + ", " + obj.ip_mask +")";
                                                                                        // res += LangHelper.GetString("CgNatService", "Protocol") + ": " + obj.proto + "<br/>";
                                                                                        // res += LangHelper.GetString("CgNatService", "NTHR") + ": " + obj.nthr + "<br/>";
                                                                                        // res += LangHelper.GetString("CgNatService", "IP mask") + ": " + obj.ip_mask + "<br/>";
                                                                                        return res;
                                                                                        // if(obj.stat_key && obj.stat_key.indexOf("cpu") >= 0)
                                                                                        // {
                                                                                        //     var chart = $$(_this.Id + "NatFullPoolUsage");
                                                                                        //     var index = obj.stat_key == "cpu" ? -1 : parseInt(obj.stat_key.replace("cpu",""),10);
                                                                                        //
                                                                                        //     index+=1;
                                                                                        //
                                                                                        //     return index%chart.xAxisStep == 0 ? obj.stat_key: "";
                                                                                        // }
                                                                                        // else
                                                                                        // {
                                                                                        //     return obj.stat_key;
                                                                                        // }
                                                                                    },
                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                },
                                                                                yAxis: {
                                                                                    start: 0,
                                                                                    end: 100,
                                                                                    step: 10,
                                                                                    template: function (value)
                                                                                    {
                                                                                        return value + " %";
                                                                                    },
                                                                                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                                                                                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                                                                                },
                                                                                series: [
                                                                                    {
                                                                                        value: function(obj)
                                                                                        {
                                                                                            return obj.load;
                                                                                        },
                                                                                        color: "#ba68c8",
                                                                                        alpha:0.7,
                                                                                        tooltip: {
                                                                                            template: function(obj)
                                                                                            {
                                                                                                return LangHelper.GetString("CgNatService", obj.nat_type == 0 ? "Ports number" : "Addresses number") +
                                                                                                    ": " + obj.total + "<br/>" +
                                                                                                    LangHelper.GetString("CgNatService", obj.nat_type == 0 ? "Ports in use" : "Addresses in use") +
                                                                                                    ": " + obj.used + " (" + obj.load + "%)<br/>" +
                                                                                                    LangHelper.GetString("CgNatService", "Protocol") + ": " + obj.proto + "<br/>" +
                                                                                                    LangHelper.GetString("CgNatService", "NTHR") + ": " + obj.nthr + "<br/>" +
                                                                                                    LangHelper.GetString("CgNatService", "IP mask") + ": " + obj.ip_mask + "<br/>";
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        value: 100,
                                                                                        color: "#4fc3f7",
                                                                                        alpha:0.3,
                                                                                        tooltip: {
                                                                                            template: function(obj)
                                                                                            {
                                                                                                return LangHelper.GetString("CgNatService", obj.nat_type == 0 ? "Ports number" : "Addresses number") +
                                                                                                    ": " + obj.total + "<br/>" +
                                                                                                    LangHelper.GetString("CgNatService", "Protocol") + ": " + obj.proto + "<br/>" +
                                                                                                    LangHelper.GetString("CgNatService", "NTHR") + ": " + obj.nthr + "<br/>" +
                                                                                                    LangHelper.GetString("CgNatService", "IP mask") + ": " + obj.ip_mask + "<br/>";
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ],
                                                                                legend: {
                                                                                    values: [
                                                                                        {text: LangHelper.GetString(_this.Id, "Used"), color: "#ba68c8"},
                                                                                        {text: LangHelper.GetString(_this.Id, "Total"), color: "#4fc3f7"}
                                                                                    ],
                                                                                    valign: "middle",
                                                                                    align: "right",
                                                                                    width: 108,
                                                                                    layout: "y"
                                                                                },
                                                                                //offset: 0,
                                                                                data:[],
                                                                                on:{
                                                                                    onBeforeRender:function (data)
                                                                                    {
                                                                                        var chart = _this.Views.NatPoolUsage;

                                                                                        chart.xAxisStep = 1;

                                                                                        if(data.length && chart.$width)
                                                                                        {
                                                                                            var l = data.length;

                                                                                            var w = this.$width;

                                                                                            for (var i = 1; i <= 20; i++)
                                                                                            {
                                                                                                if(w/l*chart.xAxisStep >= 120)
                                                                                                {
                                                                                                    break;
                                                                                                }

                                                                                                chart.xAxisStep++;
                                                                                            }
                                                                                        }

                                                                                        return true;
                                                                                    }
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    header: LangHelper.GetString("DpiPerformance", "Addresses"),
                                                                    collapsed:true,
                                                                    body:{
                                                                        rows:[
                                                                            {
                                                                                view: "toolbar",
                                                                                height: 32,
                                                                                padding: 0,
                                                                                margin: 0,
                                                                                borderless:false,
                                                                                elements: [
                                                                                    {
                                                                                        view:"label",
                                                                                        id:_this.id+"ProfileDataInfoLabel",
                                                                                        width:300
                                                                                    },
                                                                                    {},
                                                                                    {
                                                                                        view: "button",
                                                                                        type: "icon",
                                                                                        icon: "download",
                                                                                        css: "toolbar_round_btn",
                                                                                        width: 32,
                                                                                        tooltip: LangHelper.GetString("CgNatService","Download the file"),
                                                                                        click: function (id, e, node)
                                                                                        {
                                                                                            _this.ExportToExcel();
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        width: 32
                                                                                    },
                                                                                    {
                                                                                        view: "button",
                                                                                        id:_this.Id+"ListItemsRefreshBtn",
                                                                                        type: "icon",
                                                                                        icon: "refresh",
                                                                                        css: "toolbar_round_btn",
                                                                                        width: 32,
                                                                                        tooltip: LangHelper.GetString("DpiPerformance","Refresh"),
                                                                                        click: function (id, e, node)
                                                                                        {
                                                                                            _this.RefreshNatAddressPerformance();
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            },
                                                                            BlockHeaderTemplate({title: LangHelper.GetString("CgNatService", "Status"), icon: "cogs"}),
                                                                            {
                                                                                id: _this.Id + "NatAddressPerformanceTable",
                                                                                view: "datatable",
                                                                                headermenu: false,
                                                                                select: "row",
                                                                                on: {
                                                                                    onBeforeFilter:function()
                                                                                    {
                                                                                        return false;
                                                                                    },
                                                                                    onAfterFilter:function()
                                                                                    {
                                                                                        _this.RefreshNatAddressPerformance();
                                                                                    },
                                                                                    onBeforeSort:function()
                                                                                    {
                                                                                        _this.RefreshNatAddressPerformance();
                                                                                        return false;
                                                                                    }
                                                                                },
                                                                                columns: [
                                                                                    {
                                                                                        id: "profile_ids",
                                                                                        header: [LangHelper.GetString("CgNatService", "Profiles"), {
                                                                                            content: "multiSelectFilter",
                                                                                            options: _this.GetCgNatProfileOptions(),
                                                                                            inputConfig: {suggest: {fitMaster: false}}
                                                                                        }],
                                                                                        fillspace: true,
                                                                                        sort: "number",
                                                                                        template:function(obj)
                                                                                        {
                                                                                            return obj && obj.title ? obj.title : "";
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        width: 104,
                                                                                        id: "proto",
                                                                                        header: [LangHelper.GetString("CgNatService","Protocol"),{
                                                                                            content: "richSelectFilter",
                                                                                            options: Helper.DictToArr(CgNatStatusProtoDic),
                                                                                            inputConfig: {suggest: {fitMaster: false}}
                                                                                        }],
                                                                                        sort: "string"
                                                                                        // fillspace: true
                                                                                    },
                                                                                    {
                                                                                        width: 128,
                                                                                        id: "nthr",
                                                                                        header: [LangHelper.GetString("CgNatService","NTHR"),{
                                                                                            content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                                                                                        }],
                                                                                        sort: "string",
                                                                                        // fillspace: true
                                                                                    },
                                                                                    {
                                                                                        width: 72,
                                                                                        id: "ip_mask",
                                                                                        header: [LangHelper.GetString("CgNatService","IP mask"),{
                                                                                            content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                                                                                        }],
                                                                                        sort: "string",
                                                                                        // fillspace: true
                                                                                    },
                                                                                    {
                                                                                        // width: 190,
                                                                                        id: "whip",
                                                                                        header: [LangHelper.GetString("CgNatService","IP"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                                        sort: "string",
                                                                                        fillspace: true
                                                                                    },
                                                                                    {
                                                                                        // width: 190,
                                                                                        id: "total",
                                                                                        header: [LangHelper.GetString("CgNatService","Ports"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                                        sort: "number",
                                                                                        fillspace: true
                                                                                    },
                                                                                    {
                                                                                        id: "used",
                                                                                        header: [LangHelper.GetString("CgNatService","Ports in use"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                                                        sort: "number",
                                                                                        fillspace: true
                                                                                    },
                                                                                    {
                                                                                        width: 120,
                                                                                        id: "load",
                                                                                        header: [LangHelper.GetString("CgNatService","Used"), ""],
                                                                                        template: function (obj, common) {
                                                                                            var title = LangHelper.GetString("CgNatService", "Ports number") + ": " + obj.total + "; ";
                                                                                            title += LangHelper.GetString("CgNatService", "Ports in use") + ": " + obj.used + "; ";
                                                                                            title += " ("+obj.load+"%);";

                                                                                            var html = "<div class='progress_bar_element' title='" + title + "' >";
                                                                                            // html += "<div title='" + title + "' class='progress_result ' style='width:" + (percent + "%") + "'></div>";
                                                                                            html += "<div  class='progress_result progress_result_" + (obj.load >= 90 ? "red" : "green") + "' style='width:" + (obj.load + "%") + "'></div>";
                                                                                            html += "</div> <span style='display:inline-block;'>" + obj.load + "%" + "</span>";
                                                                                            return html;
                                                                                            // return AdvCellProgressTemplate(obj);
                                                                                        },
                                                                                        css: {'text-align': 'center'},
                                                                                        sort: "number"
                                                                                    }
                                                                                ],
                                                                                data:[]
                                                                            },
                                                                            {
                                                                                view: "toolbar",
                                                                                padding: 0,
                                                                                margin: 0,
                                                                                height:32,
                                                                                elements: [
                                                                                    {
                                                                                        view: "pager",
                                                                                        gravity:3,
                                                                                        id: _this.Id + "NatAddressPerformanceTable" + "Paging",
                                                                                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                                                        master:false,
                                                                                        on: {
                                                                                            onAfterPageChange:function(Page)
                                                                                            {
                                                                                                _this.RefreshNatAddressPerformance(Page);
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        view:"richselect",
                                                                                        id: _this.Id + "NatAddressPerformanceTable" + "Paging" + "Size",
                                                                                        label:LangHelper.GetString("CgNatService", "On page"),
                                                                                        labelWidth:120,
                                                                                        minWidth:220,
                                                                                        value:100,
                                                                                        options:PagingSizeOptions,
                                                                                        on: {
                                                                                            onChange:function()
                                                                                            {
                                                                                                _this.RefreshNatAddressPerformance();
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    header: LangHelper.GetString("CgNatService", "Full status"),
                                                                    collapsed:true,
                                                                    body:_this.NatTabEnabled ? _this.NatStatusView.view : {}
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                });
                                            }

                                            return cells;
                                        }()
                                    };

                                    var rows = [];

                                    if(_this.Id === _this.IdsEnum.UlrIgwNodePerformance)
                                    {
                                        rows = [
                                            {
                                                type: "clean",
                                                borderless:true,
                                                rows: [
                                                    {height:6},
                                                    header,
                                                    {height:32},
                                                    {
                                                        type: "wide",
                                                        borderless: true,
                                                        cols: [
                                                            tabbar,
                                                            {gravity:3}
                                                        ]
                                                    },
                                                    cells
                                                ]
                                            }
                                        ];
                                    }
                                    else
                                    {
                                        rows = [
                                            header,
                                            tabbar,
                                            cells
                                        ];
                                    }

                                    return rows;
                                }()
                            }
                        ]
                    });

                    return cols;
                }()
            }
        ];

        return config;
    }();

    this.Subscriptions = {};

    this.Signals = {
        DscpClassSerieSelected: new Rx.BehaviorSubject(0)
    };

    this.ChartsStep = 5;

    this.DnasInfo = null;

    this.WrongConfigInfoShowed = {};

    this.Init(Params);

    return this;
}

DpiPerformanceViewController.prototype.Init = function (Params)
{
    "use strict";
};

DpiPerformanceViewController.prototype.BindAll = function (Params)
{
    "use strict";
    var _this = this;

    this.Views.CpuUsGage = $$(this.Id + "CpuUsGage");
    this.Views.CpuSyGage = $$(this.Id + "CpuSyGage");
    this.Views.CpuIdGage = $$(this.Id + "CpuIdGage");
    this.Views.CpuFastdpiGage = $$(this.Id + "CpuFastdpiGage");
    this.Views.MemFastDpiGage = $$(this.Id + "MemFastDpiGage");
    this.Views.CpuMemGage = $$(this.Id + "CpuMemGage");
    this.Views.CpuSwapGage = $$(this.Id + "CpuSwapGage");
    this.Views.CpusChart = $$(this.Id + "CpusChart");
    this.Views.CpusCoresChart = $$(this.Id + "CpusCoresChart");
    this.Views.CpusCoresFastdpiChart = $$(this.Id + "CpusCoresFastdpiChart");
    this.Views.CpusCoresBarChart = $$(this.Id + "CpusCoresBarChart");
    this.Views.MemChart = $$(this.Id + "MemChart");
    this.Views.TopProcesses = $$(this.Id + "TopProcesses");

    this.Views.PeriodType = $$(this.Id + "PeriodType");
    this.Views.UnitsCombo = $$(this.Id + "UnitsCombo");
    this.Views.CpusStatChart = $$(this.Id + "CpusStatChart");
    this.Views.MemStatChart = $$(this.Id + "MemStatChart");
    this.Views.CpusCoresStatChart = $$(this.Id + "CpusCoresStatChart");
    this.Views.StatsDevicesTable = $$(this.Id + "StatsDevicesTable");

    this.Views.StatsAccordion = $$(this.Id + "Tabs"+"Stats"+"Accordion");

    Object.keys(this.Views.Widgets).forEach(Key => {
       this.Views.Widgets[Key].Bind(this);
    });

    this.Views.Widgets.DateRangePicker.SetValue(null, true);

    if(this.NatTabEnabled)
    {
        this.Views.NatFullPoolUsage = $$(this.Id + "NatFullPoolUsage");
        this.Views.NatPoolUsage = $$(this.Id + "NatPoolUsage");

        this.Views.NatAddressPerformanceTable = $$(this.Id + "NatAddressPerformanceTable");
        this.Views.NatAddressPerformanceTablePaging = $$(this.Id + "NatAddressPerformanceTable" + "Paging");
        this.Views.NatAddressPerformanceTablePagingSize = $$(this.Id + "NatAddressPerformanceTable" + "Paging" + "Size");
    }

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    Object.keys(this.Views.HttpStatChart).forEach(function (Key)
    {
        _this.Views.HttpStatChart[Key] = $$(_this.Id + Key);
    });

    this.Subscriptions.ResourcesUsageTicksUpdated = this.ViewModel.SignalResourcesUsageTicksUpdated.subscribe(function (ResourcesUsageTicksUpdated)
    {
        if (ResourcesUsageTicksUpdated)
        {
            _this.DefineForms();
        }
    });

    this.Subscriptions.ResourcesStatsUsageTicksUpdated = this.ViewModel.SignalResourcesStatsUsageTicksUpdated.subscribe(function (ResourcesStatsUsageTicksUpdated)
    {
        if (ResourcesStatsUsageTicksUpdated)
        {
            _this.DefineStatsForms();
        }
    });

    this.Subscriptions.HardwareDevicesStatsUpdated = this.ViewModel.SignalHardwareDevicesStatsUpdated.subscribe(function(Val){
        if(Val)
        {
            _this.DefineHardwareDevicesStats();
        }
    });

    if(this.NatTabEnabled)
    {
        this.Subscriptions.FullNatPerformanceUpdated = this.ViewModel.SignalFullNatPerformanceUpdated.subscribe(function(Updated)
        {
            if(Updated)
            {
                _this.DefineFullNatPerformanceChart();
            }
        });

        this.Subscriptions.PoolNatPerformanceUpdated = this.ViewModel.SingalPoolNatPerformanceUpdated.subscribe(function(Updated)
        {
            if(Updated)
            {
                _this.DefinePoolNatPerformanceChart();
            }
        });

        this.Subscriptions.NatAddressPerformanceUpdated = this.ViewModel.SignalNatAddressPerformanceUpdated.subscribe(function(Updated)
        {
            if(Updated)
            {
                _this.DefineNatAddressPerformance();
            }
        });
    }


    if(this.mode == "dpiui2")
    {
        if(this.Id === this.IdsEnum.UlrIgwNodePerformance)
        {
            var hwId = App.NavRouter.GetPathParam("_id", this);

            if(hwId)
            {
                App.SessionManager.SetCurrentHardwareId(hwId);
                App.SessionManager.CurrentHardwareConnected.next(1);
            }

            this.Views.ReportsWidgets.IgwsNodesSelectReport.RefreshData();
        }
        else
        {
            this.Subscriptions.HardwareConnected = App.SessionManager.CurrentHardwareConnected.subscribe(function (CurrentHardwareConnected)
            {
                _this.HardwareConnectedSubscription(CurrentHardwareConnected);
            });
        }


        if(this.NatTabEnabled)
        {
            this.Subscriptions.HardwareChanged = App.SessionManager.CurrentHardwareId.subscribe(function(Val){
                if(Val)
                {
                    _this.RefreshFullNatPerformance();
                    _this.RefreshPoolNatPerformance();
                    _this.RefreshNatAddressPerformance();

                    App.DicsManager.Refresh({data: [DicsEnum.CgNatProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});
                }
            });

            this.Subscriptions.CgNatDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.CgNatProfilesDic].subscribe(function(Val)
            {
                if(Val)
                {
                    var columnName = "profile_ids";
                    var column = _this.Views.NatAddressPerformanceTable.getColumnConfig(columnName);

                    if(column)
                    {
                        column.header[1].options = [];
                        _this.Views.NatAddressPerformanceTable.refreshColumns();
                        column.header[1].options = _this.GetCgNatProfileOptions();


                        var state = _this.Views.NatAddressPerformanceTable.getState();
                        var resultArr = [];
                        if(state.filter && state.filter[columnName])
                        {
                            var arr = state.filter[columnName].split(",");
                            arr.forEach(function(Val)
                            {

                                var index = column.header[1].options.findIndex(function(obj){
                                    return obj.id == Val;
                                });

                                if(index > -1)
                                {
                                    resultArr.push(Val);
                                }
                            });

                            column.header[1].value = resultArr.join(",");
                        }


                        _this.Views.NatAddressPerformanceTable.refreshColumns();
                        _this.Views.NatAddressPerformanceTable.refresh();
                    }
                }
            });
        }
    }

    if(this.mode == "li")
    {
        this.Subscriptions.SignalHealthUpdatedSubscription = this.Health.HealthUpdated.subscribe(function (Updated)
        {
            if (Updated)
            {
                _this.HealthResult();
            }
        });
    }

    this.Views.PeriodType.attachEvent("onChange", function(PeriodType)
    {
        _this.RefreshStats();
    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
       if(Signal)
       {
           _this.RefreshStats();
       }
    });

    this.SetDefaultChartUnitIfEmpty();

    if(this.Views.ReportsWidgets.IgwsNodesSelectReport)
    {
        this.Subscriptions.IgwsNodesSelectReportDataSignalSubscription = this.Views.ReportsWidgets.IgwsNodesSelectReport.GetReportConfig().signal.subscribe(function (Updated)
        {
            if(Updated)
            {
                var table = _this.Views.ReportsWidgets.IgwsNodesSelectReport.Views.Table;

                var hwId = parseInt(App.SessionManager.GetCurrentHardwareId());

                if(hwId)
                {
                    var data = table.find(function(Obj)
                    {
                        return parseInt(Obj.hardware_id) === hwId;
                    });
                }

                if(data && Array.isArray(data) && data.length)
                {
                    table.select(data[0].id);
                }
                else
                {
                    var first = table.getFirstId();

                    if(first)
                        table.select(first);
                }

                if(table.serialize().length)
                {
                    if(!_this.Subscriptions.HardwareConnected)
                    {
                        _this.Subscriptions.HardwareConnected = App.SessionManager.CurrentHardwareConnected.subscribe(function (CurrentHardwareConnected)
                        {
                            _this.HardwareConnectedSubscription(CurrentHardwareConnected);
                        });
                    }
                }
            }
        });

        var table = _this.Views.ReportsWidgets.IgwsNodesSelectReport.Views.Table;

        table.attachEvent("onAfterSelect", function(Selection, Preserve)
        {
            var table = this;

            var data = table.getItem(Selection);

            var hwId = data&&data.hardware_id ? data.hardware_id : 0;

            App.SessionManager.SetCurrentHardwareId(hwId);
            App.SessionManager.CurrentHardwareConnected.next(1);
        });

    }

    if(SkinHelper.GetSkin() !== SkinHelper.GetDefaultFilterUiSkin())
    {
        this.Subscriptions.DscpClassSerieSelectedSignal = this.Signals.DscpClassSerieSelected.subscribe(function (Signal)
        {
            if (Signal)
            {
                _this.RefreshConfigInfo();
            }
        });

        this.Subscriptions.DscpClassSerieSelectedAndConfigUpdatedSignal = Rx.Observable.combineLatest
        (
            this.Signals.DscpClassSerieSelected,
            this.ViewModel.SignalConfigInfoUpdated
        ).subscribe(function (Val) {
                var serieSelected = Val[0];
                var configInfoUpdated = Val[1];

                if (serieSelected && configInfoUpdated)
                {
                    _this.ShowWrongConfigInfoIfNeeded();
                }
            }
        );
    }

};

DpiPerformanceViewController.prototype.ViewDidLoad = function (Params)
{
    "use strict";
    var _this = this;

    this.PathParams = Params;

    if(this.Id === this.IdsEnum.DpiPerformance)
    {
        webix.ready(function () {
            $$(_this.Id + "LeftSideBar").select("DpiPerformance");
        });
    }

    if(this.NatTabEnabled)
        this.NatStatusView.ViewDidLoad(Params);

    this.BindAll(Params);

    if(this.mode == "li")
    {
        this.CheckHealth();
    }
};

DpiPerformanceViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if(this.NatTabEnabled)
    {
        this.NatStatusView.Destroy();
        delete this.NatStatusView;
    }

};

DpiPerformanceViewController.prototype.DefineForms = function ()
{
    this.DefineGages();

    this.Views.TopProcesses.clearAll();
    this.Views.TopProcesses.parse(this.ViewModel.GetLastTickTopProcesses());
};

DpiPerformanceViewController.prototype.DefineGages = function ()
{
    var _this = this;
    var lastTick = this.ViewModel.GetLastTick();
    var lastFastdpiTick = this.ViewModel.GetFastdpiPorocessUsageLastTick();
    var cpuTicks = this.ViewModel.GetCpusTicks();
    var memTicks = this.ViewModel.GetMemTicks();
    var cpuCoresTicks = this.ViewModel.GetCpusCoresTicks();

    this.Views.CpuUsGage.setValue(lastTick ? lastTick.cpus_usage.us : 0);
    this.Views.CpuSyGage.setValue(lastTick ? lastTick.cpus_usage.sy : 0);
    this.Views.CpuIdGage.setValue(lastTick ? lastTick.cpus_usage.idle : 0);

    this.Views.CpuFastdpiGage.setValue(lastFastdpiTick ? lastFastdpiTick.cpus_usage : 0);
    this.Views.MemFastDpiGage.setValue(lastFastdpiTick ? lastFastdpiTick.mem_usage : 0);

    this.Views.CpuMemGage.setValue(lastTick ? Math.round(lastTick.mem_usage.used / lastTick.mem_usage.total * 1000) / 10 : 0);
    this.Views.CpuSwapGage.setValue(lastTick ? Math.round(lastTick.swap_usage.used / lastTick.swap_usage.total * 1000) / 10 : 0);

    var cpusCoresBarChartVals = lastTick && lastTick.cpus_cores_usage && Helper.ObjectValues(lastTick.cpus_cores_usage) ? Helper.ObjectValues(lastTick.cpus_cores_usage) : [];

    cpusCoresBarChartVals.every(function (Val, Index)
    {
        if(typeof Val !== 'object')
        {
            cpusCoresBarChartVals.splice(Index,1);
            return false;
        }
        return true;
    });
    this.Views.CpusCoresBarChart.clearAll();
    this.Views.CpusCoresBarChart.parse(cpusCoresBarChartVals);

    this.Views.CpusChart.clearAll();
    this.Views.CpusChart.parse(cpuTicks && cpuTicks.length ? cpuTicks : []);

    this.CpusCoresChartSeriesConfig(lastTick);
    this.CpusCoresChartSeriesConfig(lastTick,true);

    this.Views.CpusCoresChart.clearAll();
    this.Views.CpusCoresChart.parse(cpuCoresTicks && cpuCoresTicks.length ? cpuCoresTicks : []);

    this.Views.CpusCoresFastdpiChart.clearAll();
    this.Views.CpusCoresFastdpiChart.parse(cpuCoresTicks && cpuCoresTicks.length ? cpuCoresTicks : []);

    this.Views.MemChart.clearAll();
    this.Views.MemChart.parse(memTicks && memTicks.length ? memTicks : []);
};

DpiPerformanceViewController.prototype.DefineStatsForms = function ()
{
    this.DefineStatsCharts();
};

DpiPerformanceViewController.prototype.DefineHardwareDevicesStats = function ()
{
    var data = this.ViewModel.GetDevicesStats();

    this.Views.StatsDevicesTable.clearAll();
    this.Views.StatsDevicesTable.parse(data);
    this.Views.StatsDevicesTable.openAll();
};

DpiPerformanceViewController.prototype.DefineStatsCharts = function ()
{
    var _this = this;

    var cpuStatsTicks = this.ViewModel.GetStatCpusTicks();
    var cpuCoresStatsTicks = this.ViewModel.GetStatCpusCoresTicks();

    var cpuStatsLastTick = cpuStatsTicks.length ? cpuStatsTicks[cpuStatsTicks.length-1]:null;

    this.ChartsStep = Math.round(cpuStatsTicks.length / 3);
    if(this.ChartsStep < 5)
        this.ChartsStep = 5;

    this.Views.CpusStatChart.clearAll();
    this.Views.CpusStatChart.parse(cpuStatsTicks);

    this.CpusCoresChartSeriesConfig(cpuStatsLastTick,false,true);

    this.Views.CpusCoresStatChart.clearAll();
    this.Views.CpusCoresStatChart.parse(cpuCoresStatsTicks);

    var memStatsTicks = this.ViewModel.GetMemStatsTicks();
    this.Views.MemStatChart.clearAll();
    this.Views.MemStatChart.parse(memStatsTicks);

    this.DefineDnaStatCharts();

    // var dna0StatsTicks = this.ViewModel.GetDnaStatsTicks({cluster:"1", dna:"0", inOut:"in"});
    // this.Views.DnaStatCharts["1"]["0"].clearAll();
    // this.Views.DnaStatCharts["1"]["0"].parse(dna0StatsTicks);
    //
    // var dna1StatsTicks = this.ViewModel.GetDnaStatsTicks({cluster:"1", dna:"1", inOut:"out"});
    // this.Views.DnaStatCharts["1"]["1"].clearAll();
    // this.Views.DnaStatCharts["1"]["1"].parse(dna1StatsTicks);

    var httpStatsTicks = this.ViewModel.GetStatHttpTicks();

    Object.keys(this.Views.HttpStatChart).forEach(function (Key)
    {
        _this.Views.HttpStatChart[Key].clearAll();
        _this.Views.HttpStatChart[Key].parse(httpStatsTicks);
    });
};

DpiPerformanceViewController.prototype.RefreshStats = function ()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(period && period.start && period.end)
    {
        var datesDiff = Math.abs(period.end.getTime() - period.start.getTime());
        var diffDays = Math.ceil(datesDiff / (1000 * 3600 * 24));

        var periodType = this.Views.PeriodType.getValue();

        if(diffDays > 30 && (periodType != "m" || periodType != "d"))
            this.Views.PeriodType.setValue("d");
        else if(diffDays > 2 && periodType == "i")
            this.Views.PeriodType.setValue("H");

        periodType = this.Views.PeriodType.getValue();

        var periodType = this.Views.PeriodType.getValue();

        var format =  webix.Date.dateToStr("%Y-%m-%dT%H:%i:%s");

        this.ViewModel.RefreshStats({period: {start:format(period.start), end:format(period.end)}, periodType:periodType});
    }
};

DpiPerformanceViewController.prototype.RefreshDevicesStatus = function()
{
    this.ViewModel.RefreshDevicesStats();
};

DpiPerformanceViewController.prototype.HttpStatChartConfig = function (Series,Locked)
{
    var _this = this;

    var id = "Http"+(Locked?"Lock":"")+"StatChart";

    var colors = Helper.DictToArr(ColorsDic);

    var series = function () {
        var arr = [];

        Series.forEach(function (Serie,Index) {
            arr.push({
                value: "#act_"+Serie+(Locked?"_lock":"")+"#",
                color: colors[Index+4].value,
                alpha:0.7,
                tooltip: {
                    template: function(Obj){return Serie+(Locked?" lock":"")+": "+Math.round(Obj["act_"+Serie+(Locked?"_lock":"")]*10)/10;}
                }
            });

        });

        return arr;
    };

    var legends = function () {
        var arr = [];

        Series.forEach(function (Serie,Index) {

            arr.push({text: Serie+(Locked?" lock":""), color: colors[Index+4].value});

        });

        return arr;

    };

    this.Views.HttpStatChart[id] = null;

    var config = {
        view: "chart",
        id:this.Id + id,
        type:"splineArea",
        xAxis: {
            lines:false,
            template:function(obj)
            {
                var chart = $$(_this.Id + id);
                return obj.index%chart.xAxisStep == 0 ? Helper.FormatDateTimeForChartXAxes(obj.date) : "";
            },
            lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
            color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
        },
        yAxis: {
            template: function (Val)
            {
                return Helper.ConvertToKMG(Val);
            },
            lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
            color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
        },
        legend: {
            values: legends(),
            valign: "middle",
            align: "right",
            width: 120,
            layout: "y"
        },
        series: series(),
        data:[],
        on:{
            onBeforeRender:function (data)
            {
                var chart = $$(_this.Id + id);

                chart.xAxisStep = 2;

                if(data.length && chart.$width)
                {
                    var l = data.length;

                    var w = this.$width;

                    for (var i = 1; i <= 20; i++)
                    {
                        if(w/l*chart.xAxisStep >= 120)
                        {
                            break;
                        }

                        chart.xAxisStep++;
                    }
                }

                return true;
            }
        }
    };

    return config;
};

DpiPerformanceViewController.prototype.DnaStatChartUnitPrefixToNumeric = function(Val)
{
    var unitId = parseInt(this.GetChartUnitValue());

    var value = Val * ChartSettingsUnitsFactorDic[unitId];
    var divider = ChartSettingsUnitsDividersDic[unitId];
    var dic = ChartSettingsUnitsDictionariesDic[unitId];

    return Helper.UnitPrefixToNumeric(value, divider, dic);
};

DpiPerformanceViewController.prototype.DnaStatChartConfig = function (Cluster, Dna,DevInOut)
{
    var _this = this;

    var id = Cluster+""+Dna+""+DevInOut+"StatChart";

    this.Views.DnaStatCharts[id] = null;
    this.Views.DnaStatChartsLegends[id+"Legend"] = null;

    this.xAxisStep = 4;

    this.xAxisIndex = 0;

    var seriesLegendData = function () {
        var index = 0, l = [], colorIndex = 0, colors = Helper.DictToArr(ColorsDic), mainColors = ["#aed581", "#ba68c8", "#d84315"];

        var nextColor = function () {
            var color = colors[colorIndex].value;
            colorIndex++;

            if (colorIndex > colors.length - 1)
                colorIndex = 0;

            if(mainColors.indexOf(color) >= 0)
                return nextColor();

            return color;
        };

        var unitId = _this.GetChartUnitValue();

        l.push({id:"act_rcvd_"+ChartSettingsUnitsSuffixesDic[unitId], legend: LangHelper.GetString("DpiPerformance", "Received"), color: mainColors[0], enabled: 1, index: index++});
        l.push({id:"act_send_"+ChartSettingsUnitsSuffixesDic[unitId], legend: LangHelper.GetString("DpiPerformance", "Sent"), color: mainColors[1], enabled: 1, index: index++});

        if(unitId != "1") {
            l.push({id:"act_drop_"+ChartSettingsUnitsSuffixesDic[unitId], legend: LangHelper.GetString("DpiPerformance", "Dropped"), color: mainColors[2], enabled: 1, index: index++});
        }

        for (var i = 0; i <= 7; i++) {
            l.push({
                id:"dscp_cs"+i+"_act_rcvd_"+ChartSettingsUnitsSuffixesDic[unitId],
                legend: "CS" + i + " " + LangHelper.GetString("DpiPerformance", "Received").toLocaleLowerCase(),
                color: nextColor(),
                index: index++
            });
            l.push({
                id:"dscp_cs"+i+"_act_send_"+ChartSettingsUnitsSuffixesDic[unitId],
                legend: "CS" + i + " " + LangHelper.GetString("DpiPerformance", "Sent").toLocaleLowerCase(),
                color: nextColor(),
                index: index++
            });

            if(unitId != "1") {
                l.push({
                    id:"dscp_cs"+i+"_act_drop_"+ChartSettingsUnitsSuffixesDic[unitId],
                    legend: "CS" + i + " " + LangHelper.GetString("DpiPerformance", "Dropped").toLocaleLowerCase(),
                    color: nextColor(),
                    index: index++
                });
            }
        }

        return l;
    }();

    var config = {
        cols:[
            {
                view: "chart",
                id:this.Id + id,
                type:"splineArea",
                alpha:0.7,
                padding:{left:120},
                xAxis: {
                    lines:false,
                    template:function(obj)
                    {
                        var chart = $$(_this.Id + id);
                        return obj.index%chart.xAxisStep == 0 ? Helper.FormatDateTimeForChartXAxes(obj.date) : "";
                    },
                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                },
                yAxis: {
                    template: function (Val)
                    {
                        return _this.DnaStatChartUnitPrefixToNumeric(Val);
                        //return Helper.ConvertToKMG(Val);
                    },
                    lineColor: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.lineColor : undefined,
                    color: typeof SkinHelper != "undefined" && SkinHelper.GetChartStyle() ? SkinHelper.GetChartStyle().xAxis.color : undefined
                },
                // legend: {
                //     values: function (){
                //         var l = [
                //             {text: LangHelper.GetString("DpiPerformance", "Received"), color: "#aed581"},
                //             {text: LangHelper.GetString("DpiPerformance", "Sent"), color: "#ba68c8"}
                //         ];
                //
                //         var colorIndex = 0;
                //
                //         var colors = Helper.DictToArr(ColorsDic);
                //
                //         var nextColor = function ()
                //         {
                //             var color = colors[colorIndex].value;
                //             colorIndex++;
                //
                //             if(colorIndex > colors.length - 1)
                //                 colorIndex = 0;
                //
                //             return color;
                //         }
                //
                //         for(var i = 0; i <= 7; i++)
                //         {
                //             l.push({text: "CS" + i + " " + LangHelper.GetString("DpiPerformance", "Received").toLocaleLowerCase(), color: nextColor()});
                //             l.push({text: "CS" + i + " " + LangHelper.GetString("DpiPerformance", "Sent").toLocaleLowerCase(), color: nextColor()});
                //         }
                //
                //         return l;
                //     }(),
                //     valign: "middle",
                //     align: "right",
                //     width: 160,
                //     layout: "y"
                // },
                series: function ()
                {
                    var s = [];

                    seriesLegendData.forEach(function (Item)
                    {
                        s.push(
                            {
                                value: "#"+Item.id+"#",
                                color: Item.color,
                                tooltip:
                                    {
                                        template: function(Obj)
                                        {
                                            return Item.legend + ": "+_this.DnaStatChartUnitPrefixToNumeric(Obj[Item.id]);
                                        }
                                    }
                            }
                        );
                    });

                    return s;
                }(),
                _series: function (){
                    var unitId = parseInt(_this.GetChartUnitValue());

                    var s = [
                        {
                            value: "#act_rcvd_"+ChartSettingsUnitsSuffixesDic[unitId]+"#",
                            color: "#aed581",
                            tooltip:
                                {
                                    template: function(Obj)
                                    {
                                        return LangHelper.GetString(_this.Id, "Received") + ": "+_this.DnaStatChartUnitPrefixToNumeric(Obj["act_rcvd_"+ChartSettingsUnitsSuffixesDic[unitId]]);
                                    }
                                }
                        },
                        {
                            value: "#act_send_"+ChartSettingsUnitsSuffixesDic[unitId]+"#",
                            color: "#ba68c8",
                            tooltip:
                                {
                                    template: function(Obj)
                                    {
                                        return LangHelper.GetString(_this.Id, "Sent") + ": "+_this.DnaStatChartUnitPrefixToNumeric(Obj["act_send_"+ChartSettingsUnitsSuffixesDic[unitId]]);
                                    }
                                }
                        }
                    ];

                    if(unitId != "1") {
                        s.push({
                            value: "#act_drop_"+ChartSettingsUnitsSuffixesDic[unitId]+"#",
                            color: "#d84315",
                            tooltip:
                            {
                                template: function(Obj)
                                {
                                    return LangHelper.GetString(_this.Id, "Dropped") + ": "+_this.DnaStatChartUnitPrefixToNumeric(Obj["act_drop_"+ChartSettingsUnitsSuffixesDic[unitId]]);
                                }
                            }
                        });
                    }

                    var colorIndex = 0;

                    var colors = Helper.DictToArr(ColorsDic);

                    var nextColor = function ()
                    {
                        var color = colors[colorIndex].value;
                        colorIndex++;

                        if(colorIndex > colors.length - 1)
                            colorIndex = 0;

                        return color;
                    }

                    for(var i = 0; i <= 7; i++)
                    {
                        s.push({
                            value: "#dscp_cs"+i+"_act_rcvd_"+ChartSettingsUnitsSuffixesDic[unitId]+"#",
                            color: nextColor(),
                            tooltip:
                                {
                                    template: function(Obj)
                                    {
                                        return "CS" + i + " " + LangHelper.GetString(_this.Id, "Received") + ": "+_this.DnaStatChartUnitPrefixToNumeric(Obj["dscp_cs"+i+"_act_rcvd_"+ChartSettingsUnitsSuffixesDic[unitId]]);
                                    }
                                }
                        });
                        s.push({
                            value: "#dscp_cs"+i+"_act_send_"+ChartSettingsUnitsSuffixesDic[unitId]+"#",
                            color: nextColor(),
                            tooltip:
                                {
                                    template: function(Obj)
                                    {
                                        return "CS" + i + " " + LangHelper.GetString(_this.Id, "Sent") + ": "+_this.DnaStatChartUnitPrefixToNumeric(Obj["dscp_cs"+i+"_act_send_"+ChartSettingsUnitsSuffixesDic[unitId]]);
                                    }
                                }
                        });

                        if(unitId != "1") {
                            s.push({
                               value: "#dscp_cs"+i+"_act_drop_"+ChartSettingsUnitsSuffixesDic[unitId]+"#",
                               color: nextColor(),
                               tooltip:
                                   {
                                       template: function(Obj)
                                       {
                                            return "CS" + i + " " + LangHelper.GetString(_this.Id, "Dropped") + ": "+_this.DnaStatChartUnitPrefixToNumeric(Obj["dscp_cs"+i+"_act_drop_"+ChartSettingsUnitsSuffixesDic[unitId]]);
                                       }
                                   }
                            });
                        }
                    }

                    return s;
                }(),
                data:[],
                on:{
                    onBeforeRender:function (data)
                    {
                        var chart = $$(_this.Id + id);

                        chart.xAxisStep = 2;

                        if(data.length && chart.$width)
                        {
                            var l = data.length;

                            var w = this.$width;

                            for (var i = 1; i <= 20; i++)
                            {
                                if(w/l*chart.xAxisStep >= 120)
                                {
                                    break;
                                }

                                chart.xAxisStep++;
                            }
                        }

                        return true;
                    },
                    "onViewShow": function(){
                        _this.RefreshChartsSeriesVisibility(id);
                    }
                }
            },
            {
                view:"datatable",
                id:this.Id + id + "Legend",
                width:160,
                checkboxRefresh:true,
                columns:[
                    {
                        id:"enabled",
                        header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:this.Id + id + "Legend"+"MasterCheckBox" }],
                        template: CellColoredCheckBoxTemplate,
                        width:SkinHelper.GetSkin() === SkinHelper.GetDefaultFilterUiSkin() ? 40 :32
                    },
                    {
                        id:"legend",
                        header:["Legend"],
                        fillspace:1
                    }
                ],
                data: seriesLegendData,
                on:{
                    "onCheck": function(Id, Column, State)
                    {
                        if(Column == "enabled")
                        {
                            var item = this.getItem(Id);

                            try
                            {
                                var view = $$(_this.Id + id);

                                if(State)
                                    view.showSeries(item.index);
                                else
                                    view.hideSeries(item.index);
                                
                                if(Id.indexOf("dscp_cs") === 0 && State)
                                {
                                    _this.ViewModel.SignalConfigInfoUpdated.next(0);
                                    _this.Signals.DscpClassSerieSelected.next(1);
                                }
                            }
                            catch(e)
                            {
                                item.enabled = 1;
                            }
                        }
                    }
                }
            }
        ]
    };

    return config;
};

DpiPerformanceViewController.prototype.DnaStatAccordionConfig = function (Cluster)
{
    var _this = this;

    var cluster = _this.DnasInfo[Cluster];

    var id = "Dna"+(cluster.in?cluster.in:"")+"-"+(cluster.out?cluster.out:"")+"StatChartAi";

    this.Views.StatsAccordionDnasItems[id] = null;

    var config = {
        view:"accordionitem",
        header:LangHelper.GetString("DpiPerformance", "Network interfaces")+" "+"in:"+(cluster.in?cluster.in:"")+" - "+"out:"+(cluster.out?cluster.out:""),
        id:this.Id + id,
        collapsed:true,
        body:{
            cols:[
                {
                    width:80,
                    type:"clean",
                    rows:[
                        DnaIfTemplate({if_title:""+(cluster.in?cluster.in:""), dev_in_out:"in"}),
                        DnaIfTemplate({if_title:""+(cluster.out?cluster.out:""), dev_in_out:"out"})
                    ]
                },
                {
                    rows:[
                        {
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "Traffic on the interface")+" "+"in:"+(cluster.in?cluster.in:""), icon: "area-chart"}),
                                this.DnaStatChartConfig(Cluster,cluster.in,"in")
                            ]
                        },
                        {view:"resizer"},
                        {
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiPerformance", "Traffic on the interface")+" "+"out:"+(cluster.out?cluster.out:""), icon: "area-chart"}),
                                this.DnaStatChartConfig(Cluster,cluster.out,"out")
                            ]
                        }
                    ]
                }
            ]
        }
    };

    return config;
};

DpiPerformanceViewController.prototype.CheckHealth = function()
{
    this.Health.Refresh({dpi_server: 1});
};

DpiPerformanceViewController.prototype.HealthResult = function()
{
    var health = this.Health.GetHealth();

    if(health.dpi_server)
    {
        if(!health.dpi_server.success)
            webix.message({text:LangHelper.GetString("AppView","Performance") + "<br/><br/>" + health.dpi_server.error.msg + "<br/><br/>" + LangHelper.GetString("Health","Verify services health"), type:"error", expire: 300000});

        if(health.dpi_server.success)
        {
            this.ViewModel.Reset();
            this.ViewModel.Refresh();
            this.RefreshStats();
            this.RefreshDevicesStatus();
        }
    }
};

DpiPerformanceViewController.prototype.CpusCoresChartSeriesConfig = function (LastTick,Fastdpi,Stat)
{
    var cpus_cores_usage_key = Stat ? "cpus_usage" : "cpus_cores_usage";

    var cpus_count = LastTick && LastTick[cpus_cores_usage_key] && Helper.ObjectValues(LastTick[cpus_cores_usage_key]) ? Helper.ObjectValues(LastTick[cpus_cores_usage_key]).length : 0;

    if(Stat)
        cpus_count = LastTick && Helper.ObjectValues(LastTick) ? Helper.ObjectValues(LastTick).length - 2 : 0;

    if(!LastTick)
        cpus_count = -100;

    var view = this.Views["CpusCores"+(Fastdpi?"Fastdpi":"")+(Stat?"Stat":"")+"Chart"];

    if(view.cpus_count != cpus_count)
    {
        view.removeAllSeries();

        var legend = {
            values: [],
            valign: "middle",
            align: "right",
            width: Fastdpi?100:90,
            layout: "y"
        };

        var series = [];

        var colors = Helper.DictToArr(ColorsDic);

        if(LastTick && ((!Stat && LastTick[cpus_cores_usage_key] && Helper.ObjectValues(LastTick[cpus_cores_usage_key])) || (Stat && Helper.ObjectValues(LastTick))))
        {
            var colorIndex = 0;

            Object.keys((Stat ? LastTick : LastTick[cpus_cores_usage_key])).forEach(function (Key)
            {
                if(Key == "index" || Key == "date" || Key == "id")
                    return;

                series.push({
                    value: function (Obj)
                    {
                        var k = Fastdpi?"fastdpi":"all";
                        return Obj[Key]&&Obj[Key][k]?Obj[Key][k]:0;
                    },
                    text:Key+(Fastdpi?"_fastdpi":""),
                    color:colors[colorIndex].value,
                    alpha:0.7,
                    line:{
                        color:colors[colorIndex].value
                    },
                    item:{
                        radius:0
                    },
                    tooltip: {
                        template:  function (Obj)
                        {
                            var k = Fastdpi?"fastdpi":"all";
                            return Key+(Fastdpi?"_fastdpi":"")+ ": " + (Obj[Key]&&Obj[Key][k]?Obj[Key][k]:0) + "%";
                        }
                    }
                });

                colorIndex++;

                if(!colors[colorIndex])
                    colorIndex = 0;
            });

            series.forEach(function (Serie)
            {
                view.addSeries(Serie);
            });

            legend.values = series;

            view.define("legend", legend);


        }

        view.cpus_count = cpus_count;
        view.refresh();
    }
};

DpiPerformanceViewController.prototype.RefreshFullNatPerformance = function()
{
    var params = {
        data: {
            hardware_id: App.SessionManager.GetCurrentHardwareId()
        }
    }

    this.ViewModel.RefreshFullNatPerformance(params);
};

DpiPerformanceViewController.prototype.DefineFullNatPerformanceChart = function()
{
  var _this = this;
  var data = this.ViewModel.GetFullNatPerformance();
  var view = this.Views.NatFullPoolUsage;

  view.clearAll();
  view.parse(data);
};

DpiPerformanceViewController.prototype.RefreshPoolNatPerformance = function()
{
    var params = {
        data: {
            hardware_id: App.SessionManager.GetCurrentHardwareId()
        }
    }

    this.ViewModel.RefreshPoolNatPerformance(params);
};

DpiPerformanceViewController.prototype.DefinePoolNatPerformanceChart = function()
{
    var _this = this;
    var data = this.ViewModel.GetPoolNatPerformance();
    var view = this.Views.NatPoolUsage;

    view.clearAll();
    view.parse(data);
};

DpiPerformanceViewController.prototype.RefreshNatAddressPerformance = function(Page)
{
    var _this = this;

    var state = this.Views.NatAddressPerformanceTable.getState();

    var size = this.Views.NatAddressPerformanceTablePagingSize.getValue();

    var params = {
        page:Page,
        filter:state.filter,
        size:size,
        sort:state.sort ? state.sort:null,
        callback:function () {}
    };

    this.ViewModel.RefreshNatAddressPerformance(params);
};

DpiPerformanceViewController.prototype.DefineNatAddressPerformance = function()
{
    var _this = this;
    this.Views.NatAddressPerformanceTable.clearAll();
    this.Views.NatAddressPerformanceTable.parse(_this.ViewModel.GetNatAddressPerformance());

    this.Views.NatAddressPerformanceTablePagingSize.setValue(this.ViewModel.NatAddressPerformanceFilter.total.size);

    this.Views.NatAddressPerformanceTablePaging.define(this.ViewModel.NatAddressPerformanceFilter.total);
    this.Views.NatAddressPerformanceTablePaging.refresh();
};

DpiPerformanceViewController.prototype.GetCgNatProfileOptions = function()
{
    var _this = this;

    var options = [
        // {value:LangHelper.GetString(_this.Id, "No profile"), id: "0", dic_id: "0"}
    ];

    var dicEnum = ServicesDicsEnum[ServicesEnum.cgnat];

    if(dicEnum)
    {
        options = options.concat(Helper.DictToArr(App.DicsManager.GetDic(dicEnum)));
    }
    return options;
};

DpiPerformanceViewController.prototype.ExportToExcel = function()
{
    var _this = this;


    var table = this.Views.NatAddressPerformanceTable;

    webix.toExcel(table, {
        filename: "nat_address_performance",
        filterHTML:true
    });
};

DpiPerformanceViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

DpiPerformanceViewController.prototype.HardwareConnectedSubscription = function (CurrentHardwareConnected)
{
    if (CurrentHardwareConnected)
    {
        this.ViewModel.Reset();
        this.ViewModel.Refresh();
        this.RefreshStats();
        this.RefreshDevicesStatus();
    }
    else
    {
        this.ViewModel.Reset();
        this.DefineForms();
        this.DefineStatsForms();
        this.DefineHardwareDevicesStats();
    }
};

DpiPerformanceViewController.prototype.RefreshChartsSeriesVisibility = function (ViewId)
{
    var _this = this;

    Object.keys(_this.Views.DnaStatCharts).forEach(function (Key)
    {
        if(ViewId)
        {
            if(ViewId != Key)
                return;
        }

        var viewLegend = _this.Views.DnaStatChartsLegends[Key+"Legend"], view = _this.Views.DnaStatCharts[Key];

        if(view && viewLegend)
        {
            var data = viewLegend.serialize();

            data.forEach(function (Item){
                try
                {
                    Item.enabled ? view.showSeries(Item.index) : view.hideSeries(Item.index);
                }
                catch(e)
                {

                }
            });
        }
    });
};

DpiPerformanceViewController.prototype.RefreshConfigInfo = function ()
{
    this.ViewModel.RefreshConfigInfo();
};

DpiPerformanceViewController.prototype.ShowWrongConfigInfoIfNeeded = function ()
{
    var config = this.ViewModel.GetConfigInfo(), hwId = this.ViewModel.GetCurrentHardwareId();

    if(this.WrongConfigInfoShowed[hwId])
        return;

    this.WrongConfigInfoShowed[hwId] = true;

    if(config && config.dbg_log_mask && (config.dbg_log_mask & "0x04"))
        return ;

    var popup = webix.ui({
                view:"popup",
                modal:true,
                width:620,
                height:240,
                position:"center",
                body:{
                    view:"form",
                    borderless:true,
                    elements:[
                        {
                            template:LangHelper.GetString("DpiPerformance", "For the correct display of traffic graphs by class, you need in the Configuration section")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("DpiPerformance", "Ok"),
                                    click:function ()
                                    {
                                        popup.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    type:"form",
                                    label:LangHelper.GetString("DpiPerformance", "Open the Configuration section"),
                                    gravity:3,
                                    click:function ()
                                    {
                                        popup.hide();
                                        App.NavRouter.PresentView({id: ControllersEnum.DpiConfig});
                                    }
                                }
                            ]
                        }
                    ]
                }
            });

    popup.show();
};

DpiPerformanceViewController.prototype.SetDefaultChartUnitIfEmpty = function ()
{
    var unitId = this.GetChartUnitValue();
    if(!unitId) {
        this.SetChartUnitValue("1");
    }
    unitId = this.GetChartUnitValue();
    this.Views.UnitsCombo.setValue(unitId);
};

DpiPerformanceViewController.prototype.GetChartUnitValue = function ()
{
    return webix.storage.local.get(this.Id + "SelectedChartUnitId" + App.SessionManager.currentLogin);
};

DpiPerformanceViewController.prototype.SetChartUnitValue = function (Value)
{
    webix.storage.local.put(this.Id + "SelectedChartUnitId" + App.SessionManager.currentLogin, Value);
};

DpiPerformanceViewController.prototype.ShowChartSettingsForm = function (Node, Pos)
{
    this.SetDefaultChartUnitIfEmpty();
    this.ChartSettingsContext.show(Node, Pos);
};

DpiPerformanceViewController.prototype.DefineDnaStatCharts = function (SetNewUnit)
{
    var _this = this;

    var dnasInfo = this.ViewModel.GetStatClusterDnaInfo();

    var removeAllDnasAccordionItems = function ()
    {
        Object.keys(_this.Views.StatsAccordionDnasItems).forEach(function (Key)
        {
            if(_this.Views.StatsAccordionDnasItems[Key])
            {
                _this.Views.StatsAccordionDnasItems[Key].collapse();

                _this.Views.StatsAccordion.removeView(_this.Id + Key);

                delete _this.Views.StatsAccordionDnasItems[Key];
            }
        });
    };

    if(dnasInfo)
    {
        if(JSON.stringify(this.DnasInfo) != JSON.stringify(dnasInfo) || SetNewUnit)
        {
            var t1 = JSON.stringify(this.DnasInfo);
            var t2 = JSON.stringify(dnasInfo);

            this.DnasInfo = dnasInfo;

            removeAllDnasAccordionItems();

            Object.keys(this.DnasInfo).sort().forEach(function (Cluster)
            {
                var cluster = _this.DnasInfo[Cluster];

                if(cluster.in || cluster.out)
                {
                    _this.Views.StatsAccordion.addView(_this.DnaStatAccordionConfig(Cluster));
                }
            });

            Object.keys(_this.Views.StatsAccordionDnasItems).forEach(function (Key)
            {
                _this.Views.StatsAccordionDnasItems[Key] = $$(_this.Id + Key);
            });

            Object.keys(_this.Views.DnaStatChartsLegends).forEach(function (Key)
            {
                _this.Views.DnaStatChartsLegends[Key] = $$(_this.Id + Key);
            });

            Object.keys(_this.Views.DnaStatCharts).forEach(function (Key)
            {
                _this.Views.DnaStatCharts[Key] = $$(_this.Id + Key);
            });
        }

        Object.keys(this.DnasInfo).sort().forEach(function (Key)
        {
            try
            {
                var cluster = Key;
                var dnas = _this.DnasInfo[Key];

                if(_this.Views.DnaStatCharts[cluster+""+dnas.in+"in"+"StatChart"])
                {
                    var dnaInStatsTicks = _this.ViewModel.GetDnaStatsTicks({cluster:cluster, dna:dnas.in, inOut:"in", inOutIndex:dnas.in_index});
                    _this.Views.DnaStatCharts[cluster+""+dnas.in+"in"+"StatChart"].clearAll();

                    if(dnaInStatsTicks)
                        _this.Views.DnaStatCharts[cluster+""+dnas.in+"in"+"StatChart"].parse(dnaInStatsTicks);

                }

                if(_this.Views.DnaStatCharts[cluster+""+dnas.out+"out"+"StatChart"])
                {
                    var dnaOutStatsTicks = _this.ViewModel.GetDnaStatsTicks({cluster:cluster, dna:dnas.out, inOut:"out", inOutIndex:dnas.out_index});

                    _this.Views.DnaStatCharts[cluster+""+dnas.out+"out"+"StatChart"].clearAll();

                    if(dnaOutStatsTicks)
                        _this.Views.DnaStatCharts[cluster+""+dnas.out+"out"+"StatChart"].parse(dnaOutStatsTicks);
                }
            }
            catch(Err) {}
        });
    }
    else
    {
        removeAllDnasAccordionItems();
        this.DnasInfo = null;
    }
};
/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */

function UsersViewModel()
{
    var _this = this;

    this.Users = [];

    this.UsersUpdated = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};

    this.Subscriptions.UsersSubscription = App.UserManager.UsersUpdated.subscribe(function (value)
    {
        var usersUpdated = value;

        if (usersUpdated)
        {
            _this.Users = App.UserManager.GetUsers();
            _this.UsersUpdated.next(1);
        }
    });

    this.Subscriptions.DicsSubscription = App.DicsManager.DicsUpdated.subscribe(function (value)
    {
        var dicsUpdated = value;

        if (dicsUpdated)
        {
            _this.Refresh();
        }
    });
}

UsersViewModel.prototype.Save = function (Params)
{
    App.UserManager.SaveUsers(Params);
}

UsersViewModel.prototype.Refresh = function (Params)
{
    App.UserManager.Refresh();
}

function UsersViewController(Params) {
    "use strict";
    var _this = this;

    this.Id = "Users";

    this.ViewModel = new UsersViewModel();

    this.UserDeleteContextRowId = 0;

    this.UserDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id, "Are you sure you want to delete the user?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id, "Cancel"),
                            click:function () {
                                _this.UserDeleteContext.hide();
                                _this.UserDeleteContextRowId = 0;
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id, "Delete"),
                            click:function () {
                                _this.UserDeleteContext.hide();
                                _this.DeleteTableRow(_this.UserDeleteContextRowId);
                                _this.UserDeleteContextRowId = 0;
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.UsersTableContext = null;

    this.UsersTableForm = null;

    this.UsersTableFormPassword = null;

    this.UsersTableFormConfig = {
        view: "popup",
        id:this.Id+"UsersTable"+"Context",
        width:400,
        relative:"right",
        modal:true,
        body: {
            rows:[
                {
                    view: "form",
                    id:this.Id+"UsersTable"+"Context"+"Form",
                    borderless:true,
                    elements:[
                        {
                            view: "text",
                            name: "username",
                            label: LangHelper.GetString(this.Id, "User name"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString(this.Id, "Enter user name"),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            view: "text",
                            name: "name",
                            label: LangHelper.GetString(this.Id, "Full name"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString(this.Id, "Enter full name"),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            view: "text",
                            name: "email",
                            label: "E-mail",
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString(this.Id, "Enter e-mail"),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            view: "text",
                            name: "phone",
                            label: LangHelper.GetString(this.Id, "Phone"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString(this.Id, "Enter phone number"),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            view: "text",
                            name: "company",
                            label: LangHelper.GetString(this.Id, "Company"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString(this.Id, "Enter the name of the organization"),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            view: "text",
                            name: "position",
                            label: LangHelper.GetString(this.Id, "Position"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString(this.Id, "Enter the position"),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            view: "richselect",
                            name: "role",
                            label: LangHelper.GetString(this.Id, "Role"),
                            options:App.DicsManager.GetDicAsArray("RolesDic"),
                            labelPosition: "top"
                        }
                    ]
                },
                {
                    type: "clean",
                    height: 2,
                    borderless: true,
                    padding: 0,
                    marging: 0,
                    css: "app_header__border_bottom",
                    template: ""
                },
                {
                    view: "form",
                    id:this.Id+"UsersTable"+"Context"+"Form"+"Password",
                    borderless:true,
                    rules:{
                        $obj:function(data)
                        {
                            if (data.password_new_confirm != data.password_new){
                                webix.message({type:"error", text:LangHelper.GetString(this.Id, "Passwords do not match")});
                                return false;
                            }
                            return true;
                        }
                    },
                    elements:[
                        {
                            view: "text",
                            label: LangHelper.GetString(this.Id, "New password"),
                            name: "password_new",
                            type: "password",
                            tooltip:LangHelper.GetString(this.Id, "New password"),
                            "labelPosition": "top",
                            invalidMessage: LangHelper.GetString(this.Id, "Enter password"),
                            validate: webix.rules.isNotEmpty,
                            attributes:{maxlength:30}
                        },
                        {
                            view: "text",
                            label: LangHelper.GetString(this.Id, "Confirm password"),
                            name: "password_new_confirm",
                            type: "password",
                            tooltip: LangHelper.GetString(this.Id, "Confirm password"),
                            "labelPosition": "top",
                            invalidMessage: LangHelper.GetString(this.Id, "Enter password"),
                            validate: webix.rules.isNotEmpty,
                            attributes:{maxlength:30}
                        },
                        {
                            cols:[
                                {},
                                { view:"button", value:LangHelper.GetString("All", "Cancel"), click:function () {_this.UsersTableContext.hide();}},
                                { view:"button", value:LangHelper.GetString("All", "Save"), type:"form", click:function () {
                                        if(_this.UsersTableForm.validate())
                                        {
                                            var passwordFormVals = _this.UsersTableFormPassword.getValues();
                                            if(passwordFormVals.password_new || passwordFormVals.password_new_confirm)
                                            {
                                                if (_this.UsersTableFormPassword.validate())
                                                {
                                                    var formVals = _this.UsersTableForm.getValues();
                                                    formVals.password = passwordFormVals.password_new;

                                                    _this.UsersTableContext.hide();
                                                    _this.UsersTableForm.save(formVals);
                                                }
                                            }
                                            else
                                            {
                                                _this.UsersTableContext.hide();
                                                _this.UsersTableForm.save();
                                            }

                                            _this.UsersTableFormPassword.clear();
                                            _this.UsersTableFormPassword.clearValidation();

                                            _this.UsersTableForm.clear();
                                            _this.UsersTableForm.clearValidation();
                                        }
                                    }}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ViewConfig = [
        {
            cols: [
                AdministratorLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clean",
                            borderless: true,
                            rows:[
                                PageHeaderTemplate({root_title:LangHelper.GetString("AppView", "Managing users and roles"), title:LangHelper.GetString("AppView", "Users")}),
                                {
                                    rows:[
                                        {
                                            view: "toolbar",
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "plus",
                                                    css:"toolbar_round_btn",
                                                    width:32,
                                                    tooltip:LangHelper.GetString(this.Id, "Add user"),
                                                    click:function ()
                                                    {
                                                        var model = new UserModel();

                                                        _this.UsersTable.add(model);

                                                        _this.UsersTable.select(model.id, false);
                                                        _this.UsersTable.editCell(model.id, "edit", true, true);
                                                    }
                                                },
                                                {},
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString(_this.Id, "Refresh"),
                                                    click: function (id, e, node) {
                                                        _this.ViewModel.Refresh();
                                                    }
                                                }
                                            ]
                                        },
                                        BlockHeaderTemplate({title:LangHelper.GetString(this.Id, "Users"), icon:"users"}),
                                        {
                                            view: "datatable",
                                            id:this.Id+"UsersTable",
                                            editable: true,
                                            editaction: "custom",
                                            select: "row",
                                            on: {
                                                onItemDblClick: function(id){
                                                    this.editCell(id);
                                                },
                                                onItemClick: function (id)
                                                {
                                                    if(id.column === 'edit')
                                                    {
                                                        this.editCell(id);
                                                    }
                                                    else if(id.column === 'trash')
                                                    {
                                                        var __this = this;

                                                        var data = _this.UsersTable.getItem(id);

                                                        if(!data.user_id)
                                                        {
                                                            _this.DeleteTableRow(id);
                                                            return;
                                                        }

                                                        setTimeout(function () {
                                                            var node = __this.getItemNode(id);
                                                            _this.UserDeleteContextRowId = id;
                                                            _this.UserDeleteContext.show(node, {pos:"bottom"});
                                                        }, 10);
                                                    }
                                                }
                                            },
                                            form:this.Id+"UsersTable"+"Context"+"Form",
                                            columns: [
                                                {
                                                    id: "edit",
                                                    header: "",
                                                    width: 40,
                                                    template: CellEditBtnTemplate,
                                                    headermenu: false
                                                },
                                                {
                                                    id: "username",
                                                    header: [LangHelper.GetString(this.Id, "User name"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                    editor:"text",
                                                    fillspace: true
                                                },
                                                {
                                                    id: "name",
                                                    header: [LangHelper.GetString(this.Id, "Full name"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                    editor:"text",
                                                    fillspace: true
                                                },
                                                {
                                                    id: "email",
                                                    header: ["E-mail",{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                    editor:"text",
                                                    fillspace: true
                                                },
                                                {
                                                    id: "phone",
                                                    header: [LangHelper.GetString(this.Id, "Phone"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                    editor:"text",
                                                    fillspace: true
                                                },
                                                {
                                                    id: "company",
                                                    header: [LangHelper.GetString(this.Id, "Company"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                    editor:"text",
                                                    fillspace: true
                                                },
                                                {
                                                    id: "position",
                                                    header: [LangHelper.GetString(this.Id, "Position"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                    editor:"text",
                                                    fillspace: true
                                                },
                                                {
                                                    id: "role",
                                                    header: [LangHelper.GetString(this.Id, "Role"), {
                                                        content: "multiSelectFilter",
                                                        options: App.DicsManager.GetDicAsArray("RolesDic"),
                                                        inputConfig: {suggest: {fitMaster: false}}
                                                    }],
                                                    fillspace: true,
                                                    editor: "multiselect",
                                                    options: App.DicsManager.GetDicAsArray("RolesDic"),
                                                    template: function (obj)
                                                    {
                                                        var rolesIds = obj.role.split(",");
                                                        var rolesStr = "";

                                                        rolesIds.forEach(function (RoleId, i)
                                                        {
                                                            if(App.DicsManager.GetDic("RolesDic")[RoleId])
                                                            {
                                                                if(i>0)
                                                                {
                                                                    rolesStr += ",";
                                                                }

                                                                rolesStr += App.DicsManager.GetDic("RolesDic")[RoleId].value;
                                                            }
                                                        });

                                                        return rolesStr;
                                                    }
                                                },
                                                {
                                                    id: "trash",
                                                    header: "",
                                                    width: 40,
                                                    template: CellTrashBtnTemplate,
                                                    headermenu: false
                                                }
                                            ],
                                            rules:{
                                                "valid":function (value) {
                                                    return value;
                                                }
                                            },
                                            data:[]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.UsersTable = null;

    this.Init(Params);

    return this;
}

UsersViewController.prototype.Init = function (Params) {
    "use strict";
};

UsersViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);
};

UsersViewController.prototype.BindAll = function (Params) {
    "use strict";
    var _this = this;

    this.UsersTable = $$(this.Id+"UsersTable");

    this.UsersTableContext = webix.ui(this.UsersTableFormConfig);
    this.UsersTableForm = $$(this.Id+"UsersTable"+"Context"+"Form");
    this.UsersTableForm.bind(this.Id+"UsersTable");
    this.UsersTableFormPassword = $$(this.Id+"UsersTable"+"Context"+"Form"+"Password");
    this.UsersTableFormPassword.bind(this.Id+"UsersTable");

    this.ViewModel.Subscriptions.UsersUpdatedSubscription = this.ViewModel.UsersUpdated.subscribe(function (value) {
        var usersUpdated = value;

        if (usersUpdated)
        {
            _this.UpdateTable();
        }
    });

    this.UsersTable.attachEvent("onDataUpdate", function(id, data){
        _this.SaveTableRow(id);
        return true;
    });
};

UsersViewController.prototype.UpdateTable = function (Params) {
    "use strict";
    var _this = this;

    // var xxx = this.UsersTable.getColumnConfig("role");
    // debugger
    //this.UsersTable.getColumnConfig("role").options = App.DicsManager.GetDicAsArray("RolesDic");
    this.UsersTable.getColumnConfig("role").header[1].options = App.DicsManager.GetDicAsArray("RolesDic");

    this.UsersTableForm.elements.role.getList().clearAll();
    this.UsersTableForm.elements.role.getList().parse(App.DicsManager.GetDicAsArrayWithEmpty("RolesDic"));

    this.UsersTable.clearAll();
    this.UsersTable.parse(this.ViewModel.Users);
};

UsersViewController.prototype.SaveTableRow = function (RowId) {
    "use strict";
    var _this = this;

    var data = this.UsersTable.getItem(RowId);
    data.valid = true;

    var isValid = this.UsersTable.validate(RowId);

    if(isValid)
    {
        this.ViewModel.Save({data:[data], callback:function (R)
        {
            if(R.success)
            {
                data.user_id = R.data.user_id;

                webix.message(LangHelper.GetString(this.Id, "Saved"));
            }
            else
            {
                data.valid = false;
                _this.UsersTable.validate(RowId);
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
    }

    delete data.password;
};

UsersViewController.prototype.DeleteTableRow = function (RowId) {
    "use strict";
    var _this = this;

    var data = this.UsersTable.getItem(RowId);
    data.valid = true;
    data.action = UserModelActionsEnum.delete;

    if(data.user_id > 0)
    {
        this.ViewModel.Save({data:[data], callback:function (R)
        {
            if(R.success)
            {
                _this.UsersTable.remove(RowId);
                webix.message(LangHelper.GetString(this.Id, "Deleted"));
            }
            else
            {
                data.valid = false;
                _this.UsersTable.validate(RowId);
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
    }
    else
    {
        this.UsersTable.remove(RowId);
    }
};

UsersViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.ViewModel.Subscriptions).forEach(function (key)
    {
        _this.ViewModel.Subscriptions[key].unsubscribe();
    });
};
/* global App */
/* global webix */
/* global App */
/* global $$ */
/* global Helper */

function RolesViewModel()
{
    var _this = this;

    this.Roles = [];

    this.RolesUpdated = new Rx.BehaviorSubject(0);

    this.RoleManager = new RolesManager();

    this.RoleManager.Refresh();

    this.Subscriptions = {};

    this.Subscriptions.RolesSubscription = this.RoleManager.RolesUpdated.subscribe(function (value) {
        var rolesUpdated = value;

        if (rolesUpdated)
        {
            _this.Roles = _this.RoleManager.GetRoles();
            _this.RolesUpdated.next(1);
        }
    });
}

RolesViewModel.prototype.Save = function (Params)
{
    this.RoleManager.SaveRoles(Params);
};

RolesViewModel.prototype.Refresh = function (Params)
{
    this.RoleManager.Refresh();
};

function RolesViewController(Params)
{
    "use strict";
    var _this = this;

    this.Id = "Roles";

    this.ViewModel = new RolesViewModel();

    this.RoleDeleteContextRowId = 0;

    this.RoleDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id, "Are you sure you want to delete the role?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id, "Cancel"),
                            click:function () {
                                _this.RoleDeleteContext.hide();
                                _this.RoleDeleteContextRowId = 0;
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id, "Delete"),
                            click:function () {
                                _this.RoleDeleteContext.hide();
                                _this.DeleteTableRow(_this.RoleDeleteContextRowId);
                                _this.RoleDeleteContextRowId = 0;
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols: [
                AdministratorLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clean",
                            borderless: true,
                            rows:[
                                PageHeaderTemplate({root_title:LangHelper.GetString("AppView", "Managing users and roles"),title:LangHelper.GetString(this.Id, "Roles")}),
                                {
                                    cols:[
                                        {
                                            width:320,
                                            rows:[
                                                {
                                                    view: "toolbar",
                                                    elements: [
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "plus",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            tooltip:LangHelper.GetString(this.Id, "Add role"),
                                                            click:function ()
                                                            {
                                                                _this.RolesTable.add(new RoleModel(),0);
                                                            }
                                                        },
                                                        {
                                                            view: "button",
                                                            id:this.Id + "CopyRoleBtn",
                                                            type: "icon",
                                                            icon: "file-plus",
                                                            align: "right",
                                                            width: 32,
                                                            css:"toolbar_round_btn",
                                                            tooltip:LangHelper.GetString("QoE","Copy role"),
                                                            click: function (id, e, node)
                                                            {
                                                                _this.CreateRoleFromCopy();
                                                            }
                                                        },
                                                        {},
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "refresh",
                                                            css: "toolbar_round_btn",
                                                            width: 32,
                                                            tooltip: LangHelper.GetString(_this.Id, "Refresh"),
                                                            click: function (id, e, node) {
                                                                _this.ViewModel.Refresh();
                                                            }
                                                        }
                                                    ]
                                                },
                                                BlockHeaderTemplate({title:LangHelper.GetString(this.Id, "Roles"), icon:"user-secret"}),
                                                {
                                                    view: "datatable",
                                                    id:this.Id+"RolesTable",
                                                    editable: true,
                                                    editaction: "custom",
                                                    select: "row",
                                                    on: {
                                                        onItemDblClick: function(id){
                                                            this.editRow(id);
                                                        },
                                                        onItemClick: function (id)
                                                        {
                                                            if(id.column === 'edit')
                                                            {
                                                                this.editRow(id);
                                                            }
                                                            else if(id.column === 'trash')
                                                            {
                                                                var __this = this;

                                                                var data = _this.RolesTable.getItem(id);

                                                                if(!data.role_id)
                                                                {
                                                                    _this.DeleteTableRow(id);
                                                                    return;
                                                                }

                                                                setTimeout(function () {
                                                                    var node = __this.getItemNode(id);
                                                                    _this.RoleDeleteContextRowId = id;
                                                                    _this.RoleDeleteContext.show(node, {pos:"bottom"});
                                                                }, 10);
                                                            }
                                                        },
                                                        onAfterSelect:function (data)
                                                        {
                                                            _this.OnRolesTableRowSelect();
                                                        },
                                                        onAfterUnSelect:function (data)
                                                        {
                                                            _this.OnRolesTableRowUnSelect();
                                                        }
                                                    },
                                                    columns: [
                                                        {
                                                            id: "edit",
                                                            header: "",
                                                            width: 40,
                                                            template: CellEditBtnTemplate,
                                                            headermenu: false
                                                        },
                                                        {
                                                            id: "role",
                                                            header: [LangHelper.GetString(this.Id, "Role"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                            editor:"text",
                                                            fillspace: true
                                                        },
                                                        {
                                                            id: "trash",
                                                            header: "",
                                                            width: 40,
                                                            template: CellTrashBtnTemplate,
                                                            headermenu: false
                                                        }
                                                    ],
                                                    rules:{
                                                        "valid":function (value) {
                                                            return value;
                                                        }
                                                    },
                                                    data:[]
                                                }
                                            ]
                                        },
                                        {
                                            id:this.Id + "SectionsPanel",
                                            rows:[
                                                {
                                                    view: "toolbar",
                                                    elements: [
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "floppy-o",
                                                            label: LangHelper.GetString(this.Id, "Save"),
                                                            css: "toolbar_round_btn",
                                                            width: 128,
                                                            tooltip: LangHelper.GetString(this.Id, "Save"),
                                                            click: function (id, e, node)
                                                            {
                                                                _this.SaveSections();
                                                            }
                                                        }
                                                    ]
                                                },
                                                BlockHeaderTemplate({title:LangHelper.GetString(this.Id, "Program sections"), icon:"sitemap"}),
                                                {
                                                    view:"datatable",
                                                    id:this.Id+"SectionsTable",
                                                    borderless:false,
                                                    checkboxRefresh:true,
                                                    select: "row",
                                                    columns:[
                                                        {
                                                            id:"id",
                                                            header:LangHelper.GetString(this.Id, "Code"),
                                                            width:160
                                                        },
                                                        {
                                                            id:"value",
                                                            header:LangHelper.GetString(this.Id, "Section"),
                                                            fillspace:true
                                                        },
                                                        {
                                                            id:"read",
                                                            header:[LangHelper.GetString(this.Id, "Read"), {content:"masterCheckbox", css:"hcell_ckeckbox"}],
                                                            template: CellYesNoTemplate,
                                                            width: 120,
                                                            headermenu: false

                                                        },
                                                        {
                                                            id:"write",
                                                            header:[LangHelper.GetString(this.Id, "Record"), {content:"masterCheckbox", css:"hcell_ckeckbox"}],
                                                            template: CellYesNoTemplate,
                                                            width: 120,
                                                            headermenu: false

                                                        },
                                                        {
                                                            id:"params",
                                                            header:"",
                                                            template: function(obj, common, value)
                                                            {
                                                                return SectionsDic[obj.id] && SectionsDic[obj.id].params ? CellSettingsBtnTemplate() : "";
                                                            },
                                                            width: 32,
                                                            headermenu: false
                                                        }
                                                    ],
                                                    data:[],
                                                    on: {
                                                        onItemClick: function (id)
                                                        {
                                                            if(id.column === 'params')
                                                            {
                                                                if(SectionsDic[id.row] && SectionsDic[id.row].params)
                                                                {
                                                                    var __this = this;

                                                                    var node = __this.getItemNode(id);

                                                                    _this.ShowSectionParams(node,"left");
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.RolesTable = null;

    this.SectionsTable = null;

    this.SectionsPanel = null;

    this.CopyRoleBtn = null;

    this.SectionParams = {
        Context:null,
        Body:null,
        Config:{
            view: "popup",
            id:this.Id+"SectionParams"+"Context",
            width:480,
            relative:"right",
            modal:true,
            body: {
                rows:[
                    {
                        id:this.Id+"SectionParams"+"Context"+"Body",
                        rows:[]
                    },
                    {
                        view:"form",
                        borderless:true,
                        elements:[
                            {
                                cols:[
                                    {},
                                    {
                                        view:"button",
                                        label:LangHelper.GetString(this.Id, "Cancel"),
                                        click:function () {
                                            _this.HideSectionParams();
                                        }
                                    },
                                    {
                                        view:"button",
                                        type:"form",
                                        label:LangHelper.GetString(this.Id, "Apply"),
                                        click:function ()
                                        {
                                            _this.ApplySectionParams();
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    };

    this.Signals = {
        RolesTableRowsSelectedCount: new Rx.BehaviorSubject(0)
    };

    this.Subscriptions = {};

    return this;
}

RolesViewController.prototype.ViewDidLoad = function (Params)
{
    "use strict";
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);
};

RolesViewController.prototype.BindAll = function (Params)
{
    "use strict";
    var _this = this;

    this.RolesTable = $$(this.Id+"RolesTable");

    this.SectionsTable = $$(this.Id+"SectionsTable");

    this.SectionsPanel = $$(this.Id+"SectionsPanel");
    this.SectionsPanel.disable();

    this.SectionParams.Context = webix.ui(this.SectionParams.Config);
    this.SectionParams.Body = $$(this.Id+"SectionParams"+"Context"+"Body");

    this.CopyRoleBtn = $$(this.Id + "CopyRoleBtn");

    this.ViewModel.Subscriptions.RolesUpdatedSubscription = this.ViewModel.RolesUpdated.subscribe(function (value)
    {
        var rolesUpdated = value;

        if (rolesUpdated)
        {
            _this.UpdateTable();
            _this.UpdateSectionsTable();
        }
    });

    this.Subscriptions.RolesTableRowsSelectedCountSubscription = this.Signals.RolesTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.RolesTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.RolesTable.attachEvent("onAfterEditStop", function(state, editor, ignoreUpdate){
        if (ignoreUpdate){
            this.editCancel();
            return;
        } else {
            var max = this.config.columns.length;
            var now = this.getColumnIndex(editor.column);

            for (var i=now+1; i<max; i++)
                if (this.config.columns[i].editor)
                    return false;
        }

        _this.SaveTableRow(editor.row);

        return false;
    });

    this.RolesTable.attachEvent("onAfterSelect", function(data, preserve)
    {
        _this.UpdateSectionsTable();
    });
};

RolesViewController.prototype.UpdateTable = function (Params)
{
    "use strict";
    var _this = this;

    this.RolesTable.clearAll();
    this.RolesTable.parse(this.ViewModel.Roles);
};

RolesViewController.prototype.UpdateSectionsTable = function (Params)
{
    "use strict";
    var _this = this;

    var roleData = this.GetRolesTableSelectedData();

    if(!roleData || (roleData && !roleData.role_id))
    {
        this.SectionsPanel.disable();
    }
    else
    {
        this.SectionsPanel.enable();
    }

    this.SectionsTable.clearAll();
    this.SectionsTable.parse(this.GetSectionsData());
};

RolesViewController.prototype.SaveTableRow = function (RowId)
{
    "use strict";
    var _this = this;

    var data = this.RolesTable.getItem(RowId);
    data.valid = true;

    var isValid = this.RolesTable.validate(RowId);

    if(isValid)
    {
        this.ViewModel.Save({data:[data], callback:function (R)
        {
            if(R.success)
            {
                data.role_id = R.data.role_id;

                webix.message(LangHelper.GetString("All", "Saved"));

                App.DicsManager.Refresh({data:[DicsEnum.RolesDic]});

                _this.UpdateSectionsTable();
            }
            else
            {
                data.valid = false;
                _this.RolesTable.validate(RowId);
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
    }
};

RolesViewController.prototype.SaveSections = function ()
{
    var _this = this;

    var roleData = this.GetRolesTableSelectedData();

    if(roleData && roleData.id && roleData.role_id)
    {
        roleData.sections = this.GetSectionsSerializedData();

        roleData.params = this.GetSectionsParamsSerializedData();

        this.SaveTableRow(roleData.id);
    }
};

RolesViewController.prototype.DeleteTableRow = function (RowId)
{
    "use strict";
    var _this = this;

    var data = this.RolesTable.getItem(RowId);
    data.valid = true;
    data.action = RoleModelActionsEnum.delete;

    if(data.role_id > 0)
    {
        this.ViewModel.Save({data:[data], callback:function (R)
        {
            if(R.success)
            {
                _this.RolesTable.remove(RowId);
                webix.message(LangHelper.GetString("All", "Deleted"));

                App.DicsManager.Refresh({data:[DicsEnum.RolesDic]});

                _this.UpdateSectionsTable();
            }
            else
            {
                data.valid = false;
                _this.RolesTable.validate(RowId);
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
    }
    else
    {
        this.RolesTable.remove(RowId);
    }
};

RolesViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.ViewModel.Subscriptions).forEach(function (key)
    {
        _this.ViewModel.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

RolesViewController.prototype.GetSectionsData = function ()
{
    var data = [];

    var enabledSections = {};

    var row = function (Params)
    {
        this.id = Params&&Params.id?Params.id:0;
        this.value = Params&&Params.value?Params.value:'';
        this.read = Params&&Params.read?Params.read:0;
        this.write = Params&&Params.write?Params.write:0;
        this.params = Params&&Params.params?Params.params:null;
    };

    var roleData = this.GetRolesTableSelectedData();

    var sectionsParams = roleData && roleData.params && JSON.parse(roleData.params) ? JSON.parse(roleData.params) : {};

    if(roleData && roleData.sections)
    {
        var sectionsArr = roleData.sections.split(",");

        sectionsArr.forEach(function (Section)
        {
            if(Section)
            {
                var s = Section.split(".");

                if(s.length == 2)
                {
                    var key = s[0];
                    var val = s[1];

                    if(!enabledSections[key])
                    {
                        enabledSections[key] = new row();
                    }

                    if(val == "read")
                    {
                        enabledSections[key].read = 1;
                    }

                    if(val == "write")
                    {
                        enabledSections[key].write = 1;
                    }
                }

            }
        });
    }

    //Hide URL if no lic
    var hasUrlLic = App.SessionManager.HasUlrLic();

    //Hide Li if no lic
    var hasLiLic = App.SessionManager.HasLiLic();

    //Hide SITES_CLSFR if no lic
    var hasSitesClsfrLic = App.SessionManager.HasSitesClsfrLic();

    Helper.DictToArr(SectionsDic).forEach(function (Section)
    {
        if((Section.id.indexOf("ulr_") >=0 || Section.id == RoleSectionsEnum.ulr)  && !hasUrlLic)
            return;

        if((Section.id.indexOf("li_") >=0 || Section.id == RoleSectionsEnum.li)  && !hasLiLic)
            return;

        if((Section.id.indexOf("sites_clsfr_") >=0 || Section.id == RoleSectionsEnum.sites_clsfr)  && !hasSitesClsfrLic)
            return;

        var obj = new row(Section);

        if(enabledSections[obj.id])
        {
            obj.read = enabledSections[obj.id].read;
            obj.write = enabledSections[obj.id].write;
        }

        obj.params = sectionsParams[obj.id] ? sectionsParams[obj.id] : null;

        data.push(obj);
    });

    return data;
};

RolesViewController.prototype.GetSectionsSerializedData = function()
{
    var data = this.SectionsTable.serialize();
    var sections = "";

    data.forEach(function (Section)
    {
        if(Section.read)
            sections += ""+Section.id+".read,";

        if(Section.write)
            sections += ""+Section.id+".write,";
    });

    return sections;
};

RolesViewController.prototype.GetSectionsParamsSerializedData = function()
{
    var data = this.SectionsTable.serialize();
    var sectionsParams = {};

    data.forEach(function (Section)
    {
        if(Section.params)
            sectionsParams[Section.id] = Section.params;
    });

    return JSON.stringify(sectionsParams);
};

RolesViewController.prototype.GetRolesTableSelectedData = function ()
{
    return this.RolesTable.getSelectedItem();
};

RolesViewController.prototype.OnRolesTableRowSelect = function ()
{
    var data = this.GetRolesTableSelectedData();
    this.Signals.RolesTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

RolesViewController.prototype.OnRolesTableRowUnSelect = function ()
{
    var data = this.GetRolesTableSelectedData();
    this.Signals.RolesTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

RolesViewController.prototype.RolesTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    if(Value == 1)
        this.CopyRoleBtn.enable();
    else
        this.CopyRoleBtn.disable();
};

RolesViewController.prototype.GetSectionsTableSelectedData = function ()
{
    return this.SectionsTable.getSelectedItem();
};

RolesViewController.prototype.ShowSectionParams = function (Node, Pos)
{
    var data = this.GetSectionsTableSelectedData();

    if(!data)
        return;

    var form = this.FormParamsFromSectionsDic(data.id);
    this.SectionParams.Context.show(Node, {pos:Pos});
    this.SectionParams.Body.define("rows",[form]);
    this.SectionParams.Body.reconstruct();
    this.SectionParams.Form = $$(this.Id+"SectionParams"+"Context"+"Form");

    if(data.params)
        this.SectionParams.Form.setValues(data.params);
};

RolesViewController.prototype.ApplySectionParams = function ()
{
    var data = this.GetSectionsTableSelectedData();

    if(!data)
        return;

    if(this.SectionParams.Form.validate())
    {
        data.params = this.SectionParams.Form.getValues();
        this.HideSectionParams();
    }

};

RolesViewController.prototype.HideSectionParams = function ()
{
    this.SectionParams.Context.hide();
};

RolesViewController.prototype.ViewParamsFromSectionsDic = function (DicId, ParamId)
{
    var view = {}, hBtnView = null;

    var obj = SectionsDic[DicId].params[ParamId];

    view.view = obj.view?obj.view:"text";
    view.name = ParamId;
    view.label = obj.label ? TooltipTemplate(obj.label, obj.tooltip) : "";
    view.tooltip = obj.tooltip?obj.tooltip:"";
    view.placeholder = obj.placeholder?obj.placeholder:"";
    view.options = obj.options?Helper.DictToArr(obj.options):[];
    view.labelPosition = "top";
    view.invalidMessage = obj.invalidMessage?obj.invalidMessage:"";

    if(obj.validate)
        view.validate = obj.validate;

    if(obj.view === "label")
    {
        view = {};
        view.view = obj.view;
        view.label = obj.label ? obj.label : "";
    }

    if(obj.tooltip)
        hBtnView = {
            view: "button",
            type: "icon",
            icon: "question-circle",
            css:"toolbar_round_btn",
            width:32,
            popup:{
                view:"popup",
                body:{
                    borderless:true,
                    template:obj.tooltip
                }
            }
        };

    var viewEnabled = {
        view:"checkbox",
        name:ParamId+"_enabled",
        width:64,
        labelPosition:"top",
        label:LangHelper.GetString("All", "On")
    };

    view = hBtnView ? {cols:[view,hBtnView]} : view;


    return {cols:[viewEnabled,view]};
};

RolesViewController.prototype.FormParamsFromSectionsDic = function (DicId)
{
    var _this = this;

    var form =
    {
        view:"form",
        borderless:true,
        id:this.Id+"SectionParams"+"Context"+"Form",
        elements:[]
    };

    Object.keys(SectionsDic[DicId].params).forEach(function (Pk) {
        form.elements.push(_this.ViewParamsFromSectionsDic(DicId, Pk));
    });

    return form;
};

RolesViewController.prototype.CreateRoleFromCopy = function()
{
    var _this = this;

    var model =  new RoleModel(webix.copy(this.GetRolesTableSelectedData()));

    model.id = webix.uid();
    model.role_id = 0;
    model.role = LangHelper.GetString(this.Id, "New role");

    _this.RolesTable.add(model,0);

    _this.RolesTable.select(model.id, false);
    _this.RolesTable.editRow(model.id);
};

function HardwaresViewController(Params)
{
    var _this = this;

    this.Id = "Hardwares";

    this.ViewModel = new HardwaresManager();

    this.HardwareDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Do you really want to delete the equipment?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function () {
                                _this.HardwareDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Delete"),
                            click:function () {
                                _this.HardwareDeleteContext.hide();
                                _this.DeleteTableSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HardwareSyncVersionContext = webix.ui({
        view:"popup",
        width:400,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Do you really want to sync tool version for the equipment?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function () {
                                _this.HardwareSyncVersionContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            width: 160,
                            label:LangHelper.GetString(_this.Id, "Sync"),
                            click:function () {
                                _this.HardwareSyncVersionContext.hide();
                                _this.SyncToolVersionForSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HardwareEditFormContext = new HardwareEditFormViewController();

    this.HardwareStateContext = new HardwareStateViewController();

    this.ViewConfig = [
        {
            cols: [
                AdministratorLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                PageHeaderTemplate({root_title:LangHelper.GetString(_this.Id, "Hardware Management"),title:LangHelper.GetString(_this.Id, "Equipment")}),
                                {
                                    rows:[
                                        {
                                            view: "toolbar",
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "plus",
                                                    css:"toolbar_round_btn",
                                                    width:32,
                                                    tooltip:LangHelper.GetString(_this.Id, "Add equipment"),
                                                    click:function ()
                                                    {
                                                        var model = new HardwareModel({
                                                            sudocheck: 1,
                                                            enable_subs_sync: 1,
                                                            enable_logs_sync: 1,
                                                            enable_cgnat_sync: 1
                                                        });

                                                        _this.HardwaresTable.add(model);

                                                        _this.HardwaresTable.select(model.id, false);
                                                        _this.HardwaresTable.showItem(model.id);

                                                        _this.HardwareEditFormContext.SetData(model);
                                                        _this.HardwareEditFormContext.Show(_this.HardwaresTable.getItemNode(model.id), "right");
                                                    }
                                                },
                                                {},
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString(_this.Id, "Refresh"),
                                                    click: function (id, e, node) {
                                                        _this.ViewModel.Refresh();
                                                    }
                                                }
                                            ]
                                        },
                                        BlockHeaderTemplate({title:LangHelper.GetString(_this.Id, "Equipment"), icon:"server"}),
                                        {
                                            view: "datatable",
                                            id:this.Id + "HardwaresTable",
                                            select: "row",
                                            tooltip:true,
                                            on: {
                                                onItemDblClick: function(id)
                                                {
                                                    this.select(id); //reset if multiple rows selected

                                                    var rowData = this.getItem(id);

                                                    _this.HardwareEditFormContext.SetData(rowData);
                                                    _this.HardwareEditFormContext.Show(this.getItemNode(rowData.id), "right");
                                                },
                                                onItemClick: function (id)
                                                {
                                                    var rowData = this.getItem(id);

                                                    if(id.column === 'edit')
                                                    {
                                                        _this.HardwareEditFormContext.SetData(rowData);
                                                        _this.HardwareEditFormContext.Show(this.getItemNode(rowData.id), "right");
                                                    }
                                                    else if(id.column === 'trash')
                                                    {
                                                        var __this = this;

                                                        var data = _this.HardwaresTable.getItem(id);

                                                        if(!data.hardware_id)
                                                        {
                                                            _this.DeleteTableRow(id);
                                                            return;
                                                        }

                                                        setTimeout(function () {
                                                            var node = __this.getItemNode(id);
                                                            _this.HardwareDeleteContext.show(node, {pos:"bottom"});
                                                        }, 10);
                                                    }
                                                    else if(id.column === 'sync_version')
                                                    {
                                                        var __this = this;

                                                        var data = _this.HardwaresTable.getItem(id);

                                                        if(!data.hardware_id || data.hardware_type != HardwareTypesDic.dpi.id)
                                                        {
                                                            return;
                                                        }

                                                        setTimeout(function () {
                                                            var node = __this.getItemNode(id);
                                                            _this.HardwareSyncVersionContext.show(node, {pos:"bottom"});
                                                        }, 10);
                                                    }
                                                    else if(id.column === 'state')
                                                    {
                                                        _this.HardwareStateContext.SetData(rowData);
                                                        var node = this.getItemNode(id);
                                                        _this.HardwareStateContext.Show(node, "right");
                                                    }
                                                    else if (id.column === 'copy')
                                                    {
                                                        var model = new HardwareModel({
                                                            sudocheck: 1,
                                                            enable_subs_sync: 1,
                                                            enable_logs_sync: 1,
                                                            enable_cgnat_sync: 1
                                                        });

                                                        var rowDataModel = new HardwareModel(rowData);
                                                        rowDataModel.hardware_id = 0;
                                                        rowDataModel.copy_hardware_id = rowData.hardware_id;

                                                        _this.HardwaresTable.add(model);

                                                        _this.HardwaresTable.select(model.id, false);
                                                        _this.HardwaresTable.showItem(model.id);

                                                        _this.HardwareEditFormContext.SetData(rowDataModel);
                                                        _this.HardwareEditFormContext.Show(this.getItemNode(model.id), "right");
                                                    }
                                                }
                                            },
                                            columns: function(){
                                                var res = [
                                                    {
                                                        id: "edit",
                                                        header: "",
                                                        width: 40,
                                                        template: CellEditBtnTemplate,
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "copy",
                                                        header: "",
                                                        width: 40,
                                                        template: function(Obj)
                                                        {
                                                            if (Obj.hardware_id)
                                                                return CellCopyBtnTemplate();

                                                            return "";
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "hardware_id",
                                                        header: [LangHelper.GetString(_this.Id, "ID"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        editor:"text",
                                                        fillspace: false
                                                    },
                                                    {
                                                        id: "name",
                                                        header: [LangHelper.GetString(_this.Id, "Name"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        editor:"text",
                                                        fillspace: true
                                                    },
                                                    {
                                                        id: "hardware_type",
                                                        header: [LangHelper.GetString(_this.Id, "Type"),{
                                                            content: "multiSelectFilter",
                                                            options: Helper.DictToArr(HardwareTypesDic),
                                                            inputConfig: {suggest: {fitMaster: false}}
                                                        }],
                                                        editor:"text",
                                                        template:function(Obj)
                                                        {
                                                            return HardwareTypesDic[Obj.hardware_type] ? HardwareTypesDic[Obj.hardware_type].value : Obj.hardware_type;
                                                        },
                                                        fillspace: true
                                                    },
                                                    {
                                                        id: "tool_version",
                                                        header: [LangHelper.GetString(_this.Id, "Version"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        editor:"text",
                                                        width: 120,
                                                        template:function(Obj)
                                                        {
                                                            if(Obj.hardware_type == HardwareTypesDic.dpi.id && Obj.hardware_id)
                                                            {
                                                                return Obj.tool_version;
                                                            }
                                                            return "";
                                                        }
                                                    },
                                                    {
                                                        id: "ip",
                                                        header: [LangHelper.GetString(_this.Id, "Host"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        editor:"text",
                                                        fillspace: true
                                                    },
                                                    {
                                                        id: "port",
                                                        header: [LangHelper.GetString(_this.Id, "Port"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        editor:"text",
                                                        fillspace: true
                                                    },
                                                    {
                                                        id: "login",
                                                        header: [LangHelper.GetString(_this.Id, "Login"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        editor:"text",
                                                        fillspace: true
                                                    },
                                                    {
                                                        id: "ipfix_id",
                                                        header: [LangHelper.GetString(_this.Id, "IPFIX ID"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        editor:"text",
                                                        fillspace: true
                                                    },
                                                    {
                                                        id: "state",
                                                        header: "",
                                                        width: 40,
                                                        headermenu: false,
                                                        tooltip: LangHelper.GetString(_this.Id, "Hardware state"),
                                                        template: CellThermBtnTemplate
                                                    }
                                                ];

                                                if(window.module == 'dpiui2')
                                                {

                                                    res.push({
                                                        id: "sync_version",
                                                        header: "",
                                                        width: 40,
                                                        headermenu: false,
                                                        tooltip: LangHelper.GetString(_this.Id, "Sync tool version"),
                                                        template: function(Obj){
                                                            if(Obj.hardware_type == HardwareTypesDic.dpi.id)
                                                            {
                                                                return CellCodeBranchBtnTemplate();
                                                            }
                                                            return "";
                                                        }
                                                    });


                                                }

                                                res.push({
                                                    id: "trash",
                                                        header: "",
                                                    width: 40,
                                                    template: CellTrashBtnTemplate,
                                                    headermenu: false
                                                });

                                                return res;
                                            }() ,
                                            rules:{
                                                "valid":function (value) {
                                                    return value;
                                                }
                                            },
                                            data:[]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.HardwaresTable = null;

    this.Subscriptions = {};

    this.Init(Params);

    return this;
}

HardwaresViewController.prototype.Init = function (Params)
{
};

HardwaresViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    this.HardwareEditFormContext.Destroy();
    this.HardwareStateContext.Destroy();
};

HardwaresViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.HardwareEditFormContext.ViewDidLoad();
    this.HardwareStateContext.ViewDidLoad();

    this.BindAll(Params);

    this.ViewModel.Refresh();
};

HardwaresViewController.prototype.BindAll = function (Params) {
    var _this = this;

    this.HardwaresTable = $$(this.Id+"HardwaresTable");

    this.Subscriptions.HardwaresUpdated = this.ViewModel.HardwaresUpdated.subscribe(function (value) {
        var harswareUpdated = value;

        if (harswareUpdated)
        {
            _this.UpdateTable();
        }
    });

    this.Subscriptions.SavedSignal = this.HardwareEditFormContext.Signals.Saved.subscribe(function (Data)
    {
        if(Data)
        {
            var data = _this.GetTableSelectedData();

            _this.HardwaresTable.updateItem(data.id,  Data);
        }
    });
};

HardwaresViewController.prototype.UpdateTable = function (Params) {
    "use strict";
    var _this = this;

    this.HardwaresTable.clearAll();
    this.HardwaresTable.parse(this.ViewModel.Hardwares);
};

HardwaresViewController.prototype.GetTableSelectedData = function ()
{
    return this.HardwaresTable.getSelectedItem();
};

HardwaresViewController.prototype.DeleteTableRow = function (RowId)
{
    var _this = this;

    var data = this.HardwaresTable.getItem(RowId);
    data.valid = true;

    if(data.hardware_id > 0)
    {
        this.ViewModel.DeleteHardware(data, function (R)
            {
                if(R.success)
                {
                    _this.HardwaresTable.remove(RowId);

                    webix.message(LangHelper.GetString(_this.Id,"Deleted"));

                    App.DicsManager.Refresh({data:[DicsEnum.HardwaresDic]});
                }
                else
                {
                    data.valid = false;
                    _this.HardwaresTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }
        );
    }
    else
    {
        this.HardwaresTable.remove(RowId);
    }
};

HardwaresViewController.prototype.DeleteTableSelectedRows = function ()
{
    var _this = this;

    var selectedRows = this.GetTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    selectedRows.forEach(function (Row)
    {
        _this.DeleteTableRow(Row.id);
    });
};

HardwaresViewController.prototype.SyncToolVersionForSelectedRows = function ()
{
    var _this = this;

    var selectedRows = this.GetTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    selectedRows.forEach(function (Row)
    {
        _this.ViewModel.SyncHardwareToolVersion(Row, function(R){
            if(R && R.success)
            {
                _this.HardwaresTable.updateItem(Row.id,  R.data);
                webix.message(LangHelper.GetString(_this.Id,"Tool version successfully synced"));
            }
            else
            {
                Row.valid = false;
                _this.HardwaresTable.validate(Row.id);
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        });
    });
};
function HardwareEditFormViewController(Params)
{
    var _this = this;

    this.Id = "HardwareEditForm" + webix.uid();

    this.ViewModel = new HardwaresManager();

    this.Views = {
        Form:null,

        IpfixHeader:null,
        IpfixIdInput:null,

        HardwareType:null,

        AuthType:null,
        HardwareSshKey:null,
        AddHardwareSshKey:null,
        PasswordField:null,

        SyncHeader:null,
        SubsSyncCheckbox:null,
        SubsAuthStatusSync:null,
        LogsSyncCheckbox:null,
        CgnatSyncCheckbox:null
    };

    this.ContextConfig = {
        view: "popup",
        id:this.Id + "Context",
        width:560,
        modal:true,
        move:true,
        body: {
            view: "form",
            id:this.Id + "Form",
            borderless:true,
            elements:[
                BlockHeaderTemplate({title:LangHelper.GetString("Hardwares", "Hardware settings"), icon:"server"}),
                {
                    cols:[
                        {
                            view: "text",
                            name: "name",
                            label: LangHelper.GetString("Hardwares", "Name"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString("Hardwares", "Enter the title"),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            view: "richselect",
                            id:this.Id + "HardwareType",
                            label: LangHelper.GetString("Hardwares", "Hardware type"),
                            name: "hardware_type",
                            labelPosition: "top",
                            suggest:{
                                fitMaster:false,
                                data:Helper.DictToArr(HardwareTypesDic)
                            },
                            value: "dpi"
                        }
                    ]
                },
                {
                    cols:[
                        {
                            view: "text",
                            name: "ip",
                            label: LangHelper.GetString("Hardwares", "Host"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString("Hardwares", "Enter Ip"),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            view: "text",
                            name: "port",
                            label: LangHelper.GetString("Hardwares", "Port"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString("Hardwares", "Enter Port"),
                            validate: webix.rules.isNotEmpty
                        }
                    ]
                },
                {
                    cols:[
                        {
                            view: "text",
                            name: "login",
                            label: LangHelper.GetString("Hardwares", "Login"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: LangHelper.GetString("Hardwares", "Enter login"),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            cols: [
                                {
                                    view: "richselect",
                                    id:this.Id + "AuthType",
                                    label: LangHelper.GetString("Hardwares", "Auth type"),
                                    name: "auth_type",
                                    labelPosition: "top",
                                    suggest:{
                                        fitMaster:false,
                                        data:Helper.DictToArr(AuthType)
                                    },
                                    value: "password",
                                    gravity: 1
                                },
                                {
                                    view: "richselect",
                                    id:this.Id + "HardwareSshKey",
                                    label: LangHelper.GetString("HardwareSshKeys", "SSH key"),
                                    name: "ssh_key_id",
                                    labelPosition: "top",
                                    hidden: true,
                                    gravity: 0.80,
                                    suggest:{
                                        width: 200,
                                        data: App.DicsManager.GetDicAsArrayWithEmpty(DicsEnum.HardwareSshKeysDic),
                                        fitMaster:false
                                    }
                                },
                                {
                                    view: "button",
                                    id:this.Id + "AddHardwareSshKey",
                                    type: "icon",
                                    icon: "plus",
                                    css:"toolbar_round_btn",
                                    width:32,
                                    tooltip:LangHelper.GetString("HardwareSshKeys", "Add ssh key"),
                                    hidden: true,
                                    click:function ()
                                    {
                                        const node = this.getNode();
                                        _this.Views.HardwareSshKeyForm.Clear();
                                        _this.Views.HardwareSshKeyForm.SetData({});
                                        _this.Views.HardwareSshKeyForm.Show(node, "right");
                                    }
                                },
                            ]
                        }

                    ]
                },
                {
                    view: "text",
                    id: _this.Id + "PasswordField",
                    type: "password",
                    name: "password",
                    label: LangHelper.GetString("Hardwares", "Password"),
                    labelPosition: "top",
                    required: true,
                    invalidMessage: LangHelper.GetString("Hardwares", "Enter password"),
                    validate: webix.rules.isNotEmpty
                },
                {
                    cols: [
                        {
                            view: "checkbox",
                            name: "sudocheck",
                            label: LangHelper.GetString("Hardwares", "Sudo user"),
                            labelPosition: "top"
                        },
                        {},
                        {
                            view: "button",
                            type: "icon",
                            icon: "question-circle",
                            css:"toolbar_round_btn",
                            width:32,
                            click: function () {
                                var __this = this;
                                var node = __this.getNode();

                                _this.ShowHelpPopup(node, LangHelper.GetString("Hardwares", "SUDO_USER_HELP_POPUP"), 50, 300);
                            }
                        },
                    ]
                },
                BlockHeaderTemplate({id:this.Id + "SyncHeader", title:LangHelper.GetString("Hardwares", "Synchronization settings"), icon:"cog"}),
                {
                    cols: [
                        {
                            view: "checkbox",
                            id:this.Id + "LogsSyncCheckbox",
                            name: "enable_logs_sync",
                            label: LangHelper.GetString("Hardwares", "Enable logs sync"),
                            labelPosition: "top"
                        },
                        {
                            view: "checkbox",
                            id:this.Id + "CgnatSyncCheckbox",
                            name: "enable_cgnat_sync",
                            label: LangHelper.GetString("Hardwares", "Enable CGNAT sync"),
                            labelPosition: "top"
                        },

                        {
                            gravity:0
                        }
                    ]
                },
                {
                    cols:[
                        {
                            view: "checkbox",
                            id:this.Id + "SubsSyncCheckbox",
                            name: "enable_subs_sync",
                            label: LangHelper.GetString("Hardwares", "Enable subscribers sync"),
                            labelPosition: "top"
                        },
                        {
                            view: "checkbox",
                            id:this.Id + "SubsAuthStatusSync",
                            name: "enable_subs_auth_status_sync",
                            label: LangHelper.GetString("Hardwares", "Enable subscribers auth status sync"),
                            labelPosition: "top"
                        },
                        {
                            gravity:0
                        }
                    ]
                },
                BlockHeaderTemplate({id:this.Id + "IpfixHeader", title:LangHelper.GetString("Hardwares", "Ipfix settings"), icon:"cog"}),
                {
                    view: "text",
                    id:this.Id + "IpfixIdInput",
                    name: "ipfix_id",
                    label: LangHelper.GetString("Hardwares", "Id on ipfix collector"),
                    labelPosition: "top",
                    validate:function(Val)
                    {
                        return !isNaN(Val*1);
                    },
                    invalidMessage: LangHelper.GetString("Dics","Enter the number")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            value:LangHelper.GetString("Hardwares", "Cancel"),
                            click:function ()
                            {
                                _this.Hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            value:LangHelper.GetString("Hardwares", "Save"),
                            click:function ()
                            {
                                setTimeout(function () {
                                    _this.Save();
                                },1);
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.Context = null;

    this.Data = null;

    this.Subscriptions = {};

    this.Signals = {
        Saved:new Rx.BehaviorSubject(null),

        HwTypeValue:new Rx.BehaviorSubject(null)
    };

    return this;
}

HardwareEditFormViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

HardwareEditFormViewController.prototype.Destroy = function (Params)
{
    var _this = this;

    this.Views.HardwareSshKeyForm.Destroy();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

};

HardwareEditFormViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Context = webix.ui(this.ContextConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    this.Views.HardwareSshKeyForm = new HardwareSshKeysEditFormViewController();
    this.Views.HardwareSshKeyForm.BindAll();

    this.Views.HardwareType.attachEvent("onChange", function(Nv, Ov)
    {
        _this.Signals.HwTypeValue.next(Nv);
        // setTimeout(function(){_this.Context.refresh()}, 10);
    });

    this.Views.SubsSyncCheckbox.attachEvent("onChange", function(Nv,Ov){
        Nv ? _this.Views.SubsAuthStatusSync.enable() : _this.Views.SubsAuthStatusSync.disable();
        // setTimeout(function(){
        //     Nv && _this.Views.SubsSyncCheckbox.isVisible() ? _this.Views.SubsAuthStatusSync.enable() : _this.Views.SubsAuthStatusSync.disable();
        // }, 10);

    });

    this.Views.AuthType.attachEvent("onChange", function(Nv, Ov)
    {
        if (Nv === AuthTypesEnum.password)
        {
            _this.Views.HardwareSshKey.hide();
            _this.Views.AddHardwareSshKey.hide();

            _this.Views.PasswordField.show();
        }
        else
        {
            _this.Views.PasswordField.hide();

            _this.Views.HardwareSshKey.show();
            _this.Views.AddHardwareSshKey.show();
        }
    });

    this.Subscriptions.SignalHardwareSshKeysDicUpdatedSubscription = App.DicsManager.Signal[DicsEnum.HardwareSshKeysDic].subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateHardwareSshKeysDics();
        }
    });

    this.Subscriptions.HardwareSshKeyFormSaved = this.Views.HardwareSshKeyForm.Signals.Saved.subscribe(function (Model) {
        if (Model)
            _this.Views.HardwareSshKey.setValue(Model.ssh_key_id);
    });

    this.Subscriptions.NodeFormHasValue = this.Signals.HwTypeValue.subscribe(function (Value)
    {
        var view = _this.Views.IpfixHeader;
        Value && Value == HardwareTypesEnum.dpi ? view.show() : view.hide();

        var view = _this.Views.IpfixIdInput;
        Value && Value == HardwareTypesEnum.dpi ? view.show() : view.hide();


        var view = _this.Views.SyncHeader;
        Value && Value == HardwareTypesEnum.dpi ? view.show() : view.hide();

        var view = _this.Views.SubsSyncCheckbox;
        Value && Value == HardwareTypesEnum.dpi ? view.show() : view.hide();

        var view = _this.Views.SubsAuthStatusSync;
        Value && Value == HardwareTypesEnum.dpi ? view.show() : view.hide();

        var view = _this.Views.LogsSyncCheckbox;
        Value && Value == HardwareTypesEnum.dpi ? view.show() : view.hide();

        var view = _this.Views.CgnatSyncCheckbox;
        Value && Value == HardwareTypesEnum.dpi ? view.show() : view.hide();
    });

    App.DicsManager.Refresh({data:[DicsEnum.HardwareSshKeysDic]});
};

HardwareEditFormViewController.prototype.Clear = function()
{
    this.Views.Form.clear();
    this.Views.Form.clearValidation();
};

HardwareEditFormViewController.prototype.Validate = function()
{
    return this.Views.Form.validate();
};

HardwareEditFormViewController.prototype.UpdateHardwareSshKeysDics = function()
{
    this.Views.HardwareSshKey.getList().clearAll();
    this.Views.HardwareSshKey.getList().parse(App.DicsManager.GetDicAsArrayWithEmpty(DicsEnum.HardwareSshKeysDic));
}

HardwareEditFormViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node,{pos:Pos});
};

HardwareEditFormViewController.prototype.Hide = function()
{
    this.Context.hide();
};

HardwareEditFormViewController.prototype.SetData = function(Data)
{
    this.Data = new HardwareModel(Data);

    this.Clear();

    this.Views.Form.setValues(this.Data);
};

HardwareEditFormViewController.prototype.GetData = function()
{
    const values = this.Views.Form.getValues();

    if (values.auth_type === AuthTypesEnum.password)
    {
        values.ssh_key_id = null;

        if (this.Data.copy_hardware_id && values.password !== this.Data.password)
        {
            values.copy_hardware_id = 0;
        }
    }

    return new HardwareModel(webix.extend(this.Data,values,true));
};

HardwareEditFormViewController.prototype.Save = function ()
{
    var _this = this;

    if(this.Validate())
    {
        this.ViewModel.SaveHardware(this.GetData(), function (R)
        {
            if(R.success)
            {
                _this.Data.hardware_id = R.data.hardware_id;

                _this.Signals.Saved.next(_this.Data);

                webix.message(LangHelper.GetString("Hardwares", "Saved"));

                App.DicsManager.Refresh({data:[DicsEnum.HardwaresDic]});

                if(module == "dpiui2")
                {
                    if(_this.Data.hardware_id == App.SessionManager.GetCurrentHardwareId())
                    {
                        App.SessionManager.RefreshCurrentHardwareState();
                    }
                }


                _this.Hide();
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        });
    }
};

HardwareEditFormViewController.prototype.ShowHelpPopup = function(Node, Text, Height, Weight)
{
    const popup = webix.ui({
        view:"popup",
        height: Height,
        width: Weight,
        body:{
            borderless:true,
            template:Text
        }
    });

    popup.show(Node, {pos: "right"});
};
function HardwareStateViewController(Params)
{
    var _this = this;

    this.Id = "HardwareState" + webix.uid();

    this.ViewModel = new HardwaresManager();

    this.Views = {
        Form:null,
        Table: null
    };

    this.ContextConfig = {
        view: "popup",
        id:this.Id + "Context",
        width:560,
        modal:true,
        move:true,
        body: {
            rows:[
                BlockHeaderTemplate({title:LangHelper.GetString("Hardwares", "Hardware state"), icon:"thermometer-half"}),
                {
                    rows:[
                        {
                            view: "toolbar",
                            padding:0,
                            margin:0,
                            elements: [
                                {},
                                {
                                    view: "button",
                                    type: "icon",
                                    icon: "refresh",
                                    css: "toolbar_round_btn",
                                    width: 32,
                                    tooltip: LangHelper.GetString("Hardwares", "Refresh"),
                                    click: function (id, e, node) {
                                        _this.RefreshState();
                                    }
                                }
                            ]
                        },
                        {
                            view: "datatable",
                            id: this.Id + "Table",
                            select: "row",
                            tooltip: true,
                            height: 480,
                            padding:0,
                            margin:0,
                            columns:[
                                {
                                    id: "title",
                                    fillspace: 1,
                                    header: LangHelper.GetString("Hardwares", "Property"),
                                    template: function(Obj)
                                    {
                                        return Obj.title;
                                    }
                                },
                                {
                                    id: "state",
                                    fillspace: 2,
                                    header: LangHelper.GetString("Hardwares", "State"),
                                    template: function(Obj)
                                    {
                                        var statusStr = "";

                                        if(Obj.loading == 1)
                                        {
                                            statusStr += '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div> <div class="bounce3"></div> </div>';
                                        }
                                        else if(Obj.msg || Obj.ok){
                                            statusStr += "<span class=\"status status_" + (Obj.ok ? "3" : "4") + "\">";

                                            if(!Obj.ok && Obj.msg)
                                            {
                                                statusStr += '<span class="webix_icon fa-times-circle"></span>';
                                            }else if (Obj.ok) {
                                                statusStr += '<span class="webix_icon fa-check-circle"></span>';
                                            }

                                            statusStr += LangHelper.GetString("Hardwares", Obj.msg) + "</span>";
                                        }

                                        return statusStr;
                                    }
                                },
                                {
                                    id: "refresh",
                                    header: "",
                                    width: 40,
                                    headermenu: false,
                                    tooltip: LangHelper.GetString("Hardwares", "Refresh"),
                                    template: CellRefreshBtnTemplate
                                }
                            ],
                            on: {
                                onItemClick: function(Id){
                                    var rowData = this.getItem(Id);

                                    _this.RefreshState([rowData.state_id])
                                }
                            }
                        },
                    ]
                },

                {
                    cols:[
                        {},
                        {},
                        {
                            view:"button",
                            value:LangHelper.GetString("Hardwares", "Close"),
                            click:function ()
                            {
                                _this.Hide();
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.Context = null;

    this.Data = null;

    this.Subscriptions = {};

    this.Signals = {};

    return this;
}

HardwareStateViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

HardwareStateViewController.prototype.Destroy = function (Params)
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

};

HardwareStateViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Context = webix.ui(this.ContextConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    this.Subscriptions.HardwareStateSubscription = this.ViewModel.Signals.HardwareStateSignal.subscribe(function(Val){

        if(Val)
        {
            _this.UpdateTable();
        }
        else{
            _this.SetLoading();
        }
    });
};

HardwareStateViewController.prototype.Clear = function()
{
    this.Views.Form.clear();
    this.Views.Form.clearValidation();
};

HardwareStateViewController.prototype.Validate = function()
{
    return this.Views.Form.validate();
};


HardwareStateViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node,{pos:Pos});
    this.ViewModel.ClearHardwareState();
};

HardwareStateViewController.prototype.Hide = function()
{
    this.Context.hide();
};

HardwareStateViewController.prototype.SetData = function(Data)
{
    this.Data = Data;

    this.UpdateTable();
    this.RefreshState();
};

HardwareStateViewController.prototype.GetData = function()
{
    return webix.copy(this.Data);
};

HardwareStateViewController.prototype.UpdateTable = function()
{
    var _this = this;

    var arr = [];

    var data = this.ViewModel.GetHardwareState();

    for(var prop in HardwareStateOptionsEnum)
    {
        var obj = new HardwareSingleStateModel(data && data[HardwareStateOptionsEnum[prop]] ? data[HardwareStateOptionsEnum[prop]] : {});

        obj.state_id = HardwareStateOptionsEnum[prop];
        obj.title = HardwareSateEnumDic[obj.state_id] && HardwareSateEnumDic[obj.state_id].value ?  HardwareSateEnumDic[obj.state_id].value : obj.state_id;

        obj.loading = 0;

        arr.push(obj)
    }

    this.Views.Table.clearAll();
    this.Views.Table.parse(arr);
};

HardwareStateViewController.prototype.SetLoading = function()
{
    var _this = this;

    this.Views.Table.eachRow(function(Id) {
        var item = _this.Views.Table.getItem(Id);
        item.loading = 1;

        _this.Views.Table.updateItem(Id, item);
    }, true);
};

HardwareStateViewController.prototype.RefreshState = function (Options)
{
    var _this = this;

    var options = Options ? Options : [];

    if(options.length > 0)
    {
        options.forEach(function(Option){
            _this.Views.Table.eachRow(function(Id) {
                var item = _this.Views.Table.getItem(Id);
                if(item.state_id == Option)
                {
                    item.loading = 1;

                    _this.Views.Table.updateItem(Id, item);
                }

            }, true);
        });
    }
    else{
        _this.SetLoading();
    }

    this.ViewModel.RefreshHardwareState({
        hardware_id: this.Data.hardware_id,
        options: options,
        callback: function(R){}
    });
};


var HardwareSshKeysTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"HardwareSshKeysTableWidget",
        sortDisabledColumns:["edit", "trash"],
        hideExport: true,
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "GetHardwareSshKeys";
            },
            sort:{id:"ssh_key_id",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [
                {
                    id: "edit",
                    header: "",
                    width: 40,
                    template: CellEditBtnTemplate,
                    headermenu: false
                },
                {
                    id: "download_public_key",
                    header: "",
                    width: 40,
                    template: function(Obj)
                    {
                        if (Obj.public_key)
                            return CellDownloadFileBtnTemplate();

                        return "";
                    },
                    headermenu: false
                },

                {
                    id: "ssh_key_id",
                    header: [LangHelper.GetString("Hardwares", "ID"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    editor:"text",
                    fillspace: true
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("Hardwares", "Name"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    editor:"text",
                    fillspace: true
                },
                {
                    id: "public_key",
                    header: [LangHelper.GetString("HardwareSshKeys", "Public key"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    editor:"text",
                    fillspace: true,
                    template: function(Obj)
                    {
                        if (Obj.public_key)
                        {
                            return Obj.public_key.split(/[\\/]/).pop();
                        }

                        return ""
                    }
                },
                {
                    id: "private_key",
                    header: [LangHelper.GetString("HardwareSshKeys", "Private key"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    editor:"text",
                    fillspace: true,
                    template: function(Obj)
                    {
                        if (Obj.private_key)
                        {
                            return Obj.private_key.split(/[\\/]/).pop();
                        }

                        return ""
                    }
                },
                {
                    id: "trash",
                    header: "",
                    width: 40,
                    template: CellTrashBtnTemplate,
                    headermenu: false
                }
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterFilterCustomHandler)
    {
        params.on.onAfterFilterCustomHandler = function ()
        {
            Params.onAfterFilterCustomHandler();
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

function HardwareSshKeysViewController(Params)
{
    var _this = this;

    this.Id = "HardwareSshKeys";

    this.ViewModel = new HardwareSshKeysManager();

    this.ReportsModel = new UniReportsManager();

    this.HardwareSshKeyDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Do you really want to delete the ssh key?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function () {
                                _this.HardwareSshKeyDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Delete"),
                            click:function () {
                                _this.HardwareSshKeyDeleteContext.hide();
                                _this.DeleteTableSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HardwareSshKeysEditFormContext = new HardwareSshKeysEditFormViewController();

    this.Views = {
        Widgets:{},
        ReportsWidgets:{
            HardwareSshKeysReport: HardwareSshKeysTableWidget({
                id: this.Id + "HardwareSshKeysReport",
                onAfterFilterCustomHandler: function ()
                {
                    _this.Refresh();
                },
                onItemClick: function (Obj)
                {
                    var table = _this.Views.ReportsWidgets.HardwareSshKeysReport.Views.Table;
                    var rowData = table.getItem(Obj.row);

                    if(Obj.column === 'edit')
                    {
                        _this.HardwareSshKeysEditFormContext.SetData(rowData);
                        _this.HardwareSshKeysEditFormContext.Show(table.getItemNode(Obj.row), "right");
                    }
                    else if(Obj.column === 'trash')
                    {
                        var __this = this;

                        setTimeout(function () {
                            let node = table.getItemNode(Obj);
                            _this.HardwareSshKeyDeleteContext.show(node, {pos:"bottom"});
                        }, 10);
                    }
                    else if(Obj.column === 'download_public_key')
                    {
                        setTimeout(function () {
                            _this.HardwareSshKeysEditFormContext.DownloadSshKeyFile(rowData.ssh_key_id);
                        }, 10);
                    }
                }
            })
        }
    };

    this.ViewConfig = [
        {
            cols: [
                AdministratorLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                PageHeaderTemplate({root_title:LangHelper.GetString(_this.Id, "SSH keys management"),title:LangHelper.GetString(_this.Id, "SSH keys")}),
                                {
                                    rows:[
                                        {
                                            view: "toolbar",
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "plus",
                                                    css:"toolbar_round_btn",
                                                    width:32,
                                                    tooltip:LangHelper.GetString(_this.Id, "Add ssh key"),
                                                    click:function ()
                                                    {
                                                        const node = this.getNode();
                                                        _this.HardwareSshKeysEditFormContext.Clear();
                                                        _this.HardwareSshKeysEditFormContext.SetData({});
                                                        _this.HardwareSshKeysEditFormContext.Show(node, "right");
                                                    }
                                                },
                                                {},
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString(_this.Id, "Refresh"),
                                                    click: function (id, e, node) {
                                                        _this.Refresh();
                                                    }
                                                }
                                            ]
                                        },
                                        BlockHeaderTemplate({title:LangHelper.GetString(_this.Id, "SSH keys"), icon:"key"}),
                                        _this.Views.ReportsWidgets.HardwareSshKeysReport.ViewConfig
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Subscriptions = {};
}

HardwareSshKeysViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.HardwareSshKeysEditFormContext.ViewDidLoad();

    this.BindAll(Params);

    this.Refresh();
};

HardwareSshKeysViewController.prototype.BindAll = function (Params) {
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.SavedSignal = this.HardwareSshKeysEditFormContext.Signals.Saved.subscribe(function (Data)
    {
        if(Data)
        {
            _this.Refresh();
        }
    });
};

HardwareSshKeysViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    this.HardwareSshKeysEditFormContext.Destroy();
};

HardwareSshKeysViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.HardwareSshKeysReport.RefreshData();
};

HardwareSshKeysViewController.prototype.DeleteTableRow = function (RowId)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.HardwareSshKeysReport.Views.Table;
    var data = table.getItem(RowId);

    this.ViewModel.DeleteHardwareSshKey(data, function (R)
        {
            if(R.success)
            {
                _this.Refresh();

                webix.message(LangHelper.GetString(_this.Id,"Deleted"));

                App.DicsManager.Refresh({data:[DicsEnum.HardwareSshKeysDic]});
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }
    );
};

HardwareSshKeysViewController.prototype.DeleteTableSelectedRows = function ()
{
    var _this = this;

    var selectedRows = this.GetTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    selectedRows.forEach(function (Row)
    {
        _this.DeleteTableRow(Row.id);
    });
};

HardwareSshKeysViewController.prototype.GetTableSelectedData = function ()
{
    return this.Views.ReportsWidgets.HardwareSshKeysReport.Views.Table.getSelectedItem();
};
function HardwareSshKeysEditFormViewController(Params)
{
    var _this = this;

    this.Id = "HardwareSshKeysEditForm";

    this.ViewModel = new HardwareSshKeysManager();

    this.Views = {
        Form:null,
        FormGenerateSshKey:null,

        PublicKeyField:null,
        PrivateKeyField:null,
        PassphraseField:null,

        PublicKeyInput:null,
        PrivateKeyInput:null,
        PublicKeyUploader:null,
        PrivateKeyUploader:null,
        IndicatorUploadPublicFile:null,
        IndicatorUploadPrivateFile:null,

        DownloadPrivateKeyBtn:null,
        DownloadPublicKeyBtn:null,
    };

    this.ContextConfig = {
        view: "popup",
        id:this.Id + "Context",
        width:560,
        height: 440,
        modal:true,
        margin: 0,
        padding: 0,
        body: {
            view: "form",
            id:this.Id + "Form",
            borderless:true,
            elements:[
                {
                    view: "text",
                    name: "name",
                    label: LangHelper.GetString("Hardwares", "Name"),
                    labelPosition: "top",
                    required: true,
                    invalidMessage: LangHelper.GetString("Hardwares", "Enter the title"),
                    validate: webix.rules.isNotEmpty
                },
                {
                    view: "toolbar",
                    elements: [
                        {
                            view: "button",
                            type: "icon",
                            icon: "key",
                            css:"toolbar_round_btn",
                            width:32,
                            tooltip:LangHelper.GetString("HardwareSshKeys", "Generate SSH keys"),
                            click: function () {
                                var __this = this;
                                var node = __this.getNode();

                                _this.Views.FormGenerateSshKey.clear();
                                _this.Views.FormGenerateSshKey.clearValidation();
                                _this.Views.FormGenerateSshKey.elements.algorithm.setValue("rsa");
                                _this.Views.FormGenerateSshKey.elements.format_key.setValue("default");
                                _this.GenerateSshKeyContext.show(node, {pos: "right"})
                            }
                        },
                        {
                            view: "button",
                            type: "icon",
                            icon: "question-circle",
                            css:"toolbar_round_btn",
                            width:32,
                            click: function () {
                                var __this = this;
                                var node = __this.getNode();

                                _this.ShowHelpPopup(node, LangHelper.GetString("HardwareSshKeys", "SSH_KEY_HELP_POPUP_TEXT"), 150, 500);
                            }
                        },
                    ]
                },
                BlockHeaderTemplate(
                    {
                        title:LangHelper.GetString("HardwareSshKeys", "SSH key settings"),
                        icon:"key",
                        css: "form-header-reset-margin",
                    }),
                {
                    id: _this.Id + "PublicKeyField",
                    css: "input-container-relative",
                    cols: [
                        {
                            view: "text",
                            id: _this.Id + "PublicKeyInput",
                            type: "public_key",
                            name: "public_key",
                            label: LangHelper.GetString("HardwareSshKeys", "Public key"),
                            labelPosition: "top",
                            disabled: true,
                            hidden_value: "",
                            required: true,
                            validate: function(Val)
                            {
                                if (!Val)
                                    return false;

                                const
                                    indicatorUpload = _this.Views.IndicatorUploadPublicFile,
                                    nodeIndicatorUploader = indicatorUpload.getNode();

                                if (nodeIndicatorUploader.classList.contains("icon-error-upload") || nodeIndicatorUploader.classList.contains("btn_icon_spin"))
                                {
                                    return false;
                                }

                                return true;
                            }
                        },
                        {
                            view: "button",
                            id: _this.Id + "IndicatorUploadPublicFile",
                            type: "icon",
                            icon: "",
                            css: "toolbar_round_btn btn_icon_spin icon-on-input",
                            disabled: true,
                            width: 32
                        },
                        {
                            view: "uploader",
                            id: _this.Id + "PublicKeyUploader",
                            type: "icon",
                            icon: "file-import",
                            css: "toolbar_round_btn",
                            width: 32,
                            autosend: false,
                            tooltip: LangHelper.GetString("HardwareSshKeys", "Upload public key")
                        },
                        {
                            view: "button",
                            id:_this.Id + "DownloadPublicKeyBtn",
                            type: "icon",
                            icon: "file-download",
                            css: "toolbar_round_btn",
                            width: 32,
                            tooltip: LangHelper.GetString("HardwareSshKeys","Download public key"),
                            disabled: true,
                            click: function (id, e, node)
                            {
                                let filename = _this.Views.PublicKeyInput.config.hidden_value;

                                if (filename.includes("/storage/"))
                                {
                                    _this.DownloadSshKeyFile(_this.Data.ssh_key_id);
                                }
                                else
                                {
                                    _this.DownloadSshKeyFile(filename);
                                }
                            }
                        },
                    ]
                },
                {
                    id: _this.Id + "PrivateKeyField",
                    css: "input-container-relative",
                    cols: [
                        {
                            view: "text",
                            id: _this.Id + "PrivateKeyInput",
                            type: "private_key",
                            name: "private_key",
                            label: LangHelper.GetString("HardwareSshKeys", "Private key"),
                            labelPosition: "top",
                            disabled: true,
                            hidden_value: "",
                            required: true,
                            validate: function(Val)
                            {
                                if (!Val)
                                    return false;

                                const
                                    indicatorUpload = _this.Views.IndicatorUploadPrivateFile,
                                    nodeIndicatorUploader = indicatorUpload.getNode();

                                if (nodeIndicatorUploader.classList.contains("icon-error-upload") || nodeIndicatorUploader.classList.contains("btn_icon_spin"))
                                {
                                    return false;
                                }

                                return true;
                            }
                        },
                        {
                            view: "button",
                            id: _this.Id + "IndicatorUploadPrivateFile",
                            type: "icon",
                            icon: "",
                            css: "toolbar_round_btn icon-on-input-private",
                            disabled: true,
                            width: 32
                        },
                        {
                            view: "uploader",
                            id: _this.Id + "PrivateKeyUploader",
                            type: "icon",
                            icon: "file-import",
                            css: "toolbar_round_btn",
                            width: 32,
                            autosend:false,
                            tooltip: LangHelper.GetString("HardwareSshKeys", "Upload private key")
                        },
                        {
                            view: "button",
                            id:_this.Id + "DownloadPrivateKeyBtn",
                            type: "icon",
                            icon: "file-download",
                            css: "toolbar_round_btn",
                            width: 32,
                            tooltip: LangHelper.GetString("HardwareSshKeys","Download private key"),
                            hidden: true,
                            click: function (id, e, node)
                            {
                                let filename = _this.Views.PrivateKeyInput.config.hidden_value;

                                if (filename)
                                    _this.DownloadSshKeyFile(filename);
                            }
                        },
                    ]
                },
                {
                    cols: [
                        {
                            view: "text",
                            id: _this.Id + "PassphraseField",
                            type: "password",
                            name: "passphrase",
                            label: LangHelper.GetString("HardwareSshKeys", "Passphrase"),
                            labelPosition: "top",
                        },
                        {
                            view: "button",
                            type: "icon",
                            icon: "question-circle",
                            css:"toolbar_round_btn",
                            width:32,
                            click: function () {
                                var __this = this;
                                var node = __this.getNode();

                                _this.ShowHelpPopup(node, LangHelper.GetString("HardwareSshKeys", "PASSPHRASE_HELP_POPUP_TEXT"), 80, 500);
                            }
                        }
                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            value:LangHelper.GetString("Hardwares", "Cancel"),
                            click:function ()
                            {
                                _this.Hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            value:LangHelper.GetString("Hardwares", "Save"),
                            click:function ()
                            {
                                setTimeout(function () {
                                    _this.Save();
                                },1);
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.GenerateSshKeyConfig = {
        view: "popup",
        id:this.Id + "GenerateSshKey",
        width:560,
        modal:true,
        move:true,
        body: {
            view: "form",
            id:this.Id + "FormGenerateSshKey",
            borderless:true,
            elements:[
                BlockHeaderTemplate({title:LangHelper.GetString("HardwareSshKeys", "Generating SSH keys"), icon:"key"}),
                {
                    view: "text",
                    name: "name",
                    label: LangHelper.GetString("Hardwares", "Name"),
                    labelPosition: "top",
                    required: true,
                    invalidMessage: LangHelper.GetString("Hardwares", "Enter the title"),
                    validate: webix.rules.isNotEmpty
                },
                {
                    view:"richselect",
                    name: "algorithm",
                    label: LangHelper.GetString("HardwareSshKeys", "Algorithm"),
                    labelPosition: "top",
                    options: Helper.DictToArr(SshKeyAlgorithmType)
                },
                {
                    view:"richselect",
                    name: "format_key",
                    label: LangHelper.GetString("HardwareSshKeys", "Format"),
                    labelPosition: "top",
                    options: Helper.DictToArr(SshKeyFormatType)
                },
                {
                    view: "text",
                    type: "password",
                    name: "passphrase",
                    label: LangHelper.GetString("HardwareSshKeys", "Passphrase"),
                    labelPosition: "top",
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            value:LangHelper.GetString("Hardwares", "Cancel"),
                            click:function ()
                            {
                                _this.GenerateSshKeyContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            value:LangHelper.GetString("HardwareSshKeys", "Generate"),
                            click:function ()
                            {
                                setTimeout(function () {
                                    _this.GenerateSshKey();
                                },1);
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.Context = null;

    this.GenerateSshKeyContext = null;

    this.Data = null;

    this.Subscriptions = {};

    this.Signals = {
        Saved:new Rx.BehaviorSubject(null)
    };
}

HardwareSshKeysEditFormViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

HardwareSshKeysEditFormViewController.prototype.Destroy = function (Params)
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    this.Views.PublicKeyUploader.detachEvent("onAfterFileAdd");
    this.Views.PrivateKeyUploader.detachEvent("onAfterFileAdd");
};

HardwareSshKeysEditFormViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Context = webix.ui(this.ContextConfig);
    this.GenerateSshKeyContext = webix.ui(this.GenerateSshKeyConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    this.Views.PublicKeyUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        if (FileObj)
        {
            _this.OnFileAdded(FileObj, _this.Views.PublicKeyInput, _this.Views.IndicatorUploadPublicFile);
        }
    });

    this.Views.PrivateKeyUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        if (FileObj)
        {
            _this.OnFileAdded(FileObj, _this.Views.PrivateKeyInput, _this.Views.IndicatorUploadPrivateFile);
        }
    });
};

HardwareSshKeysEditFormViewController.prototype.Clear = function()
{
    this.Views.Form.clear();
    this.Views.Form.clearValidation();

    this.ClearIndicatorUpload(this.Views.IndicatorUploadPublicFile);
    this.ClearIndicatorUpload(this.Views.IndicatorUploadPrivateFile);

    this.Views.DownloadPrivateKeyBtn.hide();
    this.Views.DownloadPublicKeyBtn.disable();
};

HardwareSshKeysEditFormViewController.prototype.ClearIndicatorUpload = function (Indicator)
{
    const indicatorUpload = Indicator.getNode();

    webix.html.removeCss(indicatorUpload, 'icon-error-upload');
    webix.html.removeCss(indicatorUpload, 'icon-success-upload');
    webix.html.removeCss(indicatorUpload, 'btn_icon_spin');
    Indicator.define("icon", "");
    Indicator.refresh();
}

HardwareSshKeysEditFormViewController.prototype.Validate = function()
{
    return this.Views.Form.validate({disabled: true});
};

HardwareSshKeysEditFormViewController.prototype.ValidateSshKeyForm = function()
{
    return this.Views.FormGenerateSshKey.validate();
};


HardwareSshKeysEditFormViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node,{pos:Pos});
};

HardwareSshKeysEditFormViewController.prototype.Hide = function()
{
    this.Context.hide();
};

HardwareSshKeysEditFormViewController.prototype.SetData = function(Data)
{
    this.Data = new HardwareSshKeysModel(Data);

    this.Clear();

    this.Views.PublicKeyInput.config.hidden_value = this.Data.public_key;
    this.Views.PrivateKeyInput.config.hidden_value = this.Data.private_key;

    this.Data.public_key = this.Data.public_key.split(/[\\/]/).pop();
    this.Data.private_key = this.Data.private_key.split(/[\\/]/).pop();

    if (this.Data.public_key)
    {
        this.Views.DownloadPublicKeyBtn.enable();
    }

    this.Views.Form.setValues(this.Data);
};

HardwareSshKeysEditFormViewController.prototype.GetData = function()
{
    const values = this.Views.Form.getValues();

    const
        publicInput = this.Views.PublicKeyInput,
        publicHiddenValue = publicInput.config.hidden_value,
        privateInput = this.Views.PrivateKeyInput,
        privateHiddenValue = privateInput.config.hidden_value;

    if (values.ssh_key_id)
    {
        values.public_key = publicHiddenValue ? publicHiddenValue : "";
        values.private_key = privateHiddenValue ? privateHiddenValue : "";
    }
    else
    {
        values.public_key = publicHiddenValue;
        values.private_key = privateHiddenValue;
    }

    return new HardwareSshKeysModel(webix.extend(this.Data,values,true));
};

HardwareSshKeysEditFormViewController.prototype.Save = function ()
{
    var _this = this;

    if(this.Validate())
    {
        this.ViewModel.SaveHardwareSshKey(this.GetData(), function (R)
        {
            if(R.success)
            {
                _this.Signals.Saved.next(R.data);

                webix.message(LangHelper.GetString("Hardwares", "Saved"));

                App.DicsManager.Refresh({data:[DicsEnum.HardwareSshKeysDic]});

                _this.Hide();
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        });
    }
};

HardwareSshKeysEditFormViewController.prototype.GenerateSshKey = function ()
{
    var _this = this;

    const values = this.Views.FormGenerateSshKey.getValues();

    if(this.ValidateSshKeyForm())
    {
        this.ViewModel.GenerateHardwareSshKey(values, function (R)
        {
            if(R.success)
            {
                _this.Views.PublicKeyInput.config.hidden_value = R.data.public_key;
                _this.Views.PublicKeyInput.setValue(`${values.name}.pub`);
                _this.Views.PrivateKeyInput.config.hidden_value = R.data.private_key;
                _this.Views.PrivateKeyInput.setValue(values.name);
                _this.Views.PassphraseField.setValue(values.passphrase);

                _this.Views.DownloadPrivateKeyBtn.show();
                _this.Views.DownloadPublicKeyBtn.enable();
                _this.ClearIndicatorUpload(_this.Views.IndicatorUploadPublicFile);
                _this.ClearIndicatorUpload(_this.Views.IndicatorUploadPrivateFile);
                webix.html.removeCss(_this.Views.IndicatorUploadPrivateFile.getNode(), 'icon-on-input-private');
                webix.html.addCss(_this.Views.IndicatorUploadPrivateFile.getNode(), 'icon-on-input');
                _this.Views.IndicatorUploadPrivateFile.refresh();

                webix.message(LangHelper.GetString("HardwareSshKeys", "Generate SSH key successfully"));

                _this.GenerateSshKeyContext.hide();
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        });
    }
};

HardwareSshKeysEditFormViewController.prototype.OnFileAdded = function(FileObj, FieldInput, Indicator)
{
    const
        _this = this,
        path = "upload_files/",
        fileName = FileObj.name,
        result_fpath = path + fileName,
        node = Indicator.getNode();

    webix.html.removeCss(node, 'icon-error-upload');
    webix.html.removeCss(node, 'icon-success-upload');
    Indicator.define("icon", "spinner-third");
    webix.html.addCss(node, 'btn_icon_spin');

    if (Indicator === _this.Views.IndicatorUploadPrivateFile)
    {
        webix.html.removeCss(node, 'icon-on-input');
        webix.html.addCss(node, 'icon-on-input-private');

        if (_this.Views.DownloadPrivateKeyBtn.isVisible())
        {
            _this.Views.DownloadPrivateKeyBtn.hide();
        }
    }
    else
    {
        _this.Views.DownloadPublicKeyBtn.enable();
    }

    Indicator.refresh();

    App.ServerManager.GenerateFileUploadId({
        fileName: fileName,
        path: path,
        callback: function(R)
        {
            if(R.success && R.data)
            {
                var key = R.data.key ? R.data.key : webix.uid();

                App.ServerManager.UploadFile({
                    key: key,
                    file: FileObj.file,
                    callback: function(R)
                    {
                        webix.html.removeCss(node, 'btn_icon_spin');
                        if(R.status != 200)
                        {
                            Indicator.define("icon", "exclamation-triangle");
                            webix.html.addCss(node, 'icon-error-upload');
                            webix.message({text:`${LangHelper.GetString("TrafficDecode", "File uploading error")} - ${FileObj.name}`,type:"error"});
                        }
                        else
                        {
                            FieldInput.config.hidden_value = result_fpath;
                            FieldInput.setValue(FileObj.name);
                            Indicator.define("icon", "check-circle");
                            webix.html.addCss(node, 'icon-success-upload');
                        }

                        webix.html.removeCss(node, 'btn_icon_spin');
                        Indicator.refresh();
                    }
                });
            }
            else if(R.error)
            {
                Indicator.define("icon", "exclamation-triangle");
                webix.html.addCss(node, 'icon-error-upload');
                webix.html.removeCss(node, 'btn_icon_spin');
                Indicator.refresh();
                webix.message({text:R.error.msg,type:"error"});
                _this.Views.DownloadPublicKeyBtn.disable();
            }
        }
    });
};

HardwareSshKeysEditFormViewController.prototype.ShowHelpPopup = function(Node, Text, Height, Weight)
{
    const popup = webix.ui({
        view:"popup",
        height: Height,
        width: Weight,
        body:{
            borderless:true,
            template:Text
        }
    });

    popup.show(Node, {pos: "right"});
};

HardwareSshKeysEditFormViewController.prototype.DownloadSshKeyFile = function(IdOrFilename)
{
    this.ViewModel.DownloadSshKeyFile(IdOrFilename);
};
function DpiLogsViewController(Params)
{
    this.IdsEnum =
    {
        DpiLogs:"DpiLogs",
        UlrIgwNodeLogs:"UlrIgwNodeLogs"
    };

    this.Id = Params&&Params.Id ? Params.Id : this.IdsEnum .DpiLogs;

    var params = webix.extend(Params,{
        Id: this.Id,
        PageTitle:Params&&Params.PageTitle ? Params.PageTitle : {
            RootTitle: LangHelper.GetString(this.Id,"DPI control"),
            Title: LangHelper.GetString(this.Id,"Logs")
        },
        ServerMethods:
        {
            RefreshLogsFilesList:"GetDpiLogsFilesList",

            GetLogFileTail:"GetDpiLogFileTail",

            DownloadLogFile:"DownloadDpiLogFile"
        },
        PathsNamesMap:
        {
            "alert": "Alert",
            "stat":"Stat",
            "slave": "Slave",
            "serv": "Serv",
            "bras": "Bras"
        },
        FileNamesInfoMap:
        {
            "fastdpi_bras.log":LangHelper.GetString("HardwareLogs","BRAS DHCP logs (none-default)"),
            "serv_fastdpi.log":LangHelper.GetString("HardwareLogs","Network interfaces status")
        },
        UseCurrentHardwareId: true,
        LeftSideBar: DpiConfigLeftSideBarView({id: this.Id})
    },true);

    DpiLogsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(DpiLogsViewController,HardwareLogsViewController);

// function DpiLogsViewController(Params)
// {
//     var _this = this;
//
//     this.Id = "DpiLogs";
//
//     this.mode = module ? module : "dpiui2";
//
//     this.ViewModel = new HardwareLogsManager();
//
//     if(this.mode == "li")
//         this.Health = new LiHealthManager();
//
//     this.Views = {
//         StatLogTailEditor:null,
//         AlertLogTailEditor:null
//     };
//
//     this.ViewConfig = [
//         {
//             cols:[
//                 DpiConfigLeftSideBarView({id: this.Id}),
//                 {
//                     type: "space",
//                     rows:[
//                         {
//                             type: "clear",
//                             borderless: true,
//                             rows: [
//                                 PageHeaderTemplate({root_title: LangHelper.GetString(_this.Id,"DPI control"), title: LangHelper.GetString(_this.Id,"Logs")}),
//                                 {
//                                     view:"accordion",
//                                     multi:"mixed",
//                                     cols:[
//                                         {
//                                             header:LangHelper.GetString(_this.Id,"Log of information messages and errors"),
//                                             body:{
//                                                 rows:[
//                                                     {
//                                                         view: "toolbar",
//                                                         elements: [
//                                                             {
//                                                                 view: "button",
//                                                                 type: "icon",
//                                                                 icon: "download",
//                                                                 css: "toolbar_round_btn",
//                                                                 width: 32,
//                                                                 tooltip: LangHelper.GetString(_this.Id,"Download the complete file"),
//                                                                 click: function (id, e, node)
//                                                                 {
//                                                                     _this.ViewModel.DownloadLog({log:"AlertLog"});
//                                                                 }
//                                                             },
//                                                             {},
//                                                             {
//                                                                 view: "button",
//                                                                 type: "icon",
//                                                                 icon: "refresh",
//                                                                 css: "toolbar_round_btn",
//                                                                 width: 32,
//                                                                 tooltip: LangHelper.GetString(_this.Id,"Refresh"),
//                                                                 click: function (id, e, node)
//                                                                 {
//                                                                     _this.RefreshAlertLogTail();
//                                                                 }
//                                                             }
//                                                         ]
//                                                     },
//                                                     BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"Log of information messages and errors"), icon: "list"}),
//                                                     {
//                                                         view:"codemirror-editor",
//                                                         id:this.Id + "AlertLogTail" + "Editor",
//                                                         value:""
//                                                     }
//                                                 ]
//                                             }
//                                         },
//                                         {
//                                             header:LangHelper.GetString(_this.Id,"Statistics log"),
//                                             body:{
//                                                 rows:[
//                                                     {
//                                                         view: "toolbar",
//                                                         elements: [
//                                                             {
//                                                                 view: "button",
//                                                                 type: "icon",
//                                                                 icon: "download",
//                                                                 css: "toolbar_round_btn",
//                                                                 width: 32,
//                                                                 tooltip: LangHelper.GetString(_this.Id,"Download the complete file"),
//                                                                 click: function (id, e, node)
//                                                                 {
//                                                                     _this.ViewModel.DownloadLog({log:"StatLog"});
//                                                                 }
//                                                             },
//                                                             {},
//                                                             {
//                                                                 view: "button",
//                                                                 type: "icon",
//                                                                 icon: "refresh",
//                                                                 css: "toolbar_round_btn",
//                                                                 width: 32,
//                                                                 tooltip: LangHelper.GetString(_this.Id,"Refresh"),
//                                                                 click: function (id, e, node)
//                                                                 {
//                                                                     _this.RefreshStatLogTail();
//                                                                 }
//                                                             }
//                                                         ]
//                                                     },
//                                                     BlockHeaderTemplate({title: LangHelper.GetString(_this.Id,"Statistics log"), icon: "list"}),
//                                                     {
//                                                         view:"codemirror-editor",
//                                                         id:this.Id + "StatLogTail" + "Editor",
//                                                         value:""
//                                                     }
//                                                 ]
//                                             }
//                                         }
//                                     ]
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         }
//     ];
//
//     this.Subscriptions = {};
// }
//
// DpiLogsViewController.prototype.ViewDidLoad = function (Params)
// {
//     var _this = this;
//
//     webix.ready(function () {
//         $$(_this.Id + "LeftSideBar").select("DpiLogs");
//     });
//
//     this.BindAll(Params);
//
//     if(this.mode == "li")
//     {
//         this.CheckHealth();
//     }
// };
//
// DpiLogsViewController.prototype.BindAll = function (Params)
// {
//     var _this = this;
//
//     this.Views.StatLogTailEditor = $$(this.Id + "StatLogTailEditor");
//     webix.extend(this.Views.StatLogTailEditor, webix.ProgressBar);
//
//     this.Views.AlertLogTailEditor = $$(this.Id + "AlertLogTailEditor");
//     webix.extend(this.Views.AlertLogTailEditor, webix.ProgressBar);
//
//     this.Subscriptions.StatLogTailUpdated = this.ViewModel.SignalStatLogTailUpdated.subscribe(function (V)
//     {
//         var statLogTailUpdated = V;
//
//         if (statLogTailUpdated)
//         {
//             _this.Views.StatLogTailEditor.setValue(_this.ViewModel.GetStatLogTail());
//         }
//     });
//
//     this.Subscriptions.AlertLogTailUpdated = this.ViewModel.SignalAlertLogTailUpdated.subscribe(function (V)
//     {
//         var alertLogTailUpdated = V;
//
//         if (alertLogTailUpdated)
//         {
//             _this.Views.AlertLogTailEditor.setValue(_this.ViewModel.GetAlertLogTail());
//         }
//     });
//
//     if(this.mode == "dpiui2")
//     {
//         this.Subscriptions.HardwareConnected = App.SessionManager.CurrentHardwareConnected.subscribe(function (CurrentHardwareConnected)
//         {
//             if (CurrentHardwareConnected)
//             {
//                 _this.RefreshAlertLogTail();
//                 _this.RefreshStatLogTail();
//             }
//         });
//     }
//
//     if(this.mode == "li")
//     {
//         this.Subscriptions.SignalHealthUpdatedSubscription = this.Health.HealthUpdated.subscribe(function (Updated)
//         {
//             if (Updated)
//             {
//                 _this.HealthResult();
//             }
//         });
//     }
// };
//
// DpiLogsViewController.prototype.RefreshAlertLogTail = function ()
// {
//     var _this = this;
//
//     this.Views.AlertLogTailEditor.showProgress({type: "icon"});
//
//     this.ViewModel.RefreshAlertLogTail({callback:function (R)
//     {
//         _this.Views.AlertLogTailEditor.hideProgress();
//     }});
// };
//
// DpiLogsViewController.prototype.RefreshStatLogTail = function ()
// {
//     var _this = this;
//
//     this.Views.StatLogTailEditor.showProgress({type: "icon"});
//
//     this.ViewModel.RefreshStatLogTail({callback:function (R)
//     {
//         _this.Views.StatLogTailEditor.hideProgress();
//     }});
// };
//
// DpiLogsViewController.prototype.Destroy = function ()
// {
//     var _this = this;
//
//     Object.keys(this.Subscriptions).forEach(function (key)
//     {
//         _this.Subscriptions[key].unsubscribe();
//     });
//
//     if(this.ViewModel)
//     {
//         this.ViewModel.Destroy();
//         delete this.ViewModel;
//     }
// };
//
// DpiLogsViewController.prototype.CheckHealth = function()
// {
//     this.Health.Refresh({dpi_server: 1});
// };
//
// DpiLogsViewController.prototype.HealthResult = function()
// {
//     var health = this.Health.GetHealth();
//
//     if(health.dpi_server)
//     {
//         if(!health.dpi_server.success)
//             webix.message({text:LangHelper.GetString("AppView","Logs") + "<br/><br/>" + health.dpi_server.error.msg + "<br/><br/>" + LangHelper.GetString("Health","Verify services health"), type:"error", expire: 300000});
//
//         if(health.dpi_server.success)
//         {
//             this.RefreshAlertLogTail();
//             this.RefreshStatLogTail();
//         }
//     }
// };
function HardwareNotificationsViewController(Params)
{
    var _this = this;

    this.Id = "Notifications";

    this.InContext = Params&&Params.InContext ? Params.InContext : false;

    this.ViewModel = App.NotificationsManager;

    this.DeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function ()
                            {
                                _this.DeleteContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Delete"),
                            click:function ()
                            {
                                _this.DeleteContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                                _this.DeleteSelected();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.DeleteAllContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Are you sure you want to delete all the records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function ()
                            {
                                _this.DeleteAllContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Delete"),
                            click:function ()
                            {
                                _this.DeleteAllContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                                _this.DeleteAll();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.Views =
        {
            Table:null,
            ReadSelectedBtn:null,
            DeleteSelectedBtn:null,
            Paging:null
        };

    this.ViewConfig = [
        {
            view: "toolbar",
            elements: [
                {},
                {
                    view: "button",
                    id:this.Id+"ReadSelectedBtn",
                    type: "icon",
                    icon: "book-open",
                    css: "toolbar_round_btn toolbar_btn_with_menu",
                    width: 40,
                    tooltip: LangHelper.GetString(_this.Id, "Read selection"),
                    popup:
                    {
                        id: _this.Id + "ReadPopup",
                        view:"submenu",
                        width:240,
                        data:[
                            {
                                id: _this.Id + "ReadOnlySelectedBtn",
                                value: LangHelper.GetString(_this.Id, "Read selected"),
                                callback: function()
                                {
                                    _this.SetSelectedReaded();
                                }
                            },
                            {
                                id: _this.Id + "ReadAlldBtn",
                                value: LangHelper.GetString(_this.Id, "Read all"),
                                callback: function()
                                {
                                    _this.ReadAll();
                                }
                            }
                        ],
                        template:"#value#",
                        autoheight:true,
                        select:false,
                        on:
                        {
                            onMenuItemClick: function (id)
                            {
                                var item = this.getItem(id);
                                if(item && item.callback)
                                {
                                    item.callback();
                                }
                                $$(_this.Id + "ReadPopup").hide();
                            }
                        }
                    }
                },
                {
                    view: "button",
                    id:this.Id+"DeleteSelectedBtn",
                    type: "icon",
                    icon: "trash",
                    css: "toolbar_round_btn toolbar_btn_with_menu",
                    width: 40,
                    tooltip: LangHelper.GetString(_this.Id, "Delete selection"),
                    popup:{
                        id: _this.Id + "DeletePopup",
                        view:"submenu",
                        width:240,
                        data:[
                            {
                                id: _this.Id + "DeleteOnlySelectedBtn",
                                value: LangHelper.GetString(_this.Id, "Delete selected"),
                                callback: function(node)
                                {
                                    _this.DeleteContext.show(node, {pos: "bottom"});
                                }
                            },
                            {
                                id: _this.Id + "DeleteAlldBtn",
                                value: LangHelper.GetString(_this.Id, "Delete all"),
                                callback: function(node)
                                {
                                    _this.DeleteAllContext.show(node, {pos: "bottom"});
                                }
                            }
                        ],
                        template:"#value#",
                        autoheight:true,
                        select:false,
                        on:
                        {
                            onMenuItemClick: function (id)
                            {
                                var item = this.getItem(id);
                                var node = this.getItemNode(id);
                                if(item && item.callback)
                                {
                                    item.callback(node);
                                }
                            }
                        }
                    }
                },
                {
                    width:32
                },
                {
                    view: "button",
                    id:this.Id+"RefreshBtn",
                    type: "icon",
                    icon: "refresh",
                    css: "toolbar_round_btn",
                    width: 32,
                    tooltip: LangHelper.GetString(_this.Id, "Refresh"),
                    click: function (id, e, node)
                    {
                        _this.Refresh();
                    }
                }
            ]
        },
        BlockHeaderTemplate({title:LangHelper.GetString(_this.Id, "Messages"), icon:"table"}),
        {
            view: "datatable",
            id:this.Id+"Table",
            //pager: this.Id+"Table"+"Paging",
            select: "row",
            multiselect:true,
            checkboxRefresh:true,
            columns: [
                {
                    id:"checked",
                    header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                    template: CellColoredCheckBoxTemplate,
                    width:32
                },
                {
                    id: "readed",
                    header: [LangHelper.GetString(_this.Id, "Read"), {
                        content: "richSelectFilter",
                        options: [
                            {id: "0", value: LangHelper.GetString(_this.Id, "No")},
                            {id: "1", value: LangHelper.GetString(_this.Id, "Yes")}
                        ],
                        inputConfig: {suggest: {fitMaster: false}}
                    }],
                    template: function(obj, common, value){
                        if (value == 1)
                            return "<div class='webix_table_checkbox checked'><span class=\"webix_icon fa-check-square\"></span> "+LangHelper.GetString(_this.Id, "Yes")+"</div>";
                        else
                            return "<div class='webix_table_checkbox notchecked'><span class=\"webix_icon fa-square\"></span> "+LangHelper.GetString(_this.Id, "No")+"</div>";
                    },
                    width: 120,
                    headermenu: false
                },
                {
                    id: "date",
                    header: [LangHelper.GetString(_this.Id, "Date"), {content: "dateRangeFilter"}],
                    format: webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"),
                    sort: "date",
                    width:160
                },
                {
                    id: "hardware_hardware_id",
                    header: [LangHelper.GetString(_this.Id, "Equipment"), {
                        content: "multiSelectFilter",
                        options: App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }],
                    width:200,
                    template: function (obj)
                    {
                        return App.DicsManager.GetDic(DicsEnum.HardwaresDic)[obj.hardware_hardware_id] ? App.DicsManager.GetDic(DicsEnum.HardwaresDic)[obj.hardware_hardware_id].value : "";
                    },
                    sort: "string"
                },
                {
                    id: "importance",
                    header: [LangHelper.GetString(_this.Id, "Importance"),{
                        content: "multiSelectFilter",
                        options:[
                            {id:"CRITICAL", value:"CRITICAL"},
                            {id:"INFO", value:"INFO"},
                            {id:"COMMON", value:"COMMON"}
                        ],
                        inputConfig: {suggest: {fitMaster: false}}
                    }],
                    width:120,
                    sort: "string"
                },
                {
                    id: "text",
                    header: [LangHelper.GetString(_this.Id, "Message"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace: true,
                    sort: "string"
                },
                {
                    id: "trash",
                    header: "",
                    width: 32,
                    template: "<span class=\"webix_icon fa-trash\"></span>",
                    headermenu: false,
                    align:"right"
                }
            ],
            tooltip:true,
            data:[],
            on: {
                onCheck: function(row, column, state)
                {
                    if(column === 'readed')
                    {
                        var data = this.getItem(row);
                        _this.SetReaded([data]);
                    }

                    if(column == "checked")
                    {
                        if(state)
                            this.select(row, true);
                        else
                            this.unselect(row, true);

                    }

                },
                onAfterSelect:function(data, preserve)
                {
                    var item = this.getItem(data.id);

                    if(item)
                    {
                        if(!item.checked)
                        {
                            item.checked = 1;
                        }

                        this.updateItem(data.id, item);
                    }

                    _this.OnTableSelectChanged();
                },
                onAfterUnSelect:function(data)
                {
                    var item = this.getItem(data.id);

                    if(item && item.checked)
                    {
                        if(item.checked)
                        {
                            item.checked = 0;
                        }

                        this.updateItem(data.id, item);
                    }

                    _this.OnTableSelectChanged();
                },
                onItemClick: function (id,e,node)
                {

                    var rowData = this.getItem(id);

                    if(id.column === 'trash')
                    {
                        var __this = this;

                        setTimeout(function ()
                        {
                            var node = __this.getItemNode(id);
                            _this.DeleteContext.show(node, {pos:"bottom"});
                        }, 1);
                    }
                },
                onHeaderClick:function(id, e, target)
                {
                    if(id.column == "checked")
                    {
                        var cb = this.getHeaderContent("mc");
                        if(cb.isChecked())
                        {
                            this.selectAll();
                        }
                        else{
                            this.unselectAll();
                        }
                    }
                    return false;
                }
            }
        },
        {
            view: "pager",
            id: this.Id+"Table"+"Paging",
            master:false,
            template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            on: {
                onAfterPageChange:function(Page)
                {
                    _this.Refresh(Page);
                }
            }
        }
    ];

    this.ContextConfig = {
        view: "popup",
        maxWidth: 960,
        height: 640,
        id:this.Id + "Context",
        body: {
            borderless:true,
            rows:[]
        }
    };

    this.Context = null;

    this.TableSelectedCount = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};
}

HardwareNotificationsViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

HardwareNotificationsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    if(this.InContext)
    {
        this.ContextConfig.body.rows = this.ViewConfig;
        this.Context = webix.ui(this.ContextConfig);
    }

    this.Views.ReadSelectedBtn = $$(this.Id+"ReadSelectedBtn");
    this.Views.DeleteSelectedBtn = $$(this.Id+"DeleteSelectedBtn");
    this.Views.Table = $$(this.Id+"Table");
    this.Views.Paging = $$(this.Id+"Table"+"Paging");

    webix.extend(this.Views.Table, webix.ProgressBar);
    //webix.extend(this.Views.Views.Table, webix.OverlayBox);

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (DicUpdated)
    {
        if (DicUpdated)
        {
            _this.Views.Table.getColumnConfig("hardware_hardware_id").header[1].options = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);
        }
    });

    this.Context.attachEvent("onShow", function()
    {
        _this.Update();

        _this.Subscriptions.NotificationsSignalSubscription = App.NotificationsManager.NotificationsSignal.subscribe(function (Updated)
        {
            if (Updated)
            {
                _this.Update();
            }
        });

        _this.Refresh();
    });

    this.Context.attachEvent("onHide", function()
    {
        _this.Views.Table.clearAll();
        _this.Views.Table.parse([]);
        _this.Views.Table.hideProgress();

        if(_this.Subscriptions.NotificationsSignalSubscription)
        {
            _this.Subscriptions.NotificationsSignalSubscription.unsubscribe();
            delete _this.Subscriptions.NotificationsSignalSubscription;
        }
    });

    // this.TableSelectedCount.subscribe(function (Count)
    // {
    //     if(Count > 0)
    //     {
    //         _this.Views.ReadSelectedBtn.enable();
    //         _this.Views.DeleteSelectedBtn.enable();
    //     }
    //     else
    //     {
    //         _this.Views.ReadSelectedBtn.disable();
    //         _this.Views.DeleteSelectedBtn.disable();
    //     }
    // });
};

HardwareNotificationsViewController.prototype.Refresh = function(Page)
{
    var _this = this;

    this.Views.Table.showProgress({type: "icon"});

    App.NotificationsManager.RefreshLastNotifications({Page:Page, callback:function ()
    {
        _this.Views.Table.hideProgress();
    }});
};

HardwareNotificationsViewController.prototype.Update = function()
{
    var data = this.ViewModel.GetNotifications();

    var state = this.Views.Table.getState();

    this.Views.Table.getColumnConfig("hardware_hardware_id").header[1].options = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    this.Views.Table.clearAll();
    this.Views.Table.parse(data);

    this.Views.Table.filterByAll();

    if(state && state.sort)
    {
        this.Views.Table.sort(state.sort.id, state.sort.dir);
    }

    this.Views.Paging.define(this.ViewModel.Total);
    this.Views.Paging.refresh();
};

HardwareNotificationsViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node, Pos);
};

HardwareNotificationsViewController.prototype.Hide = function()
{
    this.Context.hide();
};

HardwareNotificationsViewController.prototype.SetReaded = function(Notifs)
{
    this.ViewModel.SetNotificationsReaded({Notifs:Notifs});
};

HardwareNotificationsViewController.prototype.SetSelectedReaded = function()
{
    var _this = this;

    var selectedData = this.GetTableSelectedData();

    if(selectedData)
    {
        if(!Array.isArray(selectedData))
        {
            selectedData = [selectedData];
        }

        this.ViewModel.SetSelectedNotificationsReaded({Notifs:selectedData, callback:function (R)
        {
            if(!R.success)
            {
                webix.message({type:"error", text:R.error.msg});
            }

            _this.Update();
        }});
    }
};

HardwareNotificationsViewController.prototype.DeleteSelected = function()
{
    var _this = this;

    var selectedData = this.GetTableSelectedData();

    if(selectedData)
    {
        if(!Array.isArray(selectedData))
        {
            selectedData = [selectedData];
        }

        this.ViewModel.DeleteSelectedNotifications({Notifs:selectedData, callback:function (R)
        {
            if(!R.success)
            {
                webix.message({type:"error", text:R.error.msg});
            }

            _this.Update();
        }});
    }
};

HardwareNotificationsViewController.prototype.DeleteAll = function()
{
    var _this = this;

    this.ViewModel.DeleteAllNotifications({callback:function (R)
    {
        if(!R.success)
        {
            webix.message({type:"error", text:R.error.msg});
        }

        _this.Refresh();
    }});
};

HardwareNotificationsViewController.prototype.ReadAll = function()
{
    var _this = this;

    this.ViewModel.SetAllNotificationsReaded({callback:function (R)
    {
        if(!R.success)
        {
            webix.message({type:"error", text:R.error.msg});
        }

        _this.Refresh();
    }});
};

HardwareNotificationsViewController.prototype.GetTableSelectedData = function ()
{
    return this.Views.Table.getSelectedItem();
};

HardwareNotificationsViewController.prototype.OnTableSelectChanged = function ()
{
    var data = this.GetTableSelectedData();
    this.TableSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

HardwareNotificationsViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};
function CreateTicketViewController(Params)
{
    var _this = this;

    this.Id = "CreateTicket";

    this.InContext = Params&&Params.InContext ? Params.InContext : false;

    this.Views = {
        Subject:null,
        Message:null,
        AlertLog:null,
        StatLog:null,
        UiLog:null,
        // Secure: null,
        // AddEmail: null
    };

    this.ViewConfig = [
        BlockHeaderTemplate({title:LangHelper.GetString(_this.Id, "Send a message"), icon:"bug"}),
        {
            view:"form",
            elements:[
                {
                    view: "richselect",
                    id:this.Id + "Subject",
                    label: LangHelper.GetString(_this.Id, "Message subject"),
                    name: "subject",
                    labelPosition: "top",
                    options:Helper.DictToArr(CreateTicketSubjectsDic),
                    value:1
                },
                {
                    view:"textarea",
                    id:this.Id + "Message",
                    label: LangHelper.GetString(_this.Id, "Message text"),
                    name: "text",
                    tooltip: LangHelper.GetString(_this.Id, "Enter here any text"),
                    labelPosition: "top"
                },
                {
                    view:"checkbox",
                    id:this.Id + "DpiAlertLog",
                    labelRight: LangHelper.GetString(_this.Id, "DPI message Log"),
                    name: "alertLog",
                    tooltip: LangHelper.GetString(_this.Id, "Log of information messages and errors"),
                    labelWidth:0,
                    value:1
                },
                {
                    view:"checkbox",
                    id:this.Id + "DpiStatLog",
                    labelRight: LangHelper.GetString(_this.Id, "DPI statistics log"),
                    name: "statLog",
                    tooltip: LangHelper.GetString(_this.Id, "DPI statistics log"),
                    labelWidth:0,
                    value:1
                },
                {
                    view:"checkbox",
                    id:this.Id + "DpiUi",
                    labelRight: LangHelper.GetString(_this.Id, "UI log"),
                    name: "uiLog",
                    tooltip: LangHelper.GetString(_this.Id, "UI log"),
                    value:1,
                    labelWidth:0
                },

                // могут быть удалены DpiSecure и AddEmail
                // {
                //     view: "richselect",
                //     id:this.Id + "DpiSecure",
                //     label: LangHelper.GetString(_this.Id, "Protocol"),
                //     name: "subject",
                //     labelPosition: "top",
                //     options:Helper.DictToArr(CreateTicketDPISecureDic),
                //     value:1
                // },
                // {
                //     view:"textarea",
                //     id:this.Id + "AddEmail",
                //     label: LangHelper.GetString(_this.Id, "Additional email"),
                //     name: "text",
                //     tooltip: LangHelper.GetString(_this.Id, "Enter here any text"),
                //     labelPosition: "top"
                // },


                {
                    view: "button",
                    type: "form",
                    label: LangHelper.GetString(_this.Id, "Send"),
                    click: function ()
                    {
                        _this.Send();
                    }
                }
            ]
        }
    ];

    this.ContextConfig = {
        view: "popup",
        maxWidth: 560,
        height: 560,
        id:this.Id + "Context",
        body: {
            borderless:true,
            rows:[]
        }
    };

    this.Context = null;

    this.Subscriptions = {};
}

CreateTicketViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

CreateTicketViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    if(this.InContext)
    {
        this.ContextConfig.body.rows = this.ViewConfig;
        this.Context = webix.ui(this.ContextConfig);
    }

    this.Views.Subject = $$(this.Id + "Subject");
    this.Views.Message = $$(this.Id + "Message");

    this.Views.AlertLog = $$(this.Id + "DpiAlertLog");
    this.Views.StatLog = $$(this.Id + "DpiStatLog");
    this.Views.UiLog = $$(this.Id + "DpiUi");

    // this.Views.Secure = $$(this.Id + "DpiSecure");
    // this.Views.AddEmail = $$(this.Id + "AddEmail");
};

CreateTicketViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

CreateTicketViewController.prototype.Show = function(Node, Pos, Message)
{
    this.Context.show(Node, {pos:Pos});
    this.Views.Message.setValue(Message?Message:"");
};

CreateTicketViewController.prototype.Hide = function()
{
    this.Context.hide();
};

CreateTicketViewController.prototype.Send = function()
{
    var _this = this;

    var params =
        {
            method:"SendError",
            data:{
                Params:{
                    hardware_id:App.SessionManager.GetCurrentHardwareId(),
                    subject:CreateTicketSubjectsDic[this.Views.Subject.getValue()].value,
                    body:this.Views.Message.getValue(),
                    alertLog:this.Views.AlertLog.getValue(),
                    statLog:this.Views.StatLog.getValue(),
                    uiLog:this.Views.UiLog.getValue(),

                    // могут быть удалены
                    // secure: CreateTicketDPISecureDic[this.Views.Secure.getValue()].value,
                    // addEmail: this.Views.AddEmail.getValue()
                }

            },
            callback:function (R)
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString(_this.Id, "Message sent successfully"));
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);

    this.Hide();
};
function DpiInfoViewController(Params)
{
    var _this = this;

    this.Id = "DpiInfo";

    this.InContext = Params&&Params.InContext ? Params.InContext : false;

    this.HasNewVersion = Params&&Params.HasNewFastDPIVersion ? Params.HasNewFastDPIVersion : false;

    this.Views =
        {
            Table:null
        };

    this.ViewConfig = [
        BlockHeaderTemplate({title:LangHelper.GetString("AppView", "Device information"), icon:"table"}),
        {
            view: "datatable",
            id: this.Id + "Table",
            columns: [
                {
                    id:"property_name",
                    header:LangHelper.GetString("AppView", "Property"),
                    fillspace: true
                },
                {
                    id:"property_value",
                    header:LangHelper.GetString("AppView", "Value"),
                    fillspace: true
                }
            ],
            data:[]
        }
    ];

    this.ContextConfig = {
        view: "popup",
        maxWidth: 500,
        height: 640,
        id:this.Id + "Context",
        body: {
            borderless:true,
            rows:[]
        }
    }
}

DpiInfoViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);

    this.Refresh();
};

DpiInfoViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    if(this.InContext)
    {
        this.ContextConfig.body.rows = this.ViewConfig;
        this.Context = webix.ui(this.ContextConfig);
    }

    this.Views.Table = $$(this.Id+"Table");
};

DpiInfoViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node, Pos);
};

DpiInfoViewController.prototype.Hide = function()
{
    this.Context.hide();
};

DpiInfoViewController.prototype.Refresh = function()
{
    var _this = this;

    var hardwareId = App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"GetDpiInfo",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (R)
            {
                if(R.success)
                {
                    if(R.data)
                    {
                        var data = [];

                        Object.keys(R.data).forEach(function (Key)
                        {
                                data.push({property_name:Key, property_value:R.data[Key]});
                        });

                        if(_this.HasNewVersion){
                            var ind = data.findIndex(function (Obj)
                            {
                                return Obj.property_name == "FastDPI";
                            });

                            if(ind >=0 ) {
                                data[ind].property_value =
                                    "<a href='https://wiki.vasexperts.ru/' target='_blank' title='"+LangHelper.GetString("AppView", "New version FastDPI is available")+" ("+_this.HasNewVersion+")"+"'>" +
                                    "<span class='webix_icon fa-exclamation-triangle' style='color: #27ae60;'></span></a>" + data[ind].property_value;
                            }
                        }

                        _this.Views.Table.clearAll();
                        _this.Views.Table.parse(data);
                    }
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
function QoEAdvcWizardWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.AdvcManager = new AdvcManager();

    this.QoEReportsManager = new QoEReportsManager();

    this.Config = null;

    this.ViewConfig = null;

    this.ContextConfig = null;

    this.Context = null;

    this.CampaignEditForm = new AdvcCampaignEditViewController({embedded:true, hide_save_btn:true});

    this.Subscriptions = {};

    this.CurrentStep = 0;

    this.CampaignFormdata = null;

    this.Data = null;

    this.Pos = {
        Node:null,
        Pos:"bottom"
    };

    this.Views =
        {
            Wizard:null,

            Steps:
                {
                    Step0: //Select profile
                        {
                            Cell:null,
                            Form:null
                        },

                    Step1: //New profile confirmation
                        {
                            Cell:null,
                            Form:null
                        },

                    Step2: //Select campaign
                        {
                            Cell:null,
                            Form:null
                        },

                    Step3: //New campaign confirmation
                        {
                            Cell:null,
                            Form:null
                        },

                    Step4: //Campaign edit form
                        {
                            Cell:null,
                            Form:null
                        },

                    Step5: //Select import subscribers by login or ip
                        {
                            Cell:null,
                            Form:null
                        }
                }
        };

    this.Init(ViewConfig);
}

QoEAdvcWizardWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.Config = ViewConfig.config ? ViewConfig.config : null;

    this.ContextConfig = {
        view: "popup",
        id:this.Id + "Context",
        maxWidth: 960,
        maxHeight: 720,
        resize: true,
        body: {
            borderless:true,
            rows:
                [
                    PageHeaderTemplate({root_title: LangHelper.GetString("QoESubscribers","Add subscribers to campaign")}),
                    //BlockHeaderTemplate({title:LangHelper.GetString("QoESubscribers","Add subscribers to campaign"), icon:"users"}),
                    {
                        view:"multiview",
                        id:this.Id + "Wizard",
                        cells:
                            [
                                {
                                    id:this.Id + "Wizard" + "Step0",
                                    rows:
                                        [
                                            {
                                                view:"form",
                                                id:this.Id + "Wizard" + "Step0" + "Form",
                                                elements:
                                                    [
                                                        {},
                                                        {
                                                            view:"text",
                                                            name:"campaign_profile",
                                                            label:LangHelper.GetString("Advc", "Campaign group"),
                                                            labelPosition: "top",
                                                            tooltip:LangHelper.GetString("Advc", "Select or create new group"),
                                                            required: true,
                                                            validate:function(Val)
                                                            {
                                                                return Val ? true : false;
                                                            },
                                                            invalidMessage: LangHelper.GetString("Advc", "Select or enter new group name"),
                                                            suggest:
                                                                {
                                                                    data:[]
                                                                }
                                                        },
                                                        {},
                                                        {
                                                            cols:
                                                                [
                                                                    {
                                                                        view:"button",
                                                                        label:LangHelper.GetString("All","Cancel"),
                                                                        click:function ()
                                                                        {
                                                                            _this.Hide();
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"button",
                                                                        type:"form",
                                                                        label:LangHelper.GetString("All","Next"),
                                                                        click:function ()
                                                                        {
                                                                            _this.GoStep(1);
                                                                        }
                                                                    }
                                                                ]
                                                        }
                                                    ]
                                            }
                                        ]
                                },
                                {
                                    id:this.Id + "Wizard" + "Step1",
                                    rows:[
                                        {
                                            view:"form",
                                            id:this.Id + "Wizard" + "Step1" + "Form",
                                            elements:
                                                [
                                                    {},
                                                    {
                                                        view:"label",
                                                        label:LangHelper.GetString("Advc", "A new group and campaign will be created. Continue?")
                                                    },
                                                    {},
                                                    {
                                                        cols:
                                                            [
                                                                {
                                                                    view:"button",
                                                                    label:LangHelper.GetString("All","Cancel"),
                                                                    click:function ()
                                                                    {
                                                                        _this.Hide();
                                                                    }
                                                                },
                                                                {
                                                                    view:"button",
                                                                    label:LangHelper.GetString("All","Back"),
                                                                    click:function ()
                                                                    {
                                                                        _this.GoStep(0);
                                                                    }
                                                                },
                                                                {
                                                                    view:"button",
                                                                    type:"form",
                                                                    label:LangHelper.GetString("All","Next"),
                                                                    click:function ()
                                                                    {
                                                                        _this.GoStep(2);
                                                                    }
                                                                }
                                                            ]
                                                    }
                                                ]
                                        }
                                    ]
                                },
                                {
                                    id:this.Id + "Wizard" + "Step2",
                                    rows:[
                                        {
                                            view:"form",
                                            id:this.Id + "Wizard" + "Step2" + "Form",
                                            elements:
                                                [
                                                    {},
                                                    {
                                                        view:"text",
                                                        name:"campaign",
                                                        label:LangHelper.GetString("Advc", "Campaign"),
                                                        labelPosition: "top",
                                                        tooltip:LangHelper.GetString("Advc", "Select or create new campaign"),
                                                        required: true,
                                                        validate:function(Val)
                                                        {
                                                            return Val ? true : false;
                                                        },
                                                        invalidMessage: LangHelper.GetString("Advc", "Выберите или введите новое название кампании"),
                                                        suggest:
                                                            {
                                                                data:[]
                                                            }
                                                    },
                                                    {},
                                                    {
                                                        cols:
                                                            [
                                                                {
                                                                    view:"button",
                                                                    label:LangHelper.GetString("All","Cancel"),
                                                                    click:function ()
                                                                    {
                                                                        _this.Hide();
                                                                    }
                                                                },
                                                                {
                                                                    view:"button",
                                                                    label:LangHelper.GetString("All","Back"),
                                                                    click:function ()
                                                                    {
                                                                        _this.GoStep(0);
                                                                    }
                                                                },
                                                                {
                                                                    view:"button",
                                                                    type:"form",
                                                                    label:LangHelper.GetString("All","Next"),
                                                                    click:function ()
                                                                    {
                                                                        _this.GoStep(3);
                                                                    }
                                                                }
                                                            ]
                                                    }
                                                ]
                                        }
                                    ]
                                },
                                {
                                    id:this.Id + "Wizard" + "Step3",
                                    rows:[
                                        {
                                            view:"form",
                                            id:this.Id + "Wizard" + "Step3" + "Form",
                                            elements:
                                                [
                                                    {},
                                                    {
                                                        view:"label",
                                                        label:LangHelper.GetString("Advc", "A new campaign will be created. Continue?")
                                                    },
                                                    {},
                                                    {
                                                        cols:
                                                            [
                                                                {
                                                                    view:"button",
                                                                    label:LangHelper.GetString("All","Cancel"),
                                                                    click:function ()
                                                                    {
                                                                        _this.Hide();
                                                                    }
                                                                },
                                                                {
                                                                    view:"button",
                                                                    label:LangHelper.GetString("All","Back"),
                                                                    click:function ()
                                                                    {
                                                                        _this.GoStep(2);
                                                                    }
                                                                },
                                                                {
                                                                    view:"button",
                                                                    type:"form",
                                                                    label:LangHelper.GetString("All","Next"),
                                                                    click:function ()
                                                                    {
                                                                        _this.GoStep(4);
                                                                    }
                                                                }
                                                            ]
                                                    }
                                                ]
                                        }
                                    ]
                                },
                                {
                                    id:this.Id + "Wizard" + "Step4",
                                    rows:[
                                        this.CampaignEditForm.ViewConfig,
                                        {
                                            view:"form",
                                            elements:
                                                [
                                                    {
                                                        cols:
                                                            [
                                                                {
                                                                    view:"button",
                                                                    label:LangHelper.GetString("All","Cancel"),
                                                                    click:function ()
                                                                    {
                                                                        _this.Hide();
                                                                    }
                                                                },
                                                                {
                                                                    view:"button",
                                                                    label:LangHelper.GetString("All","Back"),
                                                                    click:function ()
                                                                    {
                                                                        _this.GoStep(2);
                                                                    }
                                                                },
                                                                {
                                                                    view:"button",
                                                                    type:"form",
                                                                    label:LangHelper.GetString("All","Next"),
                                                                    click:function ()
                                                                    {
                                                                        _this.CampaignEditForm.Save();
                                                                    }
                                                                }
                                                            ]
                                                    }
                                                ]
                                        }
                                    ]
                                },
                                {
                                    id:this.Id + "Wizard" + "Step5",
                                    rows:
                                        [
                                            {
                                                view:"form",
                                                id:this.Id + "Wizard" + "Step5" + "Form",
                                                elements:
                                                    [
                                                        {},
                                                        {
                                                            view:"richselect",
                                                            name:"import_type",
                                                            label:LangHelper.GetString("Advc", "How to export subscribers"),
                                                            labelPosition: "top",
                                                            tooltip:LangHelper.GetString("Advc", "How to export subscribers"),
                                                            required: true,
                                                            options:
                                                            [
                                                                {id:"by_ip", value:LangHelper.GetString("Advc","By IP-address")},
                                                                {id:"by_login", value:LangHelper.GetString("Advc","By login")},
                                                                {id:"by_ip_if_empty_login", value:LangHelper.GetString("Advc","By IP-address if login is empty")}
                                                            ]
                                                        },
                                                        {
                                                            view:"richselect",
                                                            name:"import_max",
                                                            label:LangHelper.GetString("Advc", "Number of subscribers"),
                                                            labelPosition: "top",
                                                            tooltip:LangHelper.GetString("Advc", "Number of subscribers"),
                                                            required: true,
                                                            options:
                                                            [
                                                                {id:"0", value:LangHelper.GetString("Advc","All subscribers")},
                                                                {id:"1000", value:LangHelper.GetString("Advc","% subscribers").replace("%","1 000")},
                                                                {id:"10000", value:LangHelper.GetString("Advc","% subscribers").replace("%","10 000")},
                                                                {id:"100000", value:LangHelper.GetString("Advc","% subscribers").replace("%","100 000")},
                                                                {id:"1000000", value:LangHelper.GetString("Advc","% subscribers").replace("%","1 000 000")}
                                                            ]
                                                        },
                                                        {},
                                                        {
                                                            cols:
                                                                [
                                                                    {
                                                                        view:"button",
                                                                        label:LangHelper.GetString("All","Cancel"),
                                                                        click:function ()
                                                                        {
                                                                            _this.Hide();
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"button",
                                                                        label:LangHelper.GetString("All","Back"),
                                                                        click:function ()
                                                                        {
                                                                            _this.GoStep(4);
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"button",
                                                                        type:"form",
                                                                        label:LangHelper.GetString("All","Save"),
                                                                        click:function ()
                                                                        {
                                                                            _this.Save();
                                                                        }
                                                                    }
                                                                ]
                                                        }
                                                    ]
                                            }
                                        ]
                                }
                            ]
                    }
                ]
        }
    };

    this.Context = null;

};

QoEAdvcWizardWidget.prototype.Bind = function (ViewController)
{
    var _this = this;

    this.Context = webix.ui(this.ContextConfig);

    this.Views.Wizard = $$(this.Id + "Wizard");

    this.CampaignEditForm.BindAll();

    Object.keys(this.Views.Steps).forEach(function (Key)
    {
        _this.Views.Steps[Key].Cell = $$(_this.Id + "Wizard" + Key);

        _this.Views.Steps[Key].Form = $$(_this.Id + "Wizard" + Key + "Form");
    });

    this.Subscriptions.ProfileUpdated = this.AdvcManager.AdvProfilesUpdated.subscribe(function (Updated)
    {
        _this.UpdateProfileSuggest();
    });

    this.Subscriptions.AdvCompaniesUpdated = this.AdvcManager.AdvCompaniesUpdated.subscribe(function (Updated)
    {
        _this.UpdateCampaignSuggest();
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshProfiles();
        }
    });

    this.Subscriptions.SignalSaveCompany = this.CampaignEditForm.SaveCampaignSignal.subscribe(function(FormData)
    {
        if(FormData)
        {
            _this.CampaignFormdata = FormData;

            _this.GoStep(5);
        }
    }
    );
};

QoEAdvcWizardWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    delete this.AdvcManager;
};

QoEAdvcWizardWidget.prototype.Show = function (Node, Pos, Data)
{
    if(!Data)
        return;

    this.Data = Data;

    this.JustShow(Node, Pos);

    this.Reset();
};

QoEAdvcWizardWidget.prototype.JustShow = function (Node, Pos)
{
    if(Node)
        this.Pos.Node = Node;

    if(Pos)
        this.Pos.Pos = Pos;

    this.Context.show(this.Pos.Node,{pos:this.Pos.Pos});
};

QoEAdvcWizardWidget.prototype.Hide = function ()
{
    this.Reset();
    this.Context.hide();
};

QoEAdvcWizardWidget.prototype.Reset = function ()
{
    var _this = this;

    this.GoStep(0);

    Object.keys(this.Views.Steps).forEach(function (Key)
    {
        var form = _this.Views.Steps[Key].Form;

        if(form)
        {
            form.clearValidation();
            form.clear();
        }
    });

    this.CampaignFormdata = null;
};

QoEAdvcWizardWidget.prototype.SetSize = function (Size)
{
    var size = Size ? Size : "compact";

    if(size == "compact")
    {
        this.Context.define("maxWidth", 480);
        this.Context.define("maxHeight", 400);
    }
    else
    {
        this.Context.define("maxWidth", 960);
        this.Context.define("maxHeight", 720);
    }

    this.Context.resize();
    this.JustShow();
};

QoEAdvcWizardWidget.prototype.RefreshProfiles = function ()
{
    var _this = this;

    this.AdvcManager.Refresh();
};

QoEAdvcWizardWidget.prototype.UpdateProfileSuggest = function ()
{
    var opts = Helper.DictToArr(this.AdvcManager.GetAdvProfilesAsDic());

    var list = $$(this.Views.Steps.Step0.Form.elements.campaign_profile.config.suggest).getList();

    list.clearAll();
    list.parse(opts);
};

QoEAdvcWizardWidget.prototype.GetSelectedProfileId = function ()
{
    var id = 0;

    var value = this.Views.Steps.Step0.Form.elements.campaign_profile.getValue();

    var dic = this.AdvcManager.GetAdvProfilesAsDic();

    if(value && dic)
    {
        Object.keys(dic).every(function (Key)
        {
            if(dic[Key].value == value)
            {
                id = Key;
                return false;
            }

            return true;
        });
    }

    return id;
};

QoEAdvcWizardWidget.prototype.RefreshCampaigns = function ()
{
    var _this = this;

    this.AdvcManager.RefreshAdvCompanies({profile_id:this.GetSelectedProfileId()});
};

QoEAdvcWizardWidget.prototype.UpdateCampaignSuggest = function ()
{
    var opts = Helper.DictToArr(this.AdvcManager.GetAdvCampaignsAsDic());

    var list = $$(this.Views.Steps.Step2.Form.elements.campaign.config.suggest).getList();

    list.clearAll();
    list.parse(opts);
};

QoEAdvcWizardWidget.prototype.GetSelectedCampaignId = function ()
{
    var id = 0;

    var value = this.Views.Steps.Step2.Form.elements.campaign.getValue();

    var dic = this.AdvcManager.GetAdvCampaignsAsDic();

    if(value && dic)
    {
        Object.keys(dic).every(function (Key)
        {
            if(dic[Key].value == value)
            {
                id = Key;
                return false;
            }

            return true;
        });
    }

    return id;
};

QoEAdvcWizardWidget.prototype.GoStep = function (Step)
{
    if(this["GoStep"+Step])
        this["GoStep"+Step]();
    else
        this.GoStep0();
};

QoEAdvcWizardWidget.prototype.GoStep0 = function ()
{
    this.Views.Steps.Step0.Cell.show();

    this.CurrentStep = 0;

    this.SetSize("compact");
};

QoEAdvcWizardWidget.prototype.GoStep1 = function ()
{
    if(this.CurrentStep == 0)
    {
        if(!this.Views.Steps.Step0.Form.validate())
            return;
    }

    if(this.GetSelectedProfileId())
    {
        this.GoStep(2);
        return;
    }

    this.Views.Steps.Step1.Cell.show();

    this.CurrentStep = 1;
};

QoEAdvcWizardWidget.prototype.GoStep2 = function ()
{
    if(!this.GetSelectedProfileId())
    {
        if(this.CurrentStep == 4)
            this.GoStep(0);
        else
            this.GoStep(4);



        return;
    }

    this.RefreshCampaigns();

    this.Views.Steps.Step2.Cell.show();

    this.CurrentStep = 2;

    this.SetSize("compact");
};

QoEAdvcWizardWidget.prototype.GoStep3 = function ()
{
    if(this.CurrentStep == 2)
    {
        if(!this.Views.Steps.Step2.Form.validate())
            return;
    }

    if(this.GetSelectedCampaignId())
    {
        this.GoStep(4);
        return;
    }

    this.Views.Steps.Step3.Cell.show();

    this.CurrentStep = 3;
};

QoEAdvcWizardWidget.prototype.GoStep4 = function ()
{
    var formData = this.AdvcManager.GetAdvCampaignById(this.GetSelectedCampaignId());

    if(!formData)
    {
        formData = new AdvCompanyModel({profile_id: this.GetSelectedProfileId()});

        formData.title = this.Views.Steps.Step2.Form.elements.campaign.getValue();
        formData.from_time = '00:00';
        formData.to_time = '23:59';
        formData.days_of_week = '1,2,3,4,5,6,7';
    }

    this.CampaignEditForm.SetData(formData);

    this.Views.Steps.Step4.Cell.show();

    this.CurrentStep = 4;

    this.SetSize("big");
};

QoEAdvcWizardWidget.prototype.GoStep5 = function ()
{
    if(!this.CampaignFormdata)
        return;

    this.Views.Steps.Step5.Form.elements.import_type.setValue("by_ip");
    this.Views.Steps.Step5.Form.elements.import_max.setValue("0");

    this.Views.Steps.Step5.Cell.show();

    this.CurrentStep = 5;

    this.SetSize("compact");
};

QoEAdvcWizardWidget.prototype.Save = function ()
{
    this.SaveProfile();
};

QoEAdvcWizardWidget.prototype.SaveProfile = function()
{
    var _this = this;

    var profileData = this.AdvcManager.GetAdvProfileById(this.GetSelectedProfileId());

    if(profileData)
    {
        this.SaveCampaign(profileData);
        return;
    }

    profileData = new AdvProfileModel({
        title:this.Views.Steps.Step0.Form.elements.campaign_profile.getValue(),
        hardware_id:App.SessionManager.GetCurrentHardwareId()
    });

    this.AdvcManager.SaveProfile(
    {
        profile: profileData,
        callback: function(R)
        {
            if(R.success && R.data && R.data.profile)
            {
                _this.RefreshProfiles();

                _this.SaveCampaign(R.data.profile);

                webix.message(LangHelper.GetString("Advc", "Group saved"));

            }
            else
            {
                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

QoEAdvcWizardWidget.prototype.SaveCampaign = function(ProfileData)
{
    var _this = this;

    var data = webix.copy(this.CampaignFormdata);

    data.profile_id = ProfileData.profile_id;

    this.AdvcManager.SaveCompany(
    {
        company: data,
        callback: function(R)
        {
            if(R.success && R.data && R.data.adc)
            {
                _this.CampaignFormdata = R.data.adc;

                webix.message(LangHelper.GetString("Advc", "Campaign saved"));

                _this.SaveImportTask({adc_id:_this.CampaignFormdata.adc_id, hardware_id:ProfileData.hardware_id});
            }
            else
            {
                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

QoEAdvcWizardWidget.prototype.SaveImportTask = function(HwCampaignData)
{
    var data = webix.copy(this.Data);

    data.Type = this.Views.Steps.Step5.Form.elements.import_type.getValue();

    data.Max = this.Views.Steps.Step5.Form.elements.import_max.getValue();

    data.HwCampaignData = HwCampaignData;

    if(data.Type == "by_ip")
    {
        data.Config.rows = ["subscriber"];
        //data.Config.values = [{col:"", alias:"total", func:"count"}];
    }

    if(data.Type == "by_login")
    {
        data.Config.rows = [{col:"login",alias:"subscriber"}];
        //data.Config.values = [{col:"", alias:"total", func:"count"}];

        data.Params.filter.login_not_empty = {id:"login", operator:"!=", value:""};
    }

    if(data.Type == "by_ip_if_empty_login")
    {
        data.Config.rows = [{col:"subscriber_login",alias:"subscriber"}];
        //data.Config.values = [{col:"", alias:"total", func:"count"}];
    }

    this.QoEReportsManager.ExpSubscribersToAdvc(data,function (R)
    {
        if(R.success)
            webix.message(LangHelper.GetString("Advc", "The task of importing successfully launched"));
        else
            webix.message({text: R.error.msg,type:"error"});
    });

    this.Hide();
};
function QoEFiltersWizardWidgetApplyModel (Params) {
    this.title = Params && Params.title ? Params.title: "";
    this.values = Params && Params.values ? Params.values : null;
};

function QoEOnlineReportsFiltersWizardWidget(ViewConfig) {
    this.ViewConfig = null;

    this.Context = null;

    this.Subscriptions = {};

    this.State = null;

    this.Views = {
        Wizard: null,

        Steps: {
            //Select type of capture
            Step0: {
                Cell:null,
                Form:null
            },
            //New subscriber login/subscriber
            Step1: {
                Cell:null,
                Form:null
            },
            //New host/host_ip
            Step2: {
                Cell:null,
                Form:null
            }
        }
    };

    this.CurrentStep = null;

    this.Node = null;

    this.ApplySignal = new Rx.BehaviorSubject(0);

    this.Init(ViewConfig);
};

QoEOnlineReportsFiltersWizardWidget.prototype.Init = function(ViewConfig) {
    const _this = this;

    if(!ViewConfig)
        return

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.ContextConfig = {
        view: "popup",
        maxWidth: 400,
        maxHeight: 220,
        modal:true,
        body: {
            borderless: true,
            rows: [
                {
                    view: "multiview",
                    height:210,
                    id: this.Id + "Wizard",
                    cells: [
                        {
                            id: this.Id + "Wizard" + "Step0",
                            rows: [
                                {
                                    view: "form",
                                    id: this.Id + "Wizard" + "Step0" + "Form",
                                    elements: [
                                        {},
                                        {
                                            view: "richselect",
                                            id: this.Id + "FlowCaptureTypeSelect",
                                            name: "flow_capture_select",
                                            label: LangHelper.GetString("QoE", "Capture type"),
                                            labelWidth: 120,
                                            value: 1,
                                            options: [
                                                {id: 1, value: LangHelper.GetString("QoE", "Subscriber flow capture")},
                                                {id: 2, value: LangHelper.GetString("QoE", "Host flow capture")}
                                            ]
                                        },
                                        {},
                                        {
                                            cols: [
                                                {
                                                    view: "button",
                                                    value: LangHelper.GetString("All", "Cancel"),
                                                    click: function() {
                                                        _this.Hide()
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    type: "form",
                                                    hotkey: "Enter",
                                                    value: LangHelper.GetString("All", "Next"),
                                                    click: function() {
                                                        _this.GoStep(_this.Views.Steps.Step0.Form.getValues().flow_capture_select);
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: this.Id + "Wizard" + "Step1",
                            rows: [
                                {
                                    view: "form",
                                    id: this.Id + "Wizard" + "Step1" + "Form",
                                    elements: [
                                        {
                                            view: "text",
                                            name: "login",
                                            label: LangHelper.GetString("QoE", "Subscriber login"),
                                            labelWidth: 125,
                                            labelAlign: "left",
                                            bottomPadding: 20,
                                            validate: function(Val) {
                                                var values = _this.Views.Steps.Step1.Form.getValues();
                                                if(Object.keys(values).every(Key => values[Key] === "")) {
                                                    return false;
                                                }

                                                return true;
                                            },
                                            invalidMessage: LangHelper.GetString("QoE", "At least one field must be filled")
                                        },
                                        {
                                            view: "text",
                                            name: "subscriber",
                                            label: LangHelper.GetString("QoE", "Subscriber IP"),
                                            labelWidth: 125,
                                            labelAlign: "left",
                                            bottomPadding: 20,
                                            validate: function(Val) {
                                                var values = _this.Views.Steps.Step1.Form.getValues();
                                                if(Object.keys(values).every(Key => values[Key] === "")) {
                                                    return false;
                                                }

                                                return true;
                                            },
                                            invalidMessage: LangHelper.GetString("QoE", "At least one field must be filled")
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: "button",
                                                    value: LangHelper.GetString("All", "Cancel"),
                                                    click: function() {
                                                        _this.ClearForm(_this.Views.Steps.Step1.Form);
                                                        _this.Hide();
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    label: LangHelper.GetString("All", "Back"),
                                                    click: function () {
                                                        _this.ClearForm(_this.Views.Steps.Step1.Form);
                                                        _this.GoStep(0);
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    type: "form",
                                                    hotkey: "Enter",
                                                    label: LangHelper.GetString("QoE", "Capture"),
                                                    click: function() {
                                                        _this.Apply();
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: this.Id + "Wizard" + "Step2",
                            rows: [
                                {
                                    view: "form",
                                    id: this.Id + "Wizard" + "Step2" + "Form",
                                    elements: [
                                        {
                                            view: "text",
                                            name: "host",
                                            label: LangHelper.GetString("QoE", "Host"),
                                            labelWidth: 80,
                                            bottomPadding: 20,
                                            validate: function(Val) {
                                                var values = _this.Views.Steps.Step2.Form.getValues();
                                                if(Object.keys(values).every(Key => values[Key] === "")) {
                                                    return false;
                                                }

                                                return true;
                                            },
                                            invalidMessage: LangHelper.GetString("QoE", "At least one field must be filled")
                                        },
                                        {
                                            view: "text",
                                            name: "host_ip",
                                            label: LangHelper.GetString("QoE", "Host IP"),
                                            labelWidth: 80,
                                            bottomPadding: 20,
                                            validate: function(Val) {
                                                var values = _this.Views.Steps.Step2.Form.getValues();
                                                if(Object.keys(values).every(Key => values[Key] === "")) {
                                                    return false;
                                                }

                                                return true;
                                            },
                                            invalidMessage: LangHelper.GetString("QoE", "At least one field must be filled")
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: "button",
                                                    value: LangHelper.GetString("All", "Cancel"),
                                                    click: function() {
                                                        _this.ClearForm(_this.Views.Steps.Step2.Form);
                                                        _this.Hide();
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    label: LangHelper.GetString("All", "Back"),
                                                    click: function () {
                                                        _this.ClearForm(_this.Views.Steps.Step2.Form);
                                                        _this.GoStep(0);
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    type: "form",
                                                    hotkey: "Enter",
                                                    label: LangHelper.GetString("QoE", "Capture"),
                                                    click: function() {
                                                        _this.Apply();
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };
};

QoEOnlineReportsFiltersWizardWidget.prototype.Bind = function() {
    this.Context = webix.ui(this.ContextConfig);

    this.Views.Wizard = $$(this.Id + "Wizard");
    this.Views.FlowCaptureTypeSelect = $$(this.Id + "FlowCaptureTypeSelect");

    Object.keys(this.Views.Steps).forEach(Key => {
        this.Views.Steps[Key].Cell = $$(this.Id + "Wizard" + Key);

        this.Views.Steps[Key].Form = $$(this.Id + "Wizard" + Key + "Form");
    });

    this.GoStep0();
};

QoEOnlineReportsFiltersWizardWidget.prototype.Destroy = function () {
    Object.keys(this.Subscriptions).forEach(Key => {
        this.Subscriptions[Key].unsubscribe();
    });
};

QoEOnlineReportsFiltersWizardWidget.prototype.GoStep = function(Step) {
    if(this["GoStep"+Step])
        this["GoStep"+Step]();
    else
        this.GoStep0();
};

QoEOnlineReportsFiltersWizardWidget.prototype.GoStep0 = function() {
    this.CurrentStep = 0;
    if(this.Context) {
        this.Views.Steps.Step0.Cell.show(this.Node, {type:"slide", subtype:"together"});
    }
};

QoEOnlineReportsFiltersWizardWidget.prototype.GoStep1 = function() {
    this.CurrentStep = 1;
    this.Views.Steps.Step1.Cell.show(this.Node, {type:"slide", subtype:"together"});
    setTimeout(() => {this.ClearForm(this.Views.Steps.Step1.Form)}, 1);
};

QoEOnlineReportsFiltersWizardWidget.prototype.GoStep2 = function() {
    this.CurrentStep = 2;
    this.Views.Steps.Step2.Cell.show(this.Node, {type:"slide", subtype:"together"});
    setTimeout(() => {this.ClearForm(this.Views.Steps.Step2.Form)});
};

QoEOnlineReportsFiltersWizardWidget.prototype.Show = function(Node, Pos) {
    this.GoStep0();
    this.Context.show(Node, Pos);
    this.Node = Node;
};

QoEOnlineReportsFiltersWizardWidget.prototype.Apply = function() {
    const val = this.Views.Steps["Step"+this.CurrentStep].Form.validate();
    if(val) {
        const formValues = this.Views.Steps["Step"+this.CurrentStep].Form.getValues();

        const values = {};
        let title = "";
        Object.keys(formValues).forEach(Key => {
           if(formValues[Key]) {
               values[Key] = formValues[Key];
               title += formValues[Key] + "_";
           }
        });

        title = title.slice(0, -1);

        this.State = new QoEFiltersWizardWidgetApplyModel({title, values});

        this.ApplySignal.next(1);

        this.Hide();
        this.ClearForm(this.Views.Steps["Step"+this.CurrentStep].Form);
    }
};

QoEOnlineReportsFiltersWizardWidget.prototype.Hide = function () {
    this.Context.hide();
};

QoEOnlineReportsFiltersWizardWidget.prototype.ClearForm = function(Form) {
    if(Form) {
        Form.clear();
        Form.clearValidation();
    }
};

QoEOnlineReportsFiltersWizardWidget.prototype.GetState = function() {
    return webix.copy(this.State);
};

QoEOnlineReportsFiltersWizardWidget.prototype.ResetState = function() {
    this.State = null;
};
function LicenseInfoViewController(Params)
{
    var _this = this;

    this.Id = "LicenseInfo";

    this.InContext = Params&&Params.InContext ? Params.InContext : false;

    this.Views =
        {
            Table:null
        };

    this.ViewConfig = [
        BlockHeaderTemplate({title:LangHelper.GetString("AppView", "License information"), icon:"table"}),
        {
            view: "datatable",
            id: this.Id + "Table",
            columns: [
                {
                    id:"property_name",
                    header:LangHelper.GetString("AppView", "Property"),
                    fillspace: true
                },
                {
                    id:"property_value",
                    header:LangHelper.GetString("AppView", "Value"),
                    fillspace: true
                }
            ],
            data:[]
        }
    ];

    this.ContextConfig = {
        view: "popup",
        maxWidth: 400,
        height: 640,
        id:this.Id + "Context",
        body: {
            borderless:true,
            rows:[]
        }
    }
}

LicenseInfoViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);

    this.Refresh();
};

LicenseInfoViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    if(this.InContext)
    {
        this.ContextConfig.body.rows = this.ViewConfig;
        this.Context = webix.ui(this.ContextConfig);
    }

    this.Views.Table = $$(this.Id+"Table");
};

LicenseInfoViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node, Pos);
};

LicenseInfoViewController.prototype.Hide = function()
{
    this.Context.hide();
};

LicenseInfoViewController.prototype.Refresh = function()
{
    var _this = this;

    var hardwareId = App.SessionManager.GetCurrentHardwareId();

    var params =
        {
            method:"GetLicenseInfo",
            data:{Id:parseInt(hardwareId,10)},
            callback:function (R)
            {
                if(R.success)
                {
                    if(R.data)
                    {
                        var data = [];

                        R.data.split('\n').forEach(function (Item)
                        {
                            var item = Item.split('=');
                            data.push(
                                {
                                    property_name: item[0].replace('_', ' '),
                                    property_value: item[1] ? item[1] : ''
                                }
                            );
                        });

                        _this.Views.Table.clearAll();
                        _this.Views.Table.parse(data);
                    }
                }
                else
                {
                    webix.message({type:"error", text:R.error.msg});
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
function MailingTemplatesEditWidget(Params)
{
    let _this = this;

    this.Id = Params && Params.id ? Params.id : "MailingTemplatesEditWidget";

    this.ViewType = Params && Params.view_type ? Params.view_type : MailingTemplatesWidgetViewTypes.build_in;

    this.ContextType = null;

    this.Manager = null;

    this.ViewController = null;

    this.ProvidedModel = null;

    this.Observer = null;

    this.EditorInstance = null;

    this.Signals = {
        CancelBtnClick: new Rx.BehaviorSubject(0)
    };

    this.Subscriptions = {};

    this.GetEditorKey = (type) => { return type && type === MailingTemplatesTypesEnum.http ? "TextArea" : "NicEditor"; };

    this.Views = {
        Common: {
            Widget: null,
            TemplateContext: null,
            EmptyContext: null,
            Toolbar: null,
            Form: null,
            ActionForm: null
        },
        Header: {
            ViewTemplate: null,
            EditTemplate: null,
            AddTemplate: null
        },
        ToolbarElmnts: {
            RestoreBtn: null,
            DefaultTemplateBtn: null,
            OptionsBtn: null
        },
        EditorLabels: {
            Label: null,
            InvalidLabel: null,
        },
        EditorElmnts: {
            NicEditor: null,
            TextArea: null
        },
        ActionBtns: {
            SaveBtn: null,
            CancelBtn: null,
            EditBtn: null
        },
        Popups: {
            Widget: null,
            DefaultTemplatesMenu: null,
            TemplateOptions: null
        }
    };

    this.ElmntsSizes = {
        formLabelWidth: 200
    };

    this.GetHelpBtnConfig = function(Key)
    {
        let helpData = {
            period_in_filename: LangHelper.GetString("MailingTemplates", "Display period in filename") + "."
        };

        return {
            view:"button",
            type:"icon",
            icon:"question-circle",
            css:"toolbar_round_btn",
            height:48,
            width:48,
            popup:{
                view:"popup",
                body:{
                    borderless:true,
                    scroll:true,
                    template:Key && helpData[Key] ? helpData[Key] : ""
                }
            }
        };
    };

    this.ElmntsConfig = {
        Common: {
            Widget: {
                id: this.Id + "Common" + "Widget",
                rows: []
            },
            TemplateContext: {
                id: this.Id + "Common" + "TemplateContext",
                rows: []
            },
            EmptyContext: {
                id: this.Id +  "Common" + "EmptyContext",
                rows: [
                    {},
                    {
                        view: "label",
                        label: LangHelper.GetString("MailingTemplates", "Please, select template or create new"),
                        align: "center"
                    },
                    {}
                ]
            },
            Toolbar: {
                id: this.Id +  "Common" + "Toolbar",
                view: "toolbar",
                borderless: true,
                elements: []
            },
            Form: {
                id: this.Id + "Common" + "Form",
                view: "form",
                borderless: true,
                elements: []
            },
            ActionForm: {
                id: this.Id + "Common" + "ActionForm",
                view: "form",
                borderless: true,
                elements: [{
                        cols: []
                }]
            }
        },
        Header: {
            ViewTemplate: BlockHeaderTemplate({
                id: this.Id + "Header" + "ViewTemplate",
                title: LangHelper.GetString("MailingTemplates", "View template"),
                icon: "eye",
                height: 40,
                borderless: true
            }),
            EditTemplate: BlockHeaderTemplate({
                id: this.Id + "Header" + "EditTemplate",
                title: LangHelper.GetString("MailingTemplates", "Edit template"),
                icon:"pencil",
                height:40,
                borderless: true
            })
        },
        ToolbarElmnts: {
            RestoreBtn: {
                id: this.Id + "ToolbarElmnts" + "RestoreBtn",
                view: "button",
                css: "toolbar_round_btn",
                type: "icon",
                icon: "repeat",
                tooltip: LangHelper.GetString("MailingTemplates","Restore template"),
                width: 32,
                click: function () {
                    _this.Show(_this.ProvidedModel, _this.ContextType);
                }
            },
            DefaultTemplateBtn: {
                id: this.Id + "ToolbarElmnts" + "DefaultTemplateBtn",
                view: "button",
                css: "toolbar_round_btn",
                type: "icon",
                icon: "file-code",
                tooltip: LangHelper.GetString("MailingTemplates","Set default template"),
                width: 32,
                click: function() {
                    let type = _this.Views.Common.Form.elements["type"].getValue();
                    let find = _this.Manager.DefaultTemplatesList.filter(Item => Item.type === type);

                    if(_this.Views.Popups.DefaultTemplatesMenu.isVisible())
                    {
                        _this.Views.Popups.DefaultTemplatesMenu.hide();
                    }
                    else if(find && find.length > 1)
                    {
                        let exist = _this.Views.Popups.DefaultTemplatesMenu.serialize();
                        exist.map(Item => _this.Views.Popups.DefaultTemplatesMenu.remove(Item.id));

                        let data = find.reduce((Acc, Item) => {
                            Acc.push({id: Item._id, value: Item.name});
                            return Acc;
                        }, []);

                        _this.Views.Popups.DefaultTemplatesMenu.define({data: data});
                        _this.Views.Popups.DefaultTemplatesMenu.refresh();
                        _this.Views.Popups.DefaultTemplatesMenu.resize();

                        _this.Views.Popups.DefaultTemplatesMenu.show(this.getNode(), {pos:"left"});
                    }
                    else if(find && (find.length === 1))
                    {
                        _this.Views.EditorElmnts.NicEditor.setValue(find[0].template);
                    }
                }
            },
            OptionsBtn: {
                id: this.Id + "ToolbarElmnts" + "OptionsBtn",
                view: "button",
                css: "toolbar_round_btn",
                type: "icon",
                icon: "code",
                tooltip: LangHelper.GetString("MailingTemplates","Template options"),
                width: 32,
                click: function () {
                    if(_this.Views.Popups.TemplateOptions.isVisible())
                        _this.Views.Popups.TemplateOptions.hide()
                    else
                        _this.Views.Popups.TemplateOptions.show(this.getNode(), {pos: "right"});
                }
            }
        },
        EditorLabels: {
            Label: {
            id: this.Id + "EditorLabels" + "Label",
            view: "label",
            label: LangHelper.GetString("QoE","Message")
            },
            InvalidLabel: {
            id: this.Id + "EditorLabels" + "InvalidLabel",
            view: "label",
            css: {"color": "#fd595f"},
            hidden: true,
            label: LangHelper.GetString("QoE","The field cannot be empty")
            },
        },
        EditorElmnts: {
            NicEditor: {
                id: this.Id + "EditorElmnts" + "NicEditor",
                view: "nic-editor",
                css: "dpiui2_selectable",
                name: "template",
                labelPosition: "top",
                labelHeight: 0,
                labelWidth: 0,
                minHeight: 240,
                validate: webix.rules.isNotEmpty,
                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                readOnly: true,
                config: {
                    fullPanel: true
                }
            },
            TextArea: {
                id: this.Id + "EditorElmnts" + "TextArea",
                view: "textarea",
                on: {
                    onChange: function() {
                        let isValid = _this.ValidateEditor(MailingTemplatesTypesEnum.http);
                        _this.DefineToolbar();
                        _this.DefineInvalidLabel(isValid);
                        _this.DefineActionBtns();
                    }
                }
            }
        },
        FormElmnts: {
            name: {
                view: "text",
                name: "name",
                labelWidth: this.ElmntsSizes.formLabelWidth,
                label: LangHelper.GetString("MailingTemplates", "Template name"),
                tooltip: LangHelper.GetString("MailingTemplates", "Template name"),
                validate: webix.rules.isNotEmpty,
                invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                on: {
                    onChange: function() {
                        this.validate();
                        _this.DefineToolbar();
                        _this.DefineActionBtns();
                    },
                    onFocus: function() {
                        let node = this.getInputNode();
                        node.selectionStart = node.selectionEnd = node.value.length;
                    }
                }
            },
            type: {
                view: "richselect",
                name: "type",
                labelWidth: this.ElmntsSizes.formLabelWidth,
                label: LangHelper.GetString("MailingTemplates", "Template type"),
                placeholder: LangHelper.GetString("MailingTemplates", "Template type"),
                options: MailingTemplatesTypes,
                validate: webix.rules.isNotEmpty,
                invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                on: {
                    onChange: function (Nv, Ov) {
                        this.validate();

                        _this.DefineToolbar();

                        _this.SetEditorValue(
                            _this.GetEditorValue(Ov),
                            Nv === MailingTemplatesTypesEnum.http ? "TextArea" : "NicEditor"
                        )
                        _this.DefineEditorElmnts();
                        _this.DefineInvalidLabel(true);
                        _this.DefineActionBtns();
                    }
                }
            },
            period_in_filename: {
                cols: [
                    {
                        view: "richselect",
                            name: "period_in_filename",
                            labelWidth: this.ElmntsSizes.formLabelWidth,
                            label: LangHelper.GetString("MailingTemplates", "Display period"),
                            options: Helper.DictToArr(YesNoDic),
                            value: "0",                                     // Not work with richselect. Set default value by this.SetWidgetValues()
                            on: {
                            onChange: function (Nv, Ov) {
                                _this.DefineToolbar();
                                _this.DefineActionBtns();
                            }
                        }
                    },
                    this.GetHelpBtnConfig("period_in_filename")
                ]
            },
            username: {
                view: "text",
                name: "username",
                labelWidth: this.ElmntsSizes.formLabelWidth,
                label: LangHelper.GetString("QoE", "User"),
                placeholder: LangHelper.GetString("QoE", "User"),
                validate: webix.rules.isNotEmpty,
                invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty")
            },
            visibility: {
                view: "richselect",
                name: "visibility",
                labelWidth: this.ElmntsSizes.formLabelWidth,
                label: LangHelper.GetString("MailingTemplates", "Template visibility"),
                placeholder: LangHelper.GetString("MailingTemplates", "Template visibility"),
                options: MailingTemplatesVisibilityGroups,
                validate: webix.rules.isNotEmpty,
                invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                on: {
                    onChange: function () {
                        this.validate();
                        _this.DefineToolbar();
                        _this.DefineActionBtns();
                    }
                }
            }
        },
        ActionBtns: {
            SaveBtn: {
                id: this.Id + "ActionBtns" + "SaveBtn",
                view: "button",
                type: "form",
                label: LangHelper.GetString("AppView","Save"),
                width: 200,
                click: function () {
                    _this.SaveTemplate();
                }
            },
            CancelBtn: {
                id: this.Id + "ActionBtns" + "CancelBtn",
                view: "button",
                label: LangHelper.GetString("AppView","Cancel"),
                width: 200,
                click: function () {
                    _this.Cancel();
                }
            },
            EditBtn: {
                id: this.Id + "ActionBtns" + "EditBtn",
                view: "button",
                type: "form",
                label: LangHelper.GetString("AppView","Edit"),
                width: 200,
                click: function () {
                    _this.Show(
                        _this.ProvidedModel,
                        MailingTemplatesWidgetContextTypes.edit_template,
                        true
                    );
                }
            }
        },
        Popups: {
            Widget: {
                id: this.Id + "Popups" + "Widget",
                view: "popup",
                width: 900,
                maxHeight: 800,
                modal: true,
                position: {
                    my: "center",
                    at: "center",
                    of: webix.viewport
                },
                body: {},
                on: {
                    onKeyPress: function(Code, E) {
                        if(E.key === "Escape")
                            _this.Cancel();
                    }
                }
            },
            DefaultTemplatesMenu: {
                id: this.Id + "Popups" + "DefaultTemplatesMenu",
                view: "submenu",
                autowidth: true,
                data: [],
                on: {
                    onMenuItemClick: function(Id) {
                        let find = _this.Manager.DefaultTemplatesList.find(Item => Item._id == Id);

                        if(find)
                            _this.SetEditorValue(
                                find.template,
                                find.type === MailingTemplatesTypesEnum.http ? "TextArea" : "NicEditor",
                                false
                            );

                        this.hide();
                    }
                }
            },
            TemplateOptions: {
                id: this.Id + "Popups" + "TemplateOptions",
                view: "popup",
                maxWidth: 800,
                maxHeight: 680,
                body: {
                    rows: [
                        {
                            height: 80,
                            borderless: true,
                            template: LangHelper.GetString("QoE", "Select one or more identifiers (via shift or ctr). Use ctrl + c to copy and ctrl + v to insert a message into the template.") + "<br>" +
                                LangHelper.GetString("MailingTemplates", "Or double click to add item to the template.")
                        },
                        {
                            id: this + "ActionParamsContext" + "Table",
                            name: "headers",
                            view: "datatable",
                            select: "cell",
                            multiselect: true,
                            clipboard: "selection",
                            resizeColumn: true,
                            tooltip: true,
                            checkboxRefresh: true,
                            height: 560,
                            borderless: true,
                            columns: [
                                {
                                    id: "id",
                                    header: [TooltipTemplate(LangHelper.GetString("QoE", "Id"))],
                                    fillspace: 2
                                },
                                {
                                    id: "value",
                                    header: [TooltipTemplate(LangHelper.GetString("QoE", "Value"))],
                                    fillspace: 3
                                }
                            ],
                            data: Helper.DictToArr(QoETriggerAlertActionBodyTemplateParametersDic),
                            on: {
                                onItemDblClick: function(Id)
                                {
                                    if(Id.column === "id" && Id.row)
                                    {
                                        const type = _this.Views.Common.Form.elements["type"].getValue();
                                        const key = type === MailingTemplatesTypesEnum.http ? "TextArea" : "NicEditor";

                                        const idx = _this.GetCursorPos(key);
                                        let lines = _this.GetEditorValue(type);

                                        lines = idx ? lines.slice(0, idx) + Id.row + lines.slice(idx) : lines + Id.row;

                                        _this.SetEditorValue(lines, key, false);
                                    }
                                }
                            }
                        }
                    ]
                },
                on: {
                    onKeyPress: function(Code, E) {
                        if(E.key === "Escape")
                            this.hide();
                    }
                }
            }
        }
    };

    this.ElmntsConfig.Common.Form.elements = Object.values(this.ElmntsConfig.FormElmnts);

    this.ElmntsConfig.Common.Toolbar.elements = [
        this.ElmntsConfig.EditorLabels.Label,
        this.ElmntsConfig.EditorLabels.InvalidLabel,
        {},
        this.ElmntsConfig.ToolbarElmnts.RestoreBtn,
        this.ElmntsConfig.ToolbarElmnts.DefaultTemplateBtn,
        this.ElmntsConfig.ToolbarElmnts.OptionsBtn
    ];

    let actionBtns = [
        this.ElmntsConfig.ActionBtns.SaveBtn,
        this.ElmntsConfig.ActionBtns.EditBtn,
        this.ElmntsConfig.ActionBtns.CancelBtn,
        {},
    ];

    actionBtns.reverse();

    // if(this.ViewType && this.ViewType === MailingTemplatesWidgetViewTypes.popup)
    //     actionBtns.reverse();

    this.ElmntsConfig.Common.ActionForm.elements[0].cols = actionBtns;

    this.ElmntsConfig.Common.TemplateContext.rows = function() {
        let rows = [];

        if(_this.ViewType === MailingTemplatesWidgetViewTypes.popup)
            rows = rows.concat([
                _this.ElmntsConfig.Header.ViewTemplate,
                _this.ElmntsConfig.Header.EditTemplate
            ]);

        rows =  rows.concat([
            _this.ElmntsConfig.Common.Form,
            _this.ElmntsConfig.Common.Toolbar,
            _this.ElmntsConfig.EditorElmnts.NicEditor,
            _this.ElmntsConfig.EditorElmnts.TextArea,
            { height: 5 },
            _this.ElmntsConfig.Common.ActionForm
        ]);

        return rows;
    }();

    this.ElmntsConfig.Common.Widget.rows = [
        this.ElmntsConfig.Common.TemplateContext,
        this.ElmntsConfig.Common.EmptyContext
    ];

    this.ViewConfig = this.ElmntsConfig.Common.Widget;

    if(this.ViewType === MailingTemplatesWidgetViewTypes.popup)
        this.ElmntsConfig.Popups.Widget.body = this.ViewConfig;
    else
        delete this.Views.Popups.Widget;
}

MailingTemplatesEditWidget.prototype.Bind = function(ViewController = null, ViewModel = null)
{
    let _this = this;

    this.ViewController = ViewController;

    this.Manager = ViewModel ? ViewModel : new MailingTemplatesManager();

    Object.values(this.ElmntsConfig.Popups).forEach(ViewConfig => {
        webix.ui(ViewConfig);
    });

    Object.keys(this.Views).forEach(Key => {
       Object.keys(_this.Views[Key]).forEach(_key => {
           _this.Views[Key][_key] = $$(_this.Id + Key + _key);
       });
    });

    this.Observer = new MutationObserver((mutationsList) => {
        if(mutationsList && mutationsList.length)
        {
            let isValid = _this.ValidateEditor(MailingTemplatesTypesEnum.mail);
            _this.DefineToolbar();
            _this.DefineInvalidLabel(isValid);
            _this.DefineActionBtns();
        }
    });

    let editor = this.Views.EditorElmnts.NicEditor.getEditor(true);

    editor.then((Instance) => {
        _this.EditorInstance = Instance;
        _this.StartEditorObserver();
    });

    this.Subscriptions.RefreshDefaultTemplatesListError = this.Manager.Signals.RefreshDefaultTemplatesListError.subscribe(function(Error) {
        if(Error && Error.msg)
            webix.message({type: "error", text: Error.msg});
    });

    this.SetWidgetView();

    this.Manager.RefreshDefaultTemplateList();
};

MailingTemplatesEditWidget.prototype.Destroy = function()
{
    let _this = this;

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        if(_this.Subscriptions[Key])
            _this.Subscriptions[Key].unsubscribe();
    });

    this.Signals = {};

    if(this.Manager)
    {
        this.Manager.Destroy();
        delete this.Manager;
    }
};

MailingTemplatesEditWidget.prototype.Show = function(Model, ContextType = null, NeedToFocus = false)
{
    let _this = this;

    if(!this.Manager.CanUserManageItem(Model))
        ContextType = MailingTemplatesWidgetContextTypes.view_template;

    this.ClearWidgetValues();
    this.SetWidgetValues(Model, ContextType);
    this.SetWidgetView(ContextType);

    if(this.ViewType === MailingTemplatesWidgetViewTypes.popup)
        this.Views.Popups.Widget.show();

    let checks = [
        ContextType === MailingTemplatesWidgetContextTypes.edit_template,
        NeedToFocus
    ];

    if(checks.every(Boolean))
        setTimeout(() => {
            _this.Views.Common.Form.elements["name"].focus();
        }, 100);

};

MailingTemplatesEditWidget.prototype.SetWidgetValues = function(Params = null, ContextType = null)
{
    let _this = this;

    this.ProvidedModel = new MailingTemplateModel(Params);

    Object.keys(this.Views.Common.Form.elements).forEach(Key => {
        let value = undefined;

        if(_this.ProvidedModel && Object.hasOwn(_this.ProvidedModel, Key))
            value = _this.ProvidedModel[Key];

        if(_this.ProvidedModel.options && Object.hasOwn(_this.ProvidedModel.options, Key))
            value = _this.ProvidedModel.options[Key];

        if(value !== undefined)
        {
            let el = _this.Views.Common.Form.elements[Key];
            el.blockEvent();
            el.setValue(value);
            el.unblockEvent();
        }
    });

    if(this.ProvidedModel.template)
    {
        let key = this.GetEditorKey(this.Views.Common.Form.elements["type"].getValue());
        this.SetEditorValue(this.ProvidedModel.template, key);
    }
};

MailingTemplatesEditWidget.prototype.GetWidgetValues = function()
{
    let model = new MailingTemplateModel(this.ProvidedModel);
    let formValues = this.Views.Common.Form.getValues();
    formValues.template = this.GetEditorValue(this.Views.Common.Form.elements["type"].getValue());

    Object.keys(formValues).forEach(Key => {
        if(Object.hasOwn(model, Key))
            model[Key] = formValues[Key];
        else if(Object.hasOwn(model.options, Key))
            model.options[Key] = formValues[Key];
    });

    return new MailingTemplateModel(model);
};

MailingTemplatesEditWidget.prototype.ClearWidgetValues = function()
{
    let _this = this;

    this.ProvidedModel = null;

    Object.keys(this.Views.Common.Form.elements).forEach(Key => {
        let el = _this.Views.Common.Form.elements[Key];
        el.blockEvent();
        el.setValue("");
        el.unblockEvent();

        _this.Views.Common.Form.markInvalid(Key, false);
    });

    this.SetEditorValue("");
    this.DefineInvalidLabel(true);
};

MailingTemplatesEditWidget.prototype.SetWidgetView = function(ContextType = null)
{
    let _this = this;

    if(!this.ProvidedModel)
    {
        this.ContextType = null;
        this.Views.Common.TemplateContext.hide();
        this.Views.Common.EmptyContext.show();
    }
    else
    {
        this.ContextType = ContextType ? ContextType : this.ContextType;
        this.DefineHeader();
        this.DefineForm();
        this.DefineToolbar();
        this.DefineEditorElmnts();
        this.DefineInvalidLabel(true);
        this.DefineActionBtns();

        this.Views.Common.EmptyContext.hide();
        this.Views.Common.TemplateContext.show();
    }
};

MailingTemplatesEditWidget.prototype.DefineHeader = function()
{
    if(this.ViewType === MailingTemplatesWidgetViewTypes.popup)
    {
        if(this.ContextType === MailingTemplatesWidgetContextTypes.view_template)
        {
            this.Views.Header.EditTemplate.hide();
            this.Views.Header.ViewTemplate.show();
        }
        else
        {
            this.Views.Header.ViewTemplate.hide();
            this.Views.Header.EditTemplate.show();
        }
    }
};

MailingTemplatesEditWidget.prototype.DefineForm = function()
{
    let _this = this;

    let keysToHide = [];
    let keysToDisable = ["username"];

    if(this.ProvidedModel.is_system)
        keysToHide.push("username");

    if(this.ContextType === MailingTemplatesWidgetContextTypes.view_template)
        keysToDisable = Object.keys(_this.Views.Common.Form.elements);
    else if(this.ViewType === MailingTemplatesWidgetViewTypes.popup)
        keysToDisable.push("type");

    Object.keys(this.Views.Common.Form.elements).forEach(Key => {
       let el = _this.Views.Common.Form.elements[Key];

       if(el)
       {
           if(keysToHide.includes(Key))
               el.hide();
           else
               el.show();

           if(keysToDisable.includes(Key))
               el.disable();
           else
               el.enable();
       }
    });
};

MailingTemplatesEditWidget.prototype.DefineToolbar = function()
{
    let _this = this;

    let keysToDisable = [];

    if(_this.ContextType === MailingTemplatesWidgetContextTypes.view_template)
        keysToDisable = [
            "RestoreBtn",
            "DefaultTemplateBtn",
            "OptionsBtn"
        ];

    if(!keysToDisable.includes("DefaultTemplateBtn") && !this.Views.Common.Form.elements["type"].getValue())
        keysToDisable.push("DefaultTemplateBtn");

    if(!keysToDisable.includes("RestoreBtn") && !_this.IsChanged())
        keysToDisable.push("RestoreBtn");

    Object.keys(this.Views.ToolbarElmnts).forEach(Key => {
        let el = _this.Views.ToolbarElmnts[Key];

        if(el)
        {
            if(keysToDisable.includes(Key))
                el.disable();
            else
                el.enable();
        }
    });
};

MailingTemplatesEditWidget.prototype.DefineEditorElmnts = function()
{
    let _this = this;

    let isReadOnly = this.ContextType === MailingTemplatesWidgetContextTypes.view_template;

    this.Views.EditorElmnts.TextArea.define({readonly: isReadOnly});
    this.Views.EditorElmnts.TextArea.refresh();

    if(this.EditorInstance && this.EditorInstance.elm)
        this.EditorInstance.elm.setAttribute("contentEditable", isReadOnly ? "false" : "true");

    let keysToHide = [];

    if(_this.Views.Common.Form.elements["type"].getValue() === MailingTemplatesTypesEnum.http)
        keysToHide = ["NicEditor"];
    else
        keysToHide = ["TextArea"];

    Object.keys(this.Views.EditorElmnts).forEach(Key => {
        let el = _this.Views.EditorElmnts[Key];

        if(el)
        {
            if(keysToHide.includes(Key))
                el.hide();
            else
                el.show();
        }
    });
};

MailingTemplatesEditWidget.prototype.DefineInvalidLabel = function(isEditorValid = true)
{
    if(isEditorValid)
    {
        this.Views.EditorLabels.InvalidLabel.hide();
        this.Views.EditorLabels.Label.show();
    }
    else
    {
        this.Views.EditorLabels.InvalidLabel.show();
        this.Views.EditorLabels.Label.hide();
    }
};

MailingTemplatesEditWidget.prototype.DefineActionBtns = function()
{
    if(this.ContextType === MailingTemplatesWidgetContextTypes.view_template)
    {
        this.Views.ActionBtns.SaveBtn.hide();
        this.Views.ActionBtns.EditBtn.show();

        if(this.Manager.CanUserManageItem(this.ProvidedModel))
        {
            this.Views.ActionBtns.EditBtn.enable();
        }
        else
        {
            this.Views.ActionBtns.EditBtn.disable();
        }
    }
    else
    {
        this.Views.ActionBtns.EditBtn.hide();
        this.Views.ActionBtns.SaveBtn.show();

        if(this.IsNeedToSave())
            this.Views.ActionBtns.SaveBtn.enable();
        else
            this.Views.ActionBtns.SaveBtn.disable();
    }
};

MailingTemplatesEditWidget.prototype.IsChanged = function()
{
    if(this.ProvidedModel) {
        let model = this.GetWidgetValues();
        return JSON.stringify(this.ProvidedModel) !== JSON.stringify(model);
    }
    return false;
};

MailingTemplatesEditWidget.prototype.IsNeedToSave = function()
{
    if(this.ContextType !== MailingTemplatesWidgetContextTypes.view_template)
    {
        if(this.ProvidedModel)
            return !!(!this.ProvidedModel._id || this.IsChanged());
    }

    return false;
};

MailingTemplatesEditWidget.prototype.GetCleanedEditorValue = function()
{
    let line = this.Views.EditorElmnts.NicEditor.getValue();

    if(["<br>", "<div><br></div>"].includes(line))
        line = "";

    return line;
};

MailingTemplatesEditWidget.prototype.Validate = function()
{
    let isFormValid = this.Views.Common.Form.validate();
    let isEditorValid = this.ValidateEditor();

    this.DefineInvalidLabel(isEditorValid);

    return isFormValid && isEditorValid;
};

MailingTemplatesEditWidget.prototype.ValidateEditor = function(Type)
{
    let res = false;

    let type = Type ? Type : this.Views.Common.Form.elements["type"].getValue();

    if(type === MailingTemplatesTypesEnum.http)
    {
        res = !!(this.Views.EditorElmnts.TextArea.getValue());
    }
    else
    {
        res = !!(this.GetCleanedEditorValue())
    }

    return res;
}

MailingTemplatesEditWidget.prototype.SaveTemplate = function()
{
    if(this.Validate())
    {
        let model = this.GetWidgetValues();
        this.Manager.SaveTemplate(model);
    }

    if(this.ViewType === MailingTemplatesWidgetViewTypes.popup)
        this.Views.Popups.Widget.hide();
};

MailingTemplatesEditWidget.prototype.Cancel = function(Silence = true)
{
    this.ClearWidgetValues();
    this.SetWidgetView();

    if(this.ViewType === MailingTemplatesWidgetViewTypes.popup)
        this.Views.Popups.Widget.hide();

    if(this.ViewType === MailingTemplatesWidgetViewTypes.build_in)
        Silence = false;

    if(!Silence)
        this.Signals.CancelBtnClick.next(1);
};

MailingTemplatesEditWidget.prototype.GetEditorValue = function(Type = null)
{
    if(Type === MailingTemplatesTypesEnum.http)
        return this.Views.EditorElmnts.TextArea.getValue();

    return this.GetCleanedEditorValue();
};

MailingTemplatesEditWidget.prototype.SetEditorValue = function(Text = null, Key = null, Silence = true)
{
    let setters = {
        "NicEditor": (_Text, _Silence) => {
            if(_Silence)
                this.StopObserver();

            this.Views.EditorElmnts.NicEditor.setValue(_Text ? _Text : "");

            if(_Silence)
                this.StartEditorObserver();
        },
        "TextArea": (_Text, _Silence) => {
            if(_Silence)
                this.Views.EditorElmnts.TextArea.blockEvent();

            this.Views.EditorElmnts.TextArea.setValue(_Text ? _Text : "");

            if(_Silence)
                this.Views.EditorElmnts.TextArea.unblockEvent();
        },
    };

    Object.keys(setters).forEach(Key => {
        setters[Key]("", true);
    });

    if(Text && Key && setters[Key])
        setters[Key](Text, Silence)
};

MailingTemplatesEditWidget.prototype.StopObserver = function()
{
    this.Observer.disconnect();
};

MailingTemplatesEditWidget.prototype.StartEditorObserver = function()
{
    if(this.EditorInstance && this.EditorInstance.elm)
        this.Observer.observe(this.EditorInstance.elm, {
            childList: true,
            subtree: true,
            characterData: true
        });
};

MailingTemplatesEditWidget.prototype.GetCursorPos = function(Key = null)
{
    let getters = {
        "NicEditor": () => {
            return undefined;
        },
        "TextArea": () => {
            let node = this.Views.EditorElmnts.TextArea.getInputNode();
            return node ? node.selectionEnd : undefined;
        },
    };

    return getters[Key]();
};

function MailingTemplatesTable(Params)
{
    let params = {
        id: Params && Params.id ? Params.id : webix.uid(),
        name: "MailingTemplatesTable",
        hideExport: true,
        config: {
            model: MailingTemplateModel,
            method:function ()
            {
                return "GetMailingTemplatesViewList";
            },
            sort:{id:"_id",dir:"desc"},
        },
        filter: {
            is_system: {
                id: "is_system",
                operator: "=",
                value: 0
            }
        },
        columns: [
            {
                id:"checked",
                header: "",
                // header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                template: CellColoredCheckBoxTemplate,
                width: 32
            },
            {
                id: "edit",
                header: "",
                width: 32,
                tooltip: (Obj) => {return Params.can_user_manage_callback(Obj) ? LangHelper.GetString("MailingTemplates", "Edit template") : "";},
                template: (Obj) => {return Params.can_user_manage_callback(Obj) ? CellEditBtnTemplate() : "";}
            },
            {
                id: "copy",
                header: "",
                width: 32,
                tooltip: (Obj) => {return Params.can_user_write_callback(Obj) ? LangHelper.GetString("MailingTemplates", "Copy template") : "";},
                template: (Obj) => {return Params.can_user_write_callback(Obj) ? CellCopyBtnTemplate() : "";}
            },
            {
                id: "name",
                header: [
                    "",
                    LangHelper.GetString("MailingTemplates", "Template name"),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                fillspace: true,
                tooltip: LangHelper.GetString("MailingTemplates", "Template name")
            },
            {
                id: "type",
                header: [
                    "",
                    LangHelper.GetString("MailingTemplates", "Template type"),
                    {
                        content:"richSelectFilter",
                        inputConfig: {suggest: {fitMaster: false}},
                        options: MailingTemplatesTypes
                    }
                ],
                fillspace: true,
                tooltip: LangHelper.GetString("MailingTemplates", "Template type"),
                template: function(Obj)
                {
                    let res = MailingTemplatesTypes.find(Item => Item.id === Obj.type);
                    return res && res.value ? res.value : "";
                }
            },
            {
                id: "visibility",
                header: [
                    "",
                    LangHelper.GetString("MailingTemplates", "Template visibility"),
                    {
                        content:"richSelectFilter",
                        inputConfig: {suggest: {fitMaster: false}},
                        options: MailingTemplatesVisibilityGroups
                    }
                ],
                fillspace: true,
                tooltip: LangHelper.GetString("MailingTemplates", "Template visibility"),
                template: function(Obj)
                {
                    let res = MailingTemplatesVisibilityGroups.find(Item => Item.id == Obj.visibility);
                    return res && res.value ? res.value : "";
                }
            },
            {
                id: "username",
                header: [
                    { content: "columnGroup", batch: "common_data", groupText: LangHelper.GetString("MailingTemplates","Template data"), colspan: 3, closed: true },
                    TooltipTemplate(LangHelper.GetString("QoE", "User")),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                width: 135
            },
            {
                id: "create_time",
                header: [
                    null,
                    TooltipTemplate(LangHelper.GetString("QoE", "Create time")),
                    {content: "dateRangeFilter", contentId: "create_time", placeholder: "&#xf002 " + LangHelper.GetString("All","Filter")}
                ],
                width: 135,
                format: Helper.GetDateTimeFormat(),
                template: LocalTimeZone,
                batch: "common_data"
            },
            {
                id: "update_time",
                header:[
                    null,
                    TooltipTemplate(LangHelper.GetString("QoE", "Update time")),
                    {content: "dateRangeFilter", contentId:"update_time", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                width: 135,
                format: Helper.GetDateTimeFormat(),
                template: LocalTimeZone,
                batch: "common_data"
            },
            {
                id: "delete",
                width: 32,
                header: "",
                tooltip: (Obj) => {return Params.can_user_manage_callback(Obj) ? LangHelper.GetString("MailingTemplates", "Delete template") : "";},
                template: (Obj) => {return Params.can_user_manage_callback(Obj) ? CellTrashBtnTemplate() : "";}
            }
        ],
        on:{},
        rules:{},
        defaultPageSize:-100
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    return new QoETableReportWidget(params);
}

function MailingTemplatesViewController(Params)
{
    let _this = this;

    this.Id = Params && Params.id ? Params.id : "MailingTemplates";
    this.MenuId = Params && Params.menu_id ? Params.menu_id : this.Id;

    this.ViewModel = new MailingTemplatesManager();
    this.ReportsModel = new UniReportsManager();

    this.Subscriptions = {};

    this.Views = {
        AccordionElmnts: {
            TableTab: null,
            WidgetTab: null
        },
        ToolbarElmnts: {
            AddBtn: null,
            EditBtn: null,
            CopyBtn: null,
            DeleteBtn: null,
            RefreshBtn: null
        },
        Widgets: {
            TemplateWidget: new MailingTemplatesEditWidget({
                id: this.Id + "MailingTemplatesEditWidget",
                view_type: MailingTemplatesWidgetViewTypes.build_in
            }),
        },
        ReportsWidgets: {
            TemplatesTable: MailingTemplatesTable({
                id: this.Id + "TableWidget",
                can_user_manage_callback: (Obj) => {return _this.ViewModel.CanUserManageItem(Obj);},
                can_user_write_callback: (Obj) => {return _this.ViewModel.CanUserWrite();},
                onItemClick: (Id, E, Node) => {_this.OnItemClickHandler(Id, E, Node);},
                onCheck: (Row, Column, State) => {_this.OnCheckHandler(Row, Column, State);}
            })
        },
        Popups: {
            DeleteContext: null,
            SaveOrCancelContext: null
        }
    };

    this.ElmntsConfig = {
        Common: {
            PageHeader: PageHeaderTemplate({
                root_title: LangHelper.GetString("AppView","QoE analytics"),
                title: LangHelper.GetString("AppView","Mailing templates")
            }),
            Accordion: {
                view: "accordion",
                multi: "mixed",
                cols: []
            },
            Toolbar: {
                view: "toolbar",
                elements: []
            }
        },
        AccordionElmnts: {
            TableTab: {
                header: BlockHeaderTemplate().template({title: LangHelper.GetString("MailingTemplates", "Mailing templates"), icon: ""}),
                id: this.Id + "AccordionElmnts" + "TableTab",
                collapsed: false,
                body: { rows: {} }
            },
            WidgetTab: {
                id: this.Id + "AccordionElmnts" + "WidgetTab",
                header: BlockHeaderTemplate().template({title: LangHelper.GetString("MailingTemplates", "Template editing"), icon: "edit"}),
                minWidth: 500,
                collapsed: false,
                body: this.Views.Widgets.TemplateWidget.ViewConfig
            }
        },
        ToolbarElmnts: {
            AddBtn: {
                id: this.Id + "ToolbarElmnts" + "AddBtn",
                view: "button",
                type: "icon",
                icon: "plus",
                css: "toolbar_round_btn",
                width: 32,
                tooltip: LangHelper.GetString("MailingTemplates", "Add template"),
                click: function () {
                    _this.ExecOrShowStopPopup(() => {_this.AddNewTemplate();});
                }
            },
            EditBtn: {
                id: this.Id + "ToolbarElmnts" + "EditBtn",
                view: "button",
                type: "icon",
                icon: "pencil-square",
                css: "toolbar_round_btn",
                width: 32,
                tooltip: LangHelper.GetString("MailingTemplates", "Edit template"),
                click: function () {
                    let tabView = _this.Views.AccordionElmnts.WidgetTab;

                    if(tabView.config.collapsed)
                        tabView.expand();
                }
            },
            CopyBtn: {
                id: this.Id + "ToolbarElmnts" + "CopyBtn",
                view: "button",
                type: "icon",
                icon: "copy",
                css: "toolbar_round_btn",
                width: 32,
                tooltip: LangHelper.GetString("MailingTemplates", "Copy template"),
                click: function () {
                    let selectedItem = _this.Views.ReportsWidgets.TemplatesTable.Views.Table.getSelectedItem();
                    _this.ExecOrShowStopPopup(() => {_this.CopyTemplate(selectedItem);});
                }
            },
            DeleteBtn: {
                id: this.Id + "ToolbarElmnts" + "DeleteBtn",
                view: "button",
                type: "icon",
                icon: "trash",
                css: "toolbar_round_btn",
                width: 32,
                tooltip: LangHelper.GetString("MailingTemplates", "Delete template"),
                click: function () {
                    if(_this.Views.Popups.DeleteContext.isVisible())
                        _this.Views.Popups.DeleteContext.hide();
                    else
                        _this.Views.Popups.DeleteContext.show(this.getNode(), {pos:"right"});
                }
            },
            RefreshBtn: {
                id: this.Id + "ToolbarElmnts" + "RefreshBtn",
                view: "button",
                type: "icon",
                icon: "refresh",
                css: "toolbar_round_btn",
                width: 32,
                tooltip: LangHelper.GetString("QoE", "Refresh"),
                click: function () {
                    _this.Views.ReportsWidgets.TemplatesTable.RefreshData();
                }
            }
        },
        Popups: {
            DeleteContext: {
                id: this.Id + "Popups" + "DeleteContext",
                view: "popup",
                body: {
                    view: "form",
                    borderless: true,
                    elements: [
                        {
                            template: LangHelper.GetString("All","Are you sure you want to delete the selected record?")
                        },
                        {
                            cols: [
                                {},
                                {
                                    view: "button",
                                    label: LangHelper.GetString("All","Cancel"),
                                    width: 200,
                                    click: function () {
                                        _this.Views.Popups.DeleteContext.hide();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    label: LangHelper.GetString("All","Delete"),
                                    width: 200,
                                    click: function ()
                                    {
                                        let item = _this.Views.ReportsWidgets.TemplatesTable.Views.Table.getSelectedItem();
                                        if(item)
                                            _this.DeleteTemplate(item);
                                        _this.Views.Popups.DeleteContext.hide();

                                    }
                                }
                            ]
                        }
                    ]
                }
            },
            SaveOrCancelContext: {
                id: this.Id + "Popups" + "SaveOrCancelContext",
                view: "popup",
                position:{
                    my: "center",
                    at: "center",
                    of: webix.viewport
                },
                body: {
                    view: "form",
                    borderless: true,
                    elements: [
                        {
                            template: LangHelper.GetString("All","Current changes have not been saved.") + "<br>" +
                                LangHelper.GetString("All", "Save changes?")
                        },
                        {
                            cols: [
                                {},
                                {
                                    view: "button",
                                    label: LangHelper.GetString("All","Cancel"),
                                    width: 200,
                                    click: function () {
                                        _this.Views.Popups.SaveOrCancelContext.hide();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    label: LangHelper.GetString("All","Save"),
                                    width: 200,
                                    click: function () {
                                        _this.Views.Widgets.TemplateWidget.SaveTemplate();
                                        _this.Views.Popups.SaveOrCancelContext.hide();
                                    }
                                }
                            ]
                        }
                    ]
                }
            }
        }
    };

    this.ElmntsConfig.Common.Toolbar.elements = [
        this.ElmntsConfig.ToolbarElmnts.AddBtn,
        { width: 10 },
        this.ElmntsConfig.ToolbarElmnts.EditBtn,
        this.ElmntsConfig.ToolbarElmnts.CopyBtn,
        this.ElmntsConfig.ToolbarElmnts.DeleteBtn,
        {},
        this.ElmntsConfig.ToolbarElmnts.RefreshBtn,
    ];

    this.ElmntsConfig.AccordionElmnts.TableTab.body.rows = [
        this.ElmntsConfig.Common.Toolbar,
        this.Views.ReportsWidgets.TemplatesTable.ViewConfig
    ];

    this.ElmntsConfig.Common.Accordion.cols = [
        this.ElmntsConfig.AccordionElmnts.TableTab,
        { view:"resizer" },
        this.ElmntsConfig.AccordionElmnts.WidgetTab
    ];

    this.ViewConfig = [{
        cols: [
            QoELeftSideBarView({id: this.Id}),
            {
                type: "space",
                rows: [{
                    type: "clear",
                    borderless: true,
                    rows: [
                        this.ElmntsConfig.Common.PageHeader,
                        this.ElmntsConfig.Common.Accordion
                    ]
                }]
            }
        ],
    }];
}

MailingTemplatesViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select(_this.MenuId);
    });

    this.BindAll(PathParams);
};

MailingTemplatesViewController.prototype.BindAll = function ()
{
    let _this = this;

    this.Views.Widgets.TemplateWidget.Bind(this, this.ViewModel);
    this.Views.ReportsWidgets.TemplatesTable.Bind(this, this.ReportsModel)

    Object.values(this.ElmntsConfig.Popups).forEach(ViewConfig => {
        webix.ui(ViewConfig);
    });

    Object.keys(this.Views).forEach(Key => {
        if(!["Widgets", "ReportsWidgets"].includes(Key))
        {
            Object.keys(_this.Views[Key]).forEach(_key => {
                _this.Views[Key][_key] = $$(_this.Id + Key + _key);
            });
        }
    });

    this.Views.ReportsWidgets.TemplatesTable.Views.Table.attachEvent("onBeforeSelect", function(Row) {
        if(_this.Views.Widgets.TemplateWidget.IsNeedToSave())
        {
            let table = _this.Views.ReportsWidgets.TemplatesTable.Views.Table;

            let selectedItem = table.getSelectedItem()
            let toSelectItem = table.getItem(Row);

            if(selectedItem.id != toSelectItem.id)
            {
                toSelectItem.checked = 0;
                table.updateItem(toSelectItem.id, toSelectItem);

                let selectedId = table.getSelectedId();
                let node = table.getItemNode({row: selectedId.row, column: "name"});

                _this.Views.Popups.SaveOrCancelContext.show(node, {pos: "bottom"});
            }

            return false;
        }
    });

    this.Views.ReportsWidgets.TemplatesTable.Views.Table.attachEvent("onAfterSelect", function(Row) {
        let table = _this.Views.ReportsWidgets.TemplatesTable.Views.Table;
        let item = table.getItem(Row);

        _this.Views.Widgets.TemplateWidget.Show(item, MailingTemplatesWidgetContextTypes.view_template);

        table.serialize().forEach(item => {
            item.checked = 0;
        });

        item.checked = 1;

        _this.ManageToolbarBtns()
    });

    this.Views.ReportsWidgets.TemplatesTable.Views.Table.attachEvent("onAfterUnselect", function() {
        _this.Views.Widgets.TemplateWidget.ClearWidgetValues();
        _this.Views.Widgets.TemplateWidget.SetWidgetView();
        _this.ManageToolbarBtns();
    });

    this.Views.ReportsWidgets.TemplatesTable.Views.Table.attachEvent("onItemDblClick", function() {
        if(_this.Views.AccordionElmnts.WidgetTab.config.collapsed)
            _this.Views.AccordionElmnts.WidgetTab.expand();
    });

    this.Subscriptions.SaveTemplateSuccess = this.ViewModel.Signals.SaveTemplateSuccess.subscribe(function(Model) {
        if(Model)
        {
            let tableW = _this.Views.ReportsWidgets.TemplatesTable;

            if(Model.id)
            {
                tableW.Views.Table.updateItem(Model.id, Model);
                _this.Views.Widgets.TemplateWidget.Show(Model, MailingTemplatesWidgetContextTypes.view_template);
            }
            else
                tableW.RefreshData();

            webix.message(LangHelper.GetString("MailingTemplates", "Template successfully saved."));
        }
    });

    this.Subscriptions.SaveTemplateError = this.ViewModel.Signals.SaveTemplateError.subscribe(function(Error) {
        if(Error)
        {
            if(Error.msg)
                webix.message({type: "error", text: Error.msg});

            _this.Views.ReportsWidgets.TemplatesTable.RefreshData();
        }
    });

    this.Subscriptions.DeleteTemplateSuccess = this.ViewModel.Signals.DeleteTemplateSuccess.subscribe(function(Model) {
        if(Model)
            _this.DeleteTemplateProcess(Model);
    });

    this.Subscriptions.DeleteTemplateError = this.ViewModel.Signals.DeleteTemplateError.subscribe(function(Error) {
        if(Error)
        {
            if(Error.msg)
                webix.message({type: "error", text: Error.msg});

            _this.Views.ReportsWidgets.TemplatesTable.RefreshData();
        }
    });

    this.Subscriptions.ServerError = this.ViewModel.Signals.ServerError.subscribe(function(Update) {
        if(Update)
            webix.message({type: "error", text: LangHelper.GetString("All", "Server error")});
    });

    this.Subscriptions.CancelBtnClick = this.Views.Widgets.TemplateWidget.Signals.CancelBtnClick.subscribe(function(Update) {
        if(Update)
        {
            let item = _this.Views.ReportsWidgets.TemplatesTable.Views.Table.getSelectedItem();

            if(item && !item._id)
            {
                _this.Views.ReportsWidgets.TemplatesTable.Views.Table.remove(item.id);
                _this.ManageTableOverlay();
            }
            else
            {
                item.checked = 0;
                _this.Views.ReportsWidgets.TemplatesTable.Views.Table.unselect(item.id);
            }

            // _this.ManageToolbarBtns()
        }
    });

    this.ManageToolbarBtns()
    this.Views.ReportsWidgets.TemplatesTable.RefreshData();
};

MailingTemplatesViewController.prototype.Destroy = function()
{
    let _this = this;

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        if(_this.Subscriptions[Key])
            _this.Subscriptions[Key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(Key => {
        let w = _this.Views.ReportsWidgets[Key];

        if(w && w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.Widgets).forEach(Key => {
        let w = _this.Views.Widgets[Key];

        if(w && w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

MailingTemplatesViewController.prototype.OnItemClickHandler = function(Id, E, Node)
{
    let table = this.Views.ReportsWidgets.TemplatesTable.Views.Table;
    let item = table.getItem(Id);


    let checks = [
        this.Views.Widgets.TemplateWidget.IsNeedToSave(),
        item.id != this.Views.Widgets.TemplateWidget.ProvidedModel.id
    ];

    if(checks.every(Boolean))
        return;

    if(this.ViewModel.CanUserManageItem(item))
    {
        if(Id.column === "edit")
        {
            let tabView = this.Views.AccordionElmnts.WidgetTab;
            if(tabView.config.collapsed)
                tabView.expand();
            this.Views.Widgets.TemplateWidget.Show(item, MailingTemplatesWidgetContextTypes.edit_template, true);
        }

        if(Id.column === "delete")
            this.Views.Popups.DeleteContext.show(table.getItemNode(Id), {pos: "left"});
    }

    if(this.ViewModel.CanUserWrite())
    {
        if(Id.column === "copy")
            this.ExecOrShowStopPopup(() => {this.CopyTemplate(item);})
    }
};

MailingTemplatesViewController.prototype.OnCheckHandler = function(Row, Column, State)
{
    let table = this.Views.ReportsWidgets.TemplatesTable.Views.Table;
    let item = table.getItem(Row);

    if(item.checked)
        table.select(item.id);
};

MailingTemplatesViewController.prototype.AddNewTemplate = function(Params)
{
    let model = new MailingTemplateModel(Params);

    model.user_id = this.ViewModel.CurUserProfile.user_id;
    model.username = this.ViewModel.CurUserProfile.username;

    this.Views.ReportsWidgets.TemplatesTable.Views.Table.add(model);
    this.ManageTableOverlay();
    this.Views.ReportsWidgets.TemplatesTable.Views.Table.select(model.id);

    if(this.Views.AccordionElmnts.WidgetTab.config.collapsed)
        this.Views.AccordionElmnts.WidgetTab.expand();

    this.Views.Widgets.TemplateWidget.Show(model, MailingTemplatesWidgetContextTypes.edit_template, true);
};

MailingTemplatesViewController.prototype.DeleteTemplate = function(Params)
{
    let model = new MailingTemplateModel(Params);

    if(model._id)
    {
        this.ViewModel.DeleteTemplate(model);
    }
    else if(!model._id)
    {
        this.DeleteTemplateProcess(model);
    }
    else
    {
        this.Views.ReportsWidgets.TemplatesTable.RefreshData();
    }
};

MailingTemplatesViewController.prototype.DeleteTemplateProcess = function(Model)
{
    let tableW = this.Views.ReportsWidgets.TemplatesTable;
    let items = tableW.Views.Table.serialize();
    let find = items.find(item => item.id == Model.id);

    if(find)
    {
        tableW.Views.Table.remove(find.id);

        if(items.length === 1)
            tableW.RefreshData();
    }

    webix.message(LangHelper.GetString("MailingTemplates", "Template successfully deleted."));
};

MailingTemplatesViewController.prototype.CopyTemplate = function(Params)
{
    let model = new MailingTemplateModel();

    model.name = Params && Params.name ? LangHelper.GetString("All", "Copy of") + " " + Params.name : "";
    model.type = Params && Params.type ? Params.type : "";
    model.template = Params && Params.template ? Params.template : "";

    this.AddNewTemplate(model);
};

MailingTemplatesViewController.prototype.ManageToolbarBtns = function()
{
    let _this = this;

    let checkBtns = {
        "EditBtn": (Obj) => {return _this.ViewModel.CanUserManageItem(Obj)},
        "DeleteBtn": (Obj) => {return _this.ViewModel.CanUserManageItem(Obj)},
        "CopyBtn": () => {return _this.ViewModel.CanUserWrite()},
        "AddBtn": () => {return _this.ViewModel.CanUserWrite()},
    }

    let selected = this.Views.ReportsWidgets.TemplatesTable.Views.Table.getSelectedItem();

    Object.keys(checkBtns).forEach(Key => {
        let btn = _this.Views.ToolbarElmnts[Key];
        let check = checkBtns[Key];

        if(btn)
        {
            if((Key === "AddBtn" && check()) || (selected && check(selected)))
                btn.enable();
            else
                btn.disable();
        }
    });
};

MailingTemplatesViewController.prototype.ManageTableOverlay = function()
{
    let tableW = this.Views.ReportsWidgets.TemplatesTable

    if(tableW.Views.Table.serialize().length)
        tableW.Views.Table.hideOverlay();
    else
        tableW.RefreshData();
};

MailingTemplatesViewController.prototype.ExecOrShowStopPopup = function(Func)
{
    if(this.Views.Widgets.TemplateWidget.IsNeedToSave())
    {
        let table = this.Views.ReportsWidgets.TemplatesTable.Views.Table;
        let selectedId = table.getSelectedId();
        let node = table.getItemNode({row: selectedId.row, column: "name"});
        this.Views.Popups.SaveOrCancelContext.show(node, {pos: "bottom"});
    }
    else
        Func();
};
function QoEDashboardItemStateModel(Params)
{
    this.id = Params&&Params.id?Params.id:webix.uid();

    this.widget = Params&&Params.widget?Params.widget:null;

    this.x = Params&&Params.x?Params.x:0;
    this.y = Params&&Params.y?Params.y:0;

    this.dx = Params&&Params.dx?Params.dx:0;
    this.dy = Params&&Params.dy?Params.dy:0;

    this.func = Params&&Params.func?Params.func:null;
    this.widget_id = Params&&Params.widget_id?Params.widget_id:null;

    this.reports_settings_ids = Params&&Params.reports_settings_ids?Params.reports_settings_ids:[];
}

function QoEDashboardViewController(Params)
{
    var _this = this;

    this.Id = "QoEDashboard";

    this.ViewModel = new QoEReportsManager();

    this.DashboardManager = new QoEDashboardManager();

    this.ProtocolsDicsManager = new HardwareDscpProrocolsManager();

    this.Subscriptions = {};

    this.DomEvents = {};

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"});

    this.Views =
        {
            Dashboard:null,
            DpiPicker:null,
            DashboardsExtendedFilter:new QoEPopupFilterWidget({
                id: this.Id + "DashboardsExtendedFilter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoEDashboards),
                enable_show_hotkey: 1
            }),
            TemplatesExtendedFilter:new QoEPopupFilterWidget({
                id: this.Id + "TemplatesExtendedFilter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoEDashboards)
            }),
            WidgetsList:new QoEWidgetsSuggestWidget({
                id:this.Id + "WidgetsSuggest",
                embedded:true,
                dragable:true,
                editable: true,
                isDashboard: true,
                exceptWidgetCodes: ExceptWidgetCodes.custom_agg
            }),
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"}),
        };

    this.QoEDashboardEditFormContext = new QoEDashboardEditViewController();

    this.Views.Widgets = {};

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Dashboard")}),
                                {
                                    view: "toolbar",
                                    elements: [
                                        this.Views.DateRangePicker.ViewConfig,
                                        {
                                            view:"multiselect",
                                            id:this.Id + "DpiPicker",
                                            value:"-2",
                                            maxWidth:320,
                                            optionWidth:320,
                                            options:[]
                                        },
                                        this.Views.DashboardsExtendedFilter.ViewConfig,
                                        {},
                                        {
                                            view: "button",
                                            id:this.Id+"RefreshAllDataBtn",
                                            type: "icon",
                                            icon: "refresh",
                                            css: "toolbar_round_btn",
                                            width: 32,
                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                            click: function (id, e, node)
                                            {
                                                _this.RefreshAllData(null,true);
                                                if(!_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
                                                    _this.Views.WidgetsList.RefreshWidgets();
                                            }
                                        },
                                        this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                        {
                                            width: 16
                                        },
                                        QoEKillProcessesBtnWidget({
                                            id:this.Id+"KillProcessesBtn",
                                            restricted:{"KillCurrentReportProcesses":1},
                                            callback:function (Id)
                                            {
                                                _this.KillProcesses(Id);
                                            }
                                        }),
                                        QoEClearCacheBtnWidget({
                                            id:this.Id+"ClearCacheBtn",
                                            restricted:{"ClearCurrentReportCache":1},
                                            callback:function (Id)
                                            {
                                                _this.ClearCache(Id);
                                            }
                                        })
                                    ]
                                },
                                {
                                    view: "accordion",
                                    multi: "mixed",
                                    cols: [
                                        {
                                            id: this.Id + "DashboardLayout",
                                            rows: [
                                                {
                                                    view: "scrollview",
                                                    id: this.Id + "DashboardScrollView",
                                                    body: {
                                                        rows:
                                                            [
                                                                {
                                                                    view: "qoedashboard",
                                                                    id: this.Id + "Dashboard",
                                                                    gridColumns: 12,
                                                                    gridRows: 72,
                                                                    cellHeight: 80,
                                                                    margin: 8,
                                                                    padding: 0,
                                                                    scroll: true,
                                                                    factory: function (Obj) {
                                                                        return _this.DashboardFactory(Obj);
                                                                    },
                                                                    on: {
                                                                        onChange: function () {
                                                                            _this.StoreState();
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                    }
                                                }
                                            ]
                                        },
                                        {view: "resizer"},
                                        {
                                            header: LangHelper.GetString("QoE", "Widgets, drag from here"),
                                            id: this.Id + "WidgetsListAi",
                                            collapsed: true,
                                            body: {
                                                width: 400,
                                                rows: [
                                                    this.Views.WidgetsList.ViewConfig,
                                                    {
                                                        id: this.Id + "WidgetListButtonsLayout",
                                                        cols: [
                                                            {
                                                                view: "button",
                                                                value: LangHelper.GetString("All", "Reset"),
                                                                click: function () {
                                                                    _this.RestoreState(false);
                                                                    _this.StoreState();
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                value: LangHelper.GetString("All", "By default"),
                                                                click: function () {
                                                                    _this.RestoreState(true);
                                                                    _this.StoreState();
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        {view: "resizer"},
                                        {
                                            header: LangHelper.GetString("QoE", "Dashboards"),
                                            id: this.Id + "DashboardsAccordion",
                                            collapsed: true,
                                            body: {
                                                view: "accordion",
                                                multi: "mixed",
                                                rows: [
                                                    {
                                                        header: LangHelper.GetString("QoE", "Saved dashboards"),
                                                        id: this.Id + "SavedDashboards",
                                                        body: {
                                                            width: 400,
                                                            rows:[
                                                                {
                                                                    view: "toolbar",
                                                                    height: 32,
                                                                    padding: 0,
                                                                    margin: 0,
                                                                    elements: [
                                                                        {
                                                                            view: "button",
                                                                            type: "icon",
                                                                            icon: "plus",
                                                                            width: 32,
                                                                            css:"toolbar_round_btn",
                                                                            tooltip:LangHelper.GetString("QoE","Add dashboard"),
                                                                            click: function () {
                                                                                _this.AddDashboard(this.getNode());
                                                                            }
                                                                        },
                                                                        {
                                                                            view: "button",
                                                                            id: this.Id + "AddSubDashboardBtn",
                                                                            type: "icon",
                                                                            icon: "plus-square",
                                                                            css: "toolbar_round_btn",
                                                                            width: 32,
                                                                            disabled: true,
                                                                            tooltip: LangHelper.GetString("QoE", "Add subdashboard"),
                                                                            click: function() {
                                                                                _this.AddDashboard(this.getNode(), true);
                                                                            }
                                                                        },
                                                                        {},
                                                                        {
                                                                            view: "button",
                                                                            type: "icon",
                                                                            icon: "refresh",
                                                                            css: "toolbar_round_btn",
                                                                            width: 32,
                                                                            tooltip: LangHelper.GetString("All", "Refresh"),
                                                                            click: function () {
                                                                                var views = _this.DashboardViews;
                                                                                _this.RefreshTable({page: views.pager.config.page}, views);
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                BlockHeaderTemplate({title: LangHelper.GetString("QoE", "Dashboards"), icon:"list"}),
                                                                {
                                                                    view:"treetable",
                                                                    id:this.Id + "SavedDashboardsTable",
                                                                    select: "row",
                                                                    scroll: true,
                                                                    columns: [
                                                                        {
                                                                            id: "edit",
                                                                            header: "",
                                                                            width: 40,
                                                                            template: CellEditBtnTemplate,
                                                                            headermenu: false
                                                                        },
                                                                        {
                                                                            id: "filter",
                                                                            header: "",
                                                                            width: 40,
                                                                            headermenu: false,
                                                                            template: function(Obj) {
                                                                                if(Obj.filter_settings) {
                                                                                    return CellFilterBtnTemplate(Obj.filter_settings);
                                                                                }

                                                                                return CellFilterBtnTemplate(Obj);
                                                                            }
                                                                        },
                                                                        {
                                                                            id:"dashboard_name",
                                                                            header:[LangHelper.GetString("QoE", "Dashboard name"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("QoE","Filter")}],
                                                                            fillspace:true,
                                                                            sort:"string",
                                                                            editor:"text",
                                                                            template:function(obj, common, value, config)
                                                                            {
                                                                                return common.treetable(obj, common, value, config) + (obj.dashboard_name?obj.dashboard_name:"");
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "trash",
                                                                            header: "",
                                                                            width: 32,
                                                                            template: CellTrashBtnTemplate,
                                                                            headermenu: false
                                                                        }
                                                                    ],
                                                                    on: {
                                                                        onItemClick: function (id)
                                                                        {
                                                                            var views = _this.DashboardViews;

                                                                            if(id.column === "edit") {
                                                                                _this.ShowEditForm(this.getItem(id.row), this.getItemNode(id.row),"left");
                                                                            }
                                                                            if(id.column === "filter") {
                                                                                views.extendedFilter.Show(this.getItemNode(id.row), "left");
                                                                            }
                                                                            else if(id.column === "trash")
                                                                            {
                                                                                var rowData = this.getItem(id);
                                                                                if(rowData && rowData.dashboard_id) {
                                                                                    Helper.Table.ShowTrashForm(id.row, function() {
                                                                                        var selectedDashboard = _this.GetTableSelectedItem(views);

                                                                                        if(selectedDashboard) {
                                                                                            _this.DeleteTableRow(selectedDashboard.id, views);
                                                                                        }
                                                                                    }, views.table, this.getItemNode(id));
                                                                                }
                                                                                else {
                                                                                    _this.DeleteTableRow(id.row, views);
                                                                                }
                                                                            }
                                                                        },
                                                                        onBeforeFilter:function ()
                                                                        {
                                                                            return false;
                                                                        },
                                                                        onAfterSelect:function ()
                                                                        {
                                                                            _this.OnTableRowSelectionChange();
                                                                        },
                                                                        onAfterUnSelect:function ()
                                                                        {
                                                                            _this.OnTableRowSelectionChange();
                                                                        },
                                                                        onBeforeSort:function ()
                                                                        {
                                                                            _this.TableFilterSortHandler(_this.DashboardViews);

                                                                            return false;
                                                                        },
                                                                        onAfterFilter:function ()
                                                                        {
                                                                            _this.TableFilterSortHandler(_this.DashboardViews);
                                                                        }
                                                                    }
                                                                },
                                                                {
                                                                    paddingY: 10,
                                                                    cols: [
                                                                        {
                                                                            view: "pager",
                                                                            id: this.Id + "SavedDashboardsPager",
                                                                            template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                                            master: false,
                                                                            on: {
                                                                                onAfterPageChange: function (Page) {
                                                                                    _this.RefreshTable({page: Page}, _this.DashboardViews);
                                                                                }
                                                                            }
                                                                        },
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        header: LangHelper.GetString("QoE", "Saved dashboard templates"),
                                                        collapsed: true,
                                                        id: this.Id + "SavedTemplates",
                                                        body: {
                                                            width: 400,
                                                            rows: [
                                                                {
                                                                    view: "toolbar",
                                                                    height: 32,
                                                                    padding: 0,
                                                                    margin: 0,
                                                                    elements: [
                                                                        {},
                                                                        {
                                                                            view: "button",
                                                                            type: "icon",
                                                                            icon: "refresh",
                                                                            css: "toolbar_round_btn",
                                                                            width: 32,
                                                                            tooltip: LangHelper.GetString("All", "Refresh"),
                                                                            click: function () {
                                                                                var views = _this.TemplateViews;
                                                                                _this.RefreshTable({page: views.pager.config.page}, views);
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                BlockHeaderTemplate({title:LangHelper.GetString("QoE", "Templates"), icon:"list"}),
                                                                {
                                                                    view: "datatable",
                                                                    id: this.Id + "SavedTemplatesTable",
                                                                    select: "row",
                                                                    columns: [
                                                                        {
                                                                            id: "edit",
                                                                            header: "",
                                                                            width: 40,
                                                                            template: CellEditBtnTemplate,
                                                                            headermenu: false
                                                                        },
                                                                        {
                                                                            id: "filter",
                                                                            header: "",
                                                                            width: 40,
                                                                            headermenu: false,
                                                                            template: function(Obj) {
                                                                                if(Obj.filter_settings) {
                                                                                    return CellFilterBtnTemplate(Obj.filter_settings);
                                                                                }

                                                                                return CellFilterBtnTemplate(Obj);
                                                                            }
                                                                        },
                                                                        {
                                                                            id:"dashboard_name",
                                                                            header:[LangHelper.GetString("QoE", "Template name"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("QoE","Filter")}],
                                                                            fillspace:true,
                                                                            sort:"string",
                                                                            editor:"text",
                                                                        },
                                                                        {
                                                                            id: "trash",
                                                                            header: "",
                                                                            width: 40,
                                                                            template: function(Obj) {
                                                                                if(!Obj.is_system) {
                                                                                    return CellTrashBtnTemplate();
                                                                                }
                                                                                return "";
                                                                            },
                                                                            headermenu: false
                                                                        }
                                                                    ],
                                                                    on: {
                                                                        onItemClick: function(id) {
                                                                            var views = _this.TemplateViews;

                                                                            if(id.column === "edit") {
                                                                                _this.ShowEditForm(this.getItem(id.row), this.getItemNode(id.row),"left");
                                                                            }
                                                                            if(id.column === "filter") {
                                                                                views.extendedFilter.Show(this.getItemNode(id.row), "left");
                                                                            }
                                                                            if(id.column === "trash") {
                                                                                var rowData = this.getItem(id);
                                                                                if(rowData && !rowData.is_system) {
                                                                                    if(rowData.dashboard_id) {
                                                                                        Helper.Table.ShowTrashForm(id.row, function() {
                                                                                            var selectedTemplate = _this.GetTableSelectedItem(views);

                                                                                            if(selectedTemplate) {
                                                                                                _this.DeleteTableRow(selectedTemplate.id, views);
                                                                                            }
                                                                                        }, views.table, this.getItemNode(id));
                                                                                    }
                                                                                    else {
                                                                                        _this.DeleteTableRow(id.row, views);
                                                                                    }
                                                                                }
                                                                            }
                                                                        },
                                                                        onBeforeFilter: function ()
                                                                        {
                                                                            return false;
                                                                        },
                                                                        onAfterSelect:function ()
                                                                        {
                                                                            _this.OnTableRowSelectionChange(true);
                                                                        },
                                                                        onAfterUnSelect:function ()
                                                                        {
                                                                            _this.OnTableRowSelectionChange(true);
                                                                        },
                                                                        onBeforeSort:function ()
                                                                        {
                                                                            _this.TableFilterSortHandler(_this.TemplateViews);

                                                                            return false;
                                                                        },
                                                                        onAfterFilter:function ()
                                                                        {
                                                                            _this.TableFilterSortHandler(_this.TemplateViews);
                                                                        }
                                                                    }
                                                                },
                                                                {
                                                                    paddingY: 10,
                                                                    cols: [
                                                                        {
                                                                            view: "pager",
                                                                            id: this.Id + "SavedTemplatesPager",
                                                                            template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                                            master: false,
                                                                            on: {
                                                                                onAfterPageChange: function(Page) {
                                                                                    _this.RefreshTable({page: Page}, _this.TemplateViews);
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        gravity: 0
                                                    }
                                                ],
                                                on: {
                                                    "onAfterCollapse":function(Id) {
                                                        if(Id) {
                                                            var accordionItems = [_this.Views.SavedTemplates, _this.Views.SavedDashboards];
                                                            accordionItems.forEach(item => {
                                                                if(item.config.id !== Id) {
                                                                    item.expand();
                                                                }
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            gravity:0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.DashboardItemsContextMenu = null;
    this.DashboardItemsContextMenuConfig = {
        view: "popup",
        width: 120,
        body: {
            view: "form",
            id: this.Id + "DashboardItemsContextMenuForm",
            borderless: true,
            padding: 0,
            elements: [
                {
                    view: "list",
                    id: this.Id + "DashboardItemsContextMenuList",
                    data: [
                        {id: "delete", value: LangHelper.GetString("All", "Delete")}
                    ],
                    on: {
                        onItemClick: function(id, e, node) {
                            if(id === "settings") {
                                _this.ShowWidgetSettingsForm(node);
                            }

                            if(id === "delete") {
                                _this.RemoveWidgetFromDashboard(_this.DashboardItemsContextMenu.getContext());
                                _this.DashboardItemsContextMenu.hide();
                            }
                        }
                    }
                }
            ]
        }
    };

    this.WidgetSettingsContext = null;
    this.WidgetSettingsContextConfig = {
        view: "popup",
        modal: true,
        css: {"padding": "0px !important"},
        body: {
            view: "form",
            id: this.Id + "WidgetSettingsContextForm",
            borderless: true,
            elements: []
        }
    };

    this.WidgetSettingsFieldsValidationConfigs = {};

    this.TableItemsChangeConfigs = {};

    this.DefaultState = new QoEDashboardModel({dashboard_state:[]});

    // this.DefaultState = new QoEDashboardModel({dashboard_state:[
    //         {
    //             x: 0, y: 0, dx: 12, dy: 2,
    //             widget: "QoESingleStatTotalsWidget"
    //         },
    //         {
    //             x: 0, y: 2, dx: 12, dy: 2,
    //             widget: "QoESingleStatRttWidget"
    //         },
    //         {
    //             x: 0, y: 4, dx: 12, dy: 2,
    //             widget: "QoESingleStatSubscribersRttWidget"
    //         },
    //         {
    //             x: 0, y: 6, dx: 6, dy: 5,
    //             widget: "QoERttDistributionWidget"
    //         },
    //         {
    //             x: 6, y: 6, dx: 6, dy: 5,
    //             widget: "QoERttByTimeWidget"
    //         },
    //         {
    //             x: 0, y: 11, dx: 6, dy: 5,
    //             widget: "QoESeriesChartTrafficWidget"
    //         },
    //         {
    //             x: 6, y: 11, dx: 6, dy: 5,
    //             widget: "QoESeriesChartRetransmitsByTimeWidget"
    //         },
    //         {
    //             x: 0, y: 16, dx: 6, dy: 5,
    //             widget: "QoEPieChartTopRttSubscribersWidget"
    //         },
    //         {
    //             x: 6, y: 16, dx: 6, dy: 5,
    //             widget: "QoETableTopRttSubscribersWidget"
    //         },
    //         {
    //             x: 0, y: 21, dx: 12, dy: 2,
    //             widget: "QoESingleStatClickstreamTotalsWidget"
    //         },
    //         {
    //             x: 0, y: 23, dx: 6, dy: 5,
    //             widget: "QoETableClickstreamTopHostsWidget"
    //         },
    //         {
    //             x: 6, y: 23, dx: 6, dy: 5,
    //             widget: "QoETableClickstreamTopDevicesWidget"
    //         }
    //     ]});

    this.TableRowSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsSettingsData = {};
};

QoEDashboardViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEDashboard");
    });

    this.BindAll(PathParams);

    this.QoEDashboardEditFormContext.ViewDidLoad();

    this.CheckQoEStorVersionCompatibility();
};

QoEDashboardViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.Views.DashboardsExtendedFilter.Bind(this);
    this.Views.TemplatesExtendedFilter.Bind(this);

    this.ReportsSettings.Bind();

    this.Views.WidgetsList.Bind(this);

    this.Views.WidgetListButtonsLayout = $$(this.Id + "WidgetListButtonsLayout");

    this.Views.Dashboard = $$(this.Id + "Dashboard");

    this.Views.AddSubDashboardBtn = $$(this.Id + "AddSubDashboardBtn");

    this.Views.SavedDashboards = $$(this.Id + "SavedDashboards");
    this.Views.SavedTemplates = $$(this.Id + "SavedTemplates");

    this.QoEDashboardEditFormContext.Bind();

    this.DashboardItemsContextMenu = webix.ui(this.DashboardItemsContextMenuConfig);
    this.DashboardItemsContextMenu = webix.extend(this.DashboardItemsContextMenu, webix.ContextHelper);
    this.Views.DashboardItemsContextMenuList = $$(this.Id + "DashboardItemsContextMenuList");

    this.WidgetSettingsContext = webix.ui(this.WidgetSettingsContextConfig);
    this.Views.WidgetSettingsContextForm = $$(this.Id + "WidgetSettingsContextForm");

    this.Views.DashboardScrollView = $$(this.Id + "DashboardScrollView");
    webix.extend(this.Views.DashboardScrollView, webix.OverlayBox);

    this.Views.DashboardLayout = $$(this.Id + "DashboardLayout");

    this.DashboardViews = {
        table: $$(this.Id + "SavedDashboardsTable"),
        extendedFilter: this.Views.DashboardsExtendedFilter,
        pager: $$(this.Id + "SavedDashboardsPager")
    }

    this.TemplateViews = {
        table: $$(this.Id + "SavedTemplatesTable"),
        extendedFilter: this.Views.TemplatesExtendedFilter,
        pager: $$(this.Id + "SavedTemplatesPager")
    }


    this.Subscriptions.SignalWidgetsUpdated = this.Views.WidgetsList.Signals.WidgetsUpdated.subscribe(function(Value) {
        if(Value) {
            _this.SetDefaultDashboardStateConfig();
            _this.SavedDashboardsTableRowsSelectedCountSubscriptionHandler(1);
        }
    });

    this.Subscriptions.SignalWidgetRemove = this.Views.WidgetsList.Signals.WidgetRemove.subscribe(function(Value) {
        if(Value) {
            _this.DeleteDashboardNotExistWidgets(_this.GetTableSelectedItem(_this.DashboardViews));
        }
    });

    this.TableItemsChangeConfigs = this.CreateTablesItemsChangeConfig();

    this.Subscriptions.SingalSaveDashboard = this.QoEDashboardEditFormContext.Signals.Save.subscribe(function(Value) {
        if(Value) {
            _this.DashboardEditFormSignalSaveHandler();
        }
    });

    this.Subscriptions.SignalDashboardsUpdated = this.DashboardManager.SignalDashboardsUpdated.subscribe(function(Data) {
        if(Data) {
            _this.UpdateDashboardsTable();
        }
    });

    this.Subscriptions.SignalTemplatesUpdated = this.DashboardManager.SignalTemplatesUpdated.subscribe(function(Data) {
        if(Data) {
            _this.UpdateTemplatesTable();
        }
    });

    this.Subscriptions.SignalTableRowSelect = this.TableRowSelectedCount.subscribe(function(Obj) {
        _this.TableRowSelectedCountSubscriptionHandler(Obj);
    });

    this.Subscriptions.SignalDashboardsExtendedFilterApply = this.DashboardViews.extendedFilter.ApplyStateSignal.subscribe(function(Value) {
        if(Value) {
            _this.ApplyExtendedFilter(_this.DashboardViews);
        }
    });

    this.Subscriptions.SignalTemplatesExtendedFilterApply = this.TemplateViews.extendedFilter.ApplyStateSignal.subscribe(function(Value) {
        if(Value) {
            _this.ApplyExtendedFilter(_this.TemplateViews);
        }
    });

    this.Subscriptions.SignalDashboardsExtendedFilterRestoreSavedState = this.DashboardViews.extendedFilter.RestoreSavedStateSignal.subscribe(function (Value) {
        if(Value) {
            _this.ExtendedFilterSavedFiltersTableSetStateHandler(_this.DashboardViews);
        }
    });

    this.Subscriptions.SignalTemplatesExtendedFilterRestoreSavedState= this.TemplateViews.extendedFilter.RestoreSavedStateSignal.subscribe(function (Value) {
        if(Value) {
            _this.ExtendedFilterSavedFiltersTableSetStateHandler(_this.TemplateViews);
        }
    });

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        _this.Views.Widgets[Key].Bind(_this);

        _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"] = Helper.SubscribeWidgetForProtocolsGroupsUpdatedIfNeeded(_this.Views.Widgets[Key].widget);

        if(!_this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"])
            delete _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"];
    });

    this.Views.DateRangePicker.Bind(this);

    this.GetAllPathParam();

    App.WebSocketManager.Connect(this.Id);

    App.WebSocketManager.Connections[this.Id].on("qoe_dashboard_save", function(R) {
        _this.WebSocketCallback(R, function(Views, ChangedItemId) {
            var changedProps = {};
            var refreshProps = {};

            var selectedItem = _this.GetTableSelectedItem(Views);

            if(selectedItem && selectedItem.dashboard_id) {
                changedProps.selectedId = selectedItem.dashboard_id;
                refreshProps.pagination_param = selectedItem.dashboard_id;
            }

            var tableId = Views.table.config.id;

            if(_this.TableItemsChangeConfigs[tableId].active) {
                refreshProps.pagination_param = ChangedItemId;
            }

            return {changedProps, refreshProps};
        });
    });

    App.WebSocketManager.Connections[this.Id].on("qoe_dashboard_delete", function(R) {
        _this.WebSocketCallback(R, function(Views, ChangedItemId) {
            var changedProps = {};
            var refreshProps = {};

            var selectedItem = _this.GetTableSelectedItem(Views);

            var tableId = Views.table.config.id;

            if(selectedItem && selectedItem.dashboard_id && !_this.TableItemsChangeConfigs[tableId].active && selectedItem.dashboard_id !== ChangedItemId) {
                changedProps.selectedId = selectedItem.dashboard_id;
                refreshProps.pagination_param = selectedItem.dashboard_id;
            }

            return {changedProps, refreshProps};
        });
    });

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.DateRangePicker = this.Views.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.DomEvents[webix.event(document.body, "click", function(ev)
    {
        var css = ev.target.className;
        if (css && css.toString().indexOf("panel_icon") != -1)
        {
            _this.Views.DashboardItemsContextMenuList.remove("settings");
            _this.DashboardItemsContextMenu.define({"height": 60});

            _this.DashboardItemsContextMenu.setContext(webix.$$(ev.target));

            var widget = _this.Views.WidgetsList.FindItemByConfig({widget_id: _this.GetWidgetFromContext().settings.widget_id});

            if(widget.form_config) {
                _this.Views.DashboardItemsContextMenuList.add({id: "settings", value: LangHelper.GetString("All", "Settings")}, 0);
                _this.DashboardItemsContextMenu.define({"height": 100});
            }

            _this.DashboardItemsContextMenu.resize();

            _this.DashboardItemsContextMenu.show(ev.target);
        }
    })] = 1;

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest(
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
    {
        if(Val[0] && Val[1] && Val[2] && Val[3])
        {
            _this.RestoreState();
        }
    });

    this.Subscriptions.SignalDicsReadySubscription = this.ProtocolsDicsManager.SignalDicsReady.subscribe(function(Updated){});

    _this.RefreshTablesAfterLoad();

    this.Views.WidgetsList.RefreshWidgets();
};

QoEDashboardViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        _this.Subscriptions[Key].unsubscribe();
    });

    var checkAndDestroyWidget = function(Widget)
    {
        if(Widget && Widget.Destroy && typeof Widget.Destroy == "function")
        {
            Widget.Destroy();
        }
    };

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var widget = _this.Views.Widgets[key];
        if(widget.widget)
        {
            checkAndDestroyWidget(widget.widget);
        }
        else{
            checkAndDestroyWidget(widget);
        }
    });

    this.Views.WidgetsList.Destroy();

    this.Views.DateRangePicker.Destroy();

    this.DashboardViews.extendedFilter.Destroy();
    this.TemplateViews.extendedFilter.Destroy();

    App.WebSocketManager.Disconnect(this.Id);

    Object.keys(this.DomEvents).forEach(function (Key)
    {
        webix.eventRemove(Key);
    });

    this.QoEDashboardEditFormContext.Destroy();

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    this.DashboardManager.Destroy();
    delete this.DashboardManager;
};

QoEDashboardViewController.prototype.CreateTablesItemsChangeConfig = function()
{
    var model = {};

    var createProps = function(Key) {
        model[Key] = new TableItemsChangeConfigModel();
    };

    createProps(this.DashboardViews.table.config.id);
    createProps(this.TemplateViews.table.config.id);

    return model;
};

QoEDashboardViewController.prototype.SetTableItemsChangeConfigProperty = function(Key, Props)
{
    var configuration = this.TableItemsChangeConfigs[Key];

    var propsModel = new TableItemsChangeConfigModel(Props);

    if(configuration) {
        Object.keys(propsModel).forEach(key => {
            if(propsModel[key] !== null) {
                configuration[key] = propsModel[key];
            }
        });
    }
};

QoEDashboardViewController.prototype.ResetTableItemsChangeConfig = function(Key)
{
    var keys = Key && Key in this.TableItemsChangeConfigs ? [Key] : Object.keys(this.TableItemsChangeConfigs);

    keys.forEach(key => {
        this.TableItemsChangeConfigs[key] = new TableItemsChangeConfigModel();
    });
};

QoEDashboardViewController.prototype.RefreshAllData = function (WidgetId, forceRefresh = false)
{
    var _this = this;

    var period = this.Views.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.DashboardViews.extendedFilter.GetFilters();

    filter = webix.extend(filter, extendedFilters, true);

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    var params = {filter:filter};

    var refresh = function(WidgetId, Params) {
        var wid = _this.Views.Widgets[WidgetId].widget;
        if(wid && wid.RefreshData) {
            var filterType = _this.Views.WidgetsList.GetWidgetFilterType({widget: wid.Name});

            var sharedFilters = _this.GetDashboardSharedFilters();

            var params = webix.copy(Params);

            if(sharedFilters.length) {
                sharedFilters.forEach(sharedFilter => {
                    var filterId = sharedFilter.shared_types[filterType];
                    if(filterId) {
                        Object.keys(params.filter).forEach(filterKey => {
                            var filter = params.filter[filterKey];
                            if(filter.id === sharedFilter.f_id) {
                                params.filter[filterKey] = webix.extend(filter, {id: filterId}, true);
                            }
                        });
                    }
                });
            }

            wid.RefreshData(0, params);
        }
    }

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(WidgetId && this.Views.Widgets[WidgetId] && this.Views.Widgets[WidgetId].widget)
        {
            refresh(WidgetId, params);
        }
        else
        {
            Object.keys(this.Views.Widgets).forEach(function (Key)
            {
                refresh(Key, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoEDashboardViewController.prototype.DashboardFactory = function (Obj, Silent)
{
    var _this = this;

    var id = _this.Id + webix.uid();
    var {widget_id, widget_settings, func} = _this.Views.WidgetsList.GetItem(Obj.name);
    var widget = window[func]({id:id, widget_settings});

    let reportsSettingsIds = [];

    this.CreateReportsSettingsData(widget);

    if(widget.WidgetOrderIds)
    {
        widget.WidgetOrderIds.forEach(widgetId => {
            reportsSettingsIds.push(_this.GetReportSettingsIdByWidgetId(widgetId));
        });
    }
    else
    {
        reportsSettingsIds.push(_this.GetReportSettingsIdByWidgetId(widget.Id));
    }


    this.Views.Widgets[id] = {
        widget,
        settings:{widget_id},
        reports_settings_ids: reportsSettingsIds
    };

    Obj.view = "panel";
    Obj.resize = true;
    Obj.icon = "bars";
    Obj.body = widget.ViewConfig;

    if(!Silent)
    {
        setTimeout(function ()
        {
            widget.Bind(_this);

            _this.Subscriptions[id + "AppProtocolsGroupsDicUpdatedSubscription"] = Helper.SubscribeWidgetForProtocolsGroupsUpdatedIfNeeded(widget);

            if(!_this.Subscriptions[id + "AppProtocolsGroupsDicUpdatedSubscription"])
                delete _this.Subscriptions[id + "AppProtocolsGroupsDicUpdatedSubscription"];
        },1);
    }

    return Obj;
};

QoEDashboardViewController.prototype.AddWidgetToDashboard = function (Widget, Position)
{
    if((!Widget.widget || !window[Widget.widget]) && (!Widget.func || !window[Widget.func]))
        return;

    var _this = this;

    var id = _this.Id + webix.uid();
    var {widget_id, func} = Widget;

    // HERE IS DROP DOWN
    if(this.Views.WidgetsList.isUpdatedWidgets)
    {
        var widget = this.Views.WidgetsList.FindItemByConfig({widget_id});

        if(!widget)
        {
            this.Views.WidgetsList.AddWidget(Widget);
            widget = this.Views.WidgetsList.FindItemByConfig({widget_id});
        }

        var widget_settings = widget.widget_settings;

        var widget = window[func]({id:id, widget_settings});

        let reportsSettingsIds = Widget && Widget.reports_settings_ids ? Widget.reports_settings_ids : [];

        if(!reportsSettingsIds.length)
        {
            this.CreateReportsSettingsData(widget);

            if(widget.WidgetOrderIds)
            {
                widget.WidgetOrderIds.forEach(widgetId => {
                    reportsSettingsIds.push(_this.GetReportSettingsIdByWidgetId(widgetId));
                });
            }
            else
            {
                reportsSettingsIds.push(this.GetReportSettingsIdByWidgetId(widget.Id));
            }
        }
        else
        {
            let isNotAvailable = Widget.reports_settings_ids.some(settings_id => !Object.keys(_this.ReportsSettingsData).includes(settings_id));

            if(isNotAvailable)
            {
                this.AddReportsSettingsData(Widget.reports_settings_ids, widget);
            }
            else
            {
                this.UpdateReportsSettingsData(Widget.reports_settings_ids, widget);
            }
        }

        this.Views.Widgets[id] = {
            widget,
            settings: {widget_id},
            reports_settings_ids: reportsSettingsIds
        };

        var view = {
            id: webix.uid(),
            view:"panel",
            resize:true,
            icon:"bars",
            body:widget.ViewConfig,
            x: Position && Position.hasOwnProperty('x') ? Position.x : Widget.x,
            y: Position && Position.hasOwnProperty('y') ? Position.y : Widget.y,
            dx: Position && Position.hasOwnProperty('dx') ? Position.dx : Widget.dx,
            dy: Position && Position.hasOwnProperty('dy') ? Position.dy : Widget.dy
        };


        this.Views.Dashboard.addView(view);

        widget.Bind(_this);

        _this.Subscriptions[id + "AppProtocolsGroupsDicUpdatedSubscription"] = Helper.SubscribeWidgetForProtocolsGroupsUpdatedIfNeeded(widget);

        if(!_this.Subscriptions[id + "AppProtocolsGroupsDicUpdatedSubscription"])
            delete _this.Subscriptions[id + "AppProtocolsGroupsDicUpdatedSubscription"];
    }

};

QoEDashboardViewController.prototype.UpdateDashboardWidget = function(OldWidget, Widget)
{
    if((!Widget.widget || !window[Widget.widget]) && (!Widget.func || !window[Widget.func]))
        return;

    this.RemoveWidgetFromDashboard(this.DashboardItemsContextMenu.getContext());
    this.AddWidgetToDashboard(Widget, OldWidget);

    if(OldWidget.widget_id != Widget.widget_id)
    {
        this.StoreState();
    }
};

QoEDashboardViewController.prototype.RemoveWidgetFromDashboard = function (WidgetPanel)
{
    var widget = WidgetPanel.getChildViews()[0];

    var widgetId = widget.config.id;

    this.Views.Widgets[widgetId].widget.Destroy();

    delete this.Views.Widgets[widgetId];

    this.Views.Dashboard.removeView(WidgetPanel);
};

QoEDashboardViewController.prototype.ClearDashboard = function ()
{
    var _this = this;

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        _this.Views.Widgets[Key].widget.Destroy();
        delete _this.Views.Widgets[Key];
    });

    this.Views.Dashboard.clearAll();
};

QoEDashboardViewController.prototype.GetDashboardState = function ()
{
    var _this = this;

    var state = [];

    var dashState = this.Views.Dashboard.serialize();

    dashState.forEach(function (State)
    {
        var widget = $$(State.id).getChildViews()[0];

        var widgetId = widget.config.id;

        var widgetModel = _this.Views.Widgets[widgetId];

        var reportsSettingsIds = _this.Views.Widgets[widgetId].reports_settings_ids

        state.push(new QoEDashboardItemStateModel({
            x:State.x,
            y:State.y,
            dx:State.dx,
            dy:State.dy,
            id:widgetId,
            widget:widgetModel.Name,
            func:widgetModel.widget.Name,
            widget_id:widgetModel.settings.widget_id,
            reports_settings_ids:reportsSettingsIds
        }));
    });

    return state;
};

QoEDashboardViewController.prototype.GetDashboardOverlay = function ()
{
    var tpl = '<div class="of-empty-folder">' +
        ' <div class="of-empty-pad">' +
        '     <div class="of-empty-cloud-txt">'+LangHelper.GetString("QoE", "Create a new dashboard")+'</div>' +
        ' </div>' +
        '</div>';
    return tpl;
};

QoEDashboardViewController.prototype.StoreState = function ()
{
    var _this = this;

    var views = this.DashboardViews;

    var selectedDashboard = webix.copy(this.GetTableSelectedItem(views));

    if(selectedDashboard.dashboard_id) {
        var state = this.GetDashboardState();

        var oldStateWidgetsCount = Array.isArray(selectedDashboard.dashboard_state) ? selectedDashboard.dashboard_state.length : 0;
        var newStateWidgetsCount = Array.isArray(state) ? state.length : 0;

        if(oldStateWidgetsCount === newStateWidgetsCount) {
            views.table.blockEvent();
        }

        selectedDashboard.dashboard_state = state;

        this.DefineAvailableFilters(state, views);

        selectedDashboard.filter_settings = this.GetFilterSettingsModel(selectedDashboard.filter_settings, views.extendedFilter.GetState());

        var tableId = views.table.config.id;

        this.SetTableItemsChangeConfigProperty(tableId, {active: true});

        this.DashboardManager.SaveDashboard(new QoEDashboardSaveModel(selectedDashboard), function(R) {
            if(!R.success && R.error) {
                views.table.unblockEvent();
                _this.ResetTableItemsChangeConfig(tableId);
            }
        });
    }
};

QoEDashboardViewController.prototype.SetExtendedFilterConfig = function(Config, Views)
{
    if(Views) {
        Views.extendedFilter.SetConfig(Config, false);

        if(Config.filters && Array.isArray(Config.filters) && Config.filters.length) {
            Views.extendedFilter.HideFiltersOverlay();
        }
        else {
            Views.extendedFilter.ShowFiltersOverlay();
        }
    }
};

QoEDashboardViewController.prototype.DefineAvailableFilters = function(DashboardState, Views)
{
    var availableFilters = this.GetAvailableFilters(DashboardState);

    var oldState = Views.extendedFilter.GetState();

    var newState = availableFilters.filters.map(filter => {
        var foundItem = oldState.find(state => state.f_id === filter.id);

        if(foundItem) {
            return foundItem;
        }

        return this.GetDefaultFilterRowModel(filter);
    });

    this.SetExtendedFilterConfig(availableFilters, Views);

    Views.extendedFilter.SetState(newState);
};

QoEDashboardViewController.prototype.GetAvailableFilters = function(DashboardState)
{
    var filterConfigs = {};

    var state = Array.isArray(DashboardState) ? DashboardState : [];

    state.forEach(stateModel => {
        var filterType = null;
        var widget = this.Views.WidgetsList.FindItemByConfig({widget_id: stateModel.widget_id});
        if(widget && widget.func !== "QoEUplinkMonitor")
        {
            filterType = widget.filter_type;

            if (!filterConfigs.hasOwnProperty(filterType))
            {
                filterConfigs[filterType] = QoEPopupFilterWidgetDefaultConfig(filterType);
            }
        }

    });

    var filterTypes = Object.keys(filterConfigs);

    var availableFilters = {type: QoESubscribersFilterListItemTypeEnum.dashboards_history, filters: [], default: []};

    var sharedFilters = this.GetDashboardSharedFilters();

    if(filterTypes.length) {
        filterTypes.forEach((type, index) => {
            var {filters} = filterConfigs[type];

            if(Array.isArray(filters) && filters.length) {
                if(index === 0) {
                    availableFilters.filters = filters;
                }
                else {
                    availableFilters.filters = filters.filter(filter => availableFilters.filters.find(availableFilters => availableFilters.id === filter.id));
                }
            }
        });

        if(sharedFilters.length) {
            sharedFilters.forEach(sharedFilter => {
                if(availableFilters.filters.length === 0 || availableFilters.filters.every(filter => filter.id !== sharedFilter.f_id)) {
                    var foundOwnerType = sharedFilter.filter_owner_types.length && sharedFilter.filter_owner_types.some(type => filterTypes.includes(type));

                    var sharedTypes = Object.keys(sharedFilter.shared_types);
                    var foundSharedType = sharedTypes.length && sharedTypes.some(type => filterTypes.includes(type));

                    var typesWithoutShared = filterTypes.filter(type => !sharedTypes.includes(type));

                    var isExistsTypeWithoutFilter = typesWithoutShared.some(type => {
                        return !QoEPopupFilterWidgetDefaultConfig(type).filters.some(filter => filter.id === sharedFilter.f_id);
                    });

                    if(foundOwnerType && foundSharedType && !isExistsTypeWithoutFilter) {
                        var ownerTypeFilters = QoEPopupFilterWidgetDefaultConfig(sharedFilter.filter_owner_types[0]).filters;
                        availableFilters.filters.splice(0, 0, ownerTypeFilters.find(filter => filter.id === sharedFilter.f_id));
                    }
                }
            });
        }

        availableFilters.default = availableFilters.filters.map(filter => {
            return this.GetDefaultFilterRowModel(filter);
        });
    }

    return availableFilters;
};

QoEDashboardViewController.prototype.GetDashboardSharedFilters = function()
{
    var {shared_filters} = QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoEDashboards);

    return shared_filters && Array.isArray(shared_filters) ? shared_filters : [];
};

QoEDashboardViewController.prototype.GetDefaultFilterRowModel = function(Filter)
{
    return new QoEPopupFilterWidgetFilterRowModel({
        f_enabled: 0,
        f_id: Filter.id,
        f_operator: Filter.operators && Filter.operators.length ? Filter.operators[0] : QoEFilterOperatorsEnum.like,
    });
};

QoEDashboardViewController.prototype.ExtendedFilterSavedFiltersTableSetStateHandler = function(Views)
{
    var selectedItem = this.GetTableSelectedItem(Views);

    if(selectedItem && selectedItem.dashboard_id) {
        this.DefineAvailableFilters(selectedItem.dashboard_state, Views);
    }
};

QoEDashboardViewController.prototype.RestoreState = function (ToDefault)
{
    var _this = this;

    var state = this.GetTableSelectedItem(this.DashboardViews);

    if(typeof ToDefault !== 'undefined')
    {
        if(ToDefault)
            state = this.DefaultState;
        else
            state = [];
    }

    _this.Views.Dashboard.blockEvent();

    _this.ClearDashboard();

    let needToUpdateDashboardState = false;

    if(state && state.dashboard_state) {
        state.dashboard_state.forEach(item => {

            if(!item.reports_settings_ids || item.reports_settings_ids.length < 1)
                needToUpdateDashboardState = true;

            var s = new QoEDashboardItemStateModel(item);

            _this.AddWidgetToDashboard(s);
        });
    }

    if(needToUpdateDashboardState)
    {
        let state = this.GetDashboardState()

        if(state && state.length)
        {
            this.UpdateSelectedItem(this.DashboardViews, {dashboard_state: state});
            this.StoreState();
        }
    }

    _this.Views.Dashboard.unblockEvent();

    this.RefreshAllData();
};

QoEDashboardViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    // var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);
    //
    // hws = hws.filter(function (Obj)
    // {
    //     return Obj.hardware_type == HardwareTypesEnum.dpi;
    // });

    App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic).forEach(function (Hw)
    {
        if(Hw.hardware_type == HardwareTypesEnum.dpi)
            opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoEDashboardViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId])
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoEDashboardViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache || ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.Views.Widgets).forEach(function (Key)
        {
            var report = _this.Views.Widgets[Key];

            if(report.GetCachesIds && report.GetCachesIds())
                params.caches_ids = params.caches_ids.concat(report.GetCachesIds());
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R && R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoEDashboardViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses || ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.Views.Widgets).forEach(function (Key)
        {
            var report = _this.Views.Widgets[Key];

            if(report.GetCachesIds && report.GetCachesIds())
                params.processes_ids = params.processes_ids.concat(_this.Views.Widgets[Key].GetCachesIds());
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R && R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoEDashboardViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R && R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoEDashboardViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEDashboardViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEDashboardViewController.prototype.SetAllPathParam = function()
{
    var period = this.Views.DateRangePicker.GetValue();

    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var dashboard = this.GetTableSelectedItem(this.DashboardViews);
    if(dashboard && dashboard.dashboard_id)
    {
        this.SetPathParam("dashboard", dashboard.dashboard_id);
    }

    this.JustNavigate();
};

QoEDashboardViewController.prototype.GetAllPathParam = function()
{
    try {
        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.DateRangePicker.SetValue(period,true);
    }
    catch(e){}
};

QoEDashboardViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEDashboardViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:[],
        filter_config: []
    };
};

QoEDashboardViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)
    };
};

QoEDashboardViewController.prototype.AddDashboard = function(Node, SubDashboard = false)
{
    var views = this.DashboardViews;

    var model = {
        available:AvailableUsersEnum.me_only.id
    };

    if(SubDashboard) {
        var selectedItem = this.GetTableSelectedItem(views);

        model.parent_dashboard_id = selectedItem.dashboard_id;
    }

    this.SetExtendedFilterConfig(QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoEDashboards))
    views.extendedFilter.SetState();

    this.ShowEditForm(model, Node,"left");
};

QoEDashboardViewController.prototype.SelectDashboard = function()
{
    this.RestoreState();

    if(Object.keys(this.ReportsSettingsData).length)
    {
        this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings(true)
    }

    var selectedDashboard = this.GetTableSelectedItem(this.DashboardViews);

    if(selectedDashboard) {
        this.PutDashboardIdInLocalStorage(selectedDashboard.dashboard_id);

        if(!selectedDashboard.parent_dashboard_id) {
            this.Views.AddSubDashboardBtn.enable();
        }

        if(!this.Views.DashboardLayout.isEnabled()){
            this.Views.DashboardLayout.enable();
            this.Views.WidgetListButtonsLayout.enable();
            this.Views.DashboardScrollView.hideOverlay();
        }
    }
};

QoEDashboardViewController.prototype.OnTableRowSelectionChange = function(Template = false)
{
    var data = this.GetTableSelectedItem(Template ? this.TemplateViews : this.DashboardViews);

    this.TableRowSelectedCount.next({
        is_template: Template,
        value: data ? (Array.isArray(data) ? data.length : 1) : 0
    });
};

QoEDashboardViewController.prototype.TableRowSelectedCountSubscriptionHandler = function(SelectObj)
{
    SelectObj.is_template
        ? this.SavedTemplatesTableRowsSelectedCountSubscriptionHandler(SelectObj.value)
        : this.SavedDashboardsTableRowsSelectedCountSubscriptionHandler(SelectObj.value);
};

QoEDashboardViewController.prototype.SavedDashboardsTableRowsSelectedCountSubscriptionHandler = function(Value)
{
    var _this = this;

    var views = this.DashboardViews;

    var _disableAll = function() {
        views.extendedFilter.DisableBtn();
        views.extendedFilter.SetDefaultState();
        _this.Views.AddSubDashboardBtn.disable();
    }

    if(Value != 1) {
        _disableAll();
        return;
    }

    var selectedData = this.GetTableSelectedItem(views);

    if(!selectedData || !selectedData.dashboard_id) {
        _disableAll();
        return;
    }

    this.DeleteDashboardNotExistWidgets(selectedData, function() {
        _this.SetAvailableFiltersConfig(selectedData, views);

        _this.SelectDashboard();
    });
};

QoEDashboardViewController.prototype.SavedTemplatesTableRowsSelectedCountSubscriptionHandler = function(Value)
{
    if(Value != 1) {
        return;
    }

    var selectedData = this.GetTableSelectedItem(this.TemplateViews);

    if(!selectedData || !selectedData.dashboard_id) {
        return;
    }

    this.SetAvailableFiltersConfig(selectedData, this.TemplateViews);
};

QoEDashboardViewController.prototype.TableFilterSortHandler = function(Views)
{
    var refreshParams = {page: Views.pager.config.page};

    var selectedItem = this.GetTableSelectedItem(Views);

    var configuration = this.TableItemsChangeConfigs[Views.table.config.id];

    if(!configuration.active) {
        if(selectedItem && selectedItem.dashboard_id) {
            configuration.active = true;
            configuration.selectedId = selectedItem.dashboard_id;
            refreshParams.pagination_param = configuration.selectedId;
        }

        this.RefreshTable(refreshParams, Views);
    }
};

QoEDashboardViewController.prototype.SetAvailableFiltersConfig = function(SelectedObj, Views)
{
    if(Views)
    {
        var availableFilters = this.GetAvailableFilters(SelectedObj.dashboard_state);

        this.SetExtendedFilterConfig(availableFilters, Views);

        if(SelectedObj.dashboard_id) {
            if(SelectedObj.filter_settings && SelectedObj.filter_settings.filter_id) {
                var filterState = this.ParseFilterState(SelectedObj.filter_settings);
                Views.extendedFilter.SetState(filterState ? filterState : []);
            }
            else {
                Views.extendedFilter.SetDefaultState();
            }

            Views.extendedFilter.EnableBtn();
        }
    }

};

QoEDashboardViewController.prototype.ParseFilterState = function(FilterSettings)
{
    var formData;

    if(FilterSettings.form_data) {
        formData = JSON.parse(FilterSettings.form_data);
    }

    return formData && formData.hasOwnProperty("filter_state") ? formData.filter_state : null;
};

QoEDashboardViewController.prototype.ApplyExtendedFilter = function(Views)
{
    var _this = this;

    var selectedData = webix.copy(this.GetTableSelectedItem(Views));

    if(selectedData.filter_settings) {
        selectedData.filter_settings.type = QoESubscribersFilterListItemTypeEnum.dashboards_history;
        selectedData.filter_settings = this.GetFilterSettingsModel(selectedData.filter_settings, Views.extendedFilter.GetState());

        var tableId = Views.table.config.id;
        this.SetTableItemsChangeConfigProperty(tableId, {active: true});

        this.DashboardManager.SaveDashboard(new QoEDashboardSaveModel(selectedData), function(R) {
            if(!R.success && R.error) {
                _this.ResetTableItemsChangeConfig(tableId);
            }
        });
    }
};

QoEDashboardViewController.prototype.ShowEditForm = function(Model, Node, Pos)
{
    this.QoEDashboardEditFormContext.SetData(Model, true);
    this.QoEDashboardEditFormContext.Show(Node, Pos);
};

QoEDashboardViewController.prototype.PutDashboardIdInLocalStorage = function(Data)
{
    var uname = App.SessionManager.currentLogin;

    webix.storage.local.put(this.Id + "SelectedDashboardId" + uname, Data);
};

QoEDashboardViewController.prototype.GetDashboardIdFromLocalStorage = function()
{
    var uname = App.SessionManager.currentLogin;

    return webix.storage.local.get(this.Id + "SelectedDashboardId" + uname);
};

QoEDashboardViewController.prototype.RefreshTablesAfterLoad = function()
{
    this.RefreshTable({pagination_param: this.FindStorageDashboardId()}, this.DashboardViews);

    this.RefreshTable(null, this.TemplateViews);
};

QoEDashboardViewController.prototype.RefreshTable = function(Params, Views)
{
    var state = Views.table.getState();

    var params = {
        page: Params && Params.page ? Params.page : 0,
        filter:state.filter,
        sort:state.sort,
        pagination_param: Params && Params.pagination_param ? Params.pagination_param : null,
    };

    Views === this.TemplateViews ? this.DashboardManager.RefreshTemplates(params) : this.DashboardManager.RefreshDashboards(params);
};

QoEDashboardViewController.prototype.UpdateDashboardsTable = function()
{
    var views = this.DashboardViews;

    this.UpdateTable(this.DashboardManager.GetDashboards(), this.DashboardManager.TotalDashboards, views);

    if(views.table.count()) {
        this.BlockTableEventsIfNeed(views);

        var rememberedDashboardId = this.GetNeedToSelectItemId(views);

        this.SelectLastRememberedTableRow(rememberedDashboardId ? rememberedDashboardId : this.FindStorageDashboardId(), views);

        var selectedData = this.GetTableSelectedItem(views);

        if(selectedData && selectedData.dashboard_id) {
            views.extendedFilter.EnableBtn();
            selectedData.parent_dashboard_id ? this.Views.AddSubDashboardBtn.disable() : this.Views.AddSubDashboardBtn.enable();
        }
    }
    else {
        this.ShowDashboardOverlay();
    }

    views.table.unblockEvent();
    this.ResetTableItemsChangeConfig(views.table.config.id);
};

QoEDashboardViewController.prototype.UpdateTemplatesTable = function()
{
    var views = this.TemplateViews;

    this.UpdateTable(this.DashboardManager.GetTemplates(), this.DashboardManager.TotalTemplates, views);

    if(views.table.count()) {
        this.BlockTableEventsIfNeed(views);

        var rememberedTemplateId = this.GetNeedToSelectItemId(views);

        this.SelectLastRememberedTableRow(rememberedTemplateId ? rememberedTemplateId : null, views);

        views.table.unblockEvent();
    }

    this.ResetTableItemsChangeConfig(views.table.config.id);
};

QoEDashboardViewController.prototype.GetNeedToSelectItemId = function(Views)
{
    var configuration = this.TableItemsChangeConfigs[Views.table.config.id];

    if(configuration.active) {
        return configuration.changedId;
    }
    else if(configuration.changedId) {
        return configuration.selectedId;
    }

    return null;
};

QoEDashboardViewController.prototype.BlockTableEventsIfNeed = function(Views)
{
    var configuration = this.TableItemsChangeConfigs[Views.table.config.id];

    if(!configuration.active && configuration.selectedId && configuration.changedId && configuration.changedId !== configuration.selectedId) {
        Views.table.blockEvent();
    }
};

QoEDashboardViewController.prototype.FindStorageDashboardId = function()
{
    var dashboardId = parseInt(this.GetPathParam("dashboard"), 10);
    if(dashboardId) {
        return dashboardId;
    }
    else {
        return this.GetDashboardIdFromLocalStorage();
    }
};

QoEDashboardViewController.prototype.WebSocketCallback = function(R, PropertiesFunc)
{
    var response = JSON.parse(R);

    if(response.success) {
        var dashboardModel = new QoEDashboardGetModel(response.data);
        var dashboardId = dashboardModel.dashboard_id;
        var views = this.GetViews(dashboardModel);

        var tableId = views.table.config.id;
        var refreshParams = {page: views.pager.config.page};
        var changedProperties = {changedId: dashboardId};

        var {changedProps, refreshProps} = PropertiesFunc(views, dashboardId);

        refreshParams = webix.extend(refreshParams, refreshProps, true);
        changedProperties = webix.extend(changedProperties, changedProps, true);

        this.SetTableItemsChangeConfigProperty(tableId, changedProperties);

        this.RefreshTable(refreshParams, views);
    }
    else {
        this.ResetTableItemsChangeConfig();
    }
};

QoEDashboardViewController.prototype.UpdateTable = function(Data, Total, Views)
{
    if(Data && Total) {
        Views.table.clearAll();
        Views.table.parse(Data);

        Views.pager.define(Total);
        Views.pager.refresh();
    }
};

QoEDashboardViewController.prototype.ShowDashboardOverlay = function()
{
    this.Views.DashboardLayout.disable();
    this.Views.WidgetListButtonsLayout.disable();
    this.RestoreState(false);
    this.Views.DashboardScrollView.showOverlay(this.GetDashboardOverlay());
};

QoEDashboardViewController.prototype.SelectLastRememberedTableRow = function(RememberedId, Views)
{
    var willBeSelectedId = Views.table.getFirstId();

    if (RememberedId) {

        var rows = this.GetFlatTableDataArray(Views);

        var foundSelectedRow = rows.find(row => row.dashboard_id == RememberedId);

        if (foundSelectedRow) {
            if(Views.table.open && Views.table.getParentId) {
                Views.table.open(Views.table.getParentId(foundSelectedRow.id));
            }
            willBeSelectedId = foundSelectedRow.id;
        }
    }
    Views.table.select(willBeSelectedId);
    Views.table.showItem(willBeSelectedId);
};

QoEDashboardViewController.prototype.GetFlatTableDataArray = function(Views)
{
    var rows = Views.table.serialize();

    var flatArray = [];

    rows.forEach(row => {
        flatArray.push(row);
        if(row.data) {
            flatArray.push(...row.data);
        }
    });

    return flatArray;
};

QoEDashboardViewController.prototype.GetViews = function(Model)
{
    if(Model) {
        if(Model.is_template) {
            return this.TemplateViews;
        }
        else {
            return this.DashboardViews;
        }
    }

    return null;
};

QoEDashboardViewController.prototype.GetTableSelectedItem = function(Views)
{
    return Views.table.getSelectedItem();
};

QoEDashboardViewController.prototype.GetTableSelectedId = function(Views)
{
    return Views.table.getSelectedId();
};

QoEDashboardViewController.prototype.UpdateSelectedItem = function(Views, Params)
{
    let id = this.GetTableSelectedId(Views);
    let item = this.GetTableSelectedItem(Views);

    Object.keys(Params).forEach(key => {
       if(Object.keys(item).includes(key))
       {
           item[key] = Params[key];
       }
    });

    return Views.table.updateItem(id.row, item);
};

QoEDashboardViewController.prototype.DashboardEditFormSignalSaveHandler = function()
{
    var _this = this;

    var data = this.QoEDashboardEditFormContext.GetData();

    var editFormState = this.QoEDashboardEditFormContext.GetState();

    var views = this.GetViews(data);

    if(data && views) {
        if(editFormState === DashboardEditFormStatesEnum.create_dashboard) {
            var selectedTemplateId = this.QoEDashboardEditFormContext.GetSelectedTemplateComboValue();

            var template = this.QoEDashboardEditFormContext.TemplatesListData.find(item => item.id === selectedTemplateId);

            if (template) {
                data.dashboard_state = template.dashboard_state;

                data.filter_settings = this.GetFilterSettingsModel({form_data: template.filter_settings.form_data}, this.ParseFilterState(template.filter_settings));
            }
            else {
                data.filter_settings = this.GetFilterSettingsModel(null, []);
            }
        }

        if(editFormState === DashboardEditFormStatesEnum.create_template) {
            data.filter_settings = this.GetFilterSettingsModel({form_data: data.filter_settings.form_data}, this.ParseFilterState(data.filter_settings));
        }

        if(editFormState === DashboardEditFormStatesEnum.edit_dashboard || editFormState === DashboardEditFormStatesEnum.edit_template) {
            data.filter_settings = this.GetFilterSettingsModel(data.filter_settings, this.ParseFilterState(data.filter_settings));
        }

        var tableId = views.table.config.id;

        this.SetTableItemsChangeConfigProperty(tableId, {active: true});

        this.DashboardManager.SaveDashboard(new QoEDashboardSaveModel(data), function(R) {
            if(R.success) {
                _this.QoEDashboardEditFormContext.Hide();
            }
            else if(R.error) {
                webix.message({type: "error", text: R.error.msg});
                _this.ResetTableItemsChangeConfig(tableId);
            }
        });
    }
};

QoEDashboardViewController.prototype.GetFilterSettingsModel = function(ListItemModel, FilterState)
{
    return new QoEDashboardFilterSettingsModel({
        filter: new QoESubscribersFilterListItemModel(webix.extend(ListItemModel ? ListItemModel : {}, {type: QoESubscribersFilterListItemTypeEnum.dashboards_history})),
        filter_form: new QoEFilterFormModel({filter_state: FilterState ? FilterState : []})
    });
};

QoEDashboardViewController.prototype.DeleteTableRow = function(Id, Views)
{
    var _this = this;

    var item = Views.table.getItem(Id);

    if(item.dashboard_id) {
        var tableId = Views.table.config.id;

        this.SetTableItemsChangeConfigProperty(tableId, {active: true});

        this.DashboardManager.Delete({
            dashboard: item,
            callback: function(R) {
                if(R.success) {
                    webix.message(LangHelper.GetString("QoE", "Dashboard deleted"));
                }
                else {
                    if(R.error) {
                        webix.message({type: "error", text:R.error.msg});
                        _this.ResetTableItemsChangeConfig(tableId);
                    }
                }
            }
        });
    }
    else {
        Views.table.remove(Id);
    }
};

// Widget Settings SECTION
QoEDashboardViewController.prototype.DeleteDashboardNotExistWidgets = function(SelectedData, IfNotDeleteCallback = null)
{
    var _this = this;

    if(SelectedData && this.Views.WidgetsList.isUpdatedWidgets) {
        if(SelectedData.hasOwnProperty("dashboard_state") && Array.isArray(SelectedData.dashboard_state)) {
            var views = this.DashboardViews;

            var newState = [];
            SelectedData.dashboard_state.forEach(item => {
                var stateModel = new QoEDashboardItemStateModel(item);

                var widget = this.Views.WidgetsList.FindItemByConfig({widget_id: stateModel.widget_id});
                if (widget) {
                    newState.push(stateModel);
                }
            });

            if (newState.length !== SelectedData.dashboard_state.length) {
                var model = webix.copy(SelectedData);

                model.dashboard_state = newState;

                this.DefineAvailableFilters(newState, views);

                model.filter_settings = this.GetFilterSettingsModel(model.filter_settings, views.extendedFilter.GetState());

                var tableId = views.table.config.id;

                this.SetTableItemsChangeConfigProperty(tableId, {
                    active: true
                });

                this.DashboardManager.SaveDashboard(new QoEDashboardSaveModel(model), function (R) {
                    if (!R.success && R.error) {
                        webix.message({type: "error", text: R.error.msg});
                        _this.ResetTableItemsChangeConfig(tableId);
                    }
                });

                return;
            }
        }

        if(IfNotDeleteCallback && typeof IfNotDeleteCallback === "function") {
            IfNotDeleteCallback();
        }
    }

    this.SetAvailableFiltersConfig(SelectedData, views);

    this.SelectDashboard();
};


QoEDashboardViewController.prototype.CreateTablesItemsChangeConfig = function()
{
    var model = {};

    var createProps = function(Key) {
        model[Key] = new TableItemsChangeConfigModel();
    };

    createProps(this.DashboardViews.table.config.id);
    createProps(this.TemplateViews.table.config.id);

    return model;
};

QoEDashboardViewController.prototype.SetTableItemsChangeConfigProperty = function(Key, Props)
{
    var configuration = this.TableItemsChangeConfigs[Key];

    var propsModel = new TableItemsChangeConfigModel(Props);

    if(configuration) {
        Object.keys(propsModel).forEach(key => {
            if(propsModel[key] !== null) {
                configuration[key] = propsModel[key];
            }
        });
    }
};

QoEDashboardViewController.prototype.ResetTableItemsChangeConfig = function(Key)
{
    var keys = Key && Key in this.TableItemsChangeConfigs ? [Key] : Object.keys(this.TableItemsChangeConfigs);

    keys.forEach(key => {
        this.TableItemsChangeConfigs[key] = new TableItemsChangeConfigModel();
    });
};

QoEDashboardViewController.prototype.SetDefaultDashboardStateConfig = function()
{
    var funcNames = {
        "QoEUplinkMonitor": {x: 0, y: 0},
        "QoESingleStatTotalsWidget": {x: 0, y: 0},
        "QoESingleStatRttWidget": {x: 0, y: 2},
        "QoESingleStatSubscribersRttWidget": {x: 0, y: 4},
        "QoERttDistributionWidget": {x: 0, y: 6},
        "QoERttByTimeWidget": {x: 6, y: 6},
        "QoESeriesChartTrafficWidget": {x: 0, y: 11},
        "QoESeriesChartRetransmitsByTimeWidget": {x: 6, y: 11},
        "QoEPieChartTopRttSubscribersWidget": {x: 0, y: 16},
        "QoETableTopRttSubscribersWidget": {x: 6, y: 16},
        "QoESingleStatClickstreamTotalsWidget": {x: 0, y: 21},
        "QoETableClickstreamTopHostsWidget": {x: 0, y: 23},
        "QoETableClickstreamTopDevicesWidget": {x: 6, y: 23}
    };

    var state = [];
    Object.keys(funcNames).forEach(funcName => {
        var widget = this.Views.WidgetsList.FindItemByConfig({func: funcName, is_system: 1});
        if (widget) {
            var {dx, dy, func, widget_id} = widget;
            var {x, y} = funcNames[funcName];
            state.push(new QoEDashboardItemStateModel({x, y, dx, dy, func, widget_id}));
        }
    });

    this.DefaultState = new QoEDashboardModel({
        dashboard_state: state
    });
};


QoEDashboardViewController.prototype.ShowWidgetSettingsForm = function(Node)
{
    var widget = this.GetWidgetFromContext();

    var {widget_settings, form_config} = this.Views.WidgetsList.FindItemByConfig({widget_id: widget.settings.widget_id});

    this.ReconstructWidgetSettingsContext(widget_settings, form_config);

    this.WidgetSettingsContext.show(Node);
};

QoEDashboardViewController.prototype.HideWidgetSettingsForm = function()
{
    this.WidgetSettingsContext.hide();
};

QoEDashboardViewController.prototype.HideDashboardItemsContextMenu = function()
{
    this.DashboardItemsContextMenu.hide();
};

QoEDashboardViewController.prototype.ApplyWidgetSettingsFormValues = function()
{
    var _this = this;
    var form = this.Views.WidgetSettingsContextForm;

    form.clearValidation();

    var widget = this.GetWidgetFromContext();

    var widget_id = widget.settings.widget_id;

    var {widget_settings} = this.Views.WidgetsList.FindItemByConfig({widget_id});

    if(this.ValidateWidgetSettingsForm(widget_settings)) {
        this.Views.WidgetsList.CopySettingsIntoNewWidget({widget: {widget_id, widget_settings: form.getValues()}, callback: R => {
                if (!R.success) {
                    webix.message({type: "error", text: R.error.msg});
                }
                else {
                    var contextWidget = this.GetWidgetFromContext();

                    var state = this.GetDashboardState();

                    var oldWidget = state.find(stateModel => stateModel.widget_id === contextWidget.settings.widget_id);

                    if (oldWidget) {
                        // var {dx, dy, x, y} = oldWidget;
                        this.Views.Dashboard.blockEvent();
                        this.UpdateDashboardWidget(oldWidget, R.data);
                        this.Views.Dashboard.unblockEvent();
                    }

                    this.HideWidgetSettingsForm();
                    this.HideDashboardItemsContextMenu();
                    webix.message(LangHelper.GetString("QoE", "Widget updated"));

                    setTimeout(() => this.RefreshAllData(), 100);
                }
            }
        });
    }else{
        webix.message({type:"error", text:LangHelper.GetString("QoE", "Please fill the form correctly!")});
    }
};

QoEDashboardViewController.prototype.ValidateWidgetSettingsForm = function(WidgetSettings)
{
    var values = this.Views.WidgetSettingsContextForm.getValues();

    var valuesByValidateFunc = {};

    Object.keys(values).forEach(fieldName => {
        var validateModel = this.WidgetSettingsFieldsValidationConfigs[fieldName];

        if(!Array.isArray(valuesByValidateFunc[validateModel.func])) {
            valuesByValidateFunc[validateModel.func] = [];
        }

        valuesByValidateFunc[validateModel.func].push({fieldName, value: values[fieldName], widgetSettings: WidgetSettings, validateModel});
    });

    return Object.keys(valuesByValidateFunc).every(func => {
        return this[func](valuesByValidateFunc[func]);
    });
};

QoEDashboardViewController.prototype.ValidateProtocolsList = function(Params)
{
    if(!Params || !Array.isArray(Params) || Params.length < 0)
    {
        return false;
    }
    var value = Params[0].value;
    if(!value || !Array.isArray(value))
        return false;

    var val = function(v)
    {
        if(!v.protocol || !v.protocol_code)
        {
            return false;
        }

        // Validate delta
        if(v.delta && Array.isArray(v.delta))
        {
            if(v.delta.length !== 3)
            {
                return false;
            }

            var prev_delta_val = 0, prev_delta_point = 0;

            var delta_valid = true;
            v.delta.forEach(delta => {
                if(delta.max_val != "none")
                {
                    if(delta.max_val < 0 || delta.max_val > 100)
                    {
                        delta_valid = false;
                    }

                    if(delta.max_val >= prev_delta_val && delta.points >= prev_delta_point)
                    {
                        prev_delta_val = delta.max_val;
                        prev_delta_point = delta.points;
                    }
                    else{
                        delta_valid = false;
                    }
                }
            });

            return delta_valid;
        }
        else{
            return false;
        }

        //Validate rtt
        if(v.rtt_to && Array.isArray(v.rtt_to))
        {
            if(v.rtt_to.length !== 7)
            {
                return false;
            }

            var prev_val = 0, prev_point = 0;

            var rtt_valid = true;

            v.rtt_to.forEach(rtt => {
                if(rtt.max_val != "none")
                {
                    if(rtt.max_val < 0)
                    {
                        rtt_valid = false;
                    }

                    if(rtt.max_val >= prev_val && rtt.points >= prev_point)
                    {
                        prev_val = rtt.max_val;
                        prev_point = rtt.points;
                    }
                    else{
                        rtt_valid = false;
                    }
                }
            });

            return rtt_valid;
        }
        else{
            return false;
        }

    };

    var valid = true;
    value.forEach(function(V){

        if(valid && !val(V))
        {
            valid = false;
        }

    });

    return valid;
};

QoEDashboardViewController.prototype.ValidateWidgetSettingsAsNumber = function(Params)
{
    var formFields = this.Views.WidgetSettingsContextForm.getChildViews();

    var result = false;

    if(Array.isArray(Params) && Params.length) {
        var isValid = Params.every(item => {
            item.validateModel.value_priority = item.validateModel.value_priority ? parseFloat(item.validateModel.value_priority) : null;

            if(item.value === "") {
                item.value = item.widgetSettings[item.fieldName];
                return true;
            }

            if(webix.rules.isNumber(item.value)) {
                item.value = parseFloat(item.value);
                item.value = item.value === -0 ? 0 : item.value;

                if(this.ValidateWidgetSettingNumberSign(item.value, item.validateModel)) {
                    return true;
                }
            }

            var field = formFields.find(view => view.config.name === item.fieldName);

            this.SetFieldInvalidMessage(field, LangHelper.GetString("QoE", "Incorrect value"));

            return false;
        });

        if(isValid) {
            var valuesWithPriority = Params.filter(item => {
                return item.validateModel.value_priority !== null;
            });

            valuesWithPriority.sort((a, b) => a.validateModel.value_priority > b.validateModel.value_priority ? 1 : -1);

            var isSorted = function(Array, Length) {
                if(Length === 1 || Length === 0) {
                    return true;
                }
                return Array[Length-2].value <= Array[Length-1].value && isSorted(Array, Length-1);
            };

            result = isSorted(valuesWithPriority, valuesWithPriority.length);

            if(!result) {
                valuesWithPriority.forEach(item => {
                    var field = formFields.find(view => view.config.name === item.fieldName);

                    this.SetFieldInvalidMessage(field, LangHelper.GetString("QoE", "Incorrect value"));
                });
            }
        }

        return result;
    }

    this.SetFieldInvalidMessage(formFields, LangHelper.GetString("QoE", "Incorrect value"));

    return result;
};

QoEDashboardViewController.prototype.ValidateWidgetSettingNumberSign = function(Value, ValidateModel) {
    return ValidateModel.number_sign ? this[ValidateModel.number_sign](Value) : true;
};

QoEDashboardViewController.prototype.ValidateWidgetSettingNotNegativeNumberSign = function(Value) {
    return Math.sign(Value) >= 0;
};

QoEDashboardViewController.prototype.SetFieldInvalidMessage = function(Fields, InvalidMessage)
{
    var setFunc = function(View) {
        if(View && View.config && View.validate && typeof View.validate === "function") {
            View.config.invalidMessage = InvalidMessage;
            View.validate();
        }
    }
    if(Array.isArray(Fields)) {
        Fields.forEach(item => {
            setFunc(item);
        });
    }
    else {
        setFunc(Fields);
    }
};

QoEDashboardViewController.prototype.GetWidgetFromContext = function()
{
    var context = this.DashboardItemsContextMenu.getContext();

    var widget = context.getChildViews()[0];

    var widgetId = widget.config.id;

    return this.Views.Widgets[widgetId];
};

QoEDashboardViewController.prototype.ReconstructWidgetSettingsContext = function(Settings, FormConfig)
{
    var _this = this;

    if(FormConfig && Array.isArray(FormConfig.elements)) {
        let needToCalculateHeight = true;
        var height = FormConfig.height ? FormConfig.height : 0;
        if(height > 0)
        {
            needToCalculateHeight = false;
        }
        var width = 0;

        var layoutFields = this.Views.WidgetSettingsContextForm.getChildViews().map(child => child.config.id);
        layoutFields.forEach(element => {
            this.Views.WidgetSettingsContextForm.removeView(element);
        });

        this.WidgetSettingsFieldsValidationConfigs = {};

        FormConfig.elements.forEach(item => {
            var labelWidth = parseInt(item.labelWidth, 10);
            var itemWidth = item.width ? parseInt(item.width, 10) : 0;
            width = !isNaN(labelWidth) && labelWidth > width ? labelWidth : width;

            if(itemWidth > width)
            {
                width = itemWidth;
            }
            if(needToCalculateHeight)
            {
                height += item.height ? item.height : 56;
            }

            this.WidgetSettingsFieldsValidationConfigs[item.name] = new QoEWidgetValidateModel(item.validate);
            if(item.view == "uplink-monitor"){
                this.Views.WidgetSettingsContextForm.addView({
                    view: "uplink-monitor",
                    name: item.name,
                    width: item.width ? item.width : 240,
                    labelWidth: 0,
                    label: null,
                    on_item_click_column_actions: item.on_item_click_column_actions,
                    toolbar_elements: item.toolbar_elements,
                    columns: item.columns,
                    validate: function(Val)
                    {
                        if(item.validate && item.validate.func)
                        {
                            var func = item.validate.func;
                            if(window[func] && typeof window[func] == "function")
                            {
                                return window[func](Val);
                            }
                        }
                        return true;
                    }
                });
            }
            else{
                this.Views.WidgetSettingsContextForm.addView({
                    view: item.view,
                    name: item.name,
                    label: LangHelper.GetLocale() === "ru" ? item.label.ru : item.label.en,
                    labelWidth: item.labelWidth,
                    labelPosition: "left",
                    labelAlign: "left",
                    bottomPadding: 20,
                    placeholder: Settings && Settings.hasOwnProperty(item.name) ? Settings[item.name].toString() : "",
                    validate: Val => false
                });
            }

        });

        const buttonHeight = 48;
        if(needToCalculateHeight)
        {
            height += buttonHeight * 2;
        }
        this.Views.WidgetSettingsContextForm.addView(
            {
                height: buttonHeight,
                cols: [
                    {
                        view: "button",
                        value: LangHelper.GetString("All", "Cancel"),
                        click: function() {
                            _this.HideWidgetSettingsForm();
                            _this.HideDashboardItemsContextMenu();
                        }
                    },
                    {
                        view: "button",
                        type: "form",
                        value: LangHelper.GetString("All", "Apply"),
                        click: function()
                        {
                            setTimeout(function(){_this.ApplyWidgetSettingsFormValues();},1);

                        }
                    }
                ]
            }
        );

        this.WidgetSettingsContext.define({"height": height, "width": width});
        this.WidgetSettingsContext.resize();
        this.Views.WidgetSettingsContextForm.refresh();
        this.Views.WidgetSettingsContextForm.setValues(Settings);
    }
};

QoEDashboardViewController.prototype.CreateReportsSettingsData = function(Widget)
{
    let _this = this;

    let dashboardId = parseInt(this.GetPathParam("dashboard"), 10);

    if(Widget.WidgetOrderIds && Widget.WidgetOrderIds.length)
    {
        Widget.WidgetOrderIds.forEach(widgetId => {
            let key =  _this.Id + "ReportSettings" + webix.uid();
            _this.ReportsSettingsData[key] = new DashboardReportSettingsDataModel({
                settings_id: key,
                dashboard_id: dashboardId ? dashboardId : null,
                cur_id: widgetId
            });
        });
    }
    else
    {
        let key =  _this.Id + "ReportSettings" + webix.uid();
        this.ReportsSettingsData[key] = new DashboardReportSettingsDataModel({
            settings_id: key,
            dashboard_id: dashboardId ? dashboardId : null,
            cur_id: Widget.Id
        });
    }
};

QoEDashboardViewController.prototype.AddReportsSettingsData = function(SettingsIds, Widget)
{
    let _this = this;

    let dashboardId = parseInt(this.GetPathParam("dashboard"), 10);

    let add = function(key, widgetId)
    {
        _this.ReportsSettingsData[key] = new DashboardReportSettingsDataModel({
            settings_id: key,
            dashboard_id: dashboardId ? dashboardId : null,
            cur_id: widgetId
        });
    }

    if(Widget.WidgetOrderIds && Widget.WidgetOrderIds.length === SettingsIds.length)
    {
        let idx = 0;
        Widget.WidgetOrderIds.forEach(widgetId => {
            let key = SettingsIds[idx];
            add(key, widgetId);
            idx++;
        });
    }
    else
    {
        add(SettingsIds[0], Widget.Id);
    }
};

QoEDashboardViewController.prototype.UpdateReportsSettingsData = function(SettingsIds, Widget)
{
    let _this = this;

    let update = function(key, widgetId)
    {
        let data = _this.ReportsSettingsData[key];
        data.prev_id = data.cur_id;
        data.cur_id = widgetId;
    }

    if(Widget.WidgetOrderIds && Widget.WidgetOrderIds.length === SettingsIds.length)
    {
        let idx = 0;
        Widget.WidgetOrderIds.forEach(widgetId => {
            let key = SettingsIds[idx];
            update(key, widgetId);
            idx++;
        });
    }
    else
    {
        update(SettingsIds[0], Widget.Id);
    }
};

QoEDashboardViewController.prototype.GetReportSettingsIdByWidgetId = function(WidgetId)
{
    let data = Helper.DictToArr(this.ReportsSettingsData);
    let find = data.find(item => item.cur_id === WidgetId);

    if(find && find.settings_id)
        return find.settings_id;
}

QoEDashboardViewController.prototype.GetDashboardReportSettingsData = function(WidgetId)
{
    return Helper.DictToArr(this.ReportsSettingsData).find(item => item.cur_id === WidgetId);
};

QoEDashboardViewController.prototype.GetSelectedDashboardId = function()
{
    let dashboard = this.GetTableSelectedItem(this.DashboardViews);
    return dashboard && dashboard.dashboard_id ? dashboard.dashboard_id : null;
};
function QoEClickStreamViewController(Params)
{
    var _this = this;

    this.Id = "QoEClickStream";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.Subscriptions = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,

        //PeriodPicker:null,
        DpiPicker:null,

        ExecTimeSelector:null
    };

    this.Views.Widgets =
    {

        DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"}),

        ExtendedFillter: new QoEPopupFilterWidget({
            id:this.Id + "ExtendedFillter",
            config: QoEPopupFilterWidgetDefaultConfig("QoEClickstream"),
            enable_show_hotkey: 1
        }),

        UserReportsFormWidget: function() {
            if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
        }(),

        TopHostsPieReport: QoEPieChartClickstreamTopHostsWidget({id:this.Id + "TopHostsPieReport"}),

        TopHostsReport: QoETableClickstreamTopHostsWidget({id:this.Id + "TopHostsReport"}),

        TopHostsBySessionsReport: QoETableClickstreamTopHostsBySessionsWidget({id:this.Id + "TopHostsBySessionsReport"}),

        TopHostsByTrafficReport: QoETableClickstreamTopHostsByTrafficWidget({id:this.Id + "TopHostsByTrafficReport"}),

        TopHostsByFlowReport: QoETableClickstreamTopHostsByFlowWidget({id:this.Id + "TopHostsByFlowReport"}),

        TopHostsByRttReport: QoETableClickstreamTopHostsByRttWidget({id:this.Id + "TopHostsByRttReport"}),



        TopSubscribersPieReport: QoEPieChartClickstreamTopSubscribersWidget({id:this.Id + "TopSubscribersPieReport"}),

        TopSubscribersReport: QoETableClickstreamTopSubscribersWidget({id:this.Id + "TopSubscribersReport"}),

        TopSubscribersBySessionsReport: QoETableClickstreamTopSubscribersBySessionsWidget({id:this.Id + "TopSubscribersBySessionsReport"}),

        TopSubscribersByTrafficReport: QoETableClickstreamTopSubscribersByTrafficWidget({id:this.Id + "TopSubscribersByTrafficReport"}),

        TopSubscribersByFlowReport: QoETableClickstreamTopSubscribersByFlowWidget({id:this.Id + "TopSubscribersByFlowReport"}),

        TopSubscribersByRttReport: QoETableClickstreamTopSubscribersByRttWidget({id:this.Id + "TopSubscribersByRttReport"}),



        TopDevicesPieReport: QoEPieChartClickstreamTopDevicesWidget({id:this.Id + "TopDevicesPieReport"}),

        TopDevicesReport: QoETableClickstreamTopDevicesWidget({id:this.Id + "TopDevicesReport"}),

        TopDevicesBySessionsReport: QoETableClickstreamTopDevicesBySessionsWidget({id:this.Id + "TopDevicesBySessionsReport"}),

        TopDevicesByTrafficReport: QoETableClickstreamTopDevicesByTrafficWidget({id:this.Id + "TopDevicesByTrafficReport"}),

        TopDevicesByFlowReport: QoETableClickstreamTopDevicesByFlowWidget({id:this.Id + "TopDevicesByFlowReport"}),

        TopDevicesByRttReport: QoETableClickstreamTopDevicesByRttWidget({id:this.Id + "TopDevicesByRttReport"}),



        TopHostIpsPieReport: QoEPieChartClickstreamTopHostIpsWidget({id:this.Id + "TopHostIpsPieReport"}),

        TopHostIpsReport: QoETableClickstreamTopHostIpsWidget({id:this.Id + "TopHostIpsReport"}),

        TopHostIpsBySessionsReport: QoETableClickstreamTopHostIpsBySessionsWidget({id:this.Id + "TopHostIpsBySessionsReport"}),

        TopHostIpsByTrafficReport: QoETableClickstreamTopHostIpsByTrafficWidget({id:this.Id + "TopHostIpsByTrafficReport"}),

        TopHostIpsByFlowReport: QoETableClickstreamTopHostIpsByFlowWidget({id:this.Id + "TopHostIpsByFlowReport"}),

        TopHostIpsByRttReport: QoETableClickstreamTopHostIpsByRttWidget({id:this.Id + "TopHostIpsByRttReport"}),



        //TopUrlsPieReport: QoEPieChartClickstreamTopUrlsWidget({id:this.Id + "TopUrlsPieReport"}),

        TopUrlsReport: QoETableClickstreamTopUrlsWidget({id:this.Id + "TopUrlsReport"}),

        TopUrlsBySessionsReport: QoETableClickstreamTopUrlsBySessionsWidget({id:this.Id + "TopUrlsBySessionsReport"}),

        TopUrlsByTrafficReport: QoETableClickstreamTopUrlsByTrafficWidget({id:this.Id + "TopUrlsByTrafficReport"}),

        TopUrlsByFlowReport: QoETableClickstreamTopUrlsByFlowWidget({id:this.Id + "TopUrlsByFlowReport"}),

        TopUrlsByRttReport: QoETableClickstreamTopUrlsByRttWidget({id:this.Id + "TopUrlsByRttReport"}),



        TopHostCategoriesPieReport: QoEPieChartClickstreamTopHostCategoriesWidget({id:this.Id + "TopHostCategoriesPieReport"}),

        TopHostCategoriesReport: QoETableClickstreamTopHostCategoriesWidget({id:this.Id + "TopHostCategoriesReport"}),

        TopHostCategoriesBySessionsReport: QoETableClickstreamTopHostCategoriesBySessionsWidget({id:this.Id + "TopHostCategoriesBySessionsReport"}),

        TopHostCategoriesByTrafficReport: QoETableClickstreamTopHostCategoriesByTrafficWidget({id:this.Id + "TopHostCategoriesByTrafficReport"}),

        TopHostCategoriesByFlowReport: QoETableClickstreamTopHostCategoriesByFlowWidget({id:this.Id + "TopHostCategoriesByFlowReport"}),

        TopHostCategoriesByRttReport: QoETableClickstreamTopHostCategoriesByRttWidget({id:this.Id + "TopHostCategoriesByRttReport"}),



        TopAgentsReport: QoETableClickstreamTopAgentsWidget({id:this.Id + "TopAgentsReport"}),

        TopAgentsBySessionsReport: QoETableClickstreamTopAgentsBySessionsWidget({id:this.Id + "TopAgentsBySessionsReport"}),

        TopAgentsByTrafficReport: QoETableClickstreamTopAgentsByTrafficWidget({id:this.Id + "TopAgentsByTrafficReport"}),

        TopAgentsByFlowReport: QoETableClickstreamTopAgentsByFlowWidget({id:this.Id + "TopAgentsByFlowReport"}),

        TopAgentsByRttReport: QoETableClickstreamTopAgentsByRttWidget({id:this.Id + "TopAgentsByRttReport"}),



        TopVchannelsPieReport: QoEPieChartClickstreamTopVchannelsWidget({id:this.Id + "TopVchannelsPieReport"}),

        TopVchannelsReport: QoETableClickstreamTopVchannelsWidget({id:this.Id + "TopVchannelsReport"}),

        TopVchannelsBySessionsReport: QoETableClickstreamTopVchannelsBySessionsWidget({id:this.Id + "TopVchannelsBySessionsReport"}),

        TopVchannelsByTrafficReport: QoETableClickstreamTopVchannelsByTrafficWidget({id:this.Id + "TopVchannelsByTrafficReport"}),

        TopVchannelsByFlowReport: QoETableClickstreamTopVchannelsByFlowWidget({id:this.Id + "TopVchannelsByFlowReport"}),

        TopVchannelsByRttReport: QoETableClickstreamTopVchannelsByRttWidget({id:this.Id + "TopVchannelsByRttReport"}),


        TopLoginsPieReport: QoEPieChartClickstreamTopLoginsWidget({id:this.Id + "TopLoginsPieReport"}),

        TopLoginsReport: QoETableClickstreamTopLoginsWidget({id:this.Id + "TopLoginsReport"}),

        TopLoginsBySessionsReport: QoETableClickstreamTopLoginsBySessionsWidget({id:this.Id + "TopLoginsBySessionsReport"}),

        TopLoginsByTrafficReport: QoETableClickstreamTopLoginsByTrafficWidget({id:this.Id + "TopLoginsByTrafficReport"}),

        TopLoginsByFlowReport: QoETableClickstreamTopLoginsByFlowWidget({id:this.Id + "TopLoginsByFlowReport"}),

        TopLoginsByRttReport: QoETableClickstreamTopLoginsByRttWidget({id:this.Id + "TopLoginsByRttReport"}),


        TopInfectedSubscribersReport: QoETableClickstreamTopInfectedSubscribersWidget({id:this.Id + "TopInfectedSubscribersReport"}),

        TopInfectedSubscribersMaliciousTrafficReport: QoETableClickstreamTopInfectedSubscribersMaliciousTrafficWidget({id:this.Id + "TopInfectedSubscribersMaliciousTrafficReport"}),

        TopInfectedSubscribersBotnetTrafficReport: QoETableClickstreamTopInfectedSubscribersBotnetTrafficWidget({id:this.Id + "TopInfectedSubscribersBotnetTrafficReport"}),

        TopInfectedSubscribersPhishingTrafficReport: QoETableClickstreamTopInfectedSubscriberPhishingTrafficWidget({id:this.Id + "TopInfectedSubscribersPhishingTrafficReport"})
    };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Clickstream")}),
                                {
                                    view: "toolbar",
                                    elements: [
                                        // {
                                        //     view:"daterangepicker",
                                        //     id:this.Id + "PeriodPicker",
                                        //     name:"period",
                                        //     label:LangHelper.GetString("QoE", "Period"),
                                        //     value:{start: webix.Date.dayStart(new Date()), end: webix.Date.dayStart(new Date())},
                                        //     timepicker:true
                                        // },
                                        this.Views.Widgets.DateRangePicker.ViewConfig,
                                        {
                                            view:"multiselect",
                                            id:this.Id + "DpiPicker",
                                            value:"-2",
                                            maxWidth:320,
                                            optionWidth:320,
                                            tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                            options:[]
                                        },
                                        {
                                            view:"richselect",
                                            id:this.Id + "ExecTimeSelector",
                                            value:600,
                                            maxWidth:120,
                                            optionWidth:320,
                                            tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                            options:[
                                                {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                            ]
                                        },
                                        this.Views.Widgets.ExtendedFillter.ViewConfig,
                                        {},
                                        {
                                            view: "button",
                                            id:this.Id+"RefreshAllDataBtn",
                                            type: "icon",
                                            icon: "refresh",
                                            css: "toolbar_round_btn",
                                            width: 32,
                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                            click: function (id, e, node)
                                            {
                                                _this.RefreshAllData(true);
                                            }
                                        },
                                        this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                        {
                                            width: 16
                                        },
                                        QoEKillProcessesBtnWidget({
                                            id:this.Id+"KillProcessesBtn",
                                            callback:function (Id)
                                            {
                                                _this.KillProcesses(Id);
                                            }
                                        }),
                                        QoEClearCacheBtnWidget({
                                            id:this.Id+"ClearCacheBtn",
                                            callback:function (Id)
                                            {
                                                _this.ClearCache(Id);
                                            }
                                        })
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            rows:[
                                                {
                                                    view:"multiview",
                                                    id:this.Id + "ReportsCells",
                                                    cells:[
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopHostsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsBySessionsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsBySessionsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsByTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsByTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsByFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsByFlowReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsByRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsByRttReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscribersPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersBySessionsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersBySessionsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersByTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersByTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersByFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersByFlowReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersByRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersByRttReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopDevicesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopDevicesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopDevicesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopDevicesBySessionsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopDevicesBySessionsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopDevicesByTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopDevicesByTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopDevicesByFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopDevicesByFlowReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopDevicesByRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopDevicesByRttReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostIpsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostIpsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopHostIpsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostIpsBySessionsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostIpsBySessionsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostIpsByTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostIpsByTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostIpsByFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostIpsByFlowReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostIpsByRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostIpsByRttReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopUrlsReport",
                                                            rows:
                                                            [
                                                                this.Views.Widgets.TopUrlsReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopUrlsBySessionsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopUrlsBySessionsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopUrlsByTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopUrlsByTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopUrlsByFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopUrlsByFlowReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopUrlsByRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopUrlsByRttReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostCategoriesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopHostCategoriesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesBySessionsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostCategoriesBySessionsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesByTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostCategoriesByTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesByFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostCategoriesByFlowReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesByRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostCategoriesByRttReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAgentsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopAgentsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAgentsBySessionsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopAgentsBySessionsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAgentsByTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopAgentsByTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAgentsByFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopAgentsByFlowReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAgentsByRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopAgentsByRttReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopVchannelsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsBySessionsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsBySessionsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsByTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsByTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsByFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsByFlowReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsByRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsByRttReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopLoginsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopLoginsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopLoginsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopLoginsBySessionsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopLoginsBySessionsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopLoginsByTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopLoginsByTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopLoginsByFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopLoginsByFlowReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopLoginsByRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopLoginsByRttReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersCellsReport",
                                                            cols: [
                                                                {
                                                                    gravity: 2,
                                                                    rows: [
                                                                        this.Views.Widgets.TopInfectedSubscribersReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersMaliciousTrafficCellsReport",
                                                            cols: [
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopInfectedSubscribersMaliciousTrafficReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersBotnetTrafficCellsReport",
                                                            cols: [
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopInfectedSubscribersBotnetTrafficReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersPhishingTrafficCellsReport",
                                                            cols: [
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopInfectedSubscribersPhishingTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {view: "resizer"},
                                        {
                                            width: 240,
                                            rows: [
                                                BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                {
                                                    view: "treetable",
                                                    id:this.Id + "ReportsList",
                                                    header:false,
                                                    select: "row",
                                                    on: {
                                                        onAfterSelect:function ()
                                                        {
                                                            _this.OnReportsListSelect();
                                                        },
                                                        onAfterUnSelect:function ()
                                                        {
                                                            _this.OnReportsListUnSelect();
                                                        }
                                                    },
                                                    columns: [
                                                        {
                                                            id: "value",
                                                            fillspace: true,
                                                            template: function(obj, common, value, config)
                                                            {
                                                                return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                            }
                                                        }
                                                    ],
                                                    data: [
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top hosts"),
                                                            data:function (){

                                                                var arr = [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostsReport",
                                                                        value:LangHelper.GetString("QoE", "By default")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostsBySessionsReport",
                                                                        value:LangHelper.GetString("QoE", "By sessions")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostsByTrafficReport",
                                                                        value:LangHelper.GetString("QoE", "By traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostsByFlowReport",
                                                                        value:LangHelper.GetString("QoE", "By flow")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostsByRttReport",
                                                                        value:LangHelper.GetString("QoE", "By RTT")
                                                                    }
                                                                ];

                                                                if(AppEnv.ClickstreamTopReportWithFullflow_isHidden === 1)
                                                                {
                                                                    arr = [
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopHostsReport",
                                                                            value:LangHelper.GetString("QoE", "By default")
                                                                        }
                                                                    ];
                                                                }

                                                                return arr;

                                                            }()
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top subscribers"),
                                                            data:function (){
                                                                var arr = [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopSubscribersReport",
                                                                        value:LangHelper.GetString("QoE", "By default")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopSubscribersBySessionsReport",
                                                                        value:LangHelper.GetString("QoE", "By sessions")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopSubscribersByTrafficReport",
                                                                        value:LangHelper.GetString("QoE", "By traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopSubscribersByFlowReport",
                                                                        value:LangHelper.GetString("QoE", "By flow")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopSubscribersByRttReport",
                                                                        value:LangHelper.GetString("QoE", "By RTT")
                                                                    }
                                                                ];

                                                                if(AppEnv.ClickstreamTopReportWithFullflow_isHidden === 1)
                                                                {
                                                                    arr = [
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopSubscribersReport",
                                                                            value:LangHelper.GetString("QoE", "By default")
                                                                        }
                                                                    ];
                                                                }

                                                                return arr;

                                                            }()
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopDevicesReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top devices"),
                                                            data:function (){
                                                                var arr =  [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopDevicesReport",
                                                                        value:LangHelper.GetString("QoE", "By default")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopDevicesBySessionsReport",
                                                                        value:LangHelper.GetString("QoE", "By sessions")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopDevicesByTrafficReport",
                                                                        value:LangHelper.GetString("QoE", "By traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopDevicesByFlowReport",
                                                                        value:LangHelper.GetString("QoE", "By flow")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopDevicesByRttReport",
                                                                        value:LangHelper.GetString("QoE", "By RTT")
                                                                    }
                                                                ];

                                                                if(AppEnv.ClickstreamTopReportWithFullflow_isHidden === 1)
                                                                {
                                                                    arr =  [
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopDevicesReport",
                                                                            value:LangHelper.GetString("QoE", "By default")
                                                                        }
                                                                    ];
                                                                }

                                                                return arr;
                                                            }()
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostIpsReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top hosts IPs"),
                                                            data:function (){
                                                                var arr =  [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostIpsReport",
                                                                        value:LangHelper.GetString("QoE", "By default")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostIpsBySessionsReport",
                                                                        value:LangHelper.GetString("QoE", "By sessions")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostIpsByTrafficReport",
                                                                        value:LangHelper.GetString("QoE", "By traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostIpsByFlowReport",
                                                                        value:LangHelper.GetString("QoE", "By flow")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostIpsByRttReport",
                                                                        value:LangHelper.GetString("QoE", "By RTT")
                                                                    }
                                                                ];

                                                                if(AppEnv.ClickstreamTopReportWithFullflow_isHidden === 1)
                                                                {
                                                                    arr =  [
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopHostIpsReport",
                                                                            value:LangHelper.GetString("QoE", "By default")
                                                                        }
                                                                    ];
                                                                }

                                                                return arr;
                                                            }()
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopUrlsReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top URLs"),
                                                            data:function (){
                                                                var arr = [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopUrlsReport",
                                                                        value:LangHelper.GetString("QoE", "By default")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopUrlsBySessionsReport",
                                                                        value:LangHelper.GetString("QoE", "By sessions")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopUrlsByTrafficReport",
                                                                        value:LangHelper.GetString("QoE", "By traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopUrlsByFlowReport",
                                                                        value:LangHelper.GetString("QoE", "By flow")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopUrlsByRttReport",
                                                                        value:LangHelper.GetString("QoE", "By RTT")
                                                                    }
                                                                ];

                                                                if(AppEnv.ClickstreamTopReportWithFullflow_isHidden === 1)
                                                                {
                                                                    arr = [
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopUrlsReport",
                                                                            value:LangHelper.GetString("QoE", "By default")
                                                                        }
                                                                    ];
                                                                }

                                                                return arr;
                                                            }()
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top host categories"),
                                                            data:function (){
                                                                var arr =  [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostCategoriesReport",
                                                                        value:LangHelper.GetString("QoE", "By default")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostCategoriesBySessionsReport",
                                                                        value:LangHelper.GetString("QoE", "By sessions")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostCategoriesByTrafficReport",
                                                                        value:LangHelper.GetString("QoE", "By traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostCategoriesByFlowReport",
                                                                        value:LangHelper.GetString("QoE", "By flow")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopHostCategoriesByRttReport",
                                                                        value:LangHelper.GetString("QoE", "By RTT")
                                                                    }
                                                                ];

                                                                if(AppEnv.ClickstreamTopReportWithFullflow_isHidden === 1)
                                                                {
                                                                    arr =  [
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopHostCategoriesReport",
                                                                            value:LangHelper.GetString("QoE", "By default")
                                                                        }
                                                                    ];
                                                                }

                                                                return arr;
                                                            }()
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAgentsReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top user agents"),
                                                            data:function (){

                                                                var arr = [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopAgentsReport",
                                                                        value:LangHelper.GetString("QoE", "By default")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopAgentsBySessionsReport",
                                                                        value:LangHelper.GetString("QoE", "By sessions")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopAgentsByTrafficReport",
                                                                        value:LangHelper.GetString("QoE", "By traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopAgentsByFlowReport",
                                                                        value:LangHelper.GetString("QoE", "By flow")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopAgentsByRttReport",
                                                                        value:LangHelper.GetString("QoE", "By RTT")
                                                                    }
                                                                ];

                                                                if(AppEnv.ClickstreamTopReportWithFullflow_isHidden === 1)
                                                                {
                                                                    arr = [
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopAgentsReport",
                                                                            value:LangHelper.GetString("QoE", "By default")
                                                                        }
                                                                    ];
                                                                }

                                                                return arr;
                                                            }()
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top vchannels"),
                                                            data:function (){
                                                                var arr = [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopVchannelsReport",
                                                                        value:LangHelper.GetString("QoE", "By default")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopVchannelsBySessionsReport",
                                                                        value:LangHelper.GetString("QoE", "By sessions")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopVchannelsByTrafficReport",
                                                                        value:LangHelper.GetString("QoE", "By traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopVchannelsByFlowReport",
                                                                        value:LangHelper.GetString("QoE", "By flow")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopVchannelsByRttReport",
                                                                        value:LangHelper.GetString("QoE", "By RTT")
                                                                    }
                                                                ];

                                                                if(AppEnv.ClickstreamTopReportWithFullflow_isHidden === 1)
                                                                {
                                                                    arr = [
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopVchannelsReport",
                                                                            value:LangHelper.GetString("QoE", "By default")
                                                                        }
                                                                    ];
                                                                }

                                                                return arr;
                                                            }()
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopLoginsReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top logins"),
                                                            data:function (){
                                                                var arr = [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopLoginsReport",
                                                                        value:LangHelper.GetString("QoE", "By default")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopLoginsBySessionsReport",
                                                                        value:LangHelper.GetString("QoE", "By sessions")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopLoginsByTrafficReport",
                                                                        value:LangHelper.GetString("QoE", "By traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopLoginsByFlowReport",
                                                                        value:LangHelper.GetString("QoE", "By flow")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopLoginsByRttReport",
                                                                        value:LangHelper.GetString("QoE", "By RTT")
                                                                    }
                                                                ];

                                                                if(AppEnv.ClickstreamTopReportWithFullflow_isHidden === 1)
                                                                {
                                                                    arr = [
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopLoginsReport",
                                                                            value:LangHelper.GetString("QoE", "By default")
                                                                        }
                                                                    ];
                                                                }

                                                                return arr;
                                                            }()
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersCellsReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top infected subscribers"),
                                                            data:function (){
                                                                var arr =  [
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopInfectedSubscribersCellsReport",
                                                                        value:LangHelper.GetString("QoE", "Top infected subscribers")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopInfectedSubscribersMaliciousTrafficCellsReport",
                                                                        value:LangHelper.GetString("QoE", "Top infected subscribers with malicious traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopInfectedSubscribersBotnetTrafficCellsReport",
                                                                        value:LangHelper.GetString("QoE", "Top infected subscribers with botnet traffic")
                                                                    },
                                                                    {
                                                                        id: _this.Id + "ReportsCells" + "TopInfectedSubscribersPhishingTrafficCellsReport",
                                                                        value:LangHelper.GetString("QoE", "Top infected subscribers with phishing traffic")
                                                                    }
                                                                ];

                                                                return arr;
                                                            }()
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsReport"] = [this.Views.Widgets.TopHostsReport, this.Views.Widgets.TopHostsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsBySessionsReport"] = [this.Views.Widgets.TopHostsBySessionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsByTrafficReport"] = [this.Views.Widgets.TopHostsByTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsByFlowReport"] = [this.Views.Widgets.TopHostsByFlowReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsByRttReport"] = [this.Views.Widgets.TopHostsByRttReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersReport"] = [this.Views.Widgets.TopSubscribersReport, this.Views.Widgets.TopSubscribersPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersBySessionsReport"] = [this.Views.Widgets.TopSubscribersBySessionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersByTrafficReport"] = [this.Views.Widgets.TopSubscribersByTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersByFlowReport"] = [this.Views.Widgets.TopSubscribersByFlowReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersByRttReport"] = [this.Views.Widgets.TopSubscribersByRttReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopDevicesReport"] = [this.Views.Widgets.TopDevicesReport, this.Views.Widgets.TopDevicesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopDevicesBySessionsReport"] = [this.Views.Widgets.TopDevicesBySessionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopDevicesByTrafficReport"] = [this.Views.Widgets.TopDevicesByTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopDevicesByFlowReport"] = [this.Views.Widgets.TopDevicesByFlowReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopDevicesByRttReport"] = [this.Views.Widgets.TopDevicesByRttReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostIpsReport"] = [this.Views.Widgets.TopHostIpsReport, this.Views.Widgets.TopHostIpsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostIpsBySessionsReport"] = [this.Views.Widgets.TopHostIpsBySessionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostIpsByTrafficReport"] = [this.Views.Widgets.TopHostIpsByTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostIpsByFlowReport"] = [this.Views.Widgets.TopHostIpsByFlowReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostIpsByRttReport"] = [this.Views.Widgets.TopHostIpsByRttReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopUrlsReport"] = [this.Views.Widgets.TopUrlsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopUrlsBySessionsReport"] = [this.Views.Widgets.TopUrlsBySessionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopUrlsByTrafficReport"] = [this.Views.Widgets.TopUrlsByTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopUrlsByFlowReport"] = [this.Views.Widgets.TopUrlsByFlowReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopUrlsByRttReport"] = [this.Views.Widgets.TopUrlsByRttReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostCategoriesReport"] = [this.Views.Widgets.TopHostCategoriesReport, this.Views.Widgets.TopHostCategoriesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostCategoriesBySessionsReport"] = [this.Views.Widgets.TopHostCategoriesBySessionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostCategoriesByTrafficReport"] = [this.Views.Widgets.TopHostCategoriesByTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostCategoriesByFlowReport"] = [this.Views.Widgets.TopHostCategoriesByFlowReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostCategoriesByRttReport"] = [this.Views.Widgets.TopHostCategoriesByRttReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAgentsReport"] = [this.Views.Widgets.TopAgentsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAgentsBySessionsReport"] = [this.Views.Widgets.TopAgentsBySessionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAgentsByTrafficReport"] = [this.Views.Widgets.TopAgentsByTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAgentsByFlowReport"] = [this.Views.Widgets.TopAgentsByFlowReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAgentsByRttReport"] = [this.Views.Widgets.TopAgentsByRttReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsReport"] = [this.Views.Widgets.TopVchannelsReport, this.Views.Widgets.TopVchannelsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsBySessionsReport"] = [this.Views.Widgets.TopVchannelsBySessionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsByTrafficReport"] = [this.Views.Widgets.TopVchannelsByTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsByFlowReport"] = [this.Views.Widgets.TopVchannelsByFlowReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsByRttReport"] = [this.Views.Widgets.TopVchannelsByRttReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopLoginsReport"] = [this.Views.Widgets.TopLoginsReport, this.Views.Widgets.TopLoginsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopLoginsBySessionsReport"] = [this.Views.Widgets.TopLoginsBySessionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopLoginsByTrafficReport"] = [this.Views.Widgets.TopLoginsByTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopLoginsByFlowReport"] = [this.Views.Widgets.TopLoginsByFlowReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopLoginsByRttReport"] = [this.Views.Widgets.TopLoginsByRttReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopInfectedSubscribersCellsReport"] = [this.Views.Widgets.TopInfectedSubscribersReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopInfectedSubscribersMaliciousTrafficCellsReport"] = [this.Views.Widgets.TopInfectedSubscribersMaliciousTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopInfectedSubscribersBotnetTrafficCellsReport"] = [this.Views.Widgets.TopInfectedSubscribersBotnetTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopInfectedSubscribersPhishingTrafficCellsReport"] = [this.Views.Widgets.TopInfectedSubscribersPhishingTrafficReport];
};

QoEClickStreamViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEClickStream");
    });

    this.BindAll(PathParams);

    App.DicsManager.Refresh({data:[DicsEnum.HostCategoriesDic]});

    this.CheckQoEStorVersionCompatibility();
};

QoEClickStreamViewController.prototype.BindAll = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    //this.Views.PeriodPicker = $$(this.Id + "PeriodPicker");

    // var date_from = Helper.RoundDateToMinutes(new Date());
    // var date_to = Helper.RoundDateToMinutes(new Date());
    // this.Views.PeriodPicker.setValue({start:webix.Date.add(date_from,-6,"hour"), end:webix.Date.add(date_to,1,"hour")});

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();

            //_this.Views.ReportsList.select(_this.Views.ReportsList.getFirstId());
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w && w.Bind)
            _this.Views.Widgets[Key].Bind(_this);
    });

    this.GetAllPathParam();

    // this.Views.PeriodPicker.attachEvent("onChange", function(Period)
    // {
    //     _this.RefreshAllData();
    // });

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
            _this.RefreshAllData();
    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();
                 _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoEClickStreamViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    //var period = this.Views.PeriodPicker.getValue();

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    filter = webix.extend(filter, extendedFilters, true);

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoEClickStreamViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEClickStreamViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoEClickStreamViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEClickStreamViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEClickStreamViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
    [
        {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
        {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
    ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoEClickStreamViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoEClickStreamViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoEClickStreamViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoEClickStreamViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoEClickStreamViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEClickStreamViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEClickStreamViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoEClickStreamViewController.prototype.GetAllPathParam = function()
{
    try
    {
        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoEClickStreamViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEClickStreamViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoEClickStreamViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};
function QoEFullNetFlowViewController(Params)
{
    var _this = this;

    this.Id = "QoEFullNetFlow";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"});

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,

        DpiPicker:null,

        ExecTimeSelector:null
    };

    this.Views.Widgets =
    {
        DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"}),

        ExtendedFillter: new QoEPopupFilterWidget({
            id:this.Id + "ExtendedFillter",
            config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow),
            enable_show_hotkey: 1
        }),

        UserReportsFormWidget: function() {
            if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
        }(),

        RttByTime: QoERttByTimeWidget({id:this.Id + "RttByTime"}),

        RttDistribution: QoERttDistributionWidget({id:this.Id + "RttDistribution"}),

        TopSubscribersRttPieReport: QoEPieChartTopRttSubscribersWidget({id:this.Id + "TopSubscribersRttPieReport"}),

        RetransmitsByTime: QoESeriesChartRetransmitsByTimeWidget({id:this.Id + "RetransmitsByTime"}),

        TopSubscribersRttShortReport: QoETableTopRttSubscribersShortWidget({id:this.Id + "TopSubscribersRttShortReport"}),

        TopSubscribersRttReport: QoETableTopRttSubscribersWidget({id:this.Id + "TopSubscribersRttReport"}),

        TopSubscriberLoginsRttShortReport: QoETableTopRttSubscriberLoginsShortWidget({id:this.Id + "TopSubscriberLoginsRttShortReport"}),

        TopSubscriberLoginsRttReport: QoETableTopRttSubscriberLoginsWidget({id:this.Id + "TopSubscriberLoginsRttReport"}),

        TopSubscriberLoginsRttPieReport: QoEPieChartTopRttSubscriberLoginsWidget({id:this.Id + "TopSubscriberLoginsRttPieReport"}),

        Traffic: QoESeriesChartTrafficWidget({id:this.Id + "Traffic"}),

        TotalTraffic: QoESingleStatTotalsVertWidget({id:this.Id + "TotalTraffic", compact:true}),

        TrafficByProtocols: QoETableNetflowTopTrafficNetProtocolsTableChartWidget({id:this.Id + "TrafficByProtocols"}),

        TrafficByAppProtocols: QoETableNetflowTopTrafficProtocolsTableChartWidget({id:this.Id + "TrafficByAppProtocols"}),

        TrafficByAppProtocolsGrps: QoETableNetflowTopTrafficProtocolsGroupsTableChartWidget({id:this.Id + "TrafficByAppProtocolsGroups"}),

        TrafficByAS: QoETableNetflowTopTrafficASTableChartWidget({id:this.Id + "TrafficByAS"}),

        TrafficBySubscribersAS: QoETableNetflowTopTrafficSubscribersASTableChartWidget({id:this.Id + "TrafficBySubscribersAS"}),

        Flow: QoESeriesChartFlowWidget({id:this.Id + "Flow"}),

        FlowByProtocols: QoESeriesChartFlowByNetProtocolsTableChartWidget({id:this.Id + "FlowByProtocols"}),

        FlowByAppProtocols: QoESeriesChartFlowByProtocolsTableChartWidget({id:this.Id + "FlowByAppProtocols"}),

        FlowByAppProtocolsGrps: QoESeriesChartFlowByProtocolsGroupsTableChartWidget({id:this.Id + "FlowByAppProtocolsGroups"}),

        TopProtocolsPieReport: QoEPieChartNetflowTopProtocolsWidget({id:this.Id + "TopProtocolsPieReport"}),

        TopProtocolsGrpsPieReport: QoEPieChartNetflowTopProtocolsGroupsWidget({id:this.Id + "TopProtocolsGroupsPieReport"}),

        TopTrafficProtocolsPieReport: QoEPieChartNetflowTopTrafficProtocolsWidget({id:this.Id + "TopTrafficProtocolsPieReport"}),

        TopTrafficProtocolsBySubscribersPieReport: QoEPieChartNetflowTopTrafficProtocolsBySubscribersWidget({id:this.Id + "TopTrafficProtocolsBySubscribersPieReport"}),

        TopTrafficProtocolsGrpsPieReport: QoEPieChartNetflowTopTrafficProtocolsGroupsWidget({id:this.Id + "TopTrafficProtocolsGroupsPieReport"}),

        TopTrafficProtocolsGrpsBySubscribersPieReport: QoEPieChartNetflowTopTrafficProtocolsGroupsBySubscribersWidget({id:this.Id + "QoEPieChartNetflowTopTrafficProtocolsGroupsBySubscribersWidget"}),

        TopProtocolsShortReport: QoETableNetflowTopProtocolsShortWidget({id:this.Id + "TopProtocolsShortReport"}),

        TopProtocolsPercentShortReport: QoETableNetflowTopProtocolsPercentShortWidget({id:this.Id + "TopProtocolsPercentShortReport"}),

        TopProtocolsGrpsShortReport: QoETableNetflowTopProtocolsGroupsShortWidget({id:this.Id + "TopProtocolsGroupsShortReport"}),

        TopProtocolsGrpsPercentShortReport: QoETableNetflowTopProtocolsGroupsPercentShortWidget({id:this.Id + "TopProtocolsGroupsPercentShortReport"}),

        TopProtocolsReport: QoETableNetflowTopProtocolsWidget({id:this.Id + "TopProtocolsReport"}),

        TopProtocolsGrpsReport: QoETableNetflowTopProtocolsGroupsWidget({id:this.Id + "TopProtocolsGroupsReport"}),

        TopTrafficProtocolsShortReport: QoETableNetflowTopTrafficProtocolsShortWidget({id:this.Id + "TopTrafficProtocolsShortReport"}),

        TopTrafficProtocolsReport: QoETableNetflowTopTrafficProtocolsWidget({id:this.Id + "TopTrafficProtocolsReport"}),

        TopTrafficProtocolsPercentSpeedShortReport: QoETableNetflowTopTrafficProtocolsPercentSpeedShortWidget({id:this.Id + "TopTrafficProtocolsPercentSpeedShortReport"}),

        TopTrafficProtocolsPercentVolumeShortReport: QoETableNetflowTopTrafficProtocolsPercentVolumeShortWidget({id:this.Id + "TopTrafficProtocolsPercentVolumeShortReport"}),

        TopTrafficProtocolsBySubscribersReport: QoETableNetflowTopTrafficProtocolsBySubscribersWidget({id:this.Id + "TopTrafficProtocolsBySubscribersReport"}),

        TopTrafficProtocolsGrpsShortReport: QoETableNetflowTopTrafficProtocolsGroupsShortWidget({id:this.Id + "TopTrafficProtocolsGroupsShortReport"}),

        TopTrafficProtocolsGrpsPercentSpeedShortReport: QoETableNetflowTopTrafficProtocolsGroupsPercentSpeedShortWidget({id:this.Id + "TopTrafficProtocolsGroupsPercentSpeedShortReport"}),

        TopTrafficProtocolsGrpsPercentVolumeShortReport: QoETableNetflowTopTrafficProtocolsGroupsPercentVolumeShortWidget({id:this.Id + "TopTrafficProtocolsGroupsPercentVolumeShortReport"}),

        TopTrafficProtocolsGrpsReport: QoETableNetflowTopTrafficProtocolsGroupsWidget({id:this.Id + "TopTrafficProtocolsGroupsReport"}),

        TopTrafficProtocolsGrpsBySubscribersReport: QoETableNetflowTopTrafficProtocolsGroupsBySubscribersWidget({id:this.Id + "TopTrafficProtocolsGroupsBySubscribersReport"}),

        SshBruteForceReport: QoETableFullnetflowRawSshBruteForceWidget({id: this.Id + "QoETableFullnetflowRawSshBruteForceWidget"}),

        TopHostsPieReport: QoEPieChartNetflowTopHostsWidget({id:this.Id + "TopHostsPieReport"}),

        TopHostsShortReport: QoETableNetflowTopHostsShortWidget({id:this.Id + "TopHostsShortReport"}),

        TopHostsReport: QoETableNetflowTopHostsWidget({id:this.Id + "TopHostsReport"}),

        TopTrafficHostsPieReport: QoEPieChartNetflowTopTrafficHostsWidget({id:this.Id + "TopTrafficHostsPieReport"}),

        TopTrafficHostsShortReport: QoETableNetflowTopTrafficHostsShortWidget({id:this.Id + "TopTrafficHostsShortReport"}),

        TopTrafficHostsReport: QoETableNetflowTopTrafficHostsWidget({id:this.Id + "TopTrafficHostsReport"}),

        TopTrafficHostsPercentSpeedShortReport: QoETableNetflowTopTrafficHostsPercentSpeedShortWidget({id:this.Id + "TopTrafficHostsPercentSpeedShortReport"}),

        TopTrafficHostsPercentVolumeShortReport: QoETableNetflowTopTrafficHostsPercentVolumeShortWidget({id:this.Id + "TopTrafficHostsPercentVolumeShortReport"}),

        TopHostsIPsPieReport: QoEPieChartNetflowTopHostsIPsWidget({id:this.Id + "TopHostsIPsPieReport"}),

        TopHostsIPsShortReport: QoETableNetflowTopHostsIPsShortWidget({id:this.Id + "TopHostsIPsShortReport"}),

        TopHostsIPsReport: QoETableNetflowTopHostsIPsWidget({id:this.Id + "TopHostsIPsReport"}),

        TopTrafficHostsIPsPieReport: QoEPieChartNetflowTopTrafficHostsIPsWidget({id:this.Id + "TopTrafficHostsIPsPieReport"}),

        TopTrafficHostsIPsShortReport: QoETableNetflowTopTrafficHostsIPsShortWidget({id:this.Id + "TopTrafficHostsIPsShortReport"}),

        TopTrafficHostsIPsReport: QoETableNetflowTopTrafficHostsIPsWidget({id:this.Id + "TopTrafficHostsIPsReport"}),

        TopHostCategoriesPieReport: QoEPieChartNetflowTopHostCategoriesWidget({id:this.Id + "TopHostCategoriesPieReport"}),

        TopHostCategoriesShortReport: QoETableNetflowTopHostCategoriesShortWidget({id:this.Id + "TopHostCategoriesShortReport"}),

        TopHostCategoriesReport: QoETableNetflowTopHostCategoriesWidget({id:this.Id + "TopHostCategoriesReport"}),

        TopTrafficHostCategoriesPieReport: QoEPieChartNetflowTopTrafficHostCategoriesWidget({id:this.Id + "TopTrafficHostCategoriesPieReport"}),

        TopTrafficHostCategoriesShortReport: QoETableNetflowTopTrafficHostCategoriesShortWidget({id:this.Id + "TopTrafficHostCategoriesShortReport"}),

        TopTrafficHostCategoriesReport: QoETableNetflowTopTrafficHostCategoriesWidget({id:this.Id + "TopTrafficHostCategoriesReport"}),

        TopASsPieReport: QoEPieChartNetflowTopASsWidget({id:this.Id + "TopASsPieReport", type:"destination"}),

        TopASsReport: QoETableNetflowTopASsWidget({id:this.Id + "TopASsReport", type:"destination"}),

        TopASsShortReport: QoETableNetflowTopASsShortWidget({id:this.Id + "TopASsShortReport", type:"destination"}),

        TopTrafficASsPieReport: QoEPieChartNetflowTopTrafficASsWidget({id:this.Id + "TopTrafficASsPieReport", type:"destination"}),

        TopTrafficASsReport: QoETableNetflowTopTrafficASsWidget({id:this.Id + "TopTrafficASsReport", type:"destination"}),

        TopTrafficASsShortReport: QoETableNetflowTopTrafficASsShortWidget({id:this.Id + "TopTrafficASsShortReport", type:"destination"}),

        TopSubscriberASsPieReport: QoEPieChartNetflowTopASsWidget({id:this.Id + "TopSubscriberASsPieReport", type:"source"}),

        TopSubscriberASsReport: QoETableNetflowTopASsWidget({id:this.Id + "TopSubscriberASsReport", type:"source"}),

        TopSubscriberASsShortReport: QoETableNetflowTopASsShortWidget({id:this.Id + "TopSubscriberASsShortReport", type:"source"}),

        TopTrafficSubscriberASsPieReport: QoEPieChartNetflowTopTrafficASsWidget({id:this.Id + "TopTrafficSubscriberASsPieReport", type:"source"}),

        TopTrafficSubscriberASsReport: QoETableNetflowTopTrafficASsWidget({id:this.Id + "TopTrafficSubscriberASsReport", type:"source"}),

        TopTrafficSubscriberASsShortReport: QoETableNetflowTopTrafficASsShortWidget({id:this.Id + "TopTrafficSubscriberASsShortReport", type:"source"}),

        TopSwitchesPieReport: QoEPieChartNetflowTopSwitchesWidget({id:this.Id + "TopSwitchesPieReport"}),

        TopSwitchesShortReport: QoETableNetflowTopSwitchesShortWidget({id:this.Id + "TopSwitchesShortReport"}),

        TopSwitchesReport: QoETableNetflowTopSwitchesWidget({id:this.Id + "TopSwitchesReport"}),

        TopTrunkSwitchesPieReport: QoEPieChartNetflowTopSwitchesWidget({id:this.Id + "TopTrunkSwitchesPieReport", type:2}),

        TopTrunkSwitchesShortReport: QoETableNetflowTopSwitchesShortWidget({id:this.Id + "TopTrunkSwitchesShortReport", type:2}),

        TopTrunkSwitchesReport: QoETableNetflowTopSwitchesWidget({id:this.Id + "TopTrunkSwitchesReport", type:2}),

        TopTrafficSwitchesPieReport: QoEPieChartNetflowTopTrafficSwitchesWidget({id:this.Id + "TopTrafficSwitchesPieReport"}),

        TopTrafficSwitchesShortReport: QoETableNetflowTopTrafficSwitchesShortWidget({id:this.Id + "TopTrafficSwitchesShortReport"}),

        TopTrafficSwitchesReport: QoETableNetflowTopTrafficSwitchesWidget({id:this.Id + "TopTrafficSwitchesReport"}),

        TopTrafficTrunkSwitchesPieReport: QoEPieChartNetflowTopTrafficSwitchesWidget({id:this.Id + "TopTrafficTrunkSwitchesPieReport", type:2}),

        TopTrafficTrunkSwitchesShortReport: QoETableNetflowTopTrafficSwitchesShortWidget({id:this.Id + "TopTrafficTrunkSwitchesShortReport", type:2}),

        TopTrafficTrunkSwitchesReport: QoETableNetflowTopTrafficSwitchesWidget({id:this.Id + "TopTrafficTrunkSwitchesReport", type:2}),

        TopSubscribersTrafficPieReport: QoEPieChartTopTrafficSubscribersWidget({id:this.Id + "TopSubscribersTrafficPieReport"}),

        TopSubscribersTrafficShortReport: QoETableTopTrafficSubscribersShortWidget({id:this.Id + "TopSubscribersTrafficShortReport"}),

        TopSubscribersTrafficReport: QoETableTopTrafficSubscribersWidget({id:this.Id + "TopSubscribersTrafficReport"}),

        TopSubscriberLoginsTrafficPieReport: QoEPieChartTopTrafficSubscriberLoginsWidget({id:this.Id + "TopSubscriberLoginsTrafficPieReport"}),

        TopSubscriberLoginsTrafficShortReport: QoETableTopTrafficSubscriberLoginsShortWidget({id:this.Id + "TopSubscriberLoginsTrafficShortReport"}),

        TopSubscriberLoginsTrafficReport: QoETableTopTrafficSubscriberLoginsWidget({id:this.Id + "TopSubscriberLoginsTrafficReport"}),

        TopSubscribersRetransmitsReport: QoETableTopRetransmitsSubscribersWidget({id:this.Id + "TopSubscribersRetransmitsReport"}),

        TopSubscribersRetransmitsPieReport: QoEPieChartTopRetransmitsSubscribersWidget({id:this.Id + "TopSubscribersRetransmitsPieReport"}),

        TopSubscribersRetransmitsShortReport: QoETableTopRetransmitsSubscribersShortWidget({id:this.Id + "TopSubscribersRetransmitsShortReport"}),

        TopSubscriberLoginsRetransmitsReport: QoETableTopRetransmitsSubscriberLoginsWidget({id:this.Id + "TopSubscriberLoginsRetransmitsReport"}),

        TopSubscriberLoginsRetransmitsPieReport: QoEPieChartTopRetransmitsSubscriberLoginsWidget({id:this.Id + "TopSubscriberLoginsRetransmitsPieReport"}),

        TopSubscriberLoginsRetransmitsShortReport: QoETableTopRetransmitsSubscriberLoginsShortWidget({id:this.Id + "TopSubscriberLoginsRetransmitsShortReport"}),

        TopRetransmitsProtocolsReport: QoETableNetflowTopRetransmitsProtocolsWidget({id:this.Id + "TopRetransmitsProtocolsReport"}),

        TopRetransmitsProtocolsShortReport: QoETableNetflowTopRetransmitsProtocolsShortWidget({id:this.Id + "TopRetransmitsProtocolsShortReport"}),

        TopRetransmitsProtocolsPercentShortReport: QoETableNetflowTopRetransmitsProtocolsPercentShortWidget({id:this.Id + "TopRetransmitsProtocolsPercentShortReport"}),

        TopProtocolsRetransmitsPieReport: QoEPieChartNetflowTopRetransmitsProtocolsWidget({id:this.Id + "TopProtocolsRetransmitsPieReport"}),

        TopRetransmitsProtocolsGrpsReport: QoETableNetflowTopRetransmitsProtocolsGroupsWidget({id:this.Id + "TopRetransmitsProtocolsGroupsReport"}),

        TopRetransmitsProtocolsGrpsShortReport: QoETableNetflowTopRetransmitsProtocolsGroupsShortWidget({id:this.Id + "TopRetransmitsProtocolsGroupsShortReport"}),

        TopRetransmitsProtocolsGrpsPercentShortReport: QoETableNetflowTopRetransmitsProtocolsGroupsPercentShortWidget({id:this.Id + "TopRetransmitsProtocolsGroupsPercentShortReport"}),

        TopProtocolsGrpsRetransmitsPieReport: QoEPieChartNetflowTopRetransmitsProtocolsGroupsWidget({id:this.Id + "TopProtocolsRetransmitsGroupsPieReport"}),

        TopRetransmitsHostsPieReport: QoEPieChartNetflowTopRetransmitsHostsWidget({id:this.Id + "TopRetransmitsHostsPieReport"}),

        TopRetransmitsHostsShortReport: QoETableNetflowTopRetransmitsHostsShortWidget({id:this.Id + "TopRetransmitsHostsShortReport"}),

        TopRetransmitsHostsReport: QoETableNetflowTopRetransmitsHostsWidget({id:this.Id + "TopRetransmitsHostsReport"}),

        TopRetransmitsHostsIPsPieReport: QoEPieChartNetflowTopRetransmitsHostsIPsWidget({id:this.Id + "TopRetransmitsHostsIPsPieReport"}),

        TopRetransmitsHostsIPsShortReport: QoETableNetflowTopRetransmitsHostsIPsShortWidget({id:this.Id + "TopRetransmitsHostsIPsShortReport"}),

        TopRetransmitsHostsIPsReport: QoETableNetflowTopRetransmitsHostsIPsWidget({id:this.Id + "TopRetransmitsHostsIPsReport"}),

        TopRetransmitsHostCategoriesPieReport: QoEPieChartNetflowTopRetransmitsHostCategoriesWidget({id:this.Id + "TopRetransmitsHostCategoriesPieReport"}),

        TopRetransmitsHostCategoriesShortReport: QoETableNetflowTopRetransmitsHostCategoriesShortWidget({id:this.Id + "TopRetransmitsHostCategoriesShortReport"}),

        TopRetransmitsHostCategoriesReport: QoETableNetflowTopRetransmitsHostCategoriesWidget({id:this.Id + "TopRetransmitsHostCategoriesReport"}),

        TopRetransmitsASsPieReport: QoEPieChartNetflowTopRetransmitsASsWidget({id:this.Id + "TopRetransmitsASsPieReport", type:"destination"}),

        TopRetransmitsASsReport: QoETableNetflowTopRetransmitsASsWidget({id:this.Id + "TopRetransmitsASsReport", type:"destination"}),

        TopRetransmitsASsShortReport: QoETableNetflowTopRetransmitsASsShortWidget({id:this.Id + "TopRetransmitsASsShortReport", type:"destination"}),

        TopRetransmitsSubscriberASsPieReport: QoEPieChartNetflowTopRetransmitsASsWidget({id:this.Id + "TopRetransmitsSubscriberASsPieReport", type:"source"}),

        TopRetransmitsSubscriberASsReport: QoETableNetflowTopRetransmitsASsWidget({id:this.Id + "TopRetransmitsSubscriberASsReport", type:"source"}),

        TopRetransmitsSubscriberASsShortReport: QoETableNetflowTopRetransmitsASsShortWidget({id:this.Id + "TopRetransmitsSubscriberASsShortReport", type:"source"}),

        TopRetransmitsSwitchesPieReport: QoEPieChartNetflowTopRetransmitsSwitchesWidget({id:this.Id + "TopRetransmitsSwitchesPieReport"}),

        TopRetransmitsSwitchesShortReport: QoETableNetflowTopRetransmitsSwitchesShortWidget({id:this.Id + "TopRetransmitsSwitchesShortReport"}),

        TopRetransmitsSwitchesReport: QoETableNetflowTopRetransmitsSwitchesWidget({id:this.Id + "TopRetransmitsSwitchesReport"}),

        TopRetransmitsTrunkSwitchesPieReport: QoEPieChartNetflowTopRetransmitsSwitchesWidget({id:this.Id + "TopRetransmitsTrunkSwitchesPieReport", type:2}),

        TopRetransmitsTrunkSwitchesShortReport: QoETableNetflowTopRetransmitsSwitchesShortWidget({id:this.Id + "TopRetransmitsTrunkSwitchesShortReport", type:2}),

        TopRetransmitsTrunkSwitchesReport: QoETableNetflowTopRetransmitsSwitchesWidget({id:this.Id + "TopRetransmitsTrunkSwitchesReport", type:2}),

        TopVchannelsRttPieReport: QoEPieChartTopRttVchannelsWidget({id:this.Id + "TopVchannelsRttPieReport"}),

        TopVchannelsRttShortReport: QoETableTopRttVchannelsShortWidget({id:this.Id + "TopVchannelsRttShortReport"}),

        TopVchannelsRttReport: QoETableTopRttVchannelsWidget({id:this.Id + "TopVchannelsRttReport"}),

        TopVchannelsTrafficPieReport: QoEPieChartTopTrafficVchannelsWidget({id:this.Id + "TopVchannelsTrafficPieReport"}),

        TopVchannelsTrafficShortReport: QoETableTopTrafficVchannelsShortWidget({id:this.Id + "TopVchannelsTrafficShortReport"}),

        TopVchannelsTrafficReport: QoETableTopTrafficVchannelsWidget({id:this.Id + "TopVchannelsTrafficReport"}),

        TopVchannelsRetransmitsPieReport: QoEPieChartTopRetransmitsVchannelsWidget({id:this.Id + "TopVchannelsRetransmitsPieReport"}),

        TopVchannelsRetransmitsShortReport: QoETableTopRetransmitsVchannelsShortWidget({id:this.Id + "TopVchannelsRetransmitsShortReport"}),

        TopVchannelsRetransmitsReport: QoETableTopRetransmitsVchannelsWidget({id:this.Id + "TopVchannelsRetransmitsReport"}),

        TrafficByVchannels: QoETableNetflowTopTrafficVchannelsTableChartWidget({id:this.Id + "TrafficByVchannels"}),

        FlowByVchannels: QoESeriesChartFlowByVchannelsTableChartWidget({id:this.Id + "FlowByVchannels"}),

        TopClassesRttPieReport: QoEPieChartTopRttClassesWidget({id:this.Id + "TopClassesRttPieReport"}),

        TopClassesRttShortReport: QoETableTopRttClassesShortWidget({id:this.Id + "TopClassesRttShortReport"}),

        TopClassesRttReport: QoETableTopRttClassesWidget({id:this.Id + "TopClassesRttReport"}),

        TopClassesTrafficPieReport: QoEPieChartTopTrafficClassesWidget({id:this.Id + "TopClassesTrafficPieReport"}),

        TopClassesTrafficShortReport: QoETableTopTrafficClassesShortWidget({id:this.Id + "TopClassesTrafficShortReport"}),

        TopClassesTrafficReport: QoETableTopTrafficClassesWidget({id:this.Id + "TopClassesTrafficReport"}),

        TopFullDscpClassesTrafficShortReport: QoETableTopTrafficFullDscpClassesShortWidget({id:this.Id + "TopFullDscpClassesTrafficShortReport"}),

        TopClassesRetransmitsPieReport: QoEPieChartTopRetransmitsClassesWidget({id:this.Id + "TopClassesRetransmitsPieReport"}),

        TopClassesRetransmitsShortReport: QoETableTopRetransmitsClassesShortWidget({id:this.Id + "TopClassesRetransmitsShortReport"}),

        TopClassesRetransmitsReport: QoETableTopRetransmitsClassesWidget({id:this.Id + "TopClassesRetransmitsReport"}),

        TrafficByClasses: QoETableNetflowTopTrafficClassesTableChartWidget({id:this.Id + "TrafficByClasses"}),

        TrafficByFullDscpClasses: QoETableNetflowTopFullDscpTrafficClassesTableChartWidget({id:this.Id + "TrafficByFullDscpClasses"}),

        FlowByClasses: QoESeriesChartFlowByClassesTableChartWidget({id:this.Id + "FlowByClasses"}),

        FlowByFullDscpClasses: QoESeriesChartFlowByFullDscpClassesTableChartWidget({id:this.Id + "FlowByFullDscpClasses"}),



        TopGTPCellsPieReport: QoEPieChartNetflowTopGTPCellsWidget({id:this.Id + "TopGTPCellsPieReport"}),

        TopGTPCellsShortReport: QoETableNetflowTopGTPCellsShortWidget({id:this.Id + "TopGTPCellsShortReport"}),

        TopGTPCellsReport: QoETableNetflowTopGTPCellsWidget({id:this.Id + "TopGTPCellsReport"}),


        TopTrafficGTPCellsPieReport: QoEPieChartNetflowTopTrafficGTPCellsWidget({id:this.Id + "TopTrafficGTPCellsPieReport"}),

        TopTrafficGTPCellsShortReport: QoETableNetflowTopTrafficGTPCellsShortWidget({id:this.Id + "TopTrafficGTPCellsShortReport"}),

        TopTrafficGTPCellsReport: QoETableNetflowTopTrafficGTPCellsWidget({id:this.Id + "TopTrafficGTPCellsReport"}),


        TopRetransmitsGTPCellsPieReport: QoEPieChartNetflowTopRetransmitsGTPCellsWidget({id:this.Id + "TopRetransmitsGTPCellsPieReport"}),

        TopRetransmitsGTPCellsShortReport: QoETableNetflowTopRetransmitsGTPCellsShortWidget({id:this.Id + "TopRetransmitsGTPCellsShortReport"}),

        TopRetransmitsGTPCellsReport: QoETableNetflowTopRetransmitsGTPCellsWidget({id:this.Id + "TopRetransmitsGTPCellsReport"}),


        TopInfectedSubscribersReport: QoETableFullNetflowTopInfectedSubscribersWidget({id:this.Id + "TopInfectedSubscribersReport"}),

        TopInfectedSubscribersMaliciousTrafficReport: QoETableFullNetflowTopInfectedSubscribersMaliciousTrafficWidget({id:this.Id + "TopInfectedSubscribersMaliciousTrafficReport"}),

        TopInfectedSubscribersBotnetTrafficReport: QoETableFullNetflowTopInfectedSubscribersBotnetTrafficWidget({id:this.Id + "TopInfectedSubscribersBotnetTrafficReport"}),


        TopInfectedSubscribersPhishingTrafficReport: QoETableFullNetflowTopInfectedSubscriberPhishingTrafficWidget({id:this.Id + "TopInfectedSubscribersPhishingTrafficReport"}),


        TopSubscribersTopFlowReport: QoETableTopFlowSubscribersWidget({id:this.Id + "TopFlowSubscribersReport"}),

        TopSubscribersTopFlowShortReport: QoETableTopFlowSubscribersShortWidget({id:this.Id + "TopSubscribersTopFlowShortReport"}),

        TopSubscribersTopFlowPieReport: QoEPieChartTopFlowSubscribersWidget({id:this.Id + "TopSubscribersTopFlowPieReport"}),

        TopSubscriberLoginsTopFlowReport: QoETableTopFlowSubscriberLoginsWidget({id:this.Id + "TopSubscriberLoginsTopFlowReport"}),

        TopSubscriberLoginsTopFlowShortReport: QoETableTopFlowSubscriberLoginsShortWidget({id:this.Id + "TopSubscriberLoginsTopFlowShortReport"}),

        TopSubscriberLoginsTopFlowPieReport: QoEPieChartTopFlowSubscriberLoginsWidget({id:this.Id + "TopSubscriberLoginsTopFlowPieReport"}),

        TopFlowProtocolsReport: QoETableNetflowTopFlowProtocolsWidget({id:this.Id + "TopFlowProtocolsReport"}),

        TopFlowProtocolsPercentShortReport: QoETableNetflowTopFlowProtocolsPercentShortWidget({id:this.Id + "TopFlowProtocolsPercentShortReport"}),

        TopFlowProtocolsShortReport: QoETableNetflowTopFlowProtocolsShortWidget({id:this.Id + "TopFlowProtocolsShortReport"}),

        TopFlowProtocolsPieReport: QoEPieChartNetflowTopFlowProtocolsWidget({id:this.Id + "TopFlowProtocolsPieReport"}),

        TopFlowProtocolsGrpsReport: QoETableNetflowTopFlowProtocolsGroupsWidget({id:this.Id + "TopFlowProtocolsGrpsReport"}),

        TopFlowProtocolsPercentGrpsShortReport: QoETableNetflowTopFlowProtocolsGroupsPercentShortWidget({id:this.Id + " TopFlowProtocolsPercentGrpsShortReport"}),

        TopFlowProtocolsGrpsShortReport: QoETableNetflowTopFlowProtocolsGroupsShortWidget({id:this.Id + " TopFlowProtocolsGrpsShortReport"}),

        TopProtocolsGrpsTopFlowPieReport: QoEPieChartNetflowTopFlowProtocolsGroupsWidget({id:this.Id + "TopProtocolsGrpsTopFlowPieReport"}),

        TopFlowHostsReport: QoETableNetflowTopFlowHostsWidget({id:this.Id + "TopFlowHostsReport"}),

        TopFlowHostsShortReport: QoETableNetflowTopFlowHostsShortWidget({id:this.Id + "TopFlowHostsShortReport"}),

        TopFlowHostsPieReport: QoEPieChartNetflowTopFlowHostsWidget({id:this.Id + " TopFlowHostsPieReport"}),

        TopFlowHostsIPsReport: QoETableNetflowTopFlowHostsIPsWidget({id:this.Id + "TopFlowHostsIPsReport"}),

        TopFlowHostsIPsShortReport: QoETableNetflowTopFlowHostsIPsShortWidget({id:this.Id + "TopFlowHostsIPsShortReport"}),

        TopFlowHostsIPsPieReport: QoEPieChartNetflowTopFlowHostsIPsWidget({id:this.Id + "TopFlowHostsIPsPieReport"}),

        TopFlowHostCategoriesReport: QoETableNetflowTopFlowHostCategoriesWidget({id:this.Id + "TopFlowHostCategoriesReport"}),

        TopFlowHostCategoriesShortReport: QoETableNetflowTopFlowHostCategoriesShortWidget({id:this.Id + "TopFlowHostCategoriesShortReport"}),

        TopFlowHostCategoriesPieReport: QoEPieChartNetflowTopFlowHostCategoriesWidget({id:this.Id + "TopFlowHostCategoriesPieReport"}),

        TopFlowASsReport: QoETableNetflowTopFlowASsWidget({id:this.Id + "TopFlowASsReport", type:"destination"}),

        TopFlowASsShortReport: QoETableNetflowTopFlowASsShortWidget({id:this.Id + "TopFlowASsShortReport", type:"destination"}),

        TopFlowASsPieReport: QoEPieChartNetflowTopFlowASsWidget({id:this.Id + "TopFlowASsPieReport", type:"destination"}),

        TopFlowSubscriberASsReport: QoETableNetflowTopFlowSubscriberASsWidget({id:this.Id + "TopFlowSubscriberASsReport"}),

        TopFlowSubscriberASsShortReport: QoETableNetflowTopFlowSubscriberASsShortWidget({id:this.Id + "TopFlowSubscriberASsShortReport"}),

        TopFlowSubscriberASsPieReport: QoEPieChartNetflowTopFlowASsWidget({id:this.Id + "TopFlowSubscriberASsPieReport", type:"source"}),

        TopFlowSwitchesReport: QoETableNetflowTopFlowSwitchesWidget({id:this.Id + "TopFlowSwitchesReport"}),

        TopFlowSwitchesShortReport: QoETableNetflowTopFlowSwitchesShortWidget({id:this.Id + "TopFlowSwitchesShortReport"}),

        TopFlowSwitchesPieReport: QoEPieChartNetflowTopFlowSwitchesWidget({id:this.Id + "TopFlowSwitchesPieReport"}),

        TopFlowTrunkSwitchesReport: QoETableNetflowTopFlowTrunkSwitchesWidget({id:this.Id + "TopFlowTrunkSwitchesReport"}),

        TopFlowTrunkSwitchesShortReport: QoETableNetflowTopFlowTrunkSwitchesShortWidget({id:this.Id + "TopFlowTrunkSwitchesShortReport"}),

        TopFlowTrunkSwitchesPieReport: QoEPieChartNetflowTopFlowSwitchesWidget({id:this.Id + "TopFlowTrunkSwitchesPieReport", type:2}),

        TopClassesTopFlowShortReport: QoETableTopFlowClassesShortWidget({id:this.Id + "TopClassesTopFlowShortReport"}),

        TopFullDscpClassesTopFlowShortWidget: QoETableTopFlowFullDscpClassesShortWidget({id: this.Id + "TopFullDscpClassesTopFlowShortWidget"}),

        TopClassesTopFlowsReport: QoETableTopFlowClassesWidget({id:this.Id + "TopClassesTopFlowsReport"}),

        TopClassesTopFlowPieReport: QoEPieChartTopFlowClassesWidget({id:this.Id + "TopClassesTopFlowPieReport"}),

        TopVchannelsTopFlowShortReport: QoETableNetflowTopFlowVchannelsShortWidget({id:this.Id + "TopVchannelsTopFlowShortReport"}),

        TopVchannelsTopFlowReport: QoETableNetflowTopFlowVchannelsWidget({id:this.Id + "TopVchannelsTopFlowReport"}),

        TopVchannelsTopFlowPieReport: QoEPieChartTopFlowVchannelsWidget({id:this.Id + "TopVchannelsTopFlowPieReport"}),

        TopFlowGTPCellsShortReport: QoETableNetflowTopFlowGTPCellsShortWidget({id:this.Id + "TopFlowGTPCellsShortReport"}),

        TopFlowGTPCellsReport: QoETableNetflowTopFlowGTPCellsWidget({id:this.Id + "TopFlowGTPCellsReport"}),

        TopFlowGTPCellsPieReport: QoEPieChartNetflowTopFlowGTPCellsWidget({id:this.Id + "TopFlowGTPCellsPieReport"}),

        TopVoipProtocolsShortReport: QoETableNetflowTopVoipProtocolsShortWidget({id:this.Id + "TopVoipProtocolsShortReport"}),

        TopVoipProtocolsTableReport: QoETableNetflowTopVoipProtocolsWidget({id:this.Id + "TopVoipProtocolsTableReport"}),

        TopVoipProtocolsPieChartReport: QoEPieChartNetflowTopVoipProtocolsWidget({id:this.Id + "TopVoipProtocolsPieChartReport"}),

        UsersByVoipProtocolsReport: QoETableNetflowUsersByVoipProtocolsTableChartWidget({id:this.Id + "UsersByVoipProtocolsReport"}),

        CallsByVoipProtocolsReport: QoETableNetflowCallsByVoipProtocolsTableChartWidget({id:this.Id + "CallsByVoipProtocolsReport"}),

        MinutesByVoipProtocolsReport: QoETableNetflowMinutesByVoipProtocolsTableChartWidget({id:this.Id + "MinutesByVoipProtocolsReport"}),

        TopTrafficByVoipProtocolsReport: QoETableNetflowTopTrafficByVoipProtocolsTableChartWidget({id:this.Id + "TopTrafficByVoipProtocolsReport"}),

        // Applications & subscribers
        TopAppProtocolsBySubscribersReport:     QoETableNetflowTopAppProtocolsBySubscribersTableChartWidget({id:this.Id + "TopAppProtocolsBySubscribersReport"}),
        TopAppProtocolsGrpsBySubscribersReport: QoETableNetflowTopAppProtocolsGroupsBySubscribersTableChartWidget({id:this.Id + "TopAppProtocolsGrpsBySubscribersReport"}),
        TopAppProtocolsByGrowthRateReport:      QoETableNetflowTopAppProtocolsByGrowthRateTableChartWidget({id:this.Id + "TopAppProtocolsByGrowthRateReport"}),
        TopAppProtocolsGrpsByGrowthRateReport:  QoETableNetflowTopAppProtocolsGroupsByGrowthRateTableChartWidget({id:this.Id + "TopAppProtocolsGrpsByGrowthRateReport"}),
        TopSubscribersByAppProtocolsReport:     QoETableNetflowTopSubscribersByAppProtocolsTableChartWidget({id:this.Id + "TopSubscribersByAppProtocolsReport"}),
        TopLoginsByAppProtocolsReport:          QoETableNetflowTopLoginsByAppProtocolsTableChartWidget({id:this.Id + "TopLoginsByAppProtocolsReport"})
    };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Netflow")}),
                                {
                                    view: "toolbar",
                                    elements: [
                                        this.Views.Widgets.DateRangePicker.ViewConfig,
                                        {
                                            view:"multiselect",
                                            id:this.Id + "DpiPicker",
                                            value:"-2",
                                            maxWidth:320,
                                            optionWidth:320,
                                            tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                            options:[]
                                        },
                                        {
                                            view:"richselect",
                                            id:this.Id + "ExecTimeSelector",
                                            value:600,
                                            maxWidth:120,
                                            optionWidth:320,
                                            tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                            options:[
                                                {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                            ]
                                        },
                                        this.Views.Widgets.ExtendedFillter.ViewConfig,
                                        {},
                                        {
                                            view: "button",
                                            id:this.Id+"RefreshAllDataBtn",
                                            type: "icon",
                                            icon: "refresh",
                                            css: "toolbar_round_btn",
                                            width: 32,
                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                            click: function (id, e, node)
                                            {
                                                _this.RefreshAllData(true);
                                            }
                                        },
                                        this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                        {
                                            width: 16
                                        },
                                        QoEKillProcessesBtnWidget({
                                            id:this.Id+"KillProcessesBtn",
                                            callback:function (Id)
                                            {
                                                _this.KillProcesses(Id);
                                            }
                                        }),
                                        QoEClearCacheBtnWidget({
                                            id:this.Id+"ClearCacheBtn",
                                            callback:function (Id)
                                            {
                                                _this.ClearCache(Id);
                                            }
                                        })
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            rows:[
                                                {
                                                    view:"multiview",
                                                    id:this.Id + "ReportsCells",
                                                    cells:[
                                                        {
                                                            id: this.Id + "ReportsCells" + "RttDistribution",
                                                            rows:[
                                                                this.Views.Widgets.RttDistribution.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "RttByTime",
                                                            rows:[
                                                                this.Views.Widgets.RttByTime.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "RetransmitsByTime",
                                                            rows:[
                                                                this.Views.Widgets.RetransmitsByTime.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "Traffic",
                                                            cols:[
                                                                {
                                                                    gravity:4,
                                                                    rows:[
                                                                        this.Views.Widgets.Traffic.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                {
                                                                    maxWidth:240,
                                                                    minWidth:160,
                                                                    rows:[
                                                                        this.Views.Widgets.TotalTraffic.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TrafficByProtocols",
                                                            rows:[
                                                                this.Views.Widgets.TrafficByProtocols.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TrafficByAppProtocols",
                                                            rows:[
                                                                this.Views.Widgets.TrafficByAppProtocols.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TrafficByAppProtocolsGrps",
                                                            rows:[
                                                                this.Views.Widgets.TrafficByAppProtocolsGrps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TrafficByAS",
                                                            rows:[
                                                                this.Views.Widgets.TrafficByAS.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TrafficBySubscribersAS",
                                                            rows:[
                                                                this.Views.Widgets.TrafficBySubscribersAS.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TrafficByVchannels",
                                                            rows:[
                                                                this.Views.Widgets.TrafficByVchannels.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TrafficByClasses",
                                                            rows:[
                                                                this.Views.Widgets.TrafficByClasses.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TrafficByFullDscpClasses",
                                                            rows:[
                                                                this.Views.Widgets.TrafficByFullDscpClasses.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "Flow",
                                                            rows:[
                                                                this.Views.Widgets.Flow.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "FlowByProtocols",
                                                            rows:[
                                                                this.Views.Widgets.FlowByProtocols.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "FlowByAppProtocols",
                                                            rows:[
                                                                this.Views.Widgets.FlowByAppProtocols.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "FlowByAppProtocolsGrps",
                                                            rows:[
                                                                this.Views.Widgets.FlowByAppProtocolsGrps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "FlowByVchannels",
                                                            rows:[
                                                                this.Views.Widgets.FlowByVchannels.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "FlowByClasses",
                                                            rows:[
                                                                this.Views.Widgets.FlowByClasses.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "FlowByFullDscpClasses",
                                                            rows:[
                                                                this.Views.Widgets.FlowByFullDscpClasses.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersTrafficShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersTrafficShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersTrafficReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscribersTrafficPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsTrafficShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberLoginsTrafficShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberLoginsTrafficReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscriberLoginsTrafficPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersRttShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersRttShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersRttReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscribersRttPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsRttShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberLoginsRttShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberLoginsRttReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscriberLoginsRttPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsRttShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsRttShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsRttReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopVchannelsRttPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsTrafficShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsTrafficShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsTrafficReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopVchannelsTrafficPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsRetransmitsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsRetransmitsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsRetransmitsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsRetransmitsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopVchannelsRetransmitsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopClassesRttShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopClassesRttShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopClassesRttReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopClassesRttReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopClassesRttPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopClassesTrafficShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopClassesTrafficShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFullDscpClassesTrafficShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFullDscpClassesTrafficShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopClassesTrafficReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopClassesTrafficReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopClassesTrafficPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopClassesRetransmitsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopClassesRetransmitsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopClassesRetransmitsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopClassesRetransmitsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopClassesRetransmitsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopProtocolsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopProtocolsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopProtocolsPercentShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopProtocolsPercentShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopProtocolsGrpsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopProtocolsGrpsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopProtocolsGrpsPercentShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopProtocolsGrpsPercentShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopProtocolsGrpsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopProtocolsGrpsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopProtocolsGrpsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopProtocolsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopProtocolsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficProtocolsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsPercentSpeedShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficProtocolsPercentSpeedShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsPercentVolumeShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficProtocolsPercentVolumeShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficProtocolsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficProtocolsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                          id: this.Id + "ReportsCells" + "TopTrafficProtocolsBySubscribersReport",
                                                          cols:[
                                                              {
                                                                  gravity: 2,
                                                                  rows: [
                                                                      this.Views.Widgets.TopTrafficProtocolsBySubscribersReport.ViewConfig
                                                                  ]
                                                              },
                                                              {view: "resizer"},
                                                              this.Views.Widgets.TopTrafficProtocolsBySubscribersPieReport.ViewConfig
                                                          ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficProtocolsGrpsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsPercentSpeedShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficProtocolsGrpsPercentSpeedShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsPercentVolumeShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficProtocolsGrpsPercentVolumeShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsBySubscribersReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficProtocolsGrpsBySubscribersReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficProtocolsGrpsBySubscribersPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficProtocolsGrpsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficProtocolsGrpsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportCells" + "SshBruteForceReport",
                                                            cols:[
                                                                {
                                                                    gravity: 2,
                                                                    rows:[
                                                                        this.Views.Widgets.SshBruteForceReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopHostsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficHostsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficHostsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficHostsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficHostsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficHostsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficHostsPercentSpeedShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficHostsPercentSpeedShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficHostsPercentVolumeShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficHostsPercentVolumeShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsIPsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsIPsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsIPsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsIPsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopHostsIPsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficHostsIPsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficHostsIPsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficHostsIPsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficHostsIPsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficHostsIPsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostCategoriesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostCategoriesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopHostCategoriesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficHostCategoriesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficHostCategoriesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficHostCategoriesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficHostCategoriesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficHostCategoriesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopASsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopASsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopASsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopASsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopASsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberASsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberASsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberASsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberASsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscriberASsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficASsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficASsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficASsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficASsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficASsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficSubscriberASsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficSubscriberASsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficSubscriberASsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficSubscriberASsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficSubscriberASsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSwitchesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSwitchesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSwitchesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSwitchesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSwitchesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrunkSwitchesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrunkSwitchesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrunkSwitchesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrunkSwitchesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrunkSwitchesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficSwitchesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficSwitchesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficSwitchesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficSwitchesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficSwitchesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficTrunkSwitchesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficTrunkSwitchesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficTrunkSwitchesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficTrunkSwitchesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficTrunkSwitchesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersRetransmitsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersRetransmitsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersRetransmitsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersRetransmitsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscribersRetransmitsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsRetransmitsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberLoginsRetransmitsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsRetransmitsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberLoginsRetransmitsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscriberLoginsRetransmitsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsProtocolsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsPercentShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsProtocolsPercentShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsProtocolsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopProtocolsRetransmitsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsProtocolsGrpsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsPercentShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsProtocolsGrpsPercentShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsProtocolsGrpsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopProtocolsGrpsRetransmitsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsHostsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsHostsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsHostsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsHostsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopRetransmitsHostsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsHostsIPsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsHostsIPsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsHostsIPsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsHostsIPsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopRetransmitsHostsIPsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsHostCategoriesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsHostCategoriesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsHostCategoriesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsHostCategoriesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopRetransmitsHostCategoriesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsASsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsASsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsASsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsASsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopRetransmitsASsPieReport.ViewConfig
                                                            ]
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsSubscriberASsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsSubscriberASsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsSubscriberASsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsSubscriberASsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopRetransmitsSubscriberASsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsSwitchesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsSwitchesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsSwitchesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsSwitchesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopRetransmitsSwitchesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsTrunkSwitchesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsTrunkSwitchesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsTrunkSwitchesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsTrunkSwitchesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopRetransmitsTrunkSwitchesPieReport.ViewConfig
                                                            ]
                                                        },


                                                        {
                                                            id: this.Id + "ReportsCells" + "TopGTPCellsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopGTPCellsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopGTPCellsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopGTPCellsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopGTPCellsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficGTPCellsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficGTPCellsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficGTPCellsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficGTPCellsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopTrafficGTPCellsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersTopFlowShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersTopFlowShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersTopFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersTopFlowReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscribersTopFlowPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsTopFlowShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberLoginsTopFlowShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsTopFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscriberLoginsTopFlowReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopSubscriberLoginsTopFlowPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowProtocolsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowProtocolsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowProtocolsPercentShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowProtocolsPercentShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowProtocolsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopFlowProtocolsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowProtocolsGrpsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowProtocolsGrpsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowProtocolsPercentGrpsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowProtocolsPercentGrpsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowProtocolsGrpsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowProtocolsGrpsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopProtocolsGrpsTopFlowPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowHostsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowHostsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowHostsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowHostsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopFlowHostsPieReport.ViewConfig
                                                            ],
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowHostsIPsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowHostsIPsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowHostsIPsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowHostsIPsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopFlowHostsIPsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowHostCategoriesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowHostCategoriesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowHostCategoriesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowHostCategoriesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopFlowHostCategoriesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowASsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowASsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowASsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowASsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopFlowASsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowSubscriberASsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowSubscriberASsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowSubscriberASsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowSubscriberASsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopFlowSubscriberASsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowSwitchesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowSwitchesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowSwitchesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowSwitchesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopFlowSwitchesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowTrunkSwitchesShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowTrunkSwitchesShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowTrunkSwitchesReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowTrunkSwitchesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopFlowTrunkSwitchesPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsTopFlowShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsTopFlowShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsTopFlowReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsTopFlowReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopVchannelsTopFlowPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopClassesTopFlowShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopClassesTopFlowShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFullDscpClassesTopFlowShortWidget",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFullDscpClassesTopFlowShortWidget.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopClassesTopFlowsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopClassesTopFlowsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopClassesTopFlowPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowGTPCellsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowGTPCellsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowGTPCellsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopFlowGTPCellsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopFlowGTPCellsPieReport.ViewConfig
                                                            ]
                                                        },


                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsGTPCellsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsGTPCellsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopRetransmitsGTPCellsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopRetransmitsGTPCellsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopRetransmitsGTPCellsPieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersCellsReport",
                                                            cols: [
                                                                {
                                                                    gravity: 2,
                                                                    rows: [
                                                                        this.Views.Widgets.TopInfectedSubscribersReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersMaliciousTrafficCellsReport",
                                                            cols: [
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopInfectedSubscribersMaliciousTrafficReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersBotnetTrafficCellsReport",
                                                            cols: [
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopInfectedSubscribersBotnetTrafficReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersPhishingTrafficCellsReport",
                                                            cols: [
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopInfectedSubscribersPhishingTrafficReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },

                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVoipProtocolsShortReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVoipProtocolsShortReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVoipProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopVoipProtocolsTableReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TopVoipProtocolsPieChartReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "UsersByVoipProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.UsersByVoipProtocolsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "CallsByVoipProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.CallsByVoipProtocolsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "MinutesByVoipProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.MinutesByVoipProtocolsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficByVoipProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopTrafficByVoipProtocolsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAppProtocolsBySubscribersReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopAppProtocolsBySubscribersReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAppProtocolsGrpsBySubscribersReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopAppProtocolsGrpsBySubscribersReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAppProtocolsByGrowthRateReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopAppProtocolsByGrowthRateReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAppProtocolsGrpsByGrowthRateReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopAppProtocolsGrpsByGrowthRateReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersByAppProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersByAppProtocolsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopLoginsByAppProtocolsReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TopLoginsByAppProtocolsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {view: "resizer"},
                                        {
                                            width: 400,
                                            rows: [
                                                BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                {
                                                    view: "treetable",
                                                    id:this.Id + "ReportsList",
                                                    header:false,
                                                    select: "row",
                                                    on: {
                                                        onAfterSelect:function ()
                                                        {
                                                            _this.OnReportsListSelect();
                                                        },
                                                        onAfterUnSelect:function ()
                                                        {
                                                            _this.OnReportsListUnSelect();
                                                        }
                                                    },
                                                    columns: [
                                                        {
                                                            id: "value",
                                                            fillspace: true,
                                                            template: function(obj, common, value, config)
                                                            {
                                                                return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                            }
                                                        }
                                                    ],
                                                    data: [
                                                        {
                                                            id: this.Id + "ReportsCells" + "Traffic" + "Group",
                                                            value:LangHelper.GetString("QoE", "Traffic"),
                                                            data:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "Traffic",
                                                                    value:LangHelper.GetString("QoE", "Traffic")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TrafficByProtocols",
                                                                    value:LangHelper.GetString("QoE", "Traffic by protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TrafficByAppProtocols",
                                                                    value:LangHelper.GetString("QoE", "Traffic by application protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TrafficByAppProtocolsGrps",
                                                                    value:LangHelper.GetString("QoE", "Traffic by application protocols groups")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TrafficByAS",
                                                                    value:LangHelper.GetString("QoE", "Traffic by AS")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TrafficBySubscribersAS",
                                                                    value:LangHelper.GetString("QoE", "Traffic by subscriber`s AS")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TrafficByVchannels",
                                                                    value:LangHelper.GetString("QoE", "Traffic by vchannels")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TrafficByClasses",
                                                                    value:LangHelper.GetString("QoE", "Traffic by classes")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TrafficByFullDscpClasses",
                                                                    value:LangHelper.GetString("QoE", "Traffic by DSCP")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "Flow",
                                                                    value:LangHelper.GetString("QoE", "Flow")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "FlowByProtocols",
                                                                    value:LangHelper.GetString("QoE", "Flow by protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "FlowByAppProtocols",
                                                                    value:LangHelper.GetString("QoE", "Flow by application protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "FlowByAppProtocolsGrps",
                                                                    value:LangHelper.GetString("QoE", "Flow by application protocols groups")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "FlowByVchannels",
                                                                    value:LangHelper.GetString("QoE", "Flow by vchannels")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "FlowByClasses",
                                                                    value:LangHelper.GetString("QoE", "Flow by classes")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "FlowByFullDscpClasses",
                                                                    value:LangHelper.GetString("QoE", "Flow by DSCP")
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersRttShortReport" + "Group" + "Group" + "Group",
                                                            value:LangHelper.GetString("QoE", "Top"),
                                                            data:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopSubscribersRttShortReport" + "Group" + "Group",
                                                                    value:LangHelper.GetString("QoE", "Top with high RTT"),
                                                                    data:[
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscribersRttShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top subscribers"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscribersRttShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscribers")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscribersRttReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscribers")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsRttShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top logins"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberLoginsRttShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top logins")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberLoginsRttReport",
                                                                                    value:LangHelper.GetString("QoE", "Top logins")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopProtocolsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top application protocols"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopProtocolsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopProtocolsPercentShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopProtocolsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopProtocolsGrpsShortReport" + "Group",
                                                                            value: LangHelper.GetString("QoE", "Top application protocols groups"),
                                                                            data: [
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopProtocolsGrpsShortReport",
                                                                                    value: LangHelper.GetString("QoE", "Top application protocols groups")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopProtocolsGrpsPercentShortReport",
                                                                                    value: LangHelper.GetString("QoE", "Top application protocols groups")+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopProtocolsGrpsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopHostsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top hosts"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopHostsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopHostsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopHostsIPsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top hosts IPs"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopHostsIPsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts IPs")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopHostsIPsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts IPs")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top host categories"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopHostCategoriesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top host categories")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopHostCategoriesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top host categories")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopASsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top AS"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopASsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top AS")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopASsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top AS")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberASsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscriber`s AS")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberASsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscriber`s AS")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSwitchesShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top switches"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSwitchesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top switches")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSwitchesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top switches")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrunkSwitchesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top trunk switches")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrunkSwitchesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top trunk switches")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopVchannelsRttShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top vchannels"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopVchannelsRttShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top vchannels")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopVchannelsRttReport",
                                                                                    value:LangHelper.GetString("QoE", "Top vchannels")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopClassesRttShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top classes"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopClassesRttShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top classes")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopClassesRttReport",
                                                                                    value:LangHelper.GetString("QoE", "Top classes")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },



                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopGTPCellsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top GTP cells"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopGTPCellsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top GTP cells")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopGTPCellsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top GTP cells")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopSubscribersTrafficShortReport" + "Group" + "Group",
                                                                    value:LangHelper.GetString("QoE", "Top with high traffic"),
                                                                    data:[
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscribersTrafficShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top subscribers"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscribersTrafficShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscribers")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscribersTrafficReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscribers")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsTrafficShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top logins"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberLoginsTrafficShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top logins")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberLoginsTrafficReport",
                                                                                    value:LangHelper.GetString("QoE", "Top logins")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top application protocols"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsPercentSpeedShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" "+LangHelper.GetString("QoE", "By traffic").toLowerCase()+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsPercentVolumeShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" "+LangHelper.GetString("QoE", "By traffic volume").toLowerCase()+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsBySubscribersReport",
                                                                                    value: LangHelper.GetString("QoE", "By subscribers")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top application protocols groups"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsPercentSpeedShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups") + " " + LangHelper.GetString("QoE", "By traffic").toLowerCase()+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsPercentVolumeShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups") + " " + LangHelper.GetString("QoE", "By traffic volume").toLowerCase()+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsBySubscribersReport",
                                                                                    value:LangHelper.GetString("QoE", "By subscribers")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopTrafficHostsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top hosts"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficHostsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficHostsPercentSpeedShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")+" "+LangHelper.GetString("QoE", "By traffic").toLowerCase()+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficHostsPercentVolumeShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")+" "+LangHelper.GetString("QoE", "By traffic volume").toLowerCase()+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficHostsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopTrafficHostsIPsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top hosts IPs"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficHostsIPsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts IPs")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficHostsIPsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts IPs")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopTrafficHostCategoriesShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top host categories"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficHostCategoriesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top host categories")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficHostCategoriesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top host categories")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopTrafficASsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top AS"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficASsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top AS")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficASsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top AS")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficSubscriberASsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscriber`s AS")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficSubscriberASsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscriber`s AS")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopTrafficSwitchesShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top switches"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficSwitchesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top switches")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficSwitchesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top switches")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficTrunkSwitchesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top trunk switches")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficTrunkSwitchesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top trunk switches")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopVchannelsTrafficShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top vchannels"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopVchannelsTrafficShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top vchannels")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopVchannelsTrafficReport",
                                                                                    value:LangHelper.GetString("QoE", "Top vchannels")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopClassesTrafficShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top classes"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopClassesTrafficShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top classes")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFullDscpClassesTrafficShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top DSCP classes")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopClassesTrafficReport",
                                                                                    value:LangHelper.GetString("QoE", "Top classes")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopTrafficGTPCellsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top GTP cells"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficGTPCellsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top GTP cells")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopTrafficGTPCellsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top GTP cells")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopSubscribersTopFlowShortReport" + "Group" + "Group",
                                                                    value:LangHelper.GetString("QoE", "Top with high flow"),
                                                                    data:[
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscribersTopFlowShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top subscribers"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscribersTopFlowShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscribers")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscribersTopFlowReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscribers") + " ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsTopFlowShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top logins"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberLoginsTopFlowShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top logins")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberLoginsTopFlowReport",
                                                                                    value:LangHelper.GetString("QoE", "Top logins") + " ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopFlowProtocolsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top application protocols"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowProtocolsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowProtocolsPercentShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowProtocolsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopFlowProtocolsGrpsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top application protocols groups"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowProtocolsGrpsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowProtocolsPercentGrpsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowProtocolsGrpsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopFlowHostsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top hosts"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowHostsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowHostsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopFlowHostsIPsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top hosts IPs"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowHostsIPsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts IPs")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowHostsIPsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts IPs")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopFlowHostCategoriesShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top host categories"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowHostCategoriesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top host categories")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowHostCategoriesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top host categories")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopFlowASsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top AS"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowASsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top AS")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowASsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top AS")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowSubscriberASsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscriber`s AS")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowSubscriberASsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscriber`s AS")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopFlowSwitchesShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top switches"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowSwitchesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top switches")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowSwitchesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top switches")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowTrunkSwitchesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top trunk switches")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowTrunkSwitchesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top trunk switches")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopVchannelsTopFlowShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top vchannels"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopVchannelsTopFlowShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top vchannels")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopVchannelsTopFlowReport",
                                                                                    value:LangHelper.GetString("QoE", "Top vchannels")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopClassesTopFlowShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top classes"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopClassesTopFlowShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top classes")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFullDscpClassesTopFlowShortWidget",
                                                                                    value:LangHelper.GetString("QoE", "Top DSCP classes")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopClassesTopFlowsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top classes")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopFlowGTPCellsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top GTP cells"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowGTPCellsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top GTP cells")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopFlowGTPCellsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top GTP cells")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopSubscribersRetransmitsShortReport" + "Group" + "Group",
                                                                    value:LangHelper.GetString("QoE", "Top with high retransmits"),
                                                                    data:[
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscribersRetransmitsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top subscribers"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscribersRetransmitsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscribers")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscribersRetransmitsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscribers")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscriberLoginsRetransmitsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top logins"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberLoginsRetransmitsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top logins")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopSubscriberLoginsRetransmitsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top logins")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top application protocols"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsPercentShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top application protocols groups"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsPercentShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups")+" ("+LangHelper.GetString("QoE", "Percent")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top application protocols groups")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopRetransmitsHostsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top hosts"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsHostsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsHostsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopRetransmitsHostsIPsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top hosts IPs"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsHostsIPsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts IPs")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsHostsIPsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top hosts IPs")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopRetransmitsHostCategoriesShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top host categories"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsHostCategoriesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top host categories")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsHostCategoriesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top host categories")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopRetransmitsASsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top AS"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsASsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top AS")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsASsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top AS")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsSubscriberASsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscriber`s AS")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsSubscriberASsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top subscriber`s AS")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopRetransmitsSwitchesShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top switches"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsSwitchesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top switches")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsSwitchesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top switches")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsTrunkSwitchesShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top trunk switches")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsTrunkSwitchesReport",
                                                                                    value:LangHelper.GetString("QoE", "Top trunk switches")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopVchannelsRetransmitsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top vchannels"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopVchannelsRetransmitsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top vchannels")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopVchannelsRetransmitsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top vchannels")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopClassesRetransmitsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top classes"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopClassesRetransmitsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top classes")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopClassesRetransmitsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top classes")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopRetransmitsGTPCellsShortReport" + "Group",
                                                                            value:LangHelper.GetString("QoE", "Top GTP cells"),
                                                                            data:[
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsGTPCellsShortReport",
                                                                                    value:LangHelper.GetString("QoE", "Top GTP cells")
                                                                                },
                                                                                {
                                                                                    id: this.Id + "ReportsCells" + "TopRetransmitsGTPCellsReport",
                                                                                    value:LangHelper.GetString("QoE", "Top GTP cells")+" ("+LangHelper.GetString("QoE", "Maxi")+")"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopInfectedSubscribersCellsReport" + "Group",
                                                                    value:LangHelper.GetString("QoE", "Top infected subscribers"),
                                                                    data:[
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersCellsReport",
                                                                            value:LangHelper.GetString("QoE", "Top infected subscribers")
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersMaliciousTrafficCellsReport",
                                                                            value:LangHelper.GetString("QoE", "Top infected subscribers with malicious traffic")
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersBotnetTrafficCellsReport",
                                                                            value:LangHelper.GetString("QoE", "Top infected subscribers with botnet traffic")
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopInfectedSubscribersPhishingTrafficCellsReport",
                                                                            value:LangHelper.GetString("QoE", "Top infected subscribers with phishing traffic")
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "RttDistribution" + "Group",
                                                            value:LangHelper.GetString("QoE", "RTT"),
                                                            data:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RttDistribution",
                                                                    value:LangHelper.GetString("QoE", "RTT distribution")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RttByTime",
                                                                    value:LangHelper.GetString("QoE", "RTT by time")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RetransmitsByTime",
                                                                    value:LangHelper.GetString("QoE", "Retransmits by time")
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "VoipProtocols" + "Group",
                                                            value:LangHelper.GetString("QoE", "VOIP"),
                                                            hidden:true,
                                                            data:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopVoipProtocolsShortReport",
                                                                    value: LangHelper.GetString("QoE", "Top protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopVoipProtocolsReport",
                                                                    value: LangHelper.GetString("QoE", "Top protocols") + " (" + LangHelper.GetString("QoE", "Maxi") + ")"
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "UsersByVoipProtocolsReport",
                                                                    value: LangHelper.GetString("QoE", "Subscribers by protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "CallsByVoipProtocolsReport",
                                                                    value: LangHelper.GetString("QoE", "Calls by protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "MinutesByVoipProtocolsReport",
                                                                    value: LangHelper.GetString("QoE", "Minutes by protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopTrafficByVoipProtocolsReport",
                                                                    value: LangHelper.GetString("QoE", "Traffic by protocols")
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopAppProtocolsBySubscribersReport" + "Group",
                                                            value:LangHelper.GetString("QoE", "Applications & subscribers"),
                                                            data:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAppProtocolsBySubscribersReport" + "Group" + "Group",
                                                                    value:LangHelper.GetString("QoE", "Top applications by subscribers"),
                                                                    data:[
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopAppProtocolsBySubscribersReport",
                                                                            value: LangHelper.GetString("QoE", "Top applications protocols by subscribers")
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopAppProtocolsGrpsBySubscribersReport",
                                                                            value: LangHelper.GetString("QoE", "Top applications protocols groups by subscribers")
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAppProtocolsByGrowthRateReport" + "Group" + "Group",
                                                                    value:LangHelper.GetString("QoE", "Top applications by growth rate"),
                                                                    data:[
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopAppProtocolsByGrowthRateReport",
                                                                            value: LangHelper.GetString("QoE", "Top applications protocols by growth rate")
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopAppProtocolsGrpsByGrowthRateReport",
                                                                            value: LangHelper.GetString("QoE", "Top applications protocols groups by growth rate")
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopSubscribersByAppProtocolsReport" + "Group" + "Group",
                                                                    value:LangHelper.GetString("QoE", "Top subscribers by applications"),
                                                                    data:[
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscribersByAppProtocolsReport",
                                                                            value: LangHelper.GetString("QoE", "Top subscribers by applications")
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopLoginsByAppProtocolsReport",
                                                                            value: LangHelper.GetString("QoE", "Top logins by applications")
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RttDistribution"] = [this.Views.Widgets.RttDistribution];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RttByTime"] = [this.Views.Widgets.RttByTime];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersTrafficReport"] = [this.Views.Widgets.TopSubscribersTrafficReport, this.Views.Widgets.TopSubscribersTrafficPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersTrafficShortReport"] = [this.Views.Widgets.TopSubscribersTrafficShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberLoginsTrafficReport"] = [this.Views.Widgets.TopSubscriberLoginsTrafficReport, this.Views.Widgets.TopSubscriberLoginsTrafficPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberLoginsTrafficShortReport"] = [this.Views.Widgets.TopSubscriberLoginsTrafficShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersRttReport"] = [this.Views.Widgets.TopSubscribersRttReport, this.Views.Widgets.TopSubscribersRttPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersRttShortReport"] = [this.Views.Widgets.TopSubscribersRttShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberLoginsRttReport"] = [this.Views.Widgets.TopSubscriberLoginsRttReport, this.Views.Widgets.TopSubscriberLoginsRttPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberLoginsRttShortReport"] = [this.Views.Widgets.TopSubscriberLoginsRttShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsRttReport"] = [this.Views.Widgets.TopVchannelsRttReport, this.Views.Widgets.TopVchannelsRttPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsRttShortReport"] = [this.Views.Widgets.TopVchannelsRttShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsTrafficReport"] = [this.Views.Widgets.TopVchannelsTrafficReport, this.Views.Widgets.TopVchannelsTrafficPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsTrafficShortReport"] = [this.Views.Widgets.TopVchannelsTrafficShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsRetransmitsReport"] = [this.Views.Widgets.TopVchannelsRetransmitsReport, this.Views.Widgets.TopVchannelsRetransmitsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsRetransmitsShortReport"] = [this.Views.Widgets.TopVchannelsRetransmitsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RetransmitsByTime"] = [this.Views.Widgets.RetransmitsByTime];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "Traffic"] = [this.Views.Widgets.Traffic, this.Views.Widgets.TotalTraffic];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TrafficByProtocols"] = [this.Views.Widgets.TrafficByProtocols];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TrafficByAppProtocols"] = [this.Views.Widgets.TrafficByAppProtocols];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TrafficByAppProtocolsGrps"] = [this.Views.Widgets.TrafficByAppProtocolsGrps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TrafficByVchannels"] = [this.Views.Widgets.TrafficByVchannels];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TrafficByAS"] = [this.Views.Widgets.TrafficByAS];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TrafficBySubscribersAS"] = [this.Views.Widgets.TrafficBySubscribersAS];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "Flow"] = [this.Views.Widgets.Flow];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "FlowByProtocols"] = [this.Views.Widgets.FlowByProtocols];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "FlowByAppProtocols"] = [this.Views.Widgets.FlowByAppProtocols];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "FlowByAppProtocolsGrps"] = [this.Views.Widgets.FlowByAppProtocolsGrps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "FlowByVchannels"] = [this.Views.Widgets.FlowByVchannels];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopProtocolsReport"] = [this.Views.Widgets.TopProtocolsReport, this.Views.Widgets.TopProtocolsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopProtocolsGrpsReport"] = [this.Views.Widgets.TopProtocolsGrpsReport, this.Views.Widgets.TopProtocolsGrpsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopProtocolsShortReport"] = [this.Views.Widgets.TopProtocolsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopProtocolsPercentShortReport"] = [this.Views.Widgets.TopProtocolsPercentShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopProtocolsGrpsShortReport"] = [this.Views.Widgets.TopProtocolsGrpsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopProtocolsGrpsPercentShortReport"] = [this.Views.Widgets.TopProtocolsGrpsPercentShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsReport"] = [this.Views.Widgets.TopTrafficProtocolsReport, this.Views.Widgets.TopTrafficProtocolsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsBySubscribersReport"] = [this.Views.Widgets.TopTrafficProtocolsBySubscribersReport, this.Views.Widgets.TopTrafficProtocolsBySubscribersPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsShortReport"] = [this.Views.Widgets.TopTrafficProtocolsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsPercentSpeedShortReport"] = [this.Views.Widgets.TopTrafficProtocolsPercentSpeedShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsPercentVolumeShortReport"] = [this.Views.Widgets.TopTrafficProtocolsPercentVolumeShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsReport"] = [this.Views.Widgets.TopTrafficProtocolsGrpsReport, this.Views.Widgets.TopTrafficProtocolsGrpsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsBySubscribersReport"] = [this.Views.Widgets.TopTrafficProtocolsGrpsBySubscribersReport, this.Views.Widgets.TopTrafficProtocolsGrpsBySubscribersPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsShortReport"] = [this.Views.Widgets.TopTrafficProtocolsGrpsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsPercentSpeedShortReport"] = [this.Views.Widgets.TopTrafficProtocolsGrpsPercentSpeedShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsGrpsPercentVolumeShortReport"] = [this.Views.Widgets.TopTrafficProtocolsGrpsPercentVolumeShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsReport"] = [this.Views.Widgets.TopHostsReport, this.Views.Widgets.TopHostsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsShortReport"] = [this.Views.Widgets.TopHostsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficHostsReport"] = [this.Views.Widgets.TopTrafficHostsReport, this.Views.Widgets.TopTrafficHostsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficHostsShortReport"] = [this.Views.Widgets.TopTrafficHostsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficHostsPercentSpeedShortReport"] = [this.Views.Widgets.TopTrafficHostsPercentSpeedShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficHostsPercentVolumeShortReport"] = [this.Views.Widgets.TopTrafficHostsPercentVolumeShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsIPsReport"] = [this.Views.Widgets.TopHostsIPsReport, this.Views.Widgets.TopHostsIPsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsIPsShortReport"] = [this.Views.Widgets.TopHostsIPsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficHostsIPsReport"] = [this.Views.Widgets.TopTrafficHostsIPsReport, this.Views.Widgets.TopTrafficHostsIPsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficHostsIPsShortReport"] = [this.Views.Widgets.TopTrafficHostsIPsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopASsReport"] = [this.Views.Widgets.TopASsReport, this.Views.Widgets.TopASsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopASsShortReport"] = [this.Views.Widgets.TopASsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficASsReport"] = [this.Views.Widgets.TopTrafficASsReport, this.Views.Widgets.TopTrafficASsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficASsShortReport"] = [this.Views.Widgets.TopTrafficASsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberASsReport"] = [this.Views.Widgets.TopSubscriberASsReport, this.Views.Widgets.TopSubscriberASsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberASsShortReport"] = [this.Views.Widgets.TopSubscriberASsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficSubscriberASsReport"] = [this.Views.Widgets.TopTrafficSubscriberASsReport, this.Views.Widgets.TopTrafficSubscriberASsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficSubscriberASsShortReport"] = [this.Views.Widgets.TopTrafficSubscriberASsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSwitchesReport"] = [this.Views.Widgets.TopSwitchesReport, this.Views.Widgets.TopSwitchesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSwitchesShortReport"] = [this.Views.Widgets.TopSwitchesShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrunkSwitchesReport"] = [this.Views.Widgets.TopTrunkSwitchesReport, this.Views.Widgets.TopTrunkSwitchesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrunkSwitchesShortReport"] = [this.Views.Widgets.TopTrunkSwitchesShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficSwitchesReport"] = [this.Views.Widgets.TopTrafficSwitchesReport, this.Views.Widgets.TopTrafficSwitchesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficSwitchesShortReport"] = [this.Views.Widgets.TopTrafficSwitchesShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficTrunkSwitchesReport"] = [this.Views.Widgets.TopTrafficTrunkSwitchesReport, this.Views.Widgets.TopTrafficTrunkSwitchesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficTrunkSwitchesShortReport"] = [this.Views.Widgets.TopTrafficTrunkSwitchesShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostCategoriesReport"] = [this.Views.Widgets.TopHostCategoriesReport, this.Views.Widgets.TopHostCategoriesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostCategoriesShortReport"] = [this.Views.Widgets.TopHostCategoriesShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficHostCategoriesReport"] = [this.Views.Widgets.TopTrafficHostCategoriesReport, this.Views.Widgets.TopTrafficHostCategoriesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficHostCategoriesShortReport"] = [this.Views.Widgets.TopTrafficHostCategoriesShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersRetransmitsShortReport"] = [this.Views.Widgets.TopSubscribersRetransmitsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersRetransmitsReport"] = [this.Views.Widgets.TopSubscribersRetransmitsReport, this.Views.Widgets.TopSubscribersRetransmitsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberLoginsRetransmitsShortReport"] = [this.Views.Widgets.TopSubscriberLoginsRetransmitsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberLoginsRetransmitsReport"] = [this.Views.Widgets.TopSubscriberLoginsRetransmitsReport, this.Views.Widgets.TopSubscriberLoginsRetransmitsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsProtocolsShortReport"] = [this.Views.Widgets.TopRetransmitsProtocolsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsProtocolsPercentShortReport"] = [this.Views.Widgets.TopRetransmitsProtocolsPercentShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsProtocolsReport"] = [this.Views.Widgets.TopRetransmitsProtocolsReport, this.Views.Widgets.TopProtocolsRetransmitsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsShortReport"] = [this.Views.Widgets.TopRetransmitsProtocolsGrpsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsPercentShortReport"] = [this.Views.Widgets.TopRetransmitsProtocolsGrpsPercentShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsProtocolsGrpsReport"] = [this.Views.Widgets.TopRetransmitsProtocolsGrpsReport, this.Views.Widgets.TopProtocolsGrpsRetransmitsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsHostsShortReport"] = [this.Views.Widgets.TopRetransmitsHostsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsHostsReport"] = [this.Views.Widgets.TopRetransmitsHostsReport, this.Views.Widgets.TopRetransmitsHostsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsHostsIPsShortReport"] = [this.Views.Widgets.TopRetransmitsHostsIPsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsHostsIPsReport"] = [this.Views.Widgets.TopRetransmitsHostsIPsReport, this.Views.Widgets.TopRetransmitsHostsIPsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsHostCategoriesShortReport"] = [this.Views.Widgets.TopRetransmitsHostCategoriesShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsHostCategoriesReport"] = [this.Views.Widgets.TopRetransmitsHostCategoriesReport, this.Views.Widgets.TopRetransmitsHostCategoriesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsASsReport"] = [this.Views.Widgets.TopRetransmitsASsReport, this.Views.Widgets.TopRetransmitsASsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsASsShortReport"] = [this.Views.Widgets.TopRetransmitsASsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsSubscriberASsReport"] = [this.Views.Widgets.TopRetransmitsSubscriberASsReport, this.Views.Widgets.TopRetransmitsSubscriberASsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsSubscriberASsShortReport"] = [this.Views.Widgets.TopRetransmitsSubscriberASsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsSwitchesReport"] = [this.Views.Widgets.TopRetransmitsSwitchesReport, this.Views.Widgets.TopRetransmitsSwitchesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsSwitchesShortReport"] = [this.Views.Widgets.TopRetransmitsSwitchesShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsTrunkSwitchesReport"] = [this.Views.Widgets.TopRetransmitsTrunkSwitchesReport, this.Views.Widgets.TopRetransmitsTrunkSwitchesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsTrunkSwitchesShortReport"] = [this.Views.Widgets.TopRetransmitsTrunkSwitchesShortReport];
    
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopClassesRttReport"] = [this.Views.Widgets.TopClassesRttReport, this.Views.Widgets.TopClassesRttPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopClassesRttShortReport"] = [this.Views.Widgets.TopClassesRttShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopClassesTrafficReport"] = [this.Views.Widgets.TopClassesTrafficReport, this.Views.Widgets.TopClassesTrafficPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopClassesTrafficShortReport"] = [this.Views.Widgets.TopClassesTrafficShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFullDscpClassesTrafficShortReport"] = [this.Views.Widgets.TopFullDscpClassesTrafficShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopClassesRetransmitsReport"] = [this.Views.Widgets.TopClassesRetransmitsReport, this.Views.Widgets.TopClassesRetransmitsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopClassesRetransmitsShortReport"] = [this.Views.Widgets.TopClassesRetransmitsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TrafficByClasses"] = [this.Views.Widgets.TrafficByClasses];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TrafficByFullDscpClasses"] = [this.Views.Widgets.TrafficByFullDscpClasses];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "FlowByClasses"] = [this.Views.Widgets.FlowByClasses];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "FlowByFullDscpClasses"] = [this.Views.Widgets.FlowByFullDscpClasses];



    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopGTPCellsReport"] = [this.Views.Widgets.TopGTPCellsReport, this.Views.Widgets.TopGTPCellsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopGTPCellsShortReport"] = [this.Views.Widgets.TopGTPCellsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficGTPCellsReport"] = [this.Views.Widgets.TopTrafficGTPCellsReport, this.Views.Widgets.TopTrafficGTPCellsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficGTPCellsShortReport"] = [this.Views.Widgets.TopTrafficGTPCellsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsGTPCellsReport"] = [this.Views.Widgets.TopRetransmitsGTPCellsReport, this.Views.Widgets.TopRetransmitsGTPCellsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopRetransmitsGTPCellsShortReport"] = [this.Views.Widgets.TopRetransmitsGTPCellsShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopInfectedSubscribersCellsReport"] = [this.Views.Widgets.TopInfectedSubscribersReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopInfectedSubscribersMaliciousTrafficCellsReport"] = [this.Views.Widgets.TopInfectedSubscribersMaliciousTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopInfectedSubscribersBotnetTrafficCellsReport"] = [this.Views.Widgets.TopInfectedSubscribersBotnetTrafficReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopInfectedSubscribersPhishingTrafficCellsReport"] = [this.Views.Widgets.TopInfectedSubscribersPhishingTrafficReport];

    // Top Flow
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersTopFlowReport"] = [this.Views.Widgets.TopSubscribersTopFlowReport, this.Views.Widgets.TopSubscribersTopFlowPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersTopFlowShortReport"] = [this.Views.Widgets.TopSubscribersTopFlowShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberLoginsTopFlowReport"] = [this.Views.Widgets.TopSubscriberLoginsTopFlowReport, this.Views.Widgets.TopSubscriberLoginsTopFlowPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscriberLoginsTopFlowShortReport"] = [this.Views.Widgets.TopSubscriberLoginsTopFlowShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowProtocolsReport"] = [this.Views.Widgets.TopFlowProtocolsReport, this.Views.Widgets.TopFlowProtocolsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowProtocolsPercentShortReport"] = [this.Views.Widgets.TopFlowProtocolsPercentShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowProtocolsShortReport"] = [this.Views.Widgets.TopFlowProtocolsShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowProtocolsGrpsReport"] = [this.Views.Widgets.TopFlowProtocolsGrpsReport, this.Views.Widgets.TopProtocolsGrpsTopFlowPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowProtocolsPercentGrpsShortReport"] = [this.Views.Widgets.TopFlowProtocolsPercentGrpsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowProtocolsGrpsShortReport"] = [this.Views.Widgets.TopFlowProtocolsGrpsShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowHostsReport"] = [this.Views.Widgets.TopFlowHostsReport, this.Views.Widgets.TopFlowHostsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowHostsShortReport"] = [this.Views.Widgets.TopFlowHostsShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowHostsIPsReport"] = [this.Views.Widgets.TopFlowHostsIPsReport, this.Views.Widgets.TopFlowHostsIPsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowHostsIPsShortReport"] = [this.Views.Widgets.TopFlowHostsIPsShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowHostCategoriesReport"] = [this.Views.Widgets.TopFlowHostCategoriesReport, this.Views.Widgets.TopFlowHostCategoriesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowHostCategoriesShortReport"] = [this.Views.Widgets.TopFlowHostCategoriesShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowASsReport"] = [this.Views.Widgets.TopFlowASsReport, this.Views.Widgets.TopFlowASsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowASsShortReport"] = [this.Views.Widgets.TopFlowASsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowSubscriberASsReport"] = [this.Views.Widgets.TopFlowSubscriberASsReport, this.Views.Widgets.TopFlowSubscriberASsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowSubscriberASsShortReport"] = [this.Views.Widgets.TopFlowSubscriberASsShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowSwitchesReport"] = [this.Views.Widgets.TopFlowSwitchesReport, this.Views.Widgets.TopFlowSwitchesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowSwitchesShortReport"] = [this.Views.Widgets.TopFlowSwitchesShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowTrunkSwitchesReport"] = [this.Views.Widgets.TopFlowTrunkSwitchesReport, this.Views.Widgets.TopFlowTrunkSwitchesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowTrunkSwitchesShortReport"] = [this.Views.Widgets.TopFlowTrunkSwitchesShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsTopFlowReport"] = [this.Views.Widgets.TopVchannelsTopFlowReport, this.Views.Widgets.TopVchannelsTopFlowPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsTopFlowShortReport"] = [this.Views.Widgets.TopVchannelsTopFlowShortReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopClassesTopFlowsReport"] = [this.Views.Widgets.TopClassesTopFlowsReport, this.Views.Widgets.TopClassesTopFlowPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopClassesTopFlowShortReport"] = [this.Views.Widgets.TopClassesTopFlowShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFullDscpClassesTopFlowShortWidget"] = [this.Views.Widgets.TopFullDscpClassesTopFlowShortWidget];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowGTPCellsReport"] = [this.Views.Widgets.TopFlowGTPCellsReport, this.Views.Widgets.TopFlowGTPCellsPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowGTPCellsShortReport"] = [this.Views.Widgets.TopFlowGTPCellsShortReport];

    // VoipProtocols
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVoipProtocolsShortReport"] = [this.Views.Widgets.TopVoipProtocolsShortReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVoipProtocolsReport"] = [this.Views.Widgets.TopVoipProtocolsTableReport, this.Views.Widgets.TopVoipProtocolsPieChartReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "UsersByVoipProtocolsReport"] = [this.Views.Widgets.UsersByVoipProtocolsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "CallsByVoipProtocolsReport"] = [this.Views.Widgets.CallsByVoipProtocolsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "MinutesByVoipProtocolsReport"] = [this.Views.Widgets.MinutesByVoipProtocolsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficByVoipProtocolsReport"] = [this.Views.Widgets.TopTrafficByVoipProtocolsReport];

    // Applications & subscribers
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAppProtocolsBySubscribersReport"] = [this.Views.Widgets.TopAppProtocolsBySubscribersReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAppProtocolsGrpsBySubscribersReport"] = [this.Views.Widgets.TopAppProtocolsGrpsBySubscribersReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAppProtocolsByGrowthRateReport"] = [this.Views.Widgets.TopAppProtocolsByGrowthRateReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAppProtocolsGrpsByGrowthRateReport"] = [this.Views.Widgets.TopAppProtocolsGrpsByGrowthRateReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersByAppProtocolsReport"] = [this.Views.Widgets.TopSubscribersByAppProtocolsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopLoginsByAppProtocolsReport"] = [this.Views.Widgets.TopLoginsByAppProtocolsReport];

    if(!AppEnv || !AppEnv.EnableVoipGroup)
        this.RollBackVoipConfig();
};

QoEFullNetFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEFullNetFlow");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();
};

QoEFullNetFlowViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w)
        {
            if(w.Bind)
                _this.Views.Widgets[Key].Bind(_this);

            _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"] = Helper.SubscribeWidgetForProtocolsGroupsUpdatedIfNeeded(w);

            if(!_this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"])
                delete _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"];
        }
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        App.DicsManager.Signal[DicsEnum.InfectedHostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId)  && Val[2] && Val[3] && Val[5])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoEFullNetFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoEFullNetFlowViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEFullNetFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoEFullNetFlowViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullNetFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullNetFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoEFullNetFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoEFullNetFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoEFullNetFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoEFullNetFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoEFullNetFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEFullNetFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEFullNetFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoEFullNetFlowViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoEFullNetFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEFullNetFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoEFullNetFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)
    };
};

QoEFullNetFlowViewController.prototype.RollBackVoipConfig = function()
{
    let _this = this;

    let reportsCellsConfig = Helper.FindObjById(this.Id + "ReportsCells", this.ViewConfig);
    let reportsListConfig = Helper.FindObjById(this.Id + "ReportsList", this.ViewConfig);

    Object.keys(_this.Views.Widgets).forEach(Key => {
        if(Key.includes(VoipProtocolsKey)) {
            _this.Views.Widgets[Key].Destroy();
            delete _this.Views.Widgets[Key];
        }
    });

    if(reportsCellsConfig && Array.isArray(reportsCellsConfig.cells))
        reportsCellsConfig.cells = reportsCellsConfig.cells.filter(item => !item.id.includes(VoipProtocolsKey));

    if(reportsListConfig && Array.isArray(reportsListConfig.data))
        reportsListConfig.data = reportsListConfig.data.filter(item => !item.id.includes(VoipProtocolsKey));
};
function QoESubscribersViewController(Params)
{
    var _this = this;

    this.Id = "QoESubscribers";

    this.ViewModel = new QoEReportsManager();

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {};

    this.Views.Widgets = {};

    this.Views.Clickstream =
    {
        //PeriodPicker:null,
        DpiPicker:null,
        ExecTimeSelector:null,
        AddCampaign:null,

        FiltersTableWidget: new QoESavedFiltersListWidget({
            id:this.Id + "Clickstream" + "FiltersTableWidget",
            title:LangHelper.GetString("QoEPopupFilterWidget", "Filters"),
            icon:"list",
            config:
            {
                type:QoESubscribersFilterListItemTypeEnum.subs_clickstream
            }
        }),

        MasterPanel:null,
        DetailsPanel:null,

        DetailsPanelTabs:null
    };

    this.Views.Clickstream.Widgets =
    {
        DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "Clickstream" + "DateRangePicker"}),

        ExtendedFillter: new QoEPopupFilterWidget({
            id:this.Id + "Clickstream" + "ExtendedFillter",
            config:
            {
                type:QoESubscribersFilterListItemTypeEnum.hist_subscribers_clickstream,
                filters:[
                    {
                        id:"host",
                        title:LangHelper.GetString("QoE", "Host"),
                        type:QoEFilterValueType.String
                    },
                    {
                        id:"host_category",
                        title:LangHelper.GetString("QoE", "Host category"),
                        type:QoEFilterValueType.UInt32,
                        operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                        editor:"multiselect",
                        dic:DicsEnum.HostCategoriesDic
                    },
                    {
                        id:"subscriber",
                        title:LangHelper.GetString("QoE", "Subscriber"),
                        type:QoEFilterValueType.String,
                        opertor_view:
                            {
                                "in CIDRs":QoEReportViews.Subnets,
                                "not in CIDRs":QoEReportViews.Subnets
                            },
                        can_cidr:true
                    },
                    {
                        id:"login",
                        title:LangHelper.GetString("QoE", "Login"),
                        type:QoEFilterValueType.String
                    },
                    {
                        id:"url",
                        title:LangHelper.GetString("QoE", "URL"),
                        type:QoEFilterValueType.String
                    },
                    {
                        id:"device",
                        title:LangHelper.GetString("QoE", "Device"),
                        type:QoEFilterValueType.String
                    },
                    {
                        id:"user_agent",
                        title:LangHelper.GetString("QoE", "User agent"),
                        type:QoEFilterValueType.String
                    },
                    {
                        id:"host_ip",
                        title:LangHelper.GetString("QoE", "Host IP"),
                        type:QoEFilterValueType.String,
                        opertor_view:
                            {
                                "in CIDRs":QoEReportViews.Subnets,
                                "not in CIDRs":QoEReportViews.Subnets
                            },
                        can_cidr:true
                    },
                    {
                        id:"bridge_vchannel",
                        title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                        type:"string"
                    },
                    {
                        id:"device_other_uniq",
                        title:LangHelper.GetString("QoE", "Devices number"),
                        type:QoEFilterValueType.UInt32,
                        sql_type:QoEFilterSqlType.having
                    },
                    {
                        id:"user_agent_uniq",
                        title:LangHelper.GetString("QoE", "Agents number"),
                        type:QoEFilterValueType.UInt32,
                        sql_type:QoEFilterSqlType.having
                    },
                    {
                        id:"hosts_uniq",
                        title:LangHelper.GetString("QoE", "Hosts number"),
                        type:QoEFilterValueType.UInt32,
                        sql_type:QoEFilterSqlType.having
                    },
                    {
                        id:"host_ip_uniq",
                        title:LangHelper.GetString("QoE", "Host IPs number"),
                        type:QoEFilterValueType.UInt32,
                        sql_type:QoEFilterSqlType.having
                    },
                    {
                        id:"sessons_uniq",
                        title: LangHelper.GetString("QoE", "Sessions"),
                        type:QoEFilterValueType.UInt32,
                        sql_type:QoEFilterSqlType.having
                    }
                ],
                default:[
                    {
                        f_enabled:0,
                        f_id:"host",
                        f_operator:QoEFilterOperatorsEnum.like
                    },
                    {
                        f_enabled:0,
                        f_id:"host_category",
                        f_operator:QoEFilterOperatorsEnum.in
                    },
                    {
                        f_enabled:0,
                        f_id:"subscriber",
                        f_operator:QoEFilterOperatorsEnum.like
                    },
                    {
                        f_enabled:0,
                        f_id:"login",
                        f_operator:QoEFilterOperatorsEnum.like
                    },
                    {
                        f_enabled:0,
                        f_id:"url",
                        f_operator:QoEFilterOperatorsEnum.like
                    },
                    {
                        f_enabled:0,
                        f_id:"device",
                        f_operator:QoEFilterOperatorsEnum.like
                    },
                    {
                        f_enabled:0,
                        f_id:"user_agent",
                        f_operator:QoEFilterOperatorsEnum.like
                    },
                    {
                        f_enabled:0,
                        f_id:"host_ip",
                        f_operator:QoEFilterOperatorsEnum.like
                    },
                    {
                        f_enabled:0,
                        f_id:"device_other_uniq",
                        f_operator:QoEFilterOperatorsEnum[">="]
                    },
                    {
                        f_enabled:0,
                        f_id:"user_agent_uniq",
                        f_operator:QoEFilterOperatorsEnum[">="]
                    },
                    {
                        f_enabled:0,
                        f_id:"hosts_uniq",
                        f_operator:QoEFilterOperatorsEnum[">="]
                    },
                    {
                        f_enabled:0,
                        f_id:"host_ip_uniq",
                        f_operator:QoEFilterOperatorsEnum[">="]
                    },
                    {
                        f_enabled:0,
                        f_id:"sessons_uniq",
                        f_operator:QoEFilterOperatorsEnum[">="]
                    }
                ]
            },
            enable_show_hotkey: 1
        }),

        TopSubscribersReport: QoETableClickstreamTopSubscribersWidget(
            {
                id:this.Id + "Clickstream" + "TopSubscribersReport",
                export_title_callback:function ()
                {
                    var selected = _this.GetFiltersTableSelectedData();

                    return selected ? selected.title : "";
                }
            })
    };

    this.Views.Clickstream.SubWidgets =
    {
        TopSubscriberDevicesReport: QoETableClickstreamTopDevicesWidget({id:this.Id + "Clickstream" + "TopSubscriberDevicesReport", no_title:true, full:true}),

        TopSubscriberAgentsReport: QoETableClickstreamTopAgentsWidget({id:this.Id + "Clickstream" + "TopSubscriberAgentsReport", no_title:true, full:true}),

        TopHostsReport: QoETableClickstreamTopHostsWidget({id:this.Id + "Clickstream" + "TopHostsReport", no_title:true, full:true}),

        TopHostCatsReport: QoETableClickstreamTopHostCategoriesWidget({id:this.Id + "Clickstream" + "TopHostCatsReport", no_title:true, full:true}),

        TopHostsIpsReport: QoETableClickstreamTopHostIpsWidget({id:this.Id + "Clickstream" + "TopHostsIpsReport", no_title:true, full:true}),

        TopUrlsReport: QoETableClickstreamTopUrlsWidget({id:this.Id + "Clickstream" + "TopUrlsReport", no_title:true, full:true}),

        TopVchannelsReport: QoETableClickstreamTopVchannelsWidget({id:this.Id + "Clickstream" + "TopVchannelsReport", no_title:true, full:true})
    };

    this.Views.Fullnetflow =
    {
        //PeriodPicker:null,
        DpiPicker:null,
        ExecTimeSelector:null,
        AddCampaign:null,

        FiltersTableWidget: new QoESavedFiltersListWidget({
            id:this.Id + "Fullnetflow" + "FiltersTableWidget",
            title:LangHelper.GetString("QoEPopupFilterWidget", "Filters"),
            icon:"list",
            config:
                {
                    type:QoESubscribersFilterListItemTypeEnum.subs_fullnetflow
                }
        }),

        MasterPanel:null,
        DetailsPanel:null,

        GroupByPicker:null,
        GroupBySwitchTypePicker:null,
        GroupByFieldPicker:null,

        DetailsPanelTabs:null
    };

    this.Views.Fullnetflow.GroupByPickerOptions =
    [
        {id: "by_subscribers", value: LangHelper.GetString("QoE", "By subscribers")},
        {id: "by_switches", value: LangHelper.GetString("QoE", "By switches")},
        {id: "by_as", value: LangHelper.GetString("QoE", "By AS")},
        {id: "by_gtp", value: LangHelper.GetString("QoE", "By GTP cells")}
    ];

    this.Views.Fullnetflow.GroupByFieldPickerOptions =
    {
        by_subscribers:
        [
            {id: "by_ip", value: LangHelper.GetString("QoE", "By IP-address")},
            {id: "by_login", value: LangHelper.GetString("QoE", "By login")},
            {id: "by_bridge_vchannel", value: LangHelper.GetString("QoE", "By vchannel")},
            {id: "by_unit_vendor", value: LangHelper.GetString("QoE", "By unit vendor")},
            {id: "by_cabel", value: LangHelper.GetString("QoE", "By cabel")},
            {id: "by_contract", value: LangHelper.GetString("QoE", "By contract")},
            {id: "by_services", value: LangHelper.GetString("QoE", "By services")}
        ],

        by_switches:
        [
            {id: "by_ip", value: LangHelper.GetString("QoE", "By IP-address")},
            {id: "by_name", value: LangHelper.GetString("QoE", "By name")},
            {id: "by_type", value: LangHelper.GetString("QoE", "By type")},
            {id: "by_region", value: LangHelper.GetString("QoE", "By region")},
            {id: "by_address", value: LangHelper.GetString("QoE", "By address")},
            {id: "by_oper_id", value: LangHelper.GetString("QoE", "By operator")},
            {id: "by_belongs_to", value: LangHelper.GetString("QoE", "By owner")}
        ],

        by_switches_types:
        [
            {id: QoEReportSwitchesTypesEnum.AccessSwitch, value: LangHelper.GetString("QoE", "By access switch")},
            {id: QoEReportSwitchesTypesEnum.TrunkSwitch, value: LangHelper.GetString("QoE", "By trunk switch")}
        ],

        by_as:
        [
            {id: "by_source_asnum", value: LangHelper.GetString("QoE", "By AS number")},
            {id: "by_source_astitle", value: LangHelper.GetString("QoE", "By AS title")}
        ],

        by_gtp:
        [
            {id: "by_cell_id", value: LangHelper.GetString("QoE", "Cell ID")},
            {id: "by_cell_name", value: LangHelper.GetString("QoE", "Cell name")},
            {id: "by_uli_mcc", value: LangHelper.GetString("QoE", "Mobile country code")},
            {id: "by_uli_mnc", value: LangHelper.GetString("QoE", "Mobile network (operator) code")},
            {id: "by_uli_tac", value: LangHelper.GetString("QoE", "Service/Tracking area code")},
            {id: "by_uli_eci", value: LangHelper.GetString("QoE", "Base station code")},

        ]
    };

    this.Views.Fullnetflow.TopSubscribersReportConfig =
        {
            common_rtt:
                {
                    values:
                        [
                            {col:"rtt_median_if", alias:"rtt_median_dummy", func:"medianIfMerge(rtt_median_if)"},
                            {col:"rtt_median_dummy", alias:"rtt_median", func:"isNaN(rtt_median_dummy) ? 0 : round(rtt_median_dummy,0)"},

                            {col:"rtt_from_subscriber_median_if", alias:"rtt_from_subscriber_median_dummy", func:"medianIfMerge(rtt_from_subscriber_median_if)"},
                            {col:"rtt_from_subscriber_median_dummy", alias:"rtt_from_subscriber_median", func:"isNaN(rtt_from_subscriber_median_dummy) ? 0 : round(rtt_from_subscriber_median_dummy,0)"},

                            {col:"rtt_to_subscriber_median_if", alias:"rtt_to_subscriber_median_dummy", func:"medianIfMerge(rtt_to_subscriber_median_if)"},
                            {col:"rtt_to_subscriber_median_dummy", alias:"rtt_to_subscriber_median", func:"isNaN(rtt_to_subscriber_median_dummy) ? 0 : round(rtt_to_subscriber_median_dummy,0)"},

                            {col:"retransmits_avg_rate", alias:"retransmits_avg_dummy", func:"avgIfMerge(retransmits_rate_avg_if)"},
                            {col:"retransmits_avg_dummy", alias:"retransmits_avg", func:"isNaN(retransmits_avg_dummy) ? 0 : round(retransmits_avg_dummy*100,2)"},

                            {col:"fragments_avg_if", alias:"fragments_avg_dummy", func:"avgIfMerge(fragments_avg_if)"},
                            {col:"fragments_avg_dummy", alias:"fragments_avg", func:"isNaN(fragments_avg_dummy) ? 0 : round(fragments_avg_dummy,0)"},

                            {col:"", alias:"traffic_sum", func:"sumMerge(octet_delta_count_sum)"},
                            {col:"", alias:"traffic_max", func:"maxMerge(flow_end_millisecond_max)"},
                            {col:"", alias:"traffic_min", func:"minMerge(flow_start_millisecond_min)"},
                            {col:"", alias:"traffic", func:"intDivOrZero(traffic_sum*8000,(traffic_max-traffic_min))"},

                            {col:"", alias:"traffic_from_subscriber_sum", func:"sumIfMerge(octet_delta_count_from_subscriber_sum_if)"},
                            {col:"", alias:"traffic_from_subscriber_max", func:"maxIfMerge(flow_end_millisecond_from_subscriber_max_if)"},
                            {col:"", alias:"traffic_from_subscriber_min", func:"minIfMerge(flow_start_millisecond_from_subscriber_min_if)"},
                            {col:"", alias:"traffic_from_subscriber", func:"intDivOrZero(traffic_from_subscriber_sum*8000,(traffic_from_subscriber_max-traffic_from_subscriber_min))"},

                            {col:"", alias:"traffic_to_subscriber_sum", func:"sumIfMerge(octet_delta_count_to_subscriber_sum_if)"},
                            {col:"", alias:"traffic_to_subscriber_max", func:"maxIfMerge(flow_end_millisecond_to_subscriber_max_if)"},
                            {col:"", alias:"traffic_to_subscriber_min", func:"minIfMerge(flow_start_millisecond_to_subscriber_min_if)"},
                            {col:"", alias:"traffic_to_subscriber", func:"intDivOrZero(traffic_to_subscriber_sum*8000,(traffic_to_subscriber_max-traffic_to_subscriber_min))"}
                        ],

                    values_new:
                        [
                            {col:"rtt_median_if", alias:"rtt_median", func:"medianIfMerge(rtt_median_if)", func_cache:"round(rtt_median,0)"},
                            {col:"rtt_from_subscriber_median_if", alias:"rtt_from_subscriber_median", func:"medianIfMerge(rtt_from_subscriber_median_if)", func_cache:"round(rtt_from_subscriber_median,0)"},
                            {col:"rtt_to_subscriber_median_if", alias:"rtt_to_subscriber_median", func:"medianIfMerge(rtt_to_subscriber_median_if)", func_cache:"round(rtt_to_subscriber_median,0)"},
                            {col:"retransmits_avg_rate", alias:"retransmits_avg", func:"avgIfMerge(retransmits_rate_avg_if)", func_cache:"round(retransmits_avg*100,0)"},
                            {col:"fragments_avg_if", alias:"fragments_avg", func:"avgIfMerge(fragments_avg_if)", func_cache:"round(fragments_avg,0)"}
                        ],

                    values_caches:
                        [
                            {col:"rtt_median_if", alias:"rtt_median", func:"medianIfMergeState", func_cache:"round(medianIfMerge(rtt_median),0)"},
                            {col:"rtt_from_subscriber_median_if", alias:"rtt_from_subscriber_median", func:"medianIfMergeState", func_cache:"round(medianIfMerge(rtt_from_subscriber_median),0)"},
                            {col:"rtt_to_subscriber_median_if", alias:"rtt_to_subscriber_median", func:"medianIfMergeState", func_cache:"round(medianIfMerge(rtt_to_subscriber_median),0)"},
                            {col:"retransmits_rate_avg_if", alias:"retransmits_avg", func:"avgIfMergeState", func_cache:"round(avgIfMerge(retransmits_avg)*100,2)"},
                            {col:"fragments_avg_if", alias:"fragments_avg", func:"avgIfMergeState", func_cache:"round(avgIfMerge(fragments_avg),0)"}
                        ],

                    columns:
                        [
                            {
                                id:"rtt_median",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT")), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string",
                                units_format_data:UnitsFormatData.SimpleTimeUnits
                            },
                            {
                                id:"rtt_from_subscriber_median",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT from subscriber")), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string",
                                units_format_data:UnitsFormatData.SimpleTimeUnits
                            },
                            {
                                id:"rtt_to_subscriber_median",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "RTT to subscriber")), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string",
                                units_format_data:UnitsFormatData.SimpleTimeUnits
                            },
                            {
                                id:"retransmits_avg",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "Retransmits")), ""],
                                format:webix.i18n.numberFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string"
                            },
                            {
                                id:"fragments_avg",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "Fragments")), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string"
                            },
                            {
                                id:"traffic",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                                format:webix.i18n.intFormat,
                                footer:{content:"totalColumn"},
                                sort:"string",
                                units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                            },
                            {
                                id:"traffic_from_subscriber",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic from subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string",
                                units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                            },
                            {
                                id:"traffic_to_subscriber",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "Traffic to subscribers")+", "+LangHelper.GetString("Dics", "Bps")), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string",
                                units_format_data:UnitsFormatData.TrafficSpeedBitUnits
                            }
                        ]
                },

            common_clickstream:
                {
                    values:
                        [
                            {col:"total_count", alias:"total", func:"countMerge"},
                            {col:"session_id_uniq", alias:"sessons_uniq", func:"uniqMerge"},
                            {col:"host", alias:"hosts_uniq", func:"uniq"},
                            {col:"host_ip", alias:"host_ip_uniq", func:"uniq"},
                            {col:"net_protocol_code", alias:"net_protocol_uniq", func:"uniq"},
                            {col:"protocol_code", alias:"protocol_uniq", func:"uniq"}
                        ],

                    values_caches:
                        [
                            {col:"total_count", alias:"total", func:"countMergeState", func_cache:"countMerge"},
                            {col:"session_id_uniq", alias:"sessons_uniq", func:"uniqMergeState", func_cache:"uniqMerge"},
                            {col:"host", alias:"hosts_uniq", func:"uniqState", func_cache:"uniqMerge"},
                            {col:"host_ip", alias:"host_ip_uniq", func:"uniqState", func_cache:"uniqMerge"},
                            {col:"net_protocol_code", alias:"net_protocol_uniq", func:"uniqState", func_cache:"uniqMerge"},
                            {col:"protocol_code", alias:"protocol_uniq", func:"uniqState", func_cache:"uniqMerge"}
                        ],

                    columns:
                        [
                            {
                                id:"total",
                                header:[LangHelper.GetString("QoE", "Total"), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string"
                            },
                            {
                                id:"sessons_uniq",
                                header:[LangHelper.GetString("QoE", "Sessions"), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string"
                            },
                            {
                                id:"hosts_uniq",
                                header:[LangHelper.GetString("QoE", "Hosts"), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string"
                            },
                            {
                                id:"host_ip_uniq",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "Hosts IPs")), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string"
                            },
                            {
                                id:"net_protocol_uniq",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "Protocols")), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string"
                            },
                            {
                                id:"protocol_uniq",
                                header:[TooltipTemplate(LangHelper.GetString("QoE", "Application protocols")), ""],
                                format:webix.i18n.intFormat,
                                //fillspace:1,
                                footer:{content:"totalColumn"},
                                sort:"string"
                            }
                        ]
                },

            by_subscribers:
                {
                    common:function(FieldBy)
                    {
                        if(FieldBy && (FieldBy == "by_ip" || FieldBy == "by_login"))
                        {
                            return {
                                values:
                                    [
                                        {col:"crc", alias:"crc_avg", func:"round(avgIf(crc, crc <> 0),0) > 0 ? round(avgIf(crc, crc <> 0),0) : 0"},
                                        {col:"unit_vendor", alias:"unit_vendor_any", func:"anyHeavyIf(unit_vendor, unit_vendor <> '')"},
                                        {col:"cabel", alias:"cabel_any", func:"anyHeavyIf(cabel, cabel <> '')"},
                                        {col:"contract", alias:"contract_any", func:"anyHeavyIf(contract, contract <> '')"},
                                        {col:"services", alias:"services_any", func:"anyHeavyIf(services, services <> '')"}
                                    ],

                                values_caches:
                                    [
                                        {col:"crc", alias:"crc_avg", func:"avgIfState(crc, crc <> 0)", func_cache:"round(avgIfMerge(crc_avg),0)"},
                                        {col:"unit_vendor", alias:"unit_vendor_any", func:"anyHeavyIfState(unit_vendor, unit_vendor <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:"cabel", alias:"cabel_any", func:"anyHeavyIfState(cabel, cabel <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:"contract", alias:"contract_any", func:"anyHeavyIfState(contract, contract <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:"services", alias:"services_any", func:"anyHeavyIfState(services, services <> '')", func_cache:"anyHeavyIfMerge"}
                                    ],

                                columns:
                                    [
                                        {
                                            id:"crc_avg",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "CRC")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"unit_vendor_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Unit vendor")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"cabel_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Cabel")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"contract_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Contract")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"services_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Services")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        }
                                    ]
                            };
                        }
                        else
                        {
                            return {
                                values:
                                    [
                                        {col:"crc", alias:"crc_avg", func:"round(avgIf(crc, crc <> 0),0) > 0 ? round(avgIf(crc, crc <> 0),0) : 0"},
                                        {col:"unit_vendor", alias:"unit_vendor_uniq", func:"uniq"},
                                        {col:"cabel", alias:"cabel_uniq", func:"uniq"},
                                        {col:"contract", alias:"contract_uniq", func:"uniq"},
                                        {col:"services", alias:"services_uniq", func:"uniq"}
                                    ],

                                values_caches:
                                    [
                                        {col:"crc", alias:"crc_avg", func:"avgIfState(crc, crc <> 0)", func_cache:"round(avgIfMerge(crc_avg),0)"},
                                        {col:"unit_vendor", alias:"unit_vendor_uniq", func:"uniqState", func_cache:"uniqMerge"},
                                        {col:"cabel", alias:"cabel_uniq", func:"uniqState", func_cache:"uniqMerge"},
                                        {col:"contract", alias:"contract_uniq", func:"uniqState", func_cache:"uniqMerge"},
                                        {col:"services", alias:"services_uniq", func:"uniqState", func_cache:"uniqMerge"}
                                    ],

                                columns:
                                    [
                                        {
                                            id:"crc_avg",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "CRC")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"unit_vendor_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Unit vendor")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"cabel_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Cabel")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"contract_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Contract")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"services_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Services")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        }
                                    ]
                            };
                        }
                    },

                    by_ip:function ()
                    {
                        return {
                            values:
                                [
                                    {col:"login", alias:"login_any", func:"any"}
                                ],

                            values_caches:
                                [
                                    {col:"login", alias:"login_any",func:"anyState(login)", func_cache:"anyMerge(login_any)"}
                                ],

                            rows:["subscriber"],

                            columns:
                                [
                                    {
                                        id:"subscriber",
                                        header:[LangHelper.GetString("QoE", "Subscriber"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        //fillspace:2,
                                        footer:{content:"totalRows"},
                                        minWidth:160,
                                        sort:"string"
                                    },
                                    {
                                        id:"login",
                                        header:[LangHelper.GetString("QoE", "Login"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        template:function(Obj)
                                        {
                                            return Obj.login_any;
                                        },
                                        //fillspace:2,
                                        footer:{content:"totalRows"},
                                        minWidth:160,
                                        sort:"string"
                                    }
                                ],

                            leftSplit:2,
                            sort_map:{"login":"login_any"}
                        };
                    },

                    by_login:function ()
                    {
                        return {

                            values:
                                [
                                    {col:"subscriber", alias:"subscriber_any", func:"any"}
                                ],

                            values_caches:
                                [
                                    {col:"subscriber", alias:"subscriber_any",func:"anyState(subscriber)", func_cache:"anyMerge(subscriber_any)"}
                                ],

                            rows:["login"],

                            columns:
                                [
                                    {
                                        id:"login",
                                        header:[LangHelper.GetString("QoE", "Login"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        //fillspace:2,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    },
                                    {
                                        id:"subscriber_any",
                                        header:[LangHelper.GetString("QoE", "Subscriber"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        template:function(Obj)
                                        {
                                            return Obj.subscriber_any;
                                        },
                                        //fillspace:2,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_bridge_vchannel:function ()
                    {
                        return {

                            values:
                                [],

                            values_caches:
                                [],

                            rows:["bridge_vchannel"],

                            columns:
                                [
                                    {
                                        id:"bridge_vchannel",
                                        header:[LangHelper.GetString("QoE", "Vchannel/Bridge"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        //fillspace:2,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:1
                        };
                    },

                    by_unit_vendor:function ()
                    {
                        return {
                            values:
                                [
                                    {col:"subscriber", alias:"subscriber_uniq", func:"uniq"}
                                ],

                            values_caches:
                                [
                                    {col:"subscriber", alias:"subscriber_uniq", func:"uniqState", func_cache:"uniqMerge"}
                                ],

                            rows:["unit_vendor"],

                            columns:
                                [
                                    {
                                        id:"unit_vendor",
                                        header:[LangHelper.GetString("QoE", "Unit vendor"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    },
                                    {
                                        id:"subscriber_uniq",
                                        header:[LangHelper.GetString("QoE", "Subscribers"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        format:webix.i18n.intFormat,
                                        footer:{content:"totalColumn"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_cabel:function ()
                    {
                        return {
                            values:
                                [
                                    {col:"subscriber", alias:"subscriber_uniq", func:"uniq"}
                                ],

                            values_caches:
                                [
                                    {col:"subscriber", alias:"subscriber_uniq", func:"uniqState", func_cache:"uniqMerge"}
                                ],

                            rows:["cabel"],

                            columns:
                                [
                                    {
                                        id:"cabel",
                                        header:[LangHelper.GetString("QoE", "Cabel"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    },
                                    {
                                        id:"subscriber_uniq",
                                        header:[LangHelper.GetString("QoE", "Subscribers"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        format:webix.i18n.intFormat,
                                        footer:{content:"totalColumn"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_contract:function ()
                    {
                        return {
                            values:
                                [
                                    {col:"subscriber", alias:"subscriber_uniq", func:"uniq"}
                                ],

                            values_caches:
                                [
                                    {col:"subscriber", alias:"subscriber_uniq", func:"uniqState", func_cache:"uniqMerge"}
                                ],

                            rows:["contract"],

                            columns:
                                [
                                    {
                                        id:"contract",
                                        header:[LangHelper.GetString("QoE", "Contract"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    },
                                    {
                                        id:"subscriber_uniq",
                                        header:[LangHelper.GetString("QoE", "Subscribers"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        format:webix.i18n.intFormat,
                                        footer:{content:"totalColumn"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_services:function ()
                    {
                        return {
                            values:
                                [
                                    {col:"subscriber", alias:"subscriber_uniq", func:"uniq"}
                                ],

                            values_caches:
                                [
                                    {col:"subscriber", alias:"subscriber_uniq", func:"uniqState", func_cache:"uniqMerge"}
                                ],

                            rows:["contract"],

                            columns:
                                [
                                    {
                                        id:"services",
                                        header:[LangHelper.GetString("QoE", "Services"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    },
                                    {
                                        id:"subscriber_uniq",
                                        header:[LangHelper.GetString("QoE", "Subscribers"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        format:webix.i18n.intFormat,
                                        footer:{content:"totalColumn"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:2
                        };
                    }
                },

            by_switches:
                {
                    common:function(FieldBy, Type)
                    {
                        var type = Type ? Type : 1;

                        if(FieldBy && FieldBy == "by_ip")
                        {
                            var hw_name = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Name+"]";

                            var hw_type = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Type+"]";

                            var hw_region = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Region+"]";

                            var hw_address = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Address+"]";

                            var hw_oper_id = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.OperId+"]";

                            var hw_belongs_to = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.BelongsTo+"]";

                            return {
                                values:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniq"},
                                        {col:hw_name, alias:"hw_name_any", func:"anyHeavyIf("+hw_name+", "+hw_name+" <> '')"},
                                        {col:hw_type, alias:"hw_type_any", func:"anyHeavyIf("+hw_type+", "+hw_type+" <> '')"},
                                        {col:hw_region, alias:"hw_region_any", func:"anyHeavyIf("+hw_region+", "+hw_region+" <> '')"},
                                        {col:hw_address, alias:"hw_address_any", func:"anyHeavyIf("+hw_address+", "+hw_address+" <> '')"},
                                        {col:hw_oper_id, alias:"hw_oper_id_any", func:"anyHeavyIf("+hw_oper_id+", "+hw_oper_id+" <> '')"},
                                        {col:hw_belongs_to, alias:"hw_belongs_to_any", func:"anyHeavyIf("+hw_belongs_to+", "+hw_belongs_to+" <> '')"}
                                    ],

                                values_caches:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniqState", func_cache:"uniqMerge"},
                                        {col:hw_name, alias:"hw_name_any", func:"anyHeavyIfState("+hw_name+", "+hw_name+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_type, alias:"hw_type_any", func:"anyHeavyIfState("+hw_type+", "+hw_type+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_region, alias:"hw_region_any", func:"anyHeavyIfState("+hw_region+", "+hw_region+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_address, alias:"hw_address_any", func:"anyHeavyIfState("+hw_address+", "+hw_address+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_oper_id, alias:"hw_oper_id_any", func:"anyHeavyIfState("+hw_oper_id+", "+hw_oper_id+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_belongs_to, alias:"hw_belongs_to_any", func:"anyHeavyIfState("+hw_belongs_to+", "+hw_belongs_to+" <> '')", func_cache:"anyHeavyIfMerge"}
                                    ],

                                columns:
                                    [
                                        {
                                            id:"subscribers_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_name_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch name")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_type_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch type")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_region_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Region")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_address_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch address")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_oper_id_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Operator")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_belongs_to_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Owner")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        }
                                    ]
                            };
                        }
                        else
                        {
                            return {
                                values:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniq"}
                                    ],

                                values_caches:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniqState", func_cache:"uniqMerge"}
                                    ],

                                columns:
                                    [
                                        {
                                            id:"subscribers_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        }
                                    ]
                            };
                        }
                    },

                    by_ip: function (Type)
                    {
                        var type = Type ? Type : 1;

                        return {
                            values: [],

                            values_caches: [],

                            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.HwIp+"]", alias:"hw_ip"}],

                            columns:
                                [
                                    {
                                        id:"hw_ip",
                                        header:[LangHelper.GetString("QoE", "Switch IP-address"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        fillspace:1,
                                        minWidth:160,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:1
                        };
                    },

                    by_name: function (Type)
                    {
                        var type = Type ? Type : 1;

                        return {
                            values: [],

                            values_caches: [],

                            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Name+"]", alias:"hw_name"}],

                            columns:
                                [
                                    {
                                        id:"hw_name",
                                        header:[LangHelper.GetString("QoE", "Switch name"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        fillspace:1,
                                        minWidth:160,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:1
                        };
                    },

                    by_region: function (Type)
                    {
                        var type = Type ? Type : 1;

                        return {
                            values: [],

                            values_caches: [],

                            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Region+"]", alias:"hw_region"}],

                            columns:
                                [
                                    {
                                        id:"hw_region",
                                        header:[LangHelper.GetString("QoE", "Region"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        fillspace:1,
                                        minWidth:160,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:1
                        };
                    },

                    by_address: function (Type)
                    {
                        var type = Type ? Type : 1;

                        return {
                            values: [],

                            values_caches: [],

                            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Address+"]", alias:"hw_address"}],

                            columns:
                                [
                                    {
                                        id:"hw_address",
                                        header:[LangHelper.GetString("QoE", "Switch address"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        fillspace:1,
                                        minWidth:160,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:1
                        };
                    },

                    by_type: function (Type)
                    {
                        var type = Type ? Type : 1;

                        return {
                            values: [],

                            values_caches: [],

                            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Type+"]", alias:"hw_type"}],

                            columns:
                                [
                                    {
                                        id:"hw_type",
                                        header:[LangHelper.GetString("QoE", "Switch type"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        fillspace:1,
                                        minWidth:160,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:1
                        };
                    },

                    by_oper_id: function (Type)
                    {
                        var type = Type ? Type : 1;

                        return {
                            values: [],

                            values_caches: [],

                            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.OperId+"]", alias:"hw_operator"}],

                            columns:
                                [
                                    {
                                        id:"hw_operator",
                                        header:[LangHelper.GetString("QoE", "Operator"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        fillspace:1,
                                        minWidth:160,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:1
                        };
                    },

                    by_belongs_to: function (Type)
                    {
                        var type = Type ? Type : 1;

                        return {
                            values: [],

                            values_caches: [],

                            rows:[{col:"hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.BelongsTo+"]", alias:"hw_belongs_to"}],

                            columns:
                                [
                                    {
                                        id:"hw_belongs_to",
                                        header:[LangHelper.GetString("QoE", "Owner"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        fillspace:1,
                                        minWidth:160,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:1
                        };
                    }
                },

            by_as:
                {
                    common:function(FieldBy, Type)
                    {
                        var type = Type ? Type : 1;

                        if(FieldBy && FieldBy == "by_ip")
                        {
                            var hw_name = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Name+"]";

                            var hw_type = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Type+"]";

                            var hw_region = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Region+"]";

                            var hw_address = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Address+"]";

                            var hw_oper_id = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.OperId+"]";

                            var hw_belongs_to = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.BelongsTo+"]";

                            return {
                                values:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniq"},
                                        {col:hw_name, alias:"hw_name_any", func:"anyHeavyIf("+hw_name+", "+hw_name+" <> '')"},
                                        {col:hw_type, alias:"hw_type_any", func:"anyHeavyIf("+hw_type+", "+hw_type+" <> '')"},
                                        {col:hw_region, alias:"hw_region_any", func:"anyHeavyIf("+hw_region+", "+hw_region+" <> '')"},
                                        {col:hw_address, alias:"hw_address_any", func:"anyHeavyIf("+hw_address+", "+hw_address+" <> '')"},
                                        {col:hw_oper_id, alias:"hw_oper_id_any", func:"anyHeavyIf("+hw_oper_id+", "+hw_oper_id+" <> '')"},
                                        {col:hw_belongs_to, alias:"hw_belongs_to_any", func:"anyHeavyIf("+hw_belongs_to+", "+hw_belongs_to+" <> '')"}
                                    ],

                                values_caches:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniqState", func_cache:"uniqMerge"},
                                        {col:hw_name, alias:"hw_name_any", func:"anyHeavyIfState("+hw_name+", "+hw_name+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_type, alias:"hw_type_any", func:"anyHeavyIfState("+hw_type+", "+hw_type+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_region, alias:"hw_region_any", func:"anyHeavyIfState("+hw_region+", "+hw_region+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_address, alias:"hw_address_any", func:"anyHeavyIfState("+hw_address+", "+hw_address+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_oper_id, alias:"hw_oper_id_any", func:"anyHeavyIfState("+hw_oper_id+", "+hw_oper_id+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_belongs_to, alias:"hw_belongs_to_any", func:"anyHeavyIfState("+hw_belongs_to+", "+hw_belongs_to+" <> '')", func_cache:"anyHeavyIfMerge"}
                                    ],

                                columns:
                                    [
                                        {
                                            id:"subscribers_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_name_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch name")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_type_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch type")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_region_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Region")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_address_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch address")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_oper_id_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Operator")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_belongs_to_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Owner")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        }
                                    ]
                            };
                        }
                        else
                        {
                            return {
                                values:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniq"}
                                    ],

                                values_caches:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniqState", func_cache:"uniqMerge"}
                                    ],

                                columns:
                                    [
                                        {
                                            id:"subscribers_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        }
                                    ]
                            };
                        }
                    },

                    by_source_asnum:function ()
                    {
                        return {
                            values:
                                [
                                    {col:"source_astitle", alias:"astitle_any", func:"any"}
                                ],

                            values_caches:
                                [
                                    {col:"source_astitle", alias:"astitle_any", func:"anyState", func_cache:"anyMerge"}
                                ],

                            rows:["source_asnum"],

                            columns:
                                [
                                    {
                                        id:"source_asnum",
                                        header:[TooltipTemplate(LangHelper.GetString("QoE", "AS number")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        footer:{content:"totalRows"},
                                        sort:"string",
                                        fillspace:1,
                                        minWidth:160
                                    },
                                    {
                                        id:"source_astitle",
                                        header:[LangHelper.GetString("QoE", "AS title"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        template:function(Obj)
                                        {
                                            return Obj.astitle_any;
                                        },
                                        fillspace:1,
                                        minWidth:160,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_source_astitle:function ()
                    {
                        return {
                            values:
                                [
                                    {col:"source_asnum", alias:"asnum_any", func:"any"}
                                ],

                            values_caches:
                                [
                                    {col:"source_asnum", alias:"asnum_any", func:"anyState", func_cache:"anyMerge"}
                                ],

                            rows:["source_astitle"],

                            columns:
                                [
                                    {
                                        id:"source_astitle",
                                        header:[LangHelper.GetString("QoE", "AS title"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        footer:{content:"totalRows"},
                                        sort:"string",
                                        fillspace:1,
                                        minWidth:160
                                    },
                                    {
                                        id:"source_asnum",
                                        header:[LangHelper.GetString("QoE", "AS number"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        template:function(Obj)
                                        {
                                            return Obj.asnum_any;
                                        },
                                        fillspace:1,
                                        minWidth:160,
                                        footer:{content:"totalRows"},
                                        sort:"string"
                                    }
                                ],

                            leftSplit:1
                        };
                    }
                },

            by_gtp:
                {
                    common:function(FieldBy, Type)
                    {
                        var type = Type ? Type : 1;

                        if(FieldBy && FieldBy == "by_ip")
                        {
                            var hw_name = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Name+"]";

                            var hw_type = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Type+"]";

                            var hw_region = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Region+"]";

                            var hw_address = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.Address+"]";

                            var hw_oper_id = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.OperId+"]";

                            var hw_belongs_to = "hw_info_chain["+type+"]["+QoEReportSwitchesInfoFieldsEnum.BelongsTo+"]";

                            return {
                                values:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniq"},
                                        {col:hw_name, alias:"hw_name_any", func:"anyHeavyIf("+hw_name+", "+hw_name+" <> '')"},
                                        {col:hw_type, alias:"hw_type_any", func:"anyHeavyIf("+hw_type+", "+hw_type+" <> '')"},
                                        {col:hw_region, alias:"hw_region_any", func:"anyHeavyIf("+hw_region+", "+hw_region+" <> '')"},
                                        {col:hw_address, alias:"hw_address_any", func:"anyHeavyIf("+hw_address+", "+hw_address+" <> '')"},
                                        {col:hw_oper_id, alias:"hw_oper_id_any", func:"anyHeavyIf("+hw_oper_id+", "+hw_oper_id+" <> '')"},
                                        {col:hw_belongs_to, alias:"hw_belongs_to_any", func:"anyHeavyIf("+hw_belongs_to+", "+hw_belongs_to+" <> '')"}
                                    ],

                                values_caches:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniqState", func_cache:"uniqMerge"},
                                        {col:hw_name, alias:"hw_name_any", func:"anyHeavyIfState("+hw_name+", "+hw_name+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_type, alias:"hw_type_any", func:"anyHeavyIfState("+hw_type+", "+hw_type+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_region, alias:"hw_region_any", func:"anyHeavyIfState("+hw_region+", "+hw_region+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_address, alias:"hw_address_any", func:"anyHeavyIfState("+hw_address+", "+hw_address+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_oper_id, alias:"hw_oper_id_any", func:"anyHeavyIfState("+hw_oper_id+", "+hw_oper_id+" <> '')", func_cache:"anyHeavyIfMerge"},
                                        {col:hw_belongs_to, alias:"hw_belongs_to_any", func:"anyHeavyIfState("+hw_belongs_to+", "+hw_belongs_to+" <> '')", func_cache:"anyHeavyIfMerge"}
                                    ],

                                columns:
                                    [
                                        {
                                            id:"subscribers_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_name_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch name")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_type_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch type")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_region_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Region")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_address_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Switch address")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_oper_id_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Operator")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        },
                                        {
                                            id:"hw_belongs_to_any",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Owner")), ""],
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        }
                                    ]
                            };
                        }
                        else
                        {
                            return {
                                values:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniq"}
                                    ],

                                values_caches:
                                    [
                                        {col:"subscriber", alias:"subscribers_uniq", func:"uniqState", func_cache:"uniqMerge"}
                                    ],

                                columns:
                                    [
                                        {
                                            id:"subscribers_uniq",
                                            header:[TooltipTemplate(LangHelper.GetString("QoE", "Subscribers")), ""],
                                            format:webix.i18n.intFormat,
                                            footer:{content:"totalColumn"},
                                            sort:"string"
                                        }
                                    ]
                            };
                        }
                    },

                    by_cell_id:function ()
                    {
                        return {
                            values:
                                [],

                            values_caches:
                                [],

                            rows:["cell_id"],

                            columns:
                                [
                                    {
                                        id:"cell_id", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell ID")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        sort:"string",
                                        fillspace:true,
                                        minWidth:160
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_cell_name:function ()
                    {
                        return {
                            values:
                                [],

                            values_caches:
                                [],

                            rows:["cell_name"],

                            columns:
                                [
                                    {
                                        id:"cell_name", header:[TooltipTemplate(LangHelper.GetString("QoE", "Cell name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        sort:"string",
                                        fillspace:true,
                                        minWidth:160
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_uli_mcc:function ()
                    {
                        return {
                            values:
                                [],

                            values_caches:
                                [],

                            rows:["uli_mcc"],

                            columns:
                                [
                                    {
                                        id:"uli_mcc", header:[TooltipTemplate(LangHelper.GetString("QoE", "Mobile country code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        sort:"string",
                                        fillspace:true,
                                        minWidth:160
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_uli_mnc:function ()
                    {
                        return {
                            values:
                                [],

                            values_caches:
                                [],

                            rows:["uli_mnc"],

                            columns:
                                [
                                    {
                                        id:"uli_mnc", header:[TooltipTemplate(LangHelper.GetString("QoE", "Mobile network (operator) code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        sort:"string",
                                        fillspace:true,
                                        minWidth:160
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_uli_tac:function ()
                    {
                        return {
                            values:
                                [],

                            values_caches:
                                [],

                            rows:["uli_tac"],

                            columns:
                                [
                                    {
                                        id:"uli_tac", header:[TooltipTemplate(LangHelper.GetString("QoE", "Service/Tracking area code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        sort:"string",
                                        fillspace:true,
                                        minWidth:160
                                    }
                                ],

                            leftSplit:2
                        };
                    },

                    by_uli_eci:function ()
                    {
                        return {
                            values:
                                [],

                            values_caches:
                                [],

                            rows:["uli_eci"],

                            columns:
                                [
                                    {
                                        id:"uli_eci", header:[TooltipTemplate(LangHelper.GetString("QoE", "Base station code")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                        sort:"string",
                                        fillspace:true,
                                        minWidth:160
                                    }
                                ],

                            leftSplit:2
                        };
                    },
                }
        };

    this.Views.Fullnetflow.Widgets =
    {
        DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "Fullnetflow" + "DateRangePicker"}),

        ExtendedFillter: new QoEPopupFilterWidget({
            id:this.Id + "Fullnetflow" + "ExtendedFillter",
            config:
                {
                    type:QoESubscribersFilterListItemTypeEnum.hist_subscribers_netflow,
                    filters:[
                        {
                            id:"host",
                            title:LangHelper.GetString("QoE", "Host"),
                            type:QoEFilterValueType.String
                        },
                        {
                            id:"host_category",
                            title:LangHelper.GetString("QoE", "Host category"),
                            type:QoEFilterValueType.UInt32,
                            operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                            editor:"multiselect",
                            dic:DicsEnum.HostCategoriesDic
                        },
                        {
                            id:"subscriber",
                            title:LangHelper.GetString("QoE", "Subscriber"),
                            type:QoEFilterValueType.String,
                            opertor_view:
                                {
                                    "in CIDRs":QoEReportViews.Subnets,
                                    "not in CIDRs":QoEReportViews.Subnets
                                },
                            can_cidr:true
                        },
                        {
                            id:"login",
                            title:LangHelper.GetString("QoE", "Login"),
                            type:QoEFilterValueType.String
                        },
                        {
                            id:"host_ip",
                            title:LangHelper.GetString("QoE", "Host IP"),
                            type:QoEFilterValueType.String,
                            opertor_view:
                                {
                                    "in CIDRs":QoEReportViews.Subnets,
                                    "not in CIDRs":QoEReportViews.Subnets
                                },
                            can_cidr:true
                        },
                        {
                            id:"bridge_vchannel",
                            title:LangHelper.GetString("QoE", "Vchannel/Bridge"),
                            type:"string"
                        },
                        {
                            id:"hosts_uniq",
                            title:LangHelper.GetString("QoE", "Hosts number"),
                            type:QoEFilterValueType.UInt32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"host_ip_uniq",
                            title:LangHelper.GetString("QoE", "Host IPs number"),
                            type:QoEFilterValueType.UInt32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"rtt_median",
                            title:LangHelper.GetString("QoE", "RTT"),
                            type:QoEFilterValueType.UInt32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"rtt_from_subscriber_median",
                            title:LangHelper.GetString("QoE", "RTT from subscriber"),
                            type:QoEFilterValueType.UInt32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"rtt_to_subscriber_median",
                            title:LangHelper.GetString("QoE", "RTT to subscriber"),
                            type:QoEFilterValueType.UInt32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"retransmits_avg",
                            title:LangHelper.GetString("QoE", "Retransmits"),
                            type:QoEFilterValueType.Float32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"fragments_avg",
                            title:LangHelper.GetString("QoE", "Fragments"),
                            type:QoEFilterValueType.String,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"traffic",
                            title:LangHelper.GetString("QoE", "Traffic"),
                            type:QoEFilterValueType.Float32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"traffic_from_subscriber",
                            title:LangHelper.GetString("QoE", "Traffic from subscriber"),
                            type:QoEFilterValueType.Float32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"traffic_to_subscriber",
                            title:LangHelper.GetString("QoE", "Traffic to subscriber"),
                            type:QoEFilterValueType.Float32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"net_protocol",
                            title:LangHelper.GetString("QoE", "Protocol"),
                            type:QoEFilterValueType.UInt32
                        },
                        {
                            id:"protocol",
                            title:LangHelper.GetString("QoE", "Application protocol"),
                            type:QoEFilterValueType.String
                        },
                        {
                            id:"source_asnum",
                            title:LangHelper.GetString("QoE", "Source AS number"),
                            type:QoEFilterValueType.UInt32
                        },
                        {
                            id:"destination_asnum",
                            title:LangHelper.GetString("QoE", "Destination AS number"),
                            type:QoEFilterValueType.UInt32
                        },
                        {
                            id:"sessons_uniq",
                            title: LangHelper.GetString("QoE", "Sessions"),
                            type:QoEFilterValueType.UInt32,
                            sql_type:QoEFilterSqlType.having
                        },
                        {
                            id:"blocked",
                            title:LangHelper.GetString("QoE", "Locked"),
                            type:QoEFilterValueType.UInt8,
                            operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                            editor:"richselect",
                            options:Helper.DictToArr(YesNoDic)
                        }
                    ],
                    default:[
                        {
                            f_enabled:0,
                            f_id:"host",
                            f_operator:QoEFilterOperatorsEnum.like
                        },
                        {
                            f_enabled:0,
                            f_id:"host_category",
                            f_operator:QoEFilterOperatorsEnum.in
                        },
                        {
                            f_enabled:0,
                            f_id:"subscriber",
                            f_operator:QoEFilterOperatorsEnum.like
                        },
                        {
                            f_enabled:0,
                            f_id:"login",
                            f_operator:QoEFilterOperatorsEnum.like
                        },
                        {
                            f_enabled:0,
                            f_id:"rtt_median",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled:0,
                            f_id:"rtt_from_subscriber_median",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled:0,
                            f_id:"rtt_to_subscriber_median",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled:0,
                            f_id:"retransmits_avg",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled:0,
                            f_id:"fragments_avg",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled:0,
                            f_id:"host_ip",
                            f_operator:QoEFilterOperatorsEnum.like
                        },
                        {
                            f_enabled:0,
                            f_id:"hosts_uniq",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled:0,
                            f_id:"host_ip_uniq",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled:0,
                            f_id:"net_protocol",
                            f_operator:QoEFilterOperatorsEnum.like
                        },
                        {
                            f_enabled:0,
                            f_id:"protocol",
                            f_operator:QoEFilterOperatorsEnum.like
                        },
                        {
                            f_enabled:0,
                            f_id:"source_asnum",
                            f_operator:QoEFilterOperatorsEnum.like
                        },
                        {
                            f_enabled:0,
                            f_id:"destination_asnum",
                            f_operator:QoEFilterOperatorsEnum.like
                        },
                        {
                            f_enabled:0,
                            f_id:"traffic",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled:0,
                            f_id:"traffic_from_subscriber",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled: 0,
                            f_id: "traffic_to_subscriber",
                            f_operator: QoEFilterOperatorsEnum[">="]
                        },
                        {
                            f_enabled:0,
                            f_id:"sessons_uniq",
                            f_operator:QoEFilterOperatorsEnum[">="]
                        }

                    ]
                }
        }),

        TopSubscribersReport: new QoETableReportWidget({
            //title:LangHelper.GetString("QoE", "Subscribers"),
            icon:"table",
            id:this.Id + "Fullnetflow" + "TopSubscribersReport",
            name:"QoETableTopRttSubscribersWidget",
            config:{
                type:QoEReportConfigTypeEnum.ClientPredefined,
                table:QoEReportTablesEnum.FullnetflowAgg,
                view:QoEReportViews.FullFlow,
                join:QoEReportViews.FullFlowSubsHwJoin,
                values: [],
                rows:[],
                sort:{id:"rtt_median",dir:"desc"},
                with_totals:true
            },
            footer:true,
            leftSplit:2,
            columns:[],
            export_title_callback:function ()
            {
                var selected = _this.FullnetflowGetFiltersTableSelectedData();

                return selected ? selected.title : "";
            },
            getReportKeyCallback: function ()
            {
                let items = [
                    _this.Id,
                    _this.Views.Fullnetflow.GroupByPicker.getValue(),
                    _this.Views.Fullnetflow.GroupByFieldPicker.getValue()
                ]

                return items.join("");
            }
        })
    };

    this.Views.Fullnetflow.SubWidgets =
    {
        RttDistribution: QoERttDistributionWidget({id:this.Id + "Fullnetflow" + "RttDistribution", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        RttByTime: QoERttByTimeWidget({id:this.Id + "Fullnetflow" + "RttByTime", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        RetransmitsByTime: QoESeriesChartRetransmitsByTimeWidget({id:this.Id + "Fullnetflow" + "RetransmitsByTime", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopProtocolsReport: QoETableNetflowTopProtocolsWidget({id:this.Id + "Fullnetflow" + "TopProtocolsReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopProtocolsGroupsReport: QoETableNetflowTopProtocolsGroupsWidget({id:this.Id + "Fullnetflow" + "TopProtocolsGroupsReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopHostsReport: QoETableNetflowTopHostsWidget({id:this.Id + "Fullnetflow" + "TopHostsReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopHostCatsReport: QoETableNetflowTopHostCategoriesWidget({id:this.Id + "Fullnetflow" + "TopHostCatsReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopHostsIPsReport: QoETableNetflowTopHostsIPsWidget({id:this.Id + "Fullnetflow" + "TopHostsIPsReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopRttSubscribersReport: QoETableTopRttSubscribersWidget({id:this.Id + "Fullnetflow" + "TopRttSubscribersReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopASsReport: QoETableNetflowTopASsWidget({id:this.Id + "Fullnetflow" + "TopASsReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopSubscriberASsReport: QoETableNetflowTopSubscriberASsWidget({id:this.Id + "Fullnetflow" + "TopSubscriberASsReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopSwitchesReport: QoETableNetflowTopAccessSwitchesWidget({id:this.Id + "Fullnetflow" + "TopSwitchesReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopTrunkSwitchesReport: QoETableNetflowTopTrunkSwitchesWidget({id:this.Id + "Fullnetflow" + "TopTrunkSwitchesReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),

        TopVchannelsReport: QoETableTopVchannelsWidget({id:this.Id + "Fullnetflow" + "TopVchannelsReport", no_title:true, view:QoEReportViews.FullFlowJoinedWithSubsHw}),
    };


    if(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.advc))
    {
        this.Views.Widgets.QoEAdvcWizardWidget = new QoEAdvcWizardWidget({
            id:this.Id + "QoEAdvcWizardWidget"
        });
    }


    this.SectionsEnum = {
        cs:this.Id + "SectionsTabs" + "Clickstream",
        ff:this.Id + "SectionsTabs" + "Fullnetflow"
    };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Subscribers")}),
                                {
                                    view: "tabbar",
                                    id: this.Id + "SectionsTabs",
                                    borderless:true,
                                    multiview:true,
                                    height:40,
                                    options:
                                    [
                                        {
                                            id:this.Id + "SectionsTabs" + "Clickstream",
                                            value:LangHelper.GetString("AppView", "Clickstream"),
                                            width:200
                                        },
                                        {
                                            id:this.Id + "SectionsTabs" + "Fullnetflow",
                                            value:LangHelper.GetString("AppView", "Netflow"),
                                            width:200
                                        }
                                    ]
                                },
                                {
                                    cells:
                                        [
                                            {
                                                id:this.Id + "SectionsTabs" + "Clickstream",
                                                rows:
                                                    [
                                                        {height: 16},
                                                        {
                                                            view: "toolbar",
                                                            elements: [
                                                                // {
                                                                //     view:"daterangepicker",
                                                                //     id:this.Id + "SectionsTabs" + "Clickstream" + "PeriodPicker",
                                                                //     name:"period",
                                                                //     label:LangHelper.GetString("QoE", "Period"),
                                                                //     value:{start: webix.Date.dayStart(new Date()), end: webix.Date.dayStart(new Date())},
                                                                //     timepicker:true
                                                                // },
                                                                this.Views.Clickstream.Widgets.DateRangePicker.ViewConfig,
                                                                {
                                                                    view:"multiselect",
                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "DpiPicker",
                                                                    value:"-2",
                                                                    maxWidth:320,
                                                                    optionWidth:320,
                                                                    tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                                                    options:[]
                                                                },
                                                                {
                                                                    view:"richselect",
                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "ExecTimeSelector",
                                                                    value:600,
                                                                    maxWidth:120,
                                                                    optionWidth:320,
                                                                    tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                                    options:[
                                                                        {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                                        {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                                        {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                                        {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                                        {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                                        {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                                        {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                                        {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                                        {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                                        {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                                    ]
                                                                },
                                                                this.Views.Clickstream.Widgets.ExtendedFillter.ViewConfig,
                                                                {
                                                                    view: "button",
                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "AddCampaign",
                                                                    type: "icon",
                                                                    icon: "bullhorn ",
                                                                    css: "toolbar_round_btn",
                                                                    width: 48,
                                                                    tooltip: LangHelper.GetString("QoESubscribers", "Add subscribers to campaign"),
                                                                    badge: 0,
                                                                    enabled: App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.advc),
                                                                    click: function (id, e, node)
                                                                    {
                                                                        _this.ShowQoEAdvcWizardWidget(this.getNode(),"bottom");
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        },
                                                        {
                                                            view: "accordion",
                                                            multi: "mixed",
                                                            cols:[
                                                                {
                                                                    header: LangHelper.GetString("QoE","Reports"),
                                                                    id: this.Id + "Clickstream" + "TopSubscribersReportAi",
                                                                    gravity:5,
                                                                    body:
                                                                        {
                                                                            cols:
                                                                                [
                                                                                    this.Views.Clickstream.FiltersTableWidget.ViewConfig,
                                                                                    {view:"resizer"},
                                                                                    {
                                                                                        gravity:2,
                                                                                        id:this.Id + "SectionsTabs" + "Clickstream" + "MasterPanel",
                                                                                        rows:
                                                                                            [
                                                                                                {
                                                                                                    view: "toolbar",
                                                                                                    height: 32,
                                                                                                    elements: [
                                                                                                        {},
                                                                                                        {
                                                                                                            view: "button",
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "RefreshSubscribersBtn",
                                                                                                            type: "icon",
                                                                                                            icon: "refresh",
                                                                                                            css: "toolbar_round_btn",
                                                                                                            width: 32,
                                                                                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                                                                            click: function (id, e, node)
                                                                                                            {
                                                                                                                _this.RefreshSubscribers();
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            width: 16
                                                                                                        },
                                                                                                        QoEKillProcessesBtnWidget({
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "KillAllProcessesBtn",
                                                                                                            restricted:{"KillCurrentReportProcesses":1, "KillAllSectionReportsProcesses":1},
                                                                                                            callback:function (Id)
                                                                                                            {
                                                                                                                _this.KillProcesses(Id);
                                                                                                            }
                                                                                                        }),
                                                                                                        QoEClearCacheBtnWidget({
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "ClearCacheBtn",
                                                                                                            restricted:{"ClearCurrentReportCache":1, "ClearAllSectionReports":1},
                                                                                                            callback:function (Id)
                                                                                                            {
                                                                                                                _this.ClearCache(Id);
                                                                                                            }
                                                                                                        })
                                                                                                    ]
                                                                                                },
                                                                                                this.Views.Clickstream.Widgets.TopSubscribersReport.ViewConfig
                                                                                            ]
                                                                                    }
                                                                                ]
                                                                        }
                                                                },
                                                                {view:"resizer"},
                                                                {
                                                                    header: LangHelper.GetString("QoE","Details"),
                                                                    id: this.Id + "Clickstream" + "DetailsPanelAi",
                                                                    gravity:4,
                                                                    collapsed:false,
                                                                    body:
                                                                        {
                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanel",
                                                                            rows:
                                                                                [
                                                                                    {
                                                                                        view: "toolbar",
                                                                                        height: 56,
                                                                                        elements: [
                                                                                            {
                                                                                                view: "tabbar",
                                                                                                id: this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs",
                                                                                                multiview: true,
                                                                                                tabMinWidth:240,
                                                                                                tabMoreWidth:80,
                                                                                                borderless:true,
                                                                                                options:
                                                                                                    [
                                                                                                        {
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopSubscriberDevicesReportTab",
                                                                                                            value:LangHelper.GetString("QoE", "Devices")
                                                                                                        },
                                                                                                        {
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopSubscriberAgentsReportTab",
                                                                                                            value:LangHelper.GetString("QoE", "Agents")
                                                                                                        },
                                                                                                        {
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopHostsReportTab",
                                                                                                            value:LangHelper.GetString("QoE", "Hosts")
                                                                                                        },
                                                                                                        {
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopHostCatsReportTab",
                                                                                                            value:LangHelper.GetString("QoE", "Host categories")
                                                                                                        },
                                                                                                        {
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopHostsIpsReportTab",
                                                                                                            value:LangHelper.GetString("QoE", "Hosts IPs")
                                                                                                        },
                                                                                                        {
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopUrlsReportTab",
                                                                                                            value:LangHelper.GetString("QoE", "URLs")
                                                                                                        },
                                                                                                        {
                                                                                                            id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopVchannelsReportTab",
                                                                                                            value:LangHelper.GetString("QoE", "Vchannels")
                                                                                                        }
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                view: "button",
                                                                                                id:this.Id+"RefreshSubscriberDetailsBtn",
                                                                                                type: "icon",
                                                                                                icon: "refresh",
                                                                                                css: "toolbar_round_btn",
                                                                                                width: 32,
                                                                                                tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                                                                click: function (id, e, node)
                                                                                                {
                                                                                                    _this.RefreshSubscriberDetails();
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        cells:
                                                                                            [
                                                                                                {
                                                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopSubscriberDevicesReportTab",
                                                                                                    rows:
                                                                                                        [
                                                                                                            this.Views.Clickstream.SubWidgets.TopSubscriberDevicesReport.ViewConfig
                                                                                                        ]
                                                                                                },
                                                                                                {
                                                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopSubscriberAgentsReportTab",
                                                                                                    rows:
                                                                                                        [
                                                                                                            this.Views.Clickstream.SubWidgets.TopSubscriberAgentsReport.ViewConfig
                                                                                                        ]
                                                                                                },
                                                                                                {
                                                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopHostsReportTab",
                                                                                                    rows:
                                                                                                        [
                                                                                                            this.Views.Clickstream.SubWidgets.TopHostsReport.ViewConfig
                                                                                                        ]
                                                                                                },
                                                                                                {
                                                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopHostCatsReportTab",
                                                                                                    rows:
                                                                                                        [
                                                                                                            this.Views.Clickstream.SubWidgets.TopHostCatsReport.ViewConfig
                                                                                                        ]
                                                                                                },
                                                                                                {
                                                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopHostsIpsReportTab",
                                                                                                    rows:
                                                                                                        [
                                                                                                            this.Views.Clickstream.SubWidgets.TopHostsIpsReport.ViewConfig
                                                                                                        ]
                                                                                                },
                                                                                                {
                                                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopUrlsReportTab",
                                                                                                    rows:
                                                                                                        [
                                                                                                            this.Views.Clickstream.SubWidgets.TopUrlsReport.ViewConfig
                                                                                                        ]
                                                                                                },
                                                                                                {
                                                                                                    id:this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + "TopVchannelsReportTab",
                                                                                                    rows:
                                                                                                        [
                                                                                                            this.Views.Clickstream.SubWidgets.TopVchannelsReport.ViewConfig
                                                                                                        ]
                                                                                                }
                                                                                            ]
                                                                                    }
                                                                                ]
                                                                        }
                                                                },
                                                                {
                                                                    gravity:0
                                                                }
                                                            ]
                                                        }
                                                    ]
                                            },
                                            {
                                                id:this.Id + "SectionsTabs" + "Fullnetflow",
                                                rows:
                                                    [
                                                        {height: 16},
                                                        {
                                                            view: "toolbar",
                                                            elements: [
                                                                // {
                                                                //     view:"daterangepicker",
                                                                //     id:this.Id + "SectionsTabs" + "Fullnetflow" + "PeriodPicker",
                                                                //     name:"period",
                                                                //     label:LangHelper.GetString("QoE", "Period"),
                                                                //     value:{start: webix.Date.dayStart(new Date()), end: webix.Date.dayStart(new Date())},
                                                                //     timepicker:true
                                                                // },
                                                                this.Views.Fullnetflow.Widgets.DateRangePicker.ViewConfig,
                                                                {
                                                                    view:"multiselect",
                                                                    id:this.Id + "SectionsTabs" + "Fullnetflow" + "DpiPicker",
                                                                    value:"-2",
                                                                    maxWidth:320,
                                                                    optionWidth:320,
                                                                    tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                                                    options:[]
                                                                },
                                                                {
                                                                    view:"richselect",
                                                                    id:this.Id + "SectionsTabs" + "Fullnetflow" + "ExecTimeSelector",
                                                                    value:600,
                                                                    maxWidth:120,
                                                                    optionWidth:320,
                                                                    tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                                    options:[
                                                                        {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                                        {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                                        {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                                        {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                                        {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                                        {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                                        {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                                        {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                                        {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                                        {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                                    ]
                                                                },
                                                                this.Views.Fullnetflow.Widgets.ExtendedFillter.ViewConfig,
                                                                {
                                                                    view: "button",
                                                                    id:this.Id + "SectionsTabs" + "Fullnetflow" + "AddCampaign",
                                                                    type: "icon",
                                                                    icon: "bullhorn ",
                                                                    css: "toolbar_round_btn",
                                                                    width: 48,
                                                                    tooltip: LangHelper.GetString("QoESubscribers", "Add subscribers to campaign"),
                                                                    badge: 0,
                                                                    enabled: App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.advc),
                                                                    click: function (id, e, node)
                                                                    {
                                                                        _this.ShowQoEAdvcWizardWidget(this.getNode(),"bottom");
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        },
                                                        {
                                                            view: "accordion",
                                                            multi: "mixed",
                                                            cols:[
                                                                {
                                                                    header: LangHelper.GetString("QoE","Reports"),
                                                                    id: this.Id + "Fullnetflow" + "TopSubscribersReportAi",
                                                                    gravity:6,
                                                                    body:
                                                                        {
                                                                            cols:
                                                                                [
                                                                                    this.Views.Fullnetflow.FiltersTableWidget.ViewConfig,
                                                                                    {view:"resizer"},
                                                                                    {
                                                                                        gravity:2,
                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "MasterPanel",
                                                                                        rows:
                                                                                            [
                                                                                                {
                                                                                                    view: "toolbar",
                                                                                                    height: 56,
                                                                                                    elements: [
                                                                                                        {
                                                                                                            view:"richselect",
                                                                                                            id:this.Id + "SectionsTabs" + "Fullnetflow" + "GroupByPicker",
                                                                                                            value:"by_subscribers",
                                                                                                            labelWidth:120,
                                                                                                            minWidth:280,
                                                                                                            label:LangHelper.GetString("QoE", "Group by"),
                                                                                                            options: this.Views.Fullnetflow.GroupByPickerOptions
                                                                                                        },
                                                                                                        {
                                                                                                            view:"richselect",
                                                                                                            id:this.Id + "SectionsTabs" + "Fullnetflow" + "GroupBySwitchTypePicker",
                                                                                                            value:"1",
                                                                                                            minWidth:160,
                                                                                                            hidden:true,
                                                                                                            options: this.Views.Fullnetflow.GroupByFieldPickerOptions.by_switches_types
                                                                                                        },
                                                                                                        {
                                                                                                            view:"richselect",
                                                                                                            id:this.Id + "SectionsTabs" + "Fullnetflow" + "GroupByFieldPicker",
                                                                                                            value:"by_ip",
                                                                                                            minWidth:160,
                                                                                                            options: this.Views.Fullnetflow.GroupByFieldPickerOptions.by_subscribers
                                                                                                        },
                                                                                                        // {
                                                                                                        //     view: "tabbar",
                                                                                                        //     id: this.Id + "SectionsTabs" + "Fullnetflow" + "MasterPanelTabs",
                                                                                                        //     multiview: true,
                                                                                                        //     height:24,
                                                                                                        //     borderless:true,
                                                                                                        //     tabMinWidth:240,
                                                                                                        //     tabMoreWidth:80,
                                                                                                        //     options:
                                                                                                        //         [
                                                                                                        //             {
                                                                                                        //                 id:this.Id + "SectionsTabs" + "Fullnetflow" + "MasterPanelTabs" + "TopSubscribersReportTab",
                                                                                                        //                 value:LangHelper.GetString("QoE", "Subscribers")
                                                                                                        //             },
                                                                                                        //             {
                                                                                                        //                 id:this.Id + "SectionsTabs" + "Fullnetflow" + "MasterPanelTabs" + "TopHwsReportTab",
                                                                                                        //                 value:LangHelper.GetString("QoE", "Access switches")
                                                                                                        //             }
                                                                                                        //         ]
                                                                                                        // },
                                                                                                        {},
                                                                                                        {
                                                                                                            view: "button",
                                                                                                            id:this.Id + "SectionsTabs" + "Fullnetflow" + "RefreshSubscribersBtn",
                                                                                                            type: "icon",
                                                                                                            icon: "refresh",
                                                                                                            css: "toolbar_round_btn",
                                                                                                            width: 32,
                                                                                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                                                                            click: function (id, e, node)
                                                                                                            {
                                                                                                                _this.FullnetflowRefreshSubscribers();
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            width: 16
                                                                                                        },
                                                                                                        QoEKillProcessesBtnWidget({
                                                                                                            id:this.Id + "SectionsTabs" + "Fullnetflow" + "KillAllProcessesBtn",
                                                                                                            restricted:{"KillCurrentReportProcesses":1, "KillAllSectionReportsProcesses":1},
                                                                                                            callback:function (Id)
                                                                                                            {
                                                                                                                _this.KillProcesses(Id);
                                                                                                            }
                                                                                                        }),
                                                                                                        QoEClearCacheBtnWidget({
                                                                                                            id:this.Id + "SectionsTabs" + "Fullnetflow" + "ClearCacheBtn",
                                                                                                            restricted:{"ClearCurrentReportCache":1, "ClearAllSectionReports":1},
                                                                                                            callback:function (Id)
                                                                                                            {
                                                                                                                _this.ClearCache(Id);
                                                                                                            }
                                                                                                        })
                                                                                                    ]
                                                                                                },
                                                                                                this.Views.Fullnetflow.Widgets.TopSubscribersReport.ViewConfig
                                                                                                // {
                                                                                                //     cells:
                                                                                                //     [
                                                                                                //         {
                                                                                                //             id:this.Id + "SectionsTabs" + "Fullnetflow" + "MasterPanelTabs" + "TopSubscribersReportTab",
                                                                                                //             rows:
                                                                                                //                 [
                                                                                                //                     this.Views.Fullnetflow.Widgets.TopSubscribersReport.ViewConfig
                                                                                                //                 ]
                                                                                                //         },
                                                                                                //         {
                                                                                                //             id:this.Id + "SectionsTabs" + "Fullnetflow" + "MasterPanelTabs" + "TopHwsReportTab",
                                                                                                //             rows:
                                                                                                //                 [
                                                                                                //                     this.Views.Fullnetflow.Widgets.TopSwitchesReport.ViewConfig
                                                                                                //                 ]
                                                                                                //         }
                                                                                                //     ]
                                                                                                // }
                                                                                            ]
                                                                                    }
                                                                                ]
                                                                        }
                                                                },
                                                                {view:"resizer"},
                                                                {
                                                                    header: LangHelper.GetString("QoE","Details"),
                                                                    id: this.Id + "Fullnetflow" + "DetailsPanelAi",
                                                                    gravity:4,
                                                                    collapsed:false,
                                                                    body:
                                                                    {
                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanel",
                                                                        rows:
                                                                            [
                                                                                {
                                                                                    view: "toolbar",
                                                                                    height: 56,
                                                                                    elements: [
                                                                                        {
                                                                                            view: "tabbar",
                                                                                            id: this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs",
                                                                                            multiview: true,
                                                                                            borderless:true,
                                                                                            tabMinWidth:240,
                                                                                            tabMoreWidth:80,
                                                                                            options:
                                                                                                [
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "RttDistributionTab",
                                                                                                        value:LangHelper.GetString("QoE", "RTT distribution")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "RttByTimeTab",
                                                                                                        value:LangHelper.GetString("QoE", "RTT by time")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "RetransmitsByTimeTab",
                                                                                                        value:LangHelper.GetString("QoE", "Retransmits by time")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopProtocolsReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top protocols")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopProtocolsGroupsReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top protocols groups")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopHostsReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top hosts")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopHostCatsReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top host categories")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopHostsIPsReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top hosts IPs")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopRttSubscribersReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top subscribers")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopASsReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top AS")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopSubscriberASsReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top subscriber`s AS")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopSwitchesReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top switches")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopTrunkSwitchesReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top trunk switches")
                                                                                                    },
                                                                                                    {
                                                                                                        id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopVchannelsReportTab",
                                                                                                        value:LangHelper.GetString("QoE", "Top vchannels")
                                                                                                    }
                                                                                                ]
                                                                                        },
                                                                                        {
                                                                                            view: "button",
                                                                                            id:this.Id + "Fullnetflow" + "RefreshSubscriberDetailsBtn",
                                                                                            type: "icon",
                                                                                            icon: "refresh",
                                                                                            css: "toolbar_round_btn",
                                                                                            width: 32,
                                                                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                                                            click: function (id, e, node)
                                                                                            {
                                                                                                _this.FullnetflowRefreshSubscriberDetails();
                                                                                            }
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    cells:
                                                                                        [
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "RttDistributionTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.RttDistribution.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "RttByTimeTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.RttByTime.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "RetransmitsByTimeTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.RetransmitsByTime.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopProtocolsReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopProtocolsReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopProtocolsGroupsReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopProtocolsGroupsReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopHostsReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopHostsReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopHostCatsReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopHostCatsReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopHostsIPsReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopHostsIPsReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopRttSubscribersReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopRttSubscribersReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopASsReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopASsReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopSubscriberASsReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopSubscriberASsReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopSwitchesReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopSwitchesReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopTrunkSwitchesReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopTrunkSwitchesReport.ViewConfig
                                                                                                    ]
                                                                                            },
                                                                                            {
                                                                                                id:this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + "TopVchannelsReportTab",
                                                                                                rows:
                                                                                                    [
                                                                                                        this.Views.Fullnetflow.SubWidgets.TopVchannelsReport.ViewConfig
                                                                                                    ]
                                                                                            }
                                                                                        ]
                                                                                }
                                                                            ]
                                                                    }
                                                                },
                                                                {
                                                                    gravity:0
                                                                }
                                                            ]
                                                        }
                                                    ]
                                            }
                                        ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
};

QoESubscribersViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoESubscribers");
    });

    this.BindAll(PathParams);

    this.FullnetflowReconfigSubscribers();

    //this.Views.Widgets.QoEAdvcWizardWidget.Show(this.Views.Clickstream.AddCampaign.getNode(),"bottom");

    this.CheckQoEStorVersionCompatibility();
};

QoESubscribersViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.SectionsTabs = $$(this.Id + "SectionsTabs");

    // this.Views.Clickstream.PeriodPicker = $$(this.Id + "SectionsTabs" + "Clickstream" + "PeriodPicker");
    //
    // var date_from = Helper.RoundDateToMinutes(new Date());
    // var date_to = Helper.RoundDateToMinutes(new Date());
    // this.Views.Clickstream.PeriodPicker.setValue({start:webix.Date.add(date_from,-6,"hour"), end:webix.Date.add(date_to,1,"hour")});
    //this.Views.Clickstream.PeriodPicker.setValue({start:webix.Date.add(date_from,-1,"month"), end:webix.Date.add(date_to,1,"hour")});

    this.Views.Clickstream.DpiPicker = $$(this.Id + "SectionsTabs" + "Clickstream" + "DpiPicker");

    this.Views.Clickstream.ExecTimeSelector = $$(this.Id + "SectionsTabs" + "Clickstream" + "ExecTimeSelector");

    this.Views.Clickstream.AddCampaign = $$(this.Id + "SectionsTabs" + "Clickstream" + "AddCampaign");

    this.Views.Clickstream.DetailsPanel = $$(this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanel");

    this.Views.Clickstream.MasterPanel = $$(this.Id + "SectionsTabs" + "Clickstream" + "MasterPanel");

    this.Views.Clickstream.DetailsPanelTabs = $$(this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs");

    Object.keys(this.Views.Clickstream.Widgets).forEach(function (Key)
    {
        _this.Views.Clickstream.Widgets[Key].Bind(_this);
    });

    this.Views.Clickstream.Widgets.DateRangePicker.SetValue(null,true);

    Object.keys(this.Views.Clickstream.SubWidgets).forEach(function (Key)
    {
        _this.Views.Clickstream.SubWidgets[Key].Bind(_this);
    });

    this.Views.Clickstream.FiltersTableWidget.Bind(this, null, this.Views.Clickstream.Widgets.ExtendedFillter);

    // this.Views.Clickstream.PeriodPicker.attachEvent("onChange", function(Period)
    // {
    //     _this.RefreshSubscribers();
    // });

    this.Subscriptions.ClickstreamDateRangePicker = this.Views.Clickstream.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshSubscribers();
        }

    });

    this.Views.Clickstream.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshSubscribers();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Clickstream.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            var selectedFilter = _this.Views.Clickstream.FiltersTableWidget.GetTableSelectedData();

            if(selectedFilter)
                _this.Views.Clickstream.FiltersTableWidget.SaveFilter();
        }

    });

    this.Subscriptions.FiltersTableRowsSelectedCountSubscription = this.Views.Clickstream.FiltersTableWidget.TableRowsSelectedCount.subscribe(function (Value)
    {
        _this.ClickstreamFiltersTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.SubscribersTableRowsSelectedCountSubscription = this.Views.Clickstream.Widgets.TopSubscribersReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        _this.SubscribersTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Views.Clickstream.DetailsPanelTabs.attachEvent("onChange", function(New, Old)
    {
        _this.RefreshSubscriberDetails();
    });

    // this.Views.Fullnetflow.PeriodPicker = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "PeriodPicker");
    //
    // var date_from = Helper.RoundDateToMinutes(new Date());
    // var date_to = Helper.RoundDateToMinutes(new Date());
    // this.Views.Fullnetflow.PeriodPicker.setValue({start:webix.Date.add(date_from,-6,"hour"), end:webix.Date.add(date_to,1,"hour")});
    //this.Views.Fullnetflow.PeriodPicker.setValue({start:webix.Date.add(date_from,-1,"month"), end:webix.Date.add(date_to,1,"hour")});

    this.Views.Fullnetflow.DpiPicker = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "DpiPicker");

    this.Views.Fullnetflow.ExecTimeSelector = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "ExecTimeSelector");

    this.Views.Fullnetflow.GroupByPicker = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "GroupByPicker");

    this.Views.Fullnetflow.GroupBySwitchTypePicker = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "GroupBySwitchTypePicker");

    this.Views.Fullnetflow.GroupByFieldPicker = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "GroupByFieldPicker");

    this.Views.Fullnetflow.AddCampaign = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "AddCampaign");

    this.Views.Fullnetflow.DetailsPanel = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanel");

    this.Views.Fullnetflow.MasterPanel = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "MasterPanel");

    this.Views.Fullnetflow.DetailsPanelTabs = $$(this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs");

    Object.keys(this.Views.Fullnetflow.Widgets).forEach(function (Key)
    {
        _this.Views.Fullnetflow.Widgets[Key].Bind(_this);
    });

    this.Views.Fullnetflow.Widgets.DateRangePicker.SetValue(null,true);

    Object.keys(this.Views.Fullnetflow.SubWidgets).forEach(function (Key)
    {
        _this.Views.Fullnetflow.SubWidgets[Key].Bind(_this);
    });

    this.Views.Fullnetflow.FiltersTableWidget.Bind(this, null, this.Views.Fullnetflow.Widgets.ExtendedFillter);

    // this.Views.Fullnetflow.PeriodPicker.attachEvent("onChange", function(Period)
    // {
    //     _this.FullnetflowRefreshSubscribers();
    // });

    this.Subscriptions.FullnetflowDateRangePicker = this.Views.Fullnetflow.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.FullnetflowRefreshSubscribers();
        }

    });

    this.Views.Fullnetflow.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.FullnetflowRefreshSubscribers();
    });

    this.Subscriptions.FullnetflowExtendedFilterApplySignal = this.Views.Fullnetflow.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            var selectedFilter = _this.Views.Fullnetflow.FiltersTableWidget.GetTableSelectedData();

            if(selectedFilter)
                _this.Views.Fullnetflow.FiltersTableWidget.SaveFilter();
        }

    });

    this.Views.Fullnetflow.GroupByPicker.attachEvent("onChange", function(Val)
    {
        var list = _this.Views.Fullnetflow.GroupByFieldPicker.getList();
        list.clearAll();
        list.parse(_this.Views.Fullnetflow.GroupByFieldPickerOptions[Val]);

        if(Val == "by_as")
            _this.Views.Fullnetflow.GroupByFieldPicker.setValue("by_source_asnum");
        else if(Val == "by_gtp")
            _this.Views.Fullnetflow.GroupByFieldPicker.setValue("by_cell_id");
        else
            _this.Views.Fullnetflow.GroupByFieldPicker.setValue("by_ip");

        _this.Views.Fullnetflow.GroupBySwitchTypePicker.setValue("1");

        if(Val == "by_switches")
            _this.Views.Fullnetflow.GroupBySwitchTypePicker.show();
        else
            _this.Views.Fullnetflow.GroupBySwitchTypePicker.hide();

        _this.FullnetflowReconfigSubscribers();
        _this.FullnetflowRefreshSubscribers();
        _this.CheckCanFullflowAddCampaignBtnBeEnabled();
    });

    this.Views.Fullnetflow.GroupBySwitchTypePicker.attachEvent("onChange", function(Val)
    {
        _this.FullnetflowReconfigSubscribers();
        _this.FullnetflowRefreshSubscribers();
    });

    this.Views.Fullnetflow.GroupByFieldPicker.attachEvent("onChange", function(Val)
    {
        _this.FullnetflowReconfigSubscribers();
        _this.FullnetflowRefreshSubscribers();
        _this.CheckCanFullflowAddCampaignBtnBeEnabled();
    });

    this.Subscriptions.FullnetflowFiltersTableRowsSelectedCountSubscription = this.Views.Fullnetflow.FiltersTableWidget.TableRowsSelectedCount.subscribe(function (Value)
    {
        _this.FullnetflowFiltersTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.FullnetflowSubscribersTableRowsSelectedCountSubscription = this.Views.Fullnetflow.Widgets.TopSubscribersReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        _this.FullnetflowSubscribersTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Views.Fullnetflow.DetailsPanelTabs.attachEvent("onChange", function(New, Old)
    {
        _this.FullnetflowRefreshSubscriberDetails();
    });

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate("Fullnetflow");
            _this.DpiPickerOptionsUpdate("Clickstream");
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic]
        // ,
        // this.Views.Clickstream.Widgets.ExtendedFillter.FilterReadySignal,
        // this.Views.Fullnetflow.Widgets.ExtendedFillter.FilterReadySignal
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2]/* && Val[3] && Val[4]*/)
            {
                _this.Views.Clickstream.FiltersTableWidget.RefreshTable(0);

                _this.Views.Fullnetflow.FiltersTableWidget.RefreshTable(0);
            }
        }
    );

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        _this.Views.Widgets[Key].Bind(_this);
    });

    this.GetAllPathParam();
};

QoESubscribersViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Clickstream.Widgets).forEach(function (key)
    {
        _this.Views.Clickstream.Widgets[key].Destroy();
    });

    Object.keys(this.Views.Clickstream.SubWidgets).forEach(function (key)
    {
        _this.Views.Clickstream.SubWidgets[key].Destroy();
    });

    Object.keys(this.Views.Fullnetflow.Widgets).forEach(function (key)
    {
        _this.Views.Fullnetflow.Widgets[key].Destroy();
    });

    Object.keys(this.Views.Fullnetflow.SubWidgets).forEach(function (key)
    {
        _this.Views.Fullnetflow.SubWidgets[key].Destroy();
    });


    this.Views.Clickstream.FiltersTableWidget.Destroy();
    this.Views.Fullnetflow.FiltersTableWidget.Destroy();

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoESubscribersViewController.prototype.GetCurrentFilterParams = function ()
{
    //var period = this.Views.Clickstream.PeriodPicker.getValue();

    var period = this.Views.Clickstream.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Clickstream.Widgets.ExtendedFillter.GetFilters();

    filter = webix.extend(filter, extendedFilters, true);

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    return {filter:filter, max_execution_time: parseInt(this.Views.Clickstream.ExecTimeSelector.getValue())};
};

QoESubscribersViewController.prototype.RefreshSubscribers = function ()
{
    var selected = this.Views.Clickstream.FiltersTableWidget.GetTableSelectedData();

    if(!selected)
        return;

    var period = this.Views.Clickstream.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var _this = this;

    var params = this.GetCurrentFilterParams();

    Object.keys(this.Views.Clickstream.Widgets).forEach(function (Key) {
        if(_this.Views.Clickstream.Widgets[Key].RefreshData)
            _this.Views.Clickstream.Widgets[Key].RefreshData(0, params);
    });

    _this.SetAllPathParam();
};

QoESubscribersViewController.prototype.RefreshSubscriberDetails = function ()
{
    var _this = this;

    //var period = this.Views.Clickstream.PeriodPicker.getValue();

    var period = this.Views.Clickstream.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Clickstream.Widgets.ExtendedFillter.GetFilters();

    Object.keys(extendedFilters).forEach(function (Key)
    {
        if(extendedFilters[Key].sql_type == QoEFilterSqlType.having)
            delete extendedFilters[Key];
    });

    filter = webix.extend(filter, extendedFilters, true);

    var selectedSubscribers = this.GetSubscribersTableSelectedData();

    if(selectedSubscribers && selectedSubscribers.subscriber)
    {
        var subsFilter = {};

        var obj =
        {
            id:"subscriber",
            operator:"=",
            value:selectedSubscribers.subscriber
        };

        var hash = Helper.HashCode(JSON.stringify(obj));

        subsFilter[hash] = obj;

        filter = webix.extend(filter, subsFilter, true);
    }

    var params = {filter:filter, max_execution_time: parseInt(this.Views.Clickstream.ExecTimeSelector.getValue())};

    var tabId = this.Views.Clickstream.DetailsPanelTabs.getValue();

    Object.keys(this.Views.Clickstream.SubWidgets).every(function (Key)
    {
        if(tabId == _this.Id + "SectionsTabs" + "Clickstream" + "DetailsPanelTabs" + Key + "Tab" && _this.Views.Clickstream.SubWidgets[Key].RefreshData)
        {
            _this.Views.Clickstream.SubWidgets[Key].RefreshData(0, params);

            return false;
        }

        return true;
    });
};

QoESubscribersViewController.prototype.GetFiltersTableSelectedData = function ()
{
    return this.Views.Clickstream.FiltersTableWidget.GetTableSelectedData();
};

QoESubscribersViewController.prototype.GetSubscribersTableSelectedData = function ()
{
    return this.Views.Clickstream.Widgets.TopSubscribersReport.GetSelectedData();
};

QoESubscribersViewController.prototype.SubscribersTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    var _this = this;

    var _disableAll = function ()
    {
        _this.Views.Clickstream.DetailsPanel.disable();
    };

    if(Value != 1)
    {
        _disableAll();
        return;
    }

    var selectedData = _this.GetSubscribersTableSelectedData();

    if(!selectedData)
    {
        _disableAll();
        return;
    }

    if(selectedData)
    {
        this.RefreshSubscriberDetails();
        this.Views.Clickstream.DetailsPanel.enable();
    }
};

QoESubscribersViewController.prototype.ClickstreamFiltersTableRowsSelectedCountSubscriptionHandler = function (Value)
{
    var _this = this;

    var _disableAll = function ()
    {
        _this.Views.Clickstream.MasterPanel.disable();
        _this.Views.Clickstream.AddCampaign.disable();
    };

    if(Value != 1)
    {
        _disableAll();
        return;
    }

    var selectedData = _this.Views.Clickstream.FiltersTableWidget.GetTableSelectedData();

    if(!selectedData)
    {
        _disableAll();
        return;
    }

    if(selectedData.filter_id)
    {
        this.RefreshSubscribers();
        _this.Views.Clickstream.MasterPanel.enable();
        _this.Views.Clickstream.AddCampaign.enable();
    }
};

QoESubscribersViewController.prototype.FullnetflowGetCurrentFilterParams = function ()
{
    //var period = this.Views.Fullnetflow.PeriodPicker.getValue();

    var period = this.Views.Fullnetflow.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Fullnetflow.Widgets.ExtendedFillter.GetFilters();

    filter = webix.extend(filter, extendedFilters, true);

    var dpiFilter = this.GetDpiPickerState(true);

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

   return {filter:filter, max_execution_time: parseInt(this.Views.Fullnetflow.ExecTimeSelector.getValue())};
};

QoESubscribersViewController.prototype.FullnetflowReconfigSubscribers = function ()
{
    var _this = this;

    var groupBy = this.Views.Fullnetflow.GroupByPicker.getValue();

    var groupBySwitchType = this.Views.Fullnetflow.GroupBySwitchTypePicker.getValue();

    var groupByField = this.Views.Fullnetflow.GroupByFieldPicker.getValue();

    var conf = this.Views.Fullnetflow.TopSubscribersReportConfig;

    var config =
    {
        config:
        {
            type:QoEReportConfigTypeEnum.ClientPredefined,
            table:QoEReportTablesEnum.FullnetflowAgg,
            view:QoEReportViews.FullFlow,
            join:groupBy === "by_gtp" ? QoEReportViews.GtpFullFlowAggJoin : QoEReportViews.FullFlowSubsHwJoin,
            values: conf[groupBy][groupByField](groupBySwitchType).values
                .concat(conf.common_rtt.values)
                .concat(conf[groupBy].common(groupByField, groupBySwitchType).values)
                .concat(conf.common_clickstream.values)
            ,
            rows:conf[groupBy][groupByField](groupBySwitchType).rows,
            sort:{id:"rtt_median",dir:"desc"},
            flags:{
                use_size:0,
                use_where:{
                    "time":1,
                    "date":1,
                    "hour":1,
                    "subscriber_login":1,
                    "unit_vendor":1,
                    "cabel":1,
                    "contract":1,
                    "services":1,
                    "crc":1,
                    "hw_chain":1,
                    "hw_info_chain":1,
                    "hw_info_uint_chain":1,
                    "hw_ip":1,
                    "hw_name":1,
                    "hw_region":1,
                    "hw_address":1,
                    "hw_type":1,
                    "hw_operator":1,
                    "hw_belongs_to":1,
                    "uli_mcc":1,
                    "uli_mnc":1,
                    "uli_tac":1,
                    "uli_eci":1,
                    "cell_id":1,
                    "cell_name":1
                }
            },
            limit:1000000,
            with_totals:true,
            cache:{
                enabled:1,
                values: [],
                rows:[],
                flags:{
                    use_where:0,
                    use_having:0
                }
            }
        },
        columns:conf[groupBy][groupByField](groupBySwitchType).columns
            .concat(conf.common_rtt.columns)
            .concat(conf[groupBy].common(groupByField, groupBySwitchType).columns)
            .concat(conf.common_clickstream.columns),
        leftSplit:conf[groupBy][groupByField](groupBySwitchType).leftSplit,
        sort_map:conf[groupBy][groupByField](groupBySwitchType).sort_map ? conf[groupBy][groupByField](groupBySwitchType).sort_map : {}
    };

    config.config.rows.forEach(function (Col)
    {
        var alias = Col;

        if(typeof Col == "object")
            alias = Col.alias ? Col.alias : Col.col;

        config.config.cache.values.push({col:alias, alias:alias});
    });

    config.config.values.forEach(function (Col)
    {
        var alias = Col.alias ? Col.alias : Col.col;

        var func = Col.func_cache ? Col.func_cache : "";

        config.config.cache.values.push({col:alias, alias:alias, func:func});
    });

    if(groupBy === "by_gtp")
    {
        config.filter = {
            "uli_mcc_filter":{id:"uli_mcc", operator:">", value:0, type:"UInt16"},
            "uli_mnc_filter":{id:"uli_mnc", operator:">", value:0, type:"UInt16"},
            "uli_tac_filter":{id:"uli_tac", operator:">", value:0, type:"UInt32"},
            "uli_eci_filter":{id:"uli_eci", operator:">", value:0, type:"UInt32"}
        };
    }

    this.Views.Fullnetflow.Widgets.TopSubscribersReport.Reconfig(config);


    Object.keys(this.Views.Fullnetflow.SubWidgets).every(function (Key)
    {
        if(Key === "RttDistribution")
            return true;

        var widget = _this.Views.Fullnetflow.SubWidgets[Key];

        if(widget.RefreshData)
        {
            var config = widget.GetReportConfig()

            config.config.view = groupBy === "by_gtp" ?  QoEReportViews.FullFlowJoinedWithGTPAgg : QoEReportViews.FullFlowJoinedWithSubsHw;

            widget.SetReportConfig(config);
        }

        return true;
    });
};

QoESubscribersViewController.prototype.FullnetflowRefreshSubscribers = function ()
{
    var selected = this.Views.Fullnetflow.FiltersTableWidget.GetTableSelectedData();

    if(!selected)
        return;

    var period = this.Views.Fullnetflow.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var _this = this;

    var params = this.FullnetflowGetCurrentFilterParams();

    Object.keys(this.Views.Fullnetflow.Widgets).forEach(function (Key) {
        if(_this.Views.Fullnetflow.Widgets[Key].RefreshData)
            _this.Views.Fullnetflow.Widgets[Key].RefreshData(0, params);
    });

    _this.SetAllPathParam();
};

QoESubscribersViewController.prototype.CheckCanFullflowAddCampaignBtnBeEnabled = function ()
{
    var groupBy = this.Views.Fullnetflow.GroupByPicker.getValue();

    var groupByField = this.Views.Fullnetflow.GroupByFieldPicker.getValue();

    if(groupBy == "by_subscribers" && groupByField == "by_ip")
    {
        this.Views.Fullnetflow.AddCampaign.enable();
    }
    else
    {
        this.Views.Fullnetflow.AddCampaign.disable();
    }
};

QoESubscribersViewController.prototype.FullnetflowFiltersTableRowsSelectedCountSubscriptionHandler = function (Value)
{
    var _this = this;

    var _disableAll = function ()
    {
        _this.Views.Fullnetflow.MasterPanel.disable();
        _this.Views.Fullnetflow.AddCampaign.disable();
    };

    if(Value != 1)
    {
        _disableAll();
        return;
    }

    var selectedData = _this.Views.Fullnetflow.FiltersTableWidget.GetTableSelectedData();

    if(!selectedData)
    {
        _disableAll();
        return;
    }

    if(selectedData.filter_id)
    {
        this.FullnetflowRefreshSubscribers();
        _this.Views.Fullnetflow.MasterPanel.enable();
        //_this.Views.Fullnetflow.AddCampaign.enable();
        _this.CheckCanFullflowAddCampaignBtnBeEnabled();
    }
};

QoESubscribersViewController.prototype.FullnetflowGetFiltersTableSelectedData = function ()
{
    return this.Views.Fullnetflow.FiltersTableWidget.GetTableSelectedData();
};

QoESubscribersViewController.prototype.FullnetflowGetSubscribersTableSelectedData = function ()
{
    return this.Views.Fullnetflow.Widgets.TopSubscribersReport.GetSelectedData();
};

QoESubscribersViewController.prototype.FullnetflowRefreshSubscriberDetails = function ()
{
    var _this = this;

    //var period = this.Views.Fullnetflow.PeriodPicker.getValue();

    var period = this.Views.Fullnetflow.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Fullnetflow.Widgets.ExtendedFillter.GetFilters();

    Object.keys(extendedFilters).forEach(function (Key)
    {
        if(extendedFilters[Key].sql_type == QoEFilterSqlType.having)
            delete extendedFilters[Key];
    });

    filter = webix.extend(filter, extendedFilters, true);

    var selectedSubscribers = this.FullnetflowGetSubscribersTableSelectedData();

    //var groupBy = this.Views.Fullnetflow.Widgets.TopSubscribersReport.Config.rows[0];

    var groupBy = this.Views.Fullnetflow.GroupByPicker.getValue();

    var groupBySwitchType = this.Views.Fullnetflow.GroupBySwitchTypePicker.getValue();

    var groupByField = this.Views.Fullnetflow.GroupByFieldPicker.getValue();

    var rows = this.Views.Fullnetflow.TopSubscribersReportConfig[groupBy][groupByField](groupBySwitchType).rows;

    rows.forEach(function (Row)
    {
        var col = Row;

        var alias = Row;

        if(typeof Row == "object")
        {
            col = Row.col;
            alias = Row.alias;
        }

        if(selectedSubscribers && selectedSubscribers.hasOwnProperty(alias))
        {
            var subsFilter = {};

            var obj =
            {
                id:col,
                operator:"=",
                value:selectedSubscribers[alias]
            };

            var hash = Helper.HashCode(JSON.stringify(obj));

            subsFilter[hash] = obj;

            filter = webix.extend(filter, subsFilter, true);
        }

    });

    var params = {filter:filter, max_execution_time: parseInt(this.Views.Fullnetflow.ExecTimeSelector.getValue())};

    var tabId = this.Views.Fullnetflow.DetailsPanelTabs.getValue();

    Object.keys(this.Views.Fullnetflow.SubWidgets).every(function (Key)
    {
        var widget = _this.Views.Fullnetflow.SubWidgets[Key];

        if(tabId == _this.Id + "SectionsTabs" + "Fullnetflow" + "DetailsPanelTabs" + Key + "Tab" && widget.RefreshData)
        {
            if(Key === "RttDistribution")
            {
                if(!(groupBy === "by_subscribers" && (groupByField === "by_ip" || groupByField === "by_login")))
                {
                    widget.CacheMonitor.WidgetView.showOverlay("<br/><br/><br/>"+LangHelper.GetString("QoE","Not applicable"));

                    return false;
                }
            }

            widget.RefreshData(0, params);

            return false;
        }

        return true;
    });
};

QoESubscribersViewController.prototype.FullnetflowSubscribersTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    var _this = this;

    var _disableAll = function ()
    {
        _this.Views.Fullnetflow.DetailsPanel.disable();
    };

    if(Value != 1)
    {
        _disableAll();
        return;
    }

    var selectedData = _this.FullnetflowGetSubscribersTableSelectedData();

    if(!selectedData)
    {
        _disableAll();
        return;
    }

    if(selectedData)
    {
        this.FullnetflowRefreshSubscriberDetails();
        this.Views.Fullnetflow.DetailsPanel.enable();
    }
};

QoESubscribersViewController.prototype.DpiPickerOptionsUpdate = function(TabName)
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views[TabName].DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoESubscribersViewController.prototype.GetDpiPickerState = function(FullflowDpiPicker)
{
    var filter = null;

    var val = FullflowDpiPicker ? this.Views.Fullnetflow.DpiPicker.getValue() : this.Views.Clickstream.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoESubscribersViewController.prototype.ShowQoEAdvcWizardWidget = function (Node, Pos)
{
    var filterParams = null;

    var c = this.Views.Clickstream.Widgets.TopSubscribersReport.Config;

    var configParams = {};
    //
    // {
    //     type:QoEReportConfigTypeEnum.ClientPredefined,
    //     table:QoEReportTablesEnum.Clickstream,
    //     values:[],
    //     rows:[],
    //     sort:{id:"total",dir:"desc"},
    //     with_totals:false
    // };

    var currTab = this.Views.SectionsTabs.getValue();

    if(currTab == this.Id + "SectionsTabs" + "Clickstream")
    {
        configParams = webix.extend({}, this.Views.Clickstream.Widgets.TopSubscribersReport.Config, true);

        filterParams = this.GetCurrentFilterParams();

        filterParams = this.Views.Clickstream.Widgets.TopSubscribersReport.GetFilterSortState(filterParams);

        filterParams.table = QoEReportTablesEnum.ClickstreamAgg;
    }

    if(currTab == this.Id + "SectionsTabs" + "Fullnetflow")
    {
        configParams = webix.extend({}, this.Views.Fullnetflow.Widgets.TopSubscribersReport.Config, true);

        filterParams = this.FullnetflowGetCurrentFilterParams();

        filterParams = this.Views.Fullnetflow.Widgets.TopSubscribersReport.GetFilterSortState(filterParams);

        filterParams.table = QoEReportTablesEnum.FullnetflowAgg;
    }

    this.Views.Widgets.QoEAdvcWizardWidget.Show(Node,Pos,{Config:configParams, Params:filterParams});
};

QoESubscribersViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoESubscribersViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoESubscribersViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoESubscribersViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoESubscribersViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoESubscribersViewController.prototype.SetAllPathParam = function()
{
    var section = this.Views.SectionsTabs.getValue();
    this.SetPathParam("section", section && section == this.SectionsEnum.ff ? "ff": "cs");

    var cs_period = this.Views.Clickstream.Widgets.DateRangePicker.GetValue();
    if(cs_period)
    {
        this.SetPathParam("cs_period", cs_period);
    }

    var cs_dpi = this.Views.Clickstream.DpiPicker.getValue();
    if(cs_dpi)
    {
        this.SetPathParam("cs_dpi", cs_dpi);
    }

    var cs_filter = this.Views.Clickstream.FiltersTableWidget.GetSelectedFilterId();
    if(cs_filter)
    {
        this.SetPathParam("cs_filter", cs_filter);
    }

    var cs_max_exec_time = this.Views.Clickstream.ExecTimeSelector.getValue();
    if(cs_max_exec_time)
    {
        this.SetPathParam("cs_max_exec_time", cs_max_exec_time);
    }


    var ff_period = this.Views.Fullnetflow.Widgets.DateRangePicker.GetValue();
    if(ff_period)
    {
        this.SetPathParam("ff_period", ff_period);
    }

    var ff_dpi = this.Views.Fullnetflow.DpiPicker.getValue();
    if(ff_dpi)
    {
        this.SetPathParam("ff_dpi", ff_dpi);
    }

    var ff_filter = this.Views.Fullnetflow.FiltersTableWidget.GetSelectedFilterId();
    if(ff_filter)
    {
        this.SetPathParam("ff_filter", ff_filter);
    }

    var ff_max_exec_time = this.Views.Fullnetflow.ExecTimeSelector.getValue();
    if(ff_max_exec_time)
    {
        this.SetPathParam("ff_max_exec_time", ff_max_exec_time);
    }

    this.JustNavigate();
};

QoESubscribersViewController.prototype.GetAllPathParam = function()
{
    try
    {
        var section = this.GetPathParam("section");
        this.Views.SectionsTabs.setValue(section && this.SectionsEnum[section] ? this.SectionsEnum[section] : this.SectionsEnum.cs);

        var cs_dpi = this.GetPathParam("cs_dpi");
        this.Views.Clickstream.DpiPicker.setValue(cs_dpi?cs_dpi:"-2");

        var cs_period = this.GetPathParam("cs_period");
        this.Views.Clickstream.Widgets.DateRangePicker.SetValue(cs_period,true);

        var cs_filter = this.GetPathParam("cs_filter");
        this.Views.Clickstream.FiltersTableWidget.Select(cs_filter);

        var cs_max_exec_time = this.GetPathParam("cs_max_exec_time");
        this.Views.Clickstream.ExecTimeSelector.setValue(cs_max_exec_time?cs_max_exec_time:600);


        var ff_dpi = this.GetPathParam("ff_dpi");
        this.Views.Fullnetflow.DpiPicker.setValue(ff_dpi?ff_dpi:"-2");

        var ff_period = this.GetPathParam("ff_period");
        this.Views.Fullnetflow.Widgets.DateRangePicker.SetValue(ff_period,true);

        var ff_filter = this.GetPathParam("ff_filter");
        this.Views.Fullnetflow.FiltersTableWidget.Select(ff_filter);

        var ff_max_exec_time = this.GetPathParam("ff_max_exec_time");
        this.Views.Fullnetflow.ExecTimeSelector.setValue(ff_max_exec_time?ff_max_exec_time:600);
    }
    catch(e){}
};

QoESubscribersViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoESubscribersViewController.prototype.GetFilterStateConfig = function()
{
    var section = this.Views.SectionsTabs.getValue();

    var type = section == this.SectionsEnum.ff ? "Fullnetflow" :  "Clickstream";

    return {
        filter_state:this.Views[type].Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views[type].Widgets.ExtendedFillter.GetFilters()
    };
};

QoESubscribersViewController.prototype.GetPeriodState = function()
{
    var section = this.Views.SectionsTabs.getValue();

    var type = section == this.SectionsEnum.ff ? "Fullnetflow" : "Clickstream";

    var period = this.Views[type].Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};
function QoEAdminViewController(Params)
{
    var _this = this;

    this.Id = "QoEAdmin";

    this.ViewModel = new QoEReportsManager();

    this.ReportsModel = new UniReportsManager();

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,

        PartitionsReportDeleteBtn:null,
        FullflowAggregationRawLogsDeleteBtn: null
    };

    this.Views.Widgets =
    {
        QueriesProcessesReport: QoETableQueriesProcessesWidget({id:this.Id + "QueriesProcessesReport", onItemClick:function (Id) {_this.QueriesProcessesReportOnItemClick(Id);}}),
        TableSpaceReport: QoETableSpaceReportWidget({id:this.Id + "TableSpaceReport"}),
        TableSpacePieReport: QoEPieChartSpaceReportWidget({id:this.Id + "TableSpacePieReport"}),
        PartitionsReport: QoETablePartitionsWidget({id:this.Id + "PartitionsReport", onItemClick:function (Id) {_this.PartitionsReportOnItemClick(Id);}}),
        CachesListReport: QoETableCachesListWidget({id:this.Id + "CachesListReport"}),
        DictionariesReport: QoETableDictionariesWidget({id:this.Id + "DictionariesReport"}),
        AsnumDicReport: QoETableAsnumDicWidget({id:this.Id + "AsnumDicReport"}),
        AsnumLocalDicReport: QoETableAsnumLocalDicWidget({id:this.Id + "AsnumLocalDicReport"}),
        AsnumExcludeDicReport: QoETableAsnumExcludeDicWidget({id:this.Id + "AsnumExcludeDicReport"}),
        CrcDicReport: QoETableCRCDicWidget({id:this.Id + "CrcDicReport"}),
        NetProtocolsDicReport: QoETableNetProtocolsDicWidget({id:this.Id + "NetProtocolsDicReport"}),
        AppProtocolsDicReport: QoETableAppProtocolsDicWidget({id:this.Id + "AppProtocolsDicReport"}),
        AppProtocolsGrpsDicReport: QoETableAppProtocolsGroupsDicWidget({id:this.Id + "AppProtocolsGroupsDicReport"}),
        SettingsDicReport: QoETableSettingsDicWidget({id:this.Id + "SettingsDicReport"}),
        SubnetsLocalDicReport: QoETableSubnetsLocalDicWidget({id:this.Id + "SubnetsLocalDicReport"}),
        SubnetsExcludeDicReport: QoETableSubnetsExcludeDicWidget({id:this.Id + "SubnetsExcludeDicReport"}),
        SubscribersDicReport: QoETableSubscribersDicWidget({id:this.Id + "SubscribersDicReport"}),
        SwitchesDicReport: QoETableSwitchesDicWidget({id:this.Id + "SwitchesDicReport"}),
        UrlcatsDicReport: QoETableUrlcatsDicWidget({id:this.Id + "UrlcatsDicReport"}),
        UrlcatsHostDic: QoETableUrlcatsHostDicWidget({id:this.Id + "UrlcatsHostDic"}),
        UlrVchanNameDic: QoETableUlrVchanNameDicWidget({id:this.Id + "UlrVchanNameDic"}),
        GtpCellsLocationsDic: QoETableLayerGtpCellsLocationsDicWidget({id:this.Id + "GtpCellsLocationsDic"}),
        GtpCountryDic: QoETableGtpCountryDicWidget({id:this.Id + "GtpCountryDic"}),
        GtpNetworkDic: QoETableGtpNetworkDicWidget({id:this.Id + "GtpNetworkDic"}),
        // UplinkLoadRateDic: QoeTableUplinkLoadRateDicWidget({id:this.Id + "UplinkLoadRateDic"}),

        DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"})
    };

    this.Views.ReportsWidgets = {
        FullflowAggregationRawLogsReport: QoETableFullflowAggregationRawLogsWidget({
            id:this.Id + "FullflowAggregationRawLogsReport_NotQoE",
            onItemClick: function (Obj, e, node)
            {
                var table = _this.Views.ReportsWidgets.FullflowAggregationRawLogsReport.Views.Table;
                let item = table.getSelectedItem();
                node = table.getItemNode(Obj);

                if(Obj.column == "data"){
                    _this.ShowDataInfoForm(node, item.data);
                }

                if (Obj.column === 'trash'){
                    Helper.Table.OnItemClickTrash(_this.Id, Obj, _this.DeleteQoECompressQueueRow, table, null, null, "left");
                }

            },
            onAfterFilterCustomHandler: function ()
            {
                _this.Refresh();
            }
        })
    }

    this.Views.Widgets.PartitionsReport.DeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("All", "Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("All", "Cancel"),
                            click:function ()
                            {
                                _this.Views.Widgets.PartitionsReport.DeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("All", "Delete"),
                            click:function ()
                            {
                                _this.Views.Widgets.PartitionsReport.DeleteContext.hide();
                                _this.DropSelectedPartitions();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.Views.Widgets.QueriesProcessesReport.KillContext = webix.ui({
        view:"popup",
        width:440,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("QoE", "Are you sure you want to cancel the selected queries?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("All", "Cancel"),
                            click:function ()
                            {
                                _this.Views.Widgets.QueriesProcessesReport.KillContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("QoE", "Cancel query"),
                            click:function ()
                            {
                                _this.Views.Widgets.QueriesProcessesReport.KillContext.hide();
                                _this.KillSelectedProcesses();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Administrator")}),
                                {
                                    view: "toolbar",
                                    elements:
                                    [
                                        {},
                                        {
                                            view: "button",
                                            id:this.Id+"RefreshBtn",
                                            type: "icon",
                                            icon: "refresh",
                                            css: "toolbar_round_btn",
                                            width: 32,
                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                            click: function (id, e, node)
                                            {
                                                _this.Refresh();
                                            }
                                        }
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            rows:[
                                                {
                                                    view:"multiview",
                                                    id:this.Id + "ReportsCells",
                                                    cells:[
                                                        {
                                                            id: this.Id + "ReportsCells" + "QueriesProcessesReport",
                                                            rows:[
                                                                {
                                                                    view: "toolbar",
                                                                    elements:
                                                                        [
                                                                            {},
                                                                            {
                                                                                view: "button",
                                                                                id:this.Id + "ReportsCells" + "QueriesProcessesReport" + "KillBtn",
                                                                                type: "icon",
                                                                                icon: "hand-paper",
                                                                                css: "toolbar_round_btn",
                                                                                width: 32,
                                                                                tooltip: LangHelper.GetString("QoE", "Cancel queries"),
                                                                                click: function (id, e, node)
                                                                                {
                                                                                    _this.Views.Widgets.QueriesProcessesReport.KillContext.show(this.getNode(), {pos:"bottom"});
                                                                                }
                                                                            }
                                                                        ]
                                                                },
                                                                this.Views.Widgets.QueriesProcessesReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TableSpaceReport",
                                                            cols:[
                                                                {
                                                                    gravity:2,
                                                                    rows:[
                                                                        this.Views.Widgets.TableSpaceReport.ViewConfig
                                                                    ]
                                                                },
                                                                {view:"resizer"},
                                                                this.Views.Widgets.TableSpacePieReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "PartitionsReport",
                                                            rows:[
                                                                {
                                                                    view: "toolbar",
                                                                    elements:
                                                                        [
                                                                            {},
                                                                            {
                                                                                view: "button",
                                                                                id:this.Id + "ReportsCells" + "PartitionsReport" + "DeleteBtn",
                                                                                type: "icon",
                                                                                icon: "trash",
                                                                                css: "toolbar_round_btn",
                                                                                width: 32,
                                                                                tooltip: LangHelper.GetString("QoE", "Delete partitions"),
                                                                                click: function (id, e, node)
                                                                                {
                                                                                    _this.Views.Widgets.PartitionsReport.DeleteContext.show(this.getNode(), {pos:"bottom"});
                                                                                }
                                                                            }
                                                                        ]
                                                                },
                                                                this.Views.Widgets.PartitionsReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "CachesListReport",
                                                            rows:[
                                                                {
                                                                    view: "toolbar",
                                                                    elements:
                                                                        [
                                                                            {},
                                                                            {
                                                                                view: "button",
                                                                                id:this.Id + "ReportsCells" + "CachesListReport" + "ClearCacheBtn",
                                                                                type: "icon",
                                                                                icon: "broom",
                                                                                css: "toolbar_round_btn",
                                                                                width: 32,
                                                                                tooltip: LangHelper.GetString("QoE", "Clear cache"),
                                                                                click: function (id, e, node)
                                                                                {
                                                                                    _this.ClearCache();
                                                                                }
                                                                            }
                                                                        ]
                                                                },
                                                                this.Views.Widgets.CachesListReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "FullflowAggregationRawLogsReport",
                                                            rows:[
                                                                {
                                                                    view: "toolbar",
                                                                    elements:
                                                                        [
                                                                            this.Views.Widgets.DateRangePicker.ViewConfig,
                                                                            {},
                                                                            {
                                                                                view: "button",
                                                                                id:this.Id + "ReportsCells" + "FullflowAggregationRawLogsReport" + "DeleteLogsBtn",
                                                                                type: "icon",
                                                                                icon: "trash",
                                                                                css: "toolbar_round_btn",
                                                                                width: 32,
                                                                                tooltip: LangHelper.GetString("All","Delete"),
                                                                                click:function (id,e,node)
                                                                                {
                                                                                    var __this = this;
                                                                                    var node = __this.getNode(id);

                                                                                    Helper.Table.ShowTrashForm(_this.Id, _this.DeleteQoECompressQueueRows, _this.Views.ReportsWidgets.FullflowAggregationRawLogsReport.Views.Table, node);
                                                                                }
                                                                            },
                                                                            {
                                                                                view: "button",
                                                                                id:this.Id + "ReportsCells" + "FullflowAggregationRawLogsReport" + "LogsEraseBtn",
                                                                                type: "icon",
                                                                                icon: "eraser",
                                                                                css:"toolbar_round_btn",
                                                                                width:32,
                                                                                tooltip:LangHelper.GetString("All", "Remove all"),
                                                                                click:function (id,e,node)
                                                                                {
                                                                                    var __this = this;
                                                                                    var node = __this.getNode(id);

                                                                                    Helper.Table.ShowEraseForm(_this.Id, _this.DeleteQoECompressQueueRows, _this.Views.ReportsWidgets.FullflowAggregationRawLogsReport.Views.Table, node);
                                                                                }
                                                                            },
                                                                        ]
                                                                },
                                                                this.Views.ReportsWidgets.FullflowAggregationRawLogsReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "DictionariesReport",
                                                            rows:[
                                                                {
                                                                    view: "toolbar",
                                                                    elements:
                                                                        [
                                                                            {},
                                                                            {
                                                                                view: "button",
                                                                                id:this.Id + "DictionariesReport" + "ReloadBtn",
                                                                                type: "icon",
                                                                                icon: "cloud-download-alt",
                                                                                css: "toolbar_round_btn",
                                                                                width: 32,
                                                                                tooltip: LangHelper.GetString("QoE", "Force reload dictionaries"),
                                                                                click: function (id, e, node)
                                                                                {
                                                                                    _this.ForceReloadDics();
                                                                                }
                                                                            }
                                                                        ]
                                                                },
                                                                this.Views.Widgets.DictionariesReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "AsnumDicReport",
                                                            rows:[
                                                                this.Views.Widgets.AsnumDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "AsnumLocalDicReport",
                                                            rows:[
                                                                this.Views.Widgets.AsnumLocalDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "AsnumExcludeDicReport",
                                                            rows:[
                                                                this.Views.Widgets.AsnumExcludeDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "CrcDicReport",
                                                            rows:[
                                                                this.Views.Widgets.CrcDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "NetProtocolsDicReport",
                                                            rows:[
                                                                this.Views.Widgets.NetProtocolsDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "AppProtocolsGrpsDicReport",
                                                            rows:[
                                                                this.Views.Widgets.AppProtocolsGrpsDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "AppProtocolsDicReport",
                                                            rows:[
                                                                this.Views.Widgets.AppProtocolsDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "SettingsDicReport",
                                                            rows:[
                                                                this.Views.Widgets.SettingsDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "SubnetsLocalDicReport",
                                                            rows:[
                                                                this.Views.Widgets.SubnetsLocalDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "SubnetsExcludeDicReport",
                                                            rows:[
                                                                this.Views.Widgets.SubnetsExcludeDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "SubscribersDicReport",
                                                            rows:[
                                                                this.Views.Widgets.SubscribersDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "SwitchesDicReport",
                                                            rows:[
                                                                this.Views.Widgets.SwitchesDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "UrlcatsDicReport",
                                                            cols:[
                                                                this.Views.Widgets.UrlcatsDicReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "UrlcatsHostDic",
                                                            cols:[
                                                                this.Views.Widgets.UrlcatsHostDic.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "UlrVchanNameDic",
                                                            cols:[
                                                                this.Views.Widgets.UlrVchanNameDic.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "GtpCellsLocationsDic",
                                                            cols:[
                                                                this.Views.Widgets.GtpCellsLocationsDic.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "GtpCountryDic",
                                                            cols:[
                                                                this.Views.Widgets.GtpCountryDic.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "GtpNetworkDic",
                                                            cols:[
                                                                this.Views.Widgets.GtpNetworkDic.ViewConfig
                                                            ]
                                                        }
                                                        // ,
                                                        // {
                                                        //     id: this.Id + "ReportsCells" + "UplinkLoadRateDic",
                                                        //     cols:[
                                                        //         this.Views.Widgets.UplinkLoadRateDic.ViewConfig
                                                        //     ]
                                                        // }
                                                    ]
                                                }
                                            ]
                                        },
                                        {view: "resizer"},
                                        {
                                            width: 360,
                                            rows: [
                                                BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                {
                                                    view: "treetable",
                                                    id:this.Id + "ReportsList",
                                                    header:false,
                                                    select: "row",
                                                    on: {
                                                        onAfterSelect:function ()
                                                        {
                                                            _this.OnReportsListSelect();
                                                        },
                                                        onAfterUnSelect:function ()
                                                        {
                                                            _this.OnReportsListUnSelect();
                                                        }
                                                    },
                                                    columns: [
                                                        {
                                                            id: "value",
                                                            fillspace: true,
                                                            template: function(obj, common, value, config)
                                                            {
                                                                return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                            }
                                                        }
                                                    ],
                                                    data: [
                                                        {
                                                            id: this.Id + "ReportsCells" + "QueriesProcessesReport",
                                                            value:LangHelper.GetString("QoE", "Queries processes list")
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TableSpaceReport" + "Group",
                                                            value: LangHelper.GetString("QoE", "Tablespace info"),
                                                            data:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TableSpaceReport",
                                                                    value:LangHelper.GetString("QoE", "Tablespace info")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "PartitionsReport",
                                                                    value:LangHelper.GetString("QoE", "Partitions info")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "CachesListReport",
                                                                    value:LangHelper.GetString("QoE", "Caches info")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "FullflowAggregationRawLogsReport",
                                                                    value:LangHelper.GetString("QoE", "Aggregation raw logs fullflow info")
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "DictionariesReport" + "Group",
                                                            value: LangHelper.GetString("QoE", "Dictionaries info"),
                                                            data:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "DictionariesReport",
                                                                    value:LangHelper.GetString("QoE", "Dictionaries info")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AsnumDicReport",
                                                                    value:LangHelper.GetString("QoE", "AS numbers dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AsnumLocalDicReport",
                                                                    value:LangHelper.GetString("QoE", "Local AS numbers dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AsnumExcludeDicReport",
                                                                    value:LangHelper.GetString("QoE", "Excluded AS numbers dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "CrcDicReport",
                                                                    value:LangHelper.GetString("QoE", "CRC dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "NetProtocolsDicReport",
                                                                    value:LangHelper.GetString("QoE", "Net protocols dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AppProtocolsGrpsDicReport",
                                                                    value:LangHelper.GetString("QoE", "App protocols groups dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AppProtocolsDicReport",
                                                                    value:LangHelper.GetString("QoE", "App protocols dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "SettingsDicReport",
                                                                    value:LangHelper.GetString("QoE", "Settings dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "SubnetsLocalDicReport",
                                                                    value:LangHelper.GetString("QoE", "Local subnets dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "SubnetsExcludeDicReport",
                                                                    value:LangHelper.GetString("QoE", "Excluded subnets dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "SubscribersDicReport",
                                                                    value:LangHelper.GetString("QoE", "Subscribers dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "SwitchesDicReport",
                                                                    value:LangHelper.GetString("QoE", "Switches dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "UrlcatsDicReport",
                                                                    value:LangHelper.GetString("QoE", "Host categories dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "UrlcatsHostDic",
                                                                    value:LangHelper.GetString("QoE", "Hosts in categories dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "UlrVchanNameDic",
                                                                    value:LangHelper.GetString("QoE", "Vchannels names dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "GtpCellsLocationsDic",
                                                                    value: LangHelper.GetString("QoE", "Gtp cells locations dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "GtpCountryDic",
                                                                    value:LangHelper.GetString("QoE", "Gtp country dictionary")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "GtpNetworkDic",
                                                                    value:LangHelper.GetString("QoE", "Gtp network (operator) dictionary")
                                                                },
                                                                // {
                                                                //     id: this.Id + "ReportsCells" + "UplinkLoadRateDic",
                                                                //     value:LangHelper.GetString("QoE", "UPLINK LOAD RATE protocols dictionary")
                                                                // }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "QueriesProcessesReport"] = [this.Views.Widgets.QueriesProcessesReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TableSpaceReport"] = [this.Views.Widgets.TableSpaceReport, this.Views.Widgets.TableSpacePieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "PartitionsReport"] = [this.Views.Widgets.PartitionsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "CachesListReport"] = [this.Views.Widgets.CachesListReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "FullflowAggregationRawLogsReport"] = [this.Views.ReportsWidgets.FullflowAggregationRawLogsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "DictionariesReport"] = [this.Views.Widgets.DictionariesReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AsnumDicReport"] = [this.Views.Widgets.AsnumDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AsnumLocalDicReport"] = [this.Views.Widgets.AsnumLocalDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AsnumExcludeDicReport"] = [this.Views.Widgets.AsnumExcludeDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "CrcDicReport"] = [this.Views.Widgets.CrcDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "NetProtocolsDicReport"] = [this.Views.Widgets.NetProtocolsDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AppProtocolsDicReport"] = [this.Views.Widgets.AppProtocolsDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AppProtocolsGrpsDicReport"] = [this.Views.Widgets.AppProtocolsGrpsDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "SettingsDicReport"] = [this.Views.Widgets.SettingsDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "SubnetsLocalDicReport"] = [this.Views.Widgets.SubnetsLocalDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "SubnetsExcludeDicReport"] = [this.Views.Widgets.SubnetsExcludeDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "SubscribersDicReport"] = [this.Views.Widgets.SubscribersDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "SwitchesDicReport"] = [this.Views.Widgets.SwitchesDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "UrlcatsDicReport"] = [this.Views.Widgets.UrlcatsDicReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "UrlcatsHostDic"] = [this.Views.Widgets.UrlcatsHostDic];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "GtpCellsLocationsDic"] = [this.Views.Widgets.GtpCellsLocationsDic];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "UlrVchanNameDic"] = [this.Views.Widgets.UlrVchanNameDic];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "GtpCountryDic"] = [this.Views.Widgets.GtpCountryDic];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "GtpNetworkDic"] = [this.Views.Widgets.GtpNetworkDic];
    // this.ReportsCellsReportMap[this.Id + "ReportsCells" + "UplinkLoadRateDic"] = [this.Views.Widgets.UplinkLoadRateDic];
}

QoEAdminViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEAdmin");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();
};

QoEAdminViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");

    this.Views.PartitionsReportDeleteBtn = $$(this.Id + "ReportsCells" + "PartitionsReport" + "DeleteBtn");
    this.Views.QueriesProcessesReportKillBtn = $$(this.Id + "ReportsCells" + "QueriesProcessesReport" + "KillBtn");

    this.Views.FullflowAggregationRawLogsDeleteBtn = $$(this.Id + "ReportsCells" + "FullflowAggregationRawLogsReport" + "DeleteLogsBtn");

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        _this.Views.Widgets[Key].Bind(_this);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.GetAllPathParam();

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged()
    ).subscribe(function(Val)
        {
            if(Val[0])
            {
                let table = _this.Views.ReportsWidgets.FullflowAggregationRawLogsReport.Views.Table;
                let options = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic).reduce((arr, item) => {
                    if(item.hardware_type === HardwareTypesEnum.qoestor)
                        arr.push({id: item.ip, value: item.value});
                    return arr;
                    }, []);
                let col = table.getColumnConfig("node");
                col.header[1].options = options;
                table.refreshColumns();
            }

            if(Val[0] && Val[1])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.Refresh();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }

        }
    );

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.Refresh();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.PartitionsReportSelectedCountSubscription = this.Views.Widgets.PartitionsReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.PartitionsReportDeleteBtn.enable();
        }
        else
        {
            _this.Views.PartitionsReportDeleteBtn.disable();
        }
    });

    this.Subscriptions.QueriesProcessesReportSelectedCountSubscription = this.Views.Widgets.QueriesProcessesReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.QueriesProcessesReportKillBtn.enable();
        }
        else
        {
            _this.Views.QueriesProcessesReportKillBtn.disable();
        }
    });

    this.Subscriptions.AppProtocolsGroupsDicUpdatedSubscription = App.DicsManager.Signal[DicsEnum.ProtocolsGroupsDic].subscribe(function(Val){
        if(Val)
        {
            _this.Views.Widgets.AppProtocolsDicReport.Views.Table.getColumnConfig("group_id").header[1].options = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic);
        }
    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.Refresh();
        }
    });

    this.Subscriptions.FullflowAggregationRawLogsTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.FullflowAggregationRawLogsReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        if (Value>0){
            _this.Views.FullflowAggregationRawLogsDeleteBtn.enable();
        } else {
            _this.Views.FullflowAggregationRawLogsDeleteBtn.disable();
        }
    });

    Helper.Table.ActivateCheckBox(this.Views.ReportsWidgets.FullflowAggregationRawLogsReport.Views.Table);
};

QoEAdminViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    this.Views.Widgets.DateRangePicker.Destroy(this);

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

QoEAdminViewController.prototype.Refresh = function ()
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var id = Helper.ReplaceAll("Group", "", selected.id);

    this.ReportsCellsReportMap[id].forEach(function (Report) {
        if(Report.RefreshData)

            var params = {};

            if(id.indexOf("TableSpace") > -1 || id.indexOf("Partitions") > -1)
            {
                params = {filter:{
                        _database:
                            {
                                id:"database",
                                operator:"=",
                                value:"qoestor"
                            },
                        _table:
                            {
                                id:"table",
                                operator:"in",
                                value:[
                                    "clickstream",
                                    "fullflow",
                                    "natflow",
                                    "gtpflow",
                                    "dnsflow",
                                    ".inner.clickstream_agg",
                                    ".inner.fullflow_agg",
                                    ".inner.subscribers_flow",
                                    ".inner.hw_chain_flow",
                                    ".inner.clickstream_from_fullflow",
                                    ".inner.natflow_agg",
                                    ".inner.gtpflow_ul_agg",
                                    ".inner.dnsflow_agg",
                                    "fullflow_compressed",
                                    ".inner.fullflow_compressed_agg",
                                    ".inner.fullflow_agg_compressed_1",
                                    ".inner.fullflow_agg_compressed_2",
                                    "aaaflow",
                                    ".inner.aaa_udr_fullflow",
                                    ".inner.aaa_udr_clickstream",
                                    "fm_attacks",
                                    ".inner.fm_attacks_agg",
                                    "fm_attacks_metrics",
                                    ".inner.fm_attacks_metrics_agg_avg_based_z_score",
                                    ".inner.fm_attacks_metrics_agg_day_avg_based_z_score",
                                    ".inner.fm_attacks_metrics_agg_median_based",
                                    ".inner.fm_attacks_metrics_agg_day_median_based",
                                    ".inner.fm_attacks_metrics_agg_isolation_forest",
                                    ".inner.fm_attacks_metrics_agg_day_isolation_forest"
                                ]

                            }
                    }};
            }
            else if(id.indexOf("CachesList") > -1)
            {
                params = {filter:{
                        _database:
                            {
                                id:"database",
                                operator:"=",
                                value:"qoestor"
                            },
                        _table:
                            {
                                id:"table",
                                operator:"like",
                                value:"cache_"
                            }
                    }};
            }
            else if(id.indexOf('FullflowAggregationRawLogsReport') > -1) {
                var period = _this.Views.Widgets.DateRangePicker.GetValue();

                var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

                if(!period.start || !period.end)
                    return;

                var filter = {
                    period:{
                        id:"update_time",
                        operator:"between",
                        value:[format(Helper.DateTimeToUTC(period.start)), format(Helper.DateTimeToUTC(period.end))]
                    }
                };

                var params = {filter:filter};
            }
            // else if(id.indexOf("QueriesProcessesReport") > -1)
            // {
            //     params = {filter:{
            //             _table:
            //                 {
            //                     id:"query_id",
            //                     operator:"like",
            //                     value:"cache_"
            //                 }
            //         }};
            // }

            Report.RefreshData(0, params);
    });

    _this.SetAllPathParam();
};

QoEAdminViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoEAdminViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEAdminViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEAdminViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoEAdminViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEAdminViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEAdminViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    if(report === 'FullflowAggregationRawLogsReport'){
        var period = this.Views.Widgets.DateRangePicker.GetValue();

        if(period)
        {
            this.SetPathParam("period", period);
        }
    }

    this.JustNavigate();
};

QoEAdminViewController.prototype.GetAllPathParam = function()
{
    try {
        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);
    }
    catch(e){}
};

QoEAdminViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEAdminViewController.prototype.PartitionsReportOnItemClick = function(Id)
{
    var _this = this;

    if(Id.column === 'trash')
    {
        var table = this.Views.Widgets.PartitionsReport.Views.Table;

        var data = table.getItem(Id);

        setTimeout(function ()
        {
            var node = table.getItemNode(Id);
            _this.Views.Widgets.PartitionsReport.DeleteContext.show(node, {pos:"bottom"});
        }, 10);
    }
};

QoEAdminViewController.prototype.QueriesProcessesReportOnItemClick = function(Id)
{
    var _this = this;

    if(Id.column === 'kill')
    {
        var table = this.Views.Widgets.QueriesProcessesReport.Views.Table;

        var data = table.getItem(Id);

        setTimeout(function ()
        {
            var node = table.getItemNode(Id);
            _this.Views.Widgets.QueriesProcessesReport.KillContext.show(node, {pos:"bottom"});
        }, 10);
    }
};

QoEAdminViewController.prototype.DropSelectedPartitions = function()
{
    var _this = this;

    var table = this.Views.Widgets.PartitionsReport.Views.Table;

    var selected = this.Views.Widgets.PartitionsReport.GetSelectedData();

    if(!selected)
        return;

    var isValid = true;

    var data = Array.isArray(selected) ? selected : [selected];

    data.forEach(function (Partition) {
        var item = table.getItem(Partition.id);
        item.valid = 1;

        if(!table.validate(Partition.id))
        {
            isValid = false;
        }
    });

    if(isValid)
    {
        this.ViewModel.DropPartitions({data:data, callback:function (R)
            {
                var processResult = function (R)
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("All","Deleted"));
                        table.remove(R.id);
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});

                        var item = table.getItem(R.id);
                        if(item)
                        {
                            item.valid = 0;
                            table.validate(R.id);
                        }
                    }
                };

                if(R)
                {
                    if(Array.isArray(R))
                    {
                        R.forEach(function (R)
                        {
                            processResult(R);
                        });
                    }
                    else
                    {
                        processResult(R);
                    }
                }
            }});
    }
};

QoEAdminViewController.prototype.KillSelectedProcesses = function()
{
    var _this = this;

    var table = this.Views.Widgets.QueriesProcessesReport.Views.Table;

    var selected = this.Views.Widgets.QueriesProcessesReport.GetSelectedData();

    if(!selected)
        return;

    var isValid = true;

    var data = Array.isArray(selected) ? selected : [selected];

    data.forEach(function (Partition) {
        var item = table.getItem(Partition.id);
        item.valid = 1;

        if(!table.validate(Partition.id))
        {
            isValid = false;
        }
    });

    if(isValid)
    {
        this.ViewModel.KillProcesses({data:data, callback:function (R)
            {
                var processResult = function (R)
                {
                    if(R.success)
                    {
                        webix.message(LangHelper.GetString("QoE","Canceled"));
                        table.remove(R.id);
                    }
                    else
                    {
                        webix.message({type:"error", text:R.error.msg});

                        var item = table.getItem(R.id);
                        if(item)
                        {
                            item.valid = 0;
                            table.validate(R.id);
                        }
                    }
                };

                if(R)
                {
                    if(Array.isArray(R))
                    {
                        R.forEach(function (R)
                        {
                            processResult(R);
                        });
                    }
                    else
                    {
                        processResult(R);
                    }
                }
            }});
    }
};

QoEAdminViewController.prototype.ForceReloadDics = function()
{
    var _this = this;

    this.ViewModel.ReloadDics(function (R)
    {
        if(R.success)
        {
            webix.message(LangHelper.GetString("QoE", "Dictionaries are reloaded"))
        }
        else
        {
            webix.message({type:"error", text:R.error.msg});
        }

        _this.Refresh();
    });
};

QoEAdminViewController.prototype.ClearCache = function()
{
    var _this = this;

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"));

        _this.Refresh();
    });
};

QoEAdminViewController.prototype.ShowDataInfoForm = function (Node, Data)
{
    if(!Data)
    {
        return;
    }

    let formData = null;
    if(typeof Data === 'object' || Array.isArray(Data))
    {
        formData = JSON.stringify( Data, null, 2);
    }
    else if(typeof Data === 'string')
    {
        try{
            let data = JSON.stringify( JSON.parse(Data), null, 2);
            formData = data;
        }
        catch(e)
        {
            formData = Data;
        }
    }

    if(!formData)
    {
        return;
    }

    let context = webix.ui({
        view:"popup",
        id: this.Id + "DataInfoContext",
        width:600,
        height:400,
        body:{
            id: this.Id + "DataInfoContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    view:"codemirror-editor",
                    id:this.Id + "DataInfoContextFormEditor",
                    height:undefined,
                    value:formData
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("All","Close"),
                            click:function ()
                            {
                                context.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    let pos = "bottom";
    context.show(Node, {pos});
};

QoEAdminViewController.prototype.DeleteQoECompressQueueRow = function(Params)
{
    var _this = this;

    var Row = Params&&Params.Row?Params.Row:null;

    var params =
        {
            id: webix.uid(),
            method:"DeleteQoECompressQueueRow",
            data: {Row},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};

QoEAdminViewController.prototype.DeleteQoECompressQueueRows = function(Params)
{
    var _this = this;

    var Ids = Params&&Params.Ids?Params.Ids:[0];

    var params =
        {
            id: webix.uid(),
            method:"DeleteQoECompressQueueRows",
            data: {Ids},
            callback:function (R)
            {
                if(Params && Params.callback && typeof Params.callback === "function")
                {
                    Params.callback(R);
                }
            }
        };

    App.ServerManager.CallMethod(params);
};
function QoETriggerEditViewController(Params)
{
    var _this = this;

    this.Id = Params && Params.id ? Params.id : "TriggerEditView";

    this.Embedded = Params && Params.embedded ? Params.embedded : false;

    this.AddActionContextId = this.Id + "AddActionContex";
    this.AddActionContex = webix.ui({
        view:"submenu",
        id:this.AddActionContextId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.AddActionContextId+"Email", icon: "envelope", value: LangHelper.GetString("QoE","E-mail action")},
            {id: this.AddActionContextId+"Http", icon: "sitemap", value: LangHelper.GetString("QoE","Http action")},
            {id: this.AddActionContextId+"Notification", icon: "bell", value: LangHelper.GetString("QoE","Notification action")},
            {id: this.AddActionContextId+"Telegram", icon: "paper-plane", value: LangHelper.GetString("QoE","Telegram action")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                if(id === _this.AddActionContextId+"Email")
                {
                    //_this._AddActionTabView(QoETriggerActionTypeEnum.email, new QoETriggerActionEmailModel({enabled:1, subject:LangHelper.GetString("QoE", "Trigger fired")+": "+"{trigger.name}", body:_this._GetTemplate()}));
                    _this.AddDefaultAction();
                }
                else if(id === _this.AddActionContextId+"Http")
                {
                    _this._AddActionTabView(QoETriggerActionTypeEnum.http,  new QoETriggerActionHttpModel({enabled:1}));
                }
                else if(id === _this.AddActionContextId+"Notification")
                {
                    _this._AddActionTabView(QoETriggerActionTypeEnum.notification, new QoETriggerActionNotificationModel({enabled: 1}));
                }
                else if(id === _this.AddActionContextId+"Telegram")
                {
                    _this._AddActionTabView(QoETriggerActionTypeEnum.telegram, new QoETriggerActionTelegramModel({enabled: 1}));
                }
            }
        }
    });

    this.ActionParamsContextId = this.Id + "ActionParamsContext";
    this.ActionParamsContext = webix.ui({
        view: "popup",
        id:this.ActionParamsContextId ,
        maxWidth: 800,
        maxHeight: 680,
        body: {
            rows:[
                {
                    borderless:true,
                    height: 80,
                    template:LangHelper.GetString("QoE", "Select one or more identifiers (via shift or ctr). Use ctrl + c to copy and ctrl + v to insert a message into the template.")
                },
                {
                    borderless:true,
                    id:this.ActionParamsContextId + "Table",
                    name: "headers",
                    view: "datatable",
                    select:"cell",
                    multiselect:true,
                    clipboard:"selection",
                    resizeColumn:true,
                    tooltip:true,
                    // scroll:true,
                    checkboxRefresh:true,
                    height:560,
                    // autoheight:true,
                    columns:
                        [
                            {
                                id: "id",
                                header: [TooltipTemplate(LangHelper.GetString("QoE", "Id"))],
                                fillspace: 2
                            },
                            {
                                id: "value",
                                header: [TooltipTemplate(LangHelper.GetString("QoE", "Value"))],
                                fillspace: 3
                            }
                        ],
                    data:Helper.DictToArr(QoETriggerAlertActionBodyTemplateParametersDic)
                }
            ]
        }
    });

    this.HttpActionTemplatesContexMenuId = this.Id + "HttpActionTemplatesContexMenu";
    this.HttpActionTemplatesContexMenu = webix.ui({
        view:"submenu",
        id:this.HttpActionTemplatesContexMenuId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.HttpActionTemplatesContexMenuId+"RedmineJson", value: LangHelper.GetString("QoE", "Redmine JSON")},
            {id: this.HttpActionTemplatesContexMenuId+"RedmineXml", value: LangHelper.GetString("QoE","Redmine XML")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "</span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                var tabId = _this.Views.GroupActionsTabBar.getValue();
                if(!tabId)
                    return;

                var form = _this.Views.GroupActionsTabBarElems[tabId] ? _this.Views.GroupActionsTabBarElems[tabId].form : null;
                if(!form)
                    return;

                var headersTable = $$(tabId+"HeadersTable");
                headersTable.clearAll();

                form.elements.method.setValue("POST");

                if(id === _this.HttpActionTemplatesContexMenuId+"RedmineJson")
                {
                    var model = new QoETriggerActionHttpHeaderModel();

                    form.elements.url.setValue("https://your_redmine_host/issues.json?key=your_redmine_api_key");

                    headersTable.parse([new QoETriggerActionHttpHeaderModel({name:"Content-Type", value:"application/json"})]);

                    form.elements.body.setValue(_this._GetTemplate("redmine.json"));
                }
                else if(id === _this.HttpActionTemplatesContexMenuId+"RedmineXml")
                {
                    form.elements.url.setValue("https://your_redmine_host/issues.xml?key=your_redmine_api_key");

                    headersTable.parse([new QoETriggerActionHttpHeaderModel({name:"Content-Type", value:"application/xml"})]);
                    form.elements.body.setValue(_this._GetTemplate("redmine.xml"));
                }
            }
        }
    });

    this.InitedWidgets = {};

    this.Views = {
        TriggerBtn:null,
        CommonForm:null,
        NoDataForm:null,
        ActionsSendEmailForm:null,

        QueriesTableForm:null,

        ConditionsTableForm:null,

        WidgetsSuggest: new QoEWidgetsSuggestWidget({
            id:this.Id + "WidgetsSuggest",
            exceptWidgetCodes: ExceptWidgetCodes.panels_maps
        }),

        ExtendedFillter: new QoEPopupFilterWidget({
            id:this.Id + "ExtendedFillter",
            config:QoEPopupFilterWidgetDefaultConfig()
        }),

        GroupActionsTabBar:null,
        GroupActionsTabBarViews:null,
        GroupActionsTabBarElems:{}
    };

    this.ViewConfig = {
        rows:[
            {
                type: "clear",
                borderless: true,
                view: "scrollview",
                id: this.Id + "GroupsScrollView",
                scroll:"y",
                body:
                {
                    cols:[
                        {width:16},
                        {
                            rows:[
                                {
                                    view:"accordion",
                                    multi:true,
                                    rows:[
                                        {
                                            height:1,
                                            id: this.Id + "GroupCommonAnchor"
                                        },
                                        {
                                            id: this.Id + "GroupCommon",
                                            header:LangHelper.GetString("QoE", "Common"),
                                            //collapsed:true,
                                            body:{
                                                rows:[
                                                    {
                                                        id:this.Id + "CommonForm",
                                                        view: "form",
                                                        borderless: true,
                                                        elements: [
                                                            {
                                                                cols:[
                                                                    {
                                                                        gravity:2,
                                                                        view: "text",
                                                                        name: "name",
                                                                        label: LangHelper.GetString("QoE","Trigger name"),
                                                                        labelPosition: "top",
                                                                        tooltip:LangHelper.GetString("QoE","Trigger title / description"),
                                                                        required: true,
                                                                        invalidMessage: LangHelper.GetString("QoE", "Enter trigger name"),
                                                                        validate: webix.rules.isNotEmpty,
                                                                        attributes:{maxlength:50},
                                                                        on: {
                                                                            "onChange": function () {
                                                                                this.validate();
                                                                            }
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"richselect",
                                                                        name:"severity",
                                                                        label: LangHelper.GetString("QoE","Severity"),
                                                                        labelPosition: "top",
                                                                        options:function ()
                                                                        {
                                                                            var o = [];

                                                                            Object.keys(QoETriggerSeverityEnum).forEach(function (Key) {
                                                                                o.push({id:Key, value:LangHelper.GetString("QoE",Helper.CapitalizeFirstLetter(Key))});
                                                                            });

                                                                            return o;
                                                                        }(),
                                                                        on: {
                                                                            "onChange": function () {
                                                                                this.validate();
                                                                            }
                                                                        }
                                                                    },
                                                                    {
                                                                        align: "right",
                                                                        body:
                                                                        {
                                                                            view: "switch",
                                                                            name:"enabled",
                                                                            label:LangHelper.GetString("QoE","Trigger"),
                                                                            onLabel: LangHelper.GetString("QoE","Enabled"),
                                                                            offLabel: LangHelper.GetString("QoE","Disabled"),
                                                                            width: 240,
                                                                            labelWidth: 120
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                cols:[
                                                                    {
                                                                        view: "multiselect",
                                                                        name: "days_of_week",
                                                                        label: LangHelper.GetString("QoE","Days of the week"),
                                                                        options: Helper.DictToArr(DaysOfWeekDic),
                                                                        tooltip: LangHelper.GetString("QoE", "Days when the trigger works"),
                                                                        labelPosition: "top",
                                                                        required: true,
                                                                        invalidMessage: LangHelper.GetString("QoE", "Should be selected at least one day of week"),
                                                                        on: {
                                                                            "onChange": function () {
                                                                                this.validate();
                                                                            }
                                                                        }
                                                                    },
                                                                    {
                                                                        view: "richselect",
                                                                        name: "evaluate_every_seconds",
                                                                        options:Helper.DictToArr(QoESecondsChunckPeriodDic),
                                                                        label: LangHelper.GetString("QoE","Check frequency"),
                                                                        labelPosition: "top",
                                                                        tooltip:LangHelper.GetString("QoE","Check frequency in seconds"),
                                                                        required: true,
                                                                        invalidMessage: LangHelper.GetString("QoE", "Required field"),
                                                                        validate: webix.rules.isNotEmpty,
                                                                        attributes:{maxlength:10},
                                                                        on: {
                                                                            "onChange": function () {
                                                                                this.validate();
                                                                            }
                                                                        }
                                                                    },
                                                                    {
                                                                        view: "text",
                                                                        type:"number",
                                                                        name: "for_count",
                                                                        label: LangHelper.GetString("QoE","Number of positives"),
                                                                        labelPosition: "top",
                                                                        tooltip:LangHelper.GetString("QoE","Number of positives before notification")
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                cols:[
                                                                    {
                                                                        view: "datepicker",
                                                                        name: "date_from",
                                                                        tooltip: LangHelper.GetString("QoE", "Trigger start date"),
                                                                        label: LangHelper.GetString("QoE","Start date"),
                                                                        labelPosition: "top",
                                                                        required: false,
                                                                        stringResult: true
                                                                    },
                                                                    {
                                                                        view: "datepicker",
                                                                        name: "date_to",
                                                                        tooltip: LangHelper.GetString("QoE", "Trigger end date"),
                                                                        label: LangHelper.GetString("QoE","End date"),
                                                                        labelPosition: "top",
                                                                        required: false,
                                                                        stringResult: true
                                                                    },
                                                                    {
                                                                        view: "datepicker",
                                                                        type: "time",
                                                                        name:"time_from",
                                                                        tooltip: LangHelper.GetString("QoE", "Trigger start time"),
                                                                        labelPosition: "top",
                                                                        label: LangHelper.GetString("QoE", "Start time"),
                                                                        stringResult: true
                                                                    },
                                                                    {
                                                                        view: "datepicker",
                                                                        type: "time",
                                                                        name:"time_to",
                                                                        tooltip: LangHelper.GetString("QoE", "Trigger end time"),
                                                                        labelPosition: "top",
                                                                        label: LangHelper.GetString("QoE", "End time"),
                                                                        stringResult: true
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            height:31
                                        },
                                        {
                                            height:1,
                                            id: this.Id + "GroupQueriesAnchor"
                                        },
                                        {
                                            id: this.Id + "GroupQueries",
                                            header:LangHelper.GetString("QoE", "Queries"),
                                            //collapsed:true,
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id:this.Id + "AddQuery",
                                                                type: "icon",
                                                                icon: "plus",
                                                                align: "right",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString("QoE","Add query"),
                                                                click: function (id, e, node)
                                                                {
                                                                    const n = "QoETableTopRttSubscribersShortWidget";
                                                                    const w = _this.GetInitWidget(null, n);
                                                                    const model = new QoETriggerQueryModel({
                                                                        enabled:1,
                                                                        widget_name:n,
                                                                        widget_func:n,
                                                                        widget_config:w.Config,
                                                                        widget_filter:w.Filter,
                                                                        widget_pdf_config:_this._GetWidgetExportPdfConfig(w),
                                                                        period_from:"now - 15 minutes",
                                                                        period_to:"now"
                                                                    });

                                                                    _this.Views.QueriesTableForm.add(model);
                                                                    _this.Views.QueriesTableForm.select(model.id, false);
                                                                }
                                                            },
                                                            {
                                                                hidden:true,
                                                                rows:[
                                                                    this.Views.ExtendedFillter.ViewConfig
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        id:this.Id + "QueriesTableForm",
                                                        view: "datatable",
                                                        select: "row",
                                                        resizeColumn:true,
                                                        tooltip:true,
                                                        scroll:false,
                                                        editable:true,
                                                        checkboxRefresh:true,
                                                        autoheight:true,
                                                        //header:false,
                                                        columns:
                                                        [
                                                            {
                                                                id: "enabled",
                                                                header: "",
                                                                template: CellOnOffTemplate,
                                                                width: 80,
                                                                headermenu: false
                                                            },
                                                            {
                                                                id:"name",
                                                                header: LangHelper.GetString("QoE","Query name")
                                                            },
                                                            {
                                                                id:"widget_name",
                                                                header: LangHelper.GetString("QoE","Report"),
                                                                fillspace:2,
                                                                template:function (Obj)
                                                                {
                                                                    const locale = LangHelper.GetLocale();
                                                                    const item = _this.Views.WidgetsSuggest.FindItemByParams(Obj);
                                                                    return item && item.widget_name && item.widget_name[locale]
                                                                        ? item.widget_name[locale]
                                                                        : "";
                                                                }
                                                            },
                                                            {
                                                                id: "filter",
                                                                width:40,
                                                                header: "",//LangHelper.GetString("QoE","Filter"),
                                                                template: CellFilterBtnTemplate,
                                                                headermenu: false
                                                            },
                                                            {
                                                                id:"period_from",
                                                                header: LangHelper.GetString("QoE","Period from"),
                                                                fillspace:1,
                                                                editor:"richselect",
                                                                suggest: {fitMaster:false, width:240},
                                                                options:function ()
                                                                {
                                                                    var o = [];

                                                                    Object.keys(QoETriggerPeriodRangesEnum).forEach(function (Key) {
                                                                        o.push({id:Key, value:LangHelper.GetString("QoE",Key)})
                                                                    });

                                                                    return o;
                                                                }(),
                                                                template: function (Obj)
                                                                {
                                                                    return LangHelper.GetString("QoE",Obj.period_from);
                                                                }
                                                            },
                                                            {
                                                                id:"period_to",
                                                                header: LangHelper.GetString("QoE","Period to"),
                                                                fillspace:1,
                                                                editor:"richselect",
                                                                suggest: {fitMaster:false, width:240},
                                                                options:function ()
                                                                {
                                                                    var o = [];

                                                                    Object.keys(QoETriggerPeriodRangesEnum).forEach(function (Key) {
                                                                        o.push({id:Key, value:LangHelper.GetString("QoE",Key)})
                                                                    });

                                                                    return o;
                                                                }(),
                                                                template: function (Obj)
                                                                {
                                                                    return LangHelper.GetString("QoE",Obj.period_to);
                                                                }
                                                            },
                                                            {
                                                                fillspace:1
                                                            },
                                                            {
                                                                id: "trash",
                                                                header: "",
                                                                width: 32,
                                                                template: CellTrashBtnTemplate,
                                                                headermenu: false,
                                                                align:"right"
                                                            }
                                                        ],
                                                        data:[{enabled:1, widget_name:"QoETableTopRttSubscribersShortWidget", period_from:"now - 15 minute", period_to:"now"}],
                                                        on:
                                                        {
                                                            onItemClick: function (id,e,node)
                                                            {
                                                                if(id.column === 'trash')
                                                                {
                                                                    this.remove(id);
                                                                }

                                                                if(id.column === 'widget_name')
                                                                {
                                                                    _this.Views.WidgetsSuggest.Show(this.getItemNode({column:"widget_name", row:id.row}),"bottom");
                                                                }

                                                                if(id.column === 'filter')
                                                                {
                                                                    let fType, fConfig;
                                                                    const node = this.getItemNode(id);
                                                                    const rowData = this.getItem(id);

                                                                    const ws = _this.Views.WidgetsSuggest.FindItemByParams(rowData);

                                                                    fConfig = ws && ws.filter_config
                                                                        ? ws.filter_config
                                                                        : null;

                                                                    fType = fConfig && fConfig.type
                                                                        ? fConfig.type
                                                                        : ws && ws.filter_type ? ws.filter_type : null;

                                                                    if(!fType && rowData.widget_name) {
                                                                        var wn = rowData.widget_name.toLowerCase();

                                                                        if(wn.indexOf("clickstream") >= 0)
                                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawClickstreamLogs : QoEPopupFilterWidgetConfigTypeEnum.QoEClickstream;

                                                                        else if(wn.indexOf("fullnetflow") >= 0 || wn.indexOf("fullflow") >= 0)
                                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNetFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;

                                                                        else if(wn.indexOf("dns") >= 0)
                                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDnsFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullDnsFlow;

                                                                        else if(wn.indexOf("dns") >= 0)
                                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDnsFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullDnsFlow;

                                                                        else if(wn.indexOf("ddos") >= 0)
                                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDdosAttackFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullDdosAttackFlow;
                                                                    }

                                                                    if(!fConfig)
                                                                        fConfig = QoEPopupFilterWidgetDefaultConfig(fType);

                                                                    _this.Views.ExtendedFillter.SetConfig(fConfig);

                                                                    if(rowData.filter_state && fType == rowData.filter_type)
                                                                        _this.Views.ExtendedFillter.SetState(rowData.filter_state);
                                                                    else
                                                                        _this.Views.ExtendedFillter.SetState();

                                                                    rowData.filter_type = fType;

                                                                    _this.Views.ExtendedFillter.Show(node, "right");
                                                                }
                                                            },

                                                            "data->onStoreUpdated":function(){
                                                                this.data.each(function(obj, i)
                                                                {
                                                                    obj.name = (i+1 + 9).toString(36).toUpperCase();
                                                                })
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            height:31
                                        },
                                        {
                                            height:1,
                                            id: this.Id + "GroupConditionsAnchor"
                                        },
                                        {
                                            id: this.Id + "GroupConditions",
                                            header:LangHelper.GetString("QoE", "Conditions"),
                                            //collapsed:true,
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id:this.Id + "AddCondition",
                                                                type: "icon",
                                                                icon: "plus",
                                                                align: "right",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString("QoE","Add condition"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var model = new QoETriggerConditionModel({enabled:1, query_name:"A", query_func:QoETriggerConditionFunctionsEnum.avg});

                                                                    _this.Views.ConditionsTableForm.add(model);
                                                                    _this.Views.ConditionsTableForm.select(model.id, false);
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        id:this.Id + "ConditionsTableForm",
                                                        view: "datatable",
                                                        select: "row",
                                                        resizeColumn:true,
                                                        tooltip:true,
                                                        scroll:false,
                                                        editable:true,
                                                        checkboxRefresh:true,
                                                        autoheight:true,
                                                        //header:false,
                                                        columns:
                                                        [
                                                            {
                                                                id: "enabled",
                                                                header: "",
                                                                template: CellOnOffTemplate,
                                                                width: 80,
                                                                headermenu: false
                                                            },
                                                            {
                                                                id:"where_bind",
                                                                header:LangHelper.GetString("QoE", "Bind"),
                                                                editor:"richselect",
                                                                options:function ()
                                                                {
                                                                    var o = [];
                                                                    Object.keys(QoETriggerConditionWhereBindEnum).forEach(
                                                                        function (Key) {
                                                                            o.push({id:QoETriggerConditionWhereBindEnum[Key], value:LangHelper.GetString("QoE",QoETriggerConditionWhereBindEnum[Key])});
                                                                        }
                                                                    );

                                                                    return o;
                                                                }()
                                                            },
                                                            {
                                                                id:"query_name",
                                                                header:LangHelper.GetString("QoE", "Query name"),
                                                                editor:"richselect"
                                                            },
                                                            {
                                                                id:"query_func",
                                                                header:LangHelper.GetString("QoE", "Function"),
                                                                editor:"richselect",
                                                                suggest: {fitMaster:false, width:240},
                                                                // template:function (Obj)
                                                                // {
                                                                //     return Obj.query_func ? Obj.query_func + "()" : "";
                                                                // },
                                                                options:function ()
                                                                {
                                                                    var o = [];

                                                                    Object.keys(QoETriggerConditionFunctionsEnum).forEach(function (Key)
                                                                    {
                                                                        o.push({id:Key, value:Key});
                                                                    });

                                                                    return o;
                                                                }()
                                                            },
                                                            {
                                                                id:"query_func_combinator",
                                                                header:LangHelper.GetString("QoE", "Combinator"),
                                                                editor:"richselect",
                                                                suggest: {fitMaster:false, width:240},
                                                                // template:function (Obj)
                                                                // {
                                                                //     return Obj.query_func ? Obj.query_func + "()" : "";
                                                                // },
                                                                options:function ()
                                                                {
                                                                    var o = [{id:"", value:""}];

                                                                    Object.keys(QoETriggerConditionFunctionsCombinatorsEnum).forEach(function (Key)
                                                                    {
                                                                        o.push({id:Key, value:LangHelper.GetString("QoE",QoeTriggersConditionsCombinatorsDic[Key].value)});
                                                                    });

                                                                    return o;
                                                                }()
                                                            },
                                                            {
                                                                id:"query_field",
                                                                header:LangHelper.GetString("QoE", "Serie"),
                                                                editor:"richselect",
                                                                suggest: {fitMaster:false, width:240},
                                                                template:function (obj, common, val, config)
                                                                {
                                                                    var field = obj.query_field ? obj.query_field : "";

                                                                    var data = _this._GetQueryFieldsSuggestOptions(obj.query_name);

                                                                    var dic = data ? Helper.ArrToDic(data) : {};

                                                                    return dic[obj.query_field] ? dic[obj.query_field] : field;
                                                                }
                                                            },
                                                            {
                                                                id:"query_operator",
                                                                header:LangHelper.GetString("QoE", "Operator"),
                                                                editor:"richselect",
                                                                suggest: {fitMaster:false, width:160},
                                                                options:function ()
                                                                {
                                                                    var o = [];

                                                                    Object.keys(QoETriggerConditionOperatorsEnum).forEach(function (Key)
                                                                    {
                                                                        o.push(Key);
                                                                    });

                                                                    return o;
                                                                }()
                                                            },
                                                            {
                                                                id: "query_value",
                                                                header: [TooltipTemplate(LangHelper.GetString("QoEPopupFilterWidget", "Value"))],
                                                                fillspace: 2,
                                                                editor: "text"
                                                            },
                                                            {
                                                                id: "trash",
                                                                header: "",
                                                                width: 32,
                                                                template: CellTrashBtnTemplate,
                                                                headermenu: false,
                                                                align:"right"
                                                            }
                                                        ],
                                                        data:[new QoETriggerConditionModel({enabled:1, query_name:"A", query_func:QoETriggerConditionFunctionsEnum.avg})],
                                                        on:
                                                        {
                                                            onItemClick: function (id,e,node)
                                                            {
                                                                if (id.column === 'trash')
                                                                {
                                                                    this.editStop();
                                                                    this.remove(id);
                                                                }
                                                            },
                                                            onBeforeEditStart:function(id)
                                                            {
                                                                var config = this.getColumnConfig(id.column);

                                                                var item = this.getItem(id.row);

                                                                if(id.column == "query_name")
                                                                {
                                                                    config.collection = new webix.DataCollection({data:_this._GetQueriesSuggestOptions()});
                                                                    config.editor = "richselect";
                                                                }

                                                                else if(id.column == "query_field")
                                                                {
                                                                    var data = _this._GetQueryFieldsSuggestOptions(item.query_name);
                                                                    config.collection = new webix.DataCollection({data:data});
                                                                    config.editor = "richselect";
                                                                }

                                                                else if(id.column == "query_value")
                                                                {
                                                                    config.collection = null;
                                                                    config.popup = null;
                                                                    config.$popup = null;
                                                                    config.editor = "text";

                                                                    var operator = item.query_operator;

                                                                    if(operator == QoETriggerConditionOperatorsEnum.between || operator == QoETriggerConditionOperatorsEnum["not between"])
                                                                    {
                                                                        config.editor = "popup";
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            height:31
                                        },
                                        {
                                            height:1,
                                            id: this.Id + "GroupConditionsAnchor"
                                        },
                                        {
                                            id: this.Id + "GroupNoData",
                                            header: LangHelper.GetString("QoE", "No data & error handling"),
                                            //collapsed:true,
                                            body: {
                                                rows:[
                                                    {
                                                        id:this.Id + "NoDataForm",
                                                        view: "form",
                                                        borderless: true,
                                                        elements: [
                                                            {
                                                                cols:[
                                                                    {
                                                                        view: "richselect",
                                                                        name: "no_data",
                                                                        label: LangHelper.GetString("QoE","If no data"),
                                                                        options:function ()
                                                                        {
                                                                            var o = [];

                                                                            Object.keys(QoETriggerAlertStateEnum).forEach(function (Key) {
                                                                                o.push({id:Key, value:LangHelper.GetString("QoE",Helper.CapitalizeFirstLetter(Key))});
                                                                            });

                                                                            return o;
                                                                        }(),
                                                                        tooltip: LangHelper.GetString("QoE", "Set state when no data"),
                                                                        labelPosition: "top",
                                                                        required: true,
                                                                        invalidMessage: LangHelper.GetString("QoE", "Should be selected at least one day of week"),
                                                                        validate: webix.rules.isNotEmpty,
                                                                        on: {
                                                                            "onChange": function () {
                                                                                this.validate();
                                                                            }
                                                                        }
                                                                    },
                                                                    {
                                                                        view: "richselect",
                                                                        name: "error",
                                                                        label: LangHelper.GetString("QoE","If execution error or timeout"),
                                                                        options:function ()
                                                                        {
                                                                            var o = [];

                                                                            Object.keys(QoETriggerAlertStateEnum).forEach(function (Key) {
                                                                                o.push({id:Key, value:LangHelper.GetString("QoE",Helper.CapitalizeFirstLetter(Key))});
                                                                            });

                                                                            return o;
                                                                        }(),
                                                                        tooltip: LangHelper.GetString("QoE", "Set state when execution error or timeout"),
                                                                        labelPosition: "top",
                                                                        required: true,
                                                                        invalidMessage: LangHelper.GetString("QoE", "Should be selected at least one day of week"),
                                                                        validate: webix.rules.isNotEmpty,
                                                                        on: {
                                                                            "onChange": function () {
                                                                                this.validate();
                                                                            }
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            height:31
                                        },
                                        {
                                            height:1,
                                            id: this.Id + "GroupActionsAnchor"
                                        },
                                        {
                                            id: this.Id + "GroupActions",
                                            header: LangHelper.GetString("QoE", "Actions"),
                                            body: {
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                        //borderless:true,
                                                        elements: [
                                                            {
                                                                view:"tabbar",
                                                                id:this.Id + "GroupActionsTabBar",
                                                                close:true,
                                                                optionWidth:160,
                                                                multiview:true,
                                                                options:[
                                                                    //{id:this.Id + "GroupActionsTabBar" + "0", value:"E-mail"}
                                                                ],
                                                                on:{
                                                                    onOptionRemove: function (Id, Val)
                                                                    {
                                                                        _this._RemoveActionTabView(Id);
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                width:32
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "AddAction",
                                                                type: "icon",
                                                                icon: "plus",
                                                                align: "right",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString("QoE","Add action"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var node = this.getNode(id);
                                                                    _this.AddActionContex.show(node, {pos: "bottom"});
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        animate:false,
                                                        id: this.Id + "GroupActionsTabBarViews",
                                                        cells:[
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            height:32
                                        }
                                    ]
                                }
                            ]
                        },
                        {width:16}
                    ]
                }
            },
            {
                view: "form",
                borderless: true,
                elements: [
                    {
                        cols:[
                            {gravity:4},
                            {
                                view:"button",
                                label:LangHelper.GetString(this.Id,"Cancel"),
                                click:function ()
                                {
                                    _this.Hide();
                                }
                            },
                            {
                                view:"button",
                                type:"form",
                                label:LangHelper.GetString(this.Id,"Save"),
                                //hotkey: "enter",
                                click:function ()
                                {
                                    setTimeout(function () {
                                        _this.Save();
                                    },1);
                                }
                            },
                            {width:32}
                        ]
                    }
                ]
            }
        ]
    };

    this.TemplatesManager = new MailingTemplatesManager();

    this.ContextConfig = {
        view: "popup",
        //fullscreen:true,
        modal: true,
        id:this.Id + "Context",
        maxWidth: 960,
        height:"auto",
        //maxHeight: 800,
        resize: true,
        body: {}
    };

    this.Context = null;

    this.Signals = {
        Save:new Rx.BehaviorSubject(null),
        QueriesTableFormChanged:new Rx.BehaviorSubject(0)

    };

    this.Subscriptions = {};

    this.Data = null;

    this.Init(Params);
}

QoETriggerEditViewController.prototype.Init = function (Params)
{
    var _this = this;

    if(!this.Embedded)
    {
        this.ContextConfig.body = this.ViewConfig;
        this.Context = webix.ui(this.ContextConfig);
    }
};

QoETriggerEditViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);

    //this._AddActionTabView();
};

QoETriggerEditViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.CommonForm = $$(this.Id + "CommonForm");

    this.Views.NoDataForm = $$(this.Id + "NoDataForm");

    this.Views.WidgetsSuggest.Bind(this);

    this.Views.QueriesTableForm = $$(this.Id + "QueriesTableForm");

    this.Views.ConditionsTableForm = $$(this.Id + "ConditionsTableForm");

    //this.Views.ActionsSendEmailForm = $$(this.Id + "ActionsSendEmailForm");
    this.Views.GroupQueries = $$(this.Id + "GroupQueries");

    this.Views.ExtendedFillter.Bind(this);

    this.Views.GroupActionsTabBar = $$(this.Id + "GroupActionsTabBar");

    this.Views.GroupActionsTabBarViews = $$(this.Id + "GroupActionsTabBarViews");

    this.Subscriptions.WidgetsListSelectSignal = this.Views.WidgetsSuggest.Signals.Select.subscribe(function (Params)
    {
        if(Params && Params.widget_code) {
            let widget = _this.GetInitWidget(Params.widget_code);

            if(!widget)
                return;

            const params = {
                widget_code: Params.widget_code,
                widget_name: widget.Name,
                widget_func: Params.func,
                widget_config: widget.Config,
                widget_filter: widget.Filter,
                widget_pdf_config: _this._GetWidgetExportPdfConfig(widget)
            };

            // if(Params.filter_config) {
            //     params.filter_config = Params.filter_config;
            //     params.filter_type = Params.filter_config.type;
            // }

            let formItem = _this.Views.QueriesTableForm.getSelectedItem();
            formItem = webix.extend(formItem, params, true);

            _this.Views.QueriesTableForm.updateItem(
                formItem.id,
                new QoETriggerQueryModel(formItem)
            );
        }
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            var selectedData = _this.Views.QueriesTableForm.getSelectedItem();

            selectedData.filter_state = _this.Views.ExtendedFillter.GetState();

            selectedData.filter_config = _this.Views.ExtendedFillter.GetFilters();

            _this.Views.QueriesTableForm.updateItem(selectedData.id,  new QoETriggerQueryModel(selectedData));
        }

    });

    this.Subscriptions.UpdateTemplatesError = this.TemplatesManager.Signals.RefreshTemplatesListError.subscribe(function(Error) {
        if(Error && Error.msg)
            webix.message({type: "error", text: Error.msg});
    });

    this.Views.WidgetsSuggest.RefreshWidgets();

    this.TemplatesManager.RefreshTemplatesList();

    // this.Views.QueriesTableForm.attachEvent("onDataUpdate", function(id, data)
    // {
    //     _this.Signals.QueriesTableFormChanged.next(1);
    //     return true;
    // });
    //
    // this.Subscriptions.QueriesTableFormChanged = this.Signals.QueriesTableFormChanged.subscribe(function (Signal)
    // {
    //     if(Signal)
    //     {
    //         var options  = _this.Views.ConditionsTableForm.getColumnConfig("query_name").collection;
    //         options.clearAll();
    //         options.parse(_this._GetQueriesSuggestOptions());
    //     }
    //
    // });
};

QoETriggerEditViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.Views.WidgetsSuggest.Destroy();
};

QoETriggerEditViewController.prototype.Show = function (Node, Pos)
{
    if(!this.Embedded)
        this.Context.show(Node,{pos:Pos});
};

QoETriggerEditViewController.prototype.Hide = function ()
{
    if(!this.Embedded)
        this.Context.hide();

    this.Clear();
};

QoETriggerEditViewController.prototype.Clear = function ()
{
    this.Views.CommonForm.clear();
    this.Views.CommonForm.clearValidation();

    this.Views.NoDataForm.clear();
    this.Views.NoDataForm.clearValidation();

    this.Views.QueriesTableForm.clearAll();
    this.Views.ConditionsTableForm.clearAll()

    this._RemoveAllActionsTabs();

    //this.Views.ActionsSendEmailForm.clear();
    //this.Views.ActionsSendEmailForm.clearValidation();
};

QoETriggerEditViewController.prototype.Validate = function ()
{
    return this.Views.CommonForm.validate();
};

QoETriggerEditViewController.prototype.SetData = function (Data)
{
    var _this = this;

    this.Data = new QoETriggerModel(Data);

    this.Clear();

    this.Views.CommonForm.setValues(new QoETriggerCommonModel(this.Data));

    const qItems = JSON.parse(this.Data.queries_json)
        .map(Params => new QoETriggerQueryModel(Params));

    this.Views.QueriesTableForm.parse(qItems);

    this.Views.ConditionsTableForm.parse(JSON.parse(this.Data.conditions_json));

    this.Views.NoDataForm.setValues(new QoETriggerWhenNodataErrorModel(JSON.parse(this.Data.when_nodata_or_error_json)));

    var actions = JSON.parse(this.Data.actions_json);

    if(actions)
    {
        actions.every(function (A)
        {
            var action = new QoETriggerActionModel(A);

            if(action.type == QoETriggerActionTypeEnum.email)
            {
                _this._AddActionTabView(action.type, new QoETriggerActionEmailModel(action.model));
            }
            else if(action.type == QoETriggerActionTypeEnum.http)
            {
                _this._AddActionTabView(action.type, new QoETriggerActionHttpModel(action.model));
            }
            else if(action.type == QoETriggerActionTypeEnum.notification)
            {
                _this._AddActionTabView(action.type, new QoETriggerActionNotificationModel(action.model));
            }
            else if(action.type == QoETriggerActionTypeEnum.telegram)
            {
                _this._AddActionTabView(action.type, new QoETriggerActionTelegramModel(action.model));
            }

            return true;
        });
    }

    if(this.Data.type == QoETriggerTypeEnum.system)
    {
        this.Views.GroupQueries.disable();
        this.Views.CommonForm.elements.name.disable();
    }
    else{
        this.Views.GroupQueries.enable();
        this.Views.CommonForm.elements.name.enable();
    }
};

QoETriggerEditViewController.prototype.GetData = function ()
{
    var _this = this;

    var common = new QoETriggerCommonModel(this.Views.CommonForm.getValues());
    var nodata = new QoETriggerWhenNodataErrorModel(this.Views.NoDataForm.getValues());

    var queries = [];
    this.Views.QueriesTableForm.serialize().forEach(function (Item)
    {
        queries.push(new QoETriggerQueryModel(Item));
    });

    var conditions = [];
    this.Views.ConditionsTableForm.serialize().forEach(function (Item)
    {
        conditions.push(new QoETriggerConditionModel(Item));
    });

    var actions = [];

    Object.keys(this.Views.GroupActionsTabBarElems).forEach(function (Id)
    {
        var view = _this.Views.GroupActionsTabBarElems[Id];

        var action = null;

        if(view.type == QoETriggerActionTypeEnum.email)
        {
            var action = new QoETriggerActionModel({
                type:view.type,
                model:new QoETriggerActionEmailModel(view.form.getValues())
            });
        }
        else if(view.type == QoETriggerActionTypeEnum.http)
        {
            var model = view.form.getValues();

            var headers = $$(Id+"HeadersTable").serialize();

            var headersModel = [];

            headers.forEach(function (H)
            {
                headersModel.push(new QoETriggerActionHttpHeaderModel(H))
            });

            model = webix.extend(model,{headers:headersModel}, true);

            var action = new QoETriggerActionModel({
                type:view.type,
                model:new QoETriggerActionHttpModel(model)
            });
        }
        else if(view.type == QoETriggerActionTypeEnum.notification)
        {
            var model = view.form.getValues();

            var action = new QoETriggerActionModel({
                type: view.type,
                model: new QoETriggerActionNotificationModel(model)
            })
        }
        else if(view.type == QoETriggerActionTypeEnum.telegram)
        {
            var action = new QoETriggerActionModel({
                type:view.type,
                model:new QoETriggerActionTelegramModel(view.form.getValues())
            });
        }

        if(action)
            actions.push(action);

    });

    this.Data = new QoETriggerModel(webix.extend(common,{
        _id:this.Data._id,
        when_nodata_or_error_json:JSON.stringify(nodata),
        queries_json: JSON.stringify(queries),
        conditions_json: JSON.stringify(conditions),
        actions_json:JSON.stringify(actions)
    }));

    return this.Data;
};

QoETriggerEditViewController.prototype.Save = function ()
{
    if(this.Validate())
        this.Signals.Save.next(this.GetData());
};

QoETriggerEditViewController.prototype._GetQueriesSuggestOptions = function ()
{
    var o = [];

    var data = this.Views.QueriesTableForm.serialize();

    data.forEach(function (Row)
    {
        if(Row.name)
            o.push({id:Row.name, value:Row.name});
    });

    return o;
};

QoETriggerEditViewController.prototype._GetQueryFieldsSuggestOptions = function (QueryName)
{
    let o = [];
    let queryTableItem;

    const data = this.Views.QueriesTableForm.serialize();

    data.every((Row) => {
        if(Row.name && Row.name == QueryName) {
            queryTableItem = Row;
            return false;
        }
        return true;
    });

    const widget = this.GetInitWidget(
        queryTableItem ? queryTableItem.widget_code : null,
        queryTableItem ? queryTableItem.widget_name : null
    );

    if(widget)
    {
        if(widget.Config && widget.Config.cache)
        {
            var columnsHeadersDic = this._GetWidgetColumns(widget);

            columnsHeadersDic = columnsHeadersDic ? columnsHeadersDic : {};

            widget.Config.cache.values.forEach(function (V)
            {
                var obj;

                if(typeof V == "string")
                    obj = {id:V, value:V};

                else if(typeof V == "object")
                {
                    if(V.alias)
                        obj = {id:V.alias, value:V.alias};

                    else if(V.col)
                        obj = {id:V.col, value:V.col};
                }

                if(obj)
                {
                    try {
                        obj.value = Helper.DecodeBase64Safe(obj.value);
                    }
                    catch (e) {}

                    var id = obj.id.replace("_any", "");

                    obj.value = columnsHeadersDic[id] ? columnsHeadersDic[id] :  obj.value;

                    o.push(obj);
                }

            });
        }
    }

    return o;
};

QoETriggerEditViewController.prototype.GetInitWidget = function(WidgetCode = null, WidgetName = null)
{
    if(!WidgetCode && !WidgetName)
        return;

    let widget = WidgetCode ? this.InitedWidgets[WidgetCode] : null;

    if(widget)
        return widget;

    const ws = this.Views.WidgetsSuggest.FindItem(WidgetCode, WidgetName, WidgetName);

    widget = ws && ws.widget_code ? this.InitedWidgets[ws.widget_code] : null;

    if(widget)
        return widget;

    const wType = ws && ws.widget_icon ? ws.widget_icon : null;
    const wFunc = ws && ws.func ? ws.func : null;
    const wParams = ws && ws.widget_settings ? ws.widget_settings : {};

    if(!window[wFunc])
        return;

    const w = new window[wFunc](wParams);
    this.InitedWidgets[ws.widget_code] = Helper.IsTableChartWidget(w) ? w.GetSubWidget(wType) : w;

    return this.InitedWidgets[ws.widget_code];
};

QoETriggerEditViewController.prototype._GetWidgetExportPdfConfig = function (Widget)
{
    let config = null;

    if(Widget.PdfExportConfig) {
        if(Widget.PdfExportConfig.view_type === "table")
            Widget.AddAllColumnLocales();
        config = WidgetPdfConfigModel({widget_pdf_config: Widget.PdfExportConfig});
    }

    return config;
};

QoETriggerEditViewController.prototype._GetWidgetColumns = function (Widget)
{
    if(Widget)
    {
        var config = Widget && Widget.Config && Widget.Config ? Widget.Config : null;

        var viewConfig = Widget && Widget.ViewConfig ? Widget.ViewConfig : null;

        var itemsMap = Widget && Widget.ItemsMap ? Widget.ItemsMap : null;

        var colsDic = {
            "subscriber":LangHelper.GetString("QoE", "Subscriber"),
            "login":LangHelper.GetString("QoE", "Login"),
            "login_any":LangHelper.GetString("QoE", "Login"),
            "host_other":LangHelper.GetString("QoE", "Host"),
            "rtt":LangHelper.GetString("QoE", "RTT"),
            "retransmits":LangHelper.GetString("QoE", "Retransmits"),
            "protocol":LangHelper.GetString("QoE", "Protocol"),
            "host_ip":LangHelper.GetString("QoE", "Host IP"),
            "host_category":LangHelper.GetString("QoE", "Host category"),
            "destination_asnum":LangHelper.GetString("QoE", "AS number"),
            "source_asnum":LangHelper.GetString("QoE", "AS number"),
            "hw_ip":LangHelper.GetString("QoE", "IP-адрес коммутатора"),
            "device_other":LangHelper.GetString("QoE", "Device")
        };

        if(viewConfig && viewConfig.rows)
        {
            viewConfig.rows.every(function (Row)
            {
                if(Row.view && Row.view == "datatable")
                {
                    var cols = Row.columns;

                    cols.forEach(function (Col) {
                        if(Col.header && Array.isArray(Col.header))
                        {
                            colsDic[Col.id] = Col.header[0];
                        }
                        else if(Col.header && typeof Col.header == "string")
                        {
                            colsDic[Col.id] = Col.header;
                        }
                    });

                    return false;
                }

                return true;
            });
        }

        if(itemsMap)
        {
            Object.keys(itemsMap).forEach(function (Key) {
                if(itemsMap[Key].text)
                    colsDic[Key] = itemsMap[Key].text;
            });
        }

        if(config && config.table)
        {
            var cols = [];

            if(config.table == QoEReportTablesEnum.FullnetflowAgg)
            {
                cols = QoETableNetflowTopCommonConfig().columns;
            }
            else if(config.table == QoEReportTablesEnum.ClickstreamAgg)
            {
                cols = QoETableClickstreamTopCommonConfig().columns;
            }

            cols.forEach(function (Col) {
                if(Col.header && Array.isArray(Col.header))
                {
                    colsDic[Col.id] = Col.header[0];
                }
                else if(Col.header && typeof Col.header == "string")
                {
                    colsDic[Col.id] = Col.header;
                }
            });
        }

        return colsDic;
    }

    return null;
};

QoETriggerEditViewController.prototype._AddActionTabView = function (Type, Model)
{
    var id = webix.uid();

    var type = Type ? Type : QoETriggerActionTypeEnum.email;

    var title = "Http";

    if(type == QoETriggerActionTypeEnum.http)
    {
        title = "Http";
        this._AddActionTabHttpForm(id);

        this._AddUserTemplatesListView(id, MailingTemplatesTypesEnum.http);
    }
    else if(type === QoETriggerActionTypeEnum.email)
    {
        title = "E-mail";
        this._AddActionTabEmailForm(id);

        this._AddUserTemplatesListView(id, MailingTemplatesTypesEnum.mail);
    }
    else if(type === QoETriggerActionTypeEnum.notification)
    {
        title = LangHelper.GetString("QoE", "Notification");
        this._AddActionTabNotification(id);
    }
    else if(type === QoETriggerActionTypeEnum.telegram)
    {
        title = "Telegram";
        this._AddActionTabTelegramForm(id);

        this._AddUserTemplatesListView(id, MailingTemplatesTypesEnum.telegram);
    }

    this.Views.GroupActionsTabBar.addOption(id, title, true);
    this.Views.GroupActionsTabBarElems[id] = {
        id:id,
        type:type,
        view:$$(id),
        form:$$(id+"Form")
    };

    this.Views.GroupActionsTabBarElems[id].view.show();

    if(Model)
    {
        this.Views.GroupActionsTabBarElems[id].form.setValues(Model);

        if(type == QoETriggerActionTypeEnum.http)
        {
            $$(id+"HeadersTable").clearAll();
            $$(id+"HeadersTable").parse(Model.headers);
        }
    }

    return id;
};

QoETriggerEditViewController.prototype._AddActionTabNotification = function(Id)
{
    var _this = this;

    this.Views.GroupActionsTabBarViews.addView(
        {
            id:Id,
            rows:[
                {
                    height:2
                },
                {
                    id:Id+"Form",
                    view: "form",
                    borderless:true,
                    elements: [
                        {
                            cols:[
                                {
                                    view: "text",
                                    name: "title",
                                    label: LangHelper.GetString("QoE","Notification title"),
                                    labelPosition: "top",
                                    tooltip:LangHelper.GetString("QoE","Notification title"),
                                    attributes:{maxlength:1000},
                                    gravity:4,
                                    on: {
                                        "onChange": function () {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    align:"right",
                                    width: 80,
                                    body:{
                                        view: "switch",
                                        name:"enabled",
                                        onLabel: LangHelper.GetString("QoE","On"),
                                        offLabel: LangHelper.GetString("QoE","Off"),

                                        labelWidth: 0
                                    }
                                }
                            ]
                        },
                        {
                            cols:[
                                {
                                    view: "text",
                                    name: "subtitle",
                                    label: LangHelper.GetString("QoE","Notification subtitle"),
                                    labelPosition: "top",
                                    tooltip:LangHelper.GetString("QoE","Notification subtitle"),
                                    attributes:{maxlength:1000},
                                    // gravity:4,
                                    on: {
                                        "onChange": function () {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "richselect",
                                    name: "type",
                                    // width: 80,
                                    label: LangHelper.GetString("QoE","Notification type"),
                                    labelPosition: "top",
                                    tooltip:LangHelper.GetString("QoE","Notification type"),
                                    options: Helper.DictToArr(SocketNotificationsTypeDic)
                                }//,
                                // {
                                //     view: "text",
                                //     name: "type",
                                //     label: LangHelper.GetString("QoE","Notification type"),
                                //     labelPosition: "top",
                                //     tooltip:LangHelper.GetString("QoE","Notification type"),
                                //     attributes:{maxlength:1000},
                                //     // gravity:4,
                                //     on: {
                                //         "onChange": function () {
                                //             this.validate();
                                //         }
                                //     }
                                // }
                            ]
                        },
                        {
                            rows:[
                                {
                                    cols:[
                                        {
                                            view: "label",
                                            label: LangHelper.GetString("QoE","Message")
                                        },
                                        {
                                            view: "toolbar",
                                            borderless:true,
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "file-code",
                                                    width: 32,
                                                    css:"toolbar_round_btn",
                                                    tooltip:LangHelper.GetString("QoE","Set default template"),
                                                    borderless:true,
                                                    click: function (id, e, node)
                                                    {
                                                        var tabId = _this.Views.GroupActionsTabBar.getValue();
                                                        if(!tabId)
                                                            return;

                                                        var form = _this.Views.GroupActionsTabBarElems[tabId] ? _this.Views.GroupActionsTabBarElems[tabId].form : null;
                                                        if(!form)
                                                            return;

                                                        form.setValues(_this._GetNotificationTemplate());
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "code",
                                                    width: 32,
                                                    css:"toolbar_round_btn",
                                                    tooltip:LangHelper.GetString("QoE","Tepmplate parameters"),
                                                    borderless:true,
                                                    click: function (id, e, node)
                                                    {
                                                        var node = this.getNode(id);
                                                        _this.ActionParamsContext.show(node, {pos: "bottom"});
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {height: 8},
                                {
                                    id:webix.uid(),
                                    view:"nic-editor",
                                    name: "body",
                                    // label: LangHelper.GetString("QoE","Message"),
                                    // labelPosition: "top",
                                    labelHeight:0,
                                    labelWidth:0,
                                    minHeight:240,
                                    config:{
                                        fullPanel:true
                                        //buttonList: ['save', 'bold', 'italic', 'underline', 'left', 'center', 'right', 'justify', 'ol', 'ul', 'indent', 'outdent']
                                    }
                                }
                                // {
                                    // label: LangHelper.GetString("QoE","Body"),
                                    // labelPosition: "top",
                                    // tooltip:LangHelper.GetString("QoE","Notification body"),
                                //     view:"textarea",
                                //     name: "body",
                                //     minHeight:240
                                // }
                            ]
                        }
                    ]
                }
            ]
        }
    );

};

QoETriggerEditViewController.prototype._AddActionTabEmailForm = function (Id)
{
    var _this = this;

    this.Views.GroupActionsTabBarViews.addView(
        {
            id:Id,
            rows:[
                {
                    height:2
                },
                {
                    id:Id+"Form",
                    view: "form",
                    borderless:true,
                    elements: [
                        {
                            cols:[
                                {
                                    view: "text",
                                    name: "to",
                                    label: LangHelper.GetString("QoE","Send to"),
                                    labelPosition: "top",
                                    tooltip:LangHelper.GetString("QoE","Message recipients email-addresses"),
                                    attributes:{maxlength:1000},
                                    gravity:4,
                                    on: {
                                        "onChange": function () {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    align:"right",
                                    width: 80,
                                    body:{
                                        view: "switch",
                                        name:"enabled",
                                        onLabel: LangHelper.GetString("QoE","On"),
                                        offLabel: LangHelper.GetString("QoE","Off"),

                                        labelWidth: 0
                                    }
                                }
                            ]
                        },
                        {
                            view: "text",
                            name: "subject",
                            label: LangHelper.GetString("QoE","Subject"),
                            labelPosition: "top",
                            tooltip:LangHelper.GetString("QoE","Message subject"),
                            attributes:{maxlength:500},
                            on: {
                                "onChange": function () {
                                    this.validate();
                                }
                            }
                        },
                        {
                            view: "richselect",
                            name: "period_in_filename",
                            label: LangHelper.GetString("MailingTemplates", "Display period in filename"),
                            labelPosition: "top",
                            options: Helper.DictToArr(YesNoDic)
                        },
                        {
                            //type:"clear",
                            rows:[
                                {
                                    //height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                    cols:[
                                        {
                                            view: "label",
                                            label: LangHelper.GetString("QoE","Message")
                                        },
                                        {
                                            view: "toolbar",
                                            borderless:true,
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "file-code",
                                                    width: 32,
                                                    css:"toolbar_round_btn",
                                                    tooltip:LangHelper.GetString("QoE","Set template"),
                                                    borderless:true,
                                                    click: function (id, e, node)
                                                    {
                                                        const templatesList = $$(Id + "TemplatesListPopup");

                                                        if(templatesList)
                                                            if(templatesList.isVisible())
                                                                templatesList.hide();
                                                            else
                                                                templatesList.show(this.getNode(), {pos: "left"});
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "code",
                                                    width: 32,
                                                    css:"toolbar_round_btn",
                                                    tooltip:LangHelper.GetString("QoE","Tepmplate parameters"),
                                                    borderless:true,
                                                    click: function (id, e, node)
                                                    {
                                                        var node = this.getNode(id);
                                                        _this.ActionParamsContext.show(node, {pos: "bottom"});
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    height:8
                                },
                                {
                                    id:webix.uid(),
                                    view:"nic-editor",
                                    name: "body",
                                    // label: LangHelper.GetString("QoE","Message"),
                                    // labelPosition: "top",
                                    labelHeight:0,
                                    labelWidth:0,
                                    minHeight:240,
                                    config:{
                                        fullPanel:true
                                        //buttonList: ['save', 'bold', 'italic', 'underline', 'left', 'center', 'right', 'justify', 'ol', 'ul', 'indent', 'outdent']
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    );
};

QoETriggerEditViewController.prototype._AddActionTabHttpForm = function (Id)
{
    var _this = this;

    this.Views.GroupActionsTabBarViews.addView(
        {
            id:Id,
            rows:[
                {
                    height:2
                },
                {
                    id:Id+"Form",
                    view: "form",
                    borderless:true,
                    elements: [
                        {
                            cols:[
                                {
                                    view:"richselect",
                                    name: "method",
                                    label: LangHelper.GetString("QoE","Method"),
                                    labelPosition: "top",
                                    options:function () {
                                        var arr = [];

                                        Object.keys(QoETriggerActionHttpMethodEnum).forEach(function (Key) {
                                            arr.push({id:Key, value:Key});
                                        });

                                        return arr;
                                    }()
                                },
                                {
                                    view: "text",
                                    name: "url",
                                    label: LangHelper.GetString("QoE","Url"),
                                    labelPosition: "top",
                                    tooltip:"http://www.exmple.com",
                                    placeholder:"http://www.exmple.com",
                                    attributes:{maxlength:1000},
                                    gravity:3,
                                    on: {
                                        "onChange": function () {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    align:"right",
                                    width: 80,
                                    body:{
                                        view: "switch",
                                        name:"enabled",
                                        onLabel: LangHelper.GetString("QoE","On"),
                                        offLabel: LangHelper.GetString("QoE","Off"),

                                        labelWidth: 0
                                    }
                                }
                            ]
                        },
                        {
                            view:"accordion",
                            multi:true,
                            cols:[
                                {
                                    header:LangHelper.GetString("QoE","Headers"),
                                    //collapsed:true,
                                    body:
                                    {
                                        rows:[
                                            {
                                                view: "toolbar",
                                                height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                elements: [
                                                    {
                                                        view: "button",
                                                        type: "icon",
                                                        icon: "plus",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString("QoE","Add header"),
                                                        click: function (id, e, node)
                                                        {
                                                            var model = new QoETriggerActionHttpHeaderModel();

                                                            $$(Id + "HeadersTable").add(model);
                                                            $$(Id + "HeadersTable").editRow(model.id);
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                id:Id + "HeadersTable",
                                                name: "headers",
                                                view: "datatable",
                                                select: "row",
                                                resizeColumn:true,
                                                tooltip:true,
                                                scroll:false,
                                                editable:true,
                                                checkboxRefresh:true,
                                                autoheight:true,
                                                columns:
                                                [
                                                    {
                                                        id: "name",
                                                        header: [TooltipTemplate(LangHelper.GetString("QoE", "Name"))],
                                                        fillspace: 1,
                                                        editor: "text"
                                                    },
                                                    {
                                                        id: "value",
                                                        header: [TooltipTemplate(LangHelper.GetString("QoE", "Value"))],
                                                        fillspace: 1,
                                                        editor: "text"
                                                    },
                                                    {
                                                        id: "trash",
                                                        header: "",
                                                        width: 32,
                                                        template: CellTrashBtnTemplate,
                                                        headermenu: false,
                                                        align:"right"
                                                    }
                                                ],
                                                data:[],
                                                on:
                                                {
                                                    onItemClick: function (id,e,node)
                                                    {
                                                        if (id.column === 'trash')
                                                        {
                                                            this.remove(id);
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    header:LangHelper.GetString("QoE","Body"),
                                    gravity:2,
                                    body:{
                                        rows:[
                                            {
                                                view: "toolbar",
                                                borderless:true,
                                                elements: [
                                                    {},
                                                    {
                                                        view: "button",
                                                        type: "icon",
                                                        icon: "file-code",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString("QoE","Set default template"),
                                                        borderless:true,
                                                        click: function (id, e, node)
                                                        {
                                                            const templatesList = $$(Id + "TemplatesListPopup");

                                                            if(templatesList)
                                                                if(templatesList.isVisible())
                                                                    templatesList.hide();
                                                                else
                                                                    templatesList.show(this.getNode(), {pos: "left"});
                                                        }
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "icon",
                                                        icon: "code",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString("QoE","Tepmplate parameters"),
                                                        borderless:true,
                                                        click: function (id, e, node)
                                                        {
                                                            var node = this.getNode(id);
                                                            _this.ActionParamsContext.show(node, {pos: "bottom"});
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                view:"textarea",
                                                name: "body",
                                                minHeight:240
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    );
};

QoETriggerEditViewController.prototype._AddActionTabTelegramForm = function (Id)
{
    var _this = this;

    this.Views.GroupActionsTabBarViews.addView(
        {
            id:Id,
            rows:[
                {
                    height:2
                },
                {
                    id:Id+"Form",
                    view: "form",
                    borderless:true,
                    elements: [
                        {
                            cols:[
                                {
                                    view: "text",
                                    name: "chat_id",
                                    label: LangHelper.GetString("QoE","Chat Id"),
                                    labelPosition: "top",
                                    tooltip:LangHelper.GetString("QoE","Chat ID where the bot will send the message"),
                                    attributes:{maxlength:500},
                                    on: {
                                        "onChange": function () {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    align:"right",
                                    width: 80,
                                    body:{
                                        view: "switch",
                                        name:"enabled",
                                        onLabel: LangHelper.GetString("QoE","On"),
                                        offLabel: LangHelper.GetString("QoE","Off"),

                                        labelWidth: 0
                                    }
                                }
                            ]
                        },
                        {
                            view: "richselect",
                            name: "period_in_filename",
                            label: LangHelper.GetString("MailingTemplates", "Display period in filename"),
                            labelPosition: "top",
                            options: Helper.DictToArr(YesNoDic)
                        },
                        {
                            //type:"clear",
                            rows:[
                                {
                                    //height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                    cols:[
                                        {
                                            view: "label",
                                            label: LangHelper.GetString("QoE","Message")
                                        },
                                        {
                                            view: "toolbar",
                                            borderless:true,
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "file-code",
                                                    width: 32,
                                                    css:"toolbar_round_btn",
                                                    tooltip:LangHelper.GetString("QoE","Set default template"),
                                                    borderless:true,
                                                    click: function (id, e, node)
                                                    {
                                                        const templatesList = $$(Id + "TemplatesListPopup");

                                                        if(templatesList)
                                                            if(templatesList.isVisible())
                                                                templatesList.hide();
                                                            else
                                                                templatesList.show(this.getNode(), {pos: "left"});
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "code",
                                                    width: 32,
                                                    css:"toolbar_round_btn",
                                                    tooltip:LangHelper.GetString("QoE","Tepmplate parameters"),
                                                    borderless:true,
                                                    click: function (id, e, node)
                                                    {
                                                        var node = this.getNode(id);
                                                        _this.ActionParamsContext.show(node, {pos: "bottom"});
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    height:8
                                },
                                {
                                    id:webix.uid(),
                                    view:"nic-editor",
                                    name: "body",
                                    // label: LangHelper.GetString("QoE","Message"),
                                    // labelPosition: "top",
                                    labelHeight:0,
                                    labelWidth:0,
                                    minHeight:240,
                                    config:{
                                        fullPanel:true
                                        //buttonList: ['save', 'bold', 'italic', 'underline', 'left', 'center', 'right', 'justify', 'ol', 'ul', 'indent', 'outdent']
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    );
};

QoETriggerEditViewController.prototype._RemoveActionTabView = function (Id)
{
    this.Views.GroupActionsTabBar.blockEvent();
    this.Views.GroupActionsTabBar.removeOption(Id);
    this.Views.GroupActionsTabBar.unblockEvent();

    this.Views.GroupActionsTabBarViews.removeView(Id);
    delete this.Views.GroupActionsTabBarElems[Id];

    if($$(Id + "TemplatesListPopup"))
        $$(Id + "TemplatesListPopup").destructor();
};

QoETriggerEditViewController.prototype._RemoveAllActionsTabs = function (Id)
{
    var _this = this;

    Object.keys(this.Views.GroupActionsTabBarElems).forEach(function (Id)
    {
        _this._RemoveActionTabView(Id);
    });
};

QoETriggerEditViewController.prototype._GetTemplate = function (Id)
{
    var id = Id ? Id : "default";

    var tpl = {
        "default":'<p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Id")+':&nbsp;</b>{trigger.id}</p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Trigger")+'</b>: {trigger.name}</p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Status")+'</b>: {trigger.state}</p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Severity")+'</b>: {trigger.severity}<br></p><p class="MsoNormal"><br></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Queries")+'</b>:&nbsp;</p><p class="MsoNormal">{trigger.queries}</p><p class="MsoNormal"><br></p><p class="MsoNormal"><p class="MsoNormal"><br></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Reasons for the occurrence of notification")+'</b>:</p><p class="MsoNormal">{trigger.notification.notes}</p><p class="MsoNormal"><br></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Links to reports")+'</b>:</p><p class="MsoNormal">{trigger.report.link}</p><br><b>'+LangHelper.GetString("QoE","Links to reports")+'</b>:</p><p class="MsoNormal">{trigger.report.csv}</p><p class="MsoNormal">{trigger.report.tsv}</p><p class="MsoNormal">{trigger.report.xlsx}</p><p class="MsoNormal">{trigger.report.pdf}</p><p class="MsoNormal">{trigger.report.merged_pdf}</p>',

        "redmine.json":'{\n' +
        '"issue":{\n' +
        '"project_id":1,\n' +
        '"subject":"'+LangHelper.GetString("QoE","Trigger fired")+': {trigger.name}",\n' +
        '"priority_id":1,\n' +
        '"description":"'+LangHelper.GetString("QoE","Id")+': {trigger.id}\\n'+LangHelper.GetString("QoE","Trigger")+': {trigger.name}\\n'+LangHelper.GetString("QoE","Status")+': {trigger.state}\\n'+LangHelper.GetString("QoE","Severity")+':{trigger.severity}\\n\\n'+LangHelper.GetString("QoE","Queries")+':\\n{trigger.queries}\\n\\n'+LangHelper.GetString("QoE","Reasons for the occurrence of notification")+':\\n{trigger.notification.notes}\\n\\n'+LangHelper.GetString("QoE","Links to reports")+':\\n{trigger.report.link}"\\n\\n' + LangHelper.GetString("QoE","Links to files")+':\\n{trigger.report.csv}"\\n' + '\\n{trigger.report.tsv}"\\n' + '\\n{trigger.report.xlsx}"\\n' + '\\n{trigger.report.pdf}"\\n' + '\\n{trigger.report.merged_pdf}"\\n' +
            '}\n' +
        '}',

        "redmine.xml":'<?xml version="1.0"?>\n' +
        '<issue>\n' +
        '  <project_id>1</project_id>\n' +
        '  <subject>'+LangHelper.GetString("QoE","Trigger fired")+': {trigger.name}</subject>\n' +
        '  <priority_id>1</priority_id>\n' +
        '  <description>'+LangHelper.GetString("QoE","Id")+': {trigger.id}\n' +
         LangHelper.GetString("QoE","Trigger")+': {trigger.name}\n' +
         LangHelper.GetString("QoE","Status")+': {trigger.state}\n' +
         LangHelper.GetString("QoE","Severity")+': {trigger.severity}\n' +
        '\n' +
        LangHelper.GetString("QoE","Queries")+': \n' +
        '{trigger.queries}\n' +
        '\n' +
        LangHelper.GetString("QoE","Reasons for the occurrence of notification")+':\n' +
        '{trigger.notification.notes}\n' +
        '\n' +
        LangHelper.GetString("QoE","Links to reports")+':\n' +
        '{trigger.report.link}\n' +
        '\n' +
        LangHelper.GetString("QoE","Links to files")+':\n' +
        '{trigger.report.csv}\n' +
        '{trigger.report.tsv}\n' +
        '{trigger.report.xlsx}\n' +
        '{trigger.report.pdf}\n' +
        '{trigger.report.merged_pdf}\n' +
        '</description>\n' +
        '</issue>'
    };

    return tpl[Id] ? tpl[Id] : tpl["default"];
};

QoETriggerEditViewController.prototype._GetNotificationTemplate = function(Id)
{
  var _this = this;

  return new QoETriggerActionNotificationModel({
    enabled: 1,
    title:"{trigger.name}",
    subtitle:"{trigger.id}",
    body:'<p class="MsoNormal">' +
    '   <b>'+LangHelper.GetString("QoE","Id")+':&nbsp;</b>{trigger.id}' +
    '</p>' +
    '<p class="MsoNormal">' +
    '   <b>'+LangHelper.GetString("QoE","Trigger")+'</b>: {trigger.name}' +
    '</p>' +
    '<p class="MsoNormal">' +
    '   <b>'+LangHelper.GetString("QoE","Status")+'</b>: {trigger.state}' +
    '</p>' +
    '<p class="MsoNormal">' +
    '   <b>'+LangHelper.GetString("QoE","Severity")+'</b>: {trigger.severity}<br>' +
    '</p>' +
    '<p class="MsoNormal"><br></p>' +
    '<p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Queries")+'</b>:&nbsp;</p>' +
    '<p class="MsoNormal">{trigger.queries}</p>' +
    '<p class="MsoNormal"><br></p>' +
    '<p class="MsoNormal">' +
    '<p class="MsoNormal"><br></p>' +
    '<p class="MsoNormal">' +
    '   <b>'+LangHelper.GetString("QoE","Reasons for the occurrence of notification")+'</b>:' +
    '</p>' +
    '<p class="MsoNormal">{trigger.notification.notes}</p>' +
    '<p class="MsoNormal"><br></p>' +
    '<p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Links to reports")+'</b>:</p>' +
    '<p class="MsoNormal">{trigger.report.link}</p>' +
    '<p class="MsoNormal"><br></p>' +
    '<p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Links to files")+'</b>:</p>' +
    '<p class="MsoNormal">{trigger.report.csv}</p>' +
    '<p class="MsoNormal">{trigger.report.tsv}</p>' +
    '<p class="MsoNormal">{trigger.report.xlsx}</p>' +
    '<p class="MsoNormal">{trigger.report.pdf}</p>' +
    '<p class="MsoNormal">{trigger.report.merged_pdf}</p>',
    type: SocketNotificationsTypeEnum.warning
  });
};

QoETriggerEditViewController.prototype._AddUserTemplatesListView = function(TabId, Type)
{
    let _this = this;

    let popupConfig = {
        id: TabId + "TemplatesListPopup",
        view: "popup",
        maxHeight: 350,
        body: {
            view: "list",
            autoheight: true,
            width: 500,
            template:"#title#",
            data: function() {
                return _this.TemplatesManager.TemplatesList
                    .sort((a, b) => b.is_system - a.is_system)
                    .filter(item => item.type === Type)
                    .map(item => ({ id: item._id, title: item.name }));
            }(),
            on: {
                onBeforeRender: function() {
                    const maxLengthVal = this.serialize().reduce((max, item) =>
                        item.title.length > max.length ? item.title : max, "");
                    const width = webix.html.getTextSize(maxLengthVal, "webix_list_item").width + 25;

                    this.define({width: width});
                    this.resize();
                },
                onItemClick: function(_Id) {
                    const item = this.getItem(_Id);
                    const tabId = _this.Views.GroupActionsTabBar.getValue();
                    const form = tabId && _this.Views.GroupActionsTabBarElems[tabId] ? _this.Views.GroupActionsTabBarElems[tabId].form : null;

                    if(item && item.id)
                    {
                        const find = _this.TemplatesManager.TemplatesList.find(Item => Item._id == item.id);

                        if(find && form)
                        {
                            let model;

                            switch(find.type)
                            {
                                case MailingTemplatesTypesEnum.mail:
                                    model = new QoETriggerActionEmailModel({
                                        enabled: 1,
                                        subject: find.options && find.options.subject ? find.options.subject : "",
                                        body: find.template ? find.template : "",
                                        period_in_filename: find.options && find.options.period_in_filename ? find.options.period_in_filename : 0
                                    });
                                    break;
                                case MailingTemplatesTypesEnum.telegram:
                                    model = new QoETriggerActionTelegramModel({
                                        enabled: 1,
                                        body: find.template ? find.template : "",
                                        period_in_filename: find.options && find.options.period_in_filename ? find.options.period_in_filename : 0
                                    });
                                    break;
                                case MailingTemplatesTypesEnum.http:
                                    model = new QoETriggerActionHttpModel({
                                        enabled: 1,
                                        method: find.options && find.options.method ? find.options.method : "",
                                        url: find.options && find.options.url ? find.options.url : "",
                                        body: find.template ? find.template : ""
                                    });

                                    if(find.options.headers)
                                        Object.keys(find.options.headers).forEach(Key => {
                                            model.headers.push(
                                                new QoETriggerActionHttpHeaderModel({
                                                    name: Key,
                                                    value: find.options.headers[Key]
                                                })
                                            );
                                        });

                                    break;
                            }

                            if(model)
                            {
                                form.setValues(model);

                                if(find.type === MailingTemplatesTypesEnum.http)
                                {
                                    let el = $$(TabId + "HeadersTable");

                                    if(el) {
                                        el.clearAll();
                                        el.parse(model.headers);
                                    }
                                }
                            }
                        }
                    }

                    this.hide();
                }
            }
        }
    };

    webix.ui(popupConfig);
};

QoETriggerEditViewController.prototype.AddDefaultAction = function (Id)
{
    let find = this.TemplatesManager.TemplatesList.find(Item => Item.is_system && Item.type === MailingTemplatesTypesEnum.mail);

    let model = new QoETriggerActionEmailModel({
        enabled: 1,
        subject: find && find.options && find.options.subject ? find.options.subject : LangHelper.GetString("QoE", "Trigger fired")+": "+"{trigger.name}",
        body: find ? find.template : this._GetTemplate()
    });

    this._AddActionTabView(QoETriggerActionTypeEnum.email, model);
};
function QoEDashboardEditViewController() {
    this.Id = "QoEDashboardEditForm";

    this.ViewModel = new QoEDashboardManager();

    this.Views = {
        Form: null,
        FormLayout: null,
        NameField: null,
        RadioLayout: null,
        Radio: null,
        RolesTable: null,
        RolesTableInvalidMessage: null,
        ButtonsLayout: null,
    };

    this.TemporaryViews = {
        SelectedTemplateComboLayout: null,
        SelectedTemplateCombo: null,
        RebuildIntoCreateTemplateBtn: null,
        RebuildIntoEditDashboardBtn: null
    }

    this.ContextEditDashboardConfig = null;
    this.ContextEditDashboard = null;

    this.StorageDashboardData = null;

    this.Subscriptions = {};

    this.State = null;

    this.TemplatesListData = [];

    this.Signals = {
        Save: new Rx.BehaviorSubject(null)
    }

    this.Init();
};

QoEDashboardEditViewController.prototype.Init = function() {
    let _this = this;

    this.ContextEditDashboardConfig = {
        view: "popup",
        modal: true,
        maxWidth: 450,
        maxHeight: 660,
        on: {
            "onHide": function() {
                _this.Clear();
            }
        },
        body: {
            view: "form",
            id: this.Id + "Form",
            borderless: true,
            elements: [
                {
                    id: this.Id + "FormLayout",
                    rows: [
                        {
                            view: "text",
                            id: this.Id + "NameField",
                            name: "dashboard_name",
                            labelPosition: "top",
                            required: true,
                            bottomPadding: 10,
                            validate: webix.rules.isNotEmpty()
                        },
                        {
                            id: this.Id + "RadioLayout",
                            paddingY: 10,
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    view: "radio",
                                    id: this.Id + "Radio",
                                    name: "available",
                                    labelPosition: "top",
                                    height: 70,
                                    vertical: true,
                                    options: Object.values(AvailableUsersEnum),
                                    on: {
                                        "onChange": function (Id) {
                                            Id !== AvailableUsersEnum.roles_users.id
                                                ? _this.ResetRoles()
                                                : _this.Views.RolesTable.enable();
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: "datatable",
                            id: this.Id + "RolesTable",
                            selected: "row",
                            height: 280,
                            columns: [
                                {
                                    id: "allow",
                                    header: "",
                                    width: 60,
                                    headermenu: false,
                                    template: function (Obj, Common, Value) {
                                        return CellOnOffCheckboxTemplate(Obj, Common, Value);
                                    }
                                },
                                {
                                    id: "role",
                                    header: LangHelper.GetString("QoE", "Role"),
                                    width: "auto",
                                    template: function (Value) {
                                        return Value.value
                                    }
                                }
                            ],
                            on: {
                                onItemClick: function (Obj) {
                                    if (Obj.column == "allow") {
                                        var item = _this.Views.RolesTable.getItem(Obj.row);

                                        item.allow = item.allow ? 0 : 1;

                                        _this.Views.RolesTable.updateItem(Obj.row, item);
                                    }
                                }
                            }
                        },
                        {
                            view: "label",
                            id: this.Id + "RolesTableInvalidMessage",
                            height: 25,
                            css: {
                                "color":"#fd595f !important",
                                "font-size":"13px"
                            },
                            template: function(Obj, Common, Value) {
                                if(Value) {
                                    return `<div>${Value}</div>`
                                }
                                return `<div></div>`

                            }
                        },
                        {
                            id: this.Id + "ButtonsLayout",
                            cols: [
                                {
                                    view: "button",
                                    value: LangHelper.GetString("All", "Cancel"),
                                    click: function () {
                                        _this.Hide();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    value: LangHelper.GetString("All", "Save"),
                                    click: function () {
                                        _this.SaveDashboard();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };
};

QoEDashboardEditViewController.prototype.ViewDidLoad = function(Params) {
    this.Bind(Params);
};

QoEDashboardEditViewController.prototype.Destroy = function(Params) {
    Object.keys(this.Subscriptions).forEach(Key => {
       if(this.Subscriptions[Key])
           this.Subscriptions[Key].unsubscribe();
    });

    if(this.ViewModel) {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEDashboardEditViewController.prototype.Bind = function(Params) {
    let _this = this;

    this.ContextEditDashboard = webix.ui(this.ContextEditDashboardConfig);

    this.StorageDashboardData = [];

    Object.keys(this.Views).forEach(View => {
        this.Views[View] = $$(this.Id + View);
    });

    this.Subscriptions.SignalRolesUpdate = App.DicsManager.Signal[DicsEnum.RolesDic].subscribe(function(Value) {
       if(Value) {
            _this.RefreshRoles();
       }
    });
};

QoEDashboardEditViewController.prototype.Show = function(Node, Pos) {
    this.ContextEditDashboard.show(Node, {pos:Pos});
};

QoEDashboardEditViewController.prototype.Hide = function() {
    this.ContextEditDashboard.hide();
    this.ResetForm();
};

QoEDashboardEditViewController.prototype.Clear = function() {
    this.Views.Form.clear();
    this.ClearValidation();
};

QoEDashboardEditViewController.prototype.ClearValidation = function() {
    this.Views.Form.clearValidation();
    this.Views.RolesTableInvalidMessage.setValue("");
};

QoEDashboardEditViewController.prototype.SetData = function(Data) {
    this.Data = new QoEDashboardModel(Data);

    this.Views.Form.setValues(this.Data);

    this.SetRoles();

    this.ConfigureForm();
};

QoEDashboardEditViewController.prototype.ConfigureForm = function() {
    if(this.Data.dashboard_id && this.Data.is_template) {
        this.RebuildIntoEditTemplateForm();
    }
    if(this.Data.dashboard_id && !this.Data.is_template) {
        this.RebuildIntoEditDashboardForm();
    }
    if(!this.Data.dashboard_id && this.Data.is_template) {
        this.RebuildIntoCreateTemplateForm();
    }
    if(!this.Data.dashboard_id && !this.Data.is_template) {
        this.RebuildIntoCreateDashboardForm();
    }
};

QoEDashboardEditViewController.prototype.RebuildIntoEditTemplateForm = function() {
    this.SetState(DashboardEditFormStatesEnum.edit_template)
    this.TemplateFormDefineTextField();
};

QoEDashboardEditViewController.prototype.RebuildIntoEditDashboardForm = function() {
    this.SetState(DashboardEditFormStatesEnum.edit_dashboard);
    this.DashboardFormDefineTextField();
    this.AddRebuildIntoCreateTemplateBtn();
};

QoEDashboardEditViewController.prototype.RebuildIntoCreateTemplateForm = function() {
    this.SetState(DashboardEditFormStatesEnum.create_template);
    this.TemplateFormDefineTextField();
    this.AddRebuildIntoEditDashboardBtn();
};

QoEDashboardEditViewController.prototype.RebuildIntoCreateDashboardForm = function() {
    this.SetState(DashboardEditFormStatesEnum.create_dashboard);
    this.DashboardFormDefineTextField();
    this.AddSelectedTemplateCombo();
};

QoEDashboardEditViewController.prototype.DefineTextField = function(TextObj) {
    this.Views.NameField.define("label", TextObj.nameValue);
    this.Views.NameField.define("invalidMessage", TextObj.nameInvalidMessageValue);
    this.Views.Radio.define("label", TextObj.radioValue);
    this.Views.NameField.refresh();
    this.Views.Radio.refresh();
};

QoEDashboardEditViewController.prototype.DashboardFormDefineTextField = function() {
    this.DefineTextField({
        nameValue: LangHelper.GetString("QoE", "Dashboard name"),
        nameInvalidMessageValue: LangHelper.GetString("QoE", "Enter dashboard name"),
        radioValue: LangHelper.GetString("QoE", "For whom the dashboard is available?")
    });
};

QoEDashboardEditViewController.prototype.TemplateFormDefineTextField = function() {
    this.DefineTextField({
        nameValue: LangHelper.GetString("QoE", "Template name"),
        nameInvalidMessageValue: LangHelper.GetString("QoE", "Enter template name"),
        radioValue: LangHelper.GetString("QoE", "For whom the template is available?"),
    });
};

QoEDashboardEditViewController.prototype.AddRebuildIntoCreateTemplateBtn = function() {
    let _this = this;

    this.Views.ButtonsLayout.addView({
        view: "button",
        id: this.Id + "RebuildIntoCreateTemplateBtn",
        type: "form",
        width: 180,
        value: LangHelper.GetString("QoE", "Save as template"),
        click: function () {
            _this.ResetForm();
            _this.StorageDashboardState();
            _this.SetData({is_template: 1, available: AvailableUsersEnum.me_only.id, dashboard_state: _this.Data.dashboard_state, filter_settings: _this.Data.filter_settings});
        }
    }, 1);

    this.TemporaryViews.RebuildIntoCreateTemplateBtn = $$(this.Id + "RebuildIntoCreateTemplateBtn");
    if(!this.Data.dashboard_state || (Array.isArray(this.Data.dashboard_state) && !this.Data.dashboard_state.length)) {
        this.TemporaryViews.RebuildIntoCreateTemplateBtn.disable();
    }
};

QoEDashboardEditViewController.prototype.AddRebuildIntoEditDashboardBtn = function() {
    let _this = this;

    this.Views.ButtonsLayout.addView({
        view: "button",
        id: this.Id + "RebuildIntoEditDashboardBtn",
        type: "form",
        width: 220,
        value: LangHelper.GetString("QoE", "Back to the dashboard"),
        click: function() {
            _this.ResetForm();
            _this.SetData(_this.StorageDashboardData);
        }
    }, 1);

    this.TemporaryViews.RebuildIntoEditDashboardBtn = $$(this.Id + "RebuildIntoEditDashboardBtn");
};

QoEDashboardEditViewController.prototype.AddSelectedTemplateCombo = function() {
    let _this = this;

    this.Views.RadioLayout.addView({
        id: this.Id + "SelectedTemplateComboLayout",
        paddingY: 10,
        rows: [
            {
                view: "combo",
                id: this.Id + "SelectedTemplateCombo",
                label: LangHelper.GetString("QoE", "Dashboard template"),
                labelPosition: "top",
                options: [],
                keyPressTimeout:100,
                on: {
                    onTimedKeyPress: function() {
                        _this.RequestTemplates(this.getText());
                    },
                    onFocus: function() {
                        let text = this.getText();

                        if(!text)
                            _this.RequestTemplates(text);
                    }
                }
            }
        ]
    });

    this.TemporaryViews.SelectedTemplateComboLayout = $$(this.Id + "SelectedTemplateComboLayout");
    this.TemporaryViews.SelectedTemplateCombo = $$(this.Id + "SelectedTemplateCombo");
};

QoEDashboardEditViewController.prototype.StorageDashboardState = function() {
    this.StorageDashboardData = webix.copy(this.Data);
};

QoEDashboardEditViewController.prototype.ResetForm = function() {
    Object.keys(this.TemporaryViews).forEach(View => {
        let element = this.TemporaryViews[View];
        if (element) {
            let layout = element.getParentView();
            layout.removeView(element.config.id);
            this.TemporaryViews[View] = null;
        }
    });
};

QoEDashboardEditViewController.prototype.SetRoles = function() {
    let roles = this.Views.RolesTable.serialize();

    let data = [];
    roles.forEach(role => {
        role.available_for_roles = this.Data.available_for_roles;
        data.push(new QoERoleModel(role));
    });

    this.Views.RolesTable.parse(data);
};

QoEDashboardEditViewController.prototype.RefreshRoles = function() {
    let roles = App.DicsManager.GetDicAsArray(DicsEnum.RolesDic);

    let rolesTableData = this.Views.RolesTable.serialize();

    let data = [];
    roles.forEach(role => {
        let newRole = new QoERoleModel(role);

        let foundRow = rolesTableData.find(row => row.id == role.id);
        if (foundRow) {
            newRole.allow = foundRow.allow;
        }

        data.push(newRole);
    });
    this.Views.RolesTable.parse(data);
};

QoEDashboardEditViewController.prototype.ResetRoles = function() {
    this.Views.RolesTable.disable();

    this.Views.RolesTable.eachRow(row => {
        let record = this.Views.RolesTable.getItem(row);

        record.allow = 0;
        this.Views.RolesTable.updateItem(row, record);
    });
};

QoEDashboardEditViewController.prototype.GetData = function() {
    return new QoEDashboardModel(this.Data);
};

QoEDashboardEditViewController.prototype.SetState = function(State) {
    if(Object.keys(DashboardEditFormStatesEnum).find(Key => DashboardEditFormStatesEnum[Key] === State)) {
        this.State = State;
    }
};

QoEDashboardEditViewController.prototype.GetState = function() {
    return this.State;
};

QoEDashboardEditViewController.prototype.SaveDashboard = function() {
    this.ClearValidation();

    this.Data = null;

    this.Data = this.Views.Form.getValues();

    let rolesTableData = this.Views.RolesTable.serialize();

    if(this.Validate(rolesTableData)) {

        this.PushRolesToSave(rolesTableData);

        this.Data.owner_id = App.SessionManager.GetProfile().user_id;

        this.Signals.Save.next(1);
    }
};

QoEDashboardEditViewController.prototype.PushRolesToSave = function(Roles) {
    if (this.Data && this.Data.available === AvailableUsersEnum.roles_users.id) {
        let roleIds = [];
        Roles.forEach(role => {
            if (role.allow) {
                roleIds.push(role.id);
            }
        });
        this.Data.available_for_roles = roleIds;
    }
    else {
        this.Data.available_for_roles = "";
    }
};

QoEDashboardEditViewController.prototype.GetSelectedTemplateComboValue = function() {
    let combo = this.TemporaryViews.SelectedTemplateCombo;
    if(combo) {
        return combo.getValue();
    }
    return null;
};

QoEDashboardEditViewController.prototype.Validate = function(Roles) {
    let result = [];
    result.push(this.Views.Form.validate());
    result.push(this.ValidateRolesTable(Roles));
    return result.every(res => res);
};

QoEDashboardEditViewController.prototype.ValidateRolesTable = function(Roles) {
    if(this.Data && this.Data.available === AvailableUsersEnum.roles_users.id) {
        let result = Roles.filter(role=>role.allow);
        if(!result.length) {
            this.Views.RolesTableInvalidMessage.setValue(LangHelper.GetString("QoE", "Select roles"));
            return false;
        }
        return true;
    }
    else {
        return true;
    }
};

QoEDashboardEditViewController.prototype.RequestTemplates = function(Text) {
  this.ViewModel.GetTemplateByName({dashboard_name: Text, size: 25, callback: this.DefineOptionsTemplateCombo.bind(this)});
};

QoEDashboardEditViewController.prototype.DefineOptionsTemplateCombo = function() {
    let selectedTemplateCombo = this.TemporaryViews.SelectedTemplateCombo;

    let list = selectedTemplateCombo.getList();
    list.clearAll();

    this.TemplatesListData = [];

    this.ViewModel.GetTemplates().forEach(template => {
        let listItemConfig = {id: template.dashboard_id, value: template.dashboard_name};
        list.add(listItemConfig);
        this.TemplatesListData.push(webix.extend({dashboard_state: template.dashboard_state, filter_settings: template.filter_settings}, listItemConfig,true));
    });
};
function QoETriggersWidget(Params)
{
    var _this = this;

    this.Id = "QoETriggersWidget";

    this.QoETriggersManager = new QoETriggersManager();

    this.ViewModel = new QoEReportsManager();

    this.Subscriptions = {};

    this.Signals = {
        QoETriggersTableRowsSelectedCount: new Rx.BehaviorSubject(0)
    };

    this.Views =
    {
        AddQoETriggerToQoETriggersTableBtn:null,
        CopyQoETriggerToQoETriggersTableBtn: null,
        QoETriggersTable:null,
        QoETriggersTablePaging:null,
        QoETriggersTablePagingSize:null,

        DeleteBtn:null
    };

    this.Views.Widgets = {};

    this.ViewConfig = {
        rows:[
            {
                view: "toolbar",
                height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                elements: [
                    {
                        view: "button",
                        id:this.Id + "AddQoETriggerToQoETriggersTableBtn",
                        type: "icon",
                        icon: "plus",
                        align: "right",
                        width: 32,
                        css:"toolbar_round_btn",
                        tooltip:LangHelper.GetString("QoE","Add trigger"),
                        click: function (id, e, node)
                        {
                            _this.AddQoETriggerToQoETriggersTable();
                        }
                    },
                    {
                        view: "button",
                        id:this.Id + "CopyQoETriggerToQoETriggersTableBtn",
                        type: "icon",
                        icon: "file-plus",
                        align: "right",
                        width: 32,
                        css:"toolbar_round_btn",
                        tooltip:LangHelper.GetString("QoE","Copy trigger"),
                        click: function (id, e, node)
                        {
                            _this.CreateTriggerFromCopy();
                        }
                    },
                    {},
                    {
                        view: "button",
                        id:_this.Id+"DeleteBtn",
                        type: "icon",
                        icon: "trash",
                        css:"toolbar_round_btn",
                        width:32,
                        tooltip:LangHelper.GetString(_this.Id, "Delete"),
                        disabled:true,
                        click:function (id,e,node)
                        {
                            var __this = this;
                            setTimeout(function () {
                                var node = __this.getNode(id);
                                _this.QoETriggerDeleteContext.show(node, {pos:"bottom"});
                            }, 10);
                        }
                    },
                    {
                        view: "button",
                        id:this.Id+"QoETriggersRefreshBtn",
                        type: "icon",
                        icon: "refresh",
                        css: "toolbar_round_btn",
                        width: 32,
                        tooltip: LangHelper.GetString("All","Refresh"),
                        click: function (id, e, node)
                        {
                            _this.RefreshQoETriggersTable(0);
                        }
                    }
                ]
            },
            {
                view: "datatable",
                id: this.Id + "QoETriggersTable",
                select: "row",
                editable: true,
                editaction:"custom",
                resizeColumn: true,
                tooltip:true,
                checkboxRefresh:true,
                multiselect:true,
                on: {
                    onCheck:function (id, column, state)
                    {
                        if(column == "checked")
                        {
                            if(state)
                                this.select(id, true);
                            else
                                this.unselect(id, true);

                        }
                    },
                    onItemDblClick: function (id)
                    {
                        this.select(id); //reset if multiple rows selected

                        var rowData = this.getItem(id);
                        _this.ShowQoETriggersEditForm(rowData, this.getItemNode({column:"edit", row:id.row}), "right");
                    },
                    onItemClick: function (id,e,node)
                    {
                        var __this = this;

                        var rowData = this.getItem(id);

                        if (id.column === 'edit')
                        {
                            _this.ShowQoETriggersEditForm(rowData, this.getItemNode(id), "right");
                        }

                        else if(id.column === 'trash')
                        {
                            var data = _this.Views.QoETriggersTable.getItem(id);

                            if(data.type == QoETriggerTypeEnum.system || data.type == QoETriggerTypeEnum.report
                                || data.type == QoETriggerTypeEnum.scheduled)
                                return;

                            if(!data._id)
                            {
                                _this.DeleteQoETrigger(id);
                                return;
                            }

                            setTimeout(function () {
                                var node = __this.getItemNode(id);
                                _this.QoETriggerDeleteContext.show(node, {pos:"bottom"});
                            }, 10);
                        }

                        else if(id.column === 'enabled')
                        {
                            if(!rowData._id)
                            {
                                return;
                            }

                            if(parseInt(rowData.enabled,10))
                            {
                                setTimeout(function ()
                                {
                                    _this.EnableQoETrigger(false);
                                }, 1);
                            }
                            else
                            {
                                setTimeout(function ()
                                {
                                    _this.EnableQoETrigger(true);
                                }, 1);
                            }
                        }
                    },
                    onBeforeFilter:function()
                    {
                        return false;
                    },
                    onAfterFilter:function()
                    {
                        _this.RefreshQoETriggersTable();
                    },
                    onBeforeSort:function()
                    {
                        _this.RefreshQoETriggersTable();
                        return false;
                    },
                    onAfterSelect:function (data)
                    {
                        var item = this.getItem(data.id);
                        if(item)
                        {
                            if(!item.checked)
                            {
                                item.checked = 1;
                            }
                            this.updateItem(data.id, item);
                        }

                        _this.OnQoETriggersTableRowSelect();
                    },
                    onAfterUnSelect:function (data)
                    {
                        var item = this.getItem(data.id);
                        if(item && item.checked)
                        {
                            if(item.checked)
                            {
                                item.checked = 0;
                            }
                            this.updateItem(data.id, item);
                        }

                        _this.OnQoETriggersTableRowUnSelect();
                    },
                    onHeaderClick:function(id, e, target)
                    {
                        if(id.column == "checked")
                        {
                            var cb = this.getHeaderContent("mc");
                            if(cb.isChecked())
                            {
                                this.selectAll();
                            }
                            else
                            {
                                this.unselectAll();
                            }

                            return false;
                        }
                    }
                },
                columns: [
                    {
                        id:"checked",
                        header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                        template: CellColoredCheckBoxTemplate,
                        width:32
                    },
                    {
                        id: "enabled",
                        header: "",
                        width: 32,
                        template: CellSwitchOnOffTemplate,
                        // template:function(Obj, Common, Value)
                        // {
                        //     return CellSwitchBoxTemplate(Obj, Common, Value);
                        // },
                        headermenu: false
                    },
                    {
                        id: "edit",
                        header: "",
                        width: 32,
                        template: CellEditBtnTemplate,
                        headermenu: false
                    },
                    {
                        id: "name",
                        header: [TooltipTemplate(LangHelper.GetString("QoE","Trigger name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        fillspace: true,
                        sort: "string"
                    },
                    {
                        id: "days_of_week",
                        header: [TooltipTemplate(LangHelper.GetString("QoE", "Days of the week")),{
                            content: "multiSelectFilter",
                            options: Helper.DictToArr(DaysOfWeekDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        sort: "string",
                        fillspace: true,
                        template: function(obj, common)
                        {
                            var result = Array();
                            var days = obj.days_of_week.split(',').sort();
                            for(var i in days)
                            {
                                if(i && days[i])
                                {
                                    result.push(DaysOfWeekDic[days[i]].value);
                                }
                            }
                            return result.join(',');
                        }
                    },
                    {
                        id: "evaluate_every_seconds",
                        header:[TooltipTemplate(LangHelper.GetString("QoE", "Check frequency")), {
                            content: "multiSelectFilter",
                            options: Helper.DictToArr(QoESecondsChunckPeriodDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        fillspace: true,
                        sort: "string",
                        template:function (Obj)
                        {
                            return Obj.evaluate_every_seconds && QoESecondsChunckPeriodDic[Obj.evaluate_every_seconds] ? QoESecondsChunckPeriodDic[Obj.evaluate_every_seconds].value : Obj.evaluate_every_seconds;
                        }
                    },
                    {
                        id: "type",
                        width: 128,
                        header: [TooltipTemplate(LangHelper.GetString("QoE", "Trigger type")),{
                            content: "richSelectFilter",
                            options: Helper.DictToArr(QoETriggerTypesDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        template: function(Obj)
                        {
                            return "<span class=\"status status_" + (Obj.type == QoETriggerTypeEnum.system ? "red" : "green") + "\">" +
                                QoETriggerTypesDic[Obj.type].value + "</span>";
                        }
                    },
                    {
                        id: "state_code",
                        header:[TooltipTemplate(LangHelper.GetString("QoE", "State")), {
                            content: "multiSelectFilter",
                            options: Helper.DictToArr(QoETriggerStateCodeDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        template:function(Obj)
                        {
                            //return QoETriggerStateCodeDic[Obj.state_code] ? QoETriggerStateCodeDic[Obj.state_code].value : Obj.state_code;

                            var stateStr = "";

                            if(QoETriggerStateCodeDic[Obj.state_code])
                            {
                                if(Obj.enabled)
                                {
                                    // debugger
                                    // if(Obj.state_code == QoETriggerStateCodeEnum.caching ||
                                    //     Obj.state_code == QoETriggerStateCodeEnum.checking ||
                                    //     Obj.state_code == QoETriggerStateCodeEnum.firing)
                                    // {
                                    //     stateStr += '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div> <div class="bounce3"></div> </div>';
                                    // }

                                    var color = "green";

                                    switch(Obj.state_code)
                                    {
                                        case QoETriggerStateCodeEnum.scheduled_ready:
                                            color = "green";
                                            break;
                                        case QoETriggerStateCodeEnum.ready:
                                            color = "green";
                                            break;
                                        case QoETriggerStateCodeEnum.invalid:
                                            color = "red";
                                            break;
                                        case QoETriggerStateCodeEnum.cache_error:
                                            color = "red";
                                            break;
                                        default:
                                            color = "orange"
                                    }

                                    stateStr += "<span class=\"status status_" + color + "\">";

                                    if(Obj.state_code == QoETriggerStateCodeEnum.invalid)
                                    {
                                        stateStr += '<span class="webix_icon fa-exclamation-triangle"></span>';
                                    }

                                    stateStr += QoETriggerStateCodeDic[Obj.state_code].value + "</span>";
                                }
                                else
                                {
                                    stateStr = QoETriggerStateCodeDic[Obj.state_code].value;
                                }
                            }
                            else
                            {
                                stateStr = Obj.state_code;
                            }


                            return stateStr;

                        },
                        fillspace: true,
                        sort: "string"
                    },
                    {
                        id: "users_user_id",
                        header: [LangHelper.GetString("QoE","User"), {
                            content: "multiSelectFilter",
                            options: App.DicsManager.GetDicAsArray(DicsEnum.UsersDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        fillspace: true,
                        //width:80,
                        template: function (obj)
                        {
                            var dic = App.DicsManager.GetDic("UsersDic");
                            if(dic && dic[obj.users_user_id])
                                return App.DicsManager.GetDic("UsersDic")[obj.users_user_id].value;
                            else
                                return "";
                        },
                        sort: "string",
                        hidden:function ()
                        {
                            var hidden = 1;

                            var sp = App.SessionManager.GetUserRoleSectionParams(RoleSectionsEnum.qoeanalytics_triggers);

                            if(sp && sp.see_all_users_enabled && sp.see_all_users == "all")
                                hidden = 0;

                            return hidden;
                        }()
                    },
                    {
                        id: "trash",
                        header: "",
                        width: 32,
                        template: function(Obj){
                            return Obj.type == QoETriggerTypeEnum.user ? CellTrashBtnTemplate() : "";
                        },
                        headermenu: false
                    }
                ],
                data:[]
            },
            {
                view: "toolbar",
                padding: 0,
                margin: 0,
                height:32,
                elements: [
                    {
                        view: "pager",
                        gravity:3,
                        id: this.Id + "QoETriggersTable" + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master:false,
                        on: {
                            onAfterPageChange:function(Page)
                            {
                                _this.RefreshQoETriggersTable(Page);
                            }
                        }
                    },
                    {
                        view:"richselect",
                        id: this.Id + "QoETriggersTable" + "Paging" + "Size",
                        label:LangHelper.GetString("QoE","On page"),
                        labelWidth:120,
                        minWidth:220,
                        value:100,
                        options:PagingSizeOptions,
                        on: {
                            onChange:function()
                            {
                                _this.RefreshQoETriggersTable();
                            }
                        }
                    }
                ]
            }
        ]
    };

    this.QoETriggerContext = new QoETriggerEditViewController();

    this.QoETriggerDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("QoE","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("QoE","Cancel"),
                            click:function () {
                                _this.QoETriggerDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("QoE","Delete"),
                            click:function ()
                            {
                                _this.QoETriggerDeleteContext.hide();

                                _this.DeleteQoETriggersTableSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });
};

QoETriggersWidget.prototype.ViewDidLoad = function ()
{
    var _this = this;

    this.BindAll();

    this.QoETriggerContext.ViewDidLoad();

    this.RefreshAllData();

    //_this.AddQoETriggerToQoETriggersTable();
};

QoETriggersWidget.prototype.BindAll = function (Params)
{
    var _this = this;
    this.Views.QoETriggersTable = $$(this.Id + "QoETriggersTable");
    this.Views.QoETriggersTablePaging = $$(this.Id + "QoETriggersTable" + "Paging");
    this.Views.QoETriggersTablePagingSize = $$(this.Id + "QoETriggersTable" + "Paging" + "Size");

    this.Views.DeleteBtn = $$(this.Id+"DeleteBtn");
    this.Views.CopyQoETriggerToQoETriggersTableBtn = $$(this.Id+"CopyQoETriggerToQoETriggersTableBtn");

    this.Subscriptions.SignalQoETriggersUpdatedSubscription = this.QoETriggersManager.SignalQoETriggersUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateQoETriggersTable();
        }
    });

    this.Subscriptions.QoETriggersTableRowsSelectedCountSubscription = this.Signals.QoETriggersTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.QoETriggersTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.QoETriggerContextSaveSubscription = this.QoETriggerContext.Signals.Save.subscribe(function (Data)
    {
        if(Data)
            _this.SaveQoETrigger(Data);
    });


    App.WebSocketManager.Connect(this.Id);

    App.WebSocketManager.Connections[this.Id].on("trigger_updated", function(data){
        _this.UpdateTrigger(JSON.parse(data));
    })
};

QoETriggersWidget.prototype.RefreshAllData = function ()
{
    this.RefreshQoETriggersTable();
};

QoETriggersWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        _this.Views.Widgets[key].Destroy();
    });

    App.WebSocketManager.Disconnect(this.Id);

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.QoETriggersManager)
    {
        this.QoETriggersManager.Destroy();
        delete this.QoETriggersManager;
    }

    this.QoETriggerContext.Destroy();
};

QoETriggersWidget.prototype.AddQoETriggerToQoETriggersTable = function ()
{
    var _this = this;

    var model = new QoETriggerModel({days_of_week:'1,2,3,4,5,6,7', evaluate_every_seconds:60, enabled:1});

    _this.Views.QoETriggersTable.add(model,0);

    _this.Views.QoETriggersTable.select(model.id, false);
    _this.Views.QoETriggersTable.showItem(model.id);

    _this.ShowQoETriggersEditForm(model, _this.Views.QoETriggersTable.getItemNode(model.id), "right", true);
};

QoETriggersWidget.prototype.CreateTriggerFromCopy = function()
{
    var _this = this;

    var model =  webix.copy(this.GetQoETriggersTableSelectedData());

    model.id = webix.uid();
    model._id = 0;
    model.type = QoETriggerTypeEnum.user;
    model.enabled = 1;
    model.name = LangHelper.GetString("QoE", "New trigger");

    _this.Views.QoETriggersTable.add(model,0);

    _this.Views.QoETriggersTable.select(model.id, false);
    _this.Views.QoETriggersTable.showItem(model.id);

    _this.ShowQoETriggersEditForm(model, _this.Views.QoETriggersTable.getItemNode(model.id), "right", false);
};

QoETriggersWidget.prototype.UpdateQoETriggersTable = function (Params)
{
    var _this = this;

    var dic = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);

    this.Views.QoETriggersTable.getColumnConfig("users_user_id").header[1].options = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);

    this.Views.QoETriggersTable.clearAll();
    this.Views.QoETriggersTable.parse(_this.QoETriggersManager.GetQoETriggers());

    this.Views.QoETriggersTablePagingSize.setValue(this.QoETriggersManager.QoETriggersFilter.total.size);

    this.Views.QoETriggersTablePaging.define(this.QoETriggersManager.QoETriggersFilter.total);
    this.Views.QoETriggersTablePaging.refresh();
};

QoETriggersWidget.prototype.RefreshQoETriggersTable = function (Page)
{
    var _this = this;

    var state = this.Views.QoETriggersTable.getState();

    var size = this.Views.QoETriggersTablePagingSize.getValue();

    this.QoETriggersManager.RefershQoETriggers({page:Page, filter:state.filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}})
};

QoETriggersWidget.prototype.OnQoETriggersTableRowSelect = function ()
{
    var data = this.GetQoETriggersTableSelectedData();

    this.Signals.QoETriggersTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoETriggersWidget.prototype.OnQoETriggersTableRowUnSelect = function ()
{
    var data = this.GetQoETriggersTableSelectedData();
    this.Signals.QoETriggersTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoETriggersWidget.prototype.ShowQoETriggersEditForm = function (Data, Node, Pos, New)
{
    var _this = this;

    if(Data)
    {
        this.QoETriggerContext.SetData(Data);
    }

    this.QoETriggerContext.Show(Node, Pos);

    if(New)
        this.QoETriggerContext.AddDefaultAction();
};

QoETriggersWidget.prototype.DeleteQoETrigger = function (RowId)
{
    var _this = this;

    var QoETriggerData = this.Views.QoETriggersTable.getItem(RowId);
    QoETriggerData.valid = true;

    if(QoETriggerData._id > 0)
    {
        this.QoETriggersManager.DeleteQoETrigger({QoETrigger:QoETriggerData, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.QoETriggersTable.remove(RowId);

                    webix.message(LangHelper.GetString(_this.Id,"Deleted"));
                }
                else
                {
                    QoETriggerData.valid = false;
                    _this.Views.QoETriggersTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
    else
    {
        this.Views.QoETriggersTable.remove(RowId);
    }
};

QoETriggersWidget.prototype.DeleteQoETriggersTableSelectedRows = function ()
{
    var _this = this;

    var selectedRows = this.GetQoETriggersTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    selectedRows.forEach(function (Row)
    {
        _this.DeleteQoETrigger(Row.id);
    });
};

QoETriggersWidget.prototype.GetQoETriggersTableSelectedData = function ()
{
    return this.Views.QoETriggersTable.getSelectedItem();
};

QoETriggersWidget.prototype.SaveQoETrigger = function (Data)
{
    var _this = this;

    var QoETriggerData = this.GetQoETriggersTableSelectedData();
    QoETriggerData.valid = true;

    var _data = new QoETriggerModel(Data);
    var _qoe_trigger_data = new QoETriggerModel(QoETriggerData);
    var newQoETriggerData = webix.extend(_data, _qoe_trigger_data);
    newQoETriggerData.type = _qoe_trigger_data.type;

    if(_data.ulr_mailing_id || _qoe_trigger_data.ulr_mailing_id)
    {
        newQoETriggerData.ulr_mailing_id = _data.ulr_mailing_id ? _data.ulr_mailing_id : _qoe_trigger_data.ulr_mailing_id;
    }

    if(newQoETriggerData.type == QoETriggerTypesDic.scheduled.id)
    {
        newQoETriggerData.state = QoETriggerStateCodeDic.scheduled_ready.id;
    }

    this.QoETriggersManager.SaveQoETrigger({QoETrigger:newQoETriggerData,  callback:function (R)
    {
        if(R.success && R.data)
        {
            _this.QoETriggerContext.Hide();

            _this.Views.QoETriggersTable.updateItem(QoETriggerData.id,  new QoETriggerModel(R.data));

            webix.message(LangHelper.GetString("QoE","Trigger saved"));
        }
        else
        {
            QoETriggerData.valid = false;
            _this.Views.QoETriggersTable.validate(QoETriggerData.id);

            if(R.error)
                webix.message({text:R.error.msg,type:"error"});
        }

        _this.OnQoETriggersTableRowSelect();
    }});

    this.Views.QoETriggersTable.validate(QoETriggerData.id);
};

QoETriggersWidget.prototype.QoETriggersTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    if(Value == 1)
    {
        this.Views.CopyQoETriggerToQoETriggersTableBtn.enable();
    }
    else{
        this.Views.CopyQoETriggerToQoETriggersTableBtn.disable();
        if(Value > 1)
        {
            var selected = this.GetQoETriggersTableSelectedData();
            if(selected && Array.isArray(selected))
            {
                for(var i in selected)
                {
                    if(selected[i].type == QoETriggerTypeEnum.system)
                    {
                        this.Views.DeleteBtn.disable();
                        return;
                    }
                }
            }
            this.Views.DeleteBtn.enable();
        }
        else
        {
            this.Views.DeleteBtn.disable();
        }
    }
};

QoETriggersWidget.prototype.EnableQoETrigger = function (Enable, Data)
{
    var _this = this;

    var QoETriggerData = Data ? Data : this.GetQoETriggersTableSelectedData();

    QoETriggerData.valid = true;

    QoETriggerData.enabled = Enable ? 1 : 0;

    this.Views.QoETriggersTable.updateItem(QoETriggerData.id,  QoETriggerData);

    this.QoETriggersManager.SaveQoETrigger({QoETrigger:QoETriggerData,  callback:function (R)
        {
            if(R.success && R.data)
            {
                _this.QoETriggerContext.Hide();

                _this.Views.QoETriggersTable.updateItem(QoETriggerData.id,  new QoETriggerModel(R.data));

                webix.message(LangHelper.GetString("QoE","Trigger "+(Enable ? "enabled" : "disabled")));
            }
            else
            {
                QoETriggerData.valid = false;
                _this.Views.QoETriggersTable.validate(QoETriggerData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.OnQoETriggersTableRowSelect();
        }});
};

QoETriggersWidget.prototype.UpdateTrigger = function(Data)
{
    var _this = this;

    var trigger = this.QoETriggersManager.QoETriggers.find(function(obj){
        return obj._id == Data._id;
    });

    if(trigger)
    {
        for(var i in Data)
        {
            trigger[i] = Data[i];
        }

        _this.Views.QoETriggersTable.updateItem(trigger.id, trigger);
    }
};
function QoETriggersAlertsWidget(Params)
{
    var _this = this;

    this.Id = "QoETriggersAlertsWidget";

    this.QoETriggersManager = new QoETriggersManager();

    this.ViewModel = new QoEReportsManager();

    this.Subscriptions = {};

    this.TriggerFilterModeEnabled = false;
    this.TriggerFilterIds = [];

    this.Signals = {
        QoETriggersAlertsTableRowsSelectedCount: new Rx.BehaviorSubject(0)
    };

    this.Views =
    {
        AddQoETriggersAlertToQoETriggersAlertsTableBtn:null,
        QoETriggersAlertsTable:null,
        QoETriggersAlertsTablePaging:null,
        QoETriggersAlertsTablePagingSize:null,

        DeleteBtn:null
    };

    this.Views.Widgets = {};

    this.ViewConfig =
    {
        rows:[
            {
                view: "toolbar",
                height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                elements: [
                    {
                        view:"checkbox",
                        id:this.Id + "TriggerFilterModeBtn",
                        labelWidth:0,
                        labelRight:LangHelper.GetString("QoE", "Only selected triggers"),
                        value:this.TriggerFilterModeEnabled ? 1 : 0,
                        on:{
                            onChange:function(New, Old)
                            {
                                _this.TriggerFilterModeEnabled = New;
                                _this.RefreshAllData();
                            }
                        }
                    },
                    {},
                    {
                        view: "button",
                        id:_this.Id+"DeleteBtn",
                        type: "icon",
                        icon: "trash",
                        css:"toolbar_round_btn",
                        width:32,
                        tooltip:LangHelper.GetString(_this.Id, "Delete"),
                        disabled:true,
                        click:function (id,e,node)
                        {
                            var __this = this;
                            setTimeout(function () {
                                var node = __this.getNode(id);
                                _this.QoETriggersAlertDeleteContext.show(node, {pos:"bottom"});
                            }, 10);
                        }
                    },
                    {
                        view: "button",
                        id:this.Id+"QoETriggersAlertsRefreshBtn",
                        type: "icon",
                        icon: "refresh",
                        css: "toolbar_round_btn",
                        width: 32,
                        tooltip: LangHelper.GetString("All","Refresh"),
                        click: function (id, e, node)
                        {
                            _this.RefreshQoETriggersAlertsTable(0);
                        }
                    }
                ]
            },
            {
                view: "datatable",
                id: this.Id + "QoETriggersAlertsTable",
                select: "row",
                editable: true,
                editaction:"custom",
                resizeColumn: true,
                tooltip:true,
                checkboxRefresh:true,
                multiselect:true,
                on: {
                    onCheck:function (id, column, state)
                    {
                        if(column == "checked")
                        {
                            if(state)
                                this.select(id, true);
                            else
                                this.unselect(id, true);

                        }
                    },
                    onItemClick: function (id,e,node)
                    {
                        var __this = this;

                        var rowData = this.getItem(id);

                        if (id.column === 'edit')
                        {
                            _this.ShowQoETriggersAlertsEditForm(rowData, this.getItemNode(id), "right");
                        }

                        else if(id.column === 'trash')
                        {
                            var data = _this.Views.QoETriggersAlertsTable.getItem(id);

                            if(!data._id)
                            {
                                _this.DeleteQoETriggersAlert(id);
                                return;
                            }

                            setTimeout(function () {
                                var node = __this.getItemNode(id);
                                _this.QoETriggersAlertDeleteContext.show(node, {pos:"bottom"});
                            }, 10);
                        }

                        else if(id.column === 'enabled')
                        {
                            if(!rowData._id)
                            {
                                return;
                            }

                            if(parseInt(rowData.enabled,10))
                            {
                                setTimeout(function ()
                                {
                                    _this.EnableQoETriggersAlert(false);
                                }, 1);
                            }
                            else
                            {
                                setTimeout(function ()
                                {
                                    _this.EnableQoETriggersAlert(true);
                                }, 1);
                            }
                        }
                    },
                    onBeforeFilter:function()
                    {
                        return false;
                    },
                    onAfterFilter:function()
                    {
                        _this.RefreshQoETriggersAlertsTable();
                    },
                    onBeforeSort:function()
                    {
                        _this.RefreshQoETriggersAlertsTable();
                        return false;
                    },
                    onAfterSelect:function (data)
                    {
                        var item = this.getItem(data.id);
                        if(item)
                        {
                            if(!item.checked)
                            {
                                item.checked = 1;
                            }
                            this.updateItem(data.id, item);
                        }

                        _this.OnQoETriggersAlertsTableRowSelect();
                    },
                    onAfterUnSelect:function (data)
                    {
                        var item = this.getItem(data.id);
                        if(item && item.checked)
                        {
                            if(item.checked)
                            {
                                item.checked = 0;
                            }
                            this.updateItem(data.id, item);
                        }

                        _this.OnQoETriggersAlertsTableRowUnSelect();
                    },
                    onHeaderClick:function(id, e, target)
                    {
                        if(id.column == "checked")
                        {
                            var cb = this.getHeaderContent("mc");
                            if(cb.isChecked())
                            {
                                this.selectAll();
                            }
                            else
                            {
                                this.unselectAll();
                            }

                            return false;
                        }
                    }
                },
                columns: [
                    {
                        id:"checked",
                        header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                        template: CellColoredCheckBoxTemplate,
                        width:32
                    },
                    {
                        id: "name",
                        header: [TooltipTemplate(LangHelper.GetString("QoE","Trigger name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        fillspace: true,
                        sort: "string"
                    },
                    {
                        id: "type",
                        header: [TooltipTemplate(LangHelper.GetString("QoE","Type")), {
                            content: "multiSelectFilter",
                            options:Helper.DictToArr(QoETriggerAlertTypeDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        template:function(Obj)
                        {
                            var typeStr = "";

                            if(QoETriggerAlertTypeDic[Obj.type])
                            {
                                var color = "orange";

                                switch(Obj.type)
                                {
                                    case QoETriggerAlertStateEnum.ok:
                                        color = "green";
                                        break;
                                    case QoETriggerAlertStateEnum.alerting:
                                        color = "red";
                                        break;
                                    default:
                                        color = "orange"
                                }

                                typeStr += "<span class=\"status status_" + color + "\">";

                                if(Obj.type == QoETriggerAlertStateEnum.alerting)
                                {
                                    typeStr += '<span class="webix_icon fa-exclamation-triangle"></span>';
                                }

                                typeStr += QoETriggerAlertTypeDic[Obj.type].value + "</span>";
                            }
                            else
                            {
                                typeStr = Obj.type;
                            }


                            return typeStr;
                        },
                        fillspace: true,
                        sort: "string"
                    },
                    {
                        id: "date",
                        header: [LangHelper.GetString(this.Id,"Date"), {content: "dateRangeFilter", timepicker: true}],
                        template:function(obj, common){
                            if(obj.date)
                            {
                                var format =  webix.Date.dateToStr("%d.%m.%Y %H:%i:%s");
                                return format(Helper.DateTimeToLocal(obj.date, obj.timezone/60));
                            }

                            return "";
                        },
                        fillspace: true,
                        sort: "date"
                    },
                    {
                        id: "note",
                        header: [TooltipTemplate(LangHelper.GetString("QoE","Note")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        fillspace: true,
                        sort: "string",
                        tooltip:function (Obj)
                        {
                            return Obj && Obj.note ? Helper.ReplaceAll("\n", "<br/>", Obj.note) : "";
                        }
                    },
                    {
                        id: "users_user_id",
                        header: [LangHelper.GetString("QoE","User"), {
                            content: "multiSelectFilter",
                            options: App.DicsManager.GetDicAsArray(DicsEnum.UsersDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        fillspace: true,
                        //width:80,
                        template: function (obj)
                        {
                            var dic = App.DicsManager.GetDic("UsersDic");
                            if(dic && dic[obj.users_user_id])
                                return App.DicsManager.GetDic("UsersDic")[obj.users_user_id].value;
                            else
                                return "";
                        },
                        sort: "string",
                        hidden:function ()
                        {
                            var hidden = 1;

                            var sp = App.SessionManager.GetUserRoleSectionParams(RoleSectionsEnum.qoeanalytics_triggers);

                            if(sp && sp.see_all_users_enabled && sp.see_all_users == "all")
                                hidden = 0;

                            return hidden;
                        }()
                    },
                    {
                        id: "trash",
                        header: "",
                        width: 32,
                        template: CellTrashBtnTemplate,
                        headermenu: false
                    }
                ],
                data:[]
            },
            {
                view: "toolbar",
                padding: 0,
                margin: 0,
                height:32,
                elements: [
                    {
                        view: "pager",
                        gravity:3,
                        id: this.Id + "QoETriggersAlertsTable" + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master:false,
                        on: {
                            onAfterPageChange:function(Page)
                            {
                                _this.RefreshQoETriggersAlertsTable(Page);
                            }
                        }
                    },
                    {
                        view:"richselect",
                        id: this.Id + "QoETriggersAlertsTable" + "Paging" + "Size",
                        label:LangHelper.GetString(this.Id,"On page"),
                        labelWidth:120,
                        minWidth:220,
                        value:100,
                        options:PagingSizeOptions,
                        on: {
                            onChange:function()
                            {
                                _this.RefreshQoETriggersAlertsTable();
                            }
                        }
                    }
                ]
            }
        ]

    };

    this.QoETriggersAlertDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("QoE","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.QoETriggersAlertDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function () {
                                _this.QoETriggersAlertDeleteContext.hide();

                                _this.DeleteQoETriggersAlertsTableSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });
};

QoETriggersAlertsWidget.prototype.ViewDidLoad = function ()
{
    var _this = this;

    this.BindAll();

    this.RefreshAllData();
};

QoETriggersAlertsWidget.prototype.BindAll = function (Params)
{
    var _this = this;
    this.Views.QoETriggersAlertsTable = $$(this.Id + "QoETriggersAlertsTable");
    this.Views.QoETriggersAlertsTablePaging = $$(this.Id + "QoETriggersAlertsTable" + "Paging");
    this.Views.QoETriggersAlertsTablePagingSize = $$(this.Id + "QoETriggersAlertsTable" + "Paging" + "Size");

    this.Views.DeleteBtn = $$(this.Id+"DeleteBtn");

    this.Subscriptions.SignalQoETriggersAlertsUpdatedSubscription = this.QoETriggersManager.SignalQoETriggersAlertsUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateQoETriggersAlertsTable();
        }
    });

    this.Subscriptions.QoETriggersAlertsTableRowsSelectedCountSubscription = this.Signals.QoETriggersAlertsTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.QoETriggersAlertsTableRowsSelectedCountSubscriptionHandler(Value);
    });
};

QoETriggersAlertsWidget.prototype.RefreshAllData = function ()
{
    this.RefreshQoETriggersAlertsTable();
};

QoETriggersAlertsWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        _this.Views.Widgets[key].Destroy();
    });

    // App.WebSocketManager.Disconnect(this.Id);

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.QoETriggersManager)
    {
        this.QoETriggersManager.Destroy();
        delete this.QoETriggersManager;
    }
};

QoETriggersAlertsWidget.prototype.AddQoETriggersAlertToQoETriggersAlertsTable = function ()
{
    var _this = this;

    var model = new QoETriggersAlertModel({days_of_week:'1,2,3,4,5,6,7'});

    _this.Views.QoETriggersAlertsTable.add(model,0);

    _this.Views.QoETriggersAlertsTable.select(model.id, false);
    _this.Views.QoETriggersAlertsTable.showItem(model.id);

    _this.ShowQoETriggersAlertsEditForm(model, _this.Views.QoETriggersAlertsTable.getItemNode(model.id), "right");
};

QoETriggersAlertsWidget.prototype.UpdateQoETriggersAlertsTable = function (Params)
{
    var _this = this;

    var dic = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);

    this.Views.QoETriggersAlertsTable.getColumnConfig("users_user_id").header[1].options = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);

    this.Views.QoETriggersAlertsTable.clearAll();
    this.Views.QoETriggersAlertsTable.parse(_this.QoETriggersManager.GetQoETriggersAlerts());

    this.Views.QoETriggersAlertsTablePagingSize.setValue(this.QoETriggersManager.QoETriggersAlertsFilter.total.size);

    this.Views.QoETriggersAlertsTablePaging.define(this.QoETriggersManager.QoETriggersAlertsFilter.total);
    this.Views.QoETriggersAlertsTablePaging.refresh();
};

QoETriggersAlertsWidget.prototype.RefreshQoETriggersAlertsTable = function (Page)
{
    var _this = this;

    var state = this.Views.QoETriggersAlertsTable.getState();

    var size = this.Views.QoETriggersAlertsTablePagingSize.getValue();

    var filter = this.TriggerFilterModeEnabled ? webix.extend(state.filter, {triggers_ids:this.TriggerFilterIds}) : state.filter;

    this.QoETriggersManager.RefershQoETriggersAlerts({page:Page, filter:filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}})
};

QoETriggersAlertsWidget.prototype.OnQoETriggersAlertsTableRowSelect = function ()
{
    var data = this.GetQoETriggersAlertsTableSelectedData();

    this.Signals.QoETriggersAlertsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoETriggersAlertsWidget.prototype.OnQoETriggersAlertsTableRowUnSelect = function ()
{
    var data = this.GetQoETriggersAlertsTableSelectedData();
    this.Signals.QoETriggersAlertsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoETriggersAlertsWidget.prototype.DeleteQoETriggersAlert = function (RowId)
{
    var _this = this;

    var QoETriggersAlertData = this.Views.QoETriggersAlertsTable.getItem(RowId);
    QoETriggersAlertData.valid = true;

    if(QoETriggersAlertData._id > 0)
    {
        this.QoETriggersManager.DeleteQoETriggerAlert({QoETriggerAlert:QoETriggersAlertData, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.QoETriggersAlertsTable.remove(RowId);

                    webix.message(LangHelper.GetString(_this.Id,"Deleted"));
                }
                else
                {
                    QoETriggersAlertData.valid = false;
                    _this.Views.QoETriggersAlertsTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
    else
    {
        this.Views.QoETriggersAlertsTable.remove(RowId);
    }
};

QoETriggersAlertsWidget.prototype.GetQoETriggersAlertsTableSelectedData = function ()
{
    return this.Views.QoETriggersAlertsTable.getSelectedItem();
};

QoETriggersAlertsWidget.prototype.QoETriggersAlertsTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    if(Value > 1)
    {
        this.Views.DeleteBtn.enable();
    }
    else
    {
        this.Views.DeleteBtn.disable();
    }
};

QoETriggersAlertsWidget.prototype.DeleteQoETriggersAlertsTableSelectedRows = function ()
{
    var _this = this;

    var selectedRows = this.GetQoETriggersAlertsTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    selectedRows.forEach(function (Row)
    {
        _this.DeleteQoETriggersAlert(Row.id);
    });
};

QoETriggersAlertsWidget.prototype.SetTriggerFilter = function (TriggerIds)
{
    this.TriggerFilterIds = TriggerIds;

    if(this.TriggerFilterModeEnabled)
        this.RefreshAllData();
};

QoETriggersAlertsWidget.prototype.ParseTriggerAlertNotification = function(Data)
{
  var _this = this;
  if(Data.success)
  {
      var page = _this.QoETriggersManager.QoETriggersAlertsFilter.paging.page;

      _this.RefreshQoETriggersAlertsTable(page);
  }
};
function QoETriggersAlertsActionsWidget(Params)
{
    var _this = this;

    this.Id = "QoETriggersAlertsActionsWidget";

    this.QoETriggersManager = new QoETriggersManager();

    this.ViewModel = new QoEReportsManager();

    this.Subscriptions = {};

    this.TriggerAlertFilterModeEnabled = false;
    this.TriggerAlertFilterIds = [];

    this.Signals = {
        QoETriggersAlertsActionsTableRowsSelectedCount: new Rx.BehaviorSubject(0)
    };

    this.Views =
    {
        AddQoETriggersAlertActionToQoETriggersAlertsActionsTableBtn:null,
        QoETriggersAlertsActionsTable:null,
        QoETriggersAlertsActionsTablePaging:null,
        QoETriggersAlertsActionsTablePagingSize:null,

        DeleteBtn:null
    };

    this.Views.Widgets = {};

    this.ViewConfig =
    {
        rows:[
            {
                view: "toolbar",
                height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                elements: [
                    {
                        view:"checkbox",
                        id:this.Id + "TriggerAlertFilterModeBtn",
                        labelWidth:0,
                        labelRight:LangHelper.GetString("QoE", "Only selected notifications"),
                        value:this.TriggerAlertFilterModeEnabled ? 1 : 0,
                        on:{
                            onChange: function(New, Old)
                            {
                                _this.TriggerAlertFilterModeEnabled = New;
                                _this.RefreshAllData();
                            }
                        }
                    },
                    {},
                    {
                        view: "button",
                        id:_this.Id+"DeleteBtn",
                        type: "icon",
                        icon: "trash",
                        css:"toolbar_round_btn",
                        width:32,
                        tooltip:LangHelper.GetString(_this.Id, "Delete"),
                        disabled:true,
                        click:function (id,e,node)
                        {
                            var __this = this;
                            setTimeout(function () {
                                var node = __this.getNode(id);
                                _this.QoETriggersAlertActionDeleteContext.show(node, {pos:"bottom"});
                            }, 10);
                        }
                    },
                    {
                        view: "button",
                        id:this.Id+"QoETriggersAlertsActionsRefreshBtn",
                        type: "icon",
                        icon: "refresh",
                        css: "toolbar_round_btn",
                        width: 32,
                        tooltip: LangHelper.GetString("All","Refresh"),
                        click: function (id, e, node)
                        {
                            _this.RefreshQoETriggersAlertsActionsTable(0);
                        }
                    }
                ]
            },
            {
                view: "datatable",
                id: this.Id + "QoETriggersAlertsActionsTable",
                select: "row",
                editable: true,
                editaction:"custom",
                resizeColumn: true,
                tooltip:true,
                checkboxRefresh:true,
                multiselect:true,
                on: {
                    onCheck:function (id, column, state)
                    {
                        if(column == "checked")
                        {
                            if(state)
                                this.select(id, true);
                            else
                                this.unselect(id, true);

                        }
                    },
                    onItemClick: function (id,e,node)
                    {
                        var __this = this;

                        var rowData = this.getItem(id);

                        if (id.column === 'edit')
                        {
                            _this.ShowQoETriggersAlertsActionsEditForm(rowData, this.getItemNode(id), "right");
                        }

                        else if(id.column === 'trash')
                        {
                            var data = _this.Views.QoETriggersAlertsActionsTable.getItem(id);

                            if(!data._id)
                            {
                                _this.DeleteQoETriggersAlertAction(id);
                                return;
                            }

                            setTimeout(function () {
                                var node = __this.getItemNode(id);
                                _this.QoETriggersAlertActionDeleteContext.show(node, {pos:"bottom"});
                            }, 10);
                        }

                        else if(id.column === 'enabled')
                        {
                            if(!rowData._id)
                            {
                                return;
                            }

                            if(parseInt(rowData.enabled,10))
                            {
                                setTimeout(function ()
                                {
                                    _this.EnableQoETriggersAlertAction(false);
                                }, 1);
                            }
                            else
                            {
                                setTimeout(function ()
                                {
                                    _this.EnableQoETriggersAlertAction(true);
                                }, 1);
                            }
                        }
                    },
                    onBeforeFilter:function()
                    {
                        return false;
                    },
                    onAfterFilter:function()
                    {
                        _this.RefreshQoETriggersAlertsActionsTable();
                    },
                    onBeforeSort:function()
                    {
                        _this.RefreshQoETriggersAlertsActionsTable();
                        return false;
                    },
                    onAfterSelect:function (data)
                    {
                        var item = this.getItem(data.id);
                        if(item)
                        {
                            if(!item.checked)
                            {
                                item.checked = 1;
                            }
                            this.updateItem(data.id, item);
                        }

                        _this.OnQoETriggersAlertsActionsTableRowSelect();
                    },
                    onAfterUnSelect:function (data)
                    {
                        var item = this.getItem(data.id);
                        if(item && item.checked)
                        {
                            if(item.checked)
                            {
                                item.checked = 0;
                            }
                            this.updateItem(data.id, item);
                        }

                        _this.OnQoETriggersAlertsActionsTableRowUnSelect();
                    },
                    onHeaderClick:function(id, e, target)
                    {
                        if(id.column == "checked")
                        {
                            var cb = this.getHeaderContent("mc");
                            if(cb.isChecked())
                            {
                                this.selectAll();
                            }
                            else
                            {
                                this.unselectAll();
                            }

                            return false;
                        }
                    }
                },
                columns: [
                    {
                        id:"checked",
                        header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                        template: CellColoredCheckBoxTemplate,
                        width:32
                    },
                    {
                        id: "type",
                        header: [TooltipTemplate(LangHelper.GetString("QoE","Type")), {
                            content: "multiSelectFilter",
                            options:Helper.DictToArr(QoETriggerAlertActionTypeDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        template:function(Obj)
                        {
                            return QoETriggerAlertActionTypeDic[Obj.type] ? QoETriggerAlertActionTypeDic[Obj.type].value : Obj.type;
                            var typeStr = "";

                            if(QoETriggerAlertActionTypeDic[Obj.type])
                            {
                                var color = "orange";

                                switch(Obj.type)
                                {
                                    case QoETriggerAlertsActionstateEnum.ok:
                                        color = "green";
                                        break;
                                    case QoETriggerAlertsActionstateEnum.alertActioning:
                                        color = "red";
                                        break;
                                    default:
                                        color = "orange"
                                }

                                typeStr += "<span class=\"status status_" + color + "\">";

                                if(Obj.type == QoETriggerAlertsActionstateEnum.alertActioning)
                                {
                                    typeStr += '<span class="webix_icon fa-exclamation-triangle"></span>';
                                }

                                typeStr += QoETriggerAlertActionTypeDic[Obj.type].value + "</span>";
                            }
                            else
                            {
                                typeStr = Obj.type;
                            }


                            return typeStr;
                        },
                        fillspace: true,
                        sort: "string"
                    },
                    {
                        id: "date",
                        header: [LangHelper.GetString(this.Id,"Date"), {content: "dateRangeFilter", timepicker: true}],
                        template:function(obj, common){
                            if(obj.date)
                            {
                                var format =  webix.Date.dateToStr("%d.%m.%Y %H:%i:%s");
                                return format(Helper.DateTimeToLocal(obj.date, obj.timezone/60));
                            }

                            return "";
                        },
                        fillspace: true,
                        sort: "date"
                    },
                    // {
                    //     id: "note",
                    //     header: [TooltipTemplate(LangHelper.GetString("QoE","Note")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    //     fillspace: true,
                    //     sort: "string",
                    //     tooltip:function (Obj)
                    //     {
                    //         return Obj && Obj.note ? Helper.ReplaceAll("\n", "<br/>", Obj.note) : "";
                    //     }
                    // },
                    {
                        id: "state_code",
                        header:[TooltipTemplate(LangHelper.GetString("QoE", "State")), {
                            content: "multiSelectFilter",
                            options: Helper.DictToArr(QoETriggerAlertActionStateCodeDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        template:function(Obj)
                        {
                            var stateStr = "";

                            if(QoETriggerAlertActionStateCodeDic[Obj.state_code])
                            {
                                var color = "green";

                                switch(Obj.state_code)
                                {
                                    case QoETriggerAlertActionStateCodeEnum.ready:
                                    case QoETriggerAlertActionStateCodeEnum.complete:
                                        color = "green";
                                        break;
                                    case QoETriggerAlertActionStateCodeEnum.error:
                                    case QoETriggerAlertActionStateCodeEnum.cancel:
                                    case QoETriggerAlertActionStateCodeEnum["max attempts"]:
                                        color = "red";
                                        break;
                                    default:
                                        color = "orange"
                                }

                                stateStr += "<span class=\"status status_" + color + "\">";

                                if(Obj.state_code == QoETriggerStateCodeEnum.error)
                                {
                                    stateStr += '<span class="webix_icon fa-exclamation-triangle"></span>';
                                }

                                stateStr += QoETriggerAlertActionStateCodeDic[Obj.state_code].value + "</span>";
                            }
                            else
                            {
                                stateStr = Obj.state_code;
                            }


                            return stateStr;

                        },
                        fillspace: true,
                        sort: "string",
                        tooltip:function (Obj)
                        {
                            var stateStr = "";

                            if(Obj.state_json && JSON.parse(Obj.state_json))
                            {
                                var state = JSON.parse(Obj.state_json);

                                if(state.result)
                                {
                                    if(state.result.success)
                                    {
                                        stateStr = "Success";
                                    }
                                    else
                                    {
                                        stateStr = state.result.error && state.result.error.msg ? "Error: " + state.result.error.msg : "Error";
                                    }
                                }
                            }

                            return stateStr;
                        }
                    },
                    {
                        id: "users_user_id",
                        header: [LangHelper.GetString("QoE","User"), {
                            content: "multiSelectFilter",
                            options: App.DicsManager.GetDicAsArray(DicsEnum.UsersDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        fillspace: true,
                        //width:80,
                        template: function (obj)
                        {
                            var dic = App.DicsManager.GetDic("UsersDic");
                            if(dic && dic[obj.users_user_id])
                                return App.DicsManager.GetDic("UsersDic")[obj.users_user_id].value;
                            else
                                return "";
                        },
                        sort: "string",
                        hidden:function ()
                        {
                            var hidden = 1;

                            var sp = App.SessionManager.GetUserRoleSectionParams(RoleSectionsEnum.qoeanalytics_triggers);

                            if(sp && sp.see_all_users_enabled && sp.see_all_users == "all")
                                hidden = 0;

                            return hidden;
                        }()
                    },
                    {
                        id: "trash",
                        header: "",
                        width: 32,
                        template: CellTrashBtnTemplate,
                        headermenu: false
                    }
                ],
                data:[]
            },
            {
                view: "toolbar",
                padding: 0,
                margin: 0,
                height:32,
                elements: [
                    {
                        view: "pager",
                        gravity:3,
                        id: this.Id + "QoETriggersAlertsActionsTable" + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master:false,
                        on: {
                            onAfterPageChange:function(Page)
                            {
                                _this.RefreshQoETriggersAlertsActionsTable(Page);
                            }
                        }
                    },
                    {
                        view:"richselect",
                        id: this.Id + "QoETriggersAlertsActionsTable" + "Paging" + "Size",
                        label:LangHelper.GetString(this.Id,"On page"),
                        labelWidth:120,
                        minWidth:220,
                        value:100,
                        options:PagingSizeOptions,
                        on: {
                            onChange:function()
                            {
                                _this.RefreshQoETriggersAlertsActionsTable();
                            }
                        }
                    }
                ]
            }
        ]

    };

    this.QoETriggersAlertActionDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("QoE","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.QoETriggersAlertActionDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function () {
                                _this.QoETriggersAlertActionDeleteContext.hide();

                                _this.DeleteQoETriggersAlertsActionsTableSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });
};

QoETriggersAlertsActionsWidget.prototype.ViewDidLoad = function ()
{
    var _this = this;

    this.BindAll();

    this.RefreshAllData();
};

QoETriggersAlertsActionsWidget.prototype.BindAll = function (Params)
{
    var _this = this;
    this.Views.QoETriggersAlertsActionsTable = $$(this.Id + "QoETriggersAlertsActionsTable");
    this.Views.QoETriggersAlertsActionsTablePaging = $$(this.Id + "QoETriggersAlertsActionsTable" + "Paging");
    this.Views.QoETriggersAlertsActionsTablePagingSize = $$(this.Id + "QoETriggersAlertsActionsTable" + "Paging" + "Size");

    this.Views.DeleteBtn = $$(this.Id+"DeleteBtn");

    this.Subscriptions.SignalQoETriggersAlertsActionsUpdatedSubscription = this.QoETriggersManager.SignalQoETriggersAlertsActionsUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateQoETriggersAlertsActionsTable();
        }
    });

    this.Subscriptions.QoETriggersAlertsActionsTableRowsSelectedCountSubscription = this.Signals.QoETriggersAlertsActionsTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.QoETriggersAlertsActionsTableRowsSelectedCountSubscriptionHandler(Value);
    });

    // App.WebSocketManager.Connect(this.Id);
    //
    // App.WebSocketManager.Connections[this.Id].on("trigger_alert_action_update", function(data){
    //     _this.ParseTriggerAlertActionsNotification(JSON.parse(data));
    // })
};

QoETriggersAlertsActionsWidget.prototype.RefreshAllData = function ()
{
    this.RefreshQoETriggersAlertsActionsTable();
};

QoETriggersAlertsActionsWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        _this.Views.Widgets[key].Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.QoETriggersManager)
    {
        this.QoETriggersManager.Destroy();
        delete this.QoETriggersManager;
    }
};

QoETriggersAlertsActionsWidget.prototype.AddQoETriggersAlertActionToQoETriggersAlertsActionsTable = function ()
{
    var _this = this;

    var model = new QoETriggersAlertActionModel({days_of_week:'1,2,3,4,5,6,7'});

    _this.Views.QoETriggersAlertsActionsTable.add(model,0);

    _this.Views.QoETriggersAlertsActionsTable.select(model.id, false);
    _this.Views.QoETriggersAlertsActionsTable.showItem(model.id);

    _this.ShowQoETriggersAlertsActionsEditForm(model, _this.Views.QoETriggersAlertsActionsTable.getItemNode(model.id), "right");
};

QoETriggersAlertsActionsWidget.prototype.UpdateQoETriggersAlertsActionsTable = function (Params)
{
    var _this = this;

    var dic = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);

    this.Views.QoETriggersAlertsActionsTable.getColumnConfig("users_user_id").header[1].options = App.DicsManager.GetDicAsArray(DicsEnum.UsersDic);

    this.Views.QoETriggersAlertsActionsTable.clearAll();
    this.Views.QoETriggersAlertsActionsTable.parse(_this.QoETriggersManager.GetQoETriggersAlertsActions());

    this.Views.QoETriggersAlertsActionsTablePagingSize.setValue(this.QoETriggersManager.QoETriggersAlertsActionsFilter.total.size);

    this.Views.QoETriggersAlertsActionsTablePaging.define(this.QoETriggersManager.QoETriggersAlertsActionsFilter.total);
    this.Views.QoETriggersAlertsActionsTablePaging.refresh();
};

QoETriggersAlertsActionsWidget.prototype.RefreshQoETriggersAlertsActionsTable = function (Page)
{
    var _this = this;

    var state = this.Views.QoETriggersAlertsActionsTable.getState();

    var size = this.Views.QoETriggersAlertsActionsTablePagingSize.getValue();

    var filter = this.TriggerAlertFilterModeEnabled ? webix.extend(state.filter, {alerts_ids:this.TriggerAlertFilterIds}) : state.filter;

    this.QoETriggersManager.RefershQoETriggersAlertsActions({page:Page, filter:filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}})
};

QoETriggersAlertsActionsWidget.prototype.OnQoETriggersAlertsActionsTableRowSelect = function ()
{
    var data = this.GetQoETriggersAlertsActionsTableSelectedData();

    this.Signals.QoETriggersAlertsActionsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoETriggersAlertsActionsWidget.prototype.OnQoETriggersAlertsActionsTableRowUnSelect = function ()
{
    var data = this.GetQoETriggersAlertsActionsTableSelectedData();
    this.Signals.QoETriggersAlertsActionsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoETriggersAlertsActionsWidget.prototype.DeleteQoETriggersAlertAction = function (RowId)
{
    var _this = this;

    var QoETriggersAlertActionData = this.Views.QoETriggersAlertsActionsTable.getItem(RowId);
    QoETriggersAlertActionData.valid = true;

    if(QoETriggersAlertActionData._id > 0)
    {
        this.QoETriggersManager.DeleteQoETriggerAlertAction({QoETriggerAlertAction:QoETriggersAlertActionData, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.QoETriggersAlertsActionsTable.remove(RowId);

                    webix.message(LangHelper.GetString(_this.Id,"Deleted"));
                }
                else
                {
                    QoETriggersAlertActionData.valid = false;
                    _this.Views.QoETriggersAlertsActionsTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
    else
    {
        this.Views.QoETriggersAlertsActionsTable.remove(RowId);
    }
};

QoETriggersAlertsActionsWidget.prototype.GetQoETriggersAlertsActionsTableSelectedData = function ()
{
    return this.Views.QoETriggersAlertsActionsTable.getSelectedItem();
};

QoETriggersAlertsActionsWidget.prototype.QoETriggersAlertsActionsTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    if(Value > 1)
    {
        this.Views.DeleteBtn.enable();
    }
    else
    {
        this.Views.DeleteBtn.disable();
    }
};

QoETriggersAlertsActionsWidget.prototype.DeleteQoETriggersAlertsActionsTableSelectedRows = function ()
{
    var _this = this;

    var selectedRows = this.GetQoETriggersAlertsActionsTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    selectedRows.forEach(function (Row)
    {
        _this.DeleteQoETriggersAlertAction(Row.id);
    });
};

QoETriggersAlertsActionsWidget.prototype.SetTriggerAlertFilter = function (TriggerAlertIds)
{
    this.TriggerAlertFilterIds = TriggerAlertIds;

    if(this.TriggerAlertFilterModeEnabled)
        this.RefreshAllData();
};

QoETriggersAlertsWidget.prototype.ParseTriggerAlertActionsNotification = function(Data)
{
    var _this = this;
    if(Data.success)
    {
        var page = _this.QoETriggersManager.QoETriggersAlertsActionsFilter.paging.page;

        _this.RefreshQoETriggersAlertsActionsTable(page);
    }
};
function QoETriggersViewController(Params)
{
    var _this = this;

    this.Id = "QoETriggers";

    this.ViewModel = new QoEReportsManager();

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views =
    {
        Widgets:{
            Triggers: new QoETriggersWidget(),
            Alerts: new QoETriggersAlertsWidget(),
            AlertsActions: new QoETriggersAlertsActionsWidget()
        },

        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({id:this.Id + "LicPageHeaderWidget", licLevel:"standard", licOption:"triggers"})
    };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    cols:[
                                        PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Triggers & Alerts")}),
                                        {
                                            gravity:3,
                                            rows:[
                                                this.Views.LicPageHeaderWidget.ViewConfig
                                            ]
                                        }
                                    ]
                                },
                                {
                                    rows:[
                                        {
                                            id:this.Id + "Accordion",
                                            view: "accordion",
                                            multi: "mixed",
                                            cols:[
                                                {
                                                    header:BlockHeaderTemplate().template({title: LangHelper.GetString("QoE", "Triggers"), icon: "bell"}),
                                                    id: this.Id + "AccordionQoETriggers",
                                                    body:this.Views.Widgets.Triggers.ViewConfig
                                                },
                                                {view:"resizer"},
                                                {
                                                    header:BlockHeaderTemplate().template({title: LangHelper.GetString("QoE", "Alerts"), icon: "alarm-clock"}),
                                                    id: this.Id + "AccordionAlerts",
                                                    body:this.Views.Widgets.Alerts.ViewConfig
                                                },
                                                {view:"resizer"},
                                                {
                                                    header:BlockHeaderTemplate().template({title: LangHelper.GetString("QoE", "Alerts actions"), icon: "location"}),
                                                    id: this.Id + "AccordionAlertsActions",
                                                    body:this.Views.Widgets.AlertsActions.ViewConfig
                                                },
                                                {gravity: 0}
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

};

QoETriggersViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoETriggers");
    });

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        _this.Views.Widgets[Key].ViewDidLoad();
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();


};

QoETriggersViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Subscriptions.TriggersSelectedCountSubscription = this.Views.Widgets.Triggers.Signals.QoETriggersTableRowsSelectedCount.subscribe(function (Value)
    {
        var ids = [];

        var selected = _this.Views.Widgets.Triggers.GetQoETriggersTableSelectedData();

        if(selected)
        {
            selected = Array.isArray(selected) ? selected : [selected];

            selected.forEach(function (Obj)
            {
                ids.push(Obj._id);
            });
        }

        _this.Views.Widgets.Alerts.SetTriggerFilter(ids);
    });

    this.Subscriptions.TriggersAlertsSelectedCountSubscription = this.Views.Widgets.Alerts.Signals.QoETriggersAlertsTableRowsSelectedCount.subscribe(function (Value)
    {
        var ids = [];

        var selected = _this.Views.Widgets.Alerts.GetQoETriggersAlertsTableSelectedData();

        if(selected)
        {
            selected = Array.isArray(selected) ? selected : [selected];

            selected.forEach(function (Obj)
            {
                ids.push(Obj._id);
            });
        }

        _this.Views.Widgets.AlertsActions.SetTriggerAlertFilter(ids);
    });

    this.Views.LicPageHeaderWidget.BindAll(Params);
};

QoETriggersViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        _this.Views.Widgets[key].Destroy();
    });

    this.Views.LicPageHeaderWidget.Destroy();

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoETriggersViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};
function QoEAnyReportViewController(Params)
{
    var _this = this;

    this.IdsEnum =
    {
        QoEAnyReport:"QoEAnyReport",
        UlrQoEAnyReport:"UlrQoEAnyReport"
    };

    this.Id = Params&&Params.Id ? Params.Id : this.IdsEnum.QoEAnyReport;

    this.PageTitle = Params&&Params.PageTitle?Params.PageTitle:{
        RootTitle: LangHelper.GetString("AppView", "QoE analytics"),
        Title: LangHelper.GetString("AppView", "Report")
    };

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.Subscriptions = {};

    this.Views =
    {
        WidgetsContainer:null,
        DpiPicker:null,
        ClearCacheBtn:null,
        KillAllProcessesBtn:null,
        DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"}),
        ExtendedFillter: new QoEPopupFilterWidget({
            id:this.Id + "ExtendedFillter",
            config: QoEPopupFilterWidgetDefaultConfig("QoEFullNetFlow"),
            enable_show_hotkey: 1
        }),
        UserReportsFormWidget: function() {
            if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
        }(),
        WidgetsSuggest:null,
        Widgets:{}
    };

    this.ReportIdentity = {
        Id:null,
        Name:null
    };

    this.Signals = {
        ReportReady: new Rx.BehaviorSubject(0)
    }


    this.ViewConfig = [
        {
            type: "space",
            rows:function (){

                var header = PageHeaderTemplate({id:_this.Id + "PageTitle", root_title: _this.Id === _this.IdsEnum.UlrQoEAnyReport ? _this.PageTitle.Title : _this.PageTitle.RootTitle, title: _this.Id === _this.IdsEnum.UlrQoEAnyReport ? "" : _this.PageTitle.Title});

                var toolbar = {
                        view: "toolbar",
                        elements: [
                            _this.Views.DateRangePicker.ViewConfig,
                            {
                                view:_this.Id === _this.IdsEnum.UlrQoEAnyReport ? "spectre_multiselect" : "multiselect",
                                id:_this.Id + "DpiPicker",
                                value:"-2",
                                maxWidth:320,
                                optionWidth:320,
                                options:[]
                            },
                            _this.Views.ExtendedFillter.ViewConfig,
                            {},
                            {
                                view: "button",
                                id:_this.Id+"RefreshAllDataBtn",
                                type: "icon",
                                icon: "refresh",
                                css: "toolbar_round_btn",
                                width: 32,
                                tooltip: LangHelper.GetString("QoE", "Refresh"),
                                click: function (id, e, node)
                                {
                                    _this.RefreshAllData(true);
                                }
                            },
                            _this.ReportsSettings.GeneralSettingsBtnViewConfig,
                            {
                                width: 16
                            },
                            QoEKillProcessesBtnWidget({
                                id:_this.Id + "KillAllProcessesBtn",
                                restricted:{"KillAllSectionReportsProcesses":1},
                                callback:function (Id)
                                {
                                    _this.KillProcesses(Id);
                                }
                            }),
                            QoEClearCacheBtnWidget({
                                id:_this.Id + "ClearCacheBtn",
                                restricted:{"ClearAllSectionReports":1},
                                callback:function (Id)
                                {
                                    _this.ClearCache(Id);
                                }
                            })
                        ]
                    };

                if(_this.Id === _this.IdsEnum.UlrQoEAnyReport)
                {
                    toolbar.elements.push({width: 1}); //Затычка, иначе едет тулбар почему-то
                }

                var container = {
                    id: _this.Id + "WidgetsContainer",
                    rows: []
                };

                var rows = [];

                if(_this.Id === _this.IdsEnum.UlrQoEAnyReport)
                {
                    rows = [
                        {height:6},
                        header,
                        {height:32},
                        toolbar,
                        container
                    ];
                }
                else
                {
                    rows = [
                        header,
                        toolbar,
                        container
                    ];
                }

                return [
                    {
                        type: "clear",
                        borderless: true,
                        rows: rows
                    }
                ]
            }()
        }
    ];
};

QoEAnyReportViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    //this.ConfigWidget("QoETableNetflowTopSubscriberASsShortWidget");

    this.GetAllPathParam();

    this.RefreshConfig();

    //this.SetAllPathParam();
};

QoEAnyReportViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ClearCacheBtn = $$(this.Id + "ClearCacheBtn");
    this.Views.KillAllProcessesBtn = $$(this.Id + "KillAllProcessesBtn");

    this.Views.DateRangePicker.Bind(this);

    this.Views.ExtendedFillter.Bind(this);

    this.ReportsSettings.Bind();

    if(this.Views.UserReportsFormWidget)
    {
        this.Views.UserReportsFormWidget.Bind(this);
        this.Views.WidgetsSuggest = this.Views.UserReportsFormWidget.Views.Widgets.WidgetsSuggest;
    }

    if(!this.Views.WidgetsSuggest)
    {
        this.Views.WidgetsSuggest = new QoEWidgetsSuggestWidget({
            id: this.Id + "WidgetsSuggest",
            exceptWidgetCodes: ExceptWidgetCodes.with_settings
        });
        this.Views.WidgetsSuggest.Bind();
        this.Views.WidgetsSuggest.RefreshWidgets();
    }

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.Views.WidgetsContainer = $$(this.Id + "WidgetsContainer");

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });
};

QoEAnyReportViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        _this.Subscriptions[Key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        _this.Views.Widgets[key].Destroy();
    });

    this.Views.ExtendedFillter.Destroy();

    this.Views.DateRangePicker.Destroy();

    if(this.Views.UserReportsFormWidget)
        this.Views.UserReportsFormWidget.Destroy();

    if(this.Views.WidgetsSuggest)
        this.Views.WidgetsSuggest.Destroy();

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEAnyReportViewController.prototype.RefreshConfig = function ()
{
    var _this = this;

    if(this.ReportIdentity.Id)
    {
        this.ViewModel.GetStoredReport(this.ReportIdentity.Id,function (R)
        {
            if(R.success)
            {
                _this.ConfigWidget(R.data);
                _this.DisableWidgetsIfNeed();
                _this.Signals.ReportReady.next(1);

                setTimeout(function () {
                    _this.RefreshAllData();
                },1);
            }
        });
    }
};

QoEAnyReportViewController.prototype.ConfigWidget = function (Config)
{
    var _this = this;

    if(this.Views.Widgets[Config.widget_name])
    {
        this.Views.Widgets[Config.widget_name].Destroy();
        delete this.Views.Widgets[Config.widget_name];
    }

    let find = this.Views.WidgetsSuggest.FindItemByParams(Config);

    const wFunc = find && find.func ? find.func : Config.widget_name;
    const wId = this.Id + webix.uid();
    const wParams = find && find.widget_settings ? find.widget_settings : {};

    if(!window[wFunc])
        return;

    wParams.id = wId;
    let widget = new window[wFunc](wParams);

    if(widget.constructor.name === "QoETableChartWidget")
        widget = this.SuggestTableChartWidget(find, widget, true);

    if(Config.lifetime_sec && widget.Config && widget.Config.cache && widget.Config.cache.enabled)
        widget.Config.cache.lifetime_sec = Config.lifetime_sec;

    this.Views.Widgets[Config.widget_name] = widget;

    this.Views.WidgetsContainer.define("rows", webix.copy([widget.ViewConfig]));
    this.Views.WidgetsContainer.reconstruct();

    setTimeout(function ()
    {
        widget.Bind(_this);

        if(Config.report_settings_json && widget.ReportsSettingsManager)
        {
            let settingsModel = widget.ReportsSettingsManager.ReportsSettings[widget.Id];

            if(settingsModel)
                settingsModel.SetCurState(Config.report_settings_json, true);
        }
    },1);

    let fConfig = find && find.filter_config
        ? find.filter_config
        : null;

    let fType = fConfig && fConfig.type
        ? fConfig.type
        : find && find.filter_type ? find.filter_type : null;

    if(!fType) {
        var wn = Config.widget_name.toLowerCase();

        if(wn.indexOf("clickstream") >= 0)
        {
            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawClickstreamLogs : QoEPopupFilterWidgetConfigTypeEnum.QoEClickstream;
        }

        else if(wn.indexOf("fullnetflow") >= 0 || wn.indexOf("fullflow") >= 0 || wn.indexOf("netflow") >= 0)
        {
            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNetFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;
        }

        else if(wn.indexOf("gtp") >= 0 || wn.indexOf("location") >= 0)
        {
            if(wn.indexOf("raw") >= 0)
            {
                fType = QoEPopupFilterWidgetConfigTypeEnum.QoERawFullGtpFlow;
            }
            else{
                fType = QoEPopupFilterWidgetConfigTypeEnum.QoEFullGtpFlow
            }
        }
        else if(wn.indexOf("nat") >= 0)
        {
            fType = QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNatFlow;
        }
        else if(wn.indexOf("vchannels") >= 0 || wn.indexOf("classes") >= 0)
        {
            fType = QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;
        }
        else if(wn.indexOf("dns") >= 0)
        {
            if(wn.indexOf("raw") >= 0)
            {
                fType = QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDnsFlow;
            }
            else{
                fType = QoEPopupFilterWidgetConfigTypeEnum.QoEFullDnsFlow;
            }
        }
        else if(wn.indexOf("ddos") >= 0)
        {
            if(wn.indexOf("raw" >= 0))
            {
                fType = QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDdosAttackFlow;
            }
            else
            {
                fType = QoEPopupFilterWidgetConfigTypeEnum.QoEFullDdosAttackFlow;
            }
        }
        // var type = Config.widget_name.indexOf("Clickstream") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoEClickstream : QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;
    }

    if(!fConfig)
        fConfig = QoEPopupFilterWidgetDefaultConfig(fType);

    _this.Views.ExtendedFillter.SetConfig(fConfig);

    if(Config.filter_state)
        _this.Views.ExtendedFillter.SetState(Config.filter_state);
    else
        _this.Views.ExtendedFillter.SetState();

    if(Config.period_state)
    {
        var format = webix.Date.strToDate("%Y-%m-%d %H:%i:%s");

        this.Views.DateRangePicker.SetValue({start: format(Config.period_state.period_from), end: format(Config.period_state.period_to)}, true);
    }
};

QoEAnyReportViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var period = this.Views.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter};

    if(this.ReportIdentity.Id)
        params.report_id = this.ReportIdentity.Id;

    var is_trigger = false;

    if(params && params.report_id && params.report_id.indexOf("_trigger_") > 0)
        is_trigger = true;

    if(is_trigger || forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        Object.keys(this.Views.Widgets).forEach(function (Key)
        {
            if(_this.Views.Widgets[Key].RefreshData)
                _this.Views.Widgets[Key].RefreshData(0, params);
        });
    }

    _this.SetAllPathParam();
};

QoEAnyReportViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache || ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.Views.Widgets).forEach(function (Key)
        {
            var report = _this.Views.Widgets[Key];

            if(report.GetCachesIds && report.GetCachesIds())
                params.caches_ids = params.caches_ids.concat(report.GetCachesIds());
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoEAnyReportViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses || ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.Views.Widgets).forEach(function (Key)
        {
            var report = _this.Views.Widgets[Key];

            if(report.GetCachesIds && report.GetCachesIds())
                params.processes_ids = params.processes_ids.concat(_this.Views.Widgets[Key].GetCachesIds());
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoEAnyReportViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoEAnyReportViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoEAnyReportViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEAnyReportViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEAnyReportViewController.prototype.SetAllPathParam = function()
{
    // var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    // if(report)
    // {
    //     this.SetPathParam("report", report);
    // }

    // var period = this.Views.DateRangePicker.GetValue();
    // if(period)
    // {
    //     this.SetPathParam("period", period);
    // }
    //
    // var dpi = this.Views.DpiPicker.getValue();
    // if(dpi)
    // {
    //     this.SetPathParam("dpi", dpi);
    // }

    // var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    // if(filter)
    // {
    //     this.SetPathParam("filter", filter);
    // }

    this.JustNavigate();
};

QoEAnyReportViewController.prototype.GetAllPathParam = function()
{
    try
    {
        this.ReportIdentity.Id = this.GetPathParam("report_id");

        this.ReportIdentity.Id = Helper.ReplaceAll(" ", "_", this.ReportIdentity.Id);
    }
    catch(e){}
};

QoEAnyReportViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEAnyReportViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.ExtendedFillter.GetState(),
        filter_config: this.Views.ExtendedFillter.GetFilters()
    };
};

QoEAnyReportViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};

QoEAnyReportViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

QoEAnyReportViewController.prototype.DisableWidgetsIfNeed = function()
{
    if(this.ReportIdentity.Id && this.ReportIdentity.Id.includes("trigger"))
    {
        if(this.Views.DateRangePicker)
            this.Views.DateRangePicker.DisableWidget();
        if(this.Views.DpiPicker)
            this.Views.DpiPicker.disable();
        if(this.Views.ExtendedFillter)
            this.Views.ExtendedFillter.DisableWidget();
        if(this.ReportsSettings)
            this.ReportsSettings.DisableWidget();
        if(this.Views.ClearCacheBtn)
            this.Views.ClearCacheBtn.disable();
        if(this.Views.KillAllProcessesBtn)
            this.Views.KillAllProcessesBtn.disable();
    }
};

QoEAnyReportViewController.prototype.SuggestTableChartWidget = function(Find, Widget, DestroyParent = false)
{
    let findProps;
    let suggestWidget = Widget;

    if(Find && Find.widget_icon)
        findProps = Object.values(WidgetTypesMap).find(item => item.type === Find.widget_icon);

    const widgetProp = findProps && findProps.prop ? findProps.prop : WidgetTypesMap["QoESeriesChartReportWidget"].prop;

    if(Widget[widgetProp])
    {
        suggestWidget = Widget[widgetProp];

        if(suggestWidget && DestroyParent)
            Widget.Destroy([suggestWidget.Id]);
    }

    return suggestWidget;
};
function QoERawClickstreamViewController(Params)
{
    var _this = this;

    this.Id = "QoERawClickstream";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,

        DpiPicker:null,

        ExecTimeSelector:null
    };
    this.Views.Widgets =
        {
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker", default_value:"Last 15 minutes"}),

            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoERawClickstreamLogs),
                enable_show_hotkey: 1
            }),

            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),

            RawReport: QoETableClickstreamRawLogAsIsWidget({id:this.Id + "Clickstream" + "RawReport"}),
            RawReportWithFullflow: QoETableClickstreamRawLogWithFullflowWidget({id:this.Id + "Clickstream" + "RawReportWithFullflow"})
        };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Raw clickstream")}),
                                {
                                    view: "toolbar",
                                    elements: [
                                        this.Views.Widgets.DateRangePicker.ViewConfig,
                                        {
                                            view:"multiselect",
                                            id:this.Id + "DpiPicker",
                                            value:"-2",
                                            maxWidth:320,
                                            optionWidth:320,
                                            options:[]
                                        },
                                        {
                                            view:"richselect",
                                            id:this.Id + "ExecTimeSelector",
                                            value:600,
                                            maxWidth:120,
                                            optionWidth:320,
                                            tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                            options:[
                                                {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                            ]
                                        },
                                        this.Views.Widgets.ExtendedFillter.ViewConfig,
                                        {},
                                        {
                                            view: "button",
                                            id:this.Id+"RefreshAllDataBtn",
                                            type: "icon",
                                            icon: "refresh",
                                            css: "toolbar_round_btn",
                                            width: 32,
                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                            click: function (id, e, node)
                                            {
                                                _this.RefreshAllData(true);
                                            }
                                        },
                                        this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                        {
                                            width: 16
                                        },
                                        QoEKillProcessesBtnWidget({
                                            id:this.Id+"KillProcessesBtn",
                                            callback:function (Id)
                                            {
                                                _this.KillProcesses(Id);
                                            }
                                        }),
                                        QoEClearCacheBtnWidget({
                                            id:this.Id+"ClearCacheBtn",
                                            callback:function (Id)
                                            {
                                                _this.ClearCache(Id);
                                            }
                                        })
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            rows:[
                                                {
                                                    view:"multiview",
                                                    id:this.Id + "ReportsCells",
                                                    cells:[
                                                        {
                                                            id: this.Id + "ReportsCells" + "RawReport",
                                                            rows:[
                                                                this.Views.Widgets.RawReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "RawReportWithFullflow",
                                                            rows:[
                                                                this.Views.Widgets.RawReportWithFullflow.ViewConfig
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {view: "resizer"},
                                        {
                                            width: 400,
                                            rows: [
                                                BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                {
                                                    view: "treetable",
                                                    id:this.Id + "ReportsList",
                                                    header:false,
                                                    select: "row",
                                                    on: {
                                                        onAfterSelect:function ()
                                                        {
                                                            _this.OnReportsListSelect();
                                                        },
                                                        onAfterUnSelect:function ()
                                                        {
                                                            _this.OnReportsListUnSelect();
                                                        }
                                                    },
                                                    columns: [
                                                        {
                                                            id: "value",
                                                            fillspace: true,
                                                            template: function(obj, common, value, config)
                                                            {
                                                                return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                            }
                                                        }
                                                    ],
                                                    data: function ()
                                                    {
                                                        var arr =
                                                        [
                                                            {
                                                                id: _this.Id + "ReportsCells" + "RawReport",
                                                                value: LangHelper.GetString("QoE", "Raw clickstream")
                                                            }
                                                        ];

                                                        if(AppEnv.ClickstreamRawReportWithFullflow_isHidden !== 1)
                                                        {
                                                            arr.push({
                                                                id: _this.Id + "ReportsCells" + "RawReportWithFullflow",
                                                                value: LangHelper.GetString("QoE", "Raw clickstream") + " " + LangHelper.GetString("QoE", "With netflow").toLowerCase()
                                                            })
                                                        }

                                                        return arr;
                                                    }()
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RawReport"] = [this.Views.Widgets.RawReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RawReportWithFullflow"] = [this.Views.Widgets.RawReportWithFullflow];
};

QoERawClickstreamViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoERawClickstream");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();


};

QoERawClickstreamViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w && w.Bind)
            _this.Views.Widgets[Key].Bind(_this);
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();
                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoERawClickstreamViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoERawClickstreamViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoERawClickstreamViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoERawClickstreamViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawClickstreamViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawClickstreamViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoERawClickstreamViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoERawClickstreamViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoERawClickstreamViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoERawClickstreamViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoERawClickstreamViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoERawClickstreamViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoERawClickstreamViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoERawClickstreamViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoERawClickstreamViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoERawClickstreamViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoERawClickstreamViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};
function QoERawFullNetFlowViewController(Params)
{
    var _this = this;

    this.Id = "QoERawFullNetFlow";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,

        DpiPicker:null,

        ExecTimeSelector:null
    };
    this.Views.Widgets =
        {
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker", default_value:"Last 15 minutes"}),

            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNetFlow),
                enable_show_hotkey: 1
            }),

            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),

            RawReport: QoETableFullflowRawLogWidget({id:this.Id + "Fullnetflow" + "RawReport"}),

            ShortRawReport: QoETableFullflowRawLogShortWidget({id:this.Id + "Fullnetflow" + "ShortRawReport"}),

            SubscriberRawReport: QoETableFullflowRawLogSubscriberWidget({id:this.Id + "Fullnetflow" + "SubscriberRawReport"}),



            TopTrafficProtocols: QoETableFullflowRawTopTrafficProtocolsWidget({id:this.Id + "Fullnetflow" + "TopTrafficProtocols"}),

            TopFlowProtocols: QoETableFullflowRawTopFlowProtocolsWidget({id:this.Id + "Fullnetflow" + "TopFlowProtocols"}),

            TopSesLifetimeProtocols: QoETableFullflowRawTopSesLifetimeProtocolsWidget({id:this.Id + "Fullnetflow" + "TopSesLifetimeProtocols"}),

            TopSubsHostsProtocols: QoETableFullflowRawTopSubsHostsProtocolsWidget({id:this.Id + "Fullnetflow" + "TopSubsHostsProtocols"}),

            TopProtocolsMaxi: QoETableFullflowRawTopProtocolsWidget({id:this.Id + "Fullnetflow" + "TopProtocolsMaxi"}),


            TopTrafficProtocolsGrps: QoETableFullflowRawTopTrafficProtocolsGroupsWidget({id:this.Id + "Fullnetflow" + "TopTrafficProtocolsGrps"}),

            TopFlowProtocolsGrps: QoETableFullflowRawTopFlowProtocolsGroupsWidget({id:this.Id + "Fullnetflow" + "TopFlowProtocolsGrps"}),

            TopSesLifetimeProtocolsGrps: QoETableFullflowRawTopSesLifetimeProtocolsGroupsWidget({id:this.Id + "Fullnetflow" + "TopSesLifetimeProtocolsGrps"}),

            TopSubsHostsProtocolsGrps: QoETableFullflowRawTopSubsHostsProtocolsGroupsWidget({id:this.Id + "Fullnetflow" + "TopSubsHostsProtocolsGrps"}),

            TopProtocolsGrpsMaxi: QoETableFullflowRawTopProtocolsGroupsWidget({id:this.Id + "Fullnetflow" + "TopProtocolsGrpsMaxi"}),


            SshBruteForceReport: QoETableFullnetflowRawSshBruteForceWidget({id: this.Id + "QoETableFullnetflowRawSshBruteForceWidget"}),

            TopTrafficSubscribers: QoETableFullflowRawTopTrafficSubscribersWidget({id:this.Id + "Fullnetflow" + "TopTrafficSubscribers"}),

            TopFlowSubscribers: QoETableFullflowRawTopFlowSubscribersWidget({id:this.Id + "Fullnetflow" + "TopFlowSubscribers"}),

            TopSesLifetimeSubscribers: QoETableFullflowRawTopSesLifetimeSubscribersWidget({id:this.Id + "Fullnetflow" + "TopSesLifetimeSubscribers"}),

            TopSubsHostsSubscribers: QoETableFullflowRawTopSubsHostsSubscribersWidget({id:this.Id + "Fullnetflow" + "TopSubsHostsSubscribers"}),

            TopSubscribersMaxi: QoETableFullflowRawTopSubscribersWidget({id:this.Id + "Fullnetflow" + "TopSubscribersMaxi"}),



            TopTrafficHostsIps: QoETableFullflowRawTopTrafficHostsIpsWidget({id:this.Id + "Fullnetflow" + "TopTrafficHostsIps"}),

            TopFlowHostsIps: QoETableFullflowRawTopFlowHostsIpsWidget({id:this.Id + "Fullnetflow" + "TopFlowHostsIps"}),

            TopSesLifetimeHostsIps: QoETableFullflowRawTopSesLifetimeHostsIpsWidget({id:this.Id + "Fullnetflow" + "TopSesLifetimeHostsIps"}),

            TopSubsHostsHostsIps: QoETableFullflowRawTopSubsHostsHostsIpsWidget({id:this.Id + "Fullnetflow" + "TopSubsHostsHostsIps"}),

            TopHostsIpsMaxi: QoETableFullflowRawTopHostsIpsWidget({id:this.Id + "Fullnetflow" + "TopHostsIpsMaxi"})
        };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Raw full netflow")}),
                                {
                                    view: "toolbar",
                                    elements: [
                                        this.Views.Widgets.DateRangePicker.ViewConfig,
                                        {
                                            view:"multiselect",
                                            id:this.Id + "DpiPicker",
                                            value:"-2",
                                            maxWidth:320,
                                            optionWidth:320,
                                            options:[]
                                        },
                                        {
                                            view:"richselect",
                                            id:this.Id + "ExecTimeSelector",
                                            value:600,
                                            maxWidth:120,
                                            optionWidth:320,
                                            tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                            options:[
                                                {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                            ]
                                        },
                                        this.Views.Widgets.ExtendedFillter.ViewConfig,
                                        {},
                                        {
                                            view: "button",
                                            id:this.Id+"RefreshAllDataBtn",
                                            type: "icon",
                                            icon: "refresh",
                                            css: "toolbar_round_btn",
                                            width: 32,
                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                            click: function (id, e, node)
                                            {
                                                _this.RefreshAllData(true);
                                            }
                                        },
                                        this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                        {
                                            width: 16
                                        },
                                        QoEKillProcessesBtnWidget({
                                            id:this.Id+"KillProcessesBtn",
                                            callback:function (Id)
                                            {
                                                _this.KillProcesses(Id);
                                            }
                                        }),
                                        QoEClearCacheBtnWidget({
                                            id:this.Id+"ClearCacheBtn",
                                            callback:function (Id)
                                            {
                                                _this.ClearCache(Id);
                                            }
                                        })
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            rows:[
                                                {
                                                    view:"multiview",
                                                    id:this.Id + "ReportsCells",
                                                    cells:[
                                                        {
                                                            id: this.Id + "ReportsCells" + "ShortRawReport",
                                                            rows:[
                                                                this.Views.Widgets.ShortRawReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "SubscriberRawReport",
                                                            rows:[
                                                                this.Views.Widgets.SubscriberRawReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "RawReport",
                                                            rows:[
                                                                this.Views.Widgets.RawReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocols",
                                                            rows:[
                                                                this.Views.Widgets.TopTrafficProtocols.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowProtocols",
                                                            rows:[
                                                                this.Views.Widgets.TopFlowProtocols.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSesLifetimeProtocols",
                                                            rows:[
                                                                this.Views.Widgets.TopSesLifetimeProtocols.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubsHostsProtocols",
                                                            rows:[
                                                                this.Views.Widgets.TopSubsHostsProtocols.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopProtocolsMaxi",
                                                            rows:[
                                                                this.Views.Widgets.TopProtocolsMaxi.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficProtocolsGrps",
                                                            rows:[
                                                                this.Views.Widgets.TopTrafficProtocolsGrps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowProtocolsGrps",
                                                            rows:[
                                                                this.Views.Widgets.TopFlowProtocolsGrps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSesLifetimeProtocolsGrps",
                                                            rows:[
                                                                this.Views.Widgets.TopSesLifetimeProtocolsGrps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubsHostsProtocolsGrps",
                                                            rows:[
                                                                this.Views.Widgets.TopSubsHostsProtocolsGrps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopProtocolsGrpsMaxi",
                                                            rows:[
                                                                this.Views.Widgets.TopProtocolsGrpsMaxi.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "SshBruteForceReport",
                                                            rows:[
                                                                this.Views.Widgets.SshBruteForceReport.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficSubscribers",
                                                            rows:[
                                                                this.Views.Widgets.TopTrafficSubscribers.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowSubscribers",
                                                            rows:[
                                                                this.Views.Widgets.TopFlowSubscribers.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSesLifetimeSubscribers",
                                                            rows:[
                                                                this.Views.Widgets.TopSesLifetimeSubscribers.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubsHostsSubscribers",
                                                            rows:[
                                                                this.Views.Widgets.TopSubsHostsSubscribers.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersMaxi",
                                                            rows:[
                                                                this.Views.Widgets.TopSubscribersMaxi.ViewConfig
                                                            ]
                                                        },



                                                        {
                                                            id: this.Id + "ReportsCells" + "TopTrafficHostsIps",
                                                            rows:[
                                                                this.Views.Widgets.TopTrafficHostsIps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopFlowHostsIps",
                                                            rows:[
                                                                this.Views.Widgets.TopFlowHostsIps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSesLifetimeHostsIps",
                                                            rows:[
                                                                this.Views.Widgets.TopSesLifetimeHostsIps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubsHostsHostsIps",
                                                            rows:[
                                                                this.Views.Widgets.TopSubsHostsHostsIps.ViewConfig
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsIpsMaxi",
                                                            rows:[
                                                                this.Views.Widgets.TopHostsIpsMaxi.ViewConfig
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {view: "resizer"},
                                        {
                                            width: 400,
                                            rows: [
                                                BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                {
                                                    view: "treetable",
                                                    id:this.Id + "ReportsList",
                                                    header:false,
                                                    select: "row",
                                                    on: {
                                                        onAfterSelect:function ()
                                                        {
                                                            _this.OnReportsListSelect();
                                                        },
                                                        onAfterUnSelect:function ()
                                                        {
                                                            _this.OnReportsListUnSelect();
                                                        }
                                                    },
                                                    columns: [
                                                        {
                                                            id: "value",
                                                            fillspace: true,
                                                            template: function(obj, common, value, config)
                                                            {
                                                                return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                            }
                                                        }
                                                    ],
                                                    data: function ()
                                                    {
                                                        var arr =
                                                            [
                                                                {
                                                                    id: _this.Id + "ReportsCells" + "ShortRawReport" + "Group",
                                                                    value: LangHelper.GetString("QoE", "Raw log"),
                                                                    data:[
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "ShortRawReport",
                                                                            value: LangHelper.GetString("QoE", "Short raw log")
                                                                        },
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "SubscriberRawReport",
                                                                            value: LangHelper.GetString("QoE", "Subscriber raw log")
                                                                        },
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "RawReport",
                                                                            value: LangHelper.GetString("QoE", "Full raw log")
                                                                        }
                                                                    ]
                                                                }
                                                            ];

                                                        if(AppEnv.FullflowRawAttacksReports_isHidden !== 1)
                                                        {
                                                            arr.push(
                                                                {
                                                                    id: _this.Id + "ReportsCells" + "TopTrafficProtocols" + "Group" + "Group",
                                                                    value: LangHelper.GetString("QoE", "Attacks detection"),
                                                                    data:[
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "SshBruteForceReport",
                                                                            value: LangHelper.GetString("QoE", "Ssh bruteforce")
                                                                        },
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopTrafficProtocols" + "Group",
                                                                            value: LangHelper.GetString("QoE", "Top application protocols"),
                                                                            data:[
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopTrafficProtocols",
                                                                                    value: LangHelper.GetString("QoE", "By traffic")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopFlowProtocols",
                                                                                    value: LangHelper.GetString("QoE", "By flow")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopSesLifetimeProtocols",
                                                                                    value: LangHelper.GetString("QoE", "By session lifetime")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopSubsHostsProtocols",
                                                                                    value: LangHelper.GetString("QoE", "By subscribers and hosts")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopProtocolsMaxi",
                                                                                    value: "Maxi"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopTrafficProtocolsGrps" + "Group",
                                                                            value: LangHelper.GetString("QoE", "Top application protocols groups"),
                                                                            data:[
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopTrafficProtocolsGrps",
                                                                                    value: LangHelper.GetString("QoE", "By traffic")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopFlowProtocolsGrps",
                                                                                    value: LangHelper.GetString("QoE", "By flow")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopSesLifetimeProtocolsGrps",
                                                                                    value: LangHelper.GetString("QoE", "By session lifetime")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopSubsHostsProtocolsGrps",
                                                                                    value: LangHelper.GetString("QoE", "By subscribers and hosts")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopProtocolsGrpsMaxi",
                                                                                    value: "Maxi"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopTrafficSubscribers" + "Group",
                                                                            value: LangHelper.GetString("QoE", "Top subscribers"),
                                                                            data:[
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopTrafficSubscribers",
                                                                                    value: LangHelper.GetString("QoE", "By traffic")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopFlowSubscribers",
                                                                                    value: LangHelper.GetString("QoE", "By flow")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopSesLifetimeSubscribers",
                                                                                    value: LangHelper.GetString("QoE", "By session lifetime")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopSubsHostsSubscribers",
                                                                                    value: LangHelper.GetString("QoE", "By subscribers and hosts")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopSubscribersMaxi",
                                                                                    value: "Maxi"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            id: _this.Id + "ReportsCells" + "TopTrafficHostsIps" + "Group",
                                                                            value: LangHelper.GetString("QoE", "Top hosts IPs"),
                                                                            data:[
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopTrafficHostsIps",
                                                                                    value: LangHelper.GetString("QoE", "By traffic")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopFlowHostsIps",
                                                                                    value: LangHelper.GetString("QoE", "By flow")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopSesLifetimeHostsIps",
                                                                                    value: LangHelper.GetString("QoE", "By session lifetime")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopSubsHostsHostsIps",
                                                                                    value: LangHelper.GetString("QoE", "By subscribers and hosts")
                                                                                },
                                                                                {
                                                                                    id: _this.Id + "ReportsCells" + "TopHostsIpsMaxi",
                                                                                    value: "Maxi"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            );
                                                        }

                                                        return arr;
                                                    }()
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RawReport"] = [this.Views.Widgets.RawReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "ShortRawReport"] = [this.Views.Widgets.ShortRawReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "SubscriberRawReport"] = [this.Views.Widgets.SubscriberRawReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocols"] = [this.Views.Widgets.TopTrafficProtocols];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowProtocols"] = [this.Views.Widgets.TopFlowProtocols];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSesLifetimeProtocols"] = [this.Views.Widgets.TopSesLifetimeProtocols];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubsHostsProtocols"] = [this.Views.Widgets.TopSubsHostsProtocols];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopProtocolsMaxi"] = [this.Views.Widgets.TopProtocolsMaxi];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficProtocolsGrps"] = [this.Views.Widgets.TopTrafficProtocolsGrps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowProtocolsGrps"] = [this.Views.Widgets.TopFlowProtocolsGrps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSesLifetimeProtocolsGrps"] = [this.Views.Widgets.TopSesLifetimeProtocolsGrps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubsHostsProtocolsGrps"] = [this.Views.Widgets.TopSubsHostsProtocolsGrps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopProtocolsGrpsMaxi"] = [this.Views.Widgets.TopProtocolsGrpsMaxi];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "SshBruteForceReport"] = [this.Views.Widgets.SshBruteForceReport];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficSubscribers"] = [this.Views.Widgets.TopTrafficSubscribers];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowSubscribers"] = [this.Views.Widgets.TopFlowSubscribers];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSesLifetimeSubscribers"] = [this.Views.Widgets.TopSesLifetimeSubscribers];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubsHostsSubscribers"] = [this.Views.Widgets.TopSubsHostsSubscribers];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersMaxi"] = [this.Views.Widgets.TopSubscribersMaxi];

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopTrafficHostsIps"] = [this.Views.Widgets.TopTrafficHostsIps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopFlowHostsIps"] = [this.Views.Widgets.TopFlowHostsIps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSesLifetimeHostsIps"] = [this.Views.Widgets.TopSesLifetimeHostsIps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubsHostsHostsIps"] = [this.Views.Widgets.TopSubsHostsHostsIps];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsIpsMaxi"] = [this.Views.Widgets.TopHostsIpsMaxi];

};

QoERawFullNetFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoERawFullNetFlow");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();
};

QoERawFullNetFlowViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w)
        {
            if(w.Bind)
                _this.Views.Widgets[Key].Bind(_this);

            _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"] = Helper.SubscribeWidgetForProtocolsGroupsUpdatedIfNeeded(w);

            if(!_this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"])
                delete _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"];
        }
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoERawFullNetFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoERawFullNetFlowViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoERawFullNetFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoERawFullNetFlowViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullNetFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullNetFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoERawFullNetFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoERawFullNetFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoERawFullNetFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoERawFullNetFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoERawFullNetFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoERawFullNetFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoERawFullNetFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoERawFullNetFlowViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoERawFullNetFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoERawFullNetFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoERawFullNetFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};
function QoEFullGtpFlowViewController(Params)
{
    var _this = this;

    this.Id = "QoEFullGtpFlow";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,
        ReportsSection: null,
        DpiPicker:null,

        ExecTimeSelector:null,

        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({id:this.Id + "LicPageHeaderWidget", licLevel:"standard", licOption:"gtpflow", onOkButtonClick: function(){_this.OnLicenseNotValid()}})
    };
    this.Views.Widgets =
        {
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"}),

            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoEFullGtpFlow),
                enable_show_hotkey: 1
            }),

            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),

            AggReport: QoETableFullGtpFlowAggLogWidget({id:this.Id + "FullGtpFlow" + "AggReport"}),
            SubscribersRoutesReport: QoETableLayerGtpSubscribersRoutescWidget({id: this.Id + "ReportCells" + "SubscribersRoutesReport"}),
            SubscribersLocationsReport: QoETableLayerSubscribersLocationsWidget({id: this.Id + "ReportCells" + "SubscribersLocationsReport"})
        };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    cols:[
                                        PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: "" + LangHelper.GetString("AppView","Gtp flow")}),
                                        {
                                            gravity:3,
                                            rows:[
                                                this.Views.LicPageHeaderWidget.ViewConfig
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: this.Id + "ReportsSection",
                                    rows: [
                                        {
                                            view: "toolbar",
                                            elements: [
                                                this.Views.Widgets.DateRangePicker.ViewConfig,
                                                {
                                                    view:"multiselect",
                                                    id:this.Id + "DpiPicker",
                                                    value:"-2",
                                                    maxWidth:320,
                                                    optionWidth:320,
                                                    tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                                    options:[]
                                                },
                                                {
                                                    view:"richselect",
                                                    id:this.Id + "ExecTimeSelector",
                                                    value:600,
                                                    maxWidth:120,
                                                    optionWidth:320,
                                                    tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                    options:[
                                                        {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                        {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                        {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                        {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                        {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                        {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                        {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                        {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                        {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                        {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                    ]
                                                },
                                                this.Views.Widgets.ExtendedFillter.ViewConfig,
                                                {},
                                                {
                                                    view: "button",
                                                    id:this.Id+"RefreshAllDataBtn",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.RefreshAllData(true);
                                                    }
                                                },
                                                this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                                {
                                                    width: 16
                                                },
                                                QoEKillProcessesBtnWidget({
                                                    id:this.Id+"KillProcessesBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.KillProcesses(Id);
                                                    }
                                                }),
                                                QoEClearCacheBtnWidget({
                                                    id:this.Id+"ClearCacheBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.ClearCache(Id);
                                                    }
                                                })
                                            ]
                                        },
                                        {
                                            cols:[
                                                {
                                                    rows:[
                                                        {
                                                            view:"multiview",
                                                            id:this.Id + "ReportsCells",
                                                            // animate: false,
                                                            cells:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AggReport",
                                                                    rows:[
                                                                        this.Views.Widgets.AggReport.ViewConfig
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "MapReportSubscribersRoutes",
                                                                    rows:[
                                                                        this.Views.Widgets.SubscribersRoutesReport.ViewConfig
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "MapReportSubscribersLocations",
                                                                    rows:[
                                                                        this.Views.Widgets.SubscribersLocationsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {view: "resizer"},
                                                {
                                                    width: 400,
                                                    rows: [
                                                        BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                        {
                                                            view: "treetable",
                                                            id:this.Id + "ReportsList",
                                                            header:false,
                                                            select: "row",
                                                            on: {
                                                                onAfterSelect:function ()
                                                                {
                                                                    _this.OnReportsListSelect();
                                                                },
                                                                onAfterUnSelect:function ()
                                                                {
                                                                    _this.OnReportsListUnSelect();
                                                                }
                                                            },
                                                            columns: [
                                                                {
                                                                    id: "value",
                                                                    fillspace: true,
                                                                    template: function(obj, common, value, config)
                                                                    {
                                                                        return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                                    }
                                                                }
                                                            ],
                                                            data: [
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AggReport",
                                                                    value: LangHelper.GetString("QoE", "Aggregated log")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "MapReportsFolder",
                                                                    value: LangHelper.GetString("QoE", "Service and tracking"),
                                                                    data: [
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "MapReportSubscribersRoutes",
                                                                            value: LangHelper.GetString("QoE", "Subscribers routes"),
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "MapReportSubscribersLocations",
                                                                            value: LangHelper.GetString("QoE", "Subscribers location"),
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }

                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AggReport"] = [this.Views.Widgets.AggReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "MapReportSubscribersRoutes"] = [this.Views.Widgets.SubscribersRoutesReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "MapReportSubscribersLocations"] = [this.Views.Widgets.SubscribersLocationsReport];
};

QoEFullGtpFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEFullGtpFlow");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();
};

QoEFullGtpFlowViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");
    this.Views.ReportsSection = $$(this.Id + "ReportsSection");
    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w && w.Bind)
            _this.Views.Widgets[Key].Bind(_this);
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess

    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.Views.LicPageHeaderWidget.BindAll(Params);
    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoEFullGtpFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoEFullGtpFlowViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    this.Views.LicPageHeaderWidget.Destroy();

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEFullGtpFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoEFullGtpFlowViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullGtpFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullGtpFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoEFullGtpFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoEFullGtpFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoEFullGtpFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoEFullGtpFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoEFullGtpFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEFullGtpFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEFullGtpFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoEFullGtpFlowViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoEFullGtpFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEFullGtpFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoEFullGtpFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};

QoEFullGtpFlowViewController.prototype.OnLicenseNotValid = function()
{
    try
    {
        if(this && this.Views && this.Views.ReportsSection)
            this.Views.ReportsSection.disable();
    } catch (e){}
};
function QoERawFullGtpFlowViewController(Params)
{
    var _this = this;

    this.Id = "QoERawFullGtpFlow";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,
        ReportsSection: null,
        DpiPicker:null,
        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({id:this.Id + "LicPageHeaderWidget", licLevel:"standard", licOption:"gtpflow", onOkButtonClick: function(){_this.OnLicenseNotValid()}}),
        ExecTimeSelector:null
    };
    this.Views.Widgets =
        {
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"}),

            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoERawFullGtpFlow),
                enable_show_hotkey: 1
            }),

            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),

            RawReport: QoETableFullGtpFlowRawLogWidget({id:this.Id + "FullGtpFlow" + "RawReport"})
        };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    cols:[
                                        PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: "" + LangHelper.GetString("AppView","Raw Gtp flow")}),
                                        {
                                            gravity:3,
                                            rows:[
                                                this.Views.LicPageHeaderWidget.ViewConfig
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: this.Id + "ReportsSection",
                                    rows:[
                                        {
                                            view: "toolbar",
                                            elements: [
                                                this.Views.Widgets.DateRangePicker.ViewConfig,
                                                {
                                                    view:"multiselect",
                                                    id:this.Id + "DpiPicker",
                                                    value:"-2",
                                                    maxWidth:320,
                                                    optionWidth:320,
                                                    options:[]
                                                },
                                                {
                                                    view:"richselect",
                                                    id:this.Id + "ExecTimeSelector",
                                                    value:600,
                                                    maxWidth:120,
                                                    optionWidth:320,
                                                    tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                    options:[
                                                        {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                        {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                        {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                        {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                        {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                        {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                        {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                        {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                        {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                        {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                    ]
                                                },
                                                this.Views.Widgets.ExtendedFillter.ViewConfig,
                                                {},
                                                {
                                                    view: "button",
                                                    id:this.Id+"RefreshAllDataBtn",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.RefreshAllData(true);
                                                    }
                                                },
                                                this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                                {
                                                    width: 16
                                                },
                                                QoEKillProcessesBtnWidget({
                                                    id:this.Id+"KillProcessesBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.KillProcesses(Id);
                                                    }
                                                }),
                                                QoEClearCacheBtnWidget({
                                                    id:this.Id+"ClearCacheBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.ClearCache(Id);
                                                    }
                                                })
                                            ]
                                        },
                                        {
                                            cols:[
                                                {
                                                    rows:[
                                                        {
                                                            view:"multiview",
                                                            id:this.Id + "ReportsCells",
                                                            // animate: false,
                                                            cells:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RawReport",
                                                                    rows:[
                                                                        this.Views.Widgets.RawReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {view: "resizer"},
                                                {
                                                    width: 400,
                                                    rows: [
                                                        BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                        {
                                                            view: "treetable",
                                                            id:this.Id + "ReportsList",
                                                            header:false,
                                                            select: "row",
                                                            on: {
                                                                onAfterSelect:function ()
                                                                {
                                                                    _this.OnReportsListSelect();
                                                                },
                                                                onAfterUnSelect:function ()
                                                                {
                                                                    _this.OnReportsListUnSelect();
                                                                }
                                                            },
                                                            columns: [
                                                                {
                                                                    id: "value",
                                                                    fillspace: true,
                                                                    template: function(obj, common, value, config)
                                                                    {
                                                                        return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                                    }
                                                                }
                                                            ],
                                                            data: [
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RawReport",
                                                                    value: LangHelper.GetString("QoE", "Full raw log")
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RawReport"] = [this.Views.Widgets.RawReport];
};

QoERawFullGtpFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select(_this.Id);
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();
};

QoERawFullGtpFlowViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");
    this.Views.ReportsSection = $$(this.Id + "ReportsSection");

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w && w.Bind)
            _this.Views.Widgets[Key].Bind(_this);
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });


    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.Views.LicPageHeaderWidget.BindAll(Params);
    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoERawFullGtpFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoERawFullGtpFlowViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    this.Views.LicPageHeaderWidget.Destroy();

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoERawFullGtpFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoERawFullGtpFlowViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullGtpFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullGtpFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoERawFullGtpFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoERawFullGtpFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoERawFullGtpFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoERawFullGtpFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoERawFullGtpFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoERawFullGtpFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoERawFullGtpFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoERawFullGtpFlowViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoERawFullGtpFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoERawFullGtpFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoERawFullGtpFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};

QoERawFullGtpFlowViewController.prototype.OnLicenseNotValid = function()
{
    try
    {
        if(this && this.Views && this.Views.ReportsSection)
            this.Views.ReportsSection.disable();
    } catch (e){}
};
function QoERawFullNatFlowViewController(Params)
{
    var _this = this;

    this.Id = "QoERawFullNatFlow";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,

        DpiPicker:null,
        ExecTimeSelector:null,

        ReportsSection: null,
        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({id:this.Id + "LicPageHeaderWidget", licLevel:"standard", licOption:"natflow", onOkButtonClick: function(){_this.OnLicenseNotValid()}})
    };
    this.Views.Widgets =
        {
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker", default_value:"Last 15 minutes"}),

            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNatFlow),
                enable_show_hotkey: 1
            }),

            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),

            RawReport: QoETableNatflowRawLogWidget({id:this.Id + "FullNatflow" + "RawReport"})
        };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                  cols:[
                                      PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Raw NAT flow")}),
                                      {
                                          gravity:3,
                                          rows:[
                                              this.Views.LicPageHeaderWidget.ViewConfig
                                          ]
                                      }
                                  ]
                                },
                                {
                                    id: this.Id + "ReportsSection",
                                    rows:[
                                        {
                                            view: "toolbar",
                                            elements: [
                                                this.Views.Widgets.DateRangePicker.ViewConfig,
                                                {
                                                    view:"multiselect",
                                                    id:this.Id + "DpiPicker",
                                                    value:"-2",
                                                    maxWidth:320,
                                                    optionWidth:320,
                                                    options:[]
                                                },
                                                {
                                                    view:"richselect",
                                                    id:this.Id + "ExecTimeSelector",
                                                    value:600,
                                                    maxWidth:120,
                                                    optionWidth:320,
                                                    tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                    options:[
                                                        {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                        {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                        {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                        {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                        {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                        {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                        {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                        {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                        {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                        {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                    ]
                                                },
                                                this.Views.Widgets.ExtendedFillter.ViewConfig,
                                                {},
                                                {
                                                    view: "button",
                                                    id:this.Id+"RefreshAllDataBtn",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.RefreshAllData(true);
                                                    }
                                                },
                                                this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                                {
                                                    width: 16
                                                },
                                                QoEKillProcessesBtnWidget({
                                                    id:this.Id+"KillProcessesBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.KillProcesses(Id);
                                                    }
                                                }),
                                                QoEClearCacheBtnWidget({
                                                    id:this.Id+"ClearCacheBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.ClearCache(Id);
                                                    }
                                                })
                                            ]
                                        },
                                        {
                                            cols:[
                                                {
                                                    rows:[
                                                        {
                                                            view:"multiview",
                                                            id:this.Id + "ReportsCells",
                                                            cells:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RawReport",
                                                                    rows:[
                                                                        this.Views.Widgets.RawReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {view: "resizer"},
                                                {
                                                    width: 400,
                                                    rows: [
                                                        BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                        {
                                                            view: "treetable",
                                                            id:this.Id + "ReportsList",
                                                            header:false,
                                                            select: "row",
                                                            on: {
                                                                onAfterSelect:function ()
                                                                {
                                                                    _this.OnReportsListSelect();
                                                                },
                                                                onAfterUnSelect:function ()
                                                                {
                                                                    _this.OnReportsListUnSelect();
                                                                }
                                                            },
                                                            columns: [
                                                                {
                                                                    id: "value",
                                                                    fillspace: true,
                                                                    template: function(obj, common, value, config)
                                                                    {
                                                                        return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                                    }
                                                                }
                                                            ],
                                                            data: [
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RawReport",
                                                                    value: LangHelper.GetString("QoE", "Raw NAT flow")
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RawReport"] = [this.Views.Widgets.RawReport];

};

QoERawFullNatFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoERawFullNatFlow");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();


};

QoERawFullNatFlowViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");
    this.Views.ReportsSection = $$(this.Id + "ReportsSection");

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w && w.Bind)
            _this.Views.Widgets[Key].Bind(_this);
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.Views.LicPageHeaderWidget.BindAll(Params);
    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoERawFullNatFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoERawFullNatFlowViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoERawFullNatFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoERawFullNatFlowViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullNatFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullNatFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoERawFullNatFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoERawFullNatFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoERawFullNatFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoERawFullNatFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoERawFullNatFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoERawFullNatFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoERawFullNatFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoERawFullNatFlowViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoERawFullNatFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoERawFullNatFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoERawFullNatFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};

QoERawFullNatFlowViewController.prototype.OnLicenseNotValid = function()
{
    try
    {
        if(this && this.Views && this.Views.ReportsSection)
            this.Views.ReportsSection.disable();
    } catch (e){}

};
function QoEFullNatFlowViewController(Params)
{
    var _this = this;

    this.Id = "QoEFullNatFlow";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,

        DpiPicker:null,

        ExecTimeSelector:null,

        ReportsSection: null,

        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({id:this.Id + "LicPageHeaderWidget", licLevel:"standard", licOption:"natflow", onOkButtonClick: function(){_this.OnLicenseNotValid()}})
    };
    this.Views.Widgets =
        {
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker", default_value:"Last 15 minutes"}),

            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNatFlow),
                enable_show_hotkey: 1
            }),

            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),

            AggReport: QoETableNatflowAggLogWidget({id:this.Id + "FullNatflow" + "AggReport"}),

            TopSubscribersReport: QoETableNatflowAggTopSubscribersWidget({id:this.Id + "FullNatflow" + "TopSubscribersReport"}),

            TopHostsIpsReport: QoETableNatflowAggTopHostsIpsWidget({id:this.Id + "FullNatflow" + "TopHostsIpsReport"}),

            TopPostNatIpsReport: QoETableNatflowAggTopPostNatIpsWidget({id:this.Id + "FullNatflow" + "TopPostNatIpsReport"})
        };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    cols:[
                                        PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","NAT flow")}),
                                        {
                                            gravity:3,
                                            rows:[
                                                this.Views.LicPageHeaderWidget.ViewConfig
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: this.Id + "ReportsSection",
                                    rows:[
                                        {
                                            view: "toolbar",
                                            elements: [
                                                this.Views.Widgets.DateRangePicker.ViewConfig,
                                                {
                                                    view:"multiselect",
                                                    id:this.Id + "DpiPicker",
                                                    value:"-2",
                                                    maxWidth:320,
                                                    optionWidth:320,
                                                    tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                                    options:[]
                                                },
                                                {
                                                    view:"richselect",
                                                    id:this.Id + "ExecTimeSelector",
                                                    value:600,
                                                    maxWidth:120,
                                                    optionWidth:320,
                                                    tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                    options:[
                                                        {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                        {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                        {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                        {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                        {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                        {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                        {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                        {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                        {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                        {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                    ]
                                                },
                                                this.Views.Widgets.ExtendedFillter.ViewConfig,
                                                {},
                                                {
                                                    view: "button",
                                                    id:this.Id+"RefreshAllDataBtn",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.RefreshAllData(true);
                                                    }
                                                },
                                                this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                                {
                                                    width: 16
                                                },
                                                QoEKillProcessesBtnWidget({
                                                    id:this.Id+"KillProcessesBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.KillProcesses(Id);
                                                    }
                                                }),
                                                QoEClearCacheBtnWidget({
                                                    id:this.Id+"ClearCacheBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.ClearCache(Id);
                                                    }
                                                })
                                            ]
                                        },
                                        {
                                            cols:[
                                                {
                                                    rows:[
                                                        {
                                                            view:"multiview",
                                                            id:this.Id + "ReportsCells",
                                                            cells:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AggReport",
                                                                    rows:[
                                                                        this.Views.Widgets.AggReport.ViewConfig
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopSubscribersReport",
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersReport.ViewConfig
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopHostsIpsReport",
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsIpsReport.ViewConfig
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopPostNatIpsReport",
                                                                    rows:[
                                                                        this.Views.Widgets.TopPostNatIpsReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {view: "resizer"},
                                                {
                                                    width: 400,
                                                    rows: [
                                                        BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                        {
                                                            view: "treetable",
                                                            id:this.Id + "ReportsList",
                                                            header:false,
                                                            select: "row",
                                                            on: {
                                                                onAfterSelect:function ()
                                                                {
                                                                    _this.OnReportsListSelect();
                                                                },
                                                                onAfterUnSelect:function ()
                                                                {
                                                                    _this.OnReportsListUnSelect();
                                                                }
                                                            },
                                                            columns: [
                                                                {
                                                                    id: "value",
                                                                    fillspace: true,
                                                                    template: function(obj, common, value, config)
                                                                    {
                                                                        return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                                    }
                                                                }
                                                            ],
                                                            data: [
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AggReport",
                                                                    value: LangHelper.GetString("QoE", "NAT flow aggregated log")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopSubscribersReport" + "Group",
                                                                    value:LangHelper.GetString("QoE", "Top"),
                                                                    data:[
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopSubscribersReport",
                                                                            value:LangHelper.GetString("QoE", "Top subscribers")
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopHostsIpsReport",
                                                                            value:LangHelper.GetString("QoE", "Top hosts IPs")
                                                                        },
                                                                        {
                                                                            id: this.Id + "ReportsCells" + "TopPostNatIpsReport",
                                                                            value:LangHelper.GetString("QoE", "Top post NAT IPs")
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AggReport"] = [this.Views.Widgets.AggReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersReport"] = [this.Views.Widgets.TopSubscribersReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsIpsReport"] = [this.Views.Widgets.TopHostsIpsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopPostNatIpsReport"] = [this.Views.Widgets.TopPostNatIpsReport];

};

QoEFullNatFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEFullNatFlow");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();


};

QoEFullNatFlowViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");
    this.Views.ReportsSection = $$(this.Id + "ReportsSection");

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w && w.Bind)
            _this.Views.Widgets[Key].Bind(_this);
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.Views.LicPageHeaderWidget.BindAll(Params);
    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoEFullNatFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoEFullNatFlowViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEFullNatFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoEFullNatFlowViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullNatFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullNatFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoEFullNatFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoEFullNatFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoEFullNatFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoEFullNatFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoEFullNatFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEFullNatFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEFullNatFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoEFullNatFlowViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoEFullNatFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEFullNatFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoEFullNatFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};

QoEFullNatFlowViewController.prototype.OnLicenseNotValid = function()
{
    try
    {
        if(this && this.Views && this.Views.ReportsSection)
            this.Views.ReportsSection.disable();
    } catch (e){}
};
function QoERawFullDnsFlowViewController(Params)
{
    var _this = this;

    this.Id = "QoERawFullDnsFlow";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,

        DpiPicker:null,

        ExecTimeSelector:null,

        ReportsSection: null,

        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({id:this.Id + "LicPageHeaderWidget", licLevel:"standard", licOption:"dnsflow", onOkButtonClick: function(){_this.OnLicenseNotValid()}})
    };
    this.Views.Widgets =
        {
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker", default_value:"Last 15 minutes"}),

            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDnsFlow),
                enable_show_hotkey: 1
            }),

            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),

            RawReport: QoETableRawDnsFlowWidget({id:this.Id + "FullDnsFlow" + "RawReport"})
        };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    cols:[
                                        PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Raw DNS flow")}),
                                        {
                                            gravity:3,
                                            rows:[
                                                this.Views.LicPageHeaderWidget.ViewConfig
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: this.Id + "ReportsSection",
                                    rows:[
                                        {
                                            view: "toolbar",
                                            elements: [
                                                this.Views.Widgets.DateRangePicker.ViewConfig,
                                                {
                                                    view:"multiselect",
                                                    id:this.Id + "DpiPicker",
                                                    value:"-2",
                                                    maxWidth:320,
                                                    optionWidth:320,
                                                    options:[]
                                                },
                                                {
                                                    view:"richselect",
                                                    id:this.Id + "ExecTimeSelector",
                                                    value:600,
                                                    maxWidth:120,
                                                    optionWidth:320,
                                                    tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                    options:[
                                                        {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                        {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                        {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                        {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                        {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                        {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                        {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                        {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                        {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                        {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                    ]
                                                },
                                                this.Views.Widgets.ExtendedFillter.ViewConfig,
                                                {},
                                                {
                                                    view: "button",
                                                    id:this.Id+"RefreshAllDataBtn",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.RefreshAllData(true);
                                                    }
                                                },
                                                this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                                {
                                                    width: 16
                                                },
                                                QoEKillProcessesBtnWidget({
                                                    id:this.Id+"KillProcessesBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.KillProcesses(Id);
                                                    }
                                                }),
                                                QoEClearCacheBtnWidget({
                                                    id:this.Id+"ClearCacheBtn",
                                                    callback:function (Id)
                                                    {
                                                        _this.ClearCache(Id);
                                                    }
                                                })
                                            ]
                                        },
                                        {
                                            cols:[
                                                {
                                                    rows:[
                                                        {
                                                            view:"multiview",
                                                            id:this.Id + "ReportsCells",
                                                            cells:[
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RawReport",
                                                                    rows:[
                                                                        this.Views.Widgets.RawReport.ViewConfig
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {view: "resizer"},
                                                {
                                                    width: 400,
                                                    rows: [
                                                        BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                        {
                                                            view: "treetable",
                                                            id:this.Id + "ReportsList",
                                                            header:false,
                                                            select: "row",
                                                            on: {
                                                                onAfterSelect:function ()
                                                                {
                                                                    _this.OnReportsListSelect();
                                                                },
                                                                onAfterUnSelect:function ()
                                                                {
                                                                    _this.OnReportsListUnSelect();
                                                                }
                                                            },
                                                            columns: [
                                                                {
                                                                    id: "value",
                                                                    fillspace: true,
                                                                    template: function(obj, common, value, config)
                                                                    {
                                                                        return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                                    }
                                                                }
                                                            ],
                                                            data: [
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RawReport",
                                                                    value: LangHelper.GetString("AppView", "Raw DNS flow")
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RawReport"] = [this.Views.Widgets.RawReport];

};

QoERawFullDnsFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoERawFullDnsFlow");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();


};

QoERawFullDnsFlowViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");
    this.Views.ReportsSection = $$(this.Id + "ReportsSection");

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w && w.Bind)
            _this.Views.Widgets[Key].Bind(_this);
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.Views.LicPageHeaderWidget.BindAll(Params);
    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoERawFullDnsFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoERawFullDnsFlowViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoERawFullDnsFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoERawFullDnsFlowViewController.prototype.OnReportsListSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullDnsFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullDnsFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoERawFullDnsFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoERawFullDnsFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoERawFullDnsFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoERawFullDnsFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoERawFullDnsFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoERawFullDnsFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoERawFullDnsFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoERawFullDnsFlowViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoERawFullDnsFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoERawFullDnsFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoERawFullDnsFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};

QoERawFullDnsFlowViewController.prototype.OnLicenseNotValid = function()
{
    try
    {
        if(this && this.Views && this.Views.ReportsSection)
            this.Views.ReportsSection.disable();
    } catch (e){}

};
function QoEFullDnsFlowViewController(Params)
{
    var _this = this;

    this.Id = "QoEFullDnsFlow";

    this.ViewModel = new QoEReportsManager();

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"})

    this.Subscriptions = {};

    this.Subscriptions = {};

    this.Views = {
        ReportsList:null,
        ReportsCells:null,

        //PeriodPicker:null,
        DpiPicker:null,

        ExecTimeSelector:null,

        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({id:this.Id + "LicPageHeaderWidget", licLevel:"standard", licOption:"dnsflow", onOkButtonClick: function(){_this.OnLicenseNotValid()}})
    };

    this.Views.Widgets =
        {

            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"}),

            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig("QoEFullDnsFlow"),
                enable_show_hotkey: 1
            }),

            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),

            TopHostsReport: QoETableDnsFlowAggTopHostsWidget({id:this.Id + "TopHostsReport"}),

            TopHostsIpsDnsDataReport: QoETableDnsFlowAggTopHostsIpsDnsDataWidget({id:this.Id + "TopHostsIpsDnsDataReport"}),

            TopHostsIpsReport: QoETableDnsFlowAggTopHostsIpsWidget({id: this.Id + "TopHostsIpsReport"}),

            TopHostCategoriesReport: QoETableDnsFlowAggTopHostCategoriesWidget({id: this.Id + "TopHostCategoriesReport"}),

            TopSubscribersReport: QoETableDnsFlowAggTopSubscribersWidget({id: this.Id + "TopSubscribersReport"}),

            TopLoginsReport: QoETableDnsFlowAggTopLoginsWidget({id: this.Id + "TopLoginsReport"}),

            TopVchannelsReport: QoETableDnsFlowAggTopVchannelsWidget({id: this.Id + "TopVchannelsReport"})

        };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    cols:[
                                        PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","DNS flow")}),
                                        {
                                            gravity:3,
                                            rows:[
                                                this.Views.LicPageHeaderWidget.ViewConfig
                                            ]
                                        }
                                    ]
                                },
                                {
                                    view: "toolbar",
                                    elements: [
                                        // {
                                        //     view:"daterangepicker",
                                        //     id:this.Id + "PeriodPicker",
                                        //     name:"period",
                                        //     label:LangHelper.GetString("QoE", "Period"),
                                        //     value:{start: webix.Date.dayStart(new Date()), end: webix.Date.dayStart(new Date())},
                                        //     timepicker:true
                                        // },
                                        this.Views.Widgets.DateRangePicker.ViewConfig,
                                        {
                                            view:"multiselect",
                                            id:this.Id + "DpiPicker",
                                            value:"-2",
                                            maxWidth:320,
                                            optionWidth:320,
                                            tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                            options:[]
                                        },
                                        {
                                            view:"richselect",
                                            id:this.Id + "ExecTimeSelector",
                                            value:600,
                                            maxWidth:120,
                                            optionWidth:320,
                                            tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                            options:[
                                                {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                            ]
                                        },
                                        this.Views.Widgets.ExtendedFillter.ViewConfig,
                                        {},
                                        {
                                            view: "button",
                                            id:this.Id+"RefreshAllDataBtn",
                                            type: "icon",
                                            icon: "refresh",
                                            css: "toolbar_round_btn",
                                            width: 32,
                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                            click: function (id, e, node)
                                            {
                                                _this.RefreshAllData(true);
                                            }
                                        },
                                        this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                        {
                                            width: 16
                                        },
                                        QoEKillProcessesBtnWidget({
                                            id:this.Id+"KillProcessesBtn",
                                            callback:function (Id)
                                            {
                                                _this.KillProcesses(Id);
                                            }
                                        }),
                                        QoEClearCacheBtnWidget({
                                            id:this.Id+"ClearCacheBtn",
                                            callback:function (Id)
                                            {
                                                _this.ClearCache(Id);
                                            }
                                        })
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            rows:[
                                                {
                                                    view:"multiview",
                                                    id:this.Id + "ReportsCells",
                                                    cells:[
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsReport",
                                                            cols:[
                                                                {
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsIpsDnsDataReport",
                                                            cols:[
                                                                {
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsIpsDnsDataReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsIpsReport",
                                                            cols:[
                                                                {
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostsIpsReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesReport",
                                                            cols:[
                                                                {
                                                                    rows:[
                                                                        this.Views.Widgets.TopHostCategoriesReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersReport",
                                                            cols:[
                                                                {
                                                                    rows:[
                                                                        this.Views.Widgets.TopSubscribersReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopLoginsReport",
                                                            cols:[
                                                                {
                                                                    rows:[
                                                                        this.Views.Widgets.TopLoginsReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsReport",
                                                            cols:[
                                                                {
                                                                    rows:[
                                                                        this.Views.Widgets.TopVchannelsReport.ViewConfig
                                                                    ]
                                                                },
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {view: "resizer"},
                                        {
                                            width: 240,
                                            rows: [
                                                BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                {
                                                    view: "treetable",
                                                    id:this.Id + "ReportsList",
                                                    header:false,
                                                    select: "row",
                                                    on: {
                                                        onAfterSelect:function ()
                                                        {
                                                            _this.OnReportsListSelect();
                                                        },
                                                        onAfterUnSelect:function ()
                                                        {
                                                            _this.OnReportsListUnSelect();
                                                        }
                                                    },
                                                    columns: [
                                                        {
                                                            id: "value",
                                                            fillspace: true,
                                                            template: function(obj, common, value, config)
                                                            {
                                                                return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                            }
                                                        }
                                                    ],
                                                    data: [
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsReport",
                                                            value:LangHelper.GetString("QoE", "Top hosts")
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsIpsDnsDataReport",
                                                            value:LangHelper.GetString("QoE", "Top hosts IPs")
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostsIpsReport",
                                                            value:LangHelper.GetString("QoE", "Top DNS servers IPs")
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopHostCategoriesReport",
                                                            value:LangHelper.GetString("QoE", "Top host categories")
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopSubscribersReport",
                                                            value:LangHelper.GetString("QoE", "Top subscribers")
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopLoginsReport",
                                                            value:LangHelper.GetString("QoE", "Top logins")
                                                        },
                                                        {
                                                            id: this.Id + "ReportsCells" + "TopVchannelsReport",
                                                            value:LangHelper.GetString("QoE", "Top vchannels")
                                                        }

                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsReport"] = [this.Views.Widgets.TopHostsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsIpsDnsDataReport"] = [this.Views.Widgets.TopHostsIpsDnsDataReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostsIpsReport"] = [this.Views.Widgets.TopHostsIpsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopHostCategoriesReport"] = [this.Views.Widgets.TopHostCategoriesReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopSubscribersReport"] = [this.Views.Widgets.TopSubscribersReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopLoginsReport"] = [this.Views.Widgets.TopLoginsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopVchannelsReport"] = [this.Views.Widgets.TopVchannelsReport];
};

QoEFullDnsFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEFullDnsFlow");
    });

    this.BindAll(PathParams);

    App.DicsManager.Refresh({data:[DicsEnum.HostCategoriesDic]});

    this.CheckQoEStorVersionCompatibility();
};

QoEFullDnsFlowViewController.prototype.BindAll = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");

    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    //this.Views.PeriodPicker = $$(this.Id + "PeriodPicker");

    // var date_from = Helper.RoundDateToMinutes(new Date());
    // var date_to = Helper.RoundDateToMinutes(new Date());
    // this.Views.PeriodPicker.setValue({start:webix.Date.add(date_from,-6,"hour"), end:webix.Date.add(date_to,1,"hour")});

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {

        var hardwaresDicUpdated = value;

        if (hardwaresDicUpdated)
        {
            _this.DpiPickerOptionsUpdate();

            //_this.Views.ReportsList.select(_this.Views.ReportsList.getFirstId());
        }
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w && w.Bind)
            _this.Views.Widgets[Key].Bind(_this);
    });

    this.GetAllPathParam();

    // this.Views.PeriodPicker.attachEvent("onChange", function(Period)
    // {
    //     _this.RefreshAllData();
    // });

    this.Views.DpiPicker.attachEvent("onChange", function(Val)
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
            _this.RefreshAllData();
    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshAllData();
        }
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Value)
    {
        if(Value)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();
                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.Views.LicPageHeaderWidget.BindAll(PathParams);
    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoEFullDnsFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    //var period = this.Views.PeriodPicker.getValue();

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    filter = webix.extend(filter, extendedFilters, true);

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoEFullDnsFlowViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEFullDnsFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoEFullDnsFlowViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullDnsFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullDnsFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoEFullDnsFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoEFullDnsFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoEFullDnsFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoEFullDnsFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoEFullDnsFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEFullDnsFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEFullDnsFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoEFullDnsFlowViewController.prototype.GetAllPathParam = function()
{
    try {
        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoEFullDnsFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEFullDnsFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoEFullDnsFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};


QoEFullDnsFlowViewController.prototype.OnLicenseNotValid = function()
{
    try
    {
        if(this && this.Views && this.Views.ReportsSection)
            this.Views.ReportsSection.disable();
    } catch (e){}

};
function QoEFullDdosAttackFlowViewController(Params)
{
    let _this = this;

    this.Id = "QoEFullDdosAttackFlow";
    this.ViewModel = new QoEReportsManager();
    this.ReportsSettings = new QoEReportsSettingsWidget({id: this.Id + "ReportsSettingsWidget"})
    this.PathParams = null;
    this.Subscriptions = {}

    this.Views = {
        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({
            id: this.Id + "LicPageHeaderWidget",
            licLevel: "complete",
            licOption: "antiddos",
            onOkButtonClick: () => _this.OnLicenseNotValid()}
        ),

        ReportsSection: null,

        DpiPicker: null,
        ExecTimeSelector:null,

        ReportsList: null,
        ReportsCells: null,

        Widgets: {
            DateRangePicker: new QoEDateRangePickerWidget({id: this.Id + "DateRangePicker"}),
            ExtendedFillter: new QoEPopupFilterWidget({
                id: this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoEFullDdosAttackFlow),
                enable_show_hotkey: 1
            }),
            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),

            TopAttackReport: QoETableDdosAttackFlowAggTopAttackWidget({id:this.Id + "TopAttackReport"}),
            AttackIntensityReport: QoESeriesChartDdosAttackFlowAggAttackIntensityWidget({id:this.Id + "AttackIntensityReport"}),
            AttackIntensityByAsReport: QoETableDdosAttackFlowAggByAsTableChartWidget({id:this.Id + "AttackIntensityByAsReport"}),
            AttackIntensityByProtocolsReport: QoETableDdosAttackFlowAggByProtocolsTableChartWidget({id:this.Id + "AttackIntensityByProtocolsReport"}),
            AttackIntensityByAppProtocolsReport: QoETableDdosAttackFlowAggByAppProtocolsTableChartWidget({id:this.Id + "AttackIntensityByAppProtocolsReport"}),
            TotalAttackIntensity: QoESingleStatTotalsDdosAttackFlowAggAttackIntensityVertWidget({id:this.Id + "TotalAttackIntensity", compact:true}),
            TopAttackerCountriesTableReport: QoETableDdosAttackFlowAggTopAttackByAttackerCountriesWidget({id:this.Id + "TopAttackerCountriesTableReport"}),
            TopAttackerCountriesPieReport: QoEPieChartDdosAttackTopAttackerCountriesWidget({id:this.Id + "TopAttackerCountriesPieReport"}),
            TopAttackerLocations: QoETableLayerDdosAttackTopAttackerLocationsWidget({id:this.Id + "TopAttackerLocations"}),
            TopAttackerIpAddressesLocations: QoETableLayerDdosAttackTopAttackerIpAddressesLocationsWidget({id:this.Id + "TopAttackerIpAddressesLocations"})
        }
    };

    this.ViewConfig = [
        {
            cols: [
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    cols: [
                                        PageHeaderTemplate({
                                            root_title: LangHelper.GetString("AppView","QoE analytics"),
                                            title: LangHelper.GetString("AppView","DDoS attack flow")
                                        }),
                                        {
                                            gravity: 3,
                                            rows: [
                                                this.Views.LicPageHeaderWidget.ViewConfig
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: this.Id + "ReportsSection",
                                    rows: [
                                        {
                                            view: "toolbar",
                                            elements: [
                                                this.Views.Widgets.DateRangePicker.ViewConfig,
                                                {
                                                    view: "multiselect",
                                                    id: this.Id + "DpiPicker",
                                                    value: "-2",
                                                    maxWidth: 320,
                                                    optionWidth: 320,
                                                    tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                                    options: []
                                                },
                                                {
                                                    view: "richselect",
                                                    id: this.Id + "ExecTimeSelector",
                                                    value: 600,
                                                    maxWidth: 120,
                                                    optionWidth: 320,
                                                    tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                    options: [
                                                        {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                        {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                        {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                        {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                        {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                        {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                        {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                        {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                        {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                        {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                    ]
                                                },
                                                this.Views.Widgets.ExtendedFillter.ViewConfig,
                                                {},
                                                {
                                                    view: "button",
                                                    id: this.Id + "RefreshAllDataBtn",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.RefreshAllData(true);
                                                    }
                                                },
                                                this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                                {
                                                    width: 16
                                                },
                                                QoEKillProcessesBtnWidget({
                                                    id: this.Id+"KillProcessesBtn",
                                                    callback: function (Id)
                                                    {
                                                        _this.KillProcesses(Id);
                                                    }
                                                }),
                                                QoEClearCacheBtnWidget({
                                                    id: this.Id+"ClearCacheBtn",
                                                    callback: function (Id)
                                                    {
                                                        _this.ClearCache(Id);
                                                    }
                                                })
                                            ]
                                        },
                                        {
                                            cols: [
                                                {
                                                    rows: [
                                                        {
                                                            view: "multiview",
                                                            id :this.Id + "ReportsCells",
                                                            cells: [
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAttackReport",
                                                                    cols:[
                                                                        {
                                                                            rows:[
                                                                                this.Views.Widgets.TopAttackReport.ViewConfig
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AttackIntensity",
                                                                    cols:[
                                                                        {
                                                                            gravity:4,
                                                                            rows:[
                                                                                this.Views.Widgets.AttackIntensityReport.ViewConfig
                                                                            ]
                                                                        },
                                                                        {view:"resizer"},
                                                                        {
                                                                            maxWidth:240,
                                                                            minWidth:160,
                                                                            rows:[
                                                                                this.Views.Widgets.TotalAttackIntensity.ViewConfig
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AttackIntensityByAsReport",
                                                                    cols:[
                                                                        {
                                                                            rows:[
                                                                                this.Views.Widgets.AttackIntensityByAsReport.ViewConfig
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AttackIntensityByProtocolsReport",
                                                                    cols:[
                                                                        {
                                                                            rows:[
                                                                                this.Views.Widgets.AttackIntensityByProtocolsReport.ViewConfig
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AttackIntensityByAppProtocolsReport",
                                                                    cols:[
                                                                        {
                                                                            rows:[
                                                                                this.Views.Widgets.AttackIntensityByAppProtocolsReport.ViewConfig
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAttackerCountries",
                                                                    cols:[
                                                                        {
                                                                            gravity:2,
                                                                            rows:[
                                                                                this.Views.Widgets.TopAttackerCountriesTableReport.ViewConfig
                                                                            ]
                                                                        },
                                                                        {view:"resizer"},
                                                                        this.Views.Widgets.TopAttackerCountriesPieReport.ViewConfig
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAttackerLocations",
                                                                    cols:[
                                                                        {
                                                                            rows:[
                                                                                this.Views.Widgets.TopAttackerLocations.ViewConfig
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAttackerIpAddressesLocations",
                                                                    cols:[
                                                                        {
                                                                            rows:[
                                                                                this.Views.Widgets.TopAttackerIpAddressesLocations.ViewConfig
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {view: "resizer"},
                                                {
                                                    width: 400,
                                                    rows: [
                                                        BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                        {
                                                            view: "treetable",
                                                            id: this.Id + "ReportsList",
                                                            header: false,
                                                            select: "row",
                                                            on: {
                                                                onAfterSelect:function ()
                                                                {
                                                                    _this.OnReportsListSelect();
                                                                },
                                                                onAfterUnSelect:function ()
                                                                {
                                                                    _this.OnReportsListUnSelect();
                                                                }
                                                            },
                                                            columns: [
                                                                {
                                                                    id: "value",
                                                                    fillspace: true,
                                                                    template: function(obj, common, value, config)
                                                                    {
                                                                        return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                                    }
                                                                }
                                                            ],
                                                            data: [
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAttackReport",
                                                                    value: LangHelper.GetString("QoE", "Top attacks")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AttackIntensity",
                                                                    value: LangHelper.GetString("QoE", "Attack intensity")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AttackIntensityByAsReport",
                                                                    value: LangHelper.GetString("QoE", "Top attacks by AS")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AttackIntensityByProtocolsReport",
                                                                    value: LangHelper.GetString("QoE", "Top attacks by protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "AttackIntensityByAppProtocolsReport",
                                                                    value: LangHelper.GetString("QoE", "Top attacks by application protocols")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAttackerCountries",
                                                                    value: LangHelper.GetString("QoE", "Top attacker countries")
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAttackerLocations",
                                                                    value: LangHelper.GetString("QoE", "Top attacker locations") + " (" + LangHelper.GetString("QoE", "Geo") + ")"
                                                                },
                                                                {
                                                                    id: this.Id + "ReportsCells" + "TopAttackerIpAddressesLocations",
                                                                    value: LangHelper.GetString("QoE", "Top attacker Ip addresses") + " (" + LangHelper.GetString("QoE", "Geo") + ")"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};

    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAttackReport"] = [this.Views.Widgets.TopAttackReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AttackIntensityReport"] = [this.Views.Widgets.AttackIntensityReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AttackIntensityByAsReport"] = [this.Views.Widgets.AttackIntensityByAsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AttackIntensityByProtocolsReport"] = [this.Views.Widgets.AttackIntensityByProtocolsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AttackIntensityByAppProtocolsReport"] = [this.Views.Widgets.AttackIntensityByAppProtocolsReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "AttackIntensity"] = [this.Views.Widgets.AttackIntensityReport, this.Views.Widgets.TotalAttackIntensity];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAttackerCountries"] = [this.Views.Widgets.TopAttackerCountriesTableReport, this.Views.Widgets.TopAttackerCountriesPieReport];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAttackerLocations"] = [this.Views.Widgets.TopAttackerLocations];
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "TopAttackerIpAddressesLocations"] = [this.Views.Widgets.TopAttackerIpAddressesLocations];
}

QoEFullDdosAttackFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    let _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEFullDdosAttackFlow");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();
};

QoEFullDdosAttackFlowViewController.prototype.BindAll = function (PathParams)
{
    let _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");
    this.Views.ReportsSection = $$(this.Id + "ReportsSection");
    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (Signal)
    {
        if(Signal)
            _this.DpiPickerOptionsUpdate();
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w)
        {
            if(w.Bind)
                _this.Views.Widgets[Key].Bind(_this);

            _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"] = Helper.SubscribeWidgetForProtocolsGroupsUpdatedIfNeeded(w);

            if(!_this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"])
                delete _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"];
        }
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function()
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
            _this.RefreshAllData();
    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
            _this.RefreshAllData();
    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
            _this.RefreshAllData();
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess

    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.Views.LicPageHeaderWidget.BindAll(PathParams);
    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoEFullDdosAttackFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoEFullDdosAttackFlowViewController.prototype.Destroy = function ()
{
    let _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEFullDdosAttackFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoEFullDdosAttackFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullDdosAttackFlowViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEFullDdosAttackFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoEFullDdosAttackFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoEFullDdosAttackFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoEFullDdosAttackFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoEFullDdosAttackFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoEFullDdosAttackFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEFullDdosAttackFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEFullDdosAttackFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoEFullDdosAttackFlowViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoEFullDdosAttackFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEFullDdosAttackFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state: this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoEFullDdosAttackFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)
    };
};

QoEFullDdosAttackFlowViewController.prototype.OnLicenseNotValid = function()
{
    try
    {
        if(this && this.Views && this.Views.ReportsSection)
            this.Views.ReportsSection.disable();
    } catch (e){}
};
function QoERawFullDdosAttackFlowViewController(Params)
{
    let _this = this;

    this.Id = "QoERawFullDdosAttackFlow";
    this.ViewModel = new QoEReportsManager();
    this.ReportsSettings = new QoEReportsSettingsWidget({id: this.Id + "ReportsSettingsWidget"})
    this.PathParams = null;
    this.Subscriptions = {}

    this.Views = {
        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({
            id: this.Id + "LicPageHeaderWidget",
            licLevel: "complete",
            licOption: "antiddos",
            onOkButtonClick: () => _this.OnLicenseNotValid()}
        ),

        ReportsSection: null,

        DpiPicker: null,
        ExecTimeSelector:null,

        ReportsList: null,
        ReportsCells: null,

        Widgets: {
            DateRangePicker: new QoEDateRangePickerWidget({id: this.Id + "DateRangePicker"}),
            ExtendedFillter: new QoEPopupFilterWidget({
                id: this.Id + "ExtendedFillter",
                config: QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDdosAttackFlow),
                enable_show_hotkey: 1
            }),

            UserReportsFormWidget: function() {
                if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                    return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
            }(),


            RawReport: QoETableRawDdosAttackFlowWidget({id:this.Id + "FullDdosAttackFlow" + "RawReport"})
        }
    };

    this.ViewConfig = [
        {
            cols: [
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    cols: [
                                        PageHeaderTemplate({
                                            root_title: LangHelper.GetString("AppView","QoE analytics"),
                                            title: LangHelper.GetString("AppView","DDoS attacks log")
                                        }),
                                        {
                                            gravity: 3,
                                            rows: [
                                                this.Views.LicPageHeaderWidget.ViewConfig
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: this.Id + "ReportsSection",
                                    rows: [
                                        {
                                            view: "toolbar",
                                            elements: [
                                                this.Views.Widgets.DateRangePicker.ViewConfig,
                                                {
                                                    view: "multiselect",
                                                    id: this.Id + "DpiPicker",
                                                    value: "-2",
                                                    maxWidth: 320,
                                                    optionWidth: 320,
                                                    tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                                    options: []
                                                },
                                                {
                                                    view: "richselect",
                                                    id: this.Id + "ExecTimeSelector",
                                                    value: 600,
                                                    maxWidth: 120,
                                                    optionWidth: 320,
                                                    tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                    options: [
                                                        {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                        {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                        {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                        {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                        {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                        {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                        {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                        {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                        {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                        {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                    ]
                                                },
                                                this.Views.Widgets.ExtendedFillter.ViewConfig,
                                                {},
                                                {
                                                    view: "button",
                                                    id: this.Id + "RefreshAllDataBtn",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.RefreshAllData(true);
                                                    }
                                                },
                                                this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                                {
                                                    width: 16
                                                },
                                                QoEKillProcessesBtnWidget({
                                                    id: this.Id+"KillProcessesBtn",
                                                    callback: function (Id)
                                                    {
                                                        _this.KillProcesses(Id);
                                                    }
                                                }),
                                                QoEClearCacheBtnWidget({
                                                    id: this.Id+"ClearCacheBtn",
                                                    callback: function (Id)
                                                    {
                                                        _this.ClearCache(Id);
                                                    }
                                                })
                                            ]
                                        },
                                        {
                                            cols: [
                                                {
                                                    rows: [
                                                        {
                                                            view: "multiview",
                                                            id: this.Id + "ReportsCells",
                                                            cells: [
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RawReport",
                                                                    cols:[
                                                                        {
                                                                            rows:[
                                                                                this.Views.Widgets.RawReport.ViewConfig
                                                                            ]
                                                                        },
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {view: "resizer"},
                                                {
                                                    width: 400,
                                                    rows: [
                                                        BlockHeaderTemplate({title: LangHelper.GetString("QoE","Reports"), icon: "list"}),
                                                        {
                                                            view: "treetable",
                                                            id: this.Id + "ReportsList",
                                                            header: false,
                                                            select: "row",
                                                            on: {
                                                                onAfterSelect:function ()
                                                                {
                                                                    _this.OnReportsListSelect();
                                                                },
                                                                onAfterUnSelect:function ()
                                                                {
                                                                    _this.OnReportsListUnSelect();
                                                                }
                                                            },
                                                            columns: [
                                                                {
                                                                    id: "value",
                                                                    fillspace: true,
                                                                    template: function(obj, common, value, config)
                                                                    {
                                                                        return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                                    }
                                                                }
                                                            ],
                                                            data: [
                                                                {
                                                                    id: this.Id + "ReportsCells" + "RawReport",
                                                                    value: LangHelper.GetString("AppView", "DDoS attacks log")
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.ReportsCellsReportMap = {};
    this.ReportsCellsReportMap[this.Id + "ReportsCells" + "RawReport"] = [this.Views.Widgets.RawReport];
}

QoERawFullDdosAttackFlowViewController.prototype.ViewDidLoad = function (PathParams)
{
    let _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoERawFullDdosAttackFlow");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();
};

QoERawFullDdosAttackFlowViewController.prototype.BindAll = function (PathParams)
{
    let _this = this;

    this.Views.ReportsList = $$(this.Id + "ReportsList");
    this.Views.ReportsCells = $$(this.Id + "ReportsCells");
    this.Views.ReportsSection = $$(this.Id + "ReportsSection");
    this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (Signal)
    {
        if(Signal)
            _this.DpiPickerOptionsUpdate();
    });

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        var w = _this.Views.Widgets[Key];

        if(w)
        {
            if(w.Bind)
                _this.Views.Widgets[Key].Bind(_this);

            _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"] = Helper.SubscribeWidgetForProtocolsGroupsUpdatedIfNeeded(w);

            if(!_this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"])
                delete _this.Subscriptions[Key + "AppProtocolsGroupsDicUpdatedSubscription"];
        }
    });

    this.GetAllPathParam();

    this.Views.DpiPicker.attachEvent("onChange", function()
    {
        _this.RefreshAllData();
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
            _this.RefreshAllData();
    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
            _this.RefreshAllData();
    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
            _this.RefreshAllData();
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.Views.ReportsCells.enable();

            var selected = _this.GetReportsListSelectedItem();

            var id = Helper.ReplaceAll("Group", "", selected.id);

            if($$(id))
            {
                $$(id).show();

                _this.RefreshAllData();
            }
        }
        else
        {
            _this.Views.ReportsCells.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        this.Views.Widgets.ExtendedFillter.FilterReadySignal,
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic],
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess

    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2] && Val[3] && Val[4])
            {
                if(_this.Views.ReportsList.getSelectedItem())
                {
                    _this.RefreshAllData();
                }
                else
                {
                    var reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.ReportsList.getFirstId();
                    reportId = _this.Views.ReportsList.exists(_this.Id + "ReportsCells" + reportId) ? _this.Id + "ReportsCells" + reportId : _this.Views.ReportsList.getFirstId();
                    _this.Views.ReportsList.select(reportId);
                    _this.Views.ReportsList.open(_this.Views.ReportsList.getParentId(reportId), true);
                }
            }
        }
    );

    this.Views.LicPageHeaderWidget.BindAll(PathParams);
    this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
};

QoERawFullDdosAttackFlowViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var selected = _this.GetReportsListSelectedItem();

    if(!selected)
        return;

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    var dpiFilter = this.GetDpiPickerState();

    if(dpiFilter)
        filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    var id = Helper.ReplaceAll("Group", "", selected.id);

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id))
    {
        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report) {
                if(Report.RefreshData)
                    Report.RefreshData(0, params);
            });
        }
    }

    _this.SetAllPathParam();
};

QoERawFullDdosAttackFlowViewController.prototype.Destroy = function ()
{
    let _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (key)
    {
        var w = _this.Views.Widgets[key];

        if(w && w.Destroy)
            _this.Views.Widgets[key].Destroy();
    });

    if(this.ReportsSettings)
    {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoERawFullDdosAttackFlowViewController.prototype.GetReportsListSelectedItem = function ()
{
    return this.Views.ReportsList.getSelectedItem();
};

QoERawFullDdosAttackFlowViewController.prototype.OnReportsListUnSelect = function ()
{
    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullDdosAttackFlowViewController.prototype.OnReportsListSelect = function ()
{
    if(!this.Views.ReportsList)
        return;

    var data = this.GetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoERawFullDdosAttackFlowViewController.prototype.DpiPickerOptionsUpdate = function()
{
    var opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    var list = this.Views.DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoERawFullDdosAttackFlowViewController.prototype.GetDpiPickerState = function()
{
    var filter = null;

    var val = this.Views.DpiPicker.getValue();

    if(val)
    {
        var vals = val.split(",");

        var ipfix_ids = {};

        var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            var hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            var fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoERawFullDdosAttackFlowViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.caches_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.caches_ids = params.caches_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoERawFullDdosAttackFlowViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses)
    {
        var selected = this.GetReportsListSelectedItem();
        var id = Helper.ReplaceAll("Group", "", selected.id);

        params.processes_ids = [];

        if(id && this.ReportsCellsReportMap[id])
        {
            this.ReportsCellsReportMap[id].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        }
    }

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.ReportsCellsReportMap).forEach(function (Key) {
            _this.ReportsCellsReportMap[Key].forEach(function (Report)
            {
                if(Report.GetCachesIds())
                    params.processes_ids = params.processes_ids.concat(Report.GetCachesIds());
            });
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoERawFullDdosAttackFlowViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoERawFullDdosAttackFlowViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoERawFullDdosAttackFlowViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoERawFullDdosAttackFlowViewController.prototype.SetAllPathParam = function()
{
    var report = Helper.ReplaceAll(this.Id+"ReportsCells","",Helper.ReplaceAll("Group", "", this.GetReportsListSelectedItem().id));
    if(report)
    {
        this.SetPathParam("report", report);
    }

    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    var dpi = this.Views.DpiPicker.getValue();
    if(dpi)
    {
        this.SetPathParam("dpi", dpi);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoERawFullDdosAttackFlowViewController.prototype.GetAllPathParam = function()
{
    try {

        var dpi = this.GetPathParam("dpi");
        this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoERawFullDdosAttackFlowViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoERawFullDdosAttackFlowViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state: this.Views.Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views.Widgets.ExtendedFillter.GetFilters()
    };
};

QoERawFullDdosAttackFlowViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)
    };
};

QoERawFullDdosAttackFlowViewController.prototype.OnLicenseNotValid = function()
{
    try
    {
        if(this && this.Views && this.Views.ReportsSection)
            this.Views.ReportsSection.disable();
    } catch (e){}
};
var QoECustomAggLogsListsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoECustomAggLogsListsTableWidget",
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.enabled = Params&&Params.enabled?Params.enabled:0;

                this.code = Params&&Params.code?Params.code:"";

                this.name = Params&&Params.name?Params.name:"";

                this.type = Params&&Params.type?Params.type:"";

                this.valid = 1;
            },
            method:function ()
            {
                return "GetQoECustomAggLogsList";
            },
            sort:{id:"_id",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header: "",
                    width: 32,
                    template: CellCheckboxSwitchOnOffTemplate,
                    headermenu: false
                },
                {
                    id: "name",
                    header: [TooltipTemplate(LangHelper.GetString("QoE","Log name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace: 3,
                    sort: "string",
                    template:function(Obj, Common, Value)
                    {
                        return LangHelper.GetString("QoE", Value);
                    }
                },
                {
                    id: "type",
                    header: [TooltipTemplate(LangHelper.GetString("QoE","Type")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace: 1,
                    sort: "string",
                    template:function(Obj, Common, Value)
                    {
                        return LangHelper.GetString("QoE", Value);
                    }
                }
            ]);
            return cols;
        }(),

        defaultPageSize:100,
        on: {},
        hideExport:true
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var QoECustomReportsListsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"QoECustomReportsListsTableWidget",
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.code = Params&&Params.code?Params.code:"";

                this.name = Params&&Params.name?Params.name:"";

                this.type = Params&&Params.type?Params.type:"";
            },
            method:function ()
            {
                return "GetQoECustomReportsList";
            },
            sort:{id:"_id",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "name",
                    header: [TooltipTemplate(LangHelper.GetString("QoE","Report name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace: 3,
                    sort: "string",
                    template:function(Obj, Common, Value)
                    {
                        return LangHelper.GetString("QoE", Value);
                    }
                },
                {
                    id: "type",
                    header: [TooltipTemplate(LangHelper.GetString("QoE","Type")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    fillspace: 1,
                    sort: "string",
                    template:function(Obj, Common, Value)
                    {
                        return LangHelper.GetString("QoE", Value);
                    }
                }
            ]);
            return cols;
        }(),

        defaultPageSize:100,
        on: {},
        hideExport:true
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};


function QoECustomReportsViewController(Params)
{
    var _this = this;

    this.Id = "QoECustomReports";

    this.CurUserProfile = App.SessionManager.GetProfile();

    this.GroupCode = AppEnv.CustomReportsGroupCode ? AppEnv.CustomReportsGroupCode : "";
    this.ShowAggLogsSection = AppEnv.CustomReportsAggLogsSectionVisible ? AppEnv.CustomReportsAggLogsSectionVisible : 0;
    this.BypassUsersIds = AppEnv.CustomReportsAggLogsBypassUsersIds ? AppEnv.CustomReportsAggLogsBypassUsersIds : [];

    if(!this.ShowAggLogsSection) {
        const userId = this.CurUserProfile ? this.CurUserProfile.user_id : null;
        this.ShowAggLogsSection = this.BypassUsersIds.includes(userId) ? 1 : 0;
    }

    this.ReportsSettings = new QoEReportsSettingsWidget({id:this.Id + "ReportsSettingsWidget"});

    this.ViewModel = new QoEReportsManager();

    this.ReportsModel = new UniReportsManager();

    this.Signal = {
        WidgetReady: new Rx.BehaviorSubject(0),
        FiltersReady: new Rx.BehaviorSubject(0),
        RefreshNeeded: new Rx.BehaviorSubject(0),
        ReportReady: new Rx.BehaviorSubject(0)
    };

    this.Subscriptions = {};

    this.Views =
    {
        //DpiPicker:null,
        DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker"}),
        ExtendedFillter: new QoEPopupFilterWidget({
            id:this.Id + "ExtendedFillter",
            config: QoEPopupFilterWidgetDefaultConfig("QoEFullNetFlow"),
            enable_show_hotkey: 1
        }),
        ExecTimeSelector:null,
        Widgets:{},
        ReportsWidgets:{
            CustomAggLogsList: QoECustomAggLogsListsTableWidget({
                id:this.Id + "CustomAggLogsList",
                onCheck:function (Row, Column, State)
                {
                    _this.CustomAggLogsListOnItemCheck(Row, Column, State);
                }
            }),
            CustomReportsList: QoECustomReportsListsTableWidget({
                id:this.Id + "CustomReportsList",
                onItemClick:function (Id, E, Node)
                {
                    _this.CustomReportsListOnItemClick(Id, E, Node);
                }
            })
        },
        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({
            id:this.Id + "LicPageHeaderWidget",
            licLevel:"standard",
            licOption:"specreports"
        }),
        AccordionSections: {
            AggLogsListSection: null,
            ReportsListSection: null,
            ReportSection: null
        },
        ReportsContainer: null,
        WidgetsContainer: null,
        UserReportsFormWidget: function() {
            if(App.SessionManager.CheckUserRoleSectionAll(RoleSectionsEnum.qoeanalytics_reports_manager))
                return new QoEUserReportsFormWidget({id: _this.Id + "UserReportsForm"});
        }()
    };

    this.ReportIdentity =
    {
        Id:null,
        Code:null
    };

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                    cols:[
                                        PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Custom reports")}),
                                        {
                                            gravity:3,
                                            rows:[
                                                this.Views.LicPageHeaderWidget.ViewConfig
                                            ]
                                        }
                                    ]
                                },

                                {
                                    id:this.Id + "Accordion",
                                    view: "accordion",
                                    multi: "mixed",
                                    cols:[
                                        {
                                            header:BlockHeaderTemplate().template({title: LangHelper.GetString("QoE", "Agg logs"), icon: ""}),
                                            id: this.Id + "AggLogsListSection",
                                            disabled:true,
                                            hidden:true,
                                            collapsed:true,
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 48,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id:this.Id + "AddAggLogBtn",
                                                                type: "icon",
                                                                icon: "plus",
                                                                align: "right",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString("QoE","Add report"),
                                                                hidden: true
                                                            },
                                                            {},
                                                            {
                                                                view: "button",
                                                                id:this.Id+"RefreshAggLogsList",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("All","Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.Views.ReportsWidgets.CustomAggLogsList.RefreshData(0);
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    this.Views.ReportsWidgets.CustomAggLogsList.ViewConfig
                                                ]
                                            }
                                        },
                                        {
                                            header:BlockHeaderTemplate().template({title: LangHelper.GetString("QoE", "Reports"), icon: ""}),
                                            id: this.Id + "ReportsListSection",
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 48,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id:this.Id + "AddReportBtn",
                                                                type: "icon",
                                                                icon: "plus",
                                                                align: "right",
                                                                width: 32,
                                                                css:"toolbar_round_btn",
                                                                tooltip:LangHelper.GetString("QoE","Add report"),
                                                                hidden: true
                                                            },
                                                            {},
                                                            {
                                                                view: "button",
                                                                id:this.Id+"RefreshReportsList",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("All","Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.Views.ReportsWidgets.CustomReportsList.RefreshData(0);
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    this.Views.ReportsWidgets.CustomReportsList.ViewConfig
                                                ]
                                            }
                                        },
                                        {view:"resizer"},
                                        {
                                            header:BlockHeaderTemplate().template({title: LangHelper.GetString("QoE", "Report"), icon: ""}),
                                            id: this.Id + "ReportSection",
                                            gravity:3,
                                            body:{
                                                id: this.Id + "ReportsContainer",
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        elements: [
                                                            this.Views.DateRangePicker.ViewConfig,
                                                            // {
                                                            //     view:"multiselect",
                                                            //     id:this.Id + "DpiPicker",
                                                            //     value:"-2",
                                                            //     maxWidth:320,
                                                            //     optionWidth:320,
                                                            //     options:[]
                                                            // },
                                                            {
                                                                view:"richselect",
                                                                id:this.Id + "ExecTimeSelector",
                                                                value:600,
                                                                maxWidth:120,
                                                                optionWidth:320,
                                                                tooltip: LangHelper.GetString("QoE", "Maximum report execution time"),
                                                                options:[
                                                                    {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                                    {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                                    {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                                    {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                                    {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                                    {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                                    {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                                    {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                                    {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                                    {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                                ]
                                                            },
                                                            this.Views.ExtendedFillter.ViewConfig,
                                                            {},
                                                            {
                                                                view: "button",
                                                                id:this.Id+"RefreshAllDataBtn",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.RefreshAllData(true);
                                                                }
                                                            },
                                                            this.ReportsSettings.GeneralSettingsBtnViewConfig,
                                                            {
                                                                width: 16
                                                            },
                                                            QoEKillProcessesBtnWidget({
                                                                id:this.Id + "KillAllProcessesBtn",
                                                                restricted:{"KillAllSectionReportsProcesses":1},
                                                                callback:function (Id)
                                                                {
                                                                    _this.KillProcesses(Id);
                                                                }
                                                            }),
                                                            QoEClearCacheBtnWidget({
                                                                id:this.Id + "ClearCacheBtn",
                                                                restricted:{"ClearAllSectionReports":1},
                                                                callback:function (Id)
                                                                {
                                                                    _this.ClearCache(Id);
                                                                }
                                                            })
                                                        ]
                                                    },
                                                    {
                                                        id: this.Id + "WidgetsContainer",
                                                        borderless:true,
                                                        view:"multiview",
                                                        cells: [{}]
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }

                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.FilterState = {}
    this.FilterStateCode = {}
};

QoECustomReportsViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    //this.ConfigWidget("QoETableNetflowTopSubscriberASsShortWidget");

    //this.GetAllPathParam();

    this.RefreshConfig();

    //this.SetAllPathParam();
};

QoECustomReportsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.ReportsSettings.Bind();

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w && typeof w.BindAll == "function")
            w.BindAll(this, _this.ReportsModel);

        if(w && typeof w.Bind == "function")
            w.Bind(this, _this.ReportsModel);
    });

    Object.keys(this.Views.AccordionSections).forEach(Key => {
        this.Views.AccordionSections[Key] = $$(this.Id + Key);
    });

    this.Views.ReportsContainer = $$(this.Id + "ReportsContainer");
    this.Views.WidgetsContainer = $$(this.Id + "WidgetsContainer");

    webix.extend(this.Views.ReportsContainer, webix.OverlayBox);

    if(this.ShowAggLogsSection) {
        this.Views.AccordionSections.AggLogsListSection.enable();
        this.Views.AccordionSections.AggLogsListSection.show();
    }

    //this.Views.DpiPicker = $$(this.Id + "DpiPicker");
    this.Views.ExecTimeSelector = $$(this.Id + "ExecTimeSelector");

    this.Views.DateRangePicker.Bind(this);

    this.Views.ExtendedFillter.Bind(this);

    this.Views.UserReportsFormWidget.Bind(this);

    // this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (value) {
    //
    //     var hardwaresDicUpdated = value;
    //
    //     if (hardwaresDicUpdated)
    //     {
    //         _this.DpiPickerOptionsUpdate();
    //     }
    // });

    this.GetAllPathParam();

    // this.Views.DpiPicker.attachEvent("onChange", function(Val)
    // {
    //     _this.RefreshNeeded();
    // });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshNeeded();
        }

    });

    this.Subscriptions.DateRangePicker = this.Views.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.RefreshNeeded();
        }

    });

    this.Subscriptions.ReportsSettingsUpdate = this.ReportsSettings.Signals.ReportsSettingsUpdate.subscribe(function (Signal)
    {
        if(Signal)
            _this.RefreshAllData();
    });

    this.Subscriptions.FilterReadySignal = this.Views.ExtendedFillter.FilterReadySignal.subscribe(function (Signal)
    {
        _this.Signal.FiltersReady.next(Signal);
    });

    this.Subscriptions.RefreshSignal = Rx.Observable.combineLatest
    (
        this.Signal.WidgetReady,
        this.Signal.FiltersReady
    ).subscribe(function(Val)
        {
            var view = _this.Views.ReportsContainer;

            if(Val[0] && Val[1])
            {
                //_this.RefreshAllData();
                view.hideOverlay();
            }
            else
            {
                view.showOverlay("")
            }
        }
    );

    this.Subscriptions.RefreshSignal = Rx.Observable.combineLatest
    (
        this.Signal.WidgetReady,
        this.Signal.FiltersReady,
        this.Signal.RefreshNeeded,
        this.ReportsSettings.ViewModel.Signals.GetLastAppliedReportsSettingsSuccess
    ).subscribe(function(Val)
        {
            if(Val[0] && Val[1] && Val[2] && Val[3])
            {
                _this.RefreshAllData();
                _this.Signal.ReportReady.next(1);
            }
        }
    );

    this.Views.LicPageHeaderWidget.BindAll(Params);
};

QoECustomReportsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ReportsSettings) {
        this.ReportsSettings.Destroy();
        delete this.ReportsSettings;
    }

    this.Views.ExtendedFillter.Destroy();

    this.Views.DateRangePicker.Destroy();

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

QoECustomReportsViewController.prototype.RefreshConfig = function ()
{
    const params = {
        filter: {
            group_code: {
                id: "group_code",
                operator: "=",
                value: this.GroupCode
            }
        }
    };

    if(this.ShowAggLogsSection)
        this.Views.ReportsWidgets.CustomAggLogsList.RefreshData(null, params);

    this.Views.ReportsWidgets.CustomReportsList.RefreshData(null, params);
    this.RefreshReportConfig();
};

QoECustomReportsViewController.prototype.RefreshReportConfig = function ()
{
    var _this = this;

    this.Signal.WidgetReady.next(0);

    if(this.ReportIdentity.Id)
    {
        const callback = function (R, ReportId){
            if(R.success) {
                _this.ConfigWidget(R.data, ReportId);

                setTimeout(function () {
                    _this.RefreshNeeded();
                },1);
            }
        };

        this.ViewModel.GetCustomReport(
            this.ReportIdentity.Id,
            this.GroupCode,
            callback
        );
    }
}

QoECustomReportsViewController.prototype.ConfigWidget = function (Config, ReportId)
{
    var _this = this;

    if(!window[Config.widget])
        return;

    var reportConfig = Config.report_config
    reportConfig.id = _this.Id + Config.code;

    // for finding in suggest widget
    if(this.GroupCode && Config.code && Config.widget)
        reportConfig.id = CustomQoEAggLogsReportsKey + this.GroupCode + Config.code + Config.widget;

    this.Views.ExtendedFillter.SetConfig(Config.filters_config);

    if(!this.Views.Widgets[ReportId])
    {
        var widget = new window[Config.widget](reportConfig);

        this.Views.Widgets[ReportId] = widget;

        this.Views.WidgetsContainer.addView(webix.copy(widget.ViewConfig));

        widget.Bind(_this);

        this.ReportsSettings.ViewModel.GetLastAppliedReportsSettings();
    }

    $$(reportConfig.id).show();

    if(this.FilterStateCode[ReportId])
    {
        _this.Views.ExtendedFillter.SetFilterCode(this.FilterStateCode[ReportId], true);
    }

    if(this.FilterState[ReportId])
    {
        _this.Views.ExtendedFillter.SetState(this.FilterState[ReportId]);
    }
    else
    {
        this.Views.ExtendedFillter.UpdateFilterStateByCode();
    }

    if(Config.defaults && Config.defaults.datepicker_value)
    {
        var value = this.Views.DateRangePicker.GetValue();

        if(!value.id && !value.start && !value.end)
            this.Views.DateRangePicker.SetValue(null, true, Config.defaults.datepicker_value)
    }

    this.Signal.WidgetReady.next(1);

};

QoECustomReportsViewController.prototype.RefreshNeeded = function ()
{
    this.Signal.RefreshNeeded.next(1)
}

QoECustomReportsViewController.prototype.RefreshAllData = function (forceRefresh = false)
{
    var _this = this;

    var period = this.Views.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    if(!period.start || !period.end)
        return;

    var filter = {
        period:{
            id:"time",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.ExtendedFillter.GetFilters();

    // var dpiFilter = this.GetDpiPickerState();
    //
    // if(dpiFilter)
    //     filter = webix.extend(filter, dpiFilter, true);

    filter = webix.extend(filter, extendedFilters, true);

    var params = {filter:filter, max_execution_time: parseInt(this.Views.ExecTimeSelector.getValue())};

    // Object.keys(this.Views.Widgets).forEach(function (Key)
    // {
    //     if(_this.Views.Widgets[Key].RefreshData)
    //         _this.Views.Widgets[Key].RefreshData(0, params);
    // });

    if(forceRefresh || !_this.ReportsSettings.GetState(GeneralReportSettingsEnum.reports_manual_refresh.id)) {
        var report = this.Views.Widgets[this.ReportIdentity.Id];
        if(report && report.RefreshData)
            report.RefreshData(0, params);
    }

    this.FilterState[this.ReportIdentity.Id] = this.Views.ExtendedFillter.GetState();
    //this.FilterStateCode[this.ReportIdentity.Id] = this.Views.ExtendedFillter.GetFilterCode();

    _this.SetAllPathParam();
};

QoECustomReportsViewController.prototype.ClearCache = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache || ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports)
    {
        params.caches_ids = [];

        Object.keys(this.Views.Widgets).forEach(function (Key)
        {
            var report = _this.Views.Widgets[Key];

            if(report.GetCachesIds && report.GetCachesIds())
                params.caches_ids = params.caches_ids.concat(report.GetCachesIds());
        });
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "Cache cleared"))
    },params);
};

QoECustomReportsViewController.prototype.KillProcesses = function(ActionId)
{
    var _this = this;

    var params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillCurrentReportProcesses || ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllSectionReportsProcesses)
    {
        params.processes_ids = [];

        Object.keys(this.Views.Widgets).forEach(function (Key)
        {
            var report = _this.Views.Widgets[Key];

            if(report.GetCachesIds && report.GetCachesIds())
                params.processes_ids = params.processes_ids.concat(_this.Views.Widgets[Key].GetCachesIds());
        });
    }

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

// QoECustomReportsViewController.prototype.DpiPickerOptionsUpdate = function()
// {
//     var opt =
//         [
//             {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
//             {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
//         ];
//
//     var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);
//
//     hws = hws.filter(function (Obj)
//     {
//         return Obj.hardware_type == HardwareTypesEnum.dpi;
//     });
//
//     hws.forEach(function (Hw)
//     {
//         opt.push({id:Hw.dic_id, value:Hw.value});
//     });
//
//     var list = this.Views.DpiPicker.getList();
//     list.clearAll();
//     list.parse(opt);
// };

// QoECustomReportsViewController.prototype.GetDpiPickerState = function()
// {
//     var filter = null;
//
//     var val = this.Views.DpiPicker.getValue();
//
//     if(val)
//     {
//         var vals = val.split(",");
//
//         var ipfix_ids = {};
//
//         var dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);
//
//         vals.every(function (Val)
//         {
//             if(Val == "-2")
//             {
//                 return false;
//             }
//
//             var hwId = Val;
//
//             if(Val == "-1")
//             {
//                 hwId = App.SessionManager.GetCurrentHardwareId();
//             }
//
//             if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
//             {
//                 ipfix_ids[dic[hwId].ipfix_id] = 1;
//             }
//
//             return true;
//         });
//
//         if(Object.keys(ipfix_ids).length)
//         {
//             var fValue = [];
//
//             Object.keys(ipfix_ids).forEach(function (Val)
//             {
//                 fValue.push(parseInt(Val,10));
//             });
//
//             filter = {
//                 dpi_id:{
//                     id:"dpi_id",
//                     operator:"in",
//                     value: fValue
//                 }
//             };
//         }
//     }
//
//     return filter;
// };

QoECustomReportsViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoECustomReportsViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoECustomReportsViewController.prototype.SetAllPathParam = function()
{
    var report_id = this.ReportIdentity.Id;
    if(report_id)
    {
        this.SetPathParam("report_id", report_id);
    }

    var period = this.Views.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    // var dpi = this.Views.DpiPicker.getValue();
    // if(dpi)
    // {
    //     this.SetPathParam("dpi", dpi);
    // }

    var filter = this.Views.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);

        if(report_id)
            this.FilterStateCode[report_id] = filter
    }


    var max_exec_time = this.Views.ExecTimeSelector.getValue();
    if(max_exec_time)
    {
        this.SetPathParam("max_exec_time", max_exec_time);
    }

    this.JustNavigate();
};

QoECustomReportsViewController.prototype.GetAllPathParam = function()
{
    try
    {
        // var dpi = this.GetPathParam("dpi");
        // this.Views.DpiPicker.setValue(dpi?dpi:"-2");

        var period = this.GetPathParam("period");
        this.Views.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.ExtendedFillter.SetFilterCode(filter);

        this.ReportIdentity.Id = this.GetPathParam("report_id");
        this.FilterStateCode[this.ReportIdentity.Id] = filter

        var max_exec_time = this.GetPathParam("max_exec_time");
        this.Views.ExecTimeSelector.setValue(max_exec_time?max_exec_time:600);
    }
    catch(e){}
};

QoECustomReportsViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoECustomReportsViewController.prototype.GetFilterStateConfig = function()
{
    return {
        filter_state:this.Views.ExtendedFillter.GetState(),
        filter_config: this.Views.ExtendedFillter.GetFilters()
    };
};

QoECustomReportsViewController.prototype.GetPeriodState = function()
{
    var period = this.Views.DateRangePicker.GetValue();

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)

    };
};

QoECustomReportsViewController.prototype.CustomAggLogsListOnItemCheck = function(Id, E, Node)
{
    var table = this.Views.ReportsWidgets.CustomAggLogsList.Views.Table;

    var data = table.getItem(Id);

    var enabled = data.enabled ? 1 : 0;

    this.ViewModel.EnableCustomAggLog(data._id, enabled, function (R)
        {
            if(!R.success)
            {
                data.enabled = enabled ? 0 : 1;

                table.updateItem(data.id, data);

                webix.message({type:"error", text:R.error.msg});
            }
            else
            {
                webix.message(LangHelper.GetString("QoE", enabled ? "Agg log enabled" : "Agg log disabled"));
            }
        }
    );
};

QoECustomReportsViewController.prototype.CustomReportsListOnItemClick = function(Id, E, Node)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.CustomReportsList.Views.Table;

    var data = table.getItem(Id);

    if(this.ReportIdentity.Id == data._id)
        return ;

    this.ReportIdentity = {
        Id:data._id,
        Name:data.name
    };

    if(!this.FilterStateCode[this.ReportIdentity.Id])
        this.FilterStateCode[this.ReportIdentity.Id] = webix.uid().toString();

    this.Signal.RefreshNeeded.next(0);

    this.RefreshReportConfig();
};

QoECustomReportsViewController.prototype.GetSelectedWidget = function()
{
    let widget;

    if(this.ReportIdentity && this.ReportIdentity.Id)
        widget = this.Views.Widgets[this.ReportIdentity.Id];

    return widget;
};
function QoEOnlineReportsViewController(Params)
{
    const _this = this;

    this.Id = "QoEOnlineReports";

    this.DefaultReportRefreshRateId = "agg_period";

    this.ViewModel = new QoEReportsManager();

    this.QoEStorConfigManager = new QoEStorConfigManager();

    this.PathParams = {};

    this.Subscriptions = {};

    this.Views = {};

    this.Views.Widgets = {};

    this.QoEOnlineNetflowDetailsPanelStateEnum = {
        show:"show",
        hide:"hide"
    };

    this.QoEOnlineNetflowReportsFunctionsEnum = [
        {
            id:"RttDistribution",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "RttDistribution": {
                    id:"RttDistribution",
                    params:{},
                    func:QoERttDistributionWidget
                }
            }
        },
        {
            id:"RttByTime",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "RttByTime": {
                    id:"RttByTime",
                    params:{},
                    func:QoERttByTimeWidget
                }
            }

        },
        {
            id:"RetransmitsByTime",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "RetransmitsByTime":{
                    id:"RetransmitsByTime",
                    params:{},
                    func:QoESeriesChartRetransmitsByTimeWidget
                }
            }
        },
        {
            id: "StatChartTraffic",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets: {
                "Traffic": {
                    id:"Traffic",
                    params:{},
                    func:QoESeriesChartTrafficWidget
                },
                "TotalTraffic": {
                    id:"TotalTraffic",
                    params:{compact:true},
                    func:QoESingleStatTotalsVertWidget
                }
            },
            template: function(Params) {
                return {
                    id: Params && Params.id ? Params.id : webix.uid(),
                    rows: [
                        {
                            cols: [
                                {
                                    gravity:4,
                                    rows:[
                                        Params.Widgets.Traffic.ViewConfig
                                    ]
                                },
                                {view:"resizer"},
                                {
                                    maxWidth:240,
                                    minWidth:160,
                                    rows:[
                                        Params.Widgets.TotalTraffic.ViewConfig
                                    ]
                                }
                            ]
                        },
                        {
                            gravity:0
                        }
                    ]
                }
            }
        },
        {
            id:"TrafficByProtocols",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TrafficByProtocols":{
                    id:"TrafficByProtocols",
                    params:{},
                    func:QoETableNetflowTopTrafficNetProtocolsTableChartWidget
                }
            }
        },
        {
            id:"TrafficByAppProtocols",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TrafficByAppProtocols":{
                    id:"TrafficByAppProtocols",
                    params:{},
                    func:QoETableNetflowTopTrafficProtocolsTableChartWidget
                }
            }
        },
        {
            id:"TrafficByAppProtocolsGrps",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TrafficByAppProtocolsGrps":{
                    id:"TrafficByAppProtocolsGrps",
                    params:{},
                    func:QoETableNetflowTopTrafficProtocolsGroupsTableChartWidget
                }
            }
        },
        {
            id:"TrafficByAs",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TrafficByAs":{
                    id:"TrafficByAs",
                    params:{},
                    func:QoETableNetflowTopTrafficASTableChartWidget
                }
            }
        },
        {
            id:"TrafficBySubscribersAS",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TrafficBySubscribersAS": {
                    id:"TrafficBySubscribersAS",
                    params:{type: "source"},
                    func:QoETableNetflowTopTrafficASTableChartWidget
                }
            }
        },
        {
            id:"TrafficByVchannels",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TrafficByVchannels": {
                    id:"TrafficByVchannels",
                    params:{},
                    func:QoETableNetflowTopTrafficVchannelsTableChartWidget
                }
            }
        },
        {
            id:"TrafficByClasses",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TrafficByClasses":{
                    id:"TrafficByClasses",
                    params:{},
                    func:QoETableNetflowTopTrafficClassesTableChartWidget
                }
            }
        },
        {
            id:"TrafficByFullDscpClasses",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TrafficByFullDscpClasses":{
                    id:"TrafficBFullDscpClasses",
                    params:{},
                    func:QoETableNetflowTopFullDscpTrafficClassesTableChartWidget
                }
            }
        },
        {
            id:"Flow",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "Flow": {
                    id:"Flow",
                    params:{},
                    func:QoESeriesChartFlowWidget
                }
            }
        },
        {
            id:"FlowByProtocols",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "FlowByProtocols": {
                    id:"FlowByProtocols",
                    params:{},
                    func:QoESeriesChartFlowByNetProtocolsTableChartWidget
                }
            }
        },
        {
            id:"FlowByAppProtocols",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "FlowByAppProtocols": {
                    id:"FlowByAppProtocols",
                    params:{},
                    func:QoESeriesChartFlowByProtocolsTableChartWidget
                }
            }
        },
        {
            id:"FlowByAppProtocolsGrps",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "FlowByAppProtocolsGrps": {
                    id:"FlowByAppProtocolsGrps",
                    params:{net_protocol:false},
                    func:QoESeriesChartFlowByProtocolsGroupsTableChartWidget
                }
            }
        },
        {
            id:"FlowByVchannels",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "FlowByVchannels": {
                    id:"FlowByVchannels",
                    params:{},
                    func:QoESeriesChartFlowByVchannelsTableChartWidget
                }
            }
        },
        {
            id:"FlowByClasses",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "FlowByClasses": {
                    id:"FlowByClasses",
                    params:{},
                    func:QoESeriesChartFlowByClassesTableChartWidget
                }
            }
        },
        {
            id:"FlowByFullDscpClasses",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "FlowByFullDscpClasses":{
                    id:"FlowByFullDscpClasses",
                    params:{},
                    func:QoESeriesChartFlowByFullDscpClassesTableChartWidget
                }
            }
        },
        {
            id:"TopSubscribersRttShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopSubscribersRttShortReport": {
                    id:"TopSubscribersRttShortReport",
                    params:{},
                    func:QoETableTopRttSubscribersShortWidget
                }
            }
        },
        {
            id:"TopSubscriberLoginsRttShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopSubscriberLoginsRttShortReport": {
                    id:"TopSubscriberLoginsRttShortReport",
                    params:{},
                    func:QoETableTopRttSubscriberLoginsShortWidget
                }
            }
        },
        {
            id:"TopProtocolsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopProtocolsShortReport": {
                    id:"TopProtocolsShortReport",
                    params:{},
                    func:QoETableNetflowTopProtocolsShortWidget
                }
            }
        },
        {
            id:"TopProtocolsGrpsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopProtocolsGrpsShortReport": {
                    id:"TopProtocolsGrpsShortReport",
                    params:{},
                    func:QoETableNetflowTopProtocolsGroupsShortWidget
                }
            }
        },
        {
            id:"TopHostsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopHostsShortReport": {
                    id:"TopHostsShortReport",
                    params:{},
                    func:QoETableNetflowTopHostsShortWidget
                }
            }
        },
        {
            id:"TopHostsIPsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopHostsIPsShortReport": {
                    id:"TopHostsIPsShortReport",
                    params:{},
                    func: QoETableNetflowTopHostsIPsShortWidget
                }
            }
        },
        {
            id:"TopHostsCategoriesShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopHostsCategoriesShortReport": {
                    id:"TopHostsCategoriesShortReport",
                    params:{},
                    func:QoETableNetflowTopHostCategoriesShortWidget
                }
            }
        },
        {
            id:"TopASsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopASsShortReport": {
                    id:"TopASsShortReport",
                    params:{type:"destination"},
                    func:QoETableNetflowTopASsShortWidget
                }
            }
        },
        {
            id:"TopSwitchesShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "TopSwitchesShortReport": {
                    id:"TopSwitchesShortReport",
                    params:{},
                    func:QoETableNetflowTopSwitchesShortWidget
                }
            }
        },
        {
            id:"TopVchannelsRttShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopVchannelsRttShortReport": {
                    id:"TopVchannelsRttShortReport",
                    params:{},
                    func:QoETableTopRttVchannelsShortWidget
                }
            }
        },
        {
            id:"TopClassesRttShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopClassesRttShortReport":{
                    id:"TopClassesRttShortReport",
                    params:{},
                    func:QoETableTopRttClassesShortWidget
                }
            }
        },
        {
            id:"TopGTPCellsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "TopGTPCellsShortReport":{
                    id:"TopGTPCellsShortReport",
                    params:{},
                    func:QoETableNetflowTopGTPCellsShortWidget
                }
            }
        },
        {
            id:"TopSubscribersTrafficShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopSubscribersTrafficShortReport": {
                    id:"TopSubscribersTrafficShortReport",
                    params:{},
                    func:QoETableTopTrafficSubscribersShortWidget
                }
            }
        },
        {
            id:"TopSubscriberLoginsTrafficShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopSubscriberLoginsTrafficShortReport": {
                    id:"TopSubscriberLoginsTrafficShortReport",
                    params:{},
                    func:QoETableTopTrafficSubscriberLoginsShortWidget
                }
            }
        },
        {
            id:"TopTrafficProtocolsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopTrafficProtocolsShortReport": {
                    id:"TopTrafficProtocolsShortReport",
                    params:{},
                    func:QoETableNetflowTopTrafficProtocolsShortWidget
                }
            },
        },
        {
            id:"TopTrafficProtocolsGrpsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopTrafficProtocolsGrpsShortReport": {
                    id:"TopTrafficProtocolsGrpsShortReport",
                    params:{},
                    func:QoETableNetflowTopTrafficProtocolsGroupsShortWidget
                }
            },
        },
        {
            id:"TopTrafficHostsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopTrafficHostsShortReport": {
                    id:"TopTrafficHostsShortReport",
                    params:{},
                    func:QoETableNetflowTopTrafficHostsShortWidget
                }
            }
        },
        {
            id:"TopTrafficHostsIPsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopTrafficHostsIPsShortReport": {
                    id:"TopTrafficHostsIPsShortReport",
                    params:{},
                    func:QoETableNetflowTopTrafficHostsIPsShortWidget
                }
            },
        },
        {
            id:"TopTrafficHostCategoriesShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopTrafficHostCategoriesShortReport": {
                    id:"TopTrafficHostCategoriesShortReport",
                    params:{},
                    func:QoETableNetflowTopTrafficHostCategoriesShortWidget
                }
            },
        },
        {
            id:"TopTrafficASsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopTrafficASsShortReport": {
                    id:"TopTrafficASsShortReport",
                    params:{type:"destination"},
                    func:QoETableNetflowTopTrafficASsShortWidget
                }
            }
        },
        {
            id:"TopTrafficSwitchesShortReport",
            detailsPanelState: this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "TopTrafficSwitchesShortReport": {
                    id:"TopTrafficSwitchesShortReport",
                    params:{},
                    func:QoETableNetflowTopTrafficSwitchesShortWidget
                }
            }
        },
        {
            id:"TopVchannelsTrafficShortReport",
            detailsPanelState: this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopVchannelsTrafficShortReport": {
                    id:"TopVchannelsTrafficShortReport",
                    params:{},
                    func:QoETableTopTrafficVchannelsShortWidget
                }
            }
        },
        {
            id:"TopClassesTrafficShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopClassesTrafficShortReport": {
                    id:"TopClassesTrafficShortReport",
                    params:{},
                    func:QoETableTopTrafficClassesShortWidget
                }
            }
        },
        {
            id:"TopFullDscpClassesTrafficShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopFullDscpClassesTrafficShortReport": {
                    id:"TopFullDscpClassesTrafficShortReport",
                    params:{},
                    func:QoETableTopTrafficFullDscpClassesShortWidget
                }
            }
        },
        {
            id:"TopTrafficGTPCellsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "TopTrafficGTPCellsShortReport":{
                    id:"TopTrafficGTPCellsShortReport",
                    params:{},
                    func:QoETableNetflowTopTrafficGTPCellsShortWidget
                }
            }
        },
        {
            id:"TopSubscribersTopFlowShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopSubscribersTopFlowShortReport": {
                    id:"TopSubscribersTopFlowShortReport",
                    params:{},
                    func:QoETableTopFlowSubscribersShortWidget
                }
            }
        },
        {
            id:"TopSubscriberLoginsTopFlowShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopSubscriberLoginsTopFlowShortReport": {
                    id:"TopSubscriberLoginsTopFlowShortReport",
                    params:{},
                    func:QoETableTopFlowSubscriberLoginsShortWidget
                }
            }
        },
        {
            id:"TopFlowProtocolsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopFlowProtocolsShortReport": {
                    id:"TopFlowProtocolsShortReport",
                    params:{},
                    func:QoETableNetflowTopFlowProtocolsShortWidget
                }
            },
        },
        {
            id:"TopFlowProtocolsGrpsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopFlowProtocolsGrpsShortReport": {
                    id:"TopFlowProtocolsGrpsShortReport",
                    params:{},
                    func:QoETableNetflowTopFlowProtocolsGroupsShortWidget
                }
            },
        },
        {
            id:"TopFlowHostsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopFlowHostsShortReport": {
                    id:"TopFlowHostsShortReport",
                    params:{},
                    func:QoETableNetflowTopFlowHostsShortWidget
                }
            }
        },
        {
            id:"TopFlowHostsIPsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopFlowHostsIPsShortReport": {
                    id:"TopFlowHostsIPsShortReport",
                    params:{},
                    func:QoETableNetflowTopFlowHostsIPsShortWidget
                }
            },
        },
        {
            id:"TopFlowHostCategoriesShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopFlowHostCategoriesShortReport": {
                    id:"TopFlowHostCategoriesShortReport",
                    params:{},
                    func:QoETableNetflowTopFlowHostCategoriesShortWidget
                }
            },
        },
        {
            id:"TopFlowASsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopFlowASsShortReport": {
                    id:"TopFlowASsShortReport",
                    params:{type:"destination"},
                    func:QoETableNetflowTopFlowASsShortWidget
                }
            }
        },
        {
            id:"TopFlowSwitchesShortReport",
            detailsPanelState: this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "TopFlowSwitchesShortReport": {
                    id:"TopFlowSwitchesShortReport",
                    params:{},
                    func:QoETableNetflowTopFlowSwitchesShortWidget
                }
            }
        },
        {
            id:"TopVchannelsTopFlowShortReport",
            detailsPanelState: this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopVchannelsTopFlowShortReport": {
                    id:"TopVchannelsTopFlowShortReport",
                    params:{},
                    func:QoETableNetflowTopFlowVchannelsShortWidget
                }
            }
        },
        {
            id:"TopClassesTopFlowShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopClassesTopFlowShortReport": {
                    id:"TopClassesTopFlowShortReport",
                    params:{},
                    func:QoETableTopFlowClassesShortWidget
                }
            }
        },
        {
            id:"TopFullDscpClassesTopFlowShortWidget",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopFullDscpClassesTopFlowShortWidget": {
                    id:"TopFullDscpClassesTopFlowShortWidget",
                    params:{},
                    func:QoETableTopFlowFullDscpClassesShortWidget
                }
            }
        },
        {
            id:"TopFlowGTPCellsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "TopFlowGTPCellsShortReport":{
                    id:"TopFlowGTPCellsShortReport",
                    params:{},
                    func:QoETableNetflowTopFlowGTPCellsShortWidget
                }
            }
        },
        {
            id:"TopSubscribersRetransmitsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopSubscribersRetransmitsShortReport": {
                    id:"TopSubscribersRetransmitsShortReport",
                    params:{},
                    func:QoETableTopRetransmitsSubscribersShortWidget
                }
            }
        },
        {
            id:"TopSubscriberLoginsRetransmitsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopSubscriberLoginsRetransmitsShortReport": {
                    id:"TopSubscriberLoginsRetransmitsShortReport",
                    params:{},
                    func:QoETableTopRetransmitsSubscriberLoginsShortWidget
                }
            }
        },
        {
            id:"TopRetransmitsProtocolsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopRetransmitsProtocolsShortReport":{
                    id:"TopRetransmitsProtocolsShortReport",
                    params:{},
                    func:QoETableNetflowTopRetransmitsProtocolsShortWidget
                }
            }
        },
        {
            id:"TopRetransmitsProtocolsGrpsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopRetransmitsProtocolsGrpsShortReport": {
                    id:"TopRetransmitsProtocolsGrpsShortReport",
                    params:{},
                    func:QoETableNetflowTopRetransmitsProtocolsGroupsShortWidget
                }
            }
        },
        {
            id:"TopRetransmitsHostsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopRetransmitsHostsShortReport": {
                    id:"TopRetransmitsHostsShortReport",
                    params:{},
                    func:QoETableNetflowTopRetransmitsHostsShortWidget
                }
            }
        },
        {
            id:"TopRetransmitsHostsIPsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopRetransmitsHostsIPsShortReport": {
                    id:"TopRetransmitsHostsIPsShortReport",
                    params:{},
                    func:QoETableNetflowTopRetransmitsHostsIPsShortWidget
                }
            }
        },
        {
            id:"TopRetransmitsHostCategoriesShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopRetransmitsHostCategoriesShortReport": {
                    id:"TopRetransmitsHostCategoriesShortReport",
                    params:{},
                    func:QoETableNetflowTopRetransmitsHostCategoriesShortWidget
                }
            }
        },
        {
            id:"TopRetransmitsASsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopRetransmitsASsShortReport": {
                    id:"TopRetransmitsASsShortReport",
                    params:{type:"destination"},
                    func:QoETableNetflowTopRetransmitsASsShortWidget
                }
            }
        },
        {
            id:"TopRetransmitsSwitchesShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "TopRetransmitsSwitchesShortReport": {
                    id:"TopRetransmitsSwitchesShortReport",
                    params:{},
                    func:QoETableNetflowTopRetransmitsSwitchesShortWidget
                }
            }
        },
        {
            id:"TopVchannelsRetransmitsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopVchannelsRetransmitsShortReport": {
                    id:"TopVchannelsRetransmitsShortReport",
                    params:{},
                    func:QoETableTopRetransmitsVchannelsShortWidget
                }
            }
        },
        {
            id:"TopClassesRetransmitsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.show,
            widgets:{
                "TopClassesRetransmitsShortReport": {
                    id:"TopClassesRetransmitsShortReport",
                    params:{},
                    func:QoETableTopRetransmitsClassesShortWidget
                }
            }
        },
        {
            id:"TopRetransmitsGTPCellsShortReport",
            detailsPanelState:this.QoEOnlineNetflowDetailsPanelStateEnum.hide,
            widgets:{
                "TopRetransmitsGTPCellsShortReport": {
                    id:"TopRetransmitsGTPCellsShortReport",
                    params:{},
                    func:QoETableNetflowTopRetransmitsGTPCellsShortWidget
                }
            }
        }
    ];

    this.Views.CommonViews = {
        CollectConfirmForm: null,
        HelpButtonPopup: null,
        HelpButtonPopupText: null,
        ReportSettingsPopup: null,
        ReportSettingsForm: null,
        ReportRefreshRate: null
    };

    this.Views.OnlineNetflow = {
        AggTimePeriod: null,
        WindowWidth: null,
        DpiPicker: null,
        CollectToolbar: null,
        StartCollectBtn: null,
        StopCollectBtn: null,
        ReportsListLayout: null,
        ReportsList: null,
        ReportsCells: null,
        SubscribersFilters: null,
        MasterPanel: null,
        EmptyMasterReport: null,
        EmptyDetailsReport: null,
        RefreshAllDataBtn: null,
        RefreshDetailsBtn: null,
        DetailsPanel: null,
        DetailsResizer: null,
        DetailsPanelHeader: null,
        FiltersTableWidget: new QoESavedFiltersListWidget({
            id:this.Id + "OnlineNetflow" + "FiltersTableWidget",
            title:LangHelper.GetString("QoEPopupFilterWidget", "Filters"),
            icon:"list",
            wizard: new QoEOnlineReportsFiltersWizardWidget({
                id:this.Id + "OnlineNetflow" + "Wizard"
            }),
            config: {
                    type:QoESubscribersFilterListItemTypeEnum.subs_onlinenetflow,
                    user_id:App.SessionManager.GetProfile().user_id
            }
        })
    };

    this.Views.OnlineNetflow.Widgets = {
        ExtendedFilter: new QoEPopupFilterWidget({
            id:this.Id + "OnlineNetflow" + "ExtendedFillter",
            config:QoEPopupFilterWidgetDefaultConfig(QoEPopupFilterWidgetConfigTypeEnum.QoEOnlineNetFlow),
            enable_show_hotkey: 1
        }),

        RawLogReport: QoETableFullflowRawLogWidget({id:this.Id + "OnlineNetflow" + "RawReport"}, true)
    };

    this.Views.OnlineNetflow.SubWidgets = {};

    this.SectionsEnum = {
        of: this.Id + "SectionsTabs" + "OnlineNetflow"
    };

    this.CollectConfirmFormContext = webix.ui({
        view: "popup",
        id: this.Id + "CollectConfirmForm",
        width: 405,
        height: 130,
        modal: true,
        body: {
            view: "form",
            borderless: true,
            elements: [
                {
                    borderless: true,
                    template:LangHelper.GetString("QoE", "You have not created any filters") + "<br/>" +
                        "<span>" +
                        LangHelper.GetString("QoE", "Are you sure you want to start data collection?") +
                        "</span>"
                },
                {
                    borderless: true,
                    cols: [
                        {
                            view: "button",
                            value: LangHelper.GetString("All", "Cancel"),
                            click: function() {
                                _this.Views.CommonViews.CollectConfirmForm.hide();
                            }
                        },
                        {
                            view: "button",
                            type: "form",
                            value: LangHelper.GetString("QoE", "Start collecting"),
                            click: function() {
                                _this.Views.CommonViews.CollectConfirmForm.hide();
                                _this.OnlineNetflowCollectData(true);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HelpButtonPopup = webix.ui({
        view: "popup",
        id: this.Id + "HelpButtonPopup",
        width: 390,
        height: 100,
        body: {
            view:"form",
            borderless: true,
            elements: [
                {
                    id: this.Id + "HelpButtonPopupText",
                    borderless:true,
                    template: Value => Value
                }
            ]
        }
    });

    this.ReportSettingsPopup = webix.ui({
        view: "popup",
        id: this.Id + "ReportSettingsPopup",
        width: 510,
        height: 150,
        body: {
            view:"form",
            id: this.Id + "ReportSettingsForm",
            borderless: true,
            elements: [
                {
                    rows: [
                        {
                            view:"richselect",
                            id: this.Id + "ReportRefreshRate",
                            label:LangHelper.GetString("QoE", "Report refresh rate"),
                            labelPosition:"right",
                            labelWidth: 210,
                            options:{
                                data: [
                                    {id:this.DefaultReportRefreshRateId, value:LangHelper.GetString("QoE", "As in the aggregation period")},
                                    {id:5, value:LangHelper.GetString("QoE", "5 seconds")},
                                    {id:15, value:LangHelper.GetString("QoE", "15 seconds")},
                                    {id:30, value:LangHelper.GetString("QoE", "30 seconds")},
                                    {id:60, value:LangHelper.GetString("QoE", "1 minute")},
                                    {id:600, value:LangHelper.GetString("QoE", "10 minutes")}
                                ]
                            }
                        },
                        {
                            cols:[
                                {
                                    view:"button",
                                    value:LangHelper.GetString("QoE", "Cancel"),
                                    click: function() {
                                        _this.Views.CommonViews.ReportSettingsPopup.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    type:"form",
                                    value:LangHelper.GetString("QoE", "Apply"),
                                    click: function() {
                                        _this.ReportSettingsPopupApplyHandler();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows:[
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView","QoE analytics"), title: LangHelper.GetString("AppView","Online reports")}),
                                {
                                    view: "tabbar",
                                    id: this.Id + "SectionsTabs",
                                    borderless:true,
                                    multiview:true,
                                    height:40,
                                    options:
                                        [
                                            {
                                                id:this.Id + "SectionsTabs" + "OnlineNetflow",
                                                value:LangHelper.GetString("AppView", "Online netflow"),
                                                width:200
                                            }
                                        ]
                                },
                                {
                                    cells:
                                        [
                                            {
                                                id:this.Id + "SectionsTabs" + "OnlineNetflow",
                                                rows:[
                                                    {height: 16},
                                                    {
                                                        view: "toolbar",
                                                        elements: [
                                                            {
                                                                view:"richselect",
                                                                id:this.Id + "SectionsTabs" + "OnlineNetflow" + "AggTimePeriod",
                                                                maxWidth:310,
                                                                tooltip: LangHelper.GetString("QoE", "Aggregation period"),
                                                                label: LangHelper.GetString("QoE", "Aggregation period"),
                                                                labelWidth: 180,
                                                                on: {
                                                                  onChange:function(newId, oldId) {
                                                                      const item = this.getList().getItem(newId);
                                                                      if(item && item.disabled) {
                                                                          this.blockEvent();
                                                                          oldId ? this.setValue(oldId) : this.setValue("");
                                                                          this.unblockEvent();
                                                                      }
                                                                  }
                                                                },
                                                                options: {
                                                                    body:{
                                                                        scheme:{
                                                                            $init:function(obj) {
                                                                                if(obj.disabled) {
                                                                                    obj.$css = "disabled";
                                                                                }
                                                                            }
                                                                        },
                                                                        data: [
                                                                            {id: 5, value: LangHelper.GetString("QoE", "5 seconds")},
                                                                            {id: 10, value: LangHelper.GetString("QoE", "10 seconds")},
                                                                            {id: 15, value: LangHelper.GetString("QoE", "15 seconds")},
                                                                            {id: 30, value: LangHelper.GetString("QoE", "30 seconds")},
                                                                            {id: 60, value: LangHelper.GetString("QoE", "1 minute")},
                                                                            {id: 120, value: LangHelper.GetString("QoE", "2 minutes")},
                                                                            {id: 180, value: LangHelper.GetString("QoE", "3 minutes")},
                                                                            {id: 240, value: LangHelper.GetString("QoE", "4 minutes")},
                                                                            {id: 300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                                            {id: 360, value: LangHelper.GetString("QoE", "6 minutes")},
                                                                            {id: 420, value: LangHelper.GetString("QoE", "7 minutes")},
                                                                            {id: 480, value: LangHelper.GetString("QoE", "8 minutes")},
                                                                            {id: 540, value: LangHelper.GetString("QoE", "9 minutes")},
                                                                            {id: 600, value: LangHelper.GetString("QoE", "10 minutes")}
                                                                        ],
                                                                        on: {
                                                                            onItemClick: function(id) {
                                                                                const selectedId = this.getSelectedId();
                                                                                if(selectedId != id) {
                                                                                    _this.Views.OnlineNetflow.AggTimePeriod.setValue(id);
                                                                                    _this.OnlineNetflowReplaceOnlineView();
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            _this.GetHelpButtonTemplate(this.Id + "SectionsTabs" + "OnlineNetflow" + "AggTimePeriodHelp", function() {
                                                                _this.ShowHelpButtonPopup(this.getNode(), {pos:"bottom"}, _this.OnlineReportsHelpPopupText.aggPeriodWidget);
                                                            }),
                                                            {width: 16},
                                                            {
                                                                view: "richselect",
                                                                id: this.Id + "SectionsTabs" + "OnlineNetflow" + "WindowWidth",
                                                                value: 1,
                                                                maxWidth: 180,
                                                                tooltip: LangHelper.GetString("QoE", "Window width"),
                                                                label: LangHelper.GetString("QoE", "Window width"),
                                                                labelWidth: 110,
                                                                value: 10,
                                                                options: {
                                                                    body: {
                                                                        data: [
                                                                            {id: 1, value: "1"},
                                                                            {id: 2, value: "2"},
                                                                            {id: 3, value: "3"},
                                                                            {id: 4, value: "4"},
                                                                            {id: 5, value: "5"},
                                                                            {id: 6, value: "6"},
                                                                            {id: 7, value: "7"},
                                                                            {id: 8, value: "8"},
                                                                            {id: 9, value: "9"},
                                                                            {id: 10, value: "10"},
                                                                            {id: 15, value: "15"},
                                                                            {id: 20, value: "20"},
                                                                            {id: 25, value: "25"},
                                                                            {id: 30, value: "30"}
                                                                        ],
                                                                        on: {
                                                                            onItemClick: function(id) {
                                                                                const selectedId = this.getSelectedId();
                                                                                if(selectedId != id) {
                                                                                    _this.Views.OnlineNetflow.WindowWidth.setValue(id);
                                                                                    _this.OnlineNetflowReplaceOnlineView();
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            _this.GetHelpButtonTemplate(this.Id + "SectionsTabs" + "OnlineNetflow" + "WindowWidthHelp", function() {
                                                                _this.ShowHelpButtonPopup(this.getNode(), {pos:"bottom"}, _this.OnlineReportsHelpPopupText.windowWidth);
                                                            }),
                                                            {width: 16},
                                                            {
                                                                view:"multiselect",
                                                                id:this.Id + "SectionsTabs" + "OnlineNetflow" + "DpiPicker",
                                                                value:"-2",
                                                                maxWidth:320,
                                                                optionWidth:320,
                                                                tooltip: LangHelper.GetString("QoE", "From wich DPI device"),
                                                                options:[]
                                                            },
                                                            this.Views.OnlineNetflow.Widgets.ExtendedFilter.ViewConfig,
                                                            {},
                                                            {
                                                                view:"button",
                                                                type:"icon",
                                                                icon:"gear",
                                                                css:"toolbar_round_btn",
                                                                width:32,
                                                                tooltip:LangHelper.GetString("QoE", "Settings"),
                                                                click:function() {
                                                                    _this.ShowReportSettingsPopup(this.getNode(), {pos:"bottom"});
                                                                }
                                                            },
                                                            {
                                                              view:"button",
                                                              id:this.Id + "SectionsTabs" + "OnlineNetflow" + "RefreshAllDataBtn",
                                                              type:"icon",
                                                              icon:"refresh",
                                                              css:"toolbar_round_btn",
                                                              width:32,
                                                              tooltip:LangHelper.GetString("QoE", "Refresh"),
                                                              click: function(id, e, node) {
                                                                  _this.SetAggTimePeriod("OnlineNetflow");
                                                                  _this.OnlineNetflowClearAllTimers();
                                                                  _this.OnlineNetflowRefreshAllData();
                                                              }
                                                            },
                                                            QoEClearCacheBtnWidget({
                                                                id: this.Id+"ClearCacheBtn",
                                                                callback:function (Id) {
                                                                    _this.ClearCache(Id, LangHelper.GetString("QoE", "Cache cleared"));
                                                                }
                                                            })

                                                        ]
                                                    },
                                                    {
                                                        view: "accordion",
                                                        multi: "mixed",
                                                        cols: [
                                                            {
                                                                header: LangHelper.GetString("QoE", "Filters"),
                                                                id: this.Id + "SectionsTabs" + "OnlineNetflow" + "SubscribersFilters",
                                                                gravity: 1,
                                                                body: {
                                                                    cols: [
                                                                        this.Views.OnlineNetflow.FiltersTableWidget.ViewConfig,
                                                                        {gravity: 0}
                                                                    ]
                                                                }
                                                            },
                                                            {
                                                                view: "resizer"
                                                            },
                                                            {
                                                                header: LangHelper.GetString("QoE", "Reports"),
                                                                id: this.Id + "SectionsTabs" + "OnlineNetflow" + "MasterPanel",
                                                                gravity: 4,
                                                                body: {
                                                                    cols: [
                                                                        {
                                                                            rows:[
                                                                                {
                                                                                    view: "toolbar",
                                                                                    id: this.Id + "SectionsTabs" + "OnlineNetflow" + "CollectToolbar",
                                                                                    height: 32,
                                                                                    padding: 0,
                                                                                    margin: 0,
                                                                                    elements: [
                                                                                        {
                                                                                            view: "button",
                                                                                            id:this.Id + "SectionsTabs" + "OnlineNetflow" + "StartCollectBtn",
                                                                                            type: "icon",
                                                                                            icon: "play-circle",
                                                                                            width: 32,
                                                                                            css:"toolbar_round_btn",
                                                                                            tooltip:LangHelper.GetString("QoE","Start collecting data"),
                                                                                            click: function (id, e, node)
                                                                                            {
                                                                                                _this.ShowIfNeedCollectConfirmForm(this.getNode(), {pos:"bottom"});
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            view: "button",
                                                                                            id:this.Id + "SectionsTabs" + "OnlineNetflow" + "StopCollectBtn",
                                                                                            type: "icon",
                                                                                            icon: "stop-circle",
                                                                                            width: 32,
                                                                                            css:"toolbar_round_btn",
                                                                                            tooltip:LangHelper.GetString("QoE","Stop collecting data"),
                                                                                            click: function (id, e, node)
                                                                                            {
                                                                                                _this.OnlineNetflowCollectData(false);
                                                                                            }
                                                                                        },
                                                                                        {},
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    id: this.Id + "SectionsTabs" + "OnlineNetflow" + "ReportsListLayout",
                                                                                    rows:[
                                                                                        BlockHeaderTemplate({title:LangHelper.GetString("QoE", "Group by"), icon: "folder-tree"}),
                                                                                        {
                                                                                            view: "treetable",
                                                                                            id: this.Id + "SectionsTabs" + "OnlineNetflow" + "ReportsList",
                                                                                            header: false,
                                                                                            select: "row",
                                                                                            on: {
                                                                                                onAfterSelect:function() {
                                                                                                    _this.OnlineNetflowOnReportsListSelectionChanged();
                                                                                                },
                                                                                                onAfterUnSelect:function() {
                                                                                                    _this.OnlineNetflowOnReportsListSelectionChanged();
                                                                                                }
                                                                                            },
                                                                                            columns: [
                                                                                                {
                                                                                                    id: "value",
                                                                                                    fillspace: true,
                                                                                                    template: function(obj, common, value, config) {
                                                                                                        return common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");
                                                                                                    }
                                                                                                }
                                                                                            ],
                                                                                            data:[
                                                                                                {
                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "RttDistribution" + "Group",
                                                                                                    value: LangHelper.GetString("QoE", "RTT"),
                                                                                                    data: [
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "RttDistribution",
                                                                                                            value: LangHelper.GetString("QoE", "RTT distribution")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "RttByTime",
                                                                                                            value: LangHelper.GetString("QoE", "RTT by time")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "RetransmitsByTime",
                                                                                                            value: LangHelper.GetString("QoE", "Retransmits by time")
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "StatChartTraffic" + "Group",
                                                                                                    value: LangHelper.GetString("QoE", "Traffic"),
                                                                                                    data: [
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "StatChartTraffic",
                                                                                                            value: LangHelper.GetString("QoE", "Traffic")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TrafficByProtocols",
                                                                                                            value: LangHelper.GetString("QoE", "Traffic by protocols")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TrafficByAppProtocols",
                                                                                                            value: LangHelper.GetString("QoE", "Traffic by application protocols")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TrafficByAppProtocolsGrps",
                                                                                                            value: LangHelper.GetString("QoE", "Traffic by application protocols groups")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TrafficByAs",
                                                                                                            value: LangHelper.GetString("QoE", "Traffic by AS")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TrafficBySubscribersAS",
                                                                                                            value: LangHelper.GetString("QoE", "Traffic by subscriber`s AS")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TrafficByVchannels",
                                                                                                            value: LangHelper.GetString("QoE", "Traffic by vchannels")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TrafficByClasses",
                                                                                                            value: LangHelper.GetString("QoE", "Traffic by classes")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TrafficByFullDscpClasses",
                                                                                                            value: LangHelper.GetString("QoE", "Traffic by DSCP")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "Flow",
                                                                                                            value: LangHelper.GetString("QoE", "Flow")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "FlowByProtocols",
                                                                                                            value: LangHelper.GetString("QoE", "Flow by protocols")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "FlowByAppProtocols",
                                                                                                            value: LangHelper.GetString("QoE", "Flow by application protocols")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "FlowByAppProtocolsGrps",
                                                                                                            value: LangHelper.GetString("QoE", "Flow by application protocols groups")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "FlowByVchannels",
                                                                                                            value: LangHelper.GetString("QoE", "Flow by vchannels")
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "FlowByClasses",
                                                                                                            value: LangHelper.GetString("QoE", "Flow by classes")
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersRttShortReport" + "Group" + "Group" + "Group",
                                                                                                    value: LangHelper.GetString("QoE", "Top"),
                                                                                                    data: [
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersRttShortReport" + "Group" + "Group",
                                                                                                            value: LangHelper.GetString("QoE", "Top with high RTT"),
                                                                                                            data: [
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersRttShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top subscribers"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersRttShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top subscribers")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscriberLoginsRttShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top logins"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscriberLoginsRttShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top logins")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopProtocolsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top protocols"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopProtocolsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top protocols")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopProtocolsGrpsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top protocols groups"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopProtocolsGrpsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top protocols groups")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopHostsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top hosts"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopHostsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top hosts")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopHostsIPsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top hosts IPs"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopHostsIPsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top hosts IPs")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopHostsCategoriesShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top host categories"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopHostsCategoriesShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top host categories")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopASsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top AS"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopASsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top AS")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSwitchesShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top switches"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSwitchesShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top switches")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopVchannelsRttShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top vchannels"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopVchannelsRttShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top vchannels")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopClassesRttShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top classes"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopClassesRttShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top classes")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopGTPCellsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top GTP cells"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopGTPCellsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top GTP cells")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersTrafficShortReport" + "Group" + "Group",
                                                                                                            value: LangHelper.GetString("QoE", "Top with high traffic"),
                                                                                                            data: [
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersTrafficShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top subscribers"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersTrafficShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top subscribers")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscriberLoginsTrafficShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top logins"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscriberLoginsTrafficShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top logins")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficProtocolsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top protocols"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficProtocolsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top protocols")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficProtocolsGrpsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top protocols groups"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficProtocolsGrpsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top protocols groups")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficHostsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top hosts"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficHostsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top hosts")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficHostsIPsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top hosts IPs"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficHostsIPsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top hosts IPs")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficHostCategoriesShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top host categories"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficHostCategoriesShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top host categories")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficASsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top AS"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficASsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top AS")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficSwitchesShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top switches"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficSwitchesShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top switches")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopVchannelsTrafficShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top vchannels"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopVchannelsTrafficShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top vchannels")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopClassesTrafficShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top classes"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopClassesTrafficShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top classes")
                                                                                                                        },
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFullDscpClassesTrafficShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top DSCP classes")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficGTPCellsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top GTP cells"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopTrafficGTPCellsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top GTP cells")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersTopFlowShortReport" + "Group" + "Group",
                                                                                                            value: LangHelper.GetString("QoE", "Top with high flow"),
                                                                                                            data: [
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersTopFlowShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top subscribers"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersTopFlowShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top subscribers")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscriberLoginsTopFlowShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top logins"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscriberLoginsTopFlowShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top logins")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowProtocolsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top protocols"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowProtocolsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top protocols")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowProtocolsGrpsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top protocols groups"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowProtocolsGrpsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top protocols groups")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowHostsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top hosts"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowHostsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top hosts")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowHostsIPsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top hosts IPs"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowHostsIPsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top hosts IPs")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowHostCategoriesShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top host categories"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowHostCategoriesShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top host categories")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowASsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top AS"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowASsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top AS")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowSwitchesShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top switches"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowSwitchesShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top switches")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopVchannelsTopFlowShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top vchannels"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopVchannelsTopFlowShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top vchannels")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopClassesTopFlowShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top classes"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopClassesTopFlowShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top classes")
                                                                                                                        },
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFullDscpClassesTopFlowShortWidget",
                                                                                                                            value: LangHelper.GetString("QoE", "Top DSCP classes")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowGTPCellsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top GTP cells"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopFlowGTPCellsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top GTP cells")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersRetransmitsShortReport" + "Group" + "Group",
                                                                                                            value: LangHelper.GetString("QoE", "Top with high retransmits"),
                                                                                                            data: [
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersRetransmitsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top subscribers"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersRetransmitsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top subscribers")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscriberLoginsRetransmitsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top logins"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscriberLoginsRetransmitsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top logins")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsProtocolsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top protocols"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsProtocolsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top protocols")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsProtocolsGrpsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top protocols groups"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsProtocolsGrpsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top protocols groups")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsHostsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top hosts"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsHostsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top hosts")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsHostsIPsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top hosts IPs"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id  + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsHostsIPsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top hosts IPs")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsHostCategoriesShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top host categories"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsHostCategoriesShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top host categories")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsASsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top AS"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsASsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top AS")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsSwitchesShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top switches"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsSwitchesShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top switches")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopVchannelsRetransmitsShortReport" + "Group",
                                                                                                                    value:LangHelper.GetString("QoE", "Top vchannels"),
                                                                                                                    data:[
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopVchannelsRetransmitsShortReport",
                                                                                                                            value:LangHelper.GetString("QoE", "Top vchannels")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopClassesRetransmitsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top classes"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopClassesRetransmitsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top classes")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsGTPCellsShortReport" + "Group",
                                                                                                                    value: LangHelper.GetString("QoE", "Top GTP cells"),
                                                                                                                    data: [
                                                                                                                        {
                                                                                                                            id: this.Id + "OnlineNetflow" + "ReportsCells" + "TopRetransmitsGTPCellsShortReport",
                                                                                                                            value: LangHelper.GetString("QoE", "Top GTP cells")
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            view:"resizer"
                                                                        },
                                                                        {
                                                                            gravity:3,
                                                                            rows:[
                                                                                {
                                                                                    view: "multiview",
                                                                                    id: this.Id + "SectionsTabs" + "OnlineNetflow" + "ReportsCells",
                                                                                    cells: [
                                                                                        {id: this.Id +  "SectionsTabs" + "OnlineNetflow" + "EmptyMasterReport"}
                                                                                    ]
                                                                                },
                                                                                {id: this.Id + "SectionsTabs" + "OnlineNetflow" + "DetailsResizer", view: "resizer"},
                                                                                {
                                                                                    rows:[
                                                                                        BlockHeaderTemplate({id:this.Id + "SectionsTabs" + "OnlineNetflow" + "DetailsPanelHeader", title:LangHelper.GetString("QoE", "Details"), icon: "list-ul"}),
                                                                                        {
                                                                                            id: this.Id + "SectionsTabs" + "OnlineNetflow" + "DetailsPanel",
                                                                                            rows: [
                                                                                                {
                                                                                                    view: "toolbar",
                                                                                                    height: 36,
                                                                                                    elements: [
                                                                                                        {},
                                                                                                        {
                                                                                                            view: "button",
                                                                                                            id: this.Id + "SectionsTabs" + "OnlineNetflow" + "RefreshDetailsBtn",
                                                                                                            type: "icon",
                                                                                                            icon: "refresh",
                                                                                                            css: "toolbar_round_btn",
                                                                                                            width: 32,
                                                                                                            tooltip: LangHelper.GetString("QoE", "Refresh"),
                                                                                                            click: function() {
                                                                                                                const id = _this.OnlineNetflowGetReportsListSelectedId();
                                                                                                                const selectedData = _this.OnlineNetflowGetTableReportSelectedData(id);
                                                                                                                if(selectedData) {
                                                                                                                    _this.SetAggTimePeriod("OnlineNetflow");
                                                                                                                    _this.OnlineNetflowRefreshDetailsPanel(id);
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    cells: [
                                                                                                        {id: this.Id +  "SectionsTabs" + "OnlineNetflow" + "EmptyDetailsReport"},
                                                                                                        {
                                                                                                            id: this.Id + "OnlineNetflow" + "DetailsPanel" + "RawLogReport",
                                                                                                            rows: [
                                                                                                                this.Views.OnlineNetflow.Widgets.RawLogReport.ViewConfig
                                                                                                            ]
                                                                                                        },
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            gravity:0
                                                                        }
                                                                    ]
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.SelectedAggTimePeriods = {
        OnlineNetflow: null
    }

    this.OnlineNetflowTimers = {
        OnlineNetflow: null,
        RefreshMasterPanel: null,
        RefreshDetailsPanel: null
    };

    this.OnlineReportsDisableListItemCss = webix.html.createCss({
        "background": "rgba(255,255,255,0.7)",
        "color": "#aaa !important",
        "opacity":"0.4"
    });

    this.OnlineReportsHelpPopupText = {
        aggPeriodWidget: {
            height:160,
            text:LangHelper.GetString("QoE", "Allows you to select the aggregation period for reports. The set of available values depends on the smallest rotation period of the receivers")
                + '<br/><br/>'
                + `<a href=${LangHelper.GetString("WikiLinks", "qoe_online_reports")} target="_blank">${LangHelper.GetString(this.Id, "Link to wiki")}</a>`
        },
        windowWidth: {
            height:160,
            text:LangHelper.GetString("QoE", "Allows you to increase the aggregation period")
                + '<br/><br/>'
                + `<a href=${LangHelper.GetString("WikiLinks", "qoe_online_reports")} target="_blank">${LangHelper.GetString(this.Id, "Link to wiki")}</a>`
        }
    };

    this.CachesToDelete = {};

    this.QoEStorServerTimezoneOffset = null;

    this.Collapse = true;

    this.ReportsListSelectedCount = new Rx.BehaviorSubject(0);

    this.view_id_table_id_map = {};
};

QoEOnlineReportsViewController.prototype.ViewDidLoad = function (PathParams)
{
    const _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEOnlineReports");
    });

    this.BindAll(PathParams);

    this.CheckQoEStorVersionCompatibility();

    this.SetAggTimePeriod("OnlineNetflow");

    this.GetQoEStorServerTimezone();
};

QoEOnlineReportsViewController.prototype.BindAll = function (Params)
{
    const _this = this;

    this.Views.SectionsTabs = $$(this.Id + "SectionsTabs");

    Object.keys(this.Views.CommonViews).forEach(Key => {
        this.Views.CommonViews[Key] = $$(this.Id + Key);
    });

    Object.keys(this.Views.OnlineNetflow).forEach(function(Key){
        if(Key.toLowerCase().indexOf("widget") === -1)
        {
            _this.Views.OnlineNetflow[Key] = $$(_this.Id + "SectionsTabs" + "OnlineNetflow" + Key);
        }
    });

    this.OnlineNetflowTimers.OnlineNetflow =  new QoEOnlineViewTimerModel();
    this.OnlineNetflowTimers.RefreshMasterPanel = new QoEOnlineViewTimerModel({button: this.Views.OnlineNetflow.RefreshAllDataBtn});
    this.OnlineNetflowTimers.RefreshDetailsPanel = new QoEOnlineViewTimerModel({button: this.Views.OnlineNetflow.RefreshDetailsBtn});

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function(Value) {
       if(Value) {
           _this.DpiPickerOptionsUpdate("OnlineNetflow");
       }
    });

    Object.keys(this.Views.OnlineNetflow.Widgets).forEach(function(Key) {
        _this.Views.OnlineNetflow.Widgets[Key].Bind(_this);
    });

    this.Subscriptions.RawLogReportRefreshSignal = this.Views.OnlineNetflow.Widgets.RawLogReport.CacheMonitor.RefreshSilenceSignal.subscribe(function(Signal) {
        _this.CacheMonitorRefreshSignal(Signal, _this.OnlineNetflowTimers.RefreshDetailsPanel);
    });

    this.Views.OnlineNetflow.DpiPicker.attachEvent("onChange", function() {
        _this.OnlineNetflowRefreshAllData();
    });

    this.Views.OnlineNetflow.FiltersTableWidget.Bind(this, null, this.Views.OnlineNetflow.Widgets.ExtendedFilter);

    this.Subscriptions.OnlineNetflowExtendedFilterApplySignal = this.Views.OnlineNetflow.Widgets.ExtendedFilter.ApplyStateSignal.subscribe(function(Signal) {
        if(Signal) {
            const selectedFilter = _this.Views.OnlineNetflow.FiltersTableWidget.GetTableSelectedData();

            if(selectedFilter) {
                _this.Views.OnlineNetflow.FiltersTableWidget.SaveFilter(null, function() {
                    _this.OnlineNetflowReplaceOnlineView();
                });
            }
        }
    });

    this.Subscriptions.OnlineNetflowExtendedFiltersTableRowsSelectedCountSubscription = this.Views.OnlineNetflow.FiltersTableWidget.TableRowsSelectedCount.subscribe(function(Value) {
        _this.OnlineNetflowFiltersTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.ReportsListSelectedCountSubscription = this.ReportsListSelectedCount.subscribe(function(Value) {
       if(Value) {
           _this.OnlineNetflowShowSelectedReport();
       }
       else {
           _this.Views.OnlineNetflow.ReportsCells.disable();
       }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.HardwaresDic],
        App.SessionManager.CurrentHardwareId.distinctUntilChanged(),
        App.DicsManager.Signal[DicsEnum.HostCategoriesDic]
    ).subscribe(function(Val)
        {
            var hwId = App.SessionManager.GetCurrentHardwareId();

            if(Val[0] && (Val[1] || !hwId) && Val[2]) {
                _this.Views.OnlineNetflow.FiltersTableWidget.RefreshTable(0);

                if(_this.Views.OnlineNetflow.ReportsList.getSelectedItem()) {
                    _this.OnlineNetflowRefreshAllData();
                }
                else {
                    let reportId = _this.GetPathParam("report");
                    reportId = reportId ? reportId : _this.Views.OnlineNetflow.ReportsList.getFirstId();
                    reportId = _this.Views.OnlineNetflow.ReportsList.exists(reportId) ? reportId : _this.Views.OnlineNetflow.ReportsList.getFirstId();
                    _this.OnlineNetflowSelectReportListItem(reportId);
                }
            }
        }
    );

    this.Subscriptions.SignalQoEStorConfigFileUpdated = this.QoEStorConfigManager.Signals.ConfigFileUpdated.subscribe(function(Val) {
        if(Val) {
            const rows = _this.QoEStorConfigManager.ParseReceiverRows([
                QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW,
            ]);
            _this.DefineAggTimePeriodWidgetList(rows, _this.Views.OnlineNetflow.AggTimePeriod);
        }
    });

    this.QoEStorConfigManager.Refresh({callback:()=>{}});

    App.WebSocketManager.Connect(this.Id);

    App.WebSocketManager.Connections[this.Id].on("qoe_env_update", function(R) {
        const response = JSON.parse(R);
        if(!_this.QoEStorConfigManager.Active)
        {
            return;
        }

        if(response.success)
        {
            _this.QoEStorConfigManager.ConfigFile = response.data;
        }
        else
        {
            _this.QoEStorConfigManager.ConfigFile = "";
        }

        _this.QoEStorConfigManager.ParseConfigToModel();
        _this.QoEStorConfigManager.ParseModelToConfig();

        _this.QoEStorConfigManager.Signals.ConfigFileUpdated.next(1);
    });

    App.WebSocketManager.Connections[this.Id].on("qoe_filters_update", function(R) {
        const filter = JSON.parse(R);
        if(filter.type == QoESubscribersFilterListItemTypeEnum.subs_onlinenetflow) {
            const table = _this.Views.OnlineNetflow.FiltersTableWidget.Views.Table;
            table.eachRow(row => {
               const rowItem = table.getItem(row);
               if(rowItem.filter_id == filter.filter_id) {
                   table.updateItem(row, new QoESubscribersFilterListItemModel(filter));
                   _this.Views.OnlineNetflow.FiltersTableWidget.TableRowsSelectedCountSubscriptionHandler(1);
               }
            });
        }
    });

    App.WebSocketManager.Connections[this.Id].on("qoe_filters_delete", function(R) {
       const filter = JSON.parse(R);
       if(filter.type == QoESubscribersFilterListItemTypeEnum.subs_onlinenetflow) {
           const table = _this.Views.OnlineNetflow.FiltersTableWidget.Views.Table;
           table.eachRow(row => {
               const rowItem = table.getItem(row);
               if(rowItem.filter_id == filter.filter_id) {
                   table.remove(rowItem.id);
               }
           });
       }
    });

    this.GetAllPathParam();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        _this.Views.Widgets[Key].Bind(_this);
    });
};

QoEOnlineReportsViewController.prototype.DefineAggTimePeriodWidgetList = function(Rows, Widget)
{
    const _this = this;

    let secondsMin = 0;
    let minutesMin = 0;

    Rows.forEach(row => {
        const seconds = parseInt(row.ROTATE_SECONDS, 10);
        const minutes = parseInt(row.ROTATE_MINUTES, 10);
        if (seconds && (!secondsMin || seconds < secondsMin)) {
            secondsMin = seconds;
        }
        if (minutes && (!minutesMin || minutes < minutesMin)) {
            minutesMin = minutes;
        }
    });

    const defineAggTimePeriodWidget = function (ReceiverSeconds, targetWidget) {
        const list = targetWidget.getList();
        const listData= list.serialize();

        listData.forEach(item => {
           if(item.id < ReceiverSeconds) {
               list.getItem(item.id).disabled = true;
               list.addCss(item.id, _this.OnlineReportsDisableListItemCss);
           }
           else {
               list.getItem(item.id).disabled = false;
               list.removeCss(item.id, _this.OnlineReportsDisableListItemCss);
           }
        });

        list.refresh();
        targetWidget.refresh();

        const aggPeriod = _this.Views.OnlineNetflow.AggTimePeriod.getValue();
        const availableAggPeriod = _this.OnlineNetflowGetAggPeriodAvailableValue(aggPeriod);

        if(aggPeriod != availableAggPeriod) {
            _this.Views.OnlineNetflow.AggTimePeriod.setValue(availableAggPeriod);
            _this.OnlineNetflowFiltersTableRowsSelectedCountSubscriptionHandler(1);
        }
    }

    if (secondsMin) {
        defineAggTimePeriodWidget(secondsMin, Widget)
        return;
    }

    if (minutesMin) {
        defineAggTimePeriodWidget(minutesMin * 60, Widget)
        return;
    }

    defineAggTimePeriodWidget(0, Widget);
};

QoEOnlineReportsViewController.prototype.Destroy = function ()
{
    const _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.DestroyUIObjects(this.Views.OnlineNetflow.Widgets);

    Object.keys(this.Views.OnlineNetflow.SubWidgets).forEach(Key => {
        this.DestroyUIObjects(this.Views.OnlineNetflow.SubWidgets[Key]);
    });

    this.OnlineNetflowClearAllTimers(true);

    App.WebSocketManager.Disconnect(this.Id);

    this.ClearCache(QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache);

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEOnlineReportsViewController.prototype.DestroyUIObjects = function(MainObject)
{
    Object.keys(MainObject).forEach(Key => {
        MainObject[Key].Destroy();
    });
};

QoEOnlineReportsViewController.prototype.OnlineNetflowClearAllTimers = function(Destroy=false)
{
    Object.keys(this.OnlineNetflowTimers).forEach(Key => {
        const timer = this.OnlineNetflowTimers[Key];
        clearTimeout(timer.id);
        timer.id = null;
        timer.cache_id = "";
        if(timer.button && !Destroy) {
            const icon = this.GetButtonRefreshIcon(timer.button);
            this.SetRotateRefreshButton(icon, 0);
        }
    });
};

QoEOnlineReportsViewController.prototype.StartOnlineNetflowTimer = function(Duration)
{
    const _this = this;

    this.OnlineNetflowTimers.OnlineNetflow.id = setTimeout(function ()
    {
        const filter_id = _this.Views.OnlineNetflow.FiltersTableWidget.GetSelectedFilterId();

        if(filter_id)
        {
            _this.ViewModel.UpdateOnlineViewCreatedTime(_this.OnlineNetflowGetViewModel(), function(R)
            {
                _this.ClearCache(QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache);

                if(!R.success)
                {
                    _this.OnlineNetflowSetDisableState();

                    webix.message({type:"error", text:R.error.msg});
                    return;
                }

                if(R.data.rows && R.data.rows.length)
                {
                    const filters = JSON.parse(R.data.rows[0].filters);
                    _this.Views.OnlineNetflow.AggTimePeriod.setValue(filters.agg_period);
                    _this.Views.OnlineNetflow.WindowWidth.setValue(filters.window_width);

                    var table_id_changed = false;

                    R.data.rows.forEach(function (Item)
                    {
                        var model = new QoEOnlineViewModel(Item);

                        if(_this.view_id_table_id_map[model.view_id] != model.table_id)
                            table_id_changed = true;

                        _this.view_id_table_id_map[model.view_id] = model.table_id;
                    });

                    if(table_id_changed)
                        _this.OnlineNetflowConfigReports();

                    _this.OnlineNetflowSetEnableState();
                }
                else
                {
                    _this.OnlineNetflowSetDisableState();
                }
            });
        }
    }, Duration);
};

QoEOnlineReportsViewController.prototype.OnlineNetflowSetDisableState = function()
{
    const views = this.Views.OnlineNetflow;

    views.EmptyMasterReport.show();
    views.EmptyDetailsReport.show();

    views.StartCollectBtn.enable();
    views.StopCollectBtn.disable();

    views.ReportsListLayout.disable();
};

QoEOnlineReportsViewController.prototype.OnlineNetflowGetAggPeriodAvailableValue = function(Value)
{
    const list = this.Views.OnlineNetflow.AggTimePeriod.getList();
    const listData = list.serialize();
    
    if(!Value || listData.find(item => item.id == Value && item.disabled)) {
        const availableValue = listData.find(val => !val.disabled);
        if(availableValue) {
            return availableValue.id;
        }
        return "";
    }
    return Value;
}

QoEOnlineReportsViewController.prototype.OnlineNetflowSetEnableState = function()
{
    const views = this.Views.OnlineNetflow;

    views.MasterPanel.enable();
    views.StartCollectBtn.disable();
    views.StopCollectBtn.enable();

    views.ReportsListLayout.enable();

    this.ClearCache(QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache);
    this.OnlineNetflowShowSelectedReport();
};

QoEOnlineReportsViewController.prototype.OnlineNetflowShowSelectedReport = function()
{
    this.Views.OnlineNetflow.ReportsCells.enable();

    const selected = this.OnlineNetflowGetReportsListSelectedItem();

    if(selected) {
        const id = Helper.ReplaceAll("Group", "", selected.id);

        if ($$(id)) {
            this.OnlineNetflowIsNeedHideDetailsPanel(selected);
            $$(id).show();
            this.OnlineNetflowClearAllTimers();
            this.SetAggTimePeriod("OnlineNetflow");
            this.OnlineNetflowRefreshAllData();
        }
    }
};

QoEOnlineReportsViewController.prototype.OnlineNetflowCollapsePanels = function()
{
    if(this.Collapse) {
        const sidebarCollapseState = parseInt(App.SessionManager.GetPreference("Collapsed"), 10);

        if (!sidebarCollapseState) {
            App.SessionManager.SetPreference("Collapsed", 1);
        }

        this.Views.OnlineNetflow.SubscribersFilters.collapse();
        this.Collapse = false;
    }
};

QoEOnlineReportsViewController.prototype.OnlineNetflowDestroySubWidgets = function()
{
    const widgets = this.Views.OnlineNetflow.SubWidgets;

    Object.keys(widgets).forEach(reportId =>
    {
        const mainWidget = widgets[reportId];

        this.DestroyUIObjects(mainWidget);

        Object.keys(mainWidget).forEach(Key =>
        {
            const subWidget = mainWidget[Key];

            const subWidgetKey = reportId + Key;

            if(this.Subscriptions[subWidgetKey + "RowsSelectedCount"])
            {
                this.Subscriptions[subWidgetKey + "RowsSelectedCount"].unsubscribe();
            }

            if(this.Subscriptions[subWidgetKey + "RefreshSignal"])
            {
                    this.Subscriptions[subWidgetKey + "RefreshSignal"].unsubscribe();
            }

            if(subWidget instanceof QoETableChartWidget)
            {
                Object.keys(subWidget).forEach(Prop =>
                {
                    const subscriptionId = subWidget[Prop] && subWidget[Prop].Id ? (subWidget[Prop].Id + "RefreshSignal") : null;

                    if(subscriptionId && this.Subscriptions[subscriptionId])
                    {
                        this.Subscriptions[subscriptionId].unsubscribe();
                    }
                });
            }
        });

        this.Views.OnlineNetflow.ReportsCells.removeView(this.Id + "OnlineNetflow" + "ReportsCells" + reportId);
    });
};

QoEOnlineReportsViewController.prototype.OnlineNetflowConfigReports = function ()
{
    const _this = this;

    const AttachRowSelectedCountSignal = function(ReportId, Widget) {
        _this.Subscriptions[ReportId + "RowsSelectedCount"] = Widget.TableRowsSelectedCount.subscribe(function(Val) {
           if(Val) {
                _this.OnlineNetflowTableReportRowsSelectedCountHandler();
           }
        });
    };

    const AttachRefreshSignal = function(ReportId, Widget) {
        _this.Subscriptions[ReportId + "RefreshSignal"] = Widget.CacheMonitor.RefreshSilenceSignal.subscribe(function(Val) {
            _this.CacheMonitorRefreshSignal(Val, _this.OnlineNetflowTimers.RefreshMasterPanel);
        });
    };

    const selectedFilterId = this.Views.OnlineNetflow.FiltersTableWidget.GetSelectedFilterId();

    if(selectedFilterId)
    {
        this.OnlineNetflowDestroySubWidgets();
        this.Views.OnlineNetflow.SubWidgets = {};

        this.QoEOnlineNetflowReportsFunctionsEnum.forEach(report =>
        {
            this.Views.OnlineNetflow.SubWidgets[report.id] = {};

            Object.keys(report.widgets).forEach(Key =>
            {
                let item = report.widgets[Key];
                let reportItemId = report.id + item.id;

                var table_id = QoEOnlineViewsPrefixesEnum.OnlineNetflow + selectedFilterId;

                table_id = _this.view_id_table_id_map[table_id] ? _this.view_id_table_id_map[table_id] : table_id;

                const params = webix.extend(
                    {
                        id: this.Id + "OnlineNetflow" + reportItemId,
                        view:QoEReportViews.OnlineNetflow,
                        table:table_id
                    }, item.params, true);

                this.Views.OnlineNetflow.SubWidgets[report.id][item.id] = item.func(params, true);
            });

            let template = report.template && typeof report.template === "function" ? report.template
                : function (Params) {
                    return {
                        id: Params && Params.id ? Params.id : webix.uid(),
                        cols: function() {
                           let res = [];

                           if(Params && Params.Widgets) {
                               Object.keys(Params.Widgets).forEach(Key => {
                                  res.push({
                                      gravity: 2,
                                      rows: [
                                          Params.Widgets[Key].ViewConfig
                                      ]
                                  });
                               });
                           }

                           return res;
                        }()
                    }
                };

            this.Views.OnlineNetflow.ReportsCells.addView(template({
                id: this.Id + "OnlineNetflow" + "ReportsCells" + report.id,
                Widgets: this.Views.OnlineNetflow.SubWidgets[report.id]
            }))

            Object.keys(this.Views.OnlineNetflow.SubWidgets[report.id]).forEach(Key => {
                this.Views.OnlineNetflow.SubWidgets[report.id][Key].Bind(this);
            });

            const details = report.detailsPanelState === this.QoEOnlineNetflowDetailsPanelStateEnum.show;

            Object.keys(this.Views.OnlineNetflow.SubWidgets[report.id]).forEach(Key => {
                    const mainWidget = this.Views.OnlineNetflow.SubWidgets[report.id][Key];
                    let tableWidget = null;
                    if (mainWidget instanceof QoETableChartWidget) {
                        Object.keys(mainWidget).forEach(Prop => {
                            if(mainWidget[Prop] && mainWidget[Prop].CacheMonitor) {
                                AttachRefreshSignal(mainWidget[Prop].Id, mainWidget[Prop]);
                            }
                        });

                        tableWidget = this.Views.OnlineNetflow.SubWidgets[report.id][Key].TableWidget;

                    } else {
                        AttachRefreshSignal(report.id + Key, this.Views.OnlineNetflow.SubWidgets[report.id][Key]);
                        if(this.Views.OnlineNetflow.SubWidgets[report.id][Key].TableRowsSelectedCount) {
                           tableWidget = this.Views.OnlineNetflow.SubWidgets[report.id][Key];
                        }
                    }

                    if(details && tableWidget !== null) {
                        AttachRowSelectedCountSignal(report.id + Key, tableWidget);
                    }
                }
            );
        });
    }
};

QoEOnlineReportsViewController.prototype.GetButtonRefreshIcon = function(Button)
{
    const node = Button.getInputNode();
    return node.querySelector(".webix_icon_btn");
};

QoEOnlineReportsViewController.prototype.SetRotateRefreshButton = function(Button, Deg = 0)
{
    Button.style.transform = "rotate("+Deg+"deg)";
};

QoEOnlineReportsViewController.prototype.CacheMonitorRefreshSignal = function(Signal, Timer)
{
    if(!Signal) {
        return;
    }

    this.CachesToDelete[Signal.cache_id] = Signal.cache_id;

    if(Timer.cache_id == Signal.cache_id) {
        if(Signal.enabled) {
            this.StartRefreshButtonAnim(Timer, Signal);
        }

        if(!Signal.enabled) {
            this.StopRefreshButtonAnim(Timer);
            Timer.cache_id = "";

            const foundTimer = Object.keys(this.OnlineNetflowTimers).find(timerKey => this.OnlineNetflowTimers[timerKey].id && timerKey != "OnlineNetflow");
            if(!foundTimer) {
                clearTimeout(this.OnlineNetflowTimers.OnlineNetflow.id);
                this.OnlineNetflowTimers.OnlineNetflow.id = null;

                const refreshRateId = this.GetReportRefreshRateId();

                let timeInMilliseconds;
                if(refreshRateId === this.DefaultReportRefreshRateId) {
                    timeInMilliseconds = this.Views.OnlineNetflow.AggTimePeriod.getValue();
                }
                else {
                    timeInMilliseconds = refreshRateId;
                }

                this.StartOnlineNetflowTimer(timeInMilliseconds * 1000);
            }
        }
    }

    if(Timer.cache_id != Signal.cache_id) {
        if(Signal.enabled && Timer.cache_id) {
            this.StopRefreshButtonAnim(Timer);
            Timer.cache_id = Signal.cache_id;
        }

        if(Signal.enabled) {
            this.StartRefreshButtonAnim(Timer, Signal);
        }
    }
};

QoEOnlineReportsViewController.prototype.StartRefreshButtonAnim = function(Timer, Signal)
{
    const _this = this;

    this.StopRefreshButtonAnim(Timer);
    Timer.cache_id = Signal.cache_id;
    const icon = this.GetButtonRefreshIcon(Timer.button);
    let deg = 0;
    Timer.id = setTimeout(function anim() {
        deg += 36;
        if(deg == 360) {
            deg = 0;
        }
        _this.SetRotateRefreshButton(icon, deg);

        Timer.id = setTimeout(anim, 100);
    }, 100);
};

QoEOnlineReportsViewController.prototype.StopRefreshButtonAnim = function(Timer)
{
    clearTimeout(Timer.id);
    Timer.id = null;
    this.SetRotateRefreshButton(this.GetButtonRefreshIcon(Timer.button), 0);
}

QoEOnlineReportsViewController.prototype.OnlineNetflowGetViewModel = function()
{
    const views = this.Views.OnlineNetflow;
    const filterId = views.FiltersTableWidget.GetSelectedFilterId();

    let params = {};

    if(filterId)
    {
        let filters = views.Widgets.ExtendedFilter.GetFilters();

        const aggPeriod = parseInt(views.AggTimePeriod.getValue(), 10);

        if(!aggPeriod)
        {
            return null;
        }

        const windowWidth = parseInt(views.WindowWidth.getValue(), 10);

        filters = webix.extend(filters, {agg_period: aggPeriod, window_width: windowWidth}, true);

        var view_id = QoEOnlineViewsPrefixesEnum.OnlineNetflow + filterId;

        var table_id = this.view_id_table_id_map[view_id] ? this.view_id_table_id_map[view_id] : view_id;

        params = {
            view_id: view_id,
            table_id: table_id ,
            filters: filters,
            view: this.OnlineNetflowGetReportConfig(this.Id + "OnlineNetflow" + "RawReport").config.view,
            view_type:QoEOnlineViewsPrefixesEnum.OnlineNetflow
        };
    }

    return new QoEOnlineViewModel(params);
};

QoEOnlineReportsViewController.prototype.OnlineNetflowReplaceOnlineView = function(ViewModel=null)
{
    const _this = this;

    const filterId = this.Views.OnlineNetflow.FiltersTableWidget.GetSelectedFilterId();

    if (filterId)
    {
        this.Views.OnlineNetflow.CollectToolbar.disable();

        const model = ViewModel ? ViewModel : this.OnlineNetflowGetViewModel();

        this.ViewModel.ReplaceOnlineView(model, function(R)
        {
            _this.Views.OnlineNetflow.CollectToolbar.enable();

            if(!R.success)
            {
                _this.OnlineNetflowSetDisableState();
                webix.message({type:"error", text:R.error.msg});
                return;
            }

            if(R.data && R.data.rows.length)
            {
                R.data.rows.forEach(function (Item)
                {
                    var model = new QoEOnlineViewModel(Item);

                    _this.view_id_table_id_map[model.view_id] = model.table_id;
                });

                _this.OnlineNetflowConfigReports();
                _this.OnlineNetflowSetEnableState();
            }
        });
    }
};

QoEOnlineReportsViewController.prototype.OnlineNetflowCollectData = function(Enabled, ViewModel)
{
    const _this = this;

    Enabled = Enabled?1:0;
    ViewModel = ViewModel?ViewModel:this.OnlineNetflowGetViewModel(Enabled);

    if(ViewModel)
    {
        this.Views.OnlineNetflow.CollectToolbar.disable();

        this.ViewModel.EnableOnlineView(ViewModel, Enabled, function(R)
        {
            _this.Views.OnlineNetflow.CollectToolbar.enable();

            if(!R.success)
            {
                _this.OnlineNetflowSetDisableState();
                webix.message({type:"error", text:R.error.msg});
                return;
            }

            if(R.data && R.data.rows.length)
            {
                R.data.rows.forEach(function (Item)
                {
                    var model = new QoEOnlineViewModel(Item);

                    _this.view_id_table_id_map[model.view_id] = model.table_id;
                });

                _this.OnlineNetflowConfigReports();
                _this.OnlineNetflowSetEnableState();
            }
            else
            {
                _this.OnlineNetflowSetDisableState();
                _this.OnlineNetflowClearAllTimers();
            }
        });
    }
};

QoEOnlineReportsViewController.prototype.OnlineNetflowRefreshAllData = function()
{
    const _this = this;

    const selectedReport = this.OnlineNetflowGetReportsListSelectedItem();

    const selectedFilter = this.Views.OnlineNetflow.FiltersTableWidget.GetTableSelectedData();

    const period = this.SelectedAggTimePeriods.OnlineNetflow;

    if(!selectedReport || !selectedFilter || !period)
        return;

    const refresh = () => {
        if(this.QoEStorServerTimezoneOffset === null) {
            return;
        }

        const format = webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

        let filter = {
            period: {
                id: "time",
                operator: "between",
                value: [
                    format(webix.Date.add(period.start, this.QoEStorServerTimezoneOffset, "minute", true)),
                    format(webix.Date.add(period.end, this.QoEStorServerTimezoneOffset, "minute", true))
                ]
            }
        };

        const dpiFilter = this.GetDpiPickerState(this.Views.OnlineNetflow);

        if(dpiFilter)
            filter = webix.extend(filter, dpiFilter, true);

        const params = {filter, max_execution_time: this.GetMaxExecutionTime(period)};

        const reportId = this.OnlineNetflowGetReportsListSelectedId(selectedReport);

        const report = this.Views.OnlineNetflow.SubWidgets[reportId];

        const RefreshReport = function(Report, FunctionKey) {
            const config = _this.OnlineNetflowGetReportConfig(Report.Id);

            _this.OnlineNetflowSetCacheLifetime(config);

            const cache_id = Report.GetCachesIds();
            _this.CachesToDelete[cache_id] = cache_id;

            Report.RefreshData(parseInt(config.data ? config.data.page : 0, 10), params);

            const reportFuncConfig = _this.QoEOnlineNetflowReportsFunctionsEnum.find(func => func.id === FunctionKey);

            if(reportFuncConfig && reportFuncConfig.detailsPanelState === _this.QoEOnlineNetflowDetailsPanelStateEnum.show)
            {
                if(Report.GetSelectedData && typeof Report.GetSelectedData === "function")
                {
                    if(Report.GetSelectedData())
                    {
                        _this.OnlineNetflowRefreshDetailsPanel(_this.OnlineNetflowGetReportsListSelectedId());
                    }
                    else {
                        _this.Views.OnlineNetflow.EmptyDetailsReport.show();
                    }
                }

            }
        }

        if (report)
        {
            Object.keys(report).forEach(Key =>
            {
                const subWidget = report[Key];

                if (subWidget instanceof QoETableChartWidget)
                {
                    Object.keys(subWidget).forEach(Prop =>
                    {
                        if (subWidget[Prop] && subWidget[Prop].RefreshData)
                        {
                            RefreshReport(subWidget[Prop], Key);
                        }
                    });
                }
                else if (subWidget.RefreshData && typeof subWidget.RefreshData === "function")
                {
                    RefreshReport(subWidget, Key);
                }
            });
        }

        this.SetAllPathParam();
    }

    this.GetQoEStorServerTimezone(refresh);
};

QoEOnlineReportsViewController.prototype.GetQoEStorServerTimezone = function(Callback)
{
    const callback = Callback && typeof Callback === "function" ? Callback : () => {};

    if(this.QoEStorServerTimezoneOffset === null) {
        this.ViewModel.GetQoEStorServerTimezoneOffset((R) => {
            if(R.success) {
                const serverTimezoneOffset = R.data;
                const timezoneOffset = -((new Date()).getTimezoneOffset());

                this.QoEStorServerTimezoneOffset = serverTimezoneOffset - timezoneOffset;

                callback();
            }
        });
    }
    else {
        callback();
    }
};

QoEOnlineReportsViewController.prototype.OnlineNetflowFiltersTableRowsSelectedCountSubscriptionHandler = function(Value)
{
    const _this = this;

    const views = this.Views.OnlineNetflow;

    if(Value != 1) {
        _this.OnlineNetflowSetDisableState();
        return;
    }

    const filterId = _this.Views.OnlineNetflow.FiltersTableWidget.GetSelectedFilterId();

    this.OnlineNetflowClearAllTimers();

    if(!filterId) {
        _this.OnlineNetflowSetDisableState();
        return;
    }

    let availableAggPeriod = _this.OnlineNetflowGetAggPeriodAvailableValue();

    if(!availableAggPeriod)
    {
        _this.OnlineNetflowSetDisableState();
    }
    else
    {
        const view_id = QoEOnlineViewsPrefixesEnum.OnlineNetflow + filterId;

        this.ViewModel.ReplaceUnAvailableAggPeriod(new QoEOnlineViewModel({view_id}), availableAggPeriod, function (R)
        {
            if (!R.success)
            {
                _this.OnlineNetflowSetDisableState();
                return;
            }

            if (R.data && R.data.rows.length)
            {
                const filters = JSON.parse(R.data.rows[0].filters);

                R.data.rows.forEach(function (Item)
                {
                    var model = new QoEOnlineViewModel(Item);

                    _this.view_id_table_id_map[model.view_id] = model.table_id;
                });

                views.AggTimePeriod.setValue(filters.agg_period);
                views.WindowWidth.setValue(filters.window_width);

                _this.OnlineNetflowConfigReports();

                _this.OnlineNetflowSetEnableState();
            }
            else
            {
                _this.OnlineNetflowSetDisableState();

                _this.OnlineNetflowDestroySubWidgets();
                _this.Views.OnlineNetflow.SubWidgets = {};

                const wizardState = _this.Views.OnlineNetflow.FiltersTableWidget.GetWizardState();
                if(wizardState && wizardState.values) {
                    _this.OnlineNetflowCollapsePanels();
                    if(wizardState.values.login || wizardState.values.subscriber) {
                        _this.OnlineNetflowSelectReportListItem(_this.Id + "OnlineNetflow" + "ReportsCells" + "TrafficByAppProtocols");
                    }
                    else {
                        _this.OnlineNetflowSelectReportListItem(_this.Id + "OnlineNetflow" + "ReportsCells" + "TopSubscribersTrafficShortReport");
                    }
                    _this.Views.OnlineNetflow.FiltersTableWidget.ResetWizardState();
                    _this.OnlineNetflowCollectData(true);
                }
            }
        });
    }
};

QoEOnlineReportsViewController.prototype.GetMaxExecutionTime = function(Period)
{
    const maxExecutionTime = (Period.end - Period.start) / 1000;
    return maxExecutionTime < 10?10:maxExecutionTime;
};

QoEOnlineReportsViewController.prototype.OnlineNetflowOnReportsListSelectionChanged = function()
{
    const data = this.OnlineNetflowGetReportsListSelectedItem();

    this.ReportsListSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

QoEOnlineReportsViewController.prototype.OnlineNetflowGetReportsListSelectedItem = function()
{
    return this.Views.OnlineNetflow.ReportsList.getSelectedItem();
};

QoEOnlineReportsViewController.prototype.OnlineNetflowGetReportsListSelectedId = function(Item)
{
    let selectedReport = Item;

    if(!selectedReport) {
        selectedReport = this.OnlineNetflowGetReportsListSelectedItem();

        return selectedReport && selectedReport.id ? Helper.ReplaceAll(["Group", this.Id + "OnlineNetflow" + "ReportsCells"], "", selectedReport.id) : null;
    }

    return Helper.ReplaceAll(["Group", this.Id + "OnlineNetflow" + "ReportsCells"], "", selectedReport.id);
};

QoEOnlineReportsViewController.prototype.OnlineNetflowGetReportConfig = function(ReportId)
{
    return this.ViewModel.GetReportConfig(ReportId);
};

QoEOnlineReportsViewController.prototype.OnlineNetflowSetCacheLifetime = function(Report)
{
    const period = this.SelectedAggTimePeriods.OnlineNetflow;

    Report.config.cache.lifetime_sec = (period.end - period.start) / 1000 * 6;
};

QoEOnlineReportsViewController.prototype.OnlineNetflowIsNeedHideDetailsPanel = function(DisplayedReport)
{
    const id = this.OnlineNetflowGetReportsListSelectedId(DisplayedReport);

    const foundWidget = this.QoEOnlineNetflowReportsFunctionsEnum.find(widget => widget.id == id);

    if(foundWidget.detailsPanelState === this.QoEOnlineNetflowDetailsPanelStateEnum.hide) {
        this.Views.OnlineNetflow.DetailsPanelHeader.hide();
        this.Views.OnlineNetflow.DetailsPanel.hide();
        this.Views.OnlineNetflow.DetailsResizer.disable();
    }
    else {
        this.Views.OnlineNetflow.DetailsPanelHeader.show();
        this.Views.OnlineNetflow.DetailsPanel.show();
        this.Views.OnlineNetflow.DetailsResizer.enable();
    }
};

QoEOnlineReportsViewController.prototype.OnlineNetflowSelectReportListItem = function(ReportId)
{
    this.Views.OnlineNetflow.ReportsList.select(ReportId);
    this.Views.OnlineNetflow.ReportsList.open(this.Views.OnlineNetflow.ReportsList.getParentId(ReportId), true);
};

QoEOnlineReportsViewController.prototype.GetDpiPickerState = function(View)
{
    let filter = null;

    const val = View.DpiPicker.getValue();

    if(val)
    {
        const vals = val.split(",");

        let ipfix_ids = {};

        let dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);

        vals.every(function (Val)
        {
            if(Val == "-2")
            {
                return false;
            }

            let hwId = Val;

            if(Val == "-1")
            {
                hwId = App.SessionManager.GetCurrentHardwareId();
            }

            if(dic && dic[hwId] && dic[hwId].ipfix_id !== null && dic[hwId].ipfix_id !== undefined)
            {
                ipfix_ids[dic[hwId].ipfix_id] = 1;
            }

            return true;
        });

        if(Object.keys(ipfix_ids).length)
        {
            const fValue = [];

            Object.keys(ipfix_ids).forEach(function (Val)
            {
                fValue.push(parseInt(Val,10));
            });

            filter = {
                dpi_id:{
                    id:"dpi_id",
                    operator:"in",
                    value: fValue
                }
            };
        }
    }

    return filter;
};

QoEOnlineReportsViewController.prototype.OnlineNetflowTableReportRowsSelectedCountHandler = function()
{
    const _this = this;

    const _disableAll = function() {
        _this.Views.OnlineNetflow.DetailsPanel.disable();
        _this.Views.OnlineNetflow.EmptyDetailsReport.show();
    };

    const selectedId = _this.OnlineNetflowGetReportsListSelectedId();

    if(!selectedId) {
        _disableAll();
        return;
    }

    const selectedData = _this.OnlineNetflowGetTableReportSelectedData(selectedId);

    if(!selectedData) {
        _disableAll();
        return;
    }

    if(selectedData) {
        this.OnlineNetflowRefreshDetailsPanel(selectedId);
        this.Views.OnlineNetflow.DetailsPanel.enable();
        if($$(this.Id + "OnlineNetflow" + "DetailsPanel" + "RawLogReport")) {
            $$(this.Id + "OnlineNetflow" + "DetailsPanel" + "RawLogReport").show();
        }
    }
};

QoEOnlineReportsViewController.prototype.OnlineNetflowRefreshDetailsPanel = function(Key)
{
    const period = this.SelectedAggTimePeriods.OnlineNetflow;

    if(!period)
        return;

    const refresh = () => {
        if(this.QoEStorServerTimezoneOffset === null) {
            return;
        }

        const format = webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

        let filter = {
            period:{
                id: "time",
                operator: "between",
                value: [
                    format(webix.Date.add(period.start, this.QoEStorServerTimezoneOffset, "minute", true)),
                    format(webix.Date.add(period.end, this.QoEStorServerTimezoneOffset, "minute", true))
                ]
            }
        };

        const extendedFilters = this.Views.OnlineNetflow.Widgets.ExtendedFilter.GetFilters();

        Object.keys(extendedFilters).forEach(function(Key) {
            if(extendedFilters[Key].sql_type == QoEFilterSqlType.having)
                delete extendedFilters[Key];
        });

        filter = webix.extend(filter, extendedFilters, true);

        const cache_id = this.Views.OnlineNetflow.Widgets.RawLogReport.GetCachesIds();
        this.CachesToDelete[cache_id] = cache_id;

        const selectedReportData = this.OnlineNetflowGetTableReportSelectedData(Key);

        let report = null;
        const subWidget = this.Views.OnlineNetflow.SubWidgets[Key];

        Object.keys(subWidget).forEach(Widget => {
            if (subWidget[Widget] instanceof QoETableChartWidget) {
                const tableReportId = subWidget[Widget].TableWidget.Id;
                report = this.ViewModel.GetReportConfig(tableReportId);
            }
            else if(subWidget[Widget].GetSelectedData && typeof subWidget[Widget].GetSelectedData === "function") {
                report = this.ViewModel.GetReportConfig(subWidget[Widget].Id);
            }
        });

        const remember_field = report.config.remember_field;

        if(selectedReportData && remember_field && selectedReportData.hasOwnProperty(remember_field.alias)) {
            let subsFilter = {};

            const obj = {
                id: remember_field.func,
                operator: "=",
                value: selectedReportData[remember_field.alias]
            };

            const hash = Helper.HashCode(JSON.stringify(obj));

            subsFilter[hash] = obj;

            filter = webix.extend(filter, subsFilter, true);
        }

        const params = {filter:filter, max_execution_time: this.GetMaxExecutionTime(period)};

        const config = this.OnlineNetflowGetReportConfig(this.Views.OnlineNetflow.Widgets.RawLogReport.Id);
        this.OnlineNetflowSetCacheLifetime(config);

        this.Views.OnlineNetflow.Widgets.RawLogReport.RefreshData(0, params);
    }

    this.GetQoEStorServerTimezone(refresh);
};

QoEOnlineReportsViewController.prototype.OnlineNetflowGetTableReportSelectedData = function(WidgetKey)
{
    let data;
    const widget = this.Views.OnlineNetflow.SubWidgets[WidgetKey];

    Object.keys(widget).forEach(Key => {
        if (widget[Key] instanceof QoETableChartWidget) {
            data = widget[Key].TableWidget.GetSelectedData();
        }
        else if (widget[Key].GetSelectedData && typeof widget[Key].GetSelectedData == "function") {
            data = widget[Key].GetSelectedData();
        }
    });

    return data;
};

QoEOnlineReportsViewController.prototype.SetAggTimePeriod = function(View)
{
    const period = this.GetAggTimePeriod(View);

    if(!period || !period.start || !period.end)
        return;

    this.SelectedAggTimePeriods[View] = period;
};

QoEOnlineReportsViewController.prototype.GetAggTimePeriod = function(View)
{
    const period = this.Views[View].AggTimePeriod.getValue();

    if(!period) {
        return null;
    }

    const windowWidth = this.Views[View].WindowWidth.getValue();

    const startDate = new Date();
    startDate.setSeconds(startDate.getSeconds() - period * windowWidth);

    return {
        id: period,
        start: startDate,
        end: new Date()
    };
};

QoEOnlineReportsViewController.prototype.ShowIfNeedCollectConfirmForm = function(Node, Pos)
{
    const selectedFilterId = this.Views.OnlineNetflow.FiltersTableWidget.GetSelectedFilterId();

    if (selectedFilterId)
    {
        const filters = this.Views.OnlineNetflow.Widgets.ExtendedFilter.GetFilters();

        if (!Object.keys(filters).length)
        {
            this.Views.CommonViews.CollectConfirmForm.show(Node, Pos);
        }
        else {
            this.OnlineNetflowCollectData(true);
        }
    }
};

QoEOnlineReportsViewController.prototype.GetHelpButtonTemplate = function(ButtonId, ClickHandler)
{
    return {
        view:"button",
        id:ButtonId,
        type:"icon",
        icon:"question-circle",
        css:"toolbar_round_btn",
        width:32,
        tooltip:LangHelper.GetString("QoE", "Help"),
        click: ClickHandler
    }
};

QoEOnlineReportsViewController.prototype.ShowHelpButtonPopup = function(Node, Pos, TextConfig)
{
    this.Views.CommonViews.HelpButtonPopupText.setValues(TextConfig.text);
    this.Views.CommonViews.HelpButtonPopup.define("height", TextConfig.height);
    this.Views.CommonViews.HelpButtonPopup.resize();
    this.Views.CommonViews.HelpButtonPopup.show(Node, Pos);
};

QoEOnlineReportsViewController.prototype.ShowReportSettingsPopup = function(Node, Pos)
{
    this.Views.CommonViews.ReportRefreshRate.setValue(this.GetReportRefreshRateId());
    this.Views.CommonViews.ReportSettingsPopup.show(Node, Pos);
};

QoEOnlineReportsViewController.prototype.GetReportRefreshRateId = function()
{
    const uname = App.SessionManager.currentLogin;
    const refreshRate = webix.storage.local.get(this.Id + "SelectedRefreshRateId" + uname);

    return refreshRate?refreshRate:this.DefaultReportRefreshRateId;
};

QoEOnlineReportsViewController.prototype.ReportSettingsPopupApplyHandler = function()
{
    let section = $$(this.Id + "SectionsTabs").getValue();
    section = Helper.ReplaceAll([this.Id, "SectionsTabs"], "", section);

    const uname = App.SessionManager.currentLogin;
    webix.storage.local.put(this.Id + "SelectedRefreshRateId" + uname, this.Views.CommonViews.ReportRefreshRate.getValue());

    this.OnlineNetflowClearAllTimers();
    this.SetAggTimePeriod(section);
    this.OnlineNetflowRefreshAllData();

    this.Views.CommonViews.ReportSettingsPopup.hide();
};

QoEOnlineReportsViewController.prototype.DpiPickerOptionsUpdate = function(TabName)
{
    const opt =
        [
            {id:"-2", value:LangHelper.GetString("QoE","For all DPI devices")},
            {id:"-1", value:LangHelper.GetString("QoE","Current DPI device")}
        ];

    let hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

    hws = hws.filter(function (Obj)
    {
        return Obj.hardware_type == HardwareTypesEnum.dpi;
    });

    hws.forEach(function (Hw)
    {
        opt.push({id:Hw.dic_id, value:Hw.value});
    });

    const list = this.Views[TabName].DpiPicker.getList();
    list.clearAll();
    list.parse(opt);
};

QoEOnlineReportsViewController.prototype.ClearCache = function(ActionId, Message)
{
    let params = {};

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllUsersCache)
        params.drop_all_caches = 1;

    if(ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearCurrentReportCache ||
        ActionId == QoEClearCacheBtnWidgetStatesEnum.ClearAllSectionReports) {
        params.caches_ids = Object.keys(this.CachesToDelete);
        this.CachesToDelete = {};
        if(!params.caches_ids.length) {
            return;
        }
    }

    this.ViewModel.ClearCache(function (R)
    {
        if(R&&R.success) {
            if(Message) {
                webix.message(Message);
            }
        }
    }, params);
};

QoEOnlineReportsViewController.prototype.KillProcesses = function(ActionId)
{
    const params = {};

    if(ActionId == QoEKillProcessesBtnWidgetStatesEnum.KillAllUsersProcesses)
        params.kill_all_processes = 1;

    this.ViewModel.KillAllProcesses(function (R)
    {
        if(R&&R.success)
            webix.message(LangHelper.GetString("QoE", "All queries are canceled"))
    },params);
};

QoEOnlineReportsViewController.prototype.CheckQoEStorVersionCompatibility = function()
{
    this.ViewModel.CheckQoEStorVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("QoE", "QoE Stor version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }
    });
};

QoEOnlineReportsViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

QoEOnlineReportsViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

QoEOnlineReportsViewController.prototype.SetAllPathParam = function()
{
    const section = this.Views.SectionsTabs.getValue();
    this.SetPathParam("section", section && section == this.SectionsEnum.of ? "of" : "of");

    const of_report = this.OnlineNetflowGetReportsListSelectedItem().id;
    if(of_report) {
        this.SetPathParam("of_report", of_report);
    }

    const of_dpi = this.Views.OnlineNetflow.DpiPicker.getValue();
    if(of_dpi) {
        this.SetPathParam("of_dpi", of_dpi);
    }

    const of_filter = this.Views.OnlineNetflow.FiltersTableWidget.GetSelectedFilterId();
    if(of_filter) {
        this.SetPathParam("of_filter", of_filter);
    }

    this.JustNavigate();
};

QoEOnlineReportsViewController.prototype.GetAllPathParam = function()
{
    try
    {
        const section = this.GetPathParam("section");
        this.Views.SectionsTabs.setValue(section && this.SectionsEnum[section] ? this.SectionsEnum[section] : this.SectionsEnum.of);

        const of_report = this.GetPathParam("of_report");
        this.OnlineNetflowSelectReportListItem(of_report);

        const of_dpi = this.GetPathParam("of_dpi");
        this.Views.OnlineNetflow.DpiPicker.setValue(of_dpi?of_dpi:"-2");

        const of_filter = this.GetPathParam("of_filter");
        this.Views.OnlineNetflow.FiltersTableWidget.Select(of_filter);
    }
    catch(e){}
};

QoEOnlineReportsViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

QoEOnlineReportsViewController.prototype.GetFilterStateConfig = function()
{
    const section = this.Views.SectionsTabs.getValue();

    const type = section && section == this.SectionsEnum.of ? "OnlineNetflow" : "OnlineNetflow";

    return {
        filter_state:this.Views[type].Widgets.ExtendedFillter.GetState(),
        filter_config: this.Views[type].Widgets.ExtendedFillter.GetFilters()
    };
};

QoEOnlineReportsViewController.prototype.GetPeriodState = function()
{
    const section = this.Views.SectionsTabs.getValue();

    const type = section && section == this.SectionsEnum.of ? "OnlineNetflow" : "OnlineNetflow";

    const period = this.GetAggTimePeriod(type);

    const format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    return {
        period_from:format(period.start),
        period_to:format(period.end)
    };
};
QoEReportSettingsSavedSettingsTable = function(Params)
{
    let params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"ReportSettingsSavedSettingsTable",
        hideExport:true,
        editable:true,
        customPaginatorToolbar: Params && Params.customPaginatorToolbar ? Params.customPaginatorToolbar : null,
        config:{
            method:function ()
            {
                return "GetQoEReportSettings";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: [
            {
                id: "edit",
                header: "",
                width: 32,
                template: CellEditBtnTemplate,
                tooltip: LangHelper.GetString("QoE", "Edit"),
            },
            {
                id:"title",
                header: [LangHelper.GetString("QoEPopupFilterWidget", "Title"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                filterMap: {
                    id: "title",
                    operator: "like",
                    value: function(Val)
                    {
                        return "%"+Val+"%";
                    }
                },
                editor: "text",
                fillspace:1,
            },
            {
                id: "delete",
                header: "",
                width: 32,
                template: CellTrashBtnTemplate,
            }
        ],
        on:{},
        rules:{},
        defaultPageSize:-10
    };

    return new QoETableReportWidget(params);
};

QoEReportSettingsHistorySettingsTable = function(Params)
{
    let params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"ReportSettingsHistorySettingsTable",
        select:"row",
        hideExport:true,
        customPaginatorToolbar: Params && Params.customPaginatorToolbar ? Params.customPaginatorToolbar : null,
        config:{
            method:function ()
            {
                return "GetQoEReportSettings";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: [
            {
                id:"update_time",
                header:[
                    LangHelper.GetString("DpiConfig", "Date"),
                    {content: "dateRangeFilter", contentId:"update_time", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                template: LocalTimeZone,
                enableDateRangeFilter:1,
                sort:"date",
                fillspace:1,
            }
        ],
        on:{},
        rules:{},
        defaultPageSize:-10
    };

    return new QoETableReportWidget(params);
};

QoEReportsSettingsWidget = function (ViewConfig)
{
    let _this = this;

    this.Id = ViewConfig && ViewConfig.id ? ViewConfig.id : "ReportsSettingsWidget";

    this.ViewModel = new QoEReportsSettingsManager();

    this.ReportsModel = new UniReportsManager();

    this.QoEStorConfigManager = new QoEStorConfigManager();

    this.Views = {
        GeneralSettings: {
            SettingsBtn:null,
            SettingsMenu:null
        },
        ReportSettings: {
            SettingsPopup:null,
            SettingsForm:null,
            AddNewSavedSettingBtn: null,
            SaveSettingsBtn:null,
            SavedSettingsLabel:null,
            Tabbar: null
        },
        ReportsWidgets: {
            SavedSettingsTable: QoEReportSettingsSavedSettingsTable(),
            HistorySettingsTable: QoEReportSettingsHistorySettingsTable(),
        }
    };

    this.GeneralSettingsBtnViewConfig = {
        view:"button",
        id:this.Id + "GeneralSettings" + "SettingsBtn",
        type:"icon",
        icon:"angle-down",
        css: "toolbar_round_btn toolbar_btn_as_menu",
        width: 14,
        borderless: true,
        click: function(){
            if(_this.Views.GeneralSettings.SettingsMenu.isVisible())
                _this.Views.GeneralSettings.SettingsMenu.hide();
            else
                _this.Views.GeneralSettings.SettingsMenu.show(this.getNode(), {pos: "bottom"});
        }
    };

    this.GeneralSettingsPopupViewConfig = {
        id:this.Id + "GeneralSettings" + "SettingsMenu",
        view:"submenu",
        width:400,
        autoheight:true,
        select:false,
        data:[
            {
                id:GeneralReportSettingsEnum.reports_manual_refresh.id,
                value:GeneralReportSettingsEnum.reports_manual_refresh.value,
                enabled: _this.getInitialManualRefreshState(GeneralReportSettingsEnum.reports_manual_refresh.id),
                disabled: AppEnv.EnableManualUpdateReportsQoEDefault
            },
            {
                id:GeneralReportSettingsEnum.create_report_task.id,
                value:GeneralReportSettingsEnum.create_report_task.value,
            }
        ],
        template: function(Obj) {
            let res = "";
            if(Object.hasOwn(Obj, "enabled"))
                res += "<span class='check webix_icon fa-"+(Obj.enabled?"check-":"")+"square-o'></span>";
            res += Obj.value;
            return res;
        },
        on: {
            onMenuItemClick: function(id){
                if(id === GeneralReportSettingsEnum.reports_manual_refresh.id)
                {
                    let item = this.getItem(id);
                    item.enabled = item.enabled ? 0 : 1;
                    _this.ViewModel.WriteToStorage(
                        GeneralReportSettingsEnum.reports_manual_refresh.id,
                        item.enabled
                    );
                    this.refresh();
                }
                else
                {
                    this.hide();
                }
            }
        }
    };

    let SectionLabelWidth = 200;

    let ReportSettingsSectionsViewConfigs = [
        {
            section_name: ReportSettingsEnum.group_by.section_name,
            form_element: {
                view: "multiselect",
                name: ReportSettingsEnum.group_by.id,
                label: LangHelper.GetString("AppView", "Group by"),
                labelWidth: SectionLabelWidth,
                suggest: {
                    fitMaster: false, data:[]},
                on: {
                    onChange: function(nV, oV)
                    {
                        // The last checked cannot be removed
                        if(!nV && oV)
                        {
                            let options = this.getList();
                            if (options && options.config && options.config.data)
                            {
                                let selected =  options.config.data.filter(item => item.$checked);
                                if(selected.length === 0)
                                {
                                    this.setValue(oV);
                                }
                            }
                        }

                        let getSelected = function (El) {
                            let list = El.getValue();
                            if (typeof list === "string")
                                list = list.split(",");
                            return list;
                        }

                        let model = _this.SelectedReportSettingsModel;
                        let form = _this.Views.ReportSettings.SettingsForm;

                        let groupColsSelect = form.elements[ReportSettingsEnum.group_by.id];
                        let groupColsList = groupColsSelect.getList();
                        let groupColsDefault = model.default_common_state.group_by;
                        let groupColsState = groupColsList.serialize();
                        let groupColsSelected = getSelected(groupColsSelect);

                        let showColsSelect = form.elements[ReportSettingsEnum.columns_to_show.id];
                        let showColsList = showColsSelect.getList();
                        let showColsState = showColsList.serialize();
                        let showColsSelected  = getSelected(showColsSelect);

                        // sorting selected items in select
                        this.blockEvent();
                        this.setValue(
                            groupColsState.filter(I => I.$checked).map(I => I.id).sort((a, b) => {
                                const ia = groupColsDefault.indexOf(a);
                                const ib = groupColsDefault.indexOf(b);
                                return ia - ib;
                            })
                        );
                        this.unblockEvent();

                        // select which elmnts select/unselect
                        let disabledIds = showColsState.filter(I => I.disabled).map(I => I.id);

                        let onlyGroupCols = showColsSelected.filter(I => groupColsDefault.includes(I));
                        let onlyShowCols = showColsSelected.filter(I => !groupColsDefault.includes(I));

                        let toSelect = [];

                        groupColsDefault.forEach(I => {
                            if(groupColsSelected.includes(I) && onlyGroupCols.includes(I))
                                toSelect.push(I);
                            else if(groupColsSelected.includes(I) && !onlyGroupCols.includes(I) && disabledIds.includes(I))
                                toSelect.push(I);
                        });

                        // disabling elements of columns to show select list
                        showColsState.forEach(Item => {
                            if(groupColsDefault.includes(Item.id))
                            {
                                if(groupColsState.filter(I => I.$checked).map(I => I.id).includes(Item.id))
                                {
                                    delete Item.disabled;
                                    delete Item.$css;
                                }
                                else
                                {
                                    Item.disabled = 1;
                                    Item.$css = "webix_disabled";
                                }
                                showColsList.updateItem(Item.id, Item);
                            }
                        });

                        toSelect = toSelect.concat(onlyShowCols);
                        showColsSelect.setValue(toSelect);
                    }
                }
            },
            help_btn_text:LangHelper.GetString("QoE", "The setting allows to select which field will be used to group the report.")
        },
        {
            section_name: ReportSettingsEnum.columns_to_show.section_name,
            form_element: {
                view: "multiselect",
                name: ReportSettingsEnum.columns_to_show.id,
                label: LangHelper.GetString("AppView", "Columns visibility"),
                labelWidth: SectionLabelWidth,
                suggest: {
                    fitMaster: false,
                    body: {
                        scheme: {
                            $init: function (obj) {
                                if (obj.disabled) {
                                    obj.$css = "webix_disabled";
                                }
                            }
                        }
                    }
                },
                on: {
                    onChange: function(nV, oV)
                    {
                        if(!nV && oV)
                        {
                            const selected = this.getList()
                                .serialize()
                                .filter(item => item.$checked);

                            if(selected.length < 1)
                                this.setValue(oV);
                        }

                        if(nV) {
                            const list = this.getList();

                            if (typeof nV === "string")
                                nV = nV.split(",");

                            nV = nV.filter(id => {
                                const item = list.getItem(id);
                                if (!item) return true;
                                return !item.disabled;
                            });

                            this.setValue(nV.join(","));
                        }
                    }
                }
            },
            help_btn_text:LangHelper.GetString("QoE", "The setting allows to choose which data columns will be visible in the report.")
        },
        {
            section_name: ReportSettingsEnum.enable_series.section_name,
            form_element: {
                view: "multiselect",
                name: ReportSettingsEnum.enable_series.id,
                label: LangHelper.GetString("QoE", "Items visibility"),
                labelWidth: SectionLabelWidth,
                suggest: {fitMaster: false, data:[]},
                on: {
                    onChange: function(nV, oV)
                    {
                        if (!nV && oV)
                        {
                            let options = this.getList();
                            if (options && options.config && options.config.data)
                            {
                                let selected =  options.config.data.filter(item => item.$checked);
                                if (selected.length === 0)
                                {
                                    this.setValue(oV);
                                }
                            }
                        }
                    }
                }
            },
            help_btn_text: LangHelper.GetString("QoE", "The setting allows to control the visibility of series or chart elements.")
        },
        {
            section_name: ReportSettingsEnum.agg_period.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.agg_period.id,
                label: LangHelper.GetString("AppView", "Chart step"),
                labelWidth: SectionLabelWidth,
                suggest: {fitMaster: false, data: []}
            },
            help_btn_text: LangHelper.GetString("QoE", "The setting determines the interval or step between values on the graph.")
        },
        {
            section_name: ReportSettingsEnum.rows_limit.section_name,
            form_element: {
                view: "text",
                name: ReportSettingsEnum.rows_limit.id,
                label: "",
                labelWidth: SectionLabelWidth,
                on: {
                    onChange:function(nV, oV)
                    {
                        let val = parseInt(nV);
                        this.setValue(Number.isNaN(val) ? oV : (val < 1 ? 1 : val));
                    }
                }
            },
            help_btn_text:LangHelper.GetString("QoE", "The setting allows you to set a limit on the number of data rows displayed in the report.")
        },
        {
            section_name: ReportSettingsEnum.graph_line_type.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.graph_line_type.id,
                label: LangHelper.GetString("QoE", "Chart type"),
                labelWidth: SectionLabelWidth,
                suggest: {
                    fitMaster: false,
                    data: Helper.DictToArr(ChartTypesDic)
                },
                on: {
                    onChange: function(nV, oV) {
                        _this.ScaleOptionsHandler();
                    }
                }
            },
            help_btn_text:LangHelper.GetString("QoE", "The setting determines chart type.")
        },
        {
            section_name: ReportSettingsEnum.chart_scale_type.section_name,
            form_element: {
                view:"richselect",
                name: ReportSettingsEnum.chart_scale_type.id,
                label: LangHelper.GetString("QoE","Scale type"),
                labelWidth: SectionLabelWidth,
                suggest:{
                    fitMaster:false,
                    data: Helper.DictToArr(ChartScalesDic)
                },
                on:{
                    onAfterRender:function(){
                        const selectView = this;
                        let list = selectView.getPopup().getList();

                        if(list.$_guardAttached)
                            return;

                        list.$_guardAttached = true;

                        list.attachEvent("onBeforeSelect", function(id){
                            const item = this.getItem(id);
                            if (item && item.disabled) {
                                const cur = selectView.getValue();
                                webix.delay(() => selectView.setValue(cur));
                                return false;
                            }
                            return true;
                        });

                        selectView.attachEvent("onChange", function(nV, oV){
                            const it = list.getItem(nV);
                            if (it && it.disabled) {
                                selectView.blockEvent();
                                selectView.setValue(oV);
                                selectView.unblockEvent();
                            }
                        });
                    }
                }
            },
            help_btn_text:LangHelper.GetString("QoE", "The setting determines chart scale type.")
        },
        {
            section_name: ReportSettingsEnum.chart_order_by.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.chart_order_by.id,
                label: LangHelper.GetString("AppView", "Order by"),
                labelWidth: SectionLabelWidth,
                suggest: {fitMaster: false, data: []}
            },
            help_btn_text: LangHelper.GetString("QoE", "The setting determines the sorting field for the chart series.")
        },
        {
            section_name: ReportSettingsEnum.chart_sort_dir.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.chart_sort_dir.id,
                label: LangHelper.GetString("AppView", "Sort direction"),
                labelWidth: SectionLabelWidth,
                suggest:{
                    fitMaster:false,
                    data: Helper.DictToArr(SortDirectionSettingsEnum)
                }
            },
            help_btn_text: LangHelper.GetString("QoE", "The setting determines the direction of sorting field for the chart series.")
        },
        {
            section_name: ReportSettingsEnum.sort_id.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.sort_id.id,
                label: LangHelper.GetString("AppView", "Order by"),
                labelWidth: SectionLabelWidth,
                suggest: {fitMaster: false, data: []}
            },
            help_btn_text: LangHelper.GetString("QoE", "The setting determines the sorting field.")
        },
        {
            section_name: ReportSettingsEnum.sort_dir.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.sort_dir.id,
                label: LangHelper.GetString("AppView", "Sort direction"),
                labelWidth: SectionLabelWidth,
                suggest: {
                    fitMaster:false,
                    data: Helper.DictToArr(SortDirectionSettingsEnum)
                }
            },
            help_btn_text: LangHelper.GetString("QoE", "The setting determines the direction of sorting.")
        },
        {
            section_name: ReportSettingsEnum.report_name.section_name,
            form_element: {
                view: "text",
                name: ReportSettingsEnum.report_name.id,
                label: LangHelper.GetString("QoE", "Report name"),
                labelWidth: SectionLabelWidth
            },
            help_btn_text:LangHelper.GetString("QoE", "The setting allows to specify the name of the PDF report.")
        },
        {
            section_name: ReportSettingsEnum.display_filter.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.display_filter.id,
                label: LangHelper.GetString("UlrModule", "Display filter"),
                labelWidth: SectionLabelWidth,
                suggest: {
                    fitMaster:false,
                    data: Helper.DictToArr(ControlTaskStatusesDic)
                }
            },
            help_btn_text:LangHelper.GetString("QoE", "The setting allows to choose whether the data filter will be displayed on the PDF report.")
        },
        {
            section_name: ReportSettingsEnum.page_orientation.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.page_orientation.id,
                label: LangHelper.GetString("UlrModule","Page orientation"),
                labelWidth: SectionLabelWidth,
                suggest: {
                    fitMaster:false,
                    data: Helper.DictToArr(OrientationDic)
                }
            },
            help_btn_text:LangHelper.GetString("QoE", "The setting allows to select the page orientation (portrait, landscape) for the report. Auto mode selects orientation depending on the amount of data.")
        },
        {
            section_name: ReportSettingsEnum.y_axis_detail_level.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.y_axis_detail_level.id,
                label: LangHelper.GetString("AppView","Y axis detalization"),
                labelWidth: SectionLabelWidth,
                suggest: {
                    fitMaster:false,
                    data: Helper.DictToArr(ChartYScaleDetailsLevelDic)
                },
                on: {
                    onChange: function(nV, oV) {
                        _this.ScaleOptionsHandler();
                    }
                }
            },
            help_btn_text:LangHelper.GetString("QoE", "The setting allows to control the detalization of the Y axis. Available options: Auto, Low, Medium, High. They differ by the number of tick marks displayed on the Y axis.")
        },
        {
            section_name: ReportSettingsEnum.display_legend_stat.section_name,
            form_element: {
                view: "richselect",
                name: ReportSettingsEnum.display_legend_stat.id,
                label: LangHelper.GetString("AppView","Series metrics"),
                labelWidth: SectionLabelWidth,
                suggest: {
                    fitMaster:false,
                    data: Helper.DictToArr(YesNoDic)
                }
            },
            help_btn_text:LangHelper.GetString("QoE", "Displays the minimum, maximum, and average values for each series in the chart legend.")
        }
    ];

    let HelpBtnConfig = {
        view:"button",
        type:"icon",
        icon:"question-circle",
        css:"toolbar_round_btn",
        width:32,
        popup:{
            view:"popup",
            body:{
                borderless:true,
                template:""
            }
        }
    };

    let SettingsFormViewConfig = {
        view:"form",
        id:this.Id + "ReportSettings" + "SettingsForm",
        elements:function()
        {
            let formSections = [];

            ReportSettingsSectionsViewConfigs.forEach(item => {
                let formElConfig = item.form_element;
                let helpBtnConfig = webix.copy(HelpBtnConfig);
                let sectionName = item.section_name;

                if(sectionName === ReportSettingsEnum.report_name.section_name)
                {
                    formSections.push(
                        BlockHeaderTemplate({
                            title: "PDF " + LangHelper.GetString("QoE","Report settings").toLowerCase(),
                            icon: "file-pdf",
                        }),
                    );
                }

                if(formElConfig && Object.keys(formElConfig).length && helpBtnConfig && sectionName)
                {
                    helpBtnConfig.popup.body.template = item.help_btn_text;

                    formSections.push({
                        id: _this.Id + "ReportSettings" + sectionName,
                        hidden:true,
                        cols: [
                            formElConfig,
                            helpBtnConfig
                        ]
                    });
                    _this.Views.ReportSettings[sectionName] = null;
                }
            });

            formSections.push({});

            return formSections;
        }()
    };

    this.SettingsPopupViewConfig = {
        view:"popup",
        id:this.Id + "ReportSettings" + "SettingsPopup",
        maxWidth:840,
        maxHeight:640,
        modal:true,
        position:{
            my: "center",
            at: "center",
            of: webix.viewport
        },
        body: {
            borderless:true,
            rows: [
                {
                    cols: [
                        {
                            width: 300,
                            minWidth: 300,
                            rows: [
                                {
                                    view:"tabbar",
                                    id:this.Id + "ReportSettings" + "Tabbar",
                                    multiview:true,
                                    options:[
                                        {
                                            value:BlockHeaderTemplate().template({
                                                title:LangHelper.GetString("QoEPopupFilterWidget", "Saved"),
                                                icon:"save"
                                            }),
                                            id:this.Id + "ReportSettings" + "SavedSettingsTabView",
                                        },
                                        {
                                            value:BlockHeaderTemplate().template({
                                                title:LangHelper.GetString("QoEPopupFilterWidget", "History"),
                                                icon:"history"
                                            }),
                                            id:this.Id + "Context" + "HistorySettingsTabView",
                                        }
                                    ]
                                },
                                {
                                    view:"multiview",
                                    cells:[
                                        {
                                            id:this.Id + "ReportSettings" + "SavedSettingsTabView",
                                            rows:[
                                                {
                                                    view:"toolbar",
                                                    height:42,
                                                    elements:[
                                                        {
                                                            view:"button",
                                                            id:this.Id + "ReportSettings" + "AddNewSavedSettingBtn",
                                                            type:"icon",
                                                            icon:"plus",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            tooltip:LangHelper.GetString("QoE", "Add"),
                                                            click:function (id, e, node)
                                                            {
                                                                _this.AddNewSavedSettings();
                                                            }
                                                        },
                                                        {},
                                                        {
                                                            view:"button",
                                                            id:this.Id + "ReportSettings" + "RefreshSavedSettingsBtn",
                                                            type:"icon",
                                                            icon:"refresh",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            tooltip:LangHelper.GetString("All", "Refresh"),
                                                            click:function (id, e, node)
                                                            {
                                                                if(_this.SelectedReportSettingsModel)
                                                                    _this.SelectedReportSettingsModel.selected_saved_setting_id = null;

                                                                _this.RefreshSavedTables();
                                                            }
                                                        }
                                                    ]
                                                },
                                                this.Views.ReportsWidgets.SavedSettingsTable.ViewConfig
                                            ]
                                        },
                                        {
                                            id:this.Id + "Context" + "HistorySettingsTabView",
                                            rows:[
                                                {
                                                    view: "toolbar",
                                                    height: 42,
                                                    elements: [
                                                        {},
                                                        {
                                                            view: "button",
                                                            id: _this.Id + "ReportSettings" + "RefreshHistorySettingsBtn",
                                                            type: "icon",
                                                            icon: "refresh",
                                                            css: "toolbar_round_btn",
                                                            width: 32,
                                                            tooltip:LangHelper.GetString("All", "Refresh"),
                                                            click: function (id, e, node)
                                                            {
                                                                _this.RefreshHistoryTables();
                                                            }
                                                        }
                                                    ]
                                                },
                                                this.Views.ReportsWidgets.HistorySettingsTable.ViewConfig
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            view:"resizer"
                        },
                        {
                            minWidth: 400,
                            rows:[
                                BlockHeaderTemplate({
                                    title:LangHelper.GetString("QoE", "Report settings"),
                                    icon:"list",
                                    height:40}),
                                {
                                    view:"toolbar",
                                    id:this.Id + "ReportSettings" + "SettingsToolbar",
                                    height: 42,
                                    elements: [
                                        {
                                            id:this.Id + "ReportSettings" + "SavedSettingsLabel",
                                            view:"label",
                                            align:"left",
                                            autoWidth:true,
                                            label:""
                                        },
                                        {},
                                        {
                                            id:this.Id + "ReportSettings" + "SaveSettingsBtn",
                                            view:"button",
                                            icon:"save",
                                            width:190,
                                            type:"form",
                                            hidden:true,
                                            labelPosition:"center",
                                            label:LangHelper.GetString("QoE", "Save settings"),
                                            click:function ()
                                            {
                                                let selected = _this.GetSelectedSavedItem();
                                                let formState = _this.GetReportSettingsState();

                                                if(selected)
                                                {
                                                    _this.SaveReportSettings(selected, formState);
                                                }
                                                else
                                                {
                                                    _this.AddNewSavedSettings(formState);
                                                }
                                            }
                                        },
                                        {
                                            view:"button",
                                            type:"icon",
                                            icon:"refresh",
                                            css:"toolbar_round_btn",
                                            tooltip:LangHelper.GetString("QoE", "Restore to default"),
                                            width:32,
                                            click:function()
                                            {
                                                _this.SetAllToDefault();
                                            }
                                        },
                                        {
                                            view:"button",
                                            type:"icon",
                                            icon:"question-circle",
                                            css:"toolbar_round_btn",
                                            width:32,
                                            popup:{
                                                view:"popup",
                                                body:{
                                                    borderless:true,
                                                    template:LangHelper.GetString("QoE", "Report settings allow to change the display of the report in the interface and exported reports.")
                                                }
                                            }
                                        },
                                        {width: 7}
                                    ]
                                },
                                {
                                    view:"scrollview",
                                    scroll:"y",
                                    body: {
                                        rows: [SettingsFormViewConfig]
                                    }
                                }
                            ]
                        },
                    ]
                },
                {
                    view:"form",
                    elements:[
                        {
                            cols:[
                                {
                                    gravity: 4
                                },
                                {
                                    view: "button",
                                    id: this.Id + "ReportSettings" + "CancelBtn",
                                    label: LangHelper.GetString("All", "Cancel"),
                                    click: function ()
                                    {
                                        _this.CancelReportSettings();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    id: this.Id + "ReportSettings" + "ApplyBtn",
                                    label: LangHelper.GetString("All", "Apply"),
                                    click: function ()
                                    {
                                        _this.ApplyReportSettings();
                                    }
                                },
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.RowsLimitSetctionLabels = {
        "QoETableReportWidget": LangHelper.GetString("AppView", "Rows limit"),
        "QoESeriesChartReportWidget": LangHelper.GetString("AppView", "Items limit"),
        "QoEPieChartReportWidget": LangHelper.GetString("AppView", "Items limit")
    };

    this.SelectedReportSettingsModel = null;

    this.AggPeriodValues = {
        "FULLFLOW_AGG_LOG_GROUP_TIME_INTERVAL": "",
        "CLICKSTREAM_AGG_LOG_GROUP_TIME_INTERVAL": ""
    };

    this.Signals = {
        ReportsSettingsUpdate: new Rx.BehaviorSubject(0)
    };

    this.Subscriptions = {};

    this.IsWidgetEnabled = true;

    webix.ui(this.SettingsPopupViewConfig);
    webix.ui(this.GeneralSettingsPopupViewConfig);
};

QoEReportsSettingsWidget.prototype.Bind = function ()
{
    let _this = this;

    Object.keys(this.Views.GeneralSettings).forEach(key => {
        _this.Views.GeneralSettings[key] = $$(_this.Id + "GeneralSettings" + key);
    });

    Object.keys(this.Views.ReportSettings).forEach(key => {
        _this.Views.ReportSettings[key] = $$(_this.Id + "ReportSettings" + key);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(WidgetKey => {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if (w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.GeneralSettings.SettingsMenu.disableItem(GeneralReportSettingsEnum.create_report_task.id);

    this.Views.ReportsWidgets.HistorySettingsTable.Views.Table.attachEvent("onAfterSelect", function (selection) {
        if (selection) {
            let savedTable = _this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;
            let historyTable = _this.Views.ReportsWidgets.HistorySettingsTable.Views.Table;

            if (_this.SelectedReportSettingsModel)
                _this.SelectedReportSettingsModel.selected_saved_setting_id = null;

            savedTable.unselectAll();

            let item = historyTable.getItem(selection);

            _this.SetReportSettingsFormState(JSON.parse(item.config));
            _this.DefineSaveBtnVisibilityState();

            setTimeout(function () {
                historyTable.unselectAll();
            }, 100);
        }
    });

    this.Views.ReportsWidgets.SavedSettingsTable.Views.Table.attachEvent("onAfterSelect", function (selection) {
        if (selection) {
            let savedTable = _this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;
            let item = savedTable.getItem(selection);

            if (_this.SelectedReportSettingsModel)
                _this.SelectedReportSettingsModel.selected_saved_setting_id = item._id;


            _this.SetReportSettingsFormState(JSON.parse(item.config));
            _this.DefineSaveBtnVisibilityState();
            _this.DefineSelectedSavedSettingsLabel();
        }
    });

    this.Views.ReportsWidgets.SavedSettingsTable.Views.Table.attachEvent("onBeforeAdd", function () {
        let tableElements = _this.Views.ReportsWidgets.SavedSettingsTable.Views.Table.serialize();

        if (!tableElements.length)
            _this.Views.ReportsWidgets.SavedSettingsTable.Views.Table.hideOverlay();
    });

    this.Views.ReportsWidgets.SavedSettingsTable.Views.Table.attachEvent("onAfterEditStop", function (state, editor) {
        let savedTable = _this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;

        let item = savedTable.getItem(editor.row);

        if (item && item._id && state.value === state.old) {
            return;
        }

        _this.SaveReportSettings(item, null, false);
    });

    this.Views.ReportsWidgets.SavedSettingsTable.Views.Table.attachEvent("onItemClick", function (id, e, node) {
        if (id) {
            let savedTable = _this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;

            if (savedTable.getEditState()) {
                savedTable.editStop();
                return;
            }

            switch (id.column) {
                case "edit":
                    savedTable.editRow(id.row);
                    savedTable.getEditState().getInputNode().select();
                    break;
                case "delete":
                    _this.DeleteSavedSettings(savedTable.getItem(id));
                    savedTable.remove(id);
                    break;
            }
        }
    });

    this.Views.ReportsWidgets.SavedSettingsTable.Views.Table.attachEvent("onItemDblClick", function (id, e, node) {
        if (id) {
            let savedTable = _this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;

            if (savedTable.getEditState()) {
                savedTable.editStop();
                return;
            }

            if (id.column === "title") {
                savedTable.editRow(id.row);
                savedTable.getEditState().getInputNode().select();
            }
        }
    });

    this.Views.ReportSettings.SettingsForm.attachEvent("onChange", function () {
        _this.DefineSaveBtnVisibilityState();
    });

    this.Subscriptions.ReportSettingsBtnClick = this.ViewModel.Signals.ReportSettingsBtnClick.subscribe(function (WidgetId) {
        if (WidgetId && _this.ViewModel.ReportsSettings[WidgetId]) {
            _this.ShowReportSettingsPopup(WidgetId);
        }
    });

    this.Subscriptions.SaveReportSettingsSuccess = this.ViewModel.Signals.SaveReportSettingsSuccess.subscribe(function (Update) {
        if (Update && Update.model && !Update.silence) {
            let savedTable = _this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;

            savedTable.updateItem(Update.model.id, Update.model);

            _this.SelectedReportSettingsModel.selected_saved_setting_id = Update.model._id;

            webix.message(LangHelper.GetString("QoE", "Settings successfully saved."));

            _this.DefineSaveBtnVisibilityState();
            _this.DefineSelectedSavedSettingsLabel();
        }
    });

    this.Subscriptions.SaveReportSettingsError = this.ViewModel.Signals.SaveReportSettingsError.subscribe(function (Error) {
        if (Error) {
            _this.RefreshSavedTables();

            if (Error.msg)
                webix.message({type: "error", text: Error.msg});
        }
    });

    this.Subscriptions.DeleteReportSettingsSuccess = this.ViewModel.Signals.DeleteReportSettingsSuccess.subscribe(function (Update) {
        if (Update) {
            if (!_this.Views.ReportsWidgets.SavedSettingsTable.Views.Table.serialize().length) {
                _this.RefreshSavedTables();
            }

            webix.message(LangHelper.GetString("QoEReportSettings", "Settings successfully deleted."));
        }
    });

    this.Subscriptions.DeleteReportSettingsError = this.ViewModel.Signals.DeleteReportSettingsError.subscribe(function (Error) {
        if (Error) {
            _this.RefreshSavedTables();

            if (Error.msg)
                webix.message({type: "error", text: Error.msg});
        }
    });

    this.Subscriptions.RefreshSavedSettings = this.Views.ReportsWidgets.SavedSettingsTable.ViewModel.Reports[this.Views.ReportsWidgets.SavedSettingsTable.Id].signal.subscribe(function (Update) {
        if(Update)
        {
            let formState = null;

            if(_this.SelectedReportSettingsModel)
            {
                if(_this.SelectedReportSettingsModel.selected_saved_setting_id)
                {
                    let savedTable = _this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;
                    let find = savedTable.serialize().find(item => item._id === _this.SelectedReportSettingsModel.selected_saved_setting_id);

                    if(find && savedTable.exists(find.id))
                    {
                        savedTable.blockEvent();
                        savedTable.select(find.id);
                        savedTable.unblockEvent();
                    }
                    else
                    {
                        _this.SelectedReportSettingsModel.selected_saved_setting_id = null;
                    }
                }
            }

            _this.SetReportSettingsFormState(formState);
            _this.DefineSaveBtnVisibilityState();
            _this.DefineSelectedSavedSettingsLabel();
            _this.Views.ReportSettings.SettingsPopup.show();
        }
    });

    this.Subscriptions.SignalQoEStorConfigFileUpdated = this.QoEStorConfigManager.Signals.ConfigFileUpdated.subscribe(function (Val) {
        if (Val) {
            Object.keys(_this.AggPeriodValues).forEach(key => {
                if (_this.QoEStorConfigManager.ConfigModel[key]) {
                    _this.AggPeriodValues[key] = _this.QoEStorConfigManager.ConfigModel[key];
                }
            });
        }
    });

    this.RefreshTablesUi();

    this.QoEStorConfigManager.Refresh({silent: true});
};

QoEReportsSettingsWidget.prototype.Destroy = function ()
{
    let _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (key)
    {
        _this.Views.ReportsWidgets[key].Destroy();
    });

    this.ViewModel.Destroy();
};

QoEReportsSettingsWidget.prototype.GetState = function (Key)
{
    let key = Key ? Key : GeneralReportSettingsEnum.reports_manual_refresh.id;
    let item = this.Views.GeneralSettings.SettingsMenu.getItem(key);

    return item && item.enabled ? true : false
};

QoEReportsSettingsWidget.prototype.RefreshTablesUi = function()
{
    let savedTableWidget = this.Views.ReportsWidgets.SavedSettingsTable;
    let historyTableWidget = this.Views.ReportsWidgets.HistorySettingsTable;

    [savedTableWidget, historyTableWidget].forEach(widget => {
        let childViews = $$(widget.Id).getChildViews().filter(view => view.name === "toolbar");
        if (childViews && childViews.length) {
            let pagerView;
            let toolBarChildViews = childViews[0].getChildViews();

            if (toolBarChildViews && toolBarChildViews.length) {
                toolBarChildViews.forEach(view => {
                    if (view.name === "pager") {
                        pagerView = view
                    } else {
                        view.hide();
                    }
                });

                pagerView.define({
                    template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                    group: 3,
                    css: "custom_pager"
                });

                pagerView.refresh();
            }
        }
    });
};

QoEReportsSettingsWidget.prototype.ShowReportSettingsPopup = function(ReportWidgetId)
{
    if(this.ViewModel.ReportsSettings[ReportWidgetId])
    {
        this.SelectedReportSettingsModel = this.ViewModel.ReportsSettings[ReportWidgetId];

        this.RefreshSavedTables();
        this.RefreshHistoryTables();

        this.SetReportSettingsFormState();

        this.Views.ReportSettings.SettingsPopup.show();
    }
};

QoEReportsSettingsWidget.prototype.SetReportSettingsFormState = function (FormState = null)
{
    if(this.SelectedReportSettingsModel)
    {
        let _this = this;

        const locale = LangHelper.GetLocale();

        let model = this.SelectedReportSettingsModel;
        let widget = model.widget;
        let defaultState = model.default_common_state;
        let targetState = FormState ? FormState : model.cur_common_state;

        let isElEnable = {};

        const getTableHeaders = (Sorted= false, FilterBy = {}) => {
            if(!Helper.IsTableWidget(widget))
                return [];

            let items = widget.GetTableHeaders()
                .map(item => ({
                    id: item.id,
                    value: item.header_name && item.header_name[locale]
                        ? item.header_name[locale]
                        : item.value
                }));

            Object.keys(FilterBy).forEach(Key => {
                const filterList = Array.isArray(FilterBy[Key])
                    ? FilterBy[Key]
                    : [];
                items = items.filter(
                    item => filterList.includes(item.id)
                );
            });

            if(Sorted) {
                const order = defaultState.columns_to_show;
                items = items.sort(
                    (a, b) => order.indexOf(a.id) - order.indexOf(b.id)
                );
            }

            return items;
        };

        const applySuggestList = (El, Options) => {
            let list = El.getList();
            list.clearAll();
            list.parse(Options);
        };

        this.Views.ReportSettings.SettingsForm.blockEvent();

        Object.keys(this.Views.ReportSettings.SettingsForm.elements).forEach((key) => {
            isElEnable[key] = true;

            let optionsData;
            let el = _this.Views.ReportSettings.SettingsForm.elements[key];
            let viewData = ReportSettingsEnum[key];
            let view = _this.Views.ReportSettings[viewData ? viewData.section_name : null];
            let targetVal = targetState[key] ? targetState[key] : defaultState[key];

            if(!el || !view || !targetVal) {
                isElEnable[key] = false;
                if(el) el.disable();
                if(view) view.hide();
                return;
            }

            switch(key)
            {
                case ReportSettingsEnum.enable_series.id:
                    optionsData = widget.GetSeriesItems();
                    applySuggestList(el, optionsData);
                    break;

                case ReportSettingsEnum.columns_to_show.id:
                    optionsData = getTableHeaders(true);

                    const defaultSet = new Set(
                        Array.isArray(defaultState.group_by)
                            ? defaultState.group_by
                            : [])
                    ;
                    const targetSet = new Set(
                        Array.isArray(targetState.group_by)
                            ? targetState.group_by
                            : []
                    );

                    const isGroupByItem = (item) => defaultSet.has(item.id);
                    const isActiveItem = (item) => targetSet.has(item.id);

                    optionsData.forEach(Item => {
                        if(!isGroupByItem(Item))
                            return;

                        if(isActiveItem(Item)) {
                            Item.$checked = 1;
                            delete Item.disabled;
                            delete Item.$css;
                        } else {
                            Item.$checked = 0;
                            Item.disabled = 1;
                            Item.$css = "webix_disabled"
                        }
                    });
                    applySuggestList(el, optionsData);
                    break;

                case ReportSettingsEnum.group_by.id:
                    optionsData = getTableHeaders(
                        true,
                        {"group_by": defaultState.group_by}
                    );
                    applySuggestList(el, optionsData);
                    break;

                case ReportSettingsEnum.chart_order_by.id:
                    if(Helper.IsObject(widget.OptionsOrderBy))
                        optionsData = Object.values(widget.OptionsOrderBy);

                    if(optionsData.length > 0)
                        applySuggestList(el, optionsData);
                    else
                        isElEnable[key] = false;
                    break;

                case ReportSettingsEnum.sort_id.id:
                    optionsData = getTableHeaders(true);
                    applySuggestList(el, optionsData);
                    break;

                case ReportSettingsEnum.agg_period.id:
                    optionsData = Helper.DictToArr(ChartsTimeStepsDic);

                    if(model.custom_options && Array.isArray(model.custom_options.allowed_chart_steps))
                        optionsData = optionsData
                            .filter(item => model.custom_options.allowed_chart_steps.includes(item.id));

                    if(AggPeriodOnlyAutoSeriesChartSeriesWidgetList.includes(widget.Name))
                        optionsData = optionsData
                            .filter(item => item.id === ChartsTimeStepsDic.auto.id);

                    applySuggestList(el, optionsData);
                    break;
            }

            if(isElEnable[key] && key === ReportSettingsEnum.rows_limit.id) {
                el.define(
                    "label",
                    _this.RowsLimitSetctionLabels[widget.constructor.name]
                );
                el.refresh();
            }

            if(isElEnable[key]) {
                el.setValue(targetVal);
                el.enable();
                view.show();
            } else {
                el.setValue("");
                el.disable();
                view.hide();
            }
        });

        this.Views.ReportSettings.SettingsForm.unblockEvent();
    }
};

QoEReportsSettingsWidget.prototype.SetAllToDefault = function()
{
    if(this.SelectedReportSettingsModel)
    {
        let formState;
        let selectedSavedItem = this.GetSelectedSavedItem(true);

        if(selectedSavedItem && selectedSavedItem.config)
        {
            formState = selectedSavedItem.config;
        }
        else
        {
            formState = this.SelectedReportSettingsModel.default_common_state;
        }

        this.SetReportSettingsFormState(formState);
        this.DefineSaveBtnVisibilityState();
    }
};

QoEReportsSettingsWidget.prototype.GetReportSettingsState = function ()
{
    let _this = this;

    let formState = {};

    Object.keys(this.Views.ReportSettings.SettingsForm.elements).forEach(key => {
        let formEl = _this.Views.ReportSettings.SettingsForm.elements[key];

        if (formEl.isEnabled())
        {
            formState[key] = formEl.getValue();

            if (formEl.config.view === "multiselect" && typeof formState[key] === "string")
            {
                formState[key] = formState[key].split(",");
            }
        }
    });

    return formState;
};

QoEReportsSettingsWidget.prototype.CancelReportSettings = function()
{
    this.ResetReportSettingsPopup();

    this.Views.ReportSettings.SettingsPopup.hide();

    this.SelectedReportSettingsModel = null;
};

QoEReportsSettingsWidget.prototype.ApplyReportSettings = function()
{
    let savedTable = this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;

    if(savedTable.getEditState())
    {
        savedTable.editStop();
        return;
    }

    if(this.SelectedReportSettingsModel)
    {
        let formState = this.GetReportSettingsState();

        this.SelectedReportSettingsModel.SetCurState(formState);

        if(this.SelectedReportSettingsModel.IsDiffWithPrev())
        {
            this.SaveReportSettings(null, formState, true);
        }

        if(this.SelectedReportSettingsModel.IsDiffWithPrev("checkDataRefresh"))
        {
            if(this.SelectedReportSettingsModel.can_update_widget) {
                this.SelectedReportSettingsModel.external_lock = true;
                this.Signals.ReportsSettingsUpdate.next(1);
            }
        }
    }

    this.ResetReportSettingsPopup();

    this.Views.ReportSettings.SettingsPopup.hide();
};

QoEReportsSettingsWidget.prototype.ResetReportSettingsPopup = function()
{
    this.Views.ReportSettings.SaveSettingsBtn.hide();
    this.Views.ReportSettings.SavedSettingsLabel.setValue("");

    let historyTable = this.Views.ReportsWidgets.HistorySettingsTable.Views.Table;
    let savedTable = this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;

    savedTable.blockEvent();

    if(savedTable.getEditState())
        savedTable.editStop();

    historyTable.clearAll();
    savedTable.clearAll();

    let historyFilter = historyTable.getFilter("update_time");
    let savedFilter = savedTable.getFilter("title");

    if(historyFilter && historyFilter.config && historyFilter.config.value)
    {
        historyFilter.config.value.start = null;
        historyFilter.config.value.end = null;
    }

    if(savedFilter && savedFilter.value)
    {
        savedFilter.value = "";
    }

    savedTable.unblockEvent();
}

QoEReportsSettingsWidget.prototype.SaveReportSettings = function(Model = null, State = null, Silence = false)
{
    if(this.ViewModel.CurUserProfile && this.SelectedReportSettingsModel)
    {
        if(!Model)
        {
            Model = new ReportSettingsModel({
                widget_id: this.SelectedReportSettingsModel.widget_id,
                dashboard_id: this.SelectedReportSettingsModel.dashboard_id,
                create_user: this.ViewModel.CurUserProfile.user_id,
                update_user: this.ViewModel.CurUserProfile.user_id
            });
        }

        if(State)
            Model.config = JSON.stringify(State);

        this.ViewModel.SaveReportSettings(Model, Silence);
    }
}

QoEReportsSettingsWidget.prototype.AddNewSavedSettings = function(State)
{
    if(this.ViewModel.CurUserProfile && this.SelectedReportSettingsModel)
    {
        this.Views.ReportSettings.Tabbar.setValue(this.Id + "ReportSettings" + "SavedSettingsTabView");

        let savedTable =  this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;

        if(savedTable.getEditState())
            savedTable.editStop();

        let wId = this.SelectedReportSettingsModel.dashboard_widget_id ? this.SelectedReportSettingsModel.dashboard_widget_id : this.SelectedReportSettingsModel.widget_id;
        let state = State ? State : this.SelectedReportSettingsModel.default_common_state;

        let newRowId = savedTable.add(
            new ReportSettingsModel({
                widget_id: wId,
                dashboard_id: this.SelectedReportSettingsModel.dashboard_id,
                title:LangHelper.GetString("QoE", "New settings"),
                config:JSON.stringify(state),
                create_user:this.ViewModel.CurUserProfile.user_id,
                update_user:this.ViewModel.CurUserProfile.user_id,
            }), 0);

        savedTable.select(newRowId);
        savedTable.editRow(newRowId);
        savedTable.getEditState().getInputNode().select();
    }
};

QoEReportsSettingsWidget.prototype.DeleteSavedSettings = function(Model)
{
    this.ViewModel.DeleteReportSettings(Model);
};

QoEReportsSettingsWidget.prototype.RefreshSavedTables = function()
{
    if(this.ViewModel.CurUserProfile && this.SelectedReportSettingsModel)
    {
        let filter = {
            title: {
                id:"title",
                operator:"is not null"
            },
            widget_id: {
                id:"widget_id",
                operator:"=",
                value:this.SelectedReportSettingsModel.widget_id
            },
            create_user: {
                id:"create_user",
                operator:"=",
                value:this.ViewModel.CurUserProfile.user_id
            }
        };

        this.Views.ReportsWidgets.SavedSettingsTable.RefreshData(0, {filter:filter});
    }
};

QoEReportsSettingsWidget.prototype.RefreshHistoryTables = function()
{
    if(this.ViewModel.CurUserProfile && this.SelectedReportSettingsModel)
    {
        let filter = {
            title: {
                id:"title",
                operator:"is null"
            },
            widget_id: {
                id:"widget_id",
                operator:"=",
                value:this.SelectedReportSettingsModel.widget_id
            },
            create_user: {
                id:"create_user",
                operator:"=",
                value:this.ViewModel.CurUserProfile.user_id
            }
        };

        this.Views.ReportsWidgets.HistorySettingsTable.RefreshData(0, {filter:filter});
    }
};

QoEReportsSettingsWidget.prototype.GetSelectedSavedItem = function(ParseJson = false)
{
    let savedTable =  this.Views.ReportsWidgets.SavedSettingsTable.Views.Table;

    let selectedItem = savedTable.getSelectedItem();

    if(selectedItem && ParseJson)
    {
        selectedItem = webix.copy(selectedItem);
        selectedItem.config = JSON.parse(selectedItem.config);
    }

    return selectedItem;
};

QoEReportsSettingsWidget.prototype.DefineSaveBtnVisibilityState = function()
{
    if(this.SelectedReportSettingsModel)
    {
        let curSettingsState = this.GetReportSettingsState();
        let selectedSavedItem = this.GetSelectedSavedItem(true);
        let countChanges = Helper.CountReportSettingsStateChanges(curSettingsState, this.SelectedReportSettingsModel.default_common_state);

        if(selectedSavedItem && selectedSavedItem.config)
        {
            countChanges = Helper.CountReportSettingsStateChanges(curSettingsState, selectedSavedItem.config);
        }

        countChanges && countChanges.by_vals > 0 ? this.Views.ReportSettings.SaveSettingsBtn.show() : this.Views.ReportSettings.SaveSettingsBtn.hide();
    }
};

QoEReportsSettingsWidget.prototype.DefineSelectedSavedSettingsLabel = function()
{
    let selectedItem = this.GetSelectedSavedItem();

    if(selectedItem && selectedItem.title)
    {
        this.Views.ReportSettings.SavedSettingsLabel.setValue(selectedItem.title);
    }
    else
    {
        this.Views.ReportSettings.SavedSettingsLabel.setValue("");
    }
};

QoEReportsSettingsWidget.prototype.DisableWidget = function()
{
    this.IsWidgetEnabled = false;
    this.ViewModel.Active = false;

    if(this.Views.GeneralSettings && this.Views.GeneralSettings.SettingsMenu)
        this.Views.GeneralSettings.SettingsMenu.disableItem(
            GeneralReportSettingsEnum.create_report_task.id
        );

    Object.values(this.ViewModel.ReportsSettings).forEach(model => {
        if(model.show_settings_btn)
            model.show_settings_btn.disable();
    });
};

QoEReportsSettingsWidget.prototype.GetInputView = function(SectionName)
{
    let sectionView, childs, inputView;

    if(this.Views.ReportSettings)
    {
        sectionView = this.Views.ReportSettings[SectionName];

        if(sectionView)
            childs = sectionView.getChildViews();

        if(Array.isArray(childs) && childs.length)
            if(childs[0] && typeof childs[0].getValue === "function")
                inputView = childs[0];
    }

    return inputView;
};

QoEReportsSettingsWidget.prototype.getInitialManualRefreshState = function(Key) {
    if (!AppEnv.EnableManualUpdateReportsQoEDefault)
    {
        return this.ViewModel.ReadFromStorage(Key);
    }
    else
    {
        return 1;
    }
};

QoEReportsSettingsWidget.prototype.ScaleOptionsHandler = function()
{
    let needDisable = false;

    let scaleInput = this.GetInputView(ReportSettingsEnum.chart_scale_type.section_name);
    let lineInput = this.GetInputView(ReportSettingsEnum.graph_line_type.section_name);
    let yLevelInput = this.GetInputView(ReportSettingsEnum.y_axis_detail_level.section_name);

    let scaleOptions = scaleInput.getList();

    const lineType = lineInput.getValue();
    const yLevel = yLevelInput.getValue();

    if(["stackedArea", "stackedBar"].includes(lineType))
        needDisable = true;

    if(yLevel !== "auto")
        needDisable = true;

    if(needDisable)
    {
        let firsId;
        scaleOptions.data.each(Item => {
            if(Item.id === ChartScalesDic.logarithmic.id){
                Item.disabled = 1;
                Item.$css = "webix_disabled";
                scaleOptions.updateItem(Item.id, Item);
            }

            if(!Item.disabled && !firsId)
                firsId = Item.id;
        });
        scaleInput.setValue(firsId);
    }
    else
    {
        scaleOptions.data.each(Item => {
            if(Item.disabled || Item.$css)
            {
                delete Item.disabled;
                delete Item.$css;
                scaleOptions.updateItem(Item.id, Item);
            }
        });
    }
};
function QoEUserReportsScheduleWidget(Params)
{
    let _this = this;

    this.Id = Params && Params.id ? Params.id : "QoEUserReportsScheduleWidget";

    this.Views = {};

    this.Signals = {
        AddSchedule: new Rx.BehaviorSubject(0)
    };

    this.formWidths = Params.formWidths;

    this.Configs = {
        FormTimeInput: {
            id: this.Id + "FormTimeInput",
            name: "time",
            view: "datepicker",
            type: "time",
            label: LangHelper.GetString("QoE", "Time"),
            labelWidth: this.formWidths.label_start_after_time,
            validate: webix.rules.isNotEmpty(),
            required: true,
            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
            format: Helper.GetDateTimeFormat("%H:%i"),
            placeholder: webix.Date.dateToStr(Helper.GetDateTimeFormat("%H:%i"))(new Date(new Date().getTime())),
            on: {
                onChange: function () {
                    this.validate();
                }
            }
        },
        FormWeekDaysSelect: {
            id: this.Id + "FormWeekDaysSelect",
            name: "week_days",
            view: "multiselect",
            width: 242,
            label: LangHelper.GetString("QoE", "Days"),
            labelWidth: this.formWidths.label_start_after_date,
            validate: webix.rules.isNotEmpty(),
            required: true,
            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
            options: Object.values(DaysOfWeekDic),
            on: {
                onChange: function() {
                    this.validate();
                }
            }
        },
        FormAddBtn: {
            id: this.Id + "FormAddBtn",
            view: "button",
            type: "icon",
            icon: "plus",
            css: "toolbar_round_btn",
            width: 48,
            height: 48,
            tooltip: LangHelper.GetString("QoE", "Add schedule"),
            click: function() {
                _this.AddSchedule();
            }
        },
        Form: {
            id: this.Id + "Form",
            view: "form",
            type: "clear",
            borderless: true,
            elements: []
        },
        Table: {
            id: this.Id + "Table",
            view: "datatable",
            autoheight: true,
            columns: function() {
                let cols = [
                    {
                        id: "start_time",
                        header: LangHelper.GetString("QoE", "Start time"),
                        sort: "string",
                        fillspace: true
                    },
                    {
                        id: "trash",
                        width: 40,
                        header: "",
                        template: CellTrashBtnTemplate
                    }
                ];

                Object.values(DaysOfWeekDic).forEach((Item, Idx) => {
                    let col = {
                        id: Item.id,
                        header: Item.value,
                        width: 55,
                        template: function(Obj) {
                            let val = Obj && Obj[parseInt(Item.id)] ? 1 : 0;
                            return CellCheckBoxTemplate({cursor: "default"}, null, val);
                        }
                    }
                    cols.splice(Idx + 1, 0, col);
                });

                return cols;
            }(),
            on: {
                onItemClick: function(Id, E, Node) {
                    if(Id.column === "trash")
                    {
                        _this.Views.Table.remove(Id.row)
                        if(!_this.Views.Table.serialize().length)
                            _this.Views.Table.hide();
                    }
                }
            }
        },
        InvalidLabel: {
            id: this.Id + "InvalidLabel",
            view: "label",
            css:{"color": "#fd595f !important"},
            hidden: true,
            label: LangHelper.GetString("QoE","No schedule added")
        }
    };

    this.Configs.Form.elements = [
        {
            cols: [
                {
                    rows: [
                        this.Configs.FormTimeInput
                    ]
                },
                {width: this.formWidths.empty},
                {
                    rows: [
                        this.Configs.FormWeekDaysSelect
                    ]
                },
                {
                    rows: [
                        this.Configs.FormAddBtn
                    ]
                }
            ]
        }
    ]

    this.ViewConfig = {
        id: this.Id + "ViewConfig",
        type: "clear",
        borderless: true,
        body: {
            rows: [
                this.Configs.Form,
                this.Configs.InvalidLabel,
                {height: 15},
                this.Configs.Table
            ]
        }
    }
}

QoEUserReportsScheduleWidget.prototype.Bind = function()
{
    let _this = this;

    Object.keys(this.Configs).forEach(Key => {
        _this.Views[Key] = $$(_this.Id + Key);
    });
};

QoEUserReportsScheduleWidget.prototype.Destroy = function()
{
    this.Signals = {};
};

QoEUserReportsScheduleWidget.prototype.GetScheduleData = function()
{
    let data = this.Views.Table.serialize().map(Item => QoEReportScheduleModel(Item));

    if(data.length)
    {
        data = data.map(Obj => {
            let time = Obj.start_time;
            let weekDays = Object.values(DaysOfWeekDic).filter(Item => Obj[Item.id])
                .map(Item => Item.id);

            [time, weekDays] = Helper.ConvertSchedule(Obj.start_time, weekDays, 'localToUtc');

            return QoEReportScheduleModel({
                client_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                start_time: time,
                week_days: weekDays,
                trigger_id: Obj.trigger_id
            });
        });
    }

    return data;
};

QoEUserReportsScheduleWidget.prototype.SetScheduleData = function(Data)
{
    let _this = this;

    if(Data && Data.length)
    {
        let data = Data.map(Obj => {
            let time = Obj.start_time;
            let weekDays = Object.values(DaysOfWeekDic).filter(Item => Obj[Item.id])
                .map(Item => Item.id);

            [time, weekDays] = Helper.ConvertSchedule(Obj.start_time, weekDays, 'UtcToLocal');

            return QoEReportScheduleModel({
                start_time: time,
                week_days: weekDays,
                trigger_id: Obj.trigger_id
            });
        });

        data.sort((a, b) => a.start_time.localeCompare(b.start_time));
        data.forEach(Item => _this.Views.Table.add(QoEReportScheduleModel(Item)));
    }
};

QoEUserReportsScheduleWidget.prototype.ClearWidget = function()
{
    this.MarkWidgetValid();
    this.ClearForm();
    this.Views.Table.clearAll();
};

QoEUserReportsScheduleWidget.prototype.ClearForm = function()
{
    let _this = this;

    ["time", "week_days"].forEach(Key => {
        let view = _this.Views.Form.elements[Key];
        view.blockEvent();
        view.setValue("");
        view.unblockEvent();
        _this.Views.Form.markInvalid(Key, false)
    });
};

QoEUserReportsScheduleWidget.prototype.EnableForm = function()
{
    [
        this.Views.FormTimeInput,
        this.Views.FormWeekDaysSelect,
        this.Views.FormAddBtn
    ].forEach(View => {
        View.enable();
        View.define({required: true});
        View.refresh();
    });

    if(this.Views.Table.serialize().length)
        this.Views.Table.show();
};

QoEUserReportsScheduleWidget.prototype.DisableForm = function()
{
    [
        this.Views.FormTimeInput,
        this.Views.FormWeekDaysSelect,
        this.Views.FormAddBtn
    ].forEach(View => {
        View.disable();
        View.define({required: false});
        View.refresh();
    });

    this.MarkFormValid();
    this.MarkWidgetValid();
    this.Views.Table.hide();
};

QoEUserReportsScheduleWidget.prototype.MarkFormValid = function()
{
    let _this = this;

    Object.keys(this.Views.Form.elements).forEach(Key => {
        _this.Views.Form.markInvalid(Key, false)
    });
};

QoEUserReportsScheduleWidget.prototype.MarkWidgetValid = function()
{
    this.Views.InvalidLabel.hide();
};

QoEUserReportsScheduleWidget.prototype.MarkWidgetInvalid = function()
{
    this.Views.InvalidLabel.show();
};

QoEUserReportsScheduleWidget.prototype.ValidateForm = function()
{
    return this.Views.Form.validate();
};

QoEUserReportsScheduleWidget.prototype.Validate = function()
{
    let res = !!(this.GetScheduleData().length);

    if(!res)
        this.MarkWidgetInvalid()

    return res;
};

QoEUserReportsScheduleWidget.prototype.AddSchedule = function()
{
    this.MarkWidgetValid();

    if(this.Views.Form.validate()) {
        let format =  webix.Date.dateToStr("%H:%i");

        this.Views.Table.add(QoEReportScheduleModel({
            start_time: format(this.Views.FormTimeInput.getValue()),
            week_days: this.Views.FormWeekDaysSelect.getValue().split(",")
        }));

        this.ClearForm();

        if(!this.Views.Table.isVisible())
            this.Views.Table.show();

        this.Signals.AddSchedule.next(1);
    }
};

function QoEUserReportsFormWidget(Params)
{
    let _this = this;

    const formWidths = {
        empty: 15,
        label: 170,
        label_start_after_time: 65,
        label_start_after_date: 65,
        checkbox: 200
    }

    this.Id = Params && Params.id ? Params.id : "QoEUserReportsFormWidget";

    this.ViewController = null;

    this.ViewModel = null;

    this.AllowedViewControllers = [
        "QoEFullNetFlowViewController",
        "QoERawFullNetFlowViewController",
        "QoEClickStreamViewController",
        "QoERawClickstreamViewController",
        "QoEFullDnsFlowViewController",
        "QoERawFullDnsFlowViewController",
        "QoEFullGtpFlowViewController",
        "QoERawFullGtpFlowViewController",
        "QoEFullNatFlowViewController",
        "QoERawFullNatFlowViewController",
        "QoEFullDdosAttackFlowViewController",
        "QoERawFullDdosAttackFlowViewController",
        "QoEAnyReportViewController",
        "QoECustomReportsViewController"
    ];

    this.SelectedTaskModel = {};

    this.Subscriptions = {};

    this.Views = {
        Popup: null,
        PopupViews: {
            Form: null,
            ExtendedFilterBtn: null,
            ReportsSettingsBtn: null,
            MailTemplatesShowBtn: null,
            MailTemplateAddBtn: null,
            TelegramTemplatesShowBtn: null,
            TelegramTemplatesAddBtn: null,
            ScheduleAddBtn: null,
            ScheduleSeeBtn: null,
            SaveBtn: null,
            SaveAndRunBtn: null,
            CancelBtn: null,
            FormDatePeriodsTab: null,
            FormSchedulePeriodsTab: null
        },
        Widgets: {
            WidgetsSuggest: new QoEWidgetsSuggestWidget({
                id: this.Id + "WidgetsSuggest",
                exceptWidgetCodes: ExceptWidgetCodes.panels_maps
            }),
            ReportsSettings: new QoEReportsSettingsWidget({id: this.Id + "ReportsSettingsWidget"}),
            ExtendedFillter: new QoEPopupFilterWidget({id: this.Id + "ExtendedFillter", enable_show_hotkey: 1}),
            MailingTemplateWidget: new MailingTemplatesEditWidget(
                {id: this.Id + "MailingTemplatesEditWidget", view_type: MailingTemplatesWidgetViewTypes.popup}
            ),
            ScheduleWidget: new QoEUserReportsScheduleWidget({formWidths: formWidths})
        }
    };

    this.FormatDate = webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    this.FormValuesStore = {};

    this.FormDefaultState = {
        "name": "",
        "suggest_input": "",
        "period_from": "",
        "period_to": "",
        "max_exec_time_sec": 4 * 60 * 60,
        "lifetime_hours": 7 * 24,
        "priority": 1,
        "out_of_turn": 0,
        "mail_notify_enabled": 0,
        "mail_address": "",
        "mail_template": "",
        "tg_notify_enabled": 0,
        "tg_channel": "",
        "tg_template": "",
        "split_report_enabled": 0,
        "split_per_days": "",
        "split_by_lines": "",
        "is_delayed": 0,
        "start_after_time": "",
        "start_after_date": "",
        "split_type": "by_time",
        "separate_delivery": 0,
        "is_scheduled": 0,
        "schedule_time": "",
        "schedule_days": ""
    };

    this.ElmntsRelation = {
        suggest_input: {views: ["ExtendedFilterBtn", "ReportsSettingsBtn"]},
        out_of_turn: {elmnts: ["priority"], reverse: true},
        mail_notify_enabled: {
            elmnts: ["mail_address", "mail_template"],
            funcs: [
                this.GetTemplateEditBtnVisibilityHandler("mail_template", "MailTemplatesShowBtn"),
                this.GetTemplateAddBtnVisibilityHandler("mail_notify_enabled", "MailTemplateAddBtn")
            ]
        },
        tg_notify_enabled: {
            elmnts: ["tg_channel", "tg_template"],
            funcs: [
                this.GetTemplateEditBtnVisibilityHandler("tg_template", "TelegramTemplatesShowBtn"),
                this.GetTemplateAddBtnVisibilityHandler("tg_notify_enabled", "TelegramTemplatesAddBtn"),
            ]
        },
        split_report_enabled: {
            elmnts: ["split_type"],
            funcs: [
                (isEnabled) => this.ReportSplitVisibilityHandler(isEnabled),
                (isEnabled) => this.ReportSeparateDeliveryHandler(isEnabled)
            ]
        },
        is_delayed: {
            exclude_elmnts: ["is_scheduled"],
            elmnts: ["start_after_time", "start_after_date"]
        },
        is_scheduled: {
            exclude_elmnts: ["is_delayed"],
            funcs: [(isEnabled) => this.ScheduleVisibilityHandler(isEnabled)]
        }
    };

    this.ReportsSettingsBtnConfig = {
        id: this.Id + "PopupViews" + "ReportsSettingsBtn",
        view: "button",
        type: "icon",
        icon: "gear",
        css: "toolbar_round_btn",
        width: 48,
        tooltip: LangHelper.GetString("QoE", "Report Settings"),
        badge: 0
    };

    this.GetHelpBtnConfig = function(Key)
    {
        const getMsg = (line) => LangHelper.GetString("QoE", line);

        let helpData = {
            max_exec_time_sec: getMsg("The parameter specifies the maximum time (in hours) to complete the report generation task."),
            lifetime_hours: getMsg("The parameter defines the storage duration of cached data (in days) for loading the report."),
            priority: getMsg(
                "The parameter determines the order of execution of tasks in the range from 1 (minimum priority) to 10 (maximum priority). " +
                "Tasks with a higher priority are executed earlier. If two tasks have the same priority, " +
                "the one that was created earlier is taken into work first."
            ),
            out_of_turn: getMsg(
                "Parameter that determines whether the task will be executed out of queue, " +
                "i.e. immediately and independently of other report generation tasks. " +
                "If this parameter is enabled, the task will be processed first, even if other tasks are in the queue."
            ),
            mail_notify_enabled: getMsg(
                "The parameter determines whether an email notification will be sent upon task completion. " +
                "If the parameter is enabled, the system will automatically send an email to the specified address. " +
                "It is also possible to customize the email template so that the notification meets specific requirements. " +
                "By default, the standard email template is used."
            ),
            tg_notify_enabled: getMsg(
                "The parameter determines whether a notification will be sent to the telegram channel upon completion of the task. " +
                "If the parameter is enabled, the system will automatically send a message. " +
                "It is also possible to customize the message template so that the notification meets specific requirements. " +
                "By default, the standard message template is used."
            ),
            split_report_enabled: getMsg("An option that enables splitting a report into multiple subreports using two alternative methods: by time interval in hours or by the maximum number of rows. " +
                "When splitting by time, each subreport covers the specified number of hours. When splitting by rows, each subreport contains no more than the defined number of rows.") +
                "<br/><br/>" +
                getMsg("Separate sending - each generated file is sent as a separate email or telegram message.") +
                "<br/><br/>" +
                getMsg("Max available number of queries is 100."),
            is_delayed: getMsg(
                "Option that determines whether the task will be delayed before execution. " +
                "If this option is enabled, you can specify a delay time after which the task will be added to the queue. " +
                "By default, if the option is not enabled, the task is immediately queued for execution."
            ),
            is_scheduled: getMsg("Option that enable task schedule.")
        };

        ["mail_notify_enabled", "tg_notify_enabled"].forEach(Key => {
            helpData[Key] += "<br/><br/>" + LangHelper.GetString("QoE", "By default, the language of system templates is English. To set the template language, set the trigger template language option in the GUI configuration.")
        });

        return {
            view:"button",
            type:"icon",
            icon:"question-circle",
            css:"toolbar_round_btn",
            height:48,
            width:48,
            popup:{
                view:"popup",
                body:{
                    borderless:true,
                    scroll:true,
                    template:Key && helpData[Key] ? helpData[Key] : ""
                }
            }
        };
    };

    this.FormElements = [
        {
            name: "name",
            view: "text",
            label: LangHelper.GetString("QoE", "Task name"),
            labelPosition: "top",
            placeholder: LangHelper.GetString("QoE", "Task name"),
            required: true,
            validate: webix.rules.isNotEmpty(),
            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
            on: {
                onChange: function() {
                    this.validate();
                }
            }
        },
        {
            cols: [
                {
                    rows: [
                        {
                            name: "suggest_input",
                            view: "text",
                            label: LangHelper.GetString("QoE", "Report"),
                            labelPosition: "top",
                            placeholder: "QoE " + LangHelper.GetString("QoE", "Report").toLowerCase(),
                            required: true,
                            validate: webix.rules.isNotEmpty(),
                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                            on: {
                                onKeyPress: function() {
                                    return false;
                                },
                                onItemClick: function() {
                                    let node = this.getNode();
                                    _this.Views.Widgets.WidgetsSuggest.Show(node, "bottom");
                                },
                                onChange: function(nV) {
                                    _this.ManageFormElmnts(_this.ElmntsRelation[this.config.name], nV);
                                }
                            }
                        },
                    ]
                },
                {
                    rows: [
                        {},
                        {
                            height: 48,
                            cols: [
                                this.Views.Widgets.ExtendedFillter.ViewConfig,
                                this.ReportsSettingsBtnConfig
                            ]
                        },
                        {}
                    ]
                }
            ]
        },
        {
            cols: [
                {
                    view: "tabview",
                    tabbar: { hidden: true },
                    cells: [
                        {
                            id: this.Id + "PopupViews" + "FormDatePeriodsTab",
                            rows: [
                                {
                                    cols: [
                                        {
                                            rows: [
                                                {
                                                    name: "period_from",
                                                    view:"datepicker",
                                                    timepicker:true,
                                                    format: Helper.GetDateTimeFormat(),
                                                    label: LangHelper.GetString("QoE", "Period from"),
                                                    labelPosition: "top",
                                                    placeholder: webix.Date.dateToStr(Helper.GetDateTimeFormat())(new Date(new Date().getTime() - (60 * 60 * 1000))),
                                                    editable: true,
                                                    stringResult: true,
                                                    required: true,
                                                    on: {
                                                        onBlur: function()
                                                        {
                                                            if(_this.ValidatePeriod(this.config.name))
                                                                _this.ValidatePeriodBoth(false);
                                                        },
                                                    }
                                                },
                                            ]
                                        },
                                        {width: formWidths.empty},
                                        {
                                            rows: [
                                                {
                                                    name: "period_to",
                                                    view:"datepicker",
                                                    timepicker:true,
                                                    format: Helper.GetDateTimeFormat(),
                                                    label: LangHelper.GetString("QoE", "Period to"),
                                                    labelPosition: "top",
                                                    placeholder: webix.Date.dateToStr(Helper.GetDateTimeFormat())(new Date(new Date().getTime())),
                                                    editable: true,
                                                    stringResult: true,
                                                    required: true,
                                                    on: {
                                                        onBlur: function()
                                                        {
                                                            if(_this.ValidatePeriod(this.config.name))
                                                                _this.ValidatePeriodBoth(false);
                                                        },
                                                    },
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: this.Id + "PopupViews" + "FormSchedulePeriodsTab",
                            rows: [
                                {
                                    cols: [
                                        {
                                            rows: [
                                                {
                                                    name:"schedule_period_from",
                                                    view: "richselect",
                                                    label: LangHelper.GetString("QoE", "Period from"),
                                                    labelPosition: "top",
                                                    placeholder: LangHelper.GetString("QoE","now - 1 hour"),
                                                    validate: webix.rules.isNotEmpty(),
                                                    invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                                                    required: true,
                                                    options: Object.keys(QoETriggerPeriodRangesEnum).reduce((acc, key) => {
                                                        acc.push({id:key, value:LangHelper.GetString("QoE",key)});
                                                        return acc;
                                                    }, []),
                                                    on: {
                                                        onChange: function() {
                                                            this.validate();
                                                        }
                                                    }
                                                },
                                            ]
                                        },
                                        {width: formWidths.empty},
                                        {
                                            rows: [
                                                {
                                                    name:"schedule_period_to",
                                                    view: "richselect",
                                                    label: LangHelper.GetString("QoE", "Period to"),
                                                    labelPosition: "top",
                                                    placeholder: LangHelper.GetString("QoE","now"),
                                                    validate: webix.rules.isNotEmpty(),
                                                    invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                                                    required: true,
                                                    options: Object.keys(QoETriggerPeriodRangesEnum).reduce((acc, key) => {
                                                        acc.push({id:key, value:LangHelper.GetString("QoE",key)});
                                                        return acc;
                                                    }, []),
                                                    on: {
                                                        onChange: function() {
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            cols: [
                {
                    name: "max_exec_time_sec",
                    view: "richselect",
                    label: LangHelper.GetString("QoE", "Maximum execute time"),
                    labelPosition: "top",
                    options: ReportTaskMaxExecTime.reduce((acc, num) => {
                        let langKey = num.toString() + " hour" + (num > 1 ? "s" : "");
                        let _id = num * 60 * 60;
                        acc.push({id:_id, value: LangHelper.GetString("QoE", langKey)});
                        return acc;
                    }, []),
                },
                this.GetHelpBtnConfig("max_exec_time_sec"),
                {width: formWidths.empty},
                {
                    name: "lifetime_hours",
                    view: "richselect",
                    label: LangHelper.GetString("QoE", "Time to store cache"),
                    labelPosition: "top",
                    options: ReportTaskLifetime.reduce((acc, num) => {
                        let langKey = num.toString() + " day" + (num > 1 ? "s" : "");
                        let _id = num * 24;
                        acc.push({id:_id, value: LangHelper.GetString("QoE", langKey)});
                        return acc;
                    }, [])
                },
                this.GetHelpBtnConfig("lifetime_hours")
            ]
        },
        {
            cols: [
                {
                    name: "priority",
                    view: "richselect",
                    label: LangHelper.GetString("QoE", "Priority"),
                    labelPosition: "top",
                    options: {
                        body: {
                            scheme: {
                                $init: function (Obj) {
                                    if (Obj.disabled) {
                                        Obj.$css = "webix_disabled";
                                    }
                                }
                            },
                            data: ReportTaskPriorities.reduce((acc, num) => {
                                acc.push({id: num, value: num, disabled: num > 1});
                                return acc;
                            }, [])
                        },
                    },
                    on:{
                        onChange:function(Nv, Ov){
                            let item = this.getList().getItem(Nv);

                            if(item && item.disabled)
                            {
                                this.blockEvent();
                                this.setValue(Ov);
                                this.unblockEvent();
                            }
                        }
                    }
                },
                this.GetHelpBtnConfig("priority"),
                {width: formWidths.empty},
                {
                    name: "out_of_turn",
                    view: "checkbox",
                    label: LangHelper.GetString("QoE", "No queue"),
                    labelPosition: "top",
                    on: {
                        onChange: function(nV) {
                            _this.ManageFormElmnts(_this.ElmntsRelation[this.config.name], nV);
                        }
                    }
                },
                this.GetHelpBtnConfig("out_of_turn")
            ]
        },
        {
            cols: [
                {
                    rows: [
                        {
                            name: "mail_notify_enabled",
                            view: "checkbox",
                            width: formWidths.checkbox,
                            label: LangHelper.GetString("QoE", "Send to email"),
                            labelWidth: formWidths.label,
                            on: {
                                onChange: function(Nv) {
                                    _this.ManageFormElmnts(_this.ElmntsRelation[this.config.name], Nv);
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    rows: [
                        {
                            name: "mail_address",
                            view: "text",
                            placeholder: LangHelper.GetString("QoE", "Email address"),
                            required: true,
                            validate: webix.rules.isNotEmpty(),
                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                            on: {
                                onChange: function() {
                                    this.validate();
                                }
                            }

                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    rows: [
                        {
                            name: "mail_template",
                            view: "richselect",
                            placeholder: LangHelper.GetString("QoE", "Templates"),
                            required: true,
                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                            suggest: {fitMaster: false, data: []},
                            // options: [],
                            validate: webix.rules.isNotEmpty(),
                            on: {
                                onChange: function() {
                                    this.validate();
                                    _this.DefineTemplateEditBtn(
                                        _this.Views.PopupViews.Form.elements["mail_template"],
                                        _this.Views.PopupViews.MailTemplatesShowBtn
                                    );
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    id: this.Id + "PopupViews" + "MailTemplatesShowBtn",
                    view: "button",
                    type: "icon",
                    icon: "eye",
                    css: "toolbar_round_btn",
                    height: 48,
                    width: 48,
                    tooltip: LangHelper.GetString("MailingTemplates", "Show template"),
                    hidden: true,
                    click: function ()
                    {
                        let selectedId = _this.Views.PopupViews.Form.elements["mail_template"].getValue();
                        let model = _this.Views.Widgets.MailingTemplateWidget.Manager.TemplatesList.find(item => item._id == selectedId);

                        if(model)
                            _this.Views.Widgets.MailingTemplateWidget.Show(
                                model,
                                MailingTemplatesWidgetContextTypes.view_template
                            );
                    }
                },
                this.GetHelpBtnConfig("mail_notify_enabled"),
            ]
        },
        {
            cols: [
                {
                    rows: [
                        {
                            name: "tg_notify_enabled",
                            view: "checkbox",
                            width: formWidths.checkbox,
                            label: LangHelper.GetString("QoE", "Send to telegram"),
                            labelWidth: formWidths.label,
                            on: {
                                onChange: function(nV) {
                                    _this.ManageFormElmnts(_this.ElmntsRelation[this.config.name], nV);
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    rows: [
                        {
                            name: "tg_channel",
                            view: "text",
                            // placeholder: LangHelper.GetString("QoE", "Channel"),
                            placeholder: LangHelper.GetString("QoE", "Chat Id"),
                            validate: webix.rules.isNotEmpty(),
                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                            on: {
                                onChange: function() {
                                    this.validate();
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    rows: [
                        {
                            name: "tg_template",
                            view: "richselect",
                            placeholder: LangHelper.GetString("QoE", "Templates"),
                            required: true,
                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                            suggest: {fitMaster: false, data: []},
                            // options: [],
                            validate: webix.rules.isNotEmpty(),
                            on: {
                                onChange: function() {
                                    this.validate();
                                    _this.DefineTemplateEditBtn(
                                        _this.Views.PopupViews.Form.elements["tg_template"],
                                        _this.Views.PopupViews.TelegramTemplatesShowBtn
                                    );
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    id: this.Id + "PopupViews" + "TelegramTemplatesShowBtn",
                    view: "button",
                    type: "icon",
                    icon: "eye",
                    css: "toolbar_round_btn",
                    height: 48,
                    width: 48,
                    tooltip: LangHelper.GetString("MailingTemplates", "Edit template"),
                    hidden: true,
                    click: function ()
                    {
                        let selectedId = _this.Views.PopupViews.Form.elements["tg_template"].getValue();
                        let model = _this.Views.Widgets.MailingTemplateWidget.Manager.TemplatesList.find(item => item._id == selectedId);

                        if(model)
                            _this.Views.Widgets.MailingTemplateWidget.Show(
                                model,
                                MailingTemplatesWidgetContextTypes.view_template
                            );
                    }
                },
                this.GetHelpBtnConfig("tg_notify_enabled"),
            ]
        },
        {
            cols: [
                {
                    rows: [
                        {
                            name: "split_report_enabled",
                            view: "checkbox",
                            width: formWidths.checkbox,
                            label: LangHelper.GetString("QoE", "Split report"),
                            labelWidth: formWidths.label,
                            on: {
                                onChange: function(nV) {
                                    _this.ManageFormElmnts(_this.ElmntsRelation[this.config.name], nV);
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    rows: [
                        {
                            name: "split_per_days",
                            view: "text",
                            placeholder: LangHelper.GetString("QoE", "Hours"),
                            required: true,
                            disabled: true,
                            validate: webix.rules.isNumber(),
                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                            gravity: 3,
                            on: {
                                onChange: function(nV)
                                {
                                    nV = nV.replace(/[^0-9]/g, '');
                                    this.setValue(nV);

                                    this.validate();
                                }
                            }
                        },
                        {
                            name: "split_by_lines",
                            view: "text",
                            placeholder: LangHelper.GetString("QoE", "Lines"),
                            required: true,
                            disabled: true,
                            hidden: true,
                            validate: webix.rules.isNumber(),
                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                            gravity: 3,
                            on: {
                                onChange: function(nV)
                                {
                                    nV = nV.replace(/[^0-9]/g, '');
                                    this.setValue(nV);

                                    this.validate();
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    rows: [
                        {
                            name: "split_type",
                            view: "richselect",
                            placeholder: LangHelper.GetString("QoE", "Split by"),
                            required: true,
                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                            suggest: {fitMaster: false, data: []},
                            options: [
                                {id: "by_time", value: LangHelper.GetString("QoE", "By time")},
                                {id: "by_lines", value: LangHelper.GetString("QoE", "By lines")},
                            ],
                            on: {
                                onChange(nV) {
                                    _this.ReportSplitVisibilityHandler(nV);
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    rows: [
                        this.GetHelpBtnConfig("split_report_enabled"),
                        {}
                    ]
                }
            ]
        },
        {
            id: this.Id + "SplitReportOptionsLine",
            cols: [
                {
                    rows: [
                        {
                            name: "separate_delivery",
                            view: "checkbox",
                            width: formWidths.checkbox,
                            label: LangHelper.GetString("QoE", "Separate delivery"),
                            labelWidth: formWidths.label
                        }
                    ]
                },
                {}
            ]
        },
        {
            cols: [
                {
                    rows: [
                        {
                            name: "is_delayed",
                            view: "checkbox",
                            width: formWidths.checkbox,
                            label: LangHelper.GetString("QoE", "Delayed start"),
                            labelWidth: formWidths.label,
                            on: {
                                onChange: function(nV) {
                                    _this.ManageFormElmnts(_this.ElmntsRelation[this.config.name], nV);
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    rows: [
                        {
                            name: "start_after_time",
                            view: "datepicker",
                            type: "time",
                            label: LangHelper.GetString("QoE", "Time"),
                            labelWidth: formWidths.label_start_after_time,
                            validate: webix.rules.isNotEmpty(),
                            format: Helper.GetDateTimeFormat("%H:%i"),
                            placeholder: webix.Date.dateToStr(Helper.GetDateTimeFormat("%H:%i"))(new Date(new Date().getTime())),
                            on: {
                                onChange: function() {
                                    this.validate();
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                {
                    rows: [
                        {
                            name: "start_after_date",
                            view:"datepicker",
                            label: LangHelper.GetString("QoE", "Date"),
                            labelWidth: formWidths.label_start_after_date,
                            format: Helper.GetDateTimeFormat("%d.%m.%Y"),
                            placeholder: webix.Date.dateToStr(Helper.GetDateTimeFormat("%d.%m.%Y"))(new Date(new Date().getTime())),
                            validate: webix.rules.isNotEmpty(),
                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                            on: {
                                onChange: function() {
                                    this.validate();
                                }
                            }
                        }
                    ]
                },
                this.GetHelpBtnConfig("is_delayed")
            ]
        },
        {
            cols: [
                {
                    rows: [
                        {
                            name: "is_scheduled",
                            view: "checkbox",
                            width: formWidths.checkbox,
                            label: LangHelper.GetString("QoE", "Task schedule"),
                            labelWidth: formWidths.label,
                            on: {
                                onChange: function(nV) {
                                    _this.ManageFormElmnts(_this.ElmntsRelation[this.config.name], nV);
                                }
                            }
                        }
                    ]
                },
                {width: formWidths.empty},
                this.Views.Widgets.ScheduleWidget.ViewConfig,
                {
                    rows: [
                        {
                            height: 48,
                            cols: [
                                this.GetHelpBtnConfig("is_scheduled")
                            ]
                        },
                    ]
                }
            ]
        }
    ];

    this.ViewConfig = {
        view:"popup",
        id: this.Id + "Popup",
        width:900,
        height:850,
        // height:1000,
        modal:true,
        position:{
            my: "center",
            at: "center",
            of: webix.viewport
        },
        body:{
            borderless: true,
            rows: [
                BlockHeaderTemplate({
                    title:LangHelper.GetString("QoE", "Create task"),
                    icon:"list",
                    height:40}),
                {
                    id: this.Id + "PopupViews" + "Form",
                    view: "form",
                    scroll: true,
                    borderless: true,
                    elements: this.FormElements
                },
                {
                    height: 80,
                    view: "form",
                    elements: [
                        {
                            cols:[
                                {
                                    view: "button",
                                    id: this.Id + "PopupViews" + "CancelBtn",
                                    label: LangHelper.GetString("All", "Cancel"),
                                    click: function ()
                                    {
                                        _this.Views.Popup.hide();
                                    }
                                },
                                {},
                                {
                                    view: "button",
                                    id: this.Id + "PopupViews" + "SaveBtn",
                                    label: LangHelper.GetString("All", "Save"),
                                    click: function ()
                                    {
                                        _this.SaveTaskModel();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    id: this.Id + "PopupViews" + "SaveAndRunBtn",
                                    label: LangHelper.GetString("QoE", "Save and run"),
                                    click: function ()
                                    {
                                        _this.SaveTaskModel(true);
                                    }
                                },
                            ]
                        }
                    ]
                }
            ]
        }
    };

    webix.ui(this.ViewConfig);
}

QoEUserReportsFormWidget.prototype.Bind = function(ViewController = null, ViewModel = null)
{
    let _this = this;

    this.ViewController = ViewController ? ViewController : null;

    this.ViewModel = ViewModel && ViewModel.constructor.name === "QoEUserReportsManager" ? ViewModel : new QoEUserReportsManager();

    this.Views.Popup = $$(this.Id + "Popup");

    Object.keys(this.Views.Widgets).forEach(Key => {
        let w = this.Views.Widgets[Key];

        if(w && w.Bind)
            w.Bind();
    });

    Object.keys(this.Views.PopupViews).forEach(Key => {
        _this.Views.PopupViews[Key] = $$(_this.Id + "PopupViews" + Key)
    });

    this.Views.PopupViews.ExtendedFilterBtn = this.Views.Widgets.ExtendedFillter.Views.FilterBtn;

    Object.keys(this.Views.PopupViews.Form.elements).forEach(Key => {
        _this.FormValuesStore[Key] = [];
    });

    this.Subscriptions.WidgetsListSelectSignal = this.Views.Widgets.WidgetsSuggest.Signals.Select.subscribe(function (Update) {
        if (Update)
            _this.SetReportFormRow();
    });

    this.Views.Popup.attachEvent("onShow", function() {
        _this.DefineSuggestInputIcon();
    });

    if (this.ViewController && this.AllowedViewControllers.includes(this.ViewController.constructor.name)) {
        let isQoEAnyReport = this.ViewController.constructor.name === "QoEAnyReportViewController";
        let isQoeCustomReports = this.ViewController.constructor.name === "QoECustomReportsViewController";

        let signals = [this.Views.Widgets.WidgetsSuggest.Signals.WidgetsUpdated]

        if (isQoEAnyReport)
            signals.push(this.ViewController.Signals.ReportReady); // SignalS
        else if (isQoeCustomReports)
            signals.push(this.ViewController.Signal.ReportReady); // Signal
        else
            signals.push(this.ViewController.ReportsListSelectedCount);

        this.Subscriptions.ReportSelectedSignal = Rx.Observable.combineLatest(...signals).subscribe(function (Val) {
            if (Val.every(Boolean)) {
                if (_this.ViewController.ReportsSettings.IsWidgetEnabled) {
                    let find = _this.FindSuggestItem(isQoEAnyReport, isQoeCustomReports);

                    if (find.suggest_item && find.suggest_widget)
                        _this.ViewController.ReportsSettings.Views.GeneralSettings.SettingsMenu.enableItem(
                            GeneralReportSettingsEnum.create_report_task.id
                        );
                    else
                        _this.ViewController.ReportsSettings.Views.GeneralSettings.SettingsMenu.disableItem(
                            GeneralReportSettingsEnum.create_report_task.id
                        );
                }
            }
        });

        this.ViewController.ReportsSettings.Views.GeneralSettings.SettingsMenu.attachEvent("onMenuItemClick", function (id) {
            if (id === GeneralReportSettingsEnum.create_report_task.id) {
                let model = _this.GetTaskModelFromViewController(isQoEAnyReport, isQoeCustomReports);
                _this.ShowPopup(model);
            }
        });

        this.Views.PopupViews.Form.elements["suggest_input"].disable();
    }

    this.Subscriptions.SaveTaskSuccess = this.ViewModel.Signals.SaveTaskSuccess.subscribe(function (Model) {
        if (Model && !EnabledReportTaskStates.includes(Model.state))
            webix.message(LangHelper.GetString("QoE", "Task successfully saved") + ".");
        else if (Model)
            webix.message(LangHelper.GetString("QoE", "Task successfully saved") + " " +
                LangHelper.GetString("QoE", "and run") + ".");
    });

    this.Subscriptions.SaveTaskError = this.ViewModel.Signals.SaveTaskError.subscribe(function (Error) {
        if (Error && Error.msg)
            webix.message({type: "error", text: Error.msg});
    });

    this.Subscriptions.UpdateTemplatesSuccess = this.Views.Widgets.MailingTemplateWidget.Manager.Signals.RefreshTemplatesListSuccess.subscribe(function(Update) {
       if(Update)
           _this.UpdateTemplatesSelects();
    });

    this.Subscriptions.UpdateTemplatesError = this.Views.Widgets.MailingTemplateWidget.Manager.Signals.RefreshTemplatesListError.subscribe(function(Error) {
        if (Error && Error.msg)
            webix.message({type: "error", text: Error.msg});
    });

    this.Subscriptions.SaveTaskError = this.ViewModel.Signals.ServerError.subscribe(function (Error) {
        if (Error && Error.msg)
            webix.message({type: "error", text: Error.msg});
    });

    this.Subscriptions.SaveTemplateSuccess = this.Views.Widgets.MailingTemplateWidget.Manager.Signals.SaveTemplateSuccess.subscribe(function(Model) {
        if(Model)
        {
            _this.UpdateTemplatesSelects();

            let views = {
                mail: _this.Views.PopupViews.Form.elements["mail_template"],
                telegram: _this.Views.PopupViews.Form.elements["tg_template"]
            };

            let view = views[Model.type];

            if(view && Model._id)
                view.setValue(Model._id);

            webix.message(LangHelper.GetString("MailingTemplates", "Template successfully saved."));
        }
    });

    this.Subscriptions.SaveTemplateError = this.Views.Widgets.MailingTemplateWidget.Manager.Signals.SaveTemplateError.subscribe(function(Error) {
        if(Error && Error.msg)
            webix.message({type: "error", text: Error.msg});
    });

    this.Subscriptions.AddSchedule = this.Views.Widgets.ScheduleWidget.Signals.AddSchedule.subscribe(function(Update) {
        if(Update)
            _this.Views.PopupViews.Form.scrollTo(0, Number.MAX_SAFE_INTEGER);
    });

    [this.ViewModel, this.Views.Widgets.MailingTemplateWidget.Manager].forEach((Obj, Idx) => {
        if(Obj.Signals && Obj.Signals.ServerError)
        {
            _this.Subscriptions[`ServerError${Idx}`] = Obj.Signals.ServerError.subscribe(function(Update) {
                if(Update)
                    webix.message({type: "error", text: LangHelper.GetString("All", "Server error")});
            });
        }
    });

    this.Views.Widgets.WidgetsSuggest.RefreshWidgets();
    this.Views.Widgets.MailingTemplateWidget.Manager.RefreshTemplatesList();
};

QoEUserReportsFormWidget.prototype.Destroy = function ()
{
    let _this = this;

    this.Views.Widgets.ReportsSettings.ViewModel.ResetWidget(true);

    Object.keys(this.Views.Widgets).forEach(Key => {
        let w = _this.Views.Widgets[Key];

        if(w && w.Destroy)
            w.Destroy()
    });

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        if(_this.Subscriptions[Key])
            _this.Subscriptions[Key].unsubscribe();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEUserReportsFormWidget.prototype.ShowPopup = function(Params, isCopy)
{
    this.ClearWidget();
    this.SetWidgetToDefault();
    this.Views.Widgets.MailingTemplateWidget.Manager.RefreshTemplatesList();
    this.SetWidgetByUserProfile();
    this.SetWidgetByRoleParams();
    this.SetWidget(Params, isCopy);
    this.Views.Popup.show();
};

QoEUserReportsFormWidget.prototype.SetWidget = function(Params, isCopy)
{
    let model = Params ? QoEReportTaskModel(Params) : null;

    if(model)
    {
        if(isCopy)
        {
            model.name = LangHelper.GetString("QoE", "Copy of task") + " " + model._id + " " + model.name;
            model.id = webix.uid();
            model._id = "";
            model.user_id = "";
            model.state = "";
            model.state_data = {};
            model.trigger_id = "";
            model.report_id = {};
            model.cache_lifetime = "";
            model.create_time = "";
            model.update_time = "";

            let maxPriority = this.ViewModel.GetUserMaxPriority();
            model.priority = model.priority > maxPriority ? maxPriority : model.priority;

            model.schedule_cfg = model.schedule_cfg.map(Item => {
                let _model = QoEReportScheduleModel(Item);
                _model._id = webix.uid();
                _model.state = "";
                _model.state_data = "";
                _model.trigger_id = "";
                _model.update_time = "";
                return _model;
            });
        }

        this.SelectedTaskModel = model;
        this.SetFormData(model);
        this.SetReportFormRow(model);
        this.SetPeriodFormRow(model);
        // mail
        this.SetTemplateRow({
            recipient_key: "mail_address",
            tpl_el_key: "mail_template",
            tpl_params: model.mail_notify_cfg
        });
        // telegram
        this.SetTemplateRow({
            recipient_key: "tg_channel",
            tpl_el_key: "tg_template",
            tpl_params: model.tg_notify_cfg
        });

        this.SetSplitReportFormRow(model);
        this.SetStartAfterFormRow(model);
        this.SetScheduleFormRow(model);
    }
};

QoEUserReportsFormWidget.prototype.SetFormData = function(Params)
{
    let _this = this;

    Object.keys(this.Views.PopupViews.Form.elements).forEach(Key => {
        let el = _this.Views.PopupViews.Form.elements[Key];

        if(el.isEnabled())
        {
            let val = Params && Params[Key] ? Params[Key] : "";
            val = val ? val : _this.FormDefaultState[Key] ? _this.FormDefaultState[Key] : "";

            el.setValue(val);

            if(!_this.FormValuesStore[Key] || !Array.isArray(_this.FormValuesStore[Key]))
                _this.FormValuesStore[Key] = []

            _this.FormValuesStore[Key].push(val);
        }
    });
};

QoEUserReportsFormWidget.prototype.SetReportFormRow = function(Params)
{
    let _this = this;

    let isSuccess = false;
    let model = Params ? QoEReportTaskModel(Params) : null;

    this.Views.Widgets.ReportsSettings.ViewModel.ResetWidget(true);

    if(model)
    {
        let find = this.Views.Widgets.WidgetsSuggest.FindItemByParams({
            widget_code: model.query_cfg.widget_code,
            widget_name: model.query_cfg.widget_name,
            widget_func:model.query_cfg.func
        });

        if(!find && model.query_cfg.suggest_widget && model.query_cfg.suggest_widget.func)
            find = this.Views.Widgets.WidgetsSuggest.FindItemByConfig({
                func: model.query_cfg.suggest_widget.func
            });

        if(find)
            this.Views.Widgets.WidgetsSuggest.SelectItem(find.id);
    }

    let selected = this.Views.Widgets.WidgetsSuggest.GetSelectedItem();

    if(selected)
    {
        if(window[selected.func])
        {
            let widget;
            const type = selected.widget_icon ? selected.widget_icon : "";
            const wFunc = selected.func;
            const wId = this.Id + wFunc;
            const wParams = selected.widget_settings ? selected.widget_settings : {};

            if(!window[wFunc])
                return;

            wParams.id = wId;
            widget = new window[wFunc](wParams);

            if(widget)
            {
                let find = Object.values(WidgetTypesMap).find(i => i.type === type);
                widget = find && Object.hasOwn(widget, find.prop) ? widget[find.prop] : widget;

                let params = {
                    show_settings_btn: this.Views.PopupViews.ReportsSettingsBtn,
                    can_update_widget: false,
                    suggest_widget_code: selected.widget_code,
                    suggest_widget_func: selected.func
                }

                let settingsModel = this.Views.Widgets.ReportsSettings.ViewModel.InitReportsSettingsModel(
                    widget,
                    params
                );

                if(settingsModel)
                {
                    settingsModel.ResetShowBtnEvent();

                    settingsModel.BindShowBtnEvent(function() {
                        _this.Views.Widgets.ReportsSettings.ShowReportSettingsPopup(settingsModel.widget_id);
                    });

                    if(model) {
                        const rSettings = model.query_cfg.report_settings;
                        if(Helper.IsChartWidget(widget) && !rSettings.chart_sort_dir)
                            rSettings.chart_sort_dir = SortDirectionSettingsEnum.desc.id;
                        settingsModel.SetCurState(rSettings);
                    }

                    settingsModel.DefineSettingsBtnBadge();

                    let config = QoEPopupFilterWidgetDefaultConfig(selected.filter_type, true);

                    if(!config && selected.filter_config)
                        config = selected.filter_config;

                    if(!config)
                        config = QoEPopupFilterWidgetDefaultConfig();

                    this.Views.Widgets.ExtendedFillter.SetConfig(config);


                    if(model) {
                        this.Views.Widgets.ExtendedFillter.SetState(model.query_cfg.filter_state);
                        this.Views.Widgets.ExtendedFillter.SetFilterBtnBage();
                    }

                    this.SetWidgetSuggestInput();
                    isSuccess = true;
                }
            }
        }
    }

    this.DefineSuggestInputIcon();

    if(!isSuccess)
        this.ClearWidget();
};

QoEUserReportsFormWidget.prototype.SetPeriodFormRow = function(Params)
{
    let _this = this;

    let keys = ["period_from", "period_to", "schedule_period_from", "schedule_period_to"];

    let config = Params && Params.query_cfg ? Params.query_cfg : null;

    keys.forEach(Key => {
        if(config && config[Key])
        {
            _this.Views.PopupViews.Form.elements[Key].blockEvent();
            _this.Views.PopupViews.Form.elements[Key].setValue(config[Key]);
            _this.Views.PopupViews.Form.elements[Key].unblockEvent();
        }
    });
};

QoEUserReportsFormWidget.prototype.SetTemplateRow = function(Params)
{
    let tplManager = this.Views.Widgets.MailingTemplateWidget.Manager;
    let tplModel = Params.tpl_params;

    //backward
    if(tplModel.template_id)
    {
        let defaultTemplatesList = tplManager.DefaultTemplatesList.filter(Item => Item.type === tplModel.type);

        let find = defaultTemplatesList
            .find(Item => Item.options && Item.options.backward_template_id == tplModel.template_id);

        if(find)
            tplModel.tpl_model = find;
    }

    this.Views.PopupViews.Form.elements[Params.recipient_key].setValue(tplModel[Params.recipient_key]);

    if(tplModel.tpl_model)
    {
        let find;

        if(tplModel.tpl_model.is_system)
            find = tplManager.TemplatesList.filter(Item => !!(Item.is_system))
                .find(Item => Item.options.template_id === tplModel.tpl_model.options.template_id);
        else if(tplModel.tpl_model._id)
            find = tplManager.TemplatesList.find(Item => Item._id == tplModel.tpl_model._id);

        if(find)
            this.Views.PopupViews.Form.elements[Params.tpl_el_key].setValue(find._id);
    }
};

QoEUserReportsFormWidget.prototype.SetSplitReportFormRow = function(Params)
{
    let config = Params && Params.split_report_cfg ? Params.split_report_cfg : null;

    if(config && config.split_per_days)
    {
        this.Views.PopupViews.Form.elements["split_type"].setValue("by_time");
        this.Views.PopupViews.Form.elements["split_per_days"].setValue(config.split_per_days);
    }
    else if(config && config.split_by_lines)
    {
        this.Views.PopupViews.Form.elements["split_type"].setValue("by_lines");
        this.Views.PopupViews.Form.elements["split_by_lines"].setValue(config.split_by_lines);
    }

    if(config && config.separate_delivery)
        this.Views.PopupViews.Form.elements["separate_delivery"].setValue(config.separate_delivery);
};

QoEUserReportsFormWidget.prototype.SetStartAfterFormRow = function(Params)
{
    let value = Params && Params.start_after ? Params.start_after : null;

    if(value)
    {
        this.Views.PopupViews.Form.elements["is_delayed"].setValue(1);

        let dateTime = Helper.DateTimeToLocal(value)

        this.Views.PopupViews.Form.elements["start_after_time"].blockEvent();
        this.Views.PopupViews.Form.elements["start_after_time"].setValue(dateTime);
        this.Views.PopupViews.Form.elements["start_after_date"].setValue(dateTime);
        this.Views.PopupViews.Form.elements["start_after_time"].unblockEvent();
    }
};

QoEUserReportsFormWidget.prototype.SetScheduleFormRow = function(Params)
{
    if(Params && Params.schedule_cfg && Params.schedule_cfg.length)
        this.Views.Widgets.ScheduleWidget.SetScheduleData(Params.schedule_cfg);

    this.Views.PopupViews.Form.elements["is_scheduled"].setValue(Params && Params.is_scheduled ? 1 : 0);
};

QoEUserReportsFormWidget.prototype.SaveTaskModel = function(IsTaskToRun = false)
{
    let check = [
        this.Views.PopupViews.Form.validate()
    ];

    if(this.Views.PopupViews.Form.elements["is_scheduled"].getValue())
        check.push(this.Views.Widgets.ScheduleWidget.Validate());
    else
        check.push(this.ValidatePeriodBoth());

    if(check.every(Boolean))
    {
        let model = this.GetTaskModel(IsTaskToRun);
        if(model === null)
        {
            return;
        }
        this.ViewModel.SaveTask(model, IsTaskToRun);
        this.Views.Popup.hide();
    }
};

QoEUserReportsFormWidget.prototype.GetTaskModel = function(IsTaskToRun = false)
{
    let formData = this.GetFormData();

    let model = QoEReportTaskModel(webix.extend(this.SelectedTaskModel, formData, true));

    model.query_cfg = this.Views.PopupViews.Form.elements["suggest_input"].getValue() ? this.GetQueryCfg() : {};

    model.mail_notify_cfg = model.mail_notify_enabled ? this.GetMailNotifyCfg() : {};

    model.tg_notify_cfg = model.tg_notify_enabled ? this.GetTgNotifyCfg() : {};

    model.split_report_cfg = model.split_report_enabled ? this.GetSplitReportCfg() : {};

    model.start_after = "";

    if(model.split_report_enabled && model.split_report_cfg.split_per_days)
    {
        var view = this.Views.PopupViews.Form.elements.split_per_days;
        var dt_from = (new Date(model.query_cfg.period_from)).getTime();
        var dt_to = (new Date(model.query_cfg.period_to)).getTime();

        var splt = parseInt(model.split_report_cfg.split_per_days) * 60 * 60 * 1000;

        var total_q = (dt_to - dt_from) / splt;

        if(total_q > 100)
        {
            var msg = LangHelper.GetString('QoE', 'Max available number of queries is 100.');
            view.define({invalidMessage: msg});
            view.refresh();
            this.Views.PopupViews.Form.markInvalid(view.config.name, true);
            webix.message({type: "error", text: LangHelper.GetString('QoE', 'Max available number of queries is 100.')});
            return null;
        }

        this.Views.PopupViews.Form.markInvalid(view.config.name, false);
    }


    if(formData.start_after_date && formData.start_after_time)
    {
        formData.start_after_date.setHours(
            formData.start_after_time.getHours(),
            formData.start_after_time.getMinutes(),
            formData.start_after_time.getSeconds()
        );

        let format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

        model.start_after = Helper.LocalDateTimeToUtc(formData.start_after_date);
        model.start_after = format(model.start_after);
    }

    model.schedule_cfg = this.Views.Widgets.ScheduleWidget.GetScheduleData()

    model.state = IsTaskToRun ? ReportTasksStates.new.id : ReportTasksStates.disabled.id;

    model.cache_lifetime = "";

    if(!model.user_id)
    {
        let userData = App.SessionManager.GetProfile();
        model.user_id = userData && userData.user_id ? userData.user_id : "";
    }

    ["query_cfg", "mail_notify_cfg", "tg_notify_cfg", "state_data",
        "split_report_cfg", "state_data", "report_id", "schedule_cfg"].forEach(Key => {
        if (model[Key] && typeof model[Key] !== "string") {
            try {
                model[Key] = JSON.stringify(model[Key]);
            } catch (e) {
                model[Key] = "";
            }
        }
    });

    return model;
};

QoEUserReportsFormWidget.prototype.GetFormData = function()
{
    let _this = this;

    let params = {};

    Object.keys(this.Views.PopupViews.Form.elements).forEach(Key => {
        params[Key] = _this.Views.PopupViews.Form.elements[Key].getValue();
    });

    return params;
};

QoEUserReportsFormWidget.prototype.GetQueryCfg = function()
{
    let params = {};

    const selected = this.Views.Widgets.WidgetsSuggest.GetSelectedItem();
    const models = Object.values(this.Views.Widgets.ReportsSettings.ViewModel.ReportsSettings);

    const settingsModel =
           models.find(model => model.suggest_widget_code === selected.widget_code)
        || models.find(model => model.suggest_widget_func === selected.widget_func);

    if(settingsModel)
    {
        const settingsState = settingsModel.GetReportSettings();
        const pdfConfig = settingsModel.GetPdfExportConfig(this.Views.Widgets.ExtendedFillter);
        const filterSettings = this.Views.Widgets.ExtendedFillter.GetFilters();
        const fType = selected.filter_config && selected.filter_config.type
            ? selected.filter_config.type
            : selected.filter_type;

        params = QoEReportTaskQueryCfgModel({
            config: settingsModel.widget.Config,
            filter_type: fType,
            filter_state: this.Views.Widgets.ExtendedFillter.GetState(),
            filter_settings: filterSettings ? filterSettings : {},
            filter_settings_enabled: filterSettings && Object.keys(filterSettings).length ? 1 : 0,
            report_settings: settingsState ? settingsState : {},
            report_settings_enabled: Number(settingsModel.IsDiffWithDefault()),
            widget_pdf_config: pdfConfig ? pdfConfig : {},
            widget_code: selected ? selected.widget_code : "",
            widget_name: settingsModel ? settingsModel.widget.Name : "",
            widget_func: selected ? selected.func : "",
            suggest_widget: selected ? selected : {},
            widget_filter: settingsModel.widget.Filter
        });

        if(this.Views.PopupViews.Form.elements["is_scheduled"].getValue()) {
            params.schedule_period_from = this.Views.PopupViews.Form.elements["schedule_period_from"].getValue();
            params.schedule_period_to = this.Views.PopupViews.Form.elements["schedule_period_to"].getValue();
        } else {
            params.period_from = this.FormatDate(this.Views.PopupViews.Form.elements["period_from"].getValue());
            params.period_to = this.FormatDate(this.Views.PopupViews.Form.elements["period_to"].getValue());
        }

        params.config = settingsModel.ReconfigReportQuery(params.config);
    }

    return params;
};

QoEUserReportsFormWidget.prototype.GetTemplateModel = function(SelectedType)
{
    let tpl_model = null;
    let selected = this.Views.PopupViews.Form.elements[SelectedType].getValue();

    if(selected)
        tpl_model = this.Views.Widgets.MailingTemplateWidget.Manager.TemplatesList.find(Item => Item._id == selected)

    return tpl_model
};

QoEUserReportsFormWidget.prototype.GetMailNotifyCfg = function()
{
    let res = {};
    let tplModel = this.GetTemplateModel("mail_template");

    if(tplModel)
        res = QoEReportTaskMailNotifyCfgModel({
            mail_address: this.Views.PopupViews.Form.elements["mail_address"].getValue(),
            tpl_model: tplModel ? tplModel : null
        });

    return res;
};

QoEUserReportsFormWidget.prototype.GetTgNotifyCfg = function()
{
    let res = {};
    let tplModel = this.GetTemplateModel("tg_template");

    if (tplModel)
        res = QoEReportTaskTgNotifyCfgModel({
            tg_channel: this.Views.PopupViews.Form.elements["tg_channel"].getValue(),
            tpl_model: tplModel ? tplModel : null
        });

    return res;
};

QoEUserReportsFormWidget.prototype.GetSplitReportCfg = function()
{
    let type = this.Views.PopupViews.Form.elements["split_type"].getValue();

    let model = QoEReportTaskSplitReportCfgModel();

    if(type && type === "by_time")
        model.split_per_days = this.Views.PopupViews.Form.elements["split_per_days"].getValue();
    else if(type && type === "by_lines")
        model.split_by_lines = this.Views.PopupViews.Form.elements["split_by_lines"].getValue();

    model.separate_delivery = this.Views.PopupViews.Form.elements["separate_delivery"].getValue();

    return model;
};

QoEUserReportsFormWidget.prototype.ClearWidget = function()
{
    let _this = this;

    this.Views.Widgets.WidgetsSuggest.UnselectAll();

    this.Views.Widgets.ExtendedFillter.SetState();
    this.Views.Widgets.ExtendedFillter.ResetState();

    this.Views.Widgets.ReportsSettings.ViewModel.ResetWidget(true);

    this.Views.PopupViews.ReportsSettingsBtn.define({badge: 0});
    this.Views.PopupViews.ReportsSettingsBtn.refresh();

    this.SelectedTaskModel = {};

    Object.keys(this.FormValuesStore).forEach(Key => {
        _this.FormValuesStore[Key] = [];
    });

    Object.keys(this.Views.PopupViews.Form.elements).forEach(Key => {
        _this.Views.PopupViews.Form.elements[Key].setValue("");
    });

    this.Views.PopupViews.Form.clearValidation();

    this.Views.Widgets.ScheduleWidget.ClearWidget();
};

QoEUserReportsFormWidget.prototype.SetWidgetToDefault = function()
{
    let _this = this;

    Object.values(this.ElmntsRelation).forEach(Val => {
        _this.ManageFormElmnts(Val, 0);
    });

    Object.keys(this.Views.PopupViews.Form.elements).forEach(Key => {
        let val = _this.FormDefaultState[Key] ? _this.FormDefaultState[Key] : "";
        let el = _this.Views.PopupViews.Form.elements[Key];

        if(el.isEnabled())
            el.setValue(val);
    });
};

QoEUserReportsFormWidget.prototype.SetWidgetByUserProfile = function()
{
    let userData = App.SessionManager.GetProfile();

    if(userData && userData.email)
        this.FormValuesStore["mail_address"].push(userData.email);
};

QoEUserReportsFormWidget.prototype.SetWidgetByRoleParams = function()
{
    let maxPriority = this.ViewModel.GetUserMaxPriority();

    let el = this.Views.PopupViews.Form.elements["priority"];
    let suggestList = $$(el.config.suggest).getList();

    let data = ReportTaskPriorities.reduce((acc, num) => {
        acc.push({id:num, value:num, disabled: num > maxPriority});
        return acc;
    }, []);

    suggestList.clearAll();
    suggestList.parse(data);

    if(this.ViewModel.CanUserEnableOutOfTurn())
        this.Views.PopupViews.Form.elements["out_of_turn"].enable();
    else
        this.Views.PopupViews.Form.elements["out_of_turn"].disable();
};

QoEUserReportsFormWidget.prototype.ManageFormElmnts = function(ElmntsParams, IsEnabled = false)
{
    let _this = this;

    let isEnabled = (typeof IsEnabled === "string" && isNaN(Number(IsEnabled)))
        ? IsEnabled.length > 0
        : Boolean(Number(IsEnabled));

    let clearEl = function(Type, View, Key)
    {
        if(Type === "elmnts")
        {
            _this.FormValuesStore[Key].push(View.getValue());
            View.blockEvent();
            View.setValue("");
            View.unblockEvent();
            _this.Views.PopupViews.Form.markInvalid(Key, false);
            View.define({required: false});
            View.refresh();
        }

        View.disable();
    };

    let setEl = function(Type, View, Key)
    {
        if(Type === "elmnts")
        {
            let lastVal = _this.FormValuesStore[Key].length ? _this.FormValuesStore[Key].pop() : "";
            let val = lastVal ? lastVal : _this.FormDefaultState[Key] ? _this.FormDefaultState[Key] : "";

            View.blockEvent();
            View.setValue(val);
            View.unblockEvent();
            View.define({required: true});
            View.refresh();
        }

        View.enable();
    };

    if(ElmntsParams)
    {
        let funcs = [setEl, clearEl];

        if(ElmntsParams.reverse)
            funcs.reverse();

        let func = isEnabled ? funcs[0] : funcs[1];

        ["elmnts", "views"].forEach(Type => {
           if(ElmntsParams[Type] && ElmntsParams[Type].length)
               ElmntsParams[Type].forEach(Key => {
                    let view = Type === "elmnts" ? _this.Views.PopupViews.Form.elements[Key] : _this.Views.PopupViews[Key];

                    func(Type, view, Key);
               });
        });
    }

    if(isEnabled && ElmntsParams.exclude_elmnts)
    {
        ElmntsParams.exclude_elmnts.forEach(Key => {
            let view = _this.Views.PopupViews.Form.elements[Key];
            view.setValue("")
        });
    }

    if(ElmntsParams.funcs && ElmntsParams.funcs.length)
    {
        ElmntsParams.funcs.forEach(Func => Func(isEnabled));
    }
};

QoEUserReportsFormWidget.prototype.SetWidgetSuggestInput = function()
{
    let lastVal = this.Views.PopupViews.Form.elements["suggest_input"].getValue();
    let dscpVal = this.Views.PopupViews.Form.elements["name"].getValue();

    let item = this.Views.Widgets.WidgetsSuggest.GetSelectedItem();

    let locale = LangHelper.GetLocale();
    let value = item && item.widget_name ? item.widget_name[locale] : "";

    this.Views.PopupViews.Form.elements["suggest_input"].setValue(value);

    if(["", lastVal].includes(dscpVal))
        this.Views.PopupViews.Form.elements["name"].setValue(value);
};

QoEUserReportsFormWidget.prototype.FindSuggestItem = function(IsQoEAnyReport, isQoeCustomReports)
{
    let findData = {
        type: null,
        suggest_item: null,
        suggest_widget: null
    };

    let widgetList, widgetItems;
    let isTrafficSpeedGroup = false;
    let cellId = null;

    const getItem = (widget = null, type = null) => ({ widget, type });

    if(IsQoEAnyReport)
    {
        widgetList = Object.values(this.ViewController.Views.Widgets);
    }
    else if(isQoeCustomReports)
    {
        const w = this.ViewController.GetSelectedWidget();
        if(w)
            widgetList = [w];
    }
    else
    {
        let selected = this.ViewController.GetReportsListSelectedItem();

        if(selected)
        {
            if(selected.$parent === "QoEFullNetFlowReportsCellsTrafficGroup")
                isTrafficSpeedGroup = true;

            cellId = Helper.ReplaceAll("Group", "", selected.id);
            widgetList = this.ViewController.ReportsCellsReportMap[cellId];
        }
    }

    if(!widgetList || !widgetList.length)
        return findData;

    widgetItems = widgetList.reduce((acc, w) => {
        if(w.constructor.name === "QoETableChartWidget")
        {
            let find = w.SuggestType ? Object.values(WidgetTypesMap).find(Item => Item.type === w.SuggestType) : null;

            if(find)
            {
                acc.push(getItem(w, find.type));
            }
            else if(isTrafficSpeedGroup || isQoeCustomReports)
            {
                acc.push(getItem(w, WidgetTypesMap["QoESeriesChartReportWidget"].type));
            }
            else
            {
                ["QoETableReportWidget", "QoESeriesChartReportWidget"].forEach(Key => {
                    const prop = WidgetTypesMap[Key].prop;
                    const type = WidgetTypesMap[Key].type;

                    if(w[prop])
                        acc.push(getItem(w[prop], type))
                });
            }
        }
        else
        {
            acc.push(getItem(
                w,
                WidgetTypesMap[w.constructor.name] ? WidgetTypesMap[w.constructor.name].type : null
            ));
        }
        return acc;
    }, []);

    if(!widgetItems || !widgetItems.length)
        return findData;

    for (let item of widgetItems)
    {
        if(item.widget && item.widget.Name && item.type)
        {
            let find = this.Views.Widgets.WidgetsSuggest.FindItemByConfig({
                func: item.widget.Name,
                widget_icon: item.type
            });

            if(!find && isQoeCustomReports)
                find = this.Views.Widgets.WidgetsSuggest.FindItemByConfig({
                    widget_code: item.widget.Id,
                    widget_icon: item.type
                });

            if(find) {
                findData.type = item.type;
                findData.suggest_item = find;
                findData.suggest_widget = item.widget;
                break;
            }
        }
    }

    return findData;
};

QoEUserReportsFormWidget.prototype.GetTaskModelFromViewController = function(IsQoEAnyReport, isQoeCustomReports)
{
    let model = {};

    let find = this.FindSuggestItem(IsQoEAnyReport, isQoeCustomReports);

    if(find.suggest_item && find.suggest_widget && find.type)
    {
        let childWidget = null;

        if(find.suggest_widget.constructor.name === "QoETableChartWidget")
        {
            let typeObj = Object.values(WidgetTypesMap).find(Item => Item.type === find.type);
            childWidget = find.suggest_widget[typeObj.prop];
        }

        let settingsWidget = this.ViewController.ReportsSettings;

        let filterWidget = (IsQoEAnyReport || isQoeCustomReports)
            ? this.ViewController.Views.ExtendedFillter
            : this.ViewController.Views.Widgets.ExtendedFillter;

        let periodWidget = (IsQoEAnyReport || isQoeCustomReports)
            ? this.ViewController.Views.DateRangePicker
            : this.ViewController.Views.Widgets.DateRangePicker;

        let periodData = periodWidget ? periodWidget.GetValue() : {};
        let settingsWidgetId = childWidget ? childWidget.Id : find.suggest_widget.Id;
        let settingsModel = settingsWidget ? settingsWidget.ViewModel.ReportsSettings[settingsWidgetId] : null;

        let query_cfg = QoEReportTaskQueryCfgModel({
            widget_code: find.suggest_item.widget_code ? find.suggest_item.widget_code : "",
            widget_name: find.suggest_widget.Name ? find.suggest_widget.Name : "",
            widget_func: find.suggest_item.func ? find.suggest_item.func : "",
            period_from: periodData.start ? periodData.start : "",
            period_to: periodData.end ? periodData.end : "",
            filter_settings: filterWidget && filterWidget.Config ? webix.copy(filterWidget.Config) : {},
            filter_state: filterWidget && filterWidget.State ? webix.copy(filterWidget.State) : {},
            report_settings: settingsModel ? settingsModel.GetReportSettings() : {},
            suggest_widget: find.suggest_item
        });

        model = QoEReportTaskModel({query_cfg:query_cfg});
    }

    return model;
};

QoEUserReportsFormWidget.prototype.ValidatePeriod = function(Key)
{
    let _this = this;

    let view = this.Views.PopupViews.Form.elements[Key];

    let msg = "";
    let form = _this.Views.PopupViews.Form;
    let format = webix.Date.strToDate(Helper.GetDateTimeFormat());
    let val = view.getText();


    if(!val)
        msg = LangHelper.GetString("QoE", "The field cannot be empty");
    else if(!Helper.IsValidDateStr(val, Helper.GetDateTimeFormat()) || !Helper.ValidateDateTimeInput(val))
        msg = LangHelper.GetString("QoE", "Enter valid date, example: ") +
            webix.Date.dateToStr(Helper.GetDateTimeFormat())(new Date(new Date().getTime() - (60 * 60 * 1000)));


    if(msg)
    {
        view.define({invalidMessage: msg});
        view.refresh();
        view.setValue("");
        form.markInvalid(view.config.name, true);
    }
    else
    {
        form.markInvalid(view.config.name, false);
        view.setValue(format(val));
    }

    return !msg;
};

QoEUserReportsFormWidget.prototype.ValidatePeriodBoth = function(ValidateSingle = true)
{
    let _this = this;

    let keys = ["period_from", "period_to"];
    let form = _this.Views.PopupViews.Form;
    let format = webix.Date.strToDate(Helper.GetDateTimeFormat());

    if(ValidateSingle)
    {
        let res = keys.map(K => _this.ValidatePeriod(K));

        if(!res.every(Boolean))
            return false;
    }

    let vals = keys.map(K => form.elements[K].getText());
    let check_vals = keys.map(K => form.elements[K].getValue())

    if(vals.length === 2 && vals.every(Boolean))
    {
        var period_from = new Date(check_vals[0]);
        var period_to = new Date(check_vals[1]);

        if(period_from >= period_to)
        {
            keys.forEach((K, Idx) => {
                form.elements[K].define({invalidMessage: LangHelper.GetString("QoE", "The period is incorrect")});
                form.elements[K].refresh();
                form.markInvalid(K, true);
                form.elements[K].setValue(format(vals[Idx]));
            });

            return false;
        }
    }

    keys.forEach((K, Idx) => {
        form.markInvalid(K, false);
    });

    return true;
};

QoEUserReportsFormWidget.prototype.DefineTemplateEditBtn = function(SelectView, BtnView)
{
    if(SelectView && BtnView)
    {
        let val = SelectView.getValue();
        let find = this.Views.Widgets.MailingTemplateWidget.Manager.TemplatesList.find(item => item._id == val);

        if(find)
            BtnView.show();
        else
            BtnView.hide();
    }
};

QoEUserReportsFormWidget.prototype.GetTemplateEditBtnVisibilityHandler = function(SelectElId, BtnId)
{
    let _this = this;

    return function() {
        let selectedId = _this.Views.PopupViews.Form.elements[SelectElId];
        let btnView = _this.Views.PopupViews[BtnId];

        _this.DefineTemplateEditBtn(selectedId, btnView);
    }
};

QoEUserReportsFormWidget.prototype.GetTemplateAddBtnVisibilityHandler = function(CheckBoxId, BtnId)
{
    let _this = this;

    return function() {
        let btnView = _this.Views.PopupViews[BtnId];
        let checkBoxView = _this.Views.PopupViews.Form.elements[CheckBoxId];

        if(checkBoxView && btnView)
        {
            if(checkBoxView.getValue())
                btnView.show();
            else
                btnView.hide();
        }
    }
};

QoEUserReportsFormWidget.prototype.DefineSuggestInputIcon = function()
{
    let view = this.Views.PopupViews.Form.elements["suggest_input"];

    if(view.isVisible())
    {
        let selected = this.Views.Widgets.WidgetsSuggest.GetSelectedItem();

        let elNode = view.getNode();
        let inputNode = elNode.querySelector("input");
        let inputWrapperNode =  inputNode.parentNode;

        let existingIcon = inputWrapperNode.querySelector(".webix_icon");

        if(existingIcon)
            inputWrapperNode.removeChild(existingIcon);

        if(selected && selected.widget_icon)
        {
            inputWrapperNode.style.display = "flex";
            inputWrapperNode.style.alignItems = "center";
            inputWrapperNode.style.gap = "3px";

            let iconNode = document.createElement("span");
            iconNode.className = "webix_icon fa-" + selected.widget_icon;
            iconNode.style.paddingLeft = "2px";

            inputWrapperNode.insertBefore(iconNode, inputNode);
        }
    }
};

QoEUserReportsFormWidget.prototype.UpdateTemplatesSelects = function()
{
    const props = {
        mail_template: MailingTemplatesTypesEnum.mail,
        tg_template: MailingTemplatesTypesEnum.telegram
    };

    let _this = this;

    Object.entries(props).forEach(([FormProp, Type]) => {
        const el = _this.Views.PopupViews.Form.elements[FormProp];
        const data = _this.Views.Widgets.MailingTemplateWidget.Manager.TemplatesList
            .sort((a, b) => b.is_system - a.is_system)
            .filter(item => item.type === Type)
            .map(item => ({ id: item._id, value: item.name }));

        let maxLengthVal ="";
        data.forEach(Item => {
            if(Item.value.length > maxLengthVal.length)
                maxLengthVal = Item.value;
        });

        let widths = [
            el.getParentView().$width,
            webix.html.getTextSize(maxLengthVal, "webix_list_item").width + 35
        ].filter(Item => typeof Item === "number" && !isNaN(Item));

        el.define({suggest: {fitMaster: false, data: data, width: widths.length ? Math.max(widths) : 200}});
        el.refresh();
    });
};

QoEUserReportsFormWidget.prototype.ScheduleVisibilityHandler = function(isEnabled)
{
    let _this = this;

    if(isEnabled){
        ["period_from", "period_to"].forEach(Key => {
            _this.Views.PopupViews.Form.elements[Key].disable();
        });
        ["schedule_period_from", "schedule_period_to"].forEach(Key => {
            _this.Views.PopupViews.Form.elements[Key].enable();
        });
        this.Views.PopupViews.FormSchedulePeriodsTab.show();
        this.Views.Widgets.ScheduleWidget.EnableForm();
    } else {
        ["period_from", "period_to"].forEach(Key => {
            _this.Views.PopupViews.Form.elements[Key].enable();
        });
        ["schedule_period_from", "schedule_period_to"].forEach(Key => {
            _this.Views.PopupViews.Form.elements[Key].disable();
        });
        this.Views.PopupViews.FormDatePeriodsTab.show();
        this.Views.Widgets.ScheduleWidget.DisableForm();
    }
};

QoEUserReportsFormWidget.prototype.ReportSplitVisibilityHandler = function(isEnabled, SplitType = null)
{
    let _this = this;

    const getElement = (Key) => _this.Views.PopupViews.Form.elements[Key];
    const markValid = (Key) => _this.Views.PopupViews.Form.markInvalid(Key, false);

    const enable = (Key) => {
        let el = getElement(Key);

        if(el) {
            el.show();
            el.enable();
        }
    };

    const disable = (Key, NeedHide=true) => {
        let el = getElement(Key);

        if(el) {
            markValid(Key)
            el.disable();
            el.disable();

            if(NeedHide)
                el.hide();
        }
    }

    const clear = (Key) => {
        let el = getElement(Key);
        el.blockEvent();
        el.setValue("");
        el.unblockEvent();
    }

    if(!SplitType)
    {
        let el = getElement("split_type");
        if(el)
            SplitType = el.getValue();
    }

    switch(SplitType)
    {
        case "by_time":
            disable("split_by_lines");
            enable("split_per_days");
            break;
        case "by_lines":
            disable("split_per_days");
            enable("split_by_lines");
            break;
        default:
            disable("split_per_days", false);
            disable("split_by_lines", false);
            clear("split_per_days");
            clear("split_by_lines");
            clear("separate_delivery");
    }
};

QoEUserReportsFormWidget.prototype.ReportSeparateDeliveryHandler = function(isEnabled)
{
    let lineEl = $$(this.Id + "SplitReportOptionsLine");
    let checkBoxEl = this.Views.PopupViews.Form.elements["separate_delivery"];

    if(isEnabled)
    {
        lineEl.show();
        checkBoxEl.enable();
    }
    else
    {
        checkBoxEl.disable();
        lineEl.hide();
    }
};


function QoEUserReportsTable(Params)
{
    let params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"QoeUserReportsTable",
        hideExport:true,
        config:{
            model: QoEReportTaskViewModel,
            method:function ()
            {
                return "GetQoEReportsViewList";
            },
            sort:{id:"_id",dir:"desc"},
        },
        columns:[
            {
                id:"checked",
                header: "",
                // header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"},""],
                template: CellColoredCheckBoxTemplate,
                width: 32
            },
            {
                id: "edit",
                header: "",
                width: 32,
                tooltip: LangHelper.GetString("QoE", "Edit task"),
                template: function(Obj)
                {
                    return Params.can_user_manage_callback(Obj) ? CellEditBtnTemplate() : "";
                }
            },
            {
                id: "run_stop",
                header: "",
                width: 32,
                tooltip: function(Obj)
                {
                    return EnabledReportTaskStates.includes(Obj.state) ? LangHelper.GetString("QoE", "Stop task") : LangHelper.GetString("QoE", "Run task");
                 },
                template: function(Obj)
                {
                    let res = EnabledReportTaskStates.includes(Obj.state) ? CellStopBtnTemplate() : CellPlayBtnTemplate();
                    return Params.can_user_manage_callback(Obj) ? res : "";
                }
            },
            {
                id: "copy",
                header: "",
                width: 32,
                tooltip: LangHelper.GetString("QoE", "Copy task"),
                template: function(Obj)
                {
                    return Params.can_user_manage_callback(Obj) ? CellCopyBtnTemplate() : "";
                }
            },
            {
                id: "_id",
                header: [
                    "",
                    "id",
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                width: 45
            },
            {
                id: "name",
                header: [
                    "",
                    LangHelper.GetString("QoE", "Task name"),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                fillspace: true,
                minWidth: 250
            },
            {
                id: "widget_name",
                header: [
                    "",
                    LangHelper.GetString("QoE", "Report name"),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                fillspace: true,
                minWidth: 250,
                template: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);
                    let langCode = LangHelper.GetLocale();

                    return model.widget_name[langCode] ? model.widget_name[langCode] : "";
                }
            },
            {
                id: "period_from",
                header: [
                    "",
                    LangHelper.GetString("QoE", "Period from"),
                    {content: "dateRangeFilter", contentId:"period_from", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                width: 135,
                template: function(Obj)
                {
                    let res = "";
                    let model = QoEReportTaskViewModel(Obj);

                    if(model.is_scheduled && model.schedule_period_from) {
                        res = LangHelper.GetString("QoE", model.schedule_period_from);
                    } else if(model.period_from) {
                        let format = Helper.GetDateTimeFormat();
                        let date = new Date(model.period_from);
                        res = webix.Date.dateToStr(format)(date);
                    }

                    return res;
                }
            },
            {
                id: "period_to",
                header: [
                    "",
                    LangHelper.GetString("QoE", "Period to"),
                    {content: "dateRangeFilter", contentId:"period_to", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                width: 135,
                template: function(Obj)
                {
                    let res = "";
                    let model = QoEReportTaskViewModel(Obj);

                    if(model.is_scheduled && model.schedule_period_to) {
                        res = LangHelper.GetString("QoE", model.schedule_period_to);
                    } else if(model.period_to) {
                        let format = Helper.GetDateTimeFormat();
                        let date = new Date(model.period_to);
                        res = webix.Date.dateToStr(format)(date);
                    }

                    return res;
                }
            },
            {
                id: "state",
                header: [
                    "",
                    LangHelper.GetString("QoE", "State")
                ],
                width: 135,
                template: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);
                    let stateTpl = "";

                    if(model.is_scheduled)
                    {
                        stateTpl = CellEyeBtnTemplate();
                    }
                    else
                    {
                        let state = ReportTasksStates[model.state];

                        if(state)
                        {
                            stateTpl = "<span class=\"status status_" + state.color + "\">";

                            if(state.id === ReportTasksStates.error.id)
                            {
                                stateTpl += '<span class="webix_icon fa-exclamation-triangle"></span>';
                                stateTpl = CellEyeBtnTemplate() + stateTpl;
                            }

                            stateTpl += state.value + "</span>";
                        }
                        else
                        {
                            stateTpl = model.state;
                        }
                    }

                    return stateTpl;
                }
            },
            {
                id: "report_json",
                header: [
                    "",
                    LangHelper.GetString("QoE", "Report")
                ],
                adjust: true,
                template: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);

                    let checks = [
                        model.is_scheduled && model.schedule_cfg.some(Item => !!(Item.state)),
                        model.is_cache && Object.keys(model.report_json).length
                    ];

                    return checks.some(I => I) ? CellEyeBtnTemplate() : "";
                }
            },
            {
                id: "is_cache",
                header: [
                    { content:"columnGroup", batch:"common_cache", groupText:LangHelper.GetString("QoE","Cache data"), colspan:3, closed:false },
                    LangHelper.GetString("QoE", "Cache"),
                    {
                        content:"richSelectFilter",
                        inputConfig: {suggest: {fitMaster: false}},
                        options:[
                            {id:1,value:LangHelper.GetString("QoE", "Cache.NotReady")},
                            {id:2,value:LangHelper.GetString("QoE", "Cache.Ready")},
                        ]
                    }
                ],
                // adjust: true,
                width:60,
                tooltip: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);
                    return model.is_cache ? LangHelper.GetString("QoE", "Cache.Ready") : LangHelper.GetString("QoE", "Cache.NotReady");

                },
                template: function(Obj)
                {
                    let res = "";
                    let model = QoEReportTaskViewModel(Obj);

                    if(!model.is_scheduled) {
                        res = CellCheckBoxTemplate({cursor:"default"}, null, model.is_cache);
                    }

                    return res;
                }
            },
            {
                id: "cache_progress",
                header: [
                    null,
                    LangHelper.GetString("QoE", "Cache progress")
                ],
                sort:false,
                width: 135,
                batch: "common_cache",
                template: function(Obj)
                {
                    let res = "";
                    let model = QoEReportTaskViewModel(Obj);

                    if(!model.is_scheduled) {
                        res = QoETopProtocolsPercentColumnWidget(
                            null,
                            null,
                            false,
                            model.progress.processing_percent,
                            ["green", "yellow"],
                            model.progress.total_percent
                        );
                    }

                    return res;
                }
            },
            {
                id: "cache_lifetime",
                header: [
                    null,
                    LangHelper.GetString("QoE", "Cache lifetime"),
                    {content: "dateRangeFilter", contentId:"cache_lifetime", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                width: 135,
                batch: "common_cache",
                format: Helper.GetDateTimeFormat(),
                template: LocalTimeZone
            },
            {
                id: "priority",
                header: [
                    { content:"columnGroup", batch:"common", groupText:LangHelper.GetString("QoE","Task settings"), colspan: 6, closed:false },
                    LangHelper.GetString("QoE", "Priority")
                ],
                width: 120,
                template: function(Obj) {
                    return Obj.priority ? Obj.priority : "";
                }
            },
            {
                id: "out_of_turn",
                header: [
                    null,
                    LangHelper.GetString("QoE", "No queue")
                ],
                adjust: true,
                batch:"common",
                template: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);
                    return CellCheckBoxTemplate({cursor:"default"}, null, model.out_of_turn);
                }
            },
            {
                id: "is_scheduled",
                header: [
                    null,
                    LangHelper.GetString("QoE", "Scheduled")
                ],
                adjust: true,
                batch:"common",
                template: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);
                    return CellCheckBoxTemplate({cursor:"default"}, null, model.is_scheduled);
                }
            },
            {
                id: "filter_settings_enabled",
                header: [
                    null,
                    LangHelper.GetString("QoE", "Filters"),
                ],
                adjust: true,
                batch:"common",
                template: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);
                    return CellCheckBoxTemplate({cursor:"default"}, null, model.filter_settings_enabled);
                }
            },
            {
                id: "report_settings_enabled",
                header: [
                    null,
                    LangHelper.GetString("QoE", "Settings")
                ],
                adjust: true,
                batch:"common",
                template: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);
                    return CellCheckBoxTemplate({cursor:"default"}, null, model.report_settings_enabled);
                }
            },
            {
                id: "mail_notify_enabled",
                header: [
                    null,
                    LangHelper.GetString("QoE", "Email")
                ],
                adjust: true,
                batch:"common",
                template: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);
                    return CellCheckBoxTemplate({cursor:"default"}, null, model.mail_notify_enabled);
                }
            },
            {
                id: "tg_notify_enabled",
                header: [
                    null,
                    LangHelper.GetString("QoE", "Telegram")
                ],
                adjust: true,
                batch:"common",
                template: function(Obj)
                {
                    let model = QoEReportTaskViewModel(Obj);
                    return CellCheckBoxTemplate({cursor:"default"}, null, model.tg_notify_enabled);
                }
            },
            {
                id:"update_time",
                header:[
                    { content:"columnGroup", batch:"common_data", groupText:LangHelper.GetString("QoE","Task data"), colspan: 3, closed:false },
                    TooltipTemplate(LangHelper.GetString("QoE", "Update time")),
                    {content: "dateRangeFilter", contentId:"update_time", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                width: 135,
                format: Helper.GetDateTimeFormat(),
                template: LocalTimeZone
            },
            {
                id: "create_time",
                header: [
                    null,
                    TooltipTemplate(LangHelper.GetString("QoE", "Create time")),
                    {content: "dateRangeFilter", contentId:"create_time", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                width: 135,
                batch: "common_data",
                format: Helper.GetDateTimeFormat(),
                template: LocalTimeZone
            },
            {
                id: "username",
                header: [
                    null,
                    TooltipTemplate(LangHelper.GetString("QoE", "User")),
                    {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                ],
                width: 135,
                batch: "common_data"
            },
            {
                id: "delete",
                width: 32,
                header: "",
                sort: false,
                tooltip: LangHelper.GetString("QoE", "Delete task"),
                template: function(Obj)
                {
                    return Params.can_user_manage_callback(Obj) ? CellTrashBtnTemplate() : "";
                }
            }
        ],
        leftSplit:6,
        rightSplit:1,
        on:{},
        rules:{},
        defaultPageSize:-100
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    return new QoETableReportWidget(params);
}

function QoEUserReportsViewController(Params)
{
    let _this = this;

    this.Id = "QoEUserReports";

    this.ViewModel = new QoEUserReportsManager();

    this.ReportsModel = new UniReportsManager();

    this.Subscriptions = {};

    this.Views = {
        Widgets: {
            UserReportsForm: new QoEUserReportsFormWidget(),
        },
        ReportsWidgets: {
            UserReportsTable: QoEUserReportsTable({
                id: "QoEUserReportsTableWidget",
                can_user_manage_callback: function(Obj)
                {
                    return _this.ViewModel.CanUserManageItem(Obj);
                },
                onItemClick: function (Id, E, Node)
                {
                    let table = _this.Views.ReportsWidgets.UserReportsTable.Views.Table;
                    let item = table.getItem(Id.row);
                    let node = table.getItemNode(Id);
                    let model = QoEReportTaskViewModel(item);

                    if(Id.column === "edit" && _this.ViewModel.CanUserManageItem(item) && item._id)
                        _this.Views.Widgets.UserReportsForm.ShowPopup(item);

                    if(Id.column === "run_stop" && _this.ViewModel.CanUserManageItem(item) && item._id)
                    {
                        let model = QoEReportTaskModel(item);

                        if(EnabledReportTaskStates.includes(item.state))
                            _this.Views.StopTaskContext.show(table.getItemNode(Id), {pos: "right"});
                        else
                            _this.ViewModel.RunTask(model);
                    }

                    if(Id.column === "state")
                    {
                        if(model.is_scheduled)
                        {
                            if(model.state && !["canceled", "disabled"].includes(model.state))
                                _this.UpdateShowScheduleContext(model, true, node);
                        }
                        else
                            _this.ShowErrorPopup(node, null, item);
                    }

                    if(Id.column === "report_json")
                    {
                        if(model.is_scheduled && model.schedule_cfg.some(Item => !!(Item.state)))
                        {
                            _this.ViewModel.GetCompletedScheduledReports(model._id);
                            _this.Views.ShowReportTable.clearAll();
                            _this.Views.ShowReportContext.show(node, {pos: "left"});
                        }
                        else if (model.is_cache)
                        {
                            // let data = webix.copy(Object.values(model.report_json));
                            let data = webix.copy(model.report_cache_list);

                            data.forEach((item, idx) => {
                                item.num = idx + 1;
                            });

                            _this.Views.ShowReportTable.clearAll();
                            _this.Views.ShowReportTable.parse(data);
                            _this.Views.ShowReportContext.show(node, {pos: "left"});
                        }
                    }

                    if(Id.column === "copy" && _this.ViewModel.CanUserManageItem(item) && item._id)
                        _this.Views.Widgets.UserReportsForm.ShowPopup(item, true);

                    if(Id.column === "delete" && _this.ViewModel.CanUserManageItem(item))
                        _this.Views.DeleteContext.show(table.getItemNode(Id), {pos: "left"});
                },
                onCheck: function (Row, Column, State) {
                    let table = _this.Views.ReportsWidgets.UserReportsTable.Views.Table;
                    let item = table.getItem(Row);

                    if(Column === "checked")
                    {
                        if(item.checked)
                        {
                            table.select(Row);
                            table.serialize().forEach(_item => {
                                _item.checked = (_item.id === item.id) && State ? 1 : 0;
                                table.updateItem(_item.id, _item);
                            });
                        }
                        else
                            table.unselect(Row);
                    }
                }
            })
        },
        UserReportsToolbar: {
            AddBtn:null,
            PlayBtn:null,
            StopBtn:null,
            EditBtn:null,
            CopyBtn:null,
            DeleteBtn:null,
            RefreshBtn:null
        },
        DeleteContext: null,
        StopTaskContext: null,
        ShowReportContext: null,
        ShowReportTable: null,
        ShowScheduleStatusContext: null,
        ShowScheduleStatusTable: null,

        LicPageHeaderWidget: new VasCloudLicenecePageHeaderWidget({id:this.Id + "LicPageHeaderWidget", licLevel:"standard", licOption:"triggers"})
    };

    this.TaskManageBtns = ["PlayBtn", "StopBtn", "EditBtn", "CopyBtn", "DeleteBtn"];

    this.UserReportsToolbarElements = [
        {
            view: "button",
            id: this.Id + "UserReportsToolbar" + "AddBtn",
            type: "icon",
            icon: "plus",
            css: "toolbar_round_btn",
            width: 32,
            tooltip: LangHelper.GetString("QoE", "Add task"),
            click: function ()
            {
                _this.Views.Widgets.UserReportsForm.ShowPopup();
            }
        },
        {width: 10},
        {
            view: "button",
            id: this.Id + "UserReportsToolbar" + "EditBtn",
            type: "icon",
            icon: "pencil-square",
            css: "toolbar_round_btn",
            width: 32,
            disabled: true,
            tooltip: LangHelper.GetString("QoE", "Edit task"),
            click: function ()
            {
                let item = _this.Views.ReportsWidgets.UserReportsTable.Views.Table.getSelectedItem();

                if(item && item._id)
                    _this.Views.Widgets.UserReportsForm.ShowPopup(item);
            }
        },
        {
            view: "button",
            id: this.Id + "UserReportsToolbar" + "PlayBtn",
            type: "icon",
            icon: "play",
            css: "toolbar_round_btn",
            width: 32,
            disabled: true,
            tooltip: LangHelper.GetString("QoE", "Run task"),
            click: function ()
            {
                let item = _this.Views.ReportsWidgets.UserReportsTable.Views.Table.getSelectedItem();

                if(item && item._id)
                    _this.ViewModel.RunTask(QoEReportTaskModel(item));
            }
        },
        {
            view: "button",
            id: this.Id + "UserReportsToolbar" + "StopBtn",
            type: "icon",
            icon: "stop",
            css: "toolbar_round_btn",
            width: 32,
            disabled: true,
            tooltip: LangHelper.GetString("QoE", "Stop task"),
            click: function ()
            {
                _this.Views.StopTaskContext.show(this.getNode(), {pos: "right"});
            }
        },
        {
            view: "button",
            id: this.Id + "UserReportsToolbar" + "CopyBtn",
            type: "icon",
            icon: "copy",
            css: "toolbar_round_btn",
            width: 32,
            disabled: true,
            tooltip: LangHelper.GetString("QoE", "Copy task"),
            click: function ()
            {
                let item = _this.Views.ReportsWidgets.UserReportsTable.Views.Table.getSelectedItem();

                if(item && item._id)
                {
                    _this.Views.Widgets.UserReportsForm.ShowPopup(item, true);
                }
            }
        },
        {
            view: "button",
            id: this.Id + "UserReportsToolbar" + "DeleteBtn",
            type: "icon",
            icon: "trash",
            css: "toolbar_round_btn",
            width: 32,
            disabled: true,
            tooltip: LangHelper.GetString("QoE", "Delete task"),
            click: function ()
            {
                _this.Views.DeleteContext.show(this.getNode(), {pos: "right"});
            }
        },
        {},
        {
            view: "button",
            id: this.Id + "UserReportsToolbar" + "RefreshBtn",
            type: "icon",
            icon: "refresh",
            css: "toolbar_round_btn",
            width: 32,
            tooltip: LangHelper.GetString("QoE", "Refresh"),
            click: function ()
            {
                _this.Views.ReportsWidgets.UserReportsTable.RefreshData();
            }
        }
    ];

    this.DeleteContext = webix.ui({
        id: this.Id + "DeleteContext",
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("All","Are you sure you want to delete the selected record?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("QoE","Cancel"),
                            click:function () {
                                _this.DeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("QoE","Delete"),
                            click:function () {
                                let item = _this.Views.ReportsWidgets.UserReportsTable.Views.Table.getSelectedItem();
                                if(item && item._id)
                                    _this.ViewModel.DeleteTask(QoEReportTaskModel(item));
                                _this.Views.DeleteContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.StopTaskContext = webix.ui({
        id: this.Id + "StopTaskContext",
        view:"popup",
        width:350,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("QoE","Are you sure you want to stop task?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.StopTaskContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("QoE","Stop"),
                            click:function () {
                                let item = _this.Views.ReportsWidgets.UserReportsTable.Views.Table.getSelectedItem();
                                if(item && item._id)
                                    _this.ViewModel.CancelTask(QoEReportTaskModel(item));
                                _this.Views.StopTaskContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ShowReportContext = webix.ui({
        id: this.Id + "ShowReportContext",
        view: "popup",
        maxWidth: 800,
        maxHeight: 600,
        body:{
            id: this.Id + "ShowReportTable",
            view: "datatable",
            borderless: true,
            // autoheight:true,
            columns: [
                {
                    id: "num",
                    header: "",
                    width: 30
                },
                // {
                //     id: "created_time",
                //     header: LangHelper.GetString("QoE", "Create time"),
                //     fillspace: true,
                //     format: Helper.GetDateTimeFormat(),
                //     template: LocalTimeZone,
                // },
                // {
                //     id: "cache_lifetime",
                //     header: LangHelper.GetString("QoE", "Cache lifetime"),
                //     fillspace: true,
                //     format: Helper.GetDateTimeFormat(),
                //     template: LocalTimeZone
                // },
                {id: "period_from", header: LangHelper.GetString("QoE", "Period from"), fillspace: true, format: Helper.GetDateTimeFormat()},
                {id: "period_to", header: LangHelper.GetString("QoE", "Period to"), fillspace: true, format: Helper.GetDateTimeFormat()},
                {
                    id: "cache_progress",
                    header: LangHelper.GetString("QoE", "Cache progress"),
                    sort:false,
                    width: 135,
                    template: function(Obj)
                    {
                        return QoETopProtocolsPercentColumnWidget(
                            null,
                            null,
                            false,
                            Obj.cache_progress,
                            ["green", "yellow"]
                        );
                    }
                },
                {id: "cache_rows", header: LangHelper.GetString("QoE", "Data"), fillspace: true},
                {
                    id: "report_id",
                    header: "",
                    adjust: true,
                    // template: function(Obj)
                    // {
                    //     return Obj.report_id ? CellTextLinkTemplate(LangHelper.GetString("QoE", "Open report")) : "";
                    // }
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="/#QoEAnyReport/report_id=' + Obj.report_id + '" onclick="return false;">' + LangHelper.GetString("QoE", "Open report") + '</a>';
                    }
                }
            ],
            on: {
                onItemClick: function(Id)
                {
                    if(Id.column === "report_id")
                    {
                        let item = this.getItem(Id.row);

                        if(item && item.report_id)
                            window.open("/#QoEAnyReport/report_id=" + item.report_id, "_blank");
                    }
                }
            }
        }
    });

    this.ShowScheduleStatusContext = webix.ui({
        id: this.Id + "ShowScheduleStatusContext",
        view: "popup",
        maxWidth: 800,
        maxHeight: 600,
        scroll: true,
        body: {
            rows: [
                {
                    id: this.Id + "ShowScheduleStatusTable",
                    view: "datatable",
                    borderless: true,
                    columns: function() {
                        let cols = [
                            {
                                id: "start_time",
                                header: LangHelper.GetString("QoE", "Start time"),
                                width: 125,
                                sort: "string"
                            }
                        ];

                        Object.values(DaysOfWeekDic).forEach((Item, Idx) => {
                            let col = {
                                id: Item.id,
                                header: Item.value,
                                width: 55,
                                template: function(Obj) {
                                    let val = Obj && Obj[parseInt(Item.id)] ? 1 : 0;
                                    return CellCheckBoxTemplate({cursor: "default"}, null, val);
                                }
                            }
                            cols.splice(Idx + 1, 0, col);
                        });

                        cols = cols.concat([
                            {
                                id: "state",
                                header: LangHelper.GetString("QoE", "State"),
                                width: 135,
                                template: function(Obj)
                                {
                                    let model = QoEReportScheduleModel(Obj);
                                    let stateTpl = "";

                                    let state = ReportTasksStates[model.state];

                                    if(state)
                                    {
                                        stateTpl = "<span class=\"status status_" + state.color + "\">";

                                        if(state.id === ReportTasksStates.error.id)
                                        {
                                            stateTpl += '<span class="webix_icon fa-exclamation-triangle"></span>';
                                            stateTpl = CellEyeBtnTemplate() + stateTpl;
                                        }

                                        stateTpl += state.value + "</span>";
                                    }
                                    else
                                    {
                                        stateTpl = model.state;
                                    }

                                    return stateTpl;
                                }
                            },
                            {
                                id:"update_time",
                                header: LangHelper.GetString("QoE", "Update time"),
                                fillspace: true,
                                template: function(Obj) {
                                    let res = "";
                                    if(Obj.state && Obj.update_time) {
                                        let format =  webix.Date.dateToStr( Helper.GetDateTimeFormat());
                                        res = format(Helper.DateTimeToLocal(Obj.update_time));
                                    }
                                    return res;
                                }
                            },
                        ]);

                        return cols;
                    }(),
                    on: {
                        onItemClick: function(Id, E, Node) {
                            let table = _this.Views.ShowScheduleStatusTable;
                            let item = table.getItem(Id.row);
                            let node = table.getItemNode(Id);
                            let model = QoEReportScheduleModel(item);

                            if(Id.column === "state" && model.state_data)
                                _this.ShowErrorPopup(node, model);
                        }
                    }
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols:[
                QoELeftSideBarView({id: this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                {
                                  cols:[
                                      PageHeaderTemplate({
                                          root_title: LangHelper.GetString("AppView","QoE analytics"),
                                          title: LangHelper.GetString("QoE","My reports")
                                      }),
                                      {
                                          gravity:3,
                                          rows:[
                                              this.Views.LicPageHeaderWidget.ViewConfig
                                          ]
                                      }
                                  ]
                                },
                                {
                                    view: "toolbar",
                                    elements: this.UserReportsToolbarElements
                                },
                                this.Views.ReportsWidgets.UserReportsTable.ViewConfig
                            ]
                        }
                    ]
                }
            ],
        }
    ];
}

QoEUserReportsViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id + "LeftSideBar").select("QoEUserReports");
    });

    this.BindAll(PathParams);
};

QoEUserReportsViewController.prototype.BindAll = function(Params)
{
    let _this = this;

    this.Views.Widgets.UserReportsForm.Bind(this, this.ViewModel);
    this.Views.ReportsWidgets.UserReportsTable.Bind(this, this.ReportsModel);

    Object.keys(this.Views.UserReportsToolbar).forEach(Key => {
        this.Views.UserReportsToolbar[Key] = $$(_this.Id + "UserReportsToolbar" + Key)
    });

    this.Views.DeleteContext = $$(this.Id + "DeleteContext");
    this.Views.StopTaskContext = $$(this.Id + "StopTaskContext");
    this.Views.ShowReportContext = $$(this.Id + "ShowReportContext");
    this.Views.ShowReportTable = $$(this.Id + "ShowReportTable");
    this.Views.ShowScheduleStatusContext = $$(this.Id + "ShowScheduleStatusContext");
    this.Views.ShowScheduleStatusTable = $$(this.Id + "ShowScheduleStatusTable");

    this.Views.ReportsWidgets.UserReportsTable.Views.Table.attachEvent("onAfterSelect", function(Row) {
       if(Row)
       {
           let table = _this.Views.ReportsWidgets.UserReportsTable.Views.Table;
           let item = table.getItem(Row);

           table.serialize().forEach(item => {
               item.checked = 0;
           });

           item.checked = 1;
       }
        _this.ManageToolbarBtns();
    });

    _this.Views.ReportsWidgets.UserReportsTable.Views.Table.attachEvent("onAfterUnSelect", function() {
        _this.ManageToolbarBtns();
    });

    this.Subscriptions.SaveTaskSuccess = this.ViewModel.Signals.SaveTaskSuccess.subscribe(function(Model) {
        if(Model)
        {
            let table = _this.Views.ReportsWidgets.UserReportsTable.Views.Table;

            let state = table.getState();
            let userData = App.SessionManager.GetProfile();
            let userFilter = state.filter && state.filter.user_id ? state.filter.user_id.split(",") : [];

            let items = table.serialize();

            let find = items.find(i => i.id == Model.id);

            if(find && find.id)
            {
                table.updateItem(find.id, Model);
            }
            else if(!userFilter.length || userFilter.includes(String(userData.user_id)))
            {
                if(!items.length)
                    table.hideOverlay();
                table.add(Model);
            }
        }
    });

    this.Subscriptions.SaveTaskError = this.ViewModel.Signals.SaveTaskError.subscribe(function(Error) {
        if(Error)
            _this.Views.ReportsWidgets.UserReportsTable.RefreshData();
    });

    this.Subscriptions.DeleteTaskSuccess = this.ViewModel.Signals.DeleteTaskSuccess.subscribe(function(Model) {
        if(Model)
            _this.Views.ReportsWidgets.UserReportsTable.RefreshData();
    });

    this.Subscriptions.DeleteTaskError = this.ViewModel.Signals.DeleteTaskError.subscribe(function(Error) {
        if(Error && Error.msg)
        {
            webix.message({type: "error", text: Error.msg});
            _this.Views.ReportsWidgets.UserReportsTable.RefreshData();
        }
    });

    this.Subscriptions.RunTaskError = this.ViewModel.Signals.RunTaskError.subscribe(function(Error) {
        if(Error && Error.msg)
        {
            webix.message({type: "error", text: Error.msg});
            _this.Views.ReportsWidgets.UserReportsTable.RefreshData();
        }
    });

    this.Subscriptions.CancelTaskError = this.ViewModel.Signals.CancelTaskError.subscribe(function(Error) {
        if(Error && Error.msg)
        {
            webix.message({type: "error", text: Error.msg});
            _this.Views.ReportsWidgets.UserReportsTable.RefreshData();
        }
    });

    this.Subscriptions.GetCompletedScheduledReportsSuccess = this.ViewModel.Signals.GetCompletedScheduledReportsSuccess.subscribe(function(Data) {
        if(Data && Data.rows && Data.task_id)
        {
            let table = _this.Views.ReportsWidgets.UserReportsTable.Views.Table;
            let selected = table.getSelectedItem();

            if(selected && selected._id == Data.task_id && _this.Views.ShowReportContext.isVisible())
            {
                _this.Views.ShowReportTable.clearAll();
                _this.Views.ShowReportTable.parse(Data.rows);
            }
        }
    });

    this.Subscriptions.GetCompletedScheduledReportsError = this.ViewModel.Signals.GetCompletedScheduledReportsError.subscribe(function(Error) {
        if(Error && Error.msg)
        {
            webix.message({type: "error", text: Error.msg});

            let table = _this.Views.ReportsWidgets.UserReportsTable.Views.Table;

            if(_this.Views.ShowReportContext.isVisible())
                _this.Views.ShowReportTable.clearAll();
        }
    });

    this.Subscriptions.RefreshSuggestWidgetDone = this.Views.Widgets.UserReportsForm.Views.Widgets.WidgetsSuggest.Signals.WidgetsUpdated.subscribe(function(Update) {
       if(Update)
           _this.Views.ReportsWidgets.UserReportsTable.RefreshData();
    });

    App.WebSocketManager.Connect("QoEReportModel");

    App.WebSocketManager.Connections["QoEReportModel"].on("qoe_report_model_state_updated", function(R){
        if(R)
        {
            try
            {
                let r = JSON.parse(R);

                if(r.success && r.data)
                {
                    let table = _this.Views.ReportsWidgets.UserReportsTable.Views.Table;
                    let model = QoEReportTaskViewModel(r.data);
                    let find = table.serialize().find(i => i._id == model._id);

                    if(find)
                    {
                        table.updateItem(find.id, model);
                        _this.ManageToolbarBtns();

                        let selected = table.getSelectedItem();

                        if(selected && selected._id == model._id)
                        {
                            if(_this.Views.ShowScheduleStatusContext.isVisible())
                                _this.UpdateShowScheduleContext(model);

                            if(_this.Views.ShowReportContext.isVisible())
                                _this.ViewModel.GetCompletedScheduledReports(parseInt(model._id));
                        }
                    }
                }
                else if(!r.success && r.error)
                {
                    throw new Error(r.error.msg)
                }
                else
                {
                    throw new Error(LangHelper.GetString("QoE", "Task update error"));
                }
            }
            catch(e)
            {
                webix.message({type: "error", text: e.message});
                _this.Views.ReportsWidgets.UserReportsTable.RefreshData();
            }
        }
    });

    this.Views.LicPageHeaderWidget.BindAll(Params);
};

QoEUserReportsViewController.prototype.Destroy = function()
{
    let _this = this;

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        if(_this.Subscriptions[Key])
            _this.Subscriptions[Key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(Key => {
        let w = _this.Views.ReportsWidgets[Key];

        if (w && w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.Widgets).forEach(Key => {
        let w = _this.Views.Widgets[Key];

        if (w && w.Destroy)
            w.Destroy();
    });

    App.WebSocketManager.Disconnect("QoEReportModel");

    this.Views.LicPageHeaderWidget.Destroy();

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

QoEUserReportsViewController.prototype.ManageToolbarBtns = function()
{
    let _this = this;

    let item = this.Views.ReportsWidgets.UserReportsTable.Views.Table.getSelectedItem();

    if(item)
    {
        if(EnabledReportTaskStates.includes(item.state))
        {
            this.Views.UserReportsToolbar.PlayBtn.hide();
            this.Views.UserReportsToolbar.StopBtn.show();
        }
        else
        {
            this.Views.UserReportsToolbar.StopBtn.hide();
            this.Views.UserReportsToolbar.PlayBtn.show();
        }
    }

    this.TaskManageBtns.forEach(Key => {
        let view = _this.Views.UserReportsToolbar[Key];

        if(view)
        {
            if(item && _this.ViewModel.CanUserManageItem(item))
                view.enable();
            else
                view.disable();
        }
    });
};

QoEUserReportsViewController.prototype.ShowErrorPopup = function (Node, Model = null, Item = null)
{
    let model = Model && Model.state_data ? Model : QoEReportTaskViewModel(Item);
    let lines = typeof model.state_data === "string" ? model.state_data : JSON.stringify(model.state_data, null, 2);

    var context = webix.ui({
        view:"popup",
        id: this.Id + "ShowErrorPopup",
        width:600,
        height:600,
        body:{
            view: "form",
            borderless:true,
            rows:[
                {
                    view: "textarea",
                    value: lines
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("All","Close"),
                            click:function ()
                            {
                                context.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    context.show(Node, {pos:"right"});
};

QoEUserReportsViewController.prototype.UpdateShowScheduleContext = function(Model, Show = false, Node = null)
{
    let _this = this;

    _this.Views.ShowScheduleStatusTable.clearAll();

    if(Model.schedule_cfg && Model.schedule_cfg.length)
    {
        _this.Views.ShowScheduleStatusTable.clearAll();

        let data = Model.schedule_cfg.map(Obj => {
            let _model = QoEReportScheduleModel(Obj);

            let weekDays = Object.values(DaysOfWeekDic).filter(Item => Obj[Item.id])
                .map(Item => Item.id);

            [_model.start_time, _model.week_days] = Helper.ConvertSchedule(_model.start_time, weekDays, 'UtcToLocal');

            return QoEReportScheduleModel(_model);
        });

        data.sort((a, b) => a.start_time.localeCompare(b.start_time));
        data.forEach(Item => _this.Views.ShowScheduleStatusTable.add(QoEReportScheduleModel(Item)));
    }

    if(Show)
        _this.Views.ShowScheduleStatusContext.show(Node, {pos: "left"});
}
function QoEMailingTemplatesViewController(Params)
{
    let id = "QoEMailingTemplates";

    let params = webix.extend(Params,
        {
            id:id,
            menu_id:id
        },true);

    QoEMailingTemplatesViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(QoEMailingTemplatesViewController, MailingTemplatesViewController);
function VasCloudPageHeaderWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.Views = {
        HeaderBalanceInfoMenu:null,
        ProfileTitle:null,

        PaymentRequestPanel:null,
        PaymentRequestForm:null,
        SendPaymentRequestBtn:null,

        PaymentRequestOkPanel:null,
        PaymentRequestOkForm:null
    };

    this.PaymentRequestInProcess = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

VasCloudPageHeaderWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.ProfileViewPopupId = this.Id + "ProfileViewPopup";
    this.ProfileViewPopupConfig = {
        view: "submenu",
        id: this.ProfileViewPopupId,
        width: 200,
        //autowidth: true,
        padding: 0,
        data: [
            {id: this.ProfileViewPopupId+"VasCloudPersonalArea", icon: "user", value: LangHelper.GetString(_this.Id, "My profile")},
            {$template: "Separator"},
            {id: this.ProfileViewPopupId+"Logout", icon: "sign-out", value: LangHelper.GetString(_this.Id, "Log out")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();
                if (id === _this.ProfileViewPopupId+"Logout")
                {
                    setTimeout(function () {
                        App.VasCloudSessionManager.Logout();
                    },10);
                }
                else if(id === _this.ProfileViewPopupId+"VasCloudPersonalArea")
                {
                    App.NavRouter.PresentView({id: "VasCloudPersonalArea"});
                }
            }
        }

    };
    this.ProfileViewPopup = null;

    this.BalanceViewPopupId = this.Id + "BalanceViewPopup";
    this.BalanceViewPopupConfig = {
        view: "submenu",
        id: this.BalanceViewPopupId,
        width: 240,
        //autowidth: true,
        padding: 0,
        data: [
            {id: _this.BalanceViewPopupId + "VasCloudAccrualsAndPayments", icon: "file-invoice", value: LangHelper.GetString("VasCloudAccrualsAndPayments", "Accruals and payments"), href:"#VasCloudAccrualsAndPayments", section:RoleSectionsEnum.vascloud},
            {id: _this.BalanceViewPopupId + "VasCloudRequestPayment", icon: "money-check", value: LangHelper.GetString("VasCloudAccrualsAndPayments", "Request payment")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();
                if (id === _this.BalanceViewPopupId + "VasCloudRequestPayment")
                {
                    setTimeout(function () {
                        var node = $$(_this.Id + "HeaderBalanceInfoMenu").getNode();
                        _this.ShowWizardPaymentRequestForm(node, "bottom");
                    },10);
                }
                else if(id === _this.BalanceViewPopupId + "VasCloudAccrualsAndPayments")
                {
                    App.NavRouter.PresentView({id: "VasCloudAccrualsAndPayments"});
                }
            }
        }

    };
    this.BalanceViewPopup = null;

    this.RequestPaymentViewPopupId = this.Id + "RequestPaymentViewPopup";
    this.RequestPaymentViewPopupConfig = {
        view: "popup",
        id:this.RequestPaymentViewPopupId,
        width: 320,
        modal: true,
        body:{
            view: "multiview",
            id: this.RequestPaymentViewPopupId+"Wizard",
            borderless:true,
            cells:[
                {
                    id: this.RequestPaymentViewPopupId+"Wizard"+"RequestPanel",
                    rows:[
                        {
                            height:160,
                            css:"vc_login-form__header",
                            template:"<div class='vc_logo'><img src='assets/imgs/"+ (AppEnv.UrlUiLogo ? AppEnv.UrlUiLogo : 'logo.png') + "'/><span>" + LangHelper.GetString('VasCloud', 'VAS Cloud') + "</span></div><div>"+LangHelper.GetString("VasCloudAccrualsAndPayments", "Send us request to get your money and we process it as soon as possible")+"</div>"
                        },
                        {
                            view:"form",
                            id: this.RequestPaymentViewPopupId+"Wizard"+"RequestForm",
                            width: 400,
                            elements: [
                                {},
                                {
                                    view: "text",
                                    label: LangHelper.GetString("VasCloudAccrualsAndPayments", "Amount of payment"),
                                    name: "amount",
                                    tooltip: LangHelper.GetString("VasCloudAccrualsAndPayments", "Amount of payment"),
                                    labelPosition: "top",
                                    required: true,
                                    invalidMessage: LangHelper.GetString("VasCloudAccrualsAndPayments", "Enter amount of payment"),
                                    validate: webix.rules.isNotEmpty,
                                    attributes:{maxlength:50},
                                    on: {
                                        "onChange": function () {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "textarea",
                                    label: LangHelper.GetString("VasCloudAccrualsAndPayments", "Notes"),
                                    name: "notes",
                                    tooltip: LangHelper.GetString("VasCloudAccrualsAndPayments", "Notes"),
                                    labelPosition: "top",
                                    height:160,
                                    on: {
                                        "onChange": function () {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    cols:[
                                        {
                                            view: "button",
                                            id: this.Id + "CancelRequestBtn",
                                            value: LangHelper.GetString("All", "Cancel"),
                                            click: function ()
                                            {
                                                _this.HideWizardPaymentRequestForm();
                                            }
                                        },
                                        {
                                            view: "button",
                                            id: this.RequestPaymentViewPopupId + "Wizard" + "SendRequestBtn",
                                            type: "form",
                                            value: LangHelper.GetString("VasCloud", "Submit request"),
                                            click: function ()
                                            {
                                                setTimeout(function () {
                                                    _this.SendPaymentRequest();
                                                },1);
                                            }
                                        }
                                    ]
                                },
                                {}
                            ]
                        }
                    ]
                },
                {
                    id: this.RequestPaymentViewPopupId+"Wizard"+"RequestOkPanel",
                    rows:[
                        {
                            height:160,
                            css:"vc_login-form__header",
                            template:"<div class='vc_logo'><img src='assets/imgs/"+ (AppEnv.UrlUiLogo ? AppEnv.UrlUiLogo : 'logo.png') + "'/><span>" + LangHelper.GetString('VasCloud', 'VAS Cloud') + "</span></div><div>"+LangHelper.GetString("VasCloud", "Your request is accepted")+"</div>"
                        },
                        {
                            view:"form",
                            id: this.RequestPaymentViewPopupId+"Wizard"+"RequestOkForm",
                            width: 400,
                            elements:
                                [
                                    {},
                                    {
                                        view: "label",
                                        label: LangHelper.GetString("VasCloud", "Your request is accepted")
                                    },
                                    {
                                        view: "button",
                                        id: this.Id + "CloseRegOkBtn",
                                        value: LangHelper.GetString("LoginView", "Close"),
                                        click: function ()
                                        {
                                            _this.HideWizardPaymentRequestForm();
                                        }
                                    },
                                    {}
                                ]
                        }
                    ]
                }
            ]
        }
    };
    this.RequestPaymentViewPopup = null;

    this.ViewConfig = VasCloudPageHeaderTemplate({
        id:this.Id,
        balance_data:App.VasCloudSessionManager.GetBalanceInfo(),
        profile_data: App.VasCloudSessionManager.GetMyUserProfile(),
        balance_popup_id:this.BalanceViewPopupId,
        profile_popup_id:this.ProfileViewPopupId
    });
};

VasCloudPageHeaderWidget.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.HeaderBalanceInfoMenu = $$(this.Id + "HeaderBalanceInfoMenu");
    this.Views.ProfileTitle = $$(this.Id + "ProfileTitle");

    this.ProfileViewPopup = webix.ui(this.ProfileViewPopupConfig);
    this.BalanceViewPopup = webix.ui(this.BalanceViewPopupConfig);

    this.RequestPaymentViewPopup = webix.ui(this.RequestPaymentViewPopupConfig);
    this.Views.PaymentRequestPanel = $$(this.RequestPaymentViewPopupId + "Wizard" + "RequestPanel");
    this.Views.PaymentRequestForm = $$(this.RequestPaymentViewPopupId + "Wizard" + "RequestForm");
    webix.extend(this.Views.PaymentRequestForm, webix.ProgressBar);
    this.Views.SendPaymentRequestBtn = $$(this.RequestPaymentViewPopupId + "Wizard" + "SendRequestBtn");

    this.Views.PaymentRequestOkPanel = $$(this.RequestPaymentViewPopupId + "Wizard" + "RequestOkPanel");
    this.Views.PaymentRequestOkForm = $$(this.RequestPaymentViewPopupId + "Wizard" + "RequestOkForm");

    this.Subscriptions.BalanceInfoSignalSubscription = App.VasCloudSessionManager.BalanceInfoSignal.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.DefineHeaderBalanceInfoMenu();
        }
    });

    this.Subscriptions.MyProfileUpdatedSignalSubscription = App.VasCloudSessionManager.MyProfileUpdatedSignal.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.DefineProfileTitle();
        }
    });

    this.Subscriptions.SignalIsLoggedIn = App.VasCloudSessionManager.SignalIsLoggedIn.subscribe(function (IsLoggedIn)
    {
        if (IsLoggedIn)
        {
            App.VasCloudSessionManager.RefreshMyUserProfile();

            App.VasCloudSessionManager.RefreshBalanceInfo();
        }
    });

    this.Subscriptions.PaymentRequestInProcess = this.PaymentRequestInProcess.subscribe(function (RequestInProcess)
    {
        if (RequestInProcess)
        {
            _this.Views.SendPaymentRequestBtn.disable();
            _this.Views.PaymentRequestForm.showProgress({type: "icon"});
        }
        else
        {
            _this.Views.SendPaymentRequestBtn.enable();
            _this.Views.PaymentRequestForm.hideProgress();
        }
    });
};

VasCloudPageHeaderWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

VasCloudPageHeaderWidget.prototype.DefineHeaderBalanceInfoMenu = function ()
{
    this.Views.HeaderBalanceInfoMenu.define("data", App.VasCloudSessionManager.GetBalanceInfo());
};

VasCloudPageHeaderWidget.prototype.DefineProfileTitle = function ()
{
    this.Views.ProfileTitle.define("data", App.VasCloudSessionManager.GetMyUserProfile());
};

VasCloudPageHeaderWidget.prototype.ShowWizardPaymentRequestForm = function (Node, Pos)
{
    this.Views.PaymentRequestForm.clear();
    this.Views.PaymentRequestForm.clearValidation();
    this.Views.PaymentRequestPanel.show();
    this.RequestPaymentViewPopup.show(Node, {pos:Pos});
};

VasCloudPageHeaderWidget.prototype.HideWizardPaymentRequestForm = function ()
{
    this.RequestPaymentViewPopup.hide();
};

VasCloudPageHeaderWidget.prototype.ShowWizardPaymentRequestOkForm = function ()
{
    this.Views.PaymentRequestOkPanel.show();
};

VasCloudPageHeaderWidget.prototype.SendPaymentRequest = function ()
{
    var _this = this;
    function PaymentRequestFormModel(Params)
    {
        this.amount = Params&&Params.amount ? Params.amount : 0;
        this.notes = Params&&Params.notes ? Params.notes : "";
    }

    if (this.Views.PaymentRequestForm.validate())
    {
        this.PaymentRequestInProcess.next(1);

        var formModel = new PaymentRequestFormModel(this.Views.PaymentRequestForm.getValues());

        App.VasCloudSessionManager.SendPaymentRequestForm({
            data:formModel,
            callback: function (R)
            {
                _this.PaymentRequestInProcess.next(0);

                if (!R.success && R.error.msg)
                {
                    webix.message({type: "error", text: R.error.msg});
                }

                if (R.success)
                {
                    _this.ShowWizardPaymentRequestOkForm();
                    webix.message({type: "info", expire: 10000, text: LangHelper.GetString("VasCloud", "Your request is accepted")});
                }
            }
        });
    }
};

var VasCloudLicenecePageHeaderWidgetStateEnum = {
    active:"active",
    no_active:"no_active",
    active_expire:"active_expire"
};

function VasCloudLicenecePageHeaderWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.LicLevel = null;
    this.LicOption = null;
    this.CompareIsLicenseAndOption = null;

    this.Views = {
        LicStateTitle:null
    };

    this.Subscriptions = {};

    this.Init(ViewConfig);
}

VasCloudLicenecePageHeaderWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : null;

    this.LicLevel = ViewConfig.licLevel ? ViewConfig.licLevel : false;
    this.LicOption = ViewConfig.licOption ? ViewConfig.licOption : false;
    this.CompareIsLicenseAndOption = ViewConfig.compareIsLicenseAndOption ? ViewConfig.compareIsLicenseAndOption : false;

    this.OnOkButtonClick = ViewConfig.onOkButtonClick && typeof ViewConfig.onOkButtonClick == "function" ? ViewConfig.onOkButtonClick : null;

    this.InfoContext = webix.ui({
        id:this.Id + "InfoContext",
        view:"popup",
        width:320,
        height:240,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("VasCloud","You need to activate the subscription to make work this section correctly. You can write to us at sd@vas.expert or request a license by clicking the \"Send request\" button.")
                },
                {
                    cols:[
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Ok"),
                            click:function () {
                                _this.InfoContext.hide();

                                if(_this.OnOkButtonClick)
                                {
                                    _this.OnOkButtonClick();
                                }
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("VasCloud","Send request"),
                            click:function () {
                                _this.InfoContext.hide();
                                _this.SendLicenceRequest();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.InfoMustContext = webix.ui({
        id:this.Id + "InfoMustContext",
        view:"popup",
        position:"center",
        modal:true,
        width:320,
        height:240,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("VasCloud","You need to activate the subscription to make work this section correctly. You can write to us at sd@vas.expert or request a license by clicking the \"Send request\" button.")
                },
                {
                    cols:[
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Ok"),
                            click:function () {
                                _this.InfoMustContext.hide();
                                if(_this.OnOkButtonClick)
                                {
                                    _this.OnOkButtonClick();
                                }
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("VasCloud","Send request"),
                            click:function () {
                                _this.InfoMustContext.hide();
                                _this.SendLicenceRequest();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = VasCloudLicencePageHeaderTemplate({
        id:this.Id
    });
};

VasCloudLicenecePageHeaderWidget.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.LicStateTitle = $$(this.Id + "LicStateTitle");

    this.Subscriptions.AppVersionSubscription = App.SessionManager.AppVersion.subscribe(function (Value)
    {
        _this.DefineLicStateTitle(Value);
    });
};

VasCloudLicenecePageHeaderWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

VasCloudLicenecePageHeaderWidget.prototype.HasLicense = function (License = false)
{
    return !(this.LicLevel !== null && License !== false && License !== this.LicLevel);
}

VasCloudLicenecePageHeaderWidget.prototype.HasOption = function (Options = false)
{
    return !(this.LicOption !== null && Options !== false && !Options.split(',').includes(this.LicOption));
}

VasCloudLicenecePageHeaderWidget.prototype.HasLicenseOrOption = function (Value)
{
    return this.HasLicense(Value.licence) || this.HasOption(Value.lic_options);
}

VasCloudLicenecePageHeaderWidget.prototype.HasLicenseAndOption = function (Value)
{
    return this.HasLicense(Value.licence) && this.HasOption(Value.lic_options);
}

VasCloudLicenecePageHeaderWidget.prototype.CheckLicenseOrOption = function (Value)
{
    return this.HasLicenseOrOption(Value) ? VasCloudLicenecePageHeaderWidgetStateEnum.active : VasCloudLicenecePageHeaderWidgetStateEnum.no_active;
}

VasCloudLicenecePageHeaderWidget.prototype.CheckLicenseAndOption = function (Value)
{
    return this.HasLicenseAndOption(Value) ? VasCloudLicenecePageHeaderWidgetStateEnum.active : VasCloudLicenecePageHeaderWidgetStateEnum.no_active;
}

VasCloudLicenecePageHeaderWidget.prototype.DefineLicStateTitle = function (Value)
{
    var data = {
        state: VasCloudLicenecePageHeaderWidgetStateEnum.no_active
    };

    if(Value)
    {
        data.state = this.CompareIsLicenseAndOption ? this.CheckLicenseAndOption(Value) : this.CheckLicenseOrOption(Value);

        if (data.state === VasCloudLicenecePageHeaderWidgetStateEnum.no_active) return;

        if(Value.lic_expiration_date)
        {
            data.days_left = Math.ceil(((new Date(Value.lic_expiration_date)) - (new Date())) / (1000 * 60 * 60 * 24));

            if(data.days_left >= 0)
            {
                data.state = VasCloudLicenecePageHeaderWidgetStateEnum.active_expire;
            }
        }

        if(data.state != VasCloudLicenecePageHeaderWidgetStateEnum.active && data.state != VasCloudLicenecePageHeaderWidgetStateEnum.active_expire)
        {
            this.InfoMustContext.show();
        }
    }

    if(!this.Views.LicStateTitle.$destructed)
        this.Views.LicStateTitle.define("data", data);
};

VasCloudLicenecePageHeaderWidget.prototype.SendLicenceRequest = function ()
{
    App.NavRouter.PresentView({id: "VasCloudPersonalArea", topMenuId: "VasCloudPersonalArea", path:"/LicRequest=true"});
};
function VasCloudRequestLicenceViewController(Params)
{
    var _this = this;

    this.Id = Params && Params.id ? Params.id : "VasCloudRequestLicenceView";

    this.Embedded = Params && Params.embedded ? Params.embedded : false;

    this.modal = Params&&Params.modal ? Params.modal : false;

    this.ViewConfig = {
        view: "multiview",
        id: this.Id+"Wizard",
        cells:[
            {
                id: this.Id + "Wizard" + "FormPanel",
                rows:[
                    {
                        view: "form",
                        id:this.Id+"Form",
                        borderless:true,
                        elements:[
                            {
                                height:160,
                                css:"vc_login-form__header",
                                template:"<div class='vc_logo'><img src='assets/imgs/"+ (AppEnv.UrlUiLogo ? AppEnv.UrlUiLogo : 'logo.png') + "'/><span>" + LangHelper.GetString('VasCloud', 'VAS Cloud') + "</span></div><div>"+LangHelper.GetString("VasCloud", "Send us a request and we will process it as soon as possible")+"</div>"
                            },
                            {
                                view: "richselect",
                                name: "product_type_code",
                                label: LangHelper.GetString("VasCloud", "Product type"),
                                options:function ()
                                {
                                    var r = [];

                                    Object.keys(VasCloudLicProductTypeCodeEnum).forEach(function (Key)
                                    {
                                        r.push({"key":Key, value:Key})
                                    });

                                    return r;
                                }(),
                                labelPosition: "top",
                                required: true,
                                validate: webix.rules.isNotEmpty,
                                invalidMessage:LangHelper.GetString("VasCloud", "Required field")
                            },
                            {
                                view: "richselect",
                                name: "lic_level",
                                label: LangHelper.GetString("VasCloud", "Licence level"),
                                options:function ()
                                {
                                    var r = [];

                                    Object.keys(VasCloudLicLevelEnum).forEach(function (Key)
                                    {
                                        r.push({id:Key, value:Helper.ToUpperCaseFirstLetter(Key)})
                                    });

                                    return r;
                                }(),
                                labelPosition: "top",
                                required: true,
                                validate: webix.rules.isNotEmpty,
                                invalidMessage:LangHelper.GetString("VasCloud", "Required field")
                            },
                            {
                                view: "richselect",
                                name: "dpi_lic_level",
                                label: LangHelper.GetString("VasCloud", "DPI licence level"),
                                options:function ()
                                {
                                    var r = [];

                                    Object.keys(VasCloudDPILicLevelEnum).forEach(function (Key)
                                    {
                                        r.push({id:Key, value: LangHelper.GetString("VasCloud", "CKAT")+ "-" + Key})
                                    });

                                    return r;
                                }(),
                                labelPosition: "top",
                                required: true,
                                validate: webix.rules.isNotEmpty,
                                invalidMessage:LangHelper.GetString("VasCloud", "Required field")
                            },
                            {
                                view: "richselect",
                                name: "expiration_date",
                                label: LangHelper.GetString("VasCloud", "Expiration date"),
                                options:[
                                    {id:"1 month", value:LangHelper.GetString("QoE", "1 month")},
                                    {id:"3 months", value:LangHelper.GetString("QoE", "3 months")},
                                    {id:"6 months", value:LangHelper.GetString("QoE", "6 months")},
                                    {id:"1 year", value:LangHelper.GetString("QoE", "1 year")},
                                    {id:"unlimited", value:LangHelper.GetString("QoE", "Unlimited")}
                                ],
                                labelPosition: "top",
                                required: true,
                                validate: webix.rules.isNotEmpty,
                                invalidMessage:LangHelper.GetString("VasCloud", "Required field")
                            },
                            {
                                cols:[
                                    {},
                                    {
                                        view:"button",
                                        label:LangHelper.GetString("VasCloud","Cancel"),
                                        click:function ()
                                        {
                                            _this.Hide();
                                        }
                                    },
                                    {
                                        view:"button",
                                        hotkey: "enter",
                                        id: this.Id + "SendBtn",
                                        value:LangHelper.GetString("VasCloud", "Send"),
                                        type:"form",
                                        click:function ()
                                        {
                                            _this.SendLicenceRequest();
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                id: this.Id + "Wizard" + "OkPanel",
                rows:[
                    {
                        view:"form",
                        id: this.Id + "Wizard" + "Form",
                        borderless:true,
                        elements:
                            [
                                {
                                    view: "label",
                                    label: LangHelper.GetString("VasCloud", "Your request is accepted")
                                },
                                {
                                    view: "button",
                                    value: LangHelper.GetString("VasCloud", "Close"),
                                    click: function ()
                                    {
                                        _this.Hide();
                                    }
                                }
                            ]
                    }
                ]
            }
        ]
    };

    this.Views = {
        Form:null,
        FormPanel:null,
        OkPanel:null,
        SendBtn:null
    };

    this.ContextConfig = {
        view: "popup",
        id:this.Id + "Context",
        modal:true,
        padding:0,
        width:400,
        body: {
            borderless:true,
            rows:[]
        }
    };

    this.Context = null;

    this.Subscriptions = {};

    this.Init(Params);
}

VasCloudRequestLicenceViewController.prototype.Init = function (Params)
{
    var _this = this;

    if(!this.Embedded)
    {
        this.ContextConfig.body = this.ViewConfig;
        this.Context = webix.ui(this.ContextConfig);
    }
};

VasCloudRequestLicenceViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

VasCloudRequestLicenceViewController.prototype.BindAll = function (Params)
{
    this.Views.Form = $$(this.Id + "Form");

    this.Views.FormPanel = $$(this.Id + "Wizard" + "FormPanel");

    this.Views.OkPanel = $$(this.Id + "Wizard" + "OkPanel");

    this.Views.SendBtn = $$(this.Id + "SendBtn");
};

VasCloudRequestLicenceViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

VasCloudRequestLicenceViewController.prototype.Show = function(Node, Pos, Message)
{
    this.Context.show(Node, {pos:Pos});
    this.Views.FormPanel.show();
    this.Clear();
    this.SetDefault();
};

VasCloudRequestLicenceViewController.prototype.Hide = function()
{
    this.Context.hide();
};

VasCloudRequestLicenceViewController.prototype.Clear = function()
{
    this.Views.Form.clear();
    this.Views.Form.clearValidation();
};

VasCloudRequestLicenceViewController.prototype.SetDefault = function()
{
    this.Views.Form.setValues({
        product_type_code:VasCloudLicProductTypeCodeEnum.dpiui2,
        lic_level:VasCloudLicLevelEnum.standard,
        dpi_lic_level:VasCloudDPILicLevelEnum["6"],
        expiration_date:"1 month"
    });
};

VasCloudRequestLicenceViewController.prototype.SendLicenceRequest = function ()
{
    var _this = this;

    function FormModel(Params)
    {
        this.product_type_code = Params&&Params.product_type_code ? Params.product_type_code : "";
        this.lic_level = Params&&Params.lic_level ? Params.lic_level : "";
        this.dpi_lic_level = Params&&Params.dpi_lic_level ? Params.dpi_lic_level : "";
        this.expiration_date = Params&&Params.expiration_date ? Params.expiration_date : "";
    }

    if (this.Views.Form.validate())
    {
        this.Views.SendBtn.disable();

        var formModel = new FormModel(this.Views.Form.getValues());

        App.VasCloudSessionManager.SendLicenceRequest({
            data:formModel,
            callback: function (R)
            {
                _this.Views.SendBtn.enable();

                if (!R.success && R.error.msg)
                {
                    webix.message({type: "error", text: R.error.msg});
                }

                if (R.success)
                {
                    _this.Views.OkPanel.show();
                    webix.message({type: "info", expire: 10000, text: LangHelper.GetString("VasCloud", "Your request is accepted")});
                }
            }
        });
    }
};



function VasCloudAdsStatisticsViewController(Params)
{
    var _this = this;

    this.Id = "VasCloudAdsStatistics";

    if(module == "dpiui2")
    {
        if(!App.VasCloudSessionManager)
        {
            App.VasCloudSessionManager = new VasCloudSessionManager();
            App.VasCloudSessionManager.CheckLoggedIn();
        }
    }

    this.Subscriptions = {};

    this.ViewModel = new UniReportsManager();

    this.Views = {
        Widgets:{
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker", default_value:"Last 2 days"}),
            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config:{
                    type:QoESubscribersFilterListItemTypeEnum.vas_ads_statistics,
                    filters:function()
                    {
                        var filters = [];

                        if(module != "dpiui2")
                            filters.push.apply(filters,[
                            {
                                id:"acp_id",
                                title:LangHelper.GetString(_this.Id, "Content provider"),
                                type:QoEFilterValueType.String,
                                operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                                editor:"multiselect",
                                dic:DicsEnum.AdsContentProvidersDic
                            }
                        ]);

                        filters.push.apply(filters,[
                            {
                                id:"offer_id",
                                title:LangHelper.GetString(_this.Id, "Offer id"),
                                type:"string"
                            },
                            {
                                id:"offer_name",
                                title:LangHelper.GetString(_this.Id, "Offer"),
                                type:"string"
                            }
                        ]);

                        if(module != "dpiui2")
                            filters.push.apply(filters,[
                            {
                                id:"subaccount",
                                title:LangHelper.GetString(_this.Id, "Subaccount"),
                                type:"string"
                            }
                        ]);

                        return filters;
                    }(),
                    default:function ()
                    {
                        var def = [];

                        if(module != "dpiui2")
                            def.push.apply(def,[
                                {
                                    f_enabled:0,
                                    f_id:"acp_id",
                                    f_operator:QoEFilterOperatorsEnum.in
                                },
                                {
                                    f_enabled:0,
                                    f_id:"offer_id",
                                    f_operator:QoEFilterOperatorsEnum.like
                                }
                            ]);

                        def.push.apply(def,[
                            {
                                f_enabled:0,
                                f_id:"offer_name",
                                f_operator:QoEFilterOperatorsEnum.like
                            }
                        ]);

                        if(module != "dpiui2")
                            def.push.apply(def,[
                                {
                                    f_enabled:0,
                                    f_id:"subaccount",
                                    f_operator:QoEFilterOperatorsEnum.like
                                }
                            ]);

                        return def;
                    }()
                }
            }),
            StatReport: new QoETableReportWidget({
                id:this.Id + "StatReport",
                name:"VasCloudAdsStatisticsWidget",
                title:LangHelper.GetString("AppView","Statistics"),
                icon:"table",
                config:{
                    model:function (Params)
                    {
                        this.id = Params&&Params.id?Params.id:webix.uid();

                        this.date = Params&&Params.date?Params.date : null;
                        this.acp_id = Params&&Params.acp_id?Params.acp_id : 0;
                        this.offer_id = Params&&Params.offer_id?Params.offer_id : 0;
                        this.subaccount = Params&&Params.subaccount?Params.subaccount : "";
                        this.company_id = Params&&Params.company_id?Params.company_id : 0;
                        this.company_name = Params&&Params.company_name?Params.company_name : "";

                        this.offer_name = Params&&Params.offer_name?Params.offer_name : "";

                        this.traffic_shows = Params&&Params.traffic_shows?Params.traffic_shows : "";
                        this.traffic_hits = Params&&Params.traffic_hits?Params.traffic_hits : "";
                        this.traffic_clicks = Params&&Params.traffic_clicks?Params.traffic_clicks : "";
                        this.traffic_back_url = Params&&Params.traffic_back_url?Params.traffic_back_url : "";

                        this.leads_total = Params&&Params.leads_total?Params.leads_total : "";
                        this.leads_approved = Params&&Params.leads_approved?Params.leads_approved : "";
                        this.leads_opened = Params&&Params.leads_opened?Params.leads_opened : "";
                        this.leads_rejected = Params&&Params.leads_rejected?Params.leads_rejected : "";
                        this.leads_paid_targets = Params&&Params.leads_paid_targets?Params.leads_paid_targets : "";

                        this.effectivity_cr = Params&&Params.effectivity_cr?Params.effectivity_cr : "";
                        this.effectivity_ar = Params&&Params.effectivity_ar?Params.effectivity_ar : "";
                        this.effectivity_ecpc = Params&&Params.effectivity_ecpc?Params.effectivity_ecpc : "";
                        this.effectivity_ecpl = Params&&Params.effectivity_ecpl?Params.effectivity_ecpl : "";

                        this.commission_approved = Params&&Params.commission_approved?Params.commission_approved : "";
                        this.commission_opened = Params&&Params.commission_opened?Params.commission_opened : "";
                        this.commission_rejected = Params&&Params.commission_rejected?Params.commission_rejected : "";
                    },
                    method:function ()
                    {
                        var m = "";

                        var s = App.SessionManager.GetUserRoleSections();

                        if(s&&s.operator_ads&&s.operator_ads.read)
                            m = "GetMyAdsStatistics";

                        if(s&&s.ads&&s.ads.read)
                            m = "GetAdsStatistics";

                        if(module == "dpiui2")
                            m = "GetVascloudAdsStatistics";

                        return m;
                    },
                    sort:{id:"date",dir:"desc"}
                },
                columns: function ()
                {
                    var cols = [];

                    cols.push.apply(cols,[{
                        id: "date",
                        header: [
                            { content:"columnGroup", batch:"common", groupText:LangHelper.GetString(_this.Id,"Common"), colspan:(module == "dpiui2" ? 5 : 6)},
                            LangHelper.GetString(_this.Id,"Date"),
                            {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                        ],
                        sort: "string",
                        template:function(obj, common)
                        {
                            if(obj.date)
                            {
                                var format =  webix.Date.dateToStr("%d.%m.%Y");
                                return format(obj.date);
                            }

                            return "";
                        },
                        fillspace: 0,
                        width:80,
                        footer:{content:"totalRows"}
                    }]);

                    if(module != "dpiui2")
                        cols.push.apply(cols,[{
                        id: "acp_id",
                        batch:"common",
                        header: [null, LangHelper.GetString(_this.Id,"Content provider"), {
                            content: "richSelectFilter",
                            options: [],
                            inputConfig: {suggest: {fitMaster: false}}
                        }],
                        sort: "string",
                        fillspace: 0,
                        width:80,
                        template:function (Obj)
                        {
                            if(Obj&&Obj.acp_id&&AdsContentProviders&&AdsContentProviders[Obj.acp_id])
                            {
                                return AdsContentProviders[Obj.acp_id].value;
                            }

                            return Obj.acp_id;
                        },
                        footer:{content:"totalRows"}
                    }]);

                    cols.push.apply(cols, [
                        {
                            id: "offer_id",
                            batch:"common",
                            header: [null, LangHelper.GetString(_this.Id,"Offer id"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            width:80,
                            footer:{content:"totalRows"}
                        },
                        {
                            id: "offer_name",
                            batch:"common",
                            header: [null, LangHelper.GetString(_this.Id,"Offer"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            width:160,
                            footer:{content:"totalRows"}
                        },
                        {
                            id: "subaccount",
                            batch:"common",
                            header: [null, LangHelper.GetString(_this.Id,"Subaccount"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            width:160,
                            footer:{content:"totalRows"}
                        },
                        {
                            id: "company_name",
                            batch:"common",
                            header: [null, LangHelper.GetString(_this.Id,"Company name"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            template:function(Obj)
                            {
                                if(module != "dpiui2")
                                {
                                    return Obj.company_name ? CellLinkTemplate(Obj.company_name) : "";
                                }

                                return Obj.company_name ? Obj.company_name : "";
                            },
                            sort: "string",
                            fillspace: 0,
                            width:160,
                            footer:{content:"totalRows"}
                        },

                        {
                            id: "traffic_shows",
                            header: [
                                { content:"columnGroup", batch:"traffic", groupText:LangHelper.GetString(_this.Id,"Traffic"), colspan:4},
                                LangHelper.GetString(_this.Id,"Shows"),
                                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                            ],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "traffic_hits",
                            batch:"traffic",
                            header: [null, LangHelper.GetString(_this.Id,"Hits"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "traffic_clicks",
                            batch:"traffic",
                            header: [null, LangHelper.GetString(_this.Id,"Clicks"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "traffic_back_url",
                            batch:"traffic",
                            header: [null, LangHelper.GetString(_this.Id,"Back url"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },


                        {
                            id: "leads_total",
                            header: [
                                { content:"columnGroup", batch:"leads", groupText:LangHelper.GetString(_this.Id,"Leads"), colspan:5},
                                LangHelper.GetString(_this.Id,"Total"),
                                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                            ],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "leads_approved",
                            batch:"leads",
                            header: [null, LangHelper.GetString(_this.Id,"Approved"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "leads_opened",
                            batch:"leads",
                            header: [null, LangHelper.GetString(_this.Id,"Opened"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "leads_rejected",
                            batch:"leads",
                            header: [null, LangHelper.GetString(_this.Id,"Rejected"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "leads_paid_targets",
                            batch:"leads",
                            header: [null, LangHelper.GetString(_this.Id,"Paid targets"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },

                        {
                            id: "effectivity_cr",
                            header: [
                                { content:"columnGroup", batch:"effectivity", groupText:LangHelper.GetString(_this.Id,"Efficiency"), colspan:4},
                                LangHelper.GetString(_this.Id,"CR"),
                                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                            ],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "effectivity_ar",
                            batch:"effectivity",
                            header: [null, LangHelper.GetString(_this.Id,"AR"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "effectivity_ecpc",
                            batch:"effectivity",
                            header: [null, LangHelper.GetString(_this.Id,"eCPC"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "effectivity_ecpl",
                            batch:"effectivity",
                            header: [null, LangHelper.GetString(_this.Id,"eCPL"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },

                        {
                            id: "commission_approved",
                            header: [
                                { content:"columnGroup", batch:"commission", groupText:LangHelper.GetString(_this.Id,"Сommission"), colspan:3},
                                LangHelper.GetString(_this.Id,"Approved"),
                                {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                            ],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "commission_opened",
                            batch:"commission",
                            header: [null, LangHelper.GetString(_this.Id,"Opened"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "commission_rejected",
                            batch:"commission",
                            header: [null, LangHelper.GetString(_this.Id,"Rejected"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        }
                    ]);

                    return cols;
                }(),
                leftSplit:(module == "dpiui2" ? 5 : 6),
                footer:true,
                on:{
                    onItemClick: function (Id, E, Node)
                    {
                        _this.StatReportOnItemClick(Id, E, Node);
                    }
                }
            })
        }
    };

    if(module == "dpiui2")
    {
        this.Views.PageHeaderWidget = new VasCloudPageHeaderWidget({id:this.Id + "PageHeaderWidget"});
    }

    if(module != "dpiui2")
        this.Views.CompanyEditForm = new CompanyEditFormViewController({ViewOnly:true});

    this.ViewConfig = [
        {
            id:this.Id + "View",
            cols:[
                (module == "dpiui2" ? (VasCloudPersonalAreaLeftSideBarView({id:this.Id})) : ({
                    rows: [
                        VasCloudShopLeftSideBarView({id:this.Id})
                    ]
                })),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                function ()
                                {
                                    var cols = [
                                        PageHeaderTemplate({root_title:LangHelper.GetString("AppView", "Vas ADS"),title:LangHelper.GetString("AppView", "Statistics")})
                                    ];

                                    if(module == "dpiui2")
                                    {
                                        cols.push(_this.Views.PageHeaderWidget.ViewConfig);
                                    }

                                    return {cols:cols};
                                }(),
                                {
                                    rows:[
                                        {
                                            view: "toolbar",
                                            elements: [
                                                this.Views.Widgets.DateRangePicker.ViewConfig,
                                                this.Views.Widgets.ExtendedFillter.ViewConfig,
                                                {},
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("All","Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.Refresh(0);
                                                    }
                                                }
                                            ]
                                        },
                                        this.Views.Widgets.StatReport.ViewConfig
                                    ]
                                }

                            ]
                        }
                    ]
                }
            ]
        }
    ];
}

VasCloudAdsStatisticsViewController.prototype.Destroy = function ()
{
    var _this = this;

    if(module != "dpiui2")
        this.Views.CompanyEditForm.Destroy();

    if(module == "dpiui2")
        this.Views.PageHeaderWidget.Destroy();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.ViewModel.Destroy();
    delete this.ViewModel;
};

VasCloudAdsStatisticsViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(PathParams);

    //this.Refresh();
};

VasCloudAdsStatisticsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.View = $$(this.Id + "View");

    if(module != "dpiui2")
        this.Views.CompanyEditForm.BindAll();

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        _this.Views.Widgets[Key].Bind(_this);
    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.Refresh();
        }

    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
            _this.Refresh();
    });

    if(module == "dpiui2")
    {
        this.Subscriptions.ExtendedFilterReadySignal = Rx.Observable.combineLatest
        (
            App.VasCloudSessionManager.SignalIsLoggedIn,
            this.Views.Widgets.ExtendedFillter.FilterReadySignal
        ).subscribe(function(Val)
            {
                IsLoggedIn = Val[0];

                if(IsLoggedIn == null)
                    return;

                if(!IsLoggedIn)
                {
                    _this.Views.View.disable();
                    App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
                }

                if(IsLoggedIn && Val[1])
                {
                    _this.Views.View.enable();

                    if(App.NavRouter.views.VasCloudLogin)
                    {
                        App.NavRouter.views.VasCloudLogin.Hide();
                    }

                    _this.Refresh();
                }
            }
        );
        App.VasCloudSessionManager.CheckLoggedIn();
    }
    else
    {
        this.Subscriptions.ExtendedFilterReadySignal = Rx.Observable.combineLatest
        (
            App.DicsManager.Signal[DicsEnum.AdsContentProvidersDic],
            this.Views.Widgets.ExtendedFillter.FilterReadySignal
        ).subscribe(function(Val)
            {
                if(Val[0] && Val[1])
                {
                    _this.Views.Widgets.StatReport.Views.Table.getColumnConfig("acp_id").header[2].options = App.DicsManager.GetDicAsArray(DicsEnum.AdsContentProvidersDic);
                    _this.Refresh();
                }
            }
        );
    }

    if(module == "dpiui2")
    {
        this.Views.PageHeaderWidget.BindAll(Params);
    }
    
    this.GetAllPathParam();
};

VasCloudAdsStatisticsViewController.prototype.GetFilterParams = function ()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    var filter = {
        period:{
            id:"date",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    filter = webix.extend(filter, extendedFilters, true);

    return {filter:filter};
};

VasCloudAdsStatisticsViewController.prototype.Refresh = function ()
{
    var _this = this;

    var params = this.GetFilterParams();

    Object.keys(this.Views.Widgets).forEach(function (Key) {
        if(_this.Views.Widgets[Key].RefreshData)
            _this.Views.Widgets[Key].RefreshData(0, params);
    });

    _this.SetAllPathParam();
};

VasCloudAdsStatisticsViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

VasCloudAdsStatisticsViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

VasCloudAdsStatisticsViewController.prototype.SetAllPathParam = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(period)
    {
        this.SetPathParam("period", period);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    this.JustNavigate();
};

VasCloudAdsStatisticsViewController.prototype.GetAllPathParam = function()
{
    try
    {
        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);
    }
    catch(e){}
};

VasCloudAdsStatisticsViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

VasCloudAdsStatisticsViewController.prototype.StatReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if((module != "dpiui2" && Id.column === 'company_name' && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.Widgets.StatReport.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode(Id);

        _this.Views.CompanyEditForm.Show({}, node, "bottom");

        _this.Views.CompanyEditForm.LoadData({company:data});
    }
};
function VasCloudAccrualsAndPaymentsViewController(Params)
{
    var _this = this;

    this.Id = "VasCloudAccrualsAndPayments";

    if(module == "dpiui2")
    {
        if(!App.VasCloudSessionManager)
        {
            App.VasCloudSessionManager = new VasCloudSessionManager();
            App.VasCloudSessionManager.CheckLoggedIn();
        }
    }

    this.Subscriptions = {};

    this.ViewModel = new UniReportsManager();

    this.Views = {
        Widgets:{
            DateRangePicker: new QoEDateRangePickerWidget({id:this.Id + "DateRangePicker", default_value:"Last 2 days"}),
            ExtendedFillter: new QoEPopupFilterWidget({
                id:this.Id + "ExtendedFillter",
                config:{
                    type:QoESubscribersFilterListItemTypeEnum.vas_bill_history,
                    filters:function()
                    {
                        var filters = [];

                        if(module != "dpiui2")
                        {
                            filters.push.apply(filters,[
                                {
                                    id:"provider_id",
                                    title:LangHelper.GetString(_this.Id, "Content provider"),
                                    type:QoEFilterValueType.String,
                                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                                    editor:"multiselect",
                                    dic:DicsEnum.AdsContentProvidersDic
                                },
                                {
                                    id:"provider_name",
                                    title:LangHelper.GetString(_this.Id, "Content provider name"),
                                    type:QoEFilterValueType.String
                                },
                                {
                                    id:"company_id",
                                    title:LangHelper.GetString(_this.Id, "Company"),
                                    type:QoEFilterValueType.String,
                                    operators:[QoEFilterOperatorsEnum.in, QoEFilterOperatorsEnum["not in"]],
                                    editor:"multiselect",
                                    dic:DicsEnum.CompaniesDic
                                },
                                {
                                    id:"company_name",
                                    title:LangHelper.GetString(_this.Id, "Company name"),
                                    type:QoEFilterValueType.String
                                }
                            ]);
                        }

                        filters.push.apply(filters,[
                            {
                                id:"show_canceled",
                                title:LangHelper.GetString(_this.Id, "Show canceled"),
                                type:QoEFilterValueType.UInt8,
                                operators:[QoEFilterOperatorsEnum["="], QoEFilterOperatorsEnum["!="]],
                                editor:"richselect",
                                options:Helper.DictToArr(YesNoDic)
                            }
                        ]);

                        return filters;
                    }(),
                    default:function ()
                    {
                        var def = [];

                        if(module != "dpiui2")
                        {
                            def.push.apply(def,[
                                {
                                    f_enabled:0,
                                    f_id:"provider_id",
                                    f_operator:QoEFilterOperatorsEnum.in
                                },
                                {
                                    f_enabled:0,
                                    f_id:"provider_name",
                                    f_operator:QoEFilterOperatorsEnum.like
                                },
                                {
                                    f_enabled:0,
                                    f_id:"company_id",
                                    f_operator:QoEFilterOperatorsEnum.in
                                },
                                {
                                    f_enabled:0,
                                    f_id:"company_name",
                                    f_operator:QoEFilterOperatorsEnum.like
                                }
                            ]);
                        }

                        def.push.apply(def,[
                            {
                                f_enabled:0,
                                f_id:"show_canceled",
                                f_operator:QoEFilterOperatorsEnum["="]
                            }
                        ]);

                        return def;
                    }()
                }
            }),
            StatReport: new QoETableReportWidget({
                id:this.Id + "StatReport",
                name:"VasCloudAccrualsAndPaymentsWidget",
                title:LangHelper.GetString("AppView","Accruals and payments"),
                icon:"table",
                config:{
                    model:function (Params)
                    {
                        this.id = Params&&Params.id?Params.id:webix.uid();

                        this.trx_id = Params&&Params.trx_id?Params.trx_id : 0;
                        this.date = Params&&Params.date?Params.date : null;

                        this.debet = Params&&Params.debet?Params.debet : 0;
                        this.credit = Params&&Params.credit?Params.credit : 0;

                        this.contract_id = Params&&Params.contract_id?Params.contract_id : 0;

                        this.charge_id = Params&&Params.charge_id?Params.charge_id : null;
                        this.charge_service_id = Params&&Params.charge_service_id?Params.charge_service_id : null;

                        this.payment_id = Params&&Params.payment_id?Params.payment_id : null;
                        this.remain_id = Params&&Params.remain_id?Params.remain_id : null;

                        this.revoke_id = Params&&Params.revoke_id?Params.revoke_id : null;
                        this.revokeby_id = Params&&Params.revokeby_id?Params.revokeby_id : null;

                        this.company_id = Params&&Params.company_id?Params.company_id : null;
                        this.provider_id = Params&&Params.provider_id?Params.provider_id : null;

                        this.note = Params&&Params.note?Params.note : null;
                    },
                    method:function ()
                    {
                        var m = "";

                        var s = App.SessionManager.GetUserRoleSections();

                        if(s&&s.operator_ads&&s.operator_ads.read)
                            m = "GetMyBillHistoryReport";

                        if(s&&s.ads&&s.ads.read)
                            m = "GetBillHistoryReport";

                        if(module == "dpiui2")
                            m = "GetVasCloudBillHistoryReport";

                        return m;
                    },
                    sort:{id:"date",dir:"desc"}
                },
                columns: function ()
                {
                    var cols = [];

                    cols.push.apply(cols,[
                        {
                            id: "trx_id",
                            header: [LangHelper.GetString(_this.Id,"Id"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            width:80,
                            footer:{content:"totalRows"}
                        },
                        {
                            id: "date",
                            header: [LangHelper.GetString(_this.Id,"Date"),{content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            template:function(obj, common)
                            {
                                if(obj.date)
                                {
                                    var format =  webix.Date.dateToStr("%d.%m.%Y");
                                    return format(obj.date);
                                }

                                return "";
                            },
                            fillspace: 0,
                            width:80,
                            footer:{content:"totalRows"}
                        },
                        {
                            id: "debet",
                            header: [LangHelper.GetString(_this.Id,"Accrual"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "credit",
                            header: [LangHelper.GetString(_this.Id,"Write-off"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: 0,
                            footer:{content:"totalColumn"}
                        },
                        {
                            id: "note",
                            header: [LangHelper.GetString(_this.Id,"Note"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            fillspace: true,
                            template:function (Obj)
                            {
                                var note = Obj.note ? Obj.note : "";

                                if(Obj.revoke_id > 0)
                                    note = "<span style='color: " + ColorsDic["23"].value + "'>" + LangHelper.GetString(_this.Id, "Canceled transaction") + ".</span> " +  note;

                                if(Obj.revokeby_id > 0)
                                    note = "<span style='color: " + ColorsDic["23"].value + "'>" + LangHelper.GetString(_this.Id, "Cancel transaction") + ".</span> " +  note;

                                return note;
                            },
                            footer:{content:"totalRows"}
                        }
                    ]);
                    return cols;
                }(),
                footer:true
            })
        }
    };

    if(module == "dpiui2")
    {
        this.Views.PageHeaderWidget = new VasCloudPageHeaderWidget({id:this.Id + "PageHeaderWidget"});
    }

    this.ViewConfig = [
        {
            id:this.Id + "View",
            cols:[
                (module == "dpiui2" ? (VasCloudPersonalAreaLeftSideBarView({id:this.Id})) : ({
                    rows: [
                        VasCloudShopLeftSideBarView({id:this.Id})
                    ]
                })),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                function ()
                                {
                                    var cols = [
                                        PageHeaderTemplate({root_title:LangHelper.GetString("AppView", "Vas ADS"),title:LangHelper.GetString("AppView", "Accruals and payments")})
                                    ];

                                    if(module == "dpiui2")
                                    {
                                        cols.push(_this.Views.PageHeaderWidget.ViewConfig);
                                    }

                                    return {cols:cols};
                                }(),
                                {
                                    rows:[
                                        {
                                            view: "toolbar",
                                            elements:function()
                                            {
                                                var elements = [];

                                                elements = elements.concat([
                                                    _this.Views.Widgets.DateRangePicker.ViewConfig,
                                                    _this.Views.Widgets.ExtendedFillter.ViewConfig
                                                ]);

                                                if(module == "vascloud")
                                                {
                                                    elements = elements.concat([
                                                        {width: 32},
                                                        {
                                                            view: "button",
                                                            id:_this.Id + "AddBillTransactionBtn",
                                                            type: "icon",
                                                            icon: "plus",
                                                            label:LangHelper.GetString("VasCloudAccrualsAndPayments","Make transaction"),
                                                            css: "toolbar_round_btn",
                                                            width: 160,
                                                            tooltip: LangHelper.GetString("VasCloudAccrualsAndPayments","Make transaction"),
                                                            click: function (id, e, node)
                                                            {
                                                                var model = {};
                                                                _this.ShowBillTransactionForm(model, this.getNode(), "bottom");
                                                            }
                                                        }
                                                    ]);
                                                }

                                                elements = elements.concat([
                                                    {},
                                                    {
                                                        view: "button",
                                                        type: "icon",
                                                        icon: "refresh",
                                                        css: "toolbar_round_btn",
                                                        width: 32,
                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.Refresh(0);

                                                            if(module == "dpiui2")
                                                                App.VasCloudSessionManager.RefreshBalanceInfo();
                                                        }
                                                    }
                                                ]);

                                                return elements;
                                            }()
                                        },
                                        this.Views.Widgets.StatReport.ViewConfig
                                    ]
                                }

                            ]
                        }
                    ]
                }
            ]
        }
    ];
}

VasCloudAccrualsAndPaymentsViewController.prototype.Destroy = function ()
{
    var _this = this;

    if(module == "dpiui2")
        this.Views.PageHeaderWidget.Destroy();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.ViewModel.Destroy();
    delete this.ViewModel;
};

VasCloudAccrualsAndPaymentsViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(PathParams);

    //this.ShowBillTransactionForm(null, this.Views.AddBillTransactionBtn.getNode(), "bottom");
};

VasCloudAccrualsAndPaymentsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.View = $$(this.Id + "View");

    Object.keys(this.Views.Widgets).forEach(function (Key)
    {
        _this.Views.Widgets[Key].Bind(_this);
    });

    this.Subscriptions.DateRangePicker = this.Views.Widgets.DateRangePicker.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            _this.Refresh();
        }

    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.Widgets.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
            _this.Refresh();
    });

    if(module == "dpiui2")
    {
        this.Subscriptions.ExtendedFilterReadySignal = Rx.Observable.combineLatest
        (
            App.VasCloudSessionManager.SignalIsLoggedIn,
            this.Views.Widgets.ExtendedFillter.FilterReadySignal
        ).subscribe(function(Val)
            {
                IsLoggedIn = Val[0];

                if(IsLoggedIn == null)
                    return;

                if(!IsLoggedIn)
                {
                    _this.Views.View.disable();
                    App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
                }

                if(IsLoggedIn && Val[1])
                {
                    _this.Views.View.enable();

                    if(App.NavRouter.views.VasCloudLogin)
                    {
                        App.NavRouter.views.VasCloudLogin.Hide();
                    }

                    _this.Refresh();
                }
            }
        );
        App.VasCloudSessionManager.CheckLoggedIn();
    }
    else
    {
        this.Subscriptions.ExtendedFilterReadySignal = this.Views.Widgets.ExtendedFillter.FilterReadySignal.subscribe(function (Signal)
        {
            if(Signal)
                _this.Refresh();
        });
    }

    if(module == "dpiui2")
    {
        this.Views.PageHeaderWidget.BindAll(Params);
    }

    this.Views.AddBillTransactionBtn = $$(this.Id + "AddBillTransactionBtn");

    this.GetAllPathParam();
};

VasCloudAccrualsAndPaymentsViewController.prototype.GetFilterParams = function ()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(!period.start || !period.end)
        return;

    var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

    var filter = {
        period:{
            id:"date",
            operator:"between",
            value:[format(period.start), format(period.end)]
        }
    };

    var extendedFilters = this.Views.Widgets.ExtendedFillter.GetFilters();

    filter = webix.extend(filter, extendedFilters, true);

    return {filter:filter};
};

VasCloudAccrualsAndPaymentsViewController.prototype.Refresh = function ()
{
    var _this = this;

    var params = this.GetFilterParams();

    Object.keys(this.Views.Widgets).forEach(function (Key) {
        if(_this.Views.Widgets[Key].RefreshData)
            _this.Views.Widgets[Key].RefreshData(0, params);
    });

    _this.SetAllPathParam();
};

VasCloudAccrualsAndPaymentsViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

VasCloudAccrualsAndPaymentsViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

VasCloudAccrualsAndPaymentsViewController.prototype.SetAllPathParam = function()
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(period)
    {
        this.SetPathParam("period", period);
    }

    var filter = this.Views.Widgets.ExtendedFillter.GetFilterCode();
    if(filter)
    {
        this.SetPathParam("filter", filter);
    }

    this.JustNavigate();
};

VasCloudAccrualsAndPaymentsViewController.prototype.GetAllPathParam = function()
{
    try
    {
        var period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        var filter = this.GetPathParam("filter");
        this.Views.Widgets.ExtendedFillter.SetFilterCode(filter);
    }
    catch(e){}
};

VasCloudAccrualsAndPaymentsViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};

VasCloudAccrualsAndPaymentsViewController.prototype.ShowBillTransactionForm = function (Data, Node, Pos)
{
    var _this = this;

    App.NavRouter.PresentModalView({
        id: "VasCloudBillTransaction",
        data: Data
    });

    App.NavRouter.views.VasCloudBillTransaction.Show(Node,Pos);

    this.Subscriptions.VasCloudBillTransactionSaveDataSinal = App.NavRouter.views.VasCloudBillTransaction.Signals.SaveDataSinal.subscribe(function (DataToSave)
    {
        if (DataToSave)
        {
            _this.Refresh();
        }
    });
};
function VasCloudPersonalAreaViewController(Params)
{
    var _this = this;

    this.Id = "VasCloudPersonalArea";

    if(!App.VasCloudSessionManager)
    {
        App.VasCloudSessionManager = new VasCloudSessionManager();
        App.VasCloudSessionManager.CheckLoggedIn();
    }

    this.RequestLicenceContext = new VasCloudRequestLicenceViewController();

    this.Views =
    {
        View:null,

        PageHeaderWidget: new VasCloudPageHeaderWidget({id:this.Id + "PageHeaderWidget"}),

        GroupsScrollView:null,
        GroupsList:null,

        GroupCompany:null,
        GroupCompanyForm:null,

        GroupProfile:null,
        GroupProfileForm:null,

        GroupSecurity:null,
        GroupSecurityForm:null,

        GroupLics:null,
        GroupLicsForm:null,
        LicReqBtn:null
    };

    this.scrollTimeout = null;

    this.ViewConfig = [
        {
            id:this.Id + "View",
            cols: [
                VasCloudPersonalAreaLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                {
                                    cols:[
                                        PageHeaderTemplate({root_title:LangHelper.GetString("VasCloud", "Vas Cloud"),title:LangHelper.GetString("VasCloud", "Account")}),
                                        this.Views.PageHeaderWidget.ViewConfig
                                    ]
                                },
                                {
                                    height:32
                                },
                                {
                                    cols:[
                                        {
                                            gravity:0.3
                                        },
                                        {
                                            gravity:2,
                                            cols:[
                                                {
                                                    width: 160,
                                                    rows: [
                                                        {
                                                            id:this.Id + "GroupsList",
                                                            view: "datatable",
                                                            header:false,
                                                            select: "row",
                                                            type: "clear",
                                                            borderless: true,
                                                            on: {
                                                                onAfterSelect: function (data, preserve)
                                                                {
                                                                    if($$(_this.Id + data.id))
                                                                    {

                                                                        var node = $$(_this.Id + data.id + "Anchor").$view;
                                                                        node.scrollIntoView({ behavior:"smooth" });
                                                                        // _this.Views.GroupsScrollView.showView(_this.Id + data.id + "Anchor");
                                                                        //_this.Views.GroupsScrollView.scrollTo(0,500);
                                                                    }
                                                                }
                                                            },
                                                            columns:
                                                            [
                                                                {
                                                                    id: "icon",
                                                                    width:32,
                                                                    template: function (Obj)
                                                                    {
                                                                        return "<span class=\"webix_icon fa-"+Obj.icon+"\"></span>";
                                                                    }
                                                                },
                                                                {
                                                                    id: "value",
                                                                    fillspace: true
                                                                }
                                                            ],
                                                            data: [
                                                                {id:"GroupCompany", value:LangHelper.GetString("VasCloud", "Company"), icon: "building"},
                                                                {id:"GroupProfile", value:LangHelper.GetString("VasCloud", "Profile"), icon: "user"},
                                                                {id:"GroupSecurity", value:LangHelper.GetString("VasCloud", "Security"), icon: "lock"},
                                                                {id:"GroupLics", value:LangHelper.GetString("VasCloud", "Licences"), icon: "file-certificate"}
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    type: "clear",
                                                    borderless: true,
                                                    view: "scrollview",
                                                    id: this.Id + "GroupsScrollView",
                                                    scroll:"y",
                                                    on:{
                                                        onAfterScroll:function()
                                                        {
                                                            var __this = this;
                                                            clearTimeout(_this.scrollTimeout);

                                                            _this.scrollTimeout = setTimeout(function () {
                                                                var pos = __this.getScrollState();
                                                                var data = _this.Views.GroupsList.serialize();

                                                                var idToSelect = "";

                                                                data.forEach(function (Item)
                                                                {
                                                                    if($$(_this.Id + Item.id))
                                                                    {
                                                                        var node = $$(_this.Id + Item.id + "Anchor").$view;

                                                                        if(pos.y >= node.offsetTop - 80)
                                                                            idToSelect = Item.id;
                                                                    }
                                                                });

                                                                if(idToSelect)
                                                                {
                                                                    _this.Views.GroupsList.blockEvent();
                                                                    _this.Views.GroupsList.select(idToSelect);
                                                                    _this.Views.GroupsList.unblockEvent();
                                                                }
                                                            }, 100);
                                                        }
                                                    },
                                                    body:{
                                                        cols:[
                                                            {width:32},
                                                            {
                                                                view:"accordion",
                                                                multi:true,
                                                                rows:[
                                                                    {
                                                                        height:1,
                                                                        id: this.Id + "GroupCompanyAnchor"
                                                                    },
                                                                    {
                                                                        id: this.Id + "GroupCompany",
                                                                        header:BlockHeaderTemplate().template({title: LangHelper.GetString("VasCloud", "Company"), icon: "building"}),
                                                                        body:{
                                                                            rows:[
                                                                                {
                                                                                    view: "form",
                                                                                    id: this.Id + "GroupCompany" + "Form",
                                                                                    elements: [
                                                                                        {
                                                                                            cols:[
                                                                                                {
                                                                                                    view: "text",
                                                                                                    label: LangHelper.GetString("VasCloud", "Company code"),
                                                                                                    name: "code",
                                                                                                    labelPosition: "top",
                                                                                                    //required: true,
                                                                                                    invalidMessage: LangHelper.GetString("VasCloud", "Enter company code"),
                                                                                                    validate: webix.rules.isNotEmpty,
                                                                                                    disabled:true,
                                                                                                    attributes:{maxlength:50},
                                                                                                    on: {
                                                                                                        "onChange": function () {
                                                                                                            this.validate();
                                                                                                        }
                                                                                                    }
                                                                                                },
                                                                                                {
                                                                                                    view: "button",
                                                                                                    type: "icon",
                                                                                                    icon: "clone",
                                                                                                    css:"toolbar_round_btn",
                                                                                                    tooltip: LangHelper.GetString("VasCloud", "Copy to clipboard"),
                                                                                                    width:32,
                                                                                                    click: function () {
                                                                                                        var codeValue = _this.Views.GroupCompanyForm.elements.code.config.value
                                                                                                        navigator.clipboard.writeText(codeValue)
                                                                                                            .then(() => {
                                                                                                                webix.message(LangHelper.GetString("VasCloud", "Copied to clipboard"))
                                                                                                            })
                                                                                                            .catch(err => {
                                                                                                                webix.message(err)
                                                                                                            });
                                                                                                    }
                                                                                                }
                                                                                            ],
                                                                                        },
                                                                                        {
                                                                                            view: "text",
                                                                                            label: LangHelper.GetString("VasCloud", "Company name"),
                                                                                            name: "name",
                                                                                            tooltip: LangHelper.GetString("VasCloud", "Name of your company"),
                                                                                            labelPosition: "top",
                                                                                            required: true,
                                                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter company name"),
                                                                                            validate: webix.rules.isNotEmpty,
                                                                                            attributes:{maxlength:50},
                                                                                            on: {
                                                                                                "onChange": function () {
                                                                                                    this.validate();
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            cols: [
                                                                                                {
                                                                                                    gravity:3
                                                                                                },
                                                                                                {
                                                                                                    view: "button",
                                                                                                    label: LangHelper.GetString("VasCloud", "Cancel"),
                                                                                                    click: function ()
                                                                                                    {
                                                                                                        setTimeout(function () {
                                                                                                            App.VasCloudSessionManager.RefreshMyCompanyProfile();
                                                                                                        },1);
                                                                                                    }
                                                                                                },
                                                                                                {
                                                                                                    view: "button",
                                                                                                    type: "form",
                                                                                                    label: LangHelper.GetString("VasCloud", "Save"),
                                                                                                    click: function ()
                                                                                                    {
                                                                                                        setTimeout(function () {
                                                                                                            _this.SaveCompanyProfileForm();
                                                                                                        },1);
                                                                                                    }
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        height:31
                                                                    },
                                                                    {
                                                                        height:1,
                                                                        id: this.Id + "GroupProfileAnchor"
                                                                    },
                                                                    {
                                                                        id: this.Id + "GroupProfile",
                                                                        header:BlockHeaderTemplate().template({title: LangHelper.GetString("VasCloud", "Profile"), icon: "user"}),
                                                                        body:{
                                                                            rows:[
                                                                                {
                                                                                    view: "form",
                                                                                    id: this.Id + "GroupProfile" + "Form",
                                                                                    elements: [
                                                                                        {
                                                                                            view: "text",
                                                                                            label: LangHelper.GetString("VasCloud", "Username"),
                                                                                            name: "username",
                                                                                            labelPosition: "top",
                                                                                            required: true,
                                                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter user name"),
                                                                                            validate: webix.rules.isNotEmpty,
                                                                                            disabled:true,
                                                                                            attributes:{maxlength:50},
                                                                                            on: {
                                                                                                "onChange": function () {
                                                                                                    this.validate();
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            view: "text",
                                                                                            label: LangHelper.GetString("VasCloud", "Full name"),
                                                                                            name: "name",
                                                                                            tooltip: LangHelper.GetString("VasCloud", "Last name First name Middle name"),
                                                                                            labelPosition: "top",
                                                                                            required: true,
                                                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter your full name"),
                                                                                            validate: webix.rules.isNotEmpty,
                                                                                            attributes:{maxlength:50},
                                                                                            on: {
                                                                                                "onChange": function () {
                                                                                                    this.validate();
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            view: "text",
                                                                                            label: LangHelper.GetString("VasCloud", "Position"),
                                                                                            name: "position",
                                                                                            tooltip: LangHelper.GetString("VasCloud", "Position"),
                                                                                            labelPosition: "top",
                                                                                            required: true,
                                                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter your position"),
                                                                                            validate: webix.rules.isNotEmpty,
                                                                                            attributes:{maxlength:50},
                                                                                            on: {
                                                                                                "onChange": function () {
                                                                                                    this.validate();
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            view: "text",
                                                                                            label: "E-mail",
                                                                                            name: "email",
                                                                                            labelPosition: "top",
                                                                                            required: true,
                                                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter your e-mail"),
                                                                                            disabled: true, // #113436
                                                                                            validate: webix.rules.isEmail,
                                                                                            attributes:{maxlength:50},
                                                                                            on: {
                                                                                                "onChange": function () {
                                                                                                    this.validate();
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            view: "text",
                                                                                            label: LangHelper.GetString("VasCloud", "Phone"),
                                                                                            name: "phone",
                                                                                            tooltip: LangHelper.GetString("VasCloud", "Contact number"),
                                                                                            labelPosition: "top",
                                                                                            required: true,
                                                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter phone number"),
                                                                                            validate: webix.rules.isNotEmpty,
                                                                                            attributes:{maxlength:50},
                                                                                            on: {
                                                                                                "onChange": function () {
                                                                                                    this.validate();
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            cols: [
                                                                                                {
                                                                                                    gravity:3
                                                                                                },
                                                                                                {
                                                                                                    view: "button",
                                                                                                    label: LangHelper.GetString("VasCloud", "Cancel"),
                                                                                                    click: function ()
                                                                                                    {
                                                                                                        setTimeout(function () {
                                                                                                            App.VasCloudSessionManager.RefreshMyUserProfile();
                                                                                                        },1);
                                                                                                    }
                                                                                                },
                                                                                                {
                                                                                                    view: "button",
                                                                                                    type: "form",
                                                                                                    label: LangHelper.GetString("VasCloud", "Save"),
                                                                                                    click: function ()
                                                                                                    {
                                                                                                        setTimeout(function () {
                                                                                                            _this.SaveUserProfileForm();
                                                                                                        },1);
                                                                                                    }
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        height:31
                                                                    },
                                                                    {
                                                                        height:1,
                                                                        id: this.Id + "GroupSecurityAnchor"
                                                                    },
                                                                    {
                                                                        id: this.Id + "GroupSecurity",
                                                                        header:BlockHeaderTemplate().template({title: LangHelper.GetString("VasCloud", "Change password"), icon: "lock"}),
                                                                        body:{
                                                                            id: this.Id + "GroupSecurity" + "Form",
                                                                            view: "form",
                                                                            borderless: true,
                                                                            elements: [
                                                                                {
                                                                                    view: "text",
                                                                                    label: LangHelper.GetString("VasCloud", "Old password"),
                                                                                    name: "password_old",
                                                                                    type: "password",
                                                                                    tooltip: LangHelper.GetString("VasCloud", "Old password"),
                                                                                    "labelPosition": "top",
                                                                                    invalidMessage: LangHelper.GetString("VasCloud", "Enter password"),
                                                                                    validate: webix.rules.isNotEmpty,
                                                                                    attributes:{maxlength:30},
                                                                                    on: {
                                                                                        "onChange": function () {
                                                                                            this.validate();
                                                                                        }
                                                                                    }
                                                                                },
                                                                                {
                                                                                    cols:[
                                                                                        {
                                                                                            view: "text",
                                                                                            label: LangHelper.GetString("VasCloud", "New password"),
                                                                                            name: "password_new",
                                                                                            type: "password",
                                                                                            tooltip: LangHelper.GetString("VasCloud", "New password"),
                                                                                            "labelPosition": "top",
                                                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter password"),
                                                                                            validate: webix.rules.isNotEmpty,
                                                                                            attributes:{maxlength:30}
                                                                                        },
                                                                                        {
                                                                                            view: "text",
                                                                                            label: LangHelper.GetString("VasCloud", "Confirm password"),
                                                                                            name: "password_new_confirm",
                                                                                            type: "password",
                                                                                            tooltip: LangHelper.GetString("VasCloud", "Confirm password"),
                                                                                            "labelPosition": "top",
                                                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter password"),
                                                                                            validate: webix.rules.isNotEmpty,
                                                                                            attributes:{maxlength:30}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    cols: [
                                                                                        {
                                                                                            gravity:3
                                                                                        },
                                                                                        {
                                                                                            view: "button",
                                                                                            label: LangHelper.GetString("VasCloud", "Cancel"),
                                                                                            click: function ()
                                                                                            {
                                                                                                setTimeout(function () {
                                                                                                    _this.Views.GroupSecurityForm.clear();
                                                                                                    _this.Views.GroupSecurityForm.clearValidation();
                                                                                                },1);
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            view: "button",
                                                                                            type: "form",
                                                                                            label: LangHelper.GetString("VasCloud", "Save"),
                                                                                            click: function ()
                                                                                            {
                                                                                                setTimeout(function () {
                                                                                                    _this.SaveSecurityForm();
                                                                                                },1);
                                                                                            }
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            rules:{
                                                                                $obj:function(data)
                                                                                {
                                                                                    if (data.password_new_confirm != data.password_new){
                                                                                        webix.message({type:"error", text:LangHelper.GetString("VasCloud", "Passwords do not match")});
                                                                                        return false;
                                                                                    }
                                                                                    return true;
                                                                                }
                                                                            }
                                                                        }
                                                                    },
                                                                    {
                                                                        height:31
                                                                    },
                                                                    {
                                                                        height:1,
                                                                        id: this.Id + "GroupLicsAnchor"
                                                                    },
                                                                    {
                                                                        id: this.Id + "GroupLics",
                                                                        header:BlockHeaderTemplate().template({title: LangHelper.GetString("VasCloud", "Licences"), icon: "file-certificate"}),
                                                                        body:{
                                                                            rows:[
                                                                                {
                                                                                    view: "toolbar",
                                                                                    elements: [
                                                                                        {
                                                                                            view:"button",
                                                                                            id:this.Id + "GroupLics" + "LicReqBtn",
                                                                                            type: "icon",
                                                                                            icon: "plus",
                                                                                            label:LangHelper.GetString("VasCloud","Request a licenсe"),
                                                                                            css: "toolbar_round_btn",
                                                                                            minWidth:200,
                                                                                            click:function ()
                                                                                            {
                                                                                                var node = this.getNode();
                                                                                                _this.RequestLicenceContext.Show(node, "right");
                                                                                            }
                                                                                        },
                                                                                        {
                                                                                            gravity:4
                                                                                        },
                                                                                        {
                                                                                            view: "button",
                                                                                            type: "icon",
                                                                                            icon: "refresh",
                                                                                            css: "toolbar_round_btn",
                                                                                            width: 32,
                                                                                            tooltip: LangHelper.GetString(_this.Id, "Refresh"),
                                                                                            click: function (id, e, node) {
                                                                                                App.VasCloudSessionManager.RefreshMyLics();
                                                                                            }
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    view: "datatable",
                                                                                    id: this.Id + "GroupLics" + "Form",
                                                                                    select: "row",
                                                                                    resizeColumn: true,
                                                                                    tooltip:true,
                                                                                    autoheight:true,
                                                                                    minHeight:80,
                                                                                    columns: [
                                                                                        {
                                                                                            id: "product_type_code",
                                                                                            header:TooltipTemplate(LangHelper.GetString("VasCloud", "Product type")),
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        },
                                                                                        {
                                                                                            id: "lic_level",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud", "Licence level")),
                                                                                            template:function(obj, common)
                                                                                            {
                                                                                                if(obj.lic_level)
                                                                                                {
                                                                                                    return Helper.ToUpperCaseFirstLetter(obj.lic_level);
                                                                                                }

                                                                                                return obj.dpi_lic_level;
                                                                                            },
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        },
                                                                                        {
                                                                                            id: "dpi_lic_level",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud", "DPI licence level")),
                                                                                            template:function(obj, common)
                                                                                            {
                                                                                                if(obj.dpi_lic_level)
                                                                                                {
                                                                                                    return LangHelper.GetString("VasCloud", "CKAT")+ "-" + obj.dpi_lic_level;
                                                                                                }

                                                                                                return obj.dpi_lic_level;
                                                                                            },
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        },
                                                                                        {
                                                                                            id: "lic_options",
                                                                                            batch:"license_parameters",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud", "Lic options")),
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        },
                                                                                        {
                                                                                            id: "expiration_date",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud","Expiration date")),
                                                                                            template:function(obj, common)
                                                                                            {
                                                                                                if(obj.expiration_date)
                                                                                                {
                                                                                                    var format =  webix.Date.dateToStr("%d.%m.%Y");
                                                                                                    return format(obj.expiration_date);
                                                                                                }

                                                                                                return "";
                                                                                            },
                                                                                            sort: "date",
                                                                                            //fillspace: true
                                                                                        },
                                                                                        {
                                                                                            id: "support_expiration_date",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud","Support expiration date")),
                                                                                            template:function(obj, common)
                                                                                            {
                                                                                                if(obj.support_expiration_date)
                                                                                                {
                                                                                                    var format =  webix.Date.dateToStr("%d.%m.%Y");
                                                                                                    return format(obj.support_expiration_date);
                                                                                                }

                                                                                                return "";
                                                                                            },
                                                                                            sort: "date",
                                                                                            //fillspace: true
                                                                                        },
                                                                                        {
                                                                                            id: "product_uuid",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud", "Product uuid")),
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        },
                                                                                        {
                                                                                            id: "lic_limit",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud", "Licence limit")),
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        },
                                                                                        {
                                                                                            id: "board_serial",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud", "Board serial")),
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        },
                                                                                        {
                                                                                            id: "chassis_serial",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud", "Chassis serial")),
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        },
                                                                                        {
                                                                                            id: "addresses",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud", "MAC addresses")),
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        },
                                                                                        {
                                                                                            id: "speeds",
                                                                                            header: TooltipTemplate(LangHelper.GetString("VasCloud", "Speeds")),
                                                                                            //fillspace: true,
                                                                                            sort: "string"
                                                                                        }
                                                                                    ],
                                                                                    data:[]
                                                                                },
                                                                                {
                                                                                    template:"" +
                                                                                        "<ol>" +
                                                                                            '<li><a href="https://dpidocs.cubro.com/doku.php?id=licenses:citra-2026" title="licenses:citra-2026" target="_blank">2026 - Software and Use Case License Certificate</a></li>' +
                                                                                            '<li><a href="https://dpidocs.cubro.com/doku.php?id=licenses:citra-2025" title="licenses:citra-2026" target="_blank">2024 - Software and Use Case License Certificate</a></li>' +
                                                                                        "</ol>",
                                                                                    minHeight:56,
                                                                                    hidden:!(vendor === 'cubro' && AppEnv.CloudServiceDPILinks_isVisible === 1)
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        height:800
                                                                    }
                                                                ]
                                                            },
                                                            {width:32}
                                                        ]
                                                    }
                                                }
                                            ]
                                        },
                                        {}
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Subscriptions = {};

    return this;
}

VasCloudPersonalAreaViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(PathParams);

    this.RequestLicenceContext.ViewDidLoad(PathParams);

    var licenceRequest = this.GetPathParam("LicRequest");

    this.Views.GroupsList.select(this.Views.GroupsList.serialize()[0].id);

    //App.VasCloudSessionManager.RefreshMyUserProfile();
    //App.VasCloudSessionManager.RefreshMyCompanyProfile();

};

VasCloudPersonalAreaViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.View = $$(this.Id + "View");

    this.Views.GroupsScrollView = $$(this.Id + "GroupsScrollView");
    this.Views.GroupsList = $$(this.Id + "GroupsList");

    this.Views.GroupCompany = $$(this.Id + "GroupCompany");
    this.Views.GroupCompanyForm = $$(this.Id + "GroupCompany" + "Form");

    this.Views.GroupProfile = $$(this.Id + "GroupProfile");
    this.Views.GroupProfileForm = $$(this.Id + "GroupProfile" + "Form");

    this.Views.GroupSecurity = $$(this.Id + "GroupSecurity");
    this.Views.GroupSecurityForm = $$(this.Id + "GroupSecurity" + "Form");

    this.Views.GroupLics = $$(this.Id + "GroupLics");
    this.Views.GroupLicsForm = $$(this.Id + "GroupLics" + "Form");
    webix.extend(this.Views.GroupLicsForm, webix.OverlayBox);

    this.Views.LicReqBtn = $$(this.Id + "GroupLics" + "LicReqBtn");

    this.Subscriptions.ProfileUpdatedSubscription = App.VasCloudSessionManager.MyProfileUpdatedSignal.subscribe(function(Updated)
    {
        if(Updated)
        {
            _this.DefineUserProfileForm();
            App.VasCloudSessionManager.RefreshMyCompanyProfile();
            App.VasCloudSessionManager.RefreshMyLics();
        }
    });

    this.Subscriptions.CompanyProfileUpdatedSubscription = App.VasCloudSessionManager.MyCompanyProfileUpdatedSignal.subscribe(function(Updated)
    {
        if(Updated)
        {
            _this.DefineCompanyProfileForm();
        }
    });

    this.Subscriptions.MyLicsUpdatedSubscription = App.VasCloudSessionManager.MyLicsUpdatedSignal.subscribe(function(Data)
    {
        if(Data)
        {
            _this.DefineMyLicsForm(Data);

            App.SessionManager.RefreshAppVersion();
        }
    });

    this.Subscriptions.SignalIsLoggedIn = App.VasCloudSessionManager.SignalIsLoggedIn.subscribe(function (IsLoggedIn)
    {
        if(IsLoggedIn == null)
            return;

        if (IsLoggedIn)
        {
            _this.Views.View.enable();

            if(App.NavRouter.views.VasCloudLogin)
            {
                App.NavRouter.views.VasCloudLogin.Hide();
            }

            var licenceRequest = _this.GetPathParam("LicRequest");

            if(licenceRequest)
            {
                setTimeout(function () {
                    _this.Views.GroupsList.select(_this.Views.GroupsList.serialize()[3].id);

                    setTimeout(function () {
                        var node = _this.Views.LicReqBtn.getNode();
                        _this.RequestLicenceContext.Show(node, "right");
                    },1000);
                },1000);
            }
        }
        else
        {
            _this.Views.View.disable();
            App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
        }
    });

    App.VasCloudSessionManager.CheckLoggedIn();

    this.Views.PageHeaderWidget.BindAll(Params);
};

VasCloudPersonalAreaViewController.prototype.Destroy = function ()
{
    var _this = this;

    this.Views.PageHeaderWidget.Destroy();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

VasCloudPersonalAreaViewController.prototype.DefineUserProfileForm = function ()
{
    var profile = App.VasCloudSessionManager.GetMyUserProfile();
    this.Views.GroupProfileForm.setValues(profile?profile:{});
};

VasCloudPersonalAreaViewController.prototype.DefineCompanyProfileForm = function ()
{
    var profile = App.VasCloudSessionManager.GetMyCompanyProfile();
    this.Views.GroupCompanyForm.setValues(profile?profile:{});
};

VasCloudPersonalAreaViewController.prototype.DefineLicsForm = function ()
{
    //var profile = App.VasCloudSessionManager.GetMyCompanyProfile();
    //this.Views.GroupCompanyForm.setValues(profile?profile:{});
};

VasCloudPersonalAreaViewController.prototype.SaveUserProfileForm = function (RowId)
{
    var _this = this;

    if(this.Views.GroupProfileForm.validate())
    {
        var data = this.Views.GroupProfileForm.getValues();

        App.VasCloudSessionManager.SaveMyProfile({data:data, callback:function (R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString(_this.Id, "Saved"));
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
    }
};

VasCloudPersonalAreaViewController.prototype.SaveCompanyProfileForm = function (RowId)
{
    var _this = this;

    if(this.Views.GroupCompanyForm.validate())
    {
        var data = this.Views.GroupCompanyForm.getValues();

        App.VasCloudSessionManager.SaveMyCompanyProfile({data:data, callback:function (R)
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString(_this.Id, "Saved"));
                }
                else
                {
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
};

VasCloudPersonalAreaViewController.prototype.SaveSecurityForm = function (RowId)
{
    var _this = this;

    if(this.Views.GroupSecurityForm.validate())
    {
        var data = this.Views.GroupSecurityForm.getValues();

        data = {
            OldPassword:data.password_old,
            NewPassword:data.password_new
        };

        App.VasCloudSessionManager.ChangeMyPassword({data:data, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.GroupSecurityForm.clear();
                    _this.Views.GroupSecurityForm.clearValidation();
                    webix.message(LangHelper.GetString(_this.Id, "Saved"));
                }
                else
                {
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
};

VasCloudPersonalAreaViewController.prototype.DefineMyLicsForm = function (Data)
{
    var profile = App.VasCloudSessionManager.GetMyCompanyProfile();

    this.Views.GroupLicsForm.clearAll();
    this.Views.GroupLicsForm.parse(Data);

    if(!this.Views.GroupLicsForm.count()){
        this.Views.GroupLicsForm.showOverlay(LangHelper.GetString("VasCloud", "No licences found"));
    }
    else
    {
        this.Views.GroupLicsForm.hideOverlay();
    }
};

VasCloudPersonalAreaViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

VasCloudPersonalAreaViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

VasCloudPersonalAreaViewController.prototype.JustNavigate = function()
{
    App.NavRouter.JustNavigate(this.Id, this.PathParams);
};
function VasCloudLoginViewController(Params) {
    "use strict";

    var _this = this;

    this.Id = "VasCloudLoginView";

    this.modal = Params&&Params.modal ? Params.modal : false;

    this.ViewConfig = {
        id: this.Id,
        type: "clear",
        rows: [
            {},
            {
                cols: [
                    {},
                    {
                        rows: [
                            {
                                view: "multiview",
                                id: this.Id+"Wizard",
                                cells:[
                                    {
                                        id: this.Id + "Wizard" + "LoginPanel",
                                        rows:[
                                            {
                                                height:160,
                                                css:"vc_login-form__header",
                                                template:"<div class='vc_logo'><img src='assets/imgs/" + (AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg") + "'/></div><div>"+LangHelper.GetString("VasCloud", "Welcome to VAS Cloud")+"</div>"
                                            },
                                            {
                                                view: "form",
                                                id: this.Id + "Wizard" + "LoginForm",
                                                width: 400,
                                                elements: [
                                                    {},
                                                    {
                                                        view: "text",
                                                        label: LangHelper.GetString("LoginView", "Login"),
                                                        name: "username",
                                                        tooltip: LangHelper.GetString("LoginView", "Login"),
                                                        "labelPosition": "top",
                                                        invalidMessage: LangHelper.GetString("LoginView", "Enter login"),
                                                        validate: webix.rules.isNotEmpty,
                                                        attributes:{maxlength:50},
                                                        on: {
                                                            "onChange": function ()
                                                            {
                                                                this.validate();
                                                            },
                                                            "onKeyPress": function(code, e)
                                                            {
                                                                if(code === 13)
                                                                {
                                                                    var form = this.getParentView();
                                                                    var passEl = form.elements.password.focus();
                                                                }
                                                            }
                                                        }

                                                    },
                                                    {
                                                        view: "text",
                                                        label: LangHelper.GetString("LoginView", "Password"),
                                                        name: "password",
                                                        type: "password",
                                                        tooltip: LangHelper.GetString("LoginView", "Password"),
                                                        "labelPosition": "top",
                                                        invalidMessage: LangHelper.GetString("LoginView", "Enter password"),
                                                        validate: webix.rules.isNotEmpty,
                                                        attributes:{maxlength:30},
                                                        on: {
                                                            "onChange": function ()
                                                            {
                                                                this.validate();
                                                            },
                                                            "onKeyPress": function(code, e)
                                                            {
                                                                if(code === 13)
                                                                {
                                                                    _this.LoginProcess();
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "checkbox",
                                                                name: "remember",
                                                                hidden:true,
                                                                labelRight: LangHelper.GetString("LoginView", "Remember me"),
                                                                value: 1,
                                                                labelWidth: 0
                                                            },
                                                            {
                                                                view: "button",
                                                                id: this.Id + "CloseBtn",
                                                                //type: "form",
                                                                value: LangHelper.GetString("LoginView", "Close"),
                                                                click: function ()
                                                                {
                                                                    _this.Hide();
                                                                    App.NavRouter.Navigate("index");
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id: this.Id + "LoginBtn",
                                                                type: "form",
                                                                value: LangHelper.GetString("LoginView", "Sign in"),
                                                                click: function ()
                                                                {
                                                                    setTimeout(function () {
                                                                        _this.LoginProcess();
                                                                    },1);
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        view: "button",
                                                        id: this.Id + "ForgotPassBtn",
                                                        value: LangHelper.GetString("VasCloud", "Forgot your password?"),
                                                        click: function ()
                                                        {
                                                            _this.ShowWizardForgotPwdForm();
                                                        }
                                                    },
                                                    {
                                                        view: "button",
                                                        id: this.Id + "CreateNewAccountBtn",
                                                        value: LangHelper.GetString("VasCloud", "I do not have an account"),
                                                        click: function ()
                                                        {
                                                            _this.ShowWizardRegForm();
                                                        }
                                                    },
                                                    {}
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        id: this.Id + "Wizard" + "RegPanel",
                                        rows:[
                                            {
                                                height:180,
                                                css:"vc_login-form__header",
                                                template:"<div class='vc_logo'><img src='assets/imgs/" + (AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg") + "'/><div>"+LangHelper.GetString("VasCloud", "Send us a request and we will process it as soon as possible")+"</div>"
                                            },
                                            {
                                                view:"form",
                                                id: this.Id + "Wizard" + "RegForm",
                                                width: 400,
                                                elements:
                                                    [
                                                        {},
                                                        {
                                                            view: "text",
                                                            label: LangHelper.GetString("VasCloud", "Company name"),
                                                            name: "company_name",
                                                            tooltip: LangHelper.GetString("VasCloud", "Name of your company"),
                                                            labelPosition: "top",
                                                            required: true,
                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter company name"),
                                                            validate: webix.rules.isNotEmpty,
                                                            attributes:{maxlength:50},
                                                            on: {
                                                                "onChange": function () {
                                                                    this.validate();
                                                                }
                                                            }
                                                        },
                                                        {
                                                            view: "text",
                                                            label: LangHelper.GetString("VasCloud", "Full name"),
                                                            name: "user_full_name",
                                                            tooltip: LangHelper.GetString("VasCloud", "Last name First name Middle name"),
                                                            labelPosition: "top",
                                                            required: true,
                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter your full name"),
                                                            validate: webix.rules.isNotEmpty,
                                                            attributes:{maxlength:50},
                                                            on: {
                                                                "onChange": function () {
                                                                    this.validate();
                                                                }
                                                            }
                                                        },
                                                        {
                                                            view: "text",
                                                            label: LangHelper.GetString("VasCloud", "Position"),
                                                            name: "position",
                                                            tooltip: LangHelper.GetString("VasCloud", "Position"),
                                                            labelPosition: "top",
                                                            required: true,
                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter your position"),
                                                            validate: webix.rules.isNotEmpty,
                                                            attributes:{maxlength:50},
                                                            on: {
                                                                "onChange": function () {
                                                                    this.validate();
                                                                }
                                                            }
                                                        },
                                                        {
                                                            view: "text",
                                                            label: "E-mail",
                                                            name: "email",
                                                            labelPosition: "top",
                                                            required: true,
                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter your e-mail"),
                                                            validate: webix.rules.isEmail,
                                                            attributes:{maxlength:50},
                                                            on: {
                                                                "onChange": function () {
                                                                    this.validate();
                                                                }
                                                            }
                                                        },
                                                        {
                                                            view: "text",
                                                            label: LangHelper.GetString("VasCloud", "Phone"),
                                                            name: "phone",
                                                            tooltip: LangHelper.GetString("VasCloud", "Contact number"),
                                                            labelPosition: "top",
                                                            required: true,
                                                            invalidMessage: LangHelper.GetString("VasCloud", "Enter phone number"),
                                                            validate: webix.rules.isNotEmpty,
                                                            attributes:{maxlength:50},
                                                            on: {
                                                                "onChange": function () {
                                                                    this.validate();
                                                                }
                                                            }
                                                        },
                                                        {
                                                            cols:[
                                                                {
                                                                    view: "button",
                                                                    id: this.Id + "CancelRegBtn",
                                                                    value: LangHelper.GetString("All", "Cancel"),
                                                                    click: function ()
                                                                    {
                                                                        _this.ShowWizardLoginForm();
                                                                    }
                                                                },
                                                                {
                                                                    view: "button",
                                                                    id: this.Id + "SendRegBtn",
                                                                    type: "form",
                                                                    value: LangHelper.GetString("VasCloud", "Submit request"),
                                                                    click: function ()
                                                                    {
                                                                        setTimeout(function () {
                                                                            _this.SendRegistrationRequest();
                                                                        },1);

                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {}
                                                    ]
                                            }
                                        ]
                                    },
                                    {
                                        id: this.Id + "Wizard" + "RegOkPanel",
                                        rows:[
                                            {
                                                height:160,
                                                css:"vc_login-form__header",
                                                template:"<div class='vc_logo'><img src='assets/imgs/" + (AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg") + "'/></div><div>"+LangHelper.GetString("VasCloud", "Your request is accepted")+"</div>"
                                            },
                                            {
                                                view:"form",
                                                id: this.Id + "Wizard" + "RegOkForm",
                                                width: 400,
                                                elements:
                                                    [
                                                        {},
                                                        {
                                                            view: "label",
                                                            label: LangHelper.GetString("VasCloud", "Your request is accepted")
                                                        },
                                                        {
                                                            view: "button",
                                                            id: this.Id + "CloseRegOkBtn",
                                                            value: LangHelper.GetString("LoginView", "Close"),
                                                            click: function ()
                                                            {
                                                                _this.Hide();
                                                                App.NavRouter.Navigate("index");
                                                            }
                                                        },
                                                        {}
                                                    ]
                                            }
                                        ]
                                    },
                                    {
                                        id: this.Id + "Wizard" + "ForgotPwdPanel",
                                        rows:[
                                            {
                                                height:160,
                                                css:"vc_login-form__header",
                                                template:"<div class='vc_logo'><img src='assets/imgs/" + (AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg") + "'/></div><div>"+LangHelper.GetString("VasCloud", "Password recovery")+"</div>"
                                            },
                                            {
                                                view: "form",
                                                id: this.Id + "Wizard" + "ForgotPwdForm",
                                                width: 400,
                                                elements: [
                                                    {},
                                                    {
                                                        view: "text",
                                                        label: "E-mail",
                                                        name: "email",
                                                        labelPosition: "top",
                                                        required: true,
                                                        invalidMessage: LangHelper.GetString("VasCloud", "Enter your e-mail"),
                                                        validate: webix.rules.isEmail,
                                                        attributes:{maxlength:50},
                                                        on: {
                                                            "onChange": function () {
                                                                this.validate();
                                                            }
                                                        }
                                                    },
                                                    {
                                                        cols:[
                                                            {
                                                                view: "button",
                                                                id: this.Id + "CancelForgotPwdBtn",
                                                                value: LangHelper.GetString("All", "Cancel"),
                                                                click: function ()
                                                                {
                                                                    _this.ShowWizardLoginForm();
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id: this.Id + "RestorePwdBtn",
                                                                type: "form",
                                                                value: LangHelper.GetString("VasCloud", "Restore"),
                                                                click: function ()
                                                                {
                                                                    _this.SendPasswordRestoreCode();
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {}
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        id: this.Id + "Wizard" + "ForgotPwdCodePanel",
                                        rows:[
                                            {
                                                height:160,
                                                css:"vc_login-form__header",
                                                template:"<div class='vc_logo'><img src='assets/imgs/" + (AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg") + "'/></div><div>"+LangHelper.GetString("VasCloud", "Password recovery")+"</div>"
                                            },
                                            {
                                                view: "form",
                                                id: this.Id + "Wizard" + "ForgotPwdCodeForm",
                                                width: 400,
                                                elements: [
                                                    {},
                                                    {
                                                        view: "label",
                                                        label: LangHelper.GetString("VasCloud", "Check your mail. We have sent you a code")
                                                    },
                                                    {
                                                        view: "text",
                                                        label: "E-mail",
                                                        name: "email",
                                                        labelPosition: "top",
                                                        required: true,
                                                        invalidMessage: LangHelper.GetString("VasCloud", "Enter your e-mail"),
                                                        validate: webix.rules.isEmail,
                                                        attributes:{maxlength:50},
                                                        on: {
                                                            "onChange": function () {
                                                                this.validate();
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view: "text",
                                                        label: LangHelper.GetString("VasCloud", "Code from e-mail"),
                                                        name: "passcode",
                                                        labelPosition: "top",
                                                        required: true,
                                                        invalidMessage: LangHelper.GetString("VasCloud", "Enter code from e-mail"),
                                                        tooltip: LangHelper.GetString("VasCloud", "Enter code from e-mail"),
                                                        validate: webix.rules.isNotEmpty,
                                                        attributes:{maxlength:50},
                                                        on: {
                                                            "onChange": function () {
                                                                this.validate();
                                                            }
                                                        }
                                                    },
                                                    {
                                                        cols:[
                                                            {
                                                                view: "button",
                                                                id: this.Id + "CancelForgotPwdCodeBtn",
                                                                value: LangHelper.GetString("All", "Cancel"),
                                                                click: function ()
                                                                {
                                                                    _this.ShowWizardLoginForm();
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id: this.Id + "RestorePwdCodeBtn",
                                                                type: "form",
                                                                value: LangHelper.GetString("VasCloud", "Restore"),
                                                                click: function ()
                                                                {
                                                                    _this.SendPasswordRestoreCode(true);
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {}
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        id: this.Id + "Wizard" + "SendPwdOkPanel",
                                        rows:[
                                            {
                                                height:160,
                                                css:"vc_login-form__header",
                                                template:"<div class='vc_logo'><img src='assets/imgs/" + (AppEnv.UrlFilterUiLogo ? AppEnv.UrlFilterUiLogo : "vas_experts_logo_b.svg") + "'/></div><div>"+LangHelper.GetString("VasCloud", "Password recovery")+"</div>"
                                            },
                                            {
                                                view:"form",
                                                id: this.Id + "Wizard" + "RegOkForm",
                                                width: 400,
                                                elements:
                                                    [
                                                        {},
                                                        {
                                                            view: "label",
                                                            label: LangHelper.GetString("VasCloud", "Check your mail. We have sent you a new password")
                                                        },
                                                        {
                                                            view: "button",
                                                            id: this.Id + "CloseSendPwdOkBtn",
                                                            value: LangHelper.GetString("LoginView", "Sign in"),
                                                            click: function ()
                                                            {
                                                                _this.ShowWizardLoginForm();
                                                            }
                                                        },
                                                        {}
                                                    ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {}
                ]
            },
            {}
        ]
    };

    this.Views = {
        LoginPanel:null,
        LoginForm:null,
        LoginBtn: null,

        RegPanel:null,
        RegForm:null,
        SendRegBtn:null,

        RegOkPanel:null,
        RegOkForm:null,

        ForgotPwdPanel:null,
        ForgotPwdForm:null,

        ForgotPwdCodePanel:null,
        ForgotPwdCodeForm:null,

        SendPwdOkPanel:null,
        SendPwdForm:null
    };

    this.LoginInProcess = new Rx.BehaviorSubject(0);

    this.RegInProcess = new Rx.BehaviorSubject(0);

    this.ContextConfig = {
        view: "popup",
        position:"center",
        modal:true,
        id:this.Id + "Context",
        padding:0,
        body: {
            borderless:true,
            rows:[]
        }
    };

    this.Context = null;

    this.Subscriptions = {};

    this.Init(Params);
}

VasCloudLoginViewController.prototype.Init = function (Params)
{
    if(this.modal)
    {
        this.ContextConfig.body.rows = this.ViewConfig.rows;
        this.Context = webix.ui(this.ContextConfig);
    }
    else
    {
        webix.ui(this.ViewConfig);
    }
};

VasCloudLoginViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    this.BindAll(Params);

    //this.ShowWizardRegOkForm();
};

VasCloudLoginViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.LoginPanel = $$(this.Id + "Wizard" + "LoginPanel");
    this.Views.LoginForm = $$(this.Id + "Wizard" + "LoginForm");
    webix.extend(this.Views.LoginForm, webix.ProgressBar);
    
    this.Views.LoginBtn = $$(this.Id + "LoginBtn");

    this.Views.RegPanel = $$(this.Id + "Wizard" + "RegPanel");
    this.Views.RegForm = $$(this.Id + "Wizard" + "RegForm");
    webix.extend(this.Views.RegForm, webix.ProgressBar);

    this.Views.SendRegBtn = $$(this.Id + "SendRegBtn");

    this.Views.RegOkPanel = $$(this.Id + "Wizard" + "RegOkPanel");
    this.Views.RegOkForm = $$(this.Id + "Wizard" + "RegOkForm");

    this.Views.ForgotPwdPanel = $$(this.Id + "Wizard" + "ForgotPwdPanel");
    this.Views.ForgotPwdForm = $$(this.Id + "Wizard" + "ForgotPwdForm");

    this.Views.ForgotPwdCodePanel = $$(this.Id + "Wizard" + "ForgotPwdCodePanel");
    this.Views.ForgotPwdCodeForm = $$(this.Id + "Wizard" + "ForgotPwdCodeForm");

    this.Views.SendPwdOkPanel = $$(this.Id + "Wizard" + "SendPwdOkPanel");
    this.Views.SendPwdOkForm = $$(this.Id + "Wizard" + "SendPwdOkForm");

    this.Subscriptions.LoginInProcess = this.LoginInProcess.subscribe(function (value) {
        var LoginInProcess = value;

        if (LoginInProcess) {
            _this.Views.LoginBtn.disable();
            _this.Views.LoginForm.showProgress({type: "icon"});
        }
        else {
            _this.Views.LoginBtn.enable();
            _this.Views.LoginForm.hideProgress();
        }
    });

    this.Subscriptions.RegInProcess = this.RegInProcess.subscribe(function (RegInProcess)
    {
        if (RegInProcess)
        {
            _this.Views.SendRegBtn.disable();
            _this.Views.RegForm.showProgress({type: "icon"});
        }
        else
        {
            _this.Views.SendRegBtn.enable();
            _this.Views.RegForm.hideProgress();
        }
    });

    if(this.Context)
    {
        this.Context.attachEvent("onHide", function()
        {
            _this.Destroy();
        });
    }
};

VasCloudLoginViewController.prototype.LoginProcess = function () {
    "use strict";
    var _this = this;

    var formData = this.Views.LoginForm.getValues();
    this.Views.LoginForm.setValues({
        username: Helper.RemoveAllWhiteSpaces(formData.username),
        password: Helper.RemoveAllWhiteSpaces(formData.password),
        remember: formData.remember
    });

    if (this.Views.LoginForm.validate()) 
    {
        this.LoginInProcess.next(1);

        formData = this.Views.LoginForm.getValues();

        App.VasCloudSessionManager.Login({
            username: formData.username,
            password: formData.password,
            remember: formData.remember,
            callback: function (R) {
                _this.LoginInProcess.next(0);

                if (!R.success && R.error.msg)
                {
                    webix.message({type: "error", text: R.error.msg});
                }

                if (R.success)
                {
                    _this.Hide();
                }
            }
        });
    }
};

VasCloudLoginViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

VasCloudLoginViewController.prototype.Show = function(Node, Pos, Message)
{
    this.Context.show(Node, {pos:Pos});
};

VasCloudLoginViewController.prototype.Hide = function()
{
    this.Context.hide();
};

VasCloudLoginViewController.prototype.ShowWizardLoginForm = function ()
{
    this.Views.LoginForm.clear();
    this.Views.LoginForm.clearValidation();
    this.Views.LoginPanel.show();
};

VasCloudLoginViewController.prototype.ShowWizardRegForm = function ()
{
    this.Views.RegForm.clear();
    this.Views.RegForm.clearValidation();
    this.Views.RegPanel.show();
};

VasCloudLoginViewController.prototype.ShowWizardRegOkForm = function ()
{
    this.Views.RegOkPanel.show();
};

VasCloudLoginViewController.prototype.ShowWizardForgotPwdForm = function ()
{
    this.Views.ForgotPwdForm.clear();
    this.Views.ForgotPwdForm.clearValidation();
    this.Views.ForgotPwdPanel.show();
};

VasCloudLoginViewController.prototype.ShowWizardForgotPwdCodeForm = function ($Email)
{
    this.Views.ForgotPwdCodeForm.clear();
    this.Views.ForgotPwdCodeForm.clearValidation();
    this.Views.ForgotPwdCodeForm.elements.email.setValue($Email);
    this.Views.ForgotPwdCodePanel.show();
};

VasCloudLoginViewController.prototype.ShowWizardSendPwdOkForm = function ()
{
    this.Views.SendPwdOkPanel.show();
};

VasCloudLoginViewController.prototype.SendRegistrationRequest = function ()
{
    var _this = this;
    function RegFormModel(Params)
    {
        this.company_name = Params&&Params.company_name ? Params.company_name : "";
        this.user_full_name = Params&&Params.user_full_name ? Params.user_full_name : "";
        this.position = Params&&Params.position ? Params.position : "";
        this.email = Params&&Params.email ? Params.email : "";
        this.phone = Params&&Params.phone ? Params.phone : "";
    }

    if (this.Views.RegForm.validate())
    {
        this.RegInProcess.next(1);

        var formModel = new RegFormModel(this.Views.RegForm.getValues());

        App.VasCloudSessionManager.SendCompanyRegistrationForm({
            data:formModel,
            callback: function (R)
            {
                _this.RegInProcess.next(0);

                if (!R.success && R.error.msg)
                {
                    webix.message({type: "error", text: R.error.msg});
                }

                if (R.success)
                {
                    _this.ShowWizardRegOkForm();
                    webix.message({type: "info", expire: 10000, text: LangHelper.GetString("VasCloud", "Your request is accepted")});
                }
            }
        });
    }
};

VasCloudLoginViewController.prototype.SendPasswordRestoreCode = function (SendCode)
{
    var _this = this;
    function FormModel(Params)
    {
        this.Email = Params&&Params.email ? Params.email : null;
        this.PassCode = Params&&Params.passcode ? Params.passcode : null;
    }

    if (!SendCode && this.Views.ForgotPwdForm.validate())
    {
        this.RegInProcess.next(1);

        var formModel = new FormModel(this.Views.ForgotPwdForm.getValues());

        App.VasCloudSessionManager.VasCloudSendPasswordRestoreCode({
            data:formModel,
            callback: function (R)
            {
                _this.RegInProcess.next(0);

                if (!R.success && R.error.msg)
                {
                    webix.message({type: "error", text: R.error.msg});
                }

                if (R.success)
                {
                    _this.ShowWizardForgotPwdCodeForm(formModel.Email);
                    webix.message({type: "info", expire: 10000, text: LangHelper.GetString("VasCloud", "Check your mail. We have sent you a code")});
                }
            }
        });
    }

    else if (SendCode && this.Views.ForgotPwdCodeForm.validate())
    {
        this.RegInProcess.next(1);

        var formModel = new FormModel(this.Views.ForgotPwdCodeForm.getValues());

        App.VasCloudSessionManager.VasCloudSendPasswordRestoreCode({
            data:formModel,
            callback: function (R)
            {
                _this.RegInProcess.next(0);

                if (!R.success && R.error.msg)
                {
                    webix.message({type: "error", text: R.error.msg});
                }

                if (R.success)
                {
                    _this.ShowWizardSendPwdOkForm();
                    webix.message({type: "info", expire: 10000, text: LangHelper.GetString("VasCloud", "Check your mail. We have sent you a new password")});
                }
            }
        });
    }
};



function VasCloudAdsViewController(Params)
{
    var _this = this;

    this.Id = "VasCloudAds";

    if(!App.VasCloudSessionManager)
    {
        App.VasCloudSessionManager = new VasCloudSessionManager();
        App.VasCloudSessionManager.CheckLoggedIn();
    }

    this.ViewModel = new VasCloudAdsManager();

    this.Views =
    {
        View:null,

        PageHeaderWidget: new VasCloudPageHeaderWidget({id:this.Id + "PageHeaderWidget"}),

        GroupVasCloudAds:null,
        GroupVasCloudAdsForm:null,
        GroupVasCloudAdsEnableSwitch:null,

        GroupDPIs:null,
        GroupDPIsList:null
    };

    this.HardwareRestartContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("AppView", "Are you sure you want to restart the fastdpi process?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("AppView", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("AppView", "Restart"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                                _this.RestartHardware();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            id:this.Id + "View",
            cols: [
                VasCloudPersonalAreaLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                {
                                    cols:[
                                        PageHeaderTemplate({root_title:LangHelper.GetString("VasCloud", "Vas Cloud"),title:LangHelper.GetString("VasCloud", "Ads")}),
                                        this.Views.PageHeaderWidget.ViewConfig
                                    ]
                                },
                                {
                                    height:16
                                },
                                {
                                    cols:[
                                        {
                                            width:1
                                        },
                                        {
                                            rows:[
                                                {
                                                    id: this.Id + "GroupVasCloudAds",
                                                    header:BlockHeaderTemplate().template({title: LangHelper.GetString("VasCloud", "Earn with Vas cloud Ads"), icon: "globe"}),
                                                    body:{
                                                        rows:[
                                                            {
                                                                view: "form",
                                                                id: this.Id + "GroupVasCloudAds" + "Form",
                                                                elements: [
                                                                    {
                                                                        borderless:true,
                                                                        minHeight:160,
                                                                        template:LangHelper.GetString("VasCloud", "Making money on affiliate programs is easy! <br/> <br/> <b> Vas cloud Ads </b> offers operators a wide selection of profitable affiliate program offers. Cooperating with us, you can earn big money on other people's sites.")
                                                                    },
                                                                    {
                                                                        align: "right",
                                                                        body: {
                                                                            id:this.Id + "GroupVasCloudAds" + "EnableSwitch",
                                                                            view: "switch",
                                                                            value: 0,
                                                                            label: LangHelper.GetString("VasCloud","Vas cloud Ads"),
                                                                            onLabel: LangHelper.GetString("VasCloud","Enabled"),
                                                                            offLabel: LangHelper.GetString("VasCloud","Disabled"),
                                                                            width: 280,
                                                                            labelWidth: 120
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                {}
                                            ]
                                        },
                                        {
                                            width:16
                                        },
                                        {
                                            gravity:3,
                                            rows:[
                                                {
                                                    id: this.Id + "GroupDPIs",
                                                    header:BlockHeaderTemplate().template({title: LangHelper.GetString("VasCloud", "Devices list"), icon: "server"}),
                                                    body:{
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                                padding: 0,
                                                                margin: 0,
                                                                borderless:false,
                                                                elements:
                                                                [
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id+"GroupDPIsListRefreshBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ViewModel.RefershHardwareSyncList();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                id:this.Id + "GroupDPIs" + "List",
                                                                disabled:true,
                                                                view: "datatable",
                                                                header:false,
                                                                select: "row",
                                                                type: "clear",
                                                                checkboxRefresh:true,
                                                                on:{
                                                                    onCheck:function (id, column, state)
                                                                    {
                                                                        if(column == "enabled")
                                                                        {
                                                                            var item = this.getItem(id);
                                                                            _this.EnableHardware(item, state);
                                                                        }
                                                                    },
                                                                    onItemClick: function (id,e,node)
                                                                    {
                                                                        this.select(id); //reset if multiple rows selected

                                                                        var item = this.getItem(id);

                                                                        var __this = this;

                                                                        if(id.column === 'restart_btn')
                                                                        {
                                                                            if(item.sync_status != VasCloudAdsHardwareSyncStatusEnum.completed_and_need_restart)
                                                                            {
                                                                                return;
                                                                            }

                                                                            setTimeout(function ()
                                                                            {
                                                                                var node = __this.getItemNode(id);
                                                                                _this.HardwareRestartContext.show(node, {pos:"bottom"});
                                                                            }, 10);
                                                                        }

                                                                        if(id.column === 'force_sync_btn')
                                                                        {
                                                                            if(!item.enabled)
                                                                                return;

                                                                            if(item.sync_status != VasCloudAdsHardwareSyncStatusEnum.completed_and_need_restart && item.sync_status != VasCloudAdsHardwareSyncStatusEnum.completed)
                                                                                return;

                                                                            setTimeout(function ()
                                                                            {
                                                                                var node = __this.getItemNode(id);
                                                                                _this.ForceListSyncOnHardware();
                                                                            }, 10);
                                                                        }
                                                                    }
                                                                },
                                                                columns:
                                                                    [
                                                                        {
                                                                            id: "name",
                                                                            fillspace: true
                                                                            // ,
                                                                            // template:"<strong>#name#</strong>"
                                                                        },
                                                                        {
                                                                            id: "force_sync_btn",
                                                                            width:32,
                                                                            template:function (Obj)
                                                                            {
                                                                                if(
                                                                                    Obj.enabled &&
                                                                                    (Obj.sync_status == VasCloudAdsHardwareSyncStatusEnum.completed_and_need_restart ||
                                                                                    Obj.sync_status == VasCloudAdsHardwareSyncStatusEnum.completed)
                                                                                )
                                                                                    return CellForceSyncBtnTemplate({title:LangHelper.GetString("VasCloud", "Force sync of lists")});

                                                                                return "";
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "restart_btn",
                                                                            width:32,
                                                                            template:function (Obj)
                                                                            {
                                                                                if(Obj.sync_status == VasCloudAdsHardwareSyncStatusEnum.completed_and_need_restart)
                                                                                    return CellDpiRestartBtnTemplate({title:LangHelper.GetString("VasCloud", "Restart fastdpi")});

                                                                                return "";
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "sync_error",
                                                                            fillspace: 3,
                                                                            template:function (obj)
                                                                            {
                                                                                var statusStr = "";

                                                                                if(VasCloudAdsHardwareSyncStatusesDic[obj.sync_status])
                                                                                {
                                                                                    if((obj.sync_need == 1 && obj.sync_status != VasCloudAdsHardwareSyncStatusEnum.error)  || obj.sync_status == VasCloudAdsHardwareSyncStatusEnum.in_progress)
                                                                                    {
                                                                                        return '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div> <div class="bounce3"></div> </div>';
                                                                                    }

                                                                                    statusStr += "<span class=\"status status_" + obj.sync_status + "\">";

                                                                                    if(obj.sync_status == VasCloudAdsHardwareSyncStatusEnum.error || obj.sync_status == VasCloudAdsHardwareSyncStatusEnum.error_max_attempts)
                                                                                    {
                                                                                        statusStr += '<span class="webix_icon fa-exclamation-triangle"></span>';
                                                                                    }

                                                                                    statusStr += VasCloudAdsHardwareSyncStatusesDic[obj.sync_status].value + "</span>";
                                                                                }

                                                                                return statusStr;
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "enabled",
                                                                            width:64,
                                                                            template:function(Obj, Common, Value)
                                                                            {
                                                                                return CellSwitchBoxTemplate(Obj, Common, Value);
                                                                            }
                                                                        }
                                                                    ],
                                                                data: []
                                                            }
                                                        ]
                                                    }
                                                },
                                                {}
                                            ]
                                        },
                                        {
                                            width:1
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Subscriptions = {};

    this.GroupDPIsListMonitorTimer = null;

    return this;
}

VasCloudAdsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

    //this.CheckAuthAndPresentView();
};

VasCloudAdsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.View = $$(this.Id + "View");

    this.Views.GroupVasCloudAds = $$(this.Id + "GroupVasCloudAds");
    this.Views.GroupVasCloudAdsForm = $$(this.Id + "GroupVasCloudAds" + "Form");
    this.Views.GroupVasCloudAdsEnableSwitch = $$(this.Id + "GroupVasCloudAds" + "EnableSwitch");

    this.Views.GroupDPIs = $$(this.Id + "GroupDPIs");
    this.Views.GroupDPIsList = $$(this.Id + "GroupDPIs" + "List");

    this.Views.GroupVasCloudAdsEnableSwitch.attachEvent("onChange", function(NewVal, OldVal)
    {
        _this.EnableAdsService(NewVal);
    });

    this.Subscriptions.AdsServiceEnabledSignalSubscription = this.ViewModel.AdsServiceEnabledSignal.subscribe(function (Enabled)
    {
        _this.Views.GroupVasCloudAdsEnableSwitch.blockEvent();
        _this.Views.GroupVasCloudAdsEnableSwitch.setValue(Enabled);
        _this.Views.GroupVasCloudAdsEnableSwitch.unblockEvent();

        if(Enabled)
            _this.Views.GroupDPIsList.enable();
        else
            _this.Views.GroupDPIsList.disable();


    });

    this.Subscriptions.HardwareSyncListUpdatedSignalSubscription = this.ViewModel.HardwareSyncListUpdatedSignal.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.DefineDPIs();
            _this.MonitorGroupDPIsList();
        }
    });

    this.Subscriptions.HardwareSyncUpdatedSignalSubscription = this.ViewModel.HardwareSyncUpdatedSignal.subscribe(function (Item)
    {
        if(Item)
        {
            var rows = _this.Views.GroupDPIsList.find(function(obj){
                return obj.hardware_id == Item.hardware_id;
            });

            if(rows && rows.length == 1)
            {
                _this.Views.GroupDPIsList.updateItem(rows[0].id,  Item);
            }

        }
    });

    this.Subscriptions.SignalIsLoggedIn = App.VasCloudSessionManager.SignalIsLoggedIn.subscribe(function (IsLoggedIn)
    {
        if(IsLoggedIn == null)
            return;

        if (IsLoggedIn)
        {
            _this.Views.View.enable();

            if(App.NavRouter.views.VasCloudLogin)
            {
                App.NavRouter.views.VasCloudLogin.Hide();
            }

            _this.ViewModel.IsAdsServiceEnabled();

            _this.ViewModel.RefershHardwareSyncList();
        }
        else
        {
            _this.Views.View.disable();
            App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
        }
    });

    App.VasCloudSessionManager.CheckLoggedIn();

    this.Views.PageHeaderWidget.BindAll(Params);
};

VasCloudAdsViewController.prototype.Destroy = function ()
{
    var _this = this;

    clearTimeout(this.GroupDPIsListMonitorTimer);

    this.Views.PageHeaderWidget.Destroy();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.ViewModel.Destroy();
    delete this.ViewModel;
};

VasCloudAdsViewController.prototype.DefineDPIs = function ()
{
    var hwArr = this.ViewModel.GetHardwareSyncList();

    this.Views.GroupDPIsList.clearAll();
    this.Views.GroupDPIsList.parse(hwArr);
};

VasCloudAdsViewController.prototype.EnableHardware = function (Item, Enabled)
{
    var _this = this;

    this.ViewModel.EnableHardware({hardware_id: Item.hardware_id, enabled:Enabled, callback:function (R)
    {
        if(R.success)
        {
            _this.Views.GroupDPIsList.updateItem(Item.id,  new VasCloudAdsHardwareSyncModel(R.data));
            webix.message(R.data.name + ": " + LangHelper.GetString("VasCloud",R.data.enabled?"Enabled":"Disabled"));

            _this.MonitorGroupDPIsList();
        }
        else
        {
            if(R.error)
                webix.message({text:R.error.msg,type:"error"});
        }
    }});
};

VasCloudAdsViewController.prototype.RestartHardware = function (Item)
{
    var _this = this;

    var item = Item ? Item : _this.Views.GroupDPIsList.getSelectedItem();

    if(!item)
        return;

    this.ViewModel.RestartHardware({hardware_id: item.hardware_id, callback:function (R)
        {
            if(R.success)
            {
                _this.Views.GroupDPIsList.updateItem(item.id,  new VasCloudAdsHardwareSyncModel(R.data));
                webix.message(LangHelper.GetString("All", "Restart was successful"));
            }
            else
            {
                if(R.error)
                {
                    if(R.error.msg.code == -1111)
                        webix.message({text:LangHelper.GetString("VasCloud", "Not need to restart"),type:"warning"});
                    else
                        webix.message({text:R.error.msg,type:"error"});
                }

            }
        }});
};

VasCloudAdsViewController.prototype.ForceListSyncOnHardware = function (Item)
{
    var _this = this;

    var item = Item ? Item : _this.Views.GroupDPIsList.getSelectedItem();

    if(!item)
        return;

    this.ViewModel.ForceListSyncOnHardware({hardware_id: item.hardware_id, callback:function (R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString("VasCloud", "Sync have been started in background"));
            }
            else
            {
                if(R.error)
                {
                    webix.message({text:R.error.msg,type:"error"});
                }

            }
        }});
};

VasCloudAdsViewController.prototype.MonitorGroupDPIsList = function()
{
    var _this = this;

    if(!this.ViewModel)
        return;

    clearTimeout(this.GroupDPIsListMonitorTimer);

    var list = this.Views.GroupDPIsList.serialize();

    var idsToMonitor = [];

    var addToMonitor = function (List)
    {
        List.forEach(function (Item)
        {
            if(
                Item.hardware_id &&
                (
                    Item.sync_status == VasCloudAdsHardwareSyncStatusEnum.in_progress ||
                    Item.sync_status == VasCloudAdsHardwareSyncStatusEnum.error ||
                    Item.sync_need == 1
                )
            )
            {
                idsToMonitor.push(Item.hardware_id )
            }
        });
    };

    addToMonitor(list);

    if(idsToMonitor.length)
    {
        this.ViewModel.RefershHardwareSyncList({hardware_ids:idsToMonitor, callback:function ()
        {
            _this.GroupDPIsListMonitorTimer = setTimeout(function ()
            {
                _this.MonitorGroupDPIsList();
            }, 10000);
        }});
    }
};

VasCloudAdsViewController.prototype.EnableAdsService = function (Enabled)
{
    var _this = this;

    this.ViewModel.EnableAdsService({enabled:Enabled, callback:function (R)
        {
            if(R.success)
            {
                webix.message("Vas cloud Ads: " + LangHelper.GetString("VasCloud",R.data?"Enabled":"Disabled"));

                var list = _this.Views.GroupDPIsList.serialize();

                list.forEach(function (Item)
                {
                    if(Item.hardware_id)
                        _this.EnableHardware(Item, R.data ? 1 : 0);
                });
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.ViewModel.IsAdsServiceEnabled();
        }});
};

VasCloudAdsViewController.prototype.CheckAuthAndPresentView = function(Params)
{
    var _this = this;
    App.VasCloudSessionManager.CheckLoggedIn({
        callback:function (IsLoggedIn)
        {
            if(IsLoggedIn)
            {
                _this.Views.View.enable();
                if(App.NavRouter.views.VasCloudLogin)
                {
                    App.NavRouter.views.VasCloudLogin.Hide();
                }
            }
            else
            {
                App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
            }

        }
    });
};


var ProtocolsLogsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"ProtocolsLogsTableWidget",
        sortDisabledColumns:["checked", "trash"],
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "VasCloudGetCustomProtocolsSyncLogs";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [
                {
                    id:"checked",
                    header:["",{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}],
                    template: CellCheckBoxTemplate,
                    width:SkinHelper.GetSkin() === SkinHelper.GetDefaultFilterUiSkin() ? 40 :32,
                    sort: false },
                { id:"item_action", fillspace:true, header:[LangHelper.GetString("Protocols","Event"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"attempts", fillspace:false, header:[LangHelper.GetString("Protocols","Attempts"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"status", width:134, template: function (Obj, Common, Value){
                        let item = LogStatusTypesDic[Value];
                        return item?item.value:Value;
                    }, fillspace:false, header:[LangHelper.GetString("Protocols","Status"), {content: "richSelectFilter", options: Helper.DictToArr(LogStatusTypesDic), inputConfig: {suggest: {fitMaster: false}}}] },
                { id:"status_description", fillspace:true, header:[LangHelper.GetString("Protocols","Status Description"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                {
                    id: "data",
                    header: [
                        LangHelper.GetString("Protocols","Data"),
                        {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                    ],
                    sort: "string",
                    width:64,
                    template: function(Obj){
                        return Obj && Obj.data ? CellEyeBtnTemplate() : "";
                    }
                },
                { id:"create_time", template: LocalTimeZone, sort: "date", fillspace:true, header:[LangHelper.GetString("Protocols","Create Time"), {content: "dateRangeFilter", contentId:"create_time", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"update_time", template: LocalTimeZone, sort: "date", fillspace:true, header:[LangHelper.GetString("Protocols","Update Time"), {content: "dateRangeFilter", contentId:"update_time", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"create_user", fillspace:true, header:[LangHelper.GetString("Protocols","Create User"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"update_user", fillspace:true, header:[LangHelper.GetString("Protocols","Update User"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate, sort:false }
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterFilterCustomHandler)
    {
        params.on.onAfterFilterCustomHandler = function ()
        {
            Params.onAfterFilterCustomHandler();
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

function VasCloudProtocolsLogsViewController(Params)
{
    var _this = this;

    this.IdsEnum = {
        VasCloudProtocolsLogs: "VasCloudProtocolsLogs",
        UlrAppPrtclsCustomLogs: "UlrAppPrtclsCustomLogs"
    };

    this.Id = Params && Params.Id ? Params.Id : this.IdsEnum.VasCloudProtocolsLogs;

    this.PageTitle = Params&&Params.PageTitle?Params.PageTitle:{
        RootTitle: App.SessionManager.IsModeDpiui2?LangHelper.GetString("AppView", "VAS CLOUD"):LangHelper.GetString("Protocols", "Protocols"),
        Title: LangHelper.GetString("VasCloud", "Logs")
    };

    if(!App.VasCloudSessionManager)
    {
        App.VasCloudSessionManager = new VasCloudSessionManager();
        App.VasCloudSessionManager.CheckLoggedIn();
    }

    this.Editable = new Rx.BehaviorSubject(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.vascloud, true));

    this.ViewModel = new VasCloudProtocolsLogsManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ToolbarTrashBtn:null,
        Widgets:{},
        ReportsWidgets:{
            LogsReport: ProtocolsLogsTableWidget({
                id: this.Id + "LogsReport",
                editable: this.Editable.getValue(),
                onAfterFilterCustomHandler: function ()
                {
                    _this.Refresh();
                },
                onItemClick: function (Obj)
                {
                    if(Obj && (Obj.column == "data" || Obj.column == "trash"))
                    {
                        var table = _this.Views.ReportsWidgets.LogsReport.Views.Table;


                        if(Obj.column == "trash")
                            Helper.Table.OnItemClickTrash(_this.Id, Obj, _this.ViewModel.DeleteRow, table);

                        if(Obj.column == "data")
                        {
                            let item = table.getSelectedItem();
                            let node = table.getItemNode(Obj);

                            _this.ShowDataInfoForm(node, item.data);
                        }
                    }
                }
            })
        }
    };

    this.ViewConfig = [
        {
            cols:function ()
            {

                const cols = [];

                if(_this.Id === _this.IdsEnum.VasCloudProtocolsLogs)
                    cols.push(VasCloudProtocolsLeftSideBarView({id:_this.Id}));

                cols.push({
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:function (){

                                const rows = [];

                                if(_this.Id === _this.IdsEnum.UlrAppPrtclsCustomLogs)
                                    rows.push({height:6});

                                rows.push(PageHeaderTemplate({id:_this.Id + "PageTitle", root_title: _this.Id === _this.IdsEnum.UlrAppPrtclsCustomLogs ? _this.PageTitle.Title : _this.PageTitle.RootTitle, title: _this.Id === _this.IdsEnum.UlrAppPrtclsCustomLogs ? "" : _this.PageTitle.Title}),);

                                if(_this.Id === _this.IdsEnum.UlrAppPrtclsCustomLogs)
                                    rows.push({height:32});

                                rows.push({
                                    cols:[
                                        {
                                            rows:[
                                                {
                                                    view: "toolbar",
                                                    height:webix.skin.$active.rowHeight,
                                                    padding: 0,
                                                    margin: 0,
                                                    elements: [
                                                        {
                                                            view: "button",
                                                            id:_this.Id+"LogsDeleteBtn",
                                                            type: "icon",
                                                            icon: "trash",
                                                            css: "toolbar_round_btn",
                                                            width: 32,
                                                            tooltip: LangHelper.GetString("All","Refresh"),
                                                            click:function (id,e,node)
                                                            {
                                                                var __this = this;
                                                                var node = __this.getNode(id);

                                                                Helper.Table.ShowTrashForm(_this.Id, _this.ViewModel.DeleteRows, _this.Views.ReportsWidgets.LogsReport.Views.Table, node);
                                                            }
                                                        },
                                                        {
                                                            view: "button",
                                                            id:_this.Id + "LogsEraseBtn",
                                                            type: "icon",
                                                            icon: "eraser",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            tooltip:LangHelper.GetString("All", "Remove all"),
                                                            click:function (id,e,node)
                                                            {
                                                                var __this = this;
                                                                var node = __this.getNode(id);

                                                                Helper.Table.ShowEraseForm(_this.Id, _this.ViewModel.DeleteRows, _this.Views.ReportsWidgets.LogsReport.Views.Table, node);
                                                            }
                                                        },
                                                        {},
                                                        {
                                                            view: "button",
                                                            id:_this.Id+"LogsRefreshBtn",
                                                            type: "icon",
                                                            icon: "refresh",
                                                            css: "toolbar_round_btn",
                                                            width: 32,
                                                            tooltip: LangHelper.GetString("All","Refresh"),
                                                            click: function (id, e, node)
                                                            {
                                                                _this.Refresh();
                                                            }
                                                        }
                                                    ]
                                                },
                                                BlockHeaderTemplate({
                                                    title:LangHelper.GetString("Protocols","Logs"), icon:"files-o"
                                                }),
                                                _this.Views.ReportsWidgets.LogsReport.ViewConfig
                                            ]
                                        }
                                    ]
                                });

                                return rows;
                            }()
                        }
                    ]
                });

                return cols;
            }()
        }
    ];

    this.Subscriptions = {};
};

VasCloudProtocolsLogsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.ToolbarTrashBtn = $$(this.Id+"LogsDeleteBtn");

    this.Subscriptions.LogsTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.LogsReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        if (Value>0){
            _this.Views.ToolbarTrashBtn.enable();
        }else {
            _this.Views.ToolbarTrashBtn.disable();
        }
    });

    this.Subscriptions.SignalIsLoggedIn = App.VasCloudSessionManager.SignalIsLoggedIn.subscribe(function (IsLoggedIn)
    {
        if(IsLoggedIn == null)
            return;

        if (!IsLoggedIn)
        {
            App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
        }
        else
        {
            if(App.NavRouter.views.VasCloudLogin)
            {
                App.NavRouter.views.VasCloudLogin.Hide();
            }
        }
    });

    App.VasCloudSessionManager.CheckLoggedIn();

    Helper.Table.ActivateCheckBox(this.Views.ReportsWidgets.LogsReport.Views.Table);
};

VasCloudProtocolsLogsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    if(_this.Id === _this.IdsEnum.VasCloudProtocolsLogs)
    {
        webix.ready(function () {
            $$(_this.Id+"LeftSideBar").select(_this.Id);
        });
    }

    this.BindAll(Params);

    this.Refresh();
};

VasCloudProtocolsLogsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

VasCloudProtocolsLogsViewController.prototype.Refresh = function ()
{
    Helper.Table.GetDateFiltersWithRefresh(this.Views.ReportsWidgets.LogsReport, ['create_time', 'update_time']);
};

VasCloudProtocolsLogsViewController.prototype.ShowServerError = function (ErrorModel)
{
    webix.message({text:ErrorModel.msg, type:"error", expire: 30000});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrorModel.msg,
        type:"alert-error",
        width:400
    });
};

VasCloudProtocolsLogsViewController.prototype.ShowDataInfoForm = function (Node, Data)
{
    if(!Data)
    {
        return;
    }

    let formData = null;
    if(typeof Data === 'object' || Array.isArray(Data))
    {
        formData = JSON.stringify( Data, null, 2);
    }
    else if(typeof Data === 'string')
    {
        try{
            let data = JSON.stringify( JSON.parse(Data), null, 2);
            formData = data;
        }
        catch(e)
        {
            formData = Data;
        }
    }

    if(!formData)
    {
        return;
    }

    let context = webix.ui({
        view:"popup",
        id: this.Id + "DataInfoContext",
        width:600,
        height:400,
        body:{
            id: this.Id + "DataInfoContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    view:"codemirror-editor",
                    id:this.Id + "DataInfoContextFormEditor",
                    height:undefined,
                    value:formData
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("All","Close"),
                            click:function ()
                            {
                                context.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    let pos = "bottom";
    context.show(Node, {pos});
};

VasCloudProtocolsLogsViewController.prototype.GetPageTitle = function () {
    if (this.PageTitle)
        return this.PageTitle;
};
var AsResourcesPopup = function (Params, table, uri)
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal form_modal_as_resources",
        id:id,
        maxWidth:800,
        maxHeight:830,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: Params && Params.modal_title ? Params.modal_title : "Application list", height:68},
                { view:"button", css:"toolbar_round_btn", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        autofit:true,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    view: "tabbar",
                    options: [
                        {
                            value: BlockHeaderTemplate().template({
                                title: LangHelper.GetString("Protocols", "IPv4"),
                            }),
                            id: "ipv4"
                        },
                        {
                            value: BlockHeaderTemplate().template({
                                title: LangHelper.GetString("Protocols", "IPv6"),
                            }),
                            id: "ipv6"
                        }
                    ],
                    on: {
                        onChange:function (newId, oldId) {
                            table.Filter = {
                                type: {
                                    id: "type",
                                    operator: "=",
                                    value: newId
                                },
                                as_number: {
                                    id:"as_number",
                                    operator: "=",
                                    value: uri
                                }
                            }
                            table.RefreshData()
                        }
                    }
                },
                table.ViewConfig
            ]
        }
    };
    return webix.ui(view).show();
};

var ProtocolsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"ProtocolsTableWidget",
        sortDisabledColumns:["checkbox", "edit", "run", "trash"],
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return (!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())?"AdminGetCustomProtocols":"GetMyCustomProtocols";
            },
            sort:{id:"_id",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [
                {
                    id:"checked",
                    header:["",{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}],
                    template: CellColoredCheckBoxTemplate,
                    width:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? 40 :32
                },
                {
                    id: "run",
                    header: "",
                    width: 32,
                    template: function (obj, common)
                    {
                        return CellSwitchOnOffTemplate(null, null, obj.protocol_enabled);
                    },
                    headermenu: false
                },
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate },
                { id:"public_alias", fillspace:true, template: function(obj, common, value) {return CellFormatTemplate(value, true, true, "-_", true);}, header:[TooltipTemplate(LangHelper.GetString("Protocols","Name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"custom_number", width: 174, fillspace:true, header:[TooltipTemplate(LangHelper.GetString("Protocols","Custom number")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"protocol_port", fillspace:true, header:[TooltipTemplate(LangHelper.GetString("Protocols","Port")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"prod_enabled", template:function (obj, common, val, config) {
                        return TextTemplate(
                            val, LangHelper.GetString("Protocols", "Main"),
                            LangHelper.GetString("Protocols", "Test"),
                            typeof vendor === 'string' && vendor == 'cubro' ? "var(--color-red)" : "#1A84D8"
                        );
                    }, fillspace:true, header:[TooltipTemplate(LangHelper.GetString("Protocols","List type")), {
                        content: "richSelectFilter",
                        options: Helper.DictToArr(TypeListDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }] },
                { id:"description", fillspace:true, header:[TooltipTemplate(LangHelper.GetString("Protocols","Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"last_resource_update_time", template: LocalTimeZone, fillspace:true, header:[LangHelper.GetString("Protocols","Updated"), {content: "dateRangeFilter", contentId:"created_date", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate, sort:false }
            ];

            (!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())?cols.splice(3,0,{ id:"company_name", fillspace:true, header:[TooltipTemplate(LangHelper.GetString("VasCloud","Company name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] }):null;

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var ProtocolsItemsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"ProtocolsItemsTableWidget",
        sortDisabledColumns:["checkbox", "item_enabled", "edit", "trash"],
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "GetMyCustomProtocolItems";
            },
            sort:{id:"_id",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [
                {
                    id:"checked",
                    header:["",{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}],
                    template: CellColoredCheckBoxTemplate,
                    width:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? 40 :32
                },
                {
                    id: "item_enabled",
                    header: "",
                    template: CellSwitchOnOffTemplate,
                    width: 32,
                    headermenu: false
                },
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate },
                { id:"public_alias", template: function(obj, common, value) {return CellFormatTemplate(value, true, true, "-_", true);}, fillspace:true, header:[TooltipTemplate(LangHelper.GetString("Protocols","Name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"type", fillspace:true, header:[TooltipTemplate(LangHelper.GetString("Protocols","Type")), {
                        content: "richSelectFilter",
                        options: Helper.DictToArr(CustomProtocolsItemTypeDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }] },
                { id:"uri", template: function (obj, common, value) {
                        if (obj.type == "template")
                        {
                            var dic = App.DicsManager.GetDic(DicsEnum.CustomProtocolsTemplatesDic)[value];
                            return dic?dic.value:"<span style=\"color:#1A84D8\">" + LangHelper.GetString("Protocols","Unknown") + "</span>";
                        }
                        if (obj.type == "asn")
                        {
                            value = CellListBtnTemplate() + value + (obj.as_name ? ` (${obj.as_name}) ` : '');
                        }
                        return value;
                    }, fillspace:true, header:[TooltipTemplate(LangHelper.GetString("Protocols","Uri")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                {
                    id:"item_imported",
                    width: 32,
                    header: TooltipTemplate("I", LangHelper.GetString("All", "Imported")),
                    template: function(obj, common, value)
                    {
                        if(obj && obj.item_imported > 0)
                            return CellYesNoDisabledTemplate(obj, common, obj.item_imported);
                        else
                            return '';
                    }

                },
                {
                    id: "intersection_warning",
                    width: 32,
                    header: TooltipTemplate("W", LangHelper.GetString("All", "Warning")),
                    template: function(obj, common, value)
                    {
                        if(obj && obj.intersection_warning)
                        {
                            var str = LangHelper.GetString("Protocols", "There is a '{resource}' intersection in the cloud protocol '{protocol}'") + " ({conflict})"

                            var splt = obj.intersection_warning.split(",");

                            if(splt.length > 3)
                            {
                                var resource = splt[1];
                                var proto = "";
                                var conflict = "";
                                if(splt.length == 5)
                                {
                                    proto = splt[3] + " " + splt[2];
                                    conflict = splt[4];
                                }
                                else if(splt.length == 4)
                                {
                                    proto = splt[2];
                                    conflict = splt[3];
                                }

                                str = str.replace("{resource}", resource);
                                str = str.replace("{protocol}", proto);
                                str = str.replace("{conflict}", conflict);
                            }
                            else
                            {
                                str = obj.intersection_warning;
                            }


                            return AlertWarningTemplate(obj, common, str);
                        }
                        else
                            return '';

                    }
                },
                {
                    id:"validation_error",
                    width: 32,
                    header: TooltipTemplate("E", LangHelper.GetString("All", "Error")),
                    template: function(obj, common, value)
                    {
                        if(obj && obj.validation_error)
                            return AlertErrorTemplate(obj, common, obj.validation_error);
                        else
                            return '';

                    }

                },
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate, sort:false }
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on: {}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var ProtocolsHardwaresTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"ProtocolsHardwaresTableWidget",
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "VasCloudGetCustomProtocolsHardwareList";
            },
            sort:{id:"hardware_id",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [
                { id:"enabled", template:CellSwitchOnOffTemplate, width: 32, fillspace:false, header: "" },
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate },
                {
                    id:"name",
                    fillspace:true,
                    header:[
                        TooltipTemplate(LangHelper.GetString("Protocols","Name")),
                        {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                    ],
                    template:function (obj)
                    {
                        return obj.name + (obj.tool_version ? (", v." + obj.tool_version) : "");
                    }
                },
                { id:"sync_mode", template:function(Obj, Common, Value) {
                        let mode = CustomProtocolsSyncModeTypeDic[Value];
                        return mode?mode.value:undefined;
                    }, fillspace:false, header:[TooltipTemplate(LangHelper.GetString("Protocols","Synchronization mode")), {
                        content: "richSelectFilter",
                        options: Helper.DictToArr(CustomProtocolsSyncModeTypeDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }] },
                { id:"mode", width:120, template:function(Obj, Common, Value) {
                        return Value=="prod"?LangHelper.GetString("Protocols", "Main"):LangHelper.GetString("Protocols", "Test");
                    }, checkValue:"prod", uncheckValue:"test", fillspace:false, header:[TooltipTemplate(LangHelper.GetString("Protocols","List type")), {
                        content: "richSelectFilter",
                        options: Helper.DictToArr(TypeListTextIdDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }] },
                { id:"status", template:function (obj) {
                        var statusStr = "";

                        statusStr += "<span class=\"status status_" + obj.status + "\">";

                        if(obj.status == "error" || obj.status == "error_max_attempts")
                        {
                            statusStr += '<span class="webix_icon fa-exclamation-triangle"></span>';
                        }else if (obj.status != "ok") {
                            statusStr += '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div> <div class="bounce3"></div> </div>';
                        }

                        statusStr += LangHelper.GetString("Protocols", obj.status) + "</span>";

                        return statusStr;
                    }, fillspace:false, header:[TooltipTemplate(LangHelper.GetString("Protocols","Status")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"status_description", template:function (obj, common, value) {
                        return LangHelper.GetString("SocketNotifications", value);
                    }, fillspace:true, header:[TooltipTemplate(LangHelper.GetString("Protocols","Status Description")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var ImportedFilesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"ImportedFilesTableWidget",
        hideExport:true,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        rowsPerPageHide:Params.rowsPerPageHide ? true : false,
        enableLocalDataSource: Params.enableLocalDataSource ? true : false,
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "name",
                    header: [LangHelper.GetString("Protocols","File")],
                    sort: "text",
                    fillspace: 1
                },
                {
                    id: "size",
                    header: [LangHelper.GetString("Protocols","File size")],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj)
                    {
                        return Obj.sizetext ? Obj.sizetext : (Obj.size + " b");
                    }
                },
                {
                    id: "state",
                    header: [LangHelper.GetString("Protocols","State")],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj)
                    {
                        var color = "orange";

                        var stateStr = "";

                        if(Obj.state != FilesStatusDic.uploaded.id && Obj.state != FilesStatusDic.failed.id)
                        {
                            stateStr += '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div> <div class="bounce3"></div> </div>';
                        }

                        switch(Obj.state)
                        {
                            case FilesStatusDic.uploaded.id:
                                color = "green";
                                break;
                            case FilesStatusDic.failed.id:
                                color = "red";
                                break;
                            default:
                                color = "orange";
                        }

                        stateStr += "<span class=\"status status_" + color + "\" style='curesor: pointer'>";

                        stateStr += (FilesStatusDic[Obj.state] && FilesStatusDic[Obj.state].value ? FilesStatusDic[Obj.state].value : Obj.state) + "</span>"

                        return stateStr;
                    }
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"=",
            //     value:LangHelper.GetLocale()
            // }
        },
        sort_map:{},
        defaultPageSize:Params && Params.defaultPageSize ? Params.defaultPageSize : -10,
        on:{},
        minHeight:40
    };

    if(Params && Params.dataSource)
    {
        params.config.dataSource = function(FilterParams)
        {
            return Params.dataSource(FilterParams);
        };
    }

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);

        };

        params.on.onCheck = function(row, column, state)
        {
            Params.onItemClick({
                row: row,
                column: column
            });
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var AsResourceListTableWidget = function (Params)
{
    var params = {
        id:(Params&&Params.id?Params.id:webix.uid()) + "NotQoE",
        name:"AsResourceListTableWidget",
        hidePaginatorToolbar:false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        config:{
            model:function (Params)
            {
                this.as_number = Params&&Params.as_number?Params.as_number:"";
                this.resource = Params&&Params.resource?Params.resource:"";
            },
            method:function ()
            {
                return "GetAsResources";
            },
            // sort:{id:"_id",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "as_number",
                    header: [LangHelper.GetString("Protocols","AS number")],
                    sort: "string",
                    fillspace: 1,
                },
                {
                    id: "resource",
                    header: [LangHelper.GetString("Protocols","CIDR")],
                    sort: "string",
                    fillspace: 1
                },
            ]);
            return cols;
        }(),

        defaultPageSize:10,
        minHeight:40,
    };

    if(Params && Params.filter){
        params.filter = Params.filter;
    }
    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

function VasCloudProtocolsCustomViewController(Params)
{
    var _this = this;

    this.IdsEnum = {
        VasCloudProtocolsCustom: "VasCloudProtocolsCustom",
        UlrAppCustomProtocols: "UlrAppCustomProtocols"
    };

    this.Id = Params && Params.Id ? Params.Id : this.IdsEnum.VasCloudProtocolsCustom;

    this.PageTitle = Params&&Params.PageTitle?Params.PageTitle:{
        RootTitle: App.SessionManager.IsModeDpiui2?LangHelper.GetString("AppView", "VAS CLOUD"):LangHelper.GetString("Protocols", "Protocols"),
        Title: LangHelper.GetString("Protocols", "Custom Protocols")
    };

    this.Prefix = "cp_";

    this.SocketRoom = "VasCloudCustomProtocolsHardwares";
    this.EventUpdateHardwareStatus = "update_row";

    this.HelperLines =
        {
            auto:[
                LangHelper.GetString("Protocols", "Automatic resource type detection"),
                "",
            ],
            sni:[
                LangHelper.GetString("Protocols", "For some domain"),
                "google.com",
                "facebook.com",
                "",

                LangHelper.GetString("Protocols", "For some subdomain"),
                "subdomain.google.com",
                "subdomain.facebook.com",
                "",

                LangHelper.GetString("Protocols", "For domain with all subdomains"),
                "*.google.com",
                "*.facebook.com",
                "",


            ],
            ip:[
                LangHelper.GetString("Protocols", "For single IP"),
                "201.1.1.1",
                "2001:db9::1",
                "",
                LangHelper.GetString("Protocols","For IP with Port"),
                "201.1.2.3 8081",
                "2001:db9::1 9090",
                "",
                LangHelper.GetString("Protocols", "For CIDR"),
                "201.198.4.0/24",
                "2001:db8::0/64",
                "",
                LangHelper.GetString("Protocols","For CIDR with Port"),
                "201.198.4.0/24 8081",
                "2001:db8::0/64 9090",
            ],
            asn:[
                LangHelper.GetString("Protocols", "Any AS number"),
                "14593",
                "16509",
                "206567"
            ]
        };

    this.CustomBusy = [];
    this.SelectCustom = null;
    this.SelectCompany = null;

    this.CustomStart = 1;
    this.CustomEnd = 4096;

    // this.Port = 53247;
    // this.PortStart = this.Port + this.CustomStart;
    // this.PortEnd = this.Port + this.CustomEnd;

    this.Editable = new Rx.BehaviorSubject(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.vascloud, true));
    this.EditableCustomPrtcls = new Rx.BehaviorSubject(App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.custom_protocols, true));

    this.ViewModel = new VasCloudProtocolsCustomManager();
    this.ReportsModel = new UniReportsManager();

    if(!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())
    {
        this.CompaniesViewModel = new CompaniesManager();
    }

    this.HelpPopup = webix.ui({
        view:"popup",
        // css:"form_modal",
        maxWidth:800,
        maxHeight:800,
        id:"HelpPopup",
        close:true,
        // modal:true,
        position:"center",
        headHeight:68,
        body: {
            // type:"space",
            borderless: true,
            rows: [
                {
                    // type:"clean",
                    view:"scrollview",
                    id:this.Id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            // {
                            //     view:"toolbar", cols:[
                            //         { view:"label", css: "help_popup_label", label: LangHelper.GetString("Protocols","Custom protocols: Resource List"), height:68},
                            //         { view:"button", type:"icon", css:"help_popup_button", icon: 'times', align:"right", width:68, height:68, click:function(){ $$("HelpPopup").hide(); }}
                            //     ]
                            // },
                            {
                                template:LangHelper.GetLocale() === LocalesEnum.ru.code ? "http->assets/html/vas_codebase/CustomProtocolsImportHelpRu.html" : "http->assets/html/vas_codebase/CustomProtocolsImportHelpEn.html",
                                autoheight:true
                            }
                        ]
                    }

                }

            ]
        }
    });

    this.HardwareEditContext = {
        view: "popup",
        modal: true,
        id: this.Id + "HardwareEditContext",
        width: 460,
        height: 680,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    id:this.Id + "HardwareEditContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            cols: [
                                {
                                    view: "richselect",
                                    id: this.Id + "HardwareEditContextFormMode",
                                    name: "mode",
                                    options: Helper.DictToArr(TypeListTextIdDic),
                                    labelWidth: 174,
                                    width: 380,
                                    label: LangHelper.GetString("Protocols","List type"),
                                    tooltip: LangHelper.GetString("Protocols","List type"),
                                    required:true,
                                    validate: webix.rules.isNotEmpty,
                                    invalidMessage: LangHelper.GetString("Protocols", "Required field")
                                },
                                {
                                    view: "button",
                                    id: this.Id + "HardwareEditContextFormModeHelper",
                                    type: "icon",
                                    icon: "question-circle",
                                    css:"toolbar_round_btn",
                                    align: "right",
                                    width:32,
                                    popup: this.Id + "TypeListHelper"
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    view: "richselect",
                                    id: this.Id + "HardwareEditContextFormSync",
                                    name: "sync_mode",
                                    options: Helper.DictToArr(CustomProtocolsSyncModeTypeDic),
                                    labelWidth: 174,
                                    width: 380,
                                    label: LangHelper.GetString("Protocols","Synchronization mode"),
                                    tooltip: LangHelper.GetString("Protocols","Synchronization mode"),
                                    required:true,
                                    validate: webix.rules.isNotEmpty,
                                    invalidMessage: LangHelper.GetString("Protocols", "Required field")
                                },
                                {
                                    view: "button",
                                    id: this.Id + "HardwareEditContextFormSyncModeHelper",
                                    type: "icon",
                                    icon: "question-circle",
                                    css:"toolbar_round_btn",
                                    align: "right",
                                    width:32,
                                    popup: this.Id + "SyncModeHelper"
                                }
                            ]
                        },
                        {
                            view: "checkbox",
                            id: this.Id + "HardwareEditContextFormEnabled",
                            name: "enabled",
                            labelWidth: 174,
                            width: 380,
                            label: LangHelper.GetString("Protocols","Enabled"),
                            tooltip: LangHelper.GetString("Protocols","Enabled"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Protocols", "Required field")
                        },
                        {
                            rows: [
                                {
                                    height: 16
                                },
                                {
                                    cols:[
                                        {},
                                        {
                                            view:"button",
                                            label:LangHelper.GetString("Protocols","Cancel"),
                                            click:function ()
                                            {
                                                _this.Views.HardwareEditContext.hide();
                                            }
                                        },
                                        {
                                            view:"button",
                                            id:this.Id + "HardwareEditContextFormSaveBtn",
                                            type:"form",
                                            label:LangHelper.GetString("Protocols","Save"),
                                            hotkey: "enter",
                                            click:function ()
                                            {
                                                _this.Views.HardwareEditContext.hide();
                                                _this.SaveHardwareEditForm();
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    webix.ui({
        view:"popup",
        id:this.Id + "CustomNumberHelper",
        body:{
            view:"form",
            borderless:true,
            elements:[
                { template:LangHelper.GetString("Protocols","Custom number is a protocol identifier, a range limited to values from 1 to 4096 is reserved for custom protocols.") }
            ]
        },
        height: 155
    }).hide();

    webix.ui({
        view:"popup",
        id:this.Id + "TypeListHelper",
        body:{
            view:"form",
            borderless:true,
            elements:[
                { template:LangHelper.GetString("Protocols","Type of list<br/>Which list to load on the equipment: Main or Test.<br/>Default is Main.") }
            ]
        },
        width: 400,
        height: 125
    }).hide();

    webix.ui({
        view:"popup",
        id:this.Id + "SyncModeHelper",
        body:{
            view:"form",
            borderless:true,
            elements:[
                { template:LangHelper.GetString("Protocols","Synchronization mode<br/>Protocol list synchronization mode.<br/>By DPIUI2 - dpiui2 module downloads lists to equipment.<br/>By URL - FastDPI downloads lists by link.<br/>By URL is default.") }
            ]
        },
        width: 400,
        height: 155
    }).hide();

    this.ProtocolsUriHelperContext = {
        view: "popup",
        id: this.Id + "ProtocolsUriHelperContext",
        // width: 320,
        // height: 800,
        body:{
            view:"form",
            borderless:true,
            margin: 0,
            padding: 0,
            elements:[
                {
                    id:this.Id + "ProtocolsUriHelperContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [{
                            id:this.Id + "ProtocolsUriHelperContextFormLabel",
                            view:"textarea",
                            borderless:true,
                            readonly:true,
                            labelAlign:"right",
                            height:320,
                            width:320,
                            value:""
                        }]
                }
            ]
        }
    };

    this.ProtocolsEditContextElements = [
        {
            view: "text",
            id: this.Id + "ProtocolsEditContextFormName",
            name: "public_alias",
            pattern: { mask:"##################################################", allow:/\w/g },
            labelWidth: 204,
            width: 460,
            label: LangHelper.GetString("Protocols","Name"),
            tooltip: LangHelper.GetString("Protocols","Name"),
            required:true,
            format:{
                parse: function(a){
                    a = CellFormatTemplate(a, true, true, "-_", true, false, _this.Prefix);
                    return Helper.Table.NumbersOnly(a)?'':a;
                },
                edit: function(a){
                    a = CellFormatTemplate(a, true, true, "-_", true, false, _this.Prefix);
                    return Helper.Table.NumbersOnly(a)?'':a;
                }
            },
            validate: webix.rules.isNotEmpty,
            invalidMessage: LangHelper.GetString("Protocols", "Required field")
        },
        {
            cols: [
                {
                    view: "text",
                    id: this.Id + "ProtocolsEditContextFormNumber",
                    name: "custom_number",
                    labelWidth: 204,
                    width: 460,
                    disabled: true,
                    placeholder: this.CustomStart + ".." + this.CustomEnd,
                    label: LangHelper.GetString("Protocols","Custom number"),
                    tooltip: LangHelper.GetString("Protocols","Custom number is a protocol identifier, a range limited to values from 1 to 1024 is reserved for custom protocols."),
                    required:true,
                    on:{
                        onTimedKeyPress: function (){
                            _this.SetPort();
                        },
                        onChange: function(){
                            _this.SetPort();
                        }
                    },
                    format:{
                        parse: function(Val){
                            var val = parseInt(Val);

                            return Helper.IsInteger(val) ? val : 0;
                        },
                        edit: function(Val){
                            var value = Val < _this.CustomStart ? _this.CustomStart : (Val > _this.CustomEnd ? _this.CustomEnd : Val);

                            var company = true;
                            if(!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())
                                var company = _this.SelectCompany == _this.Views.ProtocolsEditContextForm.elements.companies_company_id.getValue();

                            return (company && _this.SelectCustom == value) ? value : (_this.CustomBusy[value] ? this.edit(value+1) : value);
                        }
                    },
                    validate: function(Val)
                    {
                        if(!Val)
                            return false;

                        var val = parseInt(Val);
                        return Helper.IsInteger(val) && val >= _this.CustomStart && val <= _this.CustomEnd;
                    },
                    invalidMessage: LangHelper.GetString("Protocols", "Required field") + ". " +
                        LangHelper.GetString("Protocols", "Values") + " " +
                        LangHelper.GetString("Protocols", "from") + " " + this.CustomStart + " " +
                        LangHelper.GetString("Protocols", "to") + " " + this.CustomEnd
                },
                {
                    view: "button",
                    id: this.Id + "ProtocolsEditContextFormNumberHelper",
                    type: "icon",
                    icon: "question-circle",
                    css:"toolbar_round_btn",
                    align: "right",
                    width:32,
                    popup: this.Id + "CustomNumberHelper"
                }
            ]
        },
        {
            view: "text",
            id: this.Id + "ProtocolsEditContextFormPort",
            name: "port",
            labelWidth: 204,
            width: 460,
            // placeholder: this.PortStart + ".." + this.PortEnd,
            label: LangHelper.GetString("Protocols","Port"),
            tooltip: LangHelper.GetString("Protocols","Port"),
            disabled:true
        },
        {
            view: "textarea",
            id: this.Id + "ProtocolsEditContextFormDescription",
            name: "description",
            labelWidth: 204,
            width: 460,
            height: 150,
            attributes:{ maxlength:255 },
            label: LangHelper.GetString("Protocols","Description"),
            tooltip: LangHelper.GetString("Protocols","Description"),
            invalidMessage: LangHelper.GetString("Protocols", "Required field")
        },
        {
            view: "checkbox",
            id: this.Id + "ProtocolsEditContextFormMode",
            name: "prod_enabled",
            labelWidth: 204,
            width: 460,
            label: LangHelper.GetString("Protocols","Main List"),
            tooltip: LangHelper.GetString("Protocols","Main List"),
            required:true,
            validate: webix.rules.isNotEmpty,
            invalidMessage: LangHelper.GetString("Protocols", "Required field")
        },
        {
            rows: [
                {
                    height: 16
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Protocols","Cancel"),
                            click:function ()
                            {
                                _this.Views.ProtocolsEditContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id:this.Id + "ProtocolsEditContextFormSaveBtn",
                            type:"form",
                            label:LangHelper.GetString("Protocols","Save"),
                            hotkey: "enter",
                            click:function ()
                            {
                                _this.SaveProtocolsEditForm();
                            }
                        }
                    ]
                }
            ]
        }
    ];

    this.ProtocolsEditContext = {
        view: "popup",
        modal: true,
        id: this.Id + "ProtocolsEditContext",
        width: 540,
        height: 680,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    id:this.Id + "ProtocolsEditContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: this.ProtocolsEditContextElements
                }
            ]
        },
        on:{
            onShow: function (){
                _this.SetPort();
            }
        }
    };

    if(!App.SessionManager.IsModeDpiui2){
        this.ProtocolsCopyContext = webix.ui({
            view: "popup",
            modal: true,
            id: this.Id + "ProtocolsCopyContext",
            width: 360,
            height: 480,
            body:{
                id:this.Id + "ProtocolsCopyContextForm",
                view:"form",
                borderless:true,
                elements:[
                    {
                        view: "serverCombo",
                        name: "company",
                        method: "GetCompanies",
                        serverId: "company_id",
                        serverValue: "name",
                        label: LangHelper.GetString("Protocols", "Company name"),
                        labelPosition: "top",
                        required: true,
                        invalidMessage: LangHelper.GetString("Users", "Enter the company"),
                        options: [],
                        disabled: false
                    },
                    {
                        cols:[
                            {},
                            {
                                view:"button",
                                label:LangHelper.GetString("Protocols","Cancel"),
                                click:function ()
                                {
                                    _this.ProtocolsCopyContext.hide();
                                }
                            },
                            {
                                view:"button",
                                id: this.Id + "ProtocolsCopyContextFormCopyBtn",
                                type:"form",
                                label:LangHelper.GetString("Protocols","Copy"),
                                click:function ()
                                {
                                    _this.CopyProtocls();
                                }
                            }
                        ]
                    }
                ]
            }
        });
    }

    this.ProtocolsItemsEditContext = function (Edit) {
        return {
            view: "popup",
            modal: true,
            id: this.Id + "ProtocolsItemsEditContext",
            width: 460,
            height: 680,
            body: {
                view: "form",
                borderless: true,
                elements: [
                    {
                        id: this.Id + "ProtocolsItemsEditContextForm",
                        view: "form",
                        borderless: true,
                        margin: 0,
                        padding: 0,
                        elements: [
                            {
                                view: "richselect",
                                on: {
                                    onChange(newVal, oldVal)
                                    {
                                        let btnHelper = $$(_this.Id + "ProtocolsItemsEditContextFormUriHelper");

                                        if (_this.HelperLines[newVal])
                                        {
                                            btnHelper.attachEvent("onItemClick", function (id, e)
                                            {
                                                _this.ShowProtocolsUriHelperForm(_this.HelperLines[newVal].join("\n"), this.getNode(), "left");
                                            });

                                            btnHelper.enable();
                                            btnHelper.show();
                                        }
                                        else
                                        {
                                            btnHelper.disable();
                                            btnHelper.hide();
                                        }
                                    }
                                },
                                id: this.Id + "ProtocolsItemsEditContextFormType",
                                name: "type",
                                options: Helper.DictToArr(CustomProtocolsItemWithAutoTypeDic),
                                value:"auto",
                                labelWidth: 74,
                                width: 380,
                                label: LangHelper.GetString("Protocols", "Type"),
                                tooltip: LangHelper.GetString("Protocols", "Type"),
                                required: true,
                                validate: webix.rules.isNotEmpty,
                                invalidMessage: LangHelper.GetString("Protocols", "Required field")
                            },
                            {
                                id: _this.Id + "ProtocolsItemsEditContextFormResource",
                                cols: [
                                    function () {
                                        var a = {
                                            view: Edit?"text":"textarea",
                                            id: _this.Id + "ProtocolsItemsEditContextFormUri",
                                            name: "uri",
                                            labelWidth: 74,
                                            width: 380,
                                            label: LangHelper.GetString("Protocols", "Uri"),
                                            tooltip: LangHelper.GetString("Protocols", "Uri"),
                                            required: true,
                                            invalidMessage: LangHelper.GetString("Protocols", "Required field"),
                                            validate: function (Val) {
                                                this.markInvalid("uri", LangHelper.GetString("Protocols", "Required field"));

                                                if (!Val)
                                                    return false;

                                                let valid = true;

                                                let data = Val.split('\n').filter(value => value.length != 0);

                                                if (!data.length)
                                                    return false;

                                                let type = $$(_this.Id + "ProtocolsItemsEditContextFormType").getValue();

                                                this.markInvalid("uri", LangHelper.GetString("Protocols", "Validation error"));

                                                if (type == "ip") {
                                                    data.forEach(function (value) {
                                                        if (!(Helper.ValidateIPaddress(value)
                                                            || Helper.ValidateIPaddressSpacePort(value)
                                                            || Helper.ValidateIPaddressOrCidr(value)
                                                            || Helper.ValidateCidrSpacePort(value)
                                                        ))
                                                            valid = false;
                                                    });

                                                    return valid;
                                                }

                                                if (type == "sni") {
                                                    //
                                                }

                                                return valid;
                                            }
                                        };

                                        if (!Edit)
                                            a.height = 200;

                                        return a;
                                    }(),
                                    {
                                        view: "button",
                                        name: "uriHelper",
                                        id: _this.Id + "ProtocolsItemsEditContextFormUriHelper",
                                        type: "icon",
                                        icon: "question-circle",
                                        css: "toolbar_round_btn",
                                        align: "right",
                                        width: 32
                                    }
                                ]
                            },
                            {
                                rows: [
                                    {
                                        height: 24
                                    },
                                    {
                                        cols: [
                                            {},
                                            {
                                                view: "button",
                                                label: LangHelper.GetString("Protocols", "Cancel"),
                                                click: function () {
                                                    _this.Views.ProtocolsItemsEditContext.hide();
                                                }
                                            },
                                            {
                                                view: "button",
                                                id: this.Id + "ProtocolsItemsEditContextFormSaveBtn",
                                                type: "form",
                                                label: LangHelper.GetString("Protocols", "Save"),
                                                //hotkey: "enter",
                                                click: function () {
                                                    _this.SaveProtocolsItemsEditForm();
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        };
    };

    this.ProtocolsItemsCheckResourceContext = webix.ui({
        view: "popup",
        modal: true,
        id: this.Id + "ProtocolsItemsCheckResourceContext",
        width: 460,
        height: 680,
        body: {
            view: "form",
            borderless: true,
            elements: [
                {
                    id: this.Id + "ProtocolsItemsCheckResourceContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "richselect",
                            on: {
                                onChange(newVal, oldVal)
                                {
                                    let btnHelper = $$(_this.Id + "ProtocolsItemsCheckResourceEditContextFormUriHelper");

                                    if (_this.HelperLines[newVal])
                                    {
                                        btnHelper.attachEvent("onItemClick", function (id, e)
                                        {
                                            _this.ShowProtocolsUriHelperForm(_this.HelperLines[newVal].join("\n"), this.getNode(), "left");
                                        });

                                        btnHelper.enable();
                                        btnHelper.show();
                                    }
                                    else
                                    {
                                        btnHelper.disable();
                                        btnHelper.hide();
                                    }
                                }
                            },
                            id: this.Id + "ProtocolsItemsCheckResourceEditContextFormType",
                            name: "type",
                            options: Helper.DictToArr(CustomProtocolsItemWithAutoTypeDic),
                            value:"auto",
                            labelWidth: 74,
                            width: 380,
                            label: LangHelper.GetString("Protocols", "Type"),
                            tooltip: LangHelper.GetString("Protocols", "Type"),
                            required: true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Protocols", "Required field")
                        },
                        {
                            id: _this.Id + "ProtocolsItemsCheckResourceEditContextFormResource",
                            cols: [
                                {
                                    view: "textarea",
                                    id: _this.Id + "ProtocolsItemsCheckResourceEditContextFormUri",
                                    name: "uri",
                                    labelWidth: 74,
                                    width: 380,
                                    height: 200,
                                    label: LangHelper.GetString("Protocols", "Uri"),
                                    tooltip: LangHelper.GetString("Protocols", "Uri"),
                                    required: true,
                                    invalidMessage: LangHelper.GetString("Protocols", "Required field"),
                                    validate: function (Val) {
                                        this.markInvalid("uri", LangHelper.GetString("Protocols", "Required field"));

                                        if (!Val)
                                            return false;

                                        let valid = true;

                                        let data = Val.split('\n').filter(value => value.length != 0);

                                        if (!data.length)
                                            return false;

                                        let type = $$(_this.Id + "ProtocolsItemsCheckResourceEditContextFormType").getValue();

                                        this.markInvalid("uri", LangHelper.GetString("Protocols", "Validation error"));

                                        if (type == "ip") {
                                            data.forEach(function (value) {
                                                if (!(Helper.ValidateIPaddress(value)
                                                    || Helper.ValidateIPaddressSpacePort(value)
                                                    || Helper.ValidateIPaddressOrCidr(value)
                                                    || Helper.ValidateCidrSpacePort(value)
                                                ))
                                                    valid = false;
                                            });

                                            return valid;
                                        }

                                        return valid;
                                    }
                                },
                                {
                                    view: "button",
                                    name: "uriHelper",
                                    id: _this.Id + "ProtocolsItemsCheckResourceEditContextFormUriHelper",
                                    type: "icon",
                                    icon: "question-circle",
                                    css: "toolbar_round_btn",
                                    align: "right",
                                    width: 32
                                }
                            ]
                        },
                        {
                            rows: [
                                {
                                    height: 24
                                },
                                {
                                    cols: [
                                        {},
                                        {
                                            view: "button",
                                            label: LangHelper.GetString("Protocols", "Cancel"),
                                            click: function () {
                                                _this.Views.ProtocolsItemsCheckResourceContext.hide();
                                            }
                                        },
                                        {
                                            view: "button",
                                            id: this.Id + "ProtocolsItemsCheckResourceEditContextFormSaveBtn",
                                            type: "form",
                                            label: LangHelper.GetString("Classifier", "Check"),
                                            click: function ()
                                            {
                                                _this.CheckResourcesItemsIntersectionForm();
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });

    this.ProtocolsItemsSniEditContext = {
        view: "popup",
        modal: true,
        id: this.Id + "ProtocolsItemsSniEditContext",
        width: 560,
        height: 680,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    id:this.Id + "ProtocolsItemsSniEditContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            cols:[
                                {
                                    view: "text",
                                    id: this.Id + "ProtocolsItemsSniEditContextFormUri",
                                    name: "uri",
                                    labelWidth: 54,
                                    width: 400,
                                    label: LangHelper.GetString("Protocols","Uri"),
                                    tooltip: LangHelper.GetString("Protocols","Uri"),
                                    required:true,
                                    invalidMessage: LangHelper.GetString("Protocols", "Required field"),
                                    on: {
                                        onTimedKeyPress: function ()
                                        {
                                            let btn = _this.Views.ProtocolsItemsSniEditContextFormGetBtn;
                                            this.getValue()?btn.enable():btn.disable();
                                        }
                                    },
                                    validate: function(Val)
                                    {
                                        if(!Val)
                                            return false;

                                        let valid = true;

                                        return valid;
                                    }
                                },
                                {
                                    view:"button",
                                    id: this.Id + "ProtocolsItemsSniEditContextFormGetBtn",
                                    label:LangHelper.GetString("Protocols","Get"),
                                    disabled: true,
                                    click:function ()
                                    {
                                        let btn = this;
                                        Helper.Table.ShowProgressButton(btn);
                                        _this.ViewModel.GetSniResources(
                                            {
                                                resource:_this.Views.ProtocolsItemsSniEditContextFormUri.getValue(),
                                                callback:function (ResultModel)
                                                {
                                                    let table = _this.Views.ProtocolsItemsSniEditContextFormTable;

                                                    let records = [];

                                                    ResultModel.sni.forEach(function (sni){
                                                        records.push(
                                                            {
                                                                "type": "sni",
                                                                "uri": sni
                                                            }
                                                        );
                                                    });

                                                    ResultModel.ip.forEach(function (ip){
                                                        records.push(
                                                            {
                                                                "type": "ip",
                                                                "uri": ip
                                                            }
                                                        );
                                                    });

                                                    table.clearAll();
                                                    table.parse(records);

                                                    Helper.Table.ShowProgressButton(btn, false);
                                                }
                                            }
                                        );
                                    }
                                }
                            ]
                        },
                        {
                            height: 12
                        },
                        {
                            view:"datatable",
                            id:this.Id+"ProtocolsItemsSniEditContextForm" + "Table",
                            checkboxRefresh:true,
                            columns:[
                                { id:"type", fillspace:true, required:true, header:[LangHelper.GetString("Protocols","Type"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                                { id:"uri", width: 174, fillspace:true, required:true, header:[LangHelper.GetString("Protocols","Record"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                                // {
                                //     id: "trash",
                                //     header: "",
                                //     width: 32,
                                //     template: CellTrashBtnTemplate,
                                //     headermenu: false
                                // }
                            ],
                            on: {
                                onItemClick: function (id, e, node)
                                {
                                    if (id.column === 'trash')
                                    {
                                        this.remove(id);
                                    }
                                },
                                onAfterRender: function (data)
                                {
                                    let btn = _this.Views.ProtocolsItemsSniEditContextFormSaveBtn;

                                    if (btn)
                                        this.count()?btn.enable():btn.disable();
                                }
                            },
                            required:true,
                            invalidMessage: LangHelper.GetString("Protocols", "Required field")
                        },
                        {
                            rows: [
                                {
                                    height: 24
                                },
                                {
                                    cols:[
                                        {},
                                        {
                                            view:"button",
                                            label:LangHelper.GetString("Protocols","Cancel"),
                                            click:function ()
                                            {
                                                _this.Views.ProtocolsItemsSniEditContext.hide();
                                            }
                                        },
                                        {
                                            view:"button",
                                            id:this.Id + "ProtocolsItemsSniEditContextFormSaveBtn",
                                            type:"form",
                                            label:LangHelper.GetString("Protocols","Save"),
                                            hotkey: "enter",
                                            disabled: true,
                                            click:function ()
                                            {
                                                _this.SaveProtocolsItemsSniEditForm();
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ProtocolsTrashContext = {
        view:"popup",
        id: this.Id + "ProtocolsTrashContext",
        width:300,
        height:180,
        body:{
            id:this.Id + "ProtocolsTrashContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Classifier","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Protocols","Cancel"),
                            click:function ()
                            {
                                _this.Views.ProtocolsTrashContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProtocolsTrashContextFormDeleteBtn",
                            type:"form",
                            label:LangHelper.GetString("Protocols","Delete"),
                            click:function ()
                            {
                                _this.Views.ProtocolsTrashContext.hide();

                                _this.DeleteProtocol();
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.ProtocolsItemsTrashContext = {
        view:"popup",
        id: this.Id + "ProtocolsItemsTrashContext",
        width:300,
        height:180,
        body:{
            id:this.Id + "ProtocolsItemsTrashContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Classifier","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Protocols","Cancel"),
                            click:function ()
                            {
                                _this.Views.ProtocolsItemsTrashContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProtocolsItemsTrashContextFormDeleteBtn",
                            type:"form",
                            label:LangHelper.GetString("Protocols","Delete"),
                            click:function ()
                            {
                                _this.Views.ProtocolsItemsTrashContext.hide();

                                _this.DeleteProtocolItem();
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.ProtocolsDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ProtocolsDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProtocolsDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ProtocolsDeleteSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ProtocolsEraseContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to remove all list items?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ProtocolsEraseContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProtocolsEraseContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ProtocolsErase();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ProtocolsItemsDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ProtocolsItemsDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProtocolsItemsDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ProtocolsItemsDeleteSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ProtocolsItemsEraseContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to remove all list items?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ProtocolsItemsEraseContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProtocolsItemsEraseContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ProtocolsItemsErase();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ProtocolsImportContextElements = function () {
        let cols = [
            {
                view: "uploader",
                value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                id: this.Id+"ProtocolsImportContext" + "Uploader",
                css:"upload_area",
                autosend:false,
                height:64
            },
            {
                view:"datatable",
                id:this.Id+"ProtocolsImportContext" + "Table",
                checkboxRefresh:true,
                columns:[
                    { id:"public_alias", fillspace:true, header:[LangHelper.GetString("Protocols","Name"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                    { id:"custom_number", width: 174, fillspace:true, header:[LangHelper.GetString("Protocols","Custom number"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                    { id:"protocol_port", template: function (obj, common, value){
                            return _this.CalcPort(obj.custom_number);
                        }, fillspace:true, header:[LangHelper.GetString("Protocols","Port"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                    { id:"prod_enabled", template:function (obj, common, val, config) {
                            return TextTemplate(val, LangHelper.GetString("Protocols", "Main"), LangHelper.GetString("Protocols", "Test"));
                        }, fillspace:true, header:[LangHelper.GetString("Protocols","List type"), {
                            content: "richSelectFilter",
                            options: Helper.DictToArr(TypeListDic),
                            inputConfig: {suggest: {fitMaster: false}}
                        }] },
                    { id:"description", fillspace:true, header:[LangHelper.GetString("Protocols","Description"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                    {
                        id: "trash",
                        header: "",
                        width: 32,
                        template: CellTrashBtnTemplate,
                        headermenu: false
                    }
                ],
                scheme:{
                    $init:function(obj){
                        obj.public_alias = obj.data0;
                        obj.custom_number = obj.data1;
                        obj.prod_enabled = obj.data2;
                        obj.description = obj.data3;
                    }
                },
                on: {
                    onItemClick: function (id, e, node)
                    {
                        if (id.column === 'trash')
                        {
                            this.remove(id);
                        }
                    }
                }
            }
        ];

        if(!App.SessionManager.IsModeDpiui2){
            cols.push(
                {
                    view: "serverCombo",
                    method: "GetCompanies",
                    serverId: "company_id",
                    serverValue: "name",
                    id: this.Id+"ProtocolsImportContextCompany",
                    name: "company_id",
                    labelWidth: 104,
                    width: 720,
                    hidden: true,
                    options: [],
                    label: LangHelper.GetString("Protocols", "Company"),
                    tooltip: LangHelper.GetString("Protocols", "Company"),
                    required: true,
                    validate: webix.rules.isNotEmpty,
                    invalidMessage: LangHelper.GetString("Protocols", "Required field")
                }
            )
        }

        cols.push(
            {
                cols:[
                    {
                        view: "button",
                        label: LangHelper.GetString(_this.Id, "Get template"),
                        click: function()
                        {
                            _this.GetProtocolsImportTemplate();
                        }
                    },
                    {},
                    {
                        view:"button",
                        label:LangHelper.GetString(_this.Id,"Cancel"),
                        click:function ()
                        {
                            _this.ProtocolsImportContext.hide();
                            _this.Views.ProtocolsImportContextTable.clearAll();
                        }
                    },
                    {
                        view:"button",
                        id:this.Id + "ProtocolsImportContext" + "ImportBtn",
                        type:"form",
                        label:LangHelper.GetString(_this.Id,"Import"),
                        click:function ()
                        {
                            _this.ProtocolsImportContext.hide();

                            _this.SaveProtocolsImportedExceldata();
                        }
                    }
                ]
            }
        )

        return cols;
    };
    this.ProtocolsImportContext = webix.ui({
        view:"popup",
        width:720,
        height:720,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"ProtocolsImportContextForm",
            borderless:true,
            elements: _this.ProtocolsImportContextElements()
        }
    });

    this.ProtocolsDuplicateContext = webix.ui({
        view:"popup",
        width:720,
        height:720,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"ProtocolsDuplicateContextForm",
            borderless:true,
            elements: [
                BlockHeaderTemplate({
                    title:LangHelper.GetString("Protocols","Duplicates"), icon:"files-o"
                }),
                { view: "label", id:this.Id + "RowsLabel", label: LangHelper.GetString("Protocols","Rows count: ") },
                { view: "label", id:this.Id + "InsertedItemsLabel", label: LangHelper.GetString("Protocols","Inserted items count: ") },
                { view: "label", id:this.Id + "ErrorItemsLabel", label: LangHelper.GetString("Protocols","Rows per insert count: ") },
                { view: "label", id:this.Id + "DuplicatesLabel", label: LangHelper.GetString("Protocols","Duplicates count: ") },
                { view: "label", id:this.Id + "IntersectionLabel", label: LangHelper.GetString("Protocols","Intersections with the cloud list count: ") },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Close"),
                            click:function ()
                            {
                                _this.ProtocolsDuplicateContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    // this.ProtocolsItemsImportContext = webix.ui({
    //     view:"popup",
    //     width:720,
    //     height:720,
    //     modal:true,
    //     body:{
    //         view:"form",
    //         id:this.Id+"ProtocolsItemsImportContextForm",
    //         borderless:true,
    //         elements:[
    //             {
    //                 view: "uploader",
    //                 value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
    //                 id: this.Id+"ProtocolsItemsImportContext" + "Uploader",
    //                 css:"upload_area",
    //                 autosend:false,
    //                 height:64
    //             },
    //             {
    //                 view:"datatable",
    //                 id:this.Id+"ProtocolsItemsImportContext" + "Table",
    //                 checkboxRefresh:true,
    //                 columns:[
    //                     { id:"type", fillspace:true, header:[LangHelper.GetString("Protocols","Type"), {
    //                             content: "richSelectFilter",
    //                             options: Helper.DictToArr(CustomProtocolsItemTypeDic),
    //                             inputConfig: {suggest: {fitMaster: false}}
    //                         }] },
    //                     { id:"uri", template: function (obj, common, value) {
    //                             if (obj.type == "template")
    //                             {
    //                                 var dic = App.DicsManager.GetDic(DicsEnum.CustomProtocolsTemplatesDic)[value];
    //                                 return dic?dic.value:"<span style=\"color:#1A84D8\">" + LangHelper.GetString("Protocols","Unknown") + "</span>";
    //                             }

    //                             return value;
    //                         }, fillspace:true, header:[LangHelper.GetString("Protocols","Uri"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
    //                     {
    //                         id: "trash",
    //                         header: "",
    //                         width: 32,
    //                         template: CellTrashBtnTemplate,
    //                         headermenu: false
    //                     }
    //                 ],
    //                 scheme:{
    //                     $init:function(obj){
    //                         obj.type = obj.data0;
    //                         obj.uri = obj.data1;
    //                     }
    //                 },
    //                 on: {
    //                     onItemClick: function (id, e, node)
    //                     {
    //                         if (id.column === 'trash')
    //                         {
    //                             this.remove(id);
    //                         }
    //                     }
    //                 }
    //             },
    //             {
    //                 view: "richselect",
    //                 id: this.Id+"ProtocolsItemsImportContextProtocol",
    //                 name: "protocol_id",
    //                 labelWidth: 104,
    //                 width: 720,
    //                 options: [],
    //                 label: LangHelper.GetString("Protocols", "Protocol"),
    //                 tooltip: LangHelper.GetString("Protocols", "Protocol"),
    //                 required: true,
    //                 validate: webix.rules.isNotEmpty,
    //                 invalidMessage: LangHelper.GetString("Protocols", "Required field")
    //             },
    //             {
    //                 cols:[
    //                     {
    //                         view: "button",
    //                         label: LangHelper.GetString(_this.Id, "Get template"),
    //                         click: function()
    //                         {
    //                             _this.GetProtocolsItemsImportTemplate();
    //                         }
    //                     },
    //                     {},
    //                     {
    //                         view:"button",
    //                         label:LangHelper.GetString(_this.Id,"Cancel"),
    //                         click:function ()
    //                         {
    //                             _this.ProtocolsItemsImportContext.hide();
    //                             _this.Views.ProtocolsItemsImportContextTable.clearAll();
    //                         }
    //                     },
    //                     {
    //                         view:"button",
    //                         id:this.Id + "ProtocolsItemsImportContext" + "ImportBtn",
    //                         type:"form",
    //                         label:LangHelper.GetString(_this.Id,"Import"),
    //                         click:function ()
    //                         {
    //                             _this.SaveProtocolsItemsImportedExceldata();
    //                         }
    //                     }
    //                 ]
    //             }
    //         ]
    //     }
    // });

    this.ProtocolsItemsErrorValidationContext = webix.ui({
        view:"popup",
        width:480,
        height:320,
        body:{
            borderless: true,
            margin: 0,
            padding: 0,
            rows:[
                {
                    view:"codemirror-editor",
                    id:this.Id + "ProtocolsItemsErrorValidationContextEditor",
                    value:""
                },
                {
                    height:16
                },
                {
                    cols:[
                        {},
                        {
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id, "Close"),
                            click:function () {
                                _this.ProtocolsItemsErrorValidationContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.Views = {
        View:null,

        PageHeaderWidget:null,

        HardwareEditContext:null,
        HardwareEditContextForm:null,

        ProtocolsUriHelperContext:null,
        ProtocolsUriHelperContextForm:null,
        ProtocolsUriHelperContextFormLabel:null,

        ProtocolsEditContext:null,
        ProtocolsEditContextForm:null,

        ProtocolsCopyContext: null,
        ProtocolsCopyContextForm: null,
        ProtocolsCopyContextFormCopyBtn: null,
        ProtocolsCopyContextFormCompanySelect: null,

        ProtocolsItemsEditContext:null,
        ProtocolsItemsEditContextForm:null,
        ProtocolsItemsEditContextFormSaveBtn:null,

        ProtocolsItemsSniEditContext:null,
        ProtocolsItemsSniEditContextForm:null,
        ProtocolsItemsSniEditContextFormUri:null,
        ProtocolsItemsSniEditContextFormGetBtn:null,
        ProtocolsItemsSniEditContextFormSaveBtn:null,
        ProtocolsItemsSniEditContextFormTable:null,

        ProtocolsImportBtn:null,
        ProtocolsEnableBtn:null,
        ProtocolsDisableBtn:null,
        ProtocolsDeleteBtn:null,
        ProtocolsClearBtn:null,

        ProtocolsItemsToolbar:null,
        ProtocolsItemsImportBtn:null,
        ProtocolsItemsCheckResourcesBtn: null,
        ProtocolsItemsEnableBtn:null,
        ProtocolsItemsDisableBtn:null,
        ProtocolsItemsDeleteBtn:null,
        ProtocolsItemsClearBtn:null,
        ProtocolsCopyBtn: null,
        ProtocolsItemsAddBtn: null,

        ProtocolsImportContextForm:null,
        ProtocolsDuplicateContextForm:null,
        ProtocolsImportContextUploader:null,
        ProtocolsImportContextTable:null,
        ProtocolsDuplicateContextTable:null,
        ProtocolsRowsLabel:null,
        ProtocolsErrorItemsLabel:null,
        ProtocolsInsertedItemsLabel:null,
        ProtocolsDuplicatesLabel:null,
        ProtocolsIntersectionLabel:null,
        ProtocolsDuplicatesDownloadFile: null,
        ProtocolsErrorsDownloadFile: null,

        ProtocolsItemsImportContextForm:null,
        ProtocolsItemsImportContextUploader:null,
        ProtocolsItemsImportContextTable:null,
        ProtocolsItemsErrorValidationContextEditor: null,

        ProtocolsItemsFileImportContextForm:null,
        ProtocolsItemsFileImportContextUploader:null,
        ProtocolsItemsFileImportContextTable:null,

        ProtocolsForcedUnloadingProtocolDirectoryBtn: null,

        ProtocolsItemsCheckResourceContext: null,
        ProtocolsItemsCheckResourceContextForm: null,
        ProtocolsItemsCheckResourceEditContextFormSaveBtn: null,

        Widgets:{},
        ReportsWidgets:{
            ProtocolsReport: ProtocolsTableWidget({
                id:this.Id + "ProtocolsReport",
                editable:this.Editable.getValue(),
                onItemClick:function (Id,e,node)
                {
                    var table = _this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'run':
                            _this.ProtocolControl(rowData);
                            break;
                        case 'edit':
                            _this.ShowProtocolsEditForm(rowData, table.getItemNode(Id), "right");
                            break;
                        case 'trash':
                            _this.Views.ProtocolsTrashContext.show(table.getItemNode(Id), {pos:"bottom"});
                            break;
                    }
                }
            }),

            ProtocolsItemsReport: ProtocolsItemsTableWidget({
                id:this.Id + "ProtocolsItemsReport",
                editable:this.Editable.getValue(),
                onItemClick:function (Id,e,node)
                {
                    var table = _this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'item_enabled':
                            _this.ProtocolItemControl(rowData);
                            break;
                        case 'edit':
                            _this.ShowProtocolsItemsEditForm(rowData, table.getItemNode(Id), "bottom");
                            break;
                        case 'trash':
                            _this.Views.ProtocolsItemsTrashContext.show(table.getItemNode(Id), {pos:"bottom"});
                            break;
                        case 'validation_error':
                            _this.ShowProtocolsItemsErrorValidationContext(rowData, table.getItemNode(Id), "bottom");
                            break;
                        case 'uri':
                            let target = e.target || e.srcElement;

                            var data = table.getItem(Id);

                            if (data.type == "asn" && target.classList.contains("webix_icon"))
                            {
                                let uri = rowData.uri;

                                var modal_title = LangHelper.GetString("Protocols","AS resources");

                                var table_params = {
                                    enableAutoHeight: false,
                                    enableTextSearch: true,
                                    is_modal: true,
                                    filter: {
                                        type: {
                                            id: "type",
                                            operator: "=",
                                            value: "ipv4"
                                        },
                                        as_number: {
                                            id:"as_number",
                                            operator: "=",
                                            value: uri
                                        }

                                    }
                                }

                                table = new AsResourceListTableWidget(table_params);

                                AsResourcesPopup({
                                    modal_title: modal_title
                                }, table, uri);

                                table.Bind(_this, _this.ReportsModel);
                                table.RefreshData();
                            }

                            break;
                    }
                }
            }),
            ImportedFilesReport: ImportedFilesTableWidget({
                id:this.Id + "ImportedFilesReport",
                enableTextSearch:0,
                // enableAutoHeight:1,
                // hidePaginatorToolbar:1,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource: 1,
                dataSource: function(FilterParams)
                {
                    var res = {
                        count: _this.ImportFilesArr.length,
                        page: FilterParams.Params.page,
                        size: _this.Views.ReportsWidgets.ImportedFilesReport.Views.Paging.config.size,
                        rows: []
                    };

                    var sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : 'name';
                    var sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : 'asc';

                    var sort_val = sort_dir == 'asc' ? 1 : -1;


                    _this.ImportFilesArr.sort((a, b) => {
                        var val_a = a[sort_prop];
                        var val_b = b[sort_prop];

                        if(typeof val_a == 'string' || typeof val_b == 'string')
                        {
                            if(sort_val > 0)
                            {
                                return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                            }
                            else
                            {
                                return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                            }
                        }
                        else if(typeof val_a == 'number' || typeof val_b == 'number')
                        {
                            return sort_val * val_a + (-1) * sort_val * val_b;
                        }

                        return -1;
                    });

                    const start_index = res.page * res.size;
                    var finish_index = start_index + res.size;

                    if(finish_index > (_this.ImportFilesArr.length - 1))
                    {
                        res.rows = _this.ImportFilesArr.slice(start_index);
                    }
                    else
                    {
                        res.rows = _this.ImportFilesArr.slice(start_index, finish_index);
                    }

                    return res;
                },
                onItemClick:function (Id) {
                    _this.ImportFilesClick(Id);
                }
            })
        }
    };

    this.ProtocolsItemsFileImportContextConfig = {
        view:"popup",
        width:720,
        height:720,
        modal:true,
        body: {
            // type:"space",
            borderless:true,
            rows:[
                {
                    view: "form",
                    id: this.Id + "ProtocolsItemsFileImportContextForm",
                    type: typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? "wide" : undefined,
                    minWidth:720,
                    minHeight:400,
                    elements: [
                        {
                            view: "uploader",
                            css:"upload_area",
                            value: LangHelper.GetString("Protocols","Click to upload or drag a file here"),
                            id: this.Id+"ProtocolsItemsFileImportContextUploader",
                            autosend:false,
                            height:64
                        },
                        this.Views.ReportsWidgets.ImportedFilesReport.ViewConfig
                    ]
                },

                {height:20},
                {
                    type:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? "wide" : undefined,
                    height: typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? 60 : undefined,
                    cols:[
                        {
                            view:"button",
                            label:LangHelper.GetString("Protocols","Help"),
                            autowidth:true,
                            click:function ()
                            {
                                _this.HelpPopup.show(this.getNode(), {pos: "right"});
                            }
                        },
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Protocols","Close"),
                            autowidth:true,
                            click:function ()
                            {
                                setTimeout(function ()
                                {
                                    _this.ProtocolsItemsFileImportContext.hide();
                                },1);
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Protocols","Import"),
                            autowidth:true,
                            click:function ()
                            {
                                _this.SaveImportedFile();
                                setTimeout(function ()
                                {
                                    _this.ProtocolsItemsFileImportContext.hide();
                                },1);
                            }
                        },
                    ]
                }
            ]
        }
    };

    this.ProtocolsItemsFileImportContext = webix.ui(this.ProtocolsItemsFileImportContextConfig);

    var accordion = [
        {
            header:LangHelper.GetString("Protocols","Protocols"), body:{
                id:this.Id + "Protocols",
                rows:[
                    {
                        view: "toolbar",
                        height:webix.skin.$active.rowHeight,
                        padding: 0,
                        margin: 0,
                        elements: function()
                        {
                           var res = [
                               {
                                   view: "button",
                                   id:_this.Id + "AddBtn",
                                   type: "icon",
                                   icon: "plus",
                                   align: "right",
                                   width: 32,
                                   css:"toolbar_round_btn",
                                   tooltip:LangHelper.GetString("Protocols","Add list item"),
                                   click: function (id, e, node)
                                   {
                                       _this.ShowProtocolsEditForm(null, this.getNode(), "right");
                                   }
                               },
                               {
                                   width:16
                               },
                               {
                                   view: "button",
                                   id:_this.Id+"ProtocolsEnableBtn",
                                   type: "icon",
                                   icon: "play",
                                   css:"toolbar_round_btn",
                                   width:32,
                                   tooltip:LangHelper.GetString("All", "Enable"),
                                   disabled:true,
                                   click:function (id,e,node)
                                   {
                                       _this.ProtocolsEnableDisable(true);
                                   }
                               },
                               {
                                   view: "button",
                                   id:_this.Id+"ProtocolsDisableBtn",
                                   type: "icon",
                                   icon: "stop",
                                   css:"toolbar_round_btn",
                                   width:32,
                                   tooltip:LangHelper.GetString("All", "Disable"),
                                   disabled:true,
                                   click:function (id,e,node)
                                   {
                                       _this.ProtocolsEnableDisable(false);
                                   }
                               },
                               {
                                   width:16
                               },
                               {
                                   view: "button",
                                   id:_this.Id + "ProtocolsImportBtn",
                                   type: "icon",
                                   icon: "upload",
                                   css:"toolbar_round_btn",
                                   width:32,
                                   tooltip:LangHelper.GetString(this.Id,"Import from file"),
                                   click:function (id,e,node)
                                   {
                                       var __this = this;
                                       setTimeout(function () {
                                           _this.ShowProtocolsImportForm(null, __this.getNode(id), "bottom");
                                       }, 10);
                                   }
                               },
                               {
                                   width:16
                               },
                               {
                                   view: "button",
                                   id:_this.Id+"ProtocolsDeleteBtn",
                                   type: "icon",
                                   icon: "trash",
                                   css:"toolbar_round_btn",
                                   width:32,
                                   tooltip:LangHelper.GetString(this.Id, "Delete"),
                                   disabled:true,
                                   click:function (id,e,node)
                                   {
                                       var __this = this;
                                       setTimeout(function () {
                                           var node = __this.getNode(id);
                                           _this.ProtocolsDeleteContext.show(node, {pos:"bottom"});
                                       }, 10);
                                   }
                               },
                               {
                                   view: "button",
                                   id:_this.Id+"ProtocolsClearBtn",
                                   type: "icon",
                                   icon: "eraser",
                                   css:"toolbar_round_btn",
                                   width:32,
                                   tooltip:LangHelper.GetString("Protocols", "Clear list"),
                                   click:function (id,e,node)
                                   {
                                       var __this = this;
                                       setTimeout(function () {
                                           var node = __this.getNode(id);
                                           _this.ProtocolsEraseContext.show(node, {pos:"bottom"});
                                       }, 10);
                                   }
                               }

                           ];

                           if(!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())
                           {
                               res.push({width: 16});
                               res.push({
                                   view: "button",
                                   id:_this.Id+"ProtocolsCopyBtn",
                                   type: "icon",
                                   icon: "copy",
                                   css: "toolbar_round_btn",
                                   width: 32,
                                   tooltip: LangHelper.GetString("Protocols","Copy"),
                                   click: function (id, e, node)
                                   {
                                       _this.ShowCustomProtocolsCopyForm(this.getNode(), "right");
                                   }
                               })

                           }

                           res.push({
                               view: "button",
                               id:_this.Id+"ProtocolsForcedUnloadingProtocolDirectoryBtn",
                               type: "icon",
                               icon: "cloud-download-alt",
                               css:"toolbar_round_btn",
                               width:32,
                               hidden: App.SessionManager.IsModeDpiui2?true:false,
                               tooltip:LangHelper.GetString("Protocols", "Forced unloading of custom protocols and default lists")
                           })
                           res.push({});
                           res.push({
                                view: "button",
                                id:_this.Id+"ProtocolsRefreshBtn",
                                type: "icon",
                                icon: "refresh",
                                css: "toolbar_round_btn",
                                width: 32,
                                tooltip: LangHelper.GetString("All","Refresh"),
                                click: function (id, e, node)
                                {
                                    _this.Refresh();
                                }
                            });

                           return res;
                        }()
                    },
                    BlockHeaderTemplate({
                        title:LangHelper.GetString("Protocols","Protocols"), icon:"files-o"
                    }),
                    this.Views.ReportsWidgets.ProtocolsReport.ViewConfig
                ]
            }, collapsed:false
        },
        { view:"resizer" },
        {
            header:LangHelper.GetString("Protocols","Resource List"), body:{
                gravity:15,
                id:this.Id + "Items",
                rows:[
                    {
                        view: "toolbar",
                        id:this.Id + "Items" + "Toolbar",
                        height:webix.skin.$active.rowHeight,
                        padding: 0,
                        margin: 0,
                        elements: [
                            {
                                view: "button",
                                id:this.Id + "ItemsAddBtn",
                                type: "icon",
                                icon: "plus",
                                align: "right",
                                width: 32,
                                css:"toolbar_round_btn",
                                tooltip:LangHelper.GetString("Protocols","Add list item"),
                                click: function (id, e, node)
                                {
                                    _this.ShowProtocolsItemsEditForm(null, this.getNode(), "bottom");
                                }
                            },
                            {
                                view: "button",
                                id:this.Id + "ItemsAddSniBtn",
                                type: "icon",
                                icon: "plus-circle",
                                align: "right",
                                width: 32,
                                hidden: App.SessionManager.IsModeDpiui2?false:true,
                                css:"toolbar_round_btn",
                                tooltip:LangHelper.GetString("Protocols","Add list item"),
                                click: function (id, e, node)
                                {
                                    _this.ShowProtocolsSniEditForm(null, this.getNode(), "bottom");
                                }
                            },
                            {
                                width:16
                            },
                            {
                                view: "button",
                                id:this.Id+"ProtocolsItemsEnableBtn",
                                type: "icon",
                                icon: "play",
                                css:"toolbar_round_btn",
                                width:32,
                                tooltip:LangHelper.GetString("All", "Enable"),
                                disabled:true,
                                click:function (id,e,node)
                                {
                                    _this.ProtocolItemsEnableDisable(true);
                                }
                            },
                            {
                                view: "button",
                                id:this.Id+"ProtocolsItemsDisableBtn",
                                type: "icon",
                                icon: "stop",
                                css:"toolbar_round_btn",
                                width:32,
                                tooltip:LangHelper.GetString("All", "Disable"),
                                disabled:true,
                                click:function (id,e,node)
                                {
                                    _this.ProtocolItemsEnableDisable(false);
                                }
                            },
                            {
                                width:16
                            },
                            {
                                view: "button",
                                id:this.Id + "ProtocolsItemsImportBtn",
                                type: "icon",
                                icon: "upload",
                                css:"toolbar_round_btn",
                                width:32,
                                tooltip:LangHelper.GetString(this.Id,"Import from file"),
                                click:function (id,e,node)
                                {
                                    var __this = this;
                                    setTimeout(function () {
                                        _this.ShowProtocolsItemsImportForm(null, __this.getNode(id), "bottom");
                                    }, 10);
                                }
                            },
                            {
                                view: "button",
                                id:this.Id + "ProtocolsItemsCheckResourcesBtn",
                                type: "icon",
                                icon: "check",
                                css:"toolbar_round_btn",
                                width:32,
                                tooltip:LangHelper.GetString("Protocols","Check resource"),
                                click:function (id,e,node)
                                {
                                    _this.ShowProtocolsItemsCheckResourceForm(this.getNode(), "bottom");
                                }
                            },
                            {
                                width:16
                            },
                            {
                                view: "button",
                                id:this.Id+"ProtocolsItemsDeleteBtn",
                                type: "icon",
                                icon: "trash",
                                css:"toolbar_round_btn",
                                width:32,
                                tooltip:LangHelper.GetString(this.Id, "Delete"),
                                disabled:true,
                                click:function (id,e,node)
                                {
                                    var __this = this;
                                    setTimeout(function () {
                                        var node = __this.getNode(id);
                                        _this.ProtocolsItemsDeleteContext.show(node, {pos:"bottom"});
                                    }, 10);
                                }
                            },
                            {
                                view: "button",
                                id:this.Id+"ProtocolsItemsClearBtn",
                                type: "icon",
                                icon: "eraser",
                                css:"toolbar_round_btn",
                                width:32,
                                tooltip:LangHelper.GetString("Protocols", "Clear list"),
                                click:function (id,e,node)
                                {
                                    var __this = this;
                                    setTimeout(function () {
                                        var node = __this.getNode(id);
                                        _this.ProtocolsItemsEraseContext.show(node, {pos:"bottom"});
                                    }, 10);
                                }
                            },
                            {},
                            {
                                view: "button",
                                id:this.Id + "Items" + "RefreshBtn",
                                type: "icon",
                                icon: "refresh",
                                css: "toolbar_round_btn",
                                width: 32,
                                tooltip: LangHelper.GetString("All","Refresh"),
                                click: function (id, e, node)
                                {
                                    _this.RefreshItems();
                                }
                            }
                        ]
                    },
                    BlockHeaderTemplate({
                        title:LangHelper.GetString("Protocols","Resource List"), icon:"book"
                    }),
                    this.Views.ReportsWidgets.ProtocolsItemsReport.ViewConfig
                ]
            }, collapsed:false
        }
    ];

    var header = [
        PageHeaderTemplate({id:_this.Id + "PageTitle", root_title: _this.Id === _this.IdsEnum.UlrAppCustomProtocols ? _this.PageTitle.Title : _this.PageTitle.RootTitle, title: _this.Id === _this.IdsEnum.UlrAppCustomProtocols ? "" : _this.PageTitle.Title})
    ];


    var LeftSideBar = [];

    if(App.SessionManager.IsModeDpiui2)
    {
        if (!App.VasCloudSessionManager)
        {
            App.VasCloudSessionManager = new VasCloudSessionManager();
            App.VasCloudSessionManager.CheckLoggedIn();
        }

        this.ViewHardwares = new VasCloudProtocolsHardwaresManager();

        if(_this.Id === _this.IdsEnum.VasCloudProtocolsCustom)
            this.Views.PageHeaderWidget = new VasCloudPageHeaderWidget({id:this.Id + "PageHeaderWidget"});

        Object.assign(this.Views.ReportsWidgets,{HardwareReport: ProtocolsHardwaresTableWidget({
                id: this.Id + "HardwareReport",
                editable: this.Editable.getValue(),
                onItemClick: function(Id,e,node) {
                    var table = _this.Views.ReportsWidgets.HardwareReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'enabled':
                            rowData.status = 'in progress';
                            _this.ViewHardwares.Enable({enabled:!parseInt(rowData.enabled), hardware_id:rowData.hardware_id, callback:function (R)
                                {
                                    if(R.success)
                                    {
                                        webix.message(LangHelper.GetString("Protocols","Custom Protocols") + ": " + LangHelper.GetString("VasCloud",(R.data && R.data.enabled)?"Enabled":"Disabled"));
                                        table.updateItem(Id, R.data);
                                    }
                                    else
                                    {
                                        if(R.error)
                                        {
                                            webix.message({text:R.error.msg,type:"error"});

                                            rowData.status = "error";
                                            rowData.status_description = R.error.msg;
                                            rowData.enabled = rowData.enabled?0:1;
                                            table.updateItem(Id, rowData);
                                        }
                                    }
                                }});
                            break;
                        case 'edit':
                            _this.ShowHardwareEditForm(rowData, table.getItemNode(Id), "right");
                            break;
                    }
                }
            })});

        accordion.unshift(
            {
                header:LangHelper.GetString("Protocols","Hardwares"), body:{
                    id:this.Id + "Hardwares",
                    rows:[
                        {
                            view: "toolbar",
                            height:webix.skin.$active.rowHeight,
                            padding: 0,
                            margin: 0,
                            elements: [
                                {},
                                {
                                    view: "button",
                                    id:this.Id+"HardwaresRefreshBtn",
                                    type: "icon",
                                    icon: "refresh",
                                    css: "toolbar_round_btn",
                                    width: 32,
                                    tooltip: LangHelper.GetString("All","Refresh"),
                                    click: function (id, e, node)
                                    {
                                        _this.RefreshHardwares();
                                    }
                                }
                            ]
                        },
                        BlockHeaderTemplate({
                            title:LangHelper.GetString("Protocols","Hardwares"), icon:"list"
                        }),
                        this.Views.ReportsWidgets.HardwareReport.ViewConfig
                    ]
                }, collapsed:true
            },
            { view:"resizer" });

        if(_this.Id === _this.IdsEnum.VasCloudProtocolsCustom)
        {
            header.push(this.Views.PageHeaderWidget.ViewConfig);

            LeftSideBar = [VasCloudProtocolsLeftSideBarView({id:this.Id})];
        }

    }
    else
    {
        if(App.SessionManager.IsRoleAdmin())
        {
            this.ProtocolsEditContextElements.unshift({
                view: "serverCombo",
                method: "GetCompanies",
                serverId: "company_id",
                serverValue: "name",
                id: this.Id + "ProtocolsEditContextFormCompany",
                name: "companies_company_id",
                labelWidth: 204,
                width: 460,
                label: LangHelper.GetString("Protocols","Company"),
                tooltip: LangHelper.GetString("Protocols","Company"),
                options: [],
                on:{
                    onChange: function(newVal, oldVal){
                        _this.Views.ProtocolsEditContextForm.elements.custom_number.disable();
                        setTimeout(function ()
                        {
                            _this.GetBusyCustomNumber(newVal);
                        }, 30);
                    }
                },
                required:true,
                validate: webix.rules.isNotEmpty,
                invalidMessage: LangHelper.GetString("Protocols", "Required field")
            });
        }

        if(_this.Id === _this.IdsEnum.VasCloudProtocolsCustom)
        {
            LeftSideBar = [
                ProtocolsLeftSideBarView({id:this.Id})
            ]
        }
    }

    this.GetBusyCustomNumber();

    this.ViewConfig = [
        {
            id:this.Id + "View",
            cols:function (){

                var cols = [];

                if (_this.Id === _this.IdsEnum.VasCloudProtocolsCustom)
                    cols.push({
                        hidden: App.SessionManager.IsModeDpiui2,
                        rows: LeftSideBar
                    })

                cols.push({
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:function ()
                            {
                                const rows = [];

                                if(_this.Id === _this.IdsEnum.UlrAppCustomProtocols)
                                    rows.push({height:6});

                                rows.push(
                                    {
                                        cols: header
                                    }
                                );

                                if(_this.Id === _this.IdsEnum.UlrAppCustomProtocols)
                                    rows.push({height:32});

                                rows.push(
                                    {
                                        id:this.Id + "accordion",
                                        view:"accordion",
                                        multi:true,
                                        cols:accordion
                                    }
                                );

                                return rows;
                            }()
                        }
                    ]
                })

                return cols;

            }()
        }
    ];

    this.ImportFilesArr = [];

    this.Subscriptions = {};

    this.Signals = {
        ImportedFilesCountChange: new Rx.BehaviorSubject(0)
    };
};

VasCloudProtocolsCustomViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets" && View != "PageHeaderWidget")
            _this.Views[View] = $$(_this.Id + View)
    });

    if (App.SessionManager.IsModeDpiui2)
    {
        App.WebSocketManager.Connect(this.SocketRoom);

        App.WebSocketManager.Connections[this.SocketRoom].on(this.EventUpdateHardwareStatus, function(data){
            var table = _this.Views.ReportsWidgets.HardwareReport.Views.Table;
            var item = JSON.parse(data);

            var row = table.find(function(Obj) {return Obj.hardware_id == item.hardware_id;});

            if (row && Array.isArray(row) && row.length == 1)
                table.updateItem(row[0].id, item);
        });

        this.Subscriptions.SignalIsLoggedIn = App.VasCloudSessionManager.SignalIsLoggedIn.subscribe(function (IsLoggedIn)
        {
            if(IsLoggedIn == null)
                return;

            if (IsLoggedIn)
            {
                _this.Views.View.enable();

                if(App.NavRouter.views.VasCloudLogin)
                {
                    App.NavRouter.views.VasCloudLogin.Hide();
                }
            }
            else
            {
                _this.Views.View.disable();
                App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
            }
        });

        App.VasCloudSessionManager.CheckLoggedIn();

        if(_this.Id === _this.IdsEnum.VasCloudProtocolsCustom)
            this.Views.PageHeaderWidget.BindAll(Params);
    }
    else
    {
        this.Views.Widgets.VasCloudUploadProtocolsWidget = new VasCloudUploadProtocolsWidget(this.ViewModel, this.Views.ProtocolsForcedUnloadingProtocolDirectoryBtn);
    }

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.HardwareEditContext = webix.ui(this.HardwareEditContext);
    this.Views.HardwareEditContext = webix.ui(this.HardwareEditContext);
    this.Views.HardwareEditContextForm = $$(this.Id+"HardwareEditContextForm");

    this.Views.ProtocolsUriHelperContext = webix.ui(this.ProtocolsUriHelperContext);
    this.Views.ProtocolsUriHelperContextForm = $$(this.Id+"ProtocolsUriHelperContextForm");
    this.Views.ProtocolsUriHelperContextFormLabel = $$(this.Id+"ProtocolsUriHelperContextFormLabel");

    this.Views.ProtocolsEditContext = webix.ui(this.ProtocolsEditContext);
    this.Views.ProtocolsEditContextForm = $$(this.Id+"ProtocolsEditContextForm");

    this.CreateProtocolsItemsEditContext(false);

    this.Views.ProtocolsItemsSniEditContext = webix.ui(this.ProtocolsItemsSniEditContext);
    this.Views.ProtocolsItemsSniEditContextForm = $$(this.Id+"ProtocolsItemsSniEditContextForm");
    this.Views.ProtocolsItemsSniEditContextFormUri = $$(this.Id+"ProtocolsItemsSniEditContextFormUri");
    this.Views.ProtocolsItemsSniEditContextFormGetBtn = $$(this.Id+"ProtocolsItemsSniEditContextFormGetBtn");
    this.Views.ProtocolsItemsSniEditContextFormSaveBtn = $$(this.Id+"ProtocolsItemsSniEditContextFormSaveBtn");
    this.Views.ProtocolsItemsSniEditContextFormTable = $$(this.Id+"ProtocolsItemsSniEditContextFormTable");

    this.Views.ProtocolsTrashContext = webix.ui(this.ProtocolsTrashContext);
    this.Views.ProtocolsTrashContextForm = $$(this.Id+"ProtocolsTrashContextForm");

    this.Views.ProtocolsItemsTrashContext = webix.ui(this.ProtocolsItemsTrashContext);
    this.Views.ProtocolsItemsTrashContextForm = $$(this.Id+"ProtocolsItemsTrashContextForm");

    this.Views.ProtocolsItems = $$(this.Id+"Items");

    this.Views.ProtocolsImportBtn = $$(this.Id + "ProtocolsImportBtn");
    this.Views.ProtocolsEnableBtn = $$(this.Id + "ProtocolsEnableBtn");
    this.Views.ProtocolsDisableBtn = $$(this.Id + "ProtocolsDisableBtn");
    this.Views.ProtocolsDeleteBtn = $$(this.Id + "ProtocolsDeleteBtn");
    this.Views.ProtocolsClearBtn = $$(this.Id + "ProtocolsClearBtn");

    this.Views.ProtocolsItemsToolbar = $$(this.Id + "Items" + "Toolbar");
    this.Views.ProtocolsItemsImportBtn = $$(this.Id + "ProtocolsItemsImportBtn");
    this.Views.ProtocolsItemsEnableBtn = $$(this.Id + "ProtocolsItemsEnableBtn");
    this.Views.ProtocolsItemsDisableBtn = $$(this.Id + "ProtocolsItemsDisableBtn");
    this.Views.ProtocolsItemsDeleteBtn = $$(this.Id + "ProtocolsItemsDeleteBtn");
    this.Views.ProtocolsItemsClearBtn = $$(this.Id + "ProtocolsItemsClearBtn");
    this.Views.ProtocolsItemsAddBtn = $$(this.Id + "ItemsAddBtn");

    this.Views.ProtocolsImportContextForm = $$(this.Id + "ProtocolsImportContextForm");
    this.Views.ProtocolsDuplicateContextForm = $$(this.Id + "ProtocolsDuplicateContextForm");
    this.Views.ProtocolsImportContextUploader = $$(this.Id + "ProtocolsImportContextUploader");
    this.Views.ProtocolsImportContextTable = $$(this.Id + "ProtocolsImportContextTable");
    this.Views.ProtocolsDuplicateContextTable = $$(this.Id + "ProtocolsDuplicateContextTable");
    this.Views.ProtocolsRowsLabel = $$(this.Id + "RowsLabel");
    this.Views.ProtocolsErrorItemsLabel = $$(this.Id + "ErrorItemsLabel");
    this.Views.ProtocolsInsertedItemsLabel = $$(this.Id + "InsertedItemsLabel");
    this.Views.ProtocolsInsertedItemsLabel = $$(this.Id + "InsertedItemsLabel");
    this.Views.ProtocolsDuplicatesLabel = $$(this.Id + "DuplicatesLabel");
    this.Views.ProtocolsIntersectionLabel = $$(this.Id + "IntersectionLabel");
    this.Views.ProtocolsDuplicatesDownloadFile = $$(this.Id + "DuplicatesDownloadFile");
    this.Views.ProtocolsErrorsDownloadFile = $$(this.Id + "ErrorsDownloadFile");

    this.Views.ProtocolsItemsImportContextForm = $$(this.Id + "ProtocolsItemsImportContextForm");
    this.Views.ProtocolsItemsImportContextUploader = $$(this.Id + "ProtocolsItemsImportContextUploader");
    this.Views.ProtocolsItemsImportContextTable = $$(this.Id + "ProtocolsItemsImportContextTable");

    this.Views.ProtocolsItemsFileImportContextForm = $$(this.Id + "ProtocolsItemsFileImportContextForm");
    this.Views.ProtocolsItemsFileImportContextUploader = $$(this.Id + "ProtocolsItemsFileImportContextUploader");
    this.Views.ProtocolsItemsFileImportContextTable = $$(this.Id + "ProtocolsItemsFileImportContextTable");

    //App.DicsManager.Refresh({data:[DicsEnum.CustomProtocolsTemplatesDic]});

    //Hardware
    this.Subscriptions.SaveHardware = this.ViewModel.Signals.SaveHardware.subscribe(function (Model) {
        if (Model)
        {
            var table = _this.Views.ReportsWidgets.HardwareReport.Views.Table;

            var row = table.find(function(Obj){
                return Obj.hardware_id == Model.hardware_id;
            });

            if (row && Array.isArray(row) && row.length == 1)
            {
                table.updateItem(row[0].id, Model);
            }else if (row.length == 0)
            {
                var id = table.add(Model, 0);
                table.select(id);
                table.getState();
            }

            webix.message(LangHelper.GetString("Protocols", "Hardware saved successfully"));
        }
    });
    this.Subscriptions.SaveHardwareError = this.ViewModel.Signals.SaveHardwareError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    //Protocols
    this.Subscriptions.ProtocolsTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.ProtocolsReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        var widgets = _this.Views.ReportsWidgets;
        var table = widgets.ProtocolsReport.Views.Table;
        var tableItems = widgets.ProtocolsItemsReport.Views.Table;
        var itemsToolbar = _this.Views.ProtocolsItemsToolbar;

        if (Value>0){
            table.hideOverlay();
            _this.RefreshItems();
            _this.Views.ProtocolsItems.enable();
            _this.Views.ProtocolsEnableBtn.enable();
            _this.Views.ProtocolsDisableBtn.enable();
            _this.Views.ProtocolsDeleteBtn.enable();
            if(_this.Views.ProtocolsCopyBtn)
            {
                _this.Views.ProtocolsCopyBtn.enable();
            }
            Value>1?itemsToolbar.disable():itemsToolbar.enable();

        }else {
            _this.Views.ProtocolsEnableBtn.disable();
            _this.Views.ProtocolsDisableBtn.disable();
            _this.Views.ProtocolsDeleteBtn.disable();
            _this.Views.ProtocolsItems.disable();
            if(_this.Views.ProtocolsCopyBtn)
            {
                _this.Views.ProtocolsCopyBtn.disable();
            }

            itemsToolbar.disable();
            tableItems.clearAll();

            if (!table.count())
                table.showOverlay(LangHelper.GetString("QoE","Data not found"));
        }
    });

    this.Subscriptions.SaveProtocol = this.ViewModel.Signals.SaveProtocol.subscribe(function (Model) {
        if (Model)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

            var row = table.find(function(Obj){
                return Obj._id == Model._id;
            });

            if (row && Array.isArray(row) && row.length == 1)
            {
                table.updateItem(row[0].id, Model);
            }else if (row.length == 0)
            {
                var id = table.add(Model, 0);
                table.select(id);
                table.getState();
            }

            webix.message(LangHelper.GetString("Protocols", "Protocol saved successfully"));

            _this.Views.ProtocolsEditContext.hide();
        }
    });
    this.Subscriptions.SaveProtocolError = this.ViewModel.Signals.SaveProtocolError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.DeleteProtocol = this.ViewModel.Signals.DeleteProtocol.subscribe(function (Model) {
        if (Model)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

            table.remove([table.getSelectedId()]);

            webix.message(LangHelper.GetString("Protocols", "Protocol deleted successfully"));

            _this.Views.ProtocolsTrashContext.hide();
        }
    });
    this.Subscriptions.DeleteProtocolError = this.ViewModel.Signals.DeleteProtocolError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.DeleteProtocols = this.ViewModel.Signals.DeleteProtocols.subscribe(function (RowIds) {
        if (RowIds)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

            if (RowIds == "erase")
            {
                table.clearAll();
                table.showOverlay(LangHelper.GetString("QoE","Data not found"));
                webix.message(LangHelper.GetString("Protocols", "Protocols erased successfully"));
                _this.ProtocolsEraseContext.hide();
            }else {
                table.remove(RowIds);
                webix.message(LangHelper.GetString("Protocols", "Protocols deleted successfully"));
                _this.ProtocolsDeleteContext.hide();
            }
        }
    });
    this.Subscriptions.DeleteProtocolsError = this.ViewModel.Signals.DeleteProtocolsError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.EnableProtocol = this.ViewModel.Signals.EnableProtocol.subscribe(function (Model) {
        if (Model)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

            table.find(function(obj){
                if (obj._id == Model._id){
                    table.updateItem(obj.id, Model);
                }
            });

            webix.message(LangHelper.GetString("Protocols", "Protocol enabled successfully"));
        }
    });
    this.Subscriptions.EnableProtocolError = this.ViewModel.Signals.EnableProtocolError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.DisableProtocol = this.ViewModel.Signals.DisableProtocol.subscribe(function (Model) {
        if (Model)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

            table.find(function(obj){
                if (obj._id == Model._id){
                    table.updateItem(obj.id, Model);
                }
            });

            webix.message(LangHelper.GetString("Protocols", "Protocol disabled successfully"));
        }
    });
    this.Subscriptions.DisableProtocolError = this.ViewModel.Signals.DisableProtocolError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.EnableProtocolItem = this.ViewModel.Signals.EnableProtocolItem.subscribe(function (Model) {
        if (Model)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table;

            table.find(function(obj){
                if (obj._id == Model._id){
                    table.updateItem(obj.id, Model);
                }
            });

            webix.message(LangHelper.GetString("Protocols", "Protocol Item enabled successfully"));
        }
    });
    this.Subscriptions.EnableProtocolItemError = this.ViewModel.Signals.EnableProtocolItemError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.DisableProtocolItem = this.ViewModel.Signals.DisableProtocolItem.subscribe(function (Model) {
        if (Model)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table;

            table.find(function(obj){
                if (obj._id == Model._id){
                    table.updateItem(obj.id, Model);
                }
            });

            webix.message(LangHelper.GetString("Protocols", "Protocol Item disabled successfully"));
        }
    });
    this.Subscriptions.DisableProtocolItemError = this.ViewModel.Signals.DisableProtocolItemError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Views.ProtocolsImportContextUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        _this.ImportExcelToProtocolsImportContextTable(FileObj.file);
    });


    
    this.Views.ProtocolsItemsFileImportContextUploader.attachEvent("onAfterFileAdd", function(FileObj){
        if(FileObj)
        {
            _this.OnFileAdded(FileObj);
        }
    });

    this.Subscriptions.ImportFilesCountChange = this.Signals.ImportedFilesCountChange.subscribe(function(Val)
    {
       _this.DefineImportFilesBtnBadge(Val);
    });

    this.Subscriptions.ProtocolsImportedItemsSaved = this.ViewModel.Signals.ProtocolsImportedItemsSaved.subscribe(function(Val)
    {
        _this.ImportFilesArr = [];

        _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();

        _this.RefreshItems();

        _this.Views.ProtocolsItemsImportBtn.define({badge: 0});

        _this.Views.ProtocolsItemsImportBtn.refresh();

        if (Val && (Val.data.duplicatesCount || (Val.data.insertCount - Val.data.insertedItemsCount) || Val.data.intersectionCount))
            _this.ShowDuplicates(Val, "import")

    });

    this.Subscriptions.ProtocolsImportedItemsSaveError = this.ViewModel.Signals.ProtocolsImportedItemsSaveError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    //Protocols Items
    this.Subscriptions.ProtocolsItemsTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.ProtocolsItemsReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        var widgets = _this.Views.ReportsWidgets;
        var table = widgets.ProtocolsItemsReport.Views.Table;

        if (Value>0){
            table.hideOverlay();
            _this.Views.ProtocolsItemsEnableBtn.enable();
            _this.Views.ProtocolsItemsDisableBtn.enable();
            _this.Views.ProtocolsItemsDeleteBtn.enable();
        }else{
            _this.Views.ProtocolsItemsEnableBtn.disable();
            _this.Views.ProtocolsItemsDisableBtn.disable();
            _this.Views.ProtocolsItemsDeleteBtn.disable();

            if (!table.count())
                table.showOverlay(LangHelper.GetString("QoE","Data not found"));
        }
    });

    this.Subscriptions.SaveProtocolItem = this.ViewModel.Signals.SaveProtocolItem.subscribe(function (Model) {
        if (Model)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table;

            var row = table.find(function(Obj){
                return Obj._id == Model._id;
            });

            if (row && Array.isArray(row) && row.length == 1)
            {
                table.updateItem(row[0].id, Model);
            }else if (row.length == 0)
            {
                var id = table.add(Model, 0);
                table.select(id);
                table.getState();
            }

            webix.message(LangHelper.GetString("Protocols", "Resource List saved successfully"));

            Helper.Table.ShowProgressButton(_this.Views.ProtocolsItemsEditContextFormSaveBtn, false);

            _this.Views.ProtocolsItemsEditContext.hide();
        }
    });
    this.Subscriptions.SaveProtocolItemError = this.ViewModel.Signals.SaveProtocolItemError.subscribe(function (Model) {
        if (Model)
        {
            Helper.Table.ShowProgressButton(_this.Views.ProtocolsItemsEditContextFormSaveBtn, false);

            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.DeleteProtocolItem = this.ViewModel.Signals.DeleteProtocolItem.subscribe(function (Model) {
        if (Model)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table;

            table.remove([table.getSelectedId()]);

            webix.message(LangHelper.GetString("Protocols", "Resource List deleted successfully"));

            _this.Views.ProtocolsItemsTrashContext.hide();
        }
    });
    this.Subscriptions.DeleteProtocolItemError = this.ViewModel.Signals.DeleteProtocolItemError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.DeleteProtocolsItems = this.ViewModel.Signals.DeleteProtocolsItems.subscribe(function (RowIds) {
        if (RowIds)
        {
            var table = _this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table;

            if (RowIds == "erase")
            {
                table.clearAll();
                table.showOverlay(LangHelper.GetString("QoE","Data not found"));
                webix.message(LangHelper.GetString("Protocols", "Protocols Items erased successfully"));
                _this.ProtocolsItemsEraseContext.hide();
            }else {
                table.remove(RowIds);
                webix.message(LangHelper.GetString("Protocols", "Protocols Items deleted successfully"));
                _this.ProtocolsItemsDeleteContext.hide();
            }
        }
    });
    this.Subscriptions.DeleteProtocolsItemsError = this.ViewModel.Signals.DeleteProtocolsItemsError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    // this.Views.ProtocolsItemsImportContextUploader.attachEvent("onAfterFileAdd", function(FileObj)
    // {
    //     _this.ImportExcelToProtocolsItemsImportContextTable(FileObj.file);
    // });

    this.Subscriptions.HideBtnsInNotEditableMode =  this.Editable.subscribe(function (Editable)
    {
        let editable = _this.EditableCustomPrtcls.getValue();
        if(!editable)
        {
            var views = _this.Views, viewsToHide = [
                views.ProtocolsForcedUnloadingProtocolDirectoryBtn
            ];

            viewsToHide.forEach(function (View){
                View.hide();
            });
        }
    });

    Helper.Table.ActivateCheckBox(this.Views.ReportsWidgets.ProtocolsReport.Views.Table);
    Helper.Table.ActivateCheckBox(this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table);

    if(!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())
    {
        this.Subscriptions.CopyProtocolsErrorSignal = this.ViewModel.Signals.CopyProtocolsError.subscribe(function(Model){
            if(Model)
                _this.ShowServerError(Model);
        });

        this.Subscriptions.CopyProtocolsSignal = this.ViewModel.Signals.CopyProtocols.subscribe(function (Value) {
            if (Value)
            {
                _this.ProtocolsCopyContext.hide();
                _this.Refresh();
                webix.message(LangHelper.GetString("Protocols", "Protocols copied successfully"));
            }
        });

        this.Subscriptions.ProcessCopyProtocols = this.ViewModel.Signals.ProcessCopyProtocols.subscribe(function(Val){
            if(Val)
            {
                _this.Views.ProtocolsCopyContextFormCopyBtn.disable();
            }
            else{
                _this.Views.ProtocolsCopyContextFormCopyBtn.enable();
            }
        });
    }
};

VasCloudProtocolsCustomViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    if (_this.Id === _this.IdsEnum.VasCloudProtocolsCustom)
    {
        webix.ready(function () {
            $$(_this.Id+"LeftSideBar").select(_this.Id);
        });
    }


    this.BindAll(Params);

    this.Refresh();

    if (App.SessionManager.IsModeDpiui2)
        this.RefreshHardwares();
};

VasCloudProtocolsCustomViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ViewHardwares)
    {
        this.ViewHardwares.Destroy();
        delete this.ViewHardwares;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if (App.SessionManager.IsModeDpiui2)
    {
        if(_this.Id === _this.IdsEnum.VasCloudProtocolsCustom)
            this.Views.PageHeaderWidget.Destroy();

        App.WebSocketManager.Disconnect(this.SocketRoom);
    }
};

VasCloudProtocolsCustomViewController.prototype.Refresh = function ()
{
    let tempFilter = Helper.Table.GetDateFiltersWithRefresh(this.Views.ReportsWidgets.ProtocolsReport, ['last_resource_update_time'], null, false);

    this.Views.ReportsWidgets.ProtocolsReport.RefreshData(null, {
        filter: {
            ...tempFilter
        }
    });
};

VasCloudProtocolsCustomViewController.prototype.RefreshItems = function ()
{
    var _this = this;

    clearTimeout(this.RefreshItemsTimeOut);

    this.RefreshItemsTimeOut = setTimeout(function ()
    {
        _this._RefreshItems();
    }, 100);
};

VasCloudProtocolsCustomViewController.prototype._RefreshItems = function ()
{
    var table = this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

    var getSelectedItems = table.getSelectedItem(true);

    var selectedItemsIds = [];

    getSelectedItems.forEach(function (item)
    {
        selectedItemsIds.push(parseInt(item._id));
    });

    this.Views.ReportsWidgets.ProtocolsItemsReport.RefreshData(0,{
        filter:{
            protocol_id:{
                id:"protocol_id",
                operator:"in",
                value:selectedItemsIds
            }
        }});
};

VasCloudProtocolsCustomViewController.prototype.RefreshHardwares = function ()
{
    this.Views.ReportsWidgets.HardwareReport.RefreshData();
};

VasCloudProtocolsCustomViewController.prototype.ShowServerError = function (ErrorModel)
{
    webix.message({text:ErrorModel.msg, type:"error", expire: 30000});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrorModel.msg,
        type:"alert-error",
        width:400
    });
};



/* Hardware */
VasCloudProtocolsCustomViewController.prototype.ShowHardwareEditForm = function (Data, Node, Pos)
{
    var form = this.Views.HardwareEditContextForm;

    form.clearValidation();

    form.setValues("");

    if(Data)
    {
        form.setValues(Data);
    }

    this.Views.HardwareEditContext.show(Node,{pos:Pos});
};

VasCloudProtocolsCustomViewController.prototype.SaveHardwareEditForm = function ()
{
    var form = this.Views.HardwareEditContextForm;

    if(!form.validate())
    {
        return;
    }

    var formData = form.getValues();

    this.ViewModel.SaveHardware(webix.extend(formData, true));
};



/* Protocol */
VasCloudProtocolsCustomViewController.prototype.ProtocolControl = function (Data)
{
    var _this = this;

    if(parseInt(Data.protocol_enabled) == 0)
    {
        setTimeout(function ()
        {
            _this.ViewModel.EnableProtocol({Protocol: new ProtocolModel(Data)});
        }, 10);
    }
    else
    {
        setTimeout(function ()
        {
            _this.ViewModel.DisableProtocol({Protocol: new ProtocolModel(Data)});
        }, 10);
    }
};

VasCloudProtocolsCustomViewController.prototype.ShowProtocolsEditForm = function (Data, Node, Pos)
{
    var form = this.Views.ProtocolsEditContextForm;

    form.clearValidation();

    form.setValues("");

    this.SelectCustom = null;

    if (!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())
    {
        this.SelectCompany = App.SessionManager.GetProfile().companies_company_id;
        var companies = form.elements.companies_company_id;
    }

    if(Data)
    {
        this.SelectCompany = Data.companies_company_id;
        this.SelectCustom = Data.custom_number;
        form.setValues(Data);
    }

    var CompanyId = companies?companies.getValue():null;

    this.GetBusyCustomNumber(CompanyId);

    this.Views.ProtocolsEditContext.show(Node,{pos:Pos});
};

VasCloudProtocolsCustomViewController.prototype.SaveProtocolsEditForm = function ()
{
    var form = this.Views.ProtocolsEditContextForm;

    if(!form.validate())
        return;

    form.elements.custom_number.disable();

    var formData = form.getValues();

    this.ViewModel.SaveProtocol(webix.extend(formData, true));
};

VasCloudProtocolsCustomViewController.prototype.GetProtocolsTableData = function ()
{
    return this.Views.ReportsWidgets.ProtocolsReport.Views.Table.serialize();
};

VasCloudProtocolsCustomViewController.prototype.GetProtocolsTableSelectedData = function ()
{
    return this.Views.ReportsWidgets.ProtocolsReport.Views.Table.getSelectedItem();
};

VasCloudProtocolsCustomViewController.prototype.DeleteProtocol = function ()
{
    this.ViewModel.DeleteProtocol(this.GetProtocolsTableSelectedData());
};

VasCloudProtocolsCustomViewController.prototype.GetBusyCustomNumber = function(CompanyId)
{
    var _this = this;

    this.ViewModel.GetBusyCustomNumber({CompanyId, callback:function (R)
        {
            if(R.success)
            {
                _this.CustomBusy = R.data;
                var customNumber = _this.Views.ProtocolsEditContextForm.elements.custom_number;
                customNumber.enable();
                customNumber.refresh();
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
};



/* Protocol Item */
VasCloudProtocolsCustomViewController.prototype.ProtocolItemControl = function (Data)
{
    var _this = this;

    if(parseInt(Data.item_enabled) == 0)
    {
        setTimeout(function ()
        {
            _this.ViewModel.EnableProtocolItem({Item: new ProtocolItemModel(Data)});
        }, 10);
    }
    else
    {
        setTimeout(function ()
        {
            _this.ViewModel.DisableProtocolItem({Item: new ProtocolItemModel(Data)});
        }, 10);
    }
};

VasCloudProtocolsCustomViewController.prototype.ShowProtocolsUriHelperForm = function (Data = null, Node, Pos)
{
    this.Views.ProtocolsUriHelperContextFormLabel.setValue(Data);
    //form.setValues({"protocol_id":this.GetProtocolsTableSelectedData()._id});
    this.Views.ProtocolsUriHelperContext.show(Node,{pos:Pos});
};

VasCloudProtocolsCustomViewController.prototype.ShowProtocolsItemsEditForm = function (Data, Node, Pos)
{
    this.CreateProtocolsItemsEditContext(Data?true:false);

    var form = this.Views.ProtocolsItemsEditContextForm;

    Helper.Table.ShowProgressButton(this.Views.ProtocolsItemsEditContextFormSaveBtn, false);

    form.clearValidation();

    form.setValues("");

    if(Data)
    {
        form.setValues(Data);
    }else{
        form.setValues({"protocol_id":this.GetProtocolsTableSelectedData()._id, "type":"auto"});
    }

    this.Views.ProtocolsItemsEditContext.show(Node,{pos:Pos});
};

VasCloudProtocolsCustomViewController.prototype.ShowProtocolsItemsCheckResourceForm = function (Node, Pos)
{
    var form = this.Views.ProtocolsItemsCheckResourceContextForm;

    Helper.Table.ShowProgressButton(this.Views.ProtocolsItemsCheckResourceEditContextFormSaveBtn, false);

    form.clearValidation();

    form.setValues("");

    form.setValues({"protocol_id":this.GetProtocolsTableSelectedData()._id, "type":"auto"});

    this.Views.ProtocolsItemsCheckResourceContext.show(Node,{pos:Pos});
};

VasCloudProtocolsCustomViewController.prototype.ShowProtocolsSniEditForm = function (Data, Node, Pos)
{
    Helper.Table.ShowProgressButton(this.Views.ProtocolsItemsSniEditContextFormSaveBtn, false);
    this.Views.ProtocolsItemsSniEditContextFormTable.clearAll();
    this.Views.ProtocolsItemsSniEditContextFormUri.setValue("");
    this.Views.ProtocolsItemsSniEditContextFormGetBtn.disable();
    this.Views.ProtocolsItemsSniEditContext.show(Node, {pos: Pos});
};

VasCloudProtocolsCustomViewController.prototype.ShowProtocolsItemsErrorValidationContext = function (Data, Node, Pos)
{
    this.Views.ProtocolsItemsErrorValidationContextEditor.setValue("");

    if(Data.validation_error)
    {
        var _this = this;
        this.ProtocolsItemsErrorValidationContext.show(Node,{pos:Pos});
        setTimeout(function(){
            _this.Views.ProtocolsItemsErrorValidationContextEditor.setValue(Data.validation_error);
        }, 10);
    }
};

VasCloudProtocolsCustomViewController.prototype.SaveProtocolsItemsEditForm = function ()
{
    let _this = this;

    let form = this.Views.ProtocolsItemsEditContextForm;

    if(!form.validate())
    {
        return;
    }

    let SaveBtn = this.Views.ProtocolsItemsEditContextFormSaveBtn;

    Helper.Table.ShowProgressButton(SaveBtn);

    let formData = form.getValues();

    if (formData._id)
    {
        this.ViewModel.SaveProtocolItem(webix.extend(formData, true));
        return;
    }

    let uri = [];

    formData.uri.split('\n').filter(value => value.length != 0).map(function (value){
        uri.push({type: formData.type, uri: value});
    });

    this.ViewModel.ImportProtocolItemList({ProtocolId: formData.protocol_id, Items: uri, callback:function (R)
    {
        if(R.success)
        {
            _this.RefreshItems();
            webix.message(LangHelper.GetString("Protocols","Items added successfully"));
            _this.Views.ProtocolsItemsEditContext.hide();
            if(R.data.duplicatesCount || (R.data.insertCount - R.data.insertedItemsCount) || R.data.intersectionCount)
                _this.ShowDuplicates(R, "save")
        }
        else if(R.error)
        {
            webix.message({text:R.error.msg,type:"error"});
        }

        Helper.Table.ShowProgressButton(SaveBtn, false);
    }});
};

VasCloudProtocolsCustomViewController.prototype.CheckResourcesItemsIntersectionForm = function ()
{
    let _this = this;

    let form = this.Views.ProtocolsItemsCheckResourceContextForm;

    if(!form.validate())
        return;

    let SaveBtn = this.Views.ProtocolsItemsCheckResourceEditContextFormSaveBtn;

    Helper.Table.ShowProgressButton(SaveBtn);

    let formData = form.getValues();
    let uri = [];

    formData.uri.split('\n').filter(value => value.length != 0).map(function (value){
        uri.push({type: formData.type, uri: value});
    });

    this.ViewModel.CheckResourcesItemsIntersection({Items: uri, SectionCheck: App.SessionManager.IsModeDpiui2, callback:function (R)
        {
            if(R.success)
            {
                _this.RefreshItems();
                webix.message(LangHelper.GetString("Protocols","Items checked successfully"));
                _this.Views.ProtocolsItemsCheckResourceContext.hide();
                if(R.data.intersectionCount)
                    _this.ShowDuplicates(R, "check")
            }
            else if(R.error)
            {
                webix.message({text:R.error.msg,type:"error"});
            }

            Helper.Table.ShowProgressButton(SaveBtn, false);
        }});
};

VasCloudProtocolsCustomViewController.prototype.SaveProtocolsItemsSniEditForm = function ()
{
    let _this = this;

    let Items = this.Views.ProtocolsItemsSniEditContextFormTable.serialize();

    if(!Items.length)
    {
        return;
    }

    let ProtocolId = this.Views.ReportsWidgets.ProtocolsReport.Views.Table.getSelectedItem()._id;

    let SaveBtn = this.Views.ProtocolsItemsSniEditContextFormSaveBtn;

    Helper.Table.ShowProgressButton(SaveBtn);

    this.ViewModel.ImportProtocolItemList({ProtocolId, Items, callback:function (R)
        {
            if(R.success)
            {
                _this.RefreshItems();
                webix.message(LangHelper.GetString("Protocols","Items added successfully"));
                _this.Views.ProtocolsItemsSniEditContext.hide();
            }
            else if(R.error)
                webix.message({text:R.error.msg,type:"error"});

            Helper.Table.ShowProgressButton(SaveBtn, false);
        }});
};

VasCloudProtocolsCustomViewController.prototype.GetProtocolsItemsTableSelectedData = function ()
{
    return this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table.getSelectedItem();
};

VasCloudProtocolsCustomViewController.prototype.DeleteProtocolItem = function ()
{
    var data = this.GetProtocolsItemsTableSelectedData();

    this.ViewModel.DeleteProtocolItem(data);
};



VasCloudProtocolsCustomViewController.prototype.CalcPort = function (Custom)
{
    var port = parseInt(Custom);
    if(port < 1 || port > 4096)
    {
        return null;
    }

    if(port <= 1024)
    {
        port += 53248;
    }
    else if(port <= 4096)
    {
        port += 55296 - 1024;
    }

    return port - 1;
    // var port = parseInt(Custom) + this.Port;
    // return port < this.PortStart ? this.PortStart : (port > this.PortEnd ? this.PortEnd : port);
};

VasCloudProtocolsCustomViewController.prototype.SetPort = function ()
{
    var custom = $$(this.Id + "ProtocolsEditContextFormNumber").getValue();

    $$(this.Id + "ProtocolsEditContextFormPort").setValue(this.CalcPort(custom));
};



VasCloudProtocolsCustomViewController.prototype.CheckAuthAndPresentView = function(Params)
{
    var _this = this;
    App.VasCloudSessionManager.CheckLoggedIn({
        callback:function (IsLoggedIn)
        {
            if(IsLoggedIn)
            {
                _this.Views.View.enable();

                if(App.NavRouter.views.VasCloudLogin)
                {
                    App.NavRouter.views.VasCloudLogin.Hide();
                }
            }
            else
            {
                App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
            }

        }
    });
};



VasCloudProtocolsCustomViewController.prototype.ProtocolsDeleteSelectedRows = function ()
{
    var _this = this;

    var selectedRows = this.GetProtocolsTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    var selectedRowIds = [];

    var selectedIds = selectedRows.map(function (obj) { selectedRowIds.push(obj.id); return obj._id; });

    this.ViewModel.DeleteProtocols(selectedIds, selectedRowIds);
};

VasCloudProtocolsCustomViewController.prototype.ProtocolsEnableDisable = function (Enable = true)
{
    let _this = this;

    let table = _this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

    let SelectedIds = Helper.Table.GetTableSelectedIds(table);
    let ProtocolsIds = SelectedIds.rowsIds;

    let params = {Enable, ProtocolsIds, callback:function (R)
        {
            if(R.success) {
                SelectedIds.tableRowsIds.forEach(function (id){
                    let item = table.getItem(id);
                    item.protocol_enabled = Enable?1:0;
                    table.updateItem(id, item);
                });
                webix.message(LangHelper.GetString("Protocols", Enable?"Protocols enabled successfully":"Protocols disabled successfully"));
            } else {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }};

    _this.ViewModel.EnableDisableProtocols(params);
};

VasCloudProtocolsCustomViewController.prototype.ProtocolsErase = function ()
{
    var _this = this;

    this.ViewModel.DeleteProtocols([], "erase");
};



VasCloudProtocolsCustomViewController.prototype.ProtocolsItemsDeleteSelectedRows = function ()
{
    var _this = this;

    var selectedRows = this.GetProtocolsItemsTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    var selectedProtocolsIds = [];

    var selectedRowIds = [];

    var selectedIds = selectedRows.map(function (obj) { selectedProtocolsIds.push(obj.protocol_id); selectedRowIds.push(obj.id); return obj._id; });

    this.ViewModel.DeleteProtocolsItems(selectedProtocolsIds, selectedIds, selectedRowIds);
};

VasCloudProtocolsCustomViewController.prototype.ProtocolItemsEnableDisable = function (Enable = true)
{
    let _this = this;

    let table = _this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table;

    let SelectedIds = Helper.Table.GetTableSelectedIds(table);
    let ItemsIds = SelectedIds.rowsIds;

    let params = {Enable, ItemsIds, callback:function (R)
        {
            if(R.success) {
                SelectedIds.tableRowsIds.forEach(function (id){
                    let item = table.getItem(id);
                    item.item_enabled = Enable?1:0;
                    table.updateItem(id, item);
                });
                webix.message(LangHelper.GetString("Protocols", Enable?"Protocol Items enabled successfully":"Protocol Items disabled successfully"));
            } else {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }};

    _this.ViewModel.EnableDisableProtocolItems(params);
};

VasCloudProtocolsCustomViewController.prototype.ProtocolsItemsErase = function ()
{
    var _this = this;

    var selectedRows = this.GetProtocolsTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    var selectedIds = selectedRows.map(function (obj) { return obj._id; });

    this.ViewModel.DeleteProtocolsItems(selectedIds, [], "erase");
};



VasCloudProtocolsCustomViewController.prototype.ShowProtocolsImportForm = function(Data, Node, Pos)
{
    if (!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())
    {
        var companyId = this.Views.ProtocolsImportContextForm.elements.company_id;

        var selectCompany = this.GetProtocolsTableSelectedData();
        var selectCompanyId = selectCompany&&selectCompany.companies_company_id?selectCompany.companies_company_id:App.SessionManager.GetProfile().companies_company_id;
        companyId.setValue(selectCompanyId);
        companyId.show();
    }

    var table = this.Views.ProtocolsImportContextTable;
    table.clearAll();
    Helper.Table.ClearTableFilters(table);

    this.ProtocolsImportContext.show(Node, {pos: Pos});
};

VasCloudProtocolsCustomViewController.prototype.GetProtocolsImportTemplate = function()
{
    let cols = {
        public_alias:true,
        custom_number:true,
        prod_enabled:true,
        description:true
    };

    if (!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())
        cols = Object.assign({company_name:true}, cols);

    webix.toExcel(this.Views.ProtocolsImportContextTable, {
        filename: LangHelper.GetString(this.Id,"Custom Protocols"),
        name: LangHelper.GetString(this.Id,"Custom Protocols"),
        filterHTML:true,
        columns:cols
    });
};

VasCloudProtocolsCustomViewController.prototype.ImportExcelToProtocolsImportContextTable = function(ExcelFile)
{
    var _this = this;

    var table = this.Views.ProtocolsImportContextTable;

    var ev = table.attachEvent("onAfterLoad",function()
    {
        table.detachEvent(ev);

        var data = table.serialize();

        var dataPrepared = [];

        data.forEach(function (Row)
        {
            if([LangHelper.GetString("Protocols","Name"), ""].includes(Row.public_alias) ||
               (!Number.isInteger(Row.custom_number) || Row.custom_number < _this.CustomStart || Row.custom_number > _this.CustomEnd) ||
               [LangHelper.GetString("Protocols","List type"), ""].includes(Row.prod_enabled))
                return;

            Row.public_alias = CellFormatTemplate(Row.public_alias, true, true, "-_", true, false, _this.Prefix);

            if (Helper.Table.NumbersOnly(Row.public_alias) || Row.public_alias == "" || Row.public_alias == _this.Prefix)
                return;

            var prod_enabled = 1;

            if(Row.prod_enabled == "0" || Row.prod_enabled == "test" || Row.prod_enabled == LangHelper.GetString("Protocols", "Test"))
                prod_enabled = 0;

            var row = {
                data0:Row.public_alias,
                data1:Row.custom_number,
                data2:prod_enabled,
                data3:Row.description
            };

            dataPrepared.push(row);
        });

        table.clearAll();
        table.parse(dataPrepared);

    });

    table.clearAll();
    table.parse(ExcelFile, "excel");

    setTimeout(function ()
    {
        if(table.hasEvent)
        {
            table.detachEvent(ev);
        }
    },3000);
};

VasCloudProtocolsCustomViewController.prototype.SaveProtocolsImportedExceldata = function()
{
    var _this = this;

    var table = this.Views.ProtocolsImportContextTable;

    var Protocols = table.serialize();

    var CompanyId;
    if(this.Views.ProtocolsImportContextForm.elements.company_id){
        CompanyId = this.Views.ProtocolsImportContextForm.elements.company_id.getValue();
    } else {
        let company =  App.VasCloudSessionManager.GetMyCompanyProfile();
        CompanyId = company.company_id;
    }

    this.ViewModel.ImportProtocolList({Protocols, CompanyId, callback:function (R)
        {
            if(R.success)
            {
                _this.Refresh();
                webix.message(LangHelper.GetString(_this.Id,"Imported successfully"));
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});

    table.clearAll();
};



// VasCloudProtocolsCustomViewController.prototype.ShowProtocolsItemsImportForm = function(Data, Node, Pos)
// {
//     var protocolId = this.Views.ProtocolsItemsImportContextForm.elements.protocol_id;
//     var protocols = this.GetProtocolsTableData().map(item => ({
//         id: item._id,
//         value: ((!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())?item.company_name + " | ":"") + CellFormatTemplate(item.public_alias, true, true, "-_", true)
//     }));
    
//     var protocolIdList = protocolId.getList();
//     protocolIdList.clearAll();
//     protocolIdList.parse(protocols);
    
//     var selectProtocol = this.GetProtocolsTableSelectedData();
//     var selectProtocolId = selectProtocol&&selectProtocol._id?selectProtocol._id:"";
//     protocolId.setValue(selectProtocolId);
    
//     var table = this.Views.ProtocolsItemsImportContextTable;
//     table.clearAll();
//     Helper.Table.ClearTableFilters(table);
    
//     this.ProtocolsItemsImportContext.show(Node, {pos: Pos});
// };

VasCloudProtocolsCustomViewController.prototype.ShowProtocolsItemsImportForm = function(Data, Node, Pos)
{
    this.ProtocolsItemsFileImportContext.show(Node, {pos: Pos});
    this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
}

VasCloudProtocolsCustomViewController.prototype.GetProtocolsItemsImportTemplate = function()
{
    webix.toExcel(this.Views.ProtocolsItemsImportContextTable, {
        filename: LangHelper.GetString(this.Id,"Custom Protocols Items"),
        name: LangHelper.GetString(this.Id,"Custom Protocols Items"),
        filterHTML:true,
        columns: {
            type:true,
            uri:true
        }
    });
};

VasCloudProtocolsCustomViewController.prototype.ImportExcelToProtocolsItemsImportContextTable = function(ExcelFile)
{
    var table = this.Views.ReportsWidgets.ProtocolsItemsReport.Views.Table;

    var ev = table.attachEvent("onAfterLoad",function()
    {
        table.detachEvent(ev);

        var data = table.serialize();

        var dataPrepared = [];

        data.forEach(function (Row)
        {
            Row.type = Row.type.toLowerCase();

            if(CustomProtocolsItemTypeDic[Row.type] === undefined ||
              [LangHelper.GetString("Protocols","Uri"), ""].includes(Row.uri))
                return;

            var row = {
                data0:Row.type,
                data1:Row.uri
            };

            dataPrepared.push(row);
        });

        table.clearAll();
        table.parse(dataPrepared);

    });

    table.clearAll();
    table.parse(ExcelFile, "excel");

    setTimeout(function ()
    {
        if(table.hasEvent)
        {
            table.detachEvent(ev);
        }
    },3000);
};

VasCloudProtocolsCustomViewController.prototype.SaveProtocolsItemsImportedExceldata = function()
{
    var _this = this;

    var form = this.Views.ProtocolsItemsImportContextForm;

    if(!form.validate())
        return;

    var table = this.Views.ProtocolsItemsImportContextTable;

    var Items = table.serialize();

    var ProtocolId = form.elements.protocol_id.getValue();

    this.ViewModel.ImportProtocolItemList({ProtocolId, Items, callback:function (R)
        {
            if(R.success)
            {
                _this.RefreshItems();
                webix.message(LangHelper.GetString(_this.Id,"Imported successfully"));
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});

    table.clearAll();

    this.ProtocolsItemsImportContext.hide();
};

VasCloudProtocolsCustomViewController.prototype.CreateProtocolsItemsEditContext = function (Edit)
{
    this.Views.ProtocolsItemsEditContext = webix.ui(this.ProtocolsItemsEditContext(Edit));
    this.Views.ProtocolsItemsEditContextForm = $$(this.Id+"ProtocolsItemsEditContextForm");
    this.Views.ProtocolsItemsEditContextFormSaveBtn = $$(this.Id+"ProtocolsItemsEditContextFormSaveBtn");
};

VasCloudProtocolsCustomViewController.prototype.ShowCustomProtocolsCopyForm = function(Node, Pos)
{
    var _this = this;
    this.Views.ProtocolsCopyContextForm.clear();
    _this.ProtocolsCopyContext.show(Node,{pos:Pos});
};

VasCloudProtocolsCustomViewController.prototype.CopyProtocls = function()
{
    var _this = this;
    var form = this.Views.ProtocolsCopyContextForm;

    if(!form.validate())
        return;

    var formData = form.getValues();

    var company_id = formData.company;

    var selected = this.GetProtocolsTableSelectedData();
    var arr = [];
    if(Array.isArray(selected))
    {
        selected.forEach(function(Val){
            arr.push(Val);
        });
    }
    else{
        arr.push(selected);
    }

    this.ViewModel.CopyProtocols({company_id: company_id, protocols: arr});
};

VasCloudProtocolsCustomViewController.prototype.GetPageTitle = function () {
    if (this.PageTitle)
        return this.PageTitle;
};

VasCloudProtocolsCustomViewController.prototype.OnFileAdded = function(FileObj)
{
    var _this = this;

    var path = "upload_files/";

    var fileName = webix.uid() + "_" + FileObj.name;
    var result_fpath = path + fileName;

    var model = {
        id: FileObj.id ? FileObj.id : webix.uid(),
        name: FileObj.name,
        size: FileObj.size,
        sizetext: FileObj.sizetext,
        state: FilesStatusDic.new.id,
        uploadId: '',
        // filepath: ''
        filepath: result_fpath
    };

    this.ImportFilesArr.push(model);

    var modelIndex = this.ImportFilesArr.findIndex((Obj) => Obj.id == model.id);

    this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
    // var path = "upload_files/";

    // var fileName = webix.uid() + "_" + model.name;
    // var result_fpath = path + fileName;

    var updateModelClosure = function(Model)
    {
        var modelIndex = _this.ImportFilesArr.findIndex((Obj) => Obj.id == Model.id);

        if(modelIndex > -1)
        {
            _this.ImportFilesArr[modelIndex] = Model;
            return true;
        }

        return false;
    };

    (App.SessionManager.IsModeDpiui2 ? App.ServerManager.VasCloudGenerateFileUploadId : App.ServerManager.GenerateFileUploadId)({
        fileName: fileName,
        path: path,
        callback: function(R)
        {
            if(R.success && R.data)
            {
                var key = R.data.key ? R.data.key : webix.uid();

                model.uploadId = key;
                model.state = FilesStatusDic.uploading.id;

                if(updateModelClosure(model))
                {
                    _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();

                    (App.SessionManager.IsModeDpiui2 ? App.ServerManager.VasCloudUploadFile : App.ServerManager.UploadFile)({
                        key: key,
                        file: FileObj.file,
                        callback: function(R)
                        {
                            if(R.status != 200)
                            {
                                model.state = FilesStatusDic.failed.id;
                            }
                            else
                            {
                                model.state = FilesStatusDic.uploaded.id;
                                model.filepath = result_fpath;
                            }

                            if(updateModelClosure(model))
                            {
                                _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                                _this.ImportFilesArrUpdated();
                            }
                        }
                    });
                }

            }
            else if(R.error)
            {
                model.state = FilesStatusDic.failed.id;
                if(updateModelClosure(model))
                {
                    _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                }
                _this.ShowServerError(R.error);
            }
        }
    });
};

VasCloudProtocolsCustomViewController.prototype.ImportFilesClick = function(Id)
{
    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.ImportedFilesReport.Views.Table;

        var item = table.getItem(Id);

        if(item)
        {
            const index = this.ImportFilesArr.findIndex(x => x.id == item.id);
            if(index > -1)
            {
                this.ImportFilesArr.splice(index, 1);
                this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                this.ImportFilesArrUpdated();

            }
        }

        table.remove(Id);
    }
};

VasCloudProtocolsCustomViewController.prototype.ImportFilesArrUpdated = function()
{
    var count = 0;
    this.ImportFilesArr.forEach((Item) => {
        if(Item.state == FilesStatusDic.uploaded.id)
        {
            count++;
        }
    });

    this.Signals.ImportedFilesCountChange.next(count);
};

VasCloudProtocolsCustomViewController.prototype.DefineImportFilesBtnBadge = function(Count)
{
    var count = Count > 99 ? "99+" : Count;

    this.Views.ProtocolsItemsImportBtn.define({badge: AppButtonBadgeTemplate(count)});

    this.Views.ProtocolsItemsImportBtn.refresh();
};

VasCloudProtocolsCustomViewController.prototype.SaveImportedFile = function()
{

    var table = this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

    var protocolId = table.getSelectedItem()._id;

    var importFiles = [];

    this.ImportFilesArr.forEach((Model) => {
            if(Model.filepath)
            {
                importFiles.push(Model.filepath);
            }
        });

    this.ViewModel.SaveProtocolsImportedItems({protocolId, importFiles});
};

VasCloudProtocolsCustomViewController.prototype.ShowDuplicates = function (Params, mode)
{
    let _this = this

    this.Views.ProtocolsItemsEditContext.hide();

    let prefixUrl = App.SessionManager.IsModeDpiui2 ? window.location.protocol + '//' + window.location.host + '/api/vascloud_file?fileUrl=' : "";

    let node = mode === "save" ?
        this.Views.ProtocolsItemsAddBtn.getNode() :
        (mode === "check" ? this.Views.ProtocolsItemsCheckResourcesBtn.getNode() : this.Views.ProtocolsItemsImportBtn.getNode());

    this.ProtocolsDuplicateContext.show(node, {pos: "left"});

    if (mode === "check")
    {
        this.Views.ProtocolsInsertedItemsLabel.hide();
        this.Views.ProtocolsDuplicatesLabel.hide();
        this.Views.ProtocolsErrorItemsLabel.hide();
    }
    else
    {
        this.Views.ProtocolsInsertedItemsLabel.show();
        this.Views.ProtocolsDuplicatesLabel.show();
        this.Views.ProtocolsErrorItemsLabel.show();
    }

    this.Views.ProtocolsRowsLabel.setValue(LangHelper.GetString("Protocols","Rows count: ") + Params.data.rowsCount);
    this.Views.ProtocolsInsertedItemsLabel.setValue(LangHelper.GetString("Protocols","Inserted items count: ") + Params.data.insertedItemsCount);
    this.Views.ProtocolsErrorItemsLabel.setValue(LangHelper.GetString("Protocols","Error items count: ") + "<a href="+prefixUrl + Params.data.errorsUrl+">"+(Params.data.insertCount - Params.data.insertedItemsCount)+"</a>" );
    this.Views.ProtocolsDuplicatesLabel.setValue(LangHelper.GetString("Protocols","Duplicates count: ") + "<a href="+prefixUrl + Params.data.duplicatesUrl+">"+Params.data.duplicatesCount+"</a>");
    this.Views.ProtocolsIntersectionLabel.setValue(LangHelper.GetString("Protocols","Intersections with the cloud list count: ") + "<a href="+prefixUrl + Params.data.intersectionUrl+">"+Params.data.intersectionCount+"</a>");
}
function VasCloudCustomProtocolsGroupsViewController(Params)
{
    var _this = this;

    this.IdsEnum = {
        VasCloudCustomProtocolsGroups: "VasCloudCustomProtocolsGroups",
        UlrAppGroupsCustomProtocols: "UlrAppGroupsCustomProtocols"
    };

    this.Id = Params && Params.Id ? Params.Id : this.IdsEnum.VasCloudCustomProtocolsGroups;

    this.PageTitle = Params&&Params.PageTitle?Params.PageTitle:{
        RootTitle: App.SessionManager.IsModeDpiui2?LangHelper.GetString("AppView", "VAS CLOUD"):LangHelper.GetString("AppView", "Protocols"),
        Title: LangHelper.GetString("CustomProtocolsGroups", "Custom protocols groups")
    };

    this.DicsMap = {
        "CustomPrtclsGroupsDic": DicsEnum.CustomPrtclsGroupsDic,
        "ProtocolsDic": App.SessionManager.IsModeDpiui2 ? DicsEnum.ProtocolsDic : DicsEnum.PrtclsDic,
        "CustomPrtclsDic": App.SessionManager.IsModeDpiui2 ? DicsEnum.VasCloudCustomPrtclsDic : DicsEnum.CustomPrtclsDic,
        "ProtocolsGroupsDic": App.SessionManager.IsModeDpiui2 ? DicsEnum.ProtocolsGroupsDicJson : DicsEnum.PrtclsGroupsDic
    }

    this.Editable = new Rx.BehaviorSubject(App.SessionManager.CheckUserRoleSection(App.SessionManager.IsModeDpiui2 ? RoleSectionsEnum.vascloud : RoleSectionsEnum.custom_protocols, true));

    this.ViewModel = new VasCloudCustomProtocolGroupsManager();

    this.ReportsModel = new UniReportsManager();

    this.VasCloudCustomProtocolsGroupsContextMenu = webix.ui({
        view:"submenu",
        id:this.Id + "CustomProtocolsGroupsContextMenu",
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.Id+"OverrideCloud", icon: "layer-group", value: LangHelper.GetString("CustomProtocolsGroups", "Override Cloud")},
            {id: this.Id+"NewGroup", icon: "layer-group", value: LangHelper.GetString("CustomProtocolsGroups","Create a new group")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                let __this = this;
                var node = __this.getNode(id);

                if(id === _this.Id+"OverrideCloud" || id === _this.Id+"NewGroup")
                {
                    _this.ShowAddCustomProtocolsGroupsForm(node, id);
                }
            }
        }
    });
    this.VasCloudCustomProtocolsGroupNamesContextMenu = webix.ui({
        view:"submenu",
        id:this.Id + "CustomProtocolsGroupNamesContextMenu",
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.Id+"CloudProtocol", icon: "network-wired", value: LangHelper.GetString("CustomProtocolsGroups", "Add cloud protocol")},
            {id: this.Id+"CustomProtocol", icon: "network-wired", value: LangHelper.GetString("CustomProtocolsGroups","Add custom protocol")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                let __this = this;
                var node = __this.getNode(id);

                if(id === _this.Id+"CloudProtocol" || id === _this.Id+"CustomProtocol")
                {
                    _this.ShowAddCustomProtocolsGroupNameForm(node, id);
                }
            }
        }
    });

    this.CustomPrtclsGroupsEditContext = webix.ui({
        view: "popup",
        id: this.Id + "GroupsEditContext",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "GroupsEditContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: function() {
                        const rows = [];

                        if (!App.SessionManager.IsModeDpiui2)
                        {
                            rows.push({
                                view: "serverCombo",
                                name: "companies_company_id",
                                id: _this.Id + "PrtclsGroupsCompanyId",
                                label: LangHelper.GetString("Users", "Company"),
                                options: [],
                                method: "GetCompanies",
                                serverId: "company_id",
                                serverValue: "name",
                                labelPosition: "top",
                                required: true,
                                invalidMessage: LangHelper.GetString("Users", "Enter the company"),
                                hidden: !App.SessionManager.IsRoleAdmin()
                            });
                        }

                        rows.push({
                            view: "richselect",
                            name: "code",
                            id: _this.Id + "PrtclsGroupsCloudProtocols",
                            label: LangHelper.GetString("CustomProtocolsGroups", "Cloud group"),
                            options: [],
                            labelPosition: "top",
                            required: true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage:LangHelper.GetString("Lics", "Required field"),
                            on: {
                                onChange: function (newVal, oldVal) {
                                    const arrDic = App.DicsManager.GetDicAsArray(_this.DicsMap["ProtocolsGroupsDic"]);

                                    for (const arrDicElement of arrDic) {
                                        if (newVal == arrDicElement.dic_id)
                                        {
                                            _this.Views.PrtclsGroupsLocales.setValue(arrDicElement.value);
                                        }
                                    }
                                }
                            }
                        })

                        rows.push(
                            {
                                id: _this.Id + "PrtclsGroupsLocales",
                                view: "InputLocal",
                                label: LangHelper.GetString("Protocols","Name"),
                                name:"name",
                                maxInputs: 16,
                                width: 400,
                                placeholder: LangHelper.GetString("Protocols","Name"),
                                required:true,
                                validate: webix.rules.isNotEmpty,
                                invalidMessage: LangHelper.GetString("Protocols", "Required field"),
                                tooltipHeight: 320
                            },
                            {height:24},
                            {
                                cols:[
                                    {},
                                    {
                                        view:"button",
                                        label:LangHelper.GetString("Protocols","Cancel"),
                                        click:function ()
                                        {
                                            _this.CustomPrtclsGroupsEditContext.hide();
                                        }
                                    },
                                    {
                                        view:"button",
                                        type:"form",
                                        label:LangHelper.GetString("Protocols","Save"),
                                        hotkey: "enter",
                                        click:function ()
                                        {
                                            _this.SaveGroupsEditForm();
                                        }
                                    }
                                ]
                            }
                        )

                        return rows;
                    }()
                }
            ]
        }
    });
    this.CustomPrtclsGroupNameEditContext = webix.ui({
        view: "popup",
        id: this.Id + "GroupsNameEditContext",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "GroupsNameEditContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: function() {
                        const rows = [];

                        rows.push({
                            view: "combo",
                            name: "protocol_id",
                            id: _this.Id + "GroupsNameEditContextFormCloudProtocol",
                            label: LangHelper.GetString("CustomProtocolsGroups", "Cloud protocol"),
                            options:  [], //App.DicsManager.GetDicAsArray(_this.DicsMap["ProtocolsDic"]),
                            labelPosition: "top",
                            required: true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage:LangHelper.GetString("Lics", "Required field")
                        })

                        rows.push({
                            view: "combo",
                            name: "custom_protocol_id",
                            id: _this.Id + "GroupsNameEditContextFormCustomProtocol",
                            label: LangHelper.GetString("CustomProtocolsGroups", "Custom protocol"),
                            options: [],
                            labelPosition: "top",
                            required: true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage:LangHelper.GetString("Lics", "Required field")
                        })

                        rows.push(
                            {
                                view: "combo",
                                name: "group_id",
                                id: _this.Id + "GroupsNameEditContextFormGroupId",
                                labelPosition: "top",
                                label: LangHelper.GetString("Protocols", "Group"),
                                tooltip:LangHelper.GetString("Protocols","Group"),
                                required:true,
                                validate: webix.rules.isNotEmpty,
                                options: [],
                                invalidMessage: LangHelper.GetString("Protocols", "Required field"),
                                on:{
                                    onChange: function (NewVal, OldVal) {
                                        if (NewVal)
                                        {
                                            let customPrtclsGroupsDic = App.DicsManager.GetDicAsArray(_this.DicsMap["CustomPrtclsGroupsDic"]);
                                            let main_dic = App.DicsManager.GetDicAsArray(_this.DicsMap["CustomPrtclsDic"]);

                                            for (const elem of customPrtclsGroupsDic)
                                            {
                                                if (NewVal == elem.id)
                                                {
                                                    let regex = /\(.*?\)/;

                                                    let result = elem.value.match(regex);

                                                    if (result)
                                                    {
                                                        let search_company = result[0];

                                                        let dic = main_dic.filter(item => {
                                                            return item.value.includes(search_company)
                                                        })

                                                        let list = _this.Views.GroupsNameEditContextFormCustomProtocol.getList();

                                                        list.clearAll();
                                                        list.parse(dic);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            {
                                height:24
                            },
                            {
                                cols:[
                                    {},
                                    {
                                        view:"button",
                                        label:LangHelper.GetString("Protocols","Cancel"),
                                        click:function ()
                                        {
                                            _this.CustomPrtclsGroupNameEditContext.hide();
                                        }
                                    },
                                    {
                                        view:"button",
                                        type:"form",
                                        label:LangHelper.GetString("Protocols","Save"),
                                        hotkey: "enter",
                                        click:function ()
                                        {
                                            _this.SaveGroupsNameEditForm();
                                        }
                                    }
                                ]
                            }
                        )

                        return rows;
                    }()
                }
            ]
        }
    });

    this.GroupsTrashContext = webix.ui({
        view:"popup",
        id: this.Id + "GroupsTrashContext",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Protocols","Are you sure you want to delete the selected records?")
                },
                {
                    height:24
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Protocols","Cancel"),
                            click:function ()
                            {
                                _this.Views.GroupsTrashContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "GroupsTrashContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString("Protocols","Delete"),
                            click:function ()
                            {
                                _this.Views.GroupsTrashContext.hide();

                                _this.DeleteGroups();
                            }
                        }
                    ]
                }
            ]
        }
    });
    this.GroupNameTrashContext = webix.ui({
        view:"popup",
        id: this.Id + "GroupNameTrashContext",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Protocols","Are you sure you want to delete the selected records?")
                },
                {
                  height:24
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Protocols","Cancel"),
                            click:function ()
                            {
                                _this.Views.GroupNameTrashContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "GroupNameTrashContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString("Protocols","Delete"),
                            click:function ()
                            {
                                _this.Views.GroupNameTrashContext.hide();

                                _this.DeleteGroupName();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.Views = {
        View: null,

        CustomProtocolsGroupsContextMenu: null,

        GroupsEditContext: null,
        GroupsEditContextForm: null,
        PrtclsGroupsLocales: null,
        PrtclsGroupsCompanyId: null,
        PrtclsGroupsCloudProtocols: null,

        GroupsNameEditContext: null,
        GroupsNameEditContextForm: null,
        GroupsNameEditContextFormCloudProtocol: null,
        GroupsNameEditContextFormCustomProtocol: null,
        GroupsNameEditContextFormGroupId: null,

        GroupsTrashContext: null,
        GroupNameTrashContext: null,

        NamesToolbar: null,

        Widgets:{},
        ReportsWidgets:{
            CustomGroupsReport: CustomProtocolsGroupsTableWidget({
                id:this.Id + "CustomGroupsReport",
                editable:this.Editable.getValue(),
                onItemClick:function (Id,e,node)
                {
                    var table = _this.Views.ReportsWidgets.CustomGroupsReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'edit':
                            _this.ShowGroupsEditForm(rowData, table.getItemNode(Id), "top", true);
                            break;
                        case 'trash':
                            _this.ShowGroupsTrashForm(rowData, table.getItemNode(Id), "bottom");
                            break;
                    }
                }
            }),
            NamesReport: CustomProtocolsGroupsNamesTableWidget({
                id:this.Id + "NamesReport",
                editable:this.Editable.getValue(),
                onItemClick:function (Id, E, Node)
                {
                    var table = _this.Views.ReportsWidgets.NamesReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'edit':
                            _this.ShowGroupsNameEditForm(rowData,
                                table.getItemNode(Id),
                                "right",
                                true,
                                rowData.protocol_type == "1" ? `${_this.Id}CloudProtocol` : `${_this.Id}CustomProtocol`
                            );
                            break;
                        case 'trash':
                            _this.ShowGroupsNameTrashForm(rowData, table.getItemNode(Id), "bottom");
                            break;
                    }
                }
            })
        }
    };

    var header = [
        PageHeaderTemplate({id:_this.Id + "PageTitle", root_title: _this.Id === _this.IdsEnum.UlrAppGroupsCustomProtocols ? _this.PageTitle.Title : _this.PageTitle.RootTitle, title: _this.Id === _this.IdsEnum.UlrAppGroupsCustomProtocols ? "" : _this.PageTitle.Title})
    ];

    var LeftSideBar = [];

    if(App.SessionManager.IsModeDpiui2)
    {
        if (!App.VasCloudSessionManager)
        {
            App.VasCloudSessionManager = new VasCloudSessionManager();
            App.VasCloudSessionManager.CheckLoggedIn();
        }

        if(_this.Id === _this.IdsEnum.VasCloudCustomProtocolsGroups)
            this.Views.PageHeaderWidget = new VasCloudPageHeaderWidget({id:this.Id + "PageHeaderWidget"});

        if(_this.Id === _this.IdsEnum.VasCloudCustomProtocolsGroups)
        {
            header.push(this.Views.PageHeaderWidget.ViewConfig);

            LeftSideBar = [VasCloudProtocolsLeftSideBarView({id:this.Id})];
        }

    }
    else
    {
        if(_this.Id === _this.IdsEnum.VasCloudCustomProtocolsGroups)
        {
            LeftSideBar = [ProtocolsLeftSideBarView({id:this.Id})]
        }
    }

    this.ViewConfig = [
        {
            id: `${_this.Id}View`,
            cols: function()
            {
                const cols = [];

                if (_this.Id === _this.IdsEnum.VasCloudCustomProtocolsGroups)
                    cols.push({
                        hidden: App.SessionManager.IsModeDpiui2,
                        rows: LeftSideBar
                    })

                cols.push(
                    {
                        type: "space",
                        rows: [
                            {
                                type: "clear",
                                borderless: true,
                                rows: function(){
                                    var rows = [];
                                    if(_this.Id === _this.IdsEnum.UlrAppGroupsCustomProtocols)
                                    {
                                        rows.push({height: 6});
                                    }
                                    rows.push({
                                        cols: header
                                    });

                                    if(_this.Id === _this.IdsEnum.UlrAppGroupsCustomProtocols)
                                    {
                                        rows.push({height: 32});
                                    }

                                    rows.push({
                                        id:_this.Id + "accordion",
                                        view:"accordion",
                                        multi:true,
                                        cols:function(){
                                            var res = [
                                                {
                                                    gravity: 2,
                                                    header:LangHelper.GetString("Protocols","Groups"),
                                                    body:{
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                height:webix.skin.$active.rowHeight,
                                                                padding: 0,
                                                                margin: 0,
                                                                elements: [
                                                                    {
                                                                        view: "button",
                                                                        id:_this.Id + "AddGroupBtn",
                                                                        type: "icon",
                                                                        icon: "plus",
                                                                        align: "right",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Protocols","Add list item"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ShowCustomProtocolsGroupsContextMenu(this.getNode(), {pos:"right"});
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id:_this.Id+"ListItemsRefreshBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshGroups();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            _this.Views.ReportsWidgets.CustomGroupsReport.ViewConfig
                                                        ]
                                                    }
                                                },
                                                { view:"resizer" },
                                                {
                                                    gravity: 3,
                                                    header: LangHelper.GetString("Protocols","Protocols"),
                                                    body:{
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                id:_this.Id + "NamesToolbar",
                                                                height:webix.skin.$active.rowHeight,
                                                                padding: 0,
                                                                margin: 0,
                                                                elements: [
                                                                    {
                                                                        view: "button",
                                                                        id:_this.Id + "AddNameBtn",
                                                                        type: "icon",
                                                                        icon: "plus",
                                                                        align: "right",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Protocols","Add list item"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ShowCustomProtocolsGroupNamesContextMenu(this.getNode(), {pos:"right"});
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id: _this.Id + "NameRefreshBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("All", "Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshNames();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            _this.Views.ReportsWidgets.NamesReport.ViewConfig
                                                        ]
                                                    }

                                                },
                                            ];

                                            return res;
                                        }()
                                    });

                                    return rows;
                                }()
                            }
                        ]
                    }
                )

                return cols;
            }()
        }
    ];

    this.Subscriptions = {};
}

VasCloudCustomProtocolsGroupsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets" && View != "PageHeaderWidget")
            _this.Views[View] = $$(_this.Id + View)
    });

    if (App.SessionManager.IsModeDpiui2)
    {
        this.Subscriptions.SignalIsLoggedIn = App.VasCloudSessionManager.SignalIsLoggedIn.subscribe(function (IsLoggedIn)
        {
            if(IsLoggedIn == null)
                return;

            if (IsLoggedIn)
            {
                _this.Views.View.enable();

                if(App.NavRouter.views.VasCloudLogin)
                {
                    App.NavRouter.views.VasCloudLogin.Hide();
                }
            }
            else
            {
                _this.Views.View.disable();
                App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
            }
        });

        App.VasCloudSessionManager.CheckLoggedIn();

        if(_this.Id === _this.IdsEnum.VasCloudCustomProtocolsGroups)
            this.Views.PageHeaderWidget.BindAll(Params);
    }

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.SignalPrtclsGroupsDic = App.DicsManager.Signal[this.DicsMap["ProtocolsGroupsDic"]].subscribe(function (Value)
    {
        if(Value)
        {
            const lang = LangHelper.GetLocale();

            const arrDic = App.DicsManager.GetDicAsArray(_this.DicsMap["ProtocolsGroupsDic"]);

            const dic = JSON.parse(JSON.stringify(arrDic));

            var dic_filtered = [];

            dic.forEach(function (obj)
            {
                var name = obj.value;

                var id = obj.id;

                if (typeof name === "string")
                {
                    obj.value = name;
                }
                else
                {
                    obj.value = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
                }

                //Filter only cloud groups
                if(obj.dic_id < 1000)
                {
                    dic_filtered.push(obj);
                }
            });

            var list = _this.Views.PrtclsGroupsCloudProtocols.getList();

            list.clearAll();
            list.parse(dic_filtered);
        }
    });

    this.Subscriptions.CustomGroupsTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.CustomGroupsReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        var tableNames = _this.Views.ReportsWidgets.NamesReport.Views.Table;
        var tableGroups = _this.Views.ReportsWidgets.CustomGroupsReport.Views.Table;
        var toolbar = _this.Views.NamesToolbar;

        if (Value>0){
            _this.RefreshNames();
            toolbar.enable();
            tableNames.enable();
        }
        else
        {
            toolbar.disable();
            tableNames.disable();
            setTimeout(function () {
                if (!_this.Views.ReportsWidgets.CustomGroupsReport.TableRowsSelectedCount.getValue())
                    tableNames.clearAll();
            }, 300)
        }

        let selected = _this.Views.ReportsWidgets.CustomGroupsReport.Views.Table.getSelectedItem();

        if (!Array.isArray(selected))
            selected = selected?[selected]:[];

        const lang = LangHelper.GetLocale();

        _this.Views.ReportsWidgets.NamesReport.Views.Table.getColumnConfig("group_name_json").header[1].options = selected.map(item => {
            var name = JSON.parse(item.name_json);
            let local = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);

            return {
                id: item._id,
                value: local + (!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin() ? `(${item.company_name})` : '')
            }
        });
    });

    App.DicsManager.Refresh(
        {
            data:
                [
                    this.DicsMap["CustomPrtclsGroupsDic"],
                    this.DicsMap["ProtocolsDic"],
                    this.DicsMap["CustomPrtclsDic"],
                    this.DicsMap["ProtocolsGroupsDic"]
                ]
        }
    );

    Helper.Table.ActivateCheckBox(_this.Views.ReportsWidgets.CustomGroupsReport.Views.Table);
    Helper.Table.ActivateCheckBox(_this.Views.ReportsWidgets.NamesReport.Views.Table);
};

VasCloudCustomProtocolsGroupsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    if (_this.Id === _this.IdsEnum.VasCloudCustomProtocolsGroups)
    {
        webix.ready(function () {
            $$(_this.Id+"LeftSideBar").select(_this.Id);
        });
    }

    this.BindAll(Params);

    this.RefreshGroups();
};

VasCloudCustomProtocolsGroupsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if (App.SessionManager.IsModeDpiui2)
    {
        if(_this.Id === _this.IdsEnum.VasCloudCustomProtocolsGroups)
            this.Views.PageHeaderWidget.Destroy();
    }
};

VasCloudCustomProtocolsGroupsViewController.prototype.RefreshGroups = function ()
{
    this.Views.ReportsWidgets.CustomGroupsReport.RefreshData();
};

VasCloudCustomProtocolsGroupsViewController.prototype.ShowCustomProtocolsGroupsContextMenu = function (node, pos)
{
    this.VasCloudCustomProtocolsGroupsContextMenu.show(node, pos);
};

VasCloudCustomProtocolsGroupsViewController.prototype.ShowCustomProtocolsGroupNamesContextMenu = function (node, pos)
{
    this.VasCloudCustomProtocolsGroupNamesContextMenu.show(node, pos);
};

VasCloudCustomProtocolsGroupsViewController.prototype.ShowAddCustomProtocolsGroupsForm = function (node, id)
{
    const _this = this;

    var model = new VasCloudCustomProtocolGroupsFormModel();

    _this.ShowGroupsEditForm(model, node, "right", false, id);
};

VasCloudCustomProtocolsGroupsViewController.prototype.ShowAddCustomProtocolsGroupNameForm = function (node, id)
{
    const _this = this;

    var model = new VasCloudCustomProtocolGroupNameFormModel();

    _this.ShowGroupsNameEditForm(model, node, "right", false, id);
};

VasCloudCustomProtocolsGroupsViewController.prototype.SaveGroupsEditForm = function ()
{
    var _this = this;

    var form = this.Views.GroupsEditContextForm;

    if(!form.validate())
    {
        return;
    }

    var formData = form.getValues();

    if (App.SessionManager.IsRoleAdmin())
        formData.company_id = formData.companies_company_id;

    this.ViewModel.Save({data: webix.extend(formData, true), callback: (R) => {
            if(R.success)
            {
                _this.VasCloudCustomProtocolsGroupsContextMenu.hide()
                _this.CustomPrtclsGroupsEditContext.hide();
                _this.RefreshGroups();

                webix.message(LangHelper.GetString("Protocols", "Group saved successfully"));

                App.DicsManager.Refresh({data:[_this.DicsMap["CustomPrtclsGroupsDic"]]});
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
};

VasCloudCustomProtocolsGroupsViewController.prototype.SaveGroupsNameEditForm = function (Context)
{
    var _this = this;

    var form = this.Views.GroupsNameEditContextForm;

    if(!form.validate())
    {
        return;
    }

    var formData = form.getValues();

    this.ViewModel.SaveGroupName({data: webix.extend(formData, true), callback: (R) => {
            if(R.success)
            {
                _this.VasCloudCustomProtocolsGroupNamesContextMenu.hide();
                _this.CustomPrtclsGroupNameEditContext.hide();
                _this.RefreshNames();

                webix.message(LangHelper.GetString("Protocols", "Protocol saved successfully"));
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
};

VasCloudCustomProtocolsGroupsViewController.prototype.ShowGroupsEditForm = function (Data, Node, Pos, isEdit = false, id = null)
{
    var _this = this;

    this.Views.GroupsEditContextForm.clear();

    if(Data)
    {
        var formParams = new VasCloudCustomProtocolGroupsFormModel(Data);

        if (Data.code != 0)
            if (formParams && formParams["name_json"])
            {
                formParams["name"] = JSON.parse(formParams["name_json"]);
            }else{
                formParams["name"] = {en:formParams["name"]};
            }
        else
            formParams["name"] = {en: ""};

        if (App.SessionManager.IsRoleAdmin())
        {
            if (isEdit)
            {
                formParams.companies_company_id = formParams.company_id;
            }
            else
            {
                formParams.companies_company_id = App.SessionManager.GetProfile().companies_company_id;
            }
        }

        this.Views.GroupsEditContextForm.clearValidation();

        this.Views.GroupsEditContextForm.setValues(formParams);
    }

    if (!App.SessionManager.IsModeDpiui2)
    {
        if (App.SessionManager.IsRoleAdmin() && !isEdit)
        {
            this.Views.PrtclsGroupsCompanyId.show();
        }
        else
        {
            this.Views.PrtclsGroupsCompanyId.hide();
        }
    }

    if (id === _this.Id + "OverrideCloud")
    {
        this.Views.PrtclsGroupsCloudProtocols.show();
    }
    else
    {
        this.Views.PrtclsGroupsCloudProtocols.hide();
    }

    this.Views.GroupsEditContext.show(Node,{pos:Pos});
};

VasCloudCustomProtocolsGroupsViewController.prototype.ShowGroupsNameEditForm = function (Data, Node, Pos, isEdit = false, id = null)
{
    var _this = this;

    this.Views.GroupsNameEditContextForm.clear();
    this.Views.GroupsNameEditContextFormGroupId.enable();

    if(Data)
    {
        var formParams = new VasCloudCustomProtocolGroupNameFormModel(Data);

        if (id == `${_this.Id}CloudProtocol`)
        {
            this.Views.GroupsNameEditContextFormCustomProtocol.hide();
            this.Views.GroupsNameEditContextFormCloudProtocol.show();

            let prtcls_dic = App.DicsManager.GetDicAsArray(_this.DicsMap["ProtocolsDic"]);

            var dic_filtered = [];

            prtcls_dic.forEach(function (obj)
            {
                //Filter only cloud protocols
                if(obj.value.indexOf('cp_') === -1)
                {
                    dic_filtered.push(obj);
                }
            });


            let list = this.Views.GroupsNameEditContextFormCloudProtocol.getList();
            list.clearAll();
            list.parse(dic_filtered);
        }
        else
        {
            this.Views.GroupsNameEditContextFormCustomProtocol.show();
            this.Views.GroupsNameEditContextFormCloudProtocol.hide();
        }

        const lang = LangHelper.GetLocale();
        const customPrtclsGroupsDic = JSON.parse(JSON.stringify(App.DicsManager.GetDicAsArray(_this.DicsMap["CustomPrtclsGroupsDic"])));
        let
            filter_dic = [],
            selected = [];

        customPrtclsGroupsDic.forEach(function (obj){
            var name = obj.value;
            if (typeof name === "string")
            {
                obj.value = name;
            }
            else
            {
                obj.value = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
            }
        });

        if (isEdit)
        {
            selected = _this.Views.ReportsWidgets.NamesReport.Views.Table.getSelectedItem();

            let search_company = `(${selected.company_name})`;

            filter_dic = customPrtclsGroupsDic.filter(item => {
                return item.value.includes(search_company)
            })
        }
        else
        {
            selected = _this.Views.ReportsWidgets.CustomGroupsReport.Views.Table.getSelectedItem();

            if (!Array.isArray(selected))
                selected = selected?[selected]:[];

            let search_company = selected.map(item => item._id);

            filter_dic = customPrtclsGroupsDic.filter(item => {
                return search_company.includes(item.id);
            })
        }

        let list = this.Views.GroupsNameEditContextFormGroupId.getList();
        list.clearAll();
        list.parse(filter_dic);

        if (!isEdit)
        {
            if (selected.length === 1)
                this.Views.GroupsNameEditContextFormGroupId.disable();

            if (filter_dic)
                formParams.group_id = selected.length === 1 ? selected[0]._id : filter_dic[0].id;
        }

        this.Views.GroupsNameEditContextForm.clearValidation();

        if (isEdit && id == `${_this.Id}CustomProtocol`)
        {
            formParams.custom_protocol_id = formParams.protocol_id;
            formParams.protocol_id = null;
        }

        this.Views.GroupsNameEditContextForm.setValues(formParams);
    }

    if (isEdit)
    {
        this.Views.GroupsNameEditContextFormCustomProtocol.hide();
        this.Views.GroupsNameEditContextFormCloudProtocol.hide();
    }

    this.Views.GroupsNameEditContext.show(Node,{pos:Pos});
};

VasCloudCustomProtocolsGroupsViewController.prototype.ShowGroupsTrashForm = function (Data, Node, Pos)
{
    var _this = this;

    this.Views.GroupsTrashContext.show(Node,{pos:Pos});
};

VasCloudCustomProtocolsGroupsViewController.prototype.ShowGroupsNameTrashForm = function (Data, Node, Pos)
{
    var _this = this;

    this.Views.GroupNameTrashContext.show(Node,{pos:Pos});
};

VasCloudCustomProtocolsGroupsViewController.prototype.DeleteGroups = function (Model)
{
    var _this = this;

    var table = _this.Views.ReportsWidgets.CustomGroupsReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    this.ViewModel.Delete({data: webix.extend(data, true), callback: (R) => {
            if(R.success)
            {
                webix.message(LangHelper.GetString("Protocols", "Group deleted successfully"));
                _this.RefreshGroups();
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
};

VasCloudCustomProtocolsGroupsViewController.prototype.DeleteGroupName = function (Model)
{
    var _this = this;

    var table = _this.Views.ReportsWidgets.NamesReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    this.ViewModel.DeleteGroupName({data: webix.extend(data, true), callback: (R) => {
            if(R.success)
            {
                webix.message(LangHelper.GetString("Protocols", "Protocol deleted successfully"));
                _this.RefreshNames();
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }});
};

VasCloudCustomProtocolsGroupsViewController.prototype.RefreshNames = function ()
{
    var _this = this;

    clearTimeout(this.NamesRefreshTimeOut);

    this.NamesRefreshTimeOut = setTimeout(function ()
    {
        _this._RefreshNames();
    }, 100);
};

VasCloudCustomProtocolsGroupsViewController.prototype._RefreshNames = function ()
{
    var tableGroups = this.Views.ReportsWidgets.CustomGroupsReport.Views.Table;

    var getGroups = tableGroups.getSelectedItem(true);

    var GroupsIds = [];

    getGroups.forEach(function (group)
    {
        GroupsIds.push(parseInt(group._id));
    });

    this.Views.ReportsWidgets.NamesReport.RefreshData(null,{
        filter:{
            group_id:{
                id:"group_id",
                operator:"in like",
                value:GroupsIds
            }
        }});
};

VasCloudCustomProtocolsGroupsViewController.prototype.GetPageTitle = function () {
    if (this.PageTitle)
        return this.PageTitle;
};
var CustomProtocolsGroupsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"CustomProtocolsGroupsTableWidget",
        sortDisabledColumns:["checkbox", "trash"],
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return (!App.SessionManager.IsModeDpiui2 && App.SessionManager.IsRoleAdmin())?"AdminGetCustomProtocolsGroups":"GetMyCustomProtocolsGroups";
            },
            sort:{id:"_id",dir:"asc"}
        },
        columns: function ()
        {
            const cols = [];

            cols.push(
                { id:"checked", header:["",{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}], template: CellColoredCheckBoxTemplate, width:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? 40 : 32},
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate },
            )

            if (App.SessionManager.IsRoleAdmin() && !App.SessionManager.IsModeDpiui2)
            {
                cols.push({
                    id: "company_name",
                    header: [TooltipTemplate(LangHelper.GetString("VasAds","Company name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    sort: "string",
                    fillspace: 2
                })
            }

            cols.push(
                {
                    id:"code",
                    fillspace:true,
                    header:[LangHelper.GetString("CustomProtocolsGroups","Group code"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    template:function(obj, common, val)
                    {
                        return val ? val.toString().toLowerCase() : ""
                    }
                },
                { id:"name_json", template:function(obj){
                        const lang = LangHelper.GetLocale();
                        let local;

                        if (obj && obj.name_json)
                        {
                            var name = JSON.parse(obj.name_json);
                            local = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
                        }
                        else
                        {
                            local = obj.name;
                        }

                        return local;
                    },
                    fillspace:true,
                    header:[LangHelper.GetString("CustomProtocolsGroups","Group name"),
                        {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                    ]},
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate}

            );

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var CustomProtocolsGroupsNamesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.protocol?Params.protocol:"ProtocolsNamesTableWidget",
        enableCheckboxRefresh:true,
        sortDisabledColumns:["checkbox", "trash"],
        config:{
            method:function ()
            {
                return "GetCustomProtocolsGroupNamesListReport";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            const cols = [];

            cols.push({ id:"checked", header:["", {content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}], template: CellColoredCheckBoxTemplate, width:typeof SkinHelper != "undefined" && SkinHelper.IsFilterUiSkin() ? 40 : 32},
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate },
                {
                    id:"protocol_name",
                    fillspace:true,
                    header:[LangHelper.GetString("CustomProtocolsGroups","Protocol"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    template:function(obj, common, val)
                    {
                        return val ? val.toString().toLowerCase() : ""
                    }
                },
                {
                    id:"protocol_type",
                    fillspace:true,
                    header:[LangHelper.GetString("CustomProtocolsGroups","Protocol type"), {
                        content: "multiSelectFilter",
                        options: Helper.DictToArr(ProtocolTypeDic),
                        inputConfig: {suggest: {fitMaster: false}}
                    }],
                    template:function(obj, common, val)
                    {
                        if (obj.protocol_type == 1)
                        {
                            return ProtocolTypeDic["1"].value;
                        }
                        else
                        {
                            return ProtocolTypeDic["2"].value;
                        }
                    }
                },
                {
                    id:"group_name_json",
                    template:function(obj){
                        var lang = LangHelper.GetLocale();
                        if (obj && obj.group_name_json)
                        {
                            var name = JSON.parse(obj.group_name_json);
                            var local = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
                        }
                        else
                        {
                            var local = obj.name;
                        }
                        return local;
                    },
                    fillspace:true,
                    header:[LangHelper.GetString("Protocols","Group"),
                        {
                            content: "multiSelectFilter",
                            options: [],
                            inputConfig: {suggest: {fitMaster: false}}
                        }] }
            );

            if (App.SessionManager.IsRoleAdmin())
            {
                cols.push(
                    {
                        id: "company_name",
                        header: [TooltipTemplate(LangHelper.GetString("VasAds","Company name")), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                        sort: "string",
                        fillspace: 2,
                    }
                );
            }

            cols.push(
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate}
            );

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on: {}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

function CgNatServiceViewController(Params)
{
    var _this = this;

    this.Id = "CgNatService";
    this.id = this.Id;

    this.ViewModel = new CgNatManager();
    this.SubscribersManager = new HardwareSubscribersManager();

    this.ProfilesTableRowsSelectedCount = new Rx.BehaviorSubject(0);
    this.CheckLicenseChanged = new Rx.BehaviorSubject(0);

    this.ProfileDeleteContext = webix.ui({
        view:"popup",
        width:340,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the profile?")
                        + "<br/><br/>" +  "<span style='color: red'>"
                        + LangHelper.GetString(this.Id, "All subscribers associated with this profile will be unsubscribed from the CG NAT service.")
                        + "</span>"
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ProfileDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProfileDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ProfileDeleteContext.hide();

                                var selected = _this.GetProfilesTableSelectedData();

                                if(selected)
                                    _this.DeleteProfile(selected.id);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateProfileContextConfig = {
        view: "popup",
        id: this.Id + "CreateProfileContext",
        width: 440,
        height: 480,
        body: {
            rows: [
                {
                    id: this.Id + "CreateProfileContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    on:{
                        onValidationError:function(key, obj){
                            // text = "Login can't be empty";
                            // webix.message({ type:"error", text:text });
                        }
                    },
                    elements: [
                        BlockHeaderTemplate({
                            title: LangHelper.GetString(this.Id, "CGNAT profile"),
                            icon: "file"
                        }),
                        {
                            view: "text",
                            name: "title",
                            labelWidth: 200,
                            required: true,
                            label: LangHelper.GetString(this.Id, "Description"),
                            tooltip: LangHelper.GetString(this.Id, "Profile title / description")
                        },
                        {
                            id: this.Id + "ProfileType",
                            view: "richselect",
                            name: "nat_type",
                            labelWidth: 200,
                            label: LangHelper.GetString(this.Id, "Type"),
                            tooltip: LangHelper.GetString(this.Id, "Type: default or 1:1"),
                            options: Helper.DictToArr(CgNatTypesDic),
                            // required: true,
                            value: 0
                        },
                        {
                            view: "textarea",
                            name: "nat_ip_pool",
                            label: LangHelper.GetString(this.Id, "Nat IP pool"),
                            labelWidth: 200,
                            height: 150,
                            tooltip: LangHelper.GetString(this.Id, "External IP address range in CIDR format"),
                            invalidMessage: LangHelper.GetString(this.Id, "IP pool is incorrect"),
                            required: true,
                            validate: function (Val) {
                                if(!Val)
                                {
                                    return false;
                                }

                                var arr = Val.split(",");
                                for(var i in arr)
                                {
                                    if(!Helper.ValidateCgNatCIDR(arr[i].split(' ').join('')))
                                    {
                                        return false;
                                    }
                                }
                                return true;
                            }
                        },
                        {
                            view: "text",
                            name: "nat_tcp_max_sessions",
                            label: LangHelper.GetString(this.Id, "TCP sessions"),
                            labelWidth: 200,
                            tooltip: LangHelper.GetString(this.Id, "Maximum number of TCP sessions that a subscriber can create"),
                            invalidMessage: LangHelper.GetString(this.Id, "Input correct positive number"),
                            validate: function (Val) {
                                if(!Val)
                                    return false;

                                var int = parseInt(Val);

                                if(!int)
                                    return false;

                                return Helper.IsInteger(int) && int > 0;
                            }
                        },
                        {
                            view: "text",
                            name: "nat_udp_max_sessions",
                            label: LangHelper.GetString(this.Id, "UDP sessions"),
                            labelWidth: 200,
                            tooltip: LangHelper.GetString(this.Id, "Maximum number of UDP sessions that a subscriber can create"),
                            invalidMessage: LangHelper.GetString(this.Id, "Input correct positive number"),
                            validate: function (Val) {
                                if(!Val)
                                    return false;

                                var int = parseInt(Val);

                                if(!int)
                                    return false;

                                return Helper.IsInteger(int) && int > 0;
                            }
                        },
                        {
                            cols: [
                                {},
                                {
                                    view: "button",
                                    label: LangHelper.GetString(this.Id, "Cancel"),
                                    click: function () {
                                        _this.Views.CreateProfileContext.hide();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    label: LangHelper.GetString(this.Id, "Save"),
                                    hotkey: "enter",
                                    click: function () {
                                        setTimeout(function () {
                                            if (_this.SaveProfile())
                                                _this.Views.CreateProfileContext.hide()
                                        }, 10);
                                    }
                                }
                            ]
                        }
                    ],
                }
            ]
        }
    };

    this.SubscriberEmbedded = new SubscribersViewController({
        Id: this.Id,
        embedded:true,
        servicesOnly: true,
        services: ["11"],
        MultiSubscribers: {
            Widget: new MultiSubscribersTableWidget({
                id: this.Id + "MultiSubscribersCgNatServiceReport",
            }),
            WidgetName: "MultiSubscribersCgNatServiceWidget"
        }
    });

    this.StatusView = new CgNatStatusViewController({isQoE: false});

    this.ViewConfig = [
        {
            cols:[
                {
                    type: "clear",
                    borderless: false,
                    rows: [
                        {
                            view:"accordion",
                            multi:"mixed",
                            cols:[
                                {
                                    header:LangHelper.GetString(this.Id,"Profiles"),
                                    body:{
                                        rows:[
                                            {
                                                view: "toolbar",
                                                height: 40,
                                                padding: 0,
                                                margin: 0,
                                                elements: [
                                                    {
                                                        view: "button",
                                                        id:this.Id + "AddTaskBtn",
                                                        type: "icon",
                                                        icon: "plus",
                                                        align: "right",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Add profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.AddProfileToProfilesTable();
                                                        }
                                                    },
                                                    {
                                                        width:16
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "PlayBtn",
                                                        type: "icon",
                                                        icon: "play-circle",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Enable profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.RunProfile();
                                                        }
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "StopBtn",
                                                        type: "icon",
                                                        icon: "stop-circle",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Disable profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.StopProfile();
                                                        }
                                                    },
                                                    {},
                                                    {
                                                        view: "button",
                                                        id:this.Id+"ProfilesRefreshBtn",
                                                        type: "icon",
                                                        icon: "refresh",
                                                        css: "toolbar_round_btn",
                                                        width: 32,
                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.RefreshProfiles();
                                                            // _this.RefreshTasksTable(0);
                                                        }
                                                    }
                                                ]
                                            },
                                            BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Profile status"), icon:"file"}),
                                            {
                                                view: "treetable",
                                                id: this.Id + "ProfilesTable",
                                                select: "row",
                                                editable: true,
                                                editaction:"custom",
                                                resizeColumn: true,
                                                tooltip:true,
                                                on: {
                                                    onItemClick: function (id,e,node)
                                                    {
                                                        var rowData = this.getItem(id);

                                                        if(id.column === 'run')
                                                        {
                                                            var data = _this.Views.ProfilesTable.getItem(id);

                                                            if(!data.profile_id)
                                                            {
                                                                return;
                                                            }

                                                            if(data.status == BlTaskStatusEnum.enabled)
                                                            {
                                                                var __this = this;
                                                                setTimeout(function ()
                                                                {
                                                                    if(data.remote)
                                                                    {
                                                                        _node = __this.getItemNode(id);
                                                                        // _this.RemoteTaskStopContext.show(_node, {pos: "right"});
                                                                    }
                                                                    else
                                                                    {
                                                                        _this.StopProfile();
                                                                    }
                                                                }, 10);
                                                            }
                                                            else
                                                            {
                                                                setTimeout(function ()
                                                                {
                                                                    _this.RunProfile();
                                                                }, 10);
                                                            }
                                                        }

                                                        else if (id.column === 'edit')
                                                        {
                                                            _this.ShowProfileEditForm(rowData, this.getItemNode(id), "right");
                                                        }

                                                        else if(id.column === 'trash')
                                                        {
                                                            var __this = this;

                                                            var data = _this.Views.ProfilesTable.getItem(id);

                                                            if(!data.profile_id)
                                                            {
                                                                _this.DeleteProfile(id);
                                                                return;
                                                            }

                                                            setTimeout(function () {
                                                                var node = __this.getItemNode(id);
                                                                _this.ProfileDeleteContext.show(node, {pos:"bottom"});
                                                            }, 10);
                                                        }
                                                    },
                                                    onItemDblClick: function(id, e, node)
                                                    {
                                                        var rowData = this.getItem(id);
                                                        if(id.column !== "run" && id.column !== "edit" && id.column !== "trash")
                                                        {
                                                            // _this.ShowTasksEditForm(rowData, this.getItemNode(id), "right");
                                                        }
                                                    },
                                                    onBeforeFilter:function()
                                                    {
                                                        return false;
                                                    },
                                                    onAfterFilter:function()
                                                    {
                                                        _this.RefreshProfiles();
                                                    },
                                                    onBeforeSort:function()
                                                    {
                                                        _this.RefreshProfiles();
                                                        return false;
                                                    },
                                                    onAfterSelect:function ()
                                                    {
                                                        _this.OnProfilesTableRowSelect();
                                                    },
                                                    onAfterUnSelect:function ()
                                                    {
                                                        _this.OnProfilesTableRowSelect();
                                                    }
                                                },
                                                columns: [
                                                    {
                                                        id: "run",
                                                        header: "",
                                                        width: 32,
                                                        template: function (obj, common)
                                                        {
                                                            if(obj.status == CgNatProfileStatusEnum.enabled && obj.profile_id)
                                                            {
                                                                return CellStopBtnTemplate();
                                                            }

                                                            if(obj.profile_id)
                                                            {
                                                                return CellPlayBtnTemplate();
                                                            }

                                                            return "";
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "edit",
                                                        header: "",
                                                        width: 32,
                                                        template: function(obj)
                                                        {
                                                            return CellEditBtnTemplate(obj);
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "title",
                                                        header: [LangHelper.GetString(this.Id,"Profile"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        template:function(obj, common, value, config)
                                                        {
                                                            var tmp = common.treetable(obj, common, value, config) + (obj.title?obj.title:LangHelper.GetString(_this.Id,"Profile")+" "+obj.profile_id);

                                                            // if(obj.status && obj.title && obj.title !== obj.dpi_name)
                                                            // {
                                                            //     tmp += " (" + obj.dpi_name + ")";
                                                            // }
                                                            return tmp;
                                                        },
                                                        fillspace: true,
                                                        sort: "string"
                                                    },
                                                    // {
                                                    //     id: "date",
                                                    //     header: [LangHelper.GetString(this.Id,"Date"), {content: "dateRangeFilter"}],
                                                    //     width:72,
                                                    //     //format: webix.Date.dateToStr("%d.%m.%Y"),
                                                    //     template:function(obj, common){
                                                    //         if(obj.date)
                                                    //         {
                                                    //             var format =  webix.Date.dateToStr("%d.%m.%Y");
                                                    //             return format(obj.date);
                                                    //         }
                                                    //
                                                    //         return "";
                                                    //     },
                                                    //     // fillspace: true,
                                                    //     sort: "date"
                                                    // },
                                                    {
                                                        id: "nat_type",
                                                        header: [LangHelper.GetString(this.Id,"Nat type"), {
                                                            content: "richSelectFilter",
                                                            options: Helper.DictToArr(CgNatTypesDic),
                                                            inputConfig: {suggest: {fitMaster: false}}
                                                        }],
                                                        width:72,
                                                        template: function (obj, common)
                                                        {
                                                            var typeStr = "";

                                                            if(CgNatTypesDic[obj.nat_type])
                                                            {
                                                                typeStr += "<span class=\"type nat_type_" + obj.nat_type + "\">" + CgNatTypesDic[obj.nat_type].value + "</span>";
                                                            }

                                                            return typeStr;
                                                        },
                                                        // tooltip: function(obj, common)
                                                        // {
                                                        //     var tmp = (obj.title?obj.title:LangHelper.GetString(_this.Id,"Profile")+" "+obj.profile_id);
                                                        //
                                                        //     if(obj.status && obj.title && obj.title !== obj.dpi_name)
                                                        //     {
                                                        //         tmp += " (" + obj.dpi_name + ")";
                                                        //     }
                                                        //     return tmp;
                                                        // },
                                                        // fillspace: true,
                                                        sort: "string"
                                                    },
                                                    {
                                                        id: "status",
                                                        header: [LangHelper.GetString(this.Id,"Status"), {
                                                            content: "richSelectFilter",
                                                            options: Helper.DictToArr(BlStatusesDic),
                                                            inputConfig: {suggest: {fitMaster: false}}
                                                        }],
                                                        width:72,
                                                        template: function (obj, common)
                                                        {
                                                            var statusStr = "";

                                                            if(BlStatusesDic[obj.status])
                                                            {
                                                                statusStr += "<span class=\"status status_" + obj.status + "\">" + BlStatusesDic[obj.status].value + "</span>";
                                                            }

                                                            return statusStr;
                                                        },
                                                        sort: "string"
                                                    },
                                                    {
                                                        id: "trash",
                                                        header: "",
                                                        width: 32,
                                                        template: CellTrashBtnTemplate,
                                                        headermenu: false
                                                    }
                                                ],
                                                data:[]
                                            },
                                            {
                                                view: "toolbar",
                                                padding: 0,
                                                margin: 0,
                                                height:32,
                                                elements: [
                                                    {
                                                        view: "pager",
                                                        gravity:3,
                                                        id: this.Id + "ProfilesTable" + "Paging",
                                                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                        master:false,
                                                        on: {
                                                            onAfterPageChange:function(Page)
                                                            {
                                                                _this.RefreshProfiles(Page);
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"richselect",
                                                        id: this.Id + "ProfilesTable" + "Paging" + "Size",
                                                        label:LangHelper.GetString(_this.Id, "On page"),
                                                        labelWidth:120,
                                                        minWidth:220,
                                                        value:100,
                                                        options:PagingSizeOptions,
                                                        on: {
                                                            onChange:function()
                                                            {
                                                                _this.RefreshProfiles();
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    }

                                },
                                // {view:"resizer"},
                                // {
                                //     header: LangHelper.GetString(this.Id, "Subscribers"),
                                //     minWidth: 424,
                                //     gravity: 1/2,
                                //     body:{
                                //         id: this.Id + "SubsPanel",
                                //         rows:[
                                //             {
                                //                 view: "toolbar",
                                //                 height: 32,
                                //                 padding: 0,
                                //                 margin: 0,
                                //                 elements: [
                                //                     {
                                //                         view: "button",
                                //                         id:this.Id + "AddSubBtn",
                                //                         type: "icon",
                                //                         icon: "plus",
                                //                         align: "right",
                                //                         width: 32,
                                //                         css:"toolbar_round_btn",
                                //                         tooltip:LangHelper.GetString(this.Id,"Add subscriber"),
                                //                         click: function (id, e, node)
                                //                         {
                                //                             _this.AddSubToSubsTable();
                                //                         }
                                //                     },
                                //                     {
                                //                         view: "button",
                                //                         id:this.Id+"DelSubBtn",
                                //                         type: "icon",
                                //                         icon: "trash",
                                //                         css:"toolbar_round_btn",
                                //                         width:32,
                                //                         tooltip:LangHelper.GetString(this.Id, "Delete"),
                                //                         disabled:true,
                                //                         click:function (id,e,node)
                                //                         {
                                //                             var __this = this;
                                //                             setTimeout(function () {
                                //                                 var node = __this.getNode(id);
                                //                                 _this.SubsDeleteContext.show(node, {pos:"bottom"});
                                //                             }, 10);
                                //                         }
                                //                     },
                                //                     {
                                //                         width:24
                                //                     },
                                //                     {
                                //                         view: "button",
                                //                         id:this.Id + "ImportSubsBtn",
                                //                         type: "icon",
                                //                         icon: "upload",
                                //                         css:"toolbar_round_btn",
                                //                         width:32,
                                //                         tooltip:LangHelper.GetString(this.Id,"Import from file"),
                                //                         click:function (id,e,node)
                                //                         {
                                //                             var __this = this;
                                //                             setTimeout(function () {
                                //                                 var node = __this.getNode(id);
                                //                                 _this.SubsImportContext.show(node, {pos: "bottom"});
                                //                                 _this.Views.SubsImportContextTable.clearAll();
                                //                             }, 10);
                                //                         }
                                //                     },
                                //                     {
                                //                         view: "button",
                                //                         id:this.Id + "ExcelExportSubBtn",
                                //                         type: "icon",
                                //                         icon: "file-excel",
                                //                         css:"toolbar_round_btn",
                                //                         width:32,
                                //                         tooltip:LangHelper.GetString(this.Id,"Export to Excel"),
                                //                         click:function (id,e,node)
                                //                         {
                                //                             _this.ExportSubsToExcel();
                                //                         }
                                //                     },
                                //                     {},
                                //                     {
                                //                         view: "button",
                                //                         id:this.Id+"SubsRefreshBtn",
                                //                         type: "icon",
                                //                         icon: "refresh",
                                //                         css: "toolbar_round_btn",
                                //                         width: 32,
                                //                         tooltip: LangHelper.GetString("All","Refresh"),
                                //                         click: function (id, e, node)
                                //                         {
                                //                             _this.RefreshSubs(0);
                                //                         }
                                //                     }
                                //                 ]
                                //             },
                                //             BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Subscribers"), icon:"users"}),
                                //             {
                                //                 view: "datatable",
                                //                 id: this.Id + "SubsTable",
                                //                 select: "row",
                                //                 multiselect:true,
                                //                 editable: true,
                                //                 editaction:"dblclick",
                                //                 resizeColumn: true,
                                //                 tooltip:true,
                                //                 on: {
                                //                     onItemClick: function (id,e,node)
                                //                     {
                                //                         var rowData = this.getItem(id);
                                //
                                //                         if (id.column === 'edit')
                                //                         {
                                //                             this.editRow(id);
                                //                         }
                                //
                                //                         else if(id.column === 'trash')
                                //                         {
                                //                             var __this = this;
                                //
                                //                             this.select(id); //reset if multiple rows selected
                                //
                                //                             var data = _this.Views.SubsTable.getItem(id);
                                //
                                //                             var model = _this.BlTargetsManager.Targets.find(function(Val){
                                //                                return Val.id === data.id;
                                //                             });
                                //
                                //                             if(!data.target || !model || !model.target)
                                //                             {
                                //                                 _this.DeleteSubscriber(id);
                                //                                 return;
                                //                             }
                                //
                                //                             setTimeout(function ()
                                //                             {
                                //                                 var node = __this.getItemNode(id);
                                //                                 _this.SubsDeleteContext.show(node, {pos:"bottom"});
                                //                             }, 10);
                                //                         }
                                //                     },
                                //                     onBeforeFilter:function()
                                //                     {
                                //                         return false;
                                //                     },
                                //                     onAfterFilter:function()
                                //                     {
                                //                         _this.RefreshSubs();
                                //                     },
                                //                     onBeforeSort:function()
                                //                     {
                                //                         _this.RefreshSubs();
                                //                         return false;
                                //                     },
                                //                     onAfterSelect:function ()
                                //                     {
                                //                         _this.OnSubsTableRowSelect();
                                //                     },
                                //                     onAfterUnSelect:function ()
                                //                     {
                                //                         _this.OnSubsTableRowSelect();
                                //                     },
                                //
                                //                     onAfterEditStart: function(Id)
                                //                     {
                                //                         // var
                                //                         // this.
                                //                         var editor = this.getEditor(Id.row, Id.column);
                                //                         _this.UpdateSubsSuggestList(editor);
                                //                     }
                                //                 },
                                //                 columns: [
                                //                     {
                                //                         id: "edit",
                                //                         header: "",
                                //                         width: 32,
                                //                         template: CellEditBtnTemplate,
                                //                         headermenu: false
                                //                     },
                                //                     {
                                //                         id: "target",
                                //                         name: "target",
                                //                         header: [LangHelper.GetString(_this.Id,"Subscribers"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                //                         sort: "string",
                                //                         editor: "text",
                                //                         fillspace: true,
                                //                         suggest: {
                                //                             data:[]
                                //                         }
                                //                     },
                                //                     {
                                //                         id: "status",
                                //                         header: [
                                //                             LangHelper.GetString(this.Id,"Status"), {
                                //                                 content: "richSelectFilter",
                                //                                 options: Helper.DictToArr(BlTargetsStateDic),
                                //                                 inputConfig: {suggest: {fitMaster: false}}
                                //                             }
                                //                         ],
                                //                         template: function (obj, common) {
                                //                             var res = "";
                                //
                                //                             var profile = _this.GetTasksTableSelectedData();
                                //                             // if(profile && profile.profile_id)
                                //                             // {
                                //                             //     if(profile.status == 0)
                                //                             //     {
                                //                             //         return "<span class=\"bl_state bl_target_" + profile.status + "\">" + '<span class="fa fa-square"></span> ' + BlTargetsStateDic[profile.status].value + "</span>"
                                //                             //     }
                                //                             // }
                                //                             res = "<span class=\"bl_state bl_target_" + obj.status + "\">" + '<span class="fa fa-square"></span> ' + BlTargetsStateDic[obj.status].value + "</span>";
                                //
                                //                             return res;
                                //                         },
                                //                         // fillspace: true,
                                //                         sort: "int"
                                //                     },
                                //                     {
                                //                         id: "trash",
                                //                         header: "",
                                //                         width: 32,
                                //                         template: CellTrashBtnTemplate,
                                //                         headermenu: false
                                //                     }
                                //                 ],
                                //                 data:[],
                                //                 // rules:{
                                //                 //     "target": Helper.ValidateIPaddressOrCidr
                                //                 // }
                                //             },
                                //             {
                                //                 view: "toolbar",
                                //                 padding: 0,
                                //                 margin: 0,
                                //                 height:32,
                                //                 elements: [
                                //                     {
                                //                         view: "pager",
                                //                         gravity:3,
                                //                         id: this.Id + "SubsTable" + "Paging",
                                //                         template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                //                         master:false,
                                //                         on: {
                                //                             onAfterPageChange:function(Page)
                                //                             {
                                //                                 _this.RefreshSubs(Page);
                                //                             }
                                //                         }
                                //                     },
                                //                     {
                                //                         view:"richselect",
                                //                         id: this.Id + "SubsTable" + "Paging" + "Size",
                                //                         label:LangHelper.GetString(_this.Id, "On page"),
                                //                         labelWidth:120,
                                //                         minWidth:220,
                                //                         value:100,
                                //                         options:PagingSizeOptions,
                                //                         on: {
                                //                             onChange:function()
                                //                             {
                                //                                 _this.RefreshSubs();
                                //                             }
                                //                         }
                                //                     }
                                //                 ]
                                //             }
                                //         ]
                                //     }
                                // },
                                {view: "resizer"},
                                {
                                    header:LangHelper.GetString(this.Id,"Profile status"),
                                    id: _this.Id + "StatusView",
                                    body: this.StatusView.view
                                },
                                {view:"resizer"},
                                {
                                    header: LangHelper.GetString(this.Id,"Subscribers"),
                                    id: this.Id + "SubsAccord",
                                    body:this.SubscriberEmbedded.view,
                                    gravity: 1
                                },
                                {gravity: 0}
                            ]
                        }
                    ]
                }
                // ]
                // }
            ]
        }
    ];

    this.Views = {
        ProfilesTable:null,
        ProfilesTablePaging:null,
        ProfilesTablePagingSize:null,
        CreateProfileContext: null,
        CreateProfileContextForm: null,
        ProfileType: null,
        PlayBtn: null,
        StopBtn: null,
        StatusView: null
    };

    this.TasksTableRowsSelectedCount = new Rx.BehaviorSubject(0);
    this.ListItemsTableRowsSelectedCount = new Rx.BehaviorSubject(0);
    // this.SubsTableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.Subscriptions = {};
}

CgNatServiceViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.SubscriberEmbedded.Destroy();

    this.StatusView.Destroy();
};

CgNatServiceViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.SubscriberEmbedded.ViewDidLoad(Params);
    this.StatusView.ViewDidLoad();


    this.BindAll();

};

CgNatServiceViewController.prototype.BindAll = function (Params)
{
    var _this = this;
    this.Views.ProfilesTable = $$(this.Id + "ProfilesTable");
    this.Views.ProfilesTablePaging = $$(this.Id + "ProfilesTable" + "Paging");
    this.Views.ProfilesTablePagingSize = $$(this.Id + "ProfilesTable" + "Paging" + "Size");

    this.Views.CreateProfileContext = webix.ui(this.CreateProfileContextConfig);
    this.Views.CreateProfileContextForm = $$(this.Id + "CreateProfileContextForm");
    this.Views.ProfileType = $$(this.Id + "ProfileType");
    this.Views.StatusView = $$(this.Id + "StatusView");
    this.Views.PlayBtn = $$(this.Id + "PlayBtn");
    this.Views.StopBtn = $$(this.Id + "StopBtn");

    this.Subscriptions.SignalProfileUpdatedSubscription = this.ViewModel.SignalProfileUpdated.subscribe(function (Profile)
    {
        if(Profile)
        {
            var selectedData = _this.GetProfilesTableSelectedData();

            var rows = _this.Views.ProfilesTable.find(function(obj)
            {
                return obj.profile_id == Profile.profile_id;
            });

            if(rows && rows.length == 1)
            {
                _this.Views.ProfilesTable.updateItem(rows[0].id,  Profile);

                if(selectedData && selectedData.profile_id == Task.profile_id && Task.status != 0)
                {
                    _this.OnProfilesTableRowSelect();
                }
            }
        }
    });

    this.Subscriptions.SignalProfilesUpdatedSubscription = this.ViewModel.SignalProfilesUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateProfilesTable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshProfiles();
            _this.RefreshHardwareSubscribers();
        }
    });

    this.Views.ProfileType.attachEvent("onChange", function(Val)
    {
        if (Val == 1) {
            _this.Views.CreateProfileContextForm.elements.nat_tcp_max_sessions.hide();
            _this.Views.CreateProfileContextForm.elements.nat_udp_max_sessions.hide();
            // _this.Views.Form.elements.federal.hide();
        }
        else {
            _this.Views.CreateProfileContextForm.elements.nat_tcp_max_sessions.show();
            _this.Views.CreateProfileContextForm.elements.nat_udp_max_sessions.show();
            // _this.Views.Form.elements.federal.show();
        }
    });

    this.Subscriptions.ProfilesTableRowsSelectedCountSubscription = this.ProfilesTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.ProfilesTableRowsSelectedCountSubscriptionHandler(Value);
    });
};

CgNatServiceViewController.prototype.GetProfilesTableSelectedData = function ()
{
    return this.Views.ProfilesTable.getSelectedItem();
};

CgNatServiceViewController.prototype.OnProfilesTableRowSelect = function ()
{
    var data = this.GetProfilesTableSelectedData();

    this.ProfilesTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

CgNatServiceViewController.prototype.UpdateProfilesTable = function (Params)
{
    var _this = this;

    this.Views.ProfilesTable.clearAll();
    this.Views.ProfilesTable.parse(_this.ViewModel.GetProfiles());

    this.Views.ProfilesTablePagingSize.setValue(this.ViewModel.ProfilesFilter.total.size);

    this.Views.ProfilesTablePaging.define(this.ViewModel.ProfilesFilter.total);
    this.Views.ProfilesTablePaging.refresh();
};

CgNatServiceViewController.prototype.RefreshProfiles = function (Page)
{
    var _this = this;

    var state = this.Views.ProfilesTable.getState();

    var size = this.Views.ProfilesTablePagingSize.getValue();

    this.ViewModel.RefreshProfiles({page:Page, filter:state.filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}})

    _this.UpdateDics();
    // App.DicsManager.Refresh({data: [DicsEnum.WhiteListsProfilesDic, DicsEnum.BlackListsProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});
};

CgNatServiceViewController.prototype.RefreshHardwareSubscribers = function(Params)
{
    var _this = this;

    this.SubscribersManager.RefreshSubscribers(Params, App.SessionManager.GetCurrentHardwareId());
};

CgNatServiceViewController.prototype.AddProfileToProfilesTable = function ()
{
    var _this = this;

    var model = new CgNatProfileModel({hardware_id: App.SessionManager.GetCurrentHardwareId()});
    model.form_data = JSON.stringify(new CgNatFormModel());

    _this.Views.ProfilesTable.add(model,0);

    _this.Views.ProfilesTable.select(model.id, false);
    _this.Views.ProfilesTable.showItem(model.id);

    _this.ShowProfileEditForm(model, _this.Views.ProfilesTable.getItemNode(model.id), "right");
};

CgNatServiceViewController.prototype.ShowProfileEditForm = function (Data, Node, Pos)
{
    var _this = this;
    if(Data && Data.form_data)
    {
        var formParams = new CgNatFormModel(JSON.parse(Data.form_data));

        this.Views.CreateProfileContextForm.setValues(formParams);
    }

    this.Views.CreateProfileContext.show(Node,{pos:Pos});
};

CgNatServiceViewController.prototype.SaveProfile = function()
{
    var _this = this;


    if(_this.Views.CreateProfileContextForm.validate())
    {
        var profileData = this.GetProfilesTableSelectedData();

        profileData.valid = true;

        var formData = new CgNatFormModel(this.Views.CreateProfileContextForm.getValues());
        formData.nat_ip_pool = formData.nat_ip_pool.split(' ').join('');
        this.ViewModel.SaveProfile(
            {
                profile:profileData,
                profile_form:formData,
                callback:function (R)
                {
                    if(R.success && R.data && R.data.profile)
                    {
                        _this.Views.ProfilesTable.updateItem(profileData.id,  new CgNatProfileModel(R.data.profile));

                        webix.message(LangHelper.GetString(_this.Id,"Profile saved"));
                    }
                    else
                    {
                        profileData.valid = false;

                        _this.Views.ProfilesTable.validate(profileData.id);

                        if(R.error)
                            webix.message({text:R.error.msg,type:"error"});
                    }
                    _this.UpdateDics();
                    _this.OnProfilesTableRowSelect();
                }
            }
        );

        this.Views.ProfilesTable.validate(profileData.id);
        return true;
    }
    else{
        return false;
    }

};

CgNatServiceViewController.prototype.UpdateDics = function()
{
    var dicEnum = ServicesDicsEnum[ServicesEnum.cgnat];

    App.DicsManager.Refresh({data: [dicEnum], filter:App.SessionManager.GetCurrentHardwareId()});
};

CgNatServiceViewController.prototype.RunProfile = function ()
{
    var _this = this;

    var profileData = this.GetProfilesTableSelectedData();

    profileData.valid = true;

    this.ViewModel.RunProfile({profile:profileData, callback:function (R)
    {
        if(R.success && R.data)
        {
            _this.Views.ProfilesTable.updateItem(profileData.id,  new CgNatProfileModel(R.data));

            if(R.data.status == CgNatProfileStatusEnum.enabled)
            {
                webix.message(LangHelper.GetString(_this.Id,"Profile enabled"));
            }
            else
            {
                webix.message({text:LangHelper.GetString(this.Id,"Profile not enabled"), type:"debug"});
            }
        }
        else
        {
            profileData.valid = false;

            _this.Views.ProfilesTable.validate(profileData.id);

            if(R.error)
                webix.message({text:R.error.msg,type:"error"});
        }
        _this.UpdateDics();

        _this.OnProfilesTableRowSelect();
    }});
};

CgNatServiceViewController.prototype.StopProfile = function ()
{
    var _this = this;

    var profileData = this.GetProfilesTableSelectedData();

    profileData.valid = true;

    this.ViewModel.StopProfile({profile:profileData, callback:function (R)
    {
        if(R.success)
        {
            if(R.data)
            {
                _this.Views.ProfilesTable.updateItem(profileData.id,  new CgNatProfileModel(R.data));

                webix.message(LangHelper.GetString(_this.Id,"Profile disabled"));
            }
            else
            {
                webix.message(LangHelper.GetString(_this.Id,"Profile not disabled"));
            }

        }
        else
        {
            profileData.valid = false;

            _this.Views.ProfilesTable.validate(profileData.id);

            if(R.error)
                webix.message({text:R.error.msg,type:"error"});
        }
        _this.UpdateDics();

        _this.OnProfilesTableRowSelect();
    }});
};

CgNatServiceViewController.prototype.DeleteProfile = function (RowId)
{
    var _this = this;

    var profileData = this.Views.ProfilesTable.getItem(RowId);
    profileData.valid = true;

    if(profileData.profile_id > 0)
    {
        this.ViewModel.DeleteProfile({profile:profileData, callback:function (R)
        {
            if(R.success)
            {
                _this.Views.ProfilesTable.remove(RowId);

                webix.message(LangHelper.GetString(this.Id,"Profile deleted"));
            }
            else
            {
                profileData.valid = false;
                _this.Views.ProfilesTable.validate(RowId);
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
            _this.UpdateDics();
        }});
    }
    else
    {
        this.Views.ProfilesTable.remove(RowId);
    }
};

CgNatServiceViewController.prototype.ProfilesTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    var _this = this;

    var _disableAll = function (Profile)
    {
        _this.Views.StatusView.disable();

        _this.Views.PlayBtn.disable();
        _this.Views.StopBtn.disable();

        _this.StatusView.SetProfile(Profile);
    };

    if(Value != 1)
    {
        _disableAll(null);
        return;
    }

    var selectedData = _this.GetProfilesTableSelectedData();

    if(!selectedData)
    {
        _disableAll(selectedData);
        return;
    }

    if(selectedData.profile_id)
    {
        _this.Views.StatusView.enable();
        _this.StatusView.SetProfile(selectedData);
    }
    else
    {
        _this.Views.StatusView.disable();
    }

    switch (parseInt(selectedData.status))
    {
        case CgNatProfileStatusEnum.disabled:
            if(selectedData.profile_id)
            {
                _this.Views.PlayBtn.enable();
            }
            else
            {
                _this.Views.PlayBtn.disable();
            }
            _this.Views.StopBtn.disable();
            break;
        case CgNatProfileStatusEnum.enabled:
            _this.Views.PlayBtn.disable();
            _this.Views.StopBtn.enable();
            break;
        default:
            break;
    }
};

function CgNatStatusViewController(Params)
{
    var _this = this;

    this.Id = "CgNatService";

    this.id = this.Id;
    this.isQoE = false;

    this.Profile = new CgNatProfileModel();
    this.ViewModel = new CgNatStatusManager();
    this.Subscriptions = {};

    this.FormViews = [
        this.id + "Full",
        this.id + "Detailed",
        this.id + "Subscribers"
    ];


    this.view = null;

    this.Views = {
        Tabbar: null,

        FullStatusTable: null,
        FullStatusTablePaging: null,
        FullStatusTablePagingSize: null,

        DetailedStatusTable: null,
        DetailedStatusTablePaging: null,
        DetailedStatusTablePagingSize: null,

        SubscribersStatusTable: null,
        SubscribersStatusTablePaging: null,
        SubscribersStatusTablePagingSize: null
    };
    this.Init(Params);
}

CgNatStatusViewController.prototype.Init = function (Params) {
    "use strict";
    var _this = this;

    this.isQoE = Params && Params.isQoE ? Params.isQoE : false;

    this.view = {
        id: this.Id + "StatusTemplate",
        rows: [
            {
                view: "toolbar",
                height: 40,
                padding: 0,
                margin: 0,
                borderless:false,
                elements: [
                    {
                        view:"label",
                        id:this.id+"ProfileDataInfoLabel",
                        width:300
                    },
                    {},
                    {
                        view: "button",
                        type: "icon",
                        icon: "download",
                        css: "toolbar_round_btn",
                        width: 32,
                        tooltip: LangHelper.GetString(_this.Id,"Download the file"),
                        click: function (id, e, node)
                        {
                            _this.ExportToExcel();
                        }
                    },
                    {
                        width: 32
                    },
                    {
                        view: "button",
                        id:this.Id+"ListItemsRefreshBtn",
                        type: "icon",
                        icon: "refresh",
                        css: "toolbar_round_btn",
                        width: 32,
                        tooltip: LangHelper.GetString(this.Id,"Refresh"),
                        click: function (id, e, node)
                        {
                            _this.RefreshAll();
                        }
                    }
                ]
            },
            BlockHeaderTemplate({title: LangHelper.GetString(this.Id, "Status"), icon: "cogs"})
        ]
    };

    this.view.rows.push(this.GetTabbarTemplate());

    var formViews = {
        view: "multiview",
        cells:[
            _this.GetFullStatusTemplate(),
            _this.GetDetailedStatusTemplate(),
            _this.GetSubscribersStatusTemplate()
        ]
    };

    this.view.rows.push(formViews);

};


CgNatStatusViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    var _this = this;

    this.BindAll(Params);
};

CgNatStatusViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

CgNatStatusViewController.prototype.BindAll = function (Params) {
    "use strict";
    var _this = this;

    this.Views.Tabbar = $$(this.id + "Tabbar");

    this.Views.FullStatusTable = $$(this.id + "FullStatusTable");
    this.Views.FullStatusTablePaging = $$(this.Id + "FullStatusTable" + "Paging");
    this.Views.FullStatusTablePagingSize = $$(this.Id + "FullStatusTable" + "Paging" + "Size");

    this.Views.DetailedStatusTable = $$(this.id + "DetailedStatusTable");
    this.Views.DetailedStatusTablePaging = $$(this.Id + "DetailedStatusTable" + "Paging");
    this.Views.DetailedStatusTablePagingSize = $$(this.Id + "DetailedStatusTable" + "Paging" + "Size");

    this.Views.SubscribersStatusTable = $$(this.id + "SubscribersStatusTable");
    this.Views.SubscribersStatusTablePaging = $$(this.Id + "SubscribersStatusTable" + "Paging");
    this.Views.SubscribersStatusTablePagingSize = $$(this.Id + "SubscribersStatusTable" + "Paging" + "Size");

    this.Subscriptions.FullStatusUpdatedSubscription = this.ViewModel.FullStatusUpdated.subscribe(
        function(Val){
            if(Val)
            {
                _this.UpdateFullStatusTable();
            }
        }
    );

    this.Subscriptions.DetailedStatusUpdatedSubscription = this.ViewModel.DetailedStatusUpdated.subscribe(
        function(Val){
            if(Val)
            {
                _this.UpdateDetailedStatusTable();
            }
        }
    );

    this.Subscriptions.SubscribersStatusUpdateSubscription = this.ViewModel.SubscribersStatusUpdated.subscribe(
        function(Val)
        {
            if(Val)
            {
                _this.UpdateSubscribersStatusTable();
            }
        }
    );
    if(this.isQoE)
    {
        this.Subscriptions.CgNatDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.CgNatProfilesDic].subscribe(function(Val)
        {
            if(Val)
            {
                _this.UpdateProfileFilter(_this.Views.FullStatusTable);
                _this.UpdateProfileFilter(_this.Views.DetailedStatusTable);
                _this.UpdateProfileFilter(_this.Views.SubscribersStatusTable);
            }
        });

        this.Subscriptions.CurrentHardwareUpdatedSignal = App.SessionManager.CurrentHardwareId.subscribe(
            function(Val)
            {
                if(Val)
                {
                    App.DicsManager.Refresh({data: [DicsEnum.CgNatProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});
                    _this.RefreshAll();
                }
            }
        );
    }
};

CgNatStatusViewController.prototype.GetTabbarTemplate = function()
{
    var _this = this;
    return   {
        view: "tabbar",
        id: this.id + "Tabbar",
        multiview: true,
        value: this.FormViews[0],
        options:[
            {
                id: this.FormViews[0],
                value: LangHelper.GetString(this.Id, "Full status")
            },
            {
                id: this.FormViews[1],
                value: LangHelper.GetString(this.Id, "Detailed status")
            },
            {
                id: this.FormViews[2],
                value: LangHelper.GetString(this.Id, "Subscribers status")
            }
        ]
    }
};

CgNatStatusViewController.prototype.GetFullStatusTemplate = function()
{
    var _this = this;

    var cols = [
        {
            width: 72,
            id: "proto",
            header: [LangHelper.GetString(this.Id,"Protocol"),{
                content: "richSelectFilter",
                options: Helper.DictToArr(CgNatStatusProtoDic),
                inputConfig: {suggest: {fitMaster: false}}
            }],
            sort: "string",
            // fillspace: true
        },
        {
            width: 104,
            id: "nthr",
            header: [
                TooltipTemplate(LangHelper.GetString(this.Id,"NTHR"),LangHelper.GetString(this.Id,"NTHR")),
                {
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "string",
            css: {'text-align': 'center'}
            // fillspace: true
        },
        {
            width: 72,
            id: "ip_mask",
            header: [
                TooltipTemplate(LangHelper.GetString(this.Id,"IP mask"),LangHelper.GetString(this.Id, "IP mask: 0x0 is even address; 0x1 is not even address")),
                {
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "string",
            css: {'text-align': 'center'}
            // fillspace: true
        },
        {
            width: 72,
            id: "num_addr",
            header: [
                LangHelper.GetString(this.Id,"Addresses"),{
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "number",
            css: {'text-align': 'center'},
            fillspace: true
        },
        {
            width: 72,
            id: "use_addr",
            header: [
                LangHelper.GetString(this.Id,"Addresses in use"),{
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "number",
            css: {'text-align': 'center'},
            fillspace: true
        },
        {
            // width: 190,
            id: "num_port",
            header: [
                LangHelper.GetString(this.Id,"Ports"),{
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "number",
            css: {'text-align': 'center'},
            fillspace: true
        },
        {
            id: "use_port",
            header: [
                LangHelper.GetString(this.Id,"Ports in use"),{
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "number",
            css: {'text-align': 'center'},
            fillspace: true
        },
        {
            width: 120,
            id: "load",
            header: [
                LangHelper.GetString(this.Id,"Used"),
                ""
            ],
            template: function (obj, common) {
                var percent = 0;
                var title = "";
                if(obj.num_port != 0)
                {
                    percent = Math.floor(100*obj.use_port/obj.num_port);

                    title += LangHelper.GetString(_this.Id, "Ports number") + ": " + obj.num_port + "; ";
                    title += LangHelper.GetString(_this.Id, "Ports in use") + ": " + obj.use_port + "; ";
                }
                else if(obj.num_addr != 0){
                    percent = Math.floor(100*obj.use_addr/obj.num_addr);

                    title += LangHelper.GetString(_this.Id, "Addresses number") + ": " + obj.num_addr + "; ";
                    title += LangHelper.GetString(_this.Id, "Addresses in use") + ": " + obj.use_addr + "; ";
                }

                title += " ("+percent+"%);";

                var html = "<div class='progress_bar_element' title='" + title + "' >";
                html += "<div class='progress_result progress_result_" + (percent >= 90 ? "red" : "green") + "' style='width:" + (percent + "%") + "'></div>";
                html += "</div> <span style='display:inline-block;'>" + percent + "%" + "</span>";
                return html;
            },
            css: {'text-align': 'center'}
        }
    ];

    if(this.isQoE)
    {
        cols.splice(0,0,{
            id: "profile_ids",
            header: [LangHelper.GetString(this.Id, "Profiles"), {
                content: "multiSelectFilter",
                options: _this.GetProfilesOptions(),
                inputConfig: {suggest: {fitMaster: false}}
            }],
            fillspace: true,
            sort: false,
            template:function(obj)
            {
                return obj && obj.title ? obj.title : "";
            }
        });
    }

    var tmp = {
        id: this.FormViews[0],
        rows:[
            {
                id: this.id + "FullStatusTable",
                view: "datatable",
                headermenu: false,
                select: "row",
                tooltip:true,
                on: {
                    onBeforeFilter:function()
                    {
                        return false;
                    },
                    onAfterFilter:function()
                    {
                        _this.RefreshFullStatus();
                    },
                    onBeforeSort:function()
                    {
                        _this.RefreshFullStatus();
                        return false;
                    }
                },
                columns: cols,
                data:[]
            },
            {
                view: "toolbar",
                padding: 0,
                margin: 0,
                height:32,
                elements: [
                    {
                        view: "pager",
                        gravity:3,
                        id: this.Id + "FullStatusTable" + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master:false,
                        on: {
                            onAfterPageChange:function(Page)
                            {
                                _this.RefreshFullStatus(Page);
                            }
                        }
                    },
                    {
                        view:"richselect",
                        id: this.Id + "FullStatusTable" + "Paging" + "Size",
                        label:LangHelper.GetString(_this.Id, "On page"),
                        labelWidth:120,
                        minWidth:220,
                        value:100,
                        options:PagingSizeOptions,
                        on: {
                            onChange:function()
                            {
                                _this.RefreshFullStatus();
                            }
                        }
                    }
                ]
            }
        ]
    };

    return tmp;
};

CgNatStatusViewController.prototype.GetDetailedStatusTemplate = function()
{
    var _this = this;

    var cols = [
        {
            width: 104,
            id: "proto",
            header: [LangHelper.GetString(this.Id,"Protocol"),{
                content: "richSelectFilter",
                options: Helper.DictToArr(CgNatStatusProtoDic),
                inputConfig: {suggest: {fitMaster: false}}
            }],
            sort: "string",
            // fillspace: true
        },
        {
            width: 128,
            id: "nthr",
            header: [LangHelper.GetString(this.Id,"NTHR"),{
                content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            }],
            sort: "string",
            // fillspace: true
        },
        {
            width: 72,
            id: "ip_mask",
            header: [
                TooltipTemplate(LangHelper.GetString(this.Id,"IP mask"),LangHelper.GetString(this.Id, "IP mask: 0x0 is even address; 0x1 is not even address")),
                {
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "string"
        },
        {
            // width: 190,
            id: "whip",
            header: [LangHelper.GetString(this.Id,"IP"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            sort: "string",
            fillspace: true
        },
        {
            // width: 190,
            id: "num_port",
            header: [LangHelper.GetString(this.Id,"Ports"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            sort: "number",
            fillspace: true
        },
        {
            id: "use_port",
            header: [LangHelper.GetString(this.Id,"Ports in use"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
            sort: "number",
            fillspace: true
        },
        {
            width: 120,
            id: "load",
            header: [LangHelper.GetString(this.Id,"Used"), ""],
            template: function (obj, common) {
                var percent = 0;
                if(obj.num_port !== 0 && obj.use_port !== 0)
                {
                    percent = Math.floor(100*obj.use_port/obj.num_port);
                }

                var title = LangHelper.GetString(_this.Id, "Ports number") + ": " + obj.num_port + "; ";
                title += LangHelper.GetString(_this.Id, "Ports in use") + ": " + obj.use_port + "; ";
                title += " ("+percent+"%);";

                var html = "<div class='progress_bar_element' title='" + title + "' >";
                // html += "<div title='" + title + "' class='progress_result ' style='width:" + (percent + "%") + "'></div>";
                html += "<div  class='progress_result progress_result_" + (percent >= 90 ? "red" : "green") + "' style='width:" + (percent + "%") + "'></div>";
                html += "</div> <span style='display:inline-block;'>" + percent + "%" + "</span>";
                return html;
                // return AdvCellProgressTemplate(obj);
            },
            css: {'text-align': 'center'}
        }
    ];

    if(this.isQoE)
    {
        cols.splice(0,0,{
            id: "profile_ids",
            header: [LangHelper.GetString(this.Id, "Profiles"), {
                content: "multiSelectFilter",
                options: _this.GetProfilesOptions(),
                inputConfig: {suggest: {fitMaster: false}}
            }],
            fillspace: true,
            sort: false,
            template:function(obj)
            {
                return obj && obj.title ? obj.title : "";
            }
        });
    }

    return {
        id: this.FormViews[1],
        rows:[
            // this.GetHierarchyFormTemplate(this.FormViews[1]),
            {
                id: this.id + "DetailedStatusTable",
                view: "datatable",
                tooltip: true,
                headermenu: false,
                select: "row",
                on: {
                    onBeforeFilter:function()
                    {
                        return false;
                    },
                    onAfterFilter:function()
                    {
                        _this.RefreshDetailedStatus();
                    },
                    onBeforeSort:function()
                    {
                        _this.RefreshDetailedStatus();
                        return false;
                    }
                },
                columns: cols,
                data:[]
            },
            {
                view: "toolbar",
                padding: 0,
                margin: 0,
                height:32,
                elements: [
                    {
                        view: "pager",
                        gravity:3,
                        id: this.Id + "DetailedStatusTable" + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master:false,
                        on: {
                            onAfterPageChange:function(Page)
                            {
                                _this.RefreshDetailedStatus(Page);
                            }
                        }
                    },
                    {
                        view:"richselect",
                        id: this.Id + "DetailedStatusTable" + "Paging" + "Size",
                        label:LangHelper.GetString(_this.Id, "On page"),
                        labelWidth:120,
                        minWidth:220,
                        value:100,
                        options:PagingSizeOptions,
                        on: {
                            onChange:function()
                            {
                                _this.RefreshDetailedStatus();
                            }
                        }
                    }
                ]
            }
        ]
    };
};

CgNatStatusViewController.prototype.GetSubscribersStatusTemplate = function()
{
    var _this = this;

    var cols = [
        {
            width: 104,
            id: "ipv4",
            header: [LangHelper.GetString(this.Id,"IP"),{
                content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            }],
            sort: "string",
            fillspace: true
        },
        {
            width: 128,
            id: "whiteip",
            header: [LangHelper.GetString(this.Id,"White IP"),{
                content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            }],
            sort: "string",
            fillspace: true
        },
        {
            width: 72,
            id: "sess_tcp",
            header: [LangHelper.GetString(this.Id,"TCP sessions"),{
                content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            }],
            sort: "number",
            fillspace: true
        },
        {
            width: 72,
            id: "sess_udp",
            header: [LangHelper.GetString(this.Id,"UDP sessions"),{
                content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            }],
            sort: "number",
            fillspace: true
        }
    ];

    if(this.isQoE)
    {
        cols.splice(0,0,{
            id: "profile_ids",
            header: [LangHelper.GetString(this.Id, "Profiles"), {
                content: "multiSelectFilter",
                options: _this.GetProfilesOptions(),
                inputConfig: {suggest: {fitMaster: false}}
            }],
            fillspace: true,
            sort: false,
            template:function(obj)
            {
                return obj && obj.title ? obj.title : "";
            }
        });
    }

    return {
        id: this.FormViews[2],
        rows:[
            // this.GetHierarchyFormTemplate(this.FormViews[1]),
            {
                id: this.id + "SubscribersStatusTable",
                view: "datatable",
                headermenu: false,
                select: "row",
                tooltip: true,
                on: {
                    onBeforeFilter:function()
                    {
                        return false;
                    },
                    onAfterFilter:function()
                    {
                        _this.RefreshSubscribersStatus();
                    },
                    onBeforeSort:function()
                    {
                        _this.RefreshSubscribersStatus();
                        return false;
                    }
                },
                columns: cols,
                data:[]
            },
            {
                view: "toolbar",
                padding: 0,
                margin: 0,
                height:32,
                elements: [
                    {
                        view: "pager",
                        gravity:3,
                        id: this.Id + "SubscribersStatusTable" + "Paging",
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                        master:false,
                        on: {
                            onAfterPageChange:function(Page)
                            {
                                _this.RefreshSubscribersStatus(Page);
                            }
                        }
                    },
                    {
                        view:"richselect",
                        id: this.Id + "SubscribersStatusTable" + "Paging" + "Size",
                        label:LangHelper.GetString(_this.Id, "On page"),
                        labelWidth:120,
                        minWidth:220,
                        value:100,
                        options:PagingSizeOptions,
                        on: {
                            onChange:function()
                            {
                                _this.RefreshSubscribersStatus();
                            }
                        }
                    }
                ]
            }
        ]
    };
};

CgNatStatusViewController.prototype.SetProfile = function(Profile)
{
    this.Profile = new CgNatProfileModel(Profile);
    if(this.Profile && this.Profile.profile_id)
    {
        this.ResetFullStatusTable();
        this.RefreshAll();
    }
    else
    {

    }
};

CgNatStatusViewController.prototype.RefreshFullStatus = function(Page)
{
    var _this = this;

    var state = this.Views.FullStatusTable.getState();

    var size = this.Views.FullStatusTablePagingSize.getValue();

    var params = {
        page:Page,
        filter:state.filter,
        size:size,
        sort:state.sort ? state.sort:null,
        callback:function () {}
    };

    if(!this.isQoE && this.Profile && this.Profile.profile_id)
    {
        params.profile_ids = this.Profile.profile_id;
    }

    this.ViewModel.RefreshFullStatus(params)
};

CgNatStatusViewController.prototype.RefreshDetailedStatus = function(Page)
{
    var _this = this;

    var state = this.Views.DetailedStatusTable.getState();

    var size = this.Views.DetailedStatusTablePagingSize.getValue();
    var params = {
        page:Page,
        filter:state.filter,
        size:size,
        sort:state.sort ? state.sort:null,
        callback:function () {}
    };


    if(!this.isQoE && this.Profile && this.Profile.profile_id)
    {
        params.profile_ids = this.Profile.profile_id;
    }
    this.ViewModel.RefreshDetailedStatus(params);
};

CgNatStatusViewController.prototype.RefreshSubscribersStatus = function(Page)
{
    var _this = this;

    var state = this.Views.SubscribersStatusTable.getState();

    var size = this.Views.SubscribersStatusTablePagingSize.getValue();

    var params = {
        page:Page,
        filter:state.filter,
        size:size,
        sort:state.sort ? state.sort:null,
        callback:function () {}
    };

    if(!this.isQoE && this.Profile && this.Profile.profile_id)
    {
        params.profile_ids = this.Profile.profile_id;
    }

    this.ViewModel.RefreshSubscribersStatus(params)
};

CgNatStatusViewController.prototype.RefreshAll = function()
{
  this.RefreshDetailedStatus();
  this.RefreshFullStatus();
  this.RefreshSubscribersStatus();
};

CgNatStatusViewController.prototype.UpdateFullStatusTable = function()
{
    var _this = this;

    this.Views.FullStatusTable.clearAll();
    this.Views.FullStatusTable.parse(_this.ViewModel.GetFullStatus());

    this.Views.FullStatusTablePagingSize.setValue(this.ViewModel.FullStatusFilter.total.size);

    this.Views.FullStatusTablePaging.define(this.ViewModel.FullStatusFilter.total);
    this.Views.FullStatusTablePaging.refresh();
};

CgNatStatusViewController.prototype.UpdateDetailedStatusTable = function()
{
    var _this = this;

    this.Views.DetailedStatusTable.clearAll();
    this.Views.DetailedStatusTable.parse(_this.ViewModel.GetDetailedStatus());

    this.Views.DetailedStatusTablePagingSize.setValue(this.ViewModel.DetailedStatusFilter.total.size);

    this.Views.DetailedStatusTablePaging.define(this.ViewModel.DetailedStatusFilter.total);
    this.Views.DetailedStatusTablePaging.refresh();

};

CgNatStatusViewController.prototype.UpdateSubscribersStatusTable = function()
{
    var _this = this;

    this.Views.SubscribersStatusTable.clearAll();
    this.Views.SubscribersStatusTable.parse(_this.ViewModel.GetSubscribersStatus());

    this.Views.SubscribersStatusTablePagingSize.setValue(this.ViewModel.SubscribersStatusFilter.total.size);

    this.Views.SubscribersStatusTablePaging.define(this.ViewModel.SubscribersStatusFilter.total);
    this.Views.SubscribersStatusTablePaging.refresh();

};

CgNatStatusViewController.prototype.GetProfilesOptions = function()
{
    var _this = this;

    var options = [
        // {value:LangHelper.GetString(_this.Id, "No profile"), id: "0", dic_id: "0"}
    ];

    var dicEnum = ServicesDicsEnum[ServicesEnum.cgnat];

    if(dicEnum)
    {
        options = options.concat(Helper.DictToArr(App.DicsManager.GetDic(dicEnum)));
    }
    return options;
};

CgNatStatusViewController.prototype.UpdateProfileFilter = function(Table)
{
    var _this = this;

    var columnName = "profile_ids";
    var column = Table.getColumnConfig(columnName);

    if(column)
    {
        column.header[1].options = [];
        Table.refreshColumns();
        column.header[1].options = _this.GetProfilesOptions();


        var state = Table.getState();
        var resultArr = [];
        if(state.filter && state.filter[columnName])
        {
            var arr = state.filter[columnName].split(",");
            arr.forEach(function(Val)
            {

                var index = column.header[1].options.findIndex(function(obj){
                    return obj.id == Val;
                });

                if(index > -1)
                {
                    resultArr.push(Val);
                }
            });

            column.header[1].value = resultArr.join(",");
        }


        Table.refreshColumns();
        Table.refresh();
    }
};

CgNatStatusViewController.prototype.ResetFullStatusTable = function(Data)
{
    var _this = this;
    var table = this.Views.FullStatusTable;
    table.clearAll();
    table.config.columns = [];
    table.refreshColumns();
    var columns = webix.toArray(table.config.columns);

    if(this.Profile.nat_type != 1)
    {
        columns.insertAt({
            width: 72,
            id: "proto",
            header: [LangHelper.GetString(this.Id, "Protocol"), {
                content: "richSelectFilter",
                options: Helper.DictToArr(CgNatStatusProtoDic),
                inputConfig: {suggest: {fitMaster: false}}
            }],
            sort: "string"
        }, columns.length);
        columns.insertAt({
            width: 104,
            id: "nthr",
            header: [LangHelper.GetString(this.Id, "NTHR"), {
                content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            }],
            sort: "string",
            css: {'text-align': 'center'}
            // fillspace: true
        }, columns.length);
    }
    columns.insertAt({
        width: 72,
        id: "ip_mask",
        header: [
            TooltipTemplate(LangHelper.GetString(this.Id,"IP mask"),LangHelper.GetString(this.Id, "IP mask: 0x0 is even address; 0x1 is not even address")),
            {
                content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            }
        ],
        sort: "string",
        css: {'text-align': 'center'}
    },columns.length);
    columns.insertAt({
        width: 72,
        id: "num_addr",
        header: [
            LangHelper.GetString(this.Id,"Addresses"),{
                content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
            }
        ],
        sort: "number",
        css: {'text-align': 'center'},
        fillspace: true
    },columns.length);


    if(this.Profile.nat_type == 1)
    {
        columns.insertAt({
            width: 72,
            id: "use_addr",
            header: [
                LangHelper.GetString(this.Id,"Addresses in use"),{
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "number",
            css: {'text-align': 'center'},
            fillspace: true
        },columns.length);
    }
    else{
        columns.insertAt({
            // width: 190,
            id: "num_port",
            header: [
                LangHelper.GetString(this.Id,"Ports"),{
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "number",
            css: {'text-align': 'center'},
            fillspace: true
        },columns.length);
        columns.insertAt({
            id: "use_port",
            header: [
                LangHelper.GetString(this.Id,"Ports in use"),{
                    content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")
                }
            ],
            sort: "number",
            css: {'text-align': 'center'},
            fillspace: true
        },columns.length);
    }


    columns.insertAt({
        width: 120,
        id: "load",
        header: [
            LangHelper.GetString(this.Id,"Used"),
            ""
        ],
        template: function (obj, common) {
            var percent = 0;
            var title = "";
            if(obj.num_port != 0)
            {
                percent = Math.floor(100*obj.use_port/obj.num_port);

                title += LangHelper.GetString(_this.Id, "Ports number") + ": " + obj.num_port + "; ";
                title += LangHelper.GetString(_this.Id, "Ports in use") + ": " + obj.use_port + "; ";
            }
            else if(obj.num_addr != 0){
                percent = Math.floor(100*obj.use_addr/obj.num_addr);

                title += LangHelper.GetString(_this.Id, "Addresses number") + ": " + obj.num_addr + "; ";
                title += LangHelper.GetString(_this.Id, "Addresses in use") + ": " + obj.use_addr + "; ";
            }

            title += " ("+percent+"%);";

            var html = "<div class='progress_bar_element' title='" + title + "' >";
            html += "<div class='progress_result progress_result_" + (percent >= 90 ? "red" : "green") + "' style='width:" + (percent + "%") + "'></div>";
            html += "</div> <span style='display:inline-block;'>" + percent + "%" + "</span>";
            return html;
        },
        css: {'text-align': 'center'}
    },columns.length);

    table.refreshColumns();
};

CgNatStatusViewController.prototype.ExportToExcel = function()
{
    var _this = this;

    var selected = this.Views.Tabbar.getValue();

    var table = null;
    var fileName = "";
    switch(selected){
        case this.FormViews[0]:
            table = this.Views.FullStatusTable;
            fileName = "full_status";
            break;
        case this.FormViews[1]:
            table = this.Views.DetailedStatusTable;
            fileName = "detailed_status";
            break;
        case this.FormViews[2]:
            table = this.Views.SubscribersStatusTable;
            fileName = "subscribers_status";
            break;
    }


    webix.toExcel(table, {
        filename: fileName,
        filterHTML:true
    });
};
var HotSpotSettingsSectionsDic = {
    common: {id: "Common", value: LangHelper.GetString("HotSpot", "Common settings"), icon: "cogs"},
    view: {id: "View", value: LangHelper.GetString("HotSpot", "View settings"), icon: "image"},
    langs: {id: "Langs", value: LangHelper.GetString("HotSpot", "Localizations settings"), icon: "flag"},
    auth: {id: "Auth", value: LangHelper.GetString("HotSpot", "Auth and Click-Wrap settings"), icon: "user-check"},
    services: {id: "Services", value: LangHelper.GetString("HotSpot", "Services settings"), icon: "list"},
    tariffs: {id: "Tariffs", value: LangHelper.GetString("HotSpot", "Tariffs settings"), icon: "dollar"},
    dhcp: {id: "DHCP", value: LangHelper.GetString("HotSpot", "DHCP configuration"), icon: "at"},
    logs: {id: "Logs", value: LangHelper.GetString("HotSpot", "Logs"), icon: "stack-overflow"}
};
function HotSpotViewController(Params)
{
    var _this = this;

    this.Id = "HotSpot";
    this.id = this.Id;

    this.ViewModel = new WifiSettingsManager();
    this.Settings = new WifiSettingsModel();
    this.Langs = {};

    this.PolicingCaptiveView = new TariffConfigFormViewController({Id: "PolicingCaptiveView", hotspot: true});
    this.PolicingWifiView = new TariffConfigFormViewController({Id: "PolicingWifiView", hotspot: true});
    this.AddHardwareForm = new HardwareEditFormViewController();

    this.LogsView = new HardwareLogsViewController({
        Id: "HotspotLogs",
        PageTitle: null,
        Embedded: true,
        UseCurrentHardwareId: false,
        DontGetLogsListsBeforeHardwareIdSet: true,
        ServerMethods: {
            RefreshLogsFilesList:"GetHotSpotLogsFilesList",

            GetLogFileTail:"GetHotSpotLogFileTail",

            DownloadLogFile:"DownloadHotSpotLogFile"
        },
        PathsNamesMap:{
            "/var/www/html/wifi_hotspot/backend/storage/logs" : "WifiHotspot"
        }
    });

    this.CaptivePortalFAQContext = webix.ui({
        view: "popup",
        id:this.Id + "CaptivePortalFAQContext",
        maxWidth: 360,
        height: 120,
        body: {
            rows:[
                {
                    borderless:true,
                    template:LangHelper.GetString(this.Id , "Will be created/updated profile for white list service with inputed URL")
                },
                {
                    borderless:true,
                    template:LangHelper.GetString(this.Id , "Profile name is hotspot_white_list_profile")
                }
            ]
        }
    });

    this.ConfigDeleteContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Are you sure you want to delete hotspot configuration?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.ConfigDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Dics", "Delete"),
                            click:function ()
                            {
                                _this.ConfigDeleteContext.hide();
                                setTimeout(function(){
                                    _this.DeleteConfig();
                                },1);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateLangFormContext = webix.ui({
        view: "popup",
        id: this.Id + "CreateLangFormContext",
        width: 440,
        height: 480,
        body: {
            rows: [
                {
                    id: this.Id + "CreateLangForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    on:{
                        onValidationError:function(key, obj){
                            // text = "Login can't be empty";
                            // webix.message({ type:"error", text:text });
                        }
                    },
                    elements: [
                        {
                            view: "richselect",
                            name: "lang",
                            labelPosition: "left",
                            labelWidth: 200,
                            required: true,
                            // width: 400,
                            label: LangHelper.GetString(this.Id, "Language"),
                            invalidMessage: LangHelper.GetString(this.Id, "Field is required"),
                            id: this.Id + "CreateLangFormLangSwitcher",
                            options: {
                                body:{
                                    data:Helper.DictToArr(FlagsDic),
                                    template: function (obj) {
                                        if (obj.type) {
                                            return "<div class='separator'></div>";
                                        }

                                        return "<span class='webix_icon'><img src='assets/imgs/flags/"+obj.icon+".svg' style='width: 16px;'/></span><span>" + obj.value + "</span>";
                                    }
                                }
                            }
                        },
                        // {
                        //     view: "text",
                        //     name: "title",
                        //     labelWidth: 200,
                        //     required: true,
                        //     label: LangHelper.GetString(this.Id, "Language title"),
                        //     tooltip: LangHelper.GetString(this.Id, "Language title / description")
                        // },
                        {
                            cols: [
                                {},
                                {
                                    view: "button",
                                    label: LangHelper.GetString(this.Id, "Cancel"),
                                    click: function () {
                                        _this.Views.CreateLangFormContext.hide();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    label: LangHelper.GetString(this.Id, "Add"),
                                    hotkey: "enter",
                                    click: function () {
                                        setTimeout(function () {

                                            if(_this.AddLang())
                                            {
                                                _this.Views.CreateLangFormContext.hide()
                                            }

                                        }, 10);
                                    }
                                }
                            ]
                        }
                    ],
                }
            ]
        }
    });

    this.Views = {
        SaveBtn: null,
        RefreshBtn: null,
        DeleteBtn: null,
        SettingsGroupsTable: null,
        GroupSections: null,
        CaptivePortalFAQContext: null,
        LangSwitcher: null,
        LangDataTable: null,
        LangConfigButtons: null,
        LangConfigButtonsDefault: null,
        LangConfigButtonsDelete: null,
        AddLangButton: null,
        DefaultLangButton: null,
        DeleteLangButton: null,
        CreateLangFormContext: null,
        CreateLangForm: null,
        CreateLangFormLangSwitcher: null,
        Forms: {}
    };

    this.ViewConfig = [
        {
            id:this.Id,
            cols: [
                ServicesLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView", "Services control"), title: LangHelper.GetString("AppView", "HotSpot")}),
                                {
                                    rows: [
                                        {
                                            view: "toolbar",
                                            height: webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "floppy-o",
                                                    id: this.Id + "SaveBtn",
                                                    label: LangHelper.GetString("AppView", "Save"),
                                                    css: "toolbar_round_btn",
                                                    width: 128,
                                                    tooltip: LangHelper.GetString("AppView", "Save"),
                                                    click: function (id, e, node)
                                                    {
                                                        var __this = this;
                                                        setTimeout(function ()
                                                        {
                                                            _this.SaveSettings();
                                                        }, 1);
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    id: this.Id + "RefreshBtn",
                                                    type: "icon",
                                                    icon: "redo",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString(this.Id, "Cancel changes"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.ViewModel.RefreshSettings();
                                                    }
                                                },
                                                {
                                                    width: 16
                                                },
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "question",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString(this.Id, "Wiki"),
                                                    click: function(id, e, node)
                                                    {
                                                        var url = LangHelper.GetString(_this.Id, "HOTSPOT_WIKI_URL");
                                                        window.open(url, '_blank').focus();

                                                    }
                                                },
                                                {},
                                                {
                                                    view: "button",
                                                    id:this.Id+"DeleteBtn",
                                                    type: "icon",
                                                    icon: "trash",
                                                    css: "toolbar_round_btn",
                                                    label:LangHelper.GetString(_this.Id, "Delete configuration"),
                                                    width: 208,
                                                    tooltip: LangHelper.GetString(this.Id, "Delete configuration"),
                                                    click: function (id)
                                                    {
                                                        var node = this.getNode(id);
                                                        setTimeout(function(){
                                                            _this.ConfigDeleteContext.show(node, {pos: "bottom"});
                                                        }, 1);
                                                    }

                                                }
                                            ]
                                        },
                                        {
                                            cols:[
                                                {
                                                    width: 400,
                                                    rows:[
                                                        BlockHeaderTemplate({title: LangHelper.GetString("All","Configuration"), icon: "cogs"}),
                                                        {
                                                            id: this.Id + "SettingsGroupsTable",
                                                            view: "datatable",
                                                            header: false,
                                                            select: "row",
                                                            columns: [
                                                                {
                                                                    id: "value",
                                                                    fillspace: true,
                                                                    template: function(Obj)
                                                                    {
                                                                        var txt = "";

                                                                        if(Obj.icon)
                                                                        {
                                                                            txt += CellAnyIconBtnTemplate(Obj.icon);
                                                                        }

                                                                        txt += Obj.value;

                                                                        return txt;
                                                                    }
                                                                }
                                                            ],
                                                            data: function(){
                                                                return Helper.DictToArr(HotSpotSettingsSectionsDic);
                                                            }(),

                                                            on: {
                                                                onAfterSelect: function(data, preserve)
                                                                {
                                                                    var view = "GroupSections" + data.id;

                                                                    if(_this.Views[view])
                                                                    {
                                                                        _this.Views[view].show();
                                                                    }
                                                                }
                                                            }

                                                        }
                                                    ]
                                                },
                                                {view: "resizer"},
                                                {
                                                    rows: [
                                                        {
                                                            view: "multiview",
                                                            id: this.Id + "GroupSections",
                                                            animate: false,
                                                            cells: function()
                                                            {
                                                                var cells = [];

                                                                Object.keys(HotSpotSettingsSectionsDic).forEach(function(Key){
                                                                    var obj = HotSpotSettingsSectionsDic[Key];
                                                                    var cellId = "GroupSections" + obj.id;
                                                                    _this.Views[cellId] = null;
                                                                    cells.push({
                                                                        id: _this.Id + cellId,
                                                                        // scroll:true,
                                                                        rows: [
                                                                            BlockHeaderTemplate({
                                                                                title: obj.value,
                                                                                icon: obj.icon
                                                                            }),
                                                                            _this.GetFormByGroup(obj.id),
                                                                            // {}
                                                                        ]
                                                                    })
                                                                });

                                                                return cells;
                                                            }
                                                            ()
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];



    this.Signals = {
        WifiAuthEnabledSinal: new Rx.BehaviorSubject(0),
        ClickWrapEnabledSignal: new Rx.BehaviorSubject(0),
        SmsAuthEnabledSignal: new Rx.BehaviorSubject(0),
        CallAuthEnabledSignal: new Rx.BehaviorSubject(0),
        SessionManagementEnabledSignal: new Rx.BehaviorSubject(0)
    };
    this.Subscriptions = {};
}

HotSpotViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.PolicingCaptiveView.Destroy();
    this.PolicingWifiView.Destroy();
    this.AddHardwareForm.Destroy();
    this.LogsView.Destroy();
};

HotSpotViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select("HotSpot");
    });

    this.AddHardwareForm.ViewDidLoad();
    this.PolicingCaptiveView.ViewDidLoad();
    this.PolicingWifiView.ViewDidLoad();
    this.LogsView.ViewDidLoad();

    this.BindAll();

};

HotSpotViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function(View){
        if(View != "Forms")
        {
            _this.Views[View] = $$(_this.Id + View);
        }
        else
        {
            Object.keys(_this.Views[View]).forEach(function(Form){
                _this.Views[View][Form] = $$(_this.Id + Form);
            });
        }
    });

    // return;
    this.Subscriptions.AuthAndClickwrapStateSubscription = Rx.Observable.combineLatest
    (
        this.Signals.WifiAuthEnabledSinal,
        this.Signals.ClickWrapEnabledSignal
    ).subscribe(function (Val)
    {
        if(Val[0] + Val[1])
        {
            _this.Views.SessionManagementSection.show();
        }
        else
        {
            _this.Views.SessionManagementSection.hide();
        }
    });

    this.Subscriptions.WifiAuthEnabledSubscribption = this.Signals.WifiAuthEnabledSinal.subscribe(function(Val)
    {
        if(Val)
        {
            _this.Views.AuthConfigSection.show();
        }
        else
        {
            _this.Views.AuthConfigSection.hide();
        }
    });

    this.Subscriptions.SmsAndCallStateSubscription = Rx.Observable.combineLatest
    (
        this.Signals.SmsAuthEnabledSignal,
        this.Signals.CallAuthEnabledSignal
    ).subscribe(function (Val)
    {
        if(Val[0] + Val[1] > 1)
        {
            _this.Views.CallPriorityEnabledSection.show();
        }
        else
        {
            _this.Views.CallPriorityEnabledSection.hide();
        }
    });

    this.Subscriptions.SmsAuthEnabledSubscription = this.Signals.SmsAuthEnabledSignal.subscribe(function(Val)
    {
        if(Val)
        {
            _this.Views.SmsForm.show();
        }
        else
        {
            _this.Views.SmsForm.hide();
        }
    });

    this.Subscriptions.CallAuthEnabledSubscription = this.Signals.CallAuthEnabledSignal.subscribe(function(Val)
    {
        if(Val)
        {
            _this.Views.CallForm.show();
        }
        else
        {
            _this.Views.CallForm.hide();
        }
    });

    this.Subscriptions.SessionManagementEnabledSubscription = this.Signals.SessionManagementEnabledSignal.subscribe(function(Val){
        if(Val)
        {
            _this.Views.SessionLiveTimeSection.show();
            _this.Views.SessionInitWebHook.hide();
            _this.Views.Forms.FormServices.enable();
            _this.Views.TariffsSection.enable();
        }
        else
        {
            _this.Views.SessionLiveTimeSection.hide();
            _this.Views.SessionInitWebHook.show();
            _this.Views.Forms.FormServices.disable();
            _this.Views.TariffsSection.disable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val){
        if(Val)
        {
            _this.ViewModel.RefreshSettings();
        }
    });

    this.Subscriptions.SignalSettingsUpdated = this.ViewModel.SignalSettingUpdated.subscribe(function(Val){
        if(Val)
        {
            _this.UpdateForms();
        }
    });

    this.Subscriptions.BlackProfilesDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.BlackListsProfilesDic].subscribe(function(Val)
    {
        if(Val)
        {
            _this.UpdateServiceProfilesOptions(4);
        }

    });

    this.Subscriptions.CgNatDicUpdatedSignal = App.DicsManager.Signal[DicsEnum.CgNatProfilesDic].subscribe(function(Val)
    {
        if(Val)
        {
            _this.UpdateServiceProfilesOptions(11);
        }
    });

    this.Subscriptions.OnHardwareListChanged = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(
        function(Val)
        {
            if(Val)
            {
                _this.Views.HardwareSelect.getList().clearAll();

                var hws = App.DicsManager.GetDic(DicsEnum.HardwaresDic);
                var arr = [];
                for (var i in hws)
                {
                    if(hws[i].hardware_type == HardwareTypesEnum.wifi_web)
                        arr.push({id: hws[i].id, value: hws[i].value});
                }
                _this.Views.HardwareSelect.getList().parse(arr);
            }
        }
    );

    this.Views.WifiAuthorizationEnabled.attachEvent("onChange", function(Val, OldVal)
    {
        _this.Signals.WifiAuthEnabledSinal.next(parseInt(Val));
    });

    this.Views.ClickWrapEnabled.attachEvent("onChange", function(Val, OldVal)
    {
        _this.Signals.ClickWrapEnabledSignal.next(parseInt(Val));
    });

    this.Views.SessionManagementEnabled.attachEvent("onChange", function(Val, OldVal)
    {
        _this.Signals.SessionManagementEnabledSignal.next(parseInt(Val));
    });

    this.Views.AuthType.attachEvent("onChange", function(Val, OldVal)
    {
        if(Val == WifiAuthorizationType.code.id)
        {
            _this.Views.AuthByCodeSection.show();
            _this.Views.AuthByOutgoingCallSection.hide();

        }
        else
        {
            _this.Views.AuthByCodeSection.hide();
            _this.Views.AuthByOutgoingCallSection.show();

        }
    });

    this.Views.SmsAuthEnabled.attachEvent("onChange", function(Val, OldVal)
    {
        _this.Signals.SmsAuthEnabledSignal.next(parseInt(Val));
    });

    this.Views.CallAuthEnabled.attachEvent("onChange", function(Val, OldVal)
    {
        _this.Signals.CallAuthEnabledSignal.next(parseInt(Val));
    });

    this.Views.BlackListEnableSelect.attachEvent("onChange", function(Val, OldVal){
        if(parseInt(Val))
        {
            _this.Views.BlackListProfileSelectSection.show();
        }
        else
        {
            _this.Views.BlackListProfileSelectSection.hide();
        }
    });

    this.Views.HardwareSelect.attachEvent("onChange", function(Val, OldVal)
    {
        if(parseInt(Val))
        {
            if(Val != OldVal && parseInt(Val))
            {
                _this.LogsView.HardwareIdToUse = Val;
                _this.LogsView.RefreshFilesList();
            }

            _this.LogsView.Views.Body.enable();
        }
        else
        {
            _this.LogsView.Views.Body.disable();
            _this.LogsView.Views.FilesTree.clearAll();
            _this.LogsView.Signals.FileSelected.next(null);
        }
    });
};

HotSpotViewController.prototype.GetFormByGroup = function(Group)
{
    var _this = this;

    var res = {};
    if(Group == HotSpotSettingsSectionsDic.logs.id)
    {
        res = this.GetLogsForm();
    }
    else if(Group == HotSpotSettingsSectionsDic.tariffs.id)
    {
        res = this.GetTariffsForm();
    }
    else if(Group == HotSpotSettingsSectionsDic.langs.id)
    {
        res = this.GetLangsForm();
    }
    else if(Group == HotSpotSettingsSectionsDic.dhcp.id)
    {
        res = this.GetDHCPView();
    }
    else
    {
        var form_id = "Form" + Group;
        this.Views.Forms[form_id] = null;
        var form_cfg = {
            view: "form",
            id: this.Id + form_id,
            scroll:true,
            // width: 'auto',
            elements:[]
        };

        if(Group == HotSpotSettingsSectionsDic.common.id)
        {
            form_cfg.elements = this.GetCommonFormElements();
        }
        else if(Group == HotSpotSettingsSectionsDic.view.id)
        {
            form_cfg.elements = this.GetViewSettingsFormElements();
        }
        else if(Group == HotSpotSettingsSectionsDic.auth.id)
        {
            form_cfg.elements = this.GetAuthAndClickWrapFormElements();
        }
        else if(Group == HotSpotSettingsSectionsDic.services.id)
        {
            form_cfg.elements = this.GetServicesFormElements()
        }
        else
        {
            form_cfg = {};
        }

        res = form_cfg;
    }


    return res;
};

HotSpotViewController.prototype.GetCommonFormElements = function()
{
    var _this = this;
    var elements = [];

    var hw_select_id = "HardwareSelect";
    this.Views[hw_select_id] = null;
    elements.push({
        cols:[
            {
                id: this.Id + hw_select_id,
                name: "wifi_hardware_id",
                view: "richselect",
                label: LangHelper.GetString(this.Id, "Web server"),
                invalidMessage: LangHelper.GetString(this.Id, "Field is required"),
                labelPosition: "top",
                required: true,
                options: []
            },
            {
                view: "button",
                type: "icon",
                icon: "plus-circle",
                css: "toolbar_round_btn",
                tooltip: LangHelper.GetString(this.Id, "Add new hardware"),
                width: 32,
                click: function()
                {
                    var node = this.getNode();

                    _this.AddHardwareForm.SetData({
                        name: LangHelper.GetString("Dics", "HOTSPOT server"),
                        hardware_type: HardwareTypesEnum.wifi_web
                    });

                    _this.AddHardwareForm.Show(node,"right");

                }
            }
        ],

    });

    elements.push(
        {
            cols: [
                {
                    name: "cp_url",
                    view: "text",
                    label: LangHelper.GetString(this.Id, "Captive portal URL"),
                    invalidMessage: LangHelper.GetString(this.Id, "Input correct url!"),
                    labelPosition: "top",
                    required: true,
                    validate: Helper.IsUrlValid
                },
                {
                    view: "button",
                    type: "icon",
                    icon: "question-circle",
                    css: "toolbar_round_btn",
                    tooltip: LangHelper.GetString(this.Id, "?"),
                    width: 32,
                    click: function()
                    {
                        var node = this.getNode();
                        setTimeout(function(){
                            _this.CaptivePortalFAQContext.show(node, "right");
                        })
                    }
                }
            ]
        }
    );

    elements.push(
        {
            cols: [
                {
                    name: "redirect_url",
                    view: "text",
                    // type: "number",
                    label: LangHelper.GetString(this.Id, "Redirect URL"),
                    tooltip: LangHelper.GetString(this.Id, "Subscriber will be redirected to URL after authorization proceed"),
                    labelPosition: "top",
                    placeholder: "https://www.example.com/",
                    required: true,
                    validate: Helper.IsUrlValid,
                    invalidMessage: LangHelper.GetString(this.Id, "Input correct url!")

                },
                {
                    view: "button",
                    type: "icon",
                    icon: "question-circle",
                    css: "toolbar_round_btn",
                    width:32,
                    popup:{
                        view:"popup",
                        height:80,
                        width: 320,
                        body:{
                            borderless:true,
                            template: LangHelper.GetString(this.Id, "Subscriber will be redirected to URL after authorization proceed")
                        }
                    }
                }
            ]
        }

    );

    elements.push({});

    return elements;
};

HotSpotViewController.prototype.GetLangsForm = function()
{
    var _this = this;
    _this.Views.LangsTable = null;
    _this.Views.LangDataTable = null;

    this.LangDeleteContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Are you sure you want to delete the selected language?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.LangDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            hotkey: "enter",
                            label:LangHelper.GetString("Dics", "Delete"),
                            click:function ()
                            {
                                _this.LangDeleteContext.hide();
                                setTimeout(function(){
                                    var lang = _this.Views.LangsTable.getSelectedItem();
                                    if(lang.code && _this.Langs && _this.Langs[lang.code])
                                    {
                                        _this.Langs[lang.code] = null;
                                    }
                                    delete _this.Langs[lang.code];

                                    if(_this.Settings.base_lang_code == lang.code && Object.keys(_this.Langs).length > 0)
                                    {
                                        _this.Settings.base_lang_code = _this.Langs[Object.keys(_this.Langs)[0]].code;
                                    }

                                    _this.Views.LangsTable.remove(lang.id);


                                    _this.UpdateLangsOptions();
                                },1);
                            }
                        }
                    ]
                }
            ]
        }
    });


    var view  = {
        rows: [
            {
                view: "toolbar",
                height: webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                elements: [
                    {
                        view: "button",
                        type: "icon",
                        icon: "plus",
                        id: this.Id + "AddLangButton",
                        tooltip: LangHelper.GetString(this.Id, "Add new language"),
                        css: "toolbar_round_btn",
                        width: 32,
                        click: function()
                        {
                            _this.Views.CreateLangForm.clear();
                            _this.Views.CreateLangFormContext.show(this.getNode(), "right");
                        }
                    },
                    {
                        width: 8
                    },
                    {
                        view: "button",
                        type: "icon",
                        icon: "check",
                        width: 32,
                        id: this.Id + "DefaultLangButton",
                        tooltip: LangHelper.GetString(_this.Id, "Set as dafault"),
                        disabled: true,
                        css: "toolbar_round_btn",
                        click: function()
                        {
                            var item = _this.Views.LangsTable.getSelectedItem();
                            if(item && item.code)
                            {
                                _this.Settings.base_lang_code = item.code;
                                _this.Views.DefaultLangButton.disable();
                            }
                        }
                    },
                    {}
                ]
            },
            {
                cols: [
                    {
                        rows:[
                            {
                                id: this.Id + "LangsTable",
                                view: "datatable",
                                width: 320,
                                select: "row",
                                columns: [
                                    {
                                        id: "name",
                                        fillspace: true,
                                        header: LangHelper.GetString(_this.Id, "Language"),
                                        template: function(Obj)
                                        {
                                            return "<span class='webix_icon'><img src='assets/imgs/flags/"+Obj.icon+".svg' style='width: 16px;'/></span><span>" + Obj.name + "</span>";
                                        }
                                    },
                                    {
                                        id: "delete",
                                        width: 32,
                                        template: CellTrashBtnTemplate,
                                        header: null
                                    }
                                ],
                                on: {
                                    onAfterSelect: function(row, id)
                                    {
                                        var item = this.getItem(row.id);

                                        _this.Views.LangDataTable.clearAll();
                                        if(_this.Langs && _this.Langs[item.code])
                                        {
                                            var vals = _this.ViewModel.GetLangDefaultVals(item.code);

                                            if(_this.Langs[item.code].vals && Array.isArray(_this.Langs[item.code].vals))
                                            {
                                                _this.Langs[item.code].vals.forEach(Val => {
                                                    const index = vals.findIndex(obj => obj.str_key == Val.str_key);
                                                    if(index >= 0)
                                                    {
                                                        vals[index] = Val;


                                                        if((vals[index].str_key == "click_wrap_auth_checkbox" || vals[index].str_key == "call_text") && !Val.value.includes("<a>"))
                                                        {
                                                            if(vals[index].str_key == "click_wrap_auth_checkbox")
                                                            {
                                                                vals[index].value = "<a>" + vals[index].value + "</a>"
                                                            }
                                                            else
                                                            {
                                                                vals[index].value = vals[index].value + "<a></a>";
                                                            }
                                                        }
                                                    }
                                                });
                                            }

                                            _this.Views.LangDataTable.parse(vals);
                                        }

                                        if(_this.Settings.base_lang_code == item.code)
                                        {
                                            _this.Views.DefaultLangButton.disable();
                                        }
                                        else
                                        {
                                            _this.Views.DefaultLangButton.enable();
                                        }

                                        _this.Views.LangDataTable.enable();
                                    },
                                    onBeforeUnselect: function(row, id)
                                    {
                                        _this.Views.LangDataTable.disable();
                                    },
                                    onItemClick: function (id)
                                    {
                                        if(id.column === 'delete')
                                        {
                                            var __this = this;
                                            setTimeout(function () {
                                                var node = __this.getItemNode(id);
                                                var rowData = __this.getItem(id);
                                                if(rowData && node)
                                                {
                                                    _this.LangDeleteContext.show(node, {pos:"bottom"});
                                                }

                                            }, 10);
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {view: "resizer"},
                    {
                        rows: [
                            {
                                id: this.Id + "LangDataTable",
                                view: "datatable",
                                editable: true,
                                editaction: "dblclick",
                                disabled: true,
                                columns:[
                                    // {
                                    //     id: "edit",
                                    //     width: 32,
                                    //     template: CellEditBtnTemplate,
                                    //     editor: null,
                                    //     header: null
                                    // },
                                    {
                                        id:"str_key",
                                        header:LangHelper.GetString(this.Id, "Key"),
                                        editor: null,
                                        fillspace: true
                                    },
                                    {
                                        id: "value",
                                        header: LangHelper.GetString(this.Id, "Value"),
                                        editor: "text",
                                        fillspace: true,
                                        // gravity: 2
                                    }
                                ],
                                on: {
                                    onAfterEditStop: function(state, editor, ignoreUpdate)
                                    {
                                        var item = this.getItem(editor.row);
                                        if(state.value != state.old)
                                        {
                                            _this.UpdateLangRowValue(item, state.value);
                                        }
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    };

    return view;
};

HotSpotViewController.prototype.GetViewSettingsFormElements = function()
{
    var elems = [];
    var _this = this;

    elems.push({
        rows: [
            {
                view: "label",
                label: LangHelper.GetString(this.Id, "Logo"),
                tooltip: LangHelper.GetString(this.Id, "Logo")
            },
            {
                view: 'image-with-preview-input',
                label: null,
                labelWidth: 0,
                accept:"image/*",
                id: this.Id + "LogoUploader",
                tooltip: LangHelper.GetString(this.Id, "Logo"),
                name: "logo"
            }
        ]
    });

    elems.push({
        rows: [
            {
                view: "label",
                label: LangHelper.GetString(this.Id, "Favicon"),
                tooltip: LangHelper.GetString(this.Id, "Favicon")
            },
            {
                view: 'image-with-preview-input',
                label: null,
                labelWidth: 0,
                id: this.Id + "IconUploader",
                accept:"image/x-icon",
                tooltip: LangHelper.GetString(this.Id, "Favicon"),
                name: "icon"
            }
        ]
    });

    elems.push({});
    return elems;
};

HotSpotViewController.prototype.GetAuthAndClickWrapFormElements = function()
{
    var _this = this;
    var elems = [];

    this.Views.WifiAuthorizationEnabled = null;
    elems.push(
        {
            cols:[
                {
                    id: this.Id + "WifiAuthorizationEnabled",
                    name: "wifi_auth_enabled",
                    view: "richselect",
                    label: LangHelper.GetString(this.Id, "WiFi authorization enabled"),
                    labelPosition: "top",
                    default: 0,
                    options: Helper.DictToArr(YesNoDic)
                },
                {
                    view: "button",
                    type: "icon",
                    icon: "question-circle",
                    css: "toolbar_round_btn",
                    width:32,
                    popup:{
                        view:"popup",
                        height:80,
                        width: 320,
                        body:{
                            borderless:true,
                            template: LangHelper.GetString(this.Id, "WiFi authorization enabled")
                        }
                    }
                }
            ]
        });

    this.Views.ClickWrapEnabled = null;
    elems.push({
        cols: [
            {
                id: this.Id + "ClickWrapEnabled",
                name: "click_wrap_enabled",
                view: "richselect",
                label: LangHelper.GetString(this.Id, "Click wrap enabled"),
                labelPosition: "top",
                default: 0,
                options: Helper.DictToArr(YesNoDic)
            },
            {
                view: "button",
                type: "icon",
                icon: "question-circle",
                css: "toolbar_round_btn",
                width:32,
                popup:{
                    view:"popup",
                    height:80,
                    width: 320,
                    body:{
                        borderless:true,
                        template: LangHelper.GetString(this.Id, "Click wrap enabled")
                    }
                }
            }
        ]
    });

    this.Views.SessionManagementSection = null;
    this.Views.SessionManagementEnabled = null;
    this.Views.SessionLiveTimeSection = null;
    this.Views.SessionInitWebHook = null;
    elems.push({
        id: this.Id + "SessionManagementSection",
        rows:[
            {
                cols: [
                    {
                        id: this.Id + "SessionManagementEnabled",
                        name: "session_management_enabled",
                        view: "richselect",
                        label: LangHelper.GetString(this.Id, "Session management enabled"),
                        labelPosition: "top",
                        default: 1,
                        options: Helper.DictToArr(YesNoDic)
                    },
                    {
                        view: "button",
                        type: "icon",
                        icon: "question-circle",
                        css: "toolbar_round_btn",
                        width:32,
                        popup:{
                            view:"popup",
                            height:160,
                            width: 480,
                            body:{
                                borderless:true,
                                template: LangHelper.GetString(this.Id, "Session management enabled") + "." + "<br><br>" +
                                    LangHelper.GetString(this.Id, "If session management enabled - HotSpot will execute scripts for subscriber session initiation on DPI") + "." +
                                    "<br><br>" + LangHelper.GetString(this.Id, "If disabled - HotSpot will make http request for initiate subscriber session") + "."
                            }
                        }
                    }
                ]
            },
            {
                id: this.Id + "SessionLiveTimeSection",
                cols: [
                    {
                        name: "session_livetime",
                        view: "text",
                        type: "number",
                        label: LangHelper.GetString(this.Id, "Session lifetime"),
                        tooltip: LangHelper.GetString(this.Id, "Session lifetime (sec)"),
                        invalidMessage: LangHelper.GetString(this.Id, "Field is required"),
                        labelPosition: "top",
                        placeholder: "3600",
                        required: true
                    },
                    {
                        view: "button",
                        type: "icon",
                        icon: "question-circle",
                        css: "toolbar_round_btn",
                        width:32,
                        popup:{
                            view:"popup",
                            height:160,
                            width: 480,
                            body:{
                                borderless:true,
                                template: LangHelper.GetString(this.Id, "Subscriber session lifetime, seconds") + ".<br><br>" +
                                    LangHelper.GetString(this.Id, "HotSpot will execute script for delete subscriber from DPI and load auth policing and captive portal service for his IP address") + "."
                            }
                        }
                    }
                ]
            },
            {
                id: this.Id + "SessionInitWebHook",
                rows: [
                    {
                        cols: [
                            {
                                view: "label",
                                label: LangHelper.GetString(this.Id, "Session init Web-hook configuration"),
                                tooltip: LangHelper.GetString(this.Id, "Session init Web-hook configuration")
                            },
                            {
                                view: "button",
                                type: "icon",
                                icon: "question-circle",
                                css: "toolbar_round_btn",
                                width:32,
                                popup:{
                                    view:"popup",
                                    height:160,
                                    width: 480,
                                    body:{
                                        borderless:true,
                                        template: LangHelper.GetString(this.Id, "Subscriber session init HTTP request configuration") + ".<br><br>" +
                                            LangHelper.GetString(this.Id, "HotSpot will make http request for initiate subscriber session") + ".<br><br>" +
                                            LangHelper.GetString(this.Id, "Request template params:") + "<br><ul>" +
                                            "<li>[PHONE] - " + LangHelper.GetString(this.Id, "Phone") + "</li>" +
                                            "<li>[IP] - " + LangHelper.GetString(this.Id, "IP address") + "</li>" +
                                            "</ul>"
                                    }
                                }
                            }
                        ]
                    },
                    {
                        name: "session_init_params",
                        view: "hotspot-http-req-input",
                        only_phone: true,
                        label: null,
                        labelWidth: 0,
                        tooltip: LangHelper.GetString(this.Id, "Session init Web-hook configuration")
                    }
                ]
            }
        ]
    });

    this.Views.AuthConfigSection = null;
    this.Views.AuthType = null;
    this.Views.AuthByCodeSection = null;
    this.Views.SmsAuthEnabled = null;
    this.Views.SmsForm = null;
    this.Views.CallAuthEnabled = null;
    this.Views.CallForm = null;
    this.Views.CodeDebugEnabled = null;
    this.Views.CallPriorityEnabledSection = null;
    this.Views.CallPriorityEnabled = null;
    this.Views.OutgoingCallForm = null;
    this.Views.OutgoingCallPhones = null;

    this.Views.AuthByOutgoingCallSection = null;
    elems.push({
        id: this.Id + "AuthConfigSection",
        rows:[
            {
                cols: [
                    {
                        id: this.Id + "AuthType",
                        name: "auth_type",
                        view: "richselect",
                        label: LangHelper.GetString(this.Id, "Authorization type"),
                        labelPosition: "top",
                        default: WifiAuthorizationType.code.id,
                        options: Helper.DictToArr(WifiAuthorizationType)
                    },
                    {
                        view: "button",
                        type: "icon",
                        icon: "question-circle",
                        css: "toolbar_round_btn",
                        width:32,
                        popup:{
                            view:"popup",
                            height:160,
                            width: 480,
                            body:{
                                borderless:true,
                                template: LangHelper.GetString(this.Id, "Authorization type") + ".<br><br>" +
                                    "<ul>" +
                                    "<li>" + LangHelper.GetString("HotSpot","By auth code") + "</li>" +
                                    "<li>" + LangHelper.GetString("HotSpot","By outgoing call") + "</li>" +
                                    "</ul>"
                            }
                        }
                    }
                ]
            },

            {
                id: this.Id + "AuthByCodeSection",
                rows: [
                    {
                        cols: [
                            {
                                id: this.Id + "SmsAuthEnabled",
                                name: "sms_enabled",
                                view: "richselect",
                                label: LangHelper.GetString(this.Id, "SMS authorization enabled"),
                                labelPosition: "top",
                                default: 0,
                                options: Helper.DictToArr(YesNoDic),
                                on: {
                                    onChange: function(newVal)
                                    {
                                        _this.Signals.SmsAuthEnabledSignal.next(parseInt(newVal));
                                    }
                                }
                            },
                            {
                                view: "button",
                                type: "icon",
                                icon: "question-circle",
                                css: "toolbar_round_btn",
                                width:32,
                                popup:{
                                    view:"popup",
                                    height:80,
                                    width: 240,
                                    body:{
                                        borderless:true,
                                        template: LangHelper.GetString(this.Id, "SMS authorization enabled") + "."
                                    }
                                }
                            }
                        ]
                    },
                    {
                        id: this.Id + "SmsForm",
                        rows: [
                            {
                                cols: [
                                    {
                                        view: "label",
                                        label: LangHelper.GetString(this.Id, "SMS authorization settings"),
                                        tooltip: LangHelper.GetString(this.Id, "SMS authorization settings")
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "question-circle",
                                        css: "toolbar_round_btn",
                                        width:32,
                                        popup:{
                                            view:"popup",
                                            height:160,
                                            width: 480,
                                            body:{
                                                borderless:true,
                                                template: LangHelper.GetString(this.Id, "HTTP request configuration for sending a pre-generated authorization code via SMS") + ".<br><br>" +
                                                    LangHelper.GetString(this.Id, "Request template params:") + "<br><ul>" +
                                                    "<li>[PHONE] - " + LangHelper.GetString(this.Id, "Phone") + "</li>" +
                                                    "<li>[Code] - " + LangHelper.GetString(this.Id, "Code") + "</li>" +
                                                    "</ul>"
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                name: "sms_params",
                                view: "hotspot-http-req-input",
                                label: null,
                                labelWidth: 0,
                                tooltip: LangHelper.GetString(this.Id, "SMS authorization settings")
                            }
                        ]
                    },
                    {
                        cols: [
                            {
                                id: this.Id + "CallAuthEnabled",
                                name: "call_enabled",
                                view: "richselect",
                                label: LangHelper.GetString(this.Id, "Call authorization enabled"),
                                labelPosition: "top",
                                default: 0,
                                options: Helper.DictToArr(YesNoDic),
                                on: {
                                    onChange: function(newVal)
                                    {
                                        _this.Signals.CallAuthEnabledSignal.next(parseInt(newVal));
                                    }
                                }
                            },
                            {
                                view: "button",
                                type: "icon",
                                icon: "question-circle",
                                css: "toolbar_round_btn",
                                width:32,
                                popup:{
                                    view:"popup",
                                    height:80,
                                    width: 240,
                                    body:{
                                        borderless:true,
                                        template: LangHelper.GetString(this.Id, "Call authorization enabled") + "."
                                    }
                                }
                            }
                        ]
                    },
                    {
                        id: this.Id + "CallForm",
                        rows: [
                            {
                                cols: [
                                    {
                                        view: "label",
                                        label: LangHelper.GetString(this.Id, "Call service settings"),
                                        tooltip: LangHelper.GetString(this.Id, "Call service settings")
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "question-circle",
                                        css: "toolbar_round_btn",
                                        width:32,
                                        popup:{
                                            view:"popup",
                                            height:160,
                                            width: 480,
                                            body:{
                                                borderless:true,
                                                template: LangHelper.GetString(this.Id, "HTTP request configuration for sending a pre-generated authorization code via incoming call") + ".<br><br>" +
                                                    LangHelper.GetString(this.Id, "Request template params:") + "<br><ul>" +
                                                    "<li>[PHONE] - " + LangHelper.GetString(this.Id, "Phone") + "</li>" +
                                                    "<li>[Code] - " + LangHelper.GetString(this.Id, "Code") + "</li>" +
                                                    "</ul>"
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                name: "call_params",
                                view: "hotspot-http-req-input",
                                label: null,
                                labelWidth: 0,
                                tooltip: LangHelper.GetString(this.Id, "Call service settings")
                            }
                        ]
                    },
                    {
                        id: this.Id + "CallPriorityEnabledSection",
                        cols: [
                            {
                                id: this.Id + "CallPriorityEnabled",
                                name: "sequential_authorization",
                                view: "richselect",
                                label: LangHelper.GetString(this.Id, "Sequential authorization"),
                                labelPosition: "top",
                                default: 0,
                                options: [
                                    {id: "0", "value": LangHelper.GetString(this.Id, "Disable")},
                                    {id: "1", "value": LangHelper.GetString(this.Id, "Call")},
                                    {id: "2", "value": LangHelper.GetString(this.Id, "SMS")}
                                ],
                                on: {
                                    onChange: function(newVal)
                                    {
                                    }
                                }
                            },
                            {
                                view: "button",
                                type: "icon",
                                icon: "question-circle",
                                css: "toolbar_round_btn",
                                width:32,
                                popup:{
                                    view:"popup",
                                    height:80,
                                    width: 240,
                                    body:{
                                        borderless:true,
                                        template: LangHelper.GetString(this.Id, "This mode allows you to select the initial authorization method") + "."
                                    }
                                }
                            }
                        ]
                    },
                    {
                        cols: [
                            {
                                id: this.Id + "CodeDebugEnabled",
                                name: "debug_mode",
                                view: "richselect",
                                label: LangHelper.GetString(this.Id, "Debug mode"),
                                labelPosition: "top",
                                default: 0,
                                options: Helper.DictToArr(YesNoDic),
                                on: {
                                    onChange: function(newVal)
                                    {
                                    }
                                }
                            },
                            {
                                view: "button",
                                type: "icon",
                                icon: "question-circle",
                                css: "toolbar_round_btn",
                                width:32,
                                popup:{
                                    view:"popup",
                                    height:160,
                                    width: 480,
                                    body:{
                                        borderless:true,
                                        template: LangHelper.GetString(this.Id , "Debug mode allows you to send an authorization code to the email inputed to the phone number field.") + "<br><br>" +
                                            LangHelper.GetString(this.Id , "This function allows you to test after authorizations scripts.")
                                    }
                                }
                            }
                        ]
                    }

                ]
            },
            {
                id: this.Id + "AuthByOutgoingCallSection",
                hidden: true,
                rows: [
                    // {
                    //     id: this.Id + "OutgoingCallForm",
                    //     rows: [
                    //         {
                    //             view: "label",
                    //             label: LangHelper.GetString(this.Id, "Outgoing call service settings"),
                    //             tooltip: LangHelper.GetString(this.Id, "Outgoing call service settings")
                    //         },
                    //         {
                    //             name: "outgoing_call_params",
                    //             view: "hotspot-http-req-input",
                    //             only_phone: true,
                    //             label: null,
                    //             labelWidth: 0,
                    //             tooltip: LangHelper.GetString(this.Id, "Outgoing call service settings")
                    //         }
                    //     ]
                    // },
                    {
                        cols: [
                            {
                                id: this.Id + "delete_phone_lead_7_8",
                                name: "delete_phone_lead_7_8",
                                view: "richselect",
                                label: LangHelper.GetString(this.Id, "Delete leading '+7' and '8' from phone"),
                                labelPosition: "top",
                                default: 0,
                                options: Helper.DictToArr(YesNoDic)
                            },
                            {
                                view: "button",
                                type: "icon",
                                icon: "question-circle",
                                css: "toolbar_round_btn",
                                width:32,
                                popup:{
                                    view:"popup",
                                    height:40,
                                    width: 480,
                                    body:{
                                        borderless:true,
                                        template: LangHelper.GetString(this.Id, "Delete leading '+7' and '8' from phone") + "."
                                    }
                                }
                            }
                        ]
                    },
                    {
                        cols: [
                            {
                                id: this.Id + "OutgoingCallPhones",
                                name: "outgoing_call_phones",
                                view: "text",
                                label: LangHelper.GetString(this.Id, "Outgoing call phones list"),
                                tooltip: LangHelper.GetString(this.Id, "Outgoing call phones list"),
                                labelPosition: "top",
                                required: true
                            },
                            {
                                view: "button",
                                type: "icon",
                                icon: "question-circle",
                                css: "toolbar_round_btn",
                                width:32,
                                popup:{
                                    view:"popup",
                                    height:240,
                                    width: 480,
                                    body:{
                                        borderless:true,
                                        template: LangHelper.GetString(this.Id , "Outgoing call phones list") + ".<br><br>" +
                                            LangHelper.GetString(this.Id , "Input phone numbers separated by comas.") + "<br><br>" +
                                            LangHelper.GetString(this.Id, "HotSpot will select random phone number from list for authorize subscriber by outgoing call.")
                                    }
                                }
                            }
                        ]
                    },
                    {
                        cols: [
                            {
                                name: "hash_key",
                                view: "text",
                                label: LangHelper.GetString(this.Id, "Secret key for hash generating"),
                                tooltip: LangHelper.GetString(this.Id, "Secret key for hash generating"),
                                labelPosition: "top",
                                required: true
                            },
                            {
                                view: "button",
                                type: "icon",
                                icon: "question-circle",
                                css: "toolbar_round_btn",
                                width:32,
                                popup:{
                                    view:"popup",
                                    height:240,
                                    width: 480,
                                    body:{
                                        borderless:true,
                                        template: LangHelper.GetString(this.Id , "Secret key for hash generating") + ".<br><br>" +
                                            LangHelper.GetString(this.Id , "Configure your call service for sending HTTP request on call received from subscriber.") + "<br><br>" +
                                            LangHelper.GetString(this.Id, "Available API method for receiving signal") + ":<br> <b>GET <i>http://[CAPTIVE_PORTAL_URL]/api/call_rcvd?phone=[PHONE]&hash=[HASH]</i></b><br><br>" +
                                            LangHelper.GetString(this.Id, "Hash generating:") + "<br><i>$hash = md5($phone . $secret)</i>"
                                    }
                                }
                            }
                        ]
                    }

                ]
            }
        ]
    });

    elems.push({});

    return elems;
};

HotSpotViewController.prototype.GetServicesFormElements = function()
{
    var elems = [];

    elems.push({
        cols: [
            {
                name: "service_2_enabled",
                view: "richselect",
                label: LangHelper.GetString(this.Id, "Enable Advertising (service id = 2)"),
                labelPosition: "top",
                default: 0,
                options: Helper.DictToArr(YesNoDic)
            },
            {
                view: "button",
                type: "icon",
                icon: "question-circle",
                css: "toolbar_round_btn",
                width:32,
                popup:{
                    view:"popup",
                    height:120,
                    width: 360,
                    body:{
                        borderless:true,
                        template: LangHelper.GetString(this.Id , "Enable Advertising (service id = 2)") + ".<br><br>" +
                            LangHelper.GetString(this.Id , "Advertising service(id=2) will apply for authorized subscriber.")
                    }
                }
            }
        ]
    });

    elems.push({
        cols: [
            {
                name: "service_3_enabled",
                view: "richselect",
                label: LangHelper.GetString(this.Id, "Enable Ad blocking (service id = 3)"),
                labelPosition: "top",
                default: 0,
                options: Helper.DictToArr(YesNoDic)
            },
            {
                view: "button",
                type: "icon",
                icon: "question-circle",
                css: "toolbar_round_btn",
                width:32,
                popup:{
                    view:"popup",
                    height:120,
                    width: 360,
                    body:{
                        borderless:true,
                        template: LangHelper.GetString(this.Id , "Enable Ad blocking (service id = 3)") + ".<br><br>" +
                            LangHelper.GetString(this.Id , "Ad blocking service(id=3) will apply for authorized subscriber.")
                    }
                }
            }
        ]
    });

    this.Views.BlackListEnableSelect = null;
    elems.push(
        {
            cols: [
                {
                    name: "service_4_enabled",
                    id: this.Id + "BlackListEnableSelect",
                    view: "richselect",
                    label: LangHelper.GetString(this.Id, "Enable black list (service id = 4)"),
                    labelPosition: "top",
                    default: 0,
                    options: Helper.DictToArr(YesNoDic)
                },
                {
                    view: "button",
                    type: "icon",
                    icon: "question-circle",
                    css: "toolbar_round_btn",
                    width:32,
                    popup:{
                        view:"popup",
                        height:120,
                        width: 360,
                        body:{
                            borderless:true,
                            template: LangHelper.GetString(this.Id , "Enable black list (service id = 4)") + ".<br><br>" +
                                LangHelper.GetString(this.Id , "Black list service(id=3) will apply for authorized subscriber.")
                        }
                    }
                }
            ]
        }
    );

    this.Views.BlackListProfileSelectSection = null;
    this.Views.BlackListProfileSelect = null;
    elems.push({
        id: this.Id + "BlackListProfileSelectSection",
        cols: [
            {
                name: "service_4_profile",
                id: this.Id + "BlackListProfileSelect",
                view: "richselect",
                label: LangHelper.GetString(this.Id, "Use black list named profile"),
                labelPosition: "top",
                default: 0,
                options: []
            },
            {
                view: "button",
                type: "icon",
                icon: "question-circle",
                css: "toolbar_round_btn",
                width:32,
                popup:{
                    view:"popup",
                    height:120,
                    width: 360,
                    body:{
                        borderless:true,
                        template: LangHelper.GetString(this.Id , "Use black list named profile") + ".<br><br>" +
                            LangHelper.GetString(this.Id , "Black list service named profile will apply for authorized subscriber.")
                    }
                }
            }
        ]
    });

    this.Views.CgnatProfileSelect = null;
    elems.push({
        cols: [
            {
                name: "service_11_profile",
                id: this.Id + "CgnatProfileSelect",
                view: "richselect",
                label: LangHelper.GetString(this.Id, "CGNAT named profile (service id = 11)"),
                labelPosition: "top",
                default: 0,
                options: []
            },
            {
                view: "button",
                type: "icon",
                icon: "question-circle",
                css: "toolbar_round_btn",
                width:32,
                popup:{
                    view:"popup",
                    height:120,
                    width: 360,
                    body:{
                        borderless:true,
                        template: LangHelper.GetString(this.Id , "CGNAT named profile (service id = 11)") + ".<br><br>" +
                            LangHelper.GetString(this.Id , "CGNAT named profile will apply for authorized subscriber (service id = 11).")
                    }
                }
            }
        ]
    })

    elems.push({
        cols: [
            {
                name: "service_50_enabled",
                view: "richselect",
                label: LangHelper.GetString(this.Id, "Enable Notification (service id = 50)"),
                labelPosition: "top",
                default: 0,
                options: Helper.DictToArr(YesNoDic)
            },
            {
                view: "button",
                type: "icon",
                icon: "question-circle",
                css: "toolbar_round_btn",
                width:32,
                popup:{
                    view:"popup",
                    height:120,
                    width: 360,
                    body:{
                        borderless:true,
                        template: LangHelper.GetString(this.Id , "Enable Notification (service id = 50)") + ".<br><br>" +
                            LangHelper.GetString(this.Id , "Notification service(id=50) will apply for authorized subscriber.")
                    }
                }
            }
        ]
    });

    elems.push();

    elems.push({});

    return elems;
};

HotSpotViewController.prototype.GetTariffsForm = function()
{
    var _this = this;

    this.Views.TariffsSection = null;
    this.Views.PolicingCaptiveView = null;
    this.Views.PolicingWifiView = null;

    this.Views.PolicingMultiview = null;
    var view = {
        id: this.Id + "TariffsSection",
        cols: [
            {
                rows:[
                    {
                        id: this.Id + "TariffTable",
                        view: "datatable",
                        width: 320,
                        select: "row",
                        columns: [
                            {
                                id: "tariff_code",
                                fillspace: true,
                                header: LangHelper.GetString(this.Id, "Tariff"),
                                template: function(Obj)
                                {
                                    return TooltipTemplate(Obj.display_name, Obj.tariff_code);
                                }
                            }
                        ],
                        data: [
                            {
                                id: "PolicingCaptiveView",
                                tariff_code: "wifi_hotspot_auth_policing",
                                display_name: LangHelper.GetString(this.Id, "Authorization Policing")
                            },
                            {
                                id: "PolicingWifiView",
                                tariff_code: "wifi_hotspot_policing",
                                display_name: LangHelper.GetString(this.Id, "Wifi Policing")
                            }
                        ],
                        on: {
                            onAfterSelect: function(data)
                            {
                                if(_this.Views[data.id])
                                {
                                    _this.Views[data.id].show();
                                }
                                _this.Views.PolicingMultiview.enable();
                            },
                            onBeforeUnselect: function(data)
                            {
                                _this.Views.PolicingMultiview.disable();
                            }
                        }
                    }
                ]
            },
            {view: "resizer"},
            {
                rows:[
                    {
                        id: this.Id + "PolicingMultiview",
                        disabled:true,
                        view: "multiview",
                        cells: [
                            {
                                id: this.Id + "PolicingCaptiveView",
                                rows:[
                                    this.PolicingCaptiveView.view
                                ]
                            },
                            {
                                id: this.Id + "PolicingWifiView",
                                rows:[
                                    this.PolicingWifiView.view
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };

    return view;
};

HotSpotViewController.prototype.GetLogsForm = function()
{
    return {
        rows: this.LogsView.ViewConfig
    };
};

HotSpotViewController.prototype.GetDHCPView = function()
{
    return {
        rows:[
            {
                type:"space",
                height: 80,
                rows:[
                    {
                        borderless:true,
                        template:"1. " + LangHelper.GetString(this.Id, "Configure <a href=\"https://wiki.vasexperts.ru/doku.php?id=en:dpi:dpi_components:platform:subscriber_management:subsman_remote\">remote ssh commands</a>")
                    },
                    {
                        borderless:true,
                        template:"2. " + LangHelper.GetString(this.Id, "Set up on the trigger for issuing a new IP:")
                    }
                ]
            },
            {
                height: 64,
                type:"space",
                rows:[
                    {
                        borderless: true,
                        template: LangHelper.GetString(this.Id, "For Wi-Fi authorization use this trigger:") +
                            "<br/><u>ssh dpi_user@dpi_host \"/var/dpiui2/add_captive_portal_auth.sh &lt;IP&gt;</u>\""
                    }
                ]
            },
            {
                height: 64,
                type:"space",
                rows:[
                    {
                        borderless: true,
                        template: LangHelper.GetString(this.Id, "If you need only click-wrap function use this trigger:") +
                            "<br/><u>ssh dpi_user@dpi_host \"/var/dpiui2/add_captive_portal_click_wrap.sh &lt;IP&gt;\"</u>"
                    }
                ]
            },
            {}
        ]
    };
};

HotSpotViewController.prototype.UpdateForms = function()
{
    var _this = this;
    this.Settings = this.ViewModel.GetSettings();

    this.Langs = this.Settings && this.Settings.langs ? JSON.parse(this.Settings.langs) : {};
    Object.keys(this.Langs).forEach(Lang => {
        var vals = this.ViewModel.GetLangDefaultVals(Lang);

        if(this.Langs[Lang] && this.Langs[Lang].vals && Array.isArray(this.Langs[Lang].vals))
        {
            this.Langs[Lang].vals.forEach(Val =>
            {
                const index = vals.findIndex(Obj => Obj.str_key == Val.str_key);
                if(index >= 0)
                {
                    vals[index] = Val;
                }
            });
        }

        this.Langs[Lang].vals = vals;
    });

    Object.keys(_this.Views.Forms).forEach(Key => {
        if(Key != "FormServices")
        {
            this.Views.Forms[Key].setValues(this.Settings);
        }
    });

    var services_settings = {};

    try{
        var services = JSON.parse(this.Settings.services);

        if(Array.isArray(services))
        {
            services.forEach(Obj => {
                services_settings['service_' + Obj.id + '_enabled'] = Obj.enabled;
                services_settings['service_' + Obj.id + '_profile'] = Obj.profile;

            });
        }
    }
    catch(e){}

    this.Views.Forms.FormServices.setValues(services_settings);

    this.PolicingCaptiveView.SetData(new PolicingConfigModel(this.Settings.auth_policing ? JSON.parse(this.Settings.auth_policing) : {type: "HTB"}));
    this.PolicingWifiView.SetData(new PolicingConfigModel(this.Settings.wifi_policing ? JSON.parse(this.Settings.wifi_policing) : {type: "HTB"}));

   this.UpdateLangsOptions();

    this.RefreshDics();
};

HotSpotViewController.prototype.UpdateServiceProfilesOptions = function(Service)
{
    var _this = this;

    var form = _this.Views.Forms.FormServices;

    var element_name = "service_" + Service + "_profile";

    form.elements[element_name].getList().clearAll();
    var options = [
        {value:LangHelper.GetString(_this.Id, "No profile"), id: "0", dic_id: "0"}
    ];

    var dicEnum = ServicesDicsEnum[Service];

    if(dicEnum)
    {
        options = options.concat(Helper.DictToArr(App.DicsManager.GetDic(dicEnum)));
    }

    form.elements[element_name].getList().parse(options);
};

HotSpotViewController.prototype.RefreshDics = function()
{
    App.DicsManager.Refresh({data: [DicsEnum.BlackListsProfilesDic, DicsEnum.CgNatProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});
};

HotSpotViewController.prototype.UpdateLangRowValue = function(item, value)
{
    var _this = this;

    var lang = this.Views.LangsTable.getSelectedItem();

    if(this.Langs[lang.code])
    {
        this.Langs[lang.code].vals.forEach(function(Val){
            if(Val.str_key == item.str_key)
            {
                // Val.value = Helper.ReplaceAll('"', '&quot;', Val.value);
                Val.value = Helper.ReplaceAll('"', "\'", Val.value);
            }
        });
    }
};

HotSpotViewController.prototype.SaveSettings = function() {
    var _this = this;

    var data = webix.copy(this.Settings);

    Object.keys(this.Views.Forms).forEach(Form => {
        // var vals = this.Views.Forms[Form].getValues({hidden:false, disabled:false});
        if(Form == "FormServices")
        {
            var serv_config = {};
            Object.keys(this.Views.Forms[Form].elements).forEach(Elem => {
                var splt = Elem.split('_');
                var id = splt[1] + "";
                var key = splt[2];

                if(!serv_config.hasOwnProperty(id))
                {
                    serv_config[id] = {};
                }

                var val = this.Views.Forms[Form].elements[Elem].getValue();
                val = val ? parseInt(val) : 0;
                serv_config[id][key] = val;
            });

            Object.keys(serv_config).forEach(Key => {
                if(serv_config[Key].profile && !serv_config[Key].hasOwnProperty('enabled'))
                {
                    serv_config[Key].enabled = 1;
                }

                serv_config[Key].id = parseInt(Key);

                if(serv_config[Key].enabled && serv_config[Key].profile)
                {
                    var dicEnum = ServicesDicsEnum[serv_config[Key].id];
                    var dic = App.DicsManager.GetDic(dicEnum);

                    if(dic && dic[serv_config[Key].profile])
                    {
                        serv_config[Key].profile_name = dic[serv_config[Key].profile].value;
                    }
                }
            });
            data.services = JSON.stringify(Helper.DictToArr(serv_config));
        }
        else
        {
            Object.keys(this.Views.Forms[Form].elements).forEach(Elem => {
                data[Elem] = this.Views.Forms[Form].elements[Elem].getValue();
            });
        }
    });

    data.auth_policing = JSON.stringify(this.PolicingCaptiveView.GetFormDataJSON().config);
    data.wifi_policing = JSON.stringify(this.PolicingWifiView.GetFormDataJSON().config);
    data.payed_wifi_policing = JSON.stringify(new PolicingConfigModel({type: "HTB"}));

    data.langs = JSON.stringify(this.Langs);

    this.ViewModel.SaveSettings({
        model: data,
        callback: function(R)
        {
            if(R.success)
            {
                _this.ViewModel.RefreshSettings();
                webix.message(LangHelper.GetString(_this.Id, "Settings was successfully saved"));
            }
            else if (R.error)
            {
                webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

HotSpotViewController.prototype.DeleteConfig = function()
{
    var _this = this;

    this.ViewModel.DeleteSettings({
        callback: function(R)
        {
            if(R.success)
            {
                webix.message({text: LangHelper.GetString(_this.Id, "Configuration deleted")});
            }
            else{
                webix.message({text: R.error.msg,type:"error"});
            }
        }
    });
};

HotSpotViewController.prototype.AddLang = function(Params)
{
    var _this = this;
    if(_this.Views.CreateLangForm.validate())
    {
        var data = this.Views.CreateLangForm.getValues();

        if(this.Langs[data.lang])
        {
            webix.message({text: LangHelper.GetString(this.Id, "This language is already existing in dictionary!"),type:"error"});
            return false;
        }

        var obj = FlagsDic[data.lang];

        if(obj)
        {
            var lang = new LangModel({
                code: obj.code,
                name: obj.name,
                icon: obj.icon
            });

            lang.vals = this.ViewModel.GetLangDefaultVals(lang.code);

            var langs_before_add = Object.keys(this.Langs).length;
            _this.Langs[lang.code] = lang;

            _this.UpdateLangsOptions();

            if(!langs_before_add && !this.Settings.base_lang_code)
            {
                this.Settings.base_lang_code = obj.code;
            }

            return true;
        }
        else
        {
            return false;
        }

    }
    else{
        return false;
    }

    return false;
};

HotSpotViewController.prototype.UpdateLangsOptions = function(Params)
{
    var _this = this;

    var langs = [];
    Object.keys(this.Langs).forEach(Key => {
        var lang = this.Langs[Key];

        langs.push({code: lang.code, icon: lang.icon, name: lang.name});
    });

    this.Views.LangsTable.clearAll();
    this.Views.LangsTable.parse(langs);
    this.UpdateAddLangOptions();
};

HotSpotViewController.prototype.UpdateAddLangOptions = function(Params)
{
    var _this = this;
    var item = $$(this.Id + "CreateLangFormLangSwitcher");

    if(item)
    {
        item.getList().clearAll();
        var arr = webix.copy(FlagsDic);
        for(var i in this.Langs)
        {
            if(arr[i])
            {
                arr[i] = null;
                delete arr[i];
            }
        }

        arr = Helper.DictToArr(arr);
    }
    item.getList().parse(arr);
};


function QueryModel(Params)
{
  var _this = this;

    this.id = Params&&Params.id?Params.id:webix.uid();

    this.method = Params&&Params.method?Params.method:QoETriggerActionHttpMethodEnum.GET;
    this.url = Params&&Params.url?Params.url:'';

    this.headers = Params&&Params.headers?Params.headers:[];
    this.body = Params&&Params.body?Params.body:'';
    this.body_type = Params&&Params.body_type?Params.body_type : "Raw";
    this.body_form = Params&&Params.body_form?Params.body_form:[];
    this.valid = true;
};

function HttpRequestViewController(Params)
{
    "use strict";

    var _this = this;
    this.Id = "Query";

    this.Data = new QueryModel(null);

    this.Views = {};

    this.Subscriptions = {};

    this.SaveDataSignal = new Rx.BehaviorSubject(null);

    this.ParamsContext = webix.ui({
        view: "popup",
        id:this.Id + "ParamsContext",
        maxWidth: 400,
        height: 200,
        body: {
            rows:[
                {
                    borderless:true,
                    template:LangHelper.GetString("HotSpot" , "Add parameters to the request body or url for the request to be processed correctly")
                },
                {
                    borderless:true,
                    id:this.Id + "ParamsContextTable",
                    name: "headers",
                    view: "datatable",
                    select:"cell",
                    multiselect:true,
                    clipboard:"selection",
                    resizeColumn:true,
                    tooltip:true,
                    scroll:false,
                    checkboxRefresh:true,
                    autoheight:true,
                    columns:
                    [
                        {
                            id: "name",
                            header: [TooltipTemplate(LangHelper.GetString("QoE", "Name"))],
                            fillspace: 1
                        },
                        {
                            id: "example",
                            header: [TooltipTemplate(LangHelper.GetString("HotSpot", "Example"))],
                            fillspace: 1
                        }
                    ],
                    data:[
                        {
                            "name": LangHelper.GetString("HotSpot","Phone"),
                            "example": "[PHONE]"
                        },
                        {
                            "name": LangHelper.GetString("HotSpot","Code"),
                            "example": "[CODE]"
                        }
                    ]
                }
            ]
        }
    });

    this.ContextConfig = {
        view: "popup",
        minWidth: 240,
        maxWidth: 520,
        minHeight: 240,
        id:this.Id + "Context",
        body: {
            view:"form",
            minWidth: 480,
            id: this.Id + "Form",
            borderless:true,
            elements:[
                {
                    cols:[
                        {
                            id: this.Id + "MethodSelect",
                            view:"richselect",
                            name: "method",
                            label: LangHelper.GetString("QoE","Method"),
                            labelPosition: "top",
                            options:function () {
                                var arr = [];

                                Object.keys(QoETriggerActionHttpMethodEnum).forEach(function (Key) {
                                    arr.push({id:Key, value:Key});
                                });

                                return arr;
                            }()
                        },
                        {
                            view: "text",
                            name: "url",
                            label: LangHelper.GetString("QoE","Url"),
                            labelPosition: "top",
                            tooltip:"http://www.exmple.com",
                            placeholder:"http://www.exmple.com",
                            attributes:{maxlength:1000},
                            gravity:3,
                            on: {
                                "onChange": function () {
                                    this.validate();
                                }
                            }
                        },
                        {
                            view: "button",
                            type: "icon",
                            icon: "code",
                            width: 32,
                            css:"toolbar_round_btn",
                            tooltip:LangHelper.GetString("QoE","Tepmplate parameters"),
                            borderless:true,
                            click: function (id, e, node)
                            {
                                var node = this.getNode(id);
                                _this.ParamsContext.show(node, {pos: "bottom"});
                            }
                        }
                        // {
                        //     align:"right",
                        //     width: 80,
                        //     body:{
                        //         view: "switch",
                        //         name:"enabled",
                        //         onLabel: LangHelper.GetString("QoE","On"),
                        //         offLabel: LangHelper.GetString("QoE","Off"),
                        //
                        //         labelWidth: 0
                        //     }
                        // }
                    ]
                },
                {
                    view:"accordion",
                    multi:true,
                    cols:[
                        {
                            header:LangHelper.GetString("QoE","Headers"),
                            //collapsed:true,
                            body:
                                {
                                    rows:[
                                        {
                                            view: "toolbar",
                                            height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "plus",
                                                    width: 32,
                                                    css:"toolbar_round_btn",
                                                    tooltip:LangHelper.GetString("QoE","Add header"),
                                                    click: function (id, e, node)
                                                    {
                                                        var model = new QoETriggerActionHttpHeaderModel();

                                                        _this.Views.HeadersTable.add(model);
                                                        _this.Views.HeadersTable.editRow(model.id);
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            id:this.Id + "HeadersTable",
                                            name: "headers",
                                            view: "datatable",
                                            select: "row",
                                            minWidth: 200,
                                            resizeColumn:true,
                                            tooltip:true,
                                            scroll:false,
                                            editable:true,
                                            checkboxRefresh:true,
                                            autoheight:true,
                                            columns:
                                                [
                                                    {
                                                        id: "name",
                                                        header: [TooltipTemplate(LangHelper.GetString("QoE", "Name"))],
                                                        fillspace: 1,
                                                        editor: "text"
                                                    },
                                                    {
                                                        id: "value",
                                                        header: [TooltipTemplate(LangHelper.GetString("QoE", "Value"))],
                                                        fillspace: 1,
                                                        editor: "text"
                                                    },
                                                    {
                                                        id: "trash",
                                                        header: "",
                                                        width: 32,
                                                        template: CellTrashBtnTemplate,
                                                        headermenu: false,
                                                        align:"right"
                                                    }
                                                ],
                                            data:[],
                                            on:
                                                {
                                                    onItemClick: function (id,e,node)
                                                    {
                                                        if (id.column === 'trash')
                                                        {
                                                            this.remove(id);
                                                        }
                                                    }
                                                }
                                        }
                                    ]
                                }
                        },
                        {
                            id: this.Id + "QueryBody",
                            header:LangHelper.GetString("QoE","Body"),
                            gravity:2,
                            body:{
                                rows:[
                                    {
                                        view: "richselect",
                                        id: this.Id + "BodyType",
                                        name: "body_type",
                                        label: LangHelper.GetString("HotSpot", "Body type"),
                                        labelPosition: "left",
                                        options:function () {
                                            var arr = [];

                                            Object.keys(QueryBodyTypesEnum).forEach(function (Key) {
                                                arr.push({id:Key, value:Key});
                                            });

                                            return arr;
                                        }()
                                    },
                                    {
                                        id: this.Id + "BodyRow",
                                        view:"codemirror-editor",
                                        name: "body",
                                        minHeight:240
                                    },
                                    {
                                        id:this.Id + "BodyForm",
                                        rows:[
                                            {
                                                view: "toolbar",
                                                height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                elements: [
                                                    {
                                                        view: "button",
                                                        type: "icon",
                                                        icon: "plus",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString("QoE","Add form data"),
                                                        click: function (id, e, node)
                                                        {
                                                            var model = new QoETriggerActionHttpHeaderModel();

                                                            _this.Views.BodyFormTable.add(model);
                                                            _this.Views.BodyFormTable.editRow(model.id);
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                id: this.Id + "BodyFormTable",
                                                name: "body_form",
                                                view: "datatable",
                                                select: "row",
                                                minWidth: 200,
                                                minHeight:200,
                                                resizeColumn:true,
                                                tooltip:true,
                                                scroll:false,
                                                editable:true,
                                                checkboxRefresh:true,
                                                autoheight:true,
                                                columns:
                                                    [
                                                        {
                                                            id: "name",
                                                            header: [TooltipTemplate(LangHelper.GetString("QoE", "Name"))],
                                                            fillspace: 1,
                                                            editor: "text"
                                                        },
                                                        {
                                                            id: "value",
                                                            header: [TooltipTemplate(LangHelper.GetString("QoE", "Value"))],
                                                            fillspace: 1,
                                                            editor: "text"
                                                        },
                                                        {
                                                            id: "trash",
                                                            header: "",
                                                            width: 32,
                                                            template: CellTrashBtnTemplate,
                                                            headermenu: false,
                                                            align:"right"
                                                        }
                                                    ],
                                                data:[],
                                                on:
                                                    {
                                                        onItemClick: function (id,e,node)
                                                        {
                                                            if (id.column === 'trash')
                                                            {
                                                                this.remove(id);
                                                            }
                                                        }
                                                    }
                                            }
                                        ]
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view: "button",
                            label: LangHelper.GetString(this.Id, "Cancel"),
                            click: function () {
                                _this.Hide();
                            }
                        },
                        {
                            view: "button",
                            type: "form",
                            label: LangHelper.GetString(this.Id, "Apply"),
                            // hotkey: "enter",
                            click: function () {
                                setTimeout(function () {

                                    if(_this.Save())
                                    {
                                        _this.Hide();
                                    }

                                }, 10);
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.Init(Params);

    return this;
};

HttpRequestViewController.prototype.Init = function(Params)
{
    "use strict";

    var _this = this;

    if(Params && Params.data)
    {
        this.Data = new QueryModel(Params.data);
    }

    this.Context = webix.ui(this.ContextConfig);
};

HttpRequestViewController.prototype.ViewDidLoad = function(Params)
{
    "use strict";
    var _this = this;

    this.BindAll(Params);

    if(this.Data)
    {
        this.SetData();
    }
};

HttpRequestViewController.prototype.BindAll = function(Params)
{
    "use strict";
    var _this = this;

    this.Views.Form = $$(this.Id + "Form");

    this.Views.HeadersTable = $$(this.Id + "HeadersTable");

    this.Views.QueryBody = $$(this.Id + "QueryBody");
    this.Views.BodyTable = $$(this.Id + "BodyTable");
    this.Views.MethodSelect = $$(this.Id + "MethodSelect");
    this.Views.BodyType = $$(this.Id + "BodyType");
    this.Views.BodyRow = $$(this.Id + "BodyRow");
    this.Views.BodyForm = $$(this.Id + "BodyForm");
    this.Views.BodyFormTable = $$(this.Id + "BodyFormTable");


    if(this.Context)
    {
        this.Context.attachEvent("onHide", function()
        {
            _this.Destroy();
        });
    }

    this.Views.MethodSelect.attachEvent("onChange", function(Val){
        if(Val == QoETriggerActionHttpMethodEnum.POST)
        {
            _this.Views.QueryBody.enable();
        }
        else{
            _this.Views.QueryBody.disable();
        }
    });

    this.Views.BodyType.attachEvent("onChange", function(Val){
        if(Val == QueryBodyTypesEnum.Form)
        {
            _this.Views.BodyRow.hide();
            _this.Views.BodyForm.show();
        }
        else{
            _this.Views.BodyRow.show();
            _this.Views.BodyForm.hide();
        }
    });
};

HttpRequestViewController.prototype.Destroy = function(Params)
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

HttpRequestViewController.prototype.SetData = function()
{
    var _this = this;

    this.Views.Form.setValues(this.Data);

    if(this.Data && this.Data.headers)
    {
        this.Views.HeadersTable.parse(this.Data.headers);
    }

    this.Views.BodyRow.setValue(JSON.stringify(this.Data.body, null, 2));
    // this.Views.Form.elements.body.setValue(JSON.stringify(this.Data.body, null, 2));

    if(this.Data && this.Data.body_form)
    {
        this.Views.BodyFormTable.parse(this.Data.body_form);
    }

};

HttpRequestViewController.prototype.Show = function(Node, Pos)
{
    if(this.Context)
    {
        this.Context.show(Node, {pos:Pos});
    }
};

HttpRequestViewController.prototype.Hide = function()
{
    this.Context.hide();
};

HttpRequestViewController.prototype.Save = function()
{
    var _this = this;

    if(this.Views.Form.validate())
    {

        this.Data = this.Views.Form.getValues();
        this.Data.headers = this.Views.HeadersTable.serialize();
        this.Data.body_form = this.Views.BodyFormTable.serialize();

        // this.Data.body = JSON.parse(this.Data.body);
        this.SaveDataSignal.next(this.Data);
        return true;
    }
    return false;
};
function ImageContextViewController(Params) {
    "use strict";

    var _this = this;
    this.Id = "ImageContext";

    this.id = this.Id;

    this.ImageUrl = Params && Params.img ? Params.img : null;

    this.Views = {};

    this.Subscriptions = {};

    this.Rows = [];

    this.ContextConfig = {
        view: "popup",
        minWidth: 160,
        height: 160,
        id:this.id + "Context",
        body: {

        }
    };

    this.Context = null;

    this.Advanced = false;
    this.TBF = false;
    this.DpiConfig = false;

    this.Init(Params);

    return this;
}


ImageContextViewController.prototype.Init = function (Params) {
    "use strict";
    var _this = this;

    // this.ContextConfig.body = {
    //     view: "label",
    //     label: "<img src='"+_this.ImageUrl+"'/>"
    // };

    _this.ContextConfig.body = {
        rows:[
            // {},
            {
                cols:[
                    // {},
                    {
                        id: this.Id + "Logo",
                        type: "clear",
                        // css: "app_logo_login",
                        borderless: true,
                        template: "<div style='height:120px;background: url("+ _this.ImageUrl + ") center center;background-repeat: no-repeat;background-size: contain;'></div>",
                        height: 120
                        // minHeight: 40,
                        // maxHeight: 240,
                    },
                    // {}
                ]
            },
            // {}
        ]
    };

    _this.Context = webix.ui(this.ContextConfig);

    var img = new Image();

    img.onload = function()
    {
        $$(_this.Id + "Logo").define("template", "<div style='height:"+(img.height >= 120 ? 120 : img.height)+"px;background: url("+ _this.ImageUrl + ") center center;background-repeat: no-repeat;background-size: contain;'></div>");

        $$(_this.Id + "Logo").define("height", img.height >= 120 ? 120 : img.height);
        // $$(_this.id + "Context").define("height", img.height >= 240 ? 240 : img.height);
        $$(_this.Id + "Logo").refresh();
        // $$(_this.id + "Context").refresh();
    };

    img.src = this.ImageUrl;

    // this.ContextConfig.body = {
    //     id: this.Id + "Logo",
    //     type: "clear",
    //     // css: "app_logo_login",
    //     borderless: true,
    //     template: "<div style='height:240px;background: url("+ _this.ImageUrl + ") center center;background-repeat: no-repeat;background-size: contain;'></div>",
    //     minHeight: 40,
    //     maxHeight: 240,
    // };
    //
    //
    // this.Context = webix.ui(this.ContextConfig);
};

ImageContextViewController.prototype.ViewDidLoad = function (Params) {
    "use strict";
    var _this = this;

    this.BindAll(Params);
};

ImageContextViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

ImageContextViewController.prototype.BindAll = function (Params) {
    "use strict";
    var _this = this;

    if(this.Context)
    {
        this.Context.attachEvent("onHide", function()
        {
            _this.Destroy();
        });
    }
};

ImageContextViewController.prototype.Show = function(Node, Pos)
{
    if(this.Context)
    {
        this.Context.show(Node, {pos:Pos});
    }
};

ImageContextViewController.prototype.Hide = function()
{
    this.Context.hide();
};

function MiniFirewallViewController(Params)
{
    var _this = this;

    this.Id = "MiniFirewallService";
    this.id = this.Id;

    this.ViewModel = new MiniFirewallManager();
    this.SubscribersManager = new HardwareSubscribersManager();

    this.ProfileDeleteContext = webix.ui({
        view:"popup",
        width:340,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the profile?")
                    + "<br/><br/>" +  "<span style='color: red'>"
                    + LangHelper.GetString(this.Id, "All subscribers associated with this profile will be unsubscribed from the Mini FireWall service.")
                    + "</span>"
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ProfileDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProfileDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ProfileDeleteContext.hide();

                                var selected = _this.GetProfilesTableSelectedData();

                                if(selected)
                                    _this.DeleteProfile(selected.id);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateProfileContextConfig = {
        view: "popup",
        id: this.Id + "CreateProfileContext",
        width: 440,
        height: 480,
        body: {
            rows: [
                {
                    id: this.Id + "CreateProfileContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        BlockHeaderTemplate({
                            title: LangHelper.GetString(this.Id, "Mini Firewall profile"),
                            icon: "file"
                        }),
                        {
                            view: "text",
                            name: "title",
                            labelWidth: 200,
                            required: true,
                            label: LangHelper.GetString(this.Id, "Description"),
                            tooltip: LangHelper.GetString(this.Id, "Profile title / description"),
                            labelPosition: "left"
                        },
                        {
                            id: this.Id + "ProfileType",
                            view: "text",
                            name: "max_port",
                            labelWidth: 200,
                            label: LangHelper.GetString(this.Id, "Port numbers"),
                            tooltip: LangHelper.GetString(this.Id, "The port number, below which access is blocked"),
                            invalidMessage: LangHelper.GetString(this.Id, "Input correct integer number between 1 and 1024"),
                            required: true,
                            value: 0,
                            validate: function(Val)
                            {
                                if(!Val)
                                {
                                    return false;
                                }

                                var val = parseInt(Val);
                                return val && val > 0 && val <= 65535;
                            },
                            labelPosition: "left"
                        },
                        {
                            view: "text",
                            name: "port_holes",
                            label: LangHelper.GetString(this.Id, "Allowed ports"),
                            labelWidth: 200,
                            tooltip: LangHelper.GetString(this.Id, "List of ports that are allowed to access bypassing the max_port limit"),
                            invalidMessage: LangHelper.GetString(this.Id, "Enter port numbers separated by commas"),
                            // required: true,
                            validate: function (Val) {
                                if(!Val)
                                {
                                    return true;
                                }

                                var arr = Val.split(",");
                                for(var i in arr)
                                {
                                    if(arr[i] <= 0 || arr[i] > 65535)
                                    {
                                        return false;
                                    }
                                }
                                return true;
                            },
                            labelPosition: "left"
                        },
                        {
                            view: "text",
                            name: "out_port",
                            label: LangHelper.GetString(this.Id, "Closed ports"),
                            labelWidth: 200,
                            tooltip: LangHelper.GetString(this.Id, "List of ports to which outbound traffic is closed"),
                            invalidMessage: LangHelper.GetString(this.Id, "Enter port numbers separated by commas"),
                            required: true,
                            validate: function (Val) {
                                if(!Val)
                                {
                                    return false;
                                }

                                var arr = Val.split(",");
                                for(var i in arr)
                                {
                                    if(arr[i] <= 0 || arr[i] > 65535)
                                    {
                                        return false;
                                    }
                                }
                                return true;
                            },
                            labelPosition: "left"
                        },
                        {
                            cols: [
                                {},
                                {
                                    view: "button",
                                    label: LangHelper.GetString(this.Id, "Cancel"),
                                    click: function () {
                                        _this.Views.CreateProfileContext.hide();
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    label: LangHelper.GetString(this.Id, "Save"),
                                    hotkey: "enter",
                                    click: function () {
                                        setTimeout(function () {
                                            if (_this.SaveProfile())
                                                _this.Views.CreateProfileContext.hide()
                                        }, 10);
                                    }
                                }
                            ]
                        }
                    ],
                }
            ]
        }
    };

    this.SubscriberEmbedded = new SubscribersViewController({
        Id: this.Id,
        embedded:true,
        servicesOnly: true,
        services: ["13"],
        MultiSubscribers: {
            Widget: new MultiSubscribersTableWidget({
                id: this.Id + "MultiSubscribersMiniFirewallServiceReport",
            }),
            WidgetName: "MultiSubscribersMiniFirewallServiceWidget"
        }
    });

    this.ProfilesTableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.ViewConfig = [
        {
            cols:[
                {
                    type: "clear",
                    borderless: false,
                    rows: [
                        {
                            view:"accordion",
                            multi:"mixed",
                            cols:[
                                {
                                    header:LangHelper.GetString(this.Id,"Profiles"),
                                    width: 480,
                                    body:{
                                        rows:[
                                            {
                                                view: "toolbar",
                                                height: 40,
                                                padding: 0,
                                                margin: 0,
                                                elements: [
                                                    {
                                                        view: "button",
                                                        id:this.Id + "AddTaskBtn",
                                                        type: "icon",
                                                        icon: "plus",
                                                        align: "right",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Add profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.AddProfileToProfilesTable();
                                                        }
                                                    },
                                                    {
                                                        width:16
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "PlayBtn",
                                                        type: "icon",
                                                        icon: "play-circle",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Enable profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.RunProfile();
                                                        }
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "StopBtn",
                                                        type: "icon",
                                                        icon: "stop-circle",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Disable profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.StopProfile();
                                                        }
                                                    },
                                                    {},
                                                    {
                                                        view: "button",
                                                        id:this.Id+"ProfilesRefreshBtn",
                                                        type: "icon",
                                                        icon: "refresh",
                                                        css: "toolbar_round_btn",
                                                        width: 32,
                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.RefreshProfiles();
                                                        }
                                                    }
                                                ]
                                            },
                                            BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Profiles"), icon:"file"}),
                                            {
                                                view: "treetable",
                                                id: this.Id + "ProfilesTable",
                                                select: "row",
                                                editable: true,
                                                editaction:"custom",
                                                resizeColumn: true,
                                                tooltip:true,
                                                on: {
                                                    onItemClick: function (id,e,node)
                                                    {
                                                        var rowData = this.getItem(id);

                                                        if(id.column === 'run')
                                                        {
                                                            var data = _this.Views.ProfilesTable.getItem(id);

                                                            if(!data.profile_id)
                                                            {
                                                                return;
                                                            }

                                                            if(data.status == MiniFirewallProfileStatusEnum.enabled)
                                                            {
                                                                var __this = this;
                                                                setTimeout(function ()
                                                                {
                                                                    _this.StopProfile();
                                                                }, 10);
                                                            }
                                                            else
                                                            {
                                                                setTimeout(function ()
                                                                {
                                                                    _this.RunProfile();
                                                                }, 10);
                                                            }
                                                        }

                                                        else if (id.column === 'edit')
                                                        {
                                                            _this.ShowProfileEditForm(rowData, this.getItemNode(id), "right");
                                                        }

                                                        else if(id.column === 'trash')
                                                        {
                                                            var __this = this;

                                                            var data = _this.Views.ProfilesTable.getItem(id);

                                                            if(data.title == 'noname' && data.status == MiniFirewallProfileStatusEnum.enabled)
                                                            {
                                                                webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
                                                                return;
                                                            }
                                                            if(!data.profile_id)
                                                            {
                                                                _this.DeleteProfile(id);
                                                                return;
                                                            }

                                                            setTimeout(function () {
                                                                var node = __this.getItemNode(id);
                                                                _this.ProfileDeleteContext.show(node, {pos:"bottom"});
                                                            }, 10);
                                                        }
                                                    },
                                                    onItemDblClick: function(id, e, node)
                                                    {
                                                        var rowData = this.getItem(id);
                                                        if(id.column !== "run" && id.column !== "edit" && id.column !== "trash")
                                                        {
                                                            // _this.ShowTasksEditForm(rowData, this.getItemNode(id), "right");
                                                        }
                                                    },
                                                    onBeforeFilter:function()
                                                    {
                                                        return false;
                                                    },
                                                    onAfterFilter:function()
                                                    {
                                                        _this.RefreshProfiles();
                                                    },
                                                    onBeforeSort:function()
                                                    {
                                                        _this.RefreshProfiles();
                                                        return false;
                                                    },
                                                    onAfterSelect:function ()
                                                    {
                                                        _this.OnProfilesTableRowSelect();
                                                    },
                                                    onAfterUnSelect:function ()
                                                    {
                                                        _this.OnProfilesTableRowSelect();
                                                    }
                                                },
                                                columns: [
                                                    {
                                                        id: "run",
                                                        header: "",
                                                        width: 32,
                                                        template: function (obj, common)
                                                        {
                                                            if(obj.status == MiniFirewallProfileStatusEnum.enabled && obj.profile_id)
                                                            {
                                                                return CellStopBtnTemplate();
                                                            }

                                                            if(obj.profile_id)
                                                            {
                                                                return CellPlayBtnTemplate();
                                                            }

                                                            return "";
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "edit",
                                                        header: "",
                                                        width: 32,
                                                        template: function(obj)
                                                        {
                                                            return CellEditBtnTemplate(obj);
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "title",
                                                        header: [LangHelper.GetString(this.Id,"Profile"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        template:function(obj, common, value, config)
                                                        {
                                                            var tmp = common.treetable(obj, common, value, config) + (obj.title?(obj.title == 'noname' ? LangHelper.GetString(_this.Id,'noname') : obj.title):LangHelper.GetString(_this.Id,"Profile")+" "+obj.profile_id);

                                                            // if(obj.status && obj.title && obj.title !== obj.dpi_name)
                                                            // {
                                                            //     tmp += " (" + obj.dpi_name + ")";
                                                            // }
                                                            return tmp;
                                                        },
                                                        fillspace: true,
                                                        sort: "string"
                                                    },
                                                    {
                                                        id: "status",
                                                        header: [LangHelper.GetString(this.Id,"Status"), {
                                                            content: "richSelectFilter",
                                                            options: Helper.DictToArr(BlStatusesDic),
                                                            inputConfig: {suggest: {fitMaster: false}}
                                                        }],
                                                        width:80,
                                                        template: function (obj, common)
                                                        {
                                                            var statusStr = "";

                                                            if(BlStatusesDic[obj.status])
                                                            {
                                                                statusStr += "<span class=\"status status_" + obj.status + "\">" + BlStatusesDic[obj.status].value + "</span>";
                                                            }

                                                            return statusStr;
                                                        },
                                                        sort: "string"
                                                    },
                                                    {
                                                        id: "trash",
                                                        header: "",
                                                        width: 32,
                                                        template: CellTrashBtnTemplate,
                                                        headermenu: false
                                                    }
                                                ],
                                                data:[]
                                            },
                                            {
                                                view: "toolbar",
                                                padding: 0,
                                                margin: 0,
                                                height:32,
                                                elements: [
                                                    {
                                                        view: "pager",
                                                        gravity:3,
                                                        id: this.Id + "ProfilesTable" + "Paging",
                                                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                        master:false,
                                                        on: {
                                                            onAfterPageChange:function(Page)
                                                            {
                                                                _this.RefreshProfiles(Page);
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"richselect",
                                                        id: this.Id + "ProfilesTable" + "Paging" + "Size",
                                                        label:LangHelper.GetString(_this.Id, "On page"),
                                                        labelWidth:120,
                                                        minWidth:220,
                                                        value:100,
                                                        options:PagingSizeOptions,
                                                        on: {
                                                            onChange:function()
                                                            {
                                                                _this.RefreshProfiles();
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    }

                                },
                                {view:"resizer"},
                                {
                                    header: LangHelper.GetString(this.Id,"Subscribers"),
                                    id: this.Id + "SubsAccord",
                                    body:this.SubscriberEmbedded.view,
                                    gravity: 1
                                },
                                {gravity: 0}
                            ]
                        }
                    ]
                }
                // ]
                // }
            ]
        }
    ];

    this.Views = {};

    this.Subscriptions = {};
};

MiniFirewallViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.SubscriberEmbedded.Destroy();
};

MiniFirewallViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.SubscriberEmbedded.ViewDidLoad(Params);

    this.BindAll();
};

MiniFirewallViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ProfilesTable = $$(this.Id + "ProfilesTable");
    this.Views.ProfilesTablePaging = $$(this.Id + "ProfilesTable" + "Paging");
    this.Views.ProfilesTablePagingSize = $$(this.Id + "ProfilesTable" + "Paging" + "Size");

    this.Views.CreateProfileContext = webix.ui(this.CreateProfileContextConfig);
    this.Views.CreateProfileContextForm = $$(this.Id + "CreateProfileContextForm");
    this.Views.StatusView = $$(this.Id + "StatusView");
    this.Views.PlayBtn = $$(this.Id + "PlayBtn");
    this.Views.StopBtn = $$(this.Id + "StopBtn");

    this.Subscriptions.SignalProfileUpdatedSubscription = this.ViewModel.SignalProfileUpdated.subscribe(function (Profile)
    {
        if(Profile)
        {
            var selectedData = _this.GetProfilesTableSelectedData();

            var rows = _this.Views.ProfilesTable.find(function(obj)
            {
                return obj.profile_id == Profile.profile_id;
            });

            if(rows && rows.length == 1)
            {
                _this.Views.ProfilesTable.updateItem(rows[0].id,  Profile);

                if(selectedData && selectedData.profile_id == Task.profile_id && Task.status != 0)
                {
                    _this.OnProfilesTableRowSelect();
                }
            }
        }
    });

    this.Subscriptions.SignalProfilesUpdatedSubscription = this.ViewModel.SignalProfilesUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateProfilesTable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshProfiles();
        }
    });

    this.Subscriptions.ProfilesTableRowsSelectedCountSubscription = this.ProfilesTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.ProfilesTableRowsSelectedCountSubscriptionHandler(Value);
    });
};

MiniFirewallViewController.prototype.GetProfilesTableSelectedData = function ()
{
    return this.Views.ProfilesTable.getSelectedItem();
};

MiniFirewallViewController.prototype.OnProfilesTableRowSelect = function ()
{
    var data = this.GetProfilesTableSelectedData();

    this.ProfilesTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

MiniFirewallViewController.prototype.RefreshProfiles = function (Page)
{
    var _this = this;

    if(!this.Views.ProfilesTable.$destructed)
    {
        var state = this.Views.ProfilesTable.getState();

        var size = this.Views.ProfilesTablePagingSize.getValue();

        this.ViewModel.RefreshProfiles({page:Page, filter:state.filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}});
    }


    _this.UpdateDics();
    // App.DicsManager.Refresh({data: [DicsEnum.WhiteListsProfilesDic, DicsEnum.BlackListsProfilesDic], filter:App.SessionManager.GetCurrentHardwareId()});
};

MiniFirewallViewController.prototype.UpdateProfilesTable = function (Params)
{
    var _this = this;

    this.Views.ProfilesTable.clearAll();
    this.Views.ProfilesTable.parse(_this.ViewModel.GetProfiles());

    this.Views.ProfilesTablePagingSize.setValue(this.ViewModel.ProfilesFilter.total.size);

    this.Views.ProfilesTablePaging.define(this.ViewModel.ProfilesFilter.total);
    this.Views.ProfilesTablePaging.refresh();
};

MiniFirewallViewController.prototype.UpdateDics = function()
{
    var dicEnum = ServicesDicsEnum[ServicesEnum.firewall];

    App.DicsManager.Refresh({data: [dicEnum], filter:App.SessionManager.GetCurrentHardwareId()});
};

MiniFirewallViewController.prototype.ProfilesTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    var _this = this;

    var _disableAll = function (Profile)
    {
        _this.Views.PlayBtn.disable();
        _this.Views.StopBtn.disable();

    };

    if(Value != 1)
    {
        _disableAll(null);
        return;
    }

    var selectedData = _this.GetProfilesTableSelectedData();

    if(!selectedData)
    {
        _disableAll(selectedData);
        return;
    }

    switch (parseInt(selectedData.status))
    {
        case CgNatProfileStatusEnum.disabled:
            if(selectedData.profile_id)
            {
                _this.Views.PlayBtn.enable();
            }
            else
            {
                _this.Views.PlayBtn.disable();
            }
            _this.Views.StopBtn.disable();
            break;
        case CgNatProfileStatusEnum.enabled:
            _this.Views.PlayBtn.disable();
            _this.Views.StopBtn.enable();
            break;
        default:
            break;
    }
};

MiniFirewallViewController.prototype.RunProfile = function ()
{
    var _this = this;

    var profileData = this.GetProfilesTableSelectedData();

    if(profileData.title == 'noname')
    {
        webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
        return;
    }

    profileData.valid = true;

    this.ViewModel.RunProfile({profile:profileData, callback:function (R)
    {
        if(R.success && R.data)
        {
            _this.Views.ProfilesTable.updateItem(profileData.id,  new MiniFirewallProfileModel(R.data));

            if(R.data.status == MiniFirewallProfileStatusEnum.enabled)
            {
                webix.message(LangHelper.GetString(_this.Id,"Profile enabled"));
            }
            else
            {
                webix.message({text:LangHelper.GetString(this.Id,"Profile not enabled"), type:"debug"});
            }
        }
        else
        {
            profileData.valid = false;

            _this.Views.ProfilesTable.validate(profileData.id);

            if(R.error)
                webix.message({text:R.error.msg,type:"error"});
        }
        _this.UpdateDics();

        _this.OnProfilesTableRowSelect();
    }});
};

MiniFirewallViewController.prototype.StopProfile = function ()
{
    var _this = this;

    var profileData = this.GetProfilesTableSelectedData();
    if(profileData.title == 'noname')
    {
        webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
        return;
    }

    profileData.valid = true;

    this.ViewModel.StopProfile({profile:profileData, callback:function (R)
    {
        if(R.success)
        {
            if(R.data)
            {
                _this.Views.ProfilesTable.updateItem(profileData.id,  new MiniFirewallProfileModel(R.data));

                webix.message(LangHelper.GetString(_this.Id,"Profile disabled"));
            }
            else
            {
                webix.message(LangHelper.GetString(_this.Id,"Profile not disabled"));
            }

        }
        else
        {
            profileData.valid = false;

            _this.Views.ProfilesTable.validate(profileData.id);

            if(R.error)
                webix.message({text:R.error.msg,type:"error"});
        }
        _this.UpdateDics();

        _this.OnProfilesTableRowSelect();
    }});
};

MiniFirewallViewController.prototype.AddProfileToProfilesTable = function ()
{
    var _this = this;

    var model = new MiniFirewallProfileModel({hardware_id: App.SessionManager.GetCurrentHardwareId()});
    model.form_data = JSON.stringify(new MiniFirewallFormModel());

    _this.Views.ProfilesTable.add(model,0);

    _this.Views.ProfilesTable.select(model.id, false);
    _this.Views.ProfilesTable.showItem(model.id);

    _this.ShowProfileEditForm(model, _this.Views.ProfilesTable.getItemNode(model.id), "right");
};

MiniFirewallViewController.prototype.ShowProfileEditForm = function (Data, Node, Pos)
{
    var _this = this;
    if(Data && Data.form_data)
    {
        if(Data.title == 'noname')
        {
            webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
            return;
        }
        var formParams = new MiniFirewallFormModel(JSON.parse(Data.form_data));

        this.Views.CreateProfileContextForm.elements.title.setValue(formParams.title);
        this.Views.CreateProfileContextForm.elements.max_port.setValue(formParams.max_port);
        this.Views.CreateProfileContextForm.elements.port_holes.setValue(formParams.port_holes? formParams.port_holes.join(', ') : '');
        this.Views.CreateProfileContextForm.elements.out_port.setValue(formParams.out_port ? formParams.out_port.join(', ') : '');

        this.Views.CreateProfileContextForm.setValues(formParams);
    }

    this.Views.CreateProfileContext.show(Node,{pos:Pos});
};

MiniFirewallViewController.prototype.SaveProfile = function()
{
    var _this = this;


    if(_this.Views.CreateProfileContextForm.validate())
    {
        var profileData = this.GetProfilesTableSelectedData();

        profileData.valid = true;

        var formData = this.Views.CreateProfileContextForm.getValues();
        formData.out_port = formData.out_port ? formData.out_port.split(',') : [];

        formData.port_holes = formData.port_holes ? formData.port_holes.split(',') : [];

        formData = new MiniFirewallFormModel(formData);
        this.ViewModel.SaveProfile(
            {
                profile:profileData,
                profile_form:formData,
                callback:function (R)
                {
                    if(R.success && R.data && R.data.profile)
                    {
                        _this.Views.ProfilesTable.updateItem(profileData.id,  new MiniFirewallProfileModel(R.data.profile));

                        webix.message(LangHelper.GetString(_this.Id,"Profile saved"));
                    }
                    else
                    {
                        profileData.valid = false;

                        _this.Views.ProfilesTable.validate(profileData.id);

                        if(R.error)
                            webix.message({text:R.error.msg,type:"error"});
                    }
                    _this.UpdateDics();
                    _this.OnProfilesTableRowSelect();
                }
            }
        );

        this.Views.ProfilesTable.validate(profileData.id);
        return true;
    }
    else{
        return false;
    }

};

MiniFirewallViewController.prototype.DeleteProfile = function (RowId)
{
    var _this = this;

    var profileData = this.Views.ProfilesTable.getItem(RowId);
    profileData.valid = true;

    if(profileData.profile_id > 0)
    {
        this.ViewModel.DeleteProfile({profile:profileData, callback:function (R)
        {
            if(R.success)
            {
                _this.Views.ProfilesTable.remove(RowId);

                webix.message(LangHelper.GetString(this.Id,"Profile deleted"));
            }
            else
            {
                profileData.valid = false;
                _this.Views.ProfilesTable.validate(RowId);
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
            _this.UpdateDics();
        }});
    }
    else
    {
        this.Views.ProfilesTable.remove(RowId);
    }
};
function DDoSProtectionViewController(Params)
{
    var _this = this;

    this.Id = "DDoSProtectionService";

    this.ViewModel = new DDoSProtectionManager();
    this.CaptchaViewModel = new CaptchaConfigManager();
    this.SubscribersManager = new HardwareSubscribersManager();

    this.SubscriberEmbedded = new SubscribersViewController({
        Id: this.Id,
        embedded:true,
        servicesOnly: true,
        services: ["10"],
        MultiSubscribers: {
            Widget: new MultiSubscribersTableWidget({
                id: this.Id + "MultiSubscribersDDoSProtectionServiceReport",
            }),
            WidgetName: "MultiSubscribersDDoSProtectionServiceWidget"
        }
    });

    this.ProfileDeleteContext = webix.ui({
        view:"popup",
        width:340,
        height:200,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the profile?")
                        + "<br/><br/>" +  "<span style='color: red'>"
                        + LangHelper.GetString(this.Id, "All subscribers associated with this profile will be unsubscribed from the DDoS Protection service.")
                        + "</span>"
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ProfileDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProfileDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ProfileDeleteContext.hide();

                                var selected = _this.GetProfilesTableSelectedData();

                                if(selected)
                                    _this.DeleteProfile(selected.id);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateProfileContextConfig = {
        view: "popup",
        id: this.Id + "CreateProfileContext",
        maxWidth: 1080,
        height: 600,
        modal: true,
        body: {
            rows: [
                {
                    id: this.Id + "CreateProfileContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        BlockHeaderTemplate({
                            title: LangHelper.GetString(this.Id, "DDoS Protection profile"),
                            icon: "file"
                        }),
                        {
                            cols:[{
                                view: "text",
                                name: "title",
                                labelWidth: 150,
                                inputWidth: 350,
                                required: true,
                                id: this.Id + "ProfileName",
                                label: LangHelper.GetString(this.Id, "Profile name"),
                                tooltip: LangHelper.GetString(this.Id, "Profile title / description"),
                                invalidMessage: LangHelper.GetString(this.Id, "Enter profile name"),
                                labelPosition: "left"
                            }]
                        },
                        {
                            height: 20,
                        },
                        {
                            view: "toolbar",
                            height: 40,
                            elements: [
                                {
                                    view: "tabbar",
                                    id: this.Id + "Tabbar",
                                    width: 400,
                                    close: false,
                                    multiview: true,
                                    options: [
                                        {
                                            id: this.Id + "DoSConfiguration",
                                            value: LangHelper.GetString(_this.Id, "DoS configuration")
                                        },
                                        {
                                            id: this.Id + "DDoSConfiguration",
                                            value: LangHelper.GetString(_this.Id, "DDoS configuration")
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            animate: false,
                            id: this.Id + "TabbarViews",
                            cells: [
                                {
                                    id: this.Id + "DoSConfiguration",
                                    cols: [
                                        {
                                            rows:[
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                        view:"richselect",
                                                        name: "syncf_protection",
                                                        value: DDoSSyncfProtectionEnum[0].id,
                                                        label: LangHelper.GetString(this.Id, "Protection mode"),
                                                        labelPosition: "top",
                                                        options: Helper.DictToArr(DDoSSyncfProtectionEnum),
                                                        labelWidth: 400
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"To switch the protection mode on and off (off by default) ", "ddos_dos_synflood");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view: "richselect",
                                                            name: "syncf_trace",
                                                            value: DDoSSyncfTraceEnum[0].id,
                                                            label: LangHelper.GetString(this.Id, "Logging of protection triggering"),
                                                            labelPosition: "top",
                                                            options: Helper.DictToArr(DDoSSyncfTraceEnum),
                                                            labelWidth: 400
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"Protection triggering logging (default No) ", "ddos_dos_synflood");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "syncf_threshold",
                                                            label: LangHelper.GetString(this.Id, "The sync per second threshold"),
                                                            labelPosition: "top",
                                                            labelWidth: 400,
                                                            placeholder:"50",
                                                            validate: function(Val)
                                                            {
                                                                if(Val === "")
                                                                    return true;

                                                                var val = parseInt(Val);
                                                                return Helper.IsInteger(val) && val > 0;
                                                            },
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter a value higher than 0")
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"Threshold for number of syn per second (no confirmation) when we consider everything OK (default is 50) ", "ddos_dos_synflood");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "syncf_check_tmout",
                                                            label: LangHelper.GetString(this.Id, "The interval of checking the amount of syn in milliseconds"),
                                                            labelPosition: "top",
                                                            labelWidth: 400,
                                                            placeholder:"500",
                                                            validate: function(Val)
                                                            {
                                                                if(Val === "")
                                                                    return true;

                                                                var val = parseInt(Val);
                                                                return Helper.IsInteger(val) && val > 0;
                                                            },
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter a value higher than 0")
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"Interval in milliseconds for checking the number of syn and verified syn (defaults to 100) ", "ddos_dos_synflood");
                                                            }
                                                        }
                                                    ]
                                                },
                                            ]
                                        },
                                        {
                                            width: 10
                                        },
                                        {
                                            rows:[
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "syncf_tracking_packs_time",
                                                            label: LangHelper.GetString(this.Id, "The time interval for monitoring the response to syn+ack"),
                                                            labelPosition: "top",
                                                            labelWidth: 400,
                                                            placeholder:"60",
                                                            validate: function(Val)
                                                            {
                                                                if(Val === "")
                                                                    return true;

                                                                var val = parseInt(Val);
                                                                return Helper.IsInteger(val) && val > 0;
                                                            },
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter a value higher than 0")
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"Time interval in seconds to monitor the syn+ack response generated by the scat (default is 60) ", "ddos_dos_synflood");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "syncf_ports",
                                                            label: LangHelper.GetString(this.Id, "Protected port numbers"),
                                                            labelPosition: "top",
                                                            labelWidth: 400,
                                                            placeholder:"80:443"
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"The main configuration file /etc/dpi/fastdpi.conf specifies the protected port numbers (default is 80, can be changed online) ", "ddos_dos_synflood");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "syncf_unconfirmed_percent",
                                                            label: LangHelper.GetString(this.Id, "% of unconfirmed queries for activating protection"),
                                                            labelPosition: "top",
                                                            labelWidth: 400,
                                                            placeholder:"5",
                                                            validate: function(Val)
                                                            {
                                                                if(Val === "")
                                                                    return true;

                                                                var val = parseInt(Val);
                                                                return Helper.IsInteger(val) && val >= 0 && val <= 100;
                                                            },
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter value between 0 and 100")
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"Percentage of unconfirmed client requests at which protection is automatically activated (default 5, can be changed online) ", "ddos_dos_synflood");
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                },
                                {
                                    id: this.Id + "DDoSConfiguration",
                                    cols: [
                                        {
                                            rows: [
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "ddos_check_server",
                                                            label: LangHelper.GetString(this.Id, "CAPTCHA page"),
                                                            labelPosition: "top",
                                                            placeholder: "server_name.com/path/page.html",
                                                            labelWidth: 400
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "download",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                _this.GetCaptchaIp()
                                                            }
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"CAPTCHA page to be redirected to for verification ", "ddos_settings");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "ddos_security_key",
                                                            label: LangHelper.GetString(this.Id, "Encryption key"),
                                                            labelPosition: "top",
                                                            placeholder: "1234567890",
                                                            labelWidth: 400
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "download",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                _this.GetCaptchaSecurityKey()
                                                            }
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"The encryption key used in generating the tokens that indicate to the dpi that the verification has been successfully passed ", "ddos_settings");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"richselect",
                                                            name: "ddos_trace",
                                                            value: DDoSSyncfTraceEnum[0].id,
                                                            label: LangHelper.GetString(this.Id, "Logging of protection triggering"),
                                                            labelPosition: "top",
                                                            options: Helper.DictToArr(DDoSSyncfTraceEnum),
                                                            labelWidth: 400
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"Protection triggering logging (default No) ", "ddos_settings");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "ddos_reqsec_threshold",
                                                            label: LangHelper.GetString(this.Id, "Number of requests per second in normal operation"),
                                                            labelPosition: "top",
                                                            placeholder: "300",
                                                            labelWidth: 400,
                                                            validate: function(Val)
                                                            {
                                                                if(Val === "")
                                                                    return true;

                                                                var val = parseInt(Val);
                                                                return Helper.IsInteger(val) && val > 0;
                                                            },
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter a value higher than 0")
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"The number of requests per second to the protected site, usually selected at the maximum value observed during normal operation of the site ", "ddos_settings");
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            width: 10
                                        },
                                        {
                                            rows: [
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "ddos_reqsec_variation",
                                                            label: LangHelper.GetString(this.Id, "% of possible rejection of requests during normal operation of the site"),
                                                            labelPosition: "top",
                                                            placeholder: "5",
                                                            labelWidth: 400,
                                                            validate: function(Val)
                                                            {
                                                                if(Val === "")
                                                                    return true;

                                                                var val = parseInt(Val);
                                                                return Helper.IsInteger(val) && val >= 0 && val <= 100;
                                                            },
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter value between 0 and 100")

                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"Is the percentage of possible deviation from the threshold set in ddos_reqsec_threshold at which protection is activated or deactivated respectively, set to avoid the «chatter effect» and set to 5% by default ", "ddos_settings");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "ddos_pktsec_threshold",
                                                            label: LangHelper.GetString(this.Id, "Number of packets per second in normal operation"),
                                                            labelPosition: "top",
                                                            placeholder: "5000",
                                                            labelWidth: 400,
                                                            validate: function(Val)
                                                            {
                                                                if(Val === "")
                                                                    return true;

                                                                var val = parseInt(Val);
                                                                return Helper.IsInteger(val) && val > 0;
                                                            },
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter a value higher than 0")
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"The number of packets per second arriving at the protected site, usually selected at the maximum value observed during normal operation of the site ", "ddos_settings");
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:10},
                                                {
                                                    cols:[
                                                        {
                                                            view:"text",
                                                            name: "ddos_pktsec_variation",
                                                            label: LangHelper.GetString(this.Id, "% of possible deviation of packets during normal operation of the site"),
                                                            labelPosition: "top",
                                                            placeholder: "5",
                                                            labelWidth: 400,
                                                            validate: function(Val)
                                                            {
                                                                if(Val === "")
                                                                    return true;

                                                                var val = parseInt(Val);
                                                                return Helper.IsInteger(val) && val >= 0 && val <= 100;
                                                            },
                                                            invalidMessage: LangHelper.GetString(this.Id, "Enter value between 0 and 100")
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "icon",
                                                            icon: "question-circle",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            click: function () {
                                                                var __this = this;
                                                                var node = __this.getNode();

                                                                _this.ShowHelpPopup(node,"Is the percentage of possible deviation from the threshold set in ddos_pktsec_threshold at which protection is activated or deactivated respectively, set to avoid the «chatter effect» and set to 5% by default ", "ddos_settings");
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                    ]
                                }
                            ]
                        },
                        {
                            height: 20
                        },
                        {
                            cols: [
                                {},
                                {
                                    view: "button",
                                    width: 200,
                                    label: LangHelper.GetString(this.Id, "Cancel"),
                                    click: function () {
                                        _this.Views.CreateProfileContext.hide();
                                    }
                                },
                                {
                                    view: "button",
                                    width: 200,
                                    type: "form",
                                    label: LangHelper.GetString(this.Id, "Save"),
                                    hotkey: "enter",
                                    click: function () {
                                        setTimeout(function () {
                                            if (_this.SaveProfile())
                                                _this.Views.CreateProfileContext.hide()
                                        }, 10);
                                    }
                                }
                            ]
                        }
                    ],
                },
            ],
        }
    };

    this.ProfilesTableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.ViewConfig = [
        {
            cols:[
                {
                    type: "clear",
                    borderless: false,
                    rows: [
                        {
                            view:"accordion",
                            multi:"mixed",
                            cols:[
                                {
                                    header:LangHelper.GetString(this.Id,"Profiles"),
                                    width: 480,
                                    body:{
                                        rows:[
                                            {
                                                view: "toolbar",
                                                height: 40,
                                                padding: 0,
                                                margin: 0,
                                                elements: [
                                                    {
                                                        view: "button",
                                                        id:this.Id + "AddTaskBtn",
                                                        type: "icon",
                                                        icon: "plus",
                                                        align: "right",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Add profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.AddProfileToProfilesTable();
                                                        }
                                                    },
                                                    {
                                                        width:16
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "PlayBtn",
                                                        type: "icon",
                                                        icon: "play-circle",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Enable profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.RunProfile();
                                                        }
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "StopBtn",
                                                        type: "icon",
                                                        icon: "stop-circle",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Disable profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.StopProfile();
                                                        }
                                                    },
                                                    {},
                                                    {
                                                        view: "button",
                                                        id:this.Id+"ProfilesRefreshBtn",
                                                        type: "icon",
                                                        icon: "refresh",
                                                        css: "toolbar_round_btn",
                                                        width: 32,
                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.RefreshProfiles();
                                                        }
                                                    }
                                                ]
                                            },
                                            BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Profiles"), icon:"file"}),
                                            {
                                                view: "treetable",
                                                id: this.Id + "ProfilesTable",
                                                select: "row",
                                                editable: true,
                                                editaction:"custom",
                                                resizeColumn: true,
                                                tooltip:true,
                                                on: {
                                                    onItemClick: function (id,e,node)
                                                    {
                                                        var rowData = this.getItem(id);

                                                        if(id.column === 'run')
                                                        {
                                                            var data = _this.Views.ProfilesTable.getItem(id);

                                                            if(!data.profile_id)
                                                            {
                                                                return;
                                                            }

                                                            if(data.status == DDoSProtectionProfileStatusEnum.enabled)
                                                            {
                                                                setTimeout(function ()
                                                                {
                                                                    _this.StopProfile();
                                                                }, 10);
                                                            }
                                                            else
                                                            {
                                                                setTimeout(function ()
                                                                {
                                                                    _this.RunProfile();
                                                                }, 10);
                                                            }
                                                        }

                                                        else if (id.column === 'edit')
                                                        {
                                                            _this.ShowProfileEditForm(rowData, this.getItemNode(id), "bottom");
                                                        }

                                                        else if(id.column === 'trash')
                                                        {
                                                            var __this = this;

                                                            var data = _this.Views.ProfilesTable.getItem(id);

                                                            if(data.title == 'noname' && data.status == DDoSProtectionProfileStatusEnum.enabled)
                                                            {
                                                                webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
                                                                return;
                                                            }
                                                            if(!data.profile_id)
                                                            {
                                                                _this.DeleteProfile(id);
                                                                return;
                                                            }

                                                            setTimeout(function () {
                                                                var node = __this.getItemNode(id);
                                                                _this.ProfileDeleteContext.show(node, {pos:"bottom"});
                                                            }, 10);
                                                        }
                                                    },
                                                    onBeforeFilter:function()
                                                    {
                                                        return false;
                                                    },
                                                    onAfterFilter:function()
                                                    {
                                                        _this.RefreshProfiles();
                                                    },
                                                    onBeforeSort:function()
                                                    {
                                                        _this.RefreshProfiles();
                                                        return false;
                                                    },
                                                    onAfterSelect:function ()
                                                    {
                                                        _this.OnProfilesTableRowSelect();
                                                    },
                                                    onAfterUnSelect:function ()
                                                    {
                                                        _this.OnProfilesTableRowSelect();
                                                    }
                                                },
                                                columns: [
                                                    {
                                                        id: "run",
                                                        header: "",
                                                        width: 32,
                                                        template: function (obj, common)
                                                        {
                                                            if(obj.status == DDoSProtectionProfileStatusEnum.enabled && obj.profile_id)
                                                            {
                                                                return CellStopBtnTemplate();
                                                            }

                                                            if(obj.profile_id)
                                                            {
                                                                return CellPlayBtnTemplate();
                                                            }

                                                            return "";
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "edit",
                                                        header: "",
                                                        width: 32,
                                                        template: function(obj)
                                                        {
                                                            return CellEditBtnTemplate(obj);
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "title",
                                                        header: [LangHelper.GetString(this.Id,"Profile"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        template:function(obj, common, value, config)
                                                        {
                                                            var tmp = common.treetable(obj, common, value, config) + (obj.title?(obj.title == 'noname' ? LangHelper.GetString(_this.Id,'noname') : obj.title):LangHelper.GetString(_this.Id,"Profile")+" "+obj.profile_id);

                                                            return tmp;
                                                        },
                                                        fillspace: true,
                                                        sort: "string"
                                                    },
                                                    {
                                                        id: "status",
                                                        header: [LangHelper.GetString(this.Id,"Status"), {
                                                            content: "richSelectFilter",
                                                            options: Helper.DictToArr(BlStatusesDic),
                                                            inputConfig: {suggest: {fitMaster: false}}
                                                        }],
                                                        width:80,
                                                        template: function (obj, common)
                                                        {
                                                            var statusStr = "";

                                                            if(BlStatusesDic[obj.status])
                                                            {
                                                                statusStr += "<span class=\"status status_" + obj.status + "\">" + BlStatusesDic[obj.status].value + "</span>";
                                                            }

                                                            return statusStr;
                                                        },
                                                        sort: "string"
                                                    },
                                                    {
                                                        id: "trash",
                                                        header: "",
                                                        width: 32,
                                                        template: CellTrashBtnTemplate,
                                                        headermenu: false
                                                    }
                                                ],
                                                data:[]
                                            },
                                            {
                                                view: "toolbar",
                                                padding: 0,
                                                margin: 0,
                                                height:32,
                                                elements: [
                                                    {
                                                        view: "pager",
                                                        gravity:3,
                                                        id: this.Id + "ProfilesTable" + "Paging",
                                                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                        master:false,
                                                        on: {
                                                            onAfterPageChange:function(Page)
                                                            {
                                                                _this.RefreshProfiles(Page);
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"richselect",
                                                        id: this.Id + "ProfilesTable" + "Paging" + "Size",
                                                        label:LangHelper.GetString(_this.Id, "On page"),
                                                        labelWidth:120,
                                                        minWidth:220,
                                                        value:100,
                                                        options:PagingSizeOptions,
                                                        on: {
                                                            onChange:function()
                                                            {
                                                                _this.RefreshProfiles();
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    }

                                },
                                {view:"resizer"},
                                {
                                    header: LangHelper.GetString(this.Id,"Subscribers"),
                                    id: this.Id + "SubsAccord",
                                    body:this.SubscriberEmbedded.view,
                                    gravity: 1
                                },
                                {gravity: 0}
                            ]
                        }
                    ]
                },
            ]
        }
    ]

    this.Views = {};

    this.Subscriptions = {};
}

DDoSProtectionViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.SubscriberEmbedded.Destroy();
};

DDoSProtectionViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.SubscriberEmbedded.ViewDidLoad(Params);

    this.BindAll();
};

DDoSProtectionViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ProfilesTable = $$(this.Id + "ProfilesTable");
    this.Views.ProfilesTablePaging = $$(this.Id + "ProfilesTable" + "Paging");
    this.Views.ProfilesTablePagingSize = $$(this.Id + "ProfilesTable" + "Paging" + "Size");

    this.Views.CreateProfileContext = webix.ui(this.CreateProfileContextConfig);
    this.Views.CreateProfileContextForm = $$(this.Id + "CreateProfileContextForm");
    this.Views.ProfileType = $$(this.Id + "ProfileType");
    this.Views.StatusView = $$(this.Id + "StatusView");
    this.Views.PlayBtn = $$(this.Id + "PlayBtn");
    this.Views.StopBtn = $$(this.Id + "StopBtn");

    this.Subscriptions.SignalProfileUpdatedSubscription = this.ViewModel.SignalProfileUpdated.subscribe(function (Profile)
    {
        if(Profile)
        {
            var selectedData = _this.GetProfilesTableSelectedData();

            var rows = _this.Views.ProfilesTable.find(function(obj)
            {
                return obj.profile_id == Profile.profile_id;
            });

            if(rows && rows.length == 1)
            {
                _this.Views.ProfilesTable.updateItem(rows[0].id,  Profile);

                if(selectedData && selectedData.profile_id == Task.profile_id && Task.status != 0)
                {
                    _this.OnProfilesTableRowSelect();
                }
            }
        }
    });

    this.Subscriptions.SignalProfilesUpdatedSubscription = this.ViewModel.SignalProfilesUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateProfilesTable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshProfiles();
        }
    });

    this.Subscriptions.ProfilesTableRowsSelectedCountSubscription = this.ProfilesTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.ProfilesTableRowsSelectedCountSubscriptionHandler(Value);
    });
};

DDoSProtectionViewController.prototype.AddProfileToProfilesTable = function ()
{
    var _this = this;

    var model = new DDoSProtectionProfileModel({hardware_id: App.SessionManager.GetCurrentHardwareId()});
    model.form_data = JSON.stringify(new DDoSProtectionFormModel());

    _this.Views.ProfilesTable.add(model,0);

    _this.Views.ProfilesTable.select(model.id, false);
    _this.Views.ProfilesTable.showItem(model.id);

    _this.ShowProfileEditForm(null, _this.Views.ProfilesTable.getItemNode(model.id), "right");
};

DDoSProtectionViewController.prototype.ShowProfileEditForm = function (Data, Node, Pos)
{
    var _this = this;

    var form = this.Views.CreateProfileContextForm;
    form.clear();

    if(Data && Data.form_data)
    {
        var formParams = new DDoSProtectionFormModel(JSON.parse(Data.form_data));

        form.setValues(formParams);
    } else {
        var formCreateParams = new DDoSProtectionFormModel({syncf_protection: 0, syncf_trace: 0, ddos_trace: 0});

        form.setValues({syncf_protection: formCreateParams.syncf_protection, syncf_trace: formCreateParams.syncf_trace, ddos_trace: formCreateParams.ddos_trace})
    }


    this.Views.CreateProfileContext.show(Node,{pos:Pos});
};

DDoSProtectionViewController.prototype.ProfilesTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    var _this = this;

    var _disableAll = function (Profile)
    {
        _this.Views.PlayBtn.disable();
        _this.Views.StopBtn.disable();

    };

    if(Value != 1)
    {
        _disableAll(null);
        return;
    }

    var selectedData = _this.GetProfilesTableSelectedData();

    if(!selectedData)
    {
        _disableAll(selectedData);
        return;
    }

    switch (parseInt(selectedData.status))
    {
        case CgNatProfileStatusEnum.disabled:
            if(selectedData.profile_id)
            {
                _this.Views.PlayBtn.enable();
            }
            else
            {
                _this.Views.PlayBtn.disable();
            }
            _this.Views.StopBtn.disable();
            break;
        case CgNatProfileStatusEnum.enabled:
            _this.Views.PlayBtn.disable();
            _this.Views.StopBtn.enable();
            break;
        default:
            break;
    }
};

DDoSProtectionViewController.prototype.GetProfilesTableSelectedData = function ()
{
    return this.Views.ProfilesTable.getSelectedItem();
};

DDoSProtectionViewController.prototype.OnProfilesTableRowSelect = function ()
{
    var data = this.GetProfilesTableSelectedData();

    this.ProfilesTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

DDoSProtectionViewController.prototype.UpdateProfilesTable = function (Params)
{
    var _this = this;

    this.Views.ProfilesTable.clearAll();
    this.Views.ProfilesTable.parse(this.ViewModel.GetProfiles());

    this.Views.ProfilesTablePagingSize.setValue(this.ViewModel.ProfilesFilter.total.size);

    this.Views.ProfilesTablePaging.define(this.ViewModel.ProfilesFilter.total);
    this.Views.ProfilesTablePaging.refresh();
};

DDoSProtectionViewController.prototype.SaveProfile = function()
{
    var _this = this;


    if(_this.Views.CreateProfileContextForm.validate())
    {
        var profileData = this.GetProfilesTableSelectedData();

        profileData.valid = true;

        var formData = this.Views.CreateProfileContextForm.getValues();

        formData = new DDoSProtectionFormModel(formData);
        this.ViewModel.SaveProfile(
            {
                profile:profileData,
                profile_form:formData,
                callback:function (R)
                {
                    if(R.success && R.data && R.data.profile)
                    {
                        _this.Views.ProfilesTable.updateItem(profileData.id,  new DDoSProtectionProfileModel(R.data.profile));

                        webix.message(LangHelper.GetString(_this.Id,"Profile saved"));
                    }
                    else
                    {
                        profileData.valid = false;

                        _this.Views.ProfilesTable.validate(profileData.id);

                        if(R.error)
                            webix.message({text:R.error.msg,type:"error"});
                    }
                    _this.UpdateDics();
                    _this.OnProfilesTableRowSelect();
                }
            }
        );

        this.Views.ProfilesTable.validate(profileData.id);
        return true;
    }
    else{
        return false;
    }

};

DDoSProtectionViewController.prototype.UpdateDics = function()
{
    var dicEnum = ServicesDicsEnum[ServicesEnum.ddos_guard];

    App.DicsManager.Refresh({data: [dicEnum], filter:App.SessionManager.GetCurrentHardwareId()});
};

DDoSProtectionViewController.prototype.RefreshProfiles = function (Page)
{
    var _this = this;

    if(!this.Views.ProfilesTable.$destructed)
    {
        var state = this.Views.ProfilesTable.getState();

        var size = this.Views.ProfilesTablePagingSize.getValue();

        this.ViewModel.RefreshProfiles({page:Page, filter:state.filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}});
    }


    _this.UpdateDics();
};

DDoSProtectionViewController.prototype.DeleteProfile = function (RowId)
{
    var _this = this;

    var profileData = this.Views.ProfilesTable.getItem(RowId);
    profileData.valid = true;

    if(profileData.profile_id > 0)
    {
        this.ViewModel.DeleteProfile({profile:profileData, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.ProfilesTable.remove(RowId);

                    webix.message(LangHelper.GetString(this.Id,"Profile deleted"));
                }
                else
                {
                    profileData.valid = false;
                    _this.Views.ProfilesTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
                _this.UpdateDics();
            }});
    }
    else
    {
        this.Views.ProfilesTable.remove(RowId);
    }
};

DDoSProtectionViewController.prototype.GetProfilesTableSelectedData = function ()
{
    return this.Views.ProfilesTable.getSelectedItem();
};

DDoSProtectionViewController.prototype.RunProfile = function ()
{
    var _this = this;

    var profileData = this.GetProfilesTableSelectedData();

    if(profileData.title == 'noname')
    {
        webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
        return;
    }

    profileData.valid = true;

    this.ViewModel.RunProfile({profile:profileData, callback:function (R)
        {
            if(R.success && R.data)
            {
                _this.Views.ProfilesTable.updateItem(profileData.id,  new DDoSProtectionProfileModel(R.data));

                if(R.data.status == DDoSProtectionProfileStatusEnum.enabled)
                {
                    webix.message(LangHelper.GetString(_this.Id,"Profile enabled"));
                }
                else
                {
                    webix.message({text:LangHelper.GetString(this.Id,"Profile not enabled"), type:"debug"});
                }
            }
            else
            {
                profileData.valid = false;

                _this.Views.ProfilesTable.validate(profileData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.UpdateDics();
            _this.OnProfilesTableRowSelect();
        }});
};

DDoSProtectionViewController.prototype.StopProfile = function ()
{
    var _this = this;

    var profileData = this.GetProfilesTableSelectedData();
    if(profileData.title == 'noname')
    {
        webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
        return;
    }

    profileData.valid = true;

    this.ViewModel.StopProfile({profile:profileData, callback:function (R)
        {
            if(R.success)
            {
                if(R.data)
                {
                    _this.Views.ProfilesTable.updateItem(profileData.id,  new DDoSProtectionProfileModel(R.data));

                    webix.message(LangHelper.GetString(_this.Id,"Profile disabled"));
                }
                else
                {
                    webix.message(LangHelper.GetString(_this.Id,"Profile not disabled"));
                }

            }
            else
            {
                profileData.valid = false;

                _this.Views.ProfilesTable.validate(profileData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.UpdateDics();
            _this.OnProfilesTableRowSelect();
        }});
};

DDoSProtectionViewController.prototype.ShowHelpPopup = function (Node, Text, Link = null)
{
    webix.ui({
        view:"popup",
        body:{
            view:"template",
            borderless:true,
            width: 300,
            autoheight: true,
            template:LangHelper.GetString(this.Id, Text) + "<br/><br/>" + (Link ? `<a href=${LangHelper.GetString("WikiLinks", Link)} target="_blank">${LangHelper.GetString(this.Id, "Link to wiki")}</a>` : "")
        }
    }).show(Node, {pos:"bottom"})
}

DDoSProtectionViewController.prototype.GetCaptchaIp = function()
{
    var _this = this;

        this.ViewModel.GetCaptchaIp(
            {
                callback:function (R)
                {
                    if(R.success && R.data)
                    {
                        _this.Views.CreateProfileContextForm.elements.ddos_check_server.setValue(`${R.data}/?`)
                    }
                    else
                    {
                        if(R.error)
                            webix.message({text:R.error.msg,type:"error"});
                    }
                }
            }
        );

        return true;

};

DDoSProtectionViewController.prototype.GetCaptchaSecurityKey = function()
{
    var _this = this;

    this.ViewModel.GetCaptchaSecurityKey(
        {
            callback:function (R)
            {
                if(R.success && R.data)
                {
                    var parser = new ConfigIniParser();
                    parser.parse(R.data);

                    configModel = new CaptchaConfigModel(parser.itemsKeyVal());
                    _this.Views.CreateProfileContextForm.elements.ddos_security_key.setValue(configModel.captcha_key)
                }
                else
                {
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }
        }
    );

    return true;

};
function SessionPolicingsViewController(Params)
{
    var _this = this;

    this.Id = "SessionPolicingsService";

    this.ViewModel = new SessionPolicingsManager();
    this.SubscribersManager = new HardwareSubscribersManager();

    this.ReportsModel = new UniReportsManager();

    this.SubscriberEmbedded = new SubscribersViewController({
        Id: this.Id,
        embedded:true,
        servicesOnly: true,
        services: ["18"],
        MultiSubscribers: {
            Widget: new MultiSubscribersTableWidget({
                id: this.Id + "MultiSubscribersSessionPolicingsServiceReport",
            }),
            WidgetName: "MultiSubscribersSessionPolicingsServiceWidget"
        }
    });

    this.RedirectToConfigContext = webix.ui({
        view:"popup",
        modal: true,
        width:480,
        height:200,
        left: (window.innerWidth / 2 ) - 240,
        top: (window.innerHeight / 2) - 100,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:"<div style='color: red'>" + LangHelper.GetString(_this.Id, "Configuration error!") + "<br/><hr style='border: 0.1px solid #eaeef5'></div>" +
                    "<span>" +
                    LangHelper.GetString(_this.Id, "In your configuration, the parameter (support_service_18) is disabled, which is necessary for the correct operation of this service. Go to the configuration section?") +
                    "</span>"
                },
                {
                    cols:[
                        {
                            view: "button",
                            height: 40,
                            label: LangHelper.GetString("Dics", "Cancel"),
                            click: function()
                            {
                                _this.RedirectToConfigContext.hide();
                            }
                        },
                        {
                            view:"button",
                            height: 40,
                            type:"form",
                            icon: "bolt",
                            label: LangHelper.GetString(_this.Id,"Go to"),
                            click:function ()
                            {
                                var node = this.getNode();
                                setTimeout(function ()
                                {
                                    _this.RedirectToConfigContext.hide();
                                    App.NavRouter.PresentView({id: ControllersEnum.DpiConfig});
                                }, 10);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ProfileDeleteContext = webix.ui({
        view:"popup",
        width:340,
        height:200,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the profile?")
                        + "<br/><br/>" +  "<span style='color: red'>"
                        + LangHelper.GetString(this.Id, "All subscribers associated with this profile will be unsubscribed from the Session Policings service.")
                        + "</span>"
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ProfileDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProfileDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ProfileDeleteContext.hide();

                                var selected = _this.GetProfilesTableSelectedData();

                                if(selected)
                                    _this.DeleteProfile(selected.id);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateProtocolsContextFormConfig = {
        view: "popup",
        modal:true,
        id: this.Id + "CreateProtocolsContext",
        width: 600,
        height: 480,
        body:{
            rows:[
                {
                    id:this.Id + "CreateProtocolsContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0, 
                    elements: [
                        {
                            view: "combo",
                            id: _this.Id + "CreateProtocolsContextForm" + "ProtocolType",
                            name: "type",
                            labelWidth:300,
                            label: LangHelper.GetString("UlrModule", "Mode"),
                            options: {
                                point: false,
                                data: function()
                                {
                                    return Helper.DictToArr(UlrProtocolTypesDic).filter(item => item.id !== UlrProtocolTypesDic.custom_group.id);
                                }()
                            },
                            required: true,
                            value: SessionPolicingProtocolTypeEnum.protocol,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                            on: {
                                "onChange": function (Val, oldVal) {
                                    let form = _this.Views.CreateProtocolsContextForms.CreateProtocolsContextForm;
                                    let id = form.config.id;

                                    if(Val === SessionPolicingProtocolTypeEnum.protocol)
                                    {
                                        let protocols =
                                        {
                                            view: "text",
                                            id: id + "ProtocolInput",
                                            name: "value",
                                            labelWidth:300,
                                            label: LangHelper.GetString("UlrModule", "Application protocol"),
                                            suggest: {
                                                data: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsDic),
                                                template: "#value#",
                                                filter: function(obj, value)
                                                {
                                                    return true;
                                                }
                                            },
                                            keyPressTimeout: 500,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                            on: {
                                                onChange: function(Nv, Ov)
                                                {
                                                    _this.Signals.ProtocolInputValue.next(Nv);
                                                    _this.Views.CreateProtocolsContextForms.CreateProtocolsContextForm.clearValidation();
                                                },
                                                onTimedKeyPress: function()
                                                {
                                                    var val = this.getValue();
                                
                                                    if(val && typeof val == "string" && val != val.trim())
                                                    {
                                                        this.setValue(val.trim());
                                                        return;
                                                    }
                                
                                                    _this.Signals.ProtocolInputValue.next(val);
                                
                                                    App.DicsManager.Refresh({data:[DicsEnum.ProtocolsDic], filter:val});
                                                }
                                            }
                                        };

                                        webix.ui(protocols, form, $$(id + "ProtocolInput"));
                                        _this.SetProtocolInput();
                                    }
                                    else if(Val === SessionPolicingProtocolTypeEnum.group){
                                        let groups =
                                        {
                                            id: id + "ProtocolInput",
                                            view: "combo",
                                            name: "value",
                                            disabled: true,
                                            labelWidth:300,
                                            label: LangHelper.GetString("UlrModule", "Protocols group"),
                                            options: {
                                                point: false,
                                                data: []
                                            },
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                            on: {
                                                "onChange": function (Nv, Ov)
                                                {
                                                    _this.Signals.ProtocolGroupsInputValue.next(Nv);
                                                    _this.Views.CreateProtocolsContextForms.CreateProtocolsContextForm.clearValidation();
                                                }
                                            }
                                        };

                                        webix.ui(groups, form, $$(id + "ProtocolInput"));
                                        _this.SetProtocolGroupInput();
                                    }
                                }
                            }
                        },
                        {
                            view: "text",
                            id: _this.Id + "CreateProtocolsContextForm" + "ProtocolInput",
                            name: "value",
                            labelWidth:300,
                            label: LangHelper.GetString("UlrModule", "Application protocol"),
                            suggest: {
                                data: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsDic),
                                template: "#value#",
                                filter: function(obj, value)
                                {
                                    return true;
                                }
                            },
                            keyPressTimeout: 500,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                            on: {
                                onChange: function(Nv, Ov)
                                {
                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                    {
                                        this.setValue(Nv.trim());
                                        return;
                                    }

                                    _this.Signals.ProtocolInputValue.next(Nv);
                                    _this.Views.CreateProtocolsContextForms.CreateProtocolsContextForm.clearValidation();
                                },
                                onTimedKeyPress: function()
                                {
                                    var val = this.getValue();

                                    if(val && typeof val == "string" && val != val.trim())
                                    {
                                        this.setValue(val.trim());
                                        return;
                                    }

                                    _this.Signals.ProtocolInputValue.next(val);

                                    App.DicsManager.Refresh({data:[DicsEnum.ProtocolsDic], filter:val});
                                }
                            }
                        },
                        {
                            view:"combo",
                            id:_this.Id + "PriorityInput",
                            name:"priority",
                            labelWidth:300,
                            label:LangHelper.GetString("UlrModule","Priority"),
                            //value:"cs0",
                            options:{
                                view:"gridsuggest",
                                point:false,
                                body:{
                                    autoheight:false,
                                    scroll:true,
                                    maxHeight:400,
                                    //width:800,
                                    //minWidth:800,
                                    borderless:true,
                                    columns:[
                                        { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                        { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                        { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                        { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                        { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                        { id:"class_order_1", header:"class_order=1", width:160}
                                    ],
                                    data:Helper.DictToArr(DscpDic)
                                }
                            },
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                            on:{
                                onChange:function(Nv, Ov)
                                {
                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                    {
                                        this.setValue(Nv.trim());
                                        return;
                                    }

                                    _this.Signals.PriorityInputValue.next(Nv);
                                    _this.Views.CreateProtocolsContextForms.CreateProtocolsContextForm.clearValidation();
                                }
                            }
                        },
                        {
                            cols: [
                                {
                                    view: "text",
                                    name: "inbound",
                                    labelWidth:300,
                                    width: 480,
                                    label: LangHelper.GetString("Tariffs", "Inbound rate"),
                                    invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                    validate: function (Val) {
                                        return !isNaN(Val * 1);
                                    },
                                    on: {
                                        onChange: function (Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "combo",
                                    name: "inbound_unit",
                                    value: "mbit",
                                    options:{
                                        point:false,
                                        data:Helper.DictToArr(TrafficUnits)
                                    }
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    view: "text",
                                    name: "outbound",
                                    labelWidth:300,
                                    width: 480,
                                    label: LangHelper.GetString("Tariffs", "Outbound rate"),
                                    invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                    validate: function (Val) {
                                        return !isNaN(Val * 1);
                                    },
                                    on: {
                                        onChange: function (Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "combo",
                                    name: "outbound_unit",
                                    value: "mbit",
                                    options:{
                                        point:false,
                                        data:Helper.DictToArr(TrafficUnits)
                                    }
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    view: "text",
                                    name: "burst_inbound",
                                    labelWidth:300,
                                    width: 480,
                                    label: LangHelper.GetString("Tariffs", "Burst inbound rate"),
                                    invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                    validate: function (Val) {
                                        return !isNaN(Val * 1);
                                    },
                                    on: {
                                        onChange: function (Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "combo",
                                    name: "burst_inbound_unit",
                                    value: "mbit",
                                    options:{
                                        point:false,
                                        data:Helper.DictToArr(TrafficUnits)
                                    }
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    view: "text",
                                    name: "burst_outbound",
                                    labelWidth:300,
                                    width: 480,
                                    label: LangHelper.GetString("Tariffs", "Burst outbound rate"),
                                    invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                    validate: function (Val) {
                                        return !isNaN(Val * 1);
                                    },
                                    on: {
                                        onChange: function (Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "combo",
                                    name: "burst_outbound_unit",
                                    value: "mbit",
                                    options:{
                                        point:false,
                                        data:Helper.DictToArr(TrafficUnits)
                                    }
                                }
                            ]
                        },
                        {height: 20},
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString(this.Id,"Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.CreateProtocolsContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "CreateProtocolsContextFormSaveBtn",
                                    type:"form",
                                    label:LangHelper.GetString(this.Id,"Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.SaveProtocol();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ProtocolsDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.ProtocolsDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ProtocolsDeleteContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.ProtocolsDeleteContext.hide();

                                _this.DeleteProtocolsSelectedRows();
                            }
                        }
                    ]
                }
            ]
        }
    });


    this.CreateProfileContextConfig = {
        view: "popup",
        id: this.Id + "CreateProfileContext",
        // maxWidth: 1080,
        // height: 600,
        modal: true,
        body: {
            rows: [
                {
                    id: this.Id + "CreateProfileContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "text",
                            name: "title",
                            labelWidth: 150,
                            inputWidth: 350,
                            required: true,
                            id: this.Id + "ProfileName",
                            label: LangHelper.GetString(this.Id, "Profile name"),
                            tooltip: LangHelper.GetString(this.Id, "Profile title / description"),
                            invalidMessage: LangHelper.GetString(this.Id, "Enter profile name"),
                            labelPosition: "left"
                        },
                        {
                            cols: [
                                {},
                                {
                                    view: "button",
                                    width: 200,
                                    label: LangHelper.GetString(this.Id, "Cancel"),
                                    click: function () {
                                        _this.Views.CreateProfileContext.hide();
                                    }
                                },
                                {
                                    view: "button",
                                    width: 200,
                                    type: "form",
                                    label: LangHelper.GetString(this.Id, "Save"),
                                    hotkey: "enter",
                                    click: function () {
                                        setTimeout(function () {
                                            if (_this.SaveProfile())
                                                _this.Views.CreateProfileContext.hide()
                                        }, 10);
                                    }
                                }
                            ]
                        }
                    ]
                },
            ],
        }
    };

    this.ViewConfig = [
        {
            cols:[
                {
                    type: "clear",
                    borderless: false,
                    rows: [
                        {
                            view:"accordion",
                            multi:"mixed",
                            cols:[
                                {
                                    header:LangHelper.GetString(this.Id,"Profiles"),
                                    width: 420,
                                    body:{
                                        rows:[
                                            {
                                                view: "toolbar",
                                                height: 40,
                                                padding: 0,
                                                margin: 0,
                                                elements: [
                                                    {
                                                        view: "button",
                                                        id:this.Id + "AddProfileBtn",
                                                        type: "icon",
                                                        icon: "plus",
                                                        align: "right",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Add profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.AddProfileToProfilesTable();
                                                        }
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "AddSubProfileBtn",
                                                        type: "icon",
                                                        icon: "plus-square",
                                                        align: "right",
                                                        hidden:true,
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Add subprofile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.AddSubTaskToTasksTable();
                                                        }
                                                    },
                                                    {
                                                        width:16
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "PlayBtn",
                                                        type: "icon",
                                                        icon: "play-circle",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Enable profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.RunProfile();
                                                        }
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "StopBtn",
                                                        type: "icon",
                                                        icon: "stop-circle",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Disable profile"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.StopProfile();
                                                        }
                                                    },
                                                    {},
                                                    {
                                                        view: "button",
                                                        id:this.Id+"ProfilesRefreshBtn",
                                                        type: "icon",
                                                        icon: "refresh",
                                                        css: "toolbar_round_btn",
                                                        width: 32,
                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.RefreshProfiles();
                                                        }
                                                    }
                                                ]
                                            },
                                            BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Profiles"), icon:"file"}),
                                            {
                                                view: "treetable",
                                                id: this.Id + "ProfilesTable",
                                                select: "row",
                                                editable: true,
                                                editaction:"custom",
                                                resizeColumn: true,
                                                tooltip:true,
                                                on: {
                                                    onItemClick: function (id,e,node)
                                                    {
                                                        var rowData = this.getItem(id);

                                                        if(id.column === 'run')
                                                        {
                                                            var data = _this.Views.ProfilesTable.getItem(id);

                                                            if(!data.profile_id)
                                                            {
                                                                return;
                                                            }

                                                            if(data.status == DDoSProtectionProfileStatusEnum.enabled)
                                                            {
                                                                setTimeout(function ()
                                                                {
                                                                    _this.StopProfile();
                                                                }, 10);
                                                            }
                                                            else
                                                            {
                                                                setTimeout(function ()
                                                                {
                                                                    _this.RunProfile();
                                                                }, 10);
                                                            }
                                                        }

                                                        else if (id.column === 'edit')
                                                        {
                                                            _this.ShowProfileEditForm(rowData, this.getItemNode(id), "bottom");
                                                        }

                                                        else if(id.column === 'trash')
                                                        {
                                                            var __this = this;

                                                            var data = _this.Views.ProfilesTable.getItem(id);

                                                            if(data.title == 'noname' && data.status == DDoSProtectionProfileStatusEnum.enabled)
                                                            {
                                                                webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
                                                                return;
                                                            }
                                                            if(!data.profile_id)
                                                            {
                                                                _this.DeleteProfile(id);
                                                                return;
                                                            }

                                                            setTimeout(function () {
                                                                var node = __this.getItemNode(id);
                                                                _this.ProfileDeleteContext.show(node, {pos:"bottom"});
                                                            }, 10);
                                                        }
                                                    },
                                                    onBeforeFilter:function()
                                                    {
                                                        return false;
                                                    },
                                                    onAfterFilter:function()
                                                    {
                                                        _this.RefreshProfiles();
                                                    },
                                                    onBeforeSort:function()
                                                    {
                                                        _this.RefreshProfiles();
                                                        return false;
                                                    },
                                                    onAfterSelect:function ()
                                                    {
                                                        _this.OnProfilesTableRowSelect();
                                                    },
                                                    onAfterUnSelect:function ()
                                                    {
                                                        _this.OnProfilesTableRowSelect();
                                                    }
                                                },
                                                columns: [
                                                    {
                                                        id: "run",
                                                        header: "",
                                                        width: 32,
                                                        template: function (obj, common)
                                                        {
                                                            if(obj.status == DDoSProtectionProfileStatusEnum.enabled && obj.profile_id)
                                                            {
                                                                return CellStopBtnTemplate();
                                                            }

                                                            if(obj.profile_id)
                                                            {
                                                                return CellPlayBtnTemplate();
                                                            }

                                                            return "";
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "edit",
                                                        header: "",
                                                        width: 32,
                                                        template: function(obj)
                                                        {
                                                            return CellEditBtnTemplate(obj);
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "title",
                                                        header: [LangHelper.GetString(this.Id,"Profile"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        template:function(obj, common, value, config)
                                                        {
                                                            var tmp = common.treetable(obj, common, value, config) + (obj.title?(obj.title == 'noname' ? LangHelper.GetString(_this.Id,'noname') : obj.title):LangHelper.GetString(_this.Id,"Profile")+" "+obj.profile_id);

                                                            return tmp;
                                                        },
                                                        fillspace: true,
                                                        sort: "string"
                                                    },
                                                    {
                                                        id: "status",
                                                        header: [LangHelper.GetString(this.Id,"Status"), {
                                                            content: "richSelectFilter",
                                                            options: Helper.DictToArr(BlStatusesDic),
                                                            inputConfig: {suggest: {fitMaster: false}}
                                                        }],
                                                        width:80,
                                                        template: function (obj, common)
                                                        {
                                                            var statusStr = "";

                                                            if(BlStatusesDic[obj.status])
                                                            {
                                                                statusStr += "<span class=\"status status_" + obj.status + "\">" + BlStatusesDic[obj.status].value + "</span>";
                                                            }

                                                            return statusStr;
                                                        },
                                                        sort: "string"
                                                    },
                                                    {
                                                        id: "trash",
                                                        header: "",
                                                        width: 32,
                                                        template: CellTrashBtnTemplate,
                                                        headermenu: false
                                                    }
                                                ],
                                                data:[]
                                            },
                                            {
                                                view: "toolbar",
                                                padding: 0,
                                                margin: 0,
                                                height:32,
                                                elements: [
                                                    {
                                                        view: "pager",
                                                        gravity:3,
                                                        id: this.Id + "ProfilesTable" + "Paging",
                                                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                        master:false,
                                                        on: {
                                                            onAfterPageChange:function(Page)
                                                            {
                                                                _this.RefreshProfiles(Page);
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"richselect",
                                                        id: this.Id + "ProfilesTable" + "Paging" + "Size",
                                                        label:LangHelper.GetString(_this.Id, "On page"),
                                                        labelWidth:120,
                                                        minWidth:220,
                                                        value:100,
                                                        options:PagingSizeOptions,
                                                        on: {
                                                            onChange:function()
                                                            {
                                                                _this.RefreshProfiles();
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    }

                                },
                                {view:"resizer"},
                                {
                                    header:LangHelper.GetString(this.Id,"Protocols"),
                                    body:{
                                        id:this.Id + "ProtocolsPanel",
                                        rows:[
                                            {
                                                view: "toolbar",
                                                height: 40,
                                                padding: 0,
                                                margin: 0,
                                                elements: [
                                                    {},
                                                    {
                                                        view:"label",
                                                        id:this.Id+"ProfileDataInfoLabel",
                                                        width:300
                                                    },
                                                    {
                                                        width:32
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id + "AddProtocolBtn",
                                                        type: "icon",
                                                        icon: "plus",
                                                        align: "right",
                                                        width: 32,
                                                        css:"toolbar_round_btn",
                                                        tooltip:LangHelper.GetString(this.Id,"Add protocols item"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.AddProtocolsToProtocolsTable();
                                                        }
                                                    },
                                                    {
                                                        view: "button",
                                                        id:this.Id+"DelProtocolsBtn",
                                                        type: "icon",
                                                        icon: "trash",
                                                        css:"toolbar_round_btn",
                                                        width:32,
                                                        tooltip:LangHelper.GetString(this.Id, "Delete"),
                                                        disabled:true,
                                                        click:function (id,e,node)
                                                        {
                                                            var __this = this;
                                                            setTimeout(function () {
                                                                var node = __this.getNode(id);
                                                                _this.ProtocolsDeleteContext.show(node, {pos:"bottom"});
                                                            }, 10);
                                                        }
                                                    },
                                                    {
                                                        width:16
                                                    },
                                                    // {
                                                    //     view: "button",
                                                    //     id:this.Id + "ExcelExportProtocolsBtn",
                                                    //     type: "icon",
                                                    //     icon: "file-excel",
                                                    //     css:"toolbar_round_btn",
                                                    //     width:32,
                                                    //     tooltip:LangHelper.GetString(this.Id,"Export to Excel"),
                                                    //     click:function (id,e,node)
                                                    //     {
                                                    //         _this.ExportToExcel();
                                                    //     }
                                                    // },
                                                    // {
                                                    //     width:16
                                                    // },
                                                    {
                                                        view: "button",
                                                        id:this.Id+"ProtocolsRefreshBtn",
                                                        type: "icon",
                                                        icon: "refresh",
                                                        css: "toolbar_round_btn",
                                                        width: 32,
                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                        click: function (id, e, node)
                                                        {
                                                            _this.RefreshProtocols(0);
                                                        }
                                                    }
                                                ]
                                            },
                                            BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"Protocols"), icon:"file"}),
                                            {
                                                view: "datatable",
                                                id: this.Id + "ProtocolsTable",
                                                select: "row",
                                                multiselect:true,
                                                editable: true,
                                                editaction:"custom",
                                                resizeColumn: true,
                                                tooltip:true,
                                                checkboxRefresh:true,
                                                form:this.Id + "CreateProtocolsContextForm",
                                                on: {
                                                    onItemClick: function (id,e,node)
                                                    {
                                                        var rowData = this.getItem(id);

                                                        if (id.column === 'edit')
                                                        {
                                                            this.select(id); //reset if multiple rows selected

                                                            _this.ShowProtocolsEditForm(rowData, this.getItemNode(id), "right");
                                                        }

                                                        if(id.column === 'value')
                                                        {
                                                            var data = this.getItem(id);

                                                            var isGroup = data && data.type && data.type == SessionPolicingProtocolTypeEnum.group  ? 1 : 0;

                                                            if (isGroup)
                                                            {

                                                                var modal_title = "";

                                                                var dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);

                                                                if(dic && dic[data.value])
                                                                {
                                                                    modal_title =  dic[data.value].value;
                                                                }
    
                                                                var table_params = {
                                                                    enableAutoHeight: false,
                                                                    enableTextSearch: true,
                                                                    is_modal: true,
                                                                    filter: {
                                                                        group_id: {
                                                                            id: "group_id",
                                                                            operator: "=",
                                                                            value: data.value
                                                                        }
                                                                    }
                                                                }
                                                                var table = new UlrAppProtocolsTable(table_params);
    
                                                                AppPolicingPopup({
                                                                    modal_title: modal_title
                                                                }, table);
                                                                table.Bind(_this, _this.ReportsModel);
                                                                table.RefreshData();
                                                            }
                                                        }
                                                        else if(id.column === 'trash')
                                                        {
                                                            var __this = this;

                                                            this.select(id); //reset if multiple rows selected

                                                            var data = _this.Views.ProtocolsTable.getItem(id);

                                                            if(!data.protocol_id)
                                                            {
                                                                _this.Views.ProtocolsTable.remove(id.row);
                                                                return;
                                                            }

                                                            setTimeout(function ()
                                                            {
                                                                var node = __this.getItemNode(id);
                                                                _this.ProtocolsDeleteContext.show(node, {pos:"bottom"});
                                                            }, 10);
                                                        }
                                                    },
                                                    onItemDblClick: function(id, e, node)
                                                    {
                                                        var rowData = this.getItem(id);
                                                        if(id.column == "type" || id.column == "uri")
                                                        {
                                                            _this.ShowProtocolsEditForm(rowData, this.getItemNode(id), "right");
                                                        }
                                                    },
                                                    onBeforeFilter:function()
                                                    {
                                                        return false;
                                                    },
                                                    onAfterFilter:function()
                                                    {
                                                        _this.RefreshProtocols();
                                                    },
                                                    onBeforeSort:function()
                                                    {
                                                        _this.RefreshProtocols();
                                                        return false;
                                                    },
                                                    onAfterSelect:function ()
                                                    {
                                                        _this.OnProtocolsTableRowSelect();
                                                    },
                                                    onAfterUnSelect:function ()
                                                    {
                                                        _this.OnProtocolsTableRowUnSelect();
                                                    },
                                                    onCheck:function(row, column, state)
                                                    {
                                                        var rowData = this.getItem(row);

                                                        var ProfileData = _this.GetProfilesTableSelectedData();

                                                        rowData.enabled = state;
                                                        _this.JustSaveProtocol(rowData, rowData);

                                                    }
                                                },
                                                columns: [
                                                    {
                                                        id: "edit",
                                                        header: "",
                                                        width: 32,
                                                        template: CellEditBtnTemplate,
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "enabled",
                                                        header: [""],
                                                        template: CellOnOffTemplate,
                                                        width: 72,
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "value",
                                                        header: [TooltipTemplate(LangHelper.GetString("UlrModule","Protocol / Group name"))],
                                                        sort: "string",
                                                        fillspace: 3,
                                                        template: function(obj)
                                                        {
                                                            var isGroup = obj && obj.type && obj.type == SessionPolicingProtocolTypeEnum.group  ? 1 : 0;
                                                            if(isGroup)
                                                            {
                                                                var dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);

                                                                if(dic && dic[obj.value])
                                                                {
                                                                    return dic[obj.value].value + " " + CellListBtnTemplate();
                                                                }
                                                            }

                                                            return obj.value.toLowerCase();
                                                        }
                                                    },
                                                    {
                                                        id: "priority",
                                                        header: [TooltipTemplate(LangHelper.GetString("UlrModule","Priority"))],
                                                        sort: "string",
                                                        editor: "combo",
                                                        fillspace: 2,
                                                        suggest:{
                                                            view:"gridsuggest",
                                                            body:{
                                                                autoheight:false,
                                                                scroll:true,
                                                                maxHeight:400,
                                                                //width:800,
                                                                //minWidth:800,
                                                                borderless:true,
                                                                columns:[
                                                                    { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                                                    { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                                                    { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                                                    { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                                                    { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                                                    { id:"class_order_1", header:"class_order=1", width:160}
                                                                ],
                                                                data:Helper.DictToArr(DscpDic)
                                                            }
                                                        }
                                                    },
                                                    {
                                                        id: "inbound",
                                                        header: [TooltipTemplate(LangHelper.GetString("Tariffs", "Inbound rate"))],
                                                        sort: "string",
                                                        fillspace: 2,
                                                        template: (obj) => {
                                                            return obj.inbound + ' ' + TrafficUnitsEnum[obj.inbound_unit];
                                                        }
                                                    },
                                                    {
                                                        id: "outbound",
                                                        header: [TooltipTemplate(LangHelper.GetString("Tariffs", "Outbound rate"))],
                                                        sort: "string",
                                                        fillspace: 2,
                                                        template: (obj) => {
                                                            return obj.outbound + ' ' + TrafficUnitsEnum[obj.outbound_unit];
                                                        }
                                                    },
                                                    {
                                                        id: "burst_inbound",
                                                        header: [TooltipTemplate(LangHelper.GetString("Tariffs", "Burst inbound rate"))],
                                                        sort: "string",
                                                        fillspace: 2,
                                                        template: (obj) => {
                                                            return obj.burst_inbound + ' ' + TrafficUnitsEnum[obj.burst_inbound_unit];
                                                        }
                                                    },
                                                    {
                                                        id: "burst_outbound",
                                                        header: [TooltipTemplate(LangHelper.GetString("Tariffs", "Burst outbound rate"))],
                                                        sort: "string",
                                                        fillspace: 2,
                                                        template: (obj) => {
                                                            return obj.burst_outbound + ' ' + TrafficUnitsEnum[obj.burst_outbound_unit];
                                                        }
                                                    },
                                                    {
                                                        id: "trash",
                                                        header: "",
                                                        width: 32,
                                                        template: CellTrashBtnTemplate,
                                                        headermenu: false
                                                    }
                                                ],
                                                data:[]
                                            },
                                            {
                                                view: "toolbar",
                                                padding: 0,
                                                margin: 0,
                                                height:32,
                                                elements: [
                                                    {
                                                        view: "pager",
                                                        // gravity:2.5,
                                                        minWidth:240,
                                                        id: this.Id + "ProtocolsTable" + "Paging",
                                                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                                                        master:false,
                                                        on: {
                                                            onAfterPageChange:function(Page)
                                                            {
                                                                _this.RefreshProtocols(Page);
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"richselect",
                                                        id: this.Id + "ProtocolsTable" + "Paging" + "Size",
                                                        label:LangHelper.GetString(_this.Id, "On page"),
                                                        labelWidth:120,
                                                        width:200,
                                                        value:100,
                                                        options:PagingSizeOptions,
                                                        on: {
                                                            onChange:function()
                                                            {
                                                                _this.RefreshProtocols();
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                },
                                {view: "resizer"},
                                {
                                    header: LangHelper.GetString(this.Id,"Subscribers"),
                                    id: this.Id + "SubsAccord",
                                    body:this.SubscriberEmbedded.view,
                                    gravity: 1
                                },
                                {gravity: 0}
                            ]
                        }
                    ]
                },
            ]
        }
    ]

    this.Views = {
        ProfilesTable: null,
        CreateProtocolsContext:null,
        DelProtocolsBtn:null,
        AddSubProfileBtn: null,
        AddSubProfileBtn: null,
        ProtocolsTable:null,
        ProtocolDeleteContextDeleteBtn:null,
        ProtocolsTablePaging:null,
        ProtocolsTablePagingSize:null,
        CreateProtocolsContextForms:{
            CreateProtocolsContextForm:null
        },
        CreateProtocolsContextFormSaveBtn:null,
        ProtocolType: null,
        ProtocolInput: null
    };

    this.ProfilesTableRowsSelectedCount = new Rx.BehaviorSubject(0);
    this.ProtocolsTableRowsSelectedCount = new Rx.BehaviorSubject(0);
    this.ProfilesTableRowsSelectedCount = new Rx.BehaviorSubject(0);

    this.Subscriptions = {

    };

    this.Signals = {
        ProtocolInputValue: new Rx.BehaviorSubject(null),
        PriorityInputValue: new Rx.BehaviorSubject(null),
        ProtocolGroupsInputValue: new Rx.BehaviorSubject(null),
    };
}

SessionPolicingsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    this.SubscriberEmbedded.Destroy();
};

SessionPolicingsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.SubscriberEmbedded.ViewDidLoad(Params);

    this.BindAll();

    this.ViewModel.GetSupportServiceValue();
};

SessionPolicingsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.ProfilesTable = $$(this.Id + "ProfilesTable");
    this.Views.ProfilesTablePaging = $$(this.Id + "ProfilesTable" + "Paging");
    this.Views.ProfilesTablePagingSize = $$(this.Id + "ProfilesTable" + "Paging" + "Size");
    this.Views.CreateProfileContext = webix.ui(this.CreateProfileContextConfig);
    this.Views.CreateProfileContextForm = $$(this.Id + "CreateProfileContextForm");
    this.Views.ProfileType = $$(this.Id + "ProfileType");
    this.Views.StatusView = $$(this.Id + "StatusView");
    this.Views.ProtocolsPanel = $$(this.Id + "ProtocolsPanel");
    this.Views.PlayBtn = $$(this.Id + "PlayBtn");
    this.Views.StopBtn = $$(this.Id + "StopBtn");
    this.Views.AddSubProfileBtn = $$(this.Id + "AddSubProfileBtn");
    this.Views.AddProtocolBtn = $$(this.Id + "AddProtocolBtn");
    this.Views.DelProtocolsBtn = $$(this.Id + "DelProtocolsBtn");
    this.Views.ProtocolsDeleteContextDeleteBtn = $$(this.Id + "ProtocolsDeleteContextDeleteBtn");
    this.Views.CreateProtocolsContext = webix.ui(this.CreateProtocolsContextFormConfig);
    this.Views.CreateProtocolsContextForms.CreateProtocolsContextForm = $$(this.Id + "CreateProtocolsContextForm");
    this.Views.CreateProtocolsContextFormSaveBtn = $$(this.Id+"CreateProtocolsContextFormSaveBtn");
    this.Views.ProtocolsImportContextUploader = $$(this.Id + "ProtocolsImportContextUploader");
    this.Views.ProtocolsTable = $$(this.Id + "ProtocolsTable");
    this.Views.ProtocolsTablePaging = $$(this.Id + "ProtocolsTable" + "Paging");
    this.Views.ProtocolsTablePagingSize = $$(this.Id + "ProtocolsTable" + "Paging" + "Size");
    this.Views.ProtocolType = $$(this.Id + "CreateProtocolsContextForm" + "ProtocolType");
    this.Views.ProtocolInput = $$(this.Id + "CreateProtocolsContextForm" + "ProtocolInput");

    this.Subscriptions.SignalProfileUpdatedSubscription = this.ViewModel.SignalProfileUpdated.subscribe(function (Profile)
    {
        if(Profile)
        {
            var selectedData = _this.GetProfilesTableSelectedData();

            var rows = _this.Views.ProfilesTable.find(function(obj)
            {
                return obj.profile_id == profile.profile_id;
            });

            if(rows && rows.length == 1)
            {
                _this.Views.ProfilesTable.updateItem(rows[0].id,  Profile);

                if(selectedData && selectedData.profile_id == profile.profile_id && profile.status != 0)
                {
                    _this.OnProfilesTableRowSelect();
                }
            }
        }
    });

    this.Subscriptions.ProtocolsDic = App.DicsManager.Signal[DicsEnum.ProtocolsDic].subscribe(function (Updated)
    {
        if (Updated)
            _this.SetProtocolInput();
    });

    this.Subscriptions.SignalProfilesUpdatedSubscription = this.ViewModel.SignalProfilesUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateProfilesTable();
        }
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshProfiles();
        }
    });

    this.Subscriptions.ProfilesTableRowsSelectedCountSubscription = this.ProfilesTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.ProfilesTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.SignalProtocolsUpdatedSubscription = this.ViewModel.SignalProtocolsUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdateProtocolsTable();
        }
    });

    this.Subscriptions.SignalSupportServiceValueUpdatedSubscription = this.ViewModel.SignalSupportServiceValueUpdated.subscribe(function (Updated)
    {
        if (Updated && !parseInt(Updated.support_service_18, 10))
        {
            _this.RedirectToConfigContext.show();
        }
    });

    this.Subscriptions.SignalProtocolUpdatedSubscription = this.ViewModel.SignalProtocolUpdated.subscribe(function (Protocol)
    {
        if(Protocol)
        {
            var selectedData = _this.GetProtocolsTableSelectedData();

            var rows = _this.Views.ProtocolsTable.find(function(obj)
            {
                return obj.protocol_id == Protocol.protocol_id;
            });

            if(rows && rows.length == 1)
            {
                _this.Views.ProtocolsTable.updateItem(rows[0].id,  Protocol);

                if(selectedData && selectedData.protocol_id == Protocol.protocol_id && Protocol.status != 0)
                {
                    _this.OnProtocolsTableRowSelect();
                }
            }
        }
    });

    this.Subscriptions.ProtocolsTableRowsSelectedCountSubscription = this.ProtocolsTableRowsSelectedCount.subscribe(function (Value)
    {
        if(Value > 1)
        {
            _this.Views.DelProtocolsBtn.enable();
        }
        else
        {
            _this.Views.DelProtocolsBtn.disable();
        }
    });

    this.Subscriptions.ProfilesTableRowsSelectedCount = this.ProfilesTableRowsSelectedCount.subscribe(function (Value)
    {
        _this.ProfileTableRowsSelectedCountSubscriptionHandler(Value);
    });

    this.Subscriptions.SignalCurrentHardwareUpdated = App.SessionManager.CurrentHardwareId.subscribe(function(Val)
    {
        if(Val)
        {
            _this.RefreshProtocols();
        }
    });
};

SessionPolicingsViewController.prototype.AddProfileToProfilesTable = function ()
{
    var _this = this;

    var model = new SessiongPolicingsProfileModel({hardware_id: App.SessionManager.GetCurrentHardwareId()});
    model.form_data = JSON.stringify(new SessionPolicingsFormModel());

    _this.Views.ProfilesTable.add(model,0);

    _this.Views.ProfilesTable.select(model.id, false);
    _this.Views.ProfilesTable.showItem(model.id);

    _this.ShowProfileEditForm(null, _this.Views.ProfilesTable.getItemNode(model.id), "right");
};

SessionPolicingsViewController.prototype.ShowProfileEditForm = function (Data, Node, Pos)
{
    var _this = this;

    var form = this.Views.CreateProfileContextForm;
    form.clear();

    if(Data && Data.form_data)
    {
        var formParams = new SessionPolicingsFormModel(JSON.parse(Data.form_data));

        form.setValues(formParams);
    }

    this.Views.CreateProfileContext.show(Node,{pos:Pos});
};

SessionPolicingsViewController.prototype.ProfilesTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    var _this = this;

    var _disableAll = function (Profile)
    {
        _this.Views.PlayBtn.disable();
        _this.Views.StopBtn.disable();

    };

    if(Value != 1)
    {
        _disableAll(null);
        return;
    }

    var selectedData = _this.GetProfilesTableSelectedData();

    if(!selectedData)
    {
        _disableAll(selectedData);
        return;
    }

    switch (parseInt(selectedData.status))
    {
        case SessionPolicingsProfileStatusEnum.disabled:
            if(selectedData.profile_id)
            {
                _this.Views.PlayBtn.enable();
            }
            else
            {
                _this.Views.PlayBtn.disable();
            }
            _this.Views.StopBtn.disable();
            break;
        case SessionPolicingsProfileStatusEnum.enabled:
            _this.Views.PlayBtn.disable();
            _this.Views.StopBtn.enable();
            break;
        default:
            break;
    }
};

SessionPolicingsViewController.prototype.OnProfilesTableRowSelect = function ()
{
    var data = this.GetProfilesTableSelectedData();

    this.ProfilesTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

SessionPolicingsViewController.prototype.UpdateProfilesTable = function (Params)
{
    var _this = this;

    this.Views.ProfilesTable.clearAll();
    this.Views.ProfilesTable.parse(this.ViewModel.GetProfiles());

    this.Views.ProfilesTablePagingSize.setValue(this.ViewModel.ProfilesFilter.total.size);

    this.Views.ProfilesTablePaging.define(this.ViewModel.ProfilesFilter.total);
    this.Views.ProfilesTablePaging.refresh();
};

SessionPolicingsViewController.prototype.SaveProfile = function()
{
    var _this = this;


    if(_this.Views.CreateProfileContextForm.validate())
    {
        var profileData = this.GetProfilesTableSelectedData();

        profileData.valid = true;

        var formData = this.Views.CreateProfileContextForm.getValues();

        formData = new SessionPolicingsFormModel(formData);
        this.ViewModel.SaveProfile(
            {
                profile:profileData,
                profile_form:formData,
                callback:function (R)
                {
                    if(R.success && R.data && R.data.profile)
                    {
                        _this.Views.ProfilesTable.updateItem(profileData.id,  new SessiongPolicingsProfileModel(R.data.profile));

                        webix.message(LangHelper.GetString(_this.Id,"Profile saved"));
                    }
                    else
                    {
                        profileData.valid = false;

                        _this.Views.ProfilesTable.validate(profileData.id);

                        if(R.error)
                            webix.message({text:R.error.msg,type:"error"});
                    }
                    _this.UpdateDics();
                    _this.OnProfilesTableRowSelect();
                }
            }
        );

        this.Views.ProfilesTable.validate(profileData.id);
        return true;
    }
    else{
        return false;
    }

};

SessionPolicingsViewController.prototype.UpdateDics = function()
{
    var dicEnum = ServicesDicsEnum[ServicesEnum.session_policings];

    App.DicsManager.Refresh({data: [dicEnum], filter:App.SessionManager.GetCurrentHardwareId()});
};

SessionPolicingsViewController.prototype.RefreshProfiles = function (Page)
{
    var _this = this;

    if(!this.Views.ProfilesTable.$destructed)
    {
        var state = this.Views.ProfilesTable.getState();

        var size = this.Views.ProfilesTablePagingSize.getValue();

        this.ViewModel.RefreshProfiles({page:Page, filter:state.filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}});
    }


    _this.UpdateDics();
};

SessionPolicingsViewController.prototype.DeleteProfile = function (RowId)
{
    var _this = this;

    var profileData = this.Views.ProfilesTable.getItem(RowId);
    profileData.valid = true;

    if(profileData.profile_id > 0)
    {
        this.ViewModel.DeleteProfile({profile:profileData, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.ProfilesTable.remove(RowId);

                    webix.message(LangHelper.GetString(this.Id,"Profile deleted"));
                }
                else
                {
                    profileData.valid = false;
                    _this.Views.ProfilesTable.validate(RowId);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
                _this.UpdateDics();
            }});
    }
    else
    {
        this.Views.ProfilesTable.remove(RowId);
    }
};

SessionPolicingsViewController.prototype.GetProfilesTableSelectedData = function ()
{
    return this.Views.ProfilesTable.getSelectedItem();
};

SessionPolicingsViewController.prototype.RunProfile = function ()
{
    var _this = this;

    var profileData = this.GetProfilesTableSelectedData();

    if(profileData.title == 'noname')
    {
        webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
        return;
    }

    profileData.valid = true;

    this.ViewModel.RunProfile({profile:profileData, callback:function (R)
        {
            if(R.success && R.data)
            {
                _this.Views.ProfilesTable.updateItem(profileData.id,  new SessiongPolicingsProfileModel(R.data));

                if(R.data.status == SessionPolicingsProfileStatusEnum.enabled)
                {
                    webix.message(LangHelper.GetString(_this.Id,"Profile enabled"));
                }
                else
                {
                    webix.message({text:LangHelper.GetString(this.Id,"Profile not enabled"), type:"debug"});
                }
            }
            else
            {
                profileData.valid = false;

                _this.Views.ProfilesTable.validate(profileData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
            _this.UpdateDics();

            _this.OnProfilesTableRowSelect();
        }});
};

SessionPolicingsViewController.prototype.StopProfile = function ()
{
    var _this = this;

    var profileData = this.GetProfilesTableSelectedData();
    if(profileData.title == 'noname')
    {
        webix.message({text:LangHelper.GetString(_this.Id,"Profile with name 'noname' doesn`t support this feature!"),type:"error"});
        return;
    }

    profileData.valid = true;

    this.ViewModel.StopProfile({profile:profileData, callback:function (R)
        {
            if(R.success)
            {
                if(R.data)
                {
                    _this.Views.ProfilesTable.updateItem(profileData.id,  new SessiongPolicingsProfileModel(R.data));

                    webix.message(LangHelper.GetString(_this.Id,"Profile disabled"));
                }
                else
                {
                    webix.message(LangHelper.GetString(_this.Id,"Profile not disabled"));
                }

            }
            else
            {
                profileData.valid = false;

                _this.Views.ProfilesTable.validate(profileData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.UpdateDics();

            _this.OnProfilesTableRowSelect();
        }});
};

SessionPolicingsViewController.prototype.GetProtocolTableSelectedData = function ()
{
    return this.Views.ProfilesTable.getSelectedItem();
};

SessionPolicingsViewController.prototype.AddProtocolsToProtocolsTable = function ()
{
    var _this = this;

    var profile = this.GetProfilesTableSelectedData();

    if(!profile)
        return;

    var model = new SessiongPolicingsProtocolModel();

    model.enabled = 1;
    model.profile_id = profile.profile_id;

    model.type = SessionPolicingProtocolTypeEnum.protocol;

    _this.Views.ProtocolsTable.add(model,0);

    _this.Views.ProtocolsTable.select(model.id, false);
    _this.Views.ProtocolsTable.showItem(model.id);

    _this.ShowProtocolsEditForm(model, _this.Views.ProtocolsTable.getItemNode(model.id), "right");
};

SessionPolicingsViewController.prototype.ShowProtocolsEditForm = function (Data, Node, Pos)
{
    this.ClearProtocolsForms();

    if(Data)
    {
        var formParams = new SessiongPolicingsProtocolModel(Data, true);

        this.SetProtocolsEditFormValues(formParams);
    }

    this.Views.CreateProtocolsContext.show(Node, {pos:Pos});
};

SessionPolicingsViewController.prototype.ClearProtocolsForms = function ()
{
    var _this = this;

    Object.keys(this.Views.CreateProtocolsContextForms).forEach(function (Key)
    {
        _this.Views.CreateProtocolsContextForms[Key].clear();
        _this.Views.CreateProtocolsContextForms[Key].clearValidation();
    });
};

SessionPolicingsViewController.prototype.SetProtocolsEditFormValues = function (FormData)
{
    if(FormData)
    {
        this.Views.CreateProtocolsContextForms.CreateProtocolsContextForm.setValues(new SessiongPolicingsProtocolModel(FormData, true));
    }
};

SessionPolicingsViewController.prototype.RefreshProtocols = function (Page)
{
    var _this = this;

    var profile = this.GetProfilesTableSelectedData();

    if(!profile || !profile.profile_id)
        return;

    var state = this.Views.ProtocolsTable.getState();

    var size = this.Views.ProtocolsTablePagingSize.getValue();

    this.ViewModel.RefreshProtocols({title:profile.title, page:Page, filter:state.filter, size:size, sort:state.sort ? state.sort:null, callback:function () {}})
};

SessionPolicingsViewController.prototype.GetProtocolsTableSelectedData = function ()
{
    return this.Views.ProtocolsTable.getSelectedItem();
};

SessionPolicingsViewController.prototype.OnProtocolsTableRowSelect = function ()
{
    var data = this.GetProtocolsTableSelectedData();

    this.ProtocolsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

SessionPolicingsViewController.prototype.OnProtocolsTableRowUnSelect = function ()
{
    var data = this.GetProtocolsTableSelectedData();
    this.ProtocolsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

SessionPolicingsViewController.prototype.JustSaveProtocol = function (ProtocolData, Params)
{
    var _this = this;

    ProtocolData.valid = true;

    var newProtocolData = webix.extend(new SessiongPolicingsProtocolModel(Params, true), new SessiongPolicingsProtocolModel(ProtocolData));

    this.ViewModel.SaveProtocol({protocol:newProtocolData, callback:function (R)
        {
            if(R.success && R.data && R.data.protocol)
            {
                _this.Views.ProtocolsTable.updateItem(ProtocolData.id,  new SessiongPolicingsProtocolModel(R.data.protocol));

                webix.message(LangHelper.GetString(_this.Id,"Protocol saved"));
            }
            else
            {
                ProtocolData.valid = false;

                _this.Views.ProtocolsTable.validate(ProtocolData.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.UpdateDics();
            _this.OnProtocolsTableRowSelect();
        }});
};

SessionPolicingsViewController.prototype.SaveProtocol = function ()
{
    var _this = this;

    var protocolData = this.GetProtocolsTableSelectedData();

    var profileData = this.GetProfilesTableSelectedData();

    protocolData.title = profileData.title;

    if(this.ValidateProtocolsForms())
    {
        this.Views.CreateProtocolsContext.hide();

        var params = {};

        Object.keys(this.Views.CreateProtocolsContextForms).forEach(function (Key)
        {
            webix.extend(params, _this.Views.CreateProtocolsContextForms[Key].getValues());
        });
   
        this.JustSaveProtocol(protocolData, params);

        // this.ClearForms();
    }
    else
    {
        protocolData.valid = false;
    }

    this.Views.ProtocolsTable.validate(protocolData.id);
};

SessionPolicingsViewController.prototype.UpdateProtocolsTable = function (Params)
{
    var _this = this;

    this.Views.ProtocolsTable.clearAll();
    this.Views.ProtocolsTable.parse(_this.ViewModel.GetProtocols());

    this.Views.ProtocolsTablePagingSize.setValue(this.ViewModel.ProtocolsFilter.total.size);

    this.Views.ProtocolsTablePaging.define(this.ViewModel.ProtocolsFilter.total);
    this.Views.ProtocolsTablePaging.refresh();
};

SessionPolicingsViewController.prototype.AddProtocolToProtocolsTable = function ()
{
    var _this = this;

    var profile = this.GetProfileTableSelectedData();

    if(!profile)
        return;

    var model = new SessiongPolicingsProtocolModel();

    model.enabled = 1;
    model.profile_id = profile.profile_id;

    _this.Views.ProtocolsTable.add(model,0);

    _this.Views.ProtocolsTable.select(model.id, false);
    _this.Views.ProtocolsTable.showItem(model.id);

    _this.ShowProtocolsEditForm(model, _this.Views.ProtocolsTable.getItemNode(model.id), "right");
};

SessionPolicingsViewController.prototype.GetProtocolsTableSelectedData = function ()
{
    return this.Views.ProtocolsTable.getSelectedItem();
};

SessionPolicingsViewController.prototype.OnProtocolsTableRowSelect = function ()
{
    var data = this.GetProtocolsTableSelectedData();

    this.ProtocolsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

SessionPolicingsViewController.prototype.OnProtocolsTableRowUnSelect = function ()
{
    var data = this.GetProtocolsTableSelectedData();
    this.ProtocolsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

SessionPolicingsViewController.prototype.ProfileTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    var _this = this;

    var _disableAll = function ()
    {
        _this.Views.ProtocolsPanel.disable();

        _this.Views.AddSubProfileBtn.disable();
        _this.Views.PlayBtn.disable();
        _this.Views.StopBtn.disable();

        _this.Views.AddProtocolBtn.disable();
        _this.Views.ProtocolsDeleteContextDeleteBtn.disable();

        // _this.SetProfileDataInfoLabel();
        _this.Views.ProtocolsTable.clearAll();
    };

    if(Value != 1)
    {
        _disableAll();
        return;
    }

    var selectedData = _this.GetProfilesTableSelectedData();

    if(!selectedData || selectedData.remote)
    {
        _disableAll();
        return;
    }

    if(selectedData.profile_id)
    {
        _this.Views.ProtocolsPanel.enable();
        // this.SetProfileDataInfoLabel();

        if(!NoRefresh)
        {
            this.RefreshProtocols();
        }

    }
    else
    {
        _this.Views.ProtocolsPanel.disable();
    }

    _this.Views.AddSubProfileBtn.enable();

    switch (parseInt(selectedData.status))
    {
        case BlTaskStatusEnum.disabled:
            if(selectedData.profile_id)
            {
                _this.Views.PlayBtn.enable();

                if(!selectedData.remote)
                {
                    _this.Views.AddProtocolBtn.enable();

                    _this.Views.ProtocolsDeleteContextDeleteBtn.enable();
                }
            }
            else
            {
                _this.Views.PlayBtn.disable();

                _this.Views.AddProtocolBtn.disable();

                _this.Views.ProtocolsDeleteContextDeleteBtn.disable();
            }
            _this.Views.StopBtn.disable();

            break;

        case BlTaskStatusEnum.enabled:
            _this.Views.PlayBtn.disable();
            _this.Views.StopBtn.enable();

            if(!selectedData.remote)
            {
                _this.Views.AddProtocolBtn.enable();

                _this.Views.ProtocolsDeleteContextDeleteBtn.enable();
            }
            break;
        default:
            break;
    }
};

SessionPolicingsViewController.prototype.DeleteProtocol = function (ProtocolIds, ProtocolsRows)
{
    var _this = this;

    var profile = this.Views.ProfilesTable.getSelectedItem();

    if(ProtocolIds.length > 0)
    {
        this.ViewModel.DeleteProtocol({protocol_ids: ProtocolIds, profile, callback:function (R)
            {
                if(R.success)
                {
                    _this.Views.ProtocolsTable.remove(ProtocolsRows);

                    webix.message(LangHelper.GetString("All","Deleted"));
                }
                else
                {
                    protocolData.valid = false;
                    _this.Views.ProtocolsTable.validate(ProtocolsRows);
                    if(R.error)
                        webix.message({text:R.error.msg,type:"error"});
                }
            }});
    }
    else
    {
        this.Views.ProtocolsTable.remove(ProtocolsRows);
    }
};

SessionPolicingsViewController.prototype.DeleteProtocolsSelectedRows = function (RowId)
{
    var _this = this;

    var selectedRows = this.GetProtocolsTableSelectedData();

    if(!selectedRows)
        return;

    selectedRows = Array.isArray(selectedRows)?selectedRows:[selectedRows];

    var protocol_ids = selectedRows.map((i) => i.protocol_id);
    var protocol_rows = selectedRows.map((i) => i.id);

    _this.DeleteProtocol(protocol_ids, protocol_rows);

};

SessionPolicingsViewController.prototype.ValidateProtocolsForms = function ()
{
    var _this = this;

    var valid = true;

    var form = this.Views.CreateProtocolsContextForms.CreateProtocolsContextForm;
    var el = form.elements;

    // valid = el.uri.validate();
    valid = true;

    return valid;
};

SessionPolicingsViewController.prototype.ShowHelpPopup = function (Node, Text, Link = null)
{
    webix.ui({
        view:"popup",
        body:{
            view:"template",
            borderless:true,
            width: 300,
            autoheight: true,
            template:LangHelper.GetString(this.Id, Text) + "<br/><br/>" + (Link ? `<a href=${LangHelper.GetString("WikiLinks", Link)} target="_blank">${LangHelper.GetString(this.Id, "Link to wiki")}</a>` : "")
        }
    }).show(Node, {pos:"bottom"})
}

SessionPolicingsViewController.prototype.SetProtocolInput = function ()
{
    if (this.Views.ProtocolType.getValue() != SessionPolicingProtocolTypeEnum.protocol)
        return;

    var dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsDic);

    let input = $$(this.Id + 'CreateProtocolsContextForm' + 'ProtocolInput');

    var list = $$(input.config.suggest).getList();
    list.clearAll();
    list.parse(dic);

    var value = input.getValue();

    if(value)
    {
        list.select(value);
        list.showItem(value);

        if(!list.getSelectedItem())
        {
            list.select(value.toUpperCase());
            list.showItem(value.toUpperCase());
        }

        if(!list.getSelectedItem())
        {
            list.select(value.toLowerCase());
            list.showItem(value.toLowerCase());
        }
    }
}

SessionPolicingsViewController.prototype.SetProtocolGroupInput = function ()
{
    if (this.Views.ProtocolType.getValue() != SessionPolicingProtocolTypeEnum.group)
        return;

    var dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic);

    dic = dic.sort(function(a,b){
        return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
    });

    let input = $$(this.Id + 'CreateProtocolsContextForm' + 'ProtocolInput');

    input.define("options", dic);
    input.refresh();
    input.enable();
}

function SocketNotificationsViewController(Params)
{
    var _this = this;

    this.Id = "SocketNotifications";

    this.InContext = Params&&Params.InContext ? Params.InContext : false;

    this.ViewModel = App.SocketNotificationsManager;

    this.DeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function ()
                            {
                                _this.DeleteContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Delete"),
                            click:function ()
                            {
                                _this.DeleteContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                                _this.DeleteSelected();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.DeleteAllContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Are you sure you want to delete all the records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function ()
                            {
                                _this.DeleteAllContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(_this.Id, "Delete"),
                            click:function ()
                            {
                                _this.DeleteAllContext.hide();
                                $$(_this.Id + "DeletePopup").hide();
                                _this.DeleteAll();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.OptionsContext = webix.ui({
        view:"popup",
        width:120,
        // height:104,
        point: false,
        css: "notification-suggest",
        body:{
            height:96,
            rows:[
                {
                    view: "button",
                    css: "notifications-button",
                    width:120,
                    height: 32,
                    label: LangHelper.GetString(_this.Id, "Details"),
                    click: function () {
                        setTimeout(function(){
                            _this.ShowMoreInfo();

                        }, 10);
                        _this.OptionsContext.hide();
                    }
                },
                {
                    view: "button",
                    css: "notifications-button",
                    width:120,
                    height: 32,
                    label: LangHelper.GetString(_this.Id, "Mark as read"),
                    click: function () {
                        setTimeout(function(){
                            _this.SetReaded();
                        }, 10);
                        _this.OptionsContext.hide();
                    }
                },
                {
                    view: "button",
                    css: "notifications-button",
                    width:120,
                    height: 32,
                    label: LangHelper.GetString(_this.Id, "Delete"),
                    click: function () {
                        setTimeout(function(){
                            _this.DeleteSelected();
                        }, 10);
                        _this.OptionsContext.hide();
                    }
                }
            ]
        }
    });
    this.Views =
        {
            Table:null,
            ReadSelectedBtn:null,
            DeleteSelectedBtn:null,
            Paging:null,
            DeleteOnlySelectedBtn: null,
            ReadOnlySelectedBtn: null

        };



    this.ViewConfig = [
        {
            borderless: true,
            cols:[
                BlockHeaderTemplate({title:LangHelper.GetString(_this.Id, "Notifications"), icon:"bell",borderless: true}),
                {
                    borderless: true,
                    view: "button",
                    id:this.Id+"CloseBtn",
                    type: "icon",
                    icon: "times",
                    css: "toolbar_round_btn",
                    width: 32,
                    height: 32,
                    tooltip: LangHelper.GetString(_this.Id, "Close"),
                    click: function (id, e, node)
                    {
                        _this.Hide();
                    }
                }
            ]
        },
        {
            view: "multiview",
            cells:[
                {
                    id: _this.Id + "Notifications",
                    rows:[
                        {
                            view: "toolbar",
                            elements: [
                                {
                                    view: "button",
                                    id:this.Id+"SelectAll",
                                    type: "icon",
                                    icon: "check-square",
                                    css: "toolbar_round_btn",
                                    width: 32,
                                    tooltip: LangHelper.GetString(_this.Id, "Select all notifications"),
                                    click: function (id, e, node)
                                    {
                                        if(_this.Views.Table.count() > _this.TableSelectedCount.value)
                                        {
                                            _this.Views.Table.selectAll();
                                        }
                                        else{
                                            _this.Views.Table.unselectAll();
                                        }
                                    }
                                },
                                {},
                                {
                                    view: "button",
                                    id:this.Id+"ReadSelectedBtn",
                                    type: "icon",
                                    icon: "book-open",
                                    css: "toolbar_round_btn toolbar_btn_with_menu",
                                    width: 40,
                                    tooltip: LangHelper.GetString(_this.Id, "Read notifications"),
                                    popup:{
                                        id: _this.Id + "ReadPopup",
                                        view:"submenu",
                                        width:240,
                                        data:[
                                            {
                                                id: _this.Id + "ReadOnlySelectedBtn",
                                                value: LangHelper.GetString(_this.Id, "Read selected"),
                                                callback: function()
                                                {
                                                    _this.SetReaded();
                                                }
                                            },
                                            {
                                                id: _this.Id + "ReadAlldBtn",
                                                value: LangHelper.GetString(_this.Id, "Read all"),
                                                callback: function()
                                                {
                                                    _this.ReadAll();
                                                }
                                            }
                                        ],
                                        template:"#value#",
                                        autoheight:true,
                                        select:false,
                                        on:
                                            {
                                                onMenuItemClick: function (id)
                                                {
                                                    var item = this.getItem(id);
                                                    if(item && item.callback)
                                                    {
                                                        item.callback();
                                                    }
                                                    // if(Params)
                                                    // {
                                                    //     if(Params.callback)
                                                    //         Params.callback(id);
                                                    // }
                                                    //
                                                    $$(_this.Id + "ReadPopup").hide();
                                                }
                                            }
                                    }
                                    // click: function (id, e, node)
                                    // {
                                    //     _this.SetReaded();
                                    // }
                                },
                                {width: 16},
                                {
                                    view: "button",
                                    id:this.Id+"DeleteSelectedBtn",
                                    type: "icon",
                                    icon: "trash",
                                    css: "toolbar_round_btn toolbar_btn_with_menu",
                                    width: 40,
                                    tooltip: LangHelper.GetString(_this.Id, "Delete notifications"),
                                    popup:{
                                        id: _this.Id + "DeletePopup",
                                        view:"submenu",
                                        width:240,
                                        data:[
                                            {
                                                id: _this.Id + "DeleteOnlySelectedBtn",
                                                value: LangHelper.GetString(_this.Id, "Delete selected"),
                                                callback: function(node)
                                                {
                                                    _this.DeleteContext.show(node, {pos: "bottom"});
                                                }
                                            },
                                            {
                                                id: _this.Id + "DeleteAlldBtn",
                                                value: LangHelper.GetString(_this.Id, "Delete all"),
                                                callback: function(node)
                                                {
                                                    _this.DeleteAllContext.show(node, {pos: "bottom"});
                                                }
                                            }
                                        ],
                                        template:"#value#",
                                        autoheight:true,
                                        select:false,
                                        on:
                                            {
                                                onMenuItemClick: function (id)
                                                {
                                                    var item = this.getItem(id);
                                                    var node = this.getItemNode(id);
                                                    if(item && item.callback)
                                                    {
                                                        item.callback(node);
                                                    }
                                                    // if(Params)
                                                    // {
                                                    //     if(Params.callback)
                                                    //         Params.callback(id);
                                                    // }
                                                    //
                                                    // $$(_this.Id + "DeletePopup").hide();
                                                }
                                            }
                                    }
                                    // click: function (id, e, node)
                                    // {
                                    //     var __this = this;
                                    //     setTimeout(function ()
                                    //     {
                                    //         var node = __this.getNode(id);
                                    //         _this.DeleteContext.show(node, {pos:"bottom"});
                                    //     }, 1);
                                    // }
                                },
                                // {
                                //     view: "button",
                                //     id:this.Id+"RefreshButton",
                                //     type: "icon",
                                //     icon: "refresh",
                                //     css: "toolbar_round_btn",
                                //     width: 32,
                                //     tooltip: LangHelper.GetString(_this.Id, "Refresh"),
                                //     click: function (id, e, node)
                                //     {
                                //         _this.Refresh();
                                //     }
                                // }

                            ]
                        },
                        {
                            view: "list",
                            id:this.Id+"Table",
                            css: "notifications-list",
                            type: { height: "auto" },
                            select: true,
                            multiselect: true,
                            // autoheight: true,
                            template: function(Obj)
                            {
                                return _this.ParseNotificationMessage(Obj);
                            },
                            scroll: true,
                            onClick: {
                                "websocket_notification-body-buttons": function(ev, id)
                                {
                                    _this.Views.Table.select(id);
                                    setTimeout(function(){
                                        _this.OptionsContext.show({x:ev.clientX-80, y: ev.clientY});
                                    }, 10);

                                    return false;
                                },
                                "websocket_notification": function(ev, id)
                                {
                                    _this.Views.Table.select(id);
                                    var __this = this;
                                    setTimeout(function()
                                    {
                                        var data = __this.getItem(id);
                                        _this.ShowMoreInfo(data);
                                    }, 10);
                                    return false;
                                }
                            },
                            on: {
                                onSelectChange:function()
                                {
                                    _this.OnTableSelectChanged();
                                    return false;
                                },
                                onItemClick:function(id,e,node)
                                {
                                    // var __this = this;
                                    // setTimeout(function()
                                    // {
                                    //     var data = __this.getItem(id);
                                    //     _this.ShowMoreInfo(data);
                                    // }, 10);
                                }
                            }
                        },
                        {
                            view: "pager",
                            id: this.Id+"Table"+"Paging",
                            master:false,
                            template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                            on: {
                                onAfterPageChange:function(Page)
                                {
                                    _this.Refresh({page: Page});
                                }
                            }
                        }
                    ]
                },
                {
                    view: "scrollview",
                    id: _this.Id + "MoreInfo",
                    scroll: "auto",
                    body:{
                        rows:[
                            {
                                view: "toolbar",
                                height: 32,
                                padding: 0,
                                margin: 0,
                                elements: [
                                    {
                                        view: "button",
                                        id:this.Id+"NotificationsBack",
                                        type: "icon",
                                        icon: "arrow-left",
                                        css: "toolbar_round_btn",
                                        width: 72,
                                        tooltip: LangHelper.GetString(_this.Id, "Back"),
                                        // label: LangHelper.GetString(_this.Id, "Back"),
                                        click: function (id, e, node)
                                        {
                                            _this.Views.Notifications.show();
                                        }
                                    },
                                    {
                                        width:16
                                    },
                                    {
                                        view:"label",
                                        id:this.Id+"NotificationHeaderInfo",
                                        width: 300
                                    }
                                ]
                            },
                            {
                                height: 32,
                                cols:[
                                    {
                                        width: 136,
                                        view: "label",
                                        label: LangHelper.GetString(_this.Id, "Status")
                                    },
                                    {
                                        view: "label",
                                        id: _this.Id + "NotifyStatus",
                                        template: ""
                                    }
                                ]
                            },
                            {
                                height: 32,
                                cols:[
                                    {
                                        width: 136,
                                        view: "label",
                                        label: LangHelper.GetString(_this.Id, "Notification date")
                                    },
                                    {
                                        view: "label",
                                        id: _this.Id + "NotifyDate",
                                        template: ""
                                    }
                                ]
                            },
                            {
                                height: 32,
                                cols:[
                                    {
                                        width: 136,
                                        view: "label",
                                        label: LangHelper.GetString(_this.Id, "Notify type")
                                    },
                                    {
                                        view: "label",
                                        id: _this.Id + "NotifyType",
                                        template: ""
                                    }
                                ]
                            },
                            {
                                view: "toolbar",
                                height: 32,
                                padding: 0,
                                margin: 0,
                                elements: [
                                    {
                                        view:"label",
                                        // id:this.Id+"NotificationHeaderInfo",
                                        label: LangHelper.GetString(_this.Id, "Notification content")
                                    },
                                    {}
                                ]
                            },
                            {
                                view: "label",
                                id: _this.Id + "NotifyContent",
                                height:0,
                                template: ""
                            }
                        ]
                    }
                }
            ]
        }

    ];

    this.ContextConfig = {
        view: "popup",
        maxWidth: 480,
        // fullscreen:true,
        // maxHeight: 640,
        modal:true,
        id:this.Id + "Context",
        body: {
            borderless:true,
            rows:[]
        },
        // position: function(state)
        // {
        //     state.top = 0;
        //     state.height = 400;
        //     this.resize();
        // }
    }

    this.Context = null;

    this.TableSelectedCount = new Rx.BehaviorSubject(0);
    this.NotificationsCount = 0;

    this.Subscriptions = {};
}

SocketNotificationsViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
};

SocketNotificationsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    if(this.InContext)
    {
        this.ContextConfig.body.rows = this.ViewConfig;
        this.Context = webix.ui(this.ContextConfig);

        this.Context.define("height", window.innerHeight - 16);
        this.Context.resize();
    }

    this.Views.ReadSelectedBtn = $$(this.Id+"ReadSelectedBtn");
    this.Views.DeleteSelectedBtn = $$(this.Id+"DeleteSelectedBtn");
    this.Views.Table = $$(this.Id+"Table");
    this.Views.Paging = $$(this.Id+"Table"+"Paging");
    this.Views.Notifications = $$(this.Id + "Notifications");
    this.Views.MoreInfo = $$(this.Id + "MoreInfo");
    this.Views.NotificationHeaderInfo = $$(this.Id + "NotificationHeaderInfo");
    this.Views.NotifyStatus = $$(this.Id + "NotifyStatus");
    this.Views.NotifyType = $$(this.Id + "NotifyType");
    this.Views.NotifyDate = $$(this.Id + "NotifyDate");
    this.Views.NotifyContent = $$(this.Id + "NotifyContent");



    webix.extend(this.Views.Table, webix.ProgressBar);

    _this.ViewModel.BindEvent();
    // this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (DicUpdated)
    // {
    //     if (DicUpdated)
    //     {
    //         _this.Views.Table.getColumnConfig("hardware_hardware_id").header[1].options = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);
    //     }
    // });

    this.Context.attachEvent("onShow", function()
    {
        _this.Update();

        _this.Subscriptions.NotificationsSignalSubscription = _this.ViewModel.SignalNotificationsUpdated.subscribe(function (Updated)
        {
            if (Updated)
            {
                _this.Update();
            }
        });

        _this.Refresh();
    });

    this.Context.attachEvent("onHide", function()
    {

        _this.Views.Table.unselectAll();
        _this.Views.Table.clearAll();
        _this.Views.Table.parse([]);
        _this.Views.Table.hideProgress();

        if(_this.Subscriptions.NotificationsSignalSubscription)
        {
            _this.Subscriptions.NotificationsSignalSubscription.unsubscribe();
            delete _this.Subscriptions.NotificationsSignalSubscription;
        }
    });

    this.Subscriptions.CountUpdateSignal = _this.ViewModel.SignalNotificationsCount.subscribe(
        function(Val)
        {
            if(_this.Context.isVisible())
            {
                // _this.Views.RefreshButton.enable();
                // _this.Views.Table.unselectAll();
                _this.Refresh({
                    silent: true,
                    page: _this.ViewModel.NotificationsFilter.paging.page
                });
            }
            else{
                if(Val != _this.NotificationsCount && Val > 0)
                {

                    var notif_id = "notif-count-" + Val;
                    var messageWindow = webix.message({
                        text: "<div class='notif-body' id='"+notif_id+"'>" + LangHelper.GetString(_this.Id, "Unread notifications: ") + Val + "</div>",
                        type: "warning",
                        expire: 5000
                    });

                    var node = document.getElementById(notif_id);
                    if(node)
                    {
                        node.onclick = function(ev){
                            webix.message.hide(messageWindow);
                            setTimeout(function(){
                                _this.Show({
                                    x: window.innerWidth - _this.Context.width,
                                    y: 0
                                });
                            },10);
                        }
                    }
                }

            }
            _this.NotificationsCount = Val;

        }
    );

    App.WebSocketManager.Connections['App'].on(SocketNotificationsEventEnum.subscribers, function(data){
        if(!_this.Context.isVisible())
        {
            var notif = JSON.parse(data);
            var container_id = "notify-id-" + notif.notify_id;
            var config = {
                type: notif.type,
                expire: notif.payload.expire_time,
                text: "<div class='notif-body' id='"+container_id+"'>"
            };
            var hw_dic = App.DicsManager.GetDic(DicsEnum.HardwaresDic);
            if(hw_dic)
                config.text += (hw_dic[notif.payload.data.hardware_id]? hw_dic[notif.payload.data.hardware_id].value : LangHelper.GetString(_this.Id, "Unknown")) + ": " + SocketNotificationsEventsDic[notif.event].value + "<br>";

            if(notif.payload.data.message)
            {
                config.text += LangHelper.GetString(_this.Id, notif.payload.data.message);
            }
            else if(notif.type == SocketNotificationsTypeEnum.success){
                config.text += LangHelper.GetString(_this.Id, "Subscribers and vchannels synchronization completed successfully");
            }
            config.text += "</div>";

            _this.ProcessNotification({config: config, container_id : container_id, notif: notif});
        }
    });

    App.WebSocketManager.Connections['App'].on(SocketNotificationsEventEnum.connection, function(data){
        if(!_this.Context.isVisible())
        {
            var notif = JSON.parse(data);
            var container_id = "notify-id-" + notif.notify_id;
            var config = {
                type: notif.type,
                expire: notif.payload.expire_time,
                text: "<div class='notif-body' id='"+container_id+"'>"
            };

            var hws = App.DicsManager.GetDic(DicsEnum.HardwaresDic);
            if(hws)
            {
                var hw = App.DicsManager.GetDic(DicsEnum.HardwaresDic)[notif.payload.data.hardware_id];
                config.text += (hw ? hw.value : LangHelper.GetString(_this.Id, "Unknown")) + ": " + SocketNotificationsEventsDic[notif.event].value + "<br>";
            }


            if(notif.type == SocketNotificationsTypeEnum.error)
            {
                config.text += LangHelper.GetString(_this.Id, "Ssh not connected");
            }
            else{
                config.text += LangHelper.GetString(_this.Id, "Ssh connected");
            }
            config.text += "</div>";

            _this.ProcessNotification({config: config, container_id : container_id, notif: notif});

        }
    });

    App.WebSocketManager.Connections['App'].on(SocketNotificationsEventEnum.triggers, function(data){
        if(!_this.Context.isVisible())
        {
            var notif = JSON.parse(data);
            var container_id = "notify-id-" + notif.notify_id;
            var config = {
                type: notif.type,
                expire: notif.payload.expire_time,
                text: "<div class='notif-body' id='"+container_id+"'>"
            };

            config.text += LangHelper.GetString(_this.Id, "Trigger fired") + ": ";
            config.text += notif.payload.data.title + " (" + notif.payload.data.subtitle + ")";
            config.text += "</div>";

            _this.ProcessNotification({config: config, container_id : container_id, notif: notif});

        }
    });

    App.WebSocketManager.Connections['App'].on(SocketNotificationsEventEnum.qoe_report, function(data){
        if(!_this.Context.isVisible())
        {
            var notif = JSON.parse(data);
            var container_id = "notify-id-" + notif.notify_id;
            var config = {
                type: notif.type,
                expire: notif.payload.expire_time,
                text: "<div class='notif-body' id='"+container_id+"'>"
            };

            config.text += LangHelper.GetString(_this.Id, "QoE report ready") + ": ";
            config.text += notif.payload.data.title + " (" + notif.payload.data.subtitle + ")";
            config.text += "</div>";

            _this.ProcessNotification({config: config, container_id : container_id, notif: notif});

        }
    });

    App.WebSocketManager.Connections['App'].on(SocketNotificationsEventEnum.qoe, function(data){
        if(!_this.Context.isVisible())
        {
            var notif = JSON.parse(data);
            var container_id = "notify-id-" + notif.notify_id;
            var config = {
                type: notif.type,
                expire: notif.payload.expire_time,
                text: "<div class='notif-body' id='"+container_id+"'>"
            };

            if(notif.payload.data.action == "force_move_partitions")
            {
                config.text += LangHelper.GetString(_this.Id, "Forcing moving or removing data for") + " " + notif.payload.data.disk + ": " + "<br/>";
                config.text += LangHelper.GetString(_this.Id, "Partitions to move") + ": " + notif.payload.data.partitions_to_move + "<br/>";
                config.text += LangHelper.GetString(_this.Id, "Partitions to remove") + ": " + notif.payload.data.partitions_to_remove + "<br/>";
            }

            config.text += "</div>";

            _this.ProcessNotification({config: config, container_id : container_id, notif: notif});

        }
    });

    this.TableSelectedCount.subscribe(function (Count)
    {
        // var _this = this;
        // var read_pop = _this.Views.ReadSelectedBtn.getChildViews();

        // var read_btn = $$(read_pop.id);
        if(Count > 0)
        {
            if(Count == 1)
            {
                var data = _this.GetTableSelectedData();

                if(data.status == "new")
                {
                    // _this.Views.ReadOnlySelectedBtn.enable();
                }
            }
            else{
                // _this.Views.ReadOnlySelectedBtn.enable();
            }

            // _this.Views.DeleteOnlySelectedBtn.enable();
        }
        else
        {
            // _this.Views.ReadOnlySelectedBtn.disable();
            // _this.Views.DeleteOnlySelectedBtn.disable();
        }
    });
};

SocketNotificationsViewController.prototype.Refresh = function(Params)
{
    var _this = this;

    var silent = Params && Params.silent;
    if(!silent){
        this.Views.Table.showProgress({type: "icon"});
    }

    var params = {
        page: Params && Params.page ? Params.page : 0,
        size: 100,
        callback:function ()
        {
            if(!silent)
                _this.Views.Table.hideProgress();
        }
    };

    this.ViewModel.RefreshNotifications(params);
};

SocketNotificationsViewController.prototype.Update = function()
{
    var _this = this;
    var data = this.ViewModel.GetNotifications();

    var selected = this.GetTableSelectedData();
    if(selected)
    {
        if(!Array.isArray(selected))
        {
            selected = [selected];
        }
    }
    else selected = [];
    this.Views.Table.unselectAll();
    this.Views.Table.clearAll();
    this.Views.Table.parse(data);

    selected.forEach(function(Val){
       if(_this.Views.Table.exists(Val.id))
       {
           _this.Views.Table.select(Val.id, true);
       }
       else{
           var item = data.find(function(Obj){
               return Obj.notify_id == Val.notify_id;
           });

           if(item && item.id && _this.Views.Table.exists(item.id))
           {
               _this.Views.Table.select(item.id, true);
           }
       }
    });

    this.Views.Paging.define(this.ViewModel.NotificationsFilter.total);
    this.Views.Paging.refresh();
};

SocketNotificationsViewController.prototype.Show = function(Node, Pos)
{
    this.Context.show(Node, Pos);
};

SocketNotificationsViewController.prototype.Hide = function()
{
    this.Context.hide();
};

SocketNotificationsViewController.prototype.SetReadItem = function(Object)
{
    this.ViewModel.SetNotificationsReaded({
        Notifs: [Object]
    });
};

SocketNotificationsViewController.prototype.SetReaded = function()
{
    var _this = this;

    var data = this.GetTableSelectedData();

    var Notifs = [];

    if(data instanceof Array)
    {
        Notifs = data;
    }
    else{
        Notifs.push(data);
    }

    this.ViewModel.SetNotificationsReaded({
        Notifs:Notifs,
        callback: function(R){
            // Notifs.forEach(function(Val){
            //     if(_this.Views.Table.exists(Val.id))
            //    {
            //        Val.status = "read";
            //        _this.Views.Table.updateItem(Val.id, Val);
            //    }
            // });
        }});
};

SocketNotificationsViewController.prototype.ReadAll = function()
{
    var _this = this;
    this.ViewModel.ReadAllNotifications({
        callback: function(R){
        }});
};

SocketNotificationsViewController.prototype.DeleteSelected = function()
{
    var _this = this;

    var selectedData = this.GetTableSelectedData();

    if(selectedData)
    {
        if(!Array.isArray(selectedData))
        {
            selectedData = [selectedData];
        }

        this.ViewModel.DeleteSelectedNotifications({Notifs:selectedData, callback:function (R)
        {
            // selectedData.forEach(function(Val){
            //     if(_this.Views.Table.exists(Val.id))
            //     {
            //         _this.Views.Table.unselect(Val.id);
            //         _this.Views.Table.remove(Val.id);
            //     }
            // });
            // if(R.success && R.data && R.data instanceof Array)
            // {
            //     var items = _this.ViewModel.GetNotifications();
            //     R.data.forEach(function(Val){
            //         if(_this.Views.Table.exists(Val.id))
            //         {
            //             _this.Views.Table.unselect(Val.id);
            //             _this.Views.Table.remove(Val.id);
            //         }
            //         else
            //         {
            //             var item = items.find(function(Obj){
            //                 return Obj.notify_id == Val.notify_id;
            //             });
            //
            //             if(item)
            //             {
            //                 _this.Views.Table.unselect(item.id);
            //                 _this.Views.Table.remove(item.id, item);
            //             }
            //         }
            //     });
            // }

            // _this.Views.Table.unselectAll();

            // _this.Refresh({silent:true, page:_this.ViewModel.NotificationsFilter.paging.page});
        }});
    }
};

SocketNotificationsViewController.prototype.DeleteAll = function()
{
    var _this = this;

    this.ViewModel.DeleteAllNotifications({
        callback:function (R)
        {
        }
    });
};

SocketNotificationsViewController.prototype.GetTableSelectedData = function ()
{
    return this.Views.Table.getSelectedItem();
};

SocketNotificationsViewController.prototype.OnTableSelectChanged = function ()
{
    var data = this.GetTableSelectedData();
    this.TableSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

SocketNotificationsViewController.prototype.Destroy = function ()
{
    "use strict";

    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

SocketNotificationsViewController.prototype.ParseNotificationMessage = function(Obj)
{
  var _this = this;
  var params = {
      icon: "",
      event: SocketNotificationsEventsDic[Obj.event].value,
      notification_date: _this.ParseDateTime(Obj.notification_date),
      title: "",
      content: SocketNotificationsTypeDic[Obj.type].value,
      type: Obj.type
  };

  if(Obj.status == 'new')
  {
      params.event = "<b>" + params.event + "</b>";
  }

  switch(Obj.type)
  {
      case SocketNotificationsTypeEnum.success:
          params.icon = "fa-check-circle";
          break;
      default:
          params.icon = "fa-exclamation-circle";
          break;
  }

  params.icon += " icon-" + Obj.type;




  if(Obj.event == SocketNotificationsEventEnum.subscribers)
  {
      // params.icon = "fa-qoesubscribers";
      if(Obj.payload && Obj.payload.data)
      {
          params.title += LangHelper.GetString(_this.Id, "Hardware") + ": ";
          if(Obj.payload.data.hardware_id)
          {
              params.title += App.DicsManager.GetDic(DicsEnum.HardwaresDic)[Obj.payload.data.hardware_id] ? (App.DicsManager.GetDic(DicsEnum.HardwaresDic)[Obj.payload.data.hardware_id].value) : LangHelper.GetString(_this.Id, "Unknown") ;
          }
          else{
              params.title += LangHelper.GetString(_this.Id, "Unknown");
          }

          if(Obj.payload.data.message)
              params.content += ": " + LangHelper.GetString("AppView", Obj.payload.data.message);
      }
  }
  else if(Obj.event == SocketNotificationsEventEnum.connection)
  {
      params.title += LangHelper.GetString(_this.Id, "Hardware") + ": ";
      if(Obj.payload.data.hardware_id)
      {
          params.title += App.DicsManager.GetDic(DicsEnum.HardwaresDic)[Obj.payload.data.hardware_id] ? (App.DicsManager.GetDic(DicsEnum.HardwaresDic)[Obj.payload.data.hardware_id].value) : LangHelper.GetString(_this.Id, "Unknown") ;
      }
      else{
          params.title += LangHelper.GetString(_this.Id, "Unknown");
      }

      if(Obj.type == SocketNotificationsTypeEnum.error)
      {
          params.content += ": " + LangHelper.GetString(_this.Id, "Ssh not connected");
      }
      else{
          params.content += ": " + LangHelper.GetString(_this.Id, "Ssh connected");
      }
  }
  else if(Obj.event == SocketNotificationsEventEnum.triggers || Obj.event == SocketNotificationsEventEnum.qoe_report)
  {
      // if(Obj.event == SocketNotificationsEventEnum.qoe_report)
      // {
      //     debugger;
      // }
      var d = Obj.payload.data;

      params.title = d.title + " (" + d.subtitle + ")" ;

      if(Obj.event == SocketNotificationsEventEnum.qoe_report)
      {
          params.content = LangHelper.GetString(this.Id, "QoE report ready");
      }
      else{
          params.content = d.body;
      }

  }
  else if(Obj.event == SocketNotificationsEventEnum.qoe)
  {
      if(Obj.payload.data.action == "force_move_partitions")
      {
          if(Obj.payload.data.disk)
              params.title = LangHelper.GetString(_this.Id, "Forcing moving or removing data for") + " " + Obj.payload.data.disk;

          params.content = "";

          if(Obj.payload.data.partitions_to_move)
              params.content += LangHelper.GetString(_this.Id, "Partitions to move") + ": " + Obj.payload.data.partitions_to_move;

          if(Obj.payload.data.partitions_to_remove)
              params.content += LangHelper.GetString(_this.Id, "Partitions to remove") + ": " + Obj.payload.data.partitions_to_remove;
      }
  }



  return this.NotificationTemplate(params);
};

SocketNotificationsViewController.prototype.NotificationTemplate = function(Params)
{
  return "<div class='websocket_notification'>" +
      "<div class='websocket_notification-header'>" +
        "<div class='websocket_notification-icon'><span class=\"webix_icon " + Params.icon + "\"></span></div>" +
        "<div class='websocket_notification-event'>" + Params.event + "</div>" +
        "<div class='websocket_notification-date'>" + Params.notification_date + "</div>" +
      "</div>" +
      "<div class='websocket_notification-body'>" +
        "<div class='websocket_notification-body-content'>" +
          "<div class='websocket_notification-title'>" + Params.title + "</div>" +
          "<div class='websocket_notification-content'>" + Params.content + "</div>" +
        "</div>" +
        "<div class='websocket_notification-body-buttons'>" +
            "<span class='webix_icon fa-angle-right'></span>" +
        "</div>" +
      "</div>" +
      "" +
  "</div>";
};

SocketNotificationsViewController.prototype.ShowMoreInfo = function(Data)
{
    var _this = this;

    var data = Data;

    if(!Data)
    {
        var item = this.Views.Table.getSelectedItem();

        if(item)
        {
            data = item;
        }
    }

    var icon = "";
    switch(data.type)
    {
        case SocketNotificationsTypeEnum.success:
            icon = "fa-check-circle";
            break;
        default:
            icon = "fa-exclamation-circle";
            break;
    }

    _this.Views.NotificationHeaderInfo.define("template","<b>" + SocketNotificationsEventsDic[data.event].value + "</b>");
        // "<div class='websocket_notification-event'>" +  + "</div>" +
        // "<div class='websocket_notification-date'>" + _this.ParseDateTime(data.notification_date) + "</div>" +
        // "</div>");

    _this.Views.NotificationHeaderInfo.refresh();

    this.Views.NotifyType.define("template", "<b class='icon-" + data.type +"'><span class=\"webix_icon " + icon + "\"></span>" + SocketNotificationsTypeDic[data.type].value + "</b>");
    this.Views.NotifyType.refresh();

    this.Views.NotifyStatus.define("template","<b>" + SocketNotificationsStatusDic[data.status].value + "</b>");
    this.Views.NotifyStatus.refresh();


    this.Views.NotifyDate.define("template", "<b>" +  _this.ParseDateTime(data.notification_date) + "</b>");
    this.Views.NotifyDate.refresh();

    var content = "<div style=\"height:inherit;width:100%;overflow-y:auto\">";

    switch(data.event)
    {
        case SocketNotificationsEventEnum.subscribers: {
            if(data.payload && data.payload.data)
            {
                content += "<b>" + LangHelper.GetString(_this.Id, "Hardware") + ": ";
                if(data.payload.data.hardware_id)
                {
                    content += App.DicsManager.GetDic(DicsEnum.HardwaresDic)[data.payload.data.hardware_id] ? (App.DicsManager.GetDic(DicsEnum.HardwaresDic)[data.payload.data.hardware_id].value) : LangHelper.GetString(_this.Id, "Unknown") ;
                }
                else{
                    content += LangHelper.GetString(_this.Id, "Unknown");
                }
                content += "</b>";

                if(data.payload.data.message)
                    content += "<p>" + LangHelper.GetString("AppView", data.payload.data.message) + "</p>";
                else
                    content += "<p>" + SocketNotificationsTypeDic[data.type].value + "</p>"
            }
            break;
        }
        case SocketNotificationsEventEnum.connection: {
            if(data.payload && data.payload.data)
            {
                content += "<b>" + LangHelper.GetString(_this.Id, "Hardware") + ": ";
                if(data.payload.data.hardware_id)
                {
                    content += App.DicsManager.GetDic(DicsEnum.HardwaresDic)[data.payload.data.hardware_id] ? (App.DicsManager.GetDic(DicsEnum.HardwaresDic)[data.payload.data.hardware_id].value) : LangHelper.GetString(_this.Id, "Unknown") ;
                }
                else{
                    content += LangHelper.GetString(_this.Id, "Unknown");
                }
                content += "</b>";

                if(data.type == SocketNotificationsTypeEnum.error)
                    content += "<p>" + LangHelper.GetString(_this.Id, "Ssh not connected") + "</p>";
                else
                    content += "<p>" + LangHelper.GetString(_this.Id, "Ssh connected") + "</p>";
            }
            break;
        }
        case SocketNotificationsEventEnum.triggers:{
            var d = data.payload.data;

            content += "<b>" + d.title + " (" + d.subtitle + ") </b><br>";

            content += d.body.split("\n").join("<br>");

            break;
        }
        case SocketNotificationsEventEnum.qoe_report:{
            var d = data.payload.data;

            content += "<b>" + d.title + " (" + d.subtitle + ") </b><br>";

            content += d.body.split("\n").join("<br>");

            break;
        }
        case SocketNotificationsEventEnum.qoe: {
            if(data.payload && data.payload.data && data.payload.data.action == "force_move_partitions")
            {
                if(data.payload.data.disk)
                    content += "<b>" + LangHelper.GetString(_this.Id, "Forcing moving or removing data for") + " " + data.payload.data.disk + "</b>";

                if(data.payload.data.partitions_to_move)
                    content += "<p>" + LangHelper.GetString(_this.Id, "Partitions to move") + ": " + data.payload.data.partitions_to_move + "</p>";

                if(data.payload.data.partitions_to_remove)
                    content += "<p>" + LangHelper.GetString(_this.Id, "Partitions to remove") + ": " + data.payload.data.partitions_to_remove + "</p>";
            }
            break;
        }
        default:{

            break;
        }
    }

    content += "</div>";
    this.Views.NotifyContent.define("template", content);
    this.Views.NotifyContent.refresh();


    this.Views.MoreInfo.show();
    _this.SetReaded();
};

SocketNotificationsViewController.prototype.ParseDateTime = function(DateTime)
{
    return (webix.Date.dateToStr("%d.%m.%Y %H:%i"))(Helper.DateTimeToLocal(new Date(DateTime)));
};


/**
 * @return {string}
 */
SocketNotificationsViewController.prototype.GetMessageWindowTemplate = function(Count)
{
    var _this = this;
    var template = "<span>" + LangHelper.GetString(_this.Id, "Unread notifications: ");
    template += (Count ? Count : 0) + "";
    template += "</span>";
    // return "<div class='webix_warning'>" +
    return  template;
};


SocketNotificationsViewController.prototype.ProcessNotification = function(Params)
{
    var _this = this;
    var message = webix.message(Params.config);

    var node = document.getElementById(Params.container_id);
    if(node)
    {
        node.onclick = function(ev){
            webix.message.hide(message);
            setTimeout(function(){
                _this.SetReadItem(Params.notif);
            },10);
        }
    }
};
function Dpiui2ConfigViewController(Params)
{
    var _this = this;

    this.Id = "Dpiui2Config";

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new Dpiui2ConfigManager();

    this.UpdateParamsContextId = this.Id + "UpdateParamsContext";
    this.UpdateParamsContext = webix.ui({
        view:"submenu",
        id:this.UpdateParamsContextId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.UpdateParamsContextId+"RestartVisord", icon: "retweet", value: LangHelper.GetString(_this.Id, "Restart queue")},
            {id: this.UpdateParamsContextId+"RestartQueue", icon: "bolt", value: LangHelper.GetString(_this.Id,"Updating hot options")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                if(id === _this.UpdateParamsContextId+"RestartVisord")
                {
                    setTimeout(function () {
                        _this.ViewModel.RestartWorkers();
                    }, 1);
                }
                else if(id === _this.UpdateParamsContextId+"RestartQueue")
                {
                    setTimeout(function () {
                        _this.ViewModel.RestartQueue();
                    }, 1);
                }
            }
        }
    });

    this.HistoryImportContext = webix.ui({
        view:"popup",
        width:800,
        height:720,
        id:this.Id+"HistoryImportContext",
        modal:true,
        body:{
            rows:[
                {
                    borderless:true,
                    cols:[
                        {
                            width:240,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiConfig","History"), icon: "history"}),
                                {
                                    view:"datatable",
                                    id:this.Id + "HistoryImportContext" + "HistoryTable",
                                    select: "row",
                                    columns: [
                                        {
                                            id: "date",
                                            header: [LangHelper.GetString("DpiConfig","Date"), {content: "dateRangeFilter"}],
                                            format: webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"),
                                            fillspace: true,
                                            sort: "date"
                                        }
                                    ],
                                    on:{
                                        onAfterLoad:function(){
                                            this.sort("date", "desc", "date");
                                            this.markSorting("date", "desc");
                                        },
                                        onAfterSelect: function (data, preserve)
                                        {
                                            var rowData = this.getItem(data);

                                            _this.Views.HistoryEditor.showProgress({type: "icon"});

                                            _this.ViewModel.LoadHistoryFile({configFile:rowData.file_id, callback:function (R)
                                                {
                                                    _this.Views.HistoryEditor.hideProgress({type: "icon"});
                                                    if(R.success)
                                                    {
                                                        _this.Views.HistoryEditor.setValue(R.data);
                                                    }
                                                    else
                                                    {
                                                        webix.message({type:"error",text:LangHelper.GetString("DpiConfig","Could not upload file")})
                                                    }
                                                }});
                                        }
                                    },
                                    data:[]
                                }
                            ]
                        },
                        {view:"resizer"},
                        {
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiConfig","Config"), icon: "code"}),
                                {
                                    view:"codemirror-editor",
                                    id:this.Id + "HistoryImportContext" + "Editor",
                                    value:""
                                }
                            ]
                        }
                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("DpiConfig","Cancel"),
                            click:function ()
                            {
                                _this.HistoryImportContext.hide();
                                _this.Views.HistoryEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("DpiConfig","Apply"),
                            click:function () {
                                _this.HistoryImportContext.hide();

                                _this.ViewModel.SetConfig(_this.Views.HistoryEditor.getValue());

                                // _this.ViewModel.SetConfigModel(_this.GetFormsValues());

                                webix.message(LangHelper.GetString(_this.Id,"Applied"));

                                _this.Views.HistoryEditor.setValue("");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols:[
                AdministratorLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView", "Administrator"), title: LangHelper.GetString("AppView", "DPIUI2 (GUI) server configuration")}),
                                {
                                    rows:[
                                        {
                                            view: "toolbar",
                                            height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "floppy-o",
                                                    label: LangHelper.GetString("AppView", "Save"),
                                                    css: "toolbar_round_btn",
                                                    width: 128,
                                                    tooltip: LangHelper.GetString("AppView", "Save"),
                                                    click: function (id, e, node)
                                                    {
                                                        var __this = this;
                                                        setTimeout(function ()
                                                        {
                                                            _this.ConfigSave();
                                                        }, 1);
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    id:this.Id + "RestartQueueBtn",
                                                    type: "icon",
                                                    icon: "retweet",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("AppView", "Restart queue"),
                                                    click: function (id, e, node)
                                                    {
                                                        var __this = this;
                                                        setTimeout(function () {
                                                            var node = __this.getNode(id);
                                                            _this.UpdateParamsContext.show(node, {pos: "bottom"});
                                                        }, 1);
                                                    },

                                                },
                                                {
                                                    view: "button",
                                                    id:_this.Id + "HistoryBtn",
                                                    type: "icon",
                                                    icon: "history",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("Dpiui2Config","Download from history"),
                                                    click: function (id, e, node) {
                                                        var __this = this;
                                                        setTimeout(function () {
                                                            var node = __this.getNode(id);
                                                            _this.ViewModel.HistoryRefresh();
                                                            _this.HistoryImportContext.show(node, {pos: "bottom"});
                                                            _this.DefineHistoryForms();
                                                        }, 10);
                                                    }
                                                },
                                                {},
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        if(_this.mode == "dpiui2")
                                                        {
                                                            _this.Refresh();
                                                        }

                                                        if(_this.mode == "li")
                                                        {
                                                            _this.CheckHealth();
                                                        }
                                                    }
                                                },
                                                {
                                                    width:16
                                                },
                                                function(){
                                                    var tabbar = {
                                                        view:"tabbar",
                                                        id:_this.Id + "Editor" + "Tabs",
                                                        tabMoreWidth:0,
                                                        value:_this.Id + "Editor",
                                                        multiview:true,
                                                        //height:webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.material.tabbarHeight,
                                                        options: [
                                                            {
                                                                id: _this.Id + "Editor",
                                                                "value": "<span class='webix_icon fa-trello'></span> "+LangHelper.GetString("All","The form")
                                                            },
                                                            {
                                                                id: _this.Id + "Editor" + "Code",
                                                                "value": "<span class='webix_icon fa-code'></span> "+LangHelper.GetString("All","Editor")
                                                            }
                                                        ],
                                                        on:{
                                                            "onChange":function(Id, OldId)
                                                            {
                                                                if(Id == _this.Id + "Editor" + "Code")
                                                                {
                                                                    setTimeout(function ()
                                                                    {
                                                                        _this.Views.CodeEditor.setValue(_this.ViewModel.GetConfig());
                                                                    },1);
                                                                }

                                                                if(Id == _this.Id + "Editor")
                                                                {
                                                                    setTimeout(function ()
                                                                    {
                                                                        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                    },1);
                                                                }
                                                            }
                                                        }
                                                    };

                                                    if(webix.skin.$name === "dpiui2_vulkan" || webix.skin.$name === "dpiui2_vulkan")
                                                    {
                                                        tabbar = {
                                                            rows:[
                                                                {},
                                                                tabbar
                                                            ]
                                                        };
                                                    }

                                                    return tabbar;
                                                }()
                                            ]
                                        },
                                        {
                                            rows:[
                                                {
                                                    cells:[
                                                        {
                                                            id: this.Id + "Editor",
                                                            cols: [
                                                                {
                                                                    width: 400,
                                                                    rows: [
                                                                        BlockHeaderTemplate({title: LangHelper.GetString("All","Settings"), icon: "cogs"}),
                                                                        {
                                                                            view: "datatable",
                                                                            header:false,
                                                                            select: "row",
                                                                            on: {
                                                                                onAfterSelect: function (data, preserve) {
                                                                                    if($$(_this.Id + "Group_"+data.id))
                                                                                    {
                                                                                        $$(_this.Id + "Group_"+data.id).show();

                                                                                        var data = this.getItem(data.id);
                                                                                        if(data.url)
                                                                                        {
                                                                                            _this.Views.WiKi.load(data.url);
                                                                                        }
                                                                                    }
                                                                                }
                                                                            },
                                                                            columns: [
                                                                                {
                                                                                    id: "value",
                                                                                    fillspace: true
                                                                                }
                                                                            ],
                                                                            data: Dpiui2ConfigManager.GetSortedDpiui2EnvConfigGroupDicArr()
                                                                        }
                                                                    ]
                                                                },
                                                                {view: "resizer"},
                                                                {
                                                                    minWidth:880,
                                                                    rows: [
                                                                        {
                                                                            view:"multiview",
                                                                            id: this.Id + "Groups",
                                                                            cells:function ()
                                                                            {
                                                                                var cells = [];

                                                                                Dpiui2ConfigManager.GetSortedDpiui2EnvConfigGroupDicArr().forEach(function (Obj)
                                                                                {
                                                                                    if(parseInt(Obj.id) == 3)
                                                                                    {
                                                                                        cells.push({
                                                                                            id: _this.Id + "Group_" + Obj.id,
                                                                                            rows:[
                                                                                                BlockHeaderTemplate({
                                                                                                    title: Obj.value,
                                                                                                    icon: "cog"
                                                                                                }),
                                                                                                {
                                                                                                    view: "toolbar",
                                                                                                    height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 45,
                                                                                                    elements: [
                                                                                                        {
                                                                                                            view: "button",
                                                                                                            type: "icon",
                                                                                                            icon: "envelope-open",
                                                                                                            label: LangHelper.GetString("Dics", "Test email settings"),
                                                                                                            css: "toolbar_round_btn",
                                                                                                            width: 200,
                                                                                                            tooltip: LangHelper.GetString("Dics", "Test email settings"),
                                                                                                            click: function ()
                                                                                                            {
                                                                                                                _this.TestEmailPopupGetValue();
                                                                                                                _this.TestEmailSettingsPopupConfig.show();
                                                                                                                _this.Views.SendTestEmailButton.enable();
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    id:_this.Id + "Group_" + Obj.id + "_form",
                                                                                                    view:"form",
                                                                                                    scroll:true,
                                                                                                    elements:_this.ViewsFromDicForGroup(Obj.id)
                                                                                                }
                                                                                            ]
                                                                                        });
                                                                                    } else {
                                                                                        cells.push({
                                                                                            id: _this.Id + "Group_" + Obj.id,
                                                                                            rows:[
                                                                                                BlockHeaderTemplate({
                                                                                                    title: Obj.value,
                                                                                                    icon: "cog"
                                                                                                }),
                                                                                                {
                                                                                                    id:_this.Id + "Group_" + Obj.id + "_form",
                                                                                                    view:"form",
                                                                                                    scroll:true,
                                                                                                    elements:_this.ViewsFromDicForGroup(Obj.id)
                                                                                                }
                                                                                            ]
                                                                                        });
                                                                                    }
                                                                                });
                                                                                return cells;

                                                                            }()
                                                                        },
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id:this.Id + "Editor" + "Code",
                                                            rows:[
                                                                {
                                                                    view:"codemirror-editor",
                                                                    id:this.Id + "Editor" + "Code" + "Codetree",
                                                                    value:""
                                                                },
                                                                {
                                                                    view:"toolbar",
                                                                    borderless:true,
                                                                    elements:[
                                                                        {
                                                                            view:"checkbox",
                                                                            id:this.Id + "Editor" + "Code" + "ShowCommentsCheckbox",
                                                                            labelRight:LangHelper.GetString("DpiConfig", "Show comments"),
                                                                            labelWidth:0,
                                                                            on:
                                                                                {
                                                                                    "onChange":function(NewVal, OldVal)
                                                                                    {
                                                                                        App.SessionManager.SetPreference("Dpiui2ConfigManager:ShowComments",NewVal);

                                                                                        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                        _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                                                                                    }
                                                                                }
                                                                        },
                                                                        {
                                                                            view:"checkbox",
                                                                            id:this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox",
                                                                            labelRight:LangHelper.GetString("DpiConfig", "Show all params"),
                                                                            labelWidth:0,
                                                                            on:
                                                                                {
                                                                                    "onChange":function(NewVal, OldVal)
                                                                                    {
                                                                                        App.SessionManager.SetPreference("Dpiui2ConfigManager:ShowAllParams", NewVal);

                                                                                        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                        _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                                                                                    }
                                                                                }
                                                                        },
                                                                        {
                                                                            gravity:2
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Subscriptions = {};

    this.Views = {
        EditorTabs:null,
        CodeEditor:null,
        FormsGroups:{},
        SmtpSettingsPopupForm: null,
        TestEmailParamsPopupForm: null,
        ValidationDataContextCodeEditor:null,
        ImportContextCodeEditor:null,
        ImportContextUploader:null,
        HistoryTable:null,
        HistoryEditor:null,
        HistoryForwardBtn:null,
        HistoryBackBtn:null,
        RestartQueueBtn:null,
        ShowCommentsCheckbox:null,
        ShowAllParamsCheckbox:null
    };

    this.TestEmailSettingsPopupConfig = webix.ui({
        view: "popup",
        width: 1000,
        position: "center",
        padding: 0,
        marging: 0,
        modal: true,
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows: [
                        {
                            cols: [
                                {
                                    view: "form",
                                    id: _this.Id + "SmtpSettingsPopupForm",
                                    elements: [
                                        {
                                            view: "text",
                                            name: "CFG_SMTP_HOST",
                                            label: LangHelper.GetString("Dics", "SMTP host") + " (CFG_SMTP_HOST)",
                                            labelPosition: "top",
                                        },
                                        {
                                            view: "text",
                                            name: "CFG_SMTP_PORT",
                                            label: LangHelper.GetString("Dics", "SMTP port") + " (CFG_SMTP_PORT)",
                                            labelPosition: "top",
                                        },
                                        {
                                            view: "richselect",
                                            name: "CFG_SMTP_SECURE",
                                            label: LangHelper.GetString("Dics", "SMTP encryption type") + " (CFG_SMTP_SECURE)",
                                            labelPosition: "top",
                                            options: {
                                                point: false,
                                                data: Helper.DictToArr(SmtpSecureOptions)
                                            }
                                        },
                                        {
                                            view: "text",
                                            name: "CFG_SMTP_UNAME",
                                            label: LangHelper.GetString("Dics", "SMTP username") + " (CFG_SMTP_UNAME)",
                                            labelPosition: "top",
                                        },
                                        {
                                            view: "text",
                                            name: "CFG_SMTP_PW",
                                            label: LangHelper.GetString("Dics", "SMTP password") + " (CFG_SMTP_PW)",
                                            labelPosition: "top",
                                        },
                                        {
                                            view: "text",
                                            name: "CFG_SMTP_FROM",
                                            label: LangHelper.GetString("Dics", "Sender") + " (CFG_SMTP_FROM)",
                                            labelPosition: "top",
                                        }
                                    ]
                                },
                                {
                                    rows: [
                                        {
                                            view: "form",
                                            id: _this.Id + "TestEmailParamsPopupForm",
                                            elements: [
                                                {
                                                    view: "text",
                                                    name: "TO_TEST_EMAIL",
                                                    label: LangHelper.GetString("Dics", "Send test email to address:"),
                                                    labelPosition: "top",
                                                    placeholder: "test@test.com",
                                                    validate: webix.rules.isEmail,
                                                    invalidMessage: LangHelper.GetString("Dics", "Input valid email address!")
                                                },
                                                {
                                                    view: "text",
                                                    name: "SUBJECT_TEST_EMAIL",
                                                    label: LangHelper.GetString("Dics", "Email subject"),
                                                    labelPosition: "top",
                                                    placeholder: "test title",
                                                    value: "test title",
                                                    validate: function (Val)
                                                    {
                                                        return !!(Val);
                                                    },
                                                    invalidMessage: LangHelper.GetString("Dics", "Field could not be empty!")
                                                },
                                                {
                                                    view: "textarea",
                                                    height: 150,
                                                    name: "BODY_TEST_EMAIL",
                                                    label: LangHelper.GetString("Dics", "Email body:"),
                                                    labelPosition: "top",
                                                    placeholder: "test body",
                                                    value: "test body",
                                                    validate: function (Val)
                                                    {
                                                        return !!(Val);
                                                    },
                                                    invalidMessage: LangHelper.GetString("Dics", "Field could not be empty!")
                                                }
                                            ]
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: "button",
                                                    id: _this.Id + "SendTestEmailButton",
                                                    type: "icon",
                                                    icon: "envelope-open",
                                                    height: 50,
                                                    label: LangHelper.GetString("Dics", "Send test email"),
                                                    css: "toolbar_round_btn",
                                                    tooltip: LangHelper.GetString("Dics", "Send test email"),
                                                    click: function ()
                                                    {
                                                        _this.SendTestEmail();
                                                    }
                                                },
                                            ]
                                        },
                                    ]
                                }
                            ]
                        },
                        {},
                        {
                            cols: [
                                {},
                                {},
                                {
                                    view: "button",
                                    label: LangHelper.GetString("Dics", "Cancel"),
                                    click: function(){
                                    setTimeout(function () {
                                        _this.TestEmailSettingsPopupConfig.hide();
                                    },1);
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "TestEmailSettingsPopupApplyBtn",
                                    label:LangHelper.GetString("UlrModule","Apply"),
                                    click: function(){
                                        setTimeout(function () {
                                            _this.TestEmailPopupSetValue();
                                            _this.TestEmailSettingsPopupConfig.hide();
                                    },1);
                                    }
                                }
                            ]
                        }

                    ]
                }
            ]
        }
    })

    this.TestEmailPopupAgreement = webix.ui({
        view:"popup",
        width:400,
        height:180,
        position: "center",
        modal: true,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Dics", "Test email was sent successfully.") + "<br/><br/>"
                            + "<span style='color: red'>" + LangHelper.GetString("Dics", "Apply current options?")
                            + "</span>"
                },
                {
                    cols: [
                        {},
                        {
                            view: "button",
                            label: LangHelper.GetString("Dics", "Cancel"),
                            click: function () {
                                setTimeout(function () {
                                    _this.TestEmailPopupAgreement.hide();
                                }, 1);
                            }
                        },
                        {
                            view: "button",
                            label: LangHelper.GetString("UlrModule", "Apply"),
                            click: function () {
                                setTimeout(function () {
                                    _this.TestEmailPopupSetValue();
                                    _this.TestEmailPopupAgreement.hide();
                                    _this.TestEmailSettingsPopupConfig.hide();
                                }, 1);
                            }
                        }
                    ]
                }
            ]
        }
    })

    this.TestEmailPopupErrors = webix.ui({
        view:"popup",
        width:400,
        height:180,
        position: "center",
        modal: true,
        body:{
            rows: [
                {
                    view: "template",
                    borderless: true,
                    id: _this.Id + "TestEmailPopupErrors",
                    data: {
                    },
                    template: function (Obj) {
                        return Obj.text;
                    }
                },
                {
                    cols: [
                        {},
                        {
                            view: "button",
                            label: LangHelper.GetString("Dics", "Close"),
                            click: function () {
                                setTimeout(function () {
                                    _this.TestEmailPopupErrors.hide();
                                }, 1);
                            }
                        }
                    ]
                }
            ]
        }
    })

}

Dpiui2ConfigViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.CodeEditor = $$(this.Id + "Editor" + "Code" + "Codetree");
    this.Views.EditorTabs = $$(this.Id + "Editor" + "Tabs");

    this.Views.ShowCommentsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowCommentsCheckbox");
    this.Views.ShowAllParamsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox");

    this.Views.ShowCommentsCheckbox.blockEvent();
    this.Views.ShowCommentsCheckbox.setValue(App.SessionManager.GetPreference("Dpiui2ConfigManager:ShowComments"));
    this.Views.ShowCommentsCheckbox.unblockEvent();

    this.Views.ShowAllParamsCheckbox.blockEvent();
    this.Views.ShowAllParamsCheckbox.setValue(App.SessionManager.GetPreference("Dpiui2ConfigManager:ShowAllParams"));
    this.Views.ShowAllParamsCheckbox.unblockEvent();

    this.Views.SmtpSettingsPopupForm = $$(this.Id + "SmtpSettingsPopupForm");
    this.Views.TestEmailParamsPopupForm = $$(this.Id + "TestEmailParamsPopupForm");

    this.Views.SendTestEmailButton = $$(this.Id + "SendTestEmailButton");

    Dpiui2ConfigManager.GetSortedDpiui2EnvConfigGroupDicKeysArr().forEach(function (Key)
    {
        var formId = _this.Id + "Group_"+Key+"_form";
        if($$(formId))
        {
            _this.Views.FormsGroups[formId] = $$(formId);
        }
    });

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        _this.Views.FormsGroups[Key].attachEvent("onChange", function(newv, oldv)
        {
            _this.ViewModel.SetConfigModel(_this.GetFormsValues());
        });
    });

    this.Subscriptions.ConfigHistoryUpdated = this.ViewModel.Signals.ConfigHistoryUpdated.subscribe(function (value)
    {
        if (value)
        {
            _this.DefineHistoryForms();
        }
    });

    this.Subscriptions.ConfigUpdated = this.ViewModel.Signals.ConfigFileUpdated.subscribe(function (V)
    {
        if (V)
        {
            _this.DefineForms();
        }
    });

    this.Subscriptions.HardwaresDicSignalSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (Value) {

        if (Value)
        {
            var hws = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

            hws = hws.filter(function (Obj)
            {
                return Obj.hardware_type == HardwareTypesEnum.dpi;
            });

            hws.splice( 0, 0, {id:"",value:"",$empty:true} );

            Object.keys(_this.Views.FormsGroups).forEach(function (Key)
            {

                var els = _this.Views.FormsGroups[Key].elements;

                Object.keys(els).forEach(function (ElKey)
                {
                    var el = els[ElKey];

                    if(el.config.app_dic == DicsEnum.HardwaresDic)
                    {
                        var list = el.getList();
                        list.clearAll();
                        list.parse(hws);
                    }
                });

            });
        }
    });

    this.Views.HistoryTable = $$(this.Id + "HistoryImportContext" + "HistoryTable");
    this.Views.HistoryEditor = $$(this.Id + "HistoryImportContext" + "Editor");

    webix.extend(this.Views.HistoryEditor, webix.ProgressBar);

    _this.ViewModel.HistoryRefresh();
};

Dpiui2ConfigViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

    _this.Refresh();
};

Dpiui2ConfigViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });


    if(this.ViewModel)
        this.ViewModel.Destroy();
    delete this.ViewModel;
};

Dpiui2ConfigViewController.prototype.Refresh = function ()
{
    var _this = this;

    App.NavRouter.ShowProgress();

    this.ViewModel.Refresh({callback:function (R)
    {
        App.NavRouter.HideProgress();

        if(R.success)
        {
            webix.message(LangHelper.GetString("Dpiui2Config", "Configuration loaded."));
        }
        else
        {
            //webix.message({type:"error", text:R.error.msg});
            _this.ShowServerError(R.error);
        }
    }});
};

Dpiui2ConfigViewController.prototype.ViewFromDic = function (DicId)
{
    return Helper.ViewFromDpiConfigDic(DicId, Dpiui2EnvConfigDic);
};

Dpiui2ConfigViewController.prototype.ViewsFromDicForGroup = function (GroupId)
{
    var _this = this;

    var views = [];

    Dpiui2ConfigManager.GetSortedDpiui2EnvConfigDicKeysArr().forEach(function (Key)
    {
        if(Dpiui2EnvConfigDic[Key].group == GroupId && Dpiui2EnvConfigDic[Key].view)
        {
            // Issues #6076.3
            // Hide ULR_SCHEDULE_ENABLE and ULR_SCHEDULE_HOURS
            // if (!AppEnv.UlrShowCategory && (Dpiui2EnvConfigDic[Key].id == "ULR_SCHEDULE_ENABLE" || Dpiui2EnvConfigDic[Key].id == "ULR_SCHEDULE_HOURS"))
            //     return;

            views.push(_this.ViewFromDic(Key));
        }
    });

    return views;
};

Dpiui2ConfigViewController.prototype.DefineForms = function ()
{
    var _this = this;

    this.Views.CodeEditor.setValue(this.ViewModel.GetConfig());

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        var t = _this.ViewModel.GetConfigModel();

        _this.Views.FormsGroups[Key].setValues(_this.ViewModel.GetConfigModel());
    });
};

Dpiui2ConfigViewController.prototype.GetFormsValues = function ()
{
    var _this = this;

    var configModel = {};

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        Object.keys(_this.Views.FormsGroups[Key].elements).forEach(function (ElKey)
        {
            var el = _this.Views.FormsGroups[Key].elements[ElKey];
            configModel[ElKey] = el.getValue();
        });
    });

    return configModel;
};

Dpiui2ConfigViewController.prototype.ConfigSave = function (Params)
{
    var _this = this;

    if(_this.Views.EditorTabs.getValue() == _this.Id + "Editor" + "Code")
    {
        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
    }

    App.NavRouter.ShowProgress();

    this.ViewModel.Save({callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Configuration saved"));
                _this.ViewModel.RestartQueue();
            }
            else
            {
                //webix.message({type:"error", text:R.error.msg});
                _this.ShowServerError(R.error);
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }});
};

Dpiui2ConfigViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};

Dpiui2ConfigViewController.prototype.TestEmailPopupGetValue = function()
{
    var _this = this;

    var ConfigValuesPopup = _this.Views.SmtpSettingsPopupForm.getValues();
    var ConfigValues = _this.Views.FormsGroups[_this.Id + "Group_3_form"].getValues();

    Object.keys(ConfigValues).forEach(function (Key)
    {
        if (Object.keys(ConfigValuesPopup).includes(Key))
        {
           ConfigValuesPopup[Key] = ConfigValues[Key];
        }
    })

    _this.Views.SmtpSettingsPopupForm.setValues(ConfigValuesPopup);
}

Dpiui2ConfigViewController.prototype.TestEmailPopupSetValue = function()
{
    var _this = this;

    var ConfigValuesPopup = _this.Views.SmtpSettingsPopupForm.getValues();
    var ConfigValues = _this.Views.FormsGroups[_this.Id + "Group_3_form"].getValues();

    Object.keys(ConfigValuesPopup).forEach(function (Key)
    {
        ConfigValues[Key] = ConfigValuesPopup[Key];
    })

    _this.Views.FormsGroups[_this.Id + "Group_3_form"].setValues(ConfigValues);
}


Dpiui2ConfigViewController.prototype.SendTestEmail = function()
{
    var _this = this;

    if (_this.Views.TestEmailParamsPopupForm.validate())
    {
        this.Views.SendTestEmailButton.disable();

        var TestEmailConf = _this.Views.SmtpSettingsPopupForm.getValues();
        var TestEmailMessageConf = _this.Views.TestEmailParamsPopupForm.getValues();

        var params = {
            method: "SendTestEmail",
            data: {
                EmailConf: TestEmailConf,
                EmailMessageConf: TestEmailMessageConf
            },
            callback: function (R)
            {
                if(R.success)
                {
                    webix.message(LangHelper.GetString("Dics", "Test email was sent successfully."));
                    _this.TestEmailPopupAgreement.show();
                } else {
                    webix.message({type: "error", text: R.error.msg});
                    $$(_this.Id + "TestEmailPopupErrors").setValues({
                        text: LangHelper.GetString("Dics", "Test email was not sent.") + "<br/><br/>"
                            + "<span style='color: red'>" + R.error.msg
                            + "</span>"
                    })
                    _this.TestEmailPopupErrors.show();
                }

                _this.Views.SendTestEmailButton.enable();
            }
        };

        App.ServerManager.CallMethod(params);
    }
}

Dpiui2ConfigViewController.prototype.DefineHistoryForms = function (Params)
{
    this.Views.HistoryTable.clearAll();
    this.Views.HistoryTable.parse(this.ViewModel.GetHistory());
    this.Views.HistoryEditor.setValue("");
};
function Dpiui2LogsViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"Dpiui2Logs",
        PageTitle:{
            RootTitle: LangHelper.GetString("AppView", "Administrator"),
            Title: LangHelper.GetString("AppView", "DPIUI2 logs")
        },
        ServerMethods:
        {
            RefreshLogsFilesList:"GetDpiui2LogsFilesList",

            GetLogFileTail:"GetDpiui2LogFileTail",

            DownloadLogFile:"DownloadDpiui2LogFile"
        },
        PathsNamesMap:
        {
            "/var/www/html/dpiui2/backend/storage/logs":"Dpiui2"
        }
    },true);

    Dpiui2LogsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(Dpiui2LogsViewController,HardwareLogsViewController);

function Dpiui2UpdateViewController(Params)
{
    var _this = this;

    this.Id = "Dpiui2Update";

    this.ViewModel = new Dpiui2ConfigManager();

    this.Views = {
        Form:null,

        StatusIconLabel:null,
        StatusLabel:null,
        CurrentVersionLabel:null,
        DateOfInstallLabel:null,
        LastUpdateCheckLabel:null,

        AutoUpdateCheckbox:null,

        CheckUpdateBtn:null,
        StartUpdateBtn:null,
        StartUpdateBtnContext:null,

        UpdateLogAccordionItem:null,
        UpdateLogTailEditor:null,

        CheckForUpdateLogAccordionItem:null,
        CheckForUpdateLogTailEditor:null
    };

    this.ViewConfig = [
        {
            cols:[
                AdministratorLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView", "Administrator"), title: LangHelper.GetString("AppView", "DPIUI2 (GUI) update")}),
                                {
                                    height:16
                                },
                                {
                                    cols:[
                                        {
                                            width:1
                                        },
                                        {
                                            rows:[
                                                {
                                                    header:BlockHeaderTemplate().template({title: LangHelper.GetString("Dpiui2Config", "DPIUI2 update"), icon: "scrubber"}),
                                                    width:620,
                                                    body:{
                                                        rows:[
                                                            {
                                                                view: "form",
                                                                id: this.Id + "Form",
                                                                elements: [
                                                                    {
                                                                        cols:[
                                                                            {
                                                                                view:"label",
                                                                                id:this.Id + "StatusIconLabel",
                                                                                width:120,
                                                                                css:"label_big_font",
                                                                                label:"<span class='webix_icon fa-scrubber'></span>"
                                                                            },
                                                                            {
                                                                                rows:[
                                                                                    {
                                                                                        cols:[
                                                                                            {
                                                                                                view:"label",
                                                                                                id:this.Id + "StatusLabel",
                                                                                                css:"label_bold",
                                                                                                label:"..."
                                                                                            },
                                                                                            {
                                                                                                view: "button",
                                                                                                type: "icon",
                                                                                                icon: "refresh",
                                                                                                css: "toolbar_round_btn",
                                                                                                width: 32,
                                                                                                tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                                                                                click: function (id, e, node)
                                                                                                {
                                                                                                    _this.Refresh();
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        view:"label",
                                                                                        id:this.Id + "CurrentVersionLabel",
                                                                                        label:"..."
                                                                                    },
                                                                                    {
                                                                                        view:"label",
                                                                                        id:this.Id + "DateOfInstallLabel",
                                                                                        label:"..."
                                                                                    },
                                                                                    {
                                                                                        view:"label",
                                                                                        id:this.Id + "LastUpdateCheckLabel",
                                                                                        label:"..."
                                                                                    },
                                                                                    {
                                                                                        view:"checkbox",
                                                                                        id:this.Id + "AutoUpdateCheckbox",
                                                                                        labelWidth:0,
                                                                                        labelRight:LangHelper.GetString("Dpiui2Config","Automatically install updates."),
                                                                                        on:{
                                                                                            onChange:function(NewVal, OldVal)
                                                                                            {
                                                                                                _this.SetAutoupdateEnabled(NewVal);
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        cols:[
                                                                                            {},
                                                                                            {
                                                                                                view:"button",
                                                                                                id:this.Id + "CheckUpdateBtn",
                                                                                                label:LangHelper.GetString("Dpiui2Config", "Check for updates"),
                                                                                                disabled:true,
                                                                                                click:function ()
                                                                                                {
                                                                                                    //_this.Views.UpdateLogAccordionItem.collapse();

                                                                                                    _this.Views.CheckForUpdateLogAccordionItem.expand();

                                                                                                    _this.CheckForUpdates();
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                view:"button",
                                                                                                id:this.Id + "StartUpdateBtn",
                                                                                                type:"form",
                                                                                                label:LangHelper.GetString("Dpiui2Config", "Update now"),
                                                                                                disabled:true,
                                                                                                popup:{
                                                                                                    view:"popup",
                                                                                                    id:this.Id + "StartUpdateBtnContext",
                                                                                                    width:400,
                                                                                                    height:160,
                                                                                                    body:{
                                                                                                        view:"form",
                                                                                                        borderless:true,
                                                                                                        elements:[
                                                                                                            {
                                                                                                                template:LangHelper.GetString("Dpiui2Config", "Update can take several minutes. Please wait till it finished. Don`t forget press Ctrl+F5 after.")
                                                                                                            },
                                                                                                            {
                                                                                                                cols:[
                                                                                                                    {},
                                                                                                                    {
                                                                                                                        view:"button",
                                                                                                                        label:LangHelper.GetString("AppView", "Cancel"),
                                                                                                                        click:function ()
                                                                                                                        {
                                                                                                                            $$(_this.Id + "StartUpdateBtnContext").hide();
                                                                                                                        }
                                                                                                                    },
                                                                                                                    {
                                                                                                                        view:"button",
                                                                                                                        type:"form",
                                                                                                                        label:LangHelper.GetString("Dpiui2Config", "Update now"),
                                                                                                                        click:function ()
                                                                                                                        {
                                                                                                                            $$(_this.Id + "StartUpdateBtnContext").hide();

                                                                                                                            _this.Views.UpdateLogAccordionItem.expand();

                                                                                                                            //_this.Views.CheckForUpdateLogAccordionItem.collapse();

                                                                                                                            _this.StartUpdate();
                                                                                                                        }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    height:16
                                                },
                                                {
                                                    header:"WiKi",
                                                    body:{
                                                        rows:[
                                                            {
                                                                view:"iframe",
                                                                id:this.Id + "WiKi",
                                                                src:LangHelper.GetWikiLink("dpiui2_versions_info")
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    gravity:0
                                                }
                                            ]
                                        },
                                        {
                                            width:16
                                        },
                                        {
                                            rows:[
                                                {
                                                    id:this.Id + "UpdateLogAccordionItem",
                                                    header:BlockHeaderTemplate().template({title: LangHelper.GetString("Dpiui2Config", "DPIUI2 last update log") + " (" + LangHelper.GetString("Dpiui2Config", "Reversed order").toLowerCase() + ")", icon: "stack-overflow"}),
                                                    //width:620,
                                                    //collapsed:true,
                                                    body:{
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                elements: [
                                                                    {
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "download",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("Dpiui2Config", "Download the complete file"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ViewModel.DownloadUpdateLog();
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("Dpiui2Config", "Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshUpdateLogTail();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                view:"codemirror-editor",
                                                                id:this.Id + "UpdateLogTailEditor",
                                                                value:""
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    height:16
                                                },
                                                {
                                                    id:this.Id + "CheckForUpdateLogAccordionItem",
                                                    header:BlockHeaderTemplate().template({title: LangHelper.GetString("Dpiui2Config", "DPIUI2 last check for update log") + " (" + LangHelper.GetString("Dpiui2Config", "Reversed order").toLowerCase() + ")", icon: "stack-overflow"}),
                                                    //width:620,
                                                    //collapsed:true,
                                                    body:{
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                elements: [
                                                                    {
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "download",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("Dpiui2Config", "Download the complete file"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ViewModel.DownloadCheckForUpdateLog();
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("Dpiui2Config", "Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshCheckForUpdateLogTail();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                view:"codemirror-editor",
                                                                id:this.Id + "CheckForUpdateLogTailEditor",
                                                                value:""
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    gravity:0
                                                }
                                            ]
                                        },
                                        {
                                            width:1
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Subscriptions = {};

    this.MonitorTimer = null;
    this.MonitorTimerSpeedInSec = 3;


    this.AfterUpdateContext = this.Id + "AfterUpdateContext";
    this.AfterUpdateContextConfig = {
        view:"popup",
        id:this.AfterUpdateContext,
        width:480,
        height:160,
        modal:true,
        body:{
        view:"form",
            borderless:true,
            elements:[
            {
                template:LangHelper.GetString("Dpiui2Config", "The update script has completed the work. It` required to refresh the page. Click Refresh page or ctrl + f5.")
            },
            {
                cols:[
                    {},
                    {
                        view:"button",
                        label:LangHelper.GetString("AppView", "Cancel"),
                        click:function ()
                        {
                            $$(_this.AfterUpdateContext).hide();
                        }
                    },
                    {
                        view:"button",
                        type:"form",
                        label:LangHelper.GetString("Dpiui2Config", "Reload page"),
                        click:function ()
                        {
                            window.location.reload(true);
                        }
                    }
                ]
            }
        ]
        }
    };
    this.AfterUpdateContext = null;
}

Dpiui2UpdateViewController.prototype.BindAll = function ()
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    webix.extend(this.Views.UpdateLogTailEditor, webix.ProgressBar);

    webix.extend(this.Views.CheckForUpdateLogTailEditor, webix.ProgressBar);

    this.AfterUpdateContext = webix.ui(this.AfterUpdateContextConfig);

    this.Subscriptions.UpdateStatus = this.ViewModel.Signals.UpdateStatus.subscribe(function (Status)
    {
        if (Status)
        {
            _this.DefineStatus(Status);

            _this.MonitorUpdatingState(Status);

            _this.RefreshUpdateLogTail();

            if(!Status.is_runnig)
                _this.RefreshCheckForUpdateLogTail();

            if(Status.is_runnig_before && !Status.is_runnig)
                _this.AfterUpdateContext.show(_this.Views.StartUpdateBtn.getNode(), {pos:"bottom"});
        }
    });

    this.Subscriptions.UpdateLogTail = this.ViewModel.Signals.UpdateLogTail.subscribe(function (Log)
    {
        _this.Views.UpdateLogTailEditor.setValue(Log);
    });

    this.Subscriptions.CheckForUpdateLogTail = this.ViewModel.Signals.CheckForUpdateLogTail.subscribe(function (Log)
    {
        _this.Views.CheckForUpdateLogTailEditor.setValue(Log);
    });
};

Dpiui2UpdateViewController.prototype.ViewDidLoad = function ()
{
    this.BindAll();

    this.Refresh();
};

Dpiui2UpdateViewController.prototype.Destroy = function ()
{
    var _this = this;

    clearTimeout(this.MonitorTimer);

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });


    if(this.ViewModel)
        this.ViewModel.Destroy();
    delete this.ViewModel;
};

Dpiui2UpdateViewController.prototype.Refresh = function ()
{
    this.ViewModel.RefreshUpdateFullStatus();
};

Dpiui2UpdateViewController.prototype.DefineLabel = function (Label, Text)
{
    Label.define("label",Text);
    Label.refresh();
};

Dpiui2UpdateViewController.prototype.EnableProgressForButton = function (Btn, Text)
{
    if(Btn.config.icon == "spinner-third")
        return;

    Btn.config.type_was = Btn.config.type ? Btn.config.type : "";
    Btn.define("icon","spinner-third");
    Btn.define("type","icon");
    Btn.define("css","btn_icon_spin");
    Btn.refresh();
};

Dpiui2UpdateViewController.prototype.DisableProgressForButton = function (Btn, Text)
{
    if(Btn.config.icon != "spinner-third")
        return;

    Btn.define("icon","");
    Btn.define("type", Btn.config.type_was ? Btn.config.type_was : "");
    Btn.define("css","");
    Btn.refresh();
};

Dpiui2UpdateViewController.prototype.DefineStatus = function (Status)
{
    var status = new Dpiui2UpdateStatusModel(Status);

    if(status.undefined)
        return;

    switch(status.has_new_version)
    {
        case 1:
            webix.html.addCss(this.Views.StatusLabel.getNode(), "label_vas_color");
            webix.html.addCss(this.Views.StatusIconLabel.getNode(), "label_vas_color");
            break;
        default:
            webix.html.removeCss(this.Views.StatusLabel.getNode(), "label_vas_color");
            webix.html.removeCss(this.Views.StatusIconLabel.getNode(), "label_vas_color");
            break;
    }

    this.DefineLabel(this.Views.StatusLabel, status.has_new_version ? LangHelper.GetString("Dpiui2Config", "New version [version] is available.").replace("[version]", status.new_version) : LangHelper.GetString("Dpiui2Config", "No new version is available."));

    this.DefineLabel(this.Views.CurrentVersionLabel, LangHelper.GetString("Dpiui2Config", "Current version is") + " " + (status.current_version ? status.current_version : LangHelper.GetString("Dpiui2Config", "Undefined").toLowerCase()));

    this.DefineLabel(this.Views.DateOfInstallLabel, LangHelper.GetString("Dpiui2Config", "Date of install / update is") + " " + (status.date_of_install ? status.date_of_install : LangHelper.GetString("Dpiui2Config", "Undefined").toLowerCase()));

    this.DefineLabel(this.Views.LastUpdateCheckLabel, LangHelper.GetString("Dpiui2Config", "Last check for update is") + " " + (status.update_last_check ? status.update_last_check : LangHelper.GetString("Dpiui2Config", "Undefined").toLowerCase()));


    this.Views.AutoUpdateCheckbox.blockEvent();
    this.Views.AutoUpdateCheckbox.setValue(status.autoupdate ? 1 : 0);
    this.Views.AutoUpdateCheckbox.unblockEvent();

    if(!status.is_runnig)
    {
        this.Views.CheckUpdateBtn.enable();

        if(status.has_new_version)
            this.Views.StartUpdateBtn.enable();
        else
            this.Views.StartUpdateBtn.disable();

        this.DisableProgressForButton(this.Views.CheckUpdateBtn);
        this.DisableProgressForButton(this.Views.StartUpdateBtn);
    }
    else
    {
        this.Views.CheckUpdateBtn.disable();
        this.Views.StartUpdateBtn.disable();

        this.EnableProgressForButton(this.Views.StartUpdateBtn);
    }
};

Dpiui2UpdateViewController.prototype.SetAutoupdateEnabled = function (Enabled)
{
    var _this = this;

    this.Views.AutoUpdateCheckbox.disable();

    this.ViewModel.SetAutoupdateEnabled({
        enabled:Enabled,
        callback:function (R)
        {
            _this.Views.AutoUpdateCheckbox.enable();

            if(!R.success)
            {
                //webix.message({type:"error", text:R.error.msg});
                _this.ShowServerError(R.error);
            }

            _this.Refresh();
        }
    });
};

Dpiui2UpdateViewController.prototype.CheckForUpdates = function ()
{
    var _this = this;

    this.EnableProgressForButton(this.Views.CheckUpdateBtn);

    this.Views.CheckUpdateBtn.disable();
    this.Views.StartUpdateBtn.disable();

    this.ViewModel.CheckForUpdates({
        callback:function (R)
        {
            _this.DisableProgressForButton(_this.Views.CheckUpdateBtn);

            if(!R.success)
            {
                //webix.message({type:"error", text:R.error.msg});
                _this.ShowServerError(R.error);
            }

            _this.Refresh();
        }
    });
};

Dpiui2UpdateViewController.prototype.StartUpdate = function ()
{
    var _this = this;

    this.EnableProgressForButton(this.Views.StartUpdateBtn);

    this.Views.CheckUpdateBtn.disable();
    this.Views.StartUpdateBtn.disable();

    this.ViewModel.StartUpdate({
        callback:function (R)
        {
            if(!R.success)
            {
                //webix.message({type:"error", text:R.error.msg});
                _this.ShowServerError(R.error);
            }

            _this.Refresh();
        }
    });
};

Dpiui2UpdateViewController.prototype.RefreshUpdateLogTail = function ()
{
    var _this = this;

    this.Views.UpdateLogTailEditor.showProgress({type: "icon"});

    this.ViewModel.RefreshDpiui2UpdateLogTail({callback:function (R)
        {
            _this.Views.UpdateLogTailEditor.hideProgress();
        }});
};

Dpiui2UpdateViewController.prototype.MonitorUpdatingState = function(Status)
{
    var _this = this;

    clearTimeout(this.MonitorTimer);

    var status = new Dpiui2UpdateStatusModel(Status);

    if(status.is_runnig)
    {
        _this.MonitorTimer = setTimeout(function ()
        {
            _this.Refresh();
        }, _this.MonitorTimerSpeedInSec*1000);
    }
};

Dpiui2UpdateViewController.prototype.RefreshCheckForUpdateLogTail = function ()
{
    var _this = this;

    this.Views.CheckForUpdateLogTailEditor.showProgress({type: "icon"});

    this.ViewModel.RefreshDpiui2CheckForUpdateLogTail({callback:function (R)
        {
            _this.Views.CheckForUpdateLogTailEditor.hideProgress();
        }});
};

Dpiui2UpdateViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};
function QoEStorConfigViewController(Params)
{
    var _this = this;

    this.Id = "QoEStorConfig";

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new QoEStorConfigManager();

    this.UpdateParamsContextId = this.Id + "UpdateParamsContext";
    this.UpdateParamsContext = webix.ui({
        view:"submenu",
        id:this.UpdateParamsContextId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.UpdateParamsContextId+"RestartConfig", icon: "retweet", value: LangHelper.GetString(_this.Id, "Restart configuration")},
            {id: this.UpdateParamsContextId+"RestartOptions", icon: "bolt", value: LangHelper.GetString(_this.Id,"Updating hot options")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                if(id === _this.UpdateParamsContextId+"RestartConfig")
                {
                    setTimeout(function () {
                        _this.RestartConfig();
                    }, 1);
                }
                else if(id === _this.UpdateParamsContextId+"RestartOptions")
                {
                    setTimeout(function () {
                        _this.RestartOptions();
                    }, 1);
                }
            }
        }
    });

    this.HistoryImportContext = webix.ui({
        view:"popup",
        width:800,
        height:720,
        id:this.Id+"HistoryImportContext",
        modal:true,
        body:{
            rows:[
                {
                    borderless:true,
                    cols:[
                        {
                            width:240,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiConfig","History"), icon: "history"}),
                                {
                                    view:"datatable",
                                    id:this.Id + "HistoryImportContext" + "HistoryTable",
                                    select: "row",
                                    columns: [
                                        {
                                            id: "date",
                                            header: [LangHelper.GetString("DpiConfig","Date"), {content: "dateRangeFilter"}],
                                            format: webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"),
                                            fillspace: true,
                                            sort: "date"
                                        }
                                    ],
                                    on:{
                                        onAfterLoad:function(){
                                            this.sort("date", "desc", "date");
                                            this.markSorting("date", "desc");
                                        },
                                        onAfterSelect: function (data, preserve)
                                        {
                                            var rowData = this.getItem(data);

                                            _this.Views.HistoryEditor.showProgress({type: "icon"});

                                            _this.ViewModel.LoadHistoryFile({configFile:rowData.file_id, callback:function (R)
                                                {
                                                    _this.Views.HistoryEditor.hideProgress({type: "icon"});
                                                    if(R.success)
                                                    {
                                                        _this.Views.HistoryEditor.setValue(R.data);
                                                    }
                                                    else
                                                    {
                                                        webix.message({type:"error",text:LangHelper.GetString("DpiConfig","Could not upload file")})
                                                    }
                                                }});
                                        }
                                    },
                                    data:[]
                                }
                            ]
                        },
                        {view:"resizer"},
                        {
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiConfig","Config"), icon: "code"}),
                                {
                                    view:"codemirror-editor",
                                    id:this.Id + "HistoryImportContext" + "Editor",
                                    value:""
                                }
                            ]
                        }
                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("DpiConfig","Cancel"),
                            click:function ()
                            {
                                _this.HistoryImportContext.hide();
                                _this.Views.HistoryEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("DpiConfig","Apply"),
                            click:function () {
                                _this.HistoryImportContext.hide();

                                _this.ViewModel.SetConfig(_this.Views.HistoryEditor.getValue());

                                // _this.ViewModel.SetConfigModel(_this.GetFormsValues());

                                webix.message(LangHelper.GetString(_this.Id,"Applied"));

                                _this.Views.HistoryEditor.setValue("");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.RestartReceiversContext = webix.ui({
        id: this.Id + "RestartReceiversContext",
        view:"popup",
        width:370,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to restart all receivers?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.Views.RestartReceiversContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("QoE","Restart"),
                            click:function ()
                            {
                                _this.RestartAllReceivers();
                                _this.Views.RestartReceiversContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.StopReceiversContext = webix.ui({
        id: this.Id + "StopReceiversContext",
        view:"popup",
        width:370,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to stop all receivers?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.Views.StopReceiversContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("QoE","Stop"),
                            click:function ()
                            {
                                _this.StopAllReceivers();
                                _this.Views.StopReceiversContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ImportReceiversConfigContext = webix.ui({
        view: "popup",
        id: this.Id + "ImportReceiversConfig" + "Popup",
        width: 720,
        height: 720,
        modal: true,
        body: {
            view: "form",
            id: this.Id + "ImportReceiversConfig" + "Form",
            borderless: true,
            elements: [
                {
                    view: "uploader",
                    value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                    id: this.Id + "ImportReceiversConfig" + "Uploader",
                    css: "upload_area",
                    autosend: false,
                    height: 64
                },
                {
                    view: "codemirror-editor",
                    id: this.Id + "ImportReceiversConfig" + "Text",
                    value: ""
                },
                {
                    cols: [
                        {},
                        {
                            view: "button",
                            label: LangHelper.GetString(_this.Id,"Cancel"),
                            click: function ()
                            {
                                _this.Views.ImportReceiversConfigPopup.hide();
                                _this.Views.ImportReceiversConfigText.setValue("");
                            }
                        },
                        {
                            view: "button",
                            type: "form",
                            label: LangHelper.GetString(_this.Id,"Apply"),
                            click: function () {
                                _this.ApplyMergedReceiversConfig();
                                _this.Views.ImportReceiversConfigPopup.hide();
                                _this.Views.ImportReceiversConfigText.setValue("");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ExportReceiversConfigSubmenu = webix.ui({
        id: this.Id + "ExportReceiversConfig" + "Submenu",
        view: "submenu",
        width: 400,
        autoheight: true,
        select: false,
        data: [
            {id: "toExcel", value: "Excel " + LangHelper.GetString(this.Id, "configuration file")},
            // {id: "toCSV", value: "CSV " + LangHelper.GetString(this.Id, "configuration file")},
            {id: "toTabSeparated", value: "TabSeparated " + LangHelper.GetString(this.Id, "configuration file")},
            {id: "toTXT", value: " TXT " + LangHelper.GetString(this.Id, "configuration file")}
        ],
        on: {
            onMenuItemClick: function(Id) {
                let filename = "qoe_receivers_configuration";

                switch(Id)
                {
                    case "toTXT":
                        let config = _this.ViewModel.GetConfig()
                            .split("\n")
                            .filter(item =>
                                Object.values(QoEStorIpfixReceiverTypesEnum).some(i => item.includes(i))
                            );

                        _this.ViewModel.LocalDownloadFile(config.join("\n"), "text/plain", filename + ".txt");
                        break;
                    case "toTabSeparated":
                        let headersIds = Object.values(QoEStorEnvConfigReceiverDic).map(item => item.id);
                        let items = _this.Views.ReceiversTable.serialize();

                        if(items.length)
                        {
                            let lines = items.map(item => {
                                let vals = headersIds.map(Id => (item[Id] ? item[Id] : ""));
                                return vals.join("\t");
                            });

                            lines.unshift(headersIds.join("\t"));

                            _this.ViewModel.LocalDownloadFile(lines.join("\n"), "text/tab-separated-values", filename + ".tsv");
                        }
                        break;
                    default:
                        webix.csv.delimiter.cols = ",";
                        webix[Id](
                            _this.Views.ReceiversTable,
                            {
                                filename: filename,
                                columns: Object.values(QoEStorEnvConfigReceiverDic).map(item => ({ id: item.id, header: item.id })),
                                rawValues: true
                            }
                        );
                }

                this.hide();
            }
        }
    });

    this.ViewConfig = [
        {
            cols:[
                AdministratorLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView", "Administrator"), title: LangHelper.GetString("AppView", "QoE Stor (fastor) server configuration")}),
                                {
                                    view: "accordion",
                                    multi: "mixed",
                                    on:{
                                        onAfterExpanded: function()
                                        {
                                            return true;
                                        }
                                    },
                                    cols:[
                                        {
                                            header: LangHelper.GetString(this.Id,"QoE Stor nodes"),
                                            body:{
                                                view: "datatable",
                                                id: this.Id + "HardwareList",
                                                header:false,
                                                select: "row",
                                                tooltip:true,
                                                columns: [
                                                    {
                                                        id: "value",
                                                        header: LangHelper.GetString(this.Id,"Hardware"),
                                                        width: 120,
                                                        fillspace: true,
                                                        sort: "string"
                                                    },
                                                ],
                                                on: {
                                                    onAfterLoad:function()
                                                    {
                                                        if (!this.count())
                                                        {
                                                            var text = "<br/><br/><br/>";

                                                            text += LangHelper.GetString(_this.Id,"There is no QoE Stor nodes.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>.")

                                                            this.showOverlay(text);
                                                        }
                                                    },
                                                    onAfterSelect: function(id)
                                                    {
                                                        var item = this.getItem(id);
                                                        setTimeout(function()
                                                        {
                                                            _this.ViewModel.SetHwId(item.id);
                                                            _this.Refresh();
                                                        }, 1);
                                                    }
                                                }
                                            }
                                        },
                                        {view:"resizer"},
                                        {
                                            header: LangHelper.GetString(this.Id,"Configuration"),
                                            gravity: 6,
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id: this.Id + "SaveBtn",
                                                                type: "icon",
                                                                icon: "floppy-o",
                                                                label: LangHelper.GetString("AppView", "Save"),
                                                                css: "toolbar_round_btn",
                                                                width: 128,
                                                                tooltip: LangHelper.GetString("AppView", "Save"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function ()
                                                                    {
                                                                        _this.ConfigSave();
                                                                    }, 1);
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "RestartBtn",
                                                                type: "icon",
                                                                icon: "retweet",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("AppView", "Restart"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.UpdateParamsContext.show(node, {pos: "bottom"});
                                                                    }, 1);
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "icon",
                                                                id: this.Id + "ForcedDownloadBtn",
                                                                icon: "cloud-download-alt",
                                                                css:"toolbar_round_btn",
                                                                tooltip: LangHelper.GetString("QoEStorConfig", "Forced download of directories"),
                                                                width:32,
                                                                click: function () {
                                                                    _this.ForcedDownloadReferenceBook();
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:_this.Id + "HistoryBtn",
                                                                type: "icon",
                                                                icon: "history",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("DpiConfig","Download from history"),
                                                                click: function (id, e, node) {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.ViewModel.HistoryRefresh();
                                                                        _this.HistoryImportContext.show(node, {pos: "bottom"});
                                                                        _this.DefineHistoryForms();
                                                                    }, 10);
                                                                }
                                                            },
                                                            {},
                                                            {
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    if(_this.mode == "dpiui2")
                                                                    {
                                                                        _this.Refresh();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                width:16
                                                            },
                                                            function(){
                                                                var tabbar = {
                                                                    view:"tabbar",
                                                                    id:_this.Id + "Editor" + "Tabs",
                                                                    tabMoreWidth:0,
                                                                    value:_this.Id + "Editor",
                                                                    multiview:true,
                                                                    //height:webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.material.tabbarHeight,
                                                                    options: [
                                                                        {
                                                                            id: _this.Id + "Editor",
                                                                            "value": "<span class='webix_icon fa-trello'></span> "+LangHelper.GetString("All","The form")
                                                                        },
                                                                        {
                                                                            id: _this.Id + "Editor" + "Code",
                                                                            "value": "<span class='webix_icon fa-code'></span> "+LangHelper.GetString("All","Editor")
                                                                        }
                                                                    ],
                                                                    on:{
                                                                        "onChange":function(Id, OldId)
                                                                        {
                                                                            if(Id == _this.Id + "Editor" + "Code")
                                                                            {
                                                                                setTimeout(function ()
                                                                                {
                                                                                    _this.Views.CodeEditor.setValue(_this.ViewModel.GetConfig());
                                                                                },1);
                                                                            }

                                                                            if(Id == _this.Id + "Editor")
                                                                            {
                                                                                setTimeout(function ()
                                                                                {
                                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                },1);
                                                                            }
                                                                        }
                                                                    }
                                                                };

                                                                if(webix.skin.$name === "dpiui2_vulkan" || webix.skin.$name === "dpiui2_vulkan")
                                                                {
                                                                    tabbar = {
                                                                        rows:[
                                                                            {},
                                                                            tabbar
                                                                        ]
                                                                    };
                                                                }

                                                                return tabbar;
                                                            }()
                                                        ]
                                                    },
                                                    {
                                                        id:_this.Id + "FormPanel",
                                                        rows:[
                                                            {
                                                                cells:[
                                                                    {
                                                                        id: this.Id + "Editor",
                                                                        cols: [
                                                                            {
                                                                                width: 400,
                                                                                rows: [
                                                                                    BlockHeaderTemplate({title: LangHelper.GetString("All","Settings"), icon: "cogs"}),
                                                                                    {
                                                                                        view: "datatable",
                                                                                        id: _this.Id + "SettingsMenu",
                                                                                        header:false,
                                                                                        select: "row",
                                                                                        on: {
                                                                                            onAfterSelect: function (data, preserve) {
                                                                                                if($$(_this.Id + "Group_"+data.id))
                                                                                                {
                                                                                                    $$(_this.Id + "Group_"+data.id).show();

                                                                                                    var data = this.getItem(data.id);
                                                                                                    if(data.url)
                                                                                                    {
                                                                                                        _this.Views.WiKi.load(data.url);
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        columns: [
                                                                                            {
                                                                                                id: "value",
                                                                                                fillspace: true
                                                                                            }
                                                                                        ],
                                                                                        data: QoEStorConfigManager.GetSortedQoEStorEnvConfigGroupDicArr()
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {view: "resizer"},
                                                                            {
                                                                                rows: [
                                                                                    {
                                                                                        view:"multiview",
                                                                                        id: this.Id + "Groups",
                                                                                        cells:function ()
                                                                                        {
                                                                                            var cells = [];

                                                                                            QoEStorConfigManager.GetSortedQoEStorEnvConfigGroupDicArr().forEach(function (Obj)
                                                                                            {
                                                                                                var rows = [];

                                                                                                rows.push(BlockHeaderTemplate({
                                                                                                    title: Obj.value,
                                                                                                    icon: "cog"
                                                                                                }));

                                                                                                if(Obj.id == "1")
                                                                                                {
                                                                                                    rows.push(_this.ViewsForReceiversGroup(Obj.id))
                                                                                                }
                                                                                                else if (Obj.id == "15")
                                                                                                {
                                                                                                    rows.push(_this.ViewsForClustersGroup(Obj.id))
                                                                                                }
                                                                                                else
                                                                                                    rows.push({
                                                                                                        id:_this.Id + "Group_" + Obj.id + "_form",
                                                                                                        view:"form",
                                                                                                        scroll: true,
                                                                                                        elements:_this.ViewsFromDicForGroup(Obj.id)
                                                                                                    });

                                                                                                //rows.push({});

                                                                                                cells.push({
                                                                                                    id: _this.Id + "Group_" + Obj.id,
                                                                                                    rows:rows
                                                                                                });
                                                                                            });

                                                                                            return cells;

                                                                                        }()
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        id:this.Id + "Editor" + "Code",
                                                                        rows:[
                                                                            {
                                                                                view:"codemirror-editor",
                                                                                id:this.Id + "Editor" + "Code" + "Codetree",
                                                                                value:""
                                                                            },
                                                                            {
                                                                                view:"toolbar",
                                                                                borderless:true,
                                                                                elements:[
                                                                                    {
                                                                                        view:"checkbox",
                                                                                        id:this.Id + "Editor" + "Code" + "ShowCommentsCheckbox",
                                                                                        labelRight:LangHelper.GetString("DpiConfig", "Show comments"),
                                                                                        labelWidth:0,
                                                                                        on:
                                                                                            {
                                                                                                "onChange":function(NewVal, OldVal)
                                                                                                {
                                                                                                    App.SessionManager.SetPreference("QoEStorConfigManager:ShowComments",NewVal);

                                                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                                    _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                                                                                                }
                                                                                            }
                                                                                    },
                                                                                    {
                                                                                        view:"checkbox",
                                                                                        id:this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox",
                                                                                        labelRight:LangHelper.GetString("DpiConfig", "Show all params"),
                                                                                        labelWidth:0,
                                                                                        on:
                                                                                            {
                                                                                                "onChange":function(NewVal, OldVal)
                                                                                                {
                                                                                                    App.SessionManager.SetPreference("QoEStorConfigManager:ShowAllParams", NewVal);

                                                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                                    _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                                                                                                }
                                                                                            }
                                                                                    },
                                                                                    {
                                                                                        gravity:2
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.EditReceiverContextFormColsNumber = 3;

    this.EditReceiverContextFormConfig = {
        view:"popup",
        maxWidth:800,
        modal:true,
        height: 0,
        body:
        {
            view:"form",
            id:this.Id + "EditReceiverContextForm",
            borderless:true,
            elements:function(){
                var els = [];

                var formCols = [];
                var i = 0;

                Object.keys(QoEStorEnvConfigReceiverDic).forEach(function (Key)
                {
                    var el = Helper.ViewFromDpiConfigDic(Key, QoEStorEnvConfigReceiverDic);

                    if(!formCols[i])
                        formCols[i] = []

                    formCols[i].push(el);

                    i++;

                    if(i >= _this.EditReceiverContextFormColsNumber)
                        i = 0;
                });

                els.push({
                    cols:function()
                    {
                        var r = [];

                        formCols.forEach(function (Arr)
                        {
                            r.push({rows:Arr});
                        })

                        return r;
                    }()
                });

                els.push({
                    cols:[
                        {
                            gravity:2
                        },
                        {
                            view:"button",
                            label:LangHelper.GetString("All", "Cancel"),
                            click: function ()
                            {
                                _this.HideReceiverEditForm();
                            }
                        },
                        {
                            view:"button",
                            label:LangHelper.GetString("All", "Apply"),
                            type:"form",
                            click: function ()
                            {
                                _this.ApplyReceiverEditForm();
                            }
                        }
                    ]
                });

                return els;
            }()
        }
    };

    this.EditClusterContextFormConfig = {
        view:"popup",
        maxWidth:800,
        modal:true,
        height: 0,
        body:
            {
                view:"form",
                id:this.Id + "EditClusterContextForm",
                borderless:true,
                elements:function(){
                    var els = [];

                    var formCols = [];
                    var i = 0;

                    Object.keys(QoEStorEnvConfigClusterDic).forEach(function (Key)
                    {
                        var el = Helper.ViewFromDpiConfigDic(Key, QoEStorEnvConfigClusterDic);

                        if(!formCols[i])
                            formCols[i] = []

                        formCols[i].push(el);

                        i++;
                    });

                    els.push({
                        cols:function()
                        {
                            var r = [];

                            formCols.forEach(function (Arr)
                            {
                                r.push({rows:Arr});
                            })

                            return r;
                        }()
                    });

                    els.push({
                        cols:[
                            {
                                gravity:2
                            },
                            {
                                view:"button",
                                label:LangHelper.GetString("All", "Cancel"),
                                click: function ()
                                {
                                    _this.HideClusterEditForm();
                                }
                            },
                            {
                                view:"button",
                                label:LangHelper.GetString("All", "Apply"),
                                type:"form",
                                click: function ()
                                {
                                    _this.ApplyClusterEditForm();
                                }
                            }
                        ]
                    });

                    return els;
                }()
            }
    };

    this.Subscriptions = {};

    this.Views = {
        HardwareList: null,
        EditorTabs:null,
        CodeEditor:null,
        FormsGroups:{},
        ValidationDataContextCodeEditor:null,
        ImportContextCodeEditor:null,
        ImportContextUploader:null,
        HistoryTable:null,
        HistoryEditor:null,
        HistoryForwardBtn:null,
        HistoryBackBtn:null,
        SaveBtn:null,
        RestartBtn:null,
        ForcedDownloadBtn:null,
        ShowCommentsCheckbox:null,
        ShowAllParamsCheckbox:null,
        CustomPrtclsDicUrlBtn: null,
        CustomPrtclsGrpsDicUrlBtn: null,
        CompanyPrtclsDicUrlBtn: null,
        CompanyPrtclsGrpsDicUrlBtn: null,

        ReceiversTable:null,
        AddReceiverBtn:null,

        RestartReceiversContext:null,
        StopReceiversContext:null,
        RestartReceiversBtn:null,
        StopReceiversBtn:null,

        ExportReceiversConfigBtn:null,
        ExportReceiversConfigSubmenu:null,

        ImportReceiversConfigBtn:null,
        ImportReceiversConfigPopup:null,
        ImportReceiversConfigForm:null,
        ImportReceiversConfigUploader:null,
        ImportReceiversConfigText:null,

        EditReceiverContextFormPopup:null,
        EditReceiverContextForm:null,

        ClustersTable:null,
        AddClusterBtn:null,

        EditClusterContextFormPopup:null,
        EditClusterContextForm:null,

        RestartLogPopup:webix.ui({
            view:"popup",
            maxWidth:800,
            height:"auto",
            modal:true,
            body:{
                view:"form",
                borderless:true,
                elements:[
                    {
                        view:"codemirror-editor",
                        id:this.Id + "RestartLog",
                        value:""
                    },
                    {
                        cols:[
                            {
                                gravity:3
                            },
                            {
                                view:"button",
                                type:"form",
                                label:"Ok",
                                click:function ()
                                {
                                    _this.Views.RestartLogPopup.hide();
                                    _this.Views.RestartLog.setValue("");
                                }
                            }
                        ]
                    }
                ]
            }
        }),
        RestartLog:$$(this.Id + "RestartLog"),

        FullflowAggLogSettingsPopup: null,
        FullflowAggLogSettingsPopupForm: null,
    };

    this.FullflowLogTimeIntervalInputViewConfig = null;

    this.CurentMergedReceiversConfig = null;
}

QoEStorConfigViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    window.test = this;

    this.Views.FormPanel = $$(this.Id + "FormPanel");
    webix.extend(this.Views.FormPanel, webix.OverlayBox);

    this.Views.SaveBtn = $$(this.Id + "SaveBtn");
    this.Views.RestartBtn = $$(this.Id + "RestartBtn");
    this.Views.ForcedDownloadBtn = $$(this.Id + "ForcedDownloadBtn");

    this.Views.HardwareList = $$(this.Id + "HardwareList");

    this.Views.CodeEditor = $$(this.Id + "Editor" + "Code" + "Codetree");
    this.Views.EditorTabs = $$(this.Id + "Editor" + "Tabs");

    this.Views.ShowCommentsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowCommentsCheckbox");
    this.Views.ShowAllParamsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox");

    this.Views.ShowCommentsCheckbox.blockEvent();
    this.Views.ShowCommentsCheckbox.setValue(App.SessionManager.GetPreference("QoEStorConfigManager:ShowComments"));
    this.Views.ShowCommentsCheckbox.unblockEvent();

    this.Views.ShowAllParamsCheckbox.blockEvent();
    this.Views.ShowAllParamsCheckbox.setValue(App.SessionManager.GetPreference("QoEStorConfigManager:ShowAllParams"));
    this.Views.ShowAllParamsCheckbox.unblockEvent();

    this.Views.ReceiversTable = $$(this.Id + "ReceiversTable");
    this.Views.AddReceiverBtn = $$(this.Id + "AddReceiverBtn");

    this.Views.RestartReceiversBtn = $$(this.Id + "RestartReceiversBtn");
    this.Views.RestartReceiversContext = $$(this.Id + "RestartReceiversContext");

    this.Views.StopReceiversContext = $$(this.Id + "StopReceiversContext");
    this.Views.StopReceiversBtn = $$(this.Id + "StopReceiversBtn");

    this.Views.ExportReceiversConfigBtn = $$(this.Id + "ExportReceiversConfig" + "Btn");
    this.Views.ExportReceiversConfigSubmenu = $$(this.Id + "ExportReceiversConfig" + "Submenu")

    this.Views.ImportReceiversConfigBtn = $$(this.Id + "ImportReceiversConfigBtn");
    this.Views.ImportReceiversConfigPopup = $$(this.Id + "ImportReceiversConfigPopup");
    this.Views.ImportReceiversConfigFrom = $$(this.Id + "ImportReceiversConfigFrom");
    this.Views.ImportReceiversConfigUploader = $$(this.Id + "ImportReceiversConfigUploader");
    this.Views.ImportReceiversConfigText = $$(this.Id + "ImportReceiversConfigText");

    this.Views.ImportReceiversConfigText.getEditor(true).then(function(editor){
        editor.setOption("readOnly", "nocursor");
    });

    this.Views.EditReceiverContextFormPopup = webix.ui(this.EditReceiverContextFormConfig);
    this.Views.EditReceiverContextForm = $$(this.Id + "EditReceiverContextForm");

    this.Views.ClustersTable = $$(this.Id + "ClustersTable");
    this.Views.AddClusterBtn = $$(this.Id + "AddClusterBtn");

    this.Views.EditClusterContextFormPopup = webix.ui(this.EditClusterContextFormConfig);
    this.Views.EditClusterContextForm = $$(this.Id + "EditClusterContextForm");

    this.Views.CustomPrtclsDicUrlBtn = $$('CUSTOM_PRTCLS_DIC_URL_BUTTON');
    this.Views.CustomPrtclsGrpsDicUrlBtn = $$('CUSTOM_PRTCLS_GRPS_DIC_URL_BUTTON');

    this.Views.CompanyPrtclsDicUrlBtn = $$('COMPANY_PRTCLS_DIC_URL_BUTTON');
    this.Views.CompanyPrtclsGrpsDicUrlBtn = $$('COMPANY_PRTCLS_GROUPS_DIC_URL_BUTTON');

    this.Views.HistoryTable = $$(this.Id + "HistoryImportContext" + "HistoryTable");
    this.Views.HistoryEditor = $$(this.Id + "HistoryImportContext" + "Editor");

    this.Views.CustomPrtclsDicUrlBtn.attachEvent("onItemClick", function(id, e){
        _this.GetMyCompanyProfile("CUSTOM_PRTCLS_DIC_URL");
    });
    this.Views.CustomPrtclsGrpsDicUrlBtn.attachEvent("onItemClick", function(id, e){
        _this.GetMyCompanyProfile("CUSTOM_PRTCLS_GRPS_DIC_URL");
    });

    this.Views.CompanyPrtclsDicUrlBtn.attachEvent("onItemClick", function(id, e){
        _this.GetMyCompanyProfile("COMPANY_PRTCLS_DIC_URL_BUTTON");
    });
    this.Views.CompanyPrtclsGrpsDicUrlBtn.attachEvent("onItemClick", function(id, e){
        _this.GetMyCompanyProfile("COMPANY_PRTCLS_GROUPS_DIC_URL_BUTTON");
    });

    this.ReconstructFullflowForm();
    this.Views.FullflowAggLogSettingsPopup = this.FullflowAggLogSettingsGetPopup();
    this.Views.FullflowAggLogSettingsPopupForm = $$(this.Id + "FullflowAggLogSettingsPopupForm");

    webix.extend(this.Views.HistoryEditor, webix.ProgressBar);

    _this.Views.EditReceiverContextForm.elements["RECEIVER_TYPE"].attachEvent("onChange", function(Nv, Ov)
    {
        if(Nv&&Ov&&Nv!=Ov)
        {
            var rotate = _this.Views.EditReceiverContextForm.elements["ROTATE_MINUTES"], rotateVal = rotate.getValue();
            var rotateDelay = _this.Views.EditReceiverContextForm.elements["ROTATE_DELAY_SECONDS"], rotateDelayVal = rotateDelay.getValue();
            var queue = _this.Views.EditReceiverContextForm.elements["FW_MAX_QUEUE_SIZE"], queueVal = queue.getValue();

            if(rotateVal == QoEStorIpfixReceiverRotateDefaultsEnum[Ov])
                rotate.setValue(QoEStorIpfixReceiverRotateDefaultsEnum[Nv]);

            if(rotateDelayVal == QoEStorIpfixReceiverRotateDelayDefaultsEnum[Ov])
                rotateDelay.setValue(QoEStorIpfixReceiverRotateDelayDefaultsEnum[Nv]);

            if(queueVal == QoEStorIpfixReceiverQueueSizeDefaultsEnum[Ov])
                queue.setValue(QoEStorIpfixReceiverQueueSizeDefaultsEnum[Nv]);
        }
    });

    this.Views.ImportReceiversConfigUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        let types = ["txt", "tsv", "xlsx"];

        if(FileObj && types.includes(FileObj.type))
        {
            let reader = new FileReader();

            reader.onload = function(e)
            {
                _this.ViewModel.ParseReceiversConfigFile(FileObj, reader)
                    .then((result) => {
                        if(result && result.length)
                        {
                            _this.CurentMergedReceiversConfig = new QoEStorMergedConfig(
                                _this.Views.ReceiversTable.serialize(),
                                result
                            );

                            _this.Views.ImportReceiversConfigText.setValue("");

                            _this.Views.ImportReceiversConfigText.setValue(
                                _this.CurentMergedReceiversConfig.mergedConfigText
                            );

                            _this.MarkImportReceiversEditor(
                                _this.Views.ImportReceiversConfigText.getEditor(),
                                _this.CurentMergedReceiversConfig.mergedConfigText
                            );
                        }
                    })
                    .catch((error) => {
                        webix.message({type: "error", text: error});
                    });
            }

            reader.onerror = function()
            {
                webix.message({type: "error", text: LangHelper.GetString( "Dics", "Error! Can not read import file.")});
            }

            reader.readAsText(FileObj.file, "utf-8");
        }
        else
        {
            webix.message({type: "error", text: LangHelper.GetString( "Dics", "Error! Can not read import file.")});
        }
    });

    QoEStorConfigManager.GetSortedQoEStorEnvConfigGroupDicKeysArr().forEach(function (Key)
    {
        var formId = _this.Id + "Group_"+Key+"_form";
        if($$(formId))
        {
            _this.Views.FormsGroups[formId] = $$(formId);
        }
    });

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        _this.Views.FormsGroups[Key].attachEvent("onChange", function(newv, oldv)
        {
            _this.ViewModel.SetConfigModel(_this.GetFormsValues());
        });
    });

    this.Subscriptions.ConfigHistoryUpdated = this.ViewModel.Signals.ConfigHistoryUpdated.subscribe(function (value)
    {
        if (value)
        {
            _this.DefineHistoryForms();
        }
    });

    this.Subscriptions.ConfigUpdated = this.ViewModel.Signals.ConfigFileUpdated.subscribe(function (V)
    {
        if (V)
        {
            _this.DefineForms();
            _this.DefineReceiversManageBtns();
        }
    });

    this.ShowFormOverlay("");
    this.Subscriptions.SignalHardwaresDicUpdatedSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (Updated)
    {
        if (Updated)
        {
            var hardwares = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

            hardwares = hardwares.filter(function (Obj)
            {
                return Obj.hardware_type == HardwareTypesEnum.qoestor;
            });

            _this.Views.HardwareList.clearAll();
            _this.Views.HardwareList.parse(hardwares);

            if(hardwares.length)
                _this.Views.HardwareList.select(hardwares[0].id);
        }
    });

    this.Subscriptions.RestartReceiversSuccess = this.ViewModel.Signals.RestartReceiversSuccess.subscribe(function(Data)
    {
        if(Data)
        {
            webix.message(LangHelper.GetString(_this.Id, "QoE receivers successfully restarted."));

            _this.Views.RestartLogPopup.show(_this.Views.RestartReceiversBtn.getNode(),{pos:"right"});
            _this.Views.RestartLog.setValue(Data);
        }
    });

    this.Subscriptions.RestartReceiversError = this.ViewModel.Signals.RestartReceiversError.subscribe(function(Error)
    {
        if(Error.msg)
            webix.message({type: "error", text: Error.msg});
    });

    this.Subscriptions.StopReceiversSuccess = this.ViewModel.Signals.StopReceiversSuccess.subscribe(function(Data)
    {
        if(Data)
        {
            webix.message(LangHelper.GetString(_this.Id, "QoE receivers successfully stopped."));

            _this.Views.RestartLogPopup.show(_this.Views.RestartReceiversBtn.getNode(),{pos:"right"});
            _this.Views.RestartLog.setValue(Data);
        }
    });

    this.Subscriptions.StopReceiversError = this.ViewModel.Signals.StopReceiversError.subscribe(function(Error)
    {
        if(Error.msg)
            webix.message({type: "error", text: Error.msg});
    });

    _this.ViewModel.HistoryRefresh();
};

QoEStorConfigViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

    //_this.Refresh();
};

QoEStorConfigViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });


    if(this.ViewModel)
        this.ViewModel.Destroy();
    delete this.ViewModel;
};

QoEStorConfigViewController.prototype.Refresh = function ()
{
    var _this = this;

    App.NavRouter.ShowProgress();

    this.ViewModel.Refresh({callback:function (R)
    {
        App.NavRouter.HideProgress();

        if(R.success)
        {
            webix.message(LangHelper.GetString("DpiConfig", "Configuration loaded"));
            _this.HideFormOverlay();
        }
        else
        {
            _this.ShowServerError(R.error);

            _this.ShowFormOverlay(R.error.msg);
        }
    }});
};

QoEStorConfigViewController.prototype.ViewFromDic = function (DicId)
{
    return Helper.ViewFromDpiConfigDic(DicId, QoEStorEnvConfigDic);
};

QoEStorConfigViewController.prototype.ViewsFromDicForGroup = function (GroupId)
{
    var _this = this;

    var views = [];

    QoEStorConfigManager.GetSortedQoEStorEnvConfigDicKeysArr().forEach(function (Key)
    {

        if(QoEStorEnvConfigDic[Key].group == GroupId && QoEStorEnvConfigDic[Key].view)
        {
            views.push(_this.ViewFromDic(Key));
        }
    });

    views.push({});

    return views;
};

QoEStorConfigViewController.prototype.ViewsForReceiversGroup = function (GroupId)
{
    var _this = this;

    var views = {
        rows:[
            {
                view: "toolbar",
                elements:[
                    {
                        view: "button",
                        id:this.Id + "AddReceiverBtn",
                        type: "icon",
                        icon: "plus",
                        align: "right",
                        width: 32,
                        css:"toolbar_round_btn",
                        tooltip:LangHelper.GetString(this.Id,"Add receiver"),
                        click: function (id, e, node)
                        {
                            _this.OnAddReceiverBtnClick(this.getNode());
                        }
                    },
                    {width: 10},
                    {
                        view: "button",
                        id:this.Id + "RestartReceiversBtn",
                        type: "icon",
                        icon: "retweet",
                        css: "toolbar_round_btn",
                        width: 32,
                        disabled: true,
                        tooltip: LangHelper.GetString(this.Id, "Restart receivers"),
                        click: function ()
                        {
                            _this.Views.RestartReceiversContext.show(this.getNode(), {pos: "right"});
                        }
                    },
                    {
                        view: "button",
                        id:this.Id + "StopReceiversBtn",
                        type: "icon",
                        icon: "stop",
                        css: "toolbar_round_btn",
                        width: 32,
                        disabled: true,
                        tooltip: LangHelper.GetString(this.Id, "Stop receivers"),
                        click: function ()
                        {
                            _this.Views.StopReceiversContext.show(this.getNode(), {pos: "right"});
                        }
                    },
                    {width: 10},
                    {
                        view: "button",
                        id: this.Id + "ImportReceiversConfigBtn",
                        type: "icon",
                        icon: "upload",
                        css: "toolbar_round_btn",
                        width: 32,
                        tooltip: LangHelper.GetString(this.Id, "Upload receivers configuration from file"),
                        click: function (Id, E, Node) {
                            _this.Views.ImportReceiversConfigUploader.enable();
                            _this.Views.ImportReceiversConfigPopup.show(this.getNode(Id), {pos: "bottom"});
                            _this.Views.ImportReceiversConfigText.setValue("");
                        }
                    },
                    {
                        view: "button",
                        id: this.Id + "ExportReceiversConfig" + "Btn",
                        type: "icon",
                        icon: "file-excel",
                        css: "toolbar_round_btn",
                        width: 32,
                        disabled: true,
                        tooltip:  LangHelper.GetString(this.Id, "Download receivers configuration file"),
                        click: function (Id, E, Node) {
                            if(_this.Views.ExportReceiversConfigSubmenu.isVisible())
                                _this.Views.ExportReceiversConfigSubmenu.hide();
                            else
                                _this.Views.ExportReceiversConfigSubmenu.show(this.getNode(Id), {pos: "bottom"});
                        }
                    },
                ]
            },
            {
                view:"datatable",
                id:this.Id + "ReceiversTable",
                resizeColumn: true,
                select: "row",
                //editable: true,
                headermenu: false,
                columns:function(){
                    var cols = [];

                    cols.push(
                        {
                            id: "edit",
                            header: "",
                            width: 32,
                            template: CellEditBtnTemplate,
                            headermenu: false,
                            align:"right"
                        }
                    );

                    cols.push(
                        {
                            id: "copy",
                            header: "",
                            width: 32,
                            template: CellCopyBtnTemplate,
                            headermenu: false,
                            align:"right"
                        }
                    );

                    Object.keys(QoEStorEnvConfigReceiverDic).forEach(function (Key)
                    {
                        cols.push(
                            {
                                id:QoEStorEnvConfigReceiverDic[Key].id,
                                header:[{text: TooltipTemplate(QoEStorEnvConfigReceiverDic[Key].value, null, null, "question-circle"), css:{"white-space":"nowrap !important"}}],
                                editor:QoEStorEnvConfigReceiverDic[Key].view,
                                options:QoEStorEnvConfigReceiverDic[Key].options?Helper.DictToArr(QoEStorEnvConfigReceiverDic[Key].options):null,
                                fillspace:1
                            }
                        );
                    });

                    cols.push(
                        {
                            id: "trash",
                            header: "",
                            width: 32,
                            template: CellTrashBtnTemplate,
                            headermenu: false,
                            align:"right"
                        }
                    );

                    return cols;
                }(),
                on:{
                    onHeaderClick:function(id, e, node)
                    {
                        if(e.target.className == "webix_icon webix_el_icon fa-question-circle")
                        {
                            var map = {};

                            Object.keys(QoEStorEnvConfigReceiverDic).forEach(function(Key)
                            {
                                map[QoEStorEnvConfigReceiverDic[Key].id] = Key;
                            });

                            _this.ShowHelpPopup(QoEStorEnvConfigReceiverDic[map[id.column]].tooltip, node, QoEStorEnvConfigReceiverDic[map[id.column]].tooltipHeight);
                        }
                    },
                    onItemClick: function (id,e,node)
                    {
                        var __this = this;

                        if(id.column === 'trash')
                        {
                            this.remove(id);

                            setTimeout(function ()
                            {
                                _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                            },1);
                        }

                        if(id.column === 'edit')
                        {
                            setTimeout(function ()
                            {
                                _this.ShowReceiverEditForm(__this.getItemNode(id), "right");
                            },1);
                        }

                        if(id.column === 'copy')
                        {
                            let referenceItem = __this.getItem(id);

                            if(referenceItem)
                            {
                                let replicaItem = webix.extend({id: ""}, referenceItem);

                                setTimeout(function ()
                                {
                                    __this.unselectAll();
                                    _this.ShowReceiverEditForm(__this.getItemNode(id), "right", replicaItem);
                                },1);
                            }
                        }
                    },
                    onItemDblClick: function (id,e,node)
                    {
                        var __this = this;

                        setTimeout(function ()
                        {
                            _this.ShowReceiverEditForm(__this.getItemNode({column:"edit", row:id.row}), "right");
                        },1);
                    }
                }
            }
        ]
    };

    return views;
};

QoEStorConfigViewController.prototype.ViewsForClustersGroup = function (GroupId)
{
    var _this = this;

    var views = {
        rows:[
            {
                view: "toolbar",
                elements:[
                    {
                        view: "button",
                        id:this.Id + "AddClusterBtn",
                        type: "icon",
                        icon: "plus",
                        align: "right",
                        width: 32,
                        css:"toolbar_round_btn",
                        tooltip:LangHelper.GetString(this.Id,"Add cluster"),
                        click: function (id, e, node)
                        {
                            _this.OnAddClusterBtnClick(this.getNode());
                        }
                    }
                ]
            },
            {
                view:"datatable",
                id:this.Id + "ClustersTable",
                resizeColumn: true,
                select: "row",
                //editable: true,
                headermenu: false,
                columns:function(){
                    var cols = [];

                    cols.push(
                        {
                            id: "edit",
                            header: "",
                            width: 32,
                            template: CellEditBtnTemplate,
                            headermenu: false,
                            align:"right"
                        }
                    );

                    Object.keys(QoEStorEnvConfigClusterDic).forEach(function (Key)
                    {
                        cols.push(
                            {
                                id:QoEStorEnvConfigClusterDic[Key].id,
                                header:[{text: TooltipTemplate(LangHelper.GetString("Dics", "Shards"), null, null, "question-circle"), css:{"white-space":"nowrap !important"}}],
                                editor:QoEStorEnvConfigClusterDic[Key].view,
                                options:QoEStorEnvConfigClusterDic[Key].options?Helper.DictToArr(QoEStorEnvConfigClusterDic[Key].options):null,
                                fillspace:1
                            }
                        );
                    });

                    cols.push(
                        {
                            id: "trash",
                            header: "",
                            width: 32,
                            template: CellTrashBtnTemplate,
                            headermenu: false,
                            align:"right"
                        }
                    );

                    return cols;
                }(),
                on:{
                    onHeaderClick:function(id, e, node)
                    {
                        if(e.target.className == "webix_icon webix_el_icon fa-question-circle")
                        {
                            var map = {};

                            Object.keys(QoEStorEnvConfigClusterDic).forEach(function(Key)
                            {
                                map[QoEStorEnvConfigClusterDic[Key].id] = Key;
                            });

                            _this.ShowHelpPopup(QoEStorEnvConfigClusterDic[map[id.column]].tooltip, node, QoEStorEnvConfigClusterDic[map[id.column]].tooltipHeight);
                        }
                    },
                    onItemClick: function (id,e,node)
                    {
                        var __this = this;

                        if(id.column === 'trash')
                        {
                            this.remove(id);

                            setTimeout(function ()
                            {
                                _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                            },1);
                        }

                        if(id.column === 'edit')
                        {
                            setTimeout(function ()
                            {
                                _this.ShowClusterEditForm(__this.getItemNode(id), "right");
                            },1);
                        }
                    },
                    onItemDblClick: function (id,e,node)
                    {
                        var __this = this;

                        setTimeout(function ()
                        {
                            _this.ShowClusterEditForm(__this.getItemNode({column:"edit", row:id.row}), "right");
                        },1);
                    }
                }
            }
        ]
    };

    return views;
};

QoEStorConfigViewController.prototype.DefineForms = function ()
{
    var _this = this;

    this.Views.CodeEditor.setValue(this.ViewModel.GetConfig());

    this.DefineReceiversForms();
    this.DefineClustersForms();

    this.FullflowAggLogSettingsDefineForm();

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        _this.Views.FormsGroups[Key].setValues(_this.ViewModel.GetConfigModel());
    });
};

QoEStorConfigViewController.prototype.DefineReceiversForms = function ()
{
    var rows = this.ViewModel.ParseReceiverRows([
        QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW,
        QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM,
        QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW,
        QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW,
        QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM,
        QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW,
        QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW

    ]);

    this.Views.ReceiversTable.clearAll();

    this.Views.ReceiversTable.parse(rows);
};

QoEStorConfigViewController.prototype.DefineClustersForms = function ()
{
    var rows = this.ViewModel.ParseClusterRows([
        QoEStorClusterTypesEnum.CH_SHARD_REPLICAS,
    ]);

    this.Views.ClustersTable.clearAll();

    this.Views.ClustersTable.parse(rows);
};

QoEStorConfigViewController.prototype.GetFormsValues = function ()
{
    var _this = this;

    var configModel = this.GetReceiversFormsValues();
    configModel = this.GetClustersFormsValues(configModel);

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        Object.keys(_this.Views.FormsGroups[Key].elements).forEach(function (ElKey)
        {
            var el = _this.Views.FormsGroups[Key].elements[ElKey];
            configModel[ElKey] = el.getValue();
        });
    });

    return configModel;
};

QoEStorConfigViewController.prototype.GetReceiversFormsValues = function (Rows)
{
    var _this = this;

    var configModel = {};

    var rows = Rows && Rows.length ? Rows : this.Views.ReceiversTable.serialize();

    var index = {};

    index[QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW] = 0;

    index[QoEStorIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 0;

    index[QoEStorIpfixReceiverTypesEnum.IPFIX_GTPFLOW] = 0;

    index[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW] = 0;

    index[QoEStorIpfixReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM] = 0;

    index[QoEStorIpfixReceiverTypesEnum.IPFIX_DNSFLOW] = 0;

    index[QoEStorIpfixReceiverTypesEnum.IPFIX_AAAFLOW] = 0;

    rows.forEach(function (Row, Index)
    {
        var type = Row.RECEIVER_TYPE?Row.RECEIVER_TYPE:QoEStorIpfixReceiverTypesEnum.IPFIX_FULLFLOW;

        var model = new QoEStorIpfixReceiverConfigModel(Row,index[type]);

        Object.keys(model).forEach(function (Key)
        {
            configModel[Key] = model[Key]
        });

        index[type]++;
    });

    return configModel;
};

QoEStorConfigViewController.prototype.GetClustersFormsValues = function (ConfigModel)
{
    const _this = this;

    const rows = this.Views.ClustersTable.serialize();

    const index = {};

    index[QoEStorClusterTypesEnum.CH_SHARD_REPLICAS] = 0;

    rows.forEach(function (Row, Index)
    {
        const model = new QoEStorClusterConfigModel(Row,index[QoEStorClusterTypesEnum.CH_SHARD_REPLICAS]);

        Object.keys(model).forEach(function (Key)
        {
            ConfigModel[Key] = model[Key]
        });

        index[QoEStorClusterTypesEnum.CH_SHARD_REPLICAS]++;
    });

    return ConfigModel;
};

QoEStorConfigViewController.prototype.ConfigSave = function (Params)
{
    var _this = this;

    if(_this.Views.EditorTabs.getValue() == _this.Id + "Editor" + "Code")
    {
        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
    }

    let isCompress1Enabled = _this.ViewModel.ConfigModel.hasOwnProperty("FULLFLOW_AGG_COMPRESS_1_ENABLE") && _this.ViewModel.ConfigModel.FULLFLOW_AGG_COMPRESS_1_ENABLE === "1";
    let isCompress2Enabled = _this.ViewModel.ConfigModel.hasOwnProperty("FULLFLOW_AGG_COMPRESS_2_ENABLE") && _this.ViewModel.ConfigModel.FULLFLOW_AGG_COMPRESS_2_ENABLE === "1";

    if (isCompress1Enabled || isCompress2Enabled) {
        let res = _this.FullflowAggLogSettingsValidateForm();
        if (!res) {
            _this.FullflowAggLogSettingsShowForm();
            return;
        }
    }


    App.NavRouter.ShowProgress();

    this.ViewModel.Save({callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Configuration saved"));

                setTimeout(function () {
                    _this.UpdateParamsContext.show(_this.Views.RestartBtn.getNode(), {pos: "bottom"});
                }, 1);
            }
            else
            {
                //webix.message({type:"error", text:R.error.msg});
                _this.ShowServerError(R.error);
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }});
};

QoEStorConfigViewController.prototype.OnAddReceiverBtnClick = function(Node)
{
    var _this = this;

    this.Views.ReceiversTable.unselect();

    setTimeout(function ()
    {
        _this.ShowReceiverEditForm(Node, "bottom");
    },1);
};

QoEStorConfigViewController.prototype.RestartAllReceivers = function()
{
    let qoeNodeItem = this.Views.HardwareList.getSelectedItem();

    if(qoeNodeItem && qoeNodeItem.dic_id)
        this.ViewModel.RestartAllReceivers(qoeNodeItem.dic_id);
};

QoEStorConfigViewController.prototype.StopAllReceivers = function()
{
    let qoeNodeItem = this.Views.HardwareList.getSelectedItem();

    if(qoeNodeItem && qoeNodeItem.dic_id)
        this.ViewModel.StopAllReceivers(qoeNodeItem.dic_id);
};

QoEStorConfigViewController.prototype.DefineReceiversManageBtns = function()
{
    let items = this.Views.ReceiversTable.serialize();

    let manageBtn = [
        this.Views.RestartReceiversBtn,
        this.Views.StopReceiversBtn,
        this.Views.ExportReceiversConfigBtn
    ]

    manageBtn.forEach(View => {
        if(items && items.length)
            View.enable();
        else
            View.disable();
    });
};

QoEStorConfigViewController.prototype.OnAddClusterBtnClick = function(Node)
{
    var _this = this;

    this.Views.ClustersTable.unselect();

    setTimeout(function ()
    {
        _this.ShowClusterEditForm(Node, "bottom", true);
    },1);
};

QoEStorConfigViewController.prototype.ShowHelpPopup = function(Text, Node, Height)
{
    webix.ui({
        view:"popup",
        height:Height,
        body:{
            borderless:true,
            template:Text
        }
    }).show(Node);
};

QoEStorConfigViewController.prototype.ShowReceiverEditForm = function (Node, Pos, Data = null)
{
    var data = Data ? new QoEStorIpfixReceiverConfigRowModel(Data) : this.Views.ReceiversTable.getSelectedItem();

    if(!data)
        data = new QoEStorIpfixReceiverConfigRowModel();

    this.Views.EditReceiverContextForm.clear();

    this.Views.EditReceiverContextForm.clearValidation();

    this.Views.EditReceiverContextForm.setValues(data);

    this.Views.EditReceiverContextFormPopup.show(Node,{pos:Pos});
};

QoEStorConfigViewController.prototype.ShowClusterEditForm = function (Node, Pos, isAddBtn = null)
{
    var data = this.Views.ClustersTable.getSelectedItem();

    if(!data)
        data = new QoEStorClusterConfigRowModel();

    this.Views.EditClusterContextForm.clear();

    this.Views.EditClusterContextForm.clearValidation();

    if (!isAddBtn)
        this.Views.EditClusterContextForm.setValues(data);

    this.Views.EditClusterContextFormPopup.show(Node,{pos:Pos});
};


QoEStorConfigViewController.prototype.HideReceiverEditForm = function ()
{
    this.Views.EditReceiverContextFormPopup.hide();
};

QoEStorConfigViewController.prototype.HideClusterEditForm = function ()
{
    this.Views.EditClusterContextFormPopup.hide();
};

QoEStorConfigViewController.prototype.ValidateReceiverEditForm = function ()
{
    return this.Views.EditReceiverContextForm.validate();
};

QoEStorConfigViewController.prototype.ValidateClusterEditForm = function ()
{
    return this.Views.EditClusterContextForm.validate();
};

QoEStorConfigViewController.prototype.ApplyReceiverEditForm = function ()
{
    var _this = this;

    if(!this.ValidateReceiverEditForm())
        return;

    var tableData = this.Views.ReceiversTable.getSelectedItem();

    var selectedRowIdx = tableData && tableData.id ? this.Views.ReceiversTable.getIndexById(tableData.id) : null;

    var formdata = this.Views.EditReceiverContextForm.getValues();

    var typesOrder = [];

    QoEStorConfigManager.GetSortedQoEStorEnvConfigDicKeysArr().forEach(Key => {
       if(QoEStorEnvConfigDic[Key] && QoEStorEnvConfigDic[Key].id)
       {
           let type = QoEStorEnvConfigDic[Key].id.replace("_PORT_TYPE[i]", "");

           if(Object.values(QoEStorIpfixReceiverTypesEnum).includes(type))
                typesOrder.push(type);
       }
    });

    if(!tableData)
    {
        let types = this.Views.ReceiversTable.serialize().map(i => i.RECEIVER_TYPE);

        let findLastIdx = types.lastIndexOf(formdata.RECEIVER_TYPE);

        if(findLastIdx > -1)
        {
            selectedRowIdx = findLastIdx + 1;
        }
        else
        {
            let nextOrderTypes = [];
            let curOrderTypeIdx = typesOrder.indexOf(formdata.RECEIVER_TYPE);

            if(curOrderTypeIdx > -1 && curOrderTypeIdx < typesOrder.length - 1)
                nextOrderTypes = typesOrder.slice(curOrderTypeIdx + 1, typesOrder.length);

            selectedRowIdx = types.length;

            for(let orderType of nextOrderTypes)
            {
                let findIdx = types.indexOf(orderType);

                if(findIdx > -1)
                {
                    selectedRowIdx = findIdx;
                    break;
                }
            }
        }

        tableData = new QoEStorIpfixReceiverConfigRowModel();
        this.Views.ReceiversTable.add(tableData, selectedRowIdx);
    }

    this.Views.ReceiversTable.updateItem(tableData.id,  new QoEStorIpfixReceiverConfigRowModel(formdata));

    setTimeout(function ()
    {
        _this.ViewModel.SetConfigModel(_this.GetFormsValues());

        if(selectedRowIdx != null)
        {
            let findId = _this.Views.ReceiversTable.getIdByIndex(selectedRowIdx);

            if(findId)
            {
                _this.Views.ReceiversTable.select(findId, false);

                let visibleRowsCount = _this.Views.ReceiversTable.getVisibleCount();
                let rowHeight = _this.Views.ReceiversTable.config.rowHeight;
                let scrollY = (rowHeight * selectedRowIdx) - (visibleRowsCount * rowHeight * 0.5);

                _this.Views.ReceiversTable.scrollTo(0, scrollY);
            }
        }

    },1);

    _this.HideReceiverEditForm();
};

QoEStorConfigViewController.prototype.ApplyClusterEditForm = function ()
{
    var _this = this;

    if(!this.ValidateClusterEditForm())
        return;

    var tableData = this.Views.ClustersTable.getSelectedItem();

    var formdata = this.Views.EditClusterContextForm.getValues();

    if(!tableData)
    {
        tableData = new QoEStorClusterConfigRowModel();
        this.Views.ClustersTable.add(tableData);
        this.Views.ClustersTable.select(tableData.id, false);
    }

    this.Views.ClustersTable.updateItem(tableData.id,  new QoEStorClusterConfigRowModel(formdata));

    setTimeout(function ()
    {
        _this.ViewModel.SetConfigModel(_this.GetFormsValues());
    },1);

    _this.HideClusterEditForm();
};

QoEStorConfigViewController.prototype.RestartConfig = function ()
{
    var _this = this;

    this.ViewModel.RestartConfig({
        callback:function (R)
        {
            if(R.data)
            {
                _this.Views.RestartLogPopup.show(_this.Views.RestartBtn.getNode(),{pos:"right"});
                _this.Views.RestartLog.setValue(R.data);
            }

            if(R.success)
            {
                webix.message(LangHelper.GetString("QoEStorConfig", "Restart finished"));
            }
            else
            {
                //webix.message({type:"error", text:R.error.msg, expire:30000});
                _this.ShowServerError(R.error);
            }
        }
    });
};

QoEStorConfigViewController.prototype.RestartOptions = function ()
{
    var _this = this;

    this.ViewModel.RestartOptions({
        callback:function (R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString("Dpiui2Config", "Hot options updated!"));
            }
            else
            {
                _this.ShowServerError(R.error);
            }
        }
    });
};

QoEStorConfigViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};

QoEStorConfigViewController.prototype.ShowFormOverlay = function (ErrorMsg)
{
    this.Views.FormPanel.showOverlay("<br/><br/><br/>"+ErrorMsg);
    this.Views.SaveBtn.disable();
    this.Views.RestartBtn.disable();
};

QoEStorConfigViewController.prototype.HideFormOverlay = function ()
{
    this.Views.FormPanel.hideOverlay();
    this.Views.SaveBtn.enable();
    this.Views.RestartBtn.enable();
};

QoEStorConfigViewController.prototype.ForcedDownloadReferenceBook = function ()
{
    var _this = this;

    _this.Views.ForcedDownloadBtn.disable();
    webix.message(LangHelper.GetString("QoEStorConfig", "Started dictionaries forced download in background"));

    this.ViewModel.ForcedDownloadReferenceBook({
        callback:function (R)
        {
            if(R.success)
            {
               //webix.message(LangHelper.GetString("QoEStorConfig", "Forced download finished"));
                _this.Views.ForcedDownloadBtn.enable();
            }
            else
            {
                _this.ShowServerError(R.error);
                _this.Views.ForcedDownloadBtn.enable();
            }
        }
    });
};

QoEStorConfigViewController.prototype.GetMyCompanyProfile = function (Id)
{
    var _this = this;
    this.ViewModel.GetMyCompanyProfile({
        callback:function (R)
        {
            if(R.success)
            {
                if(Id == "CUSTOM_PRTCLS_DIC_URL")
                {
                    $$('QoEStorConfigGroup_3_form').elements.CUSTOM_PRTCLS_DIC_URL.setValue(`https://cloud.vasexperts.ru/api/custom_prtcls/qoe/${R.data.code}/test`)
                }
                else if (Id == "CUSTOM_PRTCLS_GRPS_DIC_URL")
                {
                    $$('QoEStorConfigGroup_3_form').elements.CUSTOM_PRTCLS_GRPS_DIC_URL.setValue(`https://cloud.vasexperts.ru/api/custom_prtcls_groups/qoe/${R.data.code}/test`)
                }
                else if (Id == "COMPANY_PRTCLS_DIC_URL_BUTTON")
                {
                    $$('QoEStorConfigGroup_3_form').elements.COMPANY_PRTCLS_DIC_URL.setValue(`https://cloud.vasexperts.ru/api/company_prtcls/qoe/${R.data.code}`)
                }
                else if (Id == "COMPANY_PRTCLS_GROUPS_DIC_URL_BUTTON")
                {
                    $$('QoEStorConfigGroup_3_form').elements.COMPANY_PRTCLS_GROUPS_DIC_URL.setValue(`https://cloud.vasexperts.ru/api/company_prtcls_groups/qoe/${R.data.code}`)
                }
            }
            else
            {
                webix.ui({
                    view:"popup",
                    id:"PopupRedirectVasCloudAuthorization",
                    modal: true,
                    height: 100,
                    width: 500,
                    position: "center",
                    body:{
                        rows:[
                            {
                                template: LangHelper.GetString("QoEStorConfig","You are not authorized in VAS Cloud"),
                                borderless: true,
                                css:{"font-weight": "bold !important", "text-align":"center !important", "font-size": "15px !important"}
                            },
                            {
                                template: LangHelper.GetString("QoEStorConfig","Move to login page?"),
                                borderless:true,
                                css:{"text-align": "center !important"}
                            },
                            {

                                cols: [
                                    {
                                        view: "button",
                                        width: 200,
                                        label: LangHelper.GetString("QoEStorConfig", "Cancel"),
                                        click: function () {
                                            $$("PopupRedirectVasCloudAuthorization").hide();
                                        }
                                    },
                                    {
                                        view: "button",
                                        width: 200,
                                        type: "form",
                                        label: LangHelper.GetString("QoEStorConfig", "Move"),
                                        hotkey: "enter",
                                        click: function () {
                                            var hash = '#VasCloudPersonalArea'
                                            location.href = `${document.location.protocol}//${document.location.host}/${hash}`
                                            $$("PopupRedirectVasCloudAuthorization").hide();
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }).show();
            }
        }
    });
};

QoEStorConfigViewController.prototype.DefineHistoryForms = function (Params)
{
    this.Views.HistoryTable.clearAll();
    this.Views.HistoryTable.parse(this.ViewModel.GetHistory());
    this.Views.HistoryEditor.setValue("");
};

QoEStorConfigViewController.prototype.ReconstructFullflowForm = function ()
{
    let _this = this;

    let fullflowGroupId = "6";
    let fullflowFormView = $$(_this.Id + "Group_" + fullflowGroupId +"_form");

    let aggLogSettingsButton = {
        view: "button",
        id: _this.Id + "FullflowAggLogSettingsButton",
        type: "icon",
        icon: "gear",
        css: "toolbar_round_btn",
        width: 32,
        click: function (id, event) {
            let node = $$(id).getNode();
            _this.FullflowAggLogSettingsShowForm(node, {pos:"left"})
        }
    }

    let views = [];

    QoEStorConfigManager.GetSortedQoEStorEnvConfigDicKeysArr().forEach(function (Key)
    {
        if(QoEStorEnvConfigDic[Key].group === fullflowGroupId && QoEStorEnvConfigDic[Key].view)
        {
            views.push(_this.ViewFromDic(Key));
        }
    });

    for (let value of Object.values(views)) {
        if(value.cols[0].name === "FULLFLOW_AGG_LOG_GROUP_TIME_INTERVAL") {
            _this.FullflowLogTimeIntervalInputViewConfig = value.cols.slice(0, 1)[0];
            value.cols.splice(1, 0, aggLogSettingsButton);
        }
    }

    views.push({});

    fullflowFormView.define("rows", views);
    fullflowFormView.reconstruct();
};

QoEStorConfigViewController.prototype.FullflowAggLogSettingsGetPopup = function ()
{
    let _this = this;

    return webix.ui({
        view: "popup",
        modal: true,
        id: _this.Id + "FullflowAggLogSettingsPopup",
        width: 650,
        height: 480,
        body: {
            borderless:true,
            rows: [
                {

                },
                _this.FullflowAggLogSettingsGetPopupForm(),
                {
                    height: 53,
                    css: {"display":"flex", "align-items":"center"},
                    rows: [
                        {
                            cols: [
                                {view: "spacer"},
                                {
                                    view:"button",
                                    height: 35,
                                    width: 130,
                                    label: LangHelper.GetString("AppView", "Cancel"),
                                    click:function () {
                                        _this.Views.FullflowAggLogSettingsPopup.hide();
                                        _this.FullflowAggLogSettingsDefineForm();
                                    }
                                },
                                {
                                    width: 20
                                },
                                {
                                    view:"button",
                                    type:"form",
                                    height: 35,
                                    width: 130,
                                    label: LangHelper.GetString("AppView", "Apply"),
                                    click:function () {
                                        if (_this.FullflowAggLogSettingsValidateForm()) {
                                            _this.FullflowAggLogSettingsSaveForm();
                                            _this.Views.FullflowAggLogSettingsPopup.hide();
                                        }
                                    }
                                },
                            ]
                        }
                    ]
                }

            ]
        }
    });
};

QoEStorConfigViewController.prototype.FullflowAggLogSettingsGetPopupForm = function()
{
    let _this = this;

    let popupFormRows = []

    let viewSettings = QoEStorEnvConfigFullflowCompressLogSettings.slice();

    let timeIntervalInput = _this.FullflowLogTimeIntervalInputViewConfig;

    timeIntervalInput.id = _this.Id + "PopupForm" + timeIntervalInput.name;
    timeIntervalInput.height = 65;

    popupFormRows.push(BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"fullflow aggregation settings"), icon:"gear", height: 38, borderless:false}),)
    popupFormRows.push(timeIntervalInput)
    popupFormRows.push({height:8})

    popupFormRows.push({
        rows:[
            {
                cols:[
                    BlockHeaderTemplate({title:LangHelper.GetString(this.Id,"fullflow additional aggregation settings"), icon:"gear", height: 38, borderless:true}),
                    {
                        view: "button",
                        id: _this.Id + "TooltipBtn" + "ReagrageteLog",
                        width: 32,
                        type: "icon",
                        icon: "question-circle",
                        css: "toolbar_round_btn",
                        popup: {
                            view: "popup",
                            body: {
                                borderless: true,
                                template: LangHelper.GetString(
                                    "QoEStorConfig",
                                    "The data from the fullflow_agg table will be reaggregated at the specified interval in the fullflow_agg_compressed_N " +
                                    "table and after the specified number of days will be moved to the fullflow_agg table and replace the corresponding partitions."
                                )
                            }
                        }
                    }
                ]
            }
        ]
        }
    )


    popupFormRows.push({
        height: 45,
        rows:[
            {
                cols:[
                    {width: 154},
                    {
                        template: LangHelper.GetString(this.Id,"After how many days to reaggregate logs"),
                        borderless: true,
                    },
                    {width:20},
                    {
                        template: LangHelper.GetString(this.Id,"Time interval for log aggregation"),
                        borderless: true,
                    },

                ]
            }
        ]
    })

    for (let numRow= 1;numRow<3; numRow++) {

        let cols = [];

        let aggCompressToggle = viewSettings.shift();

        let lifeTimeInput = viewSettings.shift();
        lifeTimeInput.name = lifeTimeInput.id;

        let timeIntervalSelect = viewSettings.shift();
        timeIntervalSelect.name = timeIntervalSelect.id;

        cols.push({view: "label", label: `${LangHelper.GetString(_this.Id, "Stage")} ${numRow}`, width: 70});
        cols.push({
            view: aggCompressToggle.view,
            id: aggCompressToggle.id,
            name: aggCompressToggle.id,
            width: 65,
            checkValue: "1",
            uncheckValue: "0",
            on: {
                onChange: function(newValue){
                    _this.FullflowAggLogSettingsSwitchChangeFields(newValue, numRow)
                }
            }
        })
        cols.push({
            view: "button",
            id: lifeTimeInput.id + "editButton",
            width: 32,
            type: "icon",
            css: "fullflow_btn",
            icon: "webix_icon fa-pencil-square",
            click: function() {
                let inputField = $$(lifeTimeInput.id);
                inputField.getInputNode().select();
            }
        });
        cols.push(lifeTimeInput);
        cols.push({width: 30});
        cols.push(timeIntervalSelect);

        popupFormRows.push({
            rows:[
                {cols: cols}
            ]});
    }

    return {
        view: "form",
        id: _this.Id + "FullflowAggLogSettingsPopupForm",
        borderless: true,
        elements: popupFormRows
    };
}

QoEStorConfigViewController.prototype.FullflowAggLogSettingsDefineForm = function ()
{
    let _this = this;

    let form = _this.Views.FullflowAggLogSettingsPopupForm;

    let curConfig = _this.ViewModel.GetConfigModel();

    form.setValues(curConfig);
}
QoEStorConfigViewController.prototype.FullflowAggLogSettingsShowForm = function (Node, Pos)
{
    let _this = this;

    if (Node && Pos) {

        _this.Views.FullflowAggLogSettingsPopup.show(Node, Pos);

    } else {

        if (_this.Views.EditorTabs.getValue() === _this.Id + "Editor" + "Code") {
            _this.Views.EditorTabs.setValue(_this.Id + "Editor");
        }

        let configMenu = $$(_this.Id + "SettingsMenu");
        configMenu.select("6")

        setTimeout(function () {
            let settingsBtn = $$(_this.Id + "FullflowAggLogSettingsButton");
            let node = settingsBtn.getNode();
            let pos = {pos:"left"};

            _this.Views.FullflowAggLogSettingsPopup.show(node, pos);
        }, 400)

    }
}

QoEStorConfigViewController.prototype.FullflowAggLogSettingsValidateForm = function()
{
    let _this = this;
    let form = _this.Views.FullflowAggLogSettingsPopupForm;
    let validateRes = true;
    let formValues = form.getValues();

    if (formValues.FULLFLOW_AGG_COMPRESS_1_ENABLE === "1")
    {
        if (formValues.FULLFLOW_AGG_COMPRESS_LOG_GROUP_LIFETIME_1 === "") {
            validateRes = false;
            let errorMsg = `${LangHelper.GetString("All", "Error")}!
                                   ${LangHelper.GetString(_this.Id, "Specify the number of days to reaggregate on stage")} 1.`
            webix.message({type:"error", text:errorMsg});
        }
        if (Number(formValues.FULLFLOW_AGG_LOG_GROUP_TIME_INTERVAL) >= Number(formValues.FULLFLOW_AGG_COMPRESS_LOG_GROUP_TIME_INTERVAL_1)) {
            validateRes = false;
            let errorMsg = `${LangHelper.GetString("All", "Error")}!
                                   ${LangHelper.GetString(_this.Id, "Time interval for fullflow log aggregation must be less than time on stage")} 1.`
            webix.message({type:"error", text:errorMsg});
        }

    }
    if (formValues.FULLFLOW_AGG_COMPRESS_2_ENABLE === "1")
    {
        if (formValues.FULLFLOW_AGG_COMPRESS_LOG_GROUP_LIFETIME_2 === "") {
            validateRes = false;
            let errorMsg = `${LangHelper.GetString("All", "Error")}!
                                   ${LangHelper.GetString(_this.Id, "Specify the number of days to reaggregate on stage")} 2.`
            webix.message({type:"error", text:errorMsg});
        }
        if (Number(formValues.FULLFLOW_AGG_LOG_GROUP_TIME_INTERVAL) >= Number(formValues.FULLFLOW_AGG_COMPRESS_LOG_GROUP_TIME_INTERVAL_2)) {
            validateRes = false;
            let errorMsg = `${LangHelper.GetString("All", "Error")}!
                                   ${LangHelper.GetString(_this.Id, "Time interval for fullflow log aggregation must be less than time on stage")} 2.`
            webix.message({type:"error", text:errorMsg});
        }

    }
    if (formValues.FULLFLOW_AGG_COMPRESS_1_ENABLE === "1" && formValues.FULLFLOW_AGG_COMPRESS_2_ENABLE === "1")
    {
        if (Number(formValues.FULLFLOW_AGG_COMPRESS_LOG_GROUP_LIFETIME_1) >= Number(formValues.FULLFLOW_AGG_COMPRESS_LOG_GROUP_LIFETIME_2)) {
            validateRes = false;
            let errorMsg = `${LangHelper.GetString("All", "Error")}!
                                   ${LangHelper.GetString(_this.Id, "The number of days for reaggregation on stage 1 must be less than on stage 2.")}`
            webix.message({type:"error", text:errorMsg});
        }
        if (Number(formValues.FULLFLOW_AGG_COMPRESS_LOG_GROUP_TIME_INTERVAL_1) >= Number(formValues.FULLFLOW_AGG_COMPRESS_LOG_GROUP_TIME_INTERVAL_2)) {
            validateRes = false;
            let errorMsg = `${LangHelper.GetString("All", "Error")}!
                                   ${LangHelper.GetString(_this.Id, "The time interval for reaggregation on stage 1 must be less than on stage 2.")}`
            webix.message({type:"error", text:errorMsg});
        }
    }

    return validateRes;
}

QoEStorConfigViewController.prototype.FullflowAggLogSettingsSaveForm = function ()
{
    let _this = this;
    let form = _this.Views.FullflowAggLogSettingsPopupForm;
    _this.ViewModel.SetConfigModel(form.getValues());
}

QoEStorConfigViewController.prototype.FullflowAggLogSettingsSwitchChangeFields = function (newValue, switchNum) {
    if (newValue === "1") {
        $$(`FULLFLOW_AGG_COMPRESS_LOG_GROUP_LIFETIME_${switchNum}`).enable();
        $$(`FULLFLOW_AGG_COMPRESS_LOG_GROUP_TIME_INTERVAL_${switchNum}`).enable();
    } else {
        $$(`FULLFLOW_AGG_COMPRESS_LOG_GROUP_LIFETIME_${switchNum}`).disable();
        $$(`FULLFLOW_AGG_COMPRESS_LOG_GROUP_TIME_INTERVAL_${switchNum}`).disable();
    }
}

QoEStorConfigViewController.prototype.MarkImportReceiversEditor = function(Editor, Text)
{
    let highLightClasses = {
        green: "editor_row_highlight_green",
        red: "editor_row_highlight_red"
    };

    Text.split("\n").forEach((Line, Idx) => {
        let color = "";

        if(Line.startsWith("+"))
            color = "green";
        if(Line.startsWith("-"))
            color = "red";

        let cssClass = highLightClasses[color];

        if(cssClass)
            Editor.markText({ line: Idx, ch: 0 }, { line: Idx, ch: Line.length }, cssClass);
    });
};

QoEStorConfigViewController.prototype.ApplyMergedReceiversConfig = function()
{
    if(this.CurentMergedReceiversConfig)
    {
        this.Views.ReceiversTable.clearAll();
        this.Views.ReceiversTable.parse(this.CurentMergedReceiversConfig.mergedConfig);
        this.ViewModel.SetConfigModel(this.GetFormsValues());
    }
}
function QoEStorLogsViewController(Params)
{
    var Id = "QoEStorLogs";

    var params = webix.extend(Params,{
        Id:Id,
        PageTitle:{
            RootTitle: LangHelper.GetString("AppView", "Administrator"),
            Title: LangHelper.GetString("AppView", "QoE Stor (fastor) logs")
        },
        ServerMethods:
        {
            RefreshLogsFilesList:"GetQoEStorLogsFilesList",

            GetLogFileTail:"GetQoEStorLogFileTail",

            DownloadLogFile:"DownloadQoEStorLogFile"
        },
        PathsNamesMap:
        {
            "/var/log/clickhouse-server":"Clickhouse",
            "/var/qoestor/backend/logs":"Receivers"
        },
        HwListSidebar:
        {
            Title:LangHelper.GetString("QoEStorConfig","QoE Stor nodes"),
            EmptyText: "<br/><br/><br/>" + LangHelper.GetString("QoEStorConfig","There is no QoE Stor nodes.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>."),
            ListType:HardwareTypesEnum.qoestor
        }
    },true);

    QoEStorLogsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(QoEStorLogsViewController,HardwareLogsViewController);

function BalancerConfigViewController(Params)
{
    var _this = this;

    this.Id = "BalancerConfig";

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new BalancerConfigManager();

    this.HistoryImportContext = webix.ui({
        view:"popup",
        width:800,
        height:720,
        id:this.Id+"HistoryImportContext",
        modal:true,
        body:{
            rows:[
                {
                    borderless:true,
                    cols:[
                        {
                            width:240,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiConfig","History"), icon: "history"}),
                                {
                                    view:"datatable",
                                    id:this.Id + "HistoryImportContext" + "HistoryTable",
                                    select: "row",
                                    columns: [
                                        {
                                            id: "date",
                                            header: [LangHelper.GetString("DpiConfig","Date"), {content: "dateRangeFilter"}],
                                            format: webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"),
                                            fillspace: true,
                                            sort: "date"
                                        }
                                    ],
                                    on:{
                                        onAfterLoad:function(){
                                            this.sort("date", "desc", "date");
                                            this.markSorting("date", "desc");
                                        },
                                        onAfterSelect: function (data, preserve)
                                        {
                                            var rowData = this.getItem(data);

                                            _this.Views.HistoryEditor.showProgress({type: "icon"});

                                            _this.ViewModel.LoadHistoryFile({configFile:rowData.file_id, callback:function (R)
                                                {
                                                    _this.Views.HistoryEditor.hideProgress({type: "icon"});
                                                    if(R.success)
                                                    {
                                                        _this.Views.HistoryEditor.setValue(R.data);
                                                    }
                                                    else
                                                    {
                                                        webix.message({type:"error",text:LangHelper.GetString("DpiConfig","Could not upload file")})
                                                    }
                                                }});
                                        }
                                    },
                                    data:[]
                                }
                            ]
                        },
                        {view:"resizer"},
                        {
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiConfig","Config"), icon: "code"}),
                                {
                                    view:"codemirror-editor",
                                    id:this.Id + "HistoryImportContext" + "Editor",
                                    value:""
                                }
                            ]
                        }
                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("DpiConfig","Cancel"),
                            click:function ()
                            {
                                _this.HistoryImportContext.hide();
                                _this.Views.HistoryEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("DpiConfig","Apply"),
                            click:function () {
                                _this.HistoryImportContext.hide();

                                _this.ViewModel.SetConfig(_this.Views.HistoryEditor.getValue());

                                // _this.ViewModel.SetConfigModel(_this.GetFormsValues());

                                webix.message(LangHelper.GetString(_this.Id,"Applied"));

                                _this.Views.HistoryEditor.setValue("");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            cols:[
                AdministratorLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView", "Administrator"), title: LangHelper.GetString("AppView", "Balancer server configuration")}),
                                {
                                    view: "accordion",
                                    multi: "mixed",
                                    on:{
                                        onAfterExpanded: function()
                                        {
                                            return true;
                                        }
                                    },
                                    cols:[
                                        {
                                            header: LangHelper.GetString(this.Id, "Balancer servers"),
                                            gravity: 1.2,
                                            body:{
                                                view: "datatable",
                                                id: this.Id + "HardwareList",
                                                header:false,
                                                select: "row",
                                                tooltip:true,
                                                columns: [
                                                    {
                                                        id: "value",
                                                        header: LangHelper.GetString("QoE","Hardware"),
                                                        width: 120,
                                                        fillspace: true,
                                                        sort: "string"
                                                    },
                                                ],
                                                on: {
                                                    onAfterLoad:function()
                                                    {
                                                        if (!this.count())
                                                        {
                                                            var text = "<br/><br/><br/>";

                                                            text += LangHelper.GetString("BalancerConfig","There is no Balancer servers.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>.")

                                                            this.showOverlay(text);
                                                        }
                                                    },
                                                    onAfterSelect: function(id)
                                                    {
                                                        var item = this.getItem(id);
                                                        setTimeout(function()
                                                        {
                                                            _this.ViewModel.SetHwId(item.id);
                                                            _this.Refresh();
                                                        }, 1);
                                                    }
                                                }
                                            }
                                        },
                                        {view:"resizer"},
                                        {
                                            header: LangHelper.GetString("QoE","Configuration"),
                                            gravity: 6,
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id: this.Id + "SaveBtn",
                                                                type: "icon",
                                                                icon: "floppy-o",
                                                                label: LangHelper.GetString("AppView", "Save"),
                                                                css: "toolbar_round_btn",
                                                                width: 128,
                                                                tooltip: LangHelper.GetString("AppView", "Save"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function ()
                                                                    {
                                                                        _this.ConfigSave();
                                                                    }, 1);
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "RestartBtn",
                                                                type: "icon",
                                                                icon: "retweet",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("AppView", "Restart"),
                                                                click: function (id, e, node)
                                                                {
                                                                    _this.Views.RestartQuestion.show(this.getNode());
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:_this.Id + "HistoryBtn",
                                                                type: "icon",
                                                                icon: "history",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("DpiConfig","Download from history"),
                                                                click: function (id, e, node) {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.ViewModel.HistoryRefresh();
                                                                        _this.HistoryImportContext.show(node, {pos: "bottom"});
                                                                        _this.DefineHistoryForms();
                                                                    }, 10);
                                                                }
                                                            },
                                                            {},
                                                            {
                                                                view: "button",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    if(_this.mode == "dpiui2")
                                                                    {
                                                                        _this.Refresh();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                width:16
                                                            },
                                                            function(){
                                                                var tabbar = {
                                                                    view:"tabbar",
                                                                    id:_this.Id + "Editor" + "Tabs",
                                                                    tabMoreWidth:0,
                                                                    value:_this.Id + "Editor",
                                                                    multiview:true,
                                                                    //height:webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.material.tabbarHeight,
                                                                    options: [
                                                                        {
                                                                            id: _this.Id + "Editor",
                                                                            "value": "<span class='webix_icon fa-trello'></span> "+LangHelper.GetString("All","The form")
                                                                        },
                                                                        {
                                                                            id: _this.Id + "Editor" + "Code",
                                                                            "value": "<span class='webix_icon fa-code'></span> "+LangHelper.GetString("All","Editor")
                                                                        }
                                                                    ],
                                                                    on:{
                                                                        "onChange":function(Id, OldId)
                                                                        {
                                                                            if(Id == _this.Id + "Editor" + "Code")
                                                                            {
                                                                                setTimeout(function ()
                                                                                {
                                                                                    _this.Views.CodeEditor.setValue(_this.ViewModel.GetConfig());
                                                                                },1);
                                                                            }

                                                                            if(Id == _this.Id + "Editor")
                                                                            {
                                                                                setTimeout(function ()
                                                                                {
                                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                },1);
                                                                            }
                                                                        }
                                                                    }
                                                                };

                                                                if(webix.skin.$name === "dpiui2_vulkan" || webix.skin.$name === "dpiui2_vulkan")
                                                                {
                                                                    tabbar = {
                                                                        rows:[
                                                                            {},
                                                                            tabbar
                                                                        ]
                                                                    };
                                                                }

                                                                return tabbar;
                                                            }()
                                                        ]
                                                    },
                                                    {
                                                        id:_this.Id + "FormPanel",
                                                        rows:[
                                                            {
                                                                cells:[
                                                                    {
                                                                        id: this.Id + "Editor",
                                                                        cols: [
                                                                            {
                                                                                width: 400,
                                                                                rows: [
                                                                                    BlockHeaderTemplate({title: LangHelper.GetString("All","Settings"), icon: "cogs"}),
                                                                                    {
                                                                                        view: "datatable",
                                                                                        id: _this.Id + "SettingsMenu",
                                                                                        header:false,
                                                                                        select: "row",
                                                                                        on: {
                                                                                            onAfterSelect: function (data, preserve) {
                                                                                                if($$(_this.Id + "Group_"+data.id))
                                                                                                {
                                                                                                    $$(_this.Id + "Group_"+data.id).show();

                                                                                                    var data = this.getItem(data.id);
                                                                                                    if(data.url)
                                                                                                    {
                                                                                                        _this.Views.WiKi.load(data.url);
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        columns: [
                                                                                            {
                                                                                                id: "value",
                                                                                                fillspace: true
                                                                                            }
                                                                                        ],
                                                                                        data: BalancerConfigManager.GetSortedBalancerEnvConfigGroupDicArr()
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {view: "resizer"},
                                                                            {
                                                                                rows: [
                                                                                    {
                                                                                        view:"multiview",
                                                                                        id: this.Id + "Groups",
                                                                                        cells:function ()
                                                                                        {
                                                                                            var cells = [];

                                                                                            BalancerConfigManager.GetSortedBalancerEnvConfigGroupDicArr().forEach(function (Obj)
                                                                                            {
                                                                                                var rows = [];

                                                                                                rows.push(BlockHeaderTemplate({
                                                                                                    title: Obj.value,
                                                                                                    icon: "cog"
                                                                                                }));

                                                                                                if(Obj.id == "1")
                                                                                                {
                                                                                                    rows.push(_this.ViewsForReceiversGroup(Obj.id))
                                                                                                }
                                                                                                else
                                                                                                    rows.push({
                                                                                                        id:_this.Id + "Group_" + Obj.id + "_form",
                                                                                                        view:"form",
                                                                                                        elements:_this.ViewsFromDicForGroup(Obj.id)
                                                                                                    });

                                                                                                //rows.push({});

                                                                                                cells.push({
                                                                                                    id: _this.Id + "Group_" + Obj.id,
                                                                                                    rows:rows
                                                                                                });
                                                                                            });

                                                                                            return cells;

                                                                                        }()
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        id:this.Id + "Editor" + "Code",
                                                                        rows:[
                                                                            {
                                                                                view:"codemirror-editor",
                                                                                id:this.Id + "Editor" + "Code" + "Codetree",
                                                                                value:""
                                                                            },
                                                                            {
                                                                                view:"toolbar",
                                                                                borderless:true,
                                                                                elements:[
                                                                                    {
                                                                                        view:"checkbox",
                                                                                        id:this.Id + "Editor" + "Code" + "ShowCommentsCheckbox",
                                                                                        labelRight:LangHelper.GetString("DpiConfig", "Show comments"),
                                                                                        labelWidth:0,
                                                                                        on:
                                                                                            {
                                                                                                "onChange":function(NewVal, OldVal)
                                                                                                {
                                                                                                    App.SessionManager.SetPreference("BalancerConfigManager:ShowComments",NewVal);

                                                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                                    _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                                                                                                }
                                                                                            }
                                                                                    },
                                                                                    {
                                                                                        view:"checkbox",
                                                                                        id:this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox",
                                                                                        labelRight:LangHelper.GetString("DpiConfig", "Show all params"),
                                                                                        labelWidth:0,
                                                                                        on:
                                                                                            {
                                                                                                "onChange":function(NewVal, OldVal)
                                                                                                {
                                                                                                    App.SessionManager.SetPreference("BalancerConfigManager:ShowAllParams", NewVal);

                                                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                                    _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                                                                                                }
                                                                                            }
                                                                                    },
                                                                                    {
                                                                                        gravity:2
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.EditReceiverContextFormColsNumber = 3;

    this.EditReceiverContextFormConfig = {
        view:"popup",
        maxWidth:800,
        modal:true,
        height: 0,
        body:
            {
                view:"form",
                id:this.Id + "EditReceiverContextForm",
                borderless:true,
                elements:function(){
                    var els = [];

                    var formCols = [];
                    var i = 0;

                    Object.keys(BalancerEnvConfigReceiverDic).forEach(function (Key)
                    {
                        var el = Helper.ViewFromDpiConfigDic(Key, BalancerEnvConfigReceiverDic);

                        if(!formCols[i])
                            formCols[i] = []

                        formCols[i].push(el);

                        i++;

                        if(i >= _this.EditReceiverContextFormColsNumber)
                            i = 0;
                    });

                    els.push({
                        cols:function()
                        {
                            var r = [];

                            formCols.forEach(function (Arr)
                            {
                                r.push({rows:Arr});
                            })

                            return r;
                        }()
                    });

                    els.push({
                        cols:[
                            {
                                gravity:2
                            },
                            {
                                view:"button",
                                label:LangHelper.GetString("All", "Cancel"),
                                click: function ()
                                {
                                    _this.HideReceiverEditForm();
                                }
                            },
                            {
                                view:"button",
                                label:LangHelper.GetString("All", "Apply"),
                                type:"form",
                                click: function ()
                                {
                                    _this.ApplyReceiverEditForm();
                                }
                            }
                        ]
                    });

                    return els;
                }()
            }
    };

    this.Subscriptions = {};

    this.Views = {
        HardwareList: null,
        EditorTabs:null,
        CodeEditor:null,
        FormsGroups:{},
        ValidationDataContextCodeEditor:null,
        ImportContextCodeEditor:null,
        ImportContextUploader:null,
        HistoryTable:null,
        HistoryEditor:null,
        HistoryForwardBtn:null,
        HistoryBackBtn:null,
        SaveBtn:null,
        RestartBtn:null,
        ShowCommentsCheckbox:null,
        ShowAllParamsCheckbox:null,

        ReceiversTable:null,
        AddReceiverBtn:null,

        EditReceiverContextFormPopup:null,
        EditReceiverContextForm:null,

        RestartQuestion:webix.ui({
            view:"popup",
            width:400,
            height:160,
            modal:true,
            body:{
                view:"form",
                borderless:true,
                elements:[
                    {
                        template:LangHelper.GetString("QoEStorConfig","Do you want to restart configuration?")
                    },
                    {
                        cols:[
                            {},
                            {
                                view:"button",
                                label:LangHelper.GetString(this.Id,"Cancel"),
                                click:function () {
                                    _this.Views.RestartQuestion.hide();
                                }
                            },
                            {
                                view:"button",
                                type:"form",
                                label:LangHelper.GetString("AppView", "Restart"),
                                click:function ()
                                {
                                    _this.Views.RestartQuestion.hide();
                                    _this.Restart();
                                }
                            }
                        ]
                    }
                ]
            }
        }),
        RestartQuestionAfterConfigSaved:webix.ui({
            view:"popup",
            width:400,
            height:160,
            modal:true,
            body:{
                view:"form",
                borderless:true,
                elements:[
                    {
                        template:LangHelper.GetString("DpiConfig","Configuration saved") + ".<br/><br/>" +
                            LangHelper.GetString("QoEStorConfig","Do you want to restart configuration?")
                    },
                    {
                        cols:[
                            {},
                            {
                                view:"button",
                                label:LangHelper.GetString(this.Id,"Cancel"),
                                click:function () {
                                    _this.Views.RestartQuestionAfterConfigSaved.hide();
                                }
                            },
                            {
                                view:"button",
                                type:"form",
                                label:LangHelper.GetString("AppView", "Restart"),
                                click:function ()
                                {
                                    _this.Views.RestartQuestionAfterConfigSaved.hide();
                                    _this.Restart();
                                }
                            }
                        ]
                    }
                ]
            }
        }),
        RestartLogPopup:webix.ui({
            view:"popup",
            maxWidth:800,
            height:"auto",
            modal:true,
            body:{
                view:"form",
                borderless:true,
                elements:[
                    {
                        view:"codemirror-editor",
                        id:this.Id + "RestartLog",
                        value:""
                    },
                    {
                        cols:[
                            {
                                gravity:3
                            },
                            {
                                view:"button",
                                type:"form",
                                label:"Ok",
                                click:function ()
                                {
                                    _this.Views.RestartLogPopup.hide();
                                    _this.Views.RestartLog.setValue("");
                                }
                            }
                        ]
                    }
                ]
            }
        }),
        RestartLog:$$(this.Id + "RestartLog"),
    };
}

BalancerConfigViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    window.test = this;

    this.Views.FormPanel = $$(this.Id + "FormPanel");
    webix.extend(this.Views.FormPanel, webix.OverlayBox);

    this.Views.SaveBtn = $$(this.Id + "SaveBtn");
    this.Views.RestartBtn = $$(this.Id + "RestartBtn");

    this.Views.HardwareList = $$(this.Id + "HardwareList");

    this.Views.CodeEditor = $$(this.Id + "Editor" + "Code" + "Codetree");
    this.Views.EditorTabs = $$(this.Id + "Editor" + "Tabs");

    this.Views.ShowCommentsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowCommentsCheckbox");
    this.Views.ShowAllParamsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox");

    this.Views.ShowCommentsCheckbox.blockEvent();
    this.Views.ShowCommentsCheckbox.setValue(App.SessionManager.GetPreference("BalancerConfigManager:ShowComments"));
    this.Views.ShowCommentsCheckbox.unblockEvent();

    this.Views.ShowAllParamsCheckbox.blockEvent();
    this.Views.ShowAllParamsCheckbox.setValue(App.SessionManager.GetPreference("BalancerConfigManager:ShowAllParams"));
    this.Views.ShowAllParamsCheckbox.unblockEvent();

    this.Views.ReceiversTable = $$(this.Id + "ReceiversTable");
    this.Views.AddReceiverBtn = $$(this.Id + "AddReceiverBtn");

    this.Views.EditReceiverContextFormPopup = webix.ui(this.EditReceiverContextFormConfig);
    this.Views.EditReceiverContextForm = $$(this.Id + "EditReceiverContextForm");

    this.Views.HistoryTable = $$(this.Id + "HistoryImportContext" + "HistoryTable");
    this.Views.HistoryEditor = $$(this.Id + "HistoryImportContext" + "Editor");

    webix.extend(this.Views.HistoryEditor, webix.ProgressBar);

    _this.Views.EditReceiverContextForm.elements["RECEIVER_TYPE"].attachEvent("onChange", function(Nv, Ov)
    {
        if(Nv&&Ov&&Nv!=Ov)
        {
            var rotate = _this.Views.EditReceiverContextForm.elements["ROTATE_MINUTES"], rotateVal = rotate.getValue();

            if(rotateVal == BalancerReceiverRotateDefaultsEnum[Ov])
                rotate.setValue(BalancerReceiverRotateDefaultsEnum[Nv]);
        }
    });

    BalancerConfigManager.GetSortedBalancerEnvConfigGroupDicKeysArr().forEach(function (Key)
    {
        var formId = _this.Id + "Group_"+Key+"_form";
        if($$(formId))
        {
            _this.Views.FormsGroups[formId] = $$(formId);
        }
    });

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        _this.Views.FormsGroups[Key].attachEvent("onChange", function(newv, oldv)
        {
            _this.ViewModel.SetConfigModel(_this.GetFormsValues());
        });
    });

    this.Subscriptions.ConfigHistoryUpdated = this.ViewModel.Signals.ConfigHistoryUpdated.subscribe(function (value)
    {
        if (value)
        {
            _this.DefineHistoryForms();
        }
    });

    this.Subscriptions.ConfigUpdated = this.ViewModel.Signals.ConfigFileUpdated.subscribe(function (V)
    {
        if (V)
        {
            _this.DefineForms();
        }
    });

    this.ShowFormOverlay("");
    this.Subscriptions.SignalHardwaresDicUpdatedSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (Updated)
    {
        if (Updated)
        {
            var hardwares = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);

            hardwares = hardwares.filter(function (Obj)
            {
                return Obj.hardware_type == HardwareTypesEnum.balancer;
            });

            _this.Views.HardwareList.clearAll();
            _this.Views.HardwareList.parse(hardwares);

            if(hardwares.length)
                _this.Views.HardwareList.select(hardwares[0].id);
        }
    });
};

BalancerConfigViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

    //_this.Refresh();
};

BalancerConfigViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });


    if(this.ViewModel)
        this.ViewModel.Destroy();
    delete this.ViewModel;
};

BalancerConfigViewController.prototype.Refresh = function ()
{
    var _this = this;

    App.NavRouter.ShowProgress();

    this.ViewModel.Refresh({callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig", "Configuration loaded"));
                _this.HideFormOverlay();
            }
            else
            {
                _this.ShowServerError(R.error);

                _this.ShowFormOverlay(R.error.msg);
            }
        }});
};

BalancerConfigViewController.prototype.ViewFromDic = function (DicId)
{
    return Helper.ViewFromDpiConfigDic(DicId, BalancerEnvConfigDic);
};

BalancerConfigViewController.prototype.ViewsFromDicForGroup = function (GroupId)
{
    var _this = this;

    var views = [];

    BalancerConfigManager.GetSortedBalancerEnvConfigDicKeysArr().forEach(function (Key)
    {

        if(BalancerEnvConfigDic[Key].group == GroupId && BalancerEnvConfigDic[Key].view)
        {
            views.push(_this.ViewFromDic(Key));
        }
    });

    views.push({});

    return views;
};

BalancerConfigViewController.prototype.ViewsForReceiversGroup = function (GroupId)
{
    var _this = this;

    var views = {
        rows:[
            {
                view: "toolbar",
                elements:[
                    {
                        view: "button",
                        id:this.Id + "AddReceiverBtn",
                        type: "icon",
                        icon: "plus",
                        align: "right",
                        width: 32,
                        css:"toolbar_round_btn",
                        tooltip:LangHelper.GetString("QoE","Add receiver"),
                        click: function (id, e, node)
                        {
                            _this.OnAddReceiverBtnClick(this.getNode());
                        }
                    }
                ]
            },
            {
                view:"datatable",
                id:this.Id + "ReceiversTable",
                resizeColumn: true,
                select: "row",
                //editable: true,
                headermenu: false,
                columns:function(){
                    var cols = [];

                    cols.push(
                        {
                            id: "edit",
                            header: "",
                            width: 32,
                            template: CellEditBtnTemplate,
                            headermenu: false,
                            align:"right"
                        }
                    );

                    Object.keys(BalancerEnvConfigReceiverDic).forEach(function (Key)
                    {
                        cols.push(
                            {
                                id:BalancerEnvConfigReceiverDic[Key].id,
                                header:[{text: TooltipTemplate(BalancerEnvConfigReceiverDic[Key].value, null, null, "question-circle"), css:{"white-space":"nowrap !important"}}],
                                editor:BalancerEnvConfigReceiverDic[Key].view,
                                options:BalancerEnvConfigReceiverDic[Key].options?Helper.DictToArr(BalancerEnvConfigReceiverDic[Key].options):null,
                                fillspace:1
                            }
                        );
                    });

                    cols.push(
                        {
                            id: "trash",
                            header: "",
                            width: 32,
                            template: CellTrashBtnTemplate,
                            headermenu: false,
                            align:"right"
                        }
                    );

                    return cols;
                }(),
                on:{
                    onHeaderClick:function(id, e, node)
                    {
                        if(e.target.className == "webix_icon webix_el_icon fa-question-circle")
                        {
                            var map = {};

                            Object.keys(BalancerEnvConfigReceiverDic).forEach(function(Key)
                            {
                                map[BalancerEnvConfigReceiverDic[Key].id] = Key;
                            });

                            _this.ShowHelpPopup(BalancerEnvConfigReceiverDic[map[id.column]].tooltip, node, BalancerEnvConfigReceiverDic[map[id.column]].tooltipHeight);
                        }
                    },
                    onItemClick: function (id,e,node)
                    {
                        var __this = this;

                        if(id.column === 'trash')
                        {
                            this.remove(id);

                            setTimeout(function ()
                            {
                                _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                            },1);
                        }

                        if(id.column === 'edit')
                        {
                            setTimeout(function ()
                            {
                                _this.ShowReceiverEditForm(__this.getItemNode(id), "right");
                            },1);
                        }
                    },
                    onItemDblClick: function (id,e,node)
                    {
                        var __this = this;

                        setTimeout(function ()
                        {
                            _this.ShowReceiverEditForm(__this.getItemNode({column:"edit", row:id.row}), "right");
                        },1);
                    }
                }
            }
        ]
    };

    return views;
};

BalancerConfigViewController.prototype.DefineForms = function ()
{
    var _this = this;

    this.Views.CodeEditor.setValue(this.ViewModel.GetConfig());

    this.DefineReceiversForms();

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        _this.Views.FormsGroups[Key].setValues(_this.ViewModel.GetConfigModel());
    });
};

BalancerConfigViewController.prototype.DefineReceiversForms = function ()
{
    var rows = this.ViewModel.ParseReceiverRows([
        BalancerReceiverTypesEnum.IPFIX_FULLFLOW,
        BalancerReceiverTypesEnum.IPFIX_CLICKSTREAM,
        BalancerReceiverTypesEnum.IPFIX_GTPFLOW,
        BalancerReceiverTypesEnum.IPFIX_NATFLOW,
        BalancerReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM,
        BalancerReceiverTypesEnum.IPFIX_DNSFLOW,
        BalancerReceiverTypesEnum.IPFIX_AAAFLOW
    ]);

    this.Views.ReceiversTable.clearAll();

    this.Views.ReceiversTable.parse(rows);
};

BalancerConfigViewController.prototype.GetFormsValues = function ()
{
    var _this = this;

    var configModel = this.GetReceiversFormsValues();

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        Object.keys(_this.Views.FormsGroups[Key].elements).forEach(function (ElKey)
        {
            var el = _this.Views.FormsGroups[Key].elements[ElKey];
            configModel[ElKey] = el.getValue();
        });
    });

    return configModel;
};

BalancerConfigViewController.prototype.GetReceiversFormsValues = function ()
{
    var _this = this;

    var configModel = {};

    var rows = this.Views.ReceiversTable.serialize();

    var index = {};

    index[BalancerReceiverTypesEnum.IPFIX_FULLFLOW] = 0;

    index[BalancerReceiverTypesEnum.IPFIX_CLICKSTREAM] = 0;

    index[BalancerReceiverTypesEnum.IPFIX_GTPFLOW] = 0;

    index[BalancerReceiverTypesEnum.IPFIX_NATFLOW] = 0;

    index[BalancerReceiverTypesEnum.IPFIX_NATFLOW_NETSTREAM] = 0;

    index[BalancerReceiverTypesEnum.IPFIX_DNSFLOW] = 0;

    index[BalancerReceiverTypesEnum.IPFIX_AAAFLOW] = 0;

    rows.forEach(function (Row, Index)
    {
        var type = Row.RECEIVER_TYPE?Row.RECEIVER_TYPE:BalancerReceiverTypesEnum.IPFIX_FULLFLOW;

        var model = new BalancerReceiverConfigModel(Row,index[type]);

        Object.keys(model).forEach(function (Key)
        {
            configModel[Key] = model[Key]
        });

        index[type]++;
    });

    return configModel;
};

BalancerConfigViewController.prototype.ConfigSave = function (Params)
{
    var _this = this;

    if(_this.Views.EditorTabs.getValue() == _this.Id + "Editor" + "Code")
    {
        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
    }

    App.NavRouter.ShowProgress();

    this.ViewModel.Save({callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Configuration saved"));

                _this.Views.RestartQuestionAfterConfigSaved.show(_this.Views.RestartBtn.getNode());
            }
            else
            {
                //webix.message({type:"error", text:R.error.msg});
                _this.ShowServerError(R.error);
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }});
};

BalancerConfigViewController.prototype.OnAddReceiverBtnClick = function(Node)
{
    var _this = this;

    this.Views.ReceiversTable.unselect();

    setTimeout(function ()
    {
        _this.ShowReceiverEditForm(Node, "bottom");
    },1);
};

BalancerConfigViewController.prototype.ShowHelpPopup = function(Text, Node, Height)
{
    webix.ui({
        view:"popup",
        height:Height,
        body:{
            borderless:true,
            template:Text
        }
    }).show(Node);
};

BalancerConfigViewController.prototype.ShowReceiverEditForm = function (Node, Pos)
{
    var data = this.Views.ReceiversTable.getSelectedItem();

    if(!data)
        data = new BalancerReceiverConfigRowModel();

    this.Views.EditReceiverContextForm.clear();

    this.Views.EditReceiverContextForm.clearValidation();

    this.Views.EditReceiverContextForm.setValues(data);

    this.Views.EditReceiverContextFormPopup.show(Node,{pos:Pos});
};

BalancerConfigViewController.prototype.HideReceiverEditForm = function ()
{
    this.Views.EditReceiverContextFormPopup.hide();
};

BalancerConfigViewController.prototype.ValidateReceiverEditForm = function ()
{
    return this.Views.EditReceiverContextForm.validate();
};

BalancerConfigViewController.prototype.ApplyReceiverEditForm = function ()
{
    var _this = this;

    if(!this.ValidateReceiverEditForm())
        return;

    var tableData = this.Views.ReceiversTable.getSelectedItem();

    var formdata = this.Views.EditReceiverContextForm.getValues();

    if(!tableData)
    {
        tableData = new BalancerReceiverConfigRowModel();
        this.Views.ReceiversTable.add(tableData);
        this.Views.ReceiversTable.select(tableData.id, false);
    }

    this.Views.ReceiversTable.updateItem(tableData.id,  new BalancerReceiverConfigRowModel(formdata));

    setTimeout(function ()
    {
        _this.ViewModel.SetConfigModel(_this.GetFormsValues());
    },1);

    _this.HideReceiverEditForm();
};

BalancerConfigViewController.prototype.Restart = function ()
{
    var _this = this;

    this.ViewModel.Restart({
        callback:function (R)
        {
            if(R.data)
            {
                _this.Views.RestartLogPopup.show(_this.Views.RestartBtn.getNode(),{pos:"right"});
                _this.Views.RestartLog.setValue(R.data);
            }

            if(R.success)
            {
                webix.message(LangHelper.GetString("QoEStorConfig", "Restart finished"));
            }
            else
            {
                //webix.message({type:"error", text:R.error.msg, expire:30000});
                _this.ShowServerError(R.error);
            }
        }
    });
};

BalancerConfigViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};

BalancerConfigViewController.prototype.ShowFormOverlay = function (ErrorMsg)
{
    this.Views.FormPanel.showOverlay("<br/><br/><br/>"+ErrorMsg);
    this.Views.SaveBtn.disable();
    this.Views.RestartBtn.disable();
};

BalancerConfigViewController.prototype.HideFormOverlay = function ()
{
    this.Views.FormPanel.hideOverlay();
    this.Views.SaveBtn.enable();
    this.Views.RestartBtn.enable();
};

BalancerConfigViewController.prototype.DefineHistoryForms = function (Params)
{
    this.Views.HistoryTable.clearAll();
    this.Views.HistoryTable.parse(this.ViewModel.GetHistory());
    this.Views.HistoryEditor.setValue("");
};
function BalancerLogsViewController(Params)
{
    var Id = "BalancerLogs";

    var params = webix.extend(Params,{
        Id:Id,
        PageTitle:{
            RootTitle: LangHelper.GetString("AppView", "Administrator"),
            Title: LangHelper.GetString("AppView", "Balancer logs")
        },
        ServerMethods:
            {
                RefreshLogsFilesList:"GetBalancerLogsFilesList",

                GetLogFileTail:"GetBalancerLogFileTail",

                DownloadLogFile:"DownloadBalancerLogFile"
            },
        PathsNamesMap:
            {
                "/var/log/syslog_ipfix_balancer_receivers": "Syslog",
                "/var/fast_ipfix_balancer/backend/logs":"Receivers"
            },
        HwListSidebar:
            {
                Title:LangHelper.GetString("BalancerConfig","Balancer servers"),
                EmptyText: "<br/><br/><br/>" + LangHelper.GetString("BalancerConfig","There is no Balancer servers.<br/>You should add it in <a href='#Hardwares'>Equipment section</a>."),
                ListType:HardwareTypesEnum.balancer
            }
    },true);

    BalancerLogsViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(BalancerLogsViewController,HardwareLogsViewController);

function CaptchaConfigViewController(Params)
{
    var _this = this;

    this.Id = "CaptchaConfig";

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new CaptchaConfigManager();

    this.ViewConfig = [
        {
            cols:[
                AdministratorLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            body: {
                                rows: [
                                    PageHeaderTemplate({root_title: LangHelper.GetString("AppView", "Administrator"), title: LangHelper.GetString("AppView", "Captcha configuration")}),
                                    {
                                        view: "toolbar",
                                        height: webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                        elements: [
                                            {
                                                view: "button",
                                                id: this.Id + "SaveBtn",
                                                type: "icon",
                                                icon: "floppy-o",
                                                label: LangHelper.GetString("AppView", "Save"),
                                                css: "toolbar_round_btn",
                                                width: 128,
                                                tooltip: LangHelper.GetString("AppView", "Save"),
                                                click: function (id, e, node) {
                                                    var __this = this;
                                                    setTimeout(function () {
                                                        _this.ConfigSave();
                                                    }, 1);
                                                }
                                            },
                                            {},
                                            {
                                                view: "button",
                                                type: "icon",
                                                icon: "refresh",
                                                css: "toolbar_round_btn",
                                                width: 32,
                                                tooltip: LangHelper.GetString(this.Id, "Refresh"),
                                                click: function (id, e, node) {
                                                    if (_this.mode == "dpiui2") {
                                                        _this.Refresh();
                                                    }
                                                }
                                            },
                                            {
                                                width: 16
                                            },
                                            function () {
                                                var tabbar = {
                                                    view: "tabbar",
                                                    id: _this.Id + "Editor" + "Tabs",
                                                    tabMoreWidth: 0,
                                                    value: _this.Id + "Editor",
                                                    multiview: true,
                                                    options: [
                                                        {
                                                            id: _this.Id + "Editor",
                                                            "value": "<span class='webix_icon fa-trello'></span> " + LangHelper.GetString("All", "The form")
                                                        },
                                                        {
                                                            id: _this.Id + "Editor" + "Code",
                                                            "value": "<span class='webix_icon fa-code'></span> " + LangHelper.GetString("All", "Editor")
                                                        }
                                                    ],
                                                    on: {
                                                        "onChange": function (Id, OldId) {
                                                            if (Id == _this.Id + "Editor" + "Code") {
                                                                setTimeout(function () {
                                                                    _this.Views.CodeEditor.setValue(_this.ViewModel.GetConfig());
                                                                }, 1);
                                                            }

                                                            if (Id == _this.Id + "Editor") {
                                                                setTimeout(function () {
                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                }, 1);
                                                            }
                                                        }
                                                    }
                                                };

                                                if (webix.skin.$name === "dpiui2_vulkan" || webix.skin.$name === "dpiui2_vulkan") {
                                                    tabbar = {
                                                        rows: [
                                                            {},
                                                            tabbar
                                                        ]
                                                    };
                                                }

                                                return tabbar;
                                            }()
                                        ]
                                    },
                                    {
                                        id: _this.Id + "FormPanel",
                                        rows: [
                                            {
                                                cells: [
                                                    {
                                                        id: this.Id + "Editor",
                                                        cols: [
                                                            {
                                                                rows: [
                                                                    {
                                                                        view: "multiview",
                                                                        id: this.Id + "Groups",
                                                                        cells: function () {
                                                                            var cells = [];

                                                                            CaptchaConfigManager.GetSortedCaptchaEnvConfigGroupDicArr().forEach(function (Obj) {
                                                                                cells.push({
                                                                                    id: _this.Id + "Group_" + Obj.id,
                                                                                    rows: [
                                                                                        BlockHeaderTemplate({
                                                                                            title: Obj.value,
                                                                                            icon: "cog"
                                                                                        }),
                                                                                        {
                                                                                            id: _this.Id + "Group_" + Obj.id + "_form",
                                                                                            view: "form",
                                                                                            scroll: true,
                                                                                            elements: _this.ViewsFromDicForGroup(Obj.id)
                                                                                        }
                                                                                    ]
                                                                                });
                                                                            });

                                                                            return cells;

                                                                        }()
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        id: this.Id + "Editor" + "Code",
                                                        rows: [
                                                            {
                                                                view: "codemirror-editor",
                                                                id: this.Id + "Editor" + "Code" + "Codetree",
                                                                value: ""
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        }]
                }
                ]
        }
    ];
    this.Subscriptions = {};

    this.Views = {
        SaveBtn:null,
        RestartBtn:null,
        ForcedDownloadBtn:null,
        EditorTabs:null,
        CodeEditor:null,
        FormsGroups:{},
    };
}

CaptchaConfigViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    window.test = this;
    this.Views.CodeEditor = $$(this.Id + "Editor" + "Code" + "Codetree");
    this.Views.SaveBtn = $$(this.Id + "SaveBtn");
    this.Views.RestartBtn = $$(this.Id + "RestartBtn");
    this.Views.ForcedDownloadBtn = $$(this.Id + "ForcedDownloadBtn");

    this.Views.EditorTabs = $$(this.Id + "Editor" + "Tabs");

    this.Subscriptions.ConfigUpdated = this.ViewModel.Signals.ConfigFileUpdated.subscribe(function (V)
    {
        if (V)
        {
            _this.DefineForms();
        }
    });

    this.Subscriptions.TemplatesUpdated = this.ViewModel.Signals.TemplatesUpdated.subscribe(function (V)
    {
        if (V)
        {
            let model = [];

            V.data.forEach((key) => {
                model.push({id: `${key}`, value: `${key}`})
            });

            let form = _this.Views.FormsGroups.CaptchaConfigGroup_1_form.elements.APP_TEMPLATE;

            let list = form.getList();
            list.clearAll();
            list.parse(model);

            let template = _this.ViewModel.GetConfigModel()["APP_TEMPLATE"];

            form.setValue(template);

            _this.Views.FormsGroups.CaptchaConfigGroup_1_form.elements.APP_TEMPLATE.enable();
        }
    });

    this.Subscriptions.TemplateFontsUpdated = this.ViewModel.Signals.TemplateFontsUpdated.subscribe(function (V)
    {
        if (V)
        {
            let model = [];
            model.push({id: "random", value: LangHelper.GetString("AppView", "Random")})

            V.forEach((key) => {
                model.push({id: `${key}`, value: `${key}`})
            });

            let form = _this.Views.FormsGroups.CaptchaConfigGroup_1_form.elements.CAPTCHA_FONT;

            let list = form.getList();
            list.clearAll();
            list.parse(model);

            let font = _this.ViewModel.GetConfigModel()["CAPTCHA_FONT"];

            form.setValue(font);

            _this.Views.FormsGroups.CaptchaConfigGroup_1_form.elements.CAPTCHA_FONT.enable();
        }
    });
    CaptchaConfigManager.GetSortedCaptchaEnvConfigGroupDicKeysArr().forEach(function (Key)
    {

        var formId = _this.Id + "Group_"+Key+"_form";
        if($$(formId))
        {
            _this.Views.FormsGroups[formId] = $$(formId);
        }
    });

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        _this.Views.FormsGroups[Key].attachEvent("onChange", function(newv, oldv)
        {
            _this.ViewModel.SetConfigModel(_this.GetFormsValues());
        });
    });

};

CaptchaConfigViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

    _this.Refresh();
};

CaptchaConfigViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });


    if(this.ViewModel)
        this.ViewModel.Destroy();
    delete this.ViewModel;
};

CaptchaConfigViewController.prototype.Refresh = function ()
{
    var _this = this;

    App.NavRouter.ShowProgress();

    this.ViewModel.Refresh({callback:function (R)
        {
            App.NavRouter.HideProgress();

            _this.Views.FormsGroups.CaptchaConfigGroup_1_form.elements.CAPTCHA_FONT.disable();
            _this.Views.FormsGroups.CaptchaConfigGroup_1_form.elements.APP_TEMPLATE.disable();

            if(R.success)
            {
                _this.ViewModel.GetCaptchaTemplates({callback:function (R)
                    {
                        if(!R.success)
                        {
                            _this.ShowServerError(R.error);
                        }
                    }});

                _this.ViewModel.GetCurrentTemplateFonts({callback:function (R)
                    {
                        if(!R.success)
                        {
                            _this.ShowServerError(R.error);
                        }
                    }});
            }
            else
            {
                _this.ShowServerError(R.error);
            }
        }});
};

CaptchaConfigViewController.prototype.ViewsFromDicForGroup = function (GroupId)
{
    var _this = this;

    var views = [];

    CaptchaConfigManager.GetSortedCaptchaEnvConfigDicKeysArr().forEach(function (Key)
    {
        if(CaptchaEnvConfigDic[Key].group == GroupId && CaptchaEnvConfigDic[Key].view)
        {
            views.push(_this.ViewFromDic(Key));
        }
    });

    return views;
};

CaptchaConfigViewController.prototype.ViewFromDic = function (DicId)
{
    return Helper.ViewFromDpiConfigDic(DicId, CaptchaEnvConfigDic);
};

CaptchaConfigViewController.prototype.DefineForms = function ()
{
    var _this = this;

    this.Views.CodeEditor.setValue(this.ViewModel.GetConfig());

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        var t = _this.ViewModel.GetConfigModel();

        _this.Views.FormsGroups[Key].setValues(_this.ViewModel.GetConfigModel());
    });
};

CaptchaConfigViewController.prototype.GetFormsValues = function ()
{
    var _this = this;

    var configModel = {};

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        Object.keys(_this.Views.FormsGroups[Key].elements).forEach(function (ElKey)
        {
            var el = _this.Views.FormsGroups[Key].elements[ElKey];

            configModel[ElKey] = el.getValue();
        });
    });

    return configModel;
};

CaptchaConfigViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};

CaptchaConfigViewController.prototype.ConfigSave = function (Params)
{
    var _this = this;

    if(_this.Views.EditorTabs.getValue() == _this.Id + "Editor" + "Code")
    {
        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
    }

    App.NavRouter.ShowProgress();

    this.ViewModel.Save({callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Configuration saved"));
                // _this.ViewModel.RestartQueue();
            }
            else
            {
                //webix.message({type:"error", text:R.error.msg});
                _this.ShowServerError(R.error);
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }});
};
function CaptchaTemplatesViewController(Params)
{
    var _this = this;

    this.Id = "CaptchaTemplates";

    this.mode = module ? module : "dpiui2";

    this.PathsNamesMap = Params&&Params.PathsNamesMap?Params.PathsNamesMap:{};

    this.ViewModel = new CaptchaConfigManager();

    this.ResetTemplateContext = webix.ui({
        view:"popup",
        width:340,
        height:200,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to reset template?")
                        + "<br/><br/>" +  "<span style='color: red'>"
                        + "</span>"
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.ResetTemplateContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "ResetTemplateContext" + "ResetBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Reset"),
                            click:function ()
                            {
                                _this.ResetTemplateContext.hide();

                                let templateName = _this.Views.TemplateName.getValue();

                                _this.GetCaptchaTemplateFiles(templateName);

                                _this.ResetTemplate();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.DeleteTemplateContext = webix.ui({
        view:"popup",
        width:340,
        height:200,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete template?")
                        + "<br/><br/>" +  "<span style='color: red'>"
                        + "</span>"
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.DeleteTemplateContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "DeleteTemplateContext" + "ResetBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.DeleteTemplateContext.hide();

                                _this.DeleteTemplate();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateTemplateContext = webix.ui({
        view:"popup",
        width:400,
        height:400,
        modal: true,
        position:"center",
        body:{
            id: this.Id + "CreateTemplateContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    rows:[
                        {
                            view: "richselect",
                            name: "templateClone",
                            label: LangHelper.GetString("AppView", "Template clone"),
                            labelWidth: 200,
                            inputWidth: 350,
                            required: true,
                            labelPosition: "left",
                            id:_this.Id + "TemplateClone",
                            invalidMessage: LangHelper.GetString("AppView", "Choose template clone"),
                            options: [],
                        },
                        {
                            view: "text",
                            name: "template",
                            labelWidth: 200,
                            inputWidth: 350,
                            required: true,
                            id: this.Id + "Template name",
                            label: LangHelper.GetString("AppView", "Template name"),
                            tooltip: LangHelper.GetString("AppView", "Template name"),
                            invalidMessage: LangHelper.GetString("AppView", "Enter template name"),
                            labelPosition: "left"
                    }]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.Views.CreateTemplateContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "Save",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Save"),
                            click:function ()
                            {
                                setTimeout(function () {
                                    if (_this.CreateTemplate())
                                        _this.Views.CreateTemplateContext.hide();
                                }, 10);

                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
        {
            type: "space",
            id: this.Id + "FileSpace",
            disabled: true,
            rows: [
                {
                    type: "clear",
                    borderless: true,
                    cols:[
                        AdministratorLeftSideBarView({id:this.Id}),
                        {
                            rows:[
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView", "Administrator"), title: LangHelper.GetString("AppView", "Captcha template")}),
                                {
                                    view: "toolbar",
                                    elements:[
                                        {
                                            view: "button",
                                            id:this.Id + "AddTemplate",
                                            type: "icon",
                                            icon: "plus",
                                            align: "right",
                                            width: 32,
                                            css:"toolbar_round_btn",
                                            tooltip:LangHelper.GetString(this.Id,""),
                                            click: function (id, e, node)
                                            {
                                                _this.Views.CreateTemplateContextForm.clear();

                                                _this.Views.CreateTemplateContext.show();
                                            }
                                        },
                                        {},
                                        {
                                            view: "button",
                                            id:_this.Id + "RefreshFilesList",
                                            type: "icon",
                                            icon: "refresh",
                                            css: "toolbar_round_btn",
                                            width: 32,
                                            tooltip: LangHelper.GetString("HardwareLogs", "Refresh"),
                                            click: function (id, e, node)
                                            {
                                                _this.GetCaptchaTemplateFiles();
                                            }
                                        }
                                    ]
                                },
                                BlockHeaderTemplate({title:LangHelper.GetString("HardwareLogs","Files"), icon:"list"}),
                                {
                                    cols:[
                                        {
                                            view: "richselect",
                                            name: "template",
                                            id:_this.Id + "TemplateName",
                                            options: [],
                                            on:{
                                                onChange: function (Data, Preserve)
                                                {
                                                    _this.GetCaptchaTemplateFiles(Data);
                                                }
                                            },
                                        },
                                        {
                                            view: "button",
                                            id:_this.Id + "DeleteTemplate",
                                            type: "icon",
                                            icon: "trash",
                                            align: "right",
                                            width: 32,
                                            css:"toolbar_round_btn",
                                            tooltip:LangHelper.GetString(this.Id,""),
                                            click: function (id)
                                            {
                                                let node = this.getNode(id);

                                                _this.DeleteTemplateContext.show(node, {pos:"bottom"});
                                            }
                                        },
                                    ],
                                },
                                {
                                    view: "treetable",
                                    id:_this.Id + "FilesTree",
                                    select: "row",
                                    columns:[
                                        {
                                            id: "filename",
                                            header: [LangHelper.GetString("HardwareLogs","File")],
                                            template: function(obj, common, value, config)
                                            {
                                                return common.treetable(obj, common, value, config) + (obj.filename ? obj.filename : _this.PathsNamesMap[obj.path]);
                                            },
                                            fillspace: true,
                                            sort: "string"
                                        }
                                    ],
                                    on:{
                                        onAfterSelect: function (Data, Preserve)
                                        {
                                            let data = this.getItem(Data.id);

                                            _this.ViewModel.SetCurrentOpenedFile(data.filename)

                                            let templateName = _this.Views.TemplateName.getValue();

                                            _this.ViewModel.RefreshTemplates(templateName);
                                        }
                                    },
                                },
                            ]
                        },
                        {
                            gravity: 6,
                            body:{
                                rows:[
                                    PageHeaderTemplate({root_title: LangHelper.GetString("AppView", "Administrator"), title: LangHelper.GetString("AppView", "Captcha template")}),
                                    {
                                        view: "toolbar",
                                        id: this.Id + "Toolbar",
                                        disabled: true,
                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                        elements: [
                                            {
                                                view: "button",
                                                id: this.Id + "SaveBtn",
                                                type: "icon",
                                                icon: "floppy-o",
                                                label: LangHelper.GetString("AppView", "Save"),
                                                css: "toolbar_round_btn",
                                                width: 128,
                                                tooltip: LangHelper.GetString("AppView", "Save"),
                                                click: function (id, e, node)
                                                {
                                                    var __this = this;
                                                    setTimeout(function ()
                                                    {
                                                        _this.TemplateSave();
                                                    }, 1);
                                                }
                                            },
                                            {
                                                view: "button",
                                                type: "icon",
                                                icon: "eye",
                                                css: "toolbar_round_btn",
                                                width: 32,
                                                tooltip: LangHelper.GetString(this.Id,"Reload view"),
                                                click: function () {
                                                    _this.Views.Iframe.define("src", `https://${_this.ViewModel.GetCaptchaSrc()}`);
                                                }
                                            },
                                            {
                                                view: "button",
                                                type: "icon",
                                                id: this.Id + "ForcedDownloadBtn",
                                                icon: "bolt",
                                                css:"toolbar_round_btn",
                                                tooltip: LangHelper.GetString("AppView", "Reset template"),
                                                width:32,
                                                click: function (id) {
                                                    var node = this.getNode(id);

                                                    _this.ResetTemplateContext.show(node, {pos:"bottom"});

                                                }
                                            },
                                            {},
                                            {
                                                view: "button",
                                                type: "icon",
                                                icon: "refresh",
                                                css: "toolbar_round_btn",
                                                width: 32,
                                                tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                                click: function (id, e, node)
                                                {
                                                    if(_this.mode == "dpiui2")
                                                    {
                                                        let templateName = _this.Views.TemplateName.getValue();

                                                        _this.ViewModel.RefreshTemplates(templateName);
                                                    }
                                                }
                                            }]},
                                    {
                                        id:_this.Id + "FormPanel",
                                        rows:[
                                            {
                                                cells:[
                                                    {
                                                        id:this.Id + "Editor" + "Code",
                                                        disabled: true,
                                                        rows:[
                                                            {
                                                                view:"codemirror-editor",
                                                                id:this.Id + "Editor" + "Code" + "Codetree",
                                                                value:""
                                                            },
                                                            {view:"resizer"},
                                                            {
                                                                view: "iframe",
                                                                id:this.Id + "Iframe",
                                                                src: "",
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }}]
                }
            ],
        }
    ];
    this.Subscriptions = {};

    this.Views = {
        SaveBtn:null,
        Toolbar:null,
        FileSpace:null,
        RestartBtn:null,
        ForcedDownloadBtn:null,
        EditorTabs:null,
        EditorCode:null,
        CodeEditor:null,
        Template:null,
        Iframe:null,
        FilesTree:null,
        TemplateName: null,
        TemplateClone: null,
        DeleteTemplate: null,
        CreateTemplateContext: null
    };
}

CaptchaTemplatesViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    window.test = this;

    this.Views.CodeEditor = $$(this.Id + "Editor" + "Code" + "Codetree");
    this.Views.EditorCode = $$(this.Id + "Editor" + "Code");
    this.Views.Template = $$(this.Id + "Template");
    this.Views.Iframe = $$(this.Id + "Iframe");
    this.Views.SaveBtn = $$(this.Id + "SaveBtn");
    this.Views.Toolbar = $$(this.Id + "Toolbar");
    this.Views.FileSpace = $$(this.Id + "FileSpace");
    this.Views.RestartBtn = $$(this.Id + "RestartBtn");
    this.Views.FilesTree = $$(this.Id + "FilesTree");
    this.Views.TemplateName = $$(this.Id + "TemplateName");
    this.Views.TemplateClone = $$(this.Id + "TemplateClone");
    this.Views.DeleteTemplate = $$(this.Id + "DeleteTemplate");
    this.Views.CreateTemplateContextForm = $$(this.Id + "CreateTemplateContextForm");
    this.Views.CreateTemplateContext = webix.ui(this.CreateTemplateContext);

    this.Subscriptions.ConfigUpdated = this.ViewModel.Signals.TemplateFileUpdated.subscribe(function (V)
    {
        if (V)
        {
            _this.Views.Toolbar.enable();

            _this.Views.EditorCode.enable();

            _this.Views.CodeEditor.setValue(_this.ViewModel.GetTemplateCode());

            _this.Views.Iframe.define("src", `https://${_this.ViewModel.GetCaptchaSrc()}`);
        }
    });

    this.Subscriptions.FilesUpdated = this.ViewModel.Signals.TemplateFilesUpdated.subscribe(function (V)
    {
        if (V)
        {
            _this.Views.FileSpace.enable();

            _this.Views.Iframe.define("src", `https://${_this.ViewModel.GetCaptchaSrc()}`);

            _this.Views.CodeEditor.setValue("");
            let table = _this.Views.FilesTree;

            table.clearAll();
            table.parse(V);
        }
    });

    this.Subscriptions.TemplatesUpdated = this.ViewModel.Signals.TemplatesUpdated.subscribe(function (V)
    {
        if (V)
        {
            let model = [];

            V.data.forEach((key) => {
                model.push({id: `${key}`, value: `${key}`})
            });

            _this.RichselectFilling(null, model, _this.Views.TemplateName);

            _this.RichselectFilling(null, model, _this.Views.TemplateClone);
        }
    });
};

CaptchaTemplatesViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

    _this.Refresh();
};

CaptchaTemplatesViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    if(this.ViewModel)
        this.ViewModel.Destroy();
    delete this.ViewModel;

    delete this;
};

CaptchaTemplatesViewController.prototype.Refresh = function ()
{
    var _this = this;

    App.NavRouter.ShowProgress();

    this.ViewModel.Refresh({callback:function (R)
        {
            _this.Views.DeleteTemplate.disable();
            if(R.success)
            {
                _this.GetCaptchaTemplateFiles();

                _this.GetCaptchaTemplates();

                App.NavRouter.HideProgress();

                _this.Views.DeleteTemplate.enable();
            }
            else
            {
                _this.ShowServerError(R.error);
            }
        }});
};

CaptchaTemplatesViewController.prototype.TemplateSave = function (Params)
{
    var _this = this;

    _this.ViewModel.SetTemplate(_this.Views.CodeEditor.getValue());

    App.NavRouter.ShowProgress();

    let templateName = this.Views.TemplateName.getValue();

    this.ViewModel.SaveTemplate({template: templateName, callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Configuration saved"));

                let templateName = _this.Views.TemplateName.getValue();

                _this.ViewModel.RefreshTemplates(templateName);
            }
            else
            {
                _this.ShowServerError(R.error);
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }});
};

CaptchaTemplatesViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};

CaptchaTemplatesViewController.prototype.ResetTemplate = function (Params)
{
    var _this = this;

    App.NavRouter.ShowProgress();

    let templateName = this.Views.TemplateName.getValue();

    this.ViewModel.ResetTemplate({template:templateName, callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Configuration saved"));
            }
            else
            {
                _this.ShowServerError(R.error);
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }});
};

CaptchaTemplatesViewController.prototype.GetCaptchaTemplates = function (Params)
{
    var _this = this;

    _this.ViewModel.GetCaptchaTemplates({callback:function (R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Configuration loaded"));
            }
            else
            {
                _this.ShowServerError(R.error);
            }
        }});
};
CaptchaTemplatesViewController.prototype.GetCaptchaTemplateFiles = function (Params)
{
    var _this = this;

    _this.ViewModel.GetCaptchaTemplateFiles( {template: Params, callback:function (R)
        {
            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Configuration loaded"));
            }
            else
            {
                _this.ShowServerError(R.error);
            }
        }});
};

CaptchaTemplatesViewController.prototype.CreateTemplate = function (Params) {
    var _this = this;

    let templateName = this.Views.CreateTemplateContextForm.elements.template.getValue();

    let templateClone = this.Views.CreateTemplateContextForm.elements.templateClone.getValue();

    this.ViewModel.CreateCaptchaTemplate(
        {
            template: templateName,
            templateClone: templateClone,
            callback: function (R) {
                if (R.success) {

                    _this.GetCaptchaTemplates({template: templateName});

                    webix.message(LangHelper.GetString("AppView", "Template saved"));
                } else {

                    if (R.error)
                        webix.message({text: R.error.msg, type: "error"});
                }
            }
        }
    );

    return true;
};

CaptchaTemplatesViewController.prototype.DeleteTemplate = function (Params) {
    var _this = this;

    let templateName = this.Views.TemplateName.getValue();

    this.ViewModel.DeleteCaptchaTemplate(
        {
            template: templateName,
            callback: function (R) {
                if (R.success) {

                    _this.GetCaptchaTemplates();

                    webix.message(LangHelper.GetString("AppView", "Template saved"));
                } else {

                    if (R.error)
                        webix.message({text: R.error.msg, type: "error"});
                }
            }
        }
    );

    return true;
};

CaptchaTemplatesViewController.prototype.RichselectFilling = function (Params, model, form) {
    var _this = this;

    let list = form.getList();
    list.clearAll();
    list.parse(model);

    let template = Params ? Params.template : _this.ViewModel.GetConfigModel()["APP_TEMPLATE"] ;

    form.setValue(template);
};
function CaptchaLogsViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"CaptchaLogs",
        PageTitle:{
            RootTitle: LangHelper.GetString("AppView", "Administrator"),
            Title: LangHelper.GetString("AppView", "CAPTCHA logs")
        },
        ServerMethods:
            {
                RefreshLogsFilesList:"GetCaptchaLogsFilesList",

                GetLogFileTail:"GetCaptchaLogFileTail",

                DownloadLogFile:"DownloadCaptchaLogFile"
            },
        PathsNamesMap:
            {
                "/var/www/fastcaptcha/log":"Captcha"
            }
    },true);

    CaptchaLogsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(CaptchaLogsViewController,HardwareLogsViewController);
webix.protoUI({
    name:"spectre_text",
    $cssName:"text",
    focused:true,
    hasValue:false,
    transformLabel:function()
    {
        var node = this.getNode();

        if(this.hasValue)
        {
            webix.html.removeCss(node, 'has_value');
            webix.html.addCss(node, 'has_value');
        }
        else
            webix.html.removeCss(node, 'has_value');
    },
    $init:function(config)
    {
        if(config && config.label)
            config.label = "<span>" + config.label + "</span>";

        this.hasValue =  this.getValue() ? true : (config.value ? true : false);

        this.transformLabel();

        this.attachEvent("onChange", function(id)
        {
            this.hasValue =  this.getValue() ? true : false;

            this.transformLabel();
        });

        this.attachEvent("onFocus", function(id)
        {
            var node = this.getNode();
            webix.html.addCss(node, 'focused');
        });
        this.attachEvent("onBlur", function(id)
        {
            var node = this.getNode();
            webix.html.removeCss(node, 'focused');
        });
    },
    $skin:function(){
        this.defaults.height = 52;
        this.defaults.bottomPadding = -1;
    },
    defaults:{
        css:"form_element",
        labelPosition:"top"
    }
}, webix.ui.text);

webix.protoUI({
    name:"spectre_textarea",
    $cssName:"textarea",
    focused:true,
    hasValue:false,
    transformLabel:function()
    {
        var node = this.getNode();

        if(this.hasValue)
        {
            webix.html.removeCss(node, 'has_value');
            webix.html.addCss(node, 'has_value');
        }
        else
            webix.html.removeCss(node, 'has_value');
    },
    $init:function(config)
    {
        if(config && config.label)
            config.label = "<span>" + config.label + "</span>";

        this.hasValue =  this.getValue() ? true : (config.value ? true : false);

        this.transformLabel();

        this.attachEvent("onChange", function(id)
        {
            this.hasValue =  this.getValue() ? true : false;

            this.transformLabel();
        });

        this.attachEvent("onFocus", function(id)
        {
            var node = this.getNode();
            webix.html.addCss(node, 'focused');
        });
        this.attachEvent("onBlur", function(id)
        {
            var node = this.getNode();
            webix.html.removeCss(node, 'focused');
        });
    },
    $skin:function(){
        this.defaults.height = 124;
        this.defaults.bottomPadding = -1;

    },
    defaults:{
        css:"form_element",
        labelPosition:"top"
    }
}, webix.ui.textarea);

webix.protoUI({
    name:"spectre_richselect",
    $cssName:"richselect",
    focused:true,
    hasValue:false,
    transformLabel:function()
    {
        var node = this.getNode();

        if(this.hasValue)
        {
            webix.html.removeCss(node, 'has_value');
            webix.html.addCss(node, 'has_value');
        }
        else
            webix.html.removeCss(node, 'has_value');
    },
    $init:function(config)
    {
        if(config && config.label)
            config.label = "<span>" + config.label + "</span>";

        this.hasValue =  this.getValue() ? true : (config.value ? true : false);

        this.transformLabel();

        this.attachEvent("onChange", function(id)
        {
            this.hasValue =  this.getValue() ? true : false;

            this.transformLabel();
        });

        this.attachEvent("onFocus", function(id)
        {
            var node = this.getNode();
            webix.html.addCss(node, 'focused');
        });
        this.attachEvent("onBlur", function(id)
        {
            var node = this.getNode();
            webix.html.removeCss(node, 'focused');
        });
    },
    $skin:function(){
        this.defaults.height = 52;
        this.defaults.bottomPadding = -1;
    },
    defaults:{
        css:"form_element",
        labelPosition:"top"
    }
}, webix.ui.richselect);

webix.protoUI({
    name:"spectre_multiselect",
    $cssName:"multiselect",
    focused:true,
    hasValue:false,
    transformLabel:function()
    {
        var node = this.getNode();

        if(this.hasValue)
        {
            webix.html.removeCss(node, 'has_value');
            webix.html.addCss(node, 'has_value');
        }
        else
            webix.html.removeCss(node, 'has_value');
    },
    $init:function(config)
    {
        if(config && config.label)
            config.label = "<span>" + config.label + "</span>";

        this.hasValue =  this.getValue() ? true : (config.value ? true : false);

        this.transformLabel();

        this.attachEvent("onChange", function(id)
        {
            this.hasValue =  this.getValue() ? true : false;

            this.transformLabel();
        });

        this.attachEvent("onFocus", function(id)
        {
            var node = this.getNode();
            webix.html.addCss(node, 'focused');
        });
        this.attachEvent("onBlur", function(id)
        {
            var node = this.getNode();
            webix.html.removeCss(node, 'focused');
        });
    },
    $skin:function(){
        this.defaults.height = 52;
        this.defaults.bottomPadding = -1;
    },
    defaults:{
        css:"form_element",
        labelPosition:"top"
    }
}, webix.ui.multiselect);

webix.protoUI({
    name:"spectre_combo",
    $cssName:"combo",
    focused:true,
    hasValue:false,
    transformLabel:function()
    {
        var node = this.getNode();

        if(this.hasValue)
        {
            webix.html.removeCss(node, 'has_value');
            webix.html.addCss(node, 'has_value');
        }
        else
            webix.html.removeCss(node, 'has_value');
    },
    $init:function(config)
    {
        if(config && config.label)
            config.label = "<span>" + config.label + "</span>";

        this.hasValue =  this.getValue() ? true : (config.value ? true : false);

        this.transformLabel();

        this.attachEvent("onChange", function(id)
        {
            this.hasValue =  this.getValue() ? true : false;

            this.transformLabel();
        });

        this.attachEvent("onFocus", function(id)
        {
            var node = this.getNode();
            webix.html.addCss(node, 'focused');
        });
        this.attachEvent("onBlur", function(id)
        {
            var node = this.getNode();
            webix.html.removeCss(node, 'focused');
        });
    },
    $skin:function(){
        this.defaults.height = 52;
        this.defaults.bottomPadding = -1;
    },
    defaults:{
        css:"form_element",
        labelPosition:"top"
    }
}, webix.ui.combo);

webix.protoUI({
    name:"spectre_button",
    $cssName:"button",
    $skin:function(){
        this.defaults.height = 44;
    }

}, webix.ui.button);

webix.protoUI({
    name:"spectre_captionlabel",
    $cssName:"label",
    $skin:function()
    {
        this.defaults.height = webix.skin.$active.inputHeight;
    },
    $setValue:function(value)
    {
        var template = this.config.template && typeof this.config.template == "function" ? this.config.template : this.defaults.template;
        this.setHTML(template({caption:this.config.caption, value:value}));
    },
    defaults:{
        css:"form_info_label",
        value:"",
        template:function (Obj)
        {
            return "<span class='caption'>"+Obj.caption+":</span> <span class='value'>"+Obj.value+"</span>";
        }
    }
}, webix.ui.label);

webix.protoUI({
    name:"spectre_toggle",
    $cssName:"label",
    $skin:function()
    {
        this.defaults.height = webix.skin.$active.inputHeight;
    },
    $setValue:function(value)
    {
        var box = this.$view.querySelector(".webix_icon");

        var onstate = this.config.onstate ? this.config.onstate : 1;

        if(value == onstate)
            webix.html.addCss(box, "fa-toggle-on");
        else
            webix.html.removeCss(box, "fa-toggle-on");
    },
    on_click:{
        "webix_icon":function(Ev, Id)
        {
            var onstate = this.config.onstate ? this.config.onstate : 1;
            var offstate = this.config.offstate ? this.config.offstate : 0;

            this.setValue(parseInt(this.config.value) == onstate ? offstate : onstate);
        }
    },
    defaults:{
        css:"block_header_toggle",
        value:"",
        template:function (Obj)
        {
            var onstate = Obj.onstate ? Obj.onstate : 1;

            return '<span class="webix_icon fa-toggle-off' + (Obj.value == onstate ? " fa-toggle-on" : "" )+ '"></span>';
        }
    }
}, webix.ui.label);

webix.protoUI({
    name:"spectre_datepicker",
    $cssName:"datepicker",
    focused:true,
    hasValue:false,
    transformLabel:function()
    {
        var node = this.getNode();

        if(this.hasValue)
        {
            webix.html.removeCss(node, 'has_value');
            webix.html.addCss(node, 'has_value');
        }
        else
            webix.html.removeCss(node, 'has_value');
    },
    $init:function(config)
    {
        if(config && config.label)
            config.label = "<span>" + config.label + "</span>";

        this.hasValue =  this.getValue() ? true : (config.value ? true : false);

        this.transformLabel();

        this.attachEvent("onChange", function(id)
        {
            this.hasValue =  this.getValue() ? true : false;

            this.transformLabel();
        });

        this.attachEvent("onFocus", function(id)
        {
            var node = this.getNode();
            webix.html.addCss(node, 'focused');
        });
        this.attachEvent("onBlur", function(id)
        {
            var node = this.getNode();
            webix.html.removeCss(node, 'focused');
        });
    },
    setValue:function(Value)
    {
        webix.ui.datepicker.prototype.setValue.call(this, Value);

        this.hasValue =  this.getValue() ? true : false;
        this.transformLabel();
    },
    $skin:function(){
        this.defaults.height = 52;
        this.defaults.bottomPadding = -1;
    },
    defaults:{
        css:"form_element",
        labelPosition:"top"
    }
}, webix.ui.datepicker);

var UlrShowAlertWindow = function (Params)
{
    var id = webix.uid();

    var view = {
        view:"window",
        id:id,
        css:"spectre-alert" + (Params&&Params.type ? " " + Params.type : ""),
        width:Params&&Params.width?Params.width:400,
        height:Params&&Params.height?Params.height:undefined,
        close:true,
        modal:true,
        position:"center",
        //head:Params&&Params.head,
        head:{
            view:"toolbar", cols:[
                {view:"label", label: Params&&Params.head, height:68},
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        $$(id).close();

                        if(Params && Params.on_close && typeof Params.on_close == 'function')
                        {
                            Params.on_close();
                        }
                    }}
            ]
        },
        headHeight:68,
        autofit:true,
        body:{
            rows:function ()
            {
                var rows =
                [
                    {
                        css:"webix_popup_text",
                        autoheight:Params&&Params.popup ? false : true,
                        template:(Params&&Params.mainTitle ? "<span class='title_main'>" + Params.mainTitle + "</span>" + "<br/>" : "") + (Params&&Params.title ? "<span class='title'>" + Params.title + ": " + "</span>" : "") + Params.message + "<br/><br/>"
                    }
                ];

                if(Params && Params.select && Params.select.id && Params.select.options)
                {
                    rows.push(
                        {
                            type:"space",
                            borderless:true,
                            cols:[
                                {
                                    id:Params.select.id,
                                    view:"richselect",
                                    label:Params.select.label ? Params.select.label : "",
                                    labelWidth: 100,
                                    suggest: {
                                        fitMaster: false,
                                        data: Params.select.options
                                    },
                                    value:Params.select.value ? Params.select.value : undefined
                                }
                            ]
                        }
                    );
                }

                if(Params&&Params.actions)
                {
                    var btns = [];

                    btns.push({width:20});

                    Params.actions.forEach(function (Action, Index)
                    {
                        var btn = {
                                view:"spectre_button",
                                css:"form_button" + (Action.css ? " " + Action.css : " main_action"),
                                label:Action.label,
                                click:function ()
                                {
                                    Action.click ? Action.click() : null;
                                    $$(id).close()
                                }
                            };

                        if(Index > 0)
                            btns.push({width:20});

                        btns.push(btn);
                    });

                    btns.push({width:20});

                    rows.push({
                        rows:[
                            {
                                height:20
                            },
                            {
                                cols:btns
                            },
                            {
                                height:20
                            }
                        ]
                    });
                }


                return rows;
            }()
        }
    };

    if(Params&&Params.popup)
    {
        view.view = "popup";
        view.padding = 0;
        view.margin = 0;
        //view.relative = "right"
        //view.point = true;
        //delete view.position;
        //delete view.head;

        return webix.ui(view).show(Params&&Params.node ? Params.node : null, {pos:Params&&Params.position ? Params.position : "bottom"});
    }
    else
        return webix.ui(view).show();
};

var UlrShowDialogPopup = function (Params)
{
    var params = Params ? Params : {};

    params.popup = true;

    UlrShowAlertWindow(params);
};

var UlrShowMessage = function (Type,Title, Text, Expire, Id)
{
    var typesEnum = {
        info:"info",
        success:"success",
        error:"error",
        debug:"debug"
    };

    var msg = {
        css:"spectre_message"
    };

    msg.type = Type && typesEnum[Type] ? typesEnum[Type] : typesEnum.info;

    msg.text = "";
    msg.text += Title ? "<div class='title'>"+Title+"</div>" : "";
    msg.text += Text ? "<div class='text'>"+Text+"</div>" : "";

    parseInt(Expire) ? msg.expire = Expire : null;

    webix.message(msg);
};

var UrlTableTestListWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlTableTestListWidget",
        hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        config:{
            _model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.mode_id = Params&&Params.mode_id?Params.mode_id : 0;

                this.name = Params&&Params.name?Params.name : null;

                this.create_time = Params&&Params.create_time?Params.create_time : null;

                this.update_time = Params&&Params.update_time?Params.update_time : null;

                this.create_user = Params&&Params.create_user?Params.create_user : null;

                this.update_user = Params&&Params.update_user?Params.update_user : null;

                this.full_text_search = Params&&Params.full_text_search?Params.full_text_search : null;
            },
            method:function ()
            {
                return "UlrGetDicProtocolsData ";
            },
            sort:{id:"name",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "_id",
                    header: [LangHelper.GetString("UlrModule","Id")],
                    sort: "string",
                    fillspace: 1,
                    template:CellLinkTemplate("#_id#")
                },
                {
                    id: "mode_id",
                    header: [LangHelper.GetString("UlrModule","Mode")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "create_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(obj, common)
                    {
                        if(obj.create_time)
                        {
                            var format =  webix.Date.dateToStr(DateFormatDic[App.Locale].date_format);
                            var create = new Date(obj.create_time);
                            var offset = create.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(create.getTime() - offset*60*1000);
                                return format(n_date);
                            }
                            return format(obj.create_time);
                        }

                        return "";
                    }
                    ,
                    fillspace: 1
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1
                }
            ]);
            return cols;
        }(),
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlWebRulesStatInfoTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlWebRulesStatInfoTableWidget",
        hideExport:true,
        hidePaginatorToolbar:true,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        config:{
            model:function (Params)
            {
                this.type = Params&&Params.type?Params.type:"";

                this.enabled = Params&&Params.active?Params.enabled : 0;

                this.disabled = Params&&Params.disabled?Params.disabled : 0;

                this.total = Params&&Params.total?Params.total : 0;
            },
            method:function ()
            {
                return "UlrCountResourceRules";
            },
            sort:{id:"type",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "active",
                    header: [LangHelper.GetString("UlrModule","Active")],
                    sort: "string",
                    fillspace: 1,
                    template:"#enabled#"
                },
                {
                    id: "disabled",
                    header: [LangHelper.GetString("UlrModule","Disabled")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "total",
                    header: [LangHelper.GetString("UlrModule","Total")],
                    sort: "string",
                    fillspace: 1
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"=",
            //     value:LangHelper.GetLocale()
            // }
        },
        sort_map:{
            active:"enabled"
        },
        defaultPageSize:-10,
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params && Params.additional_filter)
    {
        for(var i in Params.additional_filter)
        {
            params.filter[i] = Params.additional_filter[i];
        }
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlLastWebRulesEntriesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlLastWebRulesEntriesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        //enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.enabled = Params&&Params.enabled?Params.enabled:0;

                this.rule_enabled = Params&&Params.rule_enabled?Params.rule_enabled:0;

                this.rule_id = Params&&Params.rule_id?Params.rule_id:0;

                this.rule_type_mode = Params&&Params.rule_type_mode?Params.rule_type_mode:0;

                this.rule_type_id = Params&&Params.rule_type_id?Params.rule_type_id:0;

                //this.rule_name = Params&&Params.rule_name?Params.rule_name:"";

                this.type = Params&&Params.type?Params.type:"";

                this.update_time = Params&&Params.update_time?Params.update_time:null;

                this.resource_type = Params&&Params.resource_type?Params.resource_type : "";

                this.resource_raw = Params&&Params.resource_raw?Params.resource_raw : "";

                this.resource_validated = Params&&Params.resource_validated?Params.resource_validated : "";

                this.regulator = Params&&Params.regulator?Params.regulator : "";

                this.category = Params&&Params.category?Params.category : "";

                this.description_public = Params&&Params.description_public?Params.description_public : "";

                this.fastresource_config = Params && Params.fastresource_config ? Params.fastresource_config : null;

                this.imported = Params && Params.imported ? parseInt(Params.imported) : 0;

                this.lifetime = Params && Params.lifetime ? Params.lifetime : null;

                this.update_user = Params&&Params.update_user?Params.update_user : "";
            },
            method:function ()
            {
                return "UlrGetResourceRulesData";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                // {
                //     id: "enabled",
                //     header:"",
                //     sort: false,
                //     width:32,
                //     template:CellCheckboxSwitchOnOffTemplate
                // },
                {
                    id: "enabled",
                    header: "",//[LangHelper.GetString("UlrModule","Rule")],
                    template:function (Obj)
                    {
                        var s = parseInt(Obj.rule_enabled) && parseInt(Obj.enabled) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");

                        return CellAnyIconBtnTemplate("lightbulb " + (parseInt(Obj.rule_enabled) && parseInt(Obj.enabled) ? "green" : "red")) + " " + s;
                    },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","Rule id")],
                    template:function (Obj)
                    {
                        if(Params && Params.rule_type_id && Params.rule_type_id === UlrRulesTypesCodesTypeIdMap.web_ip_white)
                        {
                            return '<a class="webix_cell_link" href="#UlrEditWhiteListRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                        }
                        else
                        {
                            return '<a class="webix_cell_link" href="#UlrEditWebIpFilterRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                        }
                    },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "rule_type_mode",
                    header: [LangHelper.GetString("UlrModule", "Rule type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        const dic = UlrWebRuleTypeModeListTypes;

                        return dic[Obj.rule_type_mode] && dic[Obj.rule_type_mode].value ? dic[Obj.rule_type_mode].value : Obj.rule_type;
                    }
                },
                // {
                //     id: "rule_name",
                //     header: [LangHelper.GetString("UlrModule","Name")],
                //     sort: "string",
                //     fillspace: 1
                // },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        var type = Obj.type ? Obj.type.toLocaleUpperCase() : "";
                        // type = type.replace("IP", "IPv4");
                        return LangHelper.GetString("UlrModule", type);
                    }
                },
                {
                    id: "resource_raw",
                    header: [LangHelper.GetString("UlrModule","Resource raw")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value)
                    {
                        if(obj.type == UlrWebRuleResourcesTypesEnum.ulr_fastresource.toUpperCase() && obj.fastresource_config)
                        {
                            var cfg = JSON.parse(Helper.ReplaceAll("\n", "\\n", obj.fastresource_config));
                            var table = cfg && cfg.qoe_table ? cfg.qoe_table : ResourceImportQoETables.fullflow_agg.id;
                            if(ResourceImportQoETables[table] && ResourceImportQoETables[table].value)
                            {
                                return CellEyeBtnTemplate() + "&nbsp;" + ResourceImportQoETables[table].value;
                            }
                        }
                        resource_name = Helper.Table.ClsfrIdToNameTemplate(value, obj.type == UlrWebRuleResourcesTypesEnum.clsfr.toUpperCase());

                        if(obj.imported && parseInt(obj.imported))
                        {
                            var date = CellOnlyDateTemplate(new Date(obj.lifetime));
                            var title = LangHelper.GetString("UlrModule", "Imported from QoE.") + " " + (LangHelper.GetString("UlrModule", "Will be deleted after [DATE]").replace("[DATE]", date));
                            resource_name = CellDownloadBtnTemplate({default_cursor: true}) + "&nbsp;" + resource_name;
                            resource_name = "<span title='" + title + "'>" + resource_name + "</span>";
                        }

                        if(obj.type == UlrWebRuleResourcesTypesEnum.clsfr.toUpperCase() && App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.ulr_hosts_list))
                            resource_name =  CellHostButtonTemplate() + "&nbsp;" + resource_name;
                        
                        return resource_name;
                    }
                    // ,
                    // template:function (Obj)
                    // {
                    //     return Obj.resource_validated ? Obj.resource_validated : (Obj.resource_raw ? Obj.resource_raw : "");
                    // }
                },
                {
                    id: "resource_validated",
                    header: [LangHelper.GetString("UlrModule","Resource validated")],
                    sort: "string",
                    fillspace: 1
                    // ,
                    // template:function (Obj)
                    // {
                    //     return Obj.resource_validated ? Obj.resource_validated : (Obj.resource_raw ? Obj.resource_raw : "");
                    // }
                },
                {
                    id: "regulator",
                    header: [LangHelper.GetString("UlrModule","Regulator")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "category",
                    header: [LangHelper.GetString("UlrModule","Category")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "description_public",
                    header: [LangHelper.GetString("UlrModule","Reason")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_user",
                    header: [LangHelper.GetString("UlrModule","User")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                // {
                //     id: "delete",
                //     header:"",
                //     sort: false,
                //     width:32,
                //     template:CellTrashBtnTemplate
                // },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"equal or null",
            //     value:LangHelper.GetLocale()
            // },
            rule_type_id:{
                id:"rule_type_id",
                operator:"=",
                value:UlrRulesTypesCodesTypeIdMap.web_ip_lock
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            var ruleType = Params&&Params.rule_type_id?Params.rule_type_id:UlrRulesTypesCodesTypeIdMap.web_ip_lock;

            if(ruleType == UlrRulesTypesCodesTypeIdMap.web_ip_white)
                return LangHelper.GetString("UlrModule","Last entries in Whitelist register");

            return LangHelper.GetString("UlrModule","Last entries in Web/IP register");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlWebRulesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlLastWebRulesEntriesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        //enableCheckboxRefresh:true,
        config:{
            // model:function (Params)
            // {
            //     this._id = Params&&Params._id?Params._id:0;
            //
            //     this.enabled = Params&&Params.enabled?Params.enabled:0;
            //
            //     this.rule_enabled = Params&&Params.rule_enabled?Params.rule_enabled:0;
            //
            //     this.rule_id = Params&&Params.rule_id?Params.rule_id:0;
            //
            //     this.rule_type_mode = Params&&Params.rule_type_mode?Params.rule_type_mode:0;
            //
            //     this.rule_type_id = Params&&Params.rule_type_id?Params.rule_type_id:0;
            //
            //     //this.rule_name = Params&&Params.rule_name?Params.rule_name:"";
            //
            //     this.type = Params&&Params.type?Params.type:"";
            //
            //     this.update_time = Params&&Params.update_time?Params.update_time:null;
            //
            //     this.resource_type = Params&&Params.resource_type?Params.resource_type : "";
            //
            //     this.resource_raw = Params&&Params.resource_raw?Params.resource_raw : "";
            //
            //     this.resource_validated = Params&&Params.resource_validated?Params.resource_validated : "";
            //
            //     this.regulator = Params&&Params.regulator?Params.regulator : "";
            //
            //     this.category = Params&&Params.category?Params.category : "";
            //
            //     this.description_public = Params&&Params.description_public?Params.description_public : "";
            //
            //     this.update_user = Params&&Params.update_user?Params.update_user : "";
            // },
            method:function ()
            {
                return "UlrGetWebRulesData";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                // {
                //     id: "enabled",
                //     header:"",
                //     sort: false,
                //     width:32,
                //     template:CellCheckboxSwitchOnOffTemplate
                // },
                {
                    id:"checked",
                    header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc" }],
                    template: CellColoredCheckBoxTemplate,
                    width:40
                },
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","Rule id")],
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditWebIpFilterRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                    },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "rule_type_mode",
                    header: [LangHelper.GetString("UlrModule", "Rule type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        const dic = UlrWebRuleTypeModeListTypes;

                        return dic[Obj.rule_type_mode] && dic[Obj.rule_type_mode].value ? dic[Obj.rule_type_mode].value : Obj.rule_type;
                    }
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "regulator",
                    header: [LangHelper.GetString("UlrModule","Regulator")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "category",
                    header: [LangHelper.GetString("UlrModule","Category")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "description_public",
                    header: [LangHelper.GetString("UlrModule","Reason")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_user",
                    header: [LangHelper.GetString("UlrModule","User")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                // {
                //     id: "delete",
                //     header:"",
                //     sort: false,
                //     width:32,
                //     template:CellTrashBtnTemplate
                // },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"equal or null",
            //     value:LangHelper.GetLocale()
            // },
            rule_type_id:{
                id:"rule_type_id",
                operator:"=",
                value:UlrRulesTypesCodesTypeIdMap.web_ip_lock
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            var ruleType = Params&&Params.rule_type_id?Params.rule_type_id:UlrRulesTypesCodesTypeIdMap.web_ip_lock;

            if(ruleType == UlrRulesTypesCodesTypeIdMap.web_ip_white)
                return LangHelper.GetString("UlrModule","Last entries in Whitelist register");

            return LangHelper.GetString("UlrModule","Last entries in Web/IP register");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlLastVipSubscribersEntriesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlLastVipSubscribersEntriesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this.rule_id = Params&&Params.rule_id?Params.rule_id:0;
                this.enabled = Params&&Params.enabled?Params.enabled:0;
                this.mode_id = Params&&Params.mode_id?Params.mode_id:0;
                this.type_id = Params&&Params.type_id?Params.type_id:0;
                this.resource_id = Params&&Params.resource_id?Params.resource_id:0;
                this.resource_type_id = Params&&Params.resource_type_id?Params.resource_type_id:0;
                this.isps = Params&&Params.isps?Params.isps:'';
                this.mode = Params&&Params.mode?Params.mode:'';
                this.resource_type = Params&&Params.resource_type?Params.resource_type:'';
                this.resource = Params&&Params.resource?Params.resource:'';
                this.update_time = Params&&Params.update_time?Params.update_time:null;
            },
            method:function ()
            {
                return "UlrGetVipSubscribersList";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                // {
                //     id: "enabled",
                //     header: "",//[LangHelper.GetString("UlrModule","Rule")],
                //     template:function (Obj)
                //     {
                //         return parseInt(Obj.enabled) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");
                //     },
                //     sort: "string",
                //     fillspace: 0,
                //     width:80
                // },
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","Rule id")],
                    // template:function (Obj)
                    // {
                    //     return '<a class="webix_cell_link" href="#UlrEditVipSubscriberRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                    // },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                // {
                //     id: "rule_name",
                //     header: [LangHelper.GetString("UlrModule","Name")],
                //     sort: "string",
                //     fillspace: 1
                // },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "resource_type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.resource_type ? Obj.resource_type.toLocaleUpperCase() : "";
                    }
                },
                {
                    id: "resource",
                    header: [LangHelper.GetString("UlrModule","Resource raw")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        return obj.resource;
                    }
                },
                {
                    id: "mode",
                    header: [LangHelper.GetString("UlrModule","Mode")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        return obj.mode.toUpperCase();
                    }
                },
                // {
                //     id: "mode",
                //     header: [LangHelper.GetString("UlrModel", "Mode")],
                //     sort: "string",
                //     fillspace: 1,
                //     template: function(obj)
                //     {
                //         return obj.mode_id;
                //     }
                // },
                // {
                //     id: "resource_validated",
                //     header: [LangHelper.GetString("UlrModule","Resource validated")],
                //     sort: "string",
                //     fillspace: 1
                //     // ,
                //     // template:function (Obj)
                //     // {
                //     //     return Obj.resource_validated ? Obj.resource_validated : (Obj.resource_raw ? Obj.resource_raw : "");
                //     // }
                // },
                // {
                //     id: "regulator",
                //     header: [LangHelper.GetString("UlrModule","Regulator")],
                //     sort: "string",
                //     fillspace: 1
                // },
                // {
                //     id: "description_public",
                //     header: [LangHelper.GetString("UlrModule","Reason")],
                //     sort: "string",
                //     fillspace: 1
                // },
                {
                    id: "edit",
                    header:"",
                    hidden: Params && Params.hideEdit ? !!(Params.hideEdit) : false,
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"equal or null",
            //     value:LangHelper.GetLocale()
            // },
            rule_type_id:{
                id:"type_id",
                operator:"=",
                value:UlrRulesTypesCodesTypeIdMap.vip_subscribers
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Last entries in VIP subscribers register");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlLastTrafficRedirectionSubscribersEntriesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlLastTrafficRedirectionSubscribersEntriesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this.rule_id = Params&&Params.rule_id?Params.rule_id:0;
                this.enabled = Params&&Params.enabled?Params.enabled:0;
                this.mode_id = Params&&Params.mode_id?Params.mode_id:0;
                this.type_id = Params&&Params.type_id?Params.type_id:0;
                this.resource_id = Params&&Params.resource_id?Params.resource_id:0;
                this.resource_type_id = Params&&Params.resource_type_id?Params.resource_type_id:0;
                this.isps = Params&&Params.isps?Params.isps:'';
                this.mode = Params&&Params.mode?Params.mode:'';
                this.resource_type = Params&&Params.resource_type?Params.resource_type:'';
                this.resource = Params&&Params.resource?Params.resource:'';
                this.update_time = Params&&Params.update_time?Params.update_time:null;
            },
            method:function ()
            {
                return "UlrGetTrafficRedirectionSubscribersList";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","Rule id")],
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "resource_type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.resource_type ? Obj.resource_type.toLocaleUpperCase() : "";
                    }
                },
                {
                    id: "resource",
                    header: [LangHelper.GetString("UlrModule","Resource raw")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        return obj.resource;
                    }
                },
                {
                    id: "mode",
                    header: [LangHelper.GetString("UlrModule","Mode")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        return obj.mode.toUpperCase();
                    }
                },
                {
                    id: "edit",
                    header:"",
                    hidden: Params && Params.hideEdit ? !!(Params.hideEdit) : false,
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            rule_type_id:{
                id:"type_id",
                operator:"=",
                value:UlrRulesTypesCodesTypeIdMap.traffic_redirection
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Latest records of subscriber traffic redirection");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlRecordPCAPTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlRecordPCAPTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this.rule_id = Params&&Params.rule_id?Params.rule_id:0;
                this.enabled = Params&&Params.enabled?Params.enabled:0;
                this.mode_id = Params&&Params.mode_id?Params.mode_id:0;
                this.type_id = Params&&Params.type_id?Params.type_id:0;
                this.resource_id = Params&&Params.resource_id?Params.resource_id:0;
                this.resource_type_id = Params&&Params.resource_type_id?Params.resource_type_id:0;
                this.isps = Params&&Params.isps?Params.isps:'';
                this.mode = Params&&Params.mode?Params.mode:'';
                this.resource_type = Params&&Params.resource_type?Params.resource_type:'';
                this.state = Params&&Params.state?Params.state:'';
                this.resource = Params&&Params.resource?Params.resource:'';
                this.update_time = Params&&Params.update_time?Params.update_time:null;
            },
            method:function ()
            {
                return "UlrGetRecordPCAPSubscribersList";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template: function (Obj, Common, Value) {
                        return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                    }
                },
                {
                    id: "state",
                    header:[LangHelper.GetString("UlrModule","Rule state")],
                    fillspace: 1,
                    template:function(Obj)
                    {
                        if (Obj.state) {
                            const
                                state = JSON.parse(Obj.state),
                                format =  webix.Date.dateToStr(DateFormatDic[App.Locale].datetime_format);

                            if (state.start_time)
                            {
                                return LangHelper.GetString("UlrModule","Starts in") + format(new Date(state.start_time));
                            }
                            else if (!state.start_time && state.end_time)
                            {
                                return "<span class=\"webix_icon fa-record-vinyl\" style='color: red; cursor:pointer;'></span>" + LangHelper.GetString("UlrModule","Ends in") + format(new Date(state.end_time));
                            }
                        }

                        return "";
                    },
                },
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","Rule id")],
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "resource_type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    // fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.resource_type ? Obj.resource_type.toLocaleUpperCase() : "";
                    }
                },
                {
                    id: "resource",
                    header: [LangHelper.GetString("UlrModule","Resource raw")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        let resource = obj.resource.split(" ");
                        return resource[0];
                    }
                },
                {
                    id: "port",
                    header: [LangHelper.GetString("UlrModule","Port")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        let res = "";

                        if([
                            UlrWebRuleResourcesTypesMapEnum.ip,
                            UlrWebRuleResourcesTypesMapEnum.cidr
                        ].includes(obj.resource_type_id))
                        {
                            let resources = obj.resource.split(" ")
                                .filter(i => i.includes("="))
                                .map(i => i.split("="))
                                .reduce((acc, i) => {
                                    acc[i[0]] = i[1];
                                    return acc;
                                }, {});

                            res = resources["port"] ? resources["port"] : "";
                        }

                        if(res && res.includes(","))
                        {
                            res = CellEyeBtnTemplate();
                        }

                        return res;
                    }
                },
                {
                    id: "proto",
                    header: [LangHelper.GetString("UlrModule", "Network protocol")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        let res = "";

                        if([
                            UlrWebRuleResourcesTypesMapEnum.ip,
                            UlrWebRuleResourcesTypesMapEnum.cidr
                        ].includes(obj.resource_type_id))
                        {
                            let resource = obj.resource.split(" ");
                            if (resource.length > 2 && resource[2]) {
                                let [key, value] = resource[2].split("=");
                                res = value;
                            }
                        }

                        return res;
                    }
                },
                {
                    id: "vlan",
                    header: [LangHelper.GetString("UlrModule","VLAN")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        let res = "";

                        if([
                            UlrWebRuleResourcesTypesMapEnum.ip,
                            UlrWebRuleResourcesTypesMapEnum.cidr
                        ].includes(obj.resource_type_id))
                        {
                            let resource = obj.resource.split(" ");
                            if (resource.length > 3 && resource[3]) {
                                let [key, value] = resource[3].split("=");
                                res = value;
                            }
                        }

                        return res;
                    }
                },
                {
                    id: "ip_dst",
                    header: [LangHelper.GetString("UlrModule","Dst ip")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        let res = "";

                        if([
                            UlrWebRuleResourcesTypesMapEnum.ip,
                            UlrWebRuleResourcesTypesMapEnum.cidr
                        ].includes(obj.resource_type_id))
                        {
                            let resources = obj.resource.split(" ")
                                .filter(i => i.includes("="))
                                .map(i => i.split("="))
                                .reduce((acc, i) => {
                                    acc[i[0]] = i[1];
                                    return acc;
                                }, {});

                            res = resources["ip_dst"] ? resources["ip_dst"] : "";
                        }

                        if(res && res.includes(","))
                        {
                            res = CellEyeBtnTemplate();
                        }

                        return res;
                    }
                },
                {
                    id: "mode",
                    header: [LangHelper.GetString("UlrModule","Mode")],
                    sort: "string",
                    // fillspace: 1,
                    template: function (obj, common, value){
                        return obj.mode.toUpperCase();
                    }
                },
                {
                    id: "edit",
                    header:"",
                    hidden: Params && Params.hideEdit ? !!(Params.hideEdit) : false,
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            rule_type_id:{
                id:"type_id",
                operator:"=",
                value:UlrRulesTypesCodesTypeIdMap.pcap_recording
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Latest PCAP subscriber records");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlWebRulesSearchResultTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlWebRulesSearchResultTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        //enableCheckboxRefresh:true,
        config:{
            values:
            [
                {col:"uniq_id"},
                {col:"_id"},
                {col:"update_time"},
                {col:"resource_raw", alias:"resource_raw", func:"group_concat"},
                {col:"resource_validated", alias:"resource_validated", func:"group_concat"},
                {col:"regulator"},
                {col:"description_public"},
                //{col:"lang_code"},
                {col:"type", alias:"type", func:"group_concat"},
                {col:"rule_type_id"}
            ],
            rows:["rule_id"],
            method:function ()
            {
                return "UlrGetResourceRulesData";
            }
            // ,
            // sort:{id:"create_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","Rule id")],
                    template:function (Obj)
                    {
                        var id = Helper.StripHtml(Obj.rule_id);

                        const ruleTypeIdValue = Object.keys(UlrRulesTypesCodesTypeIdMap).find(key => UlrRulesTypesCodesTypeIdMap[key] == Obj.rule_type_id);

                        if (ruleTypeIdValue && ruleTypeIdValue == UlrRulesTypesCodesEnum.excluded_resources)
                            return "";

                        return '<a class="webix_cell_link" href="#UlrEditWebIpFilterRule/_id=' + id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                    },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    // template:function(Obj)
                    // {
                    //     var dateStr = Helper.StripHtml(Obj.update_time);
                    //     return CellSpectreDateTemplate(dateStr);
                    // },
                    fillspace: 1
                },
                {
                    id: "type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.type ? Helper.ReplaceAll(",", " \n<br/>", Obj.type.toLocaleUpperCase()) : "";
                    }
                },
                {
                    id: "resource_raw",
                    header: [LangHelper.GetString("UlrModule","Resource raw")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.resource_raw ? Helper.ReplaceAll(",", " \n<br/>", Obj.resource_raw) : "";
                    }
                },
                {
                    id: "resource_validated",
                    header: [LangHelper.GetString("UlrModule","Resource validated")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.resource_validated ? Helper.ReplaceAll(",", " \n<br/>", Obj.resource_validated) : "";
                    }
                },
                {
                    id: "rule_type_id",
                    header: [LangHelper.GetString("UlrModule","Rule type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        const ruleTypeCodeValue = Obj.rule_type_id && Object.keys(UlrRulesTypesCodesTypeIdMap).find(key => UlrRulesTypesCodesTypeIdMap[key] == Obj.rule_type_id);

                        var title = ruleTypeCodeValue && UlrRulesTypesCodesDic[ruleTypeCodeValue] ? UlrRulesTypesCodesDic[ruleTypeCodeValue].value : "";

                        var controller = ruleTypeCodeValue && UlrRulesTypesCodesListsControllersMap[ruleTypeCodeValue] ? UlrRulesTypesCodesListsControllersMap[ruleTypeCodeValue] : "";

                        if(controller)
                            return '<a class="webix_cell_link" href="#'+controller+'" onclick="return false;">' + title + '</a>';
                        else
                            return title;
                    }
                },
                {
                    id: "description_public",
                    header: [LangHelper.GetString("UlrModule","Reason")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"=",
            //     value:LangHelper.GetLocale()
            // },
            rule_type_id:{
                id:"rule_type_id",
                operator:"in",
                value:[UlrRulesTypesCodesTypeIdMap.web_ip_lock, UlrRulesTypesCodesTypeIdMap.excluded_resources]
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        fixedRowHeight:false,
        rowLineHeight:40,
        rowAutoHeight:"resource_raw",
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Search database");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    // params.on.onresize = webix.once(function(){
    //     this.adjustRowHeight("resource_raw", true);
    // });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlAllRulesSearchResultTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlAllRulesSearchResultTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        //enableCheckboxRefresh:true,
        config:{
            values:
                [
                    {col:"uniq_id"},
                    {col:"update_time"},
                    {col:"resource_raw", alias:"resource_raw", func:"group_concat"},
                    {col:"resource_validated", alias:"resource_validated", func:"group_concat"},
                    {col:"name"},
                    {col:"description"},
                    {col:"type", alias:"type", func:"group_concat"},
                    {col:"rule_type_code"}
                ],
            rows:["rule_id"],
            method:function ()
            {
                return "UlrGetAllResourceRulesData";
            }
            // ,
            // sort:{id:"create_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","Rule id")],
                    template:function (Obj)
                    {
                        var id = Helper.StripHtml(Obj.rule_id);

                        var controller = UlrRulesTypesCodesControllersMap[Obj.rule_type_code] ? UlrRulesTypesCodesControllersMap[Obj.rule_type_code] : "";

                        if(controller)
                        {
                            if (controller == UlrRulesTypesCodesControllersMap.excluded_resources)
                                return "";

                            return '<a class="webix_cell_link" href="#'+controller+'/_id=' + id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                        }
                        else
                            return Obj.rule_id;

                    },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    // template:function(Obj)
                    // {
                    //     var dateStr = Helper.StripHtml(Obj.update_time);
                    //     return CellSpectreDateTemplate(dateStr);
                    // },
                    fillspace: 1
                },
                {
                    id: "type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.type ? Helper.ReplaceAll(",", " \n<br/>", Obj.type.toLocaleUpperCase()) : "";
                    }
                },
                {
                    id: "resource_raw",
                    header: [LangHelper.GetString("UlrModule","Resource raw")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.resource_raw ? Helper.ReplaceAll(",", " \n<br/>", Obj.resource_raw) : "";
                    }
                },
                {
                    id: "resource_validated",
                    header: [LangHelper.GetString("UlrModule","Resource validated")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.resource_validated ? Helper.ReplaceAll(",", " \n<br/>", Obj.resource_validated) : "";
                    }
                },
                {
                    id: "rule_type_code",
                    header: [LangHelper.GetString("UlrModule","Rule type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        var rule_type_code = Helper.StripHtml(Obj.rule_type_code);

                        var title = rule_type_code && UlrRulesTypesCodesDic[rule_type_code] ? UlrRulesTypesCodesDic[rule_type_code].value : rule_type_code;

                        var controller = UlrRulesTypesCodesListsControllersMap[rule_type_code] ? UlrRulesTypesCodesListsControllersMap[rule_type_code] : "";

                        if(controller)
                            return '<a class="webix_cell_link" href="#'+controller+'" onclick="return false;">' + title + '</a>';
                        else
                            return title;
                    }
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "description",
                    header: [LangHelper.GetString("UlrModule","Description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"=",
            //     value:LangHelper.GetLocale()
            // },
            // rule_type_id:{
            //     id:"rule_type_id",
            //     operator:"=",
            //     value:UlrRulesTypesCodesTypeIdMap.web_ip_lock
            // }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        fixedRowHeight:false,
        rowLineHeight:40,
        rowAutoHeight:"resource_raw",
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Search database");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    // params.on.onresize = webix.once(function(){
    //     this.adjustRowHeight("resource_raw", true);
    // });

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlLastWhitelistEntriesTableWidget = function (Params)
{
    var params = webix.extend(Params,{
        name:"UrlLastWhitelistEntriesTableWidget",
        filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"=",
            //     value:LangHelper.GetLocale()
            // },
            rule_type_id:{
                id:"rule_type_id",
                operator:"=",
                value:UlrRulesTypesCodesTypeIdMap.web_ip_white
            }
        },
        rule_type_id:UlrRulesTypesCodesTypeIdMap.web_ip_white
    },true);

    return UrlLastWebRulesEntriesTableWidget(params);
};

var UrlWhitelistIspsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlWhitelistIspsTableWidget",
        hideExport:true,
        hidePaginatorToolbar:true,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "UlrGetIspList";
            },
            sort:{id:"name",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule",Params && Params.isp_type && Params.isp_type !== UlrPolicingTypeEnum.isp ? "Subscriber" : "ISP")],
                    sort: "string",
                    fillspace:1
                },
                {
                    id: "igw_name",
                    header: [LangHelper.GetString("UlrModule","IGW name")],
                    sort: "string",
                    fillspace: 5
                },
                {
                    id: "white_list_enabled",
                    header: [{text:LangHelper.GetString("UlrModule","Whitelist"), css:{'text-align':'right'}}],
                    sort: "string",
                    width:160,
                    css:{'text-align':'right'},
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            type:{
                id:"type",
                operator:"=",
                value: Params && Params.isp_type && Params.isp_type !== UlrPolicingTypeEnum.isp ? "subscriber" : UlrPolicingTypeEnum.isp
            }
        },
        //sort_map:{whitelist:"enabled"},
        defaultPageSize:-100,
        on: {},
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrSubsListTableWidget = function (Params)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    var params = {
        id:id,
        name:"UlrSubsListTableWidget",
        hideExport:Params && Params.hideExport ? Params.hideExport : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        multiselect:true,
        filter:{type : {id: "type", operator: "=", value: "subscriber"}},
        config:{
            method:function ()
            {
                return "UlrGetIspList";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id:"checked",
                    header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"cm1" }],
                    template: CellColoredCheckBoxTemplate,
                    width:40
                },
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "name",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Name"))],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        if (Params && Params.linkEdit){
                            return '<a class="webix_cell_link" href="#UlrEditSubs/_id=' + Obj._id + '" onclick="return false;">' + Obj.name + '</a>';
                        } else {
                            return Obj.name;
                        }
                    }
                },
                {
                    id: "igw_name",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","IGW name"))],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "login",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Login"))],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Date"))],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                // {
                //     id: "network_learning",
                //     header: [LangHelper.GetString("UlrModule","Network learning")],
                //     sort: "string",
                //     fillspace: 1,
                //     template: function (Obj)
                //     {
                //         var dic = IspNetworkLearningDic[Obj.network_learning];
                //         return dic ? dic.value : Obj.network_learning;
                //     }
                // },
                // {
                //     id: "state_error",
                //     header: [TooltipTemplate(LangHelper.GetString("UlrModule","State"))],
                //     sort: "string",
                //     fillspace: 1,
                //     template:function(Obj)
                //     {
                //         var running = parseInt(Obj.state_running) ? LangHelper.GetString("UlrModule","Running") : LangHelper.GetString("UlrModule","Not running");
                //
                //         var error = parseInt(Obj.state_error) ? '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Error") + '</span>' : LangHelper.GetString("UlrModule",'Ok');
                //
                //         return running + ", " + error;
                //     }
                // },
                {
                    id: "cidr_num",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","CIDRs num"))],
                    sort: "string",
                    fillspace: 1,
                    template:function(Obj)
                    {
                        return Obj.cidr_num ?  Obj.cidr_num : 0;
                    }
                },
                {
                    id: "federal_bl",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Global lists"))],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj, Common, Value)
                    {
                        return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                    }
                },
                {
                    id: "web_rule_exclude",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Exclusion list"))],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj, Common, Value)
                    {
                        return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                    }
                },
                {
                    id: "block_ipv6",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Block IPv6 traffic"))],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj, Common, Value)
                    {
                        return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                    }
                },
                {
                    id: "spoof_dns",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Spoof DNS"))],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj, Common, Value)
                    {
                        return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                    }
                },
                {
                    id: "policing_enabled",
                    header: {text: TooltipTemplate(LangHelper.GetString("UlrModule", "Policing")), colspan: 2},
                    width: 32,
                    template: function(Obj, Common, Value)
                    {
                        if(Obj && parseInt(Obj.policing_id))
                        {
                            return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                        }
                        return "";

                    }
                },
                {
                    id: "policing_url",
                    header: "",
                    width: 64,
                    template: function(Obj)
                    {
                        var href = 'UlrEditSubscriberPolicing';

                        return '<a class="webix_cell_link" href="#' + href + '/_id=' + Obj._id + '/source=UlrSubsList" onclick="return false;">' + CellEditPencilBtnTemplate() + '</a>';
                    }
                },
                {
                    id: "session_policing_enabled",
                    header: {text: TooltipTemplate(LangHelper.GetString("UlrModule", "Per-session policing")), colspan: 3},
                    width: 32,
                    template: function(Obj, Common, Value)
                    {
                        if(Obj && parseInt(Obj.session_policing_id))
                        {
                            return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                        }
                        return "";

                    }
                },
                {
                    id: "session_policing_schedule_enabled",
                    header: "",
                    width: 32,
                    template: function(Obj, Common, Value)
                    {
                        var params = {};
                        if(Obj && Obj.session_policing_schedule_enabled)
                        {
                            params.style = "color:#359DFF;";

                            if(SkinHelper.IsCubroSkin())
                            {
                                params.style = "color:var(--color-red) !important;";
                            }
                        }
                        return CellStopWatchBtnTemplate(params);
                    }
                },
                {
                    id: "session_policing_url",
                    header: "",
                    fillspace: 1,
                    template: function(Obj)
                    {
                        var href = 'UlrEditSubscriberSessionPolicing';

                        return '<a class="webix_cell_link" href="#' + href + '/_id=' + Obj._id + '/source=UlrSubsList" onclick="return false;">' + CellEditPencilBtnTemplate() + '</a>';
                    }
                },
                {
                    id: "web_rule",
                    header: TooltipTemplate(LangHelper.GetString("UlrModule", "Web rules")),
                    fillspace: 1,
                    template: function(Obj)
                    {
                        var total = Obj && Obj.total_web_rules && parseInt(Obj.total_web_rules) ? parseInt(Obj.total_web_rules) : 0;

                        if(total > 0)
                        {
                            var enabled = Obj && Obj.enabled_web_rules && parseInt(Obj.enabled_web_rules) ? parseInt(Obj.enabled_web_rules) : 0;
                            return '<a class="webix_cell_link" href="#UlrWebIpFilterRules/sub_id=' + Obj._id + '" onclick="return false;">' + enabled + ' / ' + total + '</a>';
                        }

                        return '';
                    }
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);

            if (Params && Params.columns)
                cols = cols.filter(item => Params.columns.includes(item.id));
            
            return cols;
        }(),
        rules:{},
        // filter:{
        //     lang_code:{
        //         id:"lang_code",
        //         operator:"=",
        //         value:LangHelper.GetLocale()
        //     }
        // },
        sort_map:{},
        defaultPageSize:100,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Subscribers list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrMailingListTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UlrMailingListTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "UlrGetMailingList";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditMailing/_id=' + Obj._id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "subject",
                    header: [LangHelper.GetString("UlrModule","Letter subject")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "state_code",
                    header:[TooltipTemplate(LangHelper.GetString("QoE", "State"))],
                    template:function(Obj)
                    {
                        //return QoETriggerStateCodeDic[Obj.state_code] ? QoETriggerStateCodeDic[Obj.state_code].value : Obj.state_code;

                        var stateStr = "";

                        var displayList = false;

                        if(QoETriggerStateCodeDic[Obj.state_code])
                        {
                            if(Obj.enabled)
                            {
                                // if(Obj.state_code == QoETriggerStateCodeEnum.caching ||
                                //     Obj.state_code == QoETriggerStateCodeEnum.checking ||
                                //     Obj.state_code == QoETriggerStateCodeEnum.firing)
                                // {
                                //     stateStr += '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div> <div class="bounce3"></div> </div>';
                                // }

                                var color = "green";

                                switch(Obj.state_code)
                                {
                                    case QoETriggerStateCodeEnum.scheduled_ready:
                                        color = "green";
                                        break;
                                    case QoETriggerStateCodeEnum.ready:
                                        color = "green";
                                        break;
                                    case QoETriggerStateCodeEnum.invalid:
                                    case QoETriggerStateCodeEnum.cache_error:
                                        color = "red";
                                        if(Obj.state_json || Obj.state_err)
                                            displayList = true;
                                        break;
                                    default:
                                        color = "orange"
                                }

                                stateStr += "<span class=\"status status_" + color + "\" style='cursor: pointer'>";

                                if(Obj.state_code == QoETriggerStateCodeEnum.invalid || Obj.state_code == QoETriggerStateCodeEnum.cache_error)
                                {
                                    stateStr += '<span class="webix_icon fa-exclamation-triangle"></span>';
                                }

                                stateStr += QoETriggerStateCodeDic[Obj.state_code].value + "</span>";
                            }
                            else
                            {
                                stateStr = QoETriggerStateCodeDic[Obj.state_code].value;
                            }
                        }
                        else
                        {
                            stateStr = Obj.state_code;
                        }

                        return stateStr;
                    },
                    fillspace: true,
                    sort: "string"
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "list",
                    header: "",
                    sort: false,
                    width: 32,
                    template: CellListBtnTemplate
                },
                {
                    id: "run",
                    header: "",
                    sort: false,
                    width: 32,
                    template: function(Obj){
                        return CellBoltBtnTemplate({title: LangHelper.GetString("UlrModule", "Force run mailing")})
                    }
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        // filter:{
        //     lang_code:{
        //         id:"lang_code",
        //         operator:"=",
        //         value:LangHelper.GetLocale()
        //     }
        // },
        sort_map:{},
        defaultPageSize:10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Mailing list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrMailingTemplatesListTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UlrMailingTemplatesListTableWidget",
        hideExport: Params.hideExport ? Params.hideExport : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "UlrGetMailingTemplatesList";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        if (Params && Params.columns && Params.columns.includes("name")) {
                            return Obj.name;
                        } else {
                            return '<a class="webix_cell_link" href="#UlrEditTemplateMailing/_id=' + Obj._id + '" onclick="return false;">' + Obj.name + '</a>';
                        }
                    }
                },
                {
                    id: "template",
                    header: [LangHelper.GetString("UlrModule","Template")],
                    sort: "string",
                    width:100,
                    template:CellEyeBtnTemplate
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);

            if (Params && Params.columns)
                cols = cols.filter(item => Params.columns.includes(item.id));

            return cols;
        }(),
        rules:{},
        // filter:{
        //     lang_code:{
        //         id:"lang_code",
        //         operator:"=",
        //         value:LangHelper.GetLocale()
        //     }
        // },
        sort_map:{},
        defaultPageSize:10,
        on: {},
        minHeight:Params.minHeight ? Params.minHeight : 40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Mailing templates list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrRecipientGroupTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UlrRecipientGroupTableWidget",
        hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:Params.enableCheckboxRefresh ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableLocalDataSource:Params.enableLocalDataSource ? true : false,
        hidePaginatorToolbar:true,
        config:
            {
                model:null,
                method:function ()
                {
                    return "UlrGetRecipientGroupList";
                },
                dataSource:function (FilterParams)
                {
                    if(Params&&Params.dataSource)
                        return Params.dataSource(FilterParams);
                }
            },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditRecipientGroup/_id=' + Obj._id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        // filter:{
        //     lang_code:{
        //         id:"lang_code",
        //         operator:"=",
        //         value:LangHelper.GetLocale()
        //     }
        // },
        sort_map:{},
        defaultPageSize:10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Mailing list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrRecipientContactTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UlrRecipientContactTableWidget",
        hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:Params.enableCheckboxRefresh ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableLocalDataSource:Params.enableLocalDataSource ? true : false,
        hidePaginatorToolbar:true,
        config:
            {
                model:null,
                method:function ()
                {
                    return "UlrGetIspList";
                },
                sort:{id:"cidr",dir:"desc"},
                dataSource:function (FilterParams)
                {
                    if(Params&&Params.dataSource)
                        return Params.dataSource(FilterParams);
                }
            },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    template: (Obj) => UlrRecipientGroupContactTypeDic[Obj.type].value,
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "value",
                    header: [LangHelper.GetString("UlrModule","Value")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        sort_map:{},
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Recipient group");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlWebRulesResourcesTableWidget = function (Params)
{
    let method = Params&&Params.method ? Params.method : "UlrGetResourceRulesList"
    let sort = Params&&Params.sort ? Params.sort : {id:"update_time",dir:"desc"}

    var fastresource_editable = Params && Params.fastresource_editable ? Params.fastresource_editable : false;

    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlWebRulesResourcesTableWidget",
        hideExport:false,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        rowsPerPageHide:Params.rowsPerPageHide ? true : false,
        enableLocalDataSource: Params.enableLocalDataSource ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:UlrWebRuleResourceModel,
            method:function ()
            {
                return method;
            },
            sort:sort
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "type_id",
                    header: function(){
                        var res = [LangHelper.GetString("UlrModule","Type")];

                        if(Params && Params.columns_filter)
                        {
                            res.push({
                                content: "multiSelectFilter", options: App.DicsManager.GetDicAsArray(DicsEnum.UlrResourceTypesDic), inputConfig: {suggest: {fitMaster: false}}
                            });
                        }

                        return res;
                    }(),
                    sort: "text",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        var dic = App.DicsManager.GetDic(DicsEnum.UlrResourceTypesDic);

                        return dic && dic[Obj.type_id] ? dic[Obj.type_id].value : Obj.type_id;
                    },
                    filterMap: Params && !Params.columns_filter ? null : {
                        id: "type_id",
                        operator: "in",
                        value: function(Val)
                        {
                            if(Val)
                            {
                                var arr = Val.split(",");

                                return arr;
                            }
                            return null;
                        }
                    }
                },
                {
                    id: "resource_raw",
                    header: function(){
                        var res = [LangHelper.GetString("UlrModule","Resource raw")];

                        if(Params && Params.columns_filter)
                        {
                            res.push({content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")});
                        }

                        return res;
                    }(),
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){

                        if(obj.type_id == UlrWebRuleResourcesTypesMapEnum.ulr_fastresource)
                        {
                            var cfg = JSON.parse(Helper.ReplaceAll("\n", "\\n", obj.fastresource_config));

                             var table = cfg && cfg.qoe_table ? cfg.qoe_table : ResourceImportQoETables.fullflow_agg.id;

                             if(ResourceImportQoETables[table] && ResourceImportQoETables[table].value)
                             {
                                 var icon = fastresource_editable ? CellEditPencilBtnTemplate() : CellEyeBtnTemplate();
                                 return icon + "&nbsp;" + ResourceImportQoETables[table].value;
                             }
                        }

                        var resource_name = Helper.Table.ClsfrIdToNameTemplate(value, obj.type_id == UlrWebRuleResourcesTypesMapEnum.clsfr)

                        if(obj.imported && parseInt(obj.imported))
                        {
                            var date = CellOnlyDateTemplate(new Date(obj.lifetime));
                            var title = LangHelper.GetString("UlrModule", "Imported from QoE.") + " " + (LangHelper.GetString("UlrModule", "Will be deleted after [DATE]").replace("[DATE]", date));
                            resource_name = CellDownloadBtnTemplate({default_cursor: true}) + "&nbsp;" + resource_name;
                            resource_name = "<span title='" + title + "'>" + resource_name + "</span>";
                        }

                        var typesDic = App.DicsManager.GetDic(DicsEnum.UlrResourceTypesDic);

                        if(typesDic && typesDic[obj.type_id] && typesDic[obj.type_id].value == UlrWebRuleResourcesTypesEnum.clsfr.toUpperCase() && App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.ulr_hosts_list))
                            resource_name =  CellHostButtonTemplate() + "&nbsp;" + resource_name;



                        return resource_name;
                    }
                },
                {
                    id: "resource_validated",
                    header: function(){
                        var res = [LangHelper.GetString("UlrModule","Resource validated")];

                        if(Params && Params.columns_filter)
                        {
                            res.push({content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")});
                        }

                        return res;
                    }(),
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "state_valid",
                    header: [LangHelper.GetString("UlrModule","Status")],
                    sort: "text",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        var error = parseInt(Obj.state_error);
                        var valid = parseInt(Obj.state_valid);

                        if(error)
                            return '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Error") + '</span>';

                        if(valid == UlrStateValidEnum.valid)
                            return LangHelper.GetString("UlrModule","Valid");

                        if(valid == UlrStateValidEnum.invalid)
                            return '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Invalid") + '</span>';

                        if(valid == UlrStateValidEnum.undefined)
                            return ""; //LangHelper.GetString("UlrModule","No validation");

                        return "";
                    }
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"=",
            //     value:LangHelper.GetLocale()
            // }
        },
        sort_map:{},
        defaultPageSize:Params && Params.defaultPageSize ? Params.defaultPageSize : -10,
        on:{},
        minHeight:40
    };

    if(Params && Params.dataSource)
    {
        params.config.dataSource = function(FilterParams)
        {
          return Params.dataSource(FilterParams);
        };
    }

    if(Params && Params.rule_id)
    {
        params.filter.rule_id = {
            id: "rule_id",
            operator: "=",
            value: Params.rule_id
        };
    }

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);

        };

        params.on.onCheck = function(row, column, state)
        {
            Params.onItemClick({
                row: row,
                column: column
            });
        };
    }

    if(Params&&Params.addCols)
    {
        Params.addCols.forEach(col => {
            params.columns.splice(col.start, col.deleteCount, col.item);
        })
    }

    if(Params && Params.onExport && typeof Params.onExport == "function")
    {
        params.onExport = function(filename, type, callback)
        {
            Params.onExport(filename, type, callback);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlWebRulesIspsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlWebRulesResourcesTableWidget",
        hideExport:true,
        isLocal: true,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:null,
            method:function ()
            {
                return null;
            },
            sort:{id:"id",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "value",
                    header: [LangHelper.GetString("UlrModule", Params.IspType == IspsSubscribersListTypes.isp ? "ISP" : "Subscriber")],
                    sort: "text",

                    fillspace: 1
                },
                {
                    id: "igw_name",
                    header: [LangHelper.GetString("UlrModule","IGW name")],
                    sort: "string",
                    fillspace: 5
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
        },
        sort_map:{},
        defaultPageSize:-10,
        on:{},
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlActionsLogTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlActionsLogTableWidget",
        hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:null,
            method:function ()
            {
                return "UlrGetActionsLogReport";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                }
            ]);

            if(Params&&Params.global)
            {
                cols.push.apply(cols,[
                    {
                        id: "type_code",
                        header: [LangHelper.GetString("UlrModule","Type")],
                        sort: "string",
                        fillspace: 1,
                        template:function (Obj)
                        {
                            var title = Obj.type_code && UlrUsersActionsLogsCodesDic[Obj.type_code] ? UlrUsersActionsLogsCodesDic[Obj.type_code].value : (Obj.type_code ? Obj.type_code : "");
                            //UlrRulesTypesCodesListsControllersMap

                            var controller = UlrUsersActionsLogTypesCodesListsControllersMap[Obj.type_code] ? UlrUsersActionsLogTypesCodesListsControllersMap[Obj.type_code] : "";

                            if(controller)
                                return '<a class="webix_cell_link" href="#'+controller+'" onclick="return false;">' + title + '</a>';
                            else
                                return title;
                        }
                    },
                    {
                        id: "row_id",
                        header: [LangHelper.GetString("UlrModule","Id")],
                        template:function (Obj)
                        {
                            if(!(Obj.row_id > 0))
                                return "";

                            var id = Helper.StripHtml(Obj.row_id);

                            var controller = UlrUsersActionsLogCodesControllersMap[Obj.type_code] ? UlrUsersActionsLogCodesControllersMap[Obj.type_code] : "";

                            if(controller)
                                return '<a class="webix_cell_link" href="#'+controller+'/_id=' + id + '" onclick="return false;">' + id + '</a>';
                            else
                                return Obj.row_id;

                        },
                        sort: "string",
                        fillspace: 0,
                        width:80
                    },
                    {
                        id: "name",
                        header: [LangHelper.GetString("UlrModule","Name")],
                        template:function (Obj)
                        {
                            return Obj.name ? Obj.name : "";

                        },
                        sort: "string"
                    }
                ]);
            }

            cols.push.apply(cols,[
                {
                    id: "update_user",
                    header: [LangHelper.GetString("UlrModule","User")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "action",
                    header: [LangHelper.GetString("UlrModule","Action")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "value_new",
                    header: [LangHelper.GetString("UlrModule","New value")],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj)
                    {
                        if (Obj.type_code && Obj.type_code === UlrUsersActionsLogsCodesDic.node.id && Obj.action === "Trace IP state changed.")
                        {
                            var format =  webix.Date.dateToStr("%d.%m.%Y %H:%i");
                            let value_new_split = Obj.value_new.split(". ");

                            const index_start_time = value_new_split.findIndex(element => element.includes("Starts in"));
                            const index_end_time = value_new_split.findIndex(element => element.includes("Ends in"));

                            if (index_start_time != -1)
                            {
                                let start_time = value_new_split[index_start_time].split(" ").pop().replace(/\.$/, "");

                                value_new_split[index_start_time] = `${LangHelper.GetString("UlrModule", "Starts in")} ${format(new Date(start_time))}`;
                            }

                            if (index_end_time != -1)
                            {
                                let end_time = value_new_split[index_end_time].split(" ").pop().replace(/\.$/, "");

                                value_new_split[index_end_time] = `${LangHelper.GetString("UlrModule", "Ends in")} ${format(new Date(end_time))}`;
                            }

                            return value_new_split.join(". ")
                        }
                        else if(Obj.type_code && Obj.type_code == UlrUsersActionsLogsCodesDic.ulr_fastresource_custom_prtcls.id && Obj.action === "Configuration changed.")
                        {
                            return CellEyeBtnTemplate();
                        }

                        return Obj.value_new;
                    }
                },
                {
                    id: "value_old",
                    header: [LangHelper.GetString("UlrModule","Old value")],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj)
                    {
                        if (Obj.type_code && Obj.type_code === UlrUsersActionsLogsCodesDic.node.id && Obj.action === "Trace IP state changed.")
                        {
                            var format =  webix.Date.dateToStr("%d.%m.%Y %H:%i");
                            let value_old_split = Obj.value_old.split(". ");

                            const index_start_time = value_old_split.findIndex(element => element.includes("Starts in"));
                            const index_end_time = value_old_split.findIndex(element => element.includes("Ends in"));

                            if (index_start_time != -1)
                            {
                                let start_time = value_old_split[index_start_time].split(" ").pop().replace(/\.$/, "");

                                value_old_split[index_start_time] = `${LangHelper.GetString("UlrModule", "Starts in")} ${format(new Date(start_time))}`;
                            }

                            if (index_end_time != -1)
                            {
                                let end_time = value_old_split[index_end_time].split(" ").pop().replace(/\.$/, "");

                                value_old_split[index_end_time] = `${LangHelper.GetString("UlrModule", "Ends in")} ${format(new Date(end_time))}`;
                            }

                            return value_old_split.join(". ")
                        }
                        else if(Obj.type_code && Obj.type_code == UlrUsersActionsLogsCodesDic.ulr_fastresource_custom_prtcls.id && Obj.action === "Configuration changed.")
                        {
                            return CellEyeBtnTemplate();
                        }

                        return Obj.value_old;
                    }
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params.filter ? Params.filter : null,
        defaultPageSize:-10,
        minHeight:40,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlIgwsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlIgwsTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.name = Params&&Params.name?Params.name:"";

                this.mode_id = Params&&Params.mode_id?Params.mode_id:0;

                this.mode = Params&&Params.mode?Params.mode:"";

                this.vchannel_type = Params && Params.vchannel_type ? parseInt(Params.vchannel_type) : 1;

                this.vchannel_type_str = Params && Params.vchannel_type_str ? Params.vchannel_type_str : "";

                this.update_time = Params&&Params.update_time?Params.update_time:null;
            },
            method:function ()
            {
                return "UlrGetIgwList";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditIgw/_id=' + Obj._id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "mode",
                    header: [LangHelper.GetString("UlrModule","Mode")],
                    sort: "string",
                    template:function(Obj)
                    {
                        return Obj.mode ? Obj.mode : Obj.mode_id;
                    },
                    fillspace: 1
                },
                {
                    id: "vchannel_type",
                    header: [LangHelper.GetString("UlrModule","Vchannel mode")],
                    sort: "string",
                    template:function(Obj)
                    {
                        return Obj.vchannel_type_str ? Obj.vchannel_type_str : Obj.vchannel_type;
                    },
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            lang_code:{
                id:"lang_code",
                operator:"=",
                value:LangHelper.GetLocale()
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Sites list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlIgwsQoEsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlIgwsQoEsTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.name = Params&&Params.name?Params.name:"";

                this.dpiui2_dest = Params&&Params.dpiui2_dest?Params.dpiui2_dest:"";
            },
            method:function ()
            {
                return "UlrGetIgwList";
            },
            sort:{id:"name",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditIgw/_id=' + Obj._id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "dpiui2_dest",
                    header: [LangHelper.GetString("UlrModule","QoE url")],
                    sort: "string",
                    template:function (Obj)
                    {
                        var r = Obj&&Obj.dpiui2_dest ? Obj.dpiui2_dest : "";

                        if(r)
                        {
                            if(!r.startsWith("https://") || !r.startsWith("http://"))
                                r = "https://" + r;

                        }

                        return r;
                    },
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    width:32
                },
                {
                    id: "monitor",
                    header:"",
                    sort: false,
                    width:32,
                    template:function(Obj)
                    {
                        return Obj && Obj.dpiui2_dest ? CellMonitorBtnTemplate(Obj) :"";
                    }
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            lang_code:{
                id:"lang_code",
                operator:"=",
                value:LangHelper.GetLocale()
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","IGWs QoEs list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlIgwsNodesTableWidget = function (Params)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    var params = {
        id:id,
        name:"UrlIgwsNodesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        multiselect:true,
        config:
        {
            method:function ()
            {
                return "UlrGetIgwsNodesList";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id:"checked",
                    header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:id+"MasterCheckBox" }],
                    template: CellColoredCheckBoxTemplate,
                    width:40
                },
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template: function (Obj) {
                        return Obj.name + ` (${Obj.hardware_id})`
                    }
                },
                {
                    id: "igw_name",
                    header: [LangHelper.GetString("UlrModule","IGW name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditIgw/_id=' + Obj.igw_id + '" onclick="return false;">' + Obj.igw_name + '</a>';
                    }
                },
                {
                    id: "hardware_name",
                    header: [LangHelper.GetString("UlrModule","DPI hardware name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "bridges",
                    header: [LangHelper.GetString("UlrModule","Bridges")],
                    sort: "string",
                    fillspace: 1
                    // width: 64
                },
                {
                    id: "ipfix_number",
                    header: [LangHelper.GetString("UlrModule","Ipfix number")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "bypass",
                    header: [LangHelper.GetString("UlrModule","Bypass")],
                    sort: "string",
                    template:function(Obj)
                    {
                        return CellBypassStatusTemplate(Obj);
                    },
                    fillspace: 2
                },
                {
                    id: "trace_ip_state",
                    header: [LangHelper.GetString("UlrModule", "Trace IP")],
                    sort: "string",
                    fillspace: 1.5,
                    template: function(Obj)
                    {
                        var color = "green";
                        var state = Obj.trace_ip_state ? JSON.parse(Obj.trace_ip_state) : {};
                        var text = TooltipTemplate(LangHelper.GetString("UlrModule", "Disabled") + ". ");

                        if(state.enabled)
                        {
                            color = "yellow";
                            text = TooltipTemplate(LangHelper.GetString("UlrModule", "Enabled") + ". " + state.cfg_txt);
                        }
                        else if(state.error_code || state.error_msg)
                        {
                            color = "red";
                            text = TooltipTemplate(LangHelper.GetString("UlrModule", "Error") + ". " + state.error_msg);
                        }

                        return '<span class="webix_icon fa-lightbulb webix_icon_bypass bold ' + color + '" style="cursor:pointer;"></span>'
                            + text;
                    }
                },
                {
                    id: "trace_ip_state_shedule",
                    header:"",
                    sort: false,
                    fillspace: 1.5,
                    template: function(Obj)
                    {
                        if (Obj.trace_ip_state)
                        {
                            const state = Obj.trace_ip_state ? JSON.parse(Obj.trace_ip_state) : {};
                            const format =  webix.Date.dateToStr("%Y-%m-%d %H:%i");

                            if (state.enabled && !state.start_time && !state.end_time)
                            {
                                return LangHelper.GetString("UlrModule","End trace ip not set")
                            }
                            else if (state.start_time)
                            {
                                return LangHelper.GetString("UlrModule","Starts in") + format(new Date(state.start_time));
                            }
                            else if (!state.start_time && state.end_time)
                            {
                                return "<span class=\"webix_icon fa-record-vinyl\" style='color: red; cursor:pointer;'></span>" + LangHelper.GetString("UlrModule","Ends in") + format(new Date(state.end_time));
                            }
                            else if (!state.enabled && !state.start_time && !state.end_time)
                            {
                                return LangHelper.GetString("UlrModule","Start trace ip not set")
                            }
                        }

                        return LangHelper.GetString("UlrModule","Start trace ip not set")
                    }
                },
                {
                    id: "info",
                    header: [LangHelper.GetString("UlrModule","Info")],
                    sort: "string",
                    template:CellInfoBtnTemplate,
                    tooltip:function (Obj)
                    {
                        var s = "";

                        if(Obj && Obj.info)
                        {

                            var info = JSON.parse(Obj.info);

                            if(info && info.vchannels && info.vchannels.length)
                            {
                                s += "Bridges (vhannels):<br/>";

                                info.vchannels.forEach(function (Item, I)
                                {
                                    s += Item.id + ": " + Item.value + "<br/>";
                                });

                                s += "<br/>";
                            }

                            if(info && (info.in_dev || info.out_dev))
                            {
                                s += "Devices:<br/>";
                            }

                            if(info && info.in_dev)
                            {
                                s += "in_dev: " + info.in_dev + "<br/>";
                            }

                            if(info && info.out_dev)
                            {
                                s += "out_dev: " + info.out_dev + "<br/>";
                            }
                        }

                        return s;
                    },
                    width:48
                },
                {
                    width:8
                },
                {
                    id: "tools",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellToolsBtnTemplate
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    width:8
                },
                {
                    id: "monitor",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellMonitorBtnTemplate
                },
                {
                    id: "logs",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellLogsBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        sortDisabledColumns:["spacer", "tools", "monitor", "bypass", "logs", "info"],
        rules:{},
        // filter:{
        //     lang_code:{
        //         id:"lang_code",
        //         operator:"=",
        //         value:LangHelper.GetLocale()
        //     }
        // },
        sort_map:{},
        defaultPageSize:-100,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","IGWs nodes list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlIgwsNodesListSelectWidget = function (Params)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    var params = {
        id:id,
        name:"UrlIgwsNodesListSelectWidget",
        hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        //multiselect:true,
        config:
            {
                method:function ()
                {
                    return "UlrGetIgwsNodesList";
                },
                sort:{id:"update_time",dir:"desc"}
            },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "hardware_id",
                    header: [LangHelper.GetString("UlrModule","ID")],
                    sort: "string",
                    fillspace: 0,
                    width: 40
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "igw_name",
                    header: [LangHelper.GetString("UlrModule","IGW name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        sortDisabledColumns:["spacer", "tools", "monitor", "bypass"],
        rules:{},
        // filter:{
        //     lang_code:{
        //         id:"lang_code",
        //         operator:"=",
        //         value:LangHelper.GetLocale()
        //     }
        // },
        sort_map:{},
        defaultPageSize:-100,
        on: {},
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlPCAPHwListSelectWidget = function (Params)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    var params = {
        id:id,
        name:"UrlPCAPHwListSelectWidget",
        hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:
            {
                method:function ()
                {
                    return "GetPCAPHardwaresList";
                },
                sort:{id:"hardware_id",dir:"desc"}
            },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "hardware_id",
                    header: [LangHelper.GetString("UlrModule","ID")],
                    sort: "string",
                    fillspace: 0,
                    width: 60
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        sortDisabledColumns:["space"],
        rules:{},
        sort_map:{},
        defaultPageSize:-100,
        on: {},
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrIspsTableWidget = function (Params)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    var params = {
        id:id,
        name:"UlrIspsTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        multiselect:true,
        filter:{type : {id: "type", operator: "=", value: "isp"}},
        config:{
            method:function ()
            {
                return "UlrGetIspList";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id:"checked",
                    header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"cm1" }],
                    template: CellColoredCheckBoxTemplate,
                    width:40
                },
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "name",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Name"))],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditIsp/_id=' + Obj._id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "igw_name",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","IGW name"))],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Date"))],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                // {
                //     id: "network_learning",
                //     header: [LangHelper.GetString("UlrModule","Network learning")],
                //     sort: "string",
                //     fillspace: 1,
                //     template: function (Obj)
                //     {
                //         var dic = IspNetworkLearningDic[Obj.network_learning];
                //         return dic ? dic.value : Obj.network_learning;
                //     }
                // },
                // {
                //     id: "state_error",
                //     header: [TooltipTemplate(LangHelper.GetString("UlrModule","State"))],
                //     sort: "string",
                //     fillspace: 1,
                //     template:function(Obj)
                //     {
                //         var running = parseInt(Obj.state_running) ? LangHelper.GetString("UlrModule","Running") : LangHelper.GetString("UlrModule","Not running");
                //
                //         var error = parseInt(Obj.state_error) ? '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Error") + '</span>' : LangHelper.GetString("UlrModule",'Ok');
                //
                //         return running + ", " + error;
                //     }
                // },
                {
                    id: "cidr_num",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","CIDRs num"))],
                    sort: "string",
                    fillspace: 1,
                    template:function(Obj)
                    {
                        return Obj.cidr_num ?  Obj.cidr_num : 0;
                    }
                },
                {
                    id: "federal_bl",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Global lists"))],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj, Common, Value)
                    {
                        return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                    }
                },
                {
                    id: "web_rule_exclude",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Exclusion list"))],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj, Common, Value)
                    {
                        return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                    }
                },
                {
                    id: "block_ipv6",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Block IPv6 traffic"))],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj, Common, Value)
                    {
                        return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                    }
                },
                {
                    id: "spoof_dns",
                    header: [TooltipTemplate(LangHelper.GetString("UlrModule","Spoof DNS"))],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj, Common, Value)
                    {
                        return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                    }
                },
                {
                    id: "policing_enabled",
                    header: {text: TooltipTemplate(LangHelper.GetString("UlrModule", "Policing")), colspan: 2},
                    width: 32,
                    template: function(Obj, Common, Value)
                    {
                        if(Obj && parseInt(Obj.policing_id))
                        {
                            return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                        }
                        return "";

                    }
                },
                {
                    id: "policing_url",
                    header: "",
                    width: 64,
                    template: function(Obj)
                    {
                        var href = 'UlrEditAppPolicing';

                        return '<a class="webix_cell_link" href="#' + href + '/_id=' + Obj._id + '/source=UlrIspsList" onclick="return false;">' + CellEditPencilBtnTemplate() + '</a>';
                    }
                },
                {
                    id: "session_policing_enabled",
                    header: {text: TooltipTemplate(LangHelper.GetString("UlrModule", "Per-session policing")), colspan: 3},
                    width: 32,
                    template: function(Obj, Common, Value)
                    {
                        if(Obj && parseInt(Obj.session_policing_id))
                        {
                            return CellCheckboxSwitchOnOffTemplate(Obj, Common, Value);
                        }
                        return "";
                    }
                },
                {
                    id: "session_policing_schedule_enabled",
                    header: "",
                    width: 32,
                    template: function(Obj, Common, Value)
                    {
                        var params = {};
                        if(Obj && Obj.session_policing_schedule_enabled)
                        {
                            params.style = "color:#359DFF;";
                            if(SkinHelper.IsCubroSkin())
                            {
                                params.style = "color:var(--color-red) !important;";
                            }
                        }
                        return CellStopWatchBtnTemplate(params);
                        // if(Obj && parseInt(Obj.session_policing_schedule_enabled))
                        // {
                        //
                        // }
                    }
                },
                {
                    id: "session_policing_url",
                    header: "",
                    fillspace: 1,
                    template: function(Obj)
                    {
                        var href = 'UlrEditIspSessionPolicing';

                        return '<a class="webix_cell_link" href="#' + href + '/_id=' + Obj._id + '/source=UlrIspsList" onclick="return false;">' + CellEditPencilBtnTemplate() + '</a>';
                    }
                },
                {
                    id: "web_rule",
                    header: TooltipTemplate(LangHelper.GetString("UlrModule", "Web rules")),
                    fillspace: 1,
                    template: function(Obj)
                    {
                        var total = Obj && Obj.total_web_rules && parseInt(Obj.total_web_rules) ? parseInt(Obj.total_web_rules) : 0;

                        if(total > 0)
                        {
                            var enabled = Obj && Obj.enabled_web_rules && parseInt(Obj.enabled_web_rules) ? parseInt(Obj.enabled_web_rules) : 0;
                            return '<a class="webix_cell_link" href="#UlrWebIpFilterRules/isp_id=' + Obj._id + '" onclick="return false;">' + enabled + ' / ' + total + '</a>';
                        }

                        return '';

                    }
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        // filter:{
        //     lang_code:{
        //         id:"lang_code",
        //         operator:"=",
        //         value:LangHelper.GetLocale()
        //     }
        // },
        sort_map:{},
        defaultPageSize:100,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Channels management");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlIspDpiNodesTableWidget = function (Params, GetColumnsOnly, ColumnsNum, SubsMode)
{
    var columns = function ()
    {
        var colsNum = ColumnsNum ? ColumnsNum : 0;

        var cols = [];

        var header = LangHelper.GetString("UlrModule","Bridges") + " / " + LangHelper.GetString("UlrModule","Channels");

        if(SubsMode)
            header = LangHelper.GetString("UlrModule","Nodes")

        cols.push({
            id: "node_name",
            header: [{text:header}],
            sort: "string",
            fillspace: 1,
            minWidth:160,
            template:function (Obj)
            {
                return CellInfoBtnTemplate() + "&nbsp;" + Obj.node_name;
            },
            tooltip:function (Obj)
            {
                var s = "Bridges (vhannels):<br/>";

                Object.keys(Obj).forEach(function (Key)
                {
                    var i = 0;

                    if(Key == "bridge_" + i)
                    {
                        if(parseInt(Obj["bridge_" + i]))
                        {
                            s += Obj["bridge_" + i + "_id"] + ": " + Obj["bridge_" + i + "_name"] + "<br/>";
                        }

                        i++;
                    }
                });

                s += "<br/>";

                return s;
            }
        });

        for (var i = 0; i < colsNum; i++)
        {
            cols.push({
                id: "bridge_"+i,
                header:[{text: (SubsMode ? "" : "" + (i + 1)), content:"masterCheckbox", contentId: i + "mc",  css:"hcell_ckeckbox cell_align_center"}],
                sort: false,
                // css:{'text-align':'center'},
                css:'cell_align_center',
                template:function (Obj, Common, Value)
                {
                    if(typeof Obj[this.id] !== "undefined")
                        return CellCheckBoxTemplate(Obj, Common, Value);

                    return "";
                },
                tooltip:function (Obj)
                {
                    var s = "";

                    var id = this.column && this.column.id ? this.column.id : 0;

                    if(typeof Obj[id] !== "undefined")
                    {
                        s += "Bridge " + Obj[id + "_id"] + ": " + Obj[id + "_name"] + "<br/>";

                        s += "<br/>";
                    }

                    return s;
                }
            });
        }

        cols.push({id:"space", header:"", sort: false, fillspace: 2});

        return cols;
    }();

    if(GetColumnsOnly)
    {
        return columns;
    }

    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlIspDpiNodesTableWidget",
        hideExport:true,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:null,
            method:function ()
            {
                return null;
            },
            sort:{id:"_id",dir:"desc"}
        },
        columns: columns,
        rules:{},
        filter:{
            lang_code:{
                id:"lang_code",
                operator:"=",
                value:LangHelper.GetLocale()
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        leftSplit:1,
        on:{},
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlIspNetworksTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlIspNetworksTableWidget",
        hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        // hidePaginatorToolbar:true,
        enableCheckboxRefresh:true,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableLocalDataSource:Params.enableLocalDataSource ? true : false,
        config:
        {
            model:null,
            method:function ()
            {
                return "UlrGetIspNetworksList";
            },
            sort:{id:"_id",dir:"desc"},
            dataSource:function (FilterParams)
            {
                if(Params&&Params.dataSource)
                    return Params.dataSource(FilterParams);
            }
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "cidr",
                    header: [LangHelper.GetString("UlrModule","CIDR")],
                    sort: "text",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        var r = "";

                        if(Obj.cidr_ipv4)
                            r = Obj.cidr_ipv4
                        else if(Obj.cidr_ipv6)
                            r = Obj.cidr_ipv6
                        else if(Obj.regex)
                            r = Obj.regex

                        return r;
                    }
                },
                {
                    id: "create_type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "text",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.create_type == UlrIspNetworkCreateTypesEnum.auto ? LangHelper.GetString("UlrModule","Auto") : LangHelper.GetString("UlrModule","Manual");
                    }
                },
                {
                    id: "type",
                    header: [LangHelper.GetString("UlrModule","Prefix type")],
                    sort: "text",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        var dic = PrefixTypeDic[Obj.type_id];
                        return dic ? dic.value : Obj.type_id;
                    }
                },
                {
                    id: "bgp_diff_autoapply",
                    header: [LangHelper.GetString("UlrModule", "BGP diff auto apply")],
                    sort: "text",
                    fillspace: 1,
                    template: function (Obj) {
                        if(Obj.type_id == PrefixTypeMapEnum.BGP)
                        {
                            return parseInt(Obj.bgp_diff_autoapply) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");
                        }

                        return "";
                    }
                },
                // {
                //     id: "bgp_send_notification",
                //     header: [LangHelper.GetString("UlrModule", "BGP diff notification")],
                //     sort: "text",
                //     fillspace: 1,
                //     template: function (Obj) {
                //
                //         var arr = [];
                //
                //         Obj.bgp_send_notification.split(",").forEach(function(Val)
                //         {
                //             if(UlrBgpDiffNotifications[Val] && UlrBgpDiffNotifications[Val].value)
                //             {
                //                 arr.push(UlrBgpDiffNotifications[Val].value)
                //             }
                //         });
                //
                //         return arr.join(", ");
                //     }
                // },
                {
                    id: "protocol_version",
                    header: [LangHelper.GetString("UlrModule", "IP version")],
                    sort: "text",
                    fillspace: 1,
                    template: function (Obj) {

                        var res = "";

                        if(Obj && Obj.protocol_version && Obj.type_id == PrefixTypeMapEnum.BGP)
                        {
                            res = UlrIpProtocolVersionDic[Obj.protocol_version] && UlrIpProtocolVersionDic[Obj.protocol_version].value ? UlrIpProtocolVersionDic[Obj.protocol_version].value : "";
                        }

                        return res;
                    }
                },
                {
                    id: "state",
                    header: [LangHelper.GetString("UlrModule","State")],
                    sort: "text",
                    fillspace: 1,
                    template:function(Obj)
                    {
                        if(Obj.is_added)
                            return LangHelper.GetString("UlrModule","Just added")

                        var bind = Obj.state_bind ? LangHelper.GetString("UlrModule","Binded") : LangHelper.GetString("UlrModule","Unbinded");

                        var valid = Obj.state_valid == 2 ? LangHelper.GetString("UlrModule","Valid") : (Obj.state_valid == 1 ? '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Invalid") + '</span>' : "");

                        return bind + (valid ? ", " + valid : "");
                    }
                },
                {
                    id: "list",
                    header: "",
                    sort: "false",
                    width: 32,
                    template: function(Obj)
                    {
                        if(Obj.type_id == PrefixTypeMapEnum.BGP)
                        {
                            return CellListBtnTemplate();
                        }

                        return "";
                    }
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{},
        sort_map:{},
        defaultPageSize:-10,
        on:{},
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };

        params.on.onCheck = function(row, column, state)
        {
            Params.onItemClick({
                row: row,
                column: column
            });
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlAppPolicingsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlIspPolicingsProfilesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.isp_id = Params&&Params.isp_id?Params.isp_id:0;

                this.igw_id_for_ui = Params&&Params.igw_id_for_ui?Params.igw_id_for_ui:0;

                this.igw_name_for_ui = Params&&Params.igw_name_for_ui?Params.igw_name_for_ui:0;

                this.enabled = Params&&Params.enabled?Params.enabled:0;

                this.name = Params&&Params.name?Params.name:"";

                this.type_id = Params&&Params.type_id?Params.type_id:0;

                this.type = Params&&Params.type?Params.type:"";

                this.description = Params&&Params.description?Params.description:"";

                this.update_time = Params&&Params.update_time?Params.update_time:null;
            },
            method:function ()
            {
                return "UlrGetIspPolicingList";
            },
            sort:{id:"name",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:function (Obj,Commmon, Value)
                    {
                        return parseInt(Obj.type_id) ? CellCheckboxSwitchOnOffTemplate(Obj,Commmon, Value) : "";
                    }
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        var href = 'UlrEditAppPolicing';
                        if(Params && Params.isp_type)
                        {
                            if(Params.isp_type == "subscriber")
                            {
                                href = 'UlrEditSubscriberPolicing';
                            }
                        }

                        return '<a class="webix_cell_link" href="#' + href + '/_id=' + Obj.isp_id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "igw_name_for_ui",
                    header: [LangHelper.GetString("UlrModule","IGW name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    template:function(Obj)
                    {
                        return Obj.type ? Obj.type : (Obj.type_id ? Obj.type_id : "");
                    },
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "description",
                    header: [LangHelper.GetString("UlrModule","Description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:function (Obj)
                    {
                        return parseInt(Obj.type_id) ? CellTrashBtnTemplate(Obj) : "";
                    }
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            lang_code:{
                id:"lang_code",
                operator:"equal or null",
                value:LangHelper.GetLocale()
            },
            isp_type:{
                id:"isp_type",
                operator:"=",
                value: Params && Params.isp_type ? Params.isp_type : UlrPolicingTypeEnum.isp
            }
        },
        sort_map:{},
        defaultPageSize:100,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Policing profiles");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrIgwPolicingsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlIgwPolicingsProfilesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.igw_id = Params&&Params.igw_id?Params.igw_id:0;

                this.enabled = Params&&Params.enabled?Params.enabled:0;

                this.name = Params&&Params.name?Params.name:"";

                this.type_id = Params&&Params.type_id?Params.type_id:0;

                this.type = Params&&Params.type?Params.type:"";

                this.description = Params&&Params.description?Params.description:"";

                this.update_time = Params&&Params.update_time?Params.update_time:null;
            },
            method:function ()
            {
                return "UlrGetIgwPolicingList";
            },
            sort:{id:"name",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:function (Obj,Commmon, Value)
                    {
                        return parseInt(Obj.type_id) ? CellCheckboxSwitchOnOffTemplate(Obj,Commmon, Value) : "";
                    }
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditIgwPolicing/_id=' + Obj.igw_id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    template:function(Obj)
                    {
                        return Obj.type ? Obj.type : (Obj.type_id ? Obj.type_id : "");
                    },
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "description",
                    header: [LangHelper.GetString("UlrModule","Description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:function (Obj)
                    {
                        return parseInt(Obj.type_id) ? CellTrashBtnTemplate(Obj) : "";
                    }
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            lang_code:{
                id:"lang_code",
                operator:"equal or null",
                value:LangHelper.GetLocale()
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","IGW Policing profiles");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlIspSessionPolicingsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlIspSessionPolicingsTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.isp_id = Params&&Params.isp_id?Params.isp_id:0;

                this.igw_id_for_ui = Params&&Params.igw_id_for_ui?Params.igw_id_for_ui:0;

                this.igw_name_for_ui = Params&&Params.igw_name_for_ui?Params.igw_name_for_ui:0;

                this.enabled = Params&&Params.enabled?Params.enabled:0;

                this.name = Params&&Params.name?Params.name:"";

                this.description = Params&&Params.description?Params.description:"";

                this.update_time = Params&&Params.update_time?Params.update_time:null;
            },
            method:function ()
            {
                return "UlrGetIspSessionPolicingList";
            },
            sort:{id:"name",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:function (Obj,Commmon, Value)
                    {
                        return parseInt(Obj._id) ? CellCheckboxSwitchOnOffTemplate(Obj,Commmon, Value) : "";
                    }
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        var href = ControllersEnum.UlrEditIspSessionPolicing;
                        if(Params && Params.isp_type)
                        {
                            if(Params.isp_type == "subscriber")
                            {
                                href = ControllersEnum.UlrEditSubscriberSessionPolicing;
                            }
                        }

                        return '<a class="webix_cell_link" href="#' + href + '/_id=' + Obj.isp_id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "igw_name_for_ui",
                    header: [LangHelper.GetString("UlrModule","IGW name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "description",
                    header: [LangHelper.GetString("UlrModule","Description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:function (Obj)
                    {
                        return parseInt(Obj.type_id) ? CellTrashBtnTemplate(Obj) : "";
                    }
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            isp_type:{
                id:"isp_type",
                operator:"=",
                value: Params && Params.isp_type ? Params.isp_type : UlrPolicingTypeEnum.isp
            }
        },
        sort_map:{},
        defaultPageSize:100,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Policing profiles");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlAsnRuleListTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlAsnRuleListTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this.rule_id = Params&&Params.rule_id?Params.rule_id:0;

                this.rule_enabled = Params&&Params.rule_enabled?Params.rule_enabled:0;

                this.enabled = Params&&Params.enabled?Params.enabled:0;

                this.as_number = Params&&Params.as_number?Params.as_number:0;

                this.name = Params&&Params.name?Params.name:"";

                this.description_public = Params&&Params.description_public?Params.description_public:"";

                this.resource = Params&&Params.resource?Params.resource:"";

                this.mode = Params&&Params.mode?Params.mode:"";

                this.update_time = Params&&Params.update_time?Params.update_time:null;

                this.create_time = Params&&Params.create_time?Params.create_time:null;
            },
            method:function ()
            {
                return "UlrGetASResourcesList";
            },
            sort:{id:"name",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "rule_enabled",
                    header: "",
                    sort: false,
                    template:function (Obj)
                    {
                        var s = parseInt(Obj.rule_enabled) && parseInt(Obj.enabled) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");

                        return CellAnyIconBtnTemplate("lightbulb " + (parseInt(Obj.rule_enabled) && parseInt(Obj.enabled) ? "green" : "red")) + " " + s;
                    }
                },
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","ID")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditAsnDscpRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                    }
                },
                {
                    id: "resource",
                    header: [LangHelper.GetString("UlrModule","Resource")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "as_number",
                    header: [LangHelper.GetString("UlrModule","AS number")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditAsnDscpRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.as_number + '</a>';
                    }
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditAsnDscpRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "description_public",
                    header: [LangHelper.GetString("UlrModule","Description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "mode",
                    header: [LangHelper.GetString("UlrModule","Mode")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{},
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","AS resource list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

const UlrAsnListTableWidget = function (Params) {
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UlrAsnListTableWidget",
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this.rule_id = Params&&Params.rule_id?Params.rule_id:0;

                this.enabled = Params&&Params.enabled?Params.enabled:0;

                this.as_number = Params&&Params.as_number?Params.as_number:0;

                this.name = Params&&Params.name?Params.name:"";

                this.description_public = Params&&Params.description_public?Params.description_public:"";

                this.mode = Params&&Params.mode?Params.mode:"";

                this.update_time = Params&&Params.update_time?Params.update_time:null;
            },
            method:function ()
            {
                return "UlrGetASList";
            },
            sort:{id:"name",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header: "",
                    sort: false,
                    template:function (Obj)
                    {
                        var s = parseInt(Obj.enabled) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");

                        return CellAnyIconBtnTemplate("lightbulb " + (parseInt(Obj.enabled) ? "green" : "red")) + " " + s;
                    }
                },
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","ID")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditAsnDscpRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                    }
                },
                {
                    id: "as_number",
                    header: [LangHelper.GetString("UlrModule","AS number")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditAsnDscpRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.as_number + '</a>';
                    }
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditAsnDscpRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.name + '</a>';
                    }
                },
                {
                    id: "description_public",
                    header: [LangHelper.GetString("UlrModule","Description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "mode",
                    header: [LangHelper.GetString("UlrModule","Mode")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{},
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","AS list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
}

var UrlAppDSCPsTableWidget = function (Params)
{
    var templateFunc = function(obj, isTooltip = false)
    {
        var is_group = parseInt(obj.is_group);
        var is_custom_group = parseInt(obj.is_custom_group);

        if(is_group)
        {
            if(obj && obj.group_name_json)
            {
                var grName = JSON.parse(obj.group_name_json),
                    locale = LangHelper.GetLocale();

                if(grName && grName[locale])
                {
                    return grName[locale];
                }
                else if(Object.keys(grName).length > 0)
                {
                    return grName[Object.keys(grName)[0]]
                }
            }
            else{
                var dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);

                if(dic && dic[obj.protocol])
                {
                    return dic[obj.protocol].value;
                }
            }
        }
        else if(is_custom_group)
        {
            if(obj.custom_group_id && obj.custom_group_name)
            {
                return obj.custom_group_name;
            }
            else
            {
                if(isTooltip)
                {
                    return LangHelper.GetString("UlrModule", "Custom group information missing from database.")
                }
                else
                {
                    return obj.protocol + " " + AlertErrorTemplate(null, null, obj.protocol);
                }
            }
        }

        return obj.protocol;
    }

    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlAppDSCPsTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        //editable:true,
        config:
        {
            method:function ()
            {
                return "UlrGetDscpAppRulesData";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "protocol",
                    header: [LangHelper.GetString("UlrModule","Protocol / Group name")],
                    sort: "string",
                    fillspace: 2,
                    tooltip: function(obj)
                    {
                        return templateFunc(obj, true)
                    },
                    template: function(obj)
                    {
                        return templateFunc(obj);
                    }
                },
                {
                    id: "group_id",
                    header: [LangHelper.GetString("UlrModule", "Group")],
                    sort: "string",
                    fillspace: 1,
                    template: function(obj)
                    {
                        let result = "";
                        var is_group = parseInt(obj.is_group);
                        var is_custom_group = parseInt(obj.is_custom_group);

                        if(obj && is_group && obj.group_name_json)
                        {
                            var grName = JSON.parse(obj.group_name_json), locale = LangHelper.GetLocale();

                            if(grName && grName[locale])
                            {
                                result = grName[locale] + " " + CellListBtnTemplate();
                            }
                            else if(Object.keys(grName).length > 0)
                            {
                                result = grName[Object.keys(grName)[0]] + " " + CellListBtnTemplate();
                            }

                            if(!result)
                            {
                                var dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);

                                if(dic && dic[obj.group_id])
                                {
                                    result = dic[obj.group_id].value + " " + CellListBtnTemplate();
                                }
                            }
                        }
                        else if(obj && is_custom_group && obj.custom_group_name)
                        {
                            result = obj.custom_group_name + " " + CellListBtnTemplate();
                        }

                        return result;
                    }
                },
                // {
                //     id: "priority",
                //     header: [LangHelper.GetString("UlrModule","Priority")],
                //     sort: "string",
                //     fillspace: 1
                // },
                {
                    id: "priority",
                    header: [LangHelper.GetString("UlrModule","Priority")],
                    editor:"combo",
                    fillspace: true,
                    suggest:{
                        view:"gridsuggest",
                        body:{
                            autoheight:false,
                            scroll:true,
                            maxHeight:400,
                            //width:800,
                            //minWidth:800,
                            borderless:true,
                            columns:[
                                { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                { id:"class_order_1", header:"class_order=1", width:160}
                            ],
                            data:Helper.DictToArr(DscpDic)
                        }
                    }
                },
                {
                    id: "regulator",
                    header: [LangHelper.GetString("UlrModule","Regulator")],
                    sort: "string",
                    fillspace: 1,
                    hidden: true
                },
                {
                    id: "mode",
                    header: [LangHelper.GetString("UlrModule","Mode")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        return obj.mode.toUpperCase();
                    }
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        // filter:{
        //     lang_code:{
        //         id:"lang_code",
        //         operator:"equal or null",
        //         value:LangHelper.GetLocale()
        //     }
        // },
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","DSCP rules");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterEditStop)
    {
        params.on.onAfterEditStop = function (State, Editor, IgnoreUpdate)
        {
            Params.onAfterEditStop(State, Editor, IgnoreUpdate);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlAsnDSCPsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlAsnDSCPsTableWidget",
        hideExport:false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        //editable:true,
        config:
        {
            method:function ()
            {
                return "UlrGetAsnDscpRulesData";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "protocol",
                    header: [LangHelper.GetString("UlrModule","AS number")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Rule name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "priority",
                    header: [LangHelper.GetString("UlrModule","Priority")],
                    fillspace: true,
                    hidden:Params&&Params.rule_type_id == UlrRulesTypesCodesTypeIdMap.asn_exclude,
                    template: function(Obj)
                    {
                        return Obj && Obj.priority ? Obj.priority.trim() : "";
                    }
                },
                {
                    id: "regulator",
                    header: [LangHelper.GetString("UlrModule","Regulator")],
                    sort: "string",
                    fillspace: 1,
                    hidden: true
                },
                {
                    id: "description",
                    header: [LangHelper.GetString("UlrModule","Description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "mode",
                    header: [LangHelper.GetString("UlrModule","Mode")],
                    sort: "string",
                    fillspace: 1,
                    template: function (obj, common, value){
                        return obj.mode.toUpperCase();
                    }
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            rule_type_id:{
                id:"rule_type_id",
                operator:"=",
                value:Params&&Params.rule_type_id?Params.rule_type_id:UlrRulesTypesCodesTypeIdMap.asn_lock
            }
        },
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            var ruleType = Params&&Params.rule_type_id?Params.rule_type_id:UlrRulesTypesCodesTypeIdMap.asn_lock;

            if(ruleType == UlrRulesTypesCodesTypeIdMap.ip_exclude)
                return LangHelper.GetString("UlrModule","IP excludes");

            if(ruleType == UlrRulesTypesCodesTypeIdMap.asn_exclude)
                return LangHelper.GetString("UlrModule","ASN excludes");

            return LangHelper.GetString("UlrModule","ASN DSCP rules");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterEditStop)
    {
        params.on.onAfterEditStop = function (State, Editor, IgnoreUpdate)
        {
            Params.onAfterEditStop(State, Editor, IgnoreUpdate);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlAsnExcludesTableWidget = function (Params)
{
    var params = webix.extend(Params,{
        name:"UrlAsnExcludesTableWidget",
        rule_type_id:UlrRulesTypesCodesTypeIdMap.asn_exclude
    },true);

    return UrlAsnDSCPsTableWidget(params);
};

var UrlIpExcludesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlIpExcludesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        //editable:true,
        config:
            {
                method:function ()
                {
                    return "UlrGetIpExcludeAsnRules";
                },
                sort:{id:"update_time",dir:"desc"}
            },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "protocol",
                    header: [LangHelper.GetString("UlrModule","IP or CIDR")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Rule name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "regulator",
                    header: [LangHelper.GetString("UlrModule","Regulator")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "description",
                    header: [LangHelper.GetString("UlrModule","Description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","IP excludes");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterEditStop)
    {
        params.on.onAfterEditStop = function (State, Editor, IgnoreUpdate)
        {
            Params.onAfterEditStop(State, Editor, IgnoreUpdate);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlDomainDNSPartTableWidget = function (Params){
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlDomainGeneralInformationTableWidget",
        hideExport:true,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableCheckboxRefresh:true,
        columns: function ()
        {
            var cols = [];
            cols.push.apply(cols,[
                {
                    id: "type",
                    header: LangHelper.GetString("UlrModule","Type"),
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "host",
                    header: LangHelper.GetString("UlrModule","Domain name"),
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "addr",
                    header: LangHelper.GetString("UlrModule","Address"),
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "ttl",
                    header: LangHelper.GetString("UlrModule","TTL"),
                    sort: "string",
                    fillspace: 1
                }

            ]);
            return cols;
        }(),
        rules:{},
        defaultPageSize:-10,
        on:{},
        minHeight:40

    };
    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlResourcesIntersectionTableWidget = function (Params){
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlResourcesIntersectionTableWidget",
        hideExport:true,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableCheckboxRefresh:true,
        columns: function ()
        {
            var cols = [];
            cols.push.apply(cols,[
                {
                    id: "type",
                    header: LangHelper.GetString("UlrModule","Type"),
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "verifiable_resource",
                    header: LangHelper.GetString("UlrModule","Verifiable resource"),
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "protocol_id",
                    header: LangHelper.GetString("UlrModule","Protocol id"),
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "protocol_name",
                    header: LangHelper.GetString("UlrModule","Protocol name"),
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "intersection_resource",
                    header: LangHelper.GetString("UlrModule","Intersection resource"),
                    sort: "string",
                    fillspace: 1
                }
            ]);
            return cols;
        }(),
        rules:{},
        defaultPageSize:-10,
        on:{},
        minHeight:40
    };
    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlKeyValueTableWidget = function (Params){
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlDomainGeneralInformationTableWidget",
        hideExport:true,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableCheckboxRefresh:true,
        hideHeader:true,
        columns: function ()
        {
            var cols = [];
            cols.push.apply(cols,[
                {
                    id: "key",
                    header:"",
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "value",
                    header: "",
                    sort: "string",
                    fillspace: 1
                }
            ]);
            return cols;
        }(),
        rules:{},
        defaultPageSize:-10,
        on:{},
        minHeight:44,
        rowHeight:44,
        tableCss:"key_value_report"

    };
    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrAppProtocolsTable = function (Params)
{
    let method = function ()
    {
        return Params&&Params.is_custom_group?"UlrCustomGroupsGetProtocols":"UlrGetDicProtocolsData"
    };

    var params = {
        id:(Params&&Params.id?Params.id:webix.uid()) + "NotQoE",
        name:"URLAppProtocolsTableWidget",
        //hideExport:true,
        hidePaginatorToolbar:false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        config:
        {
            model: function(Params)
            {
                this._id = Params&&Params._id?Params._id:"";
                this.name = Params&&Params.name?Params.name :" 0";
                this.priority = Params&&Params.priority ? Params.priority : "";
                this.group_id = Params&&Params.group_id ? Params.group_id : 0;
                this.group_name_json = Params&&Params.group_name_json ? Params.group_name_json : "{}";
            },
            method:method,
            sort:{id:(Params&&Params.is_custom_group?"prtcl_id":"_id"),dir:"asc"}
        },

        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "_id",
                    header: [LangHelper.GetString("UlrModule","Id")],
                    sort: "string",
                    fillspace: 1,
                    // hidden: Params && Params.is_modal
                    hidden: true
                },
                {
                    id: Params&&Params.is_custom_group?"prtcl_name":"name",
                    header: [LangHelper.GetString("UlrModule","Protocol name")],
                    sort: "string",
                    fillspace: 1,
                    tooltip: function(obj)
                    {
                        let result = obj.prtcl_name?obj.prtcl_name:(obj.name ? obj.name : obj.custom_group_name);

                        if(obj.prtcl_name && (!obj.prtcl_id || parseInt(obj.prtcl_id) === 0) && !obj.custom_group_id)
                        {
                            result = LangHelper.GetString("UlrModule", "Protocol information missing from database.")
                        }

                        return result;

                    },
                    template: function(obj)
                    {
                        let result = obj.prtcl_name?obj.prtcl_name:(obj.name ? obj.name : obj.custom_group_name);

                        if(obj.prtcl_name && (!obj.prtcl_id || parseInt(obj.prtcl_id) === 0) && !obj.custom_group_id)
                        {
                            result += " " + AlertErrorTemplate(null, null, result);
                        }

                        return result;
                    }
                },
                {
                    id: "group_id",
                    header: [LangHelper.GetString("UlrModule", "Group")],
                    sort: "string",
                    fillspace: 1,
                    template: function(obj)
                    {
                        if(obj && obj.group_name_json)
                        {
                            var grName = JSON.parse(obj.group_name_json), locale = LangHelper.GetLocale();

                            if(grName && grName[locale])
                            {
                                return grName[locale];
                            }
                            else if(Object.keys(grName).length > 0)
                            {
                                return grName[Object.keys(grName)[0]]
                            }
                        }
                        else if (obj && obj.group_id)
                        {
                            var dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);

                            if(dic && dic[obj.group_id])
                            {
                                return dic[obj.group_id].value;
                            }
                        }
                        else if (obj && obj.custom_group_name && (!obj.group_id && !obj.prtcl_id))
                        {
                            return obj.custom_group_name;
                        }

                        return "";
                    }
                },
                {
                    id: "priority",
                    header: [LangHelper.GetString("UlrModule","Priority")],
                    sort: "string",
                    fillspace: 1,
                    hidden: Params && Params.is_modal
                }

            ]);
            return cols;
        }(),

        defaultPageSize:-10,
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Applications protocols");
        }
    };

    if(Params && Params.filter){
        params.filter = Params.filter;
    }
    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrEditAppPolicingPopup = function (Params,table)
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:800,
        maxHeight:800,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: Params && Params.modal_title ? Params.modal_title : "Application list", height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        autofit:true,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        table.ViewConfig
                    ]
                }

            ]
        }
    };
    return webix.ui(view).show();
};

var UrlIgwNodesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlIgwNodesTableWidget",
        hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        hidePaginatorToolbar:true,
        enableCheckboxRefresh:true,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableLocalDataSource:Params.enableLocalDataSource ? true : false,
        config:
            {
                model:null,
                method:null,
                sort:{id:"_id",dir:"desc"},
                dataSource:function (FilterParams)
                {
                    if(Params&&Params.dataSource)
                        return Params.dataSource(FilterParams);
                }
            },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "text",
                    fillspace: 1
                },
                {
                    id: "hardware_id",
                    header: [LangHelper.GetString("UlrModule","DPI hardware name")],
                    sort: "text",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return Obj.hardware_id && App.DicsManager.GetDic(DicsEnum.HardwaresDic) && App.DicsManager.GetDic(DicsEnum.HardwaresDic)[Obj.hardware_id] ?
                            App.DicsManager.GetDic(DicsEnum.HardwaresDic)[Obj.hardware_id].value : Obj.hardware_id;
                    }
                },
                {
                    id: "bridges_num",
                    header: [LangHelper.GetString("UlrModule","Bridges")],
                    sort: "text",
                    fillspace: 1
                },
                {
                    id: "ipfix_number",
                    header: [LangHelper.GetString("UlrModule","Ipfix number")],
                    sort: "text",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:function(Obj)
                    {
                        if(Obj.removeable)
                            return CellTrashBtnTemplate(Obj);

                        return "";
                    }
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:-10,
        on:{},
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlDicTableWidget = function (Params)
{
    var dic = Params&&Params.dic ? Params.dic : UlrDicsEnum.Categories;

    var name = "UrlCategoriesDicTableWidget";

    if(dic == UlrDicsEnum.Regulators)
        name = "UrlRegulatorsDicTableWidget";

    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:name,
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        config:{
            method:function ()
            {
                var method = "UlrGetRuleCategoryList";

                if(dic == UlrDicsEnum.Regulators)
                    method = "UlrGetRegulatorList";

                return method;
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Name")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "description",
                    header: [LangHelper.GetString("UlrModule","Description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            var title = LangHelper.GetString("UlrModule","Categories dic items list");

            if(dic == UlrDicsEnum.Regulators)
                title = LangHelper.GetString("UlrModule","Regulators dic items list");

            return title;
        },
        rules:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlExportTasksTableWidget = function (Params)
{
    var id = Params&&Params.id?Params.id:webix.uid();

    var params = {
        id:id,
        name:"UrlExportTasksTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableCheckboxRefresh:true,
        multiselect:true,
        config:{
            method:function ()
            {
                return "UlrGetExportTasksLogReport";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "_id",
                    header: [LangHelper.GetString("UlrModule","Id")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "task_type",
                    header: LangHelper.GetString("UlrModule","Type"),
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "action",
                    header: [LangHelper.GetString("UlrModule","Action")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="" onclick="return false;">' + Obj.action + '</a>';
                    }
                },
                {
                    id: "attempts",
                    header: [LangHelper.GetString("UlrModule","Attempts")],
                    sort: "string",
                    fillspace: 1,
                    template:function(Obj, Common, Value)
                    {
                        var str = Value;

                        if(Value >= 100)
                            str += " (" + LangHelper.GetString("UlrModule","Max tries") + ")";

                        return str;
                    }
                },
                {
                    id: "hardware_name",
                    header: [LangHelper.GetString("UlrModule","Hardware")],
                    sort: "string",
                    fillspace: 1,
                    template:function(Obj, Common, Value)
                    {
                        var str = Value;

                        if(str && Obj.hardware_id)
                            str = str + " (" + Obj.hardware_id + ")";

                        return str;
                    }
                },
                {
                    id: "status",
                    header: [LangHelper.GetString("UlrModule","Status")],
                    sort: "string",
                    fillspace: 1,
                    template:function(Obj, Common, Value)
                    {
                        var s = Value;

                        var color = "";

                        if(s === 'success')
                        {
                            color = "green";
                        }
                        else if(s === 'processing' || s === 'waiting' || s === 'waiting_processing')
                        {
                            color = "yellow";
                        }
                        else if(s === 'error')
                        {
                            color = "red";
                        }

                        if(Obj && Obj.attempts && Obj.attempts >= 100)
                            color = "red";

                        return CellAnyIconBtnTemplate("lightbulb " + color) + " " + s;
                    }
                },
                {
                    id: "status_description",
                    header: [LangHelper.GetString("UlrModule","Status description")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "data",
                    header: [LangHelper.GetString("UlrModule","")],
                    sort: "string",
                    width:32,
                    template:CellEyeBtnTemplate
                },
                {
                    id: "delete",
                    header: [LangHelper.GetString("UlrModule","")],
                    sort: "string",
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Export tasks list");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrShowDatabaseSearchHelpPopup = function ()
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:800,
        maxHeight:800,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: LangHelper.GetString("UlrModule","Database extended query syntax"), height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        //autofit:true,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    view:"scrollview",
                    id:id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            {
                                template:"http->assets/html/UlrWebSearchDatabaseHelp.html",
                                autoheight:true
                            }
                        ]
                    }

                }

            ]
        }
    };



    return webix.ui(view).show();
};

var UlrShowCidrPrefixesHelpPopup = function ()
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:800,
        maxHeight:800,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: LangHelper.GetString("UlrModule","CIDR: static prefix"), height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    view:"scrollview",
                    id:id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            {
                                template:LangHelper.GetLocale() === LocalesEnum.ru.code ? "http->assets/html/UrlCidrPrefixesHelpRu.html" : "http->assets/html/UrlCidrPrefixesHelpEn.html",
                                autoheight:true
                            }
                        ]
                    }

                }

            ]
        }
    };



    return webix.ui(view).show();
};

var UlrShowBgpPrefixesHelpPopup = function ()
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:800,
        maxHeight:800,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: LangHelper.GetString("UlrModule","BGP: Regex Guide"), height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    view:"scrollview",
                    id:id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            {
                                template:LangHelper.GetLocale() === LocalesEnum.ru.code ? "http->assets/html/UlrBgpPrefixesHelpRu.html" : "http->assets/html/UlrBgpPrefixesHelpEn.html",
                                autoheight:true
                            }
                        ]
                    }

                }

            ]
        }
    };



    return webix.ui(view).show();
};

var UlrBgpPrefixResourcesTable = function (Params)
{
    var params = {
        id:(Params&&Params.id?Params.id:webix.uid()) + "NotQoE",
        name:"UlrBgpPrefixResourcesTableWidget",
        //hideExport:true,
        hidePaginatorToolbar:false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        config:{
            model:function (params)
            {
                this._id = params && params._id ? params._id : "";
                this.bgp_prefix = params && params.bgp_prefix ? params.bgp_prefix : "";
                this.bgp_time = params && params.bgp_time ? params.bgp_time : "";
                this.state_bind = params && params.hasOwnProperty("state_bind") ? params.state_bind : 0;
                this.state_valid = params && params.hasOwnProperty("state_valid") ? params.state_valid : 0;
                this.state = params && params.state ? params.state : '{}';
            },
            method:function ()
            {
                return "UlrGetBgpRefixes";
            },
            sort:{id:"_id",dir:"asc"}
        },

        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "_id",
                    header: [LangHelper.GetString("UlrModule","Id")],
                    sort: "string",
                    fillspace: 1,
                    hidden: Params && Params.is_modal
                },
                {
                    id: "bgp_prefix",
                    header: [LangHelper.GetString("UlrModule","Prefix")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "bgp_time",
                    header: [LangHelper.GetString("UlrModule", "BGP time")],
                    sort: "string",
                    fillspace: 1,
                    template:function(obj, common)
                    {
                        if(obj.bgp_time)
                        {
                            var update = new Date(obj.bgp_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(obj.bgp_time);
                    }
                },
                {
                    id: "state",
                    header: [LangHelper.GetString("UlrModule","State")],
                    sort: "string",
                    fillspace: 1,
                    template:function(Obj)
                    {
                        var bind = Obj.state_bind ? LangHelper.GetString("UlrModule","Binded") : LangHelper.GetString("UlrModule","Unbinded");

                        var valid = Obj.state_valid == 2 ? LangHelper.GetString("UlrModule","Valid") : (Obj.state_valid == 1 ? '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Invalid") + '</span>' : "");

                        return bind + (valid ? ", " + valid : "");
                    }
                }

            ]);
            return cols;
        }(),

        defaultPageSize:-10,
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","BGP prefixes");
        }
    };

    if(Params && Params.filter){
        params.filter = Params.filter;
    }
    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrMailingAlertsActionsTable = function (Params)
{
    var params = {
        id:(Params&&Params.id?Params.id:webix.uid()) + "NotQoE",
        name:"UlrMailingAlertsActionsTableWidget",
        //hideExport:true,
        hidePaginatorToolbar:false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        config:{
            model:function (params)
            {
                this._id = params && params._id ? params._id : "";
                this.ulr_mailing_id = params && params.ulr_mailing_id ? params.ulr_mailing_id : "";
                this.alert_note = params && params.alert_note ? params.alert_note : "";
                this.date = params && params.hasOwnProperty("date") ? params.date : '';
                this.action_type = params && params.hasOwnProperty("action_type") ? params.action_type : '';
                this.model_json = params && params.model_json ? params.model_json : '{}';
                this.state_json = params && params.state_json ? params.state_json : '{}';
                this.state_code = params && params.state_code ? params.state_code : "";
                this.state_date = params && params.hasOwnProperty("state_date") ? params.state_date : '';
            },
            method:function ()
            {
                return "UlrGetMailingActionsList";
            },
            sort:{id:"_id",dir:"desc"}
        },

        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "_id",
                    header: [LangHelper.GetString("UlrModule","Id")],
                    sort: "string",
                    fillspace: 1,
                    hidden: Params && Params.is_modal
                },
                {
                    id: "state_date",
                    header: [LangHelper.GetString("UlrModule", "Send time")],
                    sort: "string",
                    fillspace: 1,
                    template:function(obj, common)
                    {
                        var datetime = obj.state_date ? obj.state_date : obj.date;
                        if(datetime)
                        {
                            var update = new Date(datetime);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(datetime);
                    }
                },
                {
                    id: "action_type",
                    header: [LangHelper.GetString("UlrModule","Type")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "rcvr",
                    header: [LangHelper.GetString("UlrModule","Receiver")],
                    sort: "string",
                    fillspace: 1,
                    template:function(Obj)
                    {
                        var res = '';

                        if(Obj.model_json && JSON.parse(Obj.model_json))
                        {
                            var obj = JSON.parse(Obj.model_json);

                            if(Obj.action_type == QoETriggerAlertActionTypeDic.email.id)
                            {
                                res = obj.to ? obj.to : '';
                            }
                        }

                        return res;
                    }
                },
                {
                    id: "state_code",
                    header: [LangHelper.GetString("QoE", "State")],
                    template: function(Obj)
                    {
                        var stateStr = "";

                        if(QoETriggerAlertActionStateCodeDic[Obj.state_code])
                        {
                            var color = "green";

                            switch(Obj.state_code)
                            {
                                case QoETriggerAlertActionStateCodeEnum.ready:
                                case QoETriggerAlertActionStateCodeEnum.complete:
                                    color = "green";
                                    break;
                                case QoETriggerAlertActionStateCodeEnum.error:
                                case QoETriggerAlertActionStateCodeEnum.cancel:
                                case QoETriggerAlertActionStateCodeEnum["max attempts"]:
                                    color = "red";
                                    break;
                                default:
                                    color = "orange"
                            }

                            stateStr += "<span class=\"status status_" + color + "\">";

                            if(Obj.state_code == QoETriggerStateCodeEnum.error)
                            {
                                stateStr += '<span class="webix_icon fa-exclamation-triangle"></span>';
                            }

                            stateStr += QoETriggerAlertActionStateCodeDic[Obj.state_code].value + "</span>";
                        }
                        else
                        {
                            stateStr = Obj.state_code;
                        }


                        return stateStr;
                    },
                    fillspace: true,
                    sort: "string",
                    tooltip:function (Obj)
                    {
                        var stateStr = "";

                        if(Obj.state_json && JSON.parse(Obj.state_json))
                        {
                            var state = JSON.parse(Obj.state_json);

                            if(state.result)
                            {
                                if(state.result.success)
                                {
                                    stateStr = "Success";
                                }
                                else
                                {
                                    stateStr = state.result.error && state.result.error.msg ? "Error: " + state.result.error.msg : "Error";
                                }
                            }
                        }

                        return stateStr;
                    }
                }
            ]);
            return cols;
        }(),

        defaultPageSize:-10,
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Mailing");
        }
    };

    if(Params && Params.filter){
        params.filter = Params.filter;
    }
    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlImportedFilesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlImportedFilesTableWidget",
        hideExport:true,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        rowsPerPageHide:Params.rowsPerPageHide ? true : false,
        enableLocalDataSource: Params.enableLocalDataSource ? true : false,
        enableCheckboxRefresh:true,
        config:{
            // model:UlrWebRuleResourceModel,
            method:function ()
            {
                return "";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","File")],
                    sort: "text",
                    fillspace: 1
                },
                {
                    id: "size",
                    header: [LangHelper.GetString("UlrModule","File size")],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj)
                    {
                        return Obj.sizetext ? Obj.sizetext : (Obj.size + " b");
                    }
                },
                {
                    id: "state",
                    header: [LangHelper.GetString("UlrModule","State")],
                    sort: "string",
                    fillspace: 1,
                    template: function(Obj)
                    {
                        var color = "orange";

                        var stateStr = "";

                        if(Obj.state != UlrFilesStatusDic.uploaded.id && Obj.state != UlrFilesStatusDic.failed.id)
                        {
                            stateStr += '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div> <div class="bounce3"></div> </div>';
                        }

                        switch(Obj.state)
                        {
                            case UlrFilesStatusDic.uploaded.id:
                                color = "green";
                                break;
                            case UlrFilesStatusDic.failed.id:
                                color = "red";
                                break;
                            default:
                                color = "orange";
                        }

                        stateStr += "<span class=\"status status_" + color + "\" style='curesor: pointer'>";

                        stateStr += (UlrFilesStatusDic[Obj.state] && UlrFilesStatusDic[Obj.state].value ? UlrFilesStatusDic[Obj.state].value : Obj.state) + "</span>"

                        return stateStr;
                    }
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"=",
            //     value:LangHelper.GetLocale()
            // }
        },
        sort_map:{},
        defaultPageSize:Params && Params.defaultPageSize ? Params.defaultPageSize : -10,
        on:{},
        minHeight:40
    };

    if(Params && Params.dataSource)
    {
        params.config.dataSource = function(FilterParams)
        {
            return Params.dataSource(FilterParams);
        };
    }

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);

        };

        params.on.onCheck = function(row, column, state)
        {
            Params.onItemClick({
                row: row,
                column: column
            });
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrShowImportWebRulesHelpPopup = function ()
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:800,
        maxHeight:800,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: LangHelper.GetString("UlrModule","WEB Filter: import resources"), height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    view:"scrollview",
                    id:id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            {
                                template:LangHelper.GetLocale() === LocalesEnum.ru.code ? "http->assets/html/UlrWebRulesResourceImportHelpRu.html" : "http->assets/html/UlrWebRulesResourceImportHelpEn.html",
                                autoheight:true
                            }
                        ]
                    }

                }

            ]
        }
    };



    return webix.ui(view).show();
};

var UlrShowImportSpoofDnsHelpPopup = function ()
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:1200,
        maxHeight:800,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: LangHelper.GetString("UlrModule","Spoof DNS: import resources"), height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    view:"scrollview",
                    id:id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            {
                                template:function()
                                {
                                    const lang = LangHelper.GetLocale() === LocalesEnum.ru.code;

                                    if (lang)
                                            return "http->assets/html/spoof_dns/UlrSpoofDnsRulesResourcesImportHelp.html";
                                        else
                                            return "http->assets/html/spoof_dns/UlrSpoofDnsRulesResourcesImportHelpEn.html";

                                    // if (AppEnv.spoof_dns_disabled_ipv6)
                                    // {
                                    //     if (lang)
                                    //         return "http->assets/html/spoof_dns/UlrSpoofDnsRulesResourcesImportHelpIPv4Ru.html";
                                    //     else
                                    //         return "http->assets/html/spoof_dns/UlrSpoofDnsRulesResourcesImportHelpIPv4En.html";
                                    // }
                                    // else
                                    // {
                                    //     if (lang)
                                    //         return "http->assets/html/spoof_dns/UlrSpoofDnsRulesResourcesImportHelpIPv4IPv6Ru.html";
                                    //     else
                                    //         return "http->assets/html/spoof_dns/UlrSpoofDnsRulesResourcesImportHelpIPv4IPv6En.html"
                                    // }
                                }(),
                                autoheight:true
                            }
                        ]
                    }

                }

            ]
        }
    };



    return webix.ui(view).show();
};

var UlrAppCategoryHostsTable = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid() + "NotQoE",
        name:"UlrAppCategoryHostsTable",
        //hideExport:true,
        hidePaginatorToolbar:false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:"";
                this.host = Params&&Params.host ? Params.host : "";
            },
            method:function ()
            {
                return "UlrGetDicCategoryHostsData";
            },
            sort:{id:"_id",dir:"asc"}
        },

        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "_id",
                    header: [LangHelper.GetString("UlrModule","Id")],
                    sort: "string",
                    fillspace: 1,
                    hidden: Params && Params.is_modal
                },
                {
                    id: "host",
                    header: [LangHelper.GetString("UlrModule","Host")],
                    sort: "string",
                    fillspace: 1
                }

            ]);
            return cols;
        }(),

        defaultPageSize:-10,
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","List host categories");
        }
    };
    if(Params && Params.filter){
        params.filter = Params.filter;
    }
    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var URLAppHostCategoriesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UlrGetResourceRulesList",
        //hideExport:true,
        hidePaginatorToolbar:false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:"";
                this.host = Params&&Params.host?Params.host :" 0";
                this.cat_id = Params&&Params.cat_id?Params.cat_id :" 0";
            },
            method:function ()
            {
                return "UlrGetDicCategoryHostsData";
            },
            sort:{id:"_id",dir:"asc"}
        },

        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "_id",
                    header: [LangHelper.GetString("UlrModule","Id")],
                    sort: "string",
                    fillspace: 1,
                    hidden: Params && Params.is_modal
                },
                {
                    id: "host",
                    header: [LangHelper.GetString("UlrModule","Host")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "cat_name",
                    header: [LangHelper.GetString("UlrModule","Category name")],
                    sort: "string",
                    fillspace: 1,
                    template: function(obj)
                    {
                        var dic = App.DicsManager.GetDic(DicsEnum.HostCategoriesDic);

                        if(dic && dic[obj.cat_id])
                        {
                            return dic[obj.cat_id].value;
                        }

                        return "";
                    }
                },
                {
                    id: "cat_id",
                    sort: "string",
                    fillspace: 1,
                    hidden: 1
                }
            ]);
            return cols;
        }(),

        defaultPageSize:-10,
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","List host categories");
        }
    };

    if(Params && Params.filter){
        params.filter = Params.filter;
    }
    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if (typeof params.filter == 'undefined') {
        var def_filter = {};
        def_filter.cat_id = {
            id:"cat_id",
            operator:"=",
            value: "2"
        };
        params.filter = def_filter;
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrCustomGroupsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UlrCustomGroupsListTableWidget",
        hideExport:true,
        hidePaginatorToolbar:true,
        enableAutoHeight:false,
        enableLocalDataSource:false,
        enableTextSearch:false,
        editable:true,
        editaction:"dblclick",
        config:{
            model: function(Params)
            {
                return new UlrCustomGroupModel(Params);
            },
            method:function ()
            {
                return "UlrCustomGroupsGetGroupsList";
            },
            sort:{id:"_id",dir:"asc"}
        },
        filter: {},
        columns: [
            {
                id: "edit",
                header: "",
                width: 32,
                template: CellEditBtnTemplate,
            },
            {
                id: "name",
                header: LangHelper.GetString("UlrModule", "Group"),
                sort:false,
                fillspace: true,
                editor: "text"
            },
            {
                id: "delete",
                header: "",
                width: 32,
                template: CellTrashBtnTemplate,
            },
            {
                id: "empty",
                header: "",
                width: 8
            }
        ],
        on:{},
        rules:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function(id, e, node)
        {
            Params.onItemClick(id, e, node);
        };
    }

    if(Params&&Params.onAfterEditStop)
    {
        params.on.onAfterEditStop = function(state, editor)
        {
            Params.onAfterEditStop(state, editor)
        }
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrCustomGroupsProtocolsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UlrCustomGroupsProtocolsTable",
        hideExport:true,
        hidePaginatorToolbar:false,
        enableAutoHeight:false,
        enableLocalDataSource: Params && Params.enableLocalDataSource ? Params.enableLocalDataSource : false,
        enableTextSearch: Params && Params.enableTextSearch ? Params.enableTextSearch : false,
        multiselect: true,
        filter: {},
        drag: true,
        config: {
            model: function(Params)
            {
                return new UlrCustomGroupsProtocolViewModel(Params)
            },
            method:function ()
            {
                return "UlrGetDicProtocolsData";
            },
            sort:{id:"_id",dir:"asc"}
        },
        columns: function ()
        {
            let cols = [];

            cols.push.apply(cols,[
                {
                    id: "_id",
                    header: [LangHelper.GetString("UlrModule","Id")],
                    sort: "string",
                    fillspace: 1,
                    hidden: Params && Params.is_modal
                },
                {
                    id: "name",
                    header: [LangHelper.GetString("UlrModule","Protocol name")],
                    sort: "string",
                    fillspace: 1,
                    tooltip: function(obj)
                    {
                        let result = obj.name;

                        if(parseInt(obj._id) === 0)
                        {
                            result = LangHelper.GetString("UlrModule", "Protocol information missing from database.")
                        }

                        return result;

                    },
                    template: function(obj)
                    {
                        let result = obj.name;

                        if(parseInt(obj._id) === 0)
                        {
                            result += " " + AlertErrorTemplate(null, null, obj.name);
                        }

                        return result;
                    }
                },
                {
                    id: "group_id",
                    header: [LangHelper.GetString("UlrModule", "Group")],
                    sort: "string",
                    fillspace: 1,
                    template: function(obj)
                    {
                        if(obj && obj.group_name_json)
                        {
                            var grName = JSON.parse(obj.group_name_json), locale = LangHelper.GetLocale();

                            if(grName && grName[locale])
                            {
                                return grName[locale];
                            }
                            else if(Object.keys(grName).length > 0)
                            {
                                return grName[Object.keys(grName)[0]]
                            }
                        }
                        else{
                            var dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);

                            if(dic && dic[obj.group_id])
                            {
                                return dic[obj.group_id].value;
                            }
                        }

                        return "";
                    }
                },
            ]);
            return cols;
        }(),
        on:{},
        rules:{},
        defaultPageSize:-50,
    };

    if(Params && Params.arrow_direction)
    {
        let col = {
            id: "",
            header: "",
            width: 32,
            template: "",
            headermenu: false
        };

        switch (Params.arrow_direction)
        {
            case "to_left":
                col.id = "to_left";
                col.template = CellArrowToLeftBtnTemplate;
                params.columns.unshift(col);
                break;
            case "to_right":
                col.id = "to_right";
                col.template = CellArrowToRightBtnTemplate;
                params.columns.push(col);
        }
    }

    if(Params && Params.dataSource)
    {
        params.config.dataSource = function(FilterParams)
        {
            return Params.dataSource(FilterParams);
        };
    }

    if(Params && Params.filter)
    {
        params.filter = Params.filter;
    }

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlLastSpoofDnsRulesEntriesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlLastSpoofDnsRulesEntriesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        //enableCheckboxRefresh:true,
        config:{
            model:function (Params)
            {
                this._id = Params&&Params._id?Params._id:0;

                this.enabled = Params&&Params.enabled?Params.enabled:0;

                this.rule_enabled = Params&&Params.rule_enabled?Params.rule_enabled:0;

                this.rule_id = Params&&Params.rule_id?Params.rule_id:0;

                this.rule_type_mode = Params&&Params.rule_type_mode?Params.rule_type_mode:0;

                this.rule_type_id = Params&&Params.rule_type_id?Params.rule_type_id:0;

                //this.rule_name = Params&&Params.rule_name?Params.rule_name:"";

                this.type = Params&&Params.type?Params.type:"";

                this.update_time = Params&&Params.update_time?Params.update_time:null;

                this.resource_type = Params&&Params.resource_type?Params.resource_type : "";

                this.resource_raw = Params&&Params.resource_raw?Params.resource_raw : "";

                this.resource_validated = Params&&Params.resource_validated?Params.resource_validated : "";

                this.regulator = Params&&Params.regulator?Params.regulator : "";

                this.category = Params&&Params.category?Params.category : "";

                this.description_public = Params&&Params.description_public?Params.description_public : "";

                this.update_user = Params&&Params.update_user?Params.update_user : "";
            },
            method:function ()
            {
                return "UlrGetResourceRulesData";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                // {
                //     id: "enabled",
                //     header:"",
                //     sort: false,
                //     width:32,
                //     template:CellCheckboxSwitchOnOffTemplate
                // },
                {
                    id: "enabled",
                    header: "",//[LangHelper.GetString("UlrModule","Rule")],
                    template:function (Obj)
                    {
                        var s = parseInt(Obj.rule_enabled) && parseInt(Obj.enabled) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");

                        return CellAnyIconBtnTemplate("lightbulb " + (parseInt(Obj.rule_enabled) && parseInt(Obj.enabled) ? "green" : "red")) + " " + s;
                    },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","Rule id")],
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditSpoofDnsRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                    },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "rule_type_mode",
                    header: [LangHelper.GetString("UlrModule", "Rule type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        const dic = UlrWebRuleTypeModeListTypes;

                        return dic[Obj.rule_type_mode] && dic[Obj.rule_type_mode].value ? dic[Obj.rule_type_mode].value : Obj.rule_type;
                    }
                },
                // {
                //     id: "rule_name",
                //     header: [LangHelper.GetString("UlrModule","Name")],
                //     sort: "string",
                //     fillspace: 1
                // },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "resource_raw",
                    header: [LangHelper.GetString("UlrModule","Resource")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "regulator",
                    header: [LangHelper.GetString("UlrModule","Regulator")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "category",
                    header: [LangHelper.GetString("UlrModule","Category")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "description_public",
                    header: [LangHelper.GetString("UlrModule","Reason")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_user",
                    header: [LangHelper.GetString("UlrModule","User")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                // {
                //     id: "delete",
                //     header:"",
                //     sort: false,
                //     width:32,
                //     template:CellTrashBtnTemplate
                // },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"equal or null",
            //     value:LangHelper.GetLocale()
            // },
            rule_type_id:{
                id:"rule_type_id",
                operator:"=",
                value:UlrRulesTypesCodesTypeIdMap.spoof_dns
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            return LangHelper.GetString("UlrModule","Last entries in Spoof DNS register");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlSpoofDnsRulesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UrlSpoofDnsRulesTableWidget",
        //hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        //enableCheckboxRefresh:true,
        config:{
            // model:function (Params)
            // {
            //     this._id = Params&&Params._id?Params._id:0;
            //
            //     this.enabled = Params&&Params.enabled?Params.enabled:0;
            //
            //     this.rule_enabled = Params&&Params.rule_enabled?Params.rule_enabled:0;
            //
            //     this.rule_id = Params&&Params.rule_id?Params.rule_id:0;
            //
            //     this.rule_type_mode = Params&&Params.rule_type_mode?Params.rule_type_mode:0;
            //
            //     this.rule_type_id = Params&&Params.rule_type_id?Params.rule_type_id:0;
            //
            //     //this.rule_name = Params&&Params.rule_name?Params.rule_name:"";
            //
            //     this.type = Params&&Params.type?Params.type:"";
            //
            //     this.update_time = Params&&Params.update_time?Params.update_time:null;
            //
            //     this.resource_type = Params&&Params.resource_type?Params.resource_type : "";
            //
            //     this.resource_raw = Params&&Params.resource_raw?Params.resource_raw : "";
            //
            //     this.resource_validated = Params&&Params.resource_validated?Params.resource_validated : "";
            //
            //     this.regulator = Params&&Params.regulator?Params.regulator : "";
            //
            //     this.category = Params&&Params.category?Params.category : "";
            //
            //     this.description_public = Params&&Params.description_public?Params.description_public : "";
            //
            //     this.update_user = Params&&Params.update_user?Params.update_user : "";
            // },
            method:function ()
            {
                return "UlrGetWebRulesData";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                // {
                //     id: "enabled",
                //     header:"",
                //     sort: false,
                //     width:32,
                //     template:CellCheckboxSwitchOnOffTemplate
                // },
                {
                    id: "enabled",
                    header: "",//[LangHelper.GetString("UlrModule","Rule")],
                    template:function (Obj)
                    {
                        var s = parseInt(Obj.enabled) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");

                        return CellAnyIconBtnTemplate("lightbulb " + (parseInt(Obj.enabled) ? "green" : "red")) + " " + s;
                    },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "rule_id",
                    header: [LangHelper.GetString("UlrModule","Rule id")],
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditSpoofDnsRule/_id=' + Obj.rule_id + '" onclick="return false;">' + Obj.rule_id + '</a>';
                    },
                    sort: "string",
                    fillspace: 0,
                    width:80
                },
                {
                    id: "rule_type_mode",
                    header: [LangHelper.GetString("UlrModule", "Rule type")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        const dic = UlrWebRuleTypeModeListTypes;

                        return dic[Obj.rule_type_mode] && dic[Obj.rule_type_mode].value ? dic[Obj.rule_type_mode].value : Obj.rule_type;
                    }
                },
                {
                    id: "update_time",
                    header: [LangHelper.GetString("UlrModule","Date")],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "regulator",
                    header: [LangHelper.GetString("UlrModule","Regulator")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "category",
                    header: [LangHelper.GetString("UlrModule","Category")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "description_public",
                    header: [LangHelper.GetString("UlrModule","Reason")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "update_user",
                    header: [LangHelper.GetString("UlrModule","User")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "edit",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellEditPencilBtnTemplate
                },
                // {
                //     id: "delete",
                //     header:"",
                //     sort: false,
                //     width:32,
                //     template:CellTrashBtnTemplate
                // },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"equal or null",
            //     value:LangHelper.GetLocale()
            // },
            rule_type_id:{
                id:"rule_type_id",
                operator:"=",
                value:UlrRulesTypesCodesTypeIdMap.spoof_dns
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        export_title_callback:function ()
        {
            // var ruleType = Params&&Params.rule_type_id?Params.rule_type_id:UlrRulesTypesCodesTypeIdMap.web_ip_lock;
            //
            // if(ruleType == UlrRulesTypesCodesTypeIdMap.web_ip_white)
            //     return LangHelper.GetString("UlrModule","Last entries in Whitelist register");

            return LangHelper.GetString("UlrModule","Last entries in Spoof DNS register");
        }
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UrlSpoofDnsRulesResourcesTableWidget = function (Params)
{
    let method = Params&&Params.method ? Params.method : "UlrGetResourceRulesList"
    let sort = Params&&Params.sort ? Params.sort : {id:"update_time",dir:"desc"}

    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlSpoofDnsRulesResourcesTableWidget",
        hideExport:true,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        rowsPerPageHide:Params.rowsPerPageHide ? true : false,
        enableLocalDataSource: Params.enableLocalDataSource ? true : false,
        enableCheckboxRefresh:true,
        config:{
            model:UlrSpoofDnsRuleResourceModel,
            method:function ()
            {
                return method;
            },
            sort:sort
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "resource_raw",
                    header: [LangHelper.GetString("UlrModule","Resource")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"=",
            //     value:LangHelper.GetLocale()
            // }
        },
        sort_map:{},
        defaultPageSize:Params && Params.defaultPageSize ? Params.defaultPageSize : -10,
        on:{},
        minHeight:40
    };

    if(Params && Params.dataSource)
    {
        params.config.dataSource = function(FilterParams)
        {
            return Params.dataSource(FilterParams);
        };
    }

    if(Params && Params.rule_id)
    {
        params.filter.rule_id = {
            id: "rule_id",
            operator: "=",
            value: Params.rule_id
        };
    }

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);

        };

        params.on.onCheck = function(row, column, state)
        {
            Params.onItemClick({
                row: row,
                column: column
            });
        };
    }

    if(Params&&Params.addCols)
    {
        Params.addCols.forEach(col => {
            params.columns.splice(col.start, col.deleteCount, col.item);
        })
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrShowHardBlockingIPsInWebFilterHelpPopup = function ()
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:600,
        maxHeight:600,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: LangHelper.GetString("UlrModule","WEB Filter: IPs hard blocking"), height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    view:"scrollview",
                    id:id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            {
                                template:LangHelper.GetLocale() === LocalesEnum.ru.code ? "http->assets/html/UlrHardBlockingIPsInWebFilterHelpRu.html" : "http->assets/html/UlrHardBlockingIPsInWebFilterHelpEn.html",
                                autoheight:true
                            }
                        ]
                    }

                }

            ]
        }
    };



    return webix.ui(view).show();
};

var UlrShowEchEnabledWebFilterHelpPopup = function ()
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:600,
        maxHeight:600,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: LangHelper.GetString("UlrModule","WEB Filter: Block resources as ECH"), height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    view:"scrollview",
                    id:id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            {
                                template:LangHelper.GetLocale() === LocalesEnum.ru.code ? "http->assets/html/UlrEchEnabledInWebFilterHelpRu.html" : "http->assets/html/UlrEchEnabledInWebFilterHelpEn.html",
                                autoheight:true
                            }
                        ]
                    }

                }

            ]
        }
    };



    return webix.ui(view).show();
};

var UlrShowAsnTagsHelpPopup = function ()
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:700,
        maxHeight:350,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: LangHelper.GetString("UlrModule","Description of tags"), height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    view:"scrollview",
                    id:id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            {
                                template:LangHelper.GetLocale() === LocalesEnum.ru.code ? "http->assets/html/UlrAsnTagsHelpRu.html" : "http->assets/html/UlrAsnTagsHelpEn.html",
                                height: 220,
                            }
                        ]
                    }

                }

            ]
        }
    };



    return webix.ui(view).show();
};

var UlrFastresourceCustomPrtclsTableWidget = function(Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UlrFastresourceCustomPrtclsTableWidget",
        hideExport:true,
        hidePaginatorToolbar:false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:true,
        enableLocalSort:false,
        rowsPerPageHide:false,
        enableLocalDataSource: false,
        enableCheckboxRefresh:true,
        config:{
            model: function(Params)
            {
                this._id = Params && Params._id ? parseInt(Params._id) : 0;
                this.custom_protocol_port = Params && Params.custom_protocol_port ? parseInt(Params.custom_protocol_port) : 0;
                this.qoe_table = Params && Params.qoe_table ? Params.qoe_table : "";
                this.config_json = Params && Params.config_json ? Params.config_json : null;
                this.enabled = Params && Params.enabled ? parseInt(Params.enabled) : 0;
                this.update_time = Params && Params.update_time ? Params.update_time : null;
                this.create_user = Params && Params.create_user ? Params.create_user : "";
                this.update_user = Params && Params.update_user ? Params.update_user : "";
            },
            method:function ()
            {
                return "UlrGetFastresourceCustomPrtclsRules";
            },
            sort: {id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "edit",
                    header: "",
                    sort: false,
                    width: 32,
                    template: CellEditPencilBtnTemplate
                },
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "custom_protocol_port",
                    header: [
                        LangHelper.GetString("UlrModule","Protocol"),
                        {content: "multiSelectFilter", options: [], inputConfig: {suggest: {fitMaster: false}}}
                    ],
                    sort: "string",
                    fillspace: 1,
                    filterMap: {
                        id: "custom_protocol_port",
                        operator: "in",
                        value: function(Val)
                        {
                            if(Val)
                            {
                                var arr = Val.split(",");

                                return arr;
                            }
                            return null;
                        }
                    },
                    template: function(Obj)
                    {
                        var dic = App.DicsManager.GetDic(DicsEnum.CustomProtocolsDic);
                        if(Obj.custom_protocol_port && dic && dic[Obj.custom_protocol_port])
                        {
                            return dic[Obj.custom_protocol_port].value;
                        }

                        return Obj.custom_protocol_port;
                    }
                },
                {
                    id: "qoe_table",
                    header: [
                        LangHelper.GetString("Dics", "QoE table"),
                        {content: "multiSelectFilter", options: Helper.DictToArr(ResourceImportQoETables), inputConfig: {suggest: {fitMaster: false}}}
                    ],
                    sort: "string",
                    fillspace: 1,
                    filterMap: {
                        id: "qoe_table",
                        operator: "in",
                        value: function(Val)
                        {
                            if(Val)
                            {
                                var arr = Val.split(",");

                                return arr;
                            }
                            return null;
                        }
                    },
                    template: function(Obj)
                    {
                        if(Obj && Obj.qoe_table && ResourceImportQoETables[Obj.qoe_table])
                        {
                            return ResourceImportQoETables[Obj.qoe_table].value;
                        }

                        return Obj.qoe_table;
                    }
                },
                {
                    id: "update_time",
                    header: [
                        LangHelper.GetString("UlrModule","Date"),
                        {content: "dateRangeFilter", contentId:"update_time", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                    ],
                    sort: "string",
                    template:function(Obj)
                    {
                        if(Obj.update_time)
                        {
                            var update = new Date(Obj.update_time);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                return CellSpectreDateTemplate(n_date);
                            }
                        }
                        return CellSpectreDateTemplate(Obj.update_time);
                    },
                    fillspace: 1
                },
                {
                    id: "update_user",
                    header: [
                        LangHelper.GetString("UlrModule","User"),
                        {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}
                    ],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{
        },
        sort_map:{},
        defaultPageSize:Params && Params.defaultPageSize ? Params.defaultPageSize : -10,
        on:{},
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);

        };

        params.on.onCheck = function(row, column, state)
        {
            Params.onItemClick({
                row: row,
                column: column
            });
        };
    }

    return new QoETableReportWidget(params);
};

var UlrSessionPolicingsTemplatesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"UlrSessionPolicingsTemplatesTableWidget",
        hideExport: Params && Params.hideExport ? Params.hideExport : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        //enableCheckboxRefresh:true,
        config:{
            method:function ()
            {
                return "UlrGetPolicingsTemplates";
            },
            sort:{id:"update_time",dir:"desc"}
        },
        columns: function ()
        {
            var cols = [];

            var editable = true;

            if(Params && Params.read_only)
            {
                editable = false;
            }

            cols.push.apply(cols, [
                {
                    id: "_id",
                    header: [LangHelper.GetString("UlrModule","Template id")],
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditSessionPolicingTemplate/_id=' + Obj._id + '" onclick="return false;">' + Obj._id + '</a>';
                    },
                    sort: "string",
                    fillspace: 0,
                    width:120
                },
                {
                    id: "title",
                    header: [LangHelper.GetString("UlrModule", "Name")],
                    sort: "string",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        return '<a class="webix_cell_link" href="#UlrEditSessionPolicingTemplate/_id=' + Obj._id + '" onclick="return false;">' + Obj.title + '</a>';
                    },
                },
                {
                    id: "description",
                    header: [LangHelper.GetString("UlrModule", "Description")],
                    sort: "string",
                    fillspace: 1
                }
            ]);

            if(editable)
            {
                cols.push.apply(cols,[
                    {
                        id: "update_time",
                        header: [LangHelper.GetString("UlrModule","Date")],
                        sort: "string",
                        template:function(Obj)
                        {
                            if(Obj.update_time)
                            {
                                var update = new Date(Obj.update_time);
                                var offset = update.getTimezoneOffset();
                                if(offset != 0)
                                {
                                    var n_date = new Date(update.getTime() - offset*60*1000);

                                    return CellSpectreDateTemplate(n_date);
                                }
                            }
                            return CellSpectreDateTemplate(Obj.update_time);
                        },
                        fillspace: 1
                    },
                    {
                        id: "update_user",
                        header: [LangHelper.GetString("UlrModule","User")],
                        sort: "string",
                        fillspace: 1
                    },
                    {
                        id: "edit",
                        header:"",
                        sort: false,
                        width:32,
                        template:CellEditPencilBtnTemplate
                    },
                    {
                        id: "delete",
                        header:"",
                        sort: false,
                        width:32,
                        template:CellTrashBtnTemplate
                    }
                ]);
            }

            cols.push.apply(cols, [
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:Params&&Params.filter?Params.filter:{
            // lang_code:{
            //     id:"lang_code",
            //     operator:"equal or null",
            //     value:LangHelper.GetLocale()
            // },
            policing_type:{
                id:"policing_type",
                operator:"=",
                value: UlrPolicingTemplatesTypesDic.session.id
            }
        },
        sort_map:{},
        defaultPageSize:-10,
        on: {},
        minHeight:40,
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var UlrShowSessionPolicingClearProtocolHelpPopup = function ()
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:600,
        maxHeight:160,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: LangHelper.GetString("UlrModule","Remove protocols"), height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    view:"scrollview",
                    id:id + "scrollview",
                    scroll:"y",
                    borderless:true,
                    body:{
                        rows:[
                            {
                                template:"<div>" + LangHelper.GetString("UlrModule", "Protocols from the list will be removed from session policing profile.") + "</div>",
                                autoheight:true
                            }
                        ]
                    }

                }

            ]
        }
    };



    return webix.ui(view).show();
};

var UlrSessionPolicingTemplateConfigPopup = function (Params, table)
{
    var id = webix.uid();

    var view = {
        view:"window",
        css:"spectre-alert form_modal",
        id:id,
        maxWidth:800,
        maxHeight:800,
        close:true,
        modal:true,
        position:"center",
        head:{
            view:"toolbar", cols:[
                { view:"label", label: Params && Params.modal_title ? Params.modal_title : "Application list", height:68},
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ $$(id).close(); }}
            ]
        },
        headHeight:68,
        autofit:true,
        body: {
            type:"space",
            borderless: true,
            rows: [
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        table.ViewConfig
                    ]
                }

            ]
        }
    };
    return webix.ui(view).show();
};

const ResourceImportQoETables = {
    "fullflow": {value: LangHelper.GetString("AppView", "Raw full netflow"), id: "fullflow"},
    "fullflow_agg": {value: LangHelper.GetString("AppView", "Netflow"), id: "fullflow_agg"},
    "clickstream": {value: LangHelper.GetString("AppView", "Raw clickstream"), id: "clickstream"},
    "clickstream_agg": {value: LangHelper.GetString("AppView", "Clickstream"), id: "clickstream_agg"},
    "dnsflow": {value: LangHelper.GetString("AppView", "Raw DNS flow"), id: "dnsflow"},
    "dnsflow_agg": {value: LangHelper.GetString("AppView", "DNS flow"), id: "dnsflow_agg"}
}


function ResourceImportQoEModel(Params)
{
    this.qoe_table = Params && Params.qoe_table ? Params.qoe_table : ResourceImportQoETables.fullflow_agg.id;
    this.filter = Params && Params.filter ? Params.filter : [];
    this.settings = new ResourceImportQoESettingsModel(Params && Params.settings ? Params.settings : null);

    this.period_from = Params && Params.period_from ? Params.period_from : "now - 20 minutes";
    this.period_to = Params && Params.period_to ? Params.period_to : "now - 15 minutes";
}


const ResourceImportQoETableColumns = {
    "fullflow": {
        "subscriber": {value: LangHelper.GetString("QoE", "Subscriber"), id: "subscriber"},
        "subscriber_port": {value: LangHelper.GetString("QoE", "Subscriber port"), id: "subscriber_port"},
        "host": {value: LangHelper.GetString("QoE", "Host"), id: "host"},
        "host_ip": {value: LangHelper.GetString("QoE", "Host IP"), id: "host_ip"},
        "host_port": {value: LangHelper.GetString("QoE", "Host port"), id: "host_port"}
    },
    "fullflow_agg": {
        "subscriber": {value: LangHelper.GetString("QoE", "Subscriber"), id: "subscriber"},
        "host": {value: LangHelper.GetString("QoE", "Host"), id: "host"},
        "host_ip": {value: LangHelper.GetString("QoE", "Host IP"), id: "host_ip"}
    },
    "clickstream": {
        "subscriber": {value: LangHelper.GetString("QoE", "Subscriber"), id: "subscriber"},
        "host": {value: LangHelper.GetString("QoE", "Host"), id: "host"},
    },
    "clickstream_agg": {
        "subscriber": {value: LangHelper.GetString("QoE", "Subscriber"), id: "subscriber"},
        "host": {value: LangHelper.GetString("QoE", "Host"), id: "host"},
        "host_ip": {value: LangHelper.GetString("QoE", "Host IP"), id: "host_ip"}
    },
    "dnsflow": {
        "subscriber": {value: LangHelper.GetString("QoE", "Subscriber"), id: "subscriber"},
        "subscriber_port": {value: LangHelper.GetString("QoE", "Subscriber port"), id: "subscriber_port"},
        "host": {value: LangHelper.GetString("QoE", "Host"), id: "host"},
        "host_ip": {value: LangHelper.GetString("QoE", "DNS server IP"), id: "host_ip"},
        "host_port": {value: LangHelper.GetString("QoE", "DNS server port"), id: "host_port"},
        "host_ip_dns_data": {value: LangHelper.GetString("QoE", "Host IP"), id: "host_ip_dns_data"}
    },
    "dnsflow_agg": {
        "subscriber": {value: LangHelper.GetString("QoE", "Subscriber"), id: "subscriber"},
        "subscriber_port": {value: LangHelper.GetString("QoE", "Subscriber port"), id: "subscriber_port"},
        "host": {value: LangHelper.GetString("QoE", "Host"), id: "host"},
        "host_ip": {value: LangHelper.GetString("QoE", "DNS server IP"), id: "host_ip"},
        "host_port": {value: LangHelper.GetString("QoE", "DNS server port"), id: "host_port"},
        "host_ip_dns_data": {value: LangHelper.GetString("QoE", "Host IP"), id: "host_ip_dns_data"}
    }
}

function ResourceImportQoESettingsModel(Params)
{
    this.columns = Params && Params.columns ? Params.columns : ["host"];
    this.max_execute_time = Params && Params.max_execute_time ? Params.max_execute_time : 600;
    this.rows_limit = Params && Params.rows_limit ? parseInt(Params.rows_limit) : 1000;
    this.req_interval = Params && Params.req_interval ? Params.req_interval : 5;
    this.resource_lifetime = Params && Params.resource_lifetime ? Params.resource_lifetime : 30;
}

webix.protoUI({
    name: 'resource-filters-input',
    $init: function(config)
    {
        var _this = this;
        this.Id = webix.uid();
        this.FilterConfig = null;
        this.Editable = config.editable ? config.editable : false;
        this.Value = null;
        this.Views = {
            FilterTableToolbar: null,
            FilterTable: null,
            HelpContext: null,
            HelpContextBody: null
        };

        this.HelpContext = webix.ui({
            view: "popup",
            id:this.Id + "HelpContext",
            body:{
                borderless:true,
                rows:[
                    {
                        id:this.Id + "HelpContextBody",
                        rows:[{}]
                    }
                ]
            }
        });

        config.body = {
            margin: 0,
            borderless: true,
            rows: function()
            {
                var result = [BlockHeaderTemplate({title:LangHelper.GetString("QoEPopupFilterWidget", "Filters"), icon:"list"})];

                if(_this.Editable)
                {
                    result.push({
                        view: "toolbar",
                        id: _this.Id + "FilterTableToolbar",
                        height: 42,
                        elements: [
                            {
                                view: "button",
                                type: "icon",
                                icon: "plus",
                                css: "toolbar_round_btn",
                                width: 32,
                                tooltip: LangHelper.GetString("QoEPopupFilterWidget", "Add filter"),
                                click: function () {
                                    var model = new QoEPopupFilterWidgetFilterRowModel({f_enabled: 1});

                                    _this.Views.FilterTable.add(model, 0);
                                    _this.Views.FilterTable.select(model.id, false);
                                }
                            },
                            {}
                        ]
                    });
                }

                result.push({
                    view: "datatable",
                    id: _this.Id + "FilterTable",
                    select: "row",
                    borderless: true,
                    resizeColumn: true,
                    tooltip: true,
                    scroll: "xy",
                    editable: _this.Editable,
                    checkboxRefresh: true,
                    columns: function(){
                        var res = [
                            {
                                id: "f_id",
                                header: [TooltipTemplate(LangHelper.GetString("QoEPopupFilterWidget", "Filter"))],
                                fillspace: 1,
                                editor: _this.Editable ? "richselect" : null,
                                suggest: {fitMaster: false, width: 200},
                                options: [] //this.GetFiltersDic()
                            },
                            {
                                id: "f_operator",
                                header: [TooltipTemplate(LangHelper.GetString("QoEPopupFilterWidget", "Operator"))],
                                //fillspace:true,
                                editor: _this.Editable ? "richselect" : null,
                                options: function(){
                                    var res = [];

                                    Helper.EnumToArr(QoEFilterOperatorsEnum).forEach(function(obj){
                                        if(obj && obj.id && obj.id.indexOf("CIDR") === -1)
                                        {
                                            res.push(obj);
                                        }
                                    });

                                    return res;
                                }()
                            },
                            {
                                id: "f_value",
                                header: [TooltipTemplate(LangHelper.GetString("QoEPopupFilterWidget", "Value"))],
                                fillspace: 2,
                                editor: _this.Editable ? "text" : null,
                                template: function (obj)
                                {
                                    var r = obj.f_value;

                                    var filterConfig = _this.GetFilterConfigById(obj.f_id);

                                    if (filterConfig && filterConfig.dic && App.DicsManager.GetDic(filterConfig.dic)) {
                                        rArr = obj.f_value.split(",");

                                        if (rArr && rArr.length > 1) {
                                            r = "";

                                            rArr.forEach(function (Item, Index) {

                                                var item = App.DicsManager.GetDic(filterConfig.dic)[Item];

                                                item = item ? LangHelper.GetString("QoE", item.value) : Item;

                                                r += (Index > 0 ? ", " : "") + item;
                                            });
                                        } else {
                                            r = App.DicsManager.GetDic(filterConfig.dic)[obj.f_value];

                                            r = r ? LangHelper.GetString("QoE", r.value) : obj.f_value;
                                        }
                                    } else if (filterConfig && filterConfig.options) {
                                        filterConfig.options.forEach(function (option) {
                                            if (option.value && option.id === r) {
                                                r = option.value;
                                            }
                                        })
                                    }

                                    return r;
                                },
                                tooltip: function (obj, common) {
                                    var hText = _this.GetHelpTextByFilterConfig(obj);

                                    return hText ? hText : obj.f_value;
                                }
                            },
                            {
                                id: "help",
                                header: "",
                                width: 32,
                                tooltip: LangHelper.GetString("QoEPopupFilterWidget", "Details"),
                                template: function (obj) {
                                    var hText = _this.GetHelpTextByFilterConfig(obj);

                                    return hText ? CellHelpBtnTemplate() : "";
                                },
                                headermenu: false,
                                align: "right"
                            }
                        ];

                        if(_this.Editable)
                        {
                            res.push({
                                id:"clear",
                                width:32,
                                header:"",
                                headermenu:false,
                                tooltip: function(Obj)
                                {
                                    return Obj.f_value ? LangHelper.GetString("QoEPopupFilterWidget", "Clear value") : "";
                                },
                                template: function(Obj)
                                {
                                    return Obj.f_value ? CellBroomBtnTemplate() : "";
                                }
                            });

                            res.push({
                                id: "trash",
                                header: "",
                                width: 32,
                                template: CellTrashBtnTemplate,
                                headermenu: false,
                                tooltip: LangHelper.GetString("UsersActionsLog", "Delete"),
                                align: "right"
                            });
                        }


                        return res;
                    }(),
                    on: {
                        onItemClick: function (id, e, node) {
                            if (id.column === "clear") {
                                let item = this.getItem(id)
                                if(item.f_value)
                                {
                                    item.f_value = "";
                                    this.updateItem(item);
                                }
                            }

                            if (id.column === 'trash') {
                                this.editStop();
                                this.remove(id);
                            }

                            if (id.column === 'help') {
                                var obj = this.getItem(id);

                                var hText = _this.GetHelpTextByFilterConfig(obj);

                                if (hText)
                                    _this.ShowHelpContext(this.getItemNode(id), "bottom", hText);
                            }
                        },
                        onBeforeEditStart: function (id) {
                            this._lastEditColumn = id.column;

                            var config = this.getColumnConfig(id.column);

                            var item = this.getItem(id.row);

                            var editor = item.f_value_editor;

                            var operator = item.f_operator;

                            var f_id = item.f_id;

                            var filterConfig = _this.GetFilterConfigById(f_id);

                            if (id.column === "f_id") {
                                this._fIdColVal = item.f_id;
                            }

                            if (id.column == "f_value") {
                                config.collection = null;
                                config.popup = null;
                                config.$popup = null;

                                if (editor == "text" && (
                                    operator == QoEFilterOperatorsEnum.in ||
                                    operator == QoEFilterOperatorsEnum["not in"] ||
                                    operator == QoEFilterOperatorsEnum["in CIDRs"] ||
                                    operator == QoEFilterOperatorsEnum["not in CIDRs"] ||
                                    operator == QoEFilterOperatorsEnum.between ||
                                    operator == QoEFilterOperatorsEnum["not between"]))
                                {
                                    editor = "popup";
                                }

                                if (filterConfig && filterConfig.editor) {
                                    editor = filterConfig.editor;

                                }

                                if (filterConfig && filterConfig.dic) {
                                    config.collection = new webix.DataCollection(
                                        {
                                            data: App.DicsManager.GetDicAsArray(filterConfig.dic).map(function (Val) {
                                                return {
                                                    id: Val.id,
                                                    dic_id: Val.dic_id,
                                                    value: LangHelper.GetString("QoE", Val.value)
                                                }
                                            })
                                                .sort(function (a, b) {
                                                    if (a.value > b.value) {
                                                        return 1;
                                                    }
                                                    if (a.value < b.value) {
                                                        return -1;
                                                    }
                                                    return 0;
                                                })
                                        }
                                    );
                                }

                                if (filterConfig && filterConfig.options) {
                                    config.collection = new webix.DataCollection({data: filterConfig.options});
                                }

                                config.editor = editor;

                                if(editor === "popup")
                                    _this.PopupEditorIsOpen = true;
                            }

                            if (id.column == "f_operator") {
                                var list = config.collection;

                                if (filterConfig && filterConfig.operators && filterConfig.operators.length) {
                                    list.filter(function (obj) {
                                        return filterConfig.operators.indexOf(obj.id) != -1;
                                    });
                                }
                                else if (filterConfig && !filterConfig.can_cidr)
                                {
                                    list.filter(function (obj) {
                                        return obj.id != "in CIDRs" && obj.id != "not in CIDRs";
                                    });
                                } else {
                                    list.filter("id", null);
                                }
                            }
                        },
                        onAfterEditStop: function (state, id, ignore) {
                            var item = this.getItem(id.row);

                            var filterConfig = _this.GetFilterConfigById(item.f_id);

                            if (filterConfig && filterConfig.operators && filterConfig.operators.length) {
                                if (filterConfig.operators.indexOf(item.f_operator) < 0) {
                                    item.f_operator = filterConfig.operators[0];
                                }
                            } else if (filterConfig && !filterConfig.can_cidr) {
                                if (item.f_operator == "in CIDRs" || item.f_operator == "not in CIDRs") {
                                    item.f_operator = QoEFilterOperatorsEnum.like;
                                }
                            }

                            if (!item.f_operator)
                                item.f_operator = QoEFilterOperatorsEnum.like;

                            if (id.column === "f_id") {
                                if (item.f_id !== this._fIdColVal)
                                {
                                    item.f_value = "";
                                }
                            }
                        }
                    }
                });

                return result;
            }()
        };

        this.$ready.push(() => {
            Object.keys(this.Views).forEach(Key => {
                this.Views[Key] = $$(this.Id + Key);
            });


            if(config.qoe_table)
            {
                this.updateFilterConfig(config.qoe_table);

                this.setValue(this.Value ? this.Value : config.value);
            }

        });
    },
    updateFilterConfig: function(Value)
    {
        var filter_type = QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNetFlow;
        if(Value == ResourceImportQoETables.fullflow_agg.id)
        {
            filter_type = QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;
        }
        else if(Value == ResourceImportQoETables.clickstream.id)
        {
            filter_type = QoEPopupFilterWidgetConfigTypeEnum.QoERawClickstreamLogs;
        }
        else if(Value == ResourceImportQoETables.clickstream_agg.id)
        {
            filter_type = QoEPopupFilterWidgetConfigTypeEnum.QoEClickstream;
        }
        else if(Value == ResourceImportQoETables.dnsflow.id)
        {
            filter_type = QoEPopupFilterWidgetConfigTypeEnum.QoEFullDnsFlow;
        }
        else if(Value == ResourceImportQoETables.dnsflow_agg.id)
        {
            filter_type = QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDnsFlow;
        }

        this.FilterConfig = QoEPopupFilterWidgetDefaultConfig(filter_type);

        this.Views.FilterTable.config.columns = this.Views.FilterTable.config.columns.map(column => {
            if(column.id === "f_id") {
                return {
                    id:"f_id",
                    header:[TooltipTemplate(LangHelper.GetString("QoEPopupFilterWidget", "Filter"))],
                    fillspace:1,
                    editor:"richselect",
                    suggest:{fitMaster:false, width:200},
                    options:this.GetFiltersDic()
                };
            }
            return column;
        });

        this.Views.FilterTable.refreshColumns();
    },
    setValue: function(Value)
    {
        this.Value = Value;
        if(this.Views.FilterTable)
        {
            this.Views.FilterTable.clearAll();
            this.Views.FilterTable.parse(Value);
        }
    },
    getValue: function()
    {
        return this.Views.FilterTable.serialize();
    },
    GetFilterConfigById: function(FilterId)
    {
        var config = null;

        if(this.FilterConfig && this.FilterConfig.filters && FilterId)
        {
            this.FilterConfig.filters.every(function(Filter){
                if(Filter.id == FilterId)
                {
                    config = webix.copy(Filter);
                    return false;
                }

                return true;
            });
        }

        return config;
    },
    GetHelpTextByFilterConfig: function(FRow)
    {
        var filterConfig = this.GetFilterConfigById(FRow.f_id);

        var noHelpFilters = ["locked", "blocked"];

        if(noHelpFilters.includes(FRow.f_id))
            return null;

        if((
            FRow.f_operator == QoEFilterOperatorsEnum.in ||
            FRow.f_operator == QoEFilterOperatorsEnum["not in"] ||
            FRow.f_operator == QoEFilterOperatorsEnum["in CIDRs"] ||
            FRow.f_operator == QoEFilterOperatorsEnum["not in CIDRs"] ||
            FRow.f_operator == QoEFilterOperatorsEnum.between ||
            FRow.f_operator == QoEFilterOperatorsEnum["not between"]) && !(filterConfig && filterConfig.dic))
        {
            return LangHelper.GetString("QoEPopupFilterWidget", "Values are separated by a new line. Use Shift + Enter to make new line.");
        }

        if(FRow.f_operator == QoEFilterOperatorsEnum.match || FRow.f_operator == QoEFilterOperatorsEnum["not match"])
        {
            return LangHelper.GetString("QoEPopupFilterWidget", "Use regular expression with RE2 syntax.") +
                "<br/>" +
                "<a href='https://support.google.com/a/answer/1371417?hl=" + LangHelper.GetLocale() + "' target='_blank'>" + LangHelper.GetString("QoE", "Link") + " 1</a>" +
                "<br/>" +
                "<a href='https://github.com/google/re2/wiki/Syntax' target='_blank'>" + LangHelper.GetString("QoE", "Link") + " 2</a>" +
                "<br/>" +
                "<a href='https://github.com/google/re2' target='_blank'>" + LangHelper.GetString("QoE", "Link") + " 3</a>";
        }

        if(FRow.f_operator == QoEFilterOperatorsEnum.like || FRow.f_operator == QoEFilterOperatorsEnum["not like"])
        {
            return LangHelper.GetString("QoEPopupFilterWidget", "Checks whether a string matches a simple regular expression.");
        }

        return null;
    },
    GetFiltersDic: function()
    {
        var filters = [];

        if(this.FilterConfig && this.FilterConfig.filters)
        {
            this.FilterConfig.filters.forEach(function (Filter)
            {
                filters.push({id:Filter.id, value:Filter.title});
            });
        }

        return filters;
    },
    SetHelpContextBodyText: function(Text)
    {
        this.Views.HelpContextBody.define("rows",[{template:Text}]);
        this.Views.HelpContextBody.reconstruct();
    },
    ShowHelpContext: function(Node, Pos, Text)
    {
        if(Text)
            this.SetHelpContextBodyText(Text);

        this.HelpContext.show(Node, {pos:Pos});
    }
}, webix.ui.forminput)

webix.protoUI({
    name: 'resource-settings-input',
    $init: function(config)
    {
        var _this = this;
        this.Id = webix.uid();

        this.Views = {
            Form: null,
            ColumnsSelect: null
        };

        this.Value = null;

        config.body = {
            margin: 0,
            borderless: true,
            rows: [
                {
                    view: "form",
                    id: _this.Id + "Form",
                    type: "wide",
                    elements: [
                        {
                            view: "spectre_multiselect",
                            id: _this.Id + "ColumnsSelect",
                            name: "columns",
                            invalidMessage: LangHelper.GetString("Dics", "Should be selected at least 1 column"),
                            label: LangHelper.GetString("Dics", "Columns"),
                            options: Helper.DictToArr(ResourceImportQoETableColumns[ResourceImportQoETables.fullflow_agg.id]),
                            validate: webix.rules.isNotEmpty
                        },
                        {
                            view: "spectre_text",
                            name: "resource_lifetime",
                            label: LangHelper.GetString("Dics", "Imported resource lifetime, days"),
                            invalidMessage: LangHelper.GetString("Dics", "Input correct number"),
                            validate: function(Val)
                            {
                                if(!Val)
                                    return false;

                                if(!!isNaN(Val * 1))
                                    return false;

                                var v = parseInt(Val);

                                return v > 0;
                            }
                        },
                        {
                            view: "spectre_text",
                            name: "req_interval",
                            label: LangHelper.GetString("Dics", "Requests interval, minutes"),
                            invalidMessage: LangHelper.GetString("Dics", "Input correct number") + ". " + LangHelper.GetString("Dics", "Minimal interval is 5 minutes."),
                            validate: function(Val)
                            {
                                if(!Val)
                                    return false;

                                if(!!isNaN(Val * 1))
                                    return false;

                                var v = parseInt(Val);

                                return v >= 5;
                            }
                        },
                        {
                            name: "max_execute_time",
                            view: "spectre_richselect",
                            label: LangHelper.GetString("QoE", "Maximum execute time"),
                            options: [
                                {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                            ],
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("QoE", "Select an option")
                        },
                        {
                            view: "spectre_text",
                            name: "rows_limit",
                            label: LangHelper.GetString("AppView", "Rows limit"),
                            invalidMessage: LangHelper.GetString("Dics", "Input correct number"),
                            validate: function(Val)
                            {
                                if(!Val)
                                    return false;

                                if(!!isNaN(Val * 1))
                                    return false;

                                var v = parseInt(Val);

                                return v > 0 && v < 1000000;
                            }
                        }
                    ]
                }
            ]
        };

        this.$ready.push(() => {
            Object.keys(this.Views).forEach(Key => {
                this.Views[Key] = $$(this.Id + Key);
            });

            if(config.qoe_table)
            {
                this.setValue(this.Value ? this.Value : config.value);
                this.updateColumnDict(config.qoe_table, this.Value && this.Value.columns ? this.Value.columns : config.value.columns);

            }
        });
    },
    setValue: function(Value)
    {
        this.Value = Value;
        if(this.Views.Form)
        {
            this.Views.Form.setValues(Value);
        }
    },
    getValue: function()
    {
        var data = this.Views.Form.getValues();
        if(typeof data.columns == "string")
        {
            data.columns = data.columns.split(",");
        }
        return data;
    },
    updateColumnDict: function(Table, Columns)
    {
        var select = this.Views.ColumnsSelect;
        var table = Table ? Table : ResourceImportQoETables.fullflow_agg.id;

        var filtered_val = [];
        if(ResourceImportQoETableColumns[table])
        {
            var dict = ResourceImportQoETableColumns[table];
            var arr = Helper.DictToArr(ResourceImportQoETableColumns[table]);
            var list = select.getList();
            list.clearAll();
            list.parse(arr);

            var col_vals = Columns;
            if(!col_vals)
            {
                col_vals = this.Value.columns;
            }

            col_vals.forEach(function(val){
                if(val && dict[val])
                {
                    filtered_val.push(val);
                }
            });

            select.setValue(filtered_val);
        }

        return filtered_val

    },

    isValid: function()
    {
        return this.Views.Form.validate();
    }
}, webix.ui.forminput);

webix.protoUI(
    {
        name: 'resource-import-qoe-input',
        $init: function(config)
        {
            var _this = this;
            this.Id = webix.uid();

            this.Signals = {
                ValueChanged: new Rx.BehaviorSubject(0)
            };

            this.Value = new ResourceImportQoEModel();

            this.FilterConfig = null;

            this.Views = {
                Form: null,
                TableSelect: null,
                SettingsBtn: null,
                FilterBtn: null,
                SettingsPopupHeader: null,
                SettingsForm: null,
                ColumnsSelect: null,
                FilterForm: null,
                FiltersInput: null,
                SettingsInput: null
            };

            this.FilterPopup = webix.ui({
                view: "popup",
                modal: true,
                position: "center",
                padding: 20,
                margin: 0,
                width: 640,
                height: 640,
                body: {
                    rows: [
                        {height: 20},
                        BlockHeaderTemplate({
                            title:LangHelper.GetString("QoE", "Filter"),
                            icon:"",
                            borderless:true,
                            css: "custom-font-size_20"
                        }),
                        {height:20},
                        {
                            type: "space",
                            borderless: true,
                            rows: [
                                {
                                    type: "clean",
                                    borderless: true,
                                    rows: [
                                        {
                                            view: "form",
                                            id: _this.Id + "FilterForm",
                                            type: "wide",
                                            elements: [
                                                {
                                                    cols: [
                                                        {
                                                            view: "spectre_richselect",
                                                            name: "period_from",
                                                            label: LangHelper.GetString("QoE","Period from"),
                                                            options:function ()
                                                            {
                                                                var o = [];

                                                                Object.keys(QoETriggerPeriodRangesEnum).forEach(function (Key) {
                                                                    o.push({id:Key, value:LangHelper.GetString("QoE",Key)})
                                                                });

                                                                return o;
                                                            }()
                                                        },
                                                        {
                                                            view: "spectre_richselect",
                                                            name: "period_to",
                                                            label: LangHelper.GetString("QoE","Period to"),
                                                            options:function ()
                                                            {
                                                                var o = [];

                                                                Object.keys(QoETriggerPeriodRangesEnum).forEach(function (Key) {
                                                                    o.push({id:Key, value:LangHelper.GetString("QoE",Key)})
                                                                });

                                                                return o;
                                                            }()
                                                        }
                                                    ]
                                                },
                                                {
                                                    id: _this.Id + "FiltersInput",
                                                    view: "resource-filters-input",
                                                    name: "filters",
                                                    editable: true,
                                                    label: false,
                                                    labelWidth: 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {height: 30},
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    css:"form_button third_action",
                                    height: 40,
                                    label:LangHelper.GetString("Dics","Cancel"),
                                    click:function () {
                                        _this.FilterPopup.hide();
                                    }
                                },
                                {width: 20},
                                {
                                    view:"button",
                                    type:"form",
                                    css:"form_button main_action",
                                    height: 40,
                                    label:LangHelper.GetString("Dics","Apply"),
                                    click:function ()
                                    {
                                        _this.applyFilters();
                                    }
                                }
                            ]
                        },
                        {height:20}
                    ]
                }
            });

            this.SettingsPopup = webix.ui({
                view: "popup",
                modal: true,
                position: "center",
                padding: 20,
                margin: 0,
                width: 400,
                height: 640,
                body: {
                    rows: [
                        {height: 20},
                        BlockHeaderTemplate({
                            title:LangHelper.GetString("QoE", "Settings"),
                            icon:"",
                            borderless:true,
                            css: "custom-font-size_20"
                        }),
                        {height:20},
                        {
                            type: "space",
                            borderless: true,
                            rows: [
                                {
                                    type: "clean",
                                    borderless: true,
                                    rows: [
                                        {
                                            view: "form",
                                            id: _this.Id + "SettingsForm",
                                            type: "wide",
                                            elements: [
                                                {
                                                    view: "resource-settings-input",
                                                    name: "settings",
                                                    id: _this.Id + "SettingsInput",
                                                    label: false,
                                                    labelWidth: 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {height: 30},
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    css:"form_button third_action",
                                    height: 40,
                                    label:LangHelper.GetString("Dics","Cancel"),
                                    click:function () {
                                        _this.SettingsPopup.hide();
                                    }
                                },
                                {width: 20},
                                {
                                    view:"button",
                                    type:"form",
                                    css:"form_button main_action",
                                    height: 40,
                                    label:LangHelper.GetString("Dics","Apply"),
                                    click:function ()
                                    {
                                        _this.applySettings();
                                    }
                                }
                            ]
                        },
                        {height:20}
                    ]
                }
            });

            config.body = {
                margin: 0,
                rows:[
                    {
                        view: "form",
                        id: this.Id + "Form",
                        margin:0,
                        type: "wide",
                        css: config.css ? config.css : "",
                        borderless: true,
                        elements: [
                            {
                                type:"clean",
                                cols: [
                                    {
                                        view: config.type == "ulr" || config.type == "custom_prtcls" ? "spectre_richselect" : "richselect",
                                        id: this.Id + "TableSelect",
                                        name: "qoe_table",
                                        value: ResourceImportQoETables.fullflow_agg.id,
                                        label: LangHelper.GetString("Dics", "QoE table"),
                                        options: Helper.DictToArr(ResourceImportQoETables),
                                        // css: config.type == "custom_prtcls" ? "spectre_bg_select" : ""
                                    },
                                    {
                                        id: this.Id + "SettingsBtn",
                                        view: "button",
                                        type: "icon",
                                        icon: "gear",
                                        css: "toolbar_round_btn",
                                        width: 48,
                                        tooltip: LangHelper.GetString("Dics", "Settings"),
                                        badge: 0,
                                        click: function(id, e, node)
                                        {
                                            _this.showSettingsPopup();
                                        }
                                    },
                                    {
                                        view: "button",
                                        id:this.Id+"FilterBtn",
                                        type: "icon",
                                        icon: "filter",
                                        css: "toolbar_round_btn",
                                        width: 48,
                                        tooltip: LangHelper.GetString("Dics", "Filter"),
                                        badge: 0,
                                        click: function (id, e, node)
                                        {
                                            _this.showFiltersPopup();
                                            // _this.Show(this.getNode(),"bottom");
                                        }
                                    }
                                ]
                            }
                        ]
                    }

                ]
            };


            this.Ready = false;
            this.$ready.push(() => {
                Object.keys(this.Views).forEach(Key => {
                    this.Views[Key] = $$(this.Id + Key);
                });

                _this.Views.TableSelect.attachEvent("onChange", function(Nv){
                    _this.onSelectedTableChanged(Nv);

                    if(_this.Ready)
                    {
                        _this.Signals.ValueChanged.next(1);
                    }
                });

                this.setValue();

                this.Ready = true;
            });
        },
        applySettings: function()
        {
            var _this = this;

            if(!this.Views.SettingsInput.isValid())
            {
                return;
            }

            var data = this.Views.SettingsInput.getValue();

            this.Value.settings.columns = data.columns;
            this.Value.settings.max_execute_time = parseInt(data.max_execute_time);
            this.Value.settings.req_interval = parseInt(data.req_interval);
            this.Value.settings.resource_lifetime = parseInt(data.resource_lifetime);

            this.updateSettingsBadge();

            this.SettingsPopup.hide();

            if(_this.Ready)
            {
                _this.Signals.ValueChanged.next(1);
            }
        },
        applyFilters: function()
        {
            var _this = this;

            var data = this.Views.FilterForm.getValues();
            // var filters = this.Views.FilterTable.serialize();

            this.Value.period_from = data.period_from;
            this.Value.period_to = data.period_to;

            this.Value.filter = data.filters;

            this.updateFiltersBadge();
            this.FilterPopup.hide();

            if(_this.Ready)
            {
                _this.Signals.ValueChanged.next(1);
            }
        },
        updateSettingsBadge: function()
        {
            this.Views.SettingsBtn.define({badge: Object.keys(this.Value.settings).length + this.Value.settings.columns.length - 1});
            this.Views.SettingsBtn.refresh();
        },
        updateFiltersBadge: function()
        {
            this.Views.FilterBtn.define({badge: this.Value.filter.length + 2});
            this.Views.FilterBtn.refresh();
        },
        onSelectedTableChanged: function(Val)
        {
            var _this = this;

            var dict_key = Val ? Val : ResourceImportQoETables.fullflow_agg.id;

            if(ResourceImportQoETableColumns[dict_key])
            {
                this.Value.qoe_table = dict_key;

                this.Value.settings.columns = this.Views.SettingsInput.updateColumnDict(dict_key, this.Value.settings.columns);

                this.updateSettingsBadge();
            }
        },
        showFiltersPopup: function()
        {
            var _this = this;

            this.Views.FilterForm.setValues(this.Value);

            this.Views.FiltersInput.updateFilterConfig(this.Value.qoe_table);
            this.Views.FiltersInput.setValue(this.Value.filter);

            this.FilterPopup.show();
        },
        showSettingsPopup: function()
        {
            this.Views.SettingsInput.setValue(this.Value.settings);

            this.SettingsPopup.show();
        },
        setValue: function(Value)
        {
            var val = null;
            try{
                if(Value)
                {
                    if(typeof Value === "string")
                    {
                        val = JSON.parse(Value);
                    }
                    else if(typeof Value === "object")
                    {
                        val = Value;
                    }
                }
            }
            catch(e)
            {
                val = null;
            }
            val = new ResourceImportQoEModel(val);
            this.Value = val;
            this.Views.TableSelect.setValue(val.qoe_table);

            this.updateSettingsBadge();
            this.updateFiltersBadge();
        },
        getValue: function()
        {
            var model = this.getValueAsModel();
            return JSON.stringify(model);
        },
        getValueAsModel: function()
        {
            return new ResourceImportQoEModel(this.Value);
        }
    },
    webix.ui.forminput
);

var ResourceImportQoEPopupItem = function(Params)
{
    var _this = this;
    this.Id = webix.uid();
    this.Config = new ResourceImportQoEModel(Params && Params.cfg ? JSON.parse(Helper.ReplaceAll("\n", "\\n", Params.cfg)) : null);
    this.Editable = Params && Params.editable ? Params.editable : false;

    this.Views = {
        SettingsInput: null,
        FilterInput: null,
        PeriodFrom: null,
        PeriodTo: null
    };

    this.View = webix.ui({
        view: "popup",
        id: this.Id,
        css: Params && Params.css ? Params.css : "",
        width: Params && Params.width ? Params.width : 880,
        height: Params && Params.height ? Params.height : 640,
        close: true,
        modal: true,
        position: "center",
        autofit: true,
        padding: 20,
        margin: 0,
        body: {
            rows: [
                BlockHeaderTemplate({
                    title:ResourceImportQoETables[this.Config.qoe_table].value,
                    icon:null,
                    borderless:true,
                    height: 40,
                    css: "custom-font-size_20"
                }),
                {
                    type: "clean",
                    cols: [
                        {
                            gravity: 1,
                            rows: [
                                BlockHeaderTemplate({
                                    title:LangHelper.GetString("Dics", "Settings"),
                                    icon:"gear",
                                    borderless:true,
                                    // css: "custom-font-size_20"
                                }),
                                {
                                    type: "space",
                                    borderless: true,
                                    rows: [
                                        {
                                            type: "clean",
                                            borderless: true,
                                            rows: [
                                                {
                                                    view: "form",
                                                    type: "wide",
                                                    elements: [
                                                        {
                                                            view: 'resource-settings-input',
                                                            name: "settings",
                                                            id: _this.Id + "SettingsInput",
                                                            label: false,
                                                            labelWidth: 0,
                                                            value: this.Config.settings,
                                                            qoe_table: this.Config.qoe_table
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            gravity: 2,
                            rows: [
                                BlockHeaderTemplate({
                                    title:LangHelper.GetString("Dics", "Filter"),
                                    icon:"filter",
                                    borderless:true,
                                    // css: "custom-font-size_20"
                                }),
                                {
                                    type: "space",
                                    borderless: true,
                                    rows: [
                                        {
                                            type: "clean",
                                            borderless: true,
                                            rows: [
                                                {
                                                    view: "form",
                                                    type: "wide",
                                                    elements: [
                                                        {
                                                            cols: [
                                                                {
                                                                    view: "spectre_richselect",
                                                                    name: "period_from",
                                                                    id: _this.Id + "PeriodFrom",
                                                                    label: LangHelper.GetString("QoE","Period from"),
                                                                    value: this.Config.period_from,
                                                                    options:function ()
                                                                    {
                                                                        var o = [];

                                                                        Object.keys(QoETriggerPeriodRangesEnum).forEach(function (Key) {
                                                                            o.push({id:Key, value:LangHelper.GetString("QoE",Key)})
                                                                        });

                                                                        return o;
                                                                    }()
                                                                },
                                                                {
                                                                    view: "spectre_richselect",
                                                                    name: "period_to",
                                                                    id: _this.Id + "PeriodTo",
                                                                    label: LangHelper.GetString("QoE","Period to"),
                                                                    value: this.Config.period_to,
                                                                    options:function ()
                                                                    {
                                                                        var o = [];

                                                                        Object.keys(QoETriggerPeriodRangesEnum).forEach(function (Key) {
                                                                            o.push({id:Key, value:LangHelper.GetString("QoE",Key)})
                                                                        });

                                                                        return o;
                                                                    }()
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            view: "resource-filters-input",
                                                            name: "filters",
                                                            id: this.Id + "FilterInput",
                                                            label: false,
                                                            labelWidth: 0,
                                                            editable: this.Editable,
                                                            value: this.Config.filter,
                                                            qoe_table: this.Config.qoe_table
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {height: 20},
                            ]
                        }
                    ]
                },
                {height: 20},
                {
                    cols: function()
                    {
                        var res = [{}];

                        if(_this.Editable)
                        {
                            res.push({
                                view:"button",
                                css:"form_button",
                                height: 40,
                                label:LangHelper.GetString("Dics","Cancel"),
                                click:function () {
                                    _this.View.hide();
                                }
                            });

                            res.push({width: 8});

                            res.push({
                                view: "button",
                                css:"form_button main_action",
                                height: 40,
                                label:LangHelper.GetString("Dics","Apply"),
                                click:function () {
                                    if(Params && Params.update_config && typeof Params.update_config === "function")
                                    {
                                        var settings_input = $$(_this.Id + "SettingsInput");
                                        if(!settings_input.isValid())
                                        {
                                            return;
                                        }
                                        var model = new ResourceImportQoEModel();
                                        model.qoe_table = _this.Config.qoe_table;
                                        model.period_from = $$(_this.Id + "PeriodFrom").getValue();
                                        model.period_to = $$(_this.Id + "PeriodTo").getValue();
                                        model.settings = settings_input.getValue();
                                        model.filter = $$(_this.Id + "FilterInput").getValue();

                                        Params.update_config(model);
                                    }
                                    _this.View.hide();
                                }
                            });

                        }
                        else
                        {
                            res.push({});
                            res.push({
                                view:"button",
                                css:"form_button main_action",
                                height: 40,
                                label:LangHelper.GetString("Dics","Close"),
                                click:function () {
                                    _this.View.hide();
                                }
                            });
                        }

                        return res;
                    }()
                },
                {height: 20}
            ]
        }
    });

    this.View.show(Params && Params.node ? Params.node : null, {pos:Params&&Params.position ? Params.position : "bottom"});
};
function UlrSideBarWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;

    this.SideBarData = [
        {
            id:"UlrWebIpFilterRules", href:"#UlrWebIpFilterRules", icon:"filter", value:LangHelper.GetString("UlrModule","Web filter"), section:RoleSectionsEnum.ulr_web_rules,
            data:[
                {id:"UlrAddWebIpFilterRule", href:"#UlrAddWebIpFilterRule", value:LangHelper.GetString("UlrModule","Add new rule"), section:RoleSectionsEnum.ulr_web_rules},
                {id:"UlrCheckDomain", href:"#UlrCheckDomain", value:LangHelper.GetString("UlrModule","Check domain"), section:RoleSectionsEnum.ulr_web_rules},
                {id:"UlrExcludedResources", href:"#UlrExclusionList", value:LangHelper.GetString("UlrModule","Exclusion list"), section:RoleSectionsEnum.ulr_web_rules},
                {id:"UlrWebSearchDatabase", href:"#UlrWebSearchDatabase", value:LangHelper.GetString("UlrModule","Search database"), section:RoleSectionsEnum.ulr_web_rules},
                {id:"UlrWebRulesStatistics", href:"#UlrWebRulesStatistics", value:LangHelper.GetString("UlrModule","Rules statistics"), section:RoleSectionsEnum.ulr_web_rules},
                {id:"UlrHostCategories", href:"#UlrHostCategories", value:LangHelper.GetString("UlrModule","Host categories"), section:RoleSectionsEnum.ulr_hosts_list}
            ]
        },
        {
            id:"UlrSpoofDnsRules", href:"#UlrSpoofDnsRules", icon:"reply", value:LangHelper.GetString("UlrModule","Spoof DNS"), section:RoleSectionsEnum.ulr_spoof_dns,
            data:[
                {id:"UlrAddSpoofDnsRule", href:"#UlrAddSpoofDnsRule", value:LangHelper.GetString("UlrModule","Add new rule"), section:RoleSectionsEnum.ulr_spoof_dns}
            ]
        },
        {id:"_UlrIgwPolicings", href:"#UlrAppPolicings", icon:"router", value:LangHelper.GetString("UlrModule","Bandwidth management"), section:RoleSectionsEnum.ulr_policings,
            data:[
                {id:"UlrIgwPolicings", href:"#UlrIgwPolicings", value:LangHelper.GetString("UlrModule","IGW policing"), section:RoleSectionsEnum.ulr_policings},
                {id:"UlrAppDscpRules", href:"#UlrAppDscpRules", value:"&#x2022; "  + LangHelper.GetString("UlrModule","DSCP rules"), section:RoleSectionsEnum.ulr_policings},
                {id:"UlrAppPolicings", href:"#UlrAppPolicings", value:LangHelper.GetString("UlrModule","ISP policing"), section:RoleSectionsEnum.ulr_policings},
                {id:"UlrIspSessionPolicings", href:"#UlrIspSessionPolicings", value:"&#x2022; " + LangHelper.GetString("UlrModule","ISP session policing"), section:RoleSectionsEnum.ulr_policings},
                {id:"UlrSubscribersPolicings", href:"#UlrSubscribersPolicings", value:LangHelper.GetString("UlrModule","Subscribers policing"), section:RoleSectionsEnum.ulr_policings},
                {id:"UlrSubscribersSessionPolicings", href:"#UlrSubscribersSessionPolicings", value:"&#x2022; " + LangHelper.GetString("UlrModule","Subscribers session policing"), section:RoleSectionsEnum.ulr_policings},
                {id:"UlrAppProtocols", href:"#UlrAppProtocols", value:LangHelper.GetString("UlrModule","Protocols list"), section:RoleSectionsEnum.ulr_policings}
            ]
        },
        {
            id:"_UlrAppCustomProtocols", href:"#UlrAppCustomProtocols", icon:"cloud", value: LangHelper.GetString("UlrModule", "Custom Protocols"), section:RoleSectionsEnum.ulr_custom_prtcls,
            data:[
                {id:"UlrAppCustomProtocols", href:"#UlrAppCustomProtocols", value: LangHelper.GetString("UlrModule", "Custom Protocols"), section:RoleSectionsEnum.ulr_custom_prtcls},
                {id:"UlrAppGroupsCustomProtocols", href:"#UlrAppGroupsCustomProtocols", value: LangHelper.GetString("UlrModule", "Custom Protocols groups"), section:RoleSectionsEnum.ulr_custom_prtcls},
                {id:"UlrCheckResourcesIntersection", href:"#UlrCheckResourcesIntersection", value: LangHelper.GetString("UlrModule", "Check resource"), section:RoleSectionsEnum.ulr_custom_prtcls},
                {id:"UlrAppPrtclsCustomLogs", href:"#UlrAppPrtclsCustomLogs", value: LangHelper.GetString("UlrModule", "Logs"), section:RoleSectionsEnum.ulr_custom_prtcls},
                {id: "UlrFastresourceCustomPrtcls", href: "#UlrFastresourceCustomPrtcls", value: LangHelper.GetString("UlrModule", "ULR_FASTRESOURCE"), section: RoleSectionsEnum.ulr_custom_prtcls}
            ]
        },
        {
            id:"_UlrAsnDscpRules", href:"#UlrAsnDscpRules", icon:"solar-system", value:LangHelper.GetString("UlrModule","AS & DSCP"), section:RoleSectionsEnum.ulr_as_rules,
            data:[
                {id:"UlrAsnDscpRules", href:"#UlrAsnDscpRules", value:LangHelper.GetString("UlrModule","AS DSCP rules"), section:RoleSectionsEnum.ulr_as_rules},
                {id:"UlrAsnRuleList", href:"#UlrAsnRuleList", value:LangHelper.GetString("UlrModule","AS resource list"), section:RoleSectionsEnum.ulr_as_rules},
                {id:"UlrAddAsnDscpRule", href:"#UlrAddAsnDscpRule", value:LangHelper.GetString("UlrModule","Add AS"), section:RoleSectionsEnum.ulr_as_rules}
            ]
        },
        {id:"_UlrIpExcludesRules", href:"#UlrIpExcludesRules", icon:"unlink", value:LangHelper.GetString("UlrModule","IP & ASN excludes"), section:RoleSectionsEnum.ulr_excludes,
            data:[
                {id:"UlrIpExcludesRules", href:"#UlrIpExcludesRules", value:LangHelper.GetString("UlrModule","IP excludes"), section:RoleSectionsEnum.ulr_excludes},
                {id:"UlrAsnExcludesRules", href:"#UlrAsnExcludesRules", value:LangHelper.GetString("UlrModule","ASN excludes"), section:RoleSectionsEnum.ulr_excludes},
                {id:"UlrVipSubscribersRules", href:"#UlrVipSubscribersRules", value:LangHelper.GetString("UlrModule","VIP subscribers"), section:RoleSectionsEnum.ulr_excludes},
            ]
        },
        {id:"UlrWhiteList", href:"#UlrWhiteList", icon:"list", value:LangHelper.GetString("UlrModule","Whitelist"), section:RoleSectionsEnum.ulr_white_rules,
            data:[
                {id:"UlrAddWhiteListRule", href:"#UlrAddWhiteListRule", value:LangHelper.GetString("UlrModule","Add new rule"), section:RoleSectionsEnum.ulr_white_rules},
                {id:"UlrWhiteListMode", href:"#UlrWhiteListMode", value:LangHelper.GetString("UlrModule","Mode"), section:RoleSectionsEnum.ulr_white_rules}
            ]
        },
        {id:"_UlrIspsList", href:"#UlrIspsList", icon:"address-card", value:LangHelper.GetString("UlrModule","Profile management"), section:RoleSectionsEnum.ulr_isp_igw_profiles,
            data:[
                {id:"UlrIspsList", href:"#UlrIspsList", value:LangHelper.GetString("UlrModule","Channels management"), section:RoleSectionsEnum.ulr_isp_igw_profiles},
                {id:"UlrAddIsp", href:"#UlrAddIsp", value:LangHelper.GetString("UlrModule","Add new channel"), section:RoleSectionsEnum.ulr_isp_igw_profiles},
                {id:"UlrSubsList", href:"#UlrSubsList", value:LangHelper.GetString("UlrModule","Subscribers list"), section:RoleSectionsEnum.ulr_isp_igw_profiles},
                {id:"UlrAddSubs", href:"#UlrAddSubs", value:LangHelper.GetString("UlrModule","Add new subscriber"), section:RoleSectionsEnum.ulr_isp_igw_profiles},
                {id:"UlrIgwsList", href:"#UlrIgwsList", value:LangHelper.GetString("UlrModule","Sites list"), section:RoleSectionsEnum.ulr_isp_igw_profiles},
                {id:"UlrAddIgw", href:"#UlrAddIgw", value:LangHelper.GetString("UlrModule","Add new site"), section:RoleSectionsEnum.ulr_isp_igw_profiles}
            ]
        },
        {id:"_UlrRecordPCAP", href:"#UlrRecordPCAP", icon:"paperclip", value:LangHelper.GetString("UlrModule","PCAP recording"), section:RoleSectionsEnum.ulr_record_pcap,
            data:[
                {id:"UlrRecordPCAP", href:"#UlrRecordPCAP", value:LangHelper.GetString("UlrModule","PCAP rules"), section:RoleSectionsEnum.ulr_record_pcap},
                {id:"UlrPCAPFiles", href:"#UlrPCAPFiles", value:LangHelper.GetString("UlrModule","Files"), section:RoleSectionsEnum.ulr_record_pcap},
                {id:"UlrPCAPLogs", href:"#UlrPCAPLogs", value:LangHelper.GetString("UlrModule","Logs"), section:RoleSectionsEnum.ulr_record_pcap}
            ]
        },
        {id:"UlrSearchDatabase", href:"#UlrSearchDatabase", icon:"search", value:LangHelper.GetString("UlrModule","Database search"), section:RoleSectionsEnum.ulr_db_search, data:[]},
        {id:"_UlrSytemGlobalState", href:"#UlrSytemGlobalState", icon:"thermometer", value:LangHelper.GetString("UlrModule","System global state"), section:RoleSectionsEnum.ulr_system_state,
            data:[
                {id:"UlrSytemGlobalState", href:"#UlrSytemGlobalState", value:LangHelper.GetString("UlrModule","Tasks list"), section:RoleSectionsEnum.ulr_system_state},
                {id:"UlrUsersActionsLog", href:"#UlrUsersActionsLog", value:LangHelper.GetString("UlrModule","Users actions log"), section:RoleSectionsEnum.ulr_system_state},
                {id:"UlrIgwsNodesList", href:"#UlrIgwsNodesList", value:LangHelper.GetString("UlrModule","IGWs nodes list"), section:RoleSectionsEnum.ulr_system_state},
                {id:"UlrIgwsQoEsList", href:"#UlrIgwsQoEsList", value:LangHelper.GetString("UlrModule","IGWs QoEs list"), section:RoleSectionsEnum.ulr_system_state},
                {id:"UlrIgwNodePerformance", href:"#UlrIgwNodePerformance", value:LangHelper.GetString("UlrModule","Hardware performance"), section:RoleSectionsEnum.ulr_system_state},
                {id:"UlrIgwNodeLogs", href:"#UlrIgwNodeLogs", value:LangHelper.GetString("UlrModule","Hardware logs"), section:RoleSectionsEnum.ulr_system_state},
                {id:"UlrTrafficRedirectionRules", href:"#UlrTrafficRedirectionRules", value:LangHelper.GetString("UlrModule","Traffic redirection"), section:RoleSectionsEnum.ulr_system_state}
            ]
        },
        {id:"_UlrMailingList", href:"#UlrMailingList", icon:"mailbox", value:LangHelper.GetString("UlrModule","Mailing"), section:RoleSectionsEnum.ulr_mailing,
            data:[
                {id:"UlrMailingList", href:"#UlrMailingList", value:LangHelper.GetString("UlrModule","Mailing list"), section:RoleSectionsEnum.ulr_mailing},
                {id:"UlrAddMailing", href:"#UlrAddMailing", value:LangHelper.GetString("UlrModule","Add new mailing"), section:RoleSectionsEnum.ulr_mailing},
                {id:"UlrMailingTemplatesList", href:"#UlrMailingTemplatesList", value:LangHelper.GetString("UlrModule","Mailing templates list"), section:RoleSectionsEnum.ulr_mailing},
                {id:"UlrAddTemplateMailing", href:"#UlrAddTemplateMailing", value:LangHelper.GetString("UlrModule","Add new mailing template"), section:RoleSectionsEnum.ulr_mailing},
                {id:"UlrRecipientGroupList", href:"#UlrRecipientGroupList", value:LangHelper.GetString("UlrModule","Recipient group list"), section:RoleSectionsEnum.ulr_mailing},
                {id:"UlrAddRecipientGroup", href:"#UlrAddRecipientGroup", value:LangHelper.GetString("UlrModule","Add new recipient group"), section:RoleSectionsEnum.ulr_mailing},

            ]
        },
        {id:"_UrlCategoriesDic", href:"#UrlCategoriesDic", icon:"spell-check", value:LangHelper.GetString("UlrModule","Dictionaries"), section:RoleSectionsEnum.ulr_dics,
            data:[
                {id:"UrlCategoriesDic", href:"#UrlCategoriesDic", value:LangHelper.GetString("UlrModule","Categories"), section:RoleSectionsEnum.ulr_dics},
                {id:"UrlRegulatorsDic", href:"#UrlRegulatorsDic", value:LangHelper.GetString("UlrModule","Regulators"), section:RoleSectionsEnum.ulr_dics},
                {id:"UlrCustomGroupsOfProtocols", href:"#UlrCustomGroupsOfProtocols", value:LangHelper.GetString("UlrModule","Protocol groups"), section:RoleSectionsEnum.ulr_dics},
                {id: "UlrSessionPolicingsTemplates", href: "#UlrSessionPolicingsTemplates", value: LangHelper.GetString("UlrModule","Session policings templates"), section: RoleSectionsEnum.ulr_dics},
                {id: "UlrAddSessionPolicingTemplate", href: "#UlrAddSessionPolicingTemplate", value: "&#x2022; " +  LangHelper.GetString("UlrModule","Add template"), section: RoleSectionsEnum.ulr_dics}
            ]
        }
    ];

    this.IdMap = {
        UlrEditWebIpFilterRule:"UlrWebIpFilterRules",
        UlrEditSpoofDnsRule:"UlrSpoofDnsRules",
        UlrEditIsp:"UlrIspsList",
        UlrEditSubs:"UlrSubsList",
        UlrEditIgw:"UlrIgwsList",
        UlrEditAppPolicing:"UlrAppPolicings",
        UlrEditIgwPolicing: "UlrIgwPolicings",
        UlrEditSubscriberPolicing: "UlrSubscribersPolicings",
        UlrEditWhiteListRule:"UlrWhiteList",
        UlrEditAsnDscpRule:"UlrAsnRuleList",
        UlrEditMailing:"UlrMailingList",
        UlrEditTemplateMailing:"UlrMailingTemplatesList",
        UlrEditRecipientGroup:"UlrRecipientGroupList",
        UlrEditIspSessionPolicing: "UlrIspSessionPolicings",
        UlrEditSubscriberSessionPolicing: "UlrSubscribersSessionPolicings"
    };

    this.Views =
    {
        SideBar:null
    };

    this.Subscriptions = {};

    this.State = null;

    this.Init(ViewConfig);
}

UlrSideBarWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig&&ViewConfig.id ? ViewConfig.id : "UlrSideBar";

    this.ViewConfig =
    {
        width:320,
        cols:[
            {
                rows:[
                    {
                        type: "clean",
                        borderless:true,
                        height:32
                    },
                    {
                        borderless:true,
                        height: SkinHelper.GetDefaultFilterUiSkin() == SkinsEnum.dpiui2_cubro ? 47 : 27,
                        css:"sidebar_header_spectre",
                        template:LangHelper.GetString("UlrModule","Rules")
                    },
                    {
                        view: "sidebar",
                        scroll:"y",
                        id:this.Id + "SideBar",
                        css:"sidebar_spectre",
                        width:318,
                        borderless:true,
                        template: function(Obj, Common)
                        {
                            var state = _this.Views.SideBar.getState();

                            var tpl = "", circleCss = "", circleCircleCss = "";

                            if(SkinHelper.GetDefaultFilterUiSkin() != SkinsEnum.dpiui2_spectre)
                            {
                                return  "<span class='menu-span'>"+ (Obj.icon ?
                                    `<span class="webix_icon webix_sidebar_icon fa-${Obj.icon}"></span>` : '') + (Obj.href ? '<a href="'+Obj.href+'" onclick="return false;">' + Obj.value + '</a>' : Obj.value)+"</span>";
                            }

                            if(Obj.$level == 1)
                            {
                                circleCss = "grey_line";

                                if(!Obj.open)
                                {
                                    if(!(state&&state.select&&state.select.length&&state.select[0]==Obj.id))
                                        circleCircleCss = "small";
                                }
                                else
                                {
                                    circleCss += " blue_line bottom_blue_line";


                                    circleCircleCss = "";
                                }
                            }
                            else
                            {
                                circleCss = "grey_line blue_line";

                                if(!(state&&state.select&&state.select.length&&state.select[0]==Obj.id))
                                {
                                    circleCircleCss = "hidden";
                                }
                                else
                                {
                                    circleCircleCss = "small only_blue";
                                }
                            }

                            //tpl += '<div class="circle_item grey_line grey_line blue_line"><div class="circle_item_circle small only_blue"></div></div>';

                            tpl += '<div class="circle_item '+circleCss+'"><div class="circle_item_circle '+circleCircleCss+'"></div></div>';

                            tpl += "<span>"+(Obj.href ? '<a href="'+Obj.href+'" onclick="return false;">' + Obj.value + '</a>' : Obj.value)+"</span>";

                            return tpl;
                        },
                        data: [],
                        on: {
                            onBeforeSelect: function (id) {
                                //debugger

                                return true;
                            },
                            onAfterSelect: function (id)
                            {
                                //debugger
                            },
                            onItemClick:function(id, e, node)
                            {
                                var item = this.getItem(id);

                                //this.unselectAll();

                                if(item.$level == 1)
                                    this.closeAll();

                                setTimeout(function ()
                                {
                                    App.NavRouter.PresentView({id: id.replace("_","")});
                                }, 1);
                            }
                        }
                    }
                ]
            }
        ]
    };


};

UlrSideBarWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = $$(_this.Id + View)
    });

    this.ParseData(this.SideBarData);
};

UlrSideBarWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

UlrSideBarWidget.prototype.ParseData = function (Data)
{
    var data = Data ? Data : this.SideBarData;

    var items = [];

    var recursively = function(Data, Items)
    {
        Data.forEach(function (Item)
        {
            if(Item.section && App.SessionManager.CheckUserRoleSection(Item.section))
            {
                var item = {
                    id:Item.id,
                    value:Item.value,
                    section:Item.section,
                    href:Item.href,
                    icon:Item.icon
                };

                if(Item.data)
                {
                    item.data = [];

                    recursively(Item.data,item.data );
                }

                Items.push(item);
            }
        });
    };

    recursively(data, items);

    this.Views.SideBar.parse(items);
};

UlrSideBarWidget.prototype.Select = function (Id)
{
    this.Views.SideBar.unselectAll();
    this.Views.SideBar.closeAll();

    var id = this.IdMap[Id] ? this.IdMap[Id] : Id;

    if(this.Views.SideBar.getItem(id))
    {
        this.Views.SideBar.select(id);
        this.Views.SideBar.open(id, true);
        this.Views.SideBar.open(this.Views.SideBar.getParentId(id), true);
    }
};

UlrSideBarWidget.prototype.UnselectAll = function ()
{
    this.Views.SideBar.unselectAll();
};

UlrSideBarWidget.prototype.СloseAll = function ()
{
    this.Views.SideBar.closeAll();
};

function UlrTestViewController(Params)
{
    var _this = this;

    this.Id = "UlrTest";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Test page"),
        Title:""
    };

    this.ViewModel = null;

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        Widgets:{},
        ReportsWidgets:{
            TestReport: UrlTableTestListWidget({id:this.Id + "TestReport"}),
            TestReportWithSearch: UrlTableTestListWidget({id:this.Id + "TestReportWithSearch", enableTextSearch:true})
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "wide",
                        borderless:true,
                        rows: [
                            PageHeaderTemplate({root_title:LangHelper.GetString("UlrModule","Test page")}),
                            {
                                view:"form",
                                type: "wide",
                                borderless:true,
                                elements:[
                                    {
                                        cols:[
                                            {
                                                view:"label",
                                                css:"form_info_label",
                                                caption:"Rule ID",
                                                value:"3453453466",
                                                template:"<span class='caption'>#caption#:</span> <span class='value'>#value#</span>"
                                            },
                                            {
                                                css:"form_info_label_spacer",
                                                borderless:true,
                                                width:20,
                                                template:""
                                            },
                                            {
                                                view:"label",
                                                css:"form_info_label",
                                                caption:"Rule state",
                                                value:"Disaled",
                                                template:"<span class='caption'>#caption#:</span> <span class='value'>#value#</span>"
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                view:"spectre_text",
                                                css:"form_element",
                                                label:"Label 1",
                                                height:51,
                                                labelPosition:"top",
                                                value:"test"
                                            },
                                            {
                                                view:"spectre_text",
                                                css:"form_element",
                                                label:"Label 2",
                                                height:51,
                                                labelPosition:"top"
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                rows:[
                                                    {
                                                        view:"spectre_textarea",
                                                        css:"form_element",
                                                        label:"Label 1",
                                                        height:123,
                                                        labelPosition:"top"
                                                    },
                                                    {
                                                        view:"label",
                                                        css:"form_text_description_label",
                                                        label:"Some description text"
                                                    }
                                                ]
                                            },
                                            {
                                                rows:[
                                                    {
                                                        view:"spectre_textarea",
                                                        css:"form_element",
                                                        label:"Label 2",
                                                        height:123,
                                                        labelPosition:"top",
                                                        value:"test"
                                                    },
                                                    {
                                                        view:"label",
                                                        css:"form_text_description_label",
                                                        label:"Some description text"
                                                    }
                                                ]
                                            }

                                        ]
                                    }
                                ]
                            },
                            {
                                type:"wide",
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Test form"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        view:"form",
                                        type: "wide",
                                        elements:[
                                            {
                                                type:"clean",
                                                rows:[
                                                    {
                                                        view:"label",
                                                        css:"form_text_label",
                                                        label:"Select type of resource and put the URL, SNI, CN, IP, IP:PORT or CIDR to this field."
                                                    },
                                                    {
                                                        type: "wide",
                                                        cols:[
                                                            {
                                                                view:"spectre_text",
                                                                css:"form_element",
                                                                label:"Label 1",
                                                                height:51,
                                                                labelPosition:"top"
                                                            },
                                                            {
                                                                type: "wide",
                                                                cols:[
                                                                    {
                                                                        view:"spectre_richselect",
                                                                        css:"form_element",
                                                                        label:"Label 2",
                                                                        height:51,
                                                                        labelPosition:"top",
                                                                        value:"sni",
                                                                        options:{
                                                                            point:false,
                                                                            data:[
                                                                                {id:"sni", value:"SNI"},
                                                                                {id:"url", value:"URL"}
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        rows:[
                                                                            {},
                                                                            {
                                                                                view:"spectre_button",
                                                                                css:"form_button form_element third_action",
                                                                                label:"Validate",
                                                                                height:51
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        height:20
                                                    },
                                                    {
                                                        type:"wide",
                                                        rows:[
                                                            {
                                                                view:"label",
                                                                css:"form_state success",
                                                                caption:"Validation result",
                                                                icon:"check",
                                                                value:"HTTPS SNI domain *.allfilms.com is correct.<br/>SNI information ...............................................",
                                                                template:"<div class='row'><div class='caption'><span class='webix_icon form_state_icon fa-#icon#'></span>#caption#: </div><div class='value'>#value#</div></div>",
                                                                height:70
                                                            },
                                                            {
                                                                type:"wide",
                                                                cols:[
                                                                    {
                                                                        view:"spectre_button",
                                                                        type:"icon",
                                                                        css:"form_button spec_action with_icon",
                                                                        label:"Spec action with icon",
                                                                        icon:"plus-circle",
                                                                        height:44,
                                                                        autowidth:true
                                                                    },
                                                                    {
                                                                        view:"spectre_button",
                                                                        type:"icon",
                                                                        css:"form_button spec_action with_icon",
                                                                        label:"Spec action with icon",
                                                                        icon:"arrow-left",
                                                                        height:44,
                                                                        autowidth:true
                                                                    },
                                                                    {}
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        height:20
                                                    }
                                                ]
                                            }

                                        ]
                                    }
                                ]
                            },


                            {
                                type:"wide",
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Test checkbox form"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        type: "clean",
                                        view:"form",
                                        elements:[
                                            {
                                                view:"label",
                                                css:"form_text_label",
                                                label:"Select ISP which the rule will be applied "
                                            },
                                            {
                                                type: "wide",
                                                cols:[
                                                    {
                                                        rows:[
                                                            {
                                                                view:"checkbox",
                                                                labelWidth:0,
                                                                labelRight:"Earthlink 1"
                                                            },
                                                            {
                                                                view:"checkbox",
                                                                labelWidth:0,
                                                                labelRight:"Earthlink 2"
                                                            },
                                                            {
                                                                view:"checkbox",
                                                                labelWidth:0,
                                                                labelRight:"Earthlink 3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        rows:[
                                                            {
                                                                view:"checkbox",
                                                                labelWidth:0,
                                                                labelRight:"Earthlink 4"
                                                            },
                                                            {
                                                                view:"checkbox",
                                                                labelWidth:0,
                                                                labelRight:"Earthlink 5"
                                                            },
                                                            {
                                                                view:"checkbox",
                                                                labelWidth:0,
                                                                labelRight:"Earthlink 6"
                                                            }
                                                        ]
                                                    },
                                                    {}
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },



                            {
                                type:"wide",
                                cols:[
                                    {
                                        view:"spectre_button",
                                        css:"form_button main_action",
                                        label:"Main action",
                                        height:44,
                                        autowidth:true
                                    },
                                    {
                                        view:"spectre_button",
                                        css:"form_button second_action",
                                        label:"Second action",
                                        height:44,
                                        autowidth:true
                                    },
                                    {
                                        view:"spectre_button",
                                        css:"form_button third_action",
                                        label:"Third action",
                                        height:44,
                                        autowidth:true
                                    },
                                    {
                                        view:"spectre_button",
                                        css:"form_button spec_action",
                                        label:"Spec action",
                                        height:44,
                                        autowidth:true
                                    },
                                    {
                                        view:"spectre_button",
                                        type:"icon",
                                        css:"form_button spec_action with_icon",
                                        label:"Spec action with icon",
                                        icon:"plus-circle",
                                        height:44,
                                        autowidth:true
                                    },
                                    {}
                                ]
                            },
                            {
                                type: "wide",
                                borderless:true,
                                height:536,
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Test table"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        borderless:true,
                                        rows:[
                                            this.Views.ReportsWidgets.TestReport.ViewConfig
                                        ]
                                    }
                                ]
                            },
                            {
                                type: "wide",
                                borderless:true,
                                height:536,
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Test table with search"), icon:"",
                                        borderless:true
                                    }),
                                    this.Views.ReportsWidgets.TestReportWithSearch.ViewConfig
                                ]
                            },
                            {
                                height:1000,
                                template:""
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrTestViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });


};

UlrTestViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrTestViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });
};

UlrTestViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.TestReport.RefreshData();
    this.Views.ReportsWidgets.TestReportWithSearch.RefreshData();
};

UlrTestViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};
function UlrAddResourceFormWidget(Params)
{
    var _this = this;

    this.Id = Params && Params.id ? Params.id : "AddResourcesFormWidget";

    this.RuleType = Params && Params.rule_type ? Params.rule_type : UlrRulesTypesCodesEnum.excluded_resources;
    this.RuleTypeId = UlrRulesTypesCodesTypeIdMap[this.RuleType];
    this.RuleId = null;

    this.Signals = {
        ValuedResource:new Rx.BehaviorSubject(null),
        SaveResources:new Rx.BehaviorSubject(null),
        AddResourcesFromFiles: new Rx.BehaviorSubject(null)
    };
    this.Subscriptions = {};

    this.JustAddedResources = [];
    this.ImportResourcesFileArr = [];

    this.ViewModel = new UlrWebIpFilterRulesManager();
    this.CheckDomainManager = new UlrCheckDomainManager();
    this.ReportsModel = new UniReportsManager();

    this.Views = {
        AddResourceInput: null,
        AddResourceTypesInput: null,
        AddResourceSelect:null,
        ValidateResourceBtn: null,
        ValidationResultLabel:null,

        AddResourceBtn:null,

        JustAddedResourcesShowBtn: null,
        JustAddedResourcesPopup: null,

        JustAddedResourcesAddBtn: null,
        JustAddedResourcesClearBtn: null,

        ImportResourcesShowPopupBtn: null,
        ImportResourcesPopup: null,
        ImportResourcesPopupForm:null,
        ImportResourcesPopupEditor:null,
        ImportResourcesPopupImportBtn:null,
        ImportResourcesPopupClearBtn:null,

        ImportResourcesFileShowPopupBtn: null,
        ImportResourcesFilePopup: null,
        ImportResourcesFilePopupUploader: null,
        ImportResourcesFilePopupAddBtn: null,
        ImportResourcesFilePopupClearBtn: null,

        Widgets: {},
        ReportsWidgets:{
            JustAddedResourcesTable: new UrlWebRulesResourcesTableWidget({
                id: this.Id + "JustAddedResourcesTable",
                enableTextSearch:0,
                enableAutoHeight:1,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource:1,
                dataSource: function(FilterParams)
                {
                    return _this.DataSourceFunc(FilterParams, _this.JustAddedResources);
                },
                onItemClick:function (Id) {
                    _this.JustAddedResourcesTableOnClick(Id);
                },
                sort:{}
            }),
            ImportedResourcesFileReport: new UrlImportedFilesTableWidget({
                id:this.Id + "ImportedResourcesFileReport",
                enableTextSearch:0,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource: 1,
                dataSource: function(FilterParams)
                {
                    return _this.DataSourceFunc(FilterParams, _this.ImportResourcesFileArr);
                },
                onItemClick:function (Id) {
                    _this.ImportedResourcesFileReportTableOnClick(Id);
                },
                sort:{}
            }),
        }
    };

    this.ViewConfig = {
            type:"wide",
            rows:[
                {
                    cols: [
                        BlockHeaderTemplate({
                            title:LangHelper.GetString("UlrModule","Resource"), icon:"",
                            borderless:true,
                            css: "custom__app-block-header-with-icon"
                        }),
                        {
                            view: "spectre_button",
                            id:_this.Id + "ResourceHelpBtn",
                            type: "icon",
                            icon: "question-circle",
                            css:"toolbar_round_btn custom-form-btn",
                            width:32,
                            height:25,
                            tooltip:LangHelper.GetString("UlrModule", "Help"),
                            click:function (id)
                            {
                                UlrShowImportWebRulesHelpPopup();
                            }
                        },
                        {}
                    ]
                },
                {
                    view:"form",
                    id:this.Id + "AddResourceForm",
                    type: "wide",
                    elements:[
                        {
                            type:"clean",
                            rows:[
                                {
                                    view:"label",
                                    css:"form_text_label",
                                    label:LangHelper.GetString("UlrModule","Select type of resource and put the URL, SNI, CN, IP, IP:PORT or CIDR to this field.")
                                },
                                {
                                    type: "wide",
                                    cols:[
                                        {
                                            view:"spectre_text",
                                            id:this.Id + "AddResourceInput",
                                            name:"resource_raw",
                                            label:LangHelper.GetString("UlrModule","Resource"),
                                            keyPressTimeout:300,
                                            on:{
                                                onEnter:function(ev)
                                                {
                                                    setTimeout(function ()
                                                    {
                                                        _this.ValidateResource();
                                                    },1);
                                                }
                                            }
                                        },
                                        {
                                            view:"spectre_richselect",
                                            id:this.Id + "AddResourceSelect",
                                            name:"resource_raw",
                                            label:LangHelper.GetString("UlrModule","Resource"),
                                            options: {
                                                body: {
                                                    scheme: {
                                                        $sort: {
                                                            by: "value",
                                                            dir: "asc",
                                                            as: "string"
                                                        }
                                                    },
                                                    point:false,
                                                    data: []
                                                }
                                            },
                                            disabled: true,
                                            hidden: true,
                                            keyPressTimeout:300,
                                            on:{
                                                onEnter:function(ev)
                                                {
                                                    setTimeout(function ()
                                                    {
                                                        _this.ValidateResource();
                                                    },1);
                                                }
                                            }
                                        },
                                        {
                                            type: "wide",
                                            cols:[
                                                {
                                                    view:"spectre_richselect",
                                                    id:this.Id + "AddResourceTypesInput",
                                                    name:"type_id",
                                                    label:LangHelper.GetString("UlrModule","Type"),
                                                    value:"sni",
                                                    options:{
                                                        point:false,
                                                        data:[]
                                                    }
                                                },
                                                {
                                                    rows:[
                                                        {},
                                                        {
                                                            view:"spectre_button",
                                                            id:this.Id + "ValidateResourceBtn",
                                                            css:"form_button form_element main_action",
                                                            label:LangHelper.GetString("UlrModule","Validate"),
                                                            height:51,
                                                            click:function ()
                                                            {
                                                                _this.ValidateResource();
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {height:20},
                                {
                                    type:"wide",
                                    rows:[
                                        {
                                            view:"label",
                                            id:this.Id + "ValidationResultLabel",
                                            css:"slide_down_box form_state",
                                            caption:LangHelper.GetString("UlrModule","Validation result"),
                                            icon:"check",
                                            value:"",
                                            template:"<div class='row'><div class='caption'><span class='webix_icon form_state_icon fa-#icon#'></span>#caption#: </div><div class='value'>#value#</div></div>",
                                            height:70
                                        },
                                        {
                                            type:"wide",
                                            cols:[
                                                {
                                                    view:"spectre_button",
                                                    id:this.Id + "AddResourceBtn",
                                                    type:"icon",
                                                    css:"form_button spec_action with_icon",
                                                    label:LangHelper.GetString("UlrModule","Add resource"),
                                                    icon:"plus-circle",
                                                    autowidth:true,
                                                    disabled:true,
                                                    click:function ()
                                                    {
                                                        setTimeout(function ()
                                                        {
                                                            _this.AddResources();
                                                        },1);
                                                    }
                                                },
                                                {
                                                    view:"spectre_button",
                                                    id:this.Id + "ImportResourcesShowPopupBtn",
                                                    type:"icon",
                                                    css:"form_button spec_action with_icon",
                                                    label:LangHelper.GetString("UlrModule","Import resources"),
                                                    icon:"arrow-left",
                                                    autowidth:true,
                                                    click:function ()
                                                    {
                                                        _this.Views.ImportResourcesPopup.show();
                                                    }
                                                },
                                                {
                                                    view:"spectre_button",
                                                    id:this.Id + "ImportResourcesFileShowPopupBtn",
                                                    type:"icon",
                                                    css:"form_button spec_action with_icon ulr_with_badge",
                                                    label:LangHelper.GetString("UlrModule","Import from file"),
                                                    icon:"file",
                                                    badge: 0,
                                                    autowidth:true,
                                                    click:function ()
                                                    {
                                                        _this.Views.ImportResourcesFilePopup.show();
                                                    }
                                                },
                                                {}
                                            ]
                                        }
                                    ]
                                },
                                {height:20},
                                {
                                    cols:[
                                        {
                                            view:"spectre_button",
                                            id:this.Id+"JustAddedResourcesShowBtn",
                                            type:"icon",
                                            css:"form_button spec_action with_icon",
                                            label:LangHelper.GetString("UlrModule","Resources to add"),
                                            icon:"list",
                                            disabled: true,
                                            autowidth:true,
                                            click:function ()
                                            {
                                                _this.Views.JustAddedResourcesPopup.show();
                                            }
                                        },
                                        {}
                                    ]
                                },
                            ]
                        }
                    ]
                }
            ]
        }


    this.ImportResourcesPopup = webix.ui({
        view: "window",
        id: this.Id + "ImportResourcesPopup",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ImportResourcesPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Import resources"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        _this.Views.ImportResourcesPopup.hide();
                    }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ImportResourcesPopupForm",
                            type: "wide",
                            minWidth:560,
                            minHeight:400,
                            elements: [
                                {
                                    view:"spectre_textarea",
                                    id:this.Id + "ImportResourcesPopupEditor",
                                    label:LangHelper.GetString("UlrModule","File or clipboard content to import"),
                                    height:undefined,
                                    value:""
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ImportResourcesPopupImportBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Import"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            if (_this.Views.ImportResourcesPopupEditor.getValue().length)
                                            {
                                                _this.AddResourcesFromImport();
                                                _this.Views.ImportResourcesPopup.hide();
                                                _this.Views.JustAddedResourcesPopup.show();
                                            }
                                        },1);

                                    }
                                },
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ImportResourcesPopupClearBtn",
                                    css:"form_button spec_action",
                                    label:LangHelper.GetString("UlrModule","Clear"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        _this.Views.ImportResourcesPopupEditor.setValue("");
                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    });

    this.ImportResourcesFilePopup = webix.ui({
        view: "window",
        id: this.Id + "ImportResourcesFilePopup",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ImportResourcesFilePopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Import resources from file"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        _this.Views.ImportResourcesFilePopup.hide();
                    }
                }
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ImportResourcesFilePopupForm",
                            type: "wide",
                            minWidth:720,
                            minHeight:400,
                            elements: [
                                {
                                    view: "uploader",
                                    value: LangHelper.GetString("UlrModule","Click to upload or drag a file here"),
                                    id: this.Id + "ImportResourcesFilePopupUploader",
                                    css:"upload_area form_button spec_action",
                                    autosend:false,
                                    height:64
                                },
                                this.Views.ReportsWidgets.ImportedResourcesFileReport.ViewConfig
                            ]
                        },
                        {height:25},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ImportResourcesFilePopupAddBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Add to list"),
                                    autowidth:true,
                                    disabled:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.AddResourcesFromImportFiles();
                                        },1);

                                    }
                                },
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ImportResourcesFilePopupClearBtn",
                                    css:"form_button spec_action",
                                    label:LangHelper.GetString("UlrModule","Clear"),
                                    disabled:true,
                                    autowidth:true,
                                    click:function ()
                                    {
                                        _this.ClearImportResourcesFile();
                                    }
                                },
                            ]
                        }
                    ]
                }
            ]
        }
    });

    this.JustAddedResourcesPopup = webix.ui({
        view: "window",
        id: this.Id + "JustAddedResourcesPopup",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        width: 1200,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "JustAddedResourcesPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Add resources to exclusion list"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        _this.Views.JustAddedResourcesPopup.hide();
                    }
                }
            ]
        },
        body: {
            type: "space",
            borderless: true,
            rows: [
                _this.Views.ReportsWidgets.JustAddedResourcesTable.ViewConfig,
                {
                    id: _this.Id + "BtnsSection",
                    type:"wide",
                    cols:[
                        {
                            view:"spectre_button",
                            id: this.Id + "JustAddedResourcesAddBtn",
                            css:"form_button main_action",
                            label:LangHelper.GetString("UlrModule","Add to list"),
                            disabled: true,
                            autowidth:true,
                            click:function ()
                            {
                                _this.SaveJustAddedResources();
                                _this.Views.JustAddedResourcesPopup.hide();
                            }
                        },
                        {
                            view:"spectre_button",
                            id: _this.Id + "JustAddedResourcesClearBtn",
                            css:"form_button spec_action",
                            label:LangHelper.GetString("UlrModule","Clear"),
                            autowidth:true,
                            click:function ()
                            {
                                _this.JustAddedResources = [];
                                _this.RefreshJustAddedResources();
                            }
                        },
                        {}
                    ]
                }
            ]
        }
    });
};

UlrAddResourceFormWidget.prototype.BindAll = function(Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions[DicsEnum.UlrResourceTypesDic] = App.DicsManager.Signal[DicsEnum.UlrResourceTypesDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.AddResourceTypesInput.getList().clearAll();

            var dicArr = Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrResourceTypesDic));

            dicArr = dicArr.filter(item => Object.values(UlrWebRuleResourcesTypesMapEnum).indexOf(parseInt(item.id)) > -1);
            dicArr.unshift({id:"auto", value:LangHelper.GetString("UlrModule", "Auto")});

            dicArr = dicArr.filter(function(item){return item.id != UlrWebRuleResourcesTypesMapEnum.ulr_fastresource});

            // Issues #6076.3
            // Hide CATEGORY
            // if (!AppEnv.UlrShowCategory)
            //     dicArr = dicArr.filter(item => item.id != UlrWebRuleResourcesTypesMapEnum.clsfr);

            if(dicArr && dicArr.length)
            {
                _this.Views.AddResourceTypesInput.getList().clearAll();
                _this.Views.AddResourceTypesInput.getList().parse(dicArr);
                _this.Views.AddResourceTypesInput.setValue(dicArr[0].id);
            }
        }
    });

    this.Subscriptions.ResourceValidationProgress = this.ViewModel.Signals.WebRuleResourceValidationProgress.subscribe(function (InProgress)
    {
        var view = _this.Views.ValidateResourceBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.AddResourceInput;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.AddResourceTypesInput;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions.WebRuleResourceValidatedError = this.ViewModel.Signals.WebRuleResourceValidatedError.subscribe(function (ErrModel)
    {
        if(ErrModel)
        {
            this.EnableDisableInputs(1);
            _this.ShowServerError(ErrModel);
        }
    });

    this.Subscriptions.SearchRulesByRawResourceDone = this.ViewModel.Signals.SearchRulesByRawResourceDone.subscribe(function (Data)
    {
        if(Data)
        {
            if(Data.length)
            {
                _this.DefineRulesByRawResourceResult(Data);
            }
            else
            {
                _this.DefineValidationResult(new UlrValuedResourceViewModel({type_id:"auto", validation_success:0}))
            }

            _this.Views.ValidationResultLabel.show();
        }
    });

    this.Subscriptions.SearchRulesByRawResourceError = this.ViewModel.Signals.SearchRulesByRawResourceError.subscribe(function (ErrModel)
    {
        if(ErrModel)
        {
            [_this.Views.ValidateResourceBtn, _this.Views.AddResourceInput, _this.Views.AddResourceTypesInput].forEach(view => {
                view.enable();
            });
            _this.ShowServerError(ErrModel);
        }
    });

    this.Subscriptions.DomainFullInfoResultUpdated = this.CheckDomainManager.Signals.CheckResultUpdated.subscribe(function (CheckDomainModel)
    {
        if(CheckDomainModel && CheckDomainModel.resource_raw === _this.Views.AddResourceInput.getValue())
        {
            if(CheckDomainModel.valid) {
                _this.ValidateResourceAuto(CheckDomainModel);
            } else {
                _this.ViewModel.SearchRulesByRawResource({
                    rule_type_mode: "global",
                    rule_type_id: _this.RuleTypeId,
                    resource_raw: CheckDomainModel.resource_raw
                });
            }
        }
    });

    this.Subscriptions.DomainFullInfoResultError = this.CheckDomainManager.Signals.CheckResultError.subscribe(function (ErrModel)
    {
        if (ErrModel)
        {
            [_this.Views.ValidateResourceBtn, _this.Views.AddResourceInput, _this.Views.AddResourceTypesInput].forEach(view => {
                view.enable();
            });
            _this.ShowServerError(ErrModel);
        }
    });

    this.Views.AddResourceTypesInput.attachEvent("onChange", function(Nv, Ov)
    {
        let input = _this.Views.AddResourceInput;
        let select = _this.Views.AddResourceSelect;

        input.show();
        select.hide();

        let resourceRaw = _this.Views.AddResourceInput.getValue();

        if (Nv == UlrWebRuleResourcesTypesMapEnum.clsfr)
        {
            input.hide();
            input.setValue('');
            select.disable();
            select.setValue('');
            select.show();

            resourceRaw = _this.Views.AddResourceSelect.getValue();

            let Categories = [];
            let CategoriesDic = App.DicsManager.GetDicAsArray(DicsEnum.ClsfrCategoriesDic);

            let lang = LangHelper.GetLocale();

            Categories = CategoriesDic.map(function (Category){
                let name = Category.value;
                return {
                    id: Category.id,
                    value: name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]])
                };
            });

            let list = select.getList();
            list.clearAll();
            list.parse(Categories);

            select.enable();
        }

        _this.Signals.ValuedResource.next(new UlrValuedResourceViewModel({resource_raw:resourceRaw, type_id: Nv}));
    });

    this.Views.AddResourceSelect.attachEvent("onChange", function(Nv, Ov)
    {
        if (Nv == '')
            return;

        var type = _this.Views.AddResourceTypesInput.getValue();
        _this.Signals.ValuedResource.next(new UlrValuedResourceViewModel({resource_raw:Nv, type_id: type}));
    });

    this.Views.AddResourceInput.attachEvent("onChange", function(Nv, Ov)
    {
        var _Nv = Nv.trim(); //.replace(/\s/g, '');

        if(Nv != _Nv)
        {
            this.setValue(_Nv);
            return;
        }

        var type = _this.Views.AddResourceTypesInput.getValue();
        _this.Signals.ValuedResource.next(new UlrValuedResourceViewModel({resource_raw:Nv, type_id: type}));
    });

    this.Views.AddResourceInput.attachEvent("onTimedKeyPress", function()
    {
        var v = _this.Views.AddResourceInput.getValue();

        var _Nv = v; //.trim();//.replace(/\s/g, '');

        if(v != _Nv)
        {
            this.setValue(_Nv);
            return;
        }

        var type = _this.Views.AddResourceTypesInput.getValue();

        _this.Signals.ValuedResource.next(new UlrValuedResourceViewModel({resource_raw:v, type_id: type}));
    });

    this.Views.ImportResourcesFilePopupUploader.attachEvent("onAfterFileAdd", function(FileObj){
        if(FileObj)
        {
            _this.UploadImportResourcesFile(FileObj);
        }
    });

    this.Subscriptions.ValuedResource = Rx.Observable.combineLatest
    (
        this.Signals.ValuedResource.distinctUntilChanged(),
        this.ViewModel.Signals.WebRuleResourceValidationProgress.distinctUntilChanged()
    ).subscribe(function (Signal)
    {

        var ValuedResource = Signal[0];
        var InProgress = Signal[1];

        if(!InProgress && ValuedResource && ValuedResource.try_validate)
        {
            _this.DefineValidationResult(ValuedResource);

            // [_this.Views.AddResourceInput, _this.Views.AddResourceTypesInput].forEach(view => {
            //     view.enable();
            // });

            _this.Views.ValidationResultLabel.show();
        }
        else
            _this.Views.ValidationResultLabel.hide();

        var view = _this.Views.AddResourceBtn;
        InProgress || !ValuedResource || !ValuedResource.resource_raw ? view.disable() : view.enable();

        view = _this.Views.ValidateResourceBtn;
        InProgress || !ValuedResource || !ValuedResource.resource_raw || _this.Views.AddResourceTypesInput.getValue() == UlrWebRuleResourcesTypesMapEnum.clsfr ? view.disable() : view.enable();
    });

    App.DicsManager.Refresh({data:[DicsEnum.UlrResourceTypesDic]});
};

UlrAddResourceFormWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if(this.CheckDomainManager)
    {
        this.CheckDomainManager.Destroy();
        delete this.CheckDomainManager;
    }
};

UlrAddResourceFormWidget.prototype.DataSourceFunc = function(FilterParams, DataSource)
{
    let _this = this;

    var res = {
        count: DataSource.length,
        page: FilterParams.Params.page,
        size: _this.Views.ReportsWidgets.ImportedResourcesFileReport.Views.Paging.config.size,
        rows: []
    };

    var sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : null;
    var sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : "desc";

    var sort_val = sort_dir == 'asc' ? 1 : -1;

    if (sort_prop)
    {
        DataSource.sort((a, b) => {
            var val_a = a[sort_prop];
            var val_b = b[sort_prop];

            if (typeof val_a == 'string' || typeof val_b == 'string') {
                if (sort_val > 0) {
                    return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                } else {
                    return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                }
            } else if (typeof val_a == 'number' || typeof val_b == 'number') {
                return sort_val * val_a + (-1) * sort_val * val_b;
            }

            return -1;
        });
    }

    const start_index = res.page * res.size;
    var finish_index = start_index + res.size;

    if (finish_index > (DataSource.length - 1)) {
        res.rows = DataSource.slice(start_index);
    } else {
        res.rows = DataSource.slice(start_index, finish_index);
    }

    return res;
};

UlrAddResourceFormWidget.prototype.ShowServerError = function(ErrModel, Action)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};


UlrAddResourceFormWidget.prototype.EnableDisableInputs = function(Show)
{
    [this.Views.ValidateResourceBtn, this.Views.AddResourceInput, this.Views.AddResourceTypesInput].forEach(view => {
        if(Show)
        {
            view.enable();
        }
        else
        {
            view.disable();
        }
    });
}

UlrAddResourceFormWidget.prototype.ValidateResource = function(vResource = null)
{
    var _this = this;

    this.EnableDisableInputs(0);

    var vr = vResource ? vResource : new UlrValuedResourceViewModel({
        resource_raw: this.Views.AddResourceInput.getValue(),
        type_id: this.Views.AddResourceTypesInput.getValue()
    });

    if(!vr.resource_raw || !vr.type_id)
        return;

    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.ip)
    {
        vItems = vr.resource_raw.split(":");

        if(vItems.length > 2 || vItems.length == 1)
            vItems = vr.resource_raw.split(' ');

        // Добавляем порты, если не заданы
        if (typeof AppEnv.UlrAddPortsToIpOnExport == 'undefined' || AppEnv.UlrAddPortsToIpOnExport == 1)
        {
            if(vItems.length == 1)
            {
                vItems.push('80');
                vItems.push('443');
            }
        }

        ip = vItems[0];

        ipPorts = [];

        vSuccess = true;

        if(vItems.length > 1)
        {
            vItems.forEach(function (V, I)
            {
                if(I > 0)
                {
                    ipPort = ip + " " + V;
                    ipPorts.push(ipPort);

                    if(!Helper.ValidateIPv4IPv6AddressPlusPort(ipPort))
                        vSuccess = false;
                }

            });
        }
        else
        {
            ipPorts.push(ip);
            if(!Helper.ValidateIPv4IPv6AddressPlusPort(ip))
                vSuccess = false;
        }


        vr.validation_success = vSuccess;

        if(vr.validation_success)
        {
            vr.ips = ipPorts;
        }

        vr.try_validate = true;

        this.Signals.ValuedResource.next(vr);
    }

    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.cidr)
    {
        vItems = vr.resource_raw.split(":");

        if(vItems.length > 2 || vItems.length == 1)
            vItems = vr.resource_raw.split(' ');

        // Добавляем порты, если не заданы
        if (typeof AppEnv.UlrAddPortsToIpOnExport == 'undefined' || AppEnv.UlrAddPortsToIpOnExport == 1)
        {
            if(vItems.length == 1)
            {
                vItems.push('80');
                vItems.push('443');
            }
        }

        cidr = vItems[0];

        cidrPorts = [];

        vSuccess = true;

        if(vItems.length > 1)
        {
            vItems.forEach(function (V, I)
            {
                if(I > 0)
                {
                    cidrPort = cidr + " " + V;
                    cidrPorts.push(cidrPort);

                    if(!(Helper.UlrValidateCidr(cidr) && parseInt(V) > 0 && /^\d+$/.test(V)))
                        vSuccess = false;
                }

            });
        }
        else
        {
            cidrPorts.push(cidr);
            if(!(Helper.UlrValidateCidr(cidr)))
                vSuccess = false;
        }


        vr.validation_success = vSuccess;

        if(vr.validation_success)
            vr.cidrs = cidrPorts;

        vr.try_validate = true;

        this.Signals.ValuedResource.next(vr);
    }

    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.url || vr.type_id == UlrWebRuleResourcesTypesMapEnum.sni || vr.type_id == UlrWebRuleResourcesTypesMapEnum.cn)
    {
        _this.Signals.ValuedResource.next(null);

        this.ViewModel.ValidateWebRuleResource(
            {
                resource:vr.resource_raw,
                callback:function (ResultModel)
                {
                    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.url)
                    {
                        vr.validation_success = ResultModel.http_with_path.url.valid || ResultModel.http_with_www_path.url.valid;
                    }

                    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.sni)
                    {
                        vr.validation_success = ResultModel.https.url.valid || ResultModel.https_with_www.url.valid;
                    }

                    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.cn)
                    {
                        vr.validation_success = ResultModel.https.url.valid || ResultModel.https_with_www.url.valid;
                    }

                    if(ResultModel.https.url.valid || ResultModel.https_with_www.url.valid)
                    {
                        var key = ResultModel.https.url.valid ? "https" : "https_with_www";

                        vr.isHttps = 1;

                        if(ResultModel[key].cns.length)
                        {
                            ResultModel[key].cns.forEach(function (Item) {
                                vr.cns.push(Item.value);
                            });
                        }

                        if(ResultModel[key].snis.length)
                        {
                            ResultModel[key].snis.forEach(function (Item) {
                                vr.snis.push(Item.value);
                            });
                        }
                    }

                    if(ResultModel.http_with_path.url.valid || ResultModel.http_with_www_path.url.valid)
                    {
                        vr.isHttp = 1;
                        vr.http = ResultModel.http_with_path.url.valid ? ResultModel.http_with_path.url.value : ResultModel.http_with_www_path.url.value;

                        if(ResultModel.http_with_path.url.valid)
                            vr.urls.push(ResultModel.http_with_path.url.value);

                        if(ResultModel.http_with_www_path.url.valid)
                            vr.urls.push(ResultModel.http_with_www_path.url.value);
                    }

                    vr.try_validate = true;

                    if(vr.validation_success || (vr.type_id == UlrWebRuleResourcesTypesMapEnum.url && vr.isHttps)) {
                        _this.Signals.ValuedResource.next(vr);
                    } else {
                        _this.ViewModel.SearchRulesByRawResource({
                            rule_type_mode: "global",
                            rule_type_id: _this.RuleTypeId,
                            resource_raw: vr.resource_raw
                        });
                    }
                }
            }
        );
    }

    if(vr.type_id === "auto")
    {
        let vItems = vr.resource_raw.split(":");

        if(vItems.length > 2 || vItems.length == 1)
            vItems = vr.resource_raw.split(' ');

        let input = vItems[0];

        if(Helper.ValidateIPv4(input)||Helper.ValidateIPv6(input))
        {
            var vr = new UlrValuedResourceViewModel({
                resource_raw:input,
                type_id:UlrWebRuleResourcesTypesMapEnum.ip
            });
            _this.ValidateResource(vr);
        }
        else if (Helper.UlrValidateCidr(input))
        {
            var vr = new UlrValuedResourceViewModel({
                resource_raw:input,
                type_id:UlrWebRuleResourcesTypesMapEnum.cidr
            });
            _this.ValidateResource(vr);
        }
        else
        {
            _this.Signals.ValuedResource.next(null);
            _this.CheckDomainManager.GetDomainInfo({resource: vr.resource_raw});
        }
    }
};

UlrAddResourceFormWidget.prototype.ValidateResourceAuto = function(CheckDomainModel)
{
    let _this = this;

    let vr = new UlrValuedResourceViewModel({
        resource_raw: _this.Views.AddResourceInput.getValue(),
        type_id: _this.Views.AddResourceTypesInput.getValue()
    });

    if(!vr.resource_raw || !vr.type_id)
        return;

    vr.try_validate = true;

    if(CheckDomainModel.valid)
    {
        vr.isHttp = !CheckDomainModel.ssl ? 1 : 0;
        vr.isHttps = CheckDomainModel.ssl ? 1 : 0;
        vr.cns = CheckDomainModel.cns ? CheckDomainModel.cns.filter(item => item.valid === 1).map(item => item.value) : [];
        vr.snis = CheckDomainModel.snis ? CheckDomainModel.snis.filter(item => item.valid === 1).map(item => item.value) : [];
        vr.urls = CheckDomainModel.urls ? CheckDomainModel.urls : [];
        vr.ips = [];

        let ipsArr = CheckDomainModel.dns_part ? CheckDomainModel.dns_part.filter(item => ["A", "AAAA"].includes(item.type)).map(item => item.addr) : [];

        if (typeof AppEnv.UlrAddPortsToIpOnExport == 'undefined' || AppEnv.UlrAddPortsToIpOnExport == 1) {
            ipsArr.forEach((ip) => {
                vr.ips.push(ip + " " + "80");
                vr.ips.push(ip + " " + "443");
            });
        }

        vr.validation_success = true;

        vr.urls.forEach(function (Url, I)
        {
            if(typeof Url === 'string')
            {
                vr.urls[I] = Url.replace('https://', '').replace('http://', '');
            }
        });

        _this.Signals.ValuedResource.next(vr);
    }
};

UlrAddResourceFormWidget.prototype.DefineValidationResult = function(Model)
{
    var view = this.Views.ValidationResultLabel;
    var node = view.getNode();

    var text = [];

    webix.html.removeCss(node, 'success');
    webix.html.removeCss(node, 'error');

    if(Model.validation_success)
    {
        webix.html.addCss(node, 'success');
        view.define("icon","check");
    }
    else
    {
        webix.html.addCss(node, 'error');
        view.define("icon","times");
    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.ip)
    {
        if(Model.validation_success)
        {
            text.push(LangHelper.GetString("UlrModule","The IP address is valid."));
            text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            text.push(LangHelper.GetString("UlrModule","Next IP:PORTS will be added:"));

            Model.ips.forEach(function (Item)
            {
                text.push(Item);
            });
        }
        else {
            text.push(LangHelper.GetString("UlrModule","The IP address is not valid."));
            text.push(LangHelper.GetString("UlrModule","Please enter the IPv4 or IPv6 address in a proper format."));
            text.push(LangHelper.GetString("UlrModule","You can add a port number to the ip address with a colon as separator."));
            text.push(LangHelper.GetString("UlrModule","This will not work if you add this to the list."));
        }
    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.cidr)
    {
        if(Model.validation_success)
        {
            text.push(LangHelper.GetString("UlrModule","The CIDR address is valid."));
            text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            text.push(LangHelper.GetString("UlrModule","Next IP-prefix:PORTS will be added:"));

            Model.cidrs.forEach(function (Item)
            {
                text.push(Item);
            });
        }
        else {
            text.push(LangHelper.GetString("UlrModule","The CIDR address is not valid."));
            text.push(LangHelper.GetString("UlrModule","Please enter the IPv4 or IPv6 CIDR in a proper format."));
            text.push(LangHelper.GetString("UlrModule","This will not work if you add this to the list."));
        }
    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.url)
    {
        if(Model.validation_success)
        {
            var urlValid = false;

            Model.urls.forEach(function (Item)
            {
                if(Item == Model.resource_raw)
                    urlValid = true;
            });

            if(urlValid)
            {
                text.push(LangHelper.GetString("UlrModule", "The URL is valid and accessible."));
                text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            }
            else
            {
                text.push(LangHelper.GetString("UlrModule", "The resource is accessible."));
                text.push(LangHelper.GetString("UlrModule", "But URL is differ."));
                text.push(LangHelper.GetString("UlrModule", "The proper URL will be added to the list."));
                Model.urls.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "URL:") + Item);
                });
            }
        }
        else
        {
            if((Model.isHttps))
            {
                text.push(LangHelper.GetString("UlrModule", "This is SSL/TLS resource. We can block FULL DOMAIN!"));
                text.push(LangHelper.GetString("UlrModule", "Next SNI and CN will be added to the list."));

                Model.snis.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "SNI") + ":" + Item);
                });

                Model.cns.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "CN") + ":" + Item);
                });

            }
            else
            {
                text.push(LangHelper.GetString("UlrModule", "The URL is not accessible or not valid."));
                text.push(LangHelper.GetString("UlrModule","This will not work if you add this to the list."));
            }
        }

    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.cn)
    {
        if(Model.validation_success)
        {
            var cnValid = false;

            Model.cns.forEach(function (Item)
            {
                if(Item == Model.resource_raw)
                    cnValid = true;
            });

            if(cnValid)
            {
                text.push(LangHelper.GetString("UlrModule", "The CN is valid."));
                text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            }
            else
            {
                text.push(LangHelper.GetString("UlrModule", "The resource is accessible."));
                text.push(LangHelper.GetString("UlrModule", "But CN is differ."));
                text.push(LangHelper.GetString("UlrModule","The proper CN will be added to the list."));
                Model.cns.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "CN") + ":" + Item);
                });
            }
        }
        else
        {
            text.push(LangHelper.GetString("UlrModule", "The resource is not SSL/TLS or not accessible."));
            text.push(LangHelper.GetString("UlrModule", "This will not work if you add this to the list."));
        }
    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.sni)
    {
        if(Model.validation_success)
        {
            var sniValid = false;

            Model.snis.forEach(function (Item)
            {
                if(Item == Model.resource_raw)
                    sniValid = true;
            });

            if(sniValid)
            {
                text.push(LangHelper.GetString("UlrModule", "The SNI is valid."));
                text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            }
            else
            {
                text.push(LangHelper.GetString("UlrModule", "The resource is accessible."));
                text.push(LangHelper.GetString("UlrModule", "But SNI is differ."));
                text.push(LangHelper.GetString("UlrModule", "The proper SNI will be added to the list."));
                Model.snis.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "SNI") + ":" + Item);
                });
            }
        }
        else
        {
            text.push(LangHelper.GetString("UlrModule", "The resource is not SSL/TLS or not accessible."));
            text.push(LangHelper.GetString("UlrModule", "This will not work if you add this to the list."));
        }
    }

    if(Model.type_id === "auto")
    {
        if(Model.validation_success)
        {
            if(Model.isHttp)
            {
                text.push(LangHelper.GetString(
                        "UlrModule", "The resource is available via {TYPE} protocol."
                    ).replace("{TYPE}", "<strong>" + "http" + "</strong>")
                );
            }
            if(Model.isHttps)
            {
                text.push(LangHelper.GetString(
                        "UlrModule", "The resource is available via {TYPE} protocol."
                    ).replace("{TYPE}", "<strong>" + "https" + "</strong>")
                );
            }

            text.push(LangHelper.GetString("UlrModule", "The following resources will be added:"));
            text = text.concat(Model.urls ? Model.urls.map(url => "URL: " + url) : []);
            text = text.concat(Model.cns ? Model.cns.map(cn => "CN: " + cn) : []);
            text = text.concat(Model.snis ? Model.cns.map(sni => "SNI: " + sni) : []);
            text = text.concat(Model.ips ? Model.ips.map(ip => "IP: " + ip) : []);
        }
        else
        {
            text.push(LangHelper.GetString("UlrModule", "The resource is not accessible or not valid."));
            text.push(LangHelper.GetString("UlrModule", "This will not work if you add this to the list."));
        }
    }

    view.define("value",text.join("<br/>"));
    view.define("height", text.length*24 + 2*12);
    view.refresh();
    view.resize();

    this.EnableDisableInputs(1);
};

UlrAddResourceFormWidget.prototype.DefineRulesByRawResourceResult = function(Data)
{
    var _this = this;

    var view = this.Views.ValidationResultLabel;
    var node = view.getNode();

    var page = _this.RuleTypeId == 1 ? "UlrEditWebIpFilterRule" : "UlrEditWhiteListRule";

    var text = [];

    webix.html.removeCss(node, 'success');
    webix.html.removeCss(node, 'error');

    webix.html.addCss(node, 'error');
    view.define("icon","times");

    text.push(LangHelper.GetString("UlrModule", "A similar resource has already been added to the following rules:"))

    Data.forEach((item) => {
        text.push(LangHelper.GetString("UlrModule", "Rule") + ": " + `<a href='#${page}/_id=${item.rule_id}' target='_blank'>${item.rule_id}</a>`);
    })

    view.define("value", text.join("<br/>"));
    view.define("height", text.length * 24 + 2 * 12);
    view.refresh();
    view.resize();
};

UlrAddResourceFormWidget.prototype.AddResources = function()
{
    var _this = this;

    var models = [];

    var model = new UlrWebRuleResourceModel();

    var valuedModel = new UlrValuedResourceViewModel(this.Signals.ValuedResource.getValue());

    model.enabled = 1;
    model.resource_raw = valuedModel.resource_raw;
    model.type_id = valuedModel.type_id;

    if(this.RuleId)
        model.rule_id = this.RuleId;

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.ip)
    {
        if(valuedModel.validation_success && valuedModel.ips.length)
        {
            valuedModel.ips.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.ip,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.try_validate && !valuedModel.validation_success)
        {
            model.state_valid = UlrStateValidEnum.invalid;
            models.push(model);
        }
        else if(!valuedModel.try_validate)
        {
            model.state_valid = UlrStateValidEnum.undefined;
            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.cidr)
    {
        if(valuedModel.validation_success && valuedModel.cidrs.length)
        {
            valuedModel.cidrs.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.cidr,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.try_validate && !valuedModel.validation_success)
        {
            model.state_valid = UlrStateValidEnum.invalid;
            models.push(model);
        }
        else if(!valuedModel.try_validate)
        {
            model.state_valid = UlrStateValidEnum.undefined;
            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.url)
    {
        if(valuedModel.validation_success && valuedModel.urls.length)
        {
            model.resource_validated = valuedModel.isHttp;
            model.state_valid = UlrStateValidEnum.valid;

            valuedModel.urls.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.url,
                    resource_validated:Item
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.isHttps)
        {
            valuedModel.cns.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.cn,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });

            valuedModel.snis.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.sni,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else
        {
            if(valuedModel.try_validate)
                model.state_valid = UlrStateValidEnum.invalid;

            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.cn)
    {
        if(valuedModel.validation_success && valuedModel.cns.length)
        {
            valuedModel.cns.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.cn,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.try_validate && !valuedModel.validation_success)
        {
            model.state_valid = UlrStateValidEnum.invalid;
            models.push(model);
        }
        else if(!valuedModel.try_validate)
        {
            model.state_valid = UlrStateValidEnum.undefined;
            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.sni)
    {
        if(valuedModel.validation_success && valuedModel.snis.length)
        {
            valuedModel.snis.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.sni,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.try_validate && !valuedModel.validation_success)
        {
            model.state_valid = UlrStateValidEnum.invalid;
            models.push(model);
        }
        else if(!valuedModel.try_validate)
        {
            model.state_valid = UlrStateValidEnum.undefined;
            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.clsfr)
    {
        model.state_valid = UlrStateValidEnum.valid;
        models.push(model);
    }

    if(valuedModel.type_id === "auto")
    {
        if(valuedModel.try_validate && valuedModel.validation_success)
        {
            Object.keys(UlrWebRuleResourcesTypesMapListKeys).forEach((key) => {
                let listKey = UlrWebRuleResourcesTypesMapListKeys[key];

                if(valuedModel[listKey].length)
                {
                    valuedModel[listKey].forEach(function (Item)
                    {
                        var _model = webix.extend(model, {
                            type_id: UlrWebRuleResourcesTypesMapEnum[key],
                            resource_validated:Item,
                            state_valid: UlrStateValidEnum.valid
                        },true);

                        models.push(new UlrWebRuleResourceModel(_model));
                    });
                }
            })
        }
        else
        {
            let stateValid = valuedModel.try_validate  ? UlrStateValidEnum.invalid : UlrStateValidEnum.undefined;

            let vItems = valuedModel.resource_raw.split(":");
            if (vItems.length > 2 || vItems.length == 1)
                vItems = valuedModel.resource_raw.split(' ');

            let input = vItems[0];

            if(Helper.ValidateIPv4(input)||Helper.ValidateIPv6(input))
            {
                ["80", "443"].forEach((port) => {
                    var _model = webix.extend(model, {
                        resource_raw: valuedModel.resource_raw + " " + port,
                        type_id: UlrWebRuleResourcesTypesMapEnum.ip,
                        state_valid: stateValid
                    },true);
                    models.push(new UlrWebRuleResourceModel(_model));
                })
            }
            else if (Helper.UlrValidateCidr(input))
            {
                model.type_id = UlrWebRuleResourcesTypesMapEnum.cidr;
                model.state_valid = stateValid;
                models.push(model);
            }
            else
            {
                ["sni", "cn", "url"].forEach((code) => {
                    var _model = webix.extend(model, {
                        type_id: UlrWebRuleResourcesTypesMapEnum[code],
                        state_valid: stateValid
                    },true);

                    models.push(new UlrWebRuleResourceModel(_model));

                    if (code === 'url')
                    {
                        var _model = webix.extend(model, {
                            type_id: UlrWebRuleResourcesTypesMapEnum[code],
                            resource_raw: model.resource_raw + ":",
                            state_valid: stateValid
                        },true);

                        models.push(new UlrWebRuleResourceModel(_model));
                    }
                })
            }
        }
    }

    this.ClearAddResourcesForm();

    this.JustAddedResources = models.concat(this.JustAddedResources);
    this.RefreshJustAddedResources();
    this.Views.JustAddedResourcesPopup.show();
};

UlrAddResourceFormWidget.prototype.ClearAddResourcesForm = function ()
{
    this.Views.AddResourceInput.setValue("");
    this.Views.ValidationResultLabel.hide();
};


UlrAddResourceFormWidget.prototype.RefreshJustAddedResources = function()
{
    if (this.JustAddedResources.length)
    {
        this.Views.JustAddedResourcesShowBtn.enable();
        this.Views.JustAddedResourcesShowBtn.define(
            {badge: UlrButtonBadgeTemplate(this.JustAddedResources.length)}
        );
        this.Views.JustAddedResourcesShowBtn.refresh();

        this.Views.JustAddedResourcesAddBtn.enable();
        this.Views.JustAddedResourcesClearBtn.enable();
    }
    else
    {
        this.Views.JustAddedResourcesShowBtn.disable();
        this.Views.JustAddedResourcesShowBtn.define({badge: null});
        this.Views.JustAddedResourcesShowBtn.refresh();

        this.Views.JustAddedResourcesAddBtn.disable();
        this.Views.JustAddedResourcesClearBtn.disable();
    }

    this.Views.ReportsWidgets.JustAddedResourcesTable.RefreshData();
};

UlrAddResourceFormWidget.prototype.SaveJustAddedResources = function()
{
    if (this.JustAddedResources.length)
    {
        this.Signals.SaveResources.next(this.JustAddedResources)
    }
};

UlrAddResourceFormWidget.prototype.JustAddedResourcesTableOnClick = function(Id)
{
    let table = this.Views.ReportsWidgets.JustAddedResourcesTable.Views.Table;
    let item = table.getItem(Id.row);

    if (item)
    {
        switch (Id.column)
        {
            case "enabled":
                let obj = this.JustAddedResources.find((resource) => {
                    return resource.id === item.id;
                })
                obj.enabled = item.enabled;
                break;
            case "delete":
                this.JustAddedResources = this.JustAddedResources.filter((resource) => {
                    return item.id !== resource.id;
                });
                break;
        }
        this.RefreshJustAddedResources();
    }
};


UlrAddResourceFormWidget.prototype.AddResourcesFromImport = function ()
{
    var _this = this;

    var value = this.Views.ImportResourcesPopupEditor.getValue();

    if(!value)
        return;

    var lines = value.split(/\r|\n/);

    var firstLine = lines[0];

    var colsMap = {
        type_id: 0,
        resource_raw: 1,
        resource_validated: 2
    };

    if(firstLine.indexOf("type_id") >= 0 && firstLine.indexOf("resource_raw") >= 0 && firstLine.indexOf("resource_validated") >= 0 )
    {
        lines.shift();

        var headersIds = firstLine.split("\t");

        headersIds.forEach(function (Item, Index)
        {
            if(Item == "type_id" || Item == "resource_raw" || Item == "resource_validated")
                colsMap[Item] = Index;
        });
    }

    if(firstLine.indexOf(LangHelper.GetString("UlrModule","Type")) >= 0 && firstLine.indexOf(LangHelper.GetString("UlrModule","Resource raw")) >= 0 && firstLine.indexOf(LangHelper.GetString("UlrModule","Resource validated")) >= 0 )
    {
        lines.shift();

        var headersIds = firstLine.split("\t");

        headersIds.forEach(function (Item, Index)
        {
            if(Item == LangHelper.GetString("UlrModule","Type"))
                colsMap["type_id"] = Index;

            if(Item == LangHelper.GetString("UlrModule","Resource raw"))
                colsMap["resource_raw"] = Index;

            if(Item == LangHelper.GetString("UlrModule","Resource validated"))
                colsMap["resource_validated"] = Index;
        });
    }

    var item_types = [UlrWebRuleResourcesTypesMapEnum.cn, UlrWebRuleResourcesTypesMapEnum.sni, UlrWebRuleResourcesTypesMapEnum.url];

    var models = [];

    lines.forEach(function (Line)
    {
        var model = new UlrWebRuleResourceModel();

        var cols = Line.split("\t");

        if(cols.length > 1)
        {
            model.enabled = 1;
            model.resource_raw = cols[colsMap.resource_raw] ? cols[colsMap.resource_raw] : "";
            model.resource_validated = cols[colsMap.resource_validated] ? cols[colsMap.resource_validated] : "";

            model.type_id = cols[colsMap.type_id] ? cols[colsMap.type_id] : UlrWebRuleResourcesTypesMapEnum.url;
            model.type_id = model.type_id && isNaN(model.type_id) ? (UlrWebRuleResourcesTypesMapEnum[model.type_id.toLowerCase()] ? UlrWebRuleResourcesTypesMapEnum[model.type_id.toLowerCase()] : UlrWebRuleResourcesTypesMapEnum.url)  : model.type_id;

            if(model.resource_validated)
                model.state_valid = UlrStateValidEnum.valid;

            if(model.resource_raw && model.resource_validated && model.type_id)
                models.push(model);
        }
        else if(cols.length == 1)
        {
            var ports = [];

            if (AppEnv.UlrAddPortsToIpOnExport == 1)
            {
                ports = ['80', '443'];
            }

            // Разбор на порты для АР
            var splt = cols[0].split(":");
            if(splt.length == 1 || splt.length > 2)
            {
                splt = cols[0].split(" ");
            }

            var resource = splt[0];

            if(splt.length > 1)
            {
                var port = splt[splt.length - 1];
                try{
                    var check = parseInt(port);

                    if(!check || isNaN(check))
                    {
                        throw new Error();
                    }

                    ports = [port];
                }
                catch (e)
                {
                    resource = cols[0];
                }
            }

            if(Helper.ValidateIPaddressOrCidr(resource))
            {
                var add_row = function(row)
                {
                    var _model = webix.extend(webix.copy(model), {
                        enabled: 1,
                        resource_raw: row,
                        type_id: Helper.ValidateIPaddress(resource) ? UlrWebRuleResourcesTypesMapEnum.ip : UlrWebRuleResourcesTypesMapEnum.cidr
                    }, true);

                    models.push(_model);
                }

                if(Helper.ValidateIPv6Cidr(resource))
                {
                    add_row(resource);
                }
                else
                {
                    if(ports.length)
                    {
                        ports.forEach((Port) => {
                            const ipPort = resource + " " + Port;

                            add_row(ipPort);
                        });
                    }
                    else
                    {
                        add_row(resource);
                    }

                }
            }
            else if(resource)
            {
                resource = resource.replace("http://", "");
                resource = resource.replace("https://", "");

                if(resource.slice(-1) === '/')
                    resource = resource.slice(0, -1);

                // if(resource.slice(0, 4) === 'www.')
                //     resource = resource.slice(4);

                item_types.forEach((Type) => {
                    var _model = webix.extend(webix.copy(model), {
                        enabled: 1,
                        resource_raw: resource,
                        type_id: Type
                    }, true);

                    models.push(_model);
                });

                // Add URL with : at the end
                // #98998
                if(ports.length === 0 && resource.indexOf(':') === -1)
                {
                    var _model = webix.extend(webix.copy(model), {
                        enabled: 1,
                        resource_raw: resource + ":",
                        type_id: UlrWebRuleResourcesTypesMapEnum.url
                    }, true);

                    models.push(_model);
                }
            }
        }
    });

    if(this.RuleId)
    {
        models.forEach((item) => {
            item.rule_id = this.RuleId;
        })
    }

    if(models.length > 0)
    {
        this.JustAddedResources = models.concat(this.JustAddedResources);
        this.RefreshJustAddedResources();
    }

    this.Views.ImportResourcesPopupEditor.setValue("");
};


UlrAddResourceFormWidget.prototype.ImportResourcesFilePopupHide = function ()
{
    if
    (
        this.ImportResourcesFileArr.length &&
        this.ImportResourcesFileArr.some(item => item.state === UlrFilesStatusDic.failed.id)
    )
    {
        return;
    }

    this.Views.ImportResourcesFilePopup.hide();
};

UlrAddResourceFormWidget.prototype.UploadImportResourcesFile = function(FileObj)
{
    var _this = this;

    var model = {
        id: FileObj.id ? FileObj.id : webix.uid(),
        name: FileObj.name,
        size: FileObj.size,
        sizetext: FileObj.sizetext,
        state: UlrFilesStatusDic.new.id,
        uploadId: "",
        filepath: ""
    };

    this.ImportResourcesFileArr.push(model);

    var modelIndex = this.ImportResourcesFileArr.findIndex((Obj) => Obj.id == model.id);

    this.RefreshImportResourcesFiles();

    var path = "upload_files/";

    var fileName = webix.uid() + "_" + model.name;
    var result_fpath = path + fileName;

    var updateModelClosure = function(Model)
    {
        var modelIndex = _this.ImportResourcesFileArr.findIndex((Obj) => Obj.id == Model.id);
        if(modelIndex > -1)
        {
            _this.ImportResourcesFileArr[modelIndex] = Model;
            return true;
        }

        return false;
    };

    App.ServerManager.UlrGenerateFileUploadId({
        fileName: fileName,
        path: path,
        callback: function(R)
        {
            if(R.success && R.data)
            {
                var key = R.data.key ? R.data.key : webix.uid();

                model.uploadId = key;
                model.state = UlrFilesStatusDic.uploading.id;

                if(updateModelClosure(model))
                {
                    _this.RefreshImportResourcesFiles();

                    App.ServerManager.UploadFile({
                        key: key,
                        file: FileObj.file,
                        callback: function(R)
                        {
                            if(R.status != 200)
                            {
                                model.state = UlrFilesStatusDic.failed.id;
                            }
                            else
                            {
                                model.state = UlrFilesStatusDic.uploaded.id;
                                model.filepath = result_fpath;
                            }

                            if(updateModelClosure(model))
                            {
                                _this.RefreshImportResourcesFiles();
                            }
                        }
                    });
                }

            }
            else if(R.error)
            {
                model.state = UlrFilesStatusDic.failed.id;
                if(updateModelClosure(model))
                {
                    _this.RefreshImportResourcesFiles();
                }
                _this.ShowServerError(R.error);
            }
        }
    });
};

UlrAddResourceFormWidget.prototype.AddResourcesFromImportFiles = function()
{
    if (this.ImportResourcesFileArr.length)
    {
        let failedFiles = this.ImportResourcesFileArr.filter((item) => {
            return item.state !== UlrFilesStatusDic.uploaded.id;
        });

        if (failedFiles && failedFiles.length)
        {
            failedFiles.forEach((item) => {
                UlrShowMessage(
                    "error",
                    item.name ? item.name : "",
                    LangHelper.GetString("UlrModule","Can not upload file."),
                );
            })
        }
        else
        {
            this.Signals.AddResourcesFromFiles.next(this.ImportResourcesFileArr);
        }
    }
};

UlrAddResourceFormWidget.prototype.RefreshImportResourcesFiles = function()
{
    let countUploadedFiles = 0;

    if (this.ImportResourcesFileArr.length)
    {
        for (let item of this.ImportResourcesFileArr)
        {
            if (item.state === UlrFilesStatusDic.uploaded.id && item.uploadId.length)
            {
                countUploadedFiles++;
            }
        }

        if (countUploadedFiles === this.ImportResourcesFileArr.length)
        {
            this.Views.ImportResourcesFilePopupAddBtn.enable();
            this.Views.ImportResourcesFilePopupClearBtn.enable();

            let badgeCount = countUploadedFiles > 99 ? "99+" : countUploadedFiles;
            this.Views.ImportResourcesFileShowPopupBtn.define({badge: UlrButtonBadgeTemplate(badgeCount)});
        }
        else
        {
            this.Views.ImportResourcesFilePopupAddBtn.disable();
            this.Views.ImportResourcesFilePopupClearBtn.disable();
            this.Views.ImportResourcesFileShowPopupBtn.define({badge: UlrButtonBadgeAlertTemplate()});
        }

    }
    else
    {
        this.Views.ImportResourcesFilePopupAddBtn.disable();
        this.Views.ImportResourcesFilePopupClearBtn.disable();

        this.Views.ImportResourcesFileShowPopupBtn.define({badge: null});
    }

    this.Views.ImportResourcesFileShowPopupBtn.refresh();
    this.Views.ReportsWidgets.ImportedResourcesFileReport.RefreshData();
};

UlrAddResourceFormWidget.prototype.DeleteUploadedResourcesFiles = function()
{
    this.ImportResourcesFileArr = this.ImportResourcesFileArr.filter(item => item.state !== UlrFilesStatusDic.uploaded.id)
    this.RefreshImportResourcesFiles();
};

UlrAddResourceFormWidget.prototype.SetErrorStateImportResourceFile = function(FileModel)
{
    let idx = this.ImportResourcesFileArr.findIndex(x => x.id == FileModel.id);

    if (idx > -1)
    {
        this.ImportResourcesFileArr[idx].state = UlrFilesStatusDic.failed.id;
        this.RefreshImportResourcesFiles();
    }
}

UlrAddResourceFormWidget.prototype.ClearImportResourcesFile = function ()
{
    this.ImportResourcesFileArr = [];
    this.RefreshImportResourcesFiles();
};

UlrAddResourceFormWidget.prototype.ImportedResourcesFileReportTableOnClick = function(Id)
{
    let _this = this;

    if(Id.column === 'delete')
    {
        let table = _this.Views.ReportsWidgets.ImportedResourcesFileReport.Views.Table
        let item = table.getItem(Id);

        if(item)
        {
            const index = _this.ImportResourcesFileArr.findIndex(x => x.id == item.id);
            if(index > -1)
            {
                _this.ImportResourcesFileArr.splice(index, 1);
            }
        }
        table.remove(Id);

        _this.RefreshImportResourcesFiles();
    }
};

function UlrWebIpFilterRulesViewController(Params)
{
    var _this = this;

    this.Id = "UlrWebIpFilterRules";

    this.PathParams = {};

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Web filter"),
        Title:""
    };

    this.ViewModel = new UlrWebIpFilterRulesManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        FiltersForm:null,
        FilterApplyBtn:null,
        FilterClearBtn:null,
        ResourceTypesInput:null,
        SubsIdsInput: null,
        QoeImported: null,
        IspIdsInput: null,
        ToggleIcon: null,
        AdditionalFiltersContainer: null,
        LastChangesList: null,
        RulesList: null,
        EditorTabs: null,
        ResourceFilterSection: null,

        ToolsBtn: null,
        ToolsSubmenu: null,

        Widgets:{
            DateRangePicker: new QoEDateRangePickerWidget({
                id:this.Id + "DateRangePicker",
                default_value:"empty"
            })
        },
        ReportsWidgets:{
            RulesReport: UrlLastWebRulesEntriesTableWidget({
                id:this.Id + "RulesReport",
                enableTextSearch:false,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.RulesReportOnItemClick(Id, E, Node);
                }
                // ,
                // onCheck:function (Row, Column, State)
                // {
                //     _this.RulesReportOnCheck(Row, Column, State);
                // }
            }),
            WebRulesReport: UrlWebRulesTableWidget({
                id:this.Id + "WebRulesReport",
                enableTextSearch:false,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.WebRulesReportOnItemClick(Id, E, Node);
                },
                onCheck: function(Row, Column, State)
                {
                    _this.WebRulesReportOnCheck(Row, Column, State);
                }
            })
        }
    };

    this.ToolsSubmenu = webix.ui({
        view: "submenu",
        id: this.Id + "ToolsSubmenu",
        width: 200,
        autowidth: true,
        padding: 0,
        data: [
            {
                id: _this.Id + "WebRules", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Rules"),
                submenu:[
                    {
                        id: _this.Id + "ToolsSubmenu" + "EnableWebRule",
                        icon: "lightbulb bold green",
                        value: LangHelper.GetString("UlrModule", "Enable rules")
                    },
                    {
                        id: _this.Id + "ToolsSubmenu" + "DisableWebRule",
                        icon: "lightbulb red",
                        value: LangHelper.GetString("UlrModule", "Disable rules")
                    },
                ]
            }
        ],
        on: {
            onMenuItemClick: function (Id)
            {
                let selectedRows = _this.Views.ReportsWidgets.WebRulesReport.GetSelectedData();

                if(Id ===  _this.Id + "ToolsSubmenu" + "EnableWebRule")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        _this.EnableDisableWebRules(1);
                    }
                }

                if(Id ===  _this.Id + "ToolsSubmenu" + "DisableWebRule")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        _this.EnableDisableWebRules(0);
                    }
                }

                this.hide();
            }
        }
    });

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title: this.PageTitle.RootTitle}),
                            {height:32},
                            {
                                view:"template",
                                borderless:true,
                                css:"form_text_big_label",
                                autoheight:true,
                                template:function (RuleType)
                                {
                                    return LangHelper.GetString("UlrModule","WEB_FILTER_SECTION_DESCRIPTION");

                                }(this.RuleType)
                            },
                            {height:20},
                            {
                                view:"template",
                                borderless:false,
                                border:2,
                                css:"form_text_warning_label",
                                autoheight:true,
                                template:function (RuleType)
                                {
                                    var warning = "<span class='warning'>"+LangHelper.GetString("UlrModule","Warning")+"</span>" + ": ";
                                    var label = LangHelper.GetString("UlrModule","WEB_FILTER_SECTION_ATTENTION");

                                    return warning+label+'</br>&nbsp;';
                                }(this.RuleType)
                            },
                            {height:32},
                            {
                                type: "wide",
                                borderless:true,
                                rows:[
                                    {
                                        type: "wide",
                                        borderless: true,
                                        cols: [
                                            {
                                                view:"tabbar",
                                                id:this.Id + "Editor" + "Tabs",
                                                // tabMoreWidth:0,
                                                // value: this.Id + "LastChangesList",
                                                // multiview:true,
                                                css: "ulr-tabbar",
                                                options: [
                                                    {
                                                        id: this.Id + "RulesList",
                                                        // value: "<span class='webix_icon fa-trello'></span> "+LangHelper.GetString("All","Web rules list")
                                                        value: LangHelper.GetString("UlrModule","Rules")
                                                    },
                                                    {
                                                        id: this.Id + "LastChangesList",
                                                        // value: "<span class='webix_icon fa-code'></span> "+ LangHelper.GetString("UlrModule","Last entries in Web/IP register")
                                                        value: LangHelper.GetString("UlrModule","Resources")
                                                    }
                                                ],
                                                on:{
                                                    "onAfterTabClick":function(Id)
                                                    {
                                                        $$(Id).show();
                                                        _this.RefreshTableReport();

                                                        _this.SetTemplateForOpenedTab(Id);

                                                        _this.SetLastOpenedTab(Id);
                                                    }
                                                }
                                            },
                                            {
                                                gravity:3
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height:32},
                            {
                                view:"form",
                                id:this.Id + "FiltersForm",
                                type: "wide",
                                borderless:true,
                                on: {
                                    onSubmit: function(view, event) {
                                        _this.RefreshTableReport();
                                    }
                                },
                                elements:[
                                    {
                                        type: "wide",
                                        cols:[
                                            this.Views.Widgets.DateRangePicker.ViewConfig,
                                            {
                                                view:"spectre_text",
                                                name:"full_text_search",
                                                label:LangHelper.GetString("UlrModule","Search")
                                            },
                                            {
                                                view:"spectre_multiselect",
                                                name:"rule_type",
                                                label:LangHelper.GetString("UlrModule","Rule type"),
                                                options: Helper.DictToArr(UlrWebRuleResourcesListTypes)
                                            },
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "template",
                                                autoheight: true,
                                                borderless: true,
                                                template: `<span class="custom-additional-filters">${LangHelper.GetString("UlrModule","All filters")}</span><span id=${_this.Id + "ToggleIcon"} class="webix_icon fa-angle-down"></span>`,
                                                onClick: {
                                                    "webix_template": function(id){
                                                        _this.ShowHideAdditionalFilters();
                                                    }
                                                }
                                            },
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        id: _this.Id + "AdditionalFiltersContainer",
                                        hidden: true,
                                        rows: [
                                            {
                                                type:"wide",
                                                cols:[
                                                    {
                                                        view:"spectre_text",
                                                        name:"rule_id",
                                                        label:LangHelper.GetString("UlrModule","Rule id")
                                                    },
                                                    {
                                                        view:"spectre_multiselect",
                                                        name:"enabled",
                                                        label:LangHelper.GetString("UlrModule","Rule state"),
                                                        options: Helper.DictToArr(BlStatusesDic)
                                                    },
                                                    {
                                                        view:"spectre_text",
                                                        name:"description_full_text_search",
                                                        label:LangHelper.GetString("UlrModule","Reason"),
                                                    }
                                                ]
                                            },
                                            {
                                                type:"wide",
                                                id: _this.Id + "ResourceFilterSection",
                                                cols:[
                                                    {
                                                        view:"spectre_text",
                                                        name:"resource_raw",
                                                        label:LangHelper.GetString("UlrModule","Resource")
                                                    },
                                                    {
                                                        view:"spectre_text",
                                                        name:"resource_validated",
                                                        label:LangHelper.GetString("UlrModule","Resource validated")
                                                    },
                                                    {
                                                        view:"spectre_multiselect",
                                                        id:this.Id + "ResourceTypesInput",
                                                        name:"type_id",
                                                        label:LangHelper.GetString("UlrModule","Resource type"),
                                                        options:{
                                                            point:false,
                                                            data:[]
                                                        }
                                                    },
                                                ]
                                            },
                                            {
                                                type:"wide",
                                                cols:[
                                                    {
                                                        view:"spectre_text",
                                                        name:"update_user",
                                                        label:LangHelper.GetString("UlrModule","User"),
                                                    },
                                                    {
                                                        view:"spectre_text",
                                                        name:"regulator",
                                                        label:LangHelper.GetString("UlrModule","Regulator")
                                                    },
                                                    {
                                                        view:"spectre_text",
                                                        name:"category",
                                                        label:LangHelper.GetString("UlrModule","Category")
                                                    },
                                                ]
                                            },
                                            {
                                                type: "wide",
                                                cols: [
                                                    {
                                                        view: "spectre_multiselect",
                                                        id: this.Id + "IspIdsInput",
                                                        name: "isp_id",
                                                        label: LangHelper.GetString("UlrModule", "Isps"),
                                                        options:{
                                                            point:false,
                                                            data:[]
                                                        }
                                                    },
                                                    {
                                                        view: "spectre_multiselect",
                                                        id: this.Id + "SubsIdsInput",
                                                        name: "sub_id",
                                                        label: LangHelper.GetString("UlrNodule", "Subscribers"),
                                                        options:{
                                                            point:false,
                                                            data:[]
                                                        }
                                                    },
                                                    {
                                                        view: "spectre_multiselect",
                                                        id: this.Id + "QoeImported",
                                                        name: "imported",
                                                        label: LangHelper.GetString("UlrModule", "Imported from QoE resource"),
                                                        options: Helper.DictToArr(YesNoDic)
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols: [
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "FilterApplyBtn",
                                                css:"form_button form_element main_action",
                                                label:LangHelper.GetString("UlrModule","Apply"),
                                                height:51,
                                                click:function ()
                                                {
                                                    _this.DisableEnableBtn("disable");
                                                    setTimeout(function ()
                                                    {
                                                        _this.RefreshTableReport();
                                                    },1);
                                                }
                                            },
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "FilterClearBtn",
                                                css:"form_button form_element third_action",
                                                label:LangHelper.GetString("UlrModule","Clear"),
                                                height:51,
                                                click:function ()
                                                {
                                                    _this.DisableEnableBtn("disable");
                                                    _this.ClearFiltersForm();

                                                    setTimeout(function ()
                                                    {
                                                        _this.RefreshTableReport();
                                                    },1);
                                                }
                                            },
                                            {},
                                            {
                                                view: "spectre_button",
                                                id: this.Id + "ToolsBtn",
                                                type:"icon",
                                                css: "form_button spec_action with_icon",
                                                label:LangHelper.GetString("UlrModule", "Tools"),
                                                icon:"tools",
                                                //width:52
                                                //height:44,
                                                autowidth: true,
                                                click:function ()
                                                {
                                                    _this.ToolsBtnOnClick(this.getNode());
                                                }
                                            }
                                        ]
                                    }
                                ],
                            },
                            {height:32},
                            {
                                type: "wide",
                                borderless:true,
                                rows:[
                                    {
                                        id: this.Id + "TabWrapper",
                                        // view: "multiview",
                                        animate: false,
                                        // borderless: true,
                                        cells: [
                                            {
                                                id: this.Id + "RulesList",
                                                rows:[
                                                    this.Views.ReportsWidgets.WebRulesReport.ViewConfig
                                                ]
                                            },
                                            {
                                                id: this.Id + "LastChangesList",
                                                rows:[
                                                    this.Views.ReportsWidgets.RulesReport.ViewConfig
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrWebIpFilterRulesViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.Widgets.DateRangePicker.SetValue(null,true);

    this.Subscriptions.WebRulesSelectedCount = this.Views.ReportsWidgets.WebRulesReport.TableRowsSelectedCount.subscribe(function (Value) {
        if (Value > 1)
        {
            _this.Views.ToolsBtn.enable();
        }
        else
        {
            _this.Views.ToolsBtn.disable();

            if(_this.Views.ToolsSubmenu.isVisible())
            {
                _this.Views.ToolsSubmenu.hide();
            }
        }
    });

    this.Subscriptions[DicsEnum.UlrResourceTypesDic] = App.DicsManager.Signal[DicsEnum.UlrResourceTypesDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.ResourceTypesInput.getList().clearAll();

            let dicArr = Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrResourceTypesDic));

            dicArr = dicArr.filter(item => Object.values(UlrWebRuleResourcesTypesMapEnum).indexOf(parseInt(item.id)) > -1);

            var arr = [];
            dicArr.forEach(function (item){
                item.value = LangHelper.GetString("UlrModule", item.value);
                arr.push(item);
            });

            if(arr && arr.length)
            {
                _this.Views.ResourceTypesInput.getList().clearAll();
                _this.Views.ResourceTypesInput.getList().parse(arr);
            }
        }
    });

    this.Subscriptions[DicsEnum.UlrIspsDic] = App.DicsManager.Signal[DicsEnum.UlrIspsDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.IspIdsInput.getList().clearAll();

            let dicArr = [];

            Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrIspsDic)).forEach((Obj) => {
                dicArr.push({
                    id: Obj.id,
                    dic_id: Obj.dic_id,
                    value: Obj.value + " (" + Obj.igw_name + ")"
                });
            });

            if(dicArr && dicArr.length)
            {
                _this.Views.IspIdsInput.getList().clearAll();
                _this.Views.IspIdsInput.getList().parse(dicArr);
            }
        }
    });

    this.Subscriptions[DicsEnum.UlrSubscribersDic] = App.DicsManager.Signal[DicsEnum.UlrSubscribersDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.SubsIdsInput.getList().clearAll();

            let dicArr = [];

            Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrSubscribersDic)).forEach((Obj) => {
                dicArr.push({
                    id: Obj.id,
                    dic_id: Obj.dic_id,
                    value: Obj.value + " (" + Obj.igw_name + ")"
                });
            });

            if(dicArr && dicArr.length)
            {
                _this.Views.SubsIdsInput.getList().clearAll();
                _this.Views.SubsIdsInput.getList().parse(dicArr);
            }
        }
    });

    this.Subscriptions.DisableFiltersButton = this.ReportsModel.Reports[`${this.Id}RulesReport`].signal.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.DisableEnableBtn("enable");
        }
    });

    this.Subscriptions.DisableFiltersButtonWebRules = this.ReportsModel.Reports[`${this.Id}WebRulesReport`].signal.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.DisableEnableBtn("enable");
        }
    });


    this.Views.EditorTabs.setValue(this.GetLastOpenedTab());

    var tabId = this.GetLastOpenedTab();
    this.SetTemplateForOpenedTab(tabId);
    $$(tabId).show();

    App.DicsManager.Refresh({data: [DicsEnum.UlrResourceTypesDic, DicsEnum.UlrIspsDic, DicsEnum.UlrSubscribersDic, DicsEnum.UlrCategoriesDic, DicsEnum.UlrRegulatorsDic]});

    this.GetAllPathParam();
};

UlrWebIpFilterRulesViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.PathParams = Params;

    this.BindAll(Params);

    this.RefreshTableReport();
};

UlrWebIpFilterRulesViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

// UlrWebIpFilterRulesViewController.prototype.Refresh = function ()
// {
//     this.Views.ReportsWidgets.RulesReport.RefreshData();
// };

UlrWebIpFilterRulesViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrWebIpFilterRulesViewController.prototype.RulesReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.RulesReport.Views.Table;

    var data = table.getItem(Id);

    if((Id.column === 'rule_id' && E.target && E.target.className == "webix_cell_link") || Id.column === 'edit')
    {
        App.NavRouter.PresentView({id: ControllersEnum.UlrEditWebIpFilterRule, path:"/_id=" + data.rule_id});
    }
    else if(Id.column === 'resource_raw' && data.type == UlrWebRuleResourcesTypesEnum.clsfr.toUpperCase() && App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.ulr_hosts_list))
    {
        var host_type_name = Helper.Table.ClsfrIdToNameTemplate(data.resource_raw, true);

        var modal_title = LangHelper.GetString("UlrModule", "Hosts list of the {CATEGORY} category").replace("{CATEGORY}", host_type_name);

        var table_params = {
            enableAutoHeight: false,
            enableTextSearch: true,
            is_modal: true,
            filter: {
                cat_id: {
                    id: "cat_id",
                    operator: "=",
                    value: data.resource_raw
                }
            },
        }
        var table = new UlrAppCategoryHostsTable(table_params);
        UlrEditAppPolicingPopup({
            modal_title: modal_title
        }, table);
        table.Bind(_this, _this.ReportsModel);
        table.RefreshData();
    }
    else if(Id.column === "resource_raw" && data.type == UlrWebRuleResourcesTypesEnum.ulr_fastresource.toUpperCase() && data.fastresource_config)
    {
        ResourceImportQoEPopupItem({
            cfg: data.fastresource_config
        });
    }
};

UlrWebIpFilterRulesViewController.prototype.WebRulesReportOnItemClick = function(Id, E, Node)
{
    var _this = this;
    var table = this.Views.ReportsWidgets.WebRulesReport.Views.Table;

    var data = table.getItem(Id);

    if((Id.column === 'rule_id' && E.target && E.target.className == "webix_cell_link") || Id.column === 'edit')
    {
        App.NavRouter.PresentView({id: ControllersEnum.UlrEditWebIpFilterRule, path:"/_id=" + data.rule_id});
    }




    // if(Id.column === 'delete')
    // {
    //     var table = this.Views.ReportsWidgets.RulesReport.Views.Table;
    //
    //     var data = table.getItem(Id);
    //
    //     var node = table.getItemNode(Id);
    //
    //     UlrShowDialogPopup({
    //         node:node,
    //         position:"bottom",
    //         head:LangHelper.GetString("UlrModule","Delete") + "?",
    //         //type:"spectre-alert-notification",
    //         mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
    //         message:LangHelper.GetString("UlrModule","Are you sure?"),
    //         actions:[
    //             {
    //                 css:"spec_action",
    //                 label:LangHelper.GetString("UlrModule","Cancel")
    //             },
    //             {
    //                 label:LangHelper.GetString("UlrModule","Delete"),
    //                 click:function ()
    //                 {
    //                     _this.ViewModel.DeleteWebRule(data);
    //                 }
    //             }
    //         ]
    //     });
    // }
};

UlrWebIpFilterRulesViewController.prototype.WebRulesReportOnCheck = function(Row, Column, State)
{
    var _this = this;
    var table = this.Views.ReportsWidgets.WebRulesReport.Views.Table;

    var item = table.getItem(Row);

    if(Column == "checked")
    {
        if(item.checked)
        {
            table.select(Row, true)
        }
        else
        {
            table.unselect(Row);
        }
    }

    if (Column == "enabled")
    {
        var cb = table.getHeaderContent("mc");
        if (cb.isChecked())
            cb.uncheck();

        table.serialize().forEach(item => {
            item.checked = 0;
        });

        item.checked = 1;
        table.updateItem(Row, item);
        table.select(Row);
        _this.EnableDisableWebRules(State, false)
    }
}

UlrWebIpFilterRulesViewController.prototype.ShowExportForm = function()
{
    this.ExportRulePopup.show();
};

UlrWebIpFilterRulesViewController.prototype.RefreshTableReport = function ()
{
    var filter = {};

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(period)
    {
        var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

        if(period.start && period.end)
        {
            filter.period = {
                id:"update_time",
                operator:"between",
                value:[format(Helper.DateTimeToUTC(period.start)), format(Helper.DateTimeToUTC(period.end))]
            };
        }

        else if(period.start)
        {
            filter.period = {
                id:"update_time",
                operator:">=",
                value:format(Helper.DateTimeToUTC(period.start))
            };
        }

        else if(period.end)
        {
            filter.period = {
                id:"update_time",
                operator:"<=",
                value:format(Helper.DateTimeToUTC(period.end))
            };
        }
    }

    let filterFormVals = this.Views.FiltersForm.getValues();

    if(filterFormVals.rule_type)
    {
        if (Array.isArray(filterFormVals.rule_type))
            filterFormVals.rule_type = filterFormVals.rule_type.join(',');

        if (filterFormVals.rule_type.indexOf("isp") !== -1 && filterFormVals.rule_type.indexOf("subscriber") !== -1)
            filterFormVals.rule_type += ",isp_subs";

        filter.rule_type_mode =
            {
                id:"rule_type_mode",
                operator:"in",
                value:filterFormVals.rule_type.split(',')
            };
    }

    if(filterFormVals.rule_id)
    {
        filter.rule_id =
            {
                id:"rule_id",
                operator:"=",
                value:filterFormVals.rule_id
            };
    }

    if(filterFormVals.enabled)
    {
        if (Array.isArray(filterFormVals.enabled))
            filterFormVals.enabled = filterFormVals.enabled.join(',');

        filter.enabled =
            {
                id:"enabled",
                operator:"in",
                value: filterFormVals.enabled.split(',').map(item => Number(item))
            };
    }

    if(this.Views.EditorTabs.getValue() == this.Id + "LastChangesList")
    {
        if(filterFormVals.resource_raw)
        {
            filter.resource_raw =
                {
                    id:"resource_raw",
                    operator:"like",
                    value:filterFormVals.resource_raw
                };
        }

        if(filterFormVals.resource_validated)
        {
            filter.resource_validated =
                {
                    id:"resource_validated",
                    operator:"like",
                    value:filterFormVals.resource_validated
                };
        }

        if(filterFormVals.type_id)
        {
            if (Array.isArray(filterFormVals.type_id))
                filterFormVals.type_id = filterFormVals.type_id.join(',');

            filter.type_id =
                {
                    id:"type_id",
                    operator:"in",
                    value: filterFormVals.type_id.split(',')
                };
        }
    }

    if(filterFormVals.update_user)
    {
        filter.update_user =
            {
                id:"update_user",
                operator:"like",
                value:filterFormVals.update_user
            };
    }

    if(filterFormVals.regulator)
    {
        filter.regulator =
            {
                id:"regulator",
                operator:"like",
                value:filterFormVals.regulator
            };
    }

    if(filterFormVals.category)
    {
        filter.category =
            {
                id:"category",
                operator:"like",
                value:filterFormVals.category
            };
    }

    if(filterFormVals.full_text_search)
    {
        filter.full_text_search =
            {
                id:"full_text_search",
                operator:"like",
                value:filterFormVals.full_text_search
            };
    }

    if(filterFormVals.description_full_text_search)
    {
        filter.description_full_text_search =
            {
                id:"description_full_text_search",
                operator:"like",
                value:filterFormVals.description_full_text_search
            };
    }

    if(filterFormVals.sub_id)
    {
        filter.sub_id =
            {
                id:"sub_id",
                operator:"in",
                value:filterFormVals.sub_id.split(',')
            };
    }

    if(filterFormVals.isp_id)
    {
        filter.isp_id =
            {
                id:"isp_id",
                operator:"in",
                value:filterFormVals.isp_id.split(',')
            };
    }

    if(filterFormVals.imported)
    {
        filter.imported = {
            id:"imported",
            operator: "in",
            value: filterFormVals.imported.split(',')
        };
    }

    if(this.Views.EditorTabs.getValue() == this.Id + "RulesList")
    {
        this.Views.ReportsWidgets.WebRulesReport.RefreshData(0,{filter:filter});
    }
    else{
        this.Views.ReportsWidgets.RulesReport.RefreshData(0,{filter:filter});
    }

    this.SetAllPathParam(filter);
};

UlrWebIpFilterRulesViewController.prototype.ClearFiltersForm = function ()
{
    const _this = this;

    const filters = _this.Views.FiltersForm.elements;

    _this.Views.Widgets.DateRangePicker.SetValue(null, true, "empty");

    for (const filter in filters) {
        filters[filter].setValue("");
    }
};

UlrWebIpFilterRulesViewController.prototype.DisableEnableBtn = function (Action)
{
    const _this = this;

    _this.Views.FilterApplyBtn[Action]();
    _this.Views.FilterClearBtn[Action]();
}

UlrWebIpFilterRulesViewController.prototype.SetAllPathParam = function(filter)
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    if(filter)
    {
        if (filter.period)
            delete filter.period

        this.SetPathParam("filter", JSON.stringify(filter));
    }
};

UlrWebIpFilterRulesViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

UlrWebIpFilterRulesViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrWebIpFilterRulesViewController.prototype.GetAllPathParam = function()
{
    try
    {
        const period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        let filters = this.GetPathParam("filter");
        if(filters)
        {
            filters = JSON.parse(filters);
        }
        else{
            filters = {};
        }
        let excludedFilters = false;

        if (filters.rule_type_mode)
        {
            this.Views.FiltersForm.elements["rule_type"].setValue(filters["rule_type_mode"].value);
            excludedFilters = true;
        }

        if (filters.rule_id)
            this.Views.FiltersForm.elements["rule_id"].setValue(filters["rule_id"].value);

        if (filters.enabled)
            this.Views.FiltersForm.elements["enabled"].setValue(filters["enabled"].value);

        if (filters.resource_raw)
            this.Views.FiltersForm.elements["resource_raw"].setValue(filters["resource_raw"].value);

        if (filters.resource_validated)
            this.Views.FiltersForm.elements["resource_validated"].setValue(filters["resource_validated"].value);

        if (filters.type_id)
            this.Views.FiltersForm.elements["type_id"].setValue(filters["type_id"].value);

        if (filters.update_user)
            this.Views.FiltersForm.elements["update_user"].setValue(filters["update_user"].value);

        if (filters.regulator)
            this.Views.FiltersForm.elements["regulator"].setValue(filters["regulator"].value);

        if (filters.category)
            this.Views.FiltersForm.elements["category"].setValue(filters["category"].value);

        if (filters.description_full_text_search)
            this.Views.FiltersForm.elements["description_full_text_search"].setValue(filters["description_full_text_search"].value);

        if (filters.full_text_search){
            this.Views.FiltersForm.elements["full_text_search"].setValue(filters["full_text_search"].value);
            excludedFilters = true;
        }

        if(filters.imported)
        {
            this.Views.FiltersForm.elements["imported"].setValue(filters.imported.value.join(","));
        }

        var sub_id = this.GetPathParam("sub_id");
        if(sub_id)
        {
            this.Views.FiltersForm.elements["sub_id"].setValue(sub_id);
            filters.sub_id = {
                id: "isp_id",
                operator: "in",
                value: parseInt(sub_id)
            };
        }

        var isp_id = this.GetPathParam("isp_id");
        if(isp_id)
        {
            this.Views.FiltersForm.elements["isp_id"].setValue(isp_id);
            filters.isp_id = {
                id: "isp_id",
                operator: "in",
                value: parseInt(isp_id)
            };
        }

        if(Object.keys(filters).length && !excludedFilters)
            this.ShowHideAdditionalFilters(true);
    }
    catch(e){
        console.log('exception', e)
    }
};

UlrWebIpFilterRulesViewController.prototype.ShowHideAdditionalFilters = function(hasFilters = null)
{
    const _this = this;

    const formContainer = _this.Views.AdditionalFiltersContainer;
    const toggleIcon = _this.Views.ToggleIcon;
    const child = toggleIcon.getNode().children[0].lastChild;

    const hideFilters = () => {
        formContainer.hide();
        child.classList.remove('fa-angle-up');
        child.classList.add('fa-angle-down');
    }

    const showFilters = () => {
        formContainer.show();
        child.classList.remove('fa-angle-down');
        child.classList.add('fa-angle-up');
    }

    if (hasFilters)
    {
        showFilters();
    }
    else
    {
        if (formContainer.isVisible()) {
            hideFilters();
        } else {
            showFilters();
        }
    }
}

UlrWebIpFilterRulesViewController.prototype.GetLastOpenedTab = function()
{
    var val = localStorage.getItem('WebIpFilterSelectedTab');

    return val ? val : (this.Id + "RulesList");
}

UlrWebIpFilterRulesViewController.prototype.SetLastOpenedTab = function(Val)
{
    localStorage.setItem('WebIpFilterSelectedTab', Val);
}

UlrWebIpFilterRulesViewController.prototype.SetTemplateForOpenedTab = function (TabId)
{
    var _this = this;

    if (TabId == (_this.Id + "RulesList"))
    {
        _this.Views.ToolsBtn.show();
        _this.Views.ResourceFilterSection.hide();

        _this.Views.FilterApplyBtn.define("label", LangHelper.GetString("UlrModule","Search rules"));
        _this.Views.FilterApplyBtn.refresh();
    }
    else
    {
        _this.Views.ToolsBtn.hide();
        _this.Views.ResourceFilterSection.show();

        _this.Views.FilterApplyBtn.define("label", LangHelper.GetString("UlrModule","Search resources"));
        _this.Views.FilterApplyBtn.refresh();
    }
};

UlrWebIpFilterRulesViewController.prototype.ToolsBtnOnClick = function(Node)
{
    var _this = this, menu = this.Views.ToolsSubmenu;

    menu.show(Node);
};

UlrWebIpFilterRulesViewController.prototype.EnableDisableWebRules = function(State, isSubmenu = true)
{
    const _this = this;
    const table = _this.Views.ReportsWidgets.WebRulesReport.Views.Table;
    const items = table.getSelectedItem(true);

    if (!items.length)
    {
        UlrShowMessage(
            "info",
            LangHelper.GetString("UlrModule","Rules not selected")
        );
        return;
    }

    const originalItems = items.map(item => ({ ...item }));
    let rules = [];

    let categories = App.DicsManager.GetDic(DicsEnum.UlrCategoriesDic);
    let regulators = App.DicsManager.GetDic(DicsEnum.UlrRegulatorsDic);

    items.forEach(item => {
        rules.push({
            _id: item.rule_id,
            type_id: item.rule_type_id,
            regulator_id: Object.values(regulators).find(cat => cat.value === item.regulator).id,
            category_id: Object.values(categories).find(cat => cat.value === item.category).id,
            enabled: State,
            mode_id: item.rule_mode_id,
            subs_mode_id: item.rule_subs_mode_id,
            name: item.rule_name,
            description_public: item.description_public,
            description_private: item.description_private
        })
    });

    items.forEach(item => {
        table.updateItem(item.id, { ...item, enabled: State });
    });

    this.ViewModel.EnableDisableRules(webix.extend({rules}, {callback:function (R)
        {
            if (R.success)
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("QoE", "Success"),
                    LangHelper.GetString("UlrModule", State == 1 ? "Enabling rules successfully" : "Disabling rules successfully")
                );
            }
            else
            {
                originalItems.forEach(originalItem => {
                    table.updateItem(originalItem.id, originalItem);
                });

                UlrShowMessage(
                    "error",
                    LangHelper.GetString("UlrModule", "Error"),
                    LangHelper.GetString("UlrModule",State == 1 ? "Error enabling rules" : "Error disabling rules")
                );
            }
        }}));
};

// UlrWebIpFilterRulesViewController.prototype.ShowServerError = function(ErrModel)
// {
//     if(ErrModel)
//         UlrShowAlertWindow({
//             head:LangHelper.GetString("UlrModule","Error"),
//             type:"spectre-alert-error",
//             mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
//             message:LangHelper.GetString("UlrModule",ErrModel.msg),
//             actions:[
//                 {
//                     label:LangHelper.GetString("UlrModule","Ok"),
//                     click:function ()
//                     {
//
//                     }
//                 }
//             ]
//         });
// };

// UlrWebIpFilterRulesViewController.prototype.RulesReportOnCheck = function(Row, Column, State)
// {
//     var table = this.Views.ReportsWidgets.RulesReport.Views.Table;
//
//     var data = table.getItem(Row);
//
//     this.ViewModel.EnableDisableWebRule(webix.extend(data, {callback:function (R)
//         {
//             if(!R.success)
//             {
//                 data.enabled = State ? 0 : 1;
//
//                 table.updateItem(data.id, data);
//             }
//         }}), State);
// };
//
// UlrWebIpFilterRulesViewController.prototype.RuleEnableStateUpdated = function(RuleModel)
// {
//     var table = this.Views.ReportsWidgets.RulesReport.Views.Table;
//
//     var data = table.find(function(obj)
//     {
//         return obj._id == RuleModel._id;
//     });
//
//     if(data && data.length == 1 && data[0].id)
//     {
//         data = data[0];
//         data.enabled = parseInt(RuleModel.enabled);
//         table.updateItem(data.id, data);
//     }
//
// };
//
// UlrWebIpFilterRulesViewController.prototype.RulesReportOnSuccessDelete = function(RuleModel)
// {
//     var table = this.Views.ReportsWidgets.RulesReport.Views.Table;
//
//     var data = table.find(function(obj){
//         return obj._id == RuleModel._id;
//     });
//
//     if(data && data.length == 1 && data[0].id)
//         table.remove(data[0].id);
// };
function UlrEditWebIpFilterRuleViewController(Params)
{
    var _this = this;

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.Action = Params&&Params.action&&this.ActionsEnum[Params.action]?this.ActionsEnum[Params.action]:this.ActionsEnum.Edit;

    this.RuleType = Params&&Params.rule_type&&UlrRulesTypesCodesEnum[Params.rule_type]?UlrRulesTypesCodesEnum[Params.rule_type]:UlrRulesTypesCodesEnum.web_ip_lock;

    this.RuleTypeId = UlrRulesTypesCodesTypeIdMap[this.RuleType];

    this.Id = "UlrEditWebIpFilterRule";

    this.ViewModel = new UlrWebIpFilterRulesManager();
    this.ReportsModel = new UniReportsManager();
    this.CheckDomainManager = new UlrCheckDomainManager();

    this.IspsList = new UlrIspSubscribersListViews({id: this.Id + "IspsList", IspType: IspsSubscribersListTypes.isp, ViewModel: this.ReportsModel});
    this.SubsList = new UlrIspSubscribersListViews({id: this.Id + "SubsList", IspType: IspsSubscribersListTypes.subscriber, ViewModel: this.ReportsModel});

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule",this.RuleType == UlrRulesTypesCodesEnum.web_ip_white ? "Whitelist" : "Web filter"),
        Title:LangHelper.GetString("UlrModule","Edit rule")
    };

    this.AddResourceUnsaved = false;

    this.Views = {
        ScrollView:null,
        PageTitle:null,
        RuleEditForm:null,
        RuleEditFormEnabledStateView:null,
        RuleEditFormEnabledSpacerView:null,
        AddResourceForm:null,
        AddResourceInput:null,
        AddResourceSelect:null,
        AddResourceTypesInput:null,
        AddResourceBtn:null,
        ClearAllResources:null,
        FileImportBtn:null,
        RuleModeToggle:null,
        RuleModeToggleDescription:null,
        ISPListForm:null,
        ISPListFormFirstCol:null,
        ISPListFormSecondCol:null,
        ISPListFormThirdCol:null,
        SaveBtn:null,
        SaveEnableBtn:null,
        SaveDisableBtn:null,
        ExportRuleBtn:null,
        DeleteBtn:null,
        ValidateResourceSection: null,
        ValidateResourceBtn:null,
        ValidationResultLabel:null,
        EchEnabledModeSelect: null,
        RedirectIPv4Input: null,
        RedirectIPv6Input: null,
        EchEnabledHelpBtn: null,

        QoEImportInput: null,

        ImportPopupForm:null,
        ImportPopupTable:null,
        // ImportPopupUploader:null,
        ImportPopupEditor:null,
        ImportPopupBtn:null,

        ExportRulePopupForm:null,
        ExportRulePopupType:null,
        ExportRulePopupHeaderTable:null,
        ExportRulePopupResTable:null,
        ExportRulePopupBtn:null,

        AddedResourcesReportSection: null,
        ResourceListReportSection: null,

        ImportFilesPopupUploader: null,
        FromFileImportBtn: null,
        AddResourceSection: null,
        ChannelsAndSubscribersSection: null,
        HardBlockingRuleModeToggle: null,

        ImportFilesSubmenu: null,

        Widgets:{
        },
        ReportsWidgets:{
            ResourcesReport: UrlWebRulesResourcesTableWidget({
                id:this.Id + "ResourcesReport",
                // enableTextSearch:1,
                enableAutoHeight:1,
                defaultPageSize: 10,
                hidePaginatorToolbar:0,
                enableLocalSort:0,
                fastresource_editable: true,
                columns_filter: true,
                method: "UlrGetResourceRulesViewList",
                onItemClick:function (Id) {
                    _this.ResourcesReportOnItemClick(Id.row, Id.column);
                }
            }),
            AddedResourcesReport: UrlWebRulesResourcesTableWidget({
                id:this.Id + "AddedResourcesReport",
                enableTextSearch:0,
                enableAutoHeight:1,
                // hidePaginatorToolbar:1,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource: 1,
                fastresource_editable: true,
                dataSource: function(FilterParams)
                {
                    var res = {
                        count: _this.AddedResources.length,
                        page: FilterParams.Params.page,
                        size: _this.Views.ReportsWidgets.AddedResourcesReport.Views.Paging.config.size,
                        rows: []
                    };

                    var sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : 'resource_raw';
                    var sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : 'asc';

                    var sort_val = sort_dir == 'asc' ? 1 : -1;


                    _this.AddedResources.sort((a, b) => {
                        var val_a = a[sort_prop];
                        var val_b = b[sort_prop];

                        if(typeof val_a == 'string' || typeof val_b == 'string')
                        {
                            if(sort_val > 0)
                            {
                                return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                            }
                            else
                            {
                                return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                            }
                        }
                        else if(typeof val_a == 'number' || typeof val_b == 'number')
                        {
                            return sort_val * val_a + (-1) * sort_val * val_b;
                        }

                        return -1;
                    });

                    const start_index = res.page * res.size;
                    var finish_index = start_index + res.size;

                    if(finish_index > (_this.AddedResources.length - 1))
                    {
                        res.rows = _this.AddedResources.slice(start_index);
                    }
                    else
                    {
                        res.rows = _this.AddedResources.slice(start_index, finish_index);
                    }

                    return res;
                },
                onItemClick:function (Id) {
                    _this.AddedResourcesReportOnItemClick(Id);
                }
            }),
            ImportedFilesReport: UrlImportedFilesTableWidget({
                id:this.Id + "ImportedFilesReport",
                enableTextSearch:0,
                // enableAutoHeight:1,
                // hidePaginatorToolbar:1,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource: 1,
                dataSource: function(FilterParams)
                {
                    var res = {
                        count: _this.ImportFilesArr.length,
                        page: FilterParams.Params.page,
                        size: _this.Views.ReportsWidgets.ImportedFilesReport.Views.Paging.config.size,
                        rows: []
                    };

                    var sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : 'name';
                    var sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : 'asc';

                    var sort_val = sort_dir == 'asc' ? 1 : -1;


                    _this.ImportFilesArr.sort((a, b) => {
                        var val_a = a[sort_prop];
                        var val_b = b[sort_prop];

                        if(typeof val_a == 'string' || typeof val_b == 'string')
                        {
                            if(sort_val > 0)
                            {
                                return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                            }
                            else
                            {
                                return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                            }
                        }
                        else if(typeof val_a == 'number' || typeof val_b == 'number')
                        {
                            return sort_val * val_a + (-1) * sort_val * val_b;
                        }

                        return -1;
                    });

                    const start_index = res.page * res.size;
                    var finish_index = start_index + res.size;

                    if(finish_index > (_this.ImportFilesArr.length - 1))
                    {
                        res.rows = _this.ImportFilesArr.slice(start_index);
                    }
                    else
                    {
                        res.rows = _this.ImportFilesArr.slice(start_index, finish_index);
                    }

                    return res;
                },
                onItemClick:function (Id) {
                    _this.ImportFilesClick(Id);
                }
            }),

            ActionsLog: UrlActionsLogTableWidget({
                id:this.Id + "ActionsLog",
                enableTextSearch:0,
                enableAutoHeight:1,
                filter:{
                    rule_id:{
                        id:"rule_id",
                        operator:"=",
                        value:0
                    }
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({
                                id:this.Id + "PageTitle",
                                root_title:this.PageTitle.Title
                            }),
                            {
                                type: "clean",
                                rows:function () {
                                   var arr = [
                                       {height:20},
                                       {
                                           view:"template",
                                           borderless:false,
                                           border:2,
                                           css:"form_text_warning_label",
                                           height:40,
                                           //autoheight:true,
                                           template:"<span class='warning'>"+LangHelper.GetString("UlrModule","Warning")+"</span>" + ": " + LangHelper.GetString("UlrModule","This lock all resources except the resources in list below!")
                                       }
                                   ];

                                   return _this.RuleType == UlrRulesTypesCodesEnum.web_ip_white ? arr : [];
                                }()
                            },
                            {height:32},
                            {
                                view:"form",
                                id:this.Id + "RuleEditForm",
                                type: "wide",
                                borderless:true,
                                elements:[
                                    {
                                        cols:[
                                            {
                                                view:"spectre_captionlabel",
                                                name:"_id",
                                                caption:LangHelper.GetString("UlrModule","Rule id")
                                            },
                                            {
                                                id:this.Id + "RuleEditFormEnabledSpacerView",
                                                css:"form_info_label_spacer",
                                                borderless:true,
                                                width:20,
                                                template:"",
                                                hidden:true
                                            },
                                            {
                                                view:"spectre_captionlabel",
                                                id:this.Id + "RuleEditFormEnabledStateView",
                                                name:"enabled",
                                                caption:LangHelper.GetString("UlrModule","Rule state"),
                                                template:function (Obj)
                                                {
                                                    return "<span class='caption'>"+Obj.caption+":</span> <span class='value'>"+(parseInt(Obj.value) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled"))+"</span>";
                                                },
                                                hidden:true
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                view:"spectre_richselect",
                                                name:"regulator_id",
                                                label:LangHelper.GetString("UlrModule","Regulator"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                },
                                                required:true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                            this.validate();
                                                    }
                                                }
                                            },
                                            {
                                                view:"spectre_richselect",
                                                name:"category_id",
                                                label:LangHelper.GetString("UlrModule","Category"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                },
                                                required:true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov) {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                            this.validate();
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                rows:[
                                                    {
                                                        view:"spectre_textarea",
                                                        name:"description_public",
                                                        label:LangHelper.GetString("UlrModule","Reason"),
                                                        required:true,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(typeof Ov !== "undefined" && Ov !== "")
                                                                {
                                                                    if(Nv != Nv.trim())
                                                                    {
                                                                        this.setValue(Nv.trim());
                                                                        return;
                                                                    }
                                                                    this.validate();
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"label",
                                                        css:"form_text_description_label",
                                                        label:LangHelper.GetString("UlrModule","This description will be shown if you have public blacklist database")
                                                    }
                                                ]
                                            },
                                            {
                                                rows:[
                                                    {
                                                        view:"spectre_textarea",
                                                        name:"description_private",
                                                        label:LangHelper.GetString("UlrModule","Description"),
                                                        required:true,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(typeof Ov !== "undefined" && Ov !== "")
                                                                {
                                                                    if(Nv != Nv.trim())
                                                                    {
                                                                        this.setValue(Nv.trim());
                                                                        return;
                                                                    }
                                                                    this.validate();
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"label",
                                                        css:"form_text_description_label",
                                                        label:LangHelper.GetString("UlrModule","This is internal description helps you to find this rule to edit  or change state")
                                                    }
                                                ]
                                            }

                                        ]
                                    },
                                    {
                                        type: "wide",
                                        hidden: AppEnv.WebRuleHardBlockingToggle_isHidden === 1,
                                        cols:[
                                            {
                                                view:"spectre_toggle",
                                                id:this.Id + "HardBlockingRuleModeToggle",
                                                height:22,
                                                width:22,
                                                name:"hard_blocking",
                                                on:{
                                                    onChange:function(Nv, Ov)
                                                    {
                                                        _this.Views.RuleEditForm.setValues({hard_blocking: Nv}, true);
                                                    }
                                                }
                                            },
                                            {
                                                width:webix.html.getTextSize(LangHelper.GetString("UlrModule","Enable IP addresses hard blocking").replace(" ", "_"), "app_block__header_webix_template").width + 32,
                                                rows:[
                                                    {
                                                        cols:[
                                                            BlockHeaderTemplate({
                                                                title:LangHelper.GetString("UlrModule","Enable IP addresses hard blocking"), icon:"",
                                                                borderless:true
                                                            }),
                                                            {
                                                                view: "spectre_button",
                                                                id:_this.Id + "HarBlockingIPsHelpBtn",
                                                                type: "icon",
                                                                icon: "question-circle",
                                                                css:"toolbar_round_btn custom-form-btn",
                                                                width:32,
                                                                height:25,
                                                                tooltip:LangHelper.GetString("UlrModule", "Help"),
                                                                click:function (id)
                                                                {
                                                                    UlrShowHardBlockingIPsInWebFilterHelpPopup();
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {}
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        hidden: _this.RuleType != UlrRulesTypesCodesEnum.web_ip_lock,
                                        type:"wide",
                                        cols:[
                                            {
                                                view:"spectre_richselect",
                                                id:this.Id + "EchEnabledModeSelect",
                                                label: LangHelper.GetString("UlrModule","Block resources as ECH"),
                                                // height:22,
                                                width:240,
                                                name:"ech_enabled",
                                                on:{
                                                    onChange:function(Nv, Ov)
                                                    {
                                                        _this.Views.RuleEditForm.setValues({ech_enabled: Nv}, true);
                                                    }
                                                },
                                                options: {
                                                    point:false,
                                                    data:[
                                                        {id: "0", value: LangHelper.GetString("UlrModule","Disabled")},
                                                        {id: "1", value: LangHelper.GetString("UlrModule","Drop")},
                                                        {id: "2", value: LangHelper.GetString("UlrModule","Redirect")}
                                                    ]
                                                }
                                            },
                                            {
                                                view:"spectre_text",
                                                id:_this.Id + "RedirectIPv4Input",
                                                name:"ech_redirect_ipv4",
                                                hidden: true,
                                                label:LangHelper.GetString("UlrModule","IPv4 for DNS redirect (A)"),
                                                width: 240,
                                                validate: function(V)
                                                {
                                                    // debugger;
                                                    if(!V)
                                                        return true;
                                                    var mode = parseInt(_this.Views.EchEnabledModeSelect.getValue());
                                                    if(mode === 2)
                                                    {
                                                        return Helper.ValidateIPv4(V);
                                                    }

                                                    return true;
                                                },
                                                invalidMessage: LangHelper.GetString("UlrModule","Enter correct value"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        // debugger;
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                        {
                                                            if(Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                view:"spectre_text",
                                                id:_this.Id + "RedirectIPv6Input",
                                                name:"ech_redirect_ipv6",
                                                hidden: true,
                                                label:LangHelper.GetString("UlrModule","IPv6 for DNS redirect (AAAA)"),
                                                width: 240,
                                                validate: function(V)
                                                {
                                                    // debugger;
                                                    if(!V)
                                                        return true;
                                                    var mode = parseInt(_this.Views.EchEnabledModeSelect.getValue());
                                                    if(mode === 2)
                                                    {
                                                        return Helper.ValidateIPv6(V);
                                                    }

                                                    return true;
                                                },
                                                invalidMessage: LangHelper.GetString("UlrModule","Enter correct value"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                        {
                                                            if(Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                view: "spectre_button",
                                                id:_this.Id + "EchEnabledHelpBtn",
                                                type: "icon",
                                                icon: "question-circle",
                                                css:"toolbar_round_btn custom-form-btn",
                                                width:32,
                                                height:25,
                                                tooltip:LangHelper.GetString("UlrModule", "Help"),
                                                click:function (id)
                                                {
                                                    UlrShowEchEnabledWebFilterHelpPopup();
                                                }
                                            },
                                            {}
                                        ]
                                    }
                                ]
                            },
                            {
                                type:"wide",
                                id: this.Id + "AddResourceSection",
                                borderless: true,
                                rows:[
                                    {
                                        height:48
                                    },
                                    {
                                        cols: [
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","Resource"), icon:"",
                                                borderless:true,
                                                css: "custom__app-block-header-with-icon"
                                            }),
                                            {
                                                view: "spectre_button",
                                                id:_this.Id + "ImportWebRulesHelpBtn",
                                                type: "icon",
                                                icon: "question-circle",
                                                css:"toolbar_round_btn custom-form-btn",
                                                width:32,
                                                height:25,
                                                tooltip:LangHelper.GetString("UlrModule", "Help"),
                                                click:function (id)
                                                {
                                                    UlrShowImportWebRulesHelpPopup();
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        view:"form",
                                        id:this.Id + "AddResourceForm",
                                        type: "wide",
                                        elements:[
                                            {
                                                type:"clean",
                                                rows:[
                                                    {
                                                        view:"label",
                                                        css:"form_text_label",
                                                        label:LangHelper.GetString("UlrModule","Select type of resource and put the URL, SNI, CN, IP, IP:PORT or CIDR to this field.")
                                                    },
                                                    {
                                                        type: "wide",
                                                        cols:[
                                                            {
                                                                view: "resource-import-qoe-input",
                                                                name: "fastresource_config",
                                                                id: this.Id + "QoEImportInput",
                                                                hidden: true,
                                                                label: null,
                                                                labelWidth: 0,
                                                                type: "ulr"
                                                            },
                                                            {
                                                                view:"spectre_text",
                                                                id:this.Id + "AddResourceInput",
                                                                name:"resource_raw",
                                                                label:LangHelper.GetString("UlrModule","Resource"),
                                                                keyPressTimeout:300,
                                                                on:{
                                                                    onEnter:function(ev)
                                                                    {
                                                                        setTimeout(function ()
                                                                        {
                                                                            _this.ValidateResource();
                                                                        },1);
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view:"spectre_richselect",
                                                                id:this.Id + "AddResourceSelect",
                                                                name:"resource_raw",
                                                                label:LangHelper.GetString("UlrModule","Resource"),
                                                                options: {
                                                                    body: {
                                                                        scheme: {
                                                                            $sort: {
                                                                                by: "value",
                                                                                dir: "asc",
                                                                                as: "string"
                                                                            }
                                                                        },
                                                                        point:false,
                                                                        data: []
                                                                    }
                                                                },
                                                                disabled: true,
                                                                hidden: true,
                                                                keyPressTimeout:300,
                                                                on:{
                                                                    onEnter:function(ev)
                                                                    {
                                                                        setTimeout(function ()
                                                                        {
                                                                            _this.ValidateResource();
                                                                        },1);
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                type: "wide",
                                                                cols:[
                                                                    {
                                                                        view:"spectre_richselect",
                                                                        id:this.Id + "AddResourceTypesInput",
                                                                        name:"type_id",
                                                                        label:LangHelper.GetString("UlrModule","Type"),
                                                                        value:"sni",
                                                                        options:{
                                                                            point:false,
                                                                            data:[]
                                                                        }
                                                                    },
                                                                    {
                                                                        id: this.Id + "ValidateResourceSection",
                                                                        rows:[
                                                                            {},
                                                                            {
                                                                                view:"spectre_button",
                                                                                id:this.Id + "ValidateResourceBtn",
                                                                                css:"form_button form_element main_action",
                                                                                label:LangHelper.GetString("UlrModule","Validate"),
                                                                                height:51,
                                                                                click:function ()
                                                                                {
                                                                                    //webix.message(LangHelper.GetString("UlrModule","Coming soon..."));
                                                                                    //_this.ShowHideValidationResult(true);
                                                                                    _this.ValidateResource();
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        height:20
                                                    },
                                                    {
                                                        type:"wide",
                                                        rows:[
                                                            {
                                                                view:"label",
                                                                id:this.Id + "ValidationResultLabel",
                                                                css:"slide_down_box form_state",
                                                                caption:LangHelper.GetString("UlrModule","Validation result"),
                                                                icon:"check",
                                                                value:"",
                                                                template:"<div class='row'><div class='caption'><span class='webix_icon form_state_icon fa-#icon#'></span>#caption#: </div><div class='value'>#value#</div></div>",
                                                                height:70
                                                                // ,
                                                                // hidden:true
                                                            },
                                                            {
                                                                type:"wide",
                                                                cols:[
                                                                    {
                                                                        view:"spectre_button",
                                                                        id:this.Id + "AddResourceBtn",
                                                                        type:"icon",
                                                                        css:"form_button spec_action with_icon",
                                                                        label:LangHelper.GetString("UlrModule","Add to list"),
                                                                        icon:"plus-circle",
                                                                        //height:44,
                                                                        autowidth:true,
                                                                        disabled:true,
                                                                        click:function ()
                                                                        {
                                                                            setTimeout(function ()
                                                                            {
                                                                                _this.AddResource();
                                                                            },1);
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"spectre_button",
                                                                        id:this.Id + "FileImportBtn",
                                                                        type:"icon",
                                                                        css:"form_button spec_action with_icon",
                                                                        label:LangHelper.GetString("UlrModule","Import resources"),
                                                                        icon:"arrow-left",
                                                                        //height:44,
                                                                        autowidth:true,
                                                                        click:function ()
                                                                        {
                                                                            _this.ShowImportForm();
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"spectre_button",
                                                                        id:this.Id + "FromFileImportBtn",
                                                                        type:"icon",
                                                                        css:"form_button spec_action with_icon ulr_with_badge",
                                                                        label:LangHelper.GetString("UlrModule","Import from file"),
                                                                        icon:"file",
                                                                        //height:44,
                                                                        badge: 0,
                                                                        autowidth:true,
                                                                        click:function ()
                                                                        {
                                                                            _this.ImportFilesPopup.show();
                                                                            _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                                                                            // _this.ShowImportForm();
                                                                        }
                                                                    },
                                                                    {}
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                height:48
                            },
                            {
                                id: this.Id + "AddedResourcesReportSection",
                                hidden: true,
                                rows: [
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Just added resources"), icon:"",
                                        borderless:true
                                    }),
                                    this.Views.ReportsWidgets.AddedResourcesReport.ViewConfig,
                                    {
                                        height: 48
                                    }
                                ]
                            },
                            {
                                id: this.Id + "ResourceListReportSection",
                                hidden: true,
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","List of resources"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        height:20
                                    },
                                    this.Views.ReportsWidgets.ResourcesReport.ViewConfig,
                                    {
                                        height:20
                                    },
                                    {
                                        cols:[
                                            {
                                                view:"spectre_button",
                                                id:this.Id+"ClearAllResources",
                                                css:"form_button spec_action",
                                                label:LangHelper.GetString("UlrModule","Clear all"),
                                                autowidth:true,
                                                click:function ()
                                                {
                                                    _this.ClearResources();
                                                }
                                            },
                                            {}
                                        ]
                                    },
                                    {
                                        height:48
                                    }
                                ]
                            },
                            {
                                id: this.Id + "ChannelsAndSubscribersSection",
                                rows:[
                                    ...this.IspsList.ViewConfig,
                                    {height: 48},
                                    ...this.SubsList.ViewConfig,

                                    {
                                        height:48
                                    }
                                ]
                            },

                            {
                                type:"wide",
                                //height:536,
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Actions log"), icon:"",
                                        borderless:true
                                    }),
                                    this.Views.ReportsWidgets.ActionsLog.ViewConfig
                                ]
                            },
                            {
                                height:32
                            },
                            {
                                type:"wide",
                                cols:[
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveBtn",
                                        css:"form_button main_action",
                                        label:LangHelper.GetString("UlrModule","Save changes"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save();
                                        }
                                    },
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveEnableBtn",
                                        css:"form_button second_action",
                                        label:LangHelper.GetString("UlrModule","Save and enable"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save(true);
                                        },
                                        hidden:true
                                    },
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveDisableBtn",
                                        css:"form_button second_action",
                                        label:LangHelper.GetString("UlrModule","Save and disable"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save(false);
                                        },
                                        hidden:true
                                    },
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "ExportRuleBtn",
                                        css:"form_button third_action",
                                        label:LangHelper.GetString("UlrModule","Export rule"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.ShowRuleExportForm();
                                        },
                                        hidden:true
                                    },
                                    {},
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "DeleteBtn",
                                        css:"form_button delete_action",
                                        label:LangHelper.GetString("UlrModule","Delete rule"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Delete();
                                        },
                                        hidden:true
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.ExportRulePopup = null;

    this.ImportPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ImportPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Import resources"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        _this.ImportPopup.hide();
                    }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ImportPopupForm",
                            type: "wide",
                            minWidth:560,
                            minHeight:400,
                            elements: [
                                {
                                    view:"datatable",
                                    id: this.Id + "ImportPopupTable",
                                    header:false,
                                    hidden:true,
                                    columns:[
                                        {
                                            id:"type_id"
                                        },
                                        {
                                            id:"resource_raw"
                                        },
                                        {
                                            id:"resource_validated"
                                        }
                                    ]
                                },
                                // {
                                //     view: "uploader",
                                //     value: LangHelper.GetString("UlrModule","Click to upload or drag a file here"),
                                //     id: this.Id+"ImportPopupUploader",
                                //     css:"upload_area form_button spec_action",
                                //     autosend:false,
                                //     height:64
                                // },
                                {
                                    view:"spectre_textarea",
                                    id:this.Id + "ImportPopupEditor",
                                    label:LangHelper.GetString("UlrModule","File or clipboard content to import"),
                                    height:undefined,
                                    value:""
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ImportPopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Import"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ImportFile();
                                            _this.ImportPopup.hide();
                                        },1);

                                    }
                                },
                                // {
                                //     view:"spectre_button",
                                //     id:this.Id + "ImportPopupPasteBtn",
                                //     css:"form_button spec_action",
                                //     label:LangHelper.GetString("UlrModule","Paste from clipboard"),
                                //     autowidth:true,
                                //     click:function ()
                                //     {
                                //         var pasteText  = _this.Views.ImportPopupEditor.getInputNode();
                                //         pasteText.focus();
                                //         document.execCommand("insertText");
                                //         var value = pasteText.value;
                                //
                                //         _this.Views.ImportPopupEditor.setValue(value);
                                //     }
                                // },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ExportRulePopup = null;

    this.ExportRulePopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ExportRulePopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Export rule"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.ExportRulePopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ExportRulePopupForm",
                            type: "wide",
                            //minWidth:560,
                            //minHeight:400,
                            elements: [
                                {
                                    view:"datatable",
                                    id: this.Id + "ExportRulePopupResTable",
                                    header:false,
                                    hidden:true,
                                    columns: function ()
                                    {
                                        var cols = [];

                                        cols.push.apply(cols,[
                                            {
                                                id: "enabled",
                                                header:"",
                                                sort: false,
                                                template:function (Obj) {
                                                    return Obj.enabled ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");
                                                }
                                            },
                                            {
                                                id: "create_time",
                                                header: [LangHelper.GetString("UlrModule","Date")],
                                                sort: "string",
                                                template:function(Obj)
                                                {
                                                    if(Obj.create_time)
                                                    {
                                                        var update = new Date(Obj.create_time);
                                                        var offset = update.getTimezoneOffset();
                                                        if(offset != 0)
                                                        {
                                                            var n_date = new Date(update.getTime() - offset*60*1000);

                                                            return CellSpectreDateTemplate(n_date);
                                                        }
                                                    }
                                                    return CellSpectreDateTemplate(Obj.create_time);
                                                }
                                            },
                                            {
                                                id: "type_id",
                                                header: [LangHelper.GetString("UlrModule","Type")],
                                                sort: "text",
                                                template:function (Obj)
                                                {
                                                    var dic = App.DicsManager.GetDic(DicsEnum.UlrResourceTypesDic);

                                                    return dic[Obj.type_id] ? dic[Obj.type_id].value : Obj.type_id;
                                                }
                                            },
                                            {
                                                id: "resource_raw",
                                                header: [LangHelper.GetString("UlrModule","Resource raw")],
                                                sort: "string"
                                            },
                                            {
                                                id: "resource_validated",
                                                header: [LangHelper.GetString("UlrModule","Resource validated")],
                                                sort: "string"
                                            },
                                            {
                                                id: "status",
                                                header: [LangHelper.GetString("UlrModule","Status")],
                                                sort: "text",
                                                template:function (Obj)
                                                {
                                                    var error = parseInt(Obj.state_error);
                                                    var valid = parseInt(Obj.state_valid);

                                                    if(error)
                                                        return '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Error") + '</span>';

                                                    if(valid == UlrStateValidEnum.valid)
                                                        return LangHelper.GetString("UlrModule","Valid");

                                                    if(valid == UlrStateValidEnum.invalid)
                                                        return '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Invalid") + '</span>';

                                                    if(valid == UlrStateValidEnum.undefined)
                                                        return LangHelper.GetString("UlrModule","No validation");

                                                    return "";
                                                }
                                            }
                                        ]);
                                        return cols;
                                    }()
                                },
                                {
                                    cols:[
                                        {
                                            view:"spectre_richselect",
                                            id: this.Id + "ExportRulePopupType",
                                            label:LangHelper.GetString("UlrModule","Export format"),
                                            value:"toPDF",
                                            options:{
                                                point:false,
                                                data:[
                                                    {id: "toPDF", value: LangHelper.GetString("UlrModule","Export to PDF")},
                                                    {id: "toExcel", value: LangHelper.GetString("UlrModule","Export to Excel")},
                                                    {id: "toCSV", value: LangHelper.GetString("UlrModule","Export to CSV")}
                                                ]
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ExportRulePopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Export"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ExportRule();
                                            _this.ExportRulePopup.hide();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };


    this.ImportFilesPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ImportPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Import resources"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        _this.ImportFilesPopup.hide();
                    }
                }
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ImportFilesPopupForm",
                            type: "wide",
                            minWidth:720,
                            minHeight:400,
                            elements: [
                                {
                                    view: "uploader",
                                    value: LangHelper.GetString("UlrModule","Click to upload or drag a file here"),
                                    id: this.Id+"ImportFilesPopupUploader",
                                    css:"upload_area form_button spec_action",
                                    autosend:false,
                                    height:64
                                },
                                this.Views.ReportsWidgets.ImportedFilesReport.ViewConfig
                            ]
                        },

                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    // id:this.Id + "ImportPopupBtn",
                                    css:"form_button spec_action",
                                    label:LangHelper.GetString("UlrModule","Get template"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        const __this = this;
                                        const node = __this.getNode();
                                        _this.ImportFilesSubmenu.show(node, {pos: "top"})
                                    }
                                },
                                {},
                                {
                                    view:"spectre_button",
                                    // id:this.Id + "ImportPopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Close"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            // _this.ImportFile();
                                            _this.ImportFilesPopup.hide();
                                        },1);
                                    }
                                },
                                // {
                                //     view:"spectre_button",
                                //     id:this.Id + "ImportPopupPasteBtn",
                                //     css:"form_button spec_action",
                                //     label:LangHelper.GetString("UlrModule","Paste from clipboard"),
                                //     autowidth:true,
                                //     click:function ()
                                //     {
                                //         var pasteText  = _this.Views.ImportPopupEditor.getInputNode();
                                //         pasteText.focus();
                                //         document.execCommand("insertText");
                                //         var value = pasteText.value;
                                //
                                //         _this.Views.ImportPopupEditor.setValue(value);
                                //     }
                                // },
                                // {}
                            ]
                        }
                    ]
                }
            ]
        }
    };


    this.ImportFilesPopup = webix.ui(this.ImportFilesPopupConfig);

    this.ImportFilesSubmenuFormatFiles = function (SubmenuId, ListId)
    {
        const getTemplateFormatFile = function (id, value)
        {
            return {
                id: `${SubmenuId}${id}`,
                icon: "file",
                value: value
            };
        }

        return [
            getTemplateFormatFile(`${ListId}${ListId}Excel`, "Excel"),
            getTemplateFormatFile(`${ListId}${ListId}TabSeparated`, "TSV"),
            getTemplateFormatFile(`${ListId}${ListId}CSV`, "CSV"),
            getTemplateFormatFile(`${ListId}${ListId}TXT`, "TXT")
        ]
    }

    _this.ImportFilesSubmenuId = _this.Id + "ImportFilesSubmenu";
    this.ImportFilesSubmenu = webix.ui({
        view: "submenu",
        id: _this.ImportFilesSubmenuId,
        width: 200,
        autowidth: true,
        padding: 0,
        data: [
            {
                id: _this.Id + "SingleColumnList", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Single column list"),
                submenu:this.ImportFilesSubmenuFormatFiles(_this.ImportFilesSubmenuId, "SingleColumnList")
            },
            {
                id: _this.Id + "MultiColumnList", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Multi column list"),
                submenu:this.ImportFilesSubmenuFormatFiles(_this.ImportFilesSubmenuId, "MultiColumnList")
            }
        ],
        on: {
            onMenuItemClick: function (Id)
            {
                const getImportTemplateFile = function (ListFormat, Id)
                {
                    if (Id.includes("Excel"))
                    {
                        _this.GetImportTemplateFile(ListFormat, "xlsx");
                    }
                    else if(Id.includes("TabSeparated"))
                    {
                        _this.GetImportTemplateFile(ListFormat, "tsv");
                    }
                    else if(Id.includes("CSV"))
                    {
                        _this.GetImportTemplateFile(ListFormat, "csv");
                    }
                    else if(Id.includes("TXT"))
                    {
                        _this.GetImportTemplateFile(ListFormat, "txt");
                    }
                }

                if (Id.includes("SingleColumnList"))
                {
                    getImportTemplateFile("single", Id);
                }

                if (Id.includes("MultiColumnList"))
                {
                    getImportTemplateFile("multi", Id);
                }

                this.hide();
            }
        }
    });

    this.Subscriptions = {};

    this.Signals = {
        RuleEnabled: new Rx.BehaviorSubject(0),
        RuleIspModeChanged: new Rx.BehaviorSubject(0),
        ValuedResource:new Rx.BehaviorSubject(null),
        ShowJustAdded: new Rx.BehaviorSubject(false),
        ShowResourceList: new Rx.BehaviorSubject(false),
        ImportedFilesCountChange: new Rx.BehaviorSubject(0)
    };

    this.AddedResources = [];
    this.ModifiedResources = [];
    this.DeletedResources = [];
    this.DeleteAllResources = false;
    this.ImportFilesArr = [];

    this.Views.ReportsWidgets.ResourcesReport.DataAdapter = function(Data)
    {
        var res = Data;

        if(res.rows && Array.isArray(res.rows))
        {
            res.rows.forEach((row, i) =>{
                const item = _this.ModifiedResources.find(obj => obj._id == row._id);

                if(item && item.enabled != row.enabled)
                {
                    res.rows[i].enabled = item.enabled;
                }
            });
        }

        return res;
    };
}

UlrEditWebIpFilterRuleViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.ImportPopup = webix.ui(this.ImportPopupConfig);

    this.ExportRulePopup = webix.ui(this.ExportRulePopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress)
    {
        var view = _this.Views.SaveBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveEnableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveDisableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.ExportRuleBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.DeleteBtn;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions[DicsEnum.UlrRegulatorsDic] = App.DicsManager.Signal[DicsEnum.UlrRegulatorsDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.RuleEditForm.elements.regulator_id.getList().clearAll();
            _this.Views.RuleEditForm.elements.regulator_id.getList().parse(Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrRegulatorsDic)));
        }
    });

    this.Subscriptions[DicsEnum.UlrCategoriesDic] = App.DicsManager.Signal[DicsEnum.UlrCategoriesDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.RuleEditForm.elements.category_id.getList().clearAll();
            _this.Views.RuleEditForm.elements.category_id.getList().parse(Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrCategoriesDic)));
        }
    });

    this.Subscriptions[DicsEnum.UlrResourceTypesDic] = App.DicsManager.Signal[DicsEnum.UlrResourceTypesDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.AddResourceTypesInput.getList().clearAll();

            var dicArr = Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrResourceTypesDic));

            if(_this.RuleType == UlrRulesTypesCodesEnum.web_ip_lock)
            {
                dicArr = dicArr.filter(item => Object.values(UlrWebRuleResourcesTypesMapEnum).indexOf(parseInt(item.id)) > -1);
            }
            else
            {
                dicArr = dicArr.filter(item => Object.values(UlrWebRuleResourcesTypesMapEnum).indexOf(parseInt(item.id)) > -1 && item.id != UlrWebRuleResourcesTypesMapEnum.ech);
            }
            var dic_arr_for_report_table = webix.copy(dicArr);
            dicArr.unshift({id:"auto", value:LangHelper.GetString("UlrModule", "Auto")});

            // Issues #6076.3
            // Hide CATEGORY
            // if (!AppEnv.UlrShowCategory)
            //     dicArr = dicArr.filter(item => item.id != UlrWebRuleResourcesTypesMapEnum.clsfr);

            if(dicArr && dicArr.length)
            {
                _this.Views.AddResourceTypesInput.getList().clearAll();
                _this.Views.AddResourceTypesInput.getList().parse(dicArr);
                _this.Views.AddResourceTypesInput.setValue(dicArr[0].id);
            }

            var column = _this.Views.ReportsWidgets.ResourcesReport.Views.Table.getColumnConfig("type_id");
            if(column)
            {
                column.header[1].options = [];
                _this.Views.ReportsWidgets.ResourcesReport.Views.Table.refreshColumns();
                column.header[1].options = dic_arr_for_report_table;
                _this.Views.ReportsWidgets.ResourcesReport.Views.Table.refreshColumns();
                _this.Views.ReportsWidgets.ResourcesReport.Views.Table.refresh();
            }
        }
    });

    this.Subscriptions.RuleProfileUpdated = this.ViewModel.Signals.RuleProfileUpdated.subscribe(function (RuleModel) {
        if(RuleModel)
        {
            _this.DefineAll(RuleModel);
        }
    });

    this.Subscriptions.RuleProfileError = this.ViewModel.Signals.RuleProfileError.subscribe(function (ErrModel)
    {
        var action = null;

        if(ErrModel&&ErrModel.code == 404)
        {
            action = function ()
            {
                setTimeout(function ()
                {
                    App.NavRouter.PresentView({id: (_this.RuleType == UlrRulesTypesCodesEnum.web_ip_white ? ControllersEnum.UlrWhiteList : ControllersEnum.UlrWebIpFilterRules)});
                }, 1);
            }
        }

        _this.ShowServerError(ErrModel, action);
    });

    this.Subscriptions.RuleProfileSaveError = this.ViewModel.Signals.RuleProfileSaveError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RuleProfileDeleteError = this.ViewModel.Signals.RuleProfileDeleteError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.WebRuleResourceValidatedError = this.ViewModel.Signals.WebRuleResourceValidatedError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RuleProfileSaved = this.ViewModel.Signals.RuleProfileSaved.subscribe(function (RuleProfileModel)
    {
        if(RuleProfileModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", _this.RuleType == UlrRulesTypesCodesEnum.web_ip_white ? "Whitelist rule" : "Web rule")+" # "+RuleProfileModel.profile._id+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: (_this.RuleType == UlrRulesTypesCodesEnum.web_ip_white ? ControllersEnum.UlrWhiteList : ControllersEnum.UlrWebIpFilterRules)});
            },1);
        }
    });

    this.Subscriptions.RuleProfileDeleted = this.ViewModel.Signals.RuleProfileDeleted.subscribe(function (RuleModel)
    {
        if(RuleModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", _this.RuleType == UlrRulesTypesCodesEnum.web_ip_white ? "Whitelist rule" : "Web rule")+" #"+RuleModel._id+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: (_this.RuleType == UlrRulesTypesCodesEnum.web_ip_white ? ControllersEnum.UlrWhiteList : ControllersEnum.UlrWebIpFilterRules)});
            },1);
        }
    });

    this.Subscriptions.SearchRulesByRawResourceDone = this.ViewModel.Signals.SearchRulesByRawResourceDone.subscribe(function (Data)
    {
        if (Data)
        {
            if (Data.length)
            {
                _this.DefineRulesByRawResourceResult(Data);
            }
            else
            {
                _this.DefineValidationResult(new UlrValuedResourceViewModel({type_id:"auto", validation_success:0}))
            }

            _this.ShowHideValidationResult(true);
        }
    });

    this.Subscriptions.SearchRulesByRawResourceError = this.ViewModel.Signals.SearchRulesByRawResourceError.subscribe(function (Error)
    {
        if (Error)
        {
            webix.message({type:"error", text:Error.msg});
        }

    });

    this.Subscriptions.RuleEnabled = this.Signals.RuleEnabled.subscribe(function (Enabled)
    {
        var view = _this.Views.SaveDisableBtn;
        Enabled ? view.show() : view.hide();

        var view = _this.Views.SaveEnableBtn;
        !Enabled ? view.show() : view.hide();
    });

    this.Subscriptions.ShowJustAddedResources = this.Signals.ShowJustAdded.subscribe(function(Show)
    {
        Show ? _this.Views.AddedResourcesReportSection.show() : _this.Views.AddedResourcesReportSection.hide();
    });

    this.Subscriptions.ShowResourceList = this.Signals.ShowResourceList.subscribe(function(Show)
    {
        Show ? _this.Views.ResourceListReportSection.show() : _this.Views.ResourceListReportSection.hide();
    });

    this.Subscriptions.WebRuleResourceValidationProgress = this.ViewModel.Signals.WebRuleResourceValidationProgress.subscribe(function (InProgress)
    {
        var view = _this.Views.ValidateResourceBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.AddResourceInput;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.AddResourceTypesInput;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions.DomainFullInfoResultUpdated = this.CheckDomainManager.Signals.CheckResultUpdated.subscribe(function (CheckDomainModel)
    {
        if(CheckDomainModel && CheckDomainModel.resource_raw === _this.Views.AddResourceInput.getValue())
        {
            if (CheckDomainModel.valid) {
                _this.ValidateResourceAuto(CheckDomainModel);
            } else {
                _this.ViewModel.SearchRulesByRawResource({
                    rule_type_mode: "global",
                    rule_type_id: _this.RuleTypeId,
                    resource_raw: CheckDomainModel.resource_raw
                });
            }
        }
    });

    this.Subscriptions.CheckResultError = this.CheckDomainManager.Signals.CheckResultError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Views.AddResourceTypesInput.attachEvent("onChange", function(Nv, Ov)
    {
        let input = _this.Views.AddResourceInput;
        let select = _this.Views.AddResourceSelect;
        let qoe_import_input = _this.Views.QoEImportInput;

        input.show();
        select.hide();
        qoe_import_input.hide();

        _this.Views.AddResourceBtn.disable();

        let resourceRaw = _this.Views.AddResourceInput.getValue();

        if (Nv == UlrWebRuleResourcesTypesMapEnum.clsfr)
        {
            input.hide();
            input.setValue('');
            select.disable();
            select.setValue('');
            select.show();

            resourceRaw = _this.Views.AddResourceSelect.getValue();

            let Categories = [];
            let CategoriesDic = App.DicsManager.GetDicAsArray(DicsEnum.ClsfrCategoriesDic);

            let lang = LangHelper.GetLocale();

            Categories = CategoriesDic.map(function (Category){
                let name = Category.value;
                return {
                    id: Category.id,
                    value: name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]])
                };
            });

            let list = select.getList();
            list.clearAll();
            list.parse(Categories);

            select.enable();
        }
        if(Nv == UlrWebRuleResourcesTypesMapEnum.ulr_fastresource)
        {
            input.hide();
            input.setValue('');
            select.hide();
            select.setValue('');

            qoe_import_input.setValue('');
            qoe_import_input.show();

            // _this.Views.AddResourceBtn.enable();
            // return;
        }

        _this.Signals.ValuedResource.next(new UlrValuedResourceViewModel({resource_raw:resourceRaw, type_id: Nv}));
        _this.AddResourceUnsaved = false;
    });

    this.Views.EchEnabledModeSelect.attachEvent("onChange", function(Nv, Ov)
    {
        if(Nv == 2)
        {
            _this.Views.RedirectIPv4Input.show();
            _this.Views.RedirectIPv6Input.show();
        }
        else
        {
            _this.Views.RedirectIPv4Input.hide();
            _this.Views.RedirectIPv6Input.hide();
        }
    });

    this.Views.AddResourceSelect.attachEvent("onChange", function(Nv, Ov)
    {
        if (Nv == '')
            return;

        var type = _this.Views.AddResourceTypesInput.getValue();
        _this.Signals.ValuedResource.next(new UlrValuedResourceViewModel({resource_raw:Nv, type_id: type}));
        _this.AddResourceUnsaved = true;
    });

    this.Views.AddResourceInput.attachEvent("onChange", function(Nv, Ov)
    {
        var _Nv = Nv.trim(); //.replace(/\s/g, '');

        if(Nv != _Nv)
        {
            this.setValue(_Nv);
            return;
        }

        var type = _this.Views.AddResourceTypesInput.getValue();
        _this.Signals.ValuedResource.next(new UlrValuedResourceViewModel({resource_raw:Nv, type_id: type}));
        _this.AddResourceUnsaved = true;
    });

    this.Views.AddResourceInput.attachEvent("onTimedKeyPress", function()
    {
        var v = _this.Views.AddResourceInput.getValue();

        var _Nv = v; //.trim();//.replace(/\s/g, '');

        if(v != _Nv)
        {
            this.setValue(_Nv);
            return;
        }

        var type = _this.Views.AddResourceTypesInput.getValue();

        _this.Signals.ValuedResource.next(new UlrValuedResourceViewModel({resource_raw:v, type_id: type}));
        _this.AddResourceUnsaved = true;
    });

    this.Subscriptions.QoeImportValueChanged = this.Views.QoEImportInput.Signals.ValueChanged.subscribe(function(Val)
    {
        if(Val)
        {
            _this.AddResourceUnsaved = true;
        }
    });

    this.Subscriptions.ValuedResource = Rx.Observable.combineLatest
    (
        this.Signals.ValuedResource.distinctUntilChanged(),
        this.ViewModel.Signals.WebRuleResourceValidationProgress.distinctUntilChanged()
    ).subscribe(function (Signal)
    {
        var ValuedResource = Signal[0];
        var InProgress = Signal[1];

        if(!InProgress && ValuedResource && ValuedResource.try_validate)
        {
            _this.DefineValidationResult(ValuedResource);

            _this.ShowHideValidationResult(true);
        }
        else
            _this.ShowHideValidationResult(false);

        var view = _this.Views.AddResourceBtn;
        if(ValuedResource && ValuedResource.type_id == UlrWebRuleResourcesTypesMapEnum.ulr_fastresource)
        {
            view.enable();
        }
        else
        {
            InProgress || !ValuedResource || !ValuedResource.resource_raw ? view.disable() : view.enable();
        }


        view = _this.Views.ValidateResourceBtn;
        if(InProgress || !ValuedResource || !ValuedResource.resource_raw || _this.Views.AddResourceTypesInput.getValue() == UlrWebRuleResourcesTypesMapEnum.clsfr
            || _this.Views.AddResourceTypesInput.getValue() == UlrWebRuleResourcesTypesMapEnum.ulr_fastresource
            || _this.Views.AddResourceTypesInput.getValue() == UlrWebRuleResourcesTypesMapEnum.ech
        )
        {
            view.disable();
        }
        else
        {
            view.enable()
        }
    });

    this.Views.ImportFilesPopupUploader.attachEvent("onAfterFileAdd", function(FileObj){
        if(FileObj)
        {
            _this.OnFileAdded(FileObj);
        }
    });

    this.Subscriptions.ImportFilesCountChange = this.Signals.ImportedFilesCountChange.subscribe(function(Val)
    {
       _this.DefineImportFilesBtnBadge(Val);
    });

    // this.Views.ImportPopupUploader.attachEvent("onAfterFileAdd", function(FileObj)
    // {
    //     var reader = new FileReader();
    //
    //     reader.onload = function(e)
    //     {
    //         _this.Views.ImportPopupEditor.setValue(reader.result);
    //     };
    //
    //     reader.readAsText(FileObj.file, "utf-8");
    //
    // });

};

UlrEditWebIpFilterRuleViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.IspsList.ViewDidLoad(PathParams);
    this.SubsList.ViewDidLoad(PathParams);

    this.BindAll(PathParams);

    this.Signals.ShowJustAdded.next(this.Action == this.ActionsEnum.Add)
    this.Signals.ShowResourceList.next(this.Action != this.ActionsEnum.Add)

    this.Refresh();
};

UlrEditWebIpFilterRuleViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if(this.CheckDomainManager)
    {
        this.CheckDomainManager.Destroy();
        delete this.CheckDomainManager;
    }

    if(this.IspsList)
    {
        this.IspsList.Destroy();
    }

    if(this.SubsList)
    {
        this.SubsList.Destroy();
    }
};

UlrEditWebIpFilterRuleViewController.prototype.RefreshRuleProfile = function ()
{
    var id = this.Action == this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    this.ViewModel.ResfreshWebRuleProfile({_id: id, type_id: this.RuleTypeId});

    this.DefinePageTitle((this.Action == this.ActionsEnum.Add ? LangHelper.GetString("UlrModule","Add rule") : LangHelper.GetString("UlrModule","Edit rule")) + " #" + id);

    if(this.Action == this.ActionsEnum.Edit)
    {
        this.Views.RuleEditFormEnabledStateView.show();
        this.Views.RuleEditFormEnabledSpacerView.show();
        this.Views.ExportRuleBtn.show();
        this.Views.DeleteBtn.show();
    }
};

UlrEditWebIpFilterRuleViewController.prototype.Refresh = function ()
{
    this.RefreshRuleProfile();
};

UlrEditWebIpFilterRuleViewController.prototype.RefreshResources = function()
{
    if(this.Action != this.ActionsEnum.Add && this.GetPathParam("_id"))
    {
        var filter = {
            rule_id: {
                id: "rule_id",
                operator: "=",
                value: this.GetPathParam("_id")
            },
            type_id: {
                id: "type_id",
                operator: "!=",
                value: UlrWebRuleResourcesTypesMapEnum.empty
            }
        };

        this.Views.ReportsWidgets.ResourcesReport.RefreshData(null,{
            filter: filter
        });
    }
};

UlrEditWebIpFilterRuleViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrEditWebIpFilterRuleViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

UlrEditWebIpFilterRuleViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditWebIpFilterRuleViewController.prototype.DefinePageTitle = function(Title)
{
    this.Views.PageTitle.define("data", {root_title:Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

UlrEditWebIpFilterRuleViewController.prototype.DefineAll = function(RuleModel)
{
    var _this = this;

    if(RuleModel.is_system)
    {
        this.Views.AddResourceSection.hide();
        this.Views.ChannelsAndSubscribersSection.hide();
        this.Views.ClearAllResources.hide();

        // По просьбе НЦОТа вернули возможность Включать и Выключать правило
        this.Views.SaveBtn.enable();
        this.Views.SaveEnableBtn.enable();
        this.Views.SaveDisableBtn.enable();

        this.Views.DeleteBtn.disable();

        this.Views.ReportsWidgets.ResourcesReport.HideColumns(['enabled', 'delete']);
    }
    else
    {
        this.Views.AddResourceSection.show();
        this.Views.ChannelsAndSubscribersSection.show();
        this.Views.ClearAllResources.show();
        this.Views.SaveBtn.enable();
        this.Views.SaveEnableBtn.enable();
        this.Views.SaveDisableBtn.enable();
        this.Views.DeleteBtn.enable();
    }

    this.Views.RuleEditForm.clearValidation();
    this.Views.RuleEditForm.clear();

    this.Views.RuleEditForm.setValues(RuleModel.profile);

    this.Signals.RuleEnabled.next(parseInt(RuleModel.profile.enabled));


    var ispsVals = {};

    RuleModel.isps.rows.forEach(function (Item)
    {
        ispsVals[""+Item.isp_id] = 1;
    });

    this.IspsList.setForm(ispsVals,parseInt(RuleModel.profile.mode_id));
    this.SubsList.setForm(ispsVals,parseInt(RuleModel.profile.subs_mode_id));

    this.Views.HardBlockingRuleModeToggle.setValue(RuleModel.profile.hard_blocking ? 1 : 0);
    this.Views.EchEnabledModeSelect.setValue(RuleModel.profile.ech_enabled ? RuleModel.profile.ech_enabled : 0);
    this.Views.ReportsWidgets.ActionsLog.Filter =
    {
        row_id:
        {
            id:"row_id",
            operator:"=",
            value:RuleModel.profile._id ? RuleModel.profile._id : -1
        },
        type_code:
        {
            id:"type_code",
            operator:"=",
            value:_this.RuleType
        }
    };

    this.Views.ReportsWidgets.ActionsLog.RefreshData();

    this.RefreshResources();


};

UlrEditWebIpFilterRuleViewController.prototype.AddResource = function()
{
    var _this = this;

    var models = [];

    var model = new UlrWebRuleResourceModel();

    var valuedModel = new UlrValuedResourceViewModel(this.Signals.ValuedResource.getValue());

    model.enabled = 1;
    model.resource_raw = valuedModel.resource_raw;
    model.type_id = valuedModel.type_id;

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.ip)
    {
        if(valuedModel.validation_success && valuedModel.ips.length)
        {
            valuedModel.ips.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.ip,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.try_validate && !valuedModel.validation_success)
        {
            model.state_valid = UlrStateValidEnum.invalid;
            models.push(model);
        }
        else if(!valuedModel.try_validate)
        {
            model.state_valid = UlrStateValidEnum.undefined;
            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.cidr)
    {
        if(valuedModel.validation_success && valuedModel.cidrs.length)
        {
            valuedModel.cidrs.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.cidr,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.try_validate && !valuedModel.validation_success)
        {
            model.state_valid = UlrStateValidEnum.invalid;
            models.push(model);
        }
        else if(!valuedModel.try_validate)
        {
            model.state_valid = UlrStateValidEnum.undefined;
            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.url)
    {
        if(valuedModel.validation_success && valuedModel.urls.length)
        {
            model.resource_validated = valuedModel.isHttp;
            model.state_valid = UlrStateValidEnum.valid;

            valuedModel.urls.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.url,
                    resource_validated:Item
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.isHttps)
        {
            valuedModel.cns.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.cn,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });

            valuedModel.snis.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.sni,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else
        {
            if(valuedModel.try_validate)
                model.state_valid = UlrStateValidEnum.invalid;

            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.cn)
    {
        if(valuedModel.validation_success && valuedModel.cns.length)
        {
            valuedModel.cns.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.cn,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.try_validate && !valuedModel.validation_success)
        {
            model.state_valid = UlrStateValidEnum.invalid;
            models.push(model);
        }
        else if(!valuedModel.try_validate)
        {
            model.state_valid = UlrStateValidEnum.undefined;
            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.sni)
    {
        if(valuedModel.validation_success && valuedModel.snis.length)
        {
            valuedModel.snis.forEach(function (Item)
            {
                var _model = webix.extend(model, {
                    type_id: UlrWebRuleResourcesTypesMapEnum.sni,
                    resource_validated:Item,
                    state_valid: UlrStateValidEnum.valid
                },true);

                models.push(new UlrWebRuleResourceModel(_model));
            });
        }
        else if(valuedModel.try_validate && !valuedModel.validation_success)
        {
            model.state_valid = UlrStateValidEnum.invalid;
            models.push(model);
        }
        else if(!valuedModel.try_validate)
        {
            model.state_valid = UlrStateValidEnum.undefined;
            models.push(model);
        }
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.clsfr)
    {
        model.state_valid = UlrStateValidEnum.valid;
        models.push(model);
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.ulr_fastresource)
    {
        model.fastresource_config = this.Views.QoEImportInput.getValue();
        model.state_valid = UlrStateValidEnum.valid;

        models.push(model);
    }

    if(valuedModel.type_id == UlrWebRuleResourcesTypesMapEnum.ech)
    {
        model.state_valid = UlrStateValidEnum.undefined;
        models.push(model);
    }

    if(valuedModel.type_id === "auto")
    {
        if(valuedModel.try_validate && valuedModel.validation_success)
        {
            Object.keys(UlrWebRuleResourcesTypesMapListKeys).forEach((key) => {
                let listKey = UlrWebRuleResourcesTypesMapListKeys[key];

                if(valuedModel[listKey].length)
                {
                    valuedModel[listKey].forEach(function (Item)
                    {
                        var _model = webix.extend(model, {
                            type_id: UlrWebRuleResourcesTypesMapEnum[key],
                            resource_validated:Item,
                            state_valid: UlrStateValidEnum.valid
                        },true);

                        models.push(new UlrWebRuleResourceModel(_model));
                    });
                }
            })
        }
        else
        {
            let stateValid = valuedModel.try_validate  ? UlrStateValidEnum.invalid : UlrStateValidEnum.undefined;

            let vItems = valuedModel.resource_raw.split(":");
            if(vItems.length > 2 || vItems.length == 1)
                vItems = valuedModel.resource_raw.split(' ');

            let input = vItems[0];

            if(Helper.ValidateIPv4(input)||Helper.ValidateIPv6(input))
            {
                // Добавляем порты, если не заданы
                if (AppEnv.UlrAddPortsToIpOnExport == 1)
                {
                    ["80", "443"].forEach((port) => {
                        var _model = webix.extend(model, {
                            resource_raw: valuedModel.resource_raw + " " + port,
                            type_id: UlrWebRuleResourcesTypesMapEnum.ip,
                            state_valid: stateValid
                        },true);
                        models.push(new UlrWebRuleResourceModel(_model));
                    })
                }
                else
                {
                    model.type_id = UlrWebRuleResourcesTypesMapEnum.ip;
                    model.state_valid = stateValid;
                    models.push(model);
                }


            }
            else if (Helper.UlrValidateCidr(input))
            {
                // Добавляем порты, если не заданы
                if (AppEnv.UlrAddPortsToIpOnExport == 1)
                {
                    ["80", "443"].forEach((port) => {
                        var _model = webix.extend(model, {
                            resource_raw: valuedModel.resource_raw + " " + port,
                            type_id: UlrWebRuleResourcesTypesMapEnum.cidr,
                            state_valid: stateValid
                        },true);
                        models.push(new UlrWebRuleResourceModel(_model));
                    })
                }
                else
                {
                    model.type_id = UlrWebRuleResourcesTypesMapEnum.cidr;
                    model.state_valid = stateValid;
                    models.push(model);
                }

            }
            else
            {
                ["sni", "cn", "url"].forEach((code) => {
                    var _model = webix.extend(model, {
                        type_id: UlrWebRuleResourcesTypesMapEnum[code],
                        state_valid: stateValid
                    },true);

                    models.push(new UlrWebRuleResourceModel(_model));

                    if (code === 'url')
                    {
                        var _model = webix.extend(model, {
                            type_id: UlrWebRuleResourcesTypesMapEnum[code],
                            resource_raw: model.resource_raw + ":",
                            state_valid: stateValid
                        },true);

                        models.push(new UlrWebRuleResourceModel(_model));
                    }
                })
            }
        }
    }

    models.forEach(function (Model) {
        _this.JustAddResource(Model);
    });

    this.AddResourceUnsaved = false;
};

UlrEditWebIpFilterRuleViewController.prototype.JustAddResource = function(ResourceModel, MultiInsert)
{
    var table = this.Views.ReportsWidgets.AddedResourcesReport.Views.Table;

    if(!MultiInsert)
    {
        var model = new UlrWebRuleResourceModel(ResourceModel);
        this.AddedResources.push(model);
    }
    else
    {
        ResourceModel.forEach((Item) => {
            var model = new UlrWebRuleResourceModel(Item);
            this.AddedResources.push(model);
        });
    }

    this.ShowHideAddedResourcesTable();

    this.Views.ReportsWidgets.AddedResourcesReport.RefreshData();
};

UlrEditWebIpFilterRuleViewController.prototype.ShowHideAddedResourcesTable = function()
{
    this.Signals.ShowJustAdded.next(this.AddedResources.length > 0);
};

UlrEditWebIpFilterRuleViewController.prototype.ClearResources = function()
{
    var table = this.Views.ReportsWidgets.ResourcesReport.Views.Table;

    this.DeleteAllResources = true;

    var filter = {
        rule_id: {
            id: "rule_id",
            operator: "=",
            value: this.GetPathParam("_id")
        },
        rule_id_neq: {
            id: "rule_id",
            operator: "!=",
            value: this.GetPathParam("_id")
        }
    };

    this.Views.ReportsWidgets.ResourcesReport.ExternalFilter = filter;

    table.clearAll();
};

UlrEditWebIpFilterRuleViewController.prototype.AddedResourcesReportOnItemClick = function(Id)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.AddedResourcesReport.Views.Table;

    var item = table.getItem(Id);

    if(Id.column === 'delete')
    {
        if(item)
        {
            const index = this.AddedResources.findIndex(x => x.id == item.id);
            if(index > -1)
            {
                this.AddedResources.splice(index, 1);
                this.Views.ReportsWidgets.AddedResourcesReport.RefreshData();
                this.ShowHideAddedResourcesTable();
            }
        }

        table.remove(Id);
    }

    var typesDic = App.DicsManager.GetDic(DicsEnum.UlrResourceTypesDic);

    if(Id.column === 'resource_raw' && typesDic && typesDic[item.type_id] && typesDic[item.type_id].value == UlrWebRuleResourcesTypesEnum.clsfr.toUpperCase() && App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.ulr_hosts_list))
    {
        var host_type_name = Helper.Table.ClsfrIdToNameTemplate(item.resource_raw, true);

        var modal_title = LangHelper.GetString("UlrModule", "Hosts list of the {CATEGORY} category").replace("{CATEGORY}", host_type_name);

        var table_params = {
            enableAutoHeight: false,
            enableTextSearch: true,
            is_modal: true,
            filter: {
                cat_id: {
                    id: "cat_id",
                    operator: "=",
                    value: item.resource_raw
                }
            },
        }
        var table = new UlrAppCategoryHostsTable(table_params);
        UlrEditAppPolicingPopup({
            modal_title: modal_title
        }, table);
        table.Bind(_this, _this.ReportsModel);
        table.RefreshData();
    }
    else if(Id.column === 'resource_raw' && item.type_id == UlrWebRuleResourcesTypesMapEnum.ulr_fastresource)
    {
        ResourceImportQoEPopupItem({
            cfg: item.fastresource_config,
            editable: true,
            update_config: function(config)
            {
                if(item)
                {
                    const index = _this.AddedResources.findIndex(x => x.id == item.id);
                    if(index > -1)
                    {
                        _this.AddedResources[index].fastresource_config = JSON.stringify(config);
                        _this.Views.ReportsWidgets.AddedResourcesReport.RefreshData();
                        _this.ShowHideAddedResourcesTable();
                    }
                }
            }
        });
    }
};

UlrEditWebIpFilterRuleViewController.prototype.ResourcesReportOnItemClick = function(Row, Column)
{
    var _this = this;
    if (Column === 'delete' || Column === 'enabled'|| Column === 'resource_raw')
    {
        var table = this.Views.ReportsWidgets.ResourcesReport.Views.Table;
        var item = table.getItem(Row);
        if (item)
        {
            if(Column === 'delete')
            {
                this.DeletedResources.push(item);
                table.remove(Row);

                var filter = {
                        rule_id: {
                            id: "rule_id",
                            operator: "=",
                            value: this.GetPathParam("_id")
                        }
                    };

                var deleted = [];

                this.DeletedResources.forEach((item) => {
                    const _id = parseInt(item._id);

                    if(_id)
                    {
                        deleted.push(_id);
                    }
                });

                if(deleted.length > 0)
                {
                    filter._ids = {
                        id: "_id",
                        operator: "not in",
                        value: deleted
                    };
                }

                this.Views.ReportsWidgets.ResourcesReport.ExternalFilter = filter;
            }
            else if(Column === 'enabled')
            {
                this.ModifiedResources.push(item);
            }

            var typesDic = App.DicsManager.GetDic(DicsEnum.UlrResourceTypesDic);

            if(Column === 'resource_raw' && typesDic && typesDic[item.type_id] && typesDic[item.type_id].value == UlrWebRuleResourcesTypesEnum.clsfr.toUpperCase() && App.SessionManager.CheckUserRoleSection(RoleSectionsEnum.ulr_hosts_list))
            {
                var host_type_name = Helper.Table.ClsfrIdToNameTemplate(item.resource_raw, true);

                var modal_title = LangHelper.GetString("UlrModule", "Hosts list of the {CATEGORY} category").replace("{CATEGORY}", host_type_name);

                var table_params = {
                    enableAutoHeight: false,
                    enableTextSearch: true,
                    is_modal: true,
                    filter: {
                        cat_id: {
                            id: "cat_id",
                            operator: "=",
                            value: item.resource_raw
                        }
                    },
                }
                var table = new UlrAppCategoryHostsTable(table_params);
                
                UlrEditAppPolicingPopup({
                    modal_title: modal_title
                }, table);
                table.Bind(_this, _this.ReportsModel);
                table.RefreshData();
            }
            else if(Column === 'resource_raw' && item.type_id == UlrWebRuleResourcesTypesMapEnum.ulr_fastresource)
            {
                ResourceImportQoEPopupItem({
                    cfg: item.fastresource_config,
                    editable: true,
                    update_config: function(config)
                    {
                        _this.DeletedResources.push(item);
                        table.remove(Row);

                        var filter = {
                            rule_id: {
                                id: "rule_id",
                                operator: "=",
                                value: _this.GetPathParam("_id")
                            }
                        };

                        var deleted = [];

                        _this.DeletedResources.forEach((item) => {
                            const _id = parseInt(item._id);

                            if(_id)
                            {
                                deleted.push(_id);
                            }
                        });

                        if(deleted.length > 0)
                        {
                            filter._ids = {
                                id: "_id",
                                operator: "not in",
                                value: deleted
                            };
                        }

                        _this.Views.ReportsWidgets.ResourcesReport.ExternalFilter = filter;

                        var _item = webix.copy(item);
                        _item._id = 0;
                        _item.enabled = 1;
                        _item.fastresource_config = JSON.stringify(config);

                        _this.JustAddResource(_item);
                    }
                });
            }
        }
    }
};


UlrEditWebIpFilterRuleViewController.prototype.SelectAllIsps = function()
{
    var vals = this.Views.ISPListForm.getValues();

    Object.keys(vals).forEach(function (Key) {
        vals[Key] = 1;
    });

    this.Views.ISPListForm.setValues(vals);
};

UlrEditWebIpFilterRuleViewController.prototype.UnselectAllIsps = function()
{
    var vals = this.Views.ISPListForm.getValues();

    Object.keys(vals).forEach(function (Key) {
        vals[Key] = 0;
    });

    this.Views.ISPListForm.setValues(vals);
};

UlrEditWebIpFilterRuleViewController.prototype.Save = function(Enable)
{
    var _this = this;
    // debugger;
    if(!this.Views.RuleEditForm.validate())
    {
        this.Views.ScrollView.scrollTo(0, 0);
        return;
    }

    var is_unsaved = false;
    if(this.AddResourceUnsaved && this.Views.AddResourceBtn.isEnabled())
    {
        if(this.Views.QoEImportInput.isVisible())
        {
            is_unsaved = true;
        }
        else if(this.Views.AddResourceInput.isVisible())
        {
            var val = this.Views.AddResourceInput.getValue();
            if(val)
            {
                is_unsaved = true;
            }
        }
        else if(this.Views.AddResourceSelect.isVisible())
        {
            var val = this.Views.AddResourceSelect.getValue();
            if(val)
            {
                is_unsaved = true;
            }
        }
    }

    var closure = function()
    {
        var model = new UlrWebRuleViewModel();

        model.profile = new UlrWebRuleModel(_this.Views.RuleEditForm.getValues());

        if(typeof Enable != "undefined")
        {
            model.profile.enabled = Enable ? 1 : 0;
        }

        model.profile.mode_id = parseInt(_this.IspsList.Views.RuleModeToggle.getValue());
        model.profile.subs_mode_id = parseInt(_this.SubsList.Views.RuleModeToggle.getValue());

        model.resources = {
            added: _this.AddedResources,
            modified: _this.ModifiedResources,
            deleted: _this.DeletedResources,
            deleteAllResources: _this.DeleteAllResources,
            importFiles: []
        };

        _this.ImportFilesArr.forEach((Model) => {
            if(Model.filepath)
            {
                model.resources.importFiles.push(Model.filepath);
            }
        });

        model.isps = [];

        if(model.profile.mode_id == 2)
        {
            var isps = _this.IspsList.getSelectedIsps();
            isps.forEach(isp_id => {
                model.isps.push({isp_id:isp_id});
            });
        }

        if(model.profile.subs_mode_id == 2)
        {
            var isps = _this.SubsList.getSelectedIsps();
            isps.forEach(isp_id => {
                model.isps.push({isp_id:isp_id});
            });
        }

        model.profile.ech_enabled = parseInt(_this.Views.EchEnabledModeSelect.getValue());
        if(model.profile.ech_enabled == 2)
        {
            model.profile.ech_redirect_ipv4 = _this.Views.RedirectIPv4Input.getValue();
            model.profile.ech_redirect_ipv6 = _this.Views.RedirectIPv6Input.getValue();
        }
        else
        {
            model.profile.ech_redirect_ipv4 = '';
            model.profile.ech_redirect_ipv6 = '';
        }

        _this.ViewModel.SaveWebRuleProfile(model);
    }

    if(is_unsaved)
    {
        UlrShowDialogPopup({
            head:"",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule", "Unadded resource"),
            message:LangHelper.GetString("UlrModule","You have unadded resource."),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Save anyway"),
                    click: function()
                    {
                        closure();
                    }
                },
                {
                    label:LangHelper.GetString("UlrModule","Cancel"),
                    click:function ()
                    {
                        setTimeout(function(){
                            _this.Views.ScrollView.scrollTo(0, 0);
                        }, 10);

                    }
                }
            ]
        });
    }
    else
    {
        closure();
    }
};

UlrEditWebIpFilterRuleViewController.prototype.Delete = function()
{
    var _this = this;

    var model = this.ViewModel.Signals.RuleProfileUpdated.getValue();

    UlrShowDialogPopup({
        node:this.Views.DeleteBtn.getNode(),
        position:"bottom",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    _this.ViewModel.DeleteWebRule(model);
                }
            }
        ]
    });


};

UlrEditWebIpFilterRuleViewController.prototype.ValidateResource = function(vResource = null)
{
    var _this = this;

    var vr = vResource ? vResource : new UlrValuedResourceViewModel({
        resource_raw: this.Views.AddResourceInput.getValue(),
        type_id: this.Views.AddResourceTypesInput.getValue()
    });

    if(!vr.resource_raw || !vr.type_id)
        return;

    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.ip)
    {
        vItems = vr.resource_raw.split(":");

        if(vItems.length > 2 || vItems.length == 1)
            vItems = vr.resource_raw.split(' ');

        // Добавляем порты, если не заданы
        if (AppEnv.UlrAddPortsToIpOnExport == 1)
        {
            if(vItems.length == 1)
            {
                vItems.push('80');
                vItems.push('443');
            }
        }

        ip = vItems[0];

        ipPorts = [];

        vSuccess = true;

        if(vItems.length > 1)
        {
            vItems.forEach(function (V, I)
            {
                if(I > 0)
                {
                    ipPort = ip + " " + V;
                    ipPorts.push(ipPort);

                    if(!Helper.ValidateIPv4IPv6AddressPlusPort(ipPort))
                        vSuccess = false;
                }

            });
        }
        else
        {
            ipPorts.push(ip);
            if(!Helper.ValidateIPv4IPv6AddressPlusPort(ip))
                vSuccess = false;
        }


        vr.validation_success = vSuccess;

        if(vr.validation_success)
        {
            vr.ips = ipPorts;
        }

        vr.try_validate = true;

        this.Signals.ValuedResource.next(vr);

    }

    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.cidr)
    {
        vItems = vr.resource_raw.split(":");

        if(vItems.length > 2 || vItems.length == 1)
            vItems = vr.resource_raw.split(' ');

        // Добавляем порты, если не заданы
        if (AppEnv.UlrAddPortsToIpOnExport == 1)
        {
            if(vItems.length == 1)
            {
                vItems.push('80');
                vItems.push('443');
            }
        }

        cidr = vItems[0];

        cidrPorts = [];

        vSuccess = true;

        if(vItems.length > 1)
        {
            vItems.forEach(function (V, I)
            {
                if(I > 0)
                {
                    cidrPort = cidr + " " + V;
                    cidrPorts.push(cidrPort);

                    if(!(Helper.UlrValidateCidr(cidr) && parseInt(V) > 0 && /^\d+$/.test(V)))
                        vSuccess = false;
                }

            });
        }
        else
        {
            cidrPorts.push(cidr);
            if(!(Helper.UlrValidateCidr(cidr)))
                vSuccess = false;
        }


        vr.validation_success = vSuccess;

        if(vr.validation_success)
            vr.cidrs = cidrPorts;

        vr.try_validate = true;

        this.Signals.ValuedResource.next(vr);
    }

    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.url || vr.type_id == UlrWebRuleResourcesTypesMapEnum.sni || vr.type_id == UlrWebRuleResourcesTypesMapEnum.cn)
    {
        _this.Signals.ValuedResource.next(null);

        this.ViewModel.ValidateWebRuleResource(
            {
                resource:vr.resource_raw,
                callback:function (ResultModel)
                {
                    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.url)
                    {
                        vr.validation_success = ResultModel.http_with_path.url.valid || ResultModel.http_with_www_path.url.valid;
                    }

                    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.sni)
                    {
                        vr.validation_success = ResultModel.https.url.valid || ResultModel.https_with_www.url.valid;
                    }

                    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.cn)
                    {
                        vr.validation_success = ResultModel.https.url.valid || ResultModel.https_with_www.url.valid;
                    }

                    if(ResultModel.https.url.valid || ResultModel.https_with_www.url.valid)
                    {
                        var key = ResultModel.https.url.valid ? "https" : "https_with_www";

                        vr.isHttps = 1;

                        if(ResultModel[key].cns.length)
                        {
                            ResultModel[key].cns.forEach(function (Item) {
                                vr.cns.push(Item.value);
                            });
                        }

                        if(ResultModel[key].snis.length)
                        {
                            ResultModel[key].snis.forEach(function (Item) {
                                vr.snis.push(Item.value);
                            });
                        }
                    }

                    if(ResultModel.http_with_path.url.valid || ResultModel.http_with_www_path.url.valid)
                    {
                        vr.isHttp = 1;
                        vr.http = ResultModel.http_with_path.url.valid ? ResultModel.http_with_path.url.value : ResultModel.http_with_www_path.url.value;

                        if(ResultModel.http_with_path.url.valid)
                            vr.urls.push(ResultModel.http_with_path.url.value);

                        if(ResultModel.http_with_www_path.url.valid)
                            vr.urls.push(ResultModel.http_with_www_path.url.value);
                    }

                    vr.try_validate = true;

                    if(vr.validation_success || (vr.type_id == UlrWebRuleResourcesTypesMapEnum.url && vr.isHttps)) {
                        _this.Signals.ValuedResource.next(vr);
                    } else {
                        _this.ViewModel.SearchRulesByRawResource({
                            rule_type_mode: "global",
                            rule_type_id: _this.RuleTypeId,
                            resource_raw: vr.resource_raw
                        });
                    }
                }
            }
        );
    }

    if(vr.type_id === "auto")
    {
        let vItems = vr.resource_raw.split(":");

        if(vItems.length > 2 || vItems.length == 1)
            vItems = vr.resource_raw.split(' ');

        let input = vItems[0];

        if(Helper.ValidateIPv4(input)||Helper.ValidateIPv6(input))
        {
            var vr = new UlrValuedResourceViewModel({
                resource_raw:vr.resource_raw,
                type_id:UlrWebRuleResourcesTypesMapEnum.ip
            });
            _this.ValidateResource(vr);
        }
        else if (Helper.UlrValidateCidr(input))
        {
            var vr = new UlrValuedResourceViewModel({
                resource_raw:vr.resource_raw,
                type_id:UlrWebRuleResourcesTypesMapEnum.cidr
            });
            _this.ValidateResource(vr);
        }
        else
        {
            _this.Signals.ValuedResource.next(null);
            _this.CheckDomainManager.GetDomainInfo({resource: vr.resource_raw});
        }
    }

};

UlrEditWebIpFilterRuleViewController.prototype.ValidateResourceAuto = function(CheckDomainModel)
{
    let _this = this;

    let vr = new UlrValuedResourceViewModel({
        resource_raw: _this.Views.AddResourceInput.getValue(),
        type_id: _this.Views.AddResourceTypesInput.getValue()
    });

    if(!vr.resource_raw || !vr.type_id)
        return;

    vr.try_validate = true;

    if(CheckDomainModel.valid)
    {
        vr.isHttp = !CheckDomainModel.ssl ? 1 : 0;
        vr.isHttps = CheckDomainModel.ssl ? 1 : 0;
        vr.cns = CheckDomainModel.cns ? CheckDomainModel.cns.filter(item => item.valid === 1).map(item => item.value) : [];
        vr.snis = CheckDomainModel.snis ? CheckDomainModel.snis.filter(item => item.valid === 1).map(item => item.value) : [];
        vr.urls = CheckDomainModel.urls ? CheckDomainModel.urls : [];
        vr.ips = [];

        let ipsArr = CheckDomainModel.dns_part ? CheckDomainModel.dns_part.filter(item => ["A", "AAAA"].includes(item.type)).map(item => item.addr) : [];

        if (AppEnv.UlrAddPortsToIpOnExport == 1) {
            ipsArr.forEach((ip) => {
                vr.ips.push(ip + " " + "80");
                vr.ips.push(ip + " " + "443");
            });
        }

        vr.validation_success = true;

        vr.urls.forEach(function (Url, I)
        {
            if(typeof Url === 'string')
            {
                vr.urls[I] = Url.replace('https://', '').replace('http://', '');
            }
        });

        _this.Signals.ValuedResource.next(vr);
    }
}


UlrEditWebIpFilterRuleViewController.prototype.DefineValidationResult = function(Model)
{
    var view = this.Views.ValidationResultLabel;
    var node = view.getNode();

    var text = [];

    webix.html.removeCss(node, 'success');
    webix.html.removeCss(node, 'error');

    if(Model.validation_success)
    {
        webix.html.addCss(node, 'success');
        view.define("icon","check");
    }
    else
    {
        webix.html.addCss(node, 'error');
        view.define("icon","times");
    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.ip)
    {
        if(Model.validation_success)
        {
            text.push(LangHelper.GetString("UlrModule","The IP address is valid."));
            text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            text.push(LangHelper.GetString("UlrModule","Next IP:PORTS will be added:"));

            Model.ips.forEach(function (Item)
            {
                text.push(Item);
            });
        }
        else {
            text.push(LangHelper.GetString("UlrModule","The IP address is not valid."));
            text.push(LangHelper.GetString("UlrModule","Please enter the IPv4 or IPv6 address in a proper format."));
            text.push(LangHelper.GetString("UlrModule","You can add a port number to the ip address with a colon as separator."));
            text.push(LangHelper.GetString("UlrModule","This will not work if you add this to the list."));
        }
    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.cidr)
    {
        if(Model.validation_success)
        {
            text.push(LangHelper.GetString("UlrModule","The CIDR address is valid."));
            text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            text.push(LangHelper.GetString("UlrModule","Next IP-prefix:PORTS will be added:"));

            Model.cidrs.forEach(function (Item)
            {
                text.push(Item);
            });
        }
        else {
            text.push(LangHelper.GetString("UlrModule","The CIDR address is not valid."));
            text.push(LangHelper.GetString("UlrModule","Please enter the IPv4 or IPv6 CIDR in a proper format."));
            text.push(LangHelper.GetString("UlrModule","This will not work if you add this to the list."));
        }
    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.url)
    {
        if(Model.validation_success)
        {
            var urlValid = false;

            Model.urls.forEach(function (Item)
            {
                if(Item == Model.resource_raw)
                    urlValid = true;
            });

            if(urlValid)
            {
                text.push(LangHelper.GetString("UlrModule", "The URL is valid and accessible."));
                text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            }
            else
            {
                text.push(LangHelper.GetString("UlrModule", "The resource is accessible."));
                text.push(LangHelper.GetString("UlrModule", "But URL is differ."));
                text.push(LangHelper.GetString("UlrModule", "The proper URL will be added to the list."));
                Model.urls.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "URL:") + Item);
                });
            }
        }
        else
        {
            if((Model.isHttps))
            {
                text.push(LangHelper.GetString("UlrModule", "This is SSL/TLS resource. We can block FULL DOMAIN!"));
                text.push(LangHelper.GetString("UlrModule", "Next SNI and CN will be added to the list."));

                Model.snis.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "SNI") + ":" + Item);
                });

                Model.cns.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "CN") + ":" + Item);
                });

            }
            else
            {
                text.push(LangHelper.GetString("UlrModule", "The URL is not accessible or not valid."));
                text.push(LangHelper.GetString("UlrModule","This will not work if you add this to the list."));
            }
        }

    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.cn)
    {
        if(Model.validation_success)
        {
            var cnValid = false;

            Model.cns.forEach(function (Item)
            {
                if(Item == Model.resource_raw)
                    cnValid = true;
            });

            if(cnValid)
            {
                text.push(LangHelper.GetString("UlrModule", "The CN is valid."));
                text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            }
            else
            {
                text.push(LangHelper.GetString("UlrModule", "The resource is accessible."));
                text.push(LangHelper.GetString("UlrModule", "But CN is differ."));
                text.push(LangHelper.GetString("UlrModule","The proper CN will be added to the list."));
                Model.cns.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "CN") + ":" + Item);
                });
            }
        }
        else
        {
            text.push(LangHelper.GetString("UlrModule", "The resource is not SSL/TLS or not accessible."));
            text.push(LangHelper.GetString("UlrModule", "This will not work if you add this to the list."));
        }
    }

    if(Model.type_id == UlrWebRuleResourcesTypesMapEnum.sni)
    {
        if(Model.validation_success)
        {
            var sniValid = false;

            Model.snis.forEach(function (Item)
            {
                if(Item == Model.resource_raw)
                    sniValid = true;
            });

            if(sniValid)
            {
                text.push(LangHelper.GetString("UlrModule", "The SNI is valid."));
                text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
            }
            else
            {
                text.push(LangHelper.GetString("UlrModule", "The resource is accessible."));
                text.push(LangHelper.GetString("UlrModule", "But SNI is differ."));
                text.push(LangHelper.GetString("UlrModule", "The proper SNI will be added to the list."));
                Model.snis.forEach(function (Item)
                {
                    text.push(LangHelper.GetString("UlrModule", "SNI") + ":" + Item);
                });
            }
        }
        else
        {
            text.push(LangHelper.GetString("UlrModule", "The resource is not SSL/TLS or not accessible."));
            text.push(LangHelper.GetString("UlrModule", "This will not work if you add this to the list."));
        }
    }

    if(Model.type_id === "auto")
    {
        if(Model.validation_success)
        {
            if(Model.isHttp)
            {
                text.push(LangHelper.GetString(
                    "UlrModule", "The resource is available via {TYPE} protocol."
                    ).replace("{TYPE}", "<strong>" + "http" + "</strong>")
                );
            }
            if(Model.isHttps)
            {
                text.push(LangHelper.GetString(
                    "UlrModule", "The resource is available via {TYPE} protocol."
                    ).replace("{TYPE}", "<strong>" + "https" + "</strong>")
                );
            }

            text.push(LangHelper.GetString("UlrModule", "The following resources will be added:"));
            text = text.concat(Model.urls ? Model.urls.map(url => "URL: " + url) : []);
            text = text.concat(Model.cns ? Model.cns.map(cn => "CN: " + cn) : []);
            text = text.concat(Model.snis ? Model.snis.map(sni => "SNI: " + sni) : []);
            text = text.concat(Model.ips ? Model.ips.map(ip => "IP: " + ip) : []);
        }
        else
        {
            text.push(LangHelper.GetString("UlrModule", "The resource is not accessible or not valid."));
            text.push(LangHelper.GetString("UlrModule", "This will not work if you add this to the list."));
        }
    }

    view.define("value",text.join("<br/>"));
    view.define("height", text.length*24 + 2*12);
    view.refresh();
    view.resize();
};

UlrEditWebIpFilterRuleViewController.prototype.DefineRulesByRawResourceResult = function(Data)
{
    var _this = this;

    var view = this.Views.ValidationResultLabel;
    var node = view.getNode();

    var page = _this.RuleTypeId == 1 ? "UlrEditWebIpFilterRule" : "UlrEditWhiteListRule";

    var text = [];

    webix.html.removeCss(node, 'success');
    webix.html.removeCss(node, 'error');

    webix.html.addCss(node, 'error');
    view.define("icon","times");

    text.push(LangHelper.GetString("UlrModule", "A similar resource has already been added to the following rules:"))

    Data.forEach((item) => {
        text.push(LangHelper.GetString("UlrModule", "Rule") + ": " + `<a href='#${page}/_id=${item.rule_id}' target='_blank'>${item.rule_id}</a>`);
    })

    view.define("value", text.join("<br/>"));
    view.define("height", text.length * 24 + 2 * 12);
    view.refresh();
    view.resize();
};

UlrEditWebIpFilterRuleViewController.prototype.ShowHideValidationResult = function(Show)
{
    var view = this.Views.ValidationResultLabel;
    Show ? view.show() : view.hide();
};

UlrEditWebIpFilterRuleViewController.prototype.ShowServerError = function(ErrModel, Action)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};

UlrEditWebIpFilterRuleViewController.prototype.ImportFile = function ()
{
    var _this = this;

    var value = this.Views.ImportPopupEditor.getValue();

    if(!value)
        return;

    var lines = value.split(/\r|\n/);

    var firstLine = lines[0];

    var colsMap = {
        type_id: 0,
        resource_raw: 1,
        resource_validated: 2
    };

    if(firstLine.indexOf("type_id") >= 0 && firstLine.indexOf("resource_raw") >= 0 && firstLine.indexOf("resource_validated") >= 0 )
    {
        lines.shift();

        var headersIds = firstLine.split("\t");

        headersIds.forEach(function (Item, Index)
        {
            if(Item == "type_id" || Item == "resource_raw" || Item == "resource_validated")
                colsMap[Item] = Index;
        });
    }

    if(firstLine.indexOf(LangHelper.GetString("UlrModule","Type")) >= 0 && firstLine.indexOf(LangHelper.GetString("UlrModule","Resource raw")) >= 0 && firstLine.indexOf(LangHelper.GetString("UlrModule","Resource validated")) >= 0 )
    {
        lines.shift();

        var headersIds = firstLine.split("\t");

        headersIds.forEach(function (Item, Index)
        {
            if(Item == LangHelper.GetString("UlrModule","Type"))
                colsMap["type_id"] = Index;

            if(Item == LangHelper.GetString("UlrModule","Resource raw"))
                colsMap["resource_raw"] = Index;

            if(Item == LangHelper.GetString("UlrModule","Resource validated"))
                colsMap["resource_validated"] = Index;
        });
    }

    var item_types = [UlrWebRuleResourcesTypesMapEnum.cn, UlrWebRuleResourcesTypesMapEnum.sni, UlrWebRuleResourcesTypesMapEnum.url];
    var models = [];
    lines.forEach(function (Line)
    {
        var model = new UlrWebRuleResourceModel();

        var cols = Line.split("\t");

        if(cols.length > 1)
        {
            model.enabled = 1;
            model.resource_raw = (cols[colsMap.resource_raw] ? cols[colsMap.resource_raw] : "").trim();
            model.resource_validated = (cols[colsMap.resource_validated] ? cols[colsMap.resource_validated] : "").trim();

            model.type_id = cols[colsMap.type_id] ? cols[colsMap.type_id] : UlrWebRuleResourcesTypesMapEnum.url;
            model.type_id = model.type_id && isNaN(model.type_id) ? (UlrWebRuleResourcesTypesMapEnum[model.type_id.toLowerCase()] ? UlrWebRuleResourcesTypesMapEnum[model.type_id.toLowerCase()] : UlrWebRuleResourcesTypesMapEnum.url)  : model.type_id;

            if(model.resource_validated)
                model.state_valid = UlrStateValidEnum.valid;

            if(model.resource_raw && model.resource_validated && model.type_id)
                models.push(model);
        }
        else if(cols.length == 1)
        {
            var ports = [];

            if (AppEnv.UlrAddPortsToIpOnExport == 1)
            {
                ports = ['80', '443'];
            }

            // Разбор на порты для АР
            var splt = cols[0].split(":");
            if(splt.length == 1 || splt.length > 2)
            {
                splt = cols[0].split(" ");
            }

            var resource = splt[0];
            resource = resource.trim();

            if(splt.length > 1)
            {
                var port = splt[splt.length - 1];
                try{
                    var check = parseInt(port);

                    if(!check || isNaN(check))
                    {
                        throw new Error();
                    }

                    ports = [port];
                }
                catch (e)
                {
                    resource = cols[0].trim();
                }
            }

            if(Helper.ValidateIPaddressOrCidr(resource))
            {
                var add_row = function(row)
                {
                    var _model = webix.extend(webix.copy(model), {
                        enabled: 1,
                        resource_raw: row,
                        type_id: Helper.ValidateIPaddress(resource) ? UlrWebRuleResourcesTypesMapEnum.ip : UlrWebRuleResourcesTypesMapEnum.cidr
                    }, true);

                    models.push(_model);
                }

                if(Helper.ValidateIPv6Cidr(resource))
                {
                    add_row(resource);
                }
                else
                {
                    if(ports.length)
                    {
                        ports.forEach((Port) => {
                            const ipPort = resource + " " + Port;

                            add_row(ipPort);
                        });
                    }
                    else
                    {
                        add_row(resource);
                    }

                }
            }
            else if(resource)
            {
                resource = resource.replace("http://", "");
                resource = resource.replace("https://", "");

                if(resource.slice(-1) === '/')
                    resource = resource.slice(0, -1);

                // if(resource.slice(0, 4) === 'www.')
                //     resource = resource.slice(4);

                item_types.forEach((Type) => {
                    var _model = webix.extend(webix.copy(model), {
                        enabled: 1,
                        resource_raw: resource,
                        type_id: Type
                    }, true);

                    models.push(_model);
                });

                // Add URL with : at the end
                // #85642
                if(ports.length === 0 && resource.indexOf(':') === -1)
                {
                    var _model = webix.extend(webix.copy(model), {
                        enabled: 1,
                        resource_raw: resource + ":",
                        type_id: UlrWebRuleResourcesTypesMapEnum.url
                    }, true);

                    models.push(_model);
                }
            }
        }
    });

    if(models.length > 0)
    {
        _this.JustAddResource(models, true);
    }

    this.Views.ImportPopupEditor.setValue("");
};

UlrEditWebIpFilterRuleViewController.prototype.ShowImportForm = function(ImportType)
{
    var table = this.Views.ImportPopupTable.clearAll();

    this.Views.ImportPopupEditor.setValue("");

    this.ImportPopup.show();
};

UlrEditWebIpFilterRuleViewController.prototype.ShowRuleExportForm = function()
{
    this.ExportRulePopup.show();
};

UlrEditWebIpFilterRuleViewController.prototype.ExportRule = function()
{
    var _this = this;
    this.Views.ExportRuleBtn.disable();
    var exportType = this.Views.ExportRulePopupType.getValue();

    var params = {
        rule_id: this.GetPathParam("_id"),
        export_type: exportType,
        columns_header: [
            "",
            LangHelper.GetString("UlrModule","Date"),
            LangHelper.GetString("UlrModule","Type"),
            LangHelper.GetString("UlrModule","Resource validated"),
            LangHelper.GetString("UlrModule","Status"),
            LangHelper.GetString("UlrModule","Rule id"),
            LangHelper.GetString("UlrModule","Regulator"),
            LangHelper.GetString("UlrModule","Category"),
            LangHelper.GetString("UlrModule","Description public"),
            LangHelper.GetString("UlrModule","Description private")
        ],
        column_dics: {
            resources:{
                enabled: ControlTaskStatusesDic,
                type_id: App.DicsManager.GetDic(DicsEnum.UlrResourceTypesDic),
                state_valid: {
                    '0' : { id: '0', value : LangHelper.GetString("UlrModule", "No validation") } ,
                    '1' : { id: '1', value : LangHelper.GetString("UlrModule", "Invalid") } ,
                    '2' : { id: '2', value : LangHelper.GetString("UlrModule", "Valid") }
                }
            },
            rule: {
                category_id: App.DicsManager.GetDic(DicsEnum.UlrCategoriesDic),
                regulator_id: App.DicsManager.GetDic(DicsEnum.UlrRegulatorsDic)
            }
        }
    };

    this.ViewModel.GetWebIpRuleExportFileData(params, function (R)
    {
        _this.Views.ExportRuleBtn.enable();
    });
};

UlrEditWebIpFilterRuleViewController.prototype.OnFileAdded = function(FileObj)
{
    var _this = this;

    var model = {
        id: FileObj.id ? FileObj.id : webix.uid(),
        name: FileObj.name,
        size: FileObj.size,
        sizetext: FileObj.sizetext,
        state: UlrFilesStatusDic.new.id,
        uploadId: '',
        filepath: ''
    };

    this.ImportFilesArr.push(model);

    var modelIndex = this.ImportFilesArr.findIndex((Obj) => Obj.id == model.id);

    this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
    var path = "upload_files/";

    var fileName = webix.uid() + "_" + model.name;
    var result_fpath = path + fileName;

    var updateModelClosure = function(Model)
    {
        var modelIndex = _this.ImportFilesArr.findIndex((Obj) => Obj.id == Model.id);

        if(modelIndex > -1)
        {
            _this.ImportFilesArr[modelIndex] = Model;
            return true;
        }

        return false;
    };

    App.ServerManager.UlrGenerateFileUploadId({
        fileName: fileName,
        path: path,
        callback: function(R)
        {
            if(R.success && R.data)
            {
                var key = R.data.key ? R.data.key : webix.uid();

                model.uploadId = key;
                model.state = UlrFilesStatusDic.uploading.id;

                if(updateModelClosure(model))
                {
                    _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();

                    App.ServerManager.UploadFile({
                        key: key,
                        file: FileObj.file,
                        callback: function(R)
                        {
                            if(R.status != 200)
                            {
                                model.state = UlrFilesStatusDic.failed.id;
                            }
                            else
                            {
                                model.state = UlrFilesStatusDic.uploaded.id;
                                model.filepath = result_fpath;
                            }

                            if(updateModelClosure(model))
                            {
                                _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                                _this.ImportFilesArrUpdated();
                            }
                        }
                    });
                }

            }
            else if(R.error)
            {
                model.state = UlrFilesStatusDic.failed.id;
                if(updateModelClosure(model))
                {
                    _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                }
                _this.ShowServerError(R.error);
            }
        }
    });
};

UlrEditWebIpFilterRuleViewController.prototype.ImportFilesClick = function(Id)
{
    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.ImportedFilesReport.Views.Table;

        var item = table.getItem(Id);

        if(item)
        {
            const index = this.ImportFilesArr.findIndex(x => x.id == item.id);
            if(index > -1)
            {
                this.ImportFilesArr.splice(index, 1);
                this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                this.ImportFilesArrUpdated();

            }
        }

        table.remove(Id);
    }
};

UlrEditWebIpFilterRuleViewController.prototype.ImportFilesArrUpdated = function()
{
    var count = 0;
    this.ImportFilesArr.forEach((Item) => {
        if(Item.state == UlrFilesStatusDic.uploaded.id)
        {
            count++;
        }
    });

    this.Signals.ImportedFilesCountChange.next(count);
};

UlrEditWebIpFilterRuleViewController.prototype.DefineImportFilesBtnBadge = function(Count)
{
    var count = Count > 99 ? "99+" : Count;

    this.Views.FromFileImportBtn.define({badge: UlrButtonBadgeTemplate(count)});

    this.Views.FromFileImportBtn.refresh();
};

UlrEditWebIpFilterRuleViewController.prototype.GetImportTemplateFile = function(FormatList, FormatFile)
{
    const _this = this;

    _this.ViewModel.GetImportTemplateFile({
        FormatList: FormatList,
        FormatFile: FormatFile,
        callback: function(R)
        {
            if(R.success)
            {
                App.ServerManager.RedirectToFileDownload(R.data);
            }
            else
            {
                if(R.error)
                    webix.message({text: R.error.msg,type:"error"});
            }
        }
    })
};



function UlrAddWebIpFilterRuleViewController(Params)
{
    var params = webix.extend(Params,{
        action:"Add"
    },true);

    UlrAddWebIpFilterRuleViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrAddWebIpFilterRuleViewController,UlrEditWebIpFilterRuleViewController);
function UlrCheckDomainViewController(Params)
{
    var _this = this;

    this.Id = "UlrCheckDomain";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle: LangHelper.GetString("UlrModule", "Web filter"),
        Title: LangHelper.GetString("UlrModule", "Check domain")
    };

    this.ViewModel = new UlrCheckDomainManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        CheckDomainForm: null,
        CheckDomainInput: null,
        CheckDomainBtn: null,
        CertInfoBlock: null,
        DnsBlock: null,
        DnsRecursiveLabel: null,
        ResourceTypeLablel: null,
        ResourceTypeLablelLayout: null,

        ResultSslInformationBlock: null,
        ResultUrlInformationBlock:null,

        ExportPopupForm:null,
        ExportPopupTable:null,
        ExportPopupEditor:null,
        ExportPopupBtn:null,

        Widgets: {},
        ReportsWidgets: {
            CertInfoReport: UrlKeyValueTableWidget({
                id: this.Id + "CertInfoReport",
                enableTextSearch: 0,
                enableAutoHeight: 1,
                hidePaginatorToolbar: 1,
                enableLocalSort: 0

            }),
            DnsReport: UrlDomainDNSPartTableWidget({
                id: this.Id + "DnsReport",
                enableTextSearch: 0,
                enableAutoHeight: 1,
                hidePaginatorToolbar: 1,
                enableLocalSort: 1
            }),
            CnSniReport: UrlKeyValueTableWidget({
                id: this.Id + "CnSniReport",
                enableTextSearch: 0,
                enableAutoHeight: 1,
                hidePaginatorToolbar: 1,
                enableLocalSort: 0
            })
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            id:this.Id + "ScrollView",
            scroll: "y",
            body: {
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless: true,
                        rows:
                            [
                                {height: 6},
                                PageHeaderTemplate({id:this.Id + "PageTitle", root_title: this.PageTitle.Title}),
                                {height: 32},
                                {
                                    view: "form",
                                    id: this.Id + "CheckDomainForm",
                                    type: "wide",
                                    elements: [
                                        {
                                            type: "clean",
                                            rows: [
                                                {
                                                    view: "label",
                                                    css: "form_text_label",
                                                    label: LangHelper.GetString("UlrModule", "Enter IP or URL with <b>http/https</b> prefix to check resource create correct rule")
                                                },
                                                {
                                                    type: "wide",
                                                    cols: [
                                                        {
                                                            view: "spectre_text",
                                                            id: this.Id + "CheckDomainInput",
                                                            name: "checkdomain_raw",
                                                            label: LangHelper.GetString("UlrModule", "Resource check"),
                                                            keyPressTimeout: 300,
                                                            on:{
                                                                onEnter:function(ev)
                                                                {
                                                                    setTimeout(function ()
                                                                    {
                                                                        _this.CheckDomain();
                                                                    },1);
                                                                }
                                                            }
                                                        },
                                                        {
                                                            type: "wide",
                                                            cols: [
                                                                {
                                                                    rows: [
                                                                        {},
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "CheckDomainBtn",
                                                                            css: "form_button form_element main_action",
                                                                            label: LangHelper.GetString("UlrModule", "Check"),
                                                                            height: 51,
                                                                            disabled: true,
                                                                            autowidth: true,
                                                                            click: function () {
                                                                                setTimeout(function () {
                                                                                    _this.CheckDomain();
                                                                                }, 1);
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: this.Id + "ResourceTypeLablelLayout",
                                    hidden: true,
                                    type: "clean",
                                    rows: [
                                        {
                                            height: 20
                                        },
                                        {
                                            id: this.Id + "ResourceTypeLablel",
                                            view: "label",
                                            css: "form_text_label",
                                            isSsl:0,
                                            template: function (Obj)
                                            {
                                                var tpl = "";

                                                tpl += Obj.isSsl ? "<span class='fa fa-shield-check check-domain-page__check-icon'></span>" : "";

                                                //tpl += LangHelper.GetString("UlrModule", "This is <span class='blue-color'>" + (Obj.isSsl ? "SSL/TLS" : "HTTP") + "</span> resource.") + " ";

                                                tpl += LangHelper.GetString("UlrModule", "This is {TYPE} resource.").replace("{TYPE}", "<span class='blue-color'>" + (Obj.isSsl ? "SSL/TLS" : "HTTP") + "</span>") + " ";

                                                //tpl += LangHelper.GetString("UlrModule", "Type of block is <span class='blue-color'>" + (Obj.isSsl ? "FULL DOMAIN" : "URL") + "</span>!");

                                                tpl += LangHelper.GetString("UlrModule", "Type of block is {TYPE}!").replace("{TYPE}", "<span class='blue-color'>" + (Obj.isSsl ? "FULL DOMAIN" : "URL") + "</span>");

                                                return tpl;

                                            }
                                        }
                                    ]
                                },
                                {
                                    height: 32
                                },
                                {
                                    type: "wide",
                                    id: this.Id + "CertInfoBlock",
                                    hidden: true,
                                    borderless:true,
                                    rows: [
                                        BlockHeaderTemplate({
                                            title: LangHelper.GetString("UlrModule", "Certificate general information"),
                                            icon: "",
                                            borderless: true
                                        }),
                                        this.Views.ReportsWidgets.CertInfoReport.ViewConfig,
                                        {height:20}
                                        //,
                                        // {
                                        //     height: 48
                                        // },
                                        // {
                                        //     type: "wide",
                                        //     rows: [
                                        //         {
                                        //             view: "accordion",
                                        //             type: "wide",
                                        //             multi: false,
                                        //             rows: [
                                        //                 {
                                        //                     header: LangHelper.GetString("UlrModule", "Show OpenSSL handshake"),
                                        //                     body: {
                                        //                         rows: [
                                        //                             {
                                        //                                 //height:260,
                                        //                                 autoheight: true,
                                        //                                 template: "content"
                                        //                             }
                                        //                         ]
                                        //                     }
                                        //                 },
                                        //                 {}
                                        //             ]
                                        //         }
                                        //     ]
                                        // }
                                    ]
                                },
                                {
                                    type: "wide",
                                    id: this.Id + "DnsBlock",
                                    hidden: true,
                                    borderless:true,
                                    rows: [
                                        BlockHeaderTemplate({
                                            title: LangHelper.GetString("UlrModule", "DNS info"),
                                            icon: "",
                                            borderless: true
                                        }),
                                        {
                                            type:"line",
                                            rows:[
                                                this.Views.ReportsWidgets.DnsReport.ViewConfig,
                                                {
                                                    view: "label",
                                                    id: this.Id + "DnsRecursiveLabel",
                                                    css: "form_element form_text_label",
                                                    label: "",
                                                    template:LangHelper.GetString("UlrModule", "DNS recursion") + ": " + "#label#"
                                                }
                                            ]
                                        },
                                        {height:20}

                                    ]
                                },
                                {
                                    id: this.Id + "ResultSslInformationBlock",
                                    hidden: true,
                                    rows: [
                                        BlockHeaderTemplate({
                                            title: LangHelper.GetString("UlrModule", "Result information"),
                                            icon: "",
                                            borderless: true
                                        }),
                                        {
                                            height:20
                                        },
                                        {
                                            view:"form",
                                            type:"wide",
                                            elements:[
                                                {
                                                    type:"clean",
                                                    rows:[
                                                        {
                                                            height:14
                                                        },
                                                        {
                                                            type:'wide',
                                                            rows:[
                                                                {
                                                                    view: "label",
                                                                    css: "form_text_label form_sub_header_label",
                                                                    label: "<span class='circle-badget'>1</span>" + LangHelper.GetString("UlrModule", "To block this resource only with certificate use")
                                                                },
                                                                this.Views.ReportsWidgets.CnSniReport.ViewConfig,
                                                                {
                                                                    view: "label",
                                                                    label: LangHelper.GetString("UlrModule", "Download file to import to rule") + ":",
                                                                    height:20
                                                                },
                                                                {
                                                                    type: "clean",
                                                                    cols: [
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "SslDownloadFirstFile",
                                                                            type: "icon",
                                                                            css: "form_button spec_action with_icon",
                                                                            label: LangHelper.GetString("UlrModule", "Download file 1"),
                                                                            icon: "arrow-to-bottom",
                                                                            autowidth: true,
                                                                            click:function ()
                                                                            {
                                                                                _this.ShowExportForm(_this.ExportsTypesEnum.Cn);
                                                                            }
                                                                        },
                                                                        {}
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            height:20
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            view: "form",
                                            type: "wide",
                                            elements: [
                                                {
                                                    type: "clean",
                                                    rows: [
                                                        {
                                                            height:14
                                                        },
                                                        {
                                                            type:"wide",
                                                            rows:[
                                                                {
                                                                    view: "label",
                                                                    css: "form_text_label form_sub_header_label",
                                                                    label: "<span class='circle-badget'>2</span>" + LangHelper.GetString("UlrModule", "To block this resource with certificate + all IPs use")
                                                                },
                                                                {
                                                                    view: "label",
                                                                    label: LangHelper.GetString("UlrModule", "Download file to import to rule") + ":",
                                                                    height:20

                                                                },
                                                                {
                                                                    type: "clean",
                                                                    cols: [
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "SslDownloadSecondtFile",
                                                                            type: "icon",
                                                                            css: "form_button spec_action with_icon",
                                                                            label: LangHelper.GetString("UlrModule", "Download file 2"),
                                                                            icon: "arrow-to-bottom",
                                                                            autowidth: true,
                                                                            click:function ()
                                                                            {
                                                                                _this.ShowExportForm(_this.ExportsTypesEnum.CnIps);
                                                                            }
                                                                        },
                                                                        {}
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            height:20
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            view: "form",
                                            type: "wide",
                                            elements: [
                                                {
                                                    height:0
                                                }
                                            ]
                                        }
                                    ]

                                },
                                {
                                    id: this.Id + "ResultUrlInformationBlock",
                                    hidden: true,
                                    rows: [
                                        BlockHeaderTemplate({
                                            title: LangHelper.GetString("UlrModule", "Result information"),
                                            icon: "",
                                            borderless: true
                                        }),
                                        {
                                            height:20
                                        },
                                        {
                                            view:"form",
                                            type:"wide",
                                            elements:[
                                                {
                                                    type:"clean",
                                                    rows:[
                                                        {
                                                            height:14
                                                        },
                                                        {
                                                            type:'wide',
                                                            rows:[
                                                                {
                                                                    view: "label",
                                                                    css: "form_text_label form_sub_header_label",
                                                                    label: "<span class='circle-badget'>1</span>" + LangHelper.GetString("UlrModule", "To block this resource only with URL use")
                                                                },
                                                                {
                                                                    view: "label",
                                                                    label: "Download file to import to rule:",
                                                                    height:20
                                                                },
                                                                {
                                                                    type: "clean",
                                                                    cols: [
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "UrlDownloadFirstFile",
                                                                            type: "icon",
                                                                            css: "form_button spec_action with_icon",
                                                                            label: LangHelper.GetString("UlrModule", "Download file 1"),
                                                                            icon: "arrow-to-bottom",
                                                                            autowidth: true,
                                                                            click:function ()
                                                                            {
                                                                                _this.ShowExportForm(_this.ExportsTypesEnum.Url);
                                                                            }
                                                                        },
                                                                        {}
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            height:20
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            view: "form",
                                            type: "wide",
                                            elements: [
                                                {
                                                    type: "clean",
                                                    rows: [
                                                        {
                                                            height:14
                                                        },
                                                        {
                                                            type:"wide",
                                                            rows:[
                                                                {
                                                                    view: "label",
                                                                    css: "form_text_label form_sub_header_label",
                                                                    label: "<span class='circle-badget'>2</span>" + LangHelper.GetString("UlrModule", "To block this resource with URL + all IPs use")
                                                                },
                                                                {
                                                                    view: "label",
                                                                    label: LangHelper.GetString("UlrModule", "Download file to import to rule") + ":",
                                                                    height:20

                                                                },
                                                                {
                                                                    type: "clean",
                                                                    cols: [
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "UrlDownloadSecondtFile",
                                                                            type: "icon",
                                                                            css: "form_button spec_action with_icon",
                                                                            label: LangHelper.GetString("UlrModule", "Download file 2"),
                                                                            icon: "arrow-to-bottom",
                                                                            autowidth: true,
                                                                            click:function ()
                                                                            {
                                                                                _this.ShowExportForm(_this.ExportsTypesEnum.UrlIps);
                                                                            }
                                                                        },
                                                                        {}
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            height:20
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            view: "form",
                                            type: "wide",
                                            elements: [
                                                {
                                                    height:0
                                                }
                                            ]
                                        }
                                    ]

                                }
                            ]
                    }
                ]
            }
        }
    ];

    this.ExportsTypesEnum = {
        Cn:"Cn",
        CnIps:"CnIps",
        Url:"Url",
        UrlIps:"UrlIps"
    };

    this.ExportPopup = null;

    this.ExportPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ExportPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Export results"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.ExportPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ExportPopupForm",
                            type: "wide",
                            minWidth:560,
                            minHeight:400,
                            elements: [
                                {
                                    view:"datatable",
                                    id: this.Id + "ExportPopupTable",
                                    header:false,
                                    hidden:true,
                                    columns:[
                                        {
                                            id:"type_id"
                                        },
                                        {
                                            id:"resource_raw"
                                        },
                                        {
                                            id:"resource_validated"
                                        }
                                    ]
                                },
                                {
                                    view:"spectre_textarea",
                                    id:this.Id + "ExportPopupEditor",
                                    label:LangHelper.GetString("UlrModule","Export content"),
                                    height:undefined,
                                    value:""
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ExportPopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Export"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ExportFile();
                                            _this.ExportPopup.hide();
                                        },1);

                                    }
                                },
                                // {
                                //     view:"spectre_button",
                                //     id:this.Id + "ExportPopupCopyBtn",
                                //     css:"form_button spec_action",
                                //     label:LangHelper.GetString("UlrModule","Copy to clipboard"),
                                //     autowidth:true,
                                //     click:function ()
                                //     {
                                //         var copyText = _this.Views.ExportPopupEditor.getInputNode();
                                //         copyText.select();
                                //         document.execCommand("copy");
                                //
                                //         _this.ExportPopup.hide();
                                //     }
                                // },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.Subscriptions = {};

    this.Signals =
    {
        CheckDomainInputValue: new Rx.BehaviorSubject(null),
        CheckDomainInputValid: new Rx.BehaviorSubject(0),
        CheckDomainInputLastChecked: new Rx.BehaviorSubject(null)
    };
}

UlrCheckDomainViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.ExportPopup = webix.ui(this.ExportPopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.CheckDomainInput.attachEvent("onChange", function (Nv, Ov)
    {
        var _Nv = Nv.trim().replace(/\s/g, '');

        if(Nv != _Nv)
        {
            this.setValue(_Nv);
            return;
        }

        _this.Signals.CheckDomainInputValue.next(Nv);
    });

    this.Views.CheckDomainInput.attachEvent("onTimedKeyPress", function ()
    {
        var v = _this.Views.CheckDomainInput.getValue();

        var _v = v.trim().replace(/\s/g, '');

        if(v != _v)
        {
            this.setValue(_v);
            return;
        }

        _this.Signals.CheckDomainInputValue.next(v);
    });

    this.Subscriptions.CheckDomainInputValue = this.Signals.CheckDomainInputValue.subscribe(function (Value)
    {
        if(Value && (Helper.IsUrlValid(Value) || Helper.UlrValidateCidr(Value)) || Helper.ValidateIPaddressPlusPort(Value))
            _this.Signals.CheckDomainInputValid.next(1);
        else
            _this.Signals.CheckDomainInputValid.next(0);

    });

    this.Subscriptions.CheckBtn = Rx.Observable.combineLatest
    (
        this.Signals.CheckDomainInputValid,
        this.ViewModel.Signals.Progress
    ).subscribe(function (Signal)
    {
        var Valid = Signal[0];
        var InProgress = Signal[1];

        var view = _this.Views.CheckDomainBtn;
        InProgress || !Valid ? view.disable() : view.enable();
    });

    this.Subscriptions.CheckResultUpdated = this.ViewModel.Signals.CheckResultUpdated.subscribe(function (CheckDomainModel)
    {
        if(CheckDomainModel)
            _this.DefineAll(CheckDomainModel);
    });

    this.Subscriptions.CheckResultError = this.ViewModel.Signals.CheckResultError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });
};

UlrCheckDomainViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;
    this.BindAll(Params);
};

UlrCheckDomainViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key) {
        if (_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget) {
        var w = _this.Views.Widgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget) {
        var w = _this.Views.ReportsWidgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    if (this.ViewModel) {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if (this.ReportsModel) {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrCheckDomainViewController.prototype.GetPageTitle = function () {
    if (this.PageTitle)
        return this.PageTitle;
};

UlrCheckDomainViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrCheckDomainViewController.prototype.CheckDomain = function ()
{
    var resource = this.Views.CheckDomainInput.getValue();

    var valid = this.Signals.CheckDomainInputValid.getValue();

    if(!resource || !valid)
        return;

    this.Signals.CheckDomainInputLastChecked.next(resource);

    this.ViewModel.GetDomainInfo({resource:resource});
};

UlrCheckDomainViewController.prototype.DefineAll = function (CheckDomainModel)
{
    if(CheckDomainModel.resource_raw != this.Signals.CheckDomainInputLastChecked.getValue())
        return;

    !CheckDomainModel.valid ? this.ShowError() : null;

    var view = this.Views.ResourceTypeLablelLayout;
    CheckDomainModel.valid ? view.show() : view.hide();

    var view = this.Views.ResourceTypeLablel;
    view.define("isSsl", CheckDomainModel.ssl ? 1 : 0);
    view.refresh();

    var view = this.Views.CertInfoBlock;
    CheckDomainModel.ssl ? view.show() : view.hide();

    var view = this.Views.ResultSslInformationBlock;
    CheckDomainModel.ssl && CheckDomainModel.valid ? view.show() : view.hide();

    var view = this.Views.ResultUrlInformationBlock;
    !CheckDomainModel.ssl && CheckDomainModel.valid ? view.show() : view.hide();

    this.DefineCommonCertificateInfo(CheckDomainModel);

    this.DefineDns(CheckDomainModel.dns_part, CheckDomainModel.dns_recursive);

    this.DefineCn(CheckDomainModel);
};

UlrCheckDomainViewController.prototype.DefineCommonCertificateInfo = function (CheckDomainModel)
{
    var rows = [];

    var data = CheckDomainModel;

    // Common name
    if (data.cn && data.cn.value) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "Common name"),
            value: data.cn.value,
            $css:"group border-solid"
        });
    }
    // SANs
    if (data.sans && data.sans.length > 0) {
        // SANs title
        rows.push({
            key: LangHelper.GetString("UlrModule", "SANs"),
            value: "",
            $css:"group"
        });
        // SANs items
        data.sans.forEach(function (sans_item) {
            rows.push({
                key: LangHelper.GetString("UlrModule", sans_item.type || ''),
                value: sans_item.val || ''
            });
        });
        // SANs total
        rows.push({
            key: LangHelper.GetString("UlrModule", "Total number of SANs"),
            value: data.sans.length,
            $css:"border-solid"
        })
    }
    // SSL
    rows.push({
        key: LangHelper.GetString("UlrModule", "SSL"),
        value: '',
        $css:"group"
    });
    if (data.algorithm) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "Signature algorithm"),
            value: data.algorithm
        })
    }
    if (data.key_type) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "Key type"),
            value: data.key_type
        })
    }
    if (data.key_size) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "Key size"),
            value: data.key_size + " bits"
        })
    }
    if (data.serial_number) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "Serial Number"),
            value: data.serial_number
        })
    }
    if (data.not_before) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "Not Before"),
            value: CellSpectreDateTemplate(data.not_before)
        })
    }
    if (data.not_after) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "Not After"),
            value: CellSpectreDateTemplate(data.not_after)
        })
    }
    if (data.cert_num) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "Number of certs"),
            value: data.cert_num
        })
    }


    this.Views.ReportsWidgets.CertInfoReport.Views.Table.clearAll();
    this.Views.ReportsWidgets.CertInfoReport.Views.Table.parse(rows);
};

UlrCheckDomainViewController.prototype.DefineDns = function (DnsArrModel, Recursive)
{
    var view = this.Views.DnsBlock;
    DnsArrModel && DnsArrModel.length ? view.show() : view.hide();

    this.Views.ReportsWidgets.DnsReport.Views.Table.clearAll();
    this.Views.ReportsWidgets.DnsReport.Views.Table.parse(DnsArrModel ? DnsArrModel : []);

    this.Views.DnsRecursiveLabel.define("label", Recursive ? LangHelper.GetString("UlrModule", "Yes") : LangHelper.GetString("UlrModule", "No"));
    this.Views.DnsRecursiveLabel.refresh();
};

UlrCheckDomainViewController.prototype.DefineCn = function (CheckDomainModel)
{
    var rows = [];

    var data = CheckDomainModel;

    if (data.cns && data.cns.length)
    {
        data.cns.forEach(function (Item)
        {
            rows.push({
                key: LangHelper.GetString("UlrModule", "CN"),
                value: Item.value,
                type_id:UlrWebRuleResourcesTypesEnum.cn
            });
        });
    }
    else if (data.cn && data.cn.value) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "CN"),
            value: data.cn.value,
            type_id:UlrWebRuleResourcesTypesEnum.cn
        });
    }

    if (data.snis && data.snis.length)
    {
        data.snis.forEach(function (Item)
        {
            rows.push({
                key: LangHelper.GetString("UlrModule", "SNI"),
                value: Item.value,
                type_id:UlrWebRuleResourcesTypesEnum.sni
            });
        });
    }
    else if (data.sni && data.sni.value) {
        rows.push({
            key: LangHelper.GetString("UlrModule", "SNI"),
            value: data.sni.value,
            type_id:UlrWebRuleResourcesTypesEnum.sni
        });
    }

    this.Views.ReportsWidgets.CnSniReport.Views.Table.clearAll();
    this.Views.ReportsWidgets.CnSniReport.Views.Table.parse(rows);
};

UlrCheckDomainViewController.prototype.ShowError = function ()
{
    UlrShowAlertWindow({
        head: LangHelper.GetString("UlrModule", "Error"),
        type: "spectre-alert-error",
        mainTitle: LangHelper.GetString("UlrModule", "Validation error"),
        message: LangHelper.GetString("UlrModule", "Domain is not accessible or not valid"),
        actions: [
            {
                label: LangHelper.GetString("UlrModule", "Ok"),
                click: function () {

                }
            }
        ]
    });
};

UlrCheckDomainViewController.prototype.GetCnSniExportData = function ()
{
    var arr = [];

    var data = this.Views.ReportsWidgets.CnSniReport.Views.Table.serialize();

    if(data && Array.isArray(data) && data.length)
    {
        var resource_raw = this.Signals.CheckDomainInputLastChecked.getValue();

        data.forEach(function (Item)
        {
            arr.push(new UlrWebRuleResourceModel(
                {
                    enabled:1,
                    resource_raw: resource_raw,
                    resource_validated:Item.value,
                    type_id: Item.type_id
                }
            ));
        });
    }

    return arr;
};

UlrCheckDomainViewController.prototype.GetIpsExportData = function ()
{
    var arr = [];

    var data = this.Views.ReportsWidgets.DnsReport.Views.Table.serialize();

    if(data && Array.isArray(data) && data.length)
    {
        var resource_raw = this.Signals.CheckDomainInputLastChecked.getValue();

        data.forEach(function (Item)
        {
            if(Item.type == "A" || Item.type == "AAAA")
            {
                arr.push(new UlrWebRuleResourceModel(
                    {
                        enabled:1,
                        resource_raw: resource_raw,
                        resource_validated:Item.addr,
                        type_id: UlrWebRuleResourcesTypesEnum.ip
                    }
                ));
            }

        });
    }

    return arr;
};

UlrCheckDomainViewController.prototype.GetUrlExportData = function ()
{
    var arr = [];

    var resource_raw = this.Signals.CheckDomainInputLastChecked.getValue();

    var model = this.ViewModel.Signals.CheckResultUpdated.getValue();

    var valid = model && model.valid && !model.ssl ? 1 : 0;

    if(resource_raw)
    {
        arr.push(new UlrWebRuleResourceModel(
            {
                enabled:1,
                resource_raw: resource_raw,
                resource_validated:valid ? model.host : "",
                type_id: UlrWebRuleResourcesTypesEnum.url
            }
        ));
    }

    return arr;
};

UlrCheckDomainViewController.prototype.ExportFile = function ()
{
    var table = this.Views.ExportPopupTable;

    webix.toCSV(table, {footer:false});
};

UlrCheckDomainViewController.prototype.ShowExportForm = function(ExportType)
{
    var _this = this;

    var data = [];

    if(ExportType == this.ExportsTypesEnum.Cn || ExportType == this.ExportsTypesEnum.CnIps)
    {
        data = data.concat(this.GetCnSniExportData());
    }

    if(ExportType == this.ExportsTypesEnum.Url || ExportType == this.ExportsTypesEnum.UrlIps)
    {
        data = data.concat(this.GetUrlExportData());
    }

    if(ExportType == this.ExportsTypesEnum.CnIps || ExportType == this.ExportsTypesEnum.UrlIps)
    {
        data = data.concat(this.GetIpsExportData());
    }

    var table = this.Views.ExportPopupTable;

    table.clearAll();
    table.parse(data);

    webix.toCSV(table, {download:false, footer:false}).then(function(Blob)
    {
        var reader = new FileReader();

        reader.onload = function(e)
        {
            _this.Views.ExportPopupEditor.setValue(reader.result);
        };

        reader.readAsText(Blob, "utf-8");

    });

    this.ExportPopup.show();
};

function UlrExcludedResourcesViewController(Params)
{
    var _this = this;

    this.Id = "UlrExcludedResources";

    this.PathParams = {};

    this.PageTitle = {
        RootTitle: LangHelper.GetString("UlrModule", "Web filter"),
        Title: LangHelper.GetString("UlrModule","Exclusion list"),
    };

    this.ViewModel = new UlrExcludedResourcesManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        PageTitle: null,

        ToolsSubmenu:null,

        Widgets: {
            AddResourceForm: new UlrAddResourceFormWidget({
                id: this.Id + "AddResourceForm",
                rule_type: UlrRulesTypesCodesEnum.excluded_resources
            })
        },
        ReportsWidgets: {
            ExcludedResourcesTable: new UrlWebRulesResourcesTableWidget({
                id: this.Id + "ExcludedResourcesTable",
                method: "UlrGetExcludedResourcesList",
                enableTextSearch:1,
                enableAutoHeight:1,
                defaultPageSize: -10,
                hidePaginatorToolbar:0,
                enableLocalSort:0,
                enableCheckboxRefresh:0,
                onItemClick:function (Id) {
                    _this.ExcludedResourcesTableOnClick(Id);
                },
                onExport: function(FileName, Type, Callback)
                {
                    _this.ExportList(FileName, Type, Callback);
                },
                addCols: [
                    {
                        start: 0,
                        deleteCount: 0,
                        item: {
                                id:"checked",
                                header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"cm1"}],
                                template: CellColoredCheckBoxTemplate,
                                width:40
                            }
                    }
                ]
            })
        }
    };

    this.ToolsSubmenu = webix.ui({
        view: "submenu",
        id: _this.Id + "ToolsSubmenu",
        autowidth: true,
        padding: 0,
        data: [
            {
                id: _this.Id + "ToolsSubmenu" + "ExcludedResourcesEnable", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Enable"),
                submenu:[
                    {
                        id: _this.Id + "ToolsSubmenu" + "EnableSelectedExcludedResources",
                        icon: "lightbulb green",
                        value: LangHelper.GetString("UlrModule", "Enable selected resources"),
                    },
                    {
                        id: _this.Id + "ToolsSubmenu" + "DisableSelectedExcludedResources",
                        icon: "lightbulb red",
                        value: LangHelper.GetString("UlrModule", "Disable selected resources")
                    },
                ]
            },
            {
                id: _this.Id + "ToolsSubmenu" + "ExcludedResourcesDelete", icon: "trash", value: LangHelper.GetString("UlrModule", "Delete"),
                submenu:[
                    {
                        id: _this.Id + "ToolsSubmenu" + "DeleteSelectedExcludedResources",
                        icon: "trash",
                        value: LangHelper.GetString("UlrModule", "Delete selected resources")
                    },
                    {
                        id: _this.Id + "ToolsSubmenu" + "DeleteAllExcludedResources",
                        icon: "trash",
                        value: `<strong>${LangHelper.GetString("UlrModule", "Delete all resources")}</strong>`,
                    }
                ]
            }
        ],
        on: {
            onMenuItemClick: function (Id)
            {
                let table = _this.Views.ReportsWidgets.ExcludedResourcesTable.Views.Table;
                let selectedRows = [];
                let getData = _this.Views.ReportsWidgets.ExcludedResourcesTable.GetSelectedData();

                if(Array.isArray(getData))
                {
                    selectedRows = getData;
                }
                else if(typeof getData === "object")
                {
                    selectedRows.push(getData)
                }

                if(selectedRows.length > 0)
                {

                }

                switch (Id)
                {
                    case _this.Id + "ToolsSubmenu" + "EnableSelectedExcludedResources":
                        for(let item of selectedRows)
                        {
                            if(item && item.enabled == 0)
                            {
                                item.enabled = 1;
                                _this.ViewModel.UpdateResource(item);
                            }
                        }
                        break;
                    case _this.Id + "ToolsSubmenu" + "DisableSelectedExcludedResources":
                        for(let item of selectedRows)
                        {
                            if(item && item.enabled == 1)
                            {
                                item.enabled = 0;
                                _this.ViewModel.UpdateResource(item);
                            }
                        }
                        break;
                    case _this.Id + "ToolsSubmenu" + "DeleteSelectedExcludedResources":
                        for(let item of selectedRows)
                        {
                            if(item)
                            {
                                _this.ViewModel.DeleteResource({
                                    data:item,
                                    callback: () => {
                                        table.remove(item.id);
                                    }
                                });
                            }
                        }
                        break;
                    case _this.Id + "ToolsSubmenu" + "DeleteAllExcludedResources":
                        _this.Views.ToolsSubmenu.hide();
                        UlrShowAlertWindow({
                            position:"bottom",
                            head:LangHelper.GetString("UlrModule","Clear exclusion list"),
                            mainTitle:LangHelper.GetString("UlrModule","Delete all resources") + "?",
                            message:LangHelper.GetString("UlrModule","Are you sure?"),
                            actions:[
                                {
                                    css:"spec_action",
                                    label:LangHelper.GetString("UlrModule","Cancel")
                                },
                                {
                                    label:LangHelper.GetString("UlrModule","Delete"),
                                    click:function ()
                                    {
                                        _this.ViewModel.DeleteAllResources();
                                    }
                                }
                            ]
                        });
                        break;
                }
            }
        }
    });

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type:"space",
                rows:[
                    {
                        type: "clean",
                        borderless:true,
                        rows:[
                            {height:6},
                            PageHeaderTemplate({id:this.Id + "PageTitle", root_title:this.PageTitle.Title}),
                            {height:32},
                            {
                                view:"template",
                                borderless:false,
                                border:2,
                                css:"form_text_warning_label",
                                autoheight: true,
                                template: (
                                    LangHelper.GetString("UlrModule", "The web filter exclusion list prevents important resources from being accidentally blocked when blocking lists are automatically imported.") + "<br/>" +
                                    LangHelper.GetString("UlrModule", "Exclusions affect the Web filter and Spoof DNS sections.") + "<br/>&nbsp;"
                                )
                            },
                            {height:48},
                            this.Views.Widgets.AddResourceForm.ViewConfig,
                            {
                                type:"wide",
                                rows:[
                                    {
                                        type: "wide",
                                        cols: [
                                            {},
                                            {
                                                view: "spectre_button",
                                                id: this.Id + "ToolsBtn",
                                                type: "icon",
                                                css: "form_button spec_action with_icon",
                                                label: LangHelper.GetString("UlrModule", "Tools"),
                                                icon: "tools",
                                                autowidth: true,
                                                click: function () {
                                                    _this.Views.ToolsSubmenu.show(this.getNode());
                                                }
                                            }
                                        ]
                                    },
                                    this.Views.ReportsWidgets.ExcludedResourcesTable.ViewConfig,
                                ]
                            },
                            {height:32},
                        ]
                    },
                ]
            }
        }
    ];

    this.Subscriptions = {};
};

UlrExcludedResourcesViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.SaveResources = this.Views.Widgets.AddResourceForm.Signals.SaveResources.subscribe(function (Resources)
    {
        if(Resources && Resources.length)
        {
            _this.ViewModel.SaveResources(Resources);
        }
    })

    this.Subscriptions.UpdateExcludedResourceSuccess = this.ViewModel.Signals.UpdateExcludedResourceSuccess.subscribe(function (Update)
    {
        if (Update)
        {
            _this.Views.ReportsWidgets.ExcludedResourcesTable.Views.Table.refresh()
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Success"),
                LangHelper.GetString("UlrModule","Selected resource successfully updated."),
            );
        }
    });

    this.Subscriptions.UpdateExcludedResourceError = this.ViewModel.Signals.UpdateExcludedResourceError.subscribe(function (Update)
    {
        if (Update)
        {
            _this.Views.ReportsWidgets.ExcludedResourcesTable.RefreshData();
            UlrShowMessage(
                "error",
                LangHelper.GetString("UlrModule","Error"),
                LangHelper.GetString("UlrModule","Selected resource not updated."),
            );
        }
    });

    this.Subscriptions.DeleteExcludedResourceSuccess = this.ViewModel.Signals.DeleteExcludedResourceSuccess.subscribe(function (Update)
    {
        if (Update)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Success"),
                LangHelper.GetString("UlrModule","Selected resource successfully deleted."),
            );
        }
    });

    this.Subscriptions.DeleteExcludedResourceError = this.ViewModel.Signals.DeleteExcludedResourceError.subscribe(function (Update)
    {
        if (Update)
        {
            _this.Views.ReportsWidgets.ExcludedResourcesTable.RefreshData();
            UlrShowMessage(
                "error",
                LangHelper.GetString("UlrModule","Error"),
                LangHelper.GetString("UlrModule","Selected resource not deleted."),
            );
        }
    });

    this.Subscriptions.DeleteExcludedResourceSuccess = this.ViewModel.Signals.DeleteAllExcludedResourceSuccess.subscribe(function (Update)
    {
        if (Update)
        {
            _this.Views.ReportsWidgets.ExcludedResourcesTable.RefreshData();
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Success"),
                LangHelper.GetString("UlrModule","All resources successfully deleted."),
            );
        }
    });

    this.Subscriptions.DeleteExcludedResourceError = this.ViewModel.Signals.DeleteAllExcludedResourceError.subscribe(function (Update)
    {
        if (Update)
        {
            _this.Views.ReportsWidgets.ExcludedResourcesTable.RefreshData();
            UlrShowMessage(
                "error",
                LangHelper.GetString("UlrModule","Error"),
                LangHelper.GetString("UlrModule","Resources not deleted."),
            );
        }
    });

    this.Subscriptions.SaveResourcesFromFiles = this.Views.Widgets.AddResourceForm.Signals.AddResourcesFromFiles.subscribe(function (Files)
    {
        if(Files && Files.length)
        {
            _this.ViewModel.SaveResourcesFromFiles(Files);
        }
    });

    this.Subscriptions.GetExcludedResourcesRuleSuccess = this.ViewModel.Signals.ParseImportFileDone.subscribe(function (Update)
    {
        if(Update)
        {
            _this.Views.Widgets.AddResourceForm.DeleteUploadedResourcesFiles();
            _this.Views.Widgets.AddResourceForm.RefreshImportResourcesFiles();
            _this.Views.Widgets.AddResourceForm.ImportResourcesFilePopupHide();
            _this.Views.ReportsWidgets.ExcludedResourcesTable.RefreshData();
        }
    });

    this.Subscriptions.GetExcludedResourcesRuleSuccess = this.ViewModel.Signals.ParseImportFileError.subscribe(function (FileModel)
    {
        if(FileModel)
        {
            _this.Views.Widgets.AddResourceForm.SetErrorStateImportResourceFile(FileModel)
        }
    });

    this.Subscriptions.SaveJustAddedExcludedResources = this.ViewModel.Signals.SaveExcludedResourcesSuccess.subscribe(function (Update)
    {
        if (Update)
        {
            _this.Views.Widgets.AddResourceForm.JustAddedResources = [];
            _this.Views.Widgets.AddResourceForm.RefreshJustAddedResources();
            _this.Views.ReportsWidgets.ExcludedResourcesTable.RefreshData();

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Success"),
                LangHelper.GetString("UlrModule","Resources added to exclusion list."),
            );
        }
    });

    this.Subscriptions.SaveExcludedResourcesError = this.ViewModel.Signals.SaveExcludedResourcesError.subscribe(function (Update) {

        if(Update)
        {
            UlrShowMessage(
                "error",
                LangHelper.GetString("UlrModule","Error"),
                LangHelper.GetString("UlrModule","The selected resources are not saved.")
            );
        }
    })

    this.Subscriptions.ServerError = this.ViewModel.Signals.ServerError.subscribe(function (ErrModel)
    {
        if (ErrModel)
        {
            UlrShowAlertWindow({
                head:LangHelper.GetString("UlrModule","Error"),
                type:"spectre-alert-error",
                mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
                message:LangHelper.GetString("UlrModule",ErrModel.msg),
                actions:[
                    {
                        label:LangHelper.GetString("UlrModule","Ok"),
                        click:function ()
                        {
                        }
                    }
                ]
            });
        }
    });

    this.Views.ReportsWidgets.ExcludedResourcesTable.Views.Table.attachEvent("onCheck", function(row, column, state){

        let table = _this.Views.ReportsWidgets.ExcludedResourcesTable.Views.Table;
        let item = table.getItem(row);

        switch (column)
        {
            case "checked":
                if(item && item.checked)
                {
                    table.select(row, true)
                }
                else
                {
                    table.unselect(row);
                }
                break;
            case "enabled":
                if(item)
                {
                    _this.ViewModel.UpdateResource(item);
                }
                break;
        }
    });

};

UlrExcludedResourcesViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    _this.Views.ReportsWidgets.ExcludedResourcesTable.RefreshData();
};

UlrExcludedResourcesViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrExcludedResourcesViewController.prototype.GetPageTitle = function ()
{
    if (this.PageTitle)
        return this.PageTitle;
};

UlrExcludedResourcesViewController.prototype.ExcludedResourcesTableOnClick = function(Id)
{
    let table = this.Views.ReportsWidgets.ExcludedResourcesTable.Views.Table;
    let item = table.getItem(Id.row);

    if(item)
    {
        switch(Id.column)
        {
            case "delete":
                this.ViewModel.DeleteResource({
                    data:item,
                    callback: () => {
                        table.remove(Id);
                    }
                });
                break;
        }
    }
};

UlrExcludedResourcesViewController.prototype.ExportList = function(FileName, Type, Callback)
{
    var _this = this;

    var params = {
        filename: FileName,
        export_type: Type,
        columns_header: [
            "",
            LangHelper.GetString("UlrModule","Type"),
            LangHelper.GetString("UlrModule","Resource raw"),
            LangHelper.GetString("UlrModule","Resource validated"),
            LangHelper.GetString("UlrModule","Status")
        ],
        column_dics: {
            enabled: ControlTaskStatusesDic,
            type_id: App.DicsManager.GetDic(DicsEnum.UlrResourceTypesDic),
            state_valid: {
                '0' : { id: '0', value : LangHelper.GetString("UlrModule", "No validation") },
                '1' : { id: '1', value : LangHelper.GetString("UlrModule", "Invalid") },
                '2' : { id: '2', value : LangHelper.GetString("UlrModule", "Valid") }
            }
        }
    };

    this.ViewModel.GetExcludedResourcesExportFileData(params, Callback);
};
function UlrWebSearchDatabaseViewController(Params)
{
    var _this = this;

    this.IdsEnum =
    {
        UlrWebSearchDatabase:"UlrWebSearchDatabase",
        UlrSearchDatabase:"UlrSearchDatabase"
    };

    this.Id = Params&&Params.id ? Params.id : this.IdsEnum .UlrWebSearchDatabase;

    this.mode = module ? module : "dpiui2";

    this.PageTitle = Params&&Params.page_title ? Params.page_title :
    {
        RootTitle:LangHelper.GetString("UlrModule","Web filter"),
        Title:LangHelper.GetString("UlrModule","Search database")
    };

    this.ViewModel = null;

    this.ReportsModel = new UniReportsManager();

    this.Views = {

        ScrollView:null,
        PageTitle:null,

        SearchForm:null,
        SearchInput:null,
        FileldInput:null,

        SearchBtn:null,

        Reports:null,

        Widgets:{},
        ReportsWidgets:{}
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({id:this.Id + "PageTitle", root_title: this.PageTitle.Title ? this.PageTitle.Title : this.PageTitle.RootTitle}),
                            {height:32},
                            {
                                view: "form",
                                id: this.Id + "SearchForm",
                                type: "wide",
                                elements: [
                                    {
                                        type:"clean",
                                        rows:[
                                            {
                                                view:"template",
                                                id: this.Id + "HelpInfoLabel",
                                                borderless:true,
                                                css:"form_text_big_label",
                                                //height:120,
                                                autoheight:true,
                                                template:LangHelper.GetString("UlrModule",_this.Id == _this.IdsEnum.UlrSearchDatabase ? "Search by all database rules." : "Search by Web/IP database.") + "<br/><br/>" +
                                                LangHelper.GetString("UlrModule","Use <b>*</b> before and after search word to make wildcard.") + "<br/>" +
                                                LangHelper.GetString("UlrModule","Use <b>\"</b> before and after to serach certain phrase.") + "<br/>" +
                                                "<a class='help_link' href='javascript:void(0);'>"+LangHelper.GetString("UlrModule","More help.") + "</a>" + "<br/><br/>",
                                                onClick:{
                                                    "help_link":function(Ev, Id)
                                                    {
                                                        UlrShowDatabaseSearchHelpPopup();
                                                    }
                                                }
                                            },
                                            {
                                                type: "wide",
                                                cols:[
                                                    {
                                                        view:"spectre_text",
                                                        id:_this.Id + "SearchInput",
                                                        name:"search",
                                                        gravity:2,
                                                        label:LangHelper.GetString("UlrModule","IP, CIDR, Domain, Commentary"),
                                                        on:{
                                                            onEnter:function(ev)
                                                            {
                                                                setTimeout(function ()
                                                                {
                                                                    _this.Search();
                                                                },1);
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"spectre_richselect",
                                                        id:_this.Id + "FileldInput",
                                                        name:"type",
                                                        value:_this.Id == _this.IdsEnum.UlrSearchDatabase ? "dpiui2_ulr_all_rules" : "dpiui2_ulr_web_rules",
                                                        options:{
                                                            point:false,
                                                            data:function ()
                                                            {
                                                                var type = _this.Id == _this.IdsEnum.UlrSearchDatabase ? "all" : "web";

                                                                var arr = [
                                                                    {id:"dpiui2_ulr_"+type+"_rules", value:LangHelper.GetString("UlrModule","Full text")},
                                                                    {id:"dpiui2_ulr_"+type+"_rules_resource", value:LangHelper.GetString("UlrModule","By resource")},
                                                                    {id:"dpiui2_ulr_"+type+"_rules_description", value:LangHelper.GetString("UlrModule","By desctription")}
                                                                ];

                                                                return arr;
                                                            }()
                                                        }
                                                    },
                                                    {
                                                        rows:[
                                                            {},
                                                            {
                                                                view:"spectre_button",
                                                                id:this.Id + "SearchBtn",
                                                                css:"form_button form_element main_action",
                                                                label:LangHelper.GetString("UlrModule","Search"),
                                                                height:51,
                                                                autowidth:true,
                                                                click:function ()
                                                                {
                                                                    setTimeout(function () {
                                                                        _this.Search();
                                                                    },1);
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height:32},
                            {
                                //view:"multiview",
                                id:this.Id+"Reports",
                                borderless:true,
                                rows:[]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {
        SearchInputValue:  new Rx.BehaviorSubject(0)
    };
}

UlrWebSearchDatabaseViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.SearchInput.attachEvent("onChange", function(Nv, Ov)
    {
        if(Nv != Nv.trim())
        {
            this.setValue(Nv.trim());
            return;
        }
        _this.Signals.SearchInputValue.next(Nv.trim());
    });

    this.Views.SearchInput.attachEvent("onTimedKeyPress", function()
    {
        var v = _this.Views.SearchInput.getValue();

        if(v != v.trim())
        {
            this.setValue(v.trim());
            return;
        }

        _this.Signals.SearchInputValue.next(v.trim());
    });

    this.Subscriptions.SearchInputValue = this.Signals.SearchInputValue.subscribe(function (Value)
    {
        Value && Value.length >= 3 ? _this.Views.SearchBtn.enable() : _this.Views.SearchBtn.disable();
    });
};

UlrWebSearchDatabaseViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);
};

UlrWebSearchDatabaseViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrWebSearchDatabaseViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrWebSearchDatabaseViewController.prototype.Search = function ()
{
    var _this = this;

    var searchText = this.Views.SearchInput.getValue().trim();

    if(!searchText)
        return;

    var index = this.Views.FileldInput.getValue();

    if(!index)
        return;

    var id = webix.uid();

    var widget = this.Id == this.IdsEnum.UlrSearchDatabase ? UrlAllRulesSearchResultTableWidget : UrlWebRulesSearchResultTableWidget;

    this.Views.ReportsWidgets[id] = widget({
        name:this.Id + id,
        id:this.Id + id,
        enableAutoHeight:true,
        onItemClick:function (Id, E, Node)
        {
            _this.RulesReportOnItemClick(id, Id, E, Node);
        }
    });

    var view = {
        type: "wide",
        rows:[
            BlockHeaderTemplate({
                title:LangHelper.GetString("UlrModule","Search results for") + " '" + searchText + "'", icon:"",
                borderless:true
            }),
            this.Views.ReportsWidgets[id].ViewConfig
        ]
    };

    this.Views.Reports.addView({height:32}, 0);
    this.Views.Reports.addView(view, 0);

    this.Views.ReportsWidgets[id].Bind(this, this.ReportsModel);

    var sphinxSearch = {
        index_name:index,
        search_text:searchText,
        //snippets:1,
        highlightInColumns:this.Id == this.IdsEnum.UlrSearchDatabase ? ["uniq_id","rule_id","resource_raw","resource_validated","name", "description", "type", "rule_type_code", "update_time"] : ["_id","rule_id","resource_raw","resource_validated","description_public","type", "update_time"]
    };

    this.Views.ReportsWidgets[id].SetSphinxSearch(sphinxSearch);

    this.Views.ReportsWidgets[id].DataAdapter = function (Data)
    {
        return _this.SearchResultsDataAdapter(Data,this.SphinxSearch.search_text, this.SphinxSearch.highlightInColumns)
    };

    this.Views.ReportsWidgets[id].RefreshData();
};

UlrWebSearchDatabaseViewController.prototype.SearchResultsDataAdapter = function (Data, SearchWord, ColsHighlight)
{
    if(!ColsHighlight || !ColsHighlight.length)
        return Data;

    if(Data&&Data.rows&&SearchWord)
    {
        var search = SearchWord.replace(/[^\w\s]/gi, '_split_').replace(" ", '_split_').split('_split_').filter(function (Item) {
            return Item ? true : false;
        }).join("|");

        Data.rows.forEach(function (Row)
        {
            ColsHighlight.forEach(function (Item)
            {
                if(Row[Item])
                {
                    if(Item == "update_time" || Item == "create_time")
                    {
                        var update_time = CellSpectreDateTemplate(Row[Item]);
                        if(Row[Item])
                        {
                            var update = new Date(Row[Item]);
                            var offset = update.getTimezoneOffset();
                            if(offset != 0)
                            {
                                var n_date = new Date(update.getTime() - offset*60*1000);

                                update_time = CellSpectreDateTemplate(n_date);
                            }
                        }
                        else{
                            update_time = CellSpectreDateTemplate(Row[Item]);
                        }
                        Row[Item] = update_time;
                    }
                    else
                        Row[Item] = Row[Item].replace(new RegExp(search, "gi"), function(match){return '<span class="highlight">'+match+'</span>';});
                }
            });
        });
    }

    return Data;
};

UlrWebSearchDatabaseViewController.prototype.RulesReportOnItemClick = function(ReportId, RowId, E, Node)
{
    var _this = this;

    if((RowId.column === 'rule_id' && E.target && E.target.className == "webix_cell_link") || RowId.column === 'edit')
    {
        var table = this.Views.ReportsWidgets[ReportId].Views.Table;

        var data = table.getItem(RowId);

        var id = Helper.StripHtml(data.rule_id);

        var controller = UlrRulesTypesCodesControllersMap[data.rule_type_code] ? UlrRulesTypesCodesControllersMap[data.rule_type_code] : UlrRulesTypesCodesControllersMap[UlrRulesTypesCodesEnum.web_ip_lock];

        if(controller)
            App.NavRouter.PresentView({id: controller, path:"/_id=" + id});
    }

    if(RowId.column === 'rule_type_code' && E.target && E.target.className == "webix_cell_link")
    {
        var table = this.Views.ReportsWidgets[ReportId].Views.Table;

        var data = table.getItem(RowId);

        var id = Helper.StripHtml(data.rule_id);

        var rule_type_code = Helper.StripHtml(data.rule_type_code);

        var controller = UlrRulesTypesCodesListsControllersMap[rule_type_code] ? UlrRulesTypesCodesListsControllersMap[rule_type_code] : "";

        if(controller)
            App.NavRouter.PresentView({id: controller});
    }

    if(RowId.column === 'rule_type_id' && E.target && E.target.className == "webix_cell_link")
    {
        const table = this.Views.ReportsWidgets[ReportId].Views.Table;

        const data = table.getItem(RowId);

        const ruleTypeCodeValue = data.rule_type_id && Object.keys(UlrRulesTypesCodesTypeIdMap).find(key => UlrRulesTypesCodesTypeIdMap[key] == data.rule_type_id);

        const controller = ruleTypeCodeValue && UlrRulesTypesCodesListsControllersMap[ruleTypeCodeValue] ? UlrRulesTypesCodesListsControllersMap[ruleTypeCodeValue] : "";

        if(controller)
            App.NavRouter.PresentView({id: controller});
    }
};
function UlrHostCategoriesViewController(Params) {
    var _this = this;

    this.Id = "UlrAppCategories";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle: LangHelper.GetString("UlrModule", "Host categories"),
        Title: LangHelper.GetString("UlrModule", "Host categories")
    };

    this.ViewModel = null;

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        FiltersForm: null,
        Widgets: {},
        ReportsWidgets: {
            CategoriesTable: URLAppHostCategoriesTableWidget({
                id: this.Id + "CategoriesTable",
                enableTextSearch: 0,
                enableAutoHeight:true
            })
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            scroll: "y",
            body: {
                type: "space",
                rows: [

                    {
                        type: "clean",
                        borderless: true,
                        rows: [
                            {height: 6},
                            PageHeaderTemplate({root_title: this.PageTitle.Title}),
                            {height:32},
                            {
                                view: "label",
                                css:"form_text_label",
                                label:LangHelper.GetString("UlrModule","Filters")
                            },
                            {
                                view:"form",
                                id:this.Id + "FiltersForm",
                                type: "wide",
                                borderless:true,
                                elements:[
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                view:"spectre_text",
                                                name:"full_text_search",
                                                label:LangHelper.GetString("UlrModule","Search")
                                            },
                                            {
                                                view:"spectre_richselect",
                                                name:"cat_id",
                                                label:LangHelper.GetString("UlrModule","Group"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                }
                                            },
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "FilterApplyBtn",
                                                css:"form_button form_element main_action",
                                                label:LangHelper.GetString("UlrModule","Apply"),
                                                height:51,
                                                click:function ()
                                                {
                                                    setTimeout(function ()
                                                    {
                                                        _this.RefreshTableReport();
                                                    },1);
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height: 32},
                            {
                                view:"template",
                                borderless:true,
                                css:"form_text_big_label",
                                //height:120,
                                autoheight:true,
                                template: LangHelper.GetString("UlrModule", "List host categories")
                            },
                            {height: 32},
                            this.Views.ReportsWidgets.CategoriesTable.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrHostCategoriesViewController.prototype.BindAll = function (Params) {
    var _this = this;

    Object.keys(this.Views).forEach(function (View) {
        if (View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey) {
        var w = _this.Views.Widgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if (w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey) {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if (w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.SignalDicProtocolsGroupsUpdatedSubscription = App.DicsManager.Signal[DicsEnum.HostCategoriesDic].subscribe(function(Updated){
        if(Updated)
        {
            var dic = App.DicsManager.GetDicAsArray(DicsEnum.HostCategoriesDic);

            dic = dic.sort(function(a,b){
                return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
            });

            dic.splice(0,0, {dic_id: "", id: "", value: "", $empty:true});
            _this.Views.FiltersForm.elements.cat_id.define("options", dic);
            _this.Views.FiltersForm.elements.cat_id.refresh();
        }
    
    });
};

UlrHostCategoriesViewController.prototype.ViewDidLoad = function (Params) {
    var _this = this;

    this.BindAll(Params);

    this.Refresh();

    this.Views.ReportsWidgets.CategoriesTable.Filter = null;
};

UlrHostCategoriesViewController.prototype.Destroy = function () {
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key) {
        if (_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget) {
        var w = _this.Views.Widgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget) {
        var w = _this.Views.ReportsWidgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    if (this.ViewModel) {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if (this.ReportsModel) {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrHostCategoriesViewController.prototype.GetPageTitle = function () {
    if (this.PageTitle)
        return this.PageTitle;
};

UlrHostCategoriesViewController.prototype.Refresh = function () {
    this.Views.ReportsWidgets.CategoriesTable.RefreshData();
};

UlrHostCategoriesViewController.prototype.RefreshTableReport = function ()
{
    var filter = {};

    var filterFormVals = this.Views.FiltersForm.getValues();

    if(filterFormVals.cat_id)
    {
        filter.cat_id =
            {
                id:"cat_id",
                operator:"=",
                value:filterFormVals.cat_id
            };
    }

    if(filterFormVals.full_text_search)
    {
        filter.full_text_search =
            {
                id:"full_text_search",
                operator:"like",
                value:filterFormVals.full_text_search
            };
    }

    this.Views.ReportsWidgets.CategoriesTable.RefreshData(0,{filter:filter});
};

function UlrWebRulesStatisticsViewController(Params)
{
    var _this = this;

    this.Id = "UlrWebRulesStatisticsViewController";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Web filter"),
        Title: LangHelper.GetString("UlrModule", "Rules statistics")
    };

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        Widgets: {},
        ReportsWidgets:{
            StatInfoReport: UrlWebRulesStatInfoTableWidget({
                id:this.Id + "StatInfoReport",
                enableAutoHeight:1,
                additional_filter: {
                    rule_type_id:{
                        id: "rule_type_id",
                        operator: "=",
                        value: UlrRulesTypesCodesTypeIdMap.web_ip_lock
                    }
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({id:this.Id + "PageTitle", root_title: this.PageTitle.Title}),
                            {height:32},
                            {
                                type: "wide",
                                borderless:true,
                                //height:280,
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Web/IP firewall summary"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        cols:[
                                            {
                                                borderless:true,
                                                rows:[
                                                    this.Views.ReportsWidgets.StatInfoReport.ViewConfig
                                                ]
                                            },
                                            {
                                                gravity:2
                                            }
                                        ]
                                    }
                                ]
                            },
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrWebRulesStatisticsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });
};

UlrWebRulesStatisticsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrWebRulesStatisticsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrWebRulesStatisticsViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.StatInfoReport.RefreshData();
};

UlrWebRulesStatisticsViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};
function UlrSpoofDnsRulesViewController(Params)
{
    var _this = this;

    this.Id = "UlrSpoofDnsRules";

    this.PathParams = {};

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Spoof DNS"),
        Title:""
    };

    this.ViewModel = new UlrSpoofDnsRulesManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        FiltersForm:null,
        FilterApplyBtn:null,
        FilterClearBtn:null,
        SubsIdsInput: null,
        IspIdsInput: null,
        ToggleIcon: null,
        AdditionalFiltersContainer: null,
        LastChangesList: null,
        RulesList: null,
        EditorTabs: null,
        ResourceFilterSection: null,
        HiddenFilter: null,

        Widgets:{
            DateRangePicker: new QoEDateRangePickerWidget({
                id:this.Id + "DateRangePicker",
                default_value:"empty"
            })
        },
        ReportsWidgets:{
            RulesReport: UrlLastSpoofDnsRulesEntriesTableWidget({
                id:this.Id + "RulesReport",
                enableTextSearch:false,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.RulesReportOnItemClick(Id, E, Node);
                }
            }),
            SpoofDnsRulesReport: UrlSpoofDnsRulesTableWidget({
                id:this.Id + "SpoofDnsRulesReport",
                enableTextSearch:false,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.SpoofDnsRulesReportOnItemClick(Id, E, Node);
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title: this.PageTitle.RootTitle}),
                            {height:32},
                            {
                                view:"template",
                                borderless:true,
                                css:"form_text_big_label",
                                autoheight:true,
                                template:function ()
                                {
                                    return LangHelper.GetString("UlrModule","SPOOF_DNS_SECTION_DESCRIPTION");

                                }()
                            },
                            {height:20},
                            // {
                            //     view:"template",
                            //     borderless:false,
                            //     border:2,
                            //     css:"form_text_warning_label",
                            //     autoheight:true,
                            //     template:function (RuleType)
                            //     {
                            //         var warning = "<span class='warning'>"+LangHelper.GetString("UlrModule","Warning")+"</span>" + ": ";
                            //         var label = LangHelper.GetString("UlrModule","WEB_FILTER_SECTION_ATTENTION");
                            //
                            //         return warning+label+'</br>&nbsp;';
                            //     }(this.RuleType)
                            // },
                            {height:32},
                            {
                                type: "wide",
                                borderless:true,
                                rows:[
                                    {
                                        type: "wide",
                                        borderless: true,
                                        cols: [
                                            {
                                                view:"tabbar",
                                                id:this.Id + "Editor" + "Tabs",
                                                css: "ulr-tabbar",
                                                options: [
                                                    {
                                                        id: this.Id + "RulesList",
                                                        value: LangHelper.GetString("UlrModule","Rules")
                                                    },
                                                    {
                                                        id: this.Id + "LastChangesList",
                                                        value: LangHelper.GetString("UlrModule","Resources")
                                                    }
                                                ],
                                                on:{
                                                    "onAfterTabClick":function(Id)
                                                    {
                                                        $$(Id).show();
                                                        _this.RefreshTableReport();

                                                        _this.SetTemplateForOpenedTab(Id);

                                                        _this.SetLastOpenedTab(Id);
                                                    }
                                                }
                                            },
                                            {
                                                gravity:3
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height:32},
                            {
                                view:"form",
                                id:this.Id + "FiltersForm",
                                type: "wide",
                                borderless:true,
                                on: {
                                    onSubmit: function(view, event) {
                                        _this.RefreshTableReport();
                                    }
                                },
                                elements:[
                                    {
                                        type: "wide",
                                        cols:[
                                            this.Views.Widgets.DateRangePicker.ViewConfig,
                                            {
                                                view:"spectre_text",
                                                name:"full_text_search",
                                                label:LangHelper.GetString("UlrModule","Search")
                                            },
                                            {
                                                view:"spectre_multiselect",
                                                name:"rule_type",
                                                label:LangHelper.GetString("UlrModule","Rule type"),
                                                options: Helper.DictToArr(UlrWebRuleResourcesListTypes)
                                            },
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "template",
                                                autoheight: true,
                                                borderless: true,
                                                template: `<span class="custom-additional-filters">${LangHelper.GetString("UlrModule","All filters")}</span><span id=${_this.Id + "ToggleIcon"} class="webix_icon fa-angle-down"></span>`,
                                                onClick: {
                                                    "webix_template": function(id){
                                                        _this.ShowHideAdditionalFilters();
                                                    }
                                                }
                                            },
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        id: _this.Id + "AdditionalFiltersContainer",
                                        hidden: true,
                                        rows: [
                                            {
                                                type:"wide",
                                                cols:[
                                                    {
                                                        view:"spectre_text",
                                                        name:"rule_id",
                                                        label:LangHelper.GetString("UlrModule","Rule id")
                                                    },
                                                    {
                                                        view:"spectre_multiselect",
                                                        name:"enabled",
                                                        label:LangHelper.GetString("UlrModule","Rule state"),
                                                        options: Helper.DictToArr(BlStatusesDic)
                                                    },
                                                    {
                                                        view:"spectre_text",
                                                        name:"description_full_text_search",
                                                        label:LangHelper.GetString("UlrModule","Reason"),
                                                    }
                                                ]
                                            },
                                            {
                                                type:"wide",
                                                cols:[
                                                    {
                                                        view:"spectre_text",
                                                        name:"update_user",
                                                        label:LangHelper.GetString("UlrModule","User"),
                                                    },
                                                    {
                                                        view:"spectre_text",
                                                        name:"regulator",
                                                        label:LangHelper.GetString("UlrModule","Regulator")
                                                    },
                                                    {
                                                        view:"spectre_text",
                                                        name:"category",
                                                        label:LangHelper.GetString("UlrModule","Category")
                                                    },
                                                ]
                                            },
                                            {
                                                type: "wide",
                                                cols: [
                                                    {
                                                        view: "spectre_multiselect",
                                                        id: this.Id + "IspIdsInput",
                                                        name: "isp_id",
                                                        label: LangHelper.GetString("UlrModule", "Isps"),
                                                        options:{
                                                            point:false,
                                                            data:[]
                                                        }
                                                    },
                                                    {
                                                        view: "spectre_multiselect",
                                                        id: this.Id + "SubsIdsInput",
                                                        name: "sub_id",
                                                        label: LangHelper.GetString("UlrNodule", "Subscribers"),
                                                        options:{
                                                            point:false,
                                                            data:[]
                                                        }
                                                    },
                                                    {
                                                        id: _this.Id + "HiddenFilter"
                                                    },
                                                    {
                                                        type:"wide",
                                                        id: _this.Id + "ResourceFilterSection",
                                                        cols:[
                                                            {
                                                                view:"spectre_text",
                                                                name:"resource_raw",
                                                                label:LangHelper.GetString("UlrModule","Resource")
                                                            }
                                                        ]
                                                    },
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols: [
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "FilterApplyBtn",
                                                css:"form_button form_element main_action",
                                                label:LangHelper.GetString("UlrModule","Apply"),
                                                height:51,
                                                click:function ()
                                                {
                                                    _this.DisableEnableBtn("disable");
                                                    setTimeout(function ()
                                                    {
                                                        _this.RefreshTableReport();
                                                    },1);
                                                }
                                            },
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "FilterClearBtn",
                                                css:"form_button form_element third_action",
                                                label:LangHelper.GetString("UlrModule","Clear"),
                                                height:51,
                                                click:function ()
                                                {
                                                    _this.DisableEnableBtn("disable");
                                                    _this.ClearFiltersForm();

                                                    setTimeout(function ()
                                                    {
                                                        _this.RefreshTableReport();
                                                    },1);
                                                }
                                            },
                                            {}
                                        ]
                                    }
                                ],
                            },
                            {height:32},
                            {
                                type: "wide",
                                borderless:true,
                                rows:[
                                    {
                                        id: this.Id + "TabWrapper",
                                        animate: false,
                                        cells: [
                                            {
                                                id: this.Id + "RulesList",
                                                rows:[
                                                    this.Views.ReportsWidgets.SpoofDnsRulesReport.ViewConfig
                                                ]
                                            },
                                            {
                                                id: this.Id + "LastChangesList",
                                                rows:[
                                                    this.Views.ReportsWidgets.RulesReport.ViewConfig
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrSpoofDnsRulesViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.Widgets.DateRangePicker.SetValue(null,true);

    this.Subscriptions[DicsEnum.UlrIspsDic] = App.DicsManager.Signal[DicsEnum.UlrIspsDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.IspIdsInput.getList().clearAll();

            let dicArr = [];

            Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrIspsDic)).forEach((Obj) => {
                dicArr.push({
                    id: Obj.id,
                    dic_id: Obj.dic_id,
                    value: Obj.value + " (" + Obj.igw_name + ")"
                });
            });

            if(dicArr && dicArr.length)
            {
                _this.Views.IspIdsInput.getList().clearAll();
                _this.Views.IspIdsInput.getList().parse(dicArr);
            }
        }
    });

    this.Subscriptions[DicsEnum.UlrSubscribersDic] = App.DicsManager.Signal[DicsEnum.UlrSubscribersDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.SubsIdsInput.getList().clearAll();

            let dicArr = [];

            Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrSubscribersDic)).forEach((Obj) => {
                dicArr.push({
                    id: Obj.id,
                    dic_id: Obj.dic_id,
                    value: Obj.value + " (" + Obj.igw_name + ")"
                });
            });

            if(dicArr && dicArr.length)
            {
                _this.Views.SubsIdsInput.getList().clearAll();
                _this.Views.SubsIdsInput.getList().parse(dicArr);
            }
        }
    });

    this.Subscriptions.DisableFiltersButton = this.ReportsModel.Reports[`${this.Id}RulesReport`].signal.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.DisableEnableBtn("enable");
        }
    });

    this.Subscriptions.DisableFiltersButtonWebRules = this.ReportsModel.Reports[`${this.Id}SpoofDnsRulesReport`].signal.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.DisableEnableBtn("enable");
        }
    });


    this.Views.EditorTabs.setValue(this.GetLastOpenedTab());

    var tabId = this.GetLastOpenedTab();
    this.SetTemplateForOpenedTab(tabId);
    $$(tabId).show();

    App.DicsManager.Refresh({data: [DicsEnum.UlrIspsDic, DicsEnum.UlrSubscribersDic]});

    this.GetAllPathParam();
};

UlrSpoofDnsRulesViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.PathParams = Params;

    this.BindAll(Params);

    this.RefreshTableReport();
};

UlrSpoofDnsRulesViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrSpoofDnsRulesViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrSpoofDnsRulesViewController.prototype.RulesReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.RulesReport.Views.Table;

    var data = table.getItem(Id);

    if((Id.column === 'rule_id' && E.target && E.target.className == "webix_cell_link") || Id.column === 'edit')
    {
        App.NavRouter.PresentView({id: ControllersEnum.UlrEditSpoofDnsRule, path:"/_id=" + data.rule_id});
    }
};

UlrSpoofDnsRulesViewController.prototype.SpoofDnsRulesReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if((Id.column === 'rule_id' && E.target && E.target.className == "webix_cell_link") || Id.column === 'edit')
    {
        var table = this.Views.ReportsWidgets.SpoofDnsRulesReport.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: ControllersEnum.UlrEditSpoofDnsRule, path:"/_id=" + data.rule_id});
    }
};

UlrSpoofDnsRulesViewController.prototype.RefreshTableReport = function ()
{
    var filter = {};

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(period)
    {
        var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

        if(period.start && period.end)
        {
            filter.period = {
                id:"update_time",
                operator:"between",
                value:[format(Helper.DateTimeToUTC(period.start)), format(Helper.DateTimeToUTC(period.end))]
            };
        }

        else if(period.start)
        {
            filter.period = {
                id:"update_time",
                operator:">=",
                value:format(Helper.DateTimeToUTC(period.start))
            };
        }

        else if(period.end)
        {
            filter.period = {
                id:"update_time",
                operator:"<=",
                value:format(Helper.DateTimeToUTC(period.end))
            };
        }
    }

    let filterFormVals = this.Views.FiltersForm.getValues();

    if(filterFormVals.rule_type)
    {
        if (Array.isArray(filterFormVals.rule_type))
            filterFormVals.rule_type = filterFormVals.rule_type.join(',');

        if (filterFormVals.rule_type.indexOf("isp") !== -1 && filterFormVals.rule_type.indexOf("subscriber") !== -1)
            filterFormVals.rule_type += ",isp_subs";

        filter.rule_type_mode =
            {
                id:"rule_type_mode",
                operator:"in",
                value:filterFormVals.rule_type.split(',')
            };
    }

    if(filterFormVals.rule_id)
    {
        filter.rule_id =
            {
                id:"rule_id",
                operator:"=",
                value:filterFormVals.rule_id
            };
    }

    if(filterFormVals.enabled)
    {
        if (Array.isArray(filterFormVals.enabled))
            filterFormVals.enabled = filterFormVals.enabled.join(',');

        filter.enabled =
            {
                id:"enabled",
                operator:"in",
                value: filterFormVals.enabled.split(',').map(item => Number(item))
            };
    }

    if(this.Views.EditorTabs.getValue() == this.Id + "LastChangesList")
    {
        if(filterFormVals.resource_raw)
        {
            filter.resource_raw =
                {
                    id:"resource_raw",
                    operator:"like",
                    value:filterFormVals.resource_raw
                };
        }
    }

    if(filterFormVals.update_user)
    {
        filter.update_user =
            {
                id:"update_user",
                operator:"like",
                value:filterFormVals.update_user
            };
    }

    if(filterFormVals.regulator)
    {
        filter.regulator =
            {
                id:"regulator",
                operator:"like",
                value:filterFormVals.regulator
            };
    }

    if(filterFormVals.category)
    {
        filter.category =
            {
                id:"category",
                operator:"like",
                value:filterFormVals.category
            };
    }

    if(filterFormVals.full_text_search)
    {
        filter.full_text_search =
            {
                id:"full_text_search",
                operator:"like",
                value:filterFormVals.full_text_search
            };
    }

    if(filterFormVals.description_full_text_search)
    {
        filter.description_full_text_search =
            {
                id:"description_full_text_search",
                operator:"like",
                value:filterFormVals.description_full_text_search
            };
    }

    if(filterFormVals.sub_id)
    {
        filter.sub_id =
            {
                id:"sub_id",
                operator:"in",
                value:filterFormVals.sub_id.split(',')
            };
    }

    if(filterFormVals.isp_id)
    {
        filter.isp_id =
            {
                id:"isp_id",
                operator:"in",
                value:filterFormVals.isp_id.split(',')
            };
    }

    if(this.Views.EditorTabs.getValue() == this.Id + "RulesList")
    {
        this.Views.ReportsWidgets.SpoofDnsRulesReport.RefreshData(0,{filter:filter});
    }
    else{
        this.Views.ReportsWidgets.RulesReport.RefreshData(0,{filter:filter});
    }

    this.SetAllPathParam(filter);
};

UlrSpoofDnsRulesViewController.prototype.ClearFiltersForm = function ()
{
    const _this = this;

    const filters = _this.Views.FiltersForm.elements;

    _this.Views.Widgets.DateRangePicker.SetValue(null, true, "empty");

    for (const filter in filters) {
        filters[filter].setValue("");
    }
};

UlrSpoofDnsRulesViewController.prototype.DisableEnableBtn = function (Action)
{
    const _this = this;

    _this.Views.FilterApplyBtn[Action]();
    _this.Views.FilterClearBtn[Action]();
}

UlrSpoofDnsRulesViewController.prototype.SetAllPathParam = function(filter)
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();
    if(period)
    {
        this.SetPathParam("period", period);
    }

    if(filter)
    {
        if (filter.period)
            delete filter.period

        this.SetPathParam("filter", JSON.stringify(filter));
    }
};

UlrSpoofDnsRulesViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

UlrSpoofDnsRulesViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrSpoofDnsRulesViewController.prototype.GetAllPathParam = function()
{
    try
    {
        const period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        let filters = this.GetPathParam("filter");
        if(filters)
        {
            filters = JSON.parse(filters);
        }
        else{
            filters = {};
        }
        let excludedFilters = false;

        if (filters.rule_type_mode)
        {
            this.Views.FiltersForm.elements["rule_type"].setValue(filters["rule_type_mode"].value);
            excludedFilters = true;
        }

        if (filters.rule_id)
            this.Views.FiltersForm.elements["rule_id"].setValue(filters["rule_id"].value);

        if (filters.enabled)
            this.Views.FiltersForm.elements["enabled"].setValue(filters["enabled"].value);

        if (filters.resource_raw)
            this.Views.FiltersForm.elements["resource_raw"].setValue(filters["resource_raw"].value);

        if (filters.update_user)
            this.Views.FiltersForm.elements["update_user"].setValue(filters["update_user"].value);

        if (filters.regulator)
            this.Views.FiltersForm.elements["regulator"].setValue(filters["regulator"].value);

        if (filters.category)
            this.Views.FiltersForm.elements["category"].setValue(filters["category"].value);

        if (filters.description_full_text_search)
            this.Views.FiltersForm.elements["description_full_text_search"].setValue(filters["description_full_text_search"].value);

        if (filters.full_text_search){
            this.Views.FiltersForm.elements["full_text_search"].setValue(filters["full_text_search"].value);
            excludedFilters = true;
        }

        var sub_id = this.GetPathParam("sub_id");
        if(sub_id)
        {
            this.Views.FiltersForm.elements["sub_id"].setValue(sub_id);
            filters.sub_id = {
                id: "isp_id",
                operator: "in",
                value: parseInt(sub_id)
            };
        }

        var isp_id = this.GetPathParam("isp_id");
        if(isp_id)
        {
            this.Views.FiltersForm.elements["isp_id"].setValue(isp_id);
            filters.isp_id = {
                id: "isp_id",
                operator: "in",
                value: parseInt(isp_id)
            };
        }

        if(Object.keys(filters).length && !excludedFilters)
            this.ShowHideAdditionalFilters(true);
    }
    catch(e){
        console.log('exception', e)
    }
};

UlrSpoofDnsRulesViewController.prototype.ShowHideAdditionalFilters = function(hasFilters = null)
{
    const _this = this;

    const formContainer = _this.Views.AdditionalFiltersContainer;
    const toggleIcon = _this.Views.ToggleIcon;
    const child = toggleIcon.getNode().children[0].lastChild;

    const hideFilters = () => {
        formContainer.hide();
        child.classList.remove('fa-angle-up');
        child.classList.add('fa-angle-down');
    }

    const showFilters = () => {
        formContainer.show();
        child.classList.remove('fa-angle-down');
        child.classList.add('fa-angle-up');
    }

    if (hasFilters)
    {
        showFilters();
    }
    else
    {
        if (formContainer.isVisible()) {
            hideFilters();
        } else {
            showFilters();
        }
    }
}

UlrSpoofDnsRulesViewController.prototype.GetLastOpenedTab = function()
{
    var val = localStorage.getItem('SpoofDnsSelectedTab');

    return val ? val : (this.Id + "RulesList");
}

UlrSpoofDnsRulesViewController.prototype.SetLastOpenedTab = function(Val)
{
    localStorage.setItem('SpoofDnsSelectedTab', Val);
}

UlrSpoofDnsRulesViewController.prototype.SetTemplateForOpenedTab = function (TabId)
{
    var _this = this;

    if (TabId == (_this.Id + "RulesList"))
    {
        _this.Views.ResourceFilterSection.hide();
        _this.Views.HiddenFilter.show();

        _this.Views.FilterApplyBtn.define("label", LangHelper.GetString("UlrModule","Search rules"));
        _this.Views.FilterApplyBtn.refresh();
    }
    else
    {
        _this.Views.ResourceFilterSection.show();
        _this.Views.HiddenFilter.hide();

        _this.Views.FilterApplyBtn.define("label", LangHelper.GetString("UlrModule","Search resources"));
        _this.Views.FilterApplyBtn.refresh();
    }
};
function UlrEditSpoofDnsRuleViewController(Params)
{
    var _this = this;

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.Action = Params&&Params.action&&this.ActionsEnum[Params.action]?this.ActionsEnum[Params.action]:this.ActionsEnum.Edit;

    this.RuleType = Params&&Params.rule_type&&UlrRulesTypesCodesEnum[Params.rule_type]?UlrRulesTypesCodesEnum[Params.rule_type]:UlrRulesTypesCodesEnum.spoof_dns;

    this.RuleTypeId = UlrRulesTypesCodesTypeIdMap[this.RuleType];

    this.Id = "UlrEditSpoofDnsRule";

    this.ViewModel = new UlrSpoofDnsRulesManager();
    this.ReportsModel = new UniReportsManager();

    this.IspsList = new UlrIspSubscribersListViews({id: this.Id + "IspsList", IspType: IspsSubscribersListTypes.isp, ViewModel: this.ReportsModel});
    this.SubsList = new UlrIspSubscribersListViews({id: this.Id + "SubsList", IspType: IspsSubscribersListTypes.subscriber, ViewModel: this.ReportsModel});

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Spoof DNS"),
        Title:LangHelper.GetString("UlrModule","Edit rule")
    };

    this.Views = {
        ScrollView:null,
        PageTitle:null,
        RuleEditForm:null,
        RuleEditFormEnabledStateView:null,
        RuleEditFormEnabledSpacerView:null,
        AddResourceForm:null,
        AddResourceInput:null,
        AddResourceBtn:null,
        IpResourceInput:null,
        ClearAllResources:null,
        FileImportBtn:null,
        RuleModeToggle:null,
        RuleModeToggleDescription:null,
        ISPListForm:null,
        ISPListFormFirstCol:null,
        ISPListFormSecondCol:null,
        ISPListFormThirdCol:null,
        SaveBtn:null,
        SaveEnableBtn:null,
        SaveDisableBtn:null,
        ExportRuleBtn:null,
        DeleteBtn:null,
        ResourceTypeSelect: null,
        ActionTypeSelect: null,

        ImportPopupForm:null,
        ImportPopupEditor:null,
        ImportPopupBtn:null,

        ExportRulePopupForm:null,
        ExportRulePopupType:null,
        ExportRulePopupResTable:null,
        ExportRulePopupBtn:null,

        AddedResourcesReportSection: null,
        ResourceListReportSection: null,

        ImportFilesPopupUploader: null,
        FromFileImportBtn: null,
        AddResourceSection: null,
        ChannelsAndSubscribersSection: null,

        Widgets:{},
        ReportsWidgets:{
            ResourcesReport: UrlSpoofDnsRulesResourcesTableWidget({
                id:this.Id + "ResourcesReport",
                enableTextSearch:1,
                enableAutoHeight:1,
                defaultPageSize: 10,
                hidePaginatorToolbar:0,
                enableLocalSort:0,

                onItemClick:function (Id) {
                    _this.ResourcesReportOnItemClick(Id.row, Id.column);
                }
            }),
            AddedResourcesReport: UrlSpoofDnsRulesResourcesTableWidget({
                id:this.Id + "AddedResourcesReport",
                enableTextSearch:0,
                enableAutoHeight:1,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource: 1,
                dataSource: function(FilterParams)
                {
                    var res = {
                        count: _this.AddedResources.length,
                        page: FilterParams.Params.page,
                        size: _this.Views.ReportsWidgets.AddedResourcesReport.Views.Paging.config.size,
                        rows: []
                    };

                    var sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : 'resource_raw';
                    var sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : 'asc';

                    var sort_val = sort_dir == 'asc' ? 1 : -1;


                    _this.AddedResources.sort((a, b) => {
                        var val_a = a[sort_prop];
                        var val_b = b[sort_prop];

                        if(typeof val_a == 'string' || typeof val_b == 'string')
                        {
                            if(sort_val > 0)
                            {
                                return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                            }
                            else
                            {
                                return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                            }
                        }
                        else if(typeof val_a == 'number' || typeof val_b == 'number')
                        {
                            return sort_val * val_a + (-1) * sort_val * val_b;
                        }

                        return -1;
                    });

                    const start_index = res.page * res.size;
                    var finish_index = start_index + res.size;

                    if(finish_index > (_this.AddedResources.length - 1))
                    {
                        res.rows = _this.AddedResources.slice(start_index);
                    }
                    else
                    {
                        res.rows = _this.AddedResources.slice(start_index, finish_index);
                    }

                    return res;
                },
                onItemClick:function (Id) {
                    _this.AddedResourcesReportOnItemClick(Id);
                }
            }),
            ImportedFilesReport: UrlImportedFilesTableWidget({
                id:this.Id + "ImportedFilesReport",
                enableTextSearch:0,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource: 1,
                dataSource: function(FilterParams)
                {
                    var res = {
                        count: _this.ImportFilesArr.length,
                        page: FilterParams.Params.page,
                        size: _this.Views.ReportsWidgets.ImportedFilesReport.Views.Paging.config.size,
                        rows: []
                    };

                    var sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : 'name';
                    var sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : 'asc';

                    var sort_val = sort_dir == 'asc' ? 1 : -1;


                    _this.ImportFilesArr.sort((a, b) => {
                        var val_a = a[sort_prop];
                        var val_b = b[sort_prop];

                        if(typeof val_a == 'string' || typeof val_b == 'string')
                        {
                            if(sort_val > 0)
                            {
                                return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                            }
                            else
                            {
                                return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                            }
                        }
                        else if(typeof val_a == 'number' || typeof val_b == 'number')
                        {
                            return sort_val * val_a + (-1) * sort_val * val_b;
                        }

                        return -1;
                    });

                    const start_index = res.page * res.size;
                    var finish_index = start_index + res.size;

                    if(finish_index > (_this.ImportFilesArr.length - 1))
                    {
                        res.rows = _this.ImportFilesArr.slice(start_index);
                    }
                    else
                    {
                        res.rows = _this.ImportFilesArr.slice(start_index, finish_index);
                    }

                    return res;
                },
                onItemClick:function (Id) {
                    _this.ImportFilesClick(Id);
                }
            }),

            ActionsLog: UrlActionsLogTableWidget({
                id:this.Id + "ActionsLog",
                enableTextSearch:0,
                enableAutoHeight:1,
                filter:{
                    rule_id:{
                        id:"rule_id",
                        operator:"=",
                        value:0
                    }
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({
                                id:this.Id + "PageTitle",
                                root_title:this.PageTitle.Title
                            }),
                            {height:32},
                            {
                                view:"form",
                                id:this.Id + "RuleEditForm",
                                type: "wide",
                                borderless:true,
                                elements:[
                                    {
                                        cols:[
                                            {
                                                view:"spectre_captionlabel",
                                                name:"_id",
                                                caption:LangHelper.GetString("UlrModule","Rule id")
                                            },
                                            {
                                                id:this.Id + "RuleEditFormEnabledSpacerView",
                                                css:"form_info_label_spacer",
                                                borderless:true,
                                                width:20,
                                                template:"",
                                                hidden:true
                                            },
                                            {
                                                view:"spectre_captionlabel",
                                                id:this.Id + "RuleEditFormEnabledStateView",
                                                name:"enabled",
                                                caption:LangHelper.GetString("UlrModule","Rule state"),
                                                template:function (Obj)
                                                {
                                                    return "<span class='caption'>"+Obj.caption+":</span> <span class='value'>"+(parseInt(Obj.value) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled"))+"</span>";
                                                },
                                                hidden:true
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                view:"spectre_richselect",
                                                name:"regulator_id",
                                                label:LangHelper.GetString("UlrModule","Regulator"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                },
                                                required:true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                            this.validate();
                                                    }
                                                }
                                            },
                                            {
                                                view:"spectre_richselect",
                                                name:"category_id",
                                                label:LangHelper.GetString("UlrModule","Category"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                },
                                                required:true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov) {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                            this.validate();
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                rows:[
                                                    {
                                                        view:"spectre_textarea",
                                                        name:"description_public",
                                                        label:LangHelper.GetString("UlrModule","Reason"),
                                                        required:true,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(typeof Ov !== "undefined" && Ov !== "")
                                                                {
                                                                    if(Nv != Nv.trim())
                                                                    {
                                                                        this.setValue(Nv.trim());
                                                                        return;
                                                                    }
                                                                    this.validate();
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"label",
                                                        css:"form_text_description_label",
                                                        label:LangHelper.GetString("UlrModule","This description will be shown if you have public blacklist database")
                                                    }
                                                ]
                                            },
                                            {
                                                rows:[
                                                    {
                                                        view:"spectre_textarea",
                                                        name:"description_private",
                                                        label:LangHelper.GetString("UlrModule","Description"),
                                                        required:true,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(typeof Ov !== "undefined" && Ov !== "")
                                                                {
                                                                    if(Nv != Nv.trim())
                                                                    {
                                                                        this.setValue(Nv.trim());
                                                                        return;
                                                                    }
                                                                    this.validate();
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view:"label",
                                                        css:"form_text_description_label",
                                                        label:LangHelper.GetString("UlrModule","This is internal description helps you to find this rule to edit  or change state")
                                                    }
                                                ]
                                            }

                                        ]
                                    }
                                ]
                            },

                            {
                                type:"wide",
                                id: this.Id + "AddResourceSection",
                                borderless: true,
                                rows:[
                                    {
                                        height:48
                                    },
                                    {
                                        cols: [
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","Resource"), icon:"",
                                                borderless:true,
                                                css: "custom__app-block-header-with-icon"
                                            }),
                                            {
                                                view: "spectre_button",
                                                id:_this.Id + "BgpPrefixHelpBtn",
                                                type: "icon",
                                                icon: "question-circle",
                                                css:"toolbar_round_btn custom-form-btn",
                                                width:32,
                                                height:25,
                                                tooltip:LangHelper.GetString("UlrModule", "Help"),
                                                click:function (id)
                                                {
                                                    UlrShowImportSpoofDnsHelpPopup();
                                                }
                                            },
                                            {}
                                        ]
                                    },
                                    {
                                        view:"form",
                                        id:this.Id + "AddResourceForm",
                                        type: "wide",
                                        elements:[
                                            {
                                                type:"clean",
                                                rows:[
                                                    {
                                                        view:"label",
                                                        css:"form_text_label",
                                                        label: LangHelper.GetString("UlrModule", "Specify Host, DNS Record Type, Action, and Response.")
                                                        // label: function() {
                                                        //     if (AppEnv.spoof_dns_disabled_ipv6)
                                                        //         return LangHelper.GetString("UlrModule", "Enter the host you need in the host field and specify IPv4 in the ip field");
                                                        //     else
                                                        //         return LangHelper.GetString("UlrModule", "Enter the host you need in the host field and specify IPv4/IPv6 in the ip field");
                                                        // }()
                                                    },
                                                    {
                                                        type: "wide",
                                                        cols:[
                                                            {
                                                                view:"spectre_text",
                                                                id:this.Id + "AddResourceInput",
                                                                name:"host",
                                                                label:LangHelper.GetString("UlrModule","Host"),
                                                                validate: function(Val) {
                                                                    if (Val == "")
                                                                        return false

                                                                    return true;
                                                                },
                                                                invalidMessage: LangHelper.GetString("UlrModule", "Enter the correct host")
                                                            },
                                                            {
                                                                view: "spectre_richselect",
                                                                id: this.Id + "ResourceTypeSelect",
                                                                name: "resource_type",
                                                                label: LangHelper.GetString("UlrModule", "DNS Record Type"),
                                                                options: Helper.DictToArr(UlrDnsRecordTypesDic),
                                                                value: UlrDnsRecordTypesDic.ip.id,
                                                                width: 200
                                                            },
                                                            {
                                                                type: "wide",
                                                                cols:[
                                                                    {
                                                                        view: "spectre_richselect",
                                                                        id: this.Id + "ActionTypeSelect",
                                                                        name: "action_type",
                                                                        label: LangHelper.GetString("UlrModule", "Action type"),
                                                                        width: 200,
                                                                        options: Helper.DictToArr(UlrDnsResponseActionsDic),
                                                                        value: UlrDnsResponseActionsDic.spoof.id
                                                                    },
                                                                    {
                                                                        view:"spectre_text",
                                                                        id:this.Id + "IpResourceInput",
                                                                        name:"ip",
                                                                        css: "form_element",
                                                                        label:LangHelper.GetString("UlrModule","Response"),
                                                                        validate: function(Val) {
                                                                            if (Val === "clear")
                                                                                return true;

                                                                            if(_this.Views.ActionTypeSelect.getValue() == UlrDnsResponseActionsDic.spoof.id)
                                                                            {
                                                                                if(_this.Views.ResourceTypeSelect.getValue() == UlrDnsRecordTypesDic.ip.id)
                                                                                {
                                                                                    if (AppEnv.spoof_dns_disabled_ipv6)
                                                                                    {
                                                                                        if (Helper.ValidateIPv4(Val))
                                                                                            return true;
                                                                                    }
                                                                                    else
                                                                                    {
                                                                                        if (Helper.ValidateIPv4(Val) || Helper.ValidateIPv6(Val))
                                                                                            return true;
                                                                                    }

                                                                                    return false;
                                                                                }

                                                                                return Val && Val != '';
                                                                            }

                                                                            return true;
                                                                        },
                                                                        invalidMessage: function() {
                                                                            if (AppEnv.spoof_dns_disabled_ipv6)
                                                                                return LangHelper.GetString("UlrModule", "Enter the correct value")
                                                                            else
                                                                                return LangHelper.GetString("UlrModule", "Enter the correct value")
                                                                        }()
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        height:20
                                                    },
                                                    {
                                                        type:"wide",
                                                        rows:[
                                                            {
                                                                type:"wide",
                                                                cols:[
                                                                    {
                                                                        view:"spectre_button",
                                                                        id:this.Id + "AddResourceBtn",
                                                                        type:"icon",
                                                                        css:"form_button spec_action with_icon",
                                                                        label:LangHelper.GetString("UlrModule","Add to list"),
                                                                        icon:"plus-circle",
                                                                        autowidth:true,
                                                                        click:function ()
                                                                        {
                                                                            _this.ValidateFormResource();
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"spectre_button",
                                                                        id:this.Id + "FileImportBtn",
                                                                        type:"icon",
                                                                        css:"form_button spec_action with_icon",
                                                                        label:LangHelper.GetString("UlrModule","Import resources"),
                                                                        icon:"arrow-left",
                                                                        autowidth:true,
                                                                        click:function ()
                                                                        {
                                                                            _this.ShowImportForm();
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"spectre_button",
                                                                        id:this.Id + "FromFileImportBtn",
                                                                        type:"icon",
                                                                        css:"form_button spec_action with_icon ulr_with_badge",
                                                                        label:LangHelper.GetString("UlrModule","Import from file"),
                                                                        icon:"file",
                                                                        badge: 0,
                                                                        autowidth:true,
                                                                        click:function ()
                                                                        {
                                                                            _this.ImportFilesPopup.show();
                                                                            _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                                                                        }
                                                                    },
                                                                    {}
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                height:48
                            },
                            {
                                id: this.Id + "AddedResourcesReportSection",
                                hidden: true,
                                rows: [
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Just added resources"), icon:"",
                                        borderless:true
                                    }),
                                    this.Views.ReportsWidgets.AddedResourcesReport.ViewConfig,
                                    {
                                        height: 48
                                    }
                                ]
                            },
                            {
                                id: this.Id + "ResourceListReportSection",
                                hidden: true,
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","List of resources"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        height:20
                                    },
                                    this.Views.ReportsWidgets.ResourcesReport.ViewConfig,
                                    {
                                        height:20
                                    },
                                    {
                                        cols:[
                                            {
                                                view:"spectre_button",
                                                id:this.Id+"ClearAllResources",
                                                css:"form_button spec_action",
                                                label:LangHelper.GetString("UlrModule","Clear all"),
                                                autowidth:true,
                                                click:function ()
                                                {
                                                    _this.ClearResources();
                                                }
                                            },
                                            {}
                                        ]
                                    },
                                    {
                                        height:48
                                    }
                                ]
                            },
                            {
                                id: this.Id + "ChannelsAndSubscribersSection",
                                rows:[
                                    ...this.IspsList.ViewConfig,
                                    {height: 48},
                                    ...this.SubsList.ViewConfig,
                                    {
                                        height:48
                                    }
                                ]
                            },

                            {
                                type:"wide",
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Actions log"), icon:"",
                                        borderless:true
                                    }),
                                    this.Views.ReportsWidgets.ActionsLog.ViewConfig
                                ]
                            },
                            {
                                height:32
                            },
                            {
                                type:"wide",
                                cols:[
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveBtn",
                                        css:"form_button main_action",
                                        label:LangHelper.GetString("UlrModule","Save changes"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save();
                                        }
                                    },
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveEnableBtn",
                                        css:"form_button second_action",
                                        label:LangHelper.GetString("UlrModule","Save and enable"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save(true);
                                        },
                                        hidden:true
                                    },
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveDisableBtn",
                                        css:"form_button second_action",
                                        label:LangHelper.GetString("UlrModule","Save and disable"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save(false);
                                        },
                                        hidden:true
                                    },
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "ExportRuleBtn",
                                        css:"form_button third_action",
                                        label:LangHelper.GetString("UlrModule","Export rule"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.ShowRuleExportForm();
                                        },
                                        hidden:true
                                    },
                                    {},
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "DeleteBtn",
                                        css:"form_button delete_action",
                                        label:LangHelper.GetString("UlrModule","Delete rule"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Delete();
                                        },
                                        hidden:true
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.ExportRulePopup = null;

    this.ImportPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ImportPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Import resources"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        _this.ImportPopup.hide();
                    }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view:"template",
                            borderless:false,
                            border:2,
                            css:"form_text_warning_label",
                            height:40,
                            template:"<span class='warning'>"+LangHelper.GetString("UlrModule","Warning")+"</span>" + ": " + (AppEnv.spoof_dns_disabled_ipv6 ? LangHelper.GetString("UlrModule","Resources other than IPv4 will be skipped") : LangHelper.GetString("UlrModule","Resources other than IPv4/IPv6 will be skipped"))
                        },
                        {height:20},
                        {
                            view: "form",
                            id: this.Id + "ImportPopupForm",
                            type: "wide",
                            minWidth:560,
                            minHeight:400,
                            elements: [
                                {
                                    view:"spectre_textarea",
                                    id:this.Id + "ImportPopupEditor",
                                    label:LangHelper.GetString("UlrModule","File or clipboard content to import"),
                                    height:undefined,
                                    value:""
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ImportPopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Import"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ImportFile();
                                            _this.ImportPopup.hide();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ExportRulePopup = null;

    this.ExportRulePopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ExportRulePopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Export rule"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.ExportRulePopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ExportRulePopupForm",
                            type: "wide",
                            elements: [
                                {
                                    view:"datatable",
                                    id: this.Id + "ExportRulePopupResTable",
                                    header:false,
                                    hidden:true,
                                    columns: function ()
                                    {
                                        var cols = [];

                                        cols.push.apply(cols,[
                                            {
                                                id: "enabled",
                                                header:"",
                                                sort: false,
                                                template:function (Obj) {
                                                    return Obj.enabled ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");
                                                }
                                            },
                                            {
                                                id: "create_time",
                                                header: [LangHelper.GetString("UlrModule","Date")],
                                                sort: "string",
                                                template:function(Obj)
                                                {
                                                    if(Obj.create_time)
                                                    {
                                                        var update = new Date(Obj.create_time);
                                                        var offset = update.getTimezoneOffset();
                                                        if(offset != 0)
                                                        {
                                                            var n_date = new Date(update.getTime() - offset*60*1000);

                                                            return CellSpectreDateTemplate(n_date);
                                                        }
                                                    }
                                                    return CellSpectreDateTemplate(Obj.create_time);
                                                }
                                            },
                                            {
                                                id: "type_id",
                                                header: [LangHelper.GetString("UlrModule","Type")],
                                                sort: "text",
                                                template:function (Obj)
                                                {
                                                    var dic = App.DicsManager.GetDic(DicsEnum.UlrResourceTypesDic);

                                                    return dic[Obj.type_id] ? dic[Obj.type_id].value : Obj.type_id;
                                                }
                                            },
                                            {
                                                id: "resource_raw",
                                                header: [LangHelper.GetString("UlrModule","Resource raw")],
                                                sort: "string"
                                            },
                                            {
                                                id: "resource_validated",
                                                header: [LangHelper.GetString("UlrModule","Resource validated")],
                                                sort: "string"
                                            },
                                            {
                                                id: "status",
                                                header: [LangHelper.GetString("UlrModule","Status")],
                                                sort: "text",
                                                template:function (Obj)
                                                {
                                                    var error = parseInt(Obj.state_error);
                                                    var valid = parseInt(Obj.state_valid);

                                                    if(error)
                                                        return '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Error") + '</span>';

                                                    if(valid == UlrStateValidEnum.valid)
                                                        return LangHelper.GetString("UlrModule","Valid");

                                                    if(valid == UlrStateValidEnum.invalid)
                                                        return '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Invalid") + '</span>';

                                                    if(valid == UlrStateValidEnum.undefined)
                                                        return LangHelper.GetString("UlrModule","No validation");

                                                    return "";
                                                }
                                            }
                                        ]);
                                        return cols;
                                    }()
                                },
                                {
                                    cols:[
                                        {
                                            view:"spectre_richselect",
                                            id: this.Id + "ExportRulePopupType",
                                            label:LangHelper.GetString("UlrModule","Export format"),
                                            value:"toPDF",
                                            options:{
                                                point:false,
                                                data:[
                                                    {id: "toPDF", value: LangHelper.GetString("UlrModule","Export to PDF")},
                                                    {id: "toExcel", value: LangHelper.GetString("UlrModule","Export to Excel")},
                                                    {id: "toCSV", value: LangHelper.GetString("UlrModule","Export to CSV")}
                                                ]
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ExportRulePopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Export"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ExportRule();
                                            _this.ExportRulePopup.hide();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ImportFilesPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ImportFilesPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Import from file"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        _this.ImportFilesPopup.hide();
                    }
                }
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ImportFilesPopupForm",
                            type: "wide",
                            minWidth:720,
                            minHeight:400,
                            elements: [
                                {
                                    view:"template",
                                    borderless:false,
                                    border:2,
                                    css:"form_text_warning_label",
                                    height:40,
                                    template:"<span class='warning'>"+LangHelper.GetString("UlrModule","Warning")+"</span>" + ": " + (AppEnv.spoof_dns_disabled_ipv6 ? LangHelper.GetString("UlrModule","Resources other than IPv4 will be skipped") : LangHelper.GetString("UlrModule","Resources other than IPv4/IPv6 will be skipped"))
                                },
                                {
                                    view: "uploader",
                                    value: LangHelper.GetString("UlrModule","Click to upload or drag a file here"),
                                    id: this.Id+"ImportFilesPopupUploader",
                                    css:"upload_area form_button spec_action",
                                    autosend:false,
                                    height:64
                                },
                                this.Views.ReportsWidgets.ImportedFilesReport.ViewConfig
                            ]
                        },

                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {},
                                {
                                    view:"spectre_button",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Close"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ImportFilesPopup.hide();
                                        },1);
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ImportFilesPopup = webix.ui(this.ImportFilesPopupConfig);

    this.Subscriptions = {};

    this.Signals = {
        RuleEnabled: new Rx.BehaviorSubject(0),
        RuleIspModeChanged: new Rx.BehaviorSubject(0),
        ValuedResource:new Rx.BehaviorSubject(null),
        ShowJustAdded: new Rx.BehaviorSubject(false),
        ShowResourceList: new Rx.BehaviorSubject(false),
        ImportedFilesCountChange: new Rx.BehaviorSubject(0)
    };

    this.AddedResources = [];
    this.ModifiedResources = [];
    this.DeletedResources = [];
    this.DeleteAllResources = false;
    this.ImportFilesArr = [];

    this.Views.ReportsWidgets.ResourcesReport.DataAdapter = function(Data)
    {
        var res = Data;

        if(res.rows && Array.isArray(res.rows))
        {
            res.rows.forEach((row, i) =>{
                const item = _this.ModifiedResources.find(obj => obj._id == row._id);

                if(item && item.enabled != row.enabled)
                {
                    res.rows[i].enabled = item.enabled;
                }
            });
        }

        return res;
    };
}

UlrEditSpoofDnsRuleViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.ImportPopup = webix.ui(this.ImportPopupConfig);

    this.ExportRulePopup = webix.ui(this.ExportRulePopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress)
    {
        var view = _this.Views.SaveBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveEnableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveDisableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.ExportRuleBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.DeleteBtn;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions[DicsEnum.UlrRegulatorsDic] = App.DicsManager.Signal[DicsEnum.UlrRegulatorsDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.RuleEditForm.elements.regulator_id.getList().clearAll();
            _this.Views.RuleEditForm.elements.regulator_id.getList().parse(Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrRegulatorsDic)));
        }
    });

    this.Subscriptions[DicsEnum.UlrCategoriesDic] = App.DicsManager.Signal[DicsEnum.UlrCategoriesDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.RuleEditForm.elements.category_id.getList().clearAll();
            _this.Views.RuleEditForm.elements.category_id.getList().parse(Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrCategoriesDic)));
        }
    });

    this.Subscriptions.RuleProfileUpdated = this.ViewModel.Signals.RuleProfileUpdated.subscribe(function (RuleModel) {
        if(RuleModel)
        {
            _this.DefineAll(RuleModel);
        }
    });

    this.Subscriptions.RuleProfileError = this.ViewModel.Signals.RuleProfileError.subscribe(function (ErrModel)
    {
        var action = null;

        if(ErrModel&&ErrModel.code == 404)
        {
            action = function ()
            {
                setTimeout(function ()
                {
                    App.NavRouter.PresentView({id: ControllersEnum.UlrSpoofDnsRules});
                }, 1);
            }
        }

        _this.ShowServerError(ErrModel, action);
    });

    this.Subscriptions.RuleProfileSaveError = this.ViewModel.Signals.RuleProfileSaveError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RuleProfileDeleteError = this.ViewModel.Signals.RuleProfileDeleteError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RuleProfileSaved = this.ViewModel.Signals.RuleProfileSaved.subscribe(function (RuleProfileModel)
    {
        if(RuleProfileModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", "Spoof DNS")+" # "+RuleProfileModel.profile._id+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id:  ControllersEnum.UlrSpoofDnsRules});
            },1);
        }
    });

    this.Subscriptions.RuleProfileDeleted = this.ViewModel.Signals.RuleProfileDeleted.subscribe(function (RuleModel)
    {
        if(RuleModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", "Spoof DNS")+" #"+RuleModel._id+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: ControllersEnum.UlrSpoofDnsRules});
            },1);
        }
    });

    this.Subscriptions.RuleEnabled = this.Signals.RuleEnabled.subscribe(function (Enabled)
    {
        var view = _this.Views.SaveDisableBtn;
        Enabled ? view.show() : view.hide();

        var view = _this.Views.SaveEnableBtn;
        !Enabled ? view.show() : view.hide();
    });

    this.Subscriptions.ShowJustAddedResources = this.Signals.ShowJustAdded.subscribe(function(Show)
    {
        Show ? _this.Views.AddedResourcesReportSection.show() : _this.Views.AddedResourcesReportSection.hide();
    });

    this.Subscriptions.ShowResourceList = this.Signals.ShowResourceList.subscribe(function(Show)
    {
        Show ? _this.Views.ResourceListReportSection.show() : _this.Views.ResourceListReportSection.hide();
    });

    this.Views.ImportFilesPopupUploader.attachEvent("onAfterFileAdd", function(FileObj){
        if(FileObj)
        {
            _this.OnFileAdded(FileObj);
        }
    });

    this.Subscriptions.ImportFilesCountChange = this.Signals.ImportedFilesCountChange.subscribe(function(Val)
    {
        _this.DefineImportFilesBtnBadge(Val);
    });

    this.Views.ResourceTypeSelect.attachEvent("onChange", function(Nv, Ov)
    {
        var opts = Helper.DictToArr(UlrDnsResponseActionsDic);

        var curr_val = _this.Views.ActionTypeSelect.getValue();

        if(Nv == UlrDnsRecordTypesDic.HTTPS.id)
        {
            opts = opts.filter(v => v.id != UlrDnsResponseActionsDic.spoof.id);

            if(curr_val == UlrDnsResponseActionsDic.spoof.id)
            {
                curr_val = UlrDnsResponseActionsDic.drop.id;
            }
        }

        _this.Views.ActionTypeSelect.getList().clearAll();
        _this.Views.ActionTypeSelect.getList().parse(opts);
        _this.Views.ActionTypeSelect.setValue(curr_val);
    });

    this.Views.ActionTypeSelect.attachEvent("onChange", function(Nv, Ov)
    {
        if(Nv == UlrDnsResponseActionsDic.spoof.id)
        {
            _this.Views.IpResourceInput.enable();
        }
        else
        {
            _this.Views.IpResourceInput.disable();
        }
    });

};

UlrEditSpoofDnsRuleViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.IspsList.ViewDidLoad(PathParams);
    this.SubsList.ViewDidLoad(PathParams);

    this.BindAll(PathParams);

    this.Signals.ShowJustAdded.next(this.Action == this.ActionsEnum.Add)
    this.Signals.ShowResourceList.next(this.Action != this.ActionsEnum.Add)

    this.Refresh();
};

UlrEditSpoofDnsRuleViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if(this.IspsList)
    {
        this.IspsList.Destroy();
    }

    if(this.SubsList)
    {
        this.SubsList.Destroy();
    }
};

UlrEditSpoofDnsRuleViewController.prototype.RefreshRuleProfile = function ()
{
    var id = this.Action == this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    this.ViewModel.ResfreshSpoofDnsProfile({_id: id, type_id: this.RuleTypeId});

    this.DefinePageTitle((this.Action == this.ActionsEnum.Add ? LangHelper.GetString("UlrModule","Add rule") : LangHelper.GetString("UlrModule","Edit rule")) + " #" + id);

    if(this.Action == this.ActionsEnum.Edit)
    {
        this.Views.RuleEditFormEnabledStateView.show();
        this.Views.RuleEditFormEnabledSpacerView.show();
        this.Views.ExportRuleBtn.show();
        this.Views.DeleteBtn.show();
    }
};

UlrEditSpoofDnsRuleViewController.prototype.Refresh = function ()
{
    this.RefreshRuleProfile();
};

UlrEditSpoofDnsRuleViewController.prototype.RefreshResources = function()
{
    if(this.Action != this.ActionsEnum.Add && this.GetPathParam("_id"))
    {
        var filter = {
            rule_id: {
                id: "rule_id",
                operator: "=",
                value: this.GetPathParam("_id")
            },
            type_id: {
                id: "type_id",
                operator: "!=",
                value: UlrWebRuleResourcesTypesMapEnum.empty
            }
        };

        this.Views.ReportsWidgets.ResourcesReport.RefreshData(null,{
            filter: filter
        });
    }
};

UlrEditSpoofDnsRuleViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrEditSpoofDnsRuleViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

UlrEditSpoofDnsRuleViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditSpoofDnsRuleViewController.prototype.DefinePageTitle = function(Title)
{
    this.Views.PageTitle.define("data", {root_title:Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

UlrEditSpoofDnsRuleViewController.prototype.DefineAll = function(RuleModel)
{
    var _this = this;

    if(RuleModel.is_system)
    {
        this.Views.AddResourceSection.hide();
        this.Views.ChannelsAndSubscribersSection.hide();
        this.Views.ClearAllResources.hide();
        this.Views.SaveBtn.disable();
        this.Views.SaveEnableBtn.disable();
        this.Views.SaveDisableBtn.disable();
        this.Views.DeleteBtn.disable();

        this.Views.ReportsWidgets.ResourcesReport.HideColumns(['enabled', 'delete']);
    }
    else
    {
        this.Views.AddResourceSection.show();
        this.Views.ChannelsAndSubscribersSection.show();
        this.Views.ClearAllResources.show();
        this.Views.SaveBtn.enable();
        this.Views.SaveEnableBtn.enable();
        this.Views.SaveDisableBtn.enable();
        this.Views.DeleteBtn.enable();
    }

    this.Views.RuleEditForm.clearValidation();
    this.Views.RuleEditForm.clear();

    this.Views.RuleEditForm.setValues(RuleModel.profile);

    this.Signals.RuleEnabled.next(parseInt(RuleModel.profile.enabled));


    var ispsVals = {};

    RuleModel.isps.rows.forEach(function (Item)
    {
        ispsVals[""+Item.isp_id] = 1;
    });

    this.IspsList.setForm(ispsVals,parseInt(RuleModel.profile.mode_id));
    this.SubsList.setForm(ispsVals,parseInt(RuleModel.profile.subs_mode_id));


    this.Views.ReportsWidgets.ActionsLog.Filter = {
        row_id:{
            id:"row_id",
            operator:"=",
            value:RuleModel.profile._id ? RuleModel.profile._id : -1
        }
    };

    this.Views.ReportsWidgets.ActionsLog.RefreshData();

    this.RefreshResources();
};

UlrEditSpoofDnsRuleViewController.prototype.JustAddResource = function(ResourceModel, MultiInsert)
{
    var table = this.Views.ReportsWidgets.AddedResourcesReport.Views.Table;

    if(!MultiInsert)
    {
        var model = new UlrSpoofDnsRuleResourceModel(ResourceModel);
        this.AddedResources.push(model);
    }
    else
    {
        ResourceModel.forEach((Item) => {
            var model = new UlrSpoofDnsRuleResourceModel(Item);
            this.AddedResources.push(model);
        });
    }

    this.ShowHideAddedResourcesTable();

    this.Views.ReportsWidgets.AddedResourcesReport.RefreshData();
};

UlrEditSpoofDnsRuleViewController.prototype.ShowHideAddedResourcesTable = function()
{
    this.Signals.ShowJustAdded.next(this.AddedResources.length > 0);
};

UlrEditSpoofDnsRuleViewController.prototype.ClearResources = function()
{
    var table = this.Views.ReportsWidgets.ResourcesReport.Views.Table;

    this.DeleteAllResources = true;

    var filter = {
        rule_id: {
            id: "rule_id",
            operator: "=",
            value: this.GetPathParam("_id")
        },
        rule_id_neq: {
            id: "rule_id",
            operator: "!=",
            value: this.GetPathParam("_id")
        }
    };

    this.Views.ReportsWidgets.ResourcesReport.ExternalFilter = filter;

    table.clearAll();
};

UlrEditSpoofDnsRuleViewController.prototype.AddedResourcesReportOnItemClick = function(Id)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.AddedResourcesReport.Views.Table;

    var item = table.getItem(Id);

    if(Id.column === 'delete')
    {
        if(item)
        {
            const index = this.AddedResources.findIndex(x => x.id == item.id);
            if(index > -1)
            {
                this.AddedResources.splice(index, 1);
                this.Views.ReportsWidgets.AddedResourcesReport.RefreshData();
                this.ShowHideAddedResourcesTable();
            }
        }

        table.remove(Id);
    }
};

UlrEditSpoofDnsRuleViewController.prototype.ResourcesReportOnItemClick = function(Row, Column)
{
    if (Column === 'delete' || Column === 'enabled') {
        var table = this.Views.ReportsWidgets.ResourcesReport.Views.Table;
        var item = table.getItem(Row);
        if (item)
        {
            if(Column === 'delete')
            {
                this.DeletedResources.push(item);
                table.remove(Row);

                var filter = {
                    rule_id: {
                        id: "rule_id",
                        operator: "=",
                        value: this.GetPathParam("_id")
                    }
                };

                var deleted = [];

                this.DeletedResources.forEach((item) => {
                    const _id = parseInt(item._id);

                    if(_id)
                    {
                        deleted.push(_id);
                    }
                });

                if(deleted.length > 0)
                {
                    filter._ids = {
                        id: "_id",
                        operator: "not in",
                        value: deleted
                    };
                }

                this.Views.ReportsWidgets.ResourcesReport.ExternalFilter = filter;
            }
            else if(Column === 'enabled')
            {
                this.ModifiedResources.push(item);
            }
        }
    }
};

UlrEditSpoofDnsRuleViewController.prototype.SelectAllIsps = function()
{
    var vals = this.Views.ISPListForm.getValues();

    Object.keys(vals).forEach(function (Key) {
        vals[Key] = 1;
    });

    this.Views.ISPListForm.setValues(vals);
};

UlrEditSpoofDnsRuleViewController.prototype.UnselectAllIsps = function()
{
    var vals = this.Views.ISPListForm.getValues();

    Object.keys(vals).forEach(function (Key) {
        vals[Key] = 0;
    });

    this.Views.ISPListForm.setValues(vals);
};

UlrEditSpoofDnsRuleViewController.prototype.Save = function(Enable)
{
    if(!this.Views.RuleEditForm.validate())
    {
        this.Views.ScrollView.scrollTo(0, 0);
        return;
    }

    var model = new UlrSpoofDnsRuleViewModel();

    model.profile = new UlrSpoofDnsRuleModel(this.Views.RuleEditForm.getValues());

    if(typeof Enable != "undefined")
    {
        model.profile.enabled = Enable ? 1 : 0;
    }

    model.profile.mode_id = parseInt(this.IspsList.Views.RuleModeToggle.getValue());
    model.profile.subs_mode_id = parseInt(this.SubsList.Views.RuleModeToggle.getValue());

    model.resources = {
        added: this.AddedResources,
        modified: this.ModifiedResources,
        deleted: this.DeletedResources,
        deleteAllResources: this.DeleteAllResources,
        importFiles: []
    };

    this.ImportFilesArr.forEach((Model) => {
        if(Model.filepath)
        {
            model.resources.importFiles.push(Model.filepath);
        }
    });

    model.isps = [];

    if(model.profile.mode_id == 2)
    {
        var isps = this.IspsList.getSelectedIsps();
        isps.forEach(isp_id => {
            model.isps.push({isp_id:isp_id});
        });
    }

    if(model.profile.subs_mode_id == 2)
    {
        var isps = this.SubsList.getSelectedIsps();
        isps.forEach(isp_id => {
            model.isps.push({isp_id:isp_id});
        });
    }

    this.ViewModel.SaveSpoofDnsRuleProfile(model);
};

UlrEditSpoofDnsRuleViewController.prototype.Delete = function()
{
    var _this = this;

    var model = this.ViewModel.Signals.RuleProfileUpdated.getValue();

    UlrShowDialogPopup({
        node:this.Views.DeleteBtn.getNode(),
        position:"bottom",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    _this.ViewModel.DeleteSpoofDnsRule(model);
                }
            }
        ]
    });


};

UlrEditSpoofDnsRuleViewController.prototype.ValidateFormResource = function()
{
    if(!this.Views.AddResourceInput.validate())
        return;

    if(this.Views.ActionTypeSelect.getValue() != UlrDnsResponseActionsDic.spoof.id && !this.Views.IpResourceInput.validate())
    {
        return;
    }
    var host = this.Views.AddResourceInput.getValue().trim();

    var ip = '', type = this.Views.ResourceTypeSelect.getValue();

    if(this.Views.ActionTypeSelect.getValue() == UlrDnsResponseActionsDic.spoof.id)
    {
        ip = this.Views.IpResourceInput.getValue().trim();
    }
    else
    {
        ip = "#" + this.Views.ActionTypeSelect.getValue().trim();
    }

    this.AddResource(host, ip, type);
};

UlrEditSpoofDnsRuleViewController.prototype.ShowServerError = function(ErrModel, Action)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};

UlrEditSpoofDnsRuleViewController.prototype.ImportFile = function ()
{
    var _this = this;

    var value = this.Views.ImportPopupEditor.getValue();

    if(!value)
        return;

    var lines = value.split(/\r|\n/);

    var firstLine = lines[0];

    var colsMap = {
        host: 0,
        type: 1,
        response: 2
    };

    if(firstLine.indexOf("host") > -1 && (firstLine.indexOf("ip") > -1 || firstLine.indexOf("response") > -1) )
    {
        lines.shift();

        var headersIds = firstLine.trim().split("\t");

        headersIds.forEach(function (Item, Index)
        {
            if(Item == "host" || Item == "type")
                colsMap[Item] = Index;
            if(Item == "response" || Item == "ip")
                colsMap.response = Index;
        });
    }

    if(firstLine.indexOf(LangHelper.GetString("UlrModule","Host"))  > -1 && (firstLine.indexOf(LangHelper.GetString("UlrModule","IP")) > -1 || firstLine.indexOf(LangHelper.GetString("UlrModule","Response")) > -1))
    {
        lines.shift();

        var headersIds = firstLine.trim().split("\t");

        headersIds.forEach(function (Item, Index)
        {
            if(Item == LangHelper.GetString("UlrModule","Host"))
                colsMap.host = Index;

            if(Item == LangHelper.GetString("UlrModule","IP") || Item == LangHelper.GetString("UlrModule","Response"))
                colsMap.response  = Index;

            if(Item == LangHelper.GetString("UlrModule", "Type"))
                colsMap.type = Index;
        });
    }

    var models = [];
    let separators = [" ", ",", ";", "\t"];
    lines.forEach(function (Line)
    {
        var model = new UlrSpoofDnsRuleResourceModel();

        let lineSeparator = " ";

        for (let separator of separators) {
            if (Line.trim().split(separator).length > 1) {
                lineSeparator = separator;
                break;
            }
        }

        var cols = Line.trim().split(lineSeparator);

        if(cols.length > 1)
        {
            if(cols.length == 2)
            {
                var resp_index = colsMap.response;
                if(resp_index >= cols.length)
                {
                    resp_index = cols.length - 1;
                }

                let resource = ""
                if(cols[colsMap.host] && cols[resp_index])
                {
                    let correctItem = false;

                    const host = cols[colsMap.host].trim();
                    const ip = cols[resp_index].trim();

                    const
                        validateIPv4 = Helper.ValidateIPv4(ip),
                        validateIPv6 = Helper.ValidateIPv6(ip);

                    if (AppEnv.spoof_dns_disabled_ipv6)
                    {
                        if (validateIPv4 && host)
                            correctItem = true;
                    }
                    else
                    {
                        if ((validateIPv4 || validateIPv6) && host)
                            correctItem = true;
                    }

                    if (correctItem)
                    {
                        resource = `${host} ${validateIPv4 ? "A" : "AAAA"} ${ip}`

                        model.enabled = 1;
                        model.resource_raw = resource;
                        model.resource_validated = resource;

                        model.type_id = UlrWebRuleResourcesTypesMapEnum.sni;

                        if(model.resource_validated)
                            model.state_valid = UlrStateValidEnum.valid;

                        models.push(model);
                    }
                }
            }
            else if(cols.length == 3)
            {
                var host = cols[colsMap.host].trim();
                var type = cols[colsMap.type].trim().toUpperCase();
                var response = cols[colsMap.response].trim();

                if(host && response && type && ["A", "AAAA", "HTTPS", "MX"].includes(type))
                {
                    var resource = "";
                    model.type_id = UlrWebRuleResourcesTypesMapEnum.sni;
                    model.state_valid = UlrStateValidEnum.valid;
                    model.enabled = 1;

                    if(type == "MX" || response == UlrDnsResponseActionsDic.drop.value || response == UlrDnsResponseActionsDic.nxdomain.value)
                    {
                        resource = `${host} ${type} ${response}`
                    }
                    else if(type == "A" || type == "AAAA")
                    {
                        let correctItem = false;

                        const
                            validateIPv4 = Helper.ValidateIPv4(response),
                            validateIPv6 = Helper.ValidateIPv6(response);

                        if (AppEnv.spoof_dns_disabled_ipv6)
                        {
                            if (validateIPv4 && host)
                                correctItem = true;
                        }
                        else
                        {
                            if ((validateIPv4 || validateIPv6) && host)
                                correctItem = true;
                        }

                        if (correctItem)
                        {
                            resource = `${host} ${validateIPv4 ? "A" : "AAAA"} ${response}`
                        }
                    }

                    if(resource)
                    {
                        model.resource_raw = resource;
                        model.resource_validated = resource;
                        models.push(model);
                    }
                }
            }
        }
    });

    if(models.length > 0)
    {
        _this.JustAddResource(models, true);
    }

    this.Views.ImportPopupEditor.setValue("");
};

UlrEditSpoofDnsRuleViewController.prototype.ShowImportForm = function()
{
    this.Views.ImportPopupEditor.setValue("");

    this.ImportPopup.show();
};

UlrEditSpoofDnsRuleViewController.prototype.ShowRuleExportForm = function()
{
    this.ExportRulePopup.show();
};

UlrEditSpoofDnsRuleViewController.prototype.ExportRule = function()
{
    var exportType = this.Views.ExportRulePopupType.getValue();

    var tableRes = this.Views.ExportRulePopupResTable;

    var dataRes = this.Views.ReportsWidgets.ResourcesReport.Views.Table.serialize();
    var form = this.Views.RuleEditForm.getValues();

    tableRes.clearAll();
    tableRes.parse(dataRes);

    if(exportType == "toCSV" || exportType == "toExcel")
    {
        dataRes.forEach(function (Item)
        {
            Item.rule_id = form._id;
            Item.category = App.DicsManager.GetDic(DicsEnum.UlrCategoriesDic)[form.category_id] ? App.DicsManager.GetDic(DicsEnum.UlrCategoriesDic)[form.category_id].value : form.category_id;
            Item.regulator = App.DicsManager.GetDic(DicsEnum.UlrRegulatorsDic)[form.regulator_id] ? App.DicsManager.GetDic(DicsEnum.UlrRegulatorsDic)[form.regulator_id].value : form.regulator_id;
            Item.description_public = form.description_public;
            Item.description_private = form.description_private;
        });
    }

    var dataHeader = [];

    dataHeader.push({
        key:LangHelper.GetString("UlrModule","Rule id"),
        value:form._id ? form._id : "new"
    });

    dataHeader.push({
        key:LangHelper.GetString("UlrModule","Regulator"),
        value:App.DicsManager.GetDic(DicsEnum.UlrRegulatorsDic)[form.regulator_id] ? App.DicsManager.GetDic(DicsEnum.UlrRegulatorsDic)[form.regulator_id].value : form.regulator_id
    });

    dataHeader.push({
        key:LangHelper.GetString("UlrModule","Category"),
        value:App.DicsManager.GetDic(DicsEnum.UlrCategoriesDic)[form.category_id] ? App.DicsManager.GetDic(DicsEnum.UlrCategoriesDic)[form.category_id].value : form.category_id
    });

    dataHeader.push({
        key:LangHelper.GetString("UlrModule","Description public"),
        value:form.description_public
    });

    dataHeader.push({
        key:LangHelper.GetString("UlrModule","Description private"),
        value:form.description_private
    });

    webix[exportType](tableRes,{
        filename:LangHelper.GetString("UlrModule","Spoof DNS rule") + " " + (form._id ? form._id : "new"),
        autowidth:true,
        orientation:"landscape",
        filterHTML:true,
        docHeader:exportType == "toPDF" ? {
            text: function () {
                var str = "";

                dataHeader.forEach(function (Item)
                {
                    str += Item.key + ": " + Item.value + "\n\n";
                });

                return str;
            }(),
            textAlign:"left",
            fontSize:12,
            color:0x4F4F4F
        }:null,
        header:{
            textAlign:"left",
            fontSize:12,
            backgroundColor:0xEFF4F5,
            color:0x4F4F4F,
            borderWidth:0,
            paddingLeft:16,
            paddingRight:16
        },
        table:{
            textAlign:"left",
            fontSize:12,
            backgroundColor:0xFFFFFF,
            color:0x4F4F4F,
            paddingLeft:16,
            paddingRight:16
        },
        columns:function ()
        {
            var cols = {};

            tableRes.config.columns.forEach(function (Item)
            {
                cols[Item.id] = true;
            });

            if(exportType == "toCSV" || exportType == "toExcel")
            {
                cols["rule_id"] = {
                    header:LangHelper.GetString("UlrModule","Rule id")
                };

                cols["category"] = {
                    header:LangHelper.GetString("UlrModule","Category")
                };

                cols["regulator"] = {
                    header:LangHelper.GetString("UlrModule","Regulator")
                };

                cols["description_public"] = {
                    header:LangHelper.GetString("UlrModule","Description public")
                };

                cols["description_private"] = {
                    header:LangHelper.GetString("UlrModule","Description private")
                };
            }

            return cols;
        }()
    });
};

UlrEditSpoofDnsRuleViewController.prototype.OnFileAdded = function(FileObj)
{
    var _this = this;

    var model = {
        id: FileObj.id ? FileObj.id : webix.uid(),
        name: FileObj.name,
        size: FileObj.size,
        sizetext: FileObj.sizetext,
        state: UlrFilesStatusDic.new.id,
        uploadId: '',
        filepath: ''
    };

    this.ImportFilesArr.push(model);

    var modelIndex = this.ImportFilesArr.findIndex((Obj) => Obj.id == model.id);

    this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
    var path = "upload_files/";

    var fileName = webix.uid() + "_" + model.name;
    var result_fpath = path + fileName;

    var updateModelClosure = function(Model)
    {
        var modelIndex = _this.ImportFilesArr.findIndex((Obj) => Obj.id == Model.id);

        if(modelIndex > -1)
        {
            _this.ImportFilesArr[modelIndex] = Model;
            return true;
        }

        return false;
    };

    App.ServerManager.UlrGenerateFileUploadId({
        fileName: fileName,
        path: path,
        callback: function(R)
        {
            if(R.success && R.data)
            {
                var key = R.data.key ? R.data.key : webix.uid();

                model.uploadId = key;
                model.state = UlrFilesStatusDic.uploading.id;

                if(updateModelClosure(model))
                {
                    _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();

                    App.ServerManager.UploadFile({
                        key: key,
                        file: FileObj.file,
                        callback: function(R)
                        {
                            if(R.status != 200)
                            {
                                model.state = UlrFilesStatusDic.failed.id;
                            }
                            else
                            {
                                model.state = UlrFilesStatusDic.uploaded.id;
                                model.filepath = result_fpath;
                            }

                            if(updateModelClosure(model))
                            {
                                _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                                _this.ImportFilesArrUpdated();
                            }
                        }
                    });
                }

            }
            else if(R.error)
            {
                model.state = UlrFilesStatusDic.failed.id;
                if(updateModelClosure(model))
                {
                    _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                }
                _this.ShowServerError(R.error);
            }
        }
    });
};

UlrEditSpoofDnsRuleViewController.prototype.ImportFilesClick = function(Id)
{
    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.ImportedFilesReport.Views.Table;

        var item = table.getItem(Id);

        if(item)
        {
            const index = this.ImportFilesArr.findIndex(x => x.id == item.id);
            if(index > -1)
            {
                this.ImportFilesArr.splice(index, 1);
                this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                this.ImportFilesArrUpdated();

            }
        }

        table.remove(Id);
    }
};

UlrEditSpoofDnsRuleViewController.prototype.ImportFilesArrUpdated = function()
{
    var count = 0;
    this.ImportFilesArr.forEach((Item) => {
        if(Item.state == UlrFilesStatusDic.uploaded.id)
        {
            count++;
        }
    });

    this.Signals.ImportedFilesCountChange.next(count);
};

UlrEditSpoofDnsRuleViewController.prototype.DefineImportFilesBtnBadge = function(Count)
{
    var count = Count > 99 ? "99+" : Count;

    this.Views.FromFileImportBtn.define({badge: UlrButtonBadgeTemplate(count)});

    this.Views.FromFileImportBtn.refresh();
};

UlrEditSpoofDnsRuleViewController.prototype.AddResource = function(Host, Ip, Type)
{
    var _this = this;

    var models = [];

    if(Type == UlrDnsRecordTypesDic.ip.id && Ip.indexOf('#') > -1)
    {
        ['A', 'AAAA'].forEach(function(type)
        {
            var model = new UlrSpoofDnsRuleResourceModel();

            const resource = `${Host} ${type} ${Ip}`
            model.enabled = 1;
            model.resource_raw = resource;
            model.resource_validated = resource;
            model.type_id = UlrWebRuleResourcesTypesMapEnum.sni;

            models.push(model);
        });
    }
    else
    {
        var model = new UlrSpoofDnsRuleResourceModel();
        var resourceType = Type == UlrDnsRecordTypesDic.ip.id ? (Helper.ValidateIPv4(Ip) ? "A" : "AAAA") : Type;

        const resource = `${Host} ${resourceType} ${Ip}`
        model.enabled = 1;
        model.resource_raw = resource;
        model.resource_validated = resource;
        model.type_id = UlrWebRuleResourcesTypesMapEnum.sni;

        models.push(model);
    }


    models.forEach(function (Model) {
        _this.JustAddResource(Model);
    });
};

function UlrAddSpoofDnsRuleViewController(Params)
{
    var params = webix.extend(Params,{
        action:"Add"
    },true);

    UlrAddSpoofDnsRuleViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrAddSpoofDnsRuleViewController,UlrEditSpoofDnsRuleViewController);
function UlrPolicingsViewController(Params)
{
    var _this = this;

    this.Id = Params && Params.Id ? Params.Id : "UlrPolicings";

    this.PageTitle = {
        RootTitle: Params && Params.RootTitle ? Params && Params.RootTitle : LangHelper.GetString("UlrModule","Bandwidth management"),
        Title: Params && Params.Title ? Params.Title : LangHelper.GetString("UlrModule","Policings profiles")
    };

    this.ViewModel = Params && Params.ViewModel ? Params.ViewModel : new UlrAppPolicingsManager();

    this.ReportsModel = new UniReportsManager();

    this.PolicingParentField = Params && Params.PolicingParentField ? Params.PolicingParentField : "isp_id";
    this.EditPath = Params && Params.EditPath ? Params.EditPath : ControllersEnum.UlrEditAppPolicing;


    var reportWidget = Params && Params.ReportWidget ? Params.ReportWidget : UrlAppPolicingsTableWidget

    var reportParams = {
        id: this.Id + "AppPolicingsReport",
        enableTextSearch:1,
        enableAutoHeight:1,
        onItemClick:function (Id, E, Node)
        {
            _this.PolicingsReportOnItemClick(Id, E, Node);
        },
        onCheck:function (Row, Column, State)
        {
            _this.PolicingsReportOnCheck(Row, Column, State);
        }
    };

    if(Params && Params.ReportParams)
    {
        reportParams = webix.extend(reportParams, Params.ReportParams, true);
    }

    this.Views = {
        Widgets: {},
        ReportsWidgets: {
            PolicingsReport: reportWidget(reportParams)
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            scroll: "y",
            body: {
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless: true,
                        rows: function(){
                            var rows = [
                                {height: 6},
                                PageHeaderTemplate({root_title: _this.PageTitle.Title}),
                                {height: 32}
                            ];

                            if(Params && Params.BlockInfoTemplate)
                            {
                                rows.push({
                                    view: "template",
                                    borderless: true,
                                    css: "form_text_big_label",
                                    autoheight: true,
                                    template: Params.BlockInfoTemplate
                                });
                                rows.push({height: 32});
                            }

                            rows.push(_this.Views.ReportsWidgets.PolicingsReport.ViewConfig);

                            return rows;
                        }()
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrPolicingsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrPolicingsViewController.prototype.BindAll = function(Params)
{
    var _this = this;
    Object.keys(this.Views).forEach(function(View){
        if(View != "Widgets" && View != "ReportsWidgets")
        {
            _this.Views[View] = $$(_this.Id + View);
        }
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.PolicingProfileEnableStateError = this.ViewModel.Signals.PolicingProfileEnableStateError.subscribe(function(ErrModel){
        if(ErrModel)
        {
            _this.ShowServerError(ErrModel);
        }
    });

    this.Subscriptions.PolicingProfileDeleteError = this.ViewModel.Signals.PolicingProfileDeleteError.subscribe(function(ErrModel){
        if(ErrModel)
        {
            _this.ShowServerError(ErrModel);
        }
    });

    this.Subscriptions.PolicingProfileEnableStateUpdated = this.ViewModel.Signals.PolicingProfileEnableStateUpdated.subscribe(function (ProfileModel)
    {
        if(ProfileModel)
        {
            _this.PolicingProfileEnableStateUpdated(ProfileModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Policing profile")+" # "+ProfileModel.name+(ProfileModel.igw_name ? " " + ProfileModel.igw_name : "")+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.AppPolicingProfileDeleted = this.ViewModel.Signals.PolicingProfileDeleted.subscribe(function (ProfileModel)
    {
        if(ProfileModel)
        {
            _this.PolicingsReportOnSuccessDelete(ProfileModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Policing profile")+" # "+ProfileModel.name+(ProfileModel.igw_name ? " " + ProfileModel.igw_name : "")+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });
}

UlrPolicingsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrPolicingsViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrPolicingsViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.PolicingsReport.RefreshData();
};

UlrPolicingsViewController.prototype.PolicingsReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: _this.EditPath, path:"/_id=" + data[_this.PolicingParentField]});
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

        var data = table.getItem(Id);

        if(!data.type_id)
            return;

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteAppPolicingProfile(data);
                    }
                }
            ]
        });
    }
};

UlrPolicingsViewController.prototype.PolicingsReportOnCheck = function(Row, Column, State)
{
    var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

    var data = table.getItem(Row);

    this.ViewModel.EnableDisableAppPolicingProfile(webix.extend(data, {callback:function (R)
        {
            if(!R.success)
            {
                data.enabled = State ? 0 : 1;

                table.updateItem(data.id, data);
            }
        }}), State);
};

UlrPolicingsViewController.prototype.PolicingProfileEnableStateUpdated = function(AppPolicingModel)
{
    var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == AppPolicingModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = AppPolicingModel.enabled;
        table.updateItem(data.id, data);
    }
};

UlrPolicingsViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrPolicingsViewController.prototype.PolicingsReportOnSuccessDelete = function(ProfileModel)
{
    var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == ProfileModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = 0;
        data.type_id = 0;
        data.type = "";
        data.create_time = null;
        data.description = "";
        table.updateItem(data.id, data);
    }
};


function UlrAppPolicingsViewController(Params)
{
    var _this = this;

    this.Id = "UlrAppPolicings";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","ISP policing");
    this.ViewModel = new UlrAppPolicingsManager({
        profile_type: UlrPolicingTypeEnum.isp
    });

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        PolicingParentField: "isp_id",
        EditPath: ControllersEnum.UlrEditAppPolicing,
        ReportWidget: UrlAppPolicingsTableWidget,
        BlockInfoTemplate: LangHelper.GetString("UlrModule","Policing profiles are connected to channel profile.") + " " +
            LangHelper.GetString("UlrModule","This profiles can be enabled and disabled. You can edit them.") + " " +
            LangHelper.GetString("UlrModule","You can use HTB or TBF style policing. TBF doesn`t require root class but don`t support traffic ceiling.")

    }, true);

    UlrAppPolicingsViewController.superclass.constructor.call(this, params);

}

Helper.ExtendClass(UlrAppPolicingsViewController, UlrPolicingsViewController);
function UlrIgwPolicingsViewController(Params)
{
    var _this = this;

    this.Id = "UlrAppPolicings";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","IGW policing");
    this.ViewModel = new UlrAppPolicingsManager({
        profile_type: UlrPolicingTypeEnum.igw
    });

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        PolicingParentField: "igw_id",
        EditPath: ControllersEnum.UlrEditIgwPolicing,
        ReportWidget: UlrIgwPolicingsTableWidget,
        BlockInfoTemplate: LangHelper.GetString("UlrModule","Policing profiles are connected to place profile.") + " " +
            LangHelper.GetString("UlrModule","This profiles can be enabled and disabled. You can edit them.") + " " +
            LangHelper.GetString("UlrModule","You can use HTB or TBF style policing. TBF doesn`t require root class but don`t support traffic ceiling.")
    }, true);

    UlrIgwPolicingsViewController.superclass.constructor.call(this, params);

}

Helper.ExtendClass(UlrIgwPolicingsViewController, UlrPolicingsViewController);
function UlrSubscribersPolicingsViewController(Params)
{
    var _this = this;

    this.Id = "UlrSubscribersPolicings";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","Subscribers policing");
    this.ViewModel = new UlrAppPolicingsManager({
        profile_type: UlrPolicingTypeEnum.subs
    });

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        PolicingParentField: "isp_id",
        EditPath: ControllersEnum.UlrEditSubscriberPolicing,
        ReportWidget: UrlAppPolicingsTableWidget,
        ReportParams: {
            isp_type: "subscriber"
        },
        BlockInfoTemplate: LangHelper.GetString("UlrModule","Policing profiles are connected to subscriber profile.") + " " +
            LangHelper.GetString("UlrModule","This profiles can be enabled and disabled. You can edit them.") + " " +
            LangHelper.GetString("UlrModule","You can use HTB or TBF style policing. TBF doesn`t require root class but don`t support traffic ceiling.")
    }, true);

    UlrSubscribersPolicingsViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrSubscribersPolicingsViewController, UlrPolicingsViewController);
function UlrSessionPolicingsViewController(Params)
{
    var _this = this;

    this.Id = Params && Params.Id ? Params.Id : "UlrPolicings";

    this.PageTitle = {
        RootTitle: Params && Params.RootTitle ? Params && Params.RootTitle : LangHelper.GetString("UlrModule","Bandwidth management"),
        Title: Params && Params.Title ? Params.Title : LangHelper.GetString("UlrModule","Policings profiles")
    };

    this.ViewModel = Params && Params.ViewModel ? Params.ViewModel : new UlrIspSessionPolicingsManager();

    this.ReportsModel = new UniReportsManager();

    this.PolicingParentField = "isp_id";
    this.EditPath = Params && Params.EditPath ? Params.EditPath : ControllersEnum.UlrEditAppPolicing;

    var reportParams = {
        id: this.Id + "SessionPolicingsReport",
        enableTextSearch:1,
        enableAutoHeight:1,
        onItemClick:function (Id, E, Node)
        {
            _this.PolicingsReportOnItemClick(Id, E, Node);
        },
        onCheck:function (Row, Column, State)
        {
            _this.PolicingsReportOnCheck(Row, Column, State);
        }
    };

    if(Params && Params.ReportParams)
    {
        reportParams = webix.extend(reportParams, Params.ReportParams, true);
    }

    this.Views = {
        Widgets: {},
        ReportsWidgets: {
            PolicingsReport: UrlIspSessionPolicingsTableWidget(reportParams)
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            scroll: "y",
            body: {
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless: true,
                        rows: function(){
                            var rows = [
                                {height: 6},
                                PageHeaderTemplate({root_title: _this.PageTitle.Title}),
                                {height: 32}
                            ];

                            if(Params && Params.BlockInfoTemplate)
                            {
                                rows.push({
                                    view: "template",
                                    borderless: true,
                                    css: "form_text_big_label",
                                    autoheight: true,
                                    template: Params.BlockInfoTemplate
                                });
                                rows.push({height: 32});
                            }

                            rows.push(_this.Views.ReportsWidgets.PolicingsReport.ViewConfig);

                            return rows;
                        }()
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrSessionPolicingsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrSessionPolicingsViewController.prototype.BindAll = function(Params)
{
    var _this = this;
    Object.keys(this.Views).forEach(function(View){
        if(View != "Widgets" && View != "ReportsWidgets")
        {
            _this.Views[View] = $$(_this.Id + View);
        }
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.PolicingProfileEnableStateError = this.ViewModel.Signals.PolicingProfileEnableStateError.subscribe(function(ErrModel){
        if(ErrModel)
        {
            _this.ShowServerError(ErrModel);
        }
    });

    this.Subscriptions.PolicingProfileDeleteError = this.ViewModel.Signals.PolicingProfileDeleteError.subscribe(function(ErrModel){
        if(ErrModel)
        {
            _this.ShowServerError(ErrModel);
        }
    });

    this.Subscriptions.PolicingProfileEnableStateUpdated = this.ViewModel.Signals.PolicingProfileEnableStateUpdated.subscribe(function (ProfileModel)
    {
        if(ProfileModel)
        {
            _this.PolicingProfileEnableStateUpdated(ProfileModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Policing profile")+" # "+ProfileModel.name+(ProfileModel.igw_name ? " " + ProfileModel.igw_name : "")+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.AppPolicingProfileDeleted = this.ViewModel.Signals.PolicingProfileDeleted.subscribe(function (ProfileModel)
    {
        if(ProfileModel)
        {
            _this.PolicingsReportOnSuccessDelete(ProfileModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Policing profile")+" # "+ProfileModel.name+(ProfileModel.igw_name ? " " + ProfileModel.igw_name : "")+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });
}

UlrSessionPolicingsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrSessionPolicingsViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrSessionPolicingsViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.PolicingsReport.RefreshData();
};

UlrSessionPolicingsViewController.prototype.PolicingsReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: _this.EditPath, path:"/_id=" + data[_this.PolicingParentField]});
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

        var data = table.getItem(Id);

        if(!data.type_id)
            return;

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteProfile(data);
                    }
                }
            ]
        });
    }
};

UlrSessionPolicingsViewController.prototype.PolicingsReportOnCheck = function(Row, Column, State)
{
    var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

    var data = table.getItem(Row);

    this.ViewModel.EnableDisableProfile(webix.extend(data, {callback:function (R)
        {
            if(!R.success)
            {
                data.enabled = State ? 0 : 1;

                table.updateItem(data.id, data);
            }
        }}), State);
};

UlrSessionPolicingsViewController.prototype.PolicingProfileEnableStateUpdated = function(AppPolicingModel)
{
    var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == AppPolicingModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = AppPolicingModel.enabled;
        table.updateItem(data.id, data);
    }
};

UlrSessionPolicingsViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrSessionPolicingsViewController.prototype.PolicingsReportOnSuccessDelete = function(ProfileModel)
{
    var table = this.Views.ReportsWidgets.PolicingsReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == ProfileModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = 0;
        data.create_time = null;
        data.description = "";
        table.updateItem(data.id, data);
    }
};


function UlrIspSessionPolicingsViewController(Params)
{
    var _this = this;

    this.Id = "UlrIspSessionPolicings";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","ISP session policing");
    this.ViewModel = new UlrIspSessionPolicingsManager();

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        EditPath: ControllersEnum.UlrEditIspSessionPolicing,
        BlockInfoTemplate: LangHelper.GetString("UlrModule","SESSION_POLICING_PROFILE_DESCRIPTION_FOR_VCHANNEL")

    }, true);

    UlrIspSessionPolicingsViewController.superclass.constructor.call(this, params);

}

Helper.ExtendClass(UlrIspSessionPolicingsViewController, UlrSessionPolicingsViewController);
function UlrSubscribersSessionPolicingsViewController(Params)
{
    var _this = this;

    this.Id = "UlrSubscribersSessionPolicings";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","Subscribers session policing");
    this.ViewModel = new UlrIspSessionPolicingsManager();

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        EditPath: ControllersEnum.UlrEditSubscriberSessionPolicing,
        ReportParams: {
            isp_type: "subscriber"
        },
        BlockInfoTemplate: LangHelper.GetString("UlrModule","SESSION_POLICING_PROFILE_DESCRIPTION_FOR_SUBSCRIBER")

    }, true);

    UlrSubscribersSessionPolicingsViewController.superclass.constructor.call(this, params);

}

Helper.ExtendClass(UlrSubscribersSessionPolicingsViewController, UlrSessionPolicingsViewController);
function UlrAppDscpRulesViewController(Params)
{
    var _this = this;

    this.Id = "UlrAppDscpRules";

    this.SocketRoom = this.Id;

    this.mode = module ? module : "dpiui2";

    this.DscpProtoBackupEnabled = false;

    this.IspsList = new UlrIspListViews({id: "Main", hidden: !!(AppEnv.DisableISPSwitchForDSCPRules)});
    this.EditPopupIspsList = new UlrIspListViews({id: "Popup", hidden: !!(AppEnv.DisableISPSwitchForDSCPRules)});

    this.ProtocolsDicsManager = new HardwareDscpProrocolsManager();

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Bandwidth management"),
        Title:LangHelper.GetString("UlrModule","DSCP rules")
    };

    this.ViewModel = new UlrDscpRulesManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {

        ScrollView:null,
        PageTitle:null,

        AddDSCPForm:null,
        ProtocolInput:null,
        PriorityInput:null,
        SetDscpBtn:null,

        EditPopupAddDSCPForm:null,
        EditPopupProtocolLabel:null,
        EditPopupPriorityInput:null,
        EditPopupSetDscpBtn:null,
        EnableDscpSection: null,
        DscpProtoBackupEnabled: null,
        DscpProtoSection: null,
        DscpBackupsInfo: null,
        DscpBackupStateTable: null,

        Widgets:{},
        ReportsWidgets:{
            DscpReport:UrlAppDSCPsTableWidget({
                id:this.Id + "DscpReport",
                enableTextSearch:1,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.DscpReportOnItemClick(Id, E, Node);
                },
                onCheck:function (Row, Column, State)
                {
                    _this.DscpReportOnCheck(Row, Column, State);
                }
                // ,
                // onAfterEditStop:function (State, Editor, IgnoreUpdate)
                // {
                //     if(State.value != State.old)
                //     {
                //         _this.DscpReportSaveSelectedRow();
                //     }
                // }
            })
        }
    };

    this.EditPopup = null;

    this.EditPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        width:480,
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "EditPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Edit rule"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.EditPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "EditPopupAddDSCPForm",
                            type: "wide",
                            elements: [
                                {
                                    type: "wide",
                                    cols:[
                                        {
                                            view:"label",
                                            id:this.Id + "EditPopupProtocolLabel",
                                            css:"form_header_label",
                                            label:"",
                                            template: function(obj){
                                                var val = obj && obj.value ? obj.value : null;

                                                var result = LangHelper.GetString("UlrModule",val && Number.parseInt(val.is_group) ? "Group" : "Protocol") + ": ";

                                                if(val && Number.parseInt(val.is_group))
                                                {
                                                    if(val.group_name_json)
                                                    {
                                                        var grName = JSON.parse(val.group_name_json),
                                                            locale = LangHelper.GetLocale();

                                                        if(grName && grName[locale])
                                                        {
                                                            result += grName[locale];
                                                        }
                                                        else if(Object.keys(grName).length > 0)
                                                        {
                                                            result += grName[Object.keys(grName)[0]]
                                                        }
                                                    }
                                                    else{
                                                        var dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);

                                                        if(dic && dic[val.protocol])
                                                        {
                                                            result +=  dic[val.protocol].value;
                                                        }
                                                    }
                                                }
                                                else{
                                                    result += val.protocol;
                                                }

                                                return result;
                                            }
                                        }
                                    ]
                                },
                                {
                                    type: "wide",
                                    cols:[
                                        {
                                            view:"spectre_combo",
                                            id:this.Id + "EditPopupPriorityInput",
                                            name:"priority",
                                            label:LangHelper.GetString("UlrModule","Priority"),
                                            options:{
                                                view:"gridsuggest",
                                                point:false,
                                                body:{
                                                    autoheight:false,
                                                    scroll:true,
                                                    maxHeight:400,
                                                    //width:800,
                                                    //minWidth:800,
                                                    borderless:true,
                                                    columns:[
                                                        { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                                        { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                                        { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                                        { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                                        { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                                        { id:"class_order_1", header:"class_order=1", width:160}
                                                    ],
                                                    data:Helper.DictToArr(AsnDscpDic)
                                                }
                                            },
                                            required:true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                            on: {
                                                "onChange": function (Nv, Ov)
                                                {
                                                    this.validate();
                                                }
                                            }
                                        }
                                    ]
                                },
                                ...(_this.EditPopupIspsList ? _this.EditPopupIspsList.ViewConfig : [])
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "EditPopupSetDscpBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Set DSCP"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function () {
                                            _this.SaveEditForm();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.DscpBackupStatePopup = null;

    this.DscpBackupStatePopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        width:480,
        modal:true,
        close: true,
        position:"center",
        padding:0,
        marging:0,
        head: {
            view:"toolbar",
            cols:[
                {
                    view:"label",
                    label: LangHelper.GetString("UlrModule", "DSCP backups process"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function()
                    {
                        _this.DscpBackupStatePopup.hide();
                    }
                }
            ]
        },
        headHeight: 68,
        autofit: true,
        body:{
            type:"space",
            borderless: true,
            rows: [
                {
                    type: "clean",
                    borderless: true,
                    rows:[
                        {
                            view: "datatable",
                            id: _this.Id + "DscpBackupStateTable",
                            css: "",
                            columns: [
                                {
                                    id: "name",
                                    fillspace: 1,
                                    header: [LangHelper.GetString("UlrModule", "Node name")]
                                },
                                {
                                    id: "dscp_backuped",
                                    fillspace: 1,
                                    header: [LangHelper.GetString("UlrModule", "Status")],
                                    template: function(Obj)
                                    {
                                        let res = "";
                                        if(parseInt(Obj.dscp_backuped) == 0)
                                        {
                                            res = '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div> <div class="bounce3"></div> </div>';
                                        }
                                        else
                                        {
                                            res = CellAnyIconBtnTemplate("check");
                                        }

                                        return res;
                                    }
                                }
                            ],
                        }

                    ]
                }
            ]
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({id:this.Id + "PageTitle", root_title: this.PageTitle.Title}),
                            {height:32},
                            {
                                view:"template",
                                borderless:true,
                                css:"form_text_big_label",
                                //height:120,
                                autoheight:true,
                                template:LangHelper.GetString("UlrModule","Set DCSP priority to application to use it in ISP profile or use DROP to block application on all DPI units.")
                            },
                            {
                                id: this.Id + "EnableDscpSection",
                                type:"wide",
                                hidden: true,
                                rows:[
                                    {height:20},
                                    {
                                        cols:[
                                            {
                                                view: "label",
                                                css: "form_element form_text_label",
                                                label: LangHelper.GetString("UlrModule", "Enable DSCP App rules edit mode") + ":",
                                                width: 280,
                                                // autowidth:true
                                            },
                                            {
                                                view:"spectre_toggle",
                                                id:this.Id + "DscpProtoBackupEnabled",
                                                css:"form_element block_header_toggle",
                                                value:0,
                                                on:{
                                                    onChange:function (Nv, Ov)
                                                    {
                                                        _this.ChangeDscpAppRulesEditMode(Nv);
                                                    }
                                                }
                                            },
                                            {}
                                        ]
                                    },
                                    {
                                        id: this.Id + "DscpBackupsInfo",
                                        hidden: true,
                                        height: 40,
                                        borderless: true,
                                        view: "template",
                                        css: "form_text_big_label",
                                        onClick: {
                                            "form_text_big_label": function(e, id, trg)
                                            {
                                                _this.DscpBackupStatePopup.show();
                                            }
                                        },
                                        template: function(Data)
                                        {
                                            let total = 0, processed=0;
                                            if(Data && Array.isArray(Data))
                                            {
                                                Data.forEach((item) => {
                                                    total += 1;

                                                    if (parseInt(item.dscp_backuped) == 1) {
                                                        processed += 1;
                                                    }
                                                });
                                            }

                                            let res = LangHelper.GetString("UlrModule", "Created DSCP bakups") + ": " + processed + "/" + total;

                                            if(processed < total)
                                            {
                                                res += '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div> <div class="bounce3"></div> </div>';
                                            }
                                            else if(processed == total)
                                            {
                                                res += CellAnyIconBtnTemplate("check");
                                            }

                                            return res;
                                        }
                                    }
                                ]
                            },
                            {height:32},
                            {
                                id: this.Id + "DscpProtoSection",
                                disabled: true,
                                rows:[

                                    {
                                        type: "space",
                                        css: "form_background",
                                        rows:[
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","Set priority to protocol"), icon:"",
                                                borderless:true
                                            }),
                                            {
                                                view: "form",
                                                id: this.Id + "AddDSCPForm",
                                                borderless: true,
                                                type: "wide",
                                                elements: function(){
                                                    var ruleTypeInput = {
                                                        view:"spectre_combo",
                                                        name:"rule_type",
                                                        label:LangHelper.GetString("UlrModule","Mode"),
                                                        options:{
                                                            point:false,
                                                            data:Helper.DictToArr(UlrAppDscpRuleTypeDic)
                                                        },
                                                        required:true,
                                                        value: UlrAppDscpRuleTypeDic.protocol.id,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(typeof Ov !== "undefined" && Ov !== "")
                                                                    this.validate();
                                                            }
                                                        }
                                                    };

                                                    var protocolInput = {
                                                        view:"spectre_text",
                                                        id:_this.Id + "ProtocolInput",
                                                        name:"protocol",
                                                        label:LangHelper.GetString("UlrModule","Application protocol"),
                                                        suggest: {
                                                            data:App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsDic),
                                                            template:"#value#",
                                                            filter:function(obj, value)
                                                            {
                                                                return true; //obj.value.toLowerCase().indexOf(value.toLowerCase()) >= 0;
                                                            }
                                                        },
                                                        keyPressTimeout:500,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on:{
                                                            onChange:function(Nv, Ov)
                                                            {
                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                {
                                                                    this.setValue(Nv.trim());
                                                                    return;
                                                                }

                                                                _this.Signals.ProtocolInputValue.next(Nv);
                                                                _this.Views.AddDSCPForm.clearValidation();
                                                            },
                                                            onTimedKeyPress: function()
                                                            {
                                                                var val = this.getValue();

                                                                if(val && typeof val == "string" && val != val.trim())
                                                                {
                                                                    this.setValue(val.trim());
                                                                    return;
                                                                }

                                                                _this.Signals.ProtocolInputValue.next(val);

                                                                App.DicsManager.Refresh({data:[DicsEnum.ProtocolsDic], filter:val});
                                                            }
                                                            // ,
                                                            // onEnter:function(Ev)
                                                            // {
                                                            //     setTimeout(function ()
                                                            //     {
                                                            //         _this.SaveRule(true);
                                                            //     },1);
                                                            // }
                                                        }
                                                    };

                                                    var protocolGroupInput = {
                                                        view:"spectre_combo",
                                                        name:"protocol_group",
                                                        hidden: true,
                                                        label:LangHelper.GetString("UlrModule","Protocols group"),
                                                        options:{
                                                            point:false,
                                                            data:[]
                                                        },
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(typeof Ov !== "undefined" && Ov !== "")
                                                                    this.validate();

                                                                _this.Signals.ProtocolGroupsInputValue.next(Nv);
                                                                _this.Views.AddDSCPForm.clearValidation();
                                                            }
                                                        }
                                                    };

                                                    var protocolCustomGroupInput = {
                                                        view:"spectre_combo",
                                                        name:"protocol_custom_group",
                                                        hidden: true,
                                                        label:LangHelper.GetString("UlrModule","Users groups of protocols"),
                                                        options:{
                                                            point:false,
                                                            data:[]
                                                        },
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(typeof Ov !== "undefined" && Ov !== "")
                                                                    this.validate();

                                                                _this.Signals.ProtocolCustomGroupsInputValue.next(Nv);
                                                                _this.Views.AddDSCPForm.clearValidation();
                                                            }
                                                        }
                                                    };

                                                    var priorityInput = {
                                                        type: "wide",
                                                        cols:[
                                                            {
                                                                view:"spectre_combo",
                                                                id:_this.Id + "PriorityInput",
                                                                name:"priority",
                                                                label:LangHelper.GetString("UlrModule","Priority"),
                                                                //value:"cs0",
                                                                options:{
                                                                    view:"gridsuggest",
                                                                    point:false,
                                                                    body:{
                                                                        autoheight:false,
                                                                        scroll:true,
                                                                        maxHeight:400,
                                                                        //width:800,
                                                                        //minWidth:800,
                                                                        borderless:true,
                                                                        columns:[
                                                                            { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                                                            { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                                                            { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                                                            { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                                                            { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                                                            { id:"class_order_1", header:"class_order=1", width:160}
                                                                        ],
                                                                        data:Helper.DictToArr(DscpDic)
                                                                    }
                                                                },
                                                                validate: webix.rules.isNotEmpty,
                                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                                on:{
                                                                    onChange:function(Nv, Ov)
                                                                    {
                                                                        if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                        {
                                                                            this.setValue(Nv.trim());
                                                                            return;
                                                                        }

                                                                        _this.Signals.PriorityInputValue.next(Nv);
                                                                        _this.Views.AddDSCPForm.clearValidation();
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    };

                                                    const layout = [
                                                        {
                                                            type: "clean",
                                                            rows: [
                                                                {
                                                                    view:"label",
                                                                    css:"form_text_label",
                                                                    label:LangHelper.GetString("UlrModule","Start typing protocol name or use protocol list helper.")
                                                                },
                                                                {
                                                                    type: "wide",
                                                                    cols: [
                                                                        ruleTypeInput,
                                                                        protocolInput,
                                                                        protocolGroupInput,
                                                                        protocolCustomGroupInput,
                                                                        priorityInput
                                                                    ]
                                                                },
                                                                {height:20},
                                                                ..._this.IspsList.ViewConfig,
                                                                {height:20, hidden: AppEnv.DisableISPSwitchForDSCPRules},
                                                                {
                                                                    type: "wide",
                                                                    cols:[
                                                                        {
                                                                            view:"spectre_button",
                                                                            id:_this.Id + "SetDscpBtn",
                                                                            css:"form_button form_element main_action",
                                                                            label:LangHelper.GetString("UlrModule","Set DSCP"),
                                                                            height:51,
                                                                            click:function ()
                                                                            {
                                                                                setTimeout(function () {
                                                                                    _this.SaveRule(true);
                                                                                },1);
                                                                            }
                                                                        },
                                                                        {},
                                                                        {}
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ];

                                                    return layout;
                                                }()
                                            },
                                        ]
                                    },
                                    {height:20},
                                    this.Views.ReportsWidgets.DscpReport.ViewConfig
                                ]
                            },

                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {
        RuleTypeSelectValue: new Rx.BehaviorSubject(null),
        ProtocolInputValue: new Rx.BehaviorSubject(null),
        PriorityInputValue: new Rx.BehaviorSubject(null),
        ProtocolGroupsInputValue: new Rx.BehaviorSubject(null),
        ProtocolCustomGroupsInputValue: new Rx.BehaviorSubject(null),

        ProcessingModel: new Rx.BehaviorSubject(null)
    };

    this.TableRefreshTimer = null;
    this.TableRefreshPauseInSec = 5;
    this.TableRefreshPause = false;
    this.TableCanAutoRefesh = true;
}

UlrAppDscpRulesViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.DscpBackupStatePopup = webix.ui(this.DscpBackupStatePopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.ProtocolsDic = App.DicsManager.Signal[DicsEnum.ProtocolsDic].subscribe(function (Updated)
    {
        if (Updated)
        {
            var opts = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsDic);

            var list = $$(_this.Views.AddDSCPForm.elements.protocol.config.suggest).getList();
            list.clearAll();
            list.parse(opts);

            var value = _this.Views.ProtocolInput.getValue();

            if(value)
            {
                list.select(value);
                list.showItem(value);

                if(!list.getSelectedItem())
                {
                    list.select(value.toUpperCase());
                    list.showItem(value.toUpperCase());
                }

                if(!list.getSelectedItem())
                {
                    list.select(value.toLowerCase());
                    list.showItem(value.toLowerCase());
                }
            }
        }
    });

    this.Subscriptions.SetDscpBtn = Rx.Observable.combineLatest
    (
        this.ViewModel.Signals.Progress,
        this.Signals.RuleTypeSelectValue,
        this.Signals.ProtocolInputValue,
        this.Signals.ProtocolGroupsInputValue,
        this.Signals.ProtocolCustomGroupsInputValue,
        this.Signals.PriorityInputValue,
    ).subscribe(function(Val)
        {
            var progress = Val[0];
            var ruleType = Val[1] ? Val[1] : _this.Views.AddDSCPForm.elements.rule_type.getValue();
            var protocolValue = Val[2];
            var groupValue = Val[3];
            var customGroupValue = Val[4];
            var priorityValue = Val[5];

            var view = _this.Views.SetDscpBtn;

            switch (ruleType)
            {
                case UlrAppDscpRuleTypeDic.protocol.id:
                    progress || !(protocolValue && priorityValue) ? view.disable() : view.enable();
                    break;
                case UlrAppDscpRuleTypeDic.protocols_group.id:
                    progress || !(groupValue && priorityValue) ? view.disable() : view.enable();
                    break;
                case UlrAppDscpRuleTypeDic.protocols_custom_group.id:
                    progress || !(customGroupValue && priorityValue) ? view.disable() : view.enable();
                    break;
                default:
                    view.disable();
            }
        }
    );

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress)
    {
        var view = _this.Views.ProtocolInput;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.EditPopupSetDscpBtn;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions.AppDscpRuleSaveError = this.ViewModel.Signals.AppDscpRuleSaveError.subscribe(function (ErrModel)
    {
        _this.Signals.ProcessingModel.next(null);
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.ProtocolCheckError = this.ViewModel.Signals.ProtocolCheckError.subscribe(function (ErrModel)
    {
        _this.Signals.ProcessingModel.next(null);
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.AppDscpRuleDeleteError = this.ViewModel.Signals.AppDscpRuleDeleteError.subscribe(function (ErrModel)
    {
        _this.Signals.ProcessingModel.next(null);
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.AppDscpRuleEnableStateError = this.ViewModel.Signals.AppDscpRuleEnableStateError.subscribe(function (ErrModel)
    {
        _this.Signals.ProcessingModel.next(null);
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.AppDscpRuleSaved = this.ViewModel.Signals.AppDscpRuleSaved.subscribe(function (AppDscpModel)
    {
        if(AppDscpModel)
        {
            _this.Signals.ProcessingModel.next(null);
            _this.EditPopup.hide();
            _this.AddOrReplaceAppRuleModelInTable(AppDscpModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","DSCP rule")+" # "+AppDscpModel.protocol+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.AppDscpRuleDeleted = this.ViewModel.Signals.AppDscpRuleDeleted.subscribe(function (AppDscpModel)
    {
        if(AppDscpModel)
        {
            _this.Signals.ProcessingModel.next(null);
            _this.DscpReportReportOnSuccessDelete(AppDscpModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","DSCP rule")+" # "+AppDscpModel.protocol+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.AppDscpRuleEnableStateUpdated = this.ViewModel.Signals.AppDscpRuleEnableStateUpdated.subscribe(function (AppDscpModel)
    {
        if(AppDscpModel)
        {
            _this.Signals.ProcessingModel.next(null);
            _this.AppDscpRuleEnableStateUpdated(AppDscpModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","DSCP rule")+" # "+AppDscpModel.protocol+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.ProtocolCheckResult = this.ViewModel.Signals.ProtocolCheckResult.subscribe(function (CheckResultModel)
    {
        _this.ProcessCheckResult(CheckResultModel);
    });

    this.Subscriptions.ProcessingModel = this.Signals.ProcessingModel.subscribe(function (Model)
    {
        if(Model)
            _this.ViewModel.CheckProtocol(Model);
    });

    this.Subscriptions.HardwareDscpProtocolsDicUpdated = this.ProtocolsDicsManager.SignalDicsReady.subscribe(function(Val){
        if(Val)
        {
            // _this.Views.ReportsWidgets.DscpReport.Views.Table.refresh();
        }
    });

    this.Subscriptions.SignalDicProtocolsGroupsUpdatedSubscription = App.DicsManager.Signal[DicsEnum.ProtocolsGroupsDic].subscribe(function(Updated){
        if(Updated)
        {
            var dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic);

            dic = dic.sort(function(a,b){
                return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
            });

            _this.Views.AddDSCPForm.elements.protocol_group.define("options", dic);
            _this.Views.AddDSCPForm.elements.protocol_group.refresh();
        }
    });

    this.Subscriptions.SignalDicProtocolsCustomGroupsUpdatedSubscription = App.DicsManager.Signal[DicsEnum.ProtocolsCustomGroupsDic].subscribe(function(Updated){
        if(Updated)
        {
            var dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsCustomGroupsDic);

            if(dic.length)
            {
                if(!_this.Views.AddDSCPForm.elements.protocol_custom_group.isEnabled())
                {
                    _this.Views.AddDSCPForm.elements.protocol_custom_group.enable();
                }

                dic = dic.sort(function(a,b){
                    return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
                });

                _this.Views.AddDSCPForm.elements.protocol_custom_group.define("options", dic);
                _this.Views.AddDSCPForm.elements.protocol_custom_group.refresh();
            }
            else
            {
                _this.Views.AddDSCPForm.elements.protocol_custom_group.disable();
            }
        }
    });

    this.Views.AddDSCPForm.elements.rule_type.attachEvent("onChange", function(Val){
        switch (Val)
        {
            case UlrAppDscpRuleTypeDic.protocol.id:
                _this.Views.AddDSCPForm.elements.protocol_group.hide();
                _this.Views.AddDSCPForm.elements.protocol_custom_group.hide();
                _this.Views.AddDSCPForm.elements.protocol.show();
                break;
            case UlrAppDscpRuleTypeDic.protocols_group.id:
                _this.Views.AddDSCPForm.elements.protocol.hide();
                _this.Views.AddDSCPForm.elements.protocol_custom_group.hide();
                _this.Views.AddDSCPForm.elements.protocol_group.show();
                break;
            case UlrAppDscpRuleTypeDic.protocols_custom_group.id:
                _this.Views.AddDSCPForm.elements.protocol.hide();
                _this.Views.AddDSCPForm.elements.protocol_group.hide();
                _this.Views.AddDSCPForm.elements.protocol_custom_group.show();
        }
        _this.Signals.RuleTypeSelectValue.next(Val);
    })

    this.Subscriptions.DscpAppBackupModeUpdated = this.ViewModel.Signals.DscpAppBackupModeUpdated.subscribe(function(Val){
        if(Val)
        {
            _this.UpdateDspAppBackupMode(Val);
        }
    });

    this.Subscriptions.DscpAppBackupModeError = this.ViewModel.Signals.DscpAppBackupModeError.subscribe(function(ErrModel){
        if(ErrModel)
        {
            _this.ShowServerError(ErrModel);
        }
    });

    this.Subscriptions.DscpAppBackupModeSaved = this.ViewModel.Signals.DscpAppBackupModeSaved.subscribe(function(Val){
        if(Val)
        {
            // _this.UpdateDspAppBackupMode(Val);
        }
    });

    this.Subscriptions.DscpAppBackupModeSaveError = this.ViewModel.Signals.DscpAppBackupModeSaveError.subscribe(function(ErrModel){
        if(ErrModel)
        {

            _this.Views.DscpProtoBackupEnabled.setValue(_this.DscpProtoBackupEnabled);
            _this.ShowServerError(ErrModel);
        }
    });

    App.WebSocketManager.Connect(this.SocketRoom);

    App.WebSocketManager.Connections[this.SocketRoom].on("connect", (data) => {});

    App.WebSocketManager.Connections[this.SocketRoom].on("disconnect", (data) => {});

    App.WebSocketManager.Connections[this.SocketRoom].on("backup_status", (data) => {
        let _data = JSON.parse(data);
        _this.UpdateDspAppBackupMode(_data);

        if(_this.TableRefreshPause)
            return;

        _this.TableRefreshPause = true;

        _this.TableRefreshTimer = setTimeout(function ()
        {
            if(_this.TableCanAutoRefesh)
                _this.ViewModel.UlrGetDspAppModeEnabled();
            _this.TableRefreshPause = false;

        },_this.TableRefreshPauseInSec*1000);

    });

    this.ViewModel.UlrGetDspAppModeEnabled();

    App.DicsManager.Refresh({data:[DicsEnum.ProtocolsCustomGroupsDic]});
};

UlrAppDscpRulesViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.EditPopup = webix.ui(this.EditPopupConfig);

    this.IspsList.ViewDidLoad(Params);
    this.EditPopupIspsList.ViewDidLoad(Params);

    this.BindAll(Params);


    this.Refresh();
};

UlrAppDscpRulesViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    App.WebSocketManager.Disconnect(this.SocketRoom);
    clearTimeout(_this.TableRefreshTimer);

    this.IspsList.Destroy();

    this.EditPopupIspsList.Destroy();
};

UlrAppDscpRulesViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrAppDscpRulesViewController.prototype.Refresh = function (Params)
{
    this.Views.ReportsWidgets.DscpReport.RefreshData();
};

UlrAppDscpRulesViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrAppDscpRulesViewController.prototype.SaveRule = function(Check)
{
    let _this = this;

    if(Check && !_this.IsDscpFormValid())
    {
        return;
    }

    let formValues = {};

    Object.keys(_this.Views.AddDSCPForm.elements).forEach(key => {
        let el = _this.Views.AddDSCPForm.elements[key];
        formValues[el.config.name] = el.getValue();
    })

    var model = {
        is_group: 0,
        is_custom_group: 0,
        protocol: "",
        priority: formValues.priority,
        enabled:1
    };

    switch (formValues.rule_type)
    {
        case UlrAppDscpRuleTypeDic.protocol.id:
            model.protocol = formValues.protocol;
            break
        case UlrAppDscpRuleTypeDic.protocols_group.id:
            model.is_group = 1;
            model.protocol = formValues.protocol_group;
            break;
        case UlrAppDscpRuleTypeDic.protocols_custom_group.id:
            model.is_custom_group = 1;
            model.protocol = formValues.protocol_custom_group;
            break;
    }

    if(model.protocol == "")
        return;

    model.isps = this.IspsList.getSelectedIsps();
    model.mode_id = this.IspsList.getMode();

    if(Check)
    {
        this.Signals.ProcessingModel.next(model);
    }
    else
        this.JustSaveRule(model);
};

UlrAppDscpRulesViewController.prototype.IsDscpFormValid = function()
{
    let _this = this;

    this.Views.AddDSCPForm.clearValidation();

    let result = true;

    Object.keys(this.Views.AddDSCPForm.elements).forEach(key => {
        let el = _this.Views.AddDSCPForm.elements[key];
        if(el.isVisible() && !el.validate())
        {
            _this.Views.AddDSCPForm.markInvalid(key,LangHelper.GetString("UlrModule", LangHelper.GetString("UlrModule", "Required field")));
            this.Views.ScrollView.showView(el.config.id);
            result = false;
        }
    });

    return result;
};

UlrAppDscpRulesViewController.prototype.JustSaveRule = function(RuleModel)
{
    this.ViewModel.SaveAppDscpRule(RuleModel);
};

UlrAppDscpRulesViewController.prototype.ProcessCheckResult = function(CheckResultModel)
{
    if(!CheckResultModel)
        return;

    var model = new UlrAppProtocolRuleCheckModel(CheckResultModel);

    var isGroup = [UlrAppDscpRuleTypeDic.protocols_group.id, UlrAppDscpRuleTypeDic.protocols_custom_group.id].includes(
        this.Views.AddDSCPForm.elements.rule_type.getValue()
    );

    if(!isGroup && (!model.protocol || !model.protocol.protocol_exists))
    {
        this.Views.AddDSCPForm.markInvalid("protocol",LangHelper.GetString("UlrModule", "Does not exist"));

        this.Views.ScrollView.showView(this.Id + "PriorityInput");
        return;
    }

    if(model.rule && model.rule.rule_exists)
    {
        this.ShowRuleExistsModal(model.rule.rule);
        return;
    }

    this.SaveRule(false);
};

UlrAppDscpRulesViewController.prototype.AddOrReplaceAppRuleModelInTable = function(Model)
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var model = new UlrAppDscpRuleModel(Model);

    var data = table.find(function(obj)
    {
        return obj._id == model._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        table.updateItem(data.id, model);
        table.select(data.id);
    }
    else
    {
        model.id = webix.uid();
        table.add(model,0);
        table.select(model.id);
        table.hideOverlay();
        table.hideProgress();
    }

};

UlrAppDscpRulesViewController.prototype.ShowRuleExistsModal = function(RuleModel)
{
    var _this = this;

    if(RuleModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ":0",
            message:LangHelper.GetString("UlrModule","A rule with the selected protocol already exists.") + "<br/>" + LangHelper.GetString("UlrModule","Replace")+"?",
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Cancel"),
                    css:"third_action",
                    click:function ()
                    {
                        _this.Signals.ProcessingModel.next(null);
                    }
                },
                {
                    label:LangHelper.GetString("UlrModule","Replace"),
                    click:function ()
                    {
                        var processingModel = _this.Signals.ProcessingModel.getValue();

                        if(processingModel)
                        {
                            RuleModel.priority = processingModel.priority;
                            _this.JustSaveRule(RuleModel);
                        }
                    }
                }
            ]
        });
};

UlrAppDscpRulesViewController.prototype.DscpReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit')
    {
        // var table = this.Views.ReportsWidgets.DscpReport.Views.Table;
        //
        // table.editCell(Id, "priority");

        _this.ShowEditForm();
    }

    if(Id.column === 'group_id')
    {
        var table = this.Views.ReportsWidgets.DscpReport.Views.Table;
        var item = table.getItem(Id);
        var is_group = parseInt(item.is_group);
        var is_custom_group = parseInt(item.is_custom_group);

        if(is_group || is_custom_group)
        {
            let filter, modal_title;

            if(is_group)
            {
                modal_title = JSON.parse(item.group_name_json)[LangHelper.GetLocale()];
                filter = {
                    group_id: {
                        id: "group_id",
                        operator: "=",
                        value: item.group_id
                    }
                }
            }
            else if(is_custom_group)
            {
                modal_title = item.custom_group_name;
                filter = {
                    custom_group_id: {
                        id: "custom_group_id",
                        operator: "=",
                        value: item.custom_group_id
                    }
                };
            }

            var table_params = {
                enableAutoHeight: false,
                enableTextSearch: true,
                is_modal: true,
                filter: filter,
                is_custom_group: is_custom_group
            }
            var table = new UlrAppProtocolsTable(table_params);

            UlrEditAppPolicingPopup({
                modal_title: modal_title
            }, table);
            table.Bind(_this, _this.ReportsModel);
            table.RefreshData();
        }
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteAppDscpRule(data);
                    }
                }
            ]
        });
    }
};

UlrAppDscpRulesViewController.prototype.DscpReportOnCheck = function(Row, Column, State)
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.getItem(Row);

    this.ViewModel.EnableDisableAppDscpRule(webix.extend(data, {callback:function (R)
        {
            if(!R.success)
            {
                data.enabled = State ? 0 : 1;

                table.updateItem(data.id, data);
            }
        }}), State);
};

UlrAppDscpRulesViewController.prototype.DscpReportReportOnSuccessDelete = function(AppDscpModel)
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == AppDscpModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }

};

UlrAppDscpRulesViewController.prototype.AppDscpRuleEnableStateUpdated = function(AppDscpModel)
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.find(function(obj)
    {
        return obj._id == AppDscpModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = parseInt(AppDscpModel.enabled);
        table.updateItem(data.id, data);
    }

};

// UlrAppDscpRulesViewController.prototype.DscpReportSaveSelectedRow = function()
// {
//     var table = this.Views.ReportsWidgets.DscpReport.Views.Table;
//
//     var data = table.getSelectedItem();
//
//     if(data)
//         this.JustSaveRule(data);
// };

UlrAppDscpRulesViewController.prototype.ShowEditForm = function()
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    this.Views.EditPopupAddDSCPForm.clear();
    this.Views.EditPopupAddDSCPForm.clearValidation();

    this.Views.EditPopupProtocolLabel.setValue(data);
    this.Views.EditPopupAddDSCPForm.setValues(data);
    this.Views.EditPopupProtocolLabel.refresh();

    var ispsVals = {};

    data.isps.split(",").forEach(function (Item)
    {
        if(Item && parseInt(Item) > 0)
        {
            ispsVals[""+parseInt(Item)] = 1;
        }
    });

    this.EditPopupIspsList.Views.ISPListForm.setValues(ispsVals);
    this.EditPopupIspsList.Views.RuleModeToggle.setValue(parseInt(data.mode_id));

    //var node = table.getItemNode({ row: table.getSelectedId(), column:"edit"});
    //this.EditPopup.show(node, {pos:"left"});

    this.EditPopup.show();
};

UlrAppDscpRulesViewController.prototype.SaveEditForm = function()
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    if(!this.Views.EditPopupAddDSCPForm.validate())
    {
        return;
    }

    var mode = this.EditPopupIspsList ? this.EditPopupIspsList.getMode() : UlrWebRuleModesEnum.all_isps;

    var model = {
        priority:this.Views.EditPopupPriorityInput.getValue(),
        mode_id: mode == UlrWebRuleModesEnum.only_isps_in_list ? UlrWebRuleModesEnum.only_isps_in_list : UlrWebRuleModesEnum.all_isps,
        isps: []
    };

    if(model.mode_id == UlrWebRuleModesEnum.only_isps_in_list)
    {
        var isps = this.EditPopupIspsList.Views.ISPListForm.getValues();
        Object.keys(isps).forEach(function(Key){
            if(isps[Key] == 1)
            {
                model.isps.push(Key);
            }
        });
    }

    model.isps = model.isps.join(",");

    this.JustSaveRule(webix.extend(data, model, true));
};

UlrAppDscpRulesViewController.prototype.UpdateDspAppBackupMode = function (Params)
{
    let showTumbler = false;

    if(Params && parseInt(Params.env))
    {
        showTumbler = true;
    }

    if(showTumbler)
    {
        this.Views.EnableDscpSection.show();
        this.DscpProtoBackupEnabled = (Params && Params.key_val);
        this.Views.DscpProtoBackupEnabled.setValue(this.DscpProtoBackupEnabled);
        // this.OnDscpProtoBackupEnabledChange(this.DscpProtoBackupEnabled);
        if(this.DscpProtoBackupEnabled)
        {
            this.Views.DscpBackupsInfo.setValues(Params.nodes);

            this.Views.DscpBackupStateTable.clearAll();
            this.Views.DscpBackupStateTable.parse(Params.nodes);
            this.Views.DscpBackupsInfo.show();

            this.EnableSectionIfNeed(Params.nodes);

        }
        else{
            this.Views.DscpProtoSection.disable();
            this.Views.DscpBackupsInfo.hide();
        }
    }
    else{
        this.Views.EnableDscpSection.hide();
        this.Views.DscpProtoSection.enable();
        this.DscpProtoBackupEnabled = true;
    }
};

UlrAppDscpRulesViewController.prototype.EnableSectionIfNeed = function(nodes)
{
    let enable = 0;
    if(this.DscpProtoBackupEnabled)
    {
        let total = 0, processed = 0;

        if(nodes && Array.isArray(nodes))
        {
            nodes.forEach( node => {
                total += 1;
                if(parseInt(node.dscp_backuped))
                {
                    processed += 1;
                }
            });
        }

        if(total == processed)
        {
            enable = 1;
        }
    }
    this.OnDscpProtoBackupEnabledChange(enable);
};

UlrAppDscpRulesViewController.prototype.ChangeDscpAppRulesEditMode = function(Val)
{
    if(!this.Views.EnableDscpSection.hidden)
    {
        if(this.DscpProtoBackupEnabled != Val)
        {
            this.ViewModel.UlrChangeDscpAppRulesEditMode({mode: Val == 0 ? 0 : 1});
        }

    }
};

UlrAppDscpRulesViewController.prototype.OnDscpProtoBackupEnabledChange = function(Val)
{
  if(!this.Views.EnableDscpSection.hidden)
  {
      if(Val)
      {
          this.Views.DscpProtoSection.enable();
          this.Views.ProtocolInput.enable();
      }
      else
      {
          this.Views.DscpProtoSection.disable();
      }
  }
};
function UlrAppProtocolsViewController(Params) {
    var _this = this;

    this.Id = "UlrAppProtocols";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle: LangHelper.GetString("UlrModule", "Bandwidth management"),
        Title: LangHelper.GetString("UlrModule", "Applications protocols")
    };

    this.ViewModel = null;

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        FiltersForm: null,
        Widgets: {},
        ReportsWidgets: {
            ProtocolsTable: UlrAppProtocolsTable({
                id: this.Id + "ProtocolTable",
                enableTextSearch: 0,
                enableAutoHeight:true
            })
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            scroll: "y",
            body: {
                type: "space",
                rows: [

                    {
                        type: "clean",
                        borderless: true,
                        rows: [
                            {height: 6},
                            PageHeaderTemplate({root_title: this.PageTitle.Title}),
                            {height:32},
                            {
                                view: "label",
                                css:"form_text_label",
                                label:LangHelper.GetString("UlrModule","Filters")
                            },
                            {
                                view:"form",
                                id:this.Id + "FiltersForm",
                                type: "wide",
                                borderless:true,
                                elements:[
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                view:"spectre_text",
                                                name:"full_text_search",
                                                label:LangHelper.GetString("UlrModule","Search")
                                            },
                                            {
                                                view:"spectre_richselect",
                                                name:"group_id",
                                                label:LangHelper.GetString("UlrModule","Group"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                }
                                            },
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "FilterApplyBtn",
                                                css:"form_button form_element main_action",
                                                label:LangHelper.GetString("UlrModule","Apply"),
                                                height:51,
                                                click:function ()
                                                {
                                                    setTimeout(function ()
                                                    {
                                                        _this.RefreshTableReport();
                                                    },1);
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height: 32},
                            {
                                view:"template",
                                borderless:true,
                                css:"form_text_big_label",
                                //height:120,
                                autoheight:true,
                                template: LangHelper.GetString("UlrModule", "Protocols list with priority applied.")
                            },
                            {height: 32},
                            this.Views.ReportsWidgets.ProtocolsTable.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrAppProtocolsViewController.prototype.BindAll = function (Params) {
    var _this = this;

    Object.keys(this.Views).forEach(function (View) {
        if (View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey) {
        var w = _this.Views.Widgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if (w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey) {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if (w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.SignalDicProtocolsGroupsUpdatedSubscription = App.DicsManager.Signal[DicsEnum.ProtocolsGroupsDic].subscribe(function(Updated){
        if(Updated)
        {
            var dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic);

            dic = dic.sort(function(a,b){
                return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
            });

            dic.splice(0,0, {dic_id: "", id: "", value: "", $empty:true});
            _this.Views.FiltersForm.elements.group_id.define("options", dic);
            _this.Views.FiltersForm.elements.group_id.refresh();
        }
    });
};

UlrAppProtocolsViewController.prototype.ViewDidLoad = function (Params) {
    var _this = this;

    this.BindAll(Params);

    this.Refresh();


};

UlrAppProtocolsViewController.prototype.Destroy = function () {
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key) {
        if (_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget) {
        var w = _this.Views.Widgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget) {
        var w = _this.Views.ReportsWidgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    if (this.ViewModel) {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if (this.ReportsModel) {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrAppProtocolsViewController.prototype.GetPageTitle = function () {
    if (this.PageTitle)
        return this.PageTitle;
};

UlrAppProtocolsViewController.prototype.Refresh = function () {
    this.Views.ReportsWidgets.ProtocolsTable.RefreshData();
};

UlrAppProtocolsViewController.prototype.RefreshTableReport = function ()
{
    var filter = {};

    var filterFormVals = this.Views.FiltersForm.getValues();

    if(filterFormVals.group_id)
    {
        filter.group_id =
            {
                id:"group_id",
                operator:"=",
                value:filterFormVals.group_id
            };
    }

    if(filterFormVals.full_text_search)
    {
        filter.full_text_search =
            {
                id:"full_text_search",
                operator:"like",
                value:filterFormVals.full_text_search
            };
    }

    this.Views.ReportsWidgets.ProtocolsTable.RefreshData(0,{filter:filter});
};

function UlrAppCustomProtocolsViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"UlrAppCustomProtocols",
        PageTitle: {
            RootTitle:"",
            Title:LangHelper.GetString("UlrModule","Custom Protocols")
        }
    },true);

    UlrAppCustomProtocolsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrAppCustomProtocolsViewController, VasCloudProtocolsCustomViewController);
function UlrAppGroupsCustomProtocolsViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"UlrAppGroupsCustomProtocols",
        PageTitle: {
            RootTitle:LangHelper.GetString("UlrModule","Custom Protocols"),
            Title:LangHelper.GetString("UlrModule","Custom protocols groups")
        }
    },true);

    UlrAppGroupsCustomProtocolsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrAppGroupsCustomProtocolsViewController, VasCloudCustomProtocolsGroupsViewController);
function UlrCheckResourcesIntersectionViewController(Params)
{
    var _this = this;

    this.Id = "UlrCheckResourcesIntersection";

    if(!App.VasCloudSessionManager)
    {
        App.VasCloudSessionManager = new VasCloudSessionManager();
        App.VasCloudSessionManager.CheckLoggedIn();
    }

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Custom Protocols"),
        Title: LangHelper.GetString("UlrModule", "Check resource")
    };

    this.ViewModel = new UlrCheckResourcesIntersectionManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        CheckResourceIntersectionForm: null,
        CheckResourceIntersectionInput: null,
        CheckResourceIntersectionBtn: null,

        IntersectionBlockInfo: null,
        IntersectionBlockIntersectionNotFound: null,

        Widgets: {},
        ReportsWidgets: {
            ResourcesIntersection: UrlResourcesIntersectionTableWidget({
                id: this.Id + "ResourcesIntersection",
                enableTextSearch: 0,
                enableAutoHeight: 1,
                hidePaginatorToolbar: 1,
                enableLocalSort: 1
            }),
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            id:this.Id + "ScrollView",
            scroll: "y",
            body: {
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless: true,
                        rows:
                            [
                                {height: 6},
                                PageHeaderTemplate({id:this.Id + "PageTitle", root_title: this.PageTitle.Title}),
                                {height: 32},
                                {
                                    view: "form",
                                    id: this.Id + "CheckResourceIntersectionForm",
                                    type: "wide",
                                    elements: [
                                        {
                                            type: "clean",
                                            rows: [
                                                {
                                                    view: "label",
                                                    css: "form_text_label",
                                                    label: LangHelper.GetString("UlrModule", "Enter IP or SNI to check that the resource does not overlap with the protocol directory")
                                                },
                                                {
                                                    type: "wide",
                                                    cols: [
                                                        {
                                                            view: "spectre_text",
                                                            id: this.Id + "CheckResourceIntersectionInput",
                                                            name: "resource_raw",
                                                            label: LangHelper.GetString("UlrModule", "Resource check"),
                                                            keyPressTimeout: 300,
                                                            on:{
                                                                onEnter:function(ev)
                                                                {
                                                                    setTimeout(function ()
                                                                    {
                                                                        _this.CheckResourceIntersection();
                                                                    },1);
                                                                }
                                                            },
                                                            validate: function (Val) {
                                                                return Val;
                                                            }
                                                        },
                                                        {
                                                            type: "wide",
                                                            cols: [
                                                                {
                                                                    rows: [
                                                                        {},
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "CheckResourceIntersectionBtn",
                                                                            css: "form_button form_element main_action",
                                                                            label: LangHelper.GetString("UlrModule", "Check"),
                                                                            height: 51,
                                                                            autowidth: true,
                                                                            click: function () {
                                                                                setTimeout(function () {
                                                                                    _this.CheckResourceIntersection();
                                                                                }, 1);
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {height: 32},
                                BlockHeaderTemplate({
                                    title: LangHelper.GetString("UlrModule", "No intersections found"),
                                    id: this.Id + "IntersectionBlockIntersectionNotFound",
                                    icon: "",
                                    hidden: true,
                                    borderless: true
                                }),
                                {
                                    type: "wide",
                                    id: this.Id + "IntersectionBlockInfo",
                                    hidden: true,
                                    borderless:true,
                                    rows: [
                                        BlockHeaderTemplate({
                                            title: LangHelper.GetString("UlrModule", "Intersection info"),
                                            icon: "",
                                            borderless: true
                                        }),
                                        {
                                            type:"line",
                                            rows:[
                                                this.Views.ReportsWidgets.ResourcesIntersection.ViewConfig
                                            ]
                                        },
                                    ]
                                },
                            ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {
        CheckResourceIntersectionInputValue:  new Rx.BehaviorSubject(0)
    };
}

UlrCheckResourcesIntersectionViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.SignalIsLoggedIn = App.VasCloudSessionManager.SignalIsLoggedIn.subscribe(function (IsLoggedIn)
    {
        if(IsLoggedIn == null)
            return;

        if (!IsLoggedIn)
        {
            App.NavRouter.PresentModalView({id:"VasCloudLogin", modal:true});
        }
        else
        {
            if(App.NavRouter.views.VasCloudLogin)
            {
                App.NavRouter.views.VasCloudLogin.Hide();
            }
        }
    });

    this.Views.CheckResourceIntersectionInput.attachEvent("onTimedKeyPress", function()
    {
        var v = _this.Views.CheckResourceIntersectionInput.getValue();

        if(v != v.trim())
        {
            this.setValue(v.trim());
            return;
        }

        _this.Signals.CheckResourceIntersectionInputValue.next(v.trim());
    });

    this.Subscriptions.CheckResourceIntersectionInputValue = this.Signals.CheckResourceIntersectionInputValue.subscribe(function (Value)
    {
        Value && Value.length >= 3 ? _this.Views.CheckResourceIntersectionBtn.enable() : _this.Views.CheckResourceIntersectionBtn.disable();
    });

    App.VasCloudSessionManager.CheckLoggedIn();
};

UlrCheckResourcesIntersectionViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;
    this.BindAll(Params);
};

UlrCheckResourcesIntersectionViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key) {
        if (_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget) {
        var w = _this.Views.Widgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget) {
        var w = _this.Views.ReportsWidgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    if (this.ViewModel) {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if (this.ReportsModel) {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrCheckResourcesIntersectionViewController.prototype.GetPageTitle = function () {
    if (this.PageTitle)
        return this.PageTitle;
};

UlrCheckResourcesIntersectionViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrCheckResourcesIntersectionViewController.prototype.CheckResourceIntersection = function ()
{
    const _this = this;

    const resource = this.Views.CheckResourceIntersectionInput.getValue();

    if(!this.Views.CheckResourceIntersectionInput.validate())
        return;

    _this.Views.CheckResourceIntersectionBtn.disable();

    this.ViewModel.GetInfoResourceAllProtocolsIntersection({Items: [{
            type: "auto",
            uri: resource
        }],
        callback:function (R)
        {
            _this.Views.CheckResourceIntersectionBtn.enable();
            
            if(R.success)
            {
                var cloudProtocols = R.data.cloud_protocols.intersectionRows;
                var customProtocols = R.data.custom_protocols.intersectionRows;
                var customProtocolsAsns = R.data.custom_prtocols_asn.intersectionRows;

                _this.DefineResourceIntersection(cloudProtocols.concat(customProtocols).concat(customProtocolsAsns));
            }
            else
            {
                _this.ShowServerError(R.error);
            }
        }
    });
};

UlrCheckResourcesIntersectionViewController.prototype.DefineResourceIntersection = function (Arr)
{
    const viewInfo = this.Views.IntersectionBlockInfo;
    const viewInfoNotFound = this.Views.IntersectionBlockIntersectionNotFound;

    if (Arr && Arr.length)
    {
        viewInfo.show();
        viewInfoNotFound.hide();
    }
    else
    {
        viewInfo.hide();
        viewInfoNotFound.show();
    }

    const data = [];

    Arr.forEach(item => {
        const model = {}

        var itemArr = item.split(",");

        model.type = itemArr[0];
        model.verifiable_resource = itemArr[1];
        model.protocol_id = itemArr[2];
        model.protocol_name = itemArr.length >= 5 ? itemArr[3] : '';
        model.intersection_resource = itemArr.length >= 5 ? itemArr[4] : itemArr[3];

        data.push(model);
    })

    this.Views.ReportsWidgets.ResourcesIntersection.Views.Table.clearAll();
    this.Views.ReportsWidgets.ResourcesIntersection.Views.Table.parse(data ? data : []);
};

function UlrAppPrtclsCustomLogsViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"UlrAppPrtclsCustomLogs",
        PageTitle: {
            RootTitle:LangHelper.GetString("UlrModule","Custom Protocols"),
            Title:LangHelper.GetString("UlrModule","Logs")
        }
    },true);

    UlrAppPrtclsCustomLogsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrAppPrtclsCustomLogsViewController, VasCloudProtocolsLogsViewController);
function UlrEditPolicingViewController(Params) {
    var _this = this;

    this.ActionsEnum = {
        Add: "Add",
        Edit: "Edit"
    };

    this.Action = this.ActionsEnum.Edit;

    this.Id = Params && Params.Id ? Params.Id : "UlrEditAppPolicing";

    this.PageTitle = {
        RootTitle: Params && Params.RootTitle ? Params && Params.RootTitle : LangHelper.GetString("UlrModule","Bandwidth management"),
        Title: Params && Params.Title ? Params.Title : LangHelper.GetString("UlrModule","Edit application policing profile")
    };

    this.ViewModel = Params && Params.ViewModel ? Params.ViewModel : new UlrAppPolicingsManager();

    this.ReportsModel = new UniReportsManager();

    this.PolicingParentField = Params && Params.PolicingParentField ? Params.PolicingParentField : "isp_id";
    this.EditPath = Params && Params.EditPath ? Params.EditPath : ControllersEnum.UlrEditIsp;

    this.ListSection = Params && Params.ListSection ? Params.ListSection : ControllersEnum.UlrAppPolicings;

    this.EditLabel = Params && Params.EditLabel ? Params.EditLabel : LangHelper.GetString("UlrModule", "ISP profile configuration");

    this.Views = {
        ScrollView: null,
        PageTitle: null,

        PolicingForm: null,
        PolicingType: null,
        AutoFillBtn:null,

        PofileNameLabel: null,
        Description: null,

        htbForm: null,
        tbfForm: null,

        SaveBtn: null,
        SaveEnableBtn: null,
        SaveDisableBtn: null,
        ClearFormBtn: null,

        DeleteBtn:null,

        AutoFillPopupForm:null,

        Widgets: {},
        ReportsWidgets: {}
    };

    this.AutoFillPopup = null;

    this.AutoFillPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        width:400,
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "AutoFillPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Autofill"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.AutoFillPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "AutoFillPopupForm",
                            type: "wide",
                            minWidth:400,
                            elements: [
                                {
                                    type:"wide",
                                    cols:[
                                        {
                                            view: "spectre_text",
                                            name: "inbound_root_rate",
                                            label: LangHelper.GetString("UlrModule", "Inbound profile"),
                                            gravity: 2,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                            validate: function (Val)
                                            {
                                                return !isNaN(Val * 1);
                                            },
                                            on: {
                                                onChange: function (Nv, Ov)
                                                {
                                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }
                                                    this.validate();
                                                }
                                            }
                                        },
                                        {
                                            view: "spectre_richselect",
                                            name: "inbound_root_rate_unit",
                                            label: LangHelper.GetString("UlrModule", "Unit"),
                                            options:{
                                                point:false,
                                                data:Helper.DictToArr(TrafficUnits)
                                            }
                                        }
                                    ]
                                },
                                {
                                    type:"wide",
                                    cols:[
                                        {
                                            view: "spectre_text",
                                            name: "outbound_root_rate",
                                            label: LangHelper.GetString("UlrModule", "Outbound profile"),
                                            gravity: 2,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                            validate: function (Val)
                                            {
                                                return !isNaN(Val * 1);
                                            },
                                            on: {
                                                onChange: function (Nv, Ov)
                                                {
                                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }
                                                    this.validate();
                                                }
                                            }
                                        },
                                        {
                                            view: "spectre_richselect",
                                            name: "outbound_root_rate_unit",
                                            label: LangHelper.GetString("UlrModule", "Unit"),
                                            options:{
                                                point:false,
                                                data:Helper.DictToArr(TrafficUnits)
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "AutoFillPopupApplyBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Apply"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function () {
                                            _this.ApplyAutofillForm();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            id: this.Id + "ScrollView",
            scroll: "y",
            body: {
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless: true,
                        rows: [
                            {height: 6},
                            PageHeaderTemplate({
                                id: this.Id + "PageTitle",
                                root_title: this.PageTitle.Title
                            }),
                            {height: 32},
                            {
                                type: "clean",
                                rows: [
                                    {
                                        view: "template",
                                        borderless: true,
                                        css: "form_text_big_label",
                                        //height:120,
                                        autoheight: true,
                                        template: Params && Params.BlockInfoTemplate ? Params.BlockInfoTemplate : ""


                                    },
                                    {
                                        height: 32
                                    },
                                    {
                                        view: "form",
                                        id: this.Id + "PolicingForm",
                                        type: "wide",
                                        borderless: true,
                                        elements: [
                                            {
                                                cols: [
                                                    {
                                                        view: "label",
                                                        id: this.Id + "PofileNameLabel",
                                                        css: "form_header_label",
                                                        label: "",
                                                        template: LangHelper.GetString("UlrModule", "Profile name") + ": #label#"
                                                    },
                                                    {},
                                                    {
                                                        view: "spectre_button",
                                                        css: "form_button label_action with_icon",
                                                        type: "icon",
                                                        icon: "cog",
                                                        label: _this.EditLabel,
                                                        width: 280,
                                                        click:function ()
                                                        {
                                                            var parentModel = _this.ViewModel.Signals.ParentUpdated.getValue();

                                                            var _id = parentModel._id ? parentModel._id : 0;

                                                            if(_id)
                                                                App.NavRouter.PresentView({id: _this.EditPath, path:"/_id=" + _id});

                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                view: "spectre_textarea",
                                                name: "description",
                                                id: this.Id + "Description",
                                                label: LangHelper.GetString("UlrModule", "Description"),
                                                required: true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if (typeof Ov !== "undefined" && Ov !== "")
                                                        {
                                                            if(Nv && typeof Nv == "string" && typeof Nv == "string" && Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                type:"wide",
                                                cols: [
                                                    {
                                                        view: "spectre_richselect",
                                                        id: this.Id + "PolicingType",
                                                        name: "type_id",
                                                        label: LangHelper.GetString("UlrModule", "Policing type"),
                                                        options:{
                                                            point:false,
                                                            data:[]
                                                        },
                                                        required: true,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov) {
                                                                if (typeof Ov !== "undefined" && Ov !== "")
                                                                    this.validate();

                                                                _this.Signals.PolicingTypeChanged.next(Nv);
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view: "spectre_button",
                                                        id: this.Id + "AutoFillBtn",
                                                        css: "form_element form_button spec_action",
                                                        label: LangHelper.GetString("UlrModule", "Autofill"),
                                                        autowidth: true,
                                                        //hidden:true,
                                                        click: function ()
                                                        {
                                                            _this.ShowAutofillForm();
                                                        }
                                                    },
                                                    {
                                                        gravity: 3
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        height: 20
                                    },
                                    {
                                        view: "form",
                                        id: this.Id + "htbForm",
                                        css: "slide_down_box",
                                        type: "wide",
                                        borderless: true,
                                        hidden: true,
                                        elements: function () {
                                            var els = [];

                                            function construct(Direction) {
                                                els.push({
                                                    type: "wide",
                                                    cols: [
                                                        {
                                                            rows: [
                                                                {
                                                                    view: "label",
                                                                    css: "form_bold_label",
                                                                    label: LangHelper.GetString("UlrModule", Helper.CapitalizeFirstLetter(Direction) + " profile") + ":"
                                                                },
                                                                {
                                                                    type: "wide",
                                                                    rows: function () {
                                                                        var rows = [
                                                                            {
                                                                                type: "wide",
                                                                                cols: [
                                                                                    {
                                                                                        view: "spectre_text",
                                                                                        name: Direction + "_root_rate",
                                                                                        label: LangHelper.GetString("UlrModule", "ROOT_RATE"),
                                                                                        gravity: 2,
                                                                                        invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                                                                        validate: function (Val) {
                                                                                            return !isNaN(Val * 1);
                                                                                        },
                                                                                        on: {
                                                                                            onChange: function (Nv, Ov)
                                                                                            {
                                                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                                                {
                                                                                                    this.setValue(Nv.trim());
                                                                                                    return;
                                                                                                }
                                                                                                this.validate();
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        view: "spectre_richselect",
                                                                                        name: Direction + "_root_rate_unit",
                                                                                        label: LangHelper.GetString("UlrModule", "Unit"),
                                                                                        options:{
                                                                                            point:false,
                                                                                            data:Helper.DictToArr(TrafficUnits)
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ];

                                                                        for (var i = 0; i < 8; i++) {
                                                                            rows.push({
                                                                                type: "wide",
                                                                                cols: [
                                                                                    {
                                                                                        view: "spectre_text",
                                                                                        name: Direction + "_class_" + i + "_rate",
                                                                                        label: LangHelper.GetString("UlrModule", "CS" + i + "_RATE"),
                                                                                        gravity: 2,
                                                                                        invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                                                                        validate: function (Val) {
                                                                                            return !isNaN(Val * 1);
                                                                                        },
                                                                                        on: {
                                                                                            onChange: function (Nv, Ov)
                                                                                            {
                                                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                                                {
                                                                                                    this.setValue(Nv.trim());
                                                                                                    return;
                                                                                                }
                                                                                                this.validate();
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        view: "spectre_richselect",
                                                                                        name: Direction + "_class_" + i + "_rate_unit",
                                                                                        label: LangHelper.GetString("UlrModule", "Unit"),
                                                                                        options:{
                                                                                            point:false,
                                                                                            data:Helper.DictToArr(TrafficUnits)
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            });
                                                                        }

                                                                        return rows;
                                                                    }()
                                                                }
                                                            ]
                                                        },
                                                        {width: 1},
                                                        {
                                                            rows: [
                                                                {
                                                                    view: "label",
                                                                    css: "form_bold_label",
                                                                    label: ""
                                                                },
                                                                {
                                                                    type: "wide",
                                                                    rows: function () {
                                                                        var rows = [
                                                                            {
                                                                                type: "wide",
                                                                                cols: [
                                                                                    {
                                                                                        view: "spectre_text",
                                                                                        name: Direction + "_root_ceil",
                                                                                        label: LangHelper.GetString("UlrModule", "ROOT_CEIL"),
                                                                                        gravity: 2,
                                                                                        disabled: true,
                                                                                        invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                                                                        validate: function (Val) {
                                                                                            return !isNaN(Val * 1);
                                                                                        },
                                                                                        on: {
                                                                                            onChange: function (Nv, Ov)
                                                                                            {
                                                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                                                {
                                                                                                    this.setValue(Nv.trim());
                                                                                                    return;
                                                                                                }
                                                                                                this.validate();
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        view: "spectre_richselect",
                                                                                        name: Direction + "_root_ceil_unit",
                                                                                        label: LangHelper.GetString("UlrModule", "Unit"),
                                                                                        options:{
                                                                                            point:false,
                                                                                            data:Helper.DictToArr(TrafficUnits)
                                                                                        },
                                                                                        disabled: true
                                                                                    },
                                                                                    {
                                                                                        rows: [
                                                                                            {},
                                                                                            {
                                                                                                view: "checkbox",
                                                                                                name: Direction + "_root_ceil_enabled",
                                                                                                labelWidth: 0,
                                                                                                labelRight: LangHelper.GetString("UlrModule", "Enable"),
                                                                                                //height:21,
                                                                                                height: 44,
                                                                                                on: {
                                                                                                    onChange: function (Nv, Ov) {
                                                                                                        if (typeof Nv === "undefined" || Nv === null)
                                                                                                            return;

                                                                                                        var els = this.getFormView().elements;

                                                                                                        var name = this.config.name.replace("_enabled", "");
                                                                                                        var name_unit = name + "_unit";

                                                                                                        if (parseInt(Nv)) {
                                                                                                            els[name].enable();
                                                                                                            els[name_unit].enable();
                                                                                                        } else {
                                                                                                            els[name].disable();
                                                                                                            els[name_unit].disable();
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ];

                                                                        for (var i = 0; i < 8; i++) {
                                                                            rows.push({
                                                                                type: "wide",
                                                                                cols: [
                                                                                    {
                                                                                        view: "spectre_text",
                                                                                        name: Direction + "_class_" + i + "_ceil",
                                                                                        label: LangHelper.GetString("UlrModule", "CS" + i + "_CEIL"),
                                                                                        gravity: 2,
                                                                                        invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                                                                        validate: function (Val) {
                                                                                            if (Val && Val == "static")
                                                                                                return true;

                                                                                            return !isNaN(Val * 1);
                                                                                        },
                                                                                        on: {
                                                                                            onChange: function (Nv, Ov)
                                                                                            {
                                                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                                                {
                                                                                                    this.setValue(Nv.trim());
                                                                                                    return;
                                                                                                }
                                                                                                this.validate();
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        view: "spectre_richselect",
                                                                                        name: Direction + "_class_" + i + "_ceil_unit",
                                                                                        label: LangHelper.GetString("UlrModule", "Unit"),
                                                                                        options:{
                                                                                            point:false,
                                                                                            data:Helper.DictToArr(TrafficUnits)
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        rows: [
                                                                                            {},
                                                                                            {
                                                                                                view: "checkbox",
                                                                                                name: Direction + "_class_" + i + "_ceil_static",
                                                                                                labelWidth: 0,
                                                                                                labelRight: LangHelper.GetString("UlrModule", "Static"),
                                                                                                //height:21,
                                                                                                height: 44,
                                                                                                on: {
                                                                                                    onChange: function (Nv, Ov) {

                                                                                                        if (typeof Nv === "undefined" || Nv === null)
                                                                                                            return;

                                                                                                        var els = this.getFormView().elements;

                                                                                                        var name = this.config.name.replace("_static", "");
                                                                                                        var name_unit = name + "_unit";

                                                                                                        if (parseInt(Nv)) {
                                                                                                            els[name].disable();
                                                                                                            els[name_unit].disable();

                                                                                                            els[name].setValue("static");
                                                                                                        } else {
                                                                                                            els[name].enable();
                                                                                                            els[name_unit].enable();

                                                                                                            var val = els[name].getValue();
                                                                                                            if (val == "static")
                                                                                                                els[name].setValue("");
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            });
                                                                        }

                                                                        return rows;
                                                                    }()
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            width: 240,
                                                            rows: [
                                                                {
                                                                    type: "wide",
                                                                    rows: function () {
                                                                        var rows = [
                                                                            {
                                                                                height: 90
                                                                            }
                                                                        ];

                                                                        for (var i = 0; i < 8; i++) {
                                                                            rows.push(
                                                                                {
                                                                                    rows: [
                                                                                        {},
                                                                                        {
                                                                                            view: "spectre_button",
                                                                                            css: "form_button form_element label_action with_icon",
                                                                                            type: "icon",
                                                                                            icon: "list-alt",
                                                                                            autowidth: true,
                                                                                            label: LangHelper.GetString("UlrModule", "Applications CS{INDEX} list").replace("{INDEX}",i),
                                                                                            height: 32,
                                                                                            click: function (current_i) {
                                                                                                var modal_title = LangHelper.GetString("UlrModule", "Applications CS{INDEX} list").replace("{INDEX}",current_i);
                                                                                                var current_cs = "cs" + current_i;

                                                                                                var table_params = {
                                                                                                    enableAutoHeight: false,
                                                                                                    enableTextSearch: true,
                                                                                                    is_modal: true,
                                                                                                    filter: {
                                                                                                        priority: {
                                                                                                            id: "priority",
                                                                                                            operator: "=",
                                                                                                            value: current_cs
                                                                                                        }
                                                                                                    },
                                                                                                }
                                                                                                var table = new UlrAppProtocolsTable(table_params);

                                                                                                UlrEditAppPolicingPopup({
                                                                                                    modal_title: modal_title
                                                                                                }, table);
                                                                                                table.Bind(_this, _this.ReportsModel);
                                                                                                table.RefreshData();
                                                                                            }.bind(_this, i)
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            );
                                                                        }

                                                                        return rows;
                                                                    }()
                                                                }
                                                            ]

                                                        }
                                                    ]
                                                });
                                            }

                                            construct("inbound");

                                            construct("outbound");

                                            return els;
                                        }()
                                    },
                                    {
                                        view: "form",
                                        id: this.Id + "tbfForm",
                                        css: "slide_down_box",
                                        type: "wide",
                                        borderless: true,
                                        hidden: true,
                                        elements: function () {
                                            var cols = [];

                                            function construct(Direction) {
                                                cols.push({
                                                    rows: [
                                                        {
                                                            view: "label",
                                                            css: "form_bold_label",
                                                            label: LangHelper.GetString("UlrModule", Helper.CapitalizeFirstLetter(Direction) + " profile") + ":"
                                                        },
                                                        {
                                                            type: "wide",
                                                            rows: function () {
                                                                var rows = [];

                                                                for (var i = 0; i < 8; i++) {
                                                                    rows.push({
                                                                        type: "wide",
                                                                        cols: [
                                                                            {
                                                                                view: "checkbox",
                                                                                name: Direction + "_class_" + i + "_enabled",
                                                                                label: "",
                                                                                width: 32,
                                                                                on: {
                                                                                    onChange: function(Nv, Ov)
                                                                                    {
                                                                                        var els = this.getFormView().elements;
                                                                                        var name = this.config.name.replace("_enabled", "_rate");
                                                                                        var name_unit = name + "_unit";
                                                                                        if(parseInt(Nv))
                                                                                        {
                                                                                            els[name].enable();
                                                                                            els[name_unit].enable();
                                                                                        }
                                                                                        else{
                                                                                            els[name].disable();
                                                                                            els[name_unit].disable();
                                                                                        }
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                view: "spectre_text",
                                                                                name: Direction + "_class_" + i + "_rate",
                                                                                label: LangHelper.GetString("UlrModule", "CS" + i),
                                                                                gravity: 2,
                                                                                invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                                                                validate: function (Val) {
                                                                                    return !isNaN(Val * 1);
                                                                                },
                                                                                on: {
                                                                                    onChange: function (Nv, Ov)
                                                                                    {
                                                                                        if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                                        {
                                                                                            this.setValue(Nv.trim());
                                                                                            return;
                                                                                        }
                                                                                        this.validate();
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                view: "spectre_richselect",
                                                                                name: Direction + "_class_" + i + "_rate_unit",
                                                                                label: LangHelper.GetString("UlrModule", "Unit"),
                                                                                options:{
                                                                                    point:false,
                                                                                    data:Helper.DictToArr(TrafficUnits)
                                                                                }
                                                                            }
                                                                        ]
                                                                    });
                                                                }

                                                                return rows;
                                                            }()
                                                        }
                                                    ]
                                                });
                                            }

                                            construct("inbound");

                                            cols.push({width: 1});

                                            construct("outbound");

                                            cols.push({
                                                width: 240,
                                                rows: [
                                                    {
                                                        view: "label",
                                                        label: ""
                                                    },
                                                    {
                                                        type: "wide",
                                                        rows: function () {
                                                            var rows = [];

                                                            for (var i = 0; i < 8; i++) {
                                                                rows.push(
                                                                    {
                                                                        rows: [
                                                                            {},
                                                                            {
                                                                                view: "spectre_button",
                                                                                css: "form_button form_element label_action with_icon",
                                                                                type: "icon",
                                                                                icon: "list-alt",
                                                                                autowidth: true,
                                                                                label: LangHelper.GetString("UlrModule", "Applications CS{INDEX} list").replace("{INDEX}",i),
                                                                                height: 32,
                                                                                click: function (current_i) {
                                                                                    var modal_title = LangHelper.GetString("UlrModule", "Applications CS{INDEX} list").replace("{INDEX}",current_i);
                                                                                    var current_cs = "cs" + current_i;

                                                                                    var table_params = {
                                                                                        enableAutoHeight: false,
                                                                                        enableTextSearch: true,
                                                                                        is_modal: true,
                                                                                        filter: {
                                                                                            priority: {
                                                                                                id: "priority",
                                                                                                operator: "=",
                                                                                                value: current_cs
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    var table = new UlrAppProtocolsTable(table_params);

                                                                                    UlrEditAppPolicingPopup({
                                                                                        modal_title: modal_title
                                                                                    }, table);
                                                                                    table.Bind(_this, _this.ReportsModel);
                                                                                    table.RefreshData();
                                                                                }.bind(_this, i)
                                                                            }
                                                                        ]
                                                                    }
                                                                );
                                                            }

                                                            return rows;
                                                        }()
                                                    }
                                                ]

                                            });

                                            return [{
                                                type: "wide",
                                                cols: cols
                                            }];
                                        }()
                                    },
                                    {
                                        height: 32
                                    },
                                    {
                                        type: "wide",
                                        cols: [
                                            {
                                                view: "spectre_button",
                                                id: this.Id + "SaveBtn",
                                                css: "form_button main_action",
                                                label: LangHelper.GetString("UlrModule", "Save profile"),
                                                autowidth: true,
                                                click: function () {
                                                    _this.Save();
                                                }
                                            },
                                            {
                                                view: "spectre_button",
                                                id: this.Id + "SaveEnableBtn",
                                                css: "form_button second_action",
                                                label: LangHelper.GetString("UlrModule", "Save and enable"),
                                                autowidth: true,
                                                click: function () {
                                                    _this.Save(true);
                                                },
                                                hidden: true
                                            },
                                            {
                                                view: "spectre_button",
                                                id: this.Id + "SaveDisableBtn",
                                                css: "form_button second_action",
                                                label: LangHelper.GetString("UlrModule", "Save and disable"),
                                                autowidth: true,
                                                click: function () {
                                                    _this.Save(false);
                                                },
                                                hidden: true
                                            },
                                            {
                                                view: "spectre_button",
                                                id: this.Id + "ClearFormBtn",
                                                css: "form_button third_action",
                                                label: LangHelper.GetString("UlrModule", "Clear profile"),
                                                autowidth: true,
                                                click: function () {
                                                    _this.ClearProfile();
                                                }
                                            },
                                            {},
                                            {
                                                view:"spectre_button",
                                                id: this.Id + "DeleteBtn",
                                                css:"form_button delete_action",
                                                label:LangHelper.GetString("UlrModule","Delete profile"),
                                                autowidth:true,
                                                click:function ()
                                                {
                                                    _this.Delete();
                                                },
                                                hidden:true
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {
        PolicingTypeChanged: new Rx.BehaviorSubject(0),
        ProfileEnabled: new Rx.BehaviorSubject(0)
    };
}

UlrEditPolicingViewController.prototype.ViewDidLoad = function (PathParams) {
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);


    this.Refresh();

};

UlrEditPolicingViewController.prototype.BindAll = function (Params) {
    var _this = this;

    this.AutoFillPopup = webix.ui(this.AutoFillPopupConfig);

    Object.keys(this.Views).forEach(function (View) {
        if (View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey) {
        var w = _this.Views.Widgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if (w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey) {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if (w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress) {
        var view = _this.Views.SaveBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveEnableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveDisableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.ClearFormBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.DeleteBtn;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions[DicsEnum.UlrPolicingTypesDic] = App.DicsManager.Signal[DicsEnum.UlrPolicingTypesDic].subscribe(function (Dic) {
        if (Dic) {
            _this.Views.PolicingForm.elements.type_id.getList().clearAll();
            _this.Views.PolicingForm.elements.type_id.getList().parse(
                function () {
                    var arr = App.DicsManager.GetDicAsArray(DicsEnum.UlrPolicingTypesDic);

                    var newArr = [];

                    arr.forEach(function (Item) {
                        newArr.push({
                            id: Item.id,
                            value: Item.value.toUpperCase()
                        });
                    });

                    return newArr;
                }()
            );

        }
    });

    this.Subscriptions.PolicingTypeChanged = this.Signals.PolicingTypeChanged.subscribe(function (Type) {
        if (Type) {
            var typeDic = App.DicsManager.GetDic(DicsEnum.UlrPolicingTypesDic);
            var type = typeDic && typeDic[Type] ? typeDic[Type].value : null;

            if (type == UlrPolicingClassesTypeEnum.htb)
            {
                _this.Views.tbfForm.hide();
                _this.Views.htbForm.show();
                //_this.Views.AutoFillBtn.show();
            }
            else if (type == UlrPolicingClassesTypeEnum.tbf)
            {
                _this.Views.htbForm.hide();
                _this.Views.tbfForm.show();
                //_this.Views.AutoFillBtn.hide();
            }
            else
            {
                _this.Views.htbForm.hide();
                _this.Views.tbfForm.hide();
                //_this.Views.AutoFillBtn.hide();
            }
        }
    });

    this.Subscriptions.AppPolicingProfileUpdated = Rx.Observable.combineLatest
    (
        this.ViewModel.Signals.PolicingProfileUpdated,
        this.ViewModel.Signals.ParentUpdated
    ).subscribe(function (Val) {
            var appPolicingModel = Val[0];
            var parentModel = Val[1];

            if (parentModel && appPolicingModel)
                _this.DefineAll(appPolicingModel, parentModel);
        }
    );

    this.Subscriptions.ProfileEnabled = this.Signals.ProfileEnabled.subscribe(function (Enabled) {
        var view = _this.Views.SaveDisableBtn;
        Enabled ? view.show() : view.hide();

        var view = _this.Views.SaveEnableBtn;
        !Enabled ? view.show() : view.hide();
    });

    this.Subscriptions.AppPolicingProfileError = this.ViewModel.Signals.PolicingProfileError.subscribe(function (ErrModel)
    {
        var action = null;

        if(ErrModel&&ErrModel.code == 404)
        {
            action = function () {
                setTimeout(function () {
                    App.NavRouter.PresentView({id: _this.ListSection});
                }, 1);
            }
        }
        _this.ShowLoadSaveProfileError(ErrModel,action);
    });

    this.Subscriptions.AppPolicingProfileSaveError = this.ViewModel.Signals.PolicingProfileSaveError.subscribe(function (ErrModel) {
        _this.ShowLoadSaveProfileError(ErrModel);
    });

    this.Subscriptions.AppPolicingProfileDeleteError = this.ViewModel.Signals.PolicingProfileDeleteError.subscribe(function (ErrModel) {
        _this.ShowLoadSaveProfileError(ErrModel);
    });

    this.Subscriptions.AppPolicingProfileSaved = this.ViewModel.Signals.PolicingProfileSaved.subscribe(function (PolicingProfileModel) {
        if (PolicingProfileModel) {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", "App policing") + " # " + PolicingProfileModel[_this.ViewModel.ProfilePolicingType].name + ": " + LangHelper.GetString("UlrModule", "Saving"),
                LangHelper.GetString("UlrModule", "Success")
            );

            if(!AppEnv.UlrNoRedirectAfterSavePolicingAndIsps)
            {
                setTimeout(function () {
                    var source = _this.GetPathParam("source");
                    App.NavRouter.PresentView({id: source ? source : _this.ListSection});
                }, 1);
            }
            else
            {
                _this.Refresh();
            }
        }
    });

    this.Subscriptions.AppPolicingProfileDeleted = this.ViewModel.Signals.PolicingProfileDeleted.subscribe(function (PolicingIspModel) {
        if (PolicingIspModel) {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", "App policing") + " # " + PolicingIspModel.name + ": " + LangHelper.GetString("UlrModule", "Deleting"),
                LangHelper.GetString("UlrModule", "Success")
            );

            setTimeout(function () {
                var source = _this.GetPathParam("source");
                App.NavRouter.PresentView({id: source ? source : _this.ListSection});
            }, 1);
        }
    });

};

UlrEditPolicingViewController.prototype.Destroy = function () {
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key) {
        if (_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget) {
        var w = _this.Views.Widgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget) {
        var w = _this.Views.ReportsWidgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    if (this.ViewModel) {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if (this.ReportsModel) {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrEditPolicingViewController.prototype.GetPageTitle = function () {
    if (this.PageTitle)
        return this.PageTitle;
};

UlrEditPolicingViewController.prototype.Refresh = function () {
    this.RefreshAppPolicingProfile();
};

UlrEditPolicingViewController.prototype.SetPathParam = function (Key, Val) {
    App.NavRouter.SetPathParam(Key, Val, this);
};

UlrEditPolicingViewController.prototype.GetPathParam = function (Key) {
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditPolicingViewController.prototype.DefinePageTitle = function (Title) {
    this.Views.PageTitle.define("data", {root_title: Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

UlrEditPolicingViewController.prototype.RefreshAppPolicingProfile = function () {
    var id = this.Action == this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    this.ViewModel.ResfreshAppPolicingProfile({_id: id});

    this.DefinePageTitle((this.Action == this.ActionsEnum.Add ? LangHelper.GetString("UlrModule", "Add application policing profile") : this.PageTitle.Title) + " #" + id);
};

UlrEditPolicingViewController.prototype.DefineAll = function (AppPolicingModel, ParentModel) {
    var _this = this;

    var enabled = 0;
    if(ParentModel instanceof UlrIgwModel)
    {
        enabled = parseInt(AppPolicingModel.enabled);
    }
    else{
        enabled = parseInt(ParentModel.enabled)&&parseInt(AppPolicingModel.enabled)?1:0;
    }

    //var policingId = parseInt(AppPolicingModel._id);
    //var enabled = parseInt(AppPolicingModel.enabled) && policingId ? 1 : 0;

    //this.Views.PofileNameLabel.define("label", IspModel.name + (policingId ? " (" + (enabled ? LangHelper.GetString("UlrModule", "Enabled") : LangHelper.GetString("UlrModule", "Disabled")) + ")" : ""));
    this.Views.PofileNameLabel.define("label", ParentModel.name+(ParentModel.igw_name ? " " + ParentModel.igw_name : "") + " (" + (enabled ? LangHelper.GetString("UlrModule", "Enabled") : LangHelper.GetString("UlrModule", "Disabled")) + ")");
    this.Views.PofileNameLabel.refresh();

    this.Signals.ProfileEnabled.next(enabled);

    this.Views.Description.setValue(AppPolicingModel.description);

    this.Views.PolicingType.setValue(AppPolicingModel.type_id);

    var typeDic = App.DicsManager.GetDic(DicsEnum.UlrPolicingTypesDic);
    var typeId = this.Views.PolicingType.getValue();

    var type = typeDic[typeId] ? typeDic[typeId].value : null;

    var formModel = this.ViewModel.MapPolicngClassesProfileToViewModel(AppPolicingModel.config_model, type);

    this.Views.tbfForm.setValues(formModel);
    this.Views.htbForm.setValues(formModel);

    if(AppPolicingModel._id)
    {
        this.Views.DeleteBtn.show();
    }
};

UlrEditPolicingViewController.prototype.ClearProfile = function () {
    var formModel = this.ViewModel.MapPolicngClassesProfileToViewModel(null, UlrPolicingClassesTypeEnum.htb);
    this.Views.htbForm.setValues(formModel);

    var formModel = this.ViewModel.MapPolicngClassesProfileToViewModel(null, UlrPolicingClassesTypeEnum.tbf);
    this.Views.tbfForm.setValues(formModel);

};

UlrEditPolicingViewController.prototype.Save = function (Enable) {
    var _this = this;

    if (!this.Views.PolicingForm.validate()) {
        this.Views.ScrollView.scrollTo(0, 0);
        return;
    }

    var currProfile = this.ViewModel.Signals.PolicingProfileUpdated.getValue();

    var formProfile = this.Views.PolicingForm.getValues();

    var typeDic = App.DicsManager.GetDic(DicsEnum.UlrPolicingTypesDic);
    var typeId = this.Views.PolicingType.getValue();

    var type = typeDic[typeId] ? typeDic[typeId].value : null;

    var model = new UlrIspPolicingModel(webix.extend(currProfile, formProfile, true), type);

    if (type == UlrPolicingClassesTypeEnum.htb)
    {
        if (!this.Views.htbForm.validate())
        {
            this.Views.ScrollView.showView(this.Id + "htbForm");
            return false;
        }

        var htbValues = this.Views.htbForm.getValues();
        model.config_model = this.ViewModel.MapViewPolicngClassesProfileToModel(htbValues, type);

        var validModel = this.ViewModel.ValidatePolicingClassesProfileModel(model.config_model, type);

        if (!validModel.valid)
        {
            Object.keys(validModel).every(function (Key) {
                if (Key == "valid")
                    return true;

                if (!validModel[Key]) {
                    if (Key == "inbound_root" || Key == "outbound_root") {
                        var msg = Key == "inbound_root" ? LangHelper.GetString("UlrModule","Inbound profile") : LangHelper.GetString("UlrModule","Outbound profile");

                        msg += ": ";

                        msg += LangHelper.GetString("UlrModule", "Sum of classes rates should be less or equal root rate.");

                        _this.ShowLoadSaveProfileError({
                            code: 0,
                            msg: LangHelper.GetString("UlrModule", msg)
                        });
                    }

                    if (Key == "inbound_classes" || Key == "outbound_classes") {
                        var msg = Key == "inbound_classes" ? "Inbound: " : "Oubound: ";

                        msg += "Class ceil/rate ration should be less or equal 65535.";

                        _this.ShowLoadSaveProfileError({
                            code: 0,
                            msg: LangHelper.GetString("UlrModule", msg)
                        });
                    }

                    return false;
                }

                return true;
            });

            return false;
        }
    }

    if (type == UlrPolicingClassesTypeEnum.tbf) {
        if (!this.Views.tbfForm.validate()) {
            this.Views.ScrollView.showView(this.Id + "tbfForm");
            return;
        }

        var tbfValues = this.Views.tbfForm.getValues();
        model.config_model = this.ViewModel.MapViewPolicngClassesProfileToModel(tbfValues, type);
    }

    model.config = JSON.stringify(model.config_model);

    if (typeof Enable != "undefined") {
        model.enabled = Enable ? 1 : 0;
    }

    this.ViewModel.SaveAppPolicingProfile(model);
};

UlrEditPolicingViewController.prototype.ShowLoadSaveProfileError = function (ErrModel, Action) {
    if (ErrModel)
        UlrShowAlertWindow({
            head: LangHelper.GetString("UlrModule", "Error"),
            type: "spectre-alert-error",
            mainTitle: LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message: LangHelper.GetString("UlrModule", ErrModel.msg),
            actions: [
                {
                    label: LangHelper.GetString("UlrModule", "Ok"),
                    click: function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};

UlrEditPolicingViewController.prototype.Delete = function()
{
    var _this = this;

    var model = this.ViewModel.Signals.PolicingProfileUpdated.getValue();

    var ispModel = this.ViewModel.Signals.ParentUpdated.getValue();

    model = webix.extend(model,{name:ispModel.name});

    UlrShowDialogPopup({
        node:this.Views.DeleteBtn.getNode(),
        position:"bottom",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    _this.ViewModel.DeleteAppPolicingProfile(model);
                }
            }
        ]
    });
};

UlrEditPolicingViewController.prototype.ShowAutofillForm = function()
{
    var formVals = this.Views.AutoFillPopupForm.getValues();

    if(!formVals.inbound_root_rate)
    {
        formVals.inbound_root_rate = 100;
        formVals.inbound_root_rate_unit = TrafficVals.mbit.id;
    }

    if(!formVals.outbound_root_rate)
    {
        formVals.outbound_root_rate = 100;
        formVals.outbound_root_rate_unit = TrafficVals.mbit.id;
    }

    this.Views.AutoFillPopupForm.setValues(formVals);

    this.AutoFillPopup.show();

};

UlrEditPolicingViewController.prototype.ApplyAutofillForm = function()
{
    if (!this.Views.AutoFillPopupForm.validate())
    {
        return;
    }

    var typeDic = App.DicsManager.GetDic(DicsEnum.UlrPolicingTypesDic);
    var typeId = this.Views.PolicingType.getValue();
    var type = typeDic[typeId] ? typeDic[typeId].value : null;

    var formVals = this.Views.AutoFillPopupForm.getValues();

    if (type == UlrPolicingClassesTypeEnum.htb)
    {
        var inbound = formVals.inbound_root_rate+formVals.inbound_root_rate_unit;
        var outbound = formVals.outbound_root_rate+formVals.outbound_root_rate_unit;

        var model = {
            inbound:
                {
                    root_rate: inbound,
                    classes:function ()
                    {
                        var arr = [];

                        for (var i = 0; i < 8; i++)
                        {
                            arr.push({ceil:inbound, enabled: 1});
                        }

                        return arr;
                    }()
                },
            outbound:
                {
                    root_rate: outbound,
                    classes:function ()
                    {
                        var arr = [];

                        for (var i = 0; i < 8; i++)
                        {
                            arr.push({ceil:outbound, enabled: 1});
                        }

                        return arr;
                    }()
                }
        };

        var formModel = this.ViewModel.MapPolicngClassesProfileToViewModel(model, UlrPolicingClassesTypeEnum.htb);
        this.Views.htbForm.setValues(formModel);

        if(!this.Views.Description.getValue())
            this.Views.Description.setValue(inbound);
    }

    if (type == UlrPolicingClassesTypeEnum.tbf)
    {
        var inbound = formVals.inbound_root_rate+formVals.inbound_root_rate_unit;
        var outbound = formVals.outbound_root_rate+formVals.outbound_root_rate_unit;

        var model = {
            inbound:
                {
                    classes:function ()
                    {
                        var arr = [];

                        for (var i = 0; i < 8; i++)
                        {
                            arr.push({rate:inbound, enabled: 1});
                        }

                        return arr;
                    }()
                },
            outbound:
                {
                    classes:function ()
                    {
                        var arr = [];

                        for (var i = 0; i < 8; i++)
                        {
                            arr.push({rate:outbound, enabled: 1});
                        }

                        return arr;
                    }()
                }
        };

        var formModel = this.ViewModel.MapPolicngClassesProfileToViewModel(model, UlrPolicingClassesTypeEnum.tbf);
        this.Views.tbfForm.setValues(formModel);

        if(!this.Views.Description.getValue())
            this.Views.Description.setValue(inbound);
    }



    this.AutoFillPopup.hide();
};
function UlrEditAppPolicingViewController(Params) {
    var _this = this;

    this.Id = "UlrEditAppPolicing";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","Edit ISP policing profile");
    this.ViewModel = new UlrAppPolicingsManager({
        profile_type: UlrPolicingTypeEnum.isp
    });

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        PolicingParentField: "isp_id",
        EditLabel: LangHelper.GetString("UlrModule", "Channel profile configuration"),
        EditPath: ControllersEnum.UlrEditIsp,
        ListSection: ControllersEnum.UlrAppPolicings,
        BlockInfoTemplate: LangHelper.GetString("UlrModule","Policing profiles are connected to channel profile.") + " " +
            LangHelper.GetString("UlrModule","This profiles can be enabled and disabled. You can edit them.") + " " +
            LangHelper.GetString("UlrModule","You can use HTB or TBF style policing. TBF doesn`t require root class but don`t support traffic ceiling.")
    }, true);

    UlrEditAppPolicingViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrEditAppPolicingViewController, UlrEditPolicingViewController);

function UlrAddAppPolicingViewController(Params) {
    UlrAddAppPolicingViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddAppPolicingViewController, UlrEditAppPolicingViewController);
function UlrEditIgwPolicingViewController(Params) {
    var _this = this;

    this.Id = "UlrEditIgwPolicing";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","Edit IGW policing profile");
    this.ViewModel = new UlrAppPolicingsManager({
        profile_type: UlrPolicingTypeEnum.igw
    });

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        PolicingParentField: "igw_id",
        EditPath: ControllersEnum.UlrEditIgw,
        EditLabel: LangHelper.GetString("UlrModule", "Place profile configuration"),
        ListSection: ControllersEnum.UlrIgwPolicings,
        BlockInfoTemplate: LangHelper.GetString("UlrModule","Policing profiles are connected to place profile.") + " " +
            LangHelper.GetString("UlrModule","This profiles can be enabled and disabled. You can edit them.") + " " +
            LangHelper.GetString("UlrModule","You can use HTB or TBF style policing. TBF doesn`t require root class but don`t support traffic ceiling.")
    }, true);

    UlrEditIgwPolicingViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrEditIgwPolicingViewController, UlrEditPolicingViewController);

function UlrAddIgwPolicingViewController(Params) {
    UlrAddAppPolicingViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddIgwPolicingViewController, UlrEditIgwPolicingViewController);
function UlrEditSubscriberPolicingViewController(Params) {
    var _this = this;

    this.Id = "UlrEditSubscriberPolicing";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","Edit subscriber policing profile");
    this.ViewModel = new UlrAppPolicingsManager({
        profile_type: UlrPolicingTypeEnum.isp
    });

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        PolicingParentField: "isp_id",
        EditLabel: LangHelper.GetString("UlrModule", "Subscriber profile configuration"),
        EditPath: ControllersEnum.UlrEditSubs,
        ListSection: ControllersEnum.UlrSubscribersPolicings,
        BlockInfoTemplate: LangHelper.GetString("UlrModule","Policing profiles are connected to subscriber profile.") + " " +
            LangHelper.GetString("UlrModule","This profiles can be enabled and disabled. You can edit them.") + " " +
            LangHelper.GetString("UlrModule","You can use HTB or TBF style policing. TBF doesn`t require root class but don`t support traffic ceiling.")
    }, true);

    UlrEditSubscriberPolicingViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrEditSubscriberPolicingViewController, UlrEditPolicingViewController);

function UlrAddSubscriberPolicingViewController(Params) {
    UlrAddSubscriberPolicingViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddSubscriberPolicingViewController, UlrEditSubscriberPolicingViewController);
function UlrEditSessionPolicingViewController(Params)
{
    var _this = this;

    this.Id = Params && Params.Id ? Params.Id : "UlrEditIspSessionPolicing";

    this.ActionsEnum = {
        Add: "Add",
        Edit: "Edit"
    };

    this.Action = Params && Params.Action ? Params.Action : this.ActionsEnum.Edit;

    this.PageTitle = {
        RootTitle: Params && Params.RootTitle ? Params && Params.RootTitle : LangHelper.GetString("UlrModule","Bandwidth management"),
        Title: Params && Params.Title ? Params.Title : LangHelper.GetString("UlrModule","Edit ISP session policing profile")
    };

    this.ViewModel = Params && Params.ViewModel ? Params.ViewModel : new UlrIspSessionPolicingsManager();
    this.ReportsModel = new UniReportsManager();

    this.ProtocolsDicsManager = new HardwareDscpProrocolsManager();

    this.EditPath = Params && Params.EditPath ? Params.EditPath : ControllersEnum.UlrEditIsp;
    this.EditLabel = Params && Params.EditLabel ? Params.EditLabel : LangHelper.GetString("UlrModule", "ISP profile configuration");
    this.HideEditLabel = Params && Params.HideEditLabel ? Params.HideEditLabel : false;
    this.IsTemplate = Params && Params.IsTemplate ? Params.IsTemplate : false;
    this.TemplateType = Params && Params.TemplateType ? Params.TemplateType : UlrPolicingTemplatesTypesDic.session.id;
    this.ListSection = Params && Params.ListSection ? Params.ListSection : ControllersEnum.UlrIspSessionPolicings;

    this.Views = {
        ScrollView: null,
        PageTitle: null,

        ProfileNameLabel: null,
        TemplateTitle: null,
        Description: null,
        PolicingForm: null,

        SaveBtn: null,
        SaveEnableBtn: null,
        SaveDisableBtn: null,
        ClearFormBtn: null,
        DeleteBtn: null,

        Widgets: {
            ScheduleWidget: null,
            PolicingForm: new UlrEditSessionPolicingProtocolsFormWidget({id: this.Id + "UlrEditSessionPolicingFormWidget", IsTemplate: this.IsTemplate})
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            id: this.Id + "ScrollView",
            scroll: "y",
            body: {
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless: true,
                        rows: [
                            {height: 6},
                            PageHeaderTemplate({id: this.Id + "PageTitle", root_title: this.PageTitle.Title}),
                            {height: 32},
                            {
                                type: "clean",
                                rows: [
                                    {
                                        view: "template",
                                        borderless: true,
                                        css: "form_text_big_label",
                                        autoheight: true,
                                        template: Params && Params.BlockInfoTemplate ? Params.BlockInfoTemplate : ""
                                    },
                                    {height: 32},
                                    {
                                        view: "form",
                                        id: this.Id + "PolicingForm",
                                        type: "wide",
                                        borderless: true,
                                        elements: [
                                            {
                                                hidden: _this.IsTemplate,
                                                cols: [
                                                    {
                                                        view: "label",
                                                        id: this.Id + "ProfileNameLabel",
                                                        css: "form_header_label",
                                                        label: "",
                                                        template: LangHelper.GetString("UlrModule", "Profile name") + ": #label#"
                                                    },
                                                    {},
                                                    {
                                                        view: "spectre_button",
                                                        css: "form_button label_action with_icon",
                                                        type: "icon",
                                                        icon: "cog",
                                                        label: _this.EditLabel,
                                                        width: 280,
                                                        hidden: _this.HideEditLabel,
                                                        click:function ()
                                                        {
                                                            var parentModel = _this.ViewModel.Signals.ParentUpdated.getValue();

                                                            var _id = parentModel._id ? parentModel._id : 0;

                                                            if(_id)
                                                                App.NavRouter.PresentView({id: _this.EditPath, path:"/_id=" + _id});

                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                view: "spectre_text",
                                                name: "title",
                                                id: this.Id + "TemplateTitle",
                                                hidden: !_this.IsTemplate,
                                                label: LangHelper.GetString("UlrModule", "Name"),
                                                validate: function(Val)
                                                {
                                                    if(_this.IsTemplate)
                                                    {
                                                        return webix.rules.isNotEmpty;
                                                    }
                                                    return null;
                                                },
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if (typeof Ov !== "undefined" && Ov !== "")
                                                        {
                                                            if(Nv && typeof Nv == "string" && typeof Nv == "string" && Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                view: "spectre_textarea",
                                                name: "description",
                                                id: this.Id + "Description",
                                                label: LangHelper.GetString("UlrModule", "Description"),
                                                required: true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if (typeof Ov !== "undefined" && Ov !== "")
                                                        {
                                                            if(Nv && typeof Nv == "string" && typeof Nv == "string" && Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            },
                                            _this.Views.Widgets.PolicingForm.ViewConfig,
                                            {
                                                height: 32
                                            },
                                            {
                                                type: "wide",
                                                cols: [
                                                    {
                                                        view: "spectre_button",
                                                        id: this.Id + "SaveBtn",
                                                        css: "form_button main_action",
                                                        label: LangHelper.GetString("UlrModule", _this.IsTemplate ? "Save template" : "Save profile"),
                                                        autowidth: true,
                                                        click: function () {
                                                            _this.Save();
                                                        }
                                                    },
                                                    {
                                                        view: "spectre_button",
                                                        id: this.Id + "SaveEnableBtn",
                                                        css: "form_button second_action",
                                                        label: LangHelper.GetString("UlrModule", "Save and enable"),
                                                        autowidth: true,
                                                        click: function () {
                                                            _this.Save(true);
                                                        },
                                                        hidden: true
                                                    },
                                                    {
                                                        view: "spectre_button",
                                                        id: this.Id + "SaveDisableBtn",
                                                        css: "form_button second_action",
                                                        label: LangHelper.GetString("UlrModule", "Save and disable"),
                                                        autowidth: true,
                                                        click: function () {
                                                            _this.Save(false);
                                                        },
                                                        hidden: true
                                                    },
                                                    {
                                                        view: "spectre_button",
                                                        id: this.Id + "ClearFormBtn",
                                                        css: "form_button third_action",
                                                        label: LangHelper.GetString("UlrModule", _this.IsTemplate ? "Clear template" : "Clear profile"),
                                                        autowidth: true,
                                                        click: function () {
                                                            _this.ClearProfile();
                                                        }
                                                    },
                                                    {},
                                                    {
                                                        view:"spectre_button",
                                                        id: this.Id + "DeleteBtn",
                                                        css:"form_button delete_action",
                                                        label:LangHelper.GetString("UlrModule",_this.IsTemplate ? "Delete template" : "Delete profile"),
                                                        autowidth:true,
                                                        click:function ()
                                                        {
                                                            _this.Delete();
                                                        },
                                                        hidden:true
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    if(!this.IsTemplate)
    {
        this.Views.Widgets.ScheduleWidget = new UlrEditSessionPolicingScheduleWidget({
            id: this.Id + "UlrEditSessionPolicingScheduleWidget",
            template_type: UlrPolicingTemplatesTypesDic.session.id
        });
        this.ViewConfig[0].body.rows[0].rows[3].rows[2].elements.splice(
            3, 0,
            this.Views.Widgets.ScheduleWidget.ViewConfig
        );
    }

    this.Subscriptions = {};

    this.Signals = {
        ProfileEnabled: new Rx.BehaviorSubject(0),
    };
}

UlrEditSessionPolicingViewController.prototype.ViewDidLoad = function(PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    this.Refresh();
};

UlrEditSessionPolicingViewController.prototype.BindAll = function(Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(View => {
        if(View != "Widgets" && View != "ReportsWidgets")
        {
            this.Views[View] = $$(this.Id + View);
        }
    });

    Object.keys(this.Views.Widgets).forEach(WKey => {
        var w = this.Views.Widgets[WKey];

        if(w && w.BindAll && typeof w.BindAll == "function")
        {
            w.BindAll(this, this.ViewModel);
        }

        if(w && w.Bind && typeof w.Bind == "function")
        {
            w.Bind(this, this.ViewModel);
        }
    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(Progress => {
        Object.keys(this.Views).forEach(View => {
            if(View.indexOf("Btn") == (View.length - 4))
            {
                Progress ? this.Views[View].disable() : this.Views[View].enable()
            }
        });
    });

    this.Subscriptions.ProfileUpdated = Rx.Observable.combineLatest(
        this.ViewModel.Signals.PolicingProfileUpdated,
        this.ViewModel.Signals.ParentUpdated
    ).subscribe( Val => {
        var profile = Val[0];
        var parent = Val[1];

        if((parent || _this.IsTemplate) && profile)
        {
            this.DefineAll(profile, parent);
        }
    });

    this.Subscriptions.ProfileEnabled = this.Signals.ProfileEnabled.subscribe((Enabled) => {
        if(this.IsTemplate)
        {
            this.Views.SaveEnableBtn.hide();
            this.Views.SaveDisableBtn.hide();
            return;
        }

        if(Enabled)
        {
            this.Views.SaveDisableBtn.show();
            this.Views.SaveEnableBtn.hide();
        }
        else
        {
            this.Views.SaveDisableBtn.hide();
            this.Views.SaveEnableBtn.show();
        }
    });

    this.Subscriptions.AppPolicingProfileError = this.ViewModel.Signals.PolicingProfileError.subscribe(function (ErrModel)
    {
        var action = null;

        if(ErrModel&&ErrModel.code == 404)
        {
            action = function () {
                setTimeout(function () {
                    App.NavRouter.PresentView({id: _this.ListSection});
                }, 1);
            }
        }
        _this.ShowLoadSaveProfileError(ErrModel,action);
    });

    this.Subscriptions.AppPolicingProfileSaveError = this.ViewModel.Signals.PolicingProfileSaveError.subscribe(function (ErrModel) {
        _this.ShowLoadSaveProfileError(ErrModel);
    });

    this.Subscriptions.AppPolicingProfileDeleteError = this.ViewModel.Signals.PolicingProfileDeleteError.subscribe(function (ErrModel) {
        _this.ShowLoadSaveProfileError(ErrModel);
    });

    this.Subscriptions.AppPolicingProfileSaved = this.ViewModel.Signals.PolicingProfileSaved.subscribe(function (PolicingProfileModel) {
        if (PolicingProfileModel) {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", `Session policing ${_this.IsTemplate ? 'template' : 'profile'}`) + ": " + LangHelper.GetString("UlrModule", "Saving"),
                LangHelper.GetString("UlrModule", "Success")
            );

            setTimeout(function () {
                var source = _this.GetPathParam("source");
                App.NavRouter.PresentView({id: source ? source : _this.ListSection});
            }, 1);
            // if(!AppEnv.UlrNoRedirectAfterSavePolicingAndIsps)
            // {
            //     setTimeout(function () {
            //         var source = _this.GetPathParam("source");
            //         App.NavRouter.PresentView({id: source ? source : _this.ListSection});
            //     }, 1);
            // }
            // else
            // {
            //     _this.Refresh();
            // }
        }
    });

    this.Subscriptions.AppPolicingProfileDeleted = this.ViewModel.Signals.PolicingProfileDeleted.subscribe(function (PolicingIspModel) {
        if (PolicingIspModel) {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", `Session policing ${_this.IsTemplate ? 'template' : 'profile'}`) + ": " + LangHelper.GetString("UlrModule", "Deleting"),
                LangHelper.GetString("UlrModule", "Success")
            );

            setTimeout(function () {
                var source = _this.GetPathParam("source");
                App.NavRouter.PresentView({id: source ? source : _this.ListSection});
            }, 1);
        }
    });
};

UlrEditSessionPolicingViewController.prototype.Destroy = function()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(Key => {
        if(this.Subscriptions[Key])
            this.Subscriptions[Key].unsubscribe();
    });

    var destroyWidgets = (Dic) => {
        Object.keys(Dic).forEach(Widget => {
            if(Dic[Widget] && Dic[Widget].Destroy && typeof Dic[Widget].Destroy == "function")
            {
                Dic[Widget].Destroy();
            }
        });
    };

    destroyWidgets(this.Views.Widgets);

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

UlrEditSessionPolicingViewController.prototype.Refresh = function()
{
    var id = this.Action == this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    if(this.IsTemplate)
    {
        this.ViewModel.RefreshTemplate({id: id, template_type: this.TemplateType});
    }
    else
    {
        this.ViewModel.RefreshProfile({id: id});
    }

    var page_title = (this.Action == this.ActionsEnum.Add ? LangHelper.GetString("UlrModule", "Add application policing profile") : this.PageTitle.Title) + " #" + id;
    if(this.IsTemplate)
    {
        page_title = (this.Action == this.ActionsEnum.Add ? LangHelper.GetString("UlrModule", "Add session policing template") : this.PageTitle.Title) + " #" + id;
    }

    this.DefinePageTitle(page_title);
};

UlrEditSessionPolicingViewController.prototype.DefinePageTitle = function (Title) {
    this.Views.PageTitle.define("data", {root_title: Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

UlrEditSessionPolicingViewController.prototype.GetPathParam = function (Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditSessionPolicingViewController.prototype.DefineAll = function(Profile, Parent)
{
    var _this = this;

    var enabled = Profile.enabled && Parent.enabled ? 1 : 0;

    if(!this.IsTemplate)
    {
        this.Views.ProfileNameLabel.define("label", Parent.name + (Parent.igw_name ? (" " + Parent.igw_name) : "") + " (" + LangHelper.GetString("UlrModule", enabled ? "Enabled" : "Disabled") + ")");
        this.Views.ProfileNameLabel.refresh();

        this.Views.Widgets.ScheduleWidget.CurProfile = this.ViewModel.Signals.PolicingProfileUpdated.getValue();
        this.Views.Widgets.ScheduleWidget.RefreshWidget();
    }
    else
    {
        this.Views.TemplateTitle.setValue(Profile.title);
    }

    this.Signals.ProfileEnabled.next(enabled);

    this.Views.Description.setValue(Profile.description);

    if(Profile._id)
    {
        this.Views.DeleteBtn.show();
    }

    this.Views.Widgets.PolicingForm.Views.ReportsWidgets.ProtocolsReport.Views.Table.clearAll();
    this.Views.Widgets.PolicingForm.Views.ReportsWidgets.ProtocolsReport.Views.Table.parse(Profile.config_model);
};

UlrEditSessionPolicingViewController.prototype.Save = function (Enable) {
    var _this = this;

    if (!this.Views.PolicingForm.validate()) {
        this.Views.ScrollView.scrollTo(0, 0);
        return;
    }

    var currProfile = this.ViewModel.Signals.PolicingProfileUpdated.getValue();

    var formProfile = this.Views.PolicingForm.getValues();

    var model = {};
    if(!this.IsTemplate)
    {
        model = new UlrIspSessionPolicingModel(webix.extend(currProfile, formProfile, true));
    }
    else
    {
        model = new UlrPolicingTemplateModel(webix.extend(currProfile, formProfile, true));
    }

    var rows = this.Views.Widgets.PolicingForm.Views.ReportsWidgets.ProtocolsReport.Views.Table.serialize();

    var cfg_rows = [];

    rows.forEach(Row => {
        row = new SessionPolicingProtocolModel(Row);

        if(row.type === UlrProtocolTypesDic.protocol.id)
        {
            cfg_rows.push(row);
        }
        else
        {
            cfg_rows.unshift(row);
        }
    });

    model.config = JSON.stringify(cfg_rows);

    if (typeof Enable != "undefined" && !this.IsTemplate)
    {
        model.enabled = Enable ? 1 : 0;
    }

    if(this.IsTemplate)
    {
        this.ViewModel.SaveTemplate(model);
    }
    else
    {
        let scheduleUpdateData = this.Views.Widgets.ScheduleWidget.GetScheduleUpdateData();
        model.schedule_enabled = this.Views.Widgets.ScheduleWidget.IsWidgetEnable() ? 1 : 0;

        this.ViewModel.SavePolicingProfile(model, scheduleUpdateData);
    }
};

UlrEditSessionPolicingViewController.prototype.ClearProfile = function () {
    this.Views.Widgets.PolicingForm.Views.ReportsWidgets.ProtocolsReport.Views.Table.clearAll();
};

UlrEditSessionPolicingViewController.prototype.Delete = function()
{
    var _this = this;

    var model = this.ViewModel.Signals.PolicingProfileUpdated.getValue();

    if(!this.IsTemplate)
    {
        var ispModel = this.ViewModel.Signals.ParentUpdated.getValue();

        model = webix.extend(model,{name:ispModel.name});
    }

    UlrShowDialogPopup({
        node:this.Views.DeleteBtn.getNode(),
        position:"bottom",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    if(_this.IsTemplate)
                    {
                        _this.ViewModel.DeleteTemplate(model);
                    }
                    else
                    {
                        _this.ViewModel.DeleteProfile(model);
                    }
                }
            }
        ]
    });
};

UlrEditSessionPolicingViewController.prototype.ShowLoadSaveProfileError = function (ErrModel, Action) {
    if (ErrModel)
        UlrShowAlertWindow({
            head: LangHelper.GetString("UlrModule", "Error"),
            type: "spectre-alert-error",
            mainTitle: LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message: LangHelper.GetString("UlrModule", ErrModel.msg),
            actions: [
                {
                    label: LangHelper.GetString("UlrModule", "Ok"),
                    click: function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};

function PolicingsTemplatesPopupViewController(Params)
{
    var _this = this;

    this.Id = Params && Params.Id ? Params.Id : "PolicingsTemplatesPopup";

    this.ReportsModel = new UniReportsManager();

    this.TemplateType = Params && Params.TemplateType ? Params.TemplateType : UlrPolicingTemplatesTypesDic.session.id;
    this.ReturnTplModel = !!(Params && Params.ReturnTplModel);

    var reportParams = {
        id: this.Id + "TemplatesReport",
        enableTextSearch: 1,
        // enableAutoHeight: 1,
        hideExport: 1,
        read_only: true,
        onItemClick: function(Id, E, Node)
        {
            _this.OnTemplateClick(Id, E, Node)
        }
    };

    this.Views = {
        TemplatesButton: null,
        Popup: null,
        PopupHeaderLabel: null,


        ReportsWidgets: {
            TemplatesReport: UlrSessionPolicingsTemplatesTableWidget(reportParams),
            SessionPolicingConfig: UlrSessionPolicingProtocolsReportWidget({
                id: this.Id + "SessionPolicingProtocolsReport",
                enableTextSearch:0,
                // enableAutoHeight:1,
                hidePaginatorToolbar:1,
                enableLocalSort:1,
                enableLocalDataSource:1,
                read_only: true,
                template_func: _this.SetSessionPolicingConfigTableTemplateValue,
                onItemClick: function(Id, E, Node)
                {
                    // setTimeout(() => {
                    //     _this.ProtocolsReportOnItemClick(Id, E, Node);
                    // }, 1);
                }
            })
        }
    };

    this.Signals = {
        OnApplyConfigSignal: new Rx.BehaviorSubject(null)
    };
    this.Subscriptions = {};

    var header_title = this.TemplateType == UlrPolicingTemplatesTypesDic.session.id ? "Session policings templates list" : "Isp policings templates list";

    this.Popup = webix.ui({
        view: "popup",
        id: this.Id + "Popup",
        modal: true,
        position: "center",
        width: 1000,
        height: 700,
        body: {
            rows: [
                {height: 20},
                BlockHeaderTemplate({
                    title: LangHelper.GetString("UlrModule", header_title),
                    icon: "",
                    id: this.Id + "PopupHeaderLabel",
                    borderless:true,
                    css: "custom-font-size_20"
                }),
                {height: 20},
                {
                    cols: [
                        {
                            gravity: 1,
                            rows:[
                                _this.Views.ReportsWidgets.TemplatesReport.ViewConfig
                            ]
                        },
                        {width: 10},
                        function()
                        {
                            var res = {
                                gravity: 2,
                                rows: []
                            };
                            if(_this.TemplateType == UlrPolicingTemplatesTypesDic.session.id)
                            {
                                res.rows.push(_this.Views.ReportsWidgets.SessionPolicingConfig.ViewConfig);
                            }
                            else
                            {
                                res.rows = [
                                    {},
                                    {height: 12}
                                ];
                            }

                            return res;
                        }()
                    ]
                },
                {height: 30},
                {
                    cols: [
                        {},
                        {
                            view: "button",
                            css: "form_button third_action",
                            height: 40,
                            label: LangHelper.GetString("UlrModule", "Cancel"),
                            click: function(){
                                _this.Popup.hide();
                            }
                        },
                        {width: 20},
                        {
                            view: "button",
                            type: "form",
                            css: "form_button main_action",
                            height: 40,
                            label: LangHelper.GetString("UlrModule", "Apply"),
                            click: function()
                            {
                                _this.ApplyConfig();
                                _this.Popup.hide();
                            }
                        }
                    ]
                },
                {height: 20}
            ]
        }
    });

    this.ViewConfig = {
        view: "spectre_button",
        id: this.Id + "TemplatesButton",
        type: "icon",
        css: "form_button form_element spec_action with_icon",
        label: Params && Params.Label ? Params.Label : LangHelper.GetString("UlrModule", "Select template"),
        icon: "code",
        autowidth: true,
        height: 51,
        click: function()
        {
            setTimeout(function(){
                _this.Views.ReportsWidgets.TemplatesReport.RefreshData();
                _this.Popup.show();
            }, 1);
        }
    };
}

PolicingsTemplatesPopupViewController.prototype.ViewDidLoad = function(Params)
{
    var _this = this;

    this.BindAll(Params);
};

PolicingsTemplatesPopupViewController.prototype.BindAll = function(Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function(View){
        if(View != "ReportsWidgets")
        {
            _this.Views[View] = $$(_this.Id + View);
        }
        else
        {
            Object.keys(_this.Views[View]).forEach(function(WidgetKey){
                var w = _this.Views[View][WidgetKey];

                if(w.BindAll)
                    w.BindAll(_this, _this.ReportsModel);

                if(w.Bind)
                    w.Bind(_this, _this.ReportsModel);
            });
        }
    });
};

PolicingsTemplatesPopupViewController.prototype.Destroy = function()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

PolicingsTemplatesPopupViewController.prototype.OnTemplateClick = function(Id, E, Node)
{
    var _this = this;

    var item = this.Views.ReportsWidgets.TemplatesReport.Views.Table.getItem(Id);
    item = new UlrPolicingTemplateModel(item);
    if(this.TemplateType == UlrPolicingTemplatesTypesDic.session.id)
    {
        this.Views.ReportsWidgets.SessionPolicingConfig.Views.Table.clearAll();
        this.Views.ReportsWidgets.SessionPolicingConfig.Views.Table.parse(item.config_model);
    }
};

PolicingsTemplatesPopupViewController.prototype.SetSessionPolicingConfigTableTemplateValue = function(Obj, isTooltip = false)
{
    let result = "";
    let dic;

    if(Obj && Obj.type && Obj.value)
    {
        switch (Obj.type)
        {
            case UlrProtocolTypesDic.protocol.id:
                result = Obj.value;
                break;
            case UlrProtocolTypesDic.group.id:
                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);
                result = dic && dic[Obj.value] && dic[Obj.value].value ? dic[Obj.value].value : Obj.value;
                break;
            case UlrProtocolTypesDic.custom_group.id:
                result = Obj.value;

                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsCustomGroupsDic);

                if(dic)
                {
                    if(dic[Obj.value] && dic[Obj.value].value)
                    {
                        result = dic[Obj.value].value
                    }
                    else
                    {
                        if(isTooltip)
                        {
                            result = LangHelper.GetString("UlrModule", "Custom group information missing from database.")
                        }
                        else
                        {
                            result += " " + AlertErrorTemplate(null, null, result);
                        }
                    }
                }
                break;
            case UlrProtocolTypesDic.template.id:
                dic = App.DicsManager.GetDic(DicsEnum.UlrSessionPolicingTemplatesDic);
                result = dic && dic[Obj.value] && dic[Obj.value].value ? dic[Obj.value].value : Obj.value;
        }
    }

    return result;
}

PolicingsTemplatesPopupViewController.prototype.ApplyConfig = function()
{
    var _this = this;

    if(this.TemplateType == UlrPolicingTemplatesTypesDic.session.id)
    {
        if(this.ReturnTplModel)
        {
            let selected = this.Views.ReportsWidgets.TemplatesReport.Views.Table.getSelectedItem();
            if(selected)
                this.Signals.OnApplyConfigSignal.next(selected);
        }
        else
        {
            var data = this.Views.ReportsWidgets.SessionPolicingConfig.Views.Table.serialize();
            if(data)
            {
                this.Signals.OnApplyConfigSignal.next(data);
            }
        }
    }
};
function UlrSessionPolicingProtocolsReportWidget(Params)
{
    var editable = true;
    var commonSessionsExtended = Params && Params.commonSessionsExtended ? true : false;

    if(Params && Params.read_only)
    {
        editable = false;
    }

    var params = {
        id: Params && Params.id ? Params.id : webix.uid(),
        name: "UlrSessionPolicingProtocolsReportWidget",
        hideExport:true,
        hidePaginatorToolbar:Params.hidePaginatorToolbar ? true : false,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableCheckboxRefresh:editable,
        config: {},
        columns: function(){

            var cols = [
                {
                    id: "enabled",
                    header: "",
                    sort: false,
                    disabled: !editable,
                    width: 32,
                    template:function(Obj) {
                        return CellCheckboxSwitchOnOffCanDisabledTemplate(null, null, Obj.enabled, Obj.$toDelete);
                    }
                },
                {
                    id: "value",
                    header: [LangHelper.GetString("UlrModule","Protocol / Group name")],
                    sort: "string",
                    fillspace: 2,
                },
                {
                    id: "group_id",
                    header: [LangHelper.GetString("UlrModule", "Group")],
                    sort: "string",
                    fillspace: 1,
                    template: function(obj)
                    {
                        let result = "";
                        let dic;

                        switch (obj.type)
                        {
                            case UlrProtocolTypesDic.group.id:
                                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);
                                result = dic && dic[obj.value] && dic[obj.value].value ? dic[obj.value].value : obj.value;
                                result += " " + CellListBtnTemplate()
                                break;
                            case UlrProtocolTypesDic.custom_group.id:
                                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsCustomGroupsDic);
                                result = dic && dic[obj.value] && dic[obj.value].value ? dic[obj.value].value : obj.value;
                                result += " " + CellListBtnTemplate()
                                break;
                            case UlrProtocolTypesDic.template.id:
                                result = LangHelper.GetString("UlrModule", "Template") + " " + CellListBtnTemplate();
                                break
                        }

                        return result;
                    }
                },
                {
                    id: "priority",
                    header: [LangHelper.GetString("UlrModule","Priority")],
                    editor:"combo",
                    fillspace: true,
                    suggest:{
                        view:"gridsuggest",
                        body:{
                            autoheight:false,
                            scroll:true,
                            maxHeight:400,
                            //width:800,
                            //minWidth:800,
                            borderless:true,
                            columns:[
                                { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                { id:"class_order_1", header:"class_order=1", width:160}
                            ],
                            data:Helper.DictToArr(DscpDic)
                        }
                    }
                },
                {
                    id: "inbound_rate",
                    header: [LangHelper.GetString("UlrModule", "Inbound rate")],
                    sort: "string",
                    fillspace: 2
                },
                {
                    id: "rate",
                    header: [LangHelper.GetString("UlrModule", "Outbound rate")],
                    sort: "string",
                    fillspace: 2
                }
            ];

            if(commonSessionsExtended)
            {
                cols.push.apply(cols, [
                    {
                        id: "hide",
                        header:"",
                        sort: false,
                        width:32,
                        tooltip: function() {
                            if(commonSessionsExtended)
                                return LangHelper.GetString("UlrModule", "Remove from list");
                        },
                        template:CellAnyIconBtnTemplate("align-slash")
                    },
                ]);
            }

            if(editable)
            {
                cols.push.apply(cols,[
                    {
                        id: "edit",
                        header:"",
                        sort: false,
                        width:32,
                        tooltip: function() {
                            if(commonSessionsExtended)
                                return LangHelper.GetString("UlrModule", "Edit");
                        },
                        template:CellEditPencilBtnTemplate
                    },
                    {
                        id: "delete",
                        header:"",
                        sort: false,
                        width:32,
                        tooltip: function(Obj) {
                            if(commonSessionsExtended) {
                                let txt = Obj.$toDelete ? "Unmark for deletion" : "Mark for deletion";
                                return LangHelper.GetString("UlrModule", txt);
                            }
                        },
                        template: function(Obj) {
                            if(commonSessionsExtended) {
                                let icon = Obj.$toDelete ? "rotate-left" : "trash";
                                let color = Obj.$toDelete ? "green" : "#fea5a8";
                                return CellAnyIconBtnTemplate(icon, color)
                            } else {
                                return CellAnyIconBtnTemplate("trash")
                            }
                        }
                    }
                ]);
            }

            cols.push.apply(cols, [
                {
                    id: "space",
                    header:"",
                    sort: false,
                    width:16
                }
            ]);

            return cols;
        }(),
        defaultPageSize:-10,
        on: {},
        minHeight:40,
        rules:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterEditStop)
    {
        params.on.onAfterEditStop = function (State, Editor, IgnoreUpdate)
        {
            Params.onAfterEditStop(State, Editor, IgnoreUpdate);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    if(Params&&Params.template_func)
    {
        let col = params.columns.find(col => col.id === "value");

        col.template = function(obj)
        {
            return Params.template_func(obj);
        }
        col.tooltip = function(obj)
        {
            return Params.template_func(obj, true);
        }
    }

    return new QoETableReportWidget(params);
};

function UlrEditSessionPolicingProtocolsFormWidget(Params)
{
    var _this = this;

    this.Id = Params && Params.id ? Params.id : "UlrEditSessionPolicingFormWidget";
    this.IsTemplate = Params && Params.IsTemplate ? Params.IsTemplate : false;
    this.commonSessionsExtended = Params && Params.commonSessionsExtended ? Params.commonSessionsExtended : false;

    this.TemplatePopup = null;
    this.AddTemplateBtn = null;
    if(!this.IsTemplate)
    {
        this.TemplatePopup = new PolicingsTemplatesPopupViewController({
            Id: this.Id + "TemplatesPopup",
            TemplateType: UlrPolicingTemplatesTypesDic.session.id
        });

        this.AddTemplateBtn = new PolicingsTemplatesPopupViewController({
            Id: this.Id + "AddTemplateBtn",
            TemplateType: UlrPolicingTemplatesTypesDic.session.id,
            ReturnTplModel: true,
            Label: LangHelper.GetString("UlrModule", "Add template")
        });
    }

    this.ReportsModel = new UniReportsManager();

    this.ViewModel = new UlrIspSessionPolicingsManager();

    this.Views = {
        AddRowForm: null,
        ProtocolInput: null,
        ProtocolGroupInput: null,
        ProtocolCustomGroupInput: null,
        PriorityInput: null,
        AddProtocolButton: null,
        AddTemplateSection: null,
        EditPopupHeadLabel: null,
        EditProtocolPopupForm: null,
        EditProtocolPopupFormLabel: null,
        EditProtocolPopupPriorityInput: null,
        FormSecondRow: null,
        FormThirdRow: null,
        ReportsWidgets: {
            ProtocolsReport: UlrSessionPolicingProtocolsReportWidget({
                id: this.Id + "ProtocolsReport",
                enableTextSearch:0,
                enableAutoHeight: Params && Object.hasOwn(Params, 'reportAutoHeight') ? Params.reportAutoHeight : 1,
                hidePaginatorToolbar:1,
                enableLocalSort:1,
                enableLocalDataSource:1,
                template_func: this.SetTableTemplateValue,
                commonSessionsExtended:this.commonSessionsExtended,
                onItemClick: function(Id, E, Node)
                {
                    setTimeout(() => {
                        _this.ProtocolsReportOnItemClick(Id, E, Node);
                    }, 1);
                }
            })
        }
    }

    this.ViewConfig = {
        view: "form",
        id: this.Id + "PolicingForm",
        type: "wide",
        borderless: true,
        elements: [
            {
                type: "space",
                css: "form_background",
                rows: [
                    BlockHeaderTemplate({
                        title:LangHelper.GetString("UlrModule","Add protocol / protocol group"), icon:"",
                        borderless:true
                    }),
                    {
                        view: "form",
                        id: this.Id + "AddRowForm",
                        borderless: true,
                        type: "wide",
                        elements: [
                            {
                                type: "wide",
                                rows: [
                                    {
                                        cols:[
                                            {
                                                view: "spectre_combo",
                                                name: "type",
                                                label: LangHelper.GetString("UlrModule", "Mode"),
                                                options: {
                                                    point: false,
                                                    data: function(){
                                                       var res = Helper.DictToArr(UlrProtocolTypesDic);

                                                       if(_this.IsTemplate)
                                                       {
                                                           res = res.filter(x => x.id !== UlrProtocolTypesDic.template.id);
                                                       }

                                                       return res;
                                                    }()
                                                },
                                                required: true,
                                                value: UlrProtocolTypesDic.protocol.id,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                            this.validate();
                                                    }
                                                }
                                            },
                                            {width: 16},
                                            {
                                                hidden: true,
                                                id: _this.Id + "AddTemplateSection",
                                                gravity: 2,
                                                cols: function(){
                                                    var res = [];
                                                    if(!_this.IsTemplate && _this.AddTemplateBtn)
                                                    {
                                                        res.push(_this.AddTemplateBtn.ViewConfig);
                                                    }
                                                    res.push({});

                                                    return res;
                                                }()
                                            },
                                            {
                                                view: "spectre_text",
                                                id: _this.Id + "ProtocolInput",
                                                name: "protocol",
                                                label: LangHelper.GetString("UlrModule", "Application protocol"),
                                                suggest: {
                                                    data: App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsDic),
                                                    template: "#value#",
                                                    filter: function(obj, value)
                                                    {
                                                        return true;
                                                    }
                                                },
                                                keyPressTimeout: 500,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    onChange: function(Nv, Ov)
                                                    {
                                                        if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                        {
                                                            this.setValue(Nv.trim());
                                                            return;
                                                        }

                                                        _this.Signals.ProtocolInputValue.next(Nv);
                                                        _this.Views.AddRowForm.clearValidation();
                                                    },
                                                    onTimedKeyPress: function()
                                                    {
                                                        var val = this.getValue();

                                                        if(val && typeof val == "string" && val != val.trim())
                                                        {
                                                            this.setValue(val.trim());
                                                            return;
                                                        }

                                                        _this.Signals.ProtocolInputValue.next(val);

                                                        App.DicsManager.Refresh({data:[DicsEnum.ProtocolsDic], filter:val});
                                                    }
                                                }
                                            },
                                            {
                                                id: this.Id + "ProtocolGroupInput",
                                                view: "spectre_combo",
                                                name: "protocol_group",
                                                hidden: true,
                                                label: LangHelper.GetString("UlrModule", "Protocols group"),
                                                options: {
                                                    point: false,
                                                    data: []
                                                },
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                            this.validate();

                                                        _this.Signals.ProtocolGroupsInputValue.next(Nv);
                                                        _this.Views.AddRowForm.clearValidation();
                                                    }
                                                }
                                            },
                                            {
                                                id: this.Id + "ProtocolCustomGroupInput",
                                                view: "spectre_combo",
                                                name: "protocol_custom_group",
                                                hidden: true,
                                                label: LangHelper.GetString("UlrModule", "Users groups of protocols"),
                                                options: {
                                                    point: false,
                                                    data: []
                                                },
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                            this.validate();

                                                        _this.Signals.ProtocolGroupsInputValue.next(Nv);
                                                        _this.Views.AddRowForm.clearValidation();
                                                    }
                                                }
                                            },
                                            {width: 16},
                                            {
                                                type: "wide",
                                                cols: [
                                                    {
                                                        view:"spectre_combo",
                                                        id:_this.Id + "PriorityInput",
                                                        name:"priority",
                                                        label:LangHelper.GetString("UlrModule","Priority"),
                                                        //value:"cs0",
                                                        options:{
                                                            view:"gridsuggest",
                                                            point:false,
                                                            body:{
                                                                autoheight:false,
                                                                scroll:true,
                                                                maxHeight:400,
                                                                //width:800,
                                                                //minWidth:800,
                                                                borderless:true,
                                                                columns:[
                                                                    { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                                                    { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                                                    { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                                                    { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                                                    { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                                                    { id:"class_order_1", header:"class_order=1", width:160}
                                                                ],
                                                                data:Helper.DictToArr(DscpDic)
                                                            }
                                                        },
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on:{
                                                            onChange:function(Nv, Ov)
                                                            {
                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                {
                                                                    this.setValue(Nv.trim());
                                                                    return;
                                                                }

                                                                _this.Signals.PriorityInputValue.next(Nv);
                                                                _this.Views.AddRowForm.clearValidation();
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        id: _this.Id + "FormSecondRow",
                                        cols:[
                                            {
                                                cols:[
                                                    {
                                                        view: "spectre_text",
                                                        name: "inbound_rate_val",
                                                        label: LangHelper.GetString("UlrModule", "Inbound rate"),
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                                        validate: function (Val) {
                                                            return !isNaN(Val * 1);
                                                        },
                                                        on: {
                                                            onChange: function (Nv, Ov)
                                                            {
                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                {
                                                                    this.setValue(Nv.trim());
                                                                    return;
                                                                }
                                                                this.validate();
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view: "spectre_combo",
                                                        name: "inbound_rate_unit",
                                                        value: "mbit",
                                                        label: LangHelper.GetString("UlrModule", "Unit"),
                                                        options:{
                                                            point:false,
                                                            data:Helper.DictToArr(TrafficUnits)
                                                        }
                                                    }
                                                ]
                                            },
                                            {width: 16},
                                            {
                                                cols:[
                                                    {
                                                        view: "spectre_text",
                                                        name: "rate_val",
                                                        label: LangHelper.GetString("UlrModule", "Outbound rate"),
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                                        validate: function (Val) {
                                                            return !isNaN(Val * 1);
                                                        },
                                                        on: {
                                                            onChange: function (Nv, Ov)
                                                            {
                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                {
                                                                    this.setValue(Nv.trim());
                                                                    return;
                                                                }
                                                                this.validate();
                                                            }
                                                        }
                                                    },
                                                    {
                                                        view: "spectre_combo",
                                                        name: "rate_unit",
                                                        value: "mbit",
                                                        label: LangHelper.GetString("UlrModule", "Unit"),
                                                        options:{
                                                            point:false,
                                                            data:Helper.DictToArr(TrafficUnits)
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        id: _this.Id + "FormThirdRow",
                                        cols:[
                                            {
                                                view:"spectre_button",
                                                id:_this.Id + "AddProtocolButton",
                                                css:"form_button form_element spec_action",
                                                label:LangHelper.GetString("UlrModule","Add"),
                                                autowidth:true,
                                                height:51,
                                                click:function ()
                                                {
                                                    setTimeout(function ()
                                                    {
                                                        _this.AddProtocol();
                                                    },1);
                                                }
                                            },
                                            function(){
                                                if(!_this.IsTemplate && _this.TemplatePopup)
                                                {
                                                    return {
                                                        cols: [
                                                            {width: 20},
                                                            _this.TemplatePopup.ViewConfig
                                                        ]
                                                    }
                                                }
                                                return {};
                                            }(),
                                            {}
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                ]
            },
            _this.Views.ReportsWidgets.ProtocolsReport.ViewConfig,
        ]
    }

    this.EditProtocolPopup = webix.ui({
        view: "window",
        css:"spectre-alert form_modal",
        width:480,
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head: {
            view: "toolbar",
            cols: [
                {
                    view: "label",
                    id: this.Id + "EditPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule", "Edit protocol / protocol group"),
                    height: 68
                },
                {
                    view: "spectre_button",
                    css: "form_button spec_action with_icon",
                    type: "icon",
                    icon: "times",
                    align: "right",
                    width: 68,
                    height: 68,
                    click: function()
                    {
                        _this.EditProtocolPopup.hide();
                    }
                }
            ]
        },
        body:{
            type: "space",
            borderless: true,
            rows: [
                {
                    type: "clean",
                    borderless: true,
                    rows: [
                        {
                            view: "form",
                            id: this.Id + "EditProtocolPopupForm",
                            width:480,
                            type: "wide",
                            elements: [
                                {
                                    type: "wide",
                                    cols: [
                                        {
                                            view: "label",
                                            id: this.Id + "EditProtocolPopupFormLabel",
                                            css: "form_header_label",
                                            label: ""
                                        }
                                    ]
                                },
                                {
                                    type: "wide",
                                    cols: [
                                        {
                                            view:"spectre_combo",
                                            id:_this.Id + "EditProtocolPopupPriorityInput",
                                            name:"priority",
                                            label:LangHelper.GetString("UlrModule","Priority"),
                                            //value:"cs0",
                                            options:{
                                                view:"gridsuggest",
                                                point:false,
                                                body:{
                                                    autoheight:false,
                                                    scroll:true,
                                                    maxHeight:400,
                                                    //width:800,
                                                    //minWidth:800,
                                                    borderless:true,
                                                    columns:[
                                                        { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                                        { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                                        { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                                        { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                                        { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                                        { id:"class_order_1", header:"class_order=1", width:160}
                                                    ],
                                                    data:Helper.DictToArr(DscpDic)
                                                }
                                            },
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                            on:{
                                                onChange:function(Nv, Ov)
                                                {
                                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }

                                                    _this.Signals.PriorityInputValue.next(Nv);
                                                    _this.Views.EditProtocolPopupForm.clearValidation();
                                                }
                                            }
                                        }
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            view: "spectre_text",
                                            name: "inbound_rate_val",
                                            label: LangHelper.GetString("UlrModule", "Inbound rate"),
                                            invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                            validate: function (Val) {
                                                return !isNaN(Val * 1);
                                            },
                                            on: {
                                                onChange: function (Nv, Ov)
                                                {
                                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }
                                                    this.validate();
                                                }
                                            }
                                        },
                                        {
                                            view: "spectre_richselect",
                                            name: "inbound_rate_unit",
                                            value: "mbit",
                                            label: LangHelper.GetString("UlrModule", "Unit"),
                                            value: "mbit",
                                            options:{
                                                point:false,
                                                data:Helper.DictToArr(TrafficUnits)
                                            }
                                        }
                                    ]
                                },
                                {
                                    cols:[
                                        {
                                            view: "spectre_text",
                                            name: "rate_val",
                                            label: LangHelper.GetString("UlrModule", "Outbound rate"),
                                            invalidMessage: LangHelper.GetString("UlrModule", "Numeric value"),
                                            validate: function (Val) {
                                                return !isNaN(Val * 1);
                                            },
                                            on: {
                                                onChange: function (Nv, Ov)
                                                {
                                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }
                                                    this.validate();
                                                }
                                            }
                                        },
                                        {
                                            view: "spectre_richselect",
                                            name: "rate_unit",
                                            value: "mbit",
                                            label: LangHelper.GetString("UlrModule", "Unit"),
                                            options:{
                                                point:false,
                                                data:Helper.DictToArr(TrafficUnits)
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {height: 20},
                {
                    type: "wide",
                    cols: [
                        {
                            view: "spectre_button",
                            id: this.Id + "EditProtocolPopupFormBtn",
                            css: "form_button main_action",
                            label: LangHelper.GetString("UlrModule", "Apply"),
                            autowidth: true,
                            click: function()
                            {
                                setTimeout(() => {
                                    _this.ApplyEditProtocol();
                                }, 1);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.Subscriptions = {};

    this.Signals = {
        ProtocolInputValue: new Rx.BehaviorSubject(null),
        PriorityInputValue: new Rx.BehaviorSubject(null),
        ProtocolGroupsInputValue: new Rx.BehaviorSubject(null),
    };
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.BindAll = function()
{
    var _this = this;

    if(this.TemplatePopup && this.TemplatePopup.ViewDidLoad)
    {
        this.TemplatePopup.ViewDidLoad();
    }

    if(this.AddTemplateBtn && this.AddTemplateBtn.ViewDidLoad)
    {
        this.AddTemplateBtn.ViewDidLoad();
    }

    Object.keys(this.Views).forEach(View => {
        if(View != "Widgets" && View != "ReportsWidgets")
        {
            this.Views[View] = $$(this.Id + View);
        }
    });

    Object.keys(this.Views.ReportsWidgets).forEach(WKey => {
        var w = this.Views.ReportsWidgets[WKey];

        if(w.BindAll && typeof w.BindAll == "function")
        {
            w.BindAll(this, this.ReportsModel);
        }

        if(w.Bind && typeof w.Bind == "function")
        {
            w.Bind(this, this.ReportsModel);
        }
    });

    this.Subscriptions.ProtocolsDic = App.DicsManager.Signal[DicsEnum.ProtocolsDic].subscribe(function (Updated)
    {
        if (Updated)
        {
            var opts = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsDic);

            var list = $$(_this.Views.AddRowForm.elements.protocol.config.suggest).getList();
            list.clearAll();
            list.parse(opts);

            var value = _this.Views.ProtocolInput.getValue();

            if(value)
            {
                list.select(value);
                list.showItem(value);

                if(!list.getSelectedItem())
                {
                    list.select(value.toUpperCase());
                    list.showItem(value.toUpperCase());
                }

                if(!list.getSelectedItem())
                {
                    list.select(value.toLowerCase());
                    list.showItem(value.toLowerCase());
                }
            }
        }
    });

    this.Subscriptions.SignalDicProtocolsGroupsUpdatedSubscription = App.DicsManager.Signal[DicsEnum.ProtocolsGroupsDic].subscribe(function(Updated)
    {
        if(Updated)
        {
            var dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic);

            dic = dic.sort(function(a,b){
                return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
            });

            _this.Views.ProtocolGroupInput.define("options", dic);
            _this.Views.ProtocolGroupInput.refresh();
        }
    });

    this.Subscriptions.SignalDicProtocolsCustomGroupsUpdatedSubscription = App.DicsManager.Signal[DicsEnum.ProtocolsCustomGroupsDic].subscribe(function(Updated){
        if(Updated)
        {
            var dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsCustomGroupsDic);

            if(dic.length)
            {
                if(!_this.Views.AddRowForm.elements.protocol_custom_group.isEnabled())
                {
                    _this.Views.AddRowForm.elements.protocol_custom_group.enable();
                }

                dic = dic.sort(function(a,b){
                    return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
                });

                _this.Views.AddRowForm.elements.protocol_custom_group.define("options", dic);
                _this.Views.AddRowForm.elements.protocol_custom_group.refresh();
            }
            else
            {
                _this.Views.AddRowForm.elements.protocol_custom_group.disable();
            }
        }
    });

    this.Subscriptions.SignalDicUlrSessionPolicingTemplatesDicSubscription = App.DicsManager.Signal[DicsEnum.UlrSessionPolicingTemplatesDic].subscribe(function(Updated)
    {
        if(Updated)
        {
            _this.Views.ReportsWidgets.ProtocolsReport.Views.Table.refresh();
        }
    });

    if(this.TemplatePopup && this.TemplatePopup.Signals)
    {
        this.Subscriptions.OnApplyConfigFromTemplateSubsription = this.TemplatePopup.Signals.OnApplyConfigSignal.subscribe(function(Arr){
            if(Arr)
            {
                _this.SetProtocolsConfig(Arr);
            }
        });
    }

    if(this.AddTemplateBtn && this.AddTemplateBtn.Signals)
    {
        this.Subscriptions.OnAddTemplateSubsription = this.AddTemplateBtn.Signals.OnApplyConfigSignal.subscribe(function(Template){
            if(Template)
            {
                _this.AddTemplate(Template);
            }
        });
    }

    this.Views.AddRowForm.elements.type.attachEvent("onChange", Val => {
        if(Val == UlrProtocolTypesDic.template.id)
        {
            this.Views.ProtocolCustomGroupInput.hide();
            this.Views.ProtocolGroupInput.hide();
            this.Views.ProtocolInput.hide();
            this.Views.PriorityInput.hide();
            this.Views.FormSecondRow.hide();
            this.Views.FormThirdRow.hide();
            this.Views.AddTemplateSection.show();
        }
        else
        {
            this.Views.PriorityInput.show();
            this.Views.FormSecondRow.show();
            this.Views.FormThirdRow.show();
            this.Views.AddTemplateSection.hide();

            switch (Val)
            {
                case UlrProtocolTypesDic.protocol.id:
                    this.Views.ProtocolCustomGroupInput.hide();
                    this.Views.ProtocolGroupInput.hide();
                    this.Views.ProtocolInput.show();
                    break;
                case UlrProtocolTypesDic.group.id:
                    this.Views.ProtocolCustomGroupInput.hide();
                    this.Views.ProtocolInput.hide();
                    this.Views.ProtocolGroupInput.show();
                    break;
                case UlrProtocolTypesDic.custom_group.id:
                    this.Views.ProtocolInput.hide();
                    this.Views.ProtocolGroupInput.hide();
                    this.Views.ProtocolCustomGroupInput.show();
            }
        }

    });

    // Object.values(this.Views.EditProtocolPopupForm.elements).forEach(el => {
    //     el.attachEvent("onChange", Val => {
    //         _this.Views.EditProtocolPopupForm.clearValidation();
    //     });
    // })

    App.DicsManager.Refresh({data: [DicsEnum.ProtocolsCustomGroupsDic, DicsEnum.UlrSessionPolicingTemplatesDic]});
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.Destroy = function()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(Key => {
        if(this.Subscriptions[Key])
            this.Subscriptions[Key].unsubscribe();
    });

    var destroyWidgets = (Dic) => {
        Object.keys(Dic).forEach(Widget => {
            if(Dic[Widget].Destroy && typeof Dic[Widget].Destroy == "function")
            {
                Dic[Widget].Destroy();
            }
        });
    };

    destroyWidgets(this.Views.ReportsWidgets);

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if(this.TemplatePopup && this.TemplatePopup.Destroy)
    {
        this.TemplatePopup.Destroy();
    }
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.ValidateProtocolForm = function()
{
    var _this = this;

    var params = {};
    var data = this.Views.AddRowForm.getValues();

    params.type = data.type;

    switch (params.type)
    {
        case UlrProtocolTypesDic.protocol.id:
            params.value = data.protocol;
            break;
        case UlrProtocolTypesDic.group.id:
            params.value = data.protocol_group;
            break;
        case UlrProtocolTypesDic.custom_group.id:
            params.value = data.protocol_custom_group;
            break;
        default:
            this.Views.AddRowForm.markInvalid("type", LangHelper.GetString("UlrModule", "Incorrect field"));
            return;
    }

    if(!params.value)
    {
        switch (params.type)
        {
            case UlrProtocolTypesDic.protocol.id:
                this.Views.AddRowForm.markInvalid("protocol", LangHelper.GetString("UlrModule", "Required field"));
                break;
            case UlrProtocolTypesDic.group.id:
                this.Views.AddRowForm.markInvalid("protocol_group", LangHelper.GetString("UlrModule", "Required field"));
                break;
            case UlrProtocolTypesDic.custom_group.id:
                this.Views.AddRowForm.markInvalid("protocol_custom_group", LangHelper.GetString("UlrModule", "Required field"));
                break;

            return;
        }
    }

    params.inbound_rate = parseInt(data.inbound_rate_val) ?  (parseInt(data.inbound_rate_val) + data.inbound_rate_unit) : "";
    params.rate = parseInt(data.rate_val) ? (parseInt(data.rate_val) + data.rate_unit) : "";
    params.priority = data.priority;

    if(!params.inbound_rate && !params.rate && !params.priority)
    {
        this.Views.AddRowForm.markInvalid("priority", LangHelper.GetString("UlrModule", "Fill at least one of inputs!"));

        if(!data.inbound_rate_val)
            this.Views.AddRowForm.markInvalid("inbound_rate_val", LangHelper.GetString("UlrModule", "Fill at least one of inputs!"));

        if(!data.rate_val)
            this.Views.AddRowForm.markInvalid("rate_val", LangHelper.GetString("UlrModule", "Fill at least one of inputs!"));

        return;
    }

    params.enabled = 1;

    return params;
}

UlrEditSessionPolicingProtocolsFormWidget.prototype.ValidateProtocolTable = function()
{
    let _this = this;

    let result = true;

    _this.Views.ReportsWidgets.ProtocolsReport.Views.Table.eachRow(function(RowId) {
        let item = this.getItem(RowId);

        let keys = Object.keys(new SessionPolicingProtocolModel()).filter(key => {
            return !["enabled", "rate", "inbound_rate"].includes(key)
        });

        if(item.type !== UlrProtocolTypesDic.template.id)
        {
            for (let key of keys)
            {
                if (!item[key]) {

                    let protocolFullName = _this.GetProtocolFullName(item);

                    UlrShowMessage(
                        "error",
                        protocolFullName,
                        LangHelper.GetString("UlrModule", "Not all properties are specified for selected protocol."),
                    );

                    result = false;
                    break;
                }
            }
        }
    });

    return result;
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.AddProtocol = function()
{
    var _this = this;

    let params = _this.ValidateProtocolForm();

    if(params)
    {
        var model = new SessionPolicingProtocolModel(params);
        var existed_protocols = this.Views.ReportsWidgets.ProtocolsReport.Views.Table.serialize();

        if (existed_protocols.some(protocol => protocol.type === model.type && protocol.value === model.value)) {
            UlrShowMessage(
                "error",
                LangHelper.GetString("UlrModule", "Protocol has already been added."),
                _this.GetProtocolFullName(model),
            );
            return;
        }

        this.Views.ReportsWidgets.ProtocolsReport.Views.Table.add(model);
        this.Views.ReportsWidgets.ProtocolsReport.Views.Table.hideOverlay();
        this.Views.ReportsWidgets.ProtocolsReport.Views.Table.hideProgress();

        this.Views.AddRowForm.clearValidation();
    }
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.AddTemplate = function(Template)
{
    var _this = this;

    this.Views.AddRowForm.clearValidation();

    var model = new SessionPolicingProtocolModel();
    model.type = UlrProtocolTypesDic.template.id;
    model.value = Template._id;
    model.enabled = 1;
    model.priority = "";

    this.Views.ReportsWidgets.ProtocolsReport.Views.Table.add(model);
    this.Views.ReportsWidgets.ProtocolsReport.Views.Table.hideOverlay();
    this.Views.ReportsWidgets.ProtocolsReport.Views.Table.hideProgress();

    this.Views.AddRowForm.clearValidation();
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.AddProtocolsToForm = function(ProtocolsConfigs)
{
    let _this = this;

    var existed_protocols = this.Views.ReportsWidgets.ProtocolsReport.Views.Table.serialize();
    var added_protocols = []

    for (let model of ProtocolsConfigs)
    {
        if (existed_protocols.some(protocol => protocol.type === model.type && protocol.value === model.value)) {
            UlrShowMessage(
                "error",
                LangHelper.GetString("UlrModule", "Protocol has already been added."),
                _this.GetProtocolFullName(model),

            );
            continue;
        }
        else if (added_protocols.some(protocol => protocol.type === model.type && protocol.value === model.value))
        {
            continue;
        }
        added_protocols.push(model)
        _this.Views.ReportsWidgets.ProtocolsReport.Views.Table.add(model);
    }
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.GetProtocolFullName = function(model, withType = true)
{
    let result = "";

    if (model.type && model.value)
    {
        let dic;

        switch (model.type)
        {
            case UlrProtocolTypesDic.protocol.id:
                result = UlrProtocolTypesDic.protocol.value + ": ";
                break;
            case UlrProtocolTypesDic.group.id:
                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);
                result = UlrProtocolTypesDic.group.value + ": ";
                break;
            case UlrProtocolTypesDic.custom_group.id:
                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsCustomGroupsDic);
                result = UlrProtocolTypesDic.custom_group.value + ": ";
                break;
        }

        if(!withType)
            result = "";

        result += (dic && dic[model.value] && dic[model.value].value ? dic[model.value].value : model.value);
    }

    return result;
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.ShowProtocolEditForm = function()
{
    var table = this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
    {
        return;
    }

    this.Views.EditProtocolPopupForm.clear();
    this.Views.EditProtocolPopupForm.clearValidation();

    this.Views.EditProtocolPopupFormLabel.setValue(this.GetProtocolFullName(data, false));
    var rate_val_unit = data.rate ? Helper.GetTrafficValAndUnitFromString(data.rate) : null;
    var inbound_rate_val_unit = data.inbound_rate ? Helper.GetTrafficValAndUnitFromString(data.inbound_rate) : null;

    var formData = {
        priority: data.priority ? data.priority : "keep",
        rate_val: rate_val_unit && rate_val_unit.val ? rate_val_unit.val : "",
        rate_unit: rate_val_unit && rate_val_unit.unit ? rate_val_unit.unit : "mbit",
        inbound_rate_val: inbound_rate_val_unit && inbound_rate_val_unit.val ? inbound_rate_val_unit.val : "",
        inbound_rate_unit: inbound_rate_val_unit && inbound_rate_val_unit.unit ? inbound_rate_val_unit.unit : "mbit"
    }

    this.Views.EditProtocolPopupForm.setValues(formData);

    this.Views.EditProtocolPopupFormLabel.refresh();

    this.EditProtocolPopup.show();
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.ProtocolsReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    let table = this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

    const removeFromTable = (Id) => {
        if(!table.exists(Id))
            return;
        table.remove(Id);
    };

    const markToDelete = (Id) => {
        if(!table.exists(Id))
            return;

        let item = table.getItem(Id);

        item.$toDelete = !item.$toDelete;

        if(item.$toDelete)
            table.addRowCss(Id, "row-pending-delete");
        else
            table.removeRowCss(Id, "row-pending-delete");

        table.updateItem(Id, item);
    };

    const isRowDisabled = (Id) => {
        if(!_this.commonSessionsExtended)
            return false;

        let item = table.getItem(Id);
        return !!item.$toDelete;
    };

    if(!isRowDisabled(Id) && Id.column == "edit")
    {
        this.ShowProtocolEditForm();
    }
    else if(!isRowDisabled(Id) && Id.column === 'group_id')
    {
        let item = table.getItem(Id.row);
        let group_id = parseInt(item.value);
        let dic;

        if(item.type === UlrProtocolTypesDic.group.id || item.type === UlrProtocolTypesDic.custom_group.id)
        {
            let filter;

            if(item.type === UlrProtocolTypesDic.group.id)
            {
                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);
                filter = {
                    group_id: {
                        id: "group_id",
                        operator: "=",
                        value: group_id
                    }
                }
            }
            else if(item.type === UlrProtocolTypesDic.custom_group.id)
            {
                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsCustomGroupsDic);

                filter = {
                    custom_group_id: {
                        id: "custom_group_id",
                        operator: "=",
                        value: group_id
                    }
                };
            }

            let table_params = {
                enableAutoHeight: false,
                enableTextSearch: true,
                is_modal: true,
                filter: filter,
                is_custom_group: item.type === UlrProtocolTypesDic.custom_group.id ? 1 : 0
            }

            let popupTable = new UlrAppProtocolsTable(table_params);

            UlrEditAppPolicingPopup({
                modal_title: dic && dic[item.value] && dic[item.value].value ? dic[item.value].value : " "
            }, popupTable);

            popupTable.Bind(_this, _this.ReportsModel);
            popupTable.RefreshData();
        }
        else if(item.type === UlrProtocolTypesDic.template.id)
        {
            dic = App.DicsManager.GetDic(DicsEnum.UlrSessionPolicingTemplatesDic);
            var popupTable = UlrSessionPolicingProtocolsReportWidget({
                id: this.Id + "ProtocolsPopupReport",
                enableTextSearch:0,
                enableAutoHeight: 0,
                hidePaginatorToolbar:1,
                enableLocalSort:1,
                enableLocalDataSource:1,
                read_only: true,
                template_func: this.SetTableTemplateValue,
            });
            var title = dic && dic[item.value] && dic[item.value].value ? dic[item.value].value : item.value;
            UlrSessionPolicingTemplateConfigPopup({
                modal_title: title
            }, popupTable);

            this.ViewModel.RefreshTemplate({
                id: item.value + "",
                template_type: UlrPolicingTemplatesTypesDic.session.id,
                callback: function(R)
                {
                    if(R.success)
                    {
                        var model = new UlrPolicingTemplateModel(R.data.template);

                        popupTable.Bind(_this, _this.ReportsModel);
                        popupTable.Views.Table.clearAll();
                        popupTable.Views.Table.parse(model.config_model);
                    }
                }
            });
        }
    }
    else if(Id.column == "delete")
    {
        if(!this.commonSessionsExtended)
            removeFromTable(Id);
        else
            markToDelete(Id);
    }
    else if(Id.column === "hide")
    {
        removeFromTable(Id);

        // UlrShowDialogPopup({
        //     node: node,
        //     position: "bottom",
        //     head: LangHelper.GetString("UlrModule", "Delete") + "?",
        //     mainTitle: LangHelper.GetString("UlrModule", "Delete") + "?",
        //     message: LangHelper.GetString("UlrModule","Are you sure?"),
        //     actions: [
        //         {
        //             css:"spec_action",
        //             label:LangHelper.GetString("UlrModule","Cancel")
        //         },
        //         {
        //             label:LangHelper.GetString("UlrModule","Delete"),
        //             click:function ()
        //             {
        //
        //             }
        //         }
        //     ]
        // });
    }
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.ApplyEditProtocol = function()
{
    var table = this.Views.ReportsWidgets.ProtocolsReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
    {
        return;
    }

    var formData = this.Views.EditProtocolPopupForm.getValues();

    var rate = formData.rate_val + formData.rate_unit;
    var inbound_rate = formData.inbound_rate_val + formData.inbound_rate_unit;

    if(!inbound_rate && !rate && !formData.priority)
    {
        this.Views.EditProtocolPopupForm.markInvalid("priority", LangHelper.GetString("UlrModule", "Fill at least one of inputs!"));
        return;
    }

    var params = {
        priority : formData.priority
    };

    if(rate && formData.rate_val)
    {
        params.rate = rate;
    }
    else if(!formData.rate_val)
    {
        params.rate = "";
    }

    if(inbound_rate && formData.inbound_rate_val)
    {
        params.inbound_rate = inbound_rate;
    }
    else if(!formData.inbound_rate_val)
    {
        params.inbound_rate = "";
    }

    params = webix.extend(data, params, true);

    table.updateItem(data.id, params);

    this.EditProtocolPopup.hide();
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.SetFormToDefault = function()
{
    var _this = this;

    _this.Views.AddRowForm.clear();
    _this.Views.AddRowForm.clearValidation();
    _this.Views.ReportsWidgets.ProtocolsReport.Views.Table.clearAll();
    _this.Views.AddRowForm.parse({type: "protocol", inbound_rate_unit: "mbit", rate_unit: "mbit"})
};

UlrEditSessionPolicingProtocolsFormWidget.prototype.SetTableTemplateValue = function(Obj, isTooltip = false)
{
    let result = "";
    let dic;

    if(Obj && Obj.type && Obj.value)
    {
        switch (Obj.type)
        {
            case UlrProtocolTypesDic.protocol.id:
                result = Obj.value;
                break;
            case UlrProtocolTypesDic.group.id:
                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsGroupsDic);
                result = dic && dic[Obj.value] && dic[Obj.value].value ? dic[Obj.value].value : Obj.value;
                break;
            case UlrProtocolTypesDic.custom_group.id:
                result = Obj.value;

                dic = App.DicsManager.GetDic(DicsEnum.ProtocolsCustomGroupsDic);

                if(dic)
                {
                    if(dic[Obj.value] && dic[Obj.value].value)
                    {
                        result = dic[Obj.value].value
                    }
                    else
                    {
                        if(isTooltip)
                        {
                            result = LangHelper.GetString("UlrModule", "Custom group information missing from database.")
                        }
                        else
                        {
                            result += " " + AlertErrorTemplate(null, null, result);
                        }
                    }
                }
                break;
            case UlrProtocolTypesDic.template.id:
                dic = App.DicsManager.GetDic(DicsEnum.UlrSessionPolicingTemplatesDic);
                // result = dic && dic[Obj.value] && dic[Obj.value].value ? dic[Obj.value].value : (LangHelper.GetString("UlrModule", "Template not found") + " " + AlertWarningTemplate(null, null, LangHelper.GetString("UlrModule", "Template not found")));
                result = dic && dic[Obj.value] && dic[Obj.value].value ? dic[Obj.value].value : (AlertWarningTemplate(null, null, LangHelper.GetString("UlrModule", "Template not found")));
        }
    }

    return result;
}

UlrEditSessionPolicingProtocolsFormWidget.prototype.SetProtocolsConfig = function(Arr)
{
    var _this = this;

    _this.Views.ReportsWidgets.ProtocolsReport.Views.Table.clearAll();
    if(Arr && Arr.length)
    {
        _this.Views.ReportsWidgets.ProtocolsReport.Views.Table.parse(Arr);
    }
};
function UlrSessionPolicingScheduleTableWidget(Params)
{
    var params = {
        id: Params && Params.id ? Params.id : webix.uid(),
        name: "UlrSessionPolicingScheduleTableWidget",
        hideExport: true,
        hidePaginatorToolbar: 1,
        enableLocalSort: 1,
        enableLocalDataSource: 1,
        enableAutoHeight: 1,
        enableCheckboxRefresh: true,
        config: {},
        columns: [
            {
                id: "enabled",
                header: "",
                sort: false,
                width: 32,
                template: CellCheckboxSwitchOnOffTemplate
            },
            {
                id: "action",
                header: LangHelper.GetString("UlrModule", "Action"),
                fillspace: true,
                sort: "string",
                template: function(Obj)
                {
                    let model = new UlrSessionPolicingScheduleViewModel(Obj);
                    let res = model.action ? model.action : "";
                    return SessionPolicingActionsEnum[res] ? SessionPolicingActionsEnum[res].value : res;
                }
            },
            {
                id: "tpl_name",
                header: LangHelper.GetString("UlrModule", "Template"),
                fillspace: true,
                sort: "string"
            },
            {
                id: "start_time",
                header: LangHelper.GetString("UlrModule", "Start time"),
                fillspace: true,
                sort: "string",
                template: function(Obj)
                {
                    let model = new UlrSessionPolicingScheduleViewModel(Obj);
                    return model.start_time ? Helper.ConvertTimeUtcToLocal(model.start_time) : "";

                }
            },
            {
                id: "week_days",
                header: LangHelper.GetString("UlrModule", "Week days"),
                fillspace: true,
                sort: "string",
                template: function(Obj)
                {
                    let model = new UlrSessionPolicingScheduleViewModel(Obj);
                    let res = "";

                    if(model.start_time && model.week_days)
                    {
                        const [_, weekDays] = Helper.ConvertSchedule(
                            model.start_time,
                            model.week_days.split(",").sort(),
                            "UtcToLocal"
                        );

                        res = Object.values(DaysOfWeekDic).filter(Item => weekDays.includes(Item.id))
                            .map(Item => Item.value).join(",");
                    }

                    return res;
                }
            },
            {
                id: "update_time",
                header: LangHelper.GetString("QoE", "Update time"),
                fillspace: true,
                sort: "string",
                template: LocalTimeZone
            },
            {
                id: "create_time",
                header: LangHelper.GetString("QoE", "Create time"),
                fillspace: true,
                sort: "string",
                template: LocalTimeZone
            },
            {
                id: "edit",
                header: "",
                sort: false,
                width: 32,
                template:CellEditPencilBtnTemplate
            },
            {
                id: "delete",
                header: "",
                sort: false,
                width: 32,
                template: CellTrashBtnTemplate
            }

        ],
        defaultPageSize: -10,
        on: {},
        minHeight: 40,
        rules: {}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
}

function UlrEditSessionPolicingScheduleWidget(Params)
{
    let _this = this;

    this.Id = Params && Params.id ? Params.id : "UlrEditSessionPolicingScheduleWidget";

    this.ViewController = null;
    this.ViewModel = null;
    this.ReportsModel = null;
    this.CurProfile = null;
    this.SelectedTemplate = null;
    this.Subscriptions = {};
    this.TemplateType = Params && Params.template_type ? Params.template_type : UlrPolicingTemplatesTypesDic.session.id;

    this.LeftMargin = Params && Params.left_margin ? Params.left_margin : 0;
    this.IsMulti = Params && Params.is_multi ? Params.is_multi : false;

    this.SchedulesToUpdate = {
        "update": {},
        "delete": {}
    };

    this.Views = {
        Widget: null,
        ScheduleToggle: null,
        ScheduleBlock: null,
        ScheduleForm: null,
        Table: null,
        EditSchedulePopup: {
            EditForm: null,
            ApplyBtn: null
        },
        Widgets: {
            TemplatesPopup: new PolicingsTemplatesPopupViewController({
                Id: this.Id + "TemplatesPopup",
                TemplateType:this.TemplateType,
                ReturnTplModel: true
            })
        },
        ReportsWidgets: {
            SchedulesTable: new UlrSessionPolicingScheduleTableWidget({
                id: this.Id + "UlrSessionPolicingScheduleTableWidget",
                onItemClick: function(Id, E, Node)
                {
                    let table = _this.Views.ReportsWidgets.SchedulesTable.Views.Table;
                    let item = table.getItem(Id.row);
                    let model = new UlrSessionPolicingScheduleViewModel(item);

                    if(Id.column === "delete")
                    {
                        if(model._id)
                        {
                            _this.SchedulesToUpdate.delete[model.id] = model;

                            if(_this.SchedulesToUpdate.update[model.id])
                                delete _this.SchedulesToUpdate.update[model.id];
                        }
                        table.remove(model.id);
                    }
                    if(Id.column === "edit")
                    {
                        _this.SetEditSchedulePopup(model);
                        _this.EditSchedulePopup.show();
                    }
                },
                onCheck: function(Id, Column, State)
                {
                    let table = _this.Views.ReportsWidgets.SchedulesTable.Views.Table;
                    let item = table.getItem(Id);
                    let model = new UlrSessionPolicingScheduleViewModel(item);

                    if(Column === "enabled")
                        _this.SchedulesToUpdate.update[model.id] = model;
                }
            })
        }
    };

    let elementSizes = {
        "rowsFormIndent": 6,
        "rowsFormIndentLarge": 12,
        "toggleHeight": 22,
        "toggleWidth": 22,
        "inputHeight": 51,
        "inputWidth": 200,
        "inputMaxWidth": 350
    };

    this.EditSchedulePopup = webix.ui({
        view: "window",
        css: "spectre-alert form_modal",
        width: 480,
        modal: true,
        position: "center",
        padding: 0,
        marging: 0,
        head: {
            view: "toolbar",
            cols: [
                {
                    view: "label",
                    label: LangHelper.GetString("UlrModule", "Edit schedule"),
                    height: 68
                },
                {
                    view: "spectre_button",
                    css: "form_button spec_action with_icon",
                    type: "icon",
                    icon: "times",
                    align: "right",
                    width: 68,
                    height: 68,
                    click: function()
                    {
                        _this.EditSchedulePopup.hide();
                    }
                }
            ]
        },
        body: {
            type: "space",
            borderless: true,
            rows: [
                {
                    type: "clean",
                    borderless: true,
                    rows: [
                        {
                            view: "form",
                            id: this.Id + "EditSchedulePopup" + "EditForm",
                            width: 480,
                            type: "wide",
                            elements: [
                                {
                                    type: "wide",
                                    rows: [
                                        {
                                            view: "spectre_datepicker",
                                            name: "start_time",
                                            type: "time",
                                            height: elementSizes.inputHeight,
                                            maxWidth: elementSizes.inputMaxWidth,
                                            required: true,
                                            validate: webix.rules.isNotEmpty(),
                                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                                            labelPosition: "top",
                                            label: LangHelper.GetString("UlrModule", "Start time"),
                                            tooltip: LangHelper.GetString("UlrModule", "Start time"),
                                            stringResult: true,
                                            on: {
                                                onChange: function()
                                                {
                                                    this.validate();
                                                }
                                            }
                                        }
                                    ]
                                },
                                {
                                    type: "wide",
                                    rows: [
                                        {
                                            view: "spectre_multiselect",
                                            name: "week_days",
                                            height: elementSizes.inputHeight,
                                            maxWidth: elementSizes.inputMaxWidth,
                                            required: true,
                                            validate: webix.rules.isNotEmpty(),
                                            invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                                            labelPosition: "top",
                                            label: LangHelper.GetString("Tariffs", "Days of the week"),
                                            tooltip: LangHelper.GetString("Tariffs", "Days of the week"),
                                            value: Object.keys(DaysOfWeekDic),
                                            options: Helper.DictToArr(DaysOfWeekDic),
                                            on: {
                                                onChange: function()
                                                {
                                                    this.validate();
                                                }
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {height: 20},
                {
                    type: "wide",
                    cols: [
                        {
                            view: "spectre_button",
                            id: this.Id + "EditSchedulePopup" + "ApplyBtn",
                            css: "form_button main_action",
                            label: LangHelper.GetString("UlrModule", "Apply"),
                            autowidth: true,
                            click: function()
                            {
                                setTimeout(() => {
                                    _this.ApplyEditSchedulePopup();
                                }, 1);
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = {
        id: this.Id + "Widget",
        rows: [
            {
                cols: function(){
                    var res = [BlockHeaderTemplate({
                        title: LangHelper.GetString("UlrModule","Timetable"), icon:"",
                        borderless: true
                    })];
                    if(_this.LeftMargin)
                    {
                        res.unshift({width: _this.LeftMargin});
                    }
                    return res;
                }()
            },
            {height: elementSizes.rowsFormIndent},
            {
                type: "wide",
                cols: function(){
                    var res = [
                        {
                            id: _this.Id + "ScheduleToggle",
                            view: "spectre_toggle",
                            height: elementSizes.toggleHeight,
                            width: elementSizes.toggleWidth,
                            value: 0,
                            on: {
                                onChange: function(Nv, Ov)
                                {
                                    if(Nv)
                                    {
                                        if(!_this.IsMulti)
                                            _this.RefreshData();

                                        _this.ShowScheduleBlock();
                                    }
                                    else
                                    {
                                        _this.HideScheduleBlock();
                                    }
                                }
                            }
                        },
                        {
                            rows: [
                                BlockHeaderTemplate({
                                    title: LangHelper.GetString("UlrModule","Set ISP profile schedule"),
                                    icon: "",
                                    borderless: true
                                })
                            ]
                        },
                        {}
                    ];

                    if(_this.LeftMargin)
                    {
                        res.unshift({width: _this.LeftMargin});
                    }

                    return res;
                }()
            },
            {
                id: this.Id + "ScheduleBlock",
                hidden: true,
                rows: [
                    {height: elementSizes.rowsFormIndent},
                    {
                        id: this.Id + "ScheduleForm",
                        view: "form",
                        type: "wide",
                        borderless: true,
                        cols: function(){
                            var res = [
                                {
                                    view: "spectre_richselect",
                                    name: "action",
                                    height: elementSizes.inputHeight,
                                    maxWidth: elementSizes.inputMaxWidth,
                                    required: true,
                                    validate: webix.rules.isNotEmpty(),
                                    invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                                    label: LangHelper.GetString("UlrModule","Action"),
                                    tooltip: LangHelper.GetString("UlrModule", "Action"),
                                    options: Helper.DictToArr(SessionPolicingActionsEnum),
                                    on: {
                                        onChange: function(Nv, Ov)
                                        {
                                            this.validate();

                                            if(Nv === SessionPolicingActionsEnum.enable_template.id || Nv === SessionPolicingActionsEnum.add_template_to_config.id)
                                                _this.ShowTemplateBlock();
                                            else
                                                _this.HideTemplateBlock();
                                        }
                                    }
                                },
                                {
                                    view: "spectre_text",
                                    name: "template",
                                    height: elementSizes.inputHeight,
                                    maxWidth: elementSizes.inputMaxWidth,
                                    label: LangHelper.GetString("UlrModule", "Template"),
                                    tooltip: LangHelper.GetString("UlrModule", "Template"),
                                    required: true,
                                    validate: webix.rules.isNotEmpty(),
                                    invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                                    readonly: true,
                                    on: {
                                        onItemClick: function()
                                        {
                                            setTimeout(function(){
                                                _this.Views.Widgets.TemplatesPopup.Views.ReportsWidgets.TemplatesReport.RefreshData();
                                                _this.Views.Widgets.TemplatesPopup.Popup.show();
                                            }, 1);
                                        },
                                        onChange: function()
                                        {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "spectre_datepicker",
                                    name: "start_time",
                                    type: "time",
                                    height: elementSizes.inputHeight,
                                    maxWidth: elementSizes.inputMaxWidth,
                                    required: true,
                                    validate: webix.rules.isNotEmpty(),
                                    invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                                    labelPosition: "top",
                                    label: LangHelper.GetString("UlrModule", "Start time"),
                                    tooltip: LangHelper.GetString("UlrModule", "Start time"),
                                    stringResult: true,
                                    on: {
                                        onChange: function()
                                        {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "spectre_multiselect",
                                    name: "week_days",
                                    height: elementSizes.inputHeight,
                                    maxWidth: elementSizes.inputMaxWidth,
                                    required: true,
                                    validate: webix.rules.isNotEmpty(),
                                    invalidMessage: LangHelper.GetString("QoE", "The field cannot be empty"),
                                    labelPosition: "top",
                                    label: LangHelper.GetString("Tariffs", "Days of the week"),
                                    tooltip: LangHelper.GetString("Tariffs", "Days of the week"),
                                    value: Object.keys(DaysOfWeekDic),
                                    options: Helper.DictToArr(DaysOfWeekDic),
                                    on: {
                                        onChange: function()
                                        {
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "spectre_button",
                                    name: "add_btn",
                                    css: "form_button form_element spec_action",
                                    label: LangHelper.GetString("UlrModule","Add"),
                                    height: elementSizes.inputHeight,
                                    autowidth: true,
                                    click: function()
                                    {
                                        _this.ApplyForm();
                                    }
                                },
                                {}
                            ];

                            if(_this.LeftMargin)
                            {
                                res.unshift({width: _this.LeftMargin});
                            }

                            return res;
                        }(),


                    },
                    {height: elementSizes.rowsFormIndentLarge},
                    this.Views.ReportsWidgets.SchedulesTable.ViewConfig
                ]
            }
        ]
    };
}

UlrEditSessionPolicingScheduleWidget.prototype.Bind = function(ViewController = null, ViewModel = null)
{
    let _this = this;

    if(ViewController)
        this.ViewController = ViewController;

    if(this.ViewController && this.ViewController.ReportsModel)
        this.ReportsModel = this.ViewController.ReportsModel;

    if(ViewModel)
        this.ViewModel = ViewModel;

    Object.keys(this.Views).forEach(Key => {
        if(!["Widgets", "ReportsWidgets", "EditSchedulePopup"].includes(Key))
            _this.Views[Key] = $$(_this.Id + Key);
    });

    Object.keys(this.Views.EditSchedulePopup).forEach(Key => {
        _this.Views.EditSchedulePopup[Key] = $$(_this.Id + "EditSchedulePopup" + Key);
    });

    Object.keys(this.Views.Widgets).forEach(Key => {
        let w = _this.Views.Widgets[Key];

        if(w && w.Bind)
            w.Bind();

        if(w && w.BindAll)
            w.BindAll();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(Key => {
        let w = _this.Views.ReportsWidgets[Key];

        if(w && w.Bind)
            w.Bind(ViewController, this.ReportsModel);
    });

    this.HideTemplateBlock();

    this.Subscriptions.TemplateApply = this.Views.Widgets.TemplatesPopup.Signals.OnApplyConfigSignal.subscribe(Item => {
        if(Item && Item._id && Item.title)
        {
            _this.SelectedTemplate = Item;
            _this.Views.ScheduleForm.elements["template"].setValue(Item.title);
        }
    });

    this.Subscriptions.RefreshSchedulesSuccess = this.ViewModel.Signals.RefreshSchedulesSuccess.subscribe(Data => {
        if(Data && Array.isArray(Data))
        {
            let table = _this.Views.ReportsWidgets.SchedulesTable.Views.Table;
            table.clearAll();
            table.parse(Data);
            table.sort("start_time", "asc");
            table.markSorting("start_time", "asc");

            _this.SchedulesToUpdate.update = {};
            _this.SchedulesToUpdate.delete = {};
        }
    });

    this.Subscriptions.RefreshSchedulesError = this.ViewModel.Signals.RefreshSchedulesError.subscribe(Error => {
        if(Error)
            _this.ShowServerError(Error);
    });
};

UlrEditSessionPolicingScheduleWidget.prototype.Destroy = function()
{
    let _this = this;

    Object.keys(this.Views.Widgets).forEach(Key => {
        let w = _this.Views.Widgets[Key];

        if(w && w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(Key => {
        let w = _this.Views.ReportsWidgets[Key];

        if(w && w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Subscriptions).forEach(function (Key)
    {
        if(_this.Subscriptions[Key])
            _this.Subscriptions[Key].unsubscribe();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrEditSessionPolicingScheduleWidget.prototype.RefreshWidget = function()
{
    if(this.CurProfile && this.CurProfile.schedule_enabled)
    {
        this.Views.ScheduleToggle.blockEvent();
        this.Views.ScheduleToggle.setValue(1);
        this.Views.ScheduleToggle.unblockEvent();
        this.ShowScheduleBlock();
        this.RefreshData();
    }
};

UlrEditSessionPolicingScheduleWidget.prototype.ClearForm = function()
{
    let _this = this;

    ["action", "template", "start_time", "week_days"].forEach(ElId => {
        _this.ClearElmnt(_this.Views.ScheduleForm, ElId, true);
    });
};

UlrEditSessionPolicingScheduleWidget.prototype.SetFormToDefault = function()
{
    this.Views.ScheduleForm.elements["week_days"].setValue(Object.keys(DaysOfWeekDic));
};

UlrEditSessionPolicingScheduleWidget.prototype.ShowScheduleBlock = function()
{
    let _this = this;

    this.Views.ScheduleBlock.show();

    ["action", "start_time", "week_days"].forEach(ElId => {
        _this.Views.ScheduleForm.elements[ElId].show();
        _this.Views.ScheduleForm.elements[ElId].enable();
        _this.ClearElmnt(_this.Views.ScheduleForm, ElId);
    });

    this.SetFormToDefault();
};

UlrEditSessionPolicingScheduleWidget.prototype.HideScheduleBlock = function()
{
    let _this = this;

    this.HideTemplateBlock();

    ["action", "start_time", "week_days"].forEach(ElId => {
        _this.Views.ScheduleForm.elements[ElId].hide();
        _this.Views.ScheduleForm.elements[ElId].disable();
        _this.ClearElmnt(_this.Views.ScheduleForm, ElId);
    });

    this.Views.ScheduleBlock.hide();
};

UlrEditSessionPolicingScheduleWidget.prototype.ShowTemplateBlock = function()
{
    this.Views.ScheduleForm.elements["template"].show();
    this.Views.ScheduleForm.elements["template"].enable();
    this.ClearElmnt(this.Views.ScheduleForm, "template");
};

UlrEditSessionPolicingScheduleWidget.prototype.HideTemplateBlock = function()
{
    this.SelectedTemplate = null;
    this.Views.ScheduleForm.elements["template"].hide();
    this.Views.ScheduleForm.elements["template"].disable();
    this.ClearElmnt(this.Views.ScheduleForm, "template");
};

UlrEditSessionPolicingScheduleWidget.prototype.ClearElmnt = function(FormView, ElId, Check = false)
{
    if(Check && (!FormView.elements[ElId] || !FormView.elements[ElId].isVisible()))
        return;

    FormView.markInvalid(ElId, false);
    FormView.elements[ElId].blockEvent();
    FormView.elements[ElId].setValue("");
    FormView.elements[ElId].unblockEvent();
};

UlrEditSessionPolicingScheduleWidget.prototype.ApplyForm = function()
{
    if(!this.Views.ScheduleForm.validate())
        return;

    let formData = this.Views.ScheduleForm.getValues();
    let weekDays = formData && formData.week_days ? formData.week_days : Object.keys(DaysOfWeekDic);

    if(typeof weekDays === "string")
        weekDays = weekDays.split(",");

    if(!formData.start_time || !weekDays)
        return;

    const [_startTime, _weekDays] = Helper.ConvertSchedule(
        formData.start_time,
        weekDays.sort(),
        "localToUtc"
    );

    let model = new UlrSessionPolicingScheduleViewModel({
        enabled: 1,
        prfl_id: this.CurProfile && this.CurProfile._id ? this.CurProfile._id : null,
        tpl_id: this.SelectedTemplate && this.SelectedTemplate._id ? this.SelectedTemplate._id : null,
        tpl_name: this.SelectedTemplate && this.SelectedTemplate.title ? this.SelectedTemplate.title : "",
        action: formData && formData.action ? formData.action : "",
        start_time: _startTime ? _startTime : "",
        week_days: _weekDays ? _weekDays : ""
    });

    this.Views.ReportsWidgets.SchedulesTable.Views.Table.add(model);
    this.SchedulesToUpdate.update[model.id] = model;

    this.ClearForm();
    this.SetFormToDefault();
    this.SelectedTemplate = null;
};

UlrEditSessionPolicingScheduleWidget.prototype.RefreshData = function()
{
    if(this.CurProfile && this.CurProfile._id)
        this.ViewModel.GetSessionPolicingSchedulesByProfileId(this.CurProfile._id);
};

UlrEditSessionPolicingScheduleWidget.prototype.IsWidgetEnable = function()
{
    return !!(this.Views.ScheduleToggle.getValue());
};

UlrEditSessionPolicingScheduleWidget.prototype.GetScheduleUpdateData = function()
{
    return {
        "update": Object.values(this.SchedulesToUpdate.update),
        "delete": Object.values(this.SchedulesToUpdate.delete)
    };
};

UlrEditSessionPolicingScheduleWidget.prototype.SetEditSchedulePopup = function(Item)
{
    let model = new UlrSessionPolicingScheduleViewModel(Item);

    if(!model.start_time || !model.week_days)
        return;

    const [startTime, weekDays] = Helper.ConvertSchedule(
        model.start_time,
        model.week_days.split(",").sort(),
        "UtcToLocal"
    );

    this.Views.EditSchedulePopup.EditForm.elements["start_time"].setValue(startTime);
    this.Views.EditSchedulePopup.EditForm.elements["week_days"].setValue(weekDays);
};

UlrEditSessionPolicingScheduleWidget.prototype.ApplyEditSchedulePopup = function()
{
    let form = this.Views.EditSchedulePopup.EditForm;
    let table = this.Views.ReportsWidgets.SchedulesTable.Views.Table;

    if(!form.validate())
        return;

    let formData = form.getValues();
    let model = new UlrSessionPolicingScheduleViewModel(formData);

    if(!model.start_time || !model.week_days)
        return;

    const [startTime, weekDays] = Helper.ConvertSchedule(
        model.start_time,
        model.week_days.split(",").sort(),
        "localToUtc"
    );

    let selectedItem = table.getSelectedItem();
    let data = {
        start_time: startTime,
        week_days: weekDays.join(",")
    };

    if(selectedItem && (selectedItem.start_time !== data.start_time || selectedItem.week_days !== data.week_days))
    {
        let _item = webix.extend(selectedItem, data, true);
        table.updateItem(_item.id, _item);
        this.SchedulesToUpdate.update[_item.id] = _item;
    }

    this.EditSchedulePopup.hide();
};

UlrEditSessionPolicingScheduleWidget.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};
function UlrEditIspSessionPolicingViewController(Params)
{
    this.Id = "UlrEditIspSessionPolicing";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","Edit ISP session policing profile");

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        EditLabel: LangHelper.GetString("UlrModule", "ISP profile configuration"),
        EditPath: ControllersEnum.UlrEditIsp,
        ListSection: ControllersEnum.UlrIspSessionPolicings,
        BlockInfoTemplate: LangHelper.GetString("UlrModule","SESSION_POLICING_PROFILE_DESCRIPTION_FOR_VCHANNEL")
    }, true);

    UlrEditIspSessionPolicingViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrEditIspSessionPolicingViewController, UlrEditSessionPolicingViewController);

function UlrAddIspSessionPolicingViewController(Params) {
    UlrAddIspSessionPolicingViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddIspSessionPolicingViewController, UlrEditIspSessionPolicingViewController);

function UlrEditSubscriberSessionPolicingViewController(Params)
{
    this.Id = "UlrEditSubscriberSessionPolicing";
    this.RootTitle = LangHelper.GetString("UlrModule","Bandwidth management");
    this.Title = LangHelper.GetString("UlrModule","Edit subscriber session policing profile");

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        EditLabel: LangHelper.GetString("UlrModule", "Subscriber profile configuration"),
        EditPath: ControllersEnum.UlrEditSubs,
        ListSection: ControllersEnum.UlrSubscribersSessionPolicings,
        BlockInfoTemplate: LangHelper.GetString("UlrModule","SESSION_POLICING_PROFILE_DESCRIPTION_FOR_SUBSCRIBER")
    }, true);

    UlrEditSubscriberSessionPolicingViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrEditSubscriberSessionPolicingViewController, UlrEditSessionPolicingViewController);



function UlrAddIspSessionPolicingViewController(Params) {
    UlrAddIspSessionPolicingViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddIspSessionPolicingViewController, UlrEditSubscriberSessionPolicingViewController);

function UlrAsnDscpRulesViewController(Params)
{
    var _this = this;

    this.RuleType = Params&&Params.rule_type&&UlrRulesTypesCodesEnum[Params.rule_type]?UlrRulesTypesCodesEnum[Params.rule_type]:UlrRulesTypesCodesEnum.asn_lock;

    this.RuleTypeId = UlrRulesTypesCodesTypeIdMap[this.RuleType];

    this.Id = function (RuleType)
    {
        var id = "UlrAsnDscpRules";

        if(RuleType == UlrRulesTypesCodesEnum.asn_exclude)
            id = "UlrAsnExcludesRules";

        if(RuleType == UlrRulesTypesCodesEnum.ip_exclude)
            id = "UlrIpExcludesRules";

        return id;
    }(this.RuleType);

    this.mode = module ? module : "dpiui2";

    this.PageTitle = function (RuleType)
    {
        var title =
        {
            RootTitle:LangHelper.GetString("UlrModule", "ASN filter"),
            Title:LangHelper.GetString("UlrModule","AS DSCP rules")
        };

        if(RuleType == UlrRulesTypesCodesEnum.asn_exclude)
            title =
                {
                    RootTitle:LangHelper.GetString("UlrModule", "IP & ASN excludes"),
                    Title:LangHelper.GetString("UlrModule","ASN excludes")
                };

        if(RuleType == UlrRulesTypesCodesEnum.ip_exclude)
            title =
                {
                    RootTitle:LangHelper.GetString("UlrModule", "IP & ASN excludes"),
                    Title:LangHelper.GetString("UlrModule","IP excludes")
                };

        return title;
    }(this.RuleType);

    this.ViewModel = new UlrDscpRulesManager();

    this.ReportsModel = new UniReportsManager();

    if (this.RuleType == UlrRulesTypesCodesEnum.asn_lock)
    {
        this.IspsList = new UlrIspListViews({id: "Main", hidden: AppEnv.DisableISPSwitchForASNBlocks && this.RuleType == UlrRulesTypesCodesEnum.asn_lock ? true : false});
        this.EditPopupIspsList = new UlrIspListViews({id: "Popup", hidden: AppEnv.DisableISPSwitchForASNBlocks && this.RuleType == UlrRulesTypesCodesEnum.asn_lock ? true : false});
    }

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        AddDSCPForm:null,
        AsnInput:null,
        PriorityInput:null,
        AsnTagsInput: null,
        RuleNameInput:null,
        RuleDescriptionInput:null,
        SetDscpBtn:null,

        EditPopupAddDSCPForm:null,
        EditPopupAsnLabel:null,
        EditPopupPriorityInput:null,
        EditPopupAsnTagsInput: null,
        EditPopupRuleNameInput:null,
        EditPopupRuleDescriptionInput:null,
        EditPopupSetDscpBtn:null,

        Widgets:{},
        ReportsWidgets:{
            DscpReport:function()
            {
                var widget  = UrlAsnDSCPsTableWidget;

                if(_this.RuleType == UlrRulesTypesCodesEnum.asn_exclude)
                    widget = UrlAsnExcludesTableWidget;

                if(_this.RuleType == UlrRulesTypesCodesEnum.ip_exclude)
                    widget = UrlIpExcludesTableWidget;

                return widget({
                    id:_this.Id + "DscpReport",
                    enableTextSearch:1,
                    enableAutoHeight:1,
                    onItemClick:function (Id, E, Node)
                    {
                        _this.DscpReportOnItemClick(Id, E, Node);
                    },
                    onCheck:function (Row, Column, State)
                    {
                        _this.DscpReportOnCheck(Row, Column, State);
                    }
                });
            }()
        }
    };

    this.EditPopup = null;

    this.EditPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        width:600,
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "EditPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Edit rule"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.EditPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "EditPopupAddDSCPForm",
                            type: "wide",
                            minWidth:400,
                            elements: [
                                {
                                    type: "wide",
                                    cols:[
                                        {
                                            view:"label",
                                            id:this.Id + "EditPopupAsnLabel",
                                            css:"form_header_label",
                                            label:"",
                                            template:_this.RuleType == UlrRulesTypesCodesEnum.ip_exclude ? "IP or CIDR: #label#" : "AS number: #label#"
                                        }
                                    ]
                                },
                                {
                                    type: "wide",
                                    cols: function(){
                                        var arr = [
                                            {
                                                view:"spectre_combo",
                                                id:_this.Id + "EditPopupPriorityInput",
                                                name:"priority",
                                                label:LangHelper.GetString("UlrModule","Priority"),
                                                options:{
                                                    view:"gridsuggest",
                                                    point:false,
                                                    body:{
                                                        autoheight:false,
                                                        scroll:true,
                                                        maxHeight:400,
                                                        //width:800,
                                                        //minWidth:800,
                                                        borderless:true,
                                                        columns:[
                                                            { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                                            { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                                            { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                                            { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                                            { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                                            { id:"class_order_1", header:"class_order=1", width:160}
                                                        ],
                                                        data: _this.GetPriorityOptions()
                                                    }
                                                },
                                                required: _this.RuleType !== UlrRulesTypesCodesEnum.asn_lock,
                                                validate: _this.RuleType !== UlrRulesTypesCodesEnum.asn_lock ? webix.rules.isNotEmpty : () => {return true},
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                        {
                                                            this.setValue(Nv.trim());
                                                            return;
                                                        }

                                                        if(_this.RuleType === UlrRulesTypesCodesEnum.asn_lock)
                                                        {
                                                            return;
                                                        }
                                                        this.validate();
                                                    }
                                                },
                                                hidden:_this.RuleType == UlrRulesTypesCodesEnum.asn_exclude || _this.RuleType == UlrRulesTypesCodesEnum.ip_exclude
                                            }
                                        ];

                                        if(_this.RuleType == UlrRulesTypesCodesEnum.asn_lock)
                                        {
                                            arr.push({
                                                cols: [
                                                    {
                                                        id:_this.Id + "EditPopupAsnTagsInput",
                                                        view:"spectre_multiselect",
                                                        name:"asn_tags",
                                                        label:LangHelper.GetString("UlrModule","Tags"),
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        options: _this.GetDscpTagsOptions()
                                                    },
                                                    {
                                                        view: "spectre_button",
                                                        type: "icon",
                                                        icon: "question-circle",
                                                        css:"toolbar_round_btn form_element spec_action custom-form-btn",
                                                        width:32,
                                                        tooltip:LangHelper.GetString("UlrModule", "Description of tags"),
                                                        click:function (id)
                                                        {
                                                            UlrShowAsnTagsHelpPopup();
                                                        }
                                                    }
                                                ]
                                            })
                                        }

                                        return arr;
                                    }()
                                },
                                {
                                    type:"wide",
                                    cols:[
                                        {
                                            view:"spectre_text",
                                            id:this.Id + "EditPopupRuleNameInput",
                                            name:"name",
                                            label:LangHelper.GetString("UlrModule","Rule name"),
                                            required:true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                            on: {
                                                "onChange": function (Nv, Ov)
                                                {
                                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }
                                                    this.validate();
                                                }
                                            }
                                        }
                                    ]
                                },
                                {
                                    type: "wide",
                                    cols: [
                                        {
                                            view:"spectre_textarea",
                                            id:this.Id + "EditPopupRuleDescriptionInput",
                                            name:"description",
                                            label:LangHelper.GetString("UlrModule","Public description"),
                                            required:true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                            on: {
                                                "onChange": function (Nv, Ov)
                                                {
                                                    if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }
                                                    this.validate();
                                                }
                                            }
                                        }
                                    ]
                                },
                                ...(_this.EditPopupIspsList ? _this.EditPopupIspsList.ViewConfig : [])
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "EditPopupSetDscpBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Set DSCP"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function () {
                                            _this.SaveEditForm();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({id:this.Id + "PageTitle", root_title: this.PageTitle.Title}),
                            {height:32},
                            {
                                view:"template",
                                borderless:true,
                                css:"form_text_big_label",
                                //height:120,
                                autoheight:true,
                                template:function (RuleType)
                                {
                                    var label = LangHelper.GetString("UlrModule","Set DCSP priority to ASN direction to use it in ISP profile or use DROP to block ASN traffic on all DPI units.");

                                    if(RuleType == UlrRulesTypesCodesEnum.asn_exclude)
                                        label = LangHelper.GetString("UlrModule","Add AS numbers to lists and all ASN traffic will be passed without processing.");

                                    if(RuleType == UlrRulesTypesCodesEnum.ip_exclude)
                                        label = LangHelper.GetString("UlrModule","Add IP or CIDR to lists and all IP traffic will be passed without processing.");

                                    return label;

                                }(this.RuleType)
                            },
                            {height:20},
                            {
                                view:"template",
                                borderless:false,
                                border:2,
                                css:"form_text_warning_label",
                                height:40,
                                hidden: AppEnv.DisableISPSwitchForDSCPRules ? true : false,
                                //autoheight:true,
                                template:function (RuleType)
                                {
                                    var warning = "<span class='warning'>"+LangHelper.GetString("UlrModule","Warning")+"</span>" + ": ";
                                    var label = LangHelper.GetString("UlrModule","Priority works globally if no ISP is specified!");

                                    if(RuleType == UlrRulesTypesCodesEnum.asn_exclude)
                                        label = LangHelper.GetString("UlrModule","This sets PASS priority to AS numbers and works globally!");

                                    if(RuleType == UlrRulesTypesCodesEnum.ip_exclude)
                                        label = LangHelper.GetString("UlrModule","This sets PASS priority to IP-addresses and works globally!");

                                    return warning+label;
                                }(this.RuleType)
                            },
                            {height:32, hidden: AppEnv.DisableISPSwitchForDSCPRules ? true : false},
                            {
                                type:"space",
                                css:"form_background",
                                rows:[
                                    {
                                        type:"clean",
                                        borderless:true,
                                        rows:[
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","Add new rule"), icon:"",
                                                borderless:true
                                            }),
                                            {height:20},
                                            {
                                                view: "form",
                                                id: this.Id + "AddDSCPForm",
                                                type: "wide",
                                                elements: function ()
                                                {
                                                    var dscpIdInput = {
                                                        view:"spectre_text",
                                                        id:_this.Id + "AsnInput",
                                                        name:"asn",
                                                        gravity:2,
                                                        label:_this.RuleType == UlrRulesTypesCodesEnum.ip_exclude ? LangHelper.GetString("UlrModule","IP or CIDR") : LangHelper.GetString("UlrModule","AS number"),
                                                        required:true,
                                                        validate:function(Val)
                                                        {
                                                            if(_this.RuleType == UlrRulesTypesCodesEnum.ip_exclude)
                                                                return Helper.ValidateIPaddressOrCidr(Val);
                                                            else
                                                                return Val && !isNaN(Val*1);
                                                        },
                                                        invalidMessage: _this.RuleType == UlrRulesTypesCodesEnum.ip_exclude ? LangHelper.GetString("Dics","Enter the CIDR or IP") : LangHelper.GetString("Dics","Enter the number"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                {
                                                                    this.setValue(Nv.trim());
                                                                    return;
                                                                }
                                                                this.validate();
                                                            }
                                                        }
                                                    };

                                                    var dscpPriorityInput = {
                                                        view:"spectre_combo",
                                                        id:_this.Id + "PriorityInput",
                                                        name:"priority",
                                                        label:LangHelper.GetString("UlrModule","Priority"),
                                                        options:{
                                                            view:"gridsuggest",
                                                            point:false,
                                                            body:{
                                                                autoheight:false,
                                                                scroll:true,
                                                                maxHeight:400,
                                                                //width:800,
                                                                //minWidth:800,
                                                                borderless:true,
                                                                columns:[
                                                                    { id:"value", header:LangHelper.GetString("UlrModule","DSCP name"), width:160 },
                                                                    { id:"binary", header:LangHelper.GetString("UlrModule","Binary value") },
                                                                    { id:"decimal", header:LangHelper.GetString("UlrModule","Decimal value") },
                                                                    { id:"priority", header:LangHelper.GetString("UlrModule","Priority") },
                                                                    { id:"class", header:LangHelper.GetString("UlrModule","Policing class"), width:160 },
                                                                    { id:"class_order_1", header:"class_order=1", width:160}
                                                                ],
                                                                data:_this.GetPriorityOptions()
                                                            }
                                                        },
                                                        required: _this.RuleType !== UlrRulesTypesCodesEnum.asn_lock,
                                                        validate: _this.RuleType !== UlrRulesTypesCodesEnum.asn_lock ? webix.rules.isNotEmpty : () => {return true;},
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                {
                                                                    this.setValue(Nv.trim());
                                                                    return;
                                                                }
                                                                if(_this.RuleType === UlrRulesTypesCodesEnum.asn_lock)
                                                                {
                                                                    return;
                                                                }
                                                                this.validate();
                                                            }
                                                        },
                                                        hidden:_this.RuleType == UlrRulesTypesCodesEnum.asn_exclude || _this.RuleType == UlrRulesTypesCodesEnum.ip_exclude
                                                    };

                                                    var dscpMarksInput = {
                                                        view:"spectre_multiselect",
                                                        id:_this.Id + "AsnTagsInput",
                                                        name:"asn_tags",
                                                        label:LangHelper.GetString("UlrModule","Tags"),
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        options: _this.GetDscpTagsOptions()
                                                    };

                                                    var helpPopupMarksBtn = {
                                                        view: "spectre_button",
                                                        type: "icon",
                                                        icon: "question-circle",
                                                        css:"toolbar_round_btn form_element spec_action custom-form-btn",
                                                        width:32,
                                                        tooltip:LangHelper.GetString("UlrModule", "Description of tags"),
                                                        click:function (id)
                                                        {
                                                            UlrShowAsnTagsHelpPopup();
                                                        }
                                                    }

                                                    var dscpRuleNameInput = {
                                                        view:"spectre_text",
                                                        id:_this.Id + "RuleNameInput",
                                                        name:"name",
                                                        label:LangHelper.GetString("UlrModule","Rule name"),
                                                        required:true,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                {
                                                                    this.setValue(Nv.trim());
                                                                    return;
                                                                }
                                                                this.validate();
                                                            }
                                                        }
                                                    };

                                                    var dscpDescriptionInput = {
                                                        type: "wide",
                                                        cols: [
                                                            {
                                                                view:"spectre_textarea",
                                                                id:_this.Id + "RuleDescriptionInput",
                                                                name:"description",
                                                                label:LangHelper.GetString("UlrModule","Public description"),
                                                                required:true,
                                                                validate: webix.rules.isNotEmpty,
                                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                                on: {
                                                                    "onChange": function (Nv, Ov)
                                                                    {
                                                                        if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                                        {
                                                                            this.setValue(Nv.trim());
                                                                            return;
                                                                        }
                                                                        this.validate();
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    };

                                                    var layout = [
                                                        {
                                                            cols: [
                                                                {
                                                                    rows: [
                                                                        dscpIdInput,
                                                                        dscpRuleNameInput,
                                                                        dscpPriorityInput
                                                                    ]
                                                                },
                                                                {width:20},
                                                                dscpDescriptionInput
                                                            ]
                                                        },
                                                        ...(_this.IspsList ? _this.IspsList.ViewConfig : [])
                                                    ];
                                                    if(_this.RuleType === UlrRulesTypesCodesEnum.asn_lock)
                                                    {
                                                        layout = [
                                                            {
                                                                cols: [
                                                                    {
                                                                        rows: [
                                                                            dscpIdInput,
                                                                            dscpRuleNameInput,
                                                                            {
                                                                                cols: [
                                                                                    dscpPriorityInput,
                                                                                    {
                                                                                        cols: [
                                                                                            dscpMarksInput,
                                                                                            helpPopupMarksBtn,
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {width:20},
                                                                    dscpDescriptionInput
                                                                ]
                                                            },
                                                            ...(_this.IspsList ? _this.IspsList.ViewConfig : [])
                                                        ];
                                                    }
                                                    else if(_this.RuleType == UlrRulesTypesCodesEnum.asn_exclude || _this.RuleType == UlrRulesTypesCodesEnum.ip_exclude)
                                                    {
                                                        layout = [
                                                            {
                                                                type: "wide",
                                                                cols:[
                                                                    dscpIdInput,
                                                                    dscpRuleNameInput,
                                                                    dscpPriorityInput
                                                                ]
                                                            },
                                                            dscpDescriptionInput
                                                        ];
                                                    }

                                                    return layout;
                                                }()
                                            },
                                            {height:20},
                                            {
                                                type:"wide",
                                                cols:[
                                                    {
                                                        view:"spectre_button",
                                                        id:_this.Id + "SetDscpBtn",
                                                        css:"form_button main_action",
                                                        label:LangHelper.GetString("UlrModule",_this.RuleType == UlrRulesTypesCodesEnum.asn_exclude || _this.RuleType == UlrRulesTypesCodesEnum.ip_exclude ? "Set exclusion" : "Set DSCP"),
                                                        autowidth:true,
                                                        click:function ()
                                                        {
                                                            setTimeout(function () {
                                                                _this.SaveRule(true);
                                                            },1);

                                                        }
                                                    },
                                                    {}
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height:32},
                            this.Views.ReportsWidgets.DscpReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {
        AsnInputValue: new Rx.BehaviorSubject(null),
        PriorityInputValue: new Rx.BehaviorSubject(null),

        ProcessingModel: new Rx.BehaviorSubject(null)
    };
}

UlrAsnDscpRulesViewController.prototype.BindAll = function (Params)
{
    var _this = this;


    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    var _prefix = this.RuleType == UlrRulesTypesCodesEnum.ip_exclude ? "Ip" : "Asn";

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress)
    {
        var view = _this.Views.SetDscpBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.EditPopupSetDscpBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.AsnInput;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.PriorityInput;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.RuleNameInput;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.RuleDescriptionInput;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions.ProcessingModel = this.Signals.ProcessingModel.subscribe(function (Model)
    {
        if(Model)
        {
            if(_this.RuleType == UlrRulesTypesCodesEnum.ip_exclude)
                _this.ViewModel.CheckIp(Model);
            else
                _this.ViewModel.CheckAsn(Model);
        }

    });

    this.Subscriptions.AsnDscpRuleSaveError = this.ViewModel.Signals[_prefix+"DscpRuleSaveError"].subscribe(function (ErrModel)
    {
        _this.Signals.ProcessingModel.next(null);
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.AsnCheckError = this.ViewModel.Signals[_prefix+"CheckError"].subscribe(function (ErrModel)
    {
        _this.Signals.ProcessingModel.next(null);
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.AsnDscpRuleDeleteError = this.ViewModel.Signals[_prefix+"DscpRuleDeleteError"].subscribe(function (ErrModel)
    {
        _this.Signals.ProcessingModel.next(null);
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.AsnDscpRuleEnableStateError = this.ViewModel.Signals[_prefix+"DscpRuleEnableStateError"].subscribe(function (ErrModel)
    {
        _this.Signals.ProcessingModel.next(null);
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.AsnCheckResult = this.ViewModel.Signals[_prefix+"CheckResult"].subscribe(function (CheckResultModel)
    {
        _this.ProcessCheckResult(CheckResultModel);
    });

    this.Subscriptions.AsnDscpRuleSaved = this.ViewModel.Signals[_prefix+"DscpRuleSaved"].subscribe(function (AsnDscpModel)
    {
        if(AsnDscpModel)
        {
            _this.Signals.ProcessingModel.next(null);
            _this.EditPopup.hide();
            _this.AddOrReplaceAsnRuleModelInTable(AsnDscpModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","DSCP rule")+" # "+AsnDscpModel.protocol+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.AsnDscpRuleDeleted = this.ViewModel.Signals[_prefix+"DscpRuleDeleted"].subscribe(function (AsnDscpModel)
    {
        if(AsnDscpModel)
        {
            _this.Signals.ProcessingModel.next(null);
            _this.DscpReportReportOnSuccessDelete(AsnDscpModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","DSCP rule")+" # "+AsnDscpModel.protocol+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.AsnDscpRuleEnableStateUpdated = this.ViewModel.Signals[_prefix+"DscpRuleEnableStateUpdated"].subscribe(function (AsnDscpModel)
    {
        if(AsnDscpModel)
        {
            _this.Signals.ProcessingModel.next(null);
            _this.AsnDscpRuleEnableStateUpdated(AsnDscpModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","DSCP rule")+" # "+AsnDscpModel.protocol+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });
};

UlrAsnDscpRulesViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.EditPopup = webix.ui(this.EditPopupConfig);

    if (this.IspsList)
        this.IspsList.ViewDidLoad(Params);

    if (this.EditPopupIspsList)
        this.EditPopupIspsList.ViewDidLoad(Params);

    this.BindAll(Params);

    this.Refresh();
};

UlrAsnDscpRulesViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if (this.IspsList)
        this.IspsList.Destroy();

    if (this.EditPopupIspsList)
        this.EditPopupIspsList.Destroy();
};

UlrAsnDscpRulesViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrAsnDscpRulesViewController.prototype.Refresh = function (Params)
{
    this.Views.ReportsWidgets.DscpReport.RefreshData();
};

UlrAsnDscpRulesViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrAsnDscpRulesViewController.prototype.SaveRule = function(Check)
{
    this.Views.AddDSCPForm.clearValidation();

    var priority = this.Views.PriorityInput.getValue();
    if(Check)
    {
        this.Views.AddDSCPForm.clearValidation();

        if(!this.Views.AddDSCPForm.validate())
        {
            return;
        }
    }

    if(this.RuleType === UlrRulesTypesCodesEnum.asn_lock)
    {
        var asn_tags = this.Views.AsnTagsInput.getValue();

        if(!asn_tags && !priority)
        {
            this.Views.AddDSCPForm.markInvalid("priority");
            this.Views.AddDSCPForm.markInvalid("asn_tags");
            return;
        }

        priority = (priority ? priority : "") + " " + (asn_tags ? asn_tags : "");
    }

    var model = {
        protocol: this.Views.AsnInput.getValue(),
        priority: priority,
        name: this.Views.RuleNameInput.getValue(),
        description: this.Views.RuleDescriptionInput.getValue(),
        rule_type_id: this.RuleTypeId,
        enabled:1
    };

    if (this.IspsList)
    {
        model.isps = this.IspsList.getSelectedIsps();
        model.mode_id = this.IspsList.getMode();
    }

    if(!model.protocol)
        return;

    if(Check)
    {
        this.Signals.ProcessingModel.next(model);
    }
    else
        this.JustSaveRule(model);
};

UlrAsnDscpRulesViewController.prototype.JustSaveRule = function(RuleModel)
{
    if(this.RuleType == UlrRulesTypesCodesEnum.ip_exclude)
        this.ViewModel.SaveIpDscpRule(RuleModel);
    else
        this.ViewModel.SaveAsnDscpRule(RuleModel);
};

UlrAsnDscpRulesViewController.prototype.ProcessCheckResult = function(CheckResultModel)
{
    if(!CheckResultModel)
        return;

    var model = new UlrAsnProtocolRuleExistCheckModel(CheckResultModel);

    if(model.by_protocol.rule_exists && model.by_name.rule_exists)
    {
        if(model.by_protocol.rule._id == model.by_name.rule._id)
        {
            this.ShowRuleExistsModal(model.by_protocol.rule, false);
            return;
        }
    }

    if(model.by_name.rule_exists)
    {
        this.ShowRuleExistsModal(model.by_name.rule, true);
        return;
    }

    if(model.by_protocol.rule_exists)
    {
        this.ShowRuleExistsModal(model.by_protocol.rule, false);
        return;
    }

    this.SaveRule(false);
};

UlrAsnDscpRulesViewController.prototype.ShowRuleExistsModal = function(RuleModel, ByName)
{
    var _this = this;

    if(RuleModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ":0",
            message:LangHelper.GetString("UlrModule","A rule with the selected " + (ByName ? "name" : (_this.RuleType == UlrRulesTypesCodesEnum.ip_exclude ? "IP or CIDR" : "AS number")) + " already exists.") + ( !ByName ? ("<br/>" + LangHelper.GetString("UlrModule","Replace") + "?") : ""),
            actions:function () {
                var arr = [
                    {
                        label:LangHelper.GetString("UlrModule","Cancel"),
                        css:"third_action",
                        click:function ()
                        {
                            _this.Signals.ProcessingModel.next(null);
                        }
                    }
                ];

                if(!ByName)
                {
                    arr.push({
                        label:LangHelper.GetString("UlrModule","Replace"),
                        click:function ()
                        {
                            var processingModel = _this.Signals.ProcessingModel.getValue();

                            if(processingModel)
                            {
                                RuleModel.priority = processingModel.priority;
                                RuleModel.name = processingModel.name;
                                RuleModel.description = processingModel.description;
                                RuleModel.rule_type_id = _this.RuleTypeId;
                                _this.JustSaveRule(RuleModel);
                            }
                        }
                    });
                }

                return arr;
            }()
        });
};

UlrAsnDscpRulesViewController.prototype.AddOrReplaceAsnRuleModelInTable = function(Model)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var model = new UlrAsnDscpRuleModel(Model);

    var data = table.find(function(obj)
    {
        return obj._id == model._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        table.updateItem(data.id, model);
        table.select(data.id)
    }
    else
    {
        model.id = webix.uid();
        table.add(model,0);
        table.select(model.id);
        table.hideOverlay();
        table.hideProgress();
    }

};

UlrAsnDscpRulesViewController.prototype.DscpReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit')
    {
        //var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

        //table.editCell(Id, "priority");

        _this.ShowEditForm();
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        if(_this.RuleType == UlrRulesTypesCodesEnum.ip_exclude)
                            _this.ViewModel.DeleteIpDscpRule(data);
                        else
                            _this.ViewModel.DeleteAsnDscpRule(data);
                    }
                }
            ]
        });
    }
};

UlrAsnDscpRulesViewController.prototype.DscpReportOnCheck = function(Row, Column, State)
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.getItem(Row);

    var func = "EnableDisableAsnDscpRule";

    if(this.RuleType == UlrRulesTypesCodesEnum.ip_exclude)
        func = "EnableDisableIpDscpRule";

    this.ViewModel[func](webix.extend(data, {callback:function (R)
        {
            if(!R.success)
            {
                data.enabled = State ? 0 : 1;

                table.updateItem(data.id, data);
            }
        }}), State);
};

UlrAsnDscpRulesViewController.prototype.DscpReportReportOnSuccessDelete = function(AsnDscpModel)
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == AsnDscpModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }

};

UlrAsnDscpRulesViewController.prototype.AsnDscpRuleEnableStateUpdated = function(AsnDscpModel)
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.find(function(obj)
    {
        return obj._id == AsnDscpModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = parseInt(AsnDscpModel.enabled);
        table.updateItem(data.id, data);
    }

};

// UlrAsnDscpRulesViewController.prototype.DscpReportSaveSelectedRow = function()
// {
//     var table = this.Views.ReportsWidgets.DscpReport.Views.Table;
//
//     var data = table.getSelectedItem();
//
//     if(data)
//         this.JustSaveRule(data);
// };

UlrAsnDscpRulesViewController.prototype.ShowEditForm = function()
{
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    if(this.RuleType === UlrRulesTypesCodesEnum.asn_lock && data.priority)
    {
        var dscp = data.priority.split(" ");
        if(dscp.length == 1)
        {
            var val = dscp[0];
            var dscp_opt = this.GetPriorityOptions();
            var index = dscp_opt.findIndex(Obj => Obj.id === val);
            if(index >= 0)
            {
                data.priority = val;
                data.asn_tags = "";
            }
            else
            {
                data.priority = "";
                data.asn_tags = val;
            }
        }
        else if (dscp.length > 0)
        {
            data.priority = dscp[0];
            data.asn_tags = dscp[1];
        }
    }

    this.Views.EditPopupAddDSCPForm.clear();
    this.Views.EditPopupAddDSCPForm.clearValidation();

    this.Views.EditPopupAsnLabel.define("label", data.protocol);
    this.Views.EditPopupAsnLabel.refresh();
    this.Views.EditPopupAddDSCPForm.setValues(data);

    if (this.EditPopupIspsList)
    {
        var ispsVals = {};

        data.isps.split(",").forEach(function (Item)
        {
            if(Item && parseInt(Item) > 0)
            {
                ispsVals[""+parseInt(Item)] = 1;
            }
        });

        this.EditPopupIspsList.Views.ISPListForm.setValues(ispsVals);
        this.EditPopupIspsList.Views.RuleModeToggle.setValue(parseInt(data.mode_id));
    }

    // var node = table.getItemNode({ row: table.getSelectedId(), column:"edit"});
    // this.EditPopup.show(node, {pos:"left"});

    this.EditPopup.show();
};

UlrAsnDscpRulesViewController.prototype.SaveEditForm = function()
{
    this.Views.EditPopupAddDSCPForm.clearValidation();
    var _this = this;
    var table = this.Views.ReportsWidgets.DscpReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    if(!this.Views.EditPopupAddDSCPForm.validate())
    {
        return;
    }

    var priority = this.Views.EditPopupPriorityInput.getValue();

    if(_this.RuleType === UlrRulesTypesCodesEnum.asn_lock)
    {
        var asn_tags = this.Views.EditPopupAsnTagsInput.getValue();

        if(!priority && !asn_tags)
        {
            this.Views.EditPopupAddDSCPForm.markInvalid('priority');
            this.Views.EditPopupAddDSCPForm.markInvalid('asn_tags');
            return;
        }

        priority = (priority ? priority : "") + " " + (asn_tags ? asn_tags : "");
    }

    var mode = this.EditPopupIspsList ? this.EditPopupIspsList.getMode() : UlrWebRuleModesEnum.all_isps;

    var model = {
        priority:priority,
        name:this.Views.EditPopupRuleNameInput.getValue(),
        description:this.Views.EditPopupRuleDescriptionInput.getValue(),
        rule_type_id:this.RuleTypeId,
        mode_id: mode == UlrWebRuleModesEnum.only_isps_in_list ? UlrWebRuleModesEnum.only_isps_in_list : UlrWebRuleModesEnum.all_isps,
        isps: []
    };


    if(model.mode_id == UlrWebRuleModesEnum.only_isps_in_list)
    {
        var isps = this.EditPopupIspsList.Views.ISPListForm.getValues();
        Object.keys(isps).forEach(function(Key){
            if(isps[Key] == 1)
            {
                model.isps.push(Key);
            }
        });
    }

    model.isps = model.isps.join(",");

    this.JustSaveRule(webix.extend(data, model, true));
};

UlrAsnDscpRulesViewController.prototype.GetPriorityOptions  = function()
{
    var _this = this;

    var dic = Helper.DictToArr(AsnDscpDic);
    if(_this.RuleType !== UlrRulesTypesCodesEnum.asn_lock)
    {
        return dic;
    }
    var r = [{id:"", value:"", $empty:true}];

    dic.forEach(Obj => {
        if(Obj.id.includes("cs") || Obj.id.includes("af") || Obj.id.includes("ef"))
        {
            r.push(Obj);
        }
    });

    return r;
}

UlrAsnDscpRulesViewController.prototype.GetDscpTagsOptions = function()
{
    var _this = this;
    if(_this.RuleType !== UlrRulesTypesCodesEnum.asn_lock)
    {
        return [];
    }

    var dic = Helper.DictToArr(AsnDscpDic);

    var r = [];

    dic.forEach(Obj => {
        if(!(Obj.id.includes("cs") || Obj.id.includes("af") || Obj.id.includes("ef")))
        {
            r.push(Obj);
        }
    });

    return r;
};
let UrlAsnDscpRuleResourcesTableWidget = function (Params)
{
    let params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:"UrlASResourcesTableWidget",
        hideExport:true,
        enableTextSearch:Params.enableTextSearch ? true : false,
        enableAutoHeight:Params.enableAutoHeight ? true : false,
        // hidePaginatorToolbar:true,
        enableCheckboxRefresh:true,
        enableLocalSort:Params.enableLocalSort ? true : false,
        enableLocalDataSource:Params.enableLocalDataSource ? true : false,
        config:{
            model:UlrASResourceModel,
            method:function ()
            {
                return "UlrGetASResourcesList";
            },
            sort:{id:"update_time",dir:"desc"},
            dataSource:function (FilterParams)
            {
                if(Params&&Params.dataSource)
                    return Params.dataSource(FilterParams);
            }
        },
        columns: function ()
        {
            var cols = [];

            cols.push.apply(cols,[
                {
                    id: "enabled",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellCheckboxSwitchOnOffTemplate
                },
                {
                    id: "resource",
                    header: [LangHelper.GetString("UlrModule","CIDR")],
                    sort: "string",
                    fillspace: 1
                },
                {
                    id: "type_id",
                    header: [LangHelper.GetString("UlrModule","Prefix type")],
                    sort: "text",
                    fillspace: 1,
                    template:function (Obj)
                    {
                        var dic = PrefixTypeDic[Obj.type_id];
                        return dic ? dic.value : Obj.type_id;
                    }
                },
                {
                    id: "bgp_diff_autoapply",
                    header: [LangHelper.GetString("UlrModule", "BGP diff auto apply")],
                    sort: "text",
                    fillspace: 1,
                    template: function (Obj) {
                        return parseInt(Obj.bgp_diff_autoapply) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled");
                    }
                },
                {
                    id: "protocol_version",
                    header: [LangHelper.GetString("UlrModule", "IP version")],
                    sort: "text",
                    fillspace: 1,
                    template: function (Obj) {

                        var res = "";

                        if(Obj && Obj.protocol_version && Obj.type_id == PrefixTypeMapEnum.BGP)
                        {
                            res = UlrIpProtocolVersionDic[Obj.protocol_version] && UlrIpProtocolVersionDic[Obj.protocol_version].value ? UlrIpProtocolVersionDic[Obj.protocol_version].value : "";
                        }

                        return res;
                    }
                },
                {
                    id: "state_valid",
                    header: [LangHelper.GetString("UlrModule","State")],
                    sort: "text",
                    fillspace: 1,
                    template:function(Obj)
                    {
                        if(Obj.is_added)
                            return LangHelper.GetString("UlrModule","Just added")
                        
                        var bind = Obj.state_valid > 0 || Obj.state_error > 0 ? LangHelper.GetString("UlrModule","Binded") : LangHelper.GetString("UlrModule","Unbinded");

                        var valid = Obj.state_valid == 2 ? LangHelper.GetString("UlrModule","Valid") : (Obj.state_valid == 1 ? '<span class="text_style_error">' + LangHelper.GetString("UlrModule","Invalid") + '</span>' : "");

                        return bind + (valid ? ", " + valid : "");
                    }
                },
                // {
                //     id: "bgp_send_notification",
                //     header: [LangHelper.GetString("UlrModule", "BGP diff notification")],
                //     sort: "text",
                //     fillspace: 1,
                //     template: function (Obj) {
                //
                //         var arr = [];
                //
                //         Obj.bgp_send_notification.split(",").forEach(function(Val)
                //         {
                //            if(UlrBgpDiffNotifications[Val] && UlrBgpDiffNotifications[Val].value)
                //            {
                //                arr.push(UlrBgpDiffNotifications[Val].value)
                //            }
                //         });
                //
                //         return arr.join(", ");
                //     }
                // },
                {
                    id: "list",
                    header: "",
                    sort: "false",
                    width: 32,
                    template: function(Obj)
                    {
                        if(Obj.type_id == PrefixTypeMapEnum.BGP)
                        {
                            return CellListBtnTemplate();
                        }

                        return "";
                    }
                },
                {
                    id: "delete",
                    header:"",
                    sort: false,
                    width:32,
                    template:CellTrashBtnTemplate
                },
                {
                    sort: false,
                    width:16
                }
            ]);
            return cols;
        }(),
        rules:{},
        filter:{},
        sort_map:{},
        defaultPageSize:10,
        on:{},
        minHeight:40
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };

        params.on.onCheck = function(row, column, state)
        {
            Params.onItemClick({
                row: row,
                column: column
            });
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

function UlrEditAsnDscpRuleViewController(Params)
{
    var _this = this;

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.Action = Params&&Params.action&&this.ActionsEnum[Params.action]?this.ActionsEnum[Params.action]:this.ActionsEnum.Edit;

    this.Id = "UlrAddAsnDscpRule";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule", "ASN filter"),
        Title:LangHelper.GetString("UlrModule","Edit AS")
    };

    this.ViewModel = new UlrEditAsnDscpRuleManager();

    this.ReportsModel = new UniReportsManager();

    this.IspsList = new UlrIspSubscribersListViews({id: this.Id + "IspsList", IspType: IspsSubscribersListTypes.isp, ViewModel: this.ReportsModel, hidden: AppEnv.DisableISPSwitchForASNBlocks ? true : false});

    // this.IspsList = new UlrIspListViews();

    this.NetworksForm = new UlrAddNetworksViewController({
        Id: this.Id,
        EditViewMode: false,
        ViewModel: this.ViewModel,
        ReportsModel: this.ReportsModel,
        HeaderTitle: LangHelper.GetString("UlrModule","Resource")
    });

    this.Views = {
        ScrollView:null,
        PageTitle:null,
        RuleEditForm:null,
        RuleEditFormEnabledStateView:null,
        RuleEditFormEnabledSpacerView:null,
        AddResourceForm:null,
        AddResourceInput:null,
        AddResourceBtn:null,
        ClearAllResources:null,
        FileImportBtn:null,
        RuleModeToggle:null,
        SaveBtn:null,
        SaveEnableBtn:null,
        SaveDisableBtn:null,
        DeleteBtn:null,
        ValidationResultLabel:null,

        ImportPopupForm:null,
        ImportPopupTable:null,
        ImportPopupUploader:null,
        ImportPopupEditor:null,
        ImportPopupBtn:null,

        AddedResourcesSection: null,
        ResourcesSection: null,

        Widgets:{},
        ReportsWidgets:{
            ResourcesReport: UrlAsnDscpRuleResourcesTableWidget({
                id:this.Id + "ResourcesReport",
                enableTextSearch:1,
                enableAutoHeight:1,
                defaultPageSize: 10,
                hidePaginatorToolbar:0,
                enableLocalSort:0,
                onItemClick:function (Id) {
                    _this.ResourcesReportOnItemClick(Id.row, Id.column);
                }
            }),
            AddedResourcesReport: UrlAsnDscpRuleResourcesTableWidget({
                id: this.Id + "AddedResourcesReport",
                enableTextSearch:0,
                enableAutoHeight:1,
                // hidePaginatorToolbar:1,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource: 1,
                dataSource: function(FilterParams)
                {
                    var res = {
                        count: _this.AddedResources.length,
                        page: FilterParams.Params.page,
                        size: _this.Views.ReportsWidgets.AddedResourcesReport.Views.Paging.config.size,
                        rows: []
                    };

                    var sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : 'id';
                    var sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : 'asc';

                    var sort_val = sort_dir == 'asc' ? 1 : -1;


                    _this.AddedResources.sort((a, b) => {
                        var val_a = a[sort_prop];
                        var val_b = b[sort_prop];

                        if(typeof val_a == 'string' || typeof val_b == 'string')
                        {
                            if(sort_val > 0)
                            {
                                return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                            }
                            else
                            {
                                return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                            }
                        }
                        else if(typeof val_a == 'number' || typeof val_b == 'number')
                        {
                            return sort_val * val_a + (-1) * sort_val * val_b;
                        }

                        return -1;
                    });

                    const start_index = res.page * res.size;
                    var finish_index = start_index + res.size;

                    if(finish_index > (_this.AddedResources.length - 1))
                    {
                        res.rows = _this.AddedResources.slice(start_index);
                    }
                    else
                    {
                        res.rows = _this.AddedResources.slice(start_index, finish_index);
                    }

                    return res;
                },
                onItemClick:function (Id) {
                    _this.AddedResourcesReportOnItemClick(Id);
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({
                                id:this.Id + "PageTitle",
                                root_title:this.PageTitle.Title
                            }),
                            {height:32},
                            {
                                view:"form",
                                id:this.Id + "RuleEditForm",
                                type: "wide",
                                borderless:true,
                                elements:[
                                    {
                                        cols:[
                                            {
                                                view:"spectre_captionlabel",
                                                name:"rule_id",
                                                caption:LangHelper.GetString("UlrModule","AS id")
                                            },
                                            {
                                                id:this.Id + "RuleEditFormEnabledSpacerView",
                                                css:"form_info_label_spacer",
                                                borderless:true,
                                                width:20,
                                                template:"",
                                                hidden:true
                                            },
                                            {
                                                view:"spectre_captionlabel",
                                                id:this.Id + "RuleEditFormEnabledStateView",
                                                name:"enabled",
                                                caption:LangHelper.GetString("UlrModule","Status"),
                                                template:function (Obj)
                                                {
                                                    return "<span class='caption'>"+Obj.caption+":</span> <span class='value'>"+(parseInt(Obj.value) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled"))+"</span>";
                                                },
                                                hidden:true
                                            }
                                        ]
                                    },
                                    {
                                        view:"spectre_text",
                                        name:"as_number",
                                        label:LangHelper.GetString("UlrModule","AS number"),
                                        required:true,
                                        validate: webix.rules.isNotEmpty,
                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                        disabled: _this.Action == _this.ActionsEnum.Edit,
                                        on: {
                                            onChange:function(nVal)
                                            {
                                                let value = nVal > 0 ? nVal : "";
                                                this.setValue(value);
                                            }
                                        }
                                    },
                                    {
                                        view:"spectre_text",
                                        name:"name",
                                        label:LangHelper.GetString("UlrModule","AS name"),
                                        required:true,
                                        validate: webix.rules.isNotEmpty,
                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field")
                                    },
                                    {
                                        rows:[
                                            {
                                                view:"spectre_textarea",
                                                name:"description_public",
                                                label:LangHelper.GetString("UlrModule","Description"),
                                                required:true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                        {
                                                            if(Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                view:"label",
                                                css:"form_text_description_label",
                                                label:LangHelper.GetString("UlrModule","This is internal description helps you to find this AS to edit or change state")
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                height:48
                            },
                            {
                                type:"wide",
                                rows: //[
                                    this.NetworksForm.ViewConfig
                                    // BlockHeaderTemplate({
                                    //     title:LangHelper.GetString("UlrModule","Resource"), icon:"",
                                    //     borderless:true
                                    // }),
                                    // {
                                    //     view:"form",
                                    //     id:this.Id + "AddResourceForm",
                                    //     type: "wide",
                                    //     elements:[
                                    //         {
                                    //             type:"clean",
                                    //             rows:[
                                    //                 {
                                    //                     view:"label",
                                    //                     css:"form_text_label",
                                    //                     label:LangHelper.GetString("UlrModule","Enter CIDR to this field.")
                                    //                 },
                                    //                 {
                                    //                     type: "wide",
                                    //                     cols:[
                                    //                         {
                                    //                             view:"spectre_text",
                                    //                             id:this.Id + "AddResourceInput",
                                    //                             name:"resource_raw",
                                    //                             label:LangHelper.GetString("UlrModule","Resource"),
                                    //                             keyPressTimeout:300,
                                    //                             on:{
                                    //                                 onTimedKeyPress:function()
                                    //                                 {
                                    //                                     _this.DefineValidationResult(this.getValue());
                                    //                                 }
                                    //                             }
                                    //                         }
                                    //                     ]
                                    //                 },
                                    //                 {
                                    //                     height:20
                                    //                 },
                                    //                 {
                                    //                     type:"wide",
                                    //                     rows:[
                                    //                         {
                                    //                             view:"label",
                                    //                             id:this.Id + "ValidationResultLabel",
                                    //                             css:"slide_down_box form_state",
                                    //                             caption:LangHelper.GetString("UlrModule","Validation result"),
                                    //                             icon:"check",
                                    //                             value:"",
                                    //                             template:"<div class='row'><div class='caption'><span class='webix_icon form_state_icon fa-#icon#'></span>#caption#: </div><div class='value'>#value#</div></div>",
                                    //                             height:70,
                                    //                             hidden:true
                                    //                         },
                                    //                         {
                                    //                             type:"wide",
                                    //                             cols:[
                                    //                                 {
                                    //                                     view:"spectre_button",
                                    //                                     id:this.Id + "AddResourceBtn",
                                    //                                     type:"icon",
                                    //                                     css:"form_button spec_action with_icon",
                                    //                                     label:LangHelper.GetString("UlrModule","Add to list"),
                                    //                                     icon:"plus-circle",
                                    //                                     autowidth:true,
                                    //                                     disabled:true,
                                    //                                     click:function ()
                                    //                                     {
                                    //                                         let resource = _this.Views.AddResourceInput.getValue();
                                    //                                         _this.JustAddResource(resource);
                                    //                                     }
                                    //                                 },
                                    //                                 {
                                    //                                     view:"spectre_button",
                                    //                                     id:this.Id + "FileImportBtn",
                                    //                                     type:"icon",
                                    //                                     css:"form_button spec_action with_icon",
                                    //                                     label:LangHelper.GetString("UlrModule","Import from file"),
                                    //                                     icon:"arrow-left",
                                    //                                     autowidth:true,
                                    //                                     click:function ()
                                    //                                     {
                                    //                                         _this.ShowImportForm();
                                    //                                     }
                                    //                                 },
                                    //                                 {}
                                    //                             ]
                                    //                         }
                                    //                     ]
                                    //                 }
                                    //             ]
                                    //         }
                                    //     ]
                                    // }
                                //]
                            },
                            {
                                height:48
                            },
                            {
                                id: this.Id + "AddedResourcesSection",
                                hidden: true,
                                rows:[
                                    {
                                        type:"wide",
                                        rows:[
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","Just added"), icon:"",
                                                borderless:true
                                            }),
                                            this.Views.ReportsWidgets.AddedResourcesReport.ViewConfig
                                        ]
                                    },
                                    {height:32},
                                ]
                            },
                            {
                                id: this.Id + "ResourcesSection",
                                hidden: true,
                                rows:[
                                    {
                                        type:"wide",
                                        rows:[
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","List of resourses"), icon:"",
                                                borderless:true
                                            }),
                                            this.Views.ReportsWidgets.ResourcesReport.ViewConfig,
                                            {
                                                cols:[
                                                    {
                                                        view:"spectre_button",
                                                        id:this.Id+"ClearAllResources",
                                                        css:"form_button spec_action",
                                                        label:LangHelper.GetString("UlrModule","Clear all"),
                                                        autowidth:true,
                                                        click:function ()
                                                        {
                                                            _this.ClearResources();
                                                        }
                                                    },
                                                    {}
                                                ]
                                            }
                                        ]
                                    },
                                    {height:32},
                                ]
                            },

                            ...this.IspsList.ViewConfig,
                            {
                                height:32
                            },
                            {
                                type:"wide",
                                cols:[
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveBtn",
                                        css:"form_button main_action",
                                        label:LangHelper.GetString("UlrModule","Save changes"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save();
                                        }
                                    },
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveEnableBtn",
                                        css:"form_button second_action",
                                        label:LangHelper.GetString("UlrModule","Save and enable"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save(true);
                                        },
                                        hidden:true
                                    },
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveDisableBtn",
                                        css:"form_button second_action",
                                        label:LangHelper.GetString("UlrModule","Save and disable"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save(false);
                                        },
                                        hidden:true
                                    },
                                    {},
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "DeleteBtn",
                                        css:"form_button delete_action",
                                        label:LangHelper.GetString("UlrModule","Delete AS"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Delete();
                                        },
                                        hidden:true
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.ImportPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ImportPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Import resources"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.ImportPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ImportPopupForm",
                            type: "wide",
                            minWidth:560,
                            minHeight:400,
                            elements: [
                                {
                                    view:"datatable",
                                    id: this.Id + "ImportPopupTable",
                                    header:false,
                                    hidden:true,
                                    columns:[
                                        {
                                            id:"type_id"
                                        },
                                        {
                                            id:"resource_raw"
                                        },
                                        {
                                            id:"resource_validated"
                                        }
                                    ]
                                },
                                {
                                    view: "uploader",
                                    value: LangHelper.GetString("UlrModule","Click to upload or drag a file here"),
                                    id: this.Id+"ImportPopupUploader",
                                    css:"upload_area form_button spec_action",
                                    autosend:false,
                                    height:64
                                },
                                {
                                    view:"spectre_textarea",
                                    id:this.Id + "ImportPopupEditor",
                                    label:LangHelper.GetString("UlrModule","File or clipboard content to import"),
                                    height:undefined,
                                    value:""
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ImportPopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Import"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ImportFile();
                                            _this.ImportPopup.hide();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.Subscriptions = {};

    this.Signals = {
        ProfileEnabled: new Rx.BehaviorSubject(0),

        ShowAddedResources: new Rx.BehaviorSubject(0),
        ShowResources: new Rx.BehaviorSubject(0)
    };

    this.AddedResources = [];
    this.ModifiedResources = [];
    this.DeletedResources = [];
    this.DeleteAllResources = false;

    this.Views.ReportsWidgets.ResourcesReport.DataAdapter = function(Data)
    {
        var res = Data;

        if(res.rows && Array.isArray(res.rows))
        {
            res.rows.forEach((row, i) =>{
                const item = _this.ModifiedResources.find(obj => obj._id == row._id);

                if(item && item.enabled != row.enabled)
                {
                    res.rows[i].enabled = item.enabled;
                }
            });
        }

        return res;
    };
}

UlrEditAsnDscpRuleViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.ImportPopup = webix.ui(this.ImportPopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.ImportPopupUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        var reader = new FileReader();

        reader.onload = function(e)
        {
            _this.Views.ImportPopupEditor.setValue(reader.result);
        };

        reader.readAsText(FileObj.file, "utf-8");

    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress) {
        var view = _this.Views.SaveBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveEnableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveDisableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.DeleteBtn;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions.ProfileEnabled = this.Signals.ProfileEnabled.subscribe(function (Enabled) {
        var view = _this.Views.SaveDisableBtn;
        Enabled ? view.show() : view.hide();

        var view = _this.Views.SaveEnableBtn;
        !Enabled ? view.show() : view.hide();
    });

    this.Subscriptions.ASProfileUpdated = this.ViewModel.Signals.ASProfileUpdated.subscribe(function (Model) {
        if(Model)
        {
            _this.DefineAll(Model);
        }
    });

    this.Subscriptions.ASProfileSaved = this.ViewModel.Signals.ASProfileSaved.subscribe(function (Model)
    {
        if(Model)
        {
            if (Model.insert_stat && Model.insert_stat.total && Model.insert_stat.duplicate)
            {
                UlrShowAlertWindow({
                    actions: [
                        {
                            label: LangHelper.GetString("UlrModule", "Close"),
                            click: function ()
                            {
                                setTimeout(function ()
                                {
                                    App.NavRouter.PresentView({id: ControllersEnum.UlrAsnRuleList});
                                }, 1);
                            }
                        }
                    ],
                    on_close: function ()
                    {
                        setTimeout(function ()
                        {
                            App.NavRouter.PresentView({id: ControllersEnum.UlrAsnRuleList});
                        }, 1);
                    },
                    head: LangHelper.GetString("UlrModule", "Save result"),
                    mainTitle: LangHelper.GetString("UlrModule", "Save prefixes result"),
                    message: "<br/><span class='ulr-insert-stat'><b>" + LangHelper.GetString("UlrModule", "Total prefixes") + "</b>: " + Model.insert_stat.total + "<br/>" +
                        "<b>" + LangHelper.GetString("UlrModule", "Inserted prefixes") + "</b>: " + Model.insert_stat.inserted + "<br/>" +
                        "<b>" + LangHelper.GetString("UlrModule", "Skipped / duplicates prefixes") + "</b>: <a href='" + Model.insert_stat.duplicate_url + "'>" + Model.insert_stat.duplicate + "</a><br/></span>"
                });
            }
            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule", "AS") + " # " + Model.profile.rule_id + ": " + LangHelper.GetString("UlrModule", "Saving"),
                    LangHelper.GetString("UlrModule", "Success")
                );


                setTimeout(function ()
                {
                    App.NavRouter.PresentView({id: ControllersEnum.UlrAsnRuleList});
                }, 1);
            }
        }
    });

    this.Subscriptions.ASProfileDeleted = this.ViewModel.Signals.ASProfileDeleted.subscribe(function (Model)
    {
        if(Model)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", "AS")+" #"+Model._id+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: ControllersEnum.UlrAsnRuleList});
            },1);
        }
    });

    this.Subscriptions.ASProfileUpdateError = this.ViewModel.Signals.ASProfileUpdateError.subscribe(function (ErrModel)
    {
        var action = null;

        if(ErrModel&&ErrModel.code == 404)
        {
            action = function ()
            {
                setTimeout(function ()
                {
                    App.NavRouter.PresentView({id:  ControllersEnum.UlrAsnRuleList});
                }, 1);
            }
        }

        _this.ShowServerError(ErrModel, action);
    });

    this.Subscriptions.ASProfileUpdateError = this.ViewModel.Signals.ASProfileSaveError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.ASProfileUpdateError = this.ViewModel.Signals.ASProfileError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.ASProfileUpdateError = this.ViewModel.Signals.ASProfileDeleteError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NetworkToSave = this.NetworksForm.Signals.AddNetwork.subscribe(function(NetworkModel)
    {
        if(NetworkModel)
        {
            _this.JustAddResource(NetworkModel);
            // console.log(NetworkModel);
            // _this.AddNetwork(NetworkModel);
        }
    });

    this.Subscriptions.ShowAddedResources = this.Signals.ShowAddedResources.subscribe(function(Show)
    {
        Show ? _this.Views.AddedResourcesSection.show() : _this.Views.AddedResourcesSection.hide();
    });

    this.Subscriptions.ShowResources = this.Signals.ShowResources.subscribe(function(Show)
    {
        Show ? _this.Views.ResourcesSection.show() : _this.Views.ResourcesSection.hide();
    });

    this.Subscriptions.AddMultipleResources = this.NetworksForm.Signals.AddMultipleNetworks.subscribe(function(Val)
    {
        if(Val)
        {
            _this.AddMultipleResources(Val);
        }
    });
};

UlrEditAsnDscpRuleViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.NetworksForm.ViewDidLoad(PathParams);

    this.PathParams = PathParams;

    this.IspsList.ViewDidLoad(PathParams);

    this.BindAll(PathParams);

    this.Signals.ShowAddedResources.next(this.Action == this.ActionsEnum.Add)
    this.Signals.ShowResources.next(this.Action != this.ActionsEnum.Add)

    this.Refresh();
};

UlrEditAsnDscpRuleViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if(this.IspsList)
    {
        this.IspsList.Destroy();
    }

    if(this.NetworksForm)
    {
        this.NetworksForm.Destroy();
    }
};

UlrEditAsnDscpRuleViewController.prototype.RefreshRuleProfile = function ()
{
    var id = this.Action == this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    this.ViewModel.RefreshASProfile({_id: id});

    this.DefinePageTitle((this.Action == this.ActionsEnum.Add ? LangHelper.GetString("UlrModule","Add AS") : LangHelper.GetString("UlrModule","Edit AS")) + " #" + id);

    if(this.Action == this.ActionsEnum.Edit)
    {
        this.Views.RuleEditFormEnabledStateView.show();
        this.Views.RuleEditFormEnabledSpacerView.show();
        this.Views.DeleteBtn.show();

        this.RefreshResources();
    }
};

UlrEditAsnDscpRuleViewController.prototype.RefreshResources = function()
{
    if(this.Action != this.ActionsEnum.Add && this.GetPathParam("_id"))
    {
        var filter = {
            rule_id: {
                id: "rule_id",
                operator: "=",
                value: this.GetPathParam("_id")
            },
            resource: {
                id: "resource",
                operator: "!=",
                value: 'null'
            }
        };

        this.Views.ReportsWidgets.ResourcesReport.RefreshData(null,{
            filter: filter
        });
    }
};

UlrEditAsnDscpRuleViewController.prototype.Refresh = function ()
{
    this.RefreshRuleProfile();
};

UlrEditAsnDscpRuleViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrEditAsnDscpRuleViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

UlrEditAsnDscpRuleViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditAsnDscpRuleViewController.prototype.DefinePageTitle = function(Title)
{
    this.Views.PageTitle.define("data", {root_title:Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

UlrEditAsnDscpRuleViewController.prototype.DefineAll = function(Model)
{
    let _this = this;

    let enabled = parseInt(Model.profile.enabled)?1:0;

    this.Signals.ProfileEnabled.next(enabled);

    let form = this.Views.RuleEditForm;
    form.clear();
    form.setValues(Model.profile);

    var ispsVals = {};

    Model.profile.isps.split(",").forEach(function (Item)
    {
        if(Item && parseInt(Item) > 0)
        {
            ispsVals[""+parseInt(Item)] = 1;
        }
    });

    _this.IspsList.setForm(ispsVals, parseInt(Model.profile.mode_id));
};

UlrEditAsnDscpRuleViewController.prototype.AddMultipleResources = function(Arr)
{
    if(Arr && Array.isArray(Arr) && Arr.length)
    {
        Arr.forEach((Model) => {

            let model = new UlrASResourceModel({
                resource: Model.cidr_ipv4 ? Model.cidr_ipv4 : Model.cidr_ipv6,
                type_id: PrefixTypeMapEnum.CIDR,
                enabled: 1
            });

            this.AddedResources.push(model);
        });

        this.ShowHideAddedResourcesTable();

        this.Views.ReportsWidgets.AddedResourcesReport.RefreshData();
    }
};

UlrEditAsnDscpRuleViewController.prototype.JustAddResource = function(Resource)
{
    var resource = new UlrIspNetworkModel(Resource);

    // TODO: CHECK FOR UNIQUE
    // var is_not_uniq = function(Val)
    // {
    //     return table.find(function(obj){return obj.resource == Val;}).length > 0;
    // }
    //
    // if(resource.type_id == PrefixTypeMapEnum.CIDR && is_not_uniq(resource.cidr_ipv4 ? resource.cidr_ipv4 : resource.cidr_ipv6))
    // {
    //     this.NetworksForm.MarkCidrInvalid(LangHelper.GetString("UlrModule", "Dublicate entry"));
    //     return;
    // }
    //
    // if(resource.type_id == PrefixTypeMapEnum.BGP && is_not_uniq(resource.regex))
    // {
    //     this.NetworksForm.MarkRegexInvalid(LangHelper.GetString("UlrModule", "Dublicate entry"), LangHelper.GetString("UlrModule", "Dublicate entry"));
    //     return;
    // }

    let model = new UlrASResourceModel({
        resource: resource.type_id == PrefixTypeMapEnum.BGP ? resource.regex : (resource.cidr_ipv4 ? resource.cidr_ipv4 : resource.cidr_ipv6),
        type_id: resource.type_id,
        bgp_diff_autoapply: resource.type_id == PrefixTypeMapEnum.BGP ? resource.bgp_diff_autoapply : 0,
        bgp_send_notification: resource.type_id == PrefixTypeMapEnum.BGP ? resource.bgp_send_notification : '',
        protocol_version: resource.type_id == PrefixTypeMapEnum.BGP ? resource.protocol_version : UlrIpProtocolVersionDic.BOTH.id
    });

    this.AddedResources.push(model);

    this.ShowHideAddedResourcesTable();
    this.Views.ReportsWidgets.AddedResourcesReport.RefreshData();

    this.NetworksForm.ClearValidation();
};

UlrEditAsnDscpRuleViewController.prototype.ClearResources = function()
{
    var table = this.Views.ReportsWidgets.ResourcesReport.Views.Table;

    this.DeleteAllResources = true;

    var filter = {
        rule_id: {
            id: "rule_id",
            operator: "=",
            value: this.GetPathParam("_id")
        },
        rule_id_neq: {
            id: "rule_id",
            operator: "!=",
            value: this.GetPathParam("_id")
        }
    };

    this.Views.ReportsWidgets.ResourcesReport.ExternalFilter = filter;

    table.clearAll();
};

UlrEditAsnDscpRuleViewController.prototype.ResourcesReportOnItemClick = function(Row, Column)
{
    var _this = this;

    if(Column === 'enabled')
    {
        var table = this.Views.ReportsWidgets.ResourcesReport.Views.Table;

        var data = table.getItem(Row);

        this.ModifiedResources.push(data)
    }
    else if(Column === 'delete')
    {
        var table = this.Views.ReportsWidgets.ResourcesReport.Views.Table;

        var data = table.getItem(Row);

        table.remove(Row);

        this.DeletedResources.push(data);

        var filter = {
            rule_id: {
                id: "rule_id",
                operator: "=",
                value: this.GetPathParam("_id")
            }
        };

        var deleted = [];

        this.DeletedResources.forEach(item => {
            const _id = parseInt(item._id);

            if(_id)
            {
                deleted.push(_id);
            }
        });

        if(deleted.length > 0)
        {
            filter._ids = {
                id: "_id",
                operator: "not in",
                value: deleted
            };
        }

        this.Views.ReportsWidgets.ResourcesReport.ExternalFilter = filter;
    }
    else if(Column === 'list')
    {
        var data = this.Views.ReportsWidgets.ResourcesReport.Views.Table.getItem(Row);

        if(data.type_id != PrefixTypeMapEnum.BGP)
        {
            return;
        }

        var modal_title = data.resource;

        var table_params = {
            enableAutoHeight: false,
            enableTextSearch: true,
            is_modal: true,
            filter: {
                network_id: {
                    id: "resource_id",
                    operator: "=",
                    value: data._id
                }
            }
        };

        var table = new UlrBgpPrefixResourcesTable(table_params);

        UlrEditAppPolicingPopup({
            modal_title: modal_title
        }, table);
        table.Bind(_this, _this.ReportsModel);
        table.RefreshData();
    }
};

UlrEditAsnDscpRuleViewController.prototype.Save = function(Enable)
{
    let form = this.Views.RuleEditForm;

    if(!form.validate())
    {
        this.Views.ScrollView.scrollTo(0, 0);
        return;
    }

    let formData = form.getValues();

    if (!(parseInt(formData.as_number) > 0))
    {
        UlrShowMessage(
            "error",
            LangHelper.GetString("UlrModule", "AS number must be greater than 0"),
            LangHelper.GetString("UlrModule","Error")
        );

        return;
    }

    let model = new UlrASViewModel();

    model.profile = formData;
    model.profile.isps = '';
    model.profile.mode_id = parseInt(this.IspsList.Views.RuleModeToggle.getValue());

    if(model.profile.mode_id == 2)
    {
        model.profile.isps = this.IspsList.getSelectedIsps().join(",");
    }

    if(typeof Enable != "undefined")
        model.profile.enabled = Enable ? 1 : 0;

    let table = this.Views.ReportsWidgets.ResourcesReport.Views.Table;

    let resources = table.serialize();

    let key = 'resource';

    model.resources = {
        deleted: this.DeletedResources,
        added: this.AddedResources,
        modified: this.ModifiedResources,
        importFiles: this.NetworksForm.GetImportedFiles(),
        deleteAll: this.DeleteAllResources
    };

    this.ViewModel.SaveASProfile(model);
};

UlrEditAsnDscpRuleViewController.prototype.Delete = function()
{
    var _this = this;

    var model = this.ViewModel.Signals.ASProfileUpdated.getValue();

    UlrShowDialogPopup({
        node:this.Views.DeleteBtn.getNode(),
        position:"bottom",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    _this.ViewModel.DeleteAS(model);
                }
            }
        ]
    });
};

UlrEditAsnDscpRuleViewController.prototype.DefineValidationResult = function(Value)
{
    let view = this.Views.ValidationResultLabel;
    let node = view.getNode();

    let valid = Value && Helper.UlrValidateCidr(Value);
    let btn = this.Views.AddResourceBtn;

    Value?view.show():view.hide();

    let text = [];

    webix.html.removeCss(node, 'success');
    webix.html.removeCss(node, 'error');

    if(valid)
    {
        btn.enable();
        webix.html.addCss(node, 'success');
        view.define("icon","check");

        text.push(LangHelper.GetString("UlrModule","The CIDR address is valid."));
        text.push(LangHelper.GetString("UlrModule","You can add it to the list."));
    }
    else
    {
        btn.disable();
        webix.html.addCss(node, 'error');
        view.define("icon","times");

        text.push(LangHelper.GetString("UlrModule","The CIDR address is not valid."));
        text.push(LangHelper.GetString("UlrModule","Please enter the IPv4 or IPv6 CIDR in a proper format."));
        text.push(LangHelper.GetString("UlrModule","This will not work if you add this to the list."));
    }

    view.define("value",text.join("<br/>"));
    view.define("height", text.length*24 + 2*12);
    view.refresh();
    view.resize();
};

UlrEditAsnDscpRuleViewController.prototype.ShowHideValidationResult = function(Show)
{
    var view = this.Views.ValidationResultLabel;
    Show ? view.show() : view.hide();
};

UlrEditAsnDscpRuleViewController.prototype.ShowServerError = function(ErrModel, Action)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};

UlrEditAsnDscpRuleViewController.prototype.ImportFile = function ()
{
    var _this = this;

    var value = this.Views.ImportPopupEditor.getValue();

    if(!value)
        return;

    var lines = value.split(/\r|\n/);

    lines.forEach(function (Line)
    {
        if (Line && Helper.UlrValidateCidr(Line))
            _this.JustAddResource(Line);
    });

    this.Views.ImportPopupEditor.setValue("");
};

UlrEditAsnDscpRuleViewController.prototype.ShowImportForm = function(ImportType)
{
    var table = this.Views.ImportPopupTable.clearAll();

    this.Views.ImportPopupEditor.setValue("");

    this.ImportPopup.show();
};

UlrEditAsnDscpRuleViewController.prototype.AddedResourcesReportOnItemClick = function(Id)
{
    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.AddedResourcesReport.Views.Table;

        var item = table.getItem(Id);

        if(item)
        {
            const index = this.AddedResources.findIndex(x => x.id == item.id);
            if(index > -1)
            {
                this.AddedResources.splice(index, 1);
                this.Views.ReportsWidgets.AddedResourcesReport.RefreshData();
                this.ShowHideAddedResourcesTable();
            }
        }

        table.remove(Id);
    }
};

UlrEditAsnDscpRuleViewController.prototype.ShowHideAddedResourcesTable = function()
{
    this.Signals.ShowAddedResources.next(this.AddedResources.length > 0);
};

function UlrAddAsnDscpRuleViewController(Params)
{
    var params = webix.extend(Params,{
        action:"Add"
    },true);

    UlrAddAsnDscpRuleViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrAddAsnDscpRuleViewController,UlrEditAsnDscpRuleViewController);
function UlrAsnRuleListViewController(Params)
{
    var _this = this;

    this.Id = "UlrAsnRuleList";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule", "ASN filter"),
        Title:LangHelper.GetString("UlrModule","AS resource list")
    };

    this.ViewModel = new UlrEditAsnDscpRuleManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        FiltersForm:null,
        FilterApplyBtn:null,
        FilterClearBtn:null,
        ToggleIcon: null,
        AdditionalFiltersContainer: null,
        IspIdsInput: null,
        AsnList: null,
        AsnRulesList: null,
        EditorTabs: null,
        ResourceFilterField: null,

        Widgets:{
            DateRangePicker: new QoEDateRangePickerWidget({
                id:this.Id + "DateRangePicker",
                default_value:"empty"
            })
        },
        ReportsWidgets:{
            AsnRuleListReport: UrlAsnRuleListTableWidget({
                id:this.Id + "AsnRuleListReport",
                enableTextSearch:false,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.AsnRuleListReportOnItemClick(Id, E, Node);
                },
                onCheck:function (Row, Column, State)
                {
                    _this.AsnRuleListReportOnCheck(Row, Column, State);
                }
            }),
            AsnListReport: UlrAsnListTableWidget({
                id: `${this.Id}AsnListReport`,
                enableTextSearch: false,
                enableAutoHeight: 1,
                onItemClick:function (Id, E, Node)
                {
                    _this.AsnListReportOnItemClick(Id, E, Node);
                },
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title: this.PageTitle.Title}),
                            {height:32},
                            {
                                type: "wide",
                                borderless: true,
                                cols: [
                                    {
                                        view:"tabbar",
                                        id:this.Id + "Editor" + "Tabs",
                                        css: "ulr-tabbar",
                                        options: [
                                            {
                                                id: this.Id + "AsnList",
                                                value: LangHelper.GetString("UlrModule","Blocks")
                                            },
                                            {
                                                id: this.Id + "AsnRulesList",
                                                value: LangHelper.GetString("UlrModule","Resources")
                                            }
                                        ],
                                        on:{
                                            "onAfterTabClick":function(Id)
                                            {
                                                $$(Id).show();
                                                _this.RefreshTableReport();

                                                _this.SetTemplateForOpenedTab(Id);

                                                _this.SetLastOpenedTab(Id);
                                            }
                                        }
                                    },
                                    {
                                        gravity:3
                                    }
                                ]
                            },
                            {height:32},
                            {
                                view:"form",
                                id:this.Id + "FiltersForm",
                                type: "wide",
                                borderless:true,
                                on: {
                                    onSubmit: function(view, event) {
                                        _this.RefreshTableReport();
                                    }
                                },
                                elements:[
                                    {
                                        type: "wide",
                                        cols:[
                                            this.Views.Widgets.DateRangePicker.ViewConfig,
                                            {
                                                view:"spectre_text",
                                                name:"full_text_search",
                                                label:LangHelper.GetString("UlrModule","Search")
                                            },
                                            {
                                                view:"spectre_multiselect",
                                                name:"mode",
                                                label:LangHelper.GetString("UlrModule","Type"),
                                                options: Helper.DictToArr(UlrAsnRuleListTypes)
                                            },
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "template",
                                                autoheight: true,
                                                borderless: true,
                                                template: `<span class="custom-additional-filters">${LangHelper.GetString("UlrModule","All filters")}</span><span id=${_this.Id + "ToggleIcon"} class="webix_icon fa-angle-down"></span>`,
                                                onClick: {
                                                    "webix_template": function(id){
                                                        _this.ShowHideAdditionalFilters();
                                                    }
                                                }
                                            },
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        id: _this.Id + "AdditionalFiltersContainer",
                                        hidden: true,
                                        rows: [
                                            {
                                                type:"wide",
                                                cols:[
                                                    {
                                                        view:"spectre_text",
                                                        name:"rule_id",
                                                        label:LangHelper.GetString("UlrModule","ID")
                                                    },
                                                    {
                                                        view:"spectre_text",
                                                        name:"as_number",
                                                        label:LangHelper.GetString("UlrModule","AS number"),
                                                    },
                                                    {
                                                        view:"spectre_multiselect",
                                                        name:"rule_enabled",
                                                        label:LangHelper.GetString("UlrModule","State"),
                                                        options: Helper.DictToArr(BlStatusesDic)
                                                    }
                                                ]
                                            },
                                            {
                                                type:"wide",
                                                cols:[
                                                    {
                                                        type: "wide",
                                                        rows: [
                                                            {
                                                                view:"spectre_text",
                                                                id: this.Id + "ResourceFilterField",
                                                                name:"resource",
                                                                label:LangHelper.GetString("UlrModule","Resource")
                                                            },
                                                            {
                                                                view: "spectre_multiselect",
                                                                id: this.Id + "IspIdsInput",
                                                                name: "isp_id",
                                                                label: LangHelper.GetString("UlrModule", "Isps"),
                                                                options:{
                                                                    point:false,
                                                                    data:[]
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        type: "wide",
                                                        rows: [
                                                            {
                                                                view:"spectre_text",
                                                                name:"name",
                                                                label:LangHelper.GetString("UlrModule","Name")
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        type: "wide",
                                                        rows: [
                                                            {
                                                                view:"spectre_text",
                                                                name:"description_public",
                                                                label:LangHelper.GetString("UlrModule","Description")
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols: [
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "FilterApplyBtn",
                                                css:"form_button form_element main_action",
                                                label:LangHelper.GetString("UlrModule","Apply"),
                                                height:51,
                                                click:function ()
                                                {
                                                    _this.DisableEnableBtn("disable");
                                                    setTimeout(function ()
                                                    {
                                                        _this.RefreshTableReport();
                                                    },1);
                                                }
                                            },
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "FilterClearBtn",
                                                css:"form_button form_element third_action",
                                                label:LangHelper.GetString("UlrModule","Clear"),
                                                height:51,
                                                click:function ()
                                                {
                                                    _this.DisableEnableBtn("disable");
                                                    _this.ClearFiltersForm();

                                                    setTimeout(function ()
                                                    {
                                                        _this.RefreshTableReport();
                                                    },1);
                                                }
                                            },
                                            {}
                                        ]
                                    }
                                ],
                            },
                            {height:32},
                            {
                                type: "wide",
                                borderless:true,
                                rows:[
                                    {
                                        id: this.Id + "TabWrapper",
                                        animate: false,
                                        cells: [
                                            {
                                                id: this.Id + "AsnList",
                                                rows:[
                                                    this.Views.ReportsWidgets.AsnListReport.ViewConfig
                                                ]
                                            },
                                            {
                                                id: this.Id + "AsnRulesList",
                                                rows:[
                                                    this.Views.ReportsWidgets.AsnRuleListReport.ViewConfig
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.PathParams = {};

    this.Subscriptions = {};
}

UlrAsnRuleListViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.Widgets.DateRangePicker.SetValue(null,true);

    this.Subscriptions.ASProfileError = this.ViewModel.Signals.ASProfileError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.ASProfileDeleteError = this.ViewModel.Signals.ASProfileDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.ASProfileUpdated = this.ViewModel.Signals.ASProfileUpdated.subscribe(function (ASModel)
    {
        if(ASModel)
        {
            _this.ASProfileEnableStateUpdated(ASModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","AS profile")+" # "+ASModel.name+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.ASProfileDeleted = this.ViewModel.Signals.ASProfileDeleted.subscribe(function (Model)
    {
        if(Model)
        {
            _this.AsnRuleListReportOnSuccessDelete(Model);

            let table = _this.Views.ReportsWidgets.AsnRuleListReport.Views.Table;
            table.remove([table.getSelectedId()]);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","AS profile")+" # "+Model.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions[DicsEnum.UlrIspsDic] = App.DicsManager.Signal[DicsEnum.UlrIspsDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.IspIdsInput.getList().clearAll();

            let dicArr = [];

            Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrIspsDic)).forEach((Obj) => {
                dicArr.push({
                    id: Obj.id,
                    dic_id: Obj.dic_id,
                    value: Obj.value + " (" + Obj.igw_name + ")"
                });
            });

            if(dicArr && dicArr.length)
            {
                _this.Views.IspIdsInput.getList().clearAll();
                _this.Views.IspIdsInput.getList().parse(dicArr);
            }
        }
    });

    this.Subscriptions.DisableFiltersButtonResourcesList = this.ReportsModel.Reports[`${this.Id}AsnRuleListReport`].signal.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.DisableEnableBtn("enable");
        }
    });

    this.Subscriptions.DisableFiltersButtonAsnList = this.ReportsModel.Reports[`${this.Id}AsnListReport`].signal.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.DisableEnableBtn("enable");
        }
    });

    const tabId = this.GetLastOpenedTab();

    this.Views.EditorTabs.setValue(tabId);
    this.SetTemplateForOpenedTab(tabId);
    $$(tabId).show();

    App.DicsManager.Refresh({data: [DicsEnum.UlrIspsDic]});

    this.GetAllPathParam();
};

UlrAsnRuleListViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.PathParams = Params;

    this.BindAll(Params);

    this.RefreshTableReport();
};

UlrAsnRuleListViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrAsnRuleListViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrAsnRuleListViewController.prototype.AsnRuleListReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit' || ((Id.column === 'rule_id' || Id.column === 'as_number' || Id.column === 'name') && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.ReportsWidgets.AsnRuleListReport.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: ControllersEnum.UlrEditAsnDscpRule, path:"/_id=" + data.rule_id});
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.AsnRuleListReport.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteAS(data);
                    }
                }
            ]
        });
    }
};

UlrAsnRuleListViewController.prototype.AsnListReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit' || ((Id.column === 'rule_id' || Id.column === 'as_number' || Id.column === 'name') && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.ReportsWidgets.AsnListReport.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: ControllersEnum.UlrEditAsnDscpRule, path:"/_id=" + data.rule_id});
    }
};

UlrAsnRuleListViewController.prototype.AsnRuleListReportOnCheck = function(Row, Column, State)
{
    var table = this.Views.ReportsWidgets.AsnRuleListReport.Views.Table;

    var data = table.getItem(Row);

    this.ViewModel.EnableDisableASProfile(webix.extend(data, {callback:function (R)
        {
            if(!R.success)
            {
                data.enabled = State ? 0 : 1;

                table.updateItem(data.id, data);
            }
        }}), State);
};

UlrAsnRuleListViewController.prototype.ASProfileEnableStateUpdated = function(ASModel)
{
    var table = this.Views.ReportsWidgets.AsnRuleListReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == ASModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = ASModel.enabled;
        table.updateItem(data.id, data);
    }

};

UlrAsnRuleListViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrAsnRuleListViewController.prototype.AsnRuleListReportOnSuccessDelete = function(Model)
{
    var table = this.Views.ReportsWidgets.AsnRuleListReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == Model._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = 0;
        data.type_id = 0;
        data.type = "";
        data.create_time = null;
        data.description = "";
        table.updateItem(data.id, data);
    }
};

UlrAsnRuleListViewController.prototype.RefreshTableReport = function ()
{
    var filter = {};

    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(period)
    {
        var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

        if(period.start && period.end)
        {
            filter.period = {
                id:"update_time",
                operator:"between",
                value:[format(Helper.DateTimeToUTC(period.start)), format(Helper.DateTimeToUTC(period.end))]
            };
        }

        else if(period.start)
        {
            filter.period = {
                id:"update_time",
                operator:">=",
                value:format(Helper.DateTimeToUTC(period.start))
            };
        }

        else if(period.end)
        {
            filter.period = {
                id:"update_time",
                operator:"<=",
                value:format(Helper.DateTimeToUTC(period.end))
            };
        }
    }

    let filterFormVals = this.Views.FiltersForm.getValues();

    if(filterFormVals.full_text_search)
    {
        filter.full_text_search =
            {
                id:"full_text_search",
                operator:"like",
                value:filterFormVals.full_text_search
            };
    }

    if(filterFormVals.mode)
    {
        if (Array.isArray(filterFormVals.mode))
            filterFormVals.mode = filterFormVals.mode.join(',');

        filter.mode =
            {
                id:"mode_id",
                operator:"in",
                value:filterFormVals.mode.split(',')
            };
    }

    if(filterFormVals.rule_id)
    {
        filter.rule_id =
            {
                id:"rule_id",
                operator:"=",
                value:filterFormVals.rule_id
            };
    }

    if(filterFormVals.as_number)
    {
        filter.as_number =
            {
                id:"as_number",
                operator:"=",
                value:filterFormVals.as_number
            };
    }

    if(this.Views.EditorTabs.getValue() === `${this.Id}AsnRulesList`)
    {
        if(filterFormVals.rule_enabled)
        {
            if (Array.isArray(filterFormVals.rule_enabled))
                filterFormVals.rule_enabled = filterFormVals.rule_enabled.join(',');

            filter.rule_enabled =
                {
                    id:"rule_enabled",
                    operator:"in",
                    value: filterFormVals.rule_enabled.split(',').map(item => Number(item))
                };
        }

        if(filterFormVals.resource)
        {
            filter.resource =
                {
                    id:"resource",
                    operator:"like",
                    value:filterFormVals.resource
                };
        }
    } else {
        if(filterFormVals.rule_enabled)
        {
            if (Array.isArray(filterFormVals.rule_enabled))
                filterFormVals.rule_enabled = filterFormVals.rule_enabled.join(',');

            filter.rule_enabled =
                {
                    id:"enabled",
                    operator:"in",
                    value: filterFormVals.rule_enabled.split(',').map(item => Number(item))
                };
        }
    }

    if(filterFormVals.name)
    {
        filter.name =
            {
                id:"name",
                operator:"like",
                value:filterFormVals.name
            };
    }

    if(filterFormVals.description_public)
    {
        filter.description_public =
            {
                id: "description_public",
                operator: "like",
                value: filterFormVals.description_public
            };
    }

    if(filterFormVals.isp_id)
    {
        if (Array.isArray(filterFormVals.isp_id))
            filterFormVals.isp_id = filterFormVals.isp_id.join(',');

        filter.isp_id =
            {
                id:"isp_id",
                operator:"in",
                value:filterFormVals.isp_id.split(',')
            };
    }

    if(this.Views.EditorTabs.getValue() === `${this.Id}AsnRulesList`)
    {
        this.Views.ReportsWidgets.AsnRuleListReport.RefreshData(0,{filter:filter});
    }
    else{
        this.Views.ReportsWidgets.AsnListReport.RefreshData(0,{filter:filter});
    }

    this.SetAllPathParam(filter);
};

UlrAsnRuleListViewController.prototype.ClearFiltersForm = function ()
{
    const _this = this;

    const filters = _this.Views.FiltersForm.elements;

    _this.Views.Widgets.DateRangePicker.SetValue(null, true, "empty");

    for (const filter in filters) {
        filters[filter].setValue("");
    }
};

UlrAsnRuleListViewController.prototype.SetAllPathParam = function(filter)
{
    var period = this.Views.Widgets.DateRangePicker.GetValue();

    if(period)
    {
        this.SetPathParam("period", period);
    }

    if(filter)
    {
        if (filter.period)
            delete filter.period

        this.SetPathParam("filter", JSON.stringify(filter));
    }
};

UlrAsnRuleListViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

UlrAsnRuleListViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrAsnRuleListViewController.prototype.GetAllPathParam = function()
{
    try
    {
        const period = this.GetPathParam("period");
        this.Views.Widgets.DateRangePicker.SetValue(period,true);

        let filters = this.GetPathParam("filter");
        if(filters)
        {
            filters = JSON.parse(filters);
        }
        else{
            filters = {};
        }
        let excludedFilters = false;

        if (filters.full_text_search){
            this.Views.FiltersForm.elements["full_text_search"].setValue(filters["full_text_search"].value);
            excludedFilters = true;
        }

        if (filters.mode)
        {
            this.Views.FiltersForm.elements["mode"].setValue(filters["mode"].value);
            excludedFilters = true;
        }

        if (filters.rule_id)
            this.Views.FiltersForm.elements["rule_id"].setValue(filters["rule_id"].value);

        if (filters.as_number)
            this.Views.FiltersForm.elements["as_number"].setValue(filters["as_number"].value);

        if (filters.rule_enabled)
            this.Views.FiltersForm.elements["rule_enabled"].setValue(filters["rule_enabled"].value);

        if (filters.resource)
            this.Views.FiltersForm.elements["resource"].setValue(filters["resource"].value);

        if (filters.name)
            this.Views.FiltersForm.elements["name"].setValue(filters["name"].value);

        if (filters.description_public)
            this.Views.FiltersForm.elements["description_public"].setValue(filters["description_public"].value);

        if (filters.isp_id)
            this.Views.FiltersForm.elements["isp_id"].setValue(filters["isp_id"].value);

        if(Object.keys(filters).length && !excludedFilters)
            this.ShowHideAdditionalFilters(true);
    }
    catch(e){
        console.log('exception', e)
    }
};

UlrAsnRuleListViewController.prototype.ShowHideAdditionalFilters = function(hasFilters = null)
{
    const _this = this;

    const formContainer = _this.Views.AdditionalFiltersContainer;
    const toggleIcon = _this.Views.ToggleIcon;
    const child = toggleIcon.getNode().children[0].lastChild;

    const hideFilters = () => {
        formContainer.hide();
        child.classList.remove('fa-angle-up');
        child.classList.add('fa-angle-down');
    }

    const showFilters = () => {
        formContainer.show();
        child.classList.remove('fa-angle-down');
        child.classList.add('fa-angle-up');
    }

    if (hasFilters)
    {
        showFilters();
    }
    else
    {
        if (formContainer.isVisible()) {
            hideFilters();
        } else {
            showFilters();
        }
    }
}

UlrAsnRuleListViewController.prototype.GetLastOpenedTab = function()
{
    var val = localStorage.getItem('AsnRuleListSelectedTab');

    return val ? val : `${this.Id}AsnRulesList`;
}

UlrAsnRuleListViewController.prototype.SetLastOpenedTab = function(Val)
{
    localStorage.setItem('AsnRuleListSelectedTab', Val);
}

UlrAsnRuleListViewController.prototype.DisableEnableBtn = function (Action)
{
    const _this = this;

    _this.Views.FilterApplyBtn[Action]();
    _this.Views.FilterClearBtn[Action]();
}

UlrAsnRuleListViewController.prototype.SetTemplateForOpenedTab = function (TabId)
{
    var _this = this;

    if (TabId === `${_this.Id}AsnList`)
    {
        _this.Views.ResourceFilterField.hide();

        _this.Views.FilterApplyBtn.define("label", LangHelper.GetString("UlrModule","Search blocks"));
        _this.Views.FilterApplyBtn.refresh();
    }
    else
    {
        _this.Views.ResourceFilterField.show();

        _this.Views.FilterApplyBtn.define("label", LangHelper.GetString("UlrModule","Search resources"));
        _this.Views.FilterApplyBtn.refresh();
    }
};
function UlrAddNetworksViewController(Params)
{
    var _this = this;

    this.Id = "UlrAddNetworks" + (Params && Params.Id ? Params.Id : "NetworksForm");

    // this.EditViewMode = Params && Params.EditViewMode ? Params.EditViewMode : 0;

    this.ViewModel = Params && Params.ViewModel ? Params.ViewModel : (new UlrIspsManager());

    this.ReportsModel = Params && Params.ReportsModel ? Params.ReportsModel : (new UniReportsManager());

    this.Views = {
        AddNetworkPanel: null,
        AddNetworkForm: null,
        CIDRInput:null,
        COMMUNITYInput:null,
        ASPATHInput:null,
        AddNetworkBtn:null,
        AddPrefixTypeSelect:null,
        NetworksTextSearch:null,
        DiffAutoApply: null,
        DiffSendNotification: null,
        ProtocolVersion: null,
        Spacer: null,
        BgpPrefixHelpBtn: null,
        CidrPrefixHelpBtn: null,
        ImportBtn: null,
        FileImportBtn: null,
        ImportPopupForm: null,
        ImportPopupEditor: null,
        ImportFilesPopupForm: null,
        ImportFilesPopupUploader: null,

        Widgets:{},
        ReportsWidgets: {
            ImportedFilesReport: UrlImportedFilesTableWidget({
                id:this.Id + "ImportedFilesReport",
                enableTextSearch:0,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource: 1,
                dataSource: function(FilterParams)
                {
                    var res = {
                        count: _this.ImportFilesArr.length,
                        page: FilterParams.Params.page,
                        size: _this.Views.ReportsWidgets.ImportedFilesReport.Views.Paging.config.size,
                        rows: []
                    };

                    var sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : 'name';
                    var sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : 'asc';

                    var sort_val = sort_dir == 'asc' ? 1 : -1;


                    _this.ImportFilesArr.sort((a, b) => {
                        var val_a = a[sort_prop];
                        var val_b = b[sort_prop];

                        if(typeof val_a == 'string' || typeof val_b == 'string')
                        {
                            if(sort_val > 0)
                            {
                                return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                            }
                            else
                            {
                                return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                            }
                        }
                        else if(typeof val_a == 'number' || typeof val_b == 'number')
                        {
                            return sort_val * val_a + (-1) * sort_val * val_b;
                        }

                        return -1;
                    });

                    const start_index = res.page * res.size;
                    var finish_index = start_index + res.size;

                    if(finish_index > (_this.ImportFilesArr.length - 1))
                    {
                        res.rows = _this.ImportFilesArr.slice(start_index);
                    }
                    else
                    {
                        res.rows = _this.ImportFilesArr.slice(start_index, finish_index);
                    }

                    return res;
                },
                onItemClick:function (Id) {
                    _this.ImportFilesClick(Id);
                }
            })
        }
    };

    this.Subscriptions = {};

    this.Signals = {
        CIDRInputHasValue:  new Rx.BehaviorSubject(0),
        COMMUNITYInputHasValue:  new Rx.BehaviorSubject(0),
        ASPATHInputHasValue:  new Rx.BehaviorSubject(0),

        AddNetwork: new Rx.BehaviorSubject(null),
        AddMultipleNetworks: new Rx.BehaviorSubject(null),
        ImportedFilesCountChange: new Rx.BehaviorSubject(0)
    };

    this.ImportPopup = null;

    this.ImportPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ImportPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Import prefixes"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        _this.ImportPopup.hide();
                    }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ImportPopupForm",
                            type: "wide",
                            minWidth:560,
                            minHeight:400,
                            elements: [
                                {
                                    view:"datatable",
                                    id: this.Id + "ImportPopupTable",
                                    header:false,
                                    hidden:true,
                                    columns:[
                                        {
                                            id:"type_id"
                                        },
                                        {
                                            id:"resource_raw"
                                        },
                                        {
                                            id:"resource_validated"
                                        }
                                    ]
                                },
                                {
                                    view:"spectre_textarea",
                                    id:this.Id + "ImportPopupEditor",
                                    label:LangHelper.GetString("UlrModule","File or clipboard content to import"),
                                    height:undefined,
                                    value:""
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ImportPopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Import"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ImportPopupValues();
                                            _this.ImportPopup.hide();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ImportFilesPopup = null;

    this.ImportFilesPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ImportFilesPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Import prefixes"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){
                        _this.ImportFilesPopup.hide();
                    }
                }
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ImportFilesPopupForm",
                            type: "wide",
                            minWidth:720,
                            minHeight:400,
                            elements: [
                                {
                                    view: "uploader",
                                    value: LangHelper.GetString("UlrModule","Click to upload or drag a file here"),
                                    id: this.Id+"ImportFilesPopupUploader",
                                    css:"upload_area form_button spec_action",
                                    autosend:false,
                                    height:64
                                },
                                this.Views.ReportsWidgets.ImportedFilesReport.ViewConfig
                            ]
                        },

                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {},
                                {
                                    view:"spectre_button",
                                    // id:this.Id + "ImportPopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Close"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ImportFilesPopup.hide();
                                        },1);
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };


    this.ViewConfig = [
        {
            id: _this.Id + "AddNetworkPanel",
            rows:[
                {
                    type: "wide",
                    rows: [
                        {
                            cols: [
                                BlockHeaderTemplate({
                                    title:Params && Params.HeaderTitle ? Params.HeaderTitle : LangHelper.GetString("UlrModule","Add prefix"), icon:"",
                                    borderless:true,
                                    css: "custom__app-block-header-with-icon"
                                }),
                                {
                                    view: "spectre_button",
                                    id:_this.Id + "BgpPrefixHelpBtn",
                                    type: "icon",
                                    icon: "question-circle",
                                    css:"toolbar_round_btn custom-form-btn",
                                    width:32,
                                    height:25,
                                    tooltip:LangHelper.GetString("UlrModule", "Help bgp regex"),
                                    hidden: true,
                                    click:function (id)
                                    {
                                        UlrShowBgpPrefixesHelpPopup();
                                    }
                                },
                                {
                                    view: "spectre_button",
                                    id:_this.Id + "CidrPrefixHelpBtn",
                                    type: "icon",
                                    icon: "question-circle",
                                    css:"toolbar_round_btn custom-form-btn",
                                    width:32,
                                    height:25,
                                    tooltip:LangHelper.GetString("UlrModule", "Help cidr ip-prefix"),
                                    hidden: false,
                                    click:function (id)
                                    {
                                        UlrShowCidrPrefixesHelpPopup();
                                    }
                                },
                                {}
                            ]
                        },
                        {
                            type: "wide",
                            id: _this.Id + "AddNetworkForm",
                            view: "form",
                            borderless: true,
                            cols: [
                                {
                                    view:"spectre_richselect",
                                    id:_this.Id + "AddPrefixTypeSelect",
                                    name:"prefix_types",
                                    required: true,
                                    value: PrefixTypeMapEnum.CIDR,
                                    label:LangHelper.GetString("UlrModule","Prefix type"),
                                    options: Helper.DictToArr(PrefixTypeDic),
                                },
                                {
                                    view:"spectre_text",
                                    id:_this.Id + "CIDRInput",
                                    name:"cidr",
                                    label:LangHelper.GetString("UlrModule","CIDR"),
                                    //required:true,
                                    validate: function (V)
                                    {
                                        if(!V)
                                            return true;

                                        return Helper.UlrValidateCidr(V, true);
                                    },
                                    invalidMessage: LangHelper.GetString("UlrModule", "Not a CIDR"),
                                    on:{
                                        onChange: function (Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                        },
                                        onEnter:function(ev)
                                        {
                                            setTimeout(function ()
                                            {
                                                _this.AddNetwork();
                                            },1);
                                        }
                                    }
                                },
                                {
                                    view:"spectre_text",
                                    id:_this.Id + "COMMUNITYInput",
                                    name:"community",
                                    label:LangHelper.GetString("UlrModule","COMMUNITY"),
                                    hidden:true,
                                    // width: 160,
                                    validate: function (V)
                                    {
                                        return true;
                                    },
                                    invalidMessage: "",
                                    on:{
                                        onChange: function (Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                        },
                                        onEnter:function(ev)
                                        {
                                            setTimeout(function ()
                                            {
                                                _this.AddNetwork();
                                            },1);
                                        }
                                    }

                                },
                                {
                                    view:"spectre_text",
                                    id:_this.Id + "ASPATHInput",
                                    name:"aspath",
                                    label:LangHelper.GetString("UlrModule","ASPATH"),
                                    hidden:true,
                                    // width: 160,
                                    validate: function (V)
                                    {
                                        return true;
                                    },
                                    invalidMessage: "",
                                    on:{
                                        onChange: function (Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                        },
                                        onEnter:function(ev)
                                        {
                                            setTimeout(function ()
                                            {
                                                _this.AddNetwork();
                                            },1);
                                        }
                                    }
                                },
                                {
                                    view:"spectre_richselect",
                                    id:_this.Id + "DiffAutoApply",
                                    name:"bgp_diff_autoapply",
                                    hidden:true,
                                    value: 1,
                                    label:LangHelper.GetString("UlrModule","BGP diff auto apply"),
                                    options: Helper.DictToArr(BlStatusesDic),
                                },
                                {
                                    view: "spectre_richselect",
                                    id:_this.Id + "ProtocolVersion",
                                    name:"protocol_version",
                                    hidden:true,
                                    value: UlrIpProtocolVersionDic.BOTH.id,
                                    label:LangHelper.GetString("UlrModule","IP version"),
                                    options: Helper.DictToArr(UlrIpProtocolVersionDic),
                                },
                                // {
                                //     view:"spectre_multiselect",
                                //     id:_this.Id + "DiffSendNotification",
                                //     name:"bgp_send_notification",
                                //     gravity:2,
                                //     hidden:true,
                                //     value: "",
                                //     label:LangHelper.GetString("UlrModule","BGP diff notification"),
                                //     options: Helper.DictToArr(UlrBgpDiffNotifications),
                                // },
                                {
                                    rows:[
                                        {},
                                        {
                                            view:"spectre_button",
                                            id:_this.Id + "AddNetworkBtn",
                                            css:"form_button form_element spec_action",
                                            label:LangHelper.GetString("UlrModule","Add"),
                                            autowidth:true,
                                            height:51,
                                            disabled:true,
                                            click:function ()
                                            {
                                                setTimeout(function ()
                                                {
                                                    _this.AddNetwork();
                                                },1);
                                            }
                                        }
                                    ]
                                },
                                {
                                    id:_this.Id + "Spacer",
                                    gravity:1
                                }
                            ]
                        },
                        {
                            type: "wide",
                            cols: [
                                {
                                    view:"spectre_button",
                                    id:this.Id + "ImportBtn",
                                    type:"icon",
                                    css:"form_button spec_action with_icon",
                                    label:LangHelper.GetString("UlrModule","Import prefixes"),
                                    icon:"arrow-left",
                                    //height:44,
                                    autowidth:true,
                                    click:function ()
                                    {
                                        _this.ShowImportForm();
                                    }
                                },
                                {
                                    view:"spectre_button",
                                    id:this.Id + "FileImportBtn",
                                    type:"icon",
                                    css:"form_button spec_action with_icon ulr_with_badge",
                                    label:LangHelper.GetString("UlrModule","Import from file"),
                                    icon:"file",
                                    //height:44,
                                    badge: 0,
                                    autowidth:true,
                                    click:function ()
                                    {
                                        _this.ImportFilesPopup.show();
                                        _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.ImportFilesArr = [];
}

UlrAddNetworksViewController.prototype.ViewDidLoad = function(Params)
{
  this.BindAll(Params);
};

UlrAddNetworksViewController.prototype.BindAll = function(Params)
{
    var _this = this;

    this.ImportPopup = webix.ui(this.ImportPopupConfig);

    this.ImportFilesPopup = webix.ui(this.ImportFilesPopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.AddPrefixTypeSelect.attachEvent("onChange", function(Nv, Ov)
    {
        if (Nv == PrefixTypeMapEnum.BGP)
        {
            _this.Views.CIDRInput.hide();
            _this.Views.COMMUNITYInput.show();
            _this.Views.ASPATHInput.show();
            _this.Views.DiffAutoApply.show();
            _this.Views.ProtocolVersion.show();
            _this.Views.Spacer.hide();
            _this.Views.BgpPrefixHelpBtn.show();
            _this.Views.CidrPrefixHelpBtn.hide();
            // _this.Views.DiffSendNotification.show();

            _this.Views.ImportBtn.hide();
            _this.Views.FileImportBtn.hide();
        }
        else
        {
            _this.Views.CIDRInput.show();
            _this.Views.COMMUNITYInput.hide();
            _this.Views.ASPATHInput.hide();
            _this.Views.DiffAutoApply.hide();
            _this.Views.ProtocolVersion.hide();
            _this.Views.Spacer.show();
            _this.Views.BgpPrefixHelpBtn.hide();
            _this.Views.CidrPrefixHelpBtn.show();
            // _this.Views.DiffSendNotification.hide();
            _this.Views.ImportBtn.show();
            _this.Views.FileImportBtn.show();
        }
    });

    this.Views.CIDRInput.attachEvent("onChange", function(Nv, Ov)
    {
        _this.Signals.CIDRInputHasValue.next(Nv ? 1 : 0);
    });

    this.Views.CIDRInput.attachEvent("onChange", function(Nv, Ov)
    {
        if(!_this.Views.CIDRInput.validate())
            _this.Views.AddNetworkForm.markInvalid("cidr",LangHelper.GetString("UlrModule", "Not a CIDR"));

        _this.Signals.CIDRInputHasValue.next(Nv ? 1 : 0);
    });

    this.Views.CIDRInput.attachEvent("onTimedKeyPress", function()
    {
        //_this.Views.CIDRInput.validate();
        var v = _this.Views.CIDRInput.getValue();
        _this.Signals.CIDRInputHasValue.next(v ? 1 : 0);
    });

    this.Subscriptions.CIDRInputHasValue = this.Signals.CIDRInputHasValue.subscribe(function (HasValue)
    {
        HasValue ? _this.Views.AddNetworkBtn.enable() : _this.Views.AddNetworkBtn.disable();
    });

    this.Views.COMMUNITYInput.attachEvent("onChange", function(Nv, Ov)
    {
        _this.Views.COMMUNITYInput.validate()
        _this.Signals.COMMUNITYInputHasValue.next(Nv ? 1 : 0);
    });

    this.Views.COMMUNITYInput.attachEvent("onTimedKeyPress", function()
    {
        var v = _this.Views.COMMUNITYInput.getValue();
        _this.Signals.COMMUNITYInputHasValue.next(v ? 1 : 0);
    });

    this.Subscriptions.COMMUNITYInputHasValue = this.Signals.COMMUNITYInputHasValue.subscribe(function (HasValue)
    {
        HasValue || _this.Views.ASPATHInput.getValue() ? _this.Views.AddNetworkBtn.enable() : _this.Views.AddNetworkBtn.disable();
    });

    this.Views.ASPATHInput.attachEvent("onChange", function(Nv, Ov)
    {
        _this.Views.ASPATHInput.validate()
        _this.Signals.ASPATHInputHasValue.next(Nv ? 1 : 0);
    });

    this.Views.ASPATHInput.attachEvent("onTimedKeyPress", function()
    {
        var v = _this.Views.ASPATHInput.getValue();
        _this.Signals.ASPATHInputHasValue.next(v ? 1 : 0);
    });

    this.Subscriptions.ASPATHInputHasValue = this.Signals.ASPATHInputHasValue.subscribe(function (HasValue)
    {
        HasValue || _this.Views.COMMUNITYInput.getValue() ? _this.Views.AddNetworkBtn.enable() : _this.Views.AddNetworkBtn.disable();
    });

    this.Views.ImportFilesPopupUploader.attachEvent("onAfterFileAdd", function(FileObj){
        if(FileObj)
        {
            _this.OnFileAdded(FileObj);
        }
    });

    this.Subscriptions.ImportFilesCountChange = this.Signals.ImportedFilesCountChange.subscribe(function(Val)
    {
        _this.DefineImportFilesBtnBadge(Val);
    });
};

UlrAddNetworksViewController.prototype.Destroy = function()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function(Key){
        if(_this.Subscriptions[Key])
            _this.Subscriptions[Key].unsubscribe();
    });

    var destroyWidgets = function(Dic)
    {
        Object.keys(Dic).forEach(function(Key){
            var w = Dic[Key];
            if(w.Destroy)
                w.Destroy();
        });
    };

    destroyWidgets(this.Views.Widgets);
    destroyWidgets(this.Views.ReportsWidgets);

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
}

UlrAddNetworksViewController.prototype.ImportPopupValues = function()
{
    var vals = this.Views.ImportPopupEditor.getValue();

    if(!vals)
        return;

    var lines = vals.split(/\r|\n/);

    var res_arr = [];

    lines.forEach((Line) => {
        var line = Line.trim();
        line = line.split(" ")[0];

        if(line && Helper.ValidateIPaddressOrCidr(line))
        {
            var model = new UlrIspNetworkModel({
                _id: 0,
                enabled: 1,
                type_id: PrefixTypeMapEnum.CIDR
            });

            if(Helper.UlrValidateCidrIpv4(line))
            {
                model.cidr_ipv4 = line;

                if(Helper.ValidateIPv4(model.cidr_ipv4))
                {
                    model.cidr_ipv4 += "/32";
                }
            }
            else
            {
                model.cidr_ipv6 = line;

                if(!Helper.ValidateIPv6Cidr(model.cidr_ipv6))
                {
                    model.cidr_ipv6 += "/128";
                }
            }

            res_arr.push(model);
        }
    });

    this.Signals.AddMultipleNetworks.next(res_arr);
};

UlrAddNetworksViewController.prototype.AddNetwork = function()
{
    var type = this.Views.AddPrefixTypeSelect.getValue();

    if(type == PrefixTypeMapEnum.CIDR && !this.Views.CIDRInput.validate())
        return;

    var cidr = this.Views.CIDRInput.getValue();
    var aspath = this.Views.ASPATHInput.getValue();
    var community = this.Views.COMMUNITYInput.getValue();
    var autoaply = this.Views.DiffAutoApply.getValue();
    // var notif = this.Views.DiffSendNotification.getValue();
    var proto = this.Views.ProtocolVersion.getValue();

    if(!cidr && !aspath && !community)
        return;

    var regex = aspath && community ? `ASPATH: ${aspath} | COMMUNITY: ${community}` : (aspath ? `ASPATH: ${aspath} | COMMUNITY: .*` : `ASPATH: .* | COMMUNITY: ${community}`);

    var model = new UlrIspNetworkModel({
        _id: webix.uid(),
        cidr_ipv4:type == PrefixTypeMapEnum.CIDR && Helper.UlrValidateCidrIpv4(cidr) ? cidr : null,
        cidr_ipv6:type == PrefixTypeMapEnum.CIDR && Helper.UlrValidateCidrIpv6(cidr) ? cidr : null,
        enabled:1,
        is_added:1,
        type_id: parseInt(type),
        bgp_diff_autoapply: type == PrefixTypeMapEnum.BGP ? autoaply : 0,
        bgp_send_notification: '', //type== PrefixTypeMapEnum.BGP ? notif : '',
        protocol_version: type == PrefixTypeMapEnum.BGP ? proto : UlrIpProtocolVersionDic.BOTH.id,
        regex
    });

    this.Signals.AddNetwork.next(model);
};

UlrAddNetworksViewController.prototype.MarkCidrInvalid = function (Msg)
{
    this.Views.AddNetworkForm.markInvalid("cidr",Msg);
};

UlrAddNetworksViewController.prototype.MarkRegexInvalid = function (AsMsg, ComMsg)
{
    this.Views.AddNetworkForm.markInvalid("aspath",LangHelper.GetString("UlrModule", AsMsg));
    this.Views.AddNetworkForm.markInvalid("community",LangHelper.GetString("UlrModule", ComMsg));
};

UlrAddNetworksViewController.prototype.ClearValidation = function()
{
    this.Views.AddNetworkForm.clearValidation();
};

UlrAddNetworksViewController.prototype.ShowImportForm = function()
{
    this.Views.ImportPopupEditor.setValue("");

    this.ImportPopup.show();
};

UlrAddNetworksViewController.prototype.GetImportedFiles = function()
{
    var res = [];
    this.ImportFilesArr.forEach((Model) => {
        if(Model.filepath)
        {
            res.push(Model.filepath);
        }
    });

    return res;
};

UlrAddNetworksViewController.prototype.OnFileAdded = function(FileObj)
{
    var _this = this;

    var model = {
        id: FileObj.id ? FileObj.id : webix.uid(),
        name: FileObj.name,
        size: FileObj.size,
        sizetext: FileObj.sizetext,
        state: UlrFilesStatusDic.new.id,
        uploadId: '',
        filepath: ''
    };

    this.ImportFilesArr.push(model);

    var modelIndex = this.ImportFilesArr.findIndex((Obj) => Obj.id == model.id);

    this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
    var path = "upload_files/";

    var fileName = webix.uid() + "_" + model.name;
    var result_fpath = path + fileName;

    var updateModelClosure = function(Model)
    {
        var modelIndex = _this.ImportFilesArr.findIndex((Obj) => Obj.id == Model.id);

        if(modelIndex > -1)
        {
            _this.ImportFilesArr[modelIndex] = Model;
            return true;
        }

        return false;
    };

    App.ServerManager.UlrGenerateFileUploadId({
        fileName: fileName,
        path: path,
        callback: function(R)
        {
            if(R.success && R.data)
            {
                var key = R.data.key ? R.data.key : webix.uid();

                model.uploadId = key;
                model.state = UlrFilesStatusDic.uploading.id;

                if(updateModelClosure(model))
                {
                    _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();

                    App.ServerManager.UploadFile({
                        key: key,
                        file: FileObj.file,
                        callback: function(R)
                        {
                            if(R.status != 200)
                            {
                                model.state = UlrFilesStatusDic.failed.id;
                            }
                            else
                            {
                                model.state = UlrFilesStatusDic.uploaded.id;
                                model.filepath = result_fpath;
                            }

                            if(updateModelClosure(model))
                            {
                                _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                                _this.ImportFilesArrUpdated();
                            }
                        }
                    });
                }

            }
            else if(R.error)
            {
                model.state = UlrFilesStatusDic.failed.id;
                if(updateModelClosure(model))
                {
                    _this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                }
                _this.ShowServerError(R.error);
            }
        }
    });
};

UlrAddNetworksViewController.prototype.ImportFilesArrUpdated = function()
{
    var count = 0;
    this.ImportFilesArr.forEach((Item) => {
        if(Item.state == UlrFilesStatusDic.uploaded.id)
        {
            count++;
        }
    });

    this.Signals.ImportedFilesCountChange.next(count);
};

UlrAddNetworksViewController.prototype.DefineImportFilesBtnBadge = function(Count)
{
    var count = Count > 99 ? "99+" : Count;

    this.Views.FileImportBtn.define({badge: UlrButtonBadgeTemplate(count)});

    this.Views.FileImportBtn.refresh();
};

UlrAddNetworksViewController.prototype.ImportFilesClick = function(Id)
{
    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.ImportedFilesReport.Views.Table;

        var item = table.getItem(Id);

        if(item)
        {
            const index = this.ImportFilesArr.findIndex(x => x.id == item.id);
            if(index > -1)
            {
                this.ImportFilesArr.splice(index, 1);
                this.Views.ReportsWidgets.ImportedFilesReport.RefreshData();
                this.ImportFilesArrUpdated();
            }
        }

        table.remove(Id);
    }
};


function UlrIspListViews(Params)
{
    var _this = this;

    this.Id = "UlrIspList";
    if(Params && Params.id)
    {
        this.Id = Params.id + this.Id;
    }

    this.IspsVal = {};
    this.RuleMode = 1;

    this.ModesEnum = {
        all_isps:1,
        only_isps_in_list:2
    };

    this.ViewModel = new UlrDscpRulesManager();

    this.Views = {
        ISPListForm:null,
        ISPListFormFirstCol:null,
        ISPListFormSecondCol:null,
        ISPListFormThirdCol:null,
        RuleModeToggle:null,
        ModeToggleDescription:null
    };

    this.IsHidden = Params && Params.hidden ? !!(Params.hidden) : false;

    this.ViewConfig = [
        {
            type:"wide",
            hidden: this.IsHidden,
            cols:[
                {
                    view:"spectre_toggle",
                    id:this.Id + "RuleModeToggle",
                    height:22,
                    width:22,
                    onstate:this.ModesEnum.only_isps_in_list,
                    offstate:this.ModesEnum.all_isps,
                    value:this.ModesEnum.all_isps,
                    on:{
                        onChange:function(Nv, Ov)
                        {
                            _this.Signals.IspModeChanged.next(Nv);
                        }
                    }
                },
                {
                    width:webix.html.getTextSize(LangHelper.GetString("UlrModule","Apply the rule to ISPs from the list").replace(" ", "_"), "app_block__header_webix_template").width,
                    rows:[
                        BlockHeaderTemplate({
                            title:LangHelper.GetString("UlrModule","Apply the rule to ISPs from the list"), icon:"",
                            borderless:true
                        })
                    ]
                },
                {}
            ]
        },
        {
            view:"label",
            id:this.Id + "ModeToggleDescription",
            height:22,
            css:"form_text_description_label line_height_22",
            label:LangHelper.GetString("UlrModule","The rule will be applied for all ISPs by default")+".",
            hidden:true
        },
        {
            type: "clean",
            css:"slide_down_box",
            view:"form",
            id:this.Id + "ISPListForm",
            elements:[
                {
                    view: "template",
                    borderless:false,
                    border:2,
                    css:"form_text_warning_label",
                    autoheight: true,
                    template: function () {
                        return LangHelper.GetString("UlrModule", "BRIDGE_CHANNELS_DSCP_NOTE") + "<br/>&nbsp;"

                    }()
                },
                {
                    view:"label",
                    css:"form_text_label",
                    label:LangHelper.GetString("UlrModule","Select ISP which the rule will be applied")
                },
                {
                    type: "wide",
                    cols:[
                        {
                            id:this.Id + "ISPListFormFirstCol",
                            rows:[]
                        },
                        {
                            id:this.Id + "ISPListFormSecondCol",
                            rows:[]
                        },
                        {
                            id:this.Id + "ISPListFormThirdCol",
                            rows:[]
                        },
                        {}
                    ]
                },
                {
                    type: "wide",
                    cols:[
                        {
                            view:"spectre_button",
                            css:"form_button spec_action",
                            label:LangHelper.GetString("UlrModule","Select all"),
                            autowidth:true,
                            click:function ()
                            {
                                _this.SelectAllIsps();
                            }
                        },
                        {
                            view:"spectre_button",
                            css:"form_button spec_action",
                            label:LangHelper.GetString("UlrModule","Unselect all"),
                            autowidth:true,
                            click:function ()
                            {
                                _this.UnselectAllIsps();
                            }
                        },
                        {}
                    ]
                },
                {
                    height:20
                }
            ]
        }
    ];

    this.Subscriptions = {};

    this.Signals = {
        IspModeChanged: new Rx.BehaviorSubject(0),
        SetForm: new Rx.BehaviorSubject(0)
    };
}

UlrIspListViews.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Subscriptions.IspModeChanged = this.Signals.IspModeChanged.subscribe(function (Mode)
    {
        if(_this.IsHidden)
        {
            _this.Views.ISPListForm.hide();
            _this.Views.ModeToggleDescription.hide();
            return;
        }

        var view = _this.Views.ISPListForm;

        if (view)
            Mode == _this.ModesEnum.only_isps_in_list ? view.show() : view.hide();

        var view = _this.Views.ModeToggleDescription;
        if (view)
            Mode == _this.ModesEnum.all_isps ? view.show() : view.hide();
    });

    this.Subscriptions.SetForm = this.Signals.SetForm.subscribe(function ()
    {
        _this.Views.ISPListForm.setValues(_this.IspsVal);
        _this.Views.RuleModeToggle.setValue(parseInt(_this.RuleMode));
    });

    App.DicsManager.Refresh({data:[DicsEnum.UlrIspsDic]});

    this.Subscriptions[DicsEnum.UlrIspsDic] = App.DicsManager.Signal[DicsEnum.UlrIspsDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            var dicArr = Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrIspsDic));

            if(dicArr && dicArr.length)
            {
                _this.DefineIspsForm(dicArr);
            }

            _this.Signals.SetForm.next();
        }
    });
};

UlrIspListViews.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    this.BindAll(Params);
};

UlrIspListViews.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

UlrIspListViews.prototype.getSelectedIsps = function ()
{
    let result = [];

    let mode = this.getMode();

    if(mode == this.ModesEnum.only_isps_in_list)
    {
        let isps = this.Views.ISPListForm.getValues();
        Object.keys(isps).forEach(function(Key){
            if(isps[Key] == 1)
            {
                result.push(Key);
            }
        });
    }

    return result.join(",");
};

UlrIspListViews.prototype.getMode = function ()
{
    let mode = this.Views.RuleModeToggle.getValue();

    return mode == this.ModesEnum.only_isps_in_list ? this.ModesEnum.only_isps_in_list : this.ModesEnum.all_isps;
};

UlrIspListViews.prototype.setForm = function (IspsVals = {}, Mode = 1)
{
    this.IspsVal = IspsVals;
    this.RuleMode = Mode;
    this.Signals.SetForm.next();
};

UlrIspListViews.prototype.DefineIspsForm = function(IspsDicArr)
{
    var arr = IspsDicArr;

    var cols = [
        [],[],[]
    ];

    var colNum = 0;

    arr.forEach(function (IspItem)
    {
        cols[colNum].push( {
            view:"checkbox",
            labelWidth:0,
            name:""+IspItem.id,
            labelRight:IspItem.value
        });

        colNum = colNum >= 2 ? 0 : colNum+1;
    });

    this.Views.ISPListFormFirstCol.define("rows", cols[0]);
    this.Views.ISPListFormSecondCol.define("rows", cols[1]);
    this.Views.ISPListFormThirdCol.define("rows", cols[2]);

    this.Views.ISPListFormFirstCol.reconstruct();
    this.Views.ISPListFormSecondCol.reconstruct();
    this.Views.ISPListFormThirdCol.reconstruct();
};

UlrIspListViews.prototype.SelectAllIsps = function()
{
    var vals = this.Views.ISPListForm.getValues();

    Object.keys(vals).forEach(function (Key) {
        vals[Key] = 1;
    });

    this.Views.ISPListForm.setValues(vals);
};

UlrIspListViews.prototype.UnselectAllIsps = function()
{
    var vals = this.Views.ISPListForm.getValues();

    Object.keys(vals).forEach(function (Key) {
        vals[Key] = 0;
    });

    this.Views.ISPListForm.setValues(vals);
};
var IspsSubscribersListTypes = {
    isp: "isp",
    subscriber: "subscriber"
};

function UlrIspSubscribersListViews(Params)
{
    var _this = this;

    this.Id = "UlrIspList";
    if(Params && Params.id)
    {
        this.Id = Params.id + this.Id;
    }

    this.IspType = Params && Params.IspType ? Params.IspType : IspsSubscribersListTypes.isp;

    this.IspsVal = {};
    this.RuleMode = 1;

    this.ModesEnum = {
        all_isps:1,
        only_isps_in_list:2
    };

    this.IsHidden = Params && Params.hidden ? !!(Params.hidden) : false;

    this.ViewModel = Params && Params.ViewModel ? Params.ViewModel : new UniReportsManager();

    this.Views = {
        IspTable: null,
        IspTableWrapper: null,
        // ISPListForm:null,
        // ISPListFormFirstCol:null,
        // ISPListFormSecondCol:null,
        // ISPListFormThirdCol:null,
        RuleModeToggle:null,
        ModeToggleDescription:null,
        ReportsWidgets: {
            IspsListReport: UrlWebRulesIspsTableWidget({
                id: this.Id + "IspsReport",
                enableTextSearch:0,
                enableAutoHeight:1,
                hidePaginatorToolbar:1,
                IspType: this.IspType,
                enableLocalSort:1,
                onItemClick: function(id)
                {}
            })
        }
    };

    this.ViewConfig = [
        {
            type:"wide",
            hidden: this.IsHidden,
            cols:[
                {
                    view:"spectre_toggle",
                    id:this.Id + "RuleModeToggle",
                    height:22,
                    width:22,
                    onstate:this.ModesEnum.only_isps_in_list,
                    offstate:this.ModesEnum.all_isps,
                    value:this.ModesEnum.all_isps,
                    on:{
                        onChange:function(Nv, Ov)
                        {
                            _this.Signals.IspModeChanged.next(Nv);
                        }
                    }
                },
                {
                    width:webix.html.getTextSize(LangHelper.GetString("UlrModule","Apply the rule to " + (_this.IspType == IspsSubscribersListTypes.isp ?  "ISPs" : "subscribers") + " from the list").replace(" ", "_"), "app_block__header_webix_template").width,
                    rows:[
                        BlockHeaderTemplate({
                            title:LangHelper.GetString("UlrModule","Apply the rule to " + (_this.IspType == IspsSubscribersListTypes.isp ?  "ISPs" : "subscribers") + " from the list"), icon:"",
                            borderless:true
                        })
                    ]
                },
                {}
            ]
        },
        {
            view:"label",
            id:this.Id + "ModeToggleDescription",
            height:22,
            css:"form_text_description_label line_height_22",
            label:LangHelper.GetString("UlrModule","The rule will be applied for all " + (_this.IspType == IspsSubscribersListTypes.isp ?  "ISPs" : "subscribers") + " by default")+".",
            hidden:true
        },
        {height: 24},
        {
            type: "clean",
            css:"slide_down_box",
            id: this.Id + "IspTableWrapper",
            // height: 400,
            rows: [
                this.Views.ReportsWidgets.IspsListReport.ViewConfig,
                {height: 24},
                {
                    type: "wide",
                    cols:[
                        {
                            view:"spectre_button",
                            css:"form_button spec_action",
                            label:LangHelper.GetString("UlrModule","Select all"),
                            autowidth:true,
                            click:function ()
                            {
                                _this.SelectAllIsps();
                            }
                        },
                        {
                            view:"spectre_button",
                            css:"form_button spec_action",
                            label:LangHelper.GetString("UlrModule","Unselect all"),
                            autowidth:true,
                            click:function ()
                            {
                                _this.UnselectAllIsps();
                            }
                        },
                        {}
                    ]
                },
            ]
        },
    ];

    this.Subscriptions = {};

    this.Signals = {
        IspModeChanged: new Rx.BehaviorSubject(0),
        SetForm: new Rx.BehaviorSubject(0)
    };
}

UlrIspSubscribersListViews.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Subscriptions.IspModeChanged = this.Signals.IspModeChanged.subscribe(function (Mode)
    {
        if(_this.IsHidden)
        {
            _this.Views.IspTableWrapper.hide();
            _this.Views.ModeToggleDescription.hide();
            return;
        }

        var view = _this.Views.IspTableWrapper;

        if (view)
            Mode == _this.ModesEnum.only_isps_in_list ? view.show() : view.hide();

        var view = _this.Views.ModeToggleDescription;
        if (view)
            Mode == _this.ModesEnum.all_isps ? view.show() : view.hide();
    });

    this.Subscriptions.SetForm = this.Signals.SetForm.subscribe(function ()
    {
        _this.Views.RuleModeToggle.setValue(parseInt(_this.RuleMode));

        var table = _this.Views.ReportsWidgets.IspsListReport.Views.Table;
        table.eachRow(rowId => {
            if(_this.IspsVal[rowId])
            {
                var item = table.getItem(rowId);
                item.enabled = 1;
                table.updateItem(rowId, item);
            }
        });
    });

    if(this.IspType == IspsSubscribersListTypes.isp)
    {
        //App.DicsManager.Refresh({data:[DicsEnum.UlrIspsDic]});

        this.Subscriptions[DicsEnum.UlrIspsDic] = App.DicsManager.Signal[DicsEnum.UlrIspsDic].subscribe(function (Dic)
        {
            if(Dic)
            {
                _this.UpdateIspDic(DicsEnum.UlrIspsDic);
            }
        });
    }
    else if(this.IspType == IspsSubscribersListTypes.subscriber)
    {
        //App.DicsManager.Refresh({data:[DicsEnum.UlrSubscribersDic]});

        this.Subscriptions[DicsEnum.UlrSubscribersDic] = App.DicsManager.Signal[DicsEnum.UlrSubscribersDic].subscribe(function (Dic)
        {
            if(Dic)
            {
                _this.UpdateIspDic(DicsEnum.UlrSubscribersDic);
            }
        });
    }

};

UlrIspSubscribersListViews.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    this.BindAll(Params);
};

UlrIspSubscribersListViews.prototype.UpdateIspDic = function(DicId)
{
    var dicArr = Helper.DictToArr(App.DicsManager.GetDicAsArray(DicId));

    var arr = [];

    dicArr.forEach((obj) => {
        arr.push({
            id: obj.id,
            value: obj.value,
            igw_name: obj.igw_name,
            enabled: 0
        });
    });
    // this.Views.ReportsWidgets.IspsListReport.Views.Table.config.height = 80 + 40 * arr.length;
    // this.Views.ReportsWidgets.IspsListReport.Views.Table.resize();
    this.Views.ReportsWidgets.IspsListReport.Views.Table.clearAll();
    this.Views.ReportsWidgets.IspsListReport.Views.Table.parse(arr);


    this.Signals.SetForm.next();
}

UlrIspSubscribersListViews.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });
};

UlrIspSubscribersListViews.prototype.getSelectedIsps = function ()
{
    let result = [];

    let mode = this.getMode();

    if(mode == this.ModesEnum.only_isps_in_list)
    {
        var table = this.Views.ReportsWidgets.IspsListReport.Views.Table;
        table.eachRow(rowId => {
            var item = table.getItem(rowId);
            if(item.enabled == 1)
            {
                result.push(rowId);
            }
        });
    }

    return result;
};

UlrIspSubscribersListViews.prototype.getMode = function ()
{
    let mode = this.Views.RuleModeToggle.getValue();

    return mode == this.ModesEnum.only_isps_in_list ? this.ModesEnum.only_isps_in_list : this.ModesEnum.all_isps;
};

UlrIspSubscribersListViews.prototype.setForm = function (IspsVals = {}, Mode = 1)
{
    this.IspsVal = IspsVals;
    this.RuleMode = Mode;
    this.Signals.SetForm.next();
};

UlrIspSubscribersListViews.prototype.SelectAllIsps = function()
{
    var table = this.Views.ReportsWidgets.IspsListReport.Views.Table;
    table.eachRow(rowId => {
        var item = table.getItem(rowId);
        item.enabled = 1;
        table.updateItem(rowId, item);
    });
};

UlrIspSubscribersListViews.prototype.UnselectAllIsps = function()
{
    var table = this.Views.ReportsWidgets.IspsListReport.Views.Table;
    table.eachRow(rowId => {
        var item = table.getItem(rowId);
        item.enabled = 0;
        table.updateItem(rowId, item);
    });
};
function UlrSubscribersRulesViewController(Params)
{
    let _this = this;

    this.Id = Params && Params.Id ? Params.Id : "UlrVipSubscribersRules";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle: Params && Params.RootTitle ? Params && Params.RootTitle : LangHelper.GetString("UlrModule","IP & ASN excludes"),
        Title: Params && Params.Title ? Params.Title : LangHelper.GetString("UlrModule","VIP subscribers list")
    };

    this.EditFormLabel = Params && Params.EditFormLabel ? Params.EditFormLabel : LangHelper.GetString("UlrModule", "VIP subscriber [TYPE] is [VALUE].");

    this.NotificationTitle = Params && Params.NotificationTitle ? Params.NotificationTitle : "VIP Subscriber";

    this.ViewModel = new UlrSubscribersRulesManager(Params);

    this.ReportsModel = new UniReportsManager();

    this.IspsList = new UlrIspListViews({id: "Main", hidden: Params && Params.HideIspsValue ? !!(Params.HideIspsValue) : false});

    this.EditPopupIspsList = new UlrIspListViews({id: "Popup", hidden: Params && Params.HideIspsValue ? !!(Params.HideIspsValue) : false});

    this.EditPopup = null;

    this.CustomFormPCAP = Params && Params.CustomFormPCAP;

    let reportWidget = Params && Params.ReportWidget ? Params.ReportWidget : UrlLastVipSubscribersEntriesTableWidget;

    let reportParams = {
        id:this.Id + "RulesReport",
        enableTextSearch:true,
        enableAutoHeight:1,
        hideEdit: Params && Params.HideIspsValue ? (_this.Id !== "UlrRecordPCAP" ? !!(Params.HideIspsValue) : false) : false,
        onItemClick:function (Id, E, Node)
        {
            _this.RulesReportOnItemClick(Id, E, Node);
        },
        onCheck:function (Row, Column, State)
        {
            _this.RulesReportOnCheck(Row, Column, State);
        }
    };

    this.Views = {
        AddSubscriberForm: null,
        SubscriberIdentityTypeInput: null,
        SubscriberIdentityInput: null,
        SetRuleBtn: null,
        SetPendingRuleBtn: null,
        EditPopupLabel: null,
        EditPopupForm: null,
        EditPopupSaveBtn: null,
        SelectSubBtn: null,
        CustomPCAPForm: null,
        EditCustomPCAPForm: null,
        // SubscriberIdentityTypeSelect: null,
        RuleRangeTimepicker: null,
        TimetableSetDataForm: null,
        TimetableEditDataForm: null,
        StartModeToggle: null,
        ScrollListPopupArea: null,

        Widgets:{},
        ReportsWidgets:{
            RulesReport: reportWidget(reportParams),
            SubscribersShortTableReport: UlrSubsListTableWidget({
                id:this.Id + "SubscribersShortTableReport",
                enableTextSearch:1,
                enableAutoHeight:1,
                hideExport: true,
                columns: ["name", "login"],
                onItemClick: function (Obj, e, node)
                {},
                onAfterFilterCustomHandler: function ()
                {
                    _this.RefreshShortSubscribersTable();
                }
            })
        }
    };

    this.EditPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        width:640,
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "EditPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Edit rule"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.EditPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "EditPopupForm",
                            type: "wide",
                            elements: function(Val)
                            {
                                let label = {
                                    view:"label",
                                    id:_this.Id + "EditPopupLabel",
                                    css:"form_header_label",
                                    label:"",
                                };

                                const portInput = {
                                    view:"spectre_text",
                                    id:_this.Id + "EditSubscriberPort",
                                    name:"port",
                                    label:LangHelper.GetString("UlrModule","Ports or ports range with comma separated"),
                                    validate: _this.ValidatePortInput,
                                    invalidMessage: LangHelper.GetString("UlrModule", "Input correct ports or ports range"),
                                    on: {
                                        onChange: function(Val) {
                                            if(Val)
                                                this.setValue(Val.replace(/\s+/g, ""));
                                        }
                                    }
                                };

                                const protoInput = {
                                    view:"spectre_combo",
                                    id:_this.Id + "EditSubscriberProto",
                                    name:"proto",
                                    label:LangHelper.GetString("UlrModule","Network protocol"),
                                    value: "",
                                    options: {
                                        point: false,
                                        data: Helper.DictToArr(UlrPcapRecordingProtoDic)
                                    },
                                };

                                const vlanInput = {
                                    view:"spectre_text",
                                    id:_this.Id + "EditSubscriberVlan",
                                    name:"vlan",
                                    label:LangHelper.GetString("UlrModule","VLAN"),
                                    validate: function(Val) {
                                        if (Val == "")
                                            return true

                                        return webix.rules.isNumber(Val);
                                    },
                                    invalidMessage: LangHelper.GetString("UlrModule", "Enter the number")
                                };

                                const ipDst = {
                                    view:"spectre_text",
                                    id:_this.Id + "EditSubscriberIpDst",
                                    name:"ip_dst",
                                    label:LangHelper.GetString("UlrModule","Destination IPs or prefixes with comma separated"),
                                    invalidMessage: LangHelper.GetString("UlrModule", "Input correct IPs or prefixes"),
                                    validate: function(Val) {
                                        if(Val == "")
                                            return true;

                                        if(Val.length > 200)
                                            return false

                                        return Val.split(",").every(Item => Helper.UlrValidateCidr(Item, false));
                                    },
                                    on: {
                                        onChange: function(Val) {
                                            if(Val)
                                                this.setValue(Val.replace(/\s+/g, ""));
                                        }
                                    }
                                };

                                const customPCAPForm = {
                                    id: _this.Id + "EditCustomPCAPForm",
                                    hidden: !_this.CustomFormPCAP,
                                    rows: [
                                        {
                                            height: 10,
                                        },
                                        {
                                            type: "wide",
                                            cols: [
                                                portInput,
                                                protoInput
                                            ]
                                        },
                                        {
                                            height: 10,
                                        },
                                        {
                                            type: "wide",
                                            cols: [
                                                vlanInput,
                                                ipDst
                                            ]
                                        }
                                    ]
                                }

                                let layout = [
                                    {
                                        rows:[
                                            label
                                        ]
                                    },
                                    customPCAPForm,
                                    ..._this.EditPopupIspsList.ViewConfig,
                                ];

                                return layout;
                            }()
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "EditPopupSaveBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Save"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function () {
                                            _this.SaveEditForm();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.SubscribersSelectPopup = webix.ui({
        view:"popup",
        width:700,
        height:500,
        modal:true,
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type: "clean",
                    borderless: true,
                    rows: [
                        BlockHeaderTemplate({title:LangHelper.GetString("Subscribers", "List of subscribers"), icon:"users"}),
                        _this.Views.ReportsWidgets.SubscribersShortTableReport.ViewConfig,
                        {
                            height: 20,
                        },
                        {
                            type: "wide",
                            cols:[
                                {},
                                {
                                    view:"spectre_button",
                                    id:_this.Id + "CancelSubscriberPopup",
                                    css:"form_button third_action",
                                    label:LangHelper.GetString("UlrModule","Cancel"),
                                    click:function ()
                                    {
                                        _this.SubscribersSelectPopup.hide();
                                    }
                                },
                                {
                                    view:"spectre_button",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Select"),
                                    click:function ()
                                    {
                                        _this.SelectSubscriber();
                                    }
                                }
                            ]
                        }
                    ]
                },
            ]
        }
    });

    if (_this.CustomFormPCAP)
    {
        this.DateTimetableForm = function (Set = false) {
            const elem = {
                cols:[
                    {
                        type:"wide",
                        rows: [
                            {
                                type:"wide",
                                cols: [
                                    {
                                        view:"spectre_datepicker",
                                        name: "date_from_picker",
                                        label:LangHelper.GetString("UlrModule", "Starting time"),
                                        labelPosition:"top",
                                        timepicker:true,
                                        editable: true,
                                        format: "%d.%m.%Y %H:%i",
                                        //placeholder: "22.02.2022 00:00",
                                        height:51,
                                        validate: function (Value) {
                                            return Helper.ValidateDateTimeInput(Value);
                                        },
                                        invalidMessage: LangHelper.GetString("QoE", "Enter valid date, example: 22.02.2023 00:00")
                                    },
                                    {
                                        view:"spectre_combo",
                                        name:"timepicker",
                                        label:LangHelper.GetString("UlrModule","Recording duration"),
                                        value: "1 hour",
                                        width: 250,
                                        options: {
                                            point: false,
                                            data: Helper.DictToArr(RecordPCAPRangePickerRangesEnum)
                                        },
                                    }
                                ]
                            },
                            {
                                type:"wide",
                                cols:[
                                    {
                                        view:"spectre_toggle",
                                        name: "toggle_datepicker",
                                        height:22,
                                        width:22,
                                        on:{
                                            onChange:function(Nv, Ov)
                                            {
                                                const form = Set ? _this.Views.TimetableSetDataForm : _this.Views.TimetableEditDataForm;

                                                if (Nv == 1)
                                                {
                                                    form.elements["date_from_picker"].disable();
                                                }
                                                else
                                                {
                                                    form.elements["date_from_picker"].enable();
                                                }
                                            }
                                        }
                                    },
                                    {
                                        width:webix.html.getTextSize(LangHelper.GetString("UlrModule","Start now").replace(" ", "_"), "app_block__header_webix_template").width,
                                        rows:[
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","Start now"), icon:"",
                                                borderless:true
                                            })
                                        ]
                                    },
                                    {}
                                ]
                            }
                        ]
                    }
                ]
            };

            return elem;
        }

        this.DateTimetableSetDataForm = webix.ui({
            view: "popup",
            id: _this.Id + "DateTimetableSetDataPopup",
            maxWidth: 600,
            maxHeight: 680,
            modal: true,
            body: {
                type:"space",
                borderless:true,
                rows:[
                    {
                        type: "clean",
                        borderless: true,
                        rows: function () {
                            var rows = [];
                            rows.push(
                                {
                                    type: "wide",
                                    view: "form",
                                    id: _this.Id + "TimetableSetDataForm",
                                    borderless: true,
                                    elements: [
                                        _this.DateTimetableForm(true),
                                        {height: 5},
                                    ]
                                }
                            );

                            rows.push(
                                {
                                    type: "wide",
                                    cols: [
                                        {},
                                        {
                                            view: "spectre_button",
                                            id: _this.Id + "CancelSetFormPopup",
                                            css: "form_button third_action",
                                            label: LangHelper.GetString("UlrModule", "Cancel"),
                                            click: function () {
                                                _this.DateTimetableSetDataForm.hide();
                                            }
                                        },
                                        {
                                            view: "spectre_button",
                                            css: "form_button main_action",
                                            label: LangHelper.GetString("UlrModule", "Run"),
                                            click: function () {
                                                setTimeout(function () {
                                                    _this.SaveRule(true, "pending start");
                                                },1);
                                            }
                                        }
                                    ]
                                }
                            );

                            return rows;
                        }(),
                    }
                ]
            }
        });

        this.DateTimetableEditDataForm = webix.ui({
            view: "window",
            css:"spectre-alert form_modal",
            width:600,
            modal:true,
            position:"center",
            padding:0,
            marging:0,
            head:{
                view:"toolbar", cols:[
                    {
                        // view:"label",
                        // label: LangHelper.GetString("UlrModule","Timetable"),
                        // height:68
                    },
                    { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.HideEditTimetablePopup(); }}
                ]
            },
            body: {
                type:"space",
                borderless:true,
                rows:[
                    {
                        type: "clean",
                        borderless: true,
                        rows: function () {
                            var rows = [];
                            rows.push(
                                {
                                    type: "wide",
                                    view: "form",
                                    id: _this.Id + "TimetableEditDataForm",
                                    borderless: true,
                                    elements: [
                                        _this.DateTimetableForm()
                                    ]
                                }
                            );

                            rows.push(
                                {height: 20}
                            );

                            rows.push(
                                {
                                    type: "wide",
                                    cols: [
                                        {},
                                        {
                                            view: "spectre_button",
                                            id: _this.Id + "CancelEditFormPopup",
                                            css: "form_button third_action",
                                            label: LangHelper.GetString("UlrModule", "Cancel"),
                                            click: function () {
                                                _this.HideEditTimetablePopup();
                                            }
                                        },
                                        {
                                            view: "spectre_button",
                                            css: "form_button main_action",
                                            label: LangHelper.GetString("UlrModule", "Run"),
                                            click: function () {
                                                setTimeout(function () {
                                                    _this.EnableRule();
                                                },1);
                                            }
                                        }
                                    ]
                                }
                            );

                            return rows;
                        }(),
                    }
                ]
            }
        })
    }

    if(this.Id === "UlrRecordPCAP")
    {
        this.ScrollListPopup = webix.ui({
            view: "popup",
            id: this.Id + "ScrollListPopup",
            scroll: true,
            minHeight: 300,
            body: {
                id: this.Id + "ScrollListPopupArea",
                view: "list"
            }
        });
    }

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: function () {
                            const rows = [
                                {height: 6},
                                PageHeaderTemplate({id: _this.Id + "PageTitle", root_title: _this.PageTitle.Title}),
                                {
                                    height: 32
                                },
                            ];

                            if (Params && Params.BlockInfoTemplate) {
                                rows.push(
                                    {
                                        view: "template",
                                        borderless: true,
                                        css: "form_text_big_label",
                                        //height:120,
                                        autoheight: true,
                                        template: function () {
                                            return Params.BlockInfoTemplate;
                                        }()
                                    }
                                )

                                rows.push(
                                    {height: 20}
                                )
                            }
                            if (Params && Params.BlockWarningTemplate) {
                                rows.push(
                                    {
                                        view: "template",
                                        borderless: false,
                                        border: 2,
                                        css: "form_text_warning_label",
                                        //height: 40,
                                        autoheight:true,
                                        template: function () {
                                            let warning = "<span class='warning'>" + LangHelper.GetString("UlrModule", "Warning") + "</span>" + ": ";
                                            let label = Params.BlockWarningTemplate;

                                            return warning + label + "<br/>&nbsp;";
                                        }()
                                    }
                                )

                                rows.push(
                                    {height: 32}
                                )
                            }

                            rows.push(
                                {
                                    type: "wide",
                                    borderless:true,
                                    //height:536,
                                    //minHeight:560,
                                    rows:[
                                        {
                                            type:"space",
                                            css:"form_background",
                                            rows:[
                                                {
                                                    type:"clean",
                                                    borderless:true,
                                                    rows:[
                                                        BlockHeaderTemplate({
                                                            title:LangHelper.GetString("UlrModule","Add new rule"), icon:"",
                                                            borderless:true
                                                        }),
                                                        {height:20},
                                                        {
                                                            view: "form",
                                                            id: _this.Id + "AddSubscriberForm",
                                                            type: "wide",
                                                            elements: function(Val)
                                                            {
                                                                const typeInput = {
                                                                    view:"spectre_combo",
                                                                    id:_this.Id + "SubscriberIdentityTypeInput",
                                                                    name:"type_id",
                                                                    label:LangHelper.GetString("UlrModule","Type"),
                                                                    value: _this.CustomFormPCAP ? UlrWebRuleResourcesTypesMapEnum.ip : UlrWebRuleResourcesTypesMapEnum.login,
                                                                    options:{
                                                                        point:false,
                                                                        data:[]
                                                                    },
                                                                    on: {
                                                                        onChange:function(newId)
                                                                        {
                                                                            _this.Views.AddSubscriberForm.clearValidation();

                                                                            switch(newId)
                                                                            {
                                                                                case UlrWebRuleResourcesTypesMapEnum.login:
                                                                                    if(_this.CustomFormPCAP)
                                                                                        _this.Views.CustomPCAPForm.hide();
                                                                                    _this.Views.SelectSubBtn.show();
                                                                                    break;
                                                                                case UlrWebRuleResourcesTypesMapEnum.cidr:
                                                                                    if(_this.CustomFormPCAP)
                                                                                        _this.Views.CustomPCAPForm.show();
                                                                                    _this.Views.SelectSubBtn.hide();
                                                                                    break;
                                                                                default:
                                                                                    if(_this.CustomFormPCAP)
                                                                                        _this.Views.CustomPCAPForm.show();
                                                                                    _this.Views.SelectSubBtn.hide();
                                                                            }
                                                                        }
                                                                    }
                                                                };

                                                                const textInput = {
                                                                    view:"spectre_text",
                                                                    id:_this.Id + "SubscriberIdentityInput",
                                                                    name:"resource_raw",
                                                                    label:LangHelper.GetString("UlrModule","Subscriber"),
                                                                    keyPressTimeout:300,
                                                                    on:{
                                                                        onEnter:function(ev)
                                                                        {
                                                                            setTimeout(function ()
                                                                            {
                                                                                _this.ValidateSubscriber();
                                                                            },1);
                                                                        }
                                                                    }
                                                                };

                                                                const subscriberButton = {
                                                                    view: "spectre_button",
                                                                    id:_this.Id + "SelectSubBtn",
                                                                    type: "icon",
                                                                    icon: "users",
                                                                    css:"toolbar_round_btn form_element spec_action custom-form-btn",
                                                                    width:32,
                                                                    tooltip:LangHelper.GetString("UlrModule", "Select subscriber"),
                                                                    hidden: _this.CustomFormPCAP,
                                                                    click:function (id)
                                                                    {
                                                                        _this.RefreshShortSubscribersTable();
                                                                        const node = this.getNode(id);
                                                                        _this.SubscribersSelectPopup.show(node, {pos:"left"})
                                                                    }
                                                                }

                                                                const portInput = {
                                                                    view:"spectre_text",
                                                                    id:_this.Id + "SubscriberPort",
                                                                    name:"port",
                                                                    label:LangHelper.GetString("UlrModule","Ports or ports range with comma separated"),
                                                                    validate: _this.ValidatePortInput,
                                                                    invalidMessage: LangHelper.GetString("UlrModule", "Input correct ports or ports range"),
                                                                    on: {
                                                                        onChange: function(Val) {
                                                                            if(Val)
                                                                                this.setValue(Val.replace(/\s+/g, ""));
                                                                        }
                                                                    }
                                                                };

                                                                const protoInput = {
                                                                    view:"spectre_combo",
                                                                    id:_this.Id + "SubscriberProto",
                                                                    name:"proto",
                                                                    label:LangHelper.GetString("UlrModule","Network protocol"),
                                                                    value: "",
                                                                    options: {
                                                                        point: false,
                                                                        data: Helper.DictToArr(UlrPcapRecordingProtoDic)
                                                                    },
                                                                };

                                                                const vlanInput = {
                                                                    view:"spectre_text",
                                                                    id:_this.Id + "SubscriberVlan",
                                                                    name:"vlan",
                                                                    label:LangHelper.GetString("UlrModule", "VLAN"),
                                                                    validate: function(Val) {
                                                                        if (Val == "")
                                                                            return true

                                                                        return webix.rules.isNumber(Val);
                                                                    },
                                                                    invalidMessage: LangHelper.GetString("UlrModule", "Enter the number")
                                                                };

                                                                const ipDst = {
                                                                    view:"spectre_text",
                                                                    id:_this.Id + "SubscriberIpDst",
                                                                    name:"ip_dst",
                                                                    label:LangHelper.GetString("UlrModule","Destination IPs or prefixes with comma separated"),
                                                                    invalidMessage: LangHelper.GetString("UlrModule", "Input correct IPs or prefixes"),
                                                                    validate: function(Val) {
                                                                        if(Val == "")
                                                                            return true;

                                                                        return Val.split(",").every(Item => Helper.UlrValidateCidr(Item, false));
                                                                    },
                                                                    on: {
                                                                        onChange: function(Val) {
                                                                            if(Val)
                                                                                this.setValue(Val.replace(/\s+/g, ""));
                                                                        }
                                                                    }
                                                                };

                                                                const customPCAPForm = {
                                                                    id: _this.Id + "CustomPCAPForm",
                                                                    hidden: !_this.CustomFormPCAP,
                                                                    rows: [
                                                                        {
                                                                            height: 10,
                                                                        },
                                                                        {
                                                                            type: "wide",
                                                                            cols: [
                                                                                portInput,
                                                                                protoInput
                                                                            ]
                                                                        },
                                                                        {
                                                                            height: 10,
                                                                        },
                                                                        {
                                                                            type: "wide",
                                                                            cols: [
                                                                                vlanInput,
                                                                                ipDst
                                                                            ]
                                                                        }
                                                                    ]
                                                                }

                                                                const layout = [
                                                                    {
                                                                        rows:[
                                                                            {
                                                                                type: "wide",
                                                                                cols: [
                                                                                    typeInput,
                                                                                    // typeSelect,
                                                                                    {
                                                                                        cols: [
                                                                                            textInput,
                                                                                            subscriberButton
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            customPCAPForm
                                                                        ]
                                                                    },
                                                                    ..._this.IspsList.ViewConfig
                                                                ];

                                                                return layout;
                                                            }()
                                                        },
                                                        {height: 20},
                                                        {
                                                            type:"wide",
                                                            cols: function () {
                                                                const cols = [];

                                                                if (_this.CustomFormPCAP)
                                                                {
                                                                    cols.push(
                                                                        {
                                                                            view:"spectre_combo",
                                                                            id:_this.Id + "RuleRangeTimepicker",
                                                                            name:"timepicker",
                                                                            label:LangHelper.GetString("UlrModule","Recording duration"),
                                                                            value: "1 hour",
                                                                            width: 250,
                                                                            options: {
                                                                                point: false,
                                                                                data: Helper.DictToArr(RecordPCAPRangePickerRangesEnum)
                                                                            },
                                                                        },
                                                                    );
                                                                }

                                                                cols.push(
                                                                    {
                                                                        view:"spectre_button",
                                                                        id:_this.Id + "SetRuleBtn",
                                                                        css:"form_button main_action",
                                                                        label: _this.CustomFormPCAP ?
                                                                            LangHelper.GetString("UlrModule","Start now") :
                                                                            LangHelper.GetString("UlrModule", "Add"),
                                                                        autowidth:true,
                                                                        click:function ()
                                                                        {
                                                                            setTimeout(function () {
                                                                                _this.SaveRule(true, "start now");
                                                                            },1);
                                                                        }
                                                                    }
                                                                );

                                                                if (_this.CustomFormPCAP)
                                                                {
                                                                    cols.push(
                                                                        {
                                                                            view:"spectre_button",
                                                                            id:_this.Id + "SetPendingRuleBtn",
                                                                            css:"form_button main_action",
                                                                            label: LangHelper.GetString("UlrModule","Pending start"),
                                                                            autowidth:true,
                                                                            click:function (Id, E, Node)
                                                                            {
                                                                                const
                                                                                    node = this.getNode(),
                                                                                    form = _this.Views.TimetableSetDataForm;

                                                                                _this.ResetForm(form);

                                                                                _this.DateTimetableSetDataForm.show(node, {pos: "top"});
                                                                            }
                                                                        },
                                                                    );
                                                                }

                                                                cols.push({});

                                                                return cols;
                                                            }()
                                                        },
                                                    ]
                                                }
                                            ]
                                        },
                                        // {height:32},
                                        BlockHeaderTemplate({
                                            title: Params && Params.BlockHeaderTemplateTableTitle ? Params.BlockHeaderTemplateTableTitle : LangHelper.GetString("UlrModule","Last entries of VIP subscribers"),
                                            icon:"",
                                            borderless:true
                                        }),
                                        // {height:32},
                                        _this.Views.ReportsWidgets.RulesReport.ViewConfig
                                    ]
                                }
                            )

                            return rows;
                        }()
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {
        ValuedSubscriber: new Rx.BehaviorSubject(null),
        RuleEnabled: new Rx.BehaviorSubject(0),
        RuleIspModeChanged: new Rx.BehaviorSubject(0)
    };
}

UlrSubscribersRulesViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress)
    {
        var view = _this.Views.SetRuleBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.EditPopupSaveBtn;
        InProgress ? view.disable() : view.enable();

        if (_this.CustomFormPCAP)
        {
            var view = _this.Views.SetPendingRuleBtn;
            InProgress ? view.disable() : view.enable();
        }
        //
        // var view = _this.Views.AsnInput;
        // InProgress ? view.disable() : view.enable();
        //
        // var view = _this.Views.PriorityInput;
        // InProgress ? view.disable() : view.enable();
        //
        // var view = _this.Views.RuleNameInput;
        // InProgress ? view.disable() : view.enable();
        //
        // var view = _this.Views.RuleDescriptionInput;
        // InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions[DicsEnum.UlrSubscribersTypesDic] = App.DicsManager.Signal[DicsEnum.UlrSubscribersTypesDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            var dic = App.DicsManager.GetDicAsArray(DicsEnum.UlrSubscribersTypesDic);

            dic = dic.sort(function(a,b){
                return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
            });

            _this.Views.SubscriberIdentityTypeInput.define("options", dic);
            _this.Views.SubscriberIdentityTypeInput.refresh();
        }
    });

    this.Subscriptions.RuleSaved = this.ViewModel.Signals.RuleProfileSaved.subscribe(function (Model)
    {
        if(Model)
        {
            _this.EditPopup.hide();
            _this.AddOrReplaceRuleModelInTable(Model);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",`${_this.NotificationTitle} rule`)+" # "+Model.rule_id+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.RuleProfileSaveError = this.ViewModel.Signals.RuleProfileSaveError.subscribe(function(ErrModel){
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RuleProfileDeleted = this.ViewModel.Signals.RuleProfileDeleted.subscribe(function (Model)
    {
        if(Model)
        {
            _this.RulesReportOnSuccessDelete(Model);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.NotificationTitle)+" # "+Model.rule_id+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.RuleProfileDeleteError = this.ViewModel.Signals.RuleProfileDeleteError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RuleEnableStateError = this.ViewModel.Signals.RuleEnableStateError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RuleEnableStateUpdated = this.ViewModel.Signals.RuleEnableStateUpdated.subscribe(function (Model)
    {
        if(Model)
        {
            _this.RuleEnableStateUpdated(Model);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", _this.NotificationTitle)+" # "+Model.rule_id+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    // this.Views.SubscriberIdentityTypeInput.attachEvent("onChange", function(Nv, Ov)
    // {
    //     let input = _this.Views.SubscriberIdentityTypeInput;
    //     let select = _this.Views.SubscriberIdentityTypeSelect;
    //
    //     input.show();
    //     select.hide();
    //
    //     let resourceRaw = _this.Views.SubscriberIdentityTypeInput.getValue();
    //
    //     _this.Signals.ValuedSubscriber.next(new UlrValuedResourceViewModel({resource_raw:resourceRaw, type_id: Nv}));
    // });

    App.DicsManager.Refresh({data: [DicsEnum.UlrSubscribersTypesDic]});
};

UlrSubscribersRulesViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.EditPopup = webix.ui(this.EditPopupConfig);

    this.IspsList.ViewDidLoad(Params);
    this.EditPopupIspsList.ViewDidLoad(Params);

    this.BindAll(Params);

    this.Refresh();
};

UlrSubscribersRulesViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    this.IspsList.Destroy();
    this.EditPopupIspsList.Destroy();
};

UlrSubscribersRulesViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.RulesReport.RefreshData();
};

UlrSubscribersRulesViewController.prototype.RefreshShortSubscribersTable = function ()
{
    this.Views.ReportsWidgets.SubscribersShortTableReport.RefreshData();
};

UlrSubscribersRulesViewController.prototype.AddOrReplaceRuleModelInTable = function(Model)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.RulesReport.Views.Table;

    var model = Model;

    var data = table.find(function(obj)
    {
        return obj.rule_id == model.rule_id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        table.updateItem(data.id, model);
        table.select(data.id)
    }
    else
    {
        model.id = webix.uid();
        table.add(model,0);
        table.select(model.id);
        table.hideOverlay();
        table.hideProgress();
    }
};

UlrSubscribersRulesViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrSubscribersRulesViewController.prototype.ShowEditForm = function()
{
    var table = this.Views.ReportsWidgets.RulesReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    this.Views.EditPopupForm.clear();
    this.Views.EditPopupForm.clearValidation();

    let check = [
        +data.resource_type_id === UlrWebRuleResourcesTypesMapEnum.ip,
        +data.resource_type_id === UlrWebRuleResourcesTypesMapEnum.cidr
    ];

    if(this.CustomFormPCAP && check.some(Boolean))
    {
        let resources = data.resource.split(" ")
            .filter(i => i.includes("="))
            .map(i => i.split("="))
            .reduce((acc, i) => {
                acc[i[0]] = i[1];
                return acc;
            }, {});

        this.Views.EditPopupForm.setValues(resources);
        this.Views.EditCustomPCAPForm.show()
    }
    else
    {
        this.Views.EditCustomPCAPForm.hide();
    }

    var label = this.EditFormLabel;
    label = label.replace("[TYPE]", data.resource_type);
    label = label.replace("[VALUE]", data.resource);
    this.Views.EditPopupLabel.define("label",label);
    this.Views.EditPopupLabel.refresh();

    var ispsVals = {};

    data.isps.split(",").forEach(function (Item)
    {
        if(Item && parseInt(Item) > 0)
        {
            ispsVals[""+parseInt(Item)] = 1;
        }
    });

    this.EditPopupIspsList.Views.ISPListForm.setValues(ispsVals);

    this.EditPopupIspsList.Views.RuleModeToggle.setValue(parseInt(data.mode_id));

    this.EditPopup.show();
};

UlrSubscribersRulesViewController.prototype.RulesReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.RulesReport.Views.Table;

    var data = table.getItem(Id);

    var node = table.getItemNode(Id);

    if(Id.column === 'edit')
    {
        _this.ShowEditForm();
    }
    if(Id.column === 'delete')
    {
        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteRule(data);
                    }
                }
            ]
        });
    }

    if (Id.column == "enabled") {
        _this.RulesReportOnCheck(Id.row, Id.column, data.enabled ? 0 : 1);
    }

    if(this.Id === "UlrRecordPCAP")
    {
        if(Id.column === "ip_dst")
        {
            if(_this.ScrollListPopup.isVisible())
            {
                _this.ScrollListPopup.hide();
                return;
            }

            this.ShowScrollListPopup(data, "ip_dst", node);
        }

        if(Id.column === "port")
        {
            if(_this.ScrollListPopup.isVisible())
            {
                _this.ScrollListPopup.hide();
                return;
            }

            this.ShowScrollListPopup(data, "port", node);
        }
    }
};

UlrSubscribersRulesViewController.prototype.ShowExportForm = function()
{
    this.ExportRulePopup.show();
};

UlrSubscribersRulesViewController.prototype.ValidateSubscriber = function()
{
    var _this = this;

    var vr = new UlrValuedResourceViewModel({
        resource_raw:this.Views.SubscriberIdentityInput.getValue(),
        type_id: this.Views.SubscriberIdentityTypeInput.getValue()
    });

    if(!vr.resource_raw || !vr.type_id)
        return;

    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.ip)
    {
        vr.validation_success = Helper.ValidateIPaddressPlusPort(vr.resource_raw);

        if(vr.validation_success)
            vr.ips = [vr.resource_raw];

        vr.try_validate = true;

        this.Signals.ValuedSubscriber.next(vr);
    }

    if(vr.type_id == UlrWebRuleResourcesTypesMapEnum.login)
    {
        vr.validation_success = true;
        vr.try_validate = true;
        _this.Signals.ValuedSubscriber.next(vr);
    }
};

UlrSubscribersRulesViewController.prototype.JustSaveRule = function(RuleModel)
{
    this.ViewModel.SaveRule(RuleModel);
};

UlrSubscribersRulesViewController.prototype.SaveEditForm = function()
{
    var table = this.Views.ReportsWidgets.RulesReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    if(!this.Views.EditPopupForm.validate())
        return;

    const values = this.Views.EditPopupForm.getValues();

    var mode = this.EditPopupIspsList.Signals.IspModeChanged.getValue();
    var model = {
        mode_id: mode == UlrWebRuleModesEnum.only_isps_in_list ? UlrWebRuleModesEnum.only_isps_in_list : UlrWebRuleModesEnum.all_isps,
        isps: []
    };

    let check = [
        +data.resource_type_id === UlrWebRuleResourcesTypesMapEnum.ip,
        +data.resource_type_id === UlrWebRuleResourcesTypesMapEnum.cidr
    ];

    if(this.CustomFormPCAP && check.some(Boolean))
    {
        let
            [resource, ...config] = data.resource.split(" "),
            port = values.port ? values.port : "",
            proto = UlrPcapRecordingProtoDic[values.proto] ? UlrPcapRecordingProtoDic[values.proto].value : "",
            vlan = values.vlan ? values.vlan : "",
            ip_dst = values.ip_dst ? values.ip_dst : "";

        model.resource = `${resource} port=${port} proto=${proto} vlan=${vlan} ip_dst=${ip_dst}`;
    }

    if(model.mode_id == UlrWebRuleModesEnum.only_isps_in_list)
    {
        var isps = this.EditPopupIspsList.Views.ISPListForm.getValues();
        Object.keys(isps).forEach(function(Key){
            if(isps[Key] == 1)
            {
                model.isps.push(Key);
            }
        });
    }

    model.isps = model.isps.join(",");

    this.JustSaveRule(webix.extend(data, model, true));
};

UlrSubscribersRulesViewController.prototype.SaveRule = function(Enable, SaveAction = false)
{
    const _this = this;
    this.Views.AddSubscriberForm.clearValidation();
    var valid = true;

    var values = this.Views.AddSubscriberForm.getValues();

    let invalidMark = LangHelper.GetString("UlrModule", "Field is required");
    let invalidId = "type_id"

    switch(values.type_id)
    {
        case UlrWebRuleResourcesTypesMapEnum.ip:
            invalidId = "resource_raw"
            invalidMark = LangHelper.GetString("UlrModule", "Input correct IP address");
            valid = Helper.ValidateIPv6(values.resource_raw) || Helper.ValidateIPv4(values.resource_raw);
            break;
        case UlrWebRuleResourcesTypesMapEnum.cidr:
            invalidId = "resource_raw"
            invalidMark = LangHelper.GetString("UlrModule", "Input correct IPs or prefixes");

            let valid_ipv4 = false;
            let valid_ipv6 = false;

            if (Helper.UlrValidateCidrIpv4(values.resource_raw, true))
            {
                valid = true;
                valid_ipv4 = true;
            }
            else if(Helper.UlrValidateCidrIpv6(values.resource_raw, true))
            {
                valid = true;
                valid_ipv6 = true;
            }

            if(valid)
            {
                let res_parts = values.resource_raw.split('/');
                if
                (
                    res_parts.length !== 2 ||
                    !res_parts[1] ||
                    (
                        valid_ipv6 ?
                            parseInt(res_parts[1]) < (AppEnv.ipv6_cidr ? AppEnv.ipv6_cidr : 64) :
                            parseInt(res_parts[1]) < (AppEnv.ipv4_cidr ? AppEnv.ipv4_cidr : 16))
                )
                {
                    valid = false;
                }
            }

            break;
        case UlrWebRuleResourcesTypesMapEnum.login:
            break;
        default:
            valid = false;
    }

    if(!valid)
        this.Views.AddSubscriberForm.markInvalid(invalidId, invalidMark);

    if(this.CustomFormPCAP)
    {
        let checks = [
            this.Views.AddSubscriberForm.elements.port.validate(),
            this.Views.AddSubscriberForm.elements.vlan.validate(),
            this.Views.AddSubscriberForm.elements.ip_dst.validate()
        ];

        if(!checks.every(Boolean))
            valid = false;
    }

    if(!valid)
        return;

    var model = {
        resource_type_id: values.type_id,
        resource: values.resource_raw ? values.resource_raw : "",
        isps: [],
        mode_id: UlrWebRuleModesEnum.all_isps
    }

    if(this.CustomFormPCAP)
    {
        model.resource = ["port", "proto", "vlan", "ip_dst"].reduce((acc, i) => {
            acc += ` ${i}=${values[i] ? values[i] : ""}`
            return acc;
        }, `${values.resource_raw}`);
    }

    var mode = this.IspsList.Signals.IspModeChanged.getValue();
    model.mode_id = mode == UlrWebRuleModesEnum.only_isps_in_list ? UlrWebRuleModesEnum.only_isps_in_list : UlrWebRuleModesEnum.all_isps;

    if (this.CustomFormPCAP) {
        const state = {};

        if (SaveAction == "start now")
        {
            state.start_time = Helper.RoundDateToSeconds(new Date());
            const getDefaultTimepickerValue = this.Views.RuleRangeTimepicker.getValue();
            const timepicker_split = getDefaultTimepickerValue.split(" ");
            const start_time = new Date(state.start_time);
            state.end_time = webix.Date.add(start_time, parseInt(timepicker_split[0], 10), timepicker_split[1]);
        }
        else if (SaveAction == "pending start")
        {
            const
                form = this.Views.TimetableSetDataForm,
                state_start_now = form.elements["toggle_datepicker"].getValue();

            form.clearValidation();

            if (!form.validate())
                return;

            if (state_start_now == 1)
            {
                state.start_time = Helper.RoundDateToSeconds(new Date());
            }
            else
            {
                state.start_time = new Date(form.elements["date_from_picker"].getValue());

                if (state.start_time < new Date()) {
                    form.markInvalid("date_from_picker", LangHelper.GetString("UlrModule", "You can't specify a date less than the current date"));
                    return
                }
            }

            const getSetFormTimepickerValue = form.elements["timepicker"].getValue();
            const timepicker_split = getSetFormTimepickerValue.split(" ");
            const start_time = new Date(state.start_time);
            state.end_time = webix.Date.add(start_time, parseInt(timepicker_split[0], 10), timepicker_split[1]);
        }

        model.state = JSON.stringify(state);
    }

    if(mode == UlrWebRuleModesEnum.only_isps_in_list)
    {
        var isps = this.IspsList.Views.ISPListForm.getValues();
        Object.keys(isps).forEach(function(Key){
            if(isps[Key] == 1)
            {
                model.isps.push(Key);
            }
        });
    }

    model.isps = model.isps.join(",");

    this.ViewModel.SaveRule(webix.extend(model, {callback:function (R)
    {
        if (SaveAction == "pending start")
            _this.DateTimetableSetDataForm.hide();
    }}));
};

UlrSubscribersRulesViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrSubscribersRulesViewController.prototype.RulesReportOnSuccessDelete = function(Model)
{
    var table = this.Views.ReportsWidgets.RulesReport.Views.Table;

    var data = table.find(function(obj){
        return obj.rule_id == Model.rule_id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }
};

UlrSubscribersRulesViewController.prototype.RuleEnableStateUpdated = function(Model)
{
    var table = this.Views.ReportsWidgets.RulesReport.Views.Table;

    var data = table.find(function(obj)
    {
        return obj.rule_id == Model.rule_id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = parseInt(Model.enabled);
        table.updateItem(data.id, data);
    }
};

UlrSubscribersRulesViewController.prototype.RulesReportOnCheck = function(Row, Column, State)
{
    const
        table = this.Views.ReportsWidgets.RulesReport.Views.Table,
        form = this.Views.TimetableEditDataForm;

    table.select(Row);
    var data = table.getSelectedItem();

    if (Column == "enabled")
    {
        this.ResetForm(form);

        if (State && this.DateTimetableEditDataForm)
        {
            this.DateTimetableEditDataForm.show();
        }
        else
        {
            data.state = JSON.stringify({
                "start_time": null,
                "end_time": Helper.RoundDateToSeconds(new Date())
            });

            this.ViewModel.EnableDisableRule(webix.extend(data, {callback:function (R)
                {
                    if(!R.success)
                    {
                        data.enabled = State ? 0 : 1;

                        table.updateItem(data.id, data);
                    }
                }}), State);

        }
    }
};

UlrSubscribersRulesViewController.prototype.EnableRule = function () {
    const
        _this = this,
        table = this.Views.ReportsWidgets.RulesReport.Views.Table,
        data = table.getSelectedItem(),
        form = this.Views.TimetableEditDataForm,
        state_start_now = form.elements["toggle_datepicker"].getValue(),
        state = {};

    if (!form.validate())
        return;

    if (state_start_now == 1)
    {
        state.start_time = Helper.RoundDateToSeconds(new Date());
    }
    else
    {
        state.start_time = new Date(form.elements["date_from_picker"].getValue());

        if (state.start_time < new Date()) {
            form.markInvalid("date_from_picker", LangHelper.GetString("UlrModule", "You can't specify a date less than the current date"));
            return
        }
    }

    const getEditFormTimepickerValue = form.elements["timepicker"].getValue();
    const timepicker_split = getEditFormTimepickerValue.split(" ");
    const start_time = new Date(state.start_time);
    state.end_time = webix.Date.add(start_time, parseInt(timepicker_split[0], 10), timepicker_split[1]);

    data.state = JSON.stringify(state);

    this.ViewModel.EnableDisableRule(webix.extend(data, {callback:function (R)
        {
            if(!R.success)
            {
                data.enabled = data.enabled ? 0 : 1;

                table.updateItem(data.id, data);
            }
        }}), data.enabled);

    _this.DateTimetableEditDataForm.hide();
}

UlrSubscribersRulesViewController.prototype.SelectSubscriber = function () {
    const typeValue = +this.Views.SubscriberIdentityTypeInput.getValue();

    if(typeValue != UlrWebRuleResourcesTypesMapEnum.ip && typeValue != UlrWebRuleResourcesTypesMapEnum.login){
        UlrShowMessage(
            "info",
            LangHelper.GetString("UlrModule","Rules type not selected")
        );
        this.SubscribersSelectPopup.hide();
        return;
    }

    const subscribersShortTable = this.Views.ReportsWidgets.SubscribersShortTableReport.Views.Table;
    const selectedItem = subscribersShortTable.getSelectedItem();

    if(selectedItem) {
        let value;

        switch (typeValue) {
            case UlrWebRuleResourcesTypesMapEnum.ip:
                value = selectedItem.ip;
                break;
            case UlrWebRuleResourcesTypesMapEnum.login:
                value = selectedItem.login;
                break;
        }

        this.Views.SubscriberIdentityInput.setValue(value);
        this.SubscribersSelectPopup.hide();
    } else {
        UlrShowMessage(
            "info",
            LangHelper.GetString("UlrModule","Subscriber not selected")
        );
    }
};

UlrSubscribersRulesViewController.prototype.HideEditTimetablePopup = function () {
    const
        table = this.Views.ReportsWidgets.RulesReport.Views.Table,
        data = table.getSelectedItem(),
        form = this.Views.TimetableEditDataForm;

    data.enabled = data.enabled == 1 ? 0 : 1;

    table.updateItem(data.id, data);

    this.DateTimetableEditDataForm.hide();

    this.ResetForm(form);
};

UlrSubscribersRulesViewController.prototype.ResetForm = function (Form) {
    if(Form && Form.elements)
    {
        Form.elements["date_from_picker"].enable();
        Form.elements["date_from_picker"].setValue("");
        Form.elements["timepicker"].setValue("1 hour");
        Form.elements["toggle_datepicker"].setValue(0);
    }
};

UlrSubscribersRulesViewController.prototype.ValidatePortInput = function(Val)
{
    if(Val == "")
        return true

    if(Val.length > 200)
        return false

    let res = true;

    try
    {
        let vals = Val.replace(/\s+/g, "").split(',');

        for(let item of vals)
        {
            if(item.includes('-')) {
                let range = item.split('-');

                if (range.length !== 2 ||
                    range.some(I => !/^\d+$/.test(I)) ||
                    parseInt(range[0]) >= parseInt(range[1]) ||
                    parseInt(range[0]) < 1 ||
                    parseInt(range[1]) > 65535)
                {
                    res = false;
                    break;
                }
            }
            else
            {
                if (!/^\d+$/.test(item) ||
                    parseInt(item) < 1 ||
                    parseInt(item) > 65535)
                {
                    res = false;
                    break;
                }
            }
        }
    }
    catch(error)
    {
        res = false;
    }

    return res;
};

UlrSubscribersRulesViewController.prototype.ShowScrollListPopup = function(Data, Prop, Node)
{
    let vals_list;

    if(Data.resource_type === "IP")
    {
        let resources = Data.resource.split(" ")
            .filter(i => i.includes("="))
            .map(i => i.split("="))
            .reduce((acc, i) => {
                acc[i[0]] = i[1];
                return acc;
            }, {});

        vals_list = resources[Prop] ? resources[Prop] : "";
    }

    if(vals_list && vals_list.includes(","))
    {
        this.Views.ScrollListPopupArea.clearAll();

        this.Views.ScrollListPopupArea.define("data", vals_list.split(","));
        this.Views.ScrollListPopupArea.refresh();

        this.ScrollListPopup.show(Node, {pos:"left"});
    }
};
function UlrIgwsListViewController(Params)
{
    var _this = this;

    this.Id = "UlrIgwsList";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Profile management"),
        Title:LangHelper.GetString("UlrModule","Sites list")
    };

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new UlrIgwsManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        Widgets:{},
        ReportsWidgets:
        {
            IgwsReport: UrlIgwsTableWidget({
                id:this.Id + "IgwsReport",
                enableTextSearch:1,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.IgwsReportOnItemClick(Id, E, Node);
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title:this.PageTitle.Title}),
                            {height:32},
                            {
                                view:"label",
                                css:"form_text_label",
                                label:LangHelper.GetString("UlrModule","Select IGW profile from the list")
                            },
                            this.Views.ReportsWidgets.IgwsReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrIgwsListViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.IgwProfileDeleteError = this.ViewModel.Signals.IgwProfileDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.IgwProfileDeleted = this.ViewModel.Signals.IgwProfileDeleted.subscribe(function (IgwModel)
    {
        if(IgwModel)
        {
            _this.IgwsReportOnSuccessDelete(IgwModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","IGW profile")+" # "+IgwModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });
};

UlrIgwsListViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrIgwsListViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrIgwsListViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.IgwsReport.RefreshData();
};

UlrIgwsListViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrIgwsListViewController.prototype.IgwsReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.ReportsWidgets.IgwsReport.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: ControllersEnum.UlrEditIgw, path:"/_id=" + data._id});
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.IgwsReport.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteIgwProfile(data);
                    }
                }
            ]
        });
    }
};

UlrIgwsListViewController.prototype.IgwsReportOnSuccessDelete = function(IgwModel)
{
    var table = this.Views.ReportsWidgets.IgwsReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == IgwModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }

};

UlrIgwsListViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};
function UlrIspsSubsListViewController(Params)
{
    var _this = this;

    this.Id = Params && Params.Id ? Params.Id : "UlrIspsList";

    this.IsSubscribers = Params && Params.IsSubscribers ? Params.IsSubscribers : false;

    this.PageTitle = {
        RootTitle: LangHelper.GetString("UlrModule","Profile management"),
        Title: LangHelper.GetString("UlrModule",this.IsSubscribers ? "Subscribers list" : "Channels management")
    };

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new UlrIspsManager();
    this.IspSessionPolicingManager = new UlrIspSessionPolicingsManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ToolsSubmenu: null,
        SessionPolicingPopupCheckbox: null,
        ToolsBtn: null,


        SessionPolicingSchedulePopupCheckbox: null,
        SessionPolicingScheduleApplyBtn: null,
        Widgets: {
            PolicingForm: new UlrEditSessionPolicingProtocolsFormWidget({
                id: this.Id + "UlrEditSessionPolicingFormWidget",
                reportAutoHeight: false,
                commonSessionsExtended: true
            }),
            SessionPolicingScheduleWidget: new UlrEditSessionPolicingScheduleWidget({
                id: this.Id + "UlrEditSessionPolicingScheduleWidget",
                template_type: UlrPolicingTemplatesTypesDic.session.id,
                left_margin: 8,
                is_multi: 1
            })
        },
        ReportsWidgets: {
            Report: (this.IsSubscribers ? UlrSubsListTableWidget : UlrIspsTableWidget)({
                id: this.Id + "IspsReport",
                enableTextSearch:true,
                enableAutoHeight:true,
                linkEdit: true,
                onItemClick:function (Id, E, Node)
                {
                    _this.ReportOnItemClick(Id, E, Node);
                },
                onCheck: function(Row, Column, State)
                {
                    _this.IspsReportOnCheck(Row, Column, State);
                }
            })
        }
    };

    this.ToolsSubmenu = webix.ui({
        view: "submenu",
        id: this.Id + "ToolsSubmenu",
        width: 200,
        autowidth: true,
        padding: 0,
        data: [
            {
                id: _this.Id + "ToolsSubmenu" + "DSCPPerSession", icon: "tasks", value: LangHelper.GetString("UlrModule", "DSCP & Per-session"),
                submenu:[
                    {
                        id: _this.Id + "ToolsSubmenu" + "SetPerSessionPolicing", icon: "pencil", value: LangHelper.GetString("UlrModule", "Set per-session policing")
                    },
                    {id: _this.Id + "TraceIpSeparator", $template: "Separator"},
                    {
                        id: _this.Id + "ToolsSubmenu" + "EnablePerSessionPolicing",
                        icon: "lightbulb bold green",
                        value: LangHelper.GetString("UlrModule", "Enable per-session policing")
                    },
                    {
                        id: _this.Id + "ToolsSubmenu" + "DisablePerSessionPolicing",
                        icon: "lightbulb red",
                        value: LangHelper.GetString("UlrModule", "Disable per-session policing")
                    },
                    {
                        id: _this.Id + "ToolsSubmenu" + "DeletePerSessionPolicing",
                        icon: "trash",
                        value: LangHelper.GetString("UlrModule", "Clear per-session policing")
                    },
                    {id: _this.Id + "SessionPolicingMenuSeparator1", $template: "Separator"},
                    {
                        id: _this.Id + "ToolsSubmenu" + "SetPerSessionPolicingSchedule", icon: "stopwatch", value: LangHelper.GetString("UlrModule", "Set per-session policing schedule")
                    },
                    {id: _this.Id + "SessionPolicingMenuSeparator2", $template: "Separator"},
                    {
                        id: _this.Id + "ToolsSubmenu" + "EnablePerSessionPolicingSchedule",
                        icon: "stopwatch green",
                        value: LangHelper.GetString("UlrModule", "Enable per-session policing schedule")
                    },
                    {
                        id: _this.Id + "ToolsSubmenu" + "DisablePerSessionPolicingSchedule",
                        icon: "stopwatch red",
                        value: LangHelper.GetString("UlrModule", "Disable per-session policing schedule")
                    },
                    {
                        id: _this.Id + "ToolsSubmenu" + "DeletePerSessionPolicingSchedule",
                        icon: "trash",
                        value: LangHelper.GetString("UlrModule", "Clear per-session policing schedule")
                    },
                ]
            },
            {
                id: _this.Id + "IspProfile", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Channel profile"),
                submenu:[
                    {
                        id: _this.Id + "ToolsSubmenu" + "EnableProfiles",
                        icon: "lightbulb bold green",
                        value: LangHelper.GetString("UlrModule", "Enable profiles")
                    },
                    {
                        id: _this.Id + "ToolsSubmenu" + "DisableProfiles",
                        icon: "lightbulb red",
                        value: LangHelper.GetString("UlrModule", "Disable profiles")
                    },
                ]
            }
        ],
        on: {
            onMenuItemClick: function (Id)
            {
                let selectedRows = _this.Views.ReportsWidgets.Report.GetSelectedData();

                if(Id === _this.Id + "ToolsSubmenu" + "SetPerSessionPolicing")
                {
                    _this.SetSessionPolicingPopup.show();
                    this.hide();
                }

                if(Id ===  _this.Id + "ToolsSubmenu" + "EnablePerSessionPolicing")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        selectedRows.forEach(RowData => {
                            _this.EnableDisableSessionPolicing(RowData, 1);
                        })
                    }
                }

                if(Id ===  _this.Id + "ToolsSubmenu" + "DisablePerSessionPolicing")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        selectedRows.forEach(RowData => {
                            _this.EnableDisableSessionPolicing(RowData, 0);
                        })
                    }
                }

                if (Id === _this.Id + "ToolsSubmenu" + "DeletePerSessionPolicing")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        selectedRows.forEach(RowData => {
                            if (RowData.session_policing_id) {
                                _this.IspSessionPolicingManager.DeleteProfile({
                                    _id:RowData.session_policing_id,
                                    isp_id:RowData._id
                                });
                            }
                        })
                    }
                }

                if (Id === _this.Id + "ToolsSubmenu" + "EnableProfiles")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        selectedRows.forEach(RowData => {
                            if (RowData.enabled != 1)
                            {
                                _this.ViewModel.EnableDisableIspProfile(RowData, 1);
                            }
                        })
                    }
                }

                if (Id === _this.Id + "ToolsSubmenu" + "DisableProfiles")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        selectedRows.forEach(RowData => {
                            if (RowData.enabled != 0)
                            {
                                _this.ViewModel.EnableDisableIspProfile(RowData, 0);
                            }
                        })
                    }
                }

                if(Id === _this.Id + "ToolsSubmenu" + "SetPerSessionPolicingSchedule")
                {
                    _this.SetSessionPolicingScheduleFormToDefault();
                    _this.SetSessionPolicingSchedulePopup.show();
                    this.hide();
                }

                if(Id === _this.Id  + "ToolsSubmenu" + "EnablePerSessionPolicingSchedule")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        selectedRows.forEach(RowData => {
                            _this.EnableDisableSessionPolicingSchedule(RowData, 1);
                        })
                    }
                }

                if(Id === _this.Id + "ToolsSubmenu" + "DisablePerSessionPolicingSchedule")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        selectedRows.forEach(RowData => {
                            _this.EnableDisableSessionPolicingSchedule(RowData, 0);
                        })
                    }
                }

                if(Id === _this.Id + "ToolsSubmenu" + "DeletePerSessionPolicingSchedule")
                {
                    if (selectedRows && selectedRows.length)
                    {
                        selectedRows.forEach(RowData => {
                            _this.ClearIspSessionPolicingSchedule(RowData);
                        });
                    }
                }
            }
        }
    });

    this.SetSessionPolicingPopup = webix.ui({
        view: "window",
        css:"spectre-alert form_modal",
        width:1080,
        height: 880,
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head: {
            view: "toolbar",
            cols: [
                {
                    view: "label",
                    id: this.Id + "EditPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule", "Set per-session policing for selected profiles"),
                    height: 68
                },
                {
                    view: "spectre_button",
                    css: "form_button spec_action with_icon",
                    type: "icon",
                    icon: "times",
                    align: "right",
                    width: 68,
                    height: 68,
                    click: function()
                    {
                        _this.Views.Widgets.PolicingForm.SetFormToDefault();
                        _this.SetSessionPolicingPopup.hide();
                    }
                }
            ]
        },
        body:
            {
                type: "wide",
                rows:[
                    {
                        view:"scrollview",
                        scroll:"y",
                        body:{
                            type: "wide",
                            rows:[
                                _this.Views.Widgets.PolicingForm.ViewConfig
                            ]
                        }
                    },
                    {
                        type: "space",
                        borderless: true,
                        cols: [
                            {
                                view: "spectre_button",
                                id: this.Id + "ApplyBtn",
                                css: "form_button main_action",
                                label: LangHelper.GetString("UlrModule", "Apply"),
                                autowidth: true,
                                click: function () {
                                    _this.SetSessionPolicing(1);
                                }
                            },
                            {
                                view: "spectre_button",
                                id: this.Id + "ApplyDisableBtn",
                                css: "form_button second_action",
                                label: LangHelper.GetString("UlrModule", "Apply and disable"),
                                autowidth: true,
                                click: function () {
                                    _this.SetSessionPolicing(0);
                                }
                            },
                            {
                                view: "spectre_button",
                                id: this.Id + "CancelBtn",
                                css: "form_button spec_action",
                                label: LangHelper.GetString("UlrModule", "Cancel"),
                                autowidth: true,
                                click: function () {
                                    _this.Views.Widgets.PolicingForm.SetFormToDefault();
                                    _this.SetSessionPolicingPopup.hide();
                                }
                            },
                            // {},
                            {
                                view: "spectre_button",
                                id: this.Id + "CommonPolicingsBtn",
                                css: "form_button spec_action",
                                label: LangHelper.GetString("UlrModule", "Upload common"),
                                // autowidth: true,
                                click: function () {
                                    _this.GetSessionPolicingsByIds("common");
                                }
                            },
                            {
                                view: "spectre_button",
                                id: this.Id + "UniqPolicingsBtn",
                                css: "form_button spec_action",
                                label: LangHelper.GetString("UlrModule", "Upload different"),
                                // autowidth: true,
                                click: function () {
                                    _this.GetSessionPolicingsByIds("uniq");
                                }
                            }
                        ]
                    }
                ]

            }
    });

    this.SetSessionPolicingSchedulePopup = webix.ui({
        view: "window",
        css:"spectre-alert form_modal",
        height: 880,
        width:1080,
        modal:true,
        position:"center",
        padding:0,
        margin:0,
        head: {
            view: "toolbar",
            cols: [
                {
                    view: "label",
                    id: this.Id + "EditPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule", "Set per-session policing schedule for selected profiles"),
                    height: 68
                },
                {
                    view: "spectre_button",
                    css: "form_button spec_action with_icon",
                    type: "icon",
                    icon: "times",
                    align: "right",
                    width: 68,
                    height: 68,
                    click: function()
                    {
                        _this.SetSessionPolicingSchedulePopup.hide();
                        _this.SetSessionPolicingScheduleFormToDefault();
                    }
                }
            ]
        },
        body:
            {
                width:1080,
                type: "wide",
                rows:[
                    {
                        view:"scrollview",
                        scroll:"y",
                        body:{
                            type: "wide",
                            rows:[
                                {
                                    rows: [
                                        _this.Views.Widgets.SessionPolicingScheduleWidget.ViewConfig
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        cols: [
                            {
                                width: 24
                            },
                            {
                                view: "spectre_toggle",
                                id: this.Id + "SessionPolicingSchedulePopupCheckbox",
                                // label: LangHelper.GetString("UlrModule", "Clear session policing"),
                                value: false,
                                width: 32,
                                height: 22
                            },
                            {
                                width: webix.html.getTextSize(LangHelper.GetString("UlrModule","Clear current schedule").replace(" ", "_"), "app_block__header_webix_template").width + 32,
                                rows: [
                                    {
                                        cols: [
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","Clear current schedule"),
                                                icon:"",
                                                borderless:true
                                            })
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        type: "space",
                        borderless: true,
                        cols: [
                            {
                                view: "spectre_button",
                                id: this.Id + "SessionPolicingScheduleApplyBtn",
                                css: "form_button main_action",
                                label: LangHelper.GetString("UlrModule", "Apply"),
                                autowidth: true,
                                click: function ()
                                {
                                    _this.MultiplySetIspSessionPolicingSchedule();
                                }
                            },
                            {
                                view: "spectre_button",
                                id: this.Id + "CancelScheduleBtn",
                                css: "form_button spec_action",
                                label: LangHelper.GetString("UlrModule", "Cancel"),
                                autowidth: true,
                                click: function () {
                                    _this.SetSessionPolicingScheduleFormToDefault();
                                    _this.SetSessionPolicingSchedulePopup.hide();
                                }
                            },
                            {},
                            {
                                view: "spectre_button",
                                id: this.Id + "CommonPolicingsScheduleBtn",
                                css: "form_button spec_action",
                                label: LangHelper.GetString("UlrModule", "Upload common schedules"),
                                autowidth: true,
                                click: function () {
                                    _this.GetSessionPolicingsScheduleByIds();
                                }
                            },
                        ]
                    }
                ]

            }
    });

    this.ViewConfig = [
        {
            view: "scrollview",
            scroll: "y",
            body: {
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title:this.PageTitle.Title}),
                            {height: 32},
                            {
                                type: "wide",
                                rows: [
                                    {
                                        type: "wide",
                                        cols: [
                                            {
                                                view: "label",
                                                css: "form_text_label",
                                                label: LangHelper.GetString("UlrModule", this.IsSubscribers ? "Select Subscriber Profile from the list" : "Select ISP Profile from the list")
                                            },
                                            {
                                                view: "spectre_button",
                                                id: this.Id + "ToolsBtn",
                                                type: "icon",
                                                css: "form_button spec_action with_icon",
                                                label: LangHelper.GetString("UlrModule", "Tools"),
                                                icon: "tools",
                                                autowidth: true,
                                                click: function()
                                                {
                                                    _this.Views.ToolsSubmenu.show(this.getNode());
                                                }
                                            }
                                        ]
                                    },
                                    this.Views.ReportsWidgets.Report.ViewConfig
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrIspsSubsListViewController.prototype.ViewDidLoad = function (Params)
{
    this.BindAll(Params);
    this.Refresh();
};

UlrIspsSubsListViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function(View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View);
    });

    Object.keys(this.Views.Widgets).forEach(function(WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        var vm = _this.ViewModel;
        if(WidgetKey === "SessionPolicingScheduleWidget")
        {
            vm = _this.IspSessionPolicingManager;
        }

        if(w.BindAll)
            w.BindAll(_this, vm);

        if(w.Bind)
            w.Bind(_this, vm);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function(WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.IspProfileDeleted = this.ViewModel.Signals.IspProfileDeleted.subscribe(function(IspModel)
    {
        if(IspModel)
        {
            _this.IspsReportOnSuccessDelete(IspModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber profile" : "ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.IspProfileDeleteErr = this.ViewModel.Signals.IspProfileDeleteError.subscribe(function(Err)
    {
        if(Err)
        {
            _this.ShowServerError(Err);
        }
    });

    this.Subscriptions.IspProfileEnableStateUpdated = this.ViewModel.Signals.IspProfileEnableStateUpdated.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            _this.IspProfileEnableStateUpdated(IspModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber profile" : "ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.IspProfileEnableStateError = this.ViewModel.Signals.IspProfileEnableStateError.subscribe(function(Err)
    {
        if(Err)
        {
            _this.ShowServerError(Err);
        }
    });

    this.Subscriptions.FederalListStateUpdated = this.ViewModel.Signals.FederalListStateUpdated.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber profile" : "ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Global list state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.FederalListStateError = this.ViewModel.Signals.FederalListStateError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.ExcludedResourcesStateUpdated = this.ViewModel.Signals.ExcludedResourcesStateUpdated.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber profile" : "ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Exclusion list state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.ExcludedResourcesStateError = this.ViewModel.Signals.ExcludedResourcesStateError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.BlockIPv6StateUpdated = this.ViewModel.Signals.BlockIPv6StateUpdated.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber profile" : "ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Block IPv6 state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.BlockIPv6StateError = this.ViewModel.Signals.BlockIPv6StateError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.SpoofDnsStateUpdated = this.ViewModel.Signals.SpoofDnsStateUpdated.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber profile" : "ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Spoof DNS state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.SpoofDnsStateError = this.ViewModel.Signals.SpoofDnsStateError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.SessionPolicingProfileEnableStateUpdated = this.ViewModel.Signals.SessionPolicingProfileEnableStateUpdated.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            _this.Refresh();

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber Session policing Enabled/Disabled" : "ISP Session policing Enabled/Disabled"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.SessionPolicingProfileEnableStateError = this.ViewModel.Signals.SessionPolicingProfileEnableStateError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.PolicingProfileEnableStateUpdated = this.ViewModel.Signals.PolicingProfileEnableStateUpdated.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber policing Enabled/Disabled" :  "ISP policing Enabled/Disabled"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.PolicingProfileEnableStateError = this.ViewModel.Signals.PolicingProfileEnableStateError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.PolicingMultiplySetSuccess = this.IspSessionPolicingManager.Signals.PolicingMultiplySetSuccess.subscribe(function (Updated) {
        if(Updated)
        {
            _this.Refresh();

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Added new per-session policing profiles"),
                LangHelper.GetString("UlrModule","For selected profiles added new per-session policing profiles.")
            );
        }
    });

    this.Subscriptions.GetSessionPolicingsByIspIdsSuccess = this.IspSessionPolicingManager.Signals.GetSessionPolicingsByIspIdsSuccess.subscribe(function (Data) {
        if (Data)
        {
            _this.Views.Widgets.PolicingForm.AddProtocolsToForm(Data)
        }
    });

    this.Subscriptions.GetSessionPolicingsByIspIdsNotFound = this.IspSessionPolicingManager.Signals.GetSessionPolicingsByIspIdsNotFound.subscribe(function (Update) {
        if (Update)
        {
            UlrShowMessage(
                "info",
                LangHelper.GetString("UlrModule","No protocols found."),
            );
        }
    });

    this.Subscriptions.IspSessionPolicingManagerServerError = this.IspSessionPolicingManager.Signals.ServerError.subscribe(function (ErrModel) {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.PolicingProfileDeleted = this.IspSessionPolicingManager.Signals.PolicingProfileDeleted.subscribe(function (Updated) {
        if(Updated)
        {
            _this.Refresh();

            let profileName = "";

            if (Updated.isp_id)
            {
                let rows = _this.Views.ReportsWidgets.Report.Views.Table.serialize();
                let find = rows.find(item => {
                    return item._id === Updated.isp_id;
                })

                profileName =  find && find.name ? find.name : ""
            }

            UlrShowMessage(
                "success",
                profileName,
                LangHelper.GetString("UlrModule","Session policing removed.")
            );
        }
    });

    this.Subscriptions.PolicingProfileDeleteError = this.IspSessionPolicingManager.Signals.PolicingProfileDeleteError.subscribe(function (ErrModel) {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.IspProfileSelectedCount = this.Views.ReportsWidgets.Report.TableRowsSelectedCount.subscribe(function (Value) {
        if (Value > 1)
        {
            _this.Views.ToolsBtn.enable();
        }
        else
        {
            _this.Views.ToolsBtn.disable();
            if(_this.Views.ToolsSubmenu.isVisible())
            {
                _this.Views.ToolsSubmenu.hide();
            }
        }
    });

    this.Subscriptions.IspSessionPolicingScheduleUpdated = this.ViewModel.Signals.SessionPolicingScheduleStateUpdated.subscribe(function(IspModel)
    {
        if(IspModel)
        {
            _this.Refresh();

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber Session policing schedule Enabled/Disabled" : "ISP Session policing schedule Enabled/Disabled"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.SessionPolicingScheduleStateError = this.ViewModel.Signals.SessionPolicingScheduleStateError.subscribe(function(ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.SessionPolicingScheduleCleared = this.ViewModel.Signals.SessionPolicingScheduleCleared.subscribe(function(IspModel)
    {
        if(IspModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",_this.IsSubscribers ? "Subscriber Session policing schedule cleared" : "ISP Session policing schedule cleared"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.SessionPolicingScheduleClearError = this.ViewModel.Signals.SessionPolicingScheduleClearError.subscribe(function(ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.SessionPolicingSchedulesNotFound = this.IspSessionPolicingManager.Signals.SessionPolicingSchedulesNotFound.subscribe(function (Update) {
        if (Update)
        {
            UlrShowMessage(
                "info",
                LangHelper.GetString("UlrModule","No common schedules found."),
            );
        }
    });

    this.Subscriptions.SessionPolicingSchedulesSuccess = this.IspSessionPolicingManager.Signals.SessionPolicingSchedulesSuccess.subscribe(function(Update)
    {
        if(Update)
        {
            _this.Views.Widgets.SessionPolicingScheduleWidget.Views.ScheduleToggle.setValue(Update.enabled);

            if(Update.rows)
            {
                var table = _this.Views.Widgets.SessionPolicingScheduleWidget.Views.ReportsWidgets.SchedulesTable.Views.Table;

                table.clearAll();
                table.parse(Update.rows);
            }
        }
    });

    this.Subscriptions.SessionPolicingSchedulesError = this.IspSessionPolicingManager.Signals.SessionPolicingSchedulesError.subscribe(function(ErrModel)
    {
        if(ErrModel)
        {
            _this.ShowServerError(ErrModel);
        }
    });

    this.Subscriptions.SessionPolicingScheduleMultipleSuccess = this.IspSessionPolicingManager.Signals.SessionPolicingScheduleMultipleSuccess.subscribe(function(Updated){
        if(Updated)
        {
            if(Updated)
            {
                _this.Refresh();

                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Configured new per-session policing schedule"),
                    LangHelper.GetString("UlrModule","For selected profiles added new per-session policing schedule.")
                );
            }
        }
    });

    this.Views.ReportsWidgets.Report.Views.Table.attachEvent("onAfterSelect", function (Row) {
        var item = this.getItem(Row);

        if (item)
        {
            if (!parseInt(item.checked)) {
                item.checked = 1;
            }
            this.updateItem(Row, item);
        }
    });

    this.Views.ReportsWidgets.Report.Views.Table.attachEvent("onAfterUnSelect", function (Row) {
        var item = this.getItem(Row);

        if (item)
        {
            if (parseInt(item.checked)) {
                item.checked = 0;
            }
            this.updateItem(Row, item);
        }
    });
};

UlrIspsSubsListViewController.prototype.Destroy = function()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    if(this.IspSessionPolicingManager)
    {
        this.IspSessionPolicingManager.Destroy();
        delete this.IspSessionPolicingManager;
    }
};

UlrIspsSubsListViewController.prototype.Refresh = function ()
{
    let checkboxControl = this.Views.ReportsWidgets.Report.Views.Table.getHeaderContent("cm1");

    if (checkboxControl.isChecked())
    {
        checkboxControl.uncheck();
    }

    this.Views.ReportsWidgets.Report.RefreshData();
};

UlrIspsSubsListViewController.prototype.SetSessionPolicing = function (Enabled = null)
{
    var _this = this;

    if (!_this.Views.Widgets.PolicingForm.ValidateProtocolTable())
        return;

    let selectedIspProfiles = _this.Views.ReportsWidgets.Report.Views.Table.getSelectedItem();

    selectedIspProfiles = selectedIspProfiles.filter(function (Item)
    {
        return parseInt(Item.checked) ? true : false;
    });

    if(!selectedIspProfiles.length)
        return;

    let rows = _this.Views.Widgets.PolicingForm.Views.ReportsWidgets.ProtocolsReport.Views.Table.serialize();

    if(!rows.length)
    {
        UlrShowMessage(
            "error",
            LangHelper.GetString("UlrModule", "No protocol added."),
            LangHelper.GetString("UlrModule", "To set per-session policing for selected profiles, add at least one protocol.")
        );
        return;
    }

    let data = [];

    selectedIspProfiles.forEach(Profile => {

        let cfg_rows = [];

        rows.forEach(Row => {
            let policingModel = new SessionPolicingProtocolModel(Row);

            if(Row.$toDelete)
                policingModel.to_delete = 1;

            if(policingModel.type === UlrProtocolTypesDic.protocol.id)
            {
                cfg_rows.push(policingModel);
            }
            else
            {
                cfg_rows.unshift(policingModel);
            }
        });

        data.push({
            "isp_id": Profile._id,
            "description": Profile.name,
            "config": JSON.stringify(cfg_rows)});
    });

    let enabled = (Enabled === null || Enabled) ? 1 : 0;

    _this.IspSessionPolicingManager.MultiplySetIspSessionPolicing(data, enabled);

    _this.Views.Widgets.PolicingForm.SetFormToDefault();
    _this.SetSessionPolicingPopup.hide();
};

UlrIspsSubsListViewController.prototype.GetSessionPolicingsByIds = function (Type = "common")
{
    let selected = this.Views.ReportsWidgets.Report.Views.Table.getSelectedItem();

    selected = selected ? selected : [];

    let idsList = selected
        .filter(Item => Boolean(parseInt(Item.checked)))
        .map(Item => Item._id);

    if(!idsList.length)
        return

    this.IspSessionPolicingManager.GetSessionPolicingsByIspIds(idsList, Type);
};

UlrIspsSubsListViewController.prototype.EnableDisableSessionPolicing = function(RowData, State)
{
    let profileName = RowData && RowData.name ? RowData.name : "";

    if (RowData && RowData.session_policing_id)
    {
        if (RowData.session_policing_enabled != State)
        {
            this.ViewModel.EnableDisableSessionPolicingProfile({_id:RowData.session_policing_id}, State);
        }
        else
        {
            UlrShowMessage(
                "info",
                LangHelper.GetString("UlrModule", "Per-session policing for [PROFILE] is already " + ((State ? "enabled." : "disabled.")))
                    .replace("[PROFILE]", profileName)
            );
        }
    }
    else
    {
        UlrShowMessage(
            "error",
            LangHelper.GetString("UlrModule", "Profile name") + ": " + profileName,
            LangHelper.GetString("UlrModule", "To Enable/Disable per-session policing, it must be configured.")
        );
    }
};

UlrIspsSubsListViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrIspsSubsListViewController.prototype.ReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.ReportsWidgets.Report.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: this.IsSubscribers ? ControllersEnum.UlrEditSubs : ControllersEnum.UlrEditIsp, path:"/_id=" + data._id});
    }

    if(Id.column === 'policing_url')
    {
        var table = this.Views.ReportsWidgets.Report.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: _this.IsSubscribers ? 'UlrEditSubscriberPolicing' : 'UlrEditAppPolicing', path:"/_id=" + data._id + (_this.IsSubscribers ? "/source=UlrSubsList" : "/source=UlrIspsList")});
    }

    if(Id.column === 'session_policing_url')
    {
        var table = this.Views.ReportsWidgets.Report.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: _this.IsSubscribers ? 'UlrEditSubscriberSessionPolicing' : 'UlrEditIspSessionPolicing', path:"/_id=" + data._id + (_this.IsSubscribers ? "/source=UlrSubsList" : "/source=UlrIspsList")});
    }

    if(Id.column === 'session_policing_schedule_enabled')
    {
        var table = this.Views.ReportsWidgets.Report.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode({row: Id, column: 'session_policing_schedule_enabled'});

        var curr_state = parseInt(data.session_policing_schedule_enabled);
        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule",curr_state ? "Disable" : "Enable") + "?",
            mainTitle:LangHelper.GetString("UlrModule",curr_state ? "Disable" : "Enable") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel"),
                    click: function()
                    {}
                },
                {
                    label:LangHelper.GetString("UlrModule",curr_state ? "Disable" : "Enable"),
                    click:function ()
                    {
                        _this.ViewModel.EnableDisableSessionPolicingSchedule({_id: data.session_policing_id}, (curr_state + 1) % 2, function(R)
                        {});
                    }
                }
            ]
        });
    }

    if(Id.column === 'web_rule')
    {
        var table = this.Views.ReportsWidgets.Report.Views.Table;

        var data = table.getItem(Id);

        var total = data && data.total_web_rules && parseInt(data.total_web_rules) ? parseInt(data.total_web_rules) : 0;

        if(total > 0)
        {
            App.NavRouter.PresentView({id: 'UlrWebIpFilterRules', path:(_this.IsSubscribers ? "/sub_id=" : "/isp_id=") + data._id});
        }
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.Report.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteIspProfile(data);
                    }
                }
            ]
        });
    }
};

UlrIspsSubsListViewController.prototype.IspsReportOnCheck = function(Row, Column, State)
{
    var _this = this;
    var table = this.Views.ReportsWidgets.Report.Views.Table;

    var data = table.getItem(Row);

    if(Column == "checked") {

        var item = table.getItem(Row);

        if(item.checked)
        {
            table.select(Row, true)
        }
        else
        {
            table.unselect(Row);
        }
    }

    if(Column == 'enabled')
    {
        this.ViewModel.EnableDisableIspProfile(webix.extend(data, {callback:function (R)
            {
                if(!R.success)
                {
                    data.enabled = State ? 0 : 1;

                    table.updateItem(data.id, data);
                }
            }}), State);
    }

    if(Column == 'policing_enabled')
    {
        this.ViewModel.EnableDisableAppPolicingProfile(webix.extend({_id: data.policing_id}, {callback:function (R)
            {
                if(!R.success)
                {
                    data.policing_enabled = State ? 0 : 1;

                    table.updateItem(data.id, data);
                }
            }}), State);
    }

    if(Column == 'session_policing_enabled')
    {
        this.ViewModel.EnableDisableSessionPolicingProfile(webix.extend({_id: data.session_policing_id}, {callback:function (R)
            {
                if(!R.success)
                {
                    data.session_policing_enabled = State ? 0 : 1;

                    table.updateItem(data.id, data);
                }
            }}), State);
    }

    if(Column == 'federal_bl')
    {
        var node = table.getItemNode({row: Row, column: 'federal_bl'});
        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule",parseInt(data.federal_bl) ? "Enable" : "Disable") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule",parseInt(data.federal_bl) ? "Enable" : "Disable") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel"),
                    click: function()
                    {
                        data.federal_bl = State ? 0 : 1;

                        table.updateItem(data.id, data);
                    }
                },
                {
                    label:LangHelper.GetString("UlrModule",parseInt(data.federal_bl) ? "Enable" : "Disable"),
                    click:function ()
                    {
                        _this.ViewModel.EnableDisableFederalLists(data, parseInt(data.federal_bl), function(R)
                        {
                            if(!R.success)
                            {
                                data.federal_bl = State ? 0 : 1;

                                table.updateItem(data.id, data);
                            }
                        });
                    }
                }
            ]
        });
    }

    if(Column == 'web_rule_exclude')
    {
        var node = table.getItemNode({row: Row, column: 'web_rule_exclude'});
        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule",parseInt(data.web_rule_exclude) ? "Enable" : "Disable") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule",parseInt(data.web_rule_exclude) ? "Enable" : "Disable") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel"),
                    click: function()
                    {
                        data.web_rule_exclude = State ? 0 : 1;

                        table.updateItem(data.id, data);
                    }
                },
                {
                    label:LangHelper.GetString("UlrModule",parseInt(data.web_rule_exclude) ? "Enable" : "Disable"),
                    click:function ()
                    {
                        _this.ViewModel.EnableDisableExcludedResources(data, parseInt(data.web_rule_exclude), function(R)
                        {
                            if(!R.success)
                            {
                                data.web_rule_exclude = State ? 0 : 1;

                                table.updateItem(data.id, data);
                            }
                        });
                    }
                }
            ]
        });
    }

    if(Column == 'block_ipv6')
    {
        var node = table.getItemNode({row: Row, column: 'block_ipv6'});
        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule",parseInt(data.block_ipv6) ? "Enable" : "Disable") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule",parseInt(data.block_ipv6) ? "Enable" : "Disable") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel"),
                    click: function()
                    {
                        data.block_ipv6 = State ? 0 : 1;

                        table.updateItem(data.id, data);
                    }
                },
                {
                    label:LangHelper.GetString("UlrModule",parseInt(data.block_ipv6) ? "Enable" : "Disable"),
                    click:function ()
                    {
                        _this.ViewModel.EnableDisableBlockIPv6(data, parseInt(data.block_ipv6), function(R)
                        {
                            if(!R.success)
                            {
                                data.block_ipv6 = State ? 0 : 1;

                                table.updateItem(data.id, data);
                            }
                        });
                    }
                }
            ]
        });
    }

    if(Column == 'spoof_dns')
    {
        var node = table.getItemNode({row: Row, column: 'spoof_dns'});
        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule",parseInt(data.spoof_dns) ? "Enable" : "Disable") + "?",
            mainTitle:LangHelper.GetString("UlrModule",parseInt(data.spoof_dns) ? "Enable" : "Disable") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel"),
                    click: function()
                    {
                        data.spoof_dns = State ? 0 : 1;

                        table.updateItem(data.id, data);
                    }
                },
                {
                    label:LangHelper.GetString("UlrModule",parseInt(data.spoof_dns) ? "Enable" : "Disable"),
                    click:function ()
                    {
                        _this.ViewModel.EnableDisableSpoofDns(data, parseInt(data.spoof_dns), function(R)
                        {
                            if(!R.success)
                            {
                                data.spoof_dns = State ? 0 : 1;

                                table.updateItem(data.id, data);
                            }
                        });
                    }
                }
            ]
        });
    }

};

UlrIspsSubsListViewController.prototype.IspsReportOnSuccessDelete = function(IspModel)
{
    var table = this.Views.ReportsWidgets.Report.Views.Table;

    var data = table.find(function(obj){
        return obj._id == IspModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }
};

UlrIspsSubsListViewController.prototype.IspProfileEnableStateUpdated = function(IspModel)
{
    var table = this.Views.ReportsWidgets.Report.Views.Table;

    var data = table.find(function(obj){
        return obj._id == IspModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = IspModel.enabled;
        table.updateItem(data.id, data);
    }

};

UlrIspsSubsListViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrIspsSubsListViewController.prototype.EnableDisableSessionPolicingSchedule = function(RowData, State)
{
    let profileName = RowData && RowData.name ? RowData.name : "";

    if (RowData && RowData.session_policing_id)
    {
        if (RowData.session_policing_schedule_enabled != State)
        {
            this.ViewModel.EnableDisableSessionPolicingSchedule({_id:RowData.session_policing_id}, State);
        }
        else
        {
            UlrShowMessage(
                "info",
                LangHelper.GetString("UlrModule", "Per-session policing schedule for [PROFILE] is already " + ((State ? "enabled." : "disabled.")))
                    .replace("[PROFILE]", profileName)
            );
        }
    }
    else
    {
        UlrShowMessage(
            "error",
            LangHelper.GetString("UlrModule", "Profile name") + ": " + profileName,
            LangHelper.GetString("UlrModule", "To Enable/Disable per-session policing schedule, it must be configured.")
        );
    }
};

UlrIspsSubsListViewController.prototype.ClearIspSessionPolicingSchedule = function(RowData)
{
    let profileName = RowData && RowData.name ? RowData.name : "";

    if(RowData && RowData.session_policing_id)
    {
        this.ViewModel.ClearSessionPolicingSchedule({_id:RowData.session_policing_id});
    }
    else
    {
        UlrShowMessage(
            "error",
            LangHelper.GetString("UlrModule", "Profile name") + ": " + profileName,
            LangHelper.GetString("UlrModule", "To clear per-session policing schedule, it must be configured.")
        );
    }
};

UlrIspsSubsListViewController.prototype.GetSessionPolicingsScheduleByIds = function ()
{
    let _this = this;

    let selectedIspProfiles = _this.Views.ReportsWidgets.Report.Views.Table.getSelectedItem();

    selectedIspProfiles = selectedIspProfiles.filter(function (Item)
    {
        return parseInt(Item.checked) ? true : false;
    });

    if(!selectedIspProfiles.length)
        return;

    let profiles_ids = [];

    selectedIspProfiles.forEach(val => {
        profiles_ids.push(val._id);
    })

    _this.IspSessionPolicingManager.GetCommonSessionPolicingsScheduleByIspIds({data: profiles_ids});
};

UlrIspsSubsListViewController.prototype.MultiplySetIspSessionPolicingSchedule = function()
{
    var _this = this;

    let selectedIspProfiles = _this.Views.ReportsWidgets.Report.Views.Table.getSelectedItem();

    selectedIspProfiles = selectedIspProfiles.filter(function (Item)
    {
        return parseInt(Item.checked) ? true : false;
    });

    if(!selectedIspProfiles.length)
        return;

    let profiles_ids = [];

    selectedIspProfiles.forEach(val => {
        profiles_ids.push(val._id);
    });

    var enabled = this.Views.Widgets.SessionPolicingScheduleWidget.Views.ScheduleToggle.getValue();
    var delete_schedule = this.Views.SessionPolicingSchedulePopupCheckbox.getValue();
    var schedule = this.Views.Widgets.SessionPolicingScheduleWidget.GetScheduleUpdateData();

    this.IspSessionPolicingManager.MultiplySetIspSessionPolicingSchedule(profiles_ids, schedule.update, enabled, delete_schedule,function(R)
    {
        if(R.success)
        {
            _this.SetSessionPolicingSchedulePopup.hide();
            _this.SetSessionPolicingScheduleFormToDefault();
        }
    });
};

UlrIspsSubsListViewController.prototype.SetSessionPolicingScheduleFormToDefault = function()
{
    this.Views.Widgets.SessionPolicingScheduleWidget.Views.ScheduleToggle.setValue(false);
    this.Views.SessionPolicingSchedulePopupCheckbox.setValue(false);
    this.Views.Widgets.SessionPolicingScheduleWidget.Views.ReportsWidgets.SchedulesTable.Views.Table.clearAll();
};
function UlrSubsListViewController(Params)
{
    var _this = this;

    var params = webix.extend(Params,{
        IsSubscribers: true,
        Id: "UlrSubsList"
    }, true);

    UlrSubsListViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrSubsListViewController, UlrIspsSubsListViewController);
// function UlrSubsListViewController(Params)
// {
//     var _this = this;
//
//     this.Id = "UlrSubsList";
//
//     this.mode = module ? module : "dpiui2";
//
//     this.PageTitle = {
//         RootTitle:LangHelper.GetString("UlrModule","Profile management"),
//         Title:LangHelper.GetString("UlrModule","Subscribers list")
//     };
//
//     this.ViewModel = new UlrIspsManager();
//
//     this.IspSessionPolicingManager = new UlrIspSessionPolicingsManager();
//
//     this.ReportsModel = new UniReportsManager();
//
//     this.Views = {
//         ScrollView:null,
//         PageTitle:null,
//
//         ToolsBtn:null,
//         ToolsSubmenu:null,
//
//         GlobalWhitelistStateToggle:null,
//
//         SessionPolicingPopupCheckbox: null,
//
//         // SubscriberManagementEditView: null,
//         Widgets:{
//             PolicingForm: new UlrEditSessionPolicingProtocolsFormWidget({id: this.Id + "UlrEditSessionPolicingFormWidget", reportAutoHeight: false})
//         },
//         ReportsWidgets:{
//             SubscriberManagementReport: UlrSubsListTableWidget({
//                 id:this.Id + "SubscriberManagementReport",
//                 enableTextSearch:true,
//                 enableAutoHeight:1,
//                 linkEdit: true,
//                 onItemClick:function (Id, E, Node)
//                 {
//                     _this.SubscriberManagementReportOnItemClick(Id, E, Node);
//                 },
//                 onCheck:function (Row, Column, State)
//                 {
//                     _this.SubscriberManagementReportOnCheck(Row, Column, State);
//                 }
//             })
//         }
//     };
//
//     this.ToolsSubmenu = webix.ui({
//         view: "submenu",
//         id: _this.Id + "ToolsSubmenu",
//         width: 200,
//         autowidth: true,
//         padding: 0,
//         data: [
//             {
//                 id: _this.Id + "ToolsSubmenu" + "DSCPPerSession", icon: "tasks", value: LangHelper.GetString("UlrModule", "DSCP & Per-session"),
//                 submenu:[
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "SetPerSessionPolicing", icon: "pencil", value: LangHelper.GetString("UlrModule", "Set per-session policing")
//                     },
//                     {id: _this.Id + "TraceIpSeparator", $template: "Separator"},
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "EnablePerSessionPolicing",
//                         icon: "lightbulb bold green",
//                         value: LangHelper.GetString("UlrModule", "Enable per-session policing")
//                     },
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "DisablePerSessionPolicing",
//                         icon: "lightbulb red",
//                         value: LangHelper.GetString("UlrModule", "Disable per-session policing")
//                     },
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "DeletePerSessionPolicing",
//                         icon: "trash",
//                         value: LangHelper.GetString("UlrModule", "Clear per-session policing")
//                     },
//                 ]
//             },
//             {
//                 id: _this.Id + "IspProfile", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Channel profile"),
//                 submenu:[
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "EnableProfiles",
//                         icon: "lightbulb bold green",
//                         value: LangHelper.GetString("UlrModule", "Enable profiles")
//                     },
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "DisableProfiles",
//                         icon: "lightbulb red",
//                         value: LangHelper.GetString("UlrModule", "Disable profiles")
//                     },
//                 ]
//             }
//         ],
//         on: {
//             onMenuItemClick: function (Id)
//             {
//                 let selectedRows = _this.Views.ReportsWidgets.SubscriberManagementReport.GetSelectedData();
//
//                 if(Id === _this.Id + "ToolsSubmenu" + "SetPerSessionPolicing")
//                 {
//                     _this.SetSessionPolicingPopup.show();
//                     this.hide();
//                 }
//
//                 if(Id ===  _this.Id + "ToolsSubmenu" + "EnablePerSessionPolicing")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             _this.EnableDisableSessionPolicing(RowData, 1);
//                         })
//                     }
//                 }
//
//                 if(Id ===  _this.Id + "ToolsSubmenu" + "DisablePerSessionPolicing")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             _this.EnableDisableSessionPolicing(RowData, 0);
//                         })
//                     }
//                 }
//
//                 if (Id === _this.Id + "ToolsSubmenu" + "DeletePerSessionPolicing")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             if (RowData.session_policing_id) {
//                                 _this.IspSessionPolicingManager.DeleteProfile({
//                                     _id:RowData.session_policing_id,
//                                     isp_id:RowData._id
//                                 });
//                             }
//                         })
//                     }
//                 }
//
//                 if (Id === _this.Id + "ToolsSubmenu" + "EnableProfiles")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             if (RowData.enabled != 1)
//                             {
//                                 _this.ViewModel.EnableDisableIspProfile(RowData, 1);
//                             }
//                         })
//                     }
//                 }
//
//                 if (Id === _this.Id + "ToolsSubmenu" + "DisableProfiles")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             if (RowData.enabled != 0)
//                             {
//                                 _this.ViewModel.EnableDisableIspProfile(RowData, 0);
//                             }
//                         })
//                     }
//                 }
//             }
//         }
//     });
//
//     this.SetSessionPolicingPopup = webix.ui({
//         view: "window",
//         css:"spectre-alert form_modal",
//         width:1080,
//         height: 880,
//         modal:true,
//         position:"center",
//         padding:0,
//         margin:0,
//         head: {
//             view: "toolbar",
//             cols: [
//                 {
//                     view: "label",
//                     id: this.Id + "EditPopupHeadLabel",
//                     label: LangHelper.GetString("UlrModule", "Set per-session policing for selected profiles"),
//                     height: 68
//                 },
//                 {
//                     view: "spectre_button",
//                     css: "form_button spec_action with_icon",
//                     type: "icon",
//                     icon: "times",
//                     align: "right",
//                     width: 68,
//                     height: 68,
//                     click: function()
//                     {
//                         _this.Views.Widgets.PolicingForm.SetFormToDefault();
//                         _this.SetSessionPolicingPopup.hide();
//                     }
//                 }
//             ]
//         },
//         body:{
//             type: "wide",
//             rows:[
//                 _this.Views.Widgets.PolicingForm.ViewConfig,
//                 {
//                     cols: [
//                         {
//                             width: 24
//                         },
//                         {
//                             view: "spectre_toggle",
//                             id: this.Id + "SessionPolicingPopupCheckbox",
//                             value: false,
//                             width: 32,
//                             height: 22
//                         },
//                         {
//                             width: webix.html.getTextSize(LangHelper.GetString("UlrModule","Remove protocols").replace(" ", "_"), "app_block__header_webix_template").width + 32,
//                             rows: [
//                                 {
//                                     cols: [
//                                         BlockHeaderTemplate({
//                                             title:LangHelper.GetString("UlrModule","Remove protocols"),
//                                             icon:"",
//                                             borderless:true
//                                         }),
//                                         {
//                                             view: "spectre_button",
//                                             id:_this.Id + "HarBlockingIPsHelpBtn",
//                                             type: "icon",
//                                             icon: "question-circle",
//                                             css:"toolbar_round_btn custom-form-btn",
//                                             width:32,
//                                             height:25,
//                                             tooltip:LangHelper.GetString("UlrModule", "Help"),
//                                             click:function (id)
//                                             {
//                                                 UlrShowSessionPolicingClearProtocolHelpPopup();
//                                             }
//                                         }
//                                     ]
//                                 }
//                             ]
//                         }
//                     ]
//                 },
//                 {
//                     type: "space",
//                     borderless: true,
//                     cols: [
//                         {
//                             view: "spectre_button",
//                             id: this.Id + "ApplyBtn",
//                             css: "form_button main_action",
//                             label: LangHelper.GetString("UlrModule", "Apply"),
//                             autowidth: true,
//                             click: function () {
//                                 _this.SetSessionPolicing(1);
//                             }
//                         },
//                         {
//                             view: "spectre_button",
//                             id: this.Id + "ApplyDisableBtn",
//                             css: "form_button second_action",
//                             label: LangHelper.GetString("UlrModule", "Apply and disable"),
//                             autowidth: true,
//                             click: function () {
//                                 _this.SetSessionPolicing(0);
//                             }
//                         },
//                         {
//                             view: "spectre_button",
//                             id: this.Id + "CancelBtn",
//                             css: "form_button spec_action",
//                             label: LangHelper.GetString("UlrModule", "Cancel"),
//                             autowidth: true,
//                             click: function () {
//                                 _this.Views.Widgets.PolicingForm.SetFormToDefault();
//                                 _this.SetSessionPolicingPopup.hide();
//                             }
//                         },
//                         {},
//                         {
//                             view: "spectre_button",
//                             id: this.Id + "CommonPolicingsBtn",
//                             css: "form_button spec_action",
//                             label: LangHelper.GetString("UlrModule", "Upload common policings"),
//                             autowidth: true,
//                             click: function () {
//                                 _this.GetSessionPolicingsByIds();
//                             }
//                         },
//                     ]
//                 }
//             ]
//         }
//     });
//
//     this.ViewConfig = [
//         {
//             view:"scrollview",
//             scroll:"y",
//             body:{
//                 type: "space",
//                 rows: [
//                     {
//                         type: "clean",
//                         borderless:true,
//                         rows: [
//                             {height:6},
//                             PageHeaderTemplate({
//                                 id:this.Id + "PageTitle",
//                                 root_title:this.PageTitle.Title
//                             }),
//                             {height:32},
//                             {
//                                 type:"wide",
//                                 rows:[
//                                     {
//                                         type: "wide",
//                                         cols: [
//                                             {
//                                                 view:"label",
//                                                 css:"form_text_label",
//                                                 label:LangHelper.GetString("UlrModule","Select Subscriber Profile from the list")
//                                             },
//                                             {
//                                                 view: "spectre_button",
//                                                 id: this.Id + "ToolsBtn",
//                                                 type: "icon",
//                                                 css: "form_button spec_action with_icon",
//                                                 label: LangHelper.GetString("UlrModule", "Tools"),
//                                                 icon: "tools",
//                                                 autowidth: true,
//                                                 click: function () {
//                                                     _this.Views.ToolsSubmenu.show(this.getNode());
//                                                 }
//                                             }
//                                         ]
//                                     },
//                                     this.Views.ReportsWidgets.SubscriberManagementReport.ViewConfig
//                                 ]
//                             },
//                         ]
//                     }
//                 ]
//             }
//         }
//     ];
//
//     this.Subscriptions = {};
//
//     this.Signals = {};
// }
//
// UlrSubsListViewController.prototype.BindAll = function (Params)
// {
//     var _this = this;
//
//     Object.keys(this.Views).forEach(function (View)
//     {
//         if(View != "Widgets" && View != "ReportsWidgets")
//             _this.Views[View] = $$(_this.Id + View)
//     });
//
//     Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
//     {
//         var w = _this.Views.Widgets[WidgetKey];
//
//         if(w.BindAll)
//             w.BindAll(_this, _this.ViewModel);
//
//         if(w.Bind)
//             w.Bind(_this, _this.ViewModel);
//     });
//
//     Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
//     {
//         var w = _this.Views.ReportsWidgets[WidgetKey];
//
//         if(w.BindAll)
//             w.BindAll(_this, _this.ReportsModel);
//
//         if(w.Bind)
//             w.Bind(_this, _this.ReportsModel);
//     });
//
//     this.Subscriptions.IspProfileDeleteError = this.ViewModel.Signals.IspProfileDeleteError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.IspProfileEnableStateError = this.ViewModel.Signals.IspProfileEnableStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.IspProfileDeleted = this.ViewModel.Signals.IspProfileDeleted.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             _this.SubscriberManagementReportOnSuccessDelete(IspModel);
//
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","Subscriber profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.IspProfileEnableStateUpdated = this.ViewModel.Signals.IspProfileEnableStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             _this.SubscriberManagementProfileEnableStateUpdated(IspModel);
//
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","Subscriber profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Enable state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.SessionPolicingProfileEnableStateError = this.ViewModel.Signals.SessionPolicingProfileEnableStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.SessionPolicingProfileEnableStateUpdated = this.ViewModel.Signals.SessionPolicingProfileEnableStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             _this.Refresh();
//
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","Subscriber Session policing Enabled/Disabled"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.PolicingProfileEnableStateError = this.ViewModel.Signals.PolicingProfileEnableStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.PolicingProfileEnableStateUpdated = this.ViewModel.Signals.PolicingProfileEnableStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","Subscriber policing Enabled/Disabled"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.FederalListStateUpdated = this.ViewModel.Signals.FederalListStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","Subscriber profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Global list state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.FederalListStateError = this.ViewModel.Signals.FederalListStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.ExcludedResourcesStateUpdated = this.ViewModel.Signals.ExcludedResourcesStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","Subscriber profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Exclusion list state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.ExcludedResourcesStateError = this.ViewModel.Signals.ExcludedResourcesStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.BlockIPv6StateUpdated = this.ViewModel.Signals.BlockIPv6StateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","Subscriber profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Block IPv6 state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.BlockIPv6StateError = this.ViewModel.Signals.BlockIPv6StateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.SpoofDnsStateUpdated = this.ViewModel.Signals.SpoofDnsStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Spoof DNS state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.SpoofDnsStateError = this.ViewModel.Signals.SpoofDnsStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.PolicingProfileEnableStateUpdated = this.ViewModel.Signals.PolicingProfileEnableStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP policing Enabled/Disabled"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.PolicingMultiplySetSuccess = this.IspSessionPolicingManager.Signals.PolicingMultiplySetSuccess.subscribe(function (Updated) {
//         if(Updated)
//         {
//             _this.Refresh();
//
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","Added new per-session policing profiles"),
//                 LangHelper.GetString("UlrModule","For selected profiles added new per-session policing profiles.")
//             );
//         }
//     });
//
//     this.Subscriptions.GetCommonSessionPolicingsByIspIdsSuccess = this.IspSessionPolicingManager.Signals.GetCommonSessionPolicingsByIspIdsSuccess.subscribe(function (Data) {
//         if (Data)
//         {
//             _this.Views.Widgets.PolicingForm.AddCommonProtocols(Data)
//         }
//     });
//
//     this.Subscriptions.GetCommonSessionPolicingsByIspIdsNotFound = this.IspSessionPolicingManager.Signals.GetCommonSessionPolicingsByIspIdsNotFound.subscribe(function (Update) {
//         if (Update)
//         {
//             UlrShowMessage(
//                 "info",
//                 LangHelper.GetString("UlrModule","No common protocols found."),
//             );
//         }
//     });
//
//     this.Subscriptions.ServerError = this.IspSessionPolicingManager.Signals.ServerError.subscribe(function (ErrModel) {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.PolicingMultiplySetSuccess = this.IspSessionPolicingManager.Signals.PolicingProfileDeleted.subscribe(function (Updated) {
//         if(Updated)
//         {
//             _this.Refresh();
//
//             let profileName = "";
//
//             if (Updated.isp_id)
//             {
//                 let rows = _this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table.serialize();
//                 let find = rows.find(item => {
//                     return item._id === Updated.isp_id;
//                 })
//
//                 profileName =  find && find.name ? find.name : ""
//             }
//
//             UlrShowMessage(
//                 "success",
//                 profileName,
//                 LangHelper.GetString("UlrModule","Session policing removed.")
//             );
//         }
//     });
//
//     this.Subscriptions.ServerError = this.IspSessionPolicingManager.Signals.PolicingProfileDeleteError.subscribe(function (ErrModel) {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.IspProfileSelectedCount = this.Views.ReportsWidgets.SubscriberManagementReport.TableRowsSelectedCount.subscribe(function (Value) {
//         if (Value > 1)
//         {
//             _this.Views.ToolsBtn.enable();
//         }
//         else
//         {
//             _this.Views.ToolsBtn.disable();
//         }
//     });
//
//     this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table.attachEvent("onAfterSelect", function (Row) {
//         var item = this.getItem(Row);
//
//         if (item)
//         {
//             if (!parseInt(item.checked)) {
//                 item.checked = 1;
//             }
//             this.updateItem(Row, item);
//         }
//     });
//
//     this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table.attachEvent("onAfterUnSelect", function (Row) {
//         var item = this.getItem(Row);
//
//         if (item)
//         {
//             if (parseInt(item.checked)) {
//                 item.checked = 0;
//             }
//             this.updateItem(Row, item);
//         }
//     });
// };
//
// UlrSubsListViewController.prototype.ViewDidLoad = function (PathParams)
// {
//     var _this = this;
//
//     this.PathParams = PathParams;
//
//     this.BindAll(PathParams);
//
//     this.Refresh();
// };
//
// UlrSubsListViewController.prototype.Destroy = function ()
// {
//     var _this = this;
//
//     Object.keys(this.Subscriptions).forEach(function (key)
//     {
//         if(_this.Subscriptions[key])
//             _this.Subscriptions[key].unsubscribe();
//     });
//
//     Object.keys(this.Views.Widgets).forEach(function (Widget)
//     {
//         var w = _this.Views.Widgets[Widget];
//         if(w.Destroy)
//             w.Destroy();
//     });
//
//     Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
//     {
//         var w = _this.Views.ReportsWidgets[Widget];
//         if(w.Destroy)
//             w.Destroy();
//     });
//
//     if(this.ViewModel)
//     {
//         this.ViewModel.Destroy();
//         delete this.ViewModel;
//     }
//
//     if(this.ReportsModel)
//     {
//         this.ReportsModel.Destroy();
//         delete this.ReportsModel;
//     }
// };
//
// UlrSubsListViewController.prototype.ViewDidLoad = function (Params)
// {
//     var _this = this;
//
//     this.BindAll(Params);
//
//     this.Refresh();
// };
//
// UlrSubsListViewController.prototype.Destroy = function ()
// {
//     var _this = this;
//
//     Object.keys(this.Subscriptions).forEach(function (key)
//     {
//         if(_this.Subscriptions[key])
//             _this.Subscriptions[key].unsubscribe();
//     });
//
//     Object.keys(this.Views.Widgets).forEach(function (Widget)
//     {
//         var w = _this.Views.Widgets[Widget];
//         if(w.Destroy)
//             w.Destroy();
//     });
//
//     Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
//     {
//         var w = _this.Views.ReportsWidgets[Widget];
//         if(w.Destroy)
//             w.Destroy();
//     });
//
//     if(this.ViewModel)
//     {
//         this.ViewModel.Destroy();
//         delete this.ViewModel;
//     }
//
//     if(this.ReportsModel)
//     {
//         this.ReportsModel.Destroy();
//         delete this.ReportsModel;
//     }
//
//     if(this.IspSessionPolicingManager)
//     {
//         this.IspSessionPolicingManager.Destroy();
//         delete this.IspSessionPolicingManager;
//     }
// };
//
// UlrSubsListViewController.prototype.Refresh = function ()
// {
//     let checkboxControl = this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table.getHeaderContent("cm1");
//
//     if (checkboxControl.isChecked())
//     {
//         checkboxControl.uncheck();
//     }
//
//     this.Views.ReportsWidgets.SubscriberManagementReport.RefreshData();
// };
//
// UlrSubsListViewController.prototype.GetPageTitle = function ()
// {
//     if(this.PageTitle)
//         return this.PageTitle;
// };
//
// UlrSubsListViewController.prototype.SetSessionPolicing = function (Enabled)
// {
//     var _this = this;
//
//     if (!_this.Views.Widgets.PolicingForm.ValidateProtocolTable())
//         return;
//
//     let selectedIspProfiles = _this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table.getSelectedItem();
//
//     selectedIspProfiles = selectedIspProfiles.filter(function (Item)
//     {
//         return parseInt(Item.checked) ? true : false;
//     });
//
//     if(!selectedIspProfiles.length)
//         return;
//
//     let rows = _this.Views.Widgets.PolicingForm.Views.ReportsWidgets.ProtocolsReport.Views.Table.serialize();
//
//     if(!rows.length)
//     {
//         UlrShowMessage(
//             "error",
//             LangHelper.GetString("UlrModule", "No protocol added."),
//             LangHelper.GetString("UlrModule", "To set per-session policing for selected profiles, add at least one protocol.")
//         );
//         return;
//     }
//
//     let data = [];
//
//     selectedIspProfiles.forEach(Profile => {
//
//         let cfg_rows = [];
//
//         rows.forEach(Row => {
//             let policingModel = new SessionPolicingProtocolModel(Row);
//
//             if(policingModel.type === UlrProtocolTypesDic.protocol.id)
//             {
//                 cfg_rows.push(policingModel);
//             }
//             else
//             {
//                 cfg_rows.unshift(policingModel);
//             }
//         });
//
//         data.push({
//             "isp_id": Profile._id,
//             "description": Profile.name,
//             "config": JSON.stringify(cfg_rows)});
//     })
//
//     var delete_protos = this.Views.SessionPolicingPopupCheckbox.getValue();
//     delete_protos = delete_protos ? 1 : 0;
//
//     _this.IspSessionPolicingManager.MultiplySetIspSessionPolicing(data, Enabled, delete_protos);
//
//     _this.Views.Widgets.PolicingForm.SetFormToDefault();
//     _this.SetSessionPolicingPopup.hide();
// };
//
// UlrSubsListViewController.prototype.GetSessionPolicingsByIds = function ()
// {
//     let _this = this;
//
//     let selectedIspProfiles = _this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table.getSelectedItem();
//
//     selectedIspProfiles = selectedIspProfiles.filter(function (Item)
//     {
//         return parseInt(Item.checked) ? true : false;
//     });
//
//     if(!selectedIspProfiles.length)
//         return;
//
//     let profiles_ids = [];
//
//     selectedIspProfiles.forEach(val => {
//         profiles_ids.push(val._id);
//     })
//
//     _this.IspSessionPolicingManager.GetCommonSessionPolicingsByIspIds({data: profiles_ids});
// };
//
// UlrSubsListViewController.prototype.EnableDisableSessionPolicing = function(RowData, State)
// {
//     let profileName = RowData && RowData.name ? RowData.name : "";
//
//     if (RowData && RowData.session_policing_id)
//     {
//         if (RowData.session_policing_enabled != State)
//         {
//             this.ViewModel.EnableDisableSessionPolicingProfile({_id:RowData.session_policing_id}, State);
//         }
//         else
//         {
//             UlrShowMessage(
//                 "info",
//                 LangHelper.GetString("UlrModule", "Per-session policing for [PROFILE] is already " + ((State ? "enabled." : "disabled.")))
//                     .replace("[PROFILE]", profileName)
//             );
//         }
//     }
//     else
//     {
//         UlrShowMessage(
//             "error",
//             LangHelper.GetString("UlrModule", "Profile name") + ": " + profileName,
//             LangHelper.GetString("UlrModule", "To Enable/Disable per-session policing, it must be configured.")
//         );
//     }
// };
//
// UlrSubsListViewController.prototype.SubscriberManagementReportOnItemClick = function(Id, E, Node)
// {
//     var _this = this;
//
//     if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
//     {
//         var table = this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         App.NavRouter.PresentView({id: ControllersEnum.UlrEditSubs, path:"/_id=" + data._id});
//     }
//
//     if(Id.column === 'policing_url')
//     {
//         var table = this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         App.NavRouter.PresentView({id: 'UlrEditSubscriberPolicing', path:"/_id=" + data._id + "/source=UlrSubsList"});
//     }
//
//     if(Id.column === 'session_policing_url')
//     {
//         var table = this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         App.NavRouter.PresentView({id: 'UlrEditSubscriberSessionPolicing', path:"/_id=" + data._id + "/source=UlrSubsList"});
//     }
//
//     if(Id.column === 'web_rule')
//     {
//         var table = this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         var total = data && data.total_web_rules && parseInt(data.total_web_rules) ? parseInt(data.total_web_rules) : 0;
//
//         if(total > 0)
//         {
//             App.NavRouter.PresentView({id: 'UlrWebIpFilterRules', path:"/sub_id=" + data._id});
//         }
//     }
//
//     if(Id.column === 'delete')
//     {
//         var table = this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         var node = table.getItemNode(Id);
//
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule","Delete") + "?",
//             //type:"spectre-alert-notification",
//             mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel")
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule","Delete"),
//                     click:function ()
//                     {
//                         _this.ViewModel.DeleteIspProfile(data);
//                     }
//                 }
//             ]
//         });
//     }
// };
//
// UlrSubsListViewController.prototype.SubscriberManagementReportOnCheck = function(Row, Column, State)
// {
//     var _this = this;
//     var table = this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table;
//
//     var data = table.getItem(Row);
//
//     if(Column == "checked") {
//
//         var item = table.getItem(Row);
//
//         if(item.checked)
//         {
//             table.select(Row, true)
//         }
//         else
//         {
//             table.unselect(Row);
//         }
//     }
//
//     if(Column == 'enabled')
//     {
//         this.ViewModel.EnableDisableIspProfile(webix.extend(data, {callback:function (R)
//             {
//                 if(!R.success)
//                 {
//                     data.enabled = State ? 0 : 1;
//
//                     table.updateItem(data.id, data);
//                 }
//             }}), State);
//     }
//
//     if(Column == 'policing_enabled')
//     {
//         this.ViewModel.EnableDisableAppPolicingProfile(webix.extend({_id: data.policing_id}, {callback:function (R)
//             {
//                 if(!R.success)
//                 {
//                     data.policing_enabled = State ? 0 : 1;
//
//                     table.updateItem(data.id, data);
//                 }
//             }}), State);
//     }
//
//     if(Column == 'session_policing_enabled')
//     {
//         this.ViewModel.EnableDisableSessionPolicingProfile(webix.extend({_id: data.session_policing_id}, {callback:function (R)
//             {
//                 if(!R.success)
//                 {
//                     data.session_policing_enabled = State ? 0 : 1;
//
//                     table.updateItem(data.id, data);
//                 }
//             }}), State);
//     }
//
//
//     if(Column == 'federal_bl')
//     {
//         var node = table.getItemNode({row: Row, column: 'federal_bl'});
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule",parseInt(data.federal_bl) ? "Enable" : "Disable") + "?",
//             //type:"spectre-alert-notification",
//             mainTitle:LangHelper.GetString("UlrModule",parseInt(data.federal_bl) ? "Enable" : "Disable") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel"),
//                     click: function()
//                     {
//                         data.federal_bl = State ? 0 : 1;
//
//                         table.updateItem(data.id, data);
//                     }
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule",parseInt(data.federal_bl) ? "Enable" : "Disable"),
//                     click:function ()
//                     {
//                         _this.ViewModel.EnableDisableFederalLists(data, parseInt(data.federal_bl), function(R)
//                         {
//                             if(!R.success)
//                             {
//                                 data.federal_bl = State ? 0 : 1;
//
//                                 table.updateItem(data.id, data);
//                             }
//                         });
//                     }
//                 }
//             ]
//         });
//     }
//
//     if(Column == 'web_rule_exclude')
//     {
//         var node = table.getItemNode({row: Row, column: 'web_rule_exclude'});
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule",parseInt(data.web_rule_exclude) ? "Enable" : "Disable") + "?",
//             //type:"spectre-alert-notification",
//             mainTitle:LangHelper.GetString("UlrModule",parseInt(data.web_rule_exclude) ? "Enable" : "Disable") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel"),
//                     click: function()
//                     {
//                         data.web_rule_exclude = State ? 0 : 1;
//
//                         table.updateItem(data.id, data);
//                     }
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule",parseInt(data.web_rule_exclude) ? "Enable" : "Disable"),
//                     click:function ()
//                     {
//                         _this.ViewModel.EnableDisableExcludedResources(data, parseInt(data.web_rule_exclude), function(R)
//                         {
//                             if(!R.success)
//                             {
//                                 data.web_rule_exclude = State ? 0 : 1;
//
//                                 table.updateItem(data.id, data);
//                             }
//                         });
//                     }
//                 }
//             ]
//         });
//     }
//
//     if(Column == 'block_ipv6')
//     {
//         var node = table.getItemNode({row: Row, column: 'block_ipv6'});
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule",parseInt(data.block_ipv6) ? "Enable" : "Disable") + "?",
//             //type:"spectre-alert-notification",
//             mainTitle:LangHelper.GetString("UlrModule",parseInt(data.block_ipv6) ? "Enable" : "Disable") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel"),
//                     click: function()
//                     {
//                         data.block_ipv6 = State ? 0 : 1;
//
//                         table.updateItem(data.id, data);
//                     }
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule",parseInt(data.block_ipv6) ? "Enable" : "Disable"),
//                     click:function ()
//                     {
//                         _this.ViewModel.EnableDisableBlockIPv6(data, parseInt(data.block_ipv6), function(R)
//                         {
//                             if(!R.success)
//                             {
//                                 data.block_ipv6 = State ? 0 : 1;
//
//                                 table.updateItem(data.id, data);
//                             }
//                         });
//                     }
//                 }
//             ]
//         });
//     }
//
//     if(Column == 'spoof_dns')
//     {
//         var node = table.getItemNode({row: Row, column: 'spoof_dns'});
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule",parseInt(data.spoof_dns) ? "Enable" : "Disable") + "?",
//             mainTitle:LangHelper.GetString("UlrModule",parseInt(data.spoof_dns) ? "Enable" : "Disable") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel"),
//                     click: function()
//                     {
//                         data.spoof_dns = State ? 0 : 1;
//
//                         table.updateItem(data.id, data);
//                     }
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule",parseInt(data.spoof_dns) ? "Enable" : "Disable"),
//                     click:function ()
//                     {
//                         _this.ViewModel.EnableDisableSpoofDns(data, parseInt(data.spoof_dns), function(R)
//                         {
//                             if(!R.success)
//                             {
//                                 data.spoof_dns = State ? 0 : 1;
//
//                                 table.updateItem(data.id, data);
//                             }
//                         });
//                     }
//                 }
//             ]
//         });
//     }
//
// };
//
// UlrSubsListViewController.prototype.SubscriberManagementReportOnSuccessDelete = function(IspModel)
// {
//     var table = this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table;
//
//     var data = table.find(function(obj){
//         return obj._id == IspModel._id;
//     });
//
//     if(data && data.length == 1 && data[0].id)
//     {
//         table.remove(data[0].id);
//
//         if(!table.count())
//             this.Refresh();
//     }
//
// };
//
// UlrSubsListViewController.prototype.SubscriberManagementProfileEnableStateUpdated = function(IspModel)
// {
//     var table = this.Views.ReportsWidgets.SubscriberManagementReport.Views.Table;
//
//     var data = table.find(function(obj){
//         return obj._id == IspModel._id;
//     });
//
//     if(data && data.length == 1 && data[0].id)
//     {
//         data = data[0];
//         data.enabled = IspModel.enabled;
//         table.updateItem(data.id, data);
//     }
//
// };
//
// UlrSubsListViewController.prototype.ShowServerError = function(ErrModel)
// {
//     if(ErrModel)
//         UlrShowAlertWindow({
//             head:LangHelper.GetString("UlrModule","Error"),
//             type:"spectre-alert-error",
//             mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
//             message:LangHelper.GetString("UlrModule",ErrModel.msg),
//             actions:[
//                 {
//                     label:LangHelper.GetString("UlrModule","Ok"),
//                     click:function ()
//                     {
//
//                     }
//                 }
//             ]
//         });
// };
function UlrEditSubsViewController(Params) {
    var _this = this;

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.Id = "UlrEditSubs";
    this.RootTitle = LangHelper.GetString("UlrModule","Profile management");
    this.Title = LangHelper.GetString("UlrModule","Edit subscriber profile");
    this.Action = this.ActionsEnum.Edit;
    this.ViewModel = new UlrIspsManager();
    this.ReportsModel = new UniReportsManager();

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        ReportsModel: this.ReportsModel,
        Action: this.Action,
        Mode: "subscribers"
    }, true);

    UlrEditSubsViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrEditSubsViewController, UlrEditIspSubsViewController);

function UlrAddSubsViewController(Params)
{
    UlrAddSubsViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddSubsViewController,UlrEditSubsViewController);
function UlrEditIspSubsViewController(params)
{
    var _this = this;

    this.subsEditMode = params.Mode === "subscribers" ? true : false;

    this.Id = this.subsEditMode ? "UlrEditSubscriber" : "UlrEditIsp";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle: params && params.RootTitle ? params.RootTitle :
            (this.subsEditMode ? LangHelper.GetString("UlrModule","Profile management") : LangHelper.GetString("UlrModule","Profile management") ),
        Title: params && params.Title ? params.Title :
            (this.subsEditMode ? LangHelper.GetString("UlrModule","Edit subscriber profile") : LangHelper.GetString("UlrModule","Edit channel"))
    };

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.Action = params.Action;

    this.ViewModel = params && params.ViewModel ? params.ViewModel : (new UlrIspsManager());
    this.ReportsModel = params && params.ReportsModel ? params.ReportsModel : (new UniReportsManager());

    this.NetworksForm = new UlrAddNetworksViewController({
        Id: this.Id,
        subsEditMode: this.subsEditMode,
        ViewModel: this.ViewModel,
        ReportsModel: this.ReportsModel
    });

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        IspEditForm:null,
        IspEditFormEnabledStateView:null,
        IspEditFormEnabledSpacerView:null,

        AddNetworkPanel:null,
        AddNetworkForm:null,
        CIDRInput:null,
        COMMUNITYInput:null,
        ASPATHInput:null,
        AddNetworkBtn:null,
        AddPrefixTypeSelect:null,

        NetworkLearningRadio:null,

        NetworksBindedCheckbox:null,
        NetworksUnbindedCheckbox:null,
        NetworksValidCheckbox:null,
        NetworksInvalidCheckbox:null,

        SaveBtn:null,
        SaveEnableBtn:null,
        SaveDisableBtn:null,
        DeleteBtn: null,

        AddedNetworksListReportSection: null,
        NetworksListReportSection: null,

        BorderField: null,
        VchannelNumField: null,
        LoginField: null,

        ExportPopupForm: null,
        ExportPopupType:null,
        ExportBtn: null,

        Widgets:{},
        ReportsWidgets:{
            NodesBridgesReport: UrlIspDpiNodesTableWidget({
                id:this.Id + "NodesBridgesReport",
                enableTextSearch:0,
                enableAutoHeight:1,
                hidePaginatorToolbar:1,
                enableLocalSort:1
            }, null, null, _this.subsEditMode),
            NetworksReport: UrlIspNetworksTableWidget({
                id:this.Id + "NetworksReport",
                enableTextSearch:1,
                enableAutoHeight:1,
                defaultPageSize: 10,
                hidePaginatorToolbar:0,
                enableLocalSort:0,
                onItemClick:function (Id)
                {
                    setTimeout(function () {
                        _this.NetworksReportOnItemClick(Id.row, Id.column);
                    },1);
                }
            }),
            AddedNetworksReport: UrlIspNetworksTableWidget({
                id: this.Id + "AddedNetworksReport",
                enableTextSearch:0,
                enableAutoHeight:1,
                // hidePaginatorToolbar:1,
                defaultPageSize: 10,
                enableLocalSort:0,
                enableLocalDataSource: 1,
                dataSource: function(FilterParams)
                {
                    var res = {
                        count: _this.AddedNetworks.length,
                        page: FilterParams.Params.page,
                        size: FilterParams&&FilterParams.Params&&FilterParams.Params.size? FilterParams.Params.size : _this.Views.ReportsWidgets.AddedNetworksReport.Views.Paging.config.size,
                        rows: []
                    };

                    var sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : 'id';
                    var sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : 'asc';

                    var sort_val = sort_dir == 'asc' ? 1 : -1;


                    _this.AddedNetworks.sort((a, b) => {
                        var val_a = a[sort_prop];
                        var val_b = b[sort_prop];

                        if(typeof val_a == 'string' || typeof val_b == 'string')
                        {
                            if(sort_val > 0)
                            {
                                return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                            }
                            else
                            {
                                return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                            }
                        }
                        else if(typeof val_a == 'number' || typeof val_b == 'number')
                        {
                            return sort_val * val_a + (-1) * sort_val * val_b;
                        }

                        return -1;
                    });

                    const maxPage = Math.max(0, Math.ceil(_this.AddedNetworks.length / res.size) - 1);
                    res.page = Math.min(maxPage, Math.max(0, FilterParams.Params.page));

                    const start_index = res.page * res.size;
                    var finish_index = start_index + res.size;

                    if(finish_index > (_this.AddedNetworks.length - 1))
                    {
                        res.rows = _this.AddedNetworks.slice(start_index);
                    }
                    else
                    {
                        res.rows = _this.AddedNetworks.slice(start_index, finish_index);
                    }

                    return res;
                },
                onItemClick:function (Id) {
                    _this.AddedNetworksReportOnItemClick(Id);
                }
            })
        }
    };

    this.ExportPopup = null;
    this.ExportPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "ExportRulePopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Export"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.ExportPopup.hide(); }}
            ]
        },
        body: {
            type: "space",
            borderless: true,
            rows: [
                {
                    type: "clean",
                    borderless: true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "ExportPopupForm",
                            type: "wide",
                            elements: [
                                {
                                    cols: [
                                        {
                                            view:"spectre_richselect",
                                            id: this.Id + "ExportPopupType",
                                            label:LangHelper.GetString("UlrModule","Export format"),
                                            value:"toPDF",
                                            options:{
                                                point:false,
                                                data:[
                                                    {id: "toPDF", value: LangHelper.GetString("UlrModule","Export to PDF")},
                                                    {id: "toExcel", value: LangHelper.GetString("UlrModule","Export to Excel")},
                                                    {id: "toCSV", value: LangHelper.GetString("UlrModule","Export to CSV")}
                                                ]
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {height: 20},
                        {
                            type: "wide",
                            cols: [
                                {
                                    view: "spectre_button",
                                    id: this.Id + "ExportPopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Export"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function ()
                                        {
                                            _this.ExportRule();
                                            _this.ExportPopup.hide();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ViewConfig = 
        [{
            view:"scrollview",
            id:_this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows:
                            [
                                {height:6},
                                PageHeaderTemplate({
                                    id:_this.Id + "PageTitle",
                                    root_title: _this.PageTitle.Title
                                }),
                                {height:32},
                                {
                                    view:"form",
                                    id:_this.Id + "IspEditForm",
                                    type: "wide",
                                    borderless:true,
                                    elements:[
                                        {
                                            cols:[
                                                {
                                                    view:"spectre_captionlabel",
                                                    name:"_id",
                                                    caption:_this.subsEditMode ? LangHelper.GetString("UlrModule","Subscriber profile id") : LangHelper.GetString("UlrModule","ISP profile id")
                                                },
                                                {
                                                    id:_this.Id + "IspEditFormEnabledSpacerView",
                                                    css:"form_info_label_spacer",
                                                    borderless:true,
                                                    width:20,
                                                    template:"",
                                                    hidden:true
                                                },
                                                {
                                                    view:"spectre_captionlabel",
                                                    id:_this.Id + "IspEditFormEnabledStateView",
                                                    name:"enabled",
                                                    caption:LangHelper.GetString("UlrModule","ISP profile state"),
                                                    template:function (Obj)
                                                    {
                                                        return "<span class='caption'>"+Obj.caption+":</span> <span class='value'>"+(parseInt(Obj.value) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled"))+"</span>";
                                                    },
                                                    hidden:true
                                                }
                                            ]
                                        },
                                        {
                                            type: "wide",
                                            cols:[
                                                {
                                                    view:"spectre_text",
                                                    name:"name",
                                                    label:_this.subsEditMode ? LangHelper.GetString("UlrModule","Subscriber profile name") : LangHelper.GetString("UlrModule","ISP profile name"),
                                                    required:true,
                                                    validate: webix.rules.isNotEmpty,
                                                    invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                    on: {
                                                        "onChange": function (Nv, Ov)
                                                        {
                                                            if(typeof Ov !== "undefined")
                                                            {
                                                                if(Nv != Nv.trim())
                                                                {
                                                                    this.setValue(Nv.trim());
                                                                    return;
                                                                }

                                                                this.validate();
                                                            }
                                                        }
                                                    }
                                                },
                                                {
                                                    view:"spectre_richselect",
                                                    id: _this.Id + "BorderField",
                                                    name:"igw_id",
                                                    label:LangHelper.GetString("UlrModule","Border"),
                                                    options:{
                                                        point:false,
                                                        data:[]
                                                    },
                                                    required:true,
                                                    validate: webix.rules.isNotEmpty,
                                                    invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                    on: {
                                                        "onChange": function (Nv, Ov)
                                                        {
                                                            if(!Nv)
                                                            {
                                                                return;
                                                            }

                                                            if(typeof Ov !== "undefined" && Ov !== "")
                                                            {
                                                                if (!this.validate())
                                                                {
                                                                    return;
                                                                }
                                                            }

                                                            if (!_this.subsEditMode)
                                                            {
                                                                if (Nv)
                                                                {
                                                                    const ulrIgwsVchannelTypesDic = App.DicsManager.GetDic(DicsEnum.UlrIgwsVchannelTypesDic);

                                                                    const igwTypeVal = ulrIgwsVchannelTypesDic && ulrIgwsVchannelTypesDic[Nv] && ulrIgwsVchannelTypesDic[Nv].value ? ulrIgwsVchannelTypesDic[Nv].value : 1;

                                                                    if (igwTypeVal == 3)
                                                                    {
                                                                        _this.Views.LoginField.hide();
                                                                        _this.Views.VchannelNumField.show();
                                                                        _this.Views.LoginField.define("required", false);
                                                                        _this.Views.VchannelNumField.define("required", true);

                                                                        if(_this.Action == _this.ActionsEnum.Add && !_this.Views.VchannelNumField.getValue())
                                                                        {
                                                                            _this.Views.VchannelNumField.setValue(_this.ViewModel.MinVchannel[Nv]);
                                                                        }
                                                                    }
                                                                    else
                                                                    {
                                                                        _this.Views.LoginField.show();
                                                                        _this.Views.VchannelNumField.hide();
                                                                        _this.Views.LoginField.define("required", true);
                                                                        _this.Views.VchannelNumField.define("required", false);
                                                                    }

                                                                    _this.Views.LoginField.refresh();
                                                                    _this.Views.VchannelNumField.refresh();
                                                                }
                                                            }
                                                            _this.Signals.IgwChanged.next(Nv);
                                                        }
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            type: "wide",
                                            cols:[
                                                {
                                                    view:"spectre_text",
                                                    id: _this.Id + "VchannelNumField",
                                                    name:"vchannel_number",
                                                    label:LangHelper.GetString("UlrModule","Number channel"),
                                                    hidden: true,
                                                    keyPressTimeout:500,
                                                    validate: function (Val)
                                                    {
                                                        let valid = true;
                                                        if(Val == "" || Val < 1 || Val > 1024)
                                                        {
                                                            valid = false;
                                                        }
                                                        else if (isNaN(Val))
                                                        {
                                                            valid = false;
                                                        }

                                                        return valid ;
                                                    },
                                                    invalidMessage: LangHelper.GetString("UlrModule", "Input number from 1 to 1024"),
                                                    on: {
                                                        onChange: function (Nv, Ov)
                                                        {
                                                            if(typeof Ov !== "undefined")
                                                            {
                                                                if (!this.validate() && Nv !== null)
                                                                {
                                                                    return;
                                                                }
                                                            }

                                                            const nodesDic = App.DicsManager.GetDic(DicsEnum.UlrNodesDic);
                                                            const igwId = parseInt(_this.Views.BorderField.getValue());

                                                            let
                                                                table = _this.Views.ReportsWidgets.NodesBridgesReport.Views.Table,
                                                                bridgesData = table.serialize();

                                                            if (nodesDic && Nv)
                                                            {
                                                                if(_this.ViewModel.FreeVchannels[igwId] && Array.isArray(_this.ViewModel.FreeVchannels[igwId]))
                                                                {
                                                                    const vchannelIndex = _this.ViewModel.FreeVchannels[igwId].findIndex(obj => obj == Nv);

                                                                    if(vchannelIndex === -1)
                                                                    {
                                                                        _this.Views.IspEditForm.markInvalid("vchannel_number", LangHelper.GetString("UlrModule", "This channel can not be used"));
                                                                    }
                                                                    else
                                                                    {
                                                                        bridgesData.forEach(function (Item)
                                                                        {
                                                                            if(Item[`bridge_${Nv - 1}`])
                                                                            {
                                                                                Item["bridge_0"] = 1;
                                                                            }
                                                                        });

                                                                        table.clearAll();
                                                                        table.parse(bridgesData);
                                                                    }
                                                                }
                                                            }
                                                            else if (Nv == null)
                                                            {
                                                                let vchannelNum = 0;
                                                                bridgesData.forEach(function (Item)
                                                                {
                                                                    let i = 0;

                                                                    Object.keys(Item).forEach(function (Key)
                                                                    {
                                                                        if(Key == "bridge_" + i)
                                                                        {
                                                                            if(parseInt(Item["bridge_" + i]))
                                                                            {
                                                                                if (vchannelNum < i)
                                                                                    vchannelNum = i;
                                                                            }

                                                                            i++;
                                                                        }
                                                                    });
                                                                });

                                                                bridgesData.forEach(function (Item)
                                                                {
                                                                    if(Item[`bridge_${vchannelNum}`])
                                                                    {
                                                                        Item["bridge_0"] = 1;
                                                                    }
                                                                });

                                                                _this.Views.VchannelNumField.setValue(vchannelNum);
                                                                setTimeout(()=>{
                                                                    table.clearAll();
                                                                    table.parse(bridgesData);
                                                                }, 1);

                                                            }
                                                        }
                                                    }
                                                },
                                                {
                                                    view:"spectre_text",
                                                    name:"login",
                                                    id: _this.Id + "LoginField",
                                                    label:LangHelper.GetString("UlrModule","Login on DPI node"),
                                                    required:true,
                                                    validate: function (value) {
                                                        return /^\w+$/.test(value);
                                                    },
                                                    invalidMessage: LangHelper.GetString("UlrModule", "Enter Latin letters and numbers in lowercase"),
                                                    on: {
                                                        "onChange": function (Nv, Ov)
                                                        {
                                                            if(typeof Ov !== "undefined")
                                                            {
                                                                var _Nv = Nv.trim().replace(/\s/g, '');

                                                                if(Nv != _Nv)
                                                                {
                                                                    this.setValue(_Nv);
                                                                    return;
                                                                }

                                                                this.validate();
                                                            }
                                                        },
                                                        "onTimedKeyPress": function () {
                                                            let value = this.getValue();

                                                            $$(_this.Id + "PrefixField").setValue(value);
                                                        }
                                                    }
                                                },
                                                {
                                                    view:"spectre_text",
                                                    id: _this.Id + "PrefixField",
                                                    name:"prefix",
                                                    label:LangHelper.GetString("UlrModule","Lists prefix on DPI node"),
                                                    required:true,
                                                    validate: function (value) {
                                                        return /^\w+$/.test(value);
                                                    },
                                                    invalidMessage: LangHelper.GetString("UlrModule", "Enter Latin letters and numbers in lowercase"),
                                                    on: {
                                                        "onChange": function (Nv, Ov)
                                                        {
                                                            if(typeof Ov !== "undefined")
                                                            {
                                                                var _Nv = Nv.trim().replace(/\s/g, '');

                                                                if(Nv != _Nv)
                                                                {
                                                                    this.setValue(_Nv);
                                                                    return;
                                                                }

                                                                this.validate();
                                                            }
                                                        }
                                                    }
                                                }
                                            ]
                                        },
                                        BlockHeaderTemplate({
                                            title:LangHelper.GetString("UlrModule","Web Filter rules configuration"), icon:"",
                                            borderless:true
                                        }),
                                        {
                                            type: "wide",
                                            cols:[
                                                {
                                                    view:"spectre_toggle",
                                                    name: "federal_bl",
                                                    css:"form_element block_header_toggle",
                                                    value:1,
                                                    width: 32
                                                },
                                                {
                                                    view: "label",
                                                    css: "form_element form_text_label",
                                                    label: LangHelper.GetString("UlrModule", "Use federal black lists for Web Filter service profile")
                                                }

                                            ]
                                        },
                                        {
                                            type: "wide",
                                            cols:[
                                                {
                                                    view:"spectre_toggle",
                                                    name: "web_rule_exclude",
                                                    css:"form_element block_header_toggle",
                                                    value:1,
                                                    width: 32
                                                },
                                                {
                                                    view: "label",
                                                    css: "form_element form_text_label",
                                                    label: LangHelper.GetString("UlrModule", "Use WEB filter exclusion list")
                                                }

                                            ]
                                        },
                                        BlockHeaderTemplate({
                                            title:LangHelper.GetString("UlrModule","Block IPv6 traffic configuration"), icon:"",
                                            borderless:true
                                        }),
                                        {
                                            type: "wide",
                                            cols:[
                                                {
                                                    view:"spectre_toggle",
                                                    name: "block_ipv6",
                                                    css:"form_element block_header_toggle",
                                                    value:0,
                                                    width: 32
                                                },
                                                {
                                                    view: "label",
                                                    css: "form_element form_text_label",
                                                    label: LangHelper.GetString("UlrModule", "Block IPv6 traffic for this profile")
                                                }

                                            ]
                                        },
                                        BlockHeaderTemplate({
                                            title:LangHelper.GetString("UlrModule","Spoof DNS configuration"), icon:"",
                                            borderless:true
                                        }),
                                        {
                                            type: "wide",
                                            cols:[
                                                {
                                                    view:"spectre_toggle",
                                                    name: "spoof_dns",
                                                    css:"form_element block_header_toggle",
                                                    value:0,
                                                    width: 32
                                                },
                                                {
                                                    view: "label",
                                                    css: "form_element form_text_label",
                                                    label: LangHelper.GetString("UlrModule", "Use Spoof DNS for this profile")
                                                }

                                            ]
                                        }
                                    ]
                                },
                                {
                                    height:48
                                },
                                {
                                    type:"wide",
                                    rows:[
                                        BlockHeaderTemplate({
                                            title:LangHelper.GetString("UlrModule","DPI nodes"), icon:"",
                                            borderless:true
                                        }),
                                        {
                                            view:"label",
                                            css:"form_text_label",
                                            label:LangHelper.GetString("UlrModule",this.subsEditMode ? "Select the DPI nodes that pass subscriber traffic." : "Select DPI nodes and bridges/virtual channel which passing traffic of ISP.")
                                        },
                                        _this.Views.ReportsWidgets.NodesBridgesReport.ViewConfig
                                    ]
                                },
                                {
                                    id: _this.Id + "AddNetworkPanel",
                                    rows:[
                                        {
                                            height:48
                                        },
                                        {
                                            type:"wide",
                                            rows:[
                                                {
                                                    rows: this.NetworksForm.ViewConfig
                                                },
                                                {
                                                    id: this.Id + "AddedNetworksListReportSection",
                                                    hidden: true,
                                                    rows: [
                                                        BlockHeaderTemplate({
                                                            title:LangHelper.GetString("UlrModule","Just added IP-refixes"), icon:"",
                                                            borderless:true
                                                        }),
                                                        {
                                                            height: 20
                                                        },
                                                        this.Views.ReportsWidgets.AddedNetworksReport.ViewConfig,
                                                        {
                                                            height: 32
                                                        }
                                                    ]
                                                },
                                                {
                                                    id: this.Id + "NetworksListReportSection",
                                                    hidden: true,
                                                    rows:[
                                                        BlockHeaderTemplate({
                                                            title:LangHelper.GetString("UlrModule","List of IP-prefixes"), icon:"",
                                                            borderless:true
                                                        }),
                                                        {
                                                            height:20
                                                        },
                                                        this.Views.ReportsWidgets.NetworksReport.ViewConfig,
                                                        {
                                                            height:20
                                                        },
                                                        {
                                                            cols:[
                                                                {
                                                                    view:"spectre_button",
                                                                    id:this.Id+"ClearAll",
                                                                    css:"form_button spec_action",
                                                                    label:LangHelper.GetString("UlrModule","Clear all"),
                                                                    autowidth:true,
                                                                    click:function ()
                                                                    {
                                                                        _this.ClearAll();
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        },
                                                        {
                                                            height:32
                                                        },

                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {height:32},
                                {
                                    type:"wide",
                                    cols:[
                                        {
                                            view:"spectre_button",
                                            id: _this.Id + "SaveBtn",
                                            css:"form_button main_action",
                                            label:LangHelper.GetString("UlrModule","Save changes"),
                                            autowidth:true,
                                            click:function ()
                                            {
                                                _this.Save();
                                            }
                                        },
                                        {
                                            view:"spectre_button",
                                            id: _this.Id + "SaveEnableBtn",
                                            css:"form_button second_action",
                                            label:LangHelper.GetString("UlrModule","Save and enable"),
                                            autowidth:true,
                                            click:function ()
                                            {
                                                _this.Save(true);
                                            },
                                            hidden:true
                                        },
                                        {
                                            view:"spectre_button",
                                            id: _this.Id + "SaveDisableBtn",
                                            css:"form_button second_action",
                                            label:LangHelper.GetString("UlrModule","Save and disable"),
                                            autowidth:true,
                                            click:function ()
                                            {
                                                _this.Save(false);
                                            },
                                            hidden:true
                                        },
                                        {
                                            view: "spectre_button",
                                            id: this.Id + "ExportBtn",
                                            css: "form_button third_action",
                                            label: LangHelper.GetString("UlrModule", "Export"),
                                            autowidth: true,
                                            click: function()
                                            {
                                                _this.ExportPopup.show();
                                            },
                                            hidden: _this.Action == _this.ActionsEnum.Add
                                        },
                                        {},
                                        {
                                            view:"spectre_button",
                                            id: this.Id + "DeleteBtn",
                                            css:"form_button delete_action",
                                            label:LangHelper.GetString("UlrModule","Delete profile"),
                                            autowidth:true,
                                            click:function ()
                                            {
                                                _this.Delete();
                                            },
                                            hidden:true
                                        }
                                    ]
                                }
                            ]
                    }
                ]
            }
        }]

    this.Subscriptions = {};

    this.Signals = {
        IspEnabled: new Rx.BehaviorSubject(0),
        IgwChanged: new Rx.BehaviorSubject(0),

        CIDRInputHasValue:  new Rx.BehaviorSubject(0),
        COMMUNITYInputHasValue:  new Rx.BehaviorSubject(0),
        ASPATHInputHasValue:  new Rx.BehaviorSubject(0),

        ShowAddedNetworks: new Rx.BehaviorSubject(0),
        ShowNetworks: new Rx.BehaviorSubject(0)
    };

    this.AddedNetworks = [];
    this.ModifiedNetworks = [];
    this.DeletedNetworks = [];
    this.DeleteAll = false;

    this.Views.ReportsWidgets.NetworksReport.DataAdapter = function(Data)
    {
        var res = Data;

        if(res.rows && Array.isArray(res.rows))
        {
            res.rows.forEach((row, i) =>{
                const item = _this.ModifiedNetworks.find(obj => obj._id == row._id);

                if(item && item.enabled != row.enabled)
                {
                    res.rows[i].enabled = item.enabled;
                }
            });
        }

        return res;
    };
}

UlrEditIspSubsViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.ExportPopup = webix.ui(this.ExportPopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress)
    {
        var view = _this.Views.SaveBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveEnableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveDisableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.DeleteBtn;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions[DicsEnum.UlrIgwsDic] = App.DicsManager.Signal[DicsEnum.UlrIgwsDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.IspEditForm.elements.igw_id.getList().clearAll();
            _this.Views.IspEditForm.elements.igw_id.getList().parse(Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrIgwsDic)));

        }
    });

    this.Subscriptions.IgwChanged = this.Signals.IgwChanged.subscribe(function (IgwId)
    {
        if(IgwId)
        {
            _this.ViewModel.RefreshNodesDic(IgwId);

            if(!_this.subsEditMode)
            {
                _this.DefineVchannelType(IgwId);
            }
        }
    });

    this.Subscriptions.NodesBridgesUpdated = Rx.Observable.combineLatest
    (
        App.DicsManager.Signal[DicsEnum.UlrNodesDic],
        this.ViewModel.Signals.IspProfileUpdated,
        this.Signals.IgwChanged
    ).subscribe(function(Val)
        {
            var dicUpdated = Val[0];
            var ispModel = Val[1];
            var igwChanged = Val[2];

            if(dicUpdated && ispModel && igwChanged)
            {
                _this.DefineNodesBridges(ispModel);
            }
        }
    );

    this.Subscriptions.IspProfileUpdated = this.ViewModel.Signals.IspProfileUpdated.subscribe(function (IspModel) {
        if(IspModel)
        {
            _this.DefineAll(IspModel);
        }
    });

    this.Subscriptions.IspProfileError = this.ViewModel.Signals.IspProfileError.subscribe(function (ErrModel)
    {
        _this.ShowLoadSaveProfileError(ErrModel);
    });

    this.Subscriptions.IspProfileSaveError = this.ViewModel.Signals.IspProfileSaveError.subscribe(function (ErrModel)
    {
        _this.ShowLoadSaveProfileError(ErrModel);
    });

    this.Subscriptions.IspEnabled = this.Signals.IspEnabled.subscribe(function (Enabled)
    {
        var view = _this.Views.SaveDisableBtn;
        Enabled ? view.show() : view.hide();

        var view = _this.Views.SaveEnableBtn;
        !Enabled ? view.show() : view.hide();
    });

    this.Subscriptions.IspProfileSaved = this.ViewModel.Signals.IspProfileSaved.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            if(IspModel.insert_stat && IspModel.insert_stat.total && IspModel.insert_stat.duplicate)
            {
                var dublicates_url = URL.parse(IspModel.insert_stat.duplicate_url);
                var current_location_url = URL.parse(window.location.href);

                dublicates_url.hostname  = current_location_url.hostname ;
                dublicates_url.port = current_location_url.port;



                UlrShowAlertWindow({
                    actions: [
                        {
                            label: LangHelper.GetString("UlrModule", "Close"),
                            click: function()
                            {

                                if(!AppEnv.UlrNoRedirectAfterSavePolicingAndIsps)
                                {
                                    setTimeout(function ()
                                    {
                                        App.NavRouter.PresentView({id: _this.subsEditMode ? ControllersEnum.UlrSubsList : ControllersEnum.UlrIspsList});
                                    }, 1);
                                }
                            }
                        }
                    ],
                    on_close: function()
                    {
                        if(!AppEnv.UlrNoRedirectAfterSavePolicingAndIsps)
                        {
                            setTimeout(function ()
                            {
                                App.NavRouter.PresentView({id: _this.subsEditMode ? ControllersEnum.UlrSubsList : ControllersEnum.UlrIspsList});
                            }, 1);
                        }
                    },
                    head: LangHelper.GetString("UlrModule","Save result"),
                    mainTitle: LangHelper.GetString("UlrModule","Save prefixes result"),
                    message: "<br/><span class='ulr-insert-stat'><b>" + LangHelper.GetString("UlrModule", "Total prefixes") + "</b>: " + IspModel.insert_stat.total + "<br/>" +
                        "<b>" + LangHelper.GetString("UlrModule", "Inserted prefixes") + "</b>: " + IspModel.insert_stat.inserted + "<br/>" +
                        "<b>" + LangHelper.GetString("UlrModule", "Skipped / duplicates prefixes") + "</b>: <a href='" + dublicates_url.href + "' target='_blank'>" + IspModel.insert_stat.duplicate + "</a><br/></span>"
                });
            }
            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","ISP profile")+" # "+IspModel.profile.name+": "+LangHelper.GetString("UlrModule","Saving"),
                    LangHelper.GetString("UlrModule","Success")
                );
                if(!AppEnv.UlrNoRedirectAfterSavePolicingAndIsps)
                {
                    setTimeout(function ()
                    {
                        App.NavRouter.PresentView({id: _this.subsEditMode ? ControllersEnum.UlrSubsList : ControllersEnum.UlrIspsList});
                    }, 1);
                }
                else
                {
                    _this.AddedNetworks = [];

                    _this.Views.ReportsWidgets.AddedNetworksReport.RefreshData();

                    _this.ShowHideAddedNetworksTable();

                    _this.Refresh();
                }
            }
        }
    });

    this.Subscriptions.IspProfileDeleted = this.ViewModel.Signals.IspProfileDeleted.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Deleted"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: _this.subsEditMode ? ControllersEnum.UlrSubsList : ControllersEnum.UlrIspsList});
            },1);
        }
    });

    this.Subscriptions.IspProfileDeleteError = this.ViewModel.Signals.IspProfileDeleteError.subscribe(function (ErrModel)
    {
        _this.ShowLoadSaveProfileError(ErrModel);
    });

    this.Subscriptions.NetworkToSave = this.NetworksForm.Signals.AddNetwork.subscribe(function(NetworkModel)
    {
        if(NetworkModel)
        {
            _this.AddNetwork(NetworkModel);
        }
    });

    this.Subscriptions.AddMultipleNetworks = this.NetworksForm.Signals.AddMultipleNetworks.subscribe(function(Val)
    {
        if(Val)
        {
            _this.AddMultipleNetworks(Val);
        }
    });

    this.Subscriptions.ShowAddedNetworks = this.Signals.ShowAddedNetworks.subscribe(function(Show)
    {
        Show ? _this.Views.AddedNetworksListReportSection.show() : _this.Views.AddedNetworksListReportSection.hide();
    });

    this.Subscriptions.ShowNetworksList = this.Signals.ShowNetworks.subscribe(function(Show)
    {
        Show ? _this.Views.NetworksListReportSection.show() : _this.Views.NetworksListReportSection.hide();
    });

    this.Subscriptions.FreeVchannelsUpdated = this.ViewModel.Signals.FreeVchannelsUpdated.subscribe(function(Val){
        // console.log("FreeVchannelsUpdated", Val);
    });

    this.Subscriptions.MinVchannelsUpdated = this.ViewModel.Signals.MinVchannelsUpdated.subscribe(function(Val){
        // console.log("MinVchannelsUpdated", Val);
    });

    if(_this.Action == _this.ActionsEnum.Add)
    {
        this.Views.ExportBtn.hide();
    }
    else
    {
        this.Views.ExportBtn.show();
    }
};

UlrEditIspSubsViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.NetworksForm.ViewDidLoad(PathParams);

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    this.Signals.ShowAddedNetworks.next(this.Action == this.ActionsEnum.Add)
    this.Signals.ShowNetworks.next(this.Action != this.ActionsEnum.Add)

    this.Refresh();
};

UlrEditIspSubsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    this.NetworksForm.Destroy();

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrEditIspSubsViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrEditIspSubsViewController.prototype.Refresh = function ()
{
    this.RefreshIspProfile();
};

UlrEditIspSubsViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

UlrEditIspSubsViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditIspSubsViewController.prototype.DefinePageTitle = function(Title)
{
    this.Views.PageTitle.define("data", {root_title:Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

UlrEditIspSubsViewController.prototype.RefreshIspProfile = function ()
{
    var id = this.Action == this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    this.ViewModel.ResfreshIspProfile({_id: id});

    this.DefinePageTitle((this.Action == this.ActionsEnum.Add ? (this.subsEditMode ? LangHelper.GetString("UlrModule","Add subscriber profile") : LangHelper.GetString("UlrModule","Add new channel")) : (this.subsEditMode ? LangHelper.GetString("UlrModule","Edit subscriber profile") : LangHelper.GetString("UlrModule","Edit ISP profile")) + " #" + id));

    if(this.Action == this.ActionsEnum.Edit)
    {
        this.Views.IspEditFormEnabledStateView.show();
        this.Views.IspEditFormEnabledSpacerView.show();
        this.Views.DeleteBtn.show();

        this.RefreshNetworks();
    }
};

UlrEditIspSubsViewController.prototype.DefineAll = function(IspModel)
{
    var _this = this;

    this.Views.IspEditForm.clearValidation();
    this.Views.IspEditForm.clear();

    if (!_this.subsEditMode)
    {
        const dic = App.DicsManager.GetDic(DicsEnum.UlrIgwsVchannelTypesDic);
        const igwTypeVal = dic && dic[IspModel.profile.igw_id] && dic[IspModel.profile.igw_id].value ? dic[IspModel.profile.igw_id].value : 1;

        if(igwTypeVal == 3 && IspModel.profile.vchannel_number == 0 && IspModel.profile.type == "isp")
            IspModel.profile.vchannel_number = null;
    }

    this.Views.IspEditForm.setValues(IspModel.profile);
    this.Signals.IspEnabled.next(parseInt(IspModel.profile.enabled));
};

UlrEditIspSubsViewController.prototype.DefineNodesBridges = function(IspModel)
{
    var _this = this;

    let
        borderFieldValue = _this.Views.BorderField.getValue(),
        dic = App.DicsManager.GetDic(DicsEnum.UlrIgwsVchannelTypesDic),
        vchannelMode = false;

    if (!_this.subsEditMode && dic)
    {
        const igwTypeVal = dic && dic[borderFieldValue] && dic[borderFieldValue].value ? dic[borderFieldValue].value : 1;
        if (igwTypeVal == 3)
            vchannelMode = true;
    }
    var nodesDic = App.DicsManager.GetDic(DicsEnum.UlrNodesDic);

    var tableModel = [];

    var maxColsNum = 0;

    function FindBridgeState(Id)
    {
        var state = 0;

        IspModel.bridges.rows.every(function(Row)
        {
            if(Row.bridge_id == Id)
            {
                state = 1;
                return false;
            }

            return true;
        });

        return state;
    }

    var currProfile = this.ViewModel.Signals.IspProfileUpdated.getValue().profile;

    Object.keys(nodesDic).forEach(function (Key)
    {
        var rowModel = {
            node_id: nodesDic[Key].id,
            node_name: nodesDic[Key].value
        };

        var bridgesDic = nodesDic[Key].UlrBridgesDic;

        Object.keys(bridgesDic).forEach(function (Key, Index)
        {
            var i = Index;

            maxColsNum = (i+1) > maxColsNum ? (i+1) : maxColsNum;

            rowModel["bridge_"+i] = FindBridgeState(bridgesDic[Key].id);
            rowModel["bridge_"+i+"_id"] = bridgesDic[Key].id;
            rowModel["bridge_"+i+"_name"] = bridgesDic[Key].value;
            rowModel["bridge_id_"+bridgesDic[Key].id] = i;

            // первый if: костыль для абонентов, чтобы показывало только связь с узлом, а не мостом
            if(_this.subsEditMode)
            {
                if(i > 0 && rowModel["bridge_"+i])
                {
                    rowModel["bridge_0"] = 1;
                    rowModel["bridge_"+i] = 0;
                }
            }
            else if (!_this.subsEditMode && vchannelMode) {

                if(i > 0 && rowModel["bridge_"+i])
                {
                    rowModel["bridge_0"] = 1;
                    rowModel["bridge_"+i] = 0;
                }
            }

            // Если абонент и новый профиль, выбираем по умолчанию все.
            if(i === 0 && (_this.subsEditMode || (!_this.subsEditMode && vchannelMode)) && currProfile && !currProfile._id)
            {
                rowModel["bridge_"+i] = 1;
            }

        });

        tableModel.push(rowModel);
    });

    var table = this.Views.ReportsWidgets.NodesBridgesReport.Views.Table;

    var columns = UrlIspDpiNodesTableWidget(null, true, this.subsEditMode || vchannelMode ? 1 : maxColsNum, this.subsEditMode || vchannelMode);

    table.config.columns = columns;
    table.clearSelection();
    table.refreshColumns();

    table.clearAll();
    table.parse(tableModel);
};

UlrEditIspSubsViewController.prototype.DefineVchannelType = function(IgwId)
{
    const dic = App.DicsManager.GetDic(DicsEnum.UlrIgwsVchannelTypesDic)
    const val = dic && dic[IgwId] && dic[IgwId].value ? dic[IgwId].value : 1;

    if(parseInt(val) == 3)
    {
        this.Views.AddNetworkPanel.enable();
    }
    else
    {
        this.Views.AddNetworkPanel.disable();
    }
};

UlrEditIspSubsViewController.prototype.ShowLoadSaveProfileError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrEditIspSubsViewController.prototype.NetworksReportDataSource = function(FilterModel)
{
    var data = this.ViewModel.IspNetworksArrDicToArr(this.ViewModel.IspNetworksDics.InitialDataDic);

    var addedData = this.ViewModel.IspNetworksArrDicToArr(this.ViewModel.IspNetworksDics.AddedDataDic);

    //if(FilterModel && FilterModel.Params.filter.full_text_search && FilterModel.Params.filter.full_text_search.value)

    if(this.Views.NetworksBindedCheckbox.getValue())
    {
        data = data.filter(function (Item)
        {
            return Item.state_bind == 1;
        });
    }

    if(this.Views.NetworksUnbindedCheckbox.getValue())
    {
        data = data.filter(function (Item)
        {
            return Item.state_bind == 0;
        });
    }

    if(this.Views.NetworksValidCheckbox.getValue())
    {
        data = data.filter(function (Item)
        {
            return Item.state_valid == 2;
        });
    }

    if(this.Views.NetworksInvalidCheckbox.getValue())
    {
        data = data.filter(function (Item)
        {
            return Item.state_valid == 1;
        });
    }

    return {rows:addedData.concat(data)};
};

UlrEditIspSubsViewController.prototype.NetworksReportOnItemClick = function(Row, Column)
{
    var _this = this;
    if(Column === 'delete' || Column === 'enabled' || Column === 'list')
    {
        var table = this.Views.ReportsWidgets.NetworksReport.Views.Table;

        var data = table.getItem(Row);

        if(Column === 'list')
        {
            if(data.type_id != PrefixTypeMapEnum.BGP)
            {
                return;
            }

            var modal_title = data.regex;

            var table_params = {
                enableAutoHeight: false,
                enableTextSearch: true,
                is_modal: true,
                filter: {
                    network_id: {
                        id: "network_id",
                        operator: "=",
                        value: data._id
                    }
                }
            };

            var t = new UlrBgpPrefixResourcesTable(table_params);

            UlrEditAppPolicingPopup({
                modal_title: modal_title
            }, t);
            t.Bind(_this, _this.ReportsModel);
            t.RefreshData();
        }

        if(Column === 'delete')
        {
            this.DeletedNetworks.push(data);
            table.remove(Row);

            var filter = {
                isp_id: {
                    id: "isp_id",
                    operator: "=",
                    value: this.GetPathParam("_id")
                }
            };

            var deleted = [];

            this.DeletedNetworks.forEach(item => {
                const _id = parseInt(item._id);

                if(_id)
                {
                    deleted.push(_id);
                }
            });

            if(deleted.length > 0)
            {
                filter._ids = {
                    id: "_id",
                    operator: "not in",
                    value: deleted
                };
            }

            this.Views.ReportsWidgets.NetworksReport.ExternalFilter = filter;
        }

        if(Column === 'enabled')
        {
            this.ModifiedNetworks.push(data);
        }
    }
};

UlrEditIspSubsViewController.prototype.CheckNetworkPrefixForDublicate = function(Value)
{
    var networks = this.NetworksReportDataSource().rows;

    var finded = 0;

    networks.every(function (Item)
    {
        if(Item.type_id == PrefixTypeMapEnum.CIDR && (Item.cidr_ipv4 === Value || Item.cidr_ipv6 === Value))
        {
            finded = 1;

            return false;
        }
        else if(Item.type_id == PrefixTypeMapEnum.BGP && Item.regex == Value)
        {
            finded = 1;

            return false;
        }

        return true;
    });

    return finded;
};

UlrEditIspSubsViewController.prototype.AddNetwork = function(NetworkModel)
{
    var model = new UlrIspNetworkModel(NetworkModel);

    // TODO: CHECK FOR DUPLICATE (pageeeeeeeeeeeeeeeeeeeeeeeees)
    // if(model.type_id == PrefixTypeMapEnum.CIDR && this.CheckNetworkPrefixForDublicate(model.cidr_ipv4 ? model.cidr_ipv4 : model.cidr_ipv6))
    // {
    //     this.NetworksForm.MarkCidrInvalid(LangHelper.GetString("UlrModule", "Dublicate entry"));
    //     return;
    // }
    //
    // if(model.type_id == PrefixTypeMapEnum.BGP && this.CheckNetworkPrefixForDublicate(model.regex))
    // {
    //     this.NetworksForm.MarkRegexInvalid(LangHelper.GetString("UlrModule", "Dublicate entry"), LangHelper.GetString("UlrModule", "Dublicate entry"));
    //     return;
    // }

    this.AddedNetworks.push(model);

    this.ShowHideAddedNetworksTable();

    this.Views.ReportsWidgets.AddedNetworksReport.RefreshData();

    // var dataDics = this.ViewModel.IspNetworksDics;
    //
    // dataDics.AddedDataDic[model._id] = model;
    //
    // var table = this.Views.ReportsWidgets.NetworksReport.Views.Table;
    //
    // table.add(model,0);
    // table.hideOverlay();
    // table.hideProgress();

    this.NetworksForm.ClearValidation();
};

UlrEditIspSubsViewController.prototype.AddMultipleNetworks = function(Arr)
{
    if(Arr && Array.isArray(Arr) && Arr.length)
    {
        Arr.forEach((Model) => {
            var model = new UlrIspNetworkModel(Model);

            this.AddedNetworks.push(model);
        });

        this.ShowHideAddedNetworksTable();

        this.Views.ReportsWidgets.AddedNetworksReport.RefreshData();
    }
};

UlrEditIspSubsViewController.prototype.Save = function(Enable)
{
    var _this = this;
    if(!this.Views.IspEditForm.validate())
    {
        this.Views.ScrollView.scrollTo(0, 0);
        return;
    }

    var formProfile = this.Views.IspEditForm.getValues();

    if (_this.Views.VchannelNumField.isVisible())
    {
        const igw_id = formProfile.igw_id;
        const dic = this.ViewModel.FreeVchannels[igw_id] ? this.ViewModel.FreeVchannels[igw_id] : [];

        const vchannel = formProfile.vchannel_number;

        var invalid = false;
        if(dic)
        {
            if(vchannel)
            {
                const max_channel = Math.max(dic);
                if(vchannel > max_channel)
                {
                    invalid = true;
                    _this.Views.IspEditForm.markInvalid("vchannel_number", LangHelper.GetString("UlrModule", "The number exceeded the number of channels on one of the nodes"));
                }

                if(!invalid && dic.findIndex(val => val == vchannel) === -1)
                {
                    invalid = true;
                    _this.Views.IspEditForm.markInvalid("vchannel_number", LangHelper.GetString("UlrModule", "This channel is busy"));
                }
            }
            else
            {
                invalid = true;
                _this.Views.IspEditForm.markInvalid("vchannel_number", LangHelper.GetString("UlrModule", "Input correct channel number"));
            }
        }

        if(invalid)
        {
            this.Views.ScrollView.scrollTo(0, 0);
            return;
        }
    }

    var model = new UlrIspViewModel();

    var currProfile = this.ViewModel.Signals.IspProfileUpdated.getValue().profile;

    formProfile.type = this.subsEditMode ? "subscriber" : "isp"

    formProfile.network_learning = this.subsEditMode ? 0 : 1;

    model.profile = new UlrIspModel(webix.extend(currProfile, formProfile, true));

    if(typeof Enable != "undefined")
    {
        model.profile.enabled = Enable ? 1 : 0;
    }

    var table = this.Views.ReportsWidgets.NodesBridgesReport.Views.Table;

    var bridgesData = table.serialize();

    model.bridges = [];

    const
        vchannelNum = _this.Views.VchannelNumField.getValue();
    let
        borderFieldValue = _this.Views.BorderField.getValue(),
        dic = Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrIgwsVchannelTypesDic)),
        vchannelMode = false;

    if (!_this.subsEditMode && dic) {
        for (const dicItem of dic) {
            if (dicItem.id == borderFieldValue && dicItem.value == 3) {
                vchannelMode = true;
            }
        }
    }

    if (vchannelMode)
    {
        model.profile.login = formProfile.prefix;
    }
    else if (vchannelNum && !vchannelMode)
    {
        model.profile.vchannel_number = null;
    }

    bridgesData.forEach(function (Item)
    {
        var i = 0;

        if (!_this.subsEditMode && vchannelMode)
        {
            if (parseInt(Item["bridge_0"]) && vchannelNum){
                model.bridges.push({bridge_id:Item[`bridge_${vchannelNum - 1}_id`]})
            }
        }
        else
        {
            Object.keys(Item).forEach(function (Key)
            {
                if(Key == "bridge_" + i)
                {
                    if(parseInt(Item["bridge_" + i]))
                    {
                        model.bridges.push({bridge_id:Item["bridge_" + i + "_id"]});
                    }

                    i++;
                }
            });
        }
    });

    model.networks = {
        deleted: this.DeletedNetworks,
        added: this.AddedNetworks,
        modified: this.ModifiedNetworks,
        importFiles: this.NetworksForm.GetImportedFiles(),
        deleteAll: this.DeleteAll
    };

    this.ViewModel.SaveIspProfile(model);
};

UlrEditIspSubsViewController.prototype.RefreshNetworks = function()
{
    if(this.Action != this.ActionsEnum.Add && this.GetPathParam("_id"))
    {
        var filter = {
            isp_id: {
                id: "isp_id",
                operator: "=",
                value: this.GetPathParam("_id")
            }
        };

        this.Views.ReportsWidgets.NetworksReport.RefreshData(null,{
            filter: filter
        });
    }
};

UlrEditIspSubsViewController.prototype.ShowHideAddedNetworksTable = function()
{
    this.Signals.ShowAddedNetworks.next(this.AddedNetworks.length > 0);
};

UlrEditIspSubsViewController.prototype.AddedNetworksReportOnItemClick = function(Id)
{
    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.AddedNetworksReport.Views.Table;

        var item = table.getItem(Id);

        if(item)
        {
            const index = this.AddedNetworks.findIndex(x => x.id == item.id);
            if(index > -1)
            {
                this.AddedNetworks.splice(index, 1);
                this.Views.ReportsWidgets.AddedNetworksReport.RefreshData();
                this.ShowHideAddedNetworksTable();
            }
        }

        table.remove(Id);
    }
};

UlrEditIspSubsViewController.prototype.ClearAll = function()
{
    var table = this.Views.ReportsWidgets.NetworksReport.Views.Table;

    this.DeleteAll = true;
    var _id = this.GetPathParam("_id");

    var filter = {
        isp_id: {
            id: "isp_id",
            operator: "=",
            value: _id
        },
        isp_id_neq: {
            id: "isp_id",
            operator: "!=",
            value: _id
        }
    };

    this.Views.ReportsWidgets.NetworksReport.ExternalFilter = filter;

    table.clearAll();
};

UlrEditIspSubsViewController.prototype.Delete = function()
{
    var _this = this;

    var model = this.ViewModel.Signals.IspProfileUpdated.getValue();

    UlrShowDialogPopup({
        node:this.Views.DeleteBtn.getNode(),
        position:"bottom",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    _this.ViewModel.DeleteIspProfile(model.profile);
                }
            }
        ]
    });
};

UlrEditIspSubsViewController.prototype.ExportRule = function()
{
    var _this = this;
    this.Views.ExportBtn.disable();

    var exportType = this.Views.ExportPopupType.getValue();

    var params = {
        rule_id: this.GetPathParam("_id"),
        export_type: exportType,
        columns_header: [
            "",
            // LangHelper.GetString("UlrModule","Date"),
            LangHelper.GetString("UlrModule","CIDR"),
            LangHelper.GetString("UlrModule","Type"),
            LangHelper.GetString("UlrModule","Prefix type"),
            LangHelper.GetString("UlrModule","BGP diff auto apply"),
            LangHelper.GetString("UlrModule","IP version"),
            LangHelper.GetString("UlrModule","State")
        ],
        column_dics: {
            enabled: ControlTaskStatusesDic,
            create_type: {
                '0': { id: '0', value: LangHelper.GetString("UlrModule", "Manual") },
                '1': { id: '1', value: LangHelper.GetString("UlrModule", "Auto") }
            },
            type_id: PrefixTypeDic,
            bgp_diff_autoapply: ControlTaskStatusesDic,
            protocol_version: UlrIpProtocolVersionDic,
            state_bind: {
                '1': { id: '1', value: LangHelper.GetString("UlrModule","Binded") },
                '0': { id: '0', value: LangHelper.GetString("UlrModule","Unbinded") }
            },
            state_valid: {
                '0' : { id: '0', value : LangHelper.GetString("UlrModule", "No validation") } ,
                '1' : { id: '1', value : LangHelper.GetString("UlrModule", "Invalid") } ,
                '2' : { id: '2', value : LangHelper.GetString("UlrModule", "Valid") }
            }
        },
        filename: _this.subsEditMode ? LangHelper.GetString("UlrModule","Subscriber profile") : LangHelper.GetString("UlrModule","ISP profile"),
        lang: LangHelper.GetLocale()
    };

    this.ViewModel.GetIspExportFileData(params, function(R)
    {
        _this.Views.ExportBtn.enable();
    });
};
function UlrIspsListViewController(Params)
{
    var _this = this;

    var params = webix.extend(Params,{
        IsSubscribers: false,
        Id: "UlrIspsList"
    }, true);

    UlrIspsListViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrIspsListViewController, UlrIspsSubsListViewController);

// function UlrIspsListViewController(Params)
// {
//     var _this = this;
//
//     this.Id = "UlrIspsList";
//
//     this.PageTitle = {
//         RootTitle:LangHelper.GetString("UlrModule","Profile management"),
//         Title:LangHelper.GetString("UlrModule","Channels management")
//     };
//
//     this.mode = module ? module : "dpiui2";
//
//     this.ViewModel = new UlrIspsManager();
//
//     this.IspSessionPolicingManager = new UlrIspSessionPolicingsManager();
//
//     this.ReportsModel = new UniReportsManager();
//
//     this.Views = {
//         ToolsBtn:null,
//         ToolsSubmenu:null,
//         SessionPolicingPopupCheckbox: null,
//
//         Widgets:{
//             PolicingForm: new UlrEditSessionPolicingProtocolsFormWidget({id: this.Id + "UlrEditSessionPolicingFormWidget", reportAutoHeight: false})
//         },
//         ReportsWidgets:{
//             IspsReport: UlrIspsTableWidget({
//                 id:this.Id + "IspsReport",
//                 enableTextSearch:1,
//                 enableAutoHeight:1,
//                 onItemClick:function (Id, E, Node)
//                 {
//                     _this.IspsReportOnItemClick(Id, E, Node);
//                 },
//                 onCheck:function (Row, Column, State)
//                 {
//                     _this.IspsReportOnCheck(Row, Column, State);
//                 }
//             })
//         }
//     };
//
//     this.ToolsSubmenu = webix.ui({
//         view: "submenu",
//         id: _this.Id + "ToolsSubmenu",
//         width: 200,
//         autowidth: true,
//         padding: 0,
//         data: [
//             {
//                 id: _this.Id + "ToolsSubmenu" + "DSCPPerSession", icon: "tasks", value: LangHelper.GetString("UlrModule", "DSCP & Per-session"),
//                 submenu:[
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "SetPerSessionPolicing", icon: "pencil", value: LangHelper.GetString("UlrModule", "Set per-session policing")
//                     },
//                     {id: _this.Id + "TraceIpSeparator", $template: "Separator"},
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "EnablePerSessionPolicing",
//                         icon: "lightbulb bold green",
//                         value: LangHelper.GetString("UlrModule", "Enable per-session policing")
//                     },
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "DisablePerSessionPolicing",
//                         icon: "lightbulb red",
//                         value: LangHelper.GetString("UlrModule", "Disable per-session policing")
//                     },
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "DeletePerSessionPolicing",
//                         icon: "trash",
//                         value: LangHelper.GetString("UlrModule", "Clear per-session policing")
//                     },
//                 ]
//             },
//             {
//                 id: _this.Id + "IspProfile", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Channel profile"),
//                 submenu:[
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "EnableProfiles",
//                         icon: "lightbulb bold green",
//                         value: LangHelper.GetString("UlrModule", "Enable profiles")
//                     },
//                     {
//                         id: _this.Id + "ToolsSubmenu" + "DisableProfiles",
//                         icon: "lightbulb red",
//                         value: LangHelper.GetString("UlrModule", "Disable profiles")
//                     },
//                 ]
//             }
//         ],
//         on: {
//             onMenuItemClick: function (Id)
//             {
//                 let selectedRows = _this.Views.ReportsWidgets.IspsReport.GetSelectedData();
//
//                 if(Id === _this.Id + "ToolsSubmenu" + "SetPerSessionPolicing")
//                 {
//                     _this.SetSessionPolicingPopup.show();
//                     this.hide();
//                 }
//
//                 if(Id ===  _this.Id + "ToolsSubmenu" + "EnablePerSessionPolicing")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             _this.EnableDisableSessionPolicing(RowData, 1);
//                         })
//                     }
//                 }
//
//                 if(Id ===  _this.Id + "ToolsSubmenu" + "DisablePerSessionPolicing")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             _this.EnableDisableSessionPolicing(RowData, 0);
//                         })
//                     }
//                 }
//
//                 if (Id === _this.Id + "ToolsSubmenu" + "DeletePerSessionPolicing")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             if (RowData.session_policing_id) {
//                                 _this.IspSessionPolicingManager.DeleteProfile({
//                                     _id:RowData.session_policing_id,
//                                     isp_id:RowData._id
//                                 });
//                             }
//                         })
//                     }
//                 }
//
//                 if (Id === _this.Id + "ToolsSubmenu" + "EnableProfiles")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             if (RowData.enabled != 1)
//                             {
//                                 _this.ViewModel.EnableDisableIspProfile(RowData, 1);
//                             }
//                         })
//                     }
//                 }
//
//                 if (Id === _this.Id + "ToolsSubmenu" + "DisableProfiles")
//                 {
//                     if (selectedRows && selectedRows.length)
//                     {
//                         selectedRows.forEach(RowData => {
//                             if (RowData.enabled != 0)
//                             {
//                                 _this.ViewModel.EnableDisableIspProfile(RowData, 0);
//                             }
//                         })
//                     }
//                 }
//             }
//         }
//     });
//
//     this.SetSessionPolicingPopup = webix.ui({
//         view: "window",
//         css:"spectre-alert form_modal",
//         width:1080,
//         height: 880,
//         modal:true,
//         position:"center",
//         padding:0,
//         marging:0,
//         head: {
//             view: "toolbar",
//             cols: [
//                 {
//                     view: "label",
//                     id: this.Id + "EditPopupHeadLabel",
//                     label: LangHelper.GetString("UlrModule", "Set per-session policing for selected profiles"),
//                     height: 68
//                 },
//                 {
//                     view: "spectre_button",
//                     css: "form_button spec_action with_icon",
//                     type: "icon",
//                     icon: "times",
//                     align: "right",
//                     width: 68,
//                     height: 68,
//                     click: function()
//                     {
//                         _this.Views.Widgets.PolicingForm.SetFormToDefault();
//                         _this.SetSessionPolicingPopup.hide();
//                     }
//                 }
//             ]
//         },
//         body:
//         {
//             type: "wide",
//             rows:[
//                 {
//                     view:"scrollview",
//                     scroll:"y",
//                     body:{
//                         type: "wide",
//                         rows:[
//                             _this.Views.Widgets.PolicingForm.ViewConfig
//                         ]
//                     }
//                 },
//                 {
//                     cols: [
//                         {
//                             width: 24
//                         },
//                         {
//                             view: "spectre_toggle",
//                             id: this.Id + "SessionPolicingPopupCheckbox",
//                             // label: LangHelper.GetString("UlrModule", "Clear session policing"),
//                             value: false,
//                             width: 32,
//                             height: 22
//                         },
//                         {
//                             width: webix.html.getTextSize(LangHelper.GetString("UlrModule","Remove protocols").replace(" ", "_"), "app_block__header_webix_template").width + 32,
//                             rows: [
//                                 {
//                                     cols: [
//                                         BlockHeaderTemplate({
//                                             title:LangHelper.GetString("UlrModule","Remove protocols"),
//                                             icon:"",
//                                             borderless:true
//                                         }),
//                                         {
//                                             view: "spectre_button",
//                                             id:_this.Id + "HarBlockingIPsHelpBtn",
//                                             type: "icon",
//                                             icon: "question-circle",
//                                             css:"toolbar_round_btn custom-form-btn",
//                                             width:32,
//                                             height:25,
//                                             tooltip:LangHelper.GetString("UlrModule", "Help"),
//                                             click:function (id)
//                                             {
//                                                 UlrShowSessionPolicingClearProtocolHelpPopup();
//                                             }
//                                         }
//                                     ]
//                                 }
//                             ]
//                         }
//                     ]
//                 },
//                 {
//                     type: "space",
//                     borderless: true,
//                     cols: [
//                         {
//                             view: "spectre_button",
//                             id: this.Id + "ApplyBtn",
//                             css: "form_button main_action",
//                             label: LangHelper.GetString("UlrModule", "Apply"),
//                             autowidth: true,
//                             click: function () {
//                                 _this.SetSessionPolicing(1);
//                             }
//                         },
//                         {
//                             view: "spectre_button",
//                             id: this.Id + "ApplyDisableBtn",
//                             css: "form_button second_action",
//                             label: LangHelper.GetString("UlrModule", "Apply and disable"),
//                             autowidth: true,
//                             click: function () {
//                                 _this.SetSessionPolicing(0);
//                             }
//                         },
//                         {
//                             view: "spectre_button",
//                             id: this.Id + "CancelBtn",
//                             css: "form_button spec_action",
//                             label: LangHelper.GetString("UlrModule", "Cancel"),
//                             autowidth: true,
//                             click: function () {
//                                 _this.Views.Widgets.PolicingForm.SetFormToDefault();
//                                 _this.SetSessionPolicingPopup.hide();
//                             }
//                         },
//                         {},
//                         {
//                             view: "spectre_button",
//                             id: this.Id + "CommonPolicingsBtn",
//                             css: "form_button spec_action",
//                             label: LangHelper.GetString("UlrModule", "Upload common policings"),
//                             autowidth: true,
//                             click: function () {
//                                 _this.GetSessionPolicingsByIds();
//                             }
//                         },
//                     ]
//                 }
//             ]
//
//         }
//     });
//
//     this.ViewConfig = [
//         {
//             view:"scrollview",
//             scroll:"y",
//             body:{
//                 type: "space",
//                 rows: [
//                     {
//                         type: "clean",
//                         borderless:true,
//                         rows: [
//                             {height:6},
//                             PageHeaderTemplate({root_title:this.PageTitle.Title}),
//                             {height:32},
//                             {
//                                 type:"wide",
//                                 rows:[
//                                     {
//                                         type: "wide",
//                                         cols: [
//                                             {
//                                                 view: "label",
//                                                 css: "form_text_label",
//                                                 label: LangHelper.GetString("UlrModule", "Select ISP Profile from the list")
//                                             },
//                                             {
//                                                 view: "spectre_button",
//                                                 id: this.Id + "ToolsBtn",
//                                                 type: "icon",
//                                                 css: "form_button spec_action with_icon",
//                                                 label: LangHelper.GetString("UlrModule", "Tools"),
//                                                 icon: "tools",
//                                                 autowidth: true,
//                                                 click: function () {
//                                                     _this.Views.ToolsSubmenu.show(this.getNode());
//                                                 }
//                                             }
//                                         ]
//                                     },
//                                     this.Views.ReportsWidgets.IspsReport.ViewConfig
//                                 ]
//                             },
//                         ]
//                     }
//                 ]
//             }
//         }
//     ];
//
//     this.Subscriptions = {};
// }
//
// UlrIspsListViewController.prototype.BindAll = function (Params)
// {
//     var _this = this;
//
//     Object.keys(this.Views).forEach(function (View)
//     {
//         if(View != "Widgets" && View != "ReportsWidgets")
//             _this.Views[View] = $$(_this.Id + View)
//     });
//
//     Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
//     {
//         var w = _this.Views.Widgets[WidgetKey];
//
//         if(w.BindAll)
//             w.BindAll(_this, _this.ViewModel);
//
//         if(w.Bind)
//             w.Bind(_this, _this.ViewModel);
//     });
//
//     Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
//     {
//         var w = _this.Views.ReportsWidgets[WidgetKey];
//
//         if(w.BindAll)
//             w.BindAll(_this, _this.ReportsModel);
//
//         if(w.Bind)
//             w.Bind(_this, _this.ReportsModel);
//     });
//
//     this.Subscriptions.IspProfileDeleteError = this.ViewModel.Signals.IspProfileDeleteError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.IspProfileEnableStateError = this.ViewModel.Signals.IspProfileEnableStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.IspProfileDeleted = this.ViewModel.Signals.IspProfileDeleted.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             _this.IspsReportOnSuccessDelete(IspModel);
//
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.FederalListStateUpdated = this.ViewModel.Signals.FederalListStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Global list state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.FederalListStateError = this.ViewModel.Signals.FederalListStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.ExcludedResourcesStateUpdated = this.ViewModel.Signals.ExcludedResourcesStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Exclusion list state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.ExcludedResourcesStateError = this.ViewModel.Signals.ExcludedResourcesStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.BlockIPv6StateUpdated = this.ViewModel.Signals.BlockIPv6StateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Block IPv6 state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.BlockIPv6StateError = this.ViewModel.Signals.BlockIPv6StateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.SpoofDnsStateUpdated = this.ViewModel.Signals.SpoofDnsStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Spoof DNS state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.SpoofDnsStateError = this.ViewModel.Signals.SpoofDnsStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.IspProfileEnableStateUpdated = this.ViewModel.Signals.IspProfileEnableStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             _this.IspProfileEnableStateUpdated(IspModel);
//
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP profile")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Enable state changing"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.SessionPolicingProfileEnableStateError = this.ViewModel.Signals.SessionPolicingProfileEnableStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.SessionPolicingProfileEnableStateUpdated = this.ViewModel.Signals.SessionPolicingProfileEnableStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             _this.Refresh();
//
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP Session policing Enabled/Disabled"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.PolicingProfileEnableStateError = this.ViewModel.Signals.PolicingProfileEnableStateError.subscribe(function (ErrModel)
//     {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.PolicingProfileEnableStateUpdated = this.ViewModel.Signals.PolicingProfileEnableStateUpdated.subscribe(function (IspModel)
//     {
//         if(IspModel)
//         {
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","ISP policing Enabled/Disabled"),
//                 LangHelper.GetString("UlrModule","Success")
//             );
//         }
//     });
//
//     this.Subscriptions.PolicingMultiplySetSuccess = this.IspSessionPolicingManager.Signals.PolicingMultiplySetSuccess.subscribe(function (Updated) {
//         if(Updated)
//         {
//             _this.Refresh();
//
//             UlrShowMessage(
//                 "success",
//                 LangHelper.GetString("UlrModule","Added new per-session policing profiles"),
//                 LangHelper.GetString("UlrModule","For selected profiles added new per-session policing profiles.")
//             );
//         }
//     });
//
//
//     this.Subscriptions.GetCommonSessionPolicingsByIspIdsSuccess = this.IspSessionPolicingManager.Signals.GetCommonSessionPolicingsByIspIdsSuccess.subscribe(function (Data) {
//         if (Data)
//         {
//             _this.Views.Widgets.PolicingForm.AddCommonProtocols(Data)
//         }
//     });
//
//     this.Subscriptions.GetCommonSessionPolicingsByIspIdsNotFound = this.IspSessionPolicingManager.Signals.GetCommonSessionPolicingsByIspIdsNotFound.subscribe(function (Update) {
//         if (Update)
//         {
//             UlrShowMessage(
//                 "info",
//                 LangHelper.GetString("UlrModule","No common protocols found."),
//             );
//         }
//     });
//
//     this.Subscriptions.ServerError = this.IspSessionPolicingManager.Signals.ServerError.subscribe(function (ErrModel) {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.PolicingMultiplySetSuccess = this.IspSessionPolicingManager.Signals.PolicingProfileDeleted.subscribe(function (Updated) {
//         if(Updated)
//         {
//             _this.Refresh();
//
//             let profileName = "";
//
//             if (Updated.isp_id)
//             {
//                 let rows = _this.Views.ReportsWidgets.IspsReport.Views.Table.serialize();
//                 let find = rows.find(item => {
//                     return item._id === Updated.isp_id;
//                 })
//
//                 profileName =  find && find.name ? find.name : ""
//             }
//
//             UlrShowMessage(
//                 "success",
//                 profileName,
//                 LangHelper.GetString("UlrModule","Session policing removed.")
//             );
//         }
//     });
//
//     this.Subscriptions.ServerError = this.IspSessionPolicingManager.Signals.PolicingProfileDeleteError.subscribe(function (ErrModel) {
//         if(ErrModel)
//             _this.ShowServerError(ErrModel);
//     });
//
//     this.Subscriptions.IspProfileSelectedCount = this.Views.ReportsWidgets.IspsReport.TableRowsSelectedCount.subscribe(function (Value) {
//        if (Value > 1)
//        {
//            _this.Views.ToolsBtn.enable();
//        }
//        else
//        {
//            _this.Views.ToolsBtn.disable();
//        }
//     });
//
//     this.Views.ReportsWidgets.IspsReport.Views.Table.attachEvent("onAfterSelect", function (Row) {
//         var item = this.getItem(Row);
//
//         if (item)
//         {
//             if (!parseInt(item.checked)) {
//                 item.checked = 1;
//             }
//             this.updateItem(Row, item);
//         }
//     });
//
//     this.Views.ReportsWidgets.IspsReport.Views.Table.attachEvent("onAfterUnSelect", function (Row) {
//         var item = this.getItem(Row);
//
//         if (item)
//         {
//             if (parseInt(item.checked)) {
//                 item.checked = 0;
//             }
//             this.updateItem(Row, item);
//         }
//     });
// };
//
// UlrIspsListViewController.prototype.ViewDidLoad = function (Params)
// {
//     var _this = this;
//
//     this.BindAll(Params);
//
//     this.Refresh();
// };
//
// UlrIspsListViewController.prototype.Destroy = function ()
// {
//     var _this = this;
//
//     Object.keys(this.Subscriptions).forEach(function (key)
//     {
//         if(_this.Subscriptions[key])
//             _this.Subscriptions[key].unsubscribe();
//     });
//
//     Object.keys(this.Views.Widgets).forEach(function (Widget)
//     {
//         var w = _this.Views.Widgets[Widget];
//         if(w.Destroy)
//             w.Destroy();
//     });
//
//     Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
//     {
//         var w = _this.Views.ReportsWidgets[Widget];
//         if(w.Destroy)
//             w.Destroy();
//     });
//
//     if(this.ViewModel)
//     {
//         this.ViewModel.Destroy();
//         delete this.ViewModel;
//     }
//
//     if(this.ReportsModel)
//     {
//         this.ReportsModel.Destroy();
//         delete this.ReportsModel;
//     }
//
//     if(this.IspSessionPolicingManager)
//     {
//         this.IspSessionPolicingManager.Destroy();
//         delete this.IspSessionPolicingManager;
//     }
// };
//
// UlrIspsListViewController.prototype.Refresh = function ()
// {
//     let checkboxControl = this.Views.ReportsWidgets.IspsReport.Views.Table.getHeaderContent("cm1");
//
//     if (checkboxControl.isChecked())
//     {
//         checkboxControl.uncheck();
//     }
//
//     this.Views.ReportsWidgets.IspsReport.RefreshData();
// };
//
// UlrIspsListViewController.prototype.SetSessionPolicing = function (Enabled)
// {
//     var _this = this;
//
//     if (!_this.Views.Widgets.PolicingForm.ValidateProtocolTable())
//         return;
//
//     let selectedIspProfiles = _this.Views.ReportsWidgets.IspsReport.Views.Table.getSelectedItem();
//
//     selectedIspProfiles = selectedIspProfiles.filter(function (Item)
//     {
//         return parseInt(Item.checked) ? true : false;
//     });
//
//     if(!selectedIspProfiles.length)
//         return;
//
//     let rows = _this.Views.Widgets.PolicingForm.Views.ReportsWidgets.ProtocolsReport.Views.Table.serialize();
//
//     if(!rows.length)
//     {
//         UlrShowMessage(
//             "error",
//             LangHelper.GetString("UlrModule", "No protocol added."),
//             LangHelper.GetString("UlrModule", "To set per-session policing for selected profiles, add at least one protocol.")
//         );
//         return;
//     }
//
//     let data = [];
//
//     selectedIspProfiles.forEach(Profile => {
//
//         let cfg_rows = [];
//
//         rows.forEach(Row => {
//             let policingModel = new SessionPolicingProtocolModel(Row);
//
//             if(policingModel.type === UlrProtocolTypesDic.protocol.id)
//             {
//                 cfg_rows.push(policingModel);
//             }
//             else
//             {
//                 cfg_rows.unshift(policingModel);
//             }
//         });
//
//         data.push({
//             "isp_id": Profile._id,
//             "description": Profile.name,
//             "config": JSON.stringify(cfg_rows)});
//         })
//
//     var delete_protos = this.Views.SessionPolicingPopupCheckbox.getValue();
//     delete_protos = delete_protos ? 1 : 0;
//
//     _this.IspSessionPolicingManager.MultiplySetIspSessionPolicing(data, Enabled, delete_protos);
//
//     _this.Views.Widgets.PolicingForm.SetFormToDefault();
//     _this.SetSessionPolicingPopup.hide();
// };
//
// UlrIspsListViewController.prototype.GetSessionPolicingsByIds = function ()
// {
//     let _this = this;
//
//     let selectedIspProfiles = _this.Views.ReportsWidgets.IspsReport.Views.Table.getSelectedItem();
//
//     selectedIspProfiles = selectedIspProfiles.filter(function (Item)
//     {
//         return parseInt(Item.checked) ? true : false;
//     });
//
//     if(!selectedIspProfiles.length)
//         return;
//
//     let profiles_ids = [];
//
//     selectedIspProfiles.forEach(val => {
//         profiles_ids.push(val._id);
//     })
//
//     _this.IspSessionPolicingManager.GetCommonSessionPolicingsByIspIds({data: profiles_ids});
// };
//
// UlrIspsListViewController.prototype.EnableDisableSessionPolicing = function(RowData, State)
// {
//     let profileName = RowData && RowData.name ? RowData.name : "";
//
//     if (RowData && RowData.session_policing_id)
//     {
//         if (RowData.session_policing_enabled != State)
//         {
//             this.ViewModel.EnableDisableSessionPolicingProfile({_id:RowData.session_policing_id}, State);
//         }
//         else
//         {
//             UlrShowMessage(
//                 "info",
//                 LangHelper.GetString("UlrModule", "Per-session policing for [PROFILE] is already " + ((State ? "enabled." : "disabled.")))
//                     .replace("[PROFILE]", profileName)
//             );
//         }
//     }
//     else
//     {
//         UlrShowMessage(
//             "error",
//             LangHelper.GetString("UlrModule", "Profile name") + ": " + profileName,
//             LangHelper.GetString("UlrModule", "To Enable/Disable per-session policing, it must be configured.")
//         );
//     }
// };
//
// UlrIspsListViewController.prototype.GetPageTitle = function ()
// {
//     if(this.PageTitle)
//         return this.PageTitle;
// };
//
// UlrIspsListViewController.prototype.IspsReportOnItemClick = function(Id, E, Node)
// {
//     var _this = this;
//
//     if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
//     {
//         var table = this.Views.ReportsWidgets.IspsReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         App.NavRouter.PresentView({id: ControllersEnum.UlrEditIsp, path:"/_id=" + data._id});
//     }
//
//     if(Id.column === 'policing_url')
//     {
//         var table = this.Views.ReportsWidgets.IspsReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         App.NavRouter.PresentView({id: 'UlrEditAppPolicing', path:"/_id=" + data._id + "/source=UlrIspsList"});
//     }
//
//     if(Id.column === 'session_policing_url')
//     {
//         var table = this.Views.ReportsWidgets.IspsReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         App.NavRouter.PresentView({id: 'UlrEditIspSessionPolicing', path:"/_id=" + data._id + "/source=UlrIspsList"});
//     }
//
//     if(Id.column === 'web_rule')
//     {
//         var table = this.Views.ReportsWidgets.IspsReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         var total = data && data.total_web_rules && parseInt(data.total_web_rules) ? parseInt(data.total_web_rules) : 0;
//
//         if(total > 0)
//         {
//             App.NavRouter.PresentView({id: 'UlrWebIpFilterRules', path:"/isp_id=" + data._id});
//         }
//     }
//
//     if(Id.column === 'delete')
//     {
//         var table = this.Views.ReportsWidgets.IspsReport.Views.Table;
//
//         var data = table.getItem(Id);
//
//         var node = table.getItemNode(Id);
//
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule","Delete") + "?",
//             //type:"spectre-alert-notification",
//             mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel")
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule","Delete"),
//                     click:function ()
//                     {
//                         _this.ViewModel.DeleteIspProfile(data);
//                     }
//                 }
//             ]
//         });
//     }
// };
//
// UlrIspsListViewController.prototype.IspsReportOnCheck = function(Row, Column, State)
// {
//     var _this = this;
//     var table = this.Views.ReportsWidgets.IspsReport.Views.Table;
//
//     var data = table.getItem(Row);
//
//
//     if(Column == "checked") {
//
//         var item = table.getItem(Row);
//
//         if(item.checked)
//         {
//             table.select(Row, true)
//         }
//         else
//         {
//             table.unselect(Row);
//         }
//     }
//
//     if(Column == 'enabled')
//     {
//         this.ViewModel.EnableDisableIspProfile(webix.extend(data, {callback:function (R)
//             {
//                 if(!R.success)
//                 {
//                     data.enabled = State ? 0 : 1;
//
//                     table.updateItem(data.id, data);
//                 }
//             }}), State);
//     }
//
//     if(Column == 'policing_enabled')
//     {
//         this.ViewModel.EnableDisableAppPolicingProfile(webix.extend({_id: data.policing_id}, {callback:function (R)
//             {
//                 if(!R.success)
//                 {
//                     data.policing_enabled = State ? 0 : 1;
//
//                     table.updateItem(data.id, data);
//                 }
//             }}), State);
//     }
//
//     if(Column == 'session_policing_enabled')
//     {
//         this.ViewModel.EnableDisableSessionPolicingProfile(webix.extend({_id: data.session_policing_id}, {callback:function (R)
//             {
//                 if(!R.success)
//                 {
//                     data.session_policing_enabled = State ? 0 : 1;
//
//                     table.updateItem(data.id, data);
//                 }
//             }}), State);
//     }
//
//     if(Column == 'federal_bl')
//     {
//         var node = table.getItemNode({row: Row, column: 'federal_bl'});
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule",parseInt(data.federal_bl) ? "Enable" : "Disable") + "?",
//             //type:"spectre-alert-notification",
//             mainTitle:LangHelper.GetString("UlrModule",parseInt(data.federal_bl) ? "Enable" : "Disable") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel"),
//                     click: function()
//                     {
//                         data.federal_bl = State ? 0 : 1;
//
//                         table.updateItem(data.id, data);
//                     }
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule",parseInt(data.federal_bl) ? "Enable" : "Disable"),
//                     click:function ()
//                     {
//                         _this.ViewModel.EnableDisableFederalLists(data, parseInt(data.federal_bl), function(R)
//                         {
//                             if(!R.success)
//                             {
//                                 data.federal_bl = State ? 0 : 1;
//
//                                 table.updateItem(data.id, data);
//                             }
//                         });
//                     }
//                 }
//             ]
//         });
//     }
//
//     if(Column == 'web_rule_exclude')
//     {
//         var node = table.getItemNode({row: Row, column: 'web_rule_exclude'});
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule",parseInt(data.web_rule_exclude) ? "Enable" : "Disable") + "?",
//             //type:"spectre-alert-notification",
//             mainTitle:LangHelper.GetString("UlrModule",parseInt(data.web_rule_exclude) ? "Enable" : "Disable") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel"),
//                     click: function()
//                     {
//                         data.web_rule_exclude = State ? 0 : 1;
//
//                         table.updateItem(data.id, data);
//                     }
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule",parseInt(data.web_rule_exclude) ? "Enable" : "Disable"),
//                     click:function ()
//                     {
//                         _this.ViewModel.EnableDisableExcludedResources(data, parseInt(data.web_rule_exclude), function(R)
//                         {
//                             if(!R.success)
//                             {
//                                 data.web_rule_exclude = State ? 0 : 1;
//
//                                 table.updateItem(data.id, data);
//                             }
//                         });
//                     }
//                 }
//             ]
//         });
//     }
//
//     if(Column == 'block_ipv6')
//     {
//         var node = table.getItemNode({row: Row, column: 'block_ipv6'});
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule",parseInt(data.block_ipv6) ? "Enable" : "Disable") + "?",
//             //type:"spectre-alert-notification",
//             mainTitle:LangHelper.GetString("UlrModule",parseInt(data.block_ipv6) ? "Enable" : "Disable") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel"),
//                     click: function()
//                     {
//                         data.block_ipv6 = State ? 0 : 1;
//
//                         table.updateItem(data.id, data);
//                     }
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule",parseInt(data.block_ipv6) ? "Enable" : "Disable"),
//                     click:function ()
//                     {
//                         _this.ViewModel.EnableDisableBlockIPv6(data, parseInt(data.block_ipv6), function(R)
//                         {
//                             if(!R.success)
//                             {
//                                 data.block_ipv6 = State ? 0 : 1;
//
//                                 table.updateItem(data.id, data);
//                             }
//                         });
//                     }
//                 }
//             ]
//         });
//     }
//
//     if(Column == 'spoof_dns')
//     {
//         var node = table.getItemNode({row: Row, column: 'spoof_dns'});
//         UlrShowDialogPopup({
//             node:node,
//             position:"bottom",
//             head:LangHelper.GetString("UlrModule",parseInt(data.spoof_dns) ? "Enable" : "Disable") + "?",
//             mainTitle:LangHelper.GetString("UlrModule",parseInt(data.spoof_dns) ? "Enable" : "Disable") + "?",
//             message:LangHelper.GetString("UlrModule","Are you sure?"),
//             actions:[
//                 {
//                     css:"spec_action",
//                     label:LangHelper.GetString("UlrModule","Cancel"),
//                     click: function()
//                     {
//                         data.spoof_dns = State ? 0 : 1;
//
//                         table.updateItem(data.id, data);
//                     }
//                 },
//                 {
//                     label:LangHelper.GetString("UlrModule",parseInt(data.spoof_dns) ? "Enable" : "Disable"),
//                     click:function ()
//                     {
//                         _this.ViewModel.EnableDisableSpoofDns(data, parseInt(data.spoof_dns), function(R)
//                         {
//                             if(!R.success)
//                             {
//                                 data.spoof_dns = State ? 0 : 1;
//
//                                 table.updateItem(data.id, data);
//                             }
//                         });
//                     }
//                 }
//             ]
//         });
//     }
//
// };
//
// UlrIspsListViewController.prototype.IspsReportOnSuccessDelete = function(IspModel)
// {
//     var table = this.Views.ReportsWidgets.IspsReport.Views.Table;
//
//     var data = table.find(function(obj){
//         return obj._id == IspModel._id;
//     });
//
//     if(data && data.length == 1 && data[0].id)
//     {
//         table.remove(data[0].id);
//
//         if(!table.count())
//             this.Refresh();
//     }
//
// };
//
// UlrIspsListViewController.prototype.IspProfileEnableStateUpdated = function(IspModel)
// {
//     var table = this.Views.ReportsWidgets.IspsReport.Views.Table;
//
//     var data = table.find(function(obj){
//         return obj._id == IspModel._id;
//     });
//
//     if(data && data.length == 1 && data[0].id)
//     {
//         data = data[0];
//         data.enabled = IspModel.enabled;
//         table.updateItem(data.id, data);
//     }
//
// };
//
// UlrIspsListViewController.prototype.ShowServerError = function(ErrModel)
// {
//     if(ErrModel)
//         UlrShowAlertWindow({
//             head:LangHelper.GetString("UlrModule","Error"),
//             type:"spectre-alert-error",
//             mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
//             message:LangHelper.GetString("UlrModule",ErrModel.msg),
//             actions:[
//                 {
//                     label:LangHelper.GetString("UlrModule","Ok"),
//                     click:function ()
//                     {
//
//                     }
//                 }
//             ]
//         });
// };
function UlrEditIspViewController(Params)
{
    var _this = this;

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.Id = "UlrEditIsp";
    this.RootTitle = LangHelper.GetString("UlrModule","Profile management");
    this.Title = LangHelper.GetString("UlrModule","Edit ISP profile");
    this.ViewModel = new UlrIspsManager();
    this.ReportsModel = new UniReportsManager();
    this.Action = this.ActionsEnum.Edit;

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ViewModel: this.ViewModel,
        ReportsModel: this.ReportsModel,
        Action: this.Action,
        Mode: "Isp"
    }, true);

    UlrEditIspViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrEditIspViewController, UlrEditIspSubsViewController);

function UlrAddIspViewController(Params)
{
    UlrAddIspViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddIspViewController,UlrEditIspViewController);
function UlrEditIgwViewController(Params)
{
    var _this = this;

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.Action = this.ActionsEnum.Edit;

    this.Id = "UlrEditIgw";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Profile management"),
        Title:LangHelper.GetString("UlrModule","Edit IGW profile")
    };

    this.ViewModel = new UlrIgwsManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        IgwEditForm:null,
        SaveBtn:null,

        VchannelType: null,

        AddNodeForm:null,
        NodeNameInput:null,
        DPIInput:null,
        Bridges:null,
        BridgesVchannel: null,
        IpFix: null,
        AddNodeBtn:null,

        EditPopupNodeForm:null,
        EditPopupNodeNameInput:null,
        EditPopupDPIInput:null,
        EditPopupBridges:null,
        EditPopupBridgesVchannel:null,
        EditPopupNodeIpFixInput:null,
        EditPopupOkBtn:null,

        Widgets:{},
        ReportsWidgets:{
            NodesReport: UrlIgwNodesTableWidget({
                id:this.Id + "NodesReport",
                //enableTextSearch:1,
                enableAutoHeight:1,
                hidePaginatorToolbar:1,
                enableLocalSort:1,
                enableLocalDataSource:1,
                dataSource:function (FilterParams)
                {
                    return _this.NodesReportDataSource(FilterParams);
                },
                onItemClick:function (Id)
                {
                    setTimeout(function () {
                        _this.NodesReportOnItemClick(Id);
                    },1);
                },
                onCheck:function (Row, Column, State)
                {
                    _this.NodesReportOnCheck(Row, Column, State);
                }
            })
        }
    };

    this.EditPopup = null;

    this.EditPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        width:400,
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "EditPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Edit node"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.EditPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "EditPopupNodeForm",
                            type: "wide",
                            elements: [
                                {
                                    type: "wide",
                                    rows:[
                                        {
                                            view:"spectre_text",
                                            id:_this.Id + "EditPopupNodeNameInput",
                                            name:"name",
                                            label:LangHelper.GetString("UlrModule","Node name"),
                                            validate: webix.rules.isNotEmpty
                                        },
                                        {
                                            view:"spectre_richselect",
                                            id:_this.Id + "EditPopupDPIInput",
                                            name:"hardware_id",
                                            label:LangHelper.GetString("UlrModule","DPI hardware name"),
                                            options:{
                                                point:false,
                                                data:[]
                                            }
                                        },
                                        {
                                            view:"spectre_text",
                                            id:_this.Id + "EditPopupBridgesVchannel",
                                            name:"bridges_vchannel",
                                            label:LangHelper.GetString("UlrModule","Channels"),
                                            hidden: true,
                                            validate: function(Val)
                                            {
                                                if(Val == "" || Val < 1 || Val > 1024)
                                                {
                                                    return false;
                                                }

                                                return !isNaN(Val);
                                            },
                                            invalidMessage: LangHelper.GetString("UlrModule", "Input number from 1 to 1024"),
                                        },
                                        {
                                            view:"spectre_richselect",
                                            id:_this.Id + "EditPopupBridges",
                                            name:"bridges_num",
                                            label:LangHelper.GetString("UlrModule","Bridges"),
                                            options:{
                                                point:false,
                                                data:_this.BridgesNumOptions()
                                            }
                                        },
                                        {
                                            view:"spectre_text",
                                            id:_this.Id + "EditPopupNodeIpFixInput",
                                            name:"ipfix_number",
                                            label:LangHelper.GetString("UlrModule","Ipfix number"),
                                            validate: function(Val)
                                            {
                                                if(Val == "")
                                                {
                                                    return false;
                                                }
                                                return !isNaN(Val);
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:this.Id + "EditPopupOkBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Ok"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function () {
                                            _this.SaveEditForm();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({
                                id:this.Id + "PageTitle",
                                root_title:this.PageTitle.Title
                            }),
                            {height:32},
                            {
                                view:"form",
                                id:this.Id + "IgwEditForm",
                                type: "wide",
                                borderless:true,
                                elements:[
                                    {
                                        cols:[
                                            {
                                                view:"spectre_captionlabel",
                                                name:"_id",
                                                caption:LangHelper.GetString("UlrModule","IGW profile id")
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                view:"spectre_text",
                                                name:"name",
                                                label:LangHelper.GetString("UlrModule","IGW profile name"),
                                                required:true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined")
                                                        {
                                                            if(Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                            this.validate();
                                                        }

                                                    }
                                                }
                                            },
                                            {
                                                view:"spectre_richselect",
                                                name:"mode_id",
                                                label:LangHelper.GetString("UlrModule","Mode"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                },
                                                required:true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                            this.validate();
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        type: "wide",
                                        cols:[
                                            {
                                                view:"spectre_text",
                                                name:"dpiui2_dest",
                                                label:LangHelper.GetString("UlrModule","QoE UI host")
                                            },
                                            {
                                                view:"spectre_richselect",
                                                id: this.Id + "VchannelType",
                                                name:"vchannel_type",
                                                label:LangHelper.GetString("UlrModule","Vchannel mode"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                },
                                                required:true,
                                                validate: webix.rules.isNotEmpty,
                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        const table = _this.Views.ReportsWidgets.NodesReport.Views.Table;

                                                        if(typeof Ov !== "undefined" && Ov !== ""){
                                                            this.validate();
                                                            const rows = table.serialize();

                                                            if (Nv == 1) {
                                                                for (const row of rows) {
                                                                    if (row.bridges_num > 4) {
                                                                        row.bridges_num = 4;

                                                                        let model = {
                                                                            name:row.name,
                                                                            hardware_id:row.hardware_id,
                                                                            bridges_num:row.bridges_num,
                                                                            ipfix_number:row.ipfix_number,
                                                                            is_modified:1
                                                                        };
                                                                        _this.UpdateNode(model, row.id)
                                                                    }
                                                                }

                                                                table.refresh();
                                                            }
                                                        }

                                                        if (Nv == 3) {
                                                            _this.Views.Bridges.hide();
                                                            _this.Views.BridgesVchannel.show();
                                                            table.getColumnConfig("bridges_num").header[0] = LangHelper.GetString("UlrModule","Channels");
                                                        } else {
                                                            _this.Views.Bridges.show();
                                                            _this.Views.BridgesVchannel.hide();
                                                            table.getColumnConfig("bridges_num").header[0] = LangHelper.GetString("UlrModule","Bridges");
                                                        }

                                                        table.refreshColumns();
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height:48},
                            {
                                type:"wide",
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Nodes"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        type:"wide",
                                        id:this.Id + "AddNodeForm",
                                        view:"form",
                                        borderless:true,
                                        cols:[
                                            {
                                                view:"spectre_text",
                                                id:this.Id + "NodeNameInput",
                                                name:"name",
                                                label:LangHelper.GetString("UlrModule","Node name"),
                                                validate: webix.rules.isNotEmpty,
                                                on: {
                                                    "onChange": function (Nv, Ov)
                                                    {
                                                        if(typeof Ov !== "undefined")
                                                        {
                                                            if(Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                view:"spectre_richselect",
                                                id:this.Id + "DPIInput",
                                                name:"hardware_id",
                                                label:LangHelper.GetString("UlrModule","DPI hardware name"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                },
                                                validate: webix.rules.isNotEmpty
                                            },
                                            {
                                                view:"spectre_richselect",
                                                id:this.Id + "Bridges",
                                                name:"bridges_num",
                                                label:LangHelper.GetString("UlrModule","Bridges"),
                                                value:4,
                                                autowidth:true,
                                                options:{
                                                    point:false,
                                                    data:this.BridgesNumOptions()
                                                }
                                            },
                                            {
                                                view:"spectre_text",
                                                id:this.Id + "BridgesVchannel",
                                                name:"bridges_vchannel",
                                                css: "form_element invalid_msg_text",
                                                label:LangHelper.GetString("UlrModule","Channels"),
                                                value:"1024",
                                                hidden: true,
                                                validate: function(Val)
                                                {
                                                    if(Val == "" || Val < 1 || Val > 1024)
                                                    {
                                                        return false;
                                                    }

                                                    return !isNaN(Val);
                                                },
                                                invalidMessage: LangHelper.GetString("UlrModule", "Input number from 1 to 1024"),
                                            },
                                            {
                                                type: "wide",
                                                cols:[
                                                    {
                                                        view:"spectre_text",
                                                        id:this.Id + "IpFix",
                                                        name:"ipfix_number",
                                                        label:LangHelper.GetString("UlrModule","Ipfix number"),
                                                        validate: function(Val)
                                                        {
                                                            if(Val == "")
                                                            {
                                                                return false;
                                                            }
                                                            return !isNaN(Val);
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                rows:[
                                                    {},
                                                    {
                                                        view:"spectre_button",
                                                        id:this.Id + "AddNodeBtn",
                                                        css:"form_button form_element spec_action",
                                                        label:LangHelper.GetString("UlrModule","Add"),
                                                        autowidth:true,
                                                        height:51,
                                                        disabled:true,
                                                        click:function ()
                                                        {
                                                            setTimeout(function ()
                                                            {
                                                                _this.AddNode();
                                                            },1);
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                gravity:2
                                            }
                                        ]
                                    },
                                    this.Views.ReportsWidgets.NodesReport.ViewConfig
                                ]
                            },
                            {height:32},
                            {
                                type:"wide",
                                cols:[
                                    {
                                        view:"spectre_button",
                                        id: this.Id + "SaveBtn",
                                        css:"form_button main_action",
                                        label:LangHelper.GetString("UlrModule","Save changes"),
                                        autowidth:true,
                                        click:function ()
                                        {
                                            _this.Save();
                                        }
                                    },
                                    {}
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals =
    {
        NodeNameInputValue: new Rx.BehaviorSubject(0),
        DPIInputValue: new Rx.BehaviorSubject(0)
    };
}

UlrEditIgwViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.EditPopup = webix.ui(this.EditPopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress)
    {
        var view = _this.Views.SaveBtn;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions[DicsEnum.UlrIgwsModesDic] = App.DicsManager.Signal[DicsEnum.UlrIgwsModesDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.IgwEditForm.elements.mode_id.getList().clearAll();
            _this.Views.IgwEditForm.elements.mode_id.getList().parse(Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrIgwsModesDic)));

        }
    });

    this.Subscriptions[DicsEnum.UlrVchannelTypesDic] = App.DicsManager.Signal[DicsEnum.UlrVchannelTypesDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.IgwEditForm.elements.vchannel_type.getList().clearAll();
            _this.Views.IgwEditForm.elements.vchannel_type.getList().parse(Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrVchannelTypesDic)));

        }
    });

    this.Subscriptions[DicsEnum.UlrHardwaresDic] = App.DicsManager.Signal[DicsEnum.UlrHardwaresDic].subscribe(function (Dic)
    {
        if(Dic)
        {
            _this.Views.AddNodeForm.elements.hardware_id.getList().clearAll();
            _this.Views.EditPopupNodeForm.elements.hardware_id.getList().clearAll();

            var arr = Helper.DictToArr(App.DicsManager.GetDicAsArray(DicsEnum.UlrHardwaresDic));

            //arr.unshift({id:"", value:"", $empty:true});

            _this.Views.AddNodeForm.elements.hardware_id.getList().parse(arr);
            _this.Views.EditPopupNodeForm.elements.hardware_id.getList().parse(arr);

        }
    });

    this.Subscriptions.NodesInitialDataDicUpdated = this.ViewModel.Signals.NodesInitialDataDicUpdated.subscribe(function (Updated)
    {
        if(Updated)
            _this.Views.ReportsWidgets.NodesReport.RefreshData();
    });

    this.Subscriptions.IgwProfileUpdated = this.ViewModel.Signals.IgwProfileUpdated.subscribe(function (IgwModel) {
        if(IgwModel)
        {
            _this.DefineAll(IgwModel);
        }
    });

    this.Subscriptions.IgwProfileError = this.ViewModel.Signals.IgwProfileError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowLoadSaveProfileError(ErrModel);
    });

    this.Subscriptions.IgwProfileSaveError = this.ViewModel.Signals.IgwProfileSaveError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowLoadSaveProfileError(ErrModel);
    });

    this.Subscriptions.IgwProfileSaved = this.ViewModel.Signals.IgwProfileSaved.subscribe(function (IgwModel)
    {
        if(IgwModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","ISP profile")+" # "+IgwModel.name+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: ControllersEnum.UlrIgwsList});
            },1);
        }
    });

    this.Views.NodeNameInput.attachEvent("onChange", function(Nv, Ov)
    {
        _this.Views.AddNodeForm.markInvalid("name",false);
        _this.Signals.NodeNameInputValue.next(Nv.trim());
    });

    this.Views.NodeNameInput.attachEvent("onTimedKeyPress", function()
    {
        var v = _this.Views.NodeNameInput.getValue();
        _this.Signals.NodeNameInputValue.next(v.trim());
    });

    this.Views.DPIInput.attachEvent("onChange", function(Nv, Ov)
    {
        _this.Views.AddNodeForm.markInvalid("hardware_id",false);
        _this.Signals.DPIInputValue.next(Nv);
    });

    this.Subscriptions.NodeFormHasValue = Rx.Observable.combineLatest
    (
        this.Signals.NodeNameInputValue,
        this.Signals.DPIInputValue
    ).subscribe(function (Signal)
    {
        Signal[0] && Signal[1] ? _this.Views.AddNodeBtn.enable() : _this.Views.AddNodeBtn.disable();
    });
};

UlrEditIgwViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    this.Refresh();
};

UlrEditIgwViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrEditIgwViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrEditIgwViewController.prototype.Refresh = function ()
{
    this.RefreshIgwProfile();
};

UlrEditIgwViewController.prototype.SetPathParam = function(Key, Val)
{
    App.NavRouter.SetPathParam(Key, Val, this);
};

UlrEditIgwViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditIgwViewController.prototype.DefinePageTitle = function(Title)
{
    this.Views.PageTitle.define("data", {root_title:Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

UlrEditIgwViewController.prototype.RefreshIgwProfile = function ()
{
    var id = this.Action == this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    this.ViewModel.ResfreshIgwProfile({_id: id});

    this.DefinePageTitle((this.Action == this.ActionsEnum.Add ? LangHelper.GetString("UlrModule","Add site") : LangHelper.GetString("UlrModule","Edit IGW profile")) + " #" + id);
};

UlrEditIgwViewController.prototype.ShowLoadSaveProfileError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrEditIgwViewController.prototype.DefineAll = function(IgwModel)
{
    var _this = this;

    this.Views.IgwEditForm.clearValidation();
    this.Views.IgwEditForm.clear();

    this.Views.IgwEditForm.setValues(IgwModel.profile);
};

UlrEditIgwViewController.prototype.Save = function()
{
    if(!this.Views.IgwEditForm.validate())
    {
        this.Views.ScrollView.scrollTo(0, 0);
        return;
    }

    var model = new UlrIgwViewModel();

    var formProfile = this.Views.IgwEditForm.getValues();

    model.profile = new UlrIgwModel(formProfile);

    var data = this.ViewModel.IgwNodesArrDicToArr(this.ViewModel.IgwNodesDics.InitialDataDic);

    var addedData = this.ViewModel.IgwNodesArrDicToArr(this.ViewModel.IgwNodesDics.AddedDataDic);

    model.nodes =
    {
        added: this.ViewModel.IgwNodesArrDicToArr(this.ViewModel.IgwNodesDics.AddedDataDic),
        deleted: this.ViewModel.IgwNodesArrDicToArr(this.ViewModel.IgwNodesDics.RemovedDataDic),
        modified: this.ViewModel.IgwNodesArrDicToArr(this.ViewModel.IgwNodesDics.InitialDataDic).filter(function (Item)
        {
            return Item.is_modified ? 1 : 0;
        })
    };

    this.ViewModel.SaveIgwProfile(model);
};

UlrEditIgwViewController.prototype.NodesReportDataSource = function(FilterModel)
{
    //var table = this.Views.ReportsWidgets.NetworksReport.Views.Table;

    //var tableData = table.serialize();

    var data = this.ViewModel.IgwNodesArrDicToArr(this.ViewModel.IgwNodesDics.InitialDataDic);

    var addedData = this.ViewModel.IgwNodesArrDicToArr(this.ViewModel.IgwNodesDics.AddedDataDic);

    if(FilterModel && FilterModel.Params.filter.full_text_search && FilterModel.Params.filter.full_text_search.value)
    {
        var filter = FilterModel.Params.filter.full_text_search.value;

        data = data.filter(function (Item)
        {
            return (Item.name).indexOf(filter) >= 0;
        });
    }

    return {rows:addedData.concat(data)};
};

UlrEditIgwViewController.prototype.AddNode = function()
{
    this.Views.AddNodeForm.clearValidation();

    var name = this.Views.NodeNameInput.getValue();

    var dpi = this.Views.DPIInput.getValue();

    let
        vchannelNum,
        bridgesNum,
        vchannelType = this.Views.VchannelType.getValue();

    if (vchannelType == 3) {
        vchannelNum = +this.Views.BridgesVchannel.getValue();
    } else {
        bridgesNum = this.Views.Bridges.getValue();
    }

    var ipfix = this.Views.IpFix.getValue();

    if(!dpi || !name || !ipfix){
        this.Views.AddNodeForm.validate();
        return;
    }

    if(this.HasNodesDublicates(name, null))
    {
        this.Views.AddNodeForm.markInvalid("name",LangHelper.GetString("UlrModule", "Dublicate entry"));
        return;
    }

    if(this.HasNodesDublicates(null, dpi))
    {
        this.Views.AddNodeForm.markInvalid("hardware_id",LangHelper.GetString("UlrModule", "Dublicate entry"));
        return;
    }

    if(this.HasNodesDublicates(null, null, null, ipfix))
    {
        this.Views.AddNodeForm.markInvalid("ipfix_number",LangHelper.GetString("UlrModule", "Dublicate entry"));
        return;
    }

    if (!this.Views.BridgesVchannel.validate())
        return;


    var table = this.Views.ReportsWidgets.NodesReport.Views.Table;

    var model = new UlrIgwNodeModel({
        _id:webix.uid(),
        name:name,
        hardware_id:dpi,
        ipfix_number:+ipfix,
        is_added:1,
        bridges_num:bridgesNum ? bridgesNum : vchannelNum,
        enabled:1
    });

    var dataDics = this.ViewModel.IgwNodesDics;

    dataDics.AddedDataDic[model._id] = model;

    table.add(model,0);
    table.hideOverlay();
    table.hideProgress();
};

UlrEditIgwViewController.prototype.UpdateNode = function(UpdateModel, RowId)
{
    var table = this.Views.ReportsWidgets.NodesReport.Views.Table;

    var data = RowId ? table.getItem(RowId) : table.getSelectedItem();

    if(!data)
        return;

    data = webix.extend(data, UpdateModel, true);

    table.updateItem(data.id, data);

    var dataDics = this.ViewModel.IgwNodesDics;


    if(data._id)
    {
        if(data.is_added)
        {
            dataDics.AddedDataDic[data._id] = data;
        }
        else
        {
            dataDics.InitialDataDic[data._id] = data;
        }
    }
};

UlrEditIgwViewController.prototype.HasNodesDublicates = function(Name, Dpi, NotId, Ipfix)
{
    var nodes = this.NodesReportDataSource().rows;

    var finded = 0;

    nodes.every(function (Item)
    {
        if(NotId && Item._id == NotId)
            return true;

        if((Name && Item.name == Name) || (Dpi && Item.hardware_id == Dpi) || (Ipfix && Item.ipfix_number == Ipfix))
        {
            finded = 1;

            return false;
        }

        return true;
    });

    return finded;
};

UlrEditIgwViewController.prototype.NodesReportOnItemClick = function(Id)
{
    if(Id.column === 'edit')
    {
        this.ShowEditForm();
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.NodesReport.Views.Table;

        var data = table.getItem(Id);

        if(!data.removeable)
            return;

        var dataDics = this.ViewModel.IgwNodesDics;

        if(data._id)
        {
            if(data.is_added)
            {
                delete dataDics.AddedDataDic[data._id];
            }
            else
            {
                dataDics.RemovedDataDic[data._id] = dataDics.InitialDataDic[data._id];
                delete dataDics.InitialDataDic[data._id];
            }
        }

        table.remove(Id);
    }
};

UlrEditIgwViewController.prototype.NodesReportOnCheck = function(Row, Column, State)
{
    var model = {
        enabled:State,
        is_modified:1
    };

    this.UpdateNode(model, Row);
};

UlrEditIgwViewController.prototype.ShowEditForm = function()
{
    var table = this.Views.ReportsWidgets.NodesReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    this.Views.EditPopupNodeForm.clear();
    this.Views.EditPopupNodeForm.clearValidation();

    var minIndex = data.bridgeNotRemoveableIndex >= 0 ? data.bridgeNotRemoveableIndex : 0;

    var view = this.Views.EditPopupNodeForm.elements.hardware_id;
    data.removeable ? view.enable() : view.disable();

    const vchannelType = this.Views.VchannelType.getValue();

    if (vchannelType == 3) {
        this.Views.EditPopupBridges.hide();
        this.Views.EditPopupBridgesVchannel.show();
        data.bridges_vchannel = data.bridges_num;
    } else {
        this.Views.EditPopupBridgesVchannel.hide();
        this.Views.EditPopupBridges.show();

        var bridgesNumList = this.Views.EditPopupNodeForm.elements.bridges_num.getList();
        bridgesNumList.clearAll();
        bridgesNumList.parse(this.BridgesNumOptions(minIndex));
    }

    this.Views.EditPopupNodeForm.setValues(data);

    this.EditPopup.show();
};

UlrEditIgwViewController.prototype.SaveEditForm = function()
{
    var table = this.Views.ReportsWidgets.NodesReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    if(!this.Views.EditPopupNodeForm.validate())
    {
        return;
    }

    let
        bridgesNum,
        vchannelType = this.Views.VchannelType.getValue();

    if (vchannelType == 3) {
        bridgesNum = +this.Views.EditPopupBridgesVchannel.getValue()
    } else {
        bridgesNum = this.Views.EditPopupBridges.getValue();
    }

    var model = {
        name:this.Views.EditPopupNodeNameInput.getValue(),
        hardware_id:this.Views.EditPopupDPIInput.getValue(),
        bridges_num:bridgesNum,
        ipfix_number:+this.Views.EditPopupNodeIpFixInput.getValue(),
        is_modified:1
    };

    if(this.HasNodesDublicates(model.name, null, data._id))
    {
        this.Views.EditPopupNodeForm.markInvalid("name",LangHelper.GetString("UlrModule", "Dublicate entry"));
        return;
    }

    if(this.HasNodesDublicates(null, model.hardware_id, data._id))
    {
        this.Views.EditPopupNodeForm.markInvalid("hardware_id",LangHelper.GetString("UlrModule", "Dublicate entry"));
        return;
    }

    if(this.HasNodesDublicates(null, null, data._id, model.ipfix_number))
    {
        this.Views.EditPopupNodeForm.markInvalid("ipfix_number",LangHelper.GetString("UlrModule", "Dublicate entry"));
        return;
    }

    this.UpdateNode(model);

    this.EditPopup.hide();
};


UlrEditIgwViewController.prototype.BridgesNumOptions = function (MinIndex)
{
    var arr = [];

    var minIndex = (MinIndex ? MinIndex : 0) + 1;

    minIndex = minIndex <= UlrMaxNodesBridgesNum ? minIndex : UlrMaxNodesBridgesNum;

    for (var i = minIndex; i <= UlrMaxNodesBridgesNum; i++)
    {
        arr.push({id:i, value:i});
    }

    return arr;
};



function UlrAddIgwViewController(Params)
{
    UlrAddIgwViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddIgwViewController,UlrEditIgwViewController);
const RecordPCAPRangePickerRangesEnum = {
    "5 minute": {value: LangHelper.GetString("Dics", "5 minutes"), id: "5 minute"},
    "10 minute": {value: LangHelper.GetString("Dics", "10 minutes"), id: "10 minute"},
    "15 minute": {value: LangHelper.GetString("Dics", "15 minutes"), id: "15 minute"},
    "30 minute": {value: LangHelper.GetString("Dics", "30 minutes"), id: "30 minute"},
    "1 hour": {value: LangHelper.GetString("Dics", "1 hour"), id: "1 hour"},
    "2 hour": {value: LangHelper.GetString("Dics", "2 hours"), id: "2 hour"},
    // "3 hour": {value: LangHelper.GetString("Dics", "3 hours"), id: "3 hour"},
    "4 hour": {value: LangHelper.GetString("Dics", "4 hours"), id: "4 hour"},
    // "5 hour": {value: LangHelper.GetString("Dics", "5 hours"), id: "5 hour"},
    // "6 hour": {value: LangHelper.GetString("Dics", "6 hours"), id: "6 hour"},
    // "7 hour": {value: LangHelper.GetString("Dics", "7 hours"), id: "7 hour"},
    "8 hour": {value: LangHelper.GetString("Dics", "8 hours"), id: "8 hour"},
    // "9 hour": {value: LangHelper.GetString("Dics", "9 hours"), id: "9 hour"},
    // "10 hour": {value: LangHelper.GetString("Dics", "10 hours"), id: "10 hour"},
    // "11 hour": {value: LangHelper.GetString("Dics", "11 hours"), id: "11 hour"},
    "12 hour": {value: LangHelper.GetString("Dics", "12 hours"), id: "12 hour"},
    // "13 hour": {value: LangHelper.GetString("Dics", "13 hours"), id: "13 hour"},
    // "14 hour": {value: LangHelper.GetString("Dics", "14 hours"), id: "14 hour"},
    // "15 hour": {value: LangHelper.GetString("Dics", "15 hours"), id: "15 hour"},
    // "16 hour": {value: LangHelper.GetString("Dics", "16 hours"), id: "16 hour"},
    // "17 hour": {value: LangHelper.GetString("Dics", "17 hours"), id: "17 hour"},
    // "18 hour": {value: LangHelper.GetString("Dics", "18 hours"), id: "18 hour"},
    // "19 hour": {value: LangHelper.GetString("Dics", "19 hours"), id: "19 hour"},
    // "20 hour": {value: LangHelper.GetString("Dics", "20 hours"), id: "20 hour"},
    // "21 hour": {value: LangHelper.GetString("Dics", "21 hours"), id: "21 hour"},
    // "22 hour": {value: LangHelper.GetString("Dics", "22 hours"), id: "22 hour"},
    // "23 hour": {value: LangHelper.GetString("Dics", "23 hours"), id: "23 hour"},
    "24 hour": {value: LangHelper.GetString("Dics", "24 hours"), id: "24 hour"},

    "2 day": {value: LangHelper.GetString("Dics", "2 days"), id: "2 day"},
    "3 day": {value: LangHelper.GetString("Dics", "3 days"), id: "3 day"},
    "4 day": {value: LangHelper.GetString("Dics", "4 days"), id: "4 day"},
    "5 day": {value: LangHelper.GetString("Dics", "5 days"), id: "5 day"},
    "6 day": {value: LangHelper.GetString("Dics", "6 days"), id: "6 day"},
    "7 day": {value: LangHelper.GetString("Dics", "7 days"), id: "7 day"}
};

function UlrRecordPCAPViewController(Params)
{
    var _this = this;

    this.Id = "UlrRecordPCAP";
    this.RootTitle = LangHelper.GetString("UlrModule","PCAP recording");
    this.Title = LangHelper.GetString("UlrModule","PCAP rules");
    this.EditFormLabel = LangHelper.GetString("UlrModule", "PCAP record rules [TYPE] is [VALUE].");

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ReportWidget: UrlRecordPCAPTableWidget,
        EditFormLabel: this.EditFormLabel,
        CustomFormPCAP: true,
        BlockInfoTemplate: LangHelper.GetString("UlrModule", "To record a subscriber's traffic in PCAP files, add its IP or Login to the rule. Install additional filters."),
        BlockWarningTemplate: AppEnv.HidePCAPRulesMode ? "" : LangHelper.GetString("UlrModule","The subscriber`s rule is set globally if no ISPs are specified!"),
        BlockHeaderTemplateTableTitle: LangHelper.GetString("UlrModule","PCAP rules"),
        NotificationTitle: LangHelper.GetString("UlrModule","PCAP record rule"),
        Methods: {
            SaveRule: "UlrSaveRecordPCAPSubscriberRule",
            DeleteRule: "UlrDeleteRecordPCAPSubscriberRule",
            EnableRule: "UlrEnableRecordPCAPSubscriberRule",
            DisableRule: "UlrDisableRecordPCAPSubscriberRule"
        },
        HideIspsValue: AppEnv.HidePCAPRulesMode ? true : false
    }, true);

    UlrRecordPCAPViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrRecordPCAPViewController, UlrSubscribersRulesViewController);
function UlrPCAPFilesViewController(Params)
{
    var _this = this;

    this.Id = "UlrPCAPFiles";

    this.PageTitle = Params&&Params.PageTitle?Params.PageTitle:{
        RootTitle: LangHelper.GetString("UlrModule", "PCAP recording"),
        Title: LangHelper.GetString("UlrModule", "Files")
    };

    this.ViewModel = new UlrPCAPRecordManager();

    this.ReportsModel = new UniReportsManager();

    this.UseCurrentHardwareId = true;

    this.PathsNamesMap = {
        "unprocessed": "Unprocessed",
        "processing":"Processing",
        "processed": "Processed",
        "merged": "Merged"
    };

    this.Views = {
        FilesTree:null,
        DirTree:null,
        RefreshFilesList:null,
        RefreshDirList:null,

        FileLabel: null,
        FileContent:null,

        DirContentPanel: null,
        FileContentTable: null,
        FileContentPanel: null,

        DeleteFilesBtn: null,
        ClearDirBtn: null,
        DeleteDirBtn: null,
        DownloadsFilesBtn: null,

        AccordionCatalogs: null,
        AccordionFiles: null,
        AccordionFilesContent: null,

        Widgets:{},
        ReportsWidgets:{},

        HardwareList:null
    };

    this.FileDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id, "Are you sure you want to delete the file?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.FileDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function () {
                                _this.FileDeleteContext.hide();

                                _this.DeleteFile();

                            }
                        }
                    ]
                }
            ]
        }
    });

    this.DirDeleteContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("UlrModule", "Are you sure you want to delete the catalog?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.DirDeleteContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function () {
                                _this.DirDeleteContext.hide();

                                _this.ClearDeletePCAPDir("DeletePCAPDir");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.DirClearContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("UlrModule", "Are you sure you want to clear the catalog?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.DirClearContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("UlrModule", "Clear"),
                            click:function () {
                                _this.DirClearContext.hide();

                                _this.ClearDeletePCAPDir("ClearPCAPDir");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.ViewConfig = [
    {

        rows:[
            {
                id: _this.Id + "Accordion",
                view: "accordion",
                multi: "mixed",
                on: {
                    onAfterExpand: function(id) {
                        let accordionValue = App.SessionManager.GetPreference(_this.Id + "Accordion", true);

                        if (accordionValue)
                        {
                            accordionValue[id] = false;

                            App.SessionManager.SetPreference(
                                _this.Id + "Accordion",
                                accordionValue,
                                true
                            );
                        }
                        else
                        {
                            App.SessionManager.SetPreference(
                                _this.Id + "Accordion",
                                {
                                    [_this.Id + "AccordionCatalogs"]: false,
                                    [_this.Id + "AccordionFiles"]: false,
                                    [_this.Id + "AccordionFilesContent"]: false
                                },
                                true
                            );
                        }
                    },
                    onAfterCollapse: function(id)
                    {
                        let accordionValue = App.SessionManager.GetPreference(_this.Id + "Accordion", true);

                        if (accordionValue)
                        {
                            accordionValue[id] = true;
                            App.SessionManager.SetPreference(
                                _this.Id + "Accordion",
                                accordionValue,
                                true);
                        }
                    }
                },
                cols: [
                    {
                        header:LangHelper.GetString("UlrModule","Catalogs"),
                        id: _this.Id + "AccordionCatalogs",
                        gravity:2,
                        collapsed: function () {
                            let accordionValue = App.SessionManager.GetPreference(_this.Id + "Accordion", true);

                            if (accordionValue && accordionValue.hasOwnProperty(_this.Id + "AccordionCatalogs"))
                                return accordionValue[_this.Id + "AccordionCatalogs"];

                            return false;
                        }(),
                        body:{
                            rows: [
                                {
                                    type: "clear",
                                    borderless: true,
                                    rows:function ()
                                    {
                                        var rows = [];

                                        var body = {
                                            id:_this.Id+"DirBody",
                                            cols:function ()
                                            {
                                                var cols = [];

                                                cols.push({
                                                    rows:[
                                                        {
                                                            view: "toolbar",
                                                            elements:[
                                                                {
                                                                    view: "button",
                                                                    id:_this.Id + "ClearDirBtn",
                                                                    type: "icon",
                                                                    icon: "broom",
                                                                    css:"toolbar_round_btn",
                                                                    width:32,
                                                                    tooltip:LangHelper.GetString(_this.Id, "Delete"),
                                                                    disabled:true,
                                                                    click:function (id,e,node)
                                                                    {
                                                                        var __this = this;
                                                                        setTimeout(function () {
                                                                            var node = __this.getNode(id);
                                                                            _this.DirClearContext.show(node, {pos:"bottom"});
                                                                        }, 10);
                                                                    }
                                                                },
                                                                {
                                                                    view: "button",
                                                                    id:_this.Id + "DeleteDirBtn",
                                                                    type: "icon",
                                                                    icon: "trash",
                                                                    css:"toolbar_round_btn",
                                                                    width:32,
                                                                    tooltip:LangHelper.GetString(_this.Id, "Delete"),
                                                                    disabled:true,
                                                                    click:function (id,e,node)
                                                                    {
                                                                        var __this = this;
                                                                        setTimeout(function () {
                                                                            var node = __this.getNode(id);
                                                                            _this.DirDeleteContext.show(node, {pos:"bottom"});
                                                                        }, 10);
                                                                    }
                                                                },
                                                                {
                                                                    view: "button",
                                                                    id:_this.Id + "OpenDirBtn",
                                                                    type: "icon",
                                                                    icon: "plus-square",
                                                                    css:"toolbar_round_btn",
                                                                    width:32,
                                                                    tooltip:LangHelper.GetString("UlrModule", "Expand tree"),
                                                                    click:function (id,e,node)
                                                                    {
                                                                        _this.Views.DirTree.openAll();
                                                                    }
                                                                },
                                                                {
                                                                    view: "button",
                                                                    id:_this.Id + "CloseDirBtn",
                                                                    type: "icon",
                                                                    icon: "minus-square",
                                                                    css:"toolbar_round_btn",
                                                                    width:32,
                                                                    tooltip:LangHelper.GetString("UlrModule", "Collapse tree"),
                                                                    click:function (id,e,node)
                                                                    {
                                                                        _this.Views.DirTree.closeAll();
                                                                    }
                                                                },
                                                                {},
                                                                {
                                                                    view: "button",
                                                                    id:_this.Id + "RefreshDirList",
                                                                    type: "icon",
                                                                    icon: "refresh",
                                                                    css: "toolbar_round_btn",
                                                                    width: 32,
                                                                    tooltip: LangHelper.GetString("HardwareLogs", "Refresh"),
                                                                    click: function (id, e, node)
                                                                    {
                                                                        _this.RefreshDirList();
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            view: "treetable",
                                                            id:_this.Id + "DirTree",
                                                            select: "row",
                                                            resizeColumn:true,
                                                            tooltip: true,
                                                            multiselect: true,
                                                            columns:[
                                                                {
                                                                    id:"checked",
                                                                    header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"cm1" }],
                                                                    template: function (Obj, Common, Value) {
                                                                        if (Obj.hasOwnProperty("error") && Obj.error)
                                                                            return "";

                                                                        return CellColoredCheckBoxTemplate(Obj, Common, Value);
                                                                    },
                                                                    width:40
                                                                },
                                                                {
                                                                    id: "filename",
                                                                    header: [LangHelper.GetString("VasCloud","Catalog"),{content: "textFilter"}],
                                                                    template: function(obj, common, value, config)
                                                                    {
                                                                        let filename = _this.PathsNamesMap[obj.filename] ? _this.PathsNamesMap[obj.filename] : obj.filename;

                                                                        if (filename.includes("Merged"))
                                                                            filename = `${filename} (${obj.count_files})`;

                                                                        return common.treetable(obj, common, value, config) + filename;
                                                                    },
                                                                    fillspace: true,
                                                                    sort: "string",
                                                                },
                                                                {
                                                                    id: "error",
                                                                    header: "",
                                                                    width: 32,
                                                                    template: function (obj) {
                                                                        if (obj.hasOwnProperty("error") && obj.error)
                                                                            return AlertErrorTemplate(null, null, obj.error);

                                                                        return "";
                                                                    },
                                                                    headermenu: false
                                                                },
                                                                {
                                                                    id: "broom",
                                                                    header: "",
                                                                    width: 32,
                                                                    template: function (obj) {
                                                                        return obj && !obj.error ? CellBroomBtnTemplate() : "";
                                                                    },
                                                                    headermenu: false
                                                                },
                                                                {
                                                                    id: "trash",
                                                                    header: "",
                                                                    width: 32,
                                                                    template: function (obj) {
                                                                        return obj.filename.includes("ip_") ? CellTrashBtnTemplate() : "";
                                                                    },
                                                                    headermenu: false
                                                                },
                                                                {header: {content: "headerMenu"}, headermenu: false, width: 16}
                                                            ],
                                                            type: {
                                                                folder: function(obj){
                                                                    return "<span class='webix_tree_folder fa-folder'></span>";
                                                                }
                                                            },
                                                            on:{
                                                                onItemClick: function (id,e,node)
                                                                {
                                                                    var rowData = this.getItem(id);

                                                                    if (rowData && !rowData.error)
                                                                        _this.Views.DirTree.select(rowData.id, true)
                                                                    else
                                                                        _this.Views.DirTree.unselect(rowData.id, true)

                                                                    if(rowData && !rowData.error)
                                                                    {
                                                                        var __this = this;

                                                                        if (id.column === 'broom')
                                                                        {
                                                                            setTimeout(function () {
                                                                                var node = __this.getItemNode(id);
                                                                                _this.DirClearContext.show(node, {pos:"bottom"});
                                                                            }, 10);
                                                                        }

                                                                        if (id.column === 'trash' && rowData.filename.includes("ip_"))
                                                                        {
                                                                            setTimeout(function () {
                                                                                var node = __this.getItemNode(id);
                                                                                _this.DirDeleteContext.show(node, {pos:"bottom"});
                                                                            }, 10);
                                                                        }
                                                                    }

                                                                    _this.RefreshSelectedFileContent();
                                                                },
                                                                onAfterSelect:function (data)
                                                                {
                                                                    const rowData = _this.Views.DirTree.getItem(data.row);

                                                                    if(rowData && !rowData.error)
                                                                    {
                                                                        if(!rowData.checked)
                                                                        {
                                                                            rowData.checked = 1;
                                                                        }
                                                                        _this.Views.DirTree.updateItem(rowData.id, rowData);
                                                                    }

                                                                    _this.OnTableRowSelect("GetDirTableSelectedData", _this.DirTableRowsSelectedCount);
                                                                },
                                                                onAfterUnSelect:function (data)
                                                                {
                                                                    const rowData = _this.Views.DirTree.getItem(data.row);

                                                                    if(rowData)
                                                                    {
                                                                        if(rowData.checked)
                                                                        {
                                                                            rowData.checked = 0;
                                                                        }
                                                                        _this.Views.DirTree.updateItem(rowData.id, rowData);
                                                                    }

                                                                    _this.OnTableRowUnSelect("GetDirTableSelectedData", _this.DirTableRowsSelectedCount);
                                                                },
                                                                onCheck:function(row, column, state)
                                                                {
                                                                    if(column == "checked")
                                                                    {
                                                                        var item = this.getItem(row);

                                                                        if(state && !item.error)
                                                                        {
                                                                            this.select(row, true);
                                                                        }
                                                                        else
                                                                        {
                                                                            this.unselect(row, true);
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    ]
                                                });

                                                return cols;
                                            }()
                                        };

                                        rows = [
                                            {
                                                rows: [
                                                    body
                                                ]
                                            }
                                        ];

                                        return rows;
                                    }()
                                }
                            ]
                        }
                    },
                    {view:"resizer"},
                    {
                        header:LangHelper.GetString("HardwareLogs","Files"),
                        id: _this.Id + "AccordionFiles",
                        gravity:3,
                        collapsed: function () {
                            let accordionValue = App.SessionManager.GetPreference(_this.Id + "Accordion", true);

                            if (accordionValue && accordionValue.hasOwnProperty(_this.Id + "AccordionFiles"))
                                return accordionValue[_this.Id + "AccordionFiles"];

                            return false;
                        }(),
                        body:{
                            rows: [
                                {
                                    type: "clear",
                                    borderless: true,
                                    rows:function ()
                                    {
                                        var rows = [];

                                        var body = {
                                            id:_this.Id+"Body",
                                            cols:function ()
                                            {
                                                var cols = [];

                                                cols.push({
                                                    id:_this.Id + "DirContentPanel",
                                                    rows:[
                                                        {
                                                            view: "toolbar",
                                                            elements:[
                                                                {
                                                                    view: "button",
                                                                    id:_this.Id + "DeleteFilesBtn",
                                                                    type: "icon",
                                                                    icon: "trash",
                                                                    css:"toolbar_round_btn",
                                                                    width:32,
                                                                    tooltip:LangHelper.GetString(_this.Id, "Delete"),
                                                                    disabled:true,
                                                                    click:function (id,e,node)
                                                                    {
                                                                        var __this = this;
                                                                        setTimeout(function () {
                                                                            var node = __this.getNode(id);
                                                                            _this.FileDeleteContext.show(node, {pos:"bottom"});
                                                                        }, 10);
                                                                    }
                                                                },
                                                                {
                                                                    view: "button",
                                                                    id:_this.Id + "DownloadsFilesBtn",
                                                                    type: "icon",
                                                                    icon: "download",
                                                                    css: "toolbar_round_btn",
                                                                    width: 32,
                                                                    tooltip: LangHelper.GetString("UlrModule","Download the complete files"),
                                                                    click: function (id, e, node)
                                                                    {
                                                                        _this.DownloadPCAPFile();
                                                                    }
                                                                },
                                                                {},
                                                                {
                                                                    view: "button",
                                                                    id:_this.Id + "RefreshFilesList",
                                                                    type: "icon",
                                                                    icon: "refresh",
                                                                    css: "toolbar_round_btn",
                                                                    width: 32,
                                                                    tooltip: LangHelper.GetString("HardwareLogs", "Refresh"),
                                                                    click: function (id, e, node)
                                                                    {
                                                                        _this.RefreshFilesList();
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            view: "datatable",
                                                            id:_this.Id + "FilesTree",
                                                            select: "row",
                                                            resizeColumn:true,
                                                            tooltip: true,
                                                            columns:[
                                                                {
                                                                    id:"checked",
                                                                    header:[{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"cm1" }],
                                                                    template: CellColoredCheckBoxTemplate,
                                                                    width:40
                                                                },
                                                                {
                                                                    id: "download",
                                                                    header: "",
                                                                    width: 32,
                                                                    template: CellDownloadBtnTemplate,
                                                                    headermenu: false
                                                                },
                                                                {
                                                                    id: "filename",
                                                                    header: [LangHelper.GetString("HardwareLogs","File"),{content: "textFilter"}],
                                                                    template: function(obj)
                                                                    {
                                                                        return obj.filename ? obj.filename : _this.PathsNamesMap[obj.path];
                                                                    },
                                                                    fillspace: true,
                                                                    sort: "string",
                                                                },
                                                                {
                                                                    id: "size",
                                                                    header: [LangHelper.GetString("UlrModule","Size"), {content: "textFilter"}],
                                                                    width: 80,
                                                                    sort: "int",
                                                                    template:function(obj)
                                                                    {
                                                                        return Helper.BytesToSize(obj.size);
                                                                    }
                                                                },
                                                                // {
                                                                //     id: "atime",
                                                                //     header: [TooltipTemplate(LangHelper.GetString("UlrModule", "Created")), {content: "dateRangeFilter"}],
                                                                //     template:function(obj, common)
                                                                //     {
                                                                //         if(obj.atime)
                                                                //         {
                                                                //             var format =  webix.Date.dateToStr("%d.%m.%Y %H:%i");
                                                                //             return format(obj.atime);
                                                                //         }
                                                                //
                                                                //         return "";
                                                                //     },
                                                                //     width: 100,
                                                                //     sort: "date"
                                                                // },
                                                                {
                                                                    id: "mtime",
                                                                    header: [TooltipTemplate(LangHelper.GetString("UlrModule", "Updated")), {content: "dateRangeFilter"}],
                                                                    template:function(obj, common)
                                                                    {
                                                                        if(obj.mtime)
                                                                        {
                                                                            var format =  webix.Date.dateToStr("%d.%m.%Y %H:%i");
                                                                            return format(obj.mtime);
                                                                        }

                                                                        return "";
                                                                    },
                                                                    width: 100,
                                                                    sort: "date"
                                                                },
                                                                {
                                                                    id: "trash",
                                                                    header: "",
                                                                    width: 32,
                                                                    template: CellTrashBtnTemplate,
                                                                    headermenu: false
                                                                },
                                                                {header: {content: "headerMenu"}, headermenu: false, width: 16}
                                                            ],
                                                            on:{
                                                                onItemClick: function (id,e,node)
                                                                {
                                                                    var rowData = this.getItem(id);

                                                                    this.select(id, true);

                                                                    if (id.column === 'download')
                                                                    {
                                                                        _this.DownloadPCAPFile(rowData);
                                                                    }
                                                                    else if(id.column === 'trash')
                                                                    {
                                                                        var __this = this;
                                                                        setTimeout(function () {
                                                                            var node = __this.getItemNode(id);
                                                                            _this.FileDeleteContext.show(node, {pos:"bottom"});
                                                                        }, 10);
                                                                    }
                                                                    else
                                                                    {
                                                                        _this.RefreshSelectedFileContent();
                                                                    }
                                                                },
                                                                onAfterSelect:function (data)
                                                                {
                                                                    const rowData = _this.Views.FilesTree.getItem(data.row);

                                                                    if(rowData)
                                                                    {
                                                                        if(!rowData.checked)
                                                                        {
                                                                            rowData.checked = 1;
                                                                        }
                                                                        _this.Views.FilesTree.updateItem(rowData.id, rowData);
                                                                    }

                                                                    _this.OnTableRowSelect("GetFilesTableSelectedData", _this.FilesTableRowsSelectedCount);
                                                                },
                                                                onAfterUnSelect:function (data)
                                                                {
                                                                    const rowData = _this.Views.FilesTree.getItem(data.row);

                                                                    if(rowData)
                                                                    {
                                                                        if(rowData.checked)
                                                                        {
                                                                            rowData.checked = 0;
                                                                        }
                                                                        _this.Views.FilesTree.updateItem(rowData.id, rowData);
                                                                    }

                                                                    _this.OnTableRowUnSelect("GetFilesTableSelectedData", _this.FilesTableRowsSelectedCount);
                                                                },
                                                                onCheck:function(row, column, state)
                                                                {
                                                                    if(column == "checked")
                                                                    {
                                                                        if(state)
                                                                        {
                                                                            this.select(row, true);
                                                                        }
                                                                        else
                                                                        {
                                                                            this.unselect(row, true);
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    ]
                                                });

                                                return cols;
                                            }()
                                        };

                                        rows = [
                                            {
                                                rows: [
                                                    body
                                                ]
                                            }
                                        ];

                                        return rows;
                                    }()
                                }
                            ]
                        }
                    },
                    {view:"resizer"},
                    {
                        header:LangHelper.GetString("UlrModule","Content") +" ("+LangHelper.GetString("UlrModule","firts packets")+")",
                        id: _this.Id + "AccordionFilesContent",
                        gravity:1,
                        collapsed: function () {
                            let accordionValue = App.SessionManager.GetPreference(_this.Id + "Accordion", true);

                            if (accordionValue && accordionValue.hasOwnProperty(_this.Id + "AccordionFilesContent"))
                                return accordionValue[_this.Id + "AccordionFilesContent"];

                            return false;
                        }(),
                        body:{
                            rows: [
                                {
                                    type: "clear",
                                    borderless: true,
                                    rows:function ()
                                    {
                                        var rows = [];

                                        var body = {
                                            id:_this.Id+"Body",
                                            cols:function ()
                                            {
                                                var cols = [];

                                                cols.push(
                                                    {
                                                        id:_this.Id + "FileContentPanel",
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                height: 40,
                                                                elements: [
                                                                    {
                                                                        view: "button",
                                                                        type: "icon",
                                                                        icon: "download",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("HardwareLogs","Download the complete file"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.DownloadPCAPFile();
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"label",
                                                                        id:_this.Id + "FileLabel",
                                                                        label:""
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id:_this.Id+"PcapFileContentRefreshBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshSelectedFileContent();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                view:"datatable",
                                                                id:_this.Id + "FileContentTable",
                                                                select: "row",
                                                                resizeColumn:true,
                                                                tooltip: true,
                                                                columns: [
                                                                    {
                                                                        id: "time",
                                                                        header: [LangHelper.GetString("UlrModule","Time"), {content: "textFilter"}],
                                                                        fillspace: 1,
                                                                        sort: "string"
                                                                    },
                                                                    {
                                                                        id: "source",
                                                                        header: [LangHelper.GetString("UlrModule","Source"), {content: "textFilter"}],
                                                                        fillspace: 1,
                                                                        sort: "string"
                                                                    },
                                                                    {
                                                                        id: "destination",
                                                                        header: [LangHelper.GetString("UlrModule","Destination"), {content: "textFilter"}],
                                                                        fillspace: 1,
                                                                        sort: "string"
                                                                    },
                                                                    {
                                                                        id: "info",
                                                                        header: [LangHelper.GetString("UlrModule","Info"), {content: "textFilter"}],
                                                                        fillspace: 3,
                                                                        sort: "string"
                                                                    }
                                                                ],
                                                                on:{
                                                                    onAfterLoad:function()
                                                                    {
                                                                        this.sort("time", "desc", "string");
                                                                        this.markSorting("time", "desc");
                                                                    }
                                                                },
                                                                data:[]
                                                            }
                                                        ]
                                                    }
                                                )

                                                return cols;
                                            }()
                                        };

                                        rows = [
                                            {
                                                rows: [
                                                    body
                                                ]
                                            }
                                        ];

                                        return rows;
                                    }()
                                }
                            ]
                        }
                    }
                ]
            },
        ]
    }];

    this.Subscriptions = {};

    this.Signals =
    {
        FileSelected: new Rx.BehaviorSubject(null)
    };

    this.FilesTableRowsSelectedCount = new Rx.BehaviorSubject(0);
    this.DirTableRowsSelectedCount = new Rx.BehaviorSubject(0);
}

UlrPCAPFilesViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.FileSelected = this.Signals.FileSelected.subscribe(function (FileSelected)
    {
        if(FileSelected)
        {
            _this.Views.FileLabel.define("label", FileSelected.filename);
            _this.Views.FileLabel.refresh();
        }
        else
        {
            _this.Views.FileLabel.define("label", "");
            _this.Views.FileLabel.refresh();
        }
    });

    this.Subscriptions.FilesListLoaded = this.ViewModel.Signals.FilesListLoaded.subscribe(function (FilesListModel)
    {
        if(FilesListModel)
        {
            _this.UpdateFilesList(FilesListModel);
        }
    });

    this.Subscriptions.FilesListLoadError = this.ViewModel.Signals.FilesListLoadError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.DirListLoaded = this.ViewModel.Signals.DirListLoaded.subscribe(function (DirListModel)
    {
        if(DirListModel)
        {
            _this.UpdateDirList(DirListModel);
        }
    });

    this.Subscriptions.DirListLoadError = this.ViewModel.Signals.DirListLoadError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.SignalStatLogTailUpdatedSubscription = this.ViewModel.SignalStatLogTailUpdated.subscribe(function (Updated)
    {
        if (Updated)
        {
            _this.UpdatePCAPFileTableContent();
        }
    });

    this.Subscriptions.FilesTableRowsSelectedCountSubscription = this.FilesTableRowsSelectedCount.subscribe(function (Value)
    {
        Value > 1 ? _this.Views.DeleteFilesBtn.enable() : _this.Views.DeleteFilesBtn.disable();
        Value > 1 ? _this.Views.DownloadsFilesBtn.enable() : _this.Views.DownloadsFilesBtn.disable();

        _this.TableRowsSelectedCountSubscriptionHandler(Value, _this.Views.FileContentPanel, "RefreshSelectedFileContent");
    });

    this.Subscriptions.DirTableRowsSelectedCountSubscription = this.DirTableRowsSelectedCount.subscribe(function (Value)
    {
        let dirSelectedItems = _this.GetDirTableSelectedData();

        if (dirSelectedItems)
        {
            dirSelectedItems = Array.isArray(dirSelectedItems) ? dirSelectedItems : [dirSelectedItems];

            let
                clearDirCount = 0,
                deleteDirCount = 0;

            dirSelectedItems.forEach(item => {
                if (item.filename.includes("ip_"))
                {
                    clearDirCount++;
                    deleteDirCount++;
                } else {
                    clearDirCount++;
                }
            })

            const
                deleteDirBtn = _this.Views.DeleteDirBtn,
                clearDirBtn = _this.Views.ClearDirBtn;

            deleteDirCount > 1 ? deleteDirBtn.enable() : deleteDirBtn.disable();
            clearDirCount > 1 ? clearDirBtn.enable() : clearDirBtn.disable();
        }



        _this.TableRowsSelectedCountSubscriptionHandler(Value, _this.Views.DirContentPanel, "RefreshFilesList");
    });

    _this.RefreshDirList();
};

UlrPCAPFilesViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.PathParams = Params;

    webix.ready(function () {
        if($$(_this.Id+"LeftSideBar"))
            $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);
};

UlrPCAPFilesViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

};

UlrPCAPFilesViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};

UlrPCAPFilesViewController.prototype.RefreshFilesList = function ()
{
    let dirSelectedData = this.GetDirTableSelectedData();

    if (!dirSelectedData.path)
        return;

    if (this.DeleteIds && Object.keys(this.DeleteIds).length)
        return;

    const params = {
        hardware_id: dirSelectedData.hardware_id,
        dir: dirSelectedData.path
    }

    this.ViewModel.RefreshFilesList(params);
};

UlrPCAPFilesViewController.prototype.RefreshDirList = function ()
{
    this.ViewModel.RefreshDirList();


};

UlrPCAPFilesViewController.prototype.UpdateFilesList = function (FilesListModel)
{
    const
        table = this.Views.FilesTree,
        state = table.getState(),
        sort = state.sort ? state.sort : null;

    table.clearAll();
    table.parse(FilesListModel);

    if(sort)
    {
        table.markSorting(sort.id, sort.dir);

        let type_sort = "string";

        if (sort.id == "atime")
            type_sort = "date";

        if (sort.id == "size")
            type_sort = "int";

        table.sort(sort.id, sort.dir, type_sort);
    }
};

UlrPCAPFilesViewController.prototype.UpdateDirList = function (DirListModel, dirSerialize = null)
{
    const
        table = this.Views.DirTree,
        state = table.getState(),
        sort = state.sort ? state.sort : null;

    if (!dirSerialize) {
        dirSerialize = this.Views.DirTree.serialize();
    }

    const updateOpenedRecursively = (model, serialize) => {
        model.forEach(item => {
            if (serialize) {
                const matchingItem = serialize.find(serItem => serItem.filename === item.filename);

                if (matchingItem && matchingItem.open) {
                    item.open = true;
                }

                if (item.data && item.data.length > 0) {
                    updateOpenedRecursively(item.data, matchingItem ? matchingItem.data : []);
                }
            }
        });
    }


    updateOpenedRecursively(DirListModel, dirSerialize);

    table.clearAll();
    table.parse(DirListModel);

    if(sort)
    {
        table.markSorting(sort.id, sort.dir);
        table.sort(sort.id, sort.dir, "string");
    }
};

UlrPCAPFilesViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrPCAPFilesViewController.prototype.GetFilesTableSelectedData = function ()
{
    return this.Views.FilesTree.getSelectedItem();
};

UlrPCAPFilesViewController.prototype.GetDirTableSelectedData = function ()
{
    return this.Views.DirTree.getSelectedItem();
};

UlrPCAPFilesViewController.prototype.DownloadPCAPFile = function ()
{
    let
        dirSelectedData = this.GetDirTableSelectedData(),
        fileSelectedData = this.GetFilesTableSelectedData();

    fileSelectedData = Array.isArray(fileSelectedData) ? fileSelectedData : [fileSelectedData];

    if(!dirSelectedData || !fileSelectedData.length)
        return;

    if (!dirSelectedData.path)
        return;

    const params = {
        hardware_id: dirSelectedData.hardware_id,
        filenames: []
    }

    fileSelectedData.forEach(file => {
        params.filenames.push({
            path: dirSelectedData.path,
            filename: file.filename
        });
    })

    this.ViewModel.DownloadPCAPFile(params);
};

UlrPCAPFilesViewController.prototype.DeleteFile = function ()
{
    let _this = this,
        dirSelectedData = this.GetDirTableSelectedData(),
        fileSelectedData = this.GetFilesTableSelectedData();

    fileSelectedData = Array.isArray(fileSelectedData) ? fileSelectedData : [fileSelectedData];

    if(!dirSelectedData || !fileSelectedData.length)
        return;

    if (!dirSelectedData.path)
        return;

    const params = {
        hardware_id: dirSelectedData.hardware_id,
        filenames: []
    };

    fileSelectedData.forEach(item => params.filenames.push(`${dirSelectedData.path}${item.filename}`))

    this.ViewModel.DeletePCAPFile(webix.extend(params,{callback:function (R)
        {
            if(R.success)
            {
                fileSelectedData.forEach(item => _this.Views.FilesTree.remove(item.id));

                webix.message(LangHelper.GetString("All","Deleted"));
            }
            else
            {
                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }
        }}));
};

UlrPCAPFilesViewController.prototype.RefreshSelectedFileContent = function ()
{
    const
        dirSelectedData = this.GetDirTableSelectedData(),
        fileSelectedData = this.GetFilesTableSelectedData();

    if(!dirSelectedData || !fileSelectedData)
        return;

    if (!dirSelectedData.path)
        return;

    const params = {
        hardware_id: dirSelectedData.hardware_id,
        filename: `${dirSelectedData.path}${fileSelectedData.filename}`
    }

    this.ViewModel.RefreshPCAPFileTail(params);
};

UlrPCAPFilesViewController.prototype.UpdatePCAPFileTableContent = function ()
{
    const data = this.ViewModel.GetPCAPFileTableTail();

    this.Views.FileContentTable.clearAll();
    this.Views.FileContentTable.parse(data);
};

UlrPCAPFilesViewController.prototype.TableRowsSelectedCountSubscriptionHandler = function (Value, Panel, RefreshFn)
{
    const _this = this;

    const _disableAll = function ()
    {
        Panel.disable();

        if (RefreshFn === "RefreshSelectedFileContent")
        {
            _this.Signals.FileSelected.next(null);
            _this.Views.FileContentTable.clearAll();
        }
    };

    if(Value != 1)
    {
        _disableAll();
        return;
    }
    else
    {
        if (RefreshFn === "RefreshSelectedFileContent")
        {
            const selectedItem = _this.GetFilesTableSelectedData();
            _this.Signals.FileSelected.next(selectedItem);
        }
    }

    this[RefreshFn]();

    Panel.enable();
};

UlrPCAPFilesViewController.prototype.OnTableRowSelect = function (SelectedDataFn, SelectedCount)
{
    const data = this[SelectedDataFn]();

    SelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

UlrPCAPFilesViewController.prototype.OnTableRowUnSelect = function (SelectedDataFn, SelectedCount)
{
    const data = this[SelectedDataFn]();

    SelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

UlrPCAPFilesViewController.prototype.ClearDeletePCAPDir = function (Action)
{
    let
        _this = this,
        dirSelectedItems = _this.GetDirTableSelectedData();

    if (dirSelectedItems)
    {
        dirSelectedItems = Array.isArray(dirSelectedItems) ? dirSelectedItems : [dirSelectedItems];

        const items = {};
        
        if (Action === "DeletePCAPDir")
            _this.DeleteIds = {};

        dirSelectedItems.forEach(item => {
            if (!items.hasOwnProperty(item.hardware_id))
                items[item.hardware_id] = {
                    hardware_id: item.hardware_id,
                    dirnames: [],
                    ids: []
                };

            items[item.hardware_id].dirnames.push(item.path);
            items[item.hardware_id].ids.push(item.id);

            if (Action === "DeletePCAPDir")
                _this.DeleteIds[item.id] = 1;

        })

        for (const item in items) {
            _this.ViewModel[Action](webix.extend(items[item],{callback:function (R)
                {
                    if(R.success)
                    {
                        if (Action === "DeletePCAPDir")
                        {
                            items[item].ids.forEach(id => {
                                if (_this.DeleteIds.hasOwnProperty(id))
                                    delete _this.DeleteIds[id];

                                _this.Views.DirTree.remove(id);
                            })
                        }

                        if (Object.keys(items).length == 1){
                            if (Action === "ClearPCAPDir")
                                _this.RefreshFilesList();
                            else
                                _this.Views.FilesTree.clearAll();
                        }

                        webix.message(LangHelper.GetString("All",Action === "DeletePCAPDir" ? "Deleted" : "Cleared"));
                    }
                    else
                    {
                        if(R.error)
                            webix.message({text:R.error.msg,type:"error"});
                    }
                }}));
        }
    }

}

function UlrPCAPLogsViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"UlrPCAPLogs",
        PageTitle: {
            RootTitle:LangHelper.GetString("UlrModule","PCAP recording"),
            Title:LangHelper.GetString("UlrModule","Logs")
        },
        ServerMethods: {
            RefreshLogsFilesList:"GetPCAPLogsFilesList",

            GetLogFileTail:"GetPCAPLogFileTail",

            DownloadLogFile:"DownloadPCAPLogFile"
        },
        PathsNamesMap: {
            "/var/fastpcap/backend/logs":"Logs"
        },
        UseCurrentHardwareId: true,
        LeftSideBar: DpiConfigLeftSideBarView({id: this.Id})
    },true);

    UlrPCAPLogsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrPCAPLogsViewController, HardwareLogsViewController);
function UlrSearchDatabaseViewController(Params)
{
    var params = webix.extend(Params,
    {
        id:"UlrSearchDatabase",
        page_title:{
            RootTitle:LangHelper.GetString("UlrModule","Search database")
        }
    },true);

    UlrSearchDatabaseViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrSearchDatabaseViewController,UlrWebSearchDatabaseViewController);
function UlrSytemGlobalStateViewController(Params)
{
    var _this = this;

    this.Id = "UlrSytemGlobalState";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","System global state"),
        Title:LangHelper.GetString("UlrModule","Tasks list")
    };

    this.ViewModel = new UlrIgwsNodesManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        TaskDataPopupForm:null,
        TaskDataPopupEditor:null,

        DeleteSelectedTasksBtn:null,
        DeleteAllTasksBtn:null,

        TaskInfoPopupHeadLabel:null,
        TaskInfoPopupFormTitle:null,
        TaskInfoPopupFormDescription:null,

        Widgets:{},
        ReportsWidgets:{
            TasksReport:new UrlExportTasksTableWidget({
                id:this.Id + "TasksReport",
                enableTextSearch:true,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.TasksReportOnItemClick(Id, E, Node);
                }
            })
        }
    };

    this.TaskDataPopup = null;
    this.TaskDataPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "TaskDataPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Task data"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.TaskDataPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "TaskDataPopupForm",
                            type: "wide",
                            minWidth:560,
                            minHeight:400,
                            elements: [
                                {
                                    view:"spectre_textarea",
                                    //view:"codemirror-editor",
                                    id:this.Id + "TaskDataPopupEditor",
                                    label:LangHelper.GetString("UlrModule","Data"),
                                    height:undefined,
                                    value:""
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.TaskInfoPopup = null;
    this.TaskInfoPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "TaskInfoPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Task info"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.TaskInfoPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows: [
                        {
                            view: "form",
                            id: this.Id + "TaskInfoPopupForm",
                            type: "wide",
                            minWidth:560,
                            minHeight:400,
                            elements: [
                                {
                                    view:"template",
                                    id: this.Id + "TaskInfoPopupFormTitle",
                                    borderless:true,
                                    css:"form_text_big_label",
                                    autoheight:true,
                                    data:{title:""},
                                    template:function (Obj)
                                    {
                                        return "<strong>" + Obj.title + "</strong>";

                                    }
                                },
                                {
                                    view:"template",
                                    id: this.Id + "TaskInfoPopupFormDescription",
                                    borderless:true,
                                    css:"form_text_big_label",
                                    autoheight:true,
                                    data:{description:""},
                                    template:function (Obj)
                                    {
                                        return Obj.description;

                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title: this.PageTitle.Title}),
                            {height:32},
                            {
                                type: "wide",
                                rows:[
                                    {
                                        type: "wide",
                                        cols:[
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","Export tasks list"), icon:"",
                                                borderless:true
                                            }),
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "DeleteSelectedTasksBtn",
                                                //type:"icon",
                                                css:"form_button third_action",
                                                label:LangHelper.GetString("UlrModule","Delete"),
                                                //icon:"trash",
                                                //height:44,
                                                autowidth:true,
                                                disabled:true,
                                                click:function ()
                                                {
                                                    UlrShowDialogPopup({
                                                        node: this.getNode(),
                                                        position: "bottom",
                                                        head: LangHelper.GetString("UlrModule", "Delete") + "?",
                                                        //type:"spectre-alert-notification",
                                                        mainTitle: LangHelper.GetString("UlrModule", "Delete") + "?",
                                                        message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                                        actions: [
                                                            {
                                                                css: "spec_action",
                                                                label: LangHelper.GetString("UlrModule", "Cancel")
                                                            },
                                                            {
                                                                label: LangHelper.GetString("UlrModule", "Delete"),
                                                                click: function ()
                                                                {
                                                                    setTimeout(function ()
                                                                    {
                                                                        var table = _this.Views.ReportsWidgets.TasksReport.Views.Table;

                                                                        var data = table.getSelectedItem();

                                                                        data = Array.isArray(data) ? data : [data];

                                                                        var _ids = data.map(function (Item)
                                                                        {
                                                                            return Item._id;
                                                                        });

                                                                        _this.ViewModel.DeleteActionsTasks({_ids:_ids});
                                                                    },1);
                                                                }
                                                            }
                                                        ]
                                                    });
                                                }
                                            },
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "DeleteAllTasksBtn",
                                                //type:"icon",
                                                css:"form_button third_action",
                                                label:LangHelper.GetString("UlrModule","Delete all"),
                                                //icon:"trash",
                                                //height:44,
                                                autowidth:true,
                                                click:function ()
                                                {
                                                    UlrShowDialogPopup({
                                                        node: this.getNode(),
                                                        position: "bottom",
                                                        head: LangHelper.GetString("UlrModule", "Delete") + "?",
                                                        //type:"spectre-alert-notification",
                                                        mainTitle: LangHelper.GetString("UlrModule", "Delete") + "?",
                                                        message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                                        actions: [
                                                            {
                                                                css: "spec_action",
                                                                label: LangHelper.GetString("UlrModule", "Cancel")
                                                            },
                                                            {
                                                                label: LangHelper.GetString("UlrModule", "Delete"),
                                                                click: function ()
                                                                {
                                                                    setTimeout(function ()
                                                                    {
                                                                        _this.ViewModel.DeleteActionsTasks();
                                                                    },1);
                                                                }
                                                            }
                                                        ]
                                                    });
                                                }
                                            }
                                        ]
                                    },
                                    this.Views.ReportsWidgets.TasksReport.ViewConfig
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {
        TasksReportRowSelectedCount: new Rx.BehaviorSubject(0)
    };

    this.TableRefreshTimer = null;
    this.TableRefreshPauseInSec = 5;
    this.TableRefreshPause = false;
    this.TableCanAutoRefesh = false;
}

UlrSytemGlobalStateViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.TaskDataPopup = webix.ui(this.TaskDataPopupConfig);

    this.TaskInfoPopup = webix.ui(this.TaskInfoPopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
        {
            _this.Views[View] = $$(_this.Id + View);
        }

    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.ActionsTasksDeleteError = this.ViewModel.Signals.ActionsTasksDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.ActionsTasksDeleteSuccess = this.ViewModel.Signals.ActionsTasksDeleteSuccess.subscribe(function (Model)
    {
        if(Model)
        {
            _this.TasksReportOnSuccessDelete(Model);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Deleting") + " " + Model.count + " " + LangHelper.GetString("UlrModule","of tasks").toLowerCase(),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.TasksReportRowSelectedCount = _this.Views.ReportsWidgets.TasksReport.TableRowsSelectedCount.subscribe(function (Count)
    {

        _this.TableCanAutoRefesh = Count == 0 ? true : false;

        if(Count > 1)
        {
            _this.Views.DeleteSelectedTasksBtn.enable();
        }
        else
        {
            _this.Views.DeleteSelectedTasksBtn.disable();
        }
    });

    var tasksReportTable = _this.Views.ReportsWidgets.TasksReport.Views.Table;

    tasksReportTable.attachEvent("onCheck", function (Row, Column, State){
        if(Column == "checked")
        {
            if(State)
                this.select(Row, true);
            else
                this.unselect(Row, true);

        }
    });

    tasksReportTable.attachEvent("onAfterSelect",function(Data, Preserve)
    {
        var item = this.getItem(Data.id);
        if(item)
        {
            if(!item.checked)
            {
                item.checked = 1;
            }
            this.updateItem(Data.id, item);
        }
    });

    tasksReportTable.attachEvent("onAfterUnSelect",function(Data)
    {
        var item = this.getItem(Data.id);
        if(item && item.checked)
        {
            if(item.checked)
            {
                item.checked = 0;
            }
            this.updateItem(Data.id, item);
        }
    });

    App.WebSocketManager.Connect(this.Id);

    // If will smthing fail - move to the end of ViewDidLoad
    App.WebSocketManager.Connections[this.Id].on("queue_updated", function(R)
    {
        if(_this.TableRefreshPause) return;

        _this.TableRefreshPause = true;

        _this.TableRefreshTimer = setTimeout(function ()
        {
            if(_this.TableCanAutoRefesh)
                _this.Refresh();
            _this.TableRefreshPause = false;

        },_this.TableRefreshPauseInSec*1000)
    });
};

UlrSytemGlobalStateViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrSytemGlobalStateViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.WebSocketManager.Disconnect(this.Id);

    clearTimeout(_this.TableRefreshTimer);


    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrSytemGlobalStateViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrSytemGlobalStateViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.TasksReport.RefreshData();
    this.ViewModel.LoadActionTasksInfoJsonDic();
};

UlrSytemGlobalStateViewController.prototype.TasksReportOnItemClick = function(Id, E, Node) {
    var _this = this;

    if (Id.column === 'data') {
        _this.ShowTaskDataForm();
    }

    if (Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.TasksReport.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node: node,
            position: "bottom",
            head: LangHelper.GetString("UlrModule", "Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle: LangHelper.GetString("UlrModule", "Delete") + "?",
            message: LangHelper.GetString("UlrModule", "Are you sure?"),
            actions: [
                {
                    css: "spec_action",
                    label: LangHelper.GetString("UlrModule", "Cancel")
                },
                {
                    label: LangHelper.GetString("UlrModule", "Delete"),
                    click: function ()
                    {
                        _this.ViewModel.DeleteActionsTasks({_id:data._id});
                    }
                }
            ]
        });
    }

    if(Id.column === 'action' && E.target && E.target.className == "webix_cell_link")
    {
        _this.ShowTaskInfoForm();
    }
};

UlrSytemGlobalStateViewController.prototype.ShowTaskDataForm = function()
{
    var table = this.Views.ReportsWidgets.TasksReport.Views.Table;

    var item = table.getSelectedItem();

    if(!item)
        return;

    this.Views.TaskDataPopupForm.clear();
    this.Views.TaskDataPopupForm.clearValidation();

    var data = item.data ? item.data : "{}";

    if(JSON.parse(data))
    {
       var obj =  JSON.parse(data);

        data = JSON.stringify(obj, null, "\t");
    }

    if(item.status_description)
    {
        data = item.status_description + "\n\n\n" + data
    }

    this.TaskDataPopup.show();

    this.Views.TaskDataPopupEditor.setValue(data);

};

UlrSytemGlobalStateViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrSytemGlobalStateViewController.prototype.TasksReportOnSuccessDelete = function(Model)
{
    var table = this.Views.ReportsWidgets.TasksReport.Views.Table;

    var data = null;

    if(Model.filter && Model.filter._id)
    {
        data = table.find(function(obj){
            return obj._id == Model.filter._id;
        });
    }

    else if(Model.filter && Model.filter._ids)
    {
        data = table.find(function(obj){
            return Model.filter._ids.indexOf(obj._id) >= 0;
        });
    }

    if(data && data.length)
    {
        data.forEach(function (Item)
        {
            if(Item.id)
                table.remove(Item.id);
        });

        if(!table.count())
            this.Refresh();
    }
    else
    {
        this.Refresh();
    }

};

UlrSytemGlobalStateViewController.prototype.ShowTaskInfoForm = function()
{
    var table = this.Views.ReportsWidgets.TasksReport.Views.Table;

    var item = table.getSelectedItem();

    if(!item)
        return;

    var key = item.task_type + " " + item.action;

    var data = this.ViewModel.GetActionTaskInfoFromDicByKey(key);

    this.TaskInfoPopup.show();

    this.Views.TaskInfoPopupHeadLabel.setValue(key);
    this.Views.TaskInfoPopupFormTitle.setValues({title:data.title ? data.title : LangHelper.GetString("UlrModule","No info")});
    this.Views.TaskInfoPopupFormDescription.setValues({description:data.description ? data.description : LangHelper.GetString("UlrModule","No info")});

};
function UlrIgwsNodesListViewController(Params)
{
    var _this = this;

    this.Id = "UlrIgwsNodesList";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","System global state"),
        Title:LangHelper.GetString("UlrModule","IGWs nodes list")
    };

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new UlrIgwsNodesManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {

        NodeToolsSubmenu:null,

        ToolsSubmenu:null,
        ToolsBtn:null,
        TraceIpPopupHeadLabel: null,
        TraceIpPopupForm: null,
        TraceIpPopupBtn: null,

        Widgets:{},
        ReportsWidgets:
        {
            IgwsNodesReport: UrlIgwsNodesTableWidget({
                id:this.Id + "IgwsNodesReport",
                enableTextSearch:1,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.IgwsNodesReportOnItemClick(Id, E, Node);
                },
                onCheck:function (Row, Column, State)
                {
                    _this.IgwsNodesReportOnCheck(Row, Column, State);
                }
            })
        }
    };

    this.HardwareStateContext = new HardwareStateViewController();

    this.TraceHelpPopup = null;
    this.TraceHelpPopupConfig = {
        view: "popup",
        id: this.Id + "TraceHelpPopup",
        width: 340,
        height: 230,
        body: {
            view: "form",
            borderless: true,
            margin: 0,
            padding: 0,
            elements:[
                {
                    id: this.Id + "TraceHelpPopupFormLabel",
                    view: "textarea",
                    borderless: true,
                    readonly: true,
                    labelAlign: "right",
                    // width: 320,
                    value: function(){
                        var arr = [
                            LangHelper.GetString("UlrModule", "List of IPv4 and IPv6") + ".",
                            LangHelper.GetString("UlrModule", "Each IP should be written by new line") + ".",
                            LangHelper.GetString("UlrModule", "Max available of each type of address") + " 2.",
                            "",
                            LangHelper.GetString("UlrModule", "For example") + ":",
                            "201.1.1.1",
                            "201.1.1.2",
                            "228b:db51:fb53:04ff:de6c:9fc5:ea68:b568",
                            "4d07:dcce:cc57:24cb:df5c:c4f3:b4c9:449d"
                        ];

                        return arr.join("\n");
                    }()
                }
            ]
        }
    };

    this.TraceIpPopup = null;
    this.TraceIpPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        width:600,
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "TraceIpPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Enable Trace IP"),
                    height:68
                },
                {
                    view:"spectre_button",
                    css:"form_button spec_action with_icon",
                    type:"icon",
                    icon: 'times',
                    align:"right",
                    width:68,
                    height:68,
                    click:function(){_this.TraceIpPopup.hide();}
                }
            ]
        },
        body: {
            type: "space",
            borderless: true,
            rows: [
                {
                    view: "form",
                    id: this.Id + "TraceIpPopupForm",
                    type: "wide",
                    minWidth: 400,
                    borderless: true,
                    elements: [
                        {
                            type: "wide",
                            cols:[
                                {
                                    view:"spectre_textarea",
                                    name:"iplst",
                                    label:LangHelper.GetString("UlrModule","List of IPs"),
                                    required:true,
                                    invalidMessage: LangHelper.GetString("UlrModule", "Input correct IP list"),
                                    validate: function(Val)
                                    {
                                        if(!Val)
                                        {
                                            return false;
                                        }

                                        let
                                            spl = Val.split("\n"),
                                            valid = true,
                                            valid_ips = 0,
                                            counter_ipv4 = 0,
                                            counter_ipv6 = 0;

                                        spl.forEach(Line => {
                                            var line = Line.trim();

                                            if(line)
                                            {
                                                const
                                                    is_valid_ipv4 = Helper.ValidateIPv4(line),
                                                    is_valid_ipv6 = Helper.ValidateIPv6(line);

                                                if (is_valid_ipv4)
                                                {
                                                    counter_ipv4++;
                                                    valid_ips++;
                                                }
                                                else if (is_valid_ipv6)
                                                {
                                                    counter_ipv6++;
                                                    valid_ips++;
                                                }
                                                else
                                                {
                                                    valid = false;
                                                }
                                            }
                                        });

                                        let counter_valid_ipv4_or_ipv6 = (counter_ipv4 >= 0 && counter_ipv4 <= 2) && (counter_ipv6 >= 0 && counter_ipv6 <= 2)

                                        return valid && counter_valid_ipv4_or_ipv6 && (valid_ips > 0 && valid_ips < 5);
                                    },
                                    on: {
                                        onChange: function(Nv, Ov)
                                        {
                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                            this.validate();
                                        }
                                    }
                                },
                                {
                                    view: "button",
                                    name: "uriHelper",
                                    id: _this.Id + "TraceIpPopupFormHelper",
                                    type: "icon",
                                    icon: "question-circle",
                                    css: "toolbar_round_btn",
                                    align: "right",
                                    width: 32,
                                    click: function()
                                    {
                                        _this.TraceHelpPopup.show(this.getNode(), {pos: "right"});
                                    }
                                }
                            ]
                        },
                        {
                            view:"spectre_datepicker",
                            name: "date_from_picker",
                            label:LangHelper.GetString("UlrModule", "Starting time"),
                            labelPosition:"top",
                            timepicker:true,
                            editable: true,
                            format: "%d.%m.%Y %H:%i",
                            height:51,
                            validate: function (Value) {
                                return Helper.ValidateDateTimeInput(Value);
                            },
                            invalidMessage: LangHelper.GetString("QoE", "Enter valid date, example: 22.02.2023 00:00")
                        },
                        {
                            view:"spectre_combo",
                            name:"timepicker",
                            label:LangHelper.GetString("UlrModule","Recording duration"),
                            value: "1 hour",
                            options: {
                                point: false,
                                data: Helper.DictToArr(RecordPCAPRangePickerRangesEnum)
                            },
                        },
                        {
                            type: "wide",
                            cols: [
                                {
                                    view:"spectre_toggle",
                                    name: "toggle_datepicker",
                                    height:22,
                                    width:22,
                                    on:{
                                        onChange:function(Nv, Ov)
                                        {
                                            if (Nv == 1)
                                            {
                                                _this.Views.TraceIpPopupForm.elements["date_from_picker"].disable();
                                            }
                                            else
                                            {
                                                _this.Views.TraceIpPopupForm.elements["date_from_picker"].enable();
                                            }
                                        }
                                    }
                                },
                                {
                                    rows:[
                                        BlockHeaderTemplate({
                                            title:LangHelper.GetString("UlrModule","Start now"), icon:"",
                                            borderless:true
                                        })
                                    ]
                                },
                            ]
                        },
                        {
                            type: "wide",
                            cols: [
                                {
                                    view:"spectre_toggle",
                                    name: "clear_slave_log",
                                    height:22,
                                    width:22,
                                },
                                {
                                    rows:[
                                        BlockHeaderTemplate({
                                            title:LangHelper.GetString("UlrModule","Clear slave logs"), icon:"",
                                            borderless:true
                                        })
                                    ]
                                },
                            ]
                        },
                        {height: 20},
                        {
                            type: "wide",
                            cols: [
                                {
                                    view: "spectre_button",
                                    id: this.Id + "TraceIpPopupBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Enable"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function () {
                                            _this.EnableTraceIp();
                                        },1);

                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title:this.PageTitle.Title}),
                            {height:32},
                            {
                                type:"wide",
                                rows:[
                                    {
                                        type:"wide",
                                        cols:[
                                            {
                                                view:"label",
                                                css:"form_text_label",
                                                label:LangHelper.GetString("UlrModule","Select a node from the list to configure")
                                            },
                                            {
                                                view: "spectre_button",
                                                id: this.Id + "ToolsBtn",
                                                type:"icon",
                                                css: "form_button spec_action with_icon",
                                                label:LangHelper.GetString("UlrModule", "Tools"),
                                                icon:"tools",
                                                //width:52
                                                //height:44,
                                                autowidth: true,
                                                click:function ()
                                                {
                                                    _this.ToolsBtnOnClick(this.getNode());
                                                }
                                            }
                                        ]
                                    },
                                    this.Views.ReportsWidgets.IgwsNodesReport.ViewConfig
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.NodeToolsSubmenuId = this.Id + "NodeToolsSubmenu";
    this.NodeToolsSubmenuConfig = {
        view: "submenu",
        id: this.NodeToolsSubmenuId,
        width: 200,
        autowidth: true,
        padding: 0,
        data: [
            {
                id: this.NodeToolsSubmenuId + "NodeTasks", icon: "tasks", value: LangHelper.GetString("UlrModule", "Node tasks"),
                submenu:[
                    {
                        id: this.NodeToolsSubmenuId + "NodeExportTasks", icon: "bolt", value: LangHelper.GetString("UlrModule", "Create node export tasks")
                    },
                    {
                        id: this.NodeToolsSubmenuId + "DeleteNodeTasks", icon: "trash", value: LangHelper.GetString("UlrModule", "Delete all node tasks")
                    }
                ]
            },
            {
                id: this.NodeToolsSubmenuId + "Bypass", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Bypass"),
                submenu:[
                    {
                        id: this.NodeToolsSubmenuId + "BypassCheck", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Check bypass status")
                    },
                    {id: this.NodeToolsSubmenuId + "BypassSeparator", $template: "Separator"},
                    {
                        id: this.NodeToolsSubmenuId + "DisableBypass", icon: "lightbulb bold green", value: LangHelper.GetString("UlrModule", "Disable bypass")
                    },
                    {
                        id: this.NodeToolsSubmenuId + "EnableBypass", icon: "lightbulb bold red", value: LangHelper.GetString("UlrModule", "Enable bypass")
                    },
                    {id: this.NodeToolsSubmenuId + "BypassSeparator1", $template: "Separator"},
                    {
                        id: this.NodeToolsSubmenuId + "EnableNonStandardMode", icon: "lightbulb green", value: LangHelper.GetString("UlrModule", "Enable non standard mode for NIC")
                    },
                    {
                        id: this.NodeToolsSubmenuId + "DisableNonStandardMode", icon: "lightbulb red", value: LangHelper.GetString("UlrModule", "Disable non standard mode for NIC")
                    }
                ]
            },
            {
                id: this.NodeToolsSubmenuId + "TraceIp", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Trace IP"),
                submenu: [
                    {
                        id: this.NodeToolsSubmenuId + "TraceIpCheck",
                        icon: "badge-check",
                        value: LangHelper.GetString("UlrModule", "Check Trace IP status")
                    },
                    {id: this.NodeToolsSubmenuId + "TraceIpSeparator", $template: "Separator"},
                    {
                        id: this.NodeToolsSubmenuId + "TraceIpEnable",
                        icon: "lightbulb bold yellow",
                        value: LangHelper.GetString("UlrModule", "Enable Trace IP")
                    },
                    {
                        id: this.NodeToolsSubmenuId + "TraceIpDisable",
                        icon: "lightbulb bold green",
                        value: LangHelper.GetString("UlrModule", "Disable Trace IP")
                    }
                ]
            },
            {
                id: this.NodeToolsSubmenuId + "Nodeinfo", icon: "info", value: LangHelper.GetString("UlrModule", "Node info"),
                submenu: [
                {
                    id: this.NodeToolsSubmenuId + "NodeinfoSync", icon: "info", value: LangHelper.GetString("UlrModule", "Sync node info")
                },
                {
                    id: this.NodeToolsSubmenuId + "HardwareState", icon: "thermometer-half", value: LangHelper.GetString("Hardwares", "Hardware state")
                },
                ]
            }
        ],
        // type: {
        //     template: function (obj) {
        //         if (obj.type) {
        //             return "<div class='separator'></div>";
        //         }
        //
        //         return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
        //     }
        // },
        on: {
            onMenuItemClick: function (Id)
            {
                if(
                    Id === _this.NodeToolsSubmenuId + "DeleteNodeTasks" ||
                    Id === _this.NodeToolsSubmenuId + "BypassCheck" ||
                    Id === _this.NodeToolsSubmenuId + "EnableBypass" ||
                    Id === _this.NodeToolsSubmenuId + "DisableBypass" ||
                    Id === _this.NodeToolsSubmenuId + "EnableNonStandardMode" ||
                    Id === _this.NodeToolsSubmenuId + "DisableNonStandardMode" ||
                    Id === _this.NodeToolsSubmenuId + "NodeinfoSync" ||
                    Id === _this.NodeToolsSubmenuId + "TraceIpEnable" ||
                    Id === _this.NodeToolsSubmenuId + "TraceIpCheck" ||
                    Id === _this.NodeToolsSubmenuId + "TraceIpDisable" ||
                    Id === _this.NodeToolsSubmenuId + "NodeExportTasks" ||
                    Id === _this.NodeToolsSubmenuId + "HardwareState"

                )
                {
                    var table = _this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

                    var rowId = table.getSelectedId();

                    var data = table.getItem(rowId);

                    var node = table.getItemNode(rowId);

                    if(Id === _this.NodeToolsSubmenuId + "DeleteNodeTasks")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Delete") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Delete all node tasks") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Delete"),
                                        click: function ()
                                        {
                                            _this.ViewModel.DeleteActionsTasks({node_id:data._id});
                                        }
                                    }
                                ]
                            });
                        },1);
                    }

                    else if(Id === _this.NodeToolsSubmenuId + "BypassCheck")
                    {
                        setTimeout(function ()
                        {
                            _this.ViewModel.CheckNodeBypassStatus({node:data});
                        },1);
                    }

                    else if(Id === _this.NodeToolsSubmenuId + "EnableBypass")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Enable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Enable bypass") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Enable"),
                                        click: function ()
                                        {
                                            _this.ViewModel.EnableBypass({node:data});
                                        }
                                    }
                                ]
                            });
                        },1)
                    }

                    else if(Id === _this.NodeToolsSubmenuId + "DisableBypass")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Disable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Disable bypass") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Disable"),
                                        click: function ()
                                        {
                                            _this.ViewModel.DisableBypass({node:data});
                                        }
                                    }
                                ]
                            });
                        },1)
                    }

                    else if(Id === _this.NodeToolsSubmenuId + "EnableNonStandardMode")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Enable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Enable non standard mode for NIC") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Enable"),
                                        click: function ()
                                        {
                                            _this.ViewModel.EnableNonStandardMode({node:data});
                                        }
                                    }
                                ]
                            });
                        },1)
                    }

                    else if(Id === _this.NodeToolsSubmenuId + "DisableNonStandardMode")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Enable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Disable non standard mode for NIC") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Enable"),
                                        click: function ()
                                        {
                                            _this.ViewModel.DisableNonStandardMode({node:data});
                                        }
                                    }
                                ]
                            });
                        },1)
                    }

                    else if(Id === _this.NodeToolsSubmenuId + "NodeinfoSync")
                    {
                        setTimeout(function ()
                        {
                            _this.ViewModel.SyncNodeInfo({node:data});
                        },1);
                    }

                    else if(Id === _this.NodeToolsSubmenuId + "NodeExportTasks")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Create") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Create node export tasks") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Create"),
                                        click: function ()
                                        {
                                            _this.CreateNodesTasks();
                                        }
                                    }
                                ]
                            });
                        },1)
                    }

                    else if (Id === _this.NodeToolsSubmenuId + "TraceIpEnable")
                    {
                        setTimeout(() => {
                            _this.TraceIpPopup.show(node, {pos: "left"});
                        }, 1);
                    }

                    else if (Id === _this.NodeToolsSubmenuId + "TraceIpDisable")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Disable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Disable Trace IP") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Disable"),
                                        click: function ()
                                        {
                                            const state_schedule = {
                                                start_time: null,
                                                end_time: new Date(),
                                                end_now: true,
                                                clear_slave_log: 0
                                            }

                                            _this.ViewModel.NodesSetSheduleTraceIp({nodes:[data], iplst:'', state_shedule: state_schedule});
                                        }
                                    }
                                ]
                            });
                        },1);
                    }

                    else if (Id === _this.NodeToolsSubmenuId + "TraceIpCheck")
                    {
                        setTimeout(function ()
                        {
                            _this.ViewModel.SyncNodeTraceIpStatus({node:data});
                        },1);
                    }

                    else if (Id === _this.NodeToolsSubmenuId + "HardwareState")
                    {
                        _this.HardwareStateContext.SetData(data);
                        setTimeout(() => {
                            _this.HardwareStateContext.Show(node, "left");
                        }, 1);
                    }

                    this.hide();
                }

                this.hide();
            }
        }

    };

    this.ToolsSubmenuId = this.Id + "ToolsSubmenu";
    this.ToolsSubmenuConfig = {
        view: "submenu",
        id: this.ToolsSubmenuId,
        width: 200,
        autowidth: true,
        padding: 0,
        data: [
            {
                id: this.ToolsSubmenuId + "NodeTasks", icon: "tasks", value: LangHelper.GetString("UlrModule", "Node tasks"),
                submenu:[
                    {
                        id: this.ToolsSubmenuId + "NodeExportTasks", icon: "bolt", value: LangHelper.GetString("UlrModule", "Create node export tasks")
                    }
                ]
            },
            {
                id: this.ToolsSubmenuId + "Bypass", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Bypass"),
                submenu:[
                    {
                        id: this.ToolsSubmenuId + "BypassCheck", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Check bypass status")
                    },
                    {id: this.ToolsSubmenuId + "BypassSeparator", $template: "Separator"},
                    {
                        id: this.ToolsSubmenuId + "DisableBypass", icon: "lightbulb bold green", value: LangHelper.GetString("UlrModule", "Disable bypass")
                    },
                    {
                        id: this.ToolsSubmenuId + "EnableBypass", icon: "lightbulb bold red", value: LangHelper.GetString("UlrModule", "Enable bypass")
                    },
                    {id: this.ToolsSubmenuId + "BypassSeparator1", $template: "Separator"},
                    {
                        id: this.ToolsSubmenuId + "EnableNonStandardMode", icon: "lightbulb green", value: LangHelper.GetString("UlrModule", "Enable non standard mode for NIC")
                    },
                    {
                        id: this.ToolsSubmenuId + "DisableNonStandardMode", icon: "lightbulb red", value: LangHelper.GetString("UlrModule", "Disable non standard mode for NIC")
                    }
                ]
            },
            {
                id: this.ToolsSubmenuId + "TraceIp", icon: "lightbulb", value: LangHelper.GetString("UlrModule", "Trace IP"),
                submenu: [
                    {
                        id: this.ToolsSubmenuId + "TraceIpCheck",
                        icon: "badge-check",
                        value: LangHelper.GetString("UlrModule", "Check Trace IP status")
                    },
                    {id: this.ToolsSubmenuId + "TraceIpSeparator", $template: "Separator"},
                    {
                        id: this.ToolsSubmenuId + "TraceIpEnable",
                        icon: "lightbulb bold yellow",
                        value: LangHelper.GetString("UlrModule", "Enable Trace IP")
                    },
                    {
                        id: this.ToolsSubmenuId + "TraceIpDisable",
                        icon: "lightbulb bold green",
                        value: LangHelper.GetString("UlrModule", "Disable Trace IP")
                    }
                ]
            },
            {
                id: this.ToolsSubmenuId + "Nodeinfo", icon: "info", value: LangHelper.GetString("UlrModule", "Node info"),
                submenu:[
                    {
                        id: this.ToolsSubmenuId + "NodeinfoSync", icon: "info", value: LangHelper.GetString("UlrModule", "Sync node info")
                    }
                ]

            }
        ],
        on: {
            onMenuItemClick: function (Id)
            {
                if(
                    Id === _this.ToolsSubmenuId + "DeleteNodeTasks" ||
                    Id === _this.ToolsSubmenuId + "BypassCheck" ||
                    Id === _this.ToolsSubmenuId + "EnableBypass" ||
                    Id === _this.ToolsSubmenuId + "DisableBypass" ||
                    Id === _this.ToolsSubmenuId + "EnableNonStandardMode" ||
                    Id === _this.ToolsSubmenuId + "DisableNonStandardMode" ||
                    Id === _this.ToolsSubmenuId + "NodeinfoSync" ||
                    Id === _this.ToolsSubmenuId + "TraceIpEnable" ||
                    Id === _this.ToolsSubmenuId + "TraceIpCheck" ||
                    Id === _this.ToolsSubmenuId + "TraceIpDisable" ||
                    Id === _this.ToolsSubmenuId + "NodeExportTasks" ||
                    Id === _this.ToolsSubmenuId + "HardwareState"
                )
                {
                    var table = _this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

                    var data = table.getSelectedItem();

                    if(!data)
                        return;

                    if(!Array.isArray(data))
                        return;

                    data = data.filter(function (Item)
                    {
                        return parseInt(Item.checked) ? true : false;
                    });

                    var node = _this.Views.ToolsBtn.getNode();

                    if(Id === _this.ToolsSubmenuId + "BypassCheck")
                    {
                        setTimeout(function ()
                        {
                            _this.ViewModel.CheckNodesBypassStatus({nodes:data});
                        },1)
                    }

                    else if(Id === _this.ToolsSubmenuId + "EnableBypass")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Enable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Enable bypass") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Enable"),
                                        click: function ()
                                        {
                                            _this.ViewModel.ChangeNodesByPassState({nodes:data, enable:1});
                                        }
                                    }
                                ]
                            });
                        },1)
                    }

                    else if(Id === _this.ToolsSubmenuId + "DisableBypass")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Disable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Disable bypass") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Disable"),
                                        click: function ()
                                        {
                                            _this.ViewModel.ChangeNodesByPassState({nodes:data, enable:0});
                                        }
                                    }
                                ]
                            });
                        },1)
                    }

                    else if(Id === _this.ToolsSubmenuId + "EnableNonStandardMode")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Enable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Enable non standard mode for NIC") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Enable"),
                                        click: function ()
                                        {
                                            _this.ViewModel.ChangeNodesNonStandardMode({nodes:data, enable:1});
                                        }
                                    }
                                ]
                            });
                        },1)
                    }

                    else if(Id === _this.ToolsSubmenuId + "DisableNonStandardMode")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Enable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Disable non standard mode for NIC") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Enable"),
                                        click: function ()
                                        {
                                            _this.ViewModel.ChangeNodesNonStandardMode({nodes:data, enable:0});
                                        }
                                    }
                                ]
                            });
                        },1)
                    }

                    else if(Id === _this.ToolsSubmenuId + "NodeinfoSync")
                    {
                        setTimeout(function ()
                        {
                            _this.ViewModel.SyncNodesInfo({nodes:data});
                        },1);
                    }
                    else if(Id === _this.ToolsSubmenuId + "NodeExportTasks")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Create") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Create node export tasks") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Create"),
                                        click: function ()
                                        {
                                            _this.CreateNodesTasks();
                                        }
                                    }
                                ]
                            });
                        },1)
                    }
                    else if (Id === _this.ToolsSubmenuId + "TraceIpEnable")
                    {
                        setTimeout(() => {
                            _this.TraceIpPopup.show(node, {pos: "left"});
                        }, 1);
                    }

                    else if (Id === _this.ToolsSubmenuId + "TraceIpDisable")
                    {
                        setTimeout(function ()
                        {
                            UlrShowDialogPopup({
                                node: node,
                                position: "bottom",
                                head: LangHelper.GetString("UlrModule", "Disable") + "?",
                                //type:"spectre-alert-notification",
                                mainTitle: LangHelper.GetString("UlrModule", "Disable Trace IP") + "?",
                                message: LangHelper.GetString("UlrModule", "Are you sure?"),
                                actions: [
                                    {
                                        css: "spec_action",
                                        label: LangHelper.GetString("UlrModule", "Cancel")
                                    },
                                    {
                                        label: LangHelper.GetString("UlrModule", "Disable"),
                                        click: function ()
                                        {
                                            const state_schedule = {
                                                start_time: null,
                                                end_time: new Date(),
                                                end_now: true,
                                                clear_slave_log: 0
                                            }
                                            _this.ViewModel.NodesSetSheduleTraceIp({nodes:data, iplst:'', state_shedule: state_schedule});
                                        }
                                    }
                                ]
                            });
                        },1);
                    }

                    else if (Id === _this.ToolsSubmenuId + "TraceIpCheck")
                    {
                        setTimeout(function ()
                        {
                            _this.ViewModel.SyncNodesTraceIpStatuses({nodes:data});
                        },1);
                    }

                    else if (Id === _this.ToolsSubmenuId + "HardwareState")
                    {
                        _this.HardwareStateContext.SetData(data);
                        _this.HardwareStateContext.Show(node, "right");
                    }

                    this.hide();
                }
            }
        }

    };

    this.TableRefreshTimer = null;
    this.TableRefreshPauseInSec = 5;
    this.TableRefreshPause = false;
    this.TableCanAutoRefesh = false;
}

UlrIgwsNodesListViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.NodeToolsSubmenu = webix.ui(this.NodeToolsSubmenuConfig);

    this.Views.ToolsSubmenu = webix.ui(this.ToolsSubmenuConfig);

    this.BindTable();

    App.WebSocketManager.Connect(this.Id);

    App.WebSocketManager.Connections[this.Id].on("igw_node_updated", function(R)
    {
        if(_this.TableRefreshPause) return;

        _this.TableRefreshPause = true;

        _this.TableRefreshTimer = setTimeout(function ()
        {
            if(_this.TableCanAutoRefesh)
                _this.Refresh();

            _this.TableRefreshPause = false;

        },_this.TableRefreshPauseInSec*1000)
    });
};

UlrIgwsNodesListViewController.prototype.BindTable = function (Params)
{
    var _this = this;
    
    var nodesTable = _this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

    nodesTable.attachEvent("onCheck", function (Row, Column, State){
        if(Column == "checked")
        {

            var item = this.getItem(Row);

            if(State && parseInt(item.enabled))
            {
                this.select(Row, true);
            }
            else
            {
                item.checked = 0;
                this.updateItem(Row, item);
                this.unselect(Row, true);
            }


        }
    });

    nodesTable.attachEvent("onAfterSelect",function(Row, Preserve)
    {
        var item = this.getItem(Row);

        if(item && parseInt(item.enabled))
        {
            if(!parseInt(item.checked))
            {
                item.checked = 1;
            }
            this.updateItem(Row, item);
        }
    });

    nodesTable.attachEvent("onAfterUnSelect",function(Row)
    {
        var item = this.getItem(Row);

        if(item && parseInt(item.checked))
        {
            if(parseInt(item.checked))
            {
                item.checked = 0;
            }
            this.updateItem(Row, item);
        }
    });

    this.Subscriptions.IgwsNodesReportSelectedCount = _this.Views.ReportsWidgets.IgwsNodesReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        _this.TableCanAutoRefesh = Value == 0 ? true : false;

        if(Value > 1)
        {
            setTimeout(function ()
            {
                var nodesTable = _this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

                var selected = nodesTable.getSelectedItem();

                if(Array.isArray(selected))
                {
                    var checked = selected.filter(function (Item)
                    {
                        return parseInt(Item.checked) ? true : false;
                    });

                    if(checked.length > 1)
                        _this.Views.ToolsBtn.enable();
                }
            },1);
        }
        else
        {
            _this.Views.ToolsBtn.disable();
        }
    });

    //State

    this.Subscriptions.IgwNodeEnableStateError = this.ViewModel.Signals.IgwNodeEnableStateError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.IgwNodeEnableStateUpdated = this.ViewModel.Signals.IgwNodeEnableStateUpdated.subscribe(function (IgwNodeViewModel)
    {
        if(IgwNodeViewModel)
        {
            _this.IgwNodeEnableStateUpdated(IgwNodeViewModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","IGW node ")+" # "+IgwNodeViewModel.name+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    //Tasks

    this.Subscriptions.ActionsTasksDeleteError = this.ViewModel.Signals.ActionsTasksDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.ActionsTasksDeleteSuccess = this.ViewModel.Signals.ActionsTasksDeleteSuccess.subscribe(function (Model)
    {
        if(Model)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Deleting") + " " + Model.count + " " + LangHelper.GetString("UlrModule","of tasks").toLowerCase(),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    //Bypass

    this.Subscriptions.NodeSyncByPassStatusError = this.ViewModel.Signals.NodeSyncByPassStatusError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NodeSyncByPassStatusSuccess = this.ViewModel.Signals.NodeSyncByPassStatusSuccess.subscribe(function (Model)
    {
        if(Model)
        {
            if(Model.node_updated)
            {
                _this.UpdateIgwsNodesReportRow(Model.node_updated);
            }

            if(Model.sync && Model.sync.error)
            {
                _this.ShowServerError(Model.sync.error);
            }
            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Checking bypass status of node {name}").replace("{name}", Model.node && Model.node.name ? Model.node.name : ""),
                    LangHelper.GetString("UlrModule","Success")
                );
            }
        }
    });

    this.Subscriptions.NodeEnableBypassError = this.ViewModel.Signals.NodeEnableBypassError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NodeEnableBypassSuccess = this.ViewModel.Signals.NodeEnableBypassSuccess.subscribe(function (Model)
    {
        if(Model)
        {
            if(Model.node)
            {
                _this.UpdateIgwsNodesReportRow(Model.node);
            }

            if(Model.processed && Model.processed.all && Model.processed.all.error)
            {
                _this.ShowServerError(Model.processed.all.error);
            }

            else if(Model.sync && Model.sync.error)
            {
                _this.ShowServerError(Model.sync.error);
            }

            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Enabling bypass for node {name}").replace("{name}", Model.node && Model.node.name ? Model.node.name : ""),
                    LangHelper.GetString("UlrModule","Success")
                );
            }
        }
    });

    this.Subscriptions.NodeDisableBypassError = this.ViewModel.Signals.NodeDisableBypassError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NodeDisableBypassSuccess = this.ViewModel.Signals.NodeDisableBypassSuccess.subscribe(function (Model)
    {
        if(Model)
        {
            if(Model.node)
            {
                _this.UpdateIgwsNodesReportRow(Model.node);
            }

            if(Model.processed && Model.processed.all && Model.processed.all.error)
            {
                _this.ShowServerError(Model.processed.all.error);
            }

            else if(Model.sync && Model.sync.error)
            {
                _this.ShowServerError(Model.sync.error);
            }

            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Disabling bypass for node {name}").replace("{name}", Model.node && Model.node.name ? Model.node.name : ""),
                    LangHelper.GetString("UlrModule","Success")
                );
            }
        }
    });

    this.Subscriptions.NotesBgTaskStartedError = this.ViewModel.Signals.NotesBgTaskStartedError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NotesBgTaskStartedSuccess = this.ViewModel.Signals.NotesBgTaskStartedSuccess.subscribe(function (Model)
    {
        if(Model)
        {
            if(Model.action == "SyncByPass")
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Starting checking bypass state of selected nodes"),
                    LangHelper.GetString("UlrModule","Success")
                );
            }

            if(Model.action == "ChangeByPassStatus")
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Starting changing bypass state of selected nodes"),
                    LangHelper.GetString("UlrModule","Success")
                );
            }

            if(Model.action == "ChangeByPassMode")
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Starting changing standard / non-standard NIC mode of selected nodes"),
                    LangHelper.GetString("UlrModule","Success")
                );
            }

            if(Model.action == "SyncVchannels")
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Syncing of selected nodes"),
                    LangHelper.GetString("UlrModule","Success")
                );
            }

            if(Model.action == "SyncTraceIp" || Model.action == "SetTraceIp")
            {
                if(Model.action == "SyncTraceIp")
                {
                    UlrShowMessage(
                        "success",
                        LangHelper.GetString("UlrModule","Trace IP status syncing for selected nodes started"),
                        LangHelper.GetString("UlrModule","Success")
                    );
                }
                else
                {
                    UlrShowMessage(
                        "success",
                        LangHelper.GetString("UlrModule","Starting enable/disable Trace IP for selected nodes"),
                        LangHelper.GetString("UlrModule","Success")
                    );
                }
            }
        }
    });

    this.Subscriptions.NotesBgTaskFinishedError = this.ViewModel.Signals.NotesBgTaskFinishedError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NotesBgTaskFinishedSuccess = this.ViewModel.Signals.NotesBgTaskFinishedSuccess.subscribe(function (Model)
    {
        if(Model)
        {
            if(Model.action == "SyncByPass")
            {
                if(Model.status == "success")
                {
                    UlrShowMessage(
                        "success",
                        LangHelper.GetString("UlrModule","Finishing checking bypass state of selected nodes"),
                        LangHelper.GetString("UlrModule","Success")
                    );

                    _this.Views.ReportsWidgets.IgwsNodesReport.RefreshData();
                }
                else
                {
                    _this.ShowServerError({code:0, msg:Model.status_description});
                }
            }

            if(Model.action == "ChangeByPassStatus")
            {
                if(Model.status == "success")
                {
                    UlrShowMessage(
                        "success",
                        LangHelper.GetString("UlrModule","Finishing changing bypass state of selected nodes"),
                        LangHelper.GetString("UlrModule","Success")
                    );

                    _this.Views.ReportsWidgets.IgwsNodesReport.RefreshData();
                }
                else
                {
                    _this.ShowServerError({code:0, msg:Model.status_description});
                }
            }

            if(Model.action == "ChangeByPassMode")
            {
                if(Model.status == "success")
                {
                    UlrShowMessage(
                        "success",
                        LangHelper.GetString("UlrModule","Finishing changing standard / non-standard NIC mode of selected nodes"),
                        LangHelper.GetString("UlrModule","Success")
                    );

                    _this.Views.ReportsWidgets.IgwsNodesReport.RefreshData();
                }
                else
                {
                    _this.ShowServerError({code:0, msg:Model.status_description});
                }
            }

            if(Model.action == "SyncVchannels")
            {
                if(Model.status == "success")
                {
                    UlrShowMessage(
                        "success",
                        LangHelper.GetString("UlrModule","Finishing syncing of selected nodes"),
                        LangHelper.GetString("UlrModule","Success")
                    );

                    _this.Views.ReportsWidgets.IgwsNodesReport.RefreshData();
                }
                else
                {
                    _this.ShowServerError({code:0, msg:Model.status_description});
                }
            }

            if(Model.action == "SyncTraceIp" || Model.action == "SetTraceIp")
            {
                if(Model.status == "success")
                {
                    var item = _this.Views.ReportsWidgets.IgwsNodesReport.Views.Table.serialize().find((obj) => {return obj.hardware_id == Model.hardware_id});

                    if(Model.action == "SyncTraceIp")
                    {
                        UlrShowMessage(
                            "success",
                            LangHelper.GetString("UlrModule","Trace IP status syncing for selected nodes finished"),
                            LangHelper.GetString("UlrModule","Success")
                        );
                    }
                    else
                    {
                        UlrShowMessage(
                            "success",
                            LangHelper.GetString("UlrModule","Finishing enable/disable Trace IP for selected nodes"),
                            LangHelper.GetString("UlrModule","Success")
                        );
                    }

                    _this.Views.ReportsWidgets.IgwsNodesReport.RefreshData();

                }
                else{
                    _this.ShowServerError({code:0, msg:Model.status_description});
                }

            }
        }
    });

    //Non standard mode

    this.Subscriptions.NodeEnableNonStandardModeError = this.ViewModel.Signals.NodeEnableNonStandardModeError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NodeEnableNonStandardModeSuccess = this.ViewModel.Signals.NodeEnableNonStandardModeSuccess.subscribe(function (Model)
    {
        if(Model)
        {
            if(Model.node)
            {
                _this.UpdateIgwsNodesReportRow(Model.node);
            }

            if(Model.processed && Model.processed.all && Model.processed.all.error)
            {
                _this.ShowServerError(Model.processed.all.error);
            }

            else if(Model.sync && Model.sync.error)
            {
                _this.ShowServerError(Model.sync.error);
            }

            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Enabling non-standard NIC mode for node {name}").replace("{name}", Model.node && Model.node.name ? Model.node.name : ""),
                    LangHelper.GetString("UlrModule","Success")
                );
            }
        }
    });

    this.Subscriptions.NodeDisableNonStandardModeError = this.ViewModel.Signals.NodeDisableNonStandardModeError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NodeDisableNonStandardModeSuccess = this.ViewModel.Signals.NodeDisableNonStandardModeSuccess.subscribe(function (Model)
    {
        if(Model)
        {
            if(Model.node)
            {
                _this.UpdateIgwsNodesReportRow(Model.node);
            }

            if(Model.processed && Model.processed.all && Model.processed.all.error)
            {
                _this.ShowServerError(Model.processed.all.error);
            }

            else if(Model.sync && Model.sync.error)
            {
                _this.ShowServerError(Model.sync.error);
            }

            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Disabling non-standard NIC mode for node {name}").replace("{name}", Model.node && Model.node.name ? Model.node.name : ""),
                    LangHelper.GetString("UlrModule","Success")
                );
            }
        }
    });

    this.Subscriptions.NodeSyncInfoSuccess = this.ViewModel.Signals.NodeSyncInfoSuccess.subscribe(function (Model)
    {
        if(Model)
        {

            if(Model.node_updated)
            {
                _this.UpdateIgwsNodesReportRow(Model.node_updated);
            }

            if(Model.sync && Model.sync.error)
            {
                _this.ShowServerError(Model.sync.error);
            }
            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Syncing of node info {name}").replace("{name}", Model.node && Model.node.name ? Model.node.name : ""),
                    LangHelper.GetString("UlrModule","Success")
                );
            }
        }
    });

    this.Subscriptions.NodeSyncInfoError = this.ViewModel.Signals.NodeSyncInfoError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.CreateNodeTasksSuccess = this.ViewModel.Signals.CreateNodeTasksSuccess.subscribe(function(Val){
       if(Val)
       {
           UlrShowMessage(
               "success",
               LangHelper.GetString("UlrModule","Nodes export tasks created"),
               LangHelper.GetString("UlrModule","Success")
           );
       }
    });

    this.Subscriptions.CreateNodeTasksError = this.ViewModel.Signals.CreateNodeTasksError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NodeCheckTraceIpStatusSuccess = this.ViewModel.Signals.NodeCheckTraceIpStatusSuccess.subscribe(function (Model)
    {
        if(Model)
        {

            if(Model.node_updated)
            {
                _this.UpdateIgwsNodesReportRow(Model.node_updated);
            }

            if(Model.sync && Model.sync.error)
            {
                _this.ShowServerError(Model.sync.error);
            }
            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Trace IP status for {name} synced").replace("{name}", Model.node && Model.node.name ? Model.node.name : ""),
                    LangHelper.GetString("UlrModule","Success")
                );
            }
        }
    });

    this.Subscriptions.NodeCheckTraceIpStatusError = this.ViewModel.Signals.NodeCheckTraceIpStatusError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.NodeSetTraceIpSuccess = this.ViewModel.Signals.NodeSetTraceIpSuccess.subscribe(function (Model)
    {
        if(Model)
        {

            if(Model.node_updated)
            {
                _this.UpdateIgwsNodesReportRow(Model.node_updated);
            }

            if(Model.sync && Model.sync.error)
            {
                _this.ShowServerError(Model.sync.error);
            }
            else
            {
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","Trace IP for {name} enabled/disabled").replace("{name}", Model.node && Model.node.name ? Model.node.name : ""),
                    LangHelper.GetString("UlrModule","Success")
                );

                _this.Views.ReportsWidgets.IgwsNodesReport.Views.Table.unselectAll();
            }
        }
    });

    this.Subscriptions.NodeSetTraceIpError = this.ViewModel.Signals.NodeSetTraceIpError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });
};

UlrIgwsNodesListViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.TraceIpPopup = webix.ui(this.TraceIpPopupConfig);

    this.TraceHelpPopup = webix.ui(this.TraceHelpPopupConfig);

    this.HardwareStateContext.ViewDidLoad();

    this.BindAll(Params);

    this.Refresh();
};

UlrIgwsNodesListViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.WebSocketManager.Disconnect(this.Id);

    clearTimeout(_this.TableRefreshTimer);

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    this.HardwareStateContext.Destroy();
};

UlrIgwsNodesListViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.IgwsNodesReport.RefreshData();
};

UlrIgwsNodesListViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrIgwsNodesListViewController.prototype.IgwsNodesReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit' || (Id.column === 'igw_name' && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: ControllersEnum.UlrEditIgw, path:"/_id=" + data.igw_id});
    }

    else if (Id.column === 'tools')
    {
        var table = this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

        var node = table.getItemNode(Id);

        var data = table.getItem(Id);

        var menu = this.Views.NodeToolsSubmenu;

        if(parseInt(data.enabled))
        {
            menu.showItem(_this.NodeToolsSubmenuId + "Bypass");
        }
        else
        {
            menu.hideItem(_this.NodeToolsSubmenuId + "Bypass");
        }

        if(parseInt(data.bypass_available))
        {
            menu.showItem(_this.NodeToolsSubmenuId + "BypassSeparator");
            menu.showItem(_this.NodeToolsSubmenuId + "BypassSeparator1");
            menu.showItem(_this.NodeToolsSubmenuId + "EnableBypass");
            menu.showItem(_this.NodeToolsSubmenuId + "DisableBypass");
            menu.showItem(_this.NodeToolsSubmenuId + "EnableNonStandardMode");
            menu.showItem(_this.NodeToolsSubmenuId + "DisableNonStandardMode");
        }
        else
        {
            menu.hideItem(_this.NodeToolsSubmenuId + "BypassSeparator");
            menu.hideItem(_this.NodeToolsSubmenuId + "BypassSeparator1");
            menu.hideItem(_this.NodeToolsSubmenuId + "EnableBypass");
            menu.hideItem(_this.NodeToolsSubmenuId + "DisableBypass");
            menu.hideItem(_this.NodeToolsSubmenuId + "EnableNonStandardMode");
            menu.hideItem(_this.NodeToolsSubmenuId + "DisableNonStandardMode");
        }

        if(data.trace_ip_state && JSON.parse(data.trace_ip_state))
        {
            var state = JSON.parse(data.trace_ip_state);

            if(state.enabled)
            {
                menu.hideItem(_this.NodeToolsSubmenuId + "TraceIpEnable");
                menu.showItem(_this.NodeToolsSubmenuId + "TraceIpDisable");
            }
            else
            {
                menu.hideItem(_this.NodeToolsSubmenuId + "TraceIpDisable");
                menu.showItem(_this.NodeToolsSubmenuId + "TraceIpEnable");
            }
        }
        else
        {
            menu.hideItem(_this.NodeToolsSubmenuId + "TraceIpDisable");
            menu.showItem(_this.NodeToolsSubmenuId + "TraceIpEnable");
        }

        menu.show(node);
    }

    else if (Id.column === 'monitor' || Id.column === 'logs')
    {
        var table = this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

        var data = table.getItem(Id);

        var hwId = data.hardware_id ? data.hardware_id : 0;

        if(!hwId)
            return;

        var controller = Id.column === 'monitor' ? ControllersEnum.UlrIgwNodePerformance : ControllersEnum.UlrIgwNodeLogs;

        App.NavRouter.PresentView({id: controller, path:"/_id=" + hwId});

    }
};

UlrIgwsNodesListViewController.prototype.IgwsNodesReportOnCheck = function(Row, Column, State)
{
    if(Column == "enabled")
    {
        var table = this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

        var data = table.getItem(Row);

        this.ViewModel.EnableDisableIgwNode(webix.extend(data, {callback:function (R)
            {
                if(!R.success)
                {
                    data.enabled = State ? 0 : 1;

                    table.updateItem(data.id, data);
                }
            }}), State);
    }
};

UlrIgwsNodesListViewController.prototype.IgwNodeEnableStateUpdated = function(IgwNodeViewModel)
{
    var table = this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == IgwNodeViewModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = IgwNodeViewModel.enabled;
        table.updateItem(data.id, data);
    }

};

UlrIgwsNodesListViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrIgwsNodesListViewController.prototype.UpdateIgwsNodesReportRow = function(Model)
{
    var table = this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == Model._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.updateItem(data[0].id, Model);
    }

};

UlrIgwsNodesListViewController.prototype.ToolsBtnOnClick = function(Node)
{
    var _this = this, menu = this.Views.ToolsSubmenu;

    menu.show(Node);
};

UlrIgwsNodesListViewController.prototype.CreateNodesTasks = function()
{
  var _this = this;

  var items = this.Views.ReportsWidgets.IgwsNodesReport.Views.Table.getSelectedItem();
  var nodes = [];

  if(Array.isArray(items))
  {
      nodes = items;
  }
  else{
      nodes = [items];
  }

  this.ViewModel.CreateNodeTasks({nodes: nodes})
};

UlrIgwsNodesListViewController.prototype.EnableTraceIp = function()
{
    var table = this.Views.ReportsWidgets.IgwsNodesReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
    {
        this.TraceIpPopup.hide();
        return;
    }

    if(!Array.isArray(data))
    {
        data = [data];
    }

    if(!this.Views.TraceIpPopupForm.validate())
    {
        return;
    }

    var vals = this.Views.TraceIpPopupForm.getValues();

    var ips = vals.iplst.split("\n").join(",");

    const
        state_shedule = {},
        form = this.Views.TraceIpPopupForm,
        state_start_now = form.elements["toggle_datepicker"].getValue(),
        clear_slave_log = form.elements["clear_slave_log"].getValue();

    if (state_start_now == 1)
    {
        state_shedule.start_time = Helper.RoundDateToSeconds(new Date());
        state_shedule.start_now = true;
    }
    else
    {
        state_shedule.start_time = new Date(form.elements["date_from_picker"].getValue());

        if (state_shedule.start_time < new Date()) {
            form.markInvalid("date_from_picker", LangHelper.GetString("UlrModule", "You can't specify a date less than the current date"));
            return
        }
    }

    const getSetFormTimepickerValue = form.elements["timepicker"].getValue();
    const timepicker_split = getSetFormTimepickerValue.split(" ");
    const start_time = new Date(state_shedule.start_time);
    state_shedule.end_time = webix.Date.add(start_time, parseInt(timepicker_split[0], 10), timepicker_split[1]);
    state_shedule.clear_slave_log = clear_slave_log ? 1 : 0;

    this.ViewModel.NodesSetSheduleTraceIp({nodes: data, iplst: ips, state_shedule: state_shedule});

    this.Views.TraceIpPopupForm.elements.iplst.setValue('');
    this.Views.TraceIpPopupForm.elements.date_from_picker.enable();
    this.Views.TraceIpPopupForm.elements.date_from_picker.setValue("");
    this.Views.TraceIpPopupForm.elements.toggle_datepicker.setValue(0);
    this.Views.TraceIpPopupForm.elements.clear_slave_log.setValue(0);
    this.Views.TraceIpPopupForm.elements.timepicker.setValue("1 hour");
    this.Views.TraceIpPopupForm.clearValidation();
    this.TraceIpPopup.hide();
};

function UlrUsersActionsLogViewController(Params)
{
    var _this = this;

    this.Id = "UlrUsersActionsLog";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","System global state"),
        Title:LangHelper.GetString("UlrModule","Users actions log")
    };

    this.mode = module ? module : "dpiui2";

    this.ViewModel = null;

    this.ReportsModel = new UniReportsManager();

    this.Views = {

        ToolsSubmenu:null,

        FiltersForm:null,

        FilterApplyBtn:null,

        Widgets:{
            DateRangePicker: new QoEDateRangePickerWidget({
                id:this.Id + "DateRangePicker",
                default_value:"Last 7 days"
            })
        },
        ReportsWidgets:
        {
            UsersActionsLog: UrlActionsLogTableWidget({
                id:this.Id + "UsersActionsLog",
                enableTextSearch:0,
                enableAutoHeight:1,
                global:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.UsersActionsLogOnItemClick(Id, E, Node);
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title:this.PageTitle.Title}),
                            {height:32},
                            {
                                view:"label",
                                css:"form_text_label",
                                label:LangHelper.GetString("UlrModule","Filters")
                            },
                            {
                                view:"form",
                                id:this.Id + "FiltersForm",
                                type: "wide",
                                borderless:true,
                                elements:[
                                    {
                                        type: "wide",
                                        cols:[
                                            this.Views.Widgets.DateRangePicker.ViewConfig,
                                            {
                                                view:"spectre_richselect",
                                                name:"type_code",
                                                label:LangHelper.GetString("UlrModule","Type"),
                                                options:{
                                                    point:false,
                                                    data:[]
                                                }
                                            },
                                            {
                                                view:"spectre_button",
                                                id:this.Id + "FilterApplyBtn",
                                                css:"form_button form_element main_action",
                                                label:LangHelper.GetString("UlrModule","Apply"),
                                                height:51,
                                                click:function ()
                                                {
                                                    setTimeout(function ()
                                                    {
                                                        _this.RefreshTableReport();
                                                    },1);
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        type:"wide",
                                        cols:[
                                            {
                                                view:"spectre_text",
                                                name:"row_id",
                                                label:LangHelper.GetString("UlrModule","Id")
                                            },
                                            {
                                                view:"spectre_text",
                                                name:"create_user",
                                                label:LangHelper.GetString("UlrModule","User")
                                            },
                                            {
                                                view:"spectre_text",
                                                name:"full_text_search",
                                                label:LangHelper.GetString("UlrModule","Search")
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height:32},
                            {
                                view:"label",
                                css:"form_text_label",
                                label:LangHelper.GetString("UlrModule","Users actions log")
                            },
                            this.Views.ReportsWidgets.UsersActionsLog.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrUsersActionsLogViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.Widgets.DateRangePicker.SetValue(null,true);

    this.Subscriptions.UlrLogTypesDic = App.DicsManager.Signal[DicsEnum.UlrLogTypesDic].subscribe(function (V)
    {
        if (V)
        {
            var dic = App.DicsManager.GetDic(DicsEnum.UlrLogTypesDic), opts = [{id:-1, value:""}];

            Object.keys(dic).forEach(function (Key)
            {
                var item = dic[Key];
                opts.push({id:item.value, value:(UlrUsersActionsLogsCodesDic[item.value] ? UlrUsersActionsLogsCodesDic[item.value].value : item.value)});
            });

            var list = _this.Views.FiltersForm.elements.type_code.getList();
            list.clearAll();
            list.parse(opts);

            _this.RefreshTableReport();
        }
    });
};

UlrUsersActionsLogViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrUsersActionsLogViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrUsersActionsLogViewController.prototype.Refresh = function ()
{
    if(!App.DicsManager.GetDic(DicsEnum.UlrLogTypesDic))
        App.DicsManager.Refresh({data:[DicsEnum.UlrLogTypesDic]});
};

UlrUsersActionsLogViewController.prototype.RefreshTableReport = function ()
{
    var filter = {};

    var period = this.Views.Widgets.DateRangePicker.GetValue(true);

    if(period)
    {
        var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

        if(period.start && period.end)
        {
            filter.period = {
                id:"update_time",
                operator:"between",
                value:[format(period.start), format(period.end)]
            };
        }

        else if(period.start)
        {
            filter.period = {
                id:"update_time",
                operator:">=",
                value:format(period.start)
            };
        }

        else if(period.end)
        {
            filter.period = {
                id:"update_time",
                operator:"<=",
                value:format(period.end)
            };
        }
    }

    var filterFormVals = this.Views.FiltersForm.getValues();

    if(filterFormVals.row_id)
    {
        filter.row_id =
            {
                id:"row_id",
                operator:"=",
                value:filterFormVals.row_id
            };
    }

    if(filterFormVals.create_user)
    {
        filter.create_user =
            {
                id:"create_user",
                operator:"like",
                value:filterFormVals.create_user
            };
    }

    if(filterFormVals.type_code && filterFormVals.type_code != -1)
    {
        filter.type_code =
            {
                id:"type_code",
                operator:"=",
                value:filterFormVals.type_code
            };
    }

    if(filterFormVals.full_text_search)
    {
        filter.full_text_search =
            {
                id:"full_text_search",
                operator:"like",
                value:filterFormVals.full_text_search
            };
    }

    this.Views.ReportsWidgets.UsersActionsLog.RefreshData(0,{filter:filter});
};

UlrUsersActionsLogViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrUsersActionsLogViewController.prototype.UsersActionsLogOnItemClick = function(RowId, E, Node)
{
    var _this = this;

    if((RowId.column === 'row_id' && E.target && E.target.className == "webix_cell_link") || RowId.column === 'edit')
    {
        var table = this.Views.ReportsWidgets.UsersActionsLog.Views.Table;

        var data = table.getItem(RowId);

        var id = Helper.StripHtml(data.row_id);

        var controller = UlrUsersActionsLogCodesControllersMap[data.type_code] ? UlrUsersActionsLogCodesControllersMap[data.type_code] : UlrUsersActionsLogCodesControllersMap[UlrRulesTypesCodesEnum.web_ip_lock];

        if(controller)
            App.NavRouter.PresentView({id: controller, path:"/_id=" + id});
    }

    if(RowId.column === 'type_code' && E.target && E.target.className == "webix_cell_link")
    {
        var table = this.Views.ReportsWidgets.UsersActionsLog.Views.Table;

        var data = table.getItem(RowId);

        var id = Helper.StripHtml(data.row_id);

        var controller = UlrUsersActionsLogTypesCodesListsControllersMap[data.type_code] ? UlrUsersActionsLogTypesCodesListsControllersMap[data.type_code] : "";

        if(controller)
            App.NavRouter.PresentView({id: controller});
    }

    if((RowId.column == "value_new" || RowId.column == "value_old") && E.target && E.target.className == "webix_icon fa-eye")
    {
        var table = this.Views.ReportsWidgets.UsersActionsLog.Views.Table;

        var data = table.getItem(RowId);

        ResourceImportQoEPopupItem({
            cfg: RowId.column == "value_new" ? data.value_new : data.value_old,
            editable: false
        });
    }
};
function UlrTrafficRedirectionRulesViewController(Params)
{
    var _this = this;

    this.Id = "UlrTrafficRedirectionRules";
    this.RootTitle = LangHelper.GetString("UlrModule","System global state");
    this.Title = LangHelper.GetString("UlrModule","List traffic redirection subscribers");
    this.EditFormLabel = LangHelper.GetString("UlrModule", "Traffic redirection subscriber [TYPE] is [VALUE].");

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        ReportWidget: UrlLastTrafficRedirectionSubscribersEntriesTableWidget,
        EditFormLabel: this.EditFormLabel,
        BlockInfoTemplate: LangHelper.GetString("UlrModule", "Add the subscriber's login or IP to the list and traffic for this subscriber will be redirected to an external platform."),
        BlockWarningTemplate: AppEnv.DisableISPSwitchForTrafficRedirection ? "" : LangHelper.GetString("UlrModule","The subscriber`s rule is set globally if no ISPs are specified!"),
        BlockHeaderTemplateTableTitle: LangHelper.GetString("UlrModule","Latest records of subscriber traffic redirection"),
        NotificationTitle: "Traffic redirection subscriber",
        Methods: {
            SaveRule: "UlrSaveTrafficRedirectionSubscriberRule",
            DeleteRule: "UlrDeleteTrafficRedirectionSubscriberRule",
            EnableRule: "UlrEnableTrafficRedirectionSubscriberRule",
            DisableRule: "UlrDisableTrafficRedirectionSubscriberRule"
        },
        HideIspsValue: AppEnv.DisableISPSwitchForTrafficRedirection ? true : false
    }, true);

    UlrTrafficRedirectionRulesViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrTrafficRedirectionRulesViewController, UlrSubscribersRulesViewController);
function UlrIgwNodePerformanceViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"UlrIgwNodePerformance",
        PageTitle: {
            RootTitle:LangHelper.GetString("UlrModule","System global state"),
            Title:LangHelper.GetString("UlrModule","Hardware performance")
        }
    },true);

    UlrIgwNodePerformanceViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrIgwNodePerformanceViewController,DpiPerformanceViewController);
function UlrIgwNodeLogsViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"UlrIgwNodeLogs",
        PageTitle: {
            RootTitle:LangHelper.GetString("UlrModule","System global state"),
            Title:LangHelper.GetString("UlrModule","Hardware logs")
        }
    },true);

    UlrIgwNodeLogsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrIgwNodeLogsViewController,DpiLogsViewController);
function UlrIgwsQoEsListViewController(Params)
{
    var _this = this;

    this.Id = "UlrIgwsQoEsList";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","System global state"),
        Title:LangHelper.GetString("UlrModule","IGWs QoEs list")
    };

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new UlrIgwsManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        Widgets:{},
        ReportsWidgets:
            {
                IgwsQoEsReport: UrlIgwsQoEsTableWidget({
                    id:this.Id + "IgwsQoEsReportNotQoE",
                    enableTextSearch:1,
                    enableAutoHeight:1,
                    onItemClick:function (Id, E, Node)
                    {
                        _this.IgwsQoEsReportOnItemClick(Id, E, Node);
                    }
                })
            }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title:this.PageTitle.Title}),
                            {height:32},
                            {
                                view:"label",
                                css:"form_text_label",
                                label:LangHelper.GetString("UlrModule","Select IGW QoE UI from the list")
                            },
                            this.Views.ReportsWidgets.IgwsQoEsReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.MonitorSubmenuId = this.Id + "MonitorSubmenu";
    this.MonitorSubmenuConfig = {
        view: "submenu",
        id: this.MonitorSubmenuId,
        width: 200,
        autowidth: true,
        padding: 0,
        data: function (){
            var data =
            [
                {id: "QoEDashboard", icon: "braille", value: LangHelper.GetString("AppView", "QoE dashboard"), section:RoleSectionsEnum.qoeanalytics_dashboard},
                {id: "QoEFullNetFlow", icon: "fullflow", value: LangHelper.GetString("AppView", "Netflow"), section:RoleSectionsEnum.qoeanalytics_fullnetflow},
                {id: "QoERawFullNetFlow", icon: "rawfullflow", value: LangHelper.GetString("AppView", "Raw full netflow"), href:"#QoERawFullNetFlow", section:RoleSectionsEnum.qoeanalytics_rawfullnetflow},
                {id: "QoEClickStream", icon: "clickstream", value: LangHelper.GetString("AppView", "Clickstream"), section:RoleSectionsEnum.qoeanalytics_clickstream},
                {id: "QoERawClickstream", icon: "rawclickstream", value: LangHelper.GetString("AppView", "Raw clickstream"), href:"#QoERawClickstream", section:RoleSectionsEnum.qoeanalytics_rawclickstream},
                {id: "QoEFullGtpFlow", icon: "broadcast-tower", value: LangHelper.GetString("AppView", "Gtp flow"), section:RoleSectionsEnum.qoeanalytics_gtp},
                {id: "QoERawFullGtpFlow", icon: "broadcast-tower", value: LangHelper.GetString("AppView", "Raw Gtp flow"), href:"#QoERawFullGtpFlow", section:RoleSectionsEnum.qoeanalytics_rawgtp},
                {id: "QoEFullNatFlow", icon: "exchange", value: LangHelper.GetString("AppView", "NAT flow"), href:"#QoEFullNatFlow", section:RoleSectionsEnum.qoeanalytics_nat},
                {id: "QoERawFullNatFlow", icon: "exchange", value: LangHelper.GetString("AppView", "Raw NAT flow"), href:"#QoERawFullNatFlow", section:RoleSectionsEnum.qoeanalytics_rawnat},
                {id: "QoESubscribers", icon: "qoesubscribers", value: LangHelper.GetString("AppView", "Subscribers"), href:"#QoESubscribers", section:RoleSectionsEnum.qoeanalytics_subscribers},
                {id: "QoEOnlineReports", value: LangHelper.GetString("AppView", "Online reports"), href:"#QoEOnlineReports", section:RoleSectionsEnum.qoeanalytics_online_reports},
                {id: "QoETriggers", icon: "bell", value: LangHelper.GetString("AppView", "Triggers & Alerts"), href:"#QoETriggers", section:RoleSectionsEnum.qoeanalytics_triggers},
                {id: "QoEAdmin", icon: "cogs", value: LangHelper.GetString("AppView", "Administrator"), href:"#QoEAdmin", section:RoleSectionsEnum.qoeanalytics_admin}
            ];

            var r = [];

            webix.copy(data).forEach(function (Item, Index)
            {
                if(Item.section && App.SessionManager.CheckUserRoleSection(Item.section))
                {
                    delete Item.href;

                    r.push(Item);
                }
            });

            return r;

        }(),
        on: {
            onMenuItemClick: function (Id)
            {
                var table = _this.Views.ReportsWidgets.IgwsQoEsReport.Views.Table;

                var rowId = table.getSelectedId();

                var data = table.getItem(rowId);

                this.hide();

                if(data && data.dpiui2_dest)
                {
                    var destUrl = data.dpiui2_dest;

                    if(!destUrl.startsWith("https://") || !destUrl.startsWith("http://"))
                        destUrl = "https://" + destUrl;

                    _this.OpenUrlWithPostMethod(destUrl, "#"+Id);
                }
            }
        }

    };
}

UlrIgwsQoEsListViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Views.MonitorSubmenu = webix.ui(this.MonitorSubmenuConfig);
};

UlrIgwsQoEsListViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrIgwsQoEsListViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrIgwsQoEsListViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.IgwsQoEsReport.RefreshData();
};

UlrIgwsQoEsListViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrIgwsQoEsListViewController.prototype.IgwsQoEsReportOnItemClick = function(Id, E, Node)
{
    var _this = this, table, data, node, menu;

    if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
    {
        table = this.Views.ReportsWidgets.IgwsQoEsReport.Views.Table;

        data = table.getItem(Id);

        App.NavRouter.PresentView({id: ControllersEnum.UlrEditIgw, path:"/_id=" + data._id});
    }

    else if (Id.column === 'monitor')
    {
        table = this.Views.ReportsWidgets.IgwsQoEsReport.Views.Table;

        node = table.getItemNode(Id);

        data = table.getItem(Id);

        if(data && data.dpiui2_dest)
        {
            menu = this.Views.MonitorSubmenu;

            menu.show(node);
        }
    }
};

UlrIgwsQoEsListViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrIgwsQoEsListViewController.prototype.OpenUrlWithPostMethod = function(BaseUrl, UrlToRedirect)
{
    var _this = this;

    this.ViewModel.UlrGetTokenForExtAuth
    ({
        callback:function (R)
        {
            if(R.success)
            {
                var form = document.createElement("form");

                form.method = "post";
                form.action = BaseUrl+"/api/token_auth";
                form.target = "_blank";

                var redirectTo = document.createElement("input");
                redirectTo.type = "hidden";
                redirectTo.name= "redirectTo";
                redirectTo.value = UrlToRedirect;
                form.appendChild(redirectTo);

                var token = document.createElement("input");
                token.type = "hidden";
                token.name= "token";
                token.value = R.data.token;
                form.appendChild(token);

                document.body.appendChild(form);

                form.submit();

                document.body.removeChild(form);
            }
        }
    });
};
function UlrWhiteListViewController(Params)
{
    var _this = this;

    this.Id = "UlrWhiteList";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Whitelist"),
        Title:""
    };

    this.ViewModel = new UlrWebIpFilterRulesManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        Widgets:{},
        ReportsWidgets:{
            RulesReport: UrlLastWhitelistEntriesTableWidget({
                id:this.Id + "RulesReport",
                enableTextSearch:true,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.RulesReportOnItemClick(Id, E, Node);
                }
                // ,
                // onCheck:function (Row, Column, State)
                // {
                //     _this.RulesReportOnCheck(Row, Column, State);
                // }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({root_title: this.PageTitle.RootTitle}),
                            {height:32},
                            BlockHeaderTemplate({
                                title:LangHelper.GetString("UlrModule","Last entries in Whitelist register"), icon:"",
                                borderless:true
                            }),
                            {height:20},
                            {
                                view:"template",
                                borderless:false,
                                border:2,
                                css:"form_text_warning_label",
                                height:40,
                                //autoheight:true,
                                template:"<span class='warning'>"+LangHelper.GetString("UlrModule","Warning")+"</span>" + ": " + LangHelper.GetString("UlrModule","This lock all resources except the resources in list below!")
                            },
                            {height:32},
                            this.Views.ReportsWidgets.RulesReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
}

UlrWhiteListViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });
};

UlrWhiteListViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrWhiteListViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrWhiteListViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrWhiteListViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.RulesReport.RefreshData();
};

UlrWhiteListViewController.prototype.RulesReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.RulesReport.Views.Table;

    var data = table.getItem(Id);

    if((Id.column === 'rule_id' && E.target && E.target.className == "webix_cell_link") || Id.column === 'edit')
    {

        App.NavRouter.PresentView({id: ControllersEnum.UlrEditWhiteListRule, path:"/_id=" + data.rule_id});
    }
    else if(Id.column === "resource_raw" && data.type == UlrWebRuleResourcesTypesEnum.ulr_fastresource.toUpperCase() && data.fastresource_config)
    {
        ResourceImportQoEPopupItem({
            cfg: data.fastresource_config
        });
    }

    // if(Id.column === 'delete')
    // {
    //     var table = this.Views.ReportsWidgets.RulesReport.Views.Table;
    //
    //     var data = table.getItem(Id);
    //
    //     var node = table.getItemNode(Id);
    //
    //     UlrShowDialogPopup({
    //         node:node,
    //         position:"bottom",
    //         head:LangHelper.GetString("UlrModule","Delete") + "?",
    //         //type:"spectre-alert-notification",
    //         mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
    //         message:LangHelper.GetString("UlrModule","Are you sure?"),
    //         actions:[
    //             {
    //                 css:"spec_action",
    //                 label:LangHelper.GetString("UlrModule","Cancel")
    //             },
    //             {
    //                 label:LangHelper.GetString("UlrModule","Delete"),
    //                 click:function ()
    //                 {
    //                     _this.ViewModel.DeleteWebRule(data);
    //                 }
    //             }
    //         ]
    //     });
    // }
};
function UlrEditWhiteListRuleViewController(Params)
{
    var params = webix.extend(Params,{
        action:"Edit",
        rule_type:UlrRulesTypesCodesEnum.web_ip_white
    },true);

    UlrEditWhiteListRuleViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrEditWhiteListRuleViewController,UlrEditWebIpFilterRuleViewController);

function UlrAddWhiteListRuleViewController(Params)
{
    var params = webix.extend(Params,{
        action:"Add",
        rule_type:UlrRulesTypesCodesEnum.web_ip_white
    },true);

    UlrAddWhiteListRuleViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrAddWhiteListRuleViewController,UlrEditWebIpFilterRuleViewController);
function UlrWhiteListModeViewController(Params)
{
    var _this = this;

    this.Id = "UlrWhiteListMode";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Whitelist"),
        Title:LangHelper.GetString("UlrModule","Mode")
    };

    this.ViewModel = new UlrWebIpFilterRulesManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        GlobalWhitelistStateToggle:null,

        Widgets:{},
        ReportsWidgets:{
            IspsReport: UrlWhitelistIspsTableWidget({
                id:this.Id + "IspsReport",
                enableTextSearch:true,
                enableAutoHeight:1,
                onCheck:function (Row, Column, State)
                {
                    _this.IspsReportOnCheck(_this.Views.ReportsWidgets.IspsReport.Views.Table, Row, Column, State);
                }
            }),
            SubsReport: UrlWhitelistIspsTableWidget({
                id:this.Id + "SubsReport",
                enableTextSearch:true,
                enableAutoHeight:1,
                isp_type: UlrPolicingTypeEnum.subs,
                onCheck:function (Row, Column, State)
                {
                    _this.IspsReportOnCheck(_this.Views.ReportsWidgets.SubsReport.Views.Table, Row, Column, State);
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({
                                id:this.Id + "PageTitle",
                                root_title:this.PageTitle.RootTitle,
                                title:this.PageTitle.Title
                            }),
                            {height:32},
                            {
                                type: "wide",
                                borderless:true,
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Global Whitelist"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        cols:[
                                            {
                                                borderless:true,
                                                rows:[
                                                    {
                                                        view:"template",
                                                        borderless:true,
                                                        css:"form_text_big_label",
                                                        autoheight:true,
                                                        template:LangHelper.GetString("UlrModule","Set mode for Global Whitelist. It activates all Whitelist rules marked as global.  The Global Whitelist rules applied for all ISPs.")
                                                    },
                                                    {height:20},
                                                    {
                                                        type:"wide",
                                                        cols:[
                                                            {
                                                                view: "label",
                                                                css: "form_element form_text_label",
                                                                label: LangHelper.GetString("UlrModule", "State") + ":",
                                                                autowidth:true
                                                            },
                                                            {
                                                                view:"spectre_toggle",
                                                                id:this.Id + "GlobalWhitelistStateToggle",
                                                                css:"form_element block_header_toggle",
                                                                value:0,
                                                                on:{
                                                                    onChange:function (Nv, Ov)
                                                                    {
                                                                        _this.SaveWhiteListState(Nv);
                                                                    }
                                                                }
                                                            },
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                gravity:1
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height:40},
                            {
                                type: "wide",
                                borderless:true,
                                rows:[
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Whitelist for ISPs"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        cols:[
                                            {
                                                borderless:true,
                                                rows:[
                                                    {
                                                        view:"template",
                                                        borderless:true,
                                                        css:"form_text_big_label",
                                                        autoheight:true,
                                                        template:LangHelper.GetString("UlrModule","Set Whitelist mode for ISPs. If enabled for some ISP the Whitelist rules which connected to ISP will be applied.")
                                                    },
                                                    {height:20},
                                                    this.Views.ReportsWidgets.IspsReport.ViewConfig
                                                ]
                                            },
                                            {
                                                gravity:1
                                            }
                                        ]
                                    },
                                    BlockHeaderTemplate({
                                        title:LangHelper.GetString("UlrModule","Whitelist for subscribers"), icon:"",
                                        borderless:true
                                    }),
                                    {
                                        cols:[
                                            {
                                                borderless:true,
                                                rows:[
                                                    {
                                                        view:"template",
                                                        borderless:true,
                                                        css:"form_text_big_label",
                                                        autoheight:true,
                                                        template:LangHelper.GetString("UlrModule","Set Whitelist mode for subscribers. If enabled for some sibscribers the Whitelist rules which connected to subscriber will be applied.")
                                                    },
                                                    {height:20},
                                                    this.Views.ReportsWidgets.SubsReport.ViewConfig
                                                ]
                                            },
                                            {
                                                gravity:1
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {};
}

UlrWhiteListModeViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.GlobalWhitelistStateError = this.ViewModel.Signals.GlobalWhitelistStateError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.GlobalWhitelistStateSaveError = this.ViewModel.Signals.GlobalWhitelistStateSaveError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.GlobalWhitelistState = this.ViewModel.Signals.GlobalWhitelistState.subscribe(function (State)
    {
        var view = _this.Views.GlobalWhitelistStateToggle;

        view.blockEvent();
        view.setValue(State);
        view.unblockEvent();
    });

    this.Subscriptions.GlobalWhitelistStateSaved = this.ViewModel.Signals.GlobalWhitelistStateSaved.subscribe(function (State)
    {
        if(State != null)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule", "Global Whitelist")+": "+LangHelper.GetString("UlrModule",State ? "Enabled" : "Disabled"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.IspWhitelistStateSaveError = this.ViewModel.Signals.IspWhitelistStateSaveError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.IspWhitelistStateSaved = this.ViewModel.Signals.IspWhitelistStateSaved.subscribe(function (IspModel)
    {
        if(IspModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","ISP Whitelist")+" # "+IspModel.name+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });
};

UlrWhiteListModeViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    this.Refresh();
};

UlrWhiteListModeViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrWhiteListModeViewController.prototype.Refresh = function ()
{
    this.ViewModel.ResfreshGlobalWhiteListState();

    this.Views.ReportsWidgets.IspsReport.RefreshData();

    this.Views.ReportsWidgets.SubsReport.RefreshData();
};

UlrWhiteListModeViewController.prototype.ShowServerError = function(ErrModel, Action)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};

UlrWhiteListModeViewController.prototype.SaveWhiteListState = function(Sate)
{
    this.ViewModel.SaveGlobalWhiteListState({state:Sate});
};

UlrWhiteListModeViewController.prototype.IspsReportOnCheck = function(Table, Row, Column, State)
{
    var data = Table.getItem(Row);

    this.ViewModel.UlrChangeIspWhiteListState(webix.extend(data, {callback:function (R)
        {
            if(!R.success)
            {
                data.white_list_enabled = State ? 0 : 1;

                Table.updateItem(data.id, data);
            }
        }}), State);
};
function UlrIpExcludesRulesViewController(Params)
{
    var params = webix.extend(Params,{
        rule_type:UlrRulesTypesCodesEnum.ip_exclude
    },true);

    UlrIpExcludesRulesViewController.superclass.constructor.call(this, Params);

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","IP & ASN excludes"),
        Title:LangHelper.GetString("UlrModule","IP excludes list")
    };
}

Helper.ExtendClass(UlrIpExcludesRulesViewController,UlrAsnDscpRulesViewController);
function UlrAsnExcludesRulesViewController(Params)
{
    var params = webix.extend(Params,{
        rule_type:UlrRulesTypesCodesEnum.asn_exclude
    },true);

    UlrAsnExcludesRulesViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UlrAsnExcludesRulesViewController,UlrAsnDscpRulesViewController);
function UlrVipSubscribersRulesViewController(Params)
{
    var _this = this;

    this.Id = "UlrVipSubscribersRules";
    this.RootTitle = LangHelper.GetString("UlrModule","IP & ASN excludes");
    this.Title = LangHelper.GetString("UlrModule","VIP subscribers list");
    this.EditFormLabel = LangHelper.GetString("UlrModule", "VIP subscriber [TYPE] is [VALUE].");

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        EditFormLabel: this.EditFormLabel,
        ReportWidget: UrlLastVipSubscribersEntriesTableWidget,
        BlockInfoTemplate: LangHelper.GetString("UlrModule", "Add subscriber`s Login or IP to the list and the traffic for this subscriber will pass without restrictions."),
        BlockWarningTemplate: AppEnv.DisableISPSwitchForVipSubscribers ? "" : LangHelper.GetString("UlrModule","The VIP subscriber`s rule is set globally if no ISPs are specified!"),
        BlockHeaderTemplateTableTitle: LangHelper.GetString("UlrModule","Last entries of VIP subscribers"),
        NotificationTitle: "VIP Subscriber",
        Methods: {
            SaveRule: "UlrSaveVipSubscriberRule",
            DeleteRule: "UlrDeleteVipSubscriberRule",
            EnableRule: "UlrEnableVipSubscriberRule",
            DisableRule: "UlrDisableVipSubscriberRule"
        },
        HideIspsValue: AppEnv.DisableISPSwitchForVipSubscribers ? true : false
    }, true);

    UlrVipSubscribersRulesViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrVipSubscribersRulesViewController, UlrSubscribersRulesViewController);
function UlrDicViewController(Params)
{
    var _this = this;

    this.Dictionary = Params&&Params.dic&&UlrDicsEnum[Params.dic]?UlrDicsEnum[Params.dic]:UlrDicsEnum.Categories;

    this.Id = function (Dictionary)
    {
        var id = "UlrDic";

        if(Dictionary == UlrDicsEnum.Categories)
            id = "UlrCategoriesDic";

        if(Dictionary == UlrDicsEnum.Regulators)
            id = "UlrRegulatorsDic";

        return id;
    }(this.Dictionary);

    this.mode = module ? module : "dpiui2";

    this.PageTitle = function (Dictionary)
    {
        var title =
            {
                RootTitle:LangHelper.GetString("UlrModule","Dictionaries"),
                Title:LangHelper.GetString("UlrModule","Dictionary")
            };

        if(Dictionary == UlrDicsEnum.Categories)
            title =
                {
                    RootTitle:LangHelper.GetString("UlrModule","Dictionaries"),
                    Title:LangHelper.GetString("UlrModule","Categories")
                };

        if(Dictionary == UlrDicsEnum.Regulators)
            title =
                {
                    RootTitle:LangHelper.GetString("UlrModule","Dictionaries"),
                    Title:LangHelper.GetString("UlrModule","Regulators")
                };

        return title;
    }(this.Dictionary);

    this.ViewModel = new UlrDicsManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {

        ScrollView:null,
        PageTitle:null,

        AddForm:null,
        DicItemNameInput:null,
        DicItemDescriptionInput:null,
        AddItemBtn:null,

        EditPopupAddForm:null,
        EditPopupDicItemNameInput:null,
        EditPopupDicItemDescriptionInput:null,
        EditPopupSaveItemBtn:null,

        Widgets:{},
        ReportsWidgets:{
            DicReport:UrlDicTableWidget({
                dic:this.Dictionary,
                id:this.Id + "DicReport",
                enableTextSearch:1,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.DicReportOnItemClick(Id, E, Node);
                }
            })
        }
    };

    this.EditPopup = null;

    this.EditPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        width:400,
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "EditPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","Edit item"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.EditPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "EditPopupAddForm",
                            type: "wide",
                            elements: function ()
                            {
                                var nameInput = {
                                    view:"spectre_text",
                                    id:_this.Id + "EditPopupDicItemNameInput",
                                    name:"name",
                                    label:LangHelper.GetString("UlrModule","Item name"),
                                    required:true,
                                    validate: webix.rules.isNotEmpty,
                                    invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                    on: {
                                        "onChange": function (Nv, Ov)
                                        {
                                            if(Nv != Nv.trim())
                                            {
                                                this.setValue(Nv.trim());
                                                return;
                                            }
                                            this.validate();
                                        }
                                    }
                                };

                                var descriptionInput = {
                                    type: "wide",
                                    cols: [
                                        {
                                            view:"spectre_textarea",
                                            id:_this.Id + "EditPopupDicItemDescriptionInput",
                                            name:"description",
                                            label:LangHelper.GetString("UlrModule","Public description"),
                                            on: {
                                                "onChange": function (Nv, Ov)
                                                {
                                                    if(Nv != Nv.trim())
                                                    {
                                                        this.setValue(Nv.trim());
                                                        return;
                                                    }
                                                }
                                            }
                                        }
                                    ]
                                };

                                var layout = [
                                    {
                                        type:"wide",
                                        cols:[
                                            nameInput
                                        ]
                                    },
                                    descriptionInput
                                ];

                                return layout;
                            }()
                        },
                        {height:20},
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_button",
                                    id:_this.Id + "EditPopupSaveItemBtn",
                                    css:"form_button main_action",
                                    label:LangHelper.GetString("UlrModule","Save item"),
                                    autowidth:true,
                                    click:function ()
                                    {
                                        setTimeout(function () {
                                            _this.SaveEditForm();
                                        },1);

                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            id:this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless: true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({id:this.Id + "PageTitle", root_title: this.PageTitle.Title}),
                            {height:32},
                            {
                                type:"space",
                                css:"form_background",
                                rows:[
                                    {
                                        type:"clean",
                                        borderless:true,
                                        rows:[
                                            BlockHeaderTemplate({
                                                title:LangHelper.GetString("UlrModule","Add new item"), icon:"",
                                                borderless:true
                                            }),
                                            {height:20},
                                            {
                                                view: "form",
                                                id: this.Id + "AddForm",
                                                type: "wide",
                                                elements: function ()
                                                {
                                                    if (Params.layout)
                                                        return Params.layout;

                                                    var nameInput = {
                                                        view:"spectre_text",
                                                        id:_this.Id + "DicItemNameInput",
                                                        name:"name",
                                                        label:LangHelper.GetString("UlrModule","Item name"),
                                                        required:true,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {

                                                                if(Nv != Nv.trim())
                                                                {
                                                                    this.setValue(Nv.trim());
                                                                    return;
                                                                }
                                                                this.validate();
                                                            }
                                                        }
                                                    };

                                                    var descriptionInput = {
                                                        type: "wide",
                                                        cols: [
                                                            {
                                                                view:"spectre_textarea",
                                                                id:_this.Id + "DicItemDescriptionInput",
                                                                name:"description",
                                                                label:LangHelper.GetString("UlrModule","Public description"),
                                                                on: {
                                                                    "onChange": function (Nv, Ov)
                                                                    {
                                                                        if(Nv != Nv.trim())
                                                                        {
                                                                            this.setValue(Nv.trim());
                                                                            return;
                                                                        }
                                                                        this.validate();
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    };

                                                    var layout = [
                                                        {
                                                            type:"wide",
                                                            cols:[
                                                                nameInput
                                                            ]
                                                        },
                                                        descriptionInput
                                                    ];

                                                    return layout;
                                                }()
                                            },
                                            {height:20},
                                            {
                                                type:"wide",
                                                cols:[
                                                    {
                                                        view:"spectre_button",
                                                        id:_this.Id + "AddItemBtn",
                                                        css:"form_button main_action",
                                                        label:LangHelper.GetString("UlrModule","Add item"),
                                                        autowidth:true,
                                                        click:function ()
                                                        {
                                                            setTimeout(function () {
                                                                _this.SaveItem(true);
                                                            },1);

                                                        }
                                                    },
                                                    {}
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height:32},
                            this.Views.ReportsWidgets.DicReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {};
}

UlrDicViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.EditPopup = webix.ui(this.EditPopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });


    this.Subscriptions.DicItemDeleteError = this.ViewModel.Signals.DicItemDeleteError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.DicItemSaveError = this.ViewModel.Signals.DicItemSaveError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.DicItemSaved = this.ViewModel.Signals.DicItemSaved.subscribe(function (DicItemModel)
    {
        if(DicItemModel)
        {
            _this.EditPopup.hide();
            _this.AddOrReplaceDicItemModelInTable(DicItemModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Dic item")+" # "+DicItemModel.name+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.DicItemDeleted = this.ViewModel.Signals.DicItemDeleted.subscribe(function (DicItemModel)
    {
        if(DicItemModel)
        {
            _this.DicReportOnSuccessDelete(DicItemModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Dic item")+" # "+DicItemModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });
};

UlrDicViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrDicViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrDicViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.DicReport.RefreshData();
};

UlrDicViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrDicViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrDicViewController.prototype.SaveItem = function()
{
    this.Views.AddForm.clearValidation();

    if(!this.Views.AddForm.validate())
    {
        return;
    }

    var form = this.Views.AddForm.getValues();

    var model = webix.extend({},form, true);

    if(!model.name)
        return;

    this.ViewModel.SaveItem(this.Dictionary, model);
};

UlrDicViewController.prototype.ShowEditForm = function()
{
    var table = this.Views.ReportsWidgets.DicReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    this.Views.EditPopupAddForm.clear();
    this.Views.EditPopupAddForm.clearValidation();

    this.Views.EditPopupAddForm.setValues(data);

    this.EditPopup.show();
};

UlrDicViewController.prototype.SaveEditForm = function()
{
    var table = this.Views.ReportsWidgets.DicReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    if(!this.Views.EditPopupAddForm.validate())
    {
        return;
    }

    var form = this.Views.EditPopupAddForm.getValues();

    var model = webix.extend({},form, true);

    this.ViewModel.SaveItem(this.Dictionary, model);
};

UlrDicViewController.prototype.AddOrReplaceDicItemModelInTable = function(DicModel)
{
    var table = this.Views.ReportsWidgets.DicReport.Views.Table;

    var model = new UlrDicModel(DicModel);

    var data = table.find(function(obj)
    {
        return obj._id == model._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        table.updateItem(data.id, model);
        table.select(data.id);
    }
    else
    {
        model.id = webix.uid();
        table.add(model,0);
        table.select(model.id);
        table.hideOverlay();
        table.hideProgress();
    }

};

UlrDicViewController.prototype.DicReportOnSuccessDelete = function(DicModel)
{
    var table = this.Views.ReportsWidgets.DicReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == DicModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }

};

UlrDicViewController.prototype.DicReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit')
    {
        _this.ShowEditForm();
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.DicReport.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteItem(_this.Dictionary, data);
                    }
                }
            ]
        });
    }
};
function UrlCategoriesDicViewController(Params)
{
    var params = webix.extend(Params,{
        dic:UlrDicsEnum.Categories
    },true);

    UrlCategoriesDicViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UrlCategoriesDicViewController,UlrDicViewController);
function UlrCustomGroupsOfProtocolsViewController(Params)
{
    var _this = this;

    this.Id = "UlrCustomGroupsOfProtocols";

    this.PageTitle = {
        RootTitle: LangHelper.GetString("UlrModule", "Dictionaries"),
        Title: LangHelper.GetString("UlrModule","Users groups of protocols"),
    };

    this.ViewModel = new UlrCustomGroupsOfProtocolsManager();

    this.ReportsModel = new UniReportsManager();

    this.SelectedGroupModel = null;

    this.Views = {
        SaveGroupBtn: null,
        CancelGroupChangesBtn: null,
        ClearGroupBtn: null,

        GroupAddBtn: null,
        SelectedGroupLabel: null,

        DeleteProtocolArrowBtn: null,
        DeleteAllProtocolsArrowBtn: null,
        AddProtocolArrowBtn: null,
        AddAllProtocolsArrowBtn: null,

        AvailableProtocolsTextSearch: null,
        AvailableProtocolsGroupSelect: null,

        Widgets: {},
        ReportsWidgets: {
            GroupsTable: UlrCustomGroupsTableWidget({
                id: this.Id + "UlrCustomGroupsTable",
                onAfterEditStop: function(state, editor)
                {
                    let item = _this.Views.ReportsWidgets.GroupsTable.Views.Table.getItem(editor.row);

                    if(item._id && (state.old === state.value))
                        return;

                    if(!state.value)
                    {
                        item.name = state.old
                        _this.Views.ReportsWidgets.GroupsTable.Views.Table.updateItem(item);
                    }
                    else if(_this.SelectedGroupModel && (_this.SelectedGroupModel.id === item.id))
                    {
                        _this.SelectedGroupModel.name = item.name;

                        let model = new UlrCustomGroupModel(_this.SelectedGroupModel);
                        model.group_protocols = [];
                        model.view_protocols = [];

                        _this.ViewModel.SaveCustomGroup(_this.SelectedGroupModel);
                    }
                    else
                    {
                        _this.ViewModel.SaveCustomGroup(new UlrCustomGroupModel(item));
                    }
                },
                onItemClick: function(id, e, node)
                {
                    let table = _this.Views.ReportsWidgets.GroupsTable.Views.Table;

                    let activeEditor = table.getEditState();

                    table.editStop();

                    if(activeEditor && (activeEditor.row === id.row))
                    {
                        return;
                    }

                    if(id.column === "edit")
                    {
                        table.editRow(id.row);
                        table.getEditState().getInputNode().select();
                    }
                    else if(id.column === "delete")
                    {
                        _this.ShowDeletePopup(id.row, node)
                    }
                },
            }),
            GroupProtocolsTable: UlrCustomGroupsProtocolsTableWidget({
                id: this.Id + "GroupProtocolsTable",
                enableTextSearch: true,
                arrow_direction: "to_right",
                enableLocalDataSource: true,
                dataSource: function(FilterParams)
                {
                    return _this.DataSourceFunc(
                        FilterParams,
                        (_this.SelectedGroupModel ? _this.SelectedGroupModel.view_protocols : [])
                    );
                },
                onItemClick: function(id, e, node)
                {
                    if(id.column === "to_right")
                    {
                        let item = _this.Views.ReportsWidgets.GroupProtocolsTable.Views.Table.getItem(id.row)
                        _this.DeleteProtocolsFromGroup([item]);
                    }
                }
            }),
            AvailableProtocolsTable: UlrCustomGroupsProtocolsTableWidget({
                id: this.Id + "AvailableProtocolsTable",
                arrow_direction: "to_left",
                onItemClick: function(id, e, node)
                {
                    if(id.column === "to_left")
                    {
                        let item = _this.Views.ReportsWidgets.AvailableProtocolsTable.Views.Table.getItem(id.row)
                        _this.AddProtocolsToGroup([item]);
                    }
                }
            })
        }
    };

    this.ViewConfig = [
        {
            type: "space",
            rows: [
                {
                    type: "clear",
                    borderless: true,
                    rows:[
                        { height: 6 },
                        PageHeaderTemplate({id:this.Id + "PageTitle", root_title:this.PageTitle.Title}),
                        { height: 32 },
                        {
                            cols: [
                                {
                                    minWidth: 250,
                                    maxWidth: 550,
                                    width: 250,
                                    rows: [
                                        {
                                            view: "toolbar",
                                            elements: [
                                                {},
                                                {
                                                    view: "button",
                                                    id: this.Id + "GroupAddBtn",
                                                    type: "icon",
                                                    icon: "plus",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("UlrModule", "Add group"),
                                                    click: function (id, e, node) {
                                                        let table = _this.Views.ReportsWidgets.GroupsTable.Views.Table;

                                                        table.hideOverlay();
                                                        table.editStop();

                                                        let rowId = table.add(new UlrCustomGroupModel(
                                                            new UlrCustomGroupModel({name:LangHelper.GetString("UlrModule", "New Group")})
                                                        ), 0);

                                                        table.editRow(rowId);
                                                        table.getEditState().getInputNode().select();
                                                    }
                                                }
                                            ]
                                        },
                                        this.Views.ReportsWidgets.GroupsTable.ViewConfig
                                    ]
                                },
                                { view: "resizer" },
                                {
                                    rows: [
                                        {
                                            cols: [
                                                // Group protocols
                                                {
                                                    rows: [
                                                        {
                                                            view: "toolbar",
                                                            elements: [
                                                                { width: 6 },
                                                                {
                                                                    view: "label",
                                                                    id: this.Id + "SelectedGroupLabel",
                                                                    height: 30,
                                                                }
                                                            ]
                                                        },
                                                        this.Views.ReportsWidgets.GroupProtocolsTable.ViewConfig,
                                                    ]
                                                },
                                                // { width: 10 },
                                                // control buttons
                                                {
                                                    borderless:false,
                                                    rows: [
                                                        {
                                                            borderless:false,
                                                            height:1
                                                        },
                                                        {},
                                                        {
                                                            cols:[
                                                                { width: 10 },
                                                                {
                                                                    rows:[
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "AddProtocolArrowBtn",
                                                                            type: "icon",
                                                                            icon: "angle-left",
                                                                            width: 50,
                                                                            height: 50,
                                                                            css: "form_button spec_action",
                                                                            click: function () {
                                                                                let selectedItems = _this.Views.ReportsWidgets.AvailableProtocolsTable.Views.Table.getSelectedItem(true);
                                                                                _this.AddProtocolsToGroup(selectedItems);
                                                                            }
                                                                        },
                                                                        { height: 10 },
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "AddAllProtocolsArrowBtn",
                                                                            type: "icon",
                                                                            icon: "angle-double-left",
                                                                            width: 50,
                                                                            height: 50,
                                                                            css: "form_button spec_action",
                                                                            click: function () {
                                                                                let items = _this.Views.ReportsWidgets.AvailableProtocolsTable.Views.Table.serialize();
                                                                                _this.AddProtocolsToGroup(items);
                                                                            }
                                                                        },
                                                                        { height: 10 },
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "DeleteAllProtocolsArrowBtn",
                                                                            type: "icon",
                                                                            icon: "angle-double-right",
                                                                            width: 50,
                                                                            height: 50,
                                                                            css: "form_button spec_action",
                                                                            click: function () {
                                                                                let items = _this.Views.ReportsWidgets.GroupProtocolsTable.Views.Table.serialize();
                                                                                _this.DeleteProtocolsFromGroup(items);
                                                                            }
                                                                        },
                                                                        { height: 10 },
                                                                        {
                                                                            view: "spectre_button",
                                                                            id: this.Id + "DeleteProtocolArrowBtn",
                                                                            type: "icon",
                                                                            icon: "angle-right",
                                                                            width: 50,
                                                                            height: 50,
                                                                            css: "form_button spec_action",
                                                                            click: function () {
                                                                                let selectedItems = _this.Views.ReportsWidgets.GroupProtocolsTable.Views.Table.getSelectedItem(true);
                                                                                _this.DeleteProtocolsFromGroup(selectedItems);
                                                                            }
                                                                        },
                                                                    ]
                                                                },
                                                                { width: 10 },
                                                            ]
                                                        },
                                                        {},
                                                        {
                                                            borderless:false,
                                                            height:1
                                                        }
                                                    ]
                                                },
                                                // { width: 10 },
                                                // available protocols
                                                {
                                                    rows: [
                                                        {
                                                            view: "toolbar",
                                                            elements: [
                                                                { width: 6 },
                                                                {
                                                                    view: "label",
                                                                    id: this.Id + "AvailableProtocolsLabel",
                                                                    height: 30,
                                                                    label: LangHelper.GetString("UlrModule", "Available protocols")
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            css: "datatable_toolbar",
                                                            cols: [
                                                                {
                                                                    css: "datatable_search_icon",
                                                                    template: '<span class="webix_icon fa-filter"></span>',
                                                                    width: 40,
                                                                    borderless: true
                                                                },
                                                                {
                                                                    view: "text",
                                                                    css: "datatable_search_input",
                                                                    placeholder: LangHelper.GetString("UlrModule", "Filter"),
                                                                    disabled: true
                                                                },
                                                                {
                                                                    view: "text",
                                                                    id: this.Id + "AvailableProtocolsTextSearch",
                                                                    placeholder: LangHelper.GetString("UlrModule","by name"),
                                                                },
                                                                {
                                                                    view: "richselect",
                                                                    id: this.Id + "AvailableProtocolsGroupSelect",
                                                                    placeholder: LangHelper.GetString("UlrModule","by group"),
                                                                },
                                                            ]
                                                        },
                                                        this.Views.ReportsWidgets.AvailableProtocolsTable.ViewConfig,
                                                    ]
                                                },
                                            ]
                                        },
                                        // Save Clear buttons
                                        {
                                            type: "space",
                                            cols: [
                                                {
                                                    view: "spectre_button",
                                                    id: this.Id + "SaveGroupBtn",
                                                    css:"form_button main_action",
                                                    label: LangHelper.GetString("UlrModule","Save changes"),
                                                    autowidth: true,
                                                    disabled: true,
                                                    click: function () {
                                                        if(_this.SelectedGroupModel)
                                                        {
                                                            _this.SaveGroup(_this.SelectedGroupModel);
                                                        }
                                                    }
                                                },
                                                {
                                                    view: "spectre_button",
                                                    id: this.Id + "CancelGroupChangesBtn",
                                                    css: "form_button spec_action",
                                                    label: LangHelper.GetString("UlrModule","Cancel changes"),
                                                    autowidth: true,
                                                    disabled: true,
                                                    click: function () {
                                                        _this.CancelGroupChanges();
                                                    }
                                                },
                                                {
                                                    view: "spectre_button",
                                                    id: this.Id + "ClearGroupBtn",
                                                    css: "form_button spec_action",
                                                    label: LangHelper.GetString("UlrModule","Clear all"),
                                                    autowidth: true,
                                                    click:function () {
                                                        _this.ClearGroup();
                                                    }
                                                },
                                                {},
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Subscriptions = {};
};

UlrCustomGroupsOfProtocolsViewController.prototype.BindAll = function (Params)
{
    let _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if (View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if (w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if (w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.SignalDicProtocolsGroupsUpdatedSubscription = App.DicsManager.Signal[DicsEnum.ProtocolsGroupsDic].subscribe(function(Updated)
    {
        if(Updated)
        {
            let dic = App.DicsManager.GetDicAsArray(DicsEnum.ProtocolsGroupsDic);

            dic = dic.sort(function(a,b){
                return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
            });

            dic.splice(0,0, {dic_id: "", id: "", value: "", $empty:true});

            _this.Views.AvailableProtocolsGroupSelect.define("suggest", {fitMaster: false, data: dic});
            _this.Views.AvailableProtocolsGroupSelect.refresh();
        }
    });

    this.Subscriptions.GroupTableDataSignalUpdated = this.ReportsModel.GetReportConfig(this.Views.ReportsWidgets.GroupsTable.Id).signal.subscribe(function (Updated)
    {
        if(Updated)
        {
            let firstRowId = _this.Views.ReportsWidgets.GroupsTable.Views.Table.getFirstId();

            if(firstRowId && !_this.SelectedGroupModel)
            {
                _this.Views.ReportsWidgets.GroupsTable.Views.Table.select(firstRowId);
            }
        }
    });

    this.Subscriptions.ServerError = this.ViewModel.Signals.ServerError.subscribe(function (Update)
    {
        if(Update)
        {
            _this.ShowErrorMsgProcess("Server error.");
        }
    });

    this.Subscriptions.SaveCustomGroupSuccess = this.ViewModel.Signals.SaveCustomGroupSuccess.subscribe(function(Model)
    {
        if(Model)
        {
            if(_this.SelectedGroupModel && (_this.SelectedGroupModel.id === Model.id))
            {
                if(_this.Views.SaveGroupBtn.isEnabled())
                {
                    _this.SelectedGroupModel.name = Model.name;
                    _this.Views.SelectedGroupLabel.setValue(_this.SelectedGroupModel.name);
                }
                else
                {
                    _this.SelectedGroupModel = Model;
                    _this.UpdateProtocolTables();
                }
            }

            if(_this.Views.ReportsWidgets.GroupsTable.Views.Table.getItem(Model.id))
            {
                _this.Views.ReportsWidgets.GroupsTable.Views.Table.updateItem(Model.id, Model);
            }

            if(!_this.Views.SaveGroupBtn.isEnabled() && (!_this.SelectedGroupModel || (_this.SelectedGroupModel.id !== Model.id)))
            {
                _this.Views.ReportsWidgets.GroupsTable.Views.Table.select(Model.id);
            }

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Success"),
                LangHelper.GetString("UlrModule","Group saved successfully."),
            );
        }
    });

    this.Subscriptions.SaveCustomGroupError = this.ViewModel.Signals.SaveCustomGroupError.subscribe(function(Update)
    {
        if(Update)
        {
            _this.ShowErrorMsgProcess("Group not saved.");
        }
    });

    this.Subscriptions.DeleteCustomGroupSuccess = this.ViewModel.Signals.DeleteCustomGroupSuccess.subscribe(function(GroupModel)
    {
        if(GroupModel)
        {
            let table = _this.Views.ReportsWidgets.GroupsTable.Views.Table;

            let prevRowId = table.getPrevId(GroupModel.id);
            let nextRowId = table.getNextId(GroupModel.id);

            if(table.getItem(GroupModel.id))
            {
                table.remove(GroupModel.id);

                if(!table.getSelectedItem())
                {
                    if(nextRowId)
                    {
                        table.select(nextRowId);
                    }
                    else if(prevRowId)
                    {
                        table.select(prevRowId);
                    }
                    else
                    {
                        _this.SelectedGroupModel = null;
                        _this.UpdateProtocolTables();
                    }
                }
            }

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Success"),
                LangHelper.GetString("UlrModule","Group deleted successfully."),
            );
        }
    });

    this.Subscriptions.DeleteCustomGroupError = this.ViewModel.Signals.DeleteCustomGroupError.subscribe(function(Update)
    {
        if(Update)
        {
            _this.ShowErrorMsgProcess("Group not deleted.");
        }
    });

    this.Subscriptions.GetProtocolsByCustomGroupSuccess = this.ViewModel.Signals.GetProtocolsByCustomGroupSuccess.subscribe(function (GroupModel)
    {
        if(GroupModel && _this.SelectedGroupModel && (_this.SelectedGroupModel.id === GroupModel.id))
        {
            _this.SelectedGroupModel = GroupModel;
            _this.UpdateProtocolTables();
        }
    });

    this.Subscriptions.GetProtocolsByCustomGroupError = this.ViewModel.Signals.GetProtocolsByCustomGroupError.subscribe(function (Update)
    {
        if(Update)
        {
            _this.ShowErrorMsgProcess("Error loading custom group protocol list.");
        }
    });

    this.Views.ReportsWidgets.GroupsTable.Views.Table.attachEvent("onBeforeSelect", function(selection)
    {
        if(selection.column === "delete" || selection.column === "edit")
            return false;

        if(_this.ViewModel.Signals.Progress.getValue())
            return false;

        if(_this.SelectedGroupModel && (_this.SelectedGroupModel !== selection.row))
        {
            if(_this.Views.SaveGroupBtn.isEnabled())
            {
                _this.ShowSelectGroupPopup();
                return false;
            }
        }
    });

    this.Views.ReportsWidgets.GroupsTable.Views.Table.attachEvent("onAfterSelect", function(selection)
    {
        let item = _this.Views.ReportsWidgets.GroupsTable.Views.Table.getItem(selection.row);

        _this.SelectedGroupModel = new UlrCustomGroupModel(item);
        _this.ViewModel.GetProtocolsByCustomGroup(_this.SelectedGroupModel);
    });

    this.Views.ReportsWidgets.AvailableProtocolsTable.Views.Table.attachEvent("onBeforeDrag", function(context, e)
    {
        if(_this.ViewModel.Signals.Progress.getValue())
            return false;
    });

    this.Views.ReportsWidgets.GroupProtocolsTable.Views.Table.attachEvent("onBeforeDrag", function(context, e)
    {
        if(_this.ViewModel.Signals.Progress.getValue())
            return false;
    });

    this.Views.ReportsWidgets.AvailableProtocolsTable.Views.Table.attachEvent("onBeforeDrop", function(context, e)
    {
        _this.MoveTableItems(context);
        return false;
    });

    this.Views.ReportsWidgets.GroupProtocolsTable.Views.Table.attachEvent("onBeforeDrop", function(context, e)
    {
        _this.MoveTableItems(context);
        return false;
    });

    this.Views.AvailableProtocolsTextSearch.attachEvent("onTimedKeyPress", function()
    {
        _this.UpdateAvailableProtocolsTable();
    });

    this.Views.AvailableProtocolsGroupSelect.attachEvent("onChange", function ()
    {
        _this.UpdateAvailableProtocolsTable();
    });

    this.Views.ReportsWidgets.GroupsTable.RefreshData();
    this.UpdateProtocolTables();
};

UlrCustomGroupsOfProtocolsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);
};

UlrCustomGroupsOfProtocolsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key) {
        if (_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget) {
        var w = _this.Views.Widgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget) {
        var w = _this.Views.ReportsWidgets[Widget];
        if (w.Destroy)
            w.Destroy();
    });

    if (this.ViewModel) {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if (this.ReportsModel) {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrCustomGroupsOfProtocolsViewController.prototype.GetPageTitle = function ()
{
    if (this.PageTitle)
        return this.PageTitle;
};

UlrCustomGroupsOfProtocolsViewController.prototype.DataSourceFunc = function(FilterParams, DataSource)
{
    let _this = this;

    let res = {
        count: DataSource.length,
        page: FilterParams.Params.page,
        size: FilterParams.Params.size,
        rows: []
    };

    let sort_prop = FilterParams.Params.sort.id ? FilterParams.Params.sort.id : null;
    let sort_dir = FilterParams.Params.sort.dir ? FilterParams.Params.sort.dir : "desc";

    let sort_val = sort_dir === "asc" ? 1 : -1;

    if(sort_prop)
    {
        DataSource.sort((a, b) => {
            let val_a = a[sort_prop];
            let val_b = b[sort_prop];

            if(typeof val_a == 'string' || typeof val_b == 'string') {
                if(sort_val > 0) {
                    return (a[sort_prop] + '').localeCompare(b[sort_prop] + '');
                } else {
                    return (b[sort_prop] + '').localeCompare(a[sort_prop] + '');
                }
            } else if(typeof val_a == 'number' || typeof val_b == 'number') {
                return sort_val * val_a + (-1) * sort_val * val_b;
            }

            return -1;
        });
    }

    res.rows = DataSource.slice();

    if
    (
        FilterParams.Params.filter &&
        FilterParams.Params.filter.full_text_search &&
        FilterParams.Params.filter.full_text_search.value
    )
    {
        res.rows = DataSource.filter(item => {
            return item.full_text_search.includes(FilterParams.Params.filter.full_text_search.value);
        });
    }

    const start_index = res.page * res.size;
    let finish_index = start_index + res.size;

    if(finish_index > (DataSource.length - 1)) {
        res.rows = res.rows.slice(start_index);
    } else {
        res.rows = res.rows.slice(start_index, finish_index);
    }

    if(res.page > 0 && res.rows.length === 0)
    {
        FilterParams.Params.page--
        res = this.DataSourceFunc(FilterParams, DataSource)
    }

    return res;
};

UlrCustomGroupsOfProtocolsViewController.prototype.SaveGroup = function(GroupModel)
{
    this.Views.SaveGroupBtn.disable();
    this.Views.CancelGroupChangesBtn.disable();
    this.ViewModel.SaveCustomGroup(GroupModel);
}

UlrCustomGroupsOfProtocolsViewController.prototype.DeleteGroup = function(GroupModel)
{
    this.Views.SaveGroupBtn.disable();
    this.Views.CancelGroupChangesBtn.disable();
    this.ViewModel.DeleteCustomGroup(GroupModel);
}

UlrCustomGroupsOfProtocolsViewController.prototype.UpdateProtocolTables = function()
{
    this.Views.ReportsWidgets.GroupProtocolsTable.RefreshData();
    this.UpdateAvailableProtocolsTable();
    this.Views.SelectedGroupLabel.setValue((this.SelectedGroupModel ? this.SelectedGroupModel.name : ""));
    this.DefineSaveCancelBtns();
};

UlrCustomGroupsOfProtocolsViewController.prototype.UpdateAvailableProtocolsTable = function ()
{
    let filter = {};

    let textSearchVal = this.Views.AvailableProtocolsTextSearch.getValue();
    let groupSelectVal = this.Views.AvailableProtocolsGroupSelect.getValue();
    let config = this.Views.ReportsWidgets.AvailableProtocolsTable.GetReportConfig();
    let page = config.data && config.data.page ? config.data.page : 0;

    if(textSearchVal)
    {
        filter.full_text_search = {
            id:"full_text_search",
            operator:"like",
            value:textSearchVal
        }
    }

    if(groupSelectVal)
    {
        filter.group_id = {
            id:"group_id",
            operator:"=",
            value:groupSelectVal
        }
    }

    if(this.SelectedGroupModel)
    {
        filter._id = {
            id:"_id",
            operator:"not in",
            value:this.SelectedGroupModel.view_protocols.map(item => item._id)
        }
    }

    this.Views.ReportsWidgets.AvailableProtocolsTable.RefreshData(page, {filter:filter})
};

UlrCustomGroupsOfProtocolsViewController.prototype.DefineSaveCancelBtns = function()
{
    if(this.SelectedGroupModel && this.SelectedGroupModel.IsChanged())
    {
        this.Views.SaveGroupBtn.enable();
        this.Views.CancelGroupChangesBtn.enable();
    }
    else
    {
        this.Views.SaveGroupBtn.disable();
        this.Views.CancelGroupChangesBtn.disable();
    }
};

UlrCustomGroupsOfProtocolsViewController.prototype.MoveTableItems = function(Context)
{
    if(Context.from === Context.to)
        return;

    let itemsToMove = [];

    Context.source.forEach(rowId => {
        itemsToMove.push(Context.from.getItem(rowId));
    });

    switch (Context.to.config.id)
    {
        case this.Views.ReportsWidgets.GroupProtocolsTable.Views.Table.config.id:
            this.AddProtocolsToGroup(itemsToMove);
            break;
        case this.Views.ReportsWidgets.AvailableProtocolsTable.Views.Table.config.id:
            this.DeleteProtocolsFromGroup(itemsToMove);
            break;
        default:
            UlrShowMessage(
                "error",
                LangHelper.GetString("UlrModule","Error")
            );
    }
};

UlrCustomGroupsOfProtocolsViewController.prototype.AddProtocolsToGroup = function(ModelsArr)
{
    if(ModelsArr && !this.ViewModel.Signals.Progress.getValue())
    {
        if(this.SelectedGroupModel)
        {
            if(this.SelectedGroupModel && ModelsArr.length)
            {
                let existProtocolsIds = this.SelectedGroupModel.view_protocols.map(model => model.name);

                for (let model of ModelsArr)
                {
                    if(!existProtocolsIds.includes(model.name))
                    {
                        this.SelectedGroupModel.view_protocols.push(model);
                    }
                }
                this.UpdateProtocolTables();
            }
            else
            {
                UlrShowMessage(
                    "info",
                    null,
                    LangHelper.GetString("UlrModule","To add protocols to group, select available protocols.")
                );
            }
        }
        else
        {
            UlrShowMessage(
                "info",
                null,
                LangHelper.GetString("UlrModule","To edit custom group protocol list, select or create a group.")
            );
        }
    }
};

UlrCustomGroupsOfProtocolsViewController.prototype.DeleteProtocolsFromGroup = function(ModelsArr)
{
    if(ModelsArr && !this.ViewModel.Signals.Progress.getValue())
    {
        if(ModelsArr.length)
        {
            if(this.SelectedGroupModel)
            {
                let deleteIdsArr = ModelsArr.map(model => model.name);

                this.SelectedGroupModel.view_protocols = this.SelectedGroupModel.view_protocols.filter(model => !deleteIdsArr.includes(model.name));
                this.UpdateProtocolTables();
            }
        }
        else
        {
            UlrShowMessage(
                "info",
                null,
                LangHelper.GetString("UlrModule","To remove protocols from a group, select protocols from a custom group.")
            );
        }
    }
};

UlrCustomGroupsOfProtocolsViewController.prototype.CancelGroupChanges = function()
{
    if(this.SelectedGroupModel)
    {
        if(this.SelectedGroupModel.group_protocols.length)
        {
            this.ViewModel.GetProtocolsByCustomGroup(this.SelectedGroupModel);
        }
        else
        {
            this.SelectedGroupModel.view_protocols = [];
            this.UpdateProtocolTables();
        }
    }
}

UlrCustomGroupsOfProtocolsViewController.prototype.ClearGroup = function()
{
    if(this.SelectedGroupModel && this.SelectedGroupModel.view_protocols.length)
    {
        this.SelectedGroupModel.view_protocols = [];
        this.UpdateProtocolTables();
    }
};

UlrCustomGroupsOfProtocolsViewController.prototype.ShowErrorMsgProcess = function(Msg = "")
{
    this.SelectedGroupModel = null;
    this.Views.ReportsWidgets.GroupsTable.RefreshData();
    this.UpdateProtocolTables();

    UlrShowMessage(
        "error",
        LangHelper.GetString("UlrModule","Error"),
        LangHelper.GetString("UlrModule",Msg),
    );
}

UlrCustomGroupsOfProtocolsViewController.prototype.ShowDeletePopup = function(rowId, Node)
{
    let _this = this;

    let item = _this.Views.ReportsWidgets.GroupsTable.Views.Table.getItem(rowId);
    let model = new UlrCustomGroupModel(item);

    UlrShowDialogPopup({
        node:Node,
        position:"right",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    _this.DeleteGroup(model);
                }
            }
        ]
    });
};

UlrCustomGroupsOfProtocolsViewController.prototype.ShowSelectGroupPopup = function()
{
    let _this = this;

    let table = this.Views.ReportsWidgets.GroupsTable.Views.Table;
    let node = table.getItemNode(table.getSelectedId());

    UlrShowDialogPopup({
        node:node,
        position:"right",
        head:LangHelper.GetString("UlrModule","Save") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Save") + "?",
        message:LangHelper.GetString("UlrModule","The group has not been saved. Save current group?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel"),
            },
            {
                label:LangHelper.GetString("UlrModule","Save"),
                click:function ()
                {
                    _this.SaveGroup(_this.SelectedGroupModel);
                }
            }
        ]
    });
};
function UrlRegulatorsDicViewController(Params)
{
    var params = webix.extend(Params,{
        dic:UlrDicsEnum.Regulators
    },true);

    UrlRegulatorsDicViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(UrlRegulatorsDicViewController,UlrDicViewController);
function UlrPolicingsTemplatesViewController(Params)
{
    var _this = this;

    this.Id = Params && Params.id ? Params.id : "UlrSessionPolicingsTemplates";

    this.ViewModel = new UlrIspSessionPolicingsManager();

    this.ReportsModel = new UniReportsManager();

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Dictionaries"),
        Title:Params && Params.pageTitle ? Params.pageTitle : LangHelper.GetString("UlrModule","Session policing templates")
    };

    this.TemplateType = Params && Params.templateType ? Params.templateType : UlrPolicingTemplatesTypesDic.session.id;
    this.EditPath = Params && Params.editPath ? Params.editPath : ControllersEnum.UlrEditSessionPolicingTemplate;

    var tableReportParams = {
        id: this.Id + "TableReport",
        enableTextSearch: 1,
        enableAutoHeight: 1,
        onItemClick: function(Id, E, Node)
        {
            _this.OnItemClick(Id, E, Node)
        }
    };
    this.Views = {
        ScrollView: null,
        Widgets: {},
        ReportsWidgets: {
            TableReport: Params && Params.tableReport ? Params.tableReport(tableReportParams) : null
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            id: this.Id + "ScrollView",
            scroll: "y",
            body: {
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height: 6},
                            PageHeaderTemplate({id:this.Id + "PageTitle", root_title: this.PageTitle.Title}),
                            {height: 32},
                            {
                                view: "template",
                                borderless:true,
                                css: "form_text_big_label",
                                autoheight:true,
                                template: Params && Params.pageDescription ? Params.pageDescription : LangHelper.GetString("UlrModule","List of session policings profiles templates"),
                            },
                            {height: 32},
                            this.Views.ReportsWidgets.TableReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
    this.Signals = {};
}

UlrPolicingsTemplatesViewController.prototype.Destroy = function()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrPolicingsTemplatesViewController.prototype.ViewDidLoad = function(Params)
{
    this.BindAll();

    this.Refresh();
};

UlrPolicingsTemplatesViewController.prototype.BindAll = function ()
{
    var _this = this;

    Object.keys(this.Views).forEach(function(View){
        if(View != "Widgets" && View != "ReportsWidgets")
        {
            _this.Views[View] = $$(_this.Id + View);
        }
        else
        {
            Object.keys(_this.Views[View]).forEach(function(WidgetKey){
                var w = _this.Views[View][WidgetKey];

                var vmodel = View == "Widgets" ? _this.ViewModel : _this.ReportsModel;
                if(w.BindAll)
                    w.BindAll(_this, vmodel);

                if(w.Bind)
                    w.Bind(_this, vmodel);
            });
        }
    });

    this.Subscriptions.TemplateDeleted = this.ViewModel.Signals.PolicingProfileDeleted.subscribe(function (TemplateModel)
    {
        if(TemplateModel)
        {

            var table = _this.Views.ReportsWidgets.TableReport.Views.Table;

            var data = table.find(function(obj){
                return obj._id == TemplateModel._id;
            });

            if(data && data.length == 1 && data[0].id)
            {
                table.remove(data[0].id);

                if(!table.count())
                    _this.Refresh();
            }

            var msg = _this.TemplateType == UlrPolicingTemplatesTypesDic.session.id ? "Session policing template" : "Policing template";

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule",msg) + " # "+TemplateModel.title + ": " + LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });
};

UlrPolicingsTemplatesViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.TableReport.RefreshData();
};

UlrPolicingsTemplatesViewController.prototype.OnItemClick = function(Id, E, Node)
{
    var _this = this;
    if(Id.column === 'edit' || Id.column === "_id" || Id.column == "title" || Id.column === "delete")
    {
        var item = this.Views.ReportsWidgets.TableReport.Views.Table.getItem(Id);

        if(Id.column === 'edit' || Id.column === "_id" || Id.column == "title")
        {
            App.NavRouter.PresentView({id: _this.EditPath, path:"/_id=" + item._id});
        }
        else if(Id.column === "delete")
        {
            var node = this.Views.ReportsWidgets.TableReport.Views.Table.getItemNode(Id);

            UlrShowDialogPopup({
                node:node,
                position:"bottom",
                head:LangHelper.GetString("UlrModule","Delete") + "?",
                //type:"spectre-alert-notification",
                mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
                message:LangHelper.GetString("UlrModule","Are you sure?"),
                actions:[
                    {
                        css:"spec_action",
                        label:LangHelper.GetString("UlrModule","Cancel")
                    },
                    {
                        label:LangHelper.GetString("UlrModule","Delete"),
                        click:function ()
                        {
                            _this.ViewModel.DeleteTemplate(item);
                        }
                    }
                ]
            });
        }
    }
};

UlrPolicingsTemplatesViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};
function UlrSessionPolicingsTemplatesViewController(Params)
{
    var params = webix.extend(Params, {
        Id: "UlrSessionPolicingsTemplates",
        pageTitle: LangHelper.GetString("UlrModule", "Session policings templates"),
        tableReport: UlrSessionPolicingsTemplatesTableWidget,
        pageDescription: LangHelper.GetString("UlrModule","List of session policings templates"),
        templateType: UlrPolicingTemplatesTypesDic.session.id,
        editPath: ControllersEnum.UlrEditSessionPolicingTemplate
    }, true);

    UlrSessionPolicingsTemplatesViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrSessionPolicingsTemplatesViewController, UlrPolicingsTemplatesViewController);
function UlrEditSessionPolicingTemplateViewController(Params)
{
    this.Id = "UlrEditSessionPolicingTemplate";
    this.RootTitle = LangHelper.GetString("UlrModule", "Dictionaries");
    this.Title = LangHelper.GetString("UlrModule", "Edit session policing template");

    var params = webix.extend(Params, {
        Id: this.Id,
        RootTitle: this.RootTitle,
        Title: this.Title,
        HideEditLabel: true,
        ListSection: ControllersEnum.UlrSessionPolicingsTemplates,
        BlockInfoTemplate: LangHelper.GetString("UlrModule", "SESSION_POLICING_TEMPLATE_DESCRIPTION"),
        IsTemplate: true,
        TemplateType: UlrPolicingTemplatesTypesDic.session.id
    }, true);

    UlrEditSessionPolicingTemplateViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrEditSessionPolicingTemplateViewController, UlrEditSessionPolicingViewController);

function UlrAddSessionPolicingTemplateViewController(Params)
{
    UlrAddSessionPolicingTemplateViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddSessionPolicingTemplateViewController, UlrEditSessionPolicingTemplateViewController);
function UlrEditMailingViewController() {
    var _this = this;

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.group_ids = null;

    this.Action = this.ActionsEnum.Edit;

    this.Id = "UlrEditMailing";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Mailing"),
        Title:LangHelper.GetString("UlrModule","Edit mailing")
    };

    this.ViewModel = new UlrMailingManager();

    this.ReportsModel = new UniReportsManager();

    this.ActionParamsContextId = this.Id + "ActionParamsContext";

    this.ActionParamsContext = webix.ui({
        view: "popup",
        id:this.ActionParamsContextId ,
        maxWidth: 800,
        maxHeight: 680,
        body: {
            rows:[
                {
                    borderless:true,
                    height: 80,
                    template:LangHelper.GetString("QoE", "Select one or more identifiers (via shift or ctr). Use ctrl + c to copy and ctrl + v to insert a message into the template.")
                },
                {
                    borderless:true,
                    id:this.ActionParamsContextId + "Table",
                    name: "headers",
                    view: "datatable",
                    select:"cell",
                    multiselect:true,
                    clipboard:"selection",
                    resizeColumn:true,
                    tooltip:true,
                    // scroll:true,
                    checkboxRefresh:true,
                    height:560,
                    // autoheight:true,
                    columns:
                        [
                            {
                                id: "id",
                                header: [TooltipTemplate(LangHelper.GetString("QoE", "Id"))],
                                fillspace: 2
                            },
                            {
                                id: "value",
                                header: [TooltipTemplate(LangHelper.GetString("QoE", "Value"))],
                                fillspace: 3
                            }
                        ],
                    data:Helper.DictToArr(QoETriggerAlertActionBodyTemplateParametersDic)
                }
            ]
        }
    });

    this.Views = {
        QueriesTableForm: null,
        ReportRichSelect: null,
        EditMailTemplateInput: null,
        RecipientGroupRichSelect: null,
        MailingEditFormEnabledSpacerView: null,
        MailingEditFormEnabledStateView: null,
        MailingEditForm: null,
        MailingTemplateEditorPopup: null,
        DeleteBtn:null,
        SaveEnableBtn: null,
        SaveBtn: null,
        SaveDisableBtn: null,
        PageTitle:null,
        AddRecipientGroupBtn:null,
        QueriesTable: new QueriesTableViewController({
            exceptWidgetCodes: ExceptWidgetCodes.panels_maps
        }),
        DateTimePicker: new DatetimePickerViewController(),
        WidgetsSuggest: new QoEWidgetsSuggestWidget({
            id:this.Id + "WidgetsSuggest",
            exceptWidgetCodes: ExceptWidgetCodes.panels_maps
        }),
        ExtendedFillter: new QoEPopupFilterWidget({
            id:this.Id + "ExtendedFillter",
            config:QoEPopupFilterWidgetDefaultConfig()
        }),
        Widgets: {},
        ReportsWidgets:{
            RecipientGroupReport: UlrRecipientGroupTableWidget({
                id:this.Id + "RecipientGroupReport",
                enableAutoHeight:1,
                enableLocalSort:1,
                hidePaginatorToolbar:1,
                enableLocalDataSource:1,
                dataSource:function (FilterParams)
                {
                    return _this.RecipientGroupDataSource(FilterParams);
                },
                onItemClick:function (Id, E, Node)
                {
                     _this.RecipientGroupReportOnItemClick(Id, E, Node);
                },
                onCheck:function (Row, Column, State)
                {
                    // _this.MailingReportOnCheck(Row, Column, State);
                }
            }),
            MailingTemplateReport: UlrMailingTemplatesListTableWidget({
                id:this.Id + "MailingTemplatesReport",
                enableTextSearch:true,
                enableAutoHeight:1,
                hideExport: true,
                columns: ["name"],
                minHeight: 500,
                onItemClick:function (Id, E, Node)
                {
                    _this.SetTemplate(Id, E, Node);
                }
            })
        }
    };

    this.TemplatesPopup = webix.ui({
        view: "popup",
        id:this.Id + "MailingTemplatePopup",
        modal: true,
        maxWidth: 1000,
        minHeight: 700,
        body: {
            rows:[
                {height:20},
                BlockHeaderTemplate({
                    title:LangHelper.GetString("UlrModule","Mailing templates list"),
                    icon:"",
                    id: this.Id + "MailingTemplatePopupHeadLabel",
                    borderless:true,
                    css: "custom-font-size_20"
                }),
                {height:20},
                {
                    cols: [
                        _this.Views.ReportsWidgets.MailingTemplateReport.ViewConfig,
                        {width: 10},
                        {
                            rows: [
                                {
                                    view:"nic-editor",
                                    css: "dpiui2_selectable",
                                    id: _this.Id + "MailingTemplateEditorPopup",
                                    name:"template",
                                    width:800
                                },
                                {height:12},
                            ]
                        },
                    ]
                },
                {height: 30},
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            css:"form_button third_action",
                            height: 40,
                            label:LangHelper.GetString("UlrModule","Cancel"),
                            click:function () {
                                _this.TemplatesPopup.hide();
                            }
                        },
                        {width: 20},
                        {
                            view:"button",
                            type:"form",
                            css:"form_button main_action",
                            height: 40,
                            label:LangHelper.GetString("UlrModule","Insert"),
                            click:function ()
                            {
                                const value = _this.Views.MailingTemplateEditorPopup.getValue();

                                _this.Views.EditMailTemplateInput.setValue(value);

                                _this.TemplatesPopup.hide();
                            }
                        }
                    ]
                },
                {height:20},
            ]
        }
    });

    this.ViewConfig = [{
            view:"scrollview",
            id:_this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: 
                [
                    {
                        type: "clean",
                        borderless:true,
                        rows:
                            [
                                {height:6},
                                PageHeaderTemplate({
                                    id:_this.Id + "PageTitle",
                                    root_title: _this.PageTitle.Title
                                }),
                                {height:32},
                                {
                                    view:"form",
                                    id:_this.Id + "MailingEditForm",
                                    type: "wide",
                                    borderless:true,
                                    elements:[
                                        {
                                            rows: [
                                                {
                                                    cols:[
                                                        {
                                                            view:"spectre_captionlabel",
                                                            name:"_id",
                                                            caption:LangHelper.GetString("UlrModule","Mailing id")
                                                        },
                                                        {
                                                            id:_this.Id + "MailingEditFormEnabledSpacerView",
                                                            css:"form_info_label_spacer",
                                                            borderless:true,
                                                            width:20,
                                                            template:"",
                                                            hidden:true
                                                        },
                                                        {
                                                            view:"spectre_captionlabel",
                                                            id:_this.Id + "MailingEditFormEnabledStateView",
                                                            name:"enabled",
                                                            caption:LangHelper.GetString("UlrModule","Mailing state"),
                                                            template:function (Obj)
                                                            {
                                                                return "<span class='caption'>"+Obj.caption+":</span> <span class='value'>"+(parseInt(Obj.value) ? LangHelper.GetString("UlrModule","Enabled") : LangHelper.GetString("UlrModule","Disabled"))+"</span>";
                                                            },
                                                            hidden:true
                                                        },
                                                    ]
                                                },
                                                {height:22},
                                                {
                                                    type:"wide",
                                                    cols:[
                                                        {
                                                            view:"spectre_text",
                                                            name:"name",
                                                            label:LangHelper.GetString("UlrModule","Name"),
                                                            required:true,
                                                            validate: webix.rules.isNotEmpty,
                                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                            on: {
                                                                "onChange": function (Nv, Ov)
                                                                {
                                                                    if(typeof Ov !== "undefined")
                                                                    {
                                                                        if(Nv != Nv.trim())
                                                                        {
                                                                            this.setValue(Nv.trim());
                                                                            return;
                                                                        }

                                                                        this.validate();
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        {
                                                            view:"spectre_text",
                                                            name:"subject",
                                                            label:LangHelper.GetString("UlrModule","Letter subject"),
                                                            required:true,
                                                            validate: webix.rules.isNotEmpty,
                                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                            on: {
                                                                "onChange": function (Nv, Ov)
                                                                {
                                                                    if(typeof Ov !== "undefined")
                                                                    {
                                                                        if(Nv != Nv.trim())
                                                                        {
                                                                            this.setValue(Nv.trim());
                                                                            return;
                                                                        }

                                                                        this.validate();
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:22},
                                                {
                                                    cols:[
                                                        BlockHeaderTemplate({
                                                            title:LangHelper.GetString("UlrModule","Mail template"),
                                                            icon:"",
                                                            borderless:true,
                                                            css: "custom-block-header_bottom"
                                                        }),
                                                        {
                                                            view: "toolbar",
                                                            borderless:true,
                                                            elements: [
                                                                {
                                                                    view: "spectre_button",
                                                                    type: "icon",
                                                                    css: "form_button spec_action with_icon",
                                                                    label:LangHelper.GetString("UlrModule","Select template"),
                                                                    icon: "file-code",
                                                                    autowidth: true,
                                                                    click: function (id, e, node)
                                                                    {
                                                                        _this.Views.MailingTemplateEditorPopup.setValue("");
                                                                        _this.Views.ReportsWidgets.MailingTemplateReport.RefreshData();
                                                                        var node = this.getNode(id);
                                                                        _this.TemplatesPopup.show(node, {pos: "left"});
                                                                    }
                                                                },
                                                                {
                                                                    view: "spectre_button",
                                                                    type: "icon",
                                                                    css: "form_button spec_action with_icon",
                                                                    icon: "code",
                                                                    label: LangHelper.GetString("QoE","Tepmplate parameters"),
                                                                    autowidth: true,
                                                                    click: function (id, e, node)
                                                                    {
                                                                        var node = this.getNode(id);
                                                                        _this.ActionParamsContext.show(node, {pos: "bottom"});
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {height:6},
                                                {
                                                    view:"nic-editor",
                                                    css: "dpiui2_selectable",
                                                    id:this.Id + "EditMailTemplateInput",
                                                    name:"email_tpl",
                                                    labelPosition: "top",
                                                    labelHeight:0,
                                                    labelWidth:0,
                                                    minHeight:240,
                                                    required:true,
                                                    validate: webix.rules.isNotEmpty,
                                                    invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                    on: {
                                                        "onChange": function (Nv, Ov)
                                                        {
                                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                            this.validate();
                                                        }
                                                    },
                                                    config:{
                                                        fullPanel:true
                                                        //buttonList: ['save', 'bold', 'italic', 'underline', 'left', 'center', 'right', 'justify', 'ol', 'ul', 'indent', 'outdent']
                                                    }
                                                },
                                                {height:48},
                                                {
                                                    rows: [
                                                        BlockHeaderTemplate({
                                                            title:LangHelper.GetString("UlrModule","Timetable"), icon:"",
                                                            borderless:true
                                                        }),
                                                        {height:6},
                                                        this.Views.DateTimePicker.DateTimetableSetDataForm,
                                                        {height:20},
                                                        this.Views.DateTimePicker.ViewConfig
                                                    ]
                                                },
                                                {height:48},
                                                {
                                                    rows:[
                                                        this.Views.QueriesTable.ViewConfig
                                                    ]
                                                },
                                                {height:48},
                                                BlockHeaderTemplate({
                                                    title:LangHelper.GetString("UlrModule","Add recipient group"), icon:"",
                                                    borderless:true
                                                }),
                                                {height:6},
                                                {
                                                    rows: [
                                                        {
                                                            type: "wide",
                                                            cols: [
                                                                {
                                                                    view:"spectre_richselect",
                                                                    name:"recipient_group_id",
                                                                    width: 300,
                                                                    id: _this.Id + "RecipientGroupRichSelect",
                                                                    label:LangHelper.GetString("UlrModule","Recipient group"),
                                                                    options:{
                                                                        point:false,
                                                                        data:[]
                                                                    },
                                                                    invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                                    on: {
                                                                        "onChange": function (Nv, Ov) {
                                                                            if(typeof Ov !== "undefined" && Ov !== "")
                                                                                this.validate();
                                                                        }
                                                                    }
                                                                },
                                                                {
                                                                    view:"spectre_button",
                                                                    id:_this.Id + "AddRecipientGroupBtn",
                                                                    css:"form_button form_element spec_action",
                                                                    label:LangHelper.GetString("UlrModule","Add"),
                                                                    autowidth:true,
                                                                    height:51,
                                                                    disabled:true,
                                                                    click:function ()
                                                                    {
                                                                        setTimeout(function ()
                                                                        {
                                                                            _this.AddGroup();
                                                                        },1);
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        },
                                                        {height: 20},
                                                        this.Views.ReportsWidgets.RecipientGroupReport.ViewConfig,
                                                    ]
                                                },
                                                {height:32},
                                                {
                                                    type: "wide",
                                                    cols: [
                                                        {
                                                            view:"spectre_button",
                                                            id: _this.Id + "SaveBtn",
                                                            css:"form_button main_action",
                                                            label:LangHelper.GetString("UlrModule","Save changes"),
                                                            autowidth:true,
                                                            click:function ()
                                                            {
                                                                _this._Save();
                                                            }
                                                        },
                                                        {
                                                            view:"spectre_button",
                                                            id: _this.Id + "SaveEnableBtn",
                                                            css:"form_button second_action",
                                                            label:LangHelper.GetString("UlrModule","Save and enable"),
                                                            autowidth:true,
                                                            click:function ()
                                                            {
                                                                _this._Save(true);
                                                            },
                                                            hidden:true
                                                        },
                                                        {
                                                            view:"spectre_button",
                                                            id: _this.Id + "SaveDisableBtn",
                                                            css:"form_button second_action",
                                                            label:LangHelper.GetString("UlrModule","Save and disable"),
                                                            autowidth:true,
                                                            click:function ()
                                                            {
                                                                _this._Save(false);
                                                            },
                                                            hidden:true
                                                        },
                                                        {},
                                                        {
                                                            view:"spectre_button",
                                                            id: this.Id + "DeleteBtn",
                                                            css:"form_button delete_action",
                                                            label:LangHelper.GetString("UlrModule","Delete"),
                                                            autowidth:true,
                                                            click:function ()
                                                            {
                                                                _this.Delete();
                                                            },
                                                            hidden:true
                                                        }
                                                    ]
                                                },
                                                {height:16}
                                            ]
                                        }
                                    ]
                                }
                            ]
                    }
                ]
            },

    }];

    this.Subscriptions = {};

    this.Signals = {
        MailingEnabled: new Rx.BehaviorSubject(0),

        RichSelectHasValue:  new Rx.BehaviorSubject(0),
    };
};

UlrEditMailingViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets" && View != "ExtendedFillter" && View != "WidgetsSuggest" && View != "DateTimePicker" && View != "QueriesTable")
            _this.Views[View] = $$(_this.Id + View)
    });

    this.Views.QueriesTable.BindAll();

    this.Views.DateTimePicker.BindAll();

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        _this.Views.Widgets[WidgetKey].Bind(_this);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.MailingUpdated = this.ViewModel.Signals.MailingUpdated.subscribe(function (MailingModel) {
        if(MailingModel)
        {   
            _this.DefineAll(MailingModel);

            _this.ViewModel.GetRecipientGroups();
        }
    });

    this.Subscriptions.MailingSaved = this.ViewModel.Signals.MailingSaved.subscribe(function (MailingModel)
    {
        if(MailingModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Mailing")+" # "+MailingModel.name+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: ControllersEnum.UlrMailingList});
            },1);
        }
    });

    this.Subscriptions.MailingDeleted = this.ViewModel.Signals.MailingDeleted.subscribe(function (MailingModel)
    {
        if(MailingModel)
        {
            _this.RecipientGroupOnSuccessDelete(MailingModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Recipient group")+" # "+MailingModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: ControllersEnum.UlrMailingList});
            },1);
        }
    });

    this.Subscriptions.MailingError = this.ViewModel.Signals.MailingError.subscribe(function (ErrModel)
    {
        var action = null;

        if(ErrModel&&ErrModel.code == 404)
        {
            action = function ()
            {
                setTimeout(function ()
                {
                    App.NavRouter.PresentView({id: ControllersEnum.UlrMailingList});
                }, 1);
            }
        }

        _this.ShowServerError(ErrModel, action);
    });

    this.Subscriptions.MailingDeleteError = this.ViewModel.Signals.MailingDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.MailingSaveError = this.ViewModel.Signals.MailingSaveError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RecipientGroupGet = this.ViewModel.Signals.RecipientGroupGet.subscribe(function (RecipientGroups)
    {
        if (RecipientGroups == null)
            return;

        let groupIds = _this.group_ids ? _this.group_ids.split(',') : [];

        _this.Views.ReportsWidgets.RecipientGroupReport.Views.Table.clearAll();

        let model = _this.ViewModel.RecipientGroupsParseToRichSelectModel(RecipientGroups);

        model.forEach(function(item) {
            groupIds.includes(item.id.toString()) ? _this.AddGroup(item) : "";
        });

        _this.Views.MailingEditForm.elements.recipient_group_id.getList().clearAll();
        _this.Views.MailingEditForm.elements.recipient_group_id.getList().parse(model);
    });

    this.Subscriptions.RichSelectHasValue = this.Signals.RichSelectHasValue.subscribe(function (HasValue)
    {
        HasValue ? _this.Views.AddRecipientGroupBtn.enable() : _this.Views.AddRecipientGroupBtn.disable();
    });

    this.Views.RecipientGroupRichSelect.attachEvent("onChange", function(Nv, Ov)
    {
        _this.Signals.RichSelectHasValue.next(Nv ? 1 : 0);
    });

    this.Subscriptions.MailingEnabled = this.Signals.MailingEnabled.subscribe(function (Enabled)
    {
        var view = _this.Views.SaveDisableBtn;
        Enabled ? view.show() : view.hide();

        var view = _this.Views.SaveEnableBtn;
        !Enabled ? view.show() : view.hide();
    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress)
    {
        var view = _this.Views.SaveBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveEnableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.SaveDisableBtn;
        InProgress ? view.disable() : view.enable();

        var view = _this.Views.DeleteBtn;
        InProgress ? view.disable() : view.enable();
    });

    this.Subscriptions.SignalWidgetsUpdated = this.Views.QueriesTable.Views.WidgetsSuggest.ViewModel.SignalWidgetsUpdated.subscribe(function(Data) {
        if(Data) {
            _this.Views.QueriesTable.Views.QueriesTableForm.parse(_this.ViewModel.QueriesData);
        }
    });
};

UlrEditMailingViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    // this.Views.WidgetsSuggest.UpdateWidgets();

    this.Refresh();
};

UlrEditMailingViewController.prototype.Refresh = function (PathParams)
{
    this.Views.ReportsWidgets.RecipientGroupReport.RefreshData();

    this.RefreshMailingProfile();

    this.ViewModel.GetRecipientGroups();
};

UlrEditMailingViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }

    this.Views.WidgetsSuggest.Destroy();


};

UlrEditMailingViewController.prototype._GetWidgetConfigByName = function (WidgetName)
{
    if(WidgetName && window[WidgetName])
    {
        var widget = window[WidgetName]({});

        var config = widget && widget.Config && widget.Config ? widget.Config : null;

        if(!config && widget.TableWidget && widget.TableWidget.Config)
            config = widget.TableWidget.Config;

        return config;
    }

    return null;
};

UlrEditMailingViewController.prototype._GetWidgetFilterByName = function (WidgetName)
{
    if(WidgetName && window[WidgetName])
    {
        var widget = window[WidgetName]({});

        var filter = widget && widget.Filter ? widget.Filter : null;

        return filter;
    }

    return null;
};

UlrEditMailingViewController.prototype.RecipientGroupOnSuccessDelete = function(RecipientGroupModel)
{
    var table = this.Views.ReportsWidgets.RecipientGroupReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == RecipientGroupModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }

};

UlrEditMailingViewController.prototype._Save = function (Enable)
{
    var _this = this;
    
    if (!this.Views.MailingEditForm.validate())
        return;

    var queries = [];
    this.Views.QueriesTable.Views.QueriesTableForm.serialize().forEach(function (Item)
    {
        queries.push(new QoETriggerQueryModel(Item));
    });

    var form = new UlrMailingModel(this.Views.MailingEditForm.getValues());

    form.queries_json = JSON.stringify(queries);

    for (const id in this.ViewModel.RecipientGroupDics.AddedDataDic) {
        _this.ViewModel.RecipientGroupDics.GroupIdsArr.push(id);
    }

    form.group_ids =  this.ViewModel.RecipientGroupDics.GroupIdsArr.toString();

    if(typeof Enable != "undefined")
    {
        form.enabled = Enable ? 1 : 0;
    }

    let schedule_config = this.Views.DateTimePicker.Views.Timetable.serialize();

    if (schedule_config)
    {
        schedule_config = schedule_config.map(function (item) {
            item.startTime = Helper.ConvertTimeLocalToUtc(item.startTime);
            item.reportTime = item.reportTime ? Helper.ConvertTimeLocalToUtc(item.reportTime) : "";
        });
    }

    form.schedule_config_json = JSON.stringify(this.Views.DateTimePicker.Views.Timetable.serialize());

    this.ViewModel.SaveMailing(form)
};

UlrEditMailingViewController.prototype.RefreshMailingProfile = function ()
{
    var id = this.Action == this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    this.ViewModel.ResfreshMailing({_id: id});

    this.DefinePageTitle((this.Action == this.ActionsEnum.Add ? LangHelper.GetString("UlrModule","Add mailing")   : LangHelper.GetString("UlrModule","Edit mailing")) + " #" + id);

    if(this.Action == this.ActionsEnum.Edit)
    {
        this.Views.MailingEditFormEnabledStateView.show();
        this.Views.MailingEditFormEnabledSpacerView.show();
        this.Views.DeleteBtn.show();
    }
};

UlrEditMailingViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditMailingViewController.prototype.DefineAll = function(MailingModel)
{
    var _this = this;

    this.group_ids = MailingModel.group_ids;

    // TODO:

    this.Views.MailingEditForm.clear();
    this.Views.MailingEditForm.clearValidation();

    this.Views.DateTimePicker.LoadDataToTimetable(MailingModel.schedule_config_json);

    this.Views.MailingEditForm.setValues(MailingModel);

    this.Signals.MailingEnabled.next(parseInt(MailingModel.enabled));

    this.Views.QueriesTable.Views.QueriesTableForm.parse(this.ViewModel.QueriesData);
};

UlrEditMailingViewController.prototype.RecipientGroupReportOnItemClick = function(Id, E, Node)
{
    if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.ReportsWidgets.RecipientGroupReport.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: ControllersEnum.UlrEditRecipientGroup, path:"/_id=" + data._id});
    }

    if(Id.column === 'delete' || Id.column === 'enabled')
    {
        var table = this.Views.ReportsWidgets.RecipientGroupReport.Views.Table;

        var data = table.getItem(Id);

        var dataDics = this.ViewModel.RecipientGroupDics;

        if(Id.column === 'delete')
        {
            if(data._id)
            {
                if(dataDics.AddedDataDic[data._id])
                {
                    delete dataDics.AddedDataDic[data._id];
                }

                if(dataDics.InitialDataDic[data._id])
                {
                    dataDics.RemovedDataDic[data._id] = dataDics.InitialDataDic[data._id];
                    delete dataDics.InitialDataDic[data._id];
                }
            }

            table.remove(Id);
        }
    }
};

UlrEditMailingViewController.prototype.RecipientGroupDataSource = function(FilterModel)
{
    var data = this.ViewModel.RecipientGroupsArrDicToArr(this.ViewModel.RecipientGroupDics.InitialDataDic);

    var addedData = this.ViewModel.RecipientGroupsArrDicToArr(this.ViewModel.RecipientGroupDics.AddedDataDic);

    return {rows:addedData.concat(data)};
};

UlrEditMailingViewController.prototype.GetRichselectType = function()
{
    var richSelect = this.Views.RecipientGroupRichSelect;

    return {id: richSelect.getValue(), value: richSelect.getText()};
}

UlrEditMailingViewController.prototype.AddGroup = function(data = null)
{
    data = data ? data : this.GetRichselectType();

    var table = this.Views.ReportsWidgets.RecipientGroupReport.Views.Table;

    var model = new UlrRecipientGroupModel({
        _id: data.id,
        name: data.value,
    });

    this.Views.RecipientGroupRichSelect.setValue("");

    var dataDics = this.ViewModel.RecipientGroupDics;

    dataDics.AddedDataDic[model._id] = model;

    table.add(model,0);
    table.hideOverlay();
    table.hideProgress();

};

UlrEditMailingViewController.prototype.ShowServerError = function(ErrModel, Action)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};

UlrEditMailingViewController.prototype.Delete = function()
{
    var _this = this;

    var model = this.ViewModel.Signals.MailingUpdated.getValue();

    UlrShowDialogPopup({
        node:this.Views.DeleteBtn.getNode(),
        position:"bottom",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    _this.ViewModel.DeleteMailing(model);
                }
            }
        ]
    });
};

UlrEditMailingViewController.prototype._GetTemplate = function (Id)
{
    var id = Id ? Id : "default";

    var tpl = {

        "default":'<p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Final report")+':</b></p><p class="MsoNormal">{trigger.report.merged_pdf}<br></p><p class="MsoNormal"><b><br></b></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Links to reports")+':</b><br></p><p class="MsoNormal">{trigger.report.link}</p><p class="MsoNormal"><b><br></b></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Links to PDF reports")+':</b><br></p><p class="MsoNormal">{trigger.report.pdf}<br>{trigger.report.merged_pdf.as_file.zip}</p><p class="MsoNormal"><br></p><p class="MsoNormal"><br></p><div><br></div>',

        "default_trigger":'<p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Id")+':&nbsp;</b>{trigger.id}</p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Trigger")+'</b>: {trigger.name}</p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Status")+'</b>: {trigger.state}</p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Severity")+'</b>: {trigger.severity}<br></p><p class="MsoNormal"><br></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Queries")+'</b>:&nbsp;</p><p class="MsoNormal">{trigger.queries}</p><p class="MsoNormal"><br></p><p class="MsoNormal"><p class="MsoNormal"><br></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Reasons for the occurrence of notification")+'</b>:</p><p class="MsoNormal">{trigger.notification.notes}</p><p class="MsoNormal"><br></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Links to reports")+'</b>:</p><p class="MsoNormal">{trigger.report.link}</p><br><b>'+LangHelper.GetString("QoE","Links to reports")+'</b>:</p><p class="MsoNormal">{trigger.report.csv}</p><p class="MsoNormal">{trigger.report.tsv}</p><p class="MsoNormal">{trigger.report.xlsx}</p><p class="MsoNormal">{trigger.report.pdf}</p>',

        "redmine.json":'{\n' +
        '"issue":{\n' +
        '"project_id":1,\n' +
        '"subject":"'+LangHelper.GetString("QoE","Trigger fired")+': {trigger.name}",\n' +
        '"priority_id":1,\n' +
        '"description":"'+LangHelper.GetString("QoE","Id")+': {trigger.id}\\n'+LangHelper.GetString("QoE","Trigger")+': {trigger.name}\\n'+LangHelper.GetString("QoE","Status")+': {trigger.state}\\n'+LangHelper.GetString("QoE","Severity")+':{trigger.severity}\\n\\n'+LangHelper.GetString("QoE","Queries")+':\\n{trigger.queries}\\n\\n'+LangHelper.GetString("QoE","Reasons for the occurrence of notification")+':\\n{trigger.notification.notes}\\n\\n'+LangHelper.GetString("QoE","Links to reports")+':\\n{trigger.report.link}"\\n\\n' + LangHelper.GetString("QoE","Links to files")+':\\n{trigger.report.csv}"\\n' + '\\n{trigger.report.tsv}"\\n' + '\\n{trigger.report.xlsx}"\\n' + '\\n{trigger.report.pdf}"\n' +
            '}\n' +
        '}',

        "redmine.xml":'<?xml version="1.0"?>\n' +
        '<issue>\n' +
        '  <project_id>1</project_id>\n' +
        '  <subject>'+LangHelper.GetString("QoE","Trigger fired")+': {trigger.name}</subject>\n' +
        '  <priority_id>1</priority_id>\n' +
        '  <description>'+LangHelper.GetString("QoE","Id")+': {trigger.id}\n' +
         LangHelper.GetString("QoE","Trigger")+': {trigger.name}\n' +
         LangHelper.GetString("QoE","Status")+': {trigger.state}\n' +
         LangHelper.GetString("QoE","Severity")+': {trigger.severity}\n' +
        '\n' +
        LangHelper.GetString("QoE","Queries")+': \n' +
        '{trigger.queries}\n' +
        '\n' +
        LangHelper.GetString("QoE","Reasons for the occurrence of notification")+':\n' +
        '{trigger.notification.notes}\n' +
        '\n' +
        LangHelper.GetString("QoE","Links to reports")+':\n' +
        '{trigger.report.link}\n' +
        '\n' +
        LangHelper.GetString("QoE","Links to files")+':\n' +
        '{trigger.report.csv}\n' +
        '{trigger.report.tsv}\n' +
        '{trigger.report.xlsx}\n' +
        '{trigger.report.pdf}\n'+
        '\n' +
        LangHelper.GetString("QoE","Links to merged pdf report")+':\n' +
        '{trigger.report.merged_pdf}\n'+
        '</description>\n' +
        '</issue>'
    };

    return tpl[Id] ? tpl[Id] : tpl["default"];
};

UlrEditMailingViewController.prototype.DefinePageTitle = function(Title)
{
    this.Views.PageTitle.define("data", {root_title:Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

UlrEditMailingViewController.prototype.SetTemplate = function(Id, E, Node)
{
    const _this = this;

    const table = this.Views.ReportsWidgets.MailingTemplateReport.Views.Table;

    const data = table.getItem(Id);

    if(Id.column === 'name')
    {
        _this.Views.MailingTemplateEditorPopup.setValue(data.template);
    }

    if (Id.column === 'edit')
    {
        App.NavRouter.PresentView({id: ControllersEnum.UlrEditTemplateMailing, path:"/_id=" + data._id});
        _this.TemplatesPopup.hide();
    }
}

function UlrAddMailingViewController(Params)
{
    UlrAddMailingViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddMailingViewController,UlrEditMailingViewController);
function UlrEditTemplateMailingViewController() {
    var _this = this;

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.mode = module ? module : "dpiui2";

    this.Action = this.ActionsEnum.Edit;

    this.Id = "UlrEditMailingTemplate";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Mailing"),
        Title:LangHelper.GetString("UlrModule","Edit mailing template")
    };

    this.ViewModel = new UlrMailingTemplateManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        EditMailTemplateInput: null,
        MailingTemplateEditForm: null,
        DeleteBtn:null,
        SaveBtn: null,
        PageTitle:null,
        Widgets: {},
        ReportsWidgets:{}
    };

    this.ActionParamsContextId = this.Id + "ActionParamsContext";
    this.ActionParamsContext = webix.ui({
        view: "popup",
        id:this.ActionParamsContextId,
        maxWidth: 800,
        maxHeight: 680,
        body: {
            rows:[
                {
                    borderless:true,
                    height: 80,
                    template:LangHelper.GetString("QoE", "Select one or more identifiers (via shift or ctr). Use ctrl + c to copy and ctrl + v to insert a message into the template.")
                },
                {
                    borderless:true,
                    id:this.ActionParamsContextId + "Table",
                    name: "headers",
                    view: "datatable",
                    select:"cell",
                    multiselect:true,
                    clipboard:"selection",
                    resizeColumn:true,
                    tooltip:true,
                    checkboxRefresh:true,
                    height:560,
                    columns:
                        [
                            {
                                id: "id",
                                header: [TooltipTemplate(LangHelper.GetString("QoE", "Id"))],
                                fillspace: 2
                            },
                            {
                                id: "value",
                                header: [TooltipTemplate(LangHelper.GetString("QoE", "Value"))],
                                fillspace: 3
                            }
                        ],
                    data:Helper.DictToArr(QoETriggerAlertActionBodyTemplateParametersDic)
                }
            ]
        }
    });

    this.ViewConfig = [{
        view:"scrollview",
        id:_this.Id + "ScrollView",
        scroll:"y",
        body:{
            type: "space",
            rows:
                [
                    {
                        type: "clean",
                        borderless:true,
                        rows:
                            [
                                {height:6},
                                PageHeaderTemplate({
                                    id:_this.Id + "PageTitle",
                                    root_title: _this.PageTitle.Title
                                }),
                                {height:32},
                                {
                                    view:"form",
                                    id:_this.Id + "MailingTemplateEditForm",
                                    type: "wide",
                                    borderless:true,
                                    elements:[
                                        {
                                            rows: [
                                                {
                                                    cols:[
                                                        {
                                                            view:"spectre_captionlabel",
                                                            name:"_id",
                                                            caption:LangHelper.GetString("UlrModule","Mailing template id")
                                                        }
                                                    ]
                                                },
                                                {height:22},
                                                {
                                                    type:"wide",
                                                    cols:[
                                                        {
                                                            view:"spectre_text",
                                                            name:"name",
                                                            label:LangHelper.GetString("UlrModule","Name"),
                                                            required:true,
                                                            validate: webix.rules.isNotEmpty,
                                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                            on: {
                                                                "onChange": function (Nv, Ov)
                                                                {
                                                                    if(typeof Ov !== "undefined")
                                                                    {
                                                                        if(Nv != Nv.trim())
                                                                        {
                                                                            this.setValue(Nv.trim());
                                                                            return;
                                                                        }

                                                                        this.validate();
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                },
                                                {height:22},
                                                {
                                                    cols:[
                                                        BlockHeaderTemplate({
                                                            title:LangHelper.GetString("UlrModule","Mail template"),
                                                            icon:"",
                                                            borderless:true,
                                                            css: "custom-block-header_bottom"
                                                        }),
                                                        {
                                                            view: "toolbar",
                                                            borderless:true,
                                                            elements: [
                                                                {
                                                                    view: "spectre_button",
                                                                    type: "icon",
                                                                    css: "form_button spec_action with_icon",
                                                                    icon: "file-code",
                                                                    label: LangHelper.GetString("UlrModule","System template"),
                                                                    autowidth:true,
                                                                    click: function (id, e, node)
                                                                    {
                                                                        _this.Views.EditMailTemplateInput.setValue(_this._GetTemplate());
                                                                    }
                                                                },
                                                                {
                                                                    view: "spectre_button",
                                                                    type: "icon",
                                                                    css: "form_button spec_action with_icon",
                                                                    icon: "code",
                                                                    label: LangHelper.GetString("QoE","Tepmplate parameters"),
                                                                    autowidth: true,
                                                                    click: function (id, e, node)
                                                                    {
                                                                        var node = this.getNode(id);
                                                                        _this.ActionParamsContext.show(node, {pos: "bottom"});
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {height:6},
                                                {
                                                    view:"nic-editor",
                                                    css: "dpiui2_selectable",
                                                    id:this.Id + "EditMailTemplateInput",
                                                    name:"template",
                                                    labelPosition: "top",
                                                    labelHeight:0,
                                                    labelWidth:0,
                                                    minHeight:240,
                                                    required:true,
                                                    validate: webix.rules.isNotEmpty,
                                                    invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                    on: {
                                                        "onChange": function (Nv, Ov)
                                                        {
                                                            if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                                                            {
                                                                this.setValue(Nv.trim());
                                                                return;
                                                            }
                                                            this.validate();
                                                        }
                                                    },
                                                    config:{
                                                        fullPanel:true
                                                    }
                                                },
                                                {height:48},
                                                {
                                                    type: "wide",
                                                    cols: [
                                                        {
                                                            view:"spectre_button",
                                                            id: _this.Id + "SaveBtn",
                                                            css:"form_button main_action",
                                                            label:LangHelper.GetString("UlrModule","Save changes"),
                                                            autowidth:true,
                                                            click:function ()
                                                            {
                                                                _this._Save();
                                                            }
                                                        },
                                                        {},
                                                        {
                                                            view:"spectre_button",
                                                            id: this.Id + "DeleteBtn",
                                                            css:"form_button delete_action",
                                                            label:LangHelper.GetString("UlrModule","Delete"),
                                                            autowidth:true,
                                                            click:function ()
                                                            {
                                                                _this.Delete();
                                                            },
                                                            hidden:true
                                                        }
                                                    ]
                                                },
                                                {height:16}
                                            ]
                                        }
                                    ]
                                }
                            ]
                    }
                ]
        },

    }];

    this.Subscriptions = {};
};

UlrEditTemplateMailingViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets" && View != "ExtendedFillter" && View != "WidgetsSuggest" && View != "DateTimePicker" && View != "QueriesTable")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        _this.Views.Widgets[WidgetKey].Bind(_this);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.MailingTemplateUpdated = this.ViewModel.Signals.MailingTemplateUpdated.subscribe(function (MailingTemplateModel) {
        if(MailingTemplateModel)
        {
            _this.DefineAll(MailingTemplateModel);
        }
    });

    this.Subscriptions.MailingTemplateSaved = this.ViewModel.Signals.MailingTemplateSaved.subscribe(function (MailingTemplateModel)
    {
        if(MailingTemplateModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Mailing template")+" # "+MailingTemplateModel.name+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: ControllersEnum.UlrMailingTemplatesList});
            },1);
        }
    });

    this.Subscriptions.MailingTemplateDeleted = this.ViewModel.Signals.MailingTemplateDeleted.subscribe(function (MailingTemplateModel)
    {
        if(MailingTemplateModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Mailing template")+" # "+MailingTemplateModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: ControllersEnum.UlrMailingTemplatesList});
            },1);
        }
    });

    this.Subscriptions.MailingTemplateError = this.ViewModel.Signals.MailingTemplateError.subscribe(function (ErrModel)
    {
        var action = null;

        if(ErrModel&&ErrModel.code == 404)
        {
            action = function ()
            {
                setTimeout(function ()
                {
                    App.NavRouter.PresentView({id: ControllersEnum.UlrMailingTemplatesList});
                }, 1);
            }
        }

        _this.ShowServerError(ErrModel, action);
    });

    this.Subscriptions.MailingTemplateDeleteError = this.ViewModel.Signals.MailingTemplateDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.MailingTemplateSaveError = this.ViewModel.Signals.MailingTemplateSaveError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.Progress = this.ViewModel.Signals.Progress.subscribe(function (InProgress)
    {
        var view = _this.Views.SaveBtn;
        InProgress ? view.disable() : view.enable();
    });
};

UlrEditTemplateMailingViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    this.Refresh();
};

UlrEditTemplateMailingViewController.prototype.Refresh = function (PathParams)
{
    this.RefreshMailingTemplateProfile();
};

UlrEditTemplateMailingViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrEditTemplateMailingViewController.prototype._Save = function (Enable)
{
    var _this = this;

    if (!this.Views.MailingTemplateEditForm.validate())
        return;

    var form = new UlrMailingTemplateModel(this.Views.MailingTemplateEditForm.getValues());

    this.ViewModel.SaveMailingTemplate(form)
};

UlrEditTemplateMailingViewController.prototype.RefreshMailingTemplateProfile = function ()
{
    var id = this.Action === this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    this.ViewModel.RefreshMailingTemplate({_id: id});

    this.DefinePageTitle((this.Action === this.ActionsEnum.Add ? LangHelper.GetString("UlrModule","Add mailing template")   : LangHelper.GetString("UlrModule","Edit mailing template")) + " #" + id);

    if(this.Action === this.ActionsEnum.Edit)
    {
        this.Views.DeleteBtn.show();
    }
};

UlrEditTemplateMailingViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditTemplateMailingViewController.prototype.DefineAll = function(MailingTemplateModel)
{
    var _this = this;

    this.Views.MailingTemplateEditForm.clear();
    this.Views.MailingTemplateEditForm.clearValidation();

    this.Views.MailingTemplateEditForm.setValues(MailingTemplateModel);
};

UlrEditTemplateMailingViewController.prototype.ShowServerError = function(ErrModel, Action)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};

UlrEditTemplateMailingViewController.prototype.Delete = function()
{
    var _this = this;

    var model = this.ViewModel.Signals.MailingTemplateUpdated.getValue();

    UlrShowDialogPopup({
        node:this.Views.DeleteBtn.getNode(),
        position:"bottom",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    _this.ViewModel.DeleteMailingTemplate(model);
                }
            }
        ]
    });
};

UlrEditTemplateMailingViewController.prototype._GetTemplate = function (Id)
{
    var id = Id ? Id : "default";

    var tpl = {

        "default":'<p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Final report")+':</b></p><p class="MsoNormal">{trigger.report.merged_pdf}<br></p><p class="MsoNormal"><b><br></b></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Links to reports")+':</b><br></p><p class="MsoNormal">{trigger.report.link}</p><p class="MsoNormal"><b><br></b></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Links to PDF reports")+':</b><br></p><p class="MsoNormal">{trigger.report.pdf}<br>{trigger.report.merged_pdf.as_file.zip}</p><p class="MsoNormal"><br></p><p class="MsoNormal"><br></p><div><br></div>',

        "default_trigger":'<p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Id")+':&nbsp;</b>{trigger.id}</p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Trigger")+'</b>: {trigger.name}</p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Status")+'</b>: {trigger.state}</p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Severity")+'</b>: {trigger.severity}<br></p><p class="MsoNormal"><br></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Queries")+'</b>:&nbsp;</p><p class="MsoNormal">{trigger.queries}</p><p class="MsoNormal"><br></p><p class="MsoNormal"><p class="MsoNormal"><br></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Reasons for the occurrence of notification")+'</b>:</p><p class="MsoNormal">{trigger.notification.notes}</p><p class="MsoNormal"><br></p><p class="MsoNormal"><b>'+LangHelper.GetString("QoE","Links to reports")+'</b>:</p><p class="MsoNormal">{trigger.report.link}</p><br><b>'+LangHelper.GetString("QoE","Links to reports")+'</b>:</p><p class="MsoNormal">{trigger.report.csv}</p><p class="MsoNormal">{trigger.report.tsv}</p><p class="MsoNormal">{trigger.report.xlsx}</p><p class="MsoNormal">{trigger.report.pdf}</p>',

        "redmine.json":'{\n' +
            '"issue":{\n' +
            '"project_id":1,\n' +
            '"subject":"'+LangHelper.GetString("QoE","Trigger fired")+': {trigger.name}",\n' +
            '"priority_id":1,\n' +
            '"description":"'+LangHelper.GetString("QoE","Id")+': {trigger.id}\\n'+LangHelper.GetString("QoE","Trigger")+': {trigger.name}\\n'+LangHelper.GetString("QoE","Status")+': {trigger.state}\\n'+LangHelper.GetString("QoE","Severity")+':{trigger.severity}\\n\\n'+LangHelper.GetString("QoE","Queries")+':\\n{trigger.queries}\\n\\n'+LangHelper.GetString("QoE","Reasons for the occurrence of notification")+':\\n{trigger.notification.notes}\\n\\n'+LangHelper.GetString("QoE","Links to reports")+':\\n{trigger.report.link}"\\n\\n' + LangHelper.GetString("QoE","Links to files")+':\\n{trigger.report.csv}"\\n' + '\\n{trigger.report.tsv}"\\n' + '\\n{trigger.report.xlsx}"\\n' + '\\n{trigger.report.pdf}"\n' +
            '}\n' +
            '}',

        "redmine.xml":'<?xml version="1.0"?>\n' +
            '<issue>\n' +
            '  <project_id>1</project_id>\n' +
            '  <subject>'+LangHelper.GetString("QoE","Trigger fired")+': {trigger.name}</subject>\n' +
            '  <priority_id>1</priority_id>\n' +
            '  <description>'+LangHelper.GetString("QoE","Id")+': {trigger.id}\n' +
            LangHelper.GetString("QoE","Trigger")+': {trigger.name}\n' +
            LangHelper.GetString("QoE","Status")+': {trigger.state}\n' +
            LangHelper.GetString("QoE","Severity")+': {trigger.severity}\n' +
            '\n' +
            LangHelper.GetString("QoE","Queries")+': \n' +
            '{trigger.queries}\n' +
            '\n' +
            LangHelper.GetString("QoE","Reasons for the occurrence of notification")+':\n' +
            '{trigger.notification.notes}\n' +
            '\n' +
            LangHelper.GetString("QoE","Links to reports")+':\n' +
            '{trigger.report.link}\n' +
            '\n' +
            LangHelper.GetString("QoE","Links to files")+':\n' +
            '{trigger.report.csv}\n' +
            '{trigger.report.tsv}\n' +
            '{trigger.report.xlsx}\n' +
            '{trigger.report.pdf}\n'+
            '\n' +
            LangHelper.GetString("QoE","Links to merged pdf report")+':\n' +
            '{trigger.report.merged_pdf}\n'+
            '</description>\n' +
            '</issue>'
    };

    return tpl[Id] ? tpl[Id] : tpl["default"];
};

UlrEditTemplateMailingViewController.prototype.DefinePageTitle = function(Title)
{
    this.Views.PageTitle.define("data", {root_title:Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

function UlrAddTemplateMailingViewController(Params)
{
    UlrAddTemplateMailingViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddTemplateMailingViewController, UlrEditTemplateMailingViewController);
function UlrMailingListViewController(params) 
{
    var _this = this;

    this.Id = "UlrMailingList";

    this.mode = module ? module : "dpiui2";

    this.TableRefreshPause = false;
    this.TableRefreshTimer = null;
    this.TableCanAutoRefesh = true;
    this.TableRefreshPauseInSec = 5;

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Mailing"),
        Title:LangHelper.GetString("UlrModule","Mailing list")
    };

    this.ViewModel = new UlrMailingManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        TaskDataPopupForm:null,
        TaskDataPopupEditor:null,
        TaskDataPopupHeadLabel: null,

        Widgets:{},
        ReportsWidgets:{
            MailingReport: UlrMailingListTableWidget({
                id:this.Id + "MailingReport",
                enableTextSearch:true,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.MailingReportOnItemClick(Id, E, Node);
                },
                onCheck:function (Row, Column, State)
                {
                    _this.MailingReportOnCheck(Row, Column, State);
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({
                                id:this.Id + "PageTitle",
                                root_title:this.PageTitle.Title
                            }),
                            {height:32},
                            {
                                view:"label",
                                css:"form_text_label",
                                label:LangHelper.GetString("UlrModule","Select Mailing from the list")
                            },
                            this.Views.ReportsWidgets.MailingReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.TaskDataPopup = null;
    this.TaskDataPopupConfig = {
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "TaskDataPopupHeadLabel",
                    label: LangHelper.GetString("UlrModule","State"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.TaskDataPopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: this.Id + "TaskDataPopupForm",
                            type: "wide",
                            minWidth:560,
                            minHeight:400,
                            elements: [
                                {
                                    view:"spectre_textarea",
                                    //view:"codemirror-editor",
                                    id:this.Id + "TaskDataPopupEditor",
                                    label:"",
                                    height:undefined,
                                    value:""
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.Subscriptions = {};

    this.Signals = {};
}

UlrMailingListViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.TaskDataPopup = webix.ui(this.TaskDataPopupConfig);

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.MailingDeleteError = this.ViewModel.Signals.MailingDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.MailingEnableStateError = this.ViewModel.Signals.MailingEnableStateError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.MailingForceRunSuccess = this.ViewModel.Signals.MailingForceRunSuccess.subscribe(function(Model)
    {
       if(Model)
       {
           _this.Refresh();
       }
    });

    this.Subscriptions.MailingForceRunError = this.ViewModel.Signals.MailingForceRunError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.MailingDeleted = this.ViewModel.Signals.MailingDeleted.subscribe(function (MailingModel)
    {
        if(MailingModel)
        {
            _this.MailingReportOnSuccessDelete(MailingModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Mailing")+" # "+MailingModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.MailingEnableStateUpdated = this.ViewModel.Signals.MailingEnableStateUpdated.subscribe(function (MailingModel)
    {
        if(MailingModel)
        {
            _this.MailingProfileEnableStateUpdated(MailingModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Mailing")+" # "+MailingModel.name+": "+LangHelper.GetString("UlrModule","Enable state changing"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });

    this.Subscriptions.ReportRowSelectedCount = this.Views.ReportsWidgets.MailingReport.TableRowsSelectedCount.subscribe(function(Count){
        _this.TableCanAutoRefesh = Count == 0;
    });

    App.WebSocketManager.Connect(this.Id);

    App.WebSocketManager.Connections[this.Id].on("trigger_updated", function(R){

        if(_this.TableRefreshPause)
            return;

        _this.TableRefreshPause = true;

        _this.TableRefreshTimer = setTimeout(function(){
            if(_this.TableCanAutoRefesh)
                _this.Refresh();

            _this.TableRefreshPause = false;
        }, _this.TableRefreshPauseInSec * 1000);
    });
};

UlrMailingListViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    this.Refresh();
};

UlrMailingListViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.WebSocketManager.Disconnect(this.Id);

    clearTimeout(_this.TableRefreshTimer);

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrMailingListViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.MailingReport.RefreshData();
};

UlrMailingListViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrMailingListViewController.prototype.MailingReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    var selectOptions = [{id:1, value:LangHelper.GetString("QoE", "now")}];

    var table = this.Views.ReportsWidgets.MailingReport.Views.Table;

    var data = table.getItem(Id);

    var schedule = JSON.parse(data.schedule_config_json);

    if(schedule && schedule.length)
    {
        let idx = selectOptions.length;
        schedule.map(item => {
            idx++;
            selectOptions.push({
                id:idx,
                value:item.reportTime ? Helper.ConvertTimeUtcToLocal(item.reportTime) : Helper.ConvertTimeUtcToLocal(item.startTime)
            })
        })
    }

    if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
    {
        App.NavRouter.PresentView({id: ControllersEnum.UlrEditMailing, path:"/_id=" + data._id});
    }

    if(Id.column === 'list')
    {
        var table_params = {
            enableAutoHeight: false,
            enableTextSearch: true,
            is_modal: true,
            filter: {
                network_id: {
                    id: "ulr_mailing_id",
                    operator: "=",
                    value: data._id
                }
            }
        };
        var modal_title = data.name;

        var table = new UlrMailingAlertsActionsTable(table_params);

        UlrEditAppPolicingPopup({
            modal_title: modal_title
        }, table);
        table.Bind(_this, _this.ReportsModel);
        table.RefreshData();
    }

    if(Id.column === 'run')
    {
        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            height:220,
            head:LangHelper.GetString("UlrModule","Force run mailing") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Force run mailing") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            select: {
                id:_this.Id + "ReportTimeSelectPopup",
                label:LangHelper.GetString("UlrModule", "Report time"),
                options:selectOptions,
                value:1
            },
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Run"),
                    click:function ()
                    {
                        let selectView = $$(_this.Id + "ReportTimeSelectPopup");
                        let value = selectView.getValue();
                        let reportTime = selectOptions.find(item => item.id === value);
                        reportTime = reportTime && reportTime.id != 1 && reportTime.value ? Helper.ConvertTimeLocalToUtc(reportTime.value) : "";
                        _this.ViewModel.ForceRunMailing(data, reportTime);
                    }
                }
            ]
        });
    }

    if(Id.column === 'state_code')
    {
        this.Views.TaskDataPopupForm.clear();
        this.Views.TaskDataPopupForm.clearValidation();

        this.Views.TaskDataPopupHeadLabel.setValue(data.name);

        var str = "";

        if(data.state_json && JSON.parse(data.state_json))
        {
            var obj = JSON.parse(data.state_json);
            str += JSON.stringify(obj, null, "\t");
        }
        else if(data.state_json) {
            str += data.state_json;
        }
        else{
            return;
        }

        this.TaskDataPopup.show();

        this.Views.TaskDataPopupEditor.setValue(str);
    }

    if(Id.column === 'delete')
    {
        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteMailing(data);
                    }
                }
            ]
        });
    }
};

UlrMailingListViewController.prototype.MailingReportOnCheck = function(Row, Column, State)
{
    var table = this.Views.ReportsWidgets.MailingReport.Views.Table;

    var data = table.getItem(Row);

    this.ViewModel.EnableDisableMailing(data, State);
};

UlrMailingListViewController.prototype.MailingReportOnSuccessDelete = function(MailingModel)
{
    var table = this.Views.ReportsWidgets.MailingReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == MailingModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }

};

UlrMailingListViewController.prototype.MailingProfileEnableStateUpdated = function(MailingModel)
{
    var table = this.Views.ReportsWidgets.MailingReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == MailingModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = MailingModel.enabled;
        table.updateItem(data.id, data);
    }
};

UlrMailingListViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};
function UlrMailingTemplatesListViewController(params)
{
    var _this = this;

    this.Id = "UlrMailingTemplatesList";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Mailing"),
        Title:LangHelper.GetString("UlrModule","Mailing templates list")
    };

    this.ViewModel = new UlrMailingTemplateManager();

    this.ReportsModel = new UniReportsManager();

    this.MailingTemplatePopup = webix.ui({
        view: "window",
        css:"spectre-alert form_modal",
        modal:true,
        position:"center",
        padding:0,
        marging:0,
        head:{
            view:"toolbar", cols:[
                {
                    view:"label",
                    id: this.Id + "MailingTemplateHeadLabel",
                    label: LangHelper.GetString("UlrModule","Template"),
                    height:68
                },
                { view:"spectre_button", css:"form_button spec_action with_icon", type:"icon", icon: 'times', align:"right", width:68, height:68, click:function(){ _this.MailingTemplatePopup.hide(); }}
            ]
        },
        body: {
            type:"space",
            borderless:true,
            rows:[
                {
                    type:"clean",
                    borderless:true,
                    rows:[
                        {
                            view: "form",
                            id: _this.Id + "MailingTemplateForm",
                            type: "wide",
                            minWidth:700,
                            minHeight:600,
                            elements: [
                                {
                                    view:"nic-editor",
                                    css: "dpiui2_selectable",
                                    id: _this.Id + "MailingTemplateEditor",
                                    name:"template",
                                    config:{
                                        fullPanel:false
                                    }
                                },
                                {height:1},
                            ]
                        }
                    ]
                }
            ]
        }
    });

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        MailingTemplateEditor: null,
        MailingTemplateHeadLabel: null,

        Widgets:{},
        ReportsWidgets:{
            MailingTemplateReport: UlrMailingTemplatesListTableWidget({
                id:this.Id + "MailingTemplatesReport",
                enableTextSearch:true,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.MailingTemplateReportOnItemClick(Id, E, Node);
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({
                                id:this.Id + "PageTitle",
                                root_title:this.PageTitle.Title
                            }),
                            {height:32},
                            {
                                view:"label",
                                css:"form_text_label",
                                label:LangHelper.GetString("UlrModule","Select Mailing template from the list")
                            },
                            this.Views.ReportsWidgets.MailingTemplateReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {};
}

UlrMailingTemplatesListViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.MailingTemplateDeleteError = this.ViewModel.Signals.MailingTemplateDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.MailingTemplateDeleted = this.ViewModel.Signals.MailingTemplateDeleted.subscribe(function (MailingTemplateModel)
    {
        if(MailingTemplateModel)
        {
            _this.MailingTemplateReportOnSuccessDelete(MailingTemplateModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Mailing template")+" # "+MailingTemplateModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });
};

UlrMailingTemplatesListViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    this.Refresh();
};

UlrMailingTemplatesListViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrMailingTemplatesListViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.MailingTemplateReport.RefreshData();
};

UlrMailingTemplatesListViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrMailingTemplatesListViewController.prototype.MailingTemplateReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    var table = this.Views.ReportsWidgets.MailingTemplateReport.Views.Table;

    var data = table.getItem(Id);

    if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
    {
        App.NavRouter.PresentView({id: ControllersEnum.UlrEditTemplateMailing, path:"/_id=" + data._id});
    }
    else if(Id.column === 'delete')
    {
        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteMailingTemplate(data);
                    }
                }
            ]
        });
    }
    else if (Id.column === 'template')
    {
        _this.ShowMailingTemplate(data);
    }
};

UlrMailingTemplatesListViewController.prototype.MailingTemplateReportOnSuccessDelete = function(MailingTemplateModel)
{
    var table = this.Views.ReportsWidgets.MailingTemplateReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == MailingTemplateModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }

};

UlrMailingTemplatesListViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrMailingTemplatesListViewController.prototype.ShowMailingTemplate = function (Data)
{
    this.MailingTemplatePopup.show();

    this.Views.MailingTemplateHeadLabel.define("label", Data.name);
    this.Views.MailingTemplateHeadLabel.refresh();
    this.Views.MailingTemplateEditor.setValue(Data.template);
}
function UlrRecipientGroupListViewController(params) 
{
    var _this = this;

    this.Id = "UlrRecipientGroupList";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Mailing"),
        Title:LangHelper.GetString("UlrModule","Recipient group list")
    };

    this.ViewModel = new UlrRecipientGroupManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ScrollView:null,
        PageTitle:null,

        GlobalWhitelistStateToggle:null,

        Widgets:{},
        ReportsWidgets:{
            RecipientGroupReport: UlrRecipientGroupTableWidget({
                id:this.Id + "RecipientGroupReport",
                enableTextSearch:true,
                enableAutoHeight:1,
                onItemClick:function (Id, E, Node)
                {
                    _this.RecipientGroupReportOnItemClick(Id, E, Node);
                },
                onCheck:function (Row, Column, State)
                {
                    _this.RecipientGroupReportOnCheck(Row, Column, State);
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view:"scrollview",
            scroll:"y",
            body:{
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless:true,
                        rows: [
                            {height:6},
                            PageHeaderTemplate({
                                id:this.Id + "PageTitle",
                                root_title:this.PageTitle.Title
                            }),
                            {height:32},
                            {
                                view:"label",
                                css:"form_text_label",
                                label:LangHelper.GetString("UlrModule","Select recipient group from the list")
                            },
                            this.Views.ReportsWidgets.RecipientGroupReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};

    this.Signals = {};
}

UlrRecipientGroupListViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.RecipientGroupDeleteError = this.ViewModel.Signals.RecipientGroupDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RecipientGroupDeleted = this.ViewModel.Signals.RecipientGroupDeleted.subscribe(function (RecipientGroupModel)
    {
        if(RecipientGroupModel)
        {
            _this.RecipientGroupReportOnSuccessDelete(RecipientGroupModel);

            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","RecipientGroup")+" # "+RecipientGroupModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );
        }
    });
};

UlrRecipientGroupListViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    this.Refresh();
};

UlrRecipientGroupListViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrRecipientGroupListViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrRecipientGroupListViewController.prototype.Refresh = function ()
{
    this.Views.ReportsWidgets.RecipientGroupReport.RefreshData();
};

UlrRecipientGroupListViewController.prototype.GetPageTitle = function ()
{
    if(this.PageTitle)
        return this.PageTitle;
};

UlrRecipientGroupListViewController.prototype.RecipientGroupReportOnItemClick = function(Id, E, Node)
{
    var _this = this;

    if(Id.column === 'edit' || (Id.column === 'name' && E.target && E.target.className == "webix_cell_link"))
    {
        var table = this.Views.ReportsWidgets.RecipientGroupReport.Views.Table;

        var data = table.getItem(Id);

        App.NavRouter.PresentView({id: ControllersEnum.UlrEditRecipientGroup, path:"/_id=" + data._id});
    }

    if(Id.column === 'delete')
    {
        var table = this.Views.ReportsWidgets.RecipientGroupReport.Views.Table;

        var data = table.getItem(Id);

        var node = table.getItemNode(Id);

        UlrShowDialogPopup({
            node:node,
            position:"bottom",
            head:LangHelper.GetString("UlrModule","Delete") + "?",
            //type:"spectre-alert-notification",
            mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
            message:LangHelper.GetString("UlrModule","Are you sure?"),
            actions:[
                {
                    css:"spec_action",
                    label:LangHelper.GetString("UlrModule","Cancel")
                },
                {
                    label:LangHelper.GetString("UlrModule","Delete"),
                    click:function ()
                    {
                        _this.ViewModel.DeleteRecipientGroup(data);
                    }
                }
            ]
        });
    }
};

UlrRecipientGroupListViewController.prototype.RecipientGroupReportOnCheck = function(Row, Column, State)
{
    var table = this.Views.ReportsWidgets.RecipientGroupReport.Views.Table;

    var data = table.getItem(Row);

    this.ViewModel.EnableDisableRecipientGroup(webix.extend(data, {callback:function (R)
        {
            if(!R.success)
            {
                data.enabled = State ? 0 : 1;

                table.updateItem(data.id, data);
            }
        }}), State);
};

UlrRecipientGroupListViewController.prototype.RecipientGroupReportOnSuccessDelete = function(RecipientGroupModel)
{
    var table = this.Views.ReportsWidgets.RecipientGroupReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == RecipientGroupModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        table.remove(data[0].id);

        if(!table.count())
            this.Refresh();
    }

};

UlrRecipientGroupListViewController.prototype.RecipientGroupProfileEnableStateUpdated = function(RecipientGroupModel)
{
    var table = this.Views.ReportsWidgets.RecipientGroupReport.Views.Table;

    var data = table.find(function(obj){
        return obj._id == RecipientGroupModel._id;
    });

    if(data && data.length == 1 && data[0].id)
    {
        data = data[0];
        data.enabled = RecipientGroupModel.enabled;
        table.updateItem(data.id, data);
    }

};

UlrRecipientGroupListViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};
function UlrEditRecipientGroupViewController() {
    var _this = this;

    this.ActionsEnum = {
        Add:"Add",
        Edit:"Edit"
    };

    this.Action = this.ActionsEnum.Edit;

    this.Id = "UlrEditRecipientGroup";

    this.mode = module ? module : "dpiui2";

    this.PageTitle = {
        RootTitle:LangHelper.GetString("UlrModule","Mailing"),
        Title:LangHelper.GetString("UlrModule","Edit recipient group")
    };

    this.ViewModel = new UlrRecipientGroupManager();

    this.ReportsModel = new UniReportsManager();

    this.Views = {
        AddContactBtn: null,
        DeleteBtn:null,
        ValueInput: null,
        TypeSelect: null,
        GroupEditForm: null,
        ContactEditForm: null,
        Widgets: {},
        PageTitle: null,
        ReportsWidgets:{
            RecipientContactReport: UlrRecipientContactTableWidget({
            id:this.Id + "RecipientContactReport",
            enableAutoHeight:1,
            enableLocalSort:1,
            hidePaginatorToolbar:1,
            enableLocalDataSource:1,
            dataSource:function (FilterParams)
            {
                return _this.ContactsReportDataSource(FilterParams);
            },
            onItemClick:function (Id, E, Node)
            {
                 _this.RecipientContactReportOnItemClick(Id, E, Node);
            }
        })}
    };

    this.ViewConfig = [{
            view:"scrollview",
            id:_this.Id + "ScrollView",
            scroll:"y",
            body:{
                type: "space",
                rows: 
                [
                    {
                        type: "clean",
                        borderless:true,
                        rows:
                            [
                                {height:6},
                                PageHeaderTemplate({
                                    id:_this.Id + "PageTitle",
                                    root_title: _this.PageTitle.Title
                                }),
                                {height:32},
                                {
                                    view:"form",
                                    id:_this.Id + "GroupEditForm",
                                    type: "wide",
                                    borderless:true,
                                    elements:[
                                        {
                                            type: "wide",
                                            rows: [
                                            {
                                                cols:[
                                                    {
                                                        view:"spectre_text",
                                                        name:"name",
                                                        label:LangHelper.GetString("UlrModule","Group name"),
                                                        required:true,
                                                        validate: webix.rules.isNotEmpty,
                                                        invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                        on: {
                                                            "onChange": function (Nv, Ov)
                                                            {
                                                                if(typeof Ov !== "undefined")
                                                                {
                                                                    if(Nv != Nv.trim())
                                                                    {
                                                                        this.setValue(Nv.trim());
                                                                        return;
                                                                    }

                                                                    this.validate();
                                                                }
                                                            }
                                                        }
                                                    }
                                                ]
                                            },

                                        ]}
                                    ]
                                },
                                {
                                    view:"form",
                                    id:_this.Id + "ContactEditForm",
                                    type: "wide",
                                    borderless:true,
                                    elements:[
                                        {
                                            type: "wide",
                                            rows: [
                                                {height:6},
                                                BlockHeaderTemplate({
                                                    title:LangHelper.GetString("UlrModule","Add contact"), icon:"",
                                                    borderless:true
                                                }),
                                                {
                                                    type:"wide",
                                                    cols:[
                                                        {
                                                            view:"spectre_richselect",
                                                            name: "type",
                                                            css:"form_element",
                                                            id: _this.Id + "TypeSelect",
                                                            label:LangHelper.GetString("UlrModule","Type"),
                                                            width:250,
                                                            height:51,
                                                            labelPosition:"top",
                                                            value:"email",
                                                            options:{
                                                                point: false,
                                                                data: Helper.DictToArr(UlrRecipientGroupContactTypeDic)
                                                            }
                                                        },
                                                        {
                                                            view:"spectre_text",
                                                            name:"value",
                                                            id:_this.Id + "ValueInput",
                                                            label:LangHelper.GetString("UlrModule","Value"),
                                                            keyPressTimeout: 500,
                                                            invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                            validate: function(Val)
                                                            {
                                                                var input = _this.Views.ValueInput;

                                                                var type = _this.Views.TypeSelect.getValue();

                                                                if (!webix.rules.isNotEmpty(Val)) {
                                                                    input.define("invalidMessage",LangHelper.GetString("UlrModule", "Required field"));
                                                                    return false;
                                                                }

                                                                if (_this.CheckDuplicate(input.getValue(), type))
                                                                {
                                                                    input.define("invalidMessage",LangHelper.GetString("UlrModule", "Duplicate"));
                                                                    return false;
                                                                }

                                                                if (type == UlrRecipientGroupContactTypeMapEnum.email && !webix.rules.isEmail(Val))
                                                                {
                                                                    input.define("invalidMessage",LangHelper.GetString("UlrModule", "Invalid E-Mail"));
                                                                    return false;
                                                                }

                                                                return true;
                                                            },
                                                            on: {
                                                                // "onTimedKeyPress": function ()
                                                                // {
                                                                //     let inputText = this.getValue();

                                                                //     if (inputText != "")
                                                                //         this.validate();
                                                                // },
                                                                "onChange": function (Nv, Ov)
                                                                {
                                                                    if(typeof Ov !== "undefined")
                                                                    {
                                                                        if(Nv != Nv.trim())
                                                                        {
                                                                            this.setValue(Nv.trim());
                                                                            return;
                                                                        }

                                                                        this.validate();
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        {
                                                            view:"spectre_button",
                                                            id:_this.Id + "AddContactBtn",
                                                            css:"form_button form_element spec_action",
                                                            label:LangHelper.GetString("UlrModule","Add"),
                                                            autowidth:true,
                                                            height:51,
                                                            disabled:true,
                                                            click:function ()
                                                            {
                                                                setTimeout(function ()
                                                                {
                                                                    _this.AddContact();
                                                                },1);
                                                            }
                                                        },
                                                        {}
                                                    ]
                                                },
                                                this.Views.ReportsWidgets.RecipientContactReport.ViewConfig,
                                                {
                                                    type:"wide",
                                                    cols: [
                                                        {
                                                            view:"spectre_button",
                                                            id: _this.Id + "SaveBtn",
                                                            css:"form_button main_action",
                                                            autowidth: true,
                                                            label:LangHelper.GetString("UlrModule","Save changes"),
                                                            click:function ()
                                                            {
                                                                _this._Save();
                                                            }
                                                        },
                                                        {},
                                                        {
                                                            view:"spectre_button",
                                                            id: this.Id + "DeleteBtn",
                                                            css:"form_button delete_action",
                                                            label:LangHelper.GetString("UlrModule","Delete"),
                                                            autowidth:true,
                                                            click:function ()
                                                            {
                                                                _this.Delete();
                                                            },
                                                            hidden:true
                                                        }
                                                    ]
                                                }
                                            ]}
                                    ]
                                },

                            ]
                    }
                ]
            },

    }];

    this.Subscriptions = {};

    this.Signals = {};
};

UlrEditRecipientGroupViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.ContactsInitialDataDic = this.ViewModel.Signals.ContactsInitialDataDicUpdated.subscribe(function (Updated)
    {
        if(Updated)
        {
            _this.Views.ReportsWidgets.RecipientContactReport.RefreshData();
        }
    });

    this.Subscriptions.RecipientGroupError = this.ViewModel.Signals.RecipientGroupError.subscribe(function (ErrModel)
    {
        var action = null;

        if(ErrModel&&ErrModel.code == 404)
        {
            action = function ()
            {
                setTimeout(function ()
                {
                    App.NavRouter.PresentView({id: ControllersEnum.UlrRecipientGroupList});
                }, 1);
            }
        }

        _this.ShowServerError(ErrModel, action);
    });

    this.Views.ValueInput.attachEvent("onKeyPress", function(code, e)
    {
        let input = _this.Views.ValueInput;

        setTimeout(() => {
            let inputText = input.getValue();

            let btn = _this.Views.AddContactBtn;
    
            webix.rules.isNotEmpty(inputText) ? btn.enable() : btn.disable();
        }, 10);
    });

    this.Subscriptions.RecipientGroupUpdated = this.ViewModel.Signals.RecipientGroupUpdated.subscribe(function (RecipientGroupModel) {
        if(RecipientGroupModel)
        {
            _this.DefineAll(RecipientGroupModel);
        }
    });

    this.Subscriptions.RecipientGroupSaved = this.ViewModel.Signals.RecipientGroupSaved.subscribe(function (RecipientGroupModel)
    {
        if(RecipientGroupModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Recipient group")+" # "+RecipientGroupModel.name+": "+LangHelper.GetString("UlrModule","Saving"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: ControllersEnum.UlrRecipientGroupList });
            },1);
        }
    });

    this.Subscriptions.RecipientGroupSaveError = this.ViewModel.Signals.RecipientGroupSaveError.subscribe(function (ErrModel)
    {
        _this.ShowServerError(ErrModel);
    });

    this.Subscriptions.RecipientGroupDeleted = this.ViewModel.Signals.RecipientGroupDeleted.subscribe(function (RecipientGroupModel)
    {
        if(RecipientGroupModel)
        {
            UlrShowMessage(
                "success",
                LangHelper.GetString("UlrModule","Recipient group")+" # "+RecipientGroupModel.name+": "+LangHelper.GetString("UlrModule","Deleting"),
                LangHelper.GetString("UlrModule","Success")
            );

            setTimeout(function ()
            {
                App.NavRouter.PresentView({id: ControllersEnum.UlrRecipientGroupList});
            },1);
        }
    });

    this.Subscriptions.RecipientGroupDeleteError = this.ViewModel.Signals.RecipientGroupDeleteError.subscribe(function (ErrModel)
    {
        if(ErrModel)
            _this.ShowServerError(ErrModel);
    });
};

UlrEditRecipientGroupViewController.prototype.CheckDuplicate = function (Val, Type)
{
    let table = this.Views.ReportsWidgets.RecipientContactReport.Views.Table;

    let result = table.find(function(obj){
        return obj.value.toLowerCase() == Val.toLowerCase() && obj.type == Type;
    });

    return result.length == 0 ? false : true;
};

UlrEditRecipientGroupViewController.prototype.ViewDidLoad = function (PathParams)
{
    var _this = this;

    this.PathParams = PathParams;

    this.BindAll(PathParams);

    this.Refresh();
};

UlrEditRecipientGroupViewController.prototype.Refresh = function () {
    this.RefreshGroup()
    this.Views.ReportsWidgets.RecipientContactReport.RefreshData();
}

UlrEditRecipientGroupViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

UlrEditRecipientGroupViewController.prototype.GetPathParam = function(Key)
{
    return App.NavRouter.GetPathParam(Key, this);
};

UlrEditRecipientGroupViewController.prototype.RefreshGroup = function ()
{
    var id = this.Action == this.ActionsEnum.Add ? "new" : this.GetPathParam("_id");

    this.ViewModel.RefreshRecipientGroup({_id: id});

    this.DefinePageTitle(this.Action == this.ActionsEnum.Add ?
        LangHelper.GetString("UlrModule","Add recipient group"):
        LangHelper.GetString("UlrModule","Edit recipient group") + " #" + id);

    if(this.Action == this.ActionsEnum.Edit)
        this.Views.DeleteBtn.show();
};

UlrEditRecipientGroupViewController.prototype.ContactsReportDataSource = function(FilterModel)
{
    var data = this.ViewModel.ContactsArrDicToArr(this.ViewModel.ContactsDics.InitialDataDic);

    var addedData = this.ViewModel.ContactsArrDicToArr(this.ViewModel.ContactsDics.AddedDataDic);

    return {rows:addedData.concat(data)};
};

UlrEditRecipientGroupViewController.prototype.AddContact = function()
{
    if (!this.Views.ValueInput.validate())
        return;

    var type = this.Views.TypeSelect.getValue();

    var value = this.Views.ValueInput.getValue();

    var table = this.Views.ReportsWidgets.RecipientContactReport.Views.Table;

    var model = new UlrRecipientContactViewModel({
        _id:webix.uid(),
        type,
        value,
    });

    var dataDics = this.ViewModel.ContactsDics;

    dataDics.AddedDataDic[model._id] = model;

    table.add(model,0);
    table.hideOverlay();
    table.hideProgress();

    this.Views.ValueInput.setValue("");

    this.Views.ContactEditForm.clearValidation();
};

UlrEditRecipientGroupViewController.prototype.RecipientContactReportOnItemClick = function(Id)
{
    if(Id.column === 'delete' || Id.column === 'enabled')
    {
        var table = this.Views.ReportsWidgets.RecipientContactReport.Views.Table;

        var data = table.getItem(Id);

        var dataDics = this.ViewModel.ContactsDics;

        if(Id.column === 'delete')
        {
            if(data._id)
            {
                if(data.is_added)
                {
                    delete dataDics.AddedDataDic[data._id];
                }
                else
                {
                    dataDics.RemovedDataDic[data._id] = dataDics.InitialDataDic[data._id];
                    delete dataDics.InitialDataDic[data._id];
                }
            }

            table.remove(Id);
        }
    }
};

UlrEditRecipientGroupViewController.prototype.DefineAll = function(RecipientGroupModel)
{
    var _this = this;

    this.Views.GroupEditForm.clearValidation();
    this.Views.GroupEditForm.clear();

    this.Views.GroupEditForm.setValues(RecipientGroupModel);
};

UlrEditRecipientGroupViewController.prototype._Save = function ()
{
    var _this = this;

    if (!this.Views.GroupEditForm.validate())
        return;

    var form = new UlrRecipientGroupModel(this.Views.GroupEditForm.getValues());

    form.contacts_json = JSON.stringify(this.Views.ReportsWidgets.RecipientContactReport.Views.Table.serialize());

    this.ViewModel.SaveRecipientGroup(form);
};

UlrEditRecipientGroupViewController.prototype.DefinePageTitle = function(Title)
{
    this.Views.PageTitle.define("data", {root_title:Title});

    App.NavRouter.views.AppView.SetPageHeaderTitle(this.PageTitle.RootTitle, Title);
};

UlrEditRecipientGroupViewController.prototype.ShowServerError = function(ErrModel, Action)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {
                        if(Action && typeof Action == "function")
                        {
                            Action();
                        }
                    }
                }
            ]
        });
};

UlrEditRecipientGroupViewController.prototype.Delete = function()
{
    var _this = this;

    var model = this.ViewModel.Signals.RecipientGroupUpdated.getValue();

    UlrShowDialogPopup({
        node:this.Views.DeleteBtn.getNode(),
        position:"bottom",
        head:LangHelper.GetString("UlrModule","Delete") + "?",
        mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
        message:LangHelper.GetString("UlrModule","Are you sure?"),
        actions:[
            {
                css:"spec_action",
                label:LangHelper.GetString("UlrModule","Cancel")
            },
            {
                label:LangHelper.GetString("UlrModule","Delete"),
                click:function ()
                {
                    _this.ViewModel.DeleteRecipientGroup(model);
                }
            }
        ]
    });
};

function UlrAddRecipientGroupViewController(Params)
{
    UlrAddRecipientGroupViewController.superclass.constructor.call(this, Params);

    this.Action = this.ActionsEnum.Add;
}

Helper.ExtendClass(UlrAddRecipientGroupViewController,UlrEditRecipientGroupViewController);
function DatetimePickerViewController() {

    this.Id = "DateTimePicker";

    var _this = this;

    this.Views = {
        DateTimeTimetable: null,
        DateTimetableSetDataForm: null,
        Timetable: null,
    }

    this.ViewModel = new DatetimePickerManager();

    this.Subscriptions = {};

    this.ViewConfig = {
        rows:function ()
        {
            var rows = [];

            rows.push({
                id: _this.Id + "Timetable",
                view: "datatable",
                select: "row",
                scroll:false,
                resizeColumn:true,
                // autowidth: true,
                autoheight: true,
                on: {
                    onItemClick: function (id, event, node) {
                        if (id.column === "Delete") {
                            _this.TimetableDeleteRow(_this.Views.Timetable.getSelectedItem());
                        } else if (id.column === "Edit") {
                            var selectedItem = _this.Views.Timetable.getSelectedItem();

                            _this.Views.DateTimetableSetDataForm.setValues(selectedItem);
                            _this.ShowTimetableSetDataForm(null, this.getItemNode(id), {pos: "right"});
                        }
                    },
                    onAfterRender: function () {
                        if (!this.count())
                            this.showOverlay("<br/><br/><br/>" + LangHelper.GetString("Tariffs", "Click + to add a schedule"));
                        else
                            this.hideOverlay();
                    }
                },
                columns: [
                    {
                        id: "Time",
                        minWidth: 150,
                        maxWidth: 250,
                        fillspace: 1,
                        header: [LangHelper.GetString("UlrModule", "Mailing time")],
                        tooltip: false,
                        template: function(Obj, Common, Value)
                        {
                            return Obj.startTime && Obj.endTime ? Obj.startTime + "-" + Obj.endTime : (Obj.startTime ? Obj.startTime : (Obj.endTime ? Obj.endTime : ""));
                        }
                    },
                    {
                        id: "reportTime",
                        minWidth: 150,
                        maxWidth: 250,
                        fillspace: 1,
                        header: [LangHelper.GetString("UlrModule", "Report time")],
                        tooltip: false,
                        template: function(Obj, Common, Value)
                        {
                            return Obj && Obj.reportTime ? Obj.reportTime : "";
                        }
                    },
                    {
                        id: 1,
                        minWidth: 50,
                        maxWidth: 150,
                        fillspace: 1,
                        header: [LangHelper.GetString("Tariffs", "Mon")],
                        tooltip: false,
                        template: function (Obj, Common, Value) {
                            if (typeof Obj[this.id] !== "undefined")
                                return DateTimePickerCellColoredCheckBoxTemplate(Obj, Common, Value);

                            return "";
                        }
                    },
                    {
                        id: 2,
                        minWidth: 50,
                        maxWidth: 150,
                        fillspace: 1,
                        header: [LangHelper.GetString("Tariffs", "Tue")],
                        tooltip: false,
                        template: function (Obj, Common, Value) {
                            if (typeof Obj[this.id] !== "undefined")
                                return DateTimePickerCellColoredCheckBoxTemplate(Obj, Common, Value);

                            return "";
                        }
                    },
                    {
                        id: 3,
                        minWidth: 50,
                        maxWidth: 150,
                        fillspace: 1,
                        header: [LangHelper.GetString("Tariffs", "Wed")],
                        tooltip: false,
                        template: function (Obj, Common, Value) {
                            if (typeof Obj[this.id] !== "undefined")
                                return DateTimePickerCellColoredCheckBoxTemplate(Obj, Common, Value);

                            return "";
                        }
                    },
                    {
                        id: 4,
                        minWidth: 50,
                        maxWidth: 150,
                        fillspace: 1,
                        header: [LangHelper.GetString("Tariffs", "Thu")],
                        tooltip: false,
                        template: function (Obj, Common, Value) {
                            if (typeof Obj[this.id] !== "undefined")
                                return DateTimePickerCellColoredCheckBoxTemplate(Obj, Common, Value);

                            return "";
                        }
                    },
                    {
                        id: 5,
                        minWidth: 50,
                        maxWidth: 150,
                        fillspace: 1,
                        header: [LangHelper.GetString("Tariffs", "Fri")],
                        tooltip: false,
                        template: function (Obj, Common, Value) {
                            if (typeof Obj[this.id] !== "undefined")
                                return DateTimePickerCellColoredCheckBoxTemplate(Obj, Common, Value);

                            return "";
                        }
                    },
                    {
                        id: 6,
                        minWidth: 50,
                        maxWidth: 150,
                        fillspace: 1,
                        header: [LangHelper.GetString("Tariffs", "Sat")],
                        tooltip: false,
                        template: function (Obj, Common, Value) {
                            if (typeof Obj[this.id] !== "undefined")
                                return DateTimePickerCellColoredCheckBoxTemplate(Obj, Common, Value);

                            return "";
                        }
                    },
                    {
                        id: 7,
                        minWidth: 50,
                        maxWidth: 150,
                        fillspace: 1,
                        header: [LangHelper.GetString("Tariffs", "Sun")],
                        tooltip: false,
                        template: function (Obj, Common, Value) {
                            if (typeof Obj[this.id] !== "undefined")
                                return DateTimePickerCellColoredCheckBoxTemplate(Obj, Common, Value);

                            return "";
                        }
                    },
                    {fillspace:1},
                    {
                        id: "Delete",
                        header: "",
                        width: 32,
                        template: CellTrashBtnTemplate,
                        headermenu: false,
                        align:"right"
                    },
                    {width: 16}
                ]
            })
            return rows
        }()
    }

    this.DateTimetableSetDataForm = {
        rows: function (){
            var rows = [];
            rows.push(
                {
                    type:"wide",
                    view:"form",
                    id:_this.Id + "TimetableSetDataForm",
                    borderless:true,
                    elements:[
                        {
                            type:"wide",
                            cols:[
                                {
                                    view:"spectre_toggle",
                                    name:"setReportTimeToggle",
                                    height:22,
                                    width:22,
                                    on:{
                                        onChange:function(Nv, Ov)
                                        {
                                            if(Nv)
                                            {
                                                let startTime = _this.Views.DateTimetableSetDataForm.elements.startTime.getValue();
                                                _this.Views.DateTimetableSetDataForm.elements.reportTime.setValue(startTime);
                                                _this.Views.DateTimetableSetDataForm.elements.reportTime.show();
                                            }
                                            else
                                            {
                                                _this.Views.DateTimetableSetDataForm.elements.reportTime.setValue("");
                                                _this.Views.DateTimetableSetDataForm.elements.reportTime.hide();
                                            }
                                        }
                                    }
                                },
                                {
                                    rows:[
                                        BlockHeaderTemplate({
                                            title:LangHelper.GetString("UlrModule","Set report time"),
                                            icon:"",
                                            borderless:true
                                        })
                                    ]
                                },
                                {}
                            ]
                        },
                        {
                            type:"wide",
                            cols:[
                                {
                                    view: "spectre_datepicker",
                                    type: "time",
                                    height:51,
                                    name: "startTime",
                                    autowidth: true,
                                    tooltip: LangHelper.GetString("UlrModule", "Mailing time"),
                                    labelPosition: "top",
                                    label: LangHelper.GetString("UlrModule", "Mailing time"),
                                    required: true,
                                    stringResult: true,
                                    validate: function(Val)
                                    {
                                        var datepicker = _this.Views.DateTimetableSetDataForm.elements["startTime"];
                
                                        if(!Val){
                                            datepicker.define("invalidMessage",LangHelper.GetString("Tariffs", "Required field"));
                                            return false;
                                        }
                
                                        var endTime = _this.Views.DateTimetableSetDataForm.elements["endTime"].getValue();
                
                                        datepicker.define("invalidMessage",LangHelper.GetString("Tariffs", "Invalid time"));
                
                                        if(endTime)
                                            return (Val != endTime);
                
                                        return true;
                                    }
                                },
                                {
                                    view: "spectre_datepicker",
                                    type: "time",
                                    height:51,
                                    hidden: true,
                                    name: "endTime",
                                    autowidth: true,
                                    tooltip: LangHelper.GetString("Tariffs", "End time"),
                                    labelPosition: "top",
                                    label: LangHelper.GetString("Tariffs", "End time"),
                                    required: true,
                                    stringResult: true,
                                    validate: function(Val)
                                    {
                                        var datepicker = _this.Views.DateTimetableSetDataForm.elements["endTime"];
                
                                        if(!Val){
                                            datepicker.define("invalidMessage",LangHelper.GetString("Tariffs", "Required field"));
                                            return false;
                                        }
                                        var startTime = _this.Views.DateTimetableSetDataForm.elements["startTime"].getValue();
                
                                        datepicker.define("invalidMessage",LangHelper.GetString("Tariffs", "Invalid time"));
                
                                        if(startTime)
                                            return(Val != startTime)
                
                                        return true;
                                    }
                                },
                                {
                                    view: "spectre_datepicker",
                                    type: "time",
                                    height:51,
                                    name: "reportTime",
                                    autowidth: true,
                                    tooltip: LangHelper.GetString("UlrModule", "Report time"),
                                    labelPosition: "top",
                                    label: LangHelper.GetString("UlrModule", "Report time"),
                                    stringResult: true,
                                    hidden:true
                                },
                                {
                                    view: "spectre_multiselect",
                                    name: "weekday",
                                    height:51,
                                    label:LangHelper.GetString("Tariffs", "Days of the week"),
                                    labelPosition: "top",
                                    tooltip:LangHelper.GetString("Tariffs", "Days of the week"),
                                    required: true,
                                    invalidMessage: LangHelper.GetString("Tariffs", "Required field"),
                                    value: [1,2,3,4,5,6,7],
                                    options: Helper.DictToArr(DaysOfWeekDic),
                                },
                                {
                                    view:"spectre_button",
                                    css:"form_button form_element spec_action",
                                    label:LangHelper.GetString("UlrModule","Add"),
                                    autowidth: true,
                                    height:51,
                                    click:function(){
                                        var form = _this.Views.DateTimetableSetDataForm;
        
                                        var values = form.getValues();
        
                                        values.weekday = typeof(values.weekday) === "string" ? values.weekday.split(",") : values.weekday;
        
                                        _this.SetDataToTimetable(values);
                                    }
                                },
                                {}
                            ]
                        },
                    ]
                }
            )

            return rows;
        }(),
    };
}

DatetimePickerViewController.prototype.BindAll = function (Params) {
    "use strict";
    var _this = this;

    this.Views.Self = $$(this.Id);

    this.Views.Timetable = $$(this.Id + "Timetable");
    this.Views.DateTimetableSetDataForm = $$(this.Id + "TimetableSetDataForm");
    this.Views.TimetableAddRowButton = $$(this.Id + "TimetableAddRow");
    this.Views.TimetableRefreshButton = $$(this.Id + "TimetableRefresh");
    this.Views.TimetableSaveButton = $$("SaveTableButton");
    this.Views.TimetableEnableCheckbox = $$(this.Id + "TimetableEnabledCheckbox");
    this.Views.TimetableButton = $$(this.Id+"TimetableBtn");

    webix.extend(this.Views.Timetable, webix.ProgressBar);
};

DatetimePickerViewController.prototype.ShowTimetable = function (Node, Pos)
{
    this.DateTimeTimetable.show(Node,Pos);
}

DatetimePickerViewController.prototype.ShowTimetableSetDataForm = function(Data, Node, Pos)
{
    this.DateTimetableSetDataForm.show(Node,Pos);
};

DatetimePickerViewController.prototype.LoadDataToTimetable = function (scheduleConfigJson)
{
    this.Views.Timetable.clearAll();
    this.Views.Timetable.hideOverlay();

    if (scheduleConfigJson)
    {
        let scheduleConfig = JSON.parse(scheduleConfigJson);

        scheduleConfig = scheduleConfig.map((item) => DatetimePickerLocalTimeModel(item));

        this.Views.Timetable.parse(scheduleConfig);
    }
};

DatetimePickerViewController.prototype.ConfigureTimetable = function(Models = null)
{
    var _this = this;
    var items = [];

    if(Models) {
        Models.forEach(model => {
            items.push({
                id:model.profile_id,
                value:model.title
            })
        });
    }

    this._LoadDataToTimetable();
};

DatetimePickerViewController.prototype._LoadDataToTimetable = function()
{
    this.Views.TimetableAddRowButton.enable();
    this.Views.TimetableRefreshButton.enable();
    this.Views.TimetableSaveButton.enable();
    this.Views.TimetableEnableCheckbox.enable();

    this.Views.Timetable.refresh();
};

DatetimePickerViewController.prototype.SetDataToTimetable = function(values)
{
    if(this.ValidateSetDataForm()){
        values.hasOwnProperty('id')?
            this.Views.Timetable.updateItem(this.Views.Timetable.getSelectedId().row, new DatetimePickerModel(values)):
            this.Views.Timetable.add(new DatetimePickerModel(values), this.Views.Timetable.count());
        this.ClearAndHideTimetableSetDataForm();
    }
}

DatetimePickerViewController.prototype.ValidateSetDataForm = function()
{
    return this.Views.DateTimetableSetDataForm.validate();
};

DatetimePickerViewController.prototype.ClearAndHideTimetableSetDataForm = function()
{
    this.Views.DateTimetableSetDataForm.clear();
    this.Views.DateTimetableSetDataForm.clearValidation();
};

DatetimePickerViewController.prototype.TimetableDeleteRow = function(deleteRow)
{
    this.Views.Timetable.remove(deleteRow.id);
};
function QueriesTableViewController(Params) {

    this.Id = "QueriesTable";

    var _this = this;

    this.ExceptWidgetCodes = Params && Params.exceptWidgetCodes && Params.exceptWidgetCodes.length ? Params.exceptWidgetCodes : [];

    this.QoEStorConfigManager = new QoEStorConfigManager();

    this.AggValues = {
        "FULLFLOW_AGG_LOG_GROUP_TIME_INTERVAL": "",
        "CLICKSTREAM_AGG_LOG_GROUP_TIME_INTERVAL": ""
    }

    this.InitedWidgets = {};

    this.Views = {
        WidgetsInput: null,
        QueriesTableForm: null,
        ReportRichSelect: null,
        WidgetsSuggest: new QoEWidgetsSuggestWidget({
            id:this.Id + "WidgetsSuggest",
            exceptWidgetCodes: this.ExceptWidgetCodes
        }),
        ExtendedFillter: new QoEPopupFilterWidget({
            id:this.Id + "ExtendedFillter",
            config:QoEPopupFilterWidgetDefaultConfig()
        }),
        ReportsWidgets: {},
        Widgets: {},
    };

    this.Subscriptions = {};

    this.ViewConfig = {
        rows: function () {
            var rows = [];

            rows.push({
                rows:[
                    BlockHeaderTemplate({
                        title:LangHelper.GetString("QoE","Queries"), icon:"",
                        borderless:true
                    }),
                    {height:6},
                    {
                        cols: [
                            // {
                            //     view:"spectre_combo",
                            //     id:_this.Id + "WidgetsInput",
                            //     name:"widgets",
                            //     label:LangHelper.GetString("UlrModule","Widgets"),
                            //     validate: webix.rules.isNotEmpty,
                            //     invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                            //     suggest: {
                            //         view: "gridsuggest",
                            //         // id:_this.Id + "WidgetsInput",
                            //         body: _this.Views.WidgetsSuggest.Views.WidgetsList
                            //     },
                            //     on:{
                            //         onChange:function(Nv, Ov)
                            //         {
                            //             if(Nv && typeof Nv == "string" && Nv != Nv.trim())
                            //             {
                            //                 this.setValue(Nv.trim());
                            //                 return;
                            //             }
                            //         }
                            //     }
                            // },
                            {
                                view:"spectre_button",
                                // id:_this.Id + "AddRecipientGroupBtn",
                                css:"form_button form_element spec_action",
                                label:LangHelper.GetString("UlrModule","Add"),
                                autowidth: true,
                                height:51,
                                click:function ()
                                {
                                    const n = "QoETableTopRttSubscribersShortWidget";
                                    const w = _this.GetInitWidget(null, n);
                                    const model = new QoETriggerQueryModel({
                                        enabled:1,
                                        widget_name:n,
                                        widget_func:n,
                                        widget_config:w.Config,
                                        widget_filter:w.Filter,
                                        widget_pdf_config:_this._GetWidgetExportPdfConfig(w),
                                        period_from:"now - 15 minutes",
                                        period_to:"now"
                                    });

                                    _this.Views.QueriesTableForm.add(model);
                                    _this.Views.QueriesTableForm.select(model.id, false);
                                }
                            },
                            {}
                        ]
                    },
                    {height:20},
                    {
                        id: _this.Id + "GroupQueries",
                        body:{
                            rows:[
                                {
                                    id:_this.Id + "QueriesTableForm",
                                    view: "datatable",
                                    select: "row",
                                    resizeColumn:true,
                                    tooltip:true,
                                    scroll:false,
                                    editable:true,
                                    checkboxRefresh:true,
                                    autoheight:true,
                                    //header:false,
                                    drag: true,
                                    columns:
                                        [
                                            {
                                                id: "drag",
                                                header: "",
                                                template: CellDragAndDropBtnTemplate,
                                                width: 40,
                                                headermenu: false
                                            },
                                            {
                                                id: "enabled",
                                                header: "",
                                                template: CellCheckboxSwitchOnOffTemplate,
                                                width: 80,
                                                headermenu: false
                                            },
                                            {
                                                id:"name",
                                                header: LangHelper.GetString("QoE", "Report name"),
                                                editor: "text",
                                                fillspace: 2,
                                                template: function (Obj)
                                                {
                                                    if (!Obj.name || Obj.name.length < 2) {
                                                        var item = _this.Views.WidgetsSuggest.FindItemByConfig({func: Obj.widget_name ? Obj.widget_name : ""});
                                                        var locale = LangHelper.GetLocale();
                                                        Obj.name = item && item.widget_name && item.widget_name[locale] ? item.widget_name[locale] : "";
                                                    }
                                                    Obj.report_name = Obj.name;
                                                    return "<span><i class=\"webix_icon fa-pencil\" style=\"cursor:pointer;\"></i>"+Obj.name+"</span>";
                                                },
                                            },
                                            {
                                                id:"widget_name",
                                                header: LangHelper.GetString("QoE","Report"),
                                                fillspace:2,
                                                template:function (Obj)
                                                {
                                                    const locale = LangHelper.GetLocale();
                                                    const item = _this.Views.WidgetsSuggest.FindItemByParams(Obj);
                                                    return item && item.widget_name && item.widget_name[locale]
                                                        ? item.widget_name[locale]
                                                        : "";
                                                }
                                            },
                                            {
                                                id: "filter",
                                                width: 48,
                                                header: "",//LangHelper.GetString("QoE","Filter"),
                                                template: CellFilterBtnTemplate,
                                                headermenu: false
                                            },
                                            {width:100},
                                            {
                                                id:"period_from",
                                                header: TooltipTemplate(LangHelper.GetString("QoE","Period from")),
                                                width:150,
                                                editor:"richselect",
                                                suggest: {fitMaster:false, width:240},
                                                options:function ()
                                                {
                                                    var o = [];

                                                    Object.keys(QoETriggerPeriodRangesEnum).forEach(function (Key) {
                                                        o.push({id:Key, value:LangHelper.GetString("QoE",Key)})
                                                    });

                                                    return o;
                                                }(),
                                                template: function (Obj)
                                                {
                                                    return LangHelper.GetString("QoE",Obj.period_from);
                                                }
                                            },
                                            {
                                                id:"period_to",
                                                header: TooltipTemplate(LangHelper.GetString("QoE","Period to")),
                                                width:150,
                                                editor:"richselect",
                                                suggest: {fitMaster:false, width:240},
                                                options:function ()
                                                {
                                                    var o = [];

                                                    Object.keys(QoETriggerPeriodRangesEnum).forEach(function (Key) {
                                                        o.push({id:Key, value:LangHelper.GetString("QoE",Key)})
                                                    });

                                                    return o;
                                                }(),
                                                template: function (Obj)
                                                {
                                                    return LangHelper.GetString("QoE",Obj.period_to);
                                                }
                                            },
                                            {
                                                id:"widget_max_execution_time",
                                                header: TooltipTemplate(LangHelper.GetString("QoE", "Maximum report execution time")),
                                                width:150,
                                                editor:"richselect",
                                                suggest: {fitMaster:false, width:240},
                                                options:[
                                                    {id:60, value: LangHelper.GetString("QoE", "1 minute")},
                                                    {id:300, value: LangHelper.GetString("QoE", "5 minutes")},
                                                    {id:600, value: LangHelper.GetString("QoE", "10 minutes")},
                                                    {id:900, value: LangHelper.GetString("QoE", "15 minutes")},
                                                    {id:1800, value: LangHelper.GetString("QoE", "30 minutes")},
                                                    {id:3600, value: LangHelper.GetString("QoE", "1 hour")},
                                                    {id:7200, value: LangHelper.GetString("QoE", "2 hours")},
                                                    {id:21600, value: LangHelper.GetString("QoE", "6 hours")},
                                                    {id:43200, value: LangHelper.GetString("QoE", "12 hours")},
                                                    {id:86400, value: LangHelper.GetString("QoE", "24 hours")},
                                                ]
                                            },
                                            {
                                                fillspace:1
                                            },
                                            {
                                                id: "report_settings",
                                                header: "",
                                                width: 32,
                                                tooltip: LangHelper.GetString("AppView", "Report settings"),
                                                headermenu: false,
                                                template: function(item)
                                                {
                                                    let settingBtn = "";
                                                    if(_this.IsExportReportEditable(item))
                                                        settingBtn = CellSettingsBtnTemplate();
                                                    return settingBtn;
                                                },
                                            },
                                            {
                                                id: "eye",
                                                width: 32,
                                                header: "",
                                                template: CellEyeBtnTemplate,
                                                headermenu: false
                                            },
                                            {
                                                id: "trash",
                                                width: 32,
                                                header: "",
                                                template: CellTrashBtnTemplate,
                                                headermenu: false
                                            },
                                            {width: 16}
                                        ],
                                    on:
                                        {
                                            onItemClick: function (id,e,node)
                                            {
                                                if(id.column === 'trash')
                                                {
                                                    this.remove(id);
                                                }

                                                if(id.column === 'widget_name')
                                                {
                                                    _this.Views.WidgetsSuggest.Show(this.getItemNode({column:"widget_name", row:id.row}),"bottom");
                                                }

                                                if(id.column === 'filter' || id.column === 'eye')
                                                {
                                                    let fType, fConfig;
                                                    const node = this.getItemNode(id);
                                                    const rowData = this.getItem(id);

                                                    const ws = _this.Views.WidgetsSuggest.FindItemByParams(rowData);

                                                    fConfig = ws && ws.filter_config
                                                        ? ws.filter_config
                                                        : null;

                                                    fType = fConfig && fConfig.type
                                                        ? fConfig.type
                                                        : ws && ws.filter_type ? ws.filter_type : null;

                                                    if(!fType && rowData.widget_name) {
                                                        var wn = rowData.widget_name.toLowerCase();

                                                        if(wn.indexOf("clickstream") >= 0)
                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawClickstreamLogs : QoEPopupFilterWidgetConfigTypeEnum.QoEClickstream;

                                                        else if(wn.indexOf("fullnetflow") >= 0 || wn.indexOf("fullflow") >= 0)
                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullNetFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullNetFlow;

                                                        else if(wn.indexOf("dns") >= 0)
                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDnsFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullDnsFlow;

                                                        else if(wn.indexOf("dns") >= 0)
                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDnsFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullDnsFlow;

                                                        else if(wn.indexOf("ddos") >= 0)
                                                            fType = wn.indexOf("raw") >= 0 ? QoEPopupFilterWidgetConfigTypeEnum.QoERawFullDdosAttackFlow : QoEPopupFilterWidgetConfigTypeEnum.QoEFullDdosAttackFlow;
                                                    }

                                                    if(!fConfig)
                                                        fConfig = QoEPopupFilterWidgetDefaultConfig(fType);

                                                    _this.Views.ExtendedFillter.SetConfig(fConfig);

                                                    if(rowData.filter_state && fType == rowData.filter_type)
                                                        _this.Views.ExtendedFillter.SetState(rowData.filter_state);
                                                    else
                                                        _this.Views.ExtendedFillter.SetState();

                                                    rowData.filter_type = fType;

                                                    if(id.column === 'filter')
                                                        _this.Views.ExtendedFillter.Show(node, "right");
                                                }

                                                if(id.column === 'report_settings')
                                                {
                                                    let item = this.getItem(id);

                                                    let node = this.getItemNode(id);

                                                    if(_this.IsExportReportEditable(item))
                                                    {
                                                        let popupContext = _this.EditExportReportConfigPopup(item);
                                                        popupContext.show(node, {pos: "left"});
                                                    }
                                                }

                                                if(id.column === 'eye')
                                                {
                                                    _this.BuildSelectedReport();
                                                }
                                            }
                                        }
                                }
                            ]
                        }
                    },
                ]
            })
            return rows
        }()

    }
}

QueriesTableViewController.prototype.BindAll = function (Params) {
    var _this = this;

    Object.keys(this.Views).forEach(function (View) {
        if (View != "Widgets" && View != "ReportsWidgets" && View != "ExtendedFillter" && View != "WidgetsSuggest")
            _this.Views[View] = $$(_this.Id + View)
    });

    this.Views.WidgetsSuggest.Bind(this);

    this.Views.ExtendedFillter.Bind(this);

    // this.Views.WidgetsSuggest.Views.WidgetsList
    //
    // debugger
    //
    // this.Views.WidgetsInput.define("body", this.Views.WidgetsSuggest.Views.WidgetsList)

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey) {
        _this.Views.Widgets[WidgetKey].Bind(_this);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey) {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if (w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if (w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.WidgetsListSelectSignal = this.Views.WidgetsSuggest.Signals.Select.subscribe(function (Params)
    {
        if(Params && Params.widget_code) {
            let widget = _this.GetInitWidget(Params.widget_code);

            if(!widget)
                return;

            const params = {
                widget_code: Params.widget_code,
                widget_name: widget.Name,
                widget_func: Params.func,
                widget_config: widget.Config,
                widget_filter: widget.Filter,
                widget_pdf_config: _this._GetWidgetExportPdfConfig(widget)
            };

            // if(Params.filter_config) {
            //     params.filter_config = Params.filter_config;
            //     params.filter_type = Params.filter_config.type;
            // }

            let formItem = _this.Views.QueriesTableForm.getSelectedItem();
            formItem = webix.extend(formItem, params, true);

            _this.Views.QueriesTableForm.updateItem(
                formItem.id,
                new QoETriggerQueryModel(formItem)
            );
        }
    });

    this.Subscriptions.ExtendedFilterApplySignal = this.Views.ExtendedFillter.ApplyStateSignal.subscribe(function (Signal)
    {
        if(Signal)
        {
            var selectedData = _this.Views.QueriesTableForm.getSelectedItem();

            selectedData.filter_state = _this.Views.ExtendedFillter.GetState();

            selectedData.filter_config = _this.Views.ExtendedFillter.GetFilters();

            if(selectedData.widget_pdf_config && parseInt(selectedData.widget_pdf_config.display_filter))
            {
                selectedData.widget_pdf_config.locales.filter_section = _this.Views.ExtendedFillter.GetLocales();
            }

            _this.Views.QueriesTableForm.updateItem(selectedData.id,  new QoETriggerQueryModel(selectedData));
        }
    });

    this.Subscriptions.SignalQoEStorConfigFileUpdated = this.QoEStorConfigManager.Signals.ConfigFileUpdated.subscribe(function(Val) {
        if(Val) {
            Object.keys(_this.AggValues).forEach(key => {
                if(_this.QoEStorConfigManager.ConfigModel[key])
                {
                    _this.AggValues[key] = _this.QoEStorConfigManager.ConfigModel[key]
                }
            });
        }
    });

    this.Views.QueriesTableForm.attachEvent("onBeforeDrag", function(context, e){
        if (e && e.target && e.target.className && e.target.className.includes("fa-arrows"))
            return true

        return false
    });

    this.QoEStorConfigManager.Refresh({silent:true});

    this.Views.WidgetsSuggest.RefreshWidgets();
}


QueriesTableViewController.prototype.GetInitWidget = function(WidgetCode = null, WidgetName = null)
{
    if(!WidgetCode && !WidgetName)
        return;

    let widget = WidgetCode ? this.InitedWidgets[WidgetCode] : null;

    if(widget)
        return widget;

    const ws = this.Views.WidgetsSuggest.FindItem(WidgetCode, WidgetName, WidgetName);

    widget = ws && ws.widget_code ? this.InitedWidgets[ws.widget_code] : null;

    if(widget)
        return widget;

    const wType = ws && ws.widget_icon ? ws.widget_icon : null;
    const wFunc = ws && ws.func ? ws.func : null;
    const wParams = ws && ws.widget_settings ? ws.widget_settings : {};

    if(!window[wFunc])
        return;

    const w = new window[wFunc](wParams);
    this.InitedWidgets[ws.widget_code] = Helper.IsTableChartWidget(w) ? w.GetSubWidget(wType) : w;

    return this.InitedWidgets[ws.widget_code];
};

QueriesTableViewController.prototype._GetWidgetExportPdfConfig = function (Widget)
{
    let config = null;

    if(Widget.PdfExportConfig) {
        if(Widget.PdfExportConfig.view_type === "table")
            Widget.AddAllColumnLocales();
        config = WidgetPdfConfigModel({widget_pdf_config: Widget.PdfExportConfig});
    }

    return config;
};

QueriesTableViewController.prototype.BuildSelectedReport = function (SelectedWidgetName)
{
    var _this = this;

    var item = _this.Views.QueriesTableForm.getSelectedItem();

    var prepareRange = function (Str)
    {
        return Str
            .replace("now - ", "now/-")
            .replace("minutes", "minute")
            .replace("hours", "hour")
            .replace("days", "day")
            .replace("months", "month")
            .replace("years", "year")
    };

    if(item && item.widget_code)
    {
        var filterStateConfig =
        {
            filter_state:_this.Views.ExtendedFillter.GetState(),
            filter_config: _this.Views.ExtendedFillter.GetFilters()
        };


        var format =  webix.Date.dateToStr("%Y-%m-%d %H:%i:%s");

        var ParseRangeDate = QoEDateRangePickerWidget.prototype.ParseRangeDate;

        var periodState = {
            period_from:format(ParseRangeDate(prepareRange(item.period_from))),
            period_to:format(ParseRangeDate(prepareRange(item.period_to)))
        };

        var storedReport = new QoEStoredReportBaseModel({
            _id: webix.uid(),
            widget_code:item.widget_code,
            widget_name:item.widget_name,
            widget_func:item.widget_func,
            filter_config_json: JSON.stringify(filterStateConfig),
            period_state_json: JSON.stringify(periodState)
        });

        var manager = new QoEReportsManager();

        manager.SaveStoredReport(storedReport, function (R) {
            if(R && R.success && R.data)
            {
                window.open("/#UlrQoEAnyReport/report_id=" + R.data._id, "_blank");
            }

            manager.Destroy();
        });
    }
};

QueriesTableViewController.prototype.IsExportReportEditable = function(Item)
{
    let result = false;

    if (Item.widget_config&&Item.widget_pdf_config)
    {
        if (Item.widget_pdf_config.view_type&&["chart", "pie_chart", "bar_chart", "table"].includes(Item.widget_pdf_config.view_type))
        {
            result = true;
        }
    }
    return result;
}

QueriesTableViewController.prototype.IsExportReportRowsLimitEditable = function(Item)
{
    let result = false;

    if (["chart", "bar_chart"].includes(Item.widget_pdf_config.view_type)&&
        Item.widget_config.cols&&
        Item.widget_config.cols.length&&
        Item.widget_config.cols[0].values&&
        Item.widget_config.cols[0].values.params&&
        Item.widget_config.cols[0].values.params&&
        Item.widget_config.cols[0].values.params.limit
    )
    {
        result = true;
    } else if (["pie_chart", "table"].includes(Item.widget_pdf_config.view_type)) {
        result = true;
    }
    return result;
}

QueriesTableViewController.prototype.EditExportReportConfigPopup = function(Item)
{
    let _this = this;
    let popupId = this.Id + "EditReportConfigPopup";
    let width = 350;
    let labelWidth = 170;
    let defaultChartLimit = 50;
    let defaultPieChartLimit = 10;
    let elements = [];

    if (["chart", "bar_chart"].includes(Item.widget_pdf_config.view_type) && EditableSeriesChartSeriesWidgetList.includes(Item.widget_name))
    {
        const
            curLangCode = LangHelper.GetLocale(),
            reverseDic = LangHelper.GetReverseLangDic(curLangCode),
            options = [],
            isEmptySeriesConfig = !Item.widget_pdf_config.series_config.length;

        Item.widget_config.values.forEach((item) => {
            let value = Helper.IsBase64Safe(item.alias) ? Helper.DecodeBase64Safe(item.alias) : item.alias;
            let langKeys = LangHelper.SearchLangKeys(value, reverseDic);

            if (langKeys.length)
                value = LangHelper.GetStringByLangKeys(curLangCode, langKeys);

            if (isEmptySeriesConfig)
            {
                Item.widget_pdf_config.series_config.push({id: item.alias, name: value, value: item.alias, isEnable: 1});
            }

            options.push({id:item.alias, value:value});
        });

        let values = Item.widget_pdf_config.series_config && Item.widget_pdf_config.series_config.length
            ? Item.widget_pdf_config.series_config.filter(col => Number(col.isEnable)).map(col => col.id)
            : options.map(col => col.id);

        let el = {
            view:"multiselect",
            label:LangHelper.GetString("AppView", "Columns visibility"),
            width:width,
            labelWidth:labelWidth,
            tooltip:LangHelper.GetString("AppView", "Columns visibility"),
            value:values,
            suggest: {fitMaster: false, data:options},
            on:{
                onChange:function()
                {
                    let selected_items = this.getValue().split(",");
                    if (selected_items.length === 1 && selected_items[0] === "") {
                        this.setValue(options[0].id);
                        selected_items = this.getValue().split(",");
                    }

                    for (const config of Item.widget_pdf_config.series_config) {
                        if (selected_items.includes(config.id))
                            config.isEnable = 1;
                        else
                            config.isEnable = 0;
                    }
                }
            }
        }

        elements.push(el);
    }

    if(["chart", "bar_chart"].includes(Item.widget_pdf_config.view_type)) {
        let curType = Item.widget_pdf_config.view_type === "bar_chart" ? "stackedBar" : Item.widget_pdf_config.graph_line_type;

        let el = {
            view:"richselect",
            label:LangHelper.GetString("AppView", "Chart type"),
            width:width,
            labelWidth:labelWidth,
            tooltip:LangHelper.GetString("AppView", "Chart type"),
            value:curType,
            options: Helper.DictToArr(ChartTypesDic),
            suggest: {fitMaster: false, data:Helper.DictToArr(ChartTypesDic)},
            on:{
                onChange:function()
                {
                    let selectedItem = this.getValue();

                    if(selectedItem === "stackedBar") {
                        Item.widget_pdf_config.view_type = "bar_chart";
                        Item.widget_pdf_config.graph_line_type = "";
                    } else {
                        Item.widget_pdf_config.view_type = "chart";
                        Item.widget_pdf_config.graph_line_type = selectedItem;
                    }
                }
            }
        }
        elements.push(el);

        if (Item && Item.widget_config && Item.widget_config.rows)
        {
            let find = Item.widget_config.rows.find(item =>
                item.alias === "time_step" && item.func === "toStartOfAuto"
            );
            if(find)
            {
                let curItemAgg = Item.widget_config.agg_period ? Item.widget_config.agg_period : null;
                let data =  Helper.DictToArr(ChartsTimeStepsDic);
                let minAggInMinutes = null;
                let periodDiffInMinutes = parseInt(Helper.GetPeriodsDiffInMinutes(Item.period_from, Item.period_to));

                data.forEach(item => {
                    if(item.disabled)
                        delete item.disabled;
                    if(item.$css)
                        delete item.$css;
                })

                if(Item.widget_config.table.indexOf("fullflow") !== -1)
                {
                    minAggInMinutes = parseInt(this.AggValues.FULLFLOW_AGG_LOG_GROUP_TIME_INTERVAL);
                }

                if(Item.widget_config.table.indexOf("clickstream") !== -1)
                {
                    minAggInMinutes = parseInt(this.AggValues.CLICKSTREAM_AGG_LOG_GROUP_TIME_INTERVAL);
                }

                if(minAggInMinutes)
                {
                    data.forEach(item => {
                        if((parseInt(item.id) < minAggInMinutes))
                        {
                            item.disabled = true;
                        }
                    });
                }

                data.forEach(item => {
                    if(!periodDiffInMinutes || ((periodDiffInMinutes / parseInt(item.id)) < 3))
                    {
                        item.disabled = true;
                    }
                });

                let el = {
                    view:"richselect",
                    label: LangHelper.GetString("AppView", "Chart step"),
                    width: width,
                    labelWidth: labelWidth,
                    tooltip: LangHelper.GetString("AppView", "Chart step"),
                    value: data.find(item => item.id === curItemAgg && !item.disabled) ? curItemAgg : ChartsTimeStepsDic.auto.id,
                    suggest: {
                        fitMaster: false,
                        body:{
                            scheme: {
                                $init:function(obj){
                                    if (obj.disabled)
                                        obj.$css = "webix_disabled";
                                }
                            },
                            data: data
                        }
                    },
                    on:{
                        onChange:function(newV, oldV){
                            var item = this.getList().getItem(newV);

                            if (item && item.disabled)
                            {
                                this.blockEvent();
                                this.setValue(oldV);
                                this.unblockEvent();
                                return;
                            }

                            if(item && item.id && ChartsTimeStepsDic[item.id])
                            {
                                Item.widget_config.agg_period = item.id;
                            }
                        }
                    }
                }
                elements.push(el);
            }
        }
    }

    if(Item.widget_pdf_config.view_type === "table") {

        let curLangCode = LangHelper.GetLocale()
        let options = [];
        let values = Item.widget_pdf_config.columns_to_show ? Item.widget_pdf_config.columns_to_show : Item.widget_pdf_config.columns_headers.map(col => col.id);

        Item.widget_pdf_config.columns_headers.forEach(function (Col) {
            let id = Col.id;
            let header_name = Col.header_name&&Col.header_name[curLangCode] ? Col.header_name[curLangCode] : Col.id;
            options.push({id:id, value:header_name});
        })

        let el = {
            view:"multiselect",
            label:LangHelper.GetString("AppView", "Columns visibility"),
            width:width,
            labelWidth:labelWidth,
            tooltip:LangHelper.GetString("AppView", "Columns visibility"),
            value:values,
            suggest: {fitMaster: false, data:options},
            on:{
                onChange:function()
                {
                    let selected_items = this.getValue().split(",");
                    if (selected_items.length === 1 && selected_items[0] === "") {
                        this.setValue(options[0].id);
                        selected_items = this.getValue().split(",");
                    }
                    let sorted_cols_ids = Item.widget_pdf_config.columns_headers.map(col => col.id);
                    selected_items = sorted_cols_ids.filter(item => selected_items.includes(item));
                    Item.widget_pdf_config.columns_to_show = selected_items;
                }
            }
        }
        elements.push(el);
    }

    if (_this.IsExportReportRowsLimitEditable(Item)) {
        let elValue, elLabel, elAddLimitFunc, elDelLimitFunc;

        switch (Item.widget_pdf_config.view_type)
        {
            case "chart":
            case "bar_chart":
                elValue = Item.widget_config.cols[0].values.params.limit || defaultChartLimit;
                elLabel = LangHelper.GetString("AppView", "Items limit");
                elAddLimitFunc = function(value) {
                    Item.widget_config.cols[0].values.params.limit = value;
                };
                elDelLimitFunc = function() {
                    Item.widget_config.cols[0].values.params.limit = defaultChartLimit;
                };
                break;
            case "pie_chart":
                if (!("use_size" in Item.widget_config.flags) || Item.widget_config.flags.use_size) {
                    elValue = Item.widget_config.size || defaultPieChartLimit;
                } else {
                    elValue = Item.widget_config.limit || defaultPieChartLimit;
                }
                elLabel = LangHelper.GetString("AppView", "Items limit");
                elAddLimitFunc = function(value) {
                    Item.widget_config.limit = value;
                    Item.widget_config.flags.use_size = 0;
                    Item.widget_config.cache.flags.use_size = 0;
                };
                elDelLimitFunc = function() {
                    Item.widget_config.limit = defaultPieChartLimit;
                };
                break;
            case "table":
                if (!("use_size" in Item.widget_config.flags) || Item.widget_config.flags.use_size) {
                    elValue = Item.widget_config.size || "";
                } else {
                    elValue = Item.widget_config.limit || "";
                }
                elLabel = LangHelper.GetString("AppView", "Rows limit");
                elAddLimitFunc = function(value) {
                    Item.widget_config.flags.use_size = 0;
                    Item.widget_config.limit = value;
                };
                elDelLimitFunc = function() {
                    delete Item.widget_config.limit;
                };
                break;
        }
        elements.push(
            {
                view:"text",
                label:elLabel,
                width:width,
                labelWidth: labelWidth,
                tooltip:elLabel,
                value:elValue,
                on:{
                    onChange:function()
                    {
                        let value = this.getValue();
                        if(Number(value) && Number(value) !== 0){
                            elAddLimitFunc.call(this, Number(value));
                        } else {
                            elDelLimitFunc.call(this);
                        }
                    }
                }
            }
        );
    }

    elements.push(
        {
            view:"richselect",
            label:LangHelper.GetString("UlrModule", "Display filter"),
            width:width,
            labelWidth:labelWidth,
            tooltip:LangHelper.GetString("AppView", "Chart type"),
            value: parseInt(Item.widget_pdf_config.display_filter) ? "1" : "0",
            options: Helper.DictToArr(ControlTaskStatusesDic),
            on:{
                onChange:function()
                {
                    Item.widget_pdf_config.display_filter = this.getValue();

                    if(parseInt(Item.widget_pdf_config.display_filter) && Item.filter_state)
                    {
                        let filterIds = [];

                        Object.values(Item.filter_state).forEach(item => {
                            if(parseInt(item.f_enabled))
                                filterIds.push(item.f_id);
                        })

                        Item.widget_pdf_config.locales.filter_section = _this.Views.ExtendedFillter.GetLocales(filterIds);
                    }
                    else
                    {
                        if(Item.widget_pdf_config.locales && Item.widget_pdf_config.locales.filter_section)
                            delete Item.widget_pdf_config.locales.filter_section;
                    }
                }
            }
        }
    );

    elements.push(
        {
            view:"combo",
            id:_this.Id + "",
            name:"page_orientation",
            width:width,
            labelWidth: labelWidth,
            value: Item.widget_pdf_config.page_orientation,
            label:LangHelper.GetString("UlrModule","Page orientation"),
            options: Helper.DictToArr(OrientationDic),
            on: {
                onChange:function()
                {
                    Item.widget_pdf_config.page_orientation = this.getValue();
                }
            }
        }
    );

    if(["chart", "bar_chart"].includes(Item.widget_pdf_config.view_type)) {
        let val = parseInt(Item.widget_pdf_config.display_legend_stat) ? "1" : "0";

        elements.push({
                view: "richselect",
                width:width,
                labelWidth: labelWidth,
                name: ReportSettingsEnum.display_legend_stat.id,
                label: LangHelper.GetString("AppView","Series metrics"),
                options: Helper.DictToArr(YesNoDic),
                value: val,
                on: {
                    onChange: function() {
                        Item.widget_pdf_config.display_legend_stat = this.getValue();
                    }
                }
            }
        );
    }


    return webix.ui({
        view: "popup",
        id: popupId,
        body: {
            view: "form",
            id: this.Id + "EditReportConfigPopup",
            borderless: true,
            elements: elements
        }
    });
}

function UlrQoEAnyReportViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"UlrQoEAnyReport",
        PageTitle: {
            RootTitle:"",
            Title: LangHelper.GetString("AppView", "Report")
        }
    },true);

    UlrQoEAnyReportViewController.superclass.constructor.call(this, params);
}

Helper.ExtendClass(UlrQoEAnyReportViewController,QoEAnyReportViewController);
function UlrFastresourceCustomPrtclsViewController(Params)
{
    var _this = this;
    this.Id = "UlrFastresourceCustomPrtcls";

    this.PageTitle = {
        RootTitle: LangHelper.GetString("UlrModule", "Custom Protocols"),
        Title: LangHelper.GetString("UlrModule", "ULR_FASTRESOURCE")
    };

    this.ViewModel = new UlrFastresourceCustomPrtclsManager();
    this.ReportsModel = new UniReportsManager();

    this.Views = {
        ScrollView: null,
        PageTitle: null,
        RulesSection: null,
        AddRuleForm: null,
        CustomProtocolSelect: null,
        QoEImportInput: null,
        AddRuleBtn: null,

        Widgets: {},
        ReportsWidgets: {
            RulesReport: UlrFastresourceCustomPrtclsTableWidget({
                id: this.Id + "RulesReport",
                onItemClick: function(Id, E, Node)
                {
                    _this.OnTableItemClick(Id, E, Node);
                }
            })
        }
    };

    this.ViewConfig = [
        {
            view: "scrollview",
            id: this.Id + "ScrollView",
            scroll: "y",
            body: {
                type: "space",
                rows: [
                    {
                        type: "clean",
                        borderless: true,
                        rows: [
                            {height: 6},
                            PageHeaderTemplate({id: this.Id + "PageTitle", root_title: this.PageTitle.Title}),
                            {height: 32},
                            {
                                view: "template",
                                borderless: true,
                                css: "form_text_big_label",
                                autoheight: true,
                                template: LangHelper.GetString("UlrModule", "Import of SNI, IP, IP PORT resources into custom protocols from QoE on schedule according to the set filters.")
                            }
                        ]
                    },
                    {
                        id: this.Id + "RulesSection",
                        rows: [
                            {
                                type: "space",
                                css: "form_background",
                                rows: [
                                    BlockHeaderTemplate({
                                        title: LangHelper.GetString("UlrModule", "Add new rule"),
                                        icon: "",
                                        borderless: true
                                    }),
                                    {
                                        view: "form",
                                        id: this.Id + "AddRuleForm",
                                        borderless: true,
                                        type: "wide",
                                        elements: [
                                            {
                                                type: "clean",
                                                rows: [
                                                    {
                                                        view:"label",
                                                        css:"form_text_label",
                                                        label:LangHelper.GetString("UlrModule","Start typing protocol name or use protocol list helper.")
                                                    },
                                                    {
                                                        type: "wide",
                                                        cols: [
                                                            {
                                                                id: this.Id + "CustomProtocolSelect",
                                                                view: "spectre_combo",
                                                                name: "custom_protocol_port",
                                                                label: LangHelper.GetString("UlrModule", "Custom Protocol"),
                                                                options: {
                                                                    point:false,
                                                                    data:App.DicsManager.GetDicAsArray(DicsEnum.CustomProtocolsDic)
                                                                },
                                                                required: true,
                                                                validate: webix.rules.isNotEmpty,
                                                                invalidMessage: LangHelper.GetString("UlrModule", "Required field"),
                                                                on: {
                                                                    "onChange": function (Nv, Ov)
                                                                    {
                                                                        if(typeof Ov !== "undefined" && Ov !== "")
                                                                            this.validate();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                id: this.Id + "QoEImportInput",
                                                                view: "resource-import-qoe-input",
                                                                label: null,
                                                                labelWidth: 0,
                                                                css: "form_background",
                                                                type: "custom_prtcls",
                                                                disabled: true
                                                            },
                                                            {
                                                                view: "spectre_button",
                                                                id: this.Id + "AddRuleBtn",
                                                                css: "form_button form_element main_action",
                                                                disabled: true,
                                                                label: LangHelper.GetString("UlrModule", "Add rule"),
                                                                click: function () {
                                                                    setTimeout(function(){_this.AddNewRule()}, 10);
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {height: 20},
                            this.Views.ReportsWidgets.RulesReport.ViewConfig
                        ]
                    }
                ]
            }
        }
    ];

    this.Subscriptions = {};
    this.Signals = {};
}

UlrFastresourceCustomPrtclsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll(Params);

    this.Refresh();
};

UlrFastresourceCustomPrtclsViewController.prototype.BindAll = function(Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    this.Subscriptions.CustomProtocolsDic = App.DicsManager.Signal[DicsEnum.CustomProtocolsDic].subscribe(function (Updated)
    {
        if (Updated)
        {
            var opts = App.DicsManager.GetDicAsArray(DicsEnum.CustomProtocolsDic);
            var select = _this.Views.CustomProtocolSelect;
            var list = select.getList();
            list.clearAll();
            opts = opts.sort(function(a, b) { return a.value > b.value ? 1 : -1 ;});
            list.parse(opts);

            var column = _this.Views.ReportsWidgets.RulesReport.Views.Table.getColumnConfig('custom_protocol_port');
            if(column)
            {
                column.header[1].options = [];
                _this.Views.ReportsWidgets.RulesReport.Views.Table.refreshColumns();
                column.header[1].options = opts;
                _this.Views.ReportsWidgets.RulesReport.Views.Table.refreshColumns();
                _this.Views.ReportsWidgets.RulesReport.Views.Table.refresh();
            }
        }
    });

    this.Views.CustomProtocolSelect.attachEvent("onChange", function(newVal, oldVal, config){
        if(newVal)
        {
            _this.Views.QoEImportInput.enable();
            _this.Views.AddRuleBtn.enable();
        }
        else
        {
            _this.Views.QoEImportInput.disable();
            _this.Views.AddRuleBtn.disable();
        }
    });


    App.DicsManager.Refresh({data:[DicsEnum.CustomProtocolsDic]});
};

UlrFastresourceCustomPrtclsViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }
};

UlrFastresourceCustomPrtclsViewController.prototype.Refresh = function (Params)
{
    this.Views.ReportsWidgets.RulesReport.RefreshData();
};

UlrFastresourceCustomPrtclsViewController.prototype.AddNewRule = function()
{
    var _this = this;

    var custom_prtlc_id = this.Views.CustomProtocolSelect.getValue();
    var cfg = this.Views.QoEImportInput.getValueAsModel();

    var model = new UlrFastresourceCustomPrtclModel({
        _id: 0,
        custom_protocol_port: custom_prtlc_id,
        qoe_table: cfg.qoe_table,
        config_json: JSON.stringify(cfg),
        enabled: 1
    })

    this.JustSaveRule(model);
};

UlrFastresourceCustomPrtclsViewController.prototype.JustSaveRule = function(model)
{
    var _this = this;

    this.ViewModel.SaveRule({
        rule: model,
        callback: function(R)
        {
            if(R.success)
            {
                var m = new UlrFastresourceCustomPrtclModel(R.data);
                UlrShowMessage(
                    "success",
                    LangHelper.GetString("UlrModule","ULR_FASTRESOURCE")+" # "+m._id+": "+LangHelper.GetString("UlrModule","Saving"),
                    LangHelper.GetString("UlrModule","Success")
                );

                _this.Refresh();
            }
            else
            {
                _this.ShowServerError(R.error);
            }
        }
    });
};

UlrFastresourceCustomPrtclsViewController.prototype.ShowServerError = function(ErrModel)
{
    if(ErrModel)
        UlrShowAlertWindow({
            head:LangHelper.GetString("UlrModule","Error"),
            type:"spectre-alert-error",
            mainTitle:LangHelper.GetString("UlrModule","Code") + ": " + ErrModel.code,
            message:LangHelper.GetString("UlrModule",ErrModel.msg),
            actions:[
                {
                    label:LangHelper.GetString("UlrModule","Ok"),
                    click:function ()
                    {

                    }
                }
            ]
        });
};

UlrFastresourceCustomPrtclsViewController.prototype.OnTableItemClick = function(Id, E, Node)
{
    var _this = this;
    if(Id.column == 'edit' || Id.column == 'delete' || Id.column == 'enabled')
    {
        var item = this.Views.ReportsWidgets.RulesReport.Views.Table.getItem(Id.row);

        if(!item)
            return;

        var model = new UlrFastresourceCustomPrtclModel(item);
        if(Id.column == "enabled")
        {
            this.ViewModel.EnableDisableRule({
                rule: model,
                enable: model.enabled,
                callback: function(R)
                {
                    if(R.success)
                    {
                        UlrShowMessage(
                            "success",
                            LangHelper.GetString("UlrModule","ULR_FASTRESOURCE")+" # "+model._id+": "+LangHelper.GetString("UlrModule",model.enabled ? "Enabled" : "Disabled"),
                            LangHelper.GetString("UlrModule","Success")
                        );
                    }
                    else
                    {
                        _this.ShowServerError(R.error);
                        model.enabled = (model.enabled + 1) % 2;

                        _this.Views.ReportsWidgets.RulesReport.Views.Table.updateItem(Id.row, model);
                    }
                }
            });
        }
        else if(Id.column == "edit")
        {
            ResourceImportQoEPopupItem({
                cfg: item.config_json,
                editable: true,
                update_config: function(config)
                {
                    item.config_json = JSON.stringify(config);

                    _this.JustSaveRule(item);
                }
            });
        }
        else if(Id.column == "delete")
        {
            var node = this.Views.ReportsWidgets.RulesReport.Views.Table.getItemNode(Id);
            UlrShowDialogPopup({
                node:node,
                position:"bottom",
                head:LangHelper.GetString("UlrModule","Delete") + "?",
                //type:"spectre-alert-notification",
                mainTitle:LangHelper.GetString("UlrModule","Delete") + "?",
                message:LangHelper.GetString("UlrModule","Are you sure?"),
                actions:[
                    {
                        css:"spec_action",
                        label:LangHelper.GetString("UlrModule","Cancel")
                    },
                    {
                        label:LangHelper.GetString("UlrModule","Delete"),
                        click:function ()
                        {
                            _this.ViewModel.DeleteRule({
                                rule: item,
                                callback: function(R)
                                {
                                    if(R.success)
                                    {
                                        UlrShowMessage(
                                            "success",
                                            LangHelper.GetString("UlrModule","ULR_FASTRESOURCE")+" # "+model._id+": "+LangHelper.GetString("UlrModule","Deleted"),
                                            LangHelper.GetString("UlrModule","Success")
                                        );
                                        _this.Views.ReportsWidgets.RulesReport.Views.Table.remove(Id.row);
                                    }
                                    else
                                    {
                                        _this.ShowServerError(R.error);
                                    }
                                }
                            });
                        }
                    }
                ]
            });
        }
    }
};

UlrFastresourceCustomPrtclsViewController.prototype.GetPageTitle = function () {
    if (this.PageTitle)
        return this.PageTitle;
};
function HardwareConfigViewController(Params)
{
    var _this = this;

    window.Test = this;

    this.Id = "HardwareConfig";

    this.Id = Params&&Params.Id?Params.Id:"HardwareConfig";

    this.OnSave = Params && Params.onSave ? Params.onSave : null;

    this.mode = module ? module : "dpiui2";

    this.PageTitle = Params&&Params.PageTitle?Params.PageTitle:{
        RootTitle: LangHelper.GetString("AppView", "Administrator"),
        Title: LangHelper.GetString("AppView", "Hardware config")
    };

    this.mode = module ? module : "dpiui2";

    this.ViewModel = Params && Params.ViewModel ? Params.ViewModel : new Dpiui2ConfigManager();

    this.VchannelModel = Params && Params.VchannelModel ? Params.VchannelModel : "",

    this.Buttons = Params && Params.Buttons ? Params.Buttons : [];

    this.HistoryImportContext = webix.ui({
        view:"popup",
        width:800,
        height:720,
        id:this.Id+"HistoryImportContext",
        modal:true,
        body:{
            rows:[
                {
                    borderless:true,
                    cols:[
                        {
                            width:240,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiConfig","History"), icon: "history"}),
                                {
                                    view:"datatable",
                                    id:this.Id + "HistoryImportContext" + "HistoryTable",
                                    select: "row",
                                    columns: [
                                        {
                                            id: "date",
                                            header: [LangHelper.GetString("DpiConfig","Date"), {content: "dateRangeFilter"}],
                                            format: webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"),
                                            fillspace: true,
                                            sort: "date"
                                        }
                                    ],
                                    on:{
                                        onAfterLoad:function(){
                                            this.sort("date", "desc", "date");
                                            this.markSorting("date", "desc");
                                        },
                                        onAfterSelect: function (data, preserve)
                                        {
                                            var rowData = this.getItem(data);

                                            _this.Views.HistoryEditor.showProgress({type: "icon"});

                                            _this.ViewModel.LoadHistoryFile({configFile:rowData.file_id, callback:function (R)
                                            {
                                                _this.Views.HistoryEditor.hideProgress({type: "icon"});
                                                if(R.success)
                                                {
                                                    _this.Views.HistoryEditor.setValue(R.data);
                                                }
                                                else
                                                {
                                                    webix.message({type:"error",text:LangHelper.GetString("DpiConfig","Could not upload file")})
                                                }
                                            }});
                                        }
                                    },
                                    data:[]
                                }
                            ]
                        },
                        {view:"resizer"},
                        {
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiConfig","Config"), icon: "code"}),
                                {
                                    view:"codemirror-editor",
                                    id:this.Id + "HistoryImportContext" + "Editor",
                                    value:""
                                }
                            ]
                        }
                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("DpiConfig","Cancel"),
                            click:function ()
                            {
                                _this.HistoryImportContext.hide();
                                _this.Views.HistoryEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("DpiConfig","Apply"),
                            click:function () {
                                _this.HistoryImportContext.hide();

                                _this.ViewModel.SetConfig(_this.Views.HistoryEditor.getValue());

                                webix.message(LangHelper.GetString(_this.Id,"Applied"));

                                _this.Views.HistoryEditor.setValue("");
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.UseValidateOnSave = Params.UseValidateOnSave ? Params.UseValidateOnSave : false;

    this.SaveContextId = this.Id + "SaveContext";
    this.SaveContext = webix.ui({
        view:"submenu",
        id:this.SaveContextId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.SaveContextId+"Validate", icon: "check-square", value: LangHelper.GetString("DpiConfig","Verify")},
            {id: this.SaveContextId+"ValidateAndSave", icon: "floppy-o", value: LangHelper.GetString("DpiConfig","Verify and save")},
            {id: this.SaveContextId+"JustSave", icon: "floppy-o", value: LangHelper.GetString("DpiConfig","Save without verification")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();


                if(_this.Views.EditorTabs.getValue() == _this.Id + "Editor" + "Code")
                {
                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                }
                else{
                    _this.SetCurrentFormVals();
                }

                if(id === _this.SaveContextId+"Validate")
                {
                    _this.ConfigValidate();
                }
                else if(id === _this.SaveContextId+"ValidateAndSave")
                {
                    _this.ConfigValidate({callback:function (R) {
                        if(R.success)
                        {
                            _this.ConfigSave();
                        }
                    }});
                }
                else if(id === _this.SaveContextId+"JustSave")
                {
                    _this.ConfigSave();
                }
            }
        }
    });

    this.ValidationDataContext = webix.ui({
        view:"popup",
        width:800,
        height:600,
        body:{
            id:this.Id + "ValidationDataContext",
            borderless:true,
            rows:[
                {
                    view:"codemirror-editor",
                    id:this.Id + "ValidationDataContext" + "CodeEditor",
                    value:""
                },
                {
                    view:"toolbar",
                    borderless:true,
                    elements:[
                        {
                            gravity:2
                        },
                        {
                            view:"button",
                            label:LangHelper.GetString("DpiConfig","Close"),
                            click:function ()
                            {
                                _this.ValidationDataContext.hide();
                                _this.Views.ValidationDataContextCodeEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            label:LangHelper.GetString("DpiConfig","Save without verification"),
                            type:"form",
                            click:function ()
                            {
                                _this.ValidationDataContext.hide();
                                _this.Views.ValidationDataContextCodeEditor.setValue("");
                                _this.ConfigSave();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CreateVchannelContext = webix.ui({
        view: "popup",
        modal: true,
        id:this.Id+"CreateVchannelContext",
        width:400,
        body: {
            view: "form",
            id:this.Id+"CreateVchannelContextForm",
            borderless:true,
            elements:[
                {
                    view: "text",
                    name: "cidr",
                    label: LangHelper.GetString(this.Id, "CIDR"),
                    labelPosition: "top",
                    required: true,
                    validate:function(Val)
                    {
                        if(Val){
                            var val = Val.split("/");
                            if(val.length > 1){
                                let [ip, mask] = val;
                                return mask <= 128 && mask >= 0 && Helper.ValidateCidrIPv4OrIPv6(Val) ? true : false;
                            }
                        }
                    },
                    invalidMessage: LangHelper.GetString("DpiConfig","Enter correct CIDR")
                },
                {
                    view: "text",
                    name: "vchannel",
                    label: LangHelper.GetString("Vchannels", "Vchannel number") + " (1..1024)",
                    labelPosition: "top",
                    required: true,
                    invalidMessage: LangHelper.GetString("DpiConfig", "Enter correct Vchannel"),
                    options:[],
                    validate:function(V)
                    {
                        if(V && V > 0 && V <= 1024)
                            return true;

                        return false;
                    }
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.Views.CreateVchannelContext.hide();
                            }
                        },
                        {
                            view:"button",
                            hotkey: "enter",
                            value:LangHelper.GetString("All", "Save"),
                            type:"form",
                            click:function ()
                            {
                                if(_this.Views.CreateVchannelContextForm.validate()){
                                    let formValue = _this.Views.CreateVchannelContextForm.getValues();
                                    let item = _this.Views.VchannelTable.getSelectedItem();
                                    _this.Views.VchannelTable.updateItem(item.id, formValue);
                                    _this.Views.CreateVchannelContext.hide();
                                };
                            }
                        }
                    ]
                }
            ]
        },
    });

    this.DeleteVchannelTableContext = webix.ui({
        view:"popup",
        width:300,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("All","Are you sure you want to delete the selected record?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.DeleteVchannelTableContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function () {
                                let item = _this.Views.VchannelTable.getSelectedItem();
                                _this.Views.VchannelTable.remove(item.id);
                                _this.DeleteVchannelTableContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.SaveVchannelFormContext = webix.ui({
        view:"popup",
        width:400,
        height:200,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template: LangHelper.GetString("Vchannels","Are you sure you want to save the cidr list?") +
                        "<br/>" + "<br/>" + "<span style='color: red'>" + LangHelper.GetString("Vchannels","When you click on the Save button, only the CIDR list is saved")+ "</span>"
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function () {
                                _this.SaveVchannelFormContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Save"),
                            click:function () {
                                if(_this.Views.SettingsVchannelsListForm.validate()){
                                    _this.SaveVchannelSettings();
                                }
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.VchannelHistoryImportContext = webix.ui({
        view:"popup",
        width:800,
        height:720,
        id:this.Id+"VchannelHistoryImportContext",
        modal:true,
        body:{
            rows:[
                {
                    borderless:true,
                    cols:[
                        {
                            width:240,
                            rows:[
                                BlockHeaderTemplate({title: LangHelper.GetString("DpiConfig","History"), icon: "history"}),
                                {
                                    view:"datatable",
                                    id:this.Id + "VchannelHistoryImportContext" + "HistoryTable",
                                    select: "row",
                                    columns: [
                                        {
                                            id: "date",
                                            header: [LangHelper.GetString("DpiConfig","Date"), {content: "dateRangeFilter"}],
                                            format: webix.Date.dateToStr("%d.%m.%Y %H:%i:%s"),
                                            fillspace: true,
                                            sort: "date"
                                        }
                                    ],
                                    on:{
                                        onAfterLoad:function(){
                                            this.sort("date", "desc", "date");
                                            this.markSorting("date", "desc");
                                        },
                                        onAfterSelect: function (data, preserve)
                                        {
                                            var rowData = this.getItem(data);

                                            _this.Views.VchannelHistoryEditor.showProgress({type: "icon"});
                                            _this.Views.VchannelHistoryIPv6Editor.showProgress({type: "icon"});

                                            _this.VchannelModel.LoadVchannelSettingsHistoryFile({configFile:rowData.file_id, callback:function (R)
                                                {
                                                    _this.Views.VchannelHistoryEditor.hideProgress({type: "icon"});
                                                    _this.Views.VchannelHistoryIPv6Editor.hideProgress({type: "icon"});
                                                    if(R.success)
                                                    {
                                                        let cidrs = _this.CidrsSplit(R.data);

                                                        _this.Views.VchannelHistoryEditor.setValue(cidrs.IPv4);
                                                        _this.Views.VchannelHistoryIPv6Editor.setValue(cidrs.IPv6);
                                                    }
                                                    else
                                                    {
                                                        webix.message({type:"error",text:LangHelper.GetString("DpiConfig","Could not upload file")})
                                                    }
                                                }});
                                        }
                                    },
                                    data:[]
                                }
                            ]
                        },
                        {view:"resizer"},
                        {
                            rows: [
                                {
                                    cols: 
                                    [
                                        {
                                            gravity:1,
                                            rows:[
                                                BlockHeaderTemplate({title: "IPv4 " + LangHelper.GetString("DpiConfig","Config"), icon: "code"}),
                                                {
                                                    view:"codemirror-editor",
                                                    id:this.Id + "VchannelHistoryImportContext" + "Editor",
                                                    value:""
                                                }
                                            ]
                                        },
                                        {
                                            gravity:1,
                                            rows:[
                                                BlockHeaderTemplate({title: "IPv6 " + LangHelper.GetString("DpiConfig","Config"), icon: "code"}),
                                                {
                                                    view:"codemirror-editor",
                                                    id:this.Id + "VchannelHistoryImportContextIPv6Editor",
                                                    value:""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("DpiConfig","Cancel"),
                            click:function ()
                            {
                                _this.VchannelHistoryImportContext.hide();
                                _this.Views.HistoryEditor.setValue("");
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("DpiConfig","Apply"),
                            click:function () {
                                let IPv4 = _this.ValidateVchannelSettingsEditor(_this.Views.VchannelHistoryEditor);
                                let IPv6 = _this.ValidateVchannelSettingsEditor(_this.Views.VchannelHistoryIPv6Editor, 1);

                                _this.Views.VchannelTable.clearAll();
                                _this.Views.VchannelEditor.setValue("");

                                if(IPv4 == "" || IPv4){
                                    let values = [];

                                    if (IPv6 == "" || IPv6)
                                        values = (IPv4 + IPv6).split("\n");
                                    else
                                        values = IPv4.split("\n");

                                    for (const item in values) {
                                        let [cidr, vchannel] = values[item].trim().split(" ");

                                        if(cidr && vchannel){
                                            _this.Views.VchannelTable.add({
                                                cidr,
                                                vchannel
                                            })
                                        }
                                    }
                                    _this.Views.VchannelEditor.setValue(IPv4);
                                    _this.Views.VchannelIPv6Editor.setValue(IPv6);
                                    _this.VchannelHistoryImportContext.hide();
                                    webix.message(LangHelper.GetString(_this.Id,"Applied"));
                                    _this.Views.VchannelHistoryEditor.setValue("");
                                } else {
                                    webix.message({type:"error", text:LangHelper.GetString("DpiConfig","Data is Invalid")})
                                }
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.SettingsVchannelsListForm = webix.ui({
        view:"popup",
        modal: true,
        body:{
            view:"form",
            id:this.Id+"SettingsVchannelsListForm",
            width: 1000,
            borderless:true,
            elements: [
                {
                    view: "toolbar",
                    borderless:true,
                    padding: 0,
                    margin: 0,
                    elements: [
                        {
                            view: "button",
                            id:_this.Id + "VchannelsListForm" + "HistoryBtn",
                            type: "icon",
                            icon: "history",
                            css: "toolbar_round_btn",
                            width: 32,
                            tooltip: LangHelper.GetString("DpiConfig","Download from history"),
                            click:function (id,e,node)
                            {
                                let Node = this.getNode();
                                _this.VchannelHistoryImportContext.show(Node, {pos:"right"});
                                _this.GetVchannelSettingsConfigHistory();
                            }
                        },
                        {},
                        {
                            view: "button",
                            id:_this.Id + "VchannelsListForm" + "RefreshBtn",
                            type: "icon",
                            icon: "refresh",
                            css: "toolbar_round_btn",
                            width: 32,
                            tooltip: LangHelper.GetString(this.Id,"Refresh"),
                            click:function (id,e,node)
                            {
                                _this.GetVchannelSettings();
                            }
                        },
                    ]
                },
                BlockHeaderTemplate({title:LangHelper.GetString("Vchannels", "List of CIDRs for Vchannels"), icon:"table"}),
                {
                    view: "toolbar",
                    padding: 0,
                    margin: 0,
                    height: 40,
                    borderless:true,
                    elements: [
                        {
                            view: "tabbar",
                            id: this.Id + "SettingsVchannelsListForm" + "Tabbar",
                            width: 400,
                            close: false,
                            multiview: true,
                            options: [
                                {
                                    id: this.Id + "SettingsVchannelsListForm" + "Table",
                                    value: "<span class='webix_icon fa-trello'></span> "+LangHelper.GetString("All","The form")
                                },
                                {
                                    id: this.Id + "SettingsVchannelsListForm" + "Editor",
                                    value: "<span class='webix_icon fa-code'></span> "+LangHelper.GetString("All","Editor")
                                }
                            ],
                            on: {
                                onChange: function (newValue, oldValue, config) {
                                    var data = "";
                                    var dataIPv6 = "";
                                    if(oldValue == "DpiConfigSettingsVchannelsListFormTable"){
                                        var values = _this.Views.VchannelTable.serialize();

                                        for (const item in values) {
                                            if (Helper.ValidateIPv6Cidr(values[item].cidr))
                                                dataIPv6 += `${values[item].cidr} ${values[item].vchannel}\n`;
                                            else
                                                data += `${values[item].cidr} ${values[item].vchannel}\n`;
                                        }

                                        _this.Views.VchannelEditor.value = "";
                                        _this.Views.VchannelEditor.setValue(data);

                                        _this.Views.VchannelIPv6Editor.value = "";
                                        _this.Views.VchannelIPv6Editor.setValue(dataIPv6);
                                    } else {
                                        var values = _this.Views.VchannelEditor.getValue();
                                        var valuesIPv6 = _this.Views.VchannelIPv6Editor.getValue();

                                        if(values){
                                            if(valuesIPv6)
                                                values += valuesIPv6;

                                            values = values.split("\n");
                                            _this.Views.VchannelTable.clearAll();
                                            for (const item in values) {
                                                let [cidr, vchannel] = values[item].trim().split(" ");

                                                if(cidr && vchannel){
                                                    _this.Views.VchannelTable.add({
                                                        cidr,
                                                        vchannel
                                                    })
                                                }
                                            }
                                        } else {
                                            _this.Views.VchannelTable.clearAll();
                                        }
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    animate: false,
                    id: this.Id + "SettingsVchannelsListForm" + "TabbarViews",
                    cells: [
                        {
                            id: this.Id + "SettingsVchannelsListForm" + "Table",
                            rows: [
                                {
                                    cols:[
                                        {
                                            view: "button",
                                            id: this.Id + "AddVchannelItemBtn",
                                            type: "icon",
                                            icon: "plus",
                                            align: "right",
                                            width: 32,
                                            css: "toolbar_round_btn",
                                            tooltip: LangHelper.GetString("BlackListService", "Add list item"),
                                            click: function (id, e, node) {
                                                _this.AddItemToVchannelTable();
                                            }
                                        }
                                    ]
                                },
                                {
                                    view: "datatable",
                                    id: this.Id + "SettingsVchannelsListForm" + "VchannelTable",
                                    select: "row",
                                    tooltip:true,
                                    height: 250,
                                    drag: true,
                                    on: {
                                        onItemClick: function (id,e,node)
                                        {
                                            var __this = this;

                                            var rowData = this.getItem(id);

                                            if (id.column === 'edit')
                                                _this.ShowVchannelTableEditForm(rowData, this.getItemNode(id), "right");
                                            else if(id.column === 'trash')
                                                _this.DeleteVchannelTableContext.show(node, {pos: "left"});

                                        }
                                    },
                                    columns: [
                                        {
                                            id:"edit",
                                            width:32,
                                            header:"",
                                            template:CellEditBtnTemplate
                                        },
                                        {
                                            id: "cidr",
                                            header: [LangHelper.GetString(_this.Id,"CIDR")],
                                            sort: "string",
                                            editor: "text",
                                            css: "cursor-grab",
                                            fillspace: true
                                        },
                                        {
                                            id: "vchannel",
                                            header: [LangHelper.GetString(_this.Id,"Vchannel")],
                                            sort: "string",
                                            editor: "text",
                                            css: "cursor-grab",
                                            fillspace: true,
                                            template: function (val) {
                                                var value = _this.Views.ParamsForm.elements.vchannels_list.config.value.split("|");

                                                if(value.length){
                                                    var vchannel = value[val.vchannel - 1] ?  value[val.vchannel - 1] : "";
                                                    if(vchannel){
                                                        return `${val.vchannel} (${vchannel})`;
                                                    } else {
                                                        return val.vchannel;
                                                    }
                                                } else {
                                                    return val.vchannel;
                                                }
                                            }
                                        },
                                        {
                                            id: "trash",
                                            header: "",
                                            width: 32,
                                            template: CellTrashBtnTemplate,
                                            headermenu: false
                                        }
                                    ],
                                    data:[]
                                },
                            ],
                        },
                        {
                            id: this.Id + "SettingsVchannelsListForm" + "Editor",
                            cols: [
                                {
                                    rows: [
                                        {
                                            height: 282,
                                            cols: 
                                            [
                                                {
                                                    gravity:1,
                                                    rows:[
                                                        BlockHeaderTemplate({title: "IPv4", icon: "code"}),
                                                        {
                                                            view:"codemirror-editor",
                                                            id:this.Id + "SettingsVchannels" + "Editor",
                                                            // height: 250,
                                                            value:""
                                                        }
                                                    ]
                                                },
                                                {
                                                    gravity:1,
                                                    rows:[
                                                        BlockHeaderTemplate({title: "IPv6", icon: "code"}),
                                                        {
                                                            view:"codemirror-editor",
                                                            id:this.Id + "SettingsVchannelsIPv6Editor",
                                                            // height: 250,
                                                            value:""
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                            ]
                        }
                    ]
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            width: 80,
                            label:LangHelper.GetString(_this.Id, "Cancel"),
                            click:function () {
                                _this.SettingsVchannelsListForm.hide();
                            }
                        },
                        {
                            width: 10
                        },
                        {
                            view:"button",
                            type:"form",
                            width: 88,
                            label:LangHelper.GetString("AppView", "Save"),
                            click:function () {
                                let data = _this.ValidateSettingsVchannel();

                                if((data.IPv4 || data.IPv4 == "") && (data.IPv6 || data.IPv6 == "")){
                                    var node = this.getNode();
                                    _this.SaveVchannelFormContext.show(node, {pos:"left"});
                                }
                                else {
                                    webix.message({type:"error", text:LangHelper.GetString("DpiConfig","Data is Invalid")})
                                }

                            }
                        },
                    ]
                }
            ]
        }
    });

    this.SettingsVchannelsListBtn = {
        view: "button",
        id: "SettingsVchannelsListBtn",
        type: "icon",
        icon: "gear",
        css:"toolbar_round_btn",
        width:32,
        click:function(id,event){
            var node = $$(id).getNode();
            _this.SettingsVchannelsListForm.show(node, {pos: "left"});
            _this.GetVchannelSettings();
        }
    };

    this.UseCurrentHardwareId = Params && Params.UseCurrentHardwareId ? Params.UseCurrentHardwareId : false;

    this.LeftSideBar = Params && Params.LeftSideBar ? Params.LeftSideBar : AdministratorLeftSideBarView({id:this.Id});

    this.ViewConfig = [
        {
            cols:[
                this.LeftSideBar,
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({id:this.Id + "PageTitle", root_title: this.PageTitle.RootTitle, title: this.PageTitle.Title}),
                                {
                                    id: this.Id + "Accordion",
                                    view: "accordion",
                                    multi: "mixed",
                                    on: {
                                        onAfterExpand: function(id) {
                                            // _this.Views.ParamsForm.RefreshViews();
                                            return true;
                                        },
                                        onAfterCollapse: function(id)
                                        {
                                            // _this.Views.ParamsForm.RefreshViews();
                                            return true;
                                        }
                                    },
                                    cols: [
                                        {
                                            minWidth: 1040,
                                            gravity: 2,
                                            header: LangHelper.GetString("AppView", "Configuration"),
                                            body: {
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id:_this.Id + "SaveBtn",
                                                                type: "icon",
                                                                icon: "floppy-o",
                                                                label: LangHelper.GetString("AppView", "Save"),
                                                                css: "toolbar_round_btn",
                                                                width: 128,
                                                                tooltip: LangHelper.GetString("AppView", "Save"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var __this = this;
                                                                    setTimeout(function ()
                                                                    {
                                                                        if(_this.UseValidateOnSave)
                                                                        {
                                                                            var node = __this.getNode(id);
                                                                            _this.SaveContext.show(node, {pos: "bottom"});
                                                                        }
                                                                        else{

                                                                            if(_this.Views.EditorTabs.getValue() == _this.Id + "Editor" + "Code")
                                                                            {
                                                                                _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                            }
                                                                            else{
                                                                                _this.SetCurrentFormVals();
                                                                            }
                                                                            _this.ConfigSave();
                                                                        }
                                                                    }, 10);
                                                                }
                                                            },
                                                            function(){
                                                                var cols = [
                                                                    {width: 16}
                                                                ];
                                                                if(_this.Buttons)
                                                                {
                                                                    _this.Buttons.forEach(function(V){
                                                                        cols.push(V);
                                                                    });
                                                                }

                                                                return {cols: cols};
                                                            }(),
                                                            {
                                                                view: "button",
                                                                id:_this.Id + "HistoryBtn",
                                                                type: "icon",
                                                                icon: "history",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("DpiConfig","Download from history"),
                                                                click: function (id, e, node) {
                                                                    var __this = this;
                                                                    setTimeout(function () {
                                                                        var node = __this.getNode(id);
                                                                        _this.HistoryImportContext.show(node, {pos: "bottom"});
                                                                        _this.DefineHistoryForms();

                                                                        //_this.ShowHNY(node);
                                                                    }, 10);
                                                                }
                                                            },
                                                            {
                                                                width: 16
                                                            },
                                                            {},
                                                            {
                                                                view: "button",
                                                                id:_this.Id + "RefreshBtn",
                                                                type: "icon",
                                                                icon: "refresh",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                                                click: function (id, e, node)
                                                                {
                                                                    if(_this.mode == "li")
                                                                    {
                                                                        _this.CheckHealth();
                                                                    }
                                                                    else{
                                                                        _this.Refresh();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                width:16
                                                            },

                                                            function(){
                                                                var tabbar = {
                                                                    view:"tabbar",
                                                                    id:_this.Id + "Editor" + "Tabs",
                                                                    tabMoreWidth:0,
                                                                    value:_this.Id + "Editor",
                                                                    multiview:true,
                                                                    //height:webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.material.tabbarHeight,
                                                                    options: [
                                                                        {
                                                                            id: _this.Id + "Editor",
                                                                            "value": "<span class='webix_icon fa-trello'></span> "+LangHelper.GetString("All","The form")
                                                                        },
                                                                        {
                                                                            id: _this.Id + "Editor" + "Code",
                                                                            "value": "<span class='webix_icon fa-code'></span> "+LangHelper.GetString("All","Editor")
                                                                        }
                                                                    ],
                                                                    on:{
                                                                        "onChange":function(Id, OldId)
                                                                        {
                                                                            if(Id == _this.Id + "Editor" + "Code")
                                                                            {
                                                                                _this.SetCurrentFormVals();
                                                                                setTimeout(function ()
                                                                                {
                                                                                    _this.Views.CodeEditor.setValue(_this.ViewModel.GetConfig());
                                                                                },1);
                                                                            }

                                                                            if(Id == _this.Id + "Editor")
                                                                            {
                                                                                setTimeout(function ()
                                                                                {
                                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                },1);
                                                                            }
                                                                        }
                                                                    }
                                                                };

                                                                if(webix.skin.$name === "dpiui2_vulkan" || webix.skin.$name === "dpiui2_vulkan")
                                                                {
                                                                    tabbar = {
                                                                        rows:[
                                                                            {},
                                                                            tabbar
                                                                        ]
                                                                    };
                                                                }

                                                                return tabbar;
                                                            }()
                                                        ]
                                                    },
                                                    {
                                                        rows:[
                                                            {
                                                                cells:[
                                                                    {
                                                                        id: this.Id + "Editor",
                                                                        cols: [
                                                                            {
                                                                                gravity: 2,
                                                                                rows: [
                                                                                    BlockHeaderTemplate({title: LangHelper.GetString("All","Groups"), icon: "cogs"}),
                                                                                    {
                                                                                        view:"search",
                                                                                        placeholder:LangHelper.GetString("All","Search"),
                                                                                        on: {
                                                                                            onTimedKeyPress: function(code, e)
                                                                                            {
                                                                                                var __this = this;
                                                                                                setTimeout(function(){
                                                                                                    _this.RefreshParamsFormBySearchString(__this.getValue());
                                                                                                },10);
                                                                                            }
                                                                                        },
                                                                                        keyPressTimeout:500
                                                                                        // width: 300
                                                                                    },
                                                                                    // BlockHeaderTemplate({title: LangHelper.GetString("All",""), icon: "cogs"}),
                                                                                    // {
                                                                                    //     id: _this.Id + "GroupType",
                                                                                    //     view:"richselect",
                                                                                    //     value: "default",
                                                                                    //     label: LangHelper.GetString("All","Group type"),
                                                                                    //     options: Helper.DictToArr(_this.ViewModel.GroupDic),
                                                                                    //     on:{
                                                                                    //         "onChange":function(NewVal, OldVal)
                                                                                    //         {
                                                                                    //             App.SessionManager.SetPreference(_this.ViewModel.Prefix + ":GroupType",NewVal);
                                                                                    //
                                                                                    //             _this.RefreshGroupsTable();
                                                                                    //             _this.SetCurrentFormVals();
                                                                                    //             _this.RefreshParamsForm();
                                                                                    //         }
                                                                                    //     }
                                                                                    // },
                                                                                    {
                                                                                        id: _this.Id + "GroupsTable",
                                                                                        view: "treetable",
                                                                                        header:false,
                                                                                        select: "row",
                                                                                        on: {
                                                                                            onAfterSelect: function (data, preserve)
                                                                                            {
                                                                                                var parentItem = this.getParentId(data.id);

                                                                                                if(!parentItem)
                                                                                                    return

                                                                                                var item = this.getItem(data.id);

                                                                                                setTimeout(function ()
                                                                                                {
                                                                                                    //_this.SetCurrentFormVals();
                                                                                                    _this.RefreshParamsForm(item);
                                                                                                    _this.LoadWiki(item);
                                                                                                },1);
                                                                                            }
                                                                                        },
                                                                                        onClick: {
                                                                                            "fa-question-circle": function(ev, id)
                                                                                            {
                                                                                                var item = this.getItem(id);
                                                                                                var node = this.getItemNode(id);

                                                                                                var popup = webix.ui({
                                                                                                    view:"popup",
                                                                                                    height:item.infoHeight?item.infoHeight:0,
                                                                                                    body:{
                                                                                                        borderless:true,
                                                                                                        template:item.info
                                                                                                    }
                                                                                                });

                                                                                                popup.show(node);

                                                                                                return false;
                                                                                            }
                                                                                        },
                                                                                        columns: [
                                                                                            {
                                                                                                id:"value",
                                                                                                fillspace:true,
                                                                                                template: function(obj, common, value, config)
                                                                                                {
                                                                                                    var str = common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.value ? obj.value : "");

                                                                                                    return str;
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                id: "info",
                                                                                                width: 40,
                                                                                                template: function(obj, common, value, config)
                                                                                                {
                                                                                                    if(obj && obj.info && obj.show_info)
                                                                                                    {
                                                                                                        return CellQuestionBtnTemplate();
                                                                                                    }
                                                                                                    return "";
                                                                                                }
                                                                                                // template: function(){
                                                                                                //     return {
                                                                                                //         view: "button",
                                                                                                //         type: "icon",
                                                                                                //         icon: "question-circle",
                                                                                                //         css:"toolbar_round_btn",
                                                                                                //         width:32,
                                                                                                //         popup:{
                                                                                                //             view:"popup",
                                                                                                //             height:Params.tooltipHeight?Params.tooltipHeight:0,
                                                                                                //             body:{
                                                                                                //                 borderless:true,
                                                                                                //                 // template:Params.tooltip
                                                                                                //             }
                                                                                                //         }
                                                                                                //     };
                                                                                                // }
                                                                                            }
                                                                                        ],
                                                                                        data: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {view: "resizer"},
                                                                            {
                                                                                gravity: 5,
                                                                                rows: [
                                                                                    BlockHeaderTemplate({title: LangHelper.GetString("All","Params"), icon: "cogs"}),
                                                                                    {
                                                                                        rows:[
                                                                                            {
                                                                                                id: _this.Id + "ParamsForm",
                                                                                                view: "form",
                                                                                                height: 0,
                                                                                                elements: [],
                                                                                                scroll: true
                                                                                                // gravity: 1
                                                                                            }
                                                                                        ]

                                                                                    },
                                                                                    {gravity: 0}
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        id:this.Id + "Editor" + "Code",
                                                                        rows:[
                                                                            {
                                                                                view:"codemirror-editor",
                                                                                id:this.Id + "Editor" + "Code" + "Codetree",
                                                                                value:""
                                                                            },
                                                                            {
                                                                                view:"toolbar",
                                                                                borderless:true,
                                                                                elements:[
                                                                                    {
                                                                                        view:"checkbox",
                                                                                        id:this.Id + "Editor" + "Code" + "ShowCommentsCheckbox",
                                                                                        labelRight:LangHelper.GetString("DpiConfig", "Show comments"),
                                                                                        labelWidth:0,
                                                                                        on:
                                                                                            {
                                                                                                "onChange":function(NewVal, OldVal)
                                                                                                {
                                                                                                    App.SessionManager.SetPreference(_this.ViewModel.Prefix + ":ShowComments",NewVal);

                                                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                                    _this.ViewModel.SetConfigModel(_this.ViewModel.GetConfigModel());
                                                                                                }
                                                                                            }
                                                                                    },
                                                                                    {
                                                                                        view:"checkbox",
                                                                                        id:this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox",
                                                                                        labelRight:LangHelper.GetString("DpiConfig", "Show all params"),
                                                                                        labelWidth:0,
                                                                                        on:
                                                                                            {
                                                                                                "onChange":function(NewVal, OldVal)
                                                                                                {
                                                                                                    App.SessionManager.SetPreference(_this.ViewModel.Prefix + ":ShowAllParams", NewVal);

                                                                                                    _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                                    _this.ViewModel.SetConfigModel(_this.ViewModel.GetConfigModel());
                                                                                                }
                                                                                            }
                                                                                    },
                                                                                    {
                                                                                        gravity:2
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            header:"WiKi",
                                            collapsed: true,
                                            gravity: 1,
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        elements: [
                                                            {
                                                                view: "button",
                                                                id:this.Id + "WiKi"+"HistoryBackBtn",
                                                                type: "icon",
                                                                icon: "arrow-left",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("DpiConfig","Back"),
                                                                click: function (id, e, node)
                                                                {
                                                                    var histLength = _this.WikiHistoryLength.getValue();

                                                                    if(histLength > 1)
                                                                    {
                                                                        _this.WikiHistoryLength.next(histLength - 2);
                                                                        window.history.back();
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view: "button",
                                                                id:this.Id + "WiKi"+"HistoryForwardBtn",
                                                                type: "icon",
                                                                icon: "arrow-right",
                                                                css: "toolbar_round_btn",
                                                                width: 32,
                                                                tooltip: LangHelper.GetString("DpiConfig","Forward"),
                                                                click: function (id, e, node)
                                                                {
                                                                    //_this.Views.WiKi.getIframe().contentWindow.history.back();
                                                                    window.history.forward();
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        view:"iframe",
                                                        id:this.Id + "WiKi",
                                                        src:LangHelper.GetString("Dics","https://wiki.vasexperts.com/doku.php?id=dpi:dpi_options:opt_bras:bras_steps:radius_auth_fastpcrf_setup:radius_auth_fastpcrf_setup_full")
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Subscriptions = {};

    this.WikiHistoryLength = new Rx.BehaviorSubject(0);

    this.Views = {
        EditorTabs:null,
        CodeEditor:null,
        FormsGroups:{},
        ValidationDataContextCodeEditor:null,
        ImportContextCodeEditor:null,
        ImportContextUploader:null,
        HistoryTable:null,
        HistoryEditor:null,
        HistoryForwardBtn:null,
        HistoryBackBtn:null,
        RestartQueueBtn:null,
        ShowCommentsCheckbox:null,
        ShowAllParamsCheckbox:null,
        GroupType: null,
        GroupsTable: null,
        ParamsForm: null,
        Accordion: null,

        SaveBtn:null,
        HistoryBtn:null,
        RefreshBtn:null,

        Editor:null,
        EditorCode:null,

        SettingsVchannelsListForm: null,
        VchannelTable: null,
        VchannelEditor: null,
        VchannelIPv6Editor: null,
        CreateVchannelContext: null,
        CreateVchannelContextForm: null,
        VchannelHistoryTable: null,
        VchannelHistoryEditor: null,
        VchannelHistoryIPv6Editor: null
    };

    this.Signals = {
        Editable:new Rx.BehaviorSubject(0)
    }
}

HardwareConfigViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.Editor = $$(this.Id + "Editor");
    this.Views.EditorCode = $$(this.Id + "Editor" + "Code");

    this.Views.SaveBtn = $$(this.Id + "SaveBtn");
    this.Views.HistoryBtn = $$(this.Id + "HistoryBtn");
    this.Views.RefreshBtn = $$(this.Id + "RefreshBtn");

    this.Views.CodeEditor = $$(this.Id + "Editor" + "Code" + "Codetree");
    this.Views.EditorTabs = $$(this.Id + "Editor" + "Tabs");

    this.Views.ShowCommentsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowCommentsCheckbox");
    this.Views.ShowAllParamsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox");

    this.Views.GroupsTable = $$(_this.Id + "GroupsTable");
    this.Views.ParamsForm = $$(_this.Id + "ParamsForm");

    this.Views.Accordion = $$(_this.Id + "Accordion");

    this.Views.HistoryTable = $$(this.Id + "HistoryImportContext" + "HistoryTable");
    this.Views.HistoryEditor = $$(this.Id + "HistoryImportContext" + "Editor");

    this.Views.WiKi = $$(this.Id + "WiKi");
    this.Views.HistoryBackBtn = $$(this.Id + "WiKi"+"HistoryBackBtn");
    this.Views.HistoryForwardBtn = $$(this.Id + "WiKi"+"HistoryForwardBtn");

    this.Views.ValidationDataContextCodeEditor = $$(this.Id + "ValidationDataContext" + "CodeEditor");

    this.Views.SettingsVchannelsListForm = $$(this.Id + "SettingsVchannelsListForm");
    this.Views.VchannelTable = $$(this.Id + "SettingsVchannelsListForm" + "VchannelTable");
    this.Views.VchannelEditor = $$(this.Id + "SettingsVchannels" + "Editor");
    this.Views.VchannelIPv6Editor = $$(this.Id + "SettingsVchannelsIPv6Editor");
    this.Views.CreateVchannelContext = $$(this.Id+"CreateVchannelContext");
    this.Views.CreateVchannelContextForm = $$(this.Id+"CreateVchannelContextForm");
    this.Views.VchannelHistoryTable = $$(this.Id + "VchannelHistoryImportContext" + "HistoryTable");
    this.Views.VchannelHistoryEditor = $$(this.Id + "VchannelHistoryImportContext" + "Editor");
    this.Views.VchannelHistoryIPv6Editor = $$(this.Id + "VchannelHistoryImportContextIPv6Editor");

    this.Views.WiKi.attachEvent("onAfterLoad",function()
    {
        _this.WikiHistoryLength.next(_this.WikiHistoryLength.getValue()+1);
    });

    webix.extend(this.Views.HistoryEditor, webix.ProgressBar);
    webix.extend(this.Views.VchannelHistoryEditor, webix.ProgressBar);
    webix.extend(this.Views.VchannelHistoryIPv6Editor, webix.ProgressBar);

    this.Views.ShowCommentsCheckbox.blockEvent();
    this.Views.ShowCommentsCheckbox.setValue(App.SessionManager.GetPreference(_this.ViewModel.Prefix + ":ShowComments"));
    this.Views.ShowCommentsCheckbox.unblockEvent();
    //
    this.Views.ShowAllParamsCheckbox.blockEvent();
    this.Views.ShowAllParamsCheckbox.setValue(App.SessionManager.GetPreference(_this.ViewModel.Prefix + ":ShowAllParams"));
    this.Views.ShowAllParamsCheckbox.unblockEvent();

    // _this.RefreshGroupsTable();

    this.ViewModel.GetSortedConfigGroupDicKeysArr().forEach(function (Key)
    {
        var formId = _this.Id + "Group_"+Key+"_form";
        if($$(formId))
        {
            _this.Views.FormsGroups[formId] = $$(formId);
        }
    });

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        _this.Views.FormsGroups[Key].attachEvent("onChange", function(newv, oldv)
        {
            _this.ViewModel.SetConfigModel(_this.GetFormsValues());
        });
    });


    if(this.UseCurrentHardwareId)
    {
        _this.Subscriptions.CurrentHardwareChanged = App.SessionManager.CurrentHardwareId.subscribe(function(Val){
            _this.Refresh();
        });
    }

    this.Subscriptions.SignalDicsUpdated = this.ViewModel.Signals.SignalDicsUpdated.subscribe(function(value){
        if(value)
        {
            var data = _this.ViewModel.GetGroupDicAsDataForTreeTable();
            _this.Views.GroupsTable.parse(webix.copy(data));
            
            if(data && data.length && data[0].data && data[0].data.length && data[0].data[0].id)
            {
                _this.Views.GroupsTable.select(data[0].data[0].id);
            }

            //_this.LoadWiki(null);
            //_this.RefreshParamsForm();

            if(!_this.UseCurrentHardwareId)
                _this.Refresh();
        }
    });

    this.ViewModel.InitDicsIfNeed();

    this.Subscriptions.ConfigHistoryUpdated = this.ViewModel.Signals.SignalConfigHistoryUpdated.subscribe(function (value)
    {
        if (value)
        {
            _this.DefineHistoryForms();
        }
    });

    this.Subscriptions.ConfigUpdated = this.ViewModel.Signals.ConfigFileUpdated.subscribe(function (V)
    {
        if (V)
        {
            _this.DefineForms();
        }
    });


    this.Subscriptions.SignalsDicsAndConfigUpdated = Rx.Observable.combineLatest
    (
        this.ViewModel.Signals.SignalDicsUpdated,
        this.ViewModel.Signals.ConfigRefreshed
    ).subscribe(function (Val)
    {
        if(Val[0] == 1 && Val[1] == 1)
            _this.Signals.Editable.next(1);
        else
            _this.Signals.Editable.next(0);
    });

    this.Subscriptions.Editable = this.Signals.Editable.subscribe(function (V)
    {
        if (V)
        {
            _this.Views.SaveBtn.enable();
            _this.Views.HistoryBtn.enable();
            _this.Views.Editor.enable();
            _this.Views.EditorCode.enable();
            _this.Views.EditorTabs.enable();

        }
        else
        {
            _this.Views.SaveBtn.disable();
            _this.Views.HistoryBtn.disable();
            _this.Views.Editor.disable();
            _this.Views.EditorCode.disable();
            _this.Views.EditorTabs.disable();
        }
    });

    window.onbeforeunload = function()
    {
        _this.WikiHistoryLength.next(0);
        return "Your work will be lost.";
    };

    _this.ViewModel.HistoryRefresh();
    // _this.LoadWiki(null);
    // _this.RefreshParamsForm();
};

HardwareConfigViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

};

HardwareConfigViewController.prototype.Destroy = function ()
{
    var _this = this;

    this.Destroyed = true;

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });


    if(this.ViewModel)
        this.ViewModel.Destroy();
    delete this.ViewModel;
};

HardwareConfigViewController.prototype.Refresh = function ()
{
    var _this = this;

    App.NavRouter.ShowProgress();

    //_this.Views.Accordion.disable();


    this.ViewModel.Refresh({callback:function (R)
    {
        App.NavRouter.HideProgress();

        if(R.success)
        {
            webix.message(LangHelper.GetString("Dics", "Configuration loaded."));
        }
        else
        {
            //webix.message({type:"error", text:R.error.msg});
            _this.ShowServerError(R.error);
        }
    }});
};

HardwareConfigViewController.prototype.ViewFromDic = function (DicId)
{
    return Helper.ViewFromDpiConfigDic(DicId, this.ViewModel.Dic);
};

HardwareConfigViewController.prototype.ViewsFromDicForGroup = function (GroupId)
{
    var _this = this;

    var views = [];

    this.ViewModel.GetSortedConfigDicKeysArr().forEach(function (Key)
    {
        if(_this.ViewModel.Dic[Key].group == GroupId && _this.ViewModel.Dic[Key].view)
        {
            views.push(_this.ViewFromDic(Key));
        }
    });

    return views;
};

HardwareConfigViewController.prototype.DefineForms = function ()
{
    var _this = this;

    this.Views.CodeEditor.setValue(this.ViewModel.GetConfig());

    // var t = _this.ViewModel.GetConfigModel();

    _this.Views.ParamsForm.setValues(_this.ViewModel.GetConfigModel(),true);
};

HardwareConfigViewController.prototype.GetFormsValues = function ()
{
    var _this = this;

    var configModel = {};

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        Object.keys(_this.Views.FormsGroups[Key].elements).forEach(function (ElKey)
        {
            var el = _this.Views.FormsGroups[Key].elements[ElKey];

            configModel[ElKey] = el.getValue();
        });
    });

    return configModel;
};

HardwareConfigViewController.prototype.ConfigSave = function (Params)
{
    var _this = this;


    App.NavRouter.ShowProgress();
    //
    // this.ViewModel.Save();
    // App.NavRouter.HideProgress();
    this.ViewModel.Save({callback:function (R)
    {
        App.NavRouter.HideProgress();

        if(R.success)
        {
            webix.message(LangHelper.GetString("DpiConfig","Configuration saved"));

            if(_this.OnSave && typeof _this.OnSave === "function")
            {
                _this.OnSave();
            }
        }
        else
        {
            //webix.message({type:"error", text:R.error.msg});
            _this.ShowServerError(R.error);
        }

        if(Params && Params.callback && typeof Params.callback === "function")
        {
            Params.callback(R);
        }
    }});
};

HardwareConfigViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};

HardwareConfigViewController.prototype.SetCurrentFormVals = function()
{
    var _this = this;

    var vals = this.Views.ParamsForm.getValues();

    if(Object.keys(vals).length > 0)
    {
        _this.ViewModel.SetConfigModel(vals);
    }
};

HardwareConfigViewController.prototype.RefreshParamsForm = function(Params)
{
    var _this = this;

    if(this.FormIdBuilding)
    {
        this.FormIdNextBuilding = Params;
        return;
    }

    _this.SetCurrentFormVals();

    this.FormIdBuilding = Params && Params.id ? Params.id : 'default';


    var oldViews = [];
    _this.Views.ParamsForm.getChildViews().forEach(function (View)
    {
        oldViews.push(View);
    });

    var oldViewsLen = oldViews.length;

    var newViews = [];

    if (Params && Params.custom_controls) {
        newViews.push({
            view:{
            view: "toolbar",
            height: webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
            borderless: true,
            elements: function () {
                var result = [];

                var locale = LangHelper.GetLocale();

                Object.keys(Params.custom_controls).forEach(function (Key) {
                    var control = Params.custom_controls[Key];
                    var view = {
                        view: control.view,
                        label: control.label[locale],
                        tooltip: control.tooltip && control.tooltip[locale] ? control.tooltip[locale] : control.label[locale]
                    };

                    if (control.css) {
                        view.css = control.css;
                    }

                    if (control.type) {
                        view.type = control.type;
                    }

                    if (control.icon) {
                        view.icon = control.icon;
                    }

                    if (control.width) {
                        view.width = control.width;
                    }

                    if (control.height) {
                        view.height = control.height;
                    }

                    if (control.click) {
                        view.click = function () {
                            var node = this.getNode();

                            _this[control.click](node);
                        };
                    }

                    result.push(view);
                });

                result.push({});

                return result;
            }()
        },
            view_id:null
        });
    }

    _this.ViewModel.GetStoredConfigPropertiesByParamsOrder(Params).forEach(function (View)
    {
        newViews.push({
            view:_this.ViewFromHardwareConfigParam(View),
            view_id: View.id
        });
    });

    var newViewsLen = newViews.length;

    var clRefresh = function ()
    {
        _this.Views.ParamsForm.refresh();
        _this.Views.ParamsForm.setValues(_this.ViewModel.GetConfigModel(),true);
        _this.FormIdBuilding = null;

        if(_this.FormIdNextBuilding)
        {
            var next = webix.copy(_this.FormIdNextBuilding);
            _this.FormIdNextBuilding = null;

            _this.RefreshParamsForm(next);
        }
    };

    var clRemove = function (Arr)
    {
        if(_this.Destroyed)
            return;

        var view = Arr.pop();

        if(view)
        {
            _this.Views.ParamsForm.removeView(view);

            if ((oldViewsLen - Arr.length)%10 == 0) {
                setTimeout(function () {
                    clRemove(Arr);
                },1);
            }
            else {
                clRemove(Arr);
            }
        }
        else
        {
            clRefresh();
        }
    };

    var stepAdd = 0;

    var clAdd = function (Arr)
    {
        if(_this.Destroyed)
            return;

        var item = Arr.shift();

        var view  = item && item.view ? item.view : null;
        var view_id = item && item.view_id ? item.view_id : null;

        if(view)
        {
            if(_this.Views.ParamsForm.elements.vchannels_type && view_id == "vchannels_list"){
                _this.Views.ParamsForm.addView(view, stepAdd);

                _this.SettingsVchannelsList();
            } else {
                _this.Views.ParamsForm.addView(view, stepAdd);
            }

            if(view_id && _this.Views.ParamsForm.elements[view_id] !== undefined && _this.ViewModel.GetConfigModel()[view_id] !== undefined)
                _this.Views.ParamsForm.elements[view_id].setValue(_this.ViewModel.GetConfigModel()[view_id]);

            stepAdd++;

            if ((newViewsLen - Arr.length)%10 == 0) {
                setTimeout(function () {
                    clAdd(Arr);
                }, 1);
            }
            else {
                clAdd(Arr);
            }
        }
        else
        {
            clRemove(oldViews);
        }
    };

    clAdd(newViews);

    this.Views.ParamsForm.scrollTo(0,0);

    return;
};

HardwareConfigViewController.prototype.RefreshParamsFormBySearchString = function(Search)
{
    var _this = this;

    this.SetCurrentFormVals();

    var arr = [];

    if(Search)
    {
        this.Views.GroupsTable.disable();

        arr = this.ViewModel.GetStoredConfigPropertiesBySearchString(Search);
    }
    else{
        this.Views.GroupsTable.enable();
    }

    this.Views.ParamsForm.reconstruct();

    arr.forEach(function(Val){
        _this.Views.ParamsForm.addView(_this.ViewFromHardwareConfigParam(Val));
        if(Val.id == "vchannels_list")
            _this.SettingsVchannelsList();
    });


    this.Views.ParamsForm.refresh();

    _this.Views.ParamsForm.setValues(_this.ViewModel.GetConfigModel(),true);

    if(!Search)
    {
        var item = this.Views.GroupsTable.getSelectedItem();

        var parentItem = this.Views.GroupsTable.getParentId(item.id);

        if(!parentItem)
            return

        _this.RefreshParamsForm(item);
    }
};

HardwareConfigViewController.prototype.RefreshGroupsTable = function()
{
  var _this = this;

  this.Views.GroupsTable.clearAll();

  this.Views.GroupsTable.parse(this.ViewModel.GetSortedConfigGroupDicArr());
};

HardwareConfigViewController.prototype.ViewFromHardwareConfigParam = function(Params)
{
    var view = {}, hBtnView = null, locale = LangHelper.GetLocale();

    view.name = Params.id?Params.id:"";
    view.label =  Params.title && Params.title[locale] ?Params.title[locale] : "";
    view.labelPosition = "top";

    view.view = "text";
    view.invalidMessage = "";
    view.placeholder = "";
    view.tooltip = Params.description && Params.description[locale] ? Params.description[locale] : "";

    if(Params.gui)
    {
        view.view = Params.gui.view ? Params.gui.view : "text";
        view.invalidMessage = Params.gui.invalidMessage && Params.gui.invalidMessage[locale] ? Params.gui.invalidMessage[locale] : "";
        view.placeholder = Params.gui.placeholder ? Params.gui.placeholder : "";

        if(Params.gui.tooltip && Params.gui.tooltip.use_description && Params.gui.tooltip.show)
        {
            var description = Params.description && Params.description[locale] ? Params.description[locale] : "";

            if(Params.wiki && Params.wiki[locale])
            {
                description += "<br/><a href='" + Params.wiki[locale] + "' target='blank'>" + LangHelper.GetString("Dics", "More...") + "</a>";
            }

            hBtnView = {
                view: "button",
                type: "icon",
                icon: "question-circle",
                css:"toolbar_round_btn",
                width:32,
                popup:{
                    view:"popup",
                    height:Params.gui.tooltip.height ? Params.gui.tooltip.height : 0,
                    width: Params.gui.tooltip.width ? Params.gui.tooltip.width : 320,
                    body:{
                        borderless:true,
                        template: description
                    }
                }
            };

            if(Params.id == "vchannels_list") {
                hBtnView = {
                    cols:[
                        this.SettingsVchannelsListBtn,
                        {
                            view: "button",
                            type: "icon",
                            icon: "question-circle",
                            css:"toolbar_round_btn",
                            width:32,
                            popup:{
                                view:"popup",
                                height:Params.gui.tooltip.height ? Params.gui.tooltip.height : 0,
                                width: Params.gui.tooltip.width ? Params.gui.tooltip.width : 320,
                                body:{
                                    borderless:true,
                                    template: description
                                }
                            }
                        }
                    ]
                }
            }
        }


        if(Params.gui.validate)
        {
            view.validate = function(Val)
            {
              return ConfigHelper[Params.gui.validate](Val);
            };
        }

        if(Params.gui.params)
        {
            var prms = Params.gui.params;
            Object.keys(prms).forEach(function(K){
                view[K] = prms[K];
            });
        }

        if(Params.gui.cfgproperties)
        {
            view.cfgproperties = Params.gui.cfgproperties;
        }
    }

    if(Params.options)
    {
        var arr = [];
        Object.keys(Params.options).forEach(function(Val){
            arr.push({
                id: Params.options[Val].id,
                value: Params.options[Val].title && Params.options[Val].title[locale] ? Params.options[Val].title[locale] : ""
            });
        });
        view.options = arr;
    }

    if(view.validate)
    {
        view.on = {
            "onChange": function(Newv, Oldv)
            {
                this.validate();
            }
        }
    }

    if(view.view == "inputlist")
    {
        var lbl = {
            cols:[
                {
                    view: "label",
                    label: view.label
                }
            ]
        };

        view.label = null;
        view.labelWidth = 0;
        return {
            cols:[
                {
                    rows:[
                        lbl,
                        view
                    ]
                },
                hBtnView
            ]
        };
    }
    else if (view.view == "trafficConfig")
    {
        view.labelWidth = 0;
        return {
            rows: [
                {
                    view: "label",
                    label: view.label
                },
                view
            ]

        };
    }
    else if(view.view == "object-inputlist")
    {
        var lbl = {
            cols:[
                {
                    view: "label",
                    label: view.label
                }
            ]
        };

        view.label = null;
        view.labelWidth = 0;
        return {
            cols:[
                {
                    rows:[
                        lbl,
                        view
                    ]
                },
                hBtnView
            ]
        };
    }

    return hBtnView ? {cols:[view,hBtnView]} : view;
};

HardwareConfigViewController.prototype.DefineHistoryForms = function (Params)
{
    this.Views.HistoryTable.clearAll();
    this.Views.HistoryTable.parse(this.ViewModel.GetHistory());
    this.Views.HistoryEditor.setValue("");
};

HardwareConfigViewController.prototype.LoadWiki = function(Params)
{
    if(Params && Params.wiki)
    {
        this.Views.WiKi.load(Params.wiki);
    }
    else if(this.ViewModel.GroupDic && this.ViewModel.GroupDic.default){

        var locale = LangHelper.GetLocale();
        this.Views.WiKi.load(this.ViewModel.GroupDic.default.wiki[locale]);
    }
};

HardwareConfigViewController.prototype.ConfigValidate = function (Params)
{
    "use strict";

    var _this = this;

    App.NavRouter.ShowProgress();

    this.ViewModel.Validate({callback:function (R)
    {
        App.NavRouter.HideProgress();

        if(!R.success)
        {
            _this.ValidationDataContext.show();
            _this.Views.ValidationDataContextCodeEditor.setValue(R.error.msg);
        }
        else
        {
            webix.message(LangHelper.GetString("DpiConfig","Configuration is correct"));
        }

        if(Params && Params.callback && typeof Params.callback === "function")
        {
            Params.callback(R);
        }
    }});
};

HardwareConfigViewController.prototype.SettingsVchannelsList = function (View) {
    var _this = this;

    var settingsBtn = $$("SettingsVchannelsListBtn");
    var vchannelsType = _this.Views.ParamsForm.elements.vchannels_type;
    if(vchannelsType){
        if(vchannelsType.config.value != 3){
            settingsBtn.hide();
        }
        _this.Views.ParamsForm.elements.vchannels_type.attachEvent("onChange", function(Val) {
            if(Val == "3"){
                settingsBtn.show();
            }
            else if(settingsBtn){
                settingsBtn.hide()
            }
        });
    }
};

HardwareConfigViewController.prototype.AddItemToVchannelTable = function()
{
    var _this = this;

    _this.Views.CreateVchannelContextForm.clear();
    var model = new VchannelsSettingsConfigModel();

    _this.Views.VchannelTable.add(model, -1);

    _this.Views.VchannelTable.select(model.id, false);
    _this.Views.VchannelTable.showItem(model.id);

    _this.ShowVchannelTableEditForm(model, _this.Views.VchannelTable.getItemNode(model.id), "right");
};

HardwareConfigViewController.prototype.ShowVchannelTableEditForm = function (Data, Node, Pos)
{
    var _this = this;

    if(Data)
    {
        var formParams = new VchannelsSettingsConfigModel(Data);

        if(formParams)
        {
            this.Views.CreateVchannelContextForm.clear();
            this.Views.CreateVchannelContextForm.setValues(new VchannelsSettingsConfigModel(formParams), Data);
        }
    }

    this.Views.CreateVchannelContext.show(Node,{pos:Pos});
};

HardwareConfigViewController.prototype.SaveVchannelSettings = function (Data, History = null) {
    let _this = this;

    let data = Data && (Data.IPv4 || Data.IPv4 == "") && (Data.IPv6 || Data.IPv6 == "") ? Data : _this.ValidateSettingsVchannel();

    if(!data && (!data.IPv4 && data.IPv4 !== "") && (!data.IPv6 && data.IPv6 !== "")) {
        webix.message({type:"error", text:LangHelper.GetString("DpiConfig","Data is Invalid")});
        _this.SaveVchannelFormContext.hide();
        return false;
    }

    _this.VchannelModel.SaveVchannelSettings(
        {
            IPv4: data.IPv4,
            IPv6: data.IPv6,
            callback: function(R)
            {
                if(R.success)
                {
                    _this.GetVchannelSettings();
                    if(!History){
                        _this.SettingsVchannelsListForm.hide();
                    }

                    webix.message(LangHelper.GetString("Vchannels", "Vchannel settings saved"));
                }
                else{
                    if(R.error)
                        webix.message({text: R.error.msg,type:"error"});
                }
            }
        }
    );
};

HardwareConfigViewController.prototype.ValidateSettingsVchannel = function () {
    var _this = this;

    if(!_this.Views.SettingsVchannelsListForm.validate())
        return false;

    let tabbarValue = $$(this.Id + "SettingsVchannelsListForm" + "Tabbar").getValue();

    let IPv4 = "", IPv6 = "";
    
    if(tabbarValue && tabbarValue.indexOf("Table") != -1)
    {
        var values = _this.Views.VchannelTable.serialize();

        for (const item in values)
        {
            let [ip, mask] = values[item].cidr.split("/");

            if (mask && mask > 128 || mask < 0)
                return false;

            let cidrValidate = Helper.ValidateIPaddressOrCidr(values[item].cidr);

            let vchannelValidate = Number(values[item].vchannel);

            if (cidrValidate == "" || vchannelValidate == ""){
                continue;
            }

            if(!cidrValidate || !vchannelValidate)
                return false;

            let value = `${values[item].cidr} ${values[item].vchannel}\n`;

            if (Helper.ValidateIPv4OrCidr(values[item].cidr))
                IPv4 += value;
            else if (Helper.ValidateIPv6OrCidr(values[item].cidr))
                IPv6 += value;
        }
    }
    else if( tabbarValue && tabbarValue.indexOf("Editor") != -1)
    {
        IPv4 = _this.ValidateVchannelSettingsEditor(_this.Views.VchannelEditor);
        IPv6 = _this.ValidateVchannelSettingsEditor(_this.Views.VchannelIPv6Editor, 1);
    }

    return {IPv4, IPv6};
}

HardwareConfigViewController.prototype.GetVchannelSettings = function () {
    let _this = this;

    _this.VchannelModel.GetVchannelSettings(
        {
            callback: function(R)
            {
                if(R.success)
                {
                    _this.Views.VchannelTable.clearAll();
                    _this.Views.VchannelEditor.setValue("");

                    let ipv4 = "", ipv6 = "";

                    if(R.data){
                        var values = R.data.split("\n");
                        for (const item in values) {
                            let [cidr, vchannel] = values[item].trim().split(" ");
                            
                            if (cidr == EmptyCidrsEnum.IPv4 || cidr == EmptyCidrsEnum.IPv6)
                                continue;

                            if (!Helper.ValidateIPaddressOrCidr(cidr))
                                continue;

                            let value = `${cidr} ${vchannel}\n`;

                            if (Helper.ValidateIPv4Cidr(cidr))
                                ipv4 += value;
                            else if (Helper.ValidateIPv6Cidr(cidr))
                                ipv6 += value;

                            if(cidr && vchannel){
                                _this.Views.VchannelTable.add({
                                    cidr,
                                    vchannel
                                })
                            }
                        }
                        _this.Views.VchannelEditor.setValue(ipv4);
                        _this.Views.VchannelIPv6Editor.setValue(ipv6);
                    }
                }
                else{
                    if(R.error)
                        webix.message({text: R.error.msg,type:"error"});
                }
            }
        }
    );
};

HardwareConfigViewController.prototype.GetVchannelSettingsConfigHistory = function () {
    let _this = this;


    _this.VchannelModel.GetVchannelSettingsConfigHistory(
        {
            callback: function(R)
            {
                if(R.success)
                {
                    _this.Views.VchannelHistoryTable.clearAll();
                    _this.Views.VchannelHistoryTable.parse(R.data);
                    _this.Views.VchannelHistoryEditor.setValue("");
                }
                else{
                    if(R.error)
                        webix.message({text: R.error.msg,type:"error"});
                }
            }
        }
    );
}

HardwareConfigViewController.prototype.ValidateVchannelSettingsEditor = function (Editor, IsIPv6) {

    var _this = this;
    var data = "";

    var editorValue = Editor ? Editor.getValue() : _this.Views.VchannelEditor.getValue();

    var values = editorValue ? editorValue.split("\n"): "";

    if(values){
        for (const item in values) {
            let [cidr, vchannel] = values[item].trim().split(" ");

            if (cidr && vchannel) {
                let [ip, mask] = cidr.split("/");

                if(mask)
                {
                    if(mask < 0)
                    {
                        return false;
                    }

                    if((IsIPv6 && mask > 128) || (!IsIPv6 && mask > 32))
                    {
                        return false;
                    }
                }

                let cidrValidate = Helper.ValidateIPaddressOrCidr(cidr);
                let vchannelValidate = Number(vchannel);

                if(!cidrValidate || !vchannelValidate)
                    return false;

                data += `${cidr} ${vchannel}\n`
            }
        }
    }

    return data;
}

HardwareConfigViewController.prototype.CidrsSplit = function (CIDRS) {
    let IPv4 = "";
    let IPv6 = "";

    if(CIDRS)
    {
        let values = CIDRS.split("\n");

        for (const item in values) {
            let [cidr, vchannel] = values[item].trim().split(" ");

            if(!cidr && !vchannel)
                continue;

            let value = `${cidr} ${vchannel}\n`;

            if (Helper.ValidateIPv4Cidr(cidr))
                IPv4 += value;
            else if (Helper.ValidateIPv6Cidr(cidr))
                IPv6 += value;
        }
    }

    return {IPv4, IPv6, ArrIPv4:IPv4.split("\n"), ArrIPv6:IPv6.split("\n")};
}
function FastPcrfConfigViewController(Params)
{
    var _this = this;
    this.Id = "FastPcrfConfig";
    this.ViewModel = new BaseHardwareConfigManager({
        prefix: _this.Id,
        dic: "fastpcrf"
    });

    this.onRestart = function(R)
    {
        if(R.success)
        {
            if(R.data.pcrf.success)
            {
                webix.message(LangHelper.GetString(_this.Id, "Service reloaded successfully"));
            }
            else
            {
                webix.message({type:"error", text:R.data.pcrf.error.msg});
            }

            var servers = R.data.servers;
            if(servers && servers.length > 0)
            {
                servers.forEach(function(serv, i){
                    if(serv && serv.hardware)
                    {
                        if(serv.hardware.success)
                        {
                            var restart = serv.restart;

                            if(restart)
                            {
                                if(restart.success)
                                {
                                    webix.message(serv.addr + " : " +LangHelper.GetString(_this.Id, "FastDPI service restarted successfully"));
                                }
                                else
                                {
                                    webix.message({type:"error", text:serv.addr + " : " + start.error.msg});
                                }
                            }
                        }
                        else{
                            webix.message({type:"error", text:serv.addr + " : " + serv.hardware.error.msg});
                        }
                    }
                });
            }
        }
        else{
            webix.message({type:"error", text:R.error.msg});
        }
    };

    this.HardwareRestartContext = webix.ui({
        view:"popup",
        width:360,
        height:200,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Dics", "Are you sure you want to restart the PCRF process?")
                        + "<br/><br/>" +  "<span style='color: red'>"
                        + LangHelper.GetString(_this.Id, "All fastdpi services from property fdpi_server will be restarted!")
                        + "</span>"
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Dics", "Restart"),
                            click:function ()
                            {
                                _this.HardwareRestartContext.hide();
                                _this.ViewModel.Restart({
                                    callback: _this.onRestart
                                });
                                _this.OnSaveContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HardwareReloadContext = webix.ui({
        view:"popup",
        width:360,
        height:160,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Dics", "Are you sure you want to update the hot settings?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Dics", "Cancel"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                            }
                        },
                        {
                            view:"button",
                            type:"form",
                            label:LangHelper.GetString("Dics", "Refresh"),
                            click:function ()
                            {
                                _this.HardwareReloadContext.hide();
                                _this.ViewModel.Reload();
                                _this.OnSaveContext.hide();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.UpdateParamsContextId = this.Id + "UpdateParamsContext";
    this.UpdateParamsContext = webix.ui({
        view:"submenu",
        id:this.UpdateParamsContextId,
        width:320,
        autowidth: true,
        padding: 0,
        data: [
            {id: this.UpdateParamsContextId+"RestartDpi", icon: "retweet", value: LangHelper.GetString("Dics", "Restart PCRF")},
            {id: this.UpdateParamsContextId+"ReloadDpi", icon: "bolt", value: LangHelper.GetString("Dics","Updating hot options")}
        ],
        type: {
            template: function (obj) {
                if (obj.type) {
                    return "<div class='separator'></div>";
                }

                return "<span class='webix_icon alerts fa-" + obj.icon + "'></span><span>" + obj.value + "</span>";
            }
        },
        on: {
            onMenuItemClick: function (id)
            {
                this.hide();

                var node = $$(_this.Id + "OptionsUpdateBtn").getNode();
                if(id === _this.UpdateParamsContextId+"RestartDpi")
                {
                    setTimeout(function ()
                    {
                        _this.HardwareRestartContext.show(node, {pos: "bottom"});
                    }, 10);
                }
                else if(id === _this.UpdateParamsContextId+"ReloadDpi")
                {
                    _this.HardwareReloadContext.show(node, {pos: "bottom"});
                }
            }
        }
    });

    this.OnSaveContext = webix.ui({
        view:"popup",
        modal: true,
        width:480,
        height:200,
        left: (window.innerWidth / 2 ) - 240,
        top: (window.innerHeight / 2) - 100,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(_this.Id, "Fast PCRF config saved!") + "<br/>" +
                        "<span style='color: red'>" +
                            LangHelper.GetString(_this.Id, "Update the hot parameters or restart Fast PCRF for applying the changes!") +
                        "</span>"
                },
                {
                    cols:[
                        {
                            view: "button",
                            height: 40,
                            label: LangHelper.GetString("Dics", "Cancel"),
                            click: function()
                            {
                                _this.OnSaveContext.hide();
                            }
                        },
                        {
                            view:"button",
                            height: 40,
                            type:"form",
                            // label:LangHelper.GetString("Dics", "Restart"),
                            icon: "bolt",
                            label: LangHelper.GetString("Dics","Update"),
                            click:function ()
                            {
                                var node = this.getNode();
                                setTimeout(function ()
                                {
                                    _this.HardwareReloadContext.show(node, {pos: "bottom"});
                                }, 10);
                            }
                        },
                        {width: 8},
                        {
                            height: 40,
                            view:"button",
                            icon: "retweet",
                            type:"form",
                            label: LangHelper.GetString("Dics", "Restart"),
                            click:function ()
                            {
                                var node = this.getNode();
                                setTimeout(function ()
                                {
                                    _this.HardwareRestartContext.show(node, {pos: "top"});
                                }, 10);
                            }
                        }


                    ]
                }
            ]
        }
    });

    var params = webix.extend(Params,{
        Id:_this.Id,
        PageTitle:{
            RootTitle: LangHelper.GetString("AppView", "PCRF control"),
            Title: LangHelper.GetString("AppView", "Configuration")
        },
        ViewModel: _this.ViewModel,
        UseValidateOnSave: true,
        Buttons: [
            {
                view: "button",
                id:this.Id + "OptionsUpdateBtn",
                type: "icon",
                icon: "retweet",
                css: "toolbar_round_btn",
                width: 32,
                tooltip: LangHelper.GetString("Dics", "Updating options"),
                click: function (id, e, node)
                {
                    var __this = this;
                    setTimeout(function () {
                        var node = __this.getNode(id);
                        _this.UpdateParamsContext.show(node, {pos: "bottom"});
                    }, 1);
                }
            }
        ],
        onSave: function()
        {
            _this.OnSaveContext.show();
            return;
        }
    },true);

    FastPcrfConfigViewController.superclass.constructor.call(this, Params);

    // this.OnSaveContext.show();
}

Helper.ExtendClass(FastPcrfConfigViewController,HardwareConfigViewController);
function FastPcrfLogsViewController(Params)
{
    var params = webix.extend(Params,{
        Id:"FastPcrfLogs",
        PageTitle:{
            RootTitle: LangHelper.GetString("AppView", "PCRF control"),
            Title: LangHelper.GetString("AppView", "Logs")
        },
        ServerMethods:
        {
            RefreshLogsFilesList:"GetFastPcrfLogsFilesList",

            GetLogFileTail:"GetFastPcrfLogFileTail",

            DownloadLogFile:"DownloadFastPcrfLogFile"
        },
        PathsNamesMap:
        {
            "ap":"Apartment. Thread",
            "alert": "Alert",
            "stat":"Stat",
            "serv": "Serv",
        },
        FileNamesInfoMap:
        {
            "fastpcrf_ap0.log":LangHelper.GetString("HardwareLogs","FastDPI > FastPCRF interaction"),
            "fastpcrf_ap1.log":LangHelper.GetString("HardwareLogs","CoA"),
            "fastpcrf_ap2.log":LangHelper.GetString("HardwareLogs","Requests and answers to Radius servers"),
            "fastpcrf_ap3.log":LangHelper.GetString("HardwareLogs","Accounting"),
            "fastpcrf_ap4.log":LangHelper.GetString("HardwareLogs","FastPCRF > FastDPI interaction"),
            "serv_fastpcrf.log":LangHelper.GetString("HardwareLogs","Network interfaces status and services")
        }
    },true);

    FastPcrfLogsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(FastPcrfLogsViewController,HardwareLogsViewController);
function PointsLayerWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.Layer = null;

    this.Data = ViewConfig && ViewConfig.data ? ViewConfig.data : [];

    this.Style = ViewConfig && ViewConfig.style ? ViewConfig.style : new ol.style.Style({
        image: new ol.style.Circle({
            radius: 5,
            fill: new ol.style.Fill({color: 'red'})
        })
    });

    this.Subscriptions = {};

    this.Init(ViewConfig);
};

PointsLayerWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "PointsLayerWidget";
};

PointsLayerWidget.prototype.BindAll = function (ViewController, ViewModel)
{
    var _this = this;

    this.DefineLayer();
};

PointsLayerWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

PointsLayerWidget.prototype.DefineLayer = function ()
{
    var _this = this;
    var points = [];
    this.Data.forEach(function(Val, i){
        points.push(new ol.Feature({
            'geometry': new ol.geom.Point(ol.proj.fromLonLat([Val.lon, Val.lat])),
            'i': i,
            'size': 20,
            tooltip: Val.tooltip ? Val.tooltip : ''
        }));
    });

    this.Layer = new ol.layer.Vector({
        source: new ol.source.Vector({
            features: points
        }),
        style: _this.Style
    });
};
function LayersWidget(ViewConfig)
{
    var _this = this;

    this.Id = ViewConfig.id ? ViewConfig.id : "LayersWidget";

    this.ViewConfig = null;

    this.Map = null;
    this.Layers = ViewConfig && ViewConfig.layers ? ViewConfig.layers : {};
    this.Overlays = {
        Tooltip : null,
        Popup: null
    };

    this.Views = {
        Tooltip: null,
        Popup: null,
        PopupCloser: null,
        PopupContent: null
    };

    this.LayersPopup = webix.ui({
        view: "popup",
        id:this.Id + "LayersPopup",
        width: 320,
        height: 160,
        borderless: true,
        body: {
            rows:[
                        {
                            view: "form",
                            borderless: true,
                            elements:function(){
                                var elements = [];

                                Object.keys(_this.Layers).forEach(function(Key){
                                    elements.push({
                                        id: _this.Id + Key,
                                        view: "checkbox",
                                        labelPosition: "left",
                                        labelWidth: 200,
                                        label: _this.Layers[Key].title,
                                        value: 1
                                    });
                                });

                                return elements;
                            }()
                        },
                        {
                            gravity: 0
                        }
            ]
        }
    });

    this.Subscriptions = {};


    // this.MapControls = [
    //     new ol.control.OverviewMap({
    //         layers: [
    //             new ol.layer.Tile({
    //                 source: new ol.source.OSM()
    //             })
    //         ]
    //     })
    // ];

    this.Init(ViewConfig);
};

LayersWidget.prototype.Init = function (ViewConfig)
{
    var _this = this;


    this.ViewConfig =
        {
            rows: [
                {
                    id: this.Id + "Map",
                    template: "<div id=\""+_this.Id + "Map"+"\" style=\"height:inherit\" class='map'>" +
                    // "<div id=\""+_this.Id + "Tooltip\" class=\"map-tooltip\"></div>" +
                    // "<div id=\""+_this.Id + "Popup\" class=\"ol-popup\">" +
                    //     "<a href=\"#\" id=\"" + _this.Id + "PopupCloser\" class=\"ol-popup-closer\"></a>" +
                    //     "<div id=\""+ _this.Id + "PopupContent\"></div>" +
                    // "</div>" +
                    "</div>"
                },
                {gravity: 0}
            ]

        };

};

LayersWidget.prototype.Bind = function (ViewController, ViewModel)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        _this.Views[View] = document.getElementById(_this.Id + View);
    });

    Object.keys(this.Layers).forEach(function (LayerKey)
    {
        var l = _this.Layers[LayerKey].layer;

        if(l.BindAll)
            l.BindAll(_this, null);

        $$(_this.Id + LayerKey).attachEvent("onChange", function(newVal, OldVal)
        {
            _this.Layers[LayerKey].layer.Layer.setVisible(newVal);
        });

    });

    this.Views.PopupCloser.onclick = function () {
        _this.Overlays.Popup.setPosition(undefined);
        _this.Views.PopupCloser.blur();
        return false;
    };

    this.DefineMap();

};

LayersWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });
};

LayersWidget.prototype.DefineMap = function ()
{
    var _this = this;
    var zoom = 1;

    this.Map = new ol.Map({
        // controls: ol.control.defaults().extend([_this.MapControls]),
        target: this.Id + "Map",
        layers: [
            new ol.layer.Tile({
                source: new ol.source.OSM()
            })
        ],
        view: new ol.View({
            center: ol.proj.fromLonLat([-78.62971369233452, 22.100882124404166]),
            zoom: zoom
        })
    });

    this.Map.addControl(new ol.control.FullScreen());
    // this.Map.addControl(new ol.control.MousePosition());
    this.Map.addControl(new ol.control.OverviewMap({
        className: 'ol-overviewmap ol-custom-overviewmap',
        layers: [
            new ol.layer.Tile({
                source: new ol.source.OSM()
            })
        ],
        autoPan: true,
        size: {h:150, w:500},
        collapsed: false
    }));
    this.Map.addControl(new ol.control.ScaleLine());
    this.Map.addControl(new ol.control.Zoom());
    this.Map.addControl(new ol.control.ZoomSlider());

    // this.Map.addControl(new ol.control.LayerSwitcher({'ascending':false}));
    // this.Map.addControl(new ol.control.Permalink());
    // this.Map.addControl(new ol.control.Permalink('permalink'));
    // this.Map.addControl(new ol.control.KeyboardDefaults());

    Object.keys(this.Layers).forEach(function(Key){
        _this.Layers[Key].layer.DefineLayer();

        _this.Map.addLayer(_this.Layers[Key].layer.Layer);
    });

    this.SetUpOverlay();
    this.SetupPopup();
    this.SetupLayersControl();
};

LayersWidget.prototype.AddPoints = function (Points) {
    var points = [];
    Points.forEach(function(Val, i){
        points.push(new ol.Feature({
            'geometry': new ol.geom.Point(ol.proj.fromLonLat([Val.lon, Val.lat])),
            'i': i,
            'size': 20,
            tooltip: Val.tooltip ? Val.tooltip : ''
        }));
    });

    this.Layers.Points = new ol.layer.Vector({
        source: new ol.source.Vector({
            features: points
        }),
        style: new ol.style.Style({
            image: new ol.style.Circle({
                radius: 9,
                fill: new ol.style.Fill({color: 'red'})
            })
        })
    });

    this.Map.addLayer(this.Layers.Points);
};

LayersWidget.prototype.AddLines = function(Lines)
{
    var _this = this;
    var lines = [];

    Lines.forEach(function(Line){

        var points = [];

        Line.points.forEach(function(Val,i)
        {
            points[i] = ol.proj.transform([Val.lon, Val.lat], 'EPSG:4326', 'EPSG:3857')
        });

        var featureLine = new ol.Feature({
            geometry: new ol.geom.LineString(points),
            tooltip: Line.tooltip ? Line.tooltip : ''
        });

        lines.push(featureLine);
    });

    this.Layers.Lines = new ol.layer.Vector({
        source: new ol.source.Vector({
            features: lines
        }),
        style: new ol.style.Style({
            stroke: new ol.style.Stroke({
                width: 2,
                color: "green"
                // new ol.style.Fill({color: 'red'})
            }),
            image: new ol.style.Circle({
                radius: 9,
                fill: new ol.style.Fill({color: 'red'})
            })
        })
    });
    this.Map.addLayer(this.Layers.Lines);
};

LayersWidget.prototype.AddPolygons = function(Polygons)
{
    var polygons = [];

    Polygons.forEach(function(Polygon){
        var points = [];

        Polygon.points.forEach(function(Val,i)
        {
            points[i] = ol.proj.transform([Val.lon, Val.lat], 'EPSG:4326', 'EPSG:3857')
        });

        var feature = new ol.Feature({
            geometry: new ol.geom.Polygon([points]),
            tooltip: Polygon.tooltip ? Polygon.tooltip : ''
        });

        polygons.push(feature);
    });

    this.Layers.Polygons = new ol.layer.Vector({
        source: new ol.source.Vector({
            features: polygons
        }),
        style: new ol.style.Style({
            stroke: new ol.style.Stroke({
                color: 'blue',
                width: 2,
            }),
            fill: new ol.style.Fill({
                color: 'rgba(0, 0, 255, 0.1)'
            })
        })
    });

    this.Map.addLayer(this.Layers.Polygons);

};

LayersWidget.prototype.AddCircles = function(Circles)
{
  var circles = [];

  Circles.forEach(function(Circle){
     var center = ol.proj.fromLonLat([Circle.lon, Circle.lat]);

     circles.push(new ol.Feature({
        geometry: new ol.geom.Circle(center, Circle.radius),
        tooltip: Circle.tooltip ? Circle.tooltip: ""
     }));
  });

    this.Layers.Circles = new ol.layer.Vector({
        source: new ol.source.Vector({
            projection: 'EPSG:4326',
            features: circles
        }),
        style: new ol.style.Style({
            stroke: new ol.style.Stroke({
                color: 'green',
                width: 2,
            }),
            fill: new ol.style.Fill({
                color: 'rgba(0, 255, 0, 0.1)'
            })
        })
    });

    this.Map.addLayer(this.Layers.Circles);
};

LayersWidget.prototype.HideLayer = function(Layer)
{
  Layer.setVisible(false);
};

LayersWidget.prototype.ShowLayer = function(Layer)
{
  Layer.setVisible(true);
};

LayersWidget.prototype.SetUpOverlay = function()
{
  var _this = this;
  this.Overlays.Tooltip = new ol.Overlay({
      element: _this.Views.Tooltip,
      offset: [10, -10],
      autoPan: true,
      autoPanAnimation: {
          duration: 250,
      }
  });

  this.Map.addOverlay(this.Overlays.Tooltip);

  this.Map.on('pointermove', function(evt)
  {

      var pixel = evt.pixel;
      var feature = _this.Map.forEachFeatureAtPixel(pixel, function(feature) {
          return feature;
      });
      _this.Views.Tooltip.style.display = feature ? '' : 'none';
      if (feature) {
          _this.Overlays.Tooltip.setPosition(evt.coordinate);
          _this.Views.Tooltip.innerHTML = feature.get('tooltip');
      }
  })
};

LayersWidget.prototype.DisplayOverlay = function(evt)
{
    var _this = this;

    var pixel = evt.pixel;
    var feature = this.Map.forEachFeatureAtPixel(pixel, function(feature) {
        return feature;
    });
    _this.Views.Tooltip.style.display = feature ? '' : 'none';
    if (feature) {
        _this.Overlays.Tooltip.setPosition(evt.coordinate);
        _this.Views.Tooltip.innerHTML = feature.get('tooltip');
    }
};

LayersWidget.prototype.SetupPopup = function()
{
    var _this = this;
    this.Overlays.Popup = new ol.Overlay({
        element: _this.Views.Popup,
        autoPan: true,
        autoPanAnimation: {
            duration: 250,
        }
    });

    this.Map.addOverlay(this.Overlays.Popup);

    this.Map.on('singleclick', function(evt)
    {
        var pixel = evt.pixel;
        var feature = _this.Map.forEachFeatureAtPixel(pixel, function(feature) {
            return feature;
        });

        if(feature)
        {
            var coordinate = evt.coordinate;
            var hdms = ol.coordinate.toStringHDMS(ol.proj.toLonLat(coordinate));



            _this.Views.PopupContent.innerHTML = '<p>You are at ' + feature.get('tooltip') + ':</p><code>' + hdms + '</code>';
            _this.Overlays.Popup.setPosition(coordinate);
        }
    })
};

LayersWidget.prototype.SetupLayersControl = function()
{
    var _this = this;
    var button = document.createElement('button');
    var span = document.createElement('span');
    span.className = "fa-icon fa-layer-group";

    button.appendChild(span);
    var this_ = this;
    var handleCustomControl = function (e) {
        if(_this.LayersPopup.isVisible())
        {
            _this.LayersPopup.hide();
        }
        else{
            _this.LayersPopup.show(e.target, "left");
        }
    };

    button.addEventListener('click', handleCustomControl, false);
    // anchor_element.addEventListener('touchstart', handleCustomControl, false);

    var custom_element = document.createElement('div');
    custom_element.className = 'myCustomControl ol-unselectable ol-control';
    custom_element.appendChild(button);

    var myControl = new ol.control.Control({
        className: 'myControl',
        element: custom_element,
        target: document.getElementById("myCustomControl")

    });

    this.Map.addControl(myControl)
    // var map = new ol.Map({
    //     layers: [new ol.layer.Tile({source: new ol.source.OSM()})],
    //     controls: [],
    //     target: 'map',
    //     view: new ol.View({
    //         center: [-11000000, 4600000],
    //         zoom: 4
    //     })
    // });
};
var ClassifierCategoriesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"ClassifierCategoriesTableWidget",
        sortDisabledColumns:["checkbox", "trash"],
        enableCheckboxRefresh:true,
        showProgressWhenDataLoading:true,
        config:{
            method:function ()
            {
                return "Clsfr_GetCategoriesListReport";
            },
            sort:{id:"name_json",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [
                { id:"checked", header:["",{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}], template: CellColoredCheckBoxTemplate, width:32 },
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate },
                { id:"name_json", template:function(obj){
                        var lang = LangHelper.GetLocale();
                        if (obj && obj.name_json)
                        {
                            var name = JSON.parse(obj.name_json);
                            var local = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
                        }else{
                            var local = obj.name;
                        }
                        return local;
                    }, fillspace:true, header:[LangHelper.GetString("Classifier","Name"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"code", fillspace:true, header:[LangHelper.GetString("Classifier","Code") + " (" + LangHelper.GetString("Classifier","Folder") + ")", {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate, sort:false }
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var ClassifierHostsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"ClassifierHostsTableWidget",
        enableCheckboxRefresh:true,
        showProgressWhenDataLoading:true,
        sortDisabledColumns:["checkbox", "trash"],
        config:{
            method:function ()
            {
                return "Clsfr_GetHostsListReport";
            }
        },
        columns: function ()
        {
            var cols = [
                { id:"checked", header:["", {content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}], template: CellColoredCheckBoxTemplate, width:32 },
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate },
                { id:"host", fillspace:true, header:[LangHelper.GetString("Classifier","Host"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"name", template:function(obj){
                        var lang = LangHelper.GetLocale();
                        if (obj && obj.name_json)
                        {
                            var name = JSON.parse(obj.name_json);
                            var local = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
                        }else{
                            var local = obj.name;
                        }
                        return local;
                    }, fillspace:true, header:[LangHelper.GetString("Classifier","Category"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"is_porn", template:function(obj){
                    var dic = Helper.DictToArr(PornYesNoDic);
                    var elem = dic[obj.is_porn];

                    return (elem && elem.value)?elem.value:dic[2].value;
                    }, fillspace:true, header:[LangHelper.GetString("Dics","Availability of porn images"), { content: "richSelectFilter", options: Helper.DictToArr(PornYesNoDic),placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"to_recheck", fillspace:true, header:[LangHelper.GetString("Classifier","To recheck"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"recheck_date", enableDateRangeFilter:1, template: LocalTimeZone, fillspace:true, header:[LangHelper.GetString("Classifier","Recheck date"),  {content: "dateRangeFilter", contentId:"recheck_date", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate }
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on: {}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterFilterCustomHandler)
    {
        params.on.onAfterFilterCustomHandler = function ()
        {
            Params.onAfterFilterCustomHandler();
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};



function ClassifierViewController(Params)
{
    var _this = this;

    this.Id = "Classifier";

    this.ViewModel = new ClassifierCategoriesManager();

    this.HostsViewModel = new ClassifierHostsManager();

    this.ModelsViewModel = new ClassifierModelManager();

    this.ReportsModel = new UniReportsManager();

    this.CategoriesEditContext = {
        view: "popup",
        id: this.Id + "CategoriesEditContext",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "CategoriesEditContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            id: this.Id + "ClassifierCategoriesLocales",
                            view: "InputLocal",
                            label: LangHelper.GetString("Classifier","Name"),
                            name:"name",
                            maxInputs: 16,
                            width: 400,
                            placeholder: LangHelper.GetString("Classifier","Name"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field"),
                            tooltipHeight: 320
                        },
                        {
                            view: "text",
                            id:this.Id + "EditPopupCodeInput",
                            name: "code",
                            labelWidth:84,
                            width: 374,
                            label: LangHelper.GetString("Classifier","Code"),
                            tooltip:LangHelper.GetString("Classifier","Code"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.CategoriesEditContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "CreateCategoriesContextFormSaveBtn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.SaveCategoriesEditForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.CategoriesTrashContext = {
        view:"popup",
        id: this.Id + "CategoriesTrashContext",
        width:380,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Classifier","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Classifier","Cancel"),
                            click:function ()
                            {
                                _this.Views.CategoriesTrashContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "CategoriesTrashContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString("Classifier","Delete"),
                            click:function ()
                            {
                                _this.Views.CategoriesTrashContext.hide();

                                _this.DeleteCategoriesEditForm();
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.HostsEditContext = {
        view: "popup",
        id: this.Id + "HostsEditContext",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "HostsEditContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "text",
                            id:this.Id + "HostUrl",
                            name: "host",
                            labelWidth:104,
                            label: LangHelper.GetString("Classifier","Host"),
                            tooltip:LangHelper.GetString("Classifier","Host"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            view: "combo",
                            name: "cat_id",
                            labelWidth:104,
                            label: LangHelper.GetString("Classifier", "Host category"),
                            tooltip:LangHelper.GetString("Classifier","Host category"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options:[],
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.HostsEditContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "HostsEditContextFormSaveBtn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.SaveHostsEditForm();
                                    }
                                },
                                {
                                    view:"button",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Train"),
                                    click:function(id, e)
                                    {
                                        _this.Views.HostsEditContext.hide();

                                        var params = _this.Views.HostsEditContextForm;

                                        var table = _this.Views.ReportsWidgets.HostsReport.Views.Table;

                                        var data = params.getValues();

                                        var node = data._id ? table.getItemNode(table.getSelectedId()) : $$(_this.Id + 'AddHostBtn').getNode();

                                        _this.ShowHostsMachineLearningEditForm(data, node, "right");

                                        if (data.host.length > 0){
                                            _this.EnableProgressForButton(_this.Views.MlGetBtn);

                                            _this.Views.MlGetBtn.disable();
                                            _this.Views.MlSaveBtn.disable();
                                            _this.Views.MlCheckBtn.disable();
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.HostsSetCategoryContext = {
        view: "popup",
        id: this.Id + "HostsSetCategoryContext",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "HostsSetCategoryContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "combo",
                            name: "cat_id",
                            labelWidth:104,
                            label: LangHelper.GetString("Classifier", "Host category"),
                            tooltip:LangHelper.GetString("Classifier","Host category"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options:[],
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.HostsSetCategoryContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "HostsSetCategoryContextFormSaveBtn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.Views.HostsSetCategoryContext.hide();

                                        _this.SaveHostsSetCategoryForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.HostsTrashContext = {
        view:"popup",
        id: this.Id + "HostsTrashContext",
        width:380,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Classifier","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Classifier","Cancel"),
                            click:function ()
                            {
                                _this.Views.HostsTrashContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "HostsTrashContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString("Classifier","Delete"),
                            click:function ()
                            {
                                _this.Views.HostsTrashContext.hide();

                                _this.DeleteHostsEditForm();
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.HostsEraseContext = webix.ui({
        view:"popup",
        width:380,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to remove all list items?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.HostsEraseContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "HostsEraseContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Remove all"),
                            click:function ()
                            {
                                _this.HostsEraseContext.hide();

                                _this.EraseHostsEditForm();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HostsDelSelectContext = webix.ui({
        view:"popup",
        width:380,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.HostsDelSelectContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "HostsDelSelectContext" + "DeleteBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Delete"),
                            click:function ()
                            {
                                _this.HostsDelSelectContext.hide();

                                _this.HostsDelSelectEditForm();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HostsImportContext = webix.ui({
        view:"popup",
        width:520,
        height:520,
        modal:true,
        body:{
            view:"form",
            id:this.Id+"HostsImportContextForm",
            borderless:true,
            elements:[
                {
                    view: "uploader",
                    value: LangHelper.GetString(_this.Id,"Click to download or drag a file"),
                    id: this.Id+"HostsImportContext" + "Uploader",
                    css:"upload_area",
                    autosend:false,
                    height:64
                },
                {
                    view:"datatable",
                    id:this.Id+"HostsImportContext" + "Table",
                    checkboxRefresh:true,
                    columns:[
                        {
                            id: "host",
                            header: [LangHelper.GetString(_this.Id,"Host"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                            sort: "string",
                            editor: "text",
                            fillspace: true
                        },
                    ],
                    scheme:{
                        $init:function(obj){
                            obj.host = obj.data0;
                        }
                    },
                    on: {
                        onItemClick: function (id, e, node)
                        {
                            if (id.column === 'trash')
                            {
                                this.remove(id);
                            }
                        }
                    }
                },
                {
                    cols:[
                        {
                            view: "button",
                            label: LangHelper.GetString(_this.Id, "Get template"),
                            click: function()
                            {
                                _this.GetHostsImportTemplate();
                            }
                        },
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(_this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.HostsImportContext.hide();
                                _this.Views.HostsImportContextTable.clearAll();
                            }
                        },
                        {
                            view:"button",
                            id:this.Id + "HostsImportContext" + "ImportBtn",
                            type:"form",
                            label:LangHelper.GetString(_this.Id,"Import"),
                            click:function ()
                            {
                                _this.HostsImportContext.hide();

                                _this.SaveImportedExceldata();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.HostsMachineLearningEditContext = {
        view: "popup",
        id: this.Id + "HostsMachineLearningEditContext",
        width: 540,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "HostsMachineLearningEditContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            cols:[
                                {
                                    view: "text",
                                    id:this.Id + "HostsUrl",
                                    name: "host",
                                    labelWidth:104,
                                    label: LangHelper.GetString("Classifier","Host"),
                                    tooltip:LangHelper.GetString("Classifier","Host"),
                                    required:true,
                                    validate: webix.rules.isNotEmpty,
                                    invalidMessage: LangHelper.GetString("Classifier", "Required field")
                                },
                                {
                                    view:"button",
                                    id:this.Id + "MlGetBtn",
                                    width:144,
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Get"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.GetHtmlText();
                                    }
                                }
                            ]
                        },
                        {
                            view: "textarea",
                            id:this.Id + "HostText",
                            name: "HostText",
                            labelAlign:"left",
                            height:150,
                            labelWidth:104,
                            label: LangHelper.GetString("Classifier", "Host text")
                        },
                        {
                            view: "combo",
                            name: "cat_id",
                            labelWidth:104,
                            label: LangHelper.GetString("Classifier", "Host category"),
                            tooltip:LangHelper.GetString("Classifier","Host category"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options:[],
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            view: "combo",
                            name: "usedModel",
                            labelWidth:104,
                            label: LangHelper.GetString("Classifier", "Model"),
                            tooltip:LangHelper.GetString("Classifier","Model"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options:[],
                            disabled:true,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {
                                    view:"button",
                                    id:this.Id + "MlCheckBtn",
                                    label:LangHelper.GetString("Classifier","Check"),
                                    click:function ()
                                    {
                                        _this.Check();
                                    }
                                },
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.HostsMachineLearningEditContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "MlSaveBtn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.SaveHostsMachineLearningEditForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.HostsMachineLearningCheckContext = webix.ui({
        view:"popup",
        width:520,
        height:200,
        body:{
            id:this.Id + "HostsMachineLearningCheckContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    view: "text",
                    id:this.Id + "Category",
                    name: "category",
                    labelWidth:200,
                    label: LangHelper.GetString("Classifier","Likely category"),
                    tooltip:LangHelper.GetString("Classifier","Likely category"),
                    required:true,
                    disabled:true,
                    validate: webix.rules.isNotEmpty,
                    invalidMessage: LangHelper.GetString("Classifier", "Required field")
                },
                {
                    view: "text",
                    id:this.Id + "Percent",
                    name: "percent",
                    labelWidth:200,
                    label: LangHelper.GetString("Classifier","Recognition correctness"),
                    tooltip:LangHelper.GetString("Classifier","Recognition correctness"),
                    required:true,
                    disabled:true,
                    validate: webix.rules.isNotEmpty,
                    invalidMessage: LangHelper.GetString("Classifier", "Required field")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Ok"),
                            click:function ()
                            {
                                _this.HostsMachineLearningCheckContext.hide();
                            }
                        },
                        {}
                    ]
                }
            ]
        }
    });

    this.HostsRecheckContext = webix.ui({
        view:"popup",
        width:380,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to recheck the selected hosts?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.HostsRecheckContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "HostsRecheckContext" + "RecheckBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Recheck"),
                            click:function ()
                            {
                                _this.HostsRecheckContext.hide();

                                _this.RecheckHosts();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CategoryRecheckContext = webix.ui({
        view:"popup",
        width:380,
        height:180,
        body:{
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to recheck the selected hosts in categories?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.CategoryRecheckContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "CategoryRecheckContext" + "RecheckBtn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Recheck"),
                            click:function ()
                            {
                                _this.CategoryRecheckContext.hide();

                                _this.RunRecheckCategoryForm();
                            }
                        }
                    ]
                }
            ]
        }
    });

    this.CutModels = [];

    this.Views = {
        AddCategoryBtn:null,
        CategoriesEditContext:null,
        CategoriesEditContextForm:null,
        CategoriesTrashContext:null,
        CategoriesTrashContextForm:null,

        AddHostBtn:null,
        HostImportBtn:null,
        HostSetCategoryBtn:null,
        HostsEditContext:null,
        HostsEditContextForm:null,
        HostsSetCategoryContext:null,
        HostsSetCategoryContextForm:null,
        HostsTrashContext:null,
        HostsTrashContextForm:null,
        HostsDelSelectContext:null,
        HostsDelSelectContextForm:null,
        HostsImportContextTable:null,
        HostsImportContextUploader:null,
        HostsMachineLearningEditContext:null,
        HostsMachineLearningEditContextForm:null,
        HostsMachineLearningCheckContext:null,
        HostsMachineLearningCheckContextForm:null,
        HostsRecheckContext:null,
        HostsRecheckContextForm:null,
        CategoryRecheckContext:null,
        CategoryRecheckContextForm:null,
        HostsToolbar:null,
        HostsDelBtn:null,
        HostsRecheckBtn:null,
        RecheckCategoryBtn:null,

        Widgets:{},
        ReportsWidgets:{
            CategoriesReport: ClassifierCategoriesTableWidget({
                id:this.Id + "CategoriesReport",
                onItemClick:function (Id,e,node)
                {
                    var table = _this.Views.ReportsWidgets.CategoriesReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'edit':
                            _this.ShowCategoriesEditForm(rowData, table.getItemNode(Id), "top");
                            break;
                        case 'trash':
                            _this.ShowCategoriesTrashForm(rowData, table.getItemNode(Id), "bottom");
                            break;
                    }
                }
            }),
            HostsReport: ClassifierHostsTableWidget({
                id:this.Id + "HostsReport",
                onItemClick:function (Id, E, Node)
                {
                    var table = _this.Views.ReportsWidgets.HostsReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'edit':
                            _this.ShowHostsEditForm(rowData, table.getItemNode(Id), "right");
                            break;
                        case 'trash':
                            _this.ShowHostsTrashForm(rowData, table.getItemNode(Id), "bottom");
                            break;
                    }
                },
                onAfterFilterCustomHandler: function ()
                {
                    _this.RefreshHosts();
                }

            })
        }
    };

    this.ViewConfig = [
        {
            cols:[
                ClassifierLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                PageHeaderTemplate({root_title:LangHelper.GetString("AppView", "Classifier"),title:LangHelper.GetString("Classifier", "Hosts Categories")}),
                                {
                                    cols:[
                                        {
                                            rows:[
                                                {
                                                    view: "toolbar",
                                                    height:webix.skin.$active.rowHeight,
                                                    padding: 0,
                                                    margin: 0,
                                                    elements: [
                                                        {
                                                            view: "button",
                                                            id:this.Id + "AddCategoryBtn",
                                                            type: "icon",
                                                            icon: "plus",
                                                            align: "right",
                                                            width: 32,
                                                            css:"toolbar_round_btn",
                                                            tooltip:LangHelper.GetString("Protocols","Add list item"),
                                                            click: function (id, e, node)
                                                            {
                                                                _this.AddCategoryToCategoriesTable();
                                                            }
                                                        },
                                                        {
                                                            view: "button",
                                                            id:this.Id + "RecheckCategoryBtn",
                                                            type: "icon",
                                                            icon: "check-double",
                                                            align: "right",
                                                            width: 32,
                                                            css:"toolbar_round_btn",
                                                            tooltip:LangHelper.GetString("Classifier","Recheck category"),
                                                            click: function (id, e, node)
                                                            {
                                                                var __this = this;
                                                                var node = __this.getNode(id);

                                                                _this.CategoryRecheckContext.show(node, {pos:"bottom"});
                                                            }
                                                        },
                                                        {},
                                                        {
                                                            view: "button",
                                                            id:this.Id+"ListItemsRefreshBtn",
                                                            type: "icon",
                                                            icon: "refresh",
                                                            css: "toolbar_round_btn",
                                                            width: 32,
                                                            tooltip: LangHelper.GetString("All","Refresh"),
                                                            click: function (id, e, node)
                                                            {
                                                                _this.RefreshCategories();
                                                            }
                                                        }
                                                    ]
                                                },
                                                BlockHeaderTemplate({
                                                    title:LangHelper.GetString("Classifier","Categories"), icon:"files-o"
                                                }),
                                                this.Views.ReportsWidgets.CategoriesReport.ViewConfig
                                            ]
                                        },
                                        { view:"resizer" },
                                        {
                                            gravity:3,
                                            rows:[
                                                {
                                                    view: "toolbar",
                                                    id:this.Id + "HostsToolbar",
                                                    height:webix.skin.$active.rowHeight,
                                                    padding: 0,
                                                    margin: 0,
                                                    elements: [
                                                        {
                                                            view: "button",
                                                            id:this.Id + "AddHostBtn",
                                                            type: "icon",
                                                            icon: "plus",
                                                            align: "right",
                                                            width: 32,
                                                            css:"toolbar_round_btn",
                                                            tooltip:LangHelper.GetString("Protocols","Add list item"),
                                                            click: function (id, e, node)
                                                            {
                                                                _this.AddHostToHostsTable();
                                                            }
                                                        },
                                                        {
                                                            width:24
                                                        },
                                                        {
                                                            view: "button",
                                                            id:this.Id + "HostSetCategoryBtn",
                                                            type: "icon",
                                                            icon: "list-alt",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            tooltip:LangHelper.GetString("Classifier","Set category for hosts"),
                                                            click:function (id,e,node)
                                                            {
                                                                _this.SetCategoryForHostToHostsTable();
                                                            }
                                                        },
                                                        {
                                                            view: "button",
                                                            id:this.Id + "HostsRecheckBtn",
                                                            type: "icon",
                                                            icon: "check",
                                                            align: "right",
                                                            width: 32,
                                                            css:"toolbar_round_btn",
                                                            tooltip:LangHelper.GetString("Classifier","Recheck hosts"),
                                                            click: function (id, e, node)
                                                            {
                                                                var __this = this;
                                                                var node = __this.getNode(id);

                                                                _this.HostsRecheckContext.show(node, {pos: "bottom"});
                                                            }
                                                        },
                                                        {
                                                            width: 24
                                                        },
                                                        {
                                                            view: "button",
                                                            id:this.Id+"HostsDelBtn",
                                                            type: "icon",
                                                            icon: "trash",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            tooltip:LangHelper.GetString("Classifier", "Delete"),
                                                            click:function (id,e,node)
                                                            {
                                                                var __this = this;
                                                                var node = __this.getNode(id);
                                                                _this.HostsDelSelectContext.show(node, {pos: "bottom"});
                                                            }
                                                        },
                                                        {
                                                            view: "button",
                                                            id:this.Id+"HostsEraseBtn",
                                                            type: "icon",
                                                            icon: "eraser",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            tooltip:LangHelper.GetString("Classifier", "Remove all"),
                                                            click:function (id,e,node)
                                                            {
                                                                var __this = this;
                                                                setTimeout(function () {
                                                                    var node = __this.getNode(id);
                                                                    _this.HostsEraseContext.show(node, {pos:"bottom"});
                                                                }, 10);
                                                            }
                                                        },
                                                        {
                                                            width:24
                                                        },
                                                        {
                                                            view: "button",
                                                            id:this.Id + "HostImportBtn",
                                                            type: "icon",
                                                            icon: "upload",
                                                            css:"toolbar_round_btn",
                                                            width:32,
                                                            tooltip:LangHelper.GetString("Classifier","Import from file"),
                                                            click:function (id,e,node)
                                                            {
                                                                var __this = this;
                                                                setTimeout(function () {
                                                                    var node = __this.getNode(id);
                                                                    _this.HostsImportContext.show(node, {pos: "bottom"});
                                                                    //_this.Views.HostsImportContextTable.clearAll();
                                                                }, 10);
                                                            }
                                                        },
                                                        {},
                                                        {
                                                            view: "button",
                                                            id:this.Id+"HostRefreshBtn",
                                                            type: "icon",
                                                            icon: "refresh",
                                                            css: "toolbar_round_btn",
                                                            width: 32,
                                                            tooltip: LangHelper.GetString("All","Refresh"),
                                                            click: function (id, e, node)
                                                            {
                                                                _this.RefreshHosts();
                                                            }
                                                        }
                                                    ]
                                                },
                                                BlockHeaderTemplate({
                                                    title:LangHelper.GetString("Classifier","Hosts"), icon:"globe"
                                                }),
                                                this.Views.ReportsWidgets.HostsReport.ViewConfig
                                            ]
                                        },
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Subscriptions = {};

    this.HostsTableRowsSelectedCount = new Rx.BehaviorSubject(0);
}

ClassifierViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });



    App.DicsManager.Refresh({data:[DicsEnum.ClsfrCategoriesDic]});



    this.Views.CategoriesEditContext = webix.ui(this.CategoriesEditContext);

    this.Views.CategoriesEditContextForm = $$(this.Id+"CategoriesEditContextForm");

    this.Views.CategoriesTrashContext = webix.ui(this.CategoriesTrashContext);

    this.Views.CategoriesTrashContextForm = $$(this.Id+"CategoriesTrashContextForm");

    this.Views.HostsEditContext = webix.ui(this.HostsEditContext);

    this.Views.HostsEditContextForm = $$(this.Id+"HostsEditContextForm");

    this.Views.HostsSetCategoryContext = webix.ui(this.HostsSetCategoryContext);

    this.Views.HostsSetCategoryContextForm = $$(this.Id+"HostsSetCategoryContextForm");

    this.Views.HostsTrashContext = webix.ui(this.HostsTrashContext);

    this.Views.HostsTrashContextForm = $$(this.Id+"HostsTrashContextForm");

    this.Views.HostsImportContextTable = $$(this.Id+"HostsImportContextTable");

    this.Views.HostsImportContextUploader = $$(this.Id + "HostsImportContextUploader");

    this.Views.HostsMachineLearningEditContext = webix.ui(this.HostsMachineLearningEditContext);

    this.Views.HostsMachineLearningEditContextForm = $$(this.Id+"HostsMachineLearningEditContextForm");

    this.Views.HostsMachineLearningCheckContext = webix.ui(this.HostsMachineLearningCheckContext);

    this.Views.HostsMachineLearningCheckContextForm = $$(this.Id+"HostsMachineLearningCheckContextForm");



    this.Views.MlGetBtn = $$(this.Id+"MlGetBtn");

    this.Views.MlSaveBtn = $$(this.Id+"MlSaveBtn");

    this.Views.MlCheckBtn = $$(this.Id+"MlCheckBtn");



    this.Views.HostsImportContextUploader.attachEvent("onAfterFileAdd", function(FileObj)
    {
        _this.ImportExcelToHostsImportContextTable(FileObj.file);
    });



    this.Subscriptions.CategoriesTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.CategoriesReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        var tableHosts = _this.Views.ReportsWidgets.HostsReport.Views.Table;
        var categoriesRecheckBtn = _this.Views.RecheckCategoryBtn
        var toolbar = _this.Views.HostsToolbar;
        var hostsImportBtn = _this.Views.HostImportBtn;

        if (Value>0){
            if (Value == 1)
            {
                hostsImportBtn.enable();
            }else {
                hostsImportBtn.disable();
            }
            _this.RefreshHosts();
            categoriesRecheckBtn.enable();
            toolbar.enable();
            tableHosts.enable();
        }else {
            toolbar.disable();
            tableHosts.disable();
            categoriesRecheckBtn.disable();
            setTimeout(function () {
                if (!_this.Views.ReportsWidgets.CategoriesReport.TableRowsSelectedCount.getValue())
                    tableHosts.clearAll();
            }, 300)
        }
    });

    this.Subscriptions.HostsTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.HostsReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        var hostsDelBtn = _this.Views.HostsDelBtn;
        var hostsRecheckBtn = _this.Views.HostsRecheckBtn
        var hostsSetCategoryBtn = _this.Views.HostSetCategoryBtn;

        if (Value>0){
            hostsDelBtn.enable();
            hostsRecheckBtn.enable();
            Value>1?hostsSetCategoryBtn.enable():hostsSetCategoryBtn.disable();
        }else {
            hostsDelBtn.disable();
            hostsRecheckBtn.disable();
            hostsSetCategoryBtn.disable();
        }
    });



    //GetConfig
    this.ModelsViewModel.GetConfig();

    this.Subscriptions.ClassifierGetConfig = this.ModelsViewModel.Signals.ClassifierGetConfig.subscribe(function (Model) {
        if (Model)
        {
            if (module == 'dpiui2')
                _this.CutModels = Model;
        }
    });
    this.Subscriptions.ClassifierGetConfigError = this.ModelsViewModel.Signals.ClassifierGetConfigError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });



    this.Subscriptions.SignalClsfrCategoriesDic = App.DicsManager.Signal[DicsEnum.ClsfrCategoriesDic].subscribe(function (Value)
    {
        if(Value)
        {
            var lang = LangHelper.GetLocale();

            var arrDic = App.DicsManager.GetDicAsArray(DicsEnum.ClsfrCategoriesDic);

            arrDic.forEach(function (obj){
                var name = obj.value;
                if (typeof name === "string"){
                    obj.value = name;
                }else{
                    obj.value = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
                }
            });

            arrDic.sort((a, b) => (a.value > b.value) ? 1 : -1)

            var list = _this.Views.HostsEditContextForm.elements.cat_id.getList();

            list.clearAll();

            list.parse(arrDic);

            var ml = _this.Views.HostsMachineLearningEditContextForm.elements.cat_id.getList();

            ml.clearAll();

            ml.parse(arrDic);



            var setList = _this.Views.HostsSetCategoryContextForm.elements.cat_id.getList();

            setList.clearAll();

            setList.parse(arrDic);
        }
    });



    this.Subscriptions.ClassifierModelModelsGet = this.ModelsViewModel.Signals.ClassifierModelModelsGet.subscribe(function (Model) {
        if (Model)
        {
            var models = [];

            var modelDefault = 'Default';

            Model.rows.forEach(function (value){
                if (!_this.CutModels.includes(value.name))
                {
                    models.push(value.name);
                    if (value.default)
                        modelDefault = value.name
                }
            });

            if (modelDefault == 'Default')
            {
                if (models[0])
                    modelDefault = models[0];
                else
                    models[0] = modelDefault;
            }

            var usedModel = _this.Views.HostsMachineLearningEditContextForm.elements.usedModel;
            var form = usedModel.getList();

            form.clearAll();
            form.parse(models);

            usedModel.setValue(modelDefault);

            usedModel.enable();
        }
    });

    this.Subscriptions.ClassifierModelModelsGetError = this.ModelsViewModel.Signals.ClassifierModelModelsGetError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });



    this.Subscriptions.ClassifierSaved = this.ViewModel.Signals.ClassifierSaved.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Category added successfully"));
            var table = _this.Views.ReportsWidgets.CategoriesReport.Views.Table;

            var row = table.find(function(Obj)
            {
                return Obj._id == Model._id;
            });
            if (row && Array.isArray(row) && row.length == 1)
            {
                table.updateItem(row[0].id, Model);
            }else if (row.length == 0)
            {
                var id = table.add(Model, 0);
                table.select(id);
                table.getState();
            }

            table.hideProgress();
            table.hideOverlay();

            App.DicsManager.Refresh({data:[DicsEnum.ClsfrCategoriesDic]});

            _this.Views.CategoriesEditContext.hide();
        }
    });

    this.Subscriptions.ClassifierSaveError = this.ViewModel.Signals.ClassifierSaveError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierDeleted = this.ViewModel.Signals.ClassifierDeleted.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Category deleted successfully"));
            var table = _this.Views.ReportsWidgets.CategoriesReport.Views.Table;
            table.remove([table.getSelectedId()]);
            App.DicsManager.Refresh({data:[DicsEnum.ClsfrCategoriesDic]});
        }
    });

    this.Subscriptions.ClassifierDeleteError = this.ViewModel.Signals.ClassifierDeleteError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });



    this.Subscriptions.ClassifierHostsSaved = this.HostsViewModel.Signals.ClassifierHostsSaved.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Host added successfully"));
            var table = _this.Views.ReportsWidgets.HostsReport.Views.Table;

            var row = table.find(function(Obj)
            {
                return Obj._id == Model._id;
            });
            if (row && Array.isArray(row) && row.length == 1)
            {
                table.updateItem(row[0].id, Model);
            }else if (row.length == 0)
            {
                var id = table.add(Model, 0);
                table.select(id);
                table.getState();
            }

            table.hideProgress();
            table.hideOverlay();

            _this.Views.HostsEditContext.hide();
        }
    });

    this.Subscriptions.ClassifierHostsSaveError = this.HostsViewModel.Signals.ClassifierHostsSaveError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierHostsMachineLearningSaved = this.HostsViewModel.Signals.ClassifierHostsMachineLearningSaved.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Host added successfully"));
            var table = _this.Views.ReportsWidgets.HostsReport.Views.Table;

            var row = table.find(function(Obj)
            {
                return Obj._id == Model._id;
            });
            if (row && Array.isArray(row) && row.length == 1)
            {
                table.updateItem(row[0].id, Model);
            }else if (row.length == 0)
            {
                var id = table.add(Model, 0);
                table.select(id);
                table.getState();
            }

            table.hideProgress();
            table.hideOverlay();

            _this.Views.HostsMachineLearningEditContext.hide();
        }
    });

    this.Subscriptions.ClassifierHostsMachineLearningSaveError = this.HostsViewModel.Signals.ClassifierHostsMachineLearningSaveError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierHostsCheck = this.HostsViewModel.Signals.ClassifierHostsCheck.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Percentage received successfully"));

            var node = _this.Views.HostsMachineLearningEditContextForm.getNode();

            _this.Views.HostsMachineLearningCheckContext.show(node, {pos:"top"});

            var form = _this.Views.HostsMachineLearningCheckContextForm;

            function name(obj){
                var lang = LangHelper.GetLocale();
                if (obj && obj.name_json)
                {
                    var name = JSON.parse(obj.name_json);
                    var local = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
                }else{
                    var local = obj.name;
                }
                return local;
            }

            form.setValues({category:name(Model)+' ('+Model.code+')', percent:parseFloat(Model.percent).toFixed(2)*100 + '%'});

            _this.DisableProgressForButton(_this.Views.MlCheckBtn);
            _this.Views.MlCheckBtn.enable();
        }
    });

    this.Subscriptions.ClassifierHostsCheckError = this.HostsViewModel.Signals.ClassifierHostsCheckError.subscribe(function (Model) {
        if (Model)
        {
            _this.DisableProgressForButton(_this.Views.MlCheckBtn);
            _this.Views.MlCheckBtn.enable();
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierHostsDeleted = this.HostsViewModel.Signals.ClassifierHostsDeleted.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Host deleted successfully"));
            var table = _this.Views.ReportsWidgets.HostsReport.Views.Table;
            table.remove([table.getSelectedId()]);
        }
    });

    this.Subscriptions.ClassifierHostsDeleteError = this.HostsViewModel.Signals.ClassifierHostsDeleteError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierHostsErased = this.HostsViewModel.Signals.ClassifierHostsErased.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Categories deleted successfully"));
            var table = _this.Views.ReportsWidgets.HostsReport.Views.Table;
            table.clearAll();
        }
    });

    this.Subscriptions.ClassifierHostsEraseError = this.HostsViewModel.Signals.ClassifierHostsEraseError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });



    this.Subscriptions.ClassifierHostsGetHtmlText = this.HostsViewModel.Signals.ClassifierHostsGetHtmlText.subscribe(function (Model) {
        if (Model)
        {
            var form = _this.Views.HostsMachineLearningEditContextForm;
            form.elements.HostText.setValue(Model);
            webix.message(LangHelper.GetString("Classifier", "Received host text successfully"));
            _this.DisableProgressForButton(_this.Views.MlGetBtn);
            _this.Views.MlGetBtn.enable();
            _this.Views.MlSaveBtn.enable();
            _this.Views.MlCheckBtn.enable();
        }
    });

    this.Subscriptions.ClassifierHostsGetHtmlTextError = this.HostsViewModel.Signals.ClassifierHostsGetHtmlTextError.subscribe(function (Model) {
        if (Model)
        {
            _this.DisableProgressForButton(_this.Views.MlGetBtn);
            _this.Views.MlGetBtn.enable();
            _this.Views.MlSaveBtn.enable();
            _this.Views.MlCheckBtn.enable();
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierHostsGetHtmlTextFile = this.HostsViewModel.Signals.ClassifierHostsGetHtmlTextFile.subscribe(function (Model) {
        if (Model)
        {
            var form = _this.Views.HostsMachineLearningEditContextForm;
            form.elements.HostText.setValue(Model);
            _this.DisableProgressForButton(_this.Views.MlGetBtn);
            _this.Views.MlGetBtn.enable();
            _this.Views.MlSaveBtn.enable();
            _this.Views.MlCheckBtn.enable();
        }
    });

    this.Subscriptions.ClassifierHostsGetHtmlTextFileError = this.HostsViewModel.Signals.ClassifierHostsGetHtmlTextFileError.subscribe(function (Model) {
        if (Model)
        {
            _this.DisableProgressForButton(_this.Views.MlGetBtn);
            _this.Views.MlGetBtn.enable();
            _this.Views.MlSaveBtn.enable();
            _this.Views.MlCheckBtn.enable();
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierHostsRecheck = this.HostsViewModel.Signals.ClassifierHostsRecheck.subscribe(function (Model) {
        if(Model) {
            webix.message(LangHelper.GetString("Classifier", "Hosts recheck successful"));

            _this.RefreshHosts();
        }
    });

    this.Subscriptions.ClassifierHostsRecheck = this.HostsViewModel.Signals.ClassifierHostsRecheckError.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier","Hosts recheck failed"));
        }
    });

    this.Subscriptions.ClassifierRecheckCategory = this.ViewModel.Signals.ClassifierRecheckCategory.subscribe(function (Model) {
        if(Model) {
            webix.message(LangHelper.GetString("Classifier", "Category recheck successful"));

            _this.RefreshHosts();
        }
    });

    this.Subscriptions.ClassifierRecheckCategoryError = this.ViewModel.Signals.ClassifierRecheckCategoryError.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier","Category recheck failed"));
        }
    });

    var categoriesReportTable = _this.Views.ReportsWidgets.CategoriesReport.Views.Table;

    categoriesReportTable.attachEvent("onItemClick",function(id, e, node)
    {
        var cb = this.getHeaderContent("mc");
        if (cb.isChecked())
        {
            cb.uncheck();
            this.select(id, true);
        }
    });

    categoriesReportTable.attachEvent("onHeaderClick",function(id, e, target)
    {
        if(id.column == "checked")
        {
            var cb = this.getHeaderContent("mc");
            if(cb.isChecked())
            {
                this.selectAll();
            }
            else
            {
                this.unselectAll();
            }

            return false;
        }
    });

    categoriesReportTable.attachEvent("onCheck", function(Row, Column, State)
    {
        if(Column == "checked")
        {
            if(State)
                this.select(Row, true);
            else
                this.unselect(Row, true);

        }
    });

    categoriesReportTable.attachEvent("onAfterSelect",function(Data, Preserve)
    {
        var item = this.getItem(Data.id);
        if(item)
        {
            if(!item.checked)
            {
                item.checked = 1;
            }
            this.updateItem(Data.id, item);
        }
    });

    categoriesReportTable.attachEvent("onAfterUnSelect",function(Data)
    {
        var id = Data.row;
        var item = this.getItem(id);
        if(item && item.checked)
        {
            if(item.checked)
            {
                item.checked = 0;
            }
            this.updateItem(id, item);
        }
    });



    var hostsReportTable = _this.Views.ReportsWidgets.HostsReport.Views.Table;

    hostsReportTable.attachEvent("onHeaderClick",function(id, e, target)
    {
        if(id.column == "checked")
        {
            var cb = this.getHeaderContent("mc");
            if(cb.isChecked())
            {
                this.selectAll();
            }
            else
            {
                this.unselectAll();
            }

            return false;
        }
    });

    hostsReportTable.attachEvent("onCheck", function(Row, Column, State)
    {
        if(Column == "checked")
        {
            if(State)
                this.select(Row, true);
            else
                this.unselect(Row, true);

        }
    });

    hostsReportTable.attachEvent("onAfterSelect",function(Data, Preserve)
    {
        var item = this.getItem(Data.id);
        if(item)
        {
            if(!item.checked)
            {
                item.checked = 1;
            }
            this.updateItem(Data.id, item);
        }
    });

    hostsReportTable.attachEvent("onAfterUnSelect",function(Data)
    {
        var item = this.getItem(Data.id);
        if(item && item.checked)
        {
            if(item.checked)
            {
                item.checked = 0;
            }
            this.updateItem(Data.id, item);
        }
    });
};

ClassifierViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

    this.Refresh();
};

ClassifierViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

ClassifierViewController.prototype.Refresh = function ()
{
    this.RefreshCategories();
    //this.RefreshHosts();
};

ClassifierViewController.prototype.RefreshCategories = function ()
{
    this.Views.ReportsWidgets.CategoriesReport.RefreshData();
};

ClassifierViewController.prototype.RefreshHosts = function ()
{
    var _this = this;

    clearTimeout(this.HostsRefreshTimeOut);

    this.HostsRefreshTimeOut = setTimeout(function ()
    {
        _this._RefreshHosts();
    }, 100);
};

ClassifierViewController.prototype._RefreshHosts = function ()
{
    var tableCategories = this.Views.ReportsWidgets.CategoriesReport.Views.Table;

    var getCategories = tableCategories.getSelectedItem(true);

    var categoriesIds = [];

    getCategories.forEach(function (category)
    {
        categoriesIds.push(parseInt(category._id));
    });

    //let tempFilter = Helper.Table.GetDateFiltersWithRefresh(this.Views.ReportsWidgets.HostsReport, ['recheck_date'], null, false);
    //let filter = {filter:{company_id:{id:"cat_id", operator:"in like", value:categoriesIds}, ...tempFilter}}
    let filter = {filter:{company_id:{id:"cat_id", operator:"in like", value:categoriesIds}}};

    this.Views.ReportsWidgets.HostsReport.RefreshData(0, filter);
};

ClassifierViewController.prototype.Select = function ()
{
    //
};

ClassifierViewController.prototype.GetClassifierTableSelectedData = function ()
{
    return this.Views.ReportsWidgets.CategoriesReport.getSelectedItem();
};

ClassifierViewController.prototype.OnClassifierTableRowUnSelect = function ()
{
    var data = this.GetClassifierTableSelectedData();
    this.ViewModel.Signals.ClassifierTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};

ClassifierViewController.prototype.ClassifierTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    if(Value == 1)
    {
        this.Views.CopyQoETriggerToQoETriggersTableBtn.enable();
    }
    else{
        this.Views.CopyQoETriggerToQoETriggersTableBtn.disable();
        if(Value > 1)
        {
            var selected = this.GetClassifierTableSelectedData();
            if(selected && Array.isArray(selected))
            {
                for(var i in selected)
                {
                    if(selected[i].type == ClassifierTypeEnum.system)
                    {
                        this.Views.DeleteBtn.disable();
                        return;
                    }
                }
            }
            this.Views.DeleteBtn.enable();
        }
        else
        {
            this.Views.DeleteBtn.disable();
        }
    }
};



ClassifierViewController.prototype.GetCategoriesTableSelectedData = function ()
{
    return this.Views.ReportsWidgets.CategoriesReport.Views.Table.getSelectedItem();
};

ClassifierViewController.prototype.AddCategoryToCategoriesTable = function ()
{
    var _this = this;

    var model = new ClassifierCategoriesFormModel();

    _this.ShowCategoriesEditForm(model, this.Views.AddCategoryBtn.getNode(), "right");
};

ClassifierViewController.prototype.CategoriesTrashContext = function (Data, Node, Pos)
{
    var _this = this;
    if(Data)
    {
        var formParams = new ClassifierCategoriesFormModel(Data);

        this.Views.CategoriesTrashContextForm.setValues(formParams);
    }

    this.Views.CategoriesTrashContext.show(Node,{pos:Pos});
};

ClassifierViewController.prototype.ShowCategoriesTrashForm = function (Data, Node, Pos)
{
    var _this = this;

    this.Views.CategoriesTrashContext.show(Node,{pos:Pos});
};

ClassifierViewController.prototype.ShowCategoriesEditForm = function (Data, Node, Pos)
{
    var _this = this;

    if(Data)
    {
        var formParams = new ClassifierCategoriesFormModel(Data);

        if (Data._id != 0)
            if (formParams && formParams["name_json"])
            {
                formParams["name"] = JSON.parse(formParams["name_json"]);
            }else{
                formParams["name"] = {en:formParams["name"]};
            }
        else
            formParams["name"] = {en: ""};

        this.Views.CategoriesEditContextForm.clearValidation();

        this.Views.CategoriesEditContextForm.setValues(formParams);
    }

    this.Views.CategoriesEditContext.show(Node,{pos:Pos});
};

ClassifierViewController.prototype.SaveCategoriesEditForm = function (Model)
{
    var _this = this;

    var form = this.Views.CategoriesEditContextForm;

    if(!form.validate())
    {
        return ;
    }

    var formData = form.getValues();

    this.ViewModel.Save(webix.extend(formData, true));
};

ClassifierViewController.prototype.DeleteCategoriesEditForm = function (Model)
{
    var _this = this;

    var table = _this.Views.ReportsWidgets.CategoriesReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    this.ViewModel.Delete(webix.extend(data, true));
};



ClassifierViewController.prototype.RunRecheckCategoryForm = function ()
{
    let table = this.Views.ReportsWidgets.CategoriesReport.Views.Table;

    let rowsIds = [];

    let selectedItem = table.getSelectedItem();

    if (!Array.isArray(selectedItem))
        selectedItem = selectedItem?[selectedItem]:[];

    selectedItem.map(function (item) {
        rowsIds.push(item._id);
    });

    this.ViewModel.RecheckCategory(rowsIds.join(","))
};



ClassifierViewController.prototype.AddHostToHostsTable = function ()
{
    var _this = this;

    var model = new ClassifierHostsFormModel();

    _this.ShowHostsEditForm(model, this.Views.AddHostBtn.getNode(), "right");
};

ClassifierViewController.prototype.SetCategoryForHostToHostsTable = function ()
{
    var _this = this;

    var model = new ClassifierHostsFormModel();

    _this.ShowHostsSetCategoryForm(model, this.Views.HostSetCategoryBtn.getNode(), "bottom");
};

ClassifierViewController.prototype.HostsTrashContext = function (Data, Node, Pos)
{
    var _this = this;
    if(Data)
    {
        var formParams = new ClassifierHostsFormModel(Data);

        this.Views.HostsEditContextForm.setValues(formParams);

        this.Views.HostsTrashContextForm.setValues(formParams);
    }

    this.Views.HostsTrashContext.show(Node,{pos:Pos});
};

ClassifierViewController.prototype.ShowHostsTrashForm = function (Data, Node, Pos)
{
    var _this = this;

    this.Views.HostsTrashContext.show(Node,{pos:Pos});
};

ClassifierViewController.prototype.ShowHostsMachineLearningEditForm = function (Data, Node, Pos)
{
    var _this = this;

    var form = this.Views.HostsMachineLearningEditContextForm;
    form.setValues("");
    form.clearValidation();
    form.elements.usedModel.disable();

    if(Data)
    {
        var formParams = new ClassifierHostsFormModel(Data);

        if(formParams._id == 0){
            var table = _this.Views.ReportsWidgets.CategoriesReport.Views.Table;

            var cat_id = table.getSelectedItem()._id;

            formParams.cat_id = cat_id;
        }

        if (formParams.host.length > 0){
            this.HostsViewModel.GetHtmlTextFile(webix.extend(formParams, true));
        }

        form.setValues(formParams);
    }

    this.GetModels();

    this.Views.HostsMachineLearningEditContext.show(Node,{pos:Pos});
};

ClassifierViewController.prototype.GetModels = function ()
{
    return this.ModelsViewModel.ModelsGet();
}

ClassifierViewController.prototype.ShowHostsEditForm = function (Data, Node, Pos)
{
    var _this = this;
    if(Data)
    {
        var formParams = new ClassifierHostsFormModel(Data);

        if(formParams._id == 0){
            var table = _this.Views.ReportsWidgets.CategoriesReport.Views.Table;

            var cat_id = table.getSelectedItem()._id;

            formParams.cat_id = cat_id;
        }

        this.Views.HostsEditContextForm.clearValidation();

        this.Views.HostsEditContextForm.setValues(formParams);
    }

    this.Views.HostsEditContext.show(Node,{pos:Pos});
};

ClassifierViewController.prototype.ShowHostsSetCategoryForm = function (Data, Node, Pos)
{
    this.Views.HostsSetCategoryContext.show(Node,{pos:Pos});
};

ClassifierViewController.prototype.SaveHostsEditForm = function (Model)
{
    var _this = this;

    var categoriesTable = _this.Views.ReportsWidgets.CategoriesReport.Views.Table;

    var form = this.Views.HostsEditContextForm;

    if(!form.validate())
    {
        return;
    }

    var formData = form.getValues();

    this.HostsViewModel.Save(webix.extend(formData, true));
};

ClassifierViewController.prototype.SaveHostsSetCategoryForm = function (Model)
{
    var _this = this;

    var hostsTable = _this.Views.ReportsWidgets.HostsReport.Views.Table;

    var hostsItems = hostsTable.getSelectedItem();

    var hostsIDs = [];

    if (hostsItems.length > 1) {
        hostsItems.forEach(function (item) {
            hostsIDs.push(item._id);
        });
    }else{
        hostsIDs = [hostsItems._id];
    }

    var form = this.Views.HostsSetCategoryContextForm;

    if(!form.validate())
    {
        return;
    }

    var formData = form.getValues();

    formData['IDs'] = hostsIDs;

    this.HostsViewModel.SetCategoryHost(webix.extend(formData, true));
};

ClassifierViewController.prototype.DeleteHostsEditForm = function (Model)
{
    var _this = this;

    var table = _this.Views.ReportsWidgets.HostsReport.Views.Table;

    var data = table.getSelectedItem();

    if(!data)
        return;

    this.HostsViewModel.Delete(webix.extend(data, true));
};

ClassifierViewController.prototype.EraseHostsEditForm = function (Model)
{
    var _this = this;

    var table = _this.Views.ReportsWidgets.CategoriesReport.Views.Table;

    var data = table.getSelectedItem();

    var cat_ids = [];

    if (data && Array.isArray(data) && data.length)
    {
        data.forEach(function (Item) {
            cat_ids.push(Item._id);
        });
    }
    else if (data && data._id)
    {
        cat_ids.push(data._id);
    }

    if(!data)
        return;

    this.HostsViewModel.Erase(webix.extend({cat_id: cat_ids}, true));
};

ClassifierViewController.prototype.HostsDelSelectEditForm = function (Model)
{
    var _this = this;

    var tableHosts = _this.Views.ReportsWidgets.HostsReport.Views.Table;

    var dataHosts = tableHosts.getSelectedItem();

    var hosts_ids = [];

    if (dataHosts && Array.isArray(dataHosts) && dataHosts.length)
    {
        dataHosts.forEach(function (Item) {
            hosts_ids.push(Item._id);
        });
    }
    else if (dataHosts && dataHosts._id)
    {
        hosts_ids.push(dataHosts._id);
    }

    if(!dataHosts)
        return;

    this.HostsViewModel.DeleteSelect(webix.extend(hosts_ids, true));
};

ClassifierViewController.prototype.GetHostsImportTemplate = function()
{
    webix.toExcel(this.Views.HostsImportContextTable, {
        filename: LangHelper.GetString(this.Id,"Classifier"),
        name: LangHelper.GetString(this.Id,"Classifier"),
        filterHTML:true,
        columns:{
            host:true,
        }
    });
};

ClassifierViewController.prototype.ImportExcelToHostsImportContextTable = function(ExcelFile)
{
    var _this = this;

    var table = this.Views.HostsImportContextTable;

    var ev = table.attachEvent("onAfterLoad",function()
    {
        table.detachEvent(ev);

        var data = table.serialize();

        var dataPrepared = [];

        data.forEach(function (Row)
        {
            if(Row.host == LangHelper.GetString("Classifier","Host"))
                return;

            if(Row.host == "")
                return;

            var row = {
                data0:Row.host
            };

            dataPrepared.push(row);
        });

        table.clearAll();
        table.parse(dataPrepared);

    });

    table.clearAll();
    table.parse(ExcelFile, "excel");

    setTimeout(function ()
    {
        if(table.hasEvent)
        {
            table.detachEvent(ev);
        }
    },3000);
};

ClassifierViewController.prototype.SaveImportedExceldata = function()
{
    var _this = this;

    var table = this.Views.HostsImportContextTable;

    var data = this.GetCategoriesTableSelectedData();

    var hostsItems = table.serialize();

    var hosts = [];

    data.valid = true;

    hostsItems.forEach(function (Item)
    {
        var item = new ClassifierHostsFormModel(Item);

        item.cat_id = data._id;

        hosts.push(item);
    });

    this.HostsViewModel.Import({list_items:hosts, callback:function (R)
        {
            if(R.success)
            {
                _this.RefreshHosts();

                webix.message(LangHelper.GetString("Classifier","Imported successfully"));
            }
            else
            {
                data.valid = false;

                //_this.Views.HostsReport.validate(data.id);

                if(R.error)
                    webix.message({text:R.error.msg,type:"error"});
            }

            _this.OnTasksTableRowSelect();
        }});

    table.clearAll();

    //this.Views.HostsReport.validate(data.id);
};

ClassifierViewController.prototype.OnTasksTableRowSelect = function ()
{
    var data = this.GetCategoriesTableSelectedData();

    this.HostsTableRowsSelectedCount.next(data?(Array.isArray(data)?data.length:1):0);
};


ClassifierViewController.prototype.ShowServerError = function (ErrorModel)
{
    webix.message({text:ErrorModel.msg, type:"error", expire: 30000});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrorModel.msg,
        type:"alert-error",
        width:400
    });
};


ClassifierViewController.prototype.GetHtmlText = function (Model)
{
    var form = this.Views.HostsMachineLearningEditContextForm;

    if(!form.validate())
    {
        return;
    }

    var formData = form.getValues();

    this.EnableProgressForButton(this.Views.MlGetBtn);

    this.Views.MlGetBtn.disable();
    this.Views.MlSaveBtn.disable();
    this.Views.MlCheckBtn.disable();

    this.HostsViewModel.GetHtmlText(webix.extend(formData, true));
};

ClassifierViewController.prototype.Check = function (Model)
{
    var _this = this;

    var form = this.Views.HostsMachineLearningEditContextForm;

    if(!form.validate())
    {
        return;
    }

    var formData = form.getValues();

    _this.EnableProgressForButton(_this.Views.MlCheckBtn);

    _this.Views.MlCheckBtn.disable();

    this.HostsViewModel.Check(webix.extend(formData, true));
};

ClassifierViewController.prototype.SaveHostsMachineLearningEditForm = function (Model)
{
    var form = this.Views.HostsMachineLearningEditContextForm;

    if(!form.validate())
    {
        return;
    }

    var formData = form.getValues();

    this.HostsViewModel.SetCategory(webix.extend(formData, true));
};



ClassifierViewController.prototype.EnableProgressForButton = function (Btn, Text)
{
    if(Btn.config.icon == "spinner-third")
        return;

    Btn.config.type_was = Btn.config.type ? Btn.config.type : "";
    Btn.define("icon","spinner-third");
    Btn.define("type","icon");
    Btn.define("css","btn_icon_spin");
    Btn.refresh();
};

ClassifierViewController.prototype.DisableProgressForButton = function (Btn, Text)
{
    if(Btn.config.icon != "spinner-third")
        return;

    Btn.define("icon","");
    Btn.define("type", Btn.config.type_was ? Btn.config.type_was : "");
    Btn.define("css","");
    Btn.refresh();
};
ClassifierViewController.prototype.RecheckHosts = function ()
{
    let table = this.Views.ReportsWidgets.HostsReport.Views.Table;

    let rowsIds = [];

    let selectedItem = table.getSelectedItem();

    if (!Array.isArray(selectedItem))
        selectedItem = selectedItem?[selectedItem]:[];

    selectedItem.map(function (item) {
        rowsIds.push(item._id);
    });

    this.HostsViewModel.RecheckHosts(rowsIds)
}
var ClassifierModelsTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"ClassifierModelsTableWidget",
        sortDisabledColumns:["checked", "edit", "trash"],
        enableCheckboxRefresh:true,
        showProgressWhenDataLoading:true,
        config:{
            method:function ()
            {
                return "Clsfr_GetModelsListReport";
            },
            sort:{id:"name",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [
                { id:"checked", header:["",{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}], template: CellCheckBoxTemplate, width:32, sort: false },
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate, sort:false },
                { id:"name", fillspace:true, header:[LangHelper.GetString("Classifier","Name"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                    template: function (Obj){
                        var name = Obj.cutModel ? '<span class="app_view_title__highlight">' + Obj.name + '</span>' : Obj.name;
                        return Obj.default ? '<strong>' + name + '</strong>' : name;
                    }
                },
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate, sort:false }
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var ClassifierFoldersTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"ClassifierFoldersTableWidget",
        sortDisabledColumns:["checkbox", "trash"],
        enableCheckboxRefresh:true,
        showProgressWhenDataLoading:true,
        config:{
            method:function ()
            {
                return "Clsfr_GetFoldersListReport";
            },
            sort:{id:"code",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [
                { id:"checked", header:["",{content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}], template: CellColoredCheckBoxTemplate, width:32 },
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate },
                { id:"usedModel", fillspace:true, header:[LangHelper.GetString("Classifier","Model"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"code", fillspace:true, header:[LangHelper.GetString("Classifier","Folder") + " (" + LangHelper.GetString("Classifier","Code") + ")", {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate, sort:false }
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on:{}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.onAfterSelect)
    {
        params.on.onAfterSelect = function (Selection, Preserve)
        {
            Params.onAfterSelect(Selection, Preserve);
        };
    }

    if(Params&&Params.onAfterUnSelect)
    {
        params.on.onAfterUnSelect = function (Selection)
        {
            Params.onAfterUnSelect(Selection);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};

var ClassifierFilesTableWidget = function (Params)
{
    var params = {
        id:Params&&Params.id?Params.id:webix.uid(),
        name:Params&&Params.name?Params.name:"ClassifierFilesTableWidget",
        sortDisabledColumns:["checkbox", "trash"],
        enableCheckboxRefresh:true,
        showProgressWhenDataLoading:true,
        config:{
            method:function ()
            {
                return "Clsfr_GetFilesListReport";
            },
            sort:{id:"_id",dir:"asc"}
        },
        columns: function ()
        {
            var cols = [
                { id:"checked", header:["", {content:"masterCheckbox", css:"hcell_ckeckbox", contentId:"mc"}], template: CellColoredCheckBoxTemplate, width:32 },
                { id:"edit", width:32, header:"", template:CellEditBtnTemplate },
                { id:"usedModel", fillspace:true, header:[LangHelper.GetString("Classifier","Model"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"folder", fillspace:true, header:[LangHelper.GetString("Classifier","Folder"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"file", fillspace:true, header:[LangHelper.GetString("Classifier","File"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}] },
                { id:"trash", width:32, header:"", template:CellTrashBtnTemplate }
            ];

            return cols;
        }(),
        rules:{},
        sort_map:{},
        defaultPageSize:100,
        multiselect:true,
        on: {}
    };

    if(Params&&Params.onItemClick)
    {
        params.on.onItemClick = function (Id, E, Node)
        {
            Params.onItemClick(Id, E, Node);
        };
    }

    if(Params&&Params.onCheck)
    {
        params.on.onCheck = function (Row, Column, State)
        {
            Params.onCheck(Row, Column, State);
        };
    }

    if(Params&&Params.no_title)
        delete params.title;

    return new QoETableReportWidget(params);
};



function ClassifierModelViewController(Params)
{
    var _this = this;

    this.Id = "ClassifierModel";

    this.ViewModel = new ClassifierModelManager();

    this.ViewHostsModel = new ClassifierHostsManager();

    this.ReportsModel = new UniReportsManager();



    this.CutModels = [];



    this.ModelsDuplicateContext = {
        view: "popup",
        id: this.Id + "Models" + "Duplicate" + "Context",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "Models" + "Duplicate" + "ContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    rules: {
                        usedModel: function (value, val){ return this.elements.usedModel.getText() != val.name; },
                        name: function (value){ return !_this.CutModels.includes(value); }
                    },
                    elements: [
                        {
                            view:"label",
                            label: LangHelper.GetString("Classifier", "Duplicate model"),
                            inputWidth:160,
                            align:"center"
                        },
                        {
                            id:this.Id + "Models" + "Duplicate" + "ContextForm" + "UsedModel",
                            view: "combo",
                            name: "usedModel",
                            labelWidth:134,
                            label: LangHelper.GetString("Classifier", "Model"),
                            tooltip:LangHelper.GetString("Classifier","Model"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options: [],
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            view: "text",
                            id:this.Id + "Models" + "Duplicate" + "ContextForm" + "Name",
                            name: "name",
                            labelWidth:134,
                            width: 374,
                            label: LangHelper.GetString("Classifier","Duplicate name"),
                            tooltip:LangHelper.GetString("Classifier","Duplicate name"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.ModelsDuplicateContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "Models" + "Duplicate" + "ContextForm" + "Save" + "Btn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.ModelsDuplicateForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ModelsSetDefaultContext = {
        view: "popup",
        id: this.Id + "Models" + "SetDefault" + "Context",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    view: "form",
                    id:this.Id + "Models" + "SetDefault" + "ContextForm",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view:"multiselect",
                            id:this.Id + "Models" + "SetDefault" + "ContextForm" + "UsedModel",
                            name: "usedModel",
                            labelWidth:120,
                            label: LangHelper.GetString("Classifier", "Model"),
                            tooltip:LangHelper.GetString("Classifier","Model"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options:[],
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.ModelsSetDefaultContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "Models" + "SetDefault" + "ContextForm" + "Save" + "Btn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.Views.ModelsSetDefaultContext.hide();
                                        _this.ModelsSetDefaultForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ModelsEditContext = {
        view: "popup",
        id: this.Id + "Models" + "Edit" + "Context",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "Models" + "Edit" + "ContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    rules: {
                        name: function (value){ return !_this.CutModels.includes(value); }
                    },
                    elements: [
                        {
                            view: "text",
                            id:this.Id + "Models" + "EditPopup" + "Name" + "Input",
                            name: "name",
                            labelWidth:120,
                            width: 420,
                            label: LangHelper.GetString("Classifier","Name"),
                            tooltip: LangHelper.GetString("Classifier","Name"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.ModelsEditContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "Models" + "ContextForm" + "Save" + "Btn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.ModelsSaveEditForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.ModelsTrashContext = {
        view:"popup",
        id: this.Id + "Models" + "Trash" + "Context",
        width:300,
        height:180,
        body:{
            id:this.Id + "Models" + "Trash" + "ContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Classifier","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Classifier","Cancel"),
                            click:function ()
                            {
                                _this.Views.ModelsTrashContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "Models" + "Trash" + "ContextForm" + "Delete" + "Btn",
                            type:"form",
                            label:LangHelper.GetString("Classifier","Delete"),
                            click:function ()
                            {
                                _this.Views.ModelsTrashContext.hide();

                                _this.ModelsTrashEditForm();
                            }
                        }
                    ]
                }
            ]
        }
    };



    this.FoldersEditContext = {
        view: "popup",
        id: this.Id + "Folders" + "Edit" + "Context",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "Folders" + "Edit" + "ContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "combo",
                            id: this.Id + "Folders" + "Edit" + "ContextForm" + "usedModel",
                            name: "usedModel",
                            labelWidth:120,
                            label: LangHelper.GetString("Classifier", "Model"),
                            tooltip:LangHelper.GetString("Classifier","Model"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options: [],
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            view: "text",
                            id: this.Id + "Folders" + "EditPopup" + "Name" + "Input",
                            name: "folder",
                            labelWidth:120,
                            width: 420,
                            label: LangHelper.GetString("Classifier","Name"),
                            tooltip:LangHelper.GetString("Classifier","Name"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.FoldersEditContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "Folders" + "ContextForm" + "Save" + "Btn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.FoldersSaveEditForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.FoldersTrashContext = {
        view:"popup",
        id: this.Id + "Folders" + "Trash" + "Context",
        width:300,
        height:180,
        body:{
            id:this.Id + "Folders" + "Trash" + "ContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Classifier","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Classifier","Cancel"),
                            click:function ()
                            {
                                _this.Views.FoldersTrashContext.hide();
                            }
                        },
                        {
                            view:"button",
                            id: this.Id + "Folders" + "Trash" + "ContextForm" + "Delete" + "Btn",
                            type:"form",
                            label:LangHelper.GetString("Classifier","Delete"),
                            click:function ()
                            {
                                _this.Views.FoldersTrashContext.hide();

                                _this.FoldersTrashEditForm();
                            }
                        }
                    ]
                }
            ]
        }
    };



    this.FilesEditContext = {
        view: "popup",
        id: this.Id + "Files" + "Edit" + "Context",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id:this.Id + "Files" + "Edit" + "ContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "combo",
                            name: "usedModel",
                            labelWidth:120,
                            label: LangHelper.GetString("Classifier", "Model"),
                            tooltip:LangHelper.GetString("Classifier","Model"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options: [],
                            on: {
                                onChange(nValue, oValue) {
                                    var folder = _this.Views.FilesEditContextForm.elements.folder;
                                    folder.setValue("");
                                    folder.disable();
                                    folder.getList().clearAll();

                                    var data = {filter: {model: {value: [nValue]}}};

                                    _this.ViewModel.FoldersGet(data, 'FilesEditContextForm');
                                }
                            },
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            view: "combo",
                            name: "folder",
                            labelWidth:120,
                            label: LangHelper.GetString("Classifier", "Folder"),
                            tooltip:LangHelper.GetString("Classifier","Folder"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options: [],
                            disabled:true,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            view: "text",
                            id:this.Id + "Files" + "EditPopup" + "Name" + "Input",
                            name: "file",
                            labelWidth:120,
                            width: 420,
                            label: LangHelper.GetString("Classifier","Name"),
                            tooltip:LangHelper.GetString("Classifier","Name"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.FilesEditContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "Files" + "ContextForm" + "Save" + "Btn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.FilesSaveEditForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.FilesTrashContext = {
        view:"popup",
        id: this.Id + "Files" + "Trash" + "Context",
        width:300,
        height:180,
        body:{
            id:this.Id + "Files" + "Trash" + "ContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString("Classifier","Are you sure you want to delete the selected records?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString("Classifier","Cancel"),
                            click:function ()
                            {
                                _this.Views.FilesTrashContext.hide();
                            }
                        },
                        {
                            view: "button",
                            name: "delete",
                            id: this.Id + "Files" + "Trash" + "ContextForm" + "Delete" + "Btn",
                            type:"form",
                            label:LangHelper.GetString("Classifier","Delete"),
                            click:function ()
                            {
                                _this.Views.FilesTrashContext.hide();

                                _this.FilesTrashEditForm();
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.FilesEraseContext = {
        view:"popup",
        id: this.Id + "Files" + "Erase" + "Context",
        width:300,
        height:180,
        body:{
            id:this.Id + "Files" + "Erase" + "ContextForm",
            view:"form",
            borderless:true,
            elements:[
                {
                    template:LangHelper.GetString(this.Id,"Are you sure you want to remove all list items?")
                },
                {
                    cols:[
                        {},
                        {
                            view:"button",
                            label:LangHelper.GetString(this.Id,"Cancel"),
                            click:function ()
                            {
                                _this.Views.FilesEraseContext.hide();
                            }
                        },
                        {
                            view: "button",
                            name: "erase",
                            id: this.Id + "Files" + "Erase" + "ContextForm" + "RemoveAll" + "Btn",
                            type:"form",
                            label:LangHelper.GetString(this.Id,"Remove all"),
                            click:function ()
                            {
                                _this.Views.FilesEraseContext.hide();

                                _this.FilesEraseEditForm();
                            }
                        }
                    ]
                }
            ]
        }
    };

    this.FilesSetFolderContext = {
        view: "popup",
        id: this.Id + "Files" + "SetFolder" + "Context",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id: this.Id + "Files" + "SetFolder" + "Context" + "Form",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "combo",
                            name: "usedModel",
                            labelWidth:120,
                            label: LangHelper.GetString("Classifier", "Model"),
                            tooltip:LangHelper.GetString("Classifier","Model"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options: [],
                            on: {
                                onChange() {
                                    var folder = _this.Views.FilesSetFolderContextForm.elements.folder;
                                    folder.disable();
                                    folder.setValue("");

                                    var data = {filter: {model: {value: [this.getText()]}}};

                                    _this.ViewModel.FoldersGet(data, 'FilesSetFolderContextForm');
                                }
                            },
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            view: "combo",
                            name: "folder",
                            labelWidth:120,
                            label: LangHelper.GetString("Classifier", "Folder"),
                            tooltip:LangHelper.GetString("Classifier","Folder"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            options: [],
                            disabled:true,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.FilesSetFolderContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id:this.Id + "Files" + "SetFolder" + "Context" + "Form" + "Save" + "Btn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Save"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.Views.FilesSetFolderContext.hide();

                                        _this.FilesSaveSetFolderForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };

    this.FilesGetHTMLContext = {
        view: "popup",
        id: this.Id + "Files" + "GetHTML" + "Context",
        width: 440,
        height: 480,
        modal:true,
        body:{
            rows:[
                {
                    id: this.Id + "Files" + "GetHTML" + "ContextForm",
                    view: "form",
                    borderless: true,
                    margin: 0,
                    padding: 0,
                    elements: [
                        {
                            view: "text",
                            id: this.Id + "Files" + "GetHTML" + "ContextForm" + "URL",
                            name: "url",
                            labelWidth:120,
                            width: 420,
                            label: LangHelper.GetString("Classifier","URL"),
                            tooltip:LangHelper.GetString("Classifier","URL"),
                            required:true,
                            validate: webix.rules.isNotEmpty,
                            invalidMessage: LangHelper.GetString("Classifier", "Required field")
                        },
                        {
                            cols:[
                                {},
                                {
                                    view:"button",
                                    label:LangHelper.GetString("Classifier","Cancel"),
                                    click:function ()
                                    {
                                        _this.Views.FilesGetHTMLContext.hide();
                                    }
                                },
                                {
                                    view:"button",
                                    id: this.Id + "Files" + "GetHTML" + "ContextForm" + "Get" + "Btn",
                                    type:"form",
                                    label:LangHelper.GetString("Classifier","Get"),
                                    hotkey: "enter",
                                    click:function ()
                                    {
                                        _this.FilesGetHTMLForm();
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };



    this.HostsMachineLearningCheckContext = webix.ui({
        view: "popup",
        width: 520,
        height: 200,
        body: {
            id: this.Id + "HostsMachineLearningCheckContextForm",
            view: "form",
            borderless: true,
            elements: [
                {
                    view: "text",
                    id: this.Id + "Category",
                    name: "category",
                    labelWidth: 200,
                    label: LangHelper.GetString("Classifier", "Likely category"),
                    tooltip: LangHelper.GetString("Classifier", "Likely category"),
                    required: true,
                    disabled: true,
                    validate: webix.rules.isNotEmpty,
                    invalidMessage: LangHelper.GetString("Classifier", "Required field")
                },
                {
                    view: "text",
                    id: this.Id + "Percent",
                    name: "percent",
                    labelWidth: 200,
                    label: LangHelper.GetString("Classifier", "Recognition correctness"),
                    tooltip: LangHelper.GetString("Classifier", "Recognition correctness"),
                    required: true,
                    disabled: true,
                    validate: webix.rules.isNotEmpty,
                    invalidMessage: LangHelper.GetString("Classifier", "Required field")
                },
                {
                    cols: [
                        {},
                        {
                            view: "button",
                            label: LangHelper.GetString(this.Id, "Ok"),
                            click: function () {
                                _this.HostsMachineLearningCheckContext.hide();
                            }
                        },
                        {}
                    ]
                }
            ]
        }
    });



    this.Views = {
        Folders:null,
        Files:null,
        FileEditor:null,
        FileEditorContent:null,

        //Toolbars
        FoldersToolbar:null,
        FilesToolbar:null,
        FileEditorToolbar:null,

        /////////////////
        /////BUTTONS/////
        /////////////////

        //Models buttons
        ModelsAddBtn:null,

        //Folders buttons
        FoldersAddBtn:null,
        FoldersRefreshBtn:null,

        //Files buttons
        FilesAddBtn:null,
        FilesSetFolderBtn:null,
        FilesDelBtn:null,
        FilesEraseBtn:null,
        FilesRefreshBtn:null,

        //FileEditor buttons
        FileEditorSaveBtn:null,
        FileEditorRefreshBtn:null,

        ///////////////
        /////Forms/////
        ///////////////

        //Models
        ModelsDuplicateContext:null,
        ModelsDuplicateContextForm:null,

        ModelsSetDefaultContext:null,
        ModelsSetDefaultContextForm:null,

        //Files
        FilesEditContext:null,
        FilesEditContextForm:null,

        FilesTrashContext:null,
        FilesTrashContextForm:null,

        FilesEraseContext:null,
        FilesEraseContextForm:null,

        FilesSetFolderContext:null,
        FilesSetFolderContextForm:null,

        FilesGetHTMLContext:null,
        FilesGetHTMLContextForm:null,



        HostsMachineLearningCheckContext:null,
        HostsMachineLearningCheckContextForm:null,

        ///////////////
        /////Other/////
        ///////////////

        Widgets:{},
        ReportsWidgets:{
            ModelsReport: ClassifierModelsTableWidget({
                id:this.Id + "ModelsReport",
                onItemClick:function (Id,e,node)
                {
                    var table = _this.Views.ReportsWidgets.ModelsReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'edit':
                            _this.btnDisable(rowData.name, $$(_this.Id + "Models" + "ContextForm" + "Save" + "Btn"));
                            _this.btnDisable(rowData.name, $$(_this.Id + "Models" + "EditPopup" + "Name" + "Input"));

                            _this.ShowModelsEditForm(rowData, table.getItemNode(Id), "top");
                            break;
                        case 'trash':
                            _this.btnDisable(rowData.name, $$(_this.Id + "Models" + "Trash" + "ContextForm" + "Delete" + "Btn"));

                            _this.Views.ModelsTrashContext.show(table.getItemNode(Id), {pos: "bottom"});
                            break;
                    }
                }
            }),
            FoldersReport: ClassifierFoldersTableWidget({
                id:this.Id + "FoldersReport",
                onItemClick:function (Id,e,node)
                {
                    var table = _this.Views.ReportsWidgets.FoldersReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'edit':
                            _this.btnDisable(rowData.usedModel, $$(_this.Id + "Folders" + "ContextForm" + "Save" + "Btn"));

                            _this.ShowFoldersEditForm(rowData, table.getItemNode(Id), "top");

                            if(_this.CutModels.includes(rowData.usedModel))
                            {
                                var elements = _this.Views.FoldersEditContextForm.elements;
                                var usedModel = elements.usedModel;

                                var list = usedModel.getList();
                                list.clearAll();
                                list.parse([rowData.usedModel]);

                                usedModel.disable();
                                elements.folder.disable();
                            }
                            break;
                        case 'trash':
                            _this.btnDisable(rowData.usedModel, $$(_this.Id + "Folders" + "Trash" + "ContextForm" + "Delete" + "Btn"));

                            _this.Views.FoldersTrashContext.show(table.getItemNode(Id), {pos: "bottom"});
                            break;
                    }
                }
            }),
            FilesReport: ClassifierFilesTableWidget({
                id:this.Id + "FilesReport",
                onItemClick:function (Id,e,node)
                {
                    var table = _this.Views.ReportsWidgets.FilesReport.Views.Table;

                    var rowData = table.getItem(Id);

                    switch (Id.column) {
                        case 'edit':
                            _this.btnDisable(rowData.usedModel, $$(_this.Id + "Files" + "ContextForm" + "Save" + "Btn"));

                            _this.ShowFilesEditForm(rowData, table.getItemNode(Id), "top");

                            var elements = _this.Views.FilesEditContextForm.elements;
                            var usedModel = elements.usedModel;
                            var folder = elements.folder;

                            usedModel.enable();
                            elements.file.enable();

                            if(_this.CutModels.includes(rowData.usedModel))
                            {
                                var usedModelList = usedModel.getList();
                                usedModelList.clearAll();
                                usedModelList.parse([rowData.usedModel]);

                                var folderList = folder.getList();
                                folderList.clearAll();
                                folderList.parse([rowData.folder]);

                                usedModel.disable();
                                folder.disable();
                                elements.file.disable();
                            }

                            break;
                        case 'trash':
                            _this.btnDisable(rowData.usedModel, $$(_this.Id + "Files" + "Trash" + "ContextForm" + "Delete" + "Btn"));

                            _this.Views.FilesTrashContext.show(table.getItemNode(Id), {pos: "bottom"});
                            break;
                    }
                }
            })
        }
    };

    this.ViewConfig = [
        {
            cols:[
                ClassifierLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                PageHeaderTemplate({root_title:LangHelper.GetString("AppView", "Classifier"),title:LangHelper.GetString("Classifier", "Classifier model")}),
                                {
                                    cols:[
                                        {
                                            view:"accordion",
                                            multi:true,
                                            cols:[
                                                {
                                                    header:LangHelper.GetString("Classifier","Models"), body:{
                                                        id:this.Id + "Models",
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                id:this.Id + "Models" + "Toolbar",
                                                                height:webix.skin.$active.rowHeight,
                                                                padding: 0,
                                                                margin: 0,
                                                                elements: [
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Models" + "AddBtn",
                                                                        type: "icon",
                                                                        icon: "plus",
                                                                        align: "right",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Classifier","Add list item"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ModelsActionAddBtn();
                                                                        }
                                                                    },
                                                                    {
                                                                        width:24
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Models" + "DuplicateBtn",
                                                                        type: "icon",
                                                                        icon: "clone",
                                                                        align: "right",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Classifier","Duplicate model"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            var __this = this;
                                                                            var node = __this.getNode(id);

                                                                            var form = _this.Views.ModelsDuplicateContextForm;
                                                                            form.clearValidation();
                                                                            form.setValues("");

                                                                            //Options (models)
                                                                            var models = [];

                                                                            var selectedModel = _this.Views.ReportsWidgets.ModelsReport.Views.Table.getSelectedItem().name;

                                                                            _this.GetReportTableData('Models').forEach(function (value){
                                                                                models.push({value:value.name, default:value.name==selectedModel});
                                                                            });

                                                                            var usedModel = form.elements.usedModel;

                                                                            var list = usedModel.getList();
                                                                            list.clearAll();
                                                                            list.parse(models);



                                                                            var def = null;

                                                                            list.data.each(function(obj){
                                                                                if (obj.default)  def = obj.id;
                                                                            });

                                                                            if (def)
                                                                                usedModel.setValue(def);

                                                                            _this.Views.ModelsDuplicateContext.show(node, {pos: "bottom"});
                                                                        }
                                                                    },
                                                                    {
                                                                        width:24
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Models" + "SetDefaultBtn",
                                                                        type: "icon",
                                                                        icon: "sunset",
                                                                        align: "right",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Classifier","Set default model"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            var __this = this;
                                                                            var node = __this.getNode(id);

                                                                            var form = _this.Views.ModelsSetDefaultContextForm;
                                                                            form.clearValidation();
                                                                            form.setValues("");

                                                                            //Options (models)
                                                                            var def = '';
                                                                            var models = [];

                                                                            _this.GetReportTableData('Models').forEach(function (value){
                                                                                if (value.default)
                                                                                    def += def?','+value.id:value.id

                                                                                models.push({id: value.id, value:value.name, default:value.default});
                                                                            });

                                                                            var usedModel = form.elements.usedModel;

                                                                            var list = usedModel.getList();
                                                                            list.clearAll();
                                                                            list.parse(models);

                                                                            if (def)
                                                                                usedModel.setValue(def);

                                                                            _this.Views.ModelsSetDefaultContext.show(node, {pos: "bottom"});
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Models" + "RefreshBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshModels();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            BlockHeaderTemplate({
                                                                title:LangHelper.GetString("Classifier","Models"), icon:"hexagon"
                                                            }),
                                                            this.Views.ReportsWidgets.ModelsReport.ViewConfig
                                                        ]
                                                    }, collapsed:true, width:250
                                                },
                                                { view:"resizer" },
                                                {
                                                    header:LangHelper.GetString("Classifier","Folders"), body:{
                                                        id:this.Id + "Folders",
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                id:this.Id + "Folders" + "Toolbar",
                                                                height:webix.skin.$active.rowHeight,
                                                                padding: 0,
                                                                margin: 0,
                                                                elements: [
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Folders" + "AddBtn",
                                                                        type: "icon",
                                                                        icon: "plus",
                                                                        align: "right",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Classifier","Add list item"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.FoldersActionAddBtn();
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Folders" + "RefreshBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshFolders();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            BlockHeaderTemplate({
                                                                title:LangHelper.GetString("Classifier","Folders"), icon:"folders"
                                                            }),
                                                            this.Views.ReportsWidgets.FoldersReport.ViewConfig
                                                        ]
                                                    }, collapsed:false, width:300
                                                },
                                                { view:"resizer" },
                                                {
                                                    header:LangHelper.GetString("Classifier","Files"), body:{
                                                        gravity:5,
                                                        id:this.Id + "Files",
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                id:this.Id + "Files" + "Toolbar",
                                                                height:webix.skin.$active.rowHeight,
                                                                padding: 0,
                                                                margin: 0,
                                                                elements: [
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Files" + "AddBtn",
                                                                        type: "icon",
                                                                        icon: "plus",
                                                                        align: "right",
                                                                        width: 32,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Classifier","Add list item"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.FilesActionAddBtn();
                                                                        }
                                                                    },
                                                                    {
                                                                        width:24
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Files" + "SetFolderBtn",
                                                                        type: "icon",
                                                                        icon: "list-alt",
                                                                        css:"toolbar_round_btn",
                                                                        width:32,
                                                                        tooltip:LangHelper.GetString("Classifier","Set folder"),
                                                                        click:function (id,e,node)
                                                                        {
                                                                            var __this = this;
                                                                            var node = __this.getNode(id);
                                                                            _this.ShowFilesSetFolderForm(node, "bottom");
                                                                        }
                                                                    },
                                                                    {
                                                                        width:24
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Files" + "DelBtn",
                                                                        type: "icon",
                                                                        icon: "trash",
                                                                        css:"toolbar_round_btn",
                                                                        width:32,
                                                                        tooltip:LangHelper.GetString("Classifier", "Delete"),
                                                                        click:function (id,e,node)
                                                                        {
                                                                            var __this = this;
                                                                            var node = __this.getNode(id);

                                                                            var cut = _this.GetModelsReportTableInModel();

                                                                            var element = _this.Views.FilesTrashContextForm.elements.delete;

                                                                            cut ? element.disable() : element.enable();

                                                                            _this.Views.FilesTrashContext.show(node, {pos: "bottom"});
                                                                        }
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Files" + "EraseBtn",
                                                                        type: "icon",
                                                                        icon: "eraser",
                                                                        css:"toolbar_round_btn",
                                                                        width:32,
                                                                        tooltip:LangHelper.GetString("Classifier", "Remove all"),
                                                                        click:function (id,e,node)
                                                                        {
                                                                            var __this = this;
                                                                            var node = __this.getNode(id);

                                                                            var cut = _this.GetModelsReportTableInModel();

                                                                            var element = _this.Views.FilesEraseContextForm.elements.erase;

                                                                            cut ? element.disable() : element.enable();

                                                                            _this.Views.FilesEraseContext.show(node, {pos: "bottom"});
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "Files" + "RefreshBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshFiles();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            BlockHeaderTemplate({
                                                                title:LangHelper.GetString("Classifier","Files"), icon:"files-o"
                                                            }),
                                                            this.Views.ReportsWidgets.FilesReport.ViewConfig
                                                        ]
                                                    }, collapsed:false, width:350
                                                },
                                                { view:"resizer" },
                                                {
                                                    header:LangHelper.GetString("Classifier","File contents"), body:{
                                                        gravity:15,
                                                        id:this.Id + "FileEditor",
                                                        rows:[
                                                            {
                                                                view: "toolbar",
                                                                id:this.Id + "FileEditor" + "Toolbar",
                                                                height:webix.skin.$active.rowHeight,
                                                                padding: 0,
                                                                margin: 0,
                                                                elements: [
                                                                    {
                                                                        view:"button",
                                                                        name:"save",
                                                                        id:this.Id + "FileEditor" + "SaveBtn",
                                                                        type:"icon",
                                                                        icon:"save",
                                                                        label:LangHelper.GetString("Classifier","Save"),
                                                                        align:"right",
                                                                        width:128,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Classifier","Save file"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.FileEditorSave();
                                                                        }
                                                                    },
                                                                    {},
                                                                    {
                                                                        view:"button",
                                                                        id:this.Id + "FileEditor" + "CheckBtn",
                                                                        type:"icon",
                                                                        icon:"check",
                                                                        label:LangHelper.GetString("Classifier","Check"),
                                                                        align:"right",
                                                                        width:128,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Classifier","Check"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.Views.FilesGetHTMLContext.hide();

                                                                            var getBtn = $$(_this.Id + "FileEditor" + "GetBtn");
                                                                            var saveBtn = $$(_this.Id + "FileEditor" + "SaveBtn");
                                                                            var checkBtn = $$(_this.Id + "FileEditor" + "CheckBtn");

                                                                            _this.EnableProgressForButton(checkBtn);
                                                                            getBtn.disable();
                                                                            saveBtn.disable();
                                                                            checkBtn.disable();

                                                                            var fileSelected = _this.GetReportTableSelectedData('Files');
                                                                            
                                                                            var model = fileSelected.usedModel;
                                                                            var host = fileSelected.file;
                                                                            var HostText = _this.Views.FileEditorContent.getValue();

                                                                            _this.ViewHostsModel.Check(webix.extend({model: model, host: host, HostText: HostText}, true));
                                                                        }
                                                                    },
                                                                    {
                                                                        view:"button",
                                                                        id:this.Id + "FileEditor" + "GetBtn",
                                                                        type:"icon",
                                                                        icon:"globe",
                                                                        label:LangHelper.GetString("Classifier","Get"),
                                                                        align:"right",
                                                                        width:128,
                                                                        css:"toolbar_round_btn",
                                                                        tooltip:LangHelper.GetString("Classifier","Get"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.ShowFilesGetHTMLForm(this.getNode(), "bottom");
                                                                        }
                                                                    },
                                                                    {
                                                                        view: "button",
                                                                        id:this.Id + "FileEditor" + "RefreshBtn",
                                                                        type: "icon",
                                                                        icon: "refresh",
                                                                        css: "toolbar_round_btn",
                                                                        width: 32,
                                                                        tooltip: LangHelper.GetString("All","Refresh"),
                                                                        click: function (id, e, node)
                                                                        {
                                                                            _this.RefreshFileEditor();
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            BlockHeaderTemplate({
                                                                title:LangHelper.GetString("Classifier","File contents"), icon:"text"
                                                            }),
                                                            {
                                                                view:"codemirror-editor",
                                                                id:this.Id + "FileEditor" + "Content",
                                                                value:"",
                                                                disabled:true
                                                            }
                                                        ]
                                                    }, collapsed:false
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.Subscriptions = {};
}

ClassifierModelViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    Object.keys(this.Views).forEach(function (View)
    {
        if(View != "Widgets" && View != "ReportsWidgets")
            _this.Views[View] = $$(_this.Id + View)
    });

    Object.keys(this.Views.Widgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.Widgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ViewModel);

        if(w.Bind)
            w.Bind(_this, _this.ViewModel);
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (WidgetKey)
    {
        var w = _this.Views.ReportsWidgets[WidgetKey];

        if(w.BindAll)
            w.BindAll(_this, _this.ReportsModel);

        if(w.Bind)
            w.Bind(_this, _this.ReportsModel);
    });

    ///////////////
    /////Forms/////
    ///////////////

    //Models
    this.Views.ModelsDuplicateContext = webix.ui(this.ModelsDuplicateContext);
    this.Views.ModelsDuplicateContextForm = $$(this.Id+"ModelsDuplicateContextForm");

    this.Views.ModelsSetDefaultContext = webix.ui(this.ModelsSetDefaultContext);
    this.Views.ModelsSetDefaultContextForm = $$(this.Id+"ModelsSetDefaultContextForm");

    this.Views.ModelsEditContext = webix.ui(this.ModelsEditContext);
    this.Views.ModelsEditContextForm = $$(this.Id+"ModelsEditContextForm");

    this.Views.ModelsTrashContext = webix.ui(this.ModelsTrashContext);
    this.Views.ModelsTrashContextForm = $$(this.Id+"ModelsTrashContextForm");

    //Folders
    this.Views.FoldersEditContext = webix.ui(this.FoldersEditContext);
    this.Views.FoldersEditContextForm = $$(this.Id+"FoldersEditContextForm");

    this.Views.FoldersTrashContext = webix.ui(this.FoldersTrashContext);
    this.Views.FoldersTrashContextForm = $$(this.Id+"FoldersTrashContextForm");

    //Files
    this.Views.FilesEditContext = webix.ui(this.FilesEditContext);
    this.Views.FilesEditContextForm = $$(this.Id+"FilesEditContextForm");

    this.Views.FilesTrashContext = webix.ui(this.FilesTrashContext);
    this.Views.FilesTrashContextForm = $$(this.Id+"FilesTrashContextForm");

    this.Views.FilesEraseContext = webix.ui(this.FilesEraseContext);
    this.Views.FilesEraseContextForm = $$(this.Id+"FilesEraseContextForm");

    this.Views.FilesSetFolderContext = webix.ui(this.FilesSetFolderContext);
    this.Views.FilesSetFolderContextForm = $$(this.Id+"FilesSetFolderContextForm");

    this.Views.FilesGetHTMLContext = webix.ui(this.FilesGetHTMLContext);
    this.Views.FilesGetHTMLContextForm = $$(this.Id+"FilesGetHTMLContextForm");



    this.Views.HostsMachineLearningCheckContext = webix.ui(this.HostsMachineLearningCheckContext);
    this.Views.HostsMachineLearningCheckContextForm = $$(this.Id+"HostsMachineLearningCheckContextForm");



    //GetConfig
    this.ViewModel.GetConfig();

    this.Subscriptions.ClassifierGetConfig = this.ViewModel.Signals.ClassifierGetConfig.subscribe(function (Model) {
        if (Model)
        {
            if (module == 'dpiui2')
                _this.CutModels = Model;
        }
    });
    this.Subscriptions.ClassifierGetConfigError = this.ViewModel.Signals.ClassifierGetConfigError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });



    var folders = this.Views.Folders;
    var files = this.Views.Files;
    var fileEditor = this.Views.FileEditor;



    var modelsContent = this.Views.ReportsWidgets.ModelsReport.Views.Table;
    var foldersContent = this.Views.ReportsWidgets.FoldersReport.Views.Table;
    var filesContent = this.Views.ReportsWidgets.FilesReport.Views.Table;



    Helper.Table.ActivateCheckBox(modelsContent, "default");
    Helper.Table.ActivateCheckBox(foldersContent);
    Helper.Table.ActivateCheckBox(filesContent);



    webix.extend(folders, webix.ProgressBar);
    webix.extend(folders, webix.OverlayBox);

    webix.extend(files, webix.ProgressBar);
    webix.extend(files, webix.OverlayBox);

    webix.extend(fileEditor, webix.ProgressBar);
    webix.extend(fileEditor, webix.OverlayBox);



    //Models
    this.Subscriptions.ModelsTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.ModelsReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        var DuplicateBtn = $$(_this.Id + "Models" + "DuplicateBtn");
        var SetDefaultBtn = $$(_this.Id + "Models" + "SetDefaultBtn");

        var foldersToolbar = _this.Views.FoldersToolbar;

        if (Value>0){
            _this.RefreshFolders();
            foldersToolbar.enable();
            DuplicateBtn.disable();
            SetDefaultBtn.enable();
            (Value == 1) ? DuplicateBtn.enable() : '';
        }else {
            DuplicateBtn.disable();
            SetDefaultBtn.disable();
            foldersToolbar.disable();
            foldersContent.clearAll();
            setTimeout(function () {
                if (!_this.Views.ReportsWidgets.FoldersReport.TableRowsSelectedCount.getValue())
                    folders.showOverlay(_this.GetOverflowTemplate("Select model"));
            }, 100)
        }
    });

    this.Subscriptions.ClassifierModelModelsSaved = this.ViewModel.Signals.ClassifierModelModelsSaved.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Model saved successfully"));

            _this.Views.ModelsEditContext.hide();

            var item = Model.idRow;

            if (item)
                modelsContent.updateItem(item, { name: Model.new, default: Model.default, cutModel: Model.cutModel});
            else
                var item = modelsContent.add({ name: Model.new, default: Model.default, cutModel: Model.cutModel }, 0);

            modelsContent.select(item);

            modelsContent.hideOverlay();
            modelsContent.hideProgress();
        }
    });
    this.Subscriptions.ClassifierModelModelsSaveError = this.ViewModel.Signals.ClassifierModelModelsSaveError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierModelModelsDeleted = this.ViewModel.Signals.ClassifierModelModelsDeleted.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Model delete successfully"));

            modelsContent.unselectAll();

            modelsContent.remove(Model.idRows);
        }
    });
    this.Subscriptions.ClassifierModelModelsDeleteError = this.ViewModel.Signals.ClassifierModelModelsDeleteError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierModelModelsDuplicate = this.ViewModel.Signals.ClassifierModelModelsDuplicate.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Model duplicated successful"));

            _this.Views.ModelsDuplicateContext.hide();

            var item = modelsContent.add({name: Model.usedModel}, 0);

            modelsContent.select(item);

            modelsContent.hideOverlay();
            modelsContent.hideProgress();
        }
    });
    this.Subscriptions.ClassifierModelModelsDuplicateError = this.ViewModel.Signals.ClassifierModelModelsDuplicateError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierModelModelsSetDefault = this.ViewModel.Signals.ClassifierModelModelsSetDefault.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Model set default successful"));

            modelsContent.unselectAll();

            modelsContent.serialize().forEach(function (Obj){
                Obj.default ? modelsContent.getItem(Obj.id).default = 0 : '';
            });

            Model.idRows.forEach(function (idRow){
                modelsContent.getItem(idRow).default = 1;
                modelsContent.select(idRow, true);
            });
        }
    });
    this.Subscriptions.ClassifierModelModelsSetDefaultError = this.ViewModel.Signals.ClassifierModelModelsSetDefaultError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });



    //Folders
    this.Subscriptions.FoldersTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.FoldersReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        var files = _this.Views.Files;
        var filesToolbar = _this.Views.FilesToolbar;
        var filesContent = _this.Views.ReportsWidgets.FilesReport.Views.Table;

        var fileEditorToolbar = _this.Views.FileEditorToolbar;

        if (Value>0){
            _this.RefreshFiles();
            filesToolbar.enable();
            fileEditorToolbar.enable();
        }else {
            filesToolbar.disable();
            fileEditorToolbar.disable();
            filesContent.clearAll();
            setTimeout(function () {
                if (!_this.Views.ReportsWidgets.FoldersReport.TableRowsSelectedCount.getValue())
                    files.showOverlay(_this.GetOverflowTemplate("Select folder"));
            }, 100)
        }
    });

    this.Subscriptions.ClassifierModelFoldersSaved = this.ViewModel.Signals.ClassifierModelFoldersSaved.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Folder saved successfully"));

            _this.Views.FoldersEditContext.hide();

            var item = Model.idRow;

            var usedModel = Model.usedModel;
            var folder = Model.folder;

            if (item && usedModel.new == usedModel.old){
                foldersContent.updateItem(item, { code: folder.new });
            }else if (item){
                foldersContent.remove(item);
                return;
            }else if (usedModel.new == usedModel.old) {
                var item = foldersContent.add({ usedModel: usedModel.new, code: folder.new }, 0);
            }

            if (item)
                foldersContent.select(item);

            foldersContent.hideOverlay();
            foldersContent.hideProgress();
        }
    });
    this.Subscriptions.ClassifierModelFoldersSaveError = this.ViewModel.Signals.ClassifierModelFoldersSaveError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierModelFoldersDeleted = this.ViewModel.Signals.ClassifierModelFoldersDeleted.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Folder delete successfully"));

            foldersContent.unselectAll();

            foldersContent.remove(Model.idRows);
        }
    });
    this.Subscriptions.ClassifierModelFoldersDeleteError = this.ViewModel.Signals.ClassifierModelFoldersDeleteError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });


    this.Subscriptions.ClassifierModelFoldersGet = this.ViewModel.Signals.ClassifierModelFoldersGet.subscribe(function (Model) {
        if (Model)
        {
            var form = _this.Views[Model['form']];

            var cut = false;

            var foldersOptions = [];
            Model['rows'].forEach(function (Option)
            {
                foldersOptions.push({usedModel: Option.usedModel, id: Option.code, value: Option.code});

                if (_this.CutModels.includes(Option.usedModel))
                    cut = true;
            });

            var folder = form.elements.folder;

            var foldersSelect = folder.getList();
            foldersSelect.clearAll();
            foldersSelect.parse(foldersOptions);

            if (!cut)
                folder.enable();
        }
    });
    this.Subscriptions.ClassifierModelFoldersGetError = this.ViewModel.Signals.ClassifierModelFoldersGetError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });



    //Files
    this.Subscriptions.FilesTableRowsSelectedCountSubscription = this.Views.ReportsWidgets.FilesReport.TableRowsSelectedCount.subscribe(function (Value)
    {
        //Files buttons
        var filesSetFolderBtn = _this.Views.FilesSetFolderBtn;
        var filesDelBtn = _this.Views.FilesDelBtn;

        var fileEditor = _this.Views.FileEditor;
        var fileEditorContent = _this.Views.FileEditorContent;
        var fileEditorToolbar = _this.Views.FileEditorToolbar;

        function fileEditorDisabled()
        {
            fileEditorContent.disable();
            fileEditorToolbar.disable();
            fileEditorContent.setValue("");
            fileEditor.hideProgress();
            fileEditor.showOverlay(_this.GetOverflowTemplate());
        }

        if (Value>0){
            if (Value>1)
            {
                fileEditorDisabled();
            }else {
                _this.RefreshFileEditor();
                fileEditorToolbar.enable();
            }
            filesSetFolderBtn.enable();
            filesDelBtn.enable();
        }else {
            fileEditorDisabled();
            filesSetFolderBtn.disable();
            filesDelBtn.disable();
        }
    });

    this.Subscriptions.ClassifierModelFilesSaved = this.ViewModel.Signals.ClassifierModelFilesSaved.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "File saved successfully"));

            _this.Views.FilesEditContext.hide();

            var item = Model.idRow;

            var usedModel = Model.usedModel;
            var folder = Model.folder;
            var file = Model.file;

            var condition = (usedModel.new == usedModel.old) && (folder.new == folder.old);

            if (item && condition){
                filesContent.updateItem(item, { file: file.new });
            }else if (item){
                filesContent.remove(item);
                return;
            }else if (condition) {
                var item = filesContent.add({ usedModel: usedModel.new, folder: folder.new, file: file.new }, 0);
            }

            if (item)
                filesContent.select(item);

            filesContent.hideOverlay();
            filesContent.hideProgress();
        }
    });
    this.Subscriptions.ClassifierModelFilesSaveError = this.ViewModel.Signals.ClassifierModelFilesSaveError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierModelFilesDeleted = this.ViewModel.Signals.ClassifierModelFilesDeleted.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "File delete successfully"));

            filesContent.unselectAll();

            filesContent.remove(Model.idRows);
        }
    });
    this.Subscriptions.ClassifierModelFilesDeleteError = this.ViewModel.Signals.ClassifierModelFilesDeleteError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierModelFilesErased = this.ViewModel.Signals.ClassifierModelFilesErased.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Files erased successfully"));

            _this.Views.FilesEditContext.hide();

            filesContent.clearAll();
        }
    });
    this.Subscriptions.ClassifierModelFilesEraseError = this.ViewModel.Signals.ClassifierModelFilesEraseError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierModelFilesSetFolder = this.ViewModel.Signals.ClassifierModelFilesSetFolder.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Folder set successfully"));

            filesContent.unselectAll();

            filesContent.remove(Model.data.idRows);
        }
    });
    this.Subscriptions.ClassifierModelFilesSetFolderError = this.ViewModel.Signals.ClassifierModelFilesSetFolderError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });



    //FileEditor
    this.Subscriptions.ClassifierModelGetFileText = this.ViewModel.Signals.ClassifierModelGetFileText.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "File text received successfully"));

            var fileEditorToolbarSave = _this.Views.FileEditorToolbar.elements.save;
            var fileEditorContent = _this.Views.FileEditorContent;

            fileEditorContent.setValue(Model.data);

            _this.CutModels.includes(Model.usedModel) ? fileEditorToolbarSave.disable() : fileEditorToolbarSave.enable();

            _this.Views.FileEditor.hideProgress();

            fileEditorContent.enable();
        }
    });
    this.Subscriptions.ClassifierModelGetFileTextError = this.ViewModel.Signals.ClassifierModelGetFileTextError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierModelFileEditorSaved = this.ViewModel.Signals.ClassifierModelFileEditorSaved.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "File text saved successfully"));

            fileEditor.hideProgress();
            fileEditor.hideOverlay();
        }
    });
    this.Subscriptions.ClassifierModelFileEditorSaveError = this.ViewModel.Signals.ClassifierModelFileEditorSaveError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);

            fileEditor.hideProgress();
            fileEditor.hideOverlay();
        }
    });

    function bindBtn () {
        var getBtn = $$(_this.Id + "FileEditor" + "GetBtn");
        var saveBtn = $$(_this.Id + "FileEditor" + "SaveBtn");
        var checkBtn = $$(_this.Id + "FileEditor" + "CheckBtn");
        return {get: getBtn, save: saveBtn, check: checkBtn};
    }

    function enableBtn (icon = "") {
        var btn = bindBtn();

        _this.DisableProgressForButton(btn.check, icon);
        btn.get.enable();
        btn.save.enable();
        btn.check.enable();
    }

    function disableBtn () {
        var btn = bindBtn();

        _this.EnableProgressForButton(btn.check);
        btn.get.disable();
        btn.save.disable();
        btn.check.disable();
    }


    this.Subscriptions.ClassifierHostsGetHtmlText = this.ViewHostsModel.Signals.ClassifierHostsGetHtmlText.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "HTML text received successfully"));

            var fileEditorContent = _this.Views.FileEditorContent;

            fileEditorContent.setValue(Model);

            _this.Views.FileEditor.hideProgress();

            fileEditorContent.enable();
        }
    });
    this.Subscriptions.ClassifierHostsGetHtmlTextError = this.ViewHostsModel.Signals.ClassifierHostsGetHtmlTextError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    this.Subscriptions.ClassifierHostsCheck = this.ViewHostsModel.Signals.ClassifierHostsCheck.subscribe(function (Model) {
        if (Model)
        {
            webix.message(LangHelper.GetString("Classifier", "Percentage received successfully"));

            var btn = $$(_this.Id + "FileEditor" + "CheckBtn");

            var node = btn.getNode();

            var form = _this.Views.HostsMachineLearningCheckContextForm;

            function name(obj){
                var lang = LangHelper.GetLocale();
                if (obj && obj.name_json)
                {
                    var name = JSON.parse(obj.name_json);
                    var local = name[lang]?name[lang]:(name.en?name.en:name[Object.keys(name)[0]]);
                }else{
                    var local = obj.name;
                }
                return local;
            }

            form.setValues({category:name(Model)+' ('+Model.code+')', percent:parseFloat(Model.percent).toFixed(2)*100 + '%'});

            _this.Views.HostsMachineLearningCheckContext.show(node, {pos:"bottom"});

            enableBtn("check");
        }
    });
    this.Subscriptions.ClassifierHostsCheckError = this.ViewHostsModel.Signals.ClassifierHostsCheckError.subscribe(function (Model) {
        if (Model)
        {
            enableBtn("check");
            _this.ShowServerError(Model);
        }
    });
};

ClassifierModelViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

    this.Refresh();
};

ClassifierModelViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        if(_this.Subscriptions[key])
            _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Views.Widgets).forEach(function (Widget)
    {
        var w = _this.Views.Widgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    Object.keys(this.Views.ReportsWidgets).forEach(function (Widget)
    {
        var w = _this.Views.ReportsWidgets[Widget];
        if(w.Destroy)
            w.Destroy();
    });

    if(this.ViewModel)
    {
        this.ViewModel.Destroy();
        delete this.ViewModel;
    }

    if(this.ReportsModel)
    {
        this.ReportsModel.Destroy();
        delete this.ReportsModel;
    }
};

ClassifierModelViewController.prototype.Refresh = function ()
{
    this.RefreshModels();
    //this.RefreshFolders();
    //this.RefreshFiles();
};

ClassifierModelViewController.prototype.RefreshModels = function ()
{
    this.Views.ReportsWidgets.ModelsReport.RefreshData();
};

ClassifierModelViewController.prototype.RefreshFolders = function ()
{
    var _this = this;

    clearTimeout(this.FoldersRefreshTimeOut);

    this.FoldersRefreshTimeOut = setTimeout(function ()
    {
        var modelsCount = _this.GetReportTableSelectedData('Models', true).length;

        if (modelsCount)
            _this._RefreshFolders();
    }, 100);
};

ClassifierModelViewController.prototype._RefreshFolders = function ()
{
    var folders = this.Views.Folders;

    var tableModels = this.Views.ReportsWidgets.ModelsReport.Views.Table;

    var getModels = tableModels.getSelectedItem(true);

    var ModelsIds = [];

    getModels.forEach(function (folder)
    {
        ModelsIds.push(folder.name);
    });

    folders.hideOverlay();

    this.Views.ReportsWidgets.FoldersReport.RefreshData(0,{
        filter:{
            model:{
                id:"model",
                operator:"in",
                value:ModelsIds
            }
        }});
};

ClassifierModelViewController.prototype.RefreshFiles = function ()
{
    var _this = this;

    clearTimeout(this.FilesRefreshTimeOut);

    this.FilesRefreshTimeOut = setTimeout(function ()
    {
        var foldersCount = _this.GetReportTableSelectedData('Folders', true).length;

        if (foldersCount)
            _this._RefreshFiles();
    }, 100);
};

ClassifierModelViewController.prototype._RefreshFiles = function ()
{
    var files = this.Views.Files;

    var tableFolders = this.Views.ReportsWidgets.FoldersReport.Views.Table;

    var getFolders = tableFolders.getSelectedItem(true);

    var FoldersIds = [];

    getFolders.forEach(function (folder)
    {
        FoldersIds.push([folder.code,folder.usedModel]);
    });

    files.hideOverlay();

    this.Views.ReportsWidgets.FilesReport.RefreshData(0,{
        filter:{
            folders:{
                id:"folders",
                operator:"in",
                value:FoldersIds
            }
        }});
};

ClassifierModelViewController.prototype.RefreshFileEditor = function ()
{
    var tableFiles = this.Views.ReportsWidgets.FilesReport.Views.Table;

    this.Views.FileEditorContent.setValue("");

    var file = tableFiles.getSelectedItem(true)[0];

    if (file)
        this.SetFileEditor(file);
};

ClassifierModelViewController.prototype.GetReportTable = function (name_report)
{
    return this.Views.ReportsWidgets[name_report+'Report'].Views.Table;
};

ClassifierModelViewController.prototype.GetReportTableData = function (name_report)
{
    return this.GetReportTable(name_report).serialize();
};

ClassifierModelViewController.prototype.GetModelsReportTableDataWithoutModel = function (AllData = false, Model = this.CutModels)
{
    var models = [];

    this.GetReportTableData('Models').forEach(function (value){
        if (!Model.includes(value.name))
            models.push(AllData?value:value.name);
    });

    return models;
};

ClassifierModelViewController.prototype.GetReportTableSelectedData = function (name_report,as_array = false)
{
    return this.GetReportTable(name_report).getSelectedItem(as_array);
};

ClassifierModelViewController.prototype.GetModelsReportTableInModel = function (ModelCut = this.CutModels)
{
    var result = false;

    this.GetReportTableSelectedData('Models', true).forEach(function (item){
        if (ModelCut.includes(item.name))
            result = true;
    });

    return result;
};

ClassifierModelViewController.prototype.FolderTableRowsSelectedCountSubscriptionHandler = function (Value, NoRefresh)
{
    if(Value > 1)
    {
        var selected = this.GetReportTableSelectedData('Folders');
        if(selected && Array.isArray(selected))
        {
            for(var i in selected)
            {
                if(selected[i].type == FolderTypeEnum.system)
                {
                    this.Views.DeleteBtn.disable();
                    return;
                }
            }
        }
    }
};



//Show forms
//Models
ClassifierModelViewController.prototype.ShowModelsEditForm = function (Data, Node, Pos)
{
    var form = this.Views.ModelsEditContextForm;

    form.clearValidation();

    form.setValues("");

    if(Data)
    {
        form.setValues(Data);
    }

    this.Views.ModelsEditContext.show(Node,{pos:Pos});
};

//Folders
ClassifierModelViewController.prototype.ShowFoldersEditForm = function (Data, Node, Pos)
{
    var form = this.Views.FoldersEditContextForm;

    form.clearValidation();

    form.setValues("");

    if(Data)
    {
        Data.folder = Data.code;
        form.setValues(Data);
    }

    //Options (models)
    var models = this.GetModelsReportTableDataWithoutModel();

    var usedModel = form.elements.usedModel;

    var list = usedModel.getList();
    list.clearAll();
    list.parse(models);

    usedModel.enable();
    form.elements.folder.enable();

    this.Views.FoldersEditContext.show(Node,{pos:Pos});
};

//Files
ClassifierModelViewController.prototype.ShowFilesEditForm = function (Data, Node, Pos)
{
    var form = this.Views.FilesEditContextForm;

    form.clearValidation();

    form.setValues(Data?Data:"");

    //Options (models)
    var models = this.GetModelsReportTableDataWithoutModel();

    var list = form.elements.usedModel.getList();
    list.clearAll();
    list.parse(models);

    var folder = form.elements.folder;
    folder.disable();
    folder.getList().clearAll();

    var data = {filter: {model: {value: [Data.usedModel]}}};

    this.ViewModel.FoldersGet(data, 'FilesEditContextForm');

    this.Views.FilesEditContext.show(Node,{pos:Pos});
};

ClassifierModelViewController.prototype.ShowFilesSetFolderForm = function (Node, Pos)
{
    var form = this.Views.FilesSetFolderContextForm;

    form.clearValidation();

    var modelsOptions = [];
    var models = this.GetModelsReportTableDataWithoutModel(true);

    models.forEach(function (value)
    {
        modelsOptions.push({value:value.name, default:value.default});
    });



    var usedModel = form.elements.usedModel;

    var modelsSelect = usedModel.getList();
    modelsSelect.clearAll();
    modelsSelect.parse(modelsOptions);

    var def = null;

    modelsSelect.data.each(function(obj){
        if (obj.default)  def = obj.id;
    });

    if (def)
        usedModel.setValue(def);

    this.Views.FilesSetFolderContext.show(Node,{pos:Pos});
};

ClassifierModelViewController.prototype.ShowFilesGetHTMLForm = function (Node, Pos)
{
    var form = this.Views.FilesGetHTMLContextForm;

    form.clearValidation();

    var host = this.GetReportTableSelectedData('Files').file;

    form.elements.url.setValue(host);

    this.Views.FilesGetHTMLContext.show(Node,{pos:Pos});
};



//Actions
//Models
ClassifierModelViewController.prototype.ModelsActionAddBtn = function ()
{
    var _this = this;

    _this.ShowModelsEditForm(null, this.Views.ModelsAddBtn.getNode(), "right");
};

//Folders
ClassifierModelViewController.prototype.FoldersActionAddBtn = function ()
{
    var _this = this;

    var model = new FileEditorModel({usedModel:this.GetReportTableSelectedData('Models').name});

    _this.ShowFoldersEditForm(model, this.Views.FoldersAddBtn.getNode(), "right");
};

//Files
ClassifierModelViewController.prototype.FilesActionAddBtn = function ()
{
    var _this = this;

    var model = new FileEditorModel(this.GetReportTableSelectedData('Folders'));

    _this.ShowFilesEditForm(model, this.Views.FilesAddBtn.getNode(), "right");
};



//Form functions
//Global

ClassifierModelViewController.prototype.DataFormats = function (form, ColumnsName = null)
{
    var cleanValues = form.getCleanValues();
    var dirtyValues = form.getValues();

    var formData = new FileEditorModel(cleanValues, ColumnsName);

    var usedModel = ColumnsName&&ColumnsName.usedModel?ColumnsName.usedModel:"usedModel";
    var folder = ColumnsName&&ColumnsName.folder?ColumnsName.folder:"folder";
    var file = ColumnsName&&ColumnsName.file?ColumnsName.file:"file";

    formData.id = dirtyValues['id']?dirtyValues['id']:0;
    formData.usedModel = {old: formData.usedModel, new: dirtyValues[usedModel]?dirtyValues[usedModel]:""};
    formData.folder = {old: formData.folder, new: dirtyValues[folder]?dirtyValues[folder]:""};
    formData.file = {old: formData.file, new: dirtyValues[file]?dirtyValues[file]:""};

    return formData;
}



//Models
ClassifierModelViewController.prototype.ModelsDuplicateForm = function ()
{
    var form = this.Views.ModelsDuplicateContextForm;

    if(!form.validate())
    {
        return;
    }

    var data = { usedModel: form.elements.usedModel.getText(), name: form.elements.name.getValue() };

    this.ViewModel.ModelsDuplicate(webix.extend(data, true));
};

ClassifierModelViewController.prototype.ModelsSetDefaultForm = function ()
{
    var form = this.Views.ModelsSetDefaultContextForm;

    if(!form.validate())
    {
        return;
    }

    var data = { id: form.getValues().usedModel, usedModel: form.elements.usedModel.getText().replaceAll(', ', ',') };

    this.ViewModel.ModelsSetDefault(webix.extend(data, true));
};

ClassifierModelViewController.prototype.ModelsSaveEditForm = function ()
{
    var form = this.Views.ModelsEditContextForm;

    if(!form.validate())
    {
        return;
    }

    this.ViewModel.ModelsSave(webix.extend(this.DataFormats(form, {usedModel:'name'}), true));
};

ClassifierModelViewController.prototype.ModelsTrashEditForm = function ()
{
    var formData = this.GetReportTableSelectedData('Models', true);

    var data = {usedModel:[]};

    formData.forEach(function (item) {
        data['usedModel'].push({idRow: item.id, name: item.name});
    });

    this.ViewModel.ModelsDelete(webix.extend(data, true));
};



//Folders
ClassifierModelViewController.prototype.FoldersSaveEditForm = function ()
{
    var form = this.Views.FoldersEditContextForm;

    if(!form.validate())
    {
        return;
    }

    this.ViewModel.FoldersSave(webix.extend(this.DataFormats(form), true));
};

ClassifierModelViewController.prototype.FoldersTrashEditForm = function ()
{
    var formData = this.GetReportTableSelectedData('Folders', true);

    var data = {};

    formData.forEach(function (item) {
        if (!data[item.usedModel]){
            data[item.usedModel] = [];
        }

        data[item.usedModel].push({ idRow: item.id, folder: item.code });
    });

    this.ViewModel.FoldersDelete(webix.extend(data, true));
};



//Files
ClassifierModelViewController.prototype.FilesSaveEditForm = function ()
{
    var form = this.Views.FilesEditContextForm;

    if(!form.validate())
    {
        return;
    }

    this.ViewModel.FilesSave(webix.extend(this.DataFormats(form), true));
};

ClassifierModelViewController.prototype.FilesTrashEditForm = function ()
{
    var formData = this.GetReportTableSelectedData('Files', true);

    var data = {};

    formData.forEach(function (item) {
        if (!data[item.usedModel]){
            data[item.usedModel] = {};
        }

        if (!data[item.usedModel][item.folder]){
            data[item.usedModel][item.folder] = [];
        }

        data[item.usedModel][item.folder].push({idRow: item.id, file: item.file});
    });

    this.ViewModel.FilesDelete(webix.extend(data, true));
};

ClassifierModelViewController.prototype.FilesEraseEditForm = function ()
{
    var formData = this.GetReportTableSelectedData('Folders', true);

    var data = {};

    formData.forEach(function (item) {
        if (!data[item.usedModel]){
            data[item.usedModel] = [];
        }

        data[item.usedModel].push(item.code);
    });

    this.ViewModel.FilesErase(webix.extend(data, true));
};

ClassifierModelViewController.prototype.FilesSaveSetFolderForm = function ()
{
    var form = this.Views.FilesSetFolderContextForm;

    if(!form.validate())
    {
        return;
    }

    this.Views.FilesSetFolderContext.hide();

    var usedModel = form.elements.usedModel.getText();
    var folder = form.elements.folder.getText();

    var selectedItems = this.GetReportTableSelectedData('Files', true);

    var data = {};

    selectedItems.forEach(function (item) {
        if (!data[item.usedModel]){
            data[item.usedModel] = {};
        }

        if (!data[item.usedModel][item.folder]){
            data[item.usedModel][item.folder] = [];
        }

        data[item.usedModel][item.folder].push({ id: item.id, file: item.file });
    });

    var formData = { usedModel: usedModel, folder: folder, data: data };

    this.GetReportTable('Files').unselectAll();

    this.ViewModel.FilesSetFolder(webix.extend(formData, true));
};

ClassifierModelViewController.prototype.FilesGetHTMLForm = function ()
{
    var form = this.Views.FilesGetHTMLContextForm;

    if(!form.validate())
    {
        return;
    }

    this.Views.FilesGetHTMLContext.hide();

    this.Views.FileEditor.showProgress({
        type:"icon",
        delay:3000
    });

    var host = form.elements.url.getValue();

    this.ViewHostsModel.GetHtmlText(webix.extend({host: host}, true));
};



ClassifierModelViewController.prototype.SetFileEditor = function ()
{
    var _this = this;

    var fileEditor = _this.Views.FileEditor;

    var tableFiles = _this.Views.ReportsWidgets.FilesReport.Views.Table;

    var file = tableFiles.getSelectedItem(true)[0];

    if(!file)
        return;

    fileEditor.hideOverlay();

    fileEditor.showProgress({
        type:"icon",
        delay:3000
    });

    this.ViewModel.SetFileEditor(webix.extend(file, true));
};



ClassifierModelViewController.prototype.FileEditorSave = function ()
{
    var _this = this;

    var fileEditor = _this.Views.FileEditor;

    var fileEditorContent = _this.Views.FileEditorContent;

    var files = _this.Views.ReportsWidgets.FilesReport.Views.Table;

    var fileSelected = files.getSelectedItem(true)[0];

    if(!fileSelected)
        return webix.message(LangHelper("Classifier", "No file selected"), "error");

    fileSelected['text'] = fileEditorContent.getValue();

    fileEditor.showOverlay(_this.GetOverflowTemplate("File saving..."));

    fileEditor.showProgress({
        type:"icon",
        delay:3000
    });

    this.ViewModel.FileEditorSave(webix.extend(fileSelected, true));
};



ClassifierModelViewController.prototype.GetOverflowTemplate = function (text = "Select file")
{
    var tpl = '<div class="of-empty-folder">' +
        ' <div class="of-empty-pad">' +
        '     <div class="of-empty-cloud-txt">'+LangHelper.GetString("All", text)+'</div>' +
        ' </div>' +
        '</div>';

    return tpl;
};


ClassifierModelViewController.prototype.ShowServerError = function (ErrorModel)
{
    webix.message({text:ErrorModel.msg, type:"error", expire: 30000});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrorModel.msg,
        type:"alert-error",
        width:400
    });
};



ClassifierModelViewController.prototype.EnableProgressForButton = function (Btn)
{
    if(Btn.config.icon == "spinner-third")
        return;

    Btn.config.type_was = Btn.config.type ? Btn.config.type : "";
    Btn.define("icon","spinner-third");
    Btn.define("type","icon");
    Btn.define("css","btn_icon_spin");
    Btn.refresh();
};

ClassifierModelViewController.prototype.DisableProgressForButton = function (Btn, icon = "")
{
    if(Btn.config.icon != "spinner-third")
        return;

    Btn.define("icon",icon);
    Btn.define("type", Btn.config.type_was ? Btn.config.type_was : "");
    Btn.define("css","");
    webix.html.removeCss(Btn.getNode(), "btn_icon_spin");
    Btn.refresh();
};

ClassifierModelViewController.prototype.btnDisable = function (name, btn)
{
    if (this.CutModels.includes(name))
    {
        btn.disable();
    }else
    {
        btn.enable();
    }
};
function ClassifierConfigViewController(Params)
{
    var _this = this;

    this.Id = "ClassifierConfig";

    this.mode = module ? module : "dpiui2";

    this.ViewModel = new ClassifierConfigManager();

    this.ModelsViewModel = new ClassifierModelManager();

    this.ViewConfig = [
        {
            cols:[
                ClassifierLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows: [
                                PageHeaderTemplate({root_title: LangHelper.GetString("AppView", "Classifier"), title: LangHelper.GetString("AppView", "Server configuration")}),
                                {
                                    rows:[
                                        {
                                            view: "toolbar",
                                            height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                            elements: [
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "floppy-o",
                                                    label: LangHelper.GetString("AppView", "Save"),
                                                    css: "toolbar_round_btn",
                                                    width: 128,
                                                    tooltip: LangHelper.GetString("AppView", "Save"),
                                                    click: function (id, e, node)
                                                    {
                                                        var __this = this;
                                                        setTimeout(function ()
                                                        {
                                                            _this.ConfigSave();
                                                            _this.SetGrantAllPrivileges();
                                                        }, 1);
                                                    }
                                                },
                                                {
                                                    view: "button",
                                                    id:this.Id + "RestartBtn",
                                                    type: "icon",
                                                    icon: "retweet",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString("AppView", "Restart"),
                                                    click: function (id, e, node)
                                                    {
                                                        _this.Views.RestartQuestion.show(this.getNode());
                                                    }
                                                },
                                                {},
                                                {
                                                    view: "button",
                                                    type: "icon",
                                                    icon: "refresh",
                                                    css: "toolbar_round_btn",
                                                    width: 32,
                                                    tooltip: LangHelper.GetString(this.Id,"Refresh"),
                                                    click: function (id, e, node)
                                                    {
                                                        if(_this.mode == "dpiui2" || _this.mode == "vascloud")
                                                        {
                                                            _this.Refresh();
                                                        }

                                                        if(_this.mode == "li")
                                                        {
                                                            _this.CheckHealth();
                                                        }
                                                    }
                                                },
                                                {
                                                    width:16
                                                },
                                                function(){
                                                    var tabbar = {
                                                        view:"tabbar",
                                                        id:_this.Id + "Editor" + "Tabs",
                                                        tabMoreWidth:0,
                                                        value:_this.Id + "Editor",
                                                        multiview:true,
                                                        //height:webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.tabbarSmallHeight : webix.skin.material.tabbarHeight,
                                                        options: [
                                                            {
                                                                id: _this.Id + "Editor",
                                                                "value": "<span class='webix_icon fa-trello'></span> "+LangHelper.GetString("All","The form")
                                                            },
                                                            {
                                                                id: _this.Id + "Editor" + "Code",
                                                                "value": "<span class='webix_icon fa-code'></span> "+LangHelper.GetString("All","Editor")
                                                            }
                                                        ],
                                                        on:{
                                                            "onChange":function(Id, OldId)
                                                            {
                                                                if(Id == _this.Id + "Editor" + "Code")
                                                                {
                                                                    setTimeout(function ()
                                                                    {
                                                                        _this.Views.CodeEditor.setValue(_this.ViewModel.GetConfig());
                                                                    },1);
                                                                }

                                                                if(Id == _this.Id + "Editor")
                                                                {
                                                                    setTimeout(function ()
                                                                    {
                                                                        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                    },1);
                                                                }
                                                            }
                                                        }
                                                    };

                                                    if(webix.skin.$name === "dpiui2_vulkan" || webix.skin.$name === "dpiui2_vulkan")
                                                    {
                                                        tabbar = {
                                                            rows:[
                                                                {},
                                                                tabbar
                                                            ]
                                                        };
                                                    }

                                                    return tabbar;
                                                }()
                                            ]
                                        },
                                        {
                                            id:_this.Id + "FormPanel",
                                            rows:[
                                                {
                                                    cells:[
                                                        {
                                                            id: this.Id + "Editor",
                                                            cols: [
                                                                {
                                                                    width: 400,
                                                                    rows: [
                                                                        BlockHeaderTemplate({title: LangHelper.GetString("All","Settings"), icon: "cogs"}),
                                                                        {
                                                                            view: "datatable",
                                                                            header:false,
                                                                            select: "row",
                                                                            on: {
                                                                                onAfterSelect: function (data, preserve) {
                                                                                    if($$(_this.Id + "Group_"+data.id))
                                                                                    {
                                                                                        $$(_this.Id + "Group_"+data.id).show();

                                                                                        var data = this.getItem(data.id);
                                                                                        if(data.url)
                                                                                        {
                                                                                            _this.Views.WiKi.load(data.url);
                                                                                        }
                                                                                    }
                                                                                }
                                                                            },
                                                                            columns: [
                                                                                {
                                                                                    id: "value",
                                                                                    fillspace: true
                                                                                }
                                                                            ],
                                                                            data: ClassifierConfigManager.GetSortedEnvConfigGroupDicArr()
                                                                        }
                                                                    ]
                                                                },
                                                                {view: "resizer"},
                                                                {
                                                                    rows: [
                                                                        {
                                                                            view:"multiview",
                                                                            id: this.Id + "Groups",
                                                                            cells:function ()
                                                                            {
                                                                                var cells = [];

                                                                                ClassifierConfigManager.GetSortedEnvConfigGroupDicArr().forEach(function (Obj)
                                                                                {
                                                                                    var rows = [];

                                                                                    rows.push(BlockHeaderTemplate({
                                                                                        title: Obj.value,
                                                                                        icon: "cog"
                                                                                    }));

                                                                                    if(Obj.id == "1")
                                                                                    {
                                                                                        rows.push(_this.ViewsForReceiversGroup(Obj.id))
                                                                                    }else{
                                                                                        rows.push({
                                                                                            id:_this.Id + "Group_" + Obj.id + "_form",
                                                                                            view:"form",
                                                                                            scroll:true,
                                                                                            elements:_this.ViewsFromDicForGroup(Obj.id)
                                                                                        });

                                                                                        if (Obj.id == "3"){
                                                                                            _this.ModelsViewModel.ModelsGet();
                                                                                        }
                                                                                    }

                                                                                    //rows.push({});

                                                                                    cells.push({
                                                                                        id: _this.Id + "Group_" + Obj.id,
                                                                                        rows:rows
                                                                                    });
                                                                                });

                                                                                return cells;

                                                                            }()
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id:this.Id + "Editor" + "Code",
                                                            rows:[
                                                                {
                                                                    view:"codemirror-editor",
                                                                    id:this.Id + "Editor" + "Code" + "Codetree",
                                                                    value:""
                                                                },
                                                                {
                                                                    view:"toolbar",
                                                                    borderless:true,
                                                                    elements:[
                                                                        {
                                                                            view:"checkbox",
                                                                            id:this.Id + "Editor" + "Code" + "ShowCommentsCheckbox",
                                                                            labelRight:LangHelper.GetString("DpiConfig", "Show comments"),
                                                                            labelWidth:0,
                                                                            on:
                                                                                {
                                                                                    "onChange":function(NewVal, OldVal)
                                                                                    {
                                                                                        App.SessionManager.SetPreference("ClassifierConfigManager:ShowComments",NewVal);

                                                                                        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                        _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                                                                                    }
                                                                                }
                                                                        },
                                                                        {
                                                                            view:"checkbox",
                                                                            id:this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox",
                                                                            labelRight:LangHelper.GetString("DpiConfig", "Show all params"),
                                                                            labelWidth:0,
                                                                            on:
                                                                                {
                                                                                    "onChange":function(NewVal, OldVal)
                                                                                    {
                                                                                        App.SessionManager.SetPreference("ClassifierConfigManager:ShowAllParams", NewVal);

                                                                                        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
                                                                                        _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                                                                                    }
                                                                                }
                                                                        },
                                                                        {
                                                                            gravity:2
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    this.EditReceiverContextFormConfig = {
        view:"popup",
        width:320,
        modal:true,
        body:
            {
                view:"form",
                id:this.Id + "EditReceiverContextForm",
                borderless:true,
                elements:function(){
                    var els = [];

                    Object.keys(ClassifierEnvConfigReceiverDic).forEach(function (Key)
                    {
                        els.push(Helper.ViewFromDpiConfigDic(Key, ClassifierEnvConfigReceiverDic));
                    });

                    els.push({
                        cols:[
                            {},
                            {
                                view:"button",
                                label:LangHelper.GetString("All", "Cancel"),
                                click: function ()
                                {
                                    _this.HideReceiverEditForm();
                                }
                            },
                            {
                                view:"button",
                                label:LangHelper.GetString("All", "Apply"),
                                type:"form",
                                click: function ()
                                {
                                    _this.ApplyReceiverEditForm();
                                }
                            }
                        ]
                    });

                    return els;
                }()
            }
    };

    this.Subscriptions = {};

    this.CutModels = [];

    this.Views = {
        EditorTabs:null,
        CodeEditor:null,
        FormsGroups:{},
        ValidationDataContextCodeEditor:null,
        ImportContextCodeEditor:null,
        ImportContextUploader:null,
        HistoryTable:null,
        HistoryEditor:null,
        HistoryForwardBtn:null,
        HistoryBackBtn:null,
        RestartBtn:null,
        ShowCommentsCheckbox:null,
        ShowAllParamsCheckbox:null,

        ReceiversTable:null,
        AddReceiverBtn:null,

        EditReceiverContextFormPopup:null,
        EditReceiverContextForm:null,

        RestartQuestion:webix.ui({
            view:"popup",
            width:400,
            height:160,
            modal:true,
            body:{
                view:"form",
                borderless:true,
                elements:[
                    {
                        template:LangHelper.GetString("QoEStorConfig","Do you want to restart configuration?")
                    },
                    {
                        cols:[
                            {},
                            {
                                view:"button",
                                label:LangHelper.GetString(this.Id,"Cancel"),
                                click:function () {
                                    _this.Views.RestartQuestion.hide();
                                }
                            },
                            {
                                view:"button",
                                type:"form",
                                label:LangHelper.GetString("AppView", "Restart"),
                                click:function ()
                                {
                                    _this.Views.RestartQuestion.hide();
                                    _this.Restart();
                                }
                            }
                        ]
                    }
                ]
            }
        }),
        RestartQuestionAfterConfigSaved:webix.ui({
            view:"popup",
            width:400,
            height:160,
            modal:true,
            body:{
                view:"form",
                borderless:true,
                elements:[
                    {
                        template:LangHelper.GetString("DpiConfig","Configuration saved") + ".<br/><br/>" +
                            LangHelper.GetString("QoEStorConfig","Do you want to restart configuration?")
                    },
                    {
                        cols:[
                            {},
                            {
                                view:"button",
                                label:LangHelper.GetString(this.Id,"Cancel"),
                                click:function () {
                                    _this.Views.RestartQuestionAfterConfigSaved.hide();
                                }
                            },
                            {
                                view:"button",
                                type:"form",
                                label:LangHelper.GetString("AppView", "Restart"),
                                click:function ()
                                {
                                    _this.Views.RestartQuestionAfterConfigSaved.hide();
                                    _this.Restart();
                                }
                            }
                        ]
                    }
                ]
            }
        }),
        RestartLogPopup:webix.ui({
            view:"popup",
            maxWidth:800,
            height:"auto",
            modal:true,
            body:{
                view:"form",
                borderless:true,
                elements:[
                    {
                        view:"codemirror-editor",
                        id:this.Id + "RestartLog",
                        value:""
                    },
                    {
                        cols:[
                            {
                                gravity:3
                            },
                            {
                                view:"button",
                                type:"form",
                                label:"Ok",
                                click:function ()
                                {
                                    _this.Views.RestartLogPopup.hide();
                                    _this.Views.RestartLog.setValue("");
                                }
                            }
                        ]
                    }
                ]
            }
        }),
        RestartLog:$$(this.Id + "RestartLog")
    };
}

ClassifierConfigViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.FormPanel = $$(this.Id + "FormPanel");
    webix.extend(this.Views.FormPanel, webix.OverlayBox);

    this.Views.RestartBtn = $$(this.Id + "RestartBtn");

    this.Views.CodeEditor = $$(this.Id + "Editor" + "Code" + "Codetree");
    this.Views.EditorTabs = $$(this.Id + "Editor" + "Tabs");

    this.Views.ShowCommentsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowCommentsCheckbox");
    this.Views.ShowAllParamsCheckbox = $$(this.Id + "Editor" + "Code" + "ShowAllParamsCheckbox");

    this.Views.ShowCommentsCheckbox.blockEvent();
    this.Views.ShowCommentsCheckbox.setValue(App.SessionManager.GetPreference("ClassifierConfigManager:ShowComments"));
    this.Views.ShowCommentsCheckbox.unblockEvent();

    this.Views.ShowAllParamsCheckbox.blockEvent();
    this.Views.ShowAllParamsCheckbox.setValue(App.SessionManager.GetPreference("ClassifierConfigManager:ShowAllParams"));
    this.Views.ShowAllParamsCheckbox.unblockEvent();

    this.Views.ReceiversTable = $$(this.Id + "ReceiversTable");
    this.Views.AddReceiverBtn = $$(this.Id + "AddReceiverBtn");

    this.Views.EditReceiverContextFormPopup = webix.ui(this.EditReceiverContextFormConfig);
    this.Views.EditReceiverContextForm = $$(this.Id + "EditReceiverContextForm");

    ClassifierConfigManager.GetSortedEnvConfigGroupDicKeysArr().forEach(function (Key)
    {
        var formId = _this.Id + "Group_"+Key+"_form";
        if($$(formId))
        {
            _this.Views.FormsGroups[formId] = $$(formId);
        }
    });

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        _this.Views.FormsGroups[Key].attachEvent("onChange", function(newv, oldv)
        {
            _this.ViewModel.SetConfigModel(_this.GetFormsValues());
        });
    });

    this.Subscriptions.ConfigUpdated = this.ViewModel.Signals.ConfigFileUpdated.subscribe(function (V)
    {
        if (V)
        {
            _this.DefineForms();
        }
    });



    this.Subscriptions.ClassifierModelModelsGet = this.ModelsViewModel.Signals.ClassifierModelModelsGet.subscribe(function (Model) {
        if (Model)
        {
            var models = [];

            Model.rows.forEach(function (value){
                models.push(value.name);
            });

            var CFG_SITES_CLSFR_MODEL = $$('ClassifierConfigGroup_3_form').elements.CFG_SITES_CLSFR_MODEL;

            var form = CFG_SITES_CLSFR_MODEL.getList();

            form.clearAll();
            form.parse(models);

            CFG_SITES_CLSFR_MODEL.enable();
        }
    });

    this.Subscriptions.ClassifierModelModelsGetError = this.ModelsViewModel.Signals.ClassifierModelModelsGetError.subscribe(function (Model) {
        if (Model)
        {
            _this.ShowServerError(Model);
        }
    });

    $$('ClassifierConfigGroup_3_form').elements.CFG_SITES_CLSFR_MODEL.disable();
};

ClassifierConfigViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll(Params);

    _this.Refresh();

    this.CheckClsfrVersionCompatibility();
};

ClassifierConfigViewController.prototype.Destroy = function ()
{
    var _this = this;

    App.NavRouter.HideProgress();

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });


    if(this.ViewModel)
        this.ViewModel.Destroy();
    delete this.ViewModel;
};

ClassifierConfigViewController.prototype.Refresh = function ()
{
    var _this = this;

    App.NavRouter.ShowProgress();

    this.ViewModel.Refresh({callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig", "Configuration loaded"));
                _this.Views.FormPanel.hideOverlay();
            }
            else
            {
                _this.ShowServerError(R.error);

                _this.Views.FormPanel.showOverlay("<br/><br/><br/>"+R.error.msg);
            }
        }});
};

ClassifierConfigViewController.prototype.ViewFromDic = function (DicId)
{
    return Helper.ViewFromDpiConfigDic(DicId, ClassifierEnvConfigDic);
};

ClassifierConfigViewController.prototype.ViewsFromDicForGroup = function (GroupId)
{
    var _this = this;

    var views = [];

    ClassifierConfigManager.GetSortedEnvConfigDicKeysArr().forEach(function (Key)
    {
        if(ClassifierEnvConfigDic[Key].group == GroupId && ClassifierEnvConfigDic[Key].view)
        {
            views.push(_this.ViewFromDic(Key));
        }
    });

    views.push({});

    return views;
};

ClassifierConfigViewController.prototype.ViewsForReceiversGroup = function (GroupId)
{
    var _this = this;

    var views = {
        rows:[
            {
                view: "toolbar",
                elements:[
                    {
                        view: "button",
                        id:this.Id + "AddReceiverBtn",
                        type: "icon",
                        icon: "plus",
                        align: "right",
                        width: 32,
                        css:"toolbar_round_btn",
                        tooltip:LangHelper.GetString(this.Id,"Add receiver"),
                        click: function (id, e, node)
                        {
                            _this.OnAddReceiverBtnClick(this.getNode());
                        }
                    }
                ]
            },
            {
                view:"datatable",
                id:this.Id + "ReceiversTable",
                resizeColumn: true,
                select: "row",
                //editable: true,
                headermenu: false,
                columns:function(){
                    var cols = [];

                    cols.push(
                        {
                            id: "edit",
                            header: "",
                            width: 32,
                            template: CellEditBtnTemplate,
                            headermenu: false,
                            align:"right"
                        }
                    );

                    Object.keys(ClassifierEnvConfigReceiverDic).forEach(function (Key)
                    {
                        cols.push(
                            {
                                id:ClassifierEnvConfigReceiverDic[Key].id,
                                header:[{text: TooltipTemplate(ClassifierEnvConfigReceiverDic[Key].value, null, null, "question-circle")}],
                                editor:ClassifierEnvConfigReceiverDic[Key].view,
                                options:ClassifierEnvConfigReceiverDic[Key].options?Helper.DictToArr(ClassifierEnvConfigReceiverDic[Key].options):null,
                                fillspace:1
                            }
                        );
                    });

                    cols.push(
                        {
                            id: "trash",
                            header: "",
                            width: 32,
                            template: CellTrashBtnTemplate,
                            headermenu: false,
                            align:"right"
                        }
                    );

                    return cols;
                }(),
                on:{
                    onHeaderClick:function(id, e, node)
                    {
                        if(e.target.className == "webix_icon webix_el_icon fa-question-circle")
                        {
                            var map = {};

                            Object.keys(ClassifierEnvConfigReceiverDic).forEach(function(Key)
                            {
                                map[ClassifierEnvConfigReceiverDic[Key].id] = Key;
                            });

                            _this.ShowHelpPopup(ClassifierEnvConfigReceiverDic[map[id.column]].tooltip, node, ClassifierEnvConfigReceiverDic[map[id.column]].tooltipHeight);
                        }
                    },
                    onItemClick: function (id,e,node)
                    {
                        var __this = this;

                        if(id.column === 'trash')
                        {
                            this.remove(id);

                            setTimeout(function ()
                            {
                                _this.ViewModel.SetConfigModel(_this.GetFormsValues());
                            },1);
                        }

                        if(id.column === 'edit')
                        {
                            setTimeout(function ()
                            {
                                _this.ShowReceiverEditForm(__this.getItemNode(id), "right");
                            },1);
                        }
                    },
                    onItemDblClick: function (id,e,node)
                    {
                        var __this = this;

                        setTimeout(function ()
                        {
                            _this.ShowReceiverEditForm(__this.getItemNode({column:"edit", row:id.row}), "right");
                        },1);
                    }
                }
            }
        ]
    };

    return views;
};

ClassifierConfigViewController.prototype.DefineForms = function ()
{
    var _this = this;

    this.Views.CodeEditor.setValue(this.ViewModel.GetConfig());

    this.DefineReceiversForms();

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        _this.Views.FormsGroups[Key].setValues(_this.ViewModel.GetConfigModel());
    });
};

ClassifierConfigViewController.prototype.DefineReceiversForms = function ()
{
    var configModel = this.ViewModel.GetConfigModel();

    var rows = [];

    function ParseRows(ReceiverType)
    {
        var i = 0;

        while (configModel[ReceiverType + "_PORT_TYPE[" + i + "]"])
        {
            var row = new IpfixReceiverConfigRowModel();

            Object.keys(row).forEach(function (Key)
            {
                var id = ReceiverType + "_" + Key + "[" + i + "]";

                if(configModel[id])
                    row[Key] = configModel[id];
            });

            rows.push(row);

            i++;
        }
    }

    ParseRows(ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM);

    this.Views.ReceiversTable.clearAll();

    this.Views.ReceiversTable.parse(rows);
};

ClassifierConfigViewController.prototype.GetFormsValues = function ()
{
    var _this = this;

    var configModel = this.GetReceiversFormsValues();

    Object.keys(this.Views.FormsGroups).forEach(function (Key)
    {
        Object.keys(_this.Views.FormsGroups[Key].elements).forEach(function (ElKey)
        {
            var el = _this.Views.FormsGroups[Key].elements[ElKey];

            configModel[ElKey] = el.getValue();
        });
    });

    return configModel;
};

ClassifierConfigViewController.prototype.GetReceiversFormsValues = function ()
{
    var _this = this;

    var configModel = {};

    var rows = this.Views.ReceiversTable.serialize();

    var index = {};

    index[ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM] = 0;

    rows.forEach(function (Row, Index)
    {
        var type = ClassifierIpfixReceiverTypesEnum.IPFIX_CLICKSTREAM;

        var model = new IpfixReceiverConfigModel(Row,index[type]);

        Object.keys(model).forEach(function (Key)
        {
            configModel[Key] = model[Key]
        });

        index[type]++;
    });

    return configModel;
};

ClassifierConfigViewController.prototype.ConfigSave = function (Params)
{
    var _this = this;

    if(_this.Views.EditorTabs.getValue() == _this.Id + "Editor" + "Code")
    {
        _this.ViewModel.SetConfig(_this.Views.CodeEditor.getValue());
    }

    App.NavRouter.ShowProgress();

    this.ViewModel.Save({callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Configuration saved"));

                _this.Views.RestartQuestionAfterConfigSaved.show(_this.Views.RestartBtn.getNode());
            }
            else
            {
                //webix.message({type:"error", text:R.error.msg});
                _this.ShowServerError(R.error);
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }});
};

ClassifierConfigViewController.prototype.SetGrantAllPrivileges = function (Params)
{
    var _this = this;

    App.NavRouter.ShowProgress();

    this.ViewModel.SetGrantAllPrivileges({callback:function (R)
        {
            App.NavRouter.HideProgress();

            if(R.success)
            {
                webix.message(LangHelper.GetString("DpiConfig","Granted all privileges successfully"));
            }
            else
            {
                //webix.message({type:"error", text:R.error.msg});
                _this.ShowServerError(R.error);
            }

            if(Params && Params.callback && typeof Params.callback === "function")
            {
                Params.callback(R);
            }
        }});
};

ClassifierConfigViewController.prototype.OnAddReceiverBtnClick = function(Node)
{
    var _this = this;

    _this.Views.ReceiversTable.unselect();

    setTimeout(function ()
    {
        _this.ShowReceiverEditForm(Node, "bottom");
    },1);
};

ClassifierConfigViewController.prototype.ShowHelpPopup = function(Text, Node, Height)
{
    webix.ui({
        view:"popup",
        height:Height,
        body:{
            borderless:true,
            template:Text
        }
    }).show(Node);
};

ClassifierConfigViewController.prototype.ShowReceiverEditForm = function (Node, Pos)
{
    var data = this.Views.ReceiversTable.getSelectedItem();

    if(!data)
        data = new IpfixReceiverConfigRowModel();

    this.Views.EditReceiverContextForm.clear();

    this.Views.EditReceiverContextForm.clearValidation();

    this.Views.EditReceiverContextForm.setValues(data);

    this.Views.EditReceiverContextFormPopup.show(Node,{pos:Pos});
};

ClassifierConfigViewController.prototype.HideReceiverEditForm = function ()
{
    this.Views.EditReceiverContextFormPopup.hide();
};

ClassifierConfigViewController.prototype.ValidateReceiverEditForm = function ()
{
    return this.Views.EditReceiverContextForm.validate();
};

ClassifierConfigViewController.prototype.ApplyReceiverEditForm = function ()
{
    var _this = this;

    if(!this.ValidateReceiverEditForm())
        return;

    var tableData = this.Views.ReceiversTable.getSelectedItem();

    var formdata = this.Views.EditReceiverContextForm.getValues();

    if(!tableData)
    {
        tableData = new IpfixReceiverConfigRowModel();
        this.Views.ReceiversTable.add(tableData);
        this.Views.ReceiversTable.select(tableData.id, false);
    }
    this.Views.ReceiversTable.updateItem(tableData.id,  new IpfixReceiverConfigRowModel(formdata));

    setTimeout(function ()
    {
        _this.ViewModel.SetConfigModel(_this.GetFormsValues());
    },1);

    _this.HideReceiverEditForm();
};

ClassifierConfigViewController.prototype.Restart = function ()
{
    var _this = this;

    this.ViewModel.Restart({
        callback:function (R)
        {
            if(R.data)
            {
                _this.Views.RestartLogPopup.show(_this.Views.RestartBtn.getNode(),{pos:"right"});
                _this.Views.RestartLog.setValue(R.data);
            }

            if(R.success)
            {
                webix.message(LangHelper.GetString("ClassifierConfig", "Restart finished"));
            }
            else
            {
                //webix.message({type:"error", text:R.error.msg, expire:30000});
                _this.ShowServerError(R.error);
            }
        }
    });
};

ClassifierConfigViewController.prototype.ShowServerError = function (ErrModel)
{
    if(!ErrModel)
        return;

    webix.message({type:"error", text:ErrModel.msg});

    webix.alert({
        title: LangHelper.GetString("All", "Error"),
        text: ErrModel.msg,
        type:"alert-error",
        width:400
    });
};

ClassifierConfigViewController.prototype.CheckClsfrVersionCompatibility = function()
{
    this.ViewModel.CheckClsfrVersionCompatibility(function (R)
    {
        if(R&&R.success)
        {
            if(!R.data.is_compatible)
            {
                $text = LangHelper.GetString("Classifier", "Classifier version is not compatible. It should be [COMPATIBLE_VERSION]+. The current is [CURRENT_VERSION].");
                $text = $text.replace("[COMPATIBLE_VERSION]", R.data.compatible_version);
                $text = $text.replace("[CURRENT_VERSION]", R.data.current_version);

                webix.message({type:"error", text:$text, expire: 10000});
            }
        }else if(R && R.error)
        {
            webix.message({type:"error", text:R.error.msg, expire: 10000});
        }
    });
};
function ClassifierLogsViewController(Params)
{
    this.Id = "ClassifierLogs";

    var params = webix.extend(Params,{
        Id:this.Id,
        LeftSideBar:ClassifierLeftSideBarView({id:this.Id}),
        PageTitle:{
            RootTitle: LangHelper.GetString("AppView", "Classifier"),
            Title: LangHelper.GetString("AppView", "Logs")
        },
        ServerMethods:
        {
            RefreshLogsFilesList:"Clsfr_GetLogsFilesList",

            GetLogFileTail:"Clsfr_GetLogFileTail",

            DownloadLogFile:"Clsfr_DownloadLogFile"
        },
        PathsNamesMap:
        {
            "clickstream":"Clickstream",
            "sites_clsfr":"Sites classifier"
        }
    },true);

    ClassifierLogsViewController.superclass.constructor.call(this, Params);
}

Helper.ExtendClass(ClassifierLogsViewController,HardwareLogsViewController);

var ClassifierLeftSideBarView = function (Params)
{
    return LeftSideBarView([
        {id: "Classifier", icon: "sitemap", value: LangHelper.GetString("Classifier", "Hosts Categories"), href:"#Classifier", section:RoleSectionsEnum.sites_clsfr},
        {id: "ClassifierModel", icon: "hexagon", value: LangHelper.GetString("Classifier", "Classifier model"), href:"#ClassifierModel", section:RoleSectionsEnum.sites_clsfr_model},
        {id: "ClassifierConfig", icon: "server", value: LangHelper.GetString(this.id, "Configuration"), href:"#ClassifierConfig", section:RoleSectionsEnum.sites_clsfr_admin},
        {id: "ClassifierLogs", icon: "stack-overflow", value: LangHelper.GetString(this.Id, "Logs"), href:"#ClassifierLogs", section:RoleSectionsEnum.sites_clsfr_admin}
    ], "Classifier", Params);
};
var TERMINAL_BUFFER_MAX_SIZE = 1000;

function SshTerminalWidget(ViewConfig)
{
    var _this = this;

    this.Id = null;

    this.ViewConfig = null;
    this.ViewController = null;

    this.ViewModel = null;

    this.SocketRoom = null;
    this.SocketRoomId = null;

    this.HardwareId = null;
    this.HardwareModel = null;

    this.Views = {
        Command: null,
        Commands: null,
        TerminalContent: null,
        ExecuteButton: null,
        ScrollView: null
    };

    this.TerminalViews = {
        TerminalContent: null,
        TerminalContentWrap: null
    };

    this.TerminalContent = "";

    this.Subscriptions = {};
    this.Signals = {
        InputChange: new Rx.BehaviorSubject(false),
        TerminalReady: new Rx.BehaviorSubject(false)
    };

    this.RenderTimeout = null;
    this.BufferProcessingInterval = null;
    this.DisplayInput = false;
    this.OnViewShow = false;
    this.Buffer = [];
    this.Command = "";
    this.Ansi = null;
    this.UseDics = false;
    this.Init(ViewConfig);
};

SshTerminalWidget.prototype.Init = function(ViewConfig)
{
    var _this = this;

    if(!ViewConfig)
        return;

    this.Id = "SshTerminal" + (ViewConfig.id ? ViewConfig.id : webix.uid());

    this.HardwareId = ViewConfig.hardware ? ViewConfig.hardware : null;
    this.HardwareModel = ViewConfig.model ? ViewConfig.model : null;
    this.UseDics = ViewConfig.useDics ? ViewConfig.useDics: false;
    this.OnViewShow = ViewConfig.onViewShow ? ViewConfig.onViewShow : false;
    this.DisplayInput = ViewConfig.displayInput ? ViewConfig.displayInput : false;

    this.SocketRoom = "SshTerminal" + webix.uid();
    this.Ansi = new AnsiUp;
    this.ViewModel = new SshTerminalManager({hardware_type: this.HardwareModel.hardware_type});
    this.ViewConfig = {
        id: this.Id,
        view: "accordion",
        multi: _this.UseDics ? "mixed" : false,
        on:{
            onAfterExpanded: function()
            {
                // _this.PolicingCaptiveView.RefreshViews();
                // _this.PolicingWifiView.RefreshViews();
                return true;
            }
        },
        cols: function(){
            var cols = [
                {
                    header: LangHelper.GetString("SshTerminal", "Terminal"),
                    gravity: 3,
                    body:{
                        rows: function(){
                            var rows = [
                                {
                                    view: "toolbar",
                                    height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                    //borderless:true,
                                    elements: [
                                        {
                                            view: "button",
                                            type: "icon",
                                            width: 32,
                                            icon: "broom",
                                            hotkey: "ctrl+l",
                                            css:"toolbar_round_btn",
                                            tooltip: LangHelper.GetString("SshTerminal", "Clear"),
                                            click:function ()
                                            {
                                                _this.SendTerminalClearCommand();
                                                // _this.Views.TerminalContent.setValue('');
                                            }
                                        },
                                        {
                                            view: "button",
                                            type: "icon",
                                            width: 32,
                                            icon: "stop",
                                            hotkey: "ctrl+c",
                                            css:"toolbar_round_btn",
                                            tooltip: LangHelper.GetString("SshTerminal", "Stop"),
                                            click:function ()
                                            {
                                                _this.StopProcessingCommand();
                                                // _this.Views.TerminalContent.setValue('');
                                            }
                                        }
                                    ]
                                },
                                {
                                    id: _this.Id + "ScrollView",
                                    view: "scrollview",
                                    scroll: "y",
                                    body:{
                                        rows: [
                                            {
                                                id:_this.Id + "TerminalContent",
                                                view: "template",
                                                autoheight: true,
                                                data: {
                                                    content: _this.TerminalContent
                                                },
                                                template: function(obj){
                                                    return "<div id='" + _this.Id + "TerminalContent' class='terminal-content'>" +
                                                        obj.content +
                                                        "</div>";
                                                    // return "<div id='" + _this.Id + "TerminalContentWrap' class='terminal-content-view'>" +
                                                    //     "<div id='" + _this.Id + "TerminalContent' class='terminal-content'>" +
                                                    //         obj.content +
                                                    //     "</div>" +
                                                    //     "</div>";
                                                }
                                            }
                                        ]
                                    }
                                },
                            ];

                            if(_this.DisplayInput)
                            {
                                rows.push({view:"resizer"});
                                rows.push({
                                    cols:[
                                        {
                                            id: _this.Id + "Command",
                                            view:"textarea",
                                            label:null,
                                            height:56
                                        },
                                        {
                                            id: _this.Id + "ExecuteButton",
                                            view: "button",
                                            type: "icon",
                                            icon: "bolt",
                                            hotkey: "enter",
                                            label:LangHelper.GetString("SshTerminal", "Execute"),
                                            css:"toolbar_round_btn",
                                            width:120,
                                            tooltip:LangHelper.GetString("SshTerminal", "Execute"),
                                            click:function ()
                                            {
                                                if(_this.Views.Command)
                                                    _this.ProcessCommand(_this.Views.Command.getValue());
                                            }
                                        }
                                    ]
                                });
                            }

                            return rows;
                        }()
                    }
                }
            ];

            if(_this.UseDics)
            {
                cols.push({view:"resizer"});
                cols.push({
                    header: LangHelper.GetString("SshTerminal", "Commands"),
                    collapsed:true,
                    gravity: 2,
                    body:{
                        rows: [
                            {
                                view:"search",
                                placeholder:LangHelper.GetString("All","Search"),
                                on: {
                                    onTimedKeyPress: function(code, e)
                                    {
                                        var __this = this;
                                        setTimeout(function(){
                                            _this.FilterCommands(__this.getValue());
                                        },10);
                                    }
                                },
                                keyPressTimeout:500
                                // width: 300
                            },
                            {
                                view: "treetable",
                                id: _this.Id + "Commands",
                                header: false,
                                select: "row",
                                columns: [
                                    {
                                        id:"title",
                                        fillspace:true,
                                        template: function(obj, common, value, config)
                                        {
                                            var str = common.treetable(obj, common, value, config) + (obj.icon ? "<span class='webix_icon fa-" + obj.icon + "'></span>" : "") + (obj.title ? obj.title : "");

                                            return str;
                                        }
                                    },
                                    {
                                        id: "exec",
                                        header: "",
                                        width: 32,
                                        template: function (obj, common, value, config)
                                        {
                                            if(!obj.command)
                                            {
                                                return "";
                                            }
                                            return CellBoltBtnTemplate();
                                        }
                                    },
                                    {
                                        id: "info",
                                        width: 40,
                                        template: function(obj, common, value, config)
                                        {
                                            if(obj && obj.description && obj.gui)
                                            {
                                                if(obj.gui.popup && obj.gui.popup.show)
                                                {
                                                    return CellQuestionBtnTemplate();
                                                }
                                            }
                                            return "";
                                        }
                                    }
                                ],
                                onClick: {
                                    "fa-bolt-circle": function(ev,id)
                                    {
                                        var item = this.getItem(id);
                                        setTimeout(function(){
                                            _this.ExecCommand(item);
                                        }, 1);

                                        return false;
                                    },
                                    "fa-question-circle": function(ev, id)
                                    {
                                        var item = this.getItem(id);
                                        var node = this.getItemNode(id);

                                        var body =  {
                                            borderless:true,
                                            template:item.gui.popup.use_description ? item.description : (item.gui.popup.text ? item.gui.popup.text : "")
                                        };

                                        if(item.wiki)
                                        {
                                            body.template += "<br/><a href='" + item.wiki + "' target='blank'>" + LangHelper.GetString("Dics", "More...") + "</a>"
                                        }

                                        var popup = webix.ui({
                                            view:"popup",
                                            height:item.gui.popup.height?item.gui.popup.height:0,
                                            body:body
                                        });

                                        popup.show(node);

                                        return false;
                                    }
                                },
                                on: {
                                    // onItemClick: function(id, e, node)
                                    // {
                                    //     if(id.column == "exec")
                                    //     {
                                    //         var item = this.getItem(id);
                                    //         if(item.command)
                                    //         {
                                    //             setTimeout(function(){
                                    //                 _this.ExecCommand(item);
                                    //             }, 1);
                                    //         }
                                    //
                                    //     }
                                    // },
                                    onItemDblClick: function(id, ev)
                                    {
                                        var item = this.getItem(id);
                                        if(item.command)
                                        {
                                            setTimeout(function(){
                                                _this.ExecCommand(item);
                                            }, 1);
                                        }
                                    }
                                }
                            }
                        ]
                    }
                })
            }

            return cols;
        }()
    };
    this.BufferProcessingInterval = setInterval(function(){
        if(_this.BufferUpdated && _this.TerminalViews.TerminalContent)
        {
            _this.BufferUpdated = false;
            _this.TerminalViews.TerminalContent.innerHTML = _this.Buffer.join("");
            _this.Views.TerminalContent.resize();
            _this.Views.ScrollView.scrollTo(0, Number.MAX_SAFE_INTEGER);
        }
    }, 1000);
};

SshTerminalWidget.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    if(this.BufferProcessingInterval)
    {
        clearInterval(this.BufferProcessingInterval);
    }


    App.WebSocketManager.Disconnect(_this.SocketRoom);
};

SshTerminalWidget.prototype.Bind = function (ViewController, ViewModel)
{
    var _this = this;

    this.ViewController = ViewController;

    Object.keys(this.Views).forEach(function(Key)
    {
       _this.Views[Key] = $$(_this.Id + Key);
    });

    Object.keys(_this.TerminalViews).forEach(function(Key)
    {
        _this.TerminalViews[Key] = document.getElementById(_this.Id + Key);
    });

    this.Views.Self = $$(this.Id);

    this.Views.Self.attachEvent("onViewShow", function(){
        if(_this.OnViewShow)
        {
            Object.keys(_this.TerminalViews).forEach(function(Key)
            {
                _this.TerminalViews[Key] = document.getElementById(_this.Id + Key);
            });
        }

        _this.RefreshView();
    });

    this.Views.Self.disable();
    App.WebSocketManager.Connect(_this.SocketRoom);

    App.WebSocketManager.Connections[_this.SocketRoom].on("connect", function(data){
        // _this.ViewModel.ConnectToTerminal(_this.HardwareId, _this.SocketRoom);
    });

    App.WebSocketManager.Connections[_this.SocketRoom].on("disconnect", function(data){
        // Переход по ссылке из логирования в абоненты и обратно без try catch вызывает ошибки
        try {
            _this.Views.Self.disable();
            _this.WriteDataToTerminalContent("<span style='color: red'>DISCONNECTED</span>\n", true);
            _this.Signals.TerminalReady.next(false);
        }
        catch (e) {}
    });

    App.WebSocketManager.Connections[_this.SocketRoom].on("RoomConnected", function(data){
        _this.SocketRoomId = data;
        _this.ViewModel.ConnectToTerminal(_this.HardwareId, _this.SocketRoomId);
    });

    App.WebSocketManager.Connections[_this.SocketRoom].on("TerminalReady", function(data){
        _this.WriteDataToTerminalContent("\n<span style='color: green'>CONNECTED</span>\n", true);
        _this.Views.Self.enable();
        if(_this.DisplayInput && _this.Views.Command)
        {
            _this.Views.Command.setValue(' ');
            _this.Views.Command.setValue('');
            _this.Views.Command.focus();
        }

        _this.Signals.TerminalReady.next(true);
    });

    App.WebSocketManager.Connections[_this.SocketRoom].on("TerminalClose", function(data){
        _this.Signals.TerminalReady.next(false);
    });

    App.WebSocketManager.Connections[_this.SocketRoom].on("TerminalError", function(data){
        _this.Signals.TerminalReady.next(false);
        webix.message({type:"error", text:LangHelper.GetString("SshTerminal", "Can not connect to hardware")});

        webix.alert({
            title: LangHelper.GetString("All", "Error"),
            text: LangHelper.GetString("All", "Can not connect to hardware") + ".<br/>" + LangHelper.GetString("All", "Error") + ":<br/>" + JSON.stringify(data),
            type:"alert-error",
            width:800
        });
    });

    App.WebSocketManager.Connections[_this.SocketRoom].on("TerminalContentLength", function(data){
    });

    App.WebSocketManager.Connections[_this.SocketRoom].on("ClearTerminal", function(data){
    });

    App.WebSocketManager.Connections[_this.SocketRoom].on("TerminalResult", function(data){
        _this.WriteDataToTerminalContent(data);
    });

    if(this.UseDics)
    {
        this.Subscriptions.DicsUpdated = this.ViewModel.Signals.SignalDicsUpdated.subscribe(function(Val){
            if(Val)
            {
                _this.FilterCommands('');
            }
        });
    }

    if(this.DisplayInput)
    {
        this.Subscriptions.DisableButtonSubscription = this.Signals.InputChange.subscribe(function(Val){
            if(Val)
            {
                _this.Views.ExecuteButton.enable();
            }
            else{
                _this.Views.ExecuteButton.disable();
            }
        });

        this.Views.Command.attachEvent("onKeyPress", function(e){
            setTimeout(function(){
                if(_this.Views.Command)
                    _this.Signals.InputChange.next(_this.Views.Command.getValue());
            }, 1);
        });

        this.Views.Command.attachEvent("onChange", function(e){
            setTimeout(function(){
                if(_this.Views.Command)
                    _this.Signals.InputChange.next(_this.Views.Command.getValue());
            }, 1);
        });
    }


    if(this.UseDics)
        this.ViewModel.InitDicsIfNeed();
};

SshTerminalWidget.prototype.InputString = function()
{
    var _this = this;
    this.Terminal.input('', function(Input){
        _this.ProcessCommand(Input);
    });
};

SshTerminalWidget.prototype.ProcessCommand = function(Command)
{
   var _this = this;
   if(Command)
   {

       setTimeout(function(){
           App.WebSocketManager.Connections[_this.SocketRoom].emit("ExecCommand", Command + "\n");
           if(_this.Views.Command)
           {
               _this.Views.Command.setValue('');
           }
           if(Command == "clear")
           {
               _this.ClearTerminal()
           }
       }, 1);

   }

};

SshTerminalWidget.prototype.ExecCommand = function(Command)
{
    var _this = this;
    if(Command && _this.Views.Command)
    {
        _this.Views.Command.setValue(Command.command);
    }
}

SshTerminalWidget.prototype.FilterCommands = function(Str)
{
    var _this = this;
    var list = [];
    if(Str)
    {
        var data = _this.ViewModel.GetDic();
        if(data)
        {
            data.forEach(function(Group){
                Group.data.forEach(function(Command){
                    if(Command.command.indexOf(Str) > -1 || Command.title.indexOf(Str) > -1 || Command.description.indexOf(Str) > -1)
                    {
                        list.push(Command);
                    }
                });
            });
        }
    }
    else{
        list = _this.ViewModel.GetDic();
    }

    this.Views.Commands.clearAll();
    this.Views.Commands.parse(list);
}

SshTerminalWidget.prototype.WriteDataToTerminalContent = function(Data, AsHTML)
{
    var _this = this;

    if(AsHTML)
    {
        _this.Buffer.push(Data);
        if(_this.Buffer.length > TERMINAL_BUFFER_MAX_SIZE)
        {
            _this.Buffer.splice(0,1);
        }
    }
    else{
        var content = this.Ansi.ansi_to_html(Data);
        var arr = content.split("\n");
        arr.forEach(function(Line){
            if(Line)
            {
                _this.Buffer.push(Line)
                if(_this.Buffer.length > TERMINAL_BUFFER_MAX_SIZE)
                {
                    _this.Buffer.splice(0,1);
                }
            }
        });
    }
    this.BufferUpdated = true;
};

SshTerminalWidget.prototype.ClearTerminal = function()
{
  var _this = this;

  this.Buffer = [];
  this.BufferUpdated = 1;
};

SshTerminalWidget.prototype.StopProcessingCommand = function()
{
    var _this = this;

    App.WebSocketManager.Connections[_this.SocketRoom].emit("KillProcess", {"data" : 0});
};

SshTerminalWidget.prototype.SendTerminalClearCommand = function()
{
    var _this = this;
    App.WebSocketManager.Connections[_this.SocketRoom].emit("ExecCommand",  "clear");
    _this.ClearTerminal();
};

SshTerminalWidget.prototype.RefreshView = function()
{
    this.Views.TerminalContent.resize();
    this.Views.ScrollView.scrollTo(0, Number.MAX_SAFE_INTEGER);
};
function HardwareSshTerminalViewController()
{

    var _this = this;

    this.Id = "HardwareSshTerminal";
    this.id = this.Id;

    this.ViewModel = null;

    this.Widgets = {
        // Terminal: new SshTerminalWidget({id: this.Id + "Terminal", title: "Terminal", icon:"terminal"})
    };

    this.ViewConfig = [
        {
            id:this.Id,
            cols: [
                HardwareSshTerminalLeftSideBarView({id:this.Id}),
                {
                    type: "space",
                    rows: [
                        {
                            type: "clear",
                            borderless: true,
                            rows:[
                                PageHeaderTemplate({root_title:LangHelper.GetString("AppView", "Hardware ssh terminal"),title:LangHelper.GetString("AppView","Hardware ssh terminal")}),
                                {
                                    view: "accordion",
                                    multi: "mixed",
                                    on:{
                                        onAfterExpanded: function()
                                        {
                                            // _this.PolicingCaptiveView.RefreshViews();
                                            // _this.PolicingWifiView.RefreshViews();
                                            return true;
                                        }
                                    },
                                    cols: [
                                        {
                                            header: LangHelper.GetString("SshTerminal","Hardwares"),
                                            gravity: 1,
                                            body:{
                                                view: "datatable",
                                                id: this.Id + "HardwareList",
                                                select: "row",
                                                editable: true,
                                                editaction:"custom",
                                                resizeColumn: true,
                                                tooltip:true,
                                                width: 320,
                                                columns: [
                                                    {
                                                        id: "run",
                                                        header: "",
                                                        width: 32,
                                                        template: function (obj, common)
                                                        {
                                                            return CellTerminalBtnTemplate();
                                                        },
                                                        headermenu: false
                                                    },
                                                    {
                                                        id: "value",
                                                        header: [LangHelper.GetString("SshTerminal","Hardware"), {content: "textFilter", placeholder:"&#xf002 "+LangHelper.GetString("All","Filter")}],
                                                        width: 120,
                                                        fillspace: true,
                                                        sort: "string"
                                                    },
                                                    {
                                                        id: "hardware_type",
                                                        header: [LangHelper.GetString("SshTerminal","Type"), {
                                                            content: "richSelectFilter",
                                                            options: Helper.DictToArr(HardwareTypesDic),
                                                            inputConfig: {suggest: {fitMaster: false}}}],
                                                        width:120,
                                                        template: function (obj, common)
                                                        {
                                                            var statusStr = "";

                                                            if(HardwareTypesDic[obj.hardware_type])
                                                            {
                                                                statusStr += HardwareTypesDic[obj.hardware_type].value;
                                                            }

                                                            return statusStr;
                                                        },
                                                        // fillspace: true,
                                                        sort: "string"
                                                    },
                                                ],
                                                on: {
                                                    onItemClick: function(id, e, node)
                                                    {
                                                        if(id.column == "run")
                                                        {
                                                            var item = this.getItem(id);
                                                            setTimeout(function(){
                                                                _this.AddSshConnections(item);
                                                            }, 1);
                                                        }
                                                    },
                                                    onItemDblClick: function(id, ev)
                                                    {
                                                        var item = this.getItem(id);
                                                        setTimeout(function(){
                                                            _this.AddSshConnections(item);
                                                        }, 1);
                                                    }
                                                }
                                            }
                                        },
                                        {view:"resizer"},
                                        {
                                            header: LangHelper.GetString("SshTerminal","Hardware connections"),
                                            gravity: 3,
                                            body:{
                                                rows:[
                                                    {
                                                        view: "toolbar",
                                                        height:webix.skin.$name == "dpiui2_vulkan" || webix.skin.$name == "dpiui2_vulkan" ? webix.skin.$active.rowHeight : 40,
                                                        //borderless:true,
                                                        elements: [
                                                            {
                                                                view:"tabbar",
                                                                id:this.Id + "TerminalsTabBar",
                                                                close:true,
                                                                optionWidth:220,
                                                                multiview:true,
                                                                options:[
                                                                    //{id:this.Id + "GroupActionsTabBar" + "0", value:"E-mail"}
                                                                ],
                                                                on:{
                                                                    onOptionRemove: function (Id, Val)
                                                                    {
                                                                        _this._RemoveSshTabView(Id);
                                                                    },
                                                                    onAfterTabClick: function(Id)
                                                                    {
                                                                        setTimeout(function(){
                                                                            _this.Widgets[Id].RefreshView();
                                                                        }, 10);
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        animate:false,
                                                        id: this.Id + "TerminalsTabBarViews",
                                                        cells:[
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            gravity: 0
                        }
                    ]
                }
            ]
        }
    ];

    this.Views = {
        TerminalsTabBarElems: {},
        HardwareList: null
    };

    this.Subscriptions = {};

    this.Hardwares = [];
};

HardwareSshTerminalViewController.prototype.Destroy = function ()
{
    var _this = this;

    Object.keys(this.Subscriptions).forEach(function (key)
    {
        _this.Subscriptions[key].unsubscribe();
    });

    Object.keys(this.Widgets).forEach(function(key)
    {
        _this.Widgets[key].Destroy();
    });
};

HardwareSshTerminalViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    webix.ready(function () {
        $$(_this.Id+"LeftSideBar").select(_this.Id);
    });

    this.BindAll();

};

HardwareSshTerminalViewController.prototype.BindAll = function (Params)
{
    var _this = this;

    this.Views.Self = $$(this.Id);
    this.Views.TerminalsTabBar = $$(this.Id + "TerminalsTabBar");
    this.Views.TerminalsTabBarViews = $$(this.Id + "TerminalsTabBarViews");
    this.Views.HardwareList = $$(this.Id + "HardwareList");


    Object.keys(this.Widgets).forEach(function(Key){
        _this.Widgets[Key].Bind(_this);
    });

    this.Subscriptions.SignalHardwaresDicUpdatedSubscription = App.DicsManager.Signal[DicsEnum.HardwaresDic].subscribe(function (Updated)
    {
        if (Updated)
        {
            var hardwares = App.DicsManager.GetDicAsArray(DicsEnum.HardwaresDic);
            _this.Hardwares = hardwares;
            _this.Views.HardwareList.clearAll();
            _this.Views.HardwareList.parse(hardwares);
            // _this.AddTerminalContext.clearAll();
            // _this.AddTerminalContext.parse(parsed);
        }
    });
};

HardwareSshTerminalViewController.prototype.AddSshConnections = function(Hardware)
{
    var id = webix.uid();


    this.Widgets[id] = new SshTerminalWidget({
        id: id,
        hardware: Hardware.id,
        model: Hardware,
        useDics: true,
        onViewShow: false,
        displayInput: true
    });

    this.Views.TerminalsTabBarViews.addView({
        id: id,
        rows: [this.Widgets[id].ViewConfig]
    });

    this.Views.TerminalsTabBar.addOption(id, Hardware.value, true);
    this.Views.TerminalsTabBarElems[id] = {
        id:id,
        view:$$(id)
    };

    this.Views.TerminalsTabBarElems[id].view.show();

    this.Widgets[id].Bind(this);
    return id;
};

HardwareSshTerminalViewController.prototype._RemoveSshTabView = function(Id)
{
    var _this = this;

    this.Widgets[Id].Destroy();
    this.Views.TerminalsTabBar.blockEvent();
    this.Views.TerminalsTabBar.removeOption(Id);
    this.Views.TerminalsTabBar.unblockEvent();


    this.Views.TerminalsTabBarViews.removeView(Id);
    delete this.Views.TerminalsTabBarElems[Id];
};
function AntiDDoSNetworksViewController(Params)
{
    this.Id = "AntiDDoSNetworks";
    this.id = this.Id;
    this.ViewConfig = [
        {
            template:"<iframe src='assets/html/antiddos/AntiDDoSNetworks"+(LangHelper.GetLocale() === LocalesEnum.ru.code ? "Ru" : "En")+".html' style='width:100%; height:100%; border:none;'></iframe>"
        }
    ];

    this.Init(Params);
}

AntiDDoSNetworksViewController.prototype.Init = function(Params)
{

};

AntiDDoSNetworksViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll();

};

AntiDDoSNetworksViewController.prototype.BindAll = function (Params)
{
    var _this = this;
};
function AntiDDoSThreatsViewController(Params)
{
    this.Id = "AntiDDoSNetworks";
    this.ViewConfig = [
        {
            template:"<iframe src='assets/html/antiddos/AntiDDoSThreats"+(LangHelper.GetLocale() === LocalesEnum.ru.code ? "Ru" : "En")+".html' style='width:100%; height:100%; border:none;'></iframe>"
        }
    ];

    this.Init(Params);
}

AntiDDoSThreatsViewController.prototype.Init = function(Params)
{

};

AntiDDoSThreatsViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll();

};

AntiDDoSThreatsViewController.prototype.BindAll = function (Params)
{
    var _this = this;
};
function AntiDDoSProtectionViewController(Params)
{
    this.Id = "AntiDDoSProtection";
    this.ViewConfig = [
        {
            template:"<iframe src='assets/html/antiddos/AntiDDoSProtection"+(LangHelper.GetLocale() === LocalesEnum.ru.code ? "Ru" : "En")+".html' style='width:100%; height:100%; border:none;'></iframe>"
        }
    ];

    this.Init(Params);
}

AntiDDoSProtectionViewController.prototype.Init = function(Params)
{

};

AntiDDoSProtectionViewController.prototype.ViewDidLoad = function (Params)
{
    var _this = this;

    this.BindAll();

};

AntiDDoSProtectionViewController.prototype.BindAll = function (Params)
{
    var _this = this;
};
webix.skin.dpiui2 =
{
    topLayout: "space",
    barHeight: 40,
    tabbarHeight: 40,
    rowHeight: 40,
    toolbarHeight: 22,
    listItemHeight: 40,
    inputHeight: 40,
    buttonHeight: 32,
    inputPadding: 2,
    menuMargin: 0,
    menuHeight: 34,
    labelTopHeight: 16,
    propertyItemHeight: 34,
    inputSpacing: 4,
    borderWidth: 1,
    sliderHandleWidth: 16,
    sliderPadding: 10,
    sliderBorder: 1,
    switchHeight: 22,
    switchWidth: 50,
    layoutMargin:
    {
        material: 10,
        space: 16,
        wide: 16,
        clean: 0,
        head: 4,
        line: -1,
        toolbar: 4,
        form: 16,
        accordion: 0
    },
    layoutPadding:
    {
        material: 10,
        space: 16,
        wide: 0,
        clean: 0,
        head: 0,
        line: 0,
        toolbar: 4,
        form: 16,
        accordion: 0
    },
    tabMargin: 0,
    tabOffset: 0,
    tabBottomOffset: 0,
    tabTopOffset: 0,
    customCheckbox: true,
    customRadio: true,
    popupPadding: 8,
    calendarHeight: 70,
    padding: 0,
    accordionType: "accordion",

    appHeader:{height:70,padding:0},
    appHeaderTopPanel:{height:36,padding:0},
    appHeaderMenuPanel:{height:36,padding:0},

    pageHeader:{height:64},

    borderless:false,
    preferRowType:"space",

    blockHeaderHeight:24,
    tabbarSmallHeight:24,

    tableHeaderMenuWidth:350,

    leftSideBarWidth:350,
    mapClassName: "ol-controls-dpiui2",

    defaultCirclesStyle: {
        type: "Style",
        params: {
            image: {
                type: "Circle",
                params: {
                    radius: 6,
                    fill: {
                        type: "Fill",
                        params: {
                            color: "#ff0000"
                        }
                    }
                }
            }
        }
    },
    defaultMapTowersStyle: {
        type: "Style",
        params: {
            text:{
                type: "Text",
                params: {
                    text: '\uf519',     //  fa-tower
                    font: '900 24px "Font Awesome 5 Pro"',
                    textBaseline: 'bottom',
                    fill: {
                        type: "Fill",
                        params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapHumanStyle: {
        type: "Style",
        params: {
            text:{
                type: "Text",
                params: {
                    text: '\uf183',     //  fa-male
                    font: '900 24px "Font Awesome 5 Pro"',
                    placement: "point",
                    textBaseline: 'bottom',
                    // anchor: [-1.5, -1.5],
                    fill: {
                        type: "Fill",
                        params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapStrokesStyle: {
        type: "Style",
        params: {
            stroke:{
                type: "Stroke",
                params: {
                    width: 2,
                    color: "green"
                }
            }
        }
    }
};

webix.skin.dpiui2_spectre =
{
    topLayout: "space",
    barHeight: 40,
    tabbarHeight: 40,
    rowHeight: 40,
    toolbarHeight: 22,
    listItemHeight: 40,
    inputHeight: 40,
    buttonHeight: 32,
    inputPadding: 2,
    menuMargin: 0,
    menuHeight: 34,
    labelTopHeight: 16,
    propertyItemHeight: 34,
    inputSpacing: 4,
    borderWidth: 1,
    sliderHandleWidth: 16,
    sliderPadding: 10,
    sliderBorder: 1,
    switchHeight: 22,
    switchWidth: 50,
    layoutMargin:
    {
        material: 10,
        space: 24,
        wide: 20,
        clean: 0,
        head: 4,
        line: -1,
        toolbar: 4,
        form: 20,
        accordion: 0
    },
    layoutPadding:
    {
        material: 10,
        space: 24,
        wide: 0,
        clean: 0,
        head: 0,
        line: 0,
        toolbar: 4,
        form: 16,
        accordion: 0
    },
    tabMargin: 0,
    tabOffset: 0,
    tabBottomOffset: 0,
    tabTopOffset: 0,
    customCheckbox: true,
    customRadio: true,
    popupPadding: 8,
    calendarHeight: 70,
    padding: 0,
    accordionType: "accordion",
    mapClassName: "ol-controls-dpiui2",

    defaultCirclesStyle: {
        type: "Style",
        params: {
            image: {
                type: "Circle",
                params: {
                    radius: 6,
                    fill: {
                        type: "Fill",
                        params: {
                            color: "#ff0000"
                        }
                    }
                }
            }
        }
    },
    defaultMapTowersStyle: {
        type: "Style",
            params: {
            text:{
                type: "Text",
                    params: {
                    text: '\uf519',     //  fa-tower
                        font: '900 24px "Font Awesome 5 Pro"',
                        textBaseline: 'bottom',
                        fill: {
                        type: "Fill",
                            params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapHumanStyle: {
        type: "Style",
        params: {
            text:{
                type: "Text",
                params: {
                    text: '\uf183',     //  fa-male
                    font: '900 24px "Font Awesome 5 Pro"',
                    textBaseline: 'bottom',
                    fill: {
                        type: "Fill",
                        params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapStrokesStyle: {
        type: "Style",
        params: {
            stroke:{
                type: "Stroke",
                params: {
                    width: 2,
                    color: "green"
                }
            }
        }
    }
};

webix.skin.dpiui2_vulkan =
{
    topLayout: "space",
    //bar in accordion
    barHeight:24,			//!!!Set the same in skin.less!!!
    tabbarHeight:26,
    rowHeight:32,
    toolbarHeight:32,
    listItemHeight:32,		//list, grouplist, dataview, etc.
    inputHeight:32,
    buttonHeight: 32,
    inputPadding: 2,
    menuMargin: 0,
    menuHeight: 34,
    labelTopHeight: 16,
    propertyItemHeight: 34,
    inputSpacing: 4,
    borderWidth: 1,
    sliderHandleWidth: 16,
    sliderPadding: 10,
    sliderBorder: 1,
    switchHeight: 22,
    switchWidth: 50,
    //margin - distance between cells
    layoutMargin:{ material:10, space:16, wide:16, clean:0, head:4, line:-1, toolbar:4, form:16, accordion: 0  },
    //padding - distance insede cell between cell border and cell content
    layoutPadding:{ material:10, space:16, wide:0, clean:0, head:0, line:0, toolbar:0, form:16, accordion: 0  },
    //space between tabs in tabbar
    tabMargin: 0,
    tabOffset: 0,
    tabBottomOffset: 0,
    tabTopOffset: 0,
    customCheckbox: true,
    customRadio: true,
    popupPadding: 8,
    calendarHeight: 70,
    padding: 0,
    accordionType: "accordion",

    appHeader:{height:70,padding:0},
    appHeaderTopPanel:{height:56,padding:0},
    appHeaderMenuPanel:{height:36,padding:0},

    pageHeader:{height:64},

    borderless:false,
    preferRowType:"space",

    blockHeaderHeight:24,
    tabbarSmallHeight:24,

    tableHeaderMenuWidth:350,

    leftSideBarWidth:350,
    mapClassName: "ol-controls-dpiui2",

    defaultCirclesStyle: {
        type: "Style",
        params: {
            image: {
                type: "Circle",
                params: {
                    radius: 6,
                    fill: {
                        type: "Fill",
                        params: {
                            color: "#ff0000"
                        }
                    }
                }
            }
        }
    },
    defaultMapTowersStyle: {
        type: "Style",
        params: {
            text:{
                type: "Text",
                params: {
                    text: '\uf519',     //  fa-tower
                    font: '900 24px "Font Awesome 5 Pro"',
                    textBaseline: 'bottom',
                    fill: {
                        type: "Fill",
                        params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapHumanStyle: {
        type: "Style",
        params: {
            text:{
                type: "Text",
                params: {
                    text: '\uf183',     //  fa-male
                    font: '900 24px "Font Awesome 5 Pro"',
                    textBaseline: 'bottom',
                    fill: {
                        type: "Fill",
                        params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapStrokesStyle: {
        type: "Style",
        params: {
            stroke:{
                type: "Stroke",
                params: {
                    width: 2,
                    color: "green"
                }
            }
        }
    }
};

"use strict";

webix.skin.dpiui2_dark =
    {
        topLayout: "space",
        barHeight: 40,
        tabbarHeight: 40,
        rowHeight: 40,
        toolbarHeight: 22,
        listItemHeight: 40,
        inputHeight: 40,
        buttonHeight: 32,
        inputPadding: 2,
        menuMargin: 0,
        menuHeight: 34,
        labelTopHeight: 16,
        propertyItemHeight: 34,
        inputSpacing: 4,
        borderWidth: 1,
        sliderHandleWidth: 16,
        sliderPadding: 10,
        sliderBorder: 1,
        switchHeight: 22,
        switchWidth: 50,
        layoutMargin:
            {
                material: 10,
                space: 16,
                wide: 16,
                clean: 0,
                head: 4,
                line: -1,
                toolbar: 4,
                form: 16,
                accordion: 0
            },
        layoutPadding:
            {
                material: 10,
                space: 16,
                wide: 0,
                clean: 0,
                head: 0,
                line: 0,
                toolbar: 4,
                form: 16,
                accordion: 0
            },
        tabMargin: 0,
        tabOffset: 0,
        tabBottomOffset: 0,
        tabTopOffset: 0,
        customCheckbox: true,
        customRadio: true,
        popupPadding: 8,
        calendarHeight: 70,
        padding: 0,
        accordionType: "accordion",

        appHeader:{height:70,padding:0},
        appHeaderTopPanel:{height:36,padding:0},
        appHeaderMenuPanel:{height:36,padding:0},

        pageHeader:{height:64},

        borderless:false,
        preferRowType:"space",

        blockHeaderHeight:24,
        tabbarSmallHeight:24,

        tableHeaderMenuWidth:350,

        leftSideBarWidth:350,
        mapClassName: "ol-controls-dpiui2",

        defaultCirclesStyle: {
            type: "Style",
            params: {
                image: {
                    type: "Circle",
                    params: {
                        radius: 6,
                        fill: {
                            type: "Fill",
                            params: {
                                color: "#ff0000"
                            }
                        }
                    }
                }
            }
        },
        defaultMapTowersStyle: {
            type: "Style",
            params: {
                text:{
                    type: "Text",
                    params: {
                        text: '\uf519',     //  fa-tower
                        font: '900 24px "Font Awesome 5 Pro"',
                        textBaseline: 'bottom',
                        fill: {
                            type: "Fill",
                            params: {
                                color: "red"
                            }
                        }
                    }
                }
            }
        },
        defaultMapHumanStyle: {
            type: "Style",
            params: {
                text:{
                    type: "Text",
                    params: {
                        text: '\uf183',     //  fa-male
                        font: '900 24px "Font Awesome 5 Pro"',
                        placement: "point",
                        textBaseline: 'bottom',
                        // anchor: [-1.5, -1.5],
                        fill: {
                            type: "Fill",
                            params: {
                                color: "red"
                            }
                        }
                    }
                }
            }
        },
        defaultMapStrokesStyle: {
            type: "Style",
            params: {
                stroke:{
                    type: "Stroke",
                    params: {
                        width: 2,
                        color: "green"
                    }
                }
            }
        }
    };

webix.skin.dpiui2_cubro =
{
    topLayout: "space",
    barHeight: 40,
    tabbarHeight: 40,
    rowHeight: 40,
    toolbarHeight: 22,
    listItemHeight: 40,
    inputHeight: 40,
    buttonHeight: 32,
    inputPadding: 2,
    menuMargin: 0,
    menuHeight: 34,
    labelTopHeight: 16,
    propertyItemHeight: 34,
    inputSpacing: 4,
    borderWidth: 1,
    sliderHandleWidth: 16,
    sliderPadding: 10,
    sliderBorder: 1,
    switchHeight: 22,
    switchWidth: 50,
    layoutMargin:
    {
        material: 10,
        space: 24,
        wide: 20,
        clean: 0,
        head: 4,
        line: -1,
        toolbar: 4,
        form: 20,
        accordion: 0
    },
    layoutPadding:
    {
        material: 10,
        space: 24,
        wide: 0,
        clean: 0,
        head: 0,
        line: 0,
        toolbar: 4,
        form: 16,
        accordion: 0
    },
    tabMargin: 0,
    tabOffset: 0,
    tabBottomOffset: 0,
    tabTopOffset: 0,
    customCheckbox: true,
    customRadio: true,
    popupPadding: 8,
    calendarHeight: 70,
    padding: 0,
    accordionType: "accordion",
    mapClassName: "ol-controls-dpiui2",

    defaultCirclesStyle: {
        type: "Style",
        params: {
            image: {
                type: "Circle",
                params: {
                    radius: 6,
                    fill: {
                        type: "Fill",
                        params: {
                            color: "#ff0000"
                        }
                    }
                }
            }
        }
    },
    defaultMapTowersStyle: {
        type: "Style",
            params: {
            text:{
                type: "Text",
                    params: {
                    text: '\uf519',     //  fa-tower
                        font: '900 24px "Font Awesome 5 Pro"',
                        textBaseline: 'bottom',
                        fill: {
                        type: "Fill",
                            params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapHumanStyle: {
        type: "Style",
        params: {
            text:{
                type: "Text",
                params: {
                    text: '\uf183',     //  fa-male
                    font: '900 24px "Font Awesome 5 Pro"',
                    textBaseline: 'bottom',
                    fill: {
                        type: "Fill",
                        params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapStrokesStyle: {
        type: "Style",
        params: {
            stroke:{
                type: "Stroke",
                params: {
                    width: 2,
                    color: "green"
                }
            }
        }
    },


    chart:
        {
            xAxis:
                {
                    color:"#525962",
                    lineColor:"#525962"
                },

            yAxis:
                {
                    color:"#525962",
                    lineColor:"#525962"
                }
        }
};

webix.skin.dpiui2_cubro_main =
{
    topLayout: "space",
    barHeight: 40,
    tabbarHeight: 40,
    rowHeight: 40,
    toolbarHeight: 22,
    listItemHeight: 40,
    inputHeight: 40,
    buttonHeight: 32,
    inputPadding: 2,
    menuMargin: 0,
    menuHeight: 34,
    labelTopHeight: 16,
    propertyItemHeight: 34,
    inputSpacing: 4,
    borderWidth: 1,
    sliderHandleWidth: 16,
    sliderPadding: 10,
    sliderBorder: 1,
    switchHeight: 22,
    switchWidth: 50,
    layoutMargin:
    {
        material: 10,
        space: 16,
        wide: 16,
        clean: 0,
        head: 4,
        line: -1,
        toolbar: 4,
        form: 16,
        accordion: 0
    },
    layoutPadding:
    {
        material: 10,
        space: 16,
        wide: 0,
        clean: 0,
        head: 0,
        line: 0,
        toolbar: 4,
        form: 16,
        accordion: 0
    },
    tabMargin: 0,
    tabOffset: 0,
    tabBottomOffset: 0,
    tabTopOffset: 0,
    customCheckbox: true,
    customRadio: true,
    popupPadding: 8,
    calendarHeight: 70,
    padding: 0,
    accordionType: "accordion",

    appHeader:{height:70,padding:0},
    appHeaderTopPanel:{height:36,padding:0},
    appHeaderMenuPanel:{height:36,padding:0},

    pageHeader:{height:64},

    borderless:false,
    preferRowType:"space",

    blockHeaderHeight:24,
    tabbarSmallHeight:24,

    tableHeaderMenuWidth:350,

    leftSideBarWidth:350,
    mapClassName: "ol-controls-dpiui2",

    defaultCirclesStyle: {
        type: "Style",
        params: {
            image: {
                type: "Circle",
                params: {
                    radius: 6,
                    fill: {
                        type: "Fill",
                        params: {
                            color: "#ff0000"
                        }
                    }
                }
            }
        }
    },
    defaultMapTowersStyle: {
        type: "Style",
        params: {
            text:{
                type: "Text",
                params: {
                    text: '\uf519',     //  fa-tower
                    font: '900 24px "Font Awesome 5 Pro"',
                    textBaseline: 'bottom',
                    fill: {
                        type: "Fill",
                        params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapHumanStyle: {
        type: "Style",
        params: {
            text:{
                type: "Text",
                params: {
                    text: '\uf183',     //  fa-male
                    font: '900 24px "Font Awesome 5 Pro"',
                    placement: "point",
                    textBaseline: 'bottom',
                    // anchor: [-1.5, -1.5],
                    fill: {
                        type: "Fill",
                        params: {
                            color: "red"
                        }
                    }
                }
            }
        }
    },
    defaultMapStrokesStyle: {
        type: "Style",
        params: {
            stroke:{
                type: "Stroke",
                params: {
                    width: 2,
                    color: "green"
                }
            }
        }
    },


    chart:
    {
        xAxis:
        {
            color:"#525962",
            lineColor:"#525962"
        },

        yAxis:
        {
            color:"#525962",
            lineColor:"#525962"
        }
    }
};
